var _s={};(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.JV.s_ === region.HB.s_)
	{
		return 'on line ' + region.JV.s_;
	}
	return 'on lines ' + region.JV.s_ + ' through ' + region.HB.s_;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.ah_,
		impl.adT,
		impl.alO,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS
//
// For some reason, tabs can appear in href protocols and it still works.
// So '\tjava\tSCRIPT:alert("!!!")' and 'javascript:alert("!!!")' are the same
// in practice. That is why _VirtualDom_RE_js and _VirtualDom_RE_js_html look
// so freaky.
//
// Pulling the regular expressions out to the top level gives a slight speed
// boost in small benchmarks (4-10%) but hoisting values to reduce allocation
// can be unpredictable in large programs where JIT may have a harder time with
// functions are not fully self-contained. The benefit is more that the js and
// js_html ones are so weird that I prefer to see them near each other.


var _VirtualDom_RE_script = /^script$/i;
var _VirtualDom_RE_on_formAction = /^(on|formAction$)/i;
var _VirtualDom_RE_js = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i;
var _VirtualDom_RE_js_html = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;


function _VirtualDom_noScript(tag)
{
	return _VirtualDom_RE_script.test(tag) ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return _VirtualDom_RE_on_formAction.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return _VirtualDom_RE_js.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return _VirtualDom_RE_js_html.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlJson(value)
{
	return (typeof _Json_unwrap(value) === 'string' && _VirtualDom_RE_js_html.test(_Json_unwrap(value)))
		? _Json_wrap(
			/**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		) : value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		aiH: func(record.aiH),
		alJ: record.alJ,
		akc: record.akc
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.aiH;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.alJ;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.akc) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.ah_,
		impl.adT,
		impl.alO,
		function(sendToApp, initialModel) {
			var view = impl.amo;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.ah_,
		impl.adT,
		impl.alO,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.aa6 && impl.aa6(sendToApp)
			var view = impl.amo;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.fO);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.ac9) && (_VirtualDom_doc.title = title = doc.ac9);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.ajw;
	var onUrlRequest = impl.ajx;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		aa6: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr._D === next._D
							&& curr.ahL === next.ahL
							&& curr.ZN.a === next.ZN.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		ah_: function(flags)
		{
			return A3(impl.ah_, flags, _Browser_getUrl(), key);
		},
		amo: impl.amo,
		adT: impl.adT,
		alO: impl.alO
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { ahF: 'hidden', afw: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { ahF: 'mozHidden', afw: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { ahF: 'msHidden', afw: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { ahF: 'webkitHidden', afw: 'webkitvisibilitychange' }
		: { ahF: 'hidden', afw: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		aat: _Browser_getScene(),
		amp: {
			aeC: _Browser_window.pageXOffset,
			aeD: _Browser_window.pageYOffset,
			ams: _Browser_doc.documentElement.clientWidth,
			To: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		ams: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		To: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			aat: {
				ams: node.scrollWidth,
				To: node.scrollHeight
			},
			amp: {
				aeC: node.scrollLeft,
				aeD: node.scrollTop,
				ams: node.clientWidth,
				To: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			aat: _Browser_getScene(),
			amp: {
				aeC: x,
				aeD: y,
				ams: _Browser_doc.documentElement.clientWidth,
				To: _Browser_doc.documentElement.clientHeight
			},
			agJ: {
				aeC: x + rect.left,
				aeD: y + rect.top,
				ams: rect.width,
				To: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}


function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.RT.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.RT.b, xhr)); });
		$elm$core$Maybe$isJust(request.vd) && _Http_track(router, xhr, request.vd.a);

		try {
			xhr.open(request.IA, request.adY, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.adY));
		}

		_Http_configureRequest(xhr, request);

		request.fO.a && xhr.setRequestHeader('Content-Type', request.fO.a);
		xhr.send(request.fO.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.jP; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.J9.a || 0;
	xhr.responseType = request.RT.d;
	xhr.withCredentials = request.aeR;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		adY: xhr.responseURL,
		ace: xhr.status,
		alI: xhr.statusText,
		jP: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			alm: event.loaded,
			aly: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			akt: event.loaded,
			aly: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}


var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});


// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.aiR) { flags += 'm'; }
	if (options.afu) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;


// BYTES

function _Bytes_width(bytes)
{
	return bytes.byteLength;
}

var _Bytes_getHostEndianness = F2(function(le, be)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(new Uint8Array(new Uint32Array([1]))[0] === 1 ? le : be));
	});
});


// ENCODERS

function _Bytes_encode(encoder)
{
	var mutableBytes = new DataView(new ArrayBuffer($elm$bytes$Bytes$Encode$getWidth(encoder)));
	$elm$bytes$Bytes$Encode$write(encoder)(mutableBytes)(0);
	return mutableBytes;
}


// SIGNED INTEGERS

var _Bytes_write_i8  = F3(function(mb, i, n) { mb.setInt8(i, n); return i + 1; });
var _Bytes_write_i16 = F4(function(mb, i, n, isLE) { mb.setInt16(i, n, isLE); return i + 2; });
var _Bytes_write_i32 = F4(function(mb, i, n, isLE) { mb.setInt32(i, n, isLE); return i + 4; });


// UNSIGNED INTEGERS

var _Bytes_write_u8  = F3(function(mb, i, n) { mb.setUint8(i, n); return i + 1 ;});
var _Bytes_write_u16 = F4(function(mb, i, n, isLE) { mb.setUint16(i, n, isLE); return i + 2; });
var _Bytes_write_u32 = F4(function(mb, i, n, isLE) { mb.setUint32(i, n, isLE); return i + 4; });


// FLOATS

var _Bytes_write_f32 = F4(function(mb, i, n, isLE) { mb.setFloat32(i, n, isLE); return i + 4; });
var _Bytes_write_f64 = F4(function(mb, i, n, isLE) { mb.setFloat64(i, n, isLE); return i + 8; });


// BYTES

var _Bytes_write_bytes = F3(function(mb, offset, bytes)
{
	for (var i = 0, len = bytes.byteLength, limit = len - 4; i <= limit; i += 4)
	{
		mb.setUint32(offset + i, bytes.getUint32(i));
	}
	for (; i < len; i++)
	{
		mb.setUint8(offset + i, bytes.getUint8(i));
	}
	return offset + len;
});


// STRINGS

function _Bytes_getStringWidth(string)
{
	for (var width = 0, i = 0; i < string.length; i++)
	{
		var code = string.charCodeAt(i);
		width +=
			(code < 0x80) ? 1 :
			(code < 0x800) ? 2 :
			(code < 0xD800 || 0xDBFF < code) ? 3 : (i++, 4);
	}
	return width;
}

var _Bytes_write_string = F3(function(mb, offset, string)
{
	for (var i = 0; i < string.length; i++)
	{
		var code = string.charCodeAt(i);
		offset +=
			(code < 0x80)
				? (mb.setUint8(offset, code)
				, 1
				)
				:
			(code < 0x800)
				? (mb.setUint16(offset, 0xC080 /* 0b1100000010000000 */
					| (code >>> 6 & 0x1F /* 0b00011111 */) << 8
					| code & 0x3F /* 0b00111111 */)
				, 2
				)
				:
			(code < 0xD800 || 0xDBFF < code)
				? (mb.setUint16(offset, 0xE080 /* 0b1110000010000000 */
					| (code >>> 12 & 0xF /* 0b00001111 */) << 8
					| code >>> 6 & 0x3F /* 0b00111111 */)
				, mb.setUint8(offset + 2, 0x80 /* 0b10000000 */
					| code & 0x3F /* 0b00111111 */)
				, 3
				)
				:
			(code = (code - 0xD800) * 0x400 + string.charCodeAt(++i) - 0xDC00 + 0x10000
			, mb.setUint32(offset, 0xF0808080 /* 0b11110000100000001000000010000000 */
				| (code >>> 18 & 0x7 /* 0b00000111 */) << 24
				| (code >>> 12 & 0x3F /* 0b00111111 */) << 16
				| (code >>> 6 & 0x3F /* 0b00111111 */) << 8
				| code & 0x3F /* 0b00111111 */)
			, 4
			);
	}
	return offset;
});


// DECODER

var _Bytes_decode = F2(function(decoder, bytes)
{
	try {
		return $elm$core$Maybe$Just(A2(decoder, bytes, 0).b);
	} catch(e) {
		return $elm$core$Maybe$Nothing;
	}
});

var _Bytes_read_i8  = F2(function(      bytes, offset) { return _Utils_Tuple2(offset + 1, bytes.getInt8(offset)); });
var _Bytes_read_i16 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 2, bytes.getInt16(offset, isLE)); });
var _Bytes_read_i32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getInt32(offset, isLE)); });
var _Bytes_read_u8  = F2(function(      bytes, offset) { return _Utils_Tuple2(offset + 1, bytes.getUint8(offset)); });
var _Bytes_read_u16 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 2, bytes.getUint16(offset, isLE)); });
var _Bytes_read_u32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getUint32(offset, isLE)); });
var _Bytes_read_f32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getFloat32(offset, isLE)); });
var _Bytes_read_f64 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 8, bytes.getFloat64(offset, isLE)); });

var _Bytes_read_bytes = F3(function(len, bytes, offset)
{
	return _Utils_Tuple2(offset + len, new DataView(bytes.buffer, bytes.byteOffset + offset, len));
});

var _Bytes_read_string = F3(function(len, bytes, offset)
{
	var string = '';
	var end = offset + len;
	for (; offset < end;)
	{
		var byte = bytes.getUint8(offset++);
		string +=
			(byte < 128)
				? String.fromCharCode(byte)
				:
			((byte & 0xE0 /* 0b11100000 */) === 0xC0 /* 0b11000000 */)
				? String.fromCharCode((byte & 0x1F /* 0b00011111 */) << 6 | bytes.getUint8(offset++) & 0x3F /* 0b00111111 */)
				:
			((byte & 0xF0 /* 0b11110000 */) === 0xE0 /* 0b11100000 */)
				? String.fromCharCode(
					(byte & 0xF /* 0b00001111 */) << 12
					| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 6
					| bytes.getUint8(offset++) & 0x3F /* 0b00111111 */
				)
				:
				(byte =
					((byte & 0x7 /* 0b00000111 */) << 18
						| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 12
						| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 6
						| bytes.getUint8(offset++) & 0x3F /* 0b00111111 */
					) - 0x10000
				, String.fromCharCode(Math.floor(byte / 0x400) + 0xD800, byte % 0x400 + 0xDC00)
				);
	}
	return _Utils_Tuple2(offset, string);
});

var _Bytes_decodeFailure = F2(function() { throw 0; });




// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});



// DECODER

var _File_decoder = _Json_decodePrim(function(value) {
	// NOTE: checks if `File` exists in case this is run on node
	return (typeof File !== 'undefined' && value instanceof File)
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FILE', value);
});


// METADATA

function _File_name(file) { return file.name; }
function _File_mime(file) { return file.type; }
function _File_size(file) { return file.size; }

function _File_lastModified(file)
{
	return $elm$time$Time$millisToPosix(file.lastModified);
}


// DOWNLOAD

var _File_downloadNode;

function _File_getDownloadNode()
{
	return _File_downloadNode || (_File_downloadNode = document.createElement('a'));
}

var _File_download = F3(function(name, mime, content)
{
	return _Scheduler_binding(function(callback)
	{
		var blob = new Blob([content], {type: mime});

		// for IE10+
		if (navigator.msSaveOrOpenBlob)
		{
			navigator.msSaveOrOpenBlob(blob, name);
			return;
		}

		// for HTML5
		var node = _File_getDownloadNode();
		var objectUrl = URL.createObjectURL(blob);
		node.href = objectUrl;
		node.download = name;
		_File_click(node);
		URL.revokeObjectURL(objectUrl);
	});
});

function _File_downloadUrl(href)
{
	return _Scheduler_binding(function(callback)
	{
		var node = _File_getDownloadNode();
		node.href = href;
		node.download = '';
		node.origin === location.origin || (node.target = '_blank');
		_File_click(node);
	});
}


// IE COMPATIBILITY

function _File_makeBytesSafeForInternetExplorer(bytes)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/10
	// all other browsers can just run `new Blob([bytes])` directly with no problem
	//
	return new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
}

function _File_click(node)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/11
	// all other browsers have MouseEvent and do not need this conditional stuff
	//
	if (typeof MouseEvent === 'function')
	{
		node.dispatchEvent(new MouseEvent('click'));
	}
	else
	{
		var event = document.createEvent('MouseEvents');
		event.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		document.body.appendChild(node);
		node.dispatchEvent(event);
		document.body.removeChild(node);
	}
}


// UPLOAD

var _File_node;

function _File_uploadOne(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			callback(_Scheduler_succeed(event.target.files[0]));
		});
		_File_click(_File_node);
	});
}

function _File_uploadOneOrMore(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.multiple = true;
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			var elmFiles = _List_fromArray(event.target.files);
			callback(_Scheduler_succeed(_Utils_Tuple2(elmFiles.a, elmFiles.b)));
		});
		_File_click(_File_node);
	});
}


// CONTENT

function _File_toString(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsText(blob);
		return function() { reader.abort(); };
	});
}

function _File_toBytes(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(new DataView(reader.result)));
		});
		reader.readAsArrayBuffer(blob);
		return function() { reader.abort(); };
	});
}

function _File_toUrl(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsDataURL(blob);
		return function() { reader.abort(); };
	});
}

var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.F) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.X),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.X);
		} else {
			var treeLen = builder.F * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.ak) : builder.ak;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.F);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.X) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.X);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{ak: nodeList, F: (len / $elm$core$Array$branchFactor) | 0, X: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {ahu: fragment, ahL: host, YX: path, ZN: port_, _D: protocol, DE: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$element = _Browser_element;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $elm$json$Json$Decode$index = _Json_decodeIndex;
var $author$project$Main$Layout = function (a) {
	return {$: 4, a: a};
};
var $author$project$Main$Model = F5(
	function (shared, route, page, layout, loadClinicalDebouncer) {
		return {bE: layout, s2: loadClinicalDebouncer, dB: page, e: route, lk: shared};
	});
var $author$project$Main$Pages = function (a) {
	return {$: 3, a: a};
};
var $author$project$Main$Shared = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $author$project$Spa$Generated$Route$NotFound = {$: 9};
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {jM: frag, YL: params, h2: unvisited, aee: value, l2: visited};
	});
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.h2;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.aee);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.aee);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 1) {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 1) {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.YX),
					$elm$url$Url$Parser$prepareQuery(url.DE),
					url.ahu,
					$elm$core$Basics$identity)));
	});
var $author$project$Spa$Generated$Route$Account__Complete = {$: 21};
var $author$project$Spa$Generated$Route$Admin__AdvanceBilling = {$: 22};
var $author$project$Spa$Generated$Route$Admin__Athenahealth__Fields = {$: 208};
var $author$project$Spa$Generated$Route$Admin__Athenahealth__Link = {$: 209};
var $author$project$Spa$Generated$Route$Admin__Athenahealth__Locations = {$: 210};
var $author$project$Spa$Generated$Route$Admin__Athenahealth__Overview = {$: 211};
var $author$project$Spa$Generated$Route$Admin__Athenahealth__Providers = {$: 212};
var $author$project$Spa$Generated$Route$Admin__Athenahealth__Top = {$: 176};
var $author$project$Spa$Generated$Route$Admin__Billing = {$: 23};
var $author$project$Spa$Generated$Route$Admin__Billing__PracticeInvoices__Id_String = function (a) {
	return {$: 342, a: a};
};
var $author$project$Spa$Generated$Route$Admin__CancellationReasons = {$: 24};
var $author$project$Spa$Generated$Route$Admin__CardReaders = {$: 25};
var $author$project$Spa$Generated$Route$Admin__Categories = {$: 26};
var $author$project$Spa$Generated$Route$Admin__ChargeItems__Id_String = function (a) {
	return {$: 289, a: a};
};
var $author$project$Spa$Generated$Route$Admin__ChargeItems__New = {$: 213};
var $author$project$Spa$Generated$Route$Admin__ChargeItems__Top = {$: 177};
var $author$project$Spa$Generated$Route$Admin__ChargeItems__Upload = {$: 214};
var $author$project$Spa$Generated$Route$Admin__Commissions = {$: 27};
var $author$project$Spa$Generated$Route$Admin__CompanyPlans__Id_String = function (a) {
	return {$: 290, a: a};
};
var $author$project$Spa$Generated$Route$Admin__CompanyPlans__New = {$: 215};
var $author$project$Spa$Generated$Route$Admin__CompanyPlans__Top = {$: 178};
var $author$project$Spa$Generated$Route$Admin__Coupons = {$: 28};
var $author$project$Spa$Generated$Route$Admin__CoveragePlans__Id_String = function (a) {
	return {$: 291, a: a};
};
var $author$project$Spa$Generated$Route$Admin__CoveragePlans__New = {$: 216};
var $author$project$Spa$Generated$Route$Admin__CoveragePlans__Top = {$: 179};
var $author$project$Spa$Generated$Route$Admin__CreditCategories = {$: 29};
var $author$project$Spa$Generated$Route$Admin__Credits__Upload = {$: 217};
var $author$project$Spa$Generated$Route$Admin__DataExportSettings__Id_String = function (a) {
	return {$: 293, a: a};
};
var $author$project$Spa$Generated$Route$Admin__DataExportSettings__New = {$: 218};
var $author$project$Spa$Generated$Route$Admin__DataExportSettings__Top = {$: 181};
var $author$project$Spa$Generated$Route$Admin__DataExport__Id_String = function (a) {
	return {$: 292, a: a};
};
var $author$project$Spa$Generated$Route$Admin__DataExport__Top = {$: 180};
var $author$project$Spa$Generated$Route$Admin__Developers__ApiKeys = {$: 219};
var $author$project$Spa$Generated$Route$Admin__Developers__App = {$: 220};
var $author$project$Spa$Generated$Route$Admin__Developers__GetStarted = {$: 221};
var $author$project$Spa$Generated$Route$Admin__Developers__Hinter = {$: 222};
var $author$project$Spa$Generated$Route$Admin__Developers__Sandboxes = {$: 223};
var $author$project$Spa$Generated$Route$Admin__Developers__WebhookEndpoints = {$: 224};
var $author$project$Spa$Generated$Route$Admin__Documents__Id_String = function (a) {
	return {$: 294, a: a};
};
var $author$project$Spa$Generated$Route$Admin__Documents__New = {$: 225};
var $author$project$Spa$Generated$Route$Admin__Documents__Top = {$: 182};
var $author$project$Spa$Generated$Route$Admin__ElationLegacy = {$: 30};
var $author$project$Spa$Generated$Route$Admin__Elation__Link = {$: 226};
var $author$project$Spa$Generated$Route$Admin__Elation__Overview = {$: 227};
var $author$project$Spa$Generated$Route$Admin__Elation__Providers = {$: 228};
var $author$project$Spa$Generated$Route$Admin__Elation__Top = {$: 183};
var $author$project$Spa$Generated$Route$Admin__Features = {$: 31};
var $author$project$Spa$Generated$Route$Admin__HipaaAuthorizations = {$: 32};
var $author$project$Spa$Generated$Route$Admin__Integrations__Slug_String = function (a) {
	return {$: 295, a: a};
};
var $author$project$Spa$Generated$Route$Admin__InternalSettings = {$: 33};
var $author$project$Spa$Generated$Route$Admin__InvoiceSettings = {$: 34};
var $author$project$Spa$Generated$Route$Admin__LeadSources = {$: 35};
var $author$project$Spa$Generated$Route$Admin__Locations = {$: 36};
var $author$project$Spa$Generated$Route$Admin__Mailgun = {$: 37};
var $author$project$Spa$Generated$Route$Admin__Notes = {$: 38};
var $author$project$Spa$Generated$Route$Admin__Notifications__Company = {$: 229};
var $author$project$Spa$Generated$Route$Admin__Notifications__Employee = {$: 230};
var $author$project$Spa$Generated$Route$Admin__Notifications__Membership = {$: 231};
var $author$project$Spa$Generated$Route$Admin__Notifications__Patient = {$: 232};
var $author$project$Spa$Generated$Route$Admin__Notifications__Patient__DunningSchedule = {$: 321};
var $author$project$Spa$Generated$Route$Admin__Notifications__Practice = {$: 233};
var $author$project$Spa$Generated$Route$Admin__Notifications__Settings = {$: 234};
var $author$project$Spa$Generated$Route$Admin__Patients = {$: 39};
var $author$project$Spa$Generated$Route$Admin__PaymentMethodImport = {$: 40};
var $author$project$Spa$Generated$Route$Admin__PaymentMethodImport__Upload = {$: 235};
var $author$project$Spa$Generated$Route$Admin__PaymentProcessing = {$: 41};
var $author$project$Spa$Generated$Route$Admin__PaymentSources = {$: 42};
var $author$project$Spa$Generated$Route$Admin__Plans__Id_String = function (a) {
	return {$: 296, a: a};
};
var $author$project$Spa$Generated$Route$Admin__Plans__Id_String__PricingVersions__New = function (a) {
	return {$: 356, a: a};
};
var $author$project$Spa$Generated$Route$Admin__Plans__Id_String__PricingVersions__PricingVersionId_String = function (a) {
	return {$: 360, a: a};
};
var $author$project$Spa$Generated$Route$Admin__Plans__New = {$: 236};
var $author$project$Spa$Generated$Route$Admin__Plans__Top = {$: 184};
var $author$project$Spa$Generated$Route$Admin__Practice = {$: 43};
var $author$project$Spa$Generated$Route$Admin__ProviderGroups = {$: 44};
var $author$project$Spa$Generated$Route$Admin__Providers__Top = {$: 185};
var $author$project$Spa$Generated$Route$Admin__Providers__Upload = {$: 237};
var $author$project$Spa$Generated$Route$Admin__Quickbooks__Top = {$: 186};
var $author$project$Spa$Generated$Route$Admin__ScheduledJobs = {$: 45};
var $author$project$Spa$Generated$Route$Admin__SelfService = {$: 46};
var $author$project$Spa$Generated$Route$Admin__Signup = {$: 47};
var $author$project$Spa$Generated$Route$Admin__SignupPages__Id_String = function (a) {
	return {$: 297, a: a};
};
var $author$project$Spa$Generated$Route$Admin__SignupPages__New = {$: 238};
var $author$project$Spa$Generated$Route$Admin__SignupPages__Top = {$: 187};
var $author$project$Spa$Generated$Route$Admin__Stripe = {$: 48};
var $author$project$Spa$Generated$Route$Admin__Taxes = {$: 49};
var $author$project$Spa$Generated$Route$Admin__Team = {$: 50};
var $author$project$Spa$Generated$Route$Admin__Team__New = {$: 239};
var $author$project$Spa$Generated$Route$Admin__Waitlist = {$: 51};
var $author$project$Spa$Generated$Route$AffiliateBills__Top = {$: 12};
var $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__AffiliateActions = function (a) {
	return {$: 240, a: a};
};
var $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Id_String = function (a) {
	return {$: 343, a: a};
};
var $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Top = function (a) {
	return {$: 308, a: a};
};
var $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__LinkProviders = function (a) {
	return {$: 241, a: a};
};
var $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__LinkedProviders = function (a) {
	return {$: 242, a: a};
};
var $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Patients = function (a) {
	return {$: 243, a: a};
};
var $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Settings = function (a) {
	return {$: 244, a: a};
};
var $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Users = function (a) {
	return {$: 245, a: a};
};
var $author$project$Spa$Generated$Route$Affiliates__Create = {$: 52};
var $author$project$Spa$Generated$Route$Affiliates__New = {$: 53};
var $author$project$Spa$Generated$Route$Affiliates__Top = {$: 13};
var $author$project$Spa$Generated$Route$Apps__Slug_String = function (a) {
	return {$: 172, a: a};
};
var $author$project$Spa$Generated$Route$Blank = {$: 1};
var $author$project$Spa$Generated$Route$Bookkeeping = {$: 2};
var $author$project$Spa$Generated$Route$Calendar = {$: 3};
var $author$project$Spa$Generated$Route$CcdaImports__CcdaId_String__Top = function (a) {
	return {$: 188, a: a};
};
var $author$project$Spa$Generated$Route$Charges__New = {$: 54};
var $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__BrokerId_String__Top = function (a) {
	return {$: 363, a: a};
};
var $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Ended = function (a) {
	return {$: 357, a: a};
};
var $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__New = function (a) {
	return {$: 358, a: a};
};
var $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top = function (a) {
	return {$: 350, a: a};
};
var $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Deals = function (a) {
	return {$: 322, a: a};
};
var $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__EndedDeals = function (a) {
	return {$: 323, a: a};
};
var $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__StatementId_String = function (a) {
	return {$: 361, a: a};
};
var $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__Top = function (a) {
	return {$: 351, a: a};
};
var $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Top = function (a) {
	return {$: 309, a: a};
};
var $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__New = {$: 246};
var $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__Top = {$: 189};
var $author$project$Spa$Generated$Route$Commissions__StatementLines__Summary = {$: 247};
var $author$project$Spa$Generated$Route$Commissions__StatementLines__Top = {$: 190};
var $author$project$Spa$Generated$Route$Commissions__Statements = {$: 55};
var $author$project$Spa$Generated$Route$Companies__CompanyId_String__AffiliatesPricing = function (a) {
	return {$: 248, a: a};
};
var $author$project$Spa$Generated$Route$Companies__CompanyId_String__Eas = function (a) {
	return {$: 249, a: a};
};
var $author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Create = function (a) {
	return {$: 324, a: a};
};
var $author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__EmployeeId_String__Dependent__DependentId_String__Top = function (a) {
	return {$: 364, a: a};
};
var $author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top = function (a) {
	return {$: 310, a: a};
};
var $author$project$Spa$Generated$Route$Companies__CompanyId_String__EndedCommissions = function (a) {
	return {$: 250, a: a};
};
var $author$project$Spa$Generated$Route$Companies__CompanyId_String__InvoiceSettings = function (a) {
	return {$: 251, a: a};
};
var $author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String = function (a) {
	return {$: 344, a: a};
};
var $author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Top = function (a) {
	return {$: 311, a: a};
};
var $author$project$Spa$Generated$Route$Companies__CompanyId_String__Notes = function (a) {
	return {$: 252, a: a};
};
var $author$project$Spa$Generated$Route$Companies__CompanyId_String__Notifications = function (a) {
	return {$: 253, a: a};
};
var $author$project$Spa$Generated$Route$Companies__CompanyId_String__PaymentSources = function (a) {
	return {$: 254, a: a};
};
var $author$project$Spa$Generated$Route$Companies__CompanyId_String__Signup = function (a) {
	return {$: 255, a: a};
};
var $author$project$Spa$Generated$Route$Companies__CompanyId_String__SignupPages__Id_String = function (a) {
	return {$: 345, a: a};
};
var $author$project$Spa$Generated$Route$Companies__CompanyId_String__SignupPages__New = function (a) {
	return {$: 325, a: a};
};
var $author$project$Spa$Generated$Route$Companies__CompanyId_String__Top = function (a) {
	return {$: 191, a: a};
};
var $author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__Top = function (a) {
	return {$: 312, a: a};
};
var $author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__UploadId_String__Top = function (a) {
	return {$: 352, a: a};
};
var $author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__UploadId_String__UploadResults = function (a) {
	return {$: 359, a: a};
};
var $author$project$Spa$Generated$Route$Companies__New = {$: 56};
var $author$project$Spa$Generated$Route$Companies__Top = {$: 14};
var $author$project$Spa$Generated$Route$Contacts__ContactId_String__Top = function (a) {
	return {$: 192, a: a};
};
var $author$project$Spa$Generated$Route$Contacts__List = {$: 57};
var $author$project$Spa$Generated$Route$Contacts__New = {$: 58};
var $author$project$Spa$Generated$Route$Error__Status_String = function (a) {
	return {$: 173, a: a};
};
var $author$project$Spa$Generated$Route$Files__Public = {$: 59};
var $author$project$Spa$Generated$Route$Files__Top = {$: 15};
var $author$project$Spa$Generated$Route$Forms = {$: 4};
var $author$project$Spa$Generated$Route$GoogleCallback = {$: 5};
var $author$project$Spa$Generated$Route$Hinter__AdminUsersGroups__Id_String = function (a) {
	return {$: 298, a: a};
};
var $author$project$Spa$Generated$Route$Hinter__AdminUsersGroups__Top = {$: 193};
var $author$project$Spa$Generated$Route$Hinter__ClonePractice = {$: 60};
var $author$project$Spa$Generated$Route$Hinter__Disputes = {$: 61};
var $author$project$Spa$Generated$Route$Hinter__FeatureFlags = {$: 62};
var $author$project$Spa$Generated$Route$Hinter__NewGroup = {$: 63};
var $author$project$Spa$Generated$Route$Hinter__NewPartner = {$: 64};
var $author$project$Spa$Generated$Route$Hinter__NewPractice = {$: 65};
var $author$project$Spa$Generated$Route$Home = {$: 6};
var $author$project$Spa$Generated$Route$Inventory__InventoryId_String__Top = function (a) {
	return {$: 194, a: a};
};
var $author$project$Spa$Generated$Route$Inventory__List = {$: 66};
var $author$project$Spa$Generated$Route$Inventory__New = {$: 67};
var $author$project$Spa$Generated$Route$Inventory__Settings = {$: 68};
var $author$project$Spa$Generated$Route$Join__Token_String = function (a) {
	return {$: 174, a: a};
};
var $author$project$Spa$Generated$Route$Login = {$: 7};
var $author$project$Spa$Generated$Route$Logout = {$: 8};
var $author$project$Spa$Generated$Route$Marketplace__Athenahealth__Manage__Settings = {$: 326};
var $author$project$Spa$Generated$Route$Marketplace__Bookkeeping__Manage__Settings = {$: 327};
var $author$project$Spa$Generated$Route$Marketplace__Elation__Manage__Settings = {$: 328};
var $author$project$Spa$Generated$Route$Marketplace__Manage = {$: 69};
var $author$project$Spa$Generated$Route$Marketplace__Quickbooks__Manage__Settings = {$: 329};
var $author$project$Spa$Generated$Route$Marketplace__Slug_String = function (a) {
	return {$: 175, a: a};
};
var $author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Onboarding = function (a) {
	return {$: 330, a: a};
};
var $author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Settings = function (a) {
	return {$: 331, a: a};
};
var $author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Users = function (a) {
	return {$: 332, a: a};
};
var $author$project$Spa$Generated$Route$Marketplace__Top = {$: 16};
var $author$project$Spa$Generated$Route$Messages__Calls = {$: 70};
var $author$project$Spa$Generated$Route$Messages__Chat = {$: 71};
var $author$project$Spa$Generated$Route$Messages__Drafts = {$: 72};
var $author$project$Spa$Generated$Route$Messages__Fax__New = {$: 256};
var $author$project$Spa$Generated$Route$Messages__Faxes__MessageId_String = function (a) {
	return {$: 299, a: a};
};
var $author$project$Spa$Generated$Route$Messages__Faxes__New = {$: 257};
var $author$project$Spa$Generated$Route$Messages__Faxes__Top = {$: 195};
var $author$project$Spa$Generated$Route$Messages__Forms = {$: 73};
var $author$project$Spa$Generated$Route$Messages__Inbox = {$: 74};
var $author$project$Spa$Generated$Route$Messages__Labs = {$: 75};
var $author$project$Spa$Generated$Route$Messages__LegacyCalls = {$: 76};
var $author$project$Spa$Generated$Route$Messages__Legacy__Sms__PatientPhoneNumber_String__PracticePhoneNumber_String = function (a) {
	return {$: 362, a: a};
};
var $author$project$Spa$Generated$Route$Messages__ScheduledMessages__New = {$: 259};
var $author$project$Spa$Generated$Route$Messages__ScheduledMessages__ScheduledEventId_String__Top = function (a) {
	return {$: 314, a: a};
};
var $author$project$Spa$Generated$Route$Messages__Scheduled__New = {$: 258};
var $author$project$Spa$Generated$Route$Messages__Scheduled__ScheduledId_String__Top = function (a) {
	return {$: 313, a: a};
};
var $author$project$Spa$Generated$Route$Messages__Scheduled__Top = {$: 196};
var $author$project$Spa$Generated$Route$Messages__Sms = {$: 77};
var $author$project$Spa$Generated$Route$Messages__Sms__PhoneNumber_String = function (a) {
	return {$: 300, a: a};
};
var $author$project$Spa$Generated$Route$Messages__Sms__PhoneNumber_String__PracticeNumber_String = function (a) {
	return {$: 346, a: a};
};
var $author$project$Spa$Generated$Route$Messages__V2__Faxes__MessageId_String = function (a) {
	return {$: 347, a: a};
};
var $author$project$Spa$Generated$Route$NewSettings__AppointmentTypes__Ident_String = function (a) {
	return {$: 301, a: a};
};
var $author$project$Spa$Generated$Route$NewSettings__AppointmentTypes__New = {$: 260};
var $author$project$Spa$Generated$Route$NewSettings__AppointmentTypes__Top = {$: 197};
var $author$project$Spa$Generated$Route$NewSettings__BlockedPhoneNumbers = {$: 78};
var $author$project$Spa$Generated$Route$NewSettings__BookingOverview = {$: 79};
var $author$project$Spa$Generated$Route$NewSettings__Erx = {$: 80};
var $author$project$Spa$Generated$Route$NewSettings__Export = {$: 81};
var $author$project$Spa$Generated$Route$NewSettings__HinterSettings = {$: 82};
var $author$project$Spa$Generated$Route$NewSettings__Locations__BookingLocationId_String = function (a) {
	return {$: 302, a: a};
};
var $author$project$Spa$Generated$Route$NewSettings__Locations__New__LocationId_String = function (a) {
	return {$: 348, a: a};
};
var $author$project$Spa$Generated$Route$NewSettings__Locations__Top = {$: 198};
var $author$project$Spa$Generated$Route$NewSettings__PracticeInfo = {$: 83};
var $author$project$Spa$Generated$Route$NewSettings__Team = {$: 84};
var $author$project$Spa$Generated$Route$NewSettings__Team__TeamId_String = function (a) {
	return {$: 303, a: a};
};
var $author$project$Spa$Generated$Route$NewSettings__Team__TeamId_String__AiSettings = function (a) {
	return {$: 333, a: a};
};
var $author$project$Spa$Generated$Route$NewSettings__Team__TeamId_String__BasicInfo = function (a) {
	return {$: 334, a: a};
};
var $author$project$Spa$Generated$Route$NewSettings__Team__TeamId_String__CalendarAndAvailability = function (a) {
	return {$: 335, a: a};
};
var $author$project$Spa$Generated$Route$NewSettings__Templates__New = {$: 261};
var $author$project$Spa$Generated$Route$NewSettings__Templates__TemplateId_String = function (a) {
	return {$: 304, a: a};
};
var $author$project$Spa$Generated$Route$NewSettings__Templates__Top = {$: 199};
var $author$project$Spa$Generated$Route$Oauth__Callback = {$: 85};
var $author$project$Spa$Generated$Route$Onboard__DealId_String__Top = function (a) {
	return {$: 200, a: a};
};
var $author$project$Spa$Generated$Route$Onboard__OnboardId_String__Completed = function (a) {
	return {$: 262, a: a};
};
var $author$project$Spa$Generated$Route$Onboard__OnboardId_String__Completing = function (a) {
	return {$: 263, a: a};
};
var $author$project$Spa$Generated$Route$Onboard__OnboardId_String__Payment = function (a) {
	return {$: 264, a: a};
};
var $author$project$Spa$Generated$Route$Onboard__OnboardId_String__User = function (a) {
	return {$: 265, a: a};
};
var $author$project$Spa$Generated$Route$Onboarding = {$: 10};
var $author$project$Spa$Generated$Route$Partner__ApiKeys = {$: 86};
var $author$project$Spa$Generated$Route$Partner__Billing = {$: 87};
var $author$project$Spa$Generated$Route$Partner__Billing__Charges = {$: 266};
var $author$project$Spa$Generated$Route$Partner__Billing__Deposits = {$: 267};
var $author$project$Spa$Generated$Route$Partner__Billing__Hinter = {$: 268};
var $author$project$Spa$Generated$Route$Partner__Billing__ServiceFee = {$: 269};
var $author$project$Spa$Generated$Route$Partner__Billing__Subscriptions = {$: 270};
var $author$project$Spa$Generated$Route$Partner__Dashboard__Top = {$: 201};
var $author$project$Spa$Generated$Route$Partner__Engagements = {$: 88};
var $author$project$Spa$Generated$Route$Partner__Hinter = {$: 89};
var $author$project$Spa$Generated$Route$Partner__Practices__Top = {$: 202};
var $author$project$Spa$Generated$Route$Partner__Products__Id_String = function (a) {
	return {$: 305, a: a};
};
var $author$project$Spa$Generated$Route$Partner__Products__Id_String__ActivationSettings = function (a) {
	return {$: 336, a: a};
};
var $author$project$Spa$Generated$Route$Partner__Products__Id_String__AppBuilder = function (a) {
	return {$: 337, a: a};
};
var $author$project$Spa$Generated$Route$Partner__Products__Id_String__AppSettings = function (a) {
	return {$: 338, a: a};
};
var $author$project$Spa$Generated$Route$Partner__Products__Id_String__Hinter = function (a) {
	return {$: 339, a: a};
};
var $author$project$Spa$Generated$Route$Partner__Products__New = {$: 271};
var $author$project$Spa$Generated$Route$Partner__Sandboxes__Top = {$: 203};
var $author$project$Spa$Generated$Route$Partner__Team = {$: 90};
var $author$project$Spa$Generated$Route$Partner__Webhooks__Requests = {$: 272};
var $author$project$Spa$Generated$Route$Partner__Webhooks__Settings = {$: 273};
var $author$project$Spa$Generated$Route$Patients__Create = {$: 91};
var $author$project$Spa$Generated$Route$Patients__PatientId_String__Accounts__Top = function (a) {
	return {$: 315, a: a};
};
var $author$project$Spa$Generated$Route$Patients__PatientId_String__Affiliation__Top = function (a) {
	return {$: 316, a: a};
};
var $author$project$Spa$Generated$Route$Patients__PatientId_String__Agreements__AgreementId_String__Top = function (a) {
	return {$: 353, a: a};
};
var $author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top = function (a) {
	return {$: 354, a: a};
};
var $author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__Top = function (a) {
	return {$: 317, a: a};
};
var $author$project$Spa$Generated$Route$Patients__PatientId_String__Chart = function (a) {
	return {$: 274, a: a};
};
var $author$project$Spa$Generated$Route$Patients__PatientId_String__Edit = function (a) {
	return {$: 275, a: a};
};
var $author$project$Spa$Generated$Route$Patients__PatientId_String__GrowthChart = function (a) {
	return {$: 276, a: a};
};
var $author$project$Spa$Generated$Route$Patients__PatientId_String__LabTrends = function (a) {
	return {$: 277, a: a};
};
var $author$project$Spa$Generated$Route$Patients__PatientId_String__ManageCredits = function (a) {
	return {$: 278, a: a};
};
var $author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__MembershipId_String__Top = function (a) {
	return {$: 355, a: a};
};
var $author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__New = function (a) {
	return {$: 340, a: a};
};
var $author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__Top = function (a) {
	return {$: 318, a: a};
};
var $author$project$Spa$Generated$Route$Patients__PatientId_String__Merge = function (a) {
	return {$: 279, a: a};
};
var $author$project$Spa$Generated$Route$Patients__PatientId_String__Notes__NoteId_String = function (a) {
	return {$: 349, a: a};
};
var $author$project$Spa$Generated$Route$Patients__PatientId_String__Notes__Top = function (a) {
	return {$: 319, a: a};
};
var $author$project$Spa$Generated$Route$Patients__PatientId_String__Notifications__Top = function (a) {
	return {$: 320, a: a};
};
var $author$project$Spa$Generated$Route$Patients__PatientId_String__Top = function (a) {
	return {$: 204, a: a};
};
var $author$project$Spa$Generated$Route$Patients__PatientId_String__VitalsTrends = function (a) {
	return {$: 280, a: a};
};
var $author$project$Spa$Generated$Route$Patients__Top = {$: 17};
var $author$project$Spa$Generated$Route$Patients__Upload = {$: 92};
var $author$project$Spa$Generated$Route$PracticeSetup__Account = {$: 93};
var $author$project$Spa$Generated$Route$PracticeSetup__Communications = {$: 94};
var $author$project$Spa$Generated$Route$PracticeSetup__Complete = {$: 95};
var $author$project$Spa$Generated$Route$PracticeSetup__Documents = {$: 96};
var $author$project$Spa$Generated$Route$PracticeSetup__Legal = {$: 97};
var $author$project$Spa$Generated$Route$PracticeSetup__PaymentProcessing = {$: 98};
var $author$project$Spa$Generated$Route$PracticeSetup__Plans = {$: 99};
var $author$project$Spa$Generated$Route$PracticeSetup__Plans__Id_String__Edit = function (a) {
	return {$: 341, a: a};
};
var $author$project$Spa$Generated$Route$PracticeSetup__Plans__New = {$: 281};
var $author$project$Spa$Generated$Route$PracticeSetup__Team = {$: 100};
var $author$project$Spa$Generated$Route$PracticeSetup__Top = {$: 18};
var $author$project$Spa$Generated$Route$RefillRequests = {$: 11};
var $author$project$Spa$Generated$Route$Reports__AncillaryCharges__Id_String = function (a) {
	return {$: 306, a: a};
};
var $author$project$Spa$Generated$Route$Reports__AncillaryCharges__Top = {$: 205};
var $author$project$Spa$Generated$Route$Reports__CompanyInvoices = {$: 101};
var $author$project$Spa$Generated$Route$Reports__CreditOutstanding = {$: 102};
var $author$project$Spa$Generated$Route$Reports__CreditOutstanding__Summary = {$: 282};
var $author$project$Spa$Generated$Route$Reports__CreditTransactions = {$: 103};
var $author$project$Spa$Generated$Route$Reports__CreditTransactions__Summary = {$: 283};
var $author$project$Spa$Generated$Route$Reports__Custom__Id_String = function (a) {
	return {$: 307, a: a};
};
var $author$project$Spa$Generated$Route$Reports__Custom__New = {$: 284};
var $author$project$Spa$Generated$Route$Reports__Dashboard = {$: 104};
var $author$project$Spa$Generated$Route$Reports__DeferredRevenue = {$: 105};
var $author$project$Spa$Generated$Route$Reports__DeferredRevenue__Summary = {$: 285};
var $author$project$Spa$Generated$Route$Reports__Deposits = {$: 106};
var $author$project$Spa$Generated$Route$Reports__Disputes = {$: 107};
var $author$project$Spa$Generated$Route$Reports__Invoices = {$: 108};
var $author$project$Spa$Generated$Route$Reports__Memberships = {$: 109};
var $author$project$Spa$Generated$Route$Reports__Months = {$: 110};
var $author$project$Spa$Generated$Route$Reports__PatientPackages = {$: 111};
var $author$project$Spa$Generated$Route$Reports__PaymentApplications = {$: 112};
var $author$project$Spa$Generated$Route$Reports__PaymentApplications__Summary = {$: 286};
var $author$project$Spa$Generated$Route$Reports__Revenue = {$: 113};
var $author$project$Spa$Generated$Route$Reports__Revenue__Summary = {$: 287};
var $author$project$Spa$Generated$Route$Reports__SalesTax = {$: 114};
var $author$project$Spa$Generated$Route$Reports__SalesTax__Summary = {$: 288};
var $author$project$Spa$Generated$Route$Reports__SignupAttempts = {$: 115};
var $author$project$Spa$Generated$Route$StyleGuide__ActivityIndicators = {$: 116};
var $author$project$Spa$Generated$Route$StyleGuide__AddressInput = {$: 117};
var $author$project$Spa$Generated$Route$StyleGuide__Alert = {$: 118};
var $author$project$Spa$Generated$Route$StyleGuide__Badge = {$: 119};
var $author$project$Spa$Generated$Route$StyleGuide__Button = {$: 120};
var $author$project$Spa$Generated$Route$StyleGuide__Carousel = {$: 121};
var $author$project$Spa$Generated$Route$StyleGuide__Checkbox = {$: 122};
var $author$project$Spa$Generated$Route$StyleGuide__CurrencyInput = {$: 123};
var $author$project$Spa$Generated$Route$StyleGuide__DateInput = {$: 124};
var $author$project$Spa$Generated$Route$StyleGuide__DateRangeInput = {$: 125};
var $author$project$Spa$Generated$Route$StyleGuide__DragDrop = {$: 126};
var $author$project$Spa$Generated$Route$StyleGuide__Dropdown = {$: 127};
var $author$project$Spa$Generated$Route$StyleGuide__Element = {$: 128};
var $author$project$Spa$Generated$Route$StyleGuide__ExportCsv = {$: 129};
var $author$project$Spa$Generated$Route$StyleGuide__FileInput = {$: 130};
var $author$project$Spa$Generated$Route$StyleGuide__FlyoutMenu = {$: 131};
var $author$project$Spa$Generated$Route$StyleGuide__FormExample = {$: 132};
var $author$project$Spa$Generated$Route$StyleGuide__FormGroup = {$: 133};
var $author$project$Spa$Generated$Route$StyleGuide__FormStatic = {$: 134};
var $author$project$Spa$Generated$Route$StyleGuide__Grid = {$: 135};
var $author$project$Spa$Generated$Route$StyleGuide__HiConfirm = {$: 136};
var $author$project$Spa$Generated$Route$StyleGuide__HorizontalRule = {$: 137};
var $author$project$Spa$Generated$Route$StyleGuide__Icon = {$: 138};
var $author$project$Spa$Generated$Route$StyleGuide__Input = {$: 139};
var $author$project$Spa$Generated$Route$StyleGuide__Link = {$: 140};
var $author$project$Spa$Generated$Route$StyleGuide__ListGroup = {$: 141};
var $author$project$Spa$Generated$Route$StyleGuide__Modal = {$: 142};
var $author$project$Spa$Generated$Route$StyleGuide__OrderedList = {$: 143};
var $author$project$Spa$Generated$Route$StyleGuide__Pagination = {$: 144};
var $author$project$Spa$Generated$Route$StyleGuide__Panel = {$: 145};
var $author$project$Spa$Generated$Route$StyleGuide__PasswordInput = {$: 146};
var $author$project$Spa$Generated$Route$StyleGuide__PaymentSourceDisplayer = {$: 147};
var $author$project$Spa$Generated$Route$StyleGuide__PhoneInput = {$: 148};
var $author$project$Spa$Generated$Route$StyleGuide__Popover = {$: 149};
var $author$project$Spa$Generated$Route$StyleGuide__Pre = {$: 150};
var $author$project$Spa$Generated$Route$StyleGuide__ProgressBar = {$: 151};
var $author$project$Spa$Generated$Route$StyleGuide__Radio = {$: 152};
var $author$project$Spa$Generated$Route$StyleGuide__ResourceFilter = {$: 153};
var $author$project$Spa$Generated$Route$StyleGuide__SearchInput = {$: 154};
var $author$project$Spa$Generated$Route$StyleGuide__Select = {$: 155};
var $author$project$Spa$Generated$Route$StyleGuide__Skeleton = {$: 156};
var $author$project$Spa$Generated$Route$StyleGuide__Spinner = {$: 157};
var $author$project$Spa$Generated$Route$StyleGuide__Table = {$: 158};
var $author$project$Spa$Generated$Route$StyleGuide__Toast = {$: 159};
var $author$project$Spa$Generated$Route$StyleGuide__ToggleSwitch = {$: 160};
var $author$project$Spa$Generated$Route$StyleGuide__Tooltip = {$: 161};
var $author$project$Spa$Generated$Route$StyleGuide__Top = {$: 19};
var $author$project$Spa$Generated$Route$StyleGuide__Typography = {$: 162};
var $author$project$Spa$Generated$Route$StyleGuide__UploadForm = {$: 163};
var $author$project$Spa$Generated$Route$StyleGuide__UploadResult = {$: 164};
var $author$project$Spa$Generated$Route$StyleGuide__Well = {$: 165};
var $author$project$Spa$Generated$Route$Support__CannySso = {$: 166};
var $author$project$Spa$Generated$Route$Tasks__New = {$: 167};
var $author$project$Spa$Generated$Route$Tasks__TasksId_String__Top = function (a) {
	return {$: 206, a: a};
};
var $author$project$Spa$Generated$Route$Tasks__Top = {$: 20};
var $author$project$Spa$Generated$Route$Top = {$: 0};
var $author$project$Spa$Generated$Route$User__AcceptTerms = {$: 168};
var $author$project$Spa$Generated$Route$User__Mfa = {$: 169};
var $author$project$Spa$Generated$Route$User__Organizations__Top = {$: 207};
var $author$project$Spa$Generated$Route$User__Profile = {$: 170};
var $author$project$Spa$Generated$Route$User__Security = {$: 171};
var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var visited = _v0.l2;
		var unvisited = _v0.h2;
		var params = _v0.YL;
		var frag = _v0.jM;
		var value = _v0.aee;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0;
		return function (_v1) {
			var visited = _v1.l2;
			var unvisited = _v1.h2;
			var params = _v1.YL;
			var frag = _v1.jM;
			var value = _v1.aee;
			return A2(
				$elm$core$List$map,
				$elm$url$Url$Parser$mapState(value),
				parseArg(
					A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return function (state) {
		return A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var parser = _v0;
				return parser(state);
			},
			parsers);
	};
};
var $elm$url$Url$Parser$s = function (str) {
	return function (_v0) {
		var visited = _v0.l2;
		var unvisited = _v0.h2;
		var params = _v0.YL;
		var frag = _v0.jM;
		var value = _v0.aee;
		if (!unvisited.b) {
			return _List_Nil;
		} else {
			var next = unvisited.a;
			var rest = unvisited.b;
			return _Utils_eq(next, str) ? _List_fromArray(
				[
					A5(
					$elm$url$Url$Parser$State,
					A2($elm$core$List$cons, next, visited),
					rest,
					params,
					frag,
					value)
				]) : _List_Nil;
		}
	};
};
var $elm$url$Url$Parser$slash = F2(
	function (_v0, _v1) {
		var parseBefore = _v0;
		var parseAfter = _v1;
		return function (state) {
			return A2(
				$elm$core$List$concatMap,
				parseAfter,
				parseBefore(state));
		};
	});
var $elm$url$Url$Parser$custom = F2(
	function (tipe, stringToSomething) {
		return function (_v0) {
			var visited = _v0.l2;
			var unvisited = _v0.h2;
			var params = _v0.YL;
			var frag = _v0.jM;
			var value = _v0.aee;
			if (!unvisited.b) {
				return _List_Nil;
			} else {
				var next = unvisited.a;
				var rest = unvisited.b;
				var _v2 = stringToSomething(next);
				if (!_v2.$) {
					var nextValue = _v2.a;
					return _List_fromArray(
						[
							A5(
							$elm$url$Url$Parser$State,
							A2($elm$core$List$cons, next, visited),
							rest,
							params,
							frag,
							value(nextValue))
						]);
				} else {
					return _List_Nil;
				}
			}
		};
	});
var $elm$url$Url$Parser$string = A2($elm$url$Url$Parser$custom, 'STRING', $elm$core$Maybe$Just);
var $elm$url$Url$Parser$top = function (state) {
	return _List_fromArray(
		[state]);
};
var $author$project$Spa$Generated$Route$routes = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Top, $elm$url$Url$Parser$top),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Blank,
			$elm$url$Url$Parser$s('blank')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Bookkeeping,
			$elm$url$Url$Parser$s('bookkeeping')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Calendar,
			$elm$url$Url$Parser$s('calendar')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Forms,
			$elm$url$Url$Parser$s('forms')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$GoogleCallback,
			$elm$url$Url$Parser$s('google_callback')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Home,
			$elm$url$Url$Parser$s('home')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Login,
			$elm$url$Url$Parser$s('login')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Logout,
			$elm$url$Url$Parser$s('logout')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$NotFound,
			$elm$url$Url$Parser$s('not_found')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Onboarding,
			$elm$url$Url$Parser$s('onboarding')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$RefillRequests,
			$elm$url$Url$Parser$s('refill_requests')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$AffiliateBills__Top,
			$elm$url$Url$Parser$s('affiliate_bills')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Affiliates__Top,
			$elm$url$Url$Parser$s('affiliates')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Companies__Top,
			$elm$url$Url$Parser$s('companies')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Files__Top,
			$elm$url$Url$Parser$s('files')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Marketplace__Top,
			$elm$url$Url$Parser$s('marketplace')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Patients__Top,
			$elm$url$Url$Parser$s('patients')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$PracticeSetup__Top,
			$elm$url$Url$Parser$s('practice_setup')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Top,
			$elm$url$Url$Parser$s('style_guide')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Tasks__Top,
			$elm$url$Url$Parser$s('tasks')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Account__Complete,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('account'),
				$elm$url$Url$Parser$s('complete'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__AdvanceBilling,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('advance_billing'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Billing,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('billing'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__CancellationReasons,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('cancellation_reasons'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__CardReaders,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('card_readers'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Categories,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('categories'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Commissions,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('commissions'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Coupons,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('coupons'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__CreditCategories,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('credit_categories'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__ElationLegacy,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('elation_legacy'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Features,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('features'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__HipaaAuthorizations,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('hipaa_authorizations'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__InternalSettings,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('internal_settings'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__InvoiceSettings,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('invoice_settings'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__LeadSources,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('lead_sources'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Locations,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('locations'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Mailgun,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('mailgun'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Notes,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('notes'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Patients,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('patients'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__PaymentMethodImport,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('payment_method_import'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__PaymentProcessing,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('payment_processing'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__PaymentSources,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('payment_sources'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Practice,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('practice'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__ProviderGroups,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('provider_groups'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__ScheduledJobs,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('scheduled_jobs'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__SelfService,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('self_service'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Signup,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('signup'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Stripe,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('stripe'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Taxes,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('taxes'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Team,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('team'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Waitlist,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('waitlist'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Affiliates__Create,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('affiliates'),
				$elm$url$Url$Parser$s('create'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Affiliates__New,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('affiliates'),
				$elm$url$Url$Parser$s('new'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Charges__New,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('charges'),
				$elm$url$Url$Parser$s('new'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Commissions__Statements,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('commissions'),
				$elm$url$Url$Parser$s('statements'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Companies__New,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('companies'),
				$elm$url$Url$Parser$s('new'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Contacts__List,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('contacts'),
				$elm$url$Url$Parser$s('list'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Contacts__New,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('contacts'),
				$elm$url$Url$Parser$s('new'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Files__Public,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('files'),
				$elm$url$Url$Parser$s('public'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Hinter__ClonePractice,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('hinter'),
				$elm$url$Url$Parser$s('clone_practice'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Hinter__Disputes,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('hinter'),
				$elm$url$Url$Parser$s('disputes'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Hinter__FeatureFlags,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('hinter'),
				$elm$url$Url$Parser$s('feature_flags'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Hinter__NewGroup,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('hinter'),
				$elm$url$Url$Parser$s('new_group'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Hinter__NewPartner,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('hinter'),
				$elm$url$Url$Parser$s('new_partner'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Hinter__NewPractice,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('hinter'),
				$elm$url$Url$Parser$s('new_practice'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Inventory__List,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('inventory'),
				$elm$url$Url$Parser$s('list'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Inventory__New,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('inventory'),
				$elm$url$Url$Parser$s('new'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Inventory__Settings,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('inventory'),
				$elm$url$Url$Parser$s('settings'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Marketplace__Manage,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('marketplace'),
				$elm$url$Url$Parser$s('manage'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Messages__Calls,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('messages'),
				$elm$url$Url$Parser$s('calls'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Messages__Chat,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('messages'),
				$elm$url$Url$Parser$s('chat'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Messages__Drafts,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('messages'),
				$elm$url$Url$Parser$s('drafts'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Messages__Forms,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('messages'),
				$elm$url$Url$Parser$s('forms'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Messages__Inbox,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('messages'),
				$elm$url$Url$Parser$s('inbox'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Messages__Labs,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('messages'),
				$elm$url$Url$Parser$s('labs'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Messages__LegacyCalls,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('messages'),
				$elm$url$Url$Parser$s('legacy_calls'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Messages__Sms,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('messages'),
				$elm$url$Url$Parser$s('sms'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$NewSettings__BlockedPhoneNumbers,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('new_settings'),
				$elm$url$Url$Parser$s('blocked_phone_numbers'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$NewSettings__BookingOverview,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('new_settings'),
				$elm$url$Url$Parser$s('booking_overview'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$NewSettings__Erx,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('new_settings'),
				$elm$url$Url$Parser$s('erx'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$NewSettings__Export,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('new_settings'),
				$elm$url$Url$Parser$s('export'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$NewSettings__HinterSettings,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('new_settings'),
				$elm$url$Url$Parser$s('hinter_settings'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$NewSettings__PracticeInfo,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('new_settings'),
				$elm$url$Url$Parser$s('practice_info'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$NewSettings__Team,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('new_settings'),
				$elm$url$Url$Parser$s('team'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Oauth__Callback,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('oauth'),
				$elm$url$Url$Parser$s('callback'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Partner__ApiKeys,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('partner'),
				$elm$url$Url$Parser$s('api_keys'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Partner__Billing,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('partner'),
				$elm$url$Url$Parser$s('billing'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Partner__Engagements,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('partner'),
				$elm$url$Url$Parser$s('engagements'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Partner__Hinter,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('partner'),
				$elm$url$Url$Parser$s('hinter'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Partner__Team,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('partner'),
				$elm$url$Url$Parser$s('team'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Patients__Create,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('patients'),
				$elm$url$Url$Parser$s('create'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Patients__Upload,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('patients'),
				$elm$url$Url$Parser$s('upload'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$PracticeSetup__Account,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('practice_setup'),
				$elm$url$Url$Parser$s('account'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$PracticeSetup__Communications,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('practice_setup'),
				$elm$url$Url$Parser$s('communications'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$PracticeSetup__Complete,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('practice_setup'),
				$elm$url$Url$Parser$s('complete'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$PracticeSetup__Documents,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('practice_setup'),
				$elm$url$Url$Parser$s('documents'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$PracticeSetup__Legal,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('practice_setup'),
				$elm$url$Url$Parser$s('legal'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$PracticeSetup__PaymentProcessing,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('practice_setup'),
				$elm$url$Url$Parser$s('payment_processing'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$PracticeSetup__Plans,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('practice_setup'),
				$elm$url$Url$Parser$s('plans'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$PracticeSetup__Team,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('practice_setup'),
				$elm$url$Url$Parser$s('team'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__CompanyInvoices,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reports'),
				$elm$url$Url$Parser$s('company_invoices'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__CreditOutstanding,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reports'),
				$elm$url$Url$Parser$s('credit_outstanding'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__CreditTransactions,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reports'),
				$elm$url$Url$Parser$s('credit_transactions'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__Dashboard,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reports'),
				$elm$url$Url$Parser$s('dashboard'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__DeferredRevenue,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reports'),
				$elm$url$Url$Parser$s('deferred_revenue'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__Deposits,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reports'),
				$elm$url$Url$Parser$s('deposits'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__Disputes,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reports'),
				$elm$url$Url$Parser$s('disputes'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__Invoices,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reports'),
				$elm$url$Url$Parser$s('invoices'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__Memberships,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reports'),
				$elm$url$Url$Parser$s('memberships'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__Months,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reports'),
				$elm$url$Url$Parser$s('months'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__PatientPackages,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reports'),
				$elm$url$Url$Parser$s('patient_packages'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__PaymentApplications,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reports'),
				$elm$url$Url$Parser$s('payment_applications'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__Revenue,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reports'),
				$elm$url$Url$Parser$s('revenue'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__SalesTax,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reports'),
				$elm$url$Url$Parser$s('sales_tax'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__SignupAttempts,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reports'),
				$elm$url$Url$Parser$s('signup_attempts'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__ActivityIndicators,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('activity_indicators'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__AddressInput,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('address_input'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Alert,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('alert'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Badge,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('badge'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Button,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('button'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Carousel,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('carousel'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Checkbox,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('checkbox'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__CurrencyInput,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('currency_input'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__DateInput,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('date_input'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__DateRangeInput,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('date_range_input'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__DragDrop,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('drag_drop'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Dropdown,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('dropdown'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Element,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('element'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__ExportCsv,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('export_csv'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__FileInput,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('file_input'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__FlyoutMenu,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('flyout_menu'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__FormExample,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('form_example'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__FormGroup,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('form_group'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__FormStatic,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('form_static'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Grid,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('grid'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__HiConfirm,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('hi_confirm'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__HorizontalRule,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('horizontal_rule'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Icon,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('icon'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Input,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('input'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Link,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('link'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__ListGroup,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('list_group'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Modal,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('modal'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__OrderedList,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('ordered_list'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Pagination,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('pagination'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Panel,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('panel'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__PasswordInput,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('password_input'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__PaymentSourceDisplayer,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('payment_source_displayer'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__PhoneInput,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('phone_input'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Popover,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('popover'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Pre,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('pre'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__ProgressBar,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('progress_bar'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Radio,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('radio'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__ResourceFilter,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('resource_filter'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__SearchInput,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('search_input'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Select,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('select'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Skeleton,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('skeleton'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Spinner,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('spinner'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Table,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('table'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Toast,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('toast'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__ToggleSwitch,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('toggle_switch'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Tooltip,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('tooltip'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Typography,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('typography'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__UploadForm,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('upload_form'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__UploadResult,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('upload_result'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Well,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('well'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Support__CannySso,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('support'),
				$elm$url$Url$Parser$s('canny_sso'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Tasks__New,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('tasks'),
				$elm$url$Url$Parser$s('new'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$User__AcceptTerms,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				$elm$url$Url$Parser$s('accept_terms'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$User__Mfa,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				$elm$url$Url$Parser$s('mfa'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$User__Profile,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				$elm$url$Url$Parser$s('profile'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$User__Security,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				$elm$url$Url$Parser$s('security'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Apps__Slug_String,
			A2(
				$elm$url$Url$Parser$map,
				function (slug) {
					return {abG: slug};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('apps'),
					$elm$url$Url$Parser$string))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Error__Status_String,
			A2(
				$elm$url$Url$Parser$map,
				function (status) {
					return {alH: status};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('error'),
					$elm$url$Url$Parser$string))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Join__Token_String,
			A2(
				$elm$url$Url$Parser$map,
				function (token) {
					return {adi: token};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('join'),
					$elm$url$Url$Parser$string))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Marketplace__Slug_String,
			A2(
				$elm$url$Url$Parser$map,
				function (slug) {
					return {abG: slug};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('marketplace'),
					$elm$url$Url$Parser$string))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Athenahealth__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('athenahealth'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__ChargeItems__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('charge_items'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__CompanyPlans__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('company_plans'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__CoveragePlans__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('coverage_plans'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__DataExport__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('data_export'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__DataExportSettings__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('data_export_settings'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Documents__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('documents'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Elation__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('elation'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Plans__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('plans'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Providers__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('providers'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Quickbooks__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('quickbooks'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__SignupPages__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('signup_pages'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$CcdaImports__CcdaId_String__Top,
			A2(
				$elm$url$Url$Parser$map,
				function (ccdaId) {
					return {afv: ccdaId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('ccda_imports'),
					$elm$url$Url$Parser$string))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('commissions'),
				$elm$url$Url$Parser$s('broker_accounts'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Commissions__StatementLines__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('commissions'),
				$elm$url$Url$Parser$s('statement_lines'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Companies__CompanyId_String__Top,
			A2(
				$elm$url$Url$Parser$map,
				function (companyId) {
					return {fZ: companyId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('companies'),
					$elm$url$Url$Parser$string))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Contacts__ContactId_String__Top,
			A2(
				$elm$url$Url$Parser$map,
				function (contactId) {
					return {afW: contactId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('contacts'),
					$elm$url$Url$Parser$string))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Hinter__AdminUsersGroups__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('hinter'),
				$elm$url$Url$Parser$s('admin_users_groups'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Inventory__InventoryId_String__Top,
			A2(
				$elm$url$Url$Parser$map,
				function (inventoryId) {
					return {ah4: inventoryId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('inventory'),
					$elm$url$Url$Parser$string))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Messages__Faxes__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('messages'),
				$elm$url$Url$Parser$s('faxes'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Messages__Scheduled__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('messages'),
				$elm$url$Url$Parser$s('scheduled'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$NewSettings__AppointmentTypes__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('new_settings'),
				$elm$url$Url$Parser$s('appointment_types'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$NewSettings__Locations__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('new_settings'),
				$elm$url$Url$Parser$s('locations'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$NewSettings__Templates__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('new_settings'),
				$elm$url$Url$Parser$s('templates'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Onboard__DealId_String__Top,
			A2(
				$elm$url$Url$Parser$map,
				function (dealId) {
					return {agc: dealId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('onboard'),
					$elm$url$Url$Parser$string))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Partner__Dashboard__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('partner'),
				$elm$url$Url$Parser$s('dashboard'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Partner__Practices__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('partner'),
				$elm$url$Url$Parser$s('practices'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Partner__Sandboxes__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('partner'),
				$elm$url$Url$Parser$s('sandboxes'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__Top,
			A2(
				$elm$url$Url$Parser$map,
				function (patientId) {
					return {YZ: patientId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('patients'),
					$elm$url$Url$Parser$string))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__AncillaryCharges__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reports'),
				$elm$url$Url$Parser$s('ancillary_charges'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Tasks__TasksId_String__Top,
			A2(
				$elm$url$Url$Parser$map,
				function (tasksId) {
					return {alV: tasksId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('tasks'),
					$elm$url$Url$Parser$string))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$User__Organizations__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				$elm$url$Url$Parser$s('organizations'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Athenahealth__Fields,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('athenahealth'),
					$elm$url$Url$Parser$s('fields')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Athenahealth__Link,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('athenahealth'),
					$elm$url$Url$Parser$s('link')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Athenahealth__Locations,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('athenahealth'),
					$elm$url$Url$Parser$s('locations')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Athenahealth__Overview,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('athenahealth'),
					$elm$url$Url$Parser$s('overview')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Athenahealth__Providers,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('athenahealth'),
					$elm$url$Url$Parser$s('providers')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__ChargeItems__New,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('charge_items'),
					$elm$url$Url$Parser$s('new')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__ChargeItems__Upload,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('charge_items'),
					$elm$url$Url$Parser$s('upload')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__CompanyPlans__New,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('company_plans'),
					$elm$url$Url$Parser$s('new')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__CoveragePlans__New,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('coverage_plans'),
					$elm$url$Url$Parser$s('new')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Credits__Upload,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('credits'),
					$elm$url$Url$Parser$s('upload')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__DataExportSettings__New,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('data_export_settings'),
					$elm$url$Url$Parser$s('new')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Developers__ApiKeys,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('developers'),
					$elm$url$Url$Parser$s('api_keys')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Developers__App,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('developers'),
					$elm$url$Url$Parser$s('app')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Developers__GetStarted,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('developers'),
					$elm$url$Url$Parser$s('get_started')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Developers__Hinter,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('developers'),
					$elm$url$Url$Parser$s('hinter')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Developers__Sandboxes,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('developers'),
					$elm$url$Url$Parser$s('sandboxes')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Developers__WebhookEndpoints,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('developers'),
					$elm$url$Url$Parser$s('webhook_endpoints')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Documents__New,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('documents'),
					$elm$url$Url$Parser$s('new')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Elation__Link,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('elation'),
					$elm$url$Url$Parser$s('link')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Elation__Overview,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('elation'),
					$elm$url$Url$Parser$s('overview')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Elation__Providers,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('elation'),
					$elm$url$Url$Parser$s('providers')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Notifications__Company,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('notifications'),
					$elm$url$Url$Parser$s('company')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Notifications__Employee,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('notifications'),
					$elm$url$Url$Parser$s('employee')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Notifications__Membership,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('notifications'),
					$elm$url$Url$Parser$s('membership')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Notifications__Patient,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('notifications'),
					$elm$url$Url$Parser$s('patient')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Notifications__Practice,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('notifications'),
					$elm$url$Url$Parser$s('practice')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Notifications__Settings,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('notifications'),
					$elm$url$Url$Parser$s('settings')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__PaymentMethodImport__Upload,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('payment_method_import'),
					$elm$url$Url$Parser$s('upload')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Plans__New,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('plans'),
					$elm$url$Url$Parser$s('new')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Providers__Upload,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('providers'),
					$elm$url$Url$Parser$s('upload')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__SignupPages__New,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('signup_pages'),
					$elm$url$Url$Parser$s('new')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Team__New,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('team'),
					$elm$url$Url$Parser$s('new')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__AffiliateActions,
			A2(
				$elm$url$Url$Parser$map,
				function (affiliateId) {
					return {rd: affiliateId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('affiliates'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('affiliate_actions'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__LinkProviders,
			A2(
				$elm$url$Url$Parser$map,
				function (affiliateId) {
					return {rd: affiliateId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('affiliates'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('link_providers'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__LinkedProviders,
			A2(
				$elm$url$Url$Parser$map,
				function (affiliateId) {
					return {rd: affiliateId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('affiliates'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('linked_providers'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Patients,
			A2(
				$elm$url$Url$Parser$map,
				function (affiliateId) {
					return {rd: affiliateId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('affiliates'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('patients'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Settings,
			A2(
				$elm$url$Url$Parser$map,
				function (affiliateId) {
					return {rd: affiliateId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('affiliates'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('settings'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Users,
			A2(
				$elm$url$Url$Parser$map,
				function (affiliateId) {
					return {rd: affiliateId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('affiliates'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('users'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__New,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('commissions'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('broker_accounts'),
					$elm$url$Url$Parser$s('new')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Commissions__StatementLines__Summary,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('commissions'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('statement_lines'),
					$elm$url$Url$Parser$s('summary')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Companies__CompanyId_String__AffiliatesPricing,
			A2(
				$elm$url$Url$Parser$map,
				function (companyId) {
					return {fZ: companyId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('companies'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('affiliates_pricing'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Companies__CompanyId_String__Eas,
			A2(
				$elm$url$Url$Parser$map,
				function (companyId) {
					return {fZ: companyId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('companies'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('eas'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Companies__CompanyId_String__EndedCommissions,
			A2(
				$elm$url$Url$Parser$map,
				function (companyId) {
					return {fZ: companyId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('companies'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('ended_commissions'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Companies__CompanyId_String__InvoiceSettings,
			A2(
				$elm$url$Url$Parser$map,
				function (companyId) {
					return {fZ: companyId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('companies'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('invoice_settings'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Companies__CompanyId_String__Notes,
			A2(
				$elm$url$Url$Parser$map,
				function (companyId) {
					return {fZ: companyId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('companies'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('notes'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Companies__CompanyId_String__Notifications,
			A2(
				$elm$url$Url$Parser$map,
				function (companyId) {
					return {fZ: companyId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('companies'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('notifications'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Companies__CompanyId_String__PaymentSources,
			A2(
				$elm$url$Url$Parser$map,
				function (companyId) {
					return {fZ: companyId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('companies'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('payment_sources'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Companies__CompanyId_String__Signup,
			A2(
				$elm$url$Url$Parser$map,
				function (companyId) {
					return {fZ: companyId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('companies'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('signup'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Messages__Fax__New,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('messages'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('fax'),
					$elm$url$Url$Parser$s('new')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Messages__Faxes__New,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('messages'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('faxes'),
					$elm$url$Url$Parser$s('new')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Messages__Scheduled__New,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('messages'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('scheduled'),
					$elm$url$Url$Parser$s('new')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Messages__ScheduledMessages__New,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('messages'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('scheduled_messages'),
					$elm$url$Url$Parser$s('new')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$NewSettings__AppointmentTypes__New,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('new_settings'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('appointment_types'),
					$elm$url$Url$Parser$s('new')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$NewSettings__Templates__New,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('new_settings'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('templates'),
					$elm$url$Url$Parser$s('new')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Onboard__OnboardId_String__Completed,
			A2(
				$elm$url$Url$Parser$map,
				function (onboardId) {
					return {ajz: onboardId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('onboard'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('completed'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Onboard__OnboardId_String__Completing,
			A2(
				$elm$url$Url$Parser$map,
				function (onboardId) {
					return {ajz: onboardId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('onboard'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('completing'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Onboard__OnboardId_String__Payment,
			A2(
				$elm$url$Url$Parser$map,
				function (onboardId) {
					return {ajz: onboardId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('onboard'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('payment'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Onboard__OnboardId_String__User,
			A2(
				$elm$url$Url$Parser$map,
				function (onboardId) {
					return {ajz: onboardId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('onboard'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('user'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Partner__Billing__Charges,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('partner'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('billing'),
					$elm$url$Url$Parser$s('charges')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Partner__Billing__Deposits,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('partner'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('billing'),
					$elm$url$Url$Parser$s('deposits')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Partner__Billing__Hinter,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('partner'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('billing'),
					$elm$url$Url$Parser$s('hinter')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Partner__Billing__ServiceFee,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('partner'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('billing'),
					$elm$url$Url$Parser$s('service_fee')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Partner__Billing__Subscriptions,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('partner'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('billing'),
					$elm$url$Url$Parser$s('subscriptions')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Partner__Products__New,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('partner'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('products'),
					$elm$url$Url$Parser$s('new')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Partner__Webhooks__Requests,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('partner'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('webhooks'),
					$elm$url$Url$Parser$s('requests')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Partner__Webhooks__Settings,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('partner'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('webhooks'),
					$elm$url$Url$Parser$s('settings')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__Chart,
			A2(
				$elm$url$Url$Parser$map,
				function (patientId) {
					return {YZ: patientId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('patients'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('chart'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__Edit,
			A2(
				$elm$url$Url$Parser$map,
				function (patientId) {
					return {YZ: patientId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('patients'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('edit'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__GrowthChart,
			A2(
				$elm$url$Url$Parser$map,
				function (patientId) {
					return {YZ: patientId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('patients'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('growth_chart'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__LabTrends,
			A2(
				$elm$url$Url$Parser$map,
				function (patientId) {
					return {YZ: patientId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('patients'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('lab_trends'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__ManageCredits,
			A2(
				$elm$url$Url$Parser$map,
				function (patientId) {
					return {YZ: patientId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('patients'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('manage_credits'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__Merge,
			A2(
				$elm$url$Url$Parser$map,
				function (patientId) {
					return {YZ: patientId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('patients'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('merge'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__VitalsTrends,
			A2(
				$elm$url$Url$Parser$map,
				function (patientId) {
					return {YZ: patientId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('patients'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('vitals_trends'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$PracticeSetup__Plans__New,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('practice_setup'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('plans'),
					$elm$url$Url$Parser$s('new')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__CreditOutstanding__Summary,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reports'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('credit_outstanding'),
					$elm$url$Url$Parser$s('summary')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__CreditTransactions__Summary,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reports'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('credit_transactions'),
					$elm$url$Url$Parser$s('summary')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__Custom__New,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reports'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('custom'),
					$elm$url$Url$Parser$s('new')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__DeferredRevenue__Summary,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reports'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('deferred_revenue'),
					$elm$url$Url$Parser$s('summary')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__PaymentApplications__Summary,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reports'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('payment_applications'),
					$elm$url$Url$Parser$s('summary')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__Revenue__Summary,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reports'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('revenue'),
					$elm$url$Url$Parser$s('summary')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__SalesTax__Summary,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reports'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('sales_tax'),
					$elm$url$Url$Parser$s('summary')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__ChargeItems__Id_String,
			A2(
				$elm$url$Url$Parser$map,
				function (id) {
					return {ahP: id};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('admin'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('charge_items'),
						$elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__CompanyPlans__Id_String,
			A2(
				$elm$url$Url$Parser$map,
				function (id) {
					return {ahP: id};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('admin'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('company_plans'),
						$elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__CoveragePlans__Id_String,
			A2(
				$elm$url$Url$Parser$map,
				function (id) {
					return {ahP: id};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('admin'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('coverage_plans'),
						$elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__DataExport__Id_String,
			A2(
				$elm$url$Url$Parser$map,
				function (id) {
					return {ahP: id};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('admin'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('data_export'),
						$elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__DataExportSettings__Id_String,
			A2(
				$elm$url$Url$Parser$map,
				function (id) {
					return {ahP: id};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('admin'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('data_export_settings'),
						$elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Documents__Id_String,
			A2(
				$elm$url$Url$Parser$map,
				function (id) {
					return {ahP: id};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('admin'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('documents'),
						$elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Integrations__Slug_String,
			A2(
				$elm$url$Url$Parser$map,
				function (slug) {
					return {abG: slug};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('admin'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('integrations'),
						$elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Plans__Id_String,
			A2(
				$elm$url$Url$Parser$map,
				function (id) {
					return {ahP: id};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('admin'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('plans'),
						$elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__SignupPages__Id_String,
			A2(
				$elm$url$Url$Parser$map,
				function (id) {
					return {ahP: id};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('admin'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('signup_pages'),
						$elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Hinter__AdminUsersGroups__Id_String,
			A2(
				$elm$url$Url$Parser$map,
				function (id) {
					return {ahP: id};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('hinter'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('admin_users_groups'),
						$elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Messages__Faxes__MessageId_String,
			A2(
				$elm$url$Url$Parser$map,
				function (messageId) {
					return {aiI: messageId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('messages'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('faxes'),
						$elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Messages__Sms__PhoneNumber_String,
			A2(
				$elm$url$Url$Parser$map,
				function (phoneNumber) {
					return {Zx: phoneNumber};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('messages'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('sms'),
						$elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$NewSettings__AppointmentTypes__Ident_String,
			A2(
				$elm$url$Url$Parser$map,
				function (ident) {
					return {ahQ: ident};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('new_settings'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('appointment_types'),
						$elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$NewSettings__Locations__BookingLocationId_String,
			A2(
				$elm$url$Url$Parser$map,
				function (bookingLocationId) {
					return {afk: bookingLocationId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('new_settings'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('locations'),
						$elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$NewSettings__Team__TeamId_String,
			A2(
				$elm$url$Url$Parser$map,
				function (teamId) {
					return {alX: teamId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('new_settings'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('team'),
						$elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$NewSettings__Templates__TemplateId_String,
			A2(
				$elm$url$Url$Parser$map,
				function (templateId) {
					return {alY: templateId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('new_settings'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('templates'),
						$elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Partner__Products__Id_String,
			A2(
				$elm$url$Url$Parser$map,
				function (id) {
					return {ahP: id};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('partner'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('products'),
						$elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__AncillaryCharges__Id_String,
			A2(
				$elm$url$Url$Parser$map,
				function (id) {
					return {ahP: id};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('reports'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('ancillary_charges'),
						$elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__Custom__Id_String,
			A2(
				$elm$url$Url$Parser$map,
				function (id) {
					return {ahP: id};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('reports'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('custom'),
						$elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Top,
			A2(
				$elm$url$Url$Parser$map,
				function (affiliateId) {
					return {rd: affiliateId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('affiliates'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('bills'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Top,
			A2(
				$elm$url$Url$Parser$map,
				function (brokerAccountId) {
					return {cm: brokerAccountId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('commissions'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('broker_accounts'),
						$elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top,
			A2(
				$elm$url$Url$Parser$map,
				function (companyId) {
					return {fZ: companyId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('companies'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('employees'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Top,
			A2(
				$elm$url$Url$Parser$map,
				function (companyId) {
					return {fZ: companyId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('companies'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('invoices'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__Top,
			A2(
				$elm$url$Url$Parser$map,
				function (companyId) {
					return {fZ: companyId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('companies'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('uploads'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Messages__Scheduled__ScheduledId_String__Top,
			A2(
				$elm$url$Url$Parser$map,
				function (scheduledId) {
					return {ald: scheduledId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('messages'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('scheduled'),
						$elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Messages__ScheduledMessages__ScheduledEventId_String__Top,
			A2(
				$elm$url$Url$Parser$map,
				function (scheduledEventId) {
					return {alc: scheduledEventId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('messages'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('scheduled_messages'),
						$elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__Accounts__Top,
			A2(
				$elm$url$Url$Parser$map,
				function (patientId) {
					return {YZ: patientId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('patients'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('accounts'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__Affiliation__Top,
			A2(
				$elm$url$Url$Parser$map,
				function (patientId) {
					return {YZ: patientId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('patients'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('affiliation'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__Top,
			A2(
				$elm$url$Url$Parser$map,
				function (patientId) {
					return {YZ: patientId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('patients'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('charges'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__Top,
			A2(
				$elm$url$Url$Parser$map,
				function (patientId) {
					return {YZ: patientId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('patients'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('memberships'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__Notes__Top,
			A2(
				$elm$url$Url$Parser$map,
				function (patientId) {
					return {YZ: patientId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('patients'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('notes'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__Notifications__Top,
			A2(
				$elm$url$Url$Parser$map,
				function (patientId) {
					return {YZ: patientId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('patients'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('notifications'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Notifications__Patient__DunningSchedule,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('notifications'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('patient'),
						$elm$url$Url$Parser$s('dunning_schedule'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Deals,
			A2(
				$elm$url$Url$Parser$map,
				function (brokerAccountId) {
					return {cm: brokerAccountId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('commissions'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('broker_accounts'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							$elm$url$Url$Parser$s('deals')))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__EndedDeals,
			A2(
				$elm$url$Url$Parser$map,
				function (brokerAccountId) {
					return {cm: brokerAccountId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('commissions'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('broker_accounts'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							$elm$url$Url$Parser$s('ended_deals')))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Create,
			A2(
				$elm$url$Url$Parser$map,
				function (companyId) {
					return {fZ: companyId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('companies'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('employees'),
							$elm$url$Url$Parser$s('create')))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Companies__CompanyId_String__SignupPages__New,
			A2(
				$elm$url$Url$Parser$map,
				function (companyId) {
					return {fZ: companyId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('companies'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('signup_pages'),
							$elm$url$Url$Parser$s('new')))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Marketplace__Athenahealth__Manage__Settings,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('marketplace'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('athenahealth'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('manage'),
						$elm$url$Url$Parser$s('settings'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Marketplace__Bookkeeping__Manage__Settings,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('marketplace'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('bookkeeping'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('manage'),
						$elm$url$Url$Parser$s('settings'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Marketplace__Elation__Manage__Settings,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('marketplace'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('elation'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('manage'),
						$elm$url$Url$Parser$s('settings'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Marketplace__Quickbooks__Manage__Settings,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('marketplace'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('quickbooks'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('manage'),
						$elm$url$Url$Parser$s('settings'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Onboarding,
			A2(
				$elm$url$Url$Parser$map,
				function (slug) {
					return {abG: slug};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('marketplace'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('manage'),
							$elm$url$Url$Parser$s('onboarding')))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Settings,
			A2(
				$elm$url$Url$Parser$map,
				function (slug) {
					return {abG: slug};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('marketplace'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('manage'),
							$elm$url$Url$Parser$s('settings')))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Users,
			A2(
				$elm$url$Url$Parser$map,
				function (slug) {
					return {abG: slug};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('marketplace'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('manage'),
							$elm$url$Url$Parser$s('users')))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$NewSettings__Team__TeamId_String__AiSettings,
			A2(
				$elm$url$Url$Parser$map,
				function (teamId) {
					return {alX: teamId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('new_settings'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('team'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							$elm$url$Url$Parser$s('ai_settings')))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$NewSettings__Team__TeamId_String__BasicInfo,
			A2(
				$elm$url$Url$Parser$map,
				function (teamId) {
					return {alX: teamId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('new_settings'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('team'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							$elm$url$Url$Parser$s('basic_info')))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$NewSettings__Team__TeamId_String__CalendarAndAvailability,
			A2(
				$elm$url$Url$Parser$map,
				function (teamId) {
					return {alX: teamId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('new_settings'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('team'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							$elm$url$Url$Parser$s('calendar_and_availability')))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Partner__Products__Id_String__ActivationSettings,
			A2(
				$elm$url$Url$Parser$map,
				function (id) {
					return {ahP: id};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('partner'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('products'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							$elm$url$Url$Parser$s('activation_settings')))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Partner__Products__Id_String__AppBuilder,
			A2(
				$elm$url$Url$Parser$map,
				function (id) {
					return {ahP: id};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('partner'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('products'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							$elm$url$Url$Parser$s('app_builder')))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Partner__Products__Id_String__AppSettings,
			A2(
				$elm$url$Url$Parser$map,
				function (id) {
					return {ahP: id};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('partner'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('products'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							$elm$url$Url$Parser$s('app_settings')))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Partner__Products__Id_String__Hinter,
			A2(
				$elm$url$Url$Parser$map,
				function (id) {
					return {ahP: id};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('partner'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('products'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							$elm$url$Url$Parser$s('hinter')))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__New,
			A2(
				$elm$url$Url$Parser$map,
				function (patientId) {
					return {YZ: patientId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('patients'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('memberships'),
							$elm$url$Url$Parser$s('new')))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$PracticeSetup__Plans__Id_String__Edit,
			A2(
				$elm$url$Url$Parser$map,
				function (id) {
					return {ahP: id};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('practice_setup'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('plans'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							$elm$url$Url$Parser$s('edit')))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Billing__PracticeInvoices__Id_String,
			A2(
				$elm$url$Url$Parser$map,
				function (id) {
					return {ahP: id};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('admin'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('billing'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('practice_invoices'),
							$elm$url$Url$Parser$string))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Id_String,
			A2(
				$elm$url$Url$Parser$map,
				F2(
					function (affiliateId, id) {
						return {rd: affiliateId, ahP: id};
					}),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('affiliates'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('bills'),
							$elm$url$Url$Parser$string))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String,
			A2(
				$elm$url$Url$Parser$map,
				F2(
					function (companyId, id) {
						return {fZ: companyId, ahP: id};
					}),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('companies'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('invoices'),
							$elm$url$Url$Parser$string))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Companies__CompanyId_String__SignupPages__Id_String,
			A2(
				$elm$url$Url$Parser$map,
				F2(
					function (companyId, id) {
						return {fZ: companyId, ahP: id};
					}),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('companies'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('signup_pages'),
							$elm$url$Url$Parser$string))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Messages__Sms__PhoneNumber_String__PracticeNumber_String,
			A2(
				$elm$url$Url$Parser$map,
				F2(
					function (phoneNumber, practiceNumber) {
						return {Zx: phoneNumber, aj7: practiceNumber};
					}),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('messages'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('sms'),
						A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$string))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Messages__V2__Faxes__MessageId_String,
			A2(
				$elm$url$Url$Parser$map,
				function (messageId) {
					return {aiI: messageId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('messages'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('v2'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('faxes'),
							$elm$url$Url$Parser$string))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$NewSettings__Locations__New__LocationId_String,
			A2(
				$elm$url$Url$Parser$map,
				function (locationId) {
					return {We: locationId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('new_settings'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('locations'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('new'),
							$elm$url$Url$Parser$string))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__Notes__NoteId_String,
			A2(
				$elm$url$Url$Parser$map,
				F2(
					function (patientId, noteId) {
						return {ai7: noteId, YZ: patientId};
					}),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('patients'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('notes'),
							$elm$url$Url$Parser$string))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top,
			A2(
				$elm$url$Url$Parser$map,
				function (brokerAccountId) {
					return {cm: brokerAccountId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('commissions'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('broker_accounts'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							$elm$url$Url$Parser$s('brokers')))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__Top,
			A2(
				$elm$url$Url$Parser$map,
				function (brokerAccountId) {
					return {cm: brokerAccountId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('commissions'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('broker_accounts'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							$elm$url$Url$Parser$s('statements')))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__UploadId_String__Top,
			A2(
				$elm$url$Url$Parser$map,
				F2(
					function (companyId, uploadId) {
						return {fZ: companyId, Kj: uploadId};
					}),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('companies'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('uploads'),
							$elm$url$Url$Parser$string))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__Agreements__AgreementId_String__Top,
			A2(
				$elm$url$Url$Parser$map,
				F2(
					function (patientId, agreementId) {
						return {Ll: agreementId, YZ: patientId};
					}),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('patients'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('agreements'),
							$elm$url$Url$Parser$string))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top,
			A2(
				$elm$url$Url$Parser$map,
				F2(
					function (patientId, invoiceId) {
						return {Us: invoiceId, YZ: patientId};
					}),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('patients'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('charges'),
							$elm$url$Url$Parser$string))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__MembershipId_String__Top,
			A2(
				$elm$url$Url$Parser$map,
				F2(
					function (patientId, membershipId) {
						return {AW: membershipId, YZ: patientId};
					}),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('patients'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('memberships'),
							$elm$url$Url$Parser$string))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Plans__Id_String__PricingVersions__New,
			A2(
				$elm$url$Url$Parser$map,
				function (id) {
					return {ahP: id};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('admin'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('plans'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							A2(
								$elm$url$Url$Parser$slash,
								$elm$url$Url$Parser$s('pricing_versions'),
								$elm$url$Url$Parser$s('new'))))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Ended,
			A2(
				$elm$url$Url$Parser$map,
				function (brokerAccountId) {
					return {cm: brokerAccountId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('commissions'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('broker_accounts'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							A2(
								$elm$url$Url$Parser$slash,
								$elm$url$Url$Parser$s('brokers'),
								$elm$url$Url$Parser$s('ended'))))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__New,
			A2(
				$elm$url$Url$Parser$map,
				function (brokerAccountId) {
					return {cm: brokerAccountId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('commissions'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('broker_accounts'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							A2(
								$elm$url$Url$Parser$slash,
								$elm$url$Url$Parser$s('brokers'),
								$elm$url$Url$Parser$s('new'))))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__UploadId_String__UploadResults,
			A2(
				$elm$url$Url$Parser$map,
				F2(
					function (companyId, uploadId) {
						return {fZ: companyId, Kj: uploadId};
					}),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('companies'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('uploads'),
							A2(
								$elm$url$Url$Parser$slash,
								$elm$url$Url$Parser$string,
								$elm$url$Url$Parser$s('upload_results'))))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Plans__Id_String__PricingVersions__PricingVersionId_String,
			A2(
				$elm$url$Url$Parser$map,
				F2(
					function (id, pricingVersionId) {
						return {ahP: id, akh: pricingVersionId};
					}),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('admin'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('plans'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							A2(
								$elm$url$Url$Parser$slash,
								$elm$url$Url$Parser$s('pricing_versions'),
								$elm$url$Url$Parser$string)))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__StatementId_String,
			A2(
				$elm$url$Url$Parser$map,
				F2(
					function (brokerAccountId, statementId) {
						return {cm: brokerAccountId, alG: statementId};
					}),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('commissions'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('broker_accounts'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							A2(
								$elm$url$Url$Parser$slash,
								$elm$url$Url$Parser$s('statements'),
								$elm$url$Url$Parser$string)))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Messages__Legacy__Sms__PatientPhoneNumber_String__PracticePhoneNumber_String,
			A2(
				$elm$url$Url$Parser$map,
				F2(
					function (patientPhoneNumber, practicePhoneNumber) {
						return {ajT: patientPhoneNumber, aj8: practicePhoneNumber};
					}),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('messages'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('legacy'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('sms'),
							A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$string)))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__BrokerId_String__Top,
			A2(
				$elm$url$Url$Parser$map,
				F2(
					function (brokerAccountId, brokerId) {
						return {cm: brokerAccountId, GN: brokerId};
					}),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('commissions'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('broker_accounts'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							A2(
								$elm$url$Url$Parser$slash,
								$elm$url$Url$Parser$s('brokers'),
								$elm$url$Url$Parser$string)))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__EmployeeId_String__Dependent__DependentId_String__Top,
			A2(
				$elm$url$Url$Parser$map,
				F3(
					function (companyId, employeeId, dependentId) {
						return {fZ: companyId, agp: dependentId, agM: employeeId};
					}),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('companies'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('employees'),
							A2(
								$elm$url$Url$Parser$slash,
								$elm$url$Url$Parser$string,
								A2(
									$elm$url$Url$Parser$slash,
									$elm$url$Url$Parser$s('dependent'),
									$elm$url$Url$Parser$string)))))))
		]));
var $author$project$Spa$Generated$Route$fromUrl = $elm$url$Url$Parser$parse($author$project$Spa$Generated$Route$routes);
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $author$project$Utils$Route$fromUrl = A2(
	$elm$core$Basics$composeR,
	$author$project$Spa$Generated$Route$fromUrl,
	$elm$core$Maybe$withDefault($author$project$Spa$Generated$Route$NotFound));
var $jinjor$elm_debounce$Debounce$Debounce = $elm$core$Basics$identity;
var $jinjor$elm_debounce$Debounce$init = {H1: _List_Nil, Wi: false};
var $author$project$Shared$GlobalSearchMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Shared$GotTimeZone = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Data$Loading = {$: 1};
var $author$project$Api$Data$NotAsked = {$: 0};
var $author$project$Shared$ReleaseMsg = function (a) {
	return {$: 14, a: a};
};
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			A2(
				$elm$core$Task$onError,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
					$elm$core$Result$Err),
				A2(
					$elm$core$Task$andThen,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Ok),
					task)));
	});
var $author$project$Api$Data$Client = $elm$core$Basics$identity;
var $author$project$Api$Data$clientInit = F4(
	function (prePath, providerAuthUrl, apiVersion, authToken) {
		return {Gw: apiVersion, fK: authToken, Du: prePath, Jp: providerAuthUrl, Ev: true};
	});
var $author$project$Utils$Environment$Development = 2;
var $author$project$Utils$Environment$Feature = 3;
var $author$project$Utils$Environment$Production = 0;
var $author$project$Utils$Environment$Staging = 1;
var $author$project$Utils$Environment$decode = function (envName) {
	return A2(
		$elm$core$Maybe$andThen,
		function (env) {
			switch (env) {
				case 'production':
					return $elm$core$Maybe$Just(0);
				case 'staging':
					return $elm$core$Maybe$Just(1);
				case 'development':
					return $elm$core$Maybe$Just(2);
				case 'feature':
					return $elm$core$Maybe$Just(3);
				default:
					return $elm$core$Maybe$Nothing;
			}
		},
		envName);
};
var $justinmimbs$timezone_data$TimeZone$Specification$Rules = function (a) {
	return {$: 1, a: a};
};
var $justinmimbs$timezone_data$TimeZone$Specification$Zone = F2(
	function (history, current) {
		return {Pd: current, cG: history};
	});
var $justinmimbs$timezone_data$TimeZone$Specification$ZoneState = F2(
	function (standardOffset, zoneRules) {
		return {JU: standardOffset, Kt: zoneRules};
	});
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $justinmimbs$timezone_data$TimeZone$maxYear = 2037;
var $justinmimbs$timezone_data$TimeZone$minYear = 1970;
var $justinmimbs$timezone_data$TimeZone$Specification$DateTime = F5(
	function (year, month, day, time, clock) {
		return {fY: clock, af9: day, aiP: month, al3: time, amw: year};
	});
var $elm$time$Time$Jan = 0;
var $justinmimbs$timezone_data$TimeZone$Specification$Universal = 0;
var $justinmimbs$timezone_data$TimeZone$Specification$dropChangesBeforeEpoch = function (_v0) {
	dropChangesBeforeEpoch:
	while (true) {
		var initial = _v0.a;
		var changes = _v0.b;
		if (changes.b) {
			var change = changes.a;
			var rest = changes.b;
			if (change.JV <= 0) {
				var $temp$_v0 = _Utils_Tuple2(change.g, rest);
				_v0 = $temp$_v0;
				continue dropChangesBeforeEpoch;
			} else {
				return _Utils_Tuple2(initial, changes);
			}
		} else {
			return _Utils_Tuple2(initial, _List_Nil);
		}
	}
};
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $elm$core$Basics$modBy = _Basics_modBy;
var $justinmimbs$timezone_data$RataDie$weekdayNumber = function (rd) {
	var _v0 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v0) {
		return 7;
	} else {
		var n = _v0;
		return n;
	}
};
var $justinmimbs$timezone_data$RataDie$weekdayToNumber = function (wd) {
	switch (wd) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		default:
			return 7;
	}
};
var $justinmimbs$timezone_data$RataDie$floorWeekday = F2(
	function (weekday, rd) {
		var daysSincePreviousWeekday = A2(
			$elm$core$Basics$modBy,
			7,
			($justinmimbs$timezone_data$RataDie$weekdayNumber(rd) + 7) - $justinmimbs$timezone_data$RataDie$weekdayToNumber(weekday));
		return rd - daysSincePreviousWeekday;
	});
var $justinmimbs$timezone_data$RataDie$ceilingWeekday = F2(
	function (weekday, rd) {
		var floored = A2($justinmimbs$timezone_data$RataDie$floorWeekday, weekday, rd);
		return _Utils_eq(rd, floored) ? rd : (floored + 7);
	});
var $elm$core$Basics$neq = _Utils_notEqual;
var $justinmimbs$timezone_data$RataDie$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$timezone_data$RataDie$daysBeforeMonth = F2(
	function (y, m) {
		var leapDays = $justinmimbs$timezone_data$RataDie$isLeapYear(y) ? 1 : 0;
		switch (m) {
			case 0:
				return 0;
			case 1:
				return 31;
			case 2:
				return 59 + leapDays;
			case 3:
				return 90 + leapDays;
			case 4:
				return 120 + leapDays;
			case 5:
				return 151 + leapDays;
			case 6:
				return 181 + leapDays;
			case 7:
				return 212 + leapDays;
			case 8:
				return 243 + leapDays;
			case 9:
				return 273 + leapDays;
			case 10:
				return 304 + leapDays;
			default:
				return 334 + leapDays;
		}
	});
var $justinmimbs$timezone_data$RataDie$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
	return (365 * y) + leapYears;
};
var $justinmimbs$timezone_data$RataDie$dayOfMonth = F3(
	function (y, m, d) {
		return ($justinmimbs$timezone_data$RataDie$daysBeforeYear(y) + A2($justinmimbs$timezone_data$RataDie$daysBeforeMonth, y, m)) + d;
	});
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $justinmimbs$timezone_data$RataDie$daysInMonth = F2(
	function (y, m) {
		switch (m) {
			case 0:
				return 31;
			case 1:
				return $justinmimbs$timezone_data$RataDie$isLeapYear(y) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $justinmimbs$timezone_data$RataDie$lastOfMonth = F2(
	function (y, m) {
		return ($justinmimbs$timezone_data$RataDie$daysBeforeYear(y) + A2($justinmimbs$timezone_data$RataDie$daysBeforeMonth, y, m)) + A2($justinmimbs$timezone_data$RataDie$daysInMonth, y, m);
	});
var $justinmimbs$timezone_data$TimeZone$Specification$minutesFromRataDie = function (rd) {
	return (rd - 719163) * 1440;
};
var $elm$core$List$sortBy = _List_sortBy;
var $justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment = F2(
	function (clock, _v0) {
		var standard = _v0.hL;
		var save = _v0.k8;
		switch (clock) {
			case 0:
				return 0;
			case 1:
				return 0 - standard;
			default:
				return 0 - (standard + save);
		}
	});
var $justinmimbs$timezone_data$TimeZone$Specification$minutesFromDateTime = function (_v0) {
	var year = _v0.amw;
	var month = _v0.aiP;
	var day = _v0.af9;
	var time = _v0.al3;
	return $justinmimbs$timezone_data$TimeZone$Specification$minutesFromRataDie(
		A3($justinmimbs$timezone_data$RataDie$dayOfMonth, year, month, day)) + time;
};
var $justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime = F2(
	function (offset, datetime) {
		return $justinmimbs$timezone_data$TimeZone$Specification$minutesFromDateTime(datetime) + A2($justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, datetime.fY, offset);
	});
var $justinmimbs$timezone_data$TimeZone$Specification$rulesToOffsetChanges = F5(
	function (previousOffset, start, until, standardOffset, rules) {
		var transitions = A2(
			$elm$core$List$concatMap,
			function (year) {
				return A2(
					$elm$core$List$sortBy,
					function ($) {
						return $.JV;
					},
					A2(
						$elm$core$List$map,
						function (rule) {
							return {
								fY: rule.fY,
								k8: rule.k8,
								JV: $justinmimbs$timezone_data$TimeZone$Specification$minutesFromRataDie(
									function () {
										var _v2 = rule.af9;
										switch (_v2.$) {
											case 0:
												var day = _v2.a;
												return A3($justinmimbs$timezone_data$RataDie$dayOfMonth, year, rule.aiP, day);
											case 1:
												var weekday = _v2.a;
												var after = _v2.b;
												return A2(
													$justinmimbs$timezone_data$RataDie$ceilingWeekday,
													weekday,
													A3($justinmimbs$timezone_data$RataDie$dayOfMonth, year, rule.aiP, after));
											case 2:
												var weekday = _v2.a;
												var before = _v2.b;
												return A2(
													$justinmimbs$timezone_data$RataDie$floorWeekday,
													weekday,
													A3($justinmimbs$timezone_data$RataDie$dayOfMonth, year, rule.aiP, before));
											default:
												var weekday = _v2.a;
												return A2(
													$justinmimbs$timezone_data$RataDie$floorWeekday,
													weekday,
													A2($justinmimbs$timezone_data$RataDie$lastOfMonth, year, rule.aiP));
										}
									}()) + rule.al3
							};
						},
						A2(
							$elm$core$List$filter,
							function (rule) {
								return (_Utils_cmp(rule.SJ, year) < 1) && (_Utils_cmp(year, rule.ada) < 1);
							},
							rules)));
			},
			A2($elm$core$List$range, start.amw - 1, until.amw));
		var initialOffset = {k8: 0, hL: standardOffset};
		var initialChange = {
			g: standardOffset,
			JV: A2($justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime, previousOffset, start)
		};
		var _v0 = A3(
			$elm$core$List$foldl,
			F2(
				function (transition, _v1) {
					var currentOffset = _v1.a;
					var changes = _v1.b;
					var newOffset = {k8: transition.k8, hL: standardOffset};
					if (_Utils_cmp(
						transition.JV + A2($justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, transition.fY, previousOffset),
						initialChange.JV) < 1) {
						var updatedInitialChange = {g: standardOffset + transition.k8, JV: initialChange.JV};
						return _Utils_Tuple2(
							newOffset,
							_List_fromArray(
								[updatedInitialChange]));
					} else {
						if (_Utils_cmp(
							transition.JV + A2($justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, transition.fY, currentOffset),
							A2($justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime, currentOffset, until)) < 0) {
							var change = {
								g: standardOffset + transition.k8,
								JV: transition.JV + A2($justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, transition.fY, currentOffset)
							};
							return _Utils_Tuple2(
								newOffset,
								A2($elm$core$List$cons, change, changes));
						} else {
							return _Utils_Tuple2(currentOffset, changes);
						}
					}
				}),
			_Utils_Tuple2(
				initialOffset,
				_List_fromArray(
					[initialChange])),
			transitions);
		var nextOffset = _v0.a;
		var descendingChanges = _v0.b;
		return _Utils_Tuple2(
			$elm$core$List$reverse(descendingChanges),
			nextOffset);
	});
var $justinmimbs$timezone_data$TimeZone$Specification$stateToOffsetChanges = F4(
	function (previousOffset, start, until, _v0) {
		var standardOffset = _v0.JU;
		var zoneRules = _v0.Kt;
		if (!zoneRules.$) {
			var save = zoneRules.a;
			return _Utils_Tuple2(
				_List_fromArray(
					[
						{
						g: standardOffset + save,
						JV: A2($justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime, previousOffset, start)
					}
					]),
				{k8: save, hL: standardOffset});
		} else {
			var rules = zoneRules.a;
			return A5($justinmimbs$timezone_data$TimeZone$Specification$rulesToOffsetChanges, previousOffset, start, until, standardOffset, rules);
		}
	});
var $justinmimbs$timezone_data$TimeZone$Specification$stripDuplicatesByHelp = F4(
	function (f, a, rev, list) {
		stripDuplicatesByHelp:
		while (true) {
			if (!list.b) {
				return $elm$core$List$reverse(rev);
			} else {
				var x = list.a;
				var xs = list.b;
				var b = f(x);
				var rev_ = (!_Utils_eq(a, b)) ? A2($elm$core$List$cons, x, rev) : rev;
				var $temp$f = f,
					$temp$a = b,
					$temp$rev = rev_,
					$temp$list = xs;
				f = $temp$f;
				a = $temp$a;
				rev = $temp$rev;
				list = $temp$list;
				continue stripDuplicatesByHelp;
			}
		}
	});
var $justinmimbs$timezone_data$TimeZone$Specification$zoneToRanges = F3(
	function (zoneStart, zoneUntil, zone) {
		var _v0 = A3(
			$elm$core$List$foldl,
			F2(
				function (_v1, _v2) {
					var state = _v1.a;
					var nextStart = _v1.b;
					var start = _v2.a;
					var ranges = _v2.b;
					return _Utils_Tuple2(
						nextStart,
						A2(
							$elm$core$List$cons,
							_Utils_Tuple3(start, state, nextStart),
							ranges));
				}),
			_Utils_Tuple2(zoneStart, _List_Nil),
			zone.cG);
		var currentStart = _v0.a;
		var historyRanges = _v0.b;
		return $elm$core$List$reverse(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple3(currentStart, zone.Pd, zoneUntil),
				historyRanges));
	});
var $justinmimbs$timezone_data$TimeZone$Specification$toOffsets = F3(
	function (minYear, maxYear, zone) {
		var initialState = function () {
			var _v5 = zone.cG;
			if (_v5.b) {
				var _v6 = _v5.a;
				var earliest = _v6.a;
				return earliest;
			} else {
				return zone.Pd;
			}
		}();
		var initialOffset = {
			k8: function () {
				var _v4 = initialState.Kt;
				if (!_v4.$) {
					var save = _v4.a;
					return save;
				} else {
					return 0;
				}
			}(),
			hL: initialState.JU
		};
		var ascendingChanges = A4(
			$justinmimbs$timezone_data$TimeZone$Specification$stripDuplicatesByHelp,
			function ($) {
				return $.g;
			},
			initialOffset.hL + initialOffset.k8,
			_List_Nil,
			A3(
				$elm$core$List$foldl,
				F2(
					function (_v1, _v2) {
						var start = _v1.a;
						var state = _v1.b;
						var until = _v1.c;
						var prevOffset = _v2.a;
						var prevChanges = _v2.b;
						var _v3 = A4($justinmimbs$timezone_data$TimeZone$Specification$stateToOffsetChanges, prevOffset, start, until, state);
						var nextChanges = _v3.a;
						var nextOffset = _v3.b;
						return _Utils_Tuple2(
							nextOffset,
							_Utils_ap(prevChanges, nextChanges));
					}),
				_Utils_Tuple2(initialOffset, _List_Nil),
				A3(
					$justinmimbs$timezone_data$TimeZone$Specification$zoneToRanges,
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, minYear, 0, 1, 0, 0),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, maxYear + 1, 0, 1, 0, 0),
					zone)).b);
		var _v0 = $justinmimbs$timezone_data$TimeZone$Specification$dropChangesBeforeEpoch(
			_Utils_Tuple2(initialOffset.hL + initialOffset.k8, ascendingChanges));
		var initial = _v0.a;
		var ascending = _v0.b;
		return _Utils_Tuple2(
			$elm$core$List$reverse(ascending),
			initial);
	});
var $justinmimbs$timezone_data$TimeZone$fromSpecification = function (zone) {
	var _v0 = A3($justinmimbs$timezone_data$TimeZone$Specification$toOffsets, $justinmimbs$timezone_data$TimeZone$minYear, $justinmimbs$timezone_data$TimeZone$maxYear, zone);
	var descending = _v0.a;
	var bottom = _v0.b;
	return A2($elm$time$Time$customZone, bottom, descending);
};
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$time$Time$Apr = 3;
var $justinmimbs$timezone_data$TimeZone$Specification$Day = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Feb = 1;
var $justinmimbs$timezone_data$TimeZone$Specification$Last = function (a) {
	return {$: 3, a: a};
};
var $elm$time$Time$Mar = 2;
var $justinmimbs$timezone_data$TimeZone$Specification$Next = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$time$Time$Nov = 10;
var $elm$time$Time$Oct = 9;
var $justinmimbs$timezone_data$TimeZone$Specification$Rule = F7(
	function (from, to, month, day, time, clock, save) {
		return {fY: clock, af9: day, SJ: from, aiP: month, k8: save, al3: time, ada: to};
	});
var $elm$time$Time$Sun = 6;
var $justinmimbs$timezone_data$TimeZone$Specification$WallClock = 2;
var $justinmimbs$timezone_data$TimeZone$rules_US = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1967,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1967,
		1973,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1986,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		2006,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__los_angeles = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $author$project$Shared$defaultTimeZone = $justinmimbs$timezone_data$TimeZone$america__los_angeles(0);
var $justinmimbs$date$Date$RD = $elm$core$Basics$identity;
var $justinmimbs$date$Date$fromRataDie = function (rd) {
	return rd;
};
var $author$project$Api$AuthToken$Valid = $elm$core$Basics$identity;
var $author$project$Api$AuthToken$fromString = function (authToken) {
	return authToken;
};
var $justinmimbs$timezone_data$TimeZone$NoDataForZoneName = function (a) {
	return {$: 1, a: a};
};
var $justinmimbs$timezone_data$TimeZone$NoZoneName = {$: 0};
var $elm$core$Task$fail = _Scheduler_fail;
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$getZoneName = _Time_getZoneName(0);
var $justinmimbs$timezone_data$TimeZone$Specification$Save = function (a) {
	return {$: 0, a: a};
};
var $justinmimbs$timezone_data$TimeZone$africa__abidjan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__accra = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__nairobi = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__addis_ababa = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
var $elm$time$Time$May = 4;
var $elm$time$Time$Sep = 8;
var $justinmimbs$timezone_data$TimeZone$Specification$Standard = 1;
var $justinmimbs$timezone_data$TimeZone$rules_Algeria = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		1380,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		1380,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__algiers = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Algeria)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, 9, 21, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Algeria)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 9, 26, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Algeria)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 4, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__asmara = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
var $justinmimbs$timezone_data$TimeZone$africa__bamako = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
var $justinmimbs$timezone_data$TimeZone$africa__lagos = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__bangui = $justinmimbs$timezone_data$TimeZone$africa__lagos;
var $justinmimbs$timezone_data$TimeZone$africa__banjul = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
var $justinmimbs$timezone_data$TimeZone$africa__bissau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__maputo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__blantyre = $justinmimbs$timezone_data$TimeZone$africa__maputo;
var $justinmimbs$timezone_data$TimeZone$africa__brazzaville = $justinmimbs$timezone_data$TimeZone$africa__lagos;
var $justinmimbs$timezone_data$TimeZone$africa__bujumbura = $justinmimbs$timezone_data$TimeZone$africa__maputo;
var $elm$time$Time$Aug = 7;
var $elm$time$Time$Fri = 4;
var $elm$time$Time$Jul = 6;
var $elm$time$Time$Jun = 5;
var $elm$time$Time$Thu = 3;
var $justinmimbs$timezone_data$TimeZone$rules_Egypt = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1959,
		1981,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1966,
		1994,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1988,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1994,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		2010,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		2005,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(3),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 3, 1),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(3),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(3),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(3),
		1440,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__cairo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Egypt))));
};
var $elm$time$Time$Dec = 11;
var $justinmimbs$timezone_data$TimeZone$rules_Morocco = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1977,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2013,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2013,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2013,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2018,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2018,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2015,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2015,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2016,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2016,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		2017,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		2017,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2018,
		2018,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2018,
		2018,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		2019,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		2019,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2020,
		2020,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2020,
		2020,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2021,
		2021,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2021,
		2021,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2022,
		2022,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2022,
		2022,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2023,
		2023,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2023,
		2023,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2024,
		2024,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2024,
		2024,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2025,
		2025,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2025,
		2025,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2026,
		2026,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2026,
		2026,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2027,
		2027,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2027,
		2027,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2028,
		2028,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2028,
		2028,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2029,
		2029,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2029,
		2029,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(18),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2029,
		2029,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2030,
		2030,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2030,
		2030,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2031,
		2031,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2031,
		2031,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2032,
		2032,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(18),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2032,
		2032,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2033,
		2033,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2033,
		2033,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2033,
		2033,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2034,
		2034,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2034,
		2034,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2035,
		2035,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2035,
		2035,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2036,
		2036,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2036,
		2036,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2037,
		2037,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2037,
		2037,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__casablanca = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Morocco)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, 2, 16, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1986, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Morocco)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 9, 28, 180, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Morocco))));
};
var $justinmimbs$timezone_data$TimeZone$rules_EU = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1980,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		60,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1995,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$rules_SpainAfrica = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1977,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__ceuta = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_SpainAfrica)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, 2, 16, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1986, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$africa__conakry = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
var $justinmimbs$timezone_data$TimeZone$africa__dakar = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
var $justinmimbs$timezone_data$TimeZone$africa__dar_es_salaam = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
var $justinmimbs$timezone_data$TimeZone$africa__djibouti = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
var $justinmimbs$timezone_data$TimeZone$africa__douala = $justinmimbs$timezone_data$TimeZone$africa__lagos;
var $justinmimbs$timezone_data$TimeZone$africa__el_aaiun = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, 3, 14, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Morocco)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 9, 28, 180, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Morocco))));
};
var $justinmimbs$timezone_data$TimeZone$africa__freetown = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
var $justinmimbs$timezone_data$TimeZone$africa__gaborone = $justinmimbs$timezone_data$TimeZone$africa__maputo;
var $justinmimbs$timezone_data$TimeZone$africa__harare = $justinmimbs$timezone_data$TimeZone$africa__maputo;
var $justinmimbs$timezone_data$TimeZone$africa__johannesburg = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Sudan = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1985,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1985,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__juba = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Sudan)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 0, 15, 720, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2021, 1, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__kampala = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
var $justinmimbs$timezone_data$TimeZone$africa__khartoum = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Sudan)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 0, 15, 720, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2017, 10, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__kigali = $justinmimbs$timezone_data$TimeZone$africa__maputo;
var $justinmimbs$timezone_data$TimeZone$africa__kinshasa = $justinmimbs$timezone_data$TimeZone$africa__lagos;
var $justinmimbs$timezone_data$TimeZone$africa__libreville = $justinmimbs$timezone_data$TimeZone$africa__lagos;
var $justinmimbs$timezone_data$TimeZone$africa__lome = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
var $justinmimbs$timezone_data$TimeZone$africa__luanda = $justinmimbs$timezone_data$TimeZone$africa__lagos;
var $justinmimbs$timezone_data$TimeZone$africa__lubumbashi = $justinmimbs$timezone_data$TimeZone$africa__maputo;
var $justinmimbs$timezone_data$TimeZone$africa__lusaka = $justinmimbs$timezone_data$TimeZone$africa__maputo;
var $justinmimbs$timezone_data$TimeZone$africa__malabo = $justinmimbs$timezone_data$TimeZone$africa__lagos;
var $justinmimbs$timezone_data$TimeZone$africa__maseru = $justinmimbs$timezone_data$TimeZone$africa__johannesburg;
var $justinmimbs$timezone_data$TimeZone$africa__mbabane = $justinmimbs$timezone_data$TimeZone$africa__johannesburg;
var $justinmimbs$timezone_data$TimeZone$africa__mogadishu = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
var $justinmimbs$timezone_data$TimeZone$africa__monrovia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-45,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, 0, 7, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__ndjamena = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 9, 14, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 2, 8, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__niamey = $justinmimbs$timezone_data$TimeZone$africa__lagos;
var $justinmimbs$timezone_data$TimeZone$africa__nouakchott = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
var $justinmimbs$timezone_data$TimeZone$africa__ouagadougou = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
var $justinmimbs$timezone_data$TimeZone$africa__porto_novo = $justinmimbs$timezone_data$TimeZone$africa__lagos;
var $justinmimbs$timezone_data$TimeZone$africa__sao_tome = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 0, 1, 60, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2019, 0, 1, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Libya = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1984,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1985,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1989,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1989,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2013,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2013,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__tripoli = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Libya)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 4, 4, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 8, 30, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Libya)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 9, 4, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, 10, 10, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Libya)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2013, 9, 25, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Tunisia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1990,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		60,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2008,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2008,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__tunis = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Tunisia))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Namibia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		2017,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		2017,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		-60)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__windhoek = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 2, 21, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Namibia))));
};
var $justinmimbs$timezone_data$TimeZone$america__adak = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 9, 30, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 10, 30, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__anchorage = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 9, 30, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 10, 30, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__port_of_spain = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__anguilla = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$america__antigua = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$rules_Brazil = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1995,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 11),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1995,
		1,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1998,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1998,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2001,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2006,
		1,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2002,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2003,
		2003,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2017,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2011,
		1,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		1,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 22),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2014,
		1,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2015,
		1,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 22),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2019,
		1,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2018,
		2018,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__araguaina = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 8, 17, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, 8, 14, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2003, 8, 24, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, 9, 21, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2013, 8, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Arg = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1968,
		1969,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1993,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1992,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2009,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__argentina__buenos_aires = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__catamarca = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 9, 20, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 20, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 9, 18, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__cordoba = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 9, 20, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__jujuy = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 2, 4, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 9, 28, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 17, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 9, 6, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 9, 18, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__la_rioja = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 4, 7, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 20, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 9, 18, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__mendoza = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 2, 4, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 9, 15, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 9, 15, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 2, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 9, 18, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 4, 23, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 8, 26, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 9, 18, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__rio_gallegos = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 20, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 9, 18, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__salta = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 9, 20, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 9, 18, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__san_juan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 4, 7, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 4, 31, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 6, 25, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 9, 18, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_SanLuis = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2009,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2008,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		0,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__argentina__san_luis = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 2, 14, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 9, 15, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 5, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 4, 31, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 6, 25, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 0, 21, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_SanLuis)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2009, 9, 11, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__tucuman = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 9, 20, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 13, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__ushuaia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 4, 30, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 20, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 9, 18, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__curacao = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__aruba = $justinmimbs$timezone_data$TimeZone$america__curacao;
var $justinmimbs$timezone_data$TimeZone$rules_Para = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1988,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1978,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1991,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1995,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1995,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2001,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		2001,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2004,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2003,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2009,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2009,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2012,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 22),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__asuncion = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, 9, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 3, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Para))));
};
var $justinmimbs$timezone_data$TimeZone$america__atikokan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__bahia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2003, 8, 24, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 9, 16, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, 9, 21, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Mexico = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2000,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2000,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2001,
		4,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2001,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__bahia_banderas = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1970, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 3, 4, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Barb = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1978,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1980,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__barbados = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Barb))));
};
var $justinmimbs$timezone_data$TimeZone$america__belem = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 8, 12, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Belize = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(18),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__belize = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Belize))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Canada = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1986,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		2006,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__blanc_sablon = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1970, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__boa_vista = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 8, 12, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 8, 30, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 15, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_CO = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__bogota = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_CO))));
};
var $justinmimbs$timezone_data$TimeZone$america__boise = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 1, 3, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$rules_NT_YK = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1986,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		2006,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__cambridge_bay = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 31, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 29, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 10, 5, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 3, 1, 180, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__campo_grande = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil))));
};
var $justinmimbs$timezone_data$TimeZone$america__cancun = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 11, 23, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 7, 2, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, 1, 1, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__caracas = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, 11, 9, 180, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-270,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 4, 1, 150, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__cayenne = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__panama = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__cayman = $justinmimbs$timezone_data$TimeZone$america__panama;
var $justinmimbs$timezone_data$TimeZone$america__chicago = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__chihuahua = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 3, 5, 180, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
};
var $elm$time$Time$Sat = 5;
var $justinmimbs$timezone_data$TimeZone$rules_CR = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1980,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1980,
		5,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1992,
		0,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 15),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__costa_rica = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_CR))));
};
var $justinmimbs$timezone_data$TimeZone$america__creston = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__cuiaba = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2003, 8, 24, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 9, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil))));
};
var $justinmimbs$timezone_data$TimeZone$america__danmarkshavn = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 3, 6, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__dawson = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, 9, 28, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2020, 10, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Vanc = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1946,
		1986,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1962,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__dawson_creek = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Vanc)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, 7, 30, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__denver = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__detroit = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, 3, 27, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__dominica = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$rules_Edm = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1986,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__edmonton = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Edm)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1987, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__eirunepe = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 8, 12, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, 8, 28, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, 8, 22, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 5, 24, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2013, 10, 10, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Salv = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		4,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__el_salvador = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Salv))));
};
var $justinmimbs$timezone_data$TimeZone$america__fort_nelson = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Vanc)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1987, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, 2, 8, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__fortaleza = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 8, 17, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 8, 30, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 22, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 8, 13, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, 9, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Halifax = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1962,
		1973,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1962,
		1973,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__glace_bay = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Halifax)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$rules_StJohns = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1951,
		1986,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1960,
		1986,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		1,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		1,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		1,
		2,
		120),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		2006,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		1,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2011,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		1,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2010,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		1,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__goose_bay = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_StJohns)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 10, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__grand_turk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, 2, 8, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 2, 11, 180, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__grenada = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$america__guadeloupe = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$rules_Guat = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__guatemala = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Guat))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Ecuador = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__guayaquil = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Ecuador))));
};
var $justinmimbs$timezone_data$TimeZone$america__guyana = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-225,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, 6, 31, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__halifax = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Halifax)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Cuba = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1977,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1971,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1974,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1977,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1990,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1980,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1985,
		4,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 5),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1989,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 14),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1997,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1995,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1999,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		2003,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2003,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2010,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2010,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		0,
		1,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__havana = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Cuba))));
};
var $justinmimbs$timezone_data$TimeZone$america__hermosillo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1970, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__indianapolis = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__knox = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 9, 27, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 3, 2, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__marengo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 0, 6, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 9, 27, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__petersburg = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, 9, 30, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 3, 2, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, 10, 4, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__tell_city = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 3, 2, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__vevay = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__vincennes = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 3, 2, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, 10, 4, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__winamac = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 3, 2, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, 2, 11, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__inuvik = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 3, 29, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__iqaluit = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 31, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 29, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__jamaica = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__juneau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 3, 27, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 9, 26, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 9, 30, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 10, 30, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__kentucky__louisville = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 0, 6, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 9, 27, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__kentucky__monticello = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 29, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__kralendijk = $justinmimbs$timezone_data$TimeZone$america__curacao;
var $justinmimbs$timezone_data$TimeZone$america__la_paz = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Peru = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1987,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1987,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__lima = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Peru))));
};
var $justinmimbs$timezone_data$TimeZone$america__lower_princes = $justinmimbs$timezone_data$TimeZone$america__curacao;
var $justinmimbs$timezone_data$TimeZone$america__maceio = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 8, 17, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, 9, 13, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 8, 4, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 8, 30, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 22, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 8, 13, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, 9, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $elm$time$Time$Mon = 0;
var $justinmimbs$timezone_data$TimeZone$rules_Nic = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1980,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1980,
		5,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 0, 23),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		60,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__managua = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, 4, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, 1, 16, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Nic)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 1, 240, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 8, 24, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Nic))));
};
var $justinmimbs$timezone_data$TimeZone$america__manaus = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 8, 12, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, 8, 28, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, 8, 22, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__marigot = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$america__martinique = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 3, 6, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 8, 28, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__matamoros = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__mazatlan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1970, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
};
var $justinmimbs$timezone_data$TimeZone$america__menominee = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, 3, 29, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__merida = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 11, 23, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 11, 2, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
};
var $justinmimbs$timezone_data$TimeZone$america__metlakatla = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 9, 30, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, 10, 1, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 10, 4, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2019, 0, 20, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__mexico_city = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 8, 30, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, 1, 20, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
};
var $justinmimbs$timezone_data$TimeZone$america__miquelon = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 4, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1987, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Moncton = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1946,
		1972,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1957,
		1972,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		2006,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		1,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		1,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__moncton = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Moncton)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Moncton)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__monterrey = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Uruguay = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		0,
		2,
		90),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		0,
		2,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1979,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1991,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 21),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1992,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(18),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2015,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2014,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__montevideo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Uruguay)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1970, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Uruguay)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Uruguay)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 2, 10, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Uruguay)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 11, 22, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Uruguay))));
};
var $justinmimbs$timezone_data$TimeZone$america__montserrat = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$rules_Bahamas = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1964,
		1975,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1964,
		1975,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__nassau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Bahamas)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__new_york = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__nipigon = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__nome = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 9, 30, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 10, 30, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__noronha = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 8, 17, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 8, 30, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 15, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 8, 13, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, 9, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__north_dakota__beulah = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 10, 7, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__north_dakota__center = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 9, 25, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__north_dakota__new_salem = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2003, 9, 26, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__nuuk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 3, 6, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$america__ojinaga = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 3, 5, 180, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__pangnirtung = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, 3, 2, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 31, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 29, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__paramaribo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-210,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, 9, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__phoenix = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Haiti = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1987,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1987,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1997,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		60,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1997,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2006,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2015,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2015,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__port_au_prince = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Haiti))));
};
var $justinmimbs$timezone_data$TimeZone$america__porto_velho = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 8, 12, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__puerto_rico = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Chile = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1969,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1969,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1972,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1986,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1987,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1990,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1989,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1996,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1997,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1998,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1998,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		2010,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2007,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		4,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 2),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		7,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2014,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 23),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2014,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 2),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2018,
		4,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2018,
		7,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 2),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 2),
		240,
		0,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__punta_arenas = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 11, 4, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__rainy_river = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__rankin_inlet = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 29, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 3, 1, 180, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__recife = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 8, 17, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 8, 30, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 15, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 8, 13, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, 9, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__regina = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__resolute = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 29, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 3, 1, 180, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 9, 29, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, 2, 11, 180, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__rio_branco = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 8, 12, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 5, 24, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2013, 10, 10, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__santarem = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 8, 12, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 5, 24, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__santiago = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile))));
};
var $justinmimbs$timezone_data$TimeZone$rules_DR = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1973,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1974,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__santo_domingo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_DR)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 9, 27, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 29, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 11, 3, 60, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__sao_paulo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil))));
};
var $justinmimbs$timezone_data$TimeZone$rules_C_Eur = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1980,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1995,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__scoresbysund = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 3, 6, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 2, 29, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$america__sitka = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 9, 30, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 10, 30, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__st_barthelemy = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$america__st_johns = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-210,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_StJohns)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 10, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-210,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__st_kitts = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$america__st_lucia = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$america__st_thomas = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$america__st_vincent = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$america__swift_current = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, 3, 30, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Hond = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		4,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		4,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		7,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 0, 1),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__tegucigalpa = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Hond))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Thule = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1992,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1992,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		2006,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__thule = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Thule))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Toronto = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1950,
		1973,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1957,
		1973,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__thunder_bay = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1970, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Toronto)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__tijuana = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, 1, 20, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__toronto = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Toronto)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__tortola = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$america__vancouver = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Vanc)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1987, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__whitehorse = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2020, 10, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Winn = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1966,
		1986,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1966,
		2005,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		2005,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__winnipeg = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Winn)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__yakutat = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 10, 30, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__yellowknife = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__casey = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2009, 9, 18, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 2, 5, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 9, 28, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, 1, 21, 1020, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 9, 22, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 2, 11, 240, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 9, 7, 240, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2019, 2, 17, 180, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2019, 9, 4, 180, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2020, 2, 8, 180, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2020, 9, 4, 1, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__davis = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2009, 9, 18, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 2, 10, 1200, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 9, 28, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, 1, 21, 1200, 0))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__dumontdurville = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_AT = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1968,
		1985,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1971,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1981,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1983,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1986,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1990,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 22),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1990,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1999,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		2005,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$antarctica__macquarie = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AT)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AT))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__mawson = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2009, 9, 18, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_NZ = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1988,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1989,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		2006,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		2007,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__auckland = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NZ))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__mcmurdo = $justinmimbs$timezone_data$TimeZone$pacific__auckland;
var $justinmimbs$timezone_data$TimeZone$antarctica__palmer = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 4, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 11, 4, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__rothera = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, 11, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__syowa = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Troll = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		120),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$antarctica__troll = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2005, 1, 12, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Troll))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__vostok = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__oslo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$arctic__longyearbyen = $justinmimbs$timezone_data$TimeZone$europe__oslo;
var $justinmimbs$timezone_data$TimeZone$asia__riyadh = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__aden = $justinmimbs$timezone_data$TimeZone$asia__riyadh;
var $justinmimbs$timezone_data$TimeZone$rules_RussiaAsia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1984,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1983,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1995,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		2010,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2010,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__almaty = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 9, 31, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Jordan = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1975,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1977,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1988,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1990,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1993,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1998,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 15),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		1998,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 15),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		2002,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2001,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(3),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2012,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(3),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2003,
		2003,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2011,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2013,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(3),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		0,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__amman = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Jordan))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Russia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1984,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1983,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1995,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		2010,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2010,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__anadyr = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						780,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 3, 1, 0, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 2, 28, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__aqtau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 9, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, 8, 25, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 9, 31, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__aqtobe = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 9, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 9, 31, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__ashgabat = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__atyrau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 9, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 2, 28, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 9, 31, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Iraq = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1984,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1985,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1990,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1990,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		2007,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		180,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		2007,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		180,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__baghdad = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 4, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Iraq))));
};
var $justinmimbs$timezone_data$TimeZone$asia__qatar = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, 5, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__bahrain = $justinmimbs$timezone_data$TimeZone$asia__qatar;
var $justinmimbs$timezone_data$TimeZone$rules_Azer = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		2015,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		240,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		2015,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		300,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$rules_EUAsia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1995,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__baku = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 8, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EUAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Azer))));
};
var $justinmimbs$timezone_data$TimeZone$asia__bangkok = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__barnaul = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, 4, 28, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 2, 27, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Lebanon = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1977,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1977,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1987,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1991,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1992,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1998,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__beirut = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Lebanon))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Kyrgyz = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1996,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 7),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1996,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		2005,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		150,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		2004,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		150,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__bishkek = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 7, 31, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Kyrgyz)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2005, 7, 12, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__brunei = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__chita = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 2, 27, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Mongol = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1984,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1998,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1998,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2001,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(5),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2006,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(5),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2006,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(5),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2016,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(5),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2016,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(5),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__choibalsan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1978, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mongol)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 2, 31, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mongol))));
};
var $justinmimbs$timezone_data$TimeZone$asia__colombo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						330,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 4, 25, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						390,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 9, 26, 30, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 3, 15, 30, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				330,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Syria = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1966,
		1976,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1967,
		1978,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1978,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1984,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1984,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1992,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1996,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		2005,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1998,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(0),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		2006,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2011,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__damascus = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Syria))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Dhaka = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		1380,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		1440,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__dhaka = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2009, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Dhaka))));
};
var $justinmimbs$timezone_data$TimeZone$asia__dili = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, 4, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 8, 17, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__dubai = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__dushanbe = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 8, 9, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Cyprus = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1980,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1997,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1998,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__famagusta = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Cyprus)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 8, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EUAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 8, 8, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2017, 9, 29, 60, 0))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EUAsia))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Palestine = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		2005,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 15),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		2003,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 15),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2007,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2009,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		1,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2014,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(3),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2013,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2015,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2015,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2018,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 24),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2018,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 24),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		2019,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		2019,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 24),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2020,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 24),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2020,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 24),
		60,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$Specification$Prev = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $justinmimbs$timezone_data$TimeZone$rules_Zion = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		1440,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		1440,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1984,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		1440,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1984,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		1440,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		1995,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		1995,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1998,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1998,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2001,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2001,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2002,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2002,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2003,
		2003,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2003,
		2003,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2012,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Prev, 4, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 23),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__gaza = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Zion)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Jordan)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Palestine)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 7, 29, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 8, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Palestine)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 2, 27, 1, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Palestine)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 7, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Palestine))));
};
var $justinmimbs$timezone_data$TimeZone$asia__hebron = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Zion)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Jordan)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Palestine))));
};
var $justinmimbs$timezone_data$TimeZone$asia__ho_chi_minh = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, 5, 13, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_HK = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1965,
		1976,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16),
		210,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1965,
		1976,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16),
		210,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		210,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		210,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		210,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__hong_kong = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_HK))));
};
var $justinmimbs$timezone_data$TimeZone$asia__hovd = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1978, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mongol))));
};
var $justinmimbs$timezone_data$TimeZone$asia__irkutsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Turkey = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1976,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 31),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1978,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1978,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		60,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		60,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1993,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1995,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		60,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		2006,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__istanbul = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Turkey)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1978, 5, 29, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Turkey)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, 10, 1, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Turkey)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 60, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 28, 60, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 2, 30, 60, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 2, 31, 60, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, 9, 25, 60, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, 10, 8, 60, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 8, 7, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__istanbul = $justinmimbs$timezone_data$TimeZone$europe__istanbul;
var $justinmimbs$timezone_data$TimeZone$asia__jakarta = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__jayapura = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__jerusalem = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Zion))));
};
var $justinmimbs$timezone_data$TimeZone$asia__kabul = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				270,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__kamchatka = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 2, 28, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Pakistan = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2002,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 2),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2002,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 2),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2009,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__karachi = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 2, 26, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Pakistan))));
};
var $justinmimbs$timezone_data$TimeZone$asia__kathmandu = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						330,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1986, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				345,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__khandyga = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 8, 13, 0, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__kolkata = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				330,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__krasnoyarsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__kuala_lumpur = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						450,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__kuching = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__kuwait = $justinmimbs$timezone_data$TimeZone$asia__riyadh;
var $justinmimbs$timezone_data$TimeZone$rules_Macau = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1965,
		1973,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16),
		210,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1967,
		1976,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16),
		210,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		210,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1976,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16),
		210,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		210,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16),
		210,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__macau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Macau))));
};
var $justinmimbs$timezone_data$TimeZone$asia__magadan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 3, 24, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__makassar = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Phil = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__manila = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Phil))));
};
var $justinmimbs$timezone_data$TimeZone$asia__muscat = $justinmimbs$timezone_data$TimeZone$asia__dubai;
var $justinmimbs$timezone_data$TimeZone$asia__nicosia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Cyprus)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 8, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EUAsia))));
};
var $justinmimbs$timezone_data$TimeZone$asia__novokuznetsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 2, 28, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__novosibirsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, 4, 23, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 6, 24, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__omsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__oral = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 9, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 2, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 2, 29, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 9, 31, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__phnom_penh = $justinmimbs$timezone_data$TimeZone$asia__bangkok;
var $justinmimbs$timezone_data$TimeZone$asia__pontianak = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__pyongyang = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, 7, 15, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						510,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 4, 4, 1410, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__qostanay = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 9, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 9, 31, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__qyzylorda = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 9, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 8, 29, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 2, 29, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 9, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 11, 21, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__sakhalin = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 2, 30, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 2, 27, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__samarkand = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 9, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_ROK = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		4,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		180,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__seoul = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_ROK))));
};
var $justinmimbs$timezone_data$TimeZone$rules_PRC = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1991,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 11),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1991,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 11),
		120,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__shanghai = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_PRC))));
};
var $justinmimbs$timezone_data$TimeZone$asia__singapore = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						450,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__srednekolymsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Taiwan = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1975,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1975,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__taipei = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Taiwan))));
};
var $justinmimbs$timezone_data$TimeZone$asia__tashkent = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_E_EurAsia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1995,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__tbilisi = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_EurAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, 8, 25, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_EurAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 9, 27, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 2, 30, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_EurAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 27, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2005, 2, 27, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Iran = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1980,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(18),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1995,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1995,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1999,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1999,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2003,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2003,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2011,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2011,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2015,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2015,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2016,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2016,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		2019,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		2019,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2020,
		2020,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2020,
		2020,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2021,
		2023,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2021,
		2023,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2024,
		2024,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2024,
		2024,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2025,
		2027,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2025,
		2027,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2028,
		2029,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2028,
		2029,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2030,
		2031,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2030,
		2031,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2032,
		2033,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2032,
		2033,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2034,
		2035,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2034,
		2035,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2036,
		2037,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2036,
		2037,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__tehran = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						210,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, 10, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Iran)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				210,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Iran))));
};
var $justinmimbs$timezone_data$TimeZone$asia__thimphu = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						330,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1987, 9, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__tokyo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__tomsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, 4, 1, 180, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 4, 29, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__ulaanbaatar = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1978, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mongol))));
};
var $justinmimbs$timezone_data$TimeZone$asia__urumqi = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__ust_nera = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 8, 13, 0, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__vientiane = $justinmimbs$timezone_data$TimeZone$asia__bangkok;
var $justinmimbs$timezone_data$TimeZone$asia__vladivostok = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__yakutsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__yangon = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				390,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__yekaterinburg = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Armenia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__yerevan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, 8, 24, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Armenia))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Port = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1979,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1982,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1982,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$rules_W_Eur = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1980,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		60,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1995,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$atlantic__azores = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Port)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 8, 25, 60, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_W_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 8, 27, 60, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, 2, 28, 60, 0))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__bermuda = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 3, 28, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__canary = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 3, 6, 0, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 8, 28, 60, 0))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__cape_verde = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, 10, 25, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-60,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__faroe = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__madeira = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Port)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 8, 25, 60, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__reykjavik = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__south_georgia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__st_helena = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
var $justinmimbs$timezone_data$TimeZone$rules_Falk = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1985,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1984,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		2000,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		2000,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2010,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2010,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$atlantic__stanley = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Falk)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 4, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Falk)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1985, 8, 15, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Falk)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 8, 5, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_AS = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1985,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		2007,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1985,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1990,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		2005,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__adelaide = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						570,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				570,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AS))));
};
var $justinmimbs$timezone_data$TimeZone$rules_AQ = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1991,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1992,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__brisbane = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AQ))));
};
var $justinmimbs$timezone_data$TimeZone$rules_AN = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1985,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1981,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1985,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1989,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1999,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1995,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2005,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2007,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__broken_hill = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						570,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						570,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AN)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				570,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AS))));
};
var $justinmimbs$timezone_data$TimeZone$australia__darwin = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				570,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_AW = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1984,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2009,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2008,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__eucla = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				525,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AW))));
};
var $justinmimbs$timezone_data$TimeZone$australia__hobart = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AT))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Holiday = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1993,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1994,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__lindeman = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AQ)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 6, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Holiday))));
};
var $justinmimbs$timezone_data$TimeZone$rules_LH = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1984,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1985,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1989,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		120,
		2,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1999,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1995,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2005,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2007,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		30)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__lord_howe = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 2, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						630,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_LH)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1985, 6, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				630,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_LH))));
};
var $justinmimbs$timezone_data$TimeZone$rules_AV = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1985,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1985,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1990,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1987,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1999,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1994,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		2005,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2007,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__melbourne = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AV))));
};
var $justinmimbs$timezone_data$TimeZone$australia__perth = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AW))));
};
var $justinmimbs$timezone_data$TimeZone$australia__sydney = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AN))));
};
var $justinmimbs$timezone_data$TimeZone$europe__amsterdam = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__andorra = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1985, 2, 31, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__astrakhan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 2, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 2, 29, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 2, 27, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Greece = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1978,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		240,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		540,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__athens = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Greece)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__belgrade = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 10, 27, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__berlin = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__prague = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__bratislava = $justinmimbs$timezone_data$TimeZone$europe__prague;
var $justinmimbs$timezone_data$TimeZone$europe__brussels = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_E_Eur = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1980,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1995,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$rules_Romania = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		1380,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1993,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1993,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__bucharest = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Romania)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 2, 29, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Romania)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Hungary = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1983,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1983,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__budapest = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Hungary)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__zurich = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__busingen = $justinmimbs$timezone_data$TimeZone$europe__zurich;
var $justinmimbs$timezone_data$TimeZone$rules_Moldova = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		180,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__chisinau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 4, 6, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Moldova))));
};
var $justinmimbs$timezone_data$TimeZone$europe__copenhagen = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Eire = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		0,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1980,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16),
		120,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1980,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 23),
		120,
		0,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1989,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 23),
		60,
		0,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1995,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 22),
		60,
		0,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		-60)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__dublin = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Eire))));
};
var $justinmimbs$timezone_data$TimeZone$europe__gibraltar = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_GB_Eire = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1980,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1980,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 23),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1995,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1989,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 23),
		60,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1995,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 22),
		60,
		0,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__london = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 9, 31, 120, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_GB_Eire)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__guernsey = $justinmimbs$timezone_data$TimeZone$europe__london;
var $justinmimbs$timezone_data$TimeZone$rules_Finland = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1982,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1982,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		180,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__helsinki = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Finland)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__isle_of_man = $justinmimbs$timezone_data$TimeZone$europe__london;
var $justinmimbs$timezone_data$TimeZone$europe__jersey = $justinmimbs$timezone_data$TimeZone$europe__london;
var $justinmimbs$timezone_data$TimeZone$europe__kaliningrad = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 2, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__kiev = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 6, 1, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 8, 29, 180, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__kirov = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 2, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 2, 29, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__lisbon = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, 8, 26, 60, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Port)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 8, 25, 60, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_W_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 8, 27, 60, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 2, 31, 60, 0))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__ljubljana = $justinmimbs$timezone_data$TimeZone$europe__belgrade;
var $justinmimbs$timezone_data$TimeZone$europe__luxembourg = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Spain = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1975,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 12),
		1380,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1975,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		1380,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		1380,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__madrid = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Spain)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Italy = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1967,
		1969,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 22),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1969,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1972,
		4,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 22),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1974,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1979,
		4,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 22),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$rules_Malta = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1979,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1980,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__malta = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Italy)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, 2, 31, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Malta)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__mariehamn = $justinmimbs$timezone_data$TimeZone$europe__helsinki;
var $justinmimbs$timezone_data$TimeZone$europe__minsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_France = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		60,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__monaco = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_France)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__moscow = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__nicosia = $justinmimbs$timezone_data$TimeZone$asia__nicosia;
var $justinmimbs$timezone_data$TimeZone$europe__paris = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_France)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__podgorica = $justinmimbs$timezone_data$TimeZone$europe__belgrade;
var $justinmimbs$timezone_data$TimeZone$rules_Latvia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1996,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1996,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__riga = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 2, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 8, 24, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Latvia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 0, 21, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 1, 29, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 0, 2, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__rome = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Italy)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__samara = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 2, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 8, 29, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 9, 20, 180, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 2, 28, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__san_marino = $justinmimbs$timezone_data$TimeZone$europe__rome;
var $justinmimbs$timezone_data$TimeZone$europe__sarajevo = $justinmimbs$timezone_data$TimeZone$europe__belgrade;
var $justinmimbs$timezone_data$TimeZone$europe__saratov = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 2, 29, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 11, 4, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__simferopol = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 6, 1, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, 4, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 2, 31, 0, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 9, 27, 180, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 2, 30, 60, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 2, 30, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__skopje = $justinmimbs$timezone_data$TimeZone$europe__belgrade;
var $justinmimbs$timezone_data$TimeZone$rules_Bulg = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		1380,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1982,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 1),
		1380,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1981,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__sofia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 2, 31, 1380, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Bulg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 8, 26, 180, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__stockholm = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__tallinn = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 2, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 8, 24, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 8, 22, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 31, 240, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, 1, 21, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Albania = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1981,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1981,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(18),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1984,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__tirane = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Albania)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, 6, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__ulyanovsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 2, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 2, 27, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__uzhgorod = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 6, 1, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 180, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__vaduz = $justinmimbs$timezone_data$TimeZone$europe__zurich;
var $justinmimbs$timezone_data$TimeZone$europe__vatican = $justinmimbs$timezone_data$TimeZone$europe__rome;
var $justinmimbs$timezone_data$TimeZone$rules_Austria = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__vienna = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Austria)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__vilnius = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 2, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 8, 29, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 2, 29, 60, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 31, 60, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2003, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__volgograd = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 2, 29, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 9, 28, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2020, 11, 27, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__warsaw = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_W_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__zagreb = $justinmimbs$timezone_data$TimeZone$europe__belgrade;
var $justinmimbs$timezone_data$TimeZone$europe__zaporozhye = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $justinmimbs$timezone_data$TimeZone$indian__antananarivo = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
var $justinmimbs$timezone_data$TimeZone$indian__chagos = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$indian__christmas = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$indian__cocos = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				390,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$indian__comoro = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
var $justinmimbs$timezone_data$TimeZone$indian__kerguelen = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$indian__mahe = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$indian__maldives = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Mauritius = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$indian__mauritius = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mauritius))));
};
var $justinmimbs$timezone_data$TimeZone$indian__mayotte = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
var $justinmimbs$timezone_data$TimeZone$indian__reunion = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_WS = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 1),
		240,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(5),
		180,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		240,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		180,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__apia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_WS)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 11, 29, 1440, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				780,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_WS))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__bougainville = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 11, 28, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Chatham = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		165,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		165,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1988,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		165,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1989,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		165,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		165,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		2006,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		165,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		2007,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		165,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		165,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		165,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__chatham = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				765,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chatham))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__chuuk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__easter = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 2, 14, 180, 0))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Vanuatu = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		720,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		720,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1991,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 22),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1991,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 22),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1993,
		0,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 22),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 22),
		1440,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__efate = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Vanuatu))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__enderbury = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-720,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 9, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, 11, 31, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				780,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__fakaofo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 11, 30, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				780,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Fiji = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1999,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		2000,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2013,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 21),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2013,
		0,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 18),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		0,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 18),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2018,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		0,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 12),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		2019,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2020,
		2020,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2021,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		120,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__fiji = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Fiji))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__funafuti = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__galapagos = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1986, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Ecuador))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__gambier = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__guadalcanal = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Guam = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1969,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		1,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1969,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1969,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1971,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1971,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		121,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__guam = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Guam)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 11, 23, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__honolulu = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__kiritimati = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-640,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 9, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, 11, 31, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				840,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__kosrae = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__kwajalein = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-720,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, 7, 20, 1440, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__majuro = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__marquesas = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-570,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__pago_pago = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__midway = $justinmimbs$timezone_data$TimeZone$pacific__pago_pago;
var $justinmimbs$timezone_data$TimeZone$pacific__nauru = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						690,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 1, 10, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__niue = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-690,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1978, 9, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__norfolk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						690,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 9, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						690,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, 2, 2, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						690,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, 9, 4, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2019, 6, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AN))));
};
var $justinmimbs$timezone_data$TimeZone$rules_NC = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1978,
		11,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1979,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__noumea = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NC))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__palau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__pitcairn = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-510,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 3, 27, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__pohnpei = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__port_moresby = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Cook = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		0,
		2,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1991,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1990,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		30)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__rarotonga = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-630,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1978, 10, 12, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Cook))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__saipan = $justinmimbs$timezone_data$TimeZone$pacific__guam;
var $justinmimbs$timezone_data$TimeZone$pacific__tahiti = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__tarawa = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Tonga = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2001,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2002,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2016,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		2017,
		0,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		180,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__tongatapu = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						780,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				780,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Tonga))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__wake = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__wallis = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$zones = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('Africa/Abidjan', $justinmimbs$timezone_data$TimeZone$africa__abidjan),
			_Utils_Tuple2('Africa/Accra', $justinmimbs$timezone_data$TimeZone$africa__accra),
			_Utils_Tuple2('Africa/Addis_Ababa', $justinmimbs$timezone_data$TimeZone$africa__addis_ababa),
			_Utils_Tuple2('Africa/Algiers', $justinmimbs$timezone_data$TimeZone$africa__algiers),
			_Utils_Tuple2('Africa/Asmara', $justinmimbs$timezone_data$TimeZone$africa__asmara),
			_Utils_Tuple2('Africa/Bamako', $justinmimbs$timezone_data$TimeZone$africa__bamako),
			_Utils_Tuple2('Africa/Bangui', $justinmimbs$timezone_data$TimeZone$africa__bangui),
			_Utils_Tuple2('Africa/Banjul', $justinmimbs$timezone_data$TimeZone$africa__banjul),
			_Utils_Tuple2('Africa/Bissau', $justinmimbs$timezone_data$TimeZone$africa__bissau),
			_Utils_Tuple2('Africa/Blantyre', $justinmimbs$timezone_data$TimeZone$africa__blantyre),
			_Utils_Tuple2('Africa/Brazzaville', $justinmimbs$timezone_data$TimeZone$africa__brazzaville),
			_Utils_Tuple2('Africa/Bujumbura', $justinmimbs$timezone_data$TimeZone$africa__bujumbura),
			_Utils_Tuple2('Africa/Cairo', $justinmimbs$timezone_data$TimeZone$africa__cairo),
			_Utils_Tuple2('Africa/Casablanca', $justinmimbs$timezone_data$TimeZone$africa__casablanca),
			_Utils_Tuple2('Africa/Ceuta', $justinmimbs$timezone_data$TimeZone$africa__ceuta),
			_Utils_Tuple2('Africa/Conakry', $justinmimbs$timezone_data$TimeZone$africa__conakry),
			_Utils_Tuple2('Africa/Dakar', $justinmimbs$timezone_data$TimeZone$africa__dakar),
			_Utils_Tuple2('Africa/Dar_es_Salaam', $justinmimbs$timezone_data$TimeZone$africa__dar_es_salaam),
			_Utils_Tuple2('Africa/Djibouti', $justinmimbs$timezone_data$TimeZone$africa__djibouti),
			_Utils_Tuple2('Africa/Douala', $justinmimbs$timezone_data$TimeZone$africa__douala),
			_Utils_Tuple2('Africa/El_Aaiun', $justinmimbs$timezone_data$TimeZone$africa__el_aaiun),
			_Utils_Tuple2('Africa/Freetown', $justinmimbs$timezone_data$TimeZone$africa__freetown),
			_Utils_Tuple2('Africa/Gaborone', $justinmimbs$timezone_data$TimeZone$africa__gaborone),
			_Utils_Tuple2('Africa/Harare', $justinmimbs$timezone_data$TimeZone$africa__harare),
			_Utils_Tuple2('Africa/Johannesburg', $justinmimbs$timezone_data$TimeZone$africa__johannesburg),
			_Utils_Tuple2('Africa/Juba', $justinmimbs$timezone_data$TimeZone$africa__juba),
			_Utils_Tuple2('Africa/Kampala', $justinmimbs$timezone_data$TimeZone$africa__kampala),
			_Utils_Tuple2('Africa/Khartoum', $justinmimbs$timezone_data$TimeZone$africa__khartoum),
			_Utils_Tuple2('Africa/Kigali', $justinmimbs$timezone_data$TimeZone$africa__kigali),
			_Utils_Tuple2('Africa/Kinshasa', $justinmimbs$timezone_data$TimeZone$africa__kinshasa),
			_Utils_Tuple2('Africa/Lagos', $justinmimbs$timezone_data$TimeZone$africa__lagos),
			_Utils_Tuple2('Africa/Libreville', $justinmimbs$timezone_data$TimeZone$africa__libreville),
			_Utils_Tuple2('Africa/Lome', $justinmimbs$timezone_data$TimeZone$africa__lome),
			_Utils_Tuple2('Africa/Luanda', $justinmimbs$timezone_data$TimeZone$africa__luanda),
			_Utils_Tuple2('Africa/Lubumbashi', $justinmimbs$timezone_data$TimeZone$africa__lubumbashi),
			_Utils_Tuple2('Africa/Lusaka', $justinmimbs$timezone_data$TimeZone$africa__lusaka),
			_Utils_Tuple2('Africa/Malabo', $justinmimbs$timezone_data$TimeZone$africa__malabo),
			_Utils_Tuple2('Africa/Maputo', $justinmimbs$timezone_data$TimeZone$africa__maputo),
			_Utils_Tuple2('Africa/Maseru', $justinmimbs$timezone_data$TimeZone$africa__maseru),
			_Utils_Tuple2('Africa/Mbabane', $justinmimbs$timezone_data$TimeZone$africa__mbabane),
			_Utils_Tuple2('Africa/Mogadishu', $justinmimbs$timezone_data$TimeZone$africa__mogadishu),
			_Utils_Tuple2('Africa/Monrovia', $justinmimbs$timezone_data$TimeZone$africa__monrovia),
			_Utils_Tuple2('Africa/Nairobi', $justinmimbs$timezone_data$TimeZone$africa__nairobi),
			_Utils_Tuple2('Africa/Ndjamena', $justinmimbs$timezone_data$TimeZone$africa__ndjamena),
			_Utils_Tuple2('Africa/Niamey', $justinmimbs$timezone_data$TimeZone$africa__niamey),
			_Utils_Tuple2('Africa/Nouakchott', $justinmimbs$timezone_data$TimeZone$africa__nouakchott),
			_Utils_Tuple2('Africa/Ouagadougou', $justinmimbs$timezone_data$TimeZone$africa__ouagadougou),
			_Utils_Tuple2('Africa/Porto-Novo', $justinmimbs$timezone_data$TimeZone$africa__porto_novo),
			_Utils_Tuple2('Africa/Sao_Tome', $justinmimbs$timezone_data$TimeZone$africa__sao_tome),
			_Utils_Tuple2('Africa/Tripoli', $justinmimbs$timezone_data$TimeZone$africa__tripoli),
			_Utils_Tuple2('Africa/Tunis', $justinmimbs$timezone_data$TimeZone$africa__tunis),
			_Utils_Tuple2('Africa/Windhoek', $justinmimbs$timezone_data$TimeZone$africa__windhoek),
			_Utils_Tuple2('America/Adak', $justinmimbs$timezone_data$TimeZone$america__adak),
			_Utils_Tuple2('America/Anchorage', $justinmimbs$timezone_data$TimeZone$america__anchorage),
			_Utils_Tuple2('America/Anguilla', $justinmimbs$timezone_data$TimeZone$america__anguilla),
			_Utils_Tuple2('America/Antigua', $justinmimbs$timezone_data$TimeZone$america__antigua),
			_Utils_Tuple2('America/Araguaina', $justinmimbs$timezone_data$TimeZone$america__araguaina),
			_Utils_Tuple2('America/Argentina/Buenos_Aires', $justinmimbs$timezone_data$TimeZone$america__argentina__buenos_aires),
			_Utils_Tuple2('America/Argentina/Catamarca', $justinmimbs$timezone_data$TimeZone$america__argentina__catamarca),
			_Utils_Tuple2('America/Argentina/Cordoba', $justinmimbs$timezone_data$TimeZone$america__argentina__cordoba),
			_Utils_Tuple2('America/Argentina/Jujuy', $justinmimbs$timezone_data$TimeZone$america__argentina__jujuy),
			_Utils_Tuple2('America/Argentina/La_Rioja', $justinmimbs$timezone_data$TimeZone$america__argentina__la_rioja),
			_Utils_Tuple2('America/Argentina/Mendoza', $justinmimbs$timezone_data$TimeZone$america__argentina__mendoza),
			_Utils_Tuple2('America/Argentina/Rio_Gallegos', $justinmimbs$timezone_data$TimeZone$america__argentina__rio_gallegos),
			_Utils_Tuple2('America/Argentina/Salta', $justinmimbs$timezone_data$TimeZone$america__argentina__salta),
			_Utils_Tuple2('America/Argentina/San_Juan', $justinmimbs$timezone_data$TimeZone$america__argentina__san_juan),
			_Utils_Tuple2('America/Argentina/San_Luis', $justinmimbs$timezone_data$TimeZone$america__argentina__san_luis),
			_Utils_Tuple2('America/Argentina/Tucuman', $justinmimbs$timezone_data$TimeZone$america__argentina__tucuman),
			_Utils_Tuple2('America/Argentina/Ushuaia', $justinmimbs$timezone_data$TimeZone$america__argentina__ushuaia),
			_Utils_Tuple2('America/Aruba', $justinmimbs$timezone_data$TimeZone$america__aruba),
			_Utils_Tuple2('America/Asuncion', $justinmimbs$timezone_data$TimeZone$america__asuncion),
			_Utils_Tuple2('America/Atikokan', $justinmimbs$timezone_data$TimeZone$america__atikokan),
			_Utils_Tuple2('America/Bahia', $justinmimbs$timezone_data$TimeZone$america__bahia),
			_Utils_Tuple2('America/Bahia_Banderas', $justinmimbs$timezone_data$TimeZone$america__bahia_banderas),
			_Utils_Tuple2('America/Barbados', $justinmimbs$timezone_data$TimeZone$america__barbados),
			_Utils_Tuple2('America/Belem', $justinmimbs$timezone_data$TimeZone$america__belem),
			_Utils_Tuple2('America/Belize', $justinmimbs$timezone_data$TimeZone$america__belize),
			_Utils_Tuple2('America/Blanc-Sablon', $justinmimbs$timezone_data$TimeZone$america__blanc_sablon),
			_Utils_Tuple2('America/Boa_Vista', $justinmimbs$timezone_data$TimeZone$america__boa_vista),
			_Utils_Tuple2('America/Bogota', $justinmimbs$timezone_data$TimeZone$america__bogota),
			_Utils_Tuple2('America/Boise', $justinmimbs$timezone_data$TimeZone$america__boise),
			_Utils_Tuple2('America/Cambridge_Bay', $justinmimbs$timezone_data$TimeZone$america__cambridge_bay),
			_Utils_Tuple2('America/Campo_Grande', $justinmimbs$timezone_data$TimeZone$america__campo_grande),
			_Utils_Tuple2('America/Cancun', $justinmimbs$timezone_data$TimeZone$america__cancun),
			_Utils_Tuple2('America/Caracas', $justinmimbs$timezone_data$TimeZone$america__caracas),
			_Utils_Tuple2('America/Cayenne', $justinmimbs$timezone_data$TimeZone$america__cayenne),
			_Utils_Tuple2('America/Cayman', $justinmimbs$timezone_data$TimeZone$america__cayman),
			_Utils_Tuple2('America/Chicago', $justinmimbs$timezone_data$TimeZone$america__chicago),
			_Utils_Tuple2('America/Chihuahua', $justinmimbs$timezone_data$TimeZone$america__chihuahua),
			_Utils_Tuple2('America/Costa_Rica', $justinmimbs$timezone_data$TimeZone$america__costa_rica),
			_Utils_Tuple2('America/Creston', $justinmimbs$timezone_data$TimeZone$america__creston),
			_Utils_Tuple2('America/Cuiaba', $justinmimbs$timezone_data$TimeZone$america__cuiaba),
			_Utils_Tuple2('America/Curacao', $justinmimbs$timezone_data$TimeZone$america__curacao),
			_Utils_Tuple2('America/Danmarkshavn', $justinmimbs$timezone_data$TimeZone$america__danmarkshavn),
			_Utils_Tuple2('America/Dawson', $justinmimbs$timezone_data$TimeZone$america__dawson),
			_Utils_Tuple2('America/Dawson_Creek', $justinmimbs$timezone_data$TimeZone$america__dawson_creek),
			_Utils_Tuple2('America/Denver', $justinmimbs$timezone_data$TimeZone$america__denver),
			_Utils_Tuple2('America/Detroit', $justinmimbs$timezone_data$TimeZone$america__detroit),
			_Utils_Tuple2('America/Dominica', $justinmimbs$timezone_data$TimeZone$america__dominica),
			_Utils_Tuple2('America/Edmonton', $justinmimbs$timezone_data$TimeZone$america__edmonton),
			_Utils_Tuple2('America/Eirunepe', $justinmimbs$timezone_data$TimeZone$america__eirunepe),
			_Utils_Tuple2('America/El_Salvador', $justinmimbs$timezone_data$TimeZone$america__el_salvador),
			_Utils_Tuple2('America/Fort_Nelson', $justinmimbs$timezone_data$TimeZone$america__fort_nelson),
			_Utils_Tuple2('America/Fortaleza', $justinmimbs$timezone_data$TimeZone$america__fortaleza),
			_Utils_Tuple2('America/Glace_Bay', $justinmimbs$timezone_data$TimeZone$america__glace_bay),
			_Utils_Tuple2('America/Goose_Bay', $justinmimbs$timezone_data$TimeZone$america__goose_bay),
			_Utils_Tuple2('America/Grand_Turk', $justinmimbs$timezone_data$TimeZone$america__grand_turk),
			_Utils_Tuple2('America/Grenada', $justinmimbs$timezone_data$TimeZone$america__grenada),
			_Utils_Tuple2('America/Guadeloupe', $justinmimbs$timezone_data$TimeZone$america__guadeloupe),
			_Utils_Tuple2('America/Guatemala', $justinmimbs$timezone_data$TimeZone$america__guatemala),
			_Utils_Tuple2('America/Guayaquil', $justinmimbs$timezone_data$TimeZone$america__guayaquil),
			_Utils_Tuple2('America/Guyana', $justinmimbs$timezone_data$TimeZone$america__guyana),
			_Utils_Tuple2('America/Halifax', $justinmimbs$timezone_data$TimeZone$america__halifax),
			_Utils_Tuple2('America/Havana', $justinmimbs$timezone_data$TimeZone$america__havana),
			_Utils_Tuple2('America/Hermosillo', $justinmimbs$timezone_data$TimeZone$america__hermosillo),
			_Utils_Tuple2('America/Indiana/Indianapolis', $justinmimbs$timezone_data$TimeZone$america__indiana__indianapolis),
			_Utils_Tuple2('America/Indiana/Knox', $justinmimbs$timezone_data$TimeZone$america__indiana__knox),
			_Utils_Tuple2('America/Indiana/Marengo', $justinmimbs$timezone_data$TimeZone$america__indiana__marengo),
			_Utils_Tuple2('America/Indiana/Petersburg', $justinmimbs$timezone_data$TimeZone$america__indiana__petersburg),
			_Utils_Tuple2('America/Indiana/Tell_City', $justinmimbs$timezone_data$TimeZone$america__indiana__tell_city),
			_Utils_Tuple2('America/Indiana/Vevay', $justinmimbs$timezone_data$TimeZone$america__indiana__vevay),
			_Utils_Tuple2('America/Indiana/Vincennes', $justinmimbs$timezone_data$TimeZone$america__indiana__vincennes),
			_Utils_Tuple2('America/Indiana/Winamac', $justinmimbs$timezone_data$TimeZone$america__indiana__winamac),
			_Utils_Tuple2('America/Inuvik', $justinmimbs$timezone_data$TimeZone$america__inuvik),
			_Utils_Tuple2('America/Iqaluit', $justinmimbs$timezone_data$TimeZone$america__iqaluit),
			_Utils_Tuple2('America/Jamaica', $justinmimbs$timezone_data$TimeZone$america__jamaica),
			_Utils_Tuple2('America/Juneau', $justinmimbs$timezone_data$TimeZone$america__juneau),
			_Utils_Tuple2('America/Kentucky/Louisville', $justinmimbs$timezone_data$TimeZone$america__kentucky__louisville),
			_Utils_Tuple2('America/Kentucky/Monticello', $justinmimbs$timezone_data$TimeZone$america__kentucky__monticello),
			_Utils_Tuple2('America/Kralendijk', $justinmimbs$timezone_data$TimeZone$america__kralendijk),
			_Utils_Tuple2('America/La_Paz', $justinmimbs$timezone_data$TimeZone$america__la_paz),
			_Utils_Tuple2('America/Lima', $justinmimbs$timezone_data$TimeZone$america__lima),
			_Utils_Tuple2('America/Los_Angeles', $justinmimbs$timezone_data$TimeZone$america__los_angeles),
			_Utils_Tuple2('America/Lower_Princes', $justinmimbs$timezone_data$TimeZone$america__lower_princes),
			_Utils_Tuple2('America/Maceio', $justinmimbs$timezone_data$TimeZone$america__maceio),
			_Utils_Tuple2('America/Managua', $justinmimbs$timezone_data$TimeZone$america__managua),
			_Utils_Tuple2('America/Manaus', $justinmimbs$timezone_data$TimeZone$america__manaus),
			_Utils_Tuple2('America/Marigot', $justinmimbs$timezone_data$TimeZone$america__marigot),
			_Utils_Tuple2('America/Martinique', $justinmimbs$timezone_data$TimeZone$america__martinique),
			_Utils_Tuple2('America/Matamoros', $justinmimbs$timezone_data$TimeZone$america__matamoros),
			_Utils_Tuple2('America/Mazatlan', $justinmimbs$timezone_data$TimeZone$america__mazatlan),
			_Utils_Tuple2('America/Menominee', $justinmimbs$timezone_data$TimeZone$america__menominee),
			_Utils_Tuple2('America/Merida', $justinmimbs$timezone_data$TimeZone$america__merida),
			_Utils_Tuple2('America/Metlakatla', $justinmimbs$timezone_data$TimeZone$america__metlakatla),
			_Utils_Tuple2('America/Mexico_City', $justinmimbs$timezone_data$TimeZone$america__mexico_city),
			_Utils_Tuple2('America/Miquelon', $justinmimbs$timezone_data$TimeZone$america__miquelon),
			_Utils_Tuple2('America/Moncton', $justinmimbs$timezone_data$TimeZone$america__moncton),
			_Utils_Tuple2('America/Monterrey', $justinmimbs$timezone_data$TimeZone$america__monterrey),
			_Utils_Tuple2('America/Montevideo', $justinmimbs$timezone_data$TimeZone$america__montevideo),
			_Utils_Tuple2('America/Montserrat', $justinmimbs$timezone_data$TimeZone$america__montserrat),
			_Utils_Tuple2('America/Nassau', $justinmimbs$timezone_data$TimeZone$america__nassau),
			_Utils_Tuple2('America/New_York', $justinmimbs$timezone_data$TimeZone$america__new_york),
			_Utils_Tuple2('America/Nipigon', $justinmimbs$timezone_data$TimeZone$america__nipigon),
			_Utils_Tuple2('America/Nome', $justinmimbs$timezone_data$TimeZone$america__nome),
			_Utils_Tuple2('America/Noronha', $justinmimbs$timezone_data$TimeZone$america__noronha),
			_Utils_Tuple2('America/North_Dakota/Beulah', $justinmimbs$timezone_data$TimeZone$america__north_dakota__beulah),
			_Utils_Tuple2('America/North_Dakota/Center', $justinmimbs$timezone_data$TimeZone$america__north_dakota__center),
			_Utils_Tuple2('America/North_Dakota/New_Salem', $justinmimbs$timezone_data$TimeZone$america__north_dakota__new_salem),
			_Utils_Tuple2('America/Nuuk', $justinmimbs$timezone_data$TimeZone$america__nuuk),
			_Utils_Tuple2('America/Ojinaga', $justinmimbs$timezone_data$TimeZone$america__ojinaga),
			_Utils_Tuple2('America/Panama', $justinmimbs$timezone_data$TimeZone$america__panama),
			_Utils_Tuple2('America/Pangnirtung', $justinmimbs$timezone_data$TimeZone$america__pangnirtung),
			_Utils_Tuple2('America/Paramaribo', $justinmimbs$timezone_data$TimeZone$america__paramaribo),
			_Utils_Tuple2('America/Phoenix', $justinmimbs$timezone_data$TimeZone$america__phoenix),
			_Utils_Tuple2('America/Port-au-Prince', $justinmimbs$timezone_data$TimeZone$america__port_au_prince),
			_Utils_Tuple2('America/Port_of_Spain', $justinmimbs$timezone_data$TimeZone$america__port_of_spain),
			_Utils_Tuple2('America/Porto_Velho', $justinmimbs$timezone_data$TimeZone$america__porto_velho),
			_Utils_Tuple2('America/Puerto_Rico', $justinmimbs$timezone_data$TimeZone$america__puerto_rico),
			_Utils_Tuple2('America/Punta_Arenas', $justinmimbs$timezone_data$TimeZone$america__punta_arenas),
			_Utils_Tuple2('America/Rainy_River', $justinmimbs$timezone_data$TimeZone$america__rainy_river),
			_Utils_Tuple2('America/Rankin_Inlet', $justinmimbs$timezone_data$TimeZone$america__rankin_inlet),
			_Utils_Tuple2('America/Recife', $justinmimbs$timezone_data$TimeZone$america__recife),
			_Utils_Tuple2('America/Regina', $justinmimbs$timezone_data$TimeZone$america__regina),
			_Utils_Tuple2('America/Resolute', $justinmimbs$timezone_data$TimeZone$america__resolute),
			_Utils_Tuple2('America/Rio_Branco', $justinmimbs$timezone_data$TimeZone$america__rio_branco),
			_Utils_Tuple2('America/Santarem', $justinmimbs$timezone_data$TimeZone$america__santarem),
			_Utils_Tuple2('America/Santiago', $justinmimbs$timezone_data$TimeZone$america__santiago),
			_Utils_Tuple2('America/Santo_Domingo', $justinmimbs$timezone_data$TimeZone$america__santo_domingo),
			_Utils_Tuple2('America/Sao_Paulo', $justinmimbs$timezone_data$TimeZone$america__sao_paulo),
			_Utils_Tuple2('America/Scoresbysund', $justinmimbs$timezone_data$TimeZone$america__scoresbysund),
			_Utils_Tuple2('America/Sitka', $justinmimbs$timezone_data$TimeZone$america__sitka),
			_Utils_Tuple2('America/St_Barthelemy', $justinmimbs$timezone_data$TimeZone$america__st_barthelemy),
			_Utils_Tuple2('America/St_Johns', $justinmimbs$timezone_data$TimeZone$america__st_johns),
			_Utils_Tuple2('America/St_Kitts', $justinmimbs$timezone_data$TimeZone$america__st_kitts),
			_Utils_Tuple2('America/St_Lucia', $justinmimbs$timezone_data$TimeZone$america__st_lucia),
			_Utils_Tuple2('America/St_Thomas', $justinmimbs$timezone_data$TimeZone$america__st_thomas),
			_Utils_Tuple2('America/St_Vincent', $justinmimbs$timezone_data$TimeZone$america__st_vincent),
			_Utils_Tuple2('America/Swift_Current', $justinmimbs$timezone_data$TimeZone$america__swift_current),
			_Utils_Tuple2('America/Tegucigalpa', $justinmimbs$timezone_data$TimeZone$america__tegucigalpa),
			_Utils_Tuple2('America/Thule', $justinmimbs$timezone_data$TimeZone$america__thule),
			_Utils_Tuple2('America/Thunder_Bay', $justinmimbs$timezone_data$TimeZone$america__thunder_bay),
			_Utils_Tuple2('America/Tijuana', $justinmimbs$timezone_data$TimeZone$america__tijuana),
			_Utils_Tuple2('America/Toronto', $justinmimbs$timezone_data$TimeZone$america__toronto),
			_Utils_Tuple2('America/Tortola', $justinmimbs$timezone_data$TimeZone$america__tortola),
			_Utils_Tuple2('America/Vancouver', $justinmimbs$timezone_data$TimeZone$america__vancouver),
			_Utils_Tuple2('America/Whitehorse', $justinmimbs$timezone_data$TimeZone$america__whitehorse),
			_Utils_Tuple2('America/Winnipeg', $justinmimbs$timezone_data$TimeZone$america__winnipeg),
			_Utils_Tuple2('America/Yakutat', $justinmimbs$timezone_data$TimeZone$america__yakutat),
			_Utils_Tuple2('America/Yellowknife', $justinmimbs$timezone_data$TimeZone$america__yellowknife),
			_Utils_Tuple2('Antarctica/Casey', $justinmimbs$timezone_data$TimeZone$antarctica__casey),
			_Utils_Tuple2('Antarctica/Davis', $justinmimbs$timezone_data$TimeZone$antarctica__davis),
			_Utils_Tuple2('Antarctica/DumontDUrville', $justinmimbs$timezone_data$TimeZone$antarctica__dumontdurville),
			_Utils_Tuple2('Antarctica/Macquarie', $justinmimbs$timezone_data$TimeZone$antarctica__macquarie),
			_Utils_Tuple2('Antarctica/Mawson', $justinmimbs$timezone_data$TimeZone$antarctica__mawson),
			_Utils_Tuple2('Antarctica/McMurdo', $justinmimbs$timezone_data$TimeZone$antarctica__mcmurdo),
			_Utils_Tuple2('Antarctica/Palmer', $justinmimbs$timezone_data$TimeZone$antarctica__palmer),
			_Utils_Tuple2('Antarctica/Rothera', $justinmimbs$timezone_data$TimeZone$antarctica__rothera),
			_Utils_Tuple2('Antarctica/Syowa', $justinmimbs$timezone_data$TimeZone$antarctica__syowa),
			_Utils_Tuple2('Antarctica/Troll', $justinmimbs$timezone_data$TimeZone$antarctica__troll),
			_Utils_Tuple2('Antarctica/Vostok', $justinmimbs$timezone_data$TimeZone$antarctica__vostok),
			_Utils_Tuple2('Arctic/Longyearbyen', $justinmimbs$timezone_data$TimeZone$arctic__longyearbyen),
			_Utils_Tuple2('Asia/Aden', $justinmimbs$timezone_data$TimeZone$asia__aden),
			_Utils_Tuple2('Asia/Almaty', $justinmimbs$timezone_data$TimeZone$asia__almaty),
			_Utils_Tuple2('Asia/Amman', $justinmimbs$timezone_data$TimeZone$asia__amman),
			_Utils_Tuple2('Asia/Anadyr', $justinmimbs$timezone_data$TimeZone$asia__anadyr),
			_Utils_Tuple2('Asia/Aqtau', $justinmimbs$timezone_data$TimeZone$asia__aqtau),
			_Utils_Tuple2('Asia/Aqtobe', $justinmimbs$timezone_data$TimeZone$asia__aqtobe),
			_Utils_Tuple2('Asia/Ashgabat', $justinmimbs$timezone_data$TimeZone$asia__ashgabat),
			_Utils_Tuple2('Asia/Atyrau', $justinmimbs$timezone_data$TimeZone$asia__atyrau),
			_Utils_Tuple2('Asia/Baghdad', $justinmimbs$timezone_data$TimeZone$asia__baghdad),
			_Utils_Tuple2('Asia/Bahrain', $justinmimbs$timezone_data$TimeZone$asia__bahrain),
			_Utils_Tuple2('Asia/Baku', $justinmimbs$timezone_data$TimeZone$asia__baku),
			_Utils_Tuple2('Asia/Bangkok', $justinmimbs$timezone_data$TimeZone$asia__bangkok),
			_Utils_Tuple2('Asia/Barnaul', $justinmimbs$timezone_data$TimeZone$asia__barnaul),
			_Utils_Tuple2('Asia/Beirut', $justinmimbs$timezone_data$TimeZone$asia__beirut),
			_Utils_Tuple2('Asia/Bishkek', $justinmimbs$timezone_data$TimeZone$asia__bishkek),
			_Utils_Tuple2('Asia/Brunei', $justinmimbs$timezone_data$TimeZone$asia__brunei),
			_Utils_Tuple2('Asia/Chita', $justinmimbs$timezone_data$TimeZone$asia__chita),
			_Utils_Tuple2('Asia/Choibalsan', $justinmimbs$timezone_data$TimeZone$asia__choibalsan),
			_Utils_Tuple2('Asia/Colombo', $justinmimbs$timezone_data$TimeZone$asia__colombo),
			_Utils_Tuple2('Asia/Damascus', $justinmimbs$timezone_data$TimeZone$asia__damascus),
			_Utils_Tuple2('Asia/Dhaka', $justinmimbs$timezone_data$TimeZone$asia__dhaka),
			_Utils_Tuple2('Asia/Dili', $justinmimbs$timezone_data$TimeZone$asia__dili),
			_Utils_Tuple2('Asia/Dubai', $justinmimbs$timezone_data$TimeZone$asia__dubai),
			_Utils_Tuple2('Asia/Dushanbe', $justinmimbs$timezone_data$TimeZone$asia__dushanbe),
			_Utils_Tuple2('Asia/Famagusta', $justinmimbs$timezone_data$TimeZone$asia__famagusta),
			_Utils_Tuple2('Asia/Gaza', $justinmimbs$timezone_data$TimeZone$asia__gaza),
			_Utils_Tuple2('Asia/Hebron', $justinmimbs$timezone_data$TimeZone$asia__hebron),
			_Utils_Tuple2('Asia/Ho_Chi_Minh', $justinmimbs$timezone_data$TimeZone$asia__ho_chi_minh),
			_Utils_Tuple2('Asia/Hong_Kong', $justinmimbs$timezone_data$TimeZone$asia__hong_kong),
			_Utils_Tuple2('Asia/Hovd', $justinmimbs$timezone_data$TimeZone$asia__hovd),
			_Utils_Tuple2('Asia/Irkutsk', $justinmimbs$timezone_data$TimeZone$asia__irkutsk),
			_Utils_Tuple2('Asia/Istanbul', $justinmimbs$timezone_data$TimeZone$asia__istanbul),
			_Utils_Tuple2('Asia/Jakarta', $justinmimbs$timezone_data$TimeZone$asia__jakarta),
			_Utils_Tuple2('Asia/Jayapura', $justinmimbs$timezone_data$TimeZone$asia__jayapura),
			_Utils_Tuple2('Asia/Jerusalem', $justinmimbs$timezone_data$TimeZone$asia__jerusalem),
			_Utils_Tuple2('Asia/Kabul', $justinmimbs$timezone_data$TimeZone$asia__kabul),
			_Utils_Tuple2('Asia/Kamchatka', $justinmimbs$timezone_data$TimeZone$asia__kamchatka),
			_Utils_Tuple2('Asia/Karachi', $justinmimbs$timezone_data$TimeZone$asia__karachi),
			_Utils_Tuple2('Asia/Kathmandu', $justinmimbs$timezone_data$TimeZone$asia__kathmandu),
			_Utils_Tuple2('Asia/Khandyga', $justinmimbs$timezone_data$TimeZone$asia__khandyga),
			_Utils_Tuple2('Asia/Kolkata', $justinmimbs$timezone_data$TimeZone$asia__kolkata),
			_Utils_Tuple2('Asia/Krasnoyarsk', $justinmimbs$timezone_data$TimeZone$asia__krasnoyarsk),
			_Utils_Tuple2('Asia/Kuala_Lumpur', $justinmimbs$timezone_data$TimeZone$asia__kuala_lumpur),
			_Utils_Tuple2('Asia/Kuching', $justinmimbs$timezone_data$TimeZone$asia__kuching),
			_Utils_Tuple2('Asia/Kuwait', $justinmimbs$timezone_data$TimeZone$asia__kuwait),
			_Utils_Tuple2('Asia/Macau', $justinmimbs$timezone_data$TimeZone$asia__macau),
			_Utils_Tuple2('Asia/Magadan', $justinmimbs$timezone_data$TimeZone$asia__magadan),
			_Utils_Tuple2('Asia/Makassar', $justinmimbs$timezone_data$TimeZone$asia__makassar),
			_Utils_Tuple2('Asia/Manila', $justinmimbs$timezone_data$TimeZone$asia__manila),
			_Utils_Tuple2('Asia/Muscat', $justinmimbs$timezone_data$TimeZone$asia__muscat),
			_Utils_Tuple2('Asia/Nicosia', $justinmimbs$timezone_data$TimeZone$asia__nicosia),
			_Utils_Tuple2('Asia/Novokuznetsk', $justinmimbs$timezone_data$TimeZone$asia__novokuznetsk),
			_Utils_Tuple2('Asia/Novosibirsk', $justinmimbs$timezone_data$TimeZone$asia__novosibirsk),
			_Utils_Tuple2('Asia/Omsk', $justinmimbs$timezone_data$TimeZone$asia__omsk),
			_Utils_Tuple2('Asia/Oral', $justinmimbs$timezone_data$TimeZone$asia__oral),
			_Utils_Tuple2('Asia/Phnom_Penh', $justinmimbs$timezone_data$TimeZone$asia__phnom_penh),
			_Utils_Tuple2('Asia/Pontianak', $justinmimbs$timezone_data$TimeZone$asia__pontianak),
			_Utils_Tuple2('Asia/Pyongyang', $justinmimbs$timezone_data$TimeZone$asia__pyongyang),
			_Utils_Tuple2('Asia/Qatar', $justinmimbs$timezone_data$TimeZone$asia__qatar),
			_Utils_Tuple2('Asia/Qostanay', $justinmimbs$timezone_data$TimeZone$asia__qostanay),
			_Utils_Tuple2('Asia/Qyzylorda', $justinmimbs$timezone_data$TimeZone$asia__qyzylorda),
			_Utils_Tuple2('Asia/Riyadh', $justinmimbs$timezone_data$TimeZone$asia__riyadh),
			_Utils_Tuple2('Asia/Sakhalin', $justinmimbs$timezone_data$TimeZone$asia__sakhalin),
			_Utils_Tuple2('Asia/Samarkand', $justinmimbs$timezone_data$TimeZone$asia__samarkand),
			_Utils_Tuple2('Asia/Seoul', $justinmimbs$timezone_data$TimeZone$asia__seoul),
			_Utils_Tuple2('Asia/Shanghai', $justinmimbs$timezone_data$TimeZone$asia__shanghai),
			_Utils_Tuple2('Asia/Singapore', $justinmimbs$timezone_data$TimeZone$asia__singapore),
			_Utils_Tuple2('Asia/Srednekolymsk', $justinmimbs$timezone_data$TimeZone$asia__srednekolymsk),
			_Utils_Tuple2('Asia/Taipei', $justinmimbs$timezone_data$TimeZone$asia__taipei),
			_Utils_Tuple2('Asia/Tashkent', $justinmimbs$timezone_data$TimeZone$asia__tashkent),
			_Utils_Tuple2('Asia/Tbilisi', $justinmimbs$timezone_data$TimeZone$asia__tbilisi),
			_Utils_Tuple2('Asia/Tehran', $justinmimbs$timezone_data$TimeZone$asia__tehran),
			_Utils_Tuple2('Asia/Thimphu', $justinmimbs$timezone_data$TimeZone$asia__thimphu),
			_Utils_Tuple2('Asia/Tokyo', $justinmimbs$timezone_data$TimeZone$asia__tokyo),
			_Utils_Tuple2('Asia/Tomsk', $justinmimbs$timezone_data$TimeZone$asia__tomsk),
			_Utils_Tuple2('Asia/Ulaanbaatar', $justinmimbs$timezone_data$TimeZone$asia__ulaanbaatar),
			_Utils_Tuple2('Asia/Urumqi', $justinmimbs$timezone_data$TimeZone$asia__urumqi),
			_Utils_Tuple2('Asia/Ust-Nera', $justinmimbs$timezone_data$TimeZone$asia__ust_nera),
			_Utils_Tuple2('Asia/Vientiane', $justinmimbs$timezone_data$TimeZone$asia__vientiane),
			_Utils_Tuple2('Asia/Vladivostok', $justinmimbs$timezone_data$TimeZone$asia__vladivostok),
			_Utils_Tuple2('Asia/Yakutsk', $justinmimbs$timezone_data$TimeZone$asia__yakutsk),
			_Utils_Tuple2('Asia/Yangon', $justinmimbs$timezone_data$TimeZone$asia__yangon),
			_Utils_Tuple2('Asia/Yekaterinburg', $justinmimbs$timezone_data$TimeZone$asia__yekaterinburg),
			_Utils_Tuple2('Asia/Yerevan', $justinmimbs$timezone_data$TimeZone$asia__yerevan),
			_Utils_Tuple2('Atlantic/Azores', $justinmimbs$timezone_data$TimeZone$atlantic__azores),
			_Utils_Tuple2('Atlantic/Bermuda', $justinmimbs$timezone_data$TimeZone$atlantic__bermuda),
			_Utils_Tuple2('Atlantic/Canary', $justinmimbs$timezone_data$TimeZone$atlantic__canary),
			_Utils_Tuple2('Atlantic/Cape_Verde', $justinmimbs$timezone_data$TimeZone$atlantic__cape_verde),
			_Utils_Tuple2('Atlantic/Faroe', $justinmimbs$timezone_data$TimeZone$atlantic__faroe),
			_Utils_Tuple2('Atlantic/Madeira', $justinmimbs$timezone_data$TimeZone$atlantic__madeira),
			_Utils_Tuple2('Atlantic/Reykjavik', $justinmimbs$timezone_data$TimeZone$atlantic__reykjavik),
			_Utils_Tuple2('Atlantic/South_Georgia', $justinmimbs$timezone_data$TimeZone$atlantic__south_georgia),
			_Utils_Tuple2('Atlantic/St_Helena', $justinmimbs$timezone_data$TimeZone$atlantic__st_helena),
			_Utils_Tuple2('Atlantic/Stanley', $justinmimbs$timezone_data$TimeZone$atlantic__stanley),
			_Utils_Tuple2('Australia/Adelaide', $justinmimbs$timezone_data$TimeZone$australia__adelaide),
			_Utils_Tuple2('Australia/Brisbane', $justinmimbs$timezone_data$TimeZone$australia__brisbane),
			_Utils_Tuple2('Australia/Broken_Hill', $justinmimbs$timezone_data$TimeZone$australia__broken_hill),
			_Utils_Tuple2('Australia/Darwin', $justinmimbs$timezone_data$TimeZone$australia__darwin),
			_Utils_Tuple2('Australia/Eucla', $justinmimbs$timezone_data$TimeZone$australia__eucla),
			_Utils_Tuple2('Australia/Hobart', $justinmimbs$timezone_data$TimeZone$australia__hobart),
			_Utils_Tuple2('Australia/Lindeman', $justinmimbs$timezone_data$TimeZone$australia__lindeman),
			_Utils_Tuple2('Australia/Lord_Howe', $justinmimbs$timezone_data$TimeZone$australia__lord_howe),
			_Utils_Tuple2('Australia/Melbourne', $justinmimbs$timezone_data$TimeZone$australia__melbourne),
			_Utils_Tuple2('Australia/Perth', $justinmimbs$timezone_data$TimeZone$australia__perth),
			_Utils_Tuple2('Australia/Sydney', $justinmimbs$timezone_data$TimeZone$australia__sydney),
			_Utils_Tuple2('Europe/Amsterdam', $justinmimbs$timezone_data$TimeZone$europe__amsterdam),
			_Utils_Tuple2('Europe/Andorra', $justinmimbs$timezone_data$TimeZone$europe__andorra),
			_Utils_Tuple2('Europe/Astrakhan', $justinmimbs$timezone_data$TimeZone$europe__astrakhan),
			_Utils_Tuple2('Europe/Athens', $justinmimbs$timezone_data$TimeZone$europe__athens),
			_Utils_Tuple2('Europe/Belgrade', $justinmimbs$timezone_data$TimeZone$europe__belgrade),
			_Utils_Tuple2('Europe/Berlin', $justinmimbs$timezone_data$TimeZone$europe__berlin),
			_Utils_Tuple2('Europe/Bratislava', $justinmimbs$timezone_data$TimeZone$europe__bratislava),
			_Utils_Tuple2('Europe/Brussels', $justinmimbs$timezone_data$TimeZone$europe__brussels),
			_Utils_Tuple2('Europe/Bucharest', $justinmimbs$timezone_data$TimeZone$europe__bucharest),
			_Utils_Tuple2('Europe/Budapest', $justinmimbs$timezone_data$TimeZone$europe__budapest),
			_Utils_Tuple2('Europe/Busingen', $justinmimbs$timezone_data$TimeZone$europe__busingen),
			_Utils_Tuple2('Europe/Chisinau', $justinmimbs$timezone_data$TimeZone$europe__chisinau),
			_Utils_Tuple2('Europe/Copenhagen', $justinmimbs$timezone_data$TimeZone$europe__copenhagen),
			_Utils_Tuple2('Europe/Dublin', $justinmimbs$timezone_data$TimeZone$europe__dublin),
			_Utils_Tuple2('Europe/Gibraltar', $justinmimbs$timezone_data$TimeZone$europe__gibraltar),
			_Utils_Tuple2('Europe/Guernsey', $justinmimbs$timezone_data$TimeZone$europe__guernsey),
			_Utils_Tuple2('Europe/Helsinki', $justinmimbs$timezone_data$TimeZone$europe__helsinki),
			_Utils_Tuple2('Europe/Isle_of_Man', $justinmimbs$timezone_data$TimeZone$europe__isle_of_man),
			_Utils_Tuple2('Europe/Istanbul', $justinmimbs$timezone_data$TimeZone$europe__istanbul),
			_Utils_Tuple2('Europe/Jersey', $justinmimbs$timezone_data$TimeZone$europe__jersey),
			_Utils_Tuple2('Europe/Kaliningrad', $justinmimbs$timezone_data$TimeZone$europe__kaliningrad),
			_Utils_Tuple2('Europe/Kiev', $justinmimbs$timezone_data$TimeZone$europe__kiev),
			_Utils_Tuple2('Europe/Kirov', $justinmimbs$timezone_data$TimeZone$europe__kirov),
			_Utils_Tuple2('Europe/Lisbon', $justinmimbs$timezone_data$TimeZone$europe__lisbon),
			_Utils_Tuple2('Europe/Ljubljana', $justinmimbs$timezone_data$TimeZone$europe__ljubljana),
			_Utils_Tuple2('Europe/London', $justinmimbs$timezone_data$TimeZone$europe__london),
			_Utils_Tuple2('Europe/Luxembourg', $justinmimbs$timezone_data$TimeZone$europe__luxembourg),
			_Utils_Tuple2('Europe/Madrid', $justinmimbs$timezone_data$TimeZone$europe__madrid),
			_Utils_Tuple2('Europe/Malta', $justinmimbs$timezone_data$TimeZone$europe__malta),
			_Utils_Tuple2('Europe/Mariehamn', $justinmimbs$timezone_data$TimeZone$europe__mariehamn),
			_Utils_Tuple2('Europe/Minsk', $justinmimbs$timezone_data$TimeZone$europe__minsk),
			_Utils_Tuple2('Europe/Monaco', $justinmimbs$timezone_data$TimeZone$europe__monaco),
			_Utils_Tuple2('Europe/Moscow', $justinmimbs$timezone_data$TimeZone$europe__moscow),
			_Utils_Tuple2('Europe/Nicosia', $justinmimbs$timezone_data$TimeZone$europe__nicosia),
			_Utils_Tuple2('Europe/Oslo', $justinmimbs$timezone_data$TimeZone$europe__oslo),
			_Utils_Tuple2('Europe/Paris', $justinmimbs$timezone_data$TimeZone$europe__paris),
			_Utils_Tuple2('Europe/Podgorica', $justinmimbs$timezone_data$TimeZone$europe__podgorica),
			_Utils_Tuple2('Europe/Prague', $justinmimbs$timezone_data$TimeZone$europe__prague),
			_Utils_Tuple2('Europe/Riga', $justinmimbs$timezone_data$TimeZone$europe__riga),
			_Utils_Tuple2('Europe/Rome', $justinmimbs$timezone_data$TimeZone$europe__rome),
			_Utils_Tuple2('Europe/Samara', $justinmimbs$timezone_data$TimeZone$europe__samara),
			_Utils_Tuple2('Europe/San_Marino', $justinmimbs$timezone_data$TimeZone$europe__san_marino),
			_Utils_Tuple2('Europe/Sarajevo', $justinmimbs$timezone_data$TimeZone$europe__sarajevo),
			_Utils_Tuple2('Europe/Saratov', $justinmimbs$timezone_data$TimeZone$europe__saratov),
			_Utils_Tuple2('Europe/Simferopol', $justinmimbs$timezone_data$TimeZone$europe__simferopol),
			_Utils_Tuple2('Europe/Skopje', $justinmimbs$timezone_data$TimeZone$europe__skopje),
			_Utils_Tuple2('Europe/Sofia', $justinmimbs$timezone_data$TimeZone$europe__sofia),
			_Utils_Tuple2('Europe/Stockholm', $justinmimbs$timezone_data$TimeZone$europe__stockholm),
			_Utils_Tuple2('Europe/Tallinn', $justinmimbs$timezone_data$TimeZone$europe__tallinn),
			_Utils_Tuple2('Europe/Tirane', $justinmimbs$timezone_data$TimeZone$europe__tirane),
			_Utils_Tuple2('Europe/Ulyanovsk', $justinmimbs$timezone_data$TimeZone$europe__ulyanovsk),
			_Utils_Tuple2('Europe/Uzhgorod', $justinmimbs$timezone_data$TimeZone$europe__uzhgorod),
			_Utils_Tuple2('Europe/Vaduz', $justinmimbs$timezone_data$TimeZone$europe__vaduz),
			_Utils_Tuple2('Europe/Vatican', $justinmimbs$timezone_data$TimeZone$europe__vatican),
			_Utils_Tuple2('Europe/Vienna', $justinmimbs$timezone_data$TimeZone$europe__vienna),
			_Utils_Tuple2('Europe/Vilnius', $justinmimbs$timezone_data$TimeZone$europe__vilnius),
			_Utils_Tuple2('Europe/Volgograd', $justinmimbs$timezone_data$TimeZone$europe__volgograd),
			_Utils_Tuple2('Europe/Warsaw', $justinmimbs$timezone_data$TimeZone$europe__warsaw),
			_Utils_Tuple2('Europe/Zagreb', $justinmimbs$timezone_data$TimeZone$europe__zagreb),
			_Utils_Tuple2('Europe/Zaporozhye', $justinmimbs$timezone_data$TimeZone$europe__zaporozhye),
			_Utils_Tuple2('Europe/Zurich', $justinmimbs$timezone_data$TimeZone$europe__zurich),
			_Utils_Tuple2('Indian/Antananarivo', $justinmimbs$timezone_data$TimeZone$indian__antananarivo),
			_Utils_Tuple2('Indian/Chagos', $justinmimbs$timezone_data$TimeZone$indian__chagos),
			_Utils_Tuple2('Indian/Christmas', $justinmimbs$timezone_data$TimeZone$indian__christmas),
			_Utils_Tuple2('Indian/Cocos', $justinmimbs$timezone_data$TimeZone$indian__cocos),
			_Utils_Tuple2('Indian/Comoro', $justinmimbs$timezone_data$TimeZone$indian__comoro),
			_Utils_Tuple2('Indian/Kerguelen', $justinmimbs$timezone_data$TimeZone$indian__kerguelen),
			_Utils_Tuple2('Indian/Mahe', $justinmimbs$timezone_data$TimeZone$indian__mahe),
			_Utils_Tuple2('Indian/Maldives', $justinmimbs$timezone_data$TimeZone$indian__maldives),
			_Utils_Tuple2('Indian/Mauritius', $justinmimbs$timezone_data$TimeZone$indian__mauritius),
			_Utils_Tuple2('Indian/Mayotte', $justinmimbs$timezone_data$TimeZone$indian__mayotte),
			_Utils_Tuple2('Indian/Reunion', $justinmimbs$timezone_data$TimeZone$indian__reunion),
			_Utils_Tuple2('Pacific/Apia', $justinmimbs$timezone_data$TimeZone$pacific__apia),
			_Utils_Tuple2('Pacific/Auckland', $justinmimbs$timezone_data$TimeZone$pacific__auckland),
			_Utils_Tuple2('Pacific/Bougainville', $justinmimbs$timezone_data$TimeZone$pacific__bougainville),
			_Utils_Tuple2('Pacific/Chatham', $justinmimbs$timezone_data$TimeZone$pacific__chatham),
			_Utils_Tuple2('Pacific/Chuuk', $justinmimbs$timezone_data$TimeZone$pacific__chuuk),
			_Utils_Tuple2('Pacific/Easter', $justinmimbs$timezone_data$TimeZone$pacific__easter),
			_Utils_Tuple2('Pacific/Efate', $justinmimbs$timezone_data$TimeZone$pacific__efate),
			_Utils_Tuple2('Pacific/Enderbury', $justinmimbs$timezone_data$TimeZone$pacific__enderbury),
			_Utils_Tuple2('Pacific/Fakaofo', $justinmimbs$timezone_data$TimeZone$pacific__fakaofo),
			_Utils_Tuple2('Pacific/Fiji', $justinmimbs$timezone_data$TimeZone$pacific__fiji),
			_Utils_Tuple2('Pacific/Funafuti', $justinmimbs$timezone_data$TimeZone$pacific__funafuti),
			_Utils_Tuple2('Pacific/Galapagos', $justinmimbs$timezone_data$TimeZone$pacific__galapagos),
			_Utils_Tuple2('Pacific/Gambier', $justinmimbs$timezone_data$TimeZone$pacific__gambier),
			_Utils_Tuple2('Pacific/Guadalcanal', $justinmimbs$timezone_data$TimeZone$pacific__guadalcanal),
			_Utils_Tuple2('Pacific/Guam', $justinmimbs$timezone_data$TimeZone$pacific__guam),
			_Utils_Tuple2('Pacific/Honolulu', $justinmimbs$timezone_data$TimeZone$pacific__honolulu),
			_Utils_Tuple2('Pacific/Kiritimati', $justinmimbs$timezone_data$TimeZone$pacific__kiritimati),
			_Utils_Tuple2('Pacific/Kosrae', $justinmimbs$timezone_data$TimeZone$pacific__kosrae),
			_Utils_Tuple2('Pacific/Kwajalein', $justinmimbs$timezone_data$TimeZone$pacific__kwajalein),
			_Utils_Tuple2('Pacific/Majuro', $justinmimbs$timezone_data$TimeZone$pacific__majuro),
			_Utils_Tuple2('Pacific/Marquesas', $justinmimbs$timezone_data$TimeZone$pacific__marquesas),
			_Utils_Tuple2('Pacific/Midway', $justinmimbs$timezone_data$TimeZone$pacific__midway),
			_Utils_Tuple2('Pacific/Nauru', $justinmimbs$timezone_data$TimeZone$pacific__nauru),
			_Utils_Tuple2('Pacific/Niue', $justinmimbs$timezone_data$TimeZone$pacific__niue),
			_Utils_Tuple2('Pacific/Norfolk', $justinmimbs$timezone_data$TimeZone$pacific__norfolk),
			_Utils_Tuple2('Pacific/Noumea', $justinmimbs$timezone_data$TimeZone$pacific__noumea),
			_Utils_Tuple2('Pacific/Pago_Pago', $justinmimbs$timezone_data$TimeZone$pacific__pago_pago),
			_Utils_Tuple2('Pacific/Palau', $justinmimbs$timezone_data$TimeZone$pacific__palau),
			_Utils_Tuple2('Pacific/Pitcairn', $justinmimbs$timezone_data$TimeZone$pacific__pitcairn),
			_Utils_Tuple2('Pacific/Pohnpei', $justinmimbs$timezone_data$TimeZone$pacific__pohnpei),
			_Utils_Tuple2('Pacific/Port_Moresby', $justinmimbs$timezone_data$TimeZone$pacific__port_moresby),
			_Utils_Tuple2('Pacific/Rarotonga', $justinmimbs$timezone_data$TimeZone$pacific__rarotonga),
			_Utils_Tuple2('Pacific/Saipan', $justinmimbs$timezone_data$TimeZone$pacific__saipan),
			_Utils_Tuple2('Pacific/Tahiti', $justinmimbs$timezone_data$TimeZone$pacific__tahiti),
			_Utils_Tuple2('Pacific/Tarawa', $justinmimbs$timezone_data$TimeZone$pacific__tarawa),
			_Utils_Tuple2('Pacific/Tongatapu', $justinmimbs$timezone_data$TimeZone$pacific__tongatapu),
			_Utils_Tuple2('Pacific/Wake', $justinmimbs$timezone_data$TimeZone$pacific__wake),
			_Utils_Tuple2('Pacific/Wallis', $justinmimbs$timezone_data$TimeZone$pacific__wallis)
		]));
var $justinmimbs$timezone_data$TimeZone$getZone = A2(
	$elm$core$Task$andThen,
	function (nameOrOffset) {
		if (!nameOrOffset.$) {
			var zoneName = nameOrOffset.a;
			var _v1 = A2($elm$core$Dict$get, zoneName, $justinmimbs$timezone_data$TimeZone$zones);
			if (!_v1.$) {
				var zone = _v1.a;
				return $elm$core$Task$succeed(
					_Utils_Tuple2(
						zoneName,
						zone(0)));
			} else {
				return $elm$core$Task$fail(
					$justinmimbs$timezone_data$TimeZone$NoDataForZoneName(zoneName));
			}
		} else {
			return $elm$core$Task$fail($justinmimbs$timezone_data$TimeZone$NoZoneName);
		}
	},
	$elm$time$Time$getZoneName);
var $author$project$Components$GlobalSearch$Closed = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$GlobalSearch$GotSearchPermissions = function (a) {
	return {$: 14, a: a};
};
var $author$project$Utils$Maybe$toBool = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Api$Data$clientHasAuthToken = function (_v0) {
	var client = _v0;
	return $author$project$Utils$Maybe$toBool(client.fK);
};
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$Api$Provider$SearchPermissions$All$SearchPermissions = $elm$core$Basics$identity;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $author$project$Api$Provider$SearchPermissions$Shared$SearchPermissions = $elm$core$Basics$identity;
var $author$project$Api$Provider$SearchPermissions$Shared$Record = F4(
	function (id, attributes, searchable, name) {
		return {xr: attributes, ahP: id, Bq: name, aaB: searchable};
	});
var $elm$json$Json$Decode$list = _Json_decodeList;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Api$Provider$SearchPermissions$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'searchable',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'attributes',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$SearchPermissions$Shared$Record)))));
var $author$project$Api$Provider$SearchPermissions$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$SearchPermissions$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$SearchPermissions$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$SearchPermissions$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $author$project$Api$Data$Failure = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Data$Success = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Api$Data$fromResult = function (result) {
	if (!result.$) {
		var _v1 = result.a;
		var value = _v1.a;
		var headers = _v1.b;
		return A2($author$project$Api$Data$Success, value, headers);
	} else {
		var reasons = result.a;
		return $author$project$Api$Data$Failure(reasons);
	}
};
var $author$project$Api$Data$BadStatus = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Api$Data$BadUrl = {$: 1};
var $author$project$Api$Data$Conflict = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Data$Decoder = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Data$Forbidden = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Data$GatewayError = {$: 4};
var $author$project$Api$Data$Network = {$: 3};
var $author$project$Api$Data$NotFound = {$: 5};
var $author$project$Api$Data$Timeout = {$: 2};
var $author$project$Api$Data$Unauthorized = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $author$project$Api$Data$decodeErrorToString = function (decodeError) {
	switch (decodeError.$) {
		case 0:
			return $elm$json$Json$Decode$errorToString(decodeError);
		case 1:
			var index = decodeError.a;
			var error = decodeError.b;
			return $elm$core$String$fromInt(index) + (' -> ' + $author$project$Api$Data$decodeErrorToString(error));
		case 2:
			var errors = decodeError.a;
			return A2(
				$elm$core$String$join,
				'\n',
				A2($elm$core$List$map, $author$project$Api$Data$decodeErrorToString, errors));
		default:
			var message = decodeError.a;
			return message + ('\n' + A3(
				$elm$core$String$replace,
				message,
				'',
				A3(
					$elm$core$String$replace,
					'  ',
					'',
					A3(
						$elm$core$String$replace,
						'\n',
						'',
						A3(
							$elm$core$String$replace,
							'Problem with the given value:',
							'',
							$elm$json$Json$Decode$errorToString(decodeError))))));
	}
};
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $author$project$Api$Data$InternalServerError = function (a) {
	return {$: 8, a: a};
};
var $elm$core$Result$toMaybe = function (result) {
	if (!result.$) {
		var v = result.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Data$handleServerError = function (body) {
	var decodedMessage = A2(
		$elm$json$Json$Decode$decodeString,
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['message']),
			$elm$json$Json$Decode$string),
		body);
	return $elm$core$Result$Err(
		$author$project$Api$Data$InternalServerError(
			$elm$core$Result$toMaybe(decodedMessage)));
};
var $author$project$Api$Data$handleJsonResponse = F2(
	function (decoder, response) {
		switch (response.$) {
			case 0:
				return $elm$core$Result$Err($author$project$Api$Data$BadUrl);
			case 1:
				return $elm$core$Result$Err($author$project$Api$Data$Timeout);
			case 2:
				return $elm$core$Result$Err($author$project$Api$Data$Network);
			case 3:
				var metadata = response.a;
				var body = response.b;
				var _v1 = metadata.ace;
				switch (_v1) {
					case 404:
						return $elm$core$Result$Err($author$project$Api$Data$NotFound);
					case 401:
						var decodedMessage = A2(
							$elm$json$Json$Decode$decodeString,
							A2(
								$elm$json$Json$Decode$at,
								_List_fromArray(
									['message']),
								$elm$json$Json$Decode$string),
							body);
						return $elm$core$Result$Err(
							$author$project$Api$Data$Unauthorized(
								$elm$core$Result$toMaybe(decodedMessage)));
					case 403:
						var decodedMessage = A2(
							$elm$json$Json$Decode$decodeString,
							A2(
								$elm$json$Json$Decode$at,
								_List_fromArray(
									['message']),
								$elm$json$Json$Decode$string),
							body);
						return $elm$core$Result$Err(
							$author$project$Api$Data$Forbidden(
								$elm$core$Result$toMaybe(decodedMessage)));
					case 409:
						var decodedMessage = A2(
							$elm$json$Json$Decode$decodeString,
							A2(
								$elm$json$Json$Decode$at,
								_List_fromArray(
									['message']),
								$elm$json$Json$Decode$string),
							body);
						return $elm$core$Result$Err(
							$author$project$Api$Data$Conflict(
								$elm$core$Result$toMaybe(decodedMessage)));
					case 500:
						return $author$project$Api$Data$handleServerError(body);
					case 504:
						return $author$project$Api$Data$handleServerError(body);
					case 502:
						return $elm$core$Result$Err($author$project$Api$Data$GatewayError);
					default:
						var decodedError = A2(
							$elm$json$Json$Decode$decodeString,
							A2(
								$elm$json$Json$Decode$at,
								_List_fromArray(
									['message']),
								$elm$json$Json$Decode$string),
							body);
						if (!decodedError.$) {
							var error = decodedError.a;
							return $elm$core$Result$Err(
								A2($author$project$Api$Data$BadStatus, metadata.ace, error));
						} else {
							var decoderError = decodedError.a;
							return $elm$core$Result$Err(
								$author$project$Api$Data$Decoder(
									'[' + (metadata.adY + ('] ' + $author$project$Api$Data$decodeErrorToString(decoderError)))));
						}
				}
			default:
				var metadata = response.a;
				var body = response.b;
				var jsonBody = $elm$core$String$isEmpty(body) ? '{}' : body;
				var _v3 = A2($elm$json$Json$Decode$decodeString, decoder, jsonBody);
				if (!_v3.$) {
					var decoded = _v3.a;
					return $elm$core$Result$Ok(
						_Utils_Tuple2(decoded, metadata.jP));
				} else {
					var error = _v3.a;
					return $elm$core$Result$Err(
						$author$project$Api$Data$Decoder(
							'[' + (metadata.adY + ('] ' + $author$project$Api$Data$decodeErrorToString(error)))));
				}
		}
	});
var $author$project$Api$Data$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			A2($elm$core$Basics$composeR, $author$project$Api$Data$fromResult, toMsg),
			$author$project$Api$Data$handleJsonResponse(decoder));
	});
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {$z: reqs, acx: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.vd;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.$z));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.acx)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					aeR: r.aeR,
					fO: r.fO,
					RT: A2(_Http_mapExpect, func, r.RT),
					jP: r.jP,
					IA: r.IA,
					J9: r.J9,
					vd: r.vd,
					adY: r.adY
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{aeR: false, fO: r.fO, RT: r.RT, jP: r.jP, IA: r.IA, J9: r.J9, vd: r.vd, adY: r.adY}));
};
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $elm$http$Http$filePart = _Http_pair;
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$http$Http$multipartBody = function (parts) {
	return A2(
		_Http_pair,
		'',
		_Http_toFormData(parts));
};
var $author$project$Api$Data$requestBody = function (_v0) {
	var request = _v0;
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$http$Http$emptyBody,
		A2(
			$elm$core$Maybe$map,
			function (body) {
				switch (body.$) {
					case 0:
						var value = body.a;
						return $elm$http$Http$jsonBody(value);
					case 1:
						var name = body.a;
						var files = body.b;
						return $elm$http$Http$multipartBody(
							A2(
								$elm$core$List$map,
								$elm$http$Http$filePart(name),
								files));
					default:
						var parts = body.a;
						return $elm$http$Http$multipartBody(parts);
				}
			},
			request.fO));
};
var $author$project$Api$AuthToken$toString = function (authToken) {
	var token = authToken;
	return $elm$core$Maybe$Just(token);
};
var $author$project$Api$AuthToken$asHeader = function (authToken) {
	return A2(
		$elm$core$Maybe$map,
		function (token) {
			return 'Bearer ' + token;
		},
		$author$project$Api$AuthToken$toString(authToken));
};
var $elm$http$Http$Header = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$header = $elm$http$Http$Header;
var $author$project$Api$Data$authHeader = function (authToken) {
	return A2(
		$elm$core$Maybe$map,
		function (tokenHeader) {
			return A2($elm$http$Http$header, 'Authorization', tokenHeader);
		},
		$author$project$Api$AuthToken$asHeader(authToken));
};
var $author$project$Api$Data$clientApiVersionHeader = $elm$core$Maybe$map(
	$elm$http$Http$header('Hint-Version'));
var $author$project$Api$Data$clientHeaders = function (_v0) {
	var sendAuth = _v0.Ev;
	var authToken = _v0.fK;
	var apiVersion = _v0.Gw;
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				sendAuth ? A2($elm$core$Maybe$andThen, $author$project$Api$Data$authHeader, authToken) : $elm$core$Maybe$Nothing,
				$author$project$Api$Data$clientApiVersionHeader(apiVersion)
			]));
};
var $author$project$Api$Data$requestHeaders = F2(
	function (client, _v0) {
		var request = _v0;
		return _Utils_ap(
			request.jP,
			$author$project$Api$Data$clientHeaders(client));
	});
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $elm$url$Url$Builder$crossOrigin = F3(
	function (prePath, pathSegments, parameters) {
		return prePath + ('/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters)));
	});
var $author$project$Api$Data$formatToString = function (format) {
	return '.csv';
};
var $author$project$Api$Data$pathToPieces = F2(
	function (maybeFormat, _v0) {
		var pieces = _v0;
		if (!maybeFormat.$) {
			var format = maybeFormat.a;
			return A2(
				$elm$core$List$indexedMap,
				F2(
					function (index, piece) {
						return _Utils_eq(
							index,
							$elm$core$List$length(pieces) - 1) ? _Utils_ap(
							piece,
							$author$project$Api$Data$formatToString(format)) : piece;
					}),
				pieces);
		} else {
			return pieces;
		}
	});
var $author$project$Api$Data$requestToUrl = F2(
	function (_v0, _v1) {
		var client = _v0;
		var request = _v1;
		return A3(
			$elm$url$Url$Builder$crossOrigin,
			client.Du,
			A2(
				$elm$core$List$cons,
				'api',
				A2($author$project$Api$Data$pathToPieces, $elm$core$Maybe$Nothing, request.ada)),
			request.DE);
	});
var $elm$core$String$toUpper = _String_toUpper;
var $author$project$Api$Data$makeRequest = F5(
	function (method, client, decoder, toMsg, request) {
		var tracker = request.vd;
		return $elm$http$Http$request(
			{
				fO: $author$project$Api$Data$requestBody(request),
				RT: A2($author$project$Api$Data$expectJson, toMsg, decoder),
				jP: A2($author$project$Api$Data$requestHeaders, client, request),
				IA: $elm$core$String$toUpper(method),
				J9: $elm$core$Maybe$Just(61 * 1000),
				vd: tracker,
				adY: A2($author$project$Api$Data$requestToUrl, client, request)
			});
	});
var $author$project$Api$Data$get = $author$project$Api$Data$makeRequest('get');
var $author$project$Api$Data$Path = $elm$core$Basics$identity;
var $author$project$Api$Data$pathAppend = F2(
	function (pieces, _v0) {
		var path = _v0;
		return _Utils_ap(path, pieces);
	});
var $author$project$Api$Data$newPath = $elm$core$Basics$identity;
var $author$project$Api$Data$providerPath = $author$project$Api$Data$newPath(
	_List_fromArray(
		['provider']));
var $author$project$Api$Provider$Search$path = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['search']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Data$Request = $elm$core$Basics$identity;
var $author$project$Api$Data$requestTo = function (path) {
	return {
		fO: $elm$core$Maybe$Nothing,
		jP: _List_fromArray(
			[
				A2($elm$http$Http$header, 'Accept', 'application/json, text/plain, */*')
			]),
		DE: _List_Nil,
		ada: path,
		vd: $elm$core$Maybe$Nothing
	};
};
var $author$project$Api$Provider$Search$permissions = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$SearchPermissions$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['permissions']),
					$author$project$Api$Provider$Search$path)));
	});
var $author$project$Components$GlobalSearch$init = F2(
	function (apiClient, url) {
		var searchPermissionsCmd = $author$project$Api$Data$clientHasAuthToken(apiClient) ? A2($author$project$Api$Provider$Search$permissions, apiClient, $author$project$Components$GlobalSearch$GotSearchPermissions) : $elm$core$Platform$Cmd$none;
		return _Utils_Tuple2(
			$author$project$Components$GlobalSearch$Closed(
				{adY: url}),
			searchPermissionsCmd);
	});
var $gingko$time_distance$Time$Distance$I18n$en = F3(
	function (_v0, tense, distanceId) {
		var withAffix = _v0.amu;
		var toStr = $elm$core$String$fromInt;
		var maybeAffix = function (str) {
			var _v2 = _Utils_Tuple2(withAffix, tense);
			if (_v2.a) {
				if (!_v2.b) {
					var _v3 = _v2.b;
					return str + ' ago';
				} else {
					var _v4 = _v2.b;
					return 'in ' + str;
				}
			} else {
				return str;
			}
		};
		return maybeAffix(
			function () {
				switch (distanceId.$) {
					case 0:
						var i = distanceId.a;
						return (i === 1) ? 'less than 1 second' : ('less than ' + (toStr(i) + ' seconds'));
					case 1:
						return 'half a minute';
					case 2:
						var i = distanceId.a;
						return (i === 1) ? 'less than a minute' : ('less than ' + (toStr(i) + ' minutes'));
					case 3:
						var i = distanceId.a;
						return (i === 1) ? '1 minute' : (toStr(i) + ' minutes');
					case 4:
						var i = distanceId.a;
						return (i === 1) ? 'about 1 hour' : ('about ' + (toStr(i) + ' hours'));
					case 5:
						var i = distanceId.a;
						return (i === 1) ? '1 day' : (toStr(i) + ' days');
					case 6:
						var i = distanceId.a;
						return (i === 1) ? 'about 1 month' : ('about ' + (toStr(i) + ' months'));
					case 7:
						var i = distanceId.a;
						return (i === 1) ? '1 month' : (toStr(i) + ' months');
					case 8:
						var i = distanceId.a;
						return (i === 1) ? 'about 1 year' : ('about ' + (toStr(i) + ' years'));
					case 9:
						var i = distanceId.a;
						return (i === 1) ? 'over 1 year' : ('over ' + (toStr(i) + ' years'));
					default:
						var i = distanceId.a;
						return (i === 1) ? 'almost 1 year' : ('almost ' + (toStr(i) + ' years'));
				}
			}());
	});
var $gingko$time_distance$Time$Distance$Types$Future = 1;
var $gingko$time_distance$Time$Distance$Types$Past = 0;
var $gingko$time_distance$Time$Distance$Types$AboutXHours = function (a) {
	return {$: 4, a: a};
};
var $gingko$time_distance$Time$Distance$Types$LessThanXMinutes = function (a) {
	return {$: 2, a: a};
};
var $gingko$time_distance$Time$Distance$Types$XDays = function (a) {
	return {$: 5, a: a};
};
var $gingko$time_distance$Time$Distance$Types$XMinutes = function (a) {
	return {$: 3, a: a};
};
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $gingko$time_distance$Time$Distance$minutes_in_almost_two_days = 2520;
var $gingko$time_distance$Time$Distance$minutes_in_day = 1440;
var $gingko$time_distance$Time$Distance$minutes_in_month = 43200;
var $gingko$time_distance$Time$Distance$minutes_in_two_months = 86400;
var $gingko$time_distance$Time$Distance$Types$AboutXYears = function (a) {
	return {$: 8, a: a};
};
var $gingko$time_distance$Time$Distance$Types$AlmostXYears = function (a) {
	return {$: 10, a: a};
};
var $gingko$time_distance$Time$Distance$Types$OverXYears = function (a) {
	return {$: 9, a: a};
};
var $gingko$time_distance$Time$Distance$Types$XMonths = function (a) {
	return {$: 7, a: a};
};
var $elm$core$Basics$round = _Basics_round;
var $gingko$time_distance$Time$Distance$upToOneYear = function (minutes) {
	var nearestMonth = $elm$core$Basics$round(minutes / $gingko$time_distance$Time$Distance$minutes_in_month);
	return $gingko$time_distance$Time$Distance$Types$XMonths(nearestMonth);
};
var $gingko$time_distance$Time$Distance$moreThanTwoMonths = function (minutes) {
	var months = (minutes / $gingko$time_distance$Time$Distance$minutes_in_month) | 0;
	if (months < 12) {
		return $gingko$time_distance$Time$Distance$upToOneYear(minutes);
	} else {
		var years = $elm$core$Basics$floor(months / 12);
		var monthsSinceStartOfYear = A2($elm$core$Basics$modBy, 12, months);
		return (monthsSinceStartOfYear < 3) ? $gingko$time_distance$Time$Distance$Types$AboutXYears(years) : ((monthsSinceStartOfYear < 9) ? $gingko$time_distance$Time$Distance$Types$OverXYears(years) : $gingko$time_distance$Time$Distance$Types$AlmostXYears(years + 1));
	}
};
var $gingko$time_distance$Time$Distance$upToOneDay = function (minutes) {
	var hours = $elm$core$Basics$round(minutes / 60);
	return $gingko$time_distance$Time$Distance$Types$AboutXHours(hours);
};
var $gingko$time_distance$Time$Distance$Types$HalfAMinute = {$: 1};
var $gingko$time_distance$Time$Distance$Types$LessThanXSeconds = function (a) {
	return {$: 0, a: a};
};
var $gingko$time_distance$Time$Distance$upToOneMinute = function (seconds) {
	return (seconds < 5) ? $gingko$time_distance$Time$Distance$Types$LessThanXSeconds(5) : ((seconds < 10) ? $gingko$time_distance$Time$Distance$Types$LessThanXSeconds(10) : ((seconds < 20) ? $gingko$time_distance$Time$Distance$Types$LessThanXSeconds(20) : ((seconds < 40) ? $gingko$time_distance$Time$Distance$Types$HalfAMinute : ((seconds < 60) ? $gingko$time_distance$Time$Distance$Types$LessThanXMinutes(1) : $gingko$time_distance$Time$Distance$Types$XMinutes(1)))));
};
var $gingko$time_distance$Time$Distance$upToOneMonth = function (minutes) {
	var days = $elm$core$Basics$round(minutes / $gingko$time_distance$Time$Distance$minutes_in_day);
	return $gingko$time_distance$Time$Distance$Types$XDays(days);
};
var $gingko$time_distance$Time$Distance$Types$AboutXMonths = function (a) {
	return {$: 6, a: a};
};
var $gingko$time_distance$Time$Distance$upToTwoMonths = function (minutes) {
	var months = $elm$core$Basics$round(minutes / $gingko$time_distance$Time$Distance$minutes_in_month);
	return $gingko$time_distance$Time$Distance$Types$AboutXMonths(months);
};
var $gingko$time_distance$Time$Distance$calculateDistance = F3(
	function (includeSeconds, s1, s2) {
		var seconds = ($elm$core$Basics$abs(s2 - s1) / 1000) | 0;
		var minutes = $elm$core$Basics$round(seconds / 60);
		return (includeSeconds && (minutes < 2)) ? $gingko$time_distance$Time$Distance$upToOneMinute(seconds) : ((!minutes) ? $gingko$time_distance$Time$Distance$Types$LessThanXMinutes(1) : ((minutes < 2) ? $gingko$time_distance$Time$Distance$Types$XMinutes(minutes) : ((minutes < 45) ? $gingko$time_distance$Time$Distance$Types$XMinutes(minutes) : ((minutes < 90) ? $gingko$time_distance$Time$Distance$Types$AboutXHours(1) : ((_Utils_cmp(minutes, $gingko$time_distance$Time$Distance$minutes_in_day) < 0) ? $gingko$time_distance$Time$Distance$upToOneDay(minutes) : ((_Utils_cmp(minutes, $gingko$time_distance$Time$Distance$minutes_in_almost_two_days) < 0) ? $gingko$time_distance$Time$Distance$Types$XDays(1) : ((_Utils_cmp(minutes, $gingko$time_distance$Time$Distance$minutes_in_month) < 0) ? $gingko$time_distance$Time$Distance$upToOneMonth(minutes) : ((_Utils_cmp(minutes, $gingko$time_distance$Time$Distance$minutes_in_two_months) < 0) ? $gingko$time_distance$Time$Distance$upToTwoMonths(minutes) : $gingko$time_distance$Time$Distance$moreThanTwoMonths(minutes)))))))));
	});
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $gingko$time_distance$Time$Distance$inWordsWithConfig = F4(
	function (config, locale, otherTime, currentTime) {
		var otherSeconds = $elm$time$Time$posixToMillis(otherTime);
		var currentSeconds = $elm$time$Time$posixToMillis(currentTime);
		var distance = A3($gingko$time_distance$Time$Distance$calculateDistance, true, otherSeconds, currentSeconds);
		var tense = function () {
			var _v0 = A2($elm$core$Basics$compare, currentSeconds, otherSeconds);
			if (_v0 === 2) {
				return 0;
			} else {
				return 1;
			}
		}();
		return A3(locale, config, tense, distance);
	});
var $gingko$time_distance$Time$Distance$inWords = F2(
	function (otherTime, currentTime) {
		return A4(
			$gingko$time_distance$Time$Distance$inWordsWithConfig,
			{amu: true},
			$gingko$time_distance$Time$Distance$I18n$en,
			otherTime,
			currentTime);
	});
var $CoderDennis$elm_time_format$Time$Format$I18n$I_en_us$dayName = function (day) {
	switch (day) {
		case 0:
			return 'Monday';
		case 1:
			return 'Tuesday';
		case 2:
			return 'Wednesday';
		case 3:
			return 'Thursday';
		case 4:
			return 'Friday';
		case 5:
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $CoderDennis$elm_time_format$Time$Format$I18n$I_en_us$dayOfMonthWithSuffix = F2(
	function (pad, day) {
		var value = function () {
			switch (day) {
				case 1:
					return '1st';
				case 21:
					return '21st';
				case 2:
					return '2nd';
				case 22:
					return '22nd';
				case 3:
					return '3rd';
				case 23:
					return '23rd';
				case 31:
					return '31st';
				default:
					return $elm$core$String$fromInt(day) + 'th';
			}
		}();
		return pad ? A3($elm$core$String$padLeft, 4, ' ', value) : value;
	});
var $CoderDennis$elm_time_format$Time$Format$I18n$I_en_us$dayShort = function (day) {
	switch (day) {
		case 0:
			return 'Mon';
		case 1:
			return 'Tue';
		case 2:
			return 'Wed';
		case 3:
			return 'Thu';
		case 4:
			return 'Fri';
		case 5:
			return 'Sat';
		default:
			return 'Sun';
	}
};
var $CoderDennis$elm_time_format$Time$Format$I18n$I_en_us$monthName = function (month) {
	switch (month) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $CoderDennis$elm_time_format$Time$Format$I18n$I_en_us$monthShort = function (month) {
	switch (month) {
		case 0:
			return 'Jan';
		case 1:
			return 'Feb';
		case 2:
			return 'Mar';
		case 3:
			return 'Apr';
		case 4:
			return 'May';
		case 5:
			return 'Jun';
		case 6:
			return 'Jul';
		case 7:
			return 'Aug';
		case 8:
			return 'Sep';
		case 9:
			return 'Oct';
		case 10:
			return 'Nov';
		default:
			return 'Dec';
	}
};
var $CoderDennis$elm_time_format$Time$Format$I18n$I_default$twelveHourPeriod = function (period) {
	if (!period) {
		return 'AM';
	} else {
		return 'PM';
	}
};
var $CoderDennis$elm_time_format$Time$Format$Config$Config_en_us$config = {
	SG: {PB: '%-m/%-d/%Y', af8: '%-m/%-d/%Y %-I:%M %p', ahm: 6, aiu: '%A, %B %d, %Y', aiv: '%-I:%M:%S %p', al3: '%-I:%M %p'},
	b1: {PH: $CoderDennis$elm_time_format$Time$Format$I18n$I_en_us$dayName, PI: $CoderDennis$elm_time_format$Time$Format$I18n$I_en_us$dayOfMonthWithSuffix, PJ: $CoderDennis$elm_time_format$Time$Format$I18n$I_en_us$dayShort, Xp: $CoderDennis$elm_time_format$Time$Format$I18n$I_en_us$monthName, Xu: $CoderDennis$elm_time_format$Time$Format$I18n$I_en_us$monthShort, adH: $CoderDennis$elm_time_format$Time$Format$I18n$I_default$twelveHourPeriod}
};
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {sG: index, aiz: match, IO: number, alN: submatches};
	});
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{afu: false, aiR: false},
		string);
};
var $elm$regex$Regex$never = _Regex_never;
var $CoderDennis$elm_time_format$Time$Format$formatRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('%(y|Y|m|_m|-m|B|^B|b|^b|d|-d|-@d|e|@e|A|^A|a|^a|H|-H|k|I|-I|l|p|P|M|S|%|L)'));
var $CoderDennis$elm_time_format$Time$Format$collapse = function (m) {
	return A2($elm$core$Maybe$andThen, $elm$core$Basics$identity, m);
};
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $CoderDennis$elm_time_format$Time$Format$hourMod12 = function (h) {
	return (!A2($elm$core$Basics$modBy, 12, h)) ? 12 : A2($elm$core$Basics$modBy, 12, h);
};
var $CoderDennis$elm_time_format$Time$Format$Core$monthToInt = function (month) {
	switch (month) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $CoderDennis$elm_time_format$Time$Format$padWith = function (c) {
	return A2(
		$elm$core$Basics$composeL,
		A2($elm$core$String$padLeft, 2, c),
		$elm$core$String$fromInt);
};
var $CoderDennis$elm_time_format$Time$Format$padWithN = F2(
	function (n, c) {
		return A2(
			$elm$core$Basics$composeL,
			A2($elm$core$String$padLeft, n, c),
			$elm$core$String$fromInt);
	});
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.JV, posixMinutes) < 0) {
					return posixMinutes + era.g;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$core$Basics$ge = _Utils_ge;
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		af9: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		aiP: month,
		amw: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).af9;
	});
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $elm$time$Time$toMillis = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			1000,
			$elm$time$Time$posixToMillis(time));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).aiP;
		switch (_v0) {
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 3;
			case 5:
				return 4;
			case 6:
				return 5;
			case 7:
				return 6;
			case 8:
				return 7;
			case 9:
				return 8;
			case 10:
				return 9;
			case 11:
				return 10;
			default:
				return 11;
		}
	});
var $elm$time$Time$toSecond = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				1000));
	});
var $elm$time$Time$Tue = 1;
var $elm$time$Time$Wed = 2;
var $elm$time$Time$toWeekday = F2(
	function (zone, time) {
		var _v0 = A2(
			$elm$core$Basics$modBy,
			7,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60 * 24));
		switch (_v0) {
			case 0:
				return 3;
			case 1:
				return 4;
			case 2:
				return 5;
			case 3:
				return 6;
			case 4:
				return 0;
			case 5:
				return 1;
			default:
				return 2;
		}
	});
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).amw;
	});
var $CoderDennis$elm_time_format$Time$Format$TwelveHourClock$AM = 0;
var $CoderDennis$elm_time_format$Time$Format$TwelveHourClock$PM = 1;
var $CoderDennis$elm_time_format$Time$Format$TwelveHourClock$twelveHourPeriod = F2(
	function (z, d) {
		return (A2($elm$time$Time$toHour, z, d) < 12) ? 0 : 1;
	});
var $CoderDennis$elm_time_format$Time$Format$formatToken = F4(
	function (config, zone, d, m) {
		var symbol = A2(
			$elm$core$Maybe$withDefault,
			' ',
			$CoderDennis$elm_time_format$Time$Format$collapse(
				$elm$core$List$head(m.alN)));
		switch (symbol) {
			case 'Y':
				return A3(
					$CoderDennis$elm_time_format$Time$Format$padWithN,
					4,
					'0',
					A2($elm$time$Time$toYear, zone, d));
			case 'y':
				return A2(
					$elm$core$String$right,
					2,
					A3(
						$CoderDennis$elm_time_format$Time$Format$padWithN,
						2,
						'0',
						A2($elm$time$Time$toYear, zone, d)));
			case 'm':
				return A2(
					$CoderDennis$elm_time_format$Time$Format$padWith,
					'0',
					$CoderDennis$elm_time_format$Time$Format$Core$monthToInt(
						A2($elm$time$Time$toMonth, zone, d)));
			case '_m':
				return A2(
					$CoderDennis$elm_time_format$Time$Format$padWith,
					' ',
					$CoderDennis$elm_time_format$Time$Format$Core$monthToInt(
						A2($elm$time$Time$toMonth, zone, d)));
			case '-m':
				return $elm$core$String$fromInt(
					$CoderDennis$elm_time_format$Time$Format$Core$monthToInt(
						A2($elm$time$Time$toMonth, zone, d)));
			case 'B':
				return config.b1.Xp(
					A2($elm$time$Time$toMonth, zone, d));
			case '^B':
				return $elm$core$String$toUpper(
					config.b1.Xp(
						A2($elm$time$Time$toMonth, zone, d)));
			case 'b':
				return config.b1.Xu(
					A2($elm$time$Time$toMonth, zone, d));
			case '^b':
				return $elm$core$String$toUpper(
					config.b1.Xu(
						A2($elm$time$Time$toMonth, zone, d)));
			case 'd':
				return A2(
					$CoderDennis$elm_time_format$Time$Format$padWith,
					'0',
					A2($elm$time$Time$toDay, zone, d));
			case '-d':
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toDay, zone, d));
			case '-@d':
				return A2(
					config.b1.PI,
					false,
					A2($elm$time$Time$toDay, zone, d));
			case 'e':
				return A2(
					$CoderDennis$elm_time_format$Time$Format$padWith,
					' ',
					A2($elm$time$Time$toDay, zone, d));
			case '@e':
				return A2(
					config.b1.PI,
					true,
					A2($elm$time$Time$toDay, zone, d));
			case 'A':
				return config.b1.PH(
					A2($elm$time$Time$toWeekday, zone, d));
			case '^A':
				return $elm$core$String$toUpper(
					config.b1.PH(
						A2($elm$time$Time$toWeekday, zone, d)));
			case 'a':
				return config.b1.PJ(
					A2($elm$time$Time$toWeekday, zone, d));
			case '^a':
				return $elm$core$String$toUpper(
					config.b1.PJ(
						A2($elm$time$Time$toWeekday, zone, d)));
			case 'H':
				return A2(
					$CoderDennis$elm_time_format$Time$Format$padWith,
					'0',
					A2($elm$time$Time$toHour, zone, d));
			case '-H':
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toHour, zone, d));
			case 'k':
				return A2(
					$CoderDennis$elm_time_format$Time$Format$padWith,
					' ',
					A2($elm$time$Time$toHour, zone, d));
			case 'I':
				return A2(
					$CoderDennis$elm_time_format$Time$Format$padWith,
					'0',
					$CoderDennis$elm_time_format$Time$Format$hourMod12(
						A2($elm$time$Time$toHour, zone, d)));
			case '-I':
				return $elm$core$String$fromInt(
					$CoderDennis$elm_time_format$Time$Format$hourMod12(
						A2($elm$time$Time$toHour, zone, d)));
			case 'l':
				return A2(
					$CoderDennis$elm_time_format$Time$Format$padWith,
					' ',
					$CoderDennis$elm_time_format$Time$Format$hourMod12(
						A2($elm$time$Time$toHour, zone, d)));
			case 'p':
				return $elm$core$String$toUpper(
					config.b1.adH(
						A2($CoderDennis$elm_time_format$Time$Format$TwelveHourClock$twelveHourPeriod, zone, d)));
			case 'P':
				return config.b1.adH(
					A2($CoderDennis$elm_time_format$Time$Format$TwelveHourClock$twelveHourPeriod, zone, d));
			case 'M':
				return A2(
					$CoderDennis$elm_time_format$Time$Format$padWith,
					'0',
					A2($elm$time$Time$toMinute, zone, d));
			case 'S':
				return A2(
					$CoderDennis$elm_time_format$Time$Format$padWith,
					'0',
					A2($elm$time$Time$toSecond, zone, d));
			case 'L':
				return A3(
					$CoderDennis$elm_time_format$Time$Format$padWithN,
					3,
					'0',
					A2($elm$time$Time$toMillis, zone, d));
			case '%':
				return symbol;
			default:
				return '';
		}
	});
var $elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
var $CoderDennis$elm_time_format$Time$Format$format = F4(
	function (config, formatStr, zone, time) {
		return A3(
			$elm$regex$Regex$replace,
			$CoderDennis$elm_time_format$Time$Format$formatRegex,
			A3($CoderDennis$elm_time_format$Time$Format$formatToken, config, zone, time),
			formatStr);
	});
var $author$project$Formatters$Time$toTimeStamp = F3(
	function (zone, expression, time) {
		return A4($CoderDennis$elm_time_format$Time$Format$format, $CoderDennis$elm_time_format$Time$Format$Config$Config_en_us$config, expression, zone, time);
	});
var $author$project$Formatters$Time$toString = F4(
	function (zone, now, format, time) {
		switch (format) {
			case 0:
				return A3($author$project$Formatters$Time$toTimeStamp, zone, '%m/%d/%Y at %l:%M %p', time);
			case 1:
				return A2($gingko$time_distance$Time$Distance$inWords, time, now);
			case 2:
				return A3($author$project$Formatters$Time$toTimeStamp, zone, '%B %d, %Y at %l:%M %p', time);
			case 3:
				return A3($author$project$Formatters$Time$toTimeStamp, zone, '%l:%M %p', time);
			case 4:
				return A3($author$project$Formatters$Time$toTimeStamp, zone, '%m/%d/%Y %l:%M %p', time);
			case 5:
				return A3($author$project$Formatters$Time$toTimeStamp, zone, '%m/%d/%Y', time);
			default:
				return A3($author$project$Formatters$Time$toTimeStamp, zone, '%B %d, %Y', time);
		}
	});
var $author$project$Formatters$Time$init = F2(
	function (zone, now) {
		return A2($author$project$Formatters$Time$toString, zone, now);
	});
var $author$project$Ui$Toast$Toastr = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Ui$Toast$init = A2($author$project$Ui$Toast$Toastr, 1, _List_Nil);
var $author$project$Utils$Release$Model = $elm$core$Basics$identity;
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $author$project$Utils$Release$FetchLiveRelease = {$: 1};
var $elm$core$Process$sleep = _Process_sleep;
var $author$project$Utils$Release$scheduleNextReleaseCheck = A2(
	$elm$core$Task$attempt,
	function (_v0) {
		return $author$project$Utils$Release$FetchLiveRelease;
	},
	$elm$core$Process$sleep(10 * 1000));
var $author$project$Utils$Release$init = function (release) {
	return _Utils_Tuple2(
		{
			Hb: A2($elm$core$Maybe$withDefault, '', release),
			Br: false
		},
		A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Platform$Cmd$none,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$always($author$project$Utils$Release$scheduleNextReleaseCheck),
				release)));
};
var $author$project$Shared$GotSession = function (a) {
	return {$: 0, a: a};
};
var $author$project$Shared$GotUser = function (a) {
	return {$: 4, a: a};
};
var $elm$json$Json$Encode$bool = _Json_wrap;
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $author$project$Ports$Session$sessionAuthorizePort = _Platform_outgoingPort(
	'sessionAuthorizePort',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'redirect',
					$elm$json$Json$Encode$bool($.aku))
				]));
	});
var $author$project$Ports$Session$authorize = function (options) {
	return $author$project$Ports$Session$sessionAuthorizePort(options);
};
var $author$project$Shared$BackupJwtRefreshWindowFinished = {$: 27};
var $author$project$Api$Data$clientAuthToken = function (_v0) {
	var client = _v0;
	return client.fK;
};
var $simonh1000$elm_jwt$Jwt$TokenDecodeError = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Result$andThen = F2(
	function (callback, result) {
		if (!result.$) {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return $elm$core$Result$Err(msg);
		}
	});
var $simonh1000$elm_jwt$Jwt$TokenHeaderError = {$: 2};
var $simonh1000$elm_jwt$Jwt$TokenProcessingError = function (a) {
	return {$: 0, a: a};
};
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $simonh1000$elm_jwt$Jwt$fixlength = function (s) {
	var _v0 = A2(
		$elm$core$Basics$modBy,
		4,
		$elm$core$String$length(s));
	switch (_v0) {
		case 0:
			return $elm$core$Result$Ok(s);
		case 2:
			return $elm$core$Result$Ok(
				$elm$core$String$concat(
					_List_fromArray(
						[s, '=='])));
		case 3:
			return $elm$core$Result$Ok(
				$elm$core$String$concat(
					_List_fromArray(
						[s, '='])));
		default:
			return $elm$core$Result$Err(
				$simonh1000$elm_jwt$Jwt$TokenProcessingError('Wrong length'));
	}
};
var $elm$core$Result$fromMaybe = F2(
	function (err, maybe) {
		if (!maybe.$) {
			var v = maybe.a;
			return $elm$core$Result$Ok(v);
		} else {
			return $elm$core$Result$Err(err);
		}
	});
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $elm$core$Result$map2 = F3(
	function (func, ra, rb) {
		if (ra.$ === 1) {
			var x = ra.a;
			return $elm$core$Result$Err(x);
		} else {
			var a = ra.a;
			if (rb.$ === 1) {
				var x = rb.a;
				return $elm$core$Result$Err(x);
			} else {
				var b = rb.a;
				return $elm$core$Result$Ok(
					A2(func, a, b));
			}
		}
	});
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$bytes$Bytes$Encode$getWidth = function (builder) {
	switch (builder.$) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 4;
		case 3:
			return 1;
		case 4:
			return 2;
		case 5:
			return 4;
		case 6:
			return 4;
		case 7:
			return 8;
		case 8:
			var w = builder.a;
			return w;
		case 9:
			var w = builder.a;
			return w;
		default:
			var bs = builder.a;
			return _Bytes_width(bs);
	}
};
var $elm$bytes$Bytes$LE = 0;
var $elm$bytes$Bytes$Encode$write = F3(
	function (builder, mb, offset) {
		switch (builder.$) {
			case 0:
				var n = builder.a;
				return A3(_Bytes_write_i8, mb, offset, n);
			case 1:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_i16, mb, offset, n, !e);
			case 2:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_i32, mb, offset, n, !e);
			case 3:
				var n = builder.a;
				return A3(_Bytes_write_u8, mb, offset, n);
			case 4:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_u16, mb, offset, n, !e);
			case 5:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_u32, mb, offset, n, !e);
			case 6:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_f32, mb, offset, n, !e);
			case 7:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_f64, mb, offset, n, !e);
			case 8:
				var bs = builder.b;
				return A3($elm$bytes$Bytes$Encode$writeSequence, bs, mb, offset);
			case 9:
				var s = builder.b;
				return A3(_Bytes_write_string, mb, offset, s);
			default:
				var bs = builder.a;
				return A3(_Bytes_write_bytes, mb, offset, bs);
		}
	});
var $elm$bytes$Bytes$Encode$writeSequence = F3(
	function (builders, mb, offset) {
		writeSequence:
		while (true) {
			if (!builders.b) {
				return offset;
			} else {
				var b = builders.a;
				var bs = builders.b;
				var $temp$builders = bs,
					$temp$mb = mb,
					$temp$offset = A3($elm$bytes$Bytes$Encode$write, b, mb, offset);
				builders = $temp$builders;
				mb = $temp$mb;
				offset = $temp$offset;
				continue writeSequence;
			}
		}
	});
var $elm$bytes$Bytes$Decode$decode = F2(
	function (_v0, bs) {
		var decoder = _v0;
		return A2(_Bytes_decode, decoder, bs);
	});
var $elm$bytes$Bytes$Decode$Decoder = $elm$core$Basics$identity;
var $elm$bytes$Bytes$Decode$string = function (n) {
	return _Bytes_read_string(n);
};
var $elm$bytes$Bytes$Encode$encode = _Bytes_encode;
var $elm$bytes$Bytes$BE = 1;
var $danfishgold$base64_bytes$Encode$isValidChar = function (c) {
	if ($elm$core$Char$isAlphaNum(c)) {
		return true;
	} else {
		switch (c) {
			case '+':
				return true;
			case '/':
				return true;
			default:
				return false;
		}
	}
};
var $elm$core$Bitwise$or = _Bitwise_or;
var $elm$bytes$Bytes$Encode$Seq = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $elm$bytes$Bytes$Encode$getWidths = F2(
	function (width, builders) {
		getWidths:
		while (true) {
			if (!builders.b) {
				return width;
			} else {
				var b = builders.a;
				var bs = builders.b;
				var $temp$width = width + $elm$bytes$Bytes$Encode$getWidth(b),
					$temp$builders = bs;
				width = $temp$width;
				builders = $temp$builders;
				continue getWidths;
			}
		}
	});
var $elm$bytes$Bytes$Encode$sequence = function (builders) {
	return A2(
		$elm$bytes$Bytes$Encode$Seq,
		A2($elm$bytes$Bytes$Encode$getWidths, 0, builders),
		builders);
};
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $danfishgold$base64_bytes$Encode$unsafeConvertChar = function (_char) {
	var key = $elm$core$Char$toCode(_char);
	if ((key >= 65) && (key <= 90)) {
		return key - 65;
	} else {
		if ((key >= 97) && (key <= 122)) {
			return (key - 97) + 26;
		} else {
			if ((key >= 48) && (key <= 57)) {
				return ((key - 48) + 26) + 26;
			} else {
				switch (_char) {
					case '+':
						return 62;
					case '/':
						return 63;
					default:
						return -1;
				}
			}
		}
	}
};
var $elm$bytes$Bytes$Encode$U16 = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$bytes$Bytes$Encode$unsignedInt16 = $elm$bytes$Bytes$Encode$U16;
var $elm$bytes$Bytes$Encode$U8 = function (a) {
	return {$: 3, a: a};
};
var $elm$bytes$Bytes$Encode$unsignedInt8 = $elm$bytes$Bytes$Encode$U8;
var $danfishgold$base64_bytes$Encode$encodeCharacters = F4(
	function (a, b, c, d) {
		if ($danfishgold$base64_bytes$Encode$isValidChar(a) && $danfishgold$base64_bytes$Encode$isValidChar(b)) {
			var n2 = $danfishgold$base64_bytes$Encode$unsafeConvertChar(b);
			var n1 = $danfishgold$base64_bytes$Encode$unsafeConvertChar(a);
			if ('=' === d) {
				if ('=' === c) {
					var n = (n1 << 18) | (n2 << 12);
					var b1 = n >> 16;
					return $elm$core$Maybe$Just(
						$elm$bytes$Bytes$Encode$unsignedInt8(b1));
				} else {
					if ($danfishgold$base64_bytes$Encode$isValidChar(c)) {
						var n3 = $danfishgold$base64_bytes$Encode$unsafeConvertChar(c);
						var n = ((n1 << 18) | (n2 << 12)) | (n3 << 6);
						var combined = n >> 8;
						return $elm$core$Maybe$Just(
							A2($elm$bytes$Bytes$Encode$unsignedInt16, 1, combined));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}
			} else {
				if ($danfishgold$base64_bytes$Encode$isValidChar(c) && $danfishgold$base64_bytes$Encode$isValidChar(d)) {
					var n4 = $danfishgold$base64_bytes$Encode$unsafeConvertChar(d);
					var n3 = $danfishgold$base64_bytes$Encode$unsafeConvertChar(c);
					var n = ((n1 << 18) | (n2 << 12)) | ((n3 << 6) | n4);
					var combined = n >> 8;
					var b3 = n;
					return $elm$core$Maybe$Just(
						$elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									A2($elm$bytes$Bytes$Encode$unsignedInt16, 1, combined),
									$elm$bytes$Bytes$Encode$unsignedInt8(b3)
								])));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $danfishgold$base64_bytes$Encode$encodeChunks = F2(
	function (input, accum) {
		encodeChunks:
		while (true) {
			var _v0 = $elm$core$String$toList(
				A2($elm$core$String$left, 4, input));
			_v0$4:
			while (true) {
				if (!_v0.b) {
					return $elm$core$Maybe$Just(accum);
				} else {
					if (_v0.b.b) {
						if (_v0.b.b.b) {
							if (_v0.b.b.b.b) {
								if (!_v0.b.b.b.b.b) {
									var a = _v0.a;
									var _v1 = _v0.b;
									var b = _v1.a;
									var _v2 = _v1.b;
									var c = _v2.a;
									var _v3 = _v2.b;
									var d = _v3.a;
									var _v4 = A4($danfishgold$base64_bytes$Encode$encodeCharacters, a, b, c, d);
									if (!_v4.$) {
										var enc = _v4.a;
										var $temp$input = A2($elm$core$String$dropLeft, 4, input),
											$temp$accum = A2($elm$core$List$cons, enc, accum);
										input = $temp$input;
										accum = $temp$accum;
										continue encodeChunks;
									} else {
										return $elm$core$Maybe$Nothing;
									}
								} else {
									break _v0$4;
								}
							} else {
								var a = _v0.a;
								var _v5 = _v0.b;
								var b = _v5.a;
								var _v6 = _v5.b;
								var c = _v6.a;
								var _v7 = A4($danfishgold$base64_bytes$Encode$encodeCharacters, a, b, c, '=');
								if (_v7.$ === 1) {
									return $elm$core$Maybe$Nothing;
								} else {
									var enc = _v7.a;
									return $elm$core$Maybe$Just(
										A2($elm$core$List$cons, enc, accum));
								}
							}
						} else {
							var a = _v0.a;
							var _v8 = _v0.b;
							var b = _v8.a;
							var _v9 = A4($danfishgold$base64_bytes$Encode$encodeCharacters, a, b, '=', '=');
							if (_v9.$ === 1) {
								return $elm$core$Maybe$Nothing;
							} else {
								var enc = _v9.a;
								return $elm$core$Maybe$Just(
									A2($elm$core$List$cons, enc, accum));
							}
						}
					} else {
						break _v0$4;
					}
				}
			}
			return $elm$core$Maybe$Nothing;
		}
	});
var $danfishgold$base64_bytes$Encode$encoder = function (string) {
	return A2(
		$elm$core$Maybe$map,
		A2($elm$core$Basics$composeR, $elm$core$List$reverse, $elm$bytes$Bytes$Encode$sequence),
		A2($danfishgold$base64_bytes$Encode$encodeChunks, string, _List_Nil));
};
var $danfishgold$base64_bytes$Encode$toBytes = function (string) {
	return A2(
		$elm$core$Maybe$map,
		$elm$bytes$Bytes$Encode$encode,
		$danfishgold$base64_bytes$Encode$encoder(string));
};
var $danfishgold$base64_bytes$Base64$toBytes = $danfishgold$base64_bytes$Encode$toBytes;
var $elm$bytes$Bytes$width = _Bytes_width;
var $danfishgold$base64_bytes$Base64$toString = function (b64String) {
	var _v0 = $danfishgold$base64_bytes$Base64$toBytes(b64String);
	if (_v0.$ === 1) {
		return $elm$core$Maybe$Nothing;
	} else {
		var b64Bytes = _v0.a;
		return A2(
			$elm$bytes$Bytes$Decode$decode,
			$elm$bytes$Bytes$Decode$string(
				$elm$bytes$Bytes$width(b64Bytes)),
			b64Bytes);
	}
};
var $elm$core$String$map = _String_map;
var $simonh1000$elm_jwt$Jwt$unurl = function () {
	var fix = function (c) {
		switch (c) {
			case '-':
				return '+';
			case '_':
				return '/';
			default:
				return c;
		}
	};
	return $elm$core$String$map(fix);
}();
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $simonh1000$elm_jwt$Jwt$getTokenParts = function (token) {
	var verifyJson = F2(
		function (errorHandler, str) {
			return A2(
				$elm$core$Result$mapError,
				errorHandler,
				A2(
					$elm$core$Result$map,
					function (_v8) {
						return str;
					},
					A2($elm$json$Json$Decode$decodeString, $elm$json$Json$Decode$value, str)));
		});
	var processor = A2(
		$elm$core$Basics$composeR,
		$simonh1000$elm_jwt$Jwt$unurl,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$String$split('.'),
			$elm$core$List$map($simonh1000$elm_jwt$Jwt$fixlength)));
	var _v0 = processor(token);
	_v0$1:
	while (true) {
		if (((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.b.b)) {
			if (!_v0.a.$) {
				if (!_v0.b.a.$) {
					var header = _v0.a.a;
					var _v1 = _v0.b;
					var body = _v1.a.a;
					var _v2 = _v1.b;
					var header_ = A2(
						$elm$core$Result$andThen,
						verifyJson(
							function (_v3) {
								return $simonh1000$elm_jwt$Jwt$TokenHeaderError;
							}),
						A2(
							$elm$core$Result$fromMaybe,
							$simonh1000$elm_jwt$Jwt$TokenHeaderError,
							$danfishgold$base64_bytes$Base64$toString(header)));
					var body_ = A2(
						$elm$core$Result$andThen,
						verifyJson($simonh1000$elm_jwt$Jwt$TokenDecodeError),
						A2(
							$elm$core$Result$fromMaybe,
							$simonh1000$elm_jwt$Jwt$TokenProcessingError('Invalid UTF-16'),
							$danfishgold$base64_bytes$Base64$toString(body)));
					return A3(
						$elm$core$Result$map2,
						F2(
							function (a, b) {
								return _Utils_Tuple2(a, b);
							}),
						header_,
						body_);
				} else {
					break _v0$1;
				}
			} else {
				if (_v0.b.a.$ === 1) {
					break _v0$1;
				} else {
					var err = _v0.a.a;
					var _v6 = _v0.b;
					var _v7 = _v6.b;
					return $elm$core$Result$Err(err);
				}
			}
		} else {
			return $elm$core$Result$Err(
				$simonh1000$elm_jwt$Jwt$TokenProcessingError('Token has invalid shape'));
		}
	}
	var _v4 = _v0.b;
	var err = _v4.a.a;
	var _v5 = _v4.b;
	return $elm$core$Result$Err(err);
};
var $simonh1000$elm_jwt$Jwt$decodeToken = F2(
	function (dec, token) {
		return A2(
			$elm$core$Result$andThen,
			A2(
				$elm$core$Basics$composeR,
				$elm$json$Json$Decode$decodeString(dec),
				$elm$core$Result$mapError($simonh1000$elm_jwt$Jwt$TokenDecodeError)),
			A2(
				$elm$core$Result$map,
				$elm$core$Tuple$second,
				$simonh1000$elm_jwt$Jwt$getTokenParts(token)));
	});
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $simonh1000$elm_jwt$Jwt$getTokenExpirationMillis = function (token) {
	var decodeExp = $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$int,
				A2($elm$json$Json$Decode$map, $elm$core$Basics$round, $elm$json$Json$Decode$float)
			]));
	return A2(
		$elm$core$Result$map,
		function (exp) {
			return 1000 * exp;
		},
		A2(
			$simonh1000$elm_jwt$Jwt$decodeToken,
			A2($elm$json$Json$Decode$field, 'exp', decodeExp),
			token));
};
var $author$project$Api$AuthToken$expiresAt = function (authToken) {
	return A2(
		$elm$core$Maybe$andThen,
		$elm$core$Result$toMaybe,
		A2(
			$elm$core$Maybe$map,
			$simonh1000$elm_jwt$Jwt$getTokenExpirationMillis,
			A2($elm$core$Maybe$andThen, $author$project$Api$AuthToken$toString, authToken)));
};
var $author$project$Api$AuthToken$issuedAt = function (authToken) {
	return A2(
		$elm$core$Maybe$andThen,
		$elm$core$Result$toMaybe,
		A2(
			$elm$core$Maybe$map,
			function (token) {
				var decodeExp = $elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							$elm$json$Json$Decode$int,
							A2($elm$json$Json$Decode$map, $elm$core$Basics$round, $elm$json$Json$Decode$float)
						]));
				return A2(
					$elm$core$Result$map,
					function (iat) {
						return 1000 * iat;
					},
					A2(
						$simonh1000$elm_jwt$Jwt$decodeToken,
						A2($elm$json$Json$Decode$field, 'iat', decodeExp),
						token));
			},
			A2($elm$core$Maybe$andThen, $author$project$Api$AuthToken$toString, authToken)));
};
var $author$project$Shared$GotNewBackupJwt = function (a) {
	return {$: 26, a: a};
};
var $author$project$Api$Data$platformPath = $author$project$Api$Data$newPath(_List_Nil);
var $author$project$Api$Auth$authPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['auth']),
	$author$project$Api$Data$platformPath);
var $author$project$Api$AuthToken$decode = function (authToken) {
	return $elm$json$Json$Decode$succeed(authToken);
};
var $author$project$Api$Auth$authTokenDecoder = A2(
	$elm$json$Json$Decode$andThen,
	$author$project$Api$AuthToken$decode,
	A2($elm$json$Json$Decode$field, 'token', $elm$json$Json$Decode$string));
var $author$project$Api$Data$post = $author$project$Api$Data$makeRequest('post');
var $author$project$Api$Auth$refreshToken = F2(
	function (client, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			client,
			$author$project$Api$Auth$authTokenDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['refresh']),
					$author$project$Api$Auth$authPath)));
	});
var $author$project$Shared$refreshToken = function (apiClient) {
	return A2($author$project$Api$Auth$refreshToken, apiClient, $author$project$Shared$GotNewBackupJwt);
};
var $author$project$Shared$backupJwtRefreshTimeout = function (apiClient) {
	var refreshWindowStart = $author$project$Api$AuthToken$issuedAt(
		$author$project$Api$Data$clientAuthToken(apiClient));
	var expiresAt = $author$project$Api$AuthToken$expiresAt(
		$author$project$Api$Data$clientAuthToken(apiClient));
	var _v0 = _Utils_Tuple2(refreshWindowStart, expiresAt);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var refreshStart = _v0.a.a;
		var expiresAt_ = _v0.b.a;
		var fiveMinMs = (5 * 60) * 1000;
		return (_Utils_cmp(expiresAt_ - refreshStart, fiveMinMs) > 0) ? A2(
			$elm$core$Task$perform,
			function (_v1) {
				return $author$project$Shared$BackupJwtRefreshWindowFinished;
			},
			$elm$core$Process$sleep((expiresAt_ - refreshStart) - fiveMinMs)) : $author$project$Shared$refreshToken(apiClient);
	} else {
		return $elm$core$Platform$Cmd$none;
	}
};
var $simonh1000$elm_jwt$Jwt$isExpired = F2(
	function (now, token) {
		return A2(
			$elm$core$Result$map,
			function (millis) {
				return _Utils_cmp(
					$elm$time$Time$posixToMillis(now),
					millis) > 0;
			},
			$simonh1000$elm_jwt$Jwt$getTokenExpirationMillis(token));
	});
var $author$project$Api$AuthToken$isExpired = F2(
	function (authToken, now) {
		return A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$Result$toMaybe,
				A2(
					$elm$core$Maybe$map,
					$simonh1000$elm_jwt$Jwt$isExpired(now),
					A2($elm$core$Maybe$andThen, $author$project$Api$AuthToken$toString, authToken))));
	});
var $author$project$Api$Data$clientHasTokenExpired = F2(
	function (_v0, now) {
		var client = _v0;
		return A2($author$project$Api$AuthToken$isExpired, client.fK, now);
	});
var $elm$core$Basics$not = _Basics_not;
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Ports$Navigation$pushUrl = _Platform_outgoingPort('pushUrl', $elm$json$Json$Encode$string);
var $elm$core$String$append = _String_append;
var $author$project$Spa$Generated$Route$toString = function (route) {
	var segments = function () {
		switch (route.$) {
			case 0:
				return _List_Nil;
			case 1:
				return _List_fromArray(
					['blank']);
			case 2:
				return _List_fromArray(
					['bookkeeping']);
			case 3:
				return _List_fromArray(
					['calendar']);
			case 4:
				return _List_fromArray(
					['forms']);
			case 5:
				return _List_fromArray(
					['google_callback']);
			case 6:
				return _List_fromArray(
					['home']);
			case 7:
				return _List_fromArray(
					['login']);
			case 8:
				return _List_fromArray(
					['logout']);
			case 9:
				return _List_fromArray(
					['not_found']);
			case 10:
				return _List_fromArray(
					['onboarding']);
			case 11:
				return _List_fromArray(
					['refill_requests']);
			case 12:
				return _List_fromArray(
					['affiliate_bills']);
			case 13:
				return _List_fromArray(
					['affiliates']);
			case 14:
				return _List_fromArray(
					['companies']);
			case 15:
				return _List_fromArray(
					['files']);
			case 16:
				return _List_fromArray(
					['marketplace']);
			case 17:
				return _List_fromArray(
					['patients']);
			case 18:
				return _List_fromArray(
					['practice_setup']);
			case 19:
				return _List_fromArray(
					['style_guide']);
			case 20:
				return _List_fromArray(
					['tasks']);
			case 21:
				return _List_fromArray(
					['account', 'complete']);
			case 22:
				return _List_fromArray(
					['admin', 'advance_billing']);
			case 23:
				return _List_fromArray(
					['admin', 'billing']);
			case 24:
				return _List_fromArray(
					['admin', 'cancellation_reasons']);
			case 25:
				return _List_fromArray(
					['admin', 'card_readers']);
			case 26:
				return _List_fromArray(
					['admin', 'categories']);
			case 27:
				return _List_fromArray(
					['admin', 'commissions']);
			case 28:
				return _List_fromArray(
					['admin', 'coupons']);
			case 29:
				return _List_fromArray(
					['admin', 'credit_categories']);
			case 30:
				return _List_fromArray(
					['admin', 'elation_legacy']);
			case 31:
				return _List_fromArray(
					['admin', 'features']);
			case 32:
				return _List_fromArray(
					['admin', 'hipaa_authorizations']);
			case 33:
				return _List_fromArray(
					['admin', 'internal_settings']);
			case 34:
				return _List_fromArray(
					['admin', 'invoice_settings']);
			case 35:
				return _List_fromArray(
					['admin', 'lead_sources']);
			case 36:
				return _List_fromArray(
					['admin', 'locations']);
			case 37:
				return _List_fromArray(
					['admin', 'mailgun']);
			case 38:
				return _List_fromArray(
					['admin', 'notes']);
			case 39:
				return _List_fromArray(
					['admin', 'patients']);
			case 40:
				return _List_fromArray(
					['admin', 'payment_method_import']);
			case 41:
				return _List_fromArray(
					['admin', 'payment_processing']);
			case 42:
				return _List_fromArray(
					['admin', 'payment_sources']);
			case 43:
				return _List_fromArray(
					['admin', 'practice']);
			case 44:
				return _List_fromArray(
					['admin', 'provider_groups']);
			case 45:
				return _List_fromArray(
					['admin', 'scheduled_jobs']);
			case 46:
				return _List_fromArray(
					['admin', 'self_service']);
			case 47:
				return _List_fromArray(
					['admin', 'signup']);
			case 48:
				return _List_fromArray(
					['admin', 'stripe']);
			case 49:
				return _List_fromArray(
					['admin', 'taxes']);
			case 50:
				return _List_fromArray(
					['admin', 'team']);
			case 51:
				return _List_fromArray(
					['admin', 'waitlist']);
			case 52:
				return _List_fromArray(
					['affiliates', 'create']);
			case 53:
				return _List_fromArray(
					['affiliates', 'new']);
			case 54:
				return _List_fromArray(
					['charges', 'new']);
			case 55:
				return _List_fromArray(
					['commissions', 'statements']);
			case 56:
				return _List_fromArray(
					['companies', 'new']);
			case 57:
				return _List_fromArray(
					['contacts', 'list']);
			case 58:
				return _List_fromArray(
					['contacts', 'new']);
			case 59:
				return _List_fromArray(
					['files', 'public']);
			case 60:
				return _List_fromArray(
					['hinter', 'clone_practice']);
			case 61:
				return _List_fromArray(
					['hinter', 'disputes']);
			case 62:
				return _List_fromArray(
					['hinter', 'feature_flags']);
			case 63:
				return _List_fromArray(
					['hinter', 'new_group']);
			case 64:
				return _List_fromArray(
					['hinter', 'new_partner']);
			case 65:
				return _List_fromArray(
					['hinter', 'new_practice']);
			case 66:
				return _List_fromArray(
					['inventory', 'list']);
			case 67:
				return _List_fromArray(
					['inventory', 'new']);
			case 68:
				return _List_fromArray(
					['inventory', 'settings']);
			case 69:
				return _List_fromArray(
					['marketplace', 'manage']);
			case 70:
				return _List_fromArray(
					['messages', 'calls']);
			case 71:
				return _List_fromArray(
					['messages', 'chat']);
			case 72:
				return _List_fromArray(
					['messages', 'drafts']);
			case 73:
				return _List_fromArray(
					['messages', 'forms']);
			case 74:
				return _List_fromArray(
					['messages', 'inbox']);
			case 75:
				return _List_fromArray(
					['messages', 'labs']);
			case 76:
				return _List_fromArray(
					['messages', 'legacy_calls']);
			case 77:
				return _List_fromArray(
					['messages', 'sms']);
			case 78:
				return _List_fromArray(
					['new_settings', 'blocked_phone_numbers']);
			case 79:
				return _List_fromArray(
					['new_settings', 'booking_overview']);
			case 80:
				return _List_fromArray(
					['new_settings', 'erx']);
			case 81:
				return _List_fromArray(
					['new_settings', 'export']);
			case 82:
				return _List_fromArray(
					['new_settings', 'hinter_settings']);
			case 83:
				return _List_fromArray(
					['new_settings', 'practice_info']);
			case 84:
				return _List_fromArray(
					['new_settings', 'team']);
			case 85:
				return _List_fromArray(
					['oauth', 'callback']);
			case 86:
				return _List_fromArray(
					['partner', 'api_keys']);
			case 87:
				return _List_fromArray(
					['partner', 'billing']);
			case 88:
				return _List_fromArray(
					['partner', 'engagements']);
			case 89:
				return _List_fromArray(
					['partner', 'hinter']);
			case 90:
				return _List_fromArray(
					['partner', 'team']);
			case 91:
				return _List_fromArray(
					['patients', 'create']);
			case 92:
				return _List_fromArray(
					['patients', 'upload']);
			case 93:
				return _List_fromArray(
					['practice_setup', 'account']);
			case 94:
				return _List_fromArray(
					['practice_setup', 'communications']);
			case 95:
				return _List_fromArray(
					['practice_setup', 'complete']);
			case 96:
				return _List_fromArray(
					['practice_setup', 'documents']);
			case 97:
				return _List_fromArray(
					['practice_setup', 'legal']);
			case 98:
				return _List_fromArray(
					['practice_setup', 'payment_processing']);
			case 99:
				return _List_fromArray(
					['practice_setup', 'plans']);
			case 100:
				return _List_fromArray(
					['practice_setup', 'team']);
			case 101:
				return _List_fromArray(
					['reports', 'company_invoices']);
			case 102:
				return _List_fromArray(
					['reports', 'credit_outstanding']);
			case 103:
				return _List_fromArray(
					['reports', 'credit_transactions']);
			case 104:
				return _List_fromArray(
					['reports', 'dashboard']);
			case 105:
				return _List_fromArray(
					['reports', 'deferred_revenue']);
			case 106:
				return _List_fromArray(
					['reports', 'deposits']);
			case 107:
				return _List_fromArray(
					['reports', 'disputes']);
			case 108:
				return _List_fromArray(
					['reports', 'invoices']);
			case 109:
				return _List_fromArray(
					['reports', 'memberships']);
			case 110:
				return _List_fromArray(
					['reports', 'months']);
			case 111:
				return _List_fromArray(
					['reports', 'patient_packages']);
			case 112:
				return _List_fromArray(
					['reports', 'payment_applications']);
			case 113:
				return _List_fromArray(
					['reports', 'revenue']);
			case 114:
				return _List_fromArray(
					['reports', 'sales_tax']);
			case 115:
				return _List_fromArray(
					['reports', 'signup_attempts']);
			case 116:
				return _List_fromArray(
					['style_guide', 'activity_indicators']);
			case 117:
				return _List_fromArray(
					['style_guide', 'address_input']);
			case 118:
				return _List_fromArray(
					['style_guide', 'alert']);
			case 119:
				return _List_fromArray(
					['style_guide', 'badge']);
			case 120:
				return _List_fromArray(
					['style_guide', 'button']);
			case 121:
				return _List_fromArray(
					['style_guide', 'carousel']);
			case 122:
				return _List_fromArray(
					['style_guide', 'checkbox']);
			case 123:
				return _List_fromArray(
					['style_guide', 'currency_input']);
			case 124:
				return _List_fromArray(
					['style_guide', 'date_input']);
			case 125:
				return _List_fromArray(
					['style_guide', 'date_range_input']);
			case 126:
				return _List_fromArray(
					['style_guide', 'drag_drop']);
			case 127:
				return _List_fromArray(
					['style_guide', 'dropdown']);
			case 128:
				return _List_fromArray(
					['style_guide', 'element']);
			case 129:
				return _List_fromArray(
					['style_guide', 'export_csv']);
			case 130:
				return _List_fromArray(
					['style_guide', 'file_input']);
			case 131:
				return _List_fromArray(
					['style_guide', 'flyout_menu']);
			case 132:
				return _List_fromArray(
					['style_guide', 'form_example']);
			case 133:
				return _List_fromArray(
					['style_guide', 'form_group']);
			case 134:
				return _List_fromArray(
					['style_guide', 'form_static']);
			case 135:
				return _List_fromArray(
					['style_guide', 'grid']);
			case 136:
				return _List_fromArray(
					['style_guide', 'hi_confirm']);
			case 137:
				return _List_fromArray(
					['style_guide', 'horizontal_rule']);
			case 138:
				return _List_fromArray(
					['style_guide', 'icon']);
			case 139:
				return _List_fromArray(
					['style_guide', 'input']);
			case 140:
				return _List_fromArray(
					['style_guide', 'link']);
			case 141:
				return _List_fromArray(
					['style_guide', 'list_group']);
			case 142:
				return _List_fromArray(
					['style_guide', 'modal']);
			case 143:
				return _List_fromArray(
					['style_guide', 'ordered_list']);
			case 144:
				return _List_fromArray(
					['style_guide', 'pagination']);
			case 145:
				return _List_fromArray(
					['style_guide', 'panel']);
			case 146:
				return _List_fromArray(
					['style_guide', 'password_input']);
			case 147:
				return _List_fromArray(
					['style_guide', 'payment_source_displayer']);
			case 148:
				return _List_fromArray(
					['style_guide', 'phone_input']);
			case 149:
				return _List_fromArray(
					['style_guide', 'popover']);
			case 150:
				return _List_fromArray(
					['style_guide', 'pre']);
			case 151:
				return _List_fromArray(
					['style_guide', 'progress_bar']);
			case 152:
				return _List_fromArray(
					['style_guide', 'radio']);
			case 153:
				return _List_fromArray(
					['style_guide', 'resource_filter']);
			case 154:
				return _List_fromArray(
					['style_guide', 'search_input']);
			case 155:
				return _List_fromArray(
					['style_guide', 'select']);
			case 156:
				return _List_fromArray(
					['style_guide', 'skeleton']);
			case 157:
				return _List_fromArray(
					['style_guide', 'spinner']);
			case 158:
				return _List_fromArray(
					['style_guide', 'table']);
			case 159:
				return _List_fromArray(
					['style_guide', 'toast']);
			case 160:
				return _List_fromArray(
					['style_guide', 'toggle_switch']);
			case 161:
				return _List_fromArray(
					['style_guide', 'tooltip']);
			case 162:
				return _List_fromArray(
					['style_guide', 'typography']);
			case 163:
				return _List_fromArray(
					['style_guide', 'upload_form']);
			case 164:
				return _List_fromArray(
					['style_guide', 'upload_result']);
			case 165:
				return _List_fromArray(
					['style_guide', 'well']);
			case 166:
				return _List_fromArray(
					['support', 'canny_sso']);
			case 167:
				return _List_fromArray(
					['tasks', 'new']);
			case 168:
				return _List_fromArray(
					['user', 'accept_terms']);
			case 169:
				return _List_fromArray(
					['user', 'mfa']);
			case 170:
				return _List_fromArray(
					['user', 'profile']);
			case 171:
				return _List_fromArray(
					['user', 'security']);
			case 172:
				var slug = route.a.abG;
				return _List_fromArray(
					['apps', slug]);
			case 173:
				var status = route.a.alH;
				return _List_fromArray(
					['error', status]);
			case 174:
				var token = route.a.adi;
				return _List_fromArray(
					['join', token]);
			case 175:
				var slug = route.a.abG;
				return _List_fromArray(
					['marketplace', slug]);
			case 176:
				return _List_fromArray(
					['admin', 'athenahealth']);
			case 177:
				return _List_fromArray(
					['admin', 'charge_items']);
			case 178:
				return _List_fromArray(
					['admin', 'company_plans']);
			case 179:
				return _List_fromArray(
					['admin', 'coverage_plans']);
			case 180:
				return _List_fromArray(
					['admin', 'data_export']);
			case 181:
				return _List_fromArray(
					['admin', 'data_export_settings']);
			case 182:
				return _List_fromArray(
					['admin', 'documents']);
			case 183:
				return _List_fromArray(
					['admin', 'elation']);
			case 184:
				return _List_fromArray(
					['admin', 'plans']);
			case 185:
				return _List_fromArray(
					['admin', 'providers']);
			case 186:
				return _List_fromArray(
					['admin', 'quickbooks']);
			case 187:
				return _List_fromArray(
					['admin', 'signup_pages']);
			case 188:
				var ccdaId = route.a.afv;
				return _List_fromArray(
					['ccda_imports', ccdaId]);
			case 189:
				return _List_fromArray(
					['commissions', 'broker_accounts']);
			case 190:
				return _List_fromArray(
					['commissions', 'statement_lines']);
			case 191:
				var companyId = route.a.fZ;
				return _List_fromArray(
					['companies', companyId]);
			case 192:
				var contactId = route.a.afW;
				return _List_fromArray(
					['contacts', contactId]);
			case 193:
				return _List_fromArray(
					['hinter', 'admin_users_groups']);
			case 194:
				var inventoryId = route.a.ah4;
				return _List_fromArray(
					['inventory', inventoryId]);
			case 195:
				return _List_fromArray(
					['messages', 'faxes']);
			case 196:
				return _List_fromArray(
					['messages', 'scheduled']);
			case 197:
				return _List_fromArray(
					['new_settings', 'appointment_types']);
			case 198:
				return _List_fromArray(
					['new_settings', 'locations']);
			case 199:
				return _List_fromArray(
					['new_settings', 'templates']);
			case 200:
				var dealId = route.a.agc;
				return _List_fromArray(
					['onboard', dealId]);
			case 201:
				return _List_fromArray(
					['partner', 'dashboard']);
			case 202:
				return _List_fromArray(
					['partner', 'practices']);
			case 203:
				return _List_fromArray(
					['partner', 'sandboxes']);
			case 204:
				var patientId = route.a.YZ;
				return _List_fromArray(
					['patients', patientId]);
			case 205:
				return _List_fromArray(
					['reports', 'ancillary_charges']);
			case 206:
				var tasksId = route.a.alV;
				return _List_fromArray(
					['tasks', tasksId]);
			case 207:
				return _List_fromArray(
					['user', 'organizations']);
			case 208:
				return _List_fromArray(
					['admin', 'athenahealth', 'fields']);
			case 209:
				return _List_fromArray(
					['admin', 'athenahealth', 'link']);
			case 210:
				return _List_fromArray(
					['admin', 'athenahealth', 'locations']);
			case 211:
				return _List_fromArray(
					['admin', 'athenahealth', 'overview']);
			case 212:
				return _List_fromArray(
					['admin', 'athenahealth', 'providers']);
			case 213:
				return _List_fromArray(
					['admin', 'charge_items', 'new']);
			case 214:
				return _List_fromArray(
					['admin', 'charge_items', 'upload']);
			case 215:
				return _List_fromArray(
					['admin', 'company_plans', 'new']);
			case 216:
				return _List_fromArray(
					['admin', 'coverage_plans', 'new']);
			case 217:
				return _List_fromArray(
					['admin', 'credits', 'upload']);
			case 218:
				return _List_fromArray(
					['admin', 'data_export_settings', 'new']);
			case 219:
				return _List_fromArray(
					['admin', 'developers', 'api_keys']);
			case 220:
				return _List_fromArray(
					['admin', 'developers', 'app']);
			case 221:
				return _List_fromArray(
					['admin', 'developers', 'get_started']);
			case 222:
				return _List_fromArray(
					['admin', 'developers', 'hinter']);
			case 223:
				return _List_fromArray(
					['admin', 'developers', 'sandboxes']);
			case 224:
				return _List_fromArray(
					['admin', 'developers', 'webhook_endpoints']);
			case 225:
				return _List_fromArray(
					['admin', 'documents', 'new']);
			case 226:
				return _List_fromArray(
					['admin', 'elation', 'link']);
			case 227:
				return _List_fromArray(
					['admin', 'elation', 'overview']);
			case 228:
				return _List_fromArray(
					['admin', 'elation', 'providers']);
			case 229:
				return _List_fromArray(
					['admin', 'notifications', 'company']);
			case 230:
				return _List_fromArray(
					['admin', 'notifications', 'employee']);
			case 231:
				return _List_fromArray(
					['admin', 'notifications', 'membership']);
			case 232:
				return _List_fromArray(
					['admin', 'notifications', 'patient']);
			case 233:
				return _List_fromArray(
					['admin', 'notifications', 'practice']);
			case 234:
				return _List_fromArray(
					['admin', 'notifications', 'settings']);
			case 235:
				return _List_fromArray(
					['admin', 'payment_method_import', 'upload']);
			case 236:
				return _List_fromArray(
					['admin', 'plans', 'new']);
			case 237:
				return _List_fromArray(
					['admin', 'providers', 'upload']);
			case 238:
				return _List_fromArray(
					['admin', 'signup_pages', 'new']);
			case 239:
				return _List_fromArray(
					['admin', 'team', 'new']);
			case 240:
				var affiliateId = route.a.rd;
				return _List_fromArray(
					['affiliates', affiliateId, 'affiliate_actions']);
			case 241:
				var affiliateId = route.a.rd;
				return _List_fromArray(
					['affiliates', affiliateId, 'link_providers']);
			case 242:
				var affiliateId = route.a.rd;
				return _List_fromArray(
					['affiliates', affiliateId, 'linked_providers']);
			case 243:
				var affiliateId = route.a.rd;
				return _List_fromArray(
					['affiliates', affiliateId, 'patients']);
			case 244:
				var affiliateId = route.a.rd;
				return _List_fromArray(
					['affiliates', affiliateId, 'settings']);
			case 245:
				var affiliateId = route.a.rd;
				return _List_fromArray(
					['affiliates', affiliateId, 'users']);
			case 246:
				return _List_fromArray(
					['commissions', 'broker_accounts', 'new']);
			case 247:
				return _List_fromArray(
					['commissions', 'statement_lines', 'summary']);
			case 248:
				var companyId = route.a.fZ;
				return _List_fromArray(
					['companies', companyId, 'affiliates_pricing']);
			case 249:
				var companyId = route.a.fZ;
				return _List_fromArray(
					['companies', companyId, 'eas']);
			case 250:
				var companyId = route.a.fZ;
				return _List_fromArray(
					['companies', companyId, 'ended_commissions']);
			case 251:
				var companyId = route.a.fZ;
				return _List_fromArray(
					['companies', companyId, 'invoice_settings']);
			case 252:
				var companyId = route.a.fZ;
				return _List_fromArray(
					['companies', companyId, 'notes']);
			case 253:
				var companyId = route.a.fZ;
				return _List_fromArray(
					['companies', companyId, 'notifications']);
			case 254:
				var companyId = route.a.fZ;
				return _List_fromArray(
					['companies', companyId, 'payment_sources']);
			case 255:
				var companyId = route.a.fZ;
				return _List_fromArray(
					['companies', companyId, 'signup']);
			case 256:
				return _List_fromArray(
					['messages', 'fax', 'new']);
			case 257:
				return _List_fromArray(
					['messages', 'faxes', 'new']);
			case 258:
				return _List_fromArray(
					['messages', 'scheduled', 'new']);
			case 259:
				return _List_fromArray(
					['messages', 'scheduled_messages', 'new']);
			case 260:
				return _List_fromArray(
					['new_settings', 'appointment_types', 'new']);
			case 261:
				return _List_fromArray(
					['new_settings', 'templates', 'new']);
			case 262:
				var onboardId = route.a.ajz;
				return _List_fromArray(
					['onboard', onboardId, 'completed']);
			case 263:
				var onboardId = route.a.ajz;
				return _List_fromArray(
					['onboard', onboardId, 'completing']);
			case 264:
				var onboardId = route.a.ajz;
				return _List_fromArray(
					['onboard', onboardId, 'payment']);
			case 265:
				var onboardId = route.a.ajz;
				return _List_fromArray(
					['onboard', onboardId, 'user']);
			case 266:
				return _List_fromArray(
					['partner', 'billing', 'charges']);
			case 267:
				return _List_fromArray(
					['partner', 'billing', 'deposits']);
			case 268:
				return _List_fromArray(
					['partner', 'billing', 'hinter']);
			case 269:
				return _List_fromArray(
					['partner', 'billing', 'service_fee']);
			case 270:
				return _List_fromArray(
					['partner', 'billing', 'subscriptions']);
			case 271:
				return _List_fromArray(
					['partner', 'products', 'new']);
			case 272:
				return _List_fromArray(
					['partner', 'webhooks', 'requests']);
			case 273:
				return _List_fromArray(
					['partner', 'webhooks', 'settings']);
			case 274:
				var patientId = route.a.YZ;
				return _List_fromArray(
					['patients', patientId, 'chart']);
			case 275:
				var patientId = route.a.YZ;
				return _List_fromArray(
					['patients', patientId, 'edit']);
			case 276:
				var patientId = route.a.YZ;
				return _List_fromArray(
					['patients', patientId, 'growth_chart']);
			case 277:
				var patientId = route.a.YZ;
				return _List_fromArray(
					['patients', patientId, 'lab_trends']);
			case 278:
				var patientId = route.a.YZ;
				return _List_fromArray(
					['patients', patientId, 'manage_credits']);
			case 279:
				var patientId = route.a.YZ;
				return _List_fromArray(
					['patients', patientId, 'merge']);
			case 280:
				var patientId = route.a.YZ;
				return _List_fromArray(
					['patients', patientId, 'vitals_trends']);
			case 281:
				return _List_fromArray(
					['practice_setup', 'plans', 'new']);
			case 282:
				return _List_fromArray(
					['reports', 'credit_outstanding', 'summary']);
			case 283:
				return _List_fromArray(
					['reports', 'credit_transactions', 'summary']);
			case 284:
				return _List_fromArray(
					['reports', 'custom', 'new']);
			case 285:
				return _List_fromArray(
					['reports', 'deferred_revenue', 'summary']);
			case 286:
				return _List_fromArray(
					['reports', 'payment_applications', 'summary']);
			case 287:
				return _List_fromArray(
					['reports', 'revenue', 'summary']);
			case 288:
				return _List_fromArray(
					['reports', 'sales_tax', 'summary']);
			case 289:
				var id = route.a.ahP;
				return _List_fromArray(
					['admin', 'charge_items', id]);
			case 290:
				var id = route.a.ahP;
				return _List_fromArray(
					['admin', 'company_plans', id]);
			case 291:
				var id = route.a.ahP;
				return _List_fromArray(
					['admin', 'coverage_plans', id]);
			case 292:
				var id = route.a.ahP;
				return _List_fromArray(
					['admin', 'data_export', id]);
			case 293:
				var id = route.a.ahP;
				return _List_fromArray(
					['admin', 'data_export_settings', id]);
			case 294:
				var id = route.a.ahP;
				return _List_fromArray(
					['admin', 'documents', id]);
			case 295:
				var slug = route.a.abG;
				return _List_fromArray(
					['admin', 'integrations', slug]);
			case 296:
				var id = route.a.ahP;
				return _List_fromArray(
					['admin', 'plans', id]);
			case 297:
				var id = route.a.ahP;
				return _List_fromArray(
					['admin', 'signup_pages', id]);
			case 298:
				var id = route.a.ahP;
				return _List_fromArray(
					['hinter', 'admin_users_groups', id]);
			case 299:
				var messageId = route.a.aiI;
				return _List_fromArray(
					['messages', 'faxes', messageId]);
			case 300:
				var phoneNumber = route.a.Zx;
				return _List_fromArray(
					['messages', 'sms', phoneNumber]);
			case 301:
				var ident = route.a.ahQ;
				return _List_fromArray(
					['new_settings', 'appointment_types', ident]);
			case 302:
				var bookingLocationId = route.a.afk;
				return _List_fromArray(
					['new_settings', 'locations', bookingLocationId]);
			case 303:
				var teamId = route.a.alX;
				return _List_fromArray(
					['new_settings', 'team', teamId]);
			case 304:
				var templateId = route.a.alY;
				return _List_fromArray(
					['new_settings', 'templates', templateId]);
			case 305:
				var id = route.a.ahP;
				return _List_fromArray(
					['partner', 'products', id]);
			case 306:
				var id = route.a.ahP;
				return _List_fromArray(
					['reports', 'ancillary_charges', id]);
			case 307:
				var id = route.a.ahP;
				return _List_fromArray(
					['reports', 'custom', id]);
			case 308:
				var affiliateId = route.a.rd;
				return _List_fromArray(
					['affiliates', affiliateId, 'bills']);
			case 309:
				var brokerAccountId = route.a.cm;
				return _List_fromArray(
					['commissions', 'broker_accounts', brokerAccountId]);
			case 310:
				var companyId = route.a.fZ;
				return _List_fromArray(
					['companies', companyId, 'employees']);
			case 311:
				var companyId = route.a.fZ;
				return _List_fromArray(
					['companies', companyId, 'invoices']);
			case 312:
				var companyId = route.a.fZ;
				return _List_fromArray(
					['companies', companyId, 'uploads']);
			case 313:
				var scheduledId = route.a.ald;
				return _List_fromArray(
					['messages', 'scheduled', scheduledId]);
			case 314:
				var scheduledEventId = route.a.alc;
				return _List_fromArray(
					['messages', 'scheduled_messages', scheduledEventId]);
			case 315:
				var patientId = route.a.YZ;
				return _List_fromArray(
					['patients', patientId, 'accounts']);
			case 316:
				var patientId = route.a.YZ;
				return _List_fromArray(
					['patients', patientId, 'affiliation']);
			case 317:
				var patientId = route.a.YZ;
				return _List_fromArray(
					['patients', patientId, 'charges']);
			case 318:
				var patientId = route.a.YZ;
				return _List_fromArray(
					['patients', patientId, 'memberships']);
			case 319:
				var patientId = route.a.YZ;
				return _List_fromArray(
					['patients', patientId, 'notes']);
			case 320:
				var patientId = route.a.YZ;
				return _List_fromArray(
					['patients', patientId, 'notifications']);
			case 321:
				return _List_fromArray(
					['admin', 'notifications', 'patient', 'dunning_schedule']);
			case 322:
				var brokerAccountId = route.a.cm;
				return _List_fromArray(
					['commissions', 'broker_accounts', brokerAccountId, 'deals']);
			case 323:
				var brokerAccountId = route.a.cm;
				return _List_fromArray(
					['commissions', 'broker_accounts', brokerAccountId, 'ended_deals']);
			case 324:
				var companyId = route.a.fZ;
				return _List_fromArray(
					['companies', companyId, 'employees', 'create']);
			case 325:
				var companyId = route.a.fZ;
				return _List_fromArray(
					['companies', companyId, 'signup_pages', 'new']);
			case 326:
				return _List_fromArray(
					['marketplace', 'athenahealth', 'manage', 'settings']);
			case 327:
				return _List_fromArray(
					['marketplace', 'bookkeeping', 'manage', 'settings']);
			case 328:
				return _List_fromArray(
					['marketplace', 'elation', 'manage', 'settings']);
			case 329:
				return _List_fromArray(
					['marketplace', 'quickbooks', 'manage', 'settings']);
			case 330:
				var slug = route.a.abG;
				return _List_fromArray(
					['marketplace', slug, 'manage', 'onboarding']);
			case 331:
				var slug = route.a.abG;
				return _List_fromArray(
					['marketplace', slug, 'manage', 'settings']);
			case 332:
				var slug = route.a.abG;
				return _List_fromArray(
					['marketplace', slug, 'manage', 'users']);
			case 333:
				var teamId = route.a.alX;
				return _List_fromArray(
					['new_settings', 'team', teamId, 'ai_settings']);
			case 334:
				var teamId = route.a.alX;
				return _List_fromArray(
					['new_settings', 'team', teamId, 'basic_info']);
			case 335:
				var teamId = route.a.alX;
				return _List_fromArray(
					['new_settings', 'team', teamId, 'calendar_and_availability']);
			case 336:
				var id = route.a.ahP;
				return _List_fromArray(
					['partner', 'products', id, 'activation_settings']);
			case 337:
				var id = route.a.ahP;
				return _List_fromArray(
					['partner', 'products', id, 'app_builder']);
			case 338:
				var id = route.a.ahP;
				return _List_fromArray(
					['partner', 'products', id, 'app_settings']);
			case 339:
				var id = route.a.ahP;
				return _List_fromArray(
					['partner', 'products', id, 'hinter']);
			case 340:
				var patientId = route.a.YZ;
				return _List_fromArray(
					['patients', patientId, 'memberships', 'new']);
			case 341:
				var id = route.a.ahP;
				return _List_fromArray(
					['practice_setup', 'plans', id, 'edit']);
			case 342:
				var id = route.a.ahP;
				return _List_fromArray(
					['admin', 'billing', 'practice_invoices', id]);
			case 343:
				var affiliateId = route.a.rd;
				var id = route.a.ahP;
				return _List_fromArray(
					['affiliates', affiliateId, 'bills', id]);
			case 344:
				var companyId = route.a.fZ;
				var id = route.a.ahP;
				return _List_fromArray(
					['companies', companyId, 'invoices', id]);
			case 345:
				var companyId = route.a.fZ;
				var id = route.a.ahP;
				return _List_fromArray(
					['companies', companyId, 'signup_pages', id]);
			case 346:
				var phoneNumber = route.a.Zx;
				var practiceNumber = route.a.aj7;
				return _List_fromArray(
					['messages', 'sms', phoneNumber, practiceNumber]);
			case 347:
				var messageId = route.a.aiI;
				return _List_fromArray(
					['messages', 'v2', 'faxes', messageId]);
			case 348:
				var locationId = route.a.We;
				return _List_fromArray(
					['new_settings', 'locations', 'new', locationId]);
			case 349:
				var patientId = route.a.YZ;
				var noteId = route.a.ai7;
				return _List_fromArray(
					['patients', patientId, 'notes', noteId]);
			case 350:
				var brokerAccountId = route.a.cm;
				return _List_fromArray(
					['commissions', 'broker_accounts', brokerAccountId, 'brokers']);
			case 351:
				var brokerAccountId = route.a.cm;
				return _List_fromArray(
					['commissions', 'broker_accounts', brokerAccountId, 'statements']);
			case 352:
				var companyId = route.a.fZ;
				var uploadId = route.a.Kj;
				return _List_fromArray(
					['companies', companyId, 'uploads', uploadId]);
			case 353:
				var patientId = route.a.YZ;
				var agreementId = route.a.Ll;
				return _List_fromArray(
					['patients', patientId, 'agreements', agreementId]);
			case 354:
				var patientId = route.a.YZ;
				var invoiceId = route.a.Us;
				return _List_fromArray(
					['patients', patientId, 'charges', invoiceId]);
			case 355:
				var patientId = route.a.YZ;
				var membershipId = route.a.AW;
				return _List_fromArray(
					['patients', patientId, 'memberships', membershipId]);
			case 356:
				var id = route.a.ahP;
				return _List_fromArray(
					['admin', 'plans', id, 'pricing_versions', 'new']);
			case 357:
				var brokerAccountId = route.a.cm;
				return _List_fromArray(
					['commissions', 'broker_accounts', brokerAccountId, 'brokers', 'ended']);
			case 358:
				var brokerAccountId = route.a.cm;
				return _List_fromArray(
					['commissions', 'broker_accounts', brokerAccountId, 'brokers', 'new']);
			case 359:
				var companyId = route.a.fZ;
				var uploadId = route.a.Kj;
				return _List_fromArray(
					['companies', companyId, 'uploads', uploadId, 'upload_results']);
			case 360:
				var id = route.a.ahP;
				var pricingVersionId = route.a.akh;
				return _List_fromArray(
					['admin', 'plans', id, 'pricing_versions', pricingVersionId]);
			case 361:
				var brokerAccountId = route.a.cm;
				var statementId = route.a.alG;
				return _List_fromArray(
					['commissions', 'broker_accounts', brokerAccountId, 'statements', statementId]);
			case 362:
				var patientPhoneNumber = route.a.ajT;
				var practicePhoneNumber = route.a.aj8;
				return _List_fromArray(
					['messages', 'legacy', 'sms', patientPhoneNumber, practicePhoneNumber]);
			case 363:
				var brokerAccountId = route.a.cm;
				var brokerId = route.a.GN;
				return _List_fromArray(
					['commissions', 'broker_accounts', brokerAccountId, 'brokers', brokerId]);
			default:
				var companyId = route.a.fZ;
				var employeeId = route.a.agM;
				var dependentId = route.a.agp;
				return _List_fromArray(
					['companies', companyId, 'employees', employeeId, 'dependent', dependentId]);
		}
	}();
	return A2(
		$elm$core$String$append,
		'/',
		A2($elm$core$String$join, '/', segments));
};
var $author$project$Ports$Navigation$pushRoute = F2(
	function (queryParams, route) {
		return $author$project$Ports$Navigation$pushUrl(
			_Utils_ap(
				$author$project$Spa$Generated$Route$toString(route),
				$elm$url$Url$Builder$toQuery(queryParams)));
	});
var $author$project$Api$Platform$Session$One$Session = $elm$core$Basics$identity;
var $author$project$Api$Platform$Session$One$Record = function (id) {
	return function (createdAt) {
		return function (role) {
			return function (restrictedByGroups) {
				return function (user) {
					return function (showCollectionWarning) {
						return function (requestDetail) {
							return function (organization) {
								return function (permissionSets) {
									return function (locationGroups) {
										return function (sandbox) {
											return function (deferCredentialsToUser) {
												return {O1: createdAt, Qh: deferCredentialsToUser, ahP: id, Wa: locationGroups, Yr: organization, Zv: permissionSets, $A: requestDetail, $T: restrictedByGroups, ak3: role, aan: sandbox, abk: showCollectionWarning, ad0: user};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$json$Json$Decode$fail = _Json_fail;
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$ExpectingEnd = {$: 10};
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {NQ: col, afX: contextStack, pm: problem, pL: row};
	});
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.pL, s.NQ, x, s.a3));
	});
var $elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			$elm$core$String$length(s.uN),
			s.g) ? A3($elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.uN);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.g, offset) < 0,
					0,
					{NQ: col, a3: s0.a3, ahY: s0.ahY, g: offset, pL: row, uN: s0.uN});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.g, s.pL, s.NQ, s);
	};
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3($elm$core$String$slice, s0.g, s1.g, s0.uN),
						a),
					s1);
			}
		};
	});
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $elm$core$String$toFloat = _String_toFloat;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs = A2(
	$elm$parser$Parser$andThen,
	function (str) {
		if ($elm$core$String$length(str) <= 9) {
			var _v0 = $elm$core$String$toFloat('0.' + str);
			if (!_v0.$) {
				var floatVal = _v0.a;
				return $elm$parser$Parser$succeed(
					$elm$core$Basics$round(floatVal * 1000));
			} else {
				return $elm$parser$Parser$problem('Invalid float: \"' + (str + '\"'));
			}
		} else {
			return $elm$parser$Parser$problem(
				'Expected at most 9 digits, but got ' + $elm$core$String$fromInt(
					$elm$core$String$length(str)));
		}
	},
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompWhile($elm$core$Char$isDigit)));
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts = F6(
	function (monthYearDayMs, hour, minute, second, ms, utcOffsetMinutes) {
		return $elm$time$Time$millisToPosix((((monthYearDayMs + (((hour * 60) * 60) * 1000)) + (((minute - utcOffsetMinutes) * 60) * 1000)) + (second * 1000)) + ms);
	});
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $elm$parser$Parser$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$UnexpectedChar = {$: 11};
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.g, s.uN);
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{NQ: 1, a3: s.a3, ahY: s.ahY, g: s.g + 1, pL: s.pL + 1, uN: s.uN}) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{NQ: s.NQ + 1, a3: s.a3, ahY: s.ahY, g: newOffset, pL: s.pL, uN: s.uN}));
		};
	});
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var parse = _v0;
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p1 = _v1.a;
				var step = _v1.b;
				var s1 = _v1.c;
				if (!step.$) {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var $elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return function (s) {
			return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
		};
	});
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$toAdvancedStep = function (step) {
	if (!step.$) {
		var s = step.a;
		return $elm$parser$Parser$Advanced$Loop(s);
	} else {
		var a = step.a;
		return $elm$parser$Parser$Advanced$Done(a);
	}
};
var $elm$parser$Parser$loop = F2(
	function (state, callback) {
		return A2(
			$elm$parser$Parser$Advanced$loop,
			state,
			function (s) {
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$toAdvancedStep,
					callback(s));
			});
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt = function (quantity) {
	var helper = function (str) {
		if (_Utils_eq(
			$elm$core$String$length(str),
			quantity)) {
			var _v0 = $elm$core$String$toInt(str);
			if (!_v0.$) {
				var intVal = _v0.a;
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$Done,
					$elm$parser$Parser$succeed(intVal));
			} else {
				return $elm$parser$Parser$problem('Invalid integer: \"' + (str + '\"'));
			}
		} else {
			return A2(
				$elm$parser$Parser$map,
				function (nextChar) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$String$append, str, nextChar));
				},
				$elm$parser$Parser$getChompedString(
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
		}
	};
	return A2($elm$parser$Parser$loop, '', helper);
};
var $elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 8, a: a};
};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.g, s.pL, s.NQ, s.uN);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{NQ: newCol, a3: s.a3, ahY: s.ahY, g: newOffset, pL: newRow, uN: s.uN});
	};
};
var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
var $elm$parser$Parser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear = 1970;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay = function (day) {
	return $elm$parser$Parser$problem(
		'Invalid day: ' + $elm$core$String$fromInt(day));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear = function (year) {
	return (!A2($elm$core$Basics$modBy, 4, year)) && ((!(!A2($elm$core$Basics$modBy, 100, year))) || (!A2($elm$core$Basics$modBy, 400, year)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore = function (y1) {
	var y = y1 - 1;
	return (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay = 86400000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear = 31536000000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay = function (_v0) {
	var year = _v0.a;
	var month = _v0.b;
	var dayInMonth = _v0.c;
	if (dayInMonth < 0) {
		return $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth);
	} else {
		var succeedWith = function (extraMs) {
			var yearMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear * (year - $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear);
			var days = ((month < 3) || (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year))) ? (dayInMonth - 1) : dayInMonth;
			var dayMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay * (days + ($rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(year) - $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore($rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear)));
			return $elm$parser$Parser$succeed((extraMs + yearMs) + dayMs);
		};
		switch (month) {
			case 1:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(0);
			case 2:
				return ((dayInMonth > 29) || ((dayInMonth === 29) && (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year)))) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(2678400000);
			case 3:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(5097600000);
			case 4:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(7776000000);
			case 5:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(10368000000);
			case 6:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(13046400000);
			case 7:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(15638400000);
			case 8:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(18316800000);
			case 9:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(20995200000);
			case 10:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(23587200000);
			case 11:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(26265600000);
			case 12:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(28857600000);
			default:
				return $elm$parser$Parser$problem(
					'Invalid month: \"' + ($elm$core$String$fromInt(month) + '\"'));
		}
	}
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs = A2(
	$elm$parser$Parser$andThen,
	$rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F3(
						function (year, month, day) {
							return _Utils_Tuple3(year, month, day);
						})),
				$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(4)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed($elm$core$Basics$identity),
							$elm$parser$Parser$symbol('-')),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
					]))),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed($elm$core$Basics$identity),
						$elm$parser$Parser$symbol('-')),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
				]))));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes = function () {
	var utcOffsetMinutesFromParts = F3(
		function (multiplier, hours, minutes) {
			return (multiplier * (hours * 60)) + minutes;
		});
	return A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$map,
					function (_v0) {
						return 0;
					},
					$elm$parser$Parser$symbol('Z')),
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed(utcOffsetMinutesFromParts),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$map,
										function (_v1) {
											return 1;
										},
										$elm$parser$Parser$symbol('+')),
										A2(
										$elm$parser$Parser$map,
										function (_v2) {
											return -1;
										},
										$elm$parser$Parser$symbol('-'))
									]))),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$ignorer,
									$elm$parser$Parser$succeed($elm$core$Basics$identity),
									$elm$parser$Parser$symbol(':')),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
								$elm$parser$Parser$succeed(0)
							]))),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(0),
					$elm$parser$Parser$end)
				])));
}();
var $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601 = A2(
	$elm$parser$Parser$andThen,
	function (datePart) {
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed(
											$rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts(datePart)),
										$elm$parser$Parser$symbol('T')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$elm$parser$Parser$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$parser$Parser$keeper,
											A2(
												$elm$parser$Parser$ignorer,
												$elm$parser$Parser$succeed($elm$core$Basics$identity),
												$elm$parser$Parser$symbol(':')),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
										]))),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$keeper,
										A2(
											$elm$parser$Parser$ignorer,
											$elm$parser$Parser$succeed($elm$core$Basics$identity),
											$elm$parser$Parser$symbol(':')),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
										$elm$parser$Parser$succeed(0)
									]))),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$symbol('.')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs),
									$elm$parser$Parser$succeed(0)
								]))),
					A2($elm$parser$Parser$ignorer, $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes, $elm$parser$Parser$end)),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A6($rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts, datePart, 0, 0, 0, 0, 0)),
					$elm$parser$Parser$end)
				]));
	},
	$rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs);
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {NQ: col, pm: problem, pL: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.pL, p.NQ, p.pm);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{NQ: 1, a3: _List_Nil, ahY: 1, g: 0, pL: 1, uN: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime = function (str) {
	return A2($elm$parser$Parser$run, $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601, str);
};
var $elm_community$json_extra$Json$Decode$Extra$datetime = A2(
	$elm$json$Json$Decode$andThen,
	function (dateString) {
		var _v0 = $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(dateString);
		if (!_v0.$) {
			var v = _v0.a;
			return $elm$json$Json$Decode$succeed(v);
		} else {
			return $elm$json$Json$Decode$fail('Expecting an ISO-8601 formatted date+time string');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Common$LocationGroup$Shared$LocationGroup = $elm$core$Basics$identity;
var $author$project$Api$Common$LocationGroup$Min$LocationGroup = $elm$core$Basics$identity;
var $author$project$Api$Common$LocationGroup$Min$Record = F2(
	function (id, name) {
		return {ahP: id, Bq: name};
	});
var $author$project$Api$Common$LocationGroup$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Common$LocationGroup$Min$Record)));
var $author$project$Api$Common$LocationGroup$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$LocationGroup$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$LocationGroup$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$LocationGroup$Min$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$PermissionSet$Shared$PermissionSet = $elm$core$Basics$identity;
var $author$project$Api$Common$PermissionSet$Shared$Record = F2(
	function (name, enabled) {
		return {Ro: enabled, Bq: name};
	});
var $author$project$Api$Common$PermissionSet$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'enabled',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Common$PermissionSet$Shared$Record)));
var $author$project$Api$Common$PermissionSet$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$PermissionSet$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$RequestDetail$Shared$RequestDetail = $elm$core$Basics$identity;
var $author$project$Api$Common$RequestDetail$Shared$Record = F9(
	function (ip, clientName, deviceType, osName, state, country, countryCode, deviceBrand, deviceName) {
		return {NK: clientName, rK: country, OL: countryCode, Qx: deviceBrand, Qy: deviceName, Qz: deviceType, Ux: ip, Yx: osName, uP: state};
	});
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $author$project$Api$Common$RequestDetail$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'device_name',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'device_brand',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'country_code',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'country',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'state',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'os_name',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'device_type',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'client_name',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'ip',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									$elm$json$Json$Decode$succeed($author$project$Api$Common$RequestDetail$Shared$Record))))))))));
var $author$project$Api$Common$RequestDetail$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$RequestDetail$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Platform$Organization$Shared$Organization = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Platform$Organization$Min$Organization = $elm$core$Basics$identity;
var $author$project$Api$Platform$Organization$Min$Record = F3(
	function (type_, id, name) {
		return {ahP: id, Bq: name, amg: type_};
	});
var $author$project$Api$OrganizationType$Company = 1;
var $author$project$Api$OrganizationType$Partner = 2;
var $author$project$Api$OrganizationType$Practice = 0;
var $author$project$Api$OrganizationType$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'company':
				return $elm$json$Json$Decode$succeed(1);
			case 'practice':
				return $elm$json$Json$Decode$succeed(0);
			case 'partner':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Unsupported organization type: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Platform$Organization$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'type',
			$author$project$Api$OrganizationType$decoder,
			$elm$json$Json$Decode$succeed($author$project$Api$Platform$Organization$Min$Record))));
var $author$project$Api$Platform$Organization$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$Organization$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Platform$Organization$Shared$Record = F7(
	function (accountType, isNetwork, requiresMfa, requiresPaymentInformation, practiceIsOnboarding, onboardingClinical, sandboxOf) {
		return {KJ: accountType, U_: isNetwork, Yk: onboardingClinical, ZX: practiceIsOnboarding, $H: requiresMfa, $L: requiresPaymentInformation, aap: sandboxOf};
	});
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (pathDecoder, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2($elm$json$Json$Decode$decodeValue, pathDecoder, input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					var finalErr = _v1.a;
					return $elm$json$Json$Decode$fail(
						$elm$json$Json$Decode$errorToString(finalErr));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				A2($elm$json$Json$Decode$field, key, $elm$json$Json$Decode$value),
				valDecoder,
				fallback),
			decoder);
	});
var $author$project$Api$Platform$Organization$Shared$SandboxOfPartner = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Platform$Organization$Shared$SandboxOfPractice = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Platform$Organization$SandboxOf$Organization = $elm$core$Basics$identity;
var $author$project$Api$Platform$Organization$SandboxOf$ManagedByPractice = $elm$core$Basics$identity;
var $author$project$Api$Platform$Organization$Switcher$Organization = $elm$core$Basics$identity;
var $author$project$Api$Platform$Organization$Switcher$Record = F5(
	function (id, name, organizationId, type_, sandbox) {
		return {ahP: id, Bq: name, ajD: organizationId, aan: sandbox, amg: type_};
	});
var $author$project$Api$Platform$Organization$Switcher$decoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'sandbox',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'type',
			$author$project$Api$OrganizationType$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'organization_id',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'name',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Api$Platform$Organization$Switcher$Record)))))));
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $author$project$Api$Platform$Organization$SandboxOf$managedByDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (managedByType) {
		if ((!managedByType.$) && (managedByType.a === 'Practice')) {
			return A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$map($elm$core$Basics$identity),
				A2(
					$elm$json$Json$Decode$field,
					'managed_by',
					$elm$json$Json$Decode$nullable($author$project$Api$Platform$Organization$Switcher$decoder)));
		} else {
			return $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing);
		}
	},
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'managed_by_type', $elm$json$Json$Decode$string)));
var $author$project$Api$Platform$Organization$SandboxOf$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$Organization$SandboxOf$managedByDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'organization_id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed(
			F2(
				function (orgId, mb) {
					return {Wq: mb, ajD: orgId};
				}))));
var $author$project$Api$Platform$Organization$Shared$sandboxOfDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (sandboxOfType) {
		if (sandboxOfType.$ === 1) {
			return $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing);
		} else {
			switch (sandboxOfType.a) {
				case 'Practice':
					return A2(
						$elm$json$Json$Decode$map,
						$elm$core$Maybe$Just,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'sandbox_of',
							$author$project$Api$Platform$Organization$SandboxOf$decoder,
							$elm$json$Json$Decode$succeed($author$project$Api$Platform$Organization$Shared$SandboxOfPractice)));
				case 'Partner':
					return A2(
						$elm$json$Json$Decode$map,
						$elm$core$Maybe$Just,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'sandbox_of',
							$author$project$Api$Platform$Organization$SandboxOf$decoder,
							$elm$json$Json$Decode$succeed($author$project$Api$Platform$Organization$Shared$SandboxOfPartner)));
				default:
					var somethingElse = sandboxOfType.a;
					return $elm$json$Json$Decode$fail('Unsupported sandbox of type ' + somethingElse);
			}
		}
	},
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['sandbox_of_type']),
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)));
var $author$project$Api$Platform$Organization$Shared$recordDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$Organization$Shared$sandboxOfDecoder,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'onboarding_clinical',
		$elm$json$Json$Decode$bool,
		false,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'practice_is_onboarding',
			$elm$json$Json$Decode$bool,
			false,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'requires_payment_information',
				$elm$json$Json$Decode$bool,
				false,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'requires_mfa',
					$elm$json$Json$Decode$bool,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'is_network',
						$elm$json$Json$Decode$bool,
						false,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'account_type',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Api$Platform$Organization$Shared$Record))))))));
var $author$project$Api$Platform$Organization$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$Organization$Shared$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Platform$Organization$Min$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Platform$Organization$Shared$Organization)));
var $author$project$Api$Platform$User$Shared$User = $elm$core$Basics$identity;
var $author$project$Api$Platform$User$Shared$Record = function (id) {
	return function (name) {
		return function (firstName) {
			return function (lastName) {
				return function (email) {
					return function (canSwitchOrganizations) {
						return function (isAdmin) {
							return function (termsAccepted) {
								return function (mfaStatus) {
									return function (requiresMfa) {
										return function (isMfaActive) {
											return function (phones) {
												return function (identityProviderId) {
													return function (intercomUserHash) {
														return {Nk: canSwitchOrganizations, Rj: email, Sv: firstName, ahP: id, TM: identityProviderId, Uh: intercomUserHash, Uy: isAdmin, UY: isMfaActive, VH: lastName, W6: mfaStatus, Bq: name, Zy: phones, $H: requiresMfa, J5: termsAccepted};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Platform$Mfa$Status$Active = 0;
var $author$project$Api$Platform$Mfa$Status$Inactive = 1;
var $author$project$Api$Platform$Mfa$Status$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'active':
				return $elm$json$Json$Decode$succeed(0);
			case 'inactive':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Unsupported mfa status: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Common$Phone$Shared$Phone = $elm$core$Basics$identity;
var $author$project$Api$Common$Phone$Shared$Record = F3(
	function (number, type_, usFormattable) {
		return {IO: number, amg: type_, Kl: usFormattable};
	});
var $author$project$Api$Common$Phone$Shared$Home = {$: 1};
var $author$project$Api$Common$Phone$Shared$Mobile = {$: 0};
var $author$project$Api$Common$Phone$Shared$Office = {$: 2};
var $author$project$Api$Common$Phone$Shared$Other = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Common$Phone$Shared$typeDecoder = A2(
	$elm$json$Json$Decode$map,
	function (str) {
		switch (str) {
			case 'mobile':
				return $author$project$Api$Common$Phone$Shared$Mobile;
			case 'home':
				return $author$project$Api$Common$Phone$Shared$Home;
			case 'office':
				return $author$project$Api$Common$Phone$Shared$Office;
			default:
				var somethingElse = str;
				return $author$project$Api$Common$Phone$Shared$Other(somethingElse);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Common$Phone$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'us_formattable',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'type',
		$author$project$Api$Common$Phone$Shared$typeDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'number',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$json$Json$Decode$succeed($author$project$Api$Common$Phone$Shared$Record))));
var $author$project$Api$Common$Phone$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Phone$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Platform$User$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'intercom_user_hash',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'identity_provider_id',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'phones',
			$elm$json$Json$Decode$list($author$project$Api$Common$Phone$Shared$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'is_mfa_active',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'requires_mfa',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'mfa_status',
						$author$project$Api$Platform$Mfa$Status$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'terms_accepted',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'is_admin',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'can_switch_organizations',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'email',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'last_name',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'first_name',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'name',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'id',
														$elm$json$Json$Decode$string,
														$elm$json$Json$Decode$succeed($author$project$Api$Platform$User$Shared$Record)))))))))))))));
var $author$project$Api$Platform$User$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$User$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Platform$Session$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'defer_credentials_to_user',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'sandbox',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'location_groups',
			$elm$json$Json$Decode$list($author$project$Api$Common$LocationGroup$Shared$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'permission_sets',
				$elm$json$Json$Decode$list($author$project$Api$Common$PermissionSet$Shared$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'organization',
					$elm$json$Json$Decode$nullable($author$project$Api$Platform$Organization$Shared$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'request_detail',
						$elm$json$Json$Decode$nullable($author$project$Api$Common$RequestDetail$Shared$decoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'show_collection_warning',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'user',
								$author$project$Api$Platform$User$Shared$decoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'restricted_by_groups',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'role',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'created_at',
											$elm_community$json_extra$Json$Decode$Extra$datetime,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'id',
												$elm$json$Json$Decode$string,
												$elm$json$Json$Decode$succeed($author$project$Api$Platform$Session$One$Record)))))))))))));
var $author$project$Api$Platform$Session$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$Session$One$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Platform$Session$sessionPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['session']),
	$author$project$Api$Data$platformPath);
var $author$project$Api$Platform$Session$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Platform$Session$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Platform$Session$sessionPath));
	});
var $author$project$Api$Platform$User$One$User = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Platform$User$One$Record = F4(
	function (practicesCount, companiesCount, partnersCount, defaultOrganization) {
		return {Oa: companiesCount, P4: defaultOrganization, YT: partnersCount, Z0: practicesCount};
	});
var $author$project$Api$Platform$User$One$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'default_organization',
	$elm$json$Json$Decode$nullable($author$project$Api$Platform$Organization$Shared$decoder),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'partners_count',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'companies_count',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'practices_count',
				$elm$json$Json$Decode$int,
				$elm$json$Json$Decode$succeed($author$project$Api$Platform$User$One$Record)))));
var $author$project$Api$Platform$User$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$User$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Platform$User$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Platform$User$One$User)));
var $author$project$Api$Platform$User$userPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['user']),
	$author$project$Api$Data$platformPath);
var $author$project$Api$Platform$User$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Platform$User$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Platform$User$userPath));
	});
var $author$project$Api$AuthToken$jwtIssuer = function (authToken) {
	return A2(
		$elm$core$Maybe$andThen,
		$elm$core$Result$toMaybe,
		A2(
			$elm$core$Maybe$map,
			function (token) {
				return A2(
					$simonh1000$elm_jwt$Jwt$decodeToken,
					A2($elm$json$Json$Decode$field, 'iss', $elm$json$Json$Decode$string),
					token);
			},
			A2($elm$core$Maybe$andThen, $author$project$Api$AuthToken$toString, authToken)));
};
var $author$project$Api$AuthToken$isDefaultAuthJwt = F2(
	function (authToken, providerAuthUrl) {
		return A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				function (issuer) {
					return _Utils_eq(issuer, providerAuthUrl);
				},
				$author$project$Api$AuthToken$jwtIssuer(authToken)));
	});
var $author$project$Api$Data$usingDefaultAuth = F2(
	function (_v0, backupAuthEnabled) {
		var client = _v0;
		var isDefaultAuthJwt = A2($author$project$Api$AuthToken$isDefaultAuthJwt, client.fK, client.Jp);
		return (!backupAuthEnabled) && isDefaultAuthJwt;
	});
var $author$project$Shared$initSession = F3(
	function (apiClient, currentTime, backupAuthEnabled) {
		var refreshTimeoutCmd = (!A2($author$project$Api$Data$usingDefaultAuth, apiClient, backupAuthEnabled)) ? $author$project$Shared$backupJwtRefreshTimeout(apiClient) : $elm$core$Platform$Cmd$none;
		var notExpired = !A2($author$project$Api$Data$clientHasTokenExpired, apiClient, currentTime);
		var canRetrieveSession = $author$project$Api$Data$clientHasAuthToken(apiClient) && notExpired;
		var retrieveApiSession = (canRetrieveSession && backupAuthEnabled) ? $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($author$project$Api$Platform$Session$retrieve, apiClient, $author$project$Shared$GotSession),
					A2($author$project$Api$Platform$User$retrieve, apiClient, $author$project$Shared$GotUser)
				])) : $elm$core$Platform$Cmd$none;
		var session = canRetrieveSession ? $author$project$Api$Data$Loading : $author$project$Api$Data$NotAsked;
		var authenticate = function () {
			var _v0 = _Utils_Tuple2(
				$author$project$Api$Data$clientHasAuthToken(apiClient),
				backupAuthEnabled);
			if (_v0.a) {
				return $author$project$Ports$Session$authorize(
					{aku: true});
			} else {
				if (_v0.b) {
					return A2($author$project$Ports$Navigation$pushRoute, _List_Nil, $author$project$Spa$Generated$Route$Login);
				} else {
					return $elm$core$Platform$Cmd$none;
				}
			}
		}();
		return _Utils_Tuple2(
			session,
			_List_fromArray(
				[authenticate, retrieveApiSession, refreshTimeoutCmd]));
	});
var $author$project$Ui$Image$Store = $elm$core$Basics$identity;
var $author$project$Ui$Image$initStore = $elm$core$Basics$identity;
var $elm$core$Platform$Cmd$map = _Platform_map;
var $author$project$Shared$init = F2(
	function (flags, url) {
		var providerAuthUrl = flags.Jp;
		var defaultTheme = 'v2';
		var currentTime = $elm$time$Time$millisToPosix(flags.af3);
		var maybeAuthToken = A2(
			$elm$core$Maybe$andThen,
			function (token) {
				return A2(
					$author$project$Api$AuthToken$isExpired,
					$elm$core$Maybe$Just(token),
					currentTime) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(token);
			},
			A2($elm$core$Maybe$map, $author$project$Api$AuthToken$fromString, flags.alq));
		var backupAuthEnabled = flags.ae6;
		var apiClient = A4($author$project$Api$Data$clientInit, flags.aeZ, providerAuthUrl, flags.Gw, maybeAuthToken);
		var _v0 = A3($author$project$Shared$initSession, apiClient, currentTime, backupAuthEnabled);
		var session = _v0.a;
		var sessionCmds = _v0.b;
		var _v1 = $author$project$Utils$Release$init(flags.akL);
		var release = _v1.a;
		var releaseCmd = _v1.b;
		var _v2 = A2($author$project$Components$GlobalSearch$init, apiClient, url);
		var globalSearch = _v2.a;
		var globalSearchCmd = _v2.b;
		var cmds = _Utils_ap(
			sessionCmds,
			_List_fromArray(
				[
					A2($elm$core$Task$attempt, $author$project$Shared$GotTimeZone, $justinmimbs$timezone_data$TimeZone$getZone),
					A2($elm$core$Platform$Cmd$map, $author$project$Shared$GlobalSearchMsg, globalSearchCmd),
					A2($elm$core$Platform$Cmd$map, $author$project$Shared$ReleaseMsg, releaseCmd)
				]));
		return _Utils_Tuple2(
			{
				q7: maybeAuthToken,
				Gv: apiClient,
				afQ: $author$project$Api$Data$NotAsked,
				Oo: '',
				dd: $justinmimbs$date$Date$fromRataDie(flags.af2),
				G9: $author$project$Api$Data$NotAsked,
				m4: $elm$core$Maybe$Nothing,
				af3: currentTime,
				ahq: flags,
				gw: globalSearch,
				nU: false,
				ahJ: $author$project$Utils$Environment$decode(flags.ahJ),
				ahK: flags.ahK,
				sF: $author$project$Ui$Image$initStore(flags.TQ),
				sH: $elm$core$Maybe$Nothing,
				aj: $elm$core$Maybe$Nothing,
				aiY: $author$project$Utils$Environment$decode(flags.aiY),
				ajE: false,
				g1: $elm$core$Maybe$Nothing,
				YN: $author$project$Api$Data$NotAsked,
				ajU: $elm$core$Maybe$Nothing,
				ajY: $elm$core$Maybe$Nothing,
				Zn: $elm$core$Maybe$Nothing,
				dD: $elm$core$Maybe$Nothing,
				Zp: false,
				ZV: $author$project$Api$Data$Loading,
				t9: $elm$core$Maybe$Nothing,
				akL: release,
				pI: $elm$core$Maybe$Nothing,
				aa4: session,
				uA: false,
				uF: false,
				ac4: defaultTheme,
				J7: A2($author$project$Formatters$Time$init, $author$project$Shared$defaultTimeZone, currentTime),
				J8: $author$project$Shared$defaultTimeZone,
				lO: $author$project$Ui$Toast$init,
				adY: url,
				ad0: $author$project$Api$Data$Loading,
				aey: $author$project$Api$Data$Loading
			},
			$elm$core$Platform$Cmd$batch(cmds));
	});
var $author$project$Spa$Generated$Pages$Account__Complete__Model = function (a) {
	return {$: 21, a: a};
};
var $author$project$Spa$Generated$Pages$Account__Complete__Msg = function (a) {
	return {$: 21, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__AdvanceBilling__Model = function (a) {
	return {$: 22, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__AdvanceBilling__Msg = function (a) {
	return {$: 22, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Athenahealth__Fields__Model = function (a) {
	return {$: 208, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Athenahealth__Fields__Msg = function (a) {
	return {$: 208, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Athenahealth__Link__Model = function (a) {
	return {$: 209, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Athenahealth__Link__Msg = function (a) {
	return {$: 209, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Athenahealth__Locations__Model = function (a) {
	return {$: 210, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Athenahealth__Locations__Msg = function (a) {
	return {$: 210, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Athenahealth__Overview__Model = function (a) {
	return {$: 211, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Athenahealth__Overview__Msg = function (a) {
	return {$: 211, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Athenahealth__Providers__Model = function (a) {
	return {$: 212, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Athenahealth__Providers__Msg = function (a) {
	return {$: 212, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Athenahealth__Top__Model = function (a) {
	return {$: 176, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Athenahealth__Top__Msg = function (a) {
	return {$: 176, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Billing__Model = function (a) {
	return {$: 23, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Billing__Msg = function (a) {
	return {$: 23, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Billing__PracticeInvoices__Id_String__Model = function (a) {
	return {$: 342, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Billing__PracticeInvoices__Id_String__Msg = function (a) {
	return {$: 342, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__CancellationReasons__Model = function (a) {
	return {$: 24, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__CancellationReasons__Msg = function (a) {
	return {$: 24, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__CardReaders__Model = function (a) {
	return {$: 25, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__CardReaders__Msg = function (a) {
	return {$: 25, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Categories__Model = function (a) {
	return {$: 26, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Categories__Msg = function (a) {
	return {$: 26, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__ChargeItems__Id_String__Model = function (a) {
	return {$: 289, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__ChargeItems__Id_String__Msg = function (a) {
	return {$: 289, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__ChargeItems__New__Model = function (a) {
	return {$: 213, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__ChargeItems__New__Msg = function (a) {
	return {$: 213, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__ChargeItems__Top__Model = function (a) {
	return {$: 177, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__ChargeItems__Top__Msg = function (a) {
	return {$: 177, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__ChargeItems__Upload__Model = function (a) {
	return {$: 214, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__ChargeItems__Upload__Msg = function (a) {
	return {$: 214, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Commissions__Model = function (a) {
	return {$: 27, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Commissions__Msg = function (a) {
	return {$: 27, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__CompanyPlans__Id_String__Model = function (a) {
	return {$: 290, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__CompanyPlans__Id_String__Msg = function (a) {
	return {$: 290, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__CompanyPlans__New__Model = function (a) {
	return {$: 215, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__CompanyPlans__New__Msg = function (a) {
	return {$: 215, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__CompanyPlans__Top__Model = function (a) {
	return {$: 178, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__CompanyPlans__Top__Msg = function (a) {
	return {$: 178, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Coupons__Model = function (a) {
	return {$: 28, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Coupons__Msg = function (a) {
	return {$: 28, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__CoveragePlans__Id_String__Model = function (a) {
	return {$: 291, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__CoveragePlans__Id_String__Msg = function (a) {
	return {$: 291, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__CoveragePlans__New__Model = function (a) {
	return {$: 216, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__CoveragePlans__New__Msg = function (a) {
	return {$: 216, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__CoveragePlans__Top__Model = function (a) {
	return {$: 179, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__CoveragePlans__Top__Msg = function (a) {
	return {$: 179, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__CreditCategories__Model = function (a) {
	return {$: 29, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__CreditCategories__Msg = function (a) {
	return {$: 29, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Credits__Upload__Model = function (a) {
	return {$: 217, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Credits__Upload__Msg = function (a) {
	return {$: 217, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__DataExportSettings__Id_String__Model = function (a) {
	return {$: 293, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__DataExportSettings__Id_String__Msg = function (a) {
	return {$: 293, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__DataExportSettings__New__Model = function (a) {
	return {$: 218, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__DataExportSettings__New__Msg = function (a) {
	return {$: 218, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__DataExportSettings__Top__Model = function (a) {
	return {$: 181, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__DataExportSettings__Top__Msg = function (a) {
	return {$: 181, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__DataExport__Id_String__Model = function (a) {
	return {$: 292, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__DataExport__Id_String__Msg = function (a) {
	return {$: 292, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__DataExport__Top__Model = function (a) {
	return {$: 180, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__DataExport__Top__Msg = function (a) {
	return {$: 180, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Developers__ApiKeys__Model = function (a) {
	return {$: 219, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Developers__ApiKeys__Msg = function (a) {
	return {$: 219, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Developers__App__Model = function (a) {
	return {$: 220, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Developers__App__Msg = function (a) {
	return {$: 220, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Developers__GetStarted__Model = function (a) {
	return {$: 221, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Developers__GetStarted__Msg = function (a) {
	return {$: 221, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Developers__Hinter__Model = function (a) {
	return {$: 222, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Developers__Hinter__Msg = function (a) {
	return {$: 222, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Developers__Sandboxes__Model = function (a) {
	return {$: 223, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Developers__Sandboxes__Msg = function (a) {
	return {$: 223, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Developers__WebhookEndpoints__Model = function (a) {
	return {$: 224, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Developers__WebhookEndpoints__Msg = function (a) {
	return {$: 224, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Documents__Id_String__Model = function (a) {
	return {$: 294, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Documents__Id_String__Msg = function (a) {
	return {$: 294, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Documents__New__Model = function (a) {
	return {$: 225, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Documents__New__Msg = function (a) {
	return {$: 225, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Documents__Top__Model = function (a) {
	return {$: 182, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Documents__Top__Msg = function (a) {
	return {$: 182, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__ElationLegacy__Model = function (a) {
	return {$: 30, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__ElationLegacy__Msg = function (a) {
	return {$: 30, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Elation__Link__Model = function (a) {
	return {$: 226, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Elation__Link__Msg = function (a) {
	return {$: 226, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Elation__Overview__Model = function (a) {
	return {$: 227, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Elation__Overview__Msg = function (a) {
	return {$: 227, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Elation__Providers__Model = function (a) {
	return {$: 228, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Elation__Providers__Msg = function (a) {
	return {$: 228, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Elation__Top__Model = function (a) {
	return {$: 183, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Elation__Top__Msg = function (a) {
	return {$: 183, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Features__Model = function (a) {
	return {$: 31, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Features__Msg = function (a) {
	return {$: 31, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__HipaaAuthorizations__Model = function (a) {
	return {$: 32, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__HipaaAuthorizations__Msg = function (a) {
	return {$: 32, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Integrations__Slug_String__Model = function (a) {
	return {$: 295, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Integrations__Slug_String__Msg = function (a) {
	return {$: 295, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__InternalSettings__Model = function (a) {
	return {$: 33, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__InternalSettings__Msg = function (a) {
	return {$: 33, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__InvoiceSettings__Model = function (a) {
	return {$: 34, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__InvoiceSettings__Msg = function (a) {
	return {$: 34, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__LeadSources__Model = function (a) {
	return {$: 35, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__LeadSources__Msg = function (a) {
	return {$: 35, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Locations__Model = function (a) {
	return {$: 36, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Locations__Msg = function (a) {
	return {$: 36, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Mailgun__Model = function (a) {
	return {$: 37, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Mailgun__Msg = function (a) {
	return {$: 37, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Notes__Model = function (a) {
	return {$: 38, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Notes__Msg = function (a) {
	return {$: 38, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Notifications__Company__Model = function (a) {
	return {$: 229, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Notifications__Company__Msg = function (a) {
	return {$: 229, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Notifications__Employee__Model = function (a) {
	return {$: 230, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Notifications__Employee__Msg = function (a) {
	return {$: 230, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Notifications__Membership__Model = function (a) {
	return {$: 231, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Notifications__Membership__Msg = function (a) {
	return {$: 231, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Notifications__Patient__DunningSchedule__Model = function (a) {
	return {$: 321, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Notifications__Patient__DunningSchedule__Msg = function (a) {
	return {$: 321, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Notifications__Patient__Model = function (a) {
	return {$: 232, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Notifications__Patient__Msg = function (a) {
	return {$: 232, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Notifications__Practice__Model = function (a) {
	return {$: 233, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Notifications__Practice__Msg = function (a) {
	return {$: 233, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Notifications__Settings__Model = function (a) {
	return {$: 234, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Notifications__Settings__Msg = function (a) {
	return {$: 234, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Patients__Model = function (a) {
	return {$: 39, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Patients__Msg = function (a) {
	return {$: 39, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__PaymentMethodImport__Model = function (a) {
	return {$: 40, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__PaymentMethodImport__Msg = function (a) {
	return {$: 40, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__PaymentMethodImport__Upload__Model = function (a) {
	return {$: 235, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__PaymentMethodImport__Upload__Msg = function (a) {
	return {$: 235, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__PaymentProcessing__Model = function (a) {
	return {$: 41, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__PaymentProcessing__Msg = function (a) {
	return {$: 41, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__PaymentSources__Model = function (a) {
	return {$: 42, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__PaymentSources__Msg = function (a) {
	return {$: 42, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Plans__Id_String__Model = function (a) {
	return {$: 296, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Plans__Id_String__Msg = function (a) {
	return {$: 296, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Plans__Id_String__PricingVersions__New__Model = function (a) {
	return {$: 356, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Plans__Id_String__PricingVersions__New__Msg = function (a) {
	return {$: 356, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Plans__Id_String__PricingVersions__PricingVersionId_String__Model = function (a) {
	return {$: 360, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Plans__Id_String__PricingVersions__PricingVersionId_String__Msg = function (a) {
	return {$: 360, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Plans__New__Model = function (a) {
	return {$: 236, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Plans__New__Msg = function (a) {
	return {$: 236, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Plans__Top__Model = function (a) {
	return {$: 184, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Plans__Top__Msg = function (a) {
	return {$: 184, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Practice__Model = function (a) {
	return {$: 43, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Practice__Msg = function (a) {
	return {$: 43, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__ProviderGroups__Model = function (a) {
	return {$: 44, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__ProviderGroups__Msg = function (a) {
	return {$: 44, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Providers__Top__Model = function (a) {
	return {$: 185, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Providers__Top__Msg = function (a) {
	return {$: 185, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Providers__Upload__Model = function (a) {
	return {$: 237, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Providers__Upload__Msg = function (a) {
	return {$: 237, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Quickbooks__Top__Model = function (a) {
	return {$: 186, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Quickbooks__Top__Msg = function (a) {
	return {$: 186, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__ScheduledJobs__Model = function (a) {
	return {$: 45, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__ScheduledJobs__Msg = function (a) {
	return {$: 45, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__SelfService__Model = function (a) {
	return {$: 46, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__SelfService__Msg = function (a) {
	return {$: 46, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__SignupPages__Id_String__Model = function (a) {
	return {$: 297, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__SignupPages__Id_String__Msg = function (a) {
	return {$: 297, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__SignupPages__New__Model = function (a) {
	return {$: 238, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__SignupPages__New__Msg = function (a) {
	return {$: 238, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__SignupPages__Top__Model = function (a) {
	return {$: 187, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__SignupPages__Top__Msg = function (a) {
	return {$: 187, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Signup__Model = function (a) {
	return {$: 47, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Signup__Msg = function (a) {
	return {$: 47, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Stripe__Model = function (a) {
	return {$: 48, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Stripe__Msg = function (a) {
	return {$: 48, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Taxes__Model = function (a) {
	return {$: 49, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Taxes__Msg = function (a) {
	return {$: 49, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Team__Model = function (a) {
	return {$: 50, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Team__Msg = function (a) {
	return {$: 50, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Team__New__Model = function (a) {
	return {$: 239, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Team__New__Msg = function (a) {
	return {$: 239, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Waitlist__Model = function (a) {
	return {$: 51, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Waitlist__Msg = function (a) {
	return {$: 51, a: a};
};
var $author$project$Spa$Generated$Pages$AffiliateBills__Top__Model = function (a) {
	return {$: 12, a: a};
};
var $author$project$Spa$Generated$Pages$AffiliateBills__Top__Msg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__AffiliateActions__Model = function (a) {
	return {$: 240, a: a};
};
var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__AffiliateActions__Msg = function (a) {
	return {$: 240, a: a};
};
var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Bills__Id_String__Model = function (a) {
	return {$: 343, a: a};
};
var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Bills__Id_String__Msg = function (a) {
	return {$: 343, a: a};
};
var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Bills__Top__Model = function (a) {
	return {$: 308, a: a};
};
var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Bills__Top__Msg = function (a) {
	return {$: 308, a: a};
};
var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__LinkProviders__Model = function (a) {
	return {$: 241, a: a};
};
var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__LinkProviders__Msg = function (a) {
	return {$: 241, a: a};
};
var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__LinkedProviders__Model = function (a) {
	return {$: 242, a: a};
};
var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__LinkedProviders__Msg = function (a) {
	return {$: 242, a: a};
};
var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Patients__Model = function (a) {
	return {$: 243, a: a};
};
var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Patients__Msg = function (a) {
	return {$: 243, a: a};
};
var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Settings__Model = function (a) {
	return {$: 244, a: a};
};
var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Settings__Msg = function (a) {
	return {$: 244, a: a};
};
var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Users__Model = function (a) {
	return {$: 245, a: a};
};
var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Users__Msg = function (a) {
	return {$: 245, a: a};
};
var $author$project$Spa$Generated$Pages$Affiliates__Create__Model = function (a) {
	return {$: 52, a: a};
};
var $author$project$Spa$Generated$Pages$Affiliates__Create__Msg = function (a) {
	return {$: 52, a: a};
};
var $author$project$Spa$Generated$Pages$Affiliates__New__Model = function (a) {
	return {$: 53, a: a};
};
var $author$project$Spa$Generated$Pages$Affiliates__New__Msg = function (a) {
	return {$: 53, a: a};
};
var $author$project$Spa$Generated$Pages$Affiliates__Top__Model = function (a) {
	return {$: 13, a: a};
};
var $author$project$Spa$Generated$Pages$Affiliates__Top__Msg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Spa$Generated$Pages$Apps__Slug_String__Model = function (a) {
	return {$: 172, a: a};
};
var $author$project$Spa$Generated$Pages$Apps__Slug_String__Msg = function (a) {
	return {$: 172, a: a};
};
var $author$project$Spa$Generated$Pages$Blank__Model = function (a) {
	return {$: 1, a: a};
};
var $author$project$Spa$Generated$Pages$Blank__Msg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Spa$Generated$Pages$Bookkeeping__Model = function (a) {
	return {$: 2, a: a};
};
var $author$project$Spa$Generated$Pages$Bookkeeping__Msg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Spa$Generated$Pages$Calendar__Model = function (a) {
	return {$: 3, a: a};
};
var $author$project$Spa$Generated$Pages$Calendar__Msg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Spa$Generated$Pages$CcdaImports__CcdaId_String__Top__Model = function (a) {
	return {$: 188, a: a};
};
var $author$project$Spa$Generated$Pages$CcdaImports__CcdaId_String__Top__Msg = function (a) {
	return {$: 188, a: a};
};
var $author$project$Spa$Generated$Pages$Charges__New__Model = function (a) {
	return {$: 54, a: a};
};
var $author$project$Spa$Generated$Pages$Charges__New__Msg = function (a) {
	return {$: 54, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__BrokerId_String__Top__Model = function (a) {
	return {$: 363, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__BrokerId_String__Top__Msg = function (a) {
	return {$: 363, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Ended__Model = function (a) {
	return {$: 357, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Ended__Msg = function (a) {
	return {$: 357, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__New__Model = function (a) {
	return {$: 358, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__New__Msg = function (a) {
	return {$: 358, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top__Model = function (a) {
	return {$: 350, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top__Msg = function (a) {
	return {$: 350, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Deals__Model = function (a) {
	return {$: 322, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Deals__Msg = function (a) {
	return {$: 322, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__EndedDeals__Model = function (a) {
	return {$: 323, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__EndedDeals__Msg = function (a) {
	return {$: 323, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__StatementId_String__Model = function (a) {
	return {$: 361, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__StatementId_String__Msg = function (a) {
	return {$: 361, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__Top__Model = function (a) {
	return {$: 351, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__Top__Msg = function (a) {
	return {$: 351, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Top__Model = function (a) {
	return {$: 309, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Top__Msg = function (a) {
	return {$: 309, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__New__Model = function (a) {
	return {$: 246, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__New__Msg = function (a) {
	return {$: 246, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__Top__Model = function (a) {
	return {$: 189, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__Top__Msg = function (a) {
	return {$: 189, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__StatementLines__Summary__Model = function (a) {
	return {$: 247, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__StatementLines__Summary__Msg = function (a) {
	return {$: 247, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__StatementLines__Top__Model = function (a) {
	return {$: 190, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__StatementLines__Top__Msg = function (a) {
	return {$: 190, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__Statements__Model = function (a) {
	return {$: 55, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__Statements__Msg = function (a) {
	return {$: 55, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__AffiliatesPricing__Model = function (a) {
	return {$: 248, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__AffiliatesPricing__Msg = function (a) {
	return {$: 248, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Eas__Model = function (a) {
	return {$: 249, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Eas__Msg = function (a) {
	return {$: 249, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Employees__Create__Model = function (a) {
	return {$: 324, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Employees__Create__Msg = function (a) {
	return {$: 324, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Employees__EmployeeId_String__Dependent__DependentId_String__Top__Model = function (a) {
	return {$: 364, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Employees__EmployeeId_String__Dependent__DependentId_String__Top__Msg = function (a) {
	return {$: 364, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Employees__Top__Model = function (a) {
	return {$: 310, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Employees__Top__Msg = function (a) {
	return {$: 310, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__EndedCommissions__Model = function (a) {
	return {$: 250, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__EndedCommissions__Msg = function (a) {
	return {$: 250, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__InvoiceSettings__Model = function (a) {
	return {$: 251, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__InvoiceSettings__Msg = function (a) {
	return {$: 251, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Invoices__Id_String__Model = function (a) {
	return {$: 344, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Invoices__Id_String__Msg = function (a) {
	return {$: 344, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Invoices__Top__Model = function (a) {
	return {$: 311, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Invoices__Top__Msg = function (a) {
	return {$: 311, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Notes__Model = function (a) {
	return {$: 252, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Notes__Msg = function (a) {
	return {$: 252, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Notifications__Model = function (a) {
	return {$: 253, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Notifications__Msg = function (a) {
	return {$: 253, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__PaymentSources__Model = function (a) {
	return {$: 254, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__PaymentSources__Msg = function (a) {
	return {$: 254, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__SignupPages__Id_String__Model = function (a) {
	return {$: 345, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__SignupPages__Id_String__Msg = function (a) {
	return {$: 345, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__SignupPages__New__Model = function (a) {
	return {$: 325, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__SignupPages__New__Msg = function (a) {
	return {$: 325, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Signup__Model = function (a) {
	return {$: 255, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Signup__Msg = function (a) {
	return {$: 255, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Top__Model = function (a) {
	return {$: 191, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Top__Msg = function (a) {
	return {$: 191, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Uploads__Top__Model = function (a) {
	return {$: 312, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Uploads__Top__Msg = function (a) {
	return {$: 312, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Uploads__UploadId_String__Top__Model = function (a) {
	return {$: 352, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Uploads__UploadId_String__Top__Msg = function (a) {
	return {$: 352, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Uploads__UploadId_String__UploadResults__Model = function (a) {
	return {$: 359, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Uploads__UploadId_String__UploadResults__Msg = function (a) {
	return {$: 359, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__New__Model = function (a) {
	return {$: 56, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__New__Msg = function (a) {
	return {$: 56, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__Top__Model = function (a) {
	return {$: 14, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__Top__Msg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Spa$Generated$Pages$Contacts__ContactId_String__Top__Model = function (a) {
	return {$: 192, a: a};
};
var $author$project$Spa$Generated$Pages$Contacts__ContactId_String__Top__Msg = function (a) {
	return {$: 192, a: a};
};
var $author$project$Spa$Generated$Pages$Contacts__List__Model = function (a) {
	return {$: 57, a: a};
};
var $author$project$Spa$Generated$Pages$Contacts__List__Msg = function (a) {
	return {$: 57, a: a};
};
var $author$project$Spa$Generated$Pages$Contacts__New__Model = function (a) {
	return {$: 58, a: a};
};
var $author$project$Spa$Generated$Pages$Contacts__New__Msg = function (a) {
	return {$: 58, a: a};
};
var $author$project$Spa$Generated$Pages$Error__Status_String__Model = function (a) {
	return {$: 173, a: a};
};
var $author$project$Spa$Generated$Pages$Error__Status_String__Msg = function (a) {
	return {$: 173, a: a};
};
var $author$project$Spa$Generated$Pages$Files__Public__Model = function (a) {
	return {$: 59, a: a};
};
var $author$project$Spa$Generated$Pages$Files__Public__Msg = function (a) {
	return {$: 59, a: a};
};
var $author$project$Spa$Generated$Pages$Files__Top__Model = function (a) {
	return {$: 15, a: a};
};
var $author$project$Spa$Generated$Pages$Files__Top__Msg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Spa$Generated$Pages$Forms__Model = function (a) {
	return {$: 4, a: a};
};
var $author$project$Spa$Generated$Pages$Forms__Msg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Spa$Generated$Pages$GoogleCallback__Model = function (a) {
	return {$: 5, a: a};
};
var $author$project$Spa$Generated$Pages$GoogleCallback__Msg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Spa$Generated$Pages$Hinter__AdminUsersGroups__Id_String__Model = function (a) {
	return {$: 298, a: a};
};
var $author$project$Spa$Generated$Pages$Hinter__AdminUsersGroups__Id_String__Msg = function (a) {
	return {$: 298, a: a};
};
var $author$project$Spa$Generated$Pages$Hinter__AdminUsersGroups__Top__Model = function (a) {
	return {$: 193, a: a};
};
var $author$project$Spa$Generated$Pages$Hinter__AdminUsersGroups__Top__Msg = function (a) {
	return {$: 193, a: a};
};
var $author$project$Spa$Generated$Pages$Hinter__ClonePractice__Model = function (a) {
	return {$: 60, a: a};
};
var $author$project$Spa$Generated$Pages$Hinter__ClonePractice__Msg = function (a) {
	return {$: 60, a: a};
};
var $author$project$Spa$Generated$Pages$Hinter__Disputes__Model = function (a) {
	return {$: 61, a: a};
};
var $author$project$Spa$Generated$Pages$Hinter__Disputes__Msg = function (a) {
	return {$: 61, a: a};
};
var $author$project$Spa$Generated$Pages$Hinter__FeatureFlags__Model = function (a) {
	return {$: 62, a: a};
};
var $author$project$Spa$Generated$Pages$Hinter__FeatureFlags__Msg = function (a) {
	return {$: 62, a: a};
};
var $author$project$Spa$Generated$Pages$Hinter__NewGroup__Model = function (a) {
	return {$: 63, a: a};
};
var $author$project$Spa$Generated$Pages$Hinter__NewGroup__Msg = function (a) {
	return {$: 63, a: a};
};
var $author$project$Spa$Generated$Pages$Hinter__NewPartner__Model = function (a) {
	return {$: 64, a: a};
};
var $author$project$Spa$Generated$Pages$Hinter__NewPartner__Msg = function (a) {
	return {$: 64, a: a};
};
var $author$project$Spa$Generated$Pages$Hinter__NewPractice__Model = function (a) {
	return {$: 65, a: a};
};
var $author$project$Spa$Generated$Pages$Hinter__NewPractice__Msg = function (a) {
	return {$: 65, a: a};
};
var $author$project$Spa$Generated$Pages$Home__Model = function (a) {
	return {$: 6, a: a};
};
var $author$project$Spa$Generated$Pages$Home__Msg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Spa$Generated$Pages$Inventory__InventoryId_String__Top__Model = function (a) {
	return {$: 194, a: a};
};
var $author$project$Spa$Generated$Pages$Inventory__InventoryId_String__Top__Msg = function (a) {
	return {$: 194, a: a};
};
var $author$project$Spa$Generated$Pages$Inventory__List__Model = function (a) {
	return {$: 66, a: a};
};
var $author$project$Spa$Generated$Pages$Inventory__List__Msg = function (a) {
	return {$: 66, a: a};
};
var $author$project$Spa$Generated$Pages$Inventory__New__Model = function (a) {
	return {$: 67, a: a};
};
var $author$project$Spa$Generated$Pages$Inventory__New__Msg = function (a) {
	return {$: 67, a: a};
};
var $author$project$Spa$Generated$Pages$Inventory__Settings__Model = function (a) {
	return {$: 68, a: a};
};
var $author$project$Spa$Generated$Pages$Inventory__Settings__Msg = function (a) {
	return {$: 68, a: a};
};
var $author$project$Spa$Generated$Pages$Join__Token_String__Model = function (a) {
	return {$: 174, a: a};
};
var $author$project$Spa$Generated$Pages$Join__Token_String__Msg = function (a) {
	return {$: 174, a: a};
};
var $author$project$Spa$Generated$Pages$Login__Model = function (a) {
	return {$: 7, a: a};
};
var $author$project$Spa$Generated$Pages$Login__Msg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Spa$Generated$Pages$Logout__Model = function (a) {
	return {$: 8, a: a};
};
var $author$project$Spa$Generated$Pages$Logout__Msg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Spa$Generated$Pages$Marketplace__Athenahealth__Manage__Settings__Model = function (a) {
	return {$: 326, a: a};
};
var $author$project$Spa$Generated$Pages$Marketplace__Athenahealth__Manage__Settings__Msg = function (a) {
	return {$: 326, a: a};
};
var $author$project$Spa$Generated$Pages$Marketplace__Bookkeeping__Manage__Settings__Model = function (a) {
	return {$: 327, a: a};
};
var $author$project$Spa$Generated$Pages$Marketplace__Bookkeeping__Manage__Settings__Msg = function (a) {
	return {$: 327, a: a};
};
var $author$project$Spa$Generated$Pages$Marketplace__Elation__Manage__Settings__Model = function (a) {
	return {$: 328, a: a};
};
var $author$project$Spa$Generated$Pages$Marketplace__Elation__Manage__Settings__Msg = function (a) {
	return {$: 328, a: a};
};
var $author$project$Spa$Generated$Pages$Marketplace__Manage__Model = function (a) {
	return {$: 69, a: a};
};
var $author$project$Spa$Generated$Pages$Marketplace__Manage__Msg = function (a) {
	return {$: 69, a: a};
};
var $author$project$Spa$Generated$Pages$Marketplace__Quickbooks__Manage__Settings__Model = function (a) {
	return {$: 329, a: a};
};
var $author$project$Spa$Generated$Pages$Marketplace__Quickbooks__Manage__Settings__Msg = function (a) {
	return {$: 329, a: a};
};
var $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Manage__Onboarding__Model = function (a) {
	return {$: 330, a: a};
};
var $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Manage__Onboarding__Msg = function (a) {
	return {$: 330, a: a};
};
var $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Manage__Settings__Model = function (a) {
	return {$: 331, a: a};
};
var $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Manage__Settings__Msg = function (a) {
	return {$: 331, a: a};
};
var $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Manage__Users__Model = function (a) {
	return {$: 332, a: a};
};
var $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Manage__Users__Msg = function (a) {
	return {$: 332, a: a};
};
var $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Model = function (a) {
	return {$: 175, a: a};
};
var $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Msg = function (a) {
	return {$: 175, a: a};
};
var $author$project$Spa$Generated$Pages$Marketplace__Top__Model = function (a) {
	return {$: 16, a: a};
};
var $author$project$Spa$Generated$Pages$Marketplace__Top__Msg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Calls__Model = function (a) {
	return {$: 70, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Calls__Msg = function (a) {
	return {$: 70, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Chat__Model = function (a) {
	return {$: 71, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Chat__Msg = function (a) {
	return {$: 71, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Drafts__Model = function (a) {
	return {$: 72, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Drafts__Msg = function (a) {
	return {$: 72, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Fax__New__Model = function (a) {
	return {$: 256, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Fax__New__Msg = function (a) {
	return {$: 256, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Faxes__MessageId_String__Model = function (a) {
	return {$: 299, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Faxes__MessageId_String__Msg = function (a) {
	return {$: 299, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Faxes__New__Model = function (a) {
	return {$: 257, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Faxes__New__Msg = function (a) {
	return {$: 257, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Faxes__Top__Model = function (a) {
	return {$: 195, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Faxes__Top__Msg = function (a) {
	return {$: 195, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Forms__Model = function (a) {
	return {$: 73, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Forms__Msg = function (a) {
	return {$: 73, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Inbox__Model = function (a) {
	return {$: 74, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Inbox__Msg = function (a) {
	return {$: 74, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Labs__Model = function (a) {
	return {$: 75, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Labs__Msg = function (a) {
	return {$: 75, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__LegacyCalls__Model = function (a) {
	return {$: 76, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__LegacyCalls__Msg = function (a) {
	return {$: 76, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Legacy__Sms__PatientPhoneNumber_String__PracticePhoneNumber_String__Model = function (a) {
	return {$: 362, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Legacy__Sms__PatientPhoneNumber_String__PracticePhoneNumber_String__Msg = function (a) {
	return {$: 362, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__ScheduledMessages__New__Model = function (a) {
	return {$: 259, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__ScheduledMessages__New__Msg = function (a) {
	return {$: 259, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__ScheduledMessages__ScheduledEventId_String__Top__Model = function (a) {
	return {$: 314, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__ScheduledMessages__ScheduledEventId_String__Top__Msg = function (a) {
	return {$: 314, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Scheduled__New__Model = function (a) {
	return {$: 258, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Scheduled__New__Msg = function (a) {
	return {$: 258, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Scheduled__ScheduledId_String__Top__Model = function (a) {
	return {$: 313, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Scheduled__ScheduledId_String__Top__Msg = function (a) {
	return {$: 313, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Scheduled__Top__Model = function (a) {
	return {$: 196, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Scheduled__Top__Msg = function (a) {
	return {$: 196, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Sms__Model = function (a) {
	return {$: 77, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Sms__Msg = function (a) {
	return {$: 77, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Sms__PhoneNumber_String__Model = function (a) {
	return {$: 300, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Sms__PhoneNumber_String__Msg = function (a) {
	return {$: 300, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Sms__PhoneNumber_String__PracticeNumber_String__Model = function (a) {
	return {$: 346, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Sms__PhoneNumber_String__PracticeNumber_String__Msg = function (a) {
	return {$: 346, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__V2__Faxes__MessageId_String__Model = function (a) {
	return {$: 347, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__V2__Faxes__MessageId_String__Msg = function (a) {
	return {$: 347, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__AppointmentTypes__Ident_String__Model = function (a) {
	return {$: 301, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__AppointmentTypes__Ident_String__Msg = function (a) {
	return {$: 301, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__AppointmentTypes__New__Model = function (a) {
	return {$: 260, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__AppointmentTypes__New__Msg = function (a) {
	return {$: 260, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__AppointmentTypes__Top__Model = function (a) {
	return {$: 197, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__AppointmentTypes__Top__Msg = function (a) {
	return {$: 197, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__BlockedPhoneNumbers__Model = function (a) {
	return {$: 78, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__BlockedPhoneNumbers__Msg = function (a) {
	return {$: 78, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__BookingOverview__Model = function (a) {
	return {$: 79, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__BookingOverview__Msg = function (a) {
	return {$: 79, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__Erx__Model = function (a) {
	return {$: 80, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__Erx__Msg = function (a) {
	return {$: 80, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__Export__Model = function (a) {
	return {$: 81, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__Export__Msg = function (a) {
	return {$: 81, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__HinterSettings__Model = function (a) {
	return {$: 82, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__HinterSettings__Msg = function (a) {
	return {$: 82, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__Locations__BookingLocationId_String__Model = function (a) {
	return {$: 302, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__Locations__BookingLocationId_String__Msg = function (a) {
	return {$: 302, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__Locations__New__LocationId_String__Model = function (a) {
	return {$: 348, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__Locations__New__LocationId_String__Msg = function (a) {
	return {$: 348, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__Locations__Top__Model = function (a) {
	return {$: 198, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__Locations__Top__Msg = function (a) {
	return {$: 198, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__PracticeInfo__Model = function (a) {
	return {$: 83, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__PracticeInfo__Msg = function (a) {
	return {$: 83, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__Team__Model = function (a) {
	return {$: 84, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__Team__Msg = function (a) {
	return {$: 84, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__Team__TeamId_String__AiSettings__Model = function (a) {
	return {$: 333, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__Team__TeamId_String__AiSettings__Msg = function (a) {
	return {$: 333, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__Team__TeamId_String__BasicInfo__Model = function (a) {
	return {$: 334, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__Team__TeamId_String__BasicInfo__Msg = function (a) {
	return {$: 334, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__Team__TeamId_String__CalendarAndAvailability__Model = function (a) {
	return {$: 335, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__Team__TeamId_String__CalendarAndAvailability__Msg = function (a) {
	return {$: 335, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__Team__TeamId_String__Model = function (a) {
	return {$: 303, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__Team__TeamId_String__Msg = function (a) {
	return {$: 303, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__Templates__New__Model = function (a) {
	return {$: 261, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__Templates__New__Msg = function (a) {
	return {$: 261, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__Templates__TemplateId_String__Model = function (a) {
	return {$: 304, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__Templates__TemplateId_String__Msg = function (a) {
	return {$: 304, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__Templates__Top__Model = function (a) {
	return {$: 199, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__Templates__Top__Msg = function (a) {
	return {$: 199, a: a};
};
var $author$project$Spa$Generated$Pages$NotFound__Model = function (a) {
	return {$: 9, a: a};
};
var $author$project$Spa$Generated$Pages$NotFound__Msg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Spa$Generated$Pages$Oauth__Callback__Model = function (a) {
	return {$: 85, a: a};
};
var $author$project$Spa$Generated$Pages$Oauth__Callback__Msg = function (a) {
	return {$: 85, a: a};
};
var $author$project$Spa$Generated$Pages$Onboard__DealId_String__Top__Model = function (a) {
	return {$: 200, a: a};
};
var $author$project$Spa$Generated$Pages$Onboard__DealId_String__Top__Msg = function (a) {
	return {$: 200, a: a};
};
var $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__Completed__Model = function (a) {
	return {$: 262, a: a};
};
var $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__Completed__Msg = function (a) {
	return {$: 262, a: a};
};
var $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__Completing__Model = function (a) {
	return {$: 263, a: a};
};
var $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__Completing__Msg = function (a) {
	return {$: 263, a: a};
};
var $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__Payment__Model = function (a) {
	return {$: 264, a: a};
};
var $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__Payment__Msg = function (a) {
	return {$: 264, a: a};
};
var $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__User__Model = function (a) {
	return {$: 265, a: a};
};
var $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__User__Msg = function (a) {
	return {$: 265, a: a};
};
var $author$project$Spa$Generated$Pages$Onboarding__Model = function (a) {
	return {$: 10, a: a};
};
var $author$project$Spa$Generated$Pages$Onboarding__Msg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__ApiKeys__Model = function (a) {
	return {$: 86, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__ApiKeys__Msg = function (a) {
	return {$: 86, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Billing__Charges__Model = function (a) {
	return {$: 266, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Billing__Charges__Msg = function (a) {
	return {$: 266, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Billing__Deposits__Model = function (a) {
	return {$: 267, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Billing__Deposits__Msg = function (a) {
	return {$: 267, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Billing__Hinter__Model = function (a) {
	return {$: 268, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Billing__Hinter__Msg = function (a) {
	return {$: 268, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Billing__Model = function (a) {
	return {$: 87, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Billing__Msg = function (a) {
	return {$: 87, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Billing__ServiceFee__Model = function (a) {
	return {$: 269, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Billing__ServiceFee__Msg = function (a) {
	return {$: 269, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Billing__Subscriptions__Model = function (a) {
	return {$: 270, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Billing__Subscriptions__Msg = function (a) {
	return {$: 270, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Dashboard__Top__Model = function (a) {
	return {$: 201, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Dashboard__Top__Msg = function (a) {
	return {$: 201, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Engagements__Model = function (a) {
	return {$: 88, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Engagements__Msg = function (a) {
	return {$: 88, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Hinter__Model = function (a) {
	return {$: 89, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Hinter__Msg = function (a) {
	return {$: 89, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Practices__Top__Model = function (a) {
	return {$: 202, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Practices__Top__Msg = function (a) {
	return {$: 202, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Products__Id_String__ActivationSettings__Model = function (a) {
	return {$: 336, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Products__Id_String__ActivationSettings__Msg = function (a) {
	return {$: 336, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Products__Id_String__AppBuilder__Model = function (a) {
	return {$: 337, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Products__Id_String__AppBuilder__Msg = function (a) {
	return {$: 337, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Products__Id_String__AppSettings__Model = function (a) {
	return {$: 338, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Products__Id_String__AppSettings__Msg = function (a) {
	return {$: 338, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Products__Id_String__Hinter__Model = function (a) {
	return {$: 339, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Products__Id_String__Hinter__Msg = function (a) {
	return {$: 339, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Products__Id_String__Model = function (a) {
	return {$: 305, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Products__Id_String__Msg = function (a) {
	return {$: 305, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Products__New__Model = function (a) {
	return {$: 271, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Products__New__Msg = function (a) {
	return {$: 271, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Sandboxes__Top__Model = function (a) {
	return {$: 203, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Sandboxes__Top__Msg = function (a) {
	return {$: 203, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Team__Model = function (a) {
	return {$: 90, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Team__Msg = function (a) {
	return {$: 90, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Webhooks__Requests__Model = function (a) {
	return {$: 272, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Webhooks__Requests__Msg = function (a) {
	return {$: 272, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Webhooks__Settings__Model = function (a) {
	return {$: 273, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Webhooks__Settings__Msg = function (a) {
	return {$: 273, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__Create__Model = function (a) {
	return {$: 91, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__Create__Msg = function (a) {
	return {$: 91, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Accounts__Top__Model = function (a) {
	return {$: 315, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Accounts__Top__Msg = function (a) {
	return {$: 315, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Affiliation__Top__Model = function (a) {
	return {$: 316, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Affiliation__Top__Msg = function (a) {
	return {$: 316, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Agreements__AgreementId_String__Top__Model = function (a) {
	return {$: 353, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Agreements__AgreementId_String__Top__Msg = function (a) {
	return {$: 353, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Charges__InvoiceId_String__Top__Model = function (a) {
	return {$: 354, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Charges__InvoiceId_String__Top__Msg = function (a) {
	return {$: 354, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Charges__Top__Model = function (a) {
	return {$: 317, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Charges__Top__Msg = function (a) {
	return {$: 317, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Chart__Model = function (a) {
	return {$: 274, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Chart__Msg = function (a) {
	return {$: 274, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Edit__Model = function (a) {
	return {$: 275, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Edit__Msg = function (a) {
	return {$: 275, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__GrowthChart__Model = function (a) {
	return {$: 276, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__GrowthChart__Msg = function (a) {
	return {$: 276, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__LabTrends__Model = function (a) {
	return {$: 277, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__LabTrends__Msg = function (a) {
	return {$: 277, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__ManageCredits__Model = function (a) {
	return {$: 278, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__ManageCredits__Msg = function (a) {
	return {$: 278, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Memberships__MembershipId_String__Top__Model = function (a) {
	return {$: 355, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Memberships__MembershipId_String__Top__Msg = function (a) {
	return {$: 355, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Memberships__New__Model = function (a) {
	return {$: 340, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Memberships__New__Msg = function (a) {
	return {$: 340, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Memberships__Top__Model = function (a) {
	return {$: 318, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Memberships__Top__Msg = function (a) {
	return {$: 318, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Merge__Model = function (a) {
	return {$: 279, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Merge__Msg = function (a) {
	return {$: 279, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Notes__NoteId_String__Model = function (a) {
	return {$: 349, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Notes__NoteId_String__Msg = function (a) {
	return {$: 349, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Notes__Top__Model = function (a) {
	return {$: 319, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Notes__Top__Msg = function (a) {
	return {$: 319, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Notifications__Top__Model = function (a) {
	return {$: 320, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Notifications__Top__Msg = function (a) {
	return {$: 320, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Top__Model = function (a) {
	return {$: 204, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Top__Msg = function (a) {
	return {$: 204, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__VitalsTrends__Model = function (a) {
	return {$: 280, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__VitalsTrends__Msg = function (a) {
	return {$: 280, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__Top__Model = function (a) {
	return {$: 17, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__Top__Msg = function (a) {
	return {$: 17, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__Upload__Model = function (a) {
	return {$: 92, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__Upload__Msg = function (a) {
	return {$: 92, a: a};
};
var $author$project$Spa$Generated$Pages$PracticeSetup__Account__Model = function (a) {
	return {$: 93, a: a};
};
var $author$project$Spa$Generated$Pages$PracticeSetup__Account__Msg = function (a) {
	return {$: 93, a: a};
};
var $author$project$Spa$Generated$Pages$PracticeSetup__Communications__Model = function (a) {
	return {$: 94, a: a};
};
var $author$project$Spa$Generated$Pages$PracticeSetup__Communications__Msg = function (a) {
	return {$: 94, a: a};
};
var $author$project$Spa$Generated$Pages$PracticeSetup__Complete__Model = function (a) {
	return {$: 95, a: a};
};
var $author$project$Spa$Generated$Pages$PracticeSetup__Complete__Msg = function (a) {
	return {$: 95, a: a};
};
var $author$project$Spa$Generated$Pages$PracticeSetup__Documents__Model = function (a) {
	return {$: 96, a: a};
};
var $author$project$Spa$Generated$Pages$PracticeSetup__Documents__Msg = function (a) {
	return {$: 96, a: a};
};
var $author$project$Spa$Generated$Pages$PracticeSetup__Legal__Model = function (a) {
	return {$: 97, a: a};
};
var $author$project$Spa$Generated$Pages$PracticeSetup__Legal__Msg = function (a) {
	return {$: 97, a: a};
};
var $author$project$Spa$Generated$Pages$PracticeSetup__PaymentProcessing__Model = function (a) {
	return {$: 98, a: a};
};
var $author$project$Spa$Generated$Pages$PracticeSetup__PaymentProcessing__Msg = function (a) {
	return {$: 98, a: a};
};
var $author$project$Spa$Generated$Pages$PracticeSetup__Plans__Id_String__Edit__Model = function (a) {
	return {$: 341, a: a};
};
var $author$project$Spa$Generated$Pages$PracticeSetup__Plans__Id_String__Edit__Msg = function (a) {
	return {$: 341, a: a};
};
var $author$project$Spa$Generated$Pages$PracticeSetup__Plans__Model = function (a) {
	return {$: 99, a: a};
};
var $author$project$Spa$Generated$Pages$PracticeSetup__Plans__Msg = function (a) {
	return {$: 99, a: a};
};
var $author$project$Spa$Generated$Pages$PracticeSetup__Plans__New__Model = function (a) {
	return {$: 281, a: a};
};
var $author$project$Spa$Generated$Pages$PracticeSetup__Plans__New__Msg = function (a) {
	return {$: 281, a: a};
};
var $author$project$Spa$Generated$Pages$PracticeSetup__Team__Model = function (a) {
	return {$: 100, a: a};
};
var $author$project$Spa$Generated$Pages$PracticeSetup__Team__Msg = function (a) {
	return {$: 100, a: a};
};
var $author$project$Spa$Generated$Pages$PracticeSetup__Top__Model = function (a) {
	return {$: 18, a: a};
};
var $author$project$Spa$Generated$Pages$PracticeSetup__Top__Msg = function (a) {
	return {$: 18, a: a};
};
var $author$project$Spa$Generated$Pages$RefillRequests__Model = function (a) {
	return {$: 11, a: a};
};
var $author$project$Spa$Generated$Pages$RefillRequests__Msg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__AncillaryCharges__Id_String__Model = function (a) {
	return {$: 306, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__AncillaryCharges__Id_String__Msg = function (a) {
	return {$: 306, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__AncillaryCharges__Top__Model = function (a) {
	return {$: 205, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__AncillaryCharges__Top__Msg = function (a) {
	return {$: 205, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__CompanyInvoices__Model = function (a) {
	return {$: 101, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__CompanyInvoices__Msg = function (a) {
	return {$: 101, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__CreditOutstanding__Model = function (a) {
	return {$: 102, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__CreditOutstanding__Msg = function (a) {
	return {$: 102, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__CreditOutstanding__Summary__Model = function (a) {
	return {$: 282, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__CreditOutstanding__Summary__Msg = function (a) {
	return {$: 282, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__CreditTransactions__Model = function (a) {
	return {$: 103, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__CreditTransactions__Msg = function (a) {
	return {$: 103, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__CreditTransactions__Summary__Model = function (a) {
	return {$: 283, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__CreditTransactions__Summary__Msg = function (a) {
	return {$: 283, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__Custom__Id_String__Model = function (a) {
	return {$: 307, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__Custom__Id_String__Msg = function (a) {
	return {$: 307, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__Custom__New__Model = function (a) {
	return {$: 284, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__Custom__New__Msg = function (a) {
	return {$: 284, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__Dashboard__Model = function (a) {
	return {$: 104, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__Dashboard__Msg = function (a) {
	return {$: 104, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__DeferredRevenue__Model = function (a) {
	return {$: 105, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__DeferredRevenue__Msg = function (a) {
	return {$: 105, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__DeferredRevenue__Summary__Model = function (a) {
	return {$: 285, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__DeferredRevenue__Summary__Msg = function (a) {
	return {$: 285, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__Deposits__Model = function (a) {
	return {$: 106, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__Deposits__Msg = function (a) {
	return {$: 106, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__Disputes__Model = function (a) {
	return {$: 107, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__Disputes__Msg = function (a) {
	return {$: 107, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__Invoices__Model = function (a) {
	return {$: 108, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__Invoices__Msg = function (a) {
	return {$: 108, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__Memberships__Model = function (a) {
	return {$: 109, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__Memberships__Msg = function (a) {
	return {$: 109, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__Months__Model = function (a) {
	return {$: 110, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__Months__Msg = function (a) {
	return {$: 110, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__PatientPackages__Model = function (a) {
	return {$: 111, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__PatientPackages__Msg = function (a) {
	return {$: 111, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__PaymentApplications__Model = function (a) {
	return {$: 112, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__PaymentApplications__Msg = function (a) {
	return {$: 112, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__PaymentApplications__Summary__Model = function (a) {
	return {$: 286, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__PaymentApplications__Summary__Msg = function (a) {
	return {$: 286, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__Revenue__Model = function (a) {
	return {$: 113, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__Revenue__Msg = function (a) {
	return {$: 113, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__Revenue__Summary__Model = function (a) {
	return {$: 287, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__Revenue__Summary__Msg = function (a) {
	return {$: 287, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__SalesTax__Model = function (a) {
	return {$: 114, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__SalesTax__Msg = function (a) {
	return {$: 114, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__SalesTax__Summary__Model = function (a) {
	return {$: 288, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__SalesTax__Summary__Msg = function (a) {
	return {$: 288, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__SignupAttempts__Model = function (a) {
	return {$: 115, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__SignupAttempts__Msg = function (a) {
	return {$: 115, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__ActivityIndicators__Model = function (a) {
	return {$: 116, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__ActivityIndicators__Msg = function (a) {
	return {$: 116, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__AddressInput__Model = function (a) {
	return {$: 117, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__AddressInput__Msg = function (a) {
	return {$: 117, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Alert__Model = function (a) {
	return {$: 118, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Alert__Msg = function (a) {
	return {$: 118, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Badge__Model = function (a) {
	return {$: 119, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Badge__Msg = function (a) {
	return {$: 119, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Button__Model = function (a) {
	return {$: 120, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Button__Msg = function (a) {
	return {$: 120, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Carousel__Model = function (a) {
	return {$: 121, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Carousel__Msg = function (a) {
	return {$: 121, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Checkbox__Model = function (a) {
	return {$: 122, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Checkbox__Msg = function (a) {
	return {$: 122, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__CurrencyInput__Model = function (a) {
	return {$: 123, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__CurrencyInput__Msg = function (a) {
	return {$: 123, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__DateInput__Model = function (a) {
	return {$: 124, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__DateInput__Msg = function (a) {
	return {$: 124, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__DateRangeInput__Model = function (a) {
	return {$: 125, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__DateRangeInput__Msg = function (a) {
	return {$: 125, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__DragDrop__Model = function (a) {
	return {$: 126, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__DragDrop__Msg = function (a) {
	return {$: 126, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Dropdown__Model = function (a) {
	return {$: 127, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Dropdown__Msg = function (a) {
	return {$: 127, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Element__Model = function (a) {
	return {$: 128, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Element__Msg = function (a) {
	return {$: 128, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__ExportCsv__Model = function (a) {
	return {$: 129, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__ExportCsv__Msg = function (a) {
	return {$: 129, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__FileInput__Model = function (a) {
	return {$: 130, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__FileInput__Msg = function (a) {
	return {$: 130, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__FlyoutMenu__Model = function (a) {
	return {$: 131, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__FlyoutMenu__Msg = function (a) {
	return {$: 131, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__FormExample__Model = function (a) {
	return {$: 132, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__FormExample__Msg = function (a) {
	return {$: 132, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__FormGroup__Model = function (a) {
	return {$: 133, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__FormGroup__Msg = function (a) {
	return {$: 133, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__FormStatic__Model = function (a) {
	return {$: 134, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__FormStatic__Msg = function (a) {
	return {$: 134, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Grid__Model = function (a) {
	return {$: 135, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Grid__Msg = function (a) {
	return {$: 135, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__HiConfirm__Model = function (a) {
	return {$: 136, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__HiConfirm__Msg = function (a) {
	return {$: 136, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__HorizontalRule__Model = function (a) {
	return {$: 137, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__HorizontalRule__Msg = function (a) {
	return {$: 137, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Icon__Model = function (a) {
	return {$: 138, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Icon__Msg = function (a) {
	return {$: 138, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Input__Model = function (a) {
	return {$: 139, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Input__Msg = function (a) {
	return {$: 139, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Link__Model = function (a) {
	return {$: 140, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Link__Msg = function (a) {
	return {$: 140, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__ListGroup__Model = function (a) {
	return {$: 141, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__ListGroup__Msg = function (a) {
	return {$: 141, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Modal__Model = function (a) {
	return {$: 142, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Modal__Msg = function (a) {
	return {$: 142, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__OrderedList__Model = function (a) {
	return {$: 143, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__OrderedList__Msg = function (a) {
	return {$: 143, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Pagination__Model = function (a) {
	return {$: 144, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Pagination__Msg = function (a) {
	return {$: 144, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Panel__Model = function (a) {
	return {$: 145, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Panel__Msg = function (a) {
	return {$: 145, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__PasswordInput__Model = function (a) {
	return {$: 146, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__PasswordInput__Msg = function (a) {
	return {$: 146, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__PaymentSourceDisplayer__Model = function (a) {
	return {$: 147, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__PaymentSourceDisplayer__Msg = function (a) {
	return {$: 147, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__PhoneInput__Model = function (a) {
	return {$: 148, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__PhoneInput__Msg = function (a) {
	return {$: 148, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Popover__Model = function (a) {
	return {$: 149, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Popover__Msg = function (a) {
	return {$: 149, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Pre__Model = function (a) {
	return {$: 150, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Pre__Msg = function (a) {
	return {$: 150, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__ProgressBar__Model = function (a) {
	return {$: 151, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__ProgressBar__Msg = function (a) {
	return {$: 151, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Radio__Model = function (a) {
	return {$: 152, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Radio__Msg = function (a) {
	return {$: 152, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__ResourceFilter__Model = function (a) {
	return {$: 153, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__ResourceFilter__Msg = function (a) {
	return {$: 153, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__SearchInput__Model = function (a) {
	return {$: 154, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__SearchInput__Msg = function (a) {
	return {$: 154, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Select__Model = function (a) {
	return {$: 155, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Select__Msg = function (a) {
	return {$: 155, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Skeleton__Model = function (a) {
	return {$: 156, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Skeleton__Msg = function (a) {
	return {$: 156, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Spinner__Model = function (a) {
	return {$: 157, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Spinner__Msg = function (a) {
	return {$: 157, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Table__Model = function (a) {
	return {$: 158, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Table__Msg = function (a) {
	return {$: 158, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Toast__Model = function (a) {
	return {$: 159, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Toast__Msg = function (a) {
	return {$: 159, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__ToggleSwitch__Model = function (a) {
	return {$: 160, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__ToggleSwitch__Msg = function (a) {
	return {$: 160, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Tooltip__Model = function (a) {
	return {$: 161, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Tooltip__Msg = function (a) {
	return {$: 161, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Top__Model = function (a) {
	return {$: 19, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Top__Msg = function (a) {
	return {$: 19, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Typography__Model = function (a) {
	return {$: 162, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Typography__Msg = function (a) {
	return {$: 162, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__UploadForm__Model = function (a) {
	return {$: 163, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__UploadForm__Msg = function (a) {
	return {$: 163, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__UploadResult__Model = function (a) {
	return {$: 164, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__UploadResult__Msg = function (a) {
	return {$: 164, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Well__Model = function (a) {
	return {$: 165, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Well__Msg = function (a) {
	return {$: 165, a: a};
};
var $author$project$Spa$Generated$Pages$Support__CannySso__Model = function (a) {
	return {$: 166, a: a};
};
var $author$project$Spa$Generated$Pages$Support__CannySso__Msg = function (a) {
	return {$: 166, a: a};
};
var $author$project$Spa$Generated$Pages$Tasks__New__Model = function (a) {
	return {$: 167, a: a};
};
var $author$project$Spa$Generated$Pages$Tasks__New__Msg = function (a) {
	return {$: 167, a: a};
};
var $author$project$Spa$Generated$Pages$Tasks__TasksId_String__Top__Model = function (a) {
	return {$: 206, a: a};
};
var $author$project$Spa$Generated$Pages$Tasks__TasksId_String__Top__Msg = function (a) {
	return {$: 206, a: a};
};
var $author$project$Spa$Generated$Pages$Tasks__Top__Model = function (a) {
	return {$: 20, a: a};
};
var $author$project$Spa$Generated$Pages$Tasks__Top__Msg = function (a) {
	return {$: 20, a: a};
};
var $author$project$Spa$Generated$Pages$Top__Model = function (a) {
	return {$: 0, a: a};
};
var $author$project$Spa$Generated$Pages$Top__Msg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Spa$Generated$Pages$User__AcceptTerms__Model = function (a) {
	return {$: 168, a: a};
};
var $author$project$Spa$Generated$Pages$User__AcceptTerms__Msg = function (a) {
	return {$: 168, a: a};
};
var $author$project$Spa$Generated$Pages$User__Mfa__Model = function (a) {
	return {$: 169, a: a};
};
var $author$project$Spa$Generated$Pages$User__Mfa__Msg = function (a) {
	return {$: 169, a: a};
};
var $author$project$Spa$Generated$Pages$User__Organizations__Top__Model = function (a) {
	return {$: 207, a: a};
};
var $author$project$Spa$Generated$Pages$User__Organizations__Top__Msg = function (a) {
	return {$: 207, a: a};
};
var $author$project$Spa$Generated$Pages$User__Profile__Model = function (a) {
	return {$: 170, a: a};
};
var $author$project$Spa$Generated$Pages$User__Profile__Msg = function (a) {
	return {$: 170, a: a};
};
var $author$project$Spa$Generated$Pages$User__Security__Model = function (a) {
	return {$: 171, a: a};
};
var $author$project$Spa$Generated$Pages$User__Security__Msg = function (a) {
	return {$: 171, a: a};
};
var $author$project$Spa$Page$SessionFailed = {$: 2};
var $author$project$Spa$Page$SessionLoaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Spa$Page$SessionLoading = function (a) {
	return {$: 0, a: a};
};
var $author$project$Permission$User = 7;
var $author$project$Permission$Company__Account = 19;
var $author$project$Permission$Company__AffiliatesPricing = 24;
var $author$project$Permission$Company__Employees = 20;
var $author$project$Permission$Company__Invoice = 21;
var $author$project$Permission$Company__Invoices = 22;
var $author$project$Permission$Company__One = 23;
var $author$project$Permission$Company__PaymentSources = 25;
var $author$project$Permission$Company__Signup = 27;
var $author$project$Permission$Company__Uploads = 26;
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $author$project$Permission$companySessionCanGoTo = function (state) {
	var allowedStates = _List_fromArray(
		[19, 20, 21, 22, 23, 24, 25, 26, 27]);
	return A2($elm$core$List$member, state, allowedStates);
};
var $author$project$Api$Platform$User$Shared$isAdmin = function (_v0) {
	var record = _v0;
	return record.Uy;
};
var $author$project$Permission$Admin__Developers__Hinter = 16;
var $author$project$Permission$Hinter__AdminAdminUsersGroup = 14;
var $author$project$Permission$Hinter__AdminAdminUsersGroups = 13;
var $author$project$Permission$Hinter__AdminClonePractice = 9;
var $author$project$Permission$Hinter__AdminDisputes = 12;
var $author$project$Permission$Hinter__AdminFeatureFlags = 15;
var $author$project$Permission$Hinter__AdminNewGroup = 11;
var $author$project$Permission$Hinter__AdminNewPartner = 10;
var $author$project$Permission$Hinter__AdminNewPractice = 8;
var $author$project$Permission$Marketplace__List = 62;
var $author$project$Permission$Marketplace__Slug_String = 63;
var $author$project$Permission$Partner__Billing__Hinter = 35;
var $author$project$Permission$Partner__Hinter = 33;
var $author$project$Permission$Partner__Product__AppBuilder = 42;
var $author$project$Permission$Partner__Product__Hinter = 41;
var $author$project$Permission$onlyHintersStates = _List_fromArray(
	[8, 9, 12, 13, 14, 15, 10, 11, 16, 41, 42, 35, 33, 62, 63]);
var $author$project$Api$Platform$Session$One$organization = function (_v0) {
	var record = _v0;
	return record.Yr;
};
var $author$project$Permission$Partner__ApiKeys = 45;
var $author$project$Permission$Partner__Billing = 39;
var $author$project$Permission$Partner__Billing__Charges = 34;
var $author$project$Permission$Partner__Billing__Deposits = 36;
var $author$project$Permission$Partner__Billing__ServiceFee = 37;
var $author$project$Permission$Partner__Billing__Subscriptions = 38;
var $author$project$Permission$Partner__Practices = 47;
var $author$project$Permission$Partner__Product = 32;
var $author$project$Permission$Partner__Product_AppSettings = 48;
var $author$project$Permission$Partner__Product__ActivationSettings = 40;
var $author$project$Permission$Partner__Product__New = 44;
var $author$project$Permission$Partner__Products = 43;
var $author$project$Permission$Partner__Sandboxes = 49;
var $author$project$Permission$Partner__Team = 31;
var $author$project$Permission$Partner__Webhooks = 46;
var $author$project$Permission$partnerSessionCanGoTo = function (state) {
	var allowedStates = _List_fromArray(
		[31, 32, 33, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 34, 35, 36, 37, 38, 39, 63]);
	return A2($elm$core$List$member, state, allowedStates);
};
var $author$project$Permission$Admin__PaymentProcessing = 3;
var $author$project$Permission$Admin__Stripe = 6;
var $author$project$Permission$Onboarding = 57;
var $author$project$Permission$PracticeIsOnboarding = 58;
var $author$project$Api$Common$PermissionSet$Shared$enabled = function (_v0) {
	var record = _v0;
	return record.Ro;
};
var $author$project$Api$Platform$Session$One$permissionSets = function (_v0) {
	var record = _v0;
	return record.Zv;
};
var $author$project$Permission$enabledPermissionSetsFor = function (session) {
	return A2(
		$elm$core$List$filter,
		$author$project$Api$Common$PermissionSet$Shared$enabled,
		$author$project$Api$Platform$Session$One$permissionSets(session));
};
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Api$Common$PermissionSet$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Platform$Organization$Shared$practiceIsOnboarding = function (_v0) {
	var record = _v0.b;
	return record.ZX;
};
var $author$project$Permission$patientsPermission = {Bq: 'view_patients'};
var $author$project$Permission$requiredPermissionSetFor = function (state) {
	switch (state) {
		case 50:
			return $elm$core$Maybe$Just($author$project$Permission$patientsPermission);
		case 51:
			return $elm$core$Maybe$Just(
				{Bq: 'view_reports'});
		case 17:
			return $elm$core$Maybe$Just(
				{Bq: 'manage_employers'});
		case 0:
			return $elm$core$Maybe$Just(
				{Bq: 'change_admin_settings'});
		case 52:
			return $elm$core$Maybe$Just(
				{Bq: 'manage_commissions'});
		case 1:
			return $elm$core$Maybe$Just(
				{Bq: 'practice_billing_only'});
		case 2:
			return $elm$core$Maybe$Just(
				{Bq: 'practice_billing_only'});
		case 3:
			return $elm$core$Maybe$Just(
				{Bq: 'practice_billing_only'});
		case 4:
			return $elm$core$Maybe$Just(
				{Bq: 'practice_billing_only'});
		case 5:
			return $elm$core$Maybe$Just(
				{Bq: 'practice_billing_only'});
		case 6:
			return $elm$core$Maybe$Just(
				{Bq: 'change_admin_settings'});
		case 54:
			return $elm$core$Maybe$Just(
				{Bq: 'revise_invoices'});
		case 56:
			return $elm$core$Maybe$Just(
				{Bq: 'manage_networks'});
		case 55:
			return $elm$core$Maybe$Just(
				{Bq: 'issue_refunds'});
		case 7:
			return $elm$core$Maybe$Nothing;
		case 8:
			return $elm$core$Maybe$Nothing;
		case 9:
			return $elm$core$Maybe$Nothing;
		case 10:
			return $elm$core$Maybe$Nothing;
		case 11:
			return $elm$core$Maybe$Nothing;
		case 12:
			return $elm$core$Maybe$Nothing;
		case 13:
			return $elm$core$Maybe$Nothing;
		case 14:
			return $elm$core$Maybe$Nothing;
		case 15:
			return $elm$core$Maybe$Nothing;
		case 16:
			return $elm$core$Maybe$Nothing;
		case 18:
			return $elm$core$Maybe$Nothing;
		case 19:
			return $elm$core$Maybe$Nothing;
		case 20:
			return $elm$core$Maybe$Nothing;
		case 21:
			return $elm$core$Maybe$Nothing;
		case 22:
			return $elm$core$Maybe$Nothing;
		case 23:
			return $elm$core$Maybe$Nothing;
		case 24:
			return $elm$core$Maybe$Nothing;
		case 25:
			return $elm$core$Maybe$Nothing;
		case 26:
			return $elm$core$Maybe$Nothing;
		case 27:
			return $elm$core$Maybe$Nothing;
		case 28:
			return $elm$core$Maybe$Nothing;
		case 29:
			return $elm$core$Maybe$Nothing;
		case 30:
			return $elm$core$Maybe$Nothing;
		case 53:
			return $elm$core$Maybe$Nothing;
		case 57:
			return $elm$core$Maybe$Nothing;
		case 58:
			return $elm$core$Maybe$Nothing;
		case 59:
			return $elm$core$Maybe$Nothing;
		case 60:
			return $elm$core$Maybe$Nothing;
		case 31:
			return $elm$core$Maybe$Nothing;
		case 32:
			return $elm$core$Maybe$Nothing;
		case 33:
			return $elm$core$Maybe$Nothing;
		case 40:
			return $elm$core$Maybe$Nothing;
		case 41:
			return $elm$core$Maybe$Nothing;
		case 42:
			return $elm$core$Maybe$Nothing;
		case 43:
			return $elm$core$Maybe$Nothing;
		case 44:
			return $elm$core$Maybe$Nothing;
		case 45:
			return $elm$core$Maybe$Nothing;
		case 46:
			return $elm$core$Maybe$Nothing;
		case 47:
			return $elm$core$Maybe$Nothing;
		case 48:
			return $elm$core$Maybe$Nothing;
		case 49:
			return $elm$core$Maybe$Nothing;
		case 34:
			return $elm$core$Maybe$Nothing;
		case 35:
			return $elm$core$Maybe$Nothing;
		case 36:
			return $elm$core$Maybe$Nothing;
		case 37:
			return $elm$core$Maybe$Nothing;
		case 38:
			return $elm$core$Maybe$Nothing;
		case 39:
			return $elm$core$Maybe$Nothing;
		case 61:
			return $elm$core$Maybe$Nothing;
		case 62:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Platform$Organization$Shared$requiresPaymentInformation = function (_v0) {
	var record = _v0.b;
	return record.$L;
};
var $author$project$Permission$Admin = 0;
var $author$project$Permission$Bookkeeping = 59;
var $author$project$Permission$BrokerAccounts = 53;
var $author$project$Permission$ClinicalApp = 61;
var $author$project$Permission$Commissions = 52;
var $author$project$Permission$Companies = 17;
var $author$project$Permission$Company = 18;
var $author$project$Permission$IssueRefunds = 55;
var $author$project$Permission$Network = 56;
var $author$project$Permission$PartnerApp = 60;
var $author$project$Permission$Patients = 50;
var $author$project$Permission$Reports = 51;
var $author$project$Permission$ReviseInvoices = 54;
var $author$project$Permission$topLevelStateFor = function (state) {
	switch (state) {
		case 50:
			return 50;
		case 51:
			return 51;
		case 0:
			return 0;
		case 52:
			return 52;
		case 53:
			return 53;
		case 1:
			return 0;
		case 2:
			return 0;
		case 3:
			return 0;
		case 4:
			return 0;
		case 5:
			return 0;
		case 6:
			return 0;
		case 16:
			return 0;
		case 54:
			return 54;
		case 56:
			return 56;
		case 55:
			return 55;
		case 7:
			return 7;
		case 8:
			return 7;
		case 9:
			return 7;
		case 10:
			return 7;
		case 11:
			return 7;
		case 12:
			return 7;
		case 13:
			return 7;
		case 14:
			return 7;
		case 15:
			return 7;
		case 17:
			return 17;
		case 18:
			return 18;
		case 19:
			return 18;
		case 20:
			return 18;
		case 21:
			return 18;
		case 22:
			return 18;
		case 23:
			return 18;
		case 24:
			return 18;
		case 25:
			return 18;
		case 26:
			return 18;
		case 27:
			return 18;
		case 28:
			return 18;
		case 29:
			return 18;
		case 30:
			return 18;
		case 57:
			return 57;
		case 58:
			return 58;
		case 59:
			return 59;
		case 60:
			return 60;
		case 31:
			return 47;
		case 32:
			return 47;
		case 33:
			return 33;
		case 40:
			return 32;
		case 41:
			return 32;
		case 42:
			return 32;
		case 43:
			return 47;
		case 44:
			return 32;
		case 45:
			return 47;
		case 46:
			return 47;
		case 47:
			return 47;
		case 48:
			return 48;
		case 49:
			return 49;
		case 34:
			return 39;
		case 35:
			return 39;
		case 36:
			return 39;
		case 37:
			return 39;
		case 38:
			return 39;
		case 39:
			return 39;
		case 61:
			return 61;
		case 62:
			return 62;
		default:
			return 62;
	}
};
var $author$project$Api$Platform$Session$One$user = function (_v0) {
	var record = _v0;
	return record.ad0;
};
var $author$project$Utils$User$viewingAsNonHinter = F2(
	function (session, hinterViewOff) {
		return (!A2($elm$core$Basics$composeR, $author$project$Api$Platform$Session$One$user, $author$project$Api$Platform$User$Shared$isAdmin)(session)) || hinterViewOff;
	});
var $author$project$Permission$practiceSessionCanGoTo = F3(
	function (session, hinterViewOff, state) {
		if (A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Platform$Organization$Shared$requiresPaymentInformation,
				$author$project$Api$Platform$Session$One$organization(session))) && A2($author$project$Utils$User$viewingAsNonHinter, session, hinterViewOff)) {
			return state === 57;
		} else {
			if (function () {
				var practiceIsOnboarding = A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						$author$project$Api$Platform$Organization$Shared$practiceIsOnboarding,
						$author$project$Api$Platform$Session$One$organization(session)));
				return practiceIsOnboarding && A2($author$project$Utils$User$viewingAsNonHinter, session, hinterViewOff);
			}()) {
				return (state === 58) || ((state === 6) || (state === 3));
			} else {
				var topLevelState = $author$project$Permission$topLevelStateFor(state);
				var enabledPermissionSets = $author$project$Permission$enabledPermissionSetsFor(session);
				var currentPermissionSet = function () {
					var _v1 = _Utils_Tuple2(
						$author$project$Permission$requiredPermissionSetFor(state),
						$author$project$Permission$requiredPermissionSetFor(topLevelState));
					if (!_v1.a.$) {
						var permissionSet = _v1.a.a;
						return $elm$core$Maybe$Just(permissionSet);
					} else {
						if (!_v1.b.$) {
							var _v2 = _v1.a;
							var permissionSet = _v1.b.a;
							return $elm$core$Maybe$Just(permissionSet);
						} else {
							var _v3 = _v1.a;
							var _v4 = _v1.b;
							return $elm$core$Maybe$Nothing;
						}
					}
				}();
				if (currentPermissionSet.$ === 1) {
					return !$elm$core$List$isEmpty(enabledPermissionSets);
				} else {
					var currentPermissionSet_ = currentPermissionSet.a;
					return A2(
						$elm$core$List$any,
						function (permissionSet) {
							return _Utils_eq(
								$author$project$Api$Common$PermissionSet$Shared$name(permissionSet),
								currentPermissionSet_.Bq);
						},
						enabledPermissionSets);
				}
			}
		}
	});
var $author$project$Api$Platform$Organization$Min$type_ = function (_v0) {
	var record = _v0;
	return record.amg;
};
var $author$project$Api$Platform$Organization$Shared$type_ = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Platform$Organization$Min$type_(min);
};
var $author$project$Permission$canGoTo = F3(
	function (session, hinterViewOff, state) {
		if (A2($elm$core$Basics$composeR, $author$project$Api$Platform$Session$One$user, $author$project$Api$Platform$User$Shared$isAdmin)(session) && A2($elm$core$List$member, state, $author$project$Permission$onlyHintersStates)) {
			return true;
		} else {
			if (state === 7) {
				return true;
			} else {
				var _v0 = $author$project$Api$Platform$Session$One$organization(session);
				if (_v0.$ === 1) {
					return false;
				} else {
					var organization = _v0.a;
					var _v1 = $author$project$Api$Platform$Organization$Shared$type_(organization);
					switch (_v1) {
						case 1:
							return $author$project$Permission$companySessionCanGoTo(state);
						case 0:
							return A3($author$project$Permission$practiceSessionCanGoTo, session, hinterViewOff, state);
						default:
							return $author$project$Permission$partnerSessionCanGoTo(state);
					}
				}
			}
		}
	});
var $author$project$Permission$Admin__Billing = 1;
var $author$project$Permission$Admin__PaymentMethodImport = 4;
var $author$project$Permission$Admin__PaymentMethodImport__Upload = 5;
var $author$project$Permission$Admin__PaymentSources = 2;
var $author$project$Permission$Company__EndedCommissions = 30;
var $author$project$Permission$Company__Notes = 28;
var $author$project$Permission$Company__Notifications = 29;
var $author$project$Permission$forRoute = function (route) {
	switch (route.$) {
		case 208:
			return $elm$core$Maybe$Just(0);
		case 209:
			return $elm$core$Maybe$Just(0);
		case 210:
			return $elm$core$Maybe$Just(0);
		case 211:
			return $elm$core$Maybe$Just(0);
		case 212:
			return $elm$core$Maybe$Just(0);
		case 176:
			return $elm$core$Maybe$Just(0);
		case 342:
			return $elm$core$Maybe$Just(1);
		case 289:
			return $elm$core$Maybe$Just(0);
		case 213:
			return $elm$core$Maybe$Just(0);
		case 177:
			return $elm$core$Maybe$Just(0);
		case 214:
			return $elm$core$Maybe$Just(0);
		case 290:
			return $elm$core$Maybe$Just(0);
		case 215:
			return $elm$core$Maybe$Just(0);
		case 178:
			return $elm$core$Maybe$Just(0);
		case 291:
			return $elm$core$Maybe$Just(0);
		case 216:
			return $elm$core$Maybe$Just(0);
		case 179:
			return $elm$core$Maybe$Just(0);
		case 217:
			return $elm$core$Maybe$Just(0);
		case 294:
			return $elm$core$Maybe$Just(0);
		case 225:
			return $elm$core$Maybe$Just(0);
		case 182:
			return $elm$core$Maybe$Just(0);
		case 226:
			return $elm$core$Maybe$Just(0);
		case 227:
			return $elm$core$Maybe$Just(0);
		case 228:
			return $elm$core$Maybe$Just(0);
		case 183:
			return $elm$core$Maybe$Just(0);
		case 295:
			return $elm$core$Maybe$Just(0);
		case 229:
			return $elm$core$Maybe$Just(0);
		case 230:
			return $elm$core$Maybe$Just(0);
		case 231:
			return $elm$core$Maybe$Just(0);
		case 232:
			return $elm$core$Maybe$Just(0);
		case 233:
			return $elm$core$Maybe$Just(0);
		case 234:
			return $elm$core$Maybe$Just(0);
		case 321:
			return $elm$core$Maybe$Just(0);
		case 296:
			return $elm$core$Maybe$Just(0);
		case 236:
			return $elm$core$Maybe$Just(0);
		case 184:
			return $elm$core$Maybe$Just(0);
		case 185:
			return $elm$core$Maybe$Just(0);
		case 237:
			return $elm$core$Maybe$Just(0);
		case 51:
			return $elm$core$Maybe$Just(0);
		case 186:
			return $elm$core$Maybe$Just(0);
		case 297:
			return $elm$core$Maybe$Just(0);
		case 238:
			return $elm$core$Maybe$Just(0);
		case 187:
			return $elm$core$Maybe$Just(0);
		case 22:
			return $elm$core$Maybe$Just(0);
		case 23:
			return $elm$core$Maybe$Just(1);
		case 24:
			return $elm$core$Maybe$Just(0);
		case 25:
			return $elm$core$Maybe$Just(0);
		case 26:
			return $elm$core$Maybe$Just(0);
		case 27:
			return $elm$core$Maybe$Just(0);
		case 28:
			return $elm$core$Maybe$Just(0);
		case 29:
			return $elm$core$Maybe$Just(0);
		case 30:
			return $elm$core$Maybe$Just(0);
		case 31:
			return $elm$core$Maybe$Just(0);
		case 33:
			return $elm$core$Maybe$Just(0);
		case 32:
			return $elm$core$Maybe$Just(0);
		case 34:
			return $elm$core$Maybe$Just(0);
		case 35:
			return $elm$core$Maybe$Just(0);
		case 36:
			return $elm$core$Maybe$Just(0);
		case 37:
			return $elm$core$Maybe$Just(0);
		case 38:
			return $elm$core$Maybe$Just(0);
		case 39:
			return $elm$core$Maybe$Just(0);
		case 42:
			return $elm$core$Maybe$Just(2);
		case 41:
			return $elm$core$Maybe$Just(3);
		case 40:
			return $elm$core$Maybe$Just(4);
		case 235:
			return $elm$core$Maybe$Just(5);
		case 43:
			return $elm$core$Maybe$Just(0);
		case 44:
			return $elm$core$Maybe$Just(0);
		case 45:
			return $elm$core$Maybe$Just(0);
		case 46:
			return $elm$core$Maybe$Just(0);
		case 181:
			return $elm$core$Maybe$Just(0);
		case 218:
			return $elm$core$Maybe$Just(0);
		case 293:
			return $elm$core$Maybe$Just(0);
		case 180:
			return $elm$core$Maybe$Just(0);
		case 292:
			return $elm$core$Maybe$Just(0);
		case 219:
			return $elm$core$Maybe$Just(0);
		case 220:
			return $elm$core$Maybe$Just(0);
		case 221:
			return $elm$core$Maybe$Just(0);
		case 224:
			return $elm$core$Maybe$Just(0);
		case 223:
			return $elm$core$Maybe$Just(0);
		case 222:
			return $elm$core$Maybe$Just(16);
		case 47:
			return $elm$core$Maybe$Just(0);
		case 48:
			return $elm$core$Maybe$Just(6);
		case 49:
			return $elm$core$Maybe$Just(0);
		case 50:
			return $elm$core$Maybe$Just(0);
		case 239:
			return $elm$core$Maybe$Just(0);
		case 83:
			return $elm$core$Maybe$Just(61);
		case 84:
			return $elm$core$Maybe$Just(61);
		case 303:
			return $elm$core$Maybe$Just(61);
		case 334:
			return $elm$core$Maybe$Just(61);
		case 335:
			return $elm$core$Maybe$Just(61);
		case 333:
			return $elm$core$Maybe$Just(61);
		case 80:
			return $elm$core$Maybe$Just(61);
		case 79:
			return $elm$core$Maybe$Just(61);
		case 78:
			return $elm$core$Maybe$Just(61);
		case 81:
			return $elm$core$Maybe$Just(61);
		case 2:
			return $elm$core$Maybe$Just(0);
		case 65:
			return $elm$core$Maybe$Just(8);
		case 60:
			return $elm$core$Maybe$Just(9);
		case 64:
			return $elm$core$Maybe$Just(10);
		case 63:
			return $elm$core$Maybe$Just(11);
		case 61:
			return $elm$core$Maybe$Just(12);
		case 62:
			return $elm$core$Maybe$Just(15);
		case 193:
			return $elm$core$Maybe$Just(13);
		case 298:
			return $elm$core$Maybe$Just(14);
		case 170:
			return $elm$core$Maybe$Just(7);
		case 169:
			return $elm$core$Maybe$Just(7);
		case 171:
			return $elm$core$Maybe$Just(7);
		case 207:
			return $elm$core$Maybe$Just(7);
		case 168:
			return $elm$core$Maybe$Just(7);
		case 109:
			return $elm$core$Maybe$Just(51);
		case 111:
			return $elm$core$Maybe$Just(51);
		case 115:
			return $elm$core$Maybe$Just(51);
		case 104:
			return $elm$core$Maybe$Just(51);
		case 110:
			return $elm$core$Maybe$Just(51);
		case 114:
			return $elm$core$Maybe$Just(51);
		case 288:
			return $elm$core$Maybe$Just(51);
		case 205:
			return $elm$core$Maybe$Just(51);
		case 306:
			return $elm$core$Maybe$Just(51);
		case 106:
			return $elm$core$Maybe$Just(51);
		case 101:
			return $elm$core$Maybe$Just(51);
		case 108:
			return $elm$core$Maybe$Just(51);
		case 102:
			return $elm$core$Maybe$Just(51);
		case 282:
			return $elm$core$Maybe$Just(51);
		case 103:
			return $elm$core$Maybe$Just(51);
		case 283:
			return $elm$core$Maybe$Just(51);
		case 112:
			return $elm$core$Maybe$Just(51);
		case 286:
			return $elm$core$Maybe$Just(51);
		case 113:
			return $elm$core$Maybe$Just(51);
		case 287:
			return $elm$core$Maybe$Just(51);
		case 105:
			return $elm$core$Maybe$Just(51);
		case 285:
			return $elm$core$Maybe$Just(51);
		case 307:
			return $elm$core$Maybe$Just(51);
		case 107:
			return $elm$core$Maybe$Just(51);
		case 56:
			return $elm$core$Maybe$Just(17);
		case 14:
			return $elm$core$Maybe$Just(17);
		case 191:
			return $elm$core$Maybe$Just(23);
		case 250:
			return $elm$core$Maybe$Just(30);
		case 248:
			return $elm$core$Maybe$Just(24);
		case 311:
			return $elm$core$Maybe$Just(22);
		case 344:
			return $elm$core$Maybe$Just(22);
		case 252:
			return $elm$core$Maybe$Just(28);
		case 253:
			return $elm$core$Maybe$Just(29);
		case 251:
			return $elm$core$Maybe$Just(0);
		case 310:
			return $elm$core$Maybe$Just(20);
		case 324:
			return $elm$core$Maybe$Just(20);
		case 364:
			return $elm$core$Maybe$Just(20);
		case 254:
			return $elm$core$Maybe$Just(25);
		case 312:
			return $elm$core$Maybe$Just(26);
		case 352:
			return $elm$core$Maybe$Just(26);
		case 249:
			return $elm$core$Maybe$Just(26);
		case 359:
			return $elm$core$Maybe$Just(26);
		case 255:
			return $elm$core$Maybe$Just(27);
		case 325:
			return $elm$core$Maybe$Just(27);
		case 345:
			return $elm$core$Maybe$Just(27);
		case 55:
			return $elm$core$Maybe$Just(52);
		case 190:
			return $elm$core$Maybe$Just(52);
		case 247:
			return $elm$core$Maybe$Just(52);
		case 189:
			return $elm$core$Maybe$Just(52);
		case 246:
			return $elm$core$Maybe$Just(52);
		case 309:
			return $elm$core$Maybe$Just(53);
		case 322:
			return $elm$core$Maybe$Just(53);
		case 323:
			return $elm$core$Maybe$Just(53);
		case 350:
			return $elm$core$Maybe$Just(53);
		case 358:
			return $elm$core$Maybe$Just(53);
		case 363:
			return $elm$core$Maybe$Just(53);
		case 357:
			return $elm$core$Maybe$Just(53);
		case 351:
			return $elm$core$Maybe$Just(53);
		case 361:
			return $elm$core$Maybe$Just(53);
		case 13:
			return $elm$core$Maybe$Just(56);
		case 53:
			return $elm$core$Maybe$Just(56);
		case 52:
			return $elm$core$Maybe$Just(56);
		case 240:
			return $elm$core$Maybe$Just(0);
		case 241:
			return $elm$core$Maybe$Just(56);
		case 308:
			return $elm$core$Maybe$Just(56);
		case 343:
			return $elm$core$Maybe$Just(56);
		case 242:
			return $elm$core$Maybe$Just(56);
		case 244:
			return $elm$core$Maybe$Just(56);
		case 243:
			return $elm$core$Maybe$Just(56);
		case 245:
			return $elm$core$Maybe$Just(56);
		case 12:
			return $elm$core$Maybe$Just(56);
		case 174:
			return $elm$core$Maybe$Nothing;
		case 8:
			return $elm$core$Maybe$Nothing;
		case 85:
			return $elm$core$Maybe$Nothing;
		case 166:
			return $elm$core$Maybe$Nothing;
		case 173:
			return $elm$core$Maybe$Nothing;
		case 7:
			return $elm$core$Maybe$Nothing;
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Nothing;
		case 9:
			return $elm$core$Maybe$Nothing;
		case 17:
			return $elm$core$Maybe$Just(50);
		case 91:
			return $elm$core$Maybe$Just(50);
		case 92:
			return $elm$core$Maybe$Just(50);
		case 188:
			return $elm$core$Maybe$Just(50);
		case 204:
			return $elm$core$Maybe$Just(50);
		case 275:
			return $elm$core$Maybe$Just(50);
		case 279:
			return $elm$core$Maybe$Just(50);
		case 315:
			return $elm$core$Maybe$Just(50);
		case 278:
			return $elm$core$Maybe$Just(50);
		case 353:
			return $elm$core$Maybe$Just(50);
		case 274:
			return $elm$core$Maybe$Just(61);
		case 317:
			return $elm$core$Maybe$Just(50);
		case 354:
			return $elm$core$Maybe$Just(50);
		case 318:
			return $elm$core$Maybe$Just(50);
		case 340:
			return $elm$core$Maybe$Just(50);
		case 355:
			return $elm$core$Maybe$Just(50);
		case 319:
			return $elm$core$Maybe$Just(50);
		case 349:
			return $elm$core$Maybe$Just(61);
		case 276:
			return $elm$core$Maybe$Just(61);
		case 277:
			return $elm$core$Maybe$Just(61);
		case 280:
			return $elm$core$Maybe$Just(61);
		case 316:
			return $elm$core$Maybe$Just(50);
		case 320:
			return $elm$core$Maybe$Just(50);
		case 54:
			return $elm$core$Maybe$Nothing;
		case 10:
			return $elm$core$Maybe$Just(57);
		case 21:
			return $elm$core$Maybe$Nothing;
		case 90:
			return $elm$core$Maybe$Just(31);
		case 305:
			return $elm$core$Maybe$Just(32);
		case 86:
			return $elm$core$Maybe$Just(45);
		case 273:
			return $elm$core$Maybe$Just(46);
		case 272:
			return $elm$core$Maybe$Just(46);
		case 202:
			return $elm$core$Maybe$Just(47);
		case 89:
			return $elm$core$Maybe$Just(33);
		case 266:
			return $elm$core$Maybe$Just(34);
		case 268:
			return $elm$core$Maybe$Just(35);
		case 267:
			return $elm$core$Maybe$Just(36);
		case 269:
			return $elm$core$Maybe$Just(37);
		case 270:
			return $elm$core$Maybe$Just(38);
		case 87:
			return $elm$core$Maybe$Just(39);
		case 336:
			return $elm$core$Maybe$Just(40);
		case 339:
			return $elm$core$Maybe$Just(41);
		case 337:
			return $elm$core$Maybe$Just(42);
		case 201:
			return $elm$core$Maybe$Just(43);
		case 271:
			return $elm$core$Maybe$Just(44);
		case 338:
			return $elm$core$Maybe$Just(48);
		case 203:
			return $elm$core$Maybe$Just(49);
		case 88:
			return $elm$core$Maybe$Just(47);
		case 19:
			return $elm$core$Maybe$Nothing;
		case 152:
			return $elm$core$Maybe$Nothing;
		case 126:
			return $elm$core$Maybe$Nothing;
		case 128:
			return $elm$core$Maybe$Nothing;
		case 116:
			return $elm$core$Maybe$Nothing;
		case 120:
			return $elm$core$Maybe$Nothing;
		case 165:
			return $elm$core$Maybe$Nothing;
		case 137:
			return $elm$core$Maybe$Nothing;
		case 138:
			return $elm$core$Maybe$Nothing;
		case 140:
			return $elm$core$Maybe$Nothing;
		case 158:
			return $elm$core$Maybe$Nothing;
		case 145:
			return $elm$core$Maybe$Nothing;
		case 150:
			return $elm$core$Maybe$Nothing;
		case 160:
			return $elm$core$Maybe$Nothing;
		case 162:
			return $elm$core$Maybe$Nothing;
		case 159:
			return $elm$core$Maybe$Nothing;
		case 118:
			return $elm$core$Maybe$Nothing;
		case 151:
			return $elm$core$Maybe$Nothing;
		case 122:
			return $elm$core$Maybe$Nothing;
		case 139:
			return $elm$core$Maybe$Nothing;
		case 144:
			return $elm$core$Maybe$Nothing;
		case 133:
			return $elm$core$Maybe$Nothing;
		case 132:
			return $elm$core$Maybe$Nothing;
		case 148:
			return $elm$core$Maybe$Nothing;
		case 142:
			return $elm$core$Maybe$Nothing;
		case 143:
			return $elm$core$Maybe$Nothing;
		case 136:
			return $elm$core$Maybe$Nothing;
		case 119:
			return $elm$core$Maybe$Nothing;
		case 161:
			return $elm$core$Maybe$Nothing;
		case 131:
			return $elm$core$Maybe$Nothing;
		case 149:
			return $elm$core$Maybe$Nothing;
		case 129:
			return $elm$core$Maybe$Nothing;
		case 141:
			return $elm$core$Maybe$Nothing;
		case 146:
			return $elm$core$Maybe$Nothing;
		case 134:
			return $elm$core$Maybe$Nothing;
		case 125:
			return $elm$core$Maybe$Nothing;
		case 147:
			return $elm$core$Maybe$Nothing;
		case 164:
			return $elm$core$Maybe$Nothing;
		case 130:
			return $elm$core$Maybe$Nothing;
		case 163:
			return $elm$core$Maybe$Nothing;
		case 153:
			return $elm$core$Maybe$Nothing;
		case 123:
			return $elm$core$Maybe$Nothing;
		case 155:
			return $elm$core$Maybe$Nothing;
		case 124:
			return $elm$core$Maybe$Nothing;
		case 154:
			return $elm$core$Maybe$Nothing;
		case 117:
			return $elm$core$Maybe$Nothing;
		case 135:
			return $elm$core$Maybe$Nothing;
		case 156:
			return $elm$core$Maybe$Nothing;
		case 157:
			return $elm$core$Maybe$Nothing;
		case 200:
			return $elm$core$Maybe$Nothing;
		case 264:
			return $elm$core$Maybe$Nothing;
		case 265:
			return $elm$core$Maybe$Nothing;
		case 263:
			return $elm$core$Maybe$Nothing;
		case 262:
			return $elm$core$Maybe$Nothing;
		case 18:
			return $elm$core$Maybe$Just(58);
		case 93:
			return $elm$core$Maybe$Just(58);
		case 99:
			return $elm$core$Maybe$Just(58);
		case 281:
			return $elm$core$Maybe$Just(58);
		case 341:
			return $elm$core$Maybe$Just(58);
		case 96:
			return $elm$core$Maybe$Just(58);
		case 98:
			return $elm$core$Maybe$Just(58);
		case 95:
			return $elm$core$Maybe$Just(58);
		case 100:
			return $elm$core$Maybe$Just(58);
		case 94:
			return $elm$core$Maybe$Just(58);
		case 97:
			return $elm$core$Maybe$Just(58);
		case 284:
			return $elm$core$Maybe$Just(0);
		case 127:
			return $elm$core$Maybe$Nothing;
		case 121:
			return $elm$core$Maybe$Nothing;
		case 356:
			return $elm$core$Maybe$Just(0);
		case 360:
			return $elm$core$Maybe$Just(0);
		case 172:
			return $elm$core$Maybe$Just(60);
		case 16:
			return $elm$core$Maybe$Just(62);
		case 175:
			return $elm$core$Maybe$Just(63);
		case 330:
			return $elm$core$Maybe$Just(0);
		case 332:
			return $elm$core$Maybe$Just(0);
		case 331:
			return $elm$core$Maybe$Just(0);
		case 327:
			return $elm$core$Maybe$Just(0);
		case 329:
			return $elm$core$Maybe$Just(0);
		case 328:
			return $elm$core$Maybe$Just(0);
		case 326:
			return $elm$core$Maybe$Just(0);
		case 69:
			return $elm$core$Maybe$Just(0);
		case 5:
			return $elm$core$Maybe$Just(61);
		case 3:
			return $elm$core$Maybe$Just(61);
		case 6:
			return $elm$core$Maybe$Just(61);
		case 57:
			return $elm$core$Maybe$Just(61);
		case 58:
			return $elm$core$Maybe$Just(61);
		case 192:
			return $elm$core$Maybe$Just(61);
		case 15:
			return $elm$core$Maybe$Just(61);
		case 59:
			return $elm$core$Maybe$Just(61);
		case 4:
			return $elm$core$Maybe$Just(61);
		case 66:
			return $elm$core$Maybe$Just(61);
		case 67:
			return $elm$core$Maybe$Just(61);
		case 194:
			return $elm$core$Maybe$Just(61);
		case 68:
			return $elm$core$Maybe$Just(61);
		case 77:
			return $elm$core$Maybe$Just(61);
		case 300:
			return $elm$core$Maybe$Just(61);
		case 346:
			return $elm$core$Maybe$Just(61);
		case 362:
			return $elm$core$Maybe$Just(61);
		case 71:
			return $elm$core$Maybe$Just(61);
		case 70:
			return $elm$core$Maybe$Just(61);
		case 76:
			return $elm$core$Maybe$Just(61);
		case 75:
			return $elm$core$Maybe$Just(61);
		case 74:
			return $elm$core$Maybe$Just(61);
		case 195:
			return $elm$core$Maybe$Just(61);
		case 257:
			return $elm$core$Maybe$Just(61);
		case 299:
			return $elm$core$Maybe$Just(61);
		case 256:
			return $elm$core$Maybe$Just(61);
		case 347:
			return $elm$core$Maybe$Just(61);
		case 73:
			return $elm$core$Maybe$Just(61);
		case 72:
			return $elm$core$Maybe$Just(61);
		case 196:
			return $elm$core$Maybe$Just(61);
		case 258:
			return $elm$core$Maybe$Just(61);
		case 313:
			return $elm$core$Maybe$Just(61);
		case 259:
			return $elm$core$Maybe$Just(61);
		case 314:
			return $elm$core$Maybe$Just(61);
		case 20:
			return $elm$core$Maybe$Just(61);
		case 167:
			return $elm$core$Maybe$Just(61);
		case 206:
			return $elm$core$Maybe$Just(61);
		case 198:
			return $elm$core$Maybe$Just(61);
		case 302:
			return $elm$core$Maybe$Just(61);
		case 348:
			return $elm$core$Maybe$Just(61);
		case 197:
			return $elm$core$Maybe$Just(61);
		case 260:
			return $elm$core$Maybe$Just(61);
		case 301:
			return $elm$core$Maybe$Just(61);
		case 199:
			return $elm$core$Maybe$Just(61);
		case 261:
			return $elm$core$Maybe$Just(61);
		case 304:
			return $elm$core$Maybe$Just(61);
		case 82:
			return $elm$core$Maybe$Just(61);
		default:
			return $elm$core$Maybe$Just(61);
	}
};
var $author$project$Api$Platform$Session$One$deferCredentialsToUser = function (_v0) {
	var record = _v0;
	return record.Qh;
};
var $author$project$Permission$homeStateMappingFor = function (role) {
	switch (role) {
		case 'practice_admin':
			return $author$project$Spa$Generated$Route$Patients__Top;
		case 'practice_manager':
			return $author$project$Spa$Generated$Route$Patients__Top;
		case 'practice_staff':
			return $author$project$Spa$Generated$Route$Patients__Top;
		case 'practice_staff_limited':
			return $author$project$Spa$Generated$Route$Patients__Top;
		case 'practice_reports_only':
			return $author$project$Spa$Generated$Route$Reports__Dashboard;
		case 'practice_read_only':
			return $author$project$Spa$Generated$Route$Patients__Top;
		case 'practice_practice_billing_only':
			return $author$project$Spa$Generated$Route$Admin__Billing;
		default:
			return $author$project$Spa$Generated$Route$Patients__Top;
	}
};
var $author$project$Api$Platform$Organization$Min$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Platform$Organization$Shared$id = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Platform$Organization$Min$id(min);
};
var $author$project$Api$Platform$User$Shared$requiresMfa = function (_v0) {
	var record = _v0;
	return record.$H;
};
var $author$project$Api$Platform$Session$One$role = function (_v0) {
	var record = _v0;
	return record.ak3;
};
var $author$project$Permission$homeStateFor = F2(
	function (session, hinterViewOff) {
		if ($author$project$Api$Platform$Session$One$deferCredentialsToUser(session)) {
			return $author$project$Spa$Generated$Route$Account__Complete;
		} else {
			var _v0 = $author$project$Api$Platform$Session$One$organization(session);
			if (_v0.$ === 1) {
				var requiresMfa = $author$project$Api$Platform$User$Shared$requiresMfa(
					$author$project$Api$Platform$Session$One$user(session));
				return requiresMfa ? $author$project$Spa$Generated$Route$User__Mfa : $author$project$Spa$Generated$Route$User__Profile;
			} else {
				var organization = _v0.a;
				var _v1 = $author$project$Api$Platform$Organization$Shared$type_(organization);
				switch (_v1) {
					case 0:
						return ($author$project$Api$Platform$Organization$Shared$requiresPaymentInformation(organization) && A2($author$project$Utils$User$viewingAsNonHinter, session, hinterViewOff)) ? $author$project$Spa$Generated$Route$Onboarding : ($author$project$Api$Platform$Organization$Shared$practiceIsOnboarding(organization) ? $author$project$Spa$Generated$Route$Patients__Top : $author$project$Permission$homeStateMappingFor(
							$author$project$Api$Platform$Session$One$role(session)));
					case 1:
						return $author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top(
							{
								fZ: $author$project$Api$Platform$Organization$Shared$id(organization)
							});
					default:
						return $author$project$Spa$Generated$Route$Partner__Dashboard__Top;
				}
			}
		}
	});
var $author$project$Permission$authorizeRoute = F3(
	function (session, hinterViewOff, route) {
		var code = $author$project$Permission$forRoute(route);
		return A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				A2($author$project$Permission$canGoTo, session, hinterViewOff),
				code)) || _Utils_eq(
			A2($author$project$Permission$homeStateFor, session, hinterViewOff),
			route);
	});
var $author$project$Spa$Page$authorizeUrl = F3(
	function (session, hinterViewOff, url) {
		return A3(
			$author$project$Permission$authorizeRoute,
			session,
			hinterViewOff,
			$author$project$Utils$Route$fromUrl(url));
	});
var $author$project$Utils$Tuple3$fromTuple2 = F2(
	function (third_, _v0) {
		var first_ = _v0.a;
		var second_ = _v0.b;
		return _Utils_Tuple3(first_, second_, third_);
	});
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $author$project$Utils$Tuple3$mapFirst = F2(
	function (mapFunc, _v0) {
		var first_ = _v0.a;
		var second_ = _v0.b;
		var third_ = _v0.c;
		return _Utils_Tuple3(
			mapFunc(first_),
			second_,
			third_);
	});
var $elm$url$Url$Builder$QueryParameter = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $elm$url$Url$Builder$string = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$url$Url$percentEncode(value));
	});
var $author$project$Utils$Route$toString = F2(
	function (params, route) {
		var queryString = $elm$url$Url$Builder$toQuery(
			A2(
				$elm$core$List$map,
				function (_v0) {
					var k = _v0.a;
					var v = _v0.b;
					return A2($elm$url$Url$Builder$string, k, v);
				},
				$elm$core$Dict$toList(params)));
		return _Utils_ap(
			$author$project$Spa$Generated$Route$toString(route),
			queryString);
	});
var $author$project$Utils$Route$navigate = F2(
	function (params, route) {
		return $author$project$Ports$Navigation$pushUrl(
			A2($author$project$Utils$Route$toString, params, route));
	});
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $author$project$Components$BlankPage$view = _List_Nil;
var $author$project$Spa$Page$applicationPractice = function (page) {
	return {
		ah_: F2(
			function (shared, url) {
				var _v0 = _Utils_Tuple2(shared.aa4, shared.ZV);
				_v0$3:
				while (true) {
					_v0$5:
					while (true) {
						switch (_v0.a.$) {
							case 3:
								switch (_v0.b.$) {
									case 3:
										if (!_v0.b.a.$) {
											var _v1 = _v0.a;
											var session = _v1.a;
											var _v2 = _v0.b;
											var practice = _v2.a.a;
											return (!A3($author$project$Spa$Page$authorizeUrl, session, shared.ahK, shared.adY)) ? _Utils_Tuple3(
												$author$project$Spa$Page$SessionLoading(url),
												A2(
													$author$project$Utils$Route$navigate,
													$elm$core$Dict$empty,
													A2($author$project$Permission$homeStateFor, session, shared.ahK)),
												_List_Nil) : A2(
												$author$project$Utils$Tuple3$mapFirst,
												$author$project$Spa$Page$SessionLoaded,
												A2(
													$author$project$Utils$Tuple3$fromTuple2,
													_List_Nil,
													A4(page.ah_, session, practice, shared, url)));
										} else {
											var _v3 = _v0.a;
											var session = _v3.a;
											var _v4 = _v0.b;
											return _Utils_Tuple3(
												$author$project$Spa$Page$SessionLoading(url),
												A2(
													$author$project$Utils$Route$navigate,
													$elm$core$Dict$empty,
													A2($author$project$Permission$homeStateFor, session, shared.ahK)),
												_List_Nil);
										}
									case 2:
										break _v0$3;
									default:
										break _v0$5;
								}
							case 2:
								return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
							case 0:
								if (_v0.b.$ === 2) {
									break _v0$3;
								} else {
									var _v5 = _v0.a;
									return _Utils_Tuple3(
										$author$project$Spa$Page$SessionLoading(url),
										$author$project$Ports$Session$authorize(
											{aku: true}),
										_List_Nil);
								}
							default:
								if (_v0.b.$ === 2) {
									break _v0$3;
								} else {
									break _v0$5;
								}
						}
					}
					return _Utils_Tuple3(
						$author$project$Spa$Page$SessionLoading(url),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
				return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
			}),
		aiq: F2(
			function (shared, model) {
				var _v6 = _Utils_Tuple3(shared.aa4, shared.ZV, model);
				_v6$1:
				while (true) {
					_v6$3:
					while (true) {
						_v6$4:
						while (true) {
							if (!_v6.c.$) {
								switch (_v6.a.$) {
									case 3:
										switch (_v6.b.$) {
											case 3:
												if (!_v6.b.a.$) {
													var _v7 = _v6.a;
													var session = _v7.a;
													var _v8 = _v6.b;
													var practice = _v8.a.a;
													var url = _v6.c.a;
													if (!A3($author$project$Spa$Page$authorizeUrl, session, shared.ahK, shared.adY)) {
														return _Utils_Tuple3(
															$author$project$Spa$Page$SessionLoading(url),
															A2(
																$author$project$Utils$Route$navigate,
																$elm$core$Dict$empty,
																A2($author$project$Permission$homeStateFor, session, shared.ahK)),
															_List_Nil);
													} else {
														var _v9 = A4(page.ah_, session, practice, shared, url);
														var pageModel = _v9.a;
														var cmd = _v9.b;
														return _Utils_Tuple3(
															$author$project$Spa$Page$SessionLoaded(pageModel),
															cmd,
															_List_Nil);
													}
												} else {
													break _v6$1;
												}
											case 2:
												break _v6$3;
											default:
												break _v6$4;
										}
									case 2:
										return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
									default:
										if (_v6.b.$ === 2) {
											break _v6$3;
										} else {
											break _v6$4;
										}
								}
							} else {
								if (((_v6.a.$ === 3) && (_v6.b.$ === 3)) && (_v6.b.a.$ === 1)) {
									break _v6$1;
								} else {
									break _v6$4;
								}
							}
						}
						if (model.$ === 1) {
							var modelWithSession = model.a;
							return A2(
								$author$project$Utils$Tuple3$fromTuple2,
								_List_Nil,
								A2(
									$elm$core$Tuple$mapFirst,
									$author$project$Spa$Page$SessionLoaded,
									A2(
										page.aiq,
										shared,
										_Utils_update(
											modelWithSession,
											{Gv: shared.Gv}))));
						} else {
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
						}
					}
					return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
				}
				var _v10 = _v6.a;
				var session = _v10.a;
				var _v11 = _v6.b;
				return _Utils_Tuple3(
					model,
					A2(
						$author$project$Utils$Route$navigate,
						$elm$core$Dict$empty,
						A2($author$project$Permission$homeStateFor, session, shared.ahK)),
					_List_Nil);
			}),
		k8: F2(
			function (model, shared) {
				if (model.$ === 1) {
					var modelWithSession = model.a;
					return A2(page.k8, modelWithSession, shared);
				} else {
					return shared;
				}
			}),
		alO: function (model) {
			if (model.$ === 1) {
				var modelWithSession = model.a;
				return page.alO(modelWithSession);
			} else {
				return $elm$core$Platform$Sub$none;
			}
		},
		adT: F2(
			function (msg, model) {
				if (model.$ === 1) {
					var modelWithSession = model.a;
					return A2(
						$author$project$Utils$Tuple3$mapFirst,
						$author$project$Spa$Page$SessionLoaded,
						A2(page.adT, msg, modelWithSession));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			}),
		amo: function (model) {
			if (model.$ === 1) {
				var modelWithSession = model.a;
				return page.amo(modelWithSession);
			} else {
				return {fO: $author$project$Components$BlankPage$view, ac9: 'Loading...'};
			}
		}
	};
};
var $author$project$Pages$Account$Complete$CredentialsMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$ProviderCredentials$DeaStateDropdownMsg = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$ProviderCredentials$Model = $elm$core$Basics$identity;
var $author$project$Components$ProviderCredentials$MultiDeaExpirationMsg = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$ProviderCredentials$StateLicenseExpirationMsg = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$ProviderCredentials$StateLicenseStateDropdownMsg = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Utils$Form$Form = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $author$project$Utils$Form$init = function (fields_) {
	return A4($author$project$Utils$Form$Form, fields_, false, fields_, _List_Nil);
};
var $author$project$Ui$Dropdown$DownRight = 0;
var $author$project$Ui$Dropdown$defaultConfig = function (_v0) {
	var id = _v0.ahP;
	var toMsg = _v0.al6;
	return {bv: 0, ahP: id, al6: toMsg};
};
var $author$project$Components$DateInput$DatePickerMsg = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $justinmimbs$date$Date$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$date$Date$daysInMonth = F2(
	function (y, m) {
		switch (m) {
			case 0:
				return 31;
			case 1:
				return $justinmimbs$date$Date$isLeapYear(y) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $justinmimbs$date$Date$monthToNumber = function (m) {
	switch (m) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $justinmimbs$date$Date$numberToMonth = function (mn) {
	var _v0 = A2($elm$core$Basics$max, 1, mn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		case 7:
			return 6;
		case 8:
			return 7;
		case 9:
			return 8;
		case 10:
			return 9;
		case 11:
			return 10;
		default:
			return 11;
	}
};
var $justinmimbs$date$Date$toCalendarDateHelp = F3(
	function (y, m, d) {
		toCalendarDateHelp:
		while (true) {
			var monthDays = A2($justinmimbs$date$Date$daysInMonth, y, m);
			var mn = $justinmimbs$date$Date$monthToNumber(m);
			if ((mn < 12) && (_Utils_cmp(d, monthDays) > 0)) {
				var $temp$y = y,
					$temp$m = $justinmimbs$date$Date$numberToMonth(mn + 1),
					$temp$d = d - monthDays;
				y = $temp$y;
				m = $temp$m;
				d = $temp$d;
				continue toCalendarDateHelp;
			} else {
				return {af9: d, aiP: m, amw: y};
			}
		}
	});
var $justinmimbs$date$Date$floorDiv = F2(
	function (a, b) {
		return $elm$core$Basics$floor(a / b);
	});
var $justinmimbs$date$Date$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (A2($justinmimbs$date$Date$floorDiv, y, 4) - A2($justinmimbs$date$Date$floorDiv, y, 100)) + A2($justinmimbs$date$Date$floorDiv, y, 400);
	return (365 * y) + leapYears;
};
var $justinmimbs$date$Date$divWithRemainder = F2(
	function (a, b) {
		return _Utils_Tuple2(
			A2($justinmimbs$date$Date$floorDiv, a, b),
			A2($elm$core$Basics$modBy, b, a));
	});
var $justinmimbs$date$Date$year = function (_v0) {
	var rd = _v0;
	var _v1 = A2($justinmimbs$date$Date$divWithRemainder, rd, 146097);
	var n400 = _v1.a;
	var r400 = _v1.b;
	var _v2 = A2($justinmimbs$date$Date$divWithRemainder, r400, 36524);
	var n100 = _v2.a;
	var r100 = _v2.b;
	var _v3 = A2($justinmimbs$date$Date$divWithRemainder, r100, 1461);
	var n4 = _v3.a;
	var r4 = _v3.b;
	var _v4 = A2($justinmimbs$date$Date$divWithRemainder, r4, 365);
	var n1 = _v4.a;
	var r1 = _v4.b;
	var n = (!r1) ? 0 : 1;
	return ((((n400 * 400) + (n100 * 100)) + (n4 * 4)) + n1) + n;
};
var $justinmimbs$date$Date$toOrdinalDate = function (_v0) {
	var rd = _v0;
	var y = $justinmimbs$date$Date$year(rd);
	return {
		IY: rd - $justinmimbs$date$Date$daysBeforeYear(y),
		amw: y
	};
};
var $justinmimbs$date$Date$toCalendarDate = function (_v0) {
	var rd = _v0;
	var date = $justinmimbs$date$Date$toOrdinalDate(rd);
	return A3($justinmimbs$date$Date$toCalendarDateHelp, date.amw, 0, date.IY);
};
var $justinmimbs$date$Date$day = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.af9;
	});
var $justinmimbs$date$Date$month = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.aiP;
	});
var $justinmimbs$date$Date$monthNumber = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToNumber);
var $justinmimbs$date$Date$ordinalDay = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toOrdinalDate,
	function ($) {
		return $.IY;
	});
var $justinmimbs$date$Date$padSignedInt = F2(
	function (length, _int) {
		return _Utils_ap(
			(_int < 0) ? '-' : '',
			A3(
				$elm$core$String$padLeft,
				length,
				'0',
				$elm$core$String$fromInt(
					$elm$core$Basics$abs(_int))));
	});
var $justinmimbs$date$Date$monthToQuarter = function (m) {
	return (($justinmimbs$date$Date$monthToNumber(m) + 2) / 3) | 0;
};
var $justinmimbs$date$Date$quarter = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToQuarter);
var $justinmimbs$date$Date$weekdayNumber = function (_v0) {
	var rd = _v0;
	var _v1 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v1) {
		return 7;
	} else {
		var n = _v1;
		return n;
	}
};
var $justinmimbs$date$Date$daysBeforeWeekYear = function (y) {
	var jan4 = $justinmimbs$date$Date$daysBeforeYear(y) + 4;
	return jan4 - $justinmimbs$date$Date$weekdayNumber(jan4);
};
var $justinmimbs$date$Date$numberToWeekday = function (wdn) {
	var _v0 = A2($elm$core$Basics$max, 1, wdn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		default:
			return 6;
	}
};
var $justinmimbs$date$Date$toWeekDate = function (_v0) {
	var rd = _v0;
	var wdn = $justinmimbs$date$Date$weekdayNumber(rd);
	var wy = $justinmimbs$date$Date$year(rd + (4 - wdn));
	var week1Day1 = $justinmimbs$date$Date$daysBeforeWeekYear(wy) + 1;
	return {
		aew: 1 + (((rd - week1Day1) / 7) | 0),
		aex: wy,
		amr: $justinmimbs$date$Date$numberToWeekday(wdn)
	};
};
var $justinmimbs$date$Date$weekNumber = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.aew;
	});
var $justinmimbs$date$Date$weekYear = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.aex;
	});
var $justinmimbs$date$Date$weekday = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$weekdayNumber, $justinmimbs$date$Date$numberToWeekday);
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $justinmimbs$date$Date$ordinalSuffix = function (n) {
	var nn = A2($elm$core$Basics$modBy, 100, n);
	var _v0 = A2(
		$elm$core$Basics$min,
		(nn < 20) ? nn : A2($elm$core$Basics$modBy, 10, nn),
		4);
	switch (_v0) {
		case 1:
			return 'st';
		case 2:
			return 'nd';
		case 3:
			return 'rd';
		default:
			return 'th';
	}
};
var $justinmimbs$date$Date$withOrdinalSuffix = function (n) {
	return _Utils_ap(
		$elm$core$String$fromInt(n),
		$justinmimbs$date$Date$ordinalSuffix(n));
};
var $justinmimbs$date$Date$formatField = F4(
	function (language, _char, length, date) {
		switch (_char) {
			case 'y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$year(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$year(date));
				}
			case 'Y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekYear(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$weekYear(date));
				}
			case 'Q':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 3:
						return 'Q' + $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 4:
						return $justinmimbs$date$Date$withOrdinalSuffix(
							$justinmimbs$date$Date$quarter(date));
					case 5:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					default:
						return '';
				}
			case 'M':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$monthNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$monthNumber(date)));
					case 3:
						return language.Bm(
							$justinmimbs$date$Date$month(date));
					case 4:
						return language.Xp(
							$justinmimbs$date$Date$month(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.Bm(
								$justinmimbs$date$Date$month(date)));
					default:
						return '';
				}
			case 'w':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekNumber(date)));
					default:
						return '';
				}
			case 'd':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$day(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$day(date)));
					case 3:
						return language.Hk(
							$justinmimbs$date$Date$day(date));
					default:
						return '';
				}
			case 'D':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$ordinalDay(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					case 3:
						return A3(
							$elm$core$String$padLeft,
							3,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					default:
						return '';
				}
			case 'E':
				switch (length) {
					case 1:
						return language.l3(
							$justinmimbs$date$Date$weekday(date));
					case 2:
						return language.l3(
							$justinmimbs$date$Date$weekday(date));
					case 3:
						return language.l3(
							$justinmimbs$date$Date$weekday(date));
					case 4:
						return language.Ks(
							$justinmimbs$date$Date$weekday(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.l3(
								$justinmimbs$date$Date$weekday(date)));
					case 6:
						return A2(
							$elm$core$String$left,
							2,
							language.l3(
								$justinmimbs$date$Date$weekday(date)));
					default:
						return '';
				}
			case 'e':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					default:
						return A4($justinmimbs$date$Date$formatField, language, 'E', length, date);
				}
			default:
				return '';
		}
	});
var $justinmimbs$date$Date$formatWithTokens = F3(
	function (language, tokens, date) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (token, formatted) {
					if (!token.$) {
						var _char = token.a;
						var length = token.b;
						return _Utils_ap(
							A4($justinmimbs$date$Date$formatField, language, _char, length, date),
							formatted);
					} else {
						var str = token.a;
						return _Utils_ap(str, formatted);
					}
				}),
			'',
			tokens);
	});
var $justinmimbs$date$Pattern$Literal = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $elm$parser$Parser$token = function (str) {
	return $elm$parser$Parser$Advanced$token(
		$elm$parser$Parser$toToken(str));
};
var $justinmimbs$date$Pattern$escapedQuote = A2(
	$elm$parser$Parser$ignorer,
	$elm$parser$Parser$succeed(
		$justinmimbs$date$Pattern$Literal('\'')),
	$elm$parser$Parser$token('\'\''));
var $justinmimbs$date$Pattern$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$getOffset = function (s) {
	return A3($elm$parser$Parser$Advanced$Good, false, s.g, s);
};
var $elm$parser$Parser$getOffset = $elm$parser$Parser$Advanced$getOffset;
var $justinmimbs$date$Pattern$fieldRepeats = function (str) {
	var _v0 = $elm$core$String$toList(str);
	if (_v0.b && (!_v0.b.b)) {
		var _char = _v0.a;
		return A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F2(
						function (x, y) {
							return A2($justinmimbs$date$Pattern$Field, _char, 1 + (y - x));
						})),
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$getOffset,
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq(_char)))),
			$elm$parser$Parser$getOffset);
	} else {
		return $elm$parser$Parser$problem('expected exactly one char');
	}
};
var $justinmimbs$date$Pattern$field = A2(
	$elm$parser$Parser$andThen,
	$justinmimbs$date$Pattern$fieldRepeats,
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompIf($elm$core$Char$isAlpha)));
var $justinmimbs$date$Pattern$finalize = A2(
	$elm$core$List$foldl,
	F2(
		function (token, tokens) {
			var _v0 = _Utils_Tuple2(token, tokens);
			if (((_v0.a.$ === 1) && _v0.b.b) && (_v0.b.a.$ === 1)) {
				var x = _v0.a.a;
				var _v1 = _v0.b;
				var y = _v1.a.a;
				var rest = _v1.b;
				return A2(
					$elm$core$List$cons,
					$justinmimbs$date$Pattern$Literal(
						_Utils_ap(x, y)),
					rest);
			} else {
				return A2($elm$core$List$cons, token, tokens);
			}
		}),
	_List_Nil);
var $elm$parser$Parser$Advanced$lazy = function (thunk) {
	return function (s) {
		var _v0 = thunk(0);
		var parse = _v0;
		return parse(s);
	};
};
var $elm$parser$Parser$lazy = $elm$parser$Parser$Advanced$lazy;
var $justinmimbs$date$Pattern$isLiteralChar = function (_char) {
	return (_char !== '\'') && (!$elm$core$Char$isAlpha(_char));
};
var $justinmimbs$date$Pattern$literal = A2(
	$elm$parser$Parser$map,
	$justinmimbs$date$Pattern$Literal,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($justinmimbs$date$Pattern$isLiteralChar)),
			$elm$parser$Parser$chompWhile($justinmimbs$date$Pattern$isLiteralChar))));
var $justinmimbs$date$Pattern$quotedHelp = function (result) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (str) {
					return $justinmimbs$date$Pattern$quotedHelp(
						_Utils_ap(result, str));
				},
				$elm$parser$Parser$getChompedString(
					A2(
						$elm$parser$Parser$ignorer,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed(0),
							$elm$parser$Parser$chompIf(
								$elm$core$Basics$neq('\''))),
						$elm$parser$Parser$chompWhile(
							$elm$core$Basics$neq('\''))))),
				A2(
				$elm$parser$Parser$andThen,
				function (_v0) {
					return $justinmimbs$date$Pattern$quotedHelp(result + '\'');
				},
				$elm$parser$Parser$token('\'\'')),
				$elm$parser$Parser$succeed(result)
			]));
};
var $justinmimbs$date$Pattern$quoted = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($justinmimbs$date$Pattern$Literal),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('\''))),
	A2(
		$elm$parser$Parser$ignorer,
		$justinmimbs$date$Pattern$quotedHelp(''),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq('\'')),
					$elm$parser$Parser$end
				]))));
var $justinmimbs$date$Pattern$patternHelp = function (tokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (token) {
					return $justinmimbs$date$Pattern$patternHelp(
						A2($elm$core$List$cons, token, tokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[$justinmimbs$date$Pattern$field, $justinmimbs$date$Pattern$literal, $justinmimbs$date$Pattern$escapedQuote, $justinmimbs$date$Pattern$quoted]))),
				$elm$parser$Parser$lazy(
				function (_v0) {
					return $elm$parser$Parser$succeed(
						$justinmimbs$date$Pattern$finalize(tokens));
				})
			]));
};
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $justinmimbs$date$Pattern$fromString = function (str) {
	return A2(
		$elm$core$Result$withDefault,
		_List_fromArray(
			[
				$justinmimbs$date$Pattern$Literal(str)
			]),
		A2(
			$elm$parser$Parser$run,
			$justinmimbs$date$Pattern$patternHelp(_List_Nil),
			str));
};
var $justinmimbs$date$Date$formatWithLanguage = F2(
	function (language, pattern) {
		var tokens = $elm$core$List$reverse(
			$justinmimbs$date$Pattern$fromString(pattern));
		return A2($justinmimbs$date$Date$formatWithTokens, language, tokens);
	});
var $justinmimbs$date$Date$monthToName = function (m) {
	switch (m) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $justinmimbs$date$Date$weekdayToName = function (wd) {
	switch (wd) {
		case 0:
			return 'Monday';
		case 1:
			return 'Tuesday';
		case 2:
			return 'Wednesday';
		case 3:
			return 'Thursday';
		case 4:
			return 'Friday';
		case 5:
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $justinmimbs$date$Date$language_en = {
	Hk: $justinmimbs$date$Date$withOrdinalSuffix,
	Xp: $justinmimbs$date$Date$monthToName,
	Bm: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$monthToName,
		$elm$core$String$left(3)),
	Ks: $justinmimbs$date$Date$weekdayToName,
	l3: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$weekdayToName,
		$elm$core$String$left(3))
};
var $justinmimbs$date$Date$format = function (pattern) {
	return A2($justinmimbs$date$Date$formatWithLanguage, $justinmimbs$date$Date$language_en, pattern);
};
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $agustinrhcp$elm_datepicker$DatePicker$formatCell = function (day) {
	return $elm$html$Html$text(day);
};
var $agustinrhcp$elm_datepicker$DatePicker$Date$formatDay = function (day) {
	switch (day) {
		case 0:
			return 'Mo';
		case 1:
			return 'Tu';
		case 2:
			return 'We';
		case 3:
			return 'Th';
		case 4:
			return 'Fr';
		case 5:
			return 'Sa';
		default:
			return 'Su';
	}
};
var $agustinrhcp$elm_datepicker$DatePicker$Date$formatMonth = function (month) {
	switch (month) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $justinmimbs$date$Date$deadEndToString = function (_v0) {
	var problem = _v0.pm;
	if (problem.$ === 12) {
		var message = problem.a;
		return message;
	} else {
		return 'Expected a date in ISO 8601 format';
	}
};
var $justinmimbs$date$Date$MonthAndDay = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $justinmimbs$date$Date$OrdinalDay = function (a) {
	return {$: 2, a: a};
};
var $justinmimbs$date$Date$WeekAndWeekday = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0;
	return function (s0) {
		var _v1 = parse(s0);
		if (_v1.$ === 1) {
			var x = _v1.b;
			return A2($elm$parser$Parser$Advanced$Bad, false, x);
		} else {
			var a = _v1.b;
			var s1 = _v1.c;
			return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
		}
	};
};
var $elm$parser$Parser$backtrackable = $elm$parser$Parser$Advanced$backtrackable;
var $elm$parser$Parser$Advanced$commit = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, true, a, s);
	};
};
var $elm$parser$Parser$commit = $elm$parser$Parser$Advanced$commit;
var $elm$parser$Parser$mapChompedString = $elm$parser$Parser$Advanced$mapChompedString;
var $justinmimbs$date$Date$int1 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	$elm$parser$Parser$chompIf($elm$core$Char$isDigit));
var $justinmimbs$date$Date$int2 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed(0),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$int3 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$dayOfYear = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed($elm$core$Basics$identity),
				$elm$parser$Parser$token('-')),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$backtrackable(
						A2(
							$elm$parser$Parser$andThen,
							$elm$parser$Parser$commit,
							A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int2),
									$elm$parser$Parser$succeed(1)
								]))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$ignorer,
								$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
								$elm$parser$Parser$token('W')),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int1),
									$elm$parser$Parser$succeed(1)
								])))
					]))),
			$elm$parser$Parser$backtrackable(
			A2(
				$elm$parser$Parser$andThen,
				$elm$parser$Parser$commit,
				A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
						$justinmimbs$date$Date$int2),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$justinmimbs$date$Date$int2,
								$elm$parser$Parser$succeed(1)
							]))))),
			A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3),
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
					$elm$parser$Parser$token('W')),
				$justinmimbs$date$Date$int2),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$justinmimbs$date$Date$int1,
						$elm$parser$Parser$succeed(1)
					]))),
			$elm$parser$Parser$succeed(
			$justinmimbs$date$Date$OrdinalDay(1))
		]));
var $justinmimbs$date$Date$daysBeforeMonth = F2(
	function (y, m) {
		var leapDays = $justinmimbs$date$Date$isLeapYear(y) ? 1 : 0;
		switch (m) {
			case 0:
				return 0;
			case 1:
				return 31;
			case 2:
				return 59 + leapDays;
			case 3:
				return 90 + leapDays;
			case 4:
				return 120 + leapDays;
			case 5:
				return 151 + leapDays;
			case 6:
				return 181 + leapDays;
			case 7:
				return 212 + leapDays;
			case 8:
				return 243 + leapDays;
			case 9:
				return 273 + leapDays;
			case 10:
				return 304 + leapDays;
			default:
				return 334 + leapDays;
		}
	});
var $justinmimbs$date$Date$isBetweenInt = F3(
	function (a, b, x) {
		return (_Utils_cmp(a, x) < 1) && (_Utils_cmp(x, b) < 1);
	});
var $justinmimbs$date$Date$fromCalendarParts = F3(
	function (y, mn, d) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 12, mn) && A3(
			$justinmimbs$date$Date$isBetweenInt,
			1,
			A2(
				$justinmimbs$date$Date$daysInMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn)),
			d)) ? $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeYear(y) + A2(
				$justinmimbs$date$Date$daysBeforeMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn))) + d) : $elm$core$Result$Err(
			'Invalid calendar date (' + ($elm$core$String$fromInt(y) + (', ' + ($elm$core$String$fromInt(mn) + (', ' + ($elm$core$String$fromInt(d) + ')'))))));
	});
var $justinmimbs$date$Date$fromOrdinalParts = F2(
	function (y, od) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 365, od) || ((od === 366) && $justinmimbs$date$Date$isLeapYear(y))) ? $elm$core$Result$Ok(
			$justinmimbs$date$Date$daysBeforeYear(y) + od) : $elm$core$Result$Err(
			'Invalid ordinal date (' + ($elm$core$String$fromInt(y) + (', ' + ($elm$core$String$fromInt(od) + ')'))));
	});
var $justinmimbs$date$Date$firstOfYear = function (y) {
	return $justinmimbs$date$Date$daysBeforeYear(y) + 1;
};
var $justinmimbs$date$Date$is53WeekYear = function (y) {
	var wdnJan1 = $justinmimbs$date$Date$weekdayNumber(
		$justinmimbs$date$Date$firstOfYear(y));
	return (wdnJan1 === 4) || ((wdnJan1 === 3) && $justinmimbs$date$Date$isLeapYear(y));
};
var $justinmimbs$date$Date$fromWeekParts = F3(
	function (wy, wn, wdn) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 7, wdn) && (A3($justinmimbs$date$Date$isBetweenInt, 1, 52, wn) || ((wn === 53) && $justinmimbs$date$Date$is53WeekYear(wy)))) ? $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeWeekYear(wy) + ((wn - 1) * 7)) + wdn) : $elm$core$Result$Err(
			'Invalid week date (' + ($elm$core$String$fromInt(wy) + (', ' + ($elm$core$String$fromInt(wn) + (', ' + ($elm$core$String$fromInt(wdn) + ')'))))));
	});
var $justinmimbs$date$Date$fromYearAndDayOfYear = function (_v0) {
	var y = _v0.a;
	var doy = _v0.b;
	switch (doy.$) {
		case 0:
			var mn = doy.a;
			var d = doy.b;
			return A3($justinmimbs$date$Date$fromCalendarParts, y, mn, d);
		case 1:
			var wn = doy.a;
			var wdn = doy.b;
			return A3($justinmimbs$date$Date$fromWeekParts, y, wn, wdn);
		default:
			var od = doy.a;
			return A2($justinmimbs$date$Date$fromOrdinalParts, y, od);
	}
};
var $justinmimbs$date$Date$int4 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed(0),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									$elm$parser$Parser$chompIf(
									function (c) {
										return c === '-';
									}),
									$elm$parser$Parser$succeed(0)
								]))),
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $justinmimbs$date$Date$resultToParser = function (result) {
	if (!result.$) {
		var x = result.a;
		return $elm$parser$Parser$succeed(x);
	} else {
		var message = result.a;
		return $elm$parser$Parser$problem(message);
	}
};
var $justinmimbs$date$Date$parser = A2(
	$elm$parser$Parser$andThen,
	A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromYearAndDayOfYear, $justinmimbs$date$Date$resultToParser),
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Tuple$pair),
			$justinmimbs$date$Date$int4),
		$justinmimbs$date$Date$dayOfYear));
var $justinmimbs$date$Date$fromIsoString = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run(
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			A2(
				$elm$parser$Parser$ignorer,
				$justinmimbs$date$Date$parser,
				A2(
					$elm$parser$Parser$andThen,
					$justinmimbs$date$Date$resultToParser,
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2($elm$parser$Parser$map, $elm$core$Result$Ok, $elm$parser$Parser$end),
								A2(
								$elm$parser$Parser$map,
								$elm$core$Basics$always(
									$elm$core$Result$Err('Expected a date only, not a date and time')),
								$elm$parser$Parser$chompIf(
									$elm$core$Basics$eq('T'))),
								$elm$parser$Parser$succeed(
								$elm$core$Result$Err('Expected a date only'))
							])))))),
	$elm$core$Result$mapError(
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$head,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map($justinmimbs$date$Date$deadEndToString),
				$elm$core$Maybe$withDefault('')))));
var $agustinrhcp$elm_datepicker$DatePicker$Date$Off = {$: 0};
var $agustinrhcp$elm_datepicker$DatePicker$off = $agustinrhcp$elm_datepicker$DatePicker$Date$Off;
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$required = $elm$html$Html$Attributes$boolProperty('required');
var $agustinrhcp$elm_datepicker$DatePicker$defaultSettings = {
	rD: $agustinrhcp$elm_datepicker$DatePicker$formatCell,
	iH: $agustinrhcp$elm_datepicker$DatePicker$off,
	mQ: 'elm-datepicker--',
	G0: _List_Nil,
	af7: $justinmimbs$date$Date$format('yyyy-MM-dd'),
	aga: $agustinrhcp$elm_datepicker$DatePicker$Date$formatDay,
	ahm: 6,
	T3: _List_fromArray(
		[
			$elm$html$Html$Attributes$required(false)
		]),
	H2: _List_Nil,
	H3: $elm$core$Maybe$Nothing,
	H4: $elm$core$Maybe$Nothing,
	aib: $elm$core$Basics$always(false),
	Bk: $agustinrhcp$elm_datepicker$DatePicker$Date$formatMonth,
	ajM: $justinmimbs$date$Date$fromIsoString,
	aj3: 'Please pick a date...',
	q4: $elm$core$String$fromInt
};
var $author$project$Components$DateInput$formatWeekday = function (weekday) {
	switch (weekday) {
		case 0:
			return 'Mon';
		case 1:
			return 'Tue';
		case 2:
			return 'Wed';
		case 3:
			return 'Thu';
		case 4:
			return 'Fri';
		case 5:
			return 'Sat';
		default:
			return 'Sun';
	}
};
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $justinmimbs$date$Date$fromCalendarDate = F3(
	function (y, m, d) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A3(
			$elm$core$Basics$clamp,
			1,
			A2($justinmimbs$date$Date$daysInMonth, y, m),
			d);
	});
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{ak: nodeList, F: nodeListSize, X: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $author$project$Utils$Date$months = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]);
var $author$project$Utils$Date$monthFromInt = function (intMonth) {
	return A2(
		$elm$core$Array$get,
		intMonth - 1,
		$elm$core$Array$fromList($author$project$Utils$Date$months));
};
var $author$project$Utils$Date$dateFromCalendar = function (_v0) {
	var yearString = _v0.aeE;
	var monthString = _v0.Xv;
	var dayString = _v0.PK;
	var maybeYear = $elm$core$String$toInt(yearString);
	var maybeMonth = A2(
		$elm$core$Maybe$andThen,
		$author$project$Utils$Date$monthFromInt,
		$elm$core$String$toInt(monthString));
	var maybeDay = $elm$core$String$toInt(dayString);
	var _v1 = _Utils_Tuple3(maybeDay, maybeMonth, maybeYear);
	if (((!_v1.a.$) && (!_v1.b.$)) && (!_v1.c.$)) {
		var day = _v1.a.a;
		var month = _v1.b.a;
		var year = _v1.c.a;
		return $elm$core$Result$Ok(
			A3($justinmimbs$date$Date$fromCalendarDate, year, month, day));
	} else {
		return $elm$core$Result$Err('Invalid Date');
	}
};
var $author$project$Utils$Date$DateParts = F3(
	function (monthString, dayString, yearString) {
		return {PK: dayString, Xv: monthString, aeE: yearString};
	});
var $author$project$Utils$Date$validateDatePart = F2(
	function (length, datePart) {
		return _Utils_eq(
			$elm$core$String$length(datePart),
			length) ? $elm$parser$Parser$succeed(datePart) : $elm$parser$Parser$problem('Date part is invalid.');
	});
var $author$project$Utils$Date$chompDatePart = function (length) {
	return A2(
		$elm$parser$Parser$andThen,
		$author$project$Utils$Date$validateDatePart(length),
		$elm$parser$Parser$getChompedString(
			$elm$parser$Parser$chompWhile($elm$core$Char$isDigit)));
};
var $author$project$Utils$Date$dateSeparator = '/';
var $author$project$Utils$Date$dateParser = function () {
	var stringSeparator = $elm$core$String$fromChar($author$project$Utils$Date$dateSeparator);
	return A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed($author$project$Utils$Date$DateParts),
				A2(
					$elm$parser$Parser$ignorer,
					$author$project$Utils$Date$chompDatePart(2),
					$elm$parser$Parser$symbol(stringSeparator))),
			A2(
				$elm$parser$Parser$ignorer,
				$author$project$Utils$Date$chompDatePart(2),
				$elm$parser$Parser$symbol(stringSeparator))),
		A2(
			$elm$parser$Parser$ignorer,
			$author$project$Utils$Date$chompDatePart(4),
			$elm$parser$Parser$end));
}();
var $author$project$Utils$Date$fromUsString = function (dateString) {
	var _v0 = A2($elm$parser$Parser$run, $author$project$Utils$Date$dateParser, dateString);
	if (!_v0.$) {
		var dateParts = _v0.a;
		return $author$project$Utils$Date$dateFromCalendar(dateParts);
	} else {
		return $elm$core$Result$Err('Invalid Date');
	}
};
var $author$project$Components$DateInput$baseDatePickerSettings = function () {
	var defaultSettings_ = $agustinrhcp$elm_datepicker$DatePicker$defaultSettings;
	return _Utils_update(
		defaultSettings_,
		{
			af7: $justinmimbs$date$Date$format('MM/dd/yyyy'),
			aga: $author$project$Components$DateInput$formatWeekday,
			H2: _List_fromArray(
				[
					_Utils_Tuple2('form-control', true)
				]),
			ajM: $author$project$Utils$Date$fromUsString
		});
}();
var $agustinrhcp$elm_datepicker$DatePicker$CurrentDate = function (a) {
	return {$: 0, a: a};
};
var $agustinrhcp$elm_datepicker$DatePicker$DatePicker = $elm$core$Basics$identity;
var $agustinrhcp$elm_datepicker$DatePicker$Day = 0;
var $agustinrhcp$elm_datepicker$DatePicker$Date$initDate = A3($justinmimbs$date$Date$fromCalendarDate, 1992, 4, 31);
var $justinmimbs$date$Date$fromPosix = F2(
	function (zone, posix) {
		return A3(
			$justinmimbs$date$Date$fromCalendarDate,
			A2($elm$time$Time$toYear, zone, posix),
			A2($elm$time$Time$toMonth, zone, posix),
			A2($elm$time$Time$toDay, zone, posix));
	});
var $elm$time$Time$here = _Time_here(0);
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $justinmimbs$date$Date$today = A3($elm$core$Task$map2, $justinmimbs$date$Date$fromPosix, $elm$time$Time$here, $elm$time$Time$now);
var $agustinrhcp$elm_datepicker$DatePicker$init = _Utils_Tuple2(
	{
		bC: $elm$core$Maybe$Just($agustinrhcp$elm_datepicker$DatePicker$Date$initDate),
		gt: false,
		cH: $elm$core$Maybe$Nothing,
		Yn: false,
		kF: 0,
		FR: $agustinrhcp$elm_datepicker$DatePicker$Date$initDate
	},
	A2($elm$core$Task$perform, $agustinrhcp$elm_datepicker$DatePicker$CurrentDate, $justinmimbs$date$Date$today));
var $author$project$Components$DateInput$init = function () {
	var _v0 = $agustinrhcp$elm_datepicker$DatePicker$init;
	var datePicker = _v0.a;
	var datePickerCmd = _v0.b;
	return _Utils_Tuple2(
		{na: datePicker},
		A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Components$DateInput$DatePickerMsg($author$project$Components$DateInput$baseDatePickerSettings),
			datePickerCmd));
}();
var $author$project$Ui$Dropdown$init = function (_v0) {
	var id = _v0.ahP;
	var direction = _v0.bv;
	var toMsg = _v0.al6;
	return {bv: direction, ahP: id, Yn: false, al6: toMsg};
};
var $author$project$Components$ProviderCredentials$initLicense = F2(
	function (dropdownId, toDropdownMsg) {
		var _v0 = $author$project$Components$DateInput$init;
		var initialExpiration = _v0.a;
		var expirationCmd = _v0.b;
		return _Utils_Tuple2(
			_List_fromArray(
				[
					{
					M: _Utils_Tuple2($elm$core$Maybe$Nothing, initialExpiration),
					IO: $elm$core$Maybe$Nothing,
					uP: $elm$core$Maybe$Nothing,
					fj: $author$project$Ui$Dropdown$init(
						$author$project$Ui$Dropdown$defaultConfig(
							{
								ahP: dropdownId,
								al6: toDropdownMsg(0)
							})),
					fk: ''
				}
				]),
			expirationCmd);
	});
var $author$project$Components$ProviderCredentials$init = function (today) {
	var _v0 = A2($author$project$Components$ProviderCredentials$initLicense, 'state-dropdown-0', $author$project$Components$ProviderCredentials$StateLicenseStateDropdownMsg);
	var initialState = _v0.a;
	var stateCmd = _v0.b;
	var _v1 = A2($author$project$Components$ProviderCredentials$initLicense, 'dea-dropdown-0', $author$project$Components$ProviderCredentials$DeaStateDropdownMsg);
	var initialDea = _v1.a;
	var deaCmd = _v1.b;
	var fields = {nb: initialDea, Hp: $elm$core$Maybe$Nothing, X0: $elm$core$Maybe$Nothing, qm: initialState};
	return _Utils_Tuple2(
		{
			SD: $author$project$Utils$Form$init(fields),
			FR: today
		},
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Components$ProviderCredentials$StateLicenseExpirationMsg(0),
					stateCmd),
					A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Components$ProviderCredentials$MultiDeaExpirationMsg(0),
					deaCmd)
				])));
};
var $author$project$Pages$Account$Complete$init = F4(
	function (session, practice, shared, _v0) {
		var _v1 = $author$project$Components$ProviderCredentials$init(shared.dd);
		var credentials = _v1.a;
		var credentialsCmd = _v1.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, bW: credentials, ZV: practice, aa4: session, lA: false, FR: shared.dd},
			A2($elm$core$Platform$Cmd$map, $author$project$Pages$Account$Complete$CredentialsMsg, credentialsCmd));
	});
var $author$project$Pages$Account$Complete$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Account$Complete$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Account$Complete$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$OutMsg$ShowToast = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Pages$Account$Complete$SubmitResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Toast$Success = 3;
var $author$project$Api$Provider$PracticeUser$One$PracticeUser = 0;
var $author$project$Api$Provider$PracticeUser$One$decoder = $elm$json$Json$Decode$succeed(0);
var $justinmimbs$date$Date$toIsoString = $justinmimbs$date$Date$format('yyyy-MM-dd');
var $author$project$Components$ProviderCredentials$encodeLicense = function (license) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'license_number',
				$elm$json$Json$Encode$string(
					A2($elm$core$Maybe$withDefault, '', license.IO))),
				_Utils_Tuple2(
				'state',
				$elm$json$Json$Encode$string(
					A2($elm$core$Maybe$withDefault, '', license.uP))),
				_Utils_Tuple2(
				'expiration',
				$elm$json$Json$Encode$string(
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2($elm$core$Maybe$map, $justinmimbs$date$Date$toIsoString, license.M.a))))
			]));
};
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $author$project$Utils$Encode$optional = F3(
	function (fieldName, encoder, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					fieldName,
					encoder(value))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Api$Data$patch = $author$project$Api$Data$makeRequest('patch');
var $author$project$Api$Data$Json = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Data$requestWithJson = F2(
	function (json, _v0) {
		var request = _v0;
		return _Utils_update(
			request,
			{
				fO: $elm$core$Maybe$Just(
					$author$project$Api$Data$Json(json))
			});
	});
var $author$project$Api$Provider$TeamMember$teamMembersPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['team_members']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$TeamMember$completeCredentials = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'team_member',
					$elm$json$Json$Encode$object(
						$elm$core$List$concat(
							_List_fromArray(
								[
									A3($author$project$Utils$Encode$optional, 'npi', $elm$json$Json$Encode$string, fields.X0),
									A3($author$project$Utils$Encode$optional, 'education_degree', $elm$json$Json$Encode$string, fields.Hp),
									A3(
									$author$project$Utils$Encode$optional,
									'dea_licenses',
									$elm$json$Json$Encode$list($author$project$Components$ProviderCredentials$encodeLicense),
									$elm$core$List$isEmpty(fields.nb) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(fields.nb)),
									A3(
									$author$project$Utils$Encode$optional,
									'state_licenses',
									$elm$json$Json$Encode$list($author$project$Components$ProviderCredentials$encodeLicense),
									$elm$core$List$isEmpty(fields.qm) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(fields.qm))
								]))))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$PracticeUser$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['me']),
						$author$project$Api$Provider$TeamMember$teamMembersPath))));
	});
var $author$project$Ui$Toast$Error = 1;
var $author$project$OutMsg$GatewayError = {$: 20};
var $author$project$OutMsg$SessionExpired = function (a) {
	return {$: 15, a: a};
};
var $author$project$OutMsg$DecodeFailed = function (a) {
	return {$: 0, a: a};
};
var $author$project$OutMsg$reportDecodeError = function (response) {
	if ((response.$ === 2) && (response.a.$ === 7)) {
		var error = response.a.a;
		return _List_fromArray(
			[
				$author$project$OutMsg$DecodeFailed(error)
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Ui$Toast$defaultError = 'An error occurred, please try again.';
var $author$project$Ui$Toast$serverError = function (errorResponse) {
	switch (errorResponse.$) {
		case 8:
			var errorMessage = errorResponse.a;
			return A2($elm$core$Maybe$withDefault, $author$project$Ui$Toast$defaultError, errorMessage);
		case 6:
			var code = errorResponse.a;
			var errorMessage = errorResponse.b;
			return (code >= 500) ? $author$project$Ui$Toast$defaultError : errorMessage;
		case 0:
			var errorMessage = errorResponse.a;
			return A2($elm$core$Maybe$withDefault, $author$project$Ui$Toast$defaultError, errorMessage);
		default:
			return $author$project$Ui$Toast$defaultError;
	}
};
var $author$project$OutMsg$handleErrorResponse = function (response) {
	return _Utils_ap(
		$author$project$OutMsg$reportDecodeError(response),
		function () {
			if (response.$ === 2) {
				var error = response.a;
				switch (error.$) {
					case 0:
						return _List_fromArray(
							[
								$author$project$OutMsg$SessionExpired(error)
							]);
					case 4:
						return _List_fromArray(
							[
								$author$project$OutMsg$GatewayError,
								A2(
								$author$project$OutMsg$ShowToast,
								1,
								$author$project$Ui$Toast$serverError(error))
							]);
					default:
						return _List_fromArray(
							[
								A2(
								$author$project$OutMsg$ShowToast,
								1,
								$author$project$Ui$Toast$serverError(error))
							]);
				}
			} else {
				return _List_Nil;
			}
		}());
};
var $author$project$Ports$Navigation$navigationLoad = _Platform_outgoingPort('navigationLoad', $elm$json$Json$Encode$string);
var $author$project$Ports$Navigation$load = $author$project$Ports$Navigation$navigationLoad;
var $author$project$Utils$Route$navigateAndReload = F2(
	function (params, route) {
		return $author$project$Ports$Navigation$load(
			A2($author$project$Utils$Route$toString, params, route));
	});
var $author$project$Utils$Form$fields = function (_v0) {
	var fields_ = _v0.c;
	return fields_;
};
var $author$project$Components$ProviderCredentials$toApiFields = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.SD);
	return {nb: fields.nb, Hp: fields.Hp, X0: fields.X0, qm: fields.qm};
};
var $author$project$Components$ProviderCredentials$DeaExpirationAt = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$ProviderCredentials$DeaStateDropdownAt = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Components$ProviderCredentials$StateLicenseExpirationAt = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Components$ProviderCredentials$StateLicenseStateDropdownAt = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $agustinrhcp$elm_datepicker$DatePicker$initFromDate = function (date) {
	return {
		bC: $elm$core$Maybe$Just(date),
		gt: false,
		cH: $elm$core$Maybe$Nothing,
		Yn: false,
		kF: 0,
		FR: date
	};
};
var $author$project$Components$DateInput$initFromDate = function (currentDate) {
	var datePicker = $agustinrhcp$elm_datepicker$DatePicker$initFromDate(currentDate);
	return {na: datePicker};
};
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $author$project$Components$ProviderCredentials$removeAt = F2(
	function (index, list) {
		return _Utils_ap(
			A2($elm$core$List$take, index, list),
			A2($elm$core$List$drop, index + 1, list));
	});
var $elm$core$String$trim = _String_trim;
var $author$project$Utils$String$isBlank = function (string) {
	return $elm$core$String$isEmpty(
		$elm$core$String$trim(string));
};
var $author$project$Utils$String$toMaybe = function (string) {
	return $author$project$Utils$String$isBlank(string) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(string);
};
var $author$project$Components$ProviderCredentials$updateItemAt = F3(
	function (index, updateFn, items) {
		return A2(
			$elm$core$List$indexedMap,
			F2(
				function (i, item) {
					return _Utils_eq(i, index) ? updateFn(item) : item;
				}),
			items);
	});
var $author$project$Components$ProviderCredentials$formFieldsUpdate = F3(
	function (today, field, fields) {
		switch (field.$) {
			case 0:
				var value = field.a;
				return _Utils_update(
					fields,
					{
						X0: $author$project$Utils$String$toMaybe(value)
					});
			case 1:
				var value = field.a;
				return _Utils_update(
					fields,
					{
						Hp: $author$project$Utils$String$toMaybe(value)
					});
			case 2:
				var index = field.a;
				var value = field.b;
				return _Utils_update(
					fields,
					{
						nb: A3(
							$author$project$Components$ProviderCredentials$updateItemAt,
							index,
							function (l) {
								return _Utils_update(
									l,
									{
										IO: $author$project$Utils$String$toMaybe(value)
									});
							},
							fields.nb)
					});
			case 3:
				var index = field.a;
				var value = field.b;
				return _Utils_update(
					fields,
					{
						nb: A3(
							$author$project$Components$ProviderCredentials$updateItemAt,
							index,
							function (l) {
								return _Utils_update(
									l,
									{
										uP: $elm$core$Maybe$Just(value)
									});
							},
							fields.nb)
					});
			case 4:
				var index = field.a;
				var expiration = field.b;
				return _Utils_update(
					fields,
					{
						nb: A3(
							$author$project$Components$ProviderCredentials$updateItemAt,
							index,
							function (l) {
								return _Utils_update(
									l,
									{M: expiration});
							},
							fields.nb)
					});
			case 5:
				var index = field.a;
				var dropdown = field.b;
				return _Utils_update(
					fields,
					{
						nb: A3(
							$author$project$Components$ProviderCredentials$updateItemAt,
							index,
							function (l) {
								return _Utils_update(
									l,
									{fj: dropdown});
							},
							fields.nb)
					});
			case 6:
				var index = field.a;
				var search = field.b;
				return _Utils_update(
					fields,
					{
						nb: A3(
							$author$project$Components$ProviderCredentials$updateItemAt,
							index,
							function (l) {
								return _Utils_update(
									l,
									{fk: search});
							},
							fields.nb)
					});
			case 7:
				var newExpiration = $author$project$Components$DateInput$initFromDate(today);
				return _Utils_update(
					fields,
					{
						nb: _Utils_ap(
							fields.nb,
							_List_fromArray(
								[
									{
									M: _Utils_Tuple2($elm$core$Maybe$Nothing, newExpiration),
									IO: $elm$core$Maybe$Nothing,
									uP: $elm$core$Maybe$Nothing,
									fj: $author$project$Ui$Dropdown$init(
										$author$project$Ui$Dropdown$defaultConfig(
											{
												ahP: 'dea-dropdown-' + $elm$core$String$fromInt(
													$elm$core$List$length(fields.nb)),
												al6: $author$project$Components$ProviderCredentials$DeaStateDropdownMsg(
													$elm$core$List$length(fields.nb))
											})),
									fk: ''
								}
								]))
					});
			case 8:
				var index = field.a;
				return _Utils_update(
					fields,
					{
						nb: A2($author$project$Components$ProviderCredentials$removeAt, index, fields.nb)
					});
			case 9:
				var index = field.a;
				var value = field.b;
				return _Utils_update(
					fields,
					{
						qm: A3(
							$author$project$Components$ProviderCredentials$updateItemAt,
							index,
							function (l) {
								return _Utils_update(
									l,
									{
										IO: $author$project$Utils$String$toMaybe(value)
									});
							},
							fields.qm)
					});
			case 10:
				var index = field.a;
				var value = field.b;
				return _Utils_update(
					fields,
					{
						qm: A3(
							$author$project$Components$ProviderCredentials$updateItemAt,
							index,
							function (l) {
								return _Utils_update(
									l,
									{
										uP: $elm$core$Maybe$Just(value)
									});
							},
							fields.qm)
					});
			case 11:
				var index = field.a;
				var expiration = field.b;
				return _Utils_update(
					fields,
					{
						qm: A3(
							$author$project$Components$ProviderCredentials$updateItemAt,
							index,
							function (l) {
								return _Utils_update(
									l,
									{M: expiration});
							},
							fields.qm)
					});
			case 12:
				var index = field.a;
				var dropdown = field.b;
				return _Utils_update(
					fields,
					{
						qm: A3(
							$author$project$Components$ProviderCredentials$updateItemAt,
							index,
							function (l) {
								return _Utils_update(
									l,
									{fj: dropdown});
							},
							fields.qm)
					});
			case 13:
				var index = field.a;
				var search = field.b;
				return _Utils_update(
					fields,
					{
						qm: A3(
							$author$project$Components$ProviderCredentials$updateItemAt,
							index,
							function (l) {
								return _Utils_update(
									l,
									{fk: search});
							},
							fields.qm)
					});
			case 14:
				var newExpiration = $author$project$Components$DateInput$initFromDate(today);
				return _Utils_update(
					fields,
					{
						qm: _Utils_ap(
							fields.qm,
							_List_fromArray(
								[
									{
									M: _Utils_Tuple2($elm$core$Maybe$Nothing, newExpiration),
									IO: $elm$core$Maybe$Nothing,
									uP: $elm$core$Maybe$Nothing,
									fj: $author$project$Ui$Dropdown$init(
										$author$project$Ui$Dropdown$defaultConfig(
											{
												ahP: 'state-dropdown-' + $elm$core$String$fromInt(
													$elm$core$List$length(fields.qm)),
												al6: $author$project$Components$ProviderCredentials$StateLicenseStateDropdownMsg(
													$elm$core$List$length(fields.qm))
											})),
									fk: ''
								}
								]))
					});
			default:
				var index = field.a;
				return _Utils_update(
					fields,
					{
						qm: A2($author$project$Components$ProviderCredentials$removeAt, index, fields.qm)
					});
		}
	});
var $author$project$Utils$Form$update = F3(
	function (updater, field_, _v0) {
		var originalFields = _v0.a;
		var validated_ = _v0.b;
		var fields_ = _v0.c;
		var errors_ = _v0.d;
		return A4(
			$author$project$Utils$Form$Form,
			originalFields,
			validated_,
			A2(updater, field_, fields_),
			errors_);
	});
var $author$project$Components$ProviderCredentials$blankLicense = F3(
	function (index, dropdownIdPrefix, toDropdownMsg) {
		return {
			M: _Utils_Tuple2($elm$core$Maybe$Nothing, $author$project$Components$DateInput$init.a),
			IO: $elm$core$Maybe$Nothing,
			uP: $elm$core$Maybe$Nothing,
			fj: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{
						ahP: _Utils_ap(
							dropdownIdPrefix,
							$elm$core$String$fromInt(index)),
						al6: toDropdownMsg(index)
					})),
			fk: ''
		};
	});
var $author$project$Ui$Dropdown$MenuClosedAfterFocus = {$: 9};
var $author$project$Ui$Dropdown$NoOp = {$: 6};
var $author$project$Ui$Dropdown$RightDown = 1;
var $author$project$Ports$Dropdown$focusFirstDropdownOptionPort = _Platform_outgoingPort('focusFirstDropdownOptionPort', $elm$json$Json$Encode$string);
var $author$project$Ports$Dropdown$focusFirstItem = $author$project$Ports$Dropdown$focusFirstDropdownOptionPort;
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $author$project$Ports$Dropdown$focusInnerDropdownOptionInputPort = _Platform_outgoingPort(
	'focusInnerDropdownOptionInputPort',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$Dropdown$focusInnerInput = $author$project$Ports$Dropdown$focusInnerDropdownOptionInputPort(0);
var $author$project$Ports$Dropdown$focusInnerDropdownOptionLinkPort = _Platform_outgoingPort(
	'focusInnerDropdownOptionLinkPort',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$Dropdown$focusInnerLink = $author$project$Ports$Dropdown$focusInnerDropdownOptionLinkPort(0);
var $author$project$Ports$Dropdown$focusNextDropdownOptionPort = _Platform_outgoingPort(
	'focusNextDropdownOptionPort',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$Dropdown$focusNextItem = $author$project$Ports$Dropdown$focusNextDropdownOptionPort(0);
var $author$project$Ports$Dropdown$focusPrevDropdownOptionPort = _Platform_outgoingPort(
	'focusPrevDropdownOptionPort',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$Dropdown$focusPrevItem = $author$project$Ports$Dropdown$focusPrevDropdownOptionPort(0);
var $elm$browser$Browser$Dom$focus = _Browser_call('focus');
var $author$project$Ui$Dropdown$focusTrigger = F2(
	function (msg, id) {
		return A2(
			$elm$core$Task$attempt,
			$elm$core$Basics$always(msg),
			$elm$browser$Browser$Dom$focus(id + '-trigger'));
	});
var $author$project$Ports$Dropdown$dropdownSimulateClick = _Platform_outgoingPort(
	'dropdownSimulateClick',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$Dropdown$simulateClick = $author$project$Ports$Dropdown$dropdownSimulateClick(0);
var $author$project$Ports$Dropdown$submitFormDropdownPort = _Platform_outgoingPort(
	'submitFormDropdownPort',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$Dropdown$submitForm = $author$project$Ports$Dropdown$submitFormDropdownPort(0);
var $author$project$Ui$Dropdown$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{Yn: !model.Yn}),
					(!model.Yn) ? A2(
						$elm$core$Platform$Cmd$map,
						model.al6,
						$author$project$Ports$Dropdown$focusFirstItem(model.ahP)) : $elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{Yn: true}),
					$elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{Yn: true}),
					$elm$core$Platform$Cmd$none);
			case 3:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{Yn: !model.Yn}),
					(!model.Yn) ? A2(
						$elm$core$Platform$Cmd$map,
						model.al6,
						$author$project$Ports$Dropdown$focusFirstItem(model.ahP)) : $elm$core$Platform$Cmd$none);
			case 4:
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Platform$Cmd$map,
						model.al6,
						A2($author$project$Ui$Dropdown$focusTrigger, $author$project$Ui$Dropdown$MenuClosedAfterFocus, model.ahP)));
			case 5:
				var arrowDirection = msg.a;
				var openAndFocusFirst = _Utils_Tuple2(
					_Utils_update(
						model,
						{Yn: true}),
					$author$project$Ports$Dropdown$focusFirstItem(model.ahP));
				var _v1 = model.bv;
				switch (_v1) {
					case 0:
						if (arrowDirection === 1) {
							return openAndFocusFirst;
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					case 1:
						if (arrowDirection === 2) {
							return openAndFocusFirst;
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					case 4:
						if (arrowDirection === 1) {
							return openAndFocusFirst;
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					case 2:
						if (arrowDirection === 1) {
							return openAndFocusFirst;
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					default:
						if (arrowDirection === 1) {
							return openAndFocusFirst;
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
				}
			case 7:
				var direction = msg.a;
				switch (direction) {
					case 0:
						return _Utils_Tuple2(model, $author$project$Ports$Dropdown$focusPrevItem);
					case 1:
						return _Utils_Tuple2(model, $author$project$Ports$Dropdown$focusNextItem);
					case 2:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					default:
						return (model.bv === 1) ? _Utils_Tuple2(
							_Utils_update(
								model,
								{Yn: false}),
							A2(
								$elm$core$Platform$Cmd$map,
								model.al6,
								A2($author$project$Ui$Dropdown$focusTrigger, $author$project$Ui$Dropdown$NoOp, model.ahP))) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 6:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 8:
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Platform$Cmd$map,
						model.al6,
						A2($author$project$Ui$Dropdown$focusTrigger, $author$project$Ui$Dropdown$MenuClosedAfterFocus, model.ahP)));
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{Yn: false}),
					$elm$core$Platform$Cmd$none);
			case 10:
				return _Utils_Tuple2(
					model,
					A2($elm$core$Platform$Cmd$map, model.al6, $author$project$Ports$Dropdown$focusInnerInput));
			case 11:
				return _Utils_Tuple2(
					model,
					A2($elm$core$Platform$Cmd$map, model.al6, $author$project$Ports$Dropdown$focusInnerLink));
			case 12:
				var id = msg.a;
				return _Utils_eq(model.ahP, id) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{Yn: false}),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 13:
				return _Utils_Tuple2(model, $author$project$Ports$Dropdown$submitForm);
			default:
				return _Utils_Tuple2(
					model,
					A2($elm$core$Platform$Cmd$map, model.al6, $author$project$Ports$Dropdown$simulateClick));
		}
	});
var $author$project$Components$ProviderCredentials$updateLicenseDropdown = F2(
	function (cfg, model) {
		var fields = $author$project$Utils$Form$fields(model.SD);
		var license = A2(
			$elm$core$Maybe$withDefault,
			A3($author$project$Components$ProviderCredentials$blankLicense, cfg.sG, cfg.nn, cfg.qw),
			$elm$core$List$head(
				A2(
					$elm$core$List$drop,
					cfg.sG,
					cfg.nP(fields))));
		var _v0 = A2($author$project$Ui$Dropdown$update, cfg.Hw, license.fj);
		var newDropdown = _v0.a;
		var dropdownCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					SD: A3(
						$author$project$Utils$Form$update,
						$author$project$Components$ProviderCredentials$formFieldsUpdate(model.FR),
						A2(cfg.qx, cfg.sG, newDropdown),
						model.SD)
				}),
			dropdownCmd);
	});
var $author$project$Components$DateInput$None = {$: 0};
var $author$project$Components$DateInput$Picked = function (a) {
	return {$: 1, a: a};
};
var $agustinrhcp$elm_datepicker$DatePicker$Disabled = function (a) {
	return {$: 2, a: a};
};
var $agustinrhcp$elm_datepicker$DatePicker$EmptyString = {$: 1};
var $agustinrhcp$elm_datepicker$DatePicker$FailedInput = function (a) {
	return {$: 1, a: a};
};
var $agustinrhcp$elm_datepicker$DatePicker$Invalid = function (a) {
	return {$: 0, a: a};
};
var $agustinrhcp$elm_datepicker$DatePicker$None = {$: 0};
var $agustinrhcp$elm_datepicker$DatePicker$Picked = function (a) {
	return {$: 2, a: a};
};
var $agustinrhcp$elm_datepicker$DatePicker$update = F3(
	function (settings, msg, _v0) {
		var model = _v0;
		var forceOpen = model.gt;
		switch (msg.$) {
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bC: $elm$core$Maybe$Just(date),
							FR: date
						}),
					$agustinrhcp$elm_datepicker$DatePicker$None);
			case 1:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bC: $elm$core$Maybe$Just(date)
						}),
					$agustinrhcp$elm_datepicker$DatePicker$None);
			case 10:
				var date = msg.a;
				var pickable = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bC: $elm$core$Maybe$Just(date),
							kF: pickable
						}),
					$agustinrhcp$elm_datepicker$DatePicker$None);
			case 9:
				var pickable = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{kF: pickable}),
					$agustinrhcp$elm_datepicker$DatePicker$None);
			case 2:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bC: $elm$core$Maybe$Nothing, cH: $elm$core$Maybe$Nothing, Yn: false}),
					$agustinrhcp$elm_datepicker$DatePicker$Picked(date));
			case 3:
				var text = msg.a;
				var _v2 = settings.ajM(text);
				if (!_v2.$) {
					var date = _v2.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bC: $elm$core$Maybe$Just(date),
								cH: $elm$core$Maybe$Just(text),
								Yn: true
							}),
						$agustinrhcp$elm_datepicker$DatePicker$Picked(date));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								cH: $elm$core$Maybe$Just(text),
								Yn: true
							}),
						$agustinrhcp$elm_datepicker$DatePicker$None);
				}
			case 4:
				if (forceOpen) {
					return _Utils_Tuple2(model, $agustinrhcp$elm_datepicker$DatePicker$None);
				} else {
					var dateEvent = function () {
						var _v5 = model.cH;
						if (_v5.$ === 1) {
							return $agustinrhcp$elm_datepicker$DatePicker$FailedInput($agustinrhcp$elm_datepicker$DatePicker$EmptyString);
						} else {
							if (_v5.a === '') {
								return $agustinrhcp$elm_datepicker$DatePicker$FailedInput($agustinrhcp$elm_datepicker$DatePicker$EmptyString);
							} else {
								var rawInput = _v5.a;
								var _v6 = settings.ajM(rawInput);
								if (!_v6.$) {
									var date = _v6.a;
									return settings.aib(date) ? $agustinrhcp$elm_datepicker$DatePicker$FailedInput(
										$agustinrhcp$elm_datepicker$DatePicker$Disabled(date)) : $agustinrhcp$elm_datepicker$DatePicker$Picked(date);
								} else {
									var e = _v6.a;
									return $agustinrhcp$elm_datepicker$DatePicker$FailedInput(
										$agustinrhcp$elm_datepicker$DatePicker$Invalid(e));
								}
							}
						}
					}();
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bC: function () {
									if (dateEvent.$ === 2) {
										var date = dateEvent.a;
										return $elm$core$Maybe$Just(date);
									} else {
										return model.bC;
									}
								}(),
								cH: function () {
									if (dateEvent.$ === 2) {
										return $elm$core$Maybe$Nothing;
									} else {
										return model.cH;
									}
								}()
							}),
						dateEvent);
				}
			case 5:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{gt: false, Yn: true}),
					$agustinrhcp$elm_datepicker$DatePicker$None);
			case 6:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{Yn: forceOpen}),
					$agustinrhcp$elm_datepicker$DatePicker$None);
			case 7:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{gt: true}),
					$agustinrhcp$elm_datepicker$DatePicker$None);
			case 8:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{gt: false}),
					$agustinrhcp$elm_datepicker$DatePicker$None);
			default:
				var keyCode = msg.a;
				if (keyCode === 27) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{Yn: false}),
						$agustinrhcp$elm_datepicker$DatePicker$None);
				} else {
					return _Utils_Tuple2(model, $agustinrhcp$elm_datepicker$DatePicker$None);
				}
		}
	});
var $author$project$Components$DateInput$update = F2(
	function (msg, model) {
		var datePickerSettings_ = msg.a;
		var subMsg = msg.b;
		var _v1 = A3($agustinrhcp$elm_datepicker$DatePicker$update, datePickerSettings_, subMsg, model.na);
		var datePicker = _v1.a;
		var datePickerEvent = _v1.b;
		var event = function () {
			_v2$2:
			while (true) {
				switch (datePickerEvent.$) {
					case 2:
						var date_ = datePickerEvent.a;
						return $author$project$Components$DateInput$Picked(
							$elm$core$Maybe$Just(date_));
					case 1:
						if (datePickerEvent.a.$ === 1) {
							var _v3 = datePickerEvent.a;
							return $author$project$Components$DateInput$Picked($elm$core$Maybe$Nothing);
						} else {
							break _v2$2;
						}
					default:
						break _v2$2;
				}
			}
			return $author$project$Components$DateInput$None;
		}();
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{na: datePicker}),
			$elm$core$Platform$Cmd$none,
			event);
	});
var $author$project$Components$ProviderCredentials$updateLicenseExpiration = F2(
	function (cfg, model) {
		var fields = $author$project$Utils$Form$fields(model.SD);
		var license = A2(
			$elm$core$Maybe$withDefault,
			A3($author$project$Components$ProviderCredentials$blankLicense, cfg.sG, cfg.nn, cfg.qw),
			$elm$core$List$head(
				A2(
					$elm$core$List$drop,
					cfg.sG,
					cfg.nP(fields))));
		var _v0 = license.M;
		var prevValue = _v0.a;
		var prevInput = _v0.b;
		var _v1 = A2($author$project$Components$DateInput$update, cfg.FF, prevInput);
		var dateInput = _v1.a;
		var dateInputCmd = _v1.b;
		var event = _v1.c;
		var newValue = function () {
			if (event.$ === 1) {
				var date = event.a;
				return date;
			} else {
				return prevValue;
			}
		}();
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					SD: A3(
						$author$project$Utils$Form$update,
						$author$project$Components$ProviderCredentials$formFieldsUpdate(model.FR),
						A2(
							cfg.qx,
							cfg.sG,
							_Utils_Tuple2(newValue, dateInput)),
						model.SD)
				}),
			A2(
				$elm$core$Platform$Cmd$map,
				$elm$core$Basics$always(
					cfg.al6(cfg.FF)),
				dateInputCmd));
	});
var $author$project$Components$ProviderCredentials$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var field = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							SD: A3(
								$author$project$Utils$Form$update,
								$author$project$Components$ProviderCredentials$formFieldsUpdate(model.FR),
								field,
								model.SD)
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var index = msg.a;
				var subMsg = msg.b;
				return A2(
					$author$project$Components$ProviderCredentials$updateLicenseExpiration,
					{
						nn: 'dea-dropdown-',
						nP: function ($) {
							return $.nb;
						},
						sG: index,
						FF: subMsg,
						qw: $author$project$Components$ProviderCredentials$DeaStateDropdownMsg,
						qx: $author$project$Components$ProviderCredentials$DeaExpirationAt,
						al6: $author$project$Components$ProviderCredentials$MultiDeaExpirationMsg(index)
					},
					model);
			case 2:
				var index = msg.a;
				var dropdownMsg = msg.b;
				return A2(
					$author$project$Components$ProviderCredentials$updateLicenseDropdown,
					{
						nn: 'dea-dropdown-',
						Hw: dropdownMsg,
						nP: function ($) {
							return $.nb;
						},
						sG: index,
						qw: $author$project$Components$ProviderCredentials$DeaStateDropdownMsg,
						qx: $author$project$Components$ProviderCredentials$DeaStateDropdownAt
					},
					model);
			case 3:
				var index = msg.a;
				var subMsg = msg.b;
				return A2(
					$author$project$Components$ProviderCredentials$updateLicenseExpiration,
					{
						nn: 'state-dropdown-',
						nP: function ($) {
							return $.qm;
						},
						sG: index,
						FF: subMsg,
						qw: $author$project$Components$ProviderCredentials$StateLicenseStateDropdownMsg,
						qx: $author$project$Components$ProviderCredentials$StateLicenseExpirationAt,
						al6: $author$project$Components$ProviderCredentials$StateLicenseExpirationMsg(index)
					},
					model);
			default:
				var index = msg.a;
				var dropdownMsg = msg.b;
				return A2(
					$author$project$Components$ProviderCredentials$updateLicenseDropdown,
					{
						nn: 'state-dropdown-',
						Hw: dropdownMsg,
						nP: function ($) {
							return $.qm;
						},
						sG: index,
						qw: $author$project$Components$ProviderCredentials$StateLicenseStateDropdownMsg,
						qx: $author$project$Components$ProviderCredentials$StateLicenseStateDropdownAt
					},
					model);
		}
	});
var $rtfeldman$elm_validate$Validate$Valid = $elm$core$Basics$identity;
var $rtfeldman$elm_validate$Validate$validate = F2(
	function (_v0, subject) {
		var getErrors = _v0;
		var _v1 = getErrors(subject);
		if (!_v1.b) {
			return $elm$core$Result$Ok(subject);
		} else {
			var errors = _v1;
			return $elm$core$Result$Err(errors);
		}
	});
var $author$project$Utils$Form$validate = F2(
	function (formFieldsValidator, _v0) {
		var originalFields = _v0.a;
		var fields_ = _v0.c;
		var _v1 = A2($rtfeldman$elm_validate$Validate$validate, formFieldsValidator, fields_);
		if (!_v1.$) {
			var validForm = _v1.a;
			return $elm$core$Result$Ok(
				_Utils_Tuple2(
					A4($author$project$Utils$Form$Form, originalFields, true, fields_, _List_Nil),
					validForm));
		} else {
			var errors_ = _v1.a;
			return $elm$core$Result$Err(
				A4($author$project$Utils$Form$Form, originalFields, true, fields_, errors_));
		}
	});
var $rtfeldman$elm_validate$Validate$Validator = $elm$core$Basics$identity;
var $rtfeldman$elm_validate$Validate$all = function (validators) {
	var newGetErrors = function (subject) {
		var accumulateErrors = F2(
			function (_v0, totalErrors) {
				var getErrors = _v0;
				return _Utils_ap(
					totalErrors,
					getErrors(subject));
			});
		return A3($elm$core$List$foldl, accumulateErrors, _List_Nil, validators);
	};
	return newGetErrors;
};
var $rtfeldman$elm_validate$Validate$fromErrors = function (toErrors) {
	return toErrors;
};
var $author$project$Components$ProviderCredentials$DeaValidation = 2;
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $author$project$Components$ProviderCredentials$deaNumberValid = function (deaNumber) {
	var remainingChars = A3($elm$core$String$slice, 2, 9, deaNumber);
	var firstChar = A2($elm$core$String$left, 1, deaNumber);
	var isFirstCharLetter = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			$elm$core$Char$isAlpha,
			$elm$core$List$head(
				$elm$core$String$toList(firstChar))));
	var areRemainingCharsNumbers = A2(
		$elm$core$List$all,
		$elm$core$Char$isDigit,
		$elm$core$String$toList(remainingChars));
	return ($elm$core$String$length(deaNumber) >= 9) && (isFirstCharLetter && areRemainingCharsNumbers);
};
var $justinmimbs$date$Date$compare = F2(
	function (_v0, _v1) {
		var a = _v0;
		var b = _v1;
		return A2($elm$core$Basics$compare, a, b);
	});
var $author$project$Utils$Date$isBefore = F2(
	function (date, otherDate) {
		return !A2($justinmimbs$date$Date$compare, date, otherDate);
	});
var $author$project$Utils$String$notBlank = function (string) {
	return !$author$project$Utils$String$isBlank(string);
};
var $author$project$Utils$String$isMaybeNotBlank = function (maybeString) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2($elm$core$Maybe$map, $author$project$Utils$String$notBlank, maybeString));
};
var $author$project$Components$ProviderCredentials$validateLicenseFields = function (_v0) {
	var number = _v0.IO;
	var state = _v0.uP;
	var expiration = _v0.M;
	var today = _v0.FR;
	var validationGroup = _v0.l0;
	var numberValidator = _v0.IP;
	var licenseType = _v0.Iq;
	var skipIfEmpty = _v0.JO;
	var hasState = $author$project$Utils$String$isMaybeNotBlank(state);
	var hasNumber = $author$project$Utils$String$isMaybeNotBlank(number);
	var hasExpiration = !_Utils_eq(expiration, $elm$core$Maybe$Nothing);
	var anyFieldFilled = hasNumber || (hasState || hasExpiration);
	if (skipIfEmpty && (!anyFieldFilled)) {
		return _List_Nil;
	} else {
		var missingFieldErrors = (!(hasNumber && (hasState && hasExpiration))) ? _List_fromArray(
			[
				_Utils_Tuple2(validationGroup, 'Please complete all ' + (licenseType + ' fields.'))
			]) : _List_Nil;
		var formatErrors = function () {
			if (!number.$) {
				var licenseNumber = number.a;
				var _v3 = numberValidator(licenseNumber);
				if (!_v3.$) {
					var errorMsg = _v3.a;
					return _List_fromArray(
						[
							_Utils_Tuple2(validationGroup, errorMsg)
						]);
				} else {
					return _List_Nil;
				}
			} else {
				return _List_Nil;
			}
		}();
		var expirationErrors = function () {
			if (!expiration.$) {
				var date = expiration.a;
				return A2($author$project$Utils$Date$isBefore, date, today) ? _List_fromArray(
					[
						_Utils_Tuple2(
						validationGroup,
						$elm$core$String$toUpper(licenseType) + ' expiration date cannot be in the past.')
					]) : _List_Nil;
			} else {
				return _List_Nil;
			}
		}();
		return _Utils_ap(
			missingFieldErrors,
			_Utils_ap(formatErrors, expirationErrors));
	}
};
var $author$project$Components$ProviderCredentials$validateDeaNumbersField = F3(
	function (requireDea, today, fields) {
		var numberValidator = function (deaNumber) {
			return (!$author$project$Components$ProviderCredentials$deaNumberValid(deaNumber)) ? $elm$core$Maybe$Just('Please enter a valid DEA number in the format AB1234567.') : $elm$core$Maybe$Nothing;
		};
		return $elm$core$List$isEmpty(fields.nb) ? (requireDea ? _List_fromArray(
			[
				_Utils_Tuple2(2, 'Please add at least one DEA registration.')
			]) : _List_Nil) : A2(
			$elm$core$List$concatMap,
			function (license) {
				return $author$project$Components$ProviderCredentials$validateLicenseFields(
					{M: license.M.a, Iq: 'DEA', IO: license.IO, IP: numberValidator, JO: !requireDea, uP: license.uP, FR: today, l0: 2});
			},
			fields.nb);
	});
var $author$project$Components$ProviderCredentials$DegreeValidation = 1;
var $author$project$Components$ProviderCredentials$validateDegreeField = function (fields) {
	var _v0 = A2($elm$core$Maybe$withDefault, '', fields.Hp);
	if (_v0 === '') {
		return _List_fromArray(
			[
				_Utils_Tuple2(1, 'Please enter your degree.')
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$ProviderCredentials$NpiValidation = 0;
var $ahstro$elm_luhn$Helpers$checksum = F2(
	function (checkDigit, sum) {
		return (!A2($elm$core$Basics$modBy, 10, sum + checkDigit)) ? $elm$core$Result$Ok(true) : $elm$core$Result$Err('Incorrect checksum');
	});
var $ahstro$elm_luhn$Helpers$doubleAtEvenIndices = $elm$core$List$indexedMap(
	F2(
		function (index, num) {
			return (!A2($elm$core$Basics$modBy, 2, index)) ? (num * 2) : num;
		}));
var $ahstro$elm_luhn$Helpers$keepUnder10 = function (num) {
	return (num >= 10) ? (num - 9) : num;
};
var $ahstro$elm_luhn$Helpers$notEmpty = function (nums) {
	return $elm$core$List$isEmpty(nums) ? $elm$core$Result$Err('Input string is only check digit') : $elm$core$Result$Ok(nums);
};
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $ahstro$elm_luhn$Helpers$toListOfInt = function (strings) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (numberString, acc) {
				var _v0 = $elm$core$String$toInt(numberString);
				if (!_v0.$) {
					var num = _v0.a;
					return A2(
						$elm$core$Result$map,
						$elm$core$List$cons(num),
						acc);
				} else {
					return $elm$core$Result$Err('Not a number: ' + numberString);
				}
			}),
		$elm$core$Result$Ok(_List_Nil),
		$elm$core$List$reverse(strings));
};
var $ahstro$elm_luhn$Luhn$validate = function (numberString) {
	var numbers = $ahstro$elm_luhn$Helpers$toListOfInt(
		$elm$core$List$reverse(
			A2($elm$core$String$split, '', numberString)));
	var checkDigit = A2(
		$elm$core$Result$withDefault,
		0,
		A2(
			$elm$core$Result$andThen,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Result$fromMaybe('Input string is empty'),
				$elm$core$List$head),
			numbers));
	return A2(
		$elm$core$Result$map,
		function (_v0) {
			return numberString;
		},
		A2(
			$elm$core$Result$andThen,
			$ahstro$elm_luhn$Helpers$checksum(checkDigit),
			A2(
				$elm$core$Result$map,
				$elm$core$List$sum,
				A2(
					$elm$core$Result$map,
					$elm$core$List$map($ahstro$elm_luhn$Helpers$keepUnder10),
					A2(
						$elm$core$Result$map,
						$ahstro$elm_luhn$Helpers$doubleAtEvenIndices,
						A2(
							$elm$core$Result$andThen,
							$ahstro$elm_luhn$Helpers$notEmpty,
							A2(
								$elm$core$Result$andThen,
								A2(
									$elm$core$Basics$composeL,
									$elm$core$Result$fromMaybe('Input string is empty'),
									$elm$core$List$tail),
								numbers)))))));
};
var $ahstro$elm_luhn$Luhn$isValid = function (numberString) {
	var _v0 = $ahstro$elm_luhn$Luhn$validate(numberString);
	if (!_v0.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$ProviderCredentials$npiPrefix = '80840';
var $author$project$Components$ProviderCredentials$isValidNpi = function (npi) {
	return ($elm$core$String$length(npi) === 10) && $ahstro$elm_luhn$Luhn$isValid(
		_Utils_ap($author$project$Components$ProviderCredentials$npiPrefix, npi));
};
var $author$project$Components$ProviderCredentials$validateNpiField = function (fields) {
	var message = _List_fromArray(
		[
			_Utils_Tuple2(0, 'Please enter a valid 10-digit NPI number.')
		]);
	var _v0 = fields.X0;
	if (!_v0.$) {
		var npi = _v0.a;
		return $author$project$Components$ProviderCredentials$isValidNpi(npi) ? _List_Nil : message;
	} else {
		return message;
	}
};
var $author$project$Components$ProviderCredentials$StateLicenseValidation = 3;
var $author$project$Components$ProviderCredentials$validateStateLicensesField = F2(
	function (today, fields) {
		return $elm$core$List$isEmpty(fields.qm) ? _List_fromArray(
			[
				_Utils_Tuple2(3, 'Please add at least one state license.')
			]) : A2(
			$elm$core$List$concatMap,
			function (license) {
				var isAlphanumeric = function (str) {
					return A2(
						$elm$core$String$all,
						function (c) {
							return $elm$core$Char$isAlphaNum(c);
						},
						str);
				};
				var numberValidator = function (licenseNumber) {
					return (!isAlphanumeric(licenseNumber)) ? $elm$core$Maybe$Just('State license numbers must contain only letters and numbers.') : $elm$core$Maybe$Nothing;
				};
				return $author$project$Components$ProviderCredentials$validateLicenseFields(
					{M: license.M.a, Iq: 'state license', IO: license.IO, IP: numberValidator, JO: false, uP: license.uP, FR: today, l0: 3});
			},
			fields.qm);
	});
var $author$project$Components$ProviderCredentials$validator = F2(
	function (config, today) {
		return $rtfeldman$elm_validate$Validate$all(
			A2(
				$elm$core$List$cons,
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$ProviderCredentials$validateNpiField),
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$ProviderCredentials$validateDegreeField),
					A2(
						$elm$core$List$cons,
						$rtfeldman$elm_validate$Validate$fromErrors(
							$author$project$Components$ProviderCredentials$validateStateLicensesField(today)),
						config.abl ? _List_fromArray(
							[
								$rtfeldman$elm_validate$Validate$fromErrors(
								A2($author$project$Components$ProviderCredentials$validateDeaNumbersField, config.akP, today))
							]) : _List_Nil))));
	});
var $author$project$Components$ProviderCredentials$validate = F2(
	function (config, _v0) {
		var model = _v0;
		return A2(
			$elm$core$Result$mapError,
			function (validatedForm) {
				return _Utils_update(
					model,
					{SD: validatedForm});
			},
			A2(
				$elm$core$Result$map,
				function (_v1) {
					var validatedForm = _v1.a;
					return _Utils_update(
						model,
						{SD: validatedForm});
				},
				A2(
					$author$project$Utils$Form$validate,
					A2($author$project$Components$ProviderCredentials$validator, config, model.FR),
					model.SD)));
	});
var $author$project$Pages$Account$Complete$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Components$ProviderCredentials$update, subMsg, model.bW);
				var newCredentials = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bW: newCredentials}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Account$Complete$CredentialsMsg, cmd),
					_List_Nil);
			case 1:
				var _v2 = A2(
					$author$project$Components$ProviderCredentials$validate,
					{akP: true, abl: true},
					model.bW);
				if (!_v2.$) {
					var validatedCredentials = _v2.a;
					var apiFields = $author$project$Components$ProviderCredentials$toApiFields(validatedCredentials);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bW: validatedCredentials, lA: true}),
						A3($author$project$Api$Provider$TeamMember$completeCredentials, model.Gv, apiFields, $author$project$Pages$Account$Complete$SubmitResponse),
						_List_Nil);
				} else {
					var invalidCredentials = _v2.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bW: invalidCredentials}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{lA: false}),
						A2($author$project$Utils$Route$navigateAndReload, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Top),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Credentials saved.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{lA: false}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Account$Complete$SubmitClicked = {$: 1};
var $author$project$Ui$Grid$Col = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Ui$Grid$column = $author$project$Ui$Grid$Col;
var $author$project$Ui$Button$Disabled = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Button$disabled = $author$project$Ui$Button$Disabled;
var $author$project$Api$Platform$User$Shared$firstName = function (_v0) {
	var record = _v0;
	return record.Sv;
};
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $elm$html$Html$h3 = _VirtualDom_node('h3');
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $author$project$Ui$Typography$heading = function (content) {
	return A2(
		$elm$html$Html$map,
		$elm$core$Basics$never,
		A2(
			$elm$html$Html$h3,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-heading-md text-main')
				]),
			content));
};
var $author$project$Ui$Element$Alignment = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Alignment$Content = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Alignment$End = 2;
var $author$project$Ui$Alignment$justifyEnd = $author$project$Ui$Alignment$Content(2);
var $author$project$Ui$Element$justifyRight = $author$project$Ui$Element$Alignment($author$project$Ui$Alignment$justifyEnd);
var $author$project$Ui$Element$Margin = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Element$mt4 = $author$project$Ui$Element$Margin('mt-4');
var $author$project$Api$Provider$Practice$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$Practice$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$name(shared);
};
var $author$project$Ui$Grid$Offset = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Ui$ScreenSize$Xs = 0;
var $author$project$Ui$Grid$offset = $author$project$Ui$Grid$Offset(0);
var $author$project$Ui$Button$OnClick = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Button$onClick = function (msg) {
	return $author$project$Ui$Button$OnClick(msg);
};
var $elm$virtual_dom$VirtualDom$mapAttribute = _VirtualDom_mapAttribute;
var $elm$html$Html$Attributes$map = $elm$virtual_dom$VirtualDom$mapAttribute;
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $author$project$Api$Phi$maskElement = $elm$html$Html$Attributes$class('fs-mask');
var $author$project$Api$Phi$displayAttr = _List_fromArray(
	[
		$author$project$Api$Phi$maskElement,
		A2($elm$html$Html$Attributes$attribute, 'data-recording-sensitive', '')
	]);
var $author$project$Ui$Alignment$toClassName = function (alignment) {
	switch (alignment.$) {
		case 0:
			switch (alignment.a) {
				case 0:
					var _v1 = alignment.a;
					return 'text-left';
				case 1:
					var _v2 = alignment.a;
					return 'text-center';
				default:
					var _v3 = alignment.a;
					return 'text-right';
			}
		case 1:
			switch (alignment.a) {
				case 0:
					var _v4 = alignment.a;
					return 'flex items-start';
				case 1:
					var _v5 = alignment.a;
					return 'flex items-center';
				default:
					var _v6 = alignment.a;
					return 'flex items-end';
			}
		case 2:
			switch (alignment.a) {
				case 0:
					var _v7 = alignment.a;
					return 'flex justify-start';
				case 1:
					var _v8 = alignment.a;
					return 'flex justify-center';
				default:
					var _v9 = alignment.a;
					return 'flex justify-end';
			}
		case 3:
			switch (alignment.a) {
				case 1:
					var _v10 = alignment.a;
					return 'flex justify-around';
				case 0:
					var _v11 = alignment.a;
					return 'flex justify-between';
				default:
					var _v12 = alignment.a;
					return 'flex justify-evenly';
			}
		default:
			switch (alignment.a) {
				case 0:
					var _v13 = alignment.a;
					return 'flex self-start';
				case 1:
					var _v14 = alignment.a;
					return 'flex self-center';
				default:
					var _v15 = alignment.a;
					return 'flex self-end';
			}
	}
};
var $author$project$Ui$Alignment$toAttrs = function (alignment) {
	return _List_fromArray(
		[
			$elm$html$Html$Attributes$class(
			$author$project$Ui$Alignment$toClassName(alignment))
		]);
};
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $author$project$Ui$OverflowWrap$toAttrs = function (overflowWrap) {
	var value = function () {
		switch (overflowWrap) {
			case 0:
				return 'break-word';
			case 2:
				return 'anywhere';
			case 1:
				return 'normal';
			default:
				return 'break-all';
		}
	}();
	return _List_fromArray(
		[
			A2($elm$html$Html$Attributes$style, 'overflow-wrap', value)
		]);
};
var $author$project$Ui$FontWeight$toClass = function (direction) {
	if (!direction) {
		return $elm$html$Html$Attributes$class('font-medium');
	} else {
		return $elm$html$Html$Attributes$class('font-normal');
	}
};
var $author$project$Ui$Typography$optionToAttributes = function (option) {
	switch (option.$) {
		case 0:
			var list = option.a;
			return list;
		case 2:
			var alignment = option.a;
			return $author$project$Ui$Alignment$toAttrs(alignment);
		case 3:
			var overflowWrap_ = option.a;
			return $author$project$Ui$OverflowWrap$toAttrs(overflowWrap_);
		case 4:
			var decoration = option.a;
			switch (decoration) {
				case 2:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('italic')
						]);
				case 0:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('underline')
						]);
				case 1:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('line-through')
						]);
				case 3:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('font-bold')
						]);
				case 4:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('font-medium')
						]);
				default:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('capitalize')
						]);
			}
		case 1:
			var color = option.a;
			switch (color) {
				case 0:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-muted')
						]);
				case 1:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-primary')
						]);
				case 5:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-danger')
						]);
				case 2:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-success')
						]);
				case 4:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-warning')
						]);
				case 3:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-info')
						]);
				case 6:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-primary-500')
						]);
				default:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-main')
						]);
			}
		case 5:
			var bool = option.a;
			return bool ? $author$project$Api$Phi$displayAttr : _List_Nil;
		case 6:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-xs')
				]);
		case 7:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-body-sm text-muted')
				]);
		case 8:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('help-text')
				]);
		case 9:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('amount')
				]);
		case 10:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('badge')
				]);
		case 11:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('control-label')
				]);
		case 12:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('whitespace-pre-wrap')
				]);
		case 13:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('truncate')
				]);
		case 14:
			var fontWeight_ = option.a;
			return _List_fromArray(
				[
					$author$project$Ui$FontWeight$toClass(fontWeight_)
				]);
		case 15:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-label-md text-muted')
				]);
		case 16:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-body-md')
				]);
		case 17:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('subtotal')
				]);
		case 18:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('age')
				]);
		case 19:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('xs:hidden')
				]);
		case 20:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('sm:hidden')
				]);
		case 21:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('md:hidden')
				]);
		case 22:
			var bool = option.a;
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('content-disabled', bool)
						]))
				]);
		case 23:
			var bool = option.a;
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('inactive', bool)
						]))
				]);
		case 24:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('sr-only')
				]);
		case 25:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('highlighted')
				]);
		default:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('w-full')
				]);
	}
};
var $author$project$Ui$Typography$optionsToAttributes = function (options) {
	return A2(
		$elm$core$List$map,
		$elm$html$Html$Attributes$map($elm$core$Basics$never),
		A2($elm$core$List$concatMap, $author$project$Ui$Typography$optionToAttributes, options));
};
var $elm$html$Html$p = _VirtualDom_node('p');
var $author$project$Ui$Typography$p = F2(
	function (options, content) {
		return A2(
			$elm$html$Html$p,
			$author$project$Ui$Typography$optionsToAttributes(options),
			content);
	});
var $author$project$Ui$Button$Primary = 1;
var $author$project$Ui$Button$Styled = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Button$primary = $author$project$Ui$Button$Styled(1);
var $author$project$Ui$Element$Padding = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Element$py4 = $author$project$Ui$Element$Padding('py-4');
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $author$project$Utils$Html$Attributes$test = $elm$html$Html$Attributes$attribute('data-test');
var $author$project$Ui$Alignment$toClass = function (alignment) {
	return $elm$html$Html$Attributes$class(
		$author$project$Ui$Alignment$toClassName(alignment));
};
var $author$project$Ui$ScreenSize$toClassPrefix = function (screenSize) {
	switch (screenSize) {
		case 0:
			return '';
		case 1:
			return 'sm:';
		case 2:
			return 'md:';
		case 3:
			return 'lg:';
		default:
			return 'xl:';
	}
};
var $author$project$Ui$Element$optionToAttribute = function (option) {
	switch (option.$) {
		case 1:
			var alignment = option.a;
			return _List_fromArray(
				[
					$author$project$Ui$Alignment$toClass(alignment)
				]);
		case 0:
			var screenSize = option.a;
			var display = option.b;
			return $elm$core$List$singleton(
				function () {
					switch (display) {
						case 0:
							return $elm$html$Html$Attributes$class(
								$author$project$Ui$ScreenSize$toClassPrefix(screenSize) + 'block');
						case 1:
							return $elm$html$Html$Attributes$class(
								$author$project$Ui$ScreenSize$toClassPrefix(screenSize) + 'inline-block');
						case 2:
							return $elm$html$Html$Attributes$class(
								$author$project$Ui$ScreenSize$toClassPrefix(screenSize) + 'flex');
						default:
							return $elm$html$Html$Attributes$class(
								$author$project$Ui$ScreenSize$toClassPrefix(screenSize) + 'inline-flex');
					}
				}());
		case 2:
			var paddingClass = option.a;
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class(paddingClass)
				]);
		case 3:
			var marginClass = option.a;
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class(marginClass)
				]);
		case 4:
			var widthClass = option.a;
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class(widthClass)
				]);
		case 5:
			var maxHeightClass = option.a;
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class(maxHeightClass)
				]);
		case 6:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('overflow-y-auto overflow-x-clip')
				]);
		case 7:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('relative')
				]);
		case 9:
			var style = option.a;
			return $elm$core$List$singleton(
				function () {
					switch (style) {
						case 0:
							return $elm$html$Html$Attributes$class('text-muted');
						case 1:
							return $elm$html$Html$Attributes$class('text-body-sm');
						case 2:
							return $elm$html$Html$Attributes$class('text-body-md');
						case 3:
							return $elm$html$Html$Attributes$class('text-title-md');
						case 4:
							return $elm$html$Html$Attributes$class('font-bold');
						default:
							return $elm$html$Html$Attributes$class('text-danger');
					}
				}());
		case 10:
			var testString = option.a;
			return _List_fromArray(
				[
					$author$project$Utils$Html$Attributes$test(testString)
				]);
		case 8:
			var _v3 = option.a;
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-primary-50')
				]);
		case 11:
			var screenSize = option.a;
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					$author$project$Ui$ScreenSize$toClassPrefix(screenSize) + 'hidden')
				]);
		case 12:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-wrap')
				]);
		case 13:
			var val = option.a;
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					'flex gap-' + $elm$core$String$fromInt(val))
				]);
		case 14:
			var val = option.a;
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					'space-x-' + $elm$core$String$fromInt(val))
				]);
		case 15:
			var val = option.a;
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					'space-y-' + $elm$core$String$fromInt(val))
				]);
		case 28:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('divide-y divide-gray-200')
				]);
		case 16:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex-auto')
				]);
		case 17:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex-1')
				]);
		case 18:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('shrink-0')
				]);
		case 19:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('whitespace-pre-wrap')
				]);
		case 20:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('items-stretch')
				]);
		case 21:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('h-full')
				]);
		case 22:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('w-full')
				]);
		case 23:
			return $author$project$Api$Phi$displayAttr;
		case 24:
			var screenSize = option.a;
			var dir = option.b;
			return $elm$core$List$singleton(
				function () {
					if (!dir) {
						return $elm$html$Html$Attributes$class(
							$author$project$Ui$ScreenSize$toClassPrefix(screenSize) + 'flex-row');
					} else {
						return $elm$html$Html$Attributes$class(
							$author$project$Ui$ScreenSize$toClassPrefix(screenSize) + 'flex-col');
					}
				}());
		case 25:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('group')
				]);
		case 26:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('opacity-0 transition-opacity group-hover:opacity-100 group-focus-within:opacity-100')
				]);
		default:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('min-w-0')
				]);
	}
};
var $author$project$Ui$Element$optionsToAttributes = $elm$core$List$concatMap(
	A2(
		$elm$core$Basics$composeR,
		$author$project$Ui$Element$optionToAttribute,
		$elm$core$List$map(
			$elm$html$Html$Attributes$map($elm$core$Basics$never))));
var $author$project$Ui$Element$customNode = F3(
	function (node, classes, options) {
		return A2(
			$elm$html$Html$node,
			node,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class(classes),
				$author$project$Ui$Element$optionsToAttributes(options)));
	});
var $author$project$Ui$Element$custom = F2(
	function (classes, options) {
		return A3($author$project$Ui$Element$customNode, 'div', classes, options);
	});
var $author$project$Ui$Grid$optionsToClasses = F2(
	function (toAttributesFunc, options) {
		return A2($elm$core$List$concatMap, toAttributesFunc, options);
	});
var $author$project$Ui$Grid$rowElementOptions = function (options) {
	return A2(
		$elm$core$List$filterMap,
		function (option) {
			if (!option.$) {
				var elemOption = option.a;
				return $elm$core$Maybe$Just(elemOption);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		options);
};
var $author$project$Ui$Grid$rowOptionToClass = function (option) {
	if (option.$ === 1) {
		switch (option.a) {
			case 0:
				var _v1 = option.a;
				return _List_fromArray(
					['gap-0']);
			case 1:
				var _v2 = option.a;
				return _List_fromArray(
					['gap-2']);
			case 2:
				var _v3 = option.a;
				return _List_fromArray(
					['gap-4']);
			default:
				var _v4 = option.a;
				return _List_fromArray(
					['gap-6']);
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$Ui$Grid$elementOptions = function (options) {
	return A2(
		$elm$core$List$concatMap,
		function (option) {
			if (option.$ === 5) {
				var elemOption = option.a;
				return _List_fromArray(
					[elemOption]);
			} else {
				return _List_Nil;
			}
		},
		options);
};
var $author$project$Ui$Grid$optionToClass = function (option) {
	optionToClass:
	while (true) {
		switch (option.$) {
			case 1:
				var screenSize = option.a;
				return _List_fromArray(
					[
						$author$project$Ui$ScreenSize$toClassPrefix(screenSize) + 'hidden'
					]);
			case 3:
				var screenSize = option.a;
				return _List_fromArray(
					[
						$author$project$Ui$ScreenSize$toClassPrefix(screenSize) + 'grid'
					]);
			case 0:
				var screenSize = option.a;
				var _int = option.b;
				return _List_fromArray(
					[
						$author$project$Ui$ScreenSize$toClassPrefix(screenSize) + ('col-span-' + $elm$core$String$fromInt(_int))
					]);
			case 4:
				var screenSize = option.a;
				var _int = option.b;
				return _List_fromArray(
					[
						$author$project$Ui$ScreenSize$toClassPrefix(screenSize) + ('col-start-' + $elm$core$String$fromInt(_int + 1))
					]);
			case 2:
				var _v1 = option.a;
				var bool = _v1.a;
				var opt = _v1.b;
				if (bool) {
					var $temp$option = opt;
					option = $temp$option;
					continue optionToClass;
				} else {
					return _List_Nil;
				}
			case 5:
				return _List_Nil;
			case 6:
				var _int = option.a;
				return _List_fromArray(
					[
						'gap-' + $elm$core$String$fromInt(_int)
					]);
			default:
				return _List_fromArray(
					['h-full']);
		}
	}
};
var $author$project$Ui$Grid$viewCol = function (col) {
	if (col.$ === 1) {
		var options = col.a;
		var content = col.b;
		return A3(
			$author$project$Ui$Element$custom,
			A2(
				$elm$core$String$join,
				' ',
				A2(
					$elm$core$List$cons,
					'grid-col',
					A2($author$project$Ui$Grid$optionsToClasses, $author$project$Ui$Grid$optionToClass, options))),
			$author$project$Ui$Grid$elementOptions(options),
			content);
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Ui$Grid$row = F2(
	function (options, columns) {
		return A3(
			$author$project$Ui$Element$custom,
			A2(
				$elm$core$String$join,
				' ',
				A2(
					$elm$core$List$cons,
					'grid-row',
					A2($author$project$Ui$Grid$optionsToClasses, $author$project$Ui$Grid$rowOptionToClass, options))),
			$author$project$Ui$Grid$rowElementOptions(options),
			A2($elm$core$List$map, $author$project$Ui$Grid$viewCol, columns));
	});
var $author$project$Ui$Grid$Span = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Ui$Grid$span = $author$project$Ui$Grid$Span(0);
var $author$project$Ui$Button$AriaLabel = function (a) {
	return {$: 15, a: a};
};
var $elm$html$Html$button = _VirtualDom_node('button');
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$json$Json$Decode$lazy = function (thunk) {
	return A2(
		$elm$json$Json$Decode$andThen,
		thunk,
		$elm$json$Json$Decode$succeed(0));
};
var $author$project$Utils$Dom$isOutsideTarget = function (id) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$andThen,
				function (elementId) {
					return _Utils_eq(id, elementId) ? $elm$json$Json$Decode$succeed(false) : $elm$json$Json$Decode$fail('continue');
				},
				A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string)),
				$elm$json$Json$Decode$lazy(
				function (_v0) {
					return A2(
						$elm$json$Json$Decode$field,
						'parentNode',
						$author$project$Utils$Dom$isOutsideTarget(id));
				}),
				$elm$json$Json$Decode$succeed(true)
			]));
};
var $author$project$Utils$Dom$blurOutside = F2(
	function (msg, id) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (isOutside) {
				return isOutside ? $elm$json$Json$Decode$succeed(msg) : $elm$json$Json$Decode$fail('blurred inside');
			},
			A2(
				$elm$json$Json$Decode$field,
				'relatedTarget',
				$author$project$Utils$Dom$isOutsideTarget(id)));
	});
var $author$project$Utils$Dom$onOutsideBlur = F2(
	function (msg, id) {
		return A2(
			$elm$html$Html$Events$on,
			'blur',
			A2($author$project$Utils$Dom$blurOutside, msg, id));
	});
var $author$project$Ui$Button$Plain = 12;
var $author$project$Ui$Icon$Cross = 50;
var $author$project$Ui$Icon$Class = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Icon$iconOptionToSvgOption = function (iconOption) {
	return $author$project$Ui$Icon$Class(
		function () {
			switch (iconOption.$) {
				case 0:
					switch (iconOption.a) {
						case 0:
							var _v1 = iconOption.a;
							return 'icon--xs';
						case 1:
							var _v2 = iconOption.a;
							return 'icon--sm';
						case 2:
							var _v3 = iconOption.a;
							return '';
						case 3:
							var _v4 = iconOption.a;
							return 'icon--lg';
						default:
							var _v5 = iconOption.a;
							return 'icon--xl';
					}
				case 1:
					switch (iconOption.a) {
						case 0:
							var _v6 = iconOption.a;
							return 'icon--danger';
						case 1:
							var _v7 = iconOption.a;
							return 'icon--primary';
						case 2:
							var _v8 = iconOption.a;
							return 'icon--info';
						case 3:
							var _v9 = iconOption.a;
							return 'icon--success';
						default:
							var _v10 = iconOption.a;
							return '';
					}
				case 7:
					return 'icon--circled';
				case 2:
					var deg = iconOption.a;
					return 'rotate-' + $elm$core$String$fromInt(deg);
				case 3:
					return 'ml-1';
				case 4:
					return 'mr-1';
				case 5:
					var _int = iconOption.a;
					return 'mb-' + $elm$core$String$fromInt(_int);
				case 6:
					var deg = iconOption.a;
					return 'rotate-' + $elm$core$String$fromInt(deg);
				default:
					return 'sidenav__icon';
			}
		}());
};
var $author$project$Ui$Icon$iconOptionsToSvgOptions = function (iconOptions) {
	return A2(
		$elm$core$List$cons,
		$author$project$Ui$Icon$Class('icon'),
		A2($elm$core$List$map, $author$project$Ui$Icon$iconOptionToSvgOption, iconOptions));
};
var $elm$virtual_dom$VirtualDom$nodeNS = F2(
	function (namespace, tag) {
		return A2(
			_VirtualDom_nodeNS,
			namespace,
			_VirtualDom_noScript(tag));
	});
var $elm$svg$Svg$node = $elm$virtual_dom$VirtualDom$nodeNS('http://www.w3.org/2000/svg');
var $author$project$Generated$Icons$account = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '-1.5 -1.5 19 19'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'stroke', 'currentColor'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'stroke-width', '0.6'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'stroke-linejoin', 'round'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M2.93596 12.3744C3.76355 11.8095 4.58128 11.3727 5.38916 11.064C6.19704 10.7553 7.06732 10.601 8 10.601C8.93268 10.601 9.80952 10.7553 10.6305 11.064C11.4516 11.3727 12.2693 11.8095 13.0837 12.3744C13.6617 11.665 14.069 10.9557 14.3054 10.2463C14.5419 9.53695 14.6601 8.78818 14.6601 8C14.6601 6.10837 14.023 4.52545 12.7488 3.25123C11.4745 1.97701 9.89163 1.3399 8 1.3399C6.10837 1.3399 4.52545 1.97701 3.25123 3.25123C1.97701 4.52545 1.3399 6.10837 1.3399 8C1.3399 8.78818 1.46141 9.53695 1.70443 10.2463C1.94745 10.9557 2.35796 11.665 2.93596 12.3744ZM8 8.63054C7.22496 8.63054 6.578 8.36782 6.05911 7.84236C5.54023 7.31691 5.28079 6.66667 5.28079 5.89163C5.28079 5.12972 5.54351 4.48604 6.06897 3.96059C6.59442 3.43514 7.2381 3.17241 8 3.17241C8.77504 3.17241 9.422 3.43514 9.94089 3.96059C10.4598 4.48604 10.7192 5.13629 10.7192 5.91133C10.7192 6.67324 10.4565 7.31691 9.93103 7.84236C9.40558 8.36782 8.7619 8.63054 8 8.63054ZM8 16C6.90969 16 5.87849 15.7898 4.9064 15.3695C3.93432 14.9491 3.08374 14.3744 2.35468 13.6453C1.62562 12.9163 1.0509 12.069 0.630542 11.1034C0.210181 10.1379 0 9.10345 0 8C0 6.89655 0.210181 5.86207 0.630542 4.89655C1.0509 3.93103 1.62562 3.08374 2.35468 2.35468C3.08374 1.62562 3.93103 1.0509 4.89655 0.630542C5.86207 0.210181 6.89655 0 8 0C9.10345 0 10.1379 0.210181 11.1034 0.630542C12.069 1.0509 12.9163 1.62562 13.6453 2.35468C14.3744 3.08374 14.9491 3.93103 15.3695 4.89655C15.7898 5.86207 16 6.89655 16 8C16 9.09031 15.7898 10.1215 15.3695 11.0936C14.9491 12.0657 14.3744 12.9163 13.6453 13.6453C12.9163 14.3744 12.069 14.9491 11.1034 15.3695C10.1379 15.7898 9.10345 16 8 16ZM8 14.6601C8.70936 14.6601 9.4023 14.5583 10.0788 14.3547C10.7553 14.1511 11.4286 13.7931 12.0985 13.2808C11.4286 12.8079 10.7553 12.4499 10.0788 12.2069C9.4023 11.9639 8.70936 11.8424 8 11.8424C7.29064 11.8424 6.60099 11.9639 5.93103 12.2069C5.26108 12.4499 4.58457 12.8079 3.90148 13.2808C4.57143 13.7931 5.24466 14.1511 5.92118 14.3547C6.5977 14.5583 7.29064 14.6601 8 14.6601ZM8 7.38916C8.4335 7.38916 8.79146 7.25123 9.07389 6.97537C9.35632 6.69951 9.49754 6.33826 9.49754 5.89163C9.49754 5.45813 9.35632 5.10345 9.07389 4.82759C8.79146 4.55172 8.4335 4.41379 8 4.41379C7.5665 4.41379 7.20854 4.55172 6.92611 4.82759C6.64368 5.10345 6.50246 5.45813 6.50246 5.89163C6.50246 6.33826 6.64368 6.69951 6.92611 6.97537C7.20854 7.25123 7.5665 7.38916 8 7.38916Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$accountPricing = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'width', '30'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'height', '30'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 30 30'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M12.1471 27L11.5294 23.2167C11.1961 23.0985 10.8333 22.9261 10.4412 22.6995C10.049 22.4729 9.70588 22.2414 9.41176 22.0049L5.91176 23.6305L3 18.4877L6.23529 16.1232C6.19608 15.9655 6.17157 15.7783 6.16176 15.5616C6.15196 15.3448 6.14706 15.1576 6.14706 15C6.14706 14.8424 6.15196 14.6552 6.16176 14.4384C6.17157 14.2217 6.19608 14.0345 6.23529 13.8768L3 11.5123L5.91176 6.36946L9.44118 7.99507C9.71569 7.75862 10.049 7.53202 10.4412 7.31527C10.8333 7.09852 11.1961 6.93103 11.5294 6.81281L12.1471 3H17.8529L18.4706 6.78325C18.8039 6.92118 19.1716 7.0936 19.5735 7.30049C19.9755 7.50739 20.3137 7.73892 20.5882 7.99507L24.1176 6.36946L27 11.5123L23.7647 13.8177C23.8039 13.9951 23.8284 14.1921 23.8382 14.4089C23.848 14.6256 23.8529 14.8227 23.8529 15C23.8529 15.1773 23.848 15.3695 23.8382 15.5764C23.8284 15.7833 23.8039 15.9754 23.7647 16.1527L27 18.4877L24.0882 23.6305L20.5588 22.0049C20.2843 22.2414 19.9559 22.4778 19.5735 22.7143C19.1912 22.9507 18.8235 23.1182 18.4706 23.2167L17.8529 27H12.1471ZM15 18.8424C16.0588 18.8424 16.9608 18.468 17.7059 17.7192C18.451 16.9704 18.8235 16.064 18.8235 15C18.8235 13.936 18.451 13.0296 17.7059 12.2808C16.9608 11.532 16.0588 11.1576 15 11.1576C13.9412 11.1576 13.0392 11.532 12.2941 12.2808C11.549 13.0296 11.1765 13.936 11.1765 15C11.1765 16.064 11.549 16.9704 12.2941 17.7192C13.0392 18.468 13.9412 18.8424 15 18.8424ZM15 17.069C14.4118 17.069 13.9216 16.867 13.5294 16.4631C13.1373 16.0591 12.9412 15.5714 12.9412 15C12.9412 14.4286 13.1373 13.9409 13.5294 13.5369C13.9216 13.133 14.4118 12.931 15 12.931C15.5686 12.931 16.0539 13.133 16.4559 13.5369C16.8578 13.9409 17.0588 14.4286 17.0588 15C17.0588 15.5714 16.8578 16.0591 16.4559 16.4631C16.0539 16.867 15.5686 17.069 15 17.069ZM13.7647 24.9901H16.2353L16.6471 21.6798C17.2941 21.5222 17.9118 21.2759 18.5 20.9409C19.0882 20.6059 19.6176 20.1921 20.0882 19.6995L23.2059 21.0591L24.3235 19.0197L21.5588 17.0099C21.6373 16.6749 21.7059 16.3399 21.7647 16.0049C21.8235 15.67 21.8529 15.335 21.8529 15C21.8529 14.665 21.8284 14.33 21.7794 13.9951C21.7304 13.6601 21.6569 13.3251 21.5588 12.9901L24.3235 10.9803L23.2059 8.94089L20.0882 10.3005C19.6373 9.76847 19.1225 9.32512 18.5441 8.97044C17.9657 8.61576 17.3333 8.39901 16.6471 8.3202L16.2353 5.00985H13.7647L13.3529 8.3202C12.6863 8.43842 12.0588 8.66995 11.4706 9.01478C10.8824 9.35961 10.3529 9.78818 9.88235 10.3005L6.79412 8.94089L5.67647 10.9803L8.41176 12.9901C8.33333 13.3251 8.26961 13.6601 8.22059 13.9951C8.17157 14.33 8.14706 14.665 8.14706 15C8.14706 15.335 8.17157 15.67 8.22059 16.0049C8.26961 16.3399 8.33333 16.6749 8.41176 17.0099L5.67647 19.0197L6.79412 21.0591L9.88235 19.6995C10.3725 20.1921 10.9118 20.6059 11.5 20.9409C12.0882 21.2759 12.7059 21.5222 13.3529 21.6798L13.7647 24.9901Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$add = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 13 13'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M5.72183 13V7.27817H0V5.72183H5.72183V0H7.27817V5.72183H13V7.27817H7.27817V13H5.72183Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$admin = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -0.5 21 21'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M7.3 20L6.9 16.8C6.68333 16.7167 6.47917 16.6167 6.2875 16.5C6.09583 16.3833 5.90833 16.2583 5.725 16.125L2.75 17.375L0 12.625L2.575 10.675C2.55833 10.5583 2.55 10.4458 2.55 10.3375V9.6625C2.55 9.55417 2.55833 9.44167 2.575 9.325L0 7.375L2.75 2.625L5.725 3.875C5.90833 3.74167 6.1 3.61667 6.3 3.5C6.5 3.38333 6.7 3.28333 6.9 3.2L7.3 0H12.8L13.2 3.2C13.4167 3.28333 13.6208 3.38333 13.8125 3.5C14.0042 3.61667 14.1917 3.74167 14.375 3.875L17.35 2.625L20.1 7.375L17.525 9.325C17.5417 9.44167 17.55 9.55417 17.55 9.6625V10.3375C17.55 10.4458 17.5333 10.5583 17.5 10.675L20.075 12.625L17.325 17.375L14.375 16.125C14.1917 16.2583 14 16.3833 13.8 16.5C13.6 16.6167 13.4 16.7167 13.2 16.8L12.8 20H7.3ZM9.05 18H11.025L11.375 15.35C11.8917 15.2167 12.3708 15.0208 12.8125 14.7625C13.2542 14.5042 13.6583 14.1917 14.025 13.825L16.5 14.85L17.475 13.15L15.325 11.525C15.4083 11.2917 15.4667 11.0458 15.5 10.7875C15.5333 10.5292 15.55 10.2667 15.55 10C15.55 9.73333 15.5333 9.47083 15.5 9.2125C15.4667 8.95417 15.4083 8.70833 15.325 8.475L17.475 6.85L16.5 5.15L14.025 6.2C13.6583 5.81667 13.2542 5.49583 12.8125 5.2375C12.3708 4.97917 11.8917 4.78333 11.375 4.65L11.05 2H9.075L8.725 4.65C8.20833 4.78333 7.72917 4.97917 7.2875 5.2375C6.84583 5.49583 6.44167 5.80833 6.075 6.175L3.6 5.15L2.625 6.85L4.775 8.45C4.69167 8.7 4.63333 8.95 4.6 9.2C4.56667 9.45 4.55 9.71667 4.55 10C4.55 10.2667 4.56667 10.525 4.6 10.775C4.63333 11.025 4.69167 11.275 4.775 11.525L2.625 13.15L3.6 14.85L6.075 13.8C6.44167 14.1833 6.84583 14.5042 7.2875 14.7625C7.72917 15.0208 8.20833 15.2167 8.725 15.35L9.05 18ZM10.1 13.5C11.0667 13.5 11.8917 13.1583 12.575 12.475C13.2583 11.7917 13.6 10.9667 13.6 10C13.6 9.03333 13.2583 8.20833 12.575 7.525C11.8917 6.84167 11.0667 6.5 10.1 6.5C9.11667 6.5 8.2875 6.84167 7.6125 7.525C6.9375 8.20833 6.6 9.03333 6.6 10C6.6 10.9667 6.9375 11.7917 7.6125 12.475C8.2875 13.1583 9.11667 13.5 10.1 13.5Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$alert = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 24 24'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill-rule', 'evenodd'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'clip-rule', 'evenodd'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M12 0C5.37187 0 0 5.37188 0 12C0 18.6281 5.37187 24 12 24C18.6281 24 24 18.6281 24 12C24 5.37188 18.6281 0 12 0ZM19.2914 19.2914C18.3445 20.2383 17.2406 20.9836 16.0125 21.5016C14.7422 22.0406 13.3922 22.3125 12 22.3125C10.6078 22.3125 9.25781 22.0406 7.9875 21.5039C6.75938 20.9836 5.65781 20.2406 4.70859 19.2937C3.76172 18.3469 3.01641 17.243 2.49844 16.0148C1.95938 14.7422 1.6875 13.3922 1.6875 12C1.6875 10.6078 1.95938 9.25781 2.49609 7.9875C3.01641 6.75937 3.75938 5.65781 4.70625 4.70859C5.65312 3.76172 6.75703 3.01641 7.98516 2.49844C9.25781 1.95938 10.6078 1.6875 12 1.6875C13.3922 1.6875 14.7422 1.95938 16.0125 2.49609C17.2406 3.01641 18.3422 3.75937 19.2914 4.70625C20.2383 5.65312 20.9836 6.75703 21.5016 7.98516C22.0406 9.25781 22.3125 10.6078 22.3125 12C22.3125 13.3922 22.0406 14.7422 21.5039 16.0125C20.9836 17.2406 20.2406 18.3445 19.2914 19.2914ZM14.7703 16.5375H12.7734V8.33203C12.7734 7.86563 12.3961 7.48828 11.9297 7.48828H11.0859H9.67969C9.21328 7.48828 8.83594 7.86563 8.83594 8.33203C8.83594 8.79844 9.21328 9.17578 9.67969 9.17578H11.0859V16.5375H9.08906C8.62266 16.5375 8.24531 16.9148 8.24531 17.3812C8.24531 17.8477 8.62266 18.225 9.08906 18.225H11.0859H12.7734H14.7703C15.2367 18.225 15.6141 17.8477 15.6141 17.3812C15.6141 16.9148 15.2367 16.5375 14.7703 16.5375ZM11.0859 5.16797C11.0859 4.70198 11.4637 4.32422 11.9297 4.32422C12.3957 4.32422 12.7734 4.70198 12.7734 5.16797C12.7734 5.63396 12.3957 6.01172 11.9297 6.01172C11.4637 6.01172 11.0859 5.63396 11.0859 5.16797Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$apiKey = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M280-400q-33 0-56.5-23.5T200-480q0-33 23.5-56.5T280-560q33 0 56.5 23.5T360-480q0 33-23.5 56.5T280-400Zm0 160q-100 0-170-70T40-480q0-100 70-170t170-70q67 0 121.5 33t86.5 87h352l120 120-180 180-80-60-80 60-85-60h-47q-32 54-86.5 87T280-240Zm0-80q56 0 98.5-34t56.5-86h125l58 41 82-61 71 55 75-75-40-40H435q-14-52-56.5-86T280-640q-66 0-113 47t-47 113q0 66 47 113t113 47Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$arrowLeft = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 34 26'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M12.7065 25.5066L0 12.8283L12.7565 0.0999985L15.5848 2.8218L7.58705 10.8478H33.237V14.8087H7.58705L15.5348 22.7565L12.7065 25.5066Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$arrowRight = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 35 26'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M21.6215 25.4066L18.7932 22.6565L26.741 14.7087H0.886719V10.7478H26.741L18.7432 2.7218L21.5715 0L34.3281 12.7283L21.6215 25.4066Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$arrowRightBottom = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 8 8'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M4.75184 8L3.81094 7.16387L5.45953 5.70371H0V0H1.32826V4.52335H5.45953L3.81094 3.05834L4.74639 2.22222L8 5.11353L4.75184 8Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$bank = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 24 24'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M6.5 10h-2v7h2v-7zm6 0h-2v7h2v-7zm8.5 9H2v2h19v-2zm-2.5-9h-2v7h2v-7zm-7-6.74L16.71 6H6.29l5.21-2.74m0-2.26L2 6v2h19V6l-9.5-5z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$bolt = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'm422-232 207-248H469l29-227-185 267h139l-30 208ZM320-80l40-280H160l360-520h80l-40 320h240L400-80h-80Zm151-390Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$book = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -920 960 870'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M260-320q47 0 91.5 10.5T440-278v-394q-41-24-87-36t-93-12q-36 0-71.5 7T120-692v396q35-12 69.5-18t70.5-6Zm260 42q44-21 88.5-31.5T700-320q36 0 70.5 6t69.5 18v-396q-33-14-68.5-21t-71.5-7q-47 0-93 12t-87 36v394Zm-40 118q-48-38-104-59t-116-21q-42 0-82.5 11T100-198q-21 11-40.5-1T40-234v-482q0-11 5.5-21T62-752q46-24 96-36t102-12q58 0 113.5 15T480-740q51-30 106.5-45T700-800q52 0 102 12t96 36q11 5 16.5 15t5.5 21v482q0 23-19.5 35t-40.5 1q-37-20-77.5-31T700-240q-60 0-116 21t-104 59ZM280-494Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$bookmark = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 10 14'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0 14V1.5C0 1.0875 0.146875 0.734376 0.440625 0.440626C0.734375 0.146876 1.0875 0 1.5 0H8.5C8.9125 0 9.26562 0.146876 9.55937 0.440626C9.85312 0.734376 10 1.0875 10 1.5V14L5 12L0 14ZM1.5 11.7708L5 10.375L8.5 11.7708V1.5H1.5V11.7708Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$bookmarkFilled = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 10 14'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0 14V1.5C0 1.08333 0.145833 0.729167 0.4375 0.4375C0.729167 0.145833 1.08333 0 1.5 0H8.5C8.91667 0 9.27083 0.145833 9.5625 0.4375C9.85417 0.729167 10 1.08333 10 1.5V14L5 12L0 14Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$bookmarkNav = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '-3 -2 20 22'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0 18V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H12C12.55 0 13.0208 0.195833 13.4125 0.5875C13.8042 0.979167 14 1.45 14 2V18L7 15L0 18ZM2 14.95L7 12.8L12 14.95V2H2V14.95Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$burgerMenu = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'width', '16'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'height', '12'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 16 12'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill-rule', 'evenodd'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'clip-rule', 'evenodd'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0 2V0H16V2H0ZM0 7H16V5H0V7ZM0 12H16V10H0V12Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$burgerMenuClose = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'width', '16'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'height', '16'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '8 8 14 14'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M7.92918 9.3427L20.6571 22.0706L22.0713 20.6564L9.34339 7.92849L7.92918 9.3427Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
					]),
				_List_Nil),
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M20.6571 7.92893L7.92913 20.6569L9.34334 22.0711L22.0713 9.34315L20.6571 7.92893Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$calendar = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -1 20 22'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V4C0 3.45 0.195833 2.97917 0.5875 2.5875C0.979167 2.19583 1.45 2 2 2H3V0H5V2H13V0H15V2H16C16.55 2 17.0208 2.19583 17.4125 2.5875C17.8042 2.97917 18 3.45 18 4V18C18 18.55 17.8042 19.0208 17.4125 19.4125C17.0208 19.8042 16.55 20 16 20H2ZM2 18H16V8H2V18ZM2 6H16V4H2V6ZM9 12C8.71667 12 8.47917 11.9042 8.2875 11.7125C8.09583 11.5208 8 11.2833 8 11C8 10.7167 8.09583 10.4792 8.2875 10.2875C8.47917 10.0958 8.71667 10 9 10C9.28333 10 9.52083 10.0958 9.7125 10.2875C9.90417 10.4792 10 10.7167 10 11C10 11.2833 9.90417 11.5208 9.7125 11.7125C9.52083 11.9042 9.28333 12 9 12ZM5 12C4.71667 12 4.47917 11.9042 4.2875 11.7125C4.09583 11.5208 4 11.2833 4 11C4 10.7167 4.09583 10.4792 4.2875 10.2875C4.47917 10.0958 4.71667 10 5 10C5.28333 10 5.52083 10.0958 5.7125 10.2875C5.90417 10.4792 6 10.7167 6 11C6 11.2833 5.90417 11.5208 5.7125 11.7125C5.52083 11.9042 5.28333 12 5 12ZM13 12C12.7167 12 12.4792 11.9042 12.2875 11.7125C12.0958 11.5208 12 11.2833 12 11C12 10.7167 12.0958 10.4792 12.2875 10.2875C12.4792 10.0958 12.7167 10 13 10C13.2833 10 13.5208 10.0958 13.7125 10.2875C13.9042 10.4792 14 10.7167 14 11C14 11.2833 13.9042 11.5208 13.7125 11.7125C13.5208 11.9042 13.2833 12 13 12ZM9 16C8.71667 16 8.47917 15.9042 8.2875 15.7125C8.09583 15.5208 8 15.2833 8 15C8 14.7167 8.09583 14.4792 8.2875 14.2875C8.47917 14.0958 8.71667 14 9 14C9.28333 14 9.52083 14.0958 9.7125 14.2875C9.90417 14.4792 10 14.7167 10 15C10 15.2833 9.90417 15.5208 9.7125 15.7125C9.52083 15.9042 9.28333 16 9 16ZM5 16C4.71667 16 4.47917 15.9042 4.2875 15.7125C4.09583 15.5208 4 15.2833 4 15C4 14.7167 4.09583 14.4792 4.2875 14.2875C4.47917 14.0958 4.71667 14 5 14C5.28333 14 5.52083 14.0958 5.7125 14.2875C5.90417 14.4792 6 14.7167 6 15C6 15.2833 5.90417 15.5208 5.7125 15.7125C5.52083 15.9042 5.28333 16 5 16ZM13 16C12.7167 16 12.4792 15.9042 12.2875 15.7125C12.0958 15.5208 12 15.2833 12 15C12 14.7167 12.0958 14.4792 12.2875 14.2875C12.4792 14.0958 12.7167 14 13 14C13.2833 14 13.5208 14.0958 13.7125 14.2875C13.9042 14.4792 14 14.7167 14 15C14 15.2833 13.9042 15.5208 13.7125 15.7125C13.5208 15.9042 13.2833 16 13 16Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$call = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M795-120q-116 0-236.5-56T335-335Q232-438 176-558.5T120-795q0-19.29 12.86-32.14Q145.71-840 165-840h140q14 0 24 10t14 25l26.93 125.64Q372-665 369.5-653.5t-10.73 19.73L259-533q26 44 55 82t64 72q37 38 78 69.5t86 55.5l95-98q10-11 23.15-15 13.15-4 25.85-2l119 26q15 4 25 16.04 10 12.05 10 26.96v135q0 19.29-12.86 32.14Q814.29-120 795-120ZM229-588l81-82-23-110H180q2 42 13.5 88.5T229-588Zm369 363q41 19 89 31t93 14v-107l-103-21-79 83ZM229-588Zm369 363Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$card = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 24 24'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$cart = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M223.5-103.5Q200-127 200-160t23.5-56.5Q247-240 280-240t56.5 23.5Q360-193 360-160t-23.5 56.5Q313-80 280-80t-56.5-23.5Zm400 0Q600-127 600-160t23.5-56.5Q647-240 680-240t56.5 23.5Q760-193 760-160t-23.5 56.5Q713-80 680-80t-56.5-23.5ZM246-720l96 200h280l110-200H246Zm-38-80h590q23 0 35 20.5t1 41.5L692-482q-11 20-29.5 31T622-440H324l-44 80h480v80H280q-45 0-68-39.5t-2-78.5l54-98-144-304H40v-80h130l38 80Zm134 280h280-280Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$chatbox = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'width', '14'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'height', '14'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 14 14'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M4.6 6.4C4.77 6.4 4.9125 6.34252 5.0275 6.2275C5.1425 6.11248 5.2 5.96998 5.2 5.8C5.2 5.63 5.1425 5.4875 5.0275 5.3725C4.9125 5.2575 4.77 5.2 4.6 5.2C4.43 5.2 4.2875 5.2575 4.1725 5.3725C4.0575 5.4875 4 5.63 4 5.8C4 5.96998 4.0575 6.11248 4.1725 6.2275C4.2875 6.34252 4.43 6.4 4.6 6.4ZM7 6.4C7.16998 6.4 7.31248 6.34252 7.4275 6.2275C7.54252 6.11248 7.6 5.96998 7.6 5.8C7.6 5.63 7.54252 5.4875 7.4275 5.3725C7.31248 5.2575 7.16998 5.2 7 5.2C6.83002 5.2 6.68752 5.2575 6.5725 5.3725C6.45748 5.4875 6.4 5.63 6.4 5.8C6.4 5.96998 6.45748 6.11248 6.5725 6.2275C6.68752 6.34252 6.83002 6.4 7 6.4ZM9.4 6.4C9.56998 6.4 9.71248 6.34252 9.8275 6.2275C9.94252 6.11248 10 5.96998 10 5.8C10 5.63 9.94252 5.4875 9.8275 5.3725C9.71248 5.2575 9.56998 5.2 9.4 5.2C9.23002 5.2 9.08752 5.2575 8.9725 5.3725C8.85748 5.4875 8.8 5.63 8.8 5.8C8.8 5.96998 8.85748 6.11248 8.9725 6.2275C9.08752 6.34252 9.23002 6.4 9.4 6.4ZM1 13V2.2C1 1.87 1.1175 1.5875 1.3525 1.3525C1.5875 1.1175 1.87 1 2.2 1H11.8C12.13 1 12.4125 1.1175 12.6475 1.3525C12.8825 1.5875 13 1.87 13 2.2V9.4C13 9.73 12.8825 10.0125 12.6475 10.2475C12.4125 10.4825 12.13 10.6 11.8 10.6H3.4L1 13ZM2.89 9.4H11.8V2.2H2.2V10.075L2.89 9.4Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', '#0E68E2')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$check = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 10 8'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill-rule', 'evenodd'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'clip-rule', 'evenodd'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M9.22494 0.671064C9.03255 0.497837 8.73617 0.51337 8.56294 0.705758L3.31035 6.53935L1.44406 4.46663C1.27083 4.27424 0.97444 4.25871 0.782052 4.43193C0.589664 4.60516 0.574131 4.90155 0.747358 5.09394L2.95557 7.54641C3.08001 7.68461 3.268 7.73155 3.43534 7.68281C3.52259 7.66093 3.6045 7.61374 3.66921 7.54186L9.25964 1.33307C9.43286 1.14068 9.41733 0.844291 9.22494 0.671064Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$chevron = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '-2 0 13 13'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M2 2L7 6.5L2 11'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'stroke', 'currentColor'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'stroke-width', '1.5'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'stroke-linecap', 'square')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$chevronDown = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 12 8'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill-rule', 'evenodd'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'clip-rule', 'evenodd'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M11.9741 0.991346L6.07575 7.84129L0.177371 0.991345L1.06142 0.230102L6.07575 6.05338L11.0901 0.230103L11.9741 0.991346Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$circle = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 24 24'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'stroke', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'stroke-width', '1')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'circle',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'cx', '12'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'cy', '12'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'r', '10')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$commissions = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '-8 -8 64 64'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M10.5 21C7.6 21 5.125 19.975 3.075 17.925C1.025 15.875 0 13.4 0 10.5C0 7.6 1.025 5.125 3.075 3.075C5.125 1.025 7.6 0 10.5 0C13.4 0 15.875 1.025 17.925 3.075C19.975 5.125 21 7.6 21 10.5C21 13.4 19.975 15.875 17.925 17.925C15.875 19.975 13.4 21 10.5 21ZM10.5 15C11.75 15 12.8125 14.5625 13.6875 13.6875C14.5625 12.8125 15 11.75 15 10.5C15 9.25 14.5625 8.1875 13.6875 7.3125C12.8125 6.4375 11.75 6 10.5 6C9.25 6 8.1875 6.4375 7.3125 7.3125C6.4375 8.1875 6 9.25 6 10.5C6 11.75 6.4375 12.8125 7.3125 13.6875C8.1875 14.5625 9.25 15 10.5 15ZM37.5 48C34.6 48 32.125 46.975 30.075 44.925C28.025 42.875 27 40.4 27 37.5C27 34.6 28.025 32.125 30.075 30.075C32.125 28.025 34.6 27 37.5 27C40.4 27 42.875 28.025 44.925 30.075C46.975 32.125 48 34.6 48 37.5C48 40.4 46.975 42.875 44.925 44.925C42.875 46.975 40.4 48 37.5 48ZM37.5 42C38.75 42 39.8125 41.5625 40.6875 40.6875C41.5625 39.8125 42 38.75 42 37.5C42 36.25 41.5625 35.1875 40.6875 34.3125C39.8125 33.4375 38.75 33 37.5 33C36.25 33 35.1875 33.4375 34.3125 34.3125C33.4375 35.1875 33 36.25 33 37.5C33 38.75 33.4375 39.8125 34.3125 40.6875C35.1875 41.5625 36.25 42 37.5 42ZM4.2 48L0 43.8L43.8 0L48 4.2L4.2 48Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$contact = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '-1 -2 22 22'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M2 14.85C2.9 13.9667 3.94583 13.2708 5.1375 12.7625C6.32917 12.2542 7.61667 12 9 12C10.3833 12 11.6708 12.2542 12.8625 12.7625C14.0542 13.2708 15.1 13.9667 16 14.85V2H2V14.85ZM9 10C9.96667 10 10.7917 9.65833 11.475 8.975C12.1583 8.29167 12.5 7.46667 12.5 6.5C12.5 5.53333 12.1583 4.70833 11.475 4.025C10.7917 3.34167 9.96667 3 9 3C8.03333 3 7.20833 3.34167 6.525 4.025C5.84167 4.70833 5.5 5.53333 5.5 6.5C5.5 7.46667 5.84167 8.29167 6.525 8.975C7.20833 9.65833 8.03333 10 9 10ZM2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H16C16.55 0 17.0208 0.195833 17.4125 0.5875C17.8042 0.979167 18 1.45 18 2V16C18 16.55 17.8042 17.0208 17.4125 17.4125C17.0208 17.8042 16.55 18 16 18H2ZM3.725 16H14.275C13.5417 15.35 12.7125 14.8542 11.7875 14.5125C10.8625 14.1708 9.93333 14 9 14C8.06667 14 7.12917 14.1708 6.1875 14.5125C5.24583 14.8542 4.425 15.35 3.725 16ZM9 8C8.58333 8 8.22917 7.85417 7.9375 7.5625C7.64583 7.27083 7.5 6.91667 7.5 6.5C7.5 6.08333 7.64583 5.72917 7.9375 5.4375C8.22917 5.14583 8.58333 5 9 5C9.41667 5 9.77083 5.14583 10.0625 5.4375C10.3542 5.72917 10.5 6.08333 10.5 6.5C10.5 6.91667 10.3542 7.27083 10.0625 7.5625C9.77083 7.85417 9.41667 8 9 8Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$copy = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 12 12'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M2.24141 9.90068V0H11.0769V9.90068H2.24141ZM3.60072 8.62754H9.70315V1.28668H3.60072V8.62754ZM0 12V2.66817H1.37377V10.7133H8.09801V12H0ZM3.60072 8.62754V1.28668V8.62754Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$cross = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 10 9'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M5.72526 4.20443L9.04297 0.889323C9.24349 0.688802 9.24349 0.364583 9.04297 0.165365C8.84245 -0.0351562 8.51823 -0.0351562 8.31901 0.165365L5 3.47917L1.68099 0.164062C1.48047 -0.0364583 1.15625 -0.0364583 0.957031 0.164062C0.75651 0.364583 0.75651 0.688802 0.957031 0.888021L4.27474 4.20312L0.957031 7.51953C0.75651 7.72005 0.75651 8.04427 0.957031 8.24349C1.05729 8.34375 1.1888 8.39323 1.31901 8.39323C1.45052 8.39323 1.58073 8.34375 1.68099 8.24349L5 4.92839L8.31901 8.24479C8.41927 8.34505 8.54948 8.39453 8.68099 8.39453C8.8125 8.39453 8.94271 8.34505 9.04297 8.24479C9.24349 8.04427 9.24349 7.72005 9.04297 7.52083L5.72526 4.20443Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$crossCircle = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'width', '14'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'height', '14'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 14 14'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill-rule', 'evenodd'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'clip-rule', 'evenodd'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M9.80534 4.18684C9.61257 3.99543 9.30085 3.99543 9.10944 4.18821L6.99987 6.30325L4.8903 4.18821C4.6989 3.99543 4.38718 3.99543 4.1944 4.18684C4.00163 4.37825 4.00163 4.68997 4.19304 4.88274L6.30534 7.00051L4.19304 9.11829C4.00163 9.31106 4.00163 9.62278 4.1944 9.81418C4.29011 9.90989 4.41589 9.95774 4.54167 9.95774C4.66745 9.95774 4.7946 9.90989 4.8903 9.81282L6.99987 7.69778L9.10944 9.81418C9.20515 9.91125 9.33229 9.95911 9.45808 9.95911C9.58386 9.95911 9.70964 9.91125 9.80534 9.81555C9.99811 9.62415 9.99811 9.31243 9.80671 9.11965L7.6944 7.00051L9.80534 4.88274C9.99811 4.68997 9.99811 4.37825 9.80534 4.18684ZM7 0C3.13359 0 0 3.13359 0 7C0 10.8664 3.13359 14 7 14C10.8664 14 14 10.8664 14 7C14 3.13359 10.8664 0 7 0ZM11.2533 11.2533C10.701 11.8057 10.057 12.2404 9.34062 12.5426C8.59961 12.857 7.81211 13.0156 7 13.0156C6.18789 13.0156 5.40039 12.857 4.65938 12.5439C3.94297 12.2404 3.30039 11.807 2.74668 11.2547C2.19434 10.7023 1.75957 10.0584 1.45742 9.34199C1.14297 8.59961 0.984375 7.81211 0.984375 7C0.984375 6.18789 1.14297 5.40039 1.45605 4.65938C1.75957 3.94297 2.19297 3.30039 2.74531 2.74668C3.29766 2.19434 3.9416 1.75957 4.65801 1.45742C5.40039 1.14297 6.18789 0.984375 7 0.984375C7.81211 0.984375 8.59961 1.14297 9.34062 1.45605C10.057 1.75957 10.6996 2.19297 11.2533 2.74531C11.8057 3.29766 12.2404 3.9416 12.5426 4.65801C12.857 5.40039 13.0156 6.18789 13.0156 7C13.0156 7.81211 12.857 8.59961 12.5439 9.34062C12.2404 10.057 11.807 10.701 11.2533 11.2533Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$dashboard = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '-1 -2 20 22'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M2 16H5V10H11V16H14V7L8 2.5L2 7V16ZM0 18V6L8 0L16 6V18H9V12H7V18H0Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$decrease = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M480-360 280-560h400L480-360Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$delete = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 34 38'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M5.67175 37.6098C4.72348 37.6098 3.91667 37.2783 3.2513 36.6153C2.58593 35.9523 2.25325 35.1483 2.25325 34.2033V5.90655H0V2.5H9.91415V0.784798H23.5087V2.5H33.4348V5.90655H31.1816V34.2033C31.1816 35.1233 30.8426 35.921 30.1648 36.5965C29.4869 37.272 28.6863 37.6098 27.7631 37.6098H5.67175ZM27.7631 5.90655H5.67175V34.2033H27.7631V5.90655ZM10.912 29.9989H14.1152V10.0489H10.912V29.9989ZM19.3196 29.9989H22.5348V10.0489H19.3196V29.9989Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$deleteOutline = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M280-120q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520ZM360-280h80v-360h-80v360Zm160 0h80v-360h-80v360ZM280-720v520-520Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$demography = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M762.5-257.5Q780-275 780-300t-17.5-42.5Q745-360 720-360t-42.5 17.5Q660-325 660-300t17.5 42.5Q695-240 720-240t42.5-17.5ZM779-136q27-16 43-42-23-12-48.5-19t-53.5-7q-28 0-53.5 7T618-178q16 26 43 42t59 16q32 0 59-16Zm-563-8q-29.7 0-50.85-21.15Q144-186.3 144-216v-528q0-29.7 21.15-50.85Q186.3-816 216-816h528q29.7 0 50.85 21.15Q816-773.7 816-744v258q-17.1-5.76-35.1-9.92T744-502v-242H216v528h241q1.88 19.52 5.94 37.26Q467-161 473-144H216Zm0-96v24-528 242-2 264Zm72-48h172q4-19 10.19-36.97Q476.38-342.93 484-360H288v72Zm0-156h264q26-20 56-34.5t64-20.5v-17H288v72Zm0-156h384v-72H288v72ZM719.77-48Q640-48 584-104.23q-56-56.22-56-136Q528-320 584.23-376q56.22-56 136-56Q800-432 856-375.77q56 56.22 56 136Q912-160 855.77-104q-56.22 56-136 56Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$dev = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M224-358h98.67q20.1 0 34.38-14.28 14.28-14.29 14.28-34.39v-146.66q0-20.1-14.28-34.39Q342.77-602 322.67-602H224v244Zm48.67-48.67v-146.66h50v146.66h-50ZM433-358h100.67v-48.67h-82v-52h52v-44h-52v-50.66h82V-602H433.31q-13.31 0-21.81 8.5Q403-585 403-572v183.73q0 13.27 8.5 21.77T433-358Zm246.57-9.5q10.1-8.5 13.76-21.5L756-602h-50.67l-49.66 168L606-602h-50.67L618-389q3.67 13 13.76 21.5t23.91 8.5q13.81 0 23.9-8.5ZM186.67-120q-27 0-46.84-19.83Q120-159.67 120-186.67v-586.66q0-27 19.83-46.84Q159.67-840 186.67-840h586.66q27 0 46.84 19.83Q840-800.33 840-773.33v586.66q0 27-19.83 46.84Q800.33-120 773.33-120H186.67Zm0-66.67h586.66v-586.66H186.67v586.66Zm0-586.66v586.66-586.66Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$dollar = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 7 14'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M2.89385 14V12.3609C2.1378 12.2323 1.51862 11.9463 1.03631 11.5028C0.554004 11.0592 0.208566 10.4968 0 9.81543L1.19274 9.35262C1.41434 9.98255 1.73371 10.4454 2.15084 10.741C2.56797 11.0367 3.0568 11.1846 3.61732 11.1846C4.24302 11.1846 4.7514 11.0335 5.14246 10.7314C5.53352 10.4293 5.72905 10.0211 5.72905 9.50689C5.72905 8.95409 5.54656 8.52341 5.18156 8.21488C4.81657 7.90633 4.14525 7.5978 3.1676 7.28926C2.22905 6.99357 1.5284 6.59825 1.06564 6.1033C0.602887 5.60836 0.371508 4.98806 0.371508 4.24242C0.371508 3.54821 0.596368 2.95684 1.04609 2.46832C1.49581 1.9798 2.11173 1.69697 2.89385 1.61983V0H4.1257V1.61983C4.71229 1.69697 5.22393 1.89624 5.66061 2.21763C6.0973 2.53903 6.42644 2.95041 6.64804 3.45179L5.45531 3.95317C5.27281 3.55464 5.0284 3.25895 4.72207 3.06612C4.41574 2.87328 4.02142 2.77686 3.53911 2.77686C2.95251 2.77686 2.48976 2.90542 2.15084 3.16253C1.81192 3.41965 1.64246 3.77319 1.64246 4.22314C1.64246 4.68595 1.82821 5.0652 2.19972 5.36088C2.57123 5.65657 3.29143 5.9651 4.36033 6.2865C5.25978 6.56933 5.92458 6.96786 6.35475 7.48209C6.78492 7.99633 7 8.64555 7 9.42975C7 10.2525 6.75559 10.9146 6.26676 11.416C5.77793 11.9174 5.06425 12.2388 4.1257 12.3802V14H2.89385Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$dots = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'width', '12'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'height', '12'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 12 3'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M1.7622 2.02143C1.55894 2.02143 1.3811 1.94521 1.22866 1.79277C1.07622 1.64033 1 1.45741 1 1.24399C1 1.03058 1.07622 0.84765 1.22866 0.695211C1.3811 0.542772 1.56402 0.466553 1.77744 0.466553C1.98069 0.466553 2.15854 0.542772 2.31098 0.695211C2.46341 0.84765 2.53963 1.03058 2.53963 1.24399C2.53963 1.45741 2.46341 1.64033 2.31098 1.79277C2.15854 1.94521 1.97561 2.02143 1.7622 2.02143ZM6 2.02143C5.78658 2.02143 5.60366 1.94521 5.45122 1.79277C5.29878 1.64033 5.22256 1.45741 5.22256 1.24399C5.22256 1.03058 5.29878 0.84765 5.45122 0.695211C5.60366 0.542772 5.78658 0.466553 6 0.466553C6.21341 0.466553 6.39634 0.542772 6.54878 0.695211C6.70122 0.84765 6.77744 1.03058 6.77744 1.24399C6.77744 1.45741 6.70122 1.64033 6.54878 1.79277C6.39634 1.94521 6.21341 2.02143 6 2.02143ZM10.2226 2.02143C10.0091 2.02143 9.82876 1.94521 9.6814 1.79277C9.53404 1.64033 9.46036 1.45741 9.46036 1.24399C9.46036 1.03058 9.53658 0.84765 9.68902 0.695211C9.84146 0.542772 10.0244 0.466553 10.2378 0.466553C10.4512 0.466553 10.6316 0.542772 10.779 0.695211C10.9263 0.84765 11 1.03058 11 1.24399C11 1.45741 10.9238 1.64033 10.7713 1.79277C10.6189 1.94521 10.436 2.02143 10.2226 2.02143Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'stroke-width', '0.5')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$dragIndicator = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M360-160q-33 0-56.5-23.5T280-240q0-33 23.5-56.5T360-320q33 0 56.5 23.5T440-240q0 33-23.5 56.5T360-160Zm240 0q-33 0-56.5-23.5T520-240q0-33 23.5-56.5T600-320q33 0 56.5 23.5T680-240q0 33-23.5 56.5T600-160ZM360-400q-33 0-56.5-23.5T280-480q0-33 23.5-56.5T360-560q33 0 56.5 23.5T440-480q0 33-23.5 56.5T360-400Zm240 0q-33 0-56.5-23.5T520-480q0-33 23.5-56.5T600-560q33 0 56.5 23.5T680-480q0 33-23.5 56.5T600-400ZM360-640q-33 0-56.5-23.5T280-720q0-33 23.5-56.5T360-800q33 0 56.5 23.5T440-720q0 33-23.5 56.5T360-640Zm240 0q-33 0-56.5-23.5T520-720q0-33 23.5-56.5T600-800q33 0 56.5 23.5T680-720q0 33-23.5 56.5T600-640Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$edit = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 11 11'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M1.16667 9.33333H1.99792L7.7 3.63125L6.86875 2.8L1.16667 8.50208V9.33333ZM0 10.5V8.02083L7.7 0.335417C7.81667 0.228472 7.94549 0.145833 8.08646 0.0875C8.22743 0.0291667 8.37569 0 8.53125 0C8.68681 0 8.8375 0.0291667 8.98333 0.0875C9.12917 0.145833 9.25556 0.233333 9.3625 0.35L10.1646 1.16667C10.2812 1.27361 10.3663 1.4 10.4198 1.54583C10.4733 1.69167 10.5 1.8375 10.5 1.98333C10.5 2.13889 10.4733 2.28715 10.4198 2.42812C10.3663 2.5691 10.2812 2.69792 10.1646 2.81458L2.47917 10.5H0ZM7.27708 3.22292L6.86875 2.8L7.7 3.63125L7.27708 3.22292Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$editOutline = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M200-200h57l391-391-57-57-391 391v57Zm-80 80v-170l528-527q12-11 26.5-17t30.5-6q16 0 31 6t26 18l55 56q12 11 17.5 26t5.5 30q0 16-5.5 30.5T817-647L290-120H120Zm640-584-56-56 56 56Zm-141 85-28-29 57 57-29-28Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$employeeUploads = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'width', '30'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'height', '30'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 30 30'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M13.8079 23.1872H15.5813V17.2167L18.0049 19.6404L19.2463 18.399L14.6355 13.9064L10.0837 18.4581L11.3251 19.6995L13.8079 17.2167V23.1872ZM5 27V3H17.7094L24.2709 9.56158V27H5ZM16.6749 10.5074V5.00985H7.00985V24.9901H22.2611V10.5074H16.6749Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$employees = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'width', '30'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'height', '30'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 30 30'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0 25.8526V22.5893C0 21.7844 0.206677 21.0555 0.620031 20.4029C1.03339 19.7502 1.60991 19.2607 2.34959 18.9344C3.93774 18.2382 5.37904 17.7378 6.67349 17.4333C7.96795 17.1287 9.28959 16.9764 10.6384 16.9764C12.0308 16.9764 13.3633 17.1287 14.636 17.4333C15.9087 17.7378 17.3391 18.2382 18.9273 18.9344C19.667 19.2607 20.2489 19.7502 20.6731 20.4029C21.0974 21.0555 21.3095 21.7844 21.3095 22.5893V25.8526H0ZM19.5473 16.9111C21.0049 17.0852 22.381 17.3408 23.6754 17.678C24.9699 18.0152 26.0304 18.3905 26.8571 18.8039C27.5751 19.2172 28.1516 19.7502 28.5867 20.4029C29.0218 21.0555 29.2394 21.7952 29.2394 22.6219V25.8526H23.3328V22.5893C23.3328 21.2187 22.9901 20.082 22.3048 19.1791C21.6195 18.2763 20.7003 17.5203 19.5473 16.9111ZM10.6711 14.9858C9.19169 14.9858 7.9897 14.518 7.06509 13.5825C6.14048 12.6471 5.67818 11.4505 5.67818 9.99288C5.67818 8.51351 6.14048 7.31152 7.06509 6.38691C7.9897 5.4623 9.18081 5 10.6384 5C12.1178 5 13.3252 5.4623 14.2607 6.38691C15.1962 7.31152 15.6639 8.51351 15.6639 9.99288C15.6639 11.4505 15.1962 12.6471 14.2607 13.5825C13.3252 14.518 12.1287 14.9858 10.6711 14.9858ZM22.6801 9.99288C22.6801 11.4505 22.2178 12.6471 21.2932 13.5825C20.3686 14.518 19.1666 14.9858 17.6872 14.9858C17.4479 14.9858 17.1814 14.9695 16.8877 14.9368C16.594 14.9042 16.3275 14.8335 16.0882 14.7247C16.6103 14.1808 17.0073 13.5064 17.2793 12.7014C17.5512 11.8965 17.6872 10.9936 17.6872 9.99288C17.6872 8.99213 17.5512 8.11103 17.2793 7.34959C17.0073 6.58815 16.6103 5.8811 16.0882 5.22843C16.3275 5.16317 16.594 5.10878 16.8877 5.06527C17.1814 5.02176 17.4479 5 17.6872 5C19.1666 5 20.3686 5.46774 21.2932 6.40323C22.2178 7.33871 22.6801 8.53527 22.6801 9.99288ZM2.25169 23.6336H19.0578V22.6219C19.0578 22.2739 18.9545 21.9366 18.7478 21.6103C18.5411 21.284 18.2855 21.0555 17.9809 20.925C16.4363 20.2506 15.1418 19.7937 14.0976 19.5544C13.0533 19.3151 11.9002 19.1955 10.6384 19.1955C9.42012 19.1955 8.27252 19.3151 7.19563 19.5544C6.11873 19.7937 4.81884 20.2506 3.29596 20.925C2.99138 21.0555 2.74119 21.284 2.54539 21.6103C2.34959 21.9366 2.25169 22.2739 2.25169 22.6219V23.6336ZM10.6384 12.832C11.4651 12.832 12.1504 12.5655 12.6943 12.0325C13.2382 11.4995 13.5102 10.8196 13.5102 9.99288C13.5102 9.16617 13.2437 8.48088 12.7106 7.93699C12.1776 7.3931 11.4978 7.12116 10.6711 7.12116C9.84436 7.12116 9.15906 7.3931 8.61517 7.93699C8.07128 8.48088 7.79934 9.16617 7.79934 9.99288C7.79934 10.8196 8.07128 11.4995 8.61517 12.0325C9.15906 12.5655 9.83348 12.832 10.6384 12.832Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$enter = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 13 12'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'stroke', 'currentColor'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M6.92857 1H11.5V7.86957H1.5M1.5 7.86957L4.5 4.73913M1.5 7.86957L4.5 11'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'stroke-width', '1.2')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$envelope = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'width', '14'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'height', '14'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 14 14'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M2.2 11C1.87 11 1.5875 10.8899 1.3525 10.6695C1.1175 10.4492 1 10.1844 1 9.875V3.125C1 2.81563 1.1175 2.55078 1.3525 2.33047C1.5875 2.11015 1.87 2 2.2 2H11.8C12.13 2 12.4125 2.11015 12.6475 2.33047C12.8825 2.55078 13 2.81563 13 3.125V9.875C13 10.1844 12.8825 10.4492 12.6475 10.6695C12.4125 10.8899 12.13 11 11.8 11H2.2ZM7 7.0625L2.2 4.25V9.875H11.8V4.25L7 7.0625ZM7 5.9375L11.8 3.125H2.2L7 5.9375ZM2.2 4.25V3.125V9.875V4.25Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', '#0E68E2')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$eraser = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M702.91-242.87h144.5q19.16 0 32.33 13.17 13.17 13.18 13.17 32.33t-13.17 32.33q-13.17 13.17-32.33 13.17h-235.5l91-91Zm-502.84 91q-9.2 0-17.54-3.36-8.33-3.36-15.05-10.07l-72.05-72.05q-26.34-26.35-26.72-64.53-.38-38.19 25.96-65.53l437.85-450.98q26.35-27.35 64.27-27.23 37.93.12 64.28 26.47l193.97 193.98q26.35 26.34 26.35 64.65 0 38.3-26.35 64.65L531.28-165.54q-6.71 6.71-15.05 10.19-8.34 3.48-17.53 3.48H200.07Zm279.23-91 311.85-318.41L597.93-754.5 158.57-303.52l60.65 60.65H479.3ZM480-480Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$export = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 15 15'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M7.51131 11.2051L2.94118 6.69162L4.04977 5.59132L6.74208 8.26347V0H8.28054V8.26347L10.9729 5.59132L12.0814 6.69162L7.51131 11.2051ZM1.53846 15C1.13122 15 0.773002 14.8503 0.463801 14.5509C0.1546 14.2515 0 13.8922 0 13.4731V10.015H1.53846V13.4731H13.4615V10.015H15V13.4731C15 13.8922 14.8492 14.2515 14.5475 14.5509C14.2459 14.8503 13.8839 15 13.4615 15H1.53846Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$flag = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 16 18'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0 18V0H9.2549L9.75164 2.23699H16V12.1734H9.01961L8.52288 9.96243H1.77778V18H0ZM10.5359 10.4046H14.2222V4.00578H8.2353L7.73856 1.76879H1.77778V8.19364H10.0392L10.5359 10.4046Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$flagFilled = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 9 10'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0 9.91667V0H5.25L5.48333 1.16667H8.75V7H4.66667L4.43333 5.83333H1.16667V9.91667H0Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$form = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -1 18 22'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M4 16H12V14H4V16ZM4 12H12V10H4V12ZM2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H10L16 6V18C16 18.55 15.8042 19.0208 15.4125 19.4125C15.0208 19.8042 14.55 20 14 20H2ZM9 7V2H2V18H14V7H9Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$gift = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M160-80v-440H80v-240h208q-5-9-6.5-19t-1.5-21q0-50 35-85t85-35q23 0 43 8.5t37 23.5q17-16 37-24t43-8q50 0 85 35t35 85q0 11-2 20.5t-6 19.5h208v240h-80v440H160Zm371.5-748.5Q520-817 520-800t11.5 28.5Q543-760 560-760t28.5-11.5Q600-783 600-800t-11.5-28.5Q577-840 560-840t-28.5 11.5ZM360-800q0 17 11.5 28.5T400-760q17 0 28.5-11.5T440-800q0-17-11.5-28.5T400-840q-17 0-28.5 11.5T360-800ZM160-680v80h280v-80H160Zm280 520v-360H240v360h200Zm80 0h200v-360H520v360Zm280-440v-80H520v80h280Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$groups = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0-240v-63q0-43 44-70t116-27q13 0 25 .5t23 2.5q-14 21-21 44t-7 48v65H0Zm240 0v-65q0-32 17.5-58.5T307-410q32-20 76.5-30t96.5-10q53 0 97.5 10t76.5 30q32 20 49 46.5t17 58.5v65H240Zm540 0v-65q0-26-6.5-49T754-397q11-2 22.5-2.5t23.5-.5q72 0 116 26.5t44 70.5v63H780Zm-455-80h311q-10-20-55.5-35T480-370q-55 0-100.5 15T325-320ZM160-440q-33 0-56.5-23.5T80-520q0-34 23.5-57t56.5-23q34 0 57 23t23 57q0 33-23 56.5T160-440Zm640 0q-33 0-56.5-23.5T720-520q0-34 23.5-57t56.5-23q34 0 57 23t23 57q0 33-23 56.5T800-440Zm-320-40q-50 0-85-35t-35-85q0-51 35-85.5t85-34.5q51 0 85.5 34.5T600-600q0 50-34.5 85T480-480Zm0-80q17 0 28.5-11.5T520-600q0-17-11.5-28.5T480-640q-17 0-28.5 11.5T440-600q0 17 11.5 28.5T480-560Zm1 240Zm-1-280Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$help = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M513.5-254.5Q528-269 528-290t-14.5-35.5Q499-340 478-340t-35.5 14.5Q428-311 428-290t14.5 35.5Q457-240 478-240t35.5-14.5ZM442-394h74q0-33 7.5-52t42.5-52q26-26 41-49.5t15-56.5q0-56-41-86t-97-30q-57 0-92.5 30T342-618l66 26q5-18 22.5-39t53.5-21q32 0 48 17.5t16 38.5q0 20-12 37.5T506-526q-44 39-54 59t-10 73Zm38 314q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$hint404 = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'width', '190'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'height', '69'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 190 69'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M81.9569 68.9947H129.013L129.021 69V68.9947H129.026L129.021 68.9895V21.9569C129.021 9.83247 119.188 0 107.064 0C98.5922 0 91.2394 4.80054 87.5781 11.8292L91.5 24.5L96 18L101.5 39L105 33.5L122.5 64.5L106 47.5L100.5 54.5L92.5 36.5L88 44L78.1371 25.4122C67.8329 27.2205 60 36.2162 60 47.0378C60 59.1623 69.8325 68.9947 81.9569 68.9947Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'url(#paint0_linear_24_321)')
					]),
				_List_Nil),
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M30.19 55.2733H0.320007V43.0933L28.2567 0.559998H44.11V43.0933H52.9067V55.2733H44.11V69H30.19V55.2733ZM30.19 19.5067H29.9967L14.82 43.0933H30.19V19.5067Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', '#1D66F3')
					]),
				_List_Nil),
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M167.19 55.2733H137.32V43.0933L165.257 0.559998H181.11V43.0933H189.907V55.2733H181.11V69H167.19V55.2733ZM167.19 19.5067H166.997L151.82 43.0933H167.19V19.5067Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', '#06B0FE')
					]),
				_List_Nil),
				A3(
				$elm$svg$Svg$node,
				'defs',
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$elm$svg$Svg$node,
						'linearGradient',
						_List_fromArray(
							[
								A2($elm$virtual_dom$VirtualDom$attribute, 'id', 'paint0_linear_24_321'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'x1', '73'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'y1', '63'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'x2', '116.5'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'y2', '27'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'gradientUnits', 'userSpaceOnUse')
							]),
						_List_fromArray(
							[
								A3(
								$elm$svg$Svg$node,
								'stop',
								_List_fromArray(
									[
										A2($elm$virtual_dom$VirtualDom$attribute, 'stop-color', '#1D66F3')
									]),
								_List_Nil),
								A3(
								$elm$svg$Svg$node,
								'stop',
								_List_fromArray(
									[
										A2($elm$virtual_dom$VirtualDom$attribute, 'offset', '0.371318'),
										A2($elm$virtual_dom$VirtualDom$attribute, 'stop-color', '#1483F7')
									]),
								_List_Nil),
								A3(
								$elm$svg$Svg$node,
								'stop',
								_List_fromArray(
									[
										A2($elm$virtual_dom$VirtualDom$attribute, 'offset', '0.655803'),
										A2($elm$virtual_dom$VirtualDom$attribute, 'stop-color', '#06ACFC')
									]),
								_List_Nil),
								A3(
								$elm$svg$Svg$node,
								'stop',
								_List_fromArray(
									[
										A2($elm$virtual_dom$VirtualDom$attribute, 'offset', '1'),
										A2($elm$virtual_dom$VirtualDom$attribute, 'stop-color', '#00BFFF')
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $author$project$Generated$Icons$hintHeart = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 1000 1000'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'defs',
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$elm$svg$Svg$node,
						'linearGradient',
						_List_fromArray(
							[
								A2($elm$virtual_dom$VirtualDom$attribute, 'id', 'gradient1'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'x1', '681.6406'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'y1', '1557.7874'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'x2', '681.6406'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'y2', '557.7873'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'gradientUnits', 'userSpaceOnUse')
							]),
						_List_fromArray(
							[
								A3(
								$elm$svg$Svg$node,
								'stop',
								_List_fromArray(
									[
										A2($elm$virtual_dom$VirtualDom$attribute, 'offset', '0'),
										A2($elm$virtual_dom$VirtualDom$attribute, 'stop-color', '#0F91F9')
									]),
								_List_Nil),
								A3(
								$elm$svg$Svg$node,
								'stop',
								_List_fromArray(
									[
										A2($elm$virtual_dom$VirtualDom$attribute, 'offset', '1'),
										A2($elm$virtual_dom$VirtualDom$attribute, 'stop-color', '#00BFFF')
									]),
								_List_Nil)
							])),
						A3(
						$elm$svg$Svg$node,
						'linearGradient',
						_List_fromArray(
							[
								A2($elm$virtual_dom$VirtualDom$attribute, 'id', 'gradient2'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'x1', '0'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'y1', '1239.5522'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'x2', '1000'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'y2', '1239.5522'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'gradientUnits', 'userSpaceOnUse')
							]),
						_List_fromArray(
							[
								A3(
								$elm$svg$Svg$node,
								'stop',
								_List_fromArray(
									[
										A2($elm$virtual_dom$VirtualDom$attribute, 'offset', '0'),
										A2($elm$virtual_dom$VirtualDom$attribute, 'stop-color', '#1D63F2')
									]),
								_List_Nil),
								A3(
								$elm$svg$Svg$node,
								'stop',
								_List_fromArray(
									[
										A2($elm$virtual_dom$VirtualDom$attribute, 'offset', '1'),
										A2($elm$virtual_dom$VirtualDom$attribute, 'stop-color', '#0F91F9')
									]),
								_List_Nil)
							]))
					])),
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M363.3 363.9C363.3 363.9 363.3 321.3 363.3 318.2C363.3 142.5 505.9 0 681.6 0C857.3 0 1000 142.5 1000 318.2V1000L590.6 727.5L363.3 363.9Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'url(#gradient1)')
					]),
				_List_Nil),
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M364.1 363.5C364.1 363.5 321.5 363.5 318.4 363.5C142.6 363.5 0 506.1 0 681.8C0 857.5 142.6 1000 318.4 1000H1000L364.1 363.5Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'url(#gradient2)')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$hintHeartFlat = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 1000 1000'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M363.3 363.9C363.3 363.9 363.3 321.3 363.3 318.2C363.3 142.5 505.9 0 681.6 0C857.3 0 1000 142.5 1000 318.2V1000L590.6 727.5L363.3 363.9Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', '#0F91F9')
					]),
				_List_Nil),
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M364.1 363.5C364.1 363.5 321.5 363.5 318.4 363.5C142.6 363.5 0 506.1 0 681.8C0 857.5 142.6 1000 318.4 1000H1000L364.1 363.5Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', '#1D63F2')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$history = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 24 24'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0 0h24v24H0V0z')
					]),
				_List_Nil),
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.25 2.52.77-1.28-3.52-2.09V8z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$hourglass = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M320-160h320v-120q0-66-47-113t-113-47q-66 0-113 47t-47 113v120Zm273-407q47-47 47-113v-120H320v120q0 66 47 113t113 47q66 0 113-47ZM160-80v-80h80v-120q0-61 28.5-114.5T348-480q-51-32-79.5-85.5T240-680v-120h-80v-80h640v80h-80v120q0 61-28.5 114.5T612-480q51 32 79.5 85.5T720-280v120h80v80H160Zm320-80Zm0-640Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$inbox = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '-1 -2 22 22'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H16C16.55 0 17.0208 0.195833 17.4125 0.5875C17.8042 0.979167 18 1.45 18 2V16C18 16.55 17.8042 17.0208 17.4125 17.4125C17.0208 17.8042 16.55 18 16 18H2ZM2 16H16V13H13C12.5 13.6333 11.9042 14.125 11.2125 14.475C10.5208 14.825 9.78333 15 9 15C8.21667 15 7.47917 14.825 6.7875 14.475C6.09583 14.125 5.5 13.6333 5 13H2V16ZM9 13C9.63333 13 10.2083 12.8167 10.725 12.45C11.2417 12.0833 11.6 11.6 11.8 11H16V2H2V11H6.2C6.4 11.6 6.75833 12.0833 7.275 12.45C7.79167 12.8167 8.36667 13 9 13Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$increase = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'm280-400 200-200 200 200H280Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$inventory = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 50 50'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill-rule', 'evenodd'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'clip-rule', 'evenodd'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M21.2208 41.103L29.4267 32.8971L15.1029 18.5733L6.89699 26.7792C2.94159 30.7346 2.94159 37.1476 6.89699 41.103C10.8524 45.0584 17.2654 45.0584 21.2208 41.103ZM17.8821 15.7941L32.2059 30.1179L41.103 21.2208C45.0584 17.2654 45.0584 10.8524 41.103 6.89699C37.1476 2.94159 30.7346 2.94159 26.7792 6.89699L17.8821 15.7941ZM43.8823 4.11775C38.3919 -1.37259 29.4903 -1.37258 24 4.11775L4.11775 24C-1.37258 29.4903 -1.37258 38.3919 4.11775 43.8823C9.60808 49.3726 18.5097 49.3726 24 43.8822L43.8823 24C49.3726 18.5097 49.3726 9.60808 43.8823 4.11775ZM25.6991 18.364L31.7459 12.3171L28.9667 9.53789L22.9198 15.5847L25.6991 18.364Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$invoices = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'width', '30'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'height', '30'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 30 30'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M7.46624 28C6.5051 28 5.68711 27.6626 5.01227 26.9877C4.33742 26.3129 4 25.4949 4 24.5338V20.5154H7.95704V3.00012L9.85887 4.87128L11.73 3.00012L13.5705 4.87128L15.4723 3.00012L17.3128 4.87128L19.2147 3.00012L21.0858 4.87128L22.957 3.00012L24.8281 4.87128L26.6993 3.00012V24.5338C26.6993 25.4949 26.3619 26.3129 25.687 26.9877C25.0122 27.6626 24.1942 28 23.233 28H7.46624ZM23.233 25.9141C23.642 25.9141 23.9743 25.7863 24.23 25.5307C24.4856 25.2751 24.6134 24.9428 24.6134 24.5338V6.34366H10.0736V20.5154H21.8527V24.5338C21.8527 24.9428 21.9805 25.2751 22.2361 25.5307C22.4917 25.7863 22.824 25.9141 23.233 25.9141ZM11.6993 11.2209V9.38046H18.9079V11.2209H11.6993ZM11.6993 15.3314V13.4909H18.9079V15.3314H11.6993ZM21.7607 11.2209C21.5153 11.2209 21.3005 11.1289 21.1165 10.9449C20.9324 10.7608 20.8404 10.5461 20.8404 10.3007C20.8404 10.0553 20.9324 9.84058 21.1165 9.65653C21.3005 9.47248 21.5153 9.38046 21.7607 9.38046C22.0061 9.38046 22.2208 9.47248 22.4048 9.65653C22.5889 9.84058 22.6809 10.0553 22.6809 10.3007C22.6809 10.5461 22.5889 10.7608 22.4048 10.9449C22.2208 11.1289 22.0061 11.2209 21.7607 11.2209ZM21.7607 15.178C21.5153 15.178 21.3005 15.086 21.1165 14.9019C20.9324 14.7179 20.8404 14.5031 20.8404 14.2577C20.8404 14.0123 20.9324 13.7976 21.1165 13.6136C21.3005 13.4295 21.5153 13.3375 21.7607 13.3375C22.0061 13.3375 22.2208 13.4295 22.4048 13.6136C22.5889 13.7976 22.6809 14.0123 22.6809 14.2577C22.6809 14.5031 22.5889 14.7179 22.4048 14.9019C22.2208 15.086 22.0061 15.178 21.7607 15.178ZM7.43557 25.9141H19.7668V22.6013H6.08588V24.5338C6.08588 24.9428 6.21369 25.2751 6.46931 25.5307C6.72494 25.7863 7.04702 25.9141 7.43557 25.9141Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$kebabMenu = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 3 17'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M1.2439 16.9373C0.902439 16.9373 0.609756 16.8153 0.365854 16.5714C0.121951 16.3275 0 16.0348 0 15.6934C0 15.3681 0.121951 15.0836 0.365854 14.8397C0.609756 14.5958 0.902439 14.4738 1.2439 14.4738C1.58537 14.4738 1.87805 14.5958 2.12195 14.8397C2.36585 15.0836 2.4878 15.3763 2.4878 15.7177C2.4878 16.0429 2.36585 16.3275 2.12195 16.5714C1.87805 16.8153 1.58537 16.9373 1.2439 16.9373ZM1.2439 10.1812C0.902439 10.1812 0.609756 10.0592 0.365854 9.8153C0.121951 9.5714 0 9.27872 0 8.93725C0 8.59579 0.121951 8.30311 0.365854 8.05921C0.609756 7.8153 0.902439 7.69335 1.2439 7.69335C1.58537 7.69335 1.87805 7.8153 2.12195 8.05921C2.36585 8.30311 2.4878 8.59579 2.4878 8.93725C2.4878 9.27872 2.36585 9.5714 2.12195 9.8153C1.87805 10.0592 1.58537 10.1812 1.2439 10.1812ZM1.2439 3.40067C0.902439 3.40067 0.609756 3.27872 0.365854 3.03482C0.121951 2.79091 0 2.49823 0 2.15677C0 1.8153 0.121951 1.52669 0.365854 1.29091C0.609756 1.05514 0.902439 0.937256 1.2439 0.937256C1.58537 0.937256 1.87805 1.05921 2.12195 1.30311C2.36585 1.54701 2.4878 1.83969 2.4878 2.18116C2.4878 2.52262 2.36585 2.81124 2.12195 3.04701C1.87805 3.28278 1.58537 3.40067 1.2439 3.40067Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$launch = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h560v-280h80v280q0 33-23.5 56.5T760-120H200Zm188-212-56-56 372-372H560v-80h280v280h-80v-144L388-332Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$link = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M318-120q-82 0-140-58t-58-140q0-40 15-76t43-64l134-133 56 56-134 134q-17 17-25.5 38.5T200-318q0 49 34.5 83.5T318-200q23 0 45-8.5t39-25.5l133-134 57 57-134 133q-28 28-64 43t-76 15Zm79-220-57-57 223-223 57 57-223 223Zm251-28-56-57 134-133q17-17 25-38t8-44q0-50-34-85t-84-35q-23 0-44.5 8.5T558-726L425-592l-57-56 134-134q28-28 64-43t76-15q82 0 139.5 58T839-641q0 39-14.5 75T782-502L648-368Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$location = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 12 15'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M6 13.2675C7.54074 11.9909 8.7037 10.7637 9.48889 9.58587C10.2741 8.40805 10.6667 7.31003 10.6667 6.29179C10.6667 5.39514 10.5074 4.63526 10.1889 4.01216C9.87037 3.38906 9.47778 2.87994 9.01111 2.4848C8.54444 2.08967 8.03704 1.80471 7.48889 1.62994C6.94074 1.45517 6.44444 1.36778 6 1.36778C5.55556 1.36778 5.05926 1.45517 4.51111 1.62994C3.96296 1.80471 3.45556 2.08967 2.98889 2.4848C2.52222 2.87994 2.12963 3.38906 1.81111 4.01216C1.49259 4.63526 1.33333 5.39514 1.33333 6.29179C1.33333 7.31003 1.72593 8.40805 2.51111 9.58587C3.2963 10.7637 4.45926 11.9909 6 13.2675ZM6 15C3.97037 13.4347 2.46296 11.9377 1.47778 10.5091C0.492592 9.08055 0 7.67477 0 6.29179C0 5.25836 0.181482 4.3503 0.544445 3.56763C0.907408 2.78495 1.37778 2.12766 1.95556 1.59574C2.53333 1.06383 3.17778 0.664894 3.88889 0.398936C4.6 0.132979 5.3037 0 6 0C6.6963 0 7.4 0.132979 8.11111 0.398936C8.82222 0.664894 9.46667 1.06383 10.0444 1.59574C10.6222 2.12766 11.0926 2.78495 11.4556 3.56763C11.8185 4.3503 12 5.25836 12 6.29179C12 7.67477 11.5074 9.08055 10.5222 10.5091C9.53704 11.9377 8.02963 13.4347 6 15ZM6 7.75076C6.42963 7.75076 6.7963 7.59498 7.1 7.28343C7.4037 6.97188 7.55556 6.59574 7.55556 6.15502C7.55556 5.71429 7.4037 5.33815 7.1 5.0266C6.7963 4.71505 6.42963 4.55927 6 4.55927C5.57037 4.55927 5.2037 4.71505 4.9 5.0266C4.5963 5.33815 4.44444 5.71429 4.44444 6.15502C4.44444 6.59574 4.5963 6.97188 4.9 7.28343C5.2037 7.59498 5.57037 7.75076 6 7.75076Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$lock = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M240-80q-33 0-56.5-23.5T160-160v-400q0-33 23.5-56.5T240-640h40v-80q0-83 58.5-141.5T480-920q83 0 141.5 58.5T680-720v80h40q33 0 56.5 23.5T800-560v400q0 33-23.5 56.5T720-80H240Zm0-80h480v-400H240v400Zm296.5-143.5Q560-327 560-360t-23.5-56.5Q513-440 480-440t-56.5 23.5Q400-393 400-360t23.5 56.5Q447-280 480-280t56.5-23.5ZM360-640h240v-80q0-50-35-85t-85-35q-50 0-85 35t-35 85v80ZM240-160v-400 400Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$mail = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M140-160q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h680q24 0 42 18t18 42v520q0 24-18 42t-42 18H140Zm340-302L140-685v465h680v-465L480-462Zm0-60 336-218H145l335 218ZM140-685v-55 520-465Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$marketplace = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '85 -840 805 720')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M841-518v318q0 33-23.5 56.5T761-120H201q-33 0-56.5-23.5T121-200v-318q-23-21-35.5-54t-.5-72l42-136q8-26 28.5-43t47.5-17h556q27 0 47 16.5t29 43.5l42 136q12 39-.5 71T841-518Zm-272-42q27 0 41-18.5t11-41.5l-22-140h-78v148q0 21 14 36.5t34 15.5Zm-180 0q23 0 37.5-15.5T441-612v-148h-78l-22 140q-4 24 10.5 42t37.5 18Zm-178 0q18 0 31.5-13t16.5-33l22-154h-78l-40 134q-6 20 6.5 43t41.5 23Zm540 0q29 0 42-23t6-43l-42-134h-76l22 154q3 20 16.5 33t31.5 13ZM201-200h560v-282q-5 2-6.5 2H751q-27 0-47.5-9T663-518q-18 18-41 28t-49 10q-27 0-50.5-10T481-518q-17 18-39.5 28T393-480q-29 0-52.5-10T299-518q-21 21-41.5 29.5T211-480h-4.5q-2.5 0-5.5-2v282Zm560 0H201h560Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$minus = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 24 24'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0 10.56h24v2.88H0z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$moreVert = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'width', '4'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'height', '14'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 4 14'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M1.75 0C2.23125 0 2.64323 0.171354 2.98594 0.514062C3.32865 0.856771 3.5 1.26875 3.5 1.75C3.5 2.23125 3.32865 2.64323 2.98594 2.98594C2.64323 3.32865 2.23125 3.5 1.75 3.5C1.26875 3.5 0.856771 3.32865 0.514062 2.98594C0.171354 2.64323 0 2.23125 0 1.75C0 1.26875 0.171354 0.856771 0.514062 0.514062C0.856771 0.171354 1.26875 0 1.75 0ZM1.75 5.25C2.23125 5.25 2.64323 5.42135 2.98594 5.76406C3.32865 6.10677 3.5 6.51875 3.5 7C3.5 7.48125 3.32865 7.89323 2.98594 8.23594C2.64323 8.57865 2.23125 8.75 1.75 8.75C1.26875 8.75 0.856771 8.57865 0.514062 8.23594C0.171354 7.89323 0 7.48125 0 7C0 6.51875 0.171354 6.10677 0.514062 5.76406C0.856771 5.42135 1.26875 5.25 1.75 5.25ZM1.75 10.5C2.23125 10.5 2.64323 10.6714 2.98594 11.0141C3.32865 11.3568 3.5 11.7687 3.5 12.25C3.5 12.7313 3.32865 13.1432 2.98594 13.4859C2.64323 13.8286 2.23125 14 1.75 14C1.26875 14 0.856771 13.8286 0.514062 13.4859C0.171354 13.1432 0 12.7313 0 12.25C0 11.7687 0.171354 11.3568 0.514062 11.0141C0.856771 10.6714 1.26875 10.5 1.75 10.5Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', '#0E68E2')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$onlineSignup = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 30 30'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M3 3V24.9376H11.7568L13.7667 22.9278H5.00986L5.00986 5.00986H22.52V14.1744L24.5334 12.1611V3H3Z')
					]),
				_List_Nil),
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M25.6432 19.0929L23.672 17.1461L25.0288 15.8061L27 17.7529L25.6432 19.0929ZM15.6827 27V25.0532L22.5712 18.2333L24.5424 20.1801L17.6539 27H15.6827ZM7.79999 19.233V17.4884H15.7616V19.233H7.79999ZM7.79999 14.9095V13.1902H20.0368V14.9095H7.79999ZM7.79999 10.586V8.86667H20.0368V10.586H7.79999Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$open = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'width', '12'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'height', '12'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 12 12'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M6.42857 1H11V7.86957H1M1 7.86957L4 4.73913M1 7.86957L4 11'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'stroke', 'currentColor'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'stroke-width', '1.2')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$openInFull = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M120-120v-320h80v184l504-504H520v-80h320v320h-80v-184L256-200h184v80H120Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$package = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M440-183v-274L200-596v274l240 139Zm80 0 240-139v-274L520-457v274Zm-80 92L160-252q-19-11-29.5-29T120-321v-318q0-22 10.5-40t29.5-29l280-161q19-11 40-11t40 11l280 161q19 11 29.5 29t10.5 40v318q0 22-10.5 40T800-252L520-91q-19 11-40 11t-40-11Zm200-528 77-44-237-137-78 45 238 136Zm-160 93 78-45-237-137-78 45 237 137Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$patients = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '-2 -4 28 24'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0 16V13.2C0 12.6333 0.145833 12.1125 0.4375 11.6375C0.729167 11.1625 1.11667 10.8 1.6 10.55C2.63333 10.0333 3.68333 9.64583 4.75 9.3875C5.81667 9.12917 6.9 9 8 9C9.1 9 10.1833 9.12917 11.25 9.3875C12.3167 9.64583 13.3667 10.0333 14.4 10.55C14.8833 10.8 15.2708 11.1625 15.5625 11.6375C15.8542 12.1125 16 12.6333 16 13.2V16H0ZM18 16V13C18 12.2667 17.7958 11.5625 17.3875 10.8875C16.9792 10.2125 16.4 9.63333 15.65 9.15C16.5 9.25 17.3 9.42083 18.05 9.6625C18.8 9.90417 19.5 10.2 20.15 10.55C20.75 10.8833 21.2083 11.2542 21.525 11.6625C21.8417 12.0708 22 12.5167 22 13V16H18ZM8 8C6.9 8 5.95833 7.60833 5.175 6.825C4.39167 6.04167 4 5.1 4 4C4 2.9 4.39167 1.95833 5.175 1.175C5.95833 0.391667 6.9 0 8 0C9.1 0 10.0417 0.391667 10.825 1.175C11.6083 1.95833 12 2.9 12 4C12 5.1 11.6083 6.04167 10.825 6.825C10.0417 7.60833 9.1 8 8 8ZM18 4C18 5.1 17.6083 6.04167 16.825 6.825C16.0417 7.60833 15.1 8 14 8C13.8167 8 13.5833 7.97917 13.3 7.9375C13.0167 7.89583 12.7833 7.85 12.6 7.8C13.05 7.26667 13.3958 6.675 13.6375 6.025C13.8792 5.375 14 4.7 14 4C14 3.3 13.8792 2.625 13.6375 1.975C13.3958 1.325 13.05 0.733333 12.6 0.2C12.8333 0.116667 13.0667 0.0625 13.3 0.0375C13.5333 0.0125 13.7667 0 14 0C15.1 0 16.0417 0.391667 16.825 1.175C17.6083 1.95833 18 2.9 18 4ZM2 14H14V13.2C14 13.0167 13.9542 12.85 13.8625 12.7C13.7708 12.55 13.65 12.4333 13.5 12.35C12.6 11.9 11.6917 11.5625 10.775 11.3375C9.85833 11.1125 8.93333 11 8 11C7.06667 11 6.14167 11.1125 5.225 11.3375C4.30833 11.5625 3.4 11.9 2.5 12.35C2.35 12.4333 2.22917 12.55 2.1375 12.7C2.04583 12.85 2 13.0167 2 13.2V14ZM8 6C8.55 6 9.02083 5.80417 9.4125 5.4125C9.80417 5.02083 10 4.55 10 4C10 3.45 9.80417 2.97917 9.4125 2.5875C9.02083 2.19583 8.55 2 8 2C7.45 2 6.97917 2.19583 6.5875 2.5875C6.19583 2.97917 6 3.45 6 4C6 4.55 6.19583 5.02083 6.5875 5.4125C6.97917 5.80417 7.45 6 8 6Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$paymentMethods = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'width', '30'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'height', '30'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 30 30'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M2 25.8768V5H28V25.8768H2ZM4.17734 10.6034H25.8226V7.17734H4.17734V10.6034ZM4.17734 14.734V23.6995H25.8226V14.734H4.17734Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$phone = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'width', '14'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'height', '14'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 14 14'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M12.3583 13C11.0852 13 9.82729 12.7224 8.58472 12.1674C7.34215 11.6123 6.21158 10.8255 5.19306 9.80694C4.17454 8.78841 3.38773 7.65785 2.83264 6.41528C2.27755 5.17269 2 3.91481 2 2.64167C2 2.45833 2.06111 2.30556 2.18333 2.18333C2.30556 2.06111 2.45833 2 2.64167 2H5.11667C5.25926 2 5.38658 2.04838 5.49861 2.14514C5.61065 2.2419 5.67685 2.35648 5.69722 2.48889L6.09444 4.62778C6.11481 4.79074 6.10972 4.92824 6.07917 5.04028C6.04861 5.15231 5.99259 5.24908 5.91111 5.33056L4.42917 6.82778C4.63287 7.20465 4.87477 7.56875 5.15486 7.92014C5.43495 8.27153 5.74306 8.61021 6.07917 8.93611C6.39493 9.25187 6.72591 9.54466 7.07222 9.81458C7.41854 10.0845 7.78521 10.3315 8.17222 10.5556L9.60833 9.11944C9.7 9.02778 9.81966 8.95903 9.96736 8.91319C10.1151 8.86736 10.2602 8.85465 10.4028 8.875L12.5111 9.30278C12.6537 9.34354 12.7708 9.41736 12.8625 9.52431C12.9542 9.63125 13 9.75091 13 9.88333V12.3583C13 12.5417 12.9389 12.6944 12.8167 12.8167C12.6944 12.9389 12.5417 13 12.3583 13ZM3.84861 5.66667L4.85694 4.65833L4.59722 3.22222H3.2375C3.28842 3.63981 3.35972 4.05231 3.45139 4.45972C3.54306 4.86713 3.67546 5.26944 3.84861 5.66667ZM9.31806 11.1361C9.71528 11.3092 10.1201 11.4467 10.5326 11.5486C10.9451 11.6505 11.3602 11.7167 11.7778 11.7472V10.4028L10.3417 10.1125L9.31806 11.1361Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', '#0E68E2')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$pin = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'width', '14'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'height', '14'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 14 14'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M6.5 6.825C6.83229 6.825 7.11588 6.70542 7.35078 6.46625C7.58568 6.22708 7.70312 5.93833 7.70312 5.6C7.70312 5.26167 7.58568 4.97292 7.35078 4.73375C7.11588 4.49458 6.83229 4.375 6.5 4.375C6.16771 4.375 5.88412 4.49458 5.64922 4.73375C5.41432 4.97292 5.29688 5.26167 5.29688 5.6C5.29688 5.93833 5.41432 6.22708 5.64922 6.46625C5.88412 6.70542 6.16771 6.825 6.5 6.825ZM6.5 12.6175C8.02396 11.2058 9.14974 9.92542 9.87734 8.77625C10.6049 7.62708 10.9688 6.615 10.9688 5.74C10.9688 4.36333 10.5362 3.2375 9.67109 2.3625C8.80599 1.4875 7.74896 1.05 6.5 1.05C5.25104 1.05 4.19401 1.4875 3.32891 2.3625C2.46381 3.2375 2.03125 4.36333 2.03125 5.74C2.03125 6.615 2.40365 7.62708 3.14844 8.77625C3.89323 9.92542 5.01041 11.2058 6.5 12.6175ZM6.5 14C4.65521 12.4017 3.27734 10.9171 2.36641 9.54625C1.45547 8.17542 1 6.90667 1 5.74C1 3.99 1.55286 2.59583 2.65859 1.5575C3.76432 0.519167 5.04479 0 6.5 0C7.95521 0 9.23568 0.519167 10.3414 1.5575C11.4472 2.59583 12 3.99 12 5.74C12 6.90667 11.5445 8.17542 10.6336 9.54625C9.72266 10.9171 8.34479 12.4017 6.5 14Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', '#0E68E2')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$practices = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M420-280h120v-100h100v-120H540v-100H420v100H320v120h100v100ZM160-120v-480l320-240 320 240v480H160Zm80-80h480v-360L480-740 240-560v360Zm240-270Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$progressActivity = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'height', '20px'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'width', '20px'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 31.5-155.5t86-127Q252-817 325-848.5T480-880q17 0 28.5 11.5T520-840q0 17-11.5 28.5T480-800q-133 0-226.5 93.5T160-480q0 133 93.5 226.5T480-160q133 0 226.5-93.5T800-480q0-17 11.5-28.5T840-520q17 0 28.5 11.5T880-480q0 82-31.5 155t-86 127.5q-54.5 54.5-127 86T480-80Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$quote = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 66 45')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M17.9667 0L4.4 20.52C1.83333 24.48 0 27.72 0 32.04C0 39.6 5.86667 45 12.4667 45C19.4333 45 24.9333 39.6 24.9333 32.04C24.9333 27 22.7333 22.68 17.9667 20.52L28.2333 0H17.9667ZM55.7333 20.52L66 0H55.7333L42.1667 20.52C39.6 24.48 37.7667 27.72 37.7667 32.04C37.7667 39.6 43.6333 45 50.2333 45C57.2 45 62.7 39.6 62.7 32.04C62.7 27 60.5 22.68 55.7333 20.52Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$repeat = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 34 33'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M16.6813 32.6098C12.1682 32.6098 8.32346 31.0216 5.14702 27.8451C1.97056 24.6687 0.382324 20.8249 0.382324 16.3138C0.382324 11.8028 1.97056 7.95605 5.14702 4.77365C8.32346 1.59121 12.1682 -3.8147e-06 16.6813 -3.8147e-06C19.5624 -3.8147e-06 22.0911 0.583865 24.2675 1.7516C26.4438 2.91933 28.3281 4.52533 29.9204 6.5696V-3.8147e-06H33.0639V13.1424H19.9095V10.0109H28.2617C26.987 8.0428 25.3823 6.45203 23.4476 5.2386C21.5128 4.0252 19.2573 3.4185 16.6813 3.4185C13.0778 3.4185 10.0282 4.66617 7.53247 7.1615C5.03674 9.65683 3.78887 12.7059 3.78887 16.3088C3.78887 19.9116 5.03677 22.9614 7.53257 25.4582C10.0284 27.9549 13.078 29.2033 16.6816 29.2033C19.4082 29.2033 21.9115 28.4216 24.1916 26.8582C26.4716 25.2948 28.0657 23.229 28.9736 20.6609H32.4921C31.5175 24.2406 29.5679 27.127 26.6434 29.3201C23.7189 31.5132 20.3982 32.6098 16.6813 32.6098Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$report = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '-8 -8 64 64'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M36 48V27H48V48H36ZM18 48V0H30V48H18ZM0 48V15H12V48H0Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$sandbox = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M40-120v-80h42l35-525q2-32 25-53.5t55-21.5h245q32 0 55 21.5t25 53.5l36 525h162v-246q-52-14-86-56t-34-98q0-34 13-63.5t36-51.5q-5-11-7-22t-2-23q0-50 35-85t85-35q50 0 85 35t35 85q0 12-2 23t-7 22q23 22 36 51.5t13 63.5q0 56-34 98t-86 56v246h120v80H40Zm123-80h314l-35-520h-32v360h30v80H200v-80h30v-360h-32l-35 520Zm127-160h60v-360h-60v360Zm470-160q33 0 56.5-23.5T840-600q0-28-13-43t-27-29v-88q0-17-11.5-28.5T760-800q-17 0-28.5 11.5T720-760v88q-14 14-27 29t-13 43q0 33 23.5 56.5T760-520Zm0-80Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$scissors = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 50 50'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M39.5833 43.7501L25 29.1667L20.1042 34.0626C20.382 34.5834 20.5729 35.139 20.6771 35.7293C20.7813 36.3195 20.8333 36.9098 20.8333 37.5001C20.8333 39.7918 20.0174 41.7536 18.3854 43.3855C16.7535 45.0174 14.7917 45.8334 12.5 45.8334C10.2083 45.8334 8.24653 45.0174 6.61459 43.3855C4.98264 41.7536 4.16667 39.7918 4.16667 37.5001C4.16667 35.2084 4.98264 33.2466 6.61459 31.6147C8.24653 29.9827 10.2083 29.1667 12.5 29.1667C13.0903 29.1667 13.6806 29.2188 14.2708 29.323C14.8611 29.4272 15.4167 29.6181 15.9375 29.8959L20.8333 25.0001L15.9375 20.1042C15.4167 20.382 14.8611 20.573 14.2708 20.6772C13.6806 20.7813 13.0903 20.8334 12.5 20.8334C10.2083 20.8334 8.24653 20.0174 6.61459 18.3855C4.98264 16.7536 4.16667 14.7917 4.16667 12.5001C4.16667 10.2084 4.98264 8.24661 6.61459 6.61467C8.24653 4.98272 10.2083 4.16675 12.5 4.16675C14.7917 4.16675 16.7535 4.98272 18.3854 6.61467C20.0174 8.24661 20.8333 10.2084 20.8333 12.5001C20.8333 13.0904 20.7813 13.6806 20.6771 14.2709C20.5729 14.8612 20.382 15.4167 20.1042 15.9376L45.8333 41.6668V43.7501H39.5833ZM31.25 22.9167L27.0833 18.7501L39.5833 6.25008H45.8333V8.33342L31.25 22.9167ZM12.5 16.6667C13.6458 16.6667 14.6267 16.2588 15.4427 15.4428C16.2587 14.6268 16.6667 13.6459 16.6667 12.5001C16.6667 11.3542 16.2587 10.3733 15.4427 9.55737C14.6267 8.7414 13.6458 8.33342 12.5 8.33342C11.3542 8.33342 10.3733 8.7414 9.5573 9.55737C8.74133 10.3733 8.33334 11.3542 8.33334 12.5001C8.33334 13.6459 8.74133 14.6268 9.5573 15.4428C10.3733 16.2588 11.3542 16.6667 12.5 16.6667ZM25 26.0417C25.2778 26.0417 25.5208 25.9376 25.7292 25.7293C25.9375 25.5209 26.0417 25.2779 26.0417 25.0001C26.0417 24.7223 25.9375 24.4793 25.7292 24.2709C25.5208 24.0626 25.2778 23.9584 25 23.9584C24.7222 23.9584 24.4792 24.0626 24.2708 24.2709C24.0625 24.4793 23.9583 24.7223 23.9583 25.0001C23.9583 25.2779 24.0625 25.5209 24.2708 25.7293C24.4792 25.9376 24.7222 26.0417 25 26.0417ZM12.5 41.6668C13.6458 41.6668 14.6267 41.2588 15.4427 40.4428C16.2587 39.6268 16.6667 38.6459 16.6667 37.5001C16.6667 36.3543 16.2587 35.3733 15.4427 34.5574C14.6267 33.7414 13.6458 33.3334 12.5 33.3334C11.3542 33.3334 10.3733 33.7414 9.5573 34.5574C8.74133 35.3733 8.33334 36.3543 8.33334 37.5001C8.33334 38.6459 8.74133 39.6268 9.5573 40.4428C10.3733 41.2588 11.3542 41.6668 12.5 41.6668Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$search = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 16 16'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M14.9071 16L9.11475 10.2216C8.69217 10.5864 8.18944 10.871 7.60656 11.0752C7.02368 11.2795 6.40437 11.3817 5.74863 11.3817C4.14572 11.3817 2.78689 10.8272 1.67213 9.71819C0.557377 8.60921 0 7.26676 0 5.69083C0 4.11491 0.557377 2.77246 1.67213 1.66347C2.78689 0.554492 4.13115 0 5.70492 0C7.27869 0 8.61931 0.554492 9.72678 1.66347C10.8342 2.77246 11.388 4.11491 11.388 5.69083C11.388 6.31829 11.286 6.92385 11.082 7.50752C10.878 8.0912 10.5792 8.6384 10.1858 9.14911L16 14.9056L14.9071 16ZM5.72678 9.8933C6.87796 9.8933 7.85792 9.48108 8.66667 8.65663C9.47541 7.83219 9.87978 6.84359 9.87978 5.69083C9.87978 4.53808 9.47541 3.54948 8.66667 2.72503C7.85792 1.90059 6.87796 1.48837 5.72678 1.48837C4.54645 1.48837 3.54827 1.90059 2.73224 2.72503C1.91621 3.54948 1.5082 4.53808 1.5082 5.69083C1.5082 6.84359 1.91621 7.83219 2.73224 8.65663C3.54827 9.48108 4.54645 9.8933 5.72678 9.8933Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$selectArrows = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'width', '14'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'height', '14'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 14 14'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M4.13031 13L4.13031 1M4.13031 1L7.26074 4M4.13031 1L0.999873 4'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'stroke', 'currentColor'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'stroke-width', '1.2')
					]),
				_List_Nil),
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M10.1304 1V13M10.1304 13L7 10M10.1304 13L13.2609 10'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'stroke', 'currentColor'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'stroke-width', '1.2')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$send = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M120-160v-640l760 320-760 320Zm80-120 474-200-474-200v140l240 60-240 60v140Zm0 0v-400 400Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$share = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '3 0 48 48'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'stroke', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'stroke-width', '1'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M36.35 44.3Q33.85 44.3 32.1 42.525Q30.35 40.75 30.35 38.3Q30.35 37.95 30.425 37.45Q30.5 36.95 30.65 36.55L15.95 28Q15.2 28.9 14.05 29.45Q12.9 30 11.7 30Q9.2 30 7.45 28.25Q5.7 26.5 5.7 24Q5.7 21.5 7.45 19.75Q9.2 18 11.7 18Q12.9 18 14 18.475Q15.1 18.95 15.95 19.85L30.65 11.4Q30.5 11.05 30.425 10.575Q30.35 10.1 30.35 9.7Q30.35 7.2 32.1 5.45Q33.85 3.7 36.35 3.7Q38.85 3.7 40.6 5.45Q42.35 7.2 42.35 9.7Q42.35 12.2 40.6 13.95Q38.85 15.7 36.35 15.7Q35.15 15.7 34.025 15.3Q32.9 14.9 32.15 14.05L17.45 22.15Q17.55 22.55 17.625 23.1Q17.7 23.65 17.7 24Q17.7 24.35 17.625 24.75Q17.55 25.15 17.45 25.6L32.15 33.9Q32.9 33.2 33.95 32.75Q35 32.3 36.35 32.3Q38.85 32.3 40.6 34.05Q42.35 35.8 42.35 38.3Q42.35 40.8 40.6 42.55Q38.85 44.3 36.35 44.3ZM36.35 12.4Q37.5 12.4 38.275 11.625Q39.05 10.85 39.05 9.7Q39.05 8.55 38.275 7.775Q37.5 7 36.35 7Q35.2 7 34.425 7.775Q33.65 8.55 33.65 9.7Q33.65 10.85 34.425 11.625Q35.2 12.4 36.35 12.4ZM11.7 26.7Q12.85 26.7 13.625 25.925Q14.4 25.15 14.4 24Q14.4 22.85 13.625 22.075Q12.85 21.3 11.7 21.3Q10.55 21.3 9.775 22.075Q9 22.85 9 24Q9 25.15 9.775 25.925Q10.55 26.7 11.7 26.7ZM36.35 41Q37.5 41 38.275 40.225Q39.05 39.45 39.05 38.3Q39.05 37.15 38.275 36.375Q37.5 35.6 36.35 35.6Q35.2 35.6 34.425 36.375Q33.65 37.15 33.65 38.3Q33.65 39.45 34.425 40.225Q35.2 41 36.35 41Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$shield = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'width', '14'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'height', '14'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 14 14'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M7.00001 0L1.27274 2.15385V6.46154C1.27274 10.2308 4.13637 13.4615 7.00001 14C9.86364 13.4615 12.7273 10.2308 12.7273 6.46154V2.15385L7.00001 0ZM7.00001 1.29231L11.5818 3.01538V6.46154C11.5818 9.47692 9.29092 12.0615 7.00001 12.7077C4.7091 12.0615 2.41819 9.47692 2.41819 6.46154V3.01538L7.00001 1.29231ZM5.28183 5.92308L4.7091 6.46154L6.42728 8.07692L9.29092 5.38462L8.71819 4.84615L7.00001 6.46154L5.28183 5.92308Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', '#0E68E2')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$sort = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 7 11'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0.0811703 3.74379L3.09733 0.105446C3.22316 -0.0351486 3.44354 -0.0351486 3.56937 0.105446L6.57064 3.74379C6.75231 3.94762 6.60787 4.27046 6.33462 4.27046H0.316447C0.043943 4.27046 -0.101244 3.94762 0.0811703 3.74379Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', '#C4DCF8')
					]),
				_List_Nil),
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0.0811703 6.30308L3.09733 9.94143C3.22316 10.082 3.44354 10.082 3.56937 9.94143L6.57064 6.30308C6.75231 6.09926 6.60787 5.77641 6.33462 5.77641H0.316447C0.043943 5.77641 -0.101244 6.09926 0.0811703 6.30308Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', '#C4DCF8')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$sortDown = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 7 11'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0.0811703 3.74379L3.09733 0.105446C3.22316 -0.0351486 3.44354 -0.0351486 3.56937 0.105446L6.57064 3.74379C6.75231 3.94762 6.60787 4.27046 6.33462 4.27046H0.316447C0.043943 4.27046 -0.101244 3.94762 0.0811703 3.74379Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', '#C4DCF8')
					]),
				_List_Nil),
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0.0811703 6.30308L3.09733 9.94143C3.22316 10.082 3.44354 10.082 3.56937 9.94143L6.57064 6.30308C6.75231 6.09926 6.60787 5.77641 6.33462 5.77641H0.316447C0.043943 5.77641 -0.101244 6.09926 0.0811703 6.30308Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$sortUp = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 7 11'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0.0811703 3.74379L3.09733 0.105446C3.22316 -0.0351486 3.44354 -0.0351486 3.56937 0.105446L6.57064 3.74379C6.75231 3.94762 6.60787 4.27046 6.33462 4.27046H0.316447C0.043943 4.27046 -0.101244 3.94762 0.0811703 3.74379Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
					]),
				_List_Nil),
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0.0811703 6.30308L3.09733 9.94143C3.22316 10.082 3.44354 10.082 3.56937 9.94143L6.57064 6.30308C6.75231 6.09926 6.60787 5.77641 6.33462 5.77641H0.316447C0.043943 5.77641 -0.101244 6.09926 0.0811703 6.30308Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', '#C4DCF8')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$sponsors = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '2 -2 48 48'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M4 42V9.5L14 2L24 9.5V14H44V42H4ZM8 38H12V34H8V38ZM8 30H12V26H8V30ZM8 22H12V18H8V22ZM8 14H12V10H8V14ZM16 14H20V10H16V14ZM16 38H40V18H16V38ZM28 26V22H36V26H28ZM28 34V30H36V34H28ZM20 26V22H24V26H20ZM20 34V30H24V34H20Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$star = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'width', '50'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'height', '50'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 50 50'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M44.375 38.9584L38.125 32.7084L41.0417 29.7917L47.2917 36.0417L44.375 38.9584ZM36.875 13.9584L33.9583 11.0417L40.2083 4.79175L43.125 7.70841L36.875 13.9584ZM13.125 13.9584L6.87501 7.70841L9.79168 4.79175L16.0417 11.0417L13.125 13.9584ZM5.62501 38.9584L2.70834 36.0417L8.95834 29.7917L11.875 32.7084L5.62501 38.9584ZM18.4375 35.0522L25 31.0938L31.5625 35.1042L29.8438 27.6042L35.625 22.6042L28.0208 21.9272L25 14.8438L21.9792 21.8751L14.375 22.5522L20.1563 27.6042L18.4375 35.0522ZM12.1354 43.7501L15.5208 29.1147L4.16668 19.2709L19.1667 17.9688L25 4.16675L30.8333 17.9688L45.8333 19.2709L34.4792 29.1147L37.8646 43.7501L25 35.9897L12.1354 43.7501Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$starNote = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'height', '50'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 50 50'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill-rule', 'evenodd'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'clip-rule', 'evenodd'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M26.2353 34.6797H16.3529V31.3984H26.2353V34.6797ZM32.978 25.3281H16.3529V22.0469H32.978V25.3281ZM32.978 15.9766H16.3529V12.6953H32.978V15.9766ZM4.92647 42.3906C5.54412 43.0469 6.26472 43.375 7.08824 43.375H28.7059V40.0938H7.08824V7.28125H37.9706V25H41.0588V7.28125C41.0588 6.4063 40.75 5.64062 40.1324 4.98438C39.5147 4.32812 38.794 4 37.9706 4H7.08824C6.26472 4 5.54412 4.32812 4.92647 4.98438C4.30882 5.64062 4 6.4063 4 7.28125V40.0938C4 40.9687 4.30882 41.7344 4.92647 42.3906ZM34.5592 39.7809L37.3529 46L40.1467 39.7809L46 36.8125L40.1467 33.8441L37.3529 27.625L34.5592 33.8441L28.7059 36.8125L34.5592 39.7809ZM12.0294 16.3375C13.0528 16.3375 13.8824 15.456 13.8824 14.3688C13.8824 13.2816 13.0528 12.4 12.0294 12.4C11.006 12.4 10.1765 13.2816 10.1765 14.3688C10.1765 15.456 11.006 16.3375 12.0294 16.3375ZM13.8824 23.6875C13.8824 24.7747 13.0528 25.6562 12.0294 25.6562C11.006 25.6562 10.1765 24.7747 10.1765 23.6875C10.1765 22.6003 11.006 21.7188 12.0294 21.7188C13.0528 21.7188 13.8824 22.6003 13.8824 23.6875ZM12.0294 34.975C13.0528 34.975 13.8824 34.0935 13.8824 33.0063C13.8824 31.919 13.0528 31.0375 12.0294 31.0375C11.006 31.0375 10.1765 31.919 10.1765 33.0063C10.1765 34.0935 11.006 34.975 12.0294 34.975Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', '#00BFFF')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$stop = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 14 14'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M7 14C6.03448 14 5.12644 13.8161 4.27586 13.4483C3.42529 13.0805 2.68391 12.5805 2.05172 11.9483C1.41954 11.3161 0.91954 10.5747 0.551724 9.72414C0.183908 8.87356 0 7.96552 0 7C0 6.03448 0.183908 5.12356 0.551724 4.26724C0.91954 3.41092 1.41954 2.66954 2.05172 2.0431C2.68391 1.41667 3.42529 0.91954 4.27586 0.551724C5.12644 0.183908 6.03448 0 7 0C7.96552 0 8.87356 0.183908 9.72414 0.551724C10.5747 0.91954 11.3161 1.41667 11.9483 2.0431C12.5805 2.66954 13.0805 3.41092 13.4483 4.26724C13.8161 5.12356 14 6.03448 14 7C14 7.96552 13.8161 8.87356 13.4483 9.72414C13.0805 10.5747 12.5805 11.3161 11.9483 11.9483C11.3161 12.5805 10.5747 13.0805 9.72414 13.4483C8.87356 13.8161 7.96552 14 7 14ZM7 12.8276C8.62069 12.8276 9.99713 12.2615 11.1293 11.1293C12.2615 9.99713 12.8276 8.62069 12.8276 7C12.8276 6.32184 12.7126 5.66667 12.4828 5.03448C12.2529 4.4023 11.9253 3.82759 11.5 3.31034L3.31034 11.4828C3.81609 11.931 4.38793 12.2672 5.02586 12.4914C5.66379 12.7155 6.32184 12.8276 7 12.8276ZM2.51724 10.6897L10.6897 2.51724C10.1724 2.08046 9.5977 1.74713 8.96552 1.51724C8.33333 1.28736 7.67816 1.17241 7 1.17241C5.37931 1.17241 4.00287 1.73563 2.87069 2.86207C1.73851 3.98851 1.17241 5.36782 1.17241 7C1.17241 7.67816 1.2931 8.33333 1.53448 8.96552C1.77586 9.5977 2.10345 10.1724 2.51724 10.6897Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$syncedFrom = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 15 17'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'transform', 'rotate(180, 7.5, 8.5)'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M12.5 12.0161C11.8667 12.0161 11.3 12.2721 10.8667 12.6732L4.925 9.13153C4.96667 8.93524 5 8.73896 5 8.53414C5 8.32932 4.96667 8.13303 4.925 7.93675L10.8 4.42922C11.25 4.85592 11.8417 5.12048 12.5 5.12048C13.8833 5.12048 15 3.97691 15 2.56024C15 1.14357 13.8833 0 12.5 0C11.1167 0 10 1.14357 10 2.56024C10 2.76506 10.0333 2.96135 10.075 3.15763L4.2 6.66516C3.75 6.23845 3.15833 5.9739 2.5 5.9739C1.11667 5.9739 0 7.11747 0 8.53414C0 9.9508 1.11667 11.0944 2.5 11.0944C3.15833 11.0944 3.75 10.8298 4.2 10.4031L10.1333 13.9533C10.0917 14.1325 10.0667 14.3203 10.0667 14.508C10.0667 15.882 11.1583 17 12.5 17C13.8417 17 14.9333 15.882 14.9333 14.508C14.9333 13.134 13.8417 12.0161 12.5 12.0161ZM12.5 1.70683C12.9583 1.70683 13.3333 2.09086 13.3333 2.56024C13.3333 3.02962 12.9583 3.41365 12.5 3.41365C12.0417 3.41365 11.6667 3.02962 11.6667 2.56024C11.6667 2.09086 12.0417 1.70683 12.5 1.70683ZM2.5 9.38755C2.04167 9.38755 1.66667 9.00351 1.66667 8.53414C1.66667 8.06476 2.04167 7.68072 2.5 7.68072C2.95833 7.68072 3.33333 8.06476 3.33333 8.53414C3.33333 9.00351 2.95833 9.38755 2.5 9.38755ZM12.5 15.3785C12.0417 15.3785 11.6667 14.9945 11.6667 14.5251C11.6667 14.0557 12.0417 13.6717 12.5 13.6717C12.9583 13.6717 13.3333 14.0557 13.3333 14.5251C13.3333 14.9945 12.9583 15.3785 12.5 15.3785Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$syncedTo = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 15 17'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M12.5 12.0161C11.8667 12.0161 11.3 12.2721 10.8667 12.6732L4.925 9.13153C4.96667 8.93524 5 8.73896 5 8.53414C5 8.32932 4.96667 8.13303 4.925 7.93675L10.8 4.42922C11.25 4.85592 11.8417 5.12048 12.5 5.12048C13.8833 5.12048 15 3.97691 15 2.56024C15 1.14357 13.8833 0 12.5 0C11.1167 0 10 1.14357 10 2.56024C10 2.76506 10.0333 2.96135 10.075 3.15763L4.2 6.66516C3.75 6.23845 3.15833 5.9739 2.5 5.9739C1.11667 5.9739 0 7.11747 0 8.53414C0 9.9508 1.11667 11.0944 2.5 11.0944C3.15833 11.0944 3.75 10.8298 4.2 10.4031L10.1333 13.9533C10.0917 14.1325 10.0667 14.3203 10.0667 14.508C10.0667 15.882 11.1583 17 12.5 17C13.8417 17 14.9333 15.882 14.9333 14.508C14.9333 13.134 13.8417 12.0161 12.5 12.0161ZM12.5 1.70683C12.9583 1.70683 13.3333 2.09086 13.3333 2.56024C13.3333 3.02962 12.9583 3.41365 12.5 3.41365C12.0417 3.41365 11.6667 3.02962 11.6667 2.56024C11.6667 2.09086 12.0417 1.70683 12.5 1.70683ZM2.5 9.38755C2.04167 9.38755 1.66667 9.00351 1.66667 8.53414C1.66667 8.06476 2.04167 7.68072 2.5 7.68072C2.95833 7.68072 3.33333 8.06476 3.33333 8.53414C3.33333 9.00351 2.95833 9.38755 2.5 9.38755ZM12.5 15.3785C12.0417 15.3785 11.6667 14.9945 11.6667 14.5251C11.6667 14.0557 12.0417 13.6717 12.5 13.6717C12.9583 13.6717 13.3333 14.0557 13.3333 14.5251C13.3333 14.9945 12.9583 15.3785 12.5 15.3785Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$task = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -1 20 22'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M7.6 15.05L14.65 8L13.25 6.6L7.6 12.25L4.75 9.4L3.35 10.8L7.6 15.05ZM2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V4C0 3.45 0.195833 2.97917 0.5875 2.5875C0.979167 2.19583 1.45 2 2 2H6.2C6.41667 1.4 6.77917 0.916667 7.2875 0.55C7.79583 0.183333 8.36667 0 9 0C9.63333 0 10.2042 0.183333 10.7125 0.55C11.2208 0.916667 11.5833 1.4 11.8 2H16C16.55 2 17.0208 2.19583 17.4125 2.5875C17.8042 2.97917 18 3.45 18 4V18C18 18.55 17.8042 19.0208 17.4125 19.4125C17.0208 19.8042 16.55 20 16 20H2ZM2 18H16V4H2V18ZM9 3.25C9.21667 3.25 9.39583 3.17917 9.5375 3.0375C9.67917 2.89583 9.75 2.71667 9.75 2.5C9.75 2.28333 9.67917 2.10417 9.5375 1.9625C9.39583 1.82083 9.21667 1.75 9 1.75C8.78333 1.75 8.60417 1.82083 8.4625 1.9625C8.32083 2.10417 8.25 2.28333 8.25 2.5C8.25 2.71667 8.32083 2.89583 8.4625 3.0375C8.60417 3.17917 8.78333 3.25 9 3.25Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$testConnection = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'class', 'svg-icon'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'style', 'width: 1.80078125em; height: 1em;vertical-align: middle;fill: currentColor;overflow: hidden;'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 1844 1024'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'version', '1.1'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M650.541129 1022.638311 108.423481 1022.638311C52.314305 1022.638311 6.776422 976.885119 6.776422 920.510651L6.776422 103.489375C6.776422 47.114907 52.314305 1.361715 108.423481 1.361715L650.541129 1.361715C706.650305 1.361715 752.188187 47.114907 752.188187 103.489375 752.188187 159.863843 706.650305 205.617034 650.541129 205.617034L210.07054 205.617034 210.07054 818.382991 650.541129 818.382991C706.650305 818.382991 752.188187 864.136183 752.188187 920.510651 752.188187 976.885119 706.650305 1022.638311 650.541129 1022.638311L650.541129 1022.638311ZM1734.776422 1022.638311 1192.65878 1022.638311C1136.549601 1022.638311 1091.011717 976.885119 1091.011717 920.510651 1091.011717 864.136183 1136.549601 818.382991 1192.65878 818.382991L1633.129359 818.382991 1633.129359 205.617034 1192.65878 205.617034C1136.549601 205.617034 1091.011717 159.863843 1091.011717 103.489375 1091.011717 47.114907 1136.549601 1.361715 1192.65878 1.361715L1734.776422 1.361715C1790.885601 1.361715 1836.423485 47.114907 1836.423485 103.489375L1836.423485 920.510651C1836.423485 976.885119 1790.885601 1022.638311 1734.776422 1022.638311L1734.776422 1022.638311ZM1328.188191 614.127672 515.011716 614.127672C458.90254 614.127672 413.364658 568.374481 413.364658 512.000013 413.364658 455.625545 458.90254 409.872353 515.011716 409.872353L1328.188191 409.872353C1384.297359 409.872353 1429.835244 455.625545 1429.835244 512.000013 1429.835244 568.374481 1384.297359 614.127672 1328.188191 614.127672L1328.188191 614.127672Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$transfer = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 42 33'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M10.3555 32.6098L0.418457 22.6728L10.3555 12.7359L12.7425 15.1228L6.90771 20.9696H22.2414V24.3881H6.90766L12.7424 30.2228L10.3555 32.6098ZM31.0794 19.8739L28.6924 17.487L34.5392 11.6522H19.2055V8.2337H34.5392L28.6924 2.387L31.0794 -3.8147e-06L41.0283 9.937L31.0794 19.8739Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$translate = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 12 12'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M5.99882 12C5.16604 12 4.38488 11.8428 3.65534 11.5283C2.92571 11.2138 2.29008 10.7854 1.74846 10.243C1.20675 9.70048 0.77993 9.06279 0.468017 8.32991C0.156006 7.59713 0 6.81435 0 5.98156C0 5.14622 0.156006 4.36565 0.468017 3.63985C0.77993 2.91396 1.20675 2.28059 1.74846 1.73976C2.29008 1.19893 2.92571 0.773784 3.65534 0.464329C4.38488 0.154776 5.16604 0 5.99882 0C6.83406 0 7.61586 0.154776 8.34422 0.464329C9.07257 0.773784 9.70756 1.19893 10.2492 1.73976C10.7909 2.28059 11.2181 2.91396 11.5308 3.63985C11.8436 4.36565 12 5.14622 12 5.98156C12 6.81435 11.8436 7.59713 11.5308 8.32991C11.2181 9.06279 10.7909 9.70048 10.2492 10.243C9.70756 10.7854 9.07257 11.2138 8.34422 11.5283C7.61586 11.8428 6.83406 12 5.99882 12ZM5.9941 10.896C6.3009 10.5451 6.56207 10.1543 6.77762 9.72363C6.99317 9.29293 7.17056 8.79645 7.3098 8.23418H4.6964C4.826 8.7702 4.99798 9.25847 5.21235 9.699C5.42672 10.1395 5.6873 10.5385 5.9941 10.896ZM4.65996 10.6993C4.4339 10.3467 4.2417 9.96799 4.08339 9.56315C3.92507 9.15841 3.79183 8.71542 3.68366 8.23418H1.64492C1.98358 8.86037 2.3867 9.3657 2.85427 9.75018C3.32194 10.1346 3.92384 10.451 4.65996 10.6993ZM7.3393 10.6895C7.99017 10.482 8.57441 10.1676 9.09204 9.74635C9.60957 9.32509 10.0286 8.82103 10.3492 8.23418H8.32268C8.20793 8.70884 8.07188 9.14858 7.91455 9.55342C7.75712 9.95816 7.56537 10.3368 7.3393 10.6895ZM1.28458 7.26142H3.49678C3.46728 7.01893 3.44845 6.79601 3.44029 6.59265C3.43203 6.3894 3.4279 6.1857 3.4279 5.98156C3.4279 5.74881 3.43365 5.53793 3.44515 5.34894C3.45666 5.15994 3.47716 4.95398 3.50666 4.73106H1.28458C1.22233 4.95319 1.17892 5.15733 1.15433 5.34348C1.12975 5.52952 1.11746 5.74222 1.11746 5.98156C1.11746 6.21845 1.12975 6.43547 1.15433 6.63263C1.17892 6.82979 1.22233 7.03938 1.28458 7.26142ZM4.49978 7.26142H7.50656C7.54098 6.99267 7.56315 6.76321 7.57309 6.57304C7.58302 6.38286 7.58798 6.1857 7.58798 5.98156C7.58798 5.78155 7.58302 5.59034 7.57309 5.40794C7.56315 5.22543 7.54098 4.9998 7.50656 4.73106H4.49978C4.46369 4.9998 4.43994 5.22543 4.42854 5.40794C4.41703 5.59034 4.41128 5.78155 4.41128 5.98156C4.41128 6.1857 4.41703 6.38286 4.42854 6.57304C4.43994 6.76321 4.46369 6.99267 4.49978 7.26142ZM8.4898 7.26142H10.7083C10.769 7.03938 10.812 6.82979 10.8374 6.63263C10.8628 6.43547 10.8755 6.21845 10.8755 5.98156C10.8755 5.74222 10.8628 5.52952 10.8374 5.34348C10.812 5.15733 10.769 4.95319 10.7083 4.73106H8.49968C8.52525 5.02763 8.54359 5.26678 8.5547 5.4485C8.56581 5.63012 8.57137 5.80781 8.57137 5.98156C8.57137 6.19219 8.56419 6.3926 8.54983 6.58277C8.53547 6.77305 8.51546 6.99926 8.4898 7.26142ZM8.3128 3.75476H10.3492C10.0417 3.14322 9.62919 2.62702 9.11166 2.20616C8.59413 1.78529 8.0001 1.48424 7.32956 1.30301C7.55553 1.65062 7.74724 2.02296 7.90467 2.42003C8.0621 2.8171 8.19814 3.26201 8.3128 3.75476ZM4.6964 3.75476H7.31968C7.21063 3.26781 7.03973 2.79856 6.80697 2.34702C6.57422 1.89547 6.30326 1.48852 5.9941 1.12616C5.70697 1.41801 5.46113 1.77088 5.2566 2.18477C5.05207 2.59865 4.86533 3.12198 4.6964 3.75476ZM1.64492 3.75476H3.6934C3.79507 3.28168 3.92178 2.84827 4.0735 2.45455C4.22533 2.06072 4.41752 1.68017 4.65008 1.3129C3.97797 1.49412 3.38886 1.79148 2.88274 2.20498C2.37652 2.61857 1.96391 3.13516 1.64492 3.75476Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$trendingDown = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'width', '25'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'height', '25'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 25 25'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'mask',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'id', 'mask0_107_13'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'style', 'mask-type:alpha'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'maskUnits', 'userSpaceOnUse'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'x', '0'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'y', '0'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'width', '25'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'height', '25')
					]),
				_List_fromArray(
					[
						A3(
						$elm$svg$Svg$node,
						'rect',
						_List_fromArray(
							[
								A2($elm$virtual_dom$VirtualDom$attribute, 'x', '0.90918'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'y', '0.0909119'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'width', '24'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'height', '24'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'fill', '#E1000C')
							]),
						_List_Nil)
					])),
				A3(
				$elm$svg$Svg$node,
				'g',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'mask', 'url(#mask0_107_13)')
					]),
				_List_fromArray(
					[
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M16.9092 18.0909V16.0909H19.5092L14.3092 10.9409L10.3092 14.9409L2.90918 7.49091L4.30918 6.09091L10.3092 12.0909L14.3092 8.09091L20.9092 14.6909V12.0909H22.9092V18.0909H16.9092Z'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$Generated$Icons$trendingUp = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '1 -4 20 20'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M1.4 12L0 10.6L7.4 3.15L11.4 7.15L16.6 2H14V0H20V6H18V3.4L11.4 10L7.4 6L1.4 12Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$unpublishedRuleArrow = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'width', '21'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'height', '22'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 21 22'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M1 19H0.5V19.5H1V19ZM20.5 19L15.5 16.1132V21.8868L20.5 19ZM0.5 0.5V19H1.5V0.5H0.5ZM1 19.5H16V18.5H1V19.5Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$upload = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 15 16'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M1.54097 15.119C1.12482 15.119 0.763951 14.9656 0.458371 14.6587C0.15279 14.3519 0 13.9895 0 13.5715V10.0949H1.54097V13.5726H13.459V10.0949H15V13.5701C15 13.9877 14.8463 14.3503 14.5388 14.6578C14.2313 14.9653 13.8714 15.119 13.459 15.119H1.54097ZM6.73223 11.2853V2.97522L4.05056 5.66232L2.94277 4.55994L7.5027 0L12.0626 4.55994L10.9548 5.66232L8.27318 2.97522V11.2853H6.73223Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$visibility = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M607.5-372.5Q660-425 660-500t-52.5-127.5Q555-680 480-680t-127.5 52.5Q300-575 300-500t52.5 127.5Q405-320 480-320t127.5-52.5Zm-204-51Q372-455 372-500t31.5-76.5Q435-608 480-608t76.5 31.5Q588-545 588-500t-31.5 76.5Q525-392 480-392t-76.5-31.5ZM214-281.5Q94-363 40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200q-146 0-266-81.5ZM480-500Zm207.5 160.5Q782-399 832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280q113 0 207.5-59.5Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$visibilityOff = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'm644-428-58-58q9-47-27-88t-93-32l-58-58q17-8 34.5-12t37.5-4q75 0 127.5 52.5T660-500q0 20-4 37.5T644-428Zm128 126-58-56q38-29 67.5-63.5T832-500q-50-101-143.5-160.5T480-720q-29 0-57 4t-55 12l-62-62q41-17 84-25.5t90-8.5q151 0 269 83.5T920-500q-23 59-60.5 109.5T772-302Zm20 246L624-222q-35 11-70.5 16.5T480-200q-151 0-269-83.5T40-500q21-53 53-98.5t73-81.5L56-792l56-56 736 736-56 56ZM222-624q-29 26-53 57t-41 67q50 101 143.5 160.5T480-280q20 0 39-2.5t39-5.5l-36-38q-11 3-21 4.5t-21 1.5q-75 0-127.5-52.5T300-500q0-11 1.5-21t4.5-21l-84-82Zm319 93Zm-151 75Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$void = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 14 11'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M6.40872 8.5L8.52589 6.36538L10.6621 8.5L11.5395 7.63461L9.3842 5.5L11.5014 3.36539L10.624 2.48077L8.52589 4.63462L6.40872 2.48077L5.53134 3.36539L7.66758 5.5L5.53134 7.63461L6.40872 8.5ZM3.87193 11L0 5.5L3.87193 0H14V11H3.87193ZM4.53951 9.69231H12.703V1.30769H4.53951L1.62125 5.5L4.53951 9.69231Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$wandStars = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'm176-120-56-56 301-302-181-45 198-123-17-234 179 151 216-88-87 217 151 178-234-16-124 198-45-181-301 301Zm24-520-80-80 80-80 80 80-80 80Zm355 197 48-79 93 7-60-71 35-86-86 35-71-59 7 92-79 49 90 22 23 90Zm165 323-80-80 80-80 80 80-80 80ZM569-570Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$warning = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'm40-120 440-760 440 760H40Zm138-80h604L480-720 178-200Zm330.5-51.5Q520-263 520-280t-11.5-28.5Q497-320 480-320t-28.5 11.5Q440-297 440-280t11.5 28.5Q463-240 480-240t28.5-11.5ZM440-360h80v-200h-80v200Zm40-100Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$webhook = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M280-120q-83 0-141.5-58.5T80-320q0-73 45.5-127.5T240-516v83q-35 12-57.5 43T160-320q0 50 35 85t85 35q50 0 85-35t35-85v-40h235q8-9 19.5-14.5T680-380q25 0 42.5 17.5T740-320q0 25-17.5 42.5T680-260q-14 0-25.5-5.5T635-280H476q-14 69-68.5 114.5T280-120Zm400 0q-56 0-101.5-27.5T507-220h107q14 10 31 15t35 5q50 0 85-35t35-85q0-50-35-85t-85-35q-20 0-37 5.5T611-418L489-621q-21-4-35-20t-14-39q0-25 17.5-42.5T500-740q25 0 42.5 17.5T560-680v8.5q0 3.5-2 8.5l87 146q8-2 17-2.5t18-.5q83 0 141.5 58.5T880-320q0 83-58.5 141.5T680-120ZM280-260q-25 0-42.5-17.5T220-320q0-22 14-38t34-21l94-156q-29-27-45.5-64.5T300-680q0-83 58.5-141.5T500-880q83 0 141.5 58.5T700-680h-80q0-50-35-85t-85-35q-50 0-85 35t-35 85q0 43 26 75.5t66 41.5L337-338q2 5 2.5 9t.5 9q0 25-17.5 42.5T280-260Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$wrench = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M356.41-354.5q-102.87 0-175.14-72.27Q109-499.04 109-601.91q0-20 3.24-40T123-680.39q5.24-10.72 13.46-16.44 8.21-5.71 18.17-7.71t20.17.74q10.22 2.73 18.7 11.21L296.59-589.5l72-72L265.5-764.59q-8.48-8.48-11.22-18.81-2.74-10.34-.74-20.06 2-9.71 7.6-17.93 5.6-8.22 16.32-13.46 18.47-7.76 38.83-11t40.12-3.24q102.87 0 175.02 72.16 72.16 72.15 72.16 175.02 0 22.28-3.64 42.3-3.65 20.02-11.17 40.02l206.07 204.07Q826-284.37 826-239.5t-31.15 76.02q-31.15 31.15-76.14 31.15t-76.14-31.91L438.5-369.3q-19.28 7.28-38.95 11.04-19.66 3.76-43.14 3.76Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Ui$Icon$generatedFun = function (name) {
	switch (name) {
		case 0:
			return $author$project$Generated$Icons$syncedTo;
		case 1:
			return $author$project$Generated$Icons$syncedFrom;
		case 2:
			return $author$project$Generated$Icons$unpublishedRuleArrow;
		case 3:
			return $author$project$Generated$Icons$account;
		case 4:
			return $author$project$Generated$Icons$admin;
		case 6:
			return $author$project$Generated$Icons$commissions;
		case 7:
			return $author$project$Generated$Icons$help;
		case 8:
			return $author$project$Generated$Icons$patients;
		case 9:
			return $author$project$Generated$Icons$report;
		case 10:
			return $author$project$Generated$Icons$share;
		case 11:
			return $author$project$Generated$Icons$sponsors;
		case 12:
			return $author$project$Generated$Icons$chevron;
		case 13:
			return $author$project$Generated$Icons$chevronDown;
		case 14:
			return $author$project$Generated$Icons$location;
		case 15:
			return $author$project$Generated$Icons$copy;
		case 16:
			return $author$project$Generated$Icons$enter;
		case 17:
			return $author$project$Generated$Icons$selectArrows;
		case 18:
			return $author$project$Generated$Icons$open;
		case 19:
			return $author$project$Generated$Icons$openInFull;
		case 20:
			return $author$project$Generated$Icons$kebabMenu;
		case 21:
			return $author$project$Generated$Icons$launch;
		case 22:
			return $author$project$Generated$Icons$lock;
		case 23:
			return $author$project$Generated$Icons$paymentMethods;
		case 24:
			return $author$project$Generated$Icons$employees;
		case 25:
			return $author$project$Generated$Icons$employeeUploads;
		case 26:
			return $author$project$Generated$Icons$invoices;
		case 27:
			return $author$project$Generated$Icons$onlineSignup;
		case 28:
			return $author$project$Generated$Icons$accountPricing;
		case 29:
			return $author$project$Generated$Icons$burgerMenu;
		case 30:
			return $author$project$Generated$Icons$burgerMenuClose;
		case 31:
			return $author$project$Generated$Icons$hint404;
		case 32:
			return $author$project$Generated$Icons$hintHeart;
		case 33:
			return $author$project$Generated$Icons$hintHeartFlat;
		case 34:
			return $author$project$Generated$Icons$sort;
		case 35:
			return $author$project$Generated$Icons$sortDown;
		case 36:
			return $author$project$Generated$Icons$sortUp;
		case 37:
			return $author$project$Generated$Icons$send;
		case 38:
			return $author$project$Generated$Icons$add;
		case 39:
			return $author$project$Generated$Icons$edit;
		case 40:
			return $author$project$Generated$Icons$editOutline;
		case 41:
			return $author$project$Generated$Icons$search;
		case 42:
			return $author$project$Generated$Icons$delete;
		case 43:
			return $author$project$Generated$Icons$deleteOutline;
		case 44:
			return $author$project$Generated$Icons$flag;
		case 45:
			return $author$project$Generated$Icons$flagFilled;
		case 46:
			return $author$project$Generated$Icons$repeat;
		case 47:
			return $author$project$Generated$Icons$check;
		case 48:
			return $author$project$Generated$Icons$circle;
		case 50:
			return $author$project$Generated$Icons$cross;
		case 51:
			return $author$project$Generated$Icons$transfer;
		case 57:
			return $author$project$Generated$Icons$history;
		case 49:
			return $author$project$Generated$Icons$bolt;
		case 52:
			return $author$project$Generated$Icons$upload;
		case 54:
			return $author$project$Generated$Icons$visibility;
		case 55:
			return $author$project$Generated$Icons$visibilityOff;
		case 53:
			return $author$project$Generated$Icons$export;
		case 56:
			return $author$project$Generated$Icons$dollar;
		case 58:
			return $author$project$Generated$Icons$void;
		case 59:
			return $author$project$Generated$Icons$calendar;
		case 60:
			return $author$project$Generated$Icons$cart;
		case 61:
			return $author$project$Generated$Icons$stop;
		case 62:
			return $author$project$Generated$Icons$dots;
		case 63:
			return $author$project$Generated$Icons$dragIndicator;
		case 64:
			return $author$project$Generated$Icons$arrowRight;
		case 66:
			return $author$project$Generated$Icons$arrowRightBottom;
		case 65:
			return $author$project$Generated$Icons$arrowLeft;
		case 67:
			return $author$project$Generated$Icons$warning;
		case 5:
			return $author$project$Generated$Icons$alert;
		case 68:
			return $author$project$Generated$Icons$crossCircle;
		case 69:
			return $author$project$Generated$Icons$translate;
		case 71:
			return $author$project$Generated$Icons$trendingDown;
		case 70:
			return $author$project$Generated$Icons$trendingUp;
		case 72:
			return $author$project$Generated$Icons$scissors;
		case 73:
			return $author$project$Generated$Icons$star;
		case 74:
			return $author$project$Generated$Icons$starNote;
		case 75:
			return $author$project$Generated$Icons$minus;
		case 76:
			return $author$project$Generated$Icons$testConnection;
		case 77:
			return $author$project$Generated$Icons$dashboard;
		case 79:
			return $author$project$Generated$Icons$inbox;
		case 80:
			return $author$project$Generated$Icons$contact;
		case 81:
			return $author$project$Generated$Icons$form;
		case 82:
			return $author$project$Generated$Icons$inventory;
		case 83:
			return $author$project$Generated$Icons$decrease;
		case 84:
			return $author$project$Generated$Icons$increase;
		case 85:
			return $author$project$Generated$Icons$task;
		case 86:
			return $author$project$Generated$Icons$apiKey;
		case 87:
			return $author$project$Generated$Icons$webhook;
		case 88:
			return $author$project$Generated$Icons$practices;
		case 90:
			return $author$project$Generated$Icons$gift;
		case 91:
			return $author$project$Generated$Icons$groups;
		case 92:
			return $author$project$Generated$Icons$sandbox;
		case 93:
			return $author$project$Generated$Icons$package;
		case 94:
			return $author$project$Generated$Icons$call;
		case 95:
			return $author$project$Generated$Icons$mail;
		case 89:
			return $author$project$Generated$Icons$progressActivity;
		case 96:
			return $author$project$Generated$Icons$marketplace;
		case 97:
			return $author$project$Generated$Icons$book;
		case 98:
			return $author$project$Generated$Icons$bookmark;
		case 99:
			return $author$project$Generated$Icons$bookmarkFilled;
		case 100:
			return $author$project$Generated$Icons$bookmarkNav;
		case 101:
			return $author$project$Generated$Icons$demography;
		case 102:
			return $author$project$Generated$Icons$dev;
		case 103:
			return $author$project$Generated$Icons$quote;
		case 78:
			return $author$project$Generated$Icons$wrench;
		case 104:
			return $author$project$Generated$Icons$link;
		case 105:
			return $author$project$Generated$Icons$eraser;
		case 106:
			return $author$project$Generated$Icons$hourglass;
		case 107:
			return $author$project$Generated$Icons$phone;
		case 108:
			return $author$project$Generated$Icons$envelope;
		case 109:
			return $author$project$Generated$Icons$pin;
		case 110:
			return $author$project$Generated$Icons$shield;
		case 111:
			return $author$project$Generated$Icons$chatbox;
		case 112:
			return $author$project$Generated$Icons$moreVert;
		case 113:
			return $author$project$Generated$Icons$wandStars;
		case 114:
			return $author$project$Generated$Icons$bank;
		default:
			return $author$project$Generated$Icons$card;
	}
};
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $elm$svg$Svg$Attributes$color = _VirtualDom_attribute('color');
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $elm$core$String$fromFloat = _String_fromNumber;
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $elm$svg$Svg$Attributes$transform = _VirtualDom_attribute('transform');
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $author$project$Ui$Icon$optionToAttr = function (option) {
	switch (option.$) {
		case 0:
			var string = option.a;
			return _List_fromArray(
				[
					$elm$svg$Svg$Attributes$color(string)
				]);
		case 1:
			var string = option.a;
			return _List_fromArray(
				[
					$elm$svg$Svg$Attributes$class(string)
				]);
		case 2:
			var string = option.a;
			return _List_fromArray(
				[
					$elm$svg$Svg$Attributes$fill(string)
				]);
		case 3:
			var string = option.a;
			return _List_fromArray(
				[
					$elm$svg$Svg$Attributes$width(string)
				]);
		case 4:
			var string = option.a;
			return _List_fromArray(
				[
					$elm$svg$Svg$Attributes$height(string)
				]);
		case 5:
			var degrees = option.a;
			return _List_fromArray(
				[
					$elm$svg$Svg$Attributes$transform(
					'rotate(' + ($elm$core$String$fromFloat(degrees) + ')'))
				]);
		default:
			var string = option.a;
			return _List_fromArray(
				[
					$elm$svg$Svg$Attributes$class(string)
				]);
	}
};
var $author$project$Ui$Icon$view = F2(
	function (options, name) {
		var optionAttrs = A2($elm$core$List$concatMap, $author$project$Ui$Icon$optionToAttr, options);
		return A2($author$project$Ui$Icon$generatedFun, name, optionAttrs);
	});
var $author$project$Ui$Icon$viewIcon = F2(
	function (name, iconOptions) {
		return A2(
			$author$project$Ui$Icon$view,
			$author$project$Ui$Icon$iconOptionsToSvgOptions(iconOptions),
			name);
	});
var $author$project$Ui$Icon$cross = $author$project$Ui$Icon$viewIcon(50);
var $author$project$Ui$Button$Default = 0;
var $author$project$Ui$Button$Md = 1;
var $author$project$Ui$Button$defaultOptions = {xr: _List_Nil, ep: false, HT: false, ahO: $elm$core$Maybe$Nothing, z6: false, sB: _List_Nil, V8: false, IS: $elm$core$Maybe$Nothing, B0: $elm$core$Maybe$Nothing, aly: 1, JZ: 0, u1: 0, amg: 'button'};
var $author$project$Ui$Icon$Lg = 3;
var $author$project$Ui$Icon$Size = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Icon$lg = $author$project$Ui$Icon$Size(3);
var $author$project$Ui$Icon$Sm = 1;
var $author$project$Ui$Icon$sm = $author$project$Ui$Icon$Size(1);
var $author$project$Ui$Button$sizeToIconSize = function (size_) {
	switch (size_) {
		case 0:
			return _List_fromArray(
				[$author$project$Ui$Icon$sm]);
		case 1:
			return _List_Nil;
		default:
			return _List_fromArray(
				[$author$project$Ui$Icon$lg]);
	}
};
var $author$project$Ui$Button$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var stylingType = option.a;
						return _Utils_update(
							record,
							{JZ: stylingType});
					case 8:
						var size_ = option.a;
						return _Utils_update(
							record,
							{
								sB: _Utils_ap(
									$author$project$Ui$Button$sizeToIconSize(size_),
									record.sB),
								aly: size_
							});
					case 1:
						var bool = option.a;
						return _Utils_update(
							record,
							{ep: bool});
					case 3:
						return _Utils_update(
							record,
							{amg: 'submit'});
					case 10:
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Close'),
									record.xr),
								ahO: $elm$core$Maybe$Just($author$project$Ui$Icon$cross),
								JZ: 12
							});
					case 6:
						var bool = option.a;
						return _Utils_update(
							record,
							{V8: bool});
					case 4:
						var msg = option.a;
						return _Utils_update(
							record,
							{
								IS: $elm$core$Maybe$Just(msg)
							});
					case 5:
						var ids = option.a;
						var msg = option.b;
						return _Utils_update(
							record,
							{
								B0: $elm$core$Maybe$Just(
									_Utils_Tuple2(ids, msg))
							});
					case 7:
						var bool = option.a;
						return _Utils_update(
							record,
							{HT: bool});
					case 2:
						var list = option.a;
						return _Utils_update(
							record,
							{
								xr: _Utils_ap(record.xr, list)
							});
					case 9:
						var bool = option.a;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('button--primary', bool)
											])),
									record.xr)
							});
					case 11:
						var alignment = option.a;
						return _Utils_update(
							record,
							{
								xr: _Utils_ap(
									$author$project$Ui$Alignment$toAttrs(alignment),
									record.xr)
							});
					case 12:
						var string = option.a;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$author$project$Utils$Html$Attributes$test(string),
									record.xr)
							});
					case 13:
						var iconFunc = option.a;
						return _Utils_update(
							record,
							{
								ahO: $elm$core$Maybe$Just(iconFunc)
							});
					case 14:
						return _Utils_update(
							record,
							{z6: true});
					case 15:
						var label = option.a;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									A2($elm$html$Html$Attributes$attribute, 'aria-label', label),
									record.xr)
							});
					case 17:
						var index = option.a;
						return _Utils_update(
							record,
							{u1: index});
					default:
						var display_ = option.a;
						var screenSize = option.b;
						return display_ ? _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class(
										$author$project$Ui$ScreenSize$toClassPrefix(screenSize) + 'inline-flex'),
									record.xr)
							}) : _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class(
										$author$project$Ui$ScreenSize$toClassPrefix(screenSize) + 'hidden'),
									record.xr)
							});
				}
			}),
		$author$project$Ui$Button$defaultOptions,
		options);
};
var $author$project$Ui$Icon$ProgressActivity = 89;
var $author$project$Ui$Icon$progressActivity = $author$project$Ui$Icon$viewIcon(89);
var $author$project$Ui$Button$sizeClass = function (size_) {
	return $elm$html$Html$Attributes$class(
		function () {
			switch (size_) {
				case 0:
					return 'button--sm';
				case 1:
					return '';
				default:
					return 'button--lg';
			}
		}());
};
var $elm$html$Html$span = _VirtualDom_node('span');
var $author$project$Ui$Button$styleClass = function (style) {
	return $elm$html$Html$Attributes$class(
		function () {
			switch (style) {
				case 0:
					return 'button--default';
				case 1:
					return 'button--primary';
				case 2:
					return 'button--secondary';
				case 3:
					return 'button--success';
				case 4:
					return 'button--warning';
				case 5:
					return 'button--warning-inverse';
				case 6:
					return 'button--danger';
				case 8:
					return 'button--link';
				case 7:
					return 'button--outline';
				case 9:
					return 'button--link button--link-gray';
				case 10:
					return 'button--with-bg-image';
				case 11:
					return 'button--badge';
				case 12:
					return 'button--plain';
				default:
					return 'button--ghost';
			}
		}());
};
var $elm$html$Html$Attributes$tabindex = function (n) {
	return A2(
		_VirtualDom_attribute,
		'tabIndex',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $author$project$Ui$Button$view = F3(
	function (_v0, options, content) {
		var ariaLabel = _v0.mm;
		var optionsRecord = $author$project$Ui$Button$optionsToRecord(
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Button$AriaLabel(ariaLabel),
				options));
		var attributes = $elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						$elm$html$Html$Attributes$class('button'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('button--loading', optionsRecord.V8),
								_Utils_Tuple2('w-full justify-center', optionsRecord.HT),
								_Utils_Tuple2('button--icon-only', optionsRecord.z6)
							])),
						$author$project$Ui$Button$styleClass(optionsRecord.JZ),
						$author$project$Ui$Button$sizeClass(optionsRecord.aly),
						$elm$html$Html$Attributes$disabled(optionsRecord.ep || optionsRecord.V8),
						(!(!optionsRecord.u1)) ? $elm$html$Html$Attributes$tabindex(optionsRecord.u1) : $elm$html$Html$Attributes$class('')
					]),
					A2(
					$elm$core$List$map,
					$elm$html$Html$Attributes$map($elm$core$Basics$never),
					optionsRecord.xr),
					function () {
					var _v1 = _Utils_Tuple2(optionsRecord.ep, optionsRecord.IS);
					if ((!_v1.a) && (!_v1.b.$)) {
						var msg = _v1.b.a;
						return _List_fromArray(
							[
								$elm$html$Html$Events$onClick(msg)
							]);
					} else {
						return _List_Nil;
					}
				}(),
					_List_fromArray(
					[
						$elm$html$Html$Attributes$type_(optionsRecord.amg)
					]),
					function () {
					var _v2 = optionsRecord.B0;
					if (_v2.$ === 1) {
						return _List_Nil;
					} else {
						var _v3 = _v2.a;
						var id = _v3.a;
						var msg = _v3.b;
						return _List_fromArray(
							[
								A2($author$project$Utils$Dom$onOutsideBlur, msg, id)
							]);
					}
				}()
				]));
		return A2(
			$elm$html$Html$button,
			attributes,
			A2(
				$elm$core$List$cons,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$html$Html$text(''),
					A2(
						$elm$core$Maybe$map,
						function (icon_) {
							return icon_(optionsRecord.sB);
						},
						optionsRecord.ahO)),
				_Utils_ap(
					$elm$core$List$isEmpty(content) ? _List_Nil : _List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button__content')
								]),
							content)
						]),
					optionsRecord.V8 ? _List_fromArray(
						[
							$author$project$Ui$Icon$progressActivity(_List_Nil)
						]) : _List_Nil)));
	});
var $elm$html$Html$a = _VirtualDom_node('a');
var $elm$html$Html$div = _VirtualDom_node('div');
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $author$project$Ui$Card$optionsToRecord = A2(
	$elm$core$List$foldl,
	F2(
		function (option, acc) {
			switch (option.$) {
				case 0:
					var bool = option.a;
					return _Utils_update(
						acc,
						{zX: bool});
				case 3:
					var bool = option.a;
					return _Utils_update(
						acc,
						{Bp: bool});
				case 1:
					var href = option.a;
					return _Utils_update(
						acc,
						{
							Ir: $elm$core$Maybe$Just(href)
						});
				default:
					var bool = option.a;
					return _Utils_update(
						acc,
						{ep: bool});
			}
		}),
	{ep: false, zX: false, Ir: $elm$core$Maybe$Nothing, Bp: false});
var $author$project$Ui$Card$view = F2(
	function (options, content) {
		var optionsRecord = $author$project$Ui$Card$optionsToRecord(options);
		var node = A2(
			$elm$core$Maybe$withDefault,
			$elm$html$Html$div,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$always($elm$html$Html$a),
				optionsRecord.Ir));
		return A2(
			node,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('card'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('card--highlighted', optionsRecord.zX),
							_Utils_Tuple2(
							'card--clickable',
							A2(
								$elm$core$Maybe$withDefault,
								false,
								A2(
									$elm$core$Maybe$map,
									$elm$core$Basics$always(true),
									optionsRecord.Ir))),
							_Utils_Tuple2('card--muted', optionsRecord.Bp),
							_Utils_Tuple2('disabled', optionsRecord.ep)
						])),
					A2(
					$elm$core$Maybe$withDefault,
					$elm$html$Html$Attributes$class(''),
					A2($elm$core$Maybe$map, $elm$html$Html$Attributes$href, optionsRecord.Ir))
				]),
			content);
	});
var $author$project$Ui$Element$view = $author$project$Ui$Element$custom('');
var $author$project$Components$ProviderCredentials$AddDea = {$: 7};
var $author$project$Components$ProviderCredentials$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Typography$Color = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Typography$Danger = 5;
var $author$project$Ui$Typography$danger = $author$project$Ui$Typography$Color(5);
var $author$project$Utils$Html$empty = $elm$html$Html$text('');
var $author$project$Utils$Form$errorBelongsToGroup = F2(
	function (currentValidationGroup, _v0) {
		var validationGroup = _v0.a;
		var error = _v0.b;
		return _Utils_eq(currentValidationGroup, validationGroup) ? $elm$core$Maybe$Just(error) : $elm$core$Maybe$Nothing;
	});
var $author$project$Utils$Form$validationErrors = F2(
	function (validationGroup, _v0) {
		var errors_ = _v0.d;
		return A2(
			$elm$core$List$filterMap,
			$author$project$Utils$Form$errorBelongsToGroup(validationGroup),
			errors_);
	});
var $author$project$Utils$Form$hasValidationErrors = F2(
	function (validationGroup, form) {
		return !$elm$core$List$isEmpty(
			A2($author$project$Utils$Form$validationErrors, validationGroup, form));
	});
var $author$project$Ui$Form$Group$InputGrid = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Form$Group$spanToWidthClass = function (span) {
	return (span === 12) ? 'w-full' : ('w-' + ($elm$core$String$fromInt(span) + '/12'));
};
var $author$project$Ui$Form$Group$inputSpanSm = function (span) {
	return $author$project$Ui$Form$Group$InputGrid(
		_List_fromArray(
			[
				'sm:' + $author$project$Ui$Form$Group$spanToWidthClass(span)
			]));
};
var $author$project$Ui$Form$Group$Invalid = function (a) {
	return {$: 6, a: a};
};
var $author$project$Ui$Form$Group$invalid = $author$project$Ui$Form$Group$Invalid;
var $author$project$Ui$Form$Group$Label = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$Group$Plain = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$Group$label = A2($elm$core$Basics$composeR, $author$project$Ui$Form$Group$Plain, $author$project$Ui$Form$Group$Label);
var $author$project$Ui$Form$Group$LabelGrid = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Form$Group$labelSpanSm = function (span) {
	return $author$project$Ui$Form$Group$LabelGrid(
		_List_fromArray(
			[
				'sm:' + $author$project$Ui$Form$Group$spanToWidthClass(span)
			]));
};
var $author$project$Ui$Button$Link = 8;
var $author$project$Ui$Button$styled = $author$project$Ui$Button$Styled;
var $author$project$Ui$Button$link = $author$project$Ui$Button$styled(8);
var $author$project$Ui$Element$mt2 = $author$project$Ui$Element$Margin('mt-2');
var $elm$html$Html$fieldset = _VirtualDom_node('fieldset');
var $author$project$Ui$Form$Group$defaultOptions = {xr: _List_Nil, ahO: $elm$core$Maybe$Nothing, nZ: _List_Nil, aih: $elm$core$Maybe$Nothing, Av: 'control-label', of: _List_Nil, Aw: $elm$core$Maybe$Nothing, og: false, akR: false};
var $author$project$Ui$Form$Group$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var lab = option.a;
						return _Utils_update(
							record,
							{
								aih: $elm$core$Maybe$Just(lab)
							});
					case 1:
						var bool = option.a;
						return _Utils_update(
							record,
							{akR: bool});
					case 2:
						var list = option.a;
						return _Utils_update(
							record,
							{
								of: _Utils_ap(record.of, list)
							});
					case 3:
						var list = option.a;
						return _Utils_update(
							record,
							{
								nZ: _Utils_ap(record.nZ, list)
							});
					case 4:
						var list = option.a;
						return _Utils_update(
							record,
							{
								Aw: $elm$core$Maybe$Just(list)
							});
					case 5:
						var list = option.a;
						return _Utils_update(
							record,
							{Av: list});
					case 6:
						var bool = option.a;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('form-group--error', bool)
											])),
									record.xr)
							});
					case 7:
						return _Utils_update(
							record,
							{og: true});
					case 8:
						var string = option.a;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$author$project$Utils$Html$Attributes$test(string),
									record.xr)
							});
					case 9:
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class('form-group--label-above'),
									record.xr)
							});
					default:
						var icon_ = option.a;
						return _Utils_update(
							record,
							{
								ahO: $elm$core$Maybe$Just(icon_)
							});
				}
			}),
		$author$project$Ui$Form$Group$defaultOptions,
		options);
};
var $author$project$Ui$Typography$Attr = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Typography$attrs = function (attributes) {
	return $author$project$Ui$Typography$Attr(attributes);
};
var $elm$html$Html$label = _VirtualDom_node('label');
var $author$project$Ui$Typography$label = F2(
	function (options, content) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$never,
			A2(
				$elm$html$Html$label,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('text-label-md'),
					$author$project$Ui$Typography$optionsToAttributes(options)),
				content));
	});
var $author$project$Utils$String$noBreakSpace = $elm$core$String$fromChar('\u00A0');
var $author$project$Utils$Html$noBreakSpace = $elm$html$Html$text($author$project$Utils$String$noBreakSpace);
var $author$project$Api$Phi$phiSafe = function (content) {
	return A2($elm$html$Html$span, $author$project$Api$Phi$displayAttr, content);
};
var $author$project$Api$Phi$text = function (_v0) {
	var string = _v0;
	return $author$project$Api$Phi$phiSafe(
		_List_fromArray(
			[
				$elm$html$Html$text(string)
			]));
};
var $author$project$Ui$Form$Group$viewLabel = function (options) {
	var _v0 = options.aih;
	if (!_v0.$) {
		var label_ = _v0.a;
		var labelHtml_ = function () {
			switch (label_.$) {
				case 0:
					var html = label_.a;
					return A2(
						$elm$core$List$map,
						$elm$html$Html$map($elm$core$Basics$never),
						html);
				case 1:
					var lab = label_.a;
					return _List_fromArray(
						[
							$elm$html$Html$text(lab)
						]);
				default:
					var lab = label_.a;
					return _List_fromArray(
						[
							$author$project$Api$Phi$text(lab)
						]);
			}
		}();
		var iconHtml = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (icon_) {
					return _List_fromArray(
						[icon_]);
				},
				options.ahO));
		return A2(
			$author$project$Ui$Typography$label,
			_List_fromArray(
				[
					$author$project$Ui$Typography$attrs(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(options.Av),
							$elm$html$Html$Attributes$class(
							A2($elm$core$String$join, ' ', options.of)),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('label-required', options.akR)
								]))
						]))
				]),
			_Utils_ap(
				iconHtml,
				_Utils_ap(
					labelHtml_,
					_List_fromArray(
						[
							options.akR ? A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('form-group__required')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('*')
								])) : $elm$html$Html$text(''),
							A2(
							$elm$core$Maybe$withDefault,
							$elm$html$Html$text(''),
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$List$singleton,
									$elm$html$Html$div(
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('form-group__help')
											]))),
								options.Aw)),
							options.og ? $author$project$Utils$Html$noBreakSpace : $author$project$Utils$Html$empty
						]))));
	} else {
		return $elm$html$Html$text('');
	}
};
var $elm$html$Html$legend = _VirtualDom_node('legend');
var $author$project$Ui$Form$Group$viewLegend = function (options) {
	var _v0 = options.aih;
	if ((!_v0.$) && (_v0.a.$ === 1)) {
		var label_ = _v0.a.a;
		return A2(
			$elm$html$Html$legend,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('sr-only')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label_)
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Ui$Form$Group$view = F2(
	function (options, content) {
		var optionsRecord = $author$project$Ui$Form$Group$optionsToRecord(options);
		return A2(
			$elm$html$Html$fieldset,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('form-group'),
				A2(
					$elm$core$List$map,
					$elm$html$Html$Attributes$map($elm$core$Basics$never),
					optionsRecord.xr)),
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$viewLegend(optionsRecord),
					(!optionsRecord.og) ? $author$project$Ui$Form$Group$viewLabel(optionsRecord) : $author$project$Utils$Html$empty,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-group__content'),
							$elm$html$Html$Attributes$class(
							A2($elm$core$String$join, ' ', optionsRecord.nZ))
						]),
					A2(
						$elm$core$List$cons,
						optionsRecord.og ? $author$project$Ui$Form$Group$viewLabel(optionsRecord) : $author$project$Utils$Html$empty,
						content))
				]));
	});
var $author$project$Components$ProviderCredentials$DeaNumberAt = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$ProviderCredentials$DeaStateAt = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$ProviderCredentials$DeaStateSearchAt = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Components$ProviderCredentials$RemoveDea = function (a) {
	return {$: 8, a: a};
};
var $author$project$Utils$State$list = _List_fromArray(
	[
		_Utils_Tuple2('AL', 'Alabama'),
		_Utils_Tuple2('AK', 'Alaska'),
		_Utils_Tuple2('AZ', 'Arizona'),
		_Utils_Tuple2('AR', 'Arkansas'),
		_Utils_Tuple2('CA', 'California'),
		_Utils_Tuple2('CO', 'Colorado'),
		_Utils_Tuple2('CT', 'Connecticut'),
		_Utils_Tuple2('DE', 'Delaware'),
		_Utils_Tuple2('DC', 'District of Columbia'),
		_Utils_Tuple2('FL', 'Florida'),
		_Utils_Tuple2('GA', 'Georgia'),
		_Utils_Tuple2('HI', 'Hawaii'),
		_Utils_Tuple2('ID', 'Idaho'),
		_Utils_Tuple2('IL', 'Illinois'),
		_Utils_Tuple2('IN', 'Indiana'),
		_Utils_Tuple2('IA', 'Iowa'),
		_Utils_Tuple2('KS', 'Kansas'),
		_Utils_Tuple2('KY', 'Kentucky'),
		_Utils_Tuple2('LA', 'Louisiana'),
		_Utils_Tuple2('ME', 'Maine'),
		_Utils_Tuple2('MD', 'Maryland'),
		_Utils_Tuple2('MA', 'Massachusetts'),
		_Utils_Tuple2('MI', 'Michigan'),
		_Utils_Tuple2('MN', 'Minnesota'),
		_Utils_Tuple2('MS', 'Mississippi'),
		_Utils_Tuple2('MO', 'Missouri'),
		_Utils_Tuple2('MT', 'Montana'),
		_Utils_Tuple2('NE', 'Nebraska'),
		_Utils_Tuple2('NV', 'Nevada'),
		_Utils_Tuple2('NH', 'New Hampshire'),
		_Utils_Tuple2('NJ', 'New Jersey'),
		_Utils_Tuple2('NM', 'New Mexico'),
		_Utils_Tuple2('NY', 'New York'),
		_Utils_Tuple2('NC', 'North Carolina'),
		_Utils_Tuple2('ND', 'North Dakota'),
		_Utils_Tuple2('OH', 'Ohio'),
		_Utils_Tuple2('OK', 'Oklahoma'),
		_Utils_Tuple2('OR', 'Oregon'),
		_Utils_Tuple2('PA', 'Pennsylvania'),
		_Utils_Tuple2('PR', 'Puerto Rico'),
		_Utils_Tuple2('RI', 'Rhode Island'),
		_Utils_Tuple2('SC', 'South Carolina'),
		_Utils_Tuple2('SD', 'South Dakota'),
		_Utils_Tuple2('TN', 'Tennessee'),
		_Utils_Tuple2('TX', 'Texas'),
		_Utils_Tuple2('UT', 'Utah'),
		_Utils_Tuple2('VT', 'Vermont'),
		_Utils_Tuple2('VI', 'Virgin Islands'),
		_Utils_Tuple2('VA', 'Virginia'),
		_Utils_Tuple2('WA', 'Washington'),
		_Utils_Tuple2('WV', 'West Virginia'),
		_Utils_Tuple2('WI', 'Wisconsin'),
		_Utils_Tuple2('WY', 'Wyoming')
	]);
var $author$project$Utils$State$codes = A2($elm$core$List$map, $elm$core$Tuple$first, $author$project$Utils$State$list);
var $author$project$Ui$Icon$Delete = 42;
var $author$project$Ui$Icon$delete = $author$project$Ui$Icon$viewIcon(42);
var $author$project$Ui$Element$FlexAuto = {$: 16};
var $author$project$Ui$Element$flexAuto = $author$project$Ui$Element$FlexAuto;
var $author$project$Ui$Button$Icon = function (a) {
	return {$: 13, a: a};
};
var $author$project$Ui$Button$icon = $author$project$Ui$Button$Icon;
var $author$project$Ui$Dropdown$Input = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Dropdown$input = $author$project$Ui$Dropdown$Input;
var $author$project$Ui$Dropdown$Invalid = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Dropdown$invalid = $author$project$Ui$Dropdown$Invalid;
var $author$project$Ui$Form$Input$Invalid = function (a) {
	return {$: 7, a: a};
};
var $author$project$Ui$Form$Input$invalid = $author$project$Ui$Form$Input$Invalid;
var $author$project$Ui$Dropdown$Item = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Ui$Dropdown$item = $author$project$Ui$Dropdown$Item;
var $author$project$Ui$Alignment$FlexCenter = 1;
var $author$project$Ui$Alignment$Items = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Alignment$itemsCenter = $author$project$Ui$Alignment$Items(1);
var $author$project$Ui$Element$itemsCenter = $author$project$Ui$Element$Alignment($author$project$Ui$Alignment$itemsCenter);
var $author$project$Ui$Element$ml1 = $author$project$Ui$Element$Margin('ml-1');
var $author$project$Ui$Element$mr2 = $author$project$Ui$Element$Margin('mr-2');
var $author$project$Ui$Dropdown$Item$OnInput = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Dropdown$onInput = $author$project$Ui$Dropdown$Item$OnInput;
var $author$project$Ui$Form$Input$OnInput = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Form$Input$onInput = $author$project$Ui$Form$Input$OnInput;
var $author$project$Ui$Dropdown$Item$OnSelect = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Dropdown$onSelect = $author$project$Ui$Dropdown$Item$OnSelect;
var $author$project$Ui$Dropdown$Item$Placeholder = function (a) {
	return {$: 8, a: a};
};
var $author$project$Ui$Dropdown$placeholder = $author$project$Ui$Dropdown$Item$Placeholder;
var $author$project$Ui$Form$Input$Placeholder = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$Input$placeholder = $author$project$Ui$Form$Input$Placeholder;
var $author$project$Ui$Dropdown$Item$Selected = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Dropdown$selected = $author$project$Ui$Dropdown$Item$Selected;
var $author$project$Ui$Dropdown$Separator = {$: 1};
var $author$project$Ui$Dropdown$separator = $author$project$Ui$Dropdown$Separator;
var $author$project$Ui$Alignment$Between = 0;
var $author$project$Ui$Alignment$ContentSpacing = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Alignment$spaceBetween = $author$project$Ui$Alignment$ContentSpacing(0);
var $author$project$Ui$Element$spaceBetween = $author$project$Ui$Element$Alignment($author$project$Ui$Alignment$spaceBetween);
var $author$project$Ui$ScreenSize$Sm = 1;
var $author$project$Ui$Grid$spanSm = $author$project$Ui$Grid$Span(1);
var $elm$core$String$toLower = _String_toLower;
var $author$project$Ui$Dropdown$Item$Value = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Dropdown$value = $author$project$Ui$Dropdown$Item$Value;
var $author$project$Ui$Form$Input$Value = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Form$Input$value = $author$project$Ui$Form$Input$Value;
var $elm$html$Html$input = _VirtualDom_node('input');
var $author$project$Ui$Form$Input$inputTypeToAttributes = function (type_) {
	switch (type_.$) {
		case 0:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$type_('tel')
				]);
		case 1:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$type_('text')
				]);
		case 2:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$type_('text'),
					A2($elm$html$Html$Attributes$attribute, 'inputmode', 'decimal')
				]);
		case 3:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$type_('url')
				]);
		case 4:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$type_('email')
				]);
		case 5:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$type_('password')
				]);
		default:
			var otherType = type_.a;
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$type_(otherType)
				]);
	}
};
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $author$project$Ui$Form$Input$onNumberInput = F2(
	function (prevValue, tagger) {
		return A2(
			$elm$html$Html$Events$on,
			'input',
			A2(
				$elm$json$Json$Decode$map,
				function (val) {
					var _v0 = _Utils_Tuple2(
						val,
						$elm$core$String$toFloat(val));
					switch (_v0.a) {
						case '':
							return tagger(val);
						case '-':
							return tagger(val);
						default:
							if (!_v0.b.$) {
								return tagger(val);
							} else {
								return tagger(prevValue);
							}
					}
				},
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['target', 'value']),
					$elm$json$Json$Decode$string)));
	});
var $author$project$Ui$Form$Input$optionsToInputHandler = function (optionsRecord) {
	var _v0 = _Utils_Tuple2(optionsRecord.ajm, optionsRecord.amg);
	if (_v0.a.$ === 1) {
		var _v1 = _v0.a;
		return _List_Nil;
	} else {
		if (_v0.b.$ === 2) {
			var handler = _v0.a.a;
			var _v2 = _v0.b;
			return _List_fromArray(
				[
					A2($author$project$Ui$Form$Input$onNumberInput, optionsRecord.aee, handler)
				]);
		} else {
			var handler = _v0.a.a;
			return _List_fromArray(
				[
					$elm$html$Html$Events$onInput(handler)
				]);
		}
	}
};
var $elm$html$Html$Attributes$autocomplete = function (bool) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'autocomplete',
		bool ? 'on' : 'off');
};
var $elm$html$Html$Attributes$autofocus = $elm$html$Html$Attributes$boolProperty('autofocus');
var $author$project$Ui$Form$Input$Text = {$: 1};
var $author$project$Ui$Form$Input$defaultOptions = {xr: _List_Nil, agX: _List_Nil, zO: false, zT: false, sM: false, ajm: $elm$core$Maybe$Nothing, amg: $author$project$Ui$Form$Input$Text, aee: '', Gc: _List_Nil, vt: _List_Nil};
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $author$project$Api$Phi$inputAttr = _List_fromArray(
	[
		$author$project$Api$Phi$maskElement,
		A2($elm$html$Html$Attributes$attribute, 'data-recording-ignore', 'mask')
	]);
var $agustinrhcp$elm_mask$Mask$maskRec = F2(
	function (input, pattern) {
		var _v0 = _Utils_Tuple2(input, pattern);
		if (!_v0.b.b) {
			return '';
		} else {
			if (_v0.a.b) {
				var _v1 = _v0.a;
				var _char = _v1.a;
				var remainingChar = _v1.b;
				var _v2 = _v0.b;
				var token = _v2.a;
				var remainingTokens = _v2.b;
				switch (token.$) {
					case 2:
						return A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$map,
								function (_int) {
									return _Utils_ap(
										$elm$core$String$fromInt(_int),
										A2($agustinrhcp$elm_mask$Mask$maskRec, remainingChar, remainingTokens));
								},
								$elm$core$String$toInt(
									$elm$core$String$fromChar(_char))));
					case 1:
						return _Utils_ap(
							$elm$core$String$fromChar(_char),
							A2($agustinrhcp$elm_mask$Mask$maskRec, remainingChar, remainingTokens));
					default:
						var a = token.a;
						return _Utils_ap(
							$elm$core$String$fromChar(a),
							A2($agustinrhcp$elm_mask$Mask$maskRec, input, remainingTokens));
				}
			} else {
				var _v4 = _v0.b;
				var token = _v4.a;
				var remainingTokens = _v4.b;
				if (!token.$) {
					var symbol = token.a;
					return _Utils_ap(
						$elm$core$String$fromChar(symbol),
						A2($agustinrhcp$elm_mask$Mask$maskRec, input, remainingTokens));
				} else {
					return '';
				}
			}
		}
	});
var $agustinrhcp$elm_mask$Mask$mask = F2(
	function (_v0, stringInput) {
		var pattern = _v0;
		return $elm$core$String$isEmpty(stringInput) ? '' : A2(
			$agustinrhcp$elm_mask$Mask$maskRec,
			$elm$core$String$toList(stringInput),
			pattern);
	});
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $agustinrhcp$elm_mask$Mask$maskedValue = F2(
	function (pattern, val) {
		return $elm$core$String$isEmpty(val) ? $elm$html$Html$Attributes$value('') : $elm$html$Html$Attributes$value(
			A2($agustinrhcp$elm_mask$Mask$mask, pattern, val));
	});
var $elm$html$Html$Attributes$maxlength = function (n) {
	return A2(
		_VirtualDom_attribute,
		'maxlength',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$Events$onBlur = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'blur',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$keyCode = A2($elm$json$Json$Decode$field, 'keyCode', $elm$json$Json$Decode$int);
var $author$project$Utils$Dom$onKeyDown = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'keydown',
		A2($elm$json$Json$Decode$map, msg, $elm$html$Html$Events$keyCode));
};
var $elm$core$String$dropRight = F2(
	function (n, string) {
		return (n < 1) ? string : A3($elm$core$String$slice, 0, -n, string);
	});
var $agustinrhcp$elm_mask$Mask$unMaskRec = F2(
	function (input, pattern) {
		unMaskRec:
		while (true) {
			var _v0 = _Utils_Tuple2(input, pattern);
			_v0$1:
			while (true) {
				if (_v0.a.b) {
					if (_v0.b.b) {
						var _v1 = _v0.a;
						var _char = _v1.a;
						var remainingChar = _v1.b;
						var _v2 = _v0.b;
						var token = _v2.a;
						var remainingTokens = _v2.b;
						switch (token.$) {
							case 2:
								return A2(
									$elm$core$Maybe$withDefault,
									'',
									A2(
										$elm$core$Maybe$map,
										function (_int) {
											return _Utils_ap(
												$elm$core$String$fromInt(_int),
												A2($agustinrhcp$elm_mask$Mask$unMaskRec, remainingChar, remainingTokens));
										},
										$elm$core$String$toInt(
											$elm$core$String$fromChar(_char))));
							case 1:
								return _Utils_ap(
									$elm$core$String$fromChar(_char),
									A2($agustinrhcp$elm_mask$Mask$unMaskRec, remainingChar, remainingTokens));
							default:
								var symbol = token.a;
								if (_Utils_eq(symbol, _char)) {
									var $temp$input = remainingChar,
										$temp$pattern = remainingTokens;
									input = $temp$input;
									pattern = $temp$pattern;
									continue unMaskRec;
								} else {
									return '';
								}
						}
					} else {
						break _v0$1;
					}
				} else {
					if (!_v0.b.b) {
						break _v0$1;
					} else {
						return '';
					}
				}
			}
			return '';
		}
	});
var $agustinrhcp$elm_mask$Mask$unMask = F2(
	function (_v0, string) {
		var pattern = _v0;
		return $elm$core$String$isEmpty(string) ? '' : A2(
			$agustinrhcp$elm_mask$Mask$unMaskRec,
			$elm$core$String$toList(string),
			pattern);
	});
var $agustinrhcp$elm_mask$Mask$isMasked = F2(
	function (pattern, text) {
		return _Utils_eq(
			text,
			A2(
				$agustinrhcp$elm_mask$Mask$mask,
				pattern,
				A2($agustinrhcp$elm_mask$Mask$unMask, pattern, text)));
	});
var $agustinrhcp$elm_mask$Mask$unMaskValue = F3(
	function (pattern, currentValue, maskedNewValue) {
		if ($elm$core$String$isEmpty(maskedNewValue)) {
			return '';
		} else {
			if ($elm$core$String$isEmpty(currentValue)) {
				return A2($agustinrhcp$elm_mask$Mask$isMasked, pattern, maskedNewValue) ? A2($agustinrhcp$elm_mask$Mask$unMask, pattern, maskedNewValue) : A2(
					$agustinrhcp$elm_mask$Mask$unMask,
					pattern,
					A2($agustinrhcp$elm_mask$Mask$mask, pattern, maskedNewValue));
			} else {
				if (_Utils_cmp(
					A2($agustinrhcp$elm_mask$Mask$mask, pattern, currentValue),
					maskedNewValue) > 0) {
					var unmaskedNewValue = A2($agustinrhcp$elm_mask$Mask$unMask, pattern, maskedNewValue);
					return (_Utils_cmp(currentValue, unmaskedNewValue) > 0) ? unmaskedNewValue : A2($elm$core$String$dropRight, 1, currentValue);
				} else {
					return A2($agustinrhcp$elm_mask$Mask$unMask, pattern, maskedNewValue);
				}
			}
		}
	});
var $agustinrhcp$elm_mask$Mask$onMaskedInput = F3(
	function (pattern, currentValue, msg) {
		return $elm$html$Html$Events$onInput(
			A2(
				$elm$core$Basics$composeR,
				A2($agustinrhcp$elm_mask$Mask$unMaskValue, pattern, currentValue),
				msg));
	});
var $author$project$Ui$Form$Input$onOff = function (bool) {
	return bool ? 'on' : 'off';
};
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $author$project$Ui$Form$Input$trueFalse = function (bool) {
	return bool ? 'true' : 'false';
};
var $author$project$Ui$Form$Input$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var string = option.a;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$id(string),
									record.xr)
							});
					case 1:
						var string = option.a;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$placeholder(string),
									record.xr)
							});
					case 2:
						var handler = option.a;
						return _Utils_update(
							record,
							{
								ajm: $elm$core$Maybe$Just(handler)
							});
					case 3:
						var string = option.a;
						return _Utils_update(
							record,
							{aee: string});
					case 4:
						var bool = option.a;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$disabled(bool),
									record.xr)
							});
					case 5:
						var string = option.a;
						return _Utils_update(
							record,
							{amg: string});
					case 7:
						var bool = option.a;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('form-control--errored', bool)
											])),
									record.xr),
								sM: bool
							});
					case 8:
						var bool = option.a;
						var phiAttrs = bool ? $author$project$Api$Phi$inputAttr : _List_Nil;
						return _Utils_update(
							record,
							{
								xr: _Utils_ap(phiAttrs, record.xr)
							});
					case 9:
						var pattern = option.a;
						var string = option.b;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									A2($agustinrhcp$elm_mask$Mask$maskedValue, pattern, string),
									record.xr)
							});
					case 10:
						var pattern = option.a;
						var lastValue = option.b;
						var handler = option.c;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									A3($agustinrhcp$elm_mask$Mask$onMaskedInput, pattern, lastValue, handler),
									record.xr)
							});
					case 11:
						var handler = option.a;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$elm$html$Html$Events$onBlur(handler),
									record.xr)
							});
					case 12:
						var handler = option.a;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$elm$html$Html$Events$onClick(handler),
									record.xr)
							});
					case 13:
						var handler = option.a;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$author$project$Utils$Dom$onKeyDown(handler),
									record.xr)
							});
					case 14:
						var bool = option.a;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$autocomplete(bool),
									record.xr)
							});
					case 15:
						var bool = option.a;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									A2(
										$elm$html$Html$Attributes$attribute,
										'autocorrect',
										$author$project$Ui$Form$Input$onOff(bool)),
									record.xr)
							});
					case 16:
						var bool = option.a;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									A2(
										$elm$html$Html$Attributes$attribute,
										'autocapitalize',
										$author$project$Ui$Form$Input$onOff(bool)),
									record.xr)
							});
					case 17:
						var bool = option.a;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									A2(
										$elm$html$Html$Attributes$attribute,
										'spellcheck',
										$author$project$Ui$Form$Input$trueFalse(bool)),
									record.xr)
							});
					case 20:
						var bool = option.a;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$autofocus(bool),
									record.xr)
							});
					case 18:
						var bool = option.a;
						return _Utils_update(
							record,
							{
								zO: bool,
								vt: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('form-group--feedback', bool)
											])),
									record.vt)
							});
					case 19:
						var list = option.a;
						return _Utils_update(
							record,
							{agX: list});
					case 21:
						var _int = option.a;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$maxlength(_int),
									record.xr)
							});
					case 6:
						var string = option.a;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$author$project$Utils$Html$Attributes$test(string),
									record.xr)
							});
					case 22:
						var html = option.a;
						return _Utils_update(
							record,
							{Gc: html});
					case 23:
						var attributes = option.a;
						return _Utils_update(
							record,
							{
								xr: A2($elm$core$List$append, record.xr, attributes)
							});
					case 24:
						var labelled = option.a;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									A2($elm$html$Html$Attributes$attribute, 'aria-label', labelled),
									record.xr)
							});
					default:
						var bool = option.a;
						return _Utils_update(
							record,
							{zT: bool});
				}
			}),
		$author$project$Ui$Form$Input$defaultOptions,
		options);
};
var $author$project$Utils$FormErrors$viewError = function (error) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('text-danger')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(error)
			]));
};
var $author$project$Utils$FormErrors$view = function (errorList) {
	return $elm$core$List$isEmpty(errorList) ? $author$project$Utils$Html$empty : A2(
		$elm$html$Html$div,
		_List_Nil,
		A2($elm$core$List$map, $author$project$Utils$FormErrors$viewError, errorList));
};
var $author$project$Ui$Form$Input$viewErrors = function (option) {
	if (option.$ === 19) {
		var errors_ = option.a;
		return $author$project$Utils$FormErrors$view(errors_);
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Ui$Icon$Check = 47;
var $author$project$Ui$Icon$check = $author$project$Ui$Icon$viewIcon(47);
var $author$project$Ui$Icon$Danger = 0;
var $author$project$Ui$Icon$IconColor = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Icon$danger = $author$project$Ui$Icon$IconColor(0);
var $author$project$Ui$Icon$Success = 3;
var $author$project$Ui$Icon$success = $author$project$Ui$Icon$IconColor(3);
var $author$project$Ui$Form$Input$viewFeedback = function (options) {
	var _v0 = _Utils_Tuple2(options.zO, options.sM);
	if (_v0.a) {
		if (_v0.b) {
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-control__feedback form-control__feedback--error')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Icon$cross(
						_List_fromArray(
							[$author$project$Ui$Icon$danger]))
					]));
		} else {
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-muted form-control__feedback')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Icon$check(
						_List_fromArray(
							[$author$project$Ui$Icon$success]))
					]));
		}
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Ui$Form$Input$view = function (options) {
	var optionsRecord = $author$project$Ui$Form$Input$optionsToRecord(options);
	var onInputHandler = $author$project$Ui$Form$Input$optionsToInputHandler(optionsRecord);
	var errorDescription = $elm$core$List$isEmpty(optionsRecord.agX) ? _List_Nil : _List_fromArray(
		[
			A2(
			$elm$html$Html$Attributes$attribute,
			'aria-describedby',
			A2($elm$core$String$join, '. ', optionsRecord.agX))
		]);
	return A2(
		$elm$html$Html$div,
		A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$class('input-wrapper'),
			optionsRecord.vt),
		$elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						$author$project$Ui$Form$Input$viewFeedback(optionsRecord),
						A2(
						$elm$html$Html$input,
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class('form-control'),
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$value(optionsRecord.aee),
								_Utils_ap(
									$author$project$Ui$Form$Input$inputTypeToAttributes(optionsRecord.amg),
									_Utils_ap(
										errorDescription,
										_Utils_ap(optionsRecord.xr, onInputHandler))))),
						_List_Nil)
					]),
					optionsRecord.Gc,
					optionsRecord.zT ? _List_Nil : A2($elm$core$List$map, $author$project$Ui$Form$Input$viewErrors, options)
				])));
};
var $author$project$Components$DateInput$Above = 1;
var $author$project$Components$DateInput$Position = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$DateInput$above = $author$project$Components$DateInput$Position(1);
var $author$project$Components$DateInput$DisabledPickerDates = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$DateInput$disabledPickerDates = $author$project$Components$DateInput$DisabledPickerDates;
var $author$project$Components$DateInput$Invalid = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$DateInput$invalid = $author$project$Components$DateInput$Invalid;
var $author$project$Components$DateInput$Placeholder = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$DateInput$placeholder = $author$project$Components$DateInput$Placeholder;
var $author$project$Components$DateInput$Value = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$DateInput$value = $author$project$Components$DateInput$Value;
var $author$project$Ui$Form$Input$addon = $elm$html$Html$span(
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('input-group__addon')
		]));
var $author$project$Ui$Icon$Calendar = 59;
var $author$project$Ui$Icon$calendar = $author$project$Ui$Icon$viewIcon(59);
var $author$project$Components$DateInput$datePickerSettings = function (optionsRecord) {
	var dataAttributes = function () {
		var _v0 = optionsRecord.y5;
		if (!_v0.$) {
			var dataTest = _v0.a;
			return _List_fromArray(
				[
					$author$project$Utils$Html$Attributes$test(dataTest)
				]);
		} else {
			return _List_Nil;
		}
	}();
	var baseSettings_ = $author$project$Components$DateInput$baseDatePickerSettings;
	var ariaAttributes = A2(
		$elm$core$List$cons,
		optionsRecord.sM ? A2($elm$html$Html$Attributes$attribute, 'aria-invalid', 'true') : A2($elm$html$Html$Attributes$attribute, 'aria-invalid', 'false'),
		$elm$core$List$isEmpty(optionsRecord.agX) ? _List_Nil : _List_fromArray(
			[
				A2(
				$elm$html$Html$Attributes$attribute,
				'aria-describedby',
				A2($elm$core$String$join, '. ', optionsRecord.agX))
			]));
	return _Utils_update(
		baseSettings_,
		{
			T3: A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$disabled(optionsRecord.ep),
				_Utils_ap(
					baseSettings_.T3,
					_Utils_ap(dataAttributes, ariaAttributes))),
			H2: A2(
				$elm$core$List$cons,
				_Utils_Tuple2('disabled', optionsRecord.ep),
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2('form-control--errored', optionsRecord.sM),
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2('elm-datepicker--above', optionsRecord.ZP === 1),
						baseSettings_.H2))),
			aib: optionsRecord.zg,
			aj3: optionsRecord.aj3
		});
};
var $author$project$Ui$Form$Input$group = function (content) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('input-group')
			]),
		content);
};
var $author$project$Components$DateInput$Below = 0;
var $author$project$Components$DateInput$defaultOptions = {
	xr: _List_Nil,
	y5: $elm$core$Maybe$Nothing,
	ep: false,
	zg: $elm$core$Basics$always(false),
	agX: _List_Nil,
	zT: false,
	sM: false,
	aj3: 'Select a Date',
	ZP: 0,
	aee: $elm$core$Maybe$Nothing
};
var $author$project$Components$DateInput$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 1:
						var string = option.a;
						return _Utils_update(
							record,
							{aj3: string});
					case 0:
						var date = option.a;
						return _Utils_update(
							record,
							{aee: date});
					case 2:
						var bool = option.a;
						return _Utils_update(
							record,
							{ep: bool});
					case 3:
						var bool = option.a;
						return _Utils_update(
							record,
							{sM: bool});
					case 4:
						var list = option.a;
						return _Utils_update(
							record,
							{agX: list});
					case 5:
						var string = option.a;
						return _Utils_update(
							record,
							{
								y5: $elm$core$Maybe$Just(string)
							});
					case 6:
						var isDisabled = option.a;
						return _Utils_update(
							record,
							{zg: isDisabled});
					case 7:
						var attributes = option.a;
						return _Utils_update(
							record,
							{
								xr: _Utils_ap(
									A2(
										$elm$core$List$map,
										$elm$html$Html$Attributes$map($elm$core$Basics$never),
										attributes),
									record.xr)
							});
					case 8:
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									A2($elm$html$Html$Attributes$style, 'display', 'inline-flex'),
									record.xr)
							});
					case 9:
						var position = option.a;
						return _Utils_update(
							record,
							{ZP: position});
					default:
						var bool = option.a;
						return _Utils_update(
							record,
							{zT: bool});
				}
			}),
		$author$project$Components$DateInput$defaultOptions,
		options);
};
var $agustinrhcp$elm_datepicker$DatePicker$Blur = {$: 6};
var $agustinrhcp$elm_datepicker$DatePicker$Focus = {$: 5};
var $agustinrhcp$elm_datepicker$DatePicker$KeyDown = function (a) {
	return {$: 11, a: a};
};
var $agustinrhcp$elm_datepicker$DatePicker$SubmitText = {$: 4};
var $agustinrhcp$elm_datepicker$DatePicker$Text = function (a) {
	return {$: 3, a: a};
};
var $agustinrhcp$elm_datepicker$DatePicker$ChangeFocus = function (a) {
	return {$: 1, a: a};
};
var $agustinrhcp$elm_datepicker$DatePicker$ChangePicking = function (a) {
	return {$: 9, a: a};
};
var $agustinrhcp$elm_datepicker$DatePicker$Month = 1;
var $justinmimbs$date$Date$Months = 1;
var $agustinrhcp$elm_datepicker$DatePicker$MouseDown = {$: 7};
var $agustinrhcp$elm_datepicker$DatePicker$MouseUp = {$: 8};
var $agustinrhcp$elm_datepicker$DatePicker$Year = 2;
var $justinmimbs$date$Date$Years = 0;
var $justinmimbs$date$Date$add = F3(
	function (unit, n, _v0) {
		var rd = _v0;
		switch (unit) {
			case 0:
				return A3($justinmimbs$date$Date$add, 1, 12 * n, rd);
			case 1:
				var date = $justinmimbs$date$Date$toCalendarDate(rd);
				var wholeMonths = ((12 * (date.amw - 1)) + ($justinmimbs$date$Date$monthToNumber(date.aiP) - 1)) + n;
				var m = $justinmimbs$date$Date$numberToMonth(
					A2($elm$core$Basics$modBy, 12, wholeMonths) + 1);
				var y = A2($justinmimbs$date$Date$floorDiv, wholeMonths, 12) + 1;
				return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A2(
					$elm$core$Basics$min,
					date.af9,
					A2($justinmimbs$date$Date$daysInMonth, y, m));
			case 2:
				return rd + (7 * n);
			default:
				return rd + n;
		}
	});
var $agustinrhcp$elm_datepicker$DatePicker$Date$changeYear = F2(
	function (current, newYear) {
		var _v0 = $elm$core$String$toInt(newYear);
		if (!_v0.$) {
			var year = _v0.a;
			return A3(
				$justinmimbs$date$Date$fromCalendarDate,
				year,
				$justinmimbs$date$Date$month(current),
				$justinmimbs$date$Date$day(current));
		} else {
			return current;
		}
	});
var $agustinrhcp$elm_datepicker$DatePicker$groupDates = function (dates) {
	var go = F4(
		function (i, xs, racc, acc) {
			go:
			while (true) {
				if (!xs.b) {
					return $elm$core$List$reverse(acc);
				} else {
					var x = xs.a;
					var xxs = xs.b;
					if (i === 6) {
						var $temp$i = 0,
							$temp$xs = xxs,
							$temp$racc = _List_Nil,
							$temp$acc = A2(
							$elm$core$List$cons,
							$elm$core$List$reverse(
								A2($elm$core$List$cons, x, racc)),
							acc);
						i = $temp$i;
						xs = $temp$xs;
						racc = $temp$racc;
						acc = $temp$acc;
						continue go;
					} else {
						var $temp$i = i + 1,
							$temp$xs = xxs,
							$temp$racc = A2($elm$core$List$cons, x, racc),
							$temp$acc = acc;
						i = $temp$i;
						xs = $temp$xs;
						racc = $temp$racc;
						acc = $temp$acc;
						continue go;
					}
				}
			}
		});
	return A4(go, 0, dates, _List_Nil, _List_Nil);
};
var $agustinrhcp$elm_datepicker$DatePicker$maybeOr = F2(
	function (lhs, rhs) {
		if (!rhs.$) {
			return rhs;
		} else {
			return lhs;
		}
	});
var $agustinrhcp$elm_datepicker$DatePicker$mkClass = F2(
	function (_v0, c) {
		var classNamespace = _v0.mQ;
		return $elm$html$Html$Attributes$class(
			_Utils_ap(classNamespace, c));
	});
var $agustinrhcp$elm_datepicker$DatePicker$split = F2(
	function (into, list) {
		var _v0 = A2($elm$core$List$take, into, list);
		if (!_v0.b) {
			return _List_Nil;
		} else {
			var head = _v0;
			return A2(
				$elm$core$List$cons,
				head,
				A2(
					$agustinrhcp$elm_datepicker$DatePicker$split,
					into,
					A2($elm$core$List$drop, into, list)));
		}
	});
var $elm$html$Html$tr = _VirtualDom_node('tr');
var $agustinrhcp$elm_datepicker$DatePicker$ChangeFocusAndPicking = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $agustinrhcp$elm_datepicker$DatePicker$mkClassList = F2(
	function (_v0, cs) {
		var classNamespace = _v0.mQ;
		return $elm$html$Html$Attributes$classList(
			A2(
				$elm$core$List$map,
				function (_v1) {
					var c = _v1.a;
					var b = _v1.b;
					return _Utils_Tuple2(
						_Utils_ap(classNamespace, c),
						b);
				},
				cs));
	});
var $elm$html$Html$td = _VirtualDom_node('td');
var $agustinrhcp$elm_datepicker$DatePicker$viewMonth = F3(
	function (focused, settings, month) {
		var year = $justinmimbs$date$Date$year(focused);
		var day = $justinmimbs$date$Date$day(focused);
		return A2(
			$elm$html$Html$td,
			_List_fromArray(
				[
					A2(
					$agustinrhcp$elm_datepicker$DatePicker$mkClassList,
					settings,
					_List_fromArray(
						[
							_Utils_Tuple2('day', true)
						])),
					$elm$html$Html$Events$onClick(
					A2(
						$agustinrhcp$elm_datepicker$DatePicker$ChangeFocusAndPicking,
						A3($justinmimbs$date$Date$fromCalendarDate, year, month, day),
						0))
				]),
			_List_fromArray(
				[
					settings.rD(
					settings.Bk(month))
				]));
	});
var $agustinrhcp$elm_datepicker$DatePicker$monthList = F2(
	function (focused, settings) {
		var months = _List_fromArray(
			[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]);
		var splitMonths = A2($agustinrhcp$elm_datepicker$DatePicker$split, 3, months);
		return A2(
			$elm$core$List$map,
			function (monthsRow) {
				return A2(
					$elm$html$Html$tr,
					_List_Nil,
					A2(
						$elm$core$List$map,
						A2($agustinrhcp$elm_datepicker$DatePicker$viewMonth, focused, settings),
						monthsRow));
			},
			splitMonths);
	});
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNode;
var $elm$html$Html$option = _VirtualDom_node('option');
var $justinmimbs$date$Date$Day = 11;
var $justinmimbs$date$Date$weekdayToNumber = function (wd) {
	switch (wd) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		default:
			return 7;
	}
};
var $justinmimbs$date$Date$daysSincePreviousWeekday = F2(
	function (wd, date) {
		return A2(
			$elm$core$Basics$modBy,
			7,
			($justinmimbs$date$Date$weekdayNumber(date) + 7) - $justinmimbs$date$Date$weekdayToNumber(wd));
	});
var $justinmimbs$date$Date$firstOfMonth = F2(
	function (y, m) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + 1;
	});
var $justinmimbs$date$Date$quarterToMonth = function (q) {
	return $justinmimbs$date$Date$numberToMonth((q * 3) - 2);
};
var $justinmimbs$date$Date$floor = F2(
	function (interval, date) {
		var rd = date;
		switch (interval) {
			case 0:
				return $justinmimbs$date$Date$firstOfYear(
					$justinmimbs$date$Date$year(date));
			case 1:
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$quarterToMonth(
						$justinmimbs$date$Date$quarter(date)));
			case 2:
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$month(date));
			case 3:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 0, date);
			case 4:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 0, date);
			case 5:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 1, date);
			case 6:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 2, date);
			case 7:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 3, date);
			case 8:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 4, date);
			case 9:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 5, date);
			case 10:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 6, date);
			default:
				return date;
		}
	});
var $justinmimbs$date$Date$Days = 3;
var $justinmimbs$date$Date$Weeks = 2;
var $justinmimbs$date$Date$intervalToUnits = function (interval) {
	switch (interval) {
		case 0:
			return _Utils_Tuple2(1, 0);
		case 1:
			return _Utils_Tuple2(3, 1);
		case 2:
			return _Utils_Tuple2(1, 1);
		case 11:
			return _Utils_Tuple2(1, 3);
		default:
			var week = interval;
			return _Utils_Tuple2(1, 2);
	}
};
var $justinmimbs$date$Date$ceiling = F2(
	function (interval, date) {
		var floored = A2($justinmimbs$date$Date$floor, interval, date);
		if (_Utils_eq(date, floored)) {
			return date;
		} else {
			var _v0 = $justinmimbs$date$Date$intervalToUnits(interval);
			var n = _v0.a;
			var unit = _v0.b;
			return A3($justinmimbs$date$Date$add, unit, n, floored);
		}
	});
var $justinmimbs$date$Date$rangeHelp = F5(
	function (unit, step, until, revList, current) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(current, until) < 0) {
				var _v0 = A3($justinmimbs$date$Date$add, unit, step, current);
				var next = _v0;
				var $temp$unit = unit,
					$temp$step = step,
					$temp$until = until,
					$temp$revList = A2($elm$core$List$cons, current, revList),
					$temp$current = next;
				unit = $temp$unit;
				step = $temp$step;
				until = $temp$until;
				revList = $temp$revList;
				current = $temp$current;
				continue rangeHelp;
			} else {
				return $elm$core$List$reverse(revList);
			}
		}
	});
var $justinmimbs$date$Date$range = F4(
	function (interval, step, _v0, _v1) {
		var start = _v0;
		var until = _v1;
		var _v2 = $justinmimbs$date$Date$intervalToUnits(interval);
		var n = _v2.a;
		var unit = _v2.b;
		var _v3 = A2($justinmimbs$date$Date$ceiling, interval, start);
		var first = _v3;
		return (_Utils_cmp(first, until) < 0) ? A5(
			$justinmimbs$date$Date$rangeHelp,
			unit,
			A2($elm$core$Basics$max, 1, step) * n,
			until,
			_List_Nil,
			first) : _List_Nil;
	});
var $justinmimbs$date$Date$Friday = 8;
var $justinmimbs$date$Date$Monday = 4;
var $justinmimbs$date$Date$Saturday = 9;
var $justinmimbs$date$Date$Sunday = 10;
var $justinmimbs$date$Date$Thursday = 7;
var $justinmimbs$date$Date$Tuesday = 5;
var $justinmimbs$date$Date$Wednesday = 6;
var $agustinrhcp$elm_datepicker$DatePicker$Date$weekdayToInterval = function (weekday) {
	switch (weekday) {
		case 0:
			return 4;
		case 1:
			return 5;
		case 2:
			return 6;
		case 3:
			return 7;
		case 4:
			return 8;
		case 5:
			return 9;
		default:
			return 10;
	}
};
var $agustinrhcp$elm_datepicker$DatePicker$prepareDates = F2(
	function (date, firstDayOfWeek) {
		var weekdayAsInterval = $agustinrhcp$elm_datepicker$DatePicker$Date$weekdayToInterval(firstDayOfWeek);
		var start = A2(
			$justinmimbs$date$Date$floor,
			weekdayAsInterval,
			A3(
				$justinmimbs$date$Date$fromCalendarDate,
				$justinmimbs$date$Date$year(date),
				$justinmimbs$date$Date$month(date),
				1));
		var firstOfMonth = A3(
			$justinmimbs$date$Date$fromCalendarDate,
			$justinmimbs$date$Date$year(date),
			$justinmimbs$date$Date$month(date),
			1);
		var end = A2(
			$justinmimbs$date$Date$ceiling,
			weekdayAsInterval,
			A3($justinmimbs$date$Date$add, 1, 1, firstOfMonth));
		return {
			Pe: A4($justinmimbs$date$Date$range, 11, 1, start, end),
			G8: date
		};
	});
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $elm$html$Html$Attributes$selected = $elm$html$Html$Attributes$boolProperty('selected');
var $elm$html$Html$table = _VirtualDom_node('table');
var $elm$html$Html$tbody = _VirtualDom_node('tbody');
var $elm$html$Html$thead = _VirtualDom_node('thead');
var $justinmimbs$date$Date$toRataDie = function (_v0) {
	var rd = _v0;
	return rd;
};
var $agustinrhcp$elm_datepicker$DatePicker$Pick = function (a) {
	return {$: 2, a: a};
};
var $agustinrhcp$elm_datepicker$DatePicker$viewDay = F5(
	function (settings, picked, isOtherMonth, isToday, d) {
		var disabled = settings.aib(d);
		var props = (!disabled) ? _List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				$agustinrhcp$elm_datepicker$DatePicker$Pick(d))
			]) : _List_Nil;
		var classList = $agustinrhcp$elm_datepicker$DatePicker$mkClassList(settings);
		return A2(
			$elm$html$Html$td,
			A2(
				$elm$core$List$cons,
				classList(
					_List_fromArray(
						[
							_Utils_Tuple2('day', true),
							_Utils_Tuple2('disabled', disabled),
							_Utils_Tuple2(
							'picked',
							picked(d)),
							_Utils_Tuple2(
							'today',
							isToday(d)),
							_Utils_Tuple2(
							'other-month',
							isOtherMonth(d))
						])),
				props),
			_List_fromArray(
				[
					settings.rD(
					$elm$core$String$fromInt(
						$justinmimbs$date$Date$day(d)))
				]));
	});
var $agustinrhcp$elm_datepicker$DatePicker$viewYear = F3(
	function (focused, settings, year) {
		var month = $justinmimbs$date$Date$month(focused);
		var day = $justinmimbs$date$Date$day(focused);
		return A2(
			$elm$html$Html$td,
			_List_fromArray(
				[
					A2(
					$agustinrhcp$elm_datepicker$DatePicker$mkClassList,
					settings,
					_List_fromArray(
						[
							_Utils_Tuple2('day', true)
						])),
					$elm$html$Html$Events$onClick(
					A2(
						$agustinrhcp$elm_datepicker$DatePicker$ChangeFocusAndPicking,
						A3($justinmimbs$date$Date$fromCalendarDate, year, month, day),
						1))
				]),
			_List_fromArray(
				[
					settings.rD(
					settings.q4(year))
				]));
	});
var $agustinrhcp$elm_datepicker$DatePicker$yearList = F2(
	function (focused, settings) {
		var focusedYear = $justinmimbs$date$Date$year(focused);
		var years = A2($elm$core$List$range, focusedYear - 1, focusedYear + 10);
		var splitYears = A2($agustinrhcp$elm_datepicker$DatePicker$split, 3, years);
		return A2(
			$elm$core$List$map,
			function (yearsRow) {
				return A2(
					$elm$html$Html$tr,
					_List_Nil,
					A2(
						$elm$core$List$map,
						A2($agustinrhcp$elm_datepicker$DatePicker$viewYear, focused, settings),
						yearsRow));
			},
			splitYears);
	});
var $agustinrhcp$elm_datepicker$DatePicker$Date$yearRange = F2(
	function (_v0, range) {
		var currentMonth = _v0.G8;
		var today = _v0.FR;
		switch (range.$) {
			case 1:
				var num = range.a;
				return A2(
					$elm$core$List$range,
					$justinmimbs$date$Date$year(currentMonth) - num,
					$justinmimbs$date$Date$year(currentMonth) + num);
			case 2:
				var start = range.a;
				var end = range.b;
				return A2($elm$core$List$range, start, end);
			case 3:
				var year_ = range.a;
				return A2(
					$elm$core$List$range,
					year_,
					$justinmimbs$date$Date$year(today));
			case 4:
				var year_ = range.a;
				return A2(
					$elm$core$List$range,
					$justinmimbs$date$Date$year(today),
					year_);
			default:
				return _List_Nil;
		}
	});
var $agustinrhcp$elm_datepicker$DatePicker$yearRangeActive = function (yearRange) {
	return !_Utils_eq(yearRange, $agustinrhcp$elm_datepicker$DatePicker$Date$Off);
};
var $agustinrhcp$elm_datepicker$DatePicker$datePicker = F3(
	function (pickedDate, settings, _v0) {
		var focused = _v0.bC;
		var today = _v0.FR;
		var picking = _v0.kF;
		var picked = function (d) {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function (pdate) {
						return _Utils_eq(
							$justinmimbs$date$Date$toRataDie(pdate),
							$justinmimbs$date$Date$toRataDie(d));
					},
					pickedDate));
		};
		var onChange = function (handler) {
			return A2(
				$elm$html$Html$Events$on,
				'change',
				A2($elm$json$Json$Decode$map, handler, $elm$html$Html$Events$targetValue));
		};
		var isToday = function (d) {
			return _Utils_eq(
				$justinmimbs$date$Date$toRataDie(d),
				$justinmimbs$date$Date$toRataDie(today));
		};
		var firstDayOffset = $justinmimbs$date$Date$weekdayToNumber(settings.ahm) - 1;
		var dpClass = $agustinrhcp$elm_datepicker$DatePicker$mkClass(settings);
		var currentDate = A2(
			$elm$core$Maybe$withDefault,
			today,
			A2($agustinrhcp$elm_datepicker$DatePicker$maybeOr, pickedDate, focused));
		var isOtherMonth = function (d) {
			return !_Utils_eq(
				$justinmimbs$date$Date$month(currentDate),
				$justinmimbs$date$Date$month(d));
		};
		var arrow = F2(
			function (className, message) {
				return A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							dpClass(className),
							$elm$html$Html$Events$onClick(message),
							$elm$html$Html$Attributes$tabindex(-1),
							$elm$html$Html$Attributes$type_('button')
						]),
					_List_Nil);
			});
		var _v1 = A2($agustinrhcp$elm_datepicker$DatePicker$prepareDates, currentDate, settings.ahm);
		var currentMonth = _v1.G8;
		var currentDates = _v1.Pe;
		var dayList = A2(
			$elm$core$List$map,
			function (rowDays) {
				return A2(
					$elm$html$Html$tr,
					_List_fromArray(
						[
							dpClass('row')
						]),
					A2(
						$elm$core$List$map,
						A4($agustinrhcp$elm_datepicker$DatePicker$viewDay, settings, picked, isOtherMonth, isToday),
						rowDays));
			},
			$agustinrhcp$elm_datepicker$DatePicker$groupDates(currentDates));
		var isCurrentYear = function (selectedYear) {
			return _Utils_eq(
				$justinmimbs$date$Date$year(currentMonth),
				selectedYear);
		};
		var yearOption = F2(
			function (index, selectedYear) {
				return _Utils_Tuple2(
					$elm$core$String$fromInt(index),
					A2(
						$elm$html$Html$option,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$value(
								$elm$core$String$fromInt(selectedYear)),
								$elm$html$Html$Attributes$selected(
								isCurrentYear(selectedYear))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(selectedYear))
							])));
			});
		var _v2 = function () {
			var front = function (to_) {
				return A2(
					$elm$core$List$range,
					$justinmimbs$date$Date$year(currentMonth),
					to_);
			};
			var back = function (from_) {
				return A2(
					$elm$core$List$range,
					from_,
					$justinmimbs$date$Date$year(currentMonth));
			};
			var _v3 = settings.iH;
			switch (_v3.$) {
				case 3:
					var from_ = _v3.a;
					return _Utils_Tuple2(
						front(from_ - 1),
						back(
							$justinmimbs$date$Date$year(today) + 1));
				case 4:
					var to_ = _v3.a;
					return _Utils_Tuple2(
						front(
							$justinmimbs$date$Date$year(today) - 1),
						back(to_ + 1));
				case 2:
					var from_ = _v3.a;
					var to_ = _v3.b;
					return _Utils_Tuple2(
						front(from_ - 1),
						back(to_ + 1));
				case 1:
					return _Utils_Tuple2(_List_Nil, _List_Nil);
				default:
					return _Utils_Tuple2(_List_Nil, _List_Nil);
			}
		}();
		var addedYearsFront = _v2.a;
		var addedYearsBack = _v2.b;
		var dropdownYear = A3(
			$elm$html$Html$Keyed$node,
			'select',
			_List_fromArray(
				[
					onChange(
					A2(
						$elm$core$Basics$composeR,
						$agustinrhcp$elm_datepicker$DatePicker$Date$changeYear(currentDate),
						$agustinrhcp$elm_datepicker$DatePicker$ChangeFocus)),
					dpClass('year-menu')
				]),
			A2(
				$elm$core$List$indexedMap,
				yearOption,
				$elm$core$List$concat(
					_List_fromArray(
						[
							addedYearsFront,
							A2(
							$agustinrhcp$elm_datepicker$DatePicker$Date$yearRange,
							{G8: currentMonth, FR: today},
							settings.iH),
							addedYearsBack
						]))));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					dpClass('picker'),
					A2(
					$elm$html$Html$Events$stopPropagationOn,
					'mousedown',
					$elm$json$Json$Decode$succeed(
						_Utils_Tuple2($agustinrhcp$elm_datepicker$DatePicker$MouseDown, true))),
					A2(
					$elm$html$Html$Events$stopPropagationOn,
					'mouseup',
					$elm$json$Json$Decode$succeed(
						_Utils_Tuple2($agustinrhcp$elm_datepicker$DatePicker$MouseUp, true)))
				]),
			function () {
				switch (picking) {
					case 0:
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										dpClass('picker-header')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												dpClass('prev-container')
											]),
										_List_fromArray(
											[
												A2(
												arrow,
												'prev',
												$agustinrhcp$elm_datepicker$DatePicker$ChangeFocus(
													A3($justinmimbs$date$Date$add, 1, -1, currentDate)))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												dpClass('month-container')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$tabindex(-1),
														dpClass('month'),
														$elm$html$Html$Attributes$type_('button'),
														$elm$html$Html$Events$onClick(
														$agustinrhcp$elm_datepicker$DatePicker$ChangePicking(1))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														settings.Bk(
															$justinmimbs$date$Date$month(currentMonth)))
													])),
												A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$tabindex(-1),
														dpClass('year'),
														$elm$html$Html$Attributes$type_('button'),
														$elm$html$Html$Events$onClick(
														$agustinrhcp$elm_datepicker$DatePicker$ChangePicking(2))
													]),
												_List_fromArray(
													[
														(!$agustinrhcp$elm_datepicker$DatePicker$yearRangeActive(settings.iH)) ? $elm$html$Html$text(
														settings.q4(
															$justinmimbs$date$Date$year(currentMonth))) : A3(
														$elm$html$Html$Keyed$node,
														'span',
														_List_Nil,
														_List_fromArray(
															[
																_Utils_Tuple2(
																$elm$core$String$fromInt(
																	$justinmimbs$date$Date$year(currentMonth)),
																dropdownYear)
															]))
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												dpClass('next-container')
											]),
										_List_fromArray(
											[
												A2(
												arrow,
												'next',
												$agustinrhcp$elm_datepicker$DatePicker$ChangeFocus(
													A3($justinmimbs$date$Date$add, 1, 1, currentDate)))
											]))
									])),
								A2(
								$elm$html$Html$table,
								_List_fromArray(
									[
										dpClass('table')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$thead,
										_List_fromArray(
											[
												dpClass('weekdays')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$tr,
												_List_Nil,
												A2(
													$elm$core$List$map,
													function (d) {
														return A2(
															$elm$html$Html$td,
															_List_fromArray(
																[
																	dpClass('dow')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	settings.aga(d))
																]));
													},
													A2(
														$elm$core$List$take,
														7,
														A2(
															$elm$core$List$drop,
															firstDayOffset,
															$elm$core$List$concat(
																A2(
																	$elm$core$List$repeat,
																	2,
																	_List_fromArray(
																		[0, 1, 2, 3, 4, 5, 6])))))))
											])),
										A2(
										$elm$html$Html$tbody,
										_List_fromArray(
											[
												dpClass('days')
											]),
										dayList)
									]))
							]);
					case 1:
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										dpClass('picker-header')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												dpClass('prev-container')
											]),
										_List_fromArray(
											[
												A2(
												arrow,
												'prev',
												$agustinrhcp$elm_datepicker$DatePicker$ChangeFocus(
													A3($justinmimbs$date$Date$add, 0, -1, currentDate)))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												dpClass('month-container')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														dpClass('year'),
														$elm$html$Html$Attributes$type_('button'),
														$elm$html$Html$Events$onClick(
														$agustinrhcp$elm_datepicker$DatePicker$ChangePicking(2))
													]),
												_List_fromArray(
													[
														(!$agustinrhcp$elm_datepicker$DatePicker$yearRangeActive(settings.iH)) ? $elm$html$Html$text(
														settings.q4(
															$justinmimbs$date$Date$year(currentMonth))) : A3(
														$elm$html$Html$Keyed$node,
														'span',
														_List_Nil,
														_List_fromArray(
															[
																_Utils_Tuple2(
																$elm$core$String$fromInt(
																	$justinmimbs$date$Date$year(currentMonth)),
																dropdownYear)
															]))
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												dpClass('next-container')
											]),
										_List_fromArray(
											[
												A2(
												arrow,
												'next',
												$agustinrhcp$elm_datepicker$DatePicker$ChangeFocus(
													A3($justinmimbs$date$Date$add, 0, 1, currentDate)))
											]))
									])),
								A2(
								$elm$html$Html$table,
								_List_fromArray(
									[
										dpClass('table')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$tbody,
										_List_fromArray(
											[
												dpClass('months')
											]),
										A2($agustinrhcp$elm_datepicker$DatePicker$monthList, currentDate, settings))
									]))
							]);
					default:
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										dpClass('picker-header')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												dpClass('prev-container')
											]),
										_List_fromArray(
											[
												A2(
												arrow,
												'prev',
												$agustinrhcp$elm_datepicker$DatePicker$ChangeFocus(
													A3($justinmimbs$date$Date$add, 0, -12, currentDate)))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												dpClass('month-container')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														dpClass('year')
													]),
												_List_fromArray(
													[
														(!$agustinrhcp$elm_datepicker$DatePicker$yearRangeActive(settings.iH)) ? $elm$html$Html$text(
														settings.q4(
															$justinmimbs$date$Date$year(currentMonth))) : A3(
														$elm$html$Html$Keyed$node,
														'span',
														_List_Nil,
														_List_fromArray(
															[
																_Utils_Tuple2(
																$elm$core$String$fromInt(
																	$justinmimbs$date$Date$year(currentMonth)),
																dropdownYear)
															]))
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												dpClass('next-container')
											]),
										_List_fromArray(
											[
												A2(
												arrow,
												'next',
												$agustinrhcp$elm_datepicker$DatePicker$ChangeFocus(
													A3($justinmimbs$date$Date$add, 0, 12, currentDate)))
											]))
									])),
								A2(
								$elm$html$Html$table,
								_List_fromArray(
									[
										dpClass('table')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$tbody,
										_List_fromArray(
											[
												dpClass('years')
											]),
										A2($agustinrhcp$elm_datepicker$DatePicker$yearList, currentDate, settings))
									]))
							]);
				}
			}());
	});
var $elm$html$Html$Attributes$name = $elm$html$Html$Attributes$stringProperty('name');
var $elm$html$Html$Events$onFocus = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'focus',
		$elm$json$Json$Decode$succeed(msg));
};
var $agustinrhcp$elm_datepicker$DatePicker$view = F3(
	function (pickedDate, settings, _v0) {
		var model = _v0;
		var potentialInputId = A3(
			$elm$core$Basics$composeR,
			$elm$core$List$singleton,
			$elm$core$List$filterMap($elm$core$Basics$identity),
			A2($elm$core$Maybe$map, $elm$html$Html$Attributes$id, settings.H3));
		var inputClasses = A2(
			$elm$core$List$cons,
			_Utils_Tuple2(settings.mQ + 'input', true),
			settings.H2);
		var inputCommon = function (xs) {
			return A2(
				$elm$html$Html$input,
				_Utils_ap(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(inputClasses),
							$elm$html$Html$Attributes$name(
							A2($elm$core$Maybe$withDefault, '', settings.H4)),
							$elm$html$Html$Attributes$type_('text'),
							A2(
							$elm$html$Html$Events$on,
							'change',
							$elm$json$Json$Decode$succeed($agustinrhcp$elm_datepicker$DatePicker$SubmitText)),
							$elm$html$Html$Events$onInput($agustinrhcp$elm_datepicker$DatePicker$Text),
							$elm$html$Html$Events$onBlur($agustinrhcp$elm_datepicker$DatePicker$Blur),
							$elm$html$Html$Events$onClick($agustinrhcp$elm_datepicker$DatePicker$Focus),
							$elm$html$Html$Events$onFocus($agustinrhcp$elm_datepicker$DatePicker$Focus),
							A2(
							$elm$html$Html$Events$on,
							'keydown',
							A2($elm$json$Json$Decode$map, $agustinrhcp$elm_datepicker$DatePicker$KeyDown, $elm$html$Html$Events$keyCode))
						]),
					_Utils_ap(
						settings.T3,
						_Utils_ap(potentialInputId, xs))),
				_List_Nil);
		};
		var dateInput = inputCommon(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$placeholder(settings.aj3),
					$elm$html$Html$Attributes$value(
					A2(
						$elm$core$Maybe$withDefault,
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2($elm$core$Maybe$map, settings.af7, pickedDate)),
						model.cH))
				]));
		var containerClassList = A2(
			$elm$core$List$cons,
			_Utils_Tuple2(settings.mQ + 'container', true),
			settings.G0);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(containerClassList)
				]),
			_List_fromArray(
				[
					dateInput,
					model.Yn ? A3($agustinrhcp$elm_datepicker$DatePicker$datePicker, pickedDate, settings, model) : $elm$html$Html$text('')
				]));
	});
var $author$project$Components$DateInput$view = F2(
	function (options, model) {
		var optionsRecord = $author$project$Components$DateInput$optionsToRecord(options);
		var datePickerSettings_ = $author$project$Components$DateInput$datePickerSettings(optionsRecord);
		return A2(
			$elm$html$Html$div,
			optionsRecord.xr,
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$group(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Components$DateInput$DatePickerMsg(datePickerSettings_),
							A3($agustinrhcp$elm_datepicker$DatePicker$view, optionsRecord.aee, datePickerSettings_, model.na)),
							$author$project$Ui$Form$Input$addon(
							_List_fromArray(
								[
									$author$project$Ui$Icon$calendar(_List_Nil)
								]))
						])),
					optionsRecord.zT ? $elm$html$Html$text('') : $author$project$Utils$FormErrors$view(optionsRecord.agX)
				]));
	});
var $author$project$Components$ProviderCredentials$viewExpirationDateInput = function (_v0) {
	var placeholder = _v0.aj3;
	var value = _v0.aee;
	var dateInputModel = _v0.Hi;
	var today = _v0.FR;
	var hasValidationErrors = _v0.jO;
	var toMsg = _v0.al6;
	return A2(
		$elm$html$Html$map,
		toMsg,
		A2(
			$author$project$Components$DateInput$view,
			_List_fromArray(
				[
					$author$project$Components$DateInput$placeholder(placeholder),
					$author$project$Components$DateInput$value(value),
					$author$project$Components$DateInput$above,
					$author$project$Components$DateInput$disabledPickerDates(
					function (date) {
						return A2($author$project$Utils$Date$isBefore, date, today);
					}),
					$author$project$Components$DateInput$invalid(hasValidationErrors)
				]),
			dateInputModel));
};
var $author$project$Ui$Dropdown$DropdownButtonClicked = {$: 0};
var $author$project$Ui$Icon$ChevronDown = 13;
var $author$project$Ui$Icon$chevronDown = $author$project$Ui$Icon$viewIcon(13);
var $author$project$Ui$Icon$Info = 2;
var $author$project$Ui$Icon$info = $author$project$Ui$Icon$IconColor(2);
var $author$project$Ui$Dropdown$optionsToRecord = A2(
	$elm$core$List$foldl,
	F2(
		function (option, record) {
			switch (option.$) {
				case 0:
					switch (option.a) {
						case 0:
							var _v1 = option.a;
							return _Utils_update(
								record,
								{
									mA: _List_fromArray(
										['button button--secondary'])
								});
						case 2:
							var _v2 = option.a;
							return _Utils_update(
								record,
								{
									mA: _List_fromArray(
										['button button--warning'])
								});
						default:
							var _v3 = option.a;
							return _Utils_update(
								record,
								{
									mA: _List_fromArray(
										['button button--link'])
								});
					}
				case 1:
					var _v4 = option.a;
					return _Utils_update(
						record,
						{
							xH: _List_fromArray(
								['button--sm'])
						});
				case 2:
					var isInvalid = option.a;
					return _Utils_update(
						record,
						{sM: isInvalid});
				case 3:
					var isDisabled = option.a;
					return _Utils_update(
						record,
						{ep: isDisabled});
				case 4:
					var isReadonly = option.a;
					return _Utils_update(
						record,
						{ua: isReadonly});
				case 5:
					var errorList = option.a;
					return _Utils_update(
						record,
						{agX: errorList});
				case 6:
					var label = option.a;
					return _Utils_update(
						record,
						{mm: label});
				case 7:
					var placeholder_ = option.a;
					return _Utils_update(
						record,
						{x9: placeholder_});
				default:
					var isLoading = option.a;
					return _Utils_update(
						record,
						{V8: isLoading});
			}
		}),
	{
		mm: '',
		mA: _List_fromArray(
			['button button--default']),
		xH: _List_Nil,
		x9: '',
		ep: false,
		agX: _List_Nil,
		sM: false,
		V8: false,
		ua: false
	});
var $elm$html$Html$Attributes$readonly = $elm$html$Html$Attributes$boolProperty('readOnly');
var $author$project$Ui$Dropdown$ArrowPressed = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Dropdown$Down = 1;
var $author$project$Ui$Dropdown$EnterPressed = {$: 13};
var $author$project$Ui$Dropdown$Right = 2;
var $author$project$Ui$Dropdown$Up = 0;
var $elm$virtual_dom$VirtualDom$Custom = function (a) {
	return {$: 3, a: a};
};
var $elm$html$Html$Events$custom = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Custom(decoder));
	});
var $author$project$Ui$Dropdown$triggerKeyHandlers = function (toMsg) {
	return A2(
		$elm$html$Html$Events$custom,
		'keydown',
		A2(
			$elm$json$Json$Decode$map,
			function (msg_) {
				return {aiH: msg_, akc: true, alJ: true};
			},
			A2(
				$elm$json$Json$Decode$andThen,
				function (key) {
					switch (key) {
						case ' ':
							return $elm$json$Json$Decode$succeed(
								toMsg($author$project$Ui$Dropdown$DropdownButtonClicked));
						case 'Enter':
							return $elm$json$Json$Decode$succeed(
								toMsg($author$project$Ui$Dropdown$EnterPressed));
						case 'ArrowDown':
							return $elm$json$Json$Decode$succeed(
								toMsg(
									$author$project$Ui$Dropdown$ArrowPressed(1)));
						case 'ArrowUp':
							return $elm$json$Json$Decode$succeed(
								toMsg(
									$author$project$Ui$Dropdown$ArrowPressed(0)));
						case 'ArrowRight':
							return $elm$json$Json$Decode$succeed(
								toMsg(
									$author$project$Ui$Dropdown$ArrowPressed(2)));
						default:
							return $elm$json$Json$Decode$fail('ignore');
					}
				},
				A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string))));
};
var $author$project$Ui$Dropdown$ArrowNavigation = function (a) {
	return {$: 7, a: a};
};
var $author$project$Ui$Dropdown$Item$Checkbox = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Ui$Dropdown$FocusInput = {$: 10};
var $author$project$Ui$Dropdown$FocusLink = {$: 11};
var $author$project$Ui$Dropdown$Item$InnerDropdown = F4(
	function (a, b, c, d) {
		return {$: 5, a: a, b: b, c: c, d: d};
	});
var $author$project$Ui$Dropdown$InnerDropdownButtonClicked = {$: 3};
var $author$project$Ui$Dropdown$Item$Input = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Dropdown$Item$Item = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Ui$Dropdown$Item$Link = F3(
	function (a, b, c) {
		return {$: 6, a: a, b: b, c: c};
	});
var $author$project$Ui$Dropdown$Item$OnArrowRight = function (a) {
	return {$: 9, a: a};
};
var $author$project$Ui$Dropdown$Item$Radio = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Ui$Dropdown$Item$Separator = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Dropdown$ItemEnterPressed = {$: 14};
var $author$project$Ui$Dropdown$ItemSelected = {$: 8};
var $author$project$Ui$Dropdown$Left = 3;
var $author$project$Ui$Dropdown$defaultItemOptions = function (toMsg) {
	return {
		xr: _List_Nil,
		iK: false,
		ahO: $elm$core$Maybe$Nothing,
		ah$: $elm$core$Maybe$Nothing,
		Yc: _List_fromArray(
			[
				_Utils_Tuple2(
				'ArrowDown',
				toMsg(
					$author$project$Ui$Dropdown$ArrowNavigation(1))),
				_Utils_Tuple2(
				'ArrowUp',
				toMsg(
					$author$project$Ui$Dropdown$ArrowNavigation(0))),
				_Utils_Tuple2(
				'ArrowLeft',
				toMsg(
					$author$project$Ui$Dropdown$ArrowNavigation(3))),
				_Utils_Tuple2(
				'ArrowRight',
				toMsg(
					$author$project$Ui$Dropdown$ArrowNavigation(2)))
			]),
		aje: $elm$core$Basics$always(
			toMsg($author$project$Ui$Dropdown$NoOp)),
		IS: toMsg($author$project$Ui$Dropdown$NoOp),
		ajj: toMsg($author$project$Ui$Dropdown$NoOp),
		ajk: toMsg($author$project$Ui$Dropdown$ItemEnterPressed),
		ajl: toMsg($author$project$Ui$Dropdown$NoOp),
		ajm: $elm$core$Basics$always(
			toMsg($author$project$Ui$Dropdown$NoOp)),
		ajq: toMsg($author$project$Ui$Dropdown$ItemSelected),
		aju: false,
		aB: false,
		aee: $elm$core$Maybe$Nothing
	};
};
var $author$project$Ui$Dropdown$Item$OnEnter = function (a) {
	return {$: 7, a: a};
};
var $author$project$Ui$Dropdown$onEnter = $author$project$Ui$Dropdown$Item$OnEnter;
var $author$project$Ui$Dropdown$Item$OnFocus = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Dropdown$onFocus = $author$project$Ui$Dropdown$Item$OnFocus;
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $author$project$Ui$Dropdown$Item$optionsToRecord = F2(
	function (defaultOptions, options) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (option_, record) {
					switch (option_.$) {
						case 0:
							var msg = option_.a;
							return _Utils_update(
								record,
								{IS: msg});
						case 1:
							var msg = option_.a;
							return _Utils_update(
								record,
								{ajl: msg});
						case 2:
							var bool = option_.a;
							return _Utils_update(
								record,
								{aB: bool});
						case 3:
							var msg = option_.a;
							return _Utils_update(
								record,
								{ajm: msg});
						case 4:
							var string = option_.a;
							return _Utils_update(
								record,
								{
									aee: $elm$core$Maybe$Just(string)
								});
						case 5:
							var checked = option_.a;
							return _Utils_update(
								record,
								{iK: checked});
						case 6:
							var msg = option_.a;
							return _Utils_update(
								record,
								{aje: msg});
						case 7:
							var msg = option_.a;
							return _Utils_update(
								record,
								{ajj: msg});
						case 8:
							var placeholder = option_.a;
							return _Utils_update(
								record,
								{
									ah$: $elm$core$Maybe$Just(placeholder)
								});
						case 9:
							var msg = option_.a;
							return _Utils_update(
								record,
								{
									Yc: A2(
										$elm$core$List$map,
										function (_v1) {
											var key = _v1.a;
											var handler = _v1.b;
											if (key === 'ArrowRight') {
												return _Utils_Tuple2('ArrowRight', msg);
											} else {
												return _Utils_Tuple2(key, handler);
											}
										},
										record.Yc)
								});
						case 10:
							return _Utils_update(
								record,
								{aju: true});
						case 11:
							return _Utils_update(
								record,
								{
									xr: _Utils_ap(
										record.xr,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('lg:hidden')
											]))
								});
						case 12:
							var iconFunc = option_.a;
							return _Utils_update(
								record,
								{
									ahO: $elm$core$Maybe$Just(iconFunc)
								});
						default:
							return _Utils_update(
								record,
								{
									xr: A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$class('ml-2'),
										record.xr)
								});
					}
				}),
			defaultOptions,
			options);
	});
var $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty('checked');
var $elm$html$Html$li = _VirtualDom_node('li');
var $elm$html$Html$Events$targetChecked = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'checked']),
	$elm$json$Json$Decode$bool);
var $elm$html$Html$Events$onCheck = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetChecked));
};
var $author$project$Ui$Dropdown$Item$onKeyDown = function (handlers) {
	return A2(
		$elm$html$Html$Events$custom,
		'keydown',
		A2(
			$elm$json$Json$Decode$map,
			function (msg) {
				return {aiH: msg, akc: true, alJ: true};
			},
			A2(
				$elm$json$Json$Decode$andThen,
				function (key) {
					var _v0 = A2(
						$elm$core$List$filter,
						function (_v1) {
							var k = _v1.a;
							return _Utils_eq(k, key);
						},
						handlers);
					if (_v0.b && (!_v0.b.b)) {
						var _v2 = _v0.a;
						var msg = _v2.b;
						return $elm$json$Json$Decode$succeed(msg);
					} else {
						return $elm$json$Json$Decode$fail('ignore');
					}
				},
				A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string))));
};
var $author$project$Ui$Dropdown$Item$onMouse = F2(
	function (event, msg) {
		return A2(
			$elm$html$Html$Events$custom,
			event,
			$elm$json$Json$Decode$succeed(
				{aiH: msg, akc: true, alJ: true}));
	});
var $author$project$Ui$Dropdown$Item$viewCheckbox = F2(
	function (options, content) {
		return A2(
			$elm$html$Html$li,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('dropdown__item'),
				A2(
					$elm$core$List$cons,
					A2($elm$html$Html$Attributes$attribute, 'role', 'option'),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Events$onFocus(options.ajl),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class('dropdown__item--focusable'),
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$class('dropdown__item--checkbox'),
								A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$tabindex(-1),
									A2(
										$elm$core$List$map,
										$elm$html$Html$Attributes$map($elm$core$Basics$never),
										options.xr))))))),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							A2($author$project$Ui$Dropdown$Item$onMouse, 'mousedown', options.ajl)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('checkbox'),
									$author$project$Ui$Dropdown$Item$onKeyDown(
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(
											'Enter',
											options.aje(!options.iK)),
										options.Yc)),
									$elm$html$Html$Attributes$tabindex(-1),
									$elm$html$Html$Events$onCheck(options.aje),
									$elm$html$Html$Attributes$checked(options.iK)
								]),
							_List_Nil),
							content
						]))
				]));
	});
var $author$project$Ui$Dropdown$Item$viewInnerDropdown = F4(
	function (dropdownId, open, options, content) {
		return A2(
			$elm$html$Html$li,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('dropdown__item'),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('dropdown__item--focusable'),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('dropdown__item--inner'),
						A2(
							$elm$core$List$cons,
							A2($elm$html$Html$Attributes$attribute, 'role', 'option'),
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$tabindex(-1),
								A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class('dropdown'),
									A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('dropdown--open', open)
												])),
										A2(
											$elm$core$List$cons,
											$elm$html$Html$Attributes$id(dropdownId),
											A2(
												$elm$core$List$cons,
												$author$project$Ui$Dropdown$Item$onKeyDown(
													A2(
														$elm$core$List$cons,
														_Utils_Tuple2('Enter', options.ajj),
														options.Yc)),
												A2(
													$elm$core$List$map,
													$elm$html$Html$Attributes$map($elm$core$Basics$never),
													options.xr)))))))))),
			content);
	});
var $author$project$Ui$Dropdown$Item$decodePressedKey = F2(
	function (expectedKey, toMsg) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (key) {
				return _Utils_eq(key, expectedKey) ? $elm$json$Json$Decode$succeed(toMsg) : $elm$json$Json$Decode$fail('ignore');
			},
			A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
	});
var $author$project$Ui$Dropdown$Item$onEnter = F2(
	function (event, msg) {
		return A2(
			$elm$html$Html$Events$custom,
			event,
			A2(
				$elm$json$Json$Decode$map,
				function (msg_) {
					return {aiH: msg_, akc: true, alJ: true};
				},
				A2($author$project$Ui$Dropdown$Item$decodePressedKey, 'Enter', msg)));
	});
var $author$project$Ui$Dropdown$Item$viewInput = function (options) {
	return A2(
		$elm$html$Html$li,
		A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$class('dropdown__item dropdown__item--focusable'),
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('dropdown__item--input'),
				A2(
					$elm$core$List$cons,
					A2($elm$html$Html$Attributes$attribute, 'role', 'option'),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Events$onFocus(options.ajl),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$tabindex(-1),
							A2(
								$elm$core$List$map,
								$elm$html$Html$Attributes$map($elm$core$Basics$never),
								options.xr)))))),
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$html$Html$text(''),
				A2(
					$elm$core$Maybe$map,
					function (icon_) {
						return icon_(
							_List_fromArray(
								[$author$project$Ui$Icon$info]));
					},
					options.ahO)),
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('text'),
						$author$project$Ui$Dropdown$Item$onKeyDown(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2('Enter', options.ajj),
							options.Yc)),
						$elm$html$Html$Events$onInput(options.ajm),
						function () {
						var _v0 = options.ah$;
						if (!_v0.$) {
							var placeholder = _v0.a;
							return $elm$html$Html$Attributes$placeholder(placeholder);
						} else {
							return $elm$html$Html$Attributes$class('');
						}
					}(),
						$elm$html$Html$Attributes$autocomplete(false),
						$elm$html$Html$Attributes$tabindex(-1),
						A2(
						$elm$core$Maybe$withDefault,
						$elm$html$Html$Attributes$class(''),
						A2($elm$core$Maybe$map, $elm$html$Html$Attributes$value, options.aee)),
						$elm$html$Html$Attributes$class('form-control'),
						options.aju ? $elm$html$Html$Attributes$class('') : A2($author$project$Ui$Dropdown$Item$onEnter, 'keyup', options.ajk)
					]),
				_List_Nil)
			]));
};
var $author$project$Ui$Dropdown$Item$viewItem = F2(
	function (options, content) {
		return A2(
			$elm$html$Html$li,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('dropdown__item', true),
							_Utils_Tuple2('dropdown__item--active', options.aB),
							_Utils_Tuple2('dropdown__item--focusable', true)
						])),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Events$onClick(options.IS),
					A2(
						$elm$core$List$cons,
						options.aju ? $elm$html$Html$Attributes$class('') : A2($author$project$Ui$Dropdown$Item$onMouse, 'mouseup', options.ajq),
						A2(
							$elm$core$List$cons,
							A2($elm$html$Html$Attributes$attribute, 'role', 'option'),
							A2(
								$elm$core$List$cons,
								A2($elm$html$Html$Attributes$attribute, 'designMode', 'true'),
								A2(
									$elm$core$List$cons,
									options.aju ? $elm$html$Html$Attributes$class('') : A2($author$project$Ui$Dropdown$Item$onEnter, 'keyup', options.ajk),
									A2(
										$elm$core$List$cons,
										$author$project$Ui$Dropdown$Item$onKeyDown(options.Yc),
										A2(
											$elm$core$List$cons,
											$elm$html$Html$Attributes$tabindex(-1),
											A2(
												$elm$core$List$map,
												$elm$html$Html$Attributes$map($elm$core$Basics$never),
												options.xr))))))))),
			_List_fromArray(
				[content]));
	});
var $author$project$Ui$Dropdown$Item$viewLink = F3(
	function (href, options, content) {
		return A2(
			$elm$html$Html$li,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('dropdown__item', true),
							_Utils_Tuple2('dropdown__item--active', options.aB),
							_Utils_Tuple2('dropdown__item--focusable', true),
							_Utils_Tuple2('dropdown__item--link', true)
						])),
				A2(
					$elm$core$List$cons,
					A2($elm$html$Html$Attributes$attribute, 'role', 'option'),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Events$onFocus(options.ajl),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$tabindex(-1),
							A2(
								$elm$core$List$map,
								$elm$html$Html$Attributes$map($elm$core$Basics$never),
								options.xr))))),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$tabindex(-1),
							$elm$html$Html$Attributes$href(href),
							$author$project$Ui$Dropdown$Item$onKeyDown(options.Yc)
						]),
					_List_fromArray(
						[
							A2($elm$html$Html$map, $elm$core$Basics$never, content)
						]))
				]));
	});
var $author$project$Ui$Dropdown$Item$viewRadio = F2(
	function (options, content) {
		return A2(
			$elm$html$Html$li,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('dropdown__item'),
				A2(
					$elm$core$List$cons,
					A2($elm$html$Html$Attributes$attribute, 'role', 'option'),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Events$onFocus(options.ajl),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class('dropdown__item--focusable'),
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$class('dropdown__item--radio'),
								A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$tabindex(-1),
									A2(
										$elm$core$List$map,
										$elm$html$Html$Attributes$map($elm$core$Basics$never),
										options.xr))))))),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							A2($author$project$Ui$Dropdown$Item$onMouse, 'mousedown', options.ajl)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('radio'),
									$author$project$Ui$Dropdown$Item$onKeyDown(
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(
											'Enter',
											options.aje(!options.iK)),
										options.Yc)),
									$elm$html$Html$Attributes$tabindex(-1),
									$elm$html$Html$Events$onCheck(options.aje),
									$elm$html$Html$Attributes$checked(options.iK)
								]),
							_List_Nil),
							content
						]))
				]));
	});
var $elm$html$Html$Events$onMouseDown = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mousedown',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Ui$Dropdown$Item$viewSeparator = function (options) {
	return A2(
		$elm$html$Html$div,
		A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$class('dropdown__item dropdown__item--separator'),
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Events$onMouseDown(options.IS),
				A2(
					$elm$core$List$map,
					$elm$html$Html$Attributes$map($elm$core$Basics$never),
					options.xr))),
		_List_Nil);
};
var $author$project$Ui$Dropdown$Item$view = F2(
	function (defaultOptions, item) {
		switch (item.$) {
			case 0:
				var options = item.a;
				var content = item.b;
				return A2(
					$author$project$Ui$Dropdown$Item$viewItem,
					A2($author$project$Ui$Dropdown$Item$optionsToRecord, defaultOptions, options),
					content);
			case 1:
				var options = item.a;
				return $author$project$Ui$Dropdown$Item$viewInput(
					A2($author$project$Ui$Dropdown$Item$optionsToRecord, defaultOptions, options));
			case 2:
				var options = item.a;
				return $author$project$Ui$Dropdown$Item$viewSeparator(
					A2($author$project$Ui$Dropdown$Item$optionsToRecord, defaultOptions, options));
			case 3:
				var options = item.a;
				var content = item.b;
				return A2(
					$author$project$Ui$Dropdown$Item$viewCheckbox,
					A2($author$project$Ui$Dropdown$Item$optionsToRecord, defaultOptions, options),
					content);
			case 4:
				var options = item.a;
				var content = item.b;
				return A2(
					$author$project$Ui$Dropdown$Item$viewRadio,
					A2($author$project$Ui$Dropdown$Item$optionsToRecord, defaultOptions, options),
					content);
			case 5:
				var id = item.a;
				var isOpen = item.b;
				var options = item.c;
				var content = item.d;
				return A4(
					$author$project$Ui$Dropdown$Item$viewInnerDropdown,
					id,
					isOpen,
					A2($author$project$Ui$Dropdown$Item$optionsToRecord, defaultOptions, options),
					content);
			default:
				var href = item.a;
				var options = item.b;
				var content = item.c;
				return A3(
					$author$project$Ui$Dropdown$Item$viewLink,
					href,
					A2($author$project$Ui$Dropdown$Item$optionsToRecord, defaultOptions, options),
					content);
		}
	});
var $author$project$Ui$Dropdown$innerDropdownContent = F3(
	function (trigger, items, model) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dropdown__trigger'),
						$elm$html$Html$Attributes$tabindex(0),
						$elm$html$Html$Attributes$id(model.ahP + '-trigger'),
						$elm$html$Html$Events$onClick(
						model.al6($author$project$Ui$Dropdown$InnerDropdownButtonClicked))
					]),
				A2(
					$elm$core$List$map,
					$elm$html$Html$map($elm$core$Basics$never),
					trigger)),
				A3($author$project$Ui$Dropdown$viewMenu, model.al6, model, items)
			]);
	});
var $author$project$Ui$Dropdown$viewMenu = F3(
	function (toMsg, _v0, items) {
		var direction = _v0.bv;
		var hasNestedDropdowns = A2(
			$elm$core$List$any,
			function (item_) {
				if (item_.$ === 5) {
					return true;
				} else {
					return false;
				}
			},
			items);
		var directionClass = function () {
			switch (direction) {
				case 0:
					return '';
				case 1:
					return 'dropdown__menu--dir-rd';
				case 2:
					return 'dropdown__menu--dir-dl';
				case 3:
					return 'dropdown__menu--dir-tl';
				default:
					return 'dropdown__menu--dir-tr';
			}
		}();
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('dropdown__menu'),
					A2($elm$html$Html$Attributes$attribute, 'role', 'listbox'),
					$elm$html$Html$Attributes$class(directionClass),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('dropdown__menu--overflow-scroll', !hasNestedDropdowns)
						]))
				]),
			A2(
				$elm$core$List$map,
				function (item_) {
					switch (item_.$) {
						case 0:
							var options = item_.a;
							return A2(
								$author$project$Ui$Dropdown$Item$view,
								function (defaults) {
									return _Utils_update(
										defaults,
										{
											Yc: _List_fromArray(
												[
													_Utils_Tuple2(
													'ArrowDown',
													toMsg(
														$author$project$Ui$Dropdown$ArrowNavigation(1))),
													_Utils_Tuple2(
													'ArrowUp',
													toMsg(
														$author$project$Ui$Dropdown$ArrowNavigation(0)))
												])
										});
								}(
									$author$project$Ui$Dropdown$defaultItemOptions(toMsg)),
								$author$project$Ui$Dropdown$Item$Input(
									_Utils_ap(
										options,
										_List_fromArray(
											[
												$author$project$Ui$Dropdown$onFocus(
												toMsg($author$project$Ui$Dropdown$FocusInput))
											]))));
						case 1:
							return A2(
								$author$project$Ui$Dropdown$Item$view,
								$author$project$Ui$Dropdown$defaultItemOptions(toMsg),
								$author$project$Ui$Dropdown$Item$Separator(_List_Nil));
						case 2:
							var options = item_.a;
							var content = item_.b;
							return A2(
								$author$project$Ui$Dropdown$Item$view,
								$author$project$Ui$Dropdown$defaultItemOptions(toMsg),
								A2(
									$author$project$Ui$Dropdown$Item$Checkbox,
									_Utils_ap(
										options,
										_List_fromArray(
											[
												$author$project$Ui$Dropdown$onFocus(
												toMsg($author$project$Ui$Dropdown$FocusInput))
											])),
									content));
						case 3:
							var options = item_.a;
							var content = item_.b;
							return A2(
								$author$project$Ui$Dropdown$Item$view,
								$author$project$Ui$Dropdown$defaultItemOptions(toMsg),
								A2(
									$author$project$Ui$Dropdown$Item$Radio,
									_Utils_ap(
										options,
										_List_fromArray(
											[
												$author$project$Ui$Dropdown$onFocus(
												toMsg($author$project$Ui$Dropdown$FocusInput))
											])),
									content));
						case 4:
							var options = item_.a;
							var content = item_.b;
							return A2(
								$author$project$Ui$Dropdown$Item$view,
								$author$project$Ui$Dropdown$defaultItemOptions(toMsg),
								A2($author$project$Ui$Dropdown$Item$Item, options, content));
						case 6:
							var href = item_.a;
							var options = item_.b;
							var content = item_.c;
							return A2(
								$author$project$Ui$Dropdown$Item$view,
								$author$project$Ui$Dropdown$defaultItemOptions(toMsg),
								A3(
									$author$project$Ui$Dropdown$Item$Link,
									href,
									_Utils_ap(
										options,
										_List_fromArray(
											[
												$author$project$Ui$Dropdown$onFocus(
												toMsg($author$project$Ui$Dropdown$FocusLink))
											])),
									content));
						default:
							var content = item_.a;
							var items_ = item_.b;
							var innerModel = item_.c;
							return A2(
								$author$project$Ui$Dropdown$Item$view,
								$author$project$Ui$Dropdown$defaultItemOptions(toMsg),
								A4(
									$author$project$Ui$Dropdown$Item$InnerDropdown,
									innerModel.ahP,
									innerModel.Yn,
									A2(
										$elm$core$List$cons,
										$author$project$Ui$Dropdown$onEnter(
											innerModel.al6($author$project$Ui$Dropdown$DropdownButtonClicked)),
										function () {
											var _v2 = innerModel.bv;
											if (_v2 === 1) {
												return _List_fromArray(
													[
														$author$project$Ui$Dropdown$Item$OnArrowRight(
														innerModel.al6($author$project$Ui$Dropdown$InnerDropdownButtonClicked))
													]);
											} else {
												return _List_Nil;
											}
										}()),
									A3($author$project$Ui$Dropdown$innerDropdownContent, content, items_, innerModel)));
					}
				},
				items));
	});
var $author$project$Ui$Icon$Xs = 0;
var $author$project$Ui$Icon$xs = $author$project$Ui$Icon$Size(0);
var $author$project$Ui$Dropdown$viewSelect = F4(
	function (options, content, items, model) {
		var toMsg = model.al6;
		var optionsRecord = $author$project$Ui$Dropdown$optionsToRecord(options);
		var errorDescription = $elm$core$List$isEmpty(optionsRecord.agX) ? _List_Nil : _List_fromArray(
			[
				A2(
				$elm$html$Html$Attributes$attribute,
				'aria-describedby',
				A2($elm$core$String$join, '. ', optionsRecord.agX))
			]);
		var ariaInvalid = (optionsRecord.sM || (!$elm$core$List$isEmpty(optionsRecord.agX))) ? _List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'aria-invalid', 'true')
			]) : _List_Nil;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('dropdown'),
					$elm$html$Html$Attributes$id(model.ahP),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('dropdown--open', model.Yn && ((!optionsRecord.ep) && (!optionsRecord.ua))),
							_Utils_Tuple2(
							'dropdown--invalid',
							optionsRecord.sM || (!$elm$core$List$isEmpty(optionsRecord.agX))),
							_Utils_Tuple2('dropdown--disabled', optionsRecord.ep),
							_Utils_Tuple2('dropdown--readonly', optionsRecord.ua)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('dropdown__trigger dropdown__trigger--select'),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$id(model.ahP + '-trigger'),
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$type_('combobox'),
								A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$tabindex(0),
									A2(
										$elm$core$List$cons,
										A2($elm$html$Html$Attributes$attribute, 'role', 'button'),
										A2(
											$elm$core$List$cons,
											A2($elm$html$Html$Attributes$attribute, 'aria-haspopup', 'listbox'),
											A2(
												$elm$core$List$cons,
												A2(
													$elm$html$Html$Attributes$attribute,
													'aria-expanded',
													model.Yn ? 'true' : 'false'),
												A2(
													$elm$core$List$cons,
													$elm$core$String$isEmpty(optionsRecord.mm) ? $elm$html$Html$Attributes$class('') : A2($elm$html$Html$Attributes$attribute, 'aria-label', optionsRecord.mm),
													A2(
														$elm$core$List$cons,
														A2($elm$html$Html$Attributes$attribute, 'aria-controls', 'options-list'),
														_Utils_ap(
															optionsRecord.ep ? _List_fromArray(
																[
																	A2($elm$html$Html$Attributes$attribute, 'aria-disabled', 'true')
																]) : (optionsRecord.ua ? _List_fromArray(
																[
																	$elm$html$Html$Attributes$readonly(true)
																]) : _List_fromArray(
																[
																	$author$project$Ui$Dropdown$triggerKeyHandlers(toMsg),
																	$elm$html$Html$Events$onClick(
																	toMsg($author$project$Ui$Dropdown$DropdownButtonClicked))
																])),
															_Utils_ap(errorDescription, ariaInvalid))))))))))),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex justify-between items-center gap-2')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('truncate')
										]),
									A2(
										$elm$core$List$map,
										$elm$html$Html$map($elm$core$Basics$never),
										content)),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('dropdown__trigger__chevron')
										]),
									_List_fromArray(
										[
											$author$project$Ui$Icon$chevronDown(
											_List_fromArray(
												[$author$project$Ui$Icon$xs, $author$project$Ui$Icon$info]))
										]))
								]))
						])),
					(optionsRecord.ep || optionsRecord.ua) ? $elm$html$Html$text('') : A3($author$project$Ui$Dropdown$viewMenu, toMsg, model, items),
					$author$project$Utils$FormErrors$view(optionsRecord.agX)
				]));
	});
var $author$project$Components$ProviderCredentials$viewLicenseRow = F4(
	function (config, today, index, license) {
		var toStateOption = function (abbr) {
			return A2(
				$author$project$Ui$Dropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$Dropdown$onSelect(
						A2(config.B4, index, abbr)),
						$author$project$Ui$Dropdown$selected(
						_Utils_eq(
							license.uP,
							$elm$core$Maybe$Just(abbr)))
					]),
				$elm$html$Html$text(abbr));
		};
		var searchInput = $author$project$Ui$Dropdown$input(
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onInput(
					config.B3(index)),
					$author$project$Ui$Dropdown$value(license.fk),
					$author$project$Ui$Dropdown$placeholder('Search states...')
				]));
		var invalidGroup = config.jO(config.l0);
		var inputAttributes = A2(
			$elm$core$List$cons,
			$author$project$Ui$Form$Input$value(
				A2($elm$core$Maybe$withDefault, '', license.IO)),
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Form$Input$onInput(
					config.B$(index)),
				A2(
					$elm$core$List$cons,
					$author$project$Ui$Form$Input$placeholder(config.BS),
					config.Ae ? _List_fromArray(
						[
							$author$project$Ui$Form$Input$invalid(invalidGroup)
						]) : _List_Nil)));
		var contains = function (state) {
			return A2(
				$elm$core$String$contains,
				$elm$core$String$toLower(license.fk),
				$elm$core$String$toLower(state));
		};
		var filteredStates = A2($elm$core$List$filter, contains, $author$project$Utils$State$codes);
		var dropdownOptions = A2(
			$elm$core$List$cons,
			searchInput,
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Dropdown$separator,
				A2($elm$core$List$map, toStateOption, filteredStates)));
		return A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(4)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(inputAttributes)
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(3)
						]),
					_List_fromArray(
						[
							A4(
							$author$project$Ui$Dropdown$viewSelect,
							_List_fromArray(
								[
									$author$project$Ui$Dropdown$invalid(invalidGroup)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($elm$core$Maybe$withDefault, 'State', license.uP))
								]),
							dropdownOptions,
							license.fj)
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(5)
						]),
					_List_fromArray(
						[
							(index > 0) ? A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$mr2, $author$project$Ui$Element$flexAuto]),
									_List_fromArray(
										[
											$author$project$Components$ProviderCredentials$viewExpirationDateInput(
											{
												Hi: license.M.b,
												jO: invalidGroup,
												aj3: 'Expiration Date',
												al6: config.sk(index),
												FR: today,
												aee: license.M.a
											})
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$ml1]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{mm: config.DO},
											_List_fromArray(
												[
													$author$project$Ui$Button$onClick(
													config.B2(index)),
													$author$project$Ui$Button$icon($author$project$Ui$Icon$delete),
													$author$project$Ui$Button$link
												]),
											_List_Nil)
										]))
								])) : $author$project$Components$ProviderCredentials$viewExpirationDateInput(
							{
								Hi: license.M.b,
								jO: invalidGroup,
								aj3: 'Expiration Date',
								al6: config.sk(index),
								FR: today,
								aee: license.M.a
							})
						]))
				]));
	});
var $author$project$Components$ProviderCredentials$viewDeaRow = F4(
	function (form, today, index, license) {
		return A4(
			$author$project$Components$ProviderCredentials$viewLicenseRow,
			{
				sk: $author$project$Components$ProviderCredentials$MultiDeaExpirationMsg,
				jO: function (g) {
					return A2($author$project$Utils$Form$hasValidationErrors, g, form);
				},
				Ae: true,
				BS: 'AB1234567',
				B$: F2(
					function (i, v) {
						return $author$project$Components$ProviderCredentials$FormUpdated(
							A2($author$project$Components$ProviderCredentials$DeaNumberAt, i, v));
					}),
				B2: function (i) {
					return $author$project$Components$ProviderCredentials$FormUpdated(
						$author$project$Components$ProviderCredentials$RemoveDea(i));
				},
				B3: F2(
					function (i, v) {
						return $author$project$Components$ProviderCredentials$FormUpdated(
							A2($author$project$Components$ProviderCredentials$DeaStateSearchAt, i, v));
					}),
				B4: F2(
					function (i, v) {
						return $author$project$Components$ProviderCredentials$FormUpdated(
							A2($author$project$Components$ProviderCredentials$DeaStateAt, i, v));
					}),
				DO: 'Remove DEA registration',
				l0: 2
			},
			today,
			index,
			license);
	});
var $author$project$Components$ProviderCredentials$viewDeaFields = F3(
	function (form, fields, today) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(2),
					$author$project$Ui$Form$Group$inputSpanSm(10),
					$author$project$Ui$Form$Group$label('DEA Number'),
					$author$project$Ui$Form$Group$invalid(
					A2($author$project$Utils$Form$hasValidationErrors, 2, form))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						A2($author$project$Components$ProviderCredentials$viewDeaRow, form, today),
						fields.nb)),
					A2($author$project$Utils$Form$hasValidationErrors, 2, form) ? A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$danger]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$String$join,
								' ',
								A2($author$project$Utils$Form$validationErrors, 2, form)))
						])) : $author$project$Utils$Html$empty,
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mt2]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Add another DEA Number'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick(
									$author$project$Components$ProviderCredentials$FormUpdated($author$project$Components$ProviderCredentials$AddDea)),
									$author$project$Ui$Button$link
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Add another DEA number')
								]))
						]))
				]));
	});
var $author$project$Components$ProviderCredentials$Degree = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$Input$Errors = function (a) {
	return {$: 19, a: a};
};
var $author$project$Ui$Form$Input$errors = $author$project$Ui$Form$Input$Errors;
var $author$project$Ui$Typography$HelpText = {$: 8};
var $author$project$Ui$Typography$helpText = $author$project$Ui$Typography$HelpText;
var $author$project$Ui$Typography$Muted = 0;
var $author$project$Ui$Typography$muted = $author$project$Ui$Typography$Color(0);
var $author$project$Ui$Form$Group$Required = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$Group$required = $author$project$Ui$Form$Group$Required;
var $author$project$Ui$Typography$Small = {$: 6};
var $author$project$Ui$Typography$small = $author$project$Ui$Typography$Small;
var $author$project$Ui$Typography$text = F2(
	function (options, content) {
		return A2(
			$elm$html$Html$span,
			$author$project$Ui$Typography$optionsToAttributes(options),
			_List_fromArray(
				[
					$elm$html$Html$text(content)
				]));
	});
var $author$project$Components$ProviderCredentials$viewDegreeField = F2(
	function (form, fields) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(2),
					$author$project$Ui$Form$Group$inputSpanSm(10),
					$author$project$Ui$Form$Group$required(true),
					$author$project$Ui$Form$Group$label('Degree')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$value(
							A2($elm$core$Maybe$withDefault, '', fields.Hp)),
							$author$project$Ui$Form$Input$onInput(
							A2($elm$core$Basics$composeL, $author$project$Components$ProviderCredentials$FormUpdated, $author$project$Components$ProviderCredentials$Degree)),
							$author$project$Ui$Form$Input$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
							$author$project$Ui$Form$Input$errors(
							A2($author$project$Utils$Form$validationErrors, 1, form))
						])),
					A2(
					$author$project$Ui$Typography$text,
					_List_fromArray(
						[$author$project$Ui$Typography$helpText, $author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
					'This information will appear with e-signatures exactly as entered.')
				]));
	});
var $author$project$Components$ProviderCredentials$Npi = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$ProviderCredentials$viewNpiField = F2(
	function (form, fields) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(2),
					$author$project$Ui$Form$Group$inputSpanSm(10),
					$author$project$Ui$Form$Group$required(true),
					$author$project$Ui$Form$Group$label('NPI')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$value(
							A2($elm$core$Maybe$withDefault, '', fields.X0)),
							$author$project$Ui$Form$Input$placeholder('1234567890'),
							$author$project$Ui$Form$Input$onInput(
							A2($elm$core$Basics$composeL, $author$project$Components$ProviderCredentials$FormUpdated, $author$project$Components$ProviderCredentials$Npi)),
							$author$project$Ui$Form$Input$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
							$author$project$Ui$Form$Input$errors(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						]))
				]));
	});
var $author$project$Components$ProviderCredentials$AddStateLicense = {$: 14};
var $author$project$Components$ProviderCredentials$RemoveStateLicense = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$ProviderCredentials$StateLicenseNumberAt = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Components$ProviderCredentials$StateLicenseStateAt = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Components$ProviderCredentials$StateLicenseStateSearchAt = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Components$ProviderCredentials$viewStateLicenseRow = F4(
	function (form, today, index, license) {
		return A4(
			$author$project$Components$ProviderCredentials$viewLicenseRow,
			{
				sk: $author$project$Components$ProviderCredentials$StateLicenseExpirationMsg,
				jO: function (g) {
					return A2($author$project$Utils$Form$hasValidationErrors, g, form);
				},
				Ae: false,
				BS: 'A12345',
				B$: F2(
					function (i, v) {
						return $author$project$Components$ProviderCredentials$FormUpdated(
							A2($author$project$Components$ProviderCredentials$StateLicenseNumberAt, i, v));
					}),
				B2: function (i) {
					return $author$project$Components$ProviderCredentials$FormUpdated(
						$author$project$Components$ProviderCredentials$RemoveStateLicense(i));
				},
				B3: F2(
					function (i, v) {
						return $author$project$Components$ProviderCredentials$FormUpdated(
							A2($author$project$Components$ProviderCredentials$StateLicenseStateSearchAt, i, v));
					}),
				B4: F2(
					function (i, v) {
						return $author$project$Components$ProviderCredentials$FormUpdated(
							A2($author$project$Components$ProviderCredentials$StateLicenseStateAt, i, v));
					}),
				DO: 'Remove state license',
				l0: 3
			},
			today,
			index,
			license);
	});
var $author$project$Components$ProviderCredentials$viewStateLicenseFields = F3(
	function (form, fields, today) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(2),
					$author$project$Ui$Form$Group$inputSpanSm(10),
					$author$project$Ui$Form$Group$required(true),
					$author$project$Ui$Form$Group$label('State License'),
					$author$project$Ui$Form$Group$invalid(
					A2($author$project$Utils$Form$hasValidationErrors, 3, form))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						A2($author$project$Components$ProviderCredentials$viewStateLicenseRow, form, today),
						fields.qm)),
					A2($author$project$Utils$Form$hasValidationErrors, 3, form) ? A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$danger]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$String$join,
								' ',
								A2($author$project$Utils$Form$validationErrors, 3, form)))
						])) : $author$project$Utils$Html$empty,
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mt2]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Add another state license'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick(
									$author$project$Components$ProviderCredentials$FormUpdated($author$project$Components$ProviderCredentials$AddStateLicense)),
									$author$project$Ui$Button$link
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Add another state license')
								]))
						]))
				]));
	});
var $author$project$Components$ProviderCredentials$viewFields = F2(
	function (config, _v0) {
		var model = _v0;
		var fields = $author$project$Utils$Form$fields(model.SD);
		return A2(
			$elm$core$List$cons,
			A3($author$project$Components$ProviderCredentials$viewStateLicenseFields, model.SD, fields, model.FR),
			_Utils_ap(
				config.abl ? _List_fromArray(
					[
						A3($author$project$Components$ProviderCredentials$viewDeaFields, model.SD, fields, model.FR)
					]) : _List_Nil,
				_List_fromArray(
					[
						A2($author$project$Components$ProviderCredentials$viewDegreeField, model.SD, fields),
						A2($author$project$Components$ProviderCredentials$viewNpiField, model.SD, fields)
					])));
	});
var $author$project$Pages$Account$Complete$viewLayout = function (model) {
	var practiceName = $author$project$Api$Provider$Practice$One$name(model.ZV);
	var firstName = $author$project$Api$Platform$User$Shared$firstName(
		$author$project$Api$Platform$Session$One$user(model.aa4));
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$py4]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(8),
								$author$project$Ui$Grid$offset(2)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Typography$heading(
								_List_fromArray(
									[
										$elm$html$Html$text('Welcome, ' + (firstName + '.'))
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(practiceName + '\'s admin added you to the team. Add your clinical credentials so we can set up your e-prescribing features.')
									])),
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$mt4]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Card$view,
										_List_Nil,
										A2(
											$elm$core$List$map,
											$elm$html$Html$map($author$project$Pages$Account$Complete$CredentialsMsg),
											A2(
												$author$project$Components$ProviderCredentials$viewFields,
												{akP: true, abl: true},
												model.bW)))
									])),
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$mt4, $author$project$Ui$Element$justifyRight]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Complete and continue'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$disabled(model.lA),
												$author$project$Ui$Button$onClick($author$project$Pages$Account$Complete$SubmitClicked)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Complete & continue')
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Account$Complete$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				$author$project$Pages$Account$Complete$viewLayout(model)
			]),
		ac9: 'Complete your credentials'
	};
};
var $author$project$Pages$Account$Complete$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Account$Complete$init, aiq: $author$project$Pages$Account$Complete$load, k8: $author$project$Pages$Account$Complete$save, alO: $author$project$Pages$Account$Complete$subscriptions, adT: $author$project$Pages$Account$Complete$update, amo: $author$project$Pages$Account$Complete$view});
var $author$project$Pages$Admin$AdvanceBilling$GotNotificationSetting = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Utils$User$isViewingAsHinter = F2(
	function (session, hinterViewOff) {
		return A2($elm$core$Basics$composeR, $author$project$Api$Platform$Session$One$user, $author$project$Api$Platform$User$Shared$isAdmin)(session) && (!hinterViewOff);
	});
var $author$project$Shared$isHintAdmin = function (model) {
	var _v0 = model.aa4;
	if (_v0.$ === 3) {
		var session = _v0.a;
		return A2($author$project$Utils$User$isViewingAsHinter, session, model.ahK);
	} else {
		return false;
	}
};
var $author$project$Api$Provider$NotificationSetting$One$NotificationSetting = $elm$core$Basics$identity;
var $author$project$Api$Provider$NotificationSetting$Shared$NotificationSetting = $elm$core$Basics$identity;
var $author$project$Api$Provider$NotificationSetting$Shared$Record = function (id) {
	return function (shortDescriptionHtml) {
		return function (description) {
			return function (disableable) {
				return function (enabled) {
					return function (customEnabled) {
						return function (subject) {
							return function (body) {
								return function (subjectExample) {
									return function (bodyExample) {
										return function (availableLiquidVariables) {
											return function (meta) {
												return function (isTranslatable) {
													return {Mo: availableLiquidVariables, fO: body, ML: bodyExample, Pm: customEnabled, Qr: description, QC: disableable, Ro: enabled, ahP: id, Vh: isTranslatable, W4: meta, abd: shortDescriptionHtml, J_: subject, acv: subjectExample};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$HtmlTemplate$HtmlTemplate = $elm$core$Basics$identity;
var $author$project$Api$HtmlTemplate$decode = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Api$Provider$NotificationSetting$Meta$Meta = $elm$core$Basics$identity;
var $author$project$Api$Provider$NotificationSetting$Meta$MetaRecord = function (body) {
	return {fO: body};
};
var $author$project$Api$Provider$NotificationSetting$Meta$EditableRecord = function (editable) {
	return {Q4: editable};
};
var $author$project$Api$Provider$NotificationSetting$Meta$editableRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'editable',
	$elm$json$Json$Decode$bool,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$NotificationSetting$Meta$EditableRecord));
var $author$project$Api$Provider$NotificationSetting$Meta$metaRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'body',
	$author$project$Api$Provider$NotificationSetting$Meta$editableRecordDecoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$NotificationSetting$Meta$MetaRecord));
var $author$project$Api$Provider$NotificationSetting$Meta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$NotificationSetting$Meta$metaRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$NotificationSetting$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'is_translatable',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'meta',
		$author$project$Api$Provider$NotificationSetting$Meta$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'available_liquid_variables',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'body_example',
				$author$project$Api$HtmlTemplate$decode,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'subject_example',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'body',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'subject',
							$elm$json$Json$Decode$string,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'custom_enabled',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'enabled',
									$elm$json$Json$Decode$bool,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'disableable',
										$elm$json$Json$Decode$bool,
										false,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'description',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'short_description_html',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'id',
													$elm$json$Json$Decode$string,
													$elm$json$Json$Decode$succeed($author$project$Api$Provider$NotificationSetting$Shared$Record))))))))))))));
var $author$project$Api$Provider$NotificationSetting$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$NotificationSetting$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$NotificationSetting$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$NotificationSetting$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$NotificationSetting$notificationSettingsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['notification_settings']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$NotificationSetting$notificationSettingPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$NotificationSetting$notificationSettingsPath);
};
var $author$project$Api$Param$boolToString = function (bool_) {
	return A2(
		$elm$json$Json$Encode$encode,
		0,
		$elm$json$Json$Encode$bool(bool_));
};
var $author$project$Utils$Date$toQuery = function (date) {
	return A2($justinmimbs$date$Date$format, 'yyyy-MM-dd', date);
};
var $author$project$Api$Param$toQuery = function (param) {
	switch (param.$) {
		case 0:
			var key = param.a;
			var string_ = param.b;
			return _List_fromArray(
				[
					A2($elm$url$Url$Builder$string, key, string_)
				]);
		case 1:
			var key = param.a;
			var bool_ = param.b;
			return _List_fromArray(
				[
					A2(
					$elm$url$Url$Builder$string,
					key,
					$author$project$Api$Param$boolToString(bool_))
				]);
		case 2:
			var key = param.a;
			var date_ = param.b;
			return _List_fromArray(
				[
					A2(
					$elm$url$Url$Builder$string,
					key,
					$author$project$Utils$Date$toQuery(date_))
				]);
		default:
			var key = param.a;
			var list_ = param.b;
			return ($elm$core$List$length(list_) > 1) ? A2(
				$elm$core$List$map,
				function (string_) {
					return A2($elm$url$Url$Builder$string, key + '[]', string_);
				},
				list_) : A2(
				$elm$core$List$map,
				function (string_) {
					return A2($elm$url$Url$Builder$string, key, string_);
				},
				list_);
	}
};
var $author$project$Api$Data$requestWithQuery = F2(
	function (params, _v0) {
		var request = _v0;
		return _Utils_update(
			request,
			{
				DE: _Utils_ap(
					request.DE,
					A2($elm$core$List$concatMap, $author$project$Api$Param$toQuery, params))
			});
	});
var $author$project$Api$Param$String = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Param$string = $author$project$Api$Param$String;
var $author$project$Language$toValue = function (lang) {
	if (!lang) {
		return 'en';
	} else {
		return 'es';
	}
};
var $author$project$Api$Provider$NotificationSetting$retrieve = F4(
	function (apiClient, id_, maybeLanguage, toMsg) {
		var query = function () {
			if (!maybeLanguage.$) {
				var language = maybeLanguage.a;
				return _List_fromArray(
					[
						A2(
						$author$project$Api$Param$string,
						'language',
						$author$project$Language$toValue(language))
					]);
			} else {
				return _List_Nil;
			}
		}();
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$NotificationSetting$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				query,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$NotificationSetting$notificationSettingPath(id_))));
	});
var $author$project$Pages$Admin$AdvanceBilling$init = F4(
	function (_v0, practice, shared, _v1) {
		var notificationSettingIds = _List_fromArray(
			['patient_upcoming_monthly_autopay_invoice_generated', 'patient_upcoming_non_monthly_autopay_invoice_generated', 'patient_upcoming_monthly_non_autopay_invoice_generated', 'patient_upcoming_non_monthly_non_autopay_invoice_generated']);
		return _Utils_Tuple2(
			{
				Gv: shared.Gv,
				C: $elm$core$Maybe$Nothing,
				Ij: $author$project$Shared$isHintAdmin(shared),
				bI: $elm$core$Dict$empty,
				ZV: practice
			},
			$elm$core$Platform$Cmd$batch(
				A2(
					$elm$core$List$map,
					function (id) {
						return A4(
							$author$project$Api$Provider$NotificationSetting$retrieve,
							shared.Gv,
							id,
							$elm$core$Maybe$Nothing,
							$author$project$Pages$Admin$AdvanceBilling$GotNotificationSetting(id));
					},
					notificationSettingIds)));
	});
var $author$project$Pages$Admin$AdvanceBilling$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					Ij: $author$project$Shared$isHintAdmin(shared)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$AdvanceBilling$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$AdvanceBilling$CancelEdit = {$: 1};
var $author$project$Pages$Admin$AdvanceBilling$CustomizeNotificationMsg = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $elm$core$Platform$Sub$map = _Platform_map;
var $author$project$Ui$Modal$decodePressedKey = function (closeMsg) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (key) {
			return (key === 'Escape') ? $elm$json$Json$Decode$succeed(closeMsg) : $elm$json$Json$Decode$fail('ignore');
		},
		A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
};
var $elm$browser$Browser$Events$Document = 0;
var $elm$browser$Browser$Events$MySub = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$browser$Browser$Events$State = F2(
	function (subs, pids) {
		return {ZB: pids, acx: subs};
	});
var $elm$browser$Browser$Events$init = $elm$core$Task$succeed(
	A2($elm$browser$Browser$Events$State, _List_Nil, $elm$core$Dict$empty));
var $elm$browser$Browser$Events$nodeToKey = function (node) {
	if (!node) {
		return 'd_';
	} else {
		return 'w_';
	}
};
var $elm$browser$Browser$Events$addKey = function (sub) {
	var node = sub.a;
	var name = sub.b;
	return _Utils_Tuple2(
		_Utils_ap(
			$elm$browser$Browser$Events$nodeToKey(node),
			name),
		sub);
};
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$browser$Browser$Events$Event = F2(
	function (key, event) {
		return {agZ: event, At: key};
	});
var $elm$browser$Browser$Events$spawn = F3(
	function (router, key, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var actualNode = function () {
			if (!node) {
				return _Browser_doc;
			} else {
				return _Browser_window;
			}
		}();
		return A2(
			$elm$core$Task$map,
			function (value) {
				return _Utils_Tuple2(key, value);
			},
			A3(
				_Browser_on,
				actualNode,
				name,
				function (event) {
					return A2(
						$elm$core$Platform$sendToSelf,
						router,
						A2($elm$browser$Browser$Events$Event, key, event));
				}));
	});
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $elm$browser$Browser$Events$onEffects = F3(
	function (router, subs, state) {
		var stepRight = F3(
			function (key, sub, _v6) {
				var deads = _v6.a;
				var lives = _v6.b;
				var news = _v6.c;
				return _Utils_Tuple3(
					deads,
					lives,
					A2(
						$elm$core$List$cons,
						A3($elm$browser$Browser$Events$spawn, router, key, sub),
						news));
			});
		var stepLeft = F3(
			function (_v4, pid, _v5) {
				var deads = _v5.a;
				var lives = _v5.b;
				var news = _v5.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, pid, deads),
					lives,
					news);
			});
		var stepBoth = F4(
			function (key, pid, _v2, _v3) {
				var deads = _v3.a;
				var lives = _v3.b;
				var news = _v3.c;
				return _Utils_Tuple3(
					deads,
					A3($elm$core$Dict$insert, key, pid, lives),
					news);
			});
		var newSubs = A2($elm$core$List$map, $elm$browser$Browser$Events$addKey, subs);
		var _v0 = A6(
			$elm$core$Dict$merge,
			stepLeft,
			stepBoth,
			stepRight,
			state.ZB,
			$elm$core$Dict$fromList(newSubs),
			_Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
		var deadPids = _v0.a;
		var livePids = _v0.b;
		var makeNewPids = _v0.c;
		return A2(
			$elm$core$Task$andThen,
			function (pids) {
				return $elm$core$Task$succeed(
					A2(
						$elm$browser$Browser$Events$State,
						newSubs,
						A2(
							$elm$core$Dict$union,
							livePids,
							$elm$core$Dict$fromList(pids))));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$sequence(makeNewPids);
				},
				$elm$core$Task$sequence(
					A2($elm$core$List$map, $elm$core$Process$kill, deadPids))));
	});
var $elm$browser$Browser$Events$onSelfMsg = F3(
	function (router, _v0, state) {
		var key = _v0.At;
		var event = _v0.agZ;
		var toMessage = function (_v2) {
			var subKey = _v2.a;
			var _v3 = _v2.b;
			var node = _v3.a;
			var name = _v3.b;
			var decoder = _v3.c;
			return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : $elm$core$Maybe$Nothing;
		};
		var messages = A2($elm$core$List$filterMap, toMessage, state.acx);
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Platform$sendToApp(router),
					messages)));
	});
var $elm$browser$Browser$Events$subMap = F2(
	function (func, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var decoder = _v0.c;
		return A3(
			$elm$browser$Browser$Events$MySub,
			node,
			name,
			A2($elm$json$Json$Decode$map, func, decoder));
	});
_Platform_effectManagers['Browser.Events'] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
var $elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
var $elm$browser$Browser$Events$on = F3(
	function (node, name, decoder) {
		return $elm$browser$Browser$Events$subscription(
			A3($elm$browser$Browser$Events$MySub, node, name, decoder));
	});
var $elm$browser$Browser$Events$onKeyDown = A2($elm$browser$Browser$Events$on, 0, 'keydown');
var $author$project$Ui$Modal$subscribeToEscapeKeyPress = function (closeMsg) {
	return $elm$browser$Browser$Events$onKeyDown(
		$author$project$Ui$Modal$decodePressedKey(closeMsg));
};
var $author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress = $author$project$Ui$Modal$subscribeToEscapeKeyPress;
var $author$project$Components$Admin$NotificationSetting$Customize$Body = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$NotificationSetting$Customize$Close = {$: 1};
var $author$project$Components$Admin$NotificationSetting$Customize$Ignore = {$: 14};
var $author$project$Components$Admin$NotificationSetting$Customize$NotificationSettingFormFieldUpdated = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Provider$NotificationSetting$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Components$Admin$NotificationSetting$Customize$notificationBodyEditorId = function (notificationSetting) {
	return 'notification-editor' + $author$project$Api$Provider$NotificationSetting$Shared$id(notificationSetting);
};
var $author$project$Ports$CKEditor$ckEditorOnChangePort = _Platform_incomingPort(
	'ckEditorOnChangePort',
	A2(
		$elm$json$Json$Decode$andThen,
		function (_v0) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (_v1) {
					return $elm$json$Json$Decode$succeed(
						_Utils_Tuple2(_v0, _v1));
				},
				A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string)));
var $author$project$Ports$CKEditor$onChange = function (toMsg) {
	return $author$project$Ports$CKEditor$ckEditorOnChangePort(
		function (_v0) {
			var elementId = _v0.a;
			var value = _v0.b;
			return A2(toMsg, elementId, value);
		});
};
var $author$project$Ui$Dropdown$BlurredOut = function (a) {
	return {$: 12, a: a};
};
var $author$project$Ui$Dropdown$EscapeKeyPressed = {$: 4};
var $author$project$Ports$Dropdown$onDropdownBlur = _Platform_incomingPort('onDropdownBlur', $elm$json$Json$Decode$string);
var $author$project$Ports$Dropdown$onBlur = $author$project$Ports$Dropdown$onDropdownBlur;
var $author$project$Ports$Dropdown$onDropdownEscapeKeyPressed = _Platform_incomingPort('onDropdownEscapeKeyPressed', $elm$json$Json$Decode$string);
var $author$project$Ports$Dropdown$onEscapeKeyPressed = function (msg) {
	return $author$project$Ports$Dropdown$onDropdownEscapeKeyPressed(
		$elm$core$Basics$always(msg));
};
var $author$project$Ui$Dropdown$subscriptions = function (model) {
	return model.Yn ? $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				model.al6,
				$author$project$Ports$Dropdown$onEscapeKeyPressed($author$project$Ui$Dropdown$EscapeKeyPressed)),
				A2(
				$elm$core$Platform$Sub$map,
				model.al6,
				$author$project$Ports$Dropdown$onBlur($author$project$Ui$Dropdown$BlurredOut))
			])) : $elm$core$Platform$Sub$none;
};
var $author$project$Components$Admin$NotificationSetting$Customize$subscriptions = function (model) {
	if (model.Yn) {
		var notificationBodyEditorId_ = $author$project$Components$Admin$NotificationSetting$Customize$notificationBodyEditorId(model.X_);
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					$author$project$Ports$CKEditor$onChange(
					F2(
						function (elementId, value) {
							return _Utils_eq(elementId, notificationBodyEditorId_) ? A2($elm$core$Basics$composeL, $author$project$Components$Admin$NotificationSetting$Customize$NotificationSettingFormFieldUpdated, $author$project$Components$Admin$NotificationSetting$Customize$Body)(value) : $author$project$Components$Admin$NotificationSetting$Customize$Ignore;
						})),
					function () {
					var _v0 = A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.Yn;
						},
						model.gi);
					if ((!_v0.$) && _v0.a) {
						return $elm$core$Platform$Sub$none;
					} else {
						return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$NotificationSetting$Customize$Close);
					}
				}(),
					A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Ui$Dropdown$subscriptions, model.gi))
				]));
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $author$project$Pages$Admin$AdvanceBilling$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$elm$core$Platform$Sub$batch(
				A2(
					$elm$core$List$map,
					function (_v0) {
						var setting = _v0.a;
						var customize = _v0.b;
						return A2(
							$elm$core$Platform$Sub$map,
							$author$project$Pages$Admin$AdvanceBilling$CustomizeNotificationMsg(setting),
							$author$project$Components$Admin$NotificationSetting$Customize$subscriptions(customize));
					},
					$elm$core$Dict$values(model.bI))),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Admin$AdvanceBilling$CancelEdit)),
					model.C))
			]));
};
var $author$project$Api$Provider$Notification$PracticeContext = {$: 0};
var $author$project$OutMsg$PracticeUpdated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$AdvanceBilling$ToggleNotificationMsg = F3(
	function (a, b, c) {
		return {$: 7, a: a, b: b, c: c};
	});
var $author$project$Api$Provider$Practice$One$one = function (_v0) {
	var record = _v0.b;
	return record;
};
var $author$project$Api$Provider$Practice$One$billMonthlyAutopayInAdvanceInDays = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.afc;
	});
var $author$project$Api$Provider$Practice$One$billMonthlyNonAutopayInAdvanceInDays = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.afd;
	});
var $author$project$Api$Provider$Practice$One$billNonMonthlyAutopayInAdvanceInDays = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.afe;
	});
var $author$project$Api$Provider$Practice$One$billNonMonthlyNonAutopayInAdvanceInDays = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.aff;
	});
var $author$project$Api$Provider$Practice$One$scheduleMonthlyPaymentInAdvanceInDays = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.ala;
	});
var $author$project$Api$Provider$Practice$One$scheduleNonMonthlyPaymentInAdvanceInDays = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.alb;
	});
var $author$project$Pages$Admin$AdvanceBilling$formFieldsInit = F3(
	function (type_, frequency, practice) {
		return {
			afc: $elm$core$Maybe$Just(
				$author$project$Api$Provider$Practice$One$billMonthlyAutopayInAdvanceInDays(practice)),
			afd: $elm$core$Maybe$Just(
				$author$project$Api$Provider$Practice$One$billMonthlyNonAutopayInAdvanceInDays(practice)),
			afe: $elm$core$Maybe$Just(
				$author$project$Api$Provider$Practice$One$billNonMonthlyAutopayInAdvanceInDays(practice)),
			aff: $elm$core$Maybe$Just(
				$author$project$Api$Provider$Practice$One$billNonMonthlyNonAutopayInAdvanceInDays(practice)),
			sr: frequency,
			ala: $elm$core$Maybe$Just(
				$author$project$Api$Provider$Practice$One$scheduleMonthlyPaymentInAdvanceInDays(practice)),
			alb: $elm$core$Maybe$Just(
				$author$project$Api$Provider$Practice$One$scheduleNonMonthlyPaymentInAdvanceInDays(practice)),
			amg: type_
		};
	});
var $author$project$Pages$Admin$AdvanceBilling$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						afc: $elm$core$String$toInt(string)
					});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						afe: $elm$core$String$toInt(string)
					});
			case 2:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						afd: $elm$core$String$toInt(string)
					});
			case 3:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						aff: $elm$core$String$toInt(string)
					});
			case 4:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						ala: $elm$core$String$toInt(string)
					});
			default:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						alb: $elm$core$String$toInt(string)
					});
		}
	});
var $author$project$Pages$Admin$AdvanceBilling$BillMonthlyAutopayInAdvanceInDaysValidation = 0;
var $author$project$Pages$Admin$AdvanceBilling$BillNonMonthlyAutopayInAdvanceInDaysValidation = 1;
var $author$project$Pages$Admin$AdvanceBilling$ScheduleMonthlyPaymentInAdvanceInDaysValidation = 2;
var $author$project$Pages$Admin$AdvanceBilling$ScheduleNonMonthlyPaymentInAdvanceInDaysValidation = 3;
var $author$project$Pages$Admin$AdvanceBilling$validateNumberOfDays = F2(
	function (days, vaildationGroup) {
		if (!days.$) {
			var _int = days.a;
			return (_int < 0) ? _List_fromArray(
				[
					_Utils_Tuple2(vaildationGroup, 'Please enter a number greater or equal to 0')
				]) : ((_int > 90) ? _List_fromArray(
				[
					_Utils_Tuple2(vaildationGroup, 'Please enter a number lower or equal to 90')
				]) : _List_Nil);
		} else {
			return _List_fromArray(
				[
					_Utils_Tuple2(vaildationGroup, 'Please enter a number')
				]);
		}
	});
var $author$project$Pages$Admin$AdvanceBilling$validateSchedulePaymentInAdvance = F3(
	function (createDays, scheduleDays, validationGroup) {
		var _v0 = _Utils_Tuple2(createDays, scheduleDays);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var createDays_ = _v0.a.a;
			var scheduleDays_ = _v0.b.a;
			return (_Utils_cmp(createDays_, scheduleDays_) < 1) ? _List_fromArray(
				[
					_Utils_Tuple2(validationGroup, 'The number of days in create & notify needs to be greater than schedule payment in advance.')
				]) : _List_Nil;
		} else {
			return _List_Nil;
		}
	});
var $author$project$Pages$Admin$AdvanceBilling$validateAutopay = function (fields) {
	var _v0 = fields.sr;
	if (!_v0) {
		return $elm$core$List$concat(
			_List_fromArray(
				[
					A2($author$project$Pages$Admin$AdvanceBilling$validateNumberOfDays, fields.afc, 0),
					A2($author$project$Pages$Admin$AdvanceBilling$validateNumberOfDays, fields.ala, 2),
					A3($author$project$Pages$Admin$AdvanceBilling$validateSchedulePaymentInAdvance, fields.afc, fields.ala, 2)
				]));
	} else {
		return $elm$core$List$concat(
			_List_fromArray(
				[
					A2($author$project$Pages$Admin$AdvanceBilling$validateNumberOfDays, fields.afe, 1),
					A2($author$project$Pages$Admin$AdvanceBilling$validateNumberOfDays, fields.alb, 3),
					A3($author$project$Pages$Admin$AdvanceBilling$validateSchedulePaymentInAdvance, fields.afe, fields.alb, 3)
				]));
	}
};
var $author$project$Pages$Admin$AdvanceBilling$BillMonthlyNonAutopayInAdvanceInDaysValidation = 4;
var $author$project$Pages$Admin$AdvanceBilling$BillNonMonthlyNonAutopayInAdvanceInDaysValidation = 5;
var $author$project$Pages$Admin$AdvanceBilling$validateNonAutopay = function (fields) {
	var _v0 = fields.sr;
	if (!_v0) {
		return A2($author$project$Pages$Admin$AdvanceBilling$validateNumberOfDays, fields.afd, 4);
	} else {
		return A2($author$project$Pages$Admin$AdvanceBilling$validateNumberOfDays, fields.aff, 5);
	}
};
var $author$project$Pages$Admin$AdvanceBilling$validateAdvanceBilling = function (fields) {
	var _v0 = fields.amg;
	if (!_v0) {
		return $author$project$Pages$Admin$AdvanceBilling$validateAutopay(fields);
	} else {
		return $author$project$Pages$Admin$AdvanceBilling$validateNonAutopay(fields);
	}
};
var $author$project$Pages$Admin$AdvanceBilling$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Admin$AdvanceBilling$validateAdvanceBilling)
		]));
var $author$project$Api$Provider$NotificationSetting$One$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$NotificationSetting$Shared$id(shared);
};
var $author$project$Components$Admin$NotificationSetting$Toggle$Model = $elm$core$Basics$identity;
var $author$project$Components$Admin$NotificationSetting$Toggle$init = F2(
	function (getters, notificationSetting) {
		return {
			Ro: getters.Ro(notificationSetting),
			zL: getters,
			X_: notificationSetting,
			uf: $author$project$Api$Data$NotAsked
		};
	});
var $author$project$Language$EN = 0;
var $author$project$Language$english = 0;
var $author$project$Api$Provider$NotificationSetting$Shared$body = function (_v0) {
	var record = _v0;
	return record.fO;
};
var $author$project$Api$Provider$NotificationSetting$Shared$subject = function (_v0) {
	var record = _v0;
	return record.J_;
};
var $author$project$Components$Admin$NotificationSetting$Customize$initFormFields = function (notificationSetting) {
	return {
		fO: $author$project$Api$Provider$NotificationSetting$Shared$body(notificationSetting),
		J_: $author$project$Api$Provider$NotificationSetting$Shared$subject(notificationSetting)
	};
};
var $author$project$Components$Admin$NotificationSetting$Customize$init = F2(
	function (notificationSetting, context) {
		return {
			a3: context,
			gi: $elm$core$Maybe$Nothing,
			SD: $author$project$Utils$Form$init(
				$author$project$Components$Admin$NotificationSetting$Customize$initFormFields(notificationSetting)),
			Ay: $author$project$Language$english,
			tc: false,
			X_: notificationSetting,
			Yn: false,
			akd: $author$project$Api$Data$NotAsked,
			pR: false,
			p9: false,
			lK: $author$project$Api$Data$NotAsked,
			adD: $elm$core$Dict$empty,
			F1: false
		};
	});
var $author$project$Api$Provider$NotificationSetting$One$toShared = function (_v0) {
	var shared = _v0;
	return shared;
};
var $author$project$Components$Admin$NotificationSetting$Customize$initFromOne = function (notificationSettingOne) {
	return A2(
		$author$project$Components$Admin$NotificationSetting$Customize$init,
		$author$project$Api$Provider$NotificationSetting$One$toShared(notificationSettingOne),
		$author$project$Api$Provider$Notification$PracticeContext);
};
var $author$project$Api$Provider$NotificationSetting$Shared$disableable = function (_v0) {
	var record = _v0;
	return record.QC;
};
var $author$project$Api$Provider$NotificationSetting$One$disableable = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$NotificationSetting$Shared$disableable(shared);
};
var $author$project$Api$Provider$NotificationSetting$Shared$enabled = function (_v0) {
	var record = _v0;
	return record.Ro;
};
var $author$project$Api$Provider$NotificationSetting$One$enabled = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$NotificationSetting$Shared$enabled(shared);
};
var $author$project$Components$Admin$NotificationSetting$Toggle$oneGetters = {QC: $author$project$Api$Provider$NotificationSetting$One$disableable, Ro: $author$project$Api$Provider$NotificationSetting$One$enabled, ahP: $author$project$Api$Provider$NotificationSetting$One$id};
var $author$project$Components$Admin$NotificationSetting$Customize$GotNotificationSetting = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Components$Admin$NotificationSetting$Customize$LanguageDropdownMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Admin$NotificationSetting$Customize$None = 0;
var $author$project$Components$Admin$NotificationSetting$Customize$NotificationSettingUpdated = 1;
var $author$project$Api$Provider$NotificationSetting$Shared$availableLiquidVariables = function (_v0) {
	var record = _v0;
	return record.Mo;
};
var $author$project$Ports$CKEditor$ckEditorSetDataPort = _Platform_outgoingPort(
	'ckEditorSetDataPort',
	function ($) {
		var a = $.a;
		var b = $.b;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$json$Json$Encode$string(a),
					$elm$json$Json$Encode$string(b)
				]));
	});
var $author$project$Ports$CKEditor$setData = F2(
	function (elementId, value) {
		return $author$project$Ports$CKEditor$ckEditorSetDataPort(
			_Utils_Tuple2(elementId, value));
	});
var $author$project$Components$Admin$NotificationSetting$Customize$initForm = function (setting) {
	var body = $author$project$Api$Provider$NotificationSetting$Shared$body(setting);
	return _Utils_Tuple2(
		$author$project$Utils$Form$init(
			{
				fO: body,
				J_: $author$project$Api$Provider$NotificationSetting$Shared$subject(setting)
			}),
		A2(
			$author$project$Ports$CKEditor$setData,
			$author$project$Components$Admin$NotificationSetting$Customize$notificationBodyEditorId(setting),
			body));
};
var $author$project$Api$Provider$NotificationSetting$Shared$isTranslatable = function (_v0) {
	var record = _v0;
	return record.Vh;
};
var $author$project$Api$Data$map = F2(
	function (func, dataList) {
		switch (dataList.$) {
			case 3:
				var value = dataList.a;
				var headers = dataList.b;
				return A2(
					$author$project$Api$Data$Success,
					func(value),
					headers);
			case 0:
				return $author$project$Api$Data$NotAsked;
			case 1:
				return $author$project$Api$Data$Loading;
			default:
				var error = dataList.a;
				return $author$project$Api$Data$Failure(error);
		}
	});
var $author$project$Components$Admin$NotificationSetting$Customize$notificationSettingFormFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var string = field.a;
			return _Utils_update(
				fields,
				{J_: string});
		} else {
			var string = field.a;
			return _Utils_update(
				fields,
				{fO: string});
		}
	});
var $author$project$Components$Admin$NotificationSetting$Customize$notificationSettingFormFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_Nil);
var $author$project$Components$Admin$NotificationSetting$Customize$GotPreview = function (a) {
	return {$: 7, a: a};
};
var $rtfeldman$elm_validate$Validate$fromValid = function (_v0) {
	var subject = _v0;
	return subject;
};
var $author$project$Api$Provider$NotificationSettingPreview$NotificationSettingPreview = $elm$core$Basics$identity;
var $author$project$Api$Provider$NotificationSettingPreview$Record = F2(
	function (subject, body) {
		return {fO: body, J_: subject};
	});
var $author$project$Api$Provider$NotificationSettingPreview$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'body',
	$author$project$Api$HtmlTemplate$decode,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'subject',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$NotificationSettingPreview$Record)));
var $author$project$Api$Provider$NotificationSettingPreview$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$NotificationSettingPreview$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Company$companiesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['companies']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Company$companyPath = function (companyId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[companyId]),
		$author$project$Api$Provider$Company$companiesPath);
};
var $author$project$Api$Provider$Company$NotificationSetting$notificationSettingsPath = function (companyId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['notification_settings']),
		$author$project$Api$Provider$Company$companyPath(companyId));
};
var $author$project$Api$Provider$Company$NotificationSetting$notificationSettingPath = F2(
	function (companyId, id_) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id_]),
			$author$project$Api$Provider$Company$NotificationSetting$notificationSettingsPath(companyId));
	});
var $author$project$Api$Provider$Company$NotificationSetting$preview = F5(
	function (apiClient, companyId, id_, fields, toMsg) {
		var body_ = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'notification_setting',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$filterMap,
							$elm$core$Basics$identity,
							_List_fromArray(
								[
									A2(
									$elm$core$Maybe$map,
									function (subject) {
										return _Utils_Tuple2(
											'subject',
											$elm$json$Json$Encode$string(subject));
									},
									fields.J_),
									A2(
									$elm$core$Maybe$map,
									function (body) {
										return _Utils_Tuple2(
											'body',
											$elm$json$Json$Encode$string(body));
									},
									fields.fO)
								])))),
					_Utils_Tuple2(
					'language',
					$elm$json$Json$Encode$string(
						$author$project$Language$toValue(fields.Ay)))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$NotificationSettingPreview$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body_,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['preview']),
						A2($author$project$Api$Provider$Company$NotificationSetting$notificationSettingPath, companyId, id_)))));
	});
var $author$project$Api$Provider$NotificationSetting$preview = F4(
	function (apiClient, id_, fields, toMsg) {
		var body_ = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'notification_setting',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$filterMap,
							$elm$core$Basics$identity,
							_List_fromArray(
								[
									A2(
									$elm$core$Maybe$map,
									function (subject) {
										return _Utils_Tuple2(
											'subject',
											$elm$json$Json$Encode$string(subject));
									},
									fields.J_),
									A2(
									$elm$core$Maybe$map,
									function (body) {
										return _Utils_Tuple2(
											'body',
											$elm$json$Json$Encode$string(body));
									},
									fields.fO)
								])))),
					_Utils_Tuple2(
					'language',
					$elm$json$Json$Encode$string(
						$author$project$Language$toValue(fields.Ay)))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$NotificationSettingPreview$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body_,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['preview']),
						$author$project$Api$Provider$NotificationSetting$notificationSettingPath(id_)))));
	});
var $author$project$Components$Admin$NotificationSetting$Customize$previewNotificationSetting = F3(
	function (apiClient, formFields, _v0) {
		var context = _v0.a3;
		var language = _v0.Ay;
		var notificationSetting = _v0.X_;
		var _v1 = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var subject = _v1.J_;
		var body = _v1.fO;
		if (context.$ === 1) {
			var id = context.a;
			return A5(
				$author$project$Api$Provider$Company$NotificationSetting$preview,
				apiClient,
				id,
				$author$project$Api$Provider$NotificationSetting$Shared$id(notificationSetting),
				{
					fO: $elm$core$Maybe$Just(body),
					Ay: language,
					J_: $elm$core$Maybe$Just(subject)
				},
				$author$project$Components$Admin$NotificationSetting$Customize$GotPreview);
		} else {
			return A4(
				$author$project$Api$Provider$NotificationSetting$preview,
				apiClient,
				$author$project$Api$Provider$NotificationSetting$Shared$id(notificationSetting),
				{
					fO: $elm$core$Maybe$Just(body),
					Ay: language,
					J_: $elm$core$Maybe$Just(subject)
				},
				$author$project$Components$Admin$NotificationSetting$Customize$GotPreview);
		}
	});
var $elm$core$Maybe$destruct = F3(
	function (_default, func, maybe) {
		if (!maybe.$) {
			var a = maybe.a;
			return func(a);
		} else {
			return _default;
		}
	});
var $author$project$Ports$CKEditor$ckEditorReplacePort = _Platform_outgoingPort(
	'ckEditorReplacePort',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'autocompleteOptions',
					$elm$json$Json$Encode$list($elm$json$Json$Encode$string)($.Ml)),
					_Utils_Tuple2(
					'elementId',
					$elm$json$Json$Encode$string($.Re)),
					_Utils_Tuple2(
					'placeholder',
					function ($) {
						return A3($elm$core$Maybe$destruct, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string, $);
					}($.aj3)),
					_Utils_Tuple2(
					'value',
					$elm$json$Json$Encode$string($.aee))
				]));
	});
var $author$project$Ports$CKEditor$replace = F4(
	function (elementId, value, autocompleteOptions, placeholder) {
		return $author$project$Ports$CKEditor$ckEditorReplacePort(
			{Ml: autocompleteOptions, Re: elementId, aj3: placeholder, aee: value});
	});
var $author$project$Components$Admin$NotificationSetting$Customize$GotReset = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$Company$NotificationSetting$reset = F5(
	function (apiClient, companyId, id_, _v0, toMsg) {
		var language = _v0.Ay;
		var body_ = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'language',
					$elm$json$Json$Encode$string(
						$author$project$Language$toValue(language)))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$NotificationSetting$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body_,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['reset']),
						A2($author$project$Api$Provider$Company$NotificationSetting$notificationSettingPath, companyId, id_)))));
	});
var $author$project$Api$Provider$NotificationSetting$reset = F4(
	function (apiClient, id_, _v0, toMsg) {
		var language = _v0.Ay;
		var body_ = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'language',
					$elm$json$Json$Encode$string(
						$author$project$Language$toValue(language)))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$NotificationSetting$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body_,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['reset']),
						$author$project$Api$Provider$NotificationSetting$notificationSettingPath(id_)))));
	});
var $author$project$Components$Admin$NotificationSetting$Customize$resetNotificationSetting = F2(
	function (apiClient, _v0) {
		var context = _v0.a3;
		var language = _v0.Ay;
		var notificationSetting = _v0.X_;
		if (context.$ === 1) {
			var id = context.a;
			return A5(
				$author$project$Api$Provider$Company$NotificationSetting$reset,
				apiClient,
				id,
				$author$project$Api$Provider$NotificationSetting$Shared$id(notificationSetting),
				{Ay: language},
				$author$project$Components$Admin$NotificationSetting$Customize$GotReset);
		} else {
			return A4(
				$author$project$Api$Provider$NotificationSetting$reset,
				apiClient,
				$author$project$Api$Provider$NotificationSetting$Shared$id(notificationSetting),
				{Ay: language},
				$author$project$Components$Admin$NotificationSetting$Customize$GotReset);
		}
	});
var $author$project$Components$Admin$NotificationSetting$Customize$GotTest = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Data$EmptyBody = 0;
var $author$project$Api$Data$emptyBodyDecoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Provider$Company$NotificationSetting$test = F5(
	function (apiClient, companyId, id_, fields, toMsg) {
		var body_ = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'notification_setting',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'subject',
								$elm$json$Json$Encode$string(fields.J_)),
								_Utils_Tuple2(
								'body',
								$elm$json$Json$Encode$string(fields.fO))
							]))),
					_Utils_Tuple2(
					'language',
					$elm$json$Json$Encode$string(
						$author$project$Language$toValue(fields.Ay)))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body_,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['test']),
						A2($author$project$Api$Provider$Company$NotificationSetting$notificationSettingPath, companyId, id_)))));
	});
var $author$project$Api$Provider$NotificationSetting$test = F4(
	function (apiClient, id_, fields, toMsg) {
		var body_ = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'notification_setting',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'subject',
								$elm$json$Json$Encode$string(fields.J_)),
								_Utils_Tuple2(
								'body',
								$elm$json$Json$Encode$string(fields.fO))
							]))),
					_Utils_Tuple2(
					'language',
					$elm$json$Json$Encode$string(
						$author$project$Language$toValue(fields.Ay)))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body_,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['test']),
						$author$project$Api$Provider$NotificationSetting$notificationSettingPath(id_)))));
	});
var $author$project$Components$Admin$NotificationSetting$Customize$testNotificationSetting = F3(
	function (apiClient, formFields, _v0) {
		var context = _v0.a3;
		var notificationSetting = _v0.X_;
		var language = _v0.Ay;
		var _v1 = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var subject = _v1.J_;
		var body = _v1.fO;
		if (context.$ === 1) {
			var id = context.a;
			return A5(
				$author$project$Api$Provider$Company$NotificationSetting$test,
				apiClient,
				id,
				$author$project$Api$Provider$NotificationSetting$Shared$id(notificationSetting),
				{fO: body, Ay: language, J_: subject},
				$author$project$Components$Admin$NotificationSetting$Customize$GotTest);
		} else {
			return A4(
				$author$project$Api$Provider$NotificationSetting$test,
				apiClient,
				$author$project$Api$Provider$NotificationSetting$Shared$id(notificationSetting),
				{fO: body, Ay: language, J_: subject},
				$author$project$Components$Admin$NotificationSetting$Customize$GotTest);
		}
	});
var $author$project$Api$Data$toMaybe = function (data) {
	if (data.$ === 3) {
		var value = data.a;
		return $elm$core$Maybe$Just(value);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Admin$NotificationSetting$Customize$SavedNotificationSetting = function (a) {
	return {$: 11, a: a};
};
var $author$project$Api$Provider$Company$NotificationSetting$update = F5(
	function (apiClient, companyId, id_, fields, toMsg) {
		var body_ = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'notification_setting',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'subject',
								$elm$json$Json$Encode$string(fields.J_)),
								_Utils_Tuple2(
								'body',
								$elm$json$Json$Encode$string(fields.fO))
							]))),
					_Utils_Tuple2(
					'language',
					$elm$json$Json$Encode$string(
						$author$project$Language$toValue(fields.Ay)))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$NotificationSetting$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body_,
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Provider$Company$NotificationSetting$notificationSettingPath, companyId, id_))));
	});
var $author$project$Api$Provider$NotificationSetting$update = F4(
	function (apiClient, id_, fields, toMsg) {
		var body_ = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'notification_setting',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'subject',
								$elm$json$Json$Encode$string(fields.J_)),
								_Utils_Tuple2(
								'body',
								$elm$json$Json$Encode$string(fields.fO))
							]))),
					_Utils_Tuple2(
					'language',
					$elm$json$Json$Encode$string(
						$author$project$Language$toValue(fields.Ay)))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$NotificationSetting$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body_,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$NotificationSetting$notificationSettingPath(id_))));
	});
var $author$project$Components$Admin$NotificationSetting$Customize$updateNotificationSetting = F2(
	function (apiClient, _v0) {
		var context = _v0.a3;
		var language = _v0.Ay;
		var notificationSetting = _v0.X_;
		var form = _v0.SD;
		var _v1 = $author$project$Utils$Form$fields(form);
		var subject = _v1.J_;
		var body = _v1.fO;
		if (context.$ === 1) {
			var id = context.a;
			return A5(
				$author$project$Api$Provider$Company$NotificationSetting$update,
				apiClient,
				id,
				$author$project$Api$Provider$NotificationSetting$Shared$id(notificationSetting),
				{fO: body, Ay: language, J_: subject},
				$author$project$Components$Admin$NotificationSetting$Customize$SavedNotificationSetting);
		} else {
			return A4(
				$author$project$Api$Provider$NotificationSetting$update,
				apiClient,
				$author$project$Api$Provider$NotificationSetting$Shared$id(notificationSetting),
				{fO: body, Ay: language, J_: subject},
				$author$project$Components$Admin$NotificationSetting$Customize$SavedNotificationSetting);
		}
	});
var $author$project$Components$Admin$NotificationSetting$Customize$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 14:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
			case 15:
				var dropdownMsg = msg.a;
				var _v1 = model.gi;
				if (!_v1.$) {
					var dropdown = _v1.a;
					var _v2 = A2($author$project$Ui$Dropdown$update, dropdownMsg, dropdown);
					var newDropdown = _v2.a;
					var dropdownCmd = _v2.b;
					var newModel = _Utils_update(
						model,
						{
							gi: $elm$core$Maybe$Just(newDropdown)
						});
					return {GZ: dropdownCmd, agZ: 0, aiO: newModel, aR: _List_Nil};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
			case 0:
				var dropdown = (model.tc && $author$project$Api$Provider$NotificationSetting$Shared$isTranslatable(model.X_)) ? $elm$core$Maybe$Just(
					$author$project$Ui$Dropdown$init(
						$author$project$Ui$Dropdown$defaultConfig(
							{ahP: 'customize-language-dropdown', al6: $author$project$Components$Admin$NotificationSetting$Customize$LanguageDropdownMsg}))) : $elm$core$Maybe$Nothing;
				var _v3 = $author$project$Components$Admin$NotificationSetting$Customize$initForm(model.X_);
				var form = _v3.a;
				return {
					GZ: A4(
						$author$project$Ports$CKEditor$replace,
						$author$project$Components$Admin$NotificationSetting$Customize$notificationBodyEditorId(model.X_),
						$author$project$Api$Provider$NotificationSetting$Shared$body(model.X_),
						$author$project$Api$Provider$NotificationSetting$Shared$availableLiquidVariables(model.X_),
						$elm$core$Maybe$Nothing),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{gi: dropdown, SD: form, Ay: $author$project$Language$english, Yn: true}),
					aR: _List_Nil
				};
			case 1:
				return function (closedModel) {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: closedModel, aR: _List_Nil};
				}(
					_Utils_update(
						model,
						{Yn: false, akd: $author$project$Api$Data$NotAsked}));
			case 2:
				var _v4 = A2($author$project$Utils$Form$validate, $author$project$Components$Admin$NotificationSetting$Customize$notificationSettingFormFieldsValidator, model.SD);
				if (!_v4.$) {
					var _v5 = _v4.a;
					var newForm = _v5.a;
					var validFormFields = _v5.b;
					return function (okFormModel) {
						return {
							GZ: A3($author$project$Components$Admin$NotificationSetting$Customize$previewNotificationSetting, apiClient, validFormFields, okFormModel),
							agZ: 0,
							aiO: okFormModel,
							aR: _List_Nil
						};
					}(
						_Utils_update(
							model,
							{SD: newForm, akd: $author$project$Api$Data$Loading}));
				} else {
					var newForm = _v4.a;
					return function (failedFormModel) {
						return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: failedFormModel, aR: _List_Nil};
					}(
						_Utils_update(
							model,
							{SD: newForm, akd: $author$project$Api$Data$NotAsked}));
				}
			case 3:
				var _v6 = A2($author$project$Utils$Form$validate, $author$project$Components$Admin$NotificationSetting$Customize$notificationSettingFormFieldsValidator, model.SD);
				if (!_v6.$) {
					var _v7 = _v6.a;
					var newForm = _v7.a;
					var validFormFields = _v7.b;
					return function (okModel) {
						return {
							GZ: A3($author$project$Components$Admin$NotificationSetting$Customize$testNotificationSetting, apiClient, validFormFields, okModel),
							agZ: 0,
							aiO: okModel,
							aR: _List_Nil
						};
					}(
						_Utils_update(
							model,
							{SD: newForm, lK: $author$project$Api$Data$Loading}));
				} else {
					var newForm = _v6.a;
					return function (errModel) {
						return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: errModel, aR: _List_Nil};
					}(
						_Utils_update(
							model,
							{SD: newForm, lK: $author$project$Api$Data$NotAsked}));
				}
			case 4:
				return function (resettingModel) {
					return {
						GZ: A2($author$project$Components$Admin$NotificationSetting$Customize$resetNotificationSetting, apiClient, resettingModel),
						agZ: 0,
						aiO: resettingModel,
						aR: _List_Nil
					};
				}(
					_Utils_update(
						model,
						{akd: $author$project$Api$Data$Loading}));
			case 5:
				return function (editingModel) {
					var _v8 = $author$project$Utils$Form$fields(model.SD);
					var body = _v8.fO;
					return {
						GZ: A4(
							$author$project$Ports$CKEditor$replace,
							$author$project$Components$Admin$NotificationSetting$Customize$notificationBodyEditorId(model.X_),
							body,
							$author$project$Api$Provider$NotificationSetting$Shared$availableLiquidVariables(model.X_),
							$elm$core$Maybe$Nothing),
						agZ: 0,
						aiO: editingModel,
						aR: _List_Nil
					};
				}(
					_Utils_update(
						model,
						{akd: $author$project$Api$Data$NotAsked}));
			case 6:
				return {
					GZ: A2($author$project$Components$Admin$NotificationSetting$Customize$updateNotificationSetting, apiClient, model),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{pR: true}),
					aR: _List_Nil
				};
			case 7:
				var response = msg.a;
				return function (modelWPreview) {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: modelWPreview,
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}(
					_Utils_update(
						model,
						{akd: response}));
			case 10:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Admin$NotificationSetting$Customize$notificationSettingFormFieldsUpdate, field, model.SD);
				var validatedForm = function () {
					var _v9 = A2($author$project$Utils$Form$validate, $author$project$Components$Admin$NotificationSetting$Customize$notificationSettingFormFieldsValidator, newForm);
					if (!_v9.$) {
						var _v10 = _v9.a;
						var form = _v10.a;
						return form;
					} else {
						var form = _v9.a;
						return form;
					}
				}();
				var newModel = _Utils_update(
					model,
					{SD: validatedForm, pR: false});
				return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: newModel, aR: _List_Nil};
			case 11:
				var response = msg.a;
				if (response.$ === 3) {
					return function (okModel) {
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 1,
							aiO: okModel,
							aR: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Notification successfully updated.')
								])
						};
					}(
						_Utils_update(
							model,
							{Yn: false}));
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: model,
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 12:
				var language = msg.a;
				var response = msg.b;
				var _v12 = function () {
					if (_Utils_eq(language, model.Ay)) {
						if (response.$ === 3) {
							var setting = response.a;
							return $author$project$Components$Admin$NotificationSetting$Customize$initForm(
								$author$project$Api$Provider$NotificationSetting$One$toShared(setting));
						} else {
							return _Utils_Tuple2(model.SD, $elm$core$Platform$Cmd$none);
						}
					} else {
						return _Utils_Tuple2(model.SD, $elm$core$Platform$Cmd$none);
					}
				}();
				var form = _v12.a;
				var formCmd = _v12.b;
				return function (translations) {
					return {
						GZ: formCmd,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{SD: form, adD: translations}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}(
					A3(
						$elm$core$Dict$insert,
						$author$project$Language$toValue(language),
						A2($author$project$Api$Data$map, $author$project$Api$Provider$NotificationSetting$One$toShared, response),
						model.adD));
			case 8:
				var response = msg.a;
				if (response.$ === 3) {
					var notificationSettingOne = response.a;
					var notificationSetting = $author$project$Api$Provider$NotificationSetting$One$toShared(notificationSettingOne);
					var _v15 = $author$project$Components$Admin$NotificationSetting$Customize$initForm(notificationSetting);
					var form = _v15.a;
					var formCmd = _v15.b;
					var newModel = _Utils_update(
						model,
						{SD: form, X_: notificationSetting});
					return {
						GZ: formCmd,
						agZ: 1,
						aiO: newModel,
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Notification successfully reset.')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: model,
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 9:
				var response = msg.a;
				return function (newModel) {
					if (response.$ === 3) {
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 0,
							aiO: newModel,
							aR: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'A sample of this email has been sent to you.')
								])
						};
					} else {
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 0,
							aiO: newModel,
							aR: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
				}(
					_Utils_update(
						model,
						{lK: response}));
			case 13:
				return function (newModel) {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: newModel, aR: _List_Nil};
				}(
					_Utils_update(
						model,
						{p9: !model.p9}));
			default:
				var language = msg.a;
				var _v17 = _Utils_eq(language, $author$project$Language$english) ? $author$project$Components$Admin$NotificationSetting$Customize$initForm(model.X_) : A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(
						model.SD,
						A4(
							$author$project$Api$Provider$NotificationSetting$retrieve,
							apiClient,
							$author$project$Api$Provider$NotificationSetting$Shared$id(model.X_),
							$elm$core$Maybe$Just(language),
							$author$project$Components$Admin$NotificationSetting$Customize$GotNotificationSetting(language))),
					A2(
						$elm$core$Maybe$map,
						function (translatedSetting) {
							return $author$project$Components$Admin$NotificationSetting$Customize$initForm(translatedSetting);
						},
						A2(
							$elm$core$Maybe$andThen,
							$author$project$Api$Data$toMaybe,
							A2(
								$elm$core$Dict$get,
								$author$project$Language$toValue(language),
								model.adD))));
				var form = _v17.a;
				var formCmd = _v17.b;
				return {
					GZ: formCmd,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{SD: form, Ay: language}),
					aR: _List_Nil
				};
		}
	});
var $author$project$Components$Admin$NotificationSetting$Toggle$NotificationSettingToggled = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Company$NotificationSetting$toggle = F5(
	function (apiClient, companyId, id_, enabled_, toMsg) {
		var body_ = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'notification_setting',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'enabled',
								$elm$json$Json$Encode$bool(enabled_))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$NotificationSetting$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body_,
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Provider$Company$NotificationSetting$notificationSettingPath, companyId, id_))));
	});
var $author$project$Api$Provider$NotificationSetting$toggle = F4(
	function (apiClient, id_, enabled_, toMsg) {
		var body_ = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'notification_setting',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'enabled',
								$elm$json$Json$Encode$bool(enabled_))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$NotificationSetting$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body_,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$NotificationSetting$notificationSettingPath(id_))));
	});
var $author$project$Components$Admin$NotificationSetting$Toggle$update = F4(
	function (apiClient, context, msg, _v0) {
		var model = _v0;
		if (!msg.$) {
			var bool = msg.a;
			var toggleCmd = function () {
				if (context.$ === 1) {
					var companyId = context.a;
					return A5(
						$author$project$Api$Provider$Company$NotificationSetting$toggle,
						apiClient,
						companyId,
						model.zL.ahP(model.X_),
						bool,
						$author$project$Components$Admin$NotificationSetting$Toggle$NotificationSettingToggled);
				} else {
					return A4(
						$author$project$Api$Provider$NotificationSetting$toggle,
						apiClient,
						model.zL.ahP(model.X_),
						bool,
						$author$project$Components$Admin$NotificationSetting$Toggle$NotificationSettingToggled);
				}
			}();
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{uf: $author$project$Api$Data$Loading}),
				toggleCmd,
				_List_Nil);
		} else {
			var response = msg.a;
			if (response.$ === 3) {
				var notificationSetting = response.a;
				var status = $author$project$Api$Provider$NotificationSetting$One$enabled(notificationSetting) ? 'enabled' : 'disabled';
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							Ro: $author$project$Api$Provider$NotificationSetting$One$enabled(notificationSetting),
							uf: $author$project$Api$Data$NotAsked
						}),
					$elm$core$Platform$Cmd$none,
					_List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 3, 'This notification has been ' + status)
						]));
			} else {
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{uf: $author$project$Api$Data$NotAsked}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			}
		}
	});
var $author$project$Pages$Admin$AdvanceBilling$Updated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Practice$One$Practice = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Practice$Shared$Practice = $elm$core$Basics$identity;
var $author$project$Api$Provider$Practice$Shared$Record = function (id) {
	return function (name) {
		return function (email) {
			return function (usesSponsors) {
				return function (cancellationReasonOther) {
					return function (deactivated) {
						return function (deactivateOn) {
							return function (subdomain) {
								return function (hasClinicalAccount) {
									return function (hasStripeAccount) {
										return function (hasPaymentProcessorAccount) {
											return function (url) {
												return function (stripeClientId) {
													return function (stripePublishableKey) {
														return function (logoUrl) {
															return function (usesCardReaders) {
																return function (isNetwork) {
																	return function (isAffiliate) {
																		return function (elationEnabled) {
																			return function (acceptsCards) {
																				return function (acceptsAmex) {
																					return function (stripeLink) {
																						return function (encourageAch) {
																							return function (createdAt) {
																								return function (paymentProcessor) {
																									return function (hasBankTransfersCapability) {
																										return {KB: acceptsAmex, KC: acceptsCards, afp: cancellationReasonOther, O1: createdAt, PP: deactivateOn, PQ: deactivated, Ra: elationEnabled, Rj: email, Rq: encourageAch, S4: hasBankTransfersCapability, S5: hasClinicalAccount, Tg: hasPaymentProcessorAccount, Tl: hasStripeAccount, ahP: id, Uz: isAffiliate, U_: isNetwork, Wk: logoUrl, Bq: name, Zd: paymentProcessor, ack: stripeClientId, acq: stripeLink, acs: stripePublishableKey, acu: subdomain, adY: url, ad4: usesCardReaders, ad8: usesSponsors};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm_community$json_extra$Json$Decode$Extra$fromResult = function (result) {
	if (!result.$) {
		var successValue = result.a;
		return $elm$json$Json$Decode$succeed(successValue);
	} else {
		var errorMessage = result.a;
		return $elm$json$Json$Decode$fail(errorMessage);
	}
};
var $author$project$Utils$Date$decode = A2(
	$elm$json$Json$Decode$andThen,
	A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromIsoString, $elm_community$json_extra$Json$Decode$Extra$fromResult),
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$Practice$Shared$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'has_bank_transfers_capability',
	$elm$json$Json$Decode$bool,
	false,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'payment_processor',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'created_at',
			$elm_community$json_extra$Json$Decode$Extra$datetime,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'encourage_ach',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'stripe_account_link',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'accepts_amex',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'accepts_cards',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'elation_enabled',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'is_affiliate',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'is_network',
										$elm$json$Json$Decode$bool,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'uses_card_readers',
											$elm$json$Json$Decode$bool,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'logo_url',
												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'stripe_publishable_key',
													$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'stripe_client_id',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'url',
															$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'has_payment_processor_account',
																$elm$json$Json$Decode$bool,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'has_stripe_account',
																	$elm$json$Json$Decode$bool,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'has_clinical_account',
																		$elm$json$Json$Decode$bool,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'subdomain',
																			$elm$json$Json$Decode$string,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'deactivate_on',
																				$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'deactivated',
																					$elm$json$Json$Decode$bool,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'cancellation_reason_other',
																						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'uses_sponsors',
																							$elm$json$Json$Decode$bool,
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'email',
																								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'name',
																									$elm$json$Json$Decode$string,
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'id',
																										$elm$json$Json$Decode$string,
																										$elm$json$Json$Decode$succeed($author$project$Api$Provider$Practice$Shared$Record)))))))))))))))))))))))))));
var $author$project$Api$Provider$Practice$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Practice$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Practice$One$Record = function (requireGroupForLocations) {
	return function (requiresMfa) {
		return function (trackPatientsByLocation) {
			return function (chargePatientsCreditCardFees) {
				return function (passthroughFeesCutoffEnabled) {
					return function (passthroughFeesCutoffDate) {
						return function (ssnEnabled) {
							return function (requiresSSN) {
								return function (requiresPatientEmail) {
									return function (requiresPatientMobile) {
										return function (requiresPractitioner) {
											return function (requiresLocation) {
												return function (requiresDefaultLocationForCompanies) {
													return function (hasCompaniesWithoutDefaultLocation) {
														return function (hasLocationsWithoutGroup) {
															return function (requiresPaymentInformation) {
																return function (organizationId) {
																	return function (canDeleteAllPatients) {
																		return function (collectSSNOnSignup) {
																			return function (collectPractitionerOnSignup) {
																				return function (collectLocationOnSignup) {
																					return function (selfServiceRequestAccessUrl) {
																						return function (notRetailPlansCount) {
																							return function (locationGroupsCount) {
																								return function (feePlanType) {
																									return function (sendZeroRevenueMembershipNotification) {
																										return function (emailReplyAddress) {
																											return function (salutation) {
																												return function (greetsFormally) {
																													return function (footer) {
																														return function (memberPortalSignupUrl) {
																															return function (meta) {
																																return function (practiceOnboarding) {
																																	return function (features) {
																																		return function (daysWithOutstandingBalance) {
																																			return function (collectionWarningStatus) {
																																				return function (accessRestricted) {
																																					return function (daysUntilAccessRestricted) {
																																						return function (billMonthlyAutopayInAdvanceInDays) {
																																							return function (billNonMonthlyAutopayInAdvanceInDays) {
																																								return function (billMonthlyNonAutopayInAdvanceInDays) {
																																									return function (billNonMonthlyNonAutopayInAdvanceInDays) {
																																										return function (scheduleMonthlyPaymentInAdvanceInDays) {
																																											return function (scheduleNonMonthlyPaymentInAdvanceInDays) {
																																												return function (commissionsEnabled) {
																																													return function (commissionsTrackingFrom) {
																																														return function (sessionTimeoutInMinutes) {
																																															return function (ein) {
																																																return function (practicePulse) {
																																																	return function (engagementThreshold) {
																																																		return function (defaultToActivePatientsFilter) {
																																																			return function (plansCount) {
																																																				return function (companiesCount) {
																																																					return function (owner) {
																																																						return function (businessLocation) {
																																																							return function (companyInvoiceSetting) {
																																																								return function (paymentSourceSetting) {
																																																									return function (address) {
																																																										return function (phones) {
																																																											return function (network) {
																																																												return function (featureGates) {
																																																													return function (labelBillingAsShipping) {
																																																														return function (accountType) {
																																																															return function (transInclusivity) {
																																																																return function (hasActiveCompanies) {
																																																																	return function (customForms) {
																																																																		return function (acceptsAch) {
																																																																			return function (postSignupButtonLabel) {
																																																																				return function (postSignupRedirectUrl) {
																																																																					return function (showPostSignupFooterButton) {
																																																																						return function (redirectsPostSignup) {
																																																																							return function (postSignupMessage) {
																																																																								return function (collectPaymentSourceOnSignup) {
																																																																									return function (autoConfirmSignup) {
																																																																										return function (prepayFirstPaymentOnSignup) {
																																																																											return function (mergeDuplicatePatientsOnSignup) {
																																																																												return function (collectAddressOnSignup) {
																																																																													return function (collectBillingAddressOnSignup) {
																																																																														return function (collectLeadSourceOnSignup) {
																																																																															return function (collectBrokerOnSignup) {
																																																																																return function (startDateSelectableOnSignup) {
																																																																																	return function (allowPayerOnBehalfOnSignup) {
																																																																																		return function (collectInsuranceOnSignup) {
																																																																																			return function (signupPageNotFoundRedirectUrl) {
																																																																																				return function (signupSettings) {
																																																																																					return function (defaultPlanId) {
																																																																																						return function (minEnrollAge) {
																																																																																							return function (restrictZipCodesOnSignup) {
																																																																																								return function (allowedZipCodesOnSignup) {
																																																																																									return function (defaultMembershipStartDate) {
																																																																																										return function (anyRetailBrokers) {
																																																																																											return function (mailgunStatus) {
																																																																																												return function (addons) {
																																																																																													return function (customLogoUrl) {
																																																																																														return function (emr) {
																																																																																															return function (emrOther) {
																																																																																																return function (defaultPatientsPreferredLanguage) {
																																																																																																	return function (stripeCustomerLink) {
																																																																																																		return function (membershipCancellationEnabled) {
																																																																																																			return function (allowMultipleRetailMemberships) {
																																																																																																				return function (taxAddressValid) {
																																																																																																					return function (hasManagedPartner) {
																																																																																																						return {KA: acceptsAch, KE: accessRestricted, KJ: accountType, K1: addons, K2: address, Lw: allowMultipleRetailMemberships, Ly: allowPayerOnBehalfOnSignup, LC: allowedZipCodesOnSignup, LS: anyRetailBrokers, Mg: autoConfirmSignup, afc: billMonthlyAutopayInAdvanceInDays, afd: billMonthlyNonAutopayInAdvanceInDays, afe: billNonMonthlyAutopayInAdvanceInDays, aff: billNonMonthlyNonAutopayInAdvanceInDays, MY: businessLocation, M6: canDeleteAllPatients, afE: chargePatientsCreditCardFees, NR: collectAddressOnSignup, NS: collectBillingAddressOnSignup, NT: collectBrokerOnSignup, NW: collectInsuranceOnSignup, NX: collectLeadSourceOnSignup, afO: collectLocationOnSignup, NZ: collectPaymentSourceOnSignup, N_: collectPractitionerOnSignup, N$: collectSSNOnSignup, N1: collectionWarningStatus, N6: commissionsEnabled, N7: commissionsTrackingFrom, Oa: companiesCount, Oe: companyInvoiceSetting, Pn: customForms, Pq: customLogoUrl, PM: daysUntilAccessRestricted, PN: daysWithOutstandingBalance, P2: defaultMembershipStartDate, P5: defaultPatientsPreferredLanguage, P9: defaultPlanId, agn: defaultToActivePatientsFilter, Q9: ein, agK: emailReplyAddress, agO: emr, agQ: emrOther, agV: engagementThreshold, Sd: featureGates, Sf: features, Si: feePlanType, ahr: footer, ahA: greetsFormally, S3: hasActiveCompanies, S6: hasCompaniesWithoutDefaultLocation, Tc: hasLocationsWithoutGroup, Td: hasManagedPartner, Vz: labelBillingAsShipping, Wb: locationGroupsCount, aix: mailgunStatus, WM: memberPortalSignupUrl, aiF: membershipCancellationEnabled, W2: mergeDuplicatePatientsOnSignup, W4: meta, Xa: minEnrollAge, Xz: network, XZ: notRetailPlansCount, ajD: organizationId, YD: owner, ajP: passthroughFeesCutoffDate, ajQ: passthroughFeesCutoffEnabled, Zh: paymentSourceSetting, Zy: phones, ZH: plansCount, ZR: postSignupButtonLabel, ZS: postSignupMessage, ZT: postSignupRedirectUrl, ZZ: practiceOnboarding, Z_: practicePulse, _c: prepayFirstPaymentOnSignup, $l: redirectsPostSignup, akQ: requireGroupForLocations, akU: requiresDefaultLocationForCompanies, $G: requiresLocation, $H: requiresMfa, $I: requiresPatientEmail, $J: requiresPatientMobile, $L: requiresPaymentInformation, $M: requiresPractitioner, $N: requiresSSN, $S: restrictZipCodesOnSignup, ak9: salutation, ala: scheduleMonthlyPaymentInAdvanceInDays, alb: scheduleNonMonthlyPaymentInAdvanceInDays, aaI: selfServiceRequestAccessUrl, aaU: sendZeroRevenueMembershipNotification, alp: sessionTimeoutInMinutes, abp: showPostSignupFooterButton, aby: signupPageNotFoundRedirectUrl, abA: signupSettings, ab6: ssnEnabled, ab8: startDateSelectableOnSignup, acn: stripeCustomerLink, acU: taxAddressValid, adt: trackPatientsByLocation, adv: transInclusivity};
																																																																																																					};
																																																																																																				};
																																																																																																			};
																																																																																																		};
																																																																																																	};
																																																																																																};
																																																																																															};
																																																																																														};
																																																																																													};
																																																																																												};
																																																																																											};
																																																																																										};
																																																																																									};
																																																																																								};
																																																																																							};
																																																																																						};
																																																																																					};
																																																																																				};
																																																																																			};
																																																																																		};
																																																																																	};
																																																																																};
																																																																															};
																																																																														};
																																																																													};
																																																																												};
																																																																											};
																																																																										};
																																																																									};
																																																																								};
																																																																							};
																																																																						};
																																																																					};
																																																																				};
																																																																			};
																																																																		};
																																																																	};
																																																																};
																																																															};
																																																														};
																																																													};
																																																												};
																																																											};
																																																										};
																																																									};
																																																								};
																																																							};
																																																						};
																																																					};
																																																				};
																																																			};
																																																		};
																																																	};
																																																};
																																															};
																																														};
																																													};
																																												};
																																											};
																																										};
																																									};
																																								};
																																							};
																																						};
																																					};
																																				};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$AccountType$Affiliate = 1;
var $author$project$Api$AccountType$Mce = 2;
var $author$project$Api$AccountType$Standard = 0;
var $author$project$Api$AccountType$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'standard':
				return $elm$json$Json$Decode$succeed(0);
			case 'affiliate':
				return $elm$json$Json$Decode$succeed(1);
			case 'mce':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Unsupported practice account_type: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$FeePlanType$Pmpm = 1;
var $author$project$Api$FeePlanType$Transaction = 0;
var $author$project$Api$FeePlanType$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'transaction':
				return $elm$json$Json$Decode$succeed(0);
			case 'pmpm':
				return $elm$json$Json$Decode$succeed(1);
			case 'pmpm_tiered':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Unsupported practice fee_plan_type: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Language$ES = 1;
var $author$project$Language$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'en':
				return $elm$json$Json$Decode$succeed(0);
			case 'es':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Invalid language');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$CollectOnSignup$Default = 3;
var $author$project$Api$CollectOnSignup$No = 0;
var $author$project$Api$CollectOnSignup$Optional = 1;
var $author$project$Api$CollectOnSignup$Require = 2;
var $author$project$Api$CollectOnSignup$Yes = 4;
var $author$project$Api$CollectOnSignup$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'no':
				return $elm$json$Json$Decode$succeed(0);
			case 'optional':
				return $elm$json$Json$Decode$succeed(1);
			case 'require':
				return $elm$json$Json$Decode$succeed(2);
			case 'default':
				return $elm$json$Json$Decode$succeed(3);
			case 'yes':
				return $elm$json$Json$Decode$succeed(4);
			default:
				var somethingElse = str;
				return $elm$json$Json$Decode$fail('Unknown collect on signup value: ' + somethingElse);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Common$Address$Shared$Address = $elm$core$Basics$identity;
var $author$project$Api$Common$Address$Shared$Record = F7(
	function (line1, line2, city, state, zip, country, stripeCountryCode) {
		return {rE: city, rK: country, s$: line1, AD: line2, uP: state, acm: stripeCountryCode, vv: zip};
	});
var $author$project$Api$Common$Address$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'stripe_country_code',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'country',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'zip',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'state',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'city',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'line2',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'line1',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							$elm$json$Json$Decode$succeed($author$project$Api$Common$Address$Shared$Record))))))));
var $author$project$Api$Common$Address$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Address$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$FeatureGate$Shared$FeatureGate = $elm$core$Basics$identity;
var $author$project$Api$Common$FeatureGate$Shared$Record = F2(
	function (code, startingTier) {
		return {NN: code, alF: startingTier};
	});
var $author$project$Api$FeatureGate$CallUs = 3;
var $author$project$Api$FeatureGate$Enterprise = 2;
var $author$project$Api$FeatureGate$Growth = 1;
var $author$project$Api$FeatureGate$OtherStartingTier = 4;
var $author$project$Api$FeatureGate$Startup = 0;
var $author$project$Api$FeatureGate$decodeStartingTier = function (startingTierStr) {
	switch (startingTierStr) {
		case 'startup':
			return $elm$json$Json$Decode$succeed(0);
		case 'growth':
			return $elm$json$Json$Decode$succeed(1);
		case 'enterprise':
			return $elm$json$Json$Decode$succeed(2);
		case 'call_us':
			return $elm$json$Json$Decode$succeed(3);
		default:
			return $elm$json$Json$Decode$succeed(4);
	}
};
var $author$project$Api$Common$FeatureGate$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'starting_tier',
	A2($elm$json$Json$Decode$andThen, $author$project$Api$FeatureGate$decodeStartingTier, $elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'code',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Common$FeatureGate$Shared$Record)));
var $author$project$Api$Common$FeatureGate$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$FeatureGate$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Addon$Min$Addon = $elm$core$Basics$identity;
var $author$project$Api$Provider$Addon$Min$Record = F3(
	function (id, name, sendsExternalEmail) {
		return {ahP: id, Bq: name, aaW: sendsExternalEmail};
	});
var $author$project$Api$Provider$Addon$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'sends_external_email',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Addon$Min$Record))));
var $author$project$Api$Provider$Addon$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Addon$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Form$Shared$Form = $elm$core$Basics$identity;
var $author$project$Api$Provider$Form$Shared$Record = F3(
	function (id, name, formItems) {
		return {SE: formItems, ahP: id, Bq: name};
	});
var $author$project$Api$Provider$FormItem$Shared$FormItem = $elm$core$Basics$identity;
var $author$project$Api$Provider$FormItem$Shared$Record = F3(
	function (id, title, itemType) {
		return {ahP: id, sW: itemType, ac9: title};
	});
var $author$project$Api$Provider$FormItem$Shared$Boolean = 0;
var $author$project$Api$Provider$FormItem$Shared$MultipleStrings = 1;
var $author$project$Api$Provider$FormItem$Shared$String = 2;
var $author$project$Api$Provider$FormItem$Shared$itemTypeDecoder = function (itemTypeString) {
	switch (itemTypeString) {
		case 'string':
			return $elm$json$Json$Decode$succeed(2);
		case 'multiple_strings':
			return $elm$json$Json$Decode$succeed(1);
		case 'boolean':
			return $elm$json$Json$Decode$succeed(0);
		default:
			return $elm$json$Json$Decode$fail('Unsupported item type: ' + itemTypeString);
	}
};
var $author$project$Api$Provider$FormItem$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'item_type',
	A2($elm$json$Json$Decode$andThen, $author$project$Api$Provider$FormItem$Shared$itemTypeDecoder, $elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'title',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$FormItem$Shared$Record))));
var $author$project$Api$Provider$FormItem$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$FormItem$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Form$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'form_items',
	$elm$json$Json$Decode$list($author$project$Api$Provider$FormItem$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Form$Shared$Record))));
var $author$project$Api$Provider$Form$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Form$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Location$Min$Location = $elm$core$Basics$identity;
var $author$project$Api$Provider$Location$Min$Record = F2(
	function (id, name) {
		return {ahP: id, Bq: name};
	});
var $author$project$Api$Provider$Location$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Location$Min$Record)));
var $author$project$Api$Provider$Location$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Location$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Network$Shared$Network = $elm$core$Basics$identity;
var $author$project$Api$Provider$Network$Shared$Record = F2(
	function (syncByAffiliation, ratesFromAffiliate) {
		return {_5: ratesFromAffiliate, acI: syncByAffiliation};
	});
var $author$project$Api$Provider$Network$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'rates_from_affiliate',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'sync_by_affiliation',
		$elm$json$Json$Decode$bool,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Network$Shared$Record)));
var $author$project$Api$Provider$Network$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Network$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $elm_community$list_extra$List$Extra$find = F2(
	function (predicate, list) {
		find:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var first = list.a;
				var rest = list.b;
				if (predicate(first)) {
					return $elm$core$Maybe$Just(first);
				} else {
					var $temp$predicate = predicate,
						$temp$list = rest;
					predicate = $temp$predicate;
					list = $temp$list;
					continue find;
				}
			}
		}
	});
var $author$project$Api$Provider$Practice$Emr$AkuteHealth = 3;
var $author$project$Api$Provider$Practice$Emr$AthenaHealth = 4;
var $author$project$Api$Provider$Practice$Emr$Canvas = 9;
var $author$project$Api$Provider$Practice$Emr$Cerbo = 2;
var $author$project$Api$Provider$Practice$Emr$CharmEMR = 6;
var $author$project$Api$Provider$Practice$Emr$DrChrono = 8;
var $author$project$Api$Provider$Practice$Emr$EClinicalWorks = 5;
var $author$project$Api$Provider$Practice$Emr$ElationHealth = 1;
var $author$project$Api$Provider$Practice$Emr$Emr = $elm$core$Basics$identity;
var $author$project$Api$Provider$Practice$Emr$Healthie = 11;
var $author$project$Api$Provider$Practice$Emr$HintClinical = 0;
var $author$project$Api$Provider$Practice$Emr$Jane = 10;
var $author$project$Api$Provider$Practice$Emr$Other = 13;
var $author$project$Api$Provider$Practice$Emr$PracticeFusion = 7;
var $author$project$Api$Provider$Practice$Emr$VibrantPractice = 12;
var $author$project$Api$Provider$Practice$Emr$options = _List_fromArray(
	[
		{ahP: 'hint_clinical', Bq: 'Hint Clinical', ay: 0},
		{ahP: 'akute_health', Bq: 'Akute Health', ay: 3},
		{ahP: 'athena_health', Bq: 'AthenaHealth', ay: 4},
		{ahP: 'canvas', Bq: 'Canvas', ay: 9},
		{ahP: 'cerbo', Bq: 'Cerbo', ay: 2},
		{ahP: 'charm_emr', Bq: 'CharmEMR', ay: 6},
		{ahP: 'dr_chrono', Bq: 'DrChrono', ay: 8},
		{ahP: 'e_clinical_works', Bq: 'eClinicalWorks', ay: 5},
		{ahP: 'elation_health', Bq: 'Elation Health', ay: 1},
		{ahP: 'healthie', Bq: 'Healthie', ay: 11},
		{ahP: 'jane', Bq: 'Jane', ay: 10},
		{ahP: 'practice_fusion', Bq: 'PracticeFusion', ay: 7},
		{ahP: 'vibrant_practice', Bq: 'Vibrant Practice', ay: 12},
		{ahP: 'other', Bq: 'Other', ay: 13}
	]);
var $author$project$Api$Provider$Practice$Emr$fromValue = function (string) {
	return A2(
		$elm_community$list_extra$List$Extra$find,
		function (_v0) {
			var id = _v0.ahP;
			return _Utils_eq(id, string);
		},
		$author$project$Api$Provider$Practice$Emr$options);
};
var $author$project$Api$Provider$Practice$Emr$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		var _v0 = $author$project$Api$Provider$Practice$Emr$fromValue(string);
		if (!_v0.$) {
			var emr = _v0.a;
			return $elm$json$Json$Decode$succeed(emr);
		} else {
			return $elm$json$Json$Decode$fail('Unsupported emr option: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$PracticeOnboarding$Shared$PracticeOnboarding = $elm$core$Basics$identity;
var $author$project$Api$Provider$PracticeOnboarding$Shared$Record = F2(
	function (id, accountStep) {
		return {KI: accountStep, ahP: id};
	});
var $author$project$Api$Provider$PracticeOnboarding$AccountStep$Communications = 5;
var $author$project$Api$Provider$PracticeOnboarding$AccountStep$ContactInfo = 1;
var $author$project$Api$Provider$PracticeOnboarding$AccountStep$Legal = 6;
var $author$project$Api$Provider$PracticeOnboarding$AccountStep$MembershipPricing = 2;
var $author$project$Api$Provider$PracticeOnboarding$AccountStep$NotOnboarding = 8;
var $author$project$Api$Provider$PracticeOnboarding$AccountStep$NotStarted = 0;
var $author$project$Api$Provider$PracticeOnboarding$AccountStep$PatientAgreements = 3;
var $author$project$Api$Provider$PracticeOnboarding$AccountStep$Profile = 4;
var $author$project$Api$Provider$PracticeOnboarding$AccountStep$SetupCompleted = 7;
var $author$project$Api$Provider$PracticeOnboarding$AccountStep$decode = A2(
	$elm$json$Json$Decode$map,
	function (string) {
		switch (string) {
			case 'not_started':
				return 0;
			case 'contact_info':
				return 1;
			case 'membership_pricing':
				return 2;
			case 'patient_agreements':
				return 3;
			case 'users_setup':
				return 4;
			case 'communications_setup':
				return 5;
			case 'legal_setup':
				return 6;
			case 'setup_completed':
				return 7;
			default:
				return 8;
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$PracticeOnboarding$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'account_step',
	$author$project$Api$Provider$PracticeOnboarding$AccountStep$decode,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticeOnboarding$Shared$Record)));
var $author$project$Api$Provider$PracticeOnboarding$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PracticeOnboarding$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$SignupSettings$Min$SignupSettings = $elm$core$Basics$identity;
var $author$project$Api$Provider$SignupSettings$Min$Record = function (customJavascriptText) {
	return {Po: customJavascriptText};
};
var $author$project$Api$Provider$SignupSettings$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'custom_javascript_text',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$SignupSettings$Min$Record));
var $author$project$Api$Provider$SignupSettings$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$SignupSettings$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$User$Min$User = $elm$core$Basics$identity;
var $author$project$Api$Provider$User$Min$Record = function (name) {
	return {Bq: name};
};
var $author$project$Api$Provider$User$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$User$Min$Record));
var $author$project$Api$Provider$User$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$User$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Expandable$Expanded = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Expandable$NotExpanded = {$: 1};
var $author$project$Api$Expandable$expandable = F2(
	function (key, decoder) {
		return A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			key,
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						$elm$json$Json$Decode$null($author$project$Api$Expandable$NotExpanded),
						A2($elm$json$Json$Decode$map, $author$project$Api$Expandable$Expanded, decoder)
					])),
			$author$project$Api$Expandable$NotExpanded);
	});
var $author$project$Api$Provider$CustomForm$CustomForm = $elm$core$Basics$identity;
var $author$project$Api$Provider$CustomForm$FormQuestion = $elm$core$Basics$identity;
var $author$project$Api$Provider$Form$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$FormItem$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$CustomForm$Boolean = 0;
var $author$project$Api$Provider$CustomForm$MultipleStrings = 1;
var $author$project$Api$Provider$CustomForm$String = 2;
var $author$project$Api$Provider$CustomForm$itemTypeToQuestionType = function (type_) {
	switch (type_) {
		case 0:
			return 0;
		case 1:
			return 1;
		default:
			return 2;
	}
};
var $author$project$Api$Provider$Form$Shared$items = function (_v0) {
	var record = _v0;
	return record.SE;
};
var $author$project$Api$Provider$Form$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$FormItem$Shared$title = function (_v0) {
	var record = _v0;
	return record.ac9;
};
var $author$project$Api$Provider$FormItem$Shared$type_ = function (_v0) {
	var record = _v0;
	return record.sW;
};
var $author$project$Api$Provider$CustomForm$initFromForm = function (form) {
	var formItems = $author$project$Api$Provider$Form$Shared$items(form);
	var emptyFormQuestion = function (item) {
		return {
			rk: _List_Nil,
			ahP: $author$project$Api$Provider$FormItem$Shared$id(item),
			ac9: $author$project$Api$Provider$FormItem$Shared$title(item),
			amg: $author$project$Api$Provider$CustomForm$itemTypeToQuestionType(
				$author$project$Api$Provider$FormItem$Shared$type_(item))
		};
	};
	var questions_ = A2(
		$elm$core$List$map,
		function (formItem) {
			return emptyFormQuestion(formItem);
		},
		formItems);
	return {
		zJ: '',
		ahP: $author$project$Api$Provider$Form$Shared$id(form),
		Bq: $author$project$Api$Provider$Form$Shared$name(form),
		DF: questions_
	};
};
var $author$project$Api$Provider$Practice$One$OneMeta = F4(
	function (hasPractitioners, hasLocations, collectLocationOnSignup, collectPractitionerOnSignup) {
		return {afO: collectLocationOnSignup, N_: collectPractitionerOnSignup, Tb: hasLocations, Th: hasPractitioners};
	});
var $author$project$Api$Provider$Practice$One$OneMetaEditable = function (editable) {
	return {Q4: editable};
};
var $author$project$Api$Provider$Practice$One$metaEditableDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'editable',
	$elm$json$Json$Decode$bool,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Practice$One$OneMetaEditable));
var $author$project$Api$Provider$Practice$One$metaDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'collect_practitioner_on_signup',
	$author$project$Api$Provider$Practice$One$metaEditableDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'collect_location_on_signup',
		$author$project$Api$Provider$Practice$One$metaEditableDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'has_locations',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'has_practitioners',
				$elm$json$Json$Decode$bool,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$Practice$One$OneMeta)))));
var $author$project$Api$Provider$CompanyInvoiceSetting$Shared$Shared = $elm$core$Basics$identity;
var $author$project$Api$Provider$CompanyInvoiceSetting$Shared$Record = function (id) {
	return {ahP: id};
};
var $author$project$Api$Provider$CompanyInvoiceSetting$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'id',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyInvoiceSetting$Shared$Record));
var $author$project$Api$Provider$CompanyInvoiceSetting$Shared$sharedDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CompanyInvoiceSetting$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PaymentSourceSetting$Shared$Shared = $elm$core$Basics$identity;
var $author$project$Api$Provider$PaymentSourceSetting$Shared$Record = function (id) {
	return {ahP: id};
};
var $author$project$Api$Provider$PaymentSourceSetting$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'id',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$PaymentSourceSetting$Shared$Record));
var $author$project$Api$Provider$PaymentSourceSetting$Shared$sharedDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PaymentSourceSetting$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Practice$One$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'has_managed_partner',
	$elm$json$Json$Decode$bool,
	false,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'tax_address_valid',
		$elm$json$Json$Decode$bool,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'allow_multiple_retail_memberships',
			$elm$json$Json$Decode$bool,
			false,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'membership_cancellation_enabled',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'stripe_customer_link',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'default_patients_preferred_language',
						$author$project$Language$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'emr_other',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'emr',
								$elm$json$Json$Decode$nullable($author$project$Api$Provider$Practice$Emr$decoder),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'custom_logo_url',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'addons',
										$elm$json$Json$Decode$list($author$project$Api$Provider$Addon$Min$decoder),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'mailgun_status',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'any_retail_brokers',
												$elm$json$Json$Decode$bool,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'default_membership_start_date',
													$author$project$Utils$Date$decode,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'allowed_zip_codes_on_signup',
														$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'restrict_zip_codes_on_signup',
															$elm$json$Json$Decode$bool,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'min_enroll_age',
																$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																A3(
																	$author$project$Api$Expandable$expandable,
																	'default_plan_id',
																	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																	A3(
																		$author$project$Api$Expandable$expandable,
																		'signup_settings',
																		$author$project$Api$Provider$SignupSettings$Min$decoder,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'signup_page_not_found_redirect_url',
																			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'collect_insurance_on_signup',
																				$author$project$Api$CollectOnSignup$decoder,
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'allows_payer_on_behalf_on_signup',
																					$author$project$Api$CollectOnSignup$decoder,
																					A4(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																						'start_date_selectable_on_signup',
																						$elm$json$Json$Decode$bool,
																						false,
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'collect_broker_on_signup',
																							$author$project$Api$CollectOnSignup$decoder,
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'collect_lead_source_on_signup',
																								$author$project$Api$CollectOnSignup$decoder,
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'collect_billing_address_on_signup',
																									$author$project$Api$CollectOnSignup$decoder,
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'collect_address_on_signup',
																										$author$project$Api$CollectOnSignup$decoder,
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'merge_duplicate_patients_on_online_signup',
																											$elm$json$Json$Decode$bool,
																											A3(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																												'prepay_first_payment_on_signup',
																												$elm$json$Json$Decode$bool,
																												A3(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																													'auto_confirm_signups',
																													$elm$json$Json$Decode$bool,
																													A3(
																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																														'collect_payment_source_on_signup',
																														$author$project$Api$CollectOnSignup$decoder,
																														A3(
																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																															'post_signup_message',
																															$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																															A3(
																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																'redirects_post_signup',
																																$elm$json$Json$Decode$bool,
																																A3(
																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																	'show_post_signup_footer_button',
																																	$elm$json$Json$Decode$bool,
																																	A3(
																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																		'post_signup_redirect_url',
																																		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																		A3(
																																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																			'post_signup_button_label',
																																			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																			A3(
																																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																				'accepts_ach',
																																				$elm$json$Json$Decode$bool,
																																				A3(
																																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																					'forms',
																																					A2(
																																						$elm$json$Json$Decode$map,
																																						$elm$core$List$map($author$project$Api$Provider$CustomForm$initFromForm),
																																						$elm$json$Json$Decode$list($author$project$Api$Provider$Form$Shared$decoder)),
																																					A3(
																																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																						'has_active_companies',
																																						$elm$json$Json$Decode$bool,
																																						A3(
																																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																							'trans_inclusivity',
																																							$elm$json$Json$Decode$bool,
																																							A3(
																																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																								'account_type',
																																								$author$project$Api$AccountType$decode,
																																								A3(
																																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																									'label_billing_as_shipping',
																																									$elm$json$Json$Decode$bool,
																																									A3(
																																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																										'feature_gates',
																																										$elm$json$Json$Decode$list($author$project$Api$Common$FeatureGate$Shared$decoder),
																																										A3(
																																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																											'network',
																																											$elm$json$Json$Decode$nullable($author$project$Api$Provider$Network$Shared$decoder),
																																											A3(
																																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																												'phones',
																																												$elm$json$Json$Decode$list($author$project$Api$Common$Phone$Shared$decoder),
																																												A3(
																																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																													'address',
																																													$elm$json$Json$Decode$nullable($author$project$Api$Common$Address$Shared$decoder),
																																													A3(
																																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																														'payment_source_setting',
																																														$author$project$Api$Provider$PaymentSourceSetting$Shared$sharedDecoder,
																																														A3(
																																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																															'company_invoice_setting',
																																															$author$project$Api$Provider$CompanyInvoiceSetting$Shared$sharedDecoder,
																																															A3(
																																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																'business_location',
																																																$elm$json$Json$Decode$nullable($author$project$Api$Provider$Location$Min$decoder),
																																																A3(
																																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																	'owner',
																																																	$elm$json$Json$Decode$nullable($author$project$Api$Provider$User$Min$decoder),
																																																	A3(
																																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																		'companies_count',
																																																		$elm$json$Json$Decode$int,
																																																		A3(
																																																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																			'plans_count',
																																																			$elm$json$Json$Decode$int,
																																																			A3(
																																																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																				'default_to_active_patients_filter',
																																																				$elm$json$Json$Decode$bool,
																																																				A3(
																																																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																					'engagement_threshold',
																																																					$elm$json$Json$Decode$int,
																																																					A3(
																																																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																						'practice_pulse',
																																																						$elm$json$Json$Decode$bool,
																																																						A3(
																																																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																							'ein',
																																																							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																																							A3(
																																																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																								'session_timeout_in_minutes',
																																																								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																																																								A3(
																																																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																									'commissions_tracking_from',
																																																									$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
																																																									A3(
																																																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																										'commissions_enabled',
																																																										$elm$json$Json$Decode$bool,
																																																										A3(
																																																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																											'schedule_non_monthly_payment_in_advance_in_days',
																																																											$elm$json$Json$Decode$int,
																																																											A3(
																																																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																												'schedule_monthly_payment_in_advance_in_days',
																																																												$elm$json$Json$Decode$int,
																																																												A3(
																																																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																													'bill_non_monthly_non_autopay_in_advance_in_days',
																																																													$elm$json$Json$Decode$int,
																																																													A3(
																																																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																														'bill_monthly_non_autopay_in_advance_in_days',
																																																														$elm$json$Json$Decode$int,
																																																														A3(
																																																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																															'bill_non_monthly_autopay_in_advance_in_days',
																																																															$elm$json$Json$Decode$int,
																																																															A3(
																																																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																'bill_monthly_autopay_in_advance_in_days',
																																																																$elm$json$Json$Decode$int,
																																																																A3(
																																																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																	'days_until_access_restricted',
																																																																	$elm$json$Json$Decode$int,
																																																																	A3(
																																																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																		'access_restricted',
																																																																		$elm$json$Json$Decode$bool,
																																																																		A3(
																																																																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																			'collection_warning_status',
																																																																			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																																																			A3(
																																																																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																				'days_with_outstanding_balance',
																																																																				$elm$json$Json$Decode$int,
																																																																				A3(
																																																																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																					'features',
																																																																					$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
																																																																					A3(
																																																																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																						'practice_onboarding',
																																																																						$elm$json$Json$Decode$nullable($author$project$Api$Provider$PracticeOnboarding$Shared$decoder),
																																																																						A3(
																																																																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																							'meta',
																																																																							$author$project$Api$Provider$Practice$One$metaDecoder,
																																																																							A3(
																																																																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																								'member_portal_signup_url',
																																																																								$elm$json$Json$Decode$string,
																																																																								A3(
																																																																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																									'footer',
																																																																									$elm$json$Json$Decode$string,
																																																																									A3(
																																																																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																										'greets_formally',
																																																																										$elm$json$Json$Decode$bool,
																																																																										A3(
																																																																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																											'salutation',
																																																																											$elm$json$Json$Decode$string,
																																																																											A3(
																																																																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																												'email_reply_address',
																																																																												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																																																												A3(
																																																																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																													'send_zero_revenue_membership_notification',
																																																																													$elm$json$Json$Decode$bool,
																																																																													A3(
																																																																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																														'fee_plan_type',
																																																																														$author$project$Api$FeePlanType$decode,
																																																																														A3(
																																																																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																															'location_groups_count',
																																																																															$elm$json$Json$Decode$int,
																																																																															A3(
																																																																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																																'not_retail_plans_count',
																																																																																$elm$json$Json$Decode$int,
																																																																																A3(
																																																																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																																	'self_service_request_access_url',
																																																																																	$elm$json$Json$Decode$string,
																																																																																	A3(
																																																																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																																		'collect_location_on_signup',
																																																																																		$author$project$Api$CollectOnSignup$decoder,
																																																																																		A3(
																																																																																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																																			'collect_practitioner_on_signup',
																																																																																			$author$project$Api$CollectOnSignup$decoder,
																																																																																			A3(
																																																																																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																																				'collect_ssn_on_signup',
																																																																																				$author$project$Api$CollectOnSignup$decoder,
																																																																																				A3(
																																																																																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																																					'can_delete_all_patients',
																																																																																					$elm$json$Json$Decode$bool,
																																																																																					A3(
																																																																																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																																						'organization_id',
																																																																																						$elm$json$Json$Decode$string,
																																																																																						A2(
																																																																																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
																																																																																							$elm$json$Json$Decode$oneOf(
																																																																																								_List_fromArray(
																																																																																									[
																																																																																										A2($elm$json$Json$Decode$field, 'requires_payment_information', $elm$json$Json$Decode$bool),
																																																																																										A2(
																																																																																										$elm$json$Json$Decode$map,
																																																																																										$elm$core$Basics$not,
																																																																																										A2($elm$json$Json$Decode$field, 'onboarded', $elm$json$Json$Decode$bool))
																																																																																									])),
																																																																																							A3(
																																																																																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																																								'has_locations_without_group',
																																																																																								$elm$json$Json$Decode$bool,
																																																																																								A3(
																																																																																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																																									'has_companies_without_default_location',
																																																																																									$elm$json$Json$Decode$bool,
																																																																																									A3(
																																																																																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																																										'require_default_location_for_companies',
																																																																																										$elm$json$Json$Decode$bool,
																																																																																										A4(
																																																																																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																																																																											'requires_location',
																																																																																											$elm$json$Json$Decode$bool,
																																																																																											false,
																																																																																											A4(
																																																																																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																																																																												'requires_practitioner',
																																																																																												$elm$json$Json$Decode$bool,
																																																																																												false,
																																																																																												A3(
																																																																																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																																													'requires_patient_mobile',
																																																																																													$elm$json$Json$Decode$bool,
																																																																																													A3(
																																																																																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																																														'requires_patient_email',
																																																																																														$elm$json$Json$Decode$bool,
																																																																																														A3(
																																																																																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																																															'requires_ssn',
																																																																																															$elm$json$Json$Decode$bool,
																																																																																															A4(
																																																																																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																																																																																'ssn_enabled',
																																																																																																$elm$json$Json$Decode$bool,
																																																																																																false,
																																																																																																A3(
																																																																																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																																																	'passthrough_fees_cutoff_date',
																																																																																																	$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
																																																																																																	A3(
																																																																																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																																																		'passthrough_fees_cutoff_enabled',
																																																																																																		$elm$json$Json$Decode$bool,
																																																																																																		A3(
																																																																																																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																																																			'charge_patients_credit_card_fees',
																																																																																																			$elm$json$Json$Decode$bool,
																																																																																																			A4(
																																																																																																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																																																																																				'track_patients_by_location',
																																																																																																				$elm$json$Json$Decode$bool,
																																																																																																				false,
																																																																																																				A3(
																																																																																																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																																																					'requires_mfa',
																																																																																																					$elm$json$Json$Decode$bool,
																																																																																																					A3(
																																																																																																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																																																						'require_group_for_locations',
																																																																																																						$elm$json$Json$Decode$bool,
																																																																																																						$elm$json$Json$Decode$succeed($author$project$Api$Provider$Practice$One$Record)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
var $author$project$Api$Provider$Practice$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Practice$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Practice$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Practice$One$Practice)));
var $elm$json$Json$Encode$int = _Json_wrap;
var $author$project$Api$Provider$Practice$practicePath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['practice']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Practice$updateAdvanceBilling = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practice',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'bill_monthly_autopay_in_advance_in_days',
								$elm$json$Json$Encode$int(fields.afc)),
								_Utils_Tuple2(
								'bill_monthly_non_autopay_in_advance_in_days',
								$elm$json$Json$Encode$int(fields.afd)),
								_Utils_Tuple2(
								'bill_non_monthly_autopay_in_advance_in_days',
								$elm$json$Json$Encode$int(fields.afe)),
								_Utils_Tuple2(
								'bill_non_monthly_non_autopay_in_advance_in_days',
								$elm$json$Json$Encode$int(fields.aff)),
								_Utils_Tuple2(
								'schedule_monthly_payment_in_advance_in_days',
								$elm$json$Json$Encode$int(fields.ala)),
								_Utils_Tuple2(
								'schedule_non_monthly_payment_in_advance_in_days',
								$elm$json$Json$Encode$int(fields.alb))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Practice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$practicePath)));
	});
var $author$project$Pages$Admin$AdvanceBilling$updateAdvanceBilling = F2(
	function (apiClient, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A3(
			$author$project$Api$Provider$Practice$updateAdvanceBilling,
			apiClient,
			{
				afc: A2($elm$core$Maybe$withDefault, 0, fields.afc),
				afd: A2($elm$core$Maybe$withDefault, 0, fields.afd),
				afe: A2($elm$core$Maybe$withDefault, 0, fields.afe),
				aff: A2($elm$core$Maybe$withDefault, 0, fields.aff),
				ala: A2($elm$core$Maybe$withDefault, 0, fields.ala),
				alb: A2($elm$core$Maybe$withDefault, 0, fields.alb)
			},
			$author$project$Pages$Admin$AdvanceBilling$Updated);
	});
var $author$project$Pages$Admin$AdvanceBilling$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var type_ = msg.a;
				var frequency = msg.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							C: $elm$core$Maybe$Just(
								_Utils_Tuple2(
									$author$project$Utils$Form$init(
										A3($author$project$Pages$Admin$AdvanceBilling$formFieldsInit, type_, frequency, model.ZV)),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{C: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var field = msg.a;
				var _v1 = model.C;
				if (!_v1.$) {
					var _v2 = _v1.a;
					var form = _v2.a;
					var updateRequest = _v2.b;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$AdvanceBilling$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								C: $elm$core$Maybe$Just(
									_Utils_Tuple2(newForm, updateRequest))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var _v3 = model.C;
				if (!_v3.$) {
					var _v4 = _v3.a;
					var form = _v4.a;
					var _v5 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$AdvanceBilling$formFieldsValidator, form);
					if (!_v5.$) {
						var _v6 = _v5.a;
						var newForm = _v6.a;
						var validFormFields = _v6.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									C: $elm$core$Maybe$Just(
										_Utils_Tuple2(newForm, $author$project$Api$Data$Loading))
								}),
							A2($author$project$Pages$Admin$AdvanceBilling$updateAdvanceBilling, model.Gv, validFormFields),
							_List_Nil);
					} else {
						var newForm = _v5.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									C: $elm$core$Maybe$Just(
										_Utils_Tuple2(newForm, $author$project$Api$Data$NotAsked))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				var response = msg.a;
				var _v7 = model.C;
				if (!_v7.$) {
					var _v8 = _v7.a;
					var form = _v8.a;
					if (response.$ === 3) {
						var practice = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{C: $elm$core$Maybe$Nothing, ZV: practice}),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Settings successfully updated.'),
									$author$project$OutMsg$PracticeUpdated(response)
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									C: $elm$core$Maybe$Just(
										_Utils_Tuple2(form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				var id = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var notificationSetting = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bI: A3(
									$elm$core$Dict$insert,
									id,
									_Utils_Tuple3(
										notificationSetting,
										$author$project$Components$Admin$NotificationSetting$Customize$initFromOne(notificationSetting),
										A2($author$project$Components$Admin$NotificationSetting$Toggle$init, $author$project$Components$Admin$NotificationSetting$Toggle$oneGetters, notificationSetting)),
									model.bI)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 6:
				var setting = msg.a;
				var subMsg = msg.b;
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil),
					A2(
						$elm$core$Maybe$map,
						function (_v11) {
							var customize = _v11.b;
							var result = A3($author$project$Components$Admin$NotificationSetting$Customize$update, model.Gv, subMsg, customize);
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										bI: A3(
											$elm$core$Dict$update,
											$author$project$Api$Provider$NotificationSetting$One$id(setting),
											function (tuple) {
												if (!tuple.$) {
													var _v13 = tuple.a;
													var s = _v13.a;
													var t = _v13.c;
													return $elm$core$Maybe$Just(
														_Utils_Tuple3(s, result.aiO, t));
												} else {
													return $elm$core$Maybe$Nothing;
												}
											},
											model.bI)
									}),
								A2(
									$elm$core$Platform$Cmd$map,
									$author$project$Pages$Admin$AdvanceBilling$CustomizeNotificationMsg(setting),
									result.GZ),
								result.aR);
						},
						A2(
							$elm$core$Dict$get,
							$author$project$Api$Provider$NotificationSetting$One$id(setting),
							model.bI)));
			default:
				var id = msg.a;
				var toggleNotification = msg.b;
				var subMsg = msg.c;
				var _v14 = A4($author$project$Components$Admin$NotificationSetting$Toggle$update, model.Gv, $author$project$Api$Provider$Notification$PracticeContext, subMsg, toggleNotification);
				var toggleNotification_ = _v14.a;
				var subCmd = _v14.b;
				var subOutMsg = _v14.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bI: A3(
								$elm$core$Dict$update,
								id,
								$elm$core$Maybe$map(
									function (_v15) {
										var notificationSetting_ = _v15.a;
										var customize = _v15.b;
										return _Utils_Tuple3(notificationSetting_, customize, toggleNotification_);
									}),
								model.bI)
						}),
					A2(
						$elm$core$Platform$Cmd$map,
						A2($author$project$Pages$Admin$AdvanceBilling$ToggleNotificationMsg, id, toggleNotification_),
						subCmd),
					subOutMsg);
		}
	});
var $author$project$Ui$Panel$Body = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Ui$Panel$body = $author$project$Ui$Panel$Body;
var $author$project$Ui$Panel$Heading = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Ui$Panel$heading = $author$project$Ui$Panel$Heading;
var $elm$html$Html$h4 = _VirtualDom_node('h4');
var $author$project$Ui$Typography$headingSm = function (content) {
	return A2(
		$elm$html$Html$map,
		$elm$core$Basics$never,
		A2(
			$elm$html$Html$h4,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-heading-sm text-main')
				]),
			content));
};
var $author$project$Ui$Element$mb2 = $author$project$Ui$Element$Margin('mb-2');
var $author$project$Ui$Element$Muted = 0;
var $author$project$Ui$Element$Text = function (a) {
	return {$: 9, a: a};
};
var $author$project$Ui$Element$textMuted = $author$project$Ui$Element$Text(0);
var $author$project$Ui$Panel$title = function (contents) {
	return $author$project$Ui$Typography$headingSm(contents);
};
var $author$project$Ui$Panel$defaultOptions = {xs: _List_Nil, mU: $elm$core$Maybe$Nothing, JZ: 'panel-default', FG: false};
var $author$project$Ui$Panel$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 4:
						return _Utils_update(
							record,
							{FG: true});
					case 0:
						var style = option.a;
						switch (style) {
							case 0:
								return _Utils_update(
									record,
									{JZ: 'panel--primary'});
							case 1:
								return _Utils_update(
									record,
									{JZ: 'panel--success'});
							case 2:
								return _Utils_update(
									record,
									{JZ: 'panel--info'});
							case 3:
								return _Utils_update(
									record,
									{JZ: 'panel--warning'});
							default:
								return _Utils_update(
									record,
									{JZ: 'panel--danger'});
						}
					case 1:
						return _Utils_update(
							record,
							{
								xs: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class('h-full'),
									record.xs)
							});
					case 2:
						return _Utils_update(
							record,
							{
								xs: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class('p-6'),
									record.xs)
							});
					case 3:
						return _Utils_update(
							record,
							{
								xs: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class('border-left-panel'),
									record.xs)
							});
					case 5:
						var bool = option.a;
						return _Utils_update(
							record,
							{
								xs: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('panel--active', bool)
											])),
									record.xs)
							});
					case 6:
						var bool = option.a;
						return _Utils_update(
							record,
							{
								mU: $elm$core$Maybe$Just(bool)
							});
					default:
						return _Utils_update(
							record,
							{
								xs: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class('panel--tile'),
									record.xs)
							});
				}
			}),
		$author$project$Ui$Panel$defaultOptions,
		options);
};
var $elm$virtual_dom$VirtualDom$property = F2(
	function (key, value) {
		return A2(
			_VirtualDom_property,
			_VirtualDom_noInnerHtmlOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlJson(value));
	});
var $elm$html$Html$Attributes$property = $elm$virtual_dom$VirtualDom$property;
var $author$project$Ui$HorizontalRule$Default = 0;
var $author$project$Ui$HorizontalRule$baseClasses = 'w-full border-0 border-b border-subtle border-solid';
var $elm$html$Html$hr = _VirtualDom_node('hr');
var $author$project$Ui$HorizontalRule$marginClass = function (style) {
	switch (style) {
		case 0:
			return 'my-4';
		case 1:
			return 'my-2';
		default:
			return 'my-0';
	}
};
var $author$project$Ui$HorizontalRule$pickStyle = F2(
	function (_v0, _v1) {
		var s = _v0;
		return s;
	});
var $author$project$Ui$HorizontalRule$view = function (options) {
	var style = A3($elm$core$List$foldl, $author$project$Ui$HorizontalRule$pickStyle, 0, options);
	return A2(
		$elm$html$Html$hr,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class(
				$author$project$Ui$HorizontalRule$baseClasses + (' ' + $author$project$Ui$HorizontalRule$marginClass(style)))
			]),
		_List_Nil);
};
var $author$project$Ui$ListGroup$defaultOptions = {xr: _List_Nil, Gd: $elm$core$Maybe$Nothing};
var $author$project$Ui$ListGroup$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				if (!option.$) {
					var contents = option.a;
					return _Utils_update(
						record,
						{
							Gd: $elm$core$Maybe$Just(contents)
						});
				} else {
					var style_ = option.a;
					switch (style_) {
						case 0:
							return _Utils_update(
								record,
								{
									xr: A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$class('list-group--success'),
										record.xr)
								});
						case 1:
							return _Utils_update(
								record,
								{
									xr: A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$class('list-group--info'),
										record.xr)
								});
						case 2:
							return _Utils_update(
								record,
								{
									xr: A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$class('list-group--warning'),
										record.xr)
								});
						case 3:
							return _Utils_update(
								record,
								{
									xr: A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$class('list-group--danger'),
										record.xr)
								});
						default:
							return record;
					}
				}
			}),
		$author$project$Ui$ListGroup$defaultOptions,
		options);
};
var $author$project$Utils$Html$Attributes$none = $elm$html$Html$Attributes$class('');
var $author$project$Ui$ListGroup$itemOptionToAttributes = function (option) {
	switch (option.$) {
		case 0:
			var style_ = option.a;
			switch (style_) {
				case 0:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('list-group__item--success')
						]);
				case 1:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('list-group__item--info')
						]);
				case 2:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('list-group__item--warning')
						]);
				case 3:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('list-group__item--danger')
						]);
				default:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('list-group__item--header')
						]);
			}
		case 1:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('list-group__item--dashed')
				]);
		case 2:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('list-group__item--active')
				]);
		default:
			return _List_fromArray(
				[$author$project$Utils$Html$Attributes$none]);
	}
};
var $author$project$Ui$ListGroup$itemOptionsToAttributes = function (options) {
	return A2(
		$elm$core$List$map,
		$elm$html$Html$Attributes$map($elm$core$Basics$never),
		A2($elm$core$List$concatMap, $author$project$Ui$ListGroup$itemOptionToAttributes, options));
};
var $author$project$Ui$ListGroup$viewItem = function (_v0) {
	var options = _v0.a;
	var contents = _v0.b;
	return A2(
		$elm$html$Html$li,
		A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$class('list-group__item'),
			$author$project$Ui$ListGroup$itemOptionsToAttributes(options)),
		contents);
};
var $author$project$Ui$ListGroup$viewZeroState = function (zeroState_) {
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('text-center list-group__item')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(zeroState_)
			]));
};
var $author$project$Ui$ListGroup$view = F2(
	function (options, items) {
		var optionsRecord = $author$project$Ui$ListGroup$optionsToRecord(options);
		return A2(
			$elm$html$Html$ul,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('list-group'),
				optionsRecord.xr),
			_Utils_ap(
				function () {
					var _v0 = _Utils_Tuple2(
						optionsRecord.Gd,
						$elm$core$List$isEmpty(items));
					if ((!_v0.a.$) && _v0.b) {
						var zeroState_ = _v0.a.a;
						return _List_fromArray(
							[
								$author$project$Ui$ListGroup$viewZeroState(zeroState_)
							]);
					} else {
						return _List_Nil;
					}
				}(),
				A2($elm$core$List$map, $author$project$Ui$ListGroup$viewItem, items)));
	});
var $author$project$Ui$Table$defaultOptions = {
	xr: _List_Nil,
	rF: _List_Nil,
	yN: _List_fromArray(
		['table-wrapper']),
	V8: false,
	Gd: $elm$core$Maybe$Nothing
};
var $author$project$Ui$Table$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						return _Utils_update(
							record,
							{
								rF: A2($elm$core$List$cons, 'table--bordered', record.rF)
							});
					case 1:
						return _Utils_update(
							record,
							{
								rF: A2($elm$core$List$cons, 'vertical-centered', record.rF)
							});
					case 2:
						var contents = option.a;
						return _Utils_update(
							record,
							{
								Gd: $elm$core$Maybe$Just(contents)
							});
					case 3:
						var bool = option.a;
						return _Utils_update(
							record,
							{V8: bool});
					case 5:
						var classes = option.a;
						return _Utils_update(
							record,
							{yN: classes});
					default:
						var testString = option.a;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$author$project$Utils$Html$Attributes$test(testString),
									record.xr)
							});
				}
			}),
		$author$project$Ui$Table$defaultOptions,
		options);
};
var $elm$html$Html$tfoot = _VirtualDom_node('tfoot');
var $author$project$Ui$Icon$Sort = 34;
var $author$project$Ui$Icon$SortDown = 35;
var $author$project$Ui$Icon$SortUp = 36;
var $author$project$Ui$Icon$class = $author$project$Ui$Icon$Class;
var $author$project$Ui$Icon$Height = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Icon$height = $author$project$Ui$Icon$Height;
var $author$project$Ui$Table$defaultCellOptions = {xr: _List_Nil, rF: _List_Nil, rG: 1, IS: $elm$core$Maybe$Nothing, ul: 1, lv: $elm$core$Maybe$Nothing, JP: false};
var $author$project$Ui$Table$sizeToScreenPrefix = function (screenSize) {
	switch (screenSize) {
		case 0:
			return '';
		case 1:
			return 'sm:';
		case 2:
			return 'md:';
		case 3:
			return 'lg:';
		default:
			return 'xl:';
	}
};
var $author$project$Ui$Table$optionsToCellRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 3:
						var _int = option.a;
						return _Utils_update(
							record,
							{rG: _int});
					case 12:
						var _int = option.a;
						return _Utils_update(
							record,
							{ul: _int});
					case 10:
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									A2($elm$html$Html$Attributes$attribute, 'nowrap', 'nowrap'),
									record.xr)
							});
					case 9:
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									A2($elm$html$Html$Attributes$attribute, 'style', 'padding-left: 20px !important'),
									record.xr)
							});
					case 11:
						var msg = option.a;
						return _Utils_update(
							record,
							{
								IS: $elm$core$Maybe$Just(msg)
							});
					case 13:
						var bool = option.a;
						return _Utils_update(
							record,
							{JP: bool});
					case 14:
						var direction = option.a;
						return _Utils_update(
							record,
							{
								lv: $elm$core$Maybe$Just(direction)
							});
					case 7:
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class('max-w-[180px]'),
									record.xr)
							});
					case 8:
						var width = option.a;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									A2($elm$html$Html$Attributes$style, 'min-width', width),
									record.xr)
							});
					case 0:
						var attr_ = option.a;
						return _Utils_update(
							record,
							{
								xr: A2($elm$core$List$cons, attr_, record.xr)
							});
					case 16:
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									A2($elm$html$Html$Attributes$style, 'vertical-align', 'middle'),
									record.xr)
							});
					case 15:
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									A2($elm$html$Html$Attributes$style, 'vertical-align', 'bottom'),
									record.xr)
							});
					case 2:
						var alignment = option.a;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$author$project$Ui$Alignment$toClass(alignment),
									record.xr)
							});
					case 5:
						var screen = option.a;
						var span = option.b;
						var widthClass = 'w-' + ((span === 12) ? 'full' : ($elm$core$String$fromInt(span) + '/12'));
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class(
										_Utils_ap(
											$author$project$Ui$Table$sizeToScreenPrefix(screen),
											widthClass)),
									A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$class(
											$author$project$Ui$Table$sizeToScreenPrefix(screen) + 'table-cell'),
										record.xr))
							});
					case 6:
						var screenSize = option.a;
						if (!screenSize) {
							return _Utils_update(
								record,
								{
									xr: A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$class('flex-grid-hidden'),
										record.xr)
								});
						} else {
							return _Utils_update(
								record,
								{
									xr: A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$class(
											$author$project$Ui$Table$sizeToScreenPrefix(screenSize) + 'hidden'),
										record.xr)
								});
						}
					case 4:
						var screenSize = option.a;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class(
										$author$project$Ui$Table$sizeToScreenPrefix(screenSize) + 'table-cell'),
									record.xr)
							});
					default:
						var value = option.a;
						return value ? _Utils_update(
							record,
							{
								rF: A2($elm$core$List$cons, 'table__cell--active', record.rF)
							}) : record;
				}
			}),
		$author$project$Ui$Table$defaultCellOptions,
		options);
};
var $author$project$Ui$Skeleton$Span = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Ui$Skeleton$span = $author$project$Ui$Skeleton$Span(0);
var $author$project$Ui$Skeleton$innerText = function (options) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				function (option) {
					if (option.$ === 2) {
						var someText = option.a;
						return $elm$core$Maybe$Just(someText);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				options)));
};
var $author$project$Ui$Skeleton$optionToAttrs = function (option) {
	switch (option.$) {
		case 0:
			var screenSize = option.a;
			var _int = option.b;
			var width = 'w-' + ((_int === 12) ? 'full' : ($elm$core$String$fromInt(_int) + '/12'));
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					_Utils_ap(
						$author$project$Ui$ScreenSize$toClassPrefix(screenSize),
						width))
				]);
		case 1:
			var _v1 = option.a;
			return $elm$core$List$singleton(
				$elm$html$Html$Attributes$class('skeleton--block'));
		default:
			return $elm$core$List$singleton(
				$elm$html$Html$Attributes$class('w-auto'));
	}
};
var $author$project$Ui$Skeleton$view = F2(
	function (modifier, options) {
		var attrs = A3(
			$elm$core$List$foldl,
			F2(
				function (option, acc) {
					return _Utils_ap(
						acc,
						$author$project$Ui$Skeleton$optionToAttrs(option));
				}),
			_List_Nil,
			options);
		return A2(
			$elm$html$Html$span,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('skeleton--' + modifier),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('skeleton'),
					attrs)),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Ui$Skeleton$innerText(options))
				]));
	});
var $author$project$Ui$Skeleton$text = $author$project$Ui$Skeleton$view('text');
var $elm$html$Html$th = _VirtualDom_node('th');
var $author$project$Ui$Table$viewHeader = F2(
	function (loading_, _v0) {
		var _v1 = _v0;
		var options = _v1.a;
		var contents = _v1.b;
		var optionsRecord = $author$project$Ui$Table$optionsToCellRecord(options);
		var interactive = !_Utils_eq(optionsRecord.IS, $elm$core$Maybe$Nothing);
		var attributes = $elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						$elm$html$Html$Attributes$class(
						A2($elm$core$String$join, ' ', optionsRecord.rF)),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('table__cell--clickable', interactive)
							])),
						$elm$html$Html$Attributes$class('table_cell table__cell--header')
					]),
					A2(
					$elm$core$List$map,
					$elm$html$Html$Attributes$map($elm$core$Basics$never),
					optionsRecord.xr),
					function () {
					var _v4 = optionsRecord.IS;
					if (!_v4.$) {
						var toMsg = _v4.a;
						return _List_fromArray(
							[
								$elm$html$Html$Events$onClick(toMsg)
							]);
					} else {
						return _List_Nil;
					}
				}()
				]));
		return A2(
			$elm$html$Html$th,
			attributes,
			_Utils_ap(
				loading_ ? _List_fromArray(
					[
						$author$project$Ui$Skeleton$text(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$span(10)
							]))
					]) : contents,
				function () {
					var _v2 = optionsRecord.lv;
					if (!_v2.$) {
						var direction = _v2.a;
						return $elm$core$List$singleton(
							A2(
								$author$project$Ui$Icon$view,
								_List_fromArray(
									[
										$author$project$Ui$Icon$height('12px'),
										$author$project$Ui$Icon$class('ml-2 -mb-0.5')
									]),
								function () {
									if (!direction) {
										return 36;
									} else {
										return 35;
									}
								}()));
					} else {
						return optionsRecord.JP ? _List_fromArray(
							[
								A2(
								$author$project$Ui$Icon$view,
								_List_fromArray(
									[
										$author$project$Ui$Icon$height('12px'),
										$author$project$Ui$Icon$class('ml-2 -mb-0.5')
									]),
								34)
							]) : _List_Nil;
					}
				}()));
	});
var $author$project$Ui$Table$Cell = $elm$core$Basics$identity;
var $author$project$Ui$Table$cell = F2(
	function (options, content) {
		return _Utils_Tuple2(options, content);
	});
var $elm$html$Html$Attributes$colspan = function (n) {
	return A2(
		_VirtualDom_attribute,
		'colspan',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$Attributes$rowspan = function (n) {
	return A2(
		_VirtualDom_attribute,
		'rowspan',
		$elm$core$String$fromInt(n));
};
var $author$project$Ui$Table$viewCell = function (_v0) {
	var _v1 = _v0;
	var options = _v1.a;
	var content = _v1.b;
	var optionsRecord = $author$project$Ui$Table$optionsToCellRecord(options);
	var attributes = $elm$core$List$concat(
		_List_fromArray(
			[
				_List_fromArray(
				[
					$elm$html$Html$Attributes$class('table__cell')
				]),
				A2(
				$elm$core$List$map,
				$elm$html$Html$Attributes$map($elm$core$Basics$never),
				optionsRecord.xr),
				_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					A2($elm$core$String$join, ' ', optionsRecord.rF))
				]),
				(optionsRecord.rG !== 1) ? _List_fromArray(
				[
					$elm$html$Html$Attributes$colspan(optionsRecord.rG)
				]) : _List_Nil,
				(optionsRecord.ul !== 1) ? _List_fromArray(
				[
					$elm$html$Html$Attributes$rowspan(optionsRecord.ul)
				]) : _List_Nil
			]));
	return A2($elm$html$Html$td, attributes, content);
};
var $author$project$Ui$Table$viewLoading = function (colspan_) {
	return A2(
		$elm$core$List$repeat,
		10,
		A2(
			$elm$html$Html$tr,
			_List_Nil,
			A2(
				$elm$core$List$map,
				$author$project$Ui$Table$viewCell,
				A2(
					$elm$core$List$repeat,
					colspan_,
					A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$text(
								_List_fromArray(
									[
										$author$project$Ui$Skeleton$span(10)
									]))
							]))))));
};
var $author$project$Ui$Table$defaultRowOptions = {xr: _List_Nil, rF: _List_Nil};
var $author$project$Ui$Table$optionsToRowRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				if (!option.$) {
					var color_ = option.a;
					switch (color_) {
						case 1:
							return _Utils_update(
								record,
								{
									rF: A2($elm$core$List$cons, 'table__row--info', record.rF)
								});
						case 0:
							return _Utils_update(
								record,
								{
									rF: A2($elm$core$List$cons, 'table__row--success', record.rF)
								});
						case 2:
							return _Utils_update(
								record,
								{
									rF: A2($elm$core$List$cons, 'table__row--warning', record.rF)
								});
						default:
							return _Utils_update(
								record,
								{
									rF: A2($elm$core$List$cons, 'table__row--danger', record.rF)
								});
					}
				} else {
					return _Utils_update(
						record,
						{
							rF: A2($elm$core$List$cons, 'table__row--indented', record.rF)
						});
				}
			}),
		$author$project$Ui$Table$defaultRowOptions,
		options);
};
var $author$project$Ui$Table$viewRow = function (row_) {
	if (row_.$ === 1) {
		var _v1 = row_.a;
		var options = _v1.a;
		var cells = _v1.b;
		var optionsRecord = $author$project$Ui$Table$optionsToRowRecord(options);
		var attributes = _List_fromArray(
			[
				$elm$html$Html$Attributes$class('table__row'),
				$elm$html$Html$Attributes$class(
				A2($elm$core$String$join, ' ', optionsRecord.rF))
			]);
		return A2(
			$elm$html$Html$tr,
			attributes,
			A2($elm$core$List$map, $author$project$Ui$Table$viewCell, cells));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Ui$Table$viewZeroState = F2(
	function (contents, colspan_) {
		return A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('table__row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('table__cell'),
							$elm$html$Html$Attributes$colspan(colspan_),
							$elm$html$Html$Attributes$class('text-center')
						]),
					contents)
				]));
	});
var $author$project$Ui$Table$view = F4(
	function (options, headers, rows, footers) {
		var optionsRecord = $author$project$Ui$Table$optionsToRecord(options);
		var mainContainerClasses = A2($elm$core$String$join, ' ', optionsRecord.yN);
		var classes = A2($elm$core$List$cons, 'table', optionsRecord.rF);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(mainContainerClasses)
				]),
			$elm$core$List$singleton(
				A2(
					$elm$html$Html$table,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class(
							A2($elm$core$String$join, ' ', classes)),
						A2(
							$elm$core$List$map,
							$elm$html$Html$Attributes$map($elm$core$Basics$never),
							optionsRecord.xr)),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$thead,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									A2(
										$elm$core$List$map,
										$author$project$Ui$Table$viewHeader(optionsRecord.V8),
										headers))
								])),
							A2(
							$elm$html$Html$tbody,
							_List_Nil,
							function () {
								var _v0 = _Utils_Tuple3(
									optionsRecord.V8,
									optionsRecord.Gd,
									$elm$core$List$isEmpty(rows));
								if (_v0.a) {
									return $author$project$Ui$Table$viewLoading(
										$elm$core$List$length(headers));
								} else {
									if ((!_v0.b.$) && _v0.c) {
										var contents = _v0.b.a;
										return _List_fromArray(
											[
												A2(
												$author$project$Ui$Table$viewZeroState,
												contents,
												$elm$core$List$length(headers))
											]);
									} else {
										return A2($elm$core$List$map, $author$project$Ui$Table$viewRow, rows);
									}
								}
							}()),
							$elm$core$List$isEmpty(footers) ? $author$project$Utils$Html$empty : A2(
							$elm$html$Html$tfoot,
							_List_Nil,
							A2($elm$core$List$map, $author$project$Ui$Table$viewRow, footers))
						]))));
	});
var $author$project$Ui$Panel$sectionToContents = F2(
	function (optionsRecord, section) {
		switch (section.$) {
			case 0:
				var attributes = section.a;
				var contents = section.b;
				var _v1 = optionsRecord.mU;
				if (!_v1.$) {
					var isCollapsed = _v1.a;
					var chevron = A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('panel__heading__chevron')
							]),
						_List_fromArray(
							[
								$author$project$Ui$Icon$chevronDown(
								_List_fromArray(
									[$author$project$Ui$Icon$xs]))
							]));
					var checkbox = A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('checkbox'),
								$elm$html$Html$Attributes$class('panel__checkbox'),
								A2(
								$elm$html$Html$Attributes$property,
								'defaultChecked',
								$elm$json$Json$Encode$bool(isCollapsed))
							]),
						_List_Nil);
					return $elm$core$Maybe$Just(
						A4(
							$author$project$Ui$Element$customNode,
							'label',
							'panel__heading',
							attributes,
							A2(
								$elm$core$List$cons,
								checkbox,
								_Utils_ap(
									contents,
									_List_fromArray(
										[chevron])))));
				} else {
					return $elm$core$Maybe$Just(
						A3($author$project$Ui$Element$custom, 'panel__heading', attributes, contents));
				}
			case 1:
				var attributes = section.a;
				var contents = section.b;
				return $elm$core$Maybe$Just(
					A3($author$project$Ui$Element$custom, 'panel__body', attributes, contents));
			case 2:
				var attributes = section.a;
				var contents = section.b;
				return $elm$core$Maybe$Just(
					A3($author$project$Ui$Element$custom, 'panel__footer', attributes, contents));
			case 3:
				var options = section.a;
				var headers = section.b;
				var rows = section.c;
				var footers = section.d;
				return $elm$core$Maybe$Just(
					A4($author$project$Ui$Table$view, options, headers, rows, footers));
			case 4:
				var options = section.a;
				var items = section.b;
				return $elm$core$Maybe$Just(
					A2($author$project$Ui$ListGroup$view, options, items));
			case 5:
				return $elm$core$Maybe$Just(
					$author$project$Ui$HorizontalRule$view(_List_Nil));
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Ui$Panel$sectionsToContents = F2(
	function (optionsRecord, sections) {
		return A2(
			$elm$core$List$filterMap,
			$author$project$Ui$Panel$sectionToContents(optionsRecord),
			sections);
	});
var $author$project$Ui$Panel$view = F2(
	function (options, sections) {
		var optionsRecord = $author$project$Ui$Panel$optionsToRecord(options);
		var isCollapsible = !_Utils_eq(optionsRecord.mU, $elm$core$Maybe$Nothing);
		var isCollapsed = A2($elm$core$Maybe$withDefault, false, optionsRecord.mU);
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('panel'),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class(optionsRecord.JZ),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('panel--subtle', optionsRecord.FG),
									_Utils_Tuple2('panel--collapsible', isCollapsible),
									_Utils_Tuple2('panel--collapsed', isCollapsed)
								])),
						optionsRecord.xs))),
			A2($author$project$Ui$Panel$sectionsToContents, optionsRecord, sections));
	});
var $author$project$Pages$Admin$AdvanceBilling$Autopay = 0;
var $author$project$Pages$Admin$AdvanceBilling$Edit = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Pages$Admin$AdvanceBilling$Monthly = 0;
var $author$project$Pages$Admin$AdvanceBilling$NonMonthly = 1;
var $author$project$Ui$Table$Grid = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Ui$Table$Xs = 0;
var $author$project$Ui$Table$cellSpan = $author$project$Ui$Table$Grid(0);
var $author$project$Ui$Icon$Edit = 39;
var $author$project$Ui$Icon$edit = $author$project$Ui$Icon$viewIcon(39);
var $author$project$Ui$Element$Display = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Ui$Element$Flex = 2;
var $author$project$Ui$Element$flex = A2($author$project$Ui$Element$Display, 0, 2);
var $author$project$Ui$Table$Header = $elm$core$Basics$identity;
var $author$project$Ui$Table$header = F2(
	function (options, contents) {
		return _Utils_Tuple2(options, contents);
	});
var $author$project$Ui$Table$Row = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Table$row = F2(
	function (options, cells) {
		return $author$project$Ui$Table$Row(
			_Utils_Tuple2(options, cells));
	});
var $author$project$Ui$Button$Size = function (a) {
	return {$: 8, a: a};
};
var $author$project$Ui$Button$Sm = 0;
var $author$project$Ui$Button$sm = $author$project$Ui$Button$Size(0);
var $author$project$Formatters$String$vowels = _List_fromArray(
	['a', 'e', 'i', 'o', 'u']);
var $author$project$Formatters$String$endsWithConsonantAndY = function (word) {
	var lastTwoChars = $elm$core$String$toList(
		A2($elm$core$String$right, 2, word));
	if (((lastTwoChars.b && lastTwoChars.b.b) && ('y' === lastTwoChars.b.a)) && (!lastTwoChars.b.b.b)) {
		var _char = lastTwoChars.a;
		var _v1 = lastTwoChars.b;
		return !A2($elm$core$List$member, _char, $author$project$Formatters$String$vowels);
	} else {
		return false;
	}
};
var $author$project$Formatters$String$endsWithS = function (word) {
	var lastChar = A2($elm$core$String$right, 1, word);
	return lastChar === 's';
};
var $author$project$Formatters$String$pluralOf = function (singular) {
	if (singular === 'child') {
		return 'children';
	} else {
		return $author$project$Formatters$String$endsWithConsonantAndY(singular) ? (A2($elm$core$String$dropRight, 1, singular) + 'ies') : ($author$project$Formatters$String$endsWithS(singular) ? singular : (singular + 's'));
	}
};
var $elm_community$string_extra$String$Extra$pluralize = F3(
	function (singular, plural, count) {
		return (count === 1) ? ('1 ' + singular) : ($elm$core$String$fromInt(count) + (' ' + plural));
	});
var $author$project$Formatters$String$pluralize = F2(
	function (singular, count) {
		var plural = $author$project$Formatters$String$pluralOf(singular);
		return A3($elm_community$string_extra$String$Extra$pluralize, singular, plural, count);
	});
var $author$project$Formatters$Int$toDays = $author$project$Formatters$String$pluralize('day');
var $author$project$Components$Admin$NotificationSetting$Customize$OpenModal = {$: 0};
var $author$project$Api$Provider$NotificationSetting$Meta$bodyEditable = function (_v0) {
	var meta = _v0;
	return meta.fO.Q4;
};
var $author$project$Api$Provider$NotificationSetting$Shared$meta = function (_v0) {
	var record = _v0;
	return record.W4;
};
var $author$project$Components$Admin$NotificationSetting$Customize$button = function (model) {
	return $author$project$Api$Provider$NotificationSetting$Meta$bodyEditable(
		$author$project$Api$Provider$NotificationSetting$Shared$meta(model.X_)) ? A3(
		$author$project$Ui$Button$view,
		{mm: 'Customize notification'},
		_List_fromArray(
			[
				$author$project$Ui$Button$link,
				$author$project$Ui$Button$onClick($author$project$Components$Admin$NotificationSetting$Customize$OpenModal)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Customize')
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Ui$Modal$Body = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Modal$body = function (contents) {
	return $author$project$Ui$Modal$Body(contents);
};
var $author$project$Ui$Modal$Footer = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Modal$footer = function (contents) {
	return $author$project$Ui$Modal$Footer(contents);
};
var $author$project$Ui$Modal$Header = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Modal$header = function (contents) {
	return $author$project$Ui$Modal$Header(contents);
};
var $author$project$Api$Provider$NotificationSetting$Shared$shortDescriptionHtml = function (_v0) {
	var record = _v0;
	return record.abd;
};
var $author$project$Ui$Modal$title = function (string) {
	return A2(
		$elm$html$Html$h4,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal__title')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(string)
			]));
};
var $elm$html$Html$form = _VirtualDom_node('form');
var $elm$html$Html$Events$alwaysPreventDefault = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $elm$html$Html$Events$onSubmit = function (msg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'submit',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysPreventDefault,
			$elm$json$Json$Decode$succeed(msg)));
};
var $author$project$Ui$Modal$Md = 0;
var $author$project$Ui$Modal$defaultOptions = {r1: true, B5: $elm$core$Maybe$Nothing, aly: 0};
var $author$project$Ui$Modal$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var size_ = option.a;
						return _Utils_update(
							record,
							{aly: size_});
					case 1:
						var bool = option.a;
						return _Utils_update(
							record,
							{r1: bool});
					default:
						var msg = option.a;
						return _Utils_update(
							record,
							{
								B5: $elm$core$Maybe$Just(msg)
							});
				}
			}),
		$author$project$Ui$Modal$defaultOptions,
		options);
};
var $author$project$Ui$Modal$sizeClass = function (size_) {
	if (!size_) {
		return '';
	} else {
		return 'modal__dialog--lg';
	}
};
var $author$project$Ui$Modal$viewBackdrop = function (onClose) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal__backdrop'),
				A2($elm$html$Html$Attributes$style, 'position', 'fixed'),
				A2($elm$html$Html$Attributes$style, 'inset', '0px'),
				A2($elm$html$Html$Attributes$style, 'z-index', '1040'),
				$elm$html$Html$Events$onClick(onClose)
			]),
		_List_Nil);
};
var $author$project$Utils$Html$multiplication = $elm$html$Html$text(
	$elm$core$String$fromChar('×'));
var $author$project$Ui$Modal$closeButton = function (onClose) {
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$type_('button'),
				$elm$html$Html$Attributes$class('button close'),
				A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Close'),
				$elm$html$Html$Events$onClick(onClose)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
					]),
				_List_fromArray(
					[$author$project$Utils$Html$multiplication]))
			]));
};
var $author$project$Ui$Modal$viewSection = F3(
	function (dismisiable_, onCloseMsg, section) {
		switch (section.$) {
			case 0:
				var contents = section.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('modal__header')
						]),
					dismisiable_ ? A2(
						$elm$core$List$cons,
						$author$project$Ui$Modal$closeButton(onCloseMsg),
						contents) : contents);
			case 1:
				var contents = section.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('modal__body')
						]),
					contents);
			case 2:
				var sectionTitle = section.a;
				var contents = section.b;
				return A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('modal__collapsible')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('checkbox'),
									$elm$html$Html$Attributes$class('modal__collapsible__checkbox'),
									A2(
									$elm$html$Html$Attributes$property,
									'defaultChecked',
									$elm$json$Json$Encode$bool(true))
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('modal__collapsible__header')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(sectionTitle)
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('modal__collapsible__chevron')
										]),
									_List_fromArray(
										[
											$author$project$Ui$Icon$chevronDown(
											_List_fromArray(
												[$author$project$Ui$Icon$xs]))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('modal__collapsible__body')
								]),
							contents)
						]));
			default:
				var contents = section.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('modal__footer')
						]),
					contents);
		}
	});
var $author$project$Ui$Modal$view = F3(
	function (onClose, options, sections) {
		var optionsRecord = $author$project$Ui$Modal$optionsToRecord(options);
		var wrapInsideForm = function (htmlSections) {
			var _v0 = optionsRecord.B5;
			if (!_v0.$) {
				var msg = _v0.a;
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$form,
						_List_fromArray(
							[
								$elm$html$Html$Events$onSubmit(msg)
							]),
						htmlSections)
					]);
			} else {
				return htmlSections;
			}
		};
		return function (content) {
			return A3(
				$elm$html$Html$node,
				'elm-modal',
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('elm-modal show'),
						$elm$html$Html$Attributes$tabindex(-1),
						A2($elm$html$Html$Attributes$attribute, 'role', 'dialog')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Modal$viewBackdrop(onClose),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('modal__dialog'),
								$elm$html$Html$Attributes$class(
								$author$project$Ui$Modal$sizeClass(optionsRecord.aly)),
								A2($elm$html$Html$Attributes$attribute, 'role', 'document')
							]),
						_List_fromArray(
							[content]))
					]));
		}(
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('modal__content')
					]),
				wrapInsideForm(
					A2(
						$elm$core$List$map,
						A2($author$project$Ui$Modal$viewSection, optionsRecord.r1, onClose),
						sections))));
	});
var $author$project$Components$Admin$NotificationSetting$Customize$Subject = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$NotificationSettingPreview$body = function (_v0) {
	var record = _v0;
	return record.fO;
};
var $elm$html$Html$br = _VirtualDom_node('br');
var $author$project$Ui$Alert$Danger = 3;
var $author$project$Ui$Alert$dismissButton = function (msg) {
	return A3(
		$author$project$Ui$Button$view,
		{mm: 'Dismiss alert'},
		_List_fromArray(
			[
				$author$project$Ui$Button$onClick(msg)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Icon$cross(_List_Nil)
			]));
};
var $author$project$Ui$Alert$defaultOptions = {xr: _List_Nil, r1: $elm$core$Maybe$Nothing, u$: $elm$core$Maybe$Nothing};
var $author$project$Ui$Alert$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var msg = option.a;
						return _Utils_update(
							record,
							{
								r1: $elm$core$Maybe$Just(msg)
							});
					case 4:
						var list = option.a;
						return _Utils_update(
							record,
							{
								xr: _Utils_ap(record.xr, list)
							});
					case 1:
						var alignment_ = option.a;
						return _Utils_update(
							record,
							{
								xr: _Utils_ap(
									$author$project$Ui$Alignment$toAttrs(alignment_),
									record.xr)
							});
					case 2:
						var svgIcon = option.a;
						return _Utils_update(
							record,
							{
								u$: $elm$core$Maybe$Just(svgIcon)
							});
					default:
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class('h-full'),
									record.xr)
							});
				}
			}),
		$author$project$Ui$Alert$defaultOptions,
		options);
};
var $author$project$Ui$Alert$styleClass = function (style) {
	switch (style) {
		case 0:
			return 'alert--success';
		case 1:
			return 'alert--info';
		case 2:
			return 'alert--warning';
		case 3:
			return 'alert--danger';
		default:
			return 'alert--primary';
	}
};
var $author$project$Ui$Icon$Width = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Icon$width = $author$project$Ui$Icon$Width;
var $author$project$Ui$Alert$view = F3(
	function (style, options, contents) {
		var optionsRecord = $author$project$Ui$Alert$optionsToRecord(options);
		var hasFullHeight = A2(
			$elm$core$List$any,
			function (opt) {
				if (opt.$ === 3) {
					return true;
				} else {
					return false;
				}
			},
			options);
		var attributes = $elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						$elm$html$Html$Attributes$class('alert'),
						$elm$html$Html$Attributes$class(
						$author$project$Ui$Alert$styleClass(style)),
						A2($elm$html$Html$Attributes$attribute, 'role', 'alert')
					]),
					A2(
					$elm$core$List$map,
					$elm$html$Html$Attributes$map($elm$core$Basics$never),
					optionsRecord.xr),
					function () {
					var _v2 = optionsRecord.r1;
					if (!_v2.$) {
						return _List_fromArray(
							[
								$elm$html$Html$Attributes$class('alert--dismissible')
							]);
					} else {
						return _List_Nil;
					}
				}(),
					function () {
					var _v3 = optionsRecord.u$;
					if (!_v3.$) {
						return _List_fromArray(
							[
								$elm$html$Html$Attributes$class('alert--icon')
							]);
					} else {
						return _List_Nil;
					}
				}()
				]));
		return A2(
			$elm$html$Html$div,
			attributes,
			$elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						var _v0 = optionsRecord.u$;
						if (!_v0.$) {
							var msg = _v0.a;
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Icon$view,
									_List_fromArray(
										[
											$author$project$Ui$Icon$width('24px'),
											$author$project$Ui$Icon$height('24px')
										]),
									msg)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$class('alert--contents'),
								hasFullHeight ? _List_fromArray(
									[
										$elm$html$Html$Attributes$class('h-full')
									]) : _List_Nil),
							contents)
						]),
						function () {
						var _v1 = optionsRecord.r1;
						if (!_v1.$) {
							var msg = _v1.a;
							return _List_fromArray(
								[
									$author$project$Ui$Alert$dismissButton(msg)
								]);
						} else {
							return _List_Nil;
						}
					}()
					])));
	});
var $author$project$Ui$Alert$danger = $author$project$Ui$Alert$view(3);
var $author$project$Api$Data$errorToString = function (errorResponse) {
	switch (errorResponse.$) {
		case 0:
			var errorMessage = errorResponse.a;
			return A2($elm$core$Maybe$withDefault, 'Unauthorized', errorMessage);
		case 1:
			return 'BadUrl';
		case 2:
			return 'Timeout';
		case 3:
			return 'Network';
		case 4:
			return 'Server Error';
		case 5:
			return 'Not Found';
		case 8:
			var errorMessage = errorResponse.a;
			return A2($elm$core$Maybe$withDefault, 'Internal Server Error', errorMessage);
		case 6:
			var errorMessage = errorResponse.b;
			return errorMessage;
		case 7:
			var string = errorResponse.a;
			return 'Decoder error! ' + string;
		case 9:
			var errorMessage = errorResponse.a;
			return A2($elm$core$Maybe$withDefault, 'Forbidden', errorMessage);
		default:
			var errorMessage = errorResponse.a;
			return A2($elm$core$Maybe$withDefault, 'Conflict', errorMessage);
	}
};
var $author$project$Ui$Form$Textarea$Id = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$Textarea$id = $author$project$Ui$Form$Textarea$Id;
var $author$project$Ui$Form$Input$Phi = function (a) {
	return {$: 8, a: a};
};
var $author$project$Ui$Form$Input$phi = $author$project$Ui$Form$Input$Phi;
var $author$project$Ui$Form$Textarea$Phi = function (a) {
	return {$: 7, a: a};
};
var $author$project$Ui$Form$Textarea$phi = $author$project$Ui$Form$Textarea$Phi;
var $author$project$Ui$Typography$Phi = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Typography$phi = $author$project$Ui$Typography$Phi;
var $author$project$Ui$Link$Route = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Link$defaultOptions = {xr: _List_Nil, cn: false, nV: $elm$core$Maybe$Nothing, ahO: $elm$core$Maybe$Nothing, sB: _List_Nil, z7: $elm$core$Maybe$Nothing, sC: _List_Nil, e: $elm$core$Maybe$Nothing, p: _List_Nil, u1: 0};
var $author$project$Ui$Icon$Md = 2;
var $author$project$Ui$Icon$base = $author$project$Ui$Icon$Size(2);
var $author$project$Ui$Link$sizeToIconSize = function (size_) {
	switch (size_) {
		case 1:
			return _List_fromArray(
				[$author$project$Ui$Icon$xs]);
		case 0:
			return _List_fromArray(
				[$author$project$Ui$Icon$sm]);
		case 2:
			return _List_fromArray(
				[$author$project$Ui$Icon$base]);
		default:
			return _List_fromArray(
				[$author$project$Ui$Icon$lg]);
	}
};
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $author$project$Ui$Link$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var route_ = option.a;
						return _Utils_update(
							record,
							{
								e: $elm$core$Maybe$Just(route_)
							});
					case 1:
						var list = option.a;
						return _Utils_update(
							record,
							{
								p: _Utils_ap(list, record.p)
							});
					case 2:
						var string = option.a;
						return _Utils_update(
							record,
							{
								nV: $elm$core$Maybe$Just(string)
							});
					case 3:
						var string = option.a;
						return _Utils_update(
							record,
							{
								nV: $elm$core$Maybe$Just('mailto:' + string)
							});
					case 4:
						var string = option.a;
						return _Utils_update(
							record,
							{
								nV: $elm$core$Maybe$Just('tel:' + string)
							});
					case 5:
						var string = option.a;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$author$project$Utils$Html$Attributes$test(string),
									record.xr)
							});
					case 8:
						var msg = option.a;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$elm$html$Html$Events$onClick(msg),
									record.xr)
							});
					case 6:
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$target('_blank'),
									record.xr)
							});
					case 7:
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class('w-full block'),
									record.xr)
							});
					case 9:
						var bool = option.a;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$disabled(bool),
									A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('disabled', bool)
												])),
										record.xr))
							});
					case 10:
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class('text-muted pointer'),
									record.xr)
							});
					case 12:
						var size = option.a;
						var modifier = function () {
							switch (size) {
								case 1:
									return '--xs';
								case 0:
									return '--sm';
								case 2:
									return '--md';
								default:
									return '--lg';
							}
						}();
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class('link' + modifier),
									A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('button' + modifier, record.cn)
												])),
										record.xr)),
								sB: _Utils_ap(
									$author$project$Ui$Link$sizeToIconSize(size),
									record.sB),
								sC: _Utils_ap(
									$author$project$Ui$Link$sizeToIconSize(size),
									record.sC)
							});
					case 11:
						var style_ = option.a;
						switch (style_) {
							case 0:
								return _Utils_update(
									record,
									{
										xr: A2(
											$elm$core$List$cons,
											$elm$html$Html$Attributes$class('button button--primary'),
											record.xr),
										cn: true
									});
							case 1:
								return _Utils_update(
									record,
									{
										xr: A2(
											$elm$core$List$cons,
											$elm$html$Html$Attributes$class('button button--success'),
											record.xr),
										cn: true
									});
							case 2:
								return _Utils_update(
									record,
									{
										xr: A2(
											$elm$core$List$cons,
											$elm$html$Html$Attributes$class('button button--default'),
											record.xr),
										cn: true
									});
							case 3:
								return _Utils_update(
									record,
									{
										xr: A2(
											$elm$core$List$cons,
											$elm$html$Html$Attributes$class('button button--secondary'),
											record.xr),
										cn: true
									});
							case 4:
								return _Utils_update(
									record,
									{
										xr: A2(
											$elm$core$List$cons,
											$elm$html$Html$Attributes$class('button button--info'),
											record.xr),
										cn: true
									});
							case 5:
								return _Utils_update(
									record,
									{
										xr: A2(
											$elm$core$List$cons,
											$elm$html$Html$Attributes$class('button button--warning'),
											record.xr),
										cn: true
									});
							case 6:
								return _Utils_update(
									record,
									{
										xr: A2(
											$elm$core$List$cons,
											$elm$html$Html$Attributes$class('button button--warning-inverse'),
											record.xr),
										cn: true
									});
							default:
								return _Utils_update(
									record,
									{
										xr: A2(
											$elm$core$List$cons,
											$elm$html$Html$Attributes$class('underline'),
											record.xr)
									});
						}
					case 13:
						var icon_ = option.a;
						return _Utils_update(
							record,
							{
								ahO: $elm$core$Maybe$Just(icon_)
							});
					case 14:
						var iconRight_ = option.a;
						return _Utils_update(
							record,
							{
								z7: $elm$core$Maybe$Just(iconRight_)
							});
					case 15:
						var label = option.a;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									A2($elm$html$Html$Attributes$attribute, 'aria-label', label),
									record.xr)
							});
					case 16:
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class('text-current'),
									record.xr)
							});
					default:
						var _int = option.a;
						return _Utils_update(
							record,
							{u1: _int});
				}
			}),
		$author$project$Ui$Link$defaultOptions,
		options);
};
var $author$project$Ui$Link$view = F2(
	function (options, content) {
		var optionsRecord = $author$project$Ui$Link$optionsToRecord(options);
		return A2(
			$elm$html$Html$a,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('link', !optionsRecord.cn)
								]))
						]),
						function () {
						var _v0 = _Utils_Tuple2(optionsRecord.e, optionsRecord.nV);
						if (!_v0.a.$) {
							var route_ = _v0.a.a;
							return _List_fromArray(
								[
									$elm$html$Html$Attributes$href(
									_Utils_ap(
										$author$project$Spa$Generated$Route$toString(route_),
										$elm$url$Url$Builder$toQuery(optionsRecord.p)))
								]);
						} else {
							if (!_v0.b.$) {
								var _v1 = _v0.a;
								var string = _v0.b.a;
								return _List_fromArray(
									[
										$elm$html$Html$Attributes$href(string)
									]);
							} else {
								var _v2 = _v0.a;
								var _v3 = _v0.b;
								return _List_Nil;
							}
						}
					}(),
						_List_fromArray(
						[
							$elm$html$Html$Attributes$tabindex(optionsRecord.u1)
						]),
						optionsRecord.xr
					])),
			_List_fromArray(
				[
					function () {
					var _v4 = optionsRecord.ahO;
					if (!_v4.$) {
						var icon_ = _v4.a;
						return icon_(optionsRecord.sB);
					} else {
						return $elm$html$Html$text('');
					}
				}(),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('link__content')
						]),
					A2(
						$elm$core$List$map,
						$elm$html$Html$map($elm$core$Basics$never),
						content)),
					function () {
					var _v5 = optionsRecord.z7;
					if (!_v5.$) {
						var iconRight_ = _v5.a;
						return A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ml-2')
								]),
							_List_fromArray(
								[
									iconRight_(optionsRecord.sC)
								]));
					} else {
						return $elm$html$Html$text('');
					}
				}()
				]));
	});
var $author$project$Ui$Link$route = F3(
	function (route_, options, content) {
		return A2(
			$author$project$Ui$Link$view,
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Link$Route(route_),
				options),
			content);
	});
var $author$project$Ui$Form$Textarea$Rows = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$Textarea$rows = $author$project$Ui$Form$Textarea$Rows;
var $elm$html$Html$strong = _VirtualDom_node('strong');
var $author$project$Ui$Typography$strong = F2(
	function (options, content) {
		return A2(
			$elm$html$Html$strong,
			$author$project$Ui$Typography$optionsToAttributes(options),
			A2(
				$elm$core$List$map,
				$elm$html$Html$map($elm$core$Basics$never),
				content));
	});
var $author$project$Api$Provider$NotificationSettingPreview$subject = function (_v0) {
	var record = _v0;
	return record.J_;
};
var $author$project$Ui$Element$Small = 1;
var $author$project$Ui$Element$textSm = $author$project$Ui$Element$Text(1);
var $author$project$Api$HtmlTemplate$view = F2(
	function (attributes, _v0) {
		var html = _v0;
		return A3(
			$elm$html$Html$node,
			'html-template',
			A2(
				$elm$core$List$cons,
				A2($elm$html$Html$Attributes$attribute, 'contents', html),
				attributes),
			_List_Nil);
	});
var $author$project$Ui$Form$Textarea$disableGrammarly = _List_fromArray(
	[
		A2($elm$html$Html$Attributes$attribute, 'data-gramm_editor', 'false'),
		A2($elm$html$Html$Attributes$attribute, 'data-gramm', 'false'),
		A2($elm$html$Html$Attributes$attribute, 'data-enable-grammarly', 'false')
	]);
var $author$project$Ui$Form$Textarea$defaultOptions = {xr: $author$project$Ui$Form$Textarea$disableGrammarly, agX: _List_Nil, zT: false, sM: false, vt: _List_Nil};
var $elm$html$Html$Attributes$rows = function (n) {
	return A2(
		_VirtualDom_attribute,
		'rows',
		$elm$core$String$fromInt(n));
};
var $author$project$Ui$Form$Textarea$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var string = option.a;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$id(string),
									record.xr)
							});
					case 1:
						var _int = option.a;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$rows(_int),
									record.xr)
							});
					case 2:
						var handler = option.a;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$elm$html$Html$Events$onInput(handler),
									record.xr)
							});
					case 3:
						var handler = option.a;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$elm$html$Html$Events$onBlur(handler),
									record.xr)
							});
					case 4:
						var string = option.a;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$value(string),
									record.xr)
							});
					case 5:
						var bool = option.a;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('form-control--errored', bool)
											])),
									A2(
										$elm$core$List$cons,
										A2(
											$elm$html$Html$Attributes$attribute,
											'aria-invalid',
											bool ? 'true' : 'false'),
										record.xr)),
								sM: bool
							});
					case 6:
						var list = option.a;
						return _Utils_update(
							record,
							{agX: list});
					case 7:
						var bool = option.a;
						var phiAttrs = bool ? $author$project$Api$Phi$inputAttr : _List_Nil;
						return _Utils_update(
							record,
							{
								xr: _Utils_ap(phiAttrs, record.xr)
							});
					case 8:
						var string = option.a;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$placeholder(string),
									record.xr)
							});
					case 9:
						var bool = option.a;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$disabled(bool),
									A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('disabled', bool)
												])),
										record.xr))
							});
					case 10:
						var string = option.a;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$author$project$Utils$Html$Attributes$test(string),
									record.xr)
							});
					case 11:
						var string = option.a;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									A2($elm$html$Html$Attributes$style, 'min-height', string),
									record.xr)
							});
					default:
						var bool = option.a;
						return _Utils_update(
							record,
							{zT: bool});
				}
			}),
		$author$project$Ui$Form$Textarea$defaultOptions,
		options);
};
var $elm$html$Html$textarea = _VirtualDom_node('textarea');
var $author$project$Ui$Form$Textarea$viewErrors = function (option) {
	if (option.$ === 6) {
		var errors_ = option.a;
		return $author$project$Utils$FormErrors$view(errors_);
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Ui$Form$Textarea$view = function (options) {
	var optionsRecord = $author$project$Ui$Form$Textarea$optionsToRecord(options);
	var errorDescription = $elm$core$List$isEmpty(optionsRecord.agX) ? _List_Nil : _List_fromArray(
		[
			A2(
			$elm$html$Html$Attributes$attribute,
			'aria-describedby',
			A2($elm$core$String$join, '. ', optionsRecord.agX))
		]);
	return A2(
		$elm$html$Html$div,
		A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$class('input-wrapper'),
			optionsRecord.vt),
		$elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						A2(
						$elm$html$Html$textarea,
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class('form-control'),
							_Utils_ap(errorDescription, optionsRecord.xr)),
						_List_Nil)
					]),
					optionsRecord.zT ? _List_Nil : A2($elm$core$List$map, $author$project$Ui$Form$Textarea$viewErrors, options)
				])));
};
var $author$project$Ui$Well$optionToAttrs = function (option) {
	switch (option.$) {
		case 0:
			var size = option.a;
			switch (size) {
				case 0:
					return _List_Nil;
				case 1:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('well--sm'),
							$elm$html$Html$Attributes$class('max-w-sm')
						]);
				case 2:
					return _List_Nil;
				default:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('well--lg')
						]);
			}
		case 1:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('border-0')
				]);
		default:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('w-full')
				]);
	}
};
var $author$project$Ui$Well$view = F2(
	function (options, content) {
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('well'),
				A2($elm$core$List$concatMap, $author$project$Ui$Well$optionToAttrs, options)),
			content);
	});
var $author$project$Components$Admin$NotificationSetting$Customize$LanguageSelected = function (a) {
	return {$: 16, a: a};
};
var $author$project$Api$Provider$NotificationSetting$Shared$description = function (_v0) {
	var record = _v0;
	return record.Qr;
};
var $author$project$Ui$Link$ExternalHref = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Link$externalHref = F3(
	function (externalHref_, options, content) {
		return A2(
			$author$project$Ui$Link$view,
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Link$ExternalHref(externalHref_),
				options),
			content);
	});
var $author$project$Ui$Alert$Info = 1;
var $author$project$Ui$Alert$info = $author$project$Ui$Alert$view(1);
var $author$project$Ui$Form$Group$inputSpan = function (span) {
	return $author$project$Ui$Form$Group$InputGrid(
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$spanToWidthClass(span)
			]));
};
var $author$project$Ui$Form$Group$labelSpan = function (span) {
	return $author$project$Ui$Form$Group$LabelGrid(
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$spanToWidthClass(span)
			]));
};
var $author$project$Language$spanish = 1;
var $author$project$Ui$Link$TargetBlank = {$: 6};
var $author$project$Ui$Link$targetBlank = $author$project$Ui$Link$TargetBlank;
var $author$project$Language$toLabel = function (lang) {
	if (!lang) {
		return 'English';
	} else {
		return 'Spanish';
	}
};
var $author$project$Components$Admin$NotificationSetting$Customize$viewPreview = F4(
	function (notificationSetting, subject, body, model) {
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Alert$info,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Liquid syntax is used to build this email. '),
						A3(
						$author$project$Ui$Link$externalHref,
						'http://shopify.github.io/liquid/basics/introduction/',
						_List_fromArray(
							[$author$project$Ui$Link$targetBlank]),
						_List_fromArray(
							[
								$elm$html$Html$text('Click here')
							])),
						$elm$html$Html$text(' to learn more.')
					])),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mb2, $author$project$Ui$Element$mt2]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Provider$NotificationSetting$Shared$description(notificationSetting))
					])),
				function () {
				var _v0 = _Utils_Tuple2(model.akd, model.gi);
				if (_v0.a.$ === 3) {
					var _v1 = _v0.a;
					return $elm$html$Html$text('');
				} else {
					if (!_v0.b.$) {
						var dropdown = _v0.b.a;
						var languageToItem = function (lang) {
							return A2(
								$author$project$Ui$Dropdown$item,
								_List_fromArray(
									[
										$author$project$Ui$Dropdown$selected(
										_Utils_eq(lang, model.Ay)),
										$author$project$Ui$Dropdown$onSelect(
										$author$project$Components$Admin$NotificationSetting$Customize$LanguageSelected(lang))
									]),
								$elm$html$Html$text(
									$author$project$Language$toLabel(lang)));
						};
						var items = A2(
							$elm$core$List$map,
							languageToItem,
							_List_fromArray(
								[$author$project$Language$english, $author$project$Language$spanish]));
						return A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Now editing'),
									$author$project$Ui$Form$Group$labelSpan(2),
									$author$project$Ui$Form$Group$inputSpan(4)
								]),
							_List_fromArray(
								[
									A4(
									$author$project$Ui$Dropdown$viewSelect,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Language$toLabel(model.Ay))
										]),
									items,
									dropdown)
								]));
					} else {
						return $elm$html$Html$text('');
					}
				}
			}(),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpan(2),
						$author$project$Ui$Form$Group$label('Subject')
					]),
				_List_fromArray(
					[subject])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpan(2),
						$author$project$Ui$Form$Group$label('Body')
					]),
				_List_fromArray(
					[body]))
			]);
	});
var $author$project$Components$Admin$NotificationSetting$Customize$ToogleVariables = {$: 13};
var $author$project$Components$Admin$NotificationSetting$Customize$viewToogleVariables = function (showVariables) {
	var action = showVariables ? 'hide' : 'show';
	return _List_fromArray(
		[
			$elm$html$Html$text('Click '),
			A3(
			$author$project$Ui$Button$view,
			{mm: action + 'variables'},
			_List_fromArray(
				[
					$author$project$Ui$Button$link,
					$author$project$Ui$Button$onClick($author$project$Components$Admin$NotificationSetting$Customize$ToogleVariables)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('here')
				])),
			$elm$html$Html$text(' to ' + (action + ' variables'))
		]);
};
var $author$project$Components$Admin$NotificationSetting$Customize$viewModalBody = function (model) {
	var _v0 = model.akd;
	if (_v0.$ === 3) {
		var preview = _v0.a;
		return _Utils_ap(
			A4(
				$author$project$Components$Admin$NotificationSetting$Customize$viewPreview,
				model.X_,
				A2(
					$author$project$Ui$Well$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$p,
							_List_fromArray(
								[
									$author$project$Ui$Typography$phi(true)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$NotificationSettingPreview$subject(preview))
								]))
						])),
				A2(
					$author$project$Ui$Well$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('notification-email-layout')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Api$HtmlTemplate$view,
									$author$project$Api$Phi$displayAttr,
									$author$project$Api$Provider$NotificationSettingPreview$body(preview))
								]))
						])),
				model),
			_List_fromArray(
				[
					function () {
					var _v1 = model.lK;
					if (_v1.$ === 2) {
						var error = _v1.a;
						return A2(
							$author$project$Ui$Alert$danger,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Error sending email')
										])),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									$elm$html$Html$text(
									$author$project$Api$Data$errorToString(error))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]));
	} else {
		var _v2 = $author$project$Utils$Form$fields(model.SD);
		var subject = _v2.J_;
		return A4(
			$author$project$Components$Admin$NotificationSetting$Customize$viewPreview,
			model.X_,
			A2(
				$author$project$Ui$Form$Group$view,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(subject),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Components$Admin$NotificationSetting$Customize$NotificationSettingFormFieldUpdated, $author$project$Components$Admin$NotificationSetting$Customize$Subject)),
								$author$project$Ui$Form$Input$phi(true)
							]))
					])),
			A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Form$Textarea$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Textarea$rows(15),
										$author$project$Ui$Form$Textarea$id(
										$author$project$Components$Admin$NotificationSetting$Customize$notificationBodyEditorId(model.X_)),
										$author$project$Ui$Form$Textarea$phi(true)
									]))
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
						_List_fromArray(
							[
								$elm$html$Html$text('You can edit your footer '),
								A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Admin__Notifications__Settings,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('here.')
									]))
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
						model.F1 ? $author$project$Components$Admin$NotificationSetting$Customize$viewToogleVariables(model.p9) : _List_fromArray(
							[$author$project$Utils$Html$empty])),
						model.p9 ? A2(
						$author$project$Ui$Well$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$ul,
								_List_Nil,
								A2(
									$elm$core$List$map,
									function (liquidVariable) {
										return A2(
											$elm$html$Html$li,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(liquidVariable)
												]));
									},
									$author$project$Api$Provider$NotificationSetting$Shared$availableLiquidVariables(model.X_)))
							])) : $author$project$Utils$Html$empty
					])),
			model);
	}
};
var $author$project$Components$Admin$NotificationSetting$Customize$Edit = {$: 5};
var $author$project$Components$Admin$NotificationSetting$Customize$Preview = {$: 2};
var $author$project$Components$Admin$NotificationSetting$Customize$Reset = {$: 4};
var $author$project$Components$Admin$NotificationSetting$Customize$Save = {$: 6};
var $author$project$Components$Admin$NotificationSetting$Customize$Test = {$: 3};
var $author$project$Ui$Icon$Chevron = 12;
var $author$project$Ui$Icon$chevron = $author$project$Ui$Icon$viewIcon(12);
var $author$project$Ui$Button$Danger = 6;
var $author$project$Ui$Button$danger = $author$project$Ui$Button$Styled(6);
var $author$project$Ui$Button$Loading = function (a) {
	return {$: 6, a: a};
};
var $author$project$Ui$Button$loading = $author$project$Ui$Button$Loading;
var $author$project$Ui$Icon$Rotate = function (a) {
	return {$: 6, a: a};
};
var $author$project$Ui$Icon$rotate90 = $author$project$Ui$Icon$Rotate(90);
var $author$project$Ui$Icon$Send = 37;
var $author$project$Ui$Icon$send = $author$project$Ui$Icon$viewIcon(37);
var $author$project$Ui$Button$Submit = {$: 3};
var $author$project$Ui$Button$submit = $author$project$Ui$Button$Submit;
var $author$project$Components$Admin$NotificationSetting$Customize$viewModalFooter = function (model) {
	var _v0 = model.akd;
	if (_v0.$ === 3) {
		var loading = model.pR;
		return _List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Close the modal'},
				_List_fromArray(
					[
						$author$project$Ui$Button$link,
						$author$project$Ui$Button$onClick($author$project$Components$Admin$NotificationSetting$Customize$Edit)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Icon$chevronDown(
						_List_fromArray(
							[$author$project$Ui$Icon$rotate90])),
						$elm$html$Html$text('Back')
					])),
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Save email'},
				_List_fromArray(
					[
						$author$project$Ui$Button$primary,
						$author$project$Ui$Button$submit,
						$author$project$Ui$Button$onClick($author$project$Components$Admin$NotificationSetting$Customize$Save),
						$author$project$Ui$Button$loading(loading)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Save Email')
					]))
			]);
	} else {
		var testLoading = function () {
			var _v1 = model.lK;
			if (_v1.$ === 1) {
				return true;
			} else {
				return false;
			}
		}();
		var loading = model.pR;
		return _List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Reset to default version'},
				_List_fromArray(
					[
						$author$project$Ui$Button$danger,
						$author$project$Ui$Button$onClick($author$project$Components$Admin$NotificationSetting$Customize$Reset),
						$author$project$Ui$Button$loading(loading),
						$author$project$Ui$Button$icon($author$project$Ui$Icon$delete),
						$author$project$Ui$Button$sm
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Reset to Default Version')
					])),
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Send Me a Test Copy'},
				_List_fromArray(
					[
						$author$project$Ui$Button$primary,
						$author$project$Ui$Button$onClick($author$project$Components$Admin$NotificationSetting$Customize$Test),
						$author$project$Ui$Button$loading(testLoading),
						$author$project$Ui$Button$sm,
						$author$project$Ui$Button$icon($author$project$Ui$Icon$send)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(' Send Me a Test Copy')
					])),
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Preview and save'},
				_List_fromArray(
					[
						$author$project$Ui$Button$primary,
						$author$project$Ui$Button$onClick($author$project$Components$Admin$NotificationSetting$Customize$Preview),
						$author$project$Ui$Button$loading(loading),
						$author$project$Ui$Button$sm,
						$author$project$Ui$Button$icon($author$project$Ui$Icon$chevron)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(' Preview & Save')
					]))
			]);
	}
};
var $author$project$Components$Admin$NotificationSetting$Customize$viewModal = function (model) {
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Admin$NotificationSetting$Customize$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title(
						$author$project$Api$Provider$NotificationSetting$Shared$shortDescriptionHtml(model.X_))
					])),
				$author$project$Ui$Modal$body(
				$author$project$Components$Admin$NotificationSetting$Customize$viewModalBody(model)),
				$author$project$Ui$Modal$footer(
				$author$project$Components$Admin$NotificationSetting$Customize$viewModalFooter(model))
			]));
};
var $author$project$Components$Admin$NotificationSetting$Customize$modal = function (model) {
	return model.Yn ? $author$project$Components$Admin$NotificationSetting$Customize$viewModal(model) : $author$project$Utils$Html$empty;
};
var $author$project$Ui$Alignment$Center = 1;
var $author$project$Ui$Alignment$Text = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Alignment$textCenter = $author$project$Ui$Alignment$Text(1);
var $author$project$Ui$Element$textCenter = $author$project$Ui$Element$Alignment($author$project$Ui$Alignment$textCenter);
var $author$project$Components$Admin$NotificationSetting$Toggle$ToggleNotificationSetting = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$ToggleSwitch$Disabled = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$ToggleSwitch$disabled = $author$project$Ui$ToggleSwitch$Disabled;
var $author$project$Ui$ToggleSwitch$On = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$ToggleSwitch$on = $author$project$Ui$ToggleSwitch$On;
var $author$project$Ui$ToggleSwitch$OnChange = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$ToggleSwitch$onChange = $author$project$Ui$ToggleSwitch$OnChange;
var $author$project$Ui$ToggleSwitch$defaultOptions = {rF: _List_Nil, ep: false, Yb: false, al6: $elm$core$Maybe$Nothing};
var $author$project$Ui$ToggleSwitch$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var bool = option.a;
						return _Utils_update(
							record,
							{Yb: bool});
					case 1:
						var toMsg = option.a;
						return _Utils_update(
							record,
							{
								al6: $elm$core$Maybe$Just(toMsg)
							});
					case 2:
						var bool = option.a;
						return _Utils_update(
							record,
							{ep: bool});
					default:
						return _Utils_update(
							record,
							{
								rF: A2($elm$core$List$cons, 'toggle--sm', record.rF)
							});
				}
			}),
		$author$project$Ui$ToggleSwitch$defaultOptions,
		options);
};
var $author$project$Utils$Bool$toString = function (bool) {
	return bool ? 'true' : 'false';
};
var $author$project$Ui$ToggleSwitch$view = function (options) {
	var optionsRecord = $author$project$Ui$ToggleSwitch$optionsToRecord(options);
	return A2(
		$elm$html$Html$label,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'role', 'switch'),
				A2(
				$elm$html$Html$Attributes$attribute,
				'aria-checked',
				$author$project$Utils$Bool$toString(optionsRecord.Yb)),
				$elm$html$Html$Attributes$class('toggle'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('toggle--disabled', optionsRecord.ep)
					])),
				$elm$html$Html$Attributes$class(
				A2($elm$core$String$join, ' ', optionsRecord.rF))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('checkbox'),
						$elm$html$Html$Attributes$checked(optionsRecord.Yb),
						$elm$html$Html$Attributes$disabled(optionsRecord.ep),
						A2(
						$elm$core$Maybe$withDefault,
						$elm$html$Html$Attributes$class(''),
						A2($elm$core$Maybe$map, $elm$html$Html$Events$onCheck, optionsRecord.al6))
					]),
				_List_Nil),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('toggle__background')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Icon$view,
						_List_fromArray(
							[
								$author$project$Ui$Icon$class('toggle__icon')
							]),
						47),
						A2(
						$author$project$Ui$Icon$view,
						_List_fromArray(
							[
								$author$project$Ui$Icon$class('toggle__icon')
							]),
						50)
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('toggle__knob')
					]),
				_List_Nil)
			]));
};
var $author$project$Components$Admin$NotificationSetting$Toggle$view = function (_v0) {
	var model = _v0;
	return model.zL.QC(model.X_) ? $author$project$Ui$ToggleSwitch$view(
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$on(model.Ro),
				$author$project$Ui$ToggleSwitch$onChange($author$project$Components$Admin$NotificationSetting$Toggle$ToggleNotificationSetting),
				$author$project$Ui$ToggleSwitch$disabled(
				_Utils_eq(model.uf, $author$project$Api$Data$Loading))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Ui$Spinner$optionToAttrs = function (option) {
	if (option.$ === 1) {
		var attributes = option.a;
		return A2(
			$elm$core$List$map,
			$elm$html$Html$Attributes$map($elm$core$Basics$never),
			attributes);
	} else {
		var size = option.a;
		switch (size) {
			case 0:
				return _List_fromArray(
					[
						$elm$html$Html$Attributes$class('spinner-xs')
					]);
			case 1:
				return _List_fromArray(
					[
						$elm$html$Html$Attributes$class('spinner-sm')
					]);
			case 2:
				return _List_fromArray(
					[
						$elm$html$Html$Attributes$class('spinner')
					]);
			default:
				return _List_fromArray(
					[
						$elm$html$Html$Attributes$class('spinner-lg')
					]);
		}
	}
};
var $author$project$Ui$Spinner$view = function (options) {
	return A2(
		$elm$html$Html$span,
		A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$class('spinner'),
			A2($elm$core$List$concatMap, $author$project$Ui$Spinner$optionToAttrs, options)),
		_List_Nil);
};
var $author$project$Pages$Admin$AdvanceBilling$viewNotificationSetting = F2(
	function (model, id) {
		var _v0 = A2($elm$core$Dict$get, id, model.bI);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var notificationSetting = _v1.a;
			var customizeNotification = _v1.b;
			var toggleNotification = _v1.c;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					A2($author$project$Pages$Admin$AdvanceBilling$ToggleNotificationMsg, id, toggleNotification),
					$author$project$Components$Admin$NotificationSetting$Toggle$view(toggleNotification)),
					$author$project$Utils$Html$noBreakSpace,
					A2(
					$elm$html$Html$map,
					$author$project$Pages$Admin$AdvanceBilling$CustomizeNotificationMsg(notificationSetting),
					$author$project$Components$Admin$NotificationSetting$Customize$button(customizeNotification)),
					A2(
					$elm$html$Html$map,
					$author$project$Pages$Admin$AdvanceBilling$CustomizeNotificationMsg(notificationSetting),
					$author$project$Components$Admin$NotificationSetting$Customize$modal(customizeNotification))
				]);
		} else {
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$textCenter]),
					_List_fromArray(
						[
							$author$project$Ui$Spinner$view(_List_Nil)
						]))
				]);
		}
	});
var $author$project$Pages$Admin$AdvanceBilling$viewAutopayTable = function (model) {
	return A4(
		$author$project$Ui$Table$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(3)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Billing Period')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(3)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Create & Notify')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(3)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Schedule Payment In Advance')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(3)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Email Notifications')
					])),
				A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Monthly')
							])),
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Formatters$Int$toDays(
									$author$project$Api$Provider$Practice$One$billMonthlyAutopayInAdvanceInDays(model.ZV)))
							])),
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Formatters$Int$toDays(
									$author$project$Api$Provider$Practice$One$scheduleMonthlyPaymentInAdvanceInDays(model.ZV)))
							])),
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						A2($author$project$Pages$Admin$AdvanceBilling$viewNotificationSetting, model, 'patient_upcoming_monthly_autopay_invoice_generated')),
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$flex, $author$project$Ui$Element$justifyRight]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Edit'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$sm,
												$author$project$Ui$Button$onClick(
												A2($author$project$Pages$Admin$AdvanceBilling$Edit, 0, 0)),
												$author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Edit')
											]))
									]))
							]))
					])),
				A2(
				$author$project$Ui$Table$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Quarterly, Semi-Annual, Annual')
							])),
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Formatters$Int$toDays(
									$author$project$Api$Provider$Practice$One$billNonMonthlyAutopayInAdvanceInDays(model.ZV)))
							])),
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Formatters$Int$toDays(
									$author$project$Api$Provider$Practice$One$scheduleNonMonthlyPaymentInAdvanceInDays(model.ZV)))
							])),
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						A2($author$project$Pages$Admin$AdvanceBilling$viewNotificationSetting, model, 'patient_upcoming_non_monthly_autopay_invoice_generated')),
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$flex, $author$project$Ui$Element$justifyRight]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Edit'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$sm,
												$author$project$Ui$Button$onClick(
												A2($author$project$Pages$Admin$AdvanceBilling$Edit, 0, 1)),
												$author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Edit')
											]))
									]))
							]))
					]))
			]),
		_List_Nil);
};
var $author$project$Pages$Admin$AdvanceBilling$Save = {$: 3};
var $author$project$Ui$Modal$OnSubmit = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Modal$onSubmit = $author$project$Ui$Modal$OnSubmit;
var $author$project$Ui$Alert$Warning = 2;
var $author$project$Ui$Alert$warning = $author$project$Ui$Alert$view(2);
var $author$project$Components$Admin$CreateEditModal$modal = F2(
	function (_v0, formGroups) {
		var label = _v0.aih;
		var maybeId = _v0.WG;
		var onClose = _v0.Yd;
		var onSave = _v0.Yf;
		var loading = _v0.V8;
		var maybeUpdateWarning = _v0.WH;
		var helpText = _v0.Tq;
		var updating = function () {
			if (maybeId.$ === 1) {
				return false;
			} else {
				return true;
			}
		}();
		return A3(
			$author$project$Ui$Modal$view,
			onClose,
			_List_fromArray(
				[
					$author$project$Ui$Modal$onSubmit(
					onSave(maybeId))
				]),
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title(
							updating ? ('Edit ' + label) : ('New ' + label)),
							function () {
							if (!helpText.$) {
								var helpText_ = helpText.a;
								return A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$muted]),
									_List_fromArray(
										[
											$elm$html$Html$text(helpText_)
										]));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							function () {
							var _v2 = _Utils_Tuple2(maybeUpdateWarning, updating);
							if ((!_v2.a.$) && _v2.b) {
								var updateWarning = _v2.a.a;
								return A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$mb2]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Alert$warning,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(updateWarning)
												]))
										]));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}(),
							A2($elm$html$Html$div, _List_Nil, formGroups)
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Cancel and close modal'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick(onClose)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Save ' + label},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$loading(loading),
									$author$project$Ui$Button$submit
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Save')
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$AdvanceBilling$BillMonthlyAutopayInAdvanceInDays = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$AdvanceBilling$BillNonMonthlyAutopayInAdvanceInDays = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$AdvanceBilling$FormUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$AdvanceBilling$ScheduleMonthlyPaymentInAdvanceInDays = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$AdvanceBilling$ScheduleNonMonthlyPaymentInAdvanceInDays = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Form$Input$Number = {$: 2};
var $author$project$Ui$Form$Input$Type = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Form$Input$number = $author$project$Ui$Form$Input$Type($author$project$Ui$Form$Input$Number);
var $author$project$Ui$Typography$Bold = 3;
var $author$project$Ui$Typography$Decoration = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Typography$bold = $author$project$Ui$Typography$Decoration(3);
var $author$project$Ui$Typography$Italic = 2;
var $author$project$Ui$Typography$italic = $author$project$Ui$Typography$Decoration(2);
var $author$project$Pages$Admin$AdvanceBilling$viewPendingMessage = F2(
	function (frequency, days) {
		var label = function () {
			if (!frequency) {
				return 'Monthly';
			} else {
				return 'Quarterly, Semi-Annual, Annual';
			}
		}();
		return A2(
			$author$project$Ui$Typography$p,
			_List_fromArray(
				[$author$project$Ui$Typography$small]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$strong,
					_List_fromArray(
						[$author$project$Ui$Typography$italic]),
					_List_fromArray(
						[
							$elm$html$Html$text('Pending: ')
						])),
					$elm$html$Html$text('Starting tonight, your '),
					A2(
					$author$project$Ui$Typography$text,
					_List_fromArray(
						[$author$project$Ui$Typography$bold]),
					label),
					$elm$html$Html$text(' patients will have invoices generated '),
					A2(
					$author$project$Ui$Typography$text,
					_List_fromArray(
						[$author$project$Ui$Typography$bold]),
					A2(
						$elm$core$Maybe$withDefault,
						'N/A',
						A2($elm$core$Maybe$map, $author$project$Formatters$Int$toDays, days))),
					$elm$html$Html$text(' in advance')
				]));
	});
var $author$project$Pages$Admin$AdvanceBilling$viewAutopayFields = F2(
	function (frequency, form) {
		var fields = $author$project$Utils$Form$fields(form);
		var _v0 = function () {
			if (!frequency) {
				return _Utils_Tuple3(fields.ala, $author$project$Pages$Admin$AdvanceBilling$ScheduleMonthlyPaymentInAdvanceInDays, 2);
			} else {
				return _Utils_Tuple3(fields.alb, $author$project$Pages$Admin$AdvanceBilling$ScheduleNonMonthlyPaymentInAdvanceInDays, 3);
			}
		}();
		var scheduleValue = _v0.a;
		var scheduleField = _v0.b;
		var scheduleValidationGroup = _v0.c;
		var _v2 = function () {
			if (!frequency) {
				return _Utils_Tuple3(fields.afc, $author$project$Pages$Admin$AdvanceBilling$BillMonthlyAutopayInAdvanceInDays, 0);
			} else {
				return _Utils_Tuple3(fields.afe, $author$project$Pages$Admin$AdvanceBilling$BillNonMonthlyAutopayInAdvanceInDays, 1);
			}
		}();
		var createValue = _v2.a;
		var createField = _v2.b;
		var createValidationGroup = _v2.c;
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpan(5),
						$author$project$Ui$Form$Group$inputSpan(7),
						$author$project$Ui$Form$Group$label('Create & Notify')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$group(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$number,
										$author$project$Ui$Form$Input$value(
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2($elm$core$Maybe$map, $elm$core$String$fromInt, createValue))),
										$author$project$Ui$Form$Input$onInput(
										A2($elm$core$Basics$composeL, $author$project$Pages$Admin$AdvanceBilling$FormUpdated, createField))
									])),
								$author$project$Ui$Form$Input$addon(
								_List_fromArray(
									[
										$elm$html$Html$text('days')
									]))
							])),
						$author$project$Utils$FormErrors$view(
						A2($author$project$Utils$Form$validationErrors, createValidationGroup, form)),
						A2($author$project$Pages$Admin$AdvanceBilling$viewPendingMessage, frequency, createValue)
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpan(5),
						$author$project$Ui$Form$Group$inputSpan(7),
						$author$project$Ui$Form$Group$label('Schedule Payment In Advance')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$group(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$number,
										$author$project$Ui$Form$Input$value(
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2($elm$core$Maybe$map, $elm$core$String$fromInt, scheduleValue))),
										$author$project$Ui$Form$Input$onInput(
										A2($elm$core$Basics$composeL, $author$project$Pages$Admin$AdvanceBilling$FormUpdated, scheduleField))
									])),
								$author$project$Ui$Form$Input$addon(
								_List_fromArray(
									[
										$elm$html$Html$text('days')
									]))
							])),
						$author$project$Utils$FormErrors$view(
						A2($author$project$Utils$Form$validationErrors, scheduleValidationGroup, form))
					]))
			]);
	});
var $author$project$Pages$Admin$AdvanceBilling$BillMonthlyNonAutopayInAdvanceInDays = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$AdvanceBilling$BillNonMonthlyNonAutopayInAdvanceInDays = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Admin$AdvanceBilling$viewNonAutopayFields = F2(
	function (frequency, form) {
		var fields = $author$project$Utils$Form$fields(form);
		var _v0 = function () {
			if (!frequency) {
				return _Utils_Tuple3(fields.afd, $author$project$Pages$Admin$AdvanceBilling$BillMonthlyNonAutopayInAdvanceInDays, 4);
			} else {
				return _Utils_Tuple3(fields.aff, $author$project$Pages$Admin$AdvanceBilling$BillNonMonthlyNonAutopayInAdvanceInDays, 5);
			}
		}();
		var value = _v0.a;
		var field = _v0.b;
		var validationGroup = _v0.c;
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpan(5),
						$author$project$Ui$Form$Group$inputSpan(7),
						$author$project$Ui$Form$Group$label('Invoice & Notification Lead Time')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$group(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$number,
										$author$project$Ui$Form$Input$value(
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2($elm$core$Maybe$map, $elm$core$String$fromInt, value))),
										$author$project$Ui$Form$Input$onInput(
										A2($elm$core$Basics$composeL, $author$project$Pages$Admin$AdvanceBilling$FormUpdated, field))
									])),
								$author$project$Ui$Form$Input$addon(
								_List_fromArray(
									[
										$elm$html$Html$text('days')
									]))
							])),
						$author$project$Utils$FormErrors$view(
						A2($author$project$Utils$Form$validationErrors, validationGroup, form)),
						A2($author$project$Pages$Admin$AdvanceBilling$viewPendingMessage, frequency, value)
					]))
			]);
	});
var $author$project$Pages$Admin$AdvanceBilling$viewEditModal = F2(
	function (form, saveRequest) {
		var modalConfig = {
			Tq: $elm$core$Maybe$Nothing,
			aih: 'Invoicing Ahead of Time',
			V8: _Utils_eq(saveRequest, $author$project$Api$Data$Loading),
			WG: $elm$core$Maybe$Just(''),
			WH: $elm$core$Maybe$Nothing,
			Yd: $author$project$Pages$Admin$AdvanceBilling$CancelEdit,
			Yf: $elm$core$Basics$always($author$project$Pages$Admin$AdvanceBilling$Save)
		};
		var _v0 = $author$project$Utils$Form$fields(form);
		var type_ = _v0.amg;
		var frequency = _v0.sr;
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			function () {
				if (!type_) {
					return A2($author$project$Pages$Admin$AdvanceBilling$viewAutopayFields, frequency, form);
				} else {
					return A2($author$project$Pages$Admin$AdvanceBilling$viewNonAutopayFields, frequency, form);
				}
			}());
	});
var $author$project$Pages$Admin$AdvanceBilling$NonAutopay = 1;
var $author$project$Pages$Admin$AdvanceBilling$viewNonAutopayTable = function (model) {
	return A4(
		$author$project$Ui$Table$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(3)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Billing Period')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(3)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Create & Notify')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(3)
					]),
				_List_Nil),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(3)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Email Notifications')
					])),
				A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Monthly')
							])),
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Formatters$Int$toDays(
									$author$project$Api$Provider$Practice$One$billMonthlyNonAutopayInAdvanceInDays(model.ZV)))
							])),
						A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						A2($author$project$Pages$Admin$AdvanceBilling$viewNotificationSetting, model, 'patient_upcoming_monthly_non_autopay_invoice_generated')),
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$flex, $author$project$Ui$Element$justifyRight]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Edit'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$sm,
												$author$project$Ui$Button$onClick(
												A2($author$project$Pages$Admin$AdvanceBilling$Edit, 1, 0)),
												$author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Edit')
											]))
									]))
							]))
					])),
				A2(
				$author$project$Ui$Table$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Quarterly, Semi-Annual, Annual')
							])),
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Formatters$Int$toDays(
									$author$project$Api$Provider$Practice$One$billNonMonthlyNonAutopayInAdvanceInDays(model.ZV)))
							])),
						A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						A2($author$project$Pages$Admin$AdvanceBilling$viewNotificationSetting, model, 'patient_upcoming_non_monthly_non_autopay_invoice_generated')),
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$flex, $author$project$Ui$Element$justifyRight]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Edit'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$sm,
												$author$project$Ui$Button$onClick(
												A2($author$project$Pages$Admin$AdvanceBilling$Edit, 1, 1)),
												$author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Edit')
											]))
									]))
							]))
					]))
			]),
		_List_Nil);
};
var $author$project$Pages$Admin$AdvanceBilling$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				function () {
				var _v0 = model.C;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var form = _v1.a;
					var updateRequest = _v1.b;
					return A2($author$project$Pages$Admin$AdvanceBilling$viewEditModal, form, updateRequest);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Invoicing Ahead of Time')
									])),
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$textMuted]),
								_List_fromArray(
									[
										$elm$html$Html$text('We will create invoices and notify your members before their bill date, unless they have already been billed. You can specify the lead time (in days) before invoicing below. Any changes you make will take effect tonight during our nightly billing run.')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$mb2]),
								_List_fromArray(
									[
										$author$project$Ui$Typography$headingSm(
										_List_fromArray(
											[
												$elm$html$Html$text('For Autopay Members')
											]))
									])),
								$author$project$Pages$Admin$AdvanceBilling$viewAutopayTable(model)
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$mb2]),
								_List_fromArray(
									[
										$author$project$Ui$Typography$headingSm(
										_List_fromArray(
											[
												$elm$html$Html$text('For Autopay Disabled Members')
											]))
									])),
								$author$project$Pages$Admin$AdvanceBilling$viewNonAutopayTable(model)
							]))
					]))
			]),
		ac9: 'Admin | Advance Billing'
	};
};
var $author$project$Pages$Admin$AdvanceBilling$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$AdvanceBilling$init, aiq: $author$project$Pages$Admin$AdvanceBilling$load, k8: $author$project$Pages$Admin$AdvanceBilling$save, alO: $author$project$Pages$Admin$AdvanceBilling$subscriptions, adT: $author$project$Pages$Admin$AdvanceBilling$update, amo: $author$project$Pages$Admin$AdvanceBilling$view});
var $author$project$Pages$Admin$Athenahealth$Fields$init = F4(
	function (_v0, _v1, shared, _v2) {
		return _Utils_Tuple2(
			{Gv: shared.Gv},
			A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Marketplace__Athenahealth__Manage__Settings));
	});
var $author$project$Pages$Admin$Athenahealth$Fields$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Athenahealth$Fields$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Athenahealth$Fields$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$Athenahealth$Fields$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Admin$Athenahealth$Fields$view = function (_v0) {
	return {
		fO: _List_fromArray(
			[$author$project$Utils$Html$empty]),
		ac9: 'Redirecting...'
	};
};
var $author$project$Pages$Admin$Athenahealth$Fields$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Athenahealth$Fields$init, aiq: $author$project$Pages$Admin$Athenahealth$Fields$load, k8: $author$project$Pages$Admin$Athenahealth$Fields$save, alO: $author$project$Pages$Admin$Athenahealth$Fields$subscriptions, adT: $author$project$Pages$Admin$Athenahealth$Fields$update, amo: $author$project$Pages$Admin$Athenahealth$Fields$view});
var $author$project$Pages$Admin$Athenahealth$Link$init = F4(
	function (_v0, _v1, shared, _v2) {
		return _Utils_Tuple2(
			{Gv: shared.Gv},
			A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Marketplace__Athenahealth__Manage__Settings));
	});
var $author$project$Pages$Admin$Athenahealth$Link$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Athenahealth$Link$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Athenahealth$Link$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$Athenahealth$Link$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Admin$Athenahealth$Link$view = function (_v0) {
	return {
		fO: _List_fromArray(
			[$author$project$Utils$Html$empty]),
		ac9: 'Redirecting...'
	};
};
var $author$project$Pages$Admin$Athenahealth$Link$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Athenahealth$Link$init, aiq: $author$project$Pages$Admin$Athenahealth$Link$load, k8: $author$project$Pages$Admin$Athenahealth$Link$save, alO: $author$project$Pages$Admin$Athenahealth$Link$subscriptions, adT: $author$project$Pages$Admin$Athenahealth$Link$update, amo: $author$project$Pages$Admin$Athenahealth$Link$view});
var $author$project$Pages$Admin$Athenahealth$Locations$init = F4(
	function (_v0, _v1, shared, _v2) {
		return _Utils_Tuple2(
			{Gv: shared.Gv},
			A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Marketplace__Athenahealth__Manage__Settings));
	});
var $author$project$Pages$Admin$Athenahealth$Locations$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Athenahealth$Locations$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Athenahealth$Locations$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$Athenahealth$Locations$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Admin$Athenahealth$Locations$view = function (_v0) {
	return {
		fO: _List_fromArray(
			[$author$project$Utils$Html$empty]),
		ac9: 'Redirecting...'
	};
};
var $author$project$Pages$Admin$Athenahealth$Locations$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Athenahealth$Locations$init, aiq: $author$project$Pages$Admin$Athenahealth$Locations$load, k8: $author$project$Pages$Admin$Athenahealth$Locations$save, alO: $author$project$Pages$Admin$Athenahealth$Locations$subscriptions, adT: $author$project$Pages$Admin$Athenahealth$Locations$update, amo: $author$project$Pages$Admin$Athenahealth$Locations$view});
var $author$project$Pages$Admin$Athenahealth$Overview$init = F4(
	function (_v0, _v1, shared, _v2) {
		return _Utils_Tuple2(
			{Gv: shared.Gv},
			A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Marketplace__Athenahealth__Manage__Settings));
	});
var $author$project$Pages$Admin$Athenahealth$Overview$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Athenahealth$Overview$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Athenahealth$Overview$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$Athenahealth$Overview$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Admin$Athenahealth$Overview$view = function (_v0) {
	return {
		fO: _List_fromArray(
			[$author$project$Utils$Html$empty]),
		ac9: 'Redirecting...'
	};
};
var $author$project$Pages$Admin$Athenahealth$Overview$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Athenahealth$Overview$init, aiq: $author$project$Pages$Admin$Athenahealth$Overview$load, k8: $author$project$Pages$Admin$Athenahealth$Overview$save, alO: $author$project$Pages$Admin$Athenahealth$Overview$subscriptions, adT: $author$project$Pages$Admin$Athenahealth$Overview$update, amo: $author$project$Pages$Admin$Athenahealth$Overview$view});
var $author$project$Pages$Admin$Athenahealth$Providers$init = F4(
	function (_v0, _v1, shared, _v2) {
		return _Utils_Tuple2(
			{Gv: shared.Gv},
			A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Marketplace__Athenahealth__Manage__Settings));
	});
var $author$project$Pages$Admin$Athenahealth$Providers$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Athenahealth$Providers$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Athenahealth$Providers$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$Athenahealth$Providers$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Admin$Athenahealth$Providers$view = function (_v0) {
	return {
		fO: _List_fromArray(
			[$author$project$Utils$Html$empty]),
		ac9: 'Redirecting...'
	};
};
var $author$project$Pages$Admin$Athenahealth$Providers$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Athenahealth$Providers$init, aiq: $author$project$Pages$Admin$Athenahealth$Providers$load, k8: $author$project$Pages$Admin$Athenahealth$Providers$save, alO: $author$project$Pages$Admin$Athenahealth$Providers$subscriptions, adT: $author$project$Pages$Admin$Athenahealth$Providers$update, amo: $author$project$Pages$Admin$Athenahealth$Providers$view});
var $author$project$Pages$Admin$Athenahealth$Top$init = F4(
	function (_v0, _v1, shared, _v2) {
		return _Utils_Tuple2(
			{Gv: shared.Gv},
			A2(
				$author$project$Utils$Route$navigate,
				$elm$core$Dict$empty,
				$author$project$Spa$Generated$Route$Marketplace__Slug_String(
					{abG: 'athenahealth'})));
	});
var $author$project$Pages$Admin$Athenahealth$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Athenahealth$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Athenahealth$Top$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$Athenahealth$Top$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Admin$Athenahealth$Top$view = function (_v0) {
	return {
		fO: _List_fromArray(
			[$author$project$Utils$Html$empty]),
		ac9: 'Redirecting...'
	};
};
var $author$project$Pages$Admin$Athenahealth$Top$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Athenahealth$Top$init, aiq: $author$project$Pages$Admin$Athenahealth$Top$load, k8: $author$project$Pages$Admin$Athenahealth$Top$save, alO: $author$project$Pages$Admin$Athenahealth$Top$subscriptions, adT: $author$project$Pages$Admin$Athenahealth$Top$update, amo: $author$project$Pages$Admin$Athenahealth$Top$view});
var $author$project$Pages$Admin$Billing$GotManagementGroup = function (a) {
	return {$: 21, a: a};
};
var $author$project$Pages$Admin$Billing$NotInitialized = {$: 0};
var $author$project$Pages$Admin$Billing$GotBankAccounts = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$BankAccount$bankAccountsPath = function (basePath) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['bank_accounts']),
		basePath);
};
var $author$project$Api$Provider$BankAccount$All$BankAccount = $elm$core$Basics$identity;
var $author$project$Api$Provider$BankAccount$One$BankAccount = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$BankAccount$Shared$BankAccount = $elm$core$Basics$identity;
var $author$project$Api$Provider$BankAccount$Shared$Record = function (id) {
	return function (name) {
		return function (type_) {
			return function (lastFour) {
				return function (status) {
					return function (label) {
						return function (errorMessage) {
							return function (lastPaymentErrorMessage) {
								return function (createdVia) {
									return function (createdByName) {
										return function (createdAt) {
											return function (bankName) {
												return function (paymentProcessor) {
													return function (assignedMemberships) {
														return {L1: assignedMemberships, Mw: bankName, O1: createdAt, O3: createdByName, O4: createdVia, RM: errorMessage, ahP: id, aih: label, VG: lastFour, VI: lastPaymentErrorMessage, Bq: name, Zd: paymentProcessor, alH: status, amg: type_};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$BankAccount$Shared$AssignedMembership = F2(
	function (id, planName) {
		return {ahP: id, ZE: planName};
	});
var $author$project$Api$Provider$BankAccount$Shared$assignedMembershipDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'plan_name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$BankAccount$Shared$AssignedMembership)));
var $author$project$Api$Provider$BankAccount$Shared$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'assigned_memberships',
	$elm$json$Json$Decode$list($author$project$Api$Provider$BankAccount$Shared$assignedMembershipDecoder),
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'payment_processor',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'bank_name',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'created_at',
				$elm_community$json_extra$Json$Decode$Extra$datetime,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'created_by_name',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'created_via',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'last_payment_error_message',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'error_message',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'label',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'status',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'last_four',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'type',
												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'name',
													$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'id',
														$elm$json$Json$Decode$string,
														$elm$json$Json$Decode$succeed($author$project$Api$Provider$BankAccount$Shared$Record)))))))))))))));
var $author$project$Api$Provider$BankAccount$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$BankAccount$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$BankAccount$One$Record = F2(
	function (_default, defaults) {
		return {PW: _default, Qg: defaults};
	});
var $author$project$Api$Provider$Source$Defaults$Defaults = $elm$core$Basics$identity;
var $author$project$Api$Provider$Source$Defaults$Record = F3(
	function (hintCustomer, networkForStripe, networkForRainforest) {
		return {Tx: hintCustomer, XB: networkForRainforest, XC: networkForStripe};
	});
var $author$project$Api$Provider$Source$Defaults$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'network_for_rainforest',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'network_for_stripe',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'hint_customer',
			$elm$json$Json$Decode$bool,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Source$Defaults$Record))));
var $author$project$Api$Provider$Source$Defaults$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Source$Defaults$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$BankAccount$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'defaults',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Source$Defaults$decoder),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'default',
		$elm$json$Json$Decode$bool,
		false,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$BankAccount$One$Record)));
var $author$project$Api$Provider$BankAccount$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$BankAccount$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$BankAccount$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$BankAccount$One$BankAccount)));
var $author$project$Api$Provider$BankAccount$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$BankAccount$One$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Param$List = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Api$Param$list = $author$project$Api$Param$List;
var $author$project$Api$Provider$BankAccount$list = F3(
	function (basePath, apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$BankAccount$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2(
						$author$project$Api$Param$list,
						'expand',
						_List_fromArray(
							['assigned_memberships']))
					]),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$BankAccount$bankAccountsPath(basePath))));
	});
var $author$project$Pages$Admin$Billing$fetchBankAccounts = function (apiClient) {
	return A3($author$project$Api$Provider$BankAccount$list, $author$project$Api$Data$providerPath, apiClient, $author$project$Pages$Admin$Billing$GotBankAccounts);
};
var $author$project$Pages$Admin$Billing$GotCards = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Card$cardsPath = function (basePath) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['cards']),
		basePath);
};
var $author$project$Api$Provider$Card$All$Card = $elm$core$Basics$identity;
var $author$project$Api$Provider$Card$One$Card = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Card$Shared$Card = $elm$core$Basics$identity;
var $author$project$Api$Provider$Card$Shared$Record = function (id) {
	return function (name) {
		return function (type_) {
			return function (lastFour) {
				return function (status) {
					return function (label) {
						return function (errorMessage) {
							return function (lastPaymentErrorMessage) {
								return function (expMonth) {
									return function (expYear) {
										return function (createdVia) {
											return function (createdByName) {
												return function (createdAt) {
													return function (cardType) {
														return function (zip) {
															return function (paymentProcessor) {
																return function (funding) {
																	return function (assignedMemberships) {
																		return {L1: assignedMemberships, No: cardType, O1: createdAt, O3: createdByName, O4: createdVia, RM: errorMessage, ag3: expMonth, ag4: expYear, SN: funding, ahP: id, aih: label, VG: lastFour, VI: lastPaymentErrorMessage, Bq: name, Zd: paymentProcessor, alH: status, amg: type_, vv: zip};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Card$Shared$AssignedMembership = F2(
	function (id, planName) {
		return {ahP: id, ZE: planName};
	});
var $author$project$Api$Provider$Card$Shared$assignedMembershipDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'plan_name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Card$Shared$AssignedMembership)));
var $author$project$Api$Provider$Card$Shared$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'assigned_memberships',
	$elm$json$Json$Decode$list($author$project$Api$Provider$Card$Shared$assignedMembershipDecoder),
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'funding',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'payment_processor',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'zip',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'card_type',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'created_at',
						$elm_community$json_extra$Json$Decode$Extra$datetime,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'created_by_name',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'created_via',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'exp_year',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'exp_month',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'last_payment_error_message',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'error_message',
												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'label',
													$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'status',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'last_four',
															$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'type',
																$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'name',
																	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'id',
																		$elm$json$Json$Decode$string,
																		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Card$Shared$Record)))))))))))))))))));
var $author$project$Api$Provider$Card$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Card$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Card$One$Record = F2(
	function (_default, defaults) {
		return {PW: _default, Qg: defaults};
	});
var $author$project$Api$Provider$Card$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'defaults',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Source$Defaults$decoder),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'default',
		$elm$json$Json$Decode$bool,
		false,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Card$One$Record)));
var $author$project$Api$Provider$Card$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Card$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Card$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Card$One$Card)));
var $author$project$Api$Provider$Card$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Card$One$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Card$list = F3(
	function (basePath, apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Card$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2(
						$author$project$Api$Param$list,
						'expand',
						_List_fromArray(
							['assigned_memberships']))
					]),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Card$cardsPath(basePath))));
	});
var $author$project$Pages$Admin$Billing$fetchCards = function (apiClient) {
	return A3($author$project$Api$Provider$Card$list, $author$project$Api$Data$providerPath, apiClient, $author$project$Pages$Admin$Billing$GotCards);
};
var $author$project$Pages$Admin$Billing$GotPracticeInvoices = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$PracticeInvoice$All$PracticeInvoice = $elm$core$Basics$identity;
var $author$project$Api$Provider$PracticeInvoice$Shared$PracticeInvoice = $elm$core$Basics$identity;
var $author$project$Api$Provider$PracticeInvoice$Shared$Record = function (humanStatus) {
	return function (id) {
		return function (invoiceDate) {
			return function (dueDate) {
				return function (invoiceNumber) {
					return function (paidAt) {
						return function (totalInCents) {
							return function (paidInCents) {
								return function (dueInCents) {
									return function (meta) {
										return function (partner) {
											return {QX: dueDate, QY: dueInCents, TH: humanStatus, ahP: id, Uq: invoiceDate, Uu: invoiceNumber, W4: meta, YH: paidAt, YI: paidInCents, YN: partner, adp: totalInCents};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$PracticeInvoice$Status$Cancelled = 4;
var $author$project$Api$Provider$PracticeInvoice$Status$Disputed = 6;
var $author$project$Api$Provider$PracticeInvoice$Status$Draft = 2;
var $author$project$Api$Provider$PracticeInvoice$Status$Issued = 3;
var $author$project$Api$Provider$PracticeInvoice$Status$Overdue = 5;
var $author$project$Api$Provider$PracticeInvoice$Status$Paid = 0;
var $author$project$Api$Provider$PracticeInvoice$Status$Processing = 1;
var $author$project$Api$Provider$PracticeInvoice$Status$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'paid':
				return $elm$json$Json$Decode$succeed(0);
			case 'processing':
				return $elm$json$Json$Decode$succeed(1);
			case 'draft':
				return $elm$json$Json$Decode$succeed(2);
			case 'overdue':
				return $elm$json$Json$Decode$succeed(5);
			case 'cancelled':
				return $elm$json$Json$Decode$succeed(4);
			case 'disputed':
				return $elm$json$Json$Decode$succeed(6);
			case 'issued':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('Unsupported Practice Invoice status: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$Partner$Shared$Partner = $elm$core$Basics$identity;
var $author$project$Api$Provider$Partner$Shared$Record = F3(
	function (name, slug, statementDescriptor) {
		return {Bq: name, abG: slug, acc: statementDescriptor};
	});
var $author$project$Api$Provider$Partner$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'statement_descriptor',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'slug',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Partner$Shared$Record))));
var $author$project$Api$Provider$Partner$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Partner$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PracticeInvoice$Meta$Meta = $elm$core$Basics$identity;
var $author$project$Api$Provider$PracticeInvoice$Meta$MetaRecord = function (actions) {
	return {vy: actions};
};
var $author$project$Api$Provider$PracticeInvoice$Meta$ActionsRecord = F6(
	function (cancel, issue, destroy, paymentsProcess, adjust, refund) {
		return {La: adjust, Nl: cancel, Qu: destroy, Vm: issue, Zk: paymentsProcess, $m: refund};
	});
var $author$project$Api$Provider$PracticeInvoice$Meta$actionsRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'refund',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'adjust',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'payments_process',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'destroy',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'issue',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'cancel',
						$elm$json$Json$Decode$bool,
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticeInvoice$Meta$ActionsRecord)))))));
var $author$project$Api$Provider$PracticeInvoice$Meta$metaRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'actions',
	$author$project$Api$Provider$PracticeInvoice$Meta$actionsRecordDecoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticeInvoice$Meta$MetaRecord));
var $author$project$Api$Provider$PracticeInvoice$Meta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PracticeInvoice$Meta$metaRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PracticeInvoice$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'partner',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Partner$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'meta',
		$author$project$Api$Provider$PracticeInvoice$Meta$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'due_in_cents',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'paid_in_cents',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'total_in_cents',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'paid_at',
						$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'invoice_number',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'due_date',
								$author$project$Utils$Date$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'invoice_date',
									$author$project$Utils$Date$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'human_status',
											$author$project$Api$Provider$PracticeInvoice$Status$decode,
											$elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticeInvoice$Shared$Record))))))))))));
var $author$project$Api$Provider$PracticeInvoice$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PracticeInvoice$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PracticeInvoice$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PracticeInvoice$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Pagination$Model = $elm$core$Basics$identity;
var $author$project$Api$Pagination$init = {bX: 1, gG: 10, t1: '', qC: 0};
var $author$project$Api$Provider$PracticeInvoice$listDefaults = {HM: $elm$core$Maybe$Nothing, ajJ: $author$project$Api$Pagination$init};
var $author$project$Api$Pagination$limit = function (_v0) {
	var model = _v0;
	return model.gG;
};
var $author$project$Api$Pagination$offset = function (_v0) {
	var model = _v0;
	return (model.bX - 1) * model.gG;
};
var $author$project$Api$Pagination$toApiParams = function (model) {
	return A2(
		$elm$core$List$map,
		function (_v0) {
			var key = _v0.a;
			var value = _v0.b;
			return A2($author$project$Api$Param$string, key, value);
		},
		_List_fromArray(
			[
				_Utils_Tuple2(
				'offset',
				$elm$core$String$fromInt(
					$author$project$Api$Pagination$offset(model))),
				_Utils_Tuple2(
				'limit',
				$elm$core$String$fromInt(
					$author$project$Api$Pagination$limit(model)))
			]));
};
var $author$project$Api$Provider$PracticeInvoice$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$PracticeInvoice$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.HM;
				if (!_v0.$) {
					var filter = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'filter', filter)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$Provider$PracticeInvoice$practiceInvoicesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['practice', 'invoices']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$PracticeInvoice$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$PracticeInvoice$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$PracticeInvoice$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$PracticeInvoice$practiceInvoicesPath)));
	});
var $author$project$Pages$Admin$Billing$fetchPracticeInvoices = F2(
	function (apiClient, pagination) {
		return A3(
			$author$project$Api$Provider$PracticeInvoice$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{ajJ: pagination});
			},
			$author$project$Pages$Admin$Billing$GotPracticeInvoices);
	});
var $author$project$Pages$Admin$Billing$GotApplicationFeePlan = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Practice$ApplicationFeePlan$applicationFeePlanPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['fee_plan']),
	$author$project$Api$Provider$Practice$practicePath);
var $author$project$Api$Provider$ApplicationFeePlan$One$ApplicationFeePlan = $elm$core$Basics$identity;
var $author$project$Api$Provider$ApplicationFeePlan$One$Record = function (id) {
	return function (name) {
		return function (pricedBy) {
			return function (collectionFeePercentage) {
				return function (minimumPerMonthInCents) {
					return function (totalAchFeeInCents) {
						return function (totalAchFeePercentage) {
							return function (totalAmexFeePercentage) {
								return function (totalCardFeeInCents) {
									return function (totalCardFeePercentage) {
										return function (achTransactionFeeCapInCents) {
											return function (trancheSize) {
												return {KK: achTransactionFeeCapInCents, N0: collectionFeePercentage, ahP: id, Xh: minimumPerMonthInCents, Bq: name, Dx: pricedBy, adj: totalAchFeeInCents, adk: totalAchFeePercentage, adl: totalAmexFeePercentage, adm: totalCardFeeInCents, Ka: totalCardFeePercentage, amd: trancheSize};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$ApplicationFeePlan$One$RecordIntermediate = F2(
	function (pricedBy, pricingStructure) {
		return {Dx: pricedBy, _l: pricingStructure};
	});
var $author$project$Api$Provider$PricingStructure$Shared$PricingStructure = $elm$core$Basics$identity;
var $author$project$Api$Provider$PricingStructure$Shared$IntermediateRecord = F7(
	function (id, description, fixedAmountInCents, percentage, splitType, pricingType, tiers) {
		return {Qr: description, ahn: fixedAmountInCents, ahP: id, ajZ: percentage, akg: pricingType, alD: splitType, ac6: tiers};
	});
var $author$project$Api$Provider$PricingStructure$Shared$Record = F6(
	function (id, description, fixedAmountInCents, percentage, splitType, pricingType) {
		return {Qr: description, ahn: fixedAmountInCents, ahP: id, ajZ: percentage, akg: pricingType, alD: splitType};
	});
var $author$project$Api$PricingType$FixedAmountInCents = {$: 1};
var $author$project$Api$PricingType$Percentage = {$: 0};
var $author$project$Api$PricingType$PercentageAndFixedAmount = {$: 2};
var $author$project$Api$PricingType$Tiered = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$PricingType$decoder = F2(
	function (pricingTypeStr, tiers) {
		switch (pricingTypeStr) {
			case 'percentage':
				return $elm$json$Json$Decode$succeed($author$project$Api$PricingType$Percentage);
			case 'fixed_amount_in_cents':
				return $elm$json$Json$Decode$succeed($author$project$Api$PricingType$FixedAmountInCents);
			case 'percentage_and_fixed_amount':
				return $elm$json$Json$Decode$succeed($author$project$Api$PricingType$PercentageAndFixedAmount);
			case 'tiered':
				return $elm$core$List$isEmpty(tiers) ? $elm$json$Json$Decode$fail('Must have tiers if tiered') : $elm$json$Json$Decode$succeed(
					$author$project$Api$PricingType$Tiered(tiers));
			default:
				var somethingElse = pricingTypeStr;
				return $elm$json$Json$Decode$fail('Unknown PricingType value: ' + somethingElse);
		}
	});
var $author$project$Api$Provider$PricingTier$Shared$PricingTier = $elm$core$Basics$identity;
var $author$project$Api$Provider$PricingTier$Shared$Record = F3(
	function (fixedAmountInCents, lowerBound, upperBound) {
		return {ahn: fixedAmountInCents, Wn: lowerBound, adX: upperBound};
	});
var $author$project$Api$Provider$PricingTier$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'upper_bound',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'lower_bound',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'fixed_amount_in_cents',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$PricingTier$Shared$Record))));
var $author$project$Api$Provider$PricingTier$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PricingTier$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$SplitType$AllMembers = 0;
var $author$project$Api$SplitType$Flat = 2;
var $author$project$Api$SplitType$PrimaryOnly = 1;
var $author$project$Api$SplitType$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'all_members':
				return $elm$json$Json$Decode$succeed(0);
			case 'primary_only':
				return $elm$json$Json$Decode$succeed(1);
			case 'flat':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Unsupported Pricing Structure -> split_type: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded = A2($elm$core$Basics$composeR, $elm$json$Json$Decode$succeed, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom);
var $author$project$Api$Provider$PricingStructure$Shared$recordDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (intermediate) {
		return A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'tiers',
			A2($author$project$Api$PricingType$decoder, intermediate.akg, intermediate.ac6),
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
				intermediate.alD,
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
					intermediate.ajZ,
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
						intermediate.ahn,
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
							intermediate.Qr,
							A2(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
								intermediate.ahP,
								$elm$json$Json$Decode$succeed($author$project$Api$Provider$PricingStructure$Shared$Record)))))));
	},
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'tiers',
		$elm$json$Json$Decode$list($author$project$Api$Provider$PricingTier$Shared$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'pricing_type',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'split_type',
				$author$project$Api$SplitType$decoder,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'percentage',
					$elm$json$Json$Decode$float,
					0.0,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'fixed_amount_in_cents',
						$elm$json$Json$Decode$int,
						0,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'description',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Api$Provider$PricingStructure$Shared$IntermediateRecord)))))))));
var $author$project$Api$Provider$PricingStructure$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PricingStructure$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$ApplicationFeePlan$One$Pmpm = {$: 1};
var $author$project$Api$Provider$ApplicationFeePlan$One$PmpmTiered = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$ApplicationFeePlan$One$Transaction = {$: 0};
var $author$project$Api$Provider$PricingStructure$Shared$pricingType = function (_v0) {
	var record = _v0;
	return record.akg;
};
var $author$project$Api$Provider$ApplicationFeePlan$One$pricedByDecoder = F2(
	function (pricedByStr, pricingStructure) {
		switch (pricedByStr) {
			case 'transaction':
				return $elm$json$Json$Decode$succeed($author$project$Api$Provider$ApplicationFeePlan$One$Transaction);
			case 'pmpm':
				return $elm$json$Json$Decode$succeed($author$project$Api$Provider$ApplicationFeePlan$One$Pmpm);
			case 'pmpm_tiered':
				if (pricingStructure.$ === 1) {
					return $elm$json$Json$Decode$fail('PMPM ApplicationFeePlans must have pricingStructure');
				} else {
					var structure = pricingStructure.a;
					var _v2 = $author$project$Api$Provider$PricingStructure$Shared$pricingType(structure);
					if (_v2.$ === 3) {
						var tiers = _v2.a;
						return $elm$json$Json$Decode$succeed(
							$author$project$Api$Provider$ApplicationFeePlan$One$PmpmTiered(tiers));
					} else {
						return $elm$json$Json$Decode$fail('PMPM Tiered ApplicationFeePlans must have tiers');
					}
				}
			default:
				var somethingElse = pricedByStr;
				return $elm$json$Json$Decode$fail('Unknown PricedBy value: ' + somethingElse);
		}
	});
var $author$project$Api$Provider$ApplicationFeePlan$One$recordDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (intermediate) {
		return A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'tranche_size',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'ach_transaction_fee_cap_in_cents',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'total_card_fee_percentage',
					$elm$json$Json$Decode$float,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'total_card_fee_in_cents',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'total_amex_fee_percentage',
							$elm$json$Json$Decode$float,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'total_ach_fee_percentage',
								$elm$json$Json$Decode$float,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'total_ach_fee_in_cents',
									$elm$json$Json$Decode$int,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'minimum_per_month_in_cents',
										$elm$json$Json$Decode$int,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'collection_fee_percentage',
											$elm$json$Json$Decode$float,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'priced_by',
												A2($author$project$Api$Provider$ApplicationFeePlan$One$pricedByDecoder, intermediate.Dx, intermediate._l),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'name',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'id',
														$elm$json$Json$Decode$string,
														$elm$json$Json$Decode$succeed($author$project$Api$Provider$ApplicationFeePlan$One$Record)))))))))))));
	},
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'pricing_structure',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$PricingStructure$Shared$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'priced_by',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$ApplicationFeePlan$One$RecordIntermediate))));
var $author$project$Api$Provider$ApplicationFeePlan$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ApplicationFeePlan$One$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Practice$ApplicationFeePlan$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$ApplicationFeePlan$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$ApplicationFeePlan$applicationFeePlanPath));
	});
var $author$project$Pages$Admin$Billing$fetchApplicationFeePlan = function (apiClient) {
	return A2($author$project$Api$Provider$Practice$ApplicationFeePlan$retrieve, apiClient, $author$project$Pages$Admin$Billing$GotApplicationFeePlan);
};
var $author$project$Pages$Admin$Billing$GotPracticePricing = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$PracticePricing$One$PracticePricing = $elm$core$Basics$identity;
var $author$project$Api$Provider$PracticePricing$One$Record = function (nextBillDate) {
	return function (products) {
		return function (includedMembers) {
			return function (includedRevenue) {
				return function (livesOveragePriceInCents) {
					return function (revenueOveragePriceInCents) {
						return function (txnFees) {
							return function (trancheBased) {
								return function (pmpmFeeInCents) {
									return function (trancheMembersCount) {
										return function (infoMessageTitle) {
											return function (infoMessageBody) {
												return function (manualBilling) {
													return function (hubspotDealUrl) {
														return function (currentMembers) {
															return {Ph: currentMembers, TE: hubspotDealUrl, ahV: includedMembers, ahW: includedRevenue, T_: infoMessageBody, T$: infoMessageTitle, aip: livesOveragePriceInCents, Wr: manualBilling, XP: nextBillDate, ZJ: pmpmFeeInCents, Dy: products, $$: revenueOveragePriceInCents, amb: trancheBased, amc: trancheMembersCount, adI: txnFees};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$HintBillingComponent$Shared$HintBillingComponent = $elm$core$Basics$identity;
var $author$project$Api$Provider$HintBillingComponent$Shared$Record = function (id) {
	return function (quantity) {
		return function (name) {
			return function (description) {
				return function (componentType) {
					return function (unitName) {
						return function (productType) {
							return function (addonType) {
								return function (priceInCents) {
									return function (startDate) {
										return function (endDate) {
											return function (isBillable) {
												return function (hintBillingProduct) {
													return {K0: addonType, Om: componentType, Qr: description, sb: endDate, Tv: hintBillingProduct, ahP: id, UC: isBillable, Bq: name, Dw: priceInCents, Jo: productType, Dz: quantity, ab7: startDate, adM: unitName};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$HintBillingComponent$AddonType$Free = 3;
var $author$project$Api$Provider$HintBillingComponent$AddonType$OneTime = 2;
var $author$project$Api$Provider$HintBillingComponent$AddonType$Recurring = 0;
var $author$project$Api$Provider$HintBillingComponent$AddonType$RecurringQuantified = 1;
var $author$project$Api$Provider$HintBillingComponent$AddonType$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'recurring':
				return $elm$json$Json$Decode$succeed(0);
			case 'recurring_quantified':
				return $elm$json$Json$Decode$succeed(1);
			case 'one_time':
				return $elm$json$Json$Decode$succeed(2);
			case 'free':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('Unsupported addon type: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$HintBillingComponent$ComponentType$Addon = 1;
var $author$project$Api$Provider$HintBillingComponent$ComponentType$BaseFee = 0;
var $author$project$Api$Provider$HintBillingComponent$ComponentType$CliniciansPackage = 4;
var $author$project$Api$Provider$HintBillingComponent$ComponentType$Discount = 5;
var $author$project$Api$Provider$HintBillingComponent$ComponentType$LivesPackage = 2;
var $author$project$Api$Provider$HintBillingComponent$ComponentType$RevenuePackage = 3;
var $author$project$Api$Provider$HintBillingComponent$ComponentType$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'base_fee':
				return $elm$json$Json$Decode$succeed(0);
			case 'addon':
				return $elm$json$Json$Decode$succeed(1);
			case 'lives_package':
				return $elm$json$Json$Decode$succeed(2);
			case 'revenue_package':
				return $elm$json$Json$Decode$succeed(3);
			case 'discount':
				return $elm$json$Json$Decode$succeed(5);
			case 'clinicians_package':
				return $elm$json$Json$Decode$succeed(4);
			default:
				return $elm$json$Json$Decode$fail('Unsupported component type: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$HintBillingComponent$ProductType$Clinical = 1;
var $author$project$Api$Provider$HintBillingComponent$ProductType$Core = 0;
var $author$project$Api$Provider$HintBillingComponent$ProductType$Thea = 2;
var $author$project$Api$Provider$HintBillingComponent$ProductType$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'core':
				return $elm$json$Json$Decode$succeed(0);
			case 'clinical':
				return $elm$json$Json$Decode$succeed(1);
			case 'thea':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Unsupported component type: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$HintBillingComponent$UnitName$Clinician = 4;
var $author$project$Api$Provider$HintBillingComponent$UnitName$Dollar = 1;
var $author$project$Api$Provider$HintBillingComponent$UnitName$Feed = 3;
var $author$project$Api$Provider$HintBillingComponent$UnitName$HintAi = 5;
var $author$project$Api$Provider$HintBillingComponent$UnitName$Integration = 2;
var $author$project$Api$Provider$HintBillingComponent$UnitName$Member = 0;
var $author$project$Api$Provider$HintBillingComponent$UnitName$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'member':
				return $elm$json$Json$Decode$succeed(0);
			case 'dollar':
				return $elm$json$Json$Decode$succeed(1);
			case 'integration':
				return $elm$json$Json$Decode$succeed(2);
			case 'feed':
				return $elm$json$Json$Decode$succeed(3);
			case 'clinician':
				return $elm$json$Json$Decode$succeed(4);
			case 'hint_ai':
				return $elm$json$Json$Decode$succeed(5);
			case 'copilot':
				return $elm$json$Json$Decode$succeed(5);
			default:
				return $elm$json$Json$Decode$fail('Unsupported unit name: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$HintBillingProduct$Shared$HintBillingProduct = $elm$core$Basics$identity;
var $author$project$Api$Provider$HintBillingProduct$Shared$Record = F7(
	function (id, name, componentType, unitName, productType, addonType, archived) {
		return {K0: addonType, L_: archived, Om: componentType, ahP: id, Bq: name, Jo: productType, adM: unitName};
	});
var $author$project$Api$Provider$HintBillingProduct$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'archived',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'addon_type',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$HintBillingComponent$AddonType$decode),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'product',
			$elm$json$Json$Decode$nullable($author$project$Api$Provider$HintBillingComponent$ProductType$decode),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'unit_name',
				$elm$json$Json$Decode$nullable($author$project$Api$Provider$HintBillingComponent$UnitName$decode),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'component_type',
					$author$project$Api$Provider$HintBillingComponent$ComponentType$decode,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'name',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Api$Provider$HintBillingProduct$Shared$Record))))))));
var $author$project$Api$Provider$HintBillingProduct$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$HintBillingProduct$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$HintBillingComponent$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'hint_billing_product',
	$author$project$Api$Provider$HintBillingProduct$Shared$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'is_billable',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'end_date',
			$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'start_date',
				$author$project$Utils$Date$decode,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'price_in_cents',
					$elm$json$Json$Decode$float,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'addon_type',
						$elm$json$Json$Decode$nullable($author$project$Api$Provider$HintBillingComponent$AddonType$decode),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'product',
							$elm$json$Json$Decode$nullable($author$project$Api$Provider$HintBillingComponent$ProductType$decode),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'unit_name',
								$elm$json$Json$Decode$nullable($author$project$Api$Provider$HintBillingComponent$UnitName$decode),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'component_type',
									$author$project$Api$Provider$HintBillingComponent$ComponentType$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'description',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'name',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'quantity',
												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'id',
													$elm$json$Json$Decode$string,
													$elm$json$Json$Decode$succeed($author$project$Api$Provider$HintBillingComponent$Shared$Record))))))))))))));
var $author$project$Api$Provider$HintBillingComponent$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$HintBillingComponent$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$TxnFees$TxnFees = $elm$core$Basics$identity;
var $author$project$Api$Provider$TxnFees$TxnFeesRecord = F6(
	function (totalAchFeeInCents, totalAchFeePercentage, totalAmexFeePercentage, totalCardFeeInCents, totalCardFeePercentage, achTransactionFeeCapInCents) {
		return {KK: achTransactionFeeCapInCents, adj: totalAchFeeInCents, adk: totalAchFeePercentage, adl: totalAmexFeePercentage, adm: totalCardFeeInCents, Ka: totalCardFeePercentage};
	});
var $author$project$Api$Provider$TxnFees$txnFeesRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'ach_transaction_fee_cap_in_cents',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'total_card_fee_percentage',
		$elm$json$Json$Decode$float,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'total_card_fee_in_cents',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'total_amex_fee_percentage',
				$elm$json$Json$Decode$float,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'total_ach_fee_percentage',
					$elm$json$Json$Decode$float,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'total_ach_fee_in_cents',
						$elm$json$Json$Decode$int,
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$TxnFees$TxnFeesRecord)))))));
var $author$project$Api$Provider$TxnFees$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$TxnFees$txnFeesRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PracticePricing$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'current_members',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'hubspot_deal_url',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'manual_billing',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'info_message_body',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'info_message_title',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'tranche_members_count',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'pmpm_fee_in_cents',
							$elm$json$Json$Decode$float,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'tranche_based',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'txn_fees',
									$author$project$Api$Provider$TxnFees$decoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'revenue_overage_price_in_cents',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'lives_overage_price_in_cents',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'included_revenue',
												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'included_members',
													$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'products',
														$elm$json$Json$Decode$list($author$project$Api$Provider$HintBillingComponent$Shared$decoder),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'next_bill_date',
															$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
															$elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticePricing$One$Record))))))))))))))));
var $author$project$Api$Provider$PracticePricing$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PracticePricing$One$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PracticePricing$practiceSettingsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['practice/pricing']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$PracticePricing$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$PracticePricing$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$PracticePricing$practiceSettingsPath));
	});
var $author$project$Pages$Admin$Billing$fetchPracticePricing = function (apiClient) {
	return A2($author$project$Api$Provider$PracticePricing$retrieve, apiClient, $author$project$Pages$Admin$Billing$GotPracticePricing);
};
var $author$project$Pages$Admin$Billing$GotUpgradePricing = function (a) {
	return {$: 13, a: a};
};
var $author$project$Api$Provider$PracticePricing$Upgrade$UpgradePricing = $elm$core$Basics$identity;
var $author$project$Api$Provider$PracticePricing$Upgrade$Record = F6(
	function (tierName, currentTierName, totalInCents, nextBillDate, components, txnFees) {
		return {On: components, Pj: currentTierName, XP: nextBillDate, ac5: tierName, adp: totalInCents, adI: txnFees};
	});
var $author$project$Api$Provider$PracticePricing$Upgrade$componentDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'component_type',
	$author$project$Api$Provider$HintBillingComponent$ComponentType$decode,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'old_price_in_cents',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'quantity',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'price_in_cents',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'name',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed(
						F5(
							function (name, priceInCents, quantity, oldPriceInCents, componentType) {
								return {Om: componentType, Bq: name, Ya: oldPriceInCents, Dw: priceInCents, Dz: quantity};
							})))))));
var $author$project$Api$Provider$PracticePricing$Upgrade$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'txn_fees',
	$author$project$Api$Provider$TxnFees$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'components',
		$elm$json$Json$Decode$list($author$project$Api$Provider$PracticePricing$Upgrade$componentDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'next_bill_date',
			$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'total_in_cents',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'current_tier_name',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'tier_name',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticePricing$Upgrade$Record)))))));
var $author$project$Api$Provider$PracticePricing$Upgrade$decoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $author$project$Api$Provider$PracticePricing$Upgrade$recordDecoder);
var $author$project$Api$Provider$PracticePricing$Upgrade$upgradesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['practice', 'pricing', 'upgrade']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$PracticePricing$Upgrade$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$PracticePricing$Upgrade$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$PracticePricing$Upgrade$upgradesPath));
	});
var $author$project$Pages$Admin$Billing$fetchUpgradePricing = function (apiClient) {
	return A2($author$project$Api$Provider$PracticePricing$Upgrade$retrieve, apiClient, $author$project$Pages$Admin$Billing$GotUpgradePricing);
};
var $author$project$Pages$Admin$Billing$fetchPricingData = function (apiClient) {
	return _List_fromArray(
		[
			$author$project$Pages$Admin$Billing$fetchApplicationFeePlan(apiClient),
			$author$project$Pages$Admin$Billing$fetchPracticePricing(apiClient),
			$author$project$Pages$Admin$Billing$fetchUpgradePricing(apiClient)
		]);
};
var $author$project$Pages$Admin$Billing$GotUninvoicedCharges = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$PracticeCharge$All$PracticeCharge = $elm$core$Basics$identity;
var $author$project$Api$Provider$PracticeCharge$Shared$PracticeCharge = $elm$core$Basics$identity;
var $author$project$Api$Provider$PracticeCharge$Shared$Record = F8(
	function (id, description, serviceDescription, quantity, priceInCents, subtotalInCents, fromRecurringCharge, partner) {
		return {Qr: description, SL: fromRecurringCharge, ahP: id, YN: partner, Dw: priceInCents, Dz: quantity, aa0: serviceDescription, acD: subtotalInCents};
	});
var $author$project$Api$Provider$Partner$Min$Partner = $elm$core$Basics$identity;
var $author$project$Api$Provider$Partner$Min$Record = F2(
	function (id, name) {
		return {ahP: id, Bq: name};
	});
var $author$project$Api$Provider$Partner$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Partner$Min$Record)));
var $author$project$Api$Provider$Partner$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Partner$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PracticeCharge$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'partner',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Partner$Min$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'from_recurring_charge',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'subtotal_in_cents',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'price_in_cents',
				$elm$json$Json$Decode$float,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'quantity',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'service_description',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'description',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticeCharge$Shared$Record)))))))));
var $author$project$Api$Provider$PracticeCharge$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PracticeCharge$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PracticeCharge$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PracticeCharge$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PracticeCharge$listDefaults = {Uk: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$PracticeCharge$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$PracticeCharge$listDefaults);
	var _v0 = options.Uk;
	if (!_v0.$) {
		var invoice = _v0.a;
		return _List_fromArray(
			[
				A2($author$project$Api$Param$string, 'invoice', invoice)
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Api$Provider$PracticeCharge$practiceChargesPath = function (basePath) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['practice/charges']),
		basePath);
};
var $author$project$Api$Provider$PracticeCharge$list = F4(
	function (basePath, apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$PracticeCharge$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$PracticeCharge$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$PracticeCharge$practiceChargesPath(basePath))));
	});
var $author$project$Pages$Admin$Billing$fetchUninvoicedCharges = function (apiClient) {
	return A4(
		$author$project$Api$Provider$PracticeCharge$list,
		$author$project$Api$Data$providerPath,
		apiClient,
		function (d) {
			return _Utils_update(
				d,
				{
					Uk: $elm$core$Maybe$Just('')
				});
		},
		$author$project$Pages$Admin$Billing$GotUninvoicedCharges);
};
var $author$project$Api$Provider$ManagementGroup$Shared$ManagementGroup = $elm$core$Basics$identity;
var $author$project$Api$Provider$ManagementGroup$Shared$Record = F2(
	function (id, name) {
		return {ahP: id, Bq: name};
	});
var $author$project$Api$Provider$ManagementGroup$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$ManagementGroup$Shared$Record)));
var $author$project$Api$Provider$ManagementGroup$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ManagementGroup$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$ManagementGroup$resourcePath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['management_group']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$ManagementGroup$getCurrent = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$ManagementGroup$Shared$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$ManagementGroup$resourcePath));
	});
var $author$project$Api$Provider$Practice$Shared$hasClinicalAccount = function (_v0) {
	var record = _v0;
	return record.S5;
};
var $author$project$Api$Provider$Practice$One$hasClinicalAccount = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$hasClinicalAccount(shared);
};
var $author$project$Components$HintBilling$InvoicesTable$Model = $elm$core$Basics$identity;
var $author$project$Components$HintBilling$InvoicesTable$init = function (currentDate) {
	return {dd: currentDate, sP: _List_Nil, V8: false};
};
var $author$project$Api$Feature$StripeCapital = 23;
var $author$project$Api$Feature$toString = function (feature) {
	switch (feature) {
		case 0:
			return 'commissions_tracking';
		case 6:
			return 'joint_product';
		case 3:
			return 'manually_disable_elation_sync';
		case 5:
			return 'membership_auto_renew_editable';
		case 1:
			return 'nonmonthly_sponsor_billing';
		case 4:
			return 'quickbooks_bypass_pmpm_check';
		case 7:
			return 'disable_sponsor_billing';
		case 2:
			return 'tobacco_surcharge';
		case 8:
			return 'custom_js_on_signup_pages';
		case 9:
			return 'report_access';
		case 10:
			return 'multi_language';
		case 11:
			return 'virtual_bank_account';
		case 12:
			return 'customizable_notifications_by_employer';
		case 13:
			return 'passthrough_credit_card_fees';
		case 14:
			return 'allow_stripe_card_readers';
		case 15:
			return 'accounting';
		case 16:
			return 'accounting_without_bookkeeping';
		case 17:
			return 'multiple_retail_memberships';
		case 18:
			return 'manage_data_exports';
		case 19:
			return 'unified_experience';
		case 20:
			return 'age_tiered_couple_rates';
		case 21:
			return 'pricing_versions';
		case 22:
			return 'self_buy';
		case 23:
			return 'stripe_capital';
		case 24:
			return 'nav_bookmarking';
		case 25:
			return 'new_messaging_endpoint';
		case 26:
			return 'stripe_embedded_onboarding';
		case 27:
			return 'hint_billing_tax';
		case 28:
			return 'provider_waitlist';
		case 29:
			return 'address_search';
		case 30:
			return 'unified_app_card_layout';
		default:
			return 'ccda_extraction';
	}
};
var $author$project$Api$Provider$Practice$One$featureEnabled = function (feature) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Api$Provider$Practice$One$one,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.Sf;
			},
			$elm$core$List$member(
				$author$project$Api$Feature$toString(feature))));
};
var $author$project$Api$Provider$Practice$Shared$paymentProcessor = function (_v0) {
	var record = _v0;
	return record.Zd;
};
var $author$project$Api$Provider$Practice$One$paymentProcessor = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$paymentProcessor(shared);
};
var $author$project$Pages$Admin$Billing$shouldShowCapitalTile = function (practice) {
	return ($author$project$Api$Provider$Practice$One$paymentProcessor(practice) === 'stripe') && A2($author$project$Api$Provider$Practice$One$featureEnabled, 23, practice);
};
var $author$project$Components$HintBilling$InvoicesTable$withLoadingStatus = F2(
	function (loadingStatus, _v0) {
		var record = _v0;
		return _Utils_update(
			record,
			{V8: loadingStatus});
	});
var $author$project$Pages$Admin$Billing$init = F4(
	function (session, practice, shared, _v0) {
		var model = {
			Gv: shared.Gv,
			rs: $author$project$Api$Data$Loading,
			xT: $elm$core$Maybe$Nothing,
			rA: $author$project$Api$Data$NotAsked,
			rC: $author$project$Api$Data$Loading,
			iV: $elm$core$Maybe$Nothing,
			dd: shared.dd,
			nI: $author$project$Api$Data$Loading,
			S5: $author$project$Api$Provider$Practice$One$hasClinicalAccount(practice),
			Ij: $author$project$Shared$isHintAdmin(shared),
			ZV: practice,
			eU: $author$project$Api$Pagination$init,
			Dh: $author$project$Api$Data$Loading,
			kK: A2(
				$author$project$Components$HintBilling$InvoicesTable$withLoadingStatus,
				true,
				$author$project$Components$HintBilling$InvoicesTable$init(shared.dd)),
			cP: $author$project$Api$Data$Loading,
			aa4: session,
			J7: shared.J7,
			qK: _List_Nil,
			cV: $author$project$Pages$Admin$Billing$NotInitialized,
			qS: $elm$core$Maybe$Nothing,
			lV: $elm$core$Maybe$Nothing
		};
		var managementGroupCmd = $author$project$Pages$Admin$Billing$shouldShowCapitalTile(practice) ? A2($author$project$Api$Provider$ManagementGroup$getCurrent, shared.Gv, $author$project$Pages$Admin$Billing$GotManagementGroup) : $elm$core$Platform$Cmd$none;
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				A2(
					$elm$core$List$cons,
					managementGroupCmd,
					A2(
						$elm$core$List$cons,
						A2($author$project$Pages$Admin$Billing$fetchPracticeInvoices, shared.Gv, model.eU),
						A2(
							$elm$core$List$cons,
							$author$project$Pages$Admin$Billing$fetchCards(shared.Gv),
							A2(
								$elm$core$List$cons,
								$author$project$Pages$Admin$Billing$fetchBankAccounts(shared.Gv),
								A2(
									$elm$core$List$cons,
									$author$project$Pages$Admin$Billing$fetchUninvoicedCharges(shared.Gv),
									$author$project$Pages$Admin$Billing$fetchPricingData(shared.Gv))))))));
	});
var $author$project$Pages$Admin$Billing$load = F2(
	function (shared, model) {
		var _v0 = _Utils_Tuple2(shared.ZV, shared.aa4);
		if (((_v0.a.$ === 3) && (!_v0.a.a.$)) && (_v0.b.$ === 3)) {
			var _v1 = _v0.a;
			var practice = _v1.a.a;
			var _v2 = _v0.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{Gv: shared.Gv, ZV: practice}),
				$elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Admin$Billing$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Billing$CapitalOfferLoaded = function (a) {
	return {$: 22, a: a};
};
var $author$project$Pages$Admin$Billing$CreateChargeModalMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Admin$Billing$UpdateModalMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Admin$Billing$UpgradePracticeModalMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Ports$Stripe$stripePortOnCapitalOfferLoaded = _Platform_incomingPort('stripePortOnCapitalOfferLoaded', $elm$json$Json$Decode$string);
var $author$project$Ports$Stripe$onCapitalOfferLoaded = $author$project$Ports$Stripe$stripePortOnCapitalOfferLoaded;
var $author$project$Components$ApplicationFeePlan$UpdateModal$Close = {$: 0};
var $author$project$Components$ApplicationFeePlan$UpdateModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$ApplicationFeePlan$UpdateModal$Close);
};
var $author$project$Components$HintBilling$CreateChargeModal$CloseButtonClicked = {$: 0};
var $author$project$Components$HintBilling$CreateChargeModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$HintBilling$CreateChargeModal$CloseButtonClicked);
};
var $author$project$Components$UpgradePracticeModal$Close = {$: 0};
var $author$project$Components$UpgradePracticeModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$UpgradePracticeModal$Close);
};
var $author$project$Pages$Admin$Billing$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				function () {
				var _v0 = model.cV;
				if (!_v0.$) {
					return $elm$core$Platform$Sub$none;
				} else {
					var updateModal = _v0.b;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Pages$Admin$Billing$UpdateModalMsg,
						$author$project$Components$ApplicationFeePlan$UpdateModal$subscriptions(updateModal));
				}
			}(),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$Billing$CreateChargeModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$HintBilling$CreateChargeModal$subscriptions, model.iV))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$Billing$UpgradePracticeModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$UpgradePracticeModal$subscriptions, model.lV))),
				$author$project$Ports$Stripe$onCapitalOfferLoaded($author$project$Pages$Admin$Billing$CapitalOfferLoaded)
			]));
};
var $author$project$Pages$Admin$Billing$GotCapitalSession = function (a) {
	return {$: 20, a: a};
};
var $author$project$Pages$Admin$Billing$Initialized = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Pages$Admin$Billing$InvoiceCreated = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$Admin$Billing$PracticeChargeDeleted = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Api$Provider$PracticeInvoice$One$PracticeInvoice = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$PracticeInvoice$One$Record = F9(
	function (autoPayEnabled, autoPayDate, invoiceType, securePdfInlineToken, securePdfPrintableToken, source, payments, charges, purchaseOrderNumber) {
		return {Mi: autoPayDate, Mj: autoPayEnabled, NA: charges, Uv: invoiceType, Zi: payments, _K: purchaseOrderNumber, aaE: securePdfInlineToken, alh: securePdfPrintableToken, JQ: source};
	});
var $author$project$Api$Common$Source$Shared$Source = $elm$core$Basics$identity;
var $author$project$Api$Common$Source$Shared$Record = function (type_) {
	return function (id) {
		return function (name) {
			return function (label) {
				return function (status) {
					return function (lastFour) {
						return function (createdAt) {
							return function (external) {
								return function (oneTimeUse) {
									return function (paymentProcessor) {
										return function (funding) {
											return {O1: createdAt, R5: external, SN: funding, ahP: id, aih: label, VG: lastFour, Bq: name, Yl: oneTimeUse, Zd: paymentProcessor, alH: status, amg: type_};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Common$Source$Shared$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'funding',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'payment_processor',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'one_time_use',
			$elm$json$Json$Decode$bool,
			false,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'external',
				$elm$json$Json$Decode$bool,
				false,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'created_at',
					$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'last_four',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'status',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'label',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'name',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'id',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
										$elm$core$Maybe$Nothing,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'type',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
											$elm$core$Maybe$Nothing,
											$elm$json$Json$Decode$succeed($author$project$Api$Common$Source$Shared$Record))))))))))));
var $author$project$Api$Common$Source$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Source$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$File$Token$Token = $elm$core$Basics$identity;
var $author$project$Api$File$Token$decoder = A2(
	$elm$json$Json$Decode$map,
	function (string) {
		return string;
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$Payment$One$Payment = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Payment$Shared$Payment = $elm$core$Basics$identity;
var $author$project$Api$Provider$Payment$Shared$Record = function (id) {
	return function (status) {
		return function (amountInCents) {
			return function (attemptedInCents) {
				return function (paidAt) {
					return function (createdAt) {
						return function (errorMessage) {
							return function (external) {
								return function (memo) {
									return function (isRefundable) {
										return function (isRefundableOnPaymentProcessor) {
											return function (source) {
												return function (passthroughFees) {
													return function (paymentProcessor) {
														return function (cardReader) {
															return function (isCancelable) {
																return function (errorCode) {
																	return {LE: amountInCents, L7: attemptedInCents, aft: cardReader, O1: createdAt, RL: errorCode, RM: errorMessage, R5: external, ahP: id, UE: isCancelable, U8: isRefundable, U9: isRefundableOnPaymentProcessor, aiG: memo, YH: paidAt, YV: passthroughFees, Zd: paymentProcessor, JQ: source, alH: status};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$CardReader$Shared$CardReader = $elm$core$Basics$identity;
var $author$project$Api$Provider$CardReader$Shared$Record = F4(
	function (id, label, serialNumber, paymentProcessor) {
		return {ahP: id, aih: label, Zd: paymentProcessor, aaY: serialNumber};
	});
var $author$project$Api$Provider$CardReader$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'payment_processor',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'serial_number',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'label',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$CardReader$Shared$Record)))));
var $author$project$Api$Provider$CardReader$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CardReader$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Payment$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'error_code',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'is_cancelable',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'card_reader',
			$elm$json$Json$Decode$nullable($author$project$Api$Provider$CardReader$Shared$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'payment_processor',
				$elm$json$Json$Decode$string,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'passthrough_fees',
					$elm$json$Json$Decode$bool,
					false,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'source',
						$elm$json$Json$Decode$nullable($author$project$Api$Common$Source$Shared$decoder),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'is_refundable_on_payment_processor',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'is_refundable',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'memo',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'external',
										$elm$json$Json$Decode$bool,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'error_message',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'created_at',
												$elm_community$json_extra$Json$Decode$Extra$datetime,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'paid_at',
													$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'attempted_in_cents',
														$elm$json$Json$Decode$int,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'amount_in_cents',
															$elm$json$Json$Decode$int,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'status',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'id',
																	$elm$json$Json$Decode$string,
																	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Payment$Shared$Record))))))))))))))))));
var $author$project$Api$Provider$Payment$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Payment$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Payment$One$Record = F3(
	function (createdBy, refunds, dispute) {
		return {O2: createdBy, QL: dispute, $n: refunds};
	});
var $author$project$Api$Provider$Dispute$Shared$Dispute = $elm$core$Basics$identity;
var $author$project$Api$Provider$Dispute$Shared$Record = F2(
	function (id, status) {
		return {ahP: id, alH: status};
	});
var $author$project$Api$Provider$Dispute$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'status',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Dispute$Shared$Record)));
var $author$project$Api$Provider$Dispute$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Dispute$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Payment$Creator$Creator = $elm$core$Basics$identity;
var $author$project$Api$Provider$Payment$Creator$Record = function (name) {
	return {Bq: name};
};
var $author$project$Api$Provider$Payment$Creator$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Payment$Creator$Record));
var $author$project$Api$Provider$Payment$Creator$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Payment$Creator$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Refund$One$Refund = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Refund$Shared$Refund = $elm$core$Basics$identity;
var $author$project$Api$Provider$Refund$Shared$Record = F8(
	function (id, status, createdAt, external, memo, amountInCents, paymentProcessor, errorMessage) {
		return {LE: amountInCents, O1: createdAt, RM: errorMessage, R5: external, ahP: id, aiG: memo, Zd: paymentProcessor, alH: status};
	});
var $author$project$Api$Provider$Refund$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'error_message',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'payment_processor',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'amount_in_cents',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'memo',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'external',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'created_at',
						$elm_community$json_extra$Json$Decode$Extra$datetime,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'status',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Api$Provider$Refund$Shared$Record)))))))));
var $author$project$Api$Provider$Refund$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Refund$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Refund$One$Record = function (createdBy) {
	return {O2: createdBy};
};
var $author$project$Api$Provider$User$Shared$User = $elm$core$Basics$identity;
var $author$project$Api$Provider$User$Shared$Record = F3(
	function (name, displayName, isAdmin) {
		return {QK: displayName, Uy: isAdmin, Bq: name};
	});
var $author$project$Api$Provider$User$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'is_admin',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'display_name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$User$Shared$Record))));
var $author$project$Api$Provider$User$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$User$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Refund$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'created_by',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$User$Shared$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Refund$One$Record));
var $author$project$Api$Provider$Refund$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Refund$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Refund$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Refund$One$Refund)));
var $author$project$Api$Provider$Payment$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'dispute',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Dispute$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'refunds',
		$elm$json$Json$Decode$list($author$project$Api$Provider$Refund$One$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'created_by',
			$elm$json$Json$Decode$nullable($author$project$Api$Provider$Payment$Creator$decoder),
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Payment$One$Record))));
var $author$project$Api$Provider$Payment$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Payment$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Payment$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Payment$One$Payment)));
var $author$project$Api$Provider$PracticeInvoice$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'purchase_order_number',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'charges',
		$elm$json$Json$Decode$list($author$project$Api$Provider$PracticeCharge$Shared$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'payments',
			$elm$json$Json$Decode$list($author$project$Api$Provider$Payment$One$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'source',
				$elm$json$Json$Decode$nullable($author$project$Api$Common$Source$Shared$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'secure_pdf_printable_token',
					$author$project$Api$File$Token$decoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'secure_pdf_inline_token',
						$author$project$Api$File$Token$decoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'invoice_type',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'auto_pay_date',
								$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'auto_pay_enabled',
									$elm$json$Json$Decode$bool,
									$elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticeInvoice$One$Record))))))))));
var $author$project$Api$Provider$PracticeInvoice$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PracticeInvoice$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$PracticeInvoice$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticeInvoice$One$PracticeInvoice)));
var $author$project$Api$Provider$PracticeInvoice$create = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$PracticeInvoice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$PracticeInvoice$practiceInvoicesPath));
	});
var $author$project$Api$Data$delete = $author$project$Api$Data$makeRequest('delete');
var $author$project$Api$Provider$PracticeCharge$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						[id_]),
					$author$project$Api$Provider$PracticeCharge$practiceChargesPath($author$project$Api$Data$providerPath))));
	});
var $author$project$Api$Provider$PracticeCharge$Shared$description = function (_v0) {
	var record = _v0;
	return record.Qr;
};
var $author$project$Api$Provider$PracticeCharge$All$description = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PracticeCharge$Shared$description(shared);
};
var $author$project$Api$Provider$PracticePricing$One$hubspotDealUrl = function (_v0) {
	var record = _v0;
	return record.TE;
};
var $author$project$Api$Provider$PracticeCharge$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$PracticeCharge$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PracticeCharge$Shared$id(shared);
};
var $author$project$Components$ApplicationFeePlan$UpdateModal$GotCategories = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$HintBillingComponent$Shared$isBillable = function (_v0) {
	var record = _v0;
	return record.UC;
};
var $author$project$Api$Provider$PracticePricing$One$billableProducts = function (_v0) {
	var record = _v0;
	return A2(
		$elm$core$List$filter,
		function (product) {
			return $author$project$Api$Provider$HintBillingComponent$Shared$isBillable(product);
		},
		record.Dy);
};
var $author$project$Formatters$Date$Full = {$: 0};
var $author$project$Api$Provider$HintBillingComponent$Shared$componentType = function (_v0) {
	var record = _v0;
	return record.Om;
};
var $author$project$Api$Provider$HintBillingComponent$Shared$description = function (_v0) {
	var record = _v0;
	return record.Qr;
};
var $author$project$Api$Provider$HintBillingComponent$Shared$endDate = function (_v0) {
	var record = _v0;
	return record.sb;
};
var $author$project$Currency$Currency = $elm$core$Basics$identity;
var $myrho$elm_round$Round$funNum = F3(
	function (fun, s, fl) {
		return A2(
			$elm$core$Maybe$withDefault,
			0 / 0,
			$elm$core$String$toFloat(
				A2(fun, s, fl)));
	});
var $myrho$elm_round$Round$addSign = F2(
	function (signed, str) {
		var isNotZero = A2(
			$elm$core$List$any,
			function (c) {
				return (c !== '0') && (c !== '.');
			},
			$elm$core$String$toList(str));
		return _Utils_ap(
			(signed && isNotZero) ? '-' : '',
			str);
	});
var $elm$core$Char$fromCode = _Char_fromCode;
var $myrho$elm_round$Round$increaseNum = function (_v0) {
	var head = _v0.a;
	var tail = _v0.b;
	if (head === '9') {
		var _v1 = $elm$core$String$uncons(tail);
		if (_v1.$ === 1) {
			return '01';
		} else {
			var headtail = _v1.a;
			return A2(
				$elm$core$String$cons,
				'0',
				$myrho$elm_round$Round$increaseNum(headtail));
		}
	} else {
		var c = $elm$core$Char$toCode(head);
		return ((c >= 48) && (c < 57)) ? A2(
			$elm$core$String$cons,
			$elm$core$Char$fromCode(c + 1),
			tail) : '0';
	}
};
var $elm$core$Basics$isInfinite = _Basics_isInfinite;
var $elm$core$Basics$isNaN = _Basics_isNaN;
var $elm$core$String$padRight = F3(
	function (n, _char, string) {
		return _Utils_ap(
			string,
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)));
	});
var $elm$core$String$reverse = _String_reverse;
var $myrho$elm_round$Round$splitComma = function (str) {
	var _v0 = A2($elm$core$String$split, '.', str);
	if (_v0.b) {
		if (_v0.b.b) {
			var before = _v0.a;
			var _v1 = _v0.b;
			var after = _v1.a;
			return _Utils_Tuple2(before, after);
		} else {
			var before = _v0.a;
			return _Utils_Tuple2(before, '0');
		}
	} else {
		return _Utils_Tuple2('0', '0');
	}
};
var $myrho$elm_round$Round$toDecimal = function (fl) {
	var _v0 = A2(
		$elm$core$String$split,
		'e',
		$elm$core$String$fromFloat(
			$elm$core$Basics$abs(fl)));
	if (_v0.b) {
		if (_v0.b.b) {
			var num = _v0.a;
			var _v1 = _v0.b;
			var exp = _v1.a;
			var e = A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(
					A2($elm$core$String$startsWith, '+', exp) ? A2($elm$core$String$dropLeft, 1, exp) : exp));
			var _v2 = $myrho$elm_round$Round$splitComma(num);
			var before = _v2.a;
			var after = _v2.b;
			var total = _Utils_ap(before, after);
			var zeroed = (e < 0) ? A2(
				$elm$core$Maybe$withDefault,
				'0',
				A2(
					$elm$core$Maybe$map,
					function (_v3) {
						var a = _v3.a;
						var b = _v3.b;
						return a + ('.' + b);
					},
					A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$mapFirst($elm$core$String$fromChar),
						$elm$core$String$uncons(
							_Utils_ap(
								A2(
									$elm$core$String$repeat,
									$elm$core$Basics$abs(e),
									'0'),
								total))))) : A3($elm$core$String$padRight, e + 1, '0', total);
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				zeroed);
		} else {
			var num = _v0.a;
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				num);
		}
	} else {
		return '';
	}
};
var $myrho$elm_round$Round$roundFun = F3(
	function (functor, s, fl) {
		if ($elm$core$Basics$isInfinite(fl) || $elm$core$Basics$isNaN(fl)) {
			return $elm$core$String$fromFloat(fl);
		} else {
			var signed = fl < 0;
			var _v0 = $myrho$elm_round$Round$splitComma(
				$myrho$elm_round$Round$toDecimal(
					$elm$core$Basics$abs(fl)));
			var before = _v0.a;
			var after = _v0.b;
			var r = $elm$core$String$length(before) + s;
			var normalized = _Utils_ap(
				A2($elm$core$String$repeat, (-r) + 1, '0'),
				A3(
					$elm$core$String$padRight,
					r,
					'0',
					_Utils_ap(before, after)));
			var totalLen = $elm$core$String$length(normalized);
			var roundDigitIndex = A2($elm$core$Basics$max, 1, r);
			var increase = A2(
				functor,
				signed,
				A3($elm$core$String$slice, roundDigitIndex, totalLen, normalized));
			var remains = A3($elm$core$String$slice, 0, roundDigitIndex, normalized);
			var num = increase ? $elm$core$String$reverse(
				A2(
					$elm$core$Maybe$withDefault,
					'1',
					A2(
						$elm$core$Maybe$map,
						$myrho$elm_round$Round$increaseNum,
						$elm$core$String$uncons(
							$elm$core$String$reverse(remains))))) : remains;
			var numLen = $elm$core$String$length(num);
			var numZeroed = (num === '0') ? num : ((s <= 0) ? _Utils_ap(
				num,
				A2(
					$elm$core$String$repeat,
					$elm$core$Basics$abs(s),
					'0')) : ((_Utils_cmp(
				s,
				$elm$core$String$length(after)) < 0) ? (A3($elm$core$String$slice, 0, numLen - s, num) + ('.' + A3($elm$core$String$slice, numLen - s, numLen, num))) : _Utils_ap(
				before + '.',
				A3($elm$core$String$padRight, s, '0', after))));
			return A2($myrho$elm_round$Round$addSign, signed, numZeroed);
		}
	});
var $myrho$elm_round$Round$round = $myrho$elm_round$Round$roundFun(
	F2(
		function (signed, str) {
			var _v0 = $elm$core$String$uncons(str);
			if (_v0.$ === 1) {
				return false;
			} else {
				if ('5' === _v0.a.a) {
					if (_v0.a.b === '') {
						var _v1 = _v0.a;
						return !signed;
					} else {
						var _v2 = _v0.a;
						return true;
					}
				} else {
					var _v3 = _v0.a;
					var _int = _v3.a;
					return function (i) {
						return ((i > 53) && signed) || ((i >= 53) && (!signed));
					}(
						$elm$core$Char$toCode(_int));
				}
			}
		}));
var $myrho$elm_round$Round$roundNum = $myrho$elm_round$Round$funNum($myrho$elm_round$Round$round);
var $author$project$Utils$Round$float = function (value) {
	return A2($myrho$elm_round$Round$roundNum, 5, value);
};
var $author$project$Currency$fromFloat = function (_float) {
	return $elm$core$String$fromFloat(
		$author$project$Utils$Round$float(_float / 100));
};
var $author$project$Api$Provider$HintBillingComponent$Shared$hintBillingProduct = function (_v0) {
	var record = _v0;
	return record.Tv;
};
var $author$project$Api$Provider$HintBillingComponent$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$HintBillingProduct$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$HintBillingComponent$Shared$priceInCents = function (_v0) {
	var record = _v0;
	return record.Dw;
};
var $author$project$Api$Provider$HintBillingComponent$Shared$quantity = function (_v0) {
	var record = _v0;
	return record.Dz;
};
var $author$project$Api$Provider$HintBillingComponent$Shared$startDate = function (_v0) {
	var record = _v0;
	return record.ab7;
};
var $justinmimbs$date$Date$toMonths = function (rd) {
	var date = $justinmimbs$date$Date$toCalendarDate(rd);
	var wholeMonths = (12 * (date.amw - 1)) + ($justinmimbs$date$Date$monthToNumber(date.aiP) - 1);
	return wholeMonths + (date.af9 / 100);
};
var $elm$core$Basics$truncate = _Basics_truncate;
var $justinmimbs$date$Date$diff = F3(
	function (unit, _v0, _v1) {
		var rd1 = _v0;
		var rd2 = _v1;
		switch (unit) {
			case 0:
				return ((($justinmimbs$date$Date$toMonths(rd2) - $justinmimbs$date$Date$toMonths(rd1)) | 0) / 12) | 0;
			case 1:
				return ($justinmimbs$date$Date$toMonths(rd2) - $justinmimbs$date$Date$toMonths(rd1)) | 0;
			case 2:
				return ((rd2 - rd1) / 7) | 0;
			default:
				return rd2 - rd1;
		}
	});
var $author$project$Formatters$Date$relative = F3(
	function (currentDate, option, date) {
		var diff = A3($justinmimbs$date$Date$diff, 3, currentDate, date);
		return ((!_Utils_eq(
			option,
			$elm$core$Maybe$Just('bill'))) && (_Utils_cmp(diff, -1) < 1)) ? ((_Utils_cmp(diff, -7) < 1) ? A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, date) : ((_Utils_cmp(diff, -2) < 1) ? ($elm$core$String$fromInt((-1) * diff) + ' days ago') : 'Yesterday')) : ((diff <= 0) ? 'Today' : ((diff === 1) ? 'Tomorrow' : ((diff < 7) ? ('in ' + ($elm$core$String$fromInt(diff) + ' days')) : A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, date))));
	});
var $author$project$Formatters$Date$timeago = F3(
	function (currentDate, type_, date) {
		var diff = A3($justinmimbs$date$Date$diff, 3, date, currentDate);
		return (_Utils_eq(
			type_,
			$elm$core$Maybe$Just('days')) && (!diff)) ? 'today' : ((_Utils_eq(
			type_,
			$elm$core$Maybe$Just('days')) && (diff === 1)) ? 'tomorrow' : A3($author$project$Formatters$Date$relative, currentDate, $elm$core$Maybe$Nothing, date));
	});
var $author$project$Formatters$Date$toString = F2(
	function (format, date) {
		switch (format.$) {
			case 0:
				return A2($justinmimbs$date$Date$format, 'MM/dd/yyyy', date);
			case 1:
				return A2($justinmimbs$date$Date$format, 'MMMM ddd', date);
			case 2:
				return A2($justinmimbs$date$Date$format, 'MMMM yyyy', date);
			case 3:
				return A2($justinmimbs$date$Date$format, 'MMMM ddd, yyyy', date);
			case 4:
				var currentDate = format.a;
				var option = format.b;
				return A3($author$project$Formatters$Date$relative, currentDate, option, date);
			default:
				var currentDate = format.a;
				var type_ = format.b;
				return A3($author$project$Formatters$Date$timeago, currentDate, type_, date);
		}
	});
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$initHintCustomerProduct = function (charge) {
	var priceInCents = $author$project$Api$Provider$HintBillingComponent$Shared$priceInCents(charge);
	return {
		Qr: $author$project$Api$Provider$HintBillingComponent$Shared$description(charge),
		sb: $author$project$Api$Provider$HintBillingComponent$Shared$endDate(charge),
		zt: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
				$author$project$Api$Provider$HintBillingComponent$Shared$endDate(charge))),
		jS: $author$project$Api$Provider$HintBillingComponent$Shared$componentType(charge),
		Tw: $author$project$Api$Provider$HintBillingProduct$Shared$id(
			$author$project$Api$Provider$HintBillingComponent$Shared$hintBillingProduct(charge)),
		ahP: $elm$core$Maybe$Just(
			$author$project$Api$Provider$HintBillingComponent$Shared$id(charge)),
		Dw: $elm$core$Maybe$Just(
			$author$project$Currency$fromFloat(priceInCents)),
		Dz: A2(
			$elm$core$Maybe$withDefault,
			0,
			$author$project$Api$Provider$HintBillingComponent$Shared$quantity(charge)),
		ab7: $author$project$Api$Provider$HintBillingComponent$Shared$startDate(charge),
		ab9: A2(
			$author$project$Formatters$Date$toString,
			$author$project$Formatters$Date$Full,
			$author$project$Api$Provider$HintBillingComponent$Shared$startDate(charge))
	};
};
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$initFormFieldsFromPracticePlan = function (charges) {
	var recurringCharges = A2($elm$core$List$map, $author$project$Components$ApplicationFeePlan$UpdateModalForm$initHintCustomerProduct, charges);
	return {My: $elm$core$Maybe$Nothing, NA: recurringCharges, TD: $elm$core$Maybe$Nothing};
};
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$init = function (charges) {
	return $author$project$Utils$Form$init(
		$author$project$Components$ApplicationFeePlan$UpdateModalForm$initFormFieldsFromPracticePlan(charges));
};
var $author$project$Api$Provider$PracticePricing$One$isLegacyPricing = function (practicePricing) {
	return $elm$core$List$isEmpty(
		A2(
			$elm$core$List$filter,
			function (billingComponent) {
				return !$author$project$Api$Provider$HintBillingComponent$Shared$componentType(billingComponent);
			},
			$author$project$Api$Provider$PracticePricing$One$billableProducts(practicePricing)));
};
var $author$project$Api$Provider$HintBillingProduct$billingComponentsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['billing_components']),
	A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['pricing']),
		A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				['practice']),
			$author$project$Api$Data$providerPath)));
var $author$project$Api$Provider$HintBillingProduct$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$HintBillingProduct$Shared$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$HintBillingProduct$billingComponentsPath));
	});
var $author$project$Components$ApplicationFeePlan$UpdateModal$init = F4(
	function (apiClient, currentDate, practicePricing, hubspotDealUrl) {
		var charges = $author$project$Api$Provider$PracticePricing$One$billableProducts(practicePricing);
		return _Utils_Tuple2(
			{
				Nr: _List_Nil,
				NA: charges,
				dd: currentDate,
				SD: $author$project$Components$ApplicationFeePlan$UpdateModalForm$init(charges),
				TE: hubspotDealUrl,
				aic: !$author$project$Api$Provider$PracticePricing$One$isLegacyPricing(practicePricing),
				cO: $elm$core$Dict$empty,
				kN: $jinjor$elm_debounce$Debounce$init
			},
			A2($author$project$Api$Provider$HintBillingProduct$list, apiClient, $author$project$Components$ApplicationFeePlan$UpdateModal$GotCategories));
	});
var $author$project$Components$HintBilling$CreateChargeModal$GotCategories = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$HintBilling$CreateChargeModal$Model = $elm$core$Basics$identity;
var $author$project$Components$HintBilling$CreateChargeModal$formFieldInit = function (practiceInvoice) {
	return {
		jS: $elm$core$Maybe$Nothing,
		Tv: $elm$core$Maybe$Nothing,
		Bq: '',
		tV: practiceInvoice,
		Dw: $elm$core$Maybe$Nothing,
		Dz: $elm$core$Maybe$Just(1)
	};
};
var $author$project$Components$HintBilling$CreateChargeModal$init = F2(
	function (apiClient, practiceInvoice) {
		return _Utils_Tuple2(
			{
				Nr: _List_Nil,
				SD: $author$project$Utils$Form$init(
					$author$project$Components$HintBilling$CreateChargeModal$formFieldInit(practiceInvoice)),
				o7: $elm$core$Maybe$Nothing,
				kN: $jinjor$elm_debounce$Debounce$init
			},
			A2($author$project$Api$Provider$HintBillingProduct$list, apiClient, $author$project$Components$HintBilling$CreateChargeModal$GotCategories));
	});
var $author$project$Api$Provider$PracticePricing$Upgrade$currentTierName = function (_v0) {
	var record = _v0;
	return record.Pj;
};
var $author$project$Api$Platform$Session$One$organizationIsCompany = function (_v0) {
	var record = _v0;
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$eq(1),
			A2($elm$core$Maybe$map, $author$project$Api$Platform$Organization$Shared$type_, record.Yr)));
};
var $author$project$Utils$Analytics$Shared$AnalyticsProperty = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Utils$Analytics$Shared$property = F2(
	function (key, value) {
		return A2($author$project$Utils$Analytics$Shared$AnalyticsProperty, key, value);
	});
var $author$project$Utils$Analytics$Shared$appProperty = function (session) {
	var organizationIsCompany = $author$project$Api$Platform$Session$One$organizationIsCompany(session);
	var appName = organizationIsCompany ? 'employer' : 'core';
	return A2($author$project$Utils$Analytics$Shared$property, 'app', appName);
};
var $author$project$Utils$Analytics$HintBilling$currentTierProperty = function (value) {
	return A2($author$project$Utils$Analytics$Shared$property, 'current_tier', value);
};
var $elm$json$Json$Encode$dict = F3(
	function (toKey, toValue, dictionary) {
		return _Json_wrap(
			A3(
				$elm$core$Dict$foldl,
				F3(
					function (key, value, obj) {
						return A3(
							_Json_addField,
							toKey(key),
							toValue(value),
							obj);
					}),
				_Json_emptyObject(0),
				dictionary));
	});
var $author$project$Ports$FullStory$encodeEvent = F2(
	function (type_, payload) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string(type_)),
					_Utils_Tuple2('payload', payload)
				]));
	});
var $author$project$Ports$FullStory$encodeSimpleEvent = F2(
	function (type_, payload) {
		return A2(
			$author$project$Ports$FullStory$encodeEvent,
			type_,
			A3(
				$elm$json$Json$Encode$dict,
				$elm$core$Basics$identity,
				$elm$json$Json$Encode$string,
				$elm$core$Dict$fromList(payload)));
	});
var $author$project$Ports$FullStory$fullStoryPortLogEvent = _Platform_outgoingPort('fullStoryPortLogEvent', $elm$core$Basics$identity);
var $author$project$Ports$FullStory$logEvent = F2(
	function (type_, payload) {
		return $author$project$Ports$FullStory$fullStoryPortLogEvent(
			A2($author$project$Ports$FullStory$encodeSimpleEvent, type_, payload));
	});
var $author$project$Ports$Intercom$encodeEvent = F2(
	function (type_, payload) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string(type_)),
					_Utils_Tuple2('payload', payload)
				]));
	});
var $author$project$Ports$Intercom$encodeSimpleEvent = F2(
	function (type_, payload) {
		return A2(
			$author$project$Ports$Intercom$encodeEvent,
			type_,
			A3(
				$elm$json$Json$Encode$dict,
				$elm$core$Basics$identity,
				$elm$json$Json$Encode$string,
				$elm$core$Dict$fromList(payload)));
	});
var $author$project$Ports$Intercom$intercomPortLogEvent = _Platform_outgoingPort('intercomPortLogEvent', $elm$core$Basics$identity);
var $author$project$Ports$Intercom$logEvent = F2(
	function (type_, payload) {
		return $author$project$Ports$Intercom$intercomPortLogEvent(
			A2($author$project$Ports$Intercom$encodeSimpleEvent, type_, payload));
	});
var $author$project$Utils$Analytics$Shared$propertyToTuple = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return _Utils_Tuple2(key, value);
};
var $author$project$Utils$Analytics$Shared$logSimpleEvent = F2(
	function (eventName, properties) {
		var propertyTuples = A2($elm$core$List$map, $author$project$Utils$Analytics$Shared$propertyToTuple, properties);
		return $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($author$project$Ports$FullStory$logEvent, eventName, propertyTuples),
					A2($author$project$Ports$Intercom$logEvent, eventName, propertyTuples)
				]));
	});
var $author$project$Utils$Analytics$HintBilling$newTierProperty = function (value) {
	return A2($author$project$Utils$Analytics$Shared$property, 'new_tier', value);
};
var $author$project$Utils$Analytics$HintBilling$logEventWithTiers = F4(
	function (session, currentTier, newTier, eventName) {
		return A2(
			$author$project$Utils$Analytics$Shared$logSimpleEvent,
			eventName,
			_List_fromArray(
				[
					$author$project$Utils$Analytics$Shared$appProperty(session),
					$author$project$Utils$Analytics$HintBilling$currentTierProperty(currentTier),
					$author$project$Utils$Analytics$HintBilling$newTierProperty(newTier)
				]));
	});
var $author$project$Api$Provider$PracticePricing$Upgrade$tierName = function (_v0) {
	var record = _v0;
	return record.ac5;
};
var $author$project$Components$UpgradePracticeModal$logActionPerformedEvent = F3(
	function (session, pricing, eventName) {
		if (!pricing.$) {
			var pricing_ = pricing.a;
			return A4(
				$author$project$Utils$Analytics$HintBilling$logEventWithTiers,
				session,
				$author$project$Api$Provider$PracticePricing$Upgrade$currentTierName(pricing_),
				$author$project$Api$Provider$PracticePricing$Upgrade$tierName(pricing_),
				eventName);
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Components$UpgradePracticeModal$init = F3(
	function (upgradePricing, session, hasClinicalAccount) {
		return _Utils_Tuple2(
			{aeO: false, S5: hasClinicalAccount, j3: false, aa4: session, h3: upgradePricing},
			A3($author$project$Components$UpgradePracticeModal$logActionPerformedEvent, session, upgradePricing, 'Self Buy Upgrade Modal Opened'));
	});
var $author$project$Utils$Analytics$HintBilling$linkTextProperty = function (value) {
	return A2($author$project$Utils$Analytics$Shared$property, 'link_text', value);
};
var $author$project$Utils$Analytics$HintBilling$targetUrlProperty = function (value) {
	return A2($author$project$Utils$Analytics$Shared$property, 'target_url', value);
};
var $author$project$Utils$Analytics$HintBilling$logLinkClickedEvent = F3(
	function (session, linkText, targetUrl) {
		return A2(
			$author$project$Utils$Analytics$Shared$logSimpleEvent,
			'Self Buy Upgrade Link Clicked',
			_List_fromArray(
				[
					$author$project$Utils$Analytics$Shared$appProperty(session),
					$author$project$Utils$Analytics$HintBilling$linkTextProperty(linkText),
					$author$project$Utils$Analytics$HintBilling$targetUrlProperty(targetUrl)
				]));
	});
var $author$project$Ports$Stripe$stripePortMountCapitalPromoTile = _Platform_outgoingPort(
	'stripePortMountCapitalPromoTile',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'selector',
					$elm$json$Json$Encode$string($.aW)),
					_Utils_Tuple2(
					'stripeClientSecret',
					$elm$json$Json$Encode$string($.hO))
				]));
	});
var $author$project$Ports$Stripe$mountCapitalPromoTile = F2(
	function (selector, stripeClientSecret) {
		return $author$project$Ports$Stripe$stripePortMountCapitalPromoTile(
			{aW: selector, hO: stripeClientSecret});
	});
var $author$project$Pages$Admin$Billing$GotChargeCreated = function (a) {
	return {$: 19, a: a};
};
var $author$project$Api$Provider$PracticeCharge$One$PracticeCharge = 0;
var $author$project$Api$Provider$PracticeCharge$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Utils$Encode$association = function (id) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(id))
			]));
};
var $elm$json$Json$Encode$float = _Json_wrap;
var $author$project$Utils$Encode$nullable = F2(
	function (encoder, value) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$json$Json$Encode$null,
			A2($elm$core$Maybe$map, encoder, value));
	});
var $author$project$Api$Provider$PracticeCharge$encodeChargeParams = function (fields) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(fields.Qr)),
				_Utils_Tuple2(
				'quantity',
				$elm$json$Json$Encode$int(fields.Dz)),
				_Utils_Tuple2(
				'price_in_cents',
				$elm$json$Json$Encode$float(fields.Dw)),
				_Utils_Tuple2(
				'hint_billing_product',
				A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.Tw))
			]));
};
var $author$project$Api$Provider$PracticeCharge$create = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'charge',
					$author$project$Api$Provider$PracticeCharge$encodeChargeParams(fields))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$PracticeCharge$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$PracticeCharge$practiceChargesPath($author$project$Api$Data$providerPath))));
	});
var $author$project$Pages$Admin$Billing$saveCharge = F2(
	function (apiClient, chargeParams) {
		return A3($author$project$Api$Provider$PracticeCharge$create, apiClient, chargeParams, $author$project$Pages$Admin$Billing$GotChargeCreated);
	});
var $author$project$Api$Provider$Practice$StripeAccount$sessionDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['session_key']),
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$Practice$StripeAccount$stripeAccountPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['stripe_account']),
	$author$project$Api$Provider$Practice$practicePath);
var $author$project$Api$Provider$Practice$StripeAccount$session = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Practice$StripeAccount$sessionDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['session']),
					$author$project$Api$Provider$Practice$StripeAccount$stripeAccountPath)));
	});
var $author$project$Api$Pagination$totalCountFromHeaders = F2(
	function (headers, _v0) {
		var model = _v0;
		var totalCount = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$String$toInt,
				A2($elm$core$Dict$get, 'x-total-count', headers)));
		return _Utils_update(
			model,
			{qC: totalCount});
	});
var $author$project$Api$Pagination$update = F2(
	function (msg, _v0) {
		var model = _v0;
		if (!msg.$) {
			var _int = msg.a;
			return _Utils_update(
				model,
				{bX: _int});
		} else {
			var _int = msg.a;
			return _Utils_update(
				model,
				{bX: 1, gG: _int});
		}
	});
var $author$project$Components$ApplicationFeePlan$UpdateModal$ApplicationFeePlanUpdated = 2;
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$Charges = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$ApplicationFeePlan$UpdateModal$Closed = 1;
var $author$project$Components$ApplicationFeePlan$UpdateModal$HubspotDealUpdated = 3;
var $author$project$Components$ApplicationFeePlan$UpdateModal$None = 0;
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargePriceInCentsChanged = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$OutMsg$RefreshPractice = {$: 2};
var $author$project$Ui$Toast$Warning = 2;
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargeComponentTypeChanged = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargeDescriptionChanged = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Currency$toString = function (_v0) {
	var string = _v0;
	return string;
};
var $author$project$Currency$toFloat = A2(
	$elm$core$Basics$composeR,
	$author$project$Currency$toString,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$String$toFloat,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map(
				$elm$core$Basics$mul(100)),
			$elm$core$Maybe$map($author$project$Utils$Round$float))));
var $author$project$Utils$Billing$ProductPrice$convertPriceInCents = F2(
	function (currencyPrice, componentType) {
		return A2(
			$elm$core$Maybe$andThen,
			function (priceInCents) {
				if (!priceInCents) {
					return currencyPrice;
				} else {
					var absPrice = $elm$core$Basics$abs(priceInCents);
					var normalizedPrice = function () {
						if ((!componentType.$) && (componentType.a === 5)) {
							var _v1 = componentType.a;
							return -absPrice;
						} else {
							return absPrice;
						}
					}();
					return $elm$core$Maybe$Just(
						$author$project$Currency$fromFloat(normalizedPrice));
				}
			},
			A2($elm$core$Maybe$andThen, $author$project$Currency$toFloat, currencyPrice));
	});
var $elm_community$list_extra$List$Extra$getAt = F2(
	function (idx, xs) {
		return (idx < 0) ? $elm$core$Maybe$Nothing : $elm$core$List$head(
			A2($elm$core$List$drop, idx, xs));
	});
var $elm_community$list_extra$List$Extra$updateAt = F3(
	function (index, fn, list) {
		if (index < 0) {
			return list;
		} else {
			var tail = A2($elm$core$List$drop, index, list);
			var head = A2($elm$core$List$take, index, list);
			if (tail.b) {
				var x = tail.a;
				var xs = tail.b;
				return _Utils_ap(
					head,
					A2(
						$elm$core$List$cons,
						fn(x),
						xs));
			} else {
				return list;
			}
		}
	});
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$updateFormField = F2(
	function (formField, form) {
		switch (formField.$) {
			case 0:
				var index = formField.a;
				var string = formField.b;
				var newRecurringCharges = A3(
					$elm_community$list_extra$List$Extra$updateAt,
					index,
					function (charge) {
						return _Utils_update(
							charge,
							{Qr: string});
					},
					form.NA);
				return _Utils_update(
					form,
					{NA: newRecurringCharges});
			case 1:
				var list = formField.a;
				return _Utils_update(
					form,
					{NA: list});
			case 2:
				var index = formField.a;
				var string = formField.b;
				var newRecurringCharges = A3(
					$elm_community$list_extra$List$Extra$updateAt,
					index,
					function (charge) {
						return _Utils_update(
							charge,
							{ab9: string});
					},
					form.NA);
				return _Utils_update(
					form,
					{NA: newRecurringCharges});
			case 3:
				var index = formField.a;
				var string = formField.b;
				var newRecurringCharges = A3(
					$elm_community$list_extra$List$Extra$updateAt,
					index,
					function (charge) {
						return _Utils_update(
							charge,
							{zt: string});
					},
					form.NA);
				return _Utils_update(
					form,
					{NA: newRecurringCharges});
			case 4:
				var index = formField.a;
				var string = formField.b;
				var newRecurringCharges = A3(
					$elm_community$list_extra$List$Extra$updateAt,
					index,
					function (charge) {
						return _Utils_update(
							charge,
							{Tw: string});
					},
					form.NA);
				return _Utils_update(
					form,
					{NA: newRecurringCharges});
			case 5:
				var index = formField.a;
				var string = formField.b;
				var newRecurringCharges = A3(
					$elm_community$list_extra$List$Extra$updateAt,
					index,
					function (charge) {
						return _Utils_update(
							charge,
							{
								Dz: A2(
									$elm$core$Maybe$withDefault,
									0,
									$elm$core$String$toInt(string))
							});
					},
					form.NA);
				return _Utils_update(
					form,
					{NA: newRecurringCharges});
			case 6:
				var index = formField.a;
				var value = formField.b;
				var convertedValue = A2(
					$elm$core$Maybe$andThen,
					function (charge) {
						return A2(
							$author$project$Utils$Billing$ProductPrice$convertPriceInCents,
							value,
							$elm$core$Maybe$Just(charge.jS));
					},
					A2($elm_community$list_extra$List$Extra$getAt, index, form.NA));
				var newRecurringCharges = A3(
					$elm_community$list_extra$List$Extra$updateAt,
					index,
					function (charge) {
						return _Utils_update(
							charge,
							{Dw: convertedValue});
					},
					form.NA);
				return _Utils_update(
					form,
					{NA: newRecurringCharges});
			case 7:
				var value = formField.a;
				return _Utils_update(
					form,
					{
						TD: $author$project$Utils$String$toMaybe(value)
					});
			default:
				var index = formField.a;
				var value = formField.b;
				var newRecurringCharges = A3(
					$elm_community$list_extra$List$Extra$updateAt,
					index,
					function (charge) {
						return _Utils_update(
							charge,
							{jS: value});
					},
					form.NA);
				return _Utils_update(
					form,
					{NA: newRecurringCharges});
		}
	});
var $author$project$Components$ApplicationFeePlan$UpdateModal$convertPriceForCharge = F4(
	function (form, index, componentType, formWithComponentType) {
		var formFields = $author$project$Utils$Form$fields(form);
		var currentCharge = A2($elm_community$list_extra$List$Extra$getAt, index, formFields.NA);
		var currentPrice = A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Maybe$Nothing,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Dw;
				},
				currentCharge));
		var convertedPrice = A2(
			$author$project$Utils$Billing$ProductPrice$convertPriceInCents,
			currentPrice,
			$elm$core$Maybe$Just(componentType));
		return A3(
			$author$project$Utils$Form$update,
			$author$project$Components$ApplicationFeePlan$UpdateModalForm$updateFormField,
			A2($author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargePriceInCentsChanged, index, convertedPrice),
			formWithComponentType);
	});
var $author$project$Api$Provider$HintBillingProduct$Shared$componentType = function (_v0) {
	var record = _v0;
	return record.Om;
};
var $author$project$Components$ApplicationFeePlan$UpdateModal$getCategoryComponentTypeById = F2(
	function (categories, categoryId) {
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$HintBillingProduct$Shared$componentType,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (category) {
						return _Utils_eq(
							$author$project$Api$Provider$HintBillingProduct$Shared$id(category),
							categoryId);
					},
					categories)));
	});
var $author$project$Api$Provider$HintBillingProduct$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Components$ApplicationFeePlan$UpdateModal$getCategoryNameById = F2(
	function (categories, categoryId) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$HintBillingProduct$Shared$name,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (category) {
							return _Utils_eq(
								$author$project$Api$Provider$HintBillingProduct$Shared$id(category),
								categoryId);
						},
						categories))));
	});
var $author$project$Components$ApplicationFeePlan$UpdateModal$categoryFieldChanged = F4(
	function (model, index, categoryId, categoryField) {
		var newDescription = A2($author$project$Components$ApplicationFeePlan$UpdateModal$getCategoryNameById, model.Nr, categoryId);
		var formWithCategory = A3($author$project$Utils$Form$update, $author$project$Components$ApplicationFeePlan$UpdateModalForm$updateFormField, categoryField, model.SD);
		var descriptionField = A2($author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargeDescriptionChanged, index, newDescription);
		var formWithDescription = A3($author$project$Utils$Form$update, $author$project$Components$ApplicationFeePlan$UpdateModalForm$updateFormField, descriptionField, formWithCategory);
		var categoryComponentType = A2($author$project$Components$ApplicationFeePlan$UpdateModal$getCategoryComponentTypeById, model.Nr, categoryId);
		return function (form) {
			if (!categoryComponentType.$) {
				var componentType = categoryComponentType.a;
				var formWithComponentType = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$ApplicationFeePlan$UpdateModalForm$updateFormField,
					A2($author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargeComponentTypeChanged, index, componentType),
					form);
				return A4($author$project$Components$ApplicationFeePlan$UpdateModal$convertPriceForCharge, form, index, componentType, formWithComponentType);
			} else {
				return form;
			}
		}(formWithDescription);
	});
var $author$project$Components$ApplicationFeePlan$UpdateModal$PriceDebounced = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$ApplicationFeePlan$UpdateModal$debouncePrice = function (_v0) {
	var index = _v0.a;
	var price = _v0.b;
	return A2(
		$elm$core$Task$perform,
		$author$project$Components$ApplicationFeePlan$UpdateModal$PriceDebounced,
		$elm$core$Task$succeed(
			_Utils_Tuple2(index, price)));
};
var $author$project$Utils$Form$fromValidateResult = function (result) {
	if (!result.$) {
		var _v1 = result.a;
		var newForm = _v1.a;
		return newForm;
	} else {
		var newForm = result.a;
		return newForm;
	}
};
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$HubspotDealIdValidation = {$: 3};
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$hubspotDealIdIsNumber = function (form) {
	var _v0 = form.TD;
	if (!_v0.$) {
		var id = _v0.a;
		var _v1 = $elm$core$String$toInt(id);
		if (!_v1.$) {
			return true;
		} else {
			return false;
		}
	} else {
		return true;
	}
};
var $rtfeldman$elm_validate$Validate$ifFalse = F2(
	function (test, error) {
		var getErrors = function (subject) {
			return test(subject) ? _List_Nil : _List_fromArray(
				[error]);
		};
		return getErrors;
	});
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$hubspotDealIdValidator = A2(
	$rtfeldman$elm_validate$Validate$ifFalse,
	$author$project$Components$ApplicationFeePlan$UpdateModalForm$hubspotDealIdIsNumber,
	_Utils_Tuple2($author$project$Components$ApplicationFeePlan$UpdateModalForm$HubspotDealIdValidation, 'Must be a number'));
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$DescriptionValidation = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$validateDescription = F2(
	function (index, charge) {
		return $elm$core$String$isEmpty(charge.Qr) ? _List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Components$ApplicationFeePlan$UpdateModalForm$DescriptionValidation(index),
				'Description can\'t be blank')
			]) : _List_Nil;
	});
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$validateDescriptions = function (form) {
	return $elm$core$List$concat(
		A2($elm$core$List$indexedMap, $author$project$Components$ApplicationFeePlan$UpdateModalForm$validateDescription, form.NA));
};
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$recurringChargeDescriptionValidator = $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$ApplicationFeePlan$UpdateModalForm$validateDescriptions);
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$EndDateValidation = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$validateEndDate = F2(
	function (index, charge) {
		if (charge.zt === '') {
			return _List_Nil;
		} else {
			var _v0 = $author$project$Utils$Date$fromUsString(charge.zt);
			if (!_v0.$) {
				return _List_Nil;
			} else {
				return _List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$Components$ApplicationFeePlan$UpdateModalForm$EndDateValidation(index),
						'Date is invalid')
					]);
			}
		}
	});
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$validateEndDates = function (form) {
	return $elm$core$List$concat(
		A2($elm$core$List$indexedMap, $author$project$Components$ApplicationFeePlan$UpdateModalForm$validateEndDate, form.NA));
};
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$recurringChargeEndDateValidator = $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$ApplicationFeePlan$UpdateModalForm$validateEndDates);
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$PriceInCentsValidation = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$validatePriceInCentsPositive = F2(
	function (index, charge) {
		var _v0 = A2($elm$core$Maybe$andThen, $author$project$Currency$toFloat, charge.Dw);
		if (!_v0.$) {
			var priceInCents = _v0.a;
			var _v1 = _Utils_Tuple2(!priceInCents, charge.jS === 5);
			if (_v1.a && _v1.b) {
				return _List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$Components$ApplicationFeePlan$UpdateModalForm$PriceInCentsValidation(index),
						'Credit amount cannot be $0')
					]);
			} else {
				return _List_Nil;
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$validatePricesInCentsPositive = function (form) {
	return $elm$core$List$concat(
		A2($elm$core$List$indexedMap, $author$project$Components$ApplicationFeePlan$UpdateModalForm$validatePriceInCentsPositive, form.NA));
};
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$recurringChargePriceInCentsPositiveValidator = $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$ApplicationFeePlan$UpdateModalForm$validatePricesInCentsPositive);
var $author$project$Currency$isValidFloat = function (_v0) {
	var string = _v0;
	var _v1 = $elm$core$String$toFloat(string);
	if (!_v1.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$validatePriceInCents = F2(
	function (index, charge) {
		var noValueErrorMessage = (charge.jS === 5) ? 'Must be a negative number' : 'Must be a positive number';
		var _v0 = charge.Dw;
		if (!_v0.$) {
			var priceInCents = _v0.a;
			return $author$project$Currency$isValidFloat(priceInCents) ? _List_Nil : _List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Components$ApplicationFeePlan$UpdateModalForm$PriceInCentsValidation(index),
					noValueErrorMessage)
				]);
		} else {
			return _List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Components$ApplicationFeePlan$UpdateModalForm$PriceInCentsValidation(index),
					noValueErrorMessage)
				]);
		}
	});
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$validatePricesInCents = function (form) {
	return $elm$core$List$concat(
		A2($elm$core$List$indexedMap, $author$project$Components$ApplicationFeePlan$UpdateModalForm$validatePriceInCents, form.NA));
};
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$recurringChargePriceInCentsValidator = $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$ApplicationFeePlan$UpdateModalForm$validatePricesInCents);
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$QuantityValidation = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$validateQuantity = F2(
	function (index, charge) {
		return (charge.Dz > 0) ? _List_Nil : _List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Components$ApplicationFeePlan$UpdateModalForm$QuantityValidation(index),
				'Quantity must be greater than 0.')
			]);
	});
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$validateQuantities = function (form) {
	return $elm$core$List$concat(
		A2($elm$core$List$indexedMap, $author$project$Components$ApplicationFeePlan$UpdateModalForm$validateQuantity, form.NA));
};
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$recurringChargeQuantityValidator = $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$ApplicationFeePlan$UpdateModalForm$validateQuantities);
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$StartDateValidation = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$validateStartDate = F2(
	function (index, charge) {
		var _v0 = $author$project$Utils$Date$fromUsString(charge.ab9);
		if (!_v0.$) {
			return _List_Nil;
		} else {
			return _List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Components$ApplicationFeePlan$UpdateModalForm$StartDateValidation(index),
					'Date is invalid')
				]);
		}
	});
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$validateStartDates = function (form) {
	return $elm$core$List$concat(
		A2($elm$core$List$indexedMap, $author$project$Components$ApplicationFeePlan$UpdateModalForm$validateStartDate, form.NA));
};
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$recurringChargeStartDateValidator = $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$ApplicationFeePlan$UpdateModalForm$validateStartDates);
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[$author$project$Components$ApplicationFeePlan$UpdateModalForm$recurringChargeStartDateValidator, $author$project$Components$ApplicationFeePlan$UpdateModalForm$recurringChargeEndDateValidator, $author$project$Components$ApplicationFeePlan$UpdateModalForm$recurringChargeDescriptionValidator, $author$project$Components$ApplicationFeePlan$UpdateModalForm$recurringChargePriceInCentsPositiveValidator, $author$project$Components$ApplicationFeePlan$UpdateModalForm$recurringChargePriceInCentsValidator, $author$project$Components$ApplicationFeePlan$UpdateModalForm$recurringChargeQuantityValidator, $author$project$Components$ApplicationFeePlan$UpdateModalForm$hubspotDealIdValidator]));
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$hubspotOnlyValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[$author$project$Components$ApplicationFeePlan$UpdateModalForm$hubspotDealIdValidator]));
var $author$project$Components$ApplicationFeePlan$UpdateModal$getValidator = function (model) {
	return model.aic ? $author$project$Components$ApplicationFeePlan$UpdateModalForm$formFieldsValidator : $author$project$Components$ApplicationFeePlan$UpdateModalForm$hubspotOnlyValidator;
};
var $author$project$Components$ApplicationFeePlan$UpdateModal$hubspotDealModified = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form).TD;
	if (!_v0.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$initEmptyCustomerProduct = F2(
	function (category, currentDate) {
		return {
			Qr: $author$project$Api$Provider$HintBillingProduct$Shared$name(category),
			sb: $elm$core$Maybe$Nothing,
			zt: '',
			jS: $author$project$Api$Provider$HintBillingProduct$Shared$componentType(category),
			Tw: $author$project$Api$Provider$HintBillingProduct$Shared$id(category),
			ahP: $elm$core$Maybe$Nothing,
			Dw: $elm$core$Maybe$Nothing,
			Dz: 1,
			ab7: currentDate,
			ab9: A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, currentDate)
		};
	});
var $author$project$Components$ApplicationFeePlan$UpdateModal$PriceDebounceMsg = function (a) {
	return {$: 9, a: a};
};
var $jinjor$elm_debounce$Debounce$Later = function (a) {
	return {$: 2, a: a};
};
var $jinjor$elm_debounce$Debounce$later = $jinjor$elm_debounce$Debounce$Later;
var $author$project$Components$ApplicationFeePlan$UpdateModal$priceDebounceConfig = {
	alK: $jinjor$elm_debounce$Debounce$later(500),
	ame: $author$project$Components$ApplicationFeePlan$UpdateModal$PriceDebounceMsg
};
var $jinjor$elm_debounce$Debounce$Flush = function (a) {
	return {$: 1, a: a};
};
var $jinjor$elm_debounce$Debounce$SendIfLengthNotChangedFrom = function (a) {
	return {$: 2, a: a};
};
var $jinjor$elm_debounce$Debounce$delayCmd = F2(
	function (delay, msg) {
		return A2(
			$elm$core$Task$perform,
			function (_v0) {
				return msg;
			},
			$elm$core$Process$sleep(delay));
	});
var $jinjor$elm_debounce$Debounce$length = function (_v0) {
	var input = _v0.H1;
	return $elm$core$List$length(input);
};
var $jinjor$elm_debounce$Debounce$push = F3(
	function (config, a, _v0) {
		var d = _v0;
		var newDebounce = _Utils_update(
			d,
			{
				H1: A2($elm$core$List$cons, a, d.H1)
			});
		var selfCmd = function () {
			var _v1 = config.alK;
			switch (_v1.$) {
				case 0:
					var offset = _v1.a;
					return d.Wi ? $elm$core$Platform$Cmd$none : A2(
						$jinjor$elm_debounce$Debounce$delayCmd,
						offset,
						$jinjor$elm_debounce$Debounce$Flush($elm$core$Maybe$Nothing));
				case 1:
					var offset = _v1.a;
					var delay = _v1.b;
					return d.Wi ? $elm$core$Platform$Cmd$none : A2(
						$jinjor$elm_debounce$Debounce$delayCmd,
						offset,
						$jinjor$elm_debounce$Debounce$Flush(
							$elm$core$Maybe$Just(delay)));
				default:
					var delay = _v1.a;
					return A2(
						$jinjor$elm_debounce$Debounce$delayCmd,
						delay,
						$jinjor$elm_debounce$Debounce$SendIfLengthNotChangedFrom(
							$jinjor$elm_debounce$Debounce$length(newDebounce)));
			}
		}();
		return _Utils_Tuple2(
			newDebounce,
			A2($elm$core$Platform$Cmd$map, config.ame, selfCmd));
	});
var $elm_community$list_extra$List$Extra$removeAt = F2(
	function (index, l) {
		if (index < 0) {
			return l;
		} else {
			var _v0 = A2($elm$core$List$drop, index, l);
			if (!_v0.b) {
				return l;
			} else {
				var rest = _v0.b;
				return _Utils_ap(
					A2($elm$core$List$take, index, l),
					rest);
			}
		}
	});
var $jinjor$elm_debounce$Debounce$takeLast = F3(
	function (send, head, tail) {
		return _Utils_Tuple2(
			_List_Nil,
			send(head));
	});
var $jinjor$elm_debounce$Debounce$update = F4(
	function (config, send, msg, _v0) {
		var d = _v0;
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(d, $elm$core$Platform$Cmd$none);
			case 1:
				var tryAgainAfter = msg.a;
				var _v2 = d.H1;
				if (_v2.b) {
					var head = _v2.a;
					var tail = _v2.b;
					var selfCmd = function () {
						if (!tryAgainAfter.$) {
							var delay = tryAgainAfter.a;
							return A2(
								$jinjor$elm_debounce$Debounce$delayCmd,
								delay,
								$jinjor$elm_debounce$Debounce$Flush(
									$elm$core$Maybe$Just(delay)));
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}();
					var _v3 = A2(send, head, tail);
					var input = _v3.a;
					var sendCmd = _v3.b;
					return _Utils_Tuple2(
						_Utils_update(
							d,
							{H1: input, Wi: true}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									sendCmd,
									A2($elm$core$Platform$Cmd$map, config.ame, selfCmd)
								])));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							d,
							{Wi: false}),
						$elm$core$Platform$Cmd$none);
				}
			default:
				var lastInputLength = msg.a;
				var _v5 = _Utils_Tuple2(
					_Utils_cmp(
						$elm$core$List$length(d.H1),
						lastInputLength) < 1,
					d.H1);
				if (_v5.a && _v5.b.b) {
					var _v6 = _v5.b;
					var head = _v6.a;
					var tail = _v6.b;
					var _v7 = A2(send, head, tail);
					var input = _v7.a;
					var cmd = _v7.b;
					return _Utils_Tuple2(
						_Utils_update(
							d,
							{H1: input}),
						cmd);
				} else {
					return _Utils_Tuple2(d, $elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Components$ApplicationFeePlan$UpdateModal$updateModelWithForm = F2(
	function (model, newForm) {
		return {
			GZ: $elm$core$Platform$Cmd$none,
			agZ: 0,
			aiO: _Utils_update(
				model,
				{SD: newForm}),
			aR: _List_Nil
		};
	});
var $author$project$Components$ApplicationFeePlan$UpdateModal$PlanUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$ApplicationFeePlan$UpdateModal$backfillDate = F2(
	function (currentDate, charge) {
		var startDate = function () {
			var _v1 = $author$project$Utils$Date$fromUsString(charge.ab9);
			if (!_v1.$) {
				var val = _v1.a;
				return val;
			} else {
				return currentDate;
			}
		}();
		var endDate = function () {
			if (charge.zt === '') {
				return $elm$core$Maybe$Nothing;
			} else {
				var _v0 = $author$project$Utils$Date$fromUsString(charge.zt);
				if (!_v0.$) {
					var val = _v0.a;
					return $elm$core$Maybe$Just(val);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}();
		return _Utils_update(
			charge,
			{sb: endDate, ab7: startDate});
	});
var $author$project$Components$ApplicationFeePlan$UpdateModal$convertToPricingCharge = function (charge) {
	var _v0 = charge.Dw;
	if (!_v0.$) {
		var priceInCents = _v0.a;
		return $elm$core$Maybe$Just(
			{Qr: charge.Qr, sb: charge.sb, Tw: charge.Tw, ahP: charge.ahP, Dw: priceInCents, Dz: charge.Dz, ab7: charge.ab7});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Currency$encodeFloat = A2(
	$elm$core$Basics$composeR,
	$author$project$Currency$toFloat,
	$author$project$Utils$Encode$nullable($elm$json$Json$Encode$float));
var $author$project$Api$Provider$Practice$Pricing$encodeChargeParams = function (charge) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, charge.ahP)),
				_Utils_Tuple2(
				'hint_billing_product',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'id',
							$elm$json$Json$Encode$string(charge.Tw))
						]))),
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(charge.Qr)),
				_Utils_Tuple2(
				'quantity',
				$elm$json$Json$Encode$int(charge.Dz)),
				_Utils_Tuple2(
				'price_in_cents',
				$author$project$Currency$encodeFloat(charge.Dw)),
				_Utils_Tuple2(
				'start_date',
				$elm$json$Json$Encode$string(
					$justinmimbs$date$Date$toIsoString(charge.ab7))),
				_Utils_Tuple2(
				'end_date',
				A2(
					$author$project$Utils$Encode$nullable,
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $justinmimbs$date$Date$toIsoString),
					charge.sb))
			]));
};
var $author$project$Api$Provider$Practice$Pricing$pricingPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['pricing']),
	$author$project$Api$Provider$Practice$practicePath);
var $author$project$Api$Data$put = $author$project$Api$Data$makeRequest('put');
var $author$project$Api$Provider$Practice$Pricing$update = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practice_pricing',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'charges',
								A2($elm$json$Json$Encode$list, $author$project$Api$Provider$Practice$Pricing$encodeChargeParams, fields.NA)),
								_Utils_Tuple2(
								'hubspot_deal_id',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.TD))
							])))
				]));
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$ApplicationFeePlan$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$Pricing$pricingPath)));
	});
var $author$project$Components$ApplicationFeePlan$UpdateModal$updatePlan = F3(
	function (apiClient, model, validFields) {
		var formFields = $rtfeldman$elm_validate$Validate$fromValid(validFields);
		var allCharges = formFields.NA;
		var pricingCharges = A2(
			$elm$core$List$filterMap,
			$author$project$Components$ApplicationFeePlan$UpdateModal$convertToPricingCharge,
			A2(
				$elm$core$List$map,
				$author$project$Components$ApplicationFeePlan$UpdateModal$backfillDate(model.dd),
				allCharges));
		return A3(
			$author$project$Api$Provider$Practice$Pricing$update,
			apiClient,
			{NA: pricingCharges, TD: formFields.TD},
			$author$project$Components$ApplicationFeePlan$UpdateModal$PlanUpdated);
	});
var $author$project$Components$ApplicationFeePlan$UpdateModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 1,
					aiO: _Utils_update(
						model,
						{
							SD: $author$project$Components$ApplicationFeePlan$UpdateModalForm$init(model.NA),
							cO: $elm$core$Dict$empty,
							kN: $jinjor$elm_debounce$Debounce$init
						}),
					aR: _List_Nil
				};
			case 1:
				var validator = $author$project$Components$ApplicationFeePlan$UpdateModal$getValidator(model);
				var _v1 = A2($author$project$Utils$Form$validate, validator, model.SD);
				if (_v1.$ === 1) {
					var newForm = _v1.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{SD: newForm}),
						aR: _List_Nil
					};
				} else {
					var _v2 = _v1.a;
					var newForm = _v2.a;
					var validFormFields = _v2.b;
					return {
						GZ: A3($author$project$Components$ApplicationFeePlan$UpdateModal$updatePlan, apiClient, model, validFormFields),
						agZ: 0,
						aiO: _Utils_update(
							model,
							{SD: newForm}),
						aR: _List_fromArray(
							[$author$project$OutMsg$RefreshPractice])
					};
				}
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					var updateEvent = $author$project$Components$ApplicationFeePlan$UpdateModal$hubspotDealModified(model.SD) ? 3 : 2;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: updateEvent,
						aiO: model,
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Plan updated')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: model,
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 3:
				var field = msg.a;
				var validator = $author$project$Components$ApplicationFeePlan$UpdateModal$getValidator(model);
				var updatedForm = function () {
					if (field.$ === 4) {
						var index = field.a;
						var categoryId = field.b;
						return A4($author$project$Components$ApplicationFeePlan$UpdateModal$categoryFieldChanged, model, index, categoryId, field);
					} else {
						return A3($author$project$Utils$Form$update, $author$project$Components$ApplicationFeePlan$UpdateModalForm$updateFormField, field, model.SD);
					}
				}();
				return A2(
					$author$project$Components$ApplicationFeePlan$UpdateModal$updateModelWithForm,
					model,
					$author$project$Utils$Form$fromValidateResult(
						A2($author$project$Utils$Form$validate, validator, updatedForm)));
			case 8:
				var index = msg.a;
				var price = msg.b;
				var newPendingPrices = A3($elm$core$Dict$insert, index, price, model.cO);
				var _v5 = A3(
					$jinjor$elm_debounce$Debounce$push,
					$author$project$Components$ApplicationFeePlan$UpdateModal$priceDebounceConfig,
					_Utils_Tuple2(index, price),
					model.kN);
				var newDebouncer = _v5.a;
				var debounceCmd = _v5.b;
				return {
					GZ: debounceCmd,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{cO: newPendingPrices, kN: newDebouncer}),
					aR: _List_Nil
				};
			case 9:
				var debounceMsg = msg.a;
				var _v6 = A4(
					$jinjor$elm_debounce$Debounce$update,
					$author$project$Components$ApplicationFeePlan$UpdateModal$priceDebounceConfig,
					$jinjor$elm_debounce$Debounce$takeLast($author$project$Components$ApplicationFeePlan$UpdateModal$debouncePrice),
					debounceMsg,
					model.kN);
				var newDebouncer = _v6.a;
				var cmd = _v6.b;
				return {
					GZ: cmd,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{kN: newDebouncer}),
					aR: _List_Nil
				};
			case 10:
				var _v7 = msg.a;
				var index = _v7.a;
				var price = _v7.b;
				var validator = $author$project$Components$ApplicationFeePlan$UpdateModal$getValidator(model);
				var updatedForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$ApplicationFeePlan$UpdateModalForm$updateFormField,
					A2($author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargePriceInCentsChanged, index, price),
					model.SD);
				var newPendingPrices = A2($elm$core$Dict$remove, index, model.cO);
				return function (newForm) {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{SD: newForm, cO: newPendingPrices}),
						aR: _List_Nil
					};
				}(
					$author$project$Utils$Form$fromValidateResult(
						A2($author$project$Utils$Form$validate, validator, updatedForm)));
			case 4:
				var dataCategories = msg.a;
				if (dataCategories.$ === 3) {
					var categories_ = dataCategories.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{Nr: categories_}),
						aR: _List_Nil
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: model,
						aR: $author$project$OutMsg$handleErrorResponse(dataCategories)
					};
				}
			case 5:
				var fields = $author$project$Utils$Form$fields(model.SD);
				var emptyCharge = function () {
					var _v9 = $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (category) {
								return $author$project$Api$Provider$HintBillingProduct$Shared$name(category) === 'Service Credit';
							},
							model.Nr));
					if (!_v9.$) {
						var category = _v9.a;
						return _List_fromArray(
							[
								A2($author$project$Components$ApplicationFeePlan$UpdateModalForm$initEmptyCustomerProduct, category, model.dd)
							]);
					} else {
						return _List_Nil;
					}
				}();
				var newComponents = _Utils_ap(fields.NA, emptyCharge);
				return A2(
					$author$project$Components$ApplicationFeePlan$UpdateModal$updateModelWithForm,
					_Utils_update(
						model,
						{cO: $elm$core$Dict$empty}),
					A3(
						$author$project$Utils$Form$update,
						$author$project$Components$ApplicationFeePlan$UpdateModalForm$updateFormField,
						$author$project$Components$ApplicationFeePlan$UpdateModalForm$Charges(newComponents),
						model.SD));
			case 6:
				var index = msg.a;
				var fields = $author$project$Utils$Form$fields(model.SD);
				var maybeCharge = A2($elm_community$list_extra$List$Extra$getAt, index, fields.NA);
				var _v10 = A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.ahP;
					},
					maybeCharge);
				if (_v10.$ === 1) {
					if (!maybeCharge.$) {
						var validator = $author$project$Components$ApplicationFeePlan$UpdateModal$getValidator(model);
						var updatedCharges = A2($elm_community$list_extra$List$Extra$removeAt, index, fields.NA);
						var updatedForm = A3(
							$author$project$Utils$Form$update,
							$author$project$Components$ApplicationFeePlan$UpdateModalForm$updateFormField,
							$author$project$Components$ApplicationFeePlan$UpdateModalForm$Charges(updatedCharges),
							model.SD);
						var newPendingPrices = A2($elm$core$Dict$remove, index, model.cO);
						return A2(
							$author$project$Components$ApplicationFeePlan$UpdateModal$updateModelWithForm,
							_Utils_update(
								model,
								{cO: newPendingPrices}),
							$author$project$Utils$Form$fromValidateResult(
								A2($author$project$Utils$Form$validate, validator, updatedForm)));
					} else {
						return A2($author$project$Components$ApplicationFeePlan$UpdateModal$updateModelWithForm, model, model.SD);
					}
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: model,
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 2, 'Existing charges cannot be deleted')
							])
					};
				}
			default:
				var index = msg.a;
				var fields = $author$project$Utils$Form$fields(model.SD);
				var updatedCharges = A2(
					$elm$core$List$indexedMap,
					F2(
						function (i, charge) {
							if (_Utils_eq(i, index)) {
								var possibleEndDate = (A2($justinmimbs$date$Date$compare, charge.ab7, model.dd) === 2) ? charge.ab7 : model.dd;
								return _Utils_update(
									charge,
									{
										zt: A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, possibleEndDate)
									});
							} else {
								return charge;
							}
						}),
					fields.NA);
				return A2(
					$author$project$Components$ApplicationFeePlan$UpdateModal$updateModelWithForm,
					model,
					A3(
						$author$project$Utils$Form$update,
						$author$project$Components$ApplicationFeePlan$UpdateModalForm$updateFormField,
						$author$project$Components$ApplicationFeePlan$UpdateModalForm$Charges(updatedCharges),
						model.SD));
		}
	});
var $author$project$Components$HintBilling$CreateChargeModal$Closed = {$: 1};
var $author$project$Components$HintBilling$CreateChargeModal$HintBillingComponentType = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$HintBilling$CreateChargeModal$HintBillingProduct = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$HintBilling$CreateChargeModal$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$HintBilling$CreateChargeModal$None = {$: 0};
var $author$project$Components$HintBilling$CreateChargeModal$PriceInCents = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$HintBilling$CreateChargeModal$SaveCharge = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$HintBilling$CreateChargeModal$PriceDebounced = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$HintBilling$CreateChargeModal$debouncePrice = function (price) {
	return A2(
		$elm$core$Task$perform,
		$author$project$Components$HintBilling$CreateChargeModal$PriceDebounced,
		$elm$core$Task$succeed(price));
};
var $author$project$Components$HintBilling$CreateChargeModal$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{Bq: string});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Dz: $elm$core$String$toInt(string)
					});
			case 2:
				var price = field.a;
				var convertedPrice = A2($author$project$Utils$Billing$ProductPrice$convertPriceInCents, price, fields.jS);
				return _Utils_update(
					fields,
					{Dw: convertedPrice});
			case 3:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Tv: $elm$core$Maybe$Just(string)
					});
			default:
				var componentType = field.a;
				return _Utils_update(
					fields,
					{jS: componentType});
		}
	});
var $author$project$Components$HintBilling$CreateChargeModal$HintBillingProductValidation = 3;
var $rtfeldman$elm_validate$Validate$ifTrue = F2(
	function (test, error) {
		var getErrors = function (subject) {
			return test(subject) ? _List_fromArray(
				[error]) : _List_Nil;
		};
		return getErrors;
	});
var $rtfeldman$elm_validate$Validate$ifNothing = F2(
	function (subjectToMaybe, error) {
		return A2(
			$rtfeldman$elm_validate$Validate$ifTrue,
			function (subject) {
				return _Utils_eq(
					subjectToMaybe(subject),
					$elm$core$Maybe$Nothing);
			},
			error);
	});
var $author$project$Components$HintBilling$CreateChargeModal$NameValidation = 0;
var $author$project$Components$HintBilling$CreateChargeModal$validateName = function (fields) {
	return (fields.Bq === '') ? _List_fromArray(
		[
			_Utils_Tuple2(0, 'Please enter a name.')
		]) : _List_Nil;
};
var $author$project$Components$HintBilling$CreateChargeModal$PriceValidation = 2;
var $elm$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				return $elm$core$Maybe$Just(
					A2(func, a, b));
			}
		}
	});
var $author$project$Api$Provider$PracticeInvoice$Shared$dueInCents = function (_v0) {
	var record = _v0;
	return record.QY;
};
var $author$project$Api$Provider$PracticeInvoice$One$dueInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PracticeInvoice$Shared$dueInCents(shared);
};
var $author$project$Api$Provider$PracticeInvoice$Shared$paidInCents = function (_v0) {
	var record = _v0;
	return record.YI;
};
var $author$project$Api$Provider$PracticeInvoice$One$paidInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PracticeInvoice$Shared$paidInCents(shared);
};
var $author$project$Api$Provider$PracticeInvoice$Shared$humanStatus = function (_v0) {
	var record = _v0;
	return record.TH;
};
var $author$project$Api$Provider$PracticeInvoice$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PracticeInvoice$Shared$humanStatus(shared);
};
var $author$project$Components$HintBilling$CreateChargeModal$maxCreditAmount = function (practiceInvoice) {
	return ($author$project$Api$Provider$PracticeInvoice$One$status(practiceInvoice) === 3) ? $author$project$Api$Provider$PracticeInvoice$One$dueInCents(practiceInvoice) : $author$project$Api$Provider$PracticeInvoice$One$paidInCents(practiceInvoice);
};
var $cuducos$elm_format_number$FormatNumber$Parser$FormattedNumber = F5(
	function (original, integers, decimals, prefix, suffix) {
		return {PV: decimals, T7: integers, Yu: original, t1: prefix, acE: suffix};
	});
var $cuducos$elm_format_number$FormatNumber$Parser$Negative = 2;
var $cuducos$elm_format_number$FormatNumber$Parser$Positive = 0;
var $cuducos$elm_format_number$FormatNumber$Parser$Zero = 1;
var $cuducos$elm_format_number$FormatNumber$Parser$classify = function (formatted) {
	var onlyZeros = A2(
		$elm$core$String$all,
		function (_char) {
			return _char === '0';
		},
		$elm$core$String$concat(
			A2(
				$elm$core$List$append,
				formatted.T7,
				$elm$core$List$singleton(formatted.PV))));
	return onlyZeros ? 1 : ((formatted.Yu < 0) ? 2 : 0);
};
var $elm$core$String$filter = _String_filter;
var $cuducos$elm_format_number$FormatNumber$Parser$addZerosToFit = F2(
	function (desiredLength, value) {
		var length = $elm$core$String$length(value);
		var missing = (_Utils_cmp(length, desiredLength) < 0) ? $elm$core$Basics$abs(desiredLength - length) : 0;
		return _Utils_ap(
			value,
			A2($elm$core$String$repeat, missing, '0'));
	});
var $cuducos$elm_format_number$FormatNumber$Parser$removeZeros = function (decimals) {
	return (A2($elm$core$String$right, 1, decimals) !== '0') ? decimals : $cuducos$elm_format_number$FormatNumber$Parser$removeZeros(
		A2($elm$core$String$dropRight, 1, decimals));
};
var $cuducos$elm_format_number$FormatNumber$Parser$getDecimals = F2(
	function (locale, digits) {
		var _v0 = locale.PV;
		switch (_v0.$) {
			case 1:
				return $cuducos$elm_format_number$FormatNumber$Parser$removeZeros(digits);
			case 2:
				return digits;
			default:
				var min = _v0.a;
				return A2($cuducos$elm_format_number$FormatNumber$Parser$addZerosToFit, min, digits);
		}
	});
var $cuducos$elm_format_number$FormatNumber$Parser$splitInParts = F2(
	function (locale, value) {
		var toString = function () {
			var _v1 = locale.PV;
			switch (_v1.$) {
				case 1:
					var max = _v1.a;
					return $myrho$elm_round$Round$round(max);
				case 0:
					return $elm$core$String$fromFloat;
				default:
					var exact = _v1.a;
					return $myrho$elm_round$Round$round(exact);
			}
		}();
		var asList = A2(
			$elm$core$String$split,
			'.',
			toString(value));
		var decimals = function () {
			var _v0 = $elm$core$List$tail(asList);
			if (!_v0.$) {
				var values = _v0.a;
				return A2(
					$elm$core$Maybe$withDefault,
					'',
					$elm$core$List$head(values));
			} else {
				return '';
			}
		}();
		var integers = A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm$core$List$head(asList));
		return _Utils_Tuple2(integers, decimals);
	});
var $cuducos$elm_format_number$FormatNumber$Parser$splitThousands = function (integers) {
	var reversedSplitThousands = function (value) {
		return ($elm$core$String$length(value) > 3) ? A2(
			$elm$core$List$cons,
			A2($elm$core$String$right, 3, value),
			reversedSplitThousands(
				A2($elm$core$String$dropRight, 3, value))) : _List_fromArray(
			[value]);
	};
	return $elm$core$List$reverse(
		reversedSplitThousands(integers));
};
var $cuducos$elm_format_number$FormatNumber$Parser$parse = F2(
	function (locale, original) {
		var parts = A2($cuducos$elm_format_number$FormatNumber$Parser$splitInParts, locale, original);
		var integers = $cuducos$elm_format_number$FormatNumber$Parser$splitThousands(
			A2($elm$core$String$filter, $elm$core$Char$isDigit, parts.a));
		var decimals = A2($cuducos$elm_format_number$FormatNumber$Parser$getDecimals, locale, parts.b);
		var partial = A5($cuducos$elm_format_number$FormatNumber$Parser$FormattedNumber, original, integers, decimals, '', '');
		var _v0 = $cuducos$elm_format_number$FormatNumber$Parser$classify(partial);
		switch (_v0) {
			case 2:
				return _Utils_update(
					partial,
					{t1: locale.aiV, acE: locale.aiW});
			case 0:
				return _Utils_update(
					partial,
					{t1: locale.aj5, acE: locale.aj6});
			default:
				return _Utils_update(
					partial,
					{t1: locale.amy, acE: locale.amz});
		}
	});
var $cuducos$elm_format_number$FormatNumber$Stringfy$formatDecimals = F2(
	function (locale, decimals) {
		return (decimals === '') ? '' : _Utils_ap(locale.agf, decimals);
	});
var $cuducos$elm_format_number$FormatNumber$Stringfy$stringfy = F2(
	function (locale, formatted) {
		var stringfyDecimals = $cuducos$elm_format_number$FormatNumber$Stringfy$formatDecimals(locale);
		var integers = A2($elm$core$String$join, locale.al2, formatted.T7);
		var decimals = stringfyDecimals(formatted.PV);
		return $elm$core$String$concat(
			_List_fromArray(
				[formatted.t1, integers, decimals, formatted.acE]));
	});
var $cuducos$elm_format_number$FormatNumber$format = F2(
	function (locale, number_) {
		return A2(
			$cuducos$elm_format_number$FormatNumber$Stringfy$stringfy,
			locale,
			A2($cuducos$elm_format_number$FormatNumber$Parser$parse, locale, number_));
	});
var $author$project$Currency$toInt = function (_v0) {
	var string = _v0;
	return A2(
		$elm$core$Maybe$map,
		$elm$core$Basics$round,
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$mul(100),
			$elm$core$String$toFloat(string)));
};
var $cuducos$elm_format_number$FormatNumber$Locales$Exact = function (a) {
	return {$: 2, a: a};
};
var $cuducos$elm_format_number$FormatNumber$Locales$Min = function (a) {
	return {$: 0, a: a};
};
var $cuducos$elm_format_number$FormatNumber$Locales$base = {
	agf: '.',
	PV: $cuducos$elm_format_number$FormatNumber$Locales$Min(0),
	aiV: '−',
	aiW: '',
	aj5: '',
	aj6: '',
	al2: '',
	amy: '',
	amz: ''
};
var $cuducos$elm_format_number$FormatNumber$Locales$usLocale = _Utils_update(
	$cuducos$elm_format_number$FormatNumber$Locales$base,
	{
		PV: $cuducos$elm_format_number$FormatNumber$Locales$Exact(2),
		al2: ','
	});
var $author$project$Currency$format = function (currency) {
	var _v0 = $author$project$Currency$toInt(currency);
	if (!_v0.$) {
		var cents = _v0.a;
		return '$' + A2($cuducos$elm_format_number$FormatNumber$format, $cuducos$elm_format_number$FormatNumber$Locales$usLocale, cents / 100);
	} else {
		return 'N/A';
	}
};
var $author$project$Currency$fromInt = function (_int) {
	return $elm$core$String$fromFloat(_int / 100);
};
var $author$project$Components$HintBilling$CreateChargeModal$priceErrorForInvoice = function (practiceInvoice) {
	if ($author$project$Api$Provider$PracticeInvoice$One$status(practiceInvoice) === 3) {
		var dueText = $author$project$Currency$format(
			$author$project$Currency$fromInt(
				$author$project$Api$Provider$PracticeInvoice$One$dueInCents(practiceInvoice)));
		return _List_fromArray(
			[
				_Utils_Tuple2(2, 'Credit cannot excceed the Total Due of ' + (dueText + '.'))
			]);
	} else {
		return _List_fromArray(
			[
				_Utils_Tuple2(2, 'Credit cannot excceed amount paid.')
			]);
	}
};
var $author$project$Components$HintBilling$CreateChargeModal$validatePrice = function (fields) {
	var _v0 = _Utils_Tuple2(fields.Dw, fields.jS);
	if (!_v0.a.$) {
		if (!_v0.b.$) {
			var priceInCents = _v0.a.a;
			var componentType = _v0.b.a;
			var _v1 = $author$project$Currency$toFloat(priceInCents);
			if (!_v1.$) {
				var price = _v1.a;
				var _v2 = _Utils_Tuple2(!price, componentType === 5);
				_v2$2:
				while (true) {
					if (_v2.a) {
						if (_v2.b) {
							return _List_fromArray(
								[
									_Utils_Tuple2(2, 'Credit amount cannot be $0')
								]);
						} else {
							break _v2$2;
						}
					} else {
						if (_v2.b) {
							return A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A3(
									$elm$core$Maybe$map2,
									F2(
										function (practiceInvoice_, quantity_) {
											return (_Utils_cmp(
												$elm$core$Basics$abs(price * quantity_),
												$author$project$Components$HintBilling$CreateChargeModal$maxCreditAmount(practiceInvoice_)) > 0) ? $author$project$Components$HintBilling$CreateChargeModal$priceErrorForInvoice(practiceInvoice_) : _List_Nil;
										}),
									fields.tV,
									fields.Dz));
						} else {
							break _v2$2;
						}
					}
				}
				return _List_Nil;
			} else {
				return _List_fromArray(
					[
						_Utils_Tuple2(2, 'Must be a valid number')
					]);
			}
		} else {
			return _List_Nil;
		}
	} else {
		var _v3 = _v0.a;
		return _List_fromArray(
			[
				_Utils_Tuple2(2, 'Must be a number')
			]);
	}
};
var $author$project$Components$HintBilling$CreateChargeModal$QuantityValidation = 1;
var $author$project$Components$HintBilling$CreateChargeModal$validateQuantity = function (fields) {
	var _v0 = fields.Dz;
	if (_v0.$ === 1) {
		return _List_fromArray(
			[
				_Utils_Tuple2(1, 'Please enter a quantity.')
			]);
	} else {
		var qty = _v0.a;
		return (qty > 0) ? _List_Nil : _List_fromArray(
			[
				_Utils_Tuple2(1, 'Quantity must be greater than 0.')
			]);
	}
};
var $author$project$Components$HintBilling$CreateChargeModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$HintBilling$CreateChargeModal$validatePrice),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$HintBilling$CreateChargeModal$validateName),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$HintBilling$CreateChargeModal$validateQuantity),
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.Tv;
			},
			_Utils_Tuple2(3, 'Please select a category.'))
		]));
var $author$project$Components$HintBilling$CreateChargeModal$params = function (fields) {
	return {
		Qr: fields.Bq,
		Tw: fields.Tv,
		Dw: A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.Dw)),
		Dz: A2($elm$core$Maybe$withDefault, 1, fields.Dz)
	};
};
var $author$project$Components$HintBilling$CreateChargeModal$PriceDebounceMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$HintBilling$CreateChargeModal$priceDebounceConfig = {
	alK: $jinjor$elm_debounce$Debounce$later(500),
	ame: $author$project$Components$HintBilling$CreateChargeModal$PriceDebounceMsg
};
var $author$project$Components$HintBilling$CreateChargeModal$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: $author$project$Components$HintBilling$CreateChargeModal$Closed,
					aiO: _Utils_update(
						model,
						{o7: $elm$core$Maybe$Nothing, kN: $jinjor$elm_debounce$Debounce$init}),
					aR: _List_Nil
				};
			case 1:
				var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$HintBilling$CreateChargeModal$formFieldsValidator, model.SD);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var newForm = _v3.a;
					var validFormFields = _v3.b;
					var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$HintBilling$CreateChargeModal$SaveCharge(
							$author$project$Components$HintBilling$CreateChargeModal$params(fields)),
						aiO: _Utils_update(
							model,
							{SD: newForm}),
						aR: _List_Nil
					};
				} else {
					var newForm = _v2.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$HintBilling$CreateChargeModal$None,
						aiO: _Utils_update(
							model,
							{SD: newForm}),
						aR: _List_Nil
					};
				}
			case 2:
				var field = msg.a;
				if (field.$ === 2) {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$HintBilling$CreateChargeModal$None, aiO: model, aR: _List_Nil};
				} else {
					return function (updatedForm) {
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: $author$project$Components$HintBilling$CreateChargeModal$None,
							aiO: _Utils_update(
								model,
								{SD: updatedForm}),
							aR: _List_Nil
						};
					}(
						$author$project$Utils$Form$fromValidateResult(
							A2(
								$author$project$Utils$Form$validate,
								$author$project$Components$HintBilling$CreateChargeModal$formFieldsValidator,
								A3($author$project$Utils$Form$update, $author$project$Components$HintBilling$CreateChargeModal$formFieldsUpdate, field, model.SD))));
				}
			case 5:
				var price = msg.a;
				var _v5 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Components$HintBilling$CreateChargeModal$priceDebounceConfig, price, model.kN);
				var newDebouncer = _v5.a;
				var debounceCmd = _v5.b;
				return {
					GZ: debounceCmd,
					agZ: $author$project$Components$HintBilling$CreateChargeModal$None,
					aiO: _Utils_update(
						model,
						{
							o7: $elm$core$Maybe$Just(price),
							kN: newDebouncer
						}),
					aR: _List_Nil
				};
			case 6:
				var debounceMsg = msg.a;
				var _v6 = A4(
					$jinjor$elm_debounce$Debounce$update,
					$author$project$Components$HintBilling$CreateChargeModal$priceDebounceConfig,
					$jinjor$elm_debounce$Debounce$takeLast($author$project$Components$HintBilling$CreateChargeModal$debouncePrice),
					debounceMsg,
					model.kN);
				var newDebouncer = _v6.a;
				var cmd = _v6.b;
				return {
					GZ: cmd,
					agZ: $author$project$Components$HintBilling$CreateChargeModal$None,
					aiO: _Utils_update(
						model,
						{kN: newDebouncer}),
					aR: _List_Nil
				};
			case 7:
				var price = msg.a;
				var updatedForm = $author$project$Utils$Form$fromValidateResult(
					A2(
						$author$project$Utils$Form$validate,
						$author$project$Components$HintBilling$CreateChargeModal$formFieldsValidator,
						A3(
							$author$project$Utils$Form$update,
							$author$project$Components$HintBilling$CreateChargeModal$formFieldsUpdate,
							$author$project$Components$HintBilling$CreateChargeModal$PriceInCents(price),
							model.SD)));
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: $author$project$Components$HintBilling$CreateChargeModal$None,
					aiO: _Utils_update(
						model,
						{SD: updatedForm, o7: $elm$core$Maybe$Nothing}),
					aR: _List_Nil
				};
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					var list = response.a;
					var serviceCreditCategory = $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (product) {
								return $author$project$Api$Provider$HintBillingProduct$Shared$name(product) === 'Service Credit';
							},
							list));
					var updatedForm = function () {
						if (!serviceCreditCategory.$) {
							var category = serviceCreditCategory.a;
							var formWithCategory = A3(
								$author$project$Utils$Form$update,
								$author$project$Components$HintBilling$CreateChargeModal$formFieldsUpdate,
								$author$project$Components$HintBilling$CreateChargeModal$HintBillingProduct(
									$author$project$Api$Provider$HintBillingProduct$Shared$id(category)),
								model.SD);
							var formWithComponentType = A3(
								$author$project$Utils$Form$update,
								$author$project$Components$HintBilling$CreateChargeModal$formFieldsUpdate,
								$author$project$Components$HintBilling$CreateChargeModal$HintBillingComponentType(
									$elm$core$Maybe$Just(
										$author$project$Api$Provider$HintBillingProduct$Shared$componentType(category))),
								formWithCategory);
							return A3(
								$author$project$Utils$Form$update,
								$author$project$Components$HintBilling$CreateChargeModal$formFieldsUpdate,
								$author$project$Components$HintBilling$CreateChargeModal$Name(
									$author$project$Api$Provider$HintBillingProduct$Shared$name(category)),
								formWithComponentType);
						} else {
							return model.SD;
						}
					}();
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$HintBilling$CreateChargeModal$None,
						aiO: _Utils_update(
							model,
							{Nr: list, SD: updatedForm}),
						aR: _List_Nil
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$HintBilling$CreateChargeModal$None,
						aiO: model,
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			default:
				var hintBillingProductId = msg.a;
				var hintBillingProduct = $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (product) {
							return _Utils_eq(
								$author$project$Api$Provider$HintBillingProduct$Shared$id(product),
								hintBillingProductId);
						},
						model.Nr));
				var formWithCategory = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$HintBilling$CreateChargeModal$formFieldsUpdate,
					$author$project$Components$HintBilling$CreateChargeModal$HintBillingProduct(hintBillingProductId),
					model.SD);
				var currentPrice = $author$project$Utils$Form$fields(model.SD).Dw;
				var componentType = A2($elm$core$Maybe$map, $author$project$Api$Provider$HintBillingProduct$Shared$componentType, hintBillingProduct);
				var convertedPrice = A2($author$project$Utils$Billing$ProductPrice$convertPriceInCents, currentPrice, componentType);
				var formWithComponentType = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$HintBilling$CreateChargeModal$formFieldsUpdate,
					$author$project$Components$HintBilling$CreateChargeModal$HintBillingComponentType(componentType),
					formWithCategory);
				var formWithPrice = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$HintBilling$CreateChargeModal$formFieldsUpdate,
					$author$project$Components$HintBilling$CreateChargeModal$PriceInCents(convertedPrice),
					formWithComponentType);
				var categoryName = A2(
					$elm$core$Maybe$withDefault,
					'',
					A2($elm$core$Maybe$map, $author$project$Api$Provider$HintBillingProduct$Shared$name, hintBillingProduct));
				var updatedForm = $author$project$Utils$Form$fromValidateResult(
					A2(
						$author$project$Utils$Form$validate,
						$author$project$Components$HintBilling$CreateChargeModal$formFieldsValidator,
						A3(
							$author$project$Utils$Form$update,
							$author$project$Components$HintBilling$CreateChargeModal$formFieldsUpdate,
							$author$project$Components$HintBilling$CreateChargeModal$Name(categoryName),
							formWithPrice)));
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: $author$project$Components$HintBilling$CreateChargeModal$None,
					aiO: _Utils_update(
						model,
						{SD: updatedForm}),
					aR: _List_Nil
				};
		}
	});
var $author$project$Components$UpgradePracticeModal$Closed = {$: 1};
var $author$project$Components$UpgradePracticeModal$CreatedUpgrade = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$UpgradePracticeModal$None = {$: 0};
var $author$project$Components$UpgradePracticeModal$UpgradedSuccess = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$PracticePricing$Upgrade$create = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'upgrade',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'agreed_to_terms',
								$elm$json$Json$Encode$bool(fields.aeO))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$PracticePricing$Upgrade$upgradesPath)));
	});
var $author$project$Components$UpgradePracticeModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				return {
					GZ: A3($author$project$Components$UpgradePracticeModal$logActionPerformedEvent, model.aa4, model.h3, 'Self Buy Upgrade Modal Closed'),
					agZ: $author$project$Components$UpgradePracticeModal$Closed,
					aiO: model
				};
			case 1:
				var value = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: $author$project$Components$UpgradePracticeModal$None,
					aiO: _Utils_update(
						model,
						{aeO: value})
				};
			case 2:
				return model.j3 ? {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$UpgradePracticeModal$None, aiO: model} : {
					GZ: A3(
						$author$project$Api$Provider$PracticePricing$Upgrade$create,
						apiClient,
						{aeO: model.aeO},
						$author$project$Components$UpgradePracticeModal$CreatedUpgrade),
					agZ: $author$project$Components$UpgradePracticeModal$None,
					aiO: _Utils_update(
						model,
						{j3: true})
				};
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					var tier = function () {
						var _v2 = model.h3;
						if (!_v2.$) {
							var pricing = _v2.a;
							return $author$project$Api$Provider$PracticePricing$Upgrade$tierName(pricing);
						} else {
							return 'plan';
						}
					}();
					return {
						GZ: A3($author$project$Components$UpgradePracticeModal$logActionPerformedEvent, model.aa4, model.h3, 'Self Buy Upgrade Completed'),
						agZ: $author$project$Components$UpgradePracticeModal$UpgradedSuccess('Your upgrade to ' + (tier + ' was successful')),
						aiO: _Utils_update(
							model,
							{j3: false})
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$UpgradePracticeModal$None,
						aiO: _Utils_update(
							model,
							{j3: false})
					};
				}
			default:
				var text = msg.a;
				var href = msg.b;
				return {
					GZ: A3($author$project$Utils$Analytics$HintBilling$logLinkClickedEvent, model.aa4, text, href),
					agZ: $author$project$Components$UpgradePracticeModal$None,
					aiO: model
				};
		}
	});
var $elm$url$Url$Builder$Relative = {$: 1};
var $elm$url$Url$Builder$rootToPrePath = function (root) {
	switch (root.$) {
		case 0:
			return '/';
		case 1:
			return '';
		default:
			var prePath = root.a;
			return prePath + '/';
	}
};
var $elm$url$Url$Builder$custom = F4(
	function (root, pathSegments, parameters, maybeFragment) {
		var fragmentless = _Utils_ap(
			$elm$url$Url$Builder$rootToPrePath(root),
			_Utils_ap(
				A2($elm$core$String$join, '/', pathSegments),
				$elm$url$Url$Builder$toQuery(parameters)));
		if (maybeFragment.$ === 1) {
			return fragmentless;
		} else {
			var fragment = maybeFragment.a;
			return fragmentless + ('#' + fragment);
		}
	});
var $author$project$Pages$Admin$Billing$updateUrl = function (maybeCustomPath) {
	var url = $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Admin__Billing);
	if (!maybeCustomPath.$) {
		var customPath = maybeCustomPath.a;
		return $author$project$Ports$Navigation$pushUrl(
			A4(
				$elm$url$Url$Builder$custom,
				$elm$url$Url$Builder$Relative,
				_List_fromArray(
					[url]),
				_List_Nil,
				$elm$core$Maybe$Just(customPath)));
	} else {
		return $author$project$Ports$Navigation$pushUrl(url);
	}
};
var $author$project$Components$UpgradePracticeModal$urlParam = function (model) {
	return A2(
		$elm$core$Maybe$map,
		function (tierName) {
			return 'self-upgrade-' + tierName;
		},
		A2(
			$elm$core$Maybe$map,
			$elm$core$String$toLower,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$PracticePricing$Upgrade$tierName, model.h3)));
};
var $author$project$Components$HintBilling$InvoicesTable$NotPaid = {$: 1};
var $author$project$Components$HintBilling$InvoicesTable$PaidTime = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$PracticeInvoice$Shared$invoiceDate = function (_v0) {
	var record = _v0;
	return record.Uq;
};
var $author$project$Api$Provider$PracticeInvoice$All$date = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PracticeInvoice$Shared$invoiceDate(shared);
};
var $author$project$Api$Provider$PracticeInvoice$Shared$dueDate = function (_v0) {
	var record = _v0;
	return record.QX;
};
var $author$project$Api$Provider$PracticeInvoice$All$dueDate = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PracticeInvoice$Shared$dueDate(shared);
};
var $author$project$Api$Provider$PracticeInvoice$All$dueInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PracticeInvoice$Shared$dueInCents(shared);
};
var $author$project$Api$Provider$PracticeInvoice$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$PracticeInvoice$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PracticeInvoice$Shared$id(shared);
};
var $author$project$Api$Provider$PracticeInvoice$Shared$invoiceNumber = function (_v0) {
	var record = _v0;
	return record.Uu;
};
var $author$project$Api$Provider$PracticeInvoice$All$number = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PracticeInvoice$Shared$invoiceNumber(shared);
};
var $author$project$Api$Provider$PracticeInvoice$Shared$paidAt = function (_v0) {
	var record = _v0;
	return record.YH;
};
var $author$project$Api$Provider$PracticeInvoice$All$paidAt = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PracticeInvoice$Shared$paidAt(shared);
};
var $author$project$Api$Provider$PracticeInvoice$Shared$partner = function (_v0) {
	var record = _v0;
	return record.YN;
};
var $author$project$Api$Provider$PracticeInvoice$All$partner = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PracticeInvoice$Shared$partner(shared);
};
var $author$project$Api$Provider$PracticeInvoice$All$status = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PracticeInvoice$Shared$humanStatus(shared);
};
var $author$project$Api$Provider$PracticeInvoice$Shared$totalInCents = function (_v0) {
	var record = _v0;
	return record.adp;
};
var $author$project$Api$Provider$PracticeInvoice$All$totalInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PracticeInvoice$Shared$totalInCents(shared);
};
var $author$project$Components$HintBilling$InvoicesTable$withPracticeInvoices = F3(
	function (practiceInvoices, timeFormatter, _v0) {
		var record = _v0;
		return _Utils_update(
			record,
			{
				sP: A2(
					$elm$core$List$map,
					function (practiceInvoice) {
						return {
							PB: $author$project$Api$Provider$PracticeInvoice$All$date(practiceInvoice),
							QX: $author$project$Api$Provider$PracticeInvoice$All$dueDate(practiceInvoice),
							QY: $author$project$Api$Provider$PracticeInvoice$All$dueInCents(practiceInvoice),
							ahP: $author$project$Api$Provider$PracticeInvoice$All$id(practiceInvoice),
							IO: $author$project$Api$Provider$PracticeInvoice$All$number(practiceInvoice),
							I1: function () {
								var _v1 = $author$project$Api$Provider$PracticeInvoice$All$paidAt(practiceInvoice);
								if (!_v1.$) {
									var time = _v1.a;
									return A2($author$project$Components$HintBilling$InvoicesTable$PaidTime, time, timeFormatter);
								} else {
									return $author$project$Components$HintBilling$InvoicesTable$NotPaid;
								}
							}(),
							YN: $author$project$Api$Provider$PracticeInvoice$All$partner(practiceInvoice),
							alH: $author$project$Api$Provider$PracticeInvoice$All$status(practiceInvoice),
							adp: $author$project$Api$Provider$PracticeInvoice$All$totalInCents(practiceInvoice)
						};
					},
					practiceInvoices)
			});
	});
var $author$project$Pages$Admin$Billing$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nI: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 2:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cP: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 5:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{rs: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 4:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{rC: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var response = msg.a;
				if (response.$ === 3) {
					var invoices = response.a;
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								eU: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.eU),
								Dh: response,
								kK: A2(
									$author$project$Components$HintBilling$InvoicesTable$withLoadingStatus,
									false,
									A3($author$project$Components$HintBilling$InvoicesTable$withPracticeInvoices, invoices, model.J7, model.kK))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Dh: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$reportDecodeError(response));
				}
			case 8:
				var response = msg.a;
				if (response.$ === 3) {
					var uninvoicedCharges_ = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{qK: uninvoicedCharges_}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 3:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.eU);
				var newModel = _Utils_update(
					model,
					{
						eU: pagination,
						kK: A2($author$project$Components$HintBilling$InvoicesTable$withLoadingStatus, true, model.kK)
					});
				return _Utils_Tuple3(
					newModel,
					A2($author$project$Pages$Admin$Billing$fetchPracticeInvoices, model.Gv, pagination),
					_List_Nil);
			case 6:
				var practicePricing = msg.a;
				var _v3 = model.cV;
				if (!_v3.$) {
					var hubspotDealUrl = A2(
						$elm$core$Maybe$andThen,
						$author$project$Api$Provider$PracticePricing$One$hubspotDealUrl,
						$author$project$Api$Data$toMaybe(model.cP));
					var _v4 = A4($author$project$Components$ApplicationFeePlan$UpdateModal$init, model.Gv, model.dd, practicePricing, hubspotDealUrl);
					var newModel = _v4.a;
					var cmd = _v4.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cV: A2($author$project$Pages$Admin$Billing$Initialized, true, newModel)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Billing$UpdateModalMsg, cmd),
						_List_Nil);
				} else {
					var modal = _v3.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cV: A2($author$project$Pages$Admin$Billing$Initialized, true, modal)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 7:
				var subMsg = msg.a;
				var _v5 = model.cV;
				if (!_v5.$) {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				} else {
					var open = _v5.a;
					var updateModal = _v5.b;
					var result = A3($author$project$Components$ApplicationFeePlan$UpdateModal$update, model.Gv, subMsg, updateModal);
					var loadingModel = _Utils_update(
						model,
						{nI: $author$project$Api$Data$Loading, cP: $author$project$Api$Data$Loading, cV: $author$project$Pages$Admin$Billing$NotInitialized, qS: $elm$core$Maybe$Nothing});
					var fetchDataCmd = $elm$core$Platform$Cmd$batch(
						$author$project$Pages$Admin$Billing$fetchPricingData(model.Gv));
					var _v6 = result.agZ;
					switch (_v6) {
						case 1:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										cV: A2($author$project$Pages$Admin$Billing$Initialized, false, result.aiO)
									}),
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Billing$UpdateModalMsg, result.GZ),
								result.aR);
						case 2:
							return _Utils_Tuple3(
								loadingModel,
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											fetchDataCmd,
											A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Billing$UpdateModalMsg, result.GZ)
										])),
								result.aR);
						case 3:
							return _Utils_Tuple3(
								loadingModel,
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											fetchDataCmd,
											A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Billing$UpdateModalMsg, result.GZ)
										])),
								result.aR);
						default:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										cV: A2($author$project$Pages$Admin$Billing$Initialized, open, result.aiO)
									}),
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Billing$UpdateModalMsg, result.GZ),
								result.aR);
					}
				}
			case 10:
				var _v7 = A2($author$project$Components$HintBilling$CreateChargeModal$init, model.Gv, $elm$core$Maybe$Nothing);
				var createChargeModal = _v7.a;
				var createChargeModalCmd = _v7.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							iV: $elm$core$Maybe$Just(createChargeModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Billing$CreateChargeModalMsg, createChargeModalCmd),
					_List_Nil);
			case 9:
				var subMsg = msg.a;
				var _v8 = model.iV;
				if (!_v8.$) {
					var createChargeModal = _v8.a;
					var result = A2($author$project$Components$HintBilling$CreateChargeModal$update, subMsg, createChargeModal);
					var _v9 = function () {
						var _v10 = result.agZ;
						switch (_v10.$) {
							case 1:
								return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
							case 2:
								var chargeParams = _v10.a;
								return _Utils_Tuple2(
									$elm$core$Maybe$Nothing,
									A2($author$project$Pages$Admin$Billing$saveCharge, model.Gv, chargeParams));
							default:
								return _Utils_Tuple2(
									$elm$core$Maybe$Just(result.aiO),
									$elm$core$Platform$Cmd$none);
						}
					}();
					var createChargeModal_ = _v9.a;
					var cmd = _v9.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{iV: createChargeModal_}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Billing$CreateChargeModalMsg, result.GZ),
									cmd
								])),
						result.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 11:
				var practiceCharge = msg.a;
				var id = $author$project$Api$Provider$PracticeCharge$All$id(practiceCharge);
				return _Utils_Tuple3(
					model,
					A3(
						$author$project$Api$Provider$PracticeCharge$delete,
						model.Gv,
						id,
						$author$project$Pages$Admin$Billing$PracticeChargeDeleted(practiceCharge)),
					_List_Nil);
			case 12:
				var practiceCharge = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var uninvoicedCharges_ = A2(
						$elm$core$List$filter,
						function (charge) {
							return !_Utils_eq(
								$author$project$Api$Provider$PracticeCharge$All$id(charge),
								$author$project$Api$Provider$PracticeCharge$All$id(practiceCharge));
						},
						model.qK);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{qK: uninvoicedCharges_}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2(
								$author$project$OutMsg$ShowToast,
								3,
								$author$project$Api$Provider$PracticeCharge$All$description(practiceCharge) + ' was successfully deleted.')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 13:
				var response = msg.a;
				_v12$2:
				while (true) {
					switch (response.$) {
						case 3:
							var upgrade = response.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										qS: $elm$core$Maybe$Just(upgrade)
									}),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
						case 2:
							if (response.a.$ === 5) {
								var _v13 = response.a;
								return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
							} else {
								break _v12$2;
							}
						default:
							break _v12$2;
					}
				}
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 14:
				var _v14 = A3($author$project$Components$UpgradePracticeModal$init, model.qS, model.aa4, model.S5);
				var upgradePracticeModal = _v14.a;
				var upgradePracticeModalCmd = _v14.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							lV: $elm$core$Maybe$Just(upgradePracticeModal)
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Billing$UpgradePracticeModalMsg, upgradePracticeModalCmd),
								$author$project$Pages$Admin$Billing$updateUrl(
								$author$project$Components$UpgradePracticeModal$urlParam(upgradePracticeModal))
							])),
					_List_Nil);
			case 15:
				var subMsg = msg.a;
				var _v15 = model.lV;
				if (!_v15.$) {
					var upgradePracticeModal = _v15.a;
					var result = A3($author$project$Components$UpgradePracticeModal$update, model.Gv, subMsg, upgradePracticeModal);
					var _v16 = function () {
						var _v17 = result.agZ;
						switch (_v17.$) {
							case 1:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Pages$Admin$Billing$updateUrl($elm$core$Maybe$Nothing),
									_List_Nil);
							case 2:
								var successMsg = _v17.a;
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									A2($author$project$Utils$Route$navigateAndReload, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Billing),
									_List_fromArray(
										[
											A2($author$project$OutMsg$ShowToast, 3, successMsg)
										]));
							default:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(result.aiO),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
						}
					}();
					var modal_ = _v16.a;
					var cmd_ = _v16.b;
					var outMsgs_ = _v16.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{lV: modal_}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Billing$UpgradePracticeModalMsg, result.GZ),
									cmd_
								])),
						outMsgs_);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 16:
				return _Utils_Tuple3(
					model,
					A2($author$project$Api$Provider$PracticeInvoice$create, model.Gv, $author$project$Pages$Admin$Billing$InvoiceCreated),
					_List_Nil);
			case 17:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($author$project$Pages$Admin$Billing$fetchPracticeInvoices, model.Gv, model.eU),
									$author$project$Pages$Admin$Billing$fetchUninvoicedCharges(model.Gv)
								])),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Invoice created successfully.')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 18:
				var label = msg.a;
				var url = msg.b;
				return _Utils_Tuple3(
					model,
					A3($author$project$Utils$Analytics$HintBilling$logLinkClickedEvent, model.aa4, label, url),
					_List_Nil);
			case 19:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						$author$project$Pages$Admin$Billing$fetchUninvoicedCharges(model.Gv),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Charge created successfully.')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 20:
				var response = msg.a;
				if (response.$ === 3) {
					var secret = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{rA: response}),
						A2($author$project$Ports$Stripe$mountCapitalPromoTile, '#stripe-capital-promo-tile', secret),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{rA: response}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 21:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						A2($author$project$Api$Provider$Practice$StripeAccount$session, model.Gv, $author$project$Pages$Admin$Billing$GotCapitalSession),
						_List_Nil);
				}
			default:
				var productType = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							xT: $elm$core$Maybe$Just(productType)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
		}
	});
var $author$project$Pages$Admin$Billing$PracticeInvoicePaginationMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Modal$Lg = 1;
var $author$project$Ui$Modal$Size = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Modal$lg = $author$project$Ui$Modal$Size(1);
var $author$project$Components$ApplicationFeePlan$UpdateModal$Save = {$: 1};
var $author$project$Ui$Form$OnSubmit = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Form$onSubmit = $author$project$Ui$Form$OnSubmit;
var $elm$html$Html$Attributes$novalidate = $elm$html$Html$Attributes$boolProperty('noValidate');
var $author$project$Ui$Form$defaultOptions = {xt: true, BO: false, B5: $elm$core$Maybe$Nothing};
var $author$project$Ui$Form$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var bool = option.a;
						return _Utils_update(
							record,
							{BO: bool});
					case 1:
						var bool = option.a;
						return _Utils_update(
							record,
							{xt: bool});
					default:
						var msg = option.a;
						return _Utils_update(
							record,
							{
								B5: $elm$core$Maybe$Just(msg)
							});
				}
			}),
		$author$project$Ui$Form$defaultOptions,
		options);
};
var $author$project$Ui$Form$view = F2(
	function (options, contents) {
		var optionsRecord = $author$project$Ui$Form$optionsToRecord(options);
		return A2(
			$elm$html$Html$form,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$novalidate(optionsRecord.BO),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$autocomplete(optionsRecord.xt),
					function () {
						var _v0 = optionsRecord.B5;
						if (!_v0.$) {
							var onSubmit_ = _v0.a;
							return _List_fromArray(
								[
									$elm$html$Html$Events$onSubmit(onSubmit_)
								]);
						} else {
							return _List_Nil;
						}
					}())),
			contents);
	});
var $author$project$Components$ApplicationFeePlan$UpdateModal$FormChanged = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$HubspotDealIdChanged = function (a) {
	return {$: 7, a: a};
};
var $author$project$Ui$Form$Group$inputSpanMd = function (span) {
	return $author$project$Ui$Form$Group$InputGrid(
		_List_fromArray(
			[
				'md:' + $author$project$Ui$Form$Group$spanToWidthClass(span)
			]));
};
var $author$project$Ui$Form$Group$labelSpanMd = function (span) {
	return $author$project$Ui$Form$Group$LabelGrid(
		_List_fromArray(
			[
				'md:' + $author$project$Ui$Form$Group$spanToWidthClass(span)
			]));
};
var $author$project$Ui$Element$mt1 = $author$project$Ui$Element$Margin('mt-1');
var $author$project$Ui$Element$prose = A2($author$project$Ui$Element$customNode, 'p', 'm-0');
var $author$project$Components$ApplicationFeePlan$UpdateModal$viewHubspotDealId = F2(
	function (form, hubspotDealUrl) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Import from Hubspot Deal'),
					$author$project$Ui$Form$Group$labelSpanMd(3),
					$author$project$Ui$Form$Group$inputSpanMd(4)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$value(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								$author$project$Utils$Form$fields(form).TD)),
							$author$project$Ui$Form$Input$onInput(
							A2($elm$core$Basics$composeL, $author$project$Components$ApplicationFeePlan$UpdateModal$FormChanged, $author$project$Components$ApplicationFeePlan$UpdateModalForm$HubspotDealIdChanged)),
							$author$project$Ui$Form$Input$number,
							$author$project$Ui$Form$Input$placeholder('')
						])),
					function () {
					if (!hubspotDealUrl.$) {
						var url = hubspotDealUrl.a;
						return A2(
							$author$project$Ui$Element$prose,
							_List_fromArray(
								[$author$project$Ui$Element$mt1]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$externalHref,
									url,
									_List_fromArray(
										[$author$project$Ui$Link$targetBlank]),
									_List_fromArray(
										[
											$elm$html$Html$text('View in HubSpot')
										]))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]));
	});
var $author$project$Components$ApplicationFeePlan$UpdateModal$AddRecurringChargeButtonClicked = {$: 5};
var $author$project$Ui$Icon$Add = 38;
var $author$project$Ui$Icon$add = $author$project$Ui$Icon$viewIcon(38);
var $author$project$Components$ApplicationFeePlan$UpdateModal$chargesTotalInCents = function (charges) {
	return $elm$core$List$sum(
		A2(
			$elm$core$List$filterMap,
			function (c) {
				return A2(
					$elm$core$Maybe$map,
					function (cents) {
						return cents * c.Dz;
					},
					A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, c.Dw));
			},
			charges));
};
var $author$project$Ui$Grid$Element = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Alignment$Start = 0;
var $author$project$Ui$Alignment$itemsStart = $author$project$Ui$Alignment$Items(0);
var $author$project$Ui$Element$itemsStart = $author$project$Ui$Element$Alignment($author$project$Ui$Alignment$itemsStart);
var $author$project$Ui$Grid$justifyLeft = $author$project$Ui$Grid$Element($author$project$Ui$Element$itemsStart);
var $author$project$Ui$Alignment$itemsEnd = $author$project$Ui$Alignment$Items(2);
var $author$project$Ui$Element$itemsEnd = $author$project$Ui$Element$Alignment($author$project$Ui$Alignment$itemsEnd);
var $author$project$Ui$Grid$justifyRight = $author$project$Ui$Grid$Element($author$project$Ui$Element$itemsEnd);
var $author$project$Components$ApplicationFeePlan$UpdateModal$viewChargesTotal = function (charges) {
	var totalInCents = $author$project$Components$ApplicationFeePlan$UpdateModal$chargesTotalInCents(charges);
	return (totalInCents > 0) ? A2(
		$author$project$Ui$Grid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$span(6),
						$author$project$Ui$Grid$justifyLeft
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Total')
									]))
							]))
					])),
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$span(6),
						$author$project$Ui$Grid$justifyRight
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Currency$format(
									$author$project$Currency$fromInt(totalInCents)))
							]))
					]))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Components$ApplicationFeePlan$UpdateModal$DeleteRecurringCharge = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$ApplicationFeePlan$UpdateModal$EndRecurringCharge = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$Lives = 0;
var $author$project$Components$ApplicationFeePlan$UpdateModal$PriceInputChanged = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargeCategoryChanged = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargeEndDateChanged = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargeQuantityChanged = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargeStartDateChanged = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Ui$Form$Select$Item = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Ui$Form$Select$option = $author$project$Ui$Form$Select$Item;
var $author$project$Components$ApplicationFeePlan$UpdateModal$categoryOptionsForExistingCharges = function (categories) {
	return A2(
		$elm$core$List$map,
		function (category) {
			return A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(
					$author$project$Api$Provider$HintBillingProduct$Shared$id(category)),
				$author$project$Api$Provider$HintBillingProduct$Shared$name(category));
		},
		categories);
};
var $author$project$Components$HintBilling$HintBillingProductOptions$UpdatePricing = 0;
var $author$project$Api$Provider$HintBillingProduct$Shared$addonType = function (_v0) {
	var record = _v0;
	return record.K0;
};
var $author$project$Api$Provider$HintBillingProduct$Shared$archived = function (_v0) {
	var record = _v0;
	return record.L_;
};
var $author$project$Api$Provider$HintBillingComponent$AddonType$isFree = function (addonType) {
	if (addonType === 3) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$HintBilling$HintBillingProductOptions$isFreeProduct = function (hintBillingProduct) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$HintBillingComponent$AddonType$isFree,
			$author$project$Api$Provider$HintBillingProduct$Shared$addonType(hintBillingProduct)));
};
var $author$project$Api$Provider$HintBillingComponent$AddonType$isOneTime = function (addonType) {
	if (addonType === 2) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$HintBilling$HintBillingProductOptions$isSelectable = F2(
	function (action, hintBillingProduct) {
		if ($author$project$Api$Provider$HintBillingProduct$Shared$archived(hintBillingProduct) || $author$project$Components$HintBilling$HintBillingProductOptions$isFreeProduct(hintBillingProduct)) {
			return false;
		} else {
			switch (action) {
				case 0:
					var _v1 = $author$project$Api$Provider$HintBillingProduct$Shared$componentType(hintBillingProduct);
					switch (_v1) {
						case 0:
							return false;
						case 2:
							return false;
						case 4:
							return true;
						case 3:
							return false;
						case 1:
							return A2(
								$elm$core$Maybe$withDefault,
								false,
								A2(
									$elm$core$Maybe$map,
									$elm$core$Basics$not,
									A2(
										$elm$core$Maybe$map,
										$author$project$Api$Provider$HintBillingComponent$AddonType$isOneTime,
										$author$project$Api$Provider$HintBillingProduct$Shared$addonType(hintBillingProduct))));
						default:
							return true;
					}
				case 1:
					var _v2 = $author$project$Api$Provider$HintBillingProduct$Shared$componentType(hintBillingProduct);
					switch (_v2) {
						case 1:
							return A2(
								$elm$core$Maybe$withDefault,
								false,
								A2(
									$elm$core$Maybe$map,
									$author$project$Api$Provider$HintBillingComponent$AddonType$isOneTime,
									$author$project$Api$Provider$HintBillingProduct$Shared$addonType(hintBillingProduct)));
						case 5:
							return true;
						default:
							return false;
					}
				default:
					var _v3 = $author$project$Api$Provider$HintBillingProduct$Shared$componentType(hintBillingProduct);
					if (_v3 === 5) {
						return true;
					} else {
						return false;
					}
			}
		}
	});
var $author$project$Components$HintBilling$HintBillingProductOptions$toSelectOption = function (hintBillingProduct) {
	return A3(
		$author$project$Ui$Form$Select$option,
		_List_Nil,
		$elm$core$Maybe$Just(
			$author$project$Api$Provider$HintBillingProduct$Shared$id(hintBillingProduct)),
		$author$project$Api$Provider$HintBillingProduct$Shared$name(hintBillingProduct));
};
var $author$project$Components$HintBilling$HintBillingProductOptions$selectOptions = F2(
	function (action, hintBillingProducts) {
		return A2(
			$elm$core$List$map,
			$author$project$Components$HintBilling$HintBillingProductOptions$toSelectOption,
			A2(
				$elm$core$List$filter,
				$author$project$Components$HintBilling$HintBillingProductOptions$isSelectable(action),
				hintBillingProducts));
	});
var $author$project$Components$ApplicationFeePlan$UpdateModal$categoryOptionsForNewCharges = function (categories) {
	return A2($author$project$Components$HintBilling$HintBillingProductOptions$selectOptions, 0, categories);
};
var $author$project$Ui$Form$CurrencyInput$Disabled = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Form$CurrencyInput$disabled = $author$project$Ui$Form$CurrencyInput$Disabled;
var $author$project$Ui$Form$Input$Disabled = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Form$Input$disabled = $author$project$Ui$Form$Input$Disabled;
var $author$project$Ui$Form$Select$Disabled = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$Select$disabled = $author$project$Ui$Form$Select$Disabled;
var $author$project$Components$ApplicationFeePlan$UpdateModal$getDefaultDescription = F2(
	function (categories, charge) {
		return $elm$core$String$isEmpty(charge.Qr) ? A2($author$project$Components$ApplicationFeePlan$UpdateModal$getCategoryNameById, categories, charge.Tw) : charge.Qr;
	});
var $author$project$Ui$Form$CurrencyInput$Invalid = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Form$CurrencyInput$invalid = function (bool) {
	return $author$project$Ui$Form$CurrencyInput$Invalid(bool);
};
var $author$project$Ui$Grid$RowElement = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Grid$mb2 = $author$project$Ui$Grid$RowElement($author$project$Ui$Element$mb2);
var $author$project$Ui$Form$Select$OnChange = function (a) {
	return {$: 6, a: a};
};
var $author$project$Ui$Form$Select$onChange = $author$project$Ui$Form$Select$OnChange;
var $author$project$Ui$Form$CurrencyInput$OnInput = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$CurrencyInput$onInput = function (handler) {
	return $author$project$Ui$Form$CurrencyInput$OnInput(handler);
};
var $author$project$Ui$Grid$rowItemsCenter = $author$project$Ui$Grid$RowElement($author$project$Ui$Element$itemsCenter);
var $author$project$Ui$ScreenSize$Md = 2;
var $author$project$Ui$Grid$spanMd = $author$project$Ui$Grid$Span(2);
var $author$project$Ui$Form$CurrencyInput$Value = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$CurrencyInput$value = function (_int) {
	return $author$project$Ui$Form$CurrencyInput$Value(_int);
};
var $author$project$Ui$Form$Select$Value = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$Select$value = $author$project$Ui$Form$Select$Value;
var $author$project$Ui$Form$Input$HideErrors = function (a) {
	return {$: 25, a: a};
};
var $author$project$Ui$Form$Input$hideErrors = $author$project$Ui$Form$Input$HideErrors;
var $author$project$Ui$Form$CurrencyInput$defaultOptions = {agX: _List_Nil, zT: false, aN: _List_Nil, sM: false, Df: $elm$core$Maybe$Nothing, t1: true, aee: $elm$core$Maybe$Nothing};
var $author$project$Currency$fromString = $elm$core$Basics$identity;
var $author$project$Ui$Form$CurrencyInput$inputHandler = function (handler) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Utils$String$toMaybe,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($author$project$Currency$fromString),
			handler));
};
var $author$project$Ui$Form$CurrencyInput$inputValue = function (currency) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Maybe$map, $author$project$Currency$toString, currency));
};
var $author$project$Ui$Form$Input$OnBlur = function (a) {
	return {$: 11, a: a};
};
var $author$project$Ui$Form$Input$onBlur = $author$project$Ui$Form$Input$OnBlur;
var $author$project$Ui$Form$Input$Test = function (a) {
	return {$: 6, a: a};
};
var $author$project$Ui$Form$Input$test = function (dataTest) {
	return $author$project$Ui$Form$Input$Test(dataTest);
};
var $author$project$Ui$Form$CurrencyInput$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var handler = option.a;
						return _Utils_update(
							record,
							{
								aN: A2(
									$elm$core$List$cons,
									$author$project$Ui$Form$Input$onInput(
										$author$project$Ui$Form$CurrencyInput$inputHandler(handler)),
									record.aN)
							});
					case 9:
						var handler = option.a;
						return _Utils_update(
							record,
							{
								aN: A2(
									$elm$core$List$cons,
									$author$project$Ui$Form$Input$onBlur(handler),
									record.aN)
							});
					case 1:
						var _int = option.a;
						return _Utils_update(
							record,
							{
								aN: A2(
									$elm$core$List$cons,
									$author$project$Ui$Form$Input$value(
										$author$project$Ui$Form$CurrencyInput$inputValue(_int)),
									record.aN),
								aee: _int
							});
					case 2:
						var bool = option.a;
						return _Utils_update(
							record,
							{sM: bool});
					case 3:
						var list = option.a;
						return _Utils_update(
							record,
							{agX: list});
					case 4:
						var string = option.a;
						return _Utils_update(
							record,
							{
								aN: A2(
									$elm$core$List$cons,
									$author$project$Ui$Form$Input$placeholder(string),
									record.aN)
							});
					case 5:
						var bool = option.a;
						return _Utils_update(
							record,
							{
								aN: A2(
									$elm$core$List$cons,
									$author$project$Ui$Form$Input$disabled(bool),
									record.aN)
							});
					case 6:
						var string = option.a;
						return _Utils_update(
							record,
							{
								Df: $elm$core$Maybe$Just(string)
							});
					case 7:
						return _Utils_update(
							record,
							{t1: false});
					case 8:
						var string = option.a;
						return _Utils_update(
							record,
							{
								aN: A2(
									$elm$core$List$cons,
									$author$project$Ui$Form$Input$test(string),
									record.aN)
							});
					default:
						var bool = option.a;
						return _Utils_update(
							record,
							{zT: bool});
				}
			}),
		$author$project$Ui$Form$CurrencyInput$defaultOptions,
		options);
};
var $author$project$Ui$Form$CurrencyInput$view = function (options) {
	var optionsRecord = $author$project$Ui$Form$CurrencyInput$optionsToRecord(options);
	var prefix = optionsRecord.t1 ? $author$project$Ui$Form$Input$addon(
		_List_fromArray(
			[
				$elm$html$Html$text('$')
			])) : $author$project$Utils$Html$empty;
	return $author$project$Ui$Form$Input$group(
		A2(
			$elm$core$List$cons,
			prefix,
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Form$Input$view(
					A2(
						$elm$core$List$cons,
						$author$project$Ui$Form$Input$invalid(optionsRecord.sM),
						A2(
							$elm$core$List$cons,
							$author$project$Ui$Form$Input$errors(optionsRecord.agX),
							A2(
								$elm$core$List$cons,
								$author$project$Ui$Form$Input$number,
								A2(
									$elm$core$List$cons,
									$author$project$Ui$Form$Input$hideErrors(optionsRecord.zT),
									optionsRecord.aN))))),
				function () {
					var _v0 = optionsRecord.Df;
					if (!_v0.$) {
						var postfix_ = _v0.a;
						return _List_fromArray(
							[
								$author$project$Ui$Form$Input$addon(
								_List_fromArray(
									[
										$elm$html$Html$text(postfix_)
									]))
							]);
					} else {
						return _List_Nil;
					}
				}())));
};
var $author$project$Ui$Spinner$Size = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Types$Xs = 0;
var $author$project$Ui$Spinner$extraSmall = $author$project$Ui$Spinner$Size(0);
var $author$project$Ui$Form$Select$defaultOptions = {rF: _List_Nil, ep: false, agX: _List_Nil, zT: false, Ab: false, sM: false, V8: false, ajd: $elm$core$Maybe$Nothing, aee: $elm$core$Maybe$Nothing};
var $author$project$Ui$Form$Select$updateOptionsRecord = F2(
	function (option_, options) {
		switch (option_.$) {
			case 1:
				var bool = option_.a;
				return _Utils_update(
					options,
					{ep: bool});
			case 0:
				var maybeSelected = option_.a;
				return _Utils_update(
					options,
					{aee: maybeSelected});
			case 2:
				var bool = option_.a;
				return _Utils_update(
					options,
					{sM: bool});
			case 3:
				var bool = option_.a;
				return _Utils_update(
					options,
					{V8: bool});
			case 4:
				var list = option_.a;
				return _Utils_update(
					options,
					{agX: list});
			case 5:
				var string = option_.a;
				return _Utils_update(
					options,
					{
						rF: A2($elm$core$List$cons, string, options.rF)
					});
			case 6:
				var toMsg = option_.a;
				return _Utils_update(
					options,
					{
						ajd: $elm$core$Maybe$Just(toMsg)
					});
			case 7:
				return _Utils_update(
					options,
					{Ab: true});
			default:
				var bool = option_.a;
				return _Utils_update(
					options,
					{zT: bool});
		}
	});
var $author$project$Ui$Form$Select$optionsListToRecord = function (optionsList) {
	return A3($elm$core$List$foldl, $author$project$Ui$Form$Select$updateOptionsRecord, $author$project$Ui$Form$Select$defaultOptions, optionsList);
};
var $elm$html$Html$select = _VirtualDom_node('select');
var $author$project$Ui$Form$Select$itemAttributes = function (options) {
	var disabledAttr = options.ep ? _List_fromArray(
		[
			A2($elm$html$Html$Attributes$attribute, 'disabled', 'disabled')
		]) : _List_Nil;
	return A2(
		$elm$core$List$cons,
		$elm$html$Html$Attributes$classList(
			_List_fromArray(
				[
					_Utils_Tuple2('disabled', options.ep)
				])),
		disabledAttr);
};
var $author$project$Ui$Form$Select$defaultItemOptions = {ep: false};
var $author$project$Ui$Form$Select$itemOptionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option_, record) {
				var bool = option_;
				return _Utils_update(
					record,
					{ep: bool});
			}),
		$author$project$Ui$Form$Select$defaultItemOptions,
		options);
};
var $elm$html$Html$optgroup = _VirtualDom_node('optgroup');
var $author$project$Ui$Form$Select$viewItem = F2(
	function (currentValue, item_) {
		if (!item_.$) {
			var label_ = item_.a;
			var items = item_.b;
			return A2(
				$elm$html$Html$optgroup,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'label', label_)
					]),
				A2(
					$elm$core$List$map,
					$author$project$Ui$Form$Select$viewItem(currentValue),
					items));
		} else {
			var options = item_.a;
			var value_ = item_.b;
			var label_ = item_.c;
			var optionsRecord = $author$project$Ui$Form$Select$itemOptionsToRecord(options);
			return A2(
				$elm$html$Html$option,
				A2(
					$elm$core$List$cons,
					A2($elm$html$Html$Attributes$attribute, 'label', label_),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$selected(
							_Utils_eq(currentValue, value_)),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$value(
								A2($elm$core$Maybe$withDefault, '', value_)),
							$author$project$Ui$Form$Select$itemAttributes(optionsRecord)))),
				_List_fromArray(
					[
						$elm$html$Html$text(label_)
					]));
		}
	});
var $author$project$Ui$Form$Select$view = F2(
	function (options, items) {
		var optionsRecord = $author$project$Ui$Form$Select$optionsListToRecord(options);
		var errorDescription = $elm$core$List$isEmpty(optionsRecord.agX) ? _List_Nil : _List_fromArray(
			[
				A2(
				$elm$html$Html$Attributes$attribute,
				'aria-describedby',
				A2($elm$core$String$join, '. ', optionsRecord.agX))
			]);
		var ariaInvalid = optionsRecord.sM ? _List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'aria-invalid', 'true')
			]) : _List_Nil;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('input-wrapper'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('inline-block', optionsRecord.Ab)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$select,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('form-control'),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class(
								A2($elm$core$String$join, ' ', optionsRecord.rF)),
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$disabled(optionsRecord.V8 || optionsRecord.ep),
								A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('disabled', optionsRecord.V8 || optionsRecord.ep),
												_Utils_Tuple2('form-control--errored', optionsRecord.sM)
											])),
									_Utils_ap(
										function () {
											var _v0 = optionsRecord.ajd;
											if (!_v0.$) {
												var toMsg = _v0.a;
												return _List_fromArray(
													[
														$elm$html$Html$Events$onInput(toMsg)
													]);
											} else {
												return _List_Nil;
											}
										}(),
										_Utils_ap(errorDescription, ariaInvalid)))))),
					A2(
						$elm$core$List$map,
						$author$project$Ui$Form$Select$viewItem(optionsRecord.aee),
						items)),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('dropdown__trigger__chevron')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Icon$chevronDown(
							_List_fromArray(
								[$author$project$Ui$Icon$xs, $author$project$Ui$Icon$info]))
						])),
					optionsRecord.V8 ? $author$project$Ui$Spinner$view(
					_List_fromArray(
						[$author$project$Ui$Spinner$extraSmall])) : $author$project$Utils$Html$empty,
					optionsRecord.zT ? $author$project$Utils$Html$empty : $author$project$Utils$FormErrors$view(optionsRecord.agX)
				]));
	});
var $author$project$Components$ApplicationFeePlan$UpdateModal$viewPackageTotal = F2(
	function (params, packageType) {
		var totalFloat = A2(
			$elm$core$Maybe$andThen,
			function (priceInCents) {
				var quantityFloat = params.Dz;
				return A2(
					$elm$core$Maybe$map,
					$author$project$Currency$fromFloat,
					A2(
						$elm$core$Maybe$map,
						$author$project$Utils$Round$float,
						A2(
							$elm$core$Maybe$map,
							$elm$core$Basics$mul(quantityFloat),
							$author$project$Currency$toFloat(priceInCents))));
			},
			params.Dw);
		if (!totalFloat.$) {
			var value = totalFloat.a;
			return A2(
				$author$project$Ui$Typography$strong,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Currency$format(value))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Ui$Form$Input$withPreAddon = F2(
	function (addonText, options) {
		var optionsRecord = $author$project$Ui$Form$Input$optionsToRecord(options);
		var onInputHandler = $author$project$Ui$Form$Input$optionsToInputHandler(optionsRecord);
		return $elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						$author$project$Ui$Form$Input$addon(
						_List_fromArray(
							[
								$elm$html$Html$text(addonText)
							])),
						$author$project$Ui$Form$Input$viewFeedback(optionsRecord),
						A2(
						$elm$html$Html$input,
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class('form-control'),
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$value(optionsRecord.aee),
								_Utils_ap(
									$author$project$Ui$Form$Input$inputTypeToAttributes(optionsRecord.amg),
									_Utils_ap(optionsRecord.xr, onInputHandler)))),
						_List_Nil)
					]),
					A2($elm$core$List$map, $author$project$Ui$Form$Input$viewErrors, options)
				]));
	});
var $author$project$Components$ApplicationFeePlan$UpdateModal$viewRecurringCharge = F4(
	function (model, fieldsDisabled, index, charge) {
		return A2(
			$author$project$Ui$Grid$row,
			_List_fromArray(
				[$author$project$Ui$Grid$rowItemsCenter]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanMd(9)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$row,
							_List_fromArray(
								[$author$project$Ui$Grid$mb2]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(6)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Select$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Select$value(
													$elm$core$Maybe$Just(charge.Tw)),
													$author$project$Ui$Form$Select$onChange(
													A2(
														$elm$core$Basics$composeL,
														$author$project$Components$ApplicationFeePlan$UpdateModal$FormChanged,
														$author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargeCategoryChanged(index))),
													$author$project$Ui$Form$Select$disabled(
													fieldsDisabled || (!_Utils_eq(charge.ahP, $elm$core$Maybe$Nothing)))
												]),
											_Utils_eq(charge.ahP, $elm$core$Maybe$Nothing) ? $author$project$Components$ApplicationFeePlan$UpdateModal$categoryOptionsForNewCharges(model.Nr) : $author$project$Components$ApplicationFeePlan$UpdateModal$categoryOptionsForExistingCharges(model.Nr))
										])),
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(3)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$group(
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$view(
													_List_fromArray(
														[
															$author$project$Ui$Form$Input$value(charge.ab9),
															$author$project$Ui$Form$Input$onInput(
															A2(
																$elm$core$Basics$composeL,
																$author$project$Components$ApplicationFeePlan$UpdateModal$FormChanged,
																$author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargeStartDateChanged(index))),
															$author$project$Ui$Form$Input$invalid(
															A2(
																$author$project$Utils$Form$hasValidationErrors,
																$author$project$Components$ApplicationFeePlan$UpdateModalForm$StartDateValidation(index),
																model.SD)),
															$author$project$Ui$Form$Input$placeholder('mm/dd/yyyy'),
															$author$project$Ui$Form$Input$disabled(fieldsDisabled)
														]))
												]))
										])),
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(3)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$group(
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$view(
													_List_fromArray(
														[
															$author$project$Ui$Form$Input$value(charge.zt),
															$author$project$Ui$Form$Input$onInput(
															A2(
																$elm$core$Basics$composeL,
																$author$project$Components$ApplicationFeePlan$UpdateModal$FormChanged,
																$author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargeEndDateChanged(index))),
															$author$project$Ui$Form$Input$invalid(
															A2(
																$author$project$Utils$Form$hasValidationErrors,
																$author$project$Components$ApplicationFeePlan$UpdateModalForm$EndDateValidation(index),
																model.SD)),
															$author$project$Ui$Form$Input$placeholder('end date'),
															$author$project$Ui$Form$Input$disabled(fieldsDisabled)
														]))
												]))
										])),
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(6)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$value(
													A2($author$project$Components$ApplicationFeePlan$UpdateModal$getDefaultDescription, model.Nr, charge)),
													$author$project$Ui$Form$Input$onInput(
													A2(
														$elm$core$Basics$composeL,
														$author$project$Components$ApplicationFeePlan$UpdateModal$FormChanged,
														$author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargeDescriptionChanged(index))),
													$author$project$Ui$Form$Input$invalid(
													A2(
														$author$project$Utils$Form$hasValidationErrors,
														$author$project$Components$ApplicationFeePlan$UpdateModalForm$DescriptionValidation(index),
														model.SD)),
													$author$project$Ui$Form$Input$placeholder('charge name'),
													$author$project$Ui$Form$Input$disabled(fieldsDisabled)
												])),
											$author$project$Utils$FormErrors$view(
											A2(
												$author$project$Utils$Form$validationErrors,
												$author$project$Components$ApplicationFeePlan$UpdateModalForm$DescriptionValidation(index),
												model.SD))
										])),
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(3)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$group(
											A2(
												$author$project$Ui$Form$Input$withPreAddon,
												'Qty',
												_List_fromArray(
													[
														$author$project$Ui$Form$Input$value(
														$elm$core$String$fromInt(charge.Dz)),
														$author$project$Ui$Form$Input$onInput(
														A2(
															$elm$core$Basics$composeL,
															$author$project$Components$ApplicationFeePlan$UpdateModal$FormChanged,
															$author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargeQuantityChanged(index))),
														$author$project$Ui$Form$Input$number,
														$author$project$Ui$Form$Input$disabled(fieldsDisabled),
														$author$project$Ui$Form$Input$invalid(
														A2(
															$author$project$Utils$Form$hasValidationErrors,
															$author$project$Components$ApplicationFeePlan$UpdateModalForm$QuantityValidation(index),
															model.SD))
													]))),
											$author$project$Utils$FormErrors$view(
											A2(
												$author$project$Utils$Form$validationErrors,
												$author$project$Components$ApplicationFeePlan$UpdateModalForm$QuantityValidation(index),
												model.SD))
										])),
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(3)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$group(
											_List_fromArray(
												[
													$author$project$Ui$Form$CurrencyInput$view(
													_List_fromArray(
														[
															$author$project$Ui$Form$CurrencyInput$value(
															A2(
																$elm$core$Maybe$withDefault,
																charge.Dw,
																A2($elm$core$Dict$get, index, model.cO))),
															$author$project$Ui$Form$CurrencyInput$onInput(
															$author$project$Components$ApplicationFeePlan$UpdateModal$PriceInputChanged(index)),
															$author$project$Ui$Form$CurrencyInput$invalid(
															A2(
																$author$project$Utils$Form$hasValidationErrors,
																$author$project$Components$ApplicationFeePlan$UpdateModalForm$PriceInCentsValidation(index),
																model.SD)),
															$author$project$Ui$Form$CurrencyInput$disabled(fieldsDisabled)
														]))
												])),
											$author$project$Utils$FormErrors$view(
											A2(
												$author$project$Utils$Form$validationErrors,
												$author$project$Components$ApplicationFeePlan$UpdateModalForm$PriceInCentsValidation(index),
												model.SD))
										]))
								]))
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanMd(3)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(6),
											$author$project$Ui$Grid$justifyLeft
										]),
									_List_fromArray(
										[
											_Utils_eq(charge.ahP, $elm$core$Maybe$Nothing) ? A3(
											$author$project$Ui$Button$view,
											{mm: 'Delete recurring charge'},
											_List_fromArray(
												[
													$author$project$Ui$Button$onClick(
													$author$project$Components$ApplicationFeePlan$UpdateModal$DeleteRecurringCharge(index)),
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$icon($author$project$Ui$Icon$delete),
													$author$project$Ui$Button$disabled(fieldsDisabled)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Delete')
												])) : A3(
											$author$project$Ui$Button$view,
											{mm: 'End recurring charge'},
											_List_fromArray(
												[
													$author$project$Ui$Button$onClick(
													$author$project$Components$ApplicationFeePlan$UpdateModal$EndRecurringCharge(index)),
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$icon($author$project$Ui$Icon$delete),
													$author$project$Ui$Button$disabled(fieldsDisabled)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('End')
												]))
										])),
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(6),
											$author$project$Ui$Grid$justifyRight
										]),
									_List_fromArray(
										[
											A2($author$project$Components$ApplicationFeePlan$UpdateModal$viewPackageTotal, charge, 0)
										]))
								]))
						]))
				]));
	});
var $author$project$Components$ApplicationFeePlan$UpdateModal$viewRecurringChargesSection = F3(
	function (model, formFields, fieldsDisabled) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Charges'),
					$author$project$Ui$Form$Group$labelSpanMd(3),
					$author$project$Ui$Form$Group$inputSpanMd(9)
				]),
			_Utils_ap(
				A2(
					$elm$core$List$indexedMap,
					A2($author$project$Components$ApplicationFeePlan$UpdateModal$viewRecurringCharge, model, fieldsDisabled),
					$author$project$Utils$Form$fields(formFields).NA),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mt4]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Add new recurring charge'},
								_List_fromArray(
									[
										$author$project$Ui$Button$onClick($author$project$Components$ApplicationFeePlan$UpdateModal$AddRecurringChargeButtonClicked),
										$author$project$Ui$Button$icon($author$project$Ui$Icon$add),
										$author$project$Ui$Button$disabled(fieldsDisabled)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Add New')
									]))
							])),
						$author$project$Components$ApplicationFeePlan$UpdateModal$viewChargesTotal(
						$author$project$Utils$Form$fields(formFields).NA)
					])));
	});
var $author$project$Components$ApplicationFeePlan$UpdateModal$viewBody = function (model) {
	var showIfEditable = function (section) {
		return model.aic ? section : $author$project$Utils$Html$empty;
	};
	var fieldsDisabled = $author$project$Components$ApplicationFeePlan$UpdateModal$hubspotDealModified(model.SD);
	return A2(
		$author$project$Ui$Form$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$onSubmit($author$project$Components$ApplicationFeePlan$UpdateModal$Save)
			]),
		_List_fromArray(
			[
				A2($author$project$Components$ApplicationFeePlan$UpdateModal$viewHubspotDealId, model.SD, model.TE),
				showIfEditable(
				$author$project$Ui$HorizontalRule$view(_List_Nil)),
				showIfEditable(
				A3($author$project$Components$ApplicationFeePlan$UpdateModal$viewRecurringChargesSection, model, model.SD, fieldsDisabled))
			]));
};
var $author$project$Utils$Form$hasAnyValidationError = function (_v0) {
	var errors_ = _v0.d;
	return !$elm$core$List$isEmpty(errors_);
};
var $author$project$Components$ApplicationFeePlan$UpdateModal$viewFooter = function (model) {
	return _List_fromArray(
		[
			A3(
			$author$project$Ui$Button$view,
			{mm: 'Cancel and close modal'},
			_List_fromArray(
				[
					$author$project$Ui$Button$onClick($author$project$Components$ApplicationFeePlan$UpdateModal$Close)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Cancel')
				])),
			A3(
			$author$project$Ui$Button$view,
			{mm: 'Save plan'},
			_List_fromArray(
				[
					$author$project$Ui$Button$primary,
					$author$project$Ui$Button$disabled(
					$author$project$Utils$Form$hasAnyValidationError(model.SD)),
					$author$project$Ui$Button$onClick($author$project$Components$ApplicationFeePlan$UpdateModal$Save)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Save')
				]))
		]);
};
var $author$project$Components$ApplicationFeePlan$UpdateModal$view = function (model) {
	var modalTitle = model.aic ? 'Edit Subscription' : 'Reset Pricing with a HubSpot Deal';
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$ApplicationFeePlan$UpdateModal$Close,
		_List_fromArray(
			[$author$project$Ui$Modal$lg]),
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title(modalTitle)
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						$author$project$Components$ApplicationFeePlan$UpdateModal$viewBody(model)
					])),
				$author$project$Ui$Modal$footer(
				$author$project$Components$ApplicationFeePlan$UpdateModal$viewFooter(model))
			]));
};
var $author$project$Components$HintBilling$CreateChargeModal$FormUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$HintBilling$CreateChargeModal$HintBillingProductSelected = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$HintBilling$CreateChargeModal$PriceInputChanged = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$HintBilling$CreateChargeModal$Quantity = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$CurrencyInput$Errors = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Form$CurrencyInput$errors = $author$project$Ui$Form$CurrencyInput$Errors;
var $author$project$Components$HintBilling$HintBillingProductOptions$AddCharge = 1;
var $author$project$Components$HintBilling$HintBillingProductOptions$AddCredit = 2;
var $author$project$Components$HintBilling$CreateChargeModal$hintBillingProductOptions = F2(
	function (hintBillingProducts, practiceInvoice) {
		var action = function () {
			var _v0 = A2($elm$core$Maybe$map, $author$project$Api$Provider$PracticeInvoice$One$status, practiceInvoice);
			if ((!_v0.$) && (!_v0.a)) {
				var _v1 = _v0.a;
				return 2;
			} else {
				return 1;
			}
		}();
		return A2(
			$elm$core$List$cons,
			A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, 'Select a category'),
			A2($author$project$Components$HintBilling$HintBillingProductOptions$selectOptions, action, hintBillingProducts));
	});
var $author$project$Ui$Form$Select$Invalid = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Form$Select$invalid = $author$project$Ui$Form$Select$Invalid;
var $author$project$Ui$Form$Static$optionToAttributes = function (option) {
	switch (option.$) {
		case 0:
			var bool = option.a;
			return bool ? $author$project$Api$Phi$displayAttr : _List_Nil;
		case 1:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('numeric')
				]);
		case 2:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-muted')
				]);
		case 3:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('no-value')
				]);
		case 4:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex')
				]);
		case 5:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('justify-between')
				]);
		default:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('items-center')
				]);
	}
};
var $author$project$Ui$Form$Static$optionsToAttributes = function (options) {
	return A2(
		$elm$core$List$map,
		$elm$html$Html$Attributes$map($elm$core$Basics$never),
		A2($elm$core$List$concatMap, $author$project$Ui$Form$Static$optionToAttributes, options));
};
var $author$project$Ui$Form$Static$view = F2(
	function (options, contents) {
		return A2(
			$elm$html$Html$p,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('form-control--static'),
				$author$project$Ui$Form$Static$optionsToAttributes(options)),
			contents);
	});
var $author$project$Components$HintBilling$CreateChargeModal$viewBody = F3(
	function (hintBillingProducts, form, pendingPrice) {
		var fields = $author$project$Utils$Form$fields(form);
		var hintBillingProductId = fields.Tv;
		var hintBillingProduct = A2(
			$elm$core$Maybe$andThen,
			function (hintBillingProductId_) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (hintBillingProduct_) {
							return _Utils_eq(
								$author$project$Api$Provider$HintBillingProduct$Shared$id(hintBillingProduct_),
								hintBillingProductId_);
						},
						hintBillingProducts));
			},
			hintBillingProductId);
		var _v0 = fields;
		var name = _v0.Bq;
		var quantity = _v0.Dz;
		var priceInCents = _v0.Dw;
		var practiceInvoice = _v0.tV;
		var displayPrice = A2($elm$core$Maybe$withDefault, priceInCents, pendingPrice);
		var priceFloat = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$andThen, $author$project$Currency$toFloat, displayPrice));
		var floorTotalInCents = $elm$core$Basics$round(
			priceFloat * A2($elm$core$Maybe$withDefault, 0, quantity));
		return A2(
			$author$project$Ui$Form$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('Category'),
							$author$project$Ui$Form$Group$required(true),
							$author$project$Ui$Form$Group$labelSpan(3),
							$author$project$Ui$Form$Group$inputSpan(9)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(
									A2(
										$elm$core$Maybe$map,
										function (hbp) {
											return $author$project$Api$Provider$HintBillingProduct$Shared$id(hbp);
										},
										hintBillingProduct)),
									$author$project$Ui$Form$Select$onChange($author$project$Components$HintBilling$CreateChargeModal$HintBillingProductSelected),
									$author$project$Ui$Form$Select$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 3, form))
								]),
							A2($author$project$Components$HintBilling$CreateChargeModal$hintBillingProductOptions, hintBillingProducts, practiceInvoice))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('Charge Name'),
							$author$project$Ui$Form$Group$required(true),
							$author$project$Ui$Form$Group$labelSpan(3),
							$author$project$Ui$Form$Group$inputSpan(9)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(name),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$HintBilling$CreateChargeModal$FormUpdated, $author$project$Components$HintBilling$CreateChargeModal$Name)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 0, form))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('QTY'),
							$author$project$Ui$Form$Group$required(true),
							$author$project$Ui$Form$Group$labelSpan(3),
							$author$project$Ui$Form$Group$inputSpan(2)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$number,
									$author$project$Ui$Form$Input$value(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2($elm$core$Maybe$map, $elm$core$String$fromInt, quantity))),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$HintBilling$CreateChargeModal$FormUpdated, $author$project$Components$HintBilling$CreateChargeModal$Quantity)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 1, form))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('Price'),
							$author$project$Ui$Form$Group$required(true),
							$author$project$Ui$Form$Group$labelSpan(3),
							$author$project$Ui$Form$Group$inputSpan(9)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$group(
							_List_fromArray(
								[
									$author$project$Ui$Form$CurrencyInput$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$CurrencyInput$value(displayPrice),
											$author$project$Ui$Form$CurrencyInput$onInput($author$project$Components$HintBilling$CreateChargeModal$PriceInputChanged),
											$author$project$Ui$Form$CurrencyInput$invalid(
											A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
											$author$project$Ui$Form$CurrencyInput$errors(
											A2($author$project$Utils$Form$validationErrors, 2, form))
										]))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('Total'),
							$author$project$Ui$Form$Group$labelSpan(3),
							$author$project$Ui$Form$Group$inputSpan(9)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$bold]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Currency$format(
												$author$project$Currency$fromInt(floorTotalInCents)))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$HintBilling$CreateChargeModal$FormSubmitted = {$: 1};
var $author$project$Components$HintBilling$CreateChargeModal$saveButtonLabel = F2(
	function (hintBillingComponentType, practiceInvoice) {
		var _v0 = _Utils_Tuple2(
			hintBillingComponentType,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$PracticeInvoice$One$status, practiceInvoice));
		if ((!_v0.a.$) && (_v0.a.a === 5)) {
			if ((!_v0.b.$) && (!_v0.b.a)) {
				var _v1 = _v0.a.a;
				var _v2 = _v0.b.a;
				return 'Add Credit & Refund';
			} else {
				var _v3 = _v0.a.a;
				return 'Add Credit';
			}
		} else {
			return 'Add Charge';
		}
	});
var $author$project$Components$HintBilling$CreateChargeModal$viewFooter = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var hintBillingComponentType = _v0.jS;
	var practiceInvoice = _v0.tV;
	var buttonLabel = A2($author$project$Components$HintBilling$CreateChargeModal$saveButtonLabel, hintBillingComponentType, practiceInvoice);
	return _List_fromArray(
		[
			A3(
			$author$project$Ui$Button$view,
			{mm: 'Cancel and close modal'},
			_List_fromArray(
				[
					$author$project$Ui$Button$link,
					$author$project$Ui$Button$onClick($author$project$Components$HintBilling$CreateChargeModal$CloseButtonClicked)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Cancel')
				])),
			A3(
			$author$project$Ui$Button$view,
			{mm: buttonLabel},
			_List_fromArray(
				[
					$author$project$Ui$Button$primary,
					$author$project$Ui$Button$onClick($author$project$Components$HintBilling$CreateChargeModal$FormSubmitted)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(buttonLabel)
				]))
		]);
};
var $author$project$Components$HintBilling$CreateChargeModal$view = F2(
	function (_v0, modalTitle) {
		var model = _v0;
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$HintBilling$CreateChargeModal$CloseButtonClicked,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title(modalTitle)
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A3($author$project$Components$HintBilling$CreateChargeModal$viewBody, model.Nr, model.SD, model.o7)
						])),
					$author$project$Ui$Modal$footer(
					$author$project$Components$HintBilling$CreateChargeModal$viewFooter(model.SD))
				]));
	});
var $author$project$Components$UpgradePracticeModal$ConfirmUpgrade = {$: 2};
var $author$project$Ui$Grid$Gutter = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Grid$Md = 2;
var $author$project$Ui$Grid$gutterMd = $author$project$Ui$Grid$Gutter(2);
var $author$project$Ui$Alignment$justifyCenter = $author$project$Ui$Alignment$Content(1);
var $author$project$Ui$Element$justifyCenter = $author$project$Ui$Element$Alignment($author$project$Ui$Alignment$justifyCenter);
var $author$project$Ui$Element$mt8 = $author$project$Ui$Element$Margin('mt-8');
var $author$project$Ui$Element$Stretch = {$: 20};
var $author$project$Ui$Element$stretch = $author$project$Ui$Element$Stretch;
var $author$project$Ui$Grid$rowItemsStretch = $author$project$Ui$Grid$RowElement($author$project$Ui$Element$stretch);
var $author$project$Ui$Button$Secondary = 2;
var $author$project$Ui$Button$secondary = $author$project$Ui$Button$Styled(2);
var $author$project$Ui$Element$SpaceX = function (a) {
	return {$: 14, a: a};
};
var $author$project$Ui$Element$spaceX4 = $author$project$Ui$Element$SpaceX(4);
var $author$project$Components$UpgradePracticeModal$AgreedToTerms = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Element$flexMd = A2($author$project$Ui$Element$Display, 2, 2);
var $author$project$Ui$Form$Checkbox$OnCheck = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Form$Checkbox$onCheck = $author$project$Ui$Form$Checkbox$OnCheck;
var $author$project$Ui$Form$Checkbox$Required = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$Checkbox$required = $author$project$Ui$Form$Checkbox$Required;
var $author$project$Ui$Form$Checkbox$Value = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$Checkbox$value = $author$project$Ui$Form$Checkbox$Value;
var $author$project$Ui$Form$Checkbox$defaultOptions = {iJ: _List_Nil, rJ: _List_Nil, agX: _List_Nil, T3: _List_Nil, eG: _List_Nil};
var $author$project$Ui$Form$Checkbox$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var val = option.a;
						return _Utils_update(
							record,
							{
								T3: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$checked(val),
									record.T3)
							});
					case 1:
						var bool = option.a;
						return _Utils_update(
							record,
							{
								T3: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$required(bool),
									record.T3),
								eG: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('label-required', bool)
											])),
									record.eG)
							});
					case 3:
						var bool = option.a;
						return _Utils_update(
							record,
							{
								T3: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$disabled(bool),
									record.T3),
								eG: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('text-muted', bool)
											])),
									record.eG)
							});
					case 4:
						var bool = option.a;
						return _Utils_update(
							record,
							{
								T3: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$disabled(bool),
									record.T3),
								eG: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('text-muted', bool)
											])),
									record.eG)
							});
					case 2:
						var toMsg = option.a;
						return _Utils_update(
							record,
							{
								T3: A2(
									$elm$core$List$cons,
									$elm$html$Html$Events$onCheck(toMsg),
									record.T3)
							});
					case 5:
						var attributes = option.a;
						return _Utils_update(
							record,
							{
								iJ: _Utils_ap(
									A2(
										$elm$core$List$map,
										$elm$html$Html$Attributes$map($elm$core$Basics$never),
										attributes),
									record.iJ)
							});
					case 6:
						var attributes = option.a;
						return _Utils_update(
							record,
							{
								rJ: _Utils_ap(
									A2(
										$elm$core$List$map,
										$elm$html$Html$Attributes$map($elm$core$Basics$never),
										attributes),
									record.rJ)
							});
					case 7:
						return _Utils_update(
							record,
							{
								iJ: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class('inline-block'),
									record.iJ)
							});
					default:
						var errors_ = option.a;
						return _Utils_update(
							record,
							{agX: errors_});
				}
			}),
		$author$project$Ui$Form$Checkbox$defaultOptions,
		options);
};
var $author$project$Ui$Form$Checkbox$view = F2(
	function (options, content) {
		var optionsRecord = $author$project$Ui$Form$Checkbox$optionsToRecord(options);
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('checkbox'),
				optionsRecord.iJ),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					optionsRecord.eG,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$type_('checkbox'),
								optionsRecord.T3),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							optionsRecord.rJ,
							A2(
								$elm$core$List$map,
								$elm$html$Html$map($elm$core$Basics$never),
								content)),
							$author$project$Utils$FormErrors$view(optionsRecord.agX)
						]))
				]));
	});
var $author$project$Components$UpgradePracticeModal$AnalyticsLinkClicked = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$HintBilling$FeatureListLink$link = function (hasClinicalAccount) {
	return hasClinicalAccount ? 'https://www.hint.com/clinical/pricing' : 'https://www.hint.com/pricing';
};
var $author$project$Ui$Link$OnClick = function (a) {
	return {$: 8, a: a};
};
var $author$project$Ui$Link$onClick = $author$project$Ui$Link$OnClick;
var $author$project$Components$UpgradePracticeModal$viewAdditionalInfoFooter = function (hasClinicalAccount) {
	var pricingInfoText = 'view our pricing information';
	var contactSalesText = 'Contact our sales team';
	var contactSalesLinkHref = 'mailto:sales@hint.com';
	return A2(
		$author$project$Ui$Element$prose,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$text,
				_List_fromArray(
					[$author$project$Ui$Typography$muted]),
				'Have any questions? '),
				A3(
				$author$project$Ui$Link$externalHref,
				contactSalesLinkHref,
				_List_fromArray(
					[
						$author$project$Ui$Link$targetBlank,
						$author$project$Ui$Link$onClick(
						A2($author$project$Components$UpgradePracticeModal$AnalyticsLinkClicked, contactSalesText, contactSalesLinkHref))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(contactSalesText)
					])),
				A2(
				$author$project$Ui$Typography$text,
				_List_fromArray(
					[$author$project$Ui$Typography$muted]),
				' or '),
				A3(
				$author$project$Ui$Link$externalHref,
				$author$project$Components$HintBilling$FeatureListLink$link(hasClinicalAccount),
				_List_fromArray(
					[
						$author$project$Ui$Link$targetBlank,
						$author$project$Ui$Link$onClick(
						A2(
							$author$project$Components$UpgradePracticeModal$AnalyticsLinkClicked,
							pricingInfoText,
							$author$project$Components$HintBilling$FeatureListLink$link(hasClinicalAccount)))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(pricingInfoText)
					])),
				A2(
				$author$project$Ui$Typography$text,
				_List_fromArray(
					[$author$project$Ui$Typography$muted]),
				' on our website.')
			]));
};
var $author$project$Components$UpgradePracticeModal$viewConfirmationCheckbox = F2(
	function (agreedToTerms, hasClinicalAccount) {
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Checkbox$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Checkbox$value(agreedToTerms),
							$author$project$Ui$Form$Checkbox$required(true),
							$author$project$Ui$Form$Checkbox$onCheck(
							function (value) {
								return $author$project$Components$UpgradePracticeModal$AgreedToTerms(value);
							})
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flexMd]),
							_List_fromArray(
								[
									$elm$html$Html$text('I agree to these changes, subject to the previously agreed upon terms of service.'),
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$danger]),
									' *')
								]))
						])),
					$author$project$Components$UpgradePracticeModal$viewAdditionalInfoFooter(hasClinicalAccount)
				]));
	});
var $author$project$Ui$Icon$Star = 73;
var $author$project$Ui$Alert$Success = 0;
var $author$project$Ui$Alert$Alignment = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Alert$alignment = $author$project$Ui$Alert$Alignment;
var $author$project$Ui$Typography$Black = 7;
var $author$project$Ui$Typography$black = $author$project$Ui$Typography$Color(7);
var $author$project$Ui$Icon$Color = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Icon$color = $author$project$Ui$Icon$Color;
var $author$project$Ui$Element$Direction = F2(
	function (a, b) {
		return {$: 24, a: a, b: b};
	});
var $author$project$Ui$Element$DirectionColumn = 1;
var $author$project$Ui$Element$flexCol = A2($author$project$Ui$Element$Direction, 0, 1);
var $author$project$Ui$Element$Gap = function (a) {
	return {$: 13, a: a};
};
var $author$project$Ui$Element$gap2 = $author$project$Ui$Element$Gap(2);
var $author$project$Ui$Alignment$Left = 0;
var $author$project$Ui$Alignment$textLeft = $author$project$Ui$Alignment$Text(0);
var $author$project$Components$UpgradePracticeModal$viewClinicalDiscountBanner = function (hasClinicalAccount) {
	return hasClinicalAccount ? A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$mt4]),
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Alert$view,
				0,
				_List_fromArray(
					[
						$author$project$Ui$Alert$alignment($author$project$Ui$Alignment$textLeft)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$flexMd]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Icon$view,
										_List_fromArray(
											[
												$author$project$Ui$Icon$height('1.8rem'),
												$author$project$Ui$Icon$color('#2A8000')
											]),
										73)
									])),
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap2]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$text,
										_List_fromArray(
											[$author$project$Ui$Typography$bold, $author$project$Ui$Typography$black]),
										'Thanks for being a Clinical customer!'),
										A2(
										$author$project$Ui$Element$prose,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$text,
												_List_fromArray(
													[$author$project$Ui$Typography$black]),
												'You get a '),
												A2(
												$author$project$Ui$Typography$text,
												_List_fromArray(
													[$author$project$Ui$Typography$bold, $author$project$Ui$Typography$black]),
												'20% discount'),
												A2(
												$author$project$Ui$Typography$text,
												_List_fromArray(
													[$author$project$Ui$Typography$black]),
												' on clinicians and members.')
											]))
									]))
							]))
					]))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Ui$Icon$Scissors = 72;
var $author$project$Ui$Icon$Sponsors = 11;
var $author$project$Ui$Icon$StarNote = 74;
var $author$project$Ui$Element$SpaceY = function (a) {
	return {$: 15, a: a};
};
var $author$project$Ui$Element$spaceY4 = $author$project$Ui$Element$SpaceY(4);
var $author$project$Ui$Link$IconRight = function (a) {
	return {$: 14, a: a};
};
var $author$project$Ui$Link$iconRight = $author$project$Ui$Link$IconRight;
var $author$project$Ui$Icon$Launch = 21;
var $author$project$Ui$Icon$launch = $author$project$Ui$Icon$viewIcon(21);
var $author$project$Ui$Link$Md = 2;
var $author$project$Ui$Link$Size = function (a) {
	return {$: 12, a: a};
};
var $author$project$Ui$Link$md = $author$project$Ui$Link$Size(2);
var $author$project$Ui$Link$Sm = 0;
var $author$project$Ui$Link$sm = $author$project$Ui$Link$Size(0);
var $author$project$Ui$Link$Style = function (a) {
	return {$: 11, a: a};
};
var $author$project$Ui$Link$Underline = 7;
var $author$project$Ui$Link$underline = $author$project$Ui$Link$Style(7);
var $author$project$Components$HintBilling$FeatureListLink$view = F3(
	function (hasClinicalAccount, onAnalyticsClick, smallSize) {
		return A3(
			$author$project$Ui$Link$externalHref,
			$author$project$Components$HintBilling$FeatureListLink$link(hasClinicalAccount),
			_List_fromArray(
				[
					$author$project$Ui$Link$targetBlank,
					$author$project$Ui$Link$underline,
					$author$project$Ui$Link$iconRight($author$project$Ui$Icon$launch),
					$author$project$Ui$Link$onClick(
					A2(
						onAnalyticsClick,
						'See All Features',
						$author$project$Components$HintBilling$FeatureListLink$link(hasClinicalAccount))),
					smallSize ? $author$project$Ui$Link$sm : $author$project$Ui$Link$md
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('See All Features')
				]));
	});
var $author$project$Components$UpgradePracticeModal$viewFeatureItem = F3(
	function (title, description, svgIcon) {
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$flexMd, $author$project$Ui$Element$itemsStart]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mr2]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Icon$view,
							_List_fromArray(
								[
									$author$project$Ui$Icon$height('1.8rem'),
									$author$project$Ui$Icon$color('#00BFFF')
								]),
							svgIcon)
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								])),
							A2(
							$author$project$Ui$Typography$p,
							_List_fromArray(
								[$author$project$Ui$Typography$muted]),
							_List_fromArray(
								[
									$elm$html$Html$text(description)
								]))
						]))
				]));
	});
var $author$project$Components$UpgradePracticeModal$viewFeaturesList = function (hasClinicalAccount) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$mt4, $author$project$Ui$Element$spaceY4]),
		_List_fromArray(
			[
				A3($author$project$Components$UpgradePracticeModal$viewFeatureItem, 'Lower Fees on Every Transaction', 'Grow your practice and keep more of what you earn. Lower transaction fees apply to every payment, starting with your next one.', 72),
				A3($author$project$Components$UpgradePracticeModal$viewFeatureItem, 'Employer Management & Billing', 'Streamline eligibility tracking, boost enrollments, and simplify billing for sponsoring employers with intuitive, built-in tools.', 11),
				hasClinicalAccount ? A3($author$project$Components$UpgradePracticeModal$viewFeatureItem, 'Hint AI', 'Simplify charting and streamline comminication with accurate, AI-generated SOAP notes and patient summaries.', 74) : A3($author$project$Components$UpgradePracticeModal$viewFeatureItem, 'Scheduled Plan Changes', 'Automate annual price increase, plan updates, and special offers so changes go live exactly when you want them.', 59),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mt4]),
				_List_fromArray(
					[
						A3($author$project$Components$HintBilling$FeatureListLink$view, hasClinicalAccount, $author$project$Components$UpgradePracticeModal$AnalyticsLinkClicked, true)
					]))
			]));
};
var $author$project$Components$UpgradePracticeModal$viewMarketingContent = F2(
	function (upgradePricing, hasClinicalAccount) {
		var tierName = function () {
			if (!upgradePricing.$) {
				var pricing = upgradePricing.a;
				return $author$project$Api$Provider$PracticePricing$Upgrade$tierName(pricing);
			} else {
				return 'Growth';
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('px-4 py-2')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Typography$heading(
					_List_fromArray(
						[
							$elm$html$Html$text('Upgrade to ' + tierName)
						])),
					$author$project$Components$UpgradePracticeModal$viewClinicalDiscountBanner(hasClinicalAccount),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mt4]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$mb2]),
							_List_fromArray(
								[
									$author$project$Ui$Typography$headingSm(
									_List_fromArray(
										[
											$elm$html$Html$text('Unlock All Benefits Now, Pay Nothing Today')
										]))
								])),
							$author$project$Components$UpgradePracticeModal$viewFeaturesList(hasClinicalAccount)
						]))
				]));
	});
var $author$project$Ui$Alert$FullHeight = {$: 3};
var $author$project$Ui$Alert$fullHeight = $author$project$Ui$Alert$FullHeight;
var $author$project$Api$Provider$PracticePricing$Upgrade$components = function (_v0) {
	var record = _v0;
	return record.On;
};
var $author$project$Utils$Currency$fromInt = function (cents) {
	return (cents >= 0) ? ('$' + A2($cuducos$elm_format_number$FormatNumber$format, $cuducos$elm_format_number$FormatNumber$Locales$usLocale, cents / 100)) : ('-$' + A2(
		$cuducos$elm_format_number$FormatNumber$format,
		$cuducos$elm_format_number$FormatNumber$Locales$usLocale,
		$elm$core$Basics$abs(cents) / 100));
};
var $author$project$Ui$Element$FullHeight = {$: 21};
var $author$project$Ui$Element$fullHeight = $author$project$Ui$Element$FullHeight;
var $author$project$Ui$Element$mb4 = $author$project$Ui$Element$Margin('mb-4');
var $author$project$Api$Provider$PracticePricing$Upgrade$nextBillDate = function (_v0) {
	var record = _v0;
	return record.XP;
};
var $author$project$Api$Provider$PracticePricing$Upgrade$totalInCents = function (_v0) {
	var record = _v0;
	return record.adp;
};
var $author$project$Api$Provider$PracticePricing$Upgrade$txnFees = function (_v0) {
	var record = _v0;
	return record.adI;
};
var $author$project$Components$UpgradePracticeModal$viewDiscountInfo = A2(
	$author$project$Ui$Element$prose,
	_List_fromArray(
		[$author$project$Ui$Element$mt4, $author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
	_List_fromArray(
		[
			$elm$html$Html$text('Any existing credits or discounts will continue to apply until they expire.')
		]));
var $author$project$Ui$Typography$span = F2(
	function (options, content) {
		return A2(
			$elm$html$Html$span,
			$author$project$Ui$Typography$optionsToAttributes(options),
			content);
	});
var $author$project$Ui$Typography$Strike = 1;
var $author$project$Ui$Typography$strike = $author$project$Ui$Typography$Decoration(1);
var $author$project$Ui$Popover$Body = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Ui$Popover$body = $author$project$Ui$Popover$Body;
var $author$project$Ui$Popover$Dark = 0;
var $author$project$Ui$Popover$Styling = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Popover$dark = $author$project$Ui$Popover$Styling(0);
var $author$project$Formatters$Locales$noDecimalLocale = {
	agf: '.',
	PV: $cuducos$elm_format_number$FormatNumber$Locales$Min(0),
	aiV: '−',
	aiW: '',
	aj5: '',
	aj6: '',
	al2: ',',
	amy: '',
	amz: ''
};
var $author$project$Utils$Currency$fromIntNoDecimals = function (cents) {
	return '$' + A2($cuducos$elm_format_number$FormatNumber$format, $author$project$Formatters$Locales$noDecimalLocale, cents / 100);
};
var $author$project$Ui$Icon$Help = 7;
var $author$project$Ui$Icon$help = $author$project$Ui$Icon$viewIcon(7);
var $author$project$Ui$Popover$OnHover = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Popover$onHover = $author$project$Ui$Popover$OnHover;
var $author$project$Ui$Popover$Size = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Popover$Small = 3;
var $author$project$Ui$Popover$sm = $author$project$Ui$Popover$Size(3);
var $author$project$Api$Provider$PracticePricing$TrancheSizes$trancheSize = function (tierName) {
	switch (tierName) {
		case 'Growth':
			return $elm$core$Maybe$Just(50);
		case 'Scale':
			return $elm$core$Maybe$Just(250);
		case 'Enterprise':
			return $elm$core$Maybe$Just(500);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $elm$html$Html$Events$onMouseOver = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseover',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Ui$Popover$Default = 0;
var $author$project$Ui$Popover$defaultOptions = {xr: _List_Nil, z5: true, s9: false, B_: $elm$core$Maybe$Nothing, aly: 0, JZ: 'popover__elm', h8: false};
var $author$project$Ui$Popover$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, optionsRecord) {
				switch (option.$) {
					case 0:
						var style = option.a;
						return _Utils_update(
							optionsRecord,
							{JZ: 'popover--dark'});
					case 1:
						var bool = option.a;
						return _Utils_update(
							optionsRecord,
							{h8: bool});
					case 2:
						var bool = option.a;
						return _Utils_update(
							optionsRecord,
							{z5: bool});
					case 3:
						var size_ = option.a;
						return _Utils_update(
							optionsRecord,
							{aly: size_});
					case 4:
						var msg = option.a;
						return _Utils_update(
							optionsRecord,
							{
								B_: $elm$core$Maybe$Just(msg)
							});
					case 5:
						var list = option.a;
						return _Utils_update(
							optionsRecord,
							{
								xr: _Utils_ap(optionsRecord.xr, list)
							});
					default:
						return _Utils_update(
							optionsRecord,
							{s9: true});
				}
			}),
		$author$project$Ui$Popover$defaultOptions,
		options);
};
var $author$project$Ui$Popover$sectionToContents = function (section) {
	switch (section.$) {
		case 0:
			var attributes = section.a;
			var contents = section.b;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('popover__heading'),
						attributes),
					contents)
				]);
		case 1:
			var attributes = section.a;
			var contents = section.b;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('popover__body'),
						attributes),
					contents)
				]);
		default:
			var attributes = section.a;
			var contents = section.b;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('popover__footer'),
						attributes),
					contents)
				]);
	}
};
var $author$project$Ui$Popover$sectionsToContents = function (sections) {
	return A2($elm$core$List$concatMap, $author$project$Ui$Popover$sectionToContents, sections);
};
var $author$project$Ui$Popover$sizeToClass = function (size_) {
	switch (size_) {
		case 0:
			return '';
		case 3:
			return 'popover--sm';
		case 2:
			return 'popover--md';
		default:
			return 'popover--lg';
	}
};
var $author$project$Ui$Popover$popoverContent = F2(
	function (sections, optionsRecord) {
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				A2(
					$elm$core$List$map,
					$elm$html$Html$Attributes$map($elm$core$Basics$never),
					optionsRecord.xr),
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('popover__content'),
						$elm$html$Html$Attributes$class(
						$author$project$Ui$Popover$sizeToClass(optionsRecord.aly)),
						$elm$html$Html$Attributes$class(optionsRecord.JZ),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('popover--mobile-overlay', optionsRecord.s9)
							]))
					])),
			$author$project$Ui$Popover$sectionsToContents(sections));
	});
var $author$project$Ui$Popover$popoverDisplayedContent = function (content) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('popover__content--displayed')
			]),
		content);
};
var $author$project$Ui$Popover$popoverView = F4(
	function (options, displayedContent, sections, maybeModel) {
		var optionsRecord = $author$project$Ui$Popover$optionsToRecord(options);
		if (!maybeModel.$) {
			var model = maybeModel.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('popover__wrapper', true),
								_Utils_Tuple2('popover__wrapper--mobile-overlay', optionsRecord.s9),
								_Utils_Tuple2('visible', model.Yn)
							])),
						$elm$html$Html$Attributes$id(model.ahP)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Popover$popoverDisplayedContent(displayedContent),
						A2($author$project$Ui$Popover$popoverContent, sections, optionsRecord)
					]));
		} else {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('popover__wrapper', true),
								_Utils_Tuple2('popover__wrapper--mobile-overlay', optionsRecord.s9),
								_Utils_Tuple2('visible', optionsRecord.h8),
								_Utils_Tuple2('hoverable', optionsRecord.z5)
							])),
						A2(
						$elm$core$Maybe$withDefault,
						$elm$html$Html$Attributes$class(''),
						A2($elm$core$Maybe$map, $elm$html$Html$Events$onMouseOver, optionsRecord.B_))
					]),
				_List_fromArray(
					[
						$author$project$Ui$Popover$popoverDisplayedContent(displayedContent),
						A2($author$project$Ui$Popover$popoverContent, sections, optionsRecord)
					]));
		}
	});
var $author$project$Ui$Popover$view = F3(
	function (options, displayedContent, sections) {
		return A4($author$project$Ui$Popover$popoverView, options, displayedContent, sections, $elm$core$Maybe$Nothing);
	});
var $author$project$Components$HintBilling$MemberTranches$view = F4(
	function (tierName, quantity, itemPriceInCents, onAnalyticsClick) {
		var _v0 = $author$project$Api$Provider$PracticePricing$TrancheSizes$trancheSize(tierName);
		if (!_v0.$) {
			var trancheSize = _v0.a;
			var numberOfTranches = (quantity / trancheSize) | 0;
			var pricePerTranche = (itemPriceInCents / numberOfTranches) | 0;
			var perMembersPriceText = $author$project$Utils$Currency$fromIntNoDecimals(pricePerTranche) + ('/mo per ' + ($elm$core$String$fromInt(trancheSize) + ' members '));
			return A2(
				$author$project$Ui$Element$prose,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$text,
						_List_fromArray(
							[$author$project$Ui$Typography$helpText, $author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
						perMembersPriceText),
						A3(
						$author$project$Ui$Popover$view,
						_List_fromArray(
							[
								$author$project$Ui$Popover$dark,
								$author$project$Ui$Popover$sm,
								$author$project$Ui$Popover$onHover(
								A2(onAnalyticsClick, perMembersPriceText, 'tooltip'))
							]),
						_List_fromArray(
							[
								$author$project$Ui$Icon$help(_List_Nil)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Popover$body,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										'Additional members are automatically added in tranches of ' + ($elm$core$String$fromInt(trancheSize) + ' members. If your member count goes below this tranche, you can downgrade at any time.'))
									]))
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$UpgradePracticeModal$viewLineItem = F2(
	function (tierName, component) {
		var quantity = A2($elm$core$Maybe$withDefault, 1, component.Dz);
		var oldPriceInCents = A2(
			$elm$core$Maybe$map,
			function (price) {
				return quantity * price;
			},
			component.Ya);
		var itemPriceInCents = quantity * component.Dw;
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[$author$project$Ui$Typography$black]),
							_List_fromArray(
								[
									function () {
									var _v0 = component.Dz;
									if (!_v0.$) {
										var qty = _v0.a;
										return A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$text,
													_List_fromArray(
														[$author$project$Ui$Typography$bold]),
													$elm$core$String$fromInt(qty)),
													$elm$html$Html$text(' ' + component.Bq)
												]));
									} else {
										return $elm$html$Html$text(component.Bq);
									}
								}()
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									function () {
									if (!oldPriceInCents.$) {
										var price = oldPriceInCents.a;
										return A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$text,
													_List_fromArray(
														[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$strike]),
													$author$project$Utils$Currency$fromInt(price)),
													A2(
													$author$project$Ui$Typography$text,
													_List_fromArray(
														[$author$project$Ui$Typography$black]),
													$author$project$Utils$Currency$fromInt(itemPriceInCents))
												]));
									} else {
										return A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[$author$project$Ui$Typography$black]),
											$author$project$Utils$Currency$fromInt(itemPriceInCents));
									}
								}()
								]))
						])),
					(component.Om === 2) ? A4($author$project$Components$HintBilling$MemberTranches$view, tierName, quantity, itemPriceInCents, $author$project$Components$UpgradePracticeModal$AnalyticsLinkClicked) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$UpgradePracticeModal$viewLineItems = F2(
	function (tierName, components) {
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$spaceY4]),
			A2(
				$elm$core$List$map,
				$author$project$Components$UpgradePracticeModal$viewLineItem(tierName),
				A2(
					$elm$core$List$filter,
					function (component) {
						return !(!component.Dw);
					},
					components)));
	});
var $author$project$Api$Provider$TxnFees$achTransactionFeeCapInCents = function (_v0) {
	var record = _v0;
	return record.KK;
};
var $author$project$Api$Provider$TxnFees$amexSurcharge = function (_v0) {
	var record = _v0;
	return record.adl - record.Ka;
};
var $author$project$Api$Provider$TxnFees$totalAchFeeInCents = function (_v0) {
	var record = _v0;
	return record.adj;
};
var $author$project$Api$Provider$TxnFees$totalAchFeePercentage = function (_v0) {
	var record = _v0;
	return record.adk;
};
var $author$project$Api$Provider$TxnFees$totalCardFeeInCents = function (_v0) {
	var record = _v0;
	return record.adm;
};
var $author$project$Api$Provider$TxnFees$totalCardFeePercentage = function (_v0) {
	var record = _v0;
	return record.Ka;
};
var $author$project$Utils$Billing$TxnFees$viewFees = F2(
	function (txnFees, inline) {
		var totalCardFeePercentage = $elm$core$String$fromFloat(
			$author$project$Api$Provider$TxnFees$totalCardFeePercentage(txnFees)) + '%';
		var totalCardFeeInCents = $elm$core$String$fromInt(
			$author$project$Api$Provider$TxnFees$totalCardFeeInCents(txnFees)) + 'c';
		var totalAchFeePercentage = $elm$core$String$fromFloat(
			$author$project$Api$Provider$TxnFees$totalAchFeePercentage(txnFees)) + '%';
		var totalAchFeeInCents = $elm$core$String$fromInt(
			$author$project$Api$Provider$TxnFees$totalAchFeeInCents(txnFees)) + 'c';
		var amexSurchargeDisplay = ' + ' + ($elm$core$String$fromFloat(
			$author$project$Api$Provider$TxnFees$amexSurcharge(txnFees)) + '% Amex surcharge');
		var achCapDisplay = function () {
			var _v0 = $author$project$Api$Provider$TxnFees$achTransactionFeeCapInCents(txnFees);
			if (!_v0.$) {
				var cap = _v0.a;
				return ' ($' + ($elm$core$String$fromFloat(cap / 100) + ' cap per txn)');
			} else {
				return '';
			}
		}();
		return inline ? A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$black, $author$project$Ui$Typography$small]),
					_List_fromArray(
						[
							$elm$html$Html$text('Credit cards: ' + (totalCardFeePercentage + (' + ' + totalCardFeeInCents))),
							A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[$author$project$Ui$Typography$muted]),
							amexSurchargeDisplay)
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$black, $author$project$Ui$Typography$small]),
					_List_fromArray(
						[
							$elm$html$Html$text('ACH: ' + (totalAchFeePercentage + (' + ' + (totalAchFeeInCents + achCapDisplay))))
						]))
				])) : A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Credit Card:')
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$muted]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[$author$project$Ui$Typography$bold]),
							totalCardFeePercentage),
							A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[$author$project$Ui$Typography$bold, $author$project$Ui$Typography$small]),
							' + ' + totalCardFeeInCents),
							A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[$author$project$Ui$Typography$small]),
							amexSurchargeDisplay)
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('ACH:')
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$muted]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[$author$project$Ui$Typography$bold]),
							totalAchFeePercentage),
							A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[$author$project$Ui$Typography$bold, $author$project$Ui$Typography$small]),
							' + ' + totalAchFeeInCents),
							A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[$author$project$Ui$Typography$small]),
							achCapDisplay)
						]))
				]));
	});
var $author$project$Components$UpgradePracticeModal$viewTransactionFees = function (txnFees) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mb2]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$text,
						_List_fromArray(
							[$author$project$Ui$Typography$black, $author$project$Ui$Typography$small]),
						'Updated Transaction Fees')
					])),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mt2]),
				_List_fromArray(
					[
						$author$project$Ui$HorizontalRule$view(_List_Nil)
					])),
				A2($author$project$Utils$Billing$TxnFees$viewFees, txnFees, true)
			]));
};
var $author$project$Components$UpgradePracticeModal$viewPricingContent = function (pricing) {
	var nextBillDate = function () {
		var _v0 = $author$project$Api$Provider$PracticePricing$Upgrade$nextBillDate(pricing);
		if (!_v0.$) {
			var date = _v0.a;
			return A2($justinmimbs$date$Date$format, 'MMMM d, yyyy', date);
		} else {
			return '';
		}
	}();
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$fullHeight]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mb4]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$spaceBetween]),
						_List_fromArray(
							[
								$author$project$Ui$Typography$headingSm(
								_List_fromArray(
									[
										$elm$html$Html$text('Your new recurring total')
									])),
								$author$project$Ui$Typography$heading(
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Utils$Currency$fromInt(
											$author$project$Api$Provider$PracticePricing$Upgrade$totalInCents(pricing)))
									]))
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$muted]),
						_List_fromArray(
							[
								$elm$html$Html$text('Due on ' + nextBillDate)
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mt4]),
						_List_fromArray(
							[
								$author$project$Ui$HorizontalRule$view(_List_Nil)
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Components$UpgradePracticeModal$viewLineItems,
								$author$project$Api$Provider$PracticePricing$Upgrade$tierName(pricing),
								$author$project$Api$Provider$PracticePricing$Upgrade$components(pricing))
							])),
						$author$project$Components$UpgradePracticeModal$viewDiscountInfo
					])),
				A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Components$UpgradePracticeModal$viewTransactionFees(
						$author$project$Api$Provider$PracticePricing$Upgrade$txnFees(pricing))
					]))
			]));
};
var $author$project$Components$UpgradePracticeModal$viewPricingSidebar = function (upgradePricing) {
	return A3(
		$author$project$Ui$Alert$view,
		1,
		_List_fromArray(
			[
				$author$project$Ui$Alert$alignment($author$project$Ui$Alignment$textLeft),
				$author$project$Ui$Alert$fullHeight
			]),
		_List_fromArray(
			[
				function () {
				if (!upgradePricing.$) {
					var pricing = upgradePricing.a;
					return $author$project$Components$UpgradePracticeModal$viewPricingContent(pricing);
				} else {
					return A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mt4]),
						_List_fromArray(
							[
								A2($author$project$Ui$Typography$text, _List_Nil, 'Loading pricing information...')
							]));
				}
			}()
			]));
};
var $author$project$Components$UpgradePracticeModal$view = function (model) {
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$UpgradePracticeModal$Close,
		_List_fromArray(
			[$author$project$Ui$Modal$lg]),
		_List_fromArray(
			[
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$row,
						_List_fromArray(
							[$author$project$Ui$Grid$gutterMd, $author$project$Ui$Grid$rowItemsStretch]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanSm(7)
									]),
								_List_fromArray(
									[
										A2($author$project$Components$UpgradePracticeModal$viewMarketingContent, model.h3, model.S5)
									])),
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanSm(5)
									]),
								_List_fromArray(
									[
										$author$project$Components$UpgradePracticeModal$viewPricingSidebar(model.h3)
									]))
							])),
						$author$project$Ui$HorizontalRule$view(_List_Nil),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mt8]),
						_List_fromArray(
							[
								A2($author$project$Components$UpgradePracticeModal$viewConfirmationCheckbox, model.aeO, model.S5)
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$mt4, $author$project$Ui$Element$spaceX4]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Cancel and lose modal'},
								_List_fromArray(
									[
										$author$project$Ui$Button$secondary,
										$author$project$Ui$Button$onClick($author$project$Components$UpgradePracticeModal$Close)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Cancel')
									])),
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Upgrade'},
								_List_fromArray(
									[
										$author$project$Ui$Button$primary,
										$author$project$Ui$Button$onClick($author$project$Components$UpgradePracticeModal$ConfirmUpgrade),
										$author$project$Ui$Button$disabled((!model.aeO) || model.j3)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Upgrade')
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Admin$Billing$modals = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				function () {
				var _v0 = model.cV;
				if ((_v0.$ === 1) && _v0.a) {
					var modal = _v0.b;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$Admin$Billing$UpdateModalMsg,
						$author$project$Components$ApplicationFeePlan$UpdateModal$view(modal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v1 = model.iV;
				if (!_v1.$) {
					var modal = _v1.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$Admin$Billing$CreateChargeModalMsg,
						A2($author$project$Components$HintBilling$CreateChargeModal$view, modal, 'Add Charge or Credit'));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v2 = model.lV;
				if (!_v2.$) {
					var modal = _v2.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$Admin$Billing$UpgradePracticeModalMsg,
						$author$project$Components$UpgradePracticeModal$view(modal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]));
};
var $author$project$Api$Provider$PracticePricing$One$manualBilling = function (_v0) {
	var record = _v0;
	return record.Wr;
};
var $author$project$Pages$Admin$Billing$shouldShowBillingSections = function (practicePricingData) {
	if (practicePricingData.$ === 3) {
		var practicePricing = practicePricingData.a;
		return !$author$project$Api$Provider$PracticePricing$One$manualBilling(practicePricing);
	} else {
		return true;
	}
};
var $author$project$Ui$Table$Loading = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Table$loading = $author$project$Ui$Table$Loading;
var $author$project$Api$Pagination$CurrentPageChanged = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Pagination$ItemsPerPageChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Pagination$List$CurrentPage = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Pagination$List$currentPage = $author$project$Ui$Pagination$List$CurrentPage;
var $author$project$Ui$Pagination$List$ItemsPerPage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Pagination$List$itemsPerPage = $author$project$Ui$Pagination$List$ItemsPerPage;
var $author$project$Ui$Pagination$List$OnClick = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Pagination$List$onClick = $author$project$Ui$Pagination$List$OnClick;
var $author$project$Ui$Pagination$List$OnPerPageChange = function (a) {
	return {$: 6, a: a};
};
var $author$project$Ui$Pagination$List$onPerPageChange = $author$project$Ui$Pagination$List$OnPerPageChange;
var $author$project$Ui$Pagination$List$TotalCount = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Pagination$List$totalCount = $author$project$Ui$Pagination$List$TotalCount;
var $author$project$Ui$Element$FullWidth = {$: 22};
var $author$project$Ui$Element$fullWidth = $author$project$Ui$Element$FullWidth;
var $author$project$Ui$Skeleton$input = $author$project$Ui$Skeleton$view('input');
var $author$project$Ui$Skeleton$inputSm = $author$project$Ui$Skeleton$view('input-sm');
var $author$project$Ui$Pagination$List$offsetSize = 2;
var $author$project$Ui$Pagination$List$onClick_ = F2(
	function (maybeMsg, pageNumber) {
		if (!maybeMsg.$) {
			var msg = maybeMsg.a;
			return $elm$html$Html$Events$onClick(
				msg(pageNumber));
		} else {
			return $author$project$Utils$Html$Attributes$none;
		}
	});
var $author$project$Ui$Pagination$List$Base = 1;
var $author$project$Ui$Pagination$List$defaultOptions = {
	bX: 0,
	zV: false,
	zW: false,
	gG: 0,
	V8: false,
	IS: $elm$core$Maybe$Nothing,
	B1: $elm$core$Maybe$Nothing,
	I8: _List_fromArray(
		[10, 25, 50, 75, 100]),
	aly: 1,
	qC: 0
};
var $author$project$Ui$Pagination$List$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var _int = option.a;
						return _Utils_update(
							record,
							{qC: _int});
					case 1:
						var _int = option.a;
						return _Utils_update(
							record,
							{gG: _int});
					case 2:
						return _Utils_update(
							record,
							{zW: true});
					case 3:
						return _Utils_update(
							record,
							{zV: true});
					case 4:
						var _int = option.a;
						return _Utils_update(
							record,
							{bX: _int});
					case 5:
						var toMsg = option.a;
						return _Utils_update(
							record,
							{
								IS: $elm$core$Maybe$Just(toMsg)
							});
					case 6:
						var toMsg = option.a;
						return _Utils_update(
							record,
							{
								B1: $elm$core$Maybe$Just(toMsg)
							});
					case 8:
						var size_ = option.a;
						return _Utils_update(
							record,
							{aly: size_});
					default:
						var bool = option.a;
						return _Utils_update(
							record,
							{V8: bool});
				}
			}),
		$author$project$Ui$Pagination$List$defaultOptions,
		options);
};
var $author$project$Ui$Pagination$List$sizeClass = function (size_) {
	if (!size_) {
		return 'pagination--sm';
	} else {
		return '';
	}
};
var $author$project$Ui$Element$spaceX2 = $author$project$Ui$Element$SpaceX(2);
var $author$project$Ui$Skeleton$TextSpan = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Skeleton$spanFromText = $author$project$Ui$Skeleton$TextSpan;
var $author$project$Ui$Pagination$List$viewPage = F3(
	function (currentPage_, maybeMsg, pageNumber) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pagination__item'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'active',
							_Utils_eq(currentPage_, pageNumber))
						])),
					A2($author$project$Ui$Pagination$List$onClick_, maybeMsg, pageNumber)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$elm$core$String$fromInt(pageNumber))
				]));
	});
var $author$project$Ui$Pagination$List$onPerPageChange_ = function (maybeMsg) {
	if (!maybeMsg.$) {
		var msg = maybeMsg.a;
		return A2(
			$elm$json$Json$Decode$andThen,
			function (val) {
				var _v1 = $elm$core$String$toInt(val);
				if (!_v1.$) {
					var n = _v1.a;
					return $elm$json$Json$Decode$succeed(
						msg(n));
				} else {
					return $elm$json$Json$Decode$fail('invalid int');
				}
			},
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['target', 'value']),
				$elm$json$Json$Decode$string));
	} else {
		return $elm$json$Json$Decode$fail('no onPerPageChange');
	}
};
var $author$project$Ui$Pagination$List$viewPerPageSelect = function (options) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pagination__per-page')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$select,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pagination__per-page-select'),
						A2(
						$elm$html$Html$Events$on,
						'change',
						$author$project$Ui$Pagination$List$onPerPageChange_(options.B1))
					]),
				A2(
					$elm$core$List$map,
					function (n) {
						return A2(
							$elm$html$Html$option,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$value(
									$elm$core$String$fromInt(n)),
									$elm$html$Html$Attributes$selected(
									_Utils_eq(n, options.gG))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(n) + ' per page')
								]));
					},
					options.I8))
			]));
};
var $author$project$Ui$Pagination$List$view = function (options) {
	var optionsRecord = $author$project$Ui$Pagination$List$optionsToRecord(options);
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$fullWidth]),
		function () {
			if (optionsRecord.V8) {
				var skeleton = function (text) {
					return function () {
						var _v0 = optionsRecord.aly;
						if (!_v0) {
							return $author$project$Ui$Skeleton$inputSm;
						} else {
							return $author$project$Ui$Skeleton$input;
						}
					}()(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$spanFromText(text + '0')
							]));
				};
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$spaceX2, $author$project$Ui$Element$mb2]),
						_List_fromArray(
							[
								skeleton('First'),
								skeleton('1'),
								skeleton('2'),
								skeleton('3'),
								skeleton('...'),
								skeleton('Last')
							]))
					]);
			} else {
				var showTotalItems = (!optionsRecord.zV) && (!((_Utils_cmp(optionsRecord.qC, optionsRecord.gG) < 1) && optionsRecord.zW));
				return $elm$core$List$concat(
					_List_fromArray(
						[
							function () {
							if (!optionsRecord.qC) {
								return _List_Nil;
							} else {
								if (_Utils_cmp(optionsRecord.qC, optionsRecord.gG) > 0) {
									var totalPages = $elm$core$Basics$ceiling(optionsRecord.qC / optionsRecord.gG);
									var lastVisible = A2($elm$core$Basics$min, optionsRecord.bX + $author$project$Ui$Pagination$List$offsetSize, totalPages);
									var firstVisible = A2($elm$core$Basics$max, optionsRecord.bX - $author$project$Ui$Pagination$List$offsetSize, 1);
									var pages = A2($elm$core$List$range, firstVisible, lastVisible);
									return _List_fromArray(
										[
											A2(
											$elm$html$Html$ul,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pagination'),
													$elm$html$Html$Attributes$class(
													$author$project$Ui$Pagination$List$sizeClass(optionsRecord.aly))
												]),
											$elm$core$List$concat(
												_List_fromArray(
													[
														_List_fromArray(
														[
															A2(
															$elm$html$Html$li,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('pagination__item'),
																	$elm$html$Html$Attributes$classList(
																	_List_fromArray(
																		[
																			_Utils_Tuple2('disabled', optionsRecord.bX === 1)
																		])),
																	A2($author$project$Ui$Pagination$List$onClick_, optionsRecord.IS, 1)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('First')
																]))
														]),
														(firstVisible > 1) ? _List_fromArray(
														[
															A2(
															$elm$html$Html$li,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('pagination__item'),
																	A2($author$project$Ui$Pagination$List$onClick_, optionsRecord.IS, firstVisible - 1)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('...')
																]))
														]) : _List_Nil,
														A2(
														$elm$core$List$map,
														A2($author$project$Ui$Pagination$List$viewPage, optionsRecord.bX, optionsRecord.IS),
														pages),
														(_Utils_cmp(lastVisible, totalPages) < 0) ? _List_fromArray(
														[
															A2(
															$elm$html$Html$li,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('pagination__item'),
																	A2($author$project$Ui$Pagination$List$onClick_, optionsRecord.IS, lastVisible + 1)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('...')
																]))
														]) : _List_Nil,
														_List_fromArray(
														[
															A2(
															$elm$html$Html$li,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('pagination__item'),
																	$elm$html$Html$Attributes$classList(
																	_List_fromArray(
																		[
																			_Utils_Tuple2(
																			'disabled',
																			_Utils_eq(optionsRecord.bX, totalPages))
																		])),
																	A2($author$project$Ui$Pagination$List$onClick_, optionsRecord.IS, totalPages)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Last')
																]))
														])
													])))
										]);
								} else {
									return _List_Nil;
								}
							}
						}(),
							function () {
							if (showTotalItems) {
								var offsetCount = (optionsRecord.bX - 1) * optionsRecord.gG;
								var fromItems = offsetCount + 1;
								var fromItems_ = (!optionsRecord.qC) ? 0 : fromItems;
								var currentPageItemsCount = (_Utils_cmp(optionsRecord.gG * optionsRecord.bX, optionsRecord.qC) > 0) ? (optionsRecord.qC - (optionsRecord.gG * (optionsRecord.bX - 1))) : optionsRecord.gG;
								var toItems = (fromItems - 1) + currentPageItemsCount;
								return _List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pagination__right')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('pagination__total')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$elm$core$String$fromInt(fromItems_) + (' — ' + ($elm$core$String$fromInt(toItems) + (' of ' + $elm$core$String$fromInt(optionsRecord.qC)))))
													])),
												$author$project$Ui$Pagination$List$viewPerPageSelect(optionsRecord)
											]))
									]);
							} else {
								return _List_Nil;
							}
						}()
						]));
			}
		}());
};
var $author$project$Api$Pagination$view = F2(
	function (options, _v0) {
		var model = _v0;
		return $author$project$Ui$Pagination$List$view(
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Pagination$List$totalCount(model.qC),
				A2(
					$elm$core$List$cons,
					$author$project$Ui$Pagination$List$itemsPerPage(model.gG),
					A2(
						$elm$core$List$cons,
						$author$project$Ui$Pagination$List$currentPage(model.bX),
						A2(
							$elm$core$List$cons,
							$author$project$Ui$Pagination$List$onClick($author$project$Api$Pagination$CurrentPageChanged),
							A2(
								$elm$core$List$cons,
								$author$project$Ui$Pagination$List$onPerPageChange($author$project$Api$Pagination$ItemsPerPageChanged),
								options))))));
	});
var $author$project$Api$Provider$Partner$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Ui$Badge$Color = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Badge$Danger = 3;
var $author$project$Ui$Badge$danger = $author$project$Ui$Badge$Color(3);
var $author$project$Ui$Badge$Primary = 4;
var $author$project$Ui$Badge$primary = $author$project$Ui$Badge$Color(4);
var $author$project$Ui$Badge$Success = 2;
var $author$project$Ui$Badge$success = $author$project$Ui$Badge$Color(2);
var $author$project$Api$Provider$PracticeInvoice$Status$toString = function (status_) {
	switch (status_) {
		case 0:
			return 'paid';
		case 1:
			return 'processing';
		case 2:
			return 'draft';
		case 5:
			return 'overdue';
		case 4:
			return 'cancelled';
		case 6:
			return 'disputed';
		default:
			return 'issued';
	}
};
var $author$project$Ui$Badge$optionToAttr = function (option) {
	switch (option.$) {
		case 0:
			return $elm$html$Html$Attributes$class('badge--inline');
		case 1:
			return $elm$html$Html$Attributes$class('badge--lg');
		case 2:
			return $elm$html$Html$Attributes$class('badge--sm');
		case 5:
			return $elm$html$Html$Attributes$class('mr-2');
		case 3:
			var testString = option.a;
			return $author$project$Utils$Html$Attributes$test(testString);
		default:
			var color = option.a;
			switch (color) {
				case 0:
					return $elm$html$Html$Attributes$class('badge--warning');
				case 1:
					return $elm$html$Html$Attributes$class('badge--info');
				case 2:
					return $elm$html$Html$Attributes$class('badge--success');
				case 3:
					return $elm$html$Html$Attributes$class('badge--danger');
				case 4:
					return $elm$html$Html$Attributes$class('badge--primary');
				case 5:
					return $elm$html$Html$Attributes$class('badge--neutral');
				case 6:
					return $elm$html$Html$Attributes$class('badge--accent-primary');
				default:
					return $elm$html$Html$Attributes$class('badge--accent-secondary');
			}
	}
};
var $author$project$Ui$Badge$view = F2(
	function (options, content) {
		return function (attrs) {
			return A2($elm$html$Html$span, attrs, content);
		}(
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('badge'),
				A2($elm$core$List$map, $author$project$Ui$Badge$optionToAttr, options)));
	});
var $author$project$Ui$Badge$Warning = 0;
var $author$project$Ui$Badge$warning = $author$project$Ui$Badge$Color(0);
var $author$project$Api$Provider$PracticeInvoice$Status$toBadge = function (status_) {
	var badgeOption = function () {
		switch (status_) {
			case 0:
				return _List_fromArray(
					[$author$project$Ui$Badge$success]);
			case 1:
				return _List_fromArray(
					[$author$project$Ui$Badge$primary]);
			case 3:
				return _List_fromArray(
					[$author$project$Ui$Badge$warning]);
			case 5:
				return _List_fromArray(
					[$author$project$Ui$Badge$danger]);
			default:
				return _List_Nil;
		}
	}();
	return A2(
		$author$project$Ui$Badge$view,
		badgeOption,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Api$Provider$PracticeInvoice$Status$toString(status_))
			]));
};
var $author$project$Components$HintBilling$InvoicesTable$viewInvoiceUrl = F2(
	function (id, linkContent) {
		return A3(
			$author$project$Ui$Link$route,
			$author$project$Spa$Generated$Route$Admin__Billing__PracticeInvoices__Id_String(
				{ahP: id}),
			_List_Nil,
			_List_fromArray(
				[linkContent]));
	});
var $author$project$Formatters$Time$Date__Full = 5;
var $author$project$Components$HintBilling$InvoicesTable$isInvoicePaid = function (invoice) {
	return !invoice.alH;
};
var $author$project$Components$HintBilling$InvoicesTable$viewPaidInfo = function (invoice) {
	if ($author$project$Components$HintBilling$InvoicesTable$isInvoicePaid(invoice)) {
		var _v0 = invoice.I1;
		if (!_v0.$) {
			var time = _v0.a;
			var timeFormatter = _v0.b;
			return A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						' on ' + A2(timeFormatter, 5, time))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$HintBilling$InvoicesTable$viewInvoice = function (invoice) {
	return A2(
		$author$project$Ui$Table$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Components$HintBilling$InvoicesTable$viewInvoiceUrl,
						invoice.ahP,
						$elm$html$Html$text(
							A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, invoice.PB)))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$fromInt(invoice.IO))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$elm$core$Maybe$withDefault,
							'Hint',
							A2($elm$core$Maybe$map, $author$project$Api$Provider$Partner$Shared$name, invoice.YN)))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Api$Provider$PracticeInvoice$Status$toBadge(invoice.alH),
						$author$project$Components$HintBilling$InvoicesTable$viewPaidInfo(invoice)
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Utils$Currency$fromInt(invoice.adp))
					]))
			]));
};
var $author$project$Components$HintBilling$InvoicesTable$viewInvoicesTableHeaders = _List_fromArray(
	[
		A2(
		$author$project$Ui$Table$header,
		_List_fromArray(
			[
				$author$project$Ui$Table$cellSpan(3)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Date')
			])),
		A2(
		$author$project$Ui$Table$header,
		_List_fromArray(
			[
				$author$project$Ui$Table$cellSpan(2)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Invoice Number')
			])),
		A2(
		$author$project$Ui$Table$header,
		_List_fromArray(
			[
				$author$project$Ui$Table$cellSpan(2)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Billed By')
			])),
		A2(
		$author$project$Ui$Table$header,
		_List_fromArray(
			[
				$author$project$Ui$Table$cellSpan(3)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Invoice Status')
			])),
		A2(
		$author$project$Ui$Table$header,
		_List_fromArray(
			[
				$author$project$Ui$Table$cellSpan(2)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Invoice Total')
			]))
	]);
var $author$project$Components$HintBilling$InvoicesTable$view = F2(
	function (_v0, pagination) {
		var record = _v0;
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					A4(
					$author$project$Ui$Table$view,
					_List_fromArray(
						[
							$author$project$Ui$Table$loading(record.V8)
						]),
					$author$project$Components$HintBilling$InvoicesTable$viewInvoicesTableHeaders,
					$elm$core$List$isEmpty(record.sP) ? _List_fromArray(
						[
							A2(
							$author$project$Ui$Table$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Table$cell,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('You have no invoices yet!')
										]))
								]))
						]) : A2($elm$core$List$map, $author$project$Components$HintBilling$InvoicesTable$viewInvoice, record.sP),
					_List_Nil),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mt4]),
					_List_fromArray(
						[
							A2($author$project$Api$Pagination$view, _List_Nil, pagination)
						]))
				]));
	});
var $author$project$Ui$Tooltip$Bottom = 1;
var $author$project$Pages$Admin$Billing$CreateInvoiceClicked = {$: 16};
var $author$project$Ui$Icon$HintHeart = 32;
var $author$project$Ui$Icon$hintHeart = $author$project$Ui$Icon$viewIcon(32);
var $author$project$Ui$HinterOnly$icon = $author$project$Ui$Icon$hintHeart;
var $author$project$Ui$HinterOnly$button = F3(
	function (accessibility, options, content) {
		return A3(
			$author$project$Ui$Button$view,
			accessibility,
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Button$icon($author$project$Ui$HinterOnly$icon),
				options),
			content);
	});
var $author$project$Ui$Tooltip$Placement = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Tooltip$placement = $author$project$Ui$Tooltip$Placement;
var $author$project$Ui$Tooltip$placementToAttribute = function (plmnt) {
	switch (plmnt) {
		case 0:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('tooltip--top')
				]);
		case 3:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('tooltip--right')
				]);
		case 2:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('tooltip--left')
				]);
		default:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('tooltip--bottom')
				]);
	}
};
var $author$project$Ui$Tooltip$optionsToAttributes = function (options) {
	return $author$project$Ui$Tooltip$placementToAttribute(options.Dc);
};
var $author$project$Ui$Tooltip$Top = 0;
var $author$project$Ui$StackingOrder$StackingOrder = $elm$core$Basics$identity;
var $author$project$Ui$StackingOrder$z100 = 100;
var $author$project$Ui$Tooltip$defaultOptions = {KN: true, xg: false, BQ: false, Dc: 0, EK: $author$project$Ui$StackingOrder$z100, Ga: false};
var $author$project$Ui$Tooltip$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, acc) {
				switch (option.$) {
					case 0:
						var place = option.a;
						return _Utils_update(
							acc,
							{Dc: place});
					case 1:
						var bool = option.a;
						return _Utils_update(
							acc,
							{KN: bool});
					case 2:
						var order = option.a;
						return _Utils_update(
							acc,
							{EK: order});
					case 3:
						return _Utils_update(
							acc,
							{Ga: true});
					case 4:
						return _Utils_update(
							acc,
							{BQ: true});
					default:
						return _Utils_update(
							acc,
							{xg: true});
				}
			}),
		$author$project$Ui$Tooltip$defaultOptions,
		options);
};
var $author$project$Ui$StackingOrder$toClass = function (_v0) {
	var _int = _v0;
	return $elm$html$Html$Attributes$class(
		'z-' + $elm$core$String$fromInt(_int));
};
var $author$project$Ui$Tooltip$view = F3(
	function (options, tooltip, contents) {
		var optionsRecord = $author$project$Ui$Tooltip$optionsToRecord(options);
		return optionsRecord.KN ? A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tooltip-wrapper')
				]),
			_Utils_ap(
				contents,
				_List_fromArray(
					[
						function (attrs) {
						return A2($elm$html$Html$span, attrs, _List_Nil);
					}(
						function (attrs) {
							return _Utils_ap(
								attrs,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'data-text', tooltip),
										$elm$html$Html$Attributes$class('tooltip'),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('tooltip--wide', optionsRecord.Ga),
												_Utils_Tuple2('tooltip--nowrap', optionsRecord.BQ),
												_Utils_Tuple2('tooltip--align-start', optionsRecord.xg)
											])),
										$author$project$Ui$StackingOrder$toClass(optionsRecord.EK)
									]));
						}(
							$author$project$Ui$Tooltip$optionsToAttributes(optionsRecord)))
					]))) : A2($elm$html$Html$span, _List_Nil, contents);
	});
var $author$project$Ui$Tooltip$Wide = {$: 3};
var $author$project$Ui$Tooltip$wide = $author$project$Ui$Tooltip$Wide;
var $author$project$Pages$Admin$Billing$viewCreateInvoiceButton = A3(
	$author$project$Ui$Tooltip$view,
	_List_fromArray(
		[
			$author$project$Ui$Tooltip$placement(1),
			$author$project$Ui$Tooltip$wide
		]),
	'Create the invoice now based on current active counts. The next tranche check will be on the following invoice',
	_List_fromArray(
		[
			A3(
			$author$project$Ui$HinterOnly$button,
			{mm: 'Bill next month'},
			_List_fromArray(
				[
					$author$project$Ui$Button$styled(0),
					$author$project$Ui$Button$onClick($author$project$Pages$Admin$Billing$CreateInvoiceClicked)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Bill next month')
				]))
		]));
var $author$project$Pages$Admin$Billing$OpenUpdateModal = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Admin$Billing$viewUpdatePricingButton = function (practicePricing) {
	var label = $author$project$Api$Provider$PracticePricing$One$isLegacyPricing(practicePricing) ? 'Reset Pricing with a HubSpot Deal' : 'Edit Subscription';
	return A3(
		$author$project$Ui$HinterOnly$button,
		{mm: label},
		_List_fromArray(
			[
				$author$project$Ui$Button$styled(0),
				$author$project$Ui$Button$onClick(
				$author$project$Pages$Admin$Billing$OpenUpdateModal(practicePricing))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(label)
			]));
};
var $author$project$Pages$Admin$Billing$UpgradePracticeClicked = {$: 14};
var $author$project$Pages$Admin$Billing$viewUpgradeButton = function (upgradeAvailable) {
	if (!upgradeAvailable.$) {
		var upgrade = upgradeAvailable.a;
		var label = 'Upgrade to ' + $author$project$Api$Provider$PracticePricing$Upgrade$tierName(upgrade);
		return A3(
			$author$project$Ui$Button$view,
			{mm: label},
			_List_fromArray(
				[
					$author$project$Ui$Button$primary,
					$author$project$Ui$Button$onClick($author$project$Pages$Admin$Billing$UpgradePracticeClicked)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Admin$Billing$viewActionButtons = F3(
	function (dataPracticePricing, isHintAdmin, upgradeAvailable) {
		if (dataPracticePricing.$ === 3) {
			var practicePricing = dataPracticePricing.a;
			return isHintAdmin ? A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$gap2]),
				_List_fromArray(
					[
						$author$project$Pages$Admin$Billing$viewUpdatePricingButton(practicePricing),
						$author$project$Pages$Admin$Billing$viewCreateInvoiceButton,
						$author$project$Pages$Admin$Billing$viewUpgradeButton(upgradeAvailable)
					])) : A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$justifyRight]),
				_List_fromArray(
					[
						$author$project$Pages$Admin$Billing$viewUpgradeButton(upgradeAvailable)
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Api$Provider$PracticePricing$One$products = function (_v0) {
	var record = _v0;
	return record.Dy;
};
var $author$project$Pages$Admin$Billing$extractCreditsFromPracticePricing = function (practicePricing) {
	return A2(
		$elm$core$List$filter,
		function (product) {
			return $author$project$Api$Provider$HintBillingComponent$Shared$componentType(product) === 5;
		},
		$author$project$Api$Provider$PracticePricing$One$products(practicePricing));
};
var $author$project$Pages$Admin$Billing$filterCreditsBeforeNextBillDate = F2(
	function (credits, maybeNextBillDate) {
		if (!maybeNextBillDate.$) {
			var nextBillDate = maybeNextBillDate.a;
			return A2(
				$elm$core$List$filter,
				function (credit) {
					var _v1 = $author$project$Api$Provider$HintBillingComponent$Shared$endDate(credit);
					if (!_v1.$) {
						var endDate = _v1.a;
						return !(!A2($justinmimbs$date$Date$compare, endDate, nextBillDate));
					} else {
						return true;
					}
				},
				credits);
		} else {
			return credits;
		}
	});
var $author$project$Api$Provider$PracticePricing$One$nextBillDate = function (_v0) {
	var record = _v0;
	return record.XP;
};
var $author$project$Pages$Admin$Billing$AddOneTimeChargeButtonClicked = {$: 10};
var $author$project$Pages$Admin$Billing$viewAdditionalChargesHeader = function (isHintAdmin) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanMd(8)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('Additional Charges & Credits')
								])),
							A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('These will be added to the next invoice when it is created.')
								]))
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanMd(4)
						]),
					_List_fromArray(
						[
							isHintAdmin ? A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$justifyRight]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$HinterOnly$button,
									{mm: 'Add Charge or Credit'},
									_List_fromArray(
										[
											$author$project$Ui$Button$onClick($author$project$Pages$Admin$Billing$AddOneTimeChargeButtonClicked)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Add Charge or Credit')
										]))
								])) : $author$project$Utils$Html$empty
						]))
				]))
		]);
};
var $author$project$Formatters$Date$MonthAndDayAndYear = {$: 3};
var $author$project$Utils$Date$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $author$project$Utils$Date$daysInMonth = F2(
	function (y, m) {
		switch (m) {
			case 0:
				return 31;
			case 1:
				return $author$project$Utils$Date$isLeapYear(y) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $author$project$Utils$Uom$dateDiff = F2(
	function (m1, m2) {
		var yDiff = $justinmimbs$date$Date$year(m2) - $justinmimbs$date$Date$year(m1);
		var mDiff = $justinmimbs$date$Date$monthNumber(m2) - $justinmimbs$date$Date$monthNumber(m1);
		var dDiff = $justinmimbs$date$Date$day(m2) - $justinmimbs$date$Date$day(m1);
		var _v0 = function () {
			if (dDiff < 0) {
				var daysInLastFullMonth = function (lastFullMonth) {
					return A2(
						$author$project$Utils$Date$daysInMonth,
						$justinmimbs$date$Date$year(lastFullMonth),
						$justinmimbs$date$Date$month(lastFullMonth));
				}(
					A3(
						$justinmimbs$date$Date$add,
						1,
						-1,
						A3(
							$justinmimbs$date$Date$fromCalendarDate,
							$justinmimbs$date$Date$year(m2),
							$justinmimbs$date$Date$month(
								A3($justinmimbs$date$Date$add, 1, 1, m2)),
							1)));
				return _Utils_Tuple2(
					(_Utils_cmp(
						daysInLastFullMonth,
						$justinmimbs$date$Date$day(m1)) < 0) ? ((daysInLastFullMonth + dDiff) + ($justinmimbs$date$Date$day(m1) - daysInLastFullMonth)) : (daysInLastFullMonth + dDiff),
					mDiff - 1);
			} else {
				return _Utils_Tuple2(dDiff, mDiff);
			}
		}();
		var dDiff_ = _v0.a;
		var mDiff_ = _v0.b;
		var _v1 = (mDiff_ < 0) ? _Utils_Tuple2(12 + mDiff_, yDiff - 1) : _Utils_Tuple2(mDiff_, yDiff);
		var mDiff__ = _v1.a;
		var yDiff_ = _v1.b;
		return {agb: dDiff_, aiQ: mDiff__, amx: yDiff_};
	});
var $author$project$Pages$Admin$Billing$calculateMonthsRemaining = F2(
	function (currentDate, maybeEndDate) {
		if (!maybeEndDate.$) {
			var endDate = maybeEndDate.a;
			if (A2($justinmimbs$date$Date$compare, currentDate, endDate) === 2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var billingStartDate = A3($justinmimbs$date$Date$add, 3, -1, currentDate);
				var diff = A2($author$project$Utils$Uom$dateDiff, billingStartDate, endDate);
				var totalMonths = (diff.amx * 12) + diff.aiQ;
				return (totalMonths > 0) ? $elm$core$Maybe$Just(
					$elm$core$String$fromInt(totalMonths) + ' months left') : (((!totalMonths) && (diff.agb >= 0)) ? $elm$core$Maybe$Just('This month') : $elm$core$Maybe$Nothing);
			}
		} else {
			return $elm$core$Maybe$Just('forever');
		}
	});
var $cuducos$elm_format_number$FormatNumber$Locales$Max = function (a) {
	return {$: 1, a: a};
};
var $author$project$Formatters$Locales$partialPenniesLocale = _Utils_update(
	$cuducos$elm_format_number$FormatNumber$Locales$usLocale,
	{
		PV: $cuducos$elm_format_number$FormatNumber$Locales$Max(10)
	});
var $author$project$Utils$Currency$formatFromFloat = function (cents) {
	var formattedWithTwoDecimals = A2(
		$cuducos$elm_format_number$FormatNumber$format,
		$cuducos$elm_format_number$FormatNumber$Locales$usLocale,
		$elm$core$Basics$abs(cents) / 100);
	var formattedWithMaxDecimals = A2(
		$cuducos$elm_format_number$FormatNumber$format,
		$author$project$Formatters$Locales$partialPenniesLocale,
		$elm$core$Basics$abs(cents) / 100);
	return (_Utils_cmp(
		$elm$core$String$length(formattedWithMaxDecimals),
		$elm$core$String$length(formattedWithTwoDecimals)) > -1) ? formattedWithMaxDecimals : formattedWithTwoDecimals;
};
var $author$project$Utils$Currency$fromFloat = function (cents) {
	var formatted = $author$project$Utils$Currency$formatFromFloat(cents);
	return (cents >= 0) ? ('$' + formatted) : ('-$' + formatted);
};
var $author$project$Pages$Admin$Billing$viewCreditTableRow = F4(
	function (currentDate, maybeNextBillDate, _v0, credit) {
		var creditType = function () {
			var startDateToUse = (A2(
				$justinmimbs$date$Date$compare,
				$author$project$Api$Provider$HintBillingComponent$Shared$startDate(credit),
				currentDate) === 2) ? $author$project$Api$Provider$HintBillingComponent$Shared$startDate(credit) : currentDate;
			var startDate = $author$project$Api$Provider$HintBillingComponent$Shared$startDate(credit);
			var shouldShowStartsOn = function () {
				if (!maybeNextBillDate.$) {
					var nextBillDate = maybeNextBillDate.a;
					return A2($justinmimbs$date$Date$compare, startDate, nextBillDate) === 2;
				} else {
					return false;
				}
			}();
			var baseCreditType = function () {
				var _v2 = A2(
					$author$project$Pages$Admin$Billing$calculateMonthsRemaining,
					startDateToUse,
					$author$project$Api$Provider$HintBillingComponent$Shared$endDate(credit));
				if (!_v2.$) {
					var monthsText = _v2.a;
					return 'Recurring (' + (monthsText + ')');
				} else {
					return 'One-Time';
				}
			}();
			return shouldShowStartsOn ? (baseCreditType + (' - starts on ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$MonthAndDayAndYear, startDate))) : baseCreditType;
		}();
		var creditQuantity = function () {
			var _v1 = $author$project$Api$Provider$HintBillingComponent$Shared$quantity(credit);
			if (!_v1.$) {
				var qty = _v1.a;
				return $elm$core$String$fromInt(qty);
			} else {
				return '1';
			}
		}();
		var creditPrice = $author$project$Api$Provider$HintBillingComponent$Shared$priceInCents(credit);
		var creditName = $author$project$Api$Provider$HintBillingComponent$Shared$description(credit);
		var creditAmount = creditPrice * A2(
			$elm$core$Maybe$withDefault,
			1,
			$author$project$Api$Provider$HintBillingComponent$Shared$quantity(credit));
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[$author$project$Ui$Typography$bold]),
							creditName)
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Hint')
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(creditType)
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(creditQuantity)
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$Currency$fromFloat(creditPrice))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$Currency$fromFloat(creditAmount))
						])),
					A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil)
				]));
	});
var $author$project$Pages$Admin$Billing$DeleteOneTimeChargeClicked = function (a) {
	return {$: 11, a: a};
};
var $author$project$Api$Provider$Partner$Min$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$PracticeCharge$Shared$partner = function (_v0) {
	var record = _v0;
	return record.YN;
};
var $author$project$Api$Provider$PracticeCharge$All$partner = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PracticeCharge$Shared$partner(shared);
};
var $author$project$Api$Provider$PracticeCharge$Shared$priceInCents = function (_v0) {
	var record = _v0;
	return record.Dw;
};
var $author$project$Api$Provider$PracticeCharge$All$priceInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PracticeCharge$Shared$priceInCents(shared);
};
var $author$project$Api$Provider$PracticeCharge$Shared$quantity = function (_v0) {
	var record = _v0;
	return record.Dz;
};
var $author$project$Api$Provider$PracticeCharge$All$quantity = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PracticeCharge$Shared$quantity(shared);
};
var $author$project$Api$Provider$PracticeCharge$Shared$subtotalInCents = function (_v0) {
	var record = _v0;
	return record.acD;
};
var $author$project$Api$Provider$PracticeCharge$All$subtotalInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PracticeCharge$Shared$subtotalInCents(shared);
};
var $author$project$Pages$Admin$Billing$viewTableRow = F2(
	function (isHintAdmin, practiceCharge) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[$author$project$Ui$Typography$bold]),
							$author$project$Api$Provider$PracticeCharge$All$description(practiceCharge))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'Hint',
								A2(
									$elm$core$Maybe$map,
									$author$project$Api$Provider$Partner$Min$name,
									$author$project$Api$Provider$PracticeCharge$All$partner(practiceCharge))))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('One-Time')
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(
								$author$project$Api$Provider$PracticeCharge$All$quantity(practiceCharge)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$Currency$fromFloat(
								$author$project$Api$Provider$PracticeCharge$All$priceInCents(practiceCharge)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$Currency$fromInt(
								$author$project$Api$Provider$PracticeCharge$All$subtotalInCents(practiceCharge)))
						])),
					isHintAdmin ? A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$HinterOnly$button,
							{mm: 'Delete one time charge'},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$sm,
									$author$project$Ui$Button$onClick(
									$author$project$Pages$Admin$Billing$DeleteOneTimeChargeClicked(practiceCharge)),
									$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Delete')
								]))
						])) : A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil)
				]));
	});
var $author$project$Ui$Table$ZeroState = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Table$zeroState = $author$project$Ui$Table$ZeroState;
var $author$project$Pages$Admin$Billing$viewAdditionalChargesTable = F5(
	function (uninvoicedCharges, credits, isHintAdmin, currentDate, maybeNextBillDate) {
		var creditRows = A2(
			$elm$core$List$map,
			A3($author$project$Pages$Admin$Billing$viewCreditTableRow, currentDate, maybeNextBillDate, isHintAdmin),
			credits);
		var chargeRows = A2(
			$elm$core$List$map,
			$author$project$Pages$Admin$Billing$viewTableRow(isHintAdmin),
			uninvoicedCharges);
		var allRows = _Utils_ap(chargeRows, creditRows);
		return _List_fromArray(
			[
				A4(
				$author$project$Ui$Table$view,
				_List_fromArray(
					[
						$author$project$Ui$Table$zeroState(
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$muted]),
								_List_fromArray(
									[
										$elm$html$Html$text('You have no additional charges yet!')
									]))
							]))
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Charge Name')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Billed By')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Type')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Qty')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Price')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Amount')
							])),
						A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
					]),
				allRows,
				_List_Nil),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mt8]),
				_List_Nil)
			]);
	});
var $author$project$Pages$Admin$Billing$viewAdditionalChargesSection = F4(
	function (uninvoicedCharges, isHintAdmin, practicePricingData, currentDate) {
		var headerView = $author$project$Pages$Admin$Billing$viewAdditionalChargesHeader(isHintAdmin);
		var _v0 = function () {
			if (practicePricingData.$ === 3) {
				var practicePricing = practicePricingData.a;
				return _Utils_Tuple2(
					$author$project$Pages$Admin$Billing$extractCreditsFromPracticePricing(practicePricing),
					$author$project$Api$Provider$PracticePricing$One$nextBillDate(practicePricing));
			} else {
				return _Utils_Tuple2(_List_Nil, $elm$core$Maybe$Nothing);
			}
		}();
		var credits = _v0.a;
		var nextBillDate = _v0.b;
		var filteredCredits = A2($author$project$Pages$Admin$Billing$filterCreditsBeforeNextBillDate, credits, nextBillDate);
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				_Utils_ap(
					headerView,
					A5($author$project$Pages$Admin$Billing$viewAdditionalChargesTable, uninvoicedCharges, filteredCredits, isHintAdmin, currentDate, nextBillDate))));
	});
var $author$project$Api$Provider$PracticePricing$One$pmpmFeeInCents = function (_v0) {
	var record = _v0;
	return record.ZJ;
};
var $author$project$Ui$Skeleton$Block = 0;
var $author$project$Ui$Skeleton$Display = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Skeleton$block = $author$project$Ui$Skeleton$Display(0);
var $author$project$Ui$Skeleton$spanMd = $author$project$Ui$Skeleton$Span(2);
var $author$project$Components$HintBilling$NextBill$skeleton = A2(
	$elm$html$Html$div,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$spaceY4, $author$project$Ui$Element$mb2]),
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$block,
							$author$project$Ui$Skeleton$span(2)
						])),
					$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$block,
							$author$project$Ui$Skeleton$span(3)
						]))
				])),
			A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Typography$heading(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$spanFromText('$1000')
								]))
						]))
				])),
			$author$project$Ui$Skeleton$text(
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$spanMd(2),
					$author$project$Ui$Skeleton$block
				])),
			$author$project$Ui$Skeleton$text(
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$spanMd(2),
					$author$project$Ui$Skeleton$block
				]))
		]));
var $author$project$Api$Provider$ApplicationFeePlan$One$minimumPerMonthInCents = function (_v0) {
	var record = _v0;
	return record.Xh;
};
var $author$project$Components$HintBilling$LegacyPricing$startedAddOns = F2(
	function (currentDate, charges) {
		return A2(
			$elm$core$List$filter,
			function (charge) {
				return !(!A2(
					$justinmimbs$date$Date$compare,
					currentDate,
					$author$project$Api$Provider$HintBillingComponent$Shared$startDate(charge)));
			},
			A2(
				$elm$core$List$filter,
				function (addon) {
					return $author$project$Api$Provider$HintBillingComponent$Shared$componentType(addon) === 1;
				},
				charges));
	});
var $author$project$Ui$Typography$Gray = 6;
var $author$project$Ui$Typography$gray = $author$project$Ui$Typography$Color(6);
var $author$project$Api$Provider$HintBillingComponent$Shared$totalAmountInCents = function (_v0) {
	var record = _v0;
	return record.Dw * A2($elm$core$Maybe$withDefault, 0, record.Dz);
};
var $author$project$Components$HintBilling$LegacyPricing$viewAddOn = function (product) {
	var amount = $author$project$Utils$Currency$fromFloat(
		$author$project$Api$Provider$HintBillingComponent$Shared$totalAmountInCents(product));
	var description = amount + (' for ' + $author$project$Api$Provider$HintBillingComponent$Shared$description(product));
	return A2(
		$author$project$Ui$Typography$span,
		_List_fromArray(
			[$author$project$Ui$Typography$gray]),
		_List_fromArray(
			[
				$author$project$Ui$Icon$check(_List_Nil),
				$elm$html$Html$text(' ' + description)
			]));
};
var $author$project$Api$Provider$ApplicationFeePlan$One$collectionFeePercentage = function (_v0) {
	var record = _v0;
	return record.N0;
};
var $author$project$Api$Provider$ApplicationFeePlan$One$pricedBy = function (_v0) {
	var record = _v0;
	return record.Dx;
};
var $author$project$Api$Provider$PricingTier$Shared$fixedAmountInCents = function (_v0) {
	var record = _v0;
	return record.ahn;
};
var $author$project$Api$Provider$PricingTier$Shared$lowerBound = function (_v0) {
	var record = _v0;
	return record.Wn;
};
var $author$project$Api$Provider$PricingTier$Shared$upperBound = function (_v0) {
	var record = _v0;
	return record.adX;
};
var $author$project$Api$Provider$PricingTier$Shared$rangeDescription = function (tier) {
	var range = function () {
		var _v1 = $author$project$Api$Provider$PricingTier$Shared$upperBound(tier);
		if (_v1.$ === 1) {
			return $author$project$Api$Provider$PricingTier$Shared$lowerBound(tier) - 1;
		} else {
			var actualUpperbound = _v1.a;
			return actualUpperbound - ($author$project$Api$Provider$PricingTier$Shared$lowerBound(tier) - 1);
		}
	}();
	var prettyfiedRange = ((range < 1000) || (!(!A2($elm$core$Basics$modBy, 100, range)))) ? A2($cuducos$elm_format_number$FormatNumber$format, $author$project$Formatters$Locales$noDecimalLocale, range) : $elm$core$String$concat(
		_List_fromArray(
			[
				$elm$core$String$fromFloat(range / 1000.0),
				'k'
			]));
	var prefix = function () {
		if ($author$project$Api$Provider$PricingTier$Shared$lowerBound(tier) === 1) {
			return 'First ';
		} else {
			var _v0 = $author$project$Api$Provider$PricingTier$Shared$upperBound(tier);
			if (!_v0.$) {
				return 'Next ';
			} else {
				return 'After ';
			}
		}
	}();
	return $elm$core$String$concat(
		_List_fromArray(
			[prefix, prettyfiedRange, ' members']));
};
var $author$project$Components$HintBilling$LegacyPricing$viewPricingTierInformation = function (pricingTier) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('cascading-pricing-tier')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Api$Provider$PricingTier$Shared$rangeDescription(pricingTier))
							])),
						A2(
						$elm$html$Html$strong,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-lg')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Utils$Currency$fromInt(
									$author$project$Api$Provider$PricingTier$Shared$fixedAmountInCents(pricingTier)))
							])),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(' pmpm')
							]))
					]))
			]));
};
var $author$project$Components$HintBilling$LegacyPricing$viewPricingTiersInformation = function (tiers) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex')
					]),
				A2($elm$core$List$map, $author$project$Components$HintBilling$LegacyPricing$viewPricingTierInformation, tiers)),
				$author$project$Ui$HorizontalRule$view(_List_Nil)
			]));
};
var $author$project$Components$HintBilling$LegacyPricing$viewPricingInformation = F2(
	function (feePlan, pmpmFee) {
		var _v0 = $author$project$Api$Provider$ApplicationFeePlan$One$pricedBy(feePlan);
		switch (_v0.$) {
			case 0:
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$strong,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-lg')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromFloat(
									$author$project$Api$Provider$ApplicationFeePlan$One$collectionFeePercentage(feePlan)))
							])),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('% of collections')
							]))
					]);
			case 1:
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$strong,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-lg')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Utils$Currency$fromFloat(pmpmFee))
							])),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(' pmpm')
							]))
					]);
			default:
				var tiers = _v0.a;
				return _List_fromArray(
					[
						$author$project$Components$HintBilling$LegacyPricing$viewPricingTiersInformation(tiers)
					]);
		}
	});
var $author$project$Components$HintBilling$LegacyPricing$viewLegacyPricingInformation = F4(
	function (feePlan, pmpmFee, currentDate, charges) {
		var addOns = A2($author$project$Components$HintBilling$LegacyPricing$startedAddOns, currentDate, charges);
		var hasAddons = !$elm$core$List$isEmpty(addOns);
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(12)
							]),
						A2($author$project$Components$HintBilling$LegacyPricing$viewPricingInformation, feePlan, pmpmFee))
					])),
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(12)
							]),
						$elm$core$List$concat(
							_List_fromArray(
								[
									($author$project$Api$Provider$ApplicationFeePlan$One$minimumPerMonthInCents(feePlan) > 0) ? _List_fromArray(
									[
										A2($author$project$Ui$Typography$text, _List_Nil, 'Plan Minimum: '),
										A2(
										$author$project$Ui$Typography$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Utils$Currency$fromInt(
													$author$project$Api$Provider$ApplicationFeePlan$One$minimumPerMonthInCents(feePlan)))
											]))
									]) : _List_Nil,
									hasAddons ? _List_fromArray(
									[
										$author$project$Utils$Html$noBreakSpace,
										A2($author$project$Ui$Typography$text, _List_Nil, 'Add-Ons: ')
									]) : _List_Nil,
									A2(
									$elm$core$List$map,
									$author$project$Components$HintBilling$LegacyPricing$viewAddOn,
									A2($author$project$Components$HintBilling$LegacyPricing$startedAddOns, currentDate, addOns))
								])))
					]))
			]);
	});
var $author$project$Ui$Popover$Heading = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Ui$Popover$heading = $author$project$Ui$Popover$Heading;
var $author$project$Api$Provider$ApplicationFeePlan$One$achTransactionFeeCapInCents = function (_v0) {
	var record = _v0;
	return record.KK;
};
var $author$project$Api$Provider$ApplicationFeePlan$One$amexSurcharge = function (_v0) {
	var record = _v0;
	return record.adl - record.Ka;
};
var $author$project$Ui$HorizontalRule$Style = $elm$core$Basics$identity;
var $author$project$Ui$HorizontalRule$Thin = 1;
var $author$project$Ui$HorizontalRule$thin = 1;
var $author$project$Api$Provider$ApplicationFeePlan$One$totalAchFeeInCents = function (_v0) {
	var record = _v0;
	return record.adj;
};
var $author$project$Api$Provider$ApplicationFeePlan$One$totalAchFeePercentage = function (_v0) {
	var record = _v0;
	return record.adk;
};
var $author$project$Api$Provider$ApplicationFeePlan$One$totalCardFeeInCents = function (_v0) {
	var record = _v0;
	return record.adm;
};
var $author$project$Api$Provider$ApplicationFeePlan$One$totalCardFeePercentage = function (_v0) {
	var record = _v0;
	return record.Ka;
};
var $author$project$Components$HintBilling$LegacyPricing$viewFeeBreakdown = function (feePlan) {
	var totalCardFeePercentage = $elm$core$String$fromFloat(
		$author$project$Api$Provider$ApplicationFeePlan$One$totalCardFeePercentage(feePlan)) + '%';
	var totalCardFeeInCents = $elm$core$String$fromInt(
		$author$project$Api$Provider$ApplicationFeePlan$One$totalCardFeeInCents(feePlan)) + 'c';
	var totalAchFeePercentage = $elm$core$String$fromFloat(
		$author$project$Api$Provider$ApplicationFeePlan$One$totalAchFeePercentage(feePlan)) + '%';
	var totalAchFeeInCents = $elm$core$String$fromInt(
		$author$project$Api$Provider$ApplicationFeePlan$One$totalAchFeeInCents(feePlan)) + 'c';
	var creditCardTransactionDisplay = 'Credit Card: ' + (totalCardFeePercentage + (' + ' + totalCardFeeInCents));
	var amexSurchargeDisplay = '+ ' + ($elm$core$String$fromFloat(
		$author$project$Api$Provider$ApplicationFeePlan$One$amexSurcharge(feePlan)) + '% surcharge for Amex');
	var achCapDisplay = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function (achCap) {
				return ' (' + ($author$project$Utils$Currency$fromInt(achCap) + ' Cap)');
			},
			$author$project$Api$Provider$ApplicationFeePlan$One$achTransactionFeeCapInCents(feePlan)));
	var achTransactionDisplay = 'ACH: ' + (totalAchFeePercentage + (' + ' + (totalAchFeeInCents + achCapDisplay)));
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Hint pricing does not include processing fees for accepting card or ACH payments.')
						])),
					$author$project$Ui$HorizontalRule$view(
					_List_fromArray(
						[$author$project$Ui$HorizontalRule$thin])),
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(creditCardTransactionDisplay)
								])),
							A2(
							$author$project$Ui$Typography$p,
							_List_fromArray(
								[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted, $author$project$Ui$Typography$italic]),
							_List_fromArray(
								[
									$elm$html$Html$text(amexSurchargeDisplay)
								]))
						])),
					$author$project$Ui$HorizontalRule$view(
					_List_fromArray(
						[$author$project$Ui$HorizontalRule$thin])),
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(achTransactionDisplay)
								]))
						]))
				]))
		]);
};
var $author$project$Components$HintBilling$LegacyPricing$viewPopover = function (feePlan) {
	return A3(
		$author$project$Ui$Popover$view,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$Icon$help(_List_Nil)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Popover$heading,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Transaction Fees')
					])),
				A2(
				$author$project$Ui$Popover$body,
				_List_Nil,
				$author$project$Components$HintBilling$LegacyPricing$viewFeeBreakdown(feePlan))
			]));
};
var $author$project$Components$HintBilling$LegacyPricing$view = F4(
	function (currentDate, feePlan, pmpmFee, charges) {
		var popoverView = $author$project$Components$HintBilling$LegacyPricing$viewPopover(feePlan);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanMd(6)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Typography$headingSm(
									_List_fromArray(
										[
											$elm$html$Html$text('Hint Pricing'),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-sm')
												]),
											_List_fromArray(
												[popoverView]))
										]))
								]))
						])),
				A4($author$project$Components$HintBilling$LegacyPricing$viewLegacyPricingInformation, feePlan, pmpmFee, currentDate, charges)));
	});
var $author$project$Pages$Admin$Billing$viewBillingSection = F3(
	function (applicationFeePlan, practicePricingData, currentDate) {
		return A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			function () {
				var _v0 = _Utils_Tuple2(applicationFeePlan, practicePricingData);
				if ((_v0.a.$ === 3) && (_v0.b.$ === 3)) {
					var _v1 = _v0.a;
					var feePlan = _v1.a;
					var _v2 = _v0.b;
					var practicePricing = _v2.a;
					return $author$project$Api$Provider$PracticePricing$One$isLegacyPricing(practicePricing) ? _List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(10)
								]),
							_List_fromArray(
								[
									A4(
									$author$project$Components$HintBilling$LegacyPricing$view,
									currentDate,
									feePlan,
									$author$project$Api$Provider$PracticePricing$One$pmpmFeeInCents(practicePricing),
									$author$project$Api$Provider$PracticePricing$One$billableProducts(practicePricing))
								]))
						]) : _List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_Nil,
							_List_fromArray(
								[$author$project$Utils$Html$empty]))
						]);
				} else {
					return _List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_Nil,
							_List_fromArray(
								[$author$project$Components$HintBilling$NextBill$skeleton]))
						]);
				}
			}());
	});
var $author$project$Pages$Admin$Billing$viewCapitalPromoTile = F3(
	function (practice, capitalSession, capitalProductType) {
		if (capitalSession.$ === 3) {
			if ($author$project$Pages$Admin$Billing$shouldShowCapitalTile(practice)) {
				var isEligible = function () {
					if (!capitalProductType.$) {
						var productType = capitalProductType.a;
						return productType !== 'none';
					} else {
						return false;
					}
				}();
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id('stripe-capital-promo-tile'),
							$elm$html$Html$Attributes$class(
							isEligible ? 'mb-4 rounded-lg shadow-card surface-base border-l-4 border-primary p-4' : 'hidden')
						]),
					_List_Nil);
			} else {
				return $elm$html$Html$text('');
			}
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Ui$Icon$Alert = 5;
var $author$project$Ui$Alert$Icon = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Alert$icon = $author$project$Ui$Alert$Icon;
var $author$project$Api$Provider$PracticePricing$One$infoMessageBody = function (_v0) {
	var record = _v0;
	return record.T_;
};
var $author$project$Api$Provider$PracticePricing$One$infoMessageTitle = function (_v0) {
	var record = _v0;
	return record.T$;
};
var $elm$html$Html$h5 = _VirtualDom_node('h5');
var $author$project$Ui$Typography$title = F2(
	function (options, content) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$never,
			A2(
				$elm$html$Html$h5,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('text-title-md text-main'),
					$author$project$Ui$Typography$optionsToAttributes(options)),
				content));
	});
var $author$project$Pages$Admin$Billing$viewInfoMessage = function (practicePricingData) {
	if (practicePricingData.$ === 3) {
		var practicePricing = practicePricingData.a;
		var maybeTitle = $author$project$Api$Provider$PracticePricing$One$infoMessageTitle(practicePricing);
		if (!maybeTitle.$) {
			var infoMessageTitle = maybeTitle.a;
			var infoMessageBody = A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Api$Provider$PracticePricing$One$infoMessageBody(practicePricing));
			return A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Alert$info,
						_List_fromArray(
							[
								$author$project$Ui$Alert$icon(5),
								$author$project$Ui$Alert$alignment($author$project$Ui$Alignment$textLeft)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$title,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(infoMessageTitle)
									])),
								A2(
								$author$project$Ui$Element$prose,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(infoMessageBody)
									]))
							])),
						A2($elm$html$Html$br, _List_Nil, _List_Nil)
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Api$Source$BankAccount = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$BankAccount$ProviderAll = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$BankAccount$One$defaults = function (_v0) {
	var record = _v0.b;
	return record.Qg;
};
var $author$project$Api$Provider$BankAccount$All$defaults = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BankAccount$One$defaults(one);
};
var $author$project$Api$Provider$Source$Defaults$hintCustomer = function (_v0) {
	var record = _v0;
	return record.Tx;
};
var $author$project$Api$Source$defaultPracticeBankAccount = function (bankAccounts) {
	return A2(
		$elm$core$Maybe$map,
		$author$project$Api$Source$BankAccount,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$BankAccount$ProviderAll,
			A2(
				$elm_community$list_extra$List$Extra$find,
				function (bankAccount) {
					return A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$map,
							$author$project$Api$Provider$Source$Defaults$hintCustomer,
							$author$project$Api$Provider$BankAccount$All$defaults(bankAccount)));
				},
				bankAccounts)));
};
var $author$project$Api$Source$Card = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Card$ProviderAll = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Card$One$defaults = function (_v0) {
	var record = _v0.b;
	return record.Qg;
};
var $author$project$Api$Provider$Card$All$defaults = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Card$One$defaults(one);
};
var $author$project$Api$Source$defaultPracticeCard = function (cards) {
	return A2(
		$elm$core$Maybe$map,
		$author$project$Api$Source$Card,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Card$ProviderAll,
			A2(
				$elm_community$list_extra$List$Extra$find,
				function (card) {
					return A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$map,
							$author$project$Api$Provider$Source$Defaults$hintCustomer,
							$author$project$Api$Provider$Card$All$defaults(card)));
				},
				cards)));
};
var $author$project$Api$Source$defaultPracticeSource = F2(
	function (cards, bankAccounts) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						$author$project$Api$Source$defaultPracticeCard(cards),
						$author$project$Api$Source$defaultPracticeBankAccount(bankAccounts)
					])));
	});
var $author$project$Ui$Typography$HelpBlock = {$: 7};
var $author$project$Ui$Typography$helpBlock = $author$project$Ui$Typography$HelpBlock;
var $author$project$Components$PaymentSourceDisplayer$LimitedView = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$PaymentSourceDisplayer$limitedView = $author$project$Components$PaymentSourceDisplayer$LimitedView;
var $author$project$Components$PaymentSourceDisplayer$NoPaymentMethodStatus = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus = $author$project$Components$PaymentSourceDisplayer$NoPaymentMethodStatus;
var $author$project$Components$PaymentSourceDisplayer$Source = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$PaymentSourceDisplayer$source = $author$project$Components$PaymentSourceDisplayer$Source;
var $author$project$Api$Provider$BankAccount$Shared$assignedMemberships = function (_v0) {
	var record = _v0;
	return record.L1;
};
var $author$project$Api$Provider$BankAccount$One$assignedMemberships = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BankAccount$Shared$assignedMemberships(shared);
};
var $author$project$Api$Provider$BankAccount$All$assignedMemberships = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BankAccount$One$assignedMemberships(one);
};
var $author$project$Api$BankAccount$assignedMemberships = function (bankAccount) {
	switch (bankAccount.$) {
		case 0:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$One$assignedMemberships(bankAccount_);
		case 1:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$All$assignedMemberships(bankAccount_);
		case 2:
			return _List_Nil;
		default:
			return _List_Nil;
	}
};
var $author$project$Api$Provider$Card$Shared$assignedMemberships = function (_v0) {
	var record = _v0;
	return record.L1;
};
var $author$project$Api$Provider$Card$One$assignedMemberships = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Card$Shared$assignedMemberships(shared);
};
var $author$project$Api$Provider$Card$All$assignedMemberships = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Card$One$assignedMemberships(one);
};
var $author$project$Api$Card$assignedMemberships = function (card) {
	switch (card.$) {
		case 0:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$One$assignedMemberships(card_);
		case 1:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$All$assignedMemberships(card_);
		case 2:
			return _List_Nil;
		default:
			return _List_Nil;
	}
};
var $author$project$Api$Source$assignedMemberships = function (source) {
	switch (source.$) {
		case 0:
			var card = source.a;
			return $author$project$Api$Card$assignedMemberships(card);
		case 1:
			var bankAccount = source.a;
			return $author$project$Api$BankAccount$assignedMemberships(bankAccount);
		default:
			return _List_Nil;
	}
};
var $author$project$Api$Provider$StripePaymentMethodMigration$All$createdAt = function (_v0) {
	var record = _v0;
	return record.O1;
};
var $author$project$Api$Employer$BankAccount$Shared$createdAt = function (_v0) {
	var record = _v0;
	return record.O1;
};
var $author$project$Api$Employer$BankAccount$One$createdAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$BankAccount$Shared$createdAt(shared);
};
var $author$project$Api$Employer$BankAccount$All$createdAt = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$BankAccount$One$createdAt(one);
};
var $author$project$Api$Provider$BankAccount$Shared$createdAt = function (_v0) {
	var record = _v0;
	return record.O1;
};
var $author$project$Api$Provider$BankAccount$One$createdAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BankAccount$Shared$createdAt(shared);
};
var $author$project$Api$Provider$BankAccount$All$createdAt = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BankAccount$One$createdAt(one);
};
var $author$project$Api$BankAccount$createdAt = function (bankAccount) {
	switch (bankAccount.$) {
		case 0:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$One$createdAt(bankAccount_);
		case 1:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$All$createdAt(bankAccount_);
		case 2:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$One$createdAt(bankAccount_);
		default:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$All$createdAt(bankAccount_);
	}
};
var $author$project$Api$Employer$Card$Shared$createdAt = function (_v0) {
	var record = _v0;
	return record.O1;
};
var $author$project$Api$Employer$Card$One$createdAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Card$Shared$createdAt(shared);
};
var $author$project$Api$Employer$Card$All$createdAt = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$Card$One$createdAt(one);
};
var $author$project$Api$Provider$Card$Shared$createdAt = function (_v0) {
	var record = _v0;
	return record.O1;
};
var $author$project$Api$Provider$Card$One$createdAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Card$Shared$createdAt(shared);
};
var $author$project$Api$Provider$Card$All$createdAt = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Card$One$createdAt(one);
};
var $author$project$Api$Card$createdAt = function (card) {
	switch (card.$) {
		case 0:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$One$createdAt(card_);
		case 1:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$All$createdAt(card_);
		case 2:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$One$createdAt(card_);
		default:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$All$createdAt(card_);
	}
};
var $author$project$Api$Common$Source$Shared$createdAt = function (_v0) {
	var record = _v0;
	return record.O1;
};
var $author$project$Api$Source$createdAt = function (source) {
	switch (source.$) {
		case 0:
			var card = source.a;
			return $elm$core$Maybe$Just(
				$author$project$Api$Card$createdAt(card));
		case 1:
			var bankAccount = source.a;
			return $elm$core$Maybe$Just(
				$author$project$Api$BankAccount$createdAt(bankAccount));
		default:
			var source_ = source.a;
			return $author$project$Api$Common$Source$Shared$createdAt(source_);
	}
};
var $author$project$Api$Provider$StripePaymentMethodMigration$All$createdByName = function (_v0) {
	var record = _v0;
	return record.O3;
};
var $author$project$Api$Provider$BankAccount$Shared$createdByName = function (_v0) {
	var record = _v0;
	return record.O3;
};
var $author$project$Api$Provider$BankAccount$One$createdByName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BankAccount$Shared$createdByName(shared);
};
var $author$project$Api$Provider$BankAccount$All$createdByName = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BankAccount$One$createdByName(one);
};
var $author$project$Api$BankAccount$createdByName = function (bankAccount) {
	switch (bankAccount.$) {
		case 0:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$One$createdByName(bankAccount_);
		case 1:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$All$createdByName(bankAccount_);
		case 2:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$Card$Shared$createdByName = function (_v0) {
	var record = _v0;
	return record.O3;
};
var $author$project$Api$Provider$Card$One$createdByName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Card$Shared$createdByName(shared);
};
var $author$project$Api$Provider$Card$All$createdByName = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Card$One$createdByName(one);
};
var $author$project$Api$Card$createdByName = function (card) {
	switch (card.$) {
		case 0:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$One$createdByName(card_);
		case 1:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$All$createdByName(card_);
		case 2:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Source$createdByName = function (source) {
	switch (source.$) {
		case 0:
			var card = source.a;
			return $author$project$Api$Card$createdByName(card);
		case 1:
			var bankAccount = source.a;
			return $author$project$Api$BankAccount$createdByName(bankAccount);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$StripePaymentMethodMigration$All$createdVia = function (_v0) {
	var record = _v0;
	return record.O4;
};
var $author$project$Api$Provider$BankAccount$Shared$createdVia = function (_v0) {
	var record = _v0;
	return record.O4;
};
var $author$project$Api$Provider$BankAccount$One$createdVia = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BankAccount$Shared$createdVia(shared);
};
var $author$project$Api$Provider$BankAccount$All$createdVia = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BankAccount$One$createdVia(one);
};
var $author$project$Api$BankAccount$createdVia = function (bankAccount) {
	switch (bankAccount.$) {
		case 0:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$One$createdVia(bankAccount_);
		case 1:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$All$createdVia(bankAccount_);
		case 2:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$Card$Shared$createdVia = function (_v0) {
	var record = _v0;
	return record.O4;
};
var $author$project$Api$Provider$Card$One$createdVia = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Card$Shared$createdVia(shared);
};
var $author$project$Api$Provider$Card$All$createdVia = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Card$One$createdVia(one);
};
var $author$project$Api$Card$createdVia = function (card) {
	switch (card.$) {
		case 0:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$One$createdVia(card_);
		case 1:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$All$createdVia(card_);
		case 2:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Source$createdVia = function (source) {
	switch (source.$) {
		case 0:
			var card = source.a;
			return $author$project$Api$Card$createdVia(card);
		case 1:
			var bankAccount = source.a;
			return $author$project$Api$BankAccount$createdVia(bankAccount);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$StripePaymentMethodMigration$All$errorMessage = function (_v0) {
	var record = _v0;
	return record.RM;
};
var $author$project$Api$Employer$BankAccount$Shared$errorMessage = function (_v0) {
	var record = _v0;
	return record.RM;
};
var $author$project$Api$Employer$BankAccount$One$errorMessage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$BankAccount$Shared$errorMessage(shared);
};
var $author$project$Api$Employer$BankAccount$All$errorMessage = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$BankAccount$One$errorMessage(one);
};
var $author$project$Api$Provider$BankAccount$Shared$errorMessage = function (_v0) {
	var record = _v0;
	return record.RM;
};
var $author$project$Api$Provider$BankAccount$One$errorMessage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BankAccount$Shared$errorMessage(shared);
};
var $author$project$Api$Provider$BankAccount$All$errorMessage = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BankAccount$One$errorMessage(one);
};
var $author$project$Api$BankAccount$errorMessage = function (bankAccount) {
	switch (bankAccount.$) {
		case 0:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$One$errorMessage(bankAccount_);
		case 1:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$All$errorMessage(bankAccount_);
		case 2:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$One$errorMessage(bankAccount_);
		default:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$All$errorMessage(bankAccount_);
	}
};
var $author$project$Api$Employer$Card$Shared$errorMessage = function (_v0) {
	var record = _v0;
	return record.RM;
};
var $author$project$Api$Employer$Card$One$errorMessage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Card$Shared$errorMessage(shared);
};
var $author$project$Api$Employer$Card$All$errorMessage = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$Card$One$errorMessage(one);
};
var $author$project$Api$Provider$Card$Shared$errorMessage = function (_v0) {
	var record = _v0;
	return record.RM;
};
var $author$project$Api$Provider$Card$One$errorMessage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Card$Shared$errorMessage(shared);
};
var $author$project$Api$Provider$Card$All$errorMessage = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Card$One$errorMessage(one);
};
var $author$project$Api$Card$errorMessage = function (card) {
	switch (card.$) {
		case 0:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$One$errorMessage(card_);
		case 1:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$All$errorMessage(card_);
		case 2:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$One$errorMessage(card_);
		default:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$All$errorMessage(card_);
	}
};
var $author$project$Api$Source$errorMessage = function (source) {
	switch (source.$) {
		case 0:
			var card = source.a;
			return $author$project$Api$Card$errorMessage(card);
		case 1:
			var bankAccount = source.a;
			return $author$project$Api$BankAccount$errorMessage(bankAccount);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$StripePaymentMethodMigration$All$expMonth = function (_v0) {
	var record = _v0;
	return record.ag3;
};
var $author$project$Api$Employer$Card$Shared$expMonth = function (_v0) {
	var record = _v0;
	return record.ag3;
};
var $author$project$Api$Employer$Card$One$expMonth = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Card$Shared$expMonth(shared);
};
var $author$project$Api$Employer$Card$All$expMonth = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$Card$One$expMonth(one);
};
var $author$project$Api$Provider$Card$Shared$expMonth = function (_v0) {
	var record = _v0;
	return record.ag3;
};
var $author$project$Api$Provider$Card$One$expMonth = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Card$Shared$expMonth(shared);
};
var $author$project$Api$Provider$Card$All$expMonth = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Card$One$expMonth(one);
};
var $author$project$Api$Card$expMonth = function (card) {
	switch (card.$) {
		case 0:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$One$expMonth(card_);
		case 1:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$All$expMonth(card_);
		case 2:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$One$expMonth(card_);
		default:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$All$expMonth(card_);
	}
};
var $author$project$Api$Source$expMonth = function (source) {
	switch (source.$) {
		case 0:
			var card = source.a;
			return $author$project$Api$Card$expMonth(card);
		case 1:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$StripePaymentMethodMigration$All$expYear = function (_v0) {
	var record = _v0;
	return record.ag4;
};
var $author$project$Api$Employer$Card$Shared$expYear = function (_v0) {
	var record = _v0;
	return record.ag4;
};
var $author$project$Api$Employer$Card$One$expYear = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Card$Shared$expYear(shared);
};
var $author$project$Api$Employer$Card$All$expYear = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$Card$One$expYear(one);
};
var $author$project$Api$Provider$Card$Shared$expYear = function (_v0) {
	var record = _v0;
	return record.ag4;
};
var $author$project$Api$Provider$Card$One$expYear = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Card$Shared$expYear(shared);
};
var $author$project$Api$Provider$Card$All$expYear = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Card$One$expYear(one);
};
var $author$project$Api$Card$expYear = function (card) {
	switch (card.$) {
		case 0:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$One$expYear(card_);
		case 1:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$All$expYear(card_);
		case 2:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$One$expYear(card_);
		default:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$All$expYear(card_);
	}
};
var $author$project$Api$Source$expYear = function (source) {
	switch (source.$) {
		case 0:
			var card = source.a;
			return $author$project$Api$Card$expYear(card);
		case 1:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$StripePaymentMethodMigration$All$funding = function (_v0) {
	var record = _v0;
	return record.SN;
};
var $author$project$Api$Provider$Card$Shared$funding = function (_v0) {
	var record = _v0;
	return record.SN;
};
var $author$project$Api$Provider$Card$One$funding = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Card$Shared$funding(shared);
};
var $author$project$Api$Provider$Card$All$funding = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Card$One$funding(one);
};
var $author$project$Api$Card$funding = function (card) {
	switch (card.$) {
		case 0:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$One$funding(card_);
		case 1:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$All$funding(card_);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Common$Source$Shared$funding = function (_v0) {
	var record = _v0;
	return record.SN;
};
var $author$project$Api$Source$funding = function (source) {
	switch (source.$) {
		case 0:
			var card = source.a;
			return $author$project$Api$Card$funding(card);
		case 1:
			return $elm$core$Maybe$Nothing;
		default:
			var source_ = source.a;
			return $author$project$Api$Common$Source$Shared$funding(source_);
	}
};
var $author$project$Api$Provider$StripePaymentMethodMigration$All$label = function (_v0) {
	var record = _v0;
	return record.aih;
};
var $author$project$Api$Employer$BankAccount$Shared$label = function (_v0) {
	var record = _v0;
	return record.aih;
};
var $author$project$Api$Employer$BankAccount$One$label = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$BankAccount$Shared$label(shared);
};
var $author$project$Api$Employer$BankAccount$All$label = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$BankAccount$One$label(one);
};
var $author$project$Api$Provider$BankAccount$Shared$label = function (_v0) {
	var record = _v0;
	return record.aih;
};
var $author$project$Api$Provider$BankAccount$One$label = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BankAccount$Shared$label(shared);
};
var $author$project$Api$Provider$BankAccount$All$label = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BankAccount$One$label(one);
};
var $author$project$Api$BankAccount$label = function (bankAccount) {
	switch (bankAccount.$) {
		case 0:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$One$label(bankAccount_);
		case 1:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$All$label(bankAccount_);
		case 2:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$One$label(bankAccount_);
		default:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$All$label(bankAccount_);
	}
};
var $author$project$Api$Employer$Card$Shared$label = function (_v0) {
	var record = _v0;
	return record.aih;
};
var $author$project$Api$Employer$Card$One$label = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Card$Shared$label(shared);
};
var $author$project$Api$Employer$Card$All$label = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$Card$One$label(one);
};
var $author$project$Api$Provider$Card$Shared$label = function (_v0) {
	var record = _v0;
	return record.aih;
};
var $author$project$Api$Provider$Card$One$label = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Card$Shared$label(shared);
};
var $author$project$Api$Provider$Card$All$label = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Card$One$label(one);
};
var $author$project$Api$Card$label = function (card) {
	switch (card.$) {
		case 0:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$One$label(card_);
		case 1:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$All$label(card_);
		case 2:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$One$label(card_);
		default:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$All$label(card_);
	}
};
var $author$project$Api$Common$Source$Shared$label = function (_v0) {
	var record = _v0;
	return record.aih;
};
var $author$project$Api$Source$label = function (source) {
	switch (source.$) {
		case 0:
			var card = source.a;
			return $author$project$Api$Card$label(card);
		case 1:
			var bankAccount = source.a;
			return $author$project$Api$BankAccount$label(bankAccount);
		default:
			var source_ = source.a;
			return $author$project$Api$Common$Source$Shared$label(source_);
	}
};
var $author$project$Api$Provider$StripePaymentMethodMigration$All$lastFour = function (_v0) {
	var record = _v0;
	return record.VG;
};
var $author$project$Api$Employer$BankAccount$Shared$lastFour = function (_v0) {
	var record = _v0;
	return record.VG;
};
var $author$project$Api$Employer$BankAccount$One$lastFour = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$BankAccount$Shared$lastFour(shared);
};
var $author$project$Api$Employer$BankAccount$All$lastFour = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$BankAccount$One$lastFour(one);
};
var $author$project$Api$Provider$BankAccount$Shared$lastFour = function (_v0) {
	var record = _v0;
	return record.VG;
};
var $author$project$Api$Provider$BankAccount$One$lastFour = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BankAccount$Shared$lastFour(shared);
};
var $author$project$Api$Provider$BankAccount$All$lastFour = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BankAccount$One$lastFour(one);
};
var $author$project$Api$BankAccount$lastFour = function (bankAccount) {
	switch (bankAccount.$) {
		case 0:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$One$lastFour(bankAccount_);
		case 1:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$All$lastFour(bankAccount_);
		case 2:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$One$lastFour(bankAccount_);
		default:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$All$lastFour(bankAccount_);
	}
};
var $author$project$Api$Employer$Card$Shared$lastFour = function (_v0) {
	var record = _v0;
	return record.VG;
};
var $author$project$Api$Employer$Card$One$lastFour = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Card$Shared$lastFour(shared);
};
var $author$project$Api$Employer$Card$All$lastFour = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$Card$One$lastFour(one);
};
var $author$project$Api$Provider$Card$Shared$lastFour = function (_v0) {
	var record = _v0;
	return record.VG;
};
var $author$project$Api$Provider$Card$One$lastFour = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Card$Shared$lastFour(shared);
};
var $author$project$Api$Provider$Card$All$lastFour = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Card$One$lastFour(one);
};
var $author$project$Api$Card$lastFour = function (card) {
	switch (card.$) {
		case 0:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$One$lastFour(card_);
		case 1:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$All$lastFour(card_);
		case 2:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$One$lastFour(card_);
		default:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$All$lastFour(card_);
	}
};
var $author$project$Api$Common$Source$Shared$lastFour = function (_v0) {
	var record = _v0;
	return record.VG;
};
var $author$project$Api$Source$lastFour = function (source) {
	switch (source.$) {
		case 0:
			var card = source.a;
			return $author$project$Api$Card$lastFour(card);
		case 1:
			var bankAccount = source.a;
			return $author$project$Api$BankAccount$lastFour(bankAccount);
		default:
			var source_ = source.a;
			return $author$project$Api$Common$Source$Shared$lastFour(source_);
	}
};
var $author$project$Api$Provider$StripePaymentMethodMigration$All$lastPaymentErrorMessage = function (_v0) {
	var record = _v0;
	return record.VI;
};
var $author$project$Api$Employer$BankAccount$Shared$lastPaymentErrorMessage = function (_v0) {
	var record = _v0;
	return record.VI;
};
var $author$project$Api$Employer$BankAccount$One$lastPaymentErrorMessage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$BankAccount$Shared$lastPaymentErrorMessage(shared);
};
var $author$project$Api$Employer$BankAccount$All$lastPaymentErrorMessage = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$BankAccount$One$lastPaymentErrorMessage(one);
};
var $author$project$Api$Provider$BankAccount$Shared$lastPaymentErrorMessage = function (_v0) {
	var record = _v0;
	return record.VI;
};
var $author$project$Api$Provider$BankAccount$One$lastPaymentErrorMessage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BankAccount$Shared$lastPaymentErrorMessage(shared);
};
var $author$project$Api$Provider$BankAccount$All$lastPaymentErrorMessage = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BankAccount$One$lastPaymentErrorMessage(one);
};
var $author$project$Api$BankAccount$lastPaymentErrorMessage = function (bankAccount) {
	switch (bankAccount.$) {
		case 0:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$One$lastPaymentErrorMessage(bankAccount_);
		case 1:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$All$lastPaymentErrorMessage(bankAccount_);
		case 2:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$One$lastPaymentErrorMessage(bankAccount_);
		default:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$All$lastPaymentErrorMessage(bankAccount_);
	}
};
var $author$project$Api$Employer$Card$Shared$lastPaymentErrorMessage = function (_v0) {
	var record = _v0;
	return record.VI;
};
var $author$project$Api$Employer$Card$One$lastPaymentErrorMessage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Card$Shared$lastPaymentErrorMessage(shared);
};
var $author$project$Api$Employer$Card$All$lastPaymentErrorMessage = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$Card$One$lastPaymentErrorMessage(one);
};
var $author$project$Api$Provider$Card$Shared$lastPaymentErrorMessage = function (_v0) {
	var record = _v0;
	return record.VI;
};
var $author$project$Api$Provider$Card$One$lastPaymentErrorMessage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Card$Shared$lastPaymentErrorMessage(shared);
};
var $author$project$Api$Provider$Card$All$lastPaymentErrorMessage = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Card$One$lastPaymentErrorMessage(one);
};
var $author$project$Api$Card$lastPaymentErrorMessage = function (card) {
	switch (card.$) {
		case 0:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$One$lastPaymentErrorMessage(card_);
		case 1:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$All$lastPaymentErrorMessage(card_);
		case 2:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$One$lastPaymentErrorMessage(card_);
		default:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$All$lastPaymentErrorMessage(card_);
	}
};
var $author$project$Api$Source$lastPaymentErrorMessage = function (source) {
	switch (source.$) {
		case 0:
			var card = source.a;
			return $author$project$Api$Card$lastPaymentErrorMessage(card);
		case 1:
			var bankAccount = source.a;
			return $author$project$Api$BankAccount$lastPaymentErrorMessage(bankAccount);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$StripePaymentMethodMigration$All$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Employer$BankAccount$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Employer$BankAccount$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$BankAccount$Shared$name(shared);
};
var $author$project$Api$Employer$BankAccount$All$name = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$BankAccount$One$name(one);
};
var $author$project$Api$Provider$BankAccount$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$BankAccount$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BankAccount$Shared$name(shared);
};
var $author$project$Api$Provider$BankAccount$All$name = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BankAccount$One$name(one);
};
var $author$project$Api$BankAccount$name = function (bankAccount) {
	switch (bankAccount.$) {
		case 0:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$One$name(bankAccount_);
		case 1:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$All$name(bankAccount_);
		case 2:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$One$name(bankAccount_);
		default:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$All$name(bankAccount_);
	}
};
var $author$project$Api$Employer$Card$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Employer$Card$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Card$Shared$name(shared);
};
var $author$project$Api$Employer$Card$All$name = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$Card$One$name(one);
};
var $author$project$Api$Provider$Card$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$Card$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Card$Shared$name(shared);
};
var $author$project$Api$Provider$Card$All$name = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Card$One$name(one);
};
var $author$project$Api$Card$name = function (card) {
	switch (card.$) {
		case 0:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$One$name(card_);
		case 1:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$All$name(card_);
		case 2:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$One$name(card_);
		default:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$All$name(card_);
	}
};
var $author$project$Api$Common$Source$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Source$name = function (source) {
	switch (source.$) {
		case 0:
			var card = source.a;
			return $author$project$Api$Card$name(card);
		case 1:
			var bankAccount = source.a;
			return $author$project$Api$BankAccount$name(bankAccount);
		default:
			var source_ = source.a;
			return $author$project$Api$Common$Source$Shared$name(source_);
	}
};
var $author$project$Components$PaymentSourceDisplayer$defaultOptions = {aft: $elm$core$Maybe$Nothing, AC: false, BN: false, YZ: $elm$core$Maybe$Nothing, Zd: $elm$core$Maybe$Nothing, Ez: false, alv: false, JQ: $elm$core$Maybe$Nothing, ER: $elm$core$Maybe$Nothing};
var $author$project$Components$PaymentSourceDisplayer$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var source_ = option.a;
						return _Utils_update(
							record,
							{JQ: source_});
					case 1:
						var cardReader_ = option.a;
						return _Utils_update(
							record,
							{aft: cardReader_});
					case 2:
						var bool = option.a;
						return _Utils_update(
							record,
							{AC: bool});
					case 3:
						var bool = option.a;
						return _Utils_update(
							record,
							{BN: bool});
					case 4:
						var bool = option.a;
						return _Utils_update(
							record,
							{alv: bool});
					case 5:
						var processor = option.a;
						return _Utils_update(
							record,
							{
								Zd: $elm$core$Maybe$Just(processor)
							});
					case 6:
						var stripePaymentMethodMigration_ = option.a;
						return _Utils_update(
							record,
							{
								ER: $elm$core$Maybe$Just(stripePaymentMethodMigration_)
							});
					case 7:
						var bool = option.a;
						return _Utils_update(
							record,
							{Ez: bool});
					default:
						var patientId_ = option.a;
						return _Utils_update(
							record,
							{YZ: patientId_});
				}
			}),
		$author$project$Components$PaymentSourceDisplayer$defaultOptions,
		options);
};
var $author$project$Api$Provider$StripePaymentMethodMigration$All$paymentProcessor = function (_v0) {
	var record = _v0;
	return record.Zd;
};
var $author$project$Api$Employer$BankAccount$Shared$paymentProcessor = function (_v0) {
	var record = _v0;
	return record.Zd;
};
var $author$project$Api$Employer$BankAccount$One$paymentProcessor = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$BankAccount$Shared$paymentProcessor(shared);
};
var $author$project$Api$Employer$BankAccount$All$paymentProcessor = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$BankAccount$One$paymentProcessor(one);
};
var $author$project$Api$Provider$BankAccount$Shared$paymentProcessor = function (_v0) {
	var record = _v0;
	return record.Zd;
};
var $author$project$Api$Provider$BankAccount$One$paymentProcessor = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BankAccount$Shared$paymentProcessor(shared);
};
var $author$project$Api$Provider$BankAccount$All$paymentProcessor = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BankAccount$One$paymentProcessor(one);
};
var $author$project$Api$BankAccount$paymentProcessor = function (bankAccount) {
	switch (bankAccount.$) {
		case 0:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$One$paymentProcessor(bankAccount_);
		case 1:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$All$paymentProcessor(bankAccount_);
		case 2:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$One$paymentProcessor(bankAccount_);
		default:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$All$paymentProcessor(bankAccount_);
	}
};
var $author$project$Api$Employer$Card$Shared$paymentProcessor = function (_v0) {
	var record = _v0;
	return record.Zd;
};
var $author$project$Api$Employer$Card$One$paymentProcessor = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Card$Shared$paymentProcessor(shared);
};
var $author$project$Api$Employer$Card$All$paymentProcessor = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$Card$One$paymentProcessor(one);
};
var $author$project$Api$Provider$Card$Shared$paymentProcessor = function (_v0) {
	var record = _v0;
	return record.Zd;
};
var $author$project$Api$Provider$Card$One$paymentProcessor = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Card$Shared$paymentProcessor(shared);
};
var $author$project$Api$Provider$Card$All$paymentProcessor = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Card$One$paymentProcessor(one);
};
var $author$project$Api$Card$paymentProcessor = function (card) {
	switch (card.$) {
		case 0:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$One$paymentProcessor(card_);
		case 1:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$All$paymentProcessor(card_);
		case 2:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$One$paymentProcessor(card_);
		default:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$All$paymentProcessor(card_);
	}
};
var $author$project$Api$Common$Source$Shared$paymentProcessor = function (_v0) {
	var record = _v0;
	return record.Zd;
};
var $author$project$Api$Source$paymentProcessor = function (source) {
	switch (source.$) {
		case 0:
			var card = source.a;
			return $author$project$Api$Card$paymentProcessor(card);
		case 1:
			var bankAccount = source.a;
			return $author$project$Api$BankAccount$paymentProcessor(bankAccount);
		default:
			var source_ = source.a;
			return $author$project$Api$Common$Source$Shared$paymentProcessor(source_);
	}
};
var $author$project$Api$Provider$StripePaymentMethodMigration$All$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Api$Employer$BankAccount$Shared$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Api$Employer$BankAccount$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$BankAccount$Shared$status(shared);
};
var $author$project$Api$Employer$BankAccount$All$status = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$BankAccount$One$status(one);
};
var $author$project$Api$Provider$BankAccount$Shared$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Api$Provider$BankAccount$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BankAccount$Shared$status(shared);
};
var $author$project$Api$Provider$BankAccount$All$status = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BankAccount$One$status(one);
};
var $author$project$Api$BankAccount$status = function (bankAccount) {
	switch (bankAccount.$) {
		case 0:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$One$status(bankAccount_);
		case 1:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$All$status(bankAccount_);
		case 2:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$One$status(bankAccount_);
		default:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$All$status(bankAccount_);
	}
};
var $author$project$Api$Employer$Card$Shared$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Api$Employer$Card$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Card$Shared$status(shared);
};
var $author$project$Api$Employer$Card$All$status = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$Card$One$status(one);
};
var $author$project$Api$Provider$Card$Shared$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Api$Provider$Card$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Card$Shared$status(shared);
};
var $author$project$Api$Provider$Card$All$status = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Card$One$status(one);
};
var $author$project$Api$Card$status = function (card) {
	switch (card.$) {
		case 0:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$One$status(card_);
		case 1:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$All$status(card_);
		case 2:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$One$status(card_);
		default:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$All$status(card_);
	}
};
var $author$project$Api$Common$Source$Shared$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Api$Source$status = function (source) {
	switch (source.$) {
		case 0:
			var card = source.a;
			return $elm$core$Maybe$Just(
				$author$project$Api$Card$status(card));
		case 1:
			var bankAccount = source.a;
			return $elm$core$Maybe$Just(
				$author$project$Api$BankAccount$status(bankAccount));
		default:
			var source_ = source.a;
			return $author$project$Api$Common$Source$Shared$status(source_);
	}
};
var $author$project$Api$Provider$StripePaymentMethodMigration$All$type_ = function (_v0) {
	var record = _v0;
	return record.amg;
};
var $author$project$Api$Employer$BankAccount$Shared$type_ = function (_v0) {
	var record = _v0;
	return record.amg;
};
var $author$project$Api$Employer$BankAccount$One$type_ = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$BankAccount$Shared$type_(shared);
};
var $author$project$Api$Employer$BankAccount$All$type_ = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$BankAccount$One$type_(one);
};
var $author$project$Api$Provider$BankAccount$Shared$type_ = function (_v0) {
	var record = _v0;
	return record.amg;
};
var $author$project$Api$Provider$BankAccount$One$type_ = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BankAccount$Shared$type_(shared);
};
var $author$project$Api$Provider$BankAccount$All$type_ = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BankAccount$One$type_(one);
};
var $author$project$Api$BankAccount$type_ = function (bankAccount) {
	switch (bankAccount.$) {
		case 0:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$One$type_(bankAccount_);
		case 1:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$All$type_(bankAccount_);
		case 2:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$One$type_(bankAccount_);
		default:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$All$type_(bankAccount_);
	}
};
var $author$project$Api$Employer$Card$Shared$type_ = function (_v0) {
	var record = _v0;
	return record.amg;
};
var $author$project$Api$Employer$Card$One$type_ = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Card$Shared$type_(shared);
};
var $author$project$Api$Employer$Card$All$type_ = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$Card$One$type_(one);
};
var $author$project$Api$Provider$Card$Shared$type_ = function (_v0) {
	var record = _v0;
	return record.amg;
};
var $author$project$Api$Provider$Card$One$type_ = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Card$Shared$type_(shared);
};
var $author$project$Api$Provider$Card$All$type_ = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Card$One$type_(one);
};
var $author$project$Api$Card$type_ = function (card) {
	switch (card.$) {
		case 0:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$One$type_(card_);
		case 1:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$All$type_(card_);
		case 2:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$One$type_(card_);
		default:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$All$type_(card_);
	}
};
var $author$project$Api$Common$Source$Shared$type_ = function (_v0) {
	var record = _v0;
	return record.amg;
};
var $author$project$Api$Source$type_ = function (source) {
	switch (source.$) {
		case 0:
			var card = source.a;
			return $author$project$Api$Card$type_(card);
		case 1:
			var bankAccount = source.a;
			return $author$project$Api$BankAccount$type_(bankAccount);
		default:
			var source_ = source.a;
			return $author$project$Api$Common$Source$Shared$type_(source_);
	}
};
var $author$project$Api$Provider$CardReader$Shared$label = function (_v0) {
	var record = _v0;
	return record.aih;
};
var $author$project$Api$CardReader$Shared$label = function (cardReader) {
	var providerShared = cardReader;
	return $author$project$Api$Provider$CardReader$Shared$label(providerShared);
};
var $author$project$Api$Provider$CardReader$Shared$paymentProcessor = function (_v0) {
	var record = _v0;
	return record.Zd;
};
var $author$project$Api$CardReader$Shared$paymentProcessor = function (cardReader) {
	var providerShared = cardReader;
	return $author$project$Api$Provider$CardReader$Shared$paymentProcessor(providerShared);
};
var $elm_community$string_extra$String$Extra$regexFromString = A2(
	$elm$core$Basics$composeR,
	$elm$regex$Regex$fromString,
	$elm$core$Maybe$withDefault($elm$regex$Regex$never));
var $elm_community$string_extra$String$Extra$changeCase = F2(
	function (mutator, word) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					var head = _v0.a;
					var tail = _v0.b;
					return A2(
						$elm$core$String$cons,
						mutator(head),
						tail);
				},
				$elm$core$String$uncons(word)));
	});
var $elm$core$Char$toUpper = _Char_toUpper;
var $elm_community$string_extra$String$Extra$toSentenceCase = function (word) {
	return A2($elm_community$string_extra$String$Extra$changeCase, $elm$core$Char$toUpper, word);
};
var $elm_community$string_extra$String$Extra$humanize = function (string) {
	return $elm_community$string_extra$String$Extra$toSentenceCase(
		$elm$core$String$toLower(
			$elm$core$String$trim(
				A3(
					$elm$regex$Regex$replace,
					$elm_community$string_extra$String$Extra$regexFromString('_id$|[-_\\s]+'),
					$elm$core$Basics$always(' '),
					A3(
						$elm$regex$Regex$replace,
						$elm_community$string_extra$String$Extra$regexFromString('[A-Z]+'),
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.aiz;
							},
							$elm$core$String$append('-')),
						string)))));
};
var $elm_community$string_extra$String$Extra$toTitleCase = function (ws) {
	var uppercaseMatch = A2(
		$elm$regex$Regex$replace,
		$elm_community$string_extra$String$Extra$regexFromString('\\w+'),
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.aiz;
			},
			$elm_community$string_extra$String$Extra$toSentenceCase));
	return A3(
		$elm$regex$Regex$replace,
		$elm_community$string_extra$String$Extra$regexFromString('^([a-z])|\\s+([a-z])'),
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.aiz;
			},
			uppercaseMatch),
		ws);
};
var $author$project$Formatters$String$titleize = A2($elm$core$Basics$composeR, $elm_community$string_extra$String$Extra$humanize, $elm_community$string_extra$String$Extra$toTitleCase);
var $author$project$Ui$Badge$formatLabel = function (label) {
	switch (label) {
		case 'needs_payment_info':
			return 'no payment info';
		case 'bank_not_verified':
			return 'bank not verified';
		case 'saving':
			return 'saving...';
		case 'refund_pending':
			return 'refund processing';
		case 'refund_cancelled':
			return 'refund cancelled';
		case 'refund_actually_pending':
			return 'refund pending';
		case 'refund_successful':
			return 'refunded';
		case 'refund_failed':
			return 'refund failed';
		case 'refund_unattempted':
			return 'refund unattempted';
		case 'new_payment_source':
			return 'new';
		case 'needs_trial_deposits':
			return 'unverified';
		case 'not_redeemable':
			return 'not redeemable';
		case 'bad_debt':
			return 'bad debt';
		case 'no_payment':
			return 'no payment';
		case 'accepted_and_outdated':
			return 'out of date';
		case 'not_accepted':
			return 'not accepted';
		case 'scheduled_without_source':
			return 'scheduled';
		case 'review_data_matches':
			return 'review data matches';
		case 'review_file_size':
			return 'review file size';
		case 'enqueued_for_preprocessing':
			return 'enqueued';
		case 'enqueued_for_processing':
			return 'enqueued';
		case 'preprocessing':
			return 'processing';
		case 'postprocessing':
			return 'processing';
		case 'ready_to_preprocess':
			return 'enqueued';
		case 'ready_to_process':
			return 'ready to process';
		case 'deal_ending':
			return 'ending';
		case 'unpublished_change':
			return 'unpublished change';
		case 'failed_payment':
			return 'failed payment';
		case 'in_development':
			return 'in development';
		default:
			return label;
	}
};
var $author$project$Ui$Badge$Info = 1;
var $author$project$Ui$Badge$info = $author$project$Ui$Badge$Color(1);
var $author$project$Ui$Badge$mapColor = function (status) {
	switch (status) {
		case 'needs_payment_info':
			return _List_fromArray(
				[$author$project$Ui$Badge$warning]);
		case 'pending':
			return _List_fromArray(
				[$author$project$Ui$Badge$info]);
		case 'downloading':
			return _List_fromArray(
				[$author$project$Ui$Badge$info]);
		case 'bank_not_verified':
			return _List_fromArray(
				[$author$project$Ui$Badge$warning]);
		case 'successful':
			return _List_fromArray(
				[$author$project$Ui$Badge$success]);
		case 'live':
			return _List_fromArray(
				[$author$project$Ui$Badge$success]);
		case 'failed':
			return _List_fromArray(
				[$author$project$Ui$Badge$danger]);
		case 'refunded':
			return _List_fromArray(
				[$author$project$Ui$Badge$warning]);
		case 'retrying':
			return _List_fromArray(
				[$author$project$Ui$Badge$warning]);
		case 'cancelled':
			return _List_Nil;
		case 'default':
			return _List_fromArray(
				[$author$project$Ui$Badge$primary]);
		case 'saving':
			return _List_fromArray(
				[$author$project$Ui$Badge$info]);
		case 'refund_pending':
			return _List_fromArray(
				[$author$project$Ui$Badge$warning]);
		case 'refund_actually_pending':
			return _List_fromArray(
				[$author$project$Ui$Badge$warning]);
		case 'refund_successful':
			return _List_fromArray(
				[$author$project$Ui$Badge$warning]);
		case 'refund_failed':
			return _List_fromArray(
				[$author$project$Ui$Badge$danger]);
		case 'active':
			return _List_fromArray(
				[$author$project$Ui$Badge$success]);
		case 'unconfirmed':
			return _List_fromArray(
				[$author$project$Ui$Badge$warning]);
		case 'confirmed':
			return _List_fromArray(
				[$author$project$Ui$Badge$success]);
		case 'warning':
			return _List_fromArray(
				[$author$project$Ui$Badge$warning]);
		case 'new_payment_source':
			return _List_fromArray(
				[$author$project$Ui$Badge$success]);
		case 'needs_trial_deposits':
			return _List_fromArray(
				[$author$project$Ui$Badge$danger]);
		case 'invalid':
			return _List_fromArray(
				[$author$project$Ui$Badge$danger]);
		case 'inactive':
			return _List_Nil;
		case 'expiring':
			return _List_fromArray(
				[$author$project$Ui$Badge$warning]);
		case 'connected':
			return _List_fromArray(
				[$author$project$Ui$Badge$success]);
		case 'requested':
			return _List_fromArray(
				[$author$project$Ui$Badge$info]);
		case 'unpaid':
			return _List_fromArray(
				[$author$project$Ui$Badge$danger]);
		case 'paid':
			return _List_fromArray(
				[$author$project$Ui$Badge$success]);
		case 'clearing':
			return _List_fromArray(
				[$author$project$Ui$Badge$success]);
		case 'processing':
			return _List_fromArray(
				[$author$project$Ui$Badge$primary]);
		case 'redeemable':
			return _List_fromArray(
				[$author$project$Ui$Badge$primary]);
		case 'not_redeemable':
			return _List_fromArray(
				[$author$project$Ui$Badge$danger]);
		case 'viewed':
			return _List_fromArray(
				[$author$project$Ui$Badge$info]);
		case 'bad_debt':
			return _List_Nil;
		case 'disputed':
			return _List_Nil;
		case 'overdue':
			return _List_fromArray(
				[$author$project$Ui$Badge$danger]);
		case 'sent':
			return _List_fromArray(
				[$author$project$Ui$Badge$warning]);
		case 'issued':
			return _List_fromArray(
				[$author$project$Ui$Badge$warning]);
		case 'no_payment':
			return _List_fromArray(
				[$author$project$Ui$Badge$danger]);
		case 'missing':
			return _List_fromArray(
				[$author$project$Ui$Badge$danger]);
		case 'accepted':
			return _List_fromArray(
				[$author$project$Ui$Badge$success]);
		case 'accepted_and_outdated':
			return _List_fromArray(
				[$author$project$Ui$Badge$warning]);
		case 'not_accepted':
			return _List_Nil;
		case 'none':
			return _List_Nil;
		case 'scheduled':
			return _List_fromArray(
				[$author$project$Ui$Badge$info]);
		case 'scheduled_without_source':
			return _List_fromArray(
				[$author$project$Ui$Badge$danger]);
		case 'in transit':
			return _List_fromArray(
				[$author$project$Ui$Badge$info]);
		case 'completed':
			return _List_fromArray(
				[$author$project$Ui$Badge$success]);
		case 'enabled':
			return _List_fromArray(
				[$author$project$Ui$Badge$info]);
		case 'synced':
			return _List_fromArray(
				[$author$project$Ui$Badge$success]);
		case 'unsynced':
			return _List_Nil;
		case 'errored':
			return _List_fromArray(
				[$author$project$Ui$Badge$danger]);
		case 'opened':
			return _List_fromArray(
				[$author$project$Ui$Badge$success]);
		case 'error':
			return _List_fromArray(
				[$author$project$Ui$Badge$danger]);
		case 'processed':
			return _List_fromArray(
				[$author$project$Ui$Badge$success]);
		case 'review_data_matches':
			return _List_fromArray(
				[$author$project$Ui$Badge$warning]);
		case 'review_file_size':
			return _List_fromArray(
				[$author$project$Ui$Badge$warning]);
		case 'enqueued_for_preprocessing':
			return _List_fromArray(
				[$author$project$Ui$Badge$info]);
		case 'enqueued_for_processing':
			return _List_fromArray(
				[$author$project$Ui$Badge$info]);
		case 'preprocessing':
			return _List_fromArray(
				[$author$project$Ui$Badge$primary]);
		case 'postprocessing':
			return _List_fromArray(
				[$author$project$Ui$Badge$primary]);
		case 'ready_to_preprocess':
			return _List_fromArray(
				[$author$project$Ui$Badge$primary]);
		case 'ready_to_process':
			return _List_fromArray(
				[$author$project$Ui$Badge$primary]);
		case 'payable':
			return _List_fromArray(
				[$author$project$Ui$Badge$success]);
		case 'deal_ending':
			return _List_fromArray(
				[$author$project$Ui$Badge$warning]);
		case 'published':
			return _List_fromArray(
				[$author$project$Ui$Badge$success]);
		case 'unpublished':
			return _List_fromArray(
				[$author$project$Ui$Badge$warning]);
		case 'unpublished_change':
			return _List_fromArray(
				[$author$project$Ui$Badge$warning]);
		case 'upcoming':
			return _List_fromArray(
				[$author$project$Ui$Badge$info]);
		case 'failed_payment':
			return _List_fromArray(
				[$author$project$Ui$Badge$danger]);
		case 'in_development':
			return _List_Nil;
		default:
			return _List_Nil;
	}
};
var $author$project$Ui$Badge$fromString = F2(
	function (options, label) {
		return function (options_) {
			return A2(
				$author$project$Ui$Badge$view,
				options_,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Ui$Badge$formatLabel(label))
					]));
		}(
			_Utils_ap(
				options,
				$author$project$Ui$Badge$mapColor(label)));
	});
var $author$project$Ui$Badge$Spaced = {$: 5};
var $author$project$Ui$Badge$spacedRight = $author$project$Ui$Badge$Spaced;
var $author$project$Utils$PaymentProcessor$toLabelText = F2(
	function (isHintAdmin, processor) {
		var _v0 = _Utils_Tuple2(isHintAdmin, processor);
		switch (_v0.b) {
			case 'stripe':
				return 'Stripe';
			case 'rainforest':
				if (_v0.a) {
					return 'rainforest';
				} else {
					return 'Built-in Processor';
				}
			default:
				return processor;
		}
	});
var $author$project$Utils$PaymentProcessor$toBadge = F4(
	function (showProcessor, isHintAdmin, element, getPaymentProcessor) {
		var badge = F2(
			function (style, label) {
				return $elm$core$Maybe$Just(
					A2(
						$author$project$Ui$Badge$fromString,
						_List_fromArray(
							[$author$project$Ui$Badge$spacedRight, style]),
						label));
			});
		var _v0 = _Utils_Tuple2(
			showProcessor,
			getPaymentProcessor(element));
		_v0$2:
		while (true) {
			if (_v0.a && (!_v0.b.$)) {
				switch (_v0.b.a) {
					case 'stripe':
						return A2(
							badge,
							$author$project$Ui$Badge$primary,
							A2($author$project$Utils$PaymentProcessor$toLabelText, isHintAdmin, 'stripe'));
					case 'rainforest':
						return A2(
							badge,
							$author$project$Ui$Badge$success,
							A2($author$project$Utils$PaymentProcessor$toLabelText, isHintAdmin, 'rainforest'));
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Components$PaymentSourceDisplayer$viewCardReader = F2(
	function (optionsRecord, cardReader_) {
		var label = $author$project$Api$CardReader$Shared$label(cardReader_);
		return A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$withDefault,
					$author$project$Utils$Html$empty,
					A4(
						$author$project$Utils$PaymentProcessor$toBadge,
						optionsRecord.alv,
						optionsRecord.alv,
						cardReader_,
						A2($elm$core$Basics$composeR, $author$project$Api$CardReader$Shared$paymentProcessor, $elm$core$Maybe$Just))),
					A2(
					$elm$html$Html$strong,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('inline')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Card Reader: '),
									$elm$html$Html$text(
									$author$project$Formatters$String$titleize(label))
								]))
						]))
				]));
	});
var $author$project$Ui$OverflowWrap$BreakWord = 0;
var $author$project$Ui$OverflowWrap$breakWord = 0;
var $elm$html$Html$em = _VirtualDom_node('em');
var $author$project$Ui$Typography$OverflowWrap = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Typography$overflowWrap = $author$project$Ui$Typography$OverflowWrap;
var $author$project$Components$PaymentSourceDisplayer$actualPaymentProcessor = F2(
	function (givenPaymentProcessor_, source_) {
		var _v0 = _Utils_Tuple2(givenPaymentProcessor_, source_.Zd);
		if (!_v0.a.$) {
			var processor = _v0.a.a;
			return $elm$core$Maybe$Just(processor);
		} else {
			if (!_v0.b.$) {
				var _v1 = _v0.a;
				var processor = _v0.b.a;
				return $elm$core$Maybe$Just(processor);
			} else {
				var _v2 = _v0.a;
				var _v3 = _v0.b;
				return $elm$core$Maybe$Nothing;
			}
		}
	});
var $author$project$Components$PaymentSourceDisplayer$paymentProcessorLabel = F3(
	function (showProcessor_, givenPaymentProcessor_, source_) {
		return A4(
			$author$project$Utils$PaymentProcessor$toBadge,
			showProcessor_,
			showProcessor_,
			source_,
			$author$project$Components$PaymentSourceDisplayer$actualPaymentProcessor(givenPaymentProcessor_));
	});
var $author$project$Components$PaymentSourceDisplayer$sourceName = function (source_) {
	var _v0 = A2($elm$core$Maybe$andThen, $author$project$Utils$String$toMaybe, source_.Bq);
	if (!_v0.$) {
		var label = _v0.a;
		return $elm$core$Maybe$Just(label);
	} else {
		return source_.amg;
	}
};
var $elm$core$List$intersperse = F2(
	function (sep, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var hd = xs.a;
			var tl = xs.b;
			var step = F2(
				function (x, rest) {
					return A2(
						$elm$core$List$cons,
						sep,
						A2($elm$core$List$cons, x, rest));
				});
			var spersed = A3($elm$core$List$foldr, step, _List_Nil, tl);
			return A2($elm$core$List$cons, hd, spersed);
		}
	});
var $author$project$Ui$Typography$Primary = 1;
var $author$project$Ui$Typography$primary = $author$project$Ui$Typography$Color(1);
var $author$project$Components$PaymentSourceDisplayer$viewMembershipLink = F2(
	function (patientId_, membership) {
		if (!patientId_.$) {
			var pid = patientId_.a;
			return _List_fromArray(
				[
					A3(
					$author$project$Ui$Link$route,
					$author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__MembershipId_String__Top(
						{AW: membership.ahP, YZ: pid}),
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(membership.ZE)
						]))
				]);
		} else {
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$text,
					_List_fromArray(
						[$author$project$Ui$Typography$primary]),
					membership.ZE)
				]);
		}
	});
var $author$project$Components$PaymentSourceDisplayer$viewAssignedMemberships = F3(
	function (showAssignedMemberships_, patientId_, memberships) {
		if (!showAssignedMemberships_) {
			return $author$project$Utils$Html$empty;
		} else {
			if (!memberships.b) {
				return $author$project$Utils$Html$empty;
			} else {
				var membershipLinks = $elm$core$List$concat(
					A2(
						$elm$core$List$intersperse,
						_List_fromArray(
							[
								$elm$html$Html$text(', ')
							]),
						A2(
							$elm$core$List$map,
							$author$project$Components$PaymentSourceDisplayer$viewMembershipLink(patientId_),
							memberships)));
				return A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$text('Assigned to: '),
						membershipLinks));
			}
		}
	});
var $author$project$Ui$Typography$Warning = 4;
var $author$project$Ui$Typography$warning = $author$project$Ui$Typography$Color(4);
var $author$project$Components$PaymentSourceDisplayer$viewAdditionalInfo = F4(
	function (timeFormatter, showAssignedMemberships_, patientId_, source_) {
		return A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					function () {
					var _v0 = _Utils_Tuple2(source_.RM, source_.VI);
					if (!_v0.a.$) {
						var errorMessage = _v0.a.a;
						return A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[$author$project$Ui$Typography$danger]),
							'Invalid: ' + errorMessage);
					} else {
						if (!_v0.b.$) {
							var _v1 = _v0.a;
							var lastPaymentErrorMessage = _v0.b.a;
							return A2(
								$author$project$Ui$Typography$text,
								_List_fromArray(
									[$author$project$Ui$Typography$warning]),
								'Payment Failed: ' + lastPaymentErrorMessage);
						} else {
							return $author$project$Utils$Html$empty;
						}
					}
				}(),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
							'Added ' + A2(
								$elm$core$Maybe$withDefault,
								'N/A',
								A2(
									$elm$core$Maybe$map,
									timeFormatter(5),
									source_.O1))),
							function () {
							var _v2 = _Utils_Tuple2(source_.ag3, source_.ag4);
							if ((!_v2.a.$) && (!_v2.b.$)) {
								var expMonth = _v2.a.a;
								var expYear = _v2.b.a;
								var textColor = function () {
									var _v3 = source_.alH;
									if ((!_v3.$) && (_v3.a === 'expiring')) {
										return $author$project$Ui$Typography$danger;
									} else {
										return $author$project$Ui$Typography$muted;
									}
								}();
								return A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$small, textColor]),
									', expires ' + ($elm$core$String$fromInt(expMonth) + ('/' + $elm$core$String$fromInt(expYear))));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}(),
							function () {
							var _v4 = source_.vv;
							if (!_v4.$) {
								var zip = _v4.a;
								return A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
									', ZIP code ' + zip);
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						])),
					function () {
					var _v5 = source_.O4;
					if (!_v5.$) {
						var createdVia = _v5.a;
						return A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(createdVia)
										])),
									function () {
									var _v6 = source_.O3;
									if (!_v6.$) {
										var createdByName = _v6.a;
										return A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(' by ' + createdByName)
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					A3($author$project$Components$PaymentSourceDisplayer$viewAssignedMemberships, showAssignedMemberships_, patientId_, source_.L1)
				]));
	});
var $author$project$Components$PaymentSourceDisplayer$viewSource = F3(
	function (timeFormatter, optionsRecord, source_) {
		return A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$withDefault,
					$author$project$Utils$Html$empty,
					A3($author$project$Components$PaymentSourceDisplayer$paymentProcessorLabel, optionsRecord.alv, optionsRecord.Zd, source_)),
					function () {
					var _v0 = $author$project$Components$PaymentSourceDisplayer$sourceName(source_);
					if (!_v0.$) {
						var name = _v0.a;
						return A2(
							$elm$html$Html$strong,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('inline')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Formatters$String$titleize(name))
										]))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					$author$project$Utils$Html$noBreakSpace,
					function () {
					var _v1 = source_.VG;
					if (!_v1.$) {
						var lastFour = _v1.a;
						return A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[
									$author$project$Ui$Typography$phi(true)
								]),
							'*' + lastFour);
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					$author$project$Utils$Html$noBreakSpace,
					function () {
					var _v2 = source_.SN;
					if (!_v2.$) {
						var funding = _v2.a;
						return A2($author$project$Ui$Typography$text, _List_Nil, '(' + (funding + ')'));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					$author$project$Utils$Html$noBreakSpace,
					optionsRecord.BN ? $author$project$Utils$Html$empty : A2(
					$author$project$Ui$Badge$fromString,
					_List_Nil,
					A2($elm$core$Maybe$withDefault, 'N/A', source_.alH)),
					$author$project$Utils$Html$noBreakSpace,
					function () {
					var _v3 = source_.aih;
					if (!_v3.$) {
						var label = _v3.a;
						return A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$em,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-muted mr-2')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[
													$author$project$Ui$Typography$phi(true),
													$author$project$Ui$Typography$overflowWrap($author$project$Ui$OverflowWrap$breakWord)
												]),
											label)
										]))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					optionsRecord.AC ? $author$project$Utils$Html$empty : A4($author$project$Components$PaymentSourceDisplayer$viewAdditionalInfo, timeFormatter, optionsRecord.Ez, optionsRecord.YZ, source_)
				]));
	});
var $author$project$Api$Provider$StripePaymentMethodMigration$All$zip = function (_v0) {
	var record = _v0;
	return record.vv;
};
var $author$project$Api$Employer$Card$Shared$zip = function (_v0) {
	var record = _v0;
	return record.vv;
};
var $author$project$Api$Employer$Card$One$zip = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Card$Shared$zip(shared);
};
var $author$project$Api$Employer$Card$All$zip = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$Card$One$zip(one);
};
var $author$project$Api$Provider$Card$Shared$zip = function (_v0) {
	var record = _v0;
	return record.vv;
};
var $author$project$Api$Provider$Card$One$zip = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Card$Shared$zip(shared);
};
var $author$project$Api$Provider$Card$All$zip = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Card$One$zip(one);
};
var $author$project$Api$Card$zip = function (card) {
	switch (card.$) {
		case 0:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$One$zip(card_);
		case 1:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$All$zip(card_);
		case 2:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$One$zip(card_);
		default:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$All$zip(card_);
	}
};
var $author$project$Api$Source$zip = function (source) {
	switch (source.$) {
		case 0:
			var card = source.a;
			return $author$project$Api$Card$zip(card);
		case 1:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$PaymentSourceDisplayer$view = F2(
	function (timeFormatter, options) {
		var optionsRecord = $author$project$Components$PaymentSourceDisplayer$optionsToRecord(options);
		var _v0 = _Utils_Tuple3(optionsRecord.JQ, optionsRecord.aft, optionsRecord.ER);
		if (!_v0.a.$) {
			var source_ = _v0.a.a;
			return A3(
				$author$project$Components$PaymentSourceDisplayer$viewSource,
				timeFormatter,
				optionsRecord,
				{
					L1: $author$project$Api$Source$assignedMemberships(source_),
					O1: $author$project$Api$Source$createdAt(source_),
					O3: $author$project$Api$Source$createdByName(source_),
					O4: $author$project$Api$Source$createdVia(source_),
					RM: $author$project$Api$Source$errorMessage(source_),
					ag3: $author$project$Api$Source$expMonth(source_),
					ag4: $author$project$Api$Source$expYear(source_),
					SN: $author$project$Api$Source$funding(source_),
					aih: $author$project$Api$Source$label(source_),
					VG: $author$project$Api$Source$lastFour(source_),
					VI: $author$project$Api$Source$lastPaymentErrorMessage(source_),
					Bq: $author$project$Api$Source$name(source_),
					Zd: $author$project$Api$Source$paymentProcessor(source_),
					alH: $author$project$Api$Source$status(source_),
					amg: $author$project$Api$Source$type_(source_),
					vv: $author$project$Api$Source$zip(source_)
				});
		} else {
			if (!_v0.b.$) {
				var cardReader_ = _v0.b.a;
				return A2($author$project$Components$PaymentSourceDisplayer$viewCardReader, optionsRecord, cardReader_);
			} else {
				if (!_v0.c.$) {
					var _v1 = _v0.a;
					var _v2 = _v0.b;
					var stripePaymentMethodMigration_ = _v0.c.a;
					return A3(
						$author$project$Components$PaymentSourceDisplayer$viewSource,
						timeFormatter,
						optionsRecord,
						{
							L1: _List_Nil,
							O1: $elm$core$Maybe$Just(
								$author$project$Api$Provider$StripePaymentMethodMigration$All$createdAt(stripePaymentMethodMigration_)),
							O3: $author$project$Api$Provider$StripePaymentMethodMigration$All$createdByName(stripePaymentMethodMigration_),
							O4: $author$project$Api$Provider$StripePaymentMethodMigration$All$createdVia(stripePaymentMethodMigration_),
							RM: $author$project$Api$Provider$StripePaymentMethodMigration$All$errorMessage(stripePaymentMethodMigration_),
							ag3: $author$project$Api$Provider$StripePaymentMethodMigration$All$expMonth(stripePaymentMethodMigration_),
							ag4: $author$project$Api$Provider$StripePaymentMethodMigration$All$expYear(stripePaymentMethodMigration_),
							SN: $author$project$Api$Provider$StripePaymentMethodMigration$All$funding(stripePaymentMethodMigration_),
							aih: $author$project$Api$Provider$StripePaymentMethodMigration$All$label(stripePaymentMethodMigration_),
							VG: $author$project$Api$Provider$StripePaymentMethodMigration$All$lastFour(stripePaymentMethodMigration_),
							VI: $author$project$Api$Provider$StripePaymentMethodMigration$All$lastPaymentErrorMessage(stripePaymentMethodMigration_),
							Bq: $author$project$Api$Provider$StripePaymentMethodMigration$All$name(stripePaymentMethodMigration_),
							Zd: $elm$core$Maybe$Just(
								$author$project$Api$Provider$StripePaymentMethodMigration$All$paymentProcessor(stripePaymentMethodMigration_)),
							alH: $author$project$Api$Provider$StripePaymentMethodMigration$All$status(stripePaymentMethodMigration_),
							amg: $elm$core$Maybe$Just(
								$author$project$Api$Provider$StripePaymentMethodMigration$All$type_(stripePaymentMethodMigration_)),
							vv: $author$project$Api$Provider$StripePaymentMethodMigration$All$zip(stripePaymentMethodMigration_)
						});
				} else {
					var _v3 = _v0.a;
					var _v4 = _v0.b;
					var _v5 = _v0.c;
					return $author$project$Utils$Html$empty;
				}
			}
		}
	});
var $author$project$Components$PracticeSourceDisplayer$view = F2(
	function (timeFormatter, source) {
		return A2(
			$author$project$Ui$Typography$p,
			_List_fromArray(
				[$author$project$Ui$Typography$helpBlock]),
			_List_fromArray(
				[
					$elm$html$Html$text('Payment source: '),
					A2(
					$author$project$Components$PaymentSourceDisplayer$view,
					timeFormatter,
					_List_fromArray(
						[
							$author$project$Components$PaymentSourceDisplayer$source(source),
							$author$project$Components$PaymentSourceDisplayer$limitedView(true),
							$author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus(true)
						])),
					A3(
					$author$project$Ui$Link$route,
					$author$project$Spa$Generated$Route$Admin__PaymentSources,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Edit')
						]))
				]));
	});
var $author$project$Pages$Admin$Billing$viewPracticePaymentSource = F3(
	function (timeFormatter, cards, bankAccounts) {
		return A2(
			$author$project$Components$PracticeSourceDisplayer$view,
			timeFormatter,
			A2($author$project$Api$Source$defaultPracticeSource, cards, bankAccounts));
	});
var $author$project$Pages$Admin$Billing$viewInvoicesHeader = function (model) {
	return A2(
		$author$project$Ui$Grid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$spanMd(8)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Typography$headingSm(
						_List_fromArray(
							[
								$elm$html$Html$text('Invoices')
							]))
					])),
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$spanMd(4)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$justifyRight]),
						_List_fromArray(
							[
								function () {
								var _v0 = _Utils_Tuple2(model.rC, model.rs);
								if ((_v0.a.$ === 3) && (_v0.b.$ === 3)) {
									var _v1 = _v0.a;
									var cards = _v1.a;
									var _v2 = _v0.b;
									var bankAccounts = _v2.a;
									return A3($author$project$Pages$Admin$Billing$viewPracticePaymentSource, model.J7, cards, bankAccounts);
								} else {
									return $author$project$Ui$Skeleton$text(
										_List_fromArray(
											[
												$author$project$Ui$Skeleton$spanFromText('Payment source: *Visa 4242')
											]));
								}
							}()
							]))
					]))
			]));
};
var $author$project$Pages$Admin$Billing$AnalyticsLinkClicked = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Api$Provider$PracticePricing$One$addOns = function (_v0) {
	var record = _v0;
	return A2(
		$elm$core$List$filter,
		function (product) {
			return $author$project$Api$Provider$HintBillingComponent$Shared$componentType(product) === 1;
		},
		record.Dy);
};
var $author$project$Api$Provider$PracticePricing$One$txnFees = function (_v0) {
	var record = _v0;
	return record.adI;
};
var $author$project$Api$Provider$HintBillingComponent$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Ui$Element$spaceY2 = $author$project$Ui$Element$SpaceY(2);
var $author$project$Api$Provider$HintBillingComponent$Shared$addonType = function (_v0) {
	var record = _v0;
	return record.K0;
};
var $author$project$Components$HintBilling$Pricing$trimSubString = F2(
	function (name, substringToReplace) {
		return A3($elm$core$String$replace, substringToReplace, '', name);
	});
var $author$project$Ui$Alignment$Right = 2;
var $author$project$Ui$Alignment$textRight = $author$project$Ui$Alignment$Text(2);
var $author$project$Ui$Element$textRight = $author$project$Ui$Element$Alignment($author$project$Ui$Alignment$textRight);
var $author$project$Components$HintBilling$Pricing$viewProduct = F3(
	function (content, maybeQuantity, maybePrice) {
		var totalPrice = function () {
			var _v2 = _Utils_Tuple2(maybeQuantity, maybePrice);
			if ((!_v2.a.$) && (!_v2.b.$)) {
				var quantity = _v2.a.a;
				var price = _v2.b.a;
				var total = quantity * price;
				var formattedTotal = $author$project$Utils$Currency$fromIntNoDecimals(
					$elm$core$Basics$round(total));
				return $elm$core$Maybe$Just(formattedTotal);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		return A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanMd(
							A2(
								$elm$core$Maybe$withDefault,
								12,
								A2(
									$elm$core$Maybe$map,
									function (_v0) {
										return 9;
									},
									totalPrice)))
						]),
					_List_fromArray(
						[content])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanMd(3)
						]),
					_List_fromArray(
						[
							function () {
							if (!totalPrice.$) {
								var price = totalPrice.a;
								return A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textRight]),
									_List_fromArray(
										[
											$elm$html$Html$text(price)
										]));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						]))
				]));
	});
var $author$project$Components$HintBilling$Pricing$viewAddon = function (addOn) {
	var _v0 = _Utils_Tuple2(
		$author$project$Api$Provider$HintBillingComponent$Shared$componentType(addOn),
		$author$project$Api$Provider$HintBillingComponent$Shared$addonType(addOn));
	if ((_v0.a === 1) && (!_v0.b.$)) {
		var _v1 = _v0.a;
		var addonType = _v0.b.a;
		var shouldShowAddon = (addonType === 1) ? A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				function (qty) {
					return qty > 0;
				},
				$author$project$Api$Provider$HintBillingComponent$Shared$quantity(addOn))) : true;
		if (shouldShowAddon) {
			var displayName = A2(
				$author$project$Components$HintBilling$Pricing$trimSubString,
				$author$project$Api$Provider$HintBillingComponent$Shared$name(addOn),
				'Add-on: ');
			return A3(
				$author$project$Components$HintBilling$Pricing$viewProduct,
				A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
					_List_fromArray(
						[
							$author$project$Ui$Icon$check(_List_Nil),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(displayName)
								]))
						])),
				$elm$core$Maybe$Nothing,
				$elm$core$Maybe$Nothing);
		} else {
			return $author$project$Utils$Html$empty;
		}
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$HintBilling$Pricing$viewAddons = function (addOns) {
	var sortedAddOns = A2($elm$core$List$sortBy, $author$project$Api$Provider$HintBillingComponent$Shared$name, addOns);
	return A2(
		$author$project$Ui$Grid$column,
		_List_fromArray(
			[
				$author$project$Ui$Grid$spanMd(3)
			]),
		$elm$core$List$isEmpty(sortedAddOns) ? _List_Nil : _List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Typography$headingSm(
								_List_fromArray(
									[
										$elm$html$Html$text('Add-Ons')
									]))
							]))
					])),
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2($elm$html$Html$br, _List_Nil, _List_Nil)
							]))
					])),
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Panel$body,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$spaceY2]),
												A2($elm$core$List$map, $author$project$Components$HintBilling$Pricing$viewAddon, sortedAddOns))
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Components$HintBilling$Pricing$viewFeesBreakdown = function (txnFees) {
	return A2(
		$author$project$Ui$Grid$column,
		_List_fromArray(
			[
				$author$project$Ui$Grid$spanMd(4)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Typography$headingSm(
								_List_fromArray(
									[
										$elm$html$Html$text('Transaction Fees *')
									]))
							]))
					])),
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2($elm$html$Html$br, _List_Nil, _List_Nil)
							]))
					])),
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Panel$body,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$spaceY2]),
												_List_fromArray(
													[
														A2($author$project$Utils$Billing$TxnFees$viewFees, txnFees, false)
													]))
											]))
									]))
							]))
					])),
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
								_List_fromArray(
									[
										$elm$html$Html$text('* Transaction fees are taken at the time of the transaction')
									]))
							]))
					]))
			]));
};
var $author$project$Api$Provider$PracticePricing$One$revenueOveragePriceInCents = function (_v0) {
	var record = _v0;
	return record.$$;
};
var $author$project$Ui$Element$ml2 = $author$project$Ui$Element$Margin('ml-2');
var $author$project$Components$HintBilling$NextBill$viewNextBillDate = function (maybeNextBillDate) {
	var billDateText = function () {
		if (!maybeNextBillDate.$) {
			var nextBillDAte = maybeNextBillDate.a;
			return ' Next Bill: ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, nextBillDAte);
		} else {
			return '';
		}
	}();
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(billDateText)
			]));
};
var $author$project$Components$HintBilling$NextBill$viewPrice = function (billableProducts) {
	var totalAmountInCents = $elm$core$List$sum(
		A2(
			$elm$core$List$map,
			function (product) {
				return $author$project$Api$Provider$HintBillingComponent$Shared$priceInCents(product) * A2(
					$elm$core$Maybe$withDefault,
					0,
					$author$project$Api$Provider$HintBillingComponent$Shared$quantity(product));
			},
			A2(
				$elm$core$List$filter,
				function (product) {
					return $author$project$Api$Provider$HintBillingComponent$Shared$componentType(product) !== 5;
				},
				billableProducts)));
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
		_List_fromArray(
			[
				$author$project$Ui$Typography$headingSm(
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Utils$Currency$fromIntNoDecimals(
							$elm$core$Basics$round(totalAmountInCents)))
					])),
				A2(
				$author$project$Ui$Typography$text,
				_List_fromArray(
					[$author$project$Ui$Typography$small]),
				'/ mo')
			]));
};
var $author$project$Components$HintBilling$NextBill$view = F2(
	function (pricing, viewCustomContent) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(6)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Typography$headingSm(
									_List_fromArray(
										[
											$elm$html$Html$text('Monthly Subscription')
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(6),
									$author$project$Ui$Grid$justifyRight
								]),
							_List_fromArray(
								[
									$author$project$Components$HintBilling$NextBill$viewPrice(
									$author$project$Api$Provider$PracticePricing$One$billableProducts(pricing))
								]))
						])),
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanMd(12)
								]),
							_List_fromArray(
								[
									$author$project$Components$HintBilling$NextBill$viewNextBillDate(
									$author$project$Api$Provider$PracticePricing$One$nextBillDate(pricing))
								]))
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$ml2]),
					_List_fromArray(
						[viewCustomContent]))
				]));
	});
var $author$project$Components$HintBilling$Pricing$viewBillingSection = F3(
	function (applicationFeePlan, pricing, currentDate) {
		return A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			function () {
				if (applicationFeePlan.$ === 3) {
					var feePlan = applicationFeePlan.a;
					return $author$project$Api$Provider$PracticePricing$One$isLegacyPricing(pricing) ? _List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(10)
								]),
							_List_fromArray(
								[
									A4(
									$author$project$Components$HintBilling$LegacyPricing$view,
									currentDate,
									feePlan,
									$author$project$Api$Provider$PracticePricing$One$pmpmFeeInCents(pricing),
									$author$project$Api$Provider$PracticePricing$One$billableProducts(pricing))
								]))
						]) : _List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$Components$HintBilling$NextBill$view, pricing, $author$project$Utils$Html$empty)
								]))
						]);
				} else {
					return _List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_Nil,
							_List_fromArray(
								[$author$project$Components$HintBilling$NextBill$skeleton]))
						]);
				}
			}());
	});
var $author$project$Components$HintBilling$Pricing$createNewGroup = function (addonData) {
	return {
		jX: (!addonData.Dw) ? addonData.Dz : 0,
		Bq: addonData.Bq,
		eY: (addonData.Dw > 0) ? addonData.Dw : 0,
		Dz: addonData.Dz,
		adM: addonData.adM
	};
};
var $author$project$Api$Provider$HintBillingComponent$UnitName$toString = function (unitName_) {
	switch (unitName_) {
		case 0:
			return 'member';
		case 1:
			return 'dollar';
		case 2:
			return 'integration';
		case 3:
			return 'feed';
		case 4:
			return 'clinician';
		default:
			return 'hint_ai';
	}
};
var $author$project$Api$Provider$HintBillingComponent$Shared$unitName = function (_v0) {
	var record = _v0;
	return record.adM;
};
var $author$project$Components$HintBilling$Pricing$extractAddonData = function (addon) {
	var unitName = A2(
		$elm$core$Maybe$map,
		$author$project$Api$Provider$HintBillingComponent$UnitName$toString,
		$author$project$Api$Provider$HintBillingComponent$Shared$unitName(addon));
	var quantity = A2(
		$elm$core$Maybe$withDefault,
		0,
		$author$project$Api$Provider$HintBillingComponent$Shared$quantity(addon));
	var priceInCents = $author$project$Api$Provider$HintBillingComponent$Shared$priceInCents(addon);
	var addonName = A2(
		$author$project$Components$HintBilling$Pricing$trimSubString,
		$author$project$Api$Provider$HintBillingComponent$Shared$name(addon),
		'Add-on:');
	return {Bq: addonName, Dw: priceInCents, Dz: quantity, adM: unitName};
};
var $author$project$Components$HintBilling$Pricing$updateExistingGroup = F2(
	function (group, addonData) {
		return _Utils_update(
			group,
			{
				jX: group.jX + ((!addonData.Dw) ? addonData.Dz : 0),
				Bq: (addonData.Dw > 0) ? addonData.Bq : group.Bq,
				eY: ((addonData.Dw > 0) && (!group.eY)) ? addonData.Dw : group.eY,
				Dz: group.Dz + addonData.Dz
			});
	});
var $author$project$Components$HintBilling$Pricing$groupByUnitName = F2(
	function (addon, groups) {
		var addonData = $author$project$Components$HintBilling$Pricing$extractAddonData(addon);
		var _v0 = addonData.adM;
		if (_v0.$ === 1) {
			return A2(
				$elm$core$List$cons,
				$author$project$Components$HintBilling$Pricing$createNewGroup(addonData),
				groups);
		} else {
			var _v1 = A2(
				$elm$core$List$filter,
				function (group) {
					return _Utils_eq(group.adM, addonData.adM);
				},
				groups);
			if (_v1.b) {
				return A2(
					$elm$core$List$map,
					function (group) {
						return _Utils_eq(group.adM, addonData.adM) ? A2($author$project$Components$HintBilling$Pricing$updateExistingGroup, group, addonData) : group;
					},
					groups);
			} else {
				return A2(
					$elm$core$List$cons,
					$author$project$Components$HintBilling$Pricing$createNewGroup(addonData),
					groups);
			}
		}
	});
var $author$project$Components$HintBilling$Pricing$formatPluralName = F2(
	function (name, quantity) {
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$text,
				_List_fromArray(
					[$author$project$Ui$Typography$bold]),
				$elm$core$String$fromInt(quantity)),
				$elm$html$Html$text(
				A3(
					$elm$core$String$replace,
					$elm$core$String$fromInt(quantity),
					'',
					A2($author$project$Formatters$String$pluralize, name, quantity)))
			]);
	});
var $author$project$Components$HintBilling$Pricing$renderAddonGroup = function (group) {
	var pricingDetails = ((group.jX > 0) && (group.eY > 0)) ? _List_fromArray(
		[
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$elm$core$String$fromInt(group.jX) + (' included in your plan, ' + ($author$project$Utils$Currency$fromIntNoDecimals(
						$elm$core$Basics$round(group.eY)) + ' each')))
				]))
		]) : _List_Nil;
	var paidQuantity = A2($elm$core$Basics$max, 0, group.Dz - group.jX);
	var content = A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_Utils_ap(
			A2($author$project$Components$HintBilling$Pricing$formatPluralName, group.Bq, group.Dz),
			pricingDetails));
	return A3(
		$author$project$Components$HintBilling$Pricing$viewProduct,
		content,
		$elm$core$Maybe$Just(paidQuantity),
		$elm$core$Maybe$Just(group.eY));
};
var $author$project$Components$HintBilling$Pricing$viewPricedAddons = function (addons) {
	return A2(
		$elm$core$List$map,
		$author$project$Components$HintBilling$Pricing$renderAddonGroup,
		A2(
			$elm$core$List$filter,
			function (group) {
				return group.eY > 0;
			},
			A3(
				$elm$core$List$foldl,
				$author$project$Components$HintBilling$Pricing$groupByUnitName,
				_List_Nil,
				A2(
					$elm$core$List$filter,
					function (addon) {
						return !_Utils_eq(
							$author$project$Api$Provider$HintBillingComponent$Shared$quantity(addon),
							$elm$core$Maybe$Nothing);
					},
					addons))));
};
var $author$project$Api$Provider$PracticePricing$One$currentMembers = function (_v0) {
	var record = _v0;
	return record.Ph;
};
var $author$project$Api$Provider$ApplicationFeePlan$One$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Components$HintBilling$Pricing$productTypePrefix = F2(
	function (hasClinicalAccount, baseFeeName) {
		return hasClinicalAccount ? ('Clinical ' + baseFeeName) : ('Core ' + baseFeeName);
	});
var $author$project$Formatters$Float$toPercentage = function (_float) {
	return $elm$core$String$fromFloat(_float) + '%';
};
var $author$project$Components$HintBilling$Pricing$viewProductByType = F6(
	function (pricing, applicationFeePlan, product, hasClinicalAccount, onAnalyticsClick, maybeRevenueOveragePriceInCents) {
		var quantity = A2(
			$elm$core$Maybe$withDefault,
			0,
			$author$project$Api$Provider$HintBillingComponent$Shared$quantity(product));
		var _v0 = $author$project$Api$Provider$HintBillingComponent$Shared$componentType(product);
		switch (_v0) {
			case 0:
				return A3(
					$author$project$Components$HintBilling$Pricing$viewProduct,
					A2(
						$author$project$Ui$Element$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2(
											$author$project$Components$HintBilling$Pricing$productTypePrefix,
											hasClinicalAccount,
											$author$project$Api$Provider$HintBillingComponent$Shared$name(product)))
									])),
								A2(
								$author$project$Ui$Typography$text,
								_List_fromArray(
									[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
								'Base Subscription Tier. '),
								A3($author$project$Components$HintBilling$FeatureListLink$view, hasClinicalAccount, onAnalyticsClick, true)
							])),
					$elm$core$Maybe$Just(quantity),
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$HintBillingComponent$Shared$priceInCents(product)));
			case 4:
				var name = $author$project$Api$Provider$HintBillingComponent$Shared$name(product);
				var formattedPriceInCents = $author$project$Utils$Currency$fromIntNoDecimals(
					$elm$core$Basics$round(
						$author$project$Api$Provider$HintBillingComponent$Shared$priceInCents(product)));
				return A3(
					$author$project$Components$HintBilling$Pricing$viewProduct,
					A2(
						$author$project$Ui$Element$view,
						_List_Nil,
						_Utils_ap(
							A2($author$project$Components$HintBilling$Pricing$formatPluralName, name, quantity),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
									_List_fromArray(
										[
											$elm$html$Html$text(formattedPriceInCents + '/mo per Clinician')
										]))
								]))),
					$elm$core$Maybe$Just(quantity),
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$HintBillingComponent$Shared$priceInCents(product)));
			case 2:
				var membersPriceInCents = quantity * $elm$core$Basics$round(
					$author$project$Api$Provider$HintBillingComponent$Shared$priceInCents(product));
				var feePlanName = function () {
					if (applicationFeePlan.$ === 3) {
						var feePlan = applicationFeePlan.a;
						return $author$project$Api$Provider$ApplicationFeePlan$One$name(feePlan);
					} else {
						return '';
					}
				}();
				var currentUsageText = ' Current Usage ' + ($elm$core$String$fromInt(
					$author$project$Api$Provider$PracticePricing$One$currentMembers(pricing)) + ' Members');
				return A3(
					$author$project$Components$HintBilling$Pricing$viewProduct,
					A2(
						$author$project$Ui$Element$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										'Up to ' + ($elm$core$String$fromInt(quantity) + ' Members'))
									])),
								A4($author$project$Components$HintBilling$MemberTranches$view, feePlanName, quantity, membersPriceInCents, onAnalyticsClick),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpText, $author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
								_List_fromArray(
									[
										$elm$html$Html$text(currentUsageText)
									]))
							])),
					$elm$core$Maybe$Just(quantity),
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$HintBillingComponent$Shared$priceInCents(product)));
			case 3:
				if ($author$project$Api$Provider$HintBillingComponent$Shared$name(product) !== 'Additional Billed Revenue') {
					var overageRevenueExplaination = function () {
						if (!maybeRevenueOveragePriceInCents.$) {
							var revenueOveragePriceInCents = maybeRevenueOveragePriceInCents.a;
							return ' (' + ($author$project$Formatters$Float$toPercentage(revenueOveragePriceInCents) + ' on additional revenue)');
						} else {
							return '';
						}
					}();
					var revenueExplainationText = '$' + ($elm$core$String$fromFloat(quantity / 1000) + ('k' + overageRevenueExplaination));
					return A3(
						$author$project$Components$HintBilling$Pricing$viewProduct,
						A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Billed Revenue')
										])),
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$helpText, $author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
									_List_fromArray(
										[
											$elm$html$Html$text(revenueExplainationText)
										]))
								])),
						$elm$core$Maybe$Just(quantity),
						$elm$core$Maybe$Just(
							$author$project$Api$Provider$HintBillingComponent$Shared$priceInCents(product)));
				} else {
					return $author$project$Utils$Html$empty;
				}
			case 1:
				return $author$project$Utils$Html$empty;
			default:
				return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$HintBilling$Pricing$viewProductsBreakDown = F5(
	function (pricing, applicationFeePlan, currentDate, hasClinicalAccount, onAnalyticsClick) {
		var revenueOveragePriceInCents = $author$project$Api$Provider$PracticePricing$One$revenueOveragePriceInCents(pricing);
		var products = A2(
			$elm$core$List$filter,
			function (product) {
				return !_Utils_eq(
					$author$project$Api$Provider$HintBillingComponent$Shared$quantity(product),
					$elm$core$Maybe$Nothing);
			},
			$author$project$Api$Provider$PracticePricing$One$billableProducts(pricing));
		var baseFeeHasCost = A2(
			$elm$core$List$any,
			function (product) {
				return (!$author$project$Api$Provider$HintBillingComponent$Shared$componentType(product)) && ($author$project$Api$Provider$HintBillingComponent$Shared$priceInCents(product) > 0);
			},
			products);
		var addOns = $author$project$Api$Provider$PracticePricing$One$addOns(pricing);
		return A2(
			$author$project$Ui$Grid$column,
			_List_fromArray(
				[
					$author$project$Ui$Grid$spanMd(5)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_Nil,
							_List_fromArray(
								[
									A3($author$project$Components$HintBilling$Pricing$viewBillingSection, applicationFeePlan, pricing, currentDate)
								]))
						])),
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Panel$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Panel$body,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$spaceY2]),
													_Utils_ap(
														A2(
															$elm$core$List$map,
															function (product) {
																return A6($author$project$Components$HintBilling$Pricing$viewProductByType, pricing, applicationFeePlan, product, hasClinicalAccount, onAnalyticsClick, revenueOveragePriceInCents);
															},
															products),
														$author$project$Components$HintBilling$Pricing$viewPricedAddons(addOns)))
												]))
										]))
								]))
						])),
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
									_List_fromArray(
										[
											(hasClinicalAccount && baseFeeHasCost) ? $elm$html$Html$text('* Because you are a Clinical customer, you get a 20% discount on clinicians and members.') : $author$project$Utils$Html$empty
										]))
								]))
						]))
				]));
	});
var $author$project$Components$HintBilling$Pricing$view = F5(
	function (applicationFeePlan, currentDate, hasClinicalAccount, onAnalyticsClick, pricing) {
		return A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A5($author$project$Components$HintBilling$Pricing$viewProductsBreakDown, pricing, applicationFeePlan, currentDate, hasClinicalAccount, onAnalyticsClick),
					$author$project$Components$HintBilling$Pricing$viewAddons(
					$author$project$Api$Provider$PracticePricing$One$addOns(pricing)),
					$author$project$Components$HintBilling$Pricing$viewFeesBreakdown(
					$author$project$Api$Provider$PracticePricing$One$txnFees(pricing))
				]));
	});
var $author$project$Pages$Admin$Billing$viewProductsSection = F4(
	function (practicePricingData, applicationFeePlanData, currentDate, hasClinicalAccount) {
		if (practicePricingData.$ === 3) {
			var practicePricing = practicePricingData.a;
			return $author$project$Api$Provider$PracticePricing$One$isLegacyPricing(practicePricing) ? $author$project$Utils$Html$empty : A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mt8]),
				_List_fromArray(
					[
						A5($author$project$Components$HintBilling$Pricing$view, applicationFeePlanData, currentDate, hasClinicalAccount, $author$project$Pages$Admin$Billing$AnalyticsLinkClicked, practicePricing)
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Pages$Admin$Billing$viewBody = function (model) {
	var showBillingSections = $author$project$Pages$Admin$Billing$shouldShowBillingSections(model.cP);
	var billingSections = showBillingSections ? _List_fromArray(
		[
			A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanMd(6)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Panel$title(
							_List_fromArray(
								[
									$elm$html$Html$text('Billing')
								]))
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanMd(6)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$justifyRight]),
							_List_fromArray(
								[
									A3($author$project$Pages$Admin$Billing$viewActionButtons, model.cP, model.Ij, model.qS)
								]))
						]))
				])),
			A3($author$project$Pages$Admin$Billing$viewBillingSection, model.nI, model.cP, model.dd),
			A4($author$project$Pages$Admin$Billing$viewProductsSection, model.cP, model.nI, model.dd, model.S5),
			A4($author$project$Pages$Admin$Billing$viewAdditionalChargesSection, model.qK, model.Ij, model.cP, model.dd)
		]) : _List_Nil;
	return _List_fromArray(
		[
			$author$project$Pages$Admin$Billing$modals(model),
			A3($author$project$Pages$Admin$Billing$viewCapitalPromoTile, model.ZV, model.rA, model.xT),
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					A2(
						$elm$core$List$cons,
						$author$project$Pages$Admin$Billing$viewInfoMessage(model.cP),
						_Utils_ap(
							billingSections,
							_List_fromArray(
								[
									$author$project$Pages$Admin$Billing$viewInvoicesHeader(model),
									A2(
									$elm$html$Html$map,
									$author$project$Pages$Admin$Billing$PracticeInvoicePaginationMsg,
									A2($author$project$Components$HintBilling$InvoicesTable$view, model.kK, model.eU))
								]))))
				]))
		]);
};
var $author$project$Pages$Admin$Billing$view = function (model) {
	return {
		fO: $author$project$Pages$Admin$Billing$viewBody(model),
		ac9: 'Admin | Billing'
	};
};
var $author$project$Pages$Admin$Billing$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Billing$init, aiq: $author$project$Pages$Admin$Billing$load, k8: $author$project$Pages$Admin$Billing$save, alO: $author$project$Pages$Admin$Billing$subscriptions, adT: $author$project$Pages$Admin$Billing$update, amo: $author$project$Pages$Admin$Billing$view});
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$DropdownMenuMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$GotPracticeInvoice = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Invoice$DownloadFile$DropdownMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Invoice$DownloadFile$init = function (currentUrl) {
	return {
		gi: $author$project$Ui$Dropdown$init(
			$author$project$Ui$Dropdown$defaultConfig(
				{ahP: 'download-files-dropdown', al6: $author$project$Components$Invoice$DownloadFile$DropdownMsg})),
		U5: false,
		adY: currentUrl
	};
};
var $author$project$Components$Invoice$PaymentsHistory$PopoverMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$PaymentsList$init = F4(
	function (timeFormatter, basePath, session, allowPartialRefunds) {
		return {xi: allowPartialRefunds, xx: basePath, c4: $elm$core$Maybe$Nothing, iC: $elm$core$Maybe$Nothing, ej: $elm$core$Maybe$Nothing, ha: $elm$core$Maybe$Nothing, e_: $elm$core$Maybe$Nothing, kS: $elm$core$Maybe$Nothing, aa4: session, ls: $elm$core$Maybe$Nothing, lt: $elm$core$Maybe$Nothing, J7: timeFormatter};
	});
var $author$project$Ui$Popover$Model = $elm$core$Basics$identity;
var $author$project$Ui$Popover$init = F3(
	function (id, open, toMsg) {
		return {ahP: id, Yn: open, al6: toMsg};
	});
var $author$project$Components$Invoice$PaymentsHistory$init = F4(
	function (timeFormatter, basePath, session, allowPartialRefunds) {
		return {
			kD: A4($author$project$Components$PaymentsList$init, timeFormatter, basePath, session, allowPartialRefunds),
			aT: A3($author$project$Ui$Popover$init, 'payment-history', false, $author$project$Components$Invoice$PaymentsHistory$PopoverMsg),
			J7: timeFormatter
		};
	});
var $author$project$Api$Provider$PracticeInvoice$paymentsBasePath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['practice_invoices', id_]),
		$author$project$Api$Data$providerPath);
};
var $author$project$Api$Provider$PracticeInvoice$practiceInvoicePath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$PracticeInvoice$practiceInvoicesPath);
};
var $author$project$Api$Provider$PracticeInvoice$retrieve = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$PracticeInvoice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$PracticeInvoice$practiceInvoicePath(id_)));
	});
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$init = F4(
	function (session, practice, shared, _v0) {
		var params = _v0.YL;
		return _Utils_Tuple2(
			{
				Gv: shared.Gv,
				iV: $elm$core$Maybe$Nothing,
				m$: $elm$core$Maybe$Nothing,
				dd: shared.dd,
				i9: $elm$core$Maybe$Nothing,
				jt: $author$project$Components$Invoice$DownloadFile$init(shared.adY),
				no: $author$project$Ui$Dropdown$init(
					$author$project$Ui$Dropdown$defaultConfig(
						{ahP: 'invoice-actions-dropdown-menu', al6: $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$DropdownMenuMsg})),
				ahP: params.ahP,
				Ij: $author$project$Shared$isHintAdmin(shared),
				kC: A4(
					$author$project$Components$Invoice$PaymentsHistory$init,
					shared.J7,
					$author$project$Api$Provider$PracticeInvoice$paymentsBasePath(params.ahP),
					session,
					$author$project$Shared$isHintAdmin(shared)),
				ZV: practice,
				tV: $author$project$Api$Data$Loading,
				t9: shared.t9,
				k9: $author$project$Api$Data$NotAsked,
				aa4: session,
				J7: shared.J7,
				vp: $elm$core$Maybe$Nothing
			},
			A3($author$project$Api$Provider$PracticeInvoice$retrieve, shared.Gv, params.ahP, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$GotPracticeInvoice));
	});
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					Ij: $author$project$Shared$isHintAdmin(shared)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$CreatePaymentModalMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$DeleteHiConfirmClosed = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$DownloadInvoiceMsg = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$PaymentsHistoryMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$VoidHiConfirmClosed = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$HiConfirm$subscribeToEscapeKeyPress = function (onClose) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress(
		onClose(false));
};
var $author$project$Components$Invoice$CreatePaymentModal$CardReaderConnectingModalMsg = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Invoice$CreatePaymentModal$CardReaderPaymentModalMsg = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$Invoice$CreatePaymentModal$Close = {$: 0};
var $author$project$Components$Invoice$CreatePaymentModal$GotLocalStorageItem = function (a) {
	return {$: 15, a: a};
};
var $author$project$Ports$LocalStorage$localStorageGotItemPort = _Platform_incomingPort(
	'localStorageGotItemPort',
	A2(
		$elm$json$Json$Decode$andThen,
		function (_v0) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (_v1) {
					return $elm$json$Json$Decode$succeed(
						_Utils_Tuple2(_v0, _v1));
				},
				A2(
					$elm$json$Json$Decode$index,
					1,
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
							]))));
		},
		A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string)));
var $author$project$Ports$LocalStorage$gotItem = function (toMsg) {
	return $author$project$Ports$LocalStorage$localStorageGotItemPort(toMsg);
};
var $author$project$Components$CardReader$ConnectingModal$Cancel = {$: 0};
var $author$project$Components$CardReader$ConnectingModal$StripeReadReusableCardCancelled = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Components$CardReader$ConnectingModal$StripeReaderConnected = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$CardReader$ConnectingModal$StripeReaderDisconnected = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$CardReader$ConnectingModal$StripeReusableCardRead = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Components$CardReader$ConnectingModal$StripeTerminalCreated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ports$StripeTerminal$stripeTerminalPortOnCreated = _Platform_incomingPort('stripeTerminalPortOnCreated', $elm$json$Json$Decode$string);
var $author$project$Ports$StripeTerminal$onCreated = $author$project$Ports$StripeTerminal$stripeTerminalPortOnCreated;
var $author$project$Ports$StripeTerminal$stripeTerminalPortOnReadReusableCardCancelled = _Platform_incomingPort(
	'stripeTerminalPortOnReadReusableCardCancelled',
	A2(
		$elm$json$Json$Decode$andThen,
		function (_v0) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (_v1) {
					return $elm$json$Json$Decode$succeed(
						_Utils_Tuple2(_v0, _v1));
				},
				A2(
					$elm$json$Json$Decode$index,
					1,
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
							]))));
		},
		A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string)));
var $author$project$Ports$StripeTerminal$onReadReusableCardCancelled = function (toMsg) {
	return $author$project$Ports$StripeTerminal$stripeTerminalPortOnReadReusableCardCancelled(
		function (_v0) {
			var token = _v0.a;
			var error = _v0.b;
			var result = function () {
				if (!error.$) {
					var string = error.a;
					return $elm$core$Result$Err(string);
				} else {
					return $elm$core$Result$Ok(0);
				}
			}();
			return A2(toMsg, token, result);
		});
};
var $author$project$Ports$StripeTerminal$stripeTerminalPortOnReaderConnected = _Platform_incomingPort(
	'stripeTerminalPortOnReaderConnected',
	A2(
		$elm$json$Json$Decode$andThen,
		function (_v0) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (_v1) {
					return $elm$json$Json$Decode$succeed(
						_Utils_Tuple2(_v0, _v1));
				},
				A2(
					$elm$json$Json$Decode$index,
					1,
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
							]))));
		},
		A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string)));
var $author$project$Ports$StripeTerminal$onReaderConnected = function (toMsg) {
	return $author$project$Ports$StripeTerminal$stripeTerminalPortOnReaderConnected(
		function (_v0) {
			var token = _v0.a;
			var error = _v0.b;
			var result = function () {
				if (!error.$) {
					var string = error.a;
					return $elm$core$Result$Err(string);
				} else {
					return $elm$core$Result$Ok(0);
				}
			}();
			return A2(toMsg, token, result);
		});
};
var $author$project$Ports$StripeTerminal$stripeTerminalPortOnReusableCardRead = _Platform_incomingPort(
	'stripeTerminalPortOnReusableCardRead',
	A2(
		$elm$json$Json$Decode$andThen,
		function (_v0) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (_v1) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (_v2) {
							return $elm$json$Json$Decode$succeed(
								_Utils_Tuple3(_v0, _v1, _v2));
						},
						A2(
							$elm$json$Json$Decode$index,
							2,
							$elm$json$Json$Decode$oneOf(
								_List_fromArray(
									[
										$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
										A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
									]))));
				},
				A2(
					$elm$json$Json$Decode$index,
					1,
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
							]))));
		},
		A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string)));
var $author$project$Ports$StripeTerminal$onReusableCardRead = function (toMsg) {
	return $author$project$Ports$StripeTerminal$stripeTerminalPortOnReusableCardRead(
		function (_v0) {
			var token = _v0.a;
			var paymentMethodId = _v0.b;
			var error = _v0.c;
			var result = function () {
				if (!paymentMethodId.$) {
					var string = paymentMethodId.a;
					return $elm$core$Result$Ok(string);
				} else {
					return $elm$core$Result$Err(
						A2($elm$core$Maybe$withDefault, $author$project$Ui$Toast$defaultError, error));
				}
			}();
			return A2(toMsg, token, result);
		});
};
var $author$project$Ports$StripeTerminal$stripeTerminalPortOnUnexpectedReaderDisconnect = _Platform_incomingPort('stripeTerminalPortOnUnexpectedReaderDisconnect', $elm$json$Json$Decode$string);
var $author$project$Ports$StripeTerminal$onUnexpectedReaderDisconnect = $author$project$Ports$StripeTerminal$stripeTerminalPortOnUnexpectedReaderDisconnect;
var $author$project$Components$CardReader$ConnectingModal$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ports$StripeTerminal$onCreated($author$project$Components$CardReader$ConnectingModal$StripeTerminalCreated),
				$author$project$Ports$StripeTerminal$onReaderConnected($author$project$Components$CardReader$ConnectingModal$StripeReaderConnected),
				$author$project$Ports$StripeTerminal$onReusableCardRead($author$project$Components$CardReader$ConnectingModal$StripeReusableCardRead),
				$author$project$Ports$StripeTerminal$onReadReusableCardCancelled($author$project$Components$CardReader$ConnectingModal$StripeReadReusableCardCancelled),
				$author$project$Ports$StripeTerminal$onUnexpectedReaderDisconnect($author$project$Components$CardReader$ConnectingModal$StripeReaderDisconnected),
				$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$CardReader$ConnectingModal$Cancel)
			]));
};
var $author$project$Components$CardReader$PaymentModal$Cancel = {$: 0};
var $author$project$Components$CardReader$PaymentModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$CardReader$PaymentModal$Cancel);
};
var $author$project$Components$Invoice$CreatePaymentModal$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				function () {
				var _v1 = _Utils_Tuple2(model.iD, model.cp);
				if (!_v1.a.$) {
					var _v2 = _v1.a.a;
					var cardReaderConnectingModal = _v2.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Components$Invoice$CreatePaymentModal$CardReaderConnectingModalMsg,
						$author$project$Components$CardReader$ConnectingModal$subscriptions(cardReaderConnectingModal));
				} else {
					if (!_v1.b.$) {
						var _v3 = _v1.b.a;
						var cardReaderPaymentModal = _v3.a;
						return A2(
							$elm$core$Platform$Sub$map,
							$author$project$Components$Invoice$CreatePaymentModal$CardReaderPaymentModalMsg,
							$author$project$Components$CardReader$PaymentModal$subscriptions(cardReaderPaymentModal));
					} else {
						var _v4 = _v1.a;
						var _v5 = _v1.b;
						return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Invoice$CreatePaymentModal$Close);
					}
				}
			}(),
				$author$project$Ports$LocalStorage$gotItem($author$project$Components$Invoice$CreatePaymentModal$GotLocalStorageItem),
				$author$project$Ui$Dropdown$subscriptions(model.o5),
				$author$project$Ui$Dropdown$subscriptions(model.mE)
			]));
};
var $author$project$Components$Invoice$DownloadFile$CloseModal = {$: 3};
var $author$project$Components$Invoice$DownloadFile$subscriptions = function (model) {
	return model.U5 ? $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Invoice$DownloadFile$CloseModal) : $author$project$Ui$Dropdown$subscriptions(model.gi);
};
var $author$project$Components$Invoice$PaymentsHistory$PaymentsListMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Popover$isOpen = function (msg) {
	var model = msg;
	return model.Yn;
};
var $author$project$Components$PaymentsList$CancelPaymentHiConfirmClosed = F2(
	function (a, b) {
		return {$: 14, a: a, b: b};
	});
var $author$project$Components$PaymentsList$CancelRefundConfirmed = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$PaymentsList$ClosePaymentDisputeModal = {$: 3};
var $author$project$Components$PaymentsList$CloseRainforestPaymentModal = {$: 6};
var $author$project$Components$PaymentsList$DeleteExternalPaymentHiConfirmClosed = F2(
	function (a, b) {
		return {$: 20, a: a, b: b};
	});
var $author$project$Components$PaymentsList$RefundModalMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$PaymentsList$SimulateDisputeEventModalMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$PaymentsList$SimulateDisputeModalMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Invoice$RefundModal$Close = {$: 0};
var $author$project$Components$Invoice$RefundModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Invoice$RefundModal$Close);
};
var $author$project$Components$DisputeModal$subscriptions = $author$project$Ui$Modal$subscribeToEscapeKeyPress;
var $author$project$Components$PaymentDisputeModal$subscriptions = F2(
	function (model, toMsg) {
		var _v0 = model.QL;
		if (!_v0.$) {
			return $author$project$Components$DisputeModal$subscriptions(toMsg);
		} else {
			return $elm$core$Platform$Sub$none;
		}
	});
var $author$project$Components$Rainforest$SessionModal$subscriptions = $author$project$Ui$Modal$subscribeToEscapeKeyPress;
var $author$project$Components$Rainforest$SimulateDisputeEventModal$CloseModal = {$: 0};
var $author$project$Components$Rainforest$SimulateDisputeEventModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Rainforest$SimulateDisputeEventModal$CloseModal);
};
var $author$project$Components$Rainforest$SimulateDisputeModal$CloseModal = {$: 0};
var $author$project$Components$Rainforest$SimulateDisputeModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Rainforest$SimulateDisputeModal$CloseModal);
};
var $author$project$Components$PaymentsList$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$PaymentsList$RefundModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Invoice$RefundModal$subscriptions, model.kS))),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					function (paymentDisputeModal) {
						return A2($author$project$Components$PaymentDisputeModal$subscriptions, paymentDisputeModal, $author$project$Components$PaymentsList$ClosePaymentDisputeModal);
					},
					model.ha)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Rainforest$SessionModal$subscriptions($author$project$Components$PaymentsList$CloseRainforestPaymentModal)),
					model.e_)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$PaymentsList$SimulateDisputeModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Rainforest$SimulateDisputeModal$subscriptions, model.lt))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$PaymentsList$SimulateDisputeEventModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Rainforest$SimulateDisputeEventModal$subscriptions, model.ls))),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$PaymentsList$CancelPaymentHiConfirmClosed),
						$elm$core$Tuple$first),
					model.c4)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$PaymentsList$CancelRefundConfirmed)),
					model.iC)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$PaymentsList$DeleteExternalPaymentHiConfirmClosed),
						$elm$core$Tuple$first),
					model.ej))
			]));
};
var $author$project$Ui$Popover$Close = 0;
var $elm$browser$Browser$Events$onMouseDown = A2($elm$browser$Browser$Events$on, 0, 'mousedown');
var $author$project$Utils$Dom$outsideTarget = F2(
	function (msg, id) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (isOutside) {
				return isOutside ? $elm$json$Json$Decode$succeed(msg) : $elm$json$Json$Decode$fail('inside target');
			},
			A2(
				$elm$json$Json$Decode$field,
				'target',
				$author$project$Utils$Dom$isOutsideTarget(id)));
	});
var $author$project$Utils$Dom$onOutsideMouseDown = F2(
	function (msg, id) {
		return $elm$browser$Browser$Events$onMouseDown(
			A2($author$project$Utils$Dom$outsideTarget, msg, id));
	});
var $author$project$Ui$Popover$decodePressedKey = function (closeMsg) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (key) {
			return (key === 'Escape') ? $elm$json$Json$Decode$succeed(closeMsg) : $elm$json$Json$Decode$fail('ignore');
		},
		A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
};
var $author$project$Ui$Popover$subscribeToEscapeKeyPress = function (closeMsg) {
	return $elm$browser$Browser$Events$onKeyDown(
		$author$project$Ui$Popover$decodePressedKey(closeMsg));
};
var $author$project$Ui$Popover$subscriptions = function (_v0) {
	var id = _v0.ahP;
	var toMsg = _v0.al6;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$author$project$Utils$Dom$onOutsideMouseDown,
				toMsg(0),
				id),
				$author$project$Ui$Popover$subscribeToEscapeKeyPress(
				toMsg(0))
			]));
};
var $author$project$Components$Invoice$PaymentsHistory$subscriptions = function (_v0) {
	var paymentsList = _v0.kD;
	var popover = _v0.aT;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Invoice$PaymentsHistory$PaymentsListMsg,
				$author$project$Components$PaymentsList$subscriptions(paymentsList)),
				$author$project$Ui$Popover$isOpen(popover) ? $author$project$Ui$Popover$subscriptions(popover) : $elm$core$Platform$Sub$none
			]));
};
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$Dropdown$subscriptions(model.no),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$CreatePaymentModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Invoice$CreatePaymentModal$subscriptions, model.m$))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$DownloadInvoiceMsg,
				$author$project$Components$Invoice$DownloadFile$subscriptions(model.jt)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$PaymentsHistoryMsg,
				$author$project$Components$Invoice$PaymentsHistory$subscriptions(model.kC)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$DeleteHiConfirmClosed),
					A2($elm$core$Maybe$map, $elm$core$Tuple$first, model.i9))),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$VoidHiConfirmClosed),
					A2($elm$core$Maybe$map, $elm$core$Tuple$first, model.vp)))
			]));
};
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$CreateChargeModalMsg = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Deleted = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Issued = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Paid = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Invoice$CreatePaymentModal$PracticeInvoice = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Practice$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Voided = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Adjusted = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Refunded = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$PracticeInvoice$adjust = F4(
	function (apiClient, id_, chargeParams, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practice_invoice',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'charge',
								$author$project$Api$Provider$PracticeCharge$encodeChargeParams(chargeParams))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$PracticeInvoice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['adjust']),
						$author$project$Api$Provider$PracticeInvoice$practiceInvoicePath(id_)))));
	});
var $author$project$Api$Provider$PracticeInvoice$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PracticeInvoice$Shared$id(shared);
};
var $author$project$Api$Provider$PracticeInvoice$refund = F4(
	function (apiClient, id_, chargeParams, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practice_invoice',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'charge',
								$author$project$Api$Provider$PracticeCharge$encodeChargeParams(chargeParams))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$PracticeInvoice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['credit_and_refund']),
						$author$project$Api$Provider$PracticeInvoice$practiceInvoicePath(id_)))));
	});
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$adjustInvoiceAction = F3(
	function (apiClient, practiceInvoice, chargeParams) {
		if (practiceInvoice.$ === 3) {
			var practiceInvoice_ = practiceInvoice.a;
			return (!$author$project$Api$Provider$PracticeInvoice$One$status(practiceInvoice_)) ? A4(
				$author$project$Api$Provider$PracticeInvoice$refund,
				apiClient,
				$author$project$Api$Provider$PracticeInvoice$One$id(practiceInvoice_),
				chargeParams,
				$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Refunded) : A4(
				$author$project$Api$Provider$PracticeInvoice$adjust,
				apiClient,
				$author$project$Api$Provider$PracticeInvoice$One$id(practiceInvoice_),
				chargeParams,
				$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Adjusted);
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Api$Provider$PracticeInvoice$cancel = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$PracticeInvoice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['cancel']),
					$author$project$Api$Provider$PracticeInvoice$practiceInvoicePath(id_))));
	});
var $author$project$Api$Payment$Employer_One = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Payment$Provider_One = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Employer$Payment$One$Payment = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Employer$Payment$Shared$Payment = $elm$core$Basics$identity;
var $author$project$Api$Employer$Payment$Shared$Record = F9(
	function (id, status, amountInCents, attemptedInCents, createdAt, external, errorMessage, source, paymentProcessor) {
		return {LE: amountInCents, L7: attemptedInCents, O1: createdAt, RM: errorMessage, R5: external, ahP: id, Zd: paymentProcessor, JQ: source, alH: status};
	});
var $author$project$Api$Employer$Payment$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'payment_processor',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'source',
		$elm$json$Json$Decode$nullable($author$project$Api$Common$Source$Shared$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'error_message',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'external',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'created_at',
					$elm_community$json_extra$Json$Decode$Extra$datetime,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'attempted_in_cents',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'amount_in_cents',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'status',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'id',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Api$Employer$Payment$Shared$Record))))))))));
var $author$project$Api$Employer$Payment$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Payment$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Payment$One$Record = function (refunds) {
	return {$n: refunds};
};
var $author$project$Api$Employer$Refund$Shared$Refund = $elm$core$Basics$identity;
var $author$project$Api$Employer$Refund$Shared$Record = F5(
	function (id, createdAt, status, amountInCents, paymentProcessor) {
		return {LE: amountInCents, O1: createdAt, ahP: id, Zd: paymentProcessor, alH: status};
	});
var $author$project$Api$Employer$Refund$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'payment_processor',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'amount_in_cents',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'status',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'created_at',
				$elm_community$json_extra$Json$Decode$Extra$datetime,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Employer$Refund$Shared$Record))))));
var $author$project$Api$Employer$Refund$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Refund$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Payment$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'refunds',
	$elm$json$Json$Decode$list($author$project$Api$Employer$Refund$Shared$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Employer$Payment$One$Record));
var $author$project$Api$Employer$Payment$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Payment$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Employer$Payment$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$Payment$One$Payment)));
var $author$project$Currency$encode = A2(
	$elm$core$Basics$composeR,
	$author$project$Currency$toInt,
	$author$project$Utils$Encode$nullable($elm$json$Json$Encode$int));
var $author$project$Utils$Date$toIsoString = function (date) {
	return $justinmimbs$date$Date$toIsoString(date);
};
var $author$project$Utils$Date$encode = function (date) {
	return $elm$json$Json$Encode$string(
		$author$project$Utils$Date$toIsoString(date));
};
var $author$project$Api$Payment$paymentsPath = function (basePath) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['payments']),
		basePath);
};
var $author$project$Utils$Encode$typedAssociation = function (fields) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ahP)),
				_Utils_Tuple2(
				'type',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.amg))
			]));
};
var $author$project$Api$Payment$create = F7(
	function (basePath, apiClient, session, payableKey, payableId, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'payment',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								payableKey,
								$elm$json$Json$Encode$string(payableId)),
								_Utils_Tuple2(
								'source',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$typedAssociation, fields.JQ)),
								_Utils_Tuple2(
								'amount_in_cents',
								$author$project$Currency$encode(fields.LE)),
								_Utils_Tuple2(
								'external',
								$elm$json$Json$Encode$bool(fields.R5)),
								_Utils_Tuple2(
								'memo',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.aiG)),
								_Utils_Tuple2(
								'paid_at',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.YH)),
								_Utils_Tuple2(
								'card_reader',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.aft)),
								_Utils_Tuple2(
								'source_one_time_use',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$bool, fields.alB)),
								_Utils_Tuple2(
								'selected_card_type',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.alk)),
								_Utils_Tuple2(
								'selected_card_funding',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.alj))
							])))
				]));
		return ($author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Employer$Payment$One$decoder,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Payment$Employer_One))) : A3(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Payment$One$decoder,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Payment$Provider_One))))(
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Payment$paymentsPath(basePath))));
	});
var $author$project$Api$Provider$PracticeInvoice$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$PracticeInvoice$practiceInvoicePath(id_)));
	});
var $author$project$Api$Common$Source$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Practice$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Practice$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$id(shared);
};
var $author$project$Components$Invoice$CreatePaymentModal$CardReaderDropdownMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Invoice$CreatePaymentModal$External = 1;
var $author$project$Components$Invoice$CreatePaymentModal$GotBankAccounts = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Invoice$CreatePaymentModal$GotCards = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Invoice$CreatePaymentModal$GotPassthroughFees = function (a) {
	return {$: 20, a: a};
};
var $author$project$Components$Invoice$CreatePaymentModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Invoice$CreatePaymentModal$PayNow = 0;
var $author$project$Components$Invoice$CreatePaymentModal$PaymentSourceDropdownMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Practice$One$allowMultipleRetailMemberships = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Lw;
	});
var $author$project$Api$Practice$allowMultipleRetailMemberships = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$allowMultipleRetailMemberships(practice_);
	} else {
		return false;
	}
};
var $author$project$Api$Provider$Patient$patientsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['patients']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Patient$patientPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$Patient$patientsPath);
};
var $author$project$Api$Provider$PassthroughFee$One$calculatePassthroughFeesPath = function (patientId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['calculate']),
		A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				['passthroughs']),
			$author$project$Api$Provider$Patient$patientPath(patientId)));
};
var $author$project$Api$Provider$PassthroughFee$One$PassthroughFee = $elm$core$Basics$identity;
var $author$project$Api$Provider$PassthroughFee$Shared$PassthroughFee = $elm$core$Basics$identity;
var $author$project$Api$Provider$PassthroughFee$Shared$InternalRecord = F2(
	function (passthroughFeeInCents, totalInCents) {
		return {YU: passthroughFeeInCents, adp: totalInCents};
	});
var $author$project$Api$Provider$PassthroughFee$Shared$internalRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'total_in_cents',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'passthrough_fees_in_cents',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$PassthroughFee$Shared$InternalRecord)));
var $author$project$Api$Provider$PassthroughFee$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PassthroughFee$Shared$internalRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PassthroughFee$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PassthroughFee$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PassthroughFee$One$calculatePassthroughFees = F6(
	function (apiClient, patientId, paymentMethodId, type_, amountInCents, toMsg) {
		var _v0 = function () {
			_v1$3:
			while (true) {
				if (!type_.$) {
					switch (type_.a) {
						case 'credit':
							return _Utils_Tuple2(
								$elm$core$Maybe$Just('card'),
								$elm$core$Maybe$Just('credit'));
						case 'amex':
							return _Utils_Tuple2(
								$elm$core$Maybe$Just('amex'),
								$elm$core$Maybe$Just('credit'));
						case 'debit':
							return _Utils_Tuple2(
								$elm$core$Maybe$Just('card'),
								$elm$core$Maybe$Just('debit'));
						default:
							break _v1$3;
					}
				} else {
					break _v1$3;
				}
			}
			return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
		}();
		var cardType = _v0.a;
		var cardFunding = _v0.b;
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'passthrough',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'amount_in_cents',
								$elm$json$Json$Encode$int(amountInCents)),
								_Utils_Tuple2(
								'payment_method_id',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, paymentMethodId)),
								_Utils_Tuple2(
								'card_type',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, cardType)),
								_Utils_Tuple2(
								'card_funding',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, cardFunding))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$PassthroughFee$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$PassthroughFee$One$calculatePassthroughFeesPath(patientId))));
	});
var $author$project$Components$Invoice$CreatePaymentModal$Card = 2;
var $author$project$Components$Invoice$CreatePaymentModal$Cash = 1;
var $author$project$Components$Invoice$CreatePaymentModal$Check = 0;
var $author$project$Components$Invoice$CreatePaymentModal$Other = 4;
var $author$project$Components$Invoice$CreatePaymentModal$defaultOptions = {
	Hn: 0,
	r2: 0,
	R5: false,
	HG: _List_fromArray(
		[0, 1, 2, 4]),
	YV: $elm$core$Maybe$Nothing,
	alv: false
};
var $author$project$Components$Invoice$CreatePaymentModal$Manual = 0;
var $author$project$Components$Invoice$CreatePaymentModal$PaidAtDateInputMsg = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Api$Source$Source = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Employer$Invoice$Shared$dueInCents = function (_v0) {
	var record = _v0;
	return record.QY;
};
var $author$project$Api$Employer$Invoice$One$dueInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Invoice$Shared$dueInCents(shared);
};
var $author$project$Api$Provider$Invoice$Shared$dueInCents = function (_v0) {
	var record = _v0.b;
	return record.QY;
};
var $author$project$Api$Provider$Invoice$One$dueInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Invoice$Shared$dueInCents(shared);
};
var $author$project$Api$Invoice$One$dueInCents = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$One$dueInCents(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$One$dueInCents(invoice_);
	}
};
var $author$project$Api$Provider$CustomerInvoice$Shared$dueInCents = function (_v0) {
	var record = _v0;
	return record.QY;
};
var $author$project$Api$Provider$CustomerInvoice$One$dueInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CustomerInvoice$Shared$dueInCents(shared);
};
var $author$project$Api$Provider$Statement$Shared$dueInCents = function (_v0) {
	var record = _v0;
	return record.QY;
};
var $author$project$Api$Provider$Statement$One$dueInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Statement$Shared$dueInCents(shared);
};
var $author$project$Api$Provider$CustomerInvoice$One$membershipPaymentSource = function (_v0) {
	var record = _v0.b;
	return record.WT;
};
var $elm_community$maybe_extra$Maybe$Extra$orElse = F2(
	function (ma, mb) {
		if (mb.$ === 1) {
			return ma;
		} else {
			return mb;
		}
	});
var $author$project$Api$Employer$Invoice$One$source = function (_v0) {
	var record = _v0.b;
	return record.JQ;
};
var $author$project$Api$Provider$Invoice$One$source = function (_v0) {
	var record = _v0.b;
	return record.JQ;
};
var $author$project$Api$Invoice$One$source = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$One$source(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$One$source(invoice_);
	}
};
var $author$project$Api$Provider$CustomerInvoice$One$source = function (_v0) {
	var record = _v0.b;
	return record.JQ;
};
var $author$project$Api$Provider$PracticeInvoice$One$source = function (_v0) {
	var record = _v0.b;
	return record.JQ;
};
var $author$project$Components$Invoice$CreatePaymentModal$formFieldsFromPayable = F5(
	function (today, external, defaultExternalSource, allowMultipleMemberships, payable) {
		var _v0 = function () {
			switch (payable.$) {
				case 0:
					var practiceInvoice = payable.b;
					return _Utils_Tuple2(
						$author$project$Api$Provider$PracticeInvoice$One$dueInCents(practiceInvoice),
						A2(
							$elm$core$Maybe$map,
							$author$project$Api$Source$Source,
							$author$project$Api$Provider$PracticeInvoice$One$source(practiceInvoice)));
				case 1:
					var invoice = payable.b;
					return _Utils_Tuple2(
						$author$project$Api$Invoice$One$dueInCents(invoice),
						A2(
							$elm$core$Maybe$map,
							$author$project$Api$Source$Source,
							$author$project$Api$Invoice$One$source(invoice)));
				case 2:
					var invoice = payable.b;
					return _Utils_Tuple2(
						$author$project$Api$Invoice$One$dueInCents(invoice),
						A2(
							$elm$core$Maybe$map,
							$author$project$Api$Source$Source,
							$author$project$Api$Invoice$One$source(invoice)));
				case 3:
					var invoice = payable.b;
					return _Utils_Tuple2(
						$author$project$Api$Provider$CustomerInvoice$One$dueInCents(invoice),
						allowMultipleMemberships ? A2(
							$elm_community$maybe_extra$Maybe$Extra$orElse,
							A2(
								$elm$core$Maybe$map,
								$author$project$Api$Source$Source,
								$author$project$Api$Provider$CustomerInvoice$One$source(invoice)),
							A2(
								$elm$core$Maybe$map,
								$author$project$Api$Source$Source,
								$author$project$Api$Provider$CustomerInvoice$One$membershipPaymentSource(invoice))) : A2(
							$elm$core$Maybe$map,
							$author$project$Api$Source$Source,
							$author$project$Api$Provider$CustomerInvoice$One$source(invoice)));
				default:
					var statement = payable.b;
					return _Utils_Tuple2(
						$author$project$Api$Provider$Statement$One$dueInCents(statement),
						$elm$core$Maybe$Nothing);
			}
		}();
		var dueInCents = _v0.a;
		var defaultSource = _v0.b;
		var _v2 = $author$project$Components$DateInput$init;
		var dateInput = _v2.a;
		var dateInputCmd = _v2.b;
		return _Utils_Tuple2(
			{
				LE: $elm$core$Maybe$Just(
					$author$project$Currency$fromInt(dueInCents)),
				c6: 0,
				aft: $elm$core$Maybe$Nothing,
				No: $elm$core$Maybe$Nothing,
				R5: external,
				nF: defaultExternalSource,
				j$: dueInCents,
				aiG: $elm$core$Maybe$Nothing,
				YH: $elm$core$Maybe$Just(today),
				tB: dateInput,
				JQ: defaultSource,
				EM: false
			},
			A2(
				$elm$core$Platform$Cmd$map,
				$author$project$Components$Invoice$CreatePaymentModal$PaidAtDateInputMsg(dateInput),
				dateInputCmd));
	});
var $author$project$Api$Employer$BankAccount$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Employer$BankAccount$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$BankAccount$Shared$id(shared);
};
var $author$project$Api$Employer$BankAccount$All$id = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$BankAccount$One$id(one);
};
var $author$project$Api$Provider$BankAccount$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$BankAccount$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BankAccount$Shared$id(shared);
};
var $author$project$Api$Provider$BankAccount$All$id = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BankAccount$One$id(one);
};
var $author$project$Api$BankAccount$id = function (bankAccount) {
	switch (bankAccount.$) {
		case 0:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$One$id(bankAccount_);
		case 1:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$All$id(bankAccount_);
		case 2:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$One$id(bankAccount_);
		default:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$All$id(bankAccount_);
	}
};
var $author$project$Api$Employer$Card$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Employer$Card$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Card$Shared$id(shared);
};
var $author$project$Api$Employer$Card$All$id = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$Card$One$id(one);
};
var $author$project$Api$Provider$Card$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Card$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Card$Shared$id(shared);
};
var $author$project$Api$Provider$Card$All$id = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Card$One$id(one);
};
var $author$project$Api$Card$id = function (card) {
	switch (card.$) {
		case 0:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$One$id(card_);
		case 1:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$All$id(card_);
		case 2:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$One$id(card_);
		default:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$All$id(card_);
	}
};
var $author$project$Api$Source$id = function (source) {
	switch (source.$) {
		case 0:
			var card = source.a;
			return $author$project$Api$Card$id(card);
		case 1:
			var bankAccount = source.a;
			return $author$project$Api$BankAccount$id(bankAccount);
		default:
			var source_ = source.a;
			return A2(
				$elm$core$Maybe$withDefault,
				'external',
				$author$project$Api$Common$Source$Shared$id(source_));
	}
};
var $author$project$Api$BankAccount$EmployerAll = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Employer$BankAccount$bankAccountsPath = function (basePath) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['bank_accounts']),
		basePath);
};
var $author$project$Api$Employer$BankAccount$All$BankAccount = $elm$core$Basics$identity;
var $author$project$Api$Employer$BankAccount$One$BankAccount = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Employer$BankAccount$Shared$BankAccount = $elm$core$Basics$identity;
var $author$project$Api$Employer$BankAccount$Shared$Record = function (id) {
	return function (name) {
		return function (type_) {
			return function (lastFour) {
				return function (status) {
					return function (label) {
						return function (errorMessage) {
							return function (lastPaymentErrorMessage) {
								return function (createdAt) {
									return function (bankName) {
										return function (paymentProcessor) {
											return {Mw: bankName, O1: createdAt, RM: errorMessage, ahP: id, aih: label, VG: lastFour, VI: lastPaymentErrorMessage, Bq: name, Zd: paymentProcessor, alH: status, amg: type_};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Employer$BankAccount$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'payment_processor',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'bank_name',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'created_at',
			$elm_community$json_extra$Json$Decode$Extra$datetime,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'last_payment_error_message',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'error_message',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'label',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'status',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'last_four',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'type',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'name',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'id',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$Api$Employer$BankAccount$Shared$Record))))))))))));
var $author$project$Api$Employer$BankAccount$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$BankAccount$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$BankAccount$One$Record = function (_default) {
	return {PW: _default};
};
var $author$project$Api$Employer$BankAccount$One$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'default',
	$elm$json$Json$Decode$bool,
	false,
	$elm$json$Json$Decode$succeed($author$project$Api$Employer$BankAccount$One$Record));
var $author$project$Api$Employer$BankAccount$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$BankAccount$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Employer$BankAccount$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$BankAccount$One$BankAccount)));
var $author$project$Api$Employer$BankAccount$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$BankAccount$One$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$BankAccount$list = F3(
	function (basePath, apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Employer$BankAccount$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Employer$BankAccount$bankAccountsPath(basePath)));
	});
var $author$project$Api$BankAccount$list = F4(
	function (basePath, apiClient, session, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$BankAccount$list,
			basePath,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$BankAccount$EmployerAll)))) : A3(
			$author$project$Api$Provider$BankAccount$list,
			basePath,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$BankAccount$ProviderAll))));
	});
var $author$project$Api$Card$EmployerAll = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Employer$Card$cardsPath = function (basePath) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['cards']),
		basePath);
};
var $author$project$Api$Employer$Card$All$Card = $elm$core$Basics$identity;
var $author$project$Api$Employer$Card$One$Card = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Employer$Card$Shared$Card = $elm$core$Basics$identity;
var $author$project$Api$Employer$Card$Shared$Record = function (id) {
	return function (name) {
		return function (type_) {
			return function (lastFour) {
				return function (status) {
					return function (label) {
						return function (errorMessage) {
							return function (lastPaymentErrorMessage) {
								return function (expMonth) {
									return function (expYear) {
										return function (createdAt) {
											return function (cardType) {
												return function (zip) {
													return function (paymentProcessor) {
														return {No: cardType, O1: createdAt, RM: errorMessage, ag3: expMonth, ag4: expYear, ahP: id, aih: label, VG: lastFour, VI: lastPaymentErrorMessage, Bq: name, Zd: paymentProcessor, alH: status, amg: type_, vv: zip};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Employer$Card$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'payment_processor',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'zip',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'card_type',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'created_at',
				$elm_community$json_extra$Json$Decode$Extra$datetime,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'exp_year',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'exp_month',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'last_payment_error_message',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'error_message',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'label',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'status',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'last_four',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'type',
												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'name',
													$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'id',
														$elm$json$Json$Decode$string,
														$elm$json$Json$Decode$succeed($author$project$Api$Employer$Card$Shared$Record)))))))))))))));
var $author$project$Api$Employer$Card$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Card$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Card$One$Record = function (_default) {
	return {PW: _default};
};
var $author$project$Api$Employer$Card$One$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'default',
	$elm$json$Json$Decode$bool,
	false,
	$elm$json$Json$Decode$succeed($author$project$Api$Employer$Card$One$Record));
var $author$project$Api$Employer$Card$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Card$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Employer$Card$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$Card$One$Card)));
var $author$project$Api$Employer$Card$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Card$One$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Card$list = F3(
	function (basePath, apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Employer$Card$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Employer$Card$cardsPath(basePath)));
	});
var $author$project$Api$Card$list = F4(
	function (basePath, apiClient, session, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$Card$list,
			basePath,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$Card$EmployerAll)))) : A3(
			$author$project$Api$Provider$Card$list,
			basePath,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$Card$ProviderAll))));
	});
var $author$project$Components$Invoice$CreatePaymentModal$sourceIsACreditCard = F2(
	function (useExistingSources, _v0) {
		var source = _v0.JQ;
		var cardType = _v0.No;
		var _v1 = _Utils_Tuple3(
			useExistingSources,
			A2($elm$core$Maybe$andThen, $author$project$Api$Source$type_, source),
			cardType);
		_v1$3:
		while (true) {
			if (_v1.a) {
				if ((!_v1.b.$) && (_v1.b.a === 'Card')) {
					return true;
				} else {
					break _v1$3;
				}
			} else {
				if (!_v1.c.$) {
					switch (_v1.c.a) {
						case 'credit':
							return true;
						case 'amex':
							return true;
						default:
							break _v1$3;
					}
				} else {
					break _v1$3;
				}
			}
		}
		return false;
	});
var $author$project$Components$Invoice$CreatePaymentModal$init = function (today) {
	return function (timeFormatter) {
		return function (paymentPath) {
			return function (sourcePath) {
				return function (apiClient) {
					return function (session) {
						return function (practice) {
							return function (isHintAdmin) {
								return function (rainforestEnv) {
									return function (optionsBuilder) {
										return function (payable) {
											var options = optionsBuilder($author$project$Components$Invoice$CreatePaymentModal$defaultOptions);
											var displayModal = options.R5 ? 1 : 0;
											var _v0 = function () {
												var _v1 = _Utils_Tuple2(options.R5, sourcePath);
												if ((!_v1.a) && (!_v1.b.$)) {
													var sourcePath_ = _v1.b.a;
													return _Utils_Tuple2(
														$elm$core$Platform$Cmd$batch(
															_List_fromArray(
																[
																	A4($author$project$Api$Card$list, sourcePath_, apiClient, session, $author$project$Components$Invoice$CreatePaymentModal$GotCards),
																	A4($author$project$Api$BankAccount$list, sourcePath_, apiClient, session, $author$project$Components$Invoice$CreatePaymentModal$GotBankAccounts)
																])),
														$author$project$Api$Data$Loading);
												} else {
													return _Utils_Tuple2($elm$core$Platform$Cmd$none, $author$project$Api$Data$NotAsked);
												}
											}();
											var sourceCmd = _v0.a;
											var sourceStatus = _v0.b;
											var _v2 = A5(
												$author$project$Components$Invoice$CreatePaymentModal$formFieldsFromPayable,
												today,
												options.R5,
												options.Hn,
												$author$project$Api$Practice$allowMultipleRetailMemberships(practice),
												payable);
											var fields = _v2.a;
											var fieldsCmd = _v2.b;
											var _v3 = function () {
												var _v4 = _Utils_Tuple2(
													options.YV,
													A2($author$project$Components$Invoice$CreatePaymentModal$sourceIsACreditCard, true, fields));
												if ((!_v4.a.$) && _v4.b) {
													var patientId = _v4.a.a.YZ;
													return _Utils_Tuple2(
														$author$project$Api$Data$Loading,
														A6(
															$author$project$Api$Provider$PassthroughFee$One$calculatePassthroughFees,
															apiClient,
															patientId,
															A2($elm$core$Maybe$map, $author$project$Api$Source$id, fields.JQ),
															fields.No,
															fields.j$,
															$author$project$Components$Invoice$CreatePaymentModal$GotPassthroughFees));
												} else {
													return _Utils_Tuple2($author$project$Api$Data$NotAsked, $elm$core$Platform$Cmd$none);
												}
											}();
											var initialPassthroughFees = _v3.a;
											var passthroughFeesCmd = _v3.b;
											return _Utils_Tuple2(
												{
													rs: sourceStatus,
													iD: $elm$core$Maybe$Nothing,
													mE: $author$project$Ui$Dropdown$init(
														$author$project$Ui$Dropdown$defaultConfig(
															{ahP: 'card-reader-dropdown', al6: $author$project$Components$Invoice$CreatePaymentModal$CardReaderDropdownMsg})),
													cp: $elm$core$Maybe$Nothing,
													mF: '',
													iE: $author$project$Api$Data$NotAsked,
													rC: sourceStatus,
													r2: displayModal,
													SD: $author$project$Utils$Form$init(fields),
													Ij: isHintAdmin,
													Cd: options,
													YV: initialPassthroughFees,
													ajV: payable,
													an: $author$project$Api$Data$NotAsked,
													tK: paymentPath,
													o5: $author$project$Ui$Dropdown$init(
														$author$project$Ui$Dropdown$defaultConfig(
															{ahP: 'source-dropdown', al6: $author$project$Components$Invoice$CreatePaymentModal$PaymentSourceDropdownMsg})),
													o6: '',
													ZV: practice,
													t9: rainforestEnv,
													aa4: session,
													JR: sourcePath,
													uZ: fields.j$,
													J7: timeFormatter,
													FR: today,
													bP: true
												},
												$elm$core$Platform$Cmd$batch(
													_List_fromArray(
														[fieldsCmd, sourceCmd, passthroughFeesCmd])));
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$PracticeInvoice$issue = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$PracticeInvoice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['issue']),
					$author$project$Api$Provider$PracticeInvoice$practiceInvoicePath(id_))));
	});
var $author$project$Components$CardReader$ConnectingModal$Affiliate = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$CardReader$ConnectingModal$BrokerAccount = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Invoice$CreatePaymentModal$CardReader = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Invoice$CreatePaymentModal$Closed = 0;
var $author$project$Components$CardReader$ConnectingModal$Company = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Invoice$CreatePaymentModal$None = 1;
var $author$project$Components$Invoice$CreatePaymentModal$PaidAt = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$CardReader$ConnectingModal$Patient = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Invoice$CreatePaymentModal$PaymentCreated = 2;
var $author$project$Components$CardReader$ConnectingModal$Practice = function (a) {
	return {$: 2, a: a};
};
var $author$project$OutMsg$RefreshPatientsList = {$: 12};
var $author$project$Components$Invoice$CreatePaymentModal$Source = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Payment$Shared$cardReader = function (_v0) {
	var record = _v0;
	return record.aft;
};
var $author$project$Api$Provider$Payment$One$cardReader = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$cardReader(shared);
};
var $author$project$Api$Provider$Payment$SharedWithRefunds$cardReader = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$cardReader(shared);
};
var $author$project$Api$Payment$cardReader = function (payment) {
	switch (payment.$) {
		case 1:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$One$cardReader(payment_);
		case 0:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$SharedWithRefunds$cardReader(payment_);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Invoice$CreatePaymentModal$CardCreated = F2(
	function (a, b) {
		return {$: 19, a: a, b: b};
	});
var $author$project$Api$Card$EmployerOne = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Card$ProviderOne = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$PaymentProcessorParams$encode = function (param) {
	if (!param.$) {
		var stripeId = param.a;
		return _List_fromArray(
			[
				_Utils_Tuple2(
				'payment_processor',
				$elm$json$Json$Encode$string('stripe')),
				_Utils_Tuple2(
				'stripe_id',
				$elm$json$Json$Encode$string(stripeId))
			]);
	} else {
		var rainforestId = param.a;
		return _List_fromArray(
			[
				_Utils_Tuple2(
				'payment_processor',
				$elm$json$Json$Encode$string('rainforest')),
				_Utils_Tuple2(
				'rainforest_id',
				$elm$json$Json$Encode$string(rainforestId))
			]);
	}
};
var $author$project$Api$Employer$Card$create = F4(
	function (basePath, apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'card',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'card_type',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.No)),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'last_four',
									A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.VG)),
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										'created_via',
										A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.O4)),
									$author$project$Api$PaymentProcessorParams$encode(fields.Ze))))))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Employer$Card$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Employer$Card$cardsPath(basePath))));
	});
var $author$project$Api$Provider$Card$create = F4(
	function (basePath, apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'card',
					$elm$json$Json$Encode$object(
						$elm$core$List$concat(
							_List_fromArray(
								[
									_List_fromArray(
									[
										_Utils_Tuple2(
										'card_type',
										A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.No)),
										_Utils_Tuple2(
										'last_four',
										A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.VG)),
										_Utils_Tuple2(
										'created_via',
										A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.O4))
									]),
									$author$project$Api$PaymentProcessorParams$encode(fields.Ze),
									function () {
									var _v0 = fields.Yl;
									if (!_v0.$) {
										var oneTimeUse = _v0.a;
										return _List_fromArray(
											[
												_Utils_Tuple2(
												'one_time_use',
												$elm$json$Json$Encode$bool(oneTimeUse))
											]);
									} else {
										return _List_Nil;
									}
								}()
								]))))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Card$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Card$cardsPath(basePath))));
	});
var $author$project$Api$Card$create = F5(
	function (basePath, apiClient, session, fields, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4(
			$author$project$Api$Employer$Card$create,
			basePath,
			apiClient,
			{No: fields.No, O4: fields.O4, VG: fields.VG, Ze: fields.Ze},
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Card$EmployerOne))) : A4(
			$author$project$Api$Provider$Card$create,
			basePath,
			apiClient,
			fields,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Card$ProviderOne)));
	});
var $author$project$Components$Invoice$CreatePaymentModal$createCard = F5(
	function (basePath, apiClient, session, formFields, readCard) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Platform$Cmd$none,
			A2(
				$elm$core$Maybe$map,
				function (basePath_) {
					return A5(
						$author$project$Api$Card$create,
						basePath_,
						apiClient,
						session,
						{
							No: $elm$core$Maybe$Nothing,
							O4: $elm$core$Maybe$Just(readCard.O4),
							VG: $elm$core$Maybe$Nothing,
							Yl: $elm$core$Maybe$Just(readCard.Yl),
							Ze: readCard.Ze
						},
						$author$project$Components$Invoice$CreatePaymentModal$CardCreated(formFields));
				},
				basePath));
	});
var $author$project$Components$Invoice$CreatePaymentModal$Created = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Components$Invoice$CreatePaymentModal$externalSourceCode = function (externalSource) {
	switch (externalSource) {
		case 0:
			return 'check';
		case 1:
			return 'cash';
		case 2:
			return 'card';
		case 3:
			return 'eft';
		default:
			return 'other';
	}
};
var $author$project$Api$Provider$CardReader$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$CardReader$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CardReader$Shared$id(shared);
};
var $author$project$Api$Employer$Invoice$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Employer$Invoice$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Invoice$Shared$id(shared);
};
var $author$project$Api$Provider$Invoice$Min$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Invoice$Shared$id = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Provider$Invoice$Min$id(min);
};
var $author$project$Api$Provider$Invoice$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Invoice$Shared$id(shared);
};
var $author$project$Api$Invoice$One$id = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$One$id(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$One$id(invoice_);
	}
};
var $author$project$Api$Provider$CustomerInvoice$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$CustomerInvoice$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CustomerInvoice$Shared$id(shared);
};
var $author$project$Api$Provider$Statement$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Statement$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Statement$Shared$id(shared);
};
var $author$project$Components$Invoice$CreatePaymentModal$payableIdAndKey = function (payable) {
	var payableKey = function () {
		switch (payable.$) {
			case 0:
				return 'practice_invoice_id';
			case 1:
				return 'invoice_id';
			case 2:
				return 'affiliate_bill_id';
			case 3:
				return 'customer_invoice_id';
			default:
				return 'statement_id';
		}
	}();
	var payableId = function () {
		switch (payable.$) {
			case 0:
				var practiceInvoice = payable.b;
				return $author$project$Api$Provider$PracticeInvoice$One$id(practiceInvoice);
			case 1:
				var invoice = payable.b;
				return $author$project$Api$Invoice$One$id(invoice);
			case 2:
				var invoice = payable.b;
				return $author$project$Api$Invoice$One$id(invoice);
			case 3:
				var invoice = payable.b;
				return $author$project$Api$Provider$CustomerInvoice$One$id(invoice);
			default:
				var statement = payable.b;
				return $author$project$Api$Provider$Statement$One$id(statement);
		}
	}();
	return _Utils_Tuple2(payableKey, payableId);
};
var $author$project$Components$Invoice$CreatePaymentModal$createPayment = F8(
	function (options, basePath, apiClient, session, payable, formFields, cardReaderCard, cardReader) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var selectedSource = function () {
			if (options.R5) {
				return $elm$core$Maybe$Just(
					{
						ahP: $elm$core$Maybe$Nothing,
						amg: $elm$core$Maybe$Just(
							$author$project$Components$Invoice$CreatePaymentModal$externalSourceCode(fields.nF))
					});
			} else {
				var _v3 = _Utils_Tuple2(cardReaderCard, cardReader);
				if (_v3.a.$ === 1) {
					if (_v3.b.$ === 1) {
						var _v4 = _v3.a;
						var _v5 = _v3.b;
						return A2(
							$elm$core$Maybe$map,
							function (source) {
								return {
									ahP: $elm$core$Maybe$Just(
										$author$project$Api$Source$id(source)),
									amg: $author$project$Api$Source$type_(source)
								};
							},
							fields.JQ);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				} else {
					var cardReaderCard_ = _v3.a.a;
					return $elm$core$Maybe$Just(
						{
							ahP: $elm$core$Maybe$Just(
								$author$project$Api$Card$id(cardReaderCard_)),
							amg: $author$project$Api$Card$type_(cardReaderCard_)
						});
				}
			}
		}();
		var _v0 = function () {
			var _v1 = _Utils_Tuple2(options.YV, fields.No);
			_v1$3:
			while (true) {
				if ((!_v1.a.$) && (!_v1.b.$)) {
					switch (_v1.b.a) {
						case 'credit':
							return _Utils_Tuple2(
								$elm$core$Maybe$Just('card'),
								$elm$core$Maybe$Just('credit'));
						case 'amex':
							return _Utils_Tuple2(
								$elm$core$Maybe$Just('amex'),
								$elm$core$Maybe$Just('credit'));
						case 'debit':
							return _Utils_Tuple2(
								$elm$core$Maybe$Just('card'),
								$elm$core$Maybe$Just('debit'));
						default:
							break _v1$3;
					}
				} else {
					break _v1$3;
				}
			}
			return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
		}();
		var selectedCardType = _v0.a;
		var selectedCardFunding = _v0.b;
		var _v2 = $author$project$Components$Invoice$CreatePaymentModal$payableIdAndKey(payable);
		var payableKey = _v2.a;
		var payableId = _v2.b;
		return A7(
			$author$project$Api$Payment$create,
			basePath,
			apiClient,
			session,
			payableKey,
			payableId,
			{
				LE: A2(
					$elm$core$Maybe$withDefault,
					$author$project$Currency$fromInt(fields.j$),
					fields.LE),
				aft: A2($elm$core$Maybe$map, $author$project$Api$Provider$CardReader$All$id, cardReader),
				R5: fields.R5,
				aiG: fields.aiG,
				YH: fields.YH,
				alj: selectedCardFunding,
				alk: selectedCardType,
				JQ: selectedSource,
				alB: $elm$core$Maybe$Just(!fields.EM)
			},
			$author$project$Components$Invoice$CreatePaymentModal$Created(formFields));
	});
var $author$project$Api$Employer$Payment$Shared$external = function (_v0) {
	var record = _v0;
	return record.R5;
};
var $author$project$Api$Employer$Payment$One$external = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Payment$Shared$external(shared);
};
var $author$project$Api$Provider$Payment$Shared$external = function (_v0) {
	var record = _v0;
	return record.R5;
};
var $author$project$Api$Provider$Payment$One$external = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$external(shared);
};
var $author$project$Api$Provider$Payment$SharedWithRefunds$external = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$external(shared);
};
var $author$project$Api$Payment$external = function (payment) {
	switch (payment.$) {
		case 1:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$One$external(payment_);
		case 0:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$SharedWithRefunds$external(payment_);
		default:
			var payment_ = payment.a;
			return $author$project$Api$Employer$Payment$One$external(payment_);
	}
};
var $author$project$Components$Invoice$CreatePaymentModal$GotCardReaders = function (a) {
	return {$: 14, a: a};
};
var $author$project$Api$Provider$CardReader$cardReadersPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['card_readers']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$CardReader$All$CardReader = $elm$core$Basics$identity;
var $author$project$Api$Provider$CardReader$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CardReader$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CardReader$listDefaults = {ajJ: $author$project$Api$Pagination$init};
var $author$project$Api$Provider$CardReader$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$CardReader$listDefaults);
	return $author$project$Api$Pagination$toApiParams(options.ajJ);
};
var $author$project$Api$Provider$CardReader$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$CardReader$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$CardReader$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$CardReader$cardReadersPath)));
	});
var $author$project$Components$Invoice$CreatePaymentModal$fetchCardReaders = function (apiClient) {
	return A3($author$project$Api$Provider$CardReader$list, apiClient, $elm$core$Basics$identity, $author$project$Components$Invoice$CreatePaymentModal$GotCardReaders);
};
var $author$project$Components$Invoice$CreatePaymentModal$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var _int = field.a;
				return _Utils_update(
					fields,
					{LE: _int});
			case 1:
				var dateInput = field.a;
				var date = field.b;
				return _Utils_update(
					fields,
					{YH: date, tB: dateInput});
			case 2:
				var externalSource = field.a;
				return _Utils_update(
					fields,
					{nF: externalSource});
			case 4:
				var source = field.a;
				return _Utils_update(
					fields,
					{JQ: source});
			case 3:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						aiG: $author$project$Utils$String$toMaybe(string)
					});
			case 5:
				var cardReader = field.a;
				return _Utils_update(
					fields,
					{aft: cardReader});
			case 6:
				var bool = field.a;
				return _Utils_update(
					fields,
					{EM: bool});
			default:
				var cardType = field.a;
				return _Utils_update(
					fields,
					{
						No: $author$project$Utils$String$toMaybe(cardType)
					});
		}
	});
var $author$project$Components$Invoice$CreatePaymentModal$CardReaderValidation = 1;
var $author$project$Components$Invoice$CreatePaymentModal$CardTypeValidation = 3;
var $author$project$Components$Invoice$CreatePaymentModal$AmountInCentsValidation = 0;
var $author$project$Currency$isValid = F2(
	function (options, currency) {
		var _v0 = $author$project$Currency$toInt(currency);
		if (!_v0.$) {
			var _int = _v0.a;
			var _v1 = _Utils_Tuple2(options.W9, options.AU);
			if (!_v1.a.$) {
				if (!_v1.b.$) {
					var min = _v1.a.a;
					var max = _v1.b.a;
					return !((_Utils_cmp(_int, min) < 0) || (_Utils_cmp(_int, max) > 0));
				} else {
					var min = _v1.a.a;
					var _v2 = _v1.b;
					return _Utils_cmp(_int, min) > -1;
				}
			} else {
				if (!_v1.b.$) {
					var _v3 = _v1.a;
					var max = _v1.b.a;
					return _Utils_cmp(_int, max) < 1;
				} else {
					var _v4 = _v1.a;
					var _v5 = _v1.b;
					return true;
				}
			}
		} else {
			return false;
		}
	});
var $author$project$Utils$Validate$isInvalidCurrency = F2(
	function (options, currency) {
		if (!currency.$) {
			var currency_ = currency.a;
			return !A2(
				$author$project$Currency$isValid,
				{AU: options.AU, W9: options.W9},
				currency_);
		} else {
			return !options.aeU;
		}
	});
var $author$project$Components$Invoice$CreatePaymentModal$validateAmountInCents = function (fields) {
	var min = fields.R5 ? 0 : 50;
	var max = fields.j$;
	return A2(
		$author$project$Utils$Validate$isInvalidCurrency,
		{
			aeU: false,
			AU: $elm$core$Maybe$Just(max),
			W9: $elm$core$Maybe$Just(min)
		},
		fields.LE) ? _List_fromArray(
		[
			_Utils_Tuple2(
			0,
			'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
		]) : _List_Nil;
};
var $author$project$Components$Invoice$CreatePaymentModal$SourceValidation = 2;
var $author$project$Components$Invoice$CreatePaymentModal$validateSource = function (fields) {
	return ((!fields.R5) && _Utils_eq(fields.JQ, $elm$core$Maybe$Nothing)) ? _List_fromArray(
		[
			_Utils_Tuple2(2, 'Please pick a source.')
		]) : _List_Nil;
};
var $author$project$Components$Invoice$CreatePaymentModal$formFieldsValidator = F2(
	function (useExistingSources, passthroughFees) {
		return $rtfeldman$elm_validate$Validate$all(
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Invoice$CreatePaymentModal$validateAmountInCents)
						]),
						useExistingSources ? _List_fromArray(
						[
							$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Invoice$CreatePaymentModal$validateSource)
						]) : $elm$core$List$concat(
						_List_fromArray(
							[
								_List_fromArray(
								[
									A2(
									$rtfeldman$elm_validate$Validate$ifNothing,
									function ($) {
										return $.aft;
									},
									_Utils_Tuple2(1, 'Please pick a card reader.'))
								]),
								function () {
								if (!passthroughFees.$) {
									return _List_fromArray(
										[
											A2(
											$rtfeldman$elm_validate$Validate$ifNothing,
											function ($) {
												return $.No;
											},
											_Utils_Tuple2(3, 'Please pick a card type.'))
										]);
								} else {
									return _List_Nil;
								}
							}()
							]))
					])));
	});
var $author$project$Ports$LocalStorage$localStorageGetItemPort = _Platform_outgoingPort('localStorageGetItemPort', $elm$json$Json$Encode$string);
var $author$project$Ports$LocalStorage$getItem = function (key) {
	return $author$project$Ports$LocalStorage$localStorageGetItemPort(key);
};
var $author$project$Components$CardReader$ConnectingModal$Connecting = 0;
var $author$project$Components$CardReader$ConnectingModal$GotConnectionToken = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$CardReader$ConnectingModal$GotReadCardResponse = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$CardReader$ConnectingModal$Model = $elm$core$Basics$identity;
var $author$project$Components$CardReader$ConnectingModal$Rainforest = 1;
var $author$project$Components$CardReader$ConnectingModal$Stripe = 0;
var $author$project$Api$Provider$CardReader$getConnectionToken = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['token']),
				$elm$json$Json$Decode$string),
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['connection_token']),
					$author$project$Api$Provider$CardReader$cardReadersPath)));
	});
var $author$project$Components$CardReader$SimulateForm$Model = $elm$core$Basics$identity;
var $author$project$Components$CardReader$SimulateForm$initFormFields = {
	afs: $elm$core$Maybe$Just('VISA_SUCCESS'),
	agZ: $elm$core$Maybe$Just('PRESENTED')
};
var $author$project$Components$CardReader$SimulateForm$init = F2(
	function (session, cardReaderId) {
		return {
			fS: cardReaderId,
			SD: $author$project$Utils$Form$init($author$project$Components$CardReader$SimulateForm$initFormFields),
			aa4: session,
			qg: $author$project$Api$Data$NotAsked
		};
	});
var $author$project$Rainforest$isSandbox = function (env) {
	if (!env.$) {
		if (env.a === 1) {
			var _v1 = env.a;
			return true;
		} else {
			var _v2 = env.a;
			return false;
		}
	} else {
		return false;
	}
};
var $author$project$Api$Provider$CardReader$All$paymentProcessor = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CardReader$Shared$paymentProcessor(shared);
};
var $author$project$Api$Provider$CardReader$cardReaderPath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		$author$project$Api$Provider$CardReader$cardReadersPath);
};
var $author$project$Api$Provider$CardReader$readCard = F5(
	function (apiClient, id, ownerType, ownerId, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'owner',
					$author$project$Utils$Encode$typedAssociation(
						{
							ahP: $elm$core$Maybe$Just(ownerId),
							amg: $elm$core$Maybe$Just(ownerType)
						}))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['payment_method_id']),
				$elm$json$Json$Decode$string),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['read_card']),
						$author$project$Api$Provider$CardReader$cardReaderPath(id)))));
	});
var $author$project$Components$CardReader$ConnectingModal$init = F7(
	function (apiClient, session, isHintAdmin, rainforestEnv, cardReader, owner, storeCard) {
		var _v0 = function () {
			if ($author$project$Api$Provider$CardReader$All$paymentProcessor(cardReader) === 'rainforest') {
				var _v1 = function () {
					switch (owner.$) {
						case 0:
							var companyId = owner.a;
							return _Utils_Tuple2('company', companyId);
						case 1:
							var patientId = owner.a;
							return _Utils_Tuple2('patient', patientId);
						case 2:
							var practiceId = owner.a;
							return _Utils_Tuple2('practice', practiceId);
						case 3:
							var brokerAccountId = owner.a;
							return _Utils_Tuple2('broker_account', brokerAccountId);
						default:
							var affiliateId = owner.a;
							return _Utils_Tuple2('affiliate', affiliateId);
					}
				}();
				var ownerType = _v1.a;
				var ownerId = _v1.b;
				return _Utils_Tuple3(
					1,
					0,
					A5(
						$author$project$Api$Provider$CardReader$readCard,
						apiClient,
						$author$project$Api$Provider$CardReader$All$id(cardReader),
						ownerType,
						ownerId,
						$author$project$Components$CardReader$ConnectingModal$GotReadCardResponse));
			} else {
				return _Utils_Tuple3(
					0,
					0,
					A2($author$project$Api$Provider$CardReader$getConnectionToken, apiClient, $author$project$Components$CardReader$ConnectingModal$GotConnectionToken));
			}
		}();
		var paymentProcessor = _v0.a;
		var connectionStatus = _v0.b;
		var connectionCmd = _v0.c;
		var simulateForm = ((paymentProcessor === 1) && (isHintAdmin && $author$project$Rainforest$isSandbox(rainforestEnv))) ? $elm$core$Maybe$Just(
			A2(
				$author$project$Components$CardReader$SimulateForm$init,
				session,
				$author$project$Api$Provider$CardReader$All$id(cardReader))) : $elm$core$Maybe$Nothing;
		return _Utils_Tuple2(
			{c3: false, aft: cardReader, d1: connectionStatus, rI: $author$project$Api$Data$Loading, Zd: paymentProcessor, uK: simulateForm, EM: storeCard},
			connectionCmd);
	});
var $author$project$Components$CardReader$PaymentModal$Connecting = 0;
var $author$project$Components$CardReader$PaymentModal$GotReadPaymentResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$CardReader$PaymentModal$Model = $elm$core$Basics$identity;
var $author$project$Api$Employer$Payment$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Employer$Payment$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Payment$Shared$id(shared);
};
var $author$project$Api$Provider$Payment$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Payment$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$id(shared);
};
var $author$project$Api$Provider$Payment$SharedWithRefunds$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$id(shared);
};
var $author$project$Api$Payment$id = function (payment) {
	switch (payment.$) {
		case 1:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$One$id(payment_);
		case 0:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$SharedWithRefunds$id(payment_);
		default:
			var payment_ = payment.a;
			return $author$project$Api$Employer$Payment$One$id(payment_);
	}
};
var $author$project$Api$Provider$CardReader$readPayment = F4(
	function (apiClient, id, paymentId, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'payment_id',
					$elm$json$Json$Encode$string(paymentId))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Payment$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['read_payment']),
						$author$project$Api$Provider$CardReader$cardReaderPath(id)))));
	});
var $author$project$Api$CardReader$readPayment = F5(
	function (apiClient, session, id, paymentId, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : A4(
			$author$project$Api$Provider$CardReader$readPayment,
			apiClient,
			id,
			paymentId,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Payment$Provider_One)));
	});
var $author$project$Components$CardReader$PaymentModal$init = F6(
	function (apiClient, session, isHintAdmin, rainforestEnv, cardReaderId, payment) {
		var simulateForm = (isHintAdmin && $author$project$Rainforest$isSandbox(rainforestEnv)) ? $elm$core$Maybe$Just(
			A2($author$project$Components$CardReader$SimulateForm$init, session, cardReaderId)) : $elm$core$Maybe$Nothing;
		var _v0 = _Utils_Tuple2(
			0,
			A5(
				$author$project$Api$CardReader$readPayment,
				apiClient,
				session,
				cardReaderId,
				$author$project$Api$Payment$id(payment),
				$author$project$Components$CardReader$PaymentModal$GotReadPaymentResponse));
		var connectionStatus = _v0.a;
		var connectionCmd = _v0.b;
		return _Utils_Tuple2(
			{c3: false, fS: cardReaderId, d1: connectionStatus, rI: $author$project$Api$Data$Loading, Y9: payment, aa4: session, uK: simulateForm},
			connectionCmd);
	});
var $elm$core$Tuple$mapBoth = F3(
	function (funcA, funcB, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			funcA(x),
			funcB(y));
	});
var $author$project$Api$Employer$Practice$One$paymentProcessor = function (_v0) {
	var record = _v0;
	return record.Zd;
};
var $author$project$Api$Practice$paymentProcessor = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$paymentProcessor(practice_);
	} else {
		var practice_ = practice.a;
		return $author$project$Api$Employer$Practice$One$paymentProcessor(practice_);
	}
};
var $author$project$Components$Invoice$CreatePaymentModal$refreshPassthroughFees = F4(
	function (apiClient, model, amount, fields) {
		var _v0 = _Utils_Tuple2(
			model.Cd.YV,
			A2($author$project$Components$Invoice$CreatePaymentModal$sourceIsACreditCard, model.bP, fields));
		if ((!_v0.a.$) && _v0.b) {
			var patientId = _v0.a.a.YZ;
			return _Utils_Tuple2(
				$author$project$Api$Data$Loading,
				A6(
					$author$project$Api$Provider$PassthroughFee$One$calculatePassthroughFees,
					apiClient,
					patientId,
					A2($elm$core$Maybe$map, $author$project$Api$Source$id, fields.JQ),
					fields.No,
					amount,
					$author$project$Components$Invoice$CreatePaymentModal$GotPassthroughFees));
		} else {
			return _Utils_Tuple2(model.YV, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Api$Provider$Practice$Shared$usesCardReaders = function (_v0) {
	var record = _v0;
	return record.ad4;
};
var $author$project$Api$Provider$Practice$One$usesCardReaders = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$usesCardReaders(shared);
};
var $author$project$Api$Practice$usesCardReaders = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$usesCardReaders(practice_);
	} else {
		return false;
	}
};
var $author$project$Components$Invoice$CreatePaymentModal$shouldDefaultCardReaderSwitch = F3(
	function (apiClient, response, model) {
		var _v0 = function () {
			var _v1 = _Utils_Tuple2(model.rC, model.rs);
			if ((_v1.a.$ === 3) && (_v1.b.$ === 3)) {
				var _v2 = _v1.a;
				var cards = _v2.a;
				var _v3 = _v1.b;
				var bankAccounts = _v3.a;
				var useCardReader = $elm$core$List$isEmpty(cards) && ($elm$core$List$isEmpty(bankAccounts) && ($author$project$Api$Practice$usesCardReaders(model.ZV) && (!$author$project$Api$Platform$Session$One$organizationIsCompany(model.aa4))));
				return _Utils_Tuple3(
					!useCardReader,
					useCardReader ? $author$project$Api$Data$Loading : $author$project$Api$Data$NotAsked,
					useCardReader ? $author$project$Components$Invoice$CreatePaymentModal$fetchCardReaders(apiClient) : $elm$core$Platform$Cmd$none);
			} else {
				return _Utils_Tuple3(model.bP, model.iE, $elm$core$Platform$Cmd$none);
			}
		}();
		var useExistingSources = _v0.a;
		var cardReaders = _v0.b;
		var cmd = _v0.c;
		return {
			GZ: cmd,
			agZ: 1,
			aiO: _Utils_update(
				model,
				{iE: cardReaders, bP: useExistingSources}),
			aR: $author$project$OutMsg$handleErrorResponse(response)
		};
	});
var $author$project$Api$Employer$Payment$Shared$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Api$Employer$Payment$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Payment$Shared$status(shared);
};
var $author$project$Api$Provider$Payment$Shared$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Api$Provider$Payment$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$status(shared);
};
var $author$project$Api$Provider$Payment$SharedWithRefunds$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$status(shared);
};
var $author$project$Api$Payment$status = function (payment) {
	switch (payment.$) {
		case 1:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$One$status(payment_);
		case 0:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$SharedWithRefunds$status(payment_);
		default:
			var payment_ = payment.a;
			return $author$project$Api$Employer$Payment$One$status(payment_);
	}
};
var $author$project$Components$CardReader$ConnectingModal$CardRead = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$CardReader$ConnectingModal$Closed = {$: 0};
var $author$project$Components$CardReader$ConnectingModal$Connected = 1;
var $author$project$Components$CardReader$ConnectingModal$GotCardReader = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$CardReader$ConnectingModal$GotReportCardReadStatus = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Components$CardReader$ConnectingModal$None = {$: 2};
var $author$project$Components$CardReader$ConnectingModal$RainforestReadReusableCardCancelled = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$CardReader$ConnectingModal$SimulateFormMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Api$Provider$CardReader$cancelReadCard = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['cancel_read_card']),
					$author$project$Api$Provider$CardReader$cardReaderPath(id))));
	});
var $author$project$Ports$StripeTerminal$stripeTerminalPortCancelReadReusableCard = _Platform_outgoingPort('stripeTerminalPortCancelReadReusableCard', $elm$json$Json$Encode$string);
var $author$project$Ports$StripeTerminal$cancelReadReusableCard = $author$project$Ports$StripeTerminal$stripeTerminalPortCancelReadReusableCard;
var $author$project$Ports$StripeTerminal$stripeTerminalPortConnectReader = _Platform_outgoingPort(
	'stripeTerminalPortConnectReader',
	function ($) {
		var a = $.a;
		var b = $.b;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$json$Json$Encode$string(a),
					function ($) {
					return $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'device_sw_version',
								$elm$json$Json$Encode$string($.agv)),
								_Utils_Tuple2(
								'device_type',
								$elm$json$Json$Encode$string($.agw)),
								_Utils_Tuple2(
								'id',
								$elm$json$Json$Encode$string($.ahP)),
								_Utils_Tuple2(
								'ip_address',
								$elm$json$Json$Encode$string($.ah9)),
								_Utils_Tuple2(
								'label',
								$elm$json$Json$Encode$string($.aih)),
								_Utils_Tuple2(
								'livemode',
								$elm$json$Json$Encode$bool($.aio)),
								_Utils_Tuple2(
								'location',
								$elm$json$Json$Encode$string($.ais)),
								_Utils_Tuple2(
								'object',
								$elm$json$Json$Encode$string($.ai8)),
								_Utils_Tuple2(
								'serial_number',
								$elm$json$Json$Encode$string($.aln)),
								_Utils_Tuple2(
								'status',
								$elm$json$Json$Encode$string($.alH))
							]));
				}(b)
				]));
	});
var $author$project$Ports$StripeTerminal$connectReader = F2(
	function (token, stripeObject) {
		return $author$project$Ports$StripeTerminal$stripeTerminalPortConnectReader(
			_Utils_Tuple2(token, stripeObject));
	});
var $author$project$Ports$StripeTerminal$stripeTerminalPortCreate = _Platform_outgoingPort('stripeTerminalPortCreate', $elm$json$Json$Encode$string);
var $author$project$Ports$StripeTerminal$create = $author$project$Ports$StripeTerminal$stripeTerminalPortCreate;
var $author$project$Ports$StripeTerminal$stripeTerminalPortClearCachedCredentials = _Platform_outgoingPort('stripeTerminalPortClearCachedCredentials', $elm$json$Json$Encode$string);
var $author$project$Ports$StripeTerminal$clearCachedCredentials = $author$project$Ports$StripeTerminal$stripeTerminalPortClearCachedCredentials;
var $author$project$Ports$StripeTerminal$stripeTerminalPortDisconnectReader = _Platform_outgoingPort('stripeTerminalPortDisconnectReader', $elm$json$Json$Encode$string);
var $author$project$Ports$StripeTerminal$disconnectReader = $author$project$Ports$StripeTerminal$stripeTerminalPortDisconnectReader;
var $author$project$Components$CardReader$ConnectingModal$disconnectReader = F4(
	function (apiClient, model, cmd, event) {
		return {
			GZ: function () {
				var _v0 = _Utils_Tuple2(model.Zd, model.rI);
				if (!_v0.a) {
					if (_v0.b.$ === 3) {
						var _v1 = _v0.a;
						var _v2 = _v0.b;
						var token = _v2.a;
						return $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Ports$StripeTerminal$disconnectReader(token),
									$author$project$Ports$StripeTerminal$clearCachedCredentials(token),
									cmd
								]));
					} else {
						return cmd;
					}
				} else {
					var _v3 = _v0.a;
					return $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A3(
								$author$project$Api$Provider$CardReader$cancelReadCard,
								apiClient,
								$author$project$Api$Provider$CardReader$All$id(model.aft),
								$author$project$Components$CardReader$ConnectingModal$RainforestReadReusableCardCancelled),
								cmd
							]));
				}
			}(),
			agZ: A2($elm$core$Maybe$withDefault, $author$project$Components$CardReader$ConnectingModal$Closed, event),
			aiO: _Utils_update(
				model,
				{c3: false, d1: 0}),
			aR: _List_Nil
		};
	});
var $author$project$Components$CardReader$ConnectingModal$handleStripeFailure = F3(
	function (apiClient, model, error) {
		var result = A4($author$project$Components$CardReader$ConnectingModal$disconnectReader, apiClient, model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
		var messge = A2($elm$core$String$contains, 'Action canceled.', error) ? $elm$core$Maybe$Nothing : (A2($elm$core$String$contains, 'Invalid object shape', error) ? $elm$core$Maybe$Just('We are having trouble talking to the reader, please reach out for help.') : $elm$core$Maybe$Just(error));
		var outMsgs = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$OutMsg$ShowToast(1),
					$elm$core$List$singleton),
				messge));
		return _Utils_update(
			result,
			{aR: outMsgs});
	});
var $author$project$Components$CardReader$ConnectingModal$PollCardReadStatus = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Components$CardReader$ConnectingModal$pollReadCardStatus = F2(
	function (cardReader, paymentMethodId) {
		return A2(
			$elm$core$Task$perform,
			function (_v0) {
				return A2($author$project$Components$CardReader$ConnectingModal$PollCardReadStatus, cardReader, paymentMethodId);
			},
			$elm$core$Process$sleep(2000));
	});
var $author$project$Api$PaymentProcessorParams$RainforestParams = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$PaymentProcessorParams$rainforestParams = $author$project$Api$PaymentProcessorParams$RainforestParams;
var $author$project$Api$Provider$CardReader$ReadStatus = function (status) {
	return {alH: status};
};
var $author$project$Api$Provider$CardReader$readCardStatusDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'status',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$CardReader$ReadStatus));
var $author$project$Api$Provider$CardReader$readCardStatus = F4(
	function (apiClient, id, paymentMethodId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$CardReader$readCardStatusDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2($author$project$Api$Param$string, 'payment_method_id', paymentMethodId)
					]),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['read_card_status']),
						$author$project$Api$Provider$CardReader$cardReaderPath(id)))));
	});
var $author$project$Ports$StripeTerminal$stripeTerminalPortReadReusableCard = _Platform_outgoingPort('stripeTerminalPortReadReusableCard', $elm$json$Json$Encode$string);
var $author$project$Ports$StripeTerminal$readReusableCard = $author$project$Ports$StripeTerminal$stripeTerminalPortReadReusableCard;
var $author$project$Api$Provider$CardReader$One$CardReader = $elm$core$Basics$identity;
var $author$project$Api$Provider$CardReader$One$Record = function (stripeObject) {
	return {acr: stripeObject};
};
var $author$project$Api$Provider$CardReader$One$StripeObject = function (device_sw_version) {
	return function (device_type) {
		return function (id) {
			return function (ip_address) {
				return function (label) {
					return function (livemode) {
						return function (location) {
							return function (object) {
								return function (serial_number) {
									return function (status) {
										return {agv: device_sw_version, agw: device_type, ahP: id, ah9: ip_address, aih: label, aio: livemode, ais: location, ai8: object, aln: serial_number, alH: status};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$CardReader$One$stripeObjectDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'status',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'serial_number',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'object',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'location',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'livemode',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'label',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'ip_address',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'device_type',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'device_sw_version',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Api$Provider$CardReader$One$StripeObject)))))))))));
var $author$project$Api$Provider$CardReader$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'stripe_object',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$CardReader$One$stripeObjectDecoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$CardReader$One$Record));
var $author$project$Api$Provider$CardReader$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CardReader$One$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CardReader$retrieve = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$CardReader$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$CardReader$cardReaderPath(id)));
	});
var $author$project$Ports$LocalStorage$localStorageSetItemPort = _Platform_outgoingPort(
	'localStorageSetItemPort',
	function ($) {
		var a = $.a;
		var b = $.b;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$json$Json$Encode$string(a),
					$elm$json$Json$Encode$string(b)
				]));
	});
var $author$project$Ports$LocalStorage$setItem = F2(
	function (key, value) {
		return $author$project$Ports$LocalStorage$localStorageSetItemPort(
			_Utils_Tuple2(key, value));
	});
var $author$project$Api$Provider$CardReader$One$stripeObject = function (_v0) {
	var record = _v0;
	return record.acr;
};
var $author$project$Api$PaymentProcessorParams$StripeParams = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$PaymentProcessorParams$stripeParams = $author$project$Api$PaymentProcessorParams$StripeParams;
var $author$project$Components$CardReader$SimulateForm$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var event = field.a;
			return _Utils_update(
				fields,
				{
					agZ: $author$project$Utils$String$toMaybe(event)
				});
		} else {
			var card = field.a;
			return _Utils_update(
				fields,
				{
					afs: $author$project$Utils$String$toMaybe(card)
				});
		}
	});
var $author$project$Components$CardReader$SimulateForm$CardValidation = 1;
var $author$project$Components$CardReader$SimulateForm$EventValidation = 0;
var $author$project$Components$CardReader$SimulateForm$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.agZ;
			},
			_Utils_Tuple2(0, 'Please pick an event.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.afs;
			},
			_Utils_Tuple2(1, 'Please pick a card.'))
		]));
var $author$project$Components$CardReader$SimulateForm$GotSimulateResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$CardReader$simulateDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['success']),
	$elm$json$Json$Decode$bool);
var $author$project$Api$Provider$CardReader$simulate = F4(
	function (apiClient, id, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'event',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.agZ)),
					_Utils_Tuple2(
					'card',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.afs))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CardReader$simulateDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['simulate']),
						$author$project$Api$Provider$CardReader$cardReaderPath(id)))));
	});
var $author$project$Api$CardReader$simulate = F5(
	function (apiClient, session, id, params, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : A4($author$project$Api$Provider$CardReader$simulate, apiClient, id, params, toMsg);
	});
var $author$project$Components$CardReader$SimulateForm$simulate = F4(
	function (apiClient, session, cardReaderId, validSimulateFormFields) {
		return A5(
			$author$project$Api$CardReader$simulate,
			apiClient,
			session,
			cardReaderId,
			$rtfeldman$elm_validate$Validate$fromValid(validSimulateFormFields),
			$author$project$Components$CardReader$SimulateForm$GotSimulateResponse);
	});
var $author$project$Components$CardReader$SimulateForm$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$CardReader$SimulateForm$formFieldsUpdate, field, model.SD);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: newForm}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$CardReader$SimulateForm$formFieldsValidator, model.SD);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var newForm = _v3.a;
					var validFormFields = _v3.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{SD: newForm, qg: $author$project$Api$Data$Loading}),
						A4($author$project$Components$CardReader$SimulateForm$simulate, apiClient, model.aa4, model.fS, validFormFields),
						_List_Nil);
				} else {
					var newForm = _v2.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{SD: newForm}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var success = response.a;
					var _v5 = success ? _Utils_Tuple2(3, 'Simulation success') : _Utils_Tuple2(1, 'Simulation failed');
					var toastLevel = _v5.a;
					var toastMessage = _v5.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{qg: response}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, toastLevel, toastMessage)
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{qg: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$reportDecodeError(response));
				}
		}
	});
var $author$project$Components$CardReader$ConnectingModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var _v2 = _Utils_Tuple3(model.Zd, model.d1, model.rI);
				if (!_v2.a) {
					if (!_v2.b) {
						var _v3 = _v2.a;
						var _v4 = _v2.b;
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: $author$project$Components$CardReader$ConnectingModal$None,
							aiO: _Utils_update(
								model,
								{c3: true}),
							aR: _List_Nil
						};
					} else {
						if (_v2.c.$ === 3) {
							var _v7 = _v2.a;
							var _v8 = _v2.c;
							var token = _v8.a;
							return {
								GZ: $author$project$Ports$StripeTerminal$cancelReadReusableCard(token),
								agZ: $author$project$Components$CardReader$ConnectingModal$None,
								aiO: model,
								aR: _List_Nil
							};
						} else {
							return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$CardReader$ConnectingModal$Closed, aiO: model, aR: _List_Nil};
						}
					}
				} else {
					if (!_v2.b) {
						var _v5 = _v2.a;
						var _v6 = _v2.b;
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: $author$project$Components$CardReader$ConnectingModal$None,
							aiO: _Utils_update(
								model,
								{c3: true}),
							aR: _List_Nil
						};
					} else {
						var _v9 = _v2.a;
						var _v10 = _v2.b;
						return {
							GZ: A3(
								$author$project$Api$Provider$CardReader$cancelReadCard,
								apiClient,
								$author$project$Api$Provider$CardReader$All$id(model.aft),
								$author$project$Components$CardReader$ConnectingModal$RainforestReadReusableCardCancelled),
							agZ: $author$project$Components$CardReader$ConnectingModal$None,
							aiO: _Utils_update(
								model,
								{c3: true}),
							aR: _List_Nil
						};
					}
				}
			case 1:
				var response = msg.a;
				var _v11 = _Utils_Tuple2(model.Zd, response);
				if ((!_v11.a) && (_v11.b.$ === 3)) {
					var _v12 = _v11.a;
					var _v13 = _v11.b;
					var token = _v13.a;
					return {
						GZ: $author$project$Ports$StripeTerminal$create(token),
						agZ: $author$project$Components$CardReader$ConnectingModal$None,
						aiO: _Utils_update(
							model,
							{rI: response}),
						aR: _List_Nil
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$CardReader$ConnectingModal$Closed,
						aiO: model,
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 9:
				var response = msg.a;
				if (response.$ === 3) {
					var paymentMethodId = response.a;
					return model.c3 ? A4($author$project$Components$CardReader$ConnectingModal$disconnectReader, apiClient, model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing) : {
						GZ: A2($author$project$Components$CardReader$ConnectingModal$pollReadCardStatus, model.aft, paymentMethodId),
						agZ: $author$project$Components$CardReader$ConnectingModal$None,
						aiO: _Utils_update(
							model,
							{d1: 1}),
						aR: _List_Nil
					};
				} else {
					return {
						GZ: A3(
							$author$project$Api$Provider$CardReader$cancelReadCard,
							apiClient,
							$author$project$Api$Provider$CardReader$All$id(model.aft),
							$author$project$Components$CardReader$ConnectingModal$RainforestReadReusableCardCancelled),
						agZ: $author$project$Components$CardReader$ConnectingModal$Closed,
						aiO: model,
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 2:
				var token = msg.a;
				return {
					GZ: A3(
						$author$project$Api$Provider$CardReader$retrieve,
						apiClient,
						$author$project$Api$Provider$CardReader$All$id(model.aft),
						$author$project$Components$CardReader$ConnectingModal$GotCardReader(token)),
					agZ: $author$project$Components$CardReader$ConnectingModal$None,
					aiO: model,
					aR: _List_Nil
				};
			case 3:
				var token = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var cardReader = response.a;
					var _v16 = function () {
						var _v17 = _Utils_Tuple2(
							model.Zd,
							$author$project$Api$Provider$CardReader$One$stripeObject(cardReader));
						if (!_v17.a) {
							if (!_v17.b.$) {
								var _v18 = _v17.a;
								var stripeObject = _v17.b.a;
								return _Utils_Tuple2(
									0,
									A2($author$project$Ports$StripeTerminal$connectReader, token, stripeObject));
							} else {
								var _v19 = _v17.a;
								var _v20 = _v17.b;
								return _Utils_Tuple2(0, $elm$core$Platform$Cmd$none);
							}
						} else {
							var _v21 = _v17.a;
							return _Utils_Tuple2(1, $elm$core$Platform$Cmd$none);
						}
					}();
					var connectionStatus = _v16.a;
					var cmd = _v16.b;
					return {
						GZ: cmd,
						agZ: $author$project$Components$CardReader$ConnectingModal$None,
						aiO: _Utils_update(
							model,
							{d1: connectionStatus}),
						aR: _List_Nil
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$CardReader$ConnectingModal$Closed,
						aiO: model,
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 4:
				var token = msg.a;
				var result = msg.b;
				if (!result.$) {
					return model.c3 ? A4($author$project$Components$CardReader$ConnectingModal$disconnectReader, apiClient, model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing) : {
						GZ: $author$project$Ports$StripeTerminal$readReusableCard(token),
						agZ: $author$project$Components$CardReader$ConnectingModal$None,
						aiO: _Utils_update(
							model,
							{d1: 1}),
						aR: _List_Nil
					};
				} else {
					var error = result.a;
					return A3($author$project$Components$CardReader$ConnectingModal$handleStripeFailure, apiClient, model, error);
				}
			case 5:
				var cardReadResult = msg.b;
				if (!cardReadResult.$) {
					var paymentMethodId = cardReadResult.a;
					var readCard = {
						O4: 'via_card_reader',
						Yl: !model.EM,
						Ze: $author$project$Api$PaymentProcessorParams$stripeParams(paymentMethodId)
					};
					return A4(
						$author$project$Components$CardReader$ConnectingModal$disconnectReader,
						apiClient,
						model,
						A2(
							$author$project$Ports$LocalStorage$setItem,
							'last-used-card-reader',
							$author$project$Api$Provider$CardReader$All$id(model.aft)),
						$elm$core$Maybe$Just(
							$author$project$Components$CardReader$ConnectingModal$CardRead(readCard)));
				} else {
					var error = cardReadResult.a;
					return A3($author$project$Components$CardReader$ConnectingModal$handleStripeFailure, apiClient, model, error);
				}
			case 6:
				var result = msg.b;
				if (!result.$) {
					return A4($author$project$Components$CardReader$ConnectingModal$disconnectReader, apiClient, model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
				} else {
					var error = result.a;
					return A3($author$project$Components$CardReader$ConnectingModal$handleStripeFailure, apiClient, model, error);
				}
			case 7:
				var response = msg.a;
				if (response.$ === 3) {
					return A4($author$project$Components$CardReader$ConnectingModal$disconnectReader, apiClient, model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$CardReader$ConnectingModal$Closed,
						aiO: model,
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 8:
				var error = msg.a;
				return A3($author$project$Components$CardReader$ConnectingModal$handleStripeFailure, apiClient, model, error);
			case 10:
				var cardReader = msg.a;
				var paymentMethodId = msg.b;
				return {
					GZ: A4(
						$author$project$Api$Provider$CardReader$readCardStatus,
						apiClient,
						$author$project$Api$Provider$CardReader$All$id(cardReader),
						paymentMethodId,
						$author$project$Components$CardReader$ConnectingModal$GotReportCardReadStatus(paymentMethodId)),
					agZ: $author$project$Components$CardReader$ConnectingModal$None,
					aiO: model,
					aR: _List_Nil
				};
			case 11:
				var paymentMethodId = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var cardReadStatus = response.a;
					var _v27 = cardReadStatus.alH;
					switch (_v27) {
						case 'active':
							var readCard = {
								O4: 'via_card_reader',
								Yl: !model.EM,
								Ze: $author$project$Api$PaymentProcessorParams$rainforestParams(paymentMethodId)
							};
							return A4(
								$author$project$Components$CardReader$ConnectingModal$disconnectReader,
								apiClient,
								model,
								A2(
									$author$project$Ports$LocalStorage$setItem,
									'last-used-card-reader',
									$author$project$Api$Provider$CardReader$All$id(model.aft)),
								$elm$core$Maybe$Just(
									$author$project$Components$CardReader$ConnectingModal$CardRead(readCard)));
						case 'canceled':
							return A4($author$project$Components$CardReader$ConnectingModal$disconnectReader, apiClient, model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
						case 'failed':
							return A4($author$project$Components$CardReader$ConnectingModal$disconnectReader, apiClient, model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
						default:
							return {
								GZ: A2($author$project$Components$CardReader$ConnectingModal$pollReadCardStatus, model.aft, paymentMethodId),
								agZ: $author$project$Components$CardReader$ConnectingModal$None,
								aiO: model,
								aR: _List_Nil
							};
					}
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$CardReader$ConnectingModal$None,
						aiO: model,
						aR: $author$project$OutMsg$reportDecodeError(response)
					};
				}
			default:
				var subMsg = msg.a;
				var _v28 = model.uK;
				if (!_v28.$) {
					var simulateForm = _v28.a;
					var _v29 = A3($author$project$Components$CardReader$SimulateForm$update, apiClient, subMsg, simulateForm);
					var simulateForm_ = _v29.a;
					var simulateFormCmd = _v29.b;
					var simulateFormOutMsgs = _v29.c;
					return {
						GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$CardReader$ConnectingModal$SimulateFormMsg, simulateFormCmd),
						agZ: $author$project$Components$CardReader$ConnectingModal$None,
						aiO: _Utils_update(
							model,
							{
								uK: $elm$core$Maybe$Just(simulateForm_)
							}),
						aR: simulateFormOutMsgs
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$CardReader$ConnectingModal$None, aiO: model, aR: _List_Nil};
				}
		}
	});
var $author$project$Components$CardReader$PaymentModal$Closed = 0;
var $author$project$Components$CardReader$PaymentModal$Connected = 1;
var $author$project$Components$CardReader$PaymentModal$GotReportPaymentReadStatus = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$CardReader$PaymentModal$None = 4;
var $author$project$Components$CardReader$PaymentModal$PaymentRead = 1;
var $author$project$Components$CardReader$PaymentModal$PaymentReadCancelled = 3;
var $author$project$Components$CardReader$PaymentModal$PaymentReadFailed = 2;
var $author$project$Components$CardReader$PaymentModal$ReadPaymentCancelled = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$CardReader$PaymentModal$SimulateFormMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$CardReader$cancelReadPayment = F4(
	function (apiClient, id, paymentId, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'payment_id',
					$elm$json$Json$Encode$string(paymentId))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['cancel_read_payment']),
						$author$project$Api$Provider$CardReader$cardReaderPath(id)))));
	});
var $author$project$Api$CardReader$cancelReadPayment = F5(
	function (apiClient, session, id, paymentId, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : A4($author$project$Api$Provider$CardReader$cancelReadPayment, apiClient, id, paymentId, toMsg);
	});
var $author$project$Components$CardReader$PaymentModal$disconnectReader = F4(
	function (apiClient, model, cmd, event) {
		return {
			GZ: $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A5(
						$author$project$Api$CardReader$cancelReadPayment,
						apiClient,
						model.aa4,
						model.fS,
						$author$project$Api$Payment$id(model.Y9),
						$author$project$Components$CardReader$PaymentModal$ReadPaymentCancelled),
						cmd
					])),
			agZ: A2($elm$core$Maybe$withDefault, 0, event),
			aiO: _Utils_update(
				model,
				{c3: false, d1: 0}),
			aR: _List_Nil
		};
	});
var $author$project$Components$CardReader$PaymentModal$PollPaymentReadStatus = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$CardReader$PaymentModal$pollReadPaymentStatus = function (cardReaderId) {
	return A2(
		$elm$core$Task$perform,
		function (_v0) {
			return $author$project$Components$CardReader$PaymentModal$PollPaymentReadStatus(cardReaderId);
		},
		$elm$core$Process$sleep(2000));
};
var $author$project$Api$Provider$CardReader$readPaymentStatus = F4(
	function (apiClient, id, paymentId, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Payment$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2($author$project$Api$Param$string, 'payment_id', paymentId)
					]),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['read_payment_status']),
						$author$project$Api$Provider$CardReader$cardReaderPath(id)))));
	});
var $author$project$Api$CardReader$readPaymentStatus = F5(
	function (apiClient, session, id, paymentId, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : A4(
			$author$project$Api$Provider$CardReader$readPaymentStatus,
			apiClient,
			id,
			paymentId,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Payment$Provider_One)));
	});
var $author$project$Components$CardReader$PaymentModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var _v2 = _Utils_Tuple2(model.d1, model.rI);
				if (!_v2.a) {
					var _v3 = _v2.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 4,
						aiO: _Utils_update(
							model,
							{c3: true}),
						aR: _List_Nil
					};
				} else {
					var _v4 = _v2.a;
					return {
						GZ: A5(
							$author$project$Api$CardReader$cancelReadPayment,
							apiClient,
							model.aa4,
							model.fS,
							$author$project$Api$Payment$id(model.Y9),
							$author$project$Components$CardReader$PaymentModal$ReadPaymentCancelled),
						agZ: 4,
						aiO: _Utils_update(
							model,
							{c3: true}),
						aR: _List_Nil
					};
				}
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					return model.c3 ? A4($author$project$Components$CardReader$PaymentModal$disconnectReader, apiClient, model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing) : {
						GZ: $author$project$Components$CardReader$PaymentModal$pollReadPaymentStatus(model.fS),
						agZ: 4,
						aiO: _Utils_update(
							model,
							{d1: 1}),
						aR: _List_Nil
					};
				} else {
					return {
						GZ: A5(
							$author$project$Api$CardReader$cancelReadPayment,
							apiClient,
							model.aa4,
							model.fS,
							$author$project$Api$Payment$id(model.Y9),
							$author$project$Components$CardReader$PaymentModal$ReadPaymentCancelled),
						agZ: 0,
						aiO: model,
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 1:
				var response = msg.a;
				if (response.$ === 3) {
					return A4($author$project$Components$CardReader$PaymentModal$disconnectReader, apiClient, model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: model,
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 3:
				var cardReaderId = msg.a;
				return {
					GZ: A5(
						$author$project$Api$CardReader$readPaymentStatus,
						apiClient,
						model.aa4,
						cardReaderId,
						$author$project$Api$Payment$id(model.Y9),
						$author$project$Components$CardReader$PaymentModal$GotReportPaymentReadStatus),
					agZ: 4,
					aiO: model,
					aR: _List_Nil
				};
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					var payment = response.a;
					var _v8 = $author$project$Api$Payment$status(payment);
					switch (_v8) {
						case 'paid':
							return A4(
								$author$project$Components$CardReader$PaymentModal$disconnectReader,
								apiClient,
								model,
								A2($author$project$Ports$LocalStorage$setItem, 'last-used-card-reader', model.fS),
								$elm$core$Maybe$Just(1));
						case 'cancelled':
							return A4(
								$author$project$Components$CardReader$PaymentModal$disconnectReader,
								apiClient,
								model,
								$elm$core$Platform$Cmd$none,
								$elm$core$Maybe$Just(3));
						case 'failed':
							return A4(
								$author$project$Components$CardReader$PaymentModal$disconnectReader,
								apiClient,
								model,
								$elm$core$Platform$Cmd$none,
								$elm$core$Maybe$Just(2));
						default:
							return {
								GZ: $author$project$Components$CardReader$PaymentModal$pollReadPaymentStatus(model.fS),
								agZ: 4,
								aiO: model,
								aR: _List_Nil
							};
					}
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 4,
						aiO: model,
						aR: $author$project$OutMsg$reportDecodeError(response)
					};
				}
			default:
				var subMsg = msg.a;
				var _v9 = model.uK;
				if (!_v9.$) {
					var simulateForm = _v9.a;
					var _v10 = A3($author$project$Components$CardReader$SimulateForm$update, apiClient, subMsg, simulateForm);
					var simulateForm_ = _v10.a;
					var simulateFormCmd = _v10.b;
					var simulateFormOutMsgs = _v10.c;
					return {
						GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$CardReader$PaymentModal$SimulateFormMsg, simulateFormCmd),
						agZ: 4,
						aiO: _Utils_update(
							model,
							{
								uK: $elm$core$Maybe$Just(simulateForm_)
							}),
						aR: simulateFormOutMsgs
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 4, aiO: model, aR: _List_Nil};
				}
		}
	});
var $author$project$Components$Invoice$CreatePaymentModal$updateDateInputFormField = F6(
	function (model, dateInput, subMsg, toMsg, field, fieldGetter) {
		var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
		var newDateInput = _v0.a;
		var subCmd = _v0.b;
		var event = _v0.c;
		var newForm = function () {
			if (event.$ === 1) {
				var date = event.a;
				return A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Invoice$CreatePaymentModal$formFieldsUpdate,
					A2(field, newDateInput, date),
					model.SD);
			} else {
				var fields = $author$project$Utils$Form$fields(model.SD);
				return A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Invoice$CreatePaymentModal$formFieldsUpdate,
					A2(
						field,
						newDateInput,
						fieldGetter(fields)),
					model.SD);
			}
		}();
		return {
			GZ: A2(
				$elm$core$Platform$Cmd$map,
				toMsg(newDateInput),
				subCmd),
			agZ: 1,
			aiO: _Utils_update(
				model,
				{SD: newForm}),
			aR: _List_Nil
		};
	});
var $author$project$Currency$zero = '0';
var $author$project$Components$Invoice$CreatePaymentModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 12:
				var response = msg.a;
				return A3(
					$author$project$Components$Invoice$CreatePaymentModal$shouldDefaultCardReaderSwitch,
					apiClient,
					response,
					_Utils_update(
						model,
						{rC: response}));
			case 13:
				var response = msg.a;
				return A3(
					$author$project$Components$Invoice$CreatePaymentModal$shouldDefaultCardReaderSwitch,
					apiClient,
					response,
					_Utils_update(
						model,
						{rs: response}));
			case 14:
				var response = msg.a;
				return {
					GZ: $author$project$Ports$LocalStorage$getItem('last-used-card-reader'),
					agZ: 1,
					aiO: _Utils_update(
						model,
						{iE: response}),
					aR: $author$project$OutMsg$handleErrorResponse(response)
				};
			case 15:
				var _v2 = msg.a;
				var key = _v2.a;
				var value = _v2.b;
				var _v3 = _Utils_Tuple2(key, value);
				if ((_v3.a === 'last-used-card-reader') && (!_v3.b.$)) {
					var lastUsedCardReaderId = _v3.b.a;
					var cardReader = A2(
						$elm_community$list_extra$List$Extra$find,
						function (cardReader_) {
							return _Utils_eq(
								$author$project$Api$Provider$CardReader$All$id(cardReader_),
								lastUsedCardReaderId);
						},
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							$author$project$Api$Data$toMaybe(model.iE)));
					var newForm = A3(
						$author$project$Utils$Form$update,
						$author$project$Components$Invoice$CreatePaymentModal$formFieldsUpdate,
						$author$project$Components$Invoice$CreatePaymentModal$CardReader(cardReader),
						model.SD);
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 1,
						aiO: _Utils_update(
							model,
							{SD: newForm}),
						aR: _List_Nil
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 1, aiO: model, aR: _List_Nil};
				}
			case 16:
				var useExistingSources = msg.a;
				var _v4 = ((!useExistingSources) && _Utils_eq(model.iE, $author$project$Api$Data$NotAsked)) ? _Utils_Tuple2(
					$author$project$Api$Data$Loading,
					$author$project$Components$Invoice$CreatePaymentModal$fetchCardReaders(apiClient)) : _Utils_Tuple2(model.iE, $elm$core$Platform$Cmd$none);
				var cardReaders = _v4.a;
				var fetchCardReadersCmd = _v4.b;
				return {
					GZ: fetchCardReadersCmd,
					agZ: 1,
					aiO: _Utils_update(
						model,
						{iE: cardReaders, bP: useExistingSources}),
					aR: _List_Nil
				};
			case 0:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
			case 1:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Invoice$CreatePaymentModal$formFieldsUpdate, field, model.SD);
				var _v5 = function () {
					if (field.$ === 7) {
						var amountInCents = A2(
							$elm$core$Maybe$withDefault,
							0,
							$author$project$Currency$toInt(
								A2(
									$elm$core$Maybe$withDefault,
									$author$project$Currency$zero,
									$author$project$Utils$Form$fields(model.SD).LE)));
						return A4(
							$author$project$Components$Invoice$CreatePaymentModal$refreshPassthroughFees,
							apiClient,
							model,
							amountInCents,
							$author$project$Utils$Form$fields(newForm));
					} else {
						return _Utils_Tuple2(model.YV, $elm$core$Platform$Cmd$none);
					}
				}();
				var passthroughFees = _v5.a;
				var passthroughFeesCmd = _v5.b;
				return {
					GZ: passthroughFeesCmd,
					agZ: 1,
					aiO: _Utils_update(
						model,
						{SD: newForm, YV: passthroughFees}),
					aR: _List_Nil
				};
			case 2:
				var amountInCents = A2(
					$elm$core$Maybe$withDefault,
					0,
					$author$project$Currency$toInt(
						A2(
							$elm$core$Maybe$withDefault,
							$author$project$Currency$zero,
							$author$project$Utils$Form$fields(model.SD).LE)));
				var _v7 = A4(
					$author$project$Components$Invoice$CreatePaymentModal$refreshPassthroughFees,
					apiClient,
					model,
					amountInCents,
					$author$project$Utils$Form$fields(model.SD));
				var passthroughFees = _v7.a;
				var passthroughFeesCmd = _v7.b;
				return {
					GZ: passthroughFeesCmd,
					agZ: 1,
					aiO: _Utils_update(
						model,
						{YV: passthroughFees, uZ: amountInCents}),
					aR: _List_Nil
				};
			case 3:
				var dropdownMsg = msg.a;
				var _v8 = A2($author$project$Ui$Dropdown$update, dropdownMsg, model.o5);
				var dropdown = _v8.a;
				var cmd = _v8.b;
				return {
					GZ: cmd,
					agZ: 1,
					aiO: _Utils_update(
						model,
						{o5: dropdown}),
					aR: _List_Nil
				};
			case 4:
				var str = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 1,
					aiO: _Utils_update(
						model,
						{o6: str}),
					aR: _List_Nil
				};
			case 5:
				var maybeSource = msg.a;
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Invoice$CreatePaymentModal$formFieldsUpdate,
					$author$project$Components$Invoice$CreatePaymentModal$Source(maybeSource),
					model.SD);
				var amountInCents = A2(
					$elm$core$Maybe$withDefault,
					0,
					$author$project$Currency$toInt(
						A2(
							$elm$core$Maybe$withDefault,
							$author$project$Currency$zero,
							$author$project$Utils$Form$fields(model.SD).LE)));
				var _v9 = function () {
					if (!maybeSource.$) {
						return A4(
							$author$project$Components$Invoice$CreatePaymentModal$refreshPassthroughFees,
							apiClient,
							model,
							amountInCents,
							$author$project$Utils$Form$fields(newForm));
					} else {
						return _Utils_Tuple2(model.YV, $elm$core$Platform$Cmd$none);
					}
				}();
				var passthroughFees = _v9.a;
				var passthroughFeesCmd = _v9.b;
				return {
					GZ: passthroughFeesCmd,
					agZ: 1,
					aiO: _Utils_update(
						model,
						{SD: newForm, YV: passthroughFees, o6: '', uZ: amountInCents}),
					aR: _List_Nil
				};
			case 6:
				var dropdownMsg = msg.a;
				var _v11 = A2($author$project$Ui$Dropdown$update, dropdownMsg, model.mE);
				var dropdown = _v11.a;
				var cmd = _v11.b;
				return {
					GZ: cmd,
					agZ: 1,
					aiO: _Utils_update(
						model,
						{mE: dropdown}),
					aR: _List_Nil
				};
			case 7:
				var str = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 1,
					aiO: _Utils_update(
						model,
						{mF: str}),
					aR: _List_Nil
				};
			case 8:
				var maybeCardReader = msg.a;
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Invoice$CreatePaymentModal$formFieldsUpdate,
					$author$project$Components$Invoice$CreatePaymentModal$CardReader(maybeCardReader),
					model.SD);
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 1,
					aiO: _Utils_update(
						model,
						{mF: '', SD: newForm}),
					aR: _List_Nil
				};
			case 9:
				var _v12 = A2(
					$author$project$Utils$Form$validate,
					A2($author$project$Components$Invoice$CreatePaymentModal$formFieldsValidator, model.bP, model.Cd.YV),
					model.SD);
				if (!_v12.$) {
					var _v13 = _v12.a;
					var newForm = _v13.a;
					var validFormFields = _v13.b;
					var _v14 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
					var cardReader = _v14.aft;
					var storeCard = _v14.EM;
					var _v15 = function () {
						var _v16 = _Utils_Tuple3(
							model.bP,
							cardReader,
							$author$project$Api$Practice$paymentProcessor(model.ZV));
						if (_v16.a) {
							return _Utils_Tuple3(
								$elm$core$Maybe$Nothing,
								A8($author$project$Components$Invoice$CreatePaymentModal$createPayment, model.Cd, model.tK, apiClient, model.aa4, model.ajV, validFormFields, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
								$author$project$Api$Data$Loading);
						} else {
							if (!_v16.b.$) {
								if (_v16.c === 'rainforest') {
									var cardReader_ = _v16.b.a;
									return _Utils_Tuple3(
										$elm$core$Maybe$Nothing,
										A8(
											$author$project$Components$Invoice$CreatePaymentModal$createPayment,
											model.Cd,
											model.tK,
											apiClient,
											model.aa4,
											model.ajV,
											validFormFields,
											$elm$core$Maybe$Nothing,
											$elm$core$Maybe$Just(cardReader_)),
										$author$project$Api$Data$Loading);
								} else {
									var cardReader_ = _v16.b.a;
									var owner = function () {
										var _v17 = model.ajV;
										switch (_v17.$) {
											case 0:
												var practiceId = _v17.a;
												return $author$project$Components$CardReader$ConnectingModal$Practice(practiceId);
											case 1:
												var companyId = _v17.a;
												return $author$project$Components$CardReader$ConnectingModal$Company(companyId);
											case 2:
												var affiliateId = _v17.a;
												return $author$project$Components$CardReader$ConnectingModal$Affiliate(affiliateId);
											case 3:
												var patientId = _v17.a;
												return $author$project$Components$CardReader$ConnectingModal$Patient(patientId);
											default:
												var brokerAccountId = _v17.a;
												return $author$project$Components$CardReader$ConnectingModal$BrokerAccount(brokerAccountId);
										}
									}();
									return A2(
										$author$project$Utils$Tuple3$fromTuple2,
										model.an,
										A3(
											$elm$core$Tuple$mapBoth,
											function (m) {
												return $elm$core$Maybe$Just(
													_Utils_Tuple2(m, validFormFields));
											},
											$elm$core$Platform$Cmd$map($author$project$Components$Invoice$CreatePaymentModal$CardReaderConnectingModalMsg),
											A7($author$project$Components$CardReader$ConnectingModal$init, apiClient, model.aa4, model.Ij, model.t9, cardReader_, owner, storeCard)));
								}
							} else {
								var _v18 = _v16.b;
								return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none, model.an);
							}
						}
					}();
					var cardReaderConnectingModal = _v15.a;
					var cmd = _v15.b;
					var paymentCreatedSaveRequest = _v15.c;
					return {
						GZ: cmd,
						agZ: 1,
						aiO: _Utils_update(
							model,
							{iD: cardReaderConnectingModal, SD: newForm, an: paymentCreatedSaveRequest}),
						aR: _List_Nil
					};
				} else {
					var newForm = _v12.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 1,
						aiO: _Utils_update(
							model,
							{SD: newForm}),
						aR: _List_Nil
					};
				}
			case 10:
				var validFormFields = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var payment = response.a;
					var _v20 = function () {
						var _v21 = _Utils_Tuple3(
							$author$project$Api$Payment$cardReader(payment),
							$author$project$Api$Payment$external(payment),
							$author$project$Api$Payment$status(payment));
						if (!_v21.a.$) {
							var cardReader = _v21.a.a;
							return A2(
								$author$project$Utils$Tuple3$fromTuple2,
								$elm$core$Maybe$Nothing,
								A3(
									$elm$core$Tuple$mapBoth,
									function (m) {
										return $elm$core$Maybe$Just(
											_Utils_Tuple2(m, validFormFields));
									},
									$elm$core$Platform$Cmd$map($author$project$Components$Invoice$CreatePaymentModal$CardReaderPaymentModalMsg),
									A6(
										$author$project$Components$CardReader$PaymentModal$init,
										apiClient,
										model.aa4,
										model.Ij,
										model.t9,
										$author$project$Api$Provider$CardReader$Shared$id(cardReader),
										payment)));
						} else {
							if (_v21.b) {
								var _v22 = _v21.a;
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$elm$core$Platform$Cmd$none,
									$elm$core$Maybe$Just(
										_Utils_Tuple2('Payment added', 3)));
							} else {
								if (_v21.c === 'failed') {
									var _v23 = _v21.a;
									return _Utils_Tuple3(
										$elm$core$Maybe$Nothing,
										$elm$core$Platform$Cmd$none,
										$elm$core$Maybe$Just(
											_Utils_Tuple2('Payment failed', 1)));
								} else {
									var _v24 = _v21.a;
									return _Utils_Tuple3(
										$elm$core$Maybe$Nothing,
										$elm$core$Platform$Cmd$none,
										$elm$core$Maybe$Just(
											_Utils_Tuple2('Payment processed successfully', 3)));
								}
							}
						}
					}();
					var cardReaderPaymentModal = _v20.a;
					var cardReaderPaymentModalCmd = _v20.b;
					var message = _v20.c;
					return {
						GZ: cardReaderPaymentModalCmd,
						agZ: _Utils_eq(cardReaderPaymentModal, $elm$core$Maybe$Nothing) ? 2 : 1,
						aiO: _Utils_update(
							model,
							{cp: cardReaderPaymentModal, an: $author$project$Api$Data$NotAsked}),
						aR: A2(
							$elm$core$List$append,
							_List_fromArray(
								[$author$project$OutMsg$RefreshPatientsList]),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function (_v25) {
										var toastMessage_ = _v25.a;
										var toastLevel_ = _v25.b;
										return _List_fromArray(
											[
												A2($author$project$OutMsg$ShowToast, toastLevel_, toastMessage_)
											]);
									},
									message)))
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 1,
						aiO: _Utils_update(
							model,
							{an: response}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 11:
				var dateInput = msg.a;
				var subMsg = msg.b;
				return A6(
					$author$project$Components$Invoice$CreatePaymentModal$updateDateInputFormField,
					model,
					dateInput,
					subMsg,
					$author$project$Components$Invoice$CreatePaymentModal$PaidAtDateInputMsg,
					$author$project$Components$Invoice$CreatePaymentModal$PaidAt,
					function ($) {
						return $.YH;
					});
			case 17:
				var subMsg = msg.a;
				var _v26 = model.iD;
				if (!_v26.$) {
					var _v27 = _v26.a;
					var cardReaderConnectingModal = _v27.a;
					var validFormFields = _v27.b;
					var cardReaderConnectingModalResult = A3($author$project$Components$CardReader$ConnectingModal$update, apiClient, subMsg, cardReaderConnectingModal);
					var _v28 = function () {
						var _v29 = cardReaderConnectingModalResult.agZ;
						switch (_v29.$) {
							case 1:
								var card = _v29.a;
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Api$Data$Loading,
									A5($author$project$Components$Invoice$CreatePaymentModal$createCard, model.JR, apiClient, model.aa4, validFormFields, card));
							case 0:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.an, $elm$core$Platform$Cmd$none);
							default:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(
										_Utils_Tuple2(cardReaderConnectingModalResult.aiO, validFormFields)),
									model.an,
									$elm$core$Platform$Cmd$none);
						}
					}();
					var cardReaderConnectingModal_ = _v28.a;
					var paymentCreatedSaveRequest = _v28.b;
					var cmd = _v28.c;
					return {
						GZ: $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$CreatePaymentModal$CardReaderConnectingModalMsg, cardReaderConnectingModalResult.GZ),
									cmd
								])),
						agZ: 1,
						aiO: _Utils_update(
							model,
							{iD: cardReaderConnectingModal_, an: paymentCreatedSaveRequest}),
						aR: cardReaderConnectingModalResult.aR
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 1, aiO: model, aR: _List_Nil};
				}
			case 18:
				var subMsg = msg.a;
				var _v30 = model.cp;
				if (!_v30.$) {
					var _v31 = _v30.a;
					var cardReaderPaymentModal = _v31.a;
					var validFormFields = _v31.b;
					var cardReaderPaymentModalResult = A3($author$project$Components$CardReader$PaymentModal$update, apiClient, subMsg, cardReaderPaymentModal);
					var _v32 = cardReaderPaymentModalResult.agZ;
					switch (_v32) {
						case 1:
							return {
								GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$CreatePaymentModal$CardReaderPaymentModalMsg, cardReaderPaymentModalResult.GZ),
								agZ: 2,
								aiO: _Utils_update(
									model,
									{cp: $elm$core$Maybe$Nothing, an: $author$project$Api$Data$NotAsked}),
								aR: _Utils_ap(
									cardReaderPaymentModalResult.aR,
									_List_fromArray(
										[
											A2($author$project$OutMsg$ShowToast, 3, 'Payment processed successfully'),
											$author$project$OutMsg$RefreshPatientsList
										]))
							};
						case 3:
							return {
								GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$CreatePaymentModal$CardReaderPaymentModalMsg, cardReaderPaymentModalResult.GZ),
								agZ: 2,
								aiO: _Utils_update(
									model,
									{cp: $elm$core$Maybe$Nothing, an: $author$project$Api$Data$NotAsked}),
								aR: _Utils_ap(
									cardReaderPaymentModalResult.aR,
									_List_fromArray(
										[$author$project$OutMsg$RefreshPatientsList]))
							};
						case 2:
							return {
								GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$CreatePaymentModal$CardReaderPaymentModalMsg, cardReaderPaymentModalResult.GZ),
								agZ: 2,
								aiO: _Utils_update(
									model,
									{cp: $elm$core$Maybe$Nothing, an: $author$project$Api$Data$NotAsked}),
								aR: _Utils_ap(
									cardReaderPaymentModalResult.aR,
									_List_fromArray(
										[
											A2($author$project$OutMsg$ShowToast, 1, 'Payment failed'),
											$author$project$OutMsg$RefreshPatientsList
										]))
							};
						case 0:
							return {
								GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$CreatePaymentModal$CardReaderPaymentModalMsg, cardReaderPaymentModalResult.GZ),
								agZ: 1,
								aiO: _Utils_update(
									model,
									{cp: $elm$core$Maybe$Nothing, an: $author$project$Api$Data$NotAsked}),
								aR: cardReaderPaymentModalResult.aR
							};
						default:
							return {
								GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$CreatePaymentModal$CardReaderPaymentModalMsg, cardReaderPaymentModalResult.GZ),
								agZ: 1,
								aiO: _Utils_update(
									model,
									{
										cp: $elm$core$Maybe$Just(
											_Utils_Tuple2(cardReaderPaymentModalResult.aiO, validFormFields))
									}),
								aR: cardReaderPaymentModalResult.aR
							};
					}
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 1, aiO: model, aR: _List_Nil};
				}
			case 19:
				var validFormFields = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var card = response.a;
					return {
						GZ: A8(
							$author$project$Components$Invoice$CreatePaymentModal$createPayment,
							model.Cd,
							model.tK,
							apiClient,
							model.aa4,
							model.ajV,
							validFormFields,
							$elm$core$Maybe$Just(card),
							$elm$core$Maybe$Nothing),
						agZ: 1,
						aiO: model,
						aR: _List_Nil
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 1,
						aiO: _Utils_update(
							model,
							{an: $author$project$Api$Data$NotAsked}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			default:
				var response = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 1,
					aiO: _Utils_update(
						model,
						{YV: response}),
					aR: $author$project$OutMsg$handleErrorResponse(response)
				};
		}
	});
var $author$project$Components$Invoice$DownloadFile$AvailableOptionSelected = 1;
var $author$project$Components$Invoice$DownloadFile$DownloadFileClicked = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Invoice$DownloadFile$GotFile = 3;
var $author$project$Components$Invoice$DownloadFile$GotToken = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Invoice$DownloadFile$None = 0;
var $author$project$Components$Invoice$DownloadFile$PollFile = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Invoice$DownloadFile$UnavailableOptionSelected = 2;
var $author$project$Components$Invoice$DownloadFile$GotFileStatus = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Api$File$File = $elm$core$Basics$identity;
var $author$project$Api$File$Record = F2(
	function (processing, url) {
		return {_r: processing, adY: url};
	});
var $author$project$Api$File$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'url',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'processing',
		$elm$json$Json$Decode$bool,
		$elm$json$Json$Decode$succeed($author$project$Api$File$Record)));
var $author$project$Api$File$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$File$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$File$Token$toString = function (_v0) {
	var string = _v0;
	return string;
};
var $author$project$Api$File$retrievePath = function (token) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[
				'files',
				$author$project$Api$File$Token$toString(token)
			]),
		$author$project$Api$Data$providerPath);
};
var $author$project$Api$File$generate = F3(
	function (apiClient, token, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$File$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['generate']),
					$author$project$Api$File$retrievePath(token))));
	});
var $author$project$Components$Invoice$DownloadFile$generateFile = F3(
	function (model, apiClient, token) {
		return model.U5 ? A3(
			$author$project$Api$File$generate,
			apiClient,
			token,
			$author$project$Components$Invoice$DownloadFile$GotFileStatus(token)) : $elm$core$Platform$Cmd$none;
	});
var $author$project$Api$File$isProcessing = function (_v0) {
	var record = _v0;
	return record._r;
};
var $author$project$Ports$Navigation$navigationPortOpenInNewWindow = _Platform_outgoingPort('navigationPortOpenInNewWindow', $elm$json$Json$Encode$string);
var $author$project$Ports$Navigation$openInNewWindow = $author$project$Ports$Navigation$navigationPortOpenInNewWindow;
var $author$project$Api$Provider$File$One$File = $elm$core$Basics$identity;
var $author$project$Api$Provider$File$One$Record = function (token) {
	return {adi: token};
};
var $author$project$Api$Provider$File$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'token',
	$author$project$Api$File$Token$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$File$One$Record));
var $author$project$Api$Provider$File$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$File$One$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$File$retrieveToken = F4(
	function (apiClient, path, options, toMsg) {
		var lte = (options.Iw === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(options.Iw);
		var gte = (options.HY === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(options.HY);
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('account_statement')),
					_Utils_Tuple2(
					'options',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'date',
								$elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'gte',
											A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, gte)),
											_Utils_Tuple2(
											'lte',
											A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, lte))
										])))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$File$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['files']),
						path))));
	});
var $author$project$Api$Provider$File$One$token = function (_v0) {
	var record = _v0;
	return record.adi;
};
var $author$project$Api$File$url = function (_v0) {
	var record = _v0;
	return record.adY;
};
var $author$project$Components$Invoice$DownloadFile$update = F3(
	function (apiClient, msg, model) {
		update:
		while (true) {
			switch (msg.$) {
				case 6:
					var path = msg.a;
					var options = msg.b;
					return {
						GZ: A4($author$project$Api$File$retrieveToken, apiClient, path, options, $author$project$Components$Invoice$DownloadFile$GotToken),
						agZ: 0,
						aiO: model,
						aR: _List_Nil
					};
				case 7:
					var response = msg.a;
					switch (response.$) {
						case 3:
							var file = response.a;
							var $temp$apiClient = apiClient,
								$temp$msg = $author$project$Components$Invoice$DownloadFile$DownloadFileClicked(
								$author$project$Api$Provider$File$One$token(file)),
								$temp$model = model;
							apiClient = $temp$apiClient;
							msg = $temp$msg;
							model = $temp$model;
							continue update;
						case 2:
							return {
								GZ: $elm$core$Platform$Cmd$none,
								agZ: 0,
								aiO: model,
								aR: $author$project$OutMsg$handleErrorResponse(response)
							};
						default:
							return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
					}
				case 0:
					var token = msg.a;
					var newModel = _Utils_update(
						model,
						{U5: true});
					return {
						GZ: A3($author$project$Components$Invoice$DownloadFile$generateFile, newModel, apiClient, token),
						agZ: 1,
						aiO: newModel,
						aR: _List_Nil
					};
				case 1:
					var token = msg.a;
					var response = msg.b;
					if (response.$ === 3) {
						var fileStatus = response.a;
						return $author$project$Api$File$isProcessing(fileStatus) ? {
							GZ: A2(
								$elm$core$Task$perform,
								function (_v3) {
									return $author$project$Components$Invoice$DownloadFile$PollFile(token);
								},
								$elm$core$Process$sleep(2000)),
							agZ: 0,
							aiO: _Utils_update(
								model,
								{U5: true}),
							aR: _List_Nil
						} : {
							GZ: A2(
								$elm$core$Maybe$withDefault,
								$elm$core$Platform$Cmd$none,
								A2(
									$elm$core$Maybe$map,
									$author$project$Ports$Navigation$openInNewWindow,
									$author$project$Api$File$url(fileStatus))),
							agZ: 3,
							aiO: _Utils_update(
								model,
								{U5: false}),
							aR: _List_Nil
						};
					} else {
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 0,
							aiO: model,
							aR: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
				case 2:
					var token = msg.a;
					return {
						GZ: A3($author$project$Components$Invoice$DownloadFile$generateFile, model, apiClient, token),
						agZ: 0,
						aiO: model,
						aR: _List_Nil
					};
				case 3:
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{U5: false}),
						aR: _List_Nil
					};
				case 4:
					var subMsg = msg.a;
					var _v4 = A2($author$project$Ui$Dropdown$update, subMsg, model.gi);
					var newDropdown = _v4.a;
					var dropdownCmd = _v4.b;
					return {
						GZ: dropdownCmd,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{gi: newDropdown}),
						aR: _List_Nil
					};
				default:
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 2, aiO: model, aR: _List_Nil};
			}
		}
	});
var $author$project$Components$Invoice$PaymentsHistory$DisputeSimulated = 5;
var $author$project$Components$Invoice$PaymentsHistory$None = 0;
var $author$project$Components$Invoice$PaymentsHistory$PaymentCancelled = 2;
var $author$project$Components$Invoice$PaymentsHistory$PaymentDeleted = 3;
var $author$project$Components$Invoice$PaymentsHistory$RefundCancelled = 4;
var $author$project$Components$Invoice$PaymentsHistory$RefundCreated = 1;
var $author$project$Components$PaymentsList$DisputeSimulated = 5;
var $author$project$Components$PaymentsList$GotCancelPayment = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$PaymentsList$GotDeleteExternalPayment = function (a) {
	return {$: 21, a: a};
};
var $author$project$Components$PaymentsList$GotRefundCancelled = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$PaymentsList$None = 0;
var $author$project$Api$Platform$RainforestSession$Payment = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$PaymentsList$PaymentCancelled = 2;
var $author$project$Components$PaymentsList$PaymentDeleted = 3;
var $author$project$Components$PaymentsList$PaymentDisputeModalMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$PaymentsList$RainforestPaymentModalMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Platform$RainforestSession$Refund = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$PaymentsList$RefundCancelled = 4;
var $author$project$Components$PaymentsList$RefundCreated = 1;
var $author$project$Api$Payment$paymentPath = F2(
	function (basePath, id_) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id_]),
			$author$project$Api$Payment$paymentsPath(basePath));
	});
var $author$project$Api$Payment$cancel = F5(
	function (basePath, apiClient, session, id_, toMsg) {
		return ($author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Employer$Payment$One$decoder,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Payment$Employer_One))) : A3(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Payment$One$decoder,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Payment$Provider_One))))(
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['cancel']),
					A2($author$project$Api$Payment$paymentPath, basePath, id_))));
	});
var $author$project$Api$Provider$Refund$refundsPath = function (paymentPath) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['refunds']),
		paymentPath);
};
var $author$project$Api$Provider$Refund$refundPath = F2(
	function (paymentsPath, id) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id]),
			$author$project$Api$Provider$Refund$refundsPath(paymentsPath));
	});
var $author$project$Api$Provider$Refund$cancel = F4(
	function (paymentPath, apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Refund$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['cancel']),
					A2($author$project$Api$Provider$Refund$refundPath, paymentPath, id))));
	});
var $author$project$Api$Payment$deleteExternal = F4(
	function (basePath, apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Payment$paymentPath, basePath, id_)));
	});
var $author$project$Api$Employer$Refund$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Refund$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Refund$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Refund$Shared$id(shared);
};
var $author$project$Api$Refund$id = function (refund) {
	switch (refund.$) {
		case 0:
			var refund_ = refund.a;
			return $author$project$Api$Provider$Refund$One$id(refund_);
		case 1:
			var refund_ = refund.a;
			return $author$project$Api$Provider$Refund$Shared$id(refund_);
		default:
			var refund_ = refund.a;
			return $author$project$Api$Employer$Refund$Shared$id(refund_);
	}
};
var $author$project$Components$Invoice$RefundModal$Model = $elm$core$Basics$identity;
var $author$project$Api$Employer$Payment$Shared$amountInCents = function (_v0) {
	var record = _v0;
	return record.LE;
};
var $author$project$Api$Employer$Payment$One$amountInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Payment$Shared$amountInCents(shared);
};
var $author$project$Api$Provider$Payment$Shared$amountInCents = function (_v0) {
	var record = _v0;
	return record.LE;
};
var $author$project$Api$Provider$Payment$One$amountInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$amountInCents(shared);
};
var $author$project$Api$Provider$Payment$SharedWithRefunds$amountInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$amountInCents(shared);
};
var $author$project$Api$Payment$amountInCents = function (payment) {
	switch (payment.$) {
		case 1:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$One$amountInCents(payment_);
		case 0:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$SharedWithRefunds$amountInCents(payment_);
		default:
			var payment_ = payment.a;
			return $author$project$Api$Employer$Payment$One$amountInCents(payment_);
	}
};
var $author$project$Components$Invoice$RefundModal$formFieldsFromPayment = function (payment) {
	return {
		LE: $elm$core$Maybe$Just(
			$author$project$Currency$fromInt(
				$author$project$Api$Payment$amountInCents(payment))),
		aiG: $elm$core$Maybe$Nothing,
		o$: $author$project$Api$Payment$amountInCents(payment)
	};
};
var $author$project$Api$Provider$Payment$Shared$isRefundableOnPaymentProcessor = function (_v0) {
	var record = _v0;
	return record.U9;
};
var $author$project$Api$Provider$Payment$One$isRefundableOnPaymentProcessor = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$isRefundableOnPaymentProcessor(shared);
};
var $author$project$Api$Provider$Payment$SharedWithRefunds$isRefundableOnPaymentProcessor = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$isRefundableOnPaymentProcessor(shared);
};
var $author$project$Api$Payment$isRefundableOnPaymentProcessor = function (payment) {
	switch (payment.$) {
		case 1:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$One$isRefundableOnPaymentProcessor(payment_);
		case 0:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$SharedWithRefunds$isRefundableOnPaymentProcessor(payment_);
		default:
			return false;
	}
};
var $author$project$Components$Invoice$RefundModal$isOldPaymentProcessorPayment = function (payment) {
	return (!$author$project$Api$Payment$isRefundableOnPaymentProcessor(payment)) && (!$author$project$Api$Payment$external(payment));
};
var $author$project$Components$Invoice$RefundModal$isExternalRefund = function (payment) {
	var oldPaymentProcessorPayment = $author$project$Components$Invoice$RefundModal$isOldPaymentProcessorPayment(payment);
	var externalPayment = $author$project$Api$Payment$external(payment);
	return externalPayment || oldPaymentProcessorPayment;
};
var $author$project$Components$Invoice$RefundModal$init = F4(
	function (timeFormatter, paymentPath, allowPartialRefunds, payment) {
		return {
			xi: allowPartialRefunds,
			sl: $author$project$Components$Invoice$RefundModal$isExternalRefund(payment),
			SD: $author$project$Utils$Form$init(
				$author$project$Components$Invoice$RefundModal$formFieldsFromPayment(payment)),
			IQ: $author$project$Components$Invoice$RefundModal$isOldPaymentProcessorPayment(payment),
			Y9: payment,
			tK: paymentPath,
			k9: $author$project$Api$Data$NotAsked,
			J7: timeFormatter
		};
	});
var $author$project$Components$PaymentDisputeModal$Loading = {$: 2};
var $author$project$Components$PaymentDisputeModal$GotDisputes = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Dispute$All$Dispute = $elm$core$Basics$identity;
var $author$project$Api$Provider$Dispute$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Dispute$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Dispute$disputesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['disputes']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Sort$Model = $elm$core$Basics$identity;
var $author$project$Api$Sort$init = {PW: $elm$core$Maybe$Nothing, t1: '', aee: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$Dispute$listDefaults = {ajJ: $author$project$Api$Pagination$init, I7: $elm$core$Maybe$Nothing, alA: $author$project$Api$Sort$init, alH: $elm$core$Maybe$Nothing};
var $author$project$Api$Sort$pageParamName = function (prefix) {
	return prefix + 'sort';
};
var $author$project$Api$Sort$valueOrDefault = function (_v0) {
	var model = _v0;
	var _v1 = _Utils_Tuple2(model.aee, model.PW);
	if (!_v1.a.$) {
		var value = _v1.a.a;
		return $elm$core$Maybe$Just(value);
	} else {
		var _v2 = _v1.a;
		var _default = _v1.b;
		return _default;
	}
};
var $author$project$Api$Sort$toPrefixeddParams = F2(
	function (prefix, _v0) {
		var model = _v0;
		var _v1 = $author$project$Api$Sort$valueOrDefault(model);
		if (!_v1.$) {
			var _v2 = _v1.a;
			var column = _v2.a;
			var direction = _v2.b;
			var sortParam = function () {
				if (!direction) {
					return column;
				} else {
					return '-' + column;
				}
			}();
			return _List_fromArray(
				[
					A2(
					$author$project$Api$Param$string,
					$author$project$Api$Sort$pageParamName(prefix),
					sortParam)
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Api$Sort$toParams = $author$project$Api$Sort$toPrefixeddParams('');
var $author$project$Api$Provider$Dispute$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Dispute$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ),
				A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Api$Param$string('payment'),
						$elm$core$List$singleton),
					options.I7)),
				A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Api$Param$string('status'),
						$elm$core$List$singleton),
					options.alH))
			]));
};
var $author$project$Api$Provider$Dispute$list = F3(
	function (apiClient, query, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Dispute$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Dispute$listOptionsToParams(query),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Dispute$disputesPath)));
	});
var $author$project$Components$PaymentDisputeModal$fetchDisputes = F2(
	function (client, paymentId) {
		return A3(
			$author$project$Api$Provider$Dispute$list,
			client,
			function (q) {
				return _Utils_update(
					q,
					{
						I7: $elm$core$Maybe$Just(paymentId)
					});
			},
			$author$project$Components$PaymentDisputeModal$GotDisputes);
	});
var $author$project$Components$PaymentDisputeModal$init = F2(
	function (client, paymentId) {
		return _Utils_Tuple2(
			{QL: $author$project$Components$PaymentDisputeModal$Loading},
			A2($author$project$Components$PaymentDisputeModal$fetchDisputes, client, paymentId));
	});
var $author$project$Components$Rainforest$SessionModal$GotSession = $elm$core$Basics$identity;
var $author$project$Components$Rainforest$SessionModal$Loading = {$: 0};
var $author$project$Api$Platform$RainforestSession$RainforestSession = F4(
	function (rainforestResourceId, rainforestSessionKey, rainforestResourceType, rainforestParentResourceId) {
		return {akm: rainforestParentResourceId, akn: rainforestResourceId, ako: rainforestResourceType, akp: rainforestSessionKey};
	});
var $author$project$Api$Platform$RainforestSession$decodeSession = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'rainforest_parent_resource_id',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'rainforest_resource_type',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'rainforest_session_key',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'rainforest_resource_id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Platform$RainforestSession$RainforestSession)))));
var $author$project$Api$Platform$RainforestSession$rainforestSessionsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['rainforest_sessions']),
	$author$project$Api$Data$platformPath);
var $author$project$Api$Platform$RainforestSession$create = F3(
	function (apiClient, resource, toMsg) {
		var _v0 = function () {
			switch (resource.$) {
				case 0:
					var depositId = resource.a;
					return _Utils_Tuple2('deposit', depositId);
				case 1:
					var paymentId = resource.a;
					return _Utils_Tuple2('payment', paymentId);
				default:
					var refundId = resource.a;
					return _Utils_Tuple2('refund', refundId);
			}
		}();
		var resoourceType = _v0.a;
		var resoourceId = _v0.b;
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'resource_type',
					$elm$json$Json$Encode$string(resoourceType)),
					_Utils_Tuple2(
					'resource_id',
					$elm$json$Json$Encode$string(resoourceId))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Platform$RainforestSession$decodeSession,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Platform$RainforestSession$rainforestSessionsPath)));
	});
var $author$project$Components$Rainforest$SessionModal$init = F2(
	function (client, resource) {
		return _Utils_Tuple2(
			{Jy: resource, aa4: $author$project$Components$Rainforest$SessionModal$Loading},
			A3($author$project$Api$Platform$RainforestSession$create, client, resource, $elm$core$Basics$identity));
	});
var $author$project$Components$Rainforest$SimulateDisputeEventModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Rainforest$SimulateDisputeEventModal$defaultStatus = 'WON';
var $author$project$Components$Rainforest$SimulateDisputeEventModal$init = F4(
	function (basePath, session, payment, dispute) {
		return _Utils_Tuple2(
			{xx: basePath, QL: dispute, Y9: payment, aa4: session, qf: $author$project$Api$Data$NotAsked, alH: $author$project$Components$Rainforest$SimulateDisputeEventModal$defaultStatus},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Components$Rainforest$SimulateDisputeModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Rainforest$SimulateDisputeModal$defaultStatus = 'DISPUTE_ACTION_REQUIRED';
var $author$project$Components$Rainforest$SimulateDisputeModal$init = F3(
	function (basePath, session, payment) {
		return _Utils_Tuple2(
			{xx: basePath, Y9: payment, aa4: session, qg: $author$project$Api$Data$NotAsked, alH: $author$project$Components$Rainforest$SimulateDisputeModal$defaultStatus},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Components$Invoice$RefundModal$Closed = 0;
var $author$project$Components$Invoice$RefundModal$None = 1;
var $author$project$Components$Invoice$RefundModal$RefundCreated = 2;
var $author$project$Components$Invoice$RefundModal$Created = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Refund$create = F4(
	function (paymentPath, apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'refund',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'amount_in_cents',
								$author$project$Currency$encode(fields.LE)),
								_Utils_Tuple2(
								'memo',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.aiG)),
								_Utils_Tuple2(
								'external',
								$elm$json$Json$Encode$bool(fields.R5))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Refund$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Refund$refundsPath(paymentPath))));
	});
var $author$project$Components$Invoice$RefundModal$createRefund = F4(
	function (paymentPath, apiClient, formFields, externalRefund) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4(
			$author$project$Api$Provider$Refund$create,
			paymentPath,
			apiClient,
			{
				LE: A2(
					$elm$core$Maybe$withDefault,
					$author$project$Currency$fromInt(fields.o$),
					fields.LE),
				R5: externalRefund,
				aiG: fields.aiG
			},
			$author$project$Components$Invoice$RefundModal$Created);
	});
var $author$project$Components$Invoice$RefundModal$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var _int = field.a;
			return _Utils_update(
				fields,
				{LE: _int});
		} else {
			var string = field.a;
			return _Utils_update(
				fields,
				{
					aiG: $author$project$Utils$String$toMaybe(string)
				});
		}
	});
var $author$project$Components$Invoice$RefundModal$AmountInCentsValidation = 0;
var $author$project$Components$Invoice$RefundModal$validateAmountInCents = function (fields) {
	return A2(
		$author$project$Utils$Validate$isInvalidCurrency,
		{
			aeU: false,
			AU: $elm$core$Maybe$Just(fields.o$),
			W9: $elm$core$Maybe$Just(100)
		},
		fields.LE) ? _List_fromArray(
		[
			_Utils_Tuple2(
			0,
			'Please enter an amount between $1.00 and ' + ($author$project$Utils$Currency$fromInt(fields.o$) + '.'))
		]) : _List_Nil;
};
var $author$project$Components$Invoice$RefundModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Invoice$RefundModal$validateAmountInCents)
		]));
var $author$project$Components$Invoice$RefundModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
			case 1:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Invoice$RefundModal$formFieldsUpdate, field, model.SD);
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 1,
					aiO: _Utils_update(
						model,
						{SD: newForm}),
					aR: _List_Nil
				};
			case 2:
				var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$Invoice$RefundModal$formFieldsValidator, model.SD);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var newForm = _v3.a;
					var validFormFields = _v3.b;
					return {
						GZ: A4($author$project$Components$Invoice$RefundModal$createRefund, model.tK, apiClient, validFormFields, model.sl),
						agZ: 1,
						aiO: _Utils_update(
							model,
							{SD: newForm, k9: $author$project$Api$Data$Loading}),
						aR: _List_Nil
					};
				} else {
					var newForm = _v2.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 1,
						aiO: _Utils_update(
							model,
							{SD: newForm}),
						aR: _List_Nil
					};
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 2,
						aiO: _Utils_update(
							model,
							{k9: $author$project$Api$Data$NotAsked}),
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Refund successfully created')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 1,
						aiO: _Utils_update(
							model,
							{k9: response}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
		}
	});
var $author$project$Components$PaymentDisputeModal$DisputeModalMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$PaymentDisputeModal$Failed = {$: 3};
var $author$project$Components$PaymentDisputeModal$First = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$PaymentDisputeModal$NoDisputes = {$: 1};
var $author$project$Api$Provider$Dispute$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Dispute$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Dispute$Shared$id(shared);
};
var $author$project$Components$DisputeModal$GotSession = $elm$core$Basics$identity;
var $author$project$Components$DisputeModal$Loading = {$: 0};
var $author$project$Api$Platform$Dispute$Session$Rainforest = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Platform$Dispute$Session$RainforestSession = F2(
	function (chargebackId, sessionKey) {
		return {afF: chargebackId, alo: sessionKey};
	});
var $author$project$Api$Platform$Dispute$Session$Stripe = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Platform$Dispute$Session$StripeSession = F2(
	function (chargeId, sessionKey) {
		return {afz: chargeId, alo: sessionKey};
	});
var $author$project$Api$Platform$Dispute$Session$decodeSession = A2(
	$elm$json$Json$Decode$andThen,
	function (processor) {
		switch (processor) {
			case 'rainforest':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Api$Platform$Dispute$Session$Rainforest,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'session_key',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'chargeback_id',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Api$Platform$Dispute$Session$RainforestSession))));
			case 'stripe':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Api$Platform$Dispute$Session$Stripe,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'session_key',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'charge_id',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Api$Platform$Dispute$Session$StripeSession))));
			default:
				return $elm$json$Json$Decode$fail('Unsupported processor ' + processor);
		}
	},
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['payment_processor']),
		$elm$json$Json$Decode$string));
var $author$project$Api$Platform$Dispute$Session$disputesPath = function (basePath) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['disputes']),
		basePath);
};
var $author$project$Api$Platform$Dispute$Session$retrieve = F4(
	function (basePath, apiClient, disputeId, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Platform$Dispute$Session$decodeSession,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						[disputeId, 'session']),
					$author$project$Api$Platform$Dispute$Session$disputesPath(basePath))));
	});
var $author$project$Components$DisputeModal$init = F3(
	function (basePath, client, disputeId) {
		return _Utils_Tuple2(
			{QL: $author$project$Components$DisputeModal$Loading},
			A4($author$project$Api$Platform$Dispute$Session$retrieve, basePath, client, disputeId, $elm$core$Basics$identity));
	});
var $author$project$Components$DisputeModal$Failed = {$: 1};
var $author$project$Components$DisputeModal$Session = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ports$Stripe$stripePortMountPaymentDisputesComponent = _Platform_outgoingPort(
	'stripePortMountPaymentDisputesComponent',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'chargeId',
					$elm$json$Json$Encode$string($.afz)),
					_Utils_Tuple2(
					'selector',
					$elm$json$Json$Encode$string($.aW)),
					_Utils_Tuple2(
					'stripeClientSecret',
					$elm$json$Json$Encode$string($.hO))
				]));
	});
var $author$project$Ports$Stripe$mountPaymentDisputesComponent = F3(
	function (selector, stripeClientSecret, chargeId) {
		return $author$project$Ports$Stripe$stripePortMountPaymentDisputesComponent(
			{afz: chargeId, aW: selector, hO: stripeClientSecret});
	});
var $author$project$Components$DisputeModal$update = F2(
	function (msg, model) {
		var response = msg;
		switch (response.$) {
			case 3:
				var session = response.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							QL: $author$project$Components$DisputeModal$Session(session)
						}),
					function () {
						if (!session.$) {
							return $elm$core$Platform$Cmd$none;
						} else {
							var stripeSession = session.a;
							return A3($author$project$Ports$Stripe$mountPaymentDisputesComponent, '#stripe-payment-disputes-' + stripeSession.afz, stripeSession.alo, stripeSession.afz);
						}
					}(),
					_List_Nil);
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{QL: $author$project$Components$DisputeModal$Failed}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Components$PaymentDisputeModal$update = F3(
	function (client, msg, model) {
		if (!msg.$) {
			var response = msg.a;
			switch (response.$) {
				case 3:
					var disputes = response.a;
					var _v2 = $elm$core$List$head(disputes);
					if (!_v2.$) {
						var dispute = _v2.a;
						var _v3 = A3(
							$author$project$Components$DisputeModal$init,
							$author$project$Api$Data$providerPath,
							client,
							$author$project$Api$Provider$Dispute$All$id(dispute));
						var disputeModal = _v3.a;
						var disputeCmd = _v3.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									QL: $author$project$Components$PaymentDisputeModal$First(disputeModal)
								}),
							A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentDisputeModal$DisputeModalMsg, disputeCmd),
							_List_Nil);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{QL: $author$project$Components$PaymentDisputeModal$NoDisputes}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				case 2:
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{QL: $author$project$Components$PaymentDisputeModal$Failed}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				default:
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
			}
		} else {
			var subMsg = msg.a;
			var _v4 = model.QL;
			if (!_v4.$) {
				var disputeModal = _v4.a;
				var _v5 = A2($author$project$Components$DisputeModal$update, subMsg, disputeModal);
				var newDisputeModal = _v5.a;
				var disputeModalCmd = _v5.b;
				var disputeModalOutMsgs = _v5.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							QL: $author$project$Components$PaymentDisputeModal$First(newDisputeModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentDisputeModal$DisputeModalMsg, disputeModalCmd),
					disputeModalOutMsgs);
			} else {
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
			}
		}
	});
var $author$project$Components$Rainforest$SessionModal$Failed = {$: 1};
var $author$project$Components$Rainforest$SessionModal$Loaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Rainforest$SessionModal$update = F2(
	function (msg, model) {
		var response = msg;
		switch (response.$) {
			case 3:
				var session = response.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aa4: $author$project$Components$Rainforest$SessionModal$Loaded(session)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aa4: $author$project$Components$Rainforest$SessionModal$Failed}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			default:
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
		}
	});
var $author$project$Components$Rainforest$SimulateDisputeEventModal$Closed = 2;
var $author$project$Components$Rainforest$SimulateDisputeEventModal$DisputeSimulated = 1;
var $author$project$Components$Rainforest$SimulateDisputeEventModal$GotSimulateDisputeEventResponse = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Rainforest$SimulateDisputeEventModal$None = 0;
var $author$project$Api$Provider$Dispute$One$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Dispute$Shared$id(shared);
};
var $author$project$Api$Dispute$id = function (dispute) {
	if (!dispute.$) {
		var dispute_ = dispute.a;
		return $author$project$Api$Provider$Dispute$One$id(dispute_);
	} else {
		var dispute_ = dispute.a;
		return $author$project$Api$Provider$Dispute$Shared$id(dispute_);
	}
};
var $author$project$Api$Dispute$Provider_One = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Dispute$One$Dispute = $elm$core$Basics$identity;
var $author$project$Api$Provider$Dispute$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Dispute$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Payment$Dispute$paymentsDisputesPath = F2(
	function (basePath, paymentId) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				['disputes']),
			A2($author$project$Api$Payment$paymentPath, basePath, paymentId));
	});
var $author$project$Api$Payment$Dispute$paymentsDisputePath = F3(
	function (basePath, paymentId, id) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id]),
			A2($author$project$Api$Payment$Dispute$paymentsDisputesPath, basePath, paymentId));
	});
var $author$project$Api$Payment$Dispute$simulateEvent = F7(
	function (basePath, apiClient, session, paymentId, disputeId, status, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'status',
					$elm$json$Json$Encode$string(status))
				]));
		return ($author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Basics$always($elm$core$Platform$Cmd$none) : A3(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Dispute$One$decoder,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Dispute$Provider_One))))(
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['simulate_event']),
						A3($author$project$Api$Payment$Dispute$paymentsDisputePath, basePath, paymentId, disputeId)))));
	});
var $author$project$Components$Rainforest$SimulateDisputeEventModal$statuses = _List_fromArray(
	['DISPUTE_ACTION_REQUIRED', 'PROVISIONAL_WIN', 'WON', 'LOST']);
var $author$project$Components$Rainforest$SimulateDisputeEventModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: 2, aiO: model, aR: _List_Nil};
			case 1:
				var inputStatus = msg.a;
				var selectedStatus = A2(
					$elm_community$list_extra$List$Extra$find,
					function (status_) {
						return _Utils_eq(status_, inputStatus);
					},
					$author$project$Components$Rainforest$SimulateDisputeEventModal$statuses);
				var status = A2($elm$core$Maybe$withDefault, $author$project$Components$Rainforest$SimulateDisputeEventModal$defaultStatus, selectedStatus);
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{alH: status}),
					aR: _List_Nil
				};
			case 2:
				return {
					GZ: A7(
						$author$project$Api$Payment$Dispute$simulateEvent,
						model.xx,
						apiClient,
						model.aa4,
						$author$project$Api$Payment$id(model.Y9),
						$author$project$Api$Dispute$id(model.QL),
						model.alH,
						$author$project$Components$Rainforest$SimulateDisputeEventModal$GotSimulateDisputeEventResponse),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{qf: $author$project$Api$Data$Loading}),
					aR: _List_Nil
				};
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 1,
						aiO: _Utils_update(
							model,
							{qf: response}),
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Dispute event simulated successfully')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{qf: response}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
		}
	});
var $author$project$Components$Rainforest$SimulateDisputeModal$Closed = 2;
var $author$project$Components$Rainforest$SimulateDisputeModal$DisputeSimulated = 1;
var $author$project$Components$Rainforest$SimulateDisputeModal$GotSimulateDisputeResponse = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Rainforest$SimulateDisputeModal$None = 0;
var $author$project$Api$Payment$Dispute$simulate = F6(
	function (basePath, apiClient, session, paymentId, status, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'status',
					$elm$json$Json$Encode$string(status))
				]));
		return ($author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Basics$always($elm$core$Platform$Cmd$none) : A3(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Dispute$One$decoder,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Dispute$Provider_One))))(
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['simulate']),
						A2($author$project$Api$Payment$Dispute$paymentsDisputesPath, basePath, paymentId)))));
	});
var $author$project$Components$Rainforest$SimulateDisputeModal$statuses = _List_fromArray(
	['DISPUTE_ACTION_REQUIRED', 'INQUIRY_ACTION_REQUIRED']);
var $author$project$Components$Rainforest$SimulateDisputeModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: 2, aiO: model, aR: _List_Nil};
			case 1:
				var inputStatus = msg.a;
				var selectedStatus = A2(
					$elm_community$list_extra$List$Extra$find,
					function (status_) {
						return _Utils_eq(status_, inputStatus);
					},
					$author$project$Components$Rainforest$SimulateDisputeModal$statuses);
				var status = A2($elm$core$Maybe$withDefault, $author$project$Components$Rainforest$SimulateDisputeModal$defaultStatus, selectedStatus);
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{alH: status}),
					aR: _List_Nil
				};
			case 2:
				return {
					GZ: A6(
						$author$project$Api$Payment$Dispute$simulate,
						model.xx,
						apiClient,
						model.aa4,
						$author$project$Api$Payment$id(model.Y9),
						model.alH,
						$author$project$Components$Rainforest$SimulateDisputeModal$GotSimulateDisputeResponse),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{qg: $author$project$Api$Data$Loading}),
					aR: _List_Nil
				};
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 1,
						aiO: _Utils_update(
							model,
							{qg: response}),
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Dispute simulated successfully')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{qg: response}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
		}
	});
var $author$project$Components$PaymentsList$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var payment = msg.a;
				var paymentPath = A2(
					$author$project$Api$Payment$paymentPath,
					model.xx,
					$author$project$Api$Payment$id(payment));
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							kS: $elm$core$Maybe$Just(
								A4($author$project$Components$Invoice$RefundModal$init, model.J7, paymentPath, model.xi, payment))
						}),
					aR: _List_Nil
				};
			case 4:
				var subMsg = msg.a;
				var _v1 = model.ha;
				if (!_v1.$) {
					var paymentDisputeModal = _v1.a;
					var _v2 = A3($author$project$Components$PaymentDisputeModal$update, apiClient, subMsg, paymentDisputeModal);
					var newPaymentDisputeModal = _v2.a;
					var paymentDisputeModalCmd = _v2.b;
					var paymentDisputeModalOutMsgs = _v2.c;
					return function (m) {
						return {
							GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentsList$PaymentDisputeModalMsg, paymentDisputeModalCmd),
							agZ: 0,
							aiO: m,
							aR: paymentDisputeModalOutMsgs
						};
					}(
						_Utils_update(
							model,
							{
								ha: $elm$core$Maybe$Just(newPaymentDisputeModal)
							}));
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
			case 1:
				var subMsg = msg.a;
				var _v3 = model.kS;
				if (!_v3.$) {
					var refundModal = _v3.a;
					var refundModalResult = A3($author$project$Components$Invoice$RefundModal$update, apiClient, subMsg, refundModal);
					var _v4 = function () {
						var _v5 = refundModalResult.agZ;
						switch (_v5) {
							case 0:
								return _Utils_Tuple2($elm$core$Maybe$Nothing, 0);
							case 1:
								return _Utils_Tuple2(
									$elm$core$Maybe$Just(refundModalResult.aiO),
									0);
							default:
								return _Utils_Tuple2($elm$core$Maybe$Nothing, 1);
						}
					}();
					var refundModal_ = _v4.a;
					var event = _v4.b;
					return {
						GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentsList$RefundModalMsg, refundModalResult.GZ),
						agZ: event,
						aiO: _Utils_update(
							model,
							{kS: refundModal_}),
						aR: refundModalResult.aR
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
			case 2:
				var payment = msg.a;
				var _v6 = A2(
					$author$project$Components$PaymentDisputeModal$init,
					apiClient,
					$author$project$Api$Payment$id(payment));
				var paymentDisputeModal = _v6.a;
				var paymentDisputeModalCmd = _v6.b;
				return function (m) {
					return {
						GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentsList$PaymentDisputeModalMsg, paymentDisputeModalCmd),
						agZ: 0,
						aiO: m,
						aR: _List_Nil
					};
				}(
					_Utils_update(
						model,
						{
							ha: $elm$core$Maybe$Just(paymentDisputeModal)
						}));
			case 3:
				return function (m) {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: m, aR: _List_Nil};
				}(
					_Utils_update(
						model,
						{ha: $elm$core$Maybe$Nothing}));
			case 5:
				var payment = msg.a;
				var _v7 = A2(
					$author$project$Components$Rainforest$SessionModal$init,
					apiClient,
					$author$project$Api$Platform$RainforestSession$Payment(
						$author$project$Api$Payment$id(payment)));
				var rainforestPaymentModal = _v7.a;
				var rainforestPaymentModalCmd = _v7.b;
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentsList$RainforestPaymentModalMsg, rainforestPaymentModalCmd),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							e_: $elm$core$Maybe$Just(rainforestPaymentModal)
						}),
					aR: _List_Nil
				};
			case 8:
				var refund = msg.a;
				var _v8 = A2(
					$author$project$Components$Rainforest$SessionModal$init,
					apiClient,
					$author$project$Api$Platform$RainforestSession$Refund(
						$author$project$Api$Refund$id(refund)));
				var rainforestPaymentModal = _v8.a;
				var rainforestPaymentModalCmd = _v8.b;
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentsList$RainforestPaymentModalMsg, rainforestPaymentModalCmd),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							e_: $elm$core$Maybe$Just(rainforestPaymentModal)
						}),
					aR: _List_Nil
				};
			case 7:
				var subMsg = msg.a;
				var _v9 = model.e_;
				if (!_v9.$) {
					var rainforestPaymentModal = _v9.a;
					var _v10 = A2($author$project$Components$Rainforest$SessionModal$update, subMsg, rainforestPaymentModal);
					var newRainforestPaymentModal = _v10.a;
					var rainforestPaymentModalCmd = _v10.b;
					var rainforestPaymentModalOutMsg = _v10.c;
					return function (m) {
						return {
							GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentsList$RainforestPaymentModalMsg, rainforestPaymentModalCmd),
							agZ: 0,
							aiO: m,
							aR: rainforestPaymentModalOutMsg
						};
					}(
						_Utils_update(
							model,
							{
								e_: $elm$core$Maybe$Just(newRainforestPaymentModal)
							}));
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
			case 6:
				return function (m) {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: m, aR: _List_Nil};
				}(
					_Utils_update(
						model,
						{e_: $elm$core$Maybe$Nothing}));
			case 9:
				var payment = msg.a;
				var _v11 = A3($author$project$Components$Rainforest$SimulateDisputeModal$init, model.xx, model.aa4, payment);
				var simulateDisputeModal = _v11.a;
				var simulateDisputeModalCmd = _v11.b;
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentsList$SimulateDisputeModalMsg, simulateDisputeModalCmd),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							lt: $elm$core$Maybe$Just(simulateDisputeModal)
						}),
					aR: _List_Nil
				};
			case 10:
				var subMsg = msg.a;
				var _v12 = model.lt;
				if (!_v12.$) {
					var simulateDisputeModal = _v12.a;
					var simulateDisputeModalResult = A3($author$project$Components$Rainforest$SimulateDisputeModal$update, apiClient, subMsg, simulateDisputeModal);
					var _v13 = function () {
						var _v14 = simulateDisputeModalResult.agZ;
						switch (_v14) {
							case 2:
								return _Utils_Tuple2($elm$core$Maybe$Nothing, 0);
							case 0:
								return _Utils_Tuple2(
									$elm$core$Maybe$Just(simulateDisputeModalResult.aiO),
									0);
							default:
								return _Utils_Tuple2($elm$core$Maybe$Nothing, 5);
						}
					}();
					var simulateDisputeModal_ = _v13.a;
					var event = _v13.b;
					return {
						GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentsList$SimulateDisputeModalMsg, simulateDisputeModalResult.GZ),
						agZ: event,
						aiO: _Utils_update(
							model,
							{lt: simulateDisputeModal_}),
						aR: simulateDisputeModalResult.aR
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
			case 11:
				var payment = msg.a;
				var dispute = msg.b;
				var _v15 = A4($author$project$Components$Rainforest$SimulateDisputeEventModal$init, model.xx, model.aa4, payment, dispute);
				var simulateDisputeEventModal = _v15.a;
				var simulateDisputeEventModalCmd = _v15.b;
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentsList$SimulateDisputeEventModalMsg, simulateDisputeEventModalCmd),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							ls: $elm$core$Maybe$Just(simulateDisputeEventModal)
						}),
					aR: _List_Nil
				};
			case 12:
				var subMsg = msg.a;
				var _v16 = model.ls;
				if (!_v16.$) {
					var simulateDisputeEventModal = _v16.a;
					var simulateDisputeEventModalResult = A3($author$project$Components$Rainforest$SimulateDisputeEventModal$update, apiClient, subMsg, simulateDisputeEventModal);
					var _v17 = function () {
						var _v18 = simulateDisputeEventModalResult.agZ;
						switch (_v18) {
							case 2:
								return _Utils_Tuple2($elm$core$Maybe$Nothing, 0);
							case 0:
								return _Utils_Tuple2(
									$elm$core$Maybe$Just(simulateDisputeEventModalResult.aiO),
									0);
							default:
								return _Utils_Tuple2($elm$core$Maybe$Nothing, 5);
						}
					}();
					var simulateDisputeEventModal_ = _v17.a;
					var event = _v17.b;
					return {
						GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentsList$SimulateDisputeEventModalMsg, simulateDisputeEventModalResult.GZ),
						agZ: event,
						aiO: _Utils_update(
							model,
							{ls: simulateDisputeEventModal_}),
						aR: simulateDisputeEventModalResult.aR
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
			case 13:
				var payment = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							c4: $elm$core$Maybe$Just(
								_Utils_Tuple2(payment, $author$project$Api$Data$NotAsked))
						}),
					aR: _List_Nil
				};
			case 16:
				var paymentAndRefund = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							iC: $elm$core$Maybe$Just(paymentAndRefund)
						}),
					aR: _List_Nil
				};
			case 14:
				var payment = msg.a;
				var confirmed = msg.b;
				return confirmed ? {
					GZ: A5(
						$author$project$Api$Payment$cancel,
						model.xx,
						apiClient,
						model.aa4,
						$author$project$Api$Payment$id(payment),
						$author$project$Components$PaymentsList$GotCancelPayment),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							c4: $elm$core$Maybe$Just(
								_Utils_Tuple2(payment, $author$project$Api$Data$Loading))
						}),
					aR: _List_Nil
				} : {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{c4: $elm$core$Maybe$Nothing}),
					aR: _List_Nil
				};
			case 15:
				var response = msg.a;
				var _v19 = model.c4;
				if (!_v19.$) {
					var _v20 = _v19.a;
					var payment = _v20.a;
					if (response.$ === 3) {
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 2,
							aiO: _Utils_update(
								model,
								{c4: $elm$core$Maybe$Nothing}),
							aR: _List_Nil
						};
					} else {
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 0,
							aiO: _Utils_update(
								model,
								{
									c4: $elm$core$Maybe$Just(
										_Utils_Tuple2(payment, response))
								}),
							aR: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
			case 17:
				var confirmed = msg.a;
				return {
					GZ: function () {
						var _v22 = _Utils_Tuple2(confirmed, model.iC);
						if (_v22.a && (!_v22.b.$)) {
							var _v23 = _v22.b.a;
							var payment = _v23.a;
							var refund = _v23.b;
							var paymentPath = A2(
								$author$project$Api$Payment$paymentPath,
								model.xx,
								$author$project$Api$Payment$id(payment));
							return A4(
								$author$project$Api$Provider$Refund$cancel,
								paymentPath,
								apiClient,
								$author$project$Api$Refund$id(refund),
								$author$project$Components$PaymentsList$GotRefundCancelled);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}(),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{iC: $elm$core$Maybe$Nothing}),
					aR: _List_Nil
				};
			case 18:
				var response = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: function () {
						if (response.$ === 3) {
							return 4;
						} else {
							return 0;
						}
					}(),
					aiO: model,
					aR: $author$project$OutMsg$handleErrorResponse(response)
				};
			case 19:
				var payment = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							ej: $elm$core$Maybe$Just(
								_Utils_Tuple2(payment, $author$project$Api$Data$NotAsked))
						}),
					aR: _List_Nil
				};
			case 20:
				var payment = msg.a;
				var confirmed = msg.b;
				return confirmed ? {
					GZ: A4(
						$author$project$Api$Payment$deleteExternal,
						model.xx,
						apiClient,
						$author$project$Api$Payment$id(payment),
						$author$project$Components$PaymentsList$GotDeleteExternalPayment),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							ej: $elm$core$Maybe$Just(
								_Utils_Tuple2(payment, $author$project$Api$Data$Loading))
						}),
					aR: _List_Nil
				} : {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{ej: $elm$core$Maybe$Nothing}),
					aR: _List_Nil
				};
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 3,
						aiO: _Utils_update(
							model,
							{ej: $elm$core$Maybe$Nothing}),
						aR: _List_Nil
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{ej: $elm$core$Maybe$Nothing}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
		}
	});
var $author$project$Ui$Popover$update = F2(
	function (msg, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{Yn: false});
	});
var $author$project$Components$Invoice$PaymentsHistory$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var popover = A3(
					$author$project$Ui$Popover$init,
					'payment-history',
					!$author$project$Ui$Popover$isOpen(model.aT),
					$author$project$Components$Invoice$PaymentsHistory$PopoverMsg);
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{aT: popover}),
					aR: _List_Nil
				};
			case 1:
				var subMsg = msg.a;
				var paymentsListResult = A3($author$project$Components$PaymentsList$update, apiClient, subMsg, model.kD);
				var event = function () {
					var _v1 = paymentsListResult.agZ;
					switch (_v1) {
						case 0:
							return 0;
						case 1:
							return 1;
						case 2:
							return 2;
						case 3:
							return 3;
						case 4:
							return 4;
						default:
							return 5;
					}
				}();
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$PaymentsHistory$PaymentsListMsg, paymentsListResult.GZ),
					agZ: event,
					aiO: _Utils_update(
						model,
						{kD: paymentsListResult.aiO}),
					aR: paymentsListResult.aR
				};
			default:
				var subMsg = msg.a;
				var popoverModel = A2($author$project$Ui$Popover$update, subMsg, model.aT);
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{aT: popoverModel}),
					aR: _List_Nil
				};
		}
	});
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{tV: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Ui$Dropdown$update, subMsg, model.no);
				var dropdownMenu = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{no: dropdownMenu}),
					cmd,
					_List_Nil);
			case 2:
				var practiceInvoice = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							vp: $elm$core$Maybe$Just(
								_Utils_Tuple2(practiceInvoice, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var practiceInvoice = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							vp: $elm$core$Maybe$Just(
								_Utils_Tuple2(practiceInvoice, $author$project$Api$Data$Loading))
						}),
					A3(
						$author$project$Api$Provider$PracticeInvoice$cancel,
						model.Gv,
						$author$project$Api$Provider$PracticeInvoice$One$id(practiceInvoice),
						$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Voided),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{vp: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{tV: response, vp: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Invoice voided')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 5:
				var practiceInvoice = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{k9: $author$project$Api$Data$Loading}),
					A3(
						$author$project$Api$Provider$PracticeInvoice$issue,
						model.Gv,
						$author$project$Api$Provider$PracticeInvoice$One$id(practiceInvoice),
						$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Issued),
					_List_Nil);
			case 6:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{tV: response, k9: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Invoice issued')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 9:
				var practiceInvoice = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							i9: $elm$core$Maybe$Just(
								_Utils_Tuple2(practiceInvoice, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 10:
				var practiceInvoice = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							i9: $elm$core$Maybe$Just(
								_Utils_Tuple2(practiceInvoice, $author$project$Api$Data$Loading))
						}),
					A3(
						$author$project$Api$Provider$PracticeInvoice$delete,
						model.Gv,
						$author$project$Api$Provider$PracticeInvoice$One$id(practiceInvoice),
						$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Deleted),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{i9: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 11:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{i9: $elm$core$Maybe$Nothing}),
						A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Billing),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Invoice removed')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 12:
				var practiceInvoice = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{k9: $author$project$Api$Data$Loading}),
					A7(
						$author$project$Api$Payment$create,
						$author$project$Api$Data$providerPath,
						model.Gv,
						model.aa4,
						'practice_invoice_id',
						$author$project$Api$Provider$PracticeInvoice$One$id(practiceInvoice),
						{
							LE: $author$project$Currency$fromInt(
								$author$project$Api$Provider$PracticeInvoice$One$dueInCents(practiceInvoice)),
							aft: $elm$core$Maybe$Nothing,
							R5: false,
							aiG: $elm$core$Maybe$Nothing,
							YH: $elm$core$Maybe$Nothing,
							alj: $elm$core$Maybe$Nothing,
							alk: $elm$core$Maybe$Nothing,
							JQ: A2(
								$elm$core$Maybe$map,
								function (source) {
									return {
										ahP: $author$project$Api$Common$Source$Shared$id(source),
										amg: $author$project$Api$Common$Source$Shared$type_(source)
									};
								},
								$author$project$Api$Provider$PracticeInvoice$One$source(practiceInvoice)),
							alB: $elm$core$Maybe$Nothing
						},
						$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Paid),
					_List_Nil);
			case 13:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: $author$project$Api$Data$NotAsked}),
						A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Billing),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Invoice paid successfully!')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 14:
				var practiceInvoice = msg.a;
				var _v6 = $author$project$Components$Invoice$CreatePaymentModal$init(model.dd)(model.J7)($author$project$Api$Data$providerPath)(
					$elm$core$Maybe$Just($author$project$Api$Data$providerPath))(model.Gv)(model.aa4)(
					$author$project$Api$Practice$Provider(model.ZV))(model.Ij)(model.t9)(
					function (d) {
						return _Utils_update(
							d,
							{R5: true, alv: model.Ij});
					})(
					A2(
						$author$project$Components$Invoice$CreatePaymentModal$PracticeInvoice,
						$author$project$Api$Provider$Practice$One$id(model.ZV),
						practiceInvoice));
				var createPaymentModal = _v6.a;
				var createPaymentModalCmd = _v6.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							m$: $elm$core$Maybe$Just(createPaymentModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$CreatePaymentModalMsg, createPaymentModalCmd),
					_List_Nil);
			case 15:
				var subMsg = msg.a;
				var paymentsHistoryResult = A3($author$project$Components$Invoice$PaymentsHistory$update, model.Gv, subMsg, model.kC);
				var _v7 = function () {
					var _v8 = paymentsHistoryResult.agZ;
					switch (_v8) {
						case 0:
							return _Utils_Tuple2(model.tV, $elm$core$Platform$Cmd$none);
						case 1:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								A3($author$project$Api$Provider$PracticeInvoice$retrieve, model.Gv, model.ahP, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$GotPracticeInvoice));
						case 2:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								A3($author$project$Api$Provider$PracticeInvoice$retrieve, model.Gv, model.ahP, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$GotPracticeInvoice));
						case 3:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								A3($author$project$Api$Provider$PracticeInvoice$retrieve, model.Gv, model.ahP, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$GotPracticeInvoice));
						case 4:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								A3($author$project$Api$Provider$PracticeInvoice$retrieve, model.Gv, model.ahP, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$GotPracticeInvoice));
						default:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								A3($author$project$Api$Provider$PracticeInvoice$retrieve, model.Gv, model.ahP, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$GotPracticeInvoice));
					}
				}();
				var practiceInvoice = _v7.a;
				var cmd = _v7.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{kC: paymentsHistoryResult.aiO, tV: practiceInvoice}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$PaymentsHistoryMsg, paymentsHistoryResult.GZ),
								cmd
							])),
					paymentsHistoryResult.aR);
			case 16:
				var subMsg = msg.a;
				var _v9 = model.m$;
				if (!_v9.$) {
					var createPaymentModal = _v9.a;
					var createPaymentModalResult = A3($author$project$Components$Invoice$CreatePaymentModal$update, model.Gv, subMsg, createPaymentModal);
					var _v10 = function () {
						var _v11 = createPaymentModalResult.agZ;
						switch (_v11) {
							case 1:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(createPaymentModalResult.aiO),
									model.tV,
									$elm$core$Platform$Cmd$none);
							case 2:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Api$Data$Loading,
									A3($author$project$Api$Provider$PracticeInvoice$retrieve, model.Gv, model.ahP, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$GotPracticeInvoice));
							default:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.tV, $elm$core$Platform$Cmd$none);
						}
					}();
					var createPaymentModal_ = _v10.a;
					var practiceInvoice = _v10.b;
					var cmd = _v10.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{m$: createPaymentModal_, tV: practiceInvoice}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$CreatePaymentModalMsg, createPaymentModalResult.GZ),
									cmd
								])),
						createPaymentModalResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 17:
				var subMsg = msg.a;
				var downloadInvoiceResult = A3($author$project$Components$Invoice$DownloadFile$update, model.Gv, subMsg, model.jt);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{jt: downloadInvoiceResult.aiO}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$DownloadInvoiceMsg, downloadInvoiceResult.GZ),
					downloadInvoiceResult.aR);
			case 18:
				var practiceInvoice = msg.a;
				var _v12 = A2(
					$author$project$Components$HintBilling$CreateChargeModal$init,
					model.Gv,
					$elm$core$Maybe$Just(practiceInvoice));
				var createChargeModal = _v12.a;
				var createChargeModalCmd = _v12.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							iV: $elm$core$Maybe$Just(createChargeModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$CreateChargeModalMsg, createChargeModalCmd),
					_List_Nil);
			case 19:
				var subMsg = msg.a;
				var _v13 = model.iV;
				if (!_v13.$) {
					var createChargeModal = _v13.a;
					var result = A2($author$project$Components$HintBilling$CreateChargeModal$update, subMsg, createChargeModal);
					var _v14 = function () {
						var _v15 = result.agZ;
						switch (_v15.$) {
							case 1:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none, $author$project$Api$Data$NotAsked);
							case 2:
								var chargeParams = _v15.a;
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									A3($author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$adjustInvoiceAction, model.Gv, model.tV, chargeParams),
									$author$project$Api$Data$Loading);
							default:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(result.aiO),
									$elm$core$Platform$Cmd$none,
									$author$project$Api$Data$NotAsked);
						}
					}();
					var createChargeModal_ = _v14.a;
					var cmd = _v14.b;
					var saveRequest_ = _v14.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{iV: createChargeModal_, k9: saveRequest_}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$CreateChargeModalMsg, result.GZ),
									cmd
								])),
						result.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{tV: response, k9: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Invoice adjusted')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{tV: response, k9: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Invoice refunded')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Formatters$Time$Date__Friendly = 6;
var $author$project$Formatters$Time$Time__Friendly = 2;
var $author$project$Ui$Breadcrumb$Active = $elm$core$Basics$identity;
var $author$project$Ui$Breadcrumb$active = $elm$core$Basics$identity;
var $author$project$Api$Provider$Practice$One$address = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.K2;
	});
var $author$project$Api$Provider$PracticeInvoice$One$autoPayDate = function (_v0) {
	var record = _v0.b;
	return record.Mi;
};
var $author$project$Api$Provider$PracticeInvoice$One$autoPayEnabled = function (_v0) {
	var record = _v0.b;
	return record.Mj;
};
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$chargeModalTitle = function (practiceInvoiceData) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function (status) {
				return (!status) ? 'Add Credit & Refund' : 'Add Charge or Credit';
			},
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$PracticeInvoice$One$status,
				$author$project$Api$Data$toMaybe(practiceInvoiceData))));
};
var $author$project$Api$Provider$PracticeInvoice$One$charges = function (_v0) {
	var record = _v0.b;
	return record.NA;
};
var $author$project$Api$Provider$PracticeInvoice$One$date = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PracticeInvoice$Shared$invoiceDate(shared);
};
var $author$project$Components$HiConfirm$Detail = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$HiConfirm$detail = $author$project$Components$HiConfirm$Detail;
var $agustinrhcp$elm_mask$Mask$defaultConfig = {Gt: '*', Ht: '#'};
var $agustinrhcp$elm_mask$Mask$Pattern = $elm$core$Basics$identity;
var $agustinrhcp$elm_mask$Mask$Any = {$: 1};
var $agustinrhcp$elm_mask$Mask$Digit = {$: 2};
var $agustinrhcp$elm_mask$Mask$Symbol = function (a) {
	return {$: 0, a: a};
};
var $agustinrhcp$elm_mask$Mask$charToToken = F2(
	function (_v0, _char) {
		var digitChar = _v0.Ht;
		var anyChar = _v0.Gt;
		return _Utils_eq(_char, digitChar) ? $agustinrhcp$elm_mask$Mask$Digit : (_Utils_eq(_char, anyChar) ? $agustinrhcp$elm_mask$Mask$Any : $agustinrhcp$elm_mask$Mask$Symbol(_char));
	});
var $agustinrhcp$elm_mask$Mask$tokens = F2(
	function (conf, string) {
		return A2(
			$elm$core$List$map,
			$agustinrhcp$elm_mask$Mask$charToToken(conf),
			$elm$core$String$toList(string));
	});
var $agustinrhcp$elm_mask$Mask$fromStringWithConf = F2(
	function (conf, string) {
		return A2($agustinrhcp$elm_mask$Mask$tokens, conf, string);
	});
var $agustinrhcp$elm_mask$Mask$fromString = $agustinrhcp$elm_mask$Mask$fromStringWithConf($agustinrhcp$elm_mask$Mask$defaultConfig);
var $author$project$Formatters$Phone$phoneMask = '(###) ###-####';
var $author$project$Formatters$Phone$phonePattern = $agustinrhcp$elm_mask$Mask$fromString($author$project$Formatters$Phone$phoneMask);
var $author$project$Formatters$Phone$format = function (phoneNumber) {
	return A2($agustinrhcp$elm_mask$Mask$mask, $author$project$Formatters$Phone$phonePattern, phoneNumber);
};
var $author$project$Api$Provider$PracticeCharge$Shared$fromRecurringCharge = function (_v0) {
	var record = _v0;
	return record.SL;
};
var $author$project$Ui$Typography$HintLabel = {$: 15};
var $author$project$Ui$Typography$hintLabel = $author$project$Ui$Typography$HintLabel;
var $author$project$Ui$Breadcrumb$Item = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Ui$Breadcrumb$item = $author$project$Ui$Breadcrumb$Item;
var $author$project$Components$HiConfirm$Loading = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$HiConfirm$loading = $author$project$Components$HiConfirm$Loading;
var $author$project$Components$HiConfirm$defaultOptions = {xI: $elm$core$Maybe$Nothing, xW: true, y1: $elm$core$Maybe$Nothing, y2: $elm$core$Maybe$Nothing, zd: $elm$core$Maybe$Nothing, V8: false, BP: $elm$core$Maybe$Nothing, Ew: $elm$core$Maybe$Nothing, EA: true, FQ: true, aef: $elm$core$Maybe$Nothing};
var $author$project$Components$HiConfirm$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var string = option.a;
						return _Utils_update(
							record,
							{
								aef: $elm$core$Maybe$Just(string)
							});
					case 1:
						var string = option.a;
						return _Utils_update(
							record,
							{
								BP: $elm$core$Maybe$Just(string)
							});
					case 2:
						var string = option.a;
						return _Utils_update(
							record,
							{
								y1: $elm$core$Maybe$Just(string)
							});
					case 3:
						var bool = option.a;
						return _Utils_update(
							record,
							{FQ: bool});
					case 4:
						var bool = option.a;
						return _Utils_update(
							record,
							{xW: bool});
					case 5:
						var string = option.a;
						return _Utils_update(
							record,
							{
								zd: $elm$core$Maybe$Just(string)
							});
					case 6:
						var string = option.a;
						return _Utils_update(
							record,
							{
								Ew: $elm$core$Maybe$Just(string)
							});
					case 7:
						var bool = option.a;
						return _Utils_update(
							record,
							{V8: bool});
					case 8:
						var string = option.a;
						return _Utils_update(
							record,
							{
								y2: $elm$core$Maybe$Just(string)
							});
					case 9:
						var bool = option.a;
						return _Utils_update(
							record,
							{EA: bool});
					default:
						var buttonStyle_ = option.a;
						return _Utils_update(
							record,
							{
								xI: $elm$core$Maybe$Just(buttonStyle_)
							});
				}
			}),
		$author$project$Components$HiConfirm$defaultOptions,
		options);
};
var $author$project$Ui$Typography$Aligned = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Typography$aligned = $author$project$Ui$Typography$Aligned;
var $author$project$Components$HiConfirm$viewMessage = F4(
	function (maybeVerb, maybeProcessedNoun, maybeDetail, maybeSentence) {
		var _v0 = _Utils_Tuple2(maybeVerb, maybeProcessedNoun);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var verb_ = _v0.a.a;
			var processedNoun = _v0.b.a;
			var _v1 = _Utils_Tuple2(maybeDetail, maybeSentence);
			if (!_v1.a.$) {
				if (_v1.b.$ === 1) {
					var detail_ = _v1.a.a;
					var _v4 = _v1.b;
					return $elm$core$Maybe$Just('You\'re about to ' + (verb_ + (' ' + (processedNoun + ('  ' + (detail_ + '.'))))));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			} else {
				if (_v1.b.$ === 1) {
					var _v2 = _v1.a;
					var _v3 = _v1.b;
					return $elm$core$Maybe$Just('You\'re about to ' + (verb_ + (' this ' + (processedNoun + '.'))));
				} else {
					var _v5 = _v1.a;
					var sentence_ = _v1.b.a;
					return $elm$core$Maybe$Just('You\'re about to ' + (verb_ + (' ' + (processedNoun + ('. ' + sentence_)))));
				}
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$HiConfirm$viewBody = F2(
	function (processedNoun, options) {
		var alignment = options.xW ? _List_fromArray(
			[
				$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
			]) : _List_Nil;
		return A2(
			$elm$html$Html$div,
			$author$project$Api$Phi$displayAttr,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$p,
					alignment,
					function () {
						var _v0 = options.y1;
						if (!_v0.$) {
							var customMessage_ = _v0.a;
							return A2(
								$elm$core$List$map,
								$elm$html$Html$map($elm$core$Basics$never),
								customMessage_);
						} else {
							return $elm$core$List$concat(
								_List_fromArray(
									[
										function () {
										var _v1 = A4($author$project$Components$HiConfirm$viewMessage, options.aef, processedNoun, options.zd, options.Ew);
										if (!_v1.$) {
											var message = _v1.a;
											return _List_fromArray(
												[
													$elm$html$Html$text(message),
													$author$project$Utils$Html$noBreakSpace
												]);
										} else {
											return _List_Nil;
										}
									}(),
										_List_fromArray(
										[
											$elm$html$Html$text('This action cannot be undone.')
										])
									]));
						}
					}())
				]));
	});
var $author$project$Ui$Button$Success = 3;
var $author$project$Ui$Button$Warning = 4;
var $author$project$Components$HiConfirm$calculatebuttonStyle = function (maybeVerb) {
	if (maybeVerb.$ === 1) {
		return 1;
	} else {
		var verb_ = maybeVerb.a;
		switch (verb_) {
			case 'remove':
				return 6;
			case 'deactivate':
				return 6;
			case 'delete':
				return 6;
			case 'disable':
				return 6;
			case 'destroy':
				return 6;
			case 'void':
				return 6;
			case 'mark':
				return 6;
			case 'unlock':
				return 4;
			case 'unenroll':
				return 6;
			case 'approve':
				return 3;
			case 'merge':
				return 6;
			case 'enroll':
				return 4;
			case 'end':
				return 6;
			case 'clear':
				return 6;
			case 'archive':
				return 6;
			case 'cancel':
				return 6;
			default:
				return 1;
		}
	}
};
var $author$project$Ui$Button$FullWidth = function (a) {
	return {$: 7, a: a};
};
var $author$project$Ui$Button$fullWidth = $author$project$Ui$Button$FullWidth;
var $author$project$Ui$Grid$Empty = {$: 0};
var $author$project$Ui$Grid$none = $author$project$Ui$Grid$Empty;
var $author$project$Components$HiConfirm$viewFooter = F6(
	function (maybeVerb, processedNoun, loading_, showCancelButton, buttonStyle_, onClose) {
		var verb_ = A2($elm$core$Maybe$withDefault, 'confirm', maybeVerb);
		var confirmButtonColOptions = showCancelButton ? _List_fromArray(
			[
				$author$project$Ui$Grid$span(6)
			]) : _List_fromArray(
			[
				$author$project$Ui$Grid$span(6),
				$author$project$Ui$Grid$offset(3)
			]);
		return A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					showCancelButton ? A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$span(6)
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Cancel action'},
							_List_fromArray(
								[
									$author$project$Ui$Button$fullWidth(true),
									$author$project$Ui$Button$onClick(
									onClose(false))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								]))
						])) : $author$project$Ui$Grid$none,
					A2(
					$author$project$Ui$Grid$column,
					confirmButtonColOptions,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{
								mm: $author$project$Formatters$String$titleize(verb_) + (' ' + A2($elm$core$Maybe$withDefault, '', processedNoun))
							},
							_List_fromArray(
								[
									$author$project$Ui$Button$fullWidth(true),
									$author$project$Ui$Button$styled(
									A2(
										$elm$core$Maybe$withDefault,
										$author$project$Components$HiConfirm$calculatebuttonStyle(maybeVerb),
										buttonStyle_)),
									$author$project$Ui$Button$loading(loading_),
									$author$project$Ui$Button$onClick(
									onClose(true))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Formatters$String$titleize(verb_) + (' ' + A2($elm$core$Maybe$withDefault, '', processedNoun)))
								]))
						]))
				]));
	});
var $author$project$Components$HiConfirm$viewHeader = F3(
	function (maybeCustomTitle, mayberVerb, maybeProcessedNoun) {
		var header = function () {
			if (!maybeCustomTitle.$) {
				var title = maybeCustomTitle.a;
				return title;
			} else {
				var _v1 = _Utils_Tuple2(mayberVerb, maybeProcessedNoun);
				if (!_v1.a.$) {
					if (_v1.b.$ === 1) {
						var verb_ = _v1.a.a;
						var _v2 = _v1.b;
						return $author$project$Formatters$String$titleize(verb_);
					} else {
						var verb_ = _v1.a.a;
						var processedNoun = _v1.b.a;
						return $author$project$Formatters$String$titleize(verb_) + (' ' + processedNoun);
					}
				} else {
					return 'Please Confirm';
				}
			}
		}();
		return $author$project$Ui$Typography$headingSm(
			_List_fromArray(
				[
					$elm$html$Html$text(header)
				]));
	});
var $author$project$Components$HiConfirm$modal = F2(
	function (onClose, options) {
		var optionsRecord = $author$project$Components$HiConfirm$optionsToRecord(options);
		var processedNoun = function () {
			var _v0 = _Utils_Tuple2(optionsRecord.FQ, optionsRecord.BP);
			_v0$2:
			while (true) {
				if (_v0.a) {
					if (!_v0.b.$) {
						var noun_ = _v0.b.a;
						return $elm$core$Maybe$Just(
							$author$project$Formatters$String$titleize(noun_));
					} else {
						break _v0$2;
					}
				} else {
					if (!_v0.b.$) {
						var noun_ = _v0.b.a;
						return $elm$core$Maybe$Just(noun_);
					} else {
						break _v0$2;
					}
				}
			}
			return $elm$core$Maybe$Nothing;
		}();
		return A3(
			$author$project$Ui$Modal$view,
			onClose(false),
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							A3($author$project$Components$HiConfirm$viewHeader, optionsRecord.y2, optionsRecord.aef, processedNoun)
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2($author$project$Components$HiConfirm$viewBody, processedNoun, optionsRecord)
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A6($author$project$Components$HiConfirm$viewFooter, optionsRecord.aef, processedNoun, optionsRecord.V8, optionsRecord.EA, optionsRecord.xI, onClose)
						]))
				]));
	});
var $author$project$Components$HiConfirm$Noun = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$HiConfirm$noun = $author$project$Components$HiConfirm$Noun;
var $author$project$Components$HiConfirm$Verb = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$HiConfirm$verb = $author$project$Components$HiConfirm$Verb;
var $author$project$Components$Invoice$RefundModal$AmountInCents = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Invoice$RefundModal$FormUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Invoice$RefundModal$Memo = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Invoice$RefundModal$Save = {$: 2};
var $author$project$Api$Provider$Payment$Shared$paidAt = function (_v0) {
	var record = _v0;
	return record.YH;
};
var $author$project$Api$Provider$Payment$One$paidAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$paidAt(shared);
};
var $author$project$Api$Provider$Payment$SharedWithRefunds$paidAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$paidAt(shared);
};
var $author$project$Api$Payment$paidAt = function (payment) {
	switch (payment.$) {
		case 1:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$One$paidAt(payment_);
		case 0:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$SharedWithRefunds$paidAt(payment_);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Employer$Payment$Shared$paymentProcessor = function (_v0) {
	var record = _v0;
	return record.Zd;
};
var $author$project$Api$Employer$Payment$One$paymentProcessor = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Payment$Shared$paymentProcessor(shared);
};
var $author$project$Api$Provider$Payment$Shared$paymentProcessor = function (_v0) {
	var record = _v0;
	return record.Zd;
};
var $author$project$Api$Provider$Payment$One$paymentProcessor = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$paymentProcessor(shared);
};
var $author$project$Api$Provider$Payment$SharedWithRefunds$paymentProcessor = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$paymentProcessor(shared);
};
var $author$project$Api$Payment$paymentProcessor = function (payment) {
	switch (payment.$) {
		case 1:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$One$paymentProcessor(payment_);
		case 0:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$SharedWithRefunds$paymentProcessor(payment_);
		default:
			var payment_ = payment.a;
			return $author$project$Api$Employer$Payment$One$paymentProcessor(payment_);
	}
};
var $author$project$Components$PaymentSourceDisplayer$PaymentProcessor = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$PaymentSourceDisplayer$paymentProcessor = $author$project$Components$PaymentSourceDisplayer$PaymentProcessor;
var $author$project$Api$Employer$Payment$Shared$source = function (_v0) {
	var record = _v0;
	return record.JQ;
};
var $author$project$Api$Employer$Payment$One$source = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Payment$Shared$source(shared);
};
var $author$project$Api$Provider$Payment$Shared$source = function (_v0) {
	var record = _v0;
	return record.JQ;
};
var $author$project$Api$Provider$Payment$One$source = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$source(shared);
};
var $author$project$Api$Provider$Payment$SharedWithRefunds$source = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$source(shared);
};
var $author$project$Api$Payment$source = function (payment) {
	switch (payment.$) {
		case 1:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$One$source(payment_);
		case 0:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$SharedWithRefunds$source(payment_);
		default:
			var payment_ = payment.a;
			return $author$project$Api$Employer$Payment$One$source(payment_);
	}
};
var $author$project$Components$Invoice$RefundModal$viewExternalRefundAlert = function (oldPaymentProcessorPayment) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_Nil,
		_List_fromArray(
			[
				oldPaymentProcessorPayment ? A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(10)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Alert$warning,
										_List_Nil,
										_List_fromArray(
											[
												A2($author$project$Ui$Typography$text, _List_Nil, 'This refund can no longer be processed in this platform and must be processed externally. By continuing, you acknowledge that you are responsible for refunding the sponsor outside of this platform.')
											]))
									]))
							]))
					])) : $author$project$Utils$Html$empty
			]));
};
var $author$project$Components$Invoice$RefundModal$view = function (_v0) {
	var model = _v0;
	var source_ = $author$project$Api$Payment$source(model.Y9);
	var fields = $author$project$Utils$Form$fields(model.SD);
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Invoice$RefundModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title(
						model.sl ? 'Record Refund' : 'Process Refund')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$onSubmit($author$project$Components$Invoice$RefundModal$Save)
							]),
						_List_fromArray(
							[
								$author$project$Components$Invoice$RefundModal$viewExternalRefundAlert(model.IQ),
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Payment'),
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(8)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Static$view,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2(
													$elm$core$Maybe$withDefault,
													'N/A',
													A2(
														$elm$core$Maybe$map,
														model.J7(5),
														$author$project$Api$Payment$paidAt(model.Y9)))),
												$author$project$Api$Payment$external(model.Y9) ? $elm$html$Html$text(' with ') : $elm$html$Html$text(' on '),
												A2(
												$author$project$Components$PaymentSourceDisplayer$view,
												model.J7,
												_List_fromArray(
													[
														$author$project$Components$PaymentSourceDisplayer$source(
														A2($elm$core$Maybe$map, $author$project$Api$Source$Source, source_)),
														$author$project$Components$PaymentSourceDisplayer$limitedView(true),
														$author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus(true),
														$author$project$Components$PaymentSourceDisplayer$paymentProcessor(
														$author$project$Api$Payment$paymentProcessor(model.Y9))
													]))
											]))
									])),
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label(
										model.xi ? 'Available' : 'Refund'),
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(8)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Static$view,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$text,
												_List_Nil,
												$author$project$Utils$Currency$fromInt(fields.o$))
											]))
									])),
								model.xi ? A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Refund'),
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(8)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$CurrencyInput$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$CurrencyInput$value(fields.LE),
												$author$project$Ui$Form$CurrencyInput$onInput(
												A2($elm$core$Basics$composeL, $author$project$Components$Invoice$RefundModal$FormUpdated, $author$project$Components$Invoice$RefundModal$AmountInCents)),
												$author$project$Ui$Form$CurrencyInput$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, 0, model.SD)),
												$author$project$Ui$Form$CurrencyInput$errors(
												A2($author$project$Utils$Form$validationErrors, 0, model.SD))
											]))
									])) : $author$project$Utils$Html$empty,
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Memo'),
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(8)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$value(
												A2($elm$core$Maybe$withDefault, '', fields.aiG)),
												$author$project$Ui$Form$Input$placeholder('Additional notes about this refund'),
												$author$project$Ui$Form$Input$onInput(
												A2($elm$core$Basics$composeL, $author$project$Components$Invoice$RefundModal$FormUpdated, $author$project$Components$Invoice$RefundModal$Memo))
											]))
									]))
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Invoice$RefundModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						function () {
						var label = A2(
							$elm$core$String$join,
							' ',
							_List_fromArray(
								[
									model.sl ? 'Record' : 'Process',
									$author$project$Currency$format(
									A2($elm$core$Maybe$withDefault, $author$project$Currency$zero, fields.LE)),
									'Refund'
								]));
						return A3(
							$author$project$Ui$Button$view,
							{mm: label},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$loading(
									_Utils_eq(model.k9, $author$project$Api$Data$Loading)),
									$author$project$Ui$Button$onClick($author$project$Components$Invoice$RefundModal$Save)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(label)
								]));
					}()
					]))
			]));
};
var $author$project$WebComponents$Rainforest$ChargebackRespond$view = F2(
	function (onClose, data) {
		return A3(
			$elm$html$Html$node,
			'rainforest-chargeback-respond',
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'session-key', data.alo),
					A2($elm$html$Html$Attributes$attribute, 'chargeback-id', data.afF),
					A2($elm$html$Html$Attributes$attribute, 'show-respond-button', 'true'),
					A2($elm$html$Html$Attributes$attribute, 'hide-metadata', 'true'),
					A2($elm$html$Html$Attributes$attribute, 'hide-related-info', 'true'),
					A2($elm$html$Html$Attributes$attribute, 'style-button-color', 'var(--color-primary-300)'),
					A2($elm$html$Html$Attributes$attribute, 'style-button-border-radius', '9999px'),
					A2($elm$html$Html$Attributes$attribute, 'style-font-family', 'sans-serif'),
					A2(
					$elm$html$Html$Events$on,
					'close-button-clicked',
					$elm$json$Json$Decode$succeed(onClose))
				]),
			_List_Nil);
	});
var $author$project$Components$DisputeModal$view = F2(
	function (onClose, model) {
		return A3(
			$author$project$Ui$Modal$view,
			onClose,
			_List_Nil,
			_Utils_ap(
				function () {
					var _v0 = model.QL;
					if (_v0.$ === 2) {
						return _List_Nil;
					} else {
						return _List_fromArray(
							[
								$author$project$Ui$Modal$header(_List_Nil)
							]);
					}
				}(),
				_List_fromArray(
					[
						$author$project$Ui$Modal$body(
						_List_fromArray(
							[
								function () {
								var _v1 = model.QL;
								switch (_v1.$) {
									case 0:
										return $elm$html$Html$text('Loading...');
									case 1:
										return $elm$html$Html$text('There was an error loading the dispute');
									default:
										if (!_v1.a.$) {
											var session = _v1.a.a;
											return A2($author$project$WebComponents$Rainforest$ChargebackRespond$view, onClose, session);
										} else {
											var session = _v1.a.a;
											return A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$id('stripe-payment-disputes-' + session.afz)
													]),
												_List_Nil);
										}
								}
							}()
							]))
					])));
	});
var $author$project$Components$PaymentDisputeModal$viewModal = F2(
	function (onClose, text) {
		return A3(
			$author$project$Ui$Modal$view,
			onClose,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(_List_Nil),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							$elm$html$Html$text(text)
						]))
				]));
	});
var $author$project$Components$PaymentDisputeModal$view = F2(
	function (onClose, model) {
		var _v0 = model.QL;
		switch (_v0.$) {
			case 2:
				return A2($author$project$Components$PaymentDisputeModal$viewModal, onClose, 'Loading...');
			case 0:
				var disputeModal = _v0.a;
				return A2($author$project$Components$DisputeModal$view, onClose, disputeModal);
			case 3:
				return A2($author$project$Components$PaymentDisputeModal$viewModal, onClose, 'There was an error loading the dispute');
			default:
				return A2($author$project$Components$PaymentDisputeModal$viewModal, onClose, 'There was an error loading the dispute');
		}
	});
var $author$project$Components$Rainforest$SessionModal$resourceDescription = function (resource) {
	switch (resource.$) {
		case 0:
			return 'deposit';
		case 1:
			return 'payment';
		default:
			return 'refund';
	}
};
var $author$project$WebComponents$Rainforest$DepositDetails$view = function (data) {
	return A3(
		$elm$html$Html$node,
		'rainforest-deposit-details',
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'session-key', data.alo),
				A2($elm$html$Html$Attributes$attribute, 'deposit-id', data.agt),
				A2($elm$html$Html$Attributes$attribute, 'show-payin-signature', ''),
				A2($elm$html$Html$Attributes$attribute, 'hide-actions', ''),
				A2($elm$html$Html$Attributes$attribute, 'style-button-color', 'var(--color-primary-300)'),
				A2($elm$html$Html$Attributes$attribute, 'style-button-border-radius', '9999px'),
				A2($elm$html$Html$Attributes$attribute, 'style-font-family', 'Avenir')
			]),
		_List_Nil);
};
var $author$project$WebComponents$Rainforest$PayinDetails$view = function (data) {
	return A3(
		$elm$html$Html$node,
		'rainforest-payin-details',
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'session-key', data.alo),
				A2($elm$html$Html$Attributes$attribute, 'payin-id', data.Y7),
				A2($elm$html$Html$Attributes$attribute, 'show-signature', ''),
				A2($elm$html$Html$Attributes$attribute, 'hide-actions', ''),
				A2($elm$html$Html$Attributes$attribute, 'style-button-color', 'var(--color-primary-300)'),
				A2($elm$html$Html$Attributes$attribute, 'style-button-border-radius', '9999px'),
				A2($elm$html$Html$Attributes$attribute, 'style-font-family', 'Avenir')
			]),
		_List_Nil);
};
var $author$project$WebComponents$Rainforest$RefundDetails$view = function (data) {
	return A3(
		$elm$html$Html$node,
		'rainforest-refund-details',
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'session-key', data.alo),
				A2($elm$html$Html$Attributes$attribute, 'refund-id', data.akA),
				A2($elm$html$Html$Attributes$attribute, 'parent-payin-id', data.Y7),
				A2($elm$html$Html$Attributes$attribute, 'show-signature', ''),
				A2($elm$html$Html$Attributes$attribute, 'hide-actions', ''),
				A2($elm$html$Html$Attributes$attribute, 'style-button-color', 'var(--color-primary-300)'),
				A2($elm$html$Html$Attributes$attribute, 'style-button-border-radius', '9999px'),
				A2($elm$html$Html$Attributes$attribute, 'style-font-family', 'Avenir')
			]),
		_List_Nil);
};
var $author$project$Components$Rainforest$SessionModal$view = F2(
	function (onClose, model) {
		return A3(
			$author$project$Ui$Modal$view,
			onClose,
			_List_fromArray(
				[$author$project$Ui$Modal$lg]),
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(_List_Nil),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							function () {
							var _v0 = model.aa4;
							switch (_v0.$) {
								case 0:
									return $elm$html$Html$text('Loading...');
								case 1:
									return $elm$html$Html$text(
										'There was an error loading the ' + $author$project$Components$Rainforest$SessionModal$resourceDescription(model.Jy));
								default:
									var session = _v0.a;
									var _v1 = model.Jy;
									switch (_v1.$) {
										case 0:
											return $author$project$WebComponents$Rainforest$DepositDetails$view(
												{agt: session.akn, alo: session.akp});
										case 1:
											return $author$project$WebComponents$Rainforest$PayinDetails$view(
												{Y7: session.akn, alo: session.akp});
										default:
											return $author$project$WebComponents$Rainforest$RefundDetails$view(
												{
													Y7: A2($elm$core$Maybe$withDefault, '', session.akm),
													akA: session.akn,
													alo: session.akp
												});
									}
							}
						}()
						]))
				]));
	});
var $author$project$Components$Rainforest$SimulateDisputeEventModal$SimulateDisputeEvent = {$: 2};
var $author$project$Components$Rainforest$SimulateDisputeEventModal$StatusSelected = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Rainforest$SimulateDisputeEventModal$statusOptions = A2(
	$elm$core$List$map,
	function (status) {
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(status),
			status);
	},
	$author$project$Components$Rainforest$SimulateDisputeEventModal$statuses);
var $author$project$Components$Rainforest$SimulateDisputeEventModal$view = function (_v0) {
	var model = _v0;
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Rainforest$SimulateDisputeEventModal$CloseModal,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Simulate Dispute Event')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$muted]),
						_List_fromArray(
							[
								$elm$html$Html$text('Simulate a dispute event for testing purposes.')
							])),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Status'),
								$author$project$Ui$Form$Group$labelSpan(4),
								$author$project$Ui$Form$Group$inputSpan(8)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Select$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Select$value(
										$elm$core$Maybe$Just(model.alH)),
										$author$project$Ui$Form$Select$onChange($author$project$Components$Rainforest$SimulateDisputeEventModal$StatusSelected)
									]),
								$author$project$Components$Rainforest$SimulateDisputeEventModal$statusOptions)
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Cancel'},
						_List_fromArray(
							[
								$author$project$Ui$Button$secondary,
								$author$project$Ui$Button$onClick($author$project$Components$Rainforest$SimulateDisputeEventModal$CloseModal)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Simulate Dispute Event'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$onClick($author$project$Components$Rainforest$SimulateDisputeEventModal$SimulateDisputeEvent),
								$author$project$Ui$Button$loading(
								_Utils_eq(model.qf, $author$project$Api$Data$Loading))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Simulate Dispute Event')
							]))
					]))
			]));
};
var $author$project$Components$Rainforest$SimulateDisputeModal$SimulateDispute = {$: 2};
var $author$project$Components$Rainforest$SimulateDisputeModal$StatusSelected = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Rainforest$SimulateDisputeModal$statusOptions = A2(
	$elm$core$List$map,
	function (status) {
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(status),
			status);
	},
	$author$project$Components$Rainforest$SimulateDisputeModal$statuses);
var $author$project$Components$Rainforest$SimulateDisputeModal$view = function (_v0) {
	var model = _v0;
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Rainforest$SimulateDisputeModal$CloseModal,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Simulate Dispute')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$muted]),
						_List_fromArray(
							[
								$elm$html$Html$text('Simulate a dispute for testing purposes. This will mark the payment as disputed.')
							])),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Status'),
								$author$project$Ui$Form$Group$labelSpan(4),
								$author$project$Ui$Form$Group$inputSpan(8)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Select$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Select$value(
										$elm$core$Maybe$Just(model.alH)),
										$author$project$Ui$Form$Select$onChange($author$project$Components$Rainforest$SimulateDisputeModal$StatusSelected)
									]),
								$author$project$Components$Rainforest$SimulateDisputeModal$statusOptions)
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Cancel'},
						_List_fromArray(
							[
								$author$project$Ui$Button$secondary,
								$author$project$Ui$Button$onClick($author$project$Components$Rainforest$SimulateDisputeModal$CloseModal)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Simulate Dispute'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$onClick($author$project$Components$Rainforest$SimulateDisputeModal$SimulateDispute),
								$author$project$Ui$Button$loading(
								_Utils_eq(model.qg, $author$project$Api$Data$Loading))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Simulate Dispute')
							]))
					]))
			]));
};
var $author$project$Components$PaymentsList$modal = function (_v0) {
	var refundModal = _v0.kS;
	var paymentDisputeModal = _v0.ha;
	var rainforestPaymentModal = _v0.e_;
	var simulateDisputeModal = _v0.lt;
	var simulateDisputeEventModal = _v0.ls;
	var cancelingPayment = _v0.c4;
	var cancellingRefund = _v0.iC;
	var deletingPayment = _v0.ej;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Invoice$RefundModal$view,
						$elm$html$Html$map($author$project$Components$PaymentsList$RefundModalMsg)),
					refundModal)),
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					$author$project$Components$PaymentDisputeModal$view($author$project$Components$PaymentsList$ClosePaymentDisputeModal),
					paymentDisputeModal)),
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					$author$project$Components$Rainforest$SessionModal$view($author$project$Components$PaymentsList$CloseRainforestPaymentModal),
					rainforestPaymentModal)),
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Rainforest$SimulateDisputeModal$view,
						$elm$html$Html$map($author$project$Components$PaymentsList$SimulateDisputeModalMsg)),
					simulateDisputeModal)),
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Rainforest$SimulateDisputeEventModal$view,
						$elm$html$Html$map($author$project$Components$PaymentsList$SimulateDisputeEventModalMsg)),
					simulateDisputeEventModal)),
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					function (_v1) {
						var payment = _v1.a;
						var cancelRequest = _v1.b;
						return A2(
							$author$project$Components$HiConfirm$modal,
							$author$project$Components$PaymentsList$CancelPaymentHiConfirmClosed(payment),
							_List_fromArray(
								[
									$author$project$Components$HiConfirm$verb('cancel'),
									$author$project$Components$HiConfirm$noun('payment'),
									$author$project$Components$HiConfirm$loading(
									_Utils_eq(cancelRequest, $author$project$Api$Data$Loading))
								]));
					},
					cancelingPayment)),
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					function (_v2) {
						return A2(
							$author$project$Components$HiConfirm$modal,
							$author$project$Components$PaymentsList$CancelRefundConfirmed,
							_List_fromArray(
								[
									$author$project$Components$HiConfirm$verb('cancel'),
									$author$project$Components$HiConfirm$noun('refund')
								]));
					},
					cancellingRefund)),
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					function (_v3) {
						var payment = _v3.a;
						var deleteRequest = _v3.b;
						return A2(
							$author$project$Components$HiConfirm$modal,
							$author$project$Components$PaymentsList$DeleteExternalPaymentHiConfirmClosed(payment),
							_List_fromArray(
								[
									$author$project$Components$HiConfirm$verb('delete'),
									$author$project$Components$HiConfirm$noun('payment'),
									$author$project$Components$HiConfirm$loading(
									_Utils_eq(deleteRequest, $author$project$Api$Data$Loading))
								]));
					},
					deletingPayment))
			]));
};
var $author$project$Components$Invoice$PaymentsHistory$modal = function (model) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Invoice$PaymentsHistory$PaymentsListMsg,
		$author$project$Components$PaymentsList$modal(model.kD));
};
var $author$project$Api$Common$Phone$Shared$number = function (_v0) {
	var record = _v0;
	return record.IO;
};
var $author$project$Api$Provider$PracticeInvoice$One$number = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PracticeInvoice$Shared$invoiceNumber(shared);
};
var $author$project$Api$Provider$PracticeInvoice$One$paidAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PracticeInvoice$Shared$paidAt(shared);
};
var $elm$core$List$partition = F2(
	function (pred, list) {
		var step = F2(
			function (x, _v0) {
				var trues = _v0.a;
				var falses = _v0.b;
				return pred(x) ? _Utils_Tuple2(
					A2($elm$core$List$cons, x, trues),
					falses) : _Utils_Tuple2(
					trues,
					A2($elm$core$List$cons, x, falses));
			});
		return A3(
			$elm$core$List$foldr,
			step,
			_Utils_Tuple2(_List_Nil, _List_Nil),
			list);
	});
var $author$project$Api$Provider$PracticeInvoice$One$payments = function (_v0) {
	var record = _v0.b;
	return record.Zi;
};
var $author$project$Ui$Element$Phi = {$: 23};
var $author$project$Ui$Element$phi = $author$project$Ui$Element$Phi;
var $author$project$Api$Provider$Practice$One$phones = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Zy;
	});
var $author$project$Api$Provider$PracticeInvoice$One$purchaseOrderNumber = function (_v0) {
	var record = _v0.b;
	return record._K;
};
var $author$project$Formatters$Bool$toString = function (bool) {
	return bool ? 'Yes' : 'No';
};
var $author$project$Api$Provider$PracticeInvoice$One$totalInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PracticeInvoice$Shared$totalInCents(shared);
};
var $author$project$Api$Common$Address$Shared$city = function (_v0) {
	var record = _v0;
	return record.rE;
};
var $author$project$Api$Common$Address$Shared$line1 = function (_v0) {
	var record = _v0;
	return record.s$;
};
var $author$project$Api$Common$Address$Shared$line2 = function (_v0) {
	var record = _v0;
	return record.AD;
};
var $author$project$Api$Common$Address$Shared$state = function (_v0) {
	var record = _v0;
	return record.uP;
};
var $author$project$Components$AddressDisplay$viewField = F3(
	function (breakLike, getter, address) {
		var _v0 = getter(address);
		if (!_v0.$) {
			if (_v0.a === '') {
				return $author$project$Utils$Html$empty;
			} else {
				var string = _v0.a;
				return A2(
					$author$project$Ui$Element$prose,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(string),
							breakLike ? A2($elm$html$Html$br, _List_Nil, _List_Nil) : $author$project$Utils$Html$empty
						]));
			}
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Api$Common$Address$Shared$zip = function (_v0) {
	var record = _v0;
	return record.vv;
};
var $author$project$Components$AddressDisplay$view = function (address) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				A3($author$project$Components$AddressDisplay$viewField, true, $author$project$Api$Common$Address$Shared$line1, address),
				A3($author$project$Components$AddressDisplay$viewField, true, $author$project$Api$Common$Address$Shared$line2, address),
				function () {
				var _v0 = A2(
					$elm$core$Maybe$map,
					$elm$core$String$trim,
					$author$project$Api$Common$Address$Shared$city(address));
				if (!_v0.$) {
					if (_v0.a === '') {
						return $author$project$Utils$Html$empty;
					} else {
						var city = _v0.a;
						return A2(
							$author$project$Ui$Element$prose,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(city),
									$elm$html$Html$text(', '),
									A3($author$project$Components$AddressDisplay$viewField, false, $author$project$Api$Common$Address$Shared$state, address),
									$author$project$Utils$Html$noBreakSpace,
									A3($author$project$Components$AddressDisplay$viewField, false, $author$project$Api$Common$Address$Shared$zip, address)
								]));
					}
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]));
};
var $author$project$Components$CardReader$SimulateForm$Card = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$CardReader$SimulateForm$Event = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$CardReader$SimulateForm$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$CardReader$SimulateForm$Simulate = {$: 1};
var $author$project$Components$CardReader$SimulateForm$cards = _List_fromArray(
	['VISA_SUCCESS', 'VISA_42_SUCCESS', 'VISA_DEBIT_SUCCESS', 'MC_SUCCESS', 'MC_2_SUCCESS', 'MC_DEBIT_SUCCESS', 'MC_PREPAID_SUCCESS', 'AMEX_SUCCESS', 'AMEX_2_SUCCESS', 'DISCOVER_SUCCESS', 'DISCOVER_2_SUCCESS', 'DISCOVER_DEBIT_SUCCESS', 'DINERS_SUCCESS', 'DINERS_14_SUCCESS']);
var $author$project$Components$CardReader$SimulateForm$cardOptions = A2(
	$elm$core$List$cons,
	A3(
		$author$project$Ui$Form$Select$option,
		_List_Nil,
		$elm$core$Maybe$Just(''),
		'Choose a card...'),
	A2(
		$elm$core$List$map,
		function (card) {
			return A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(card),
				card);
		},
		$author$project$Components$CardReader$SimulateForm$cards));
var $author$project$Ui$Form$Select$Errors = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Form$Select$errors = $author$project$Ui$Form$Select$Errors;
var $author$project$Components$CardReader$SimulateForm$events = _List_fromArray(
	['PRESENTED', 'CANCEL']);
var $author$project$Components$CardReader$SimulateForm$eventOptions = A2(
	$elm$core$List$cons,
	A3(
		$author$project$Ui$Form$Select$option,
		_List_Nil,
		$elm$core$Maybe$Just(''),
		'Choose an event...'),
	A2(
		$elm$core$List$map,
		function (event) {
			return A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(event),
				event);
		},
		$author$project$Components$CardReader$SimulateForm$events));
var $author$project$Ui$Form$Group$Icon = function (a) {
	return {$: 10, a: a};
};
var $author$project$Ui$Form$Group$icon = $author$project$Ui$Form$Group$Icon;
var $author$project$Ui$Icon$SpacedRight = {$: 4};
var $author$project$Ui$Icon$spacedRight = $author$project$Ui$Icon$SpacedRight;
var $author$project$Ui$HinterOnly$formGroup = F2(
	function (options, content) {
		return A2(
			$author$project$Ui$Form$Group$view,
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Form$Group$icon(
					$author$project$Ui$HinterOnly$icon(
						_List_fromArray(
							[$author$project$Ui$Icon$spacedRight]))),
				options),
			content);
	});
var $author$project$Components$CardReader$SimulateForm$view = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.SD);
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$HinterOnly$formGroup,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(6),
						$author$project$Ui$Form$Group$label('Event')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Select$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Select$value(fields.agZ),
								$author$project$Ui$Form$Select$onChange(
								A2($elm$core$Basics$composeL, $author$project$Components$CardReader$SimulateForm$FormUpdated, $author$project$Components$CardReader$SimulateForm$Event)),
								$author$project$Ui$Form$Select$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 0, model.SD)),
								$author$project$Ui$Form$Select$errors(
								A2($author$project$Utils$Form$validationErrors, 0, model.SD))
							]),
						$author$project$Components$CardReader$SimulateForm$eventOptions)
					])),
				A2(
				$author$project$Ui$HinterOnly$formGroup,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(6),
						$author$project$Ui$Form$Group$label('Card')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Select$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Select$value(fields.afs),
								$author$project$Ui$Form$Select$onChange(
								A2($elm$core$Basics$composeL, $author$project$Components$CardReader$SimulateForm$FormUpdated, $author$project$Components$CardReader$SimulateForm$Card)),
								$author$project$Ui$Form$Select$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 1, model.SD)),
								$author$project$Ui$Form$Select$errors(
								A2($author$project$Utils$Form$validationErrors, 1, model.SD))
							]),
						$author$project$Components$CardReader$SimulateForm$cardOptions)
					])),
				A3(
				$author$project$Ui$HinterOnly$button,
				{mm: 'Simulate'},
				_List_fromArray(
					[
						$author$project$Ui$Button$secondary,
						$author$project$Ui$Button$sm,
						$author$project$Ui$Button$onClick($author$project$Components$CardReader$SimulateForm$Simulate),
						$author$project$Ui$Button$loading(
						_Utils_eq(model.qg, $author$project$Api$Data$Loading))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Simulate')
					]))
			]));
};
var $author$project$Components$CardReader$ConnectingModal$view = function (_v0) {
	var model = _v0;
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$CardReader$ConnectingModal$Cancel,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Processing Card')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$textCenter]),
						_List_fromArray(
							[
								(!model.d1) ? $author$project$Ui$Spinner$view(_List_Nil) : $author$project$Utils$Html$empty,
								A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								function () {
									var _v1 = model.d1;
									if (!_v1) {
										return _List_fromArray(
											[
												$elm$html$Html$text('Connecting to your card reader...')
											]);
									} else {
										return _List_fromArray(
											[
												$elm$html$Html$text('Please insert or swipe your credit card into the card reader now.'),
												function () {
												var _v2 = model.uK;
												if (!_v2.$) {
													var simulateForm = _v2.a;
													return A2(
														$elm$html$Html$map,
														$author$project$Components$CardReader$ConnectingModal$SimulateFormMsg,
														$author$project$Components$CardReader$SimulateForm$view(simulateForm));
												} else {
													return $author$project$Utils$Html$empty;
												}
											}()
											]);
									}
								}())
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Cancel card reader connection'},
						_List_fromArray(
							[
								$author$project$Ui$Button$fullWidth(true),
								$author$project$Ui$Button$onClick($author$project$Components$CardReader$ConnectingModal$Cancel),
								$author$project$Ui$Button$disabled(model.c3)
							]),
						_List_fromArray(
							[
								model.c3 ? $elm$html$Html$text('Cancelling') : $elm$html$Html$text('Cancel')
							]))
					]))
			]));
};
var $author$project$Components$CardReader$PaymentModal$view = function (_v0) {
	var model = _v0;
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$CardReader$PaymentModal$Cancel,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Processing Card')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$textCenter]),
						_List_fromArray(
							[
								(!model.d1) ? $author$project$Ui$Spinner$view(_List_Nil) : $author$project$Utils$Html$empty,
								A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								function () {
									var _v1 = model.d1;
									if (!_v1) {
										return _List_fromArray(
											[
												$elm$html$Html$text('Connecting to your card reader...')
											]);
									} else {
										return _List_fromArray(
											[
												$elm$html$Html$text('Please insert or swipe your credit card into the card reader now.'),
												function () {
												var _v2 = model.uK;
												if (!_v2.$) {
													var simulateForm = _v2.a;
													return A2(
														$elm$html$Html$map,
														$author$project$Components$CardReader$PaymentModal$SimulateFormMsg,
														$author$project$Components$CardReader$SimulateForm$view(simulateForm));
												} else {
													return $author$project$Utils$Html$empty;
												}
											}()
											]);
									}
								}())
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$span(3),
										$author$project$Ui$Grid$offset(9)
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Cancel card reader connection'},
										_List_fromArray(
											[
												$author$project$Ui$Button$fullWidth(true),
												$author$project$Ui$Button$onClick($author$project$Components$CardReader$PaymentModal$Cancel),
												$author$project$Ui$Button$disabled(model.c3)
											]),
										_List_fromArray(
											[
												model.c3 ? $elm$html$Html$text('Cancelling') : $elm$html$Html$text('Cancel')
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Components$Invoice$CreatePaymentModal$passthroughFeesActive = F2(
	function (model, fields) {
		return (!_Utils_eq(model.Cd.YV, $elm$core$Maybe$Nothing)) && A2($author$project$Components$Invoice$CreatePaymentModal$sourceIsACreditCard, model.bP, fields);
	});
var $author$project$Api$Provider$PassthroughFee$Shared$totalInCents = function (_v0) {
	var internalRecord = _v0;
	return internalRecord.adp;
};
var $author$project$Api$Provider$PassthroughFee$One$totalInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PassthroughFee$Shared$totalInCents(shared);
};
var $author$project$Components$Invoice$CreatePaymentModal$passthroughFeesTotalAmount = function (passthroughFees) {
	return A2(
		$elm$core$Maybe$map,
		$author$project$Api$Provider$PassthroughFee$One$totalInCents,
		$author$project$Api$Data$toMaybe(passthroughFees));
};
var $author$project$Components$Invoice$CreatePaymentModal$CreatePayment = {$: 9};
var $author$project$Components$Invoice$CreatePaymentModal$viewCardPaymentWarningModal = function (fields) {
	return (fields.nF === 2) ? A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$text,
				_List_fromArray(
					[$author$project$Ui$Typography$warning]),
				'We will not collect this payment. This form is used to record a payment made in person, by mail, or using a different payment processor.')
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Components$Invoice$CreatePaymentModal$ExternalSource = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Invoice$CreatePaymentModal$FormUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$Radio$OnCheck = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$Radio$onCheck = $author$project$Ui$Form$Radio$OnCheck;
var $author$project$Ui$Form$Radio$Value = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$Radio$value = $author$project$Ui$Form$Radio$Value;
var $author$project$Ui$Form$Radio$inputOptionToAttributes = function (option) {
	switch (option.$) {
		case 0:
			var val = option.a;
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$checked(val)
				]);
		case 1:
			var toMsg = option.a;
			return _List_fromArray(
				[
					$elm$html$Html$Events$onCheck(toMsg)
				]);
		case 2:
			return _List_Nil;
		case 3:
			var disabled_ = option.a;
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$disabled(disabled_)
				]);
		case 4:
			return _List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, '-webkit-appearance', 'none'),
					A2($elm$html$Html$Attributes$style, 'appearance', 'none'),
					A2($elm$html$Html$Attributes$style, 'background-color', '#fff'),
					A2($elm$html$Html$Attributes$style, 'margin', '0')
				]);
		case 5:
			return _List_Nil;
		default:
			return _List_Nil;
	}
};
var $author$project$Ui$Form$Radio$isCard = function (options) {
	return A2(
		$elm$core$List$any,
		function (opt) {
			if (opt.$ === 6) {
				return true;
			} else {
				return false;
			}
		},
		options);
};
var $author$project$Ui$Form$Radio$labelOptionToAttributes = function (option) {
	switch (option.$) {
		case 0:
			return _List_Nil;
		case 1:
			return _List_Nil;
		case 2:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('radio-inline')
				]);
		case 3:
			var isDisabled = option.a;
			return isDisabled ? _List_fromArray(
				[
					$elm$html$Html$Attributes$class('opacity-50 cursor-not-allowed')
				]) : _List_Nil;
		case 4:
			return _List_Nil;
		case 5:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('pl-0')
				]);
		default:
			return _List_Nil;
	}
};
var $author$project$Ui$Form$Radio$view = F2(
	function (options, content) {
		return $author$project$Ui$Form$Radio$isCard(options) ? A2(
			$elm$html$Html$label,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('radio radio--card'),
				A2($elm$core$List$concatMap, $author$project$Ui$Form$Radio$labelOptionToAttributes, options)),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$type_('radio'),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class('shrink-0'),
							A2($elm$core$List$concatMap, $author$project$Ui$Form$Radio$inputOptionToAttributes, options))),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$elm$html$Html$map($elm$core$Basics$never),
						content))
				])) : A2(
			$elm$html$Html$label,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('radio-inline'),
				A2($elm$core$List$concatMap, $author$project$Ui$Form$Radio$labelOptionToAttributes, options)),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$type_('radio'),
						A2($elm$core$List$concatMap, $author$project$Ui$Form$Radio$inputOptionToAttributes, options)),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$elm$html$Html$map($elm$core$Basics$never),
						content))
				]));
	});
var $author$project$Components$Invoice$CreatePaymentModal$viewExternalSourceLabel = function (externalSource) {
	switch (externalSource) {
		case 0:
			return 'Check';
		case 1:
			return 'Cash';
		case 2:
			return 'External Card';
		case 3:
			return 'Electronic Funds Transfer';
		default:
			return 'Other';
	}
};
var $author$project$Components$Invoice$CreatePaymentModal$viewExternalSource = F2(
	function (currentExternalSource, externalSource) {
		return A2(
			$author$project$Ui$Form$Radio$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Radio$value(
					_Utils_eq(currentExternalSource, externalSource)),
					$author$project$Ui$Form$Radio$onCheck(
					A2(
						$elm$core$Basics$composeL,
						$author$project$Components$Invoice$CreatePaymentModal$FormUpdated,
						$elm$core$Basics$always(
							$author$project$Components$Invoice$CreatePaymentModal$ExternalSource(externalSource))))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$strong,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Components$Invoice$CreatePaymentModal$viewExternalSourceLabel(externalSource))
						]))
				]));
	});
var $author$project$Components$Invoice$CreatePaymentModal$Memo = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Invoice$CreatePaymentModal$viewMemoModal = function (fields) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Memo'),
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$value(
						A2($elm$core$Maybe$withDefault, '', fields.aiG)),
						$author$project$Ui$Form$Input$placeholder('Additional notes about this payment'),
						$author$project$Ui$Form$Input$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Invoice$CreatePaymentModal$FormUpdated, $author$project$Components$Invoice$CreatePaymentModal$Memo))
					]))
			]));
};
var $author$project$Components$Invoice$CreatePaymentModal$AmountInCents = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Invoice$CreatePaymentModal$AmountInCentsBlur = {$: 2};
var $author$project$Ui$Form$CurrencyInput$OnBlur = function (a) {
	return {$: 9, a: a};
};
var $author$project$Ui$Form$CurrencyInput$onBlur = $author$project$Ui$Form$CurrencyInput$OnBlur;
var $author$project$Components$Invoice$CreatePaymentModal$viewPayNowPanel = F2(
	function (fields, model) {
		var passthroughEnabled = !_Utils_eq(model.Cd.YV, $elm$core$Maybe$Nothing);
		var amountInputAttrs = $elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						$author$project$Ui$Form$CurrencyInput$value(fields.LE),
						$author$project$Ui$Form$CurrencyInput$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Invoice$CreatePaymentModal$FormUpdated, $author$project$Components$Invoice$CreatePaymentModal$AmountInCents)),
						$author$project$Ui$Form$CurrencyInput$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 0, model.SD))
					]),
					passthroughEnabled ? _List_fromArray(
					[
						$author$project$Ui$Form$CurrencyInput$onBlur($author$project$Components$Invoice$CreatePaymentModal$AmountInCentsBlur)
					]) : _List_Nil
				]));
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Payment'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(7)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$CurrencyInput$view(amountInputAttrs)
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(5)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									$elm$core$List$concat(
										_List_fromArray(
											[
												_List_fromArray(
												[
													$elm$html$Html$text(' of '),
													$elm$html$Html$text(
													$author$project$Utils$Currency$fromInt(fields.j$)),
													$elm$html$Html$text(' due')
												]),
												A2($author$project$Components$Invoice$CreatePaymentModal$passthroughFeesActive, model, fields) ? _List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$text,
													_List_fromArray(
														[$author$project$Ui$Typography$muted]),
													' (+ credit card fees)')
												]) : _List_Nil
											])))
								]))
						])),
					$author$project$Utils$FormErrors$view(
					A2($author$project$Utils$Form$validationErrors, 0, model.SD))
				]));
	});
var $author$project$Components$Invoice$CreatePaymentModal$viewExternalSourceModal = F3(
	function (model, fields, amountInCentsString) {
		return _List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Record External Payment')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$onSubmit($author$project$Components$Invoice$CreatePaymentModal$CreatePayment)
							]),
						_List_fromArray(
							[
								A2($author$project$Components$Invoice$CreatePaymentModal$viewPayNowPanel, fields, model),
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('On date'),
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(8)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Components$Invoice$CreatePaymentModal$PaidAtDateInputMsg(fields.tB),
										A2(
											$author$project$Components$DateInput$view,
											_List_fromArray(
												[
													$author$project$Components$DateInput$value(fields.YH)
												]),
											fields.tB))
									])),
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Paid By'),
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(8)
									]),
								A2(
									$elm$core$List$map,
									$author$project$Components$Invoice$CreatePaymentModal$viewExternalSource(fields.nF),
									model.Cd.HG)),
								$author$project$Utils$Html$empty,
								$author$project$Utils$Html$empty,
								$author$project$Components$Invoice$CreatePaymentModal$viewMemoModal(fields)
							])),
						$author$project$Components$Invoice$CreatePaymentModal$viewCardPaymentWarningModal(fields)
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Invoice$CreatePaymentModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Record payment'},
						_List_fromArray(
							[
								$author$project$Ui$Button$styled(1),
								$author$project$Ui$Button$loading(
								_Utils_eq(model.an, $author$project$Api$Data$Loading)),
								$author$project$Ui$Button$onClick($author$project$Components$Invoice$CreatePaymentModal$CreatePayment),
								$author$project$Ui$Button$icon($author$project$Ui$Icon$check)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Record '),
								$elm$html$Html$text(amountInCentsString),
								$elm$html$Html$text(' Payment')
							]))
					]))
			]);
	});
var $author$project$Components$Invoice$CreatePaymentModal$StoreCard = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Invoice$CreatePaymentModal$UpdateUseExistingSources = function (a) {
	return {$: 16, a: a};
};
var $author$project$Ui$Icon$Bolt = 49;
var $author$project$Ui$Icon$bolt = $author$project$Ui$Icon$viewIcon(49);
var $author$project$Ui$Grid$mb4 = $author$project$Ui$Grid$RowElement($author$project$Ui$Element$mb4);
var $author$project$Ui$Grid$offsetSm = $author$project$Ui$Grid$Offset(1);
var $author$project$Ui$Form$ButtonSelect$Option = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Ui$Form$ButtonSelect$option = F2(
	function (value, label) {
		return A2($author$project$Ui$Form$ButtonSelect$Option, value, label);
	});
var $author$project$Ui$Typography$p0 = $author$project$Ui$Typography$Attr(
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('p-0')
		]));
var $author$project$Ui$Typography$textLeft = $author$project$Ui$Typography$Aligned($author$project$Ui$Alignment$textLeft);
var $author$project$Ui$Button$group = function (contents) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('button-group')
			]),
		contents);
};
var $author$project$Ui$Button$Active = function (a) {
	return {$: 9, a: a};
};
var $author$project$Ui$Button$active = $author$project$Ui$Button$Active;
var $author$project$Ui$Form$ButtonSelect$viewOptionButton = F3(
	function (currentCardInput, onChange, _v0) {
		var value = _v0.a;
		var label = _v0.b;
		return A3(
			$author$project$Ui$Button$view,
			{mm: 'Select ' + label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(currentCardInput, value)),
					$author$project$Ui$Button$onClick(
					onChange(value))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Ui$Form$ButtonSelect$view = function (_v0) {
	var value = _v0.aee;
	var options = _v0.Cd;
	var onChange = _v0.ajd;
	return $author$project$Ui$Button$group(
		A2(
			$elm$core$List$map,
			A2($author$project$Ui$Form$ButtonSelect$viewOptionButton, value, onChange),
			options));
};
var $author$project$Components$Invoice$CreatePaymentModal$CardReaderSearchChanged = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Invoice$CreatePaymentModal$CardReaderSelected = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$CardReader$All$label = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CardReader$Shared$label(shared);
};
var $author$project$Utils$PaymentProcessor$toLabel = F3(
	function (showProcessor, element, getPaymentProcessor) {
		var _v0 = _Utils_Tuple2(
			showProcessor,
			getPaymentProcessor(element));
		if (_v0.a && (!_v0.b.$)) {
			var paymentProcessor_ = _v0.b.a;
			return $elm$core$Maybe$Just('[' + (paymentProcessor_ + ']'));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Invoice$CreatePaymentModal$cardReaderLabel = F2(
	function (showProcessor, cardReader) {
		return A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A3(
						$author$project$Utils$PaymentProcessor$toLabel,
						showProcessor,
						cardReader,
						A2($elm$core$Basics$composeR, $author$project$Api$Provider$CardReader$All$paymentProcessor, $elm$core$Maybe$Just)),
						$elm$core$Maybe$Just(
						$author$project$Api$Provider$CardReader$All$label(cardReader))
					])));
	});
var $author$project$Ui$Dropdown$Disabled = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Dropdown$disabled = $author$project$Ui$Dropdown$Disabled;
var $author$project$Ui$Dropdown$Errors = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Dropdown$errors = $author$project$Ui$Dropdown$Errors;
var $author$project$Components$Invoice$CreatePaymentModal$viewCardReader = F2(
	function (showProcessor, cardReader) {
		return A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$withDefault,
					$author$project$Utils$Html$empty,
					A4(
						$author$project$Utils$PaymentProcessor$toBadge,
						showProcessor,
						showProcessor,
						cardReader,
						A2($elm$core$Basics$composeR, $author$project$Api$Provider$CardReader$All$paymentProcessor, $elm$core$Maybe$Just))),
					A2(
					$elm$html$Html$strong,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Components$Invoice$CreatePaymentModal$cardReaderLabel, showProcessor, cardReader))
						]))
				]));
	});
var $author$project$Components$Invoice$CreatePaymentModal$viewCardReaders = function (model) {
	var _v0 = function () {
		var _v1 = model.iE;
		if (_v1.$ === 3) {
			var cardReaders_ = _v1.a;
			return _Utils_Tuple2(cardReaders_, false);
		} else {
			return _Utils_Tuple2(_List_Nil, true);
		}
	}();
	var cardReaders = _v0.a;
	var cardReadersLoading = _v0.b;
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				((!cardReadersLoading) && $elm$core$List$isEmpty(cardReaders)) ? A2(
				$author$project$Ui$Alert$danger,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('There are no card readers available. Please '),
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Admin__CardReaders,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('add a card reader')
							])),
						$elm$html$Html$text(' now.')
					])) : $author$project$Utils$Html$empty,
				function () {
				if (cardReadersLoading) {
					return $author$project$Ui$Skeleton$input(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$span(2)
							]));
				} else {
					var _v2 = $author$project$Utils$Form$fields(model.SD);
					var cardReader = _v2.aft;
					return A4(
						$author$project$Ui$Dropdown$viewSelect,
						_List_fromArray(
							[
								$author$project$Ui$Dropdown$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 1, model.SD)),
								$author$project$Ui$Dropdown$errors(
								A2($author$project$Utils$Form$validationErrors, 1, model.SD)),
								$author$project$Ui$Dropdown$disabled(
								$elm$core$List$isEmpty(cardReaders))
							]),
						function () {
							if (!cardReader.$) {
								var cr = cardReader.a;
								return _List_fromArray(
									[
										A2($author$project$Components$Invoice$CreatePaymentModal$viewCardReader, model.Cd.alv, cr)
									]);
							} else {
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$text,
										_List_fromArray(
											[$author$project$Ui$Typography$muted]),
										'Choose Card Reader')
									]);
							}
						}(),
						function () {
							var query = $elm$core$String$toLower(model.mF);
							return A2(
								$elm$core$List$cons,
								$author$project$Ui$Dropdown$input(
									_List_fromArray(
										[
											$author$project$Ui$Dropdown$onInput($author$project$Components$Invoice$CreatePaymentModal$CardReaderSearchChanged),
											$author$project$Ui$Dropdown$value(model.mF),
											$author$project$Ui$Dropdown$placeholder('Search...')
										])),
								A2(
									$elm$core$List$map,
									function (cr) {
										return A2(
											$author$project$Ui$Dropdown$item,
											_List_fromArray(
												[
													$author$project$Ui$Dropdown$onSelect(
													$author$project$Components$Invoice$CreatePaymentModal$CardReaderSelected(
														$elm$core$Maybe$Just(cr))),
													$author$project$Ui$Dropdown$selected(
													_Utils_eq(
														A2($elm$core$Maybe$map, $author$project$Api$Provider$CardReader$All$id, cardReader),
														$elm$core$Maybe$Just(
															$author$project$Api$Provider$CardReader$All$id(cr))))
												]),
											A2($author$project$Components$Invoice$CreatePaymentModal$viewCardReader, model.Cd.alv, cr));
									},
									A2(
										$elm$core$List$filter,
										function (cr) {
											return $elm$core$String$isEmpty(query) || A2(
												$elm$core$String$contains,
												query,
												$elm$core$String$toLower(
													A2($author$project$Components$Invoice$CreatePaymentModal$cardReaderLabel, model.Cd.alv, cr)));
										},
										cardReaders)));
						}(),
						model.mE);
				}
			}(),
				A2(
				$author$project$Ui$Element$prose,
				_List_fromArray(
					[$author$project$Ui$Element$mt2, $author$project$Ui$Element$textMuted]),
				_List_fromArray(
					[
						$elm$html$Html$text('Defaulted to the last reader used on this computer. '),
						$elm$html$Html$text('Tap payments such as Apple Pay & Google Pay are not supported at this time.')
					]))
			]));
};
var $author$project$Components$Invoice$CreatePaymentModal$CardType = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Invoice$CreatePaymentModal$cardTypeOptions = _List_fromArray(
	[
		A3(
		$author$project$Ui$Form$Select$option,
		_List_Nil,
		$elm$core$Maybe$Just(''),
		'Choose a card type...'),
		A3(
		$author$project$Ui$Form$Select$option,
		_List_Nil,
		$elm$core$Maybe$Just('debit'),
		'Debit'),
		A3(
		$author$project$Ui$Form$Select$option,
		_List_Nil,
		$elm$core$Maybe$Just('credit'),
		'Credit'),
		A3(
		$author$project$Ui$Form$Select$option,
		_List_Nil,
		$elm$core$Maybe$Just('amex'),
		'American Express')
	]);
var $author$project$Components$Invoice$CreatePaymentModal$viewCardTypeFormGroup = F2(
	function (fields, model) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Card Type'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Select$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Select$value(fields.No),
							$author$project$Ui$Form$Select$onChange(
							A2($elm$core$Basics$composeL, $author$project$Components$Invoice$CreatePaymentModal$FormUpdated, $author$project$Components$Invoice$CreatePaymentModal$CardType)),
							$author$project$Ui$Form$Select$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 3, model.SD)),
							$author$project$Ui$Form$Select$errors(
							A2($author$project$Utils$Form$validationErrors, 3, model.SD))
						]),
					$author$project$Components$Invoice$CreatePaymentModal$cardTypeOptions),
					function () {
					var _v0 = fields.No;
					_v0$3:
					while (true) {
						if (!_v0.$) {
							switch (_v0.a) {
								case 'debit':
									return A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$mt1]),
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Alert$view,
												1,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('No extra fees will be charged to the customer\'s card')
													]))
											]));
								case 'credit':
									return A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$mt1]),
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Alert$view,
												2,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Credit card fees will be charged to the customer\'s card')
													]))
											]));
								case 'amex':
									return A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$mt1]),
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Alert$view,
												2,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Credit card fees will be charged to the customer\'s card')
													]))
											]));
								default:
									break _v0$3;
							}
						} else {
							break _v0$3;
						}
					}
					return $author$project$Utils$Html$empty;
				}()
				]));
	});
var $author$project$Components$Invoice$CreatePaymentModal$PaymentSourceSearchChanged = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Invoice$CreatePaymentModal$PaymentSourceSelected = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Invoice$CreatePaymentModal$sourceName = function (source_) {
	var _v0 = $author$project$Api$Source$name(source_);
	if (!_v0.$) {
		var name = _v0.a;
		return $elm$core$Maybe$Just(name);
	} else {
		return $author$project$Api$Source$type_(source_);
	}
};
var $author$project$Components$Invoice$CreatePaymentModal$sourceLabel = F2(
	function (showProcessor, source) {
		return A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A3($author$project$Utils$PaymentProcessor$toLabel, showProcessor, source, $author$project$Api$Source$paymentProcessor),
						A2(
						$elm$core$Maybe$map,
						$author$project$Formatters$String$titleize,
						$author$project$Components$Invoice$CreatePaymentModal$sourceName(source)),
						A2(
						$elm$core$Maybe$map,
						function (lastFour) {
							return ' * ' + lastFour;
						},
						$author$project$Api$Source$lastFour(source)),
						A2(
						$elm$core$Maybe$map,
						function (funding) {
							return ' (' + (funding + ')');
						},
						$author$project$Api$Source$funding(source))
					])));
	});
var $author$project$Components$Invoice$CreatePaymentModal$viewPaymentSource = F2(
	function (showProcessor, source) {
		return A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$withDefault,
					$author$project$Utils$Html$empty,
					A4($author$project$Utils$PaymentProcessor$toBadge, showProcessor, showProcessor, source, $author$project$Api$Source$paymentProcessor)),
					function () {
					var _v0 = $author$project$Components$Invoice$CreatePaymentModal$sourceName(source);
					if (!_v0.$) {
						var name = _v0.a;
						return A2(
							$elm$html$Html$strong,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('inline')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Formatters$String$titleize(name))
										]))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					$author$project$Utils$Html$noBreakSpace,
					function () {
					var _v1 = $author$project$Api$Source$lastFour(source);
					if (!_v1.$) {
						var lastFour = _v1.a;
						return A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[
									$author$project$Ui$Typography$phi(true)
								]),
							'*' + lastFour);
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					$author$project$Utils$Html$noBreakSpace,
					function () {
					var _v2 = $author$project$Api$Source$funding(source);
					if (!_v2.$) {
						var funding = _v2.a;
						return A2($author$project$Ui$Typography$text, _List_Nil, '(' + (funding + ')'));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					$author$project$Utils$Html$noBreakSpace,
					A2(
					$author$project$Ui$Badge$fromString,
					_List_Nil,
					A2(
						$elm$core$Maybe$withDefault,
						'N/A',
						$author$project$Api$Source$status(source))),
					$author$project$Utils$Html$noBreakSpace,
					function () {
					var _v3 = $author$project$Api$Source$label(source);
					if (!_v3.$) {
						var label = _v3.a;
						return A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$em,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-muted')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[
													$author$project$Ui$Typography$phi(true),
													$author$project$Ui$Typography$overflowWrap($author$project$Ui$OverflowWrap$breakWord)
												]),
											label)
										]))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]));
	});
var $author$project$Components$Invoice$CreatePaymentModal$viewPaymentSources = F2(
	function (model, selected) {
		return A4(
			$author$project$Ui$Dropdown$viewSelect,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$invalid(
					A2($author$project$Utils$Form$hasValidationErrors, 2, model.SD)),
					$author$project$Ui$Dropdown$errors(
					A2($author$project$Utils$Form$validationErrors, 2, model.SD))
				]),
			function () {
				if (!selected.$) {
					var source = selected.a;
					return _List_fromArray(
						[
							A2($author$project$Components$Invoice$CreatePaymentModal$viewPaymentSource, model.Cd.alv, source)
						]);
				} else {
					return _List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[$author$project$Ui$Typography$muted]),
							'Select a Source')
						]);
				}
			}(),
			function () {
				var selectedSourceId = A2($elm$core$Maybe$map, $author$project$Api$Source$id, selected);
				var query = $elm$core$String$toLower(model.o6);
				var patientSources = function () {
					var _v2 = _Utils_Tuple2(model.rC, model.rs);
					if ((_v2.a.$ === 3) && (_v2.b.$ === 3)) {
						var _v3 = _v2.a;
						var cards = _v3.a;
						var _v4 = _v2.b;
						var bankAccounts = _v4.a;
						return $elm$core$List$reverse(
							A2(
								$elm$core$List$sortBy,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Api$Source$createdAt,
									A2(
										$elm$core$Basics$composeR,
										$elm$core$Maybe$map($elm$time$Time$posixToMillis),
										$elm$core$Maybe$withDefault(0))),
								_Utils_ap(
									A2($elm$core$List$map, $author$project$Api$Source$Card, cards),
									A2($elm$core$List$map, $author$project$Api$Source$BankAccount, bankAccounts))));
					} else {
						return _List_Nil;
					}
				}();
				var isSelectedInList = A2(
					$elm$core$Maybe$withDefault,
					true,
					A2(
						$elm$core$Maybe$map,
						function (id) {
							return A2(
								$elm$core$List$any,
								function (s) {
									return _Utils_eq(
										$author$project$Api$Source$id(s),
										id);
								},
								patientSources);
						},
						selectedSourceId));
				var sources = function () {
					var _v1 = _Utils_Tuple2(selected, isSelectedInList);
					if ((!_v1.a.$) && (!_v1.b)) {
						var selectedSource = _v1.a.a;
						return A2($elm$core$List$cons, selectedSource, patientSources);
					} else {
						return patientSources;
					}
				}();
				return A2(
					$elm$core$List$cons,
					$author$project$Ui$Dropdown$input(
						_List_fromArray(
							[
								$author$project$Ui$Dropdown$onInput($author$project$Components$Invoice$CreatePaymentModal$PaymentSourceSearchChanged),
								$author$project$Ui$Dropdown$value(model.o6),
								$author$project$Ui$Dropdown$placeholder('Search...')
							])),
					A2(
						$elm$core$List$map,
						function (s) {
							return A2(
								$author$project$Ui$Dropdown$item,
								_List_fromArray(
									[
										$author$project$Ui$Dropdown$onSelect(
										$author$project$Components$Invoice$CreatePaymentModal$PaymentSourceSelected(
											$elm$core$Maybe$Just(s))),
										$author$project$Ui$Dropdown$selected(
										_Utils_eq(
											A2($elm$core$Maybe$map, $author$project$Api$Source$id, selected),
											$elm$core$Maybe$Just(
												$author$project$Api$Source$id(s))))
									]),
								A2($author$project$Components$Invoice$CreatePaymentModal$viewPaymentSource, model.Cd.alv, s));
						},
						A2(
							$elm$core$List$filter,
							function (s) {
								return $elm$core$String$isEmpty(query) || A2(
									$elm$core$String$contains,
									query,
									$elm$core$String$toLower(
										A2($author$project$Components$Invoice$CreatePaymentModal$sourceLabel, model.Cd.alv, s)));
							},
							sources)));
			}(),
			model.o5);
	});
var $author$project$Api$Provider$PassthroughFee$Shared$passthroughFeeInCents = function (_v0) {
	var internalRecord = _v0;
	return internalRecord.YU;
};
var $author$project$Api$Provider$PassthroughFee$One$passthroughFeeInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PassthroughFee$Shared$passthroughFeeInCents(shared);
};
var $author$project$Components$Invoice$CreatePaymentModal$passthroughFeesInCents = function (passthroughFees) {
	return A2(
		$elm$core$Maybe$map,
		$author$project$Api$Provider$PassthroughFee$One$passthroughFeeInCents,
		$author$project$Api$Data$toMaybe(passthroughFees));
};
var $author$project$Components$Invoice$CreatePaymentModal$viewPaymentTotalModal = F2(
	function (subtotal, passthroughFees) {
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mt2]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$justifyCenter]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('Payment Total')
								]))
						])),
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$offsetSm(1),
									$author$project$Ui$Grid$span(5)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$hintLabel, $author$project$Ui$Typography$p0, $author$project$Ui$Typography$textLeft]),
									'Subtotal')
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(5)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[
											$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
										]),
									$author$project$Currency$format(
										$author$project$Currency$fromInt(subtotal)))
								]))
						])),
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$offsetSm(1),
									$author$project$Ui$Grid$span(5)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$hintLabel, $author$project$Ui$Typography$p0, $author$project$Ui$Typography$textLeft]),
									'Credit Card Fees')
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(5)
								]),
							_List_fromArray(
								[
									function () {
									var _v0 = $author$project$Components$Invoice$CreatePaymentModal$passthroughFeesInCents(passthroughFees);
									if (!_v0.$) {
										var cents = _v0.a;
										return A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[
													$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
												]),
											$author$project$Currency$format(
												$author$project$Currency$fromInt(cents)));
									} else {
										return $author$project$Ui$Skeleton$text(
											_List_fromArray(
												[
													$author$project$Ui$Skeleton$span(1)
												]));
									}
								}()
								]))
						]))
				]));
	});
var $author$project$Components$Invoice$CreatePaymentModal$viewPayNowModal = F3(
	function (model, fields, amountInCentsString) {
		var passthroughActive = A2($author$project$Components$Invoice$CreatePaymentModal$passthroughFeesActive, model, fields);
		return _List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Process Payment')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$onSubmit($author$project$Components$Invoice$CreatePaymentModal$CreatePayment)
							]),
						_List_fromArray(
							[
								A2($author$project$Components$Invoice$CreatePaymentModal$viewPayNowPanel, fields, model),
								$author$project$Utils$Html$empty,
								$author$project$Utils$Html$empty,
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Source'),
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(8)
									]),
								_List_fromArray(
									[
										($author$project$Api$Practice$usesCardReaders(model.ZV) && (!$author$project$Api$Platform$Session$One$organizationIsCompany(model.aa4))) ? A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$mb2]),
										_List_fromArray(
											[
												$author$project$Ui$Form$ButtonSelect$view(
												{
													ajd: $author$project$Components$Invoice$CreatePaymentModal$UpdateUseExistingSources,
													Cd: _List_fromArray(
														[
															A2($author$project$Ui$Form$ButtonSelect$option, true, 'Existing payment source'),
															A2($author$project$Ui$Form$ButtonSelect$option, false, 'Card Reader')
														]),
													aee: model.bP
												})
											])) : $author$project$Utils$Html$empty,
										model.bP ? A2($author$project$Components$Invoice$CreatePaymentModal$viewPaymentSources, model, fields.JQ) : $author$project$Components$Invoice$CreatePaymentModal$viewCardReaders(model)
									])),
								((!model.bP) && (!_Utils_eq(model.Cd.YV, $elm$core$Maybe$Nothing))) ? A2($author$project$Components$Invoice$CreatePaymentModal$viewCardTypeFormGroup, fields, model) : $author$project$Utils$Html$empty,
								function () {
								if (!model.bP) {
									var _v0 = function () {
										var _v1 = model.iE;
										if (_v1.$ === 3) {
											var cardReaders_ = _v1.a;
											return _Utils_Tuple2(cardReaders_, false);
										} else {
											return _Utils_Tuple2(_List_Nil, true);
										}
									}();
									var cardReaders = _v0.a;
									var cardReadersLoading = _v0.b;
									return A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$label('Remember this card'),
												$author$project$Ui$Form$Group$labelSpan(4),
												$author$project$Ui$Form$Group$inputSpan(8)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Element$view,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Store card for future use')
													])),
												((!cardReadersLoading) && (!$elm$core$List$isEmpty(cardReaders))) ? A2(
												$author$project$Ui$Typography$p,
												_List_fromArray(
													[$author$project$Ui$Typography$gray]),
												_List_fromArray(
													[
														$elm$html$Html$text('Save and set this card as the default payment method for future invoices.')
													])) : $author$project$Utils$Html$empty,
												$author$project$Ui$ToggleSwitch$view(
												_List_fromArray(
													[
														$author$project$Ui$ToggleSwitch$on(fields.EM),
														$author$project$Ui$ToggleSwitch$onChange(
														A2($elm$core$Basics$composeL, $author$project$Components$Invoice$CreatePaymentModal$FormUpdated, $author$project$Components$Invoice$CreatePaymentModal$StoreCard))
													]))
											]));
								} else {
									return $author$project$Utils$Html$empty;
								}
							}(),
								$author$project$Components$Invoice$CreatePaymentModal$viewMemoModal(fields)
							])),
						passthroughActive ? A2($author$project$Components$Invoice$CreatePaymentModal$viewPaymentTotalModal, model.uZ, model.YV) : $author$project$Utils$Html$empty
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
						_List_fromArray(
							[
								passthroughActive ? A2(
								$author$project$Ui$Grid$row,
								_List_fromArray(
									[$author$project$Ui$Grid$mb4]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$offsetSm(1),
												$author$project$Ui$Grid$span(5)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$text,
												_List_fromArray(
													[$author$project$Ui$Typography$hintLabel, $author$project$Ui$Typography$p0, $author$project$Ui$Typography$textLeft]),
												'Total')
											])),
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(5)
											]),
										_List_fromArray(
											[
												function () {
												var _v2 = $author$project$Components$Invoice$CreatePaymentModal$passthroughFeesTotalAmount(model.YV);
												if (!_v2.$) {
													var total = _v2.a;
													return $author$project$Ui$Typography$headingSm(
														_List_fromArray(
															[
																$elm$html$Html$text(
																$author$project$Currency$format(
																	$author$project$Currency$fromInt(total)))
															]));
												} else {
													return $author$project$Ui$Skeleton$text(
														_List_fromArray(
															[
																$author$project$Ui$Skeleton$span(1)
															]));
												}
											}()
											]))
									])) : $author$project$Utils$Html$empty,
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Cancel and close modal'},
								_List_fromArray(
									[
										$author$project$Ui$Button$onClick($author$project$Components$Invoice$CreatePaymentModal$Close)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Cancel')
									])),
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Process payment now'},
								_List_fromArray(
									[
										$author$project$Ui$Button$styled(3),
										$author$project$Ui$Button$loading(
										_Utils_eq(model.an, $author$project$Api$Data$Loading)),
										$author$project$Ui$Button$onClick($author$project$Components$Invoice$CreatePaymentModal$CreatePayment),
										$author$project$Ui$Button$icon($author$project$Ui$Icon$bolt)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(' Process '),
										$elm$html$Html$text(amountInCentsString),
										$elm$html$Html$text(' Now')
									]))
							]))
					]))
			]);
	});
var $author$project$Components$Invoice$CreatePaymentModal$viewCreatePaymentModal = function (model) {
	var fields = $author$project$Utils$Form$fields(model.SD);
	var amountInCentsString = function () {
		var _v1 = _Utils_Tuple2(
			A2($author$project$Components$Invoice$CreatePaymentModal$passthroughFeesActive, model, fields),
			$author$project$Components$Invoice$CreatePaymentModal$passthroughFeesTotalAmount(model.YV));
		if (_v1.a && (!_v1.b.$)) {
			var total = _v1.b.a;
			return $author$project$Currency$format(
				$author$project$Currency$fromInt(total));
		} else {
			return $author$project$Currency$format(
				A2($elm$core$Maybe$withDefault, $author$project$Currency$zero, fields.LE));
		}
	}();
	var modalToDisplay = function () {
		var _v0 = model.r2;
		if (!_v0) {
			return A3($author$project$Components$Invoice$CreatePaymentModal$viewPayNowModal, model, fields, amountInCentsString);
		} else {
			return A3($author$project$Components$Invoice$CreatePaymentModal$viewExternalSourceModal, model, fields, amountInCentsString);
		}
	}();
	return A3($author$project$Ui$Modal$view, $author$project$Components$Invoice$CreatePaymentModal$Close, _List_Nil, modalToDisplay);
};
var $author$project$Components$Invoice$CreatePaymentModal$view = function (_v0) {
	var model = _v0;
	var _v1 = _Utils_Tuple2(model.iD, model.cp);
	if (!_v1.a.$) {
		var _v2 = _v1.a.a;
		var cardReaderConnectingModal = _v2.a;
		return A2(
			$elm$html$Html$map,
			$author$project$Components$Invoice$CreatePaymentModal$CardReaderConnectingModalMsg,
			$author$project$Components$CardReader$ConnectingModal$view(cardReaderConnectingModal));
	} else {
		if (!_v1.b.$) {
			var _v3 = _v1.b.a;
			var cardReaderPaymentModal = _v3.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Components$Invoice$CreatePaymentModal$CardReaderPaymentModalMsg,
				$author$project$Components$CardReader$PaymentModal$view(cardReaderPaymentModal));
		} else {
			var _v4 = _v1.a;
			var _v5 = _v1.b;
			return $author$project$Components$Invoice$CreatePaymentModal$viewCreatePaymentModal(model);
		}
	}
};
var $author$project$Components$Invoice$PaymentsHistory$Toggle = {$: 0};
var $author$project$Components$PaymentsList$AllowDisputes = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$PaymentsList$allowDisputes = $author$project$Components$PaymentsList$AllowDisputes;
var $author$project$Components$PaymentsList$AllowRefunds = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$PaymentsList$allowRefunds = $author$project$Components$PaymentsList$AllowRefunds;
var $author$project$Components$PaymentsList$IsHintAdmin = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$PaymentsList$isHintAdmin = $author$project$Components$PaymentsList$IsHintAdmin;
var $author$project$Ui$Popover$Large = 1;
var $author$project$Ui$Popover$lg = $author$project$Ui$Popover$Size(1);
var $author$project$Components$PaymentsList$ShowRefundMemo = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$PaymentsList$showRefundMemo = $author$project$Components$PaymentsList$ShowRefundMemo;
var $author$project$Components$PaymentsList$defaultOptions = {aeS: false, aeV: false, Ij: false, uC: false, alx: false};
var $author$project$Components$PaymentsList$optionsToRecord = A2(
	$elm$core$List$foldl,
	F2(
		function (option, acc) {
			switch (option.$) {
				case 0:
					var bool = option.a;
					return _Utils_update(
						acc,
						{uC: bool});
				case 1:
					var bool = option.a;
					return _Utils_update(
						acc,
						{aeV: bool});
				case 2:
					var bool = option.a;
					return _Utils_update(
						acc,
						{alx: bool});
				case 3:
					var bool = option.a;
					return _Utils_update(
						acc,
						{aeS: bool});
				default:
					var bool = option.a;
					return _Utils_update(
						acc,
						{Ij: bool});
			}
		}),
	$author$project$Components$PaymentsList$defaultOptions);
var $author$project$Components$PaymentsList$CancelPayment = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$PaymentsList$DeleteExternalPayment = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$PaymentsList$OpenPaymentDisputeModal = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$PaymentsList$OpenRainforestPaymentModal = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$PaymentsList$OpenSimulateDisputeEventModal = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Components$PaymentsList$OpenSimulateDisputeModal = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$CardReader$Shared$Provider = $elm$core$Basics$identity;
var $author$project$Components$PaymentsList$Refund = function (a) {
	return {$: 0, a: a};
};
var $author$project$Formatters$Time$Time__Full = 0;
var $author$project$Api$Employer$Payment$Shared$attemptedInCents = function (_v0) {
	var record = _v0;
	return record.L7;
};
var $author$project$Api$Employer$Payment$One$attemptedInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Payment$Shared$attemptedInCents(shared);
};
var $author$project$Api$Provider$Payment$Shared$attemptedInCents = function (_v0) {
	var record = _v0;
	return record.L7;
};
var $author$project$Api$Provider$Payment$One$attemptedInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$attemptedInCents(shared);
};
var $author$project$Api$Provider$Payment$SharedWithRefunds$attemptedInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$attemptedInCents(shared);
};
var $author$project$Api$Payment$attemptedInCents = function (payment) {
	switch (payment.$) {
		case 1:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$One$attemptedInCents(payment_);
		case 0:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$SharedWithRefunds$attemptedInCents(payment_);
		default:
			var payment_ = payment.a;
			return $author$project$Api$Employer$Payment$One$attemptedInCents(payment_);
	}
};
var $author$project$Components$PaymentSourceDisplayer$CardReader = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$PaymentSourceDisplayer$cardReader = $author$project$Components$PaymentSourceDisplayer$CardReader;
var $author$project$Api$Employer$Payment$Shared$createdAt = function (_v0) {
	var record = _v0;
	return record.O1;
};
var $author$project$Api$Employer$Payment$One$createdAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Payment$Shared$createdAt(shared);
};
var $author$project$Api$Provider$Payment$Shared$createdAt = function (_v0) {
	var record = _v0;
	return record.O1;
};
var $author$project$Api$Provider$Payment$One$createdAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$createdAt(shared);
};
var $author$project$Api$Provider$Payment$SharedWithRefunds$createdAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$createdAt(shared);
};
var $author$project$Api$Payment$createdAt = function (payment) {
	switch (payment.$) {
		case 1:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$One$createdAt(payment_);
		case 0:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$SharedWithRefunds$createdAt(payment_);
		default:
			var payment_ = payment.a;
			return $author$project$Api$Employer$Payment$One$createdAt(payment_);
	}
};
var $author$project$Api$Provider$Payment$One$createdBy = function (_v0) {
	var record = _v0.b;
	return record.O2;
};
var $author$project$Api$Payment$createdBy = function (payment) {
	switch (payment.$) {
		case 1:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$One$createdBy(payment_);
		case 0:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Ui$Icon$CrossCircle = 68;
var $author$project$Ui$Icon$crossCircle = $author$project$Ui$Icon$viewIcon(68);
var $author$project$Api$Provider$Payment$Creator$displayName = function (_v0) {
	var creator = _v0;
	return creator.Bq;
};
var $author$project$Api$Dispute$Provider_Shared = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Payment$One$dispute = function (_v0) {
	var record = _v0.b;
	return record.QL;
};
var $author$project$Api$Provider$Payment$SharedWithRefunds$dispute = function (_v0) {
	var record = _v0.b;
	return record.QL;
};
var $author$project$Api$Payment$dispute = function (payment) {
	switch (payment.$) {
		case 1:
			var payment_ = payment.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$Dispute$Provider_Shared,
				$author$project$Api$Provider$Payment$One$dispute(payment_));
		case 0:
			var payment_ = payment.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$Dispute$Provider_Shared,
				$author$project$Api$Provider$Payment$SharedWithRefunds$dispute(payment_));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$Payment$Shared$errorCode = function (_v0) {
	var record = _v0;
	return record.RL;
};
var $author$project$Api$Provider$Payment$One$errorCode = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$errorCode(shared);
};
var $author$project$Api$Payment$errorCode = function (payment) {
	switch (payment.$) {
		case 1:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$One$errorCode(payment_);
		case 0:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Employer$Payment$Shared$errorMessage = function (_v0) {
	var record = _v0;
	return record.RM;
};
var $author$project$Api$Employer$Payment$One$errorMessage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Payment$Shared$errorMessage(shared);
};
var $author$project$Api$Provider$Payment$Shared$errorMessage = function (_v0) {
	var record = _v0;
	return record.RM;
};
var $author$project$Api$Provider$Payment$One$errorMessage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$errorMessage(shared);
};
var $author$project$Api$Provider$Payment$SharedWithRefunds$errorMessage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$errorMessage(shared);
};
var $author$project$Api$Payment$errorMessage = function (payment) {
	switch (payment.$) {
		case 1:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$One$errorMessage(payment_);
		case 0:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$SharedWithRefunds$errorMessage(payment_);
		default:
			var payment_ = payment.a;
			return $author$project$Api$Employer$Payment$One$errorMessage(payment_);
	}
};
var $author$project$Ui$Element$gap = $author$project$Ui$Element$Gap(1);
var $author$project$Formatters$String$humanize = $elm_community$string_extra$String$Extra$humanize;
var $author$project$Api$Provider$Payment$Shared$isCancelable = function (_v0) {
	var record = _v0;
	return record.UE;
};
var $author$project$Api$Provider$Payment$One$isCancelable = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$isCancelable(shared);
};
var $author$project$Api$Provider$Payment$SharedWithRefunds$isCancelable = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$isCancelable(shared);
};
var $author$project$Api$Payment$isCancelable = function (payment) {
	switch (payment.$) {
		case 1:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$One$isCancelable(payment_);
		case 0:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$SharedWithRefunds$isCancelable(payment_);
		default:
			return false;
	}
};
var $author$project$Api$Provider$Payment$Shared$isRefundable = function (_v0) {
	var record = _v0;
	return record.U8;
};
var $author$project$Api$Provider$Payment$One$isRefundable = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$isRefundable(shared);
};
var $author$project$Api$Provider$Payment$SharedWithRefunds$isRefundable = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$isRefundable(shared);
};
var $author$project$Api$Payment$isRefundable = function (payment) {
	switch (payment.$) {
		case 1:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$One$isRefundable(payment_);
		case 0:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$SharedWithRefunds$isRefundable(payment_);
		default:
			return false;
	}
};
var $author$project$Api$Provider$Payment$Shared$memo = function (_v0) {
	var record = _v0;
	return record.aiG;
};
var $author$project$Api$Provider$Payment$One$memo = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$memo(shared);
};
var $author$project$Api$Provider$Payment$SharedWithRefunds$memo = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$memo(shared);
};
var $author$project$Api$Payment$memo = function (payment) {
	switch (payment.$) {
		case 1:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$One$memo(payment_);
		case 0:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$SharedWithRefunds$memo(payment_);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Common$Source$Shared$oneTimeUse = function (_v0) {
	var record = _v0;
	return record.Yl;
};
var $author$project$Api$Refund$Employer_Shared = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Refund$Provider_One = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Refund$Provider_Shared = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Employer$Payment$One$refunds = function (_v0) {
	var record = _v0.b;
	return record.$n;
};
var $author$project$Api$Provider$Payment$One$refunds = function (_v0) {
	var record = _v0.b;
	return record.$n;
};
var $author$project$Api$Provider$Payment$SharedWithRefunds$refunds = function (_v0) {
	var record = _v0.b;
	return record.$n;
};
var $author$project$Api$Payment$refunds = function (payment) {
	switch (payment.$) {
		case 1:
			var payment_ = payment.a;
			return A2(
				$elm$core$List$map,
				$author$project$Api$Refund$Provider_One,
				$author$project$Api$Provider$Payment$One$refunds(payment_));
		case 0:
			var payment_ = payment.a;
			return A2(
				$elm$core$List$map,
				$author$project$Api$Refund$Provider_Shared,
				$author$project$Api$Provider$Payment$SharedWithRefunds$refunds(payment_));
		default:
			var payment_ = payment.a;
			return A2(
				$elm$core$List$map,
				$author$project$Api$Refund$Employer_Shared,
				$author$project$Api$Employer$Payment$One$refunds(payment_));
	}
};
var $author$project$Components$PaymentSourceDisplayer$ShowProcessor = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$PaymentSourceDisplayer$showProcessor = $author$project$Components$PaymentSourceDisplayer$ShowProcessor;
var $author$project$Api$Provider$Dispute$Shared$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Api$Provider$Dispute$One$status = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Dispute$Shared$status(shared);
};
var $author$project$Api$Dispute$status = function (dispute) {
	if (!dispute.$) {
		var dispute_ = dispute.a;
		return $author$project$Api$Provider$Dispute$One$status(dispute_);
	} else {
		var dispute_ = dispute.a;
		return $author$project$Api$Provider$Dispute$Shared$status(dispute_);
	}
};
var $author$project$Api$Employer$Refund$Shared$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Api$Provider$Refund$Shared$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Api$Provider$Refund$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Refund$Shared$status(shared);
};
var $author$project$Api$Refund$status = function (refund) {
	switch (refund.$) {
		case 0:
			var refund_ = refund.a;
			return $author$project$Api$Provider$Refund$One$status(refund_);
		case 1:
			var refund_ = refund.a;
			return $author$project$Api$Provider$Refund$Shared$status(refund_);
		default:
			var refund_ = refund.a;
			return $author$project$Api$Employer$Refund$Shared$status(refund_);
	}
};
var $author$project$Api$Platform$Session$One$userIsPracticeAdmin = function (_v0) {
	var record = _v0;
	return record.ak3 === 'practice_admin';
};
var $author$project$Ui$Badge$fromStringWithIcon = F3(
	function (options, label, icon) {
		var content = _List_fromArray(
			[
				icon,
				$elm$html$Html$text(
				$author$project$Ui$Badge$formatLabel(label))
			]);
		return function (attrs) {
			return A2($elm$html$Html$span, attrs, content);
		}(
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('badge badge--icon'),
				A2(
					$elm$core$List$map,
					$author$project$Ui$Badge$optionToAttr,
					_Utils_ap(
						options,
						$author$project$Ui$Badge$mapColor(label)))));
	});
var $author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping = {Hl: 'Cardholder should contact their bank to find out why the payment was declined or try a different payment method.', Hu: 'The bank didn\'t approve this payment — often this happens when the purchase is unusual for the cardholder\'s account, like a new merchant or a different amount than normal. Cardholder should contact the bank to approve the payment, or try another payment method.', HF: 'Ask the cardholder to update their payment method with a valid, unexpired card.', HR: 'Use a different payment method or contact the associated bank if this may be an error.', H0: 'Double-check the card details and try again.', H6: 'Use a different payment method or add funds to the respective account before retrying.', H7: 'Some card details weren\'t recognized. Please double-check the card information and try again.', H8: 'Some card details weren\'t recognized. Please double-check the card information and try again.', H9: 'Some card details weren\'t recognized. Please double-check the card information and try again.', Iv: 'This card has been reported lost, so the bank won\'t approve the payment. Try a different payment method or contact the bank if this may be a mistake.', IJ: 'This card number isn\'t recognized by the bank — it may have been entered incorrectly or the card may have been replaced. Please double-check the number or use a different payment method.', IM: 'The card number entered doesn\'t match any known bank. Please double-check the number and try again.', I0: 'Cardholder should contact their bank to increase their card limit or use another payment method.', Jm: 'There was a problem processing the payment. Please try again or use a different payment method.', JB: 'There was a problem processing the payment. Please try again or use a different payment method.', JC: 'Cardholder should contact their bank to find out why the payment was declined or try a different payment method.', JD: 'Bank payment failed — account owner should check the account details and balance or try another method.', JE: 'Contact the bank to find out why the payment was declined or try another payment method.', JY: 'Cardholder should contact their bank for more information or try a different payment method', J6: 'Cardholder should contact their bank for more information or try a different payment method', Kf: 'Looks like we couldn\'t use the saved card on file. Please re-enter your card details and try again', Ki: 'This card type isn\'t supported. Please try a Visa, Mastercard, or another accepted payment method.'};
var $author$project$Components$PaymentFailedRecommendation$getRecommendationForErrorCode = function (errorCode) {
	var normalizedErrorCode = $elm$core$String$toLower(errorCode);
	switch (normalizedErrorCode) {
		case 'declined':
			return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.Hl);
		case 'do_not_honor':
			return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.Hu);
		case 'expired_card':
			return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.HF);
		case 'fraudulent_card':
			return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.HR);
		case 'incorrect_payment_information':
			return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.H0);
		case 'insufficient_funds':
			return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.H6);
		case 'invalid_card_security_code':
			return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.H7);
		case 'invalid_expiration_date':
			return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.H8);
		case 'invalid_pin':
			return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.H9);
		case 'lost_card':
			return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.Iv);
		case 'no_card_number_on_file_with_issuer':
			return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.IJ);
		case 'no_such_card_issuer':
			return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.IM);
		case 'over_limit':
			return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.I0);
		case 'processing_error':
			return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.Jm);
		case 'retry':
			return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.JB);
		case 'retry_with_threeds':
			return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.JC);
		case 'risk_decline':
			return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.JE);
		case 'stolen_card':
			return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.JY);
		case 'threeds_challenge_failed':
			return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.J6);
		case 'unexpected_payin_token':
			return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.Kf);
		case 'unsupported_card_type':
			return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.Ki);
		case 'return_code':
			return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.JD);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Ui$Icon$Warning = 67;
var $author$project$Ui$Icon$warning = $author$project$Ui$Icon$viewIcon(67);
var $author$project$Components$PaymentFailedRecommendation$view = F2(
	function (maybeErrorCode, maybePaymentProcessor) {
		var _v0 = _Utils_Tuple2(
			A2($elm$core$Maybe$andThen, $author$project$Components$PaymentFailedRecommendation$getRecommendationForErrorCode, maybeErrorCode),
			maybePaymentProcessor);
		if (((!_v0.a.$) && (!_v0.b.$)) && (_v0.b.a === 'rainforest')) {
			var recommendation = _v0.a.a;
			return A3(
				$author$project$Ui$Popover$view,
				_List_fromArray(
					[$author$project$Ui$Popover$dark]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Badge$fromStringWithIcon,
						_List_fromArray(
							[$author$project$Ui$Badge$danger]),
						'recommendation',
						$author$project$Ui$Icon$warning(
							_List_fromArray(
								[$author$project$Ui$Icon$danger])))
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Popover$body,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(recommendation)
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$PaymentsList$CancelRefundClicked = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$PaymentsList$OpenRainforestRefundModal = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Employer$Refund$Shared$amountInCents = function (_v0) {
	var record = _v0;
	return record.LE;
};
var $author$project$Api$Provider$Refund$Shared$amountInCents = function (_v0) {
	var record = _v0;
	return record.LE;
};
var $author$project$Api$Provider$Refund$One$amountInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Refund$Shared$amountInCents(shared);
};
var $author$project$Api$Refund$amountInCents = function (refund) {
	switch (refund.$) {
		case 0:
			var refund_ = refund.a;
			return $author$project$Api$Provider$Refund$One$amountInCents(refund_);
		case 1:
			var refund_ = refund.a;
			return $author$project$Api$Provider$Refund$Shared$amountInCents(refund_);
		default:
			var refund_ = refund.a;
			return $author$project$Api$Employer$Refund$Shared$amountInCents(refund_);
	}
};
var $author$project$Api$Employer$Refund$Shared$createdAt = function (_v0) {
	var record = _v0;
	return record.O1;
};
var $author$project$Api$Provider$Refund$Shared$createdAt = function (_v0) {
	var record = _v0;
	return record.O1;
};
var $author$project$Api$Provider$Refund$One$createdAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Refund$Shared$createdAt(shared);
};
var $author$project$Api$Refund$createdAt = function (refund) {
	switch (refund.$) {
		case 0:
			var refund_ = refund.a;
			return $author$project$Api$Provider$Refund$One$createdAt(refund_);
		case 1:
			var refund_ = refund.a;
			return $author$project$Api$Provider$Refund$Shared$createdAt(refund_);
		default:
			var refund_ = refund.a;
			return $author$project$Api$Employer$Refund$Shared$createdAt(refund_);
	}
};
var $author$project$Api$Provider$Refund$One$createdBy = function (_v0) {
	var record = _v0.b;
	return record.O2;
};
var $author$project$Api$Refund$createdBy = function (refund) {
	switch (refund.$) {
		case 0:
			var refund_ = refund.a;
			return $author$project$Api$Provider$Refund$One$createdBy(refund_);
		case 1:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$User$Shared$displayName = function (_v0) {
	var record = _v0;
	return record.QK;
};
var $author$project$Api$Provider$Refund$Shared$errorMessage = function (_v0) {
	var record = _v0;
	return record.RM;
};
var $author$project$Api$Provider$Refund$One$errorMessage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Refund$Shared$errorMessage(shared);
};
var $author$project$Api$Refund$errorMessage = function (refund) {
	switch (refund.$) {
		case 0:
			var refund_ = refund.a;
			return $author$project$Api$Provider$Refund$One$errorMessage(refund_);
		case 1:
			var refund_ = refund.a;
			return $author$project$Api$Provider$Refund$Shared$errorMessage(refund_);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$Refund$Shared$external = function (_v0) {
	var record = _v0;
	return record.R5;
};
var $author$project$Api$Provider$Refund$One$external = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Refund$Shared$external(shared);
};
var $author$project$Api$Refund$external = function (refund) {
	switch (refund.$) {
		case 0:
			var refund_ = refund.a;
			return $author$project$Api$Provider$Refund$One$external(refund_);
		case 1:
			var refund_ = refund.a;
			return $author$project$Api$Provider$Refund$Shared$external(refund_);
		default:
			return false;
	}
};
var $author$project$Api$Provider$Refund$Shared$memo = function (_v0) {
	var record = _v0;
	return record.aiG;
};
var $author$project$Api$Provider$Refund$One$memo = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Refund$Shared$memo(shared);
};
var $author$project$Api$Refund$memo = function (refund) {
	switch (refund.$) {
		case 0:
			var refund_ = refund.a;
			return $author$project$Api$Provider$Refund$One$memo(refund_);
		case 1:
			var refund_ = refund.a;
			return $author$project$Api$Provider$Refund$Shared$memo(refund_);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Employer$Refund$Shared$paymentProcessor = function (_v0) {
	var record = _v0;
	return record.Zd;
};
var $author$project$Api$Provider$Refund$Shared$paymentProcessor = function (_v0) {
	var record = _v0;
	return record.Zd;
};
var $author$project$Api$Provider$Refund$One$paymentProcessor = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Refund$Shared$paymentProcessor(shared);
};
var $author$project$Api$Refund$paymentProcessor = function (refund) {
	switch (refund.$) {
		case 0:
			var refund_ = refund.a;
			return $author$project$Api$Provider$Refund$One$paymentProcessor(refund_);
		case 1:
			var refund_ = refund.a;
			return $author$project$Api$Provider$Refund$Shared$paymentProcessor(refund_);
		default:
			var refund_ = refund.a;
			return $author$project$Api$Employer$Refund$Shared$paymentProcessor(refund_);
	}
};
var $author$project$Ui$Element$Danger = 5;
var $author$project$Ui$Element$textDanger = $author$project$Ui$Element$Text(5);
var $author$project$Components$PaymentsList$viewRefund = F5(
	function (timeFormatter, source, optionsRecord, payment, refund) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('payment__refund')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(2)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										timeFormatter,
										5,
										$author$project$Api$Refund$createdAt(refund)))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(7)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Badge$fromString,
											_List_Nil,
											function () {
												var _v0 = _Utils_Tuple2(
													$author$project$Api$Refund$paymentProcessor(refund),
													$author$project$Api$Refund$status(refund));
												if ((_v0.a === 'rainforest') && (_v0.b === 'pending')) {
													return 'refund_actually_pending';
												} else {
													var status = _v0.b;
													return 'refund_' + status;
												}
											}()),
											function () {
											if ($author$project$Api$Refund$external(refund)) {
												return $elm$html$Html$text(' Refunded as an external refund');
											} else {
												var _v1 = $author$project$Api$Refund$status(refund);
												if (_v1 === 'cancelled') {
													return $elm$html$Html$text('');
												} else {
													return A2(
														$author$project$Ui$Element$view,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(' Processed automatically to '),
																A2(
																$elm$core$Maybe$withDefault,
																$author$project$Utils$Html$empty,
																A4(
																	$author$project$Utils$PaymentProcessor$toBadge,
																	optionsRecord.Ij,
																	optionsRecord.Ij,
																	refund,
																	A2($elm$core$Basics$composeR, $author$project$Api$Refund$paymentProcessor, $elm$core$Maybe$Just))),
																A2(
																$author$project$Ui$Typography$strong,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		A2(
																			$elm$core$Maybe$withDefault,
																			'N/A',
																			A2($elm$core$Maybe$andThen, $author$project$Api$Common$Source$Shared$name, source)))
																	])),
																$elm$html$Html$text(' *'),
																$elm$html$Html$text(
																A2(
																	$elm$core$Maybe$withDefault,
																	'',
																	A2($elm$core$Maybe$andThen, $author$project$Api$Common$Source$Shared$lastFour, source)))
															]));
												}
											}
										}(),
											$author$project$Utils$Html$noBreakSpace,
											$author$project$Utils$Html$noBreakSpace,
											function () {
											var _v2 = _Utils_Tuple3(
												optionsRecord.Ij,
												$author$project$Api$Refund$paymentProcessor(refund),
												$author$project$Api$Refund$status(refund));
											_v2$2:
											while (true) {
												_v2$3:
												while (true) {
													_v2$4:
													while (true) {
														if (_v2.b === 'rainforest') {
															switch (_v2.c) {
																case 'pending':
																	return A3(
																		$author$project$Ui$Button$view,
																		{mm: 'Cancel refund'},
																		_List_fromArray(
																			[
																				$author$project$Ui$Button$link,
																				$author$project$Ui$Button$icon($author$project$Ui$Icon$crossCircle),
																				$author$project$Ui$Button$onClick(
																				$author$project$Components$PaymentsList$CancelRefundClicked(
																					_Utils_Tuple2(payment, refund)))
																			]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text('Cancel')
																			]));
																case 'cancelled':
																	if (_v2.a) {
																		return $author$project$Utils$Html$empty;
																	} else {
																		break _v2$4;
																	}
																case 'failed':
																	if (_v2.a) {
																		break _v2$2;
																	} else {
																		break _v2$3;
																	}
																default:
																	if (_v2.a) {
																		break _v2$2;
																	} else {
																		break _v2$4;
																	}
															}
														} else {
															if (_v2.c === 'failed') {
																break _v2$3;
															} else {
																break _v2$4;
															}
														}
													}
													return $author$project$Utils$Html$empty;
												}
												return A2(
													$author$project$Ui$Typography$text,
													_List_fromArray(
														[$author$project$Ui$Typography$danger]),
													A2(
														$elm$core$Maybe$withDefault,
														'',
														A2(
															$elm$core$Maybe$map,
															$author$project$Formatters$String$humanize,
															$author$project$Api$Refund$errorMessage(refund))));
											}
											return A3(
												$author$project$Ui$HinterOnly$button,
												{mm: 'View on rainforest'},
												_List_fromArray(
													[
														$author$project$Ui$Button$link,
														$author$project$Ui$Button$onClick(
														$author$project$Components$PaymentsList$OpenRainforestRefundModal(refund))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('View on Rainforest')
													]));
										}(),
											function () {
											var _v3 = _Utils_Tuple2(
												optionsRecord.alx,
												$author$project$Api$Refund$memo(refund));
											if (_v3.a && (!_v3.b.$)) {
												var memo = _v3.b.a;
												return $elm$html$Html$text(' - ' + memo);
											} else {
												return $author$project$Utils$Html$empty;
											}
										}()
										])),
									optionsRecord.uC ? A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											'Created by ' + (A2(
												$elm$core$Maybe$withDefault,
												'this platform',
												A2(
													$elm$core$Maybe$map,
													$author$project$Api$Provider$User$Shared$displayName,
													$author$project$Api$Refund$createdBy(refund))) + (' on ' + A2(
												timeFormatter,
												0,
												$author$project$Api$Refund$createdAt(refund)))))
										])) : $author$project$Utils$Html$empty
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(2)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textRight, $author$project$Ui$Element$textDanger]),
									_List_fromArray(
										[
											($author$project$Api$Refund$status(refund) === 'failed') ? A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[$author$project$Ui$Typography$strike, $author$project$Ui$Typography$muted]),
											'-' + $author$project$Utils$Currency$fromInt(
												$author$project$Api$Refund$amountInCents(refund))) : A2(
											$author$project$Ui$Typography$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													'-' + $author$project$Utils$Currency$fromInt(
														$author$project$Api$Refund$amountInCents(refund)))
												]))
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(1)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('')
								]))
						]))
				]));
	});
var $author$project$Components$PaymentsList$viewPayment = F4(
	function (timeFormatter, optionsRecord, session, payment) {
		var source = $author$project$Api$Payment$source(payment);
		var refunds_ = $author$project$Api$Payment$refunds(payment);
		var cardReader = $author$project$Api$Payment$cardReader(payment);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('payment__item')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(2)
								]),
							_List_fromArray(
								[
									function () {
									var _v0 = $author$project$Api$Payment$paidAt(payment);
									if (!_v0.$) {
										var paidAt_ = _v0.a;
										return $elm$html$Html$text(
											A2(timeFormatter, 5, paidAt_));
									} else {
										return $elm$html$Html$text(
											A2(
												timeFormatter,
												5,
												$author$project$Api$Payment$createdAt(payment)));
									}
								}()
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(5)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Badge$fromString,
											_List_Nil,
											$author$project$Api$Payment$status(payment)),
											$author$project$Api$Payment$external(payment) ? $elm$html$Html$text(' with ') : $elm$html$Html$text(' on '),
											A2(
											$author$project$Components$PaymentSourceDisplayer$view,
											timeFormatter,
											_List_fromArray(
												[
													$author$project$Components$PaymentSourceDisplayer$source(
													A2($elm$core$Maybe$map, $author$project$Api$Source$Source, source)),
													$author$project$Components$PaymentSourceDisplayer$cardReader(
													A2($elm$core$Maybe$map, $elm$core$Basics$identity, cardReader)),
													$author$project$Components$PaymentSourceDisplayer$limitedView(true),
													$author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus(true),
													$author$project$Components$PaymentSourceDisplayer$showProcessor(optionsRecord.Ij),
													$author$project$Components$PaymentSourceDisplayer$paymentProcessor(
													$author$project$Api$Payment$paymentProcessor(payment))
												])),
											function () {
											var _v1 = _Utils_Tuple2(
												$author$project$Api$Payment$status(payment),
												$author$project$Api$Payment$errorMessage(payment));
											if ((_v1.a === 'failed') && (!_v1.b.$)) {
												return A2($elm$html$Html$br, _List_Nil, _List_Nil);
											} else {
												return $author$project$Utils$Html$empty;
											}
										}(),
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
											_List_fromArray(
												[
													function () {
													var _v2 = $author$project$Api$Payment$status(payment);
													switch (_v2) {
														case 'failed':
															return A2(
																$author$project$Ui$Element$view,
																_List_Nil,
																_List_fromArray(
																	[
																		A2(
																		$author$project$Ui$Typography$text,
																		_List_fromArray(
																			[$author$project$Ui$Typography$danger]),
																		A2(
																			$elm$core$Maybe$withDefault,
																			'',
																			A2(
																				$elm$core$Maybe$map,
																				$author$project$Formatters$String$humanize,
																				$author$project$Api$Payment$errorMessage(payment)))),
																		$author$project$Utils$Html$noBreakSpace,
																		A2(
																		$author$project$Components$PaymentFailedRecommendation$view,
																		$author$project$Api$Payment$errorCode(payment),
																		$elm$core$Maybe$Just(
																			$author$project$Api$Payment$paymentProcessor(payment)))
																	]));
														case 'disputed':
															var _v3 = _Utils_Tuple2(
																optionsRecord.aeS,
																$author$project$Api$Platform$Session$One$userIsPracticeAdmin(session));
															if (_v3.a && _v3.b) {
																return A3(
																	$author$project$Ui$Button$view,
																	{mm: 'View dispute'},
																	_List_fromArray(
																		[
																			$author$project$Ui$Button$link,
																			$author$project$Ui$Button$onClick(
																			$author$project$Components$PaymentsList$OpenPaymentDisputeModal(payment))
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('View Dispute')
																		]));
															} else {
																return $author$project$Utils$Html$empty;
															}
														default:
															return $author$project$Utils$Html$empty;
													}
												}(),
													function () {
													var _v4 = _Utils_Tuple2(
														optionsRecord.Ij,
														$author$project$Api$Payment$paymentProcessor(payment));
													if (_v4.a && (_v4.b === 'rainforest')) {
														return A3(
															$author$project$Ui$HinterOnly$button,
															{mm: 'View on rainforet '},
															_List_fromArray(
																[
																	$author$project$Ui$Button$link,
																	$author$project$Ui$Button$onClick(
																	$author$project$Components$PaymentsList$OpenRainforestPaymentModal(payment))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('View on Rainforest')
																]));
													} else {
														return $author$project$Utils$Html$empty;
													}
												}(),
													function () {
													var _v5 = _Utils_Tuple3(
														optionsRecord.Ij,
														$author$project$Api$Payment$paymentProcessor(payment),
														$author$project$Api$Payment$status(payment));
													if ((_v5.a && (_v5.b === 'rainforest')) && (_v5.c === 'paid')) {
														return A3(
															$author$project$Ui$HinterOnly$button,
															{mm: 'Simulate dispute'},
															_List_fromArray(
																[
																	$author$project$Ui$Button$link,
																	$author$project$Ui$Button$onClick(
																	$author$project$Components$PaymentsList$OpenSimulateDisputeModal(payment))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Simulate Dispute')
																]));
													} else {
														return $author$project$Utils$Html$empty;
													}
												}(),
													function () {
													var _v6 = _Utils_Tuple3(
														optionsRecord.Ij,
														$author$project$Api$Payment$paymentProcessor(payment),
														$author$project$Api$Payment$dispute(payment));
													if ((_v6.a && (_v6.b === 'rainforest')) && (!_v6.c.$)) {
														var dispute = _v6.c.a;
														return (($author$project$Api$Dispute$status(dispute) !== 'won') && ($author$project$Api$Dispute$status(dispute) !== 'lost')) ? A3(
															$author$project$Ui$HinterOnly$button,
															{mm: 'Simulate dispute'},
															_List_fromArray(
																[
																	$author$project$Ui$Button$link,
																	$author$project$Ui$Button$onClick(
																	A2($author$project$Components$PaymentsList$OpenSimulateDisputeEventModal, payment, dispute))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Simulate Dispute Event')
																])) : $author$project$Utils$Html$empty;
													} else {
														return $author$project$Utils$Html$empty;
													}
												}(),
													function () {
													var _v7 = _Utils_Tuple3(
														$author$project$Api$Payment$paymentProcessor(payment),
														$author$project$Api$Payment$status(payment),
														$author$project$Api$Payment$isCancelable(payment));
													if (((_v7.a === 'rainforest') && (_v7.b === 'paid')) && _v7.c) {
														return A2(
															$author$project$Ui$Element$view,
															_List_fromArray(
																[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap]),
															_List_fromArray(
																[
																	A3(
																	$author$project$Ui$Button$view,
																	{mm: 'Cancel payment'},
																	_List_fromArray(
																		[
																			$author$project$Ui$Button$onClick(
																			$author$project$Components$PaymentsList$CancelPayment(payment)),
																			$author$project$Ui$Button$link,
																			$author$project$Ui$Button$icon($author$project$Ui$Icon$crossCircle)
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Cancel')
																		])),
																	A3(
																	$author$project$Ui$Tooltip$view,
																	_List_Nil,
																	'Payment can be cancelled until 10PM EST',
																	_List_fromArray(
																		[
																			$author$project$Ui$Icon$help(_List_Nil)
																		]))
																]));
													} else {
														return $author$project$Utils$Html$empty;
													}
												}()
												])),
											function () {
											var _v8 = $author$project$Api$Payment$memo(payment);
											if (!_v8.$) {
												var memo = _v8.a;
												return A2(
													$author$project$Ui$Typography$text,
													_List_fromArray(
														[
															$author$project$Ui$Typography$phi(true)
														]),
													' - ' + memo);
											} else {
												return $author$project$Utils$Html$empty;
											}
										}(),
											optionsRecord.uC ? A2(
											$author$project$Ui$Typography$p,
											_List_fromArray(
												[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													'Created by ' + (A2(
														$elm$core$Maybe$withDefault,
														'this platform',
														A2(
															$elm$core$Maybe$map,
															$author$project$Api$Provider$Payment$Creator$displayName,
															$author$project$Api$Payment$createdBy(payment))) + (' on ' + A2(
														timeFormatter,
														0,
														$author$project$Api$Payment$createdAt(payment)))))
												])) : $author$project$Utils$Html$empty
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(2)
								]),
							_List_fromArray(
								[
									function () {
									var isNotBankTransfers = !_Utils_eq(
										A2($elm$core$Maybe$andThen, $author$project$Api$Common$Source$Shared$type_, source),
										$elm$core$Maybe$Just('BankTransfer'));
									return ($author$project$Api$Payment$isRefundable(payment) && (optionsRecord.aeV && isNotBankTransfers)) ? A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$textRight]),
										_List_fromArray(
											[
												function () {
												var verb = $author$project$Api$Payment$external(payment) ? 'Record Refund' : 'Process Refund';
												return A3(
													$author$project$Ui$Button$view,
													{mm: verb},
													_List_fromArray(
														[
															$author$project$Ui$Button$link,
															$author$project$Ui$Button$sm,
															$author$project$Ui$Button$onClick(
															$author$project$Components$PaymentsList$Refund(payment))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(verb)
														]));
											}()
											])) : $author$project$Utils$Html$empty;
								}(),
									($author$project$Api$Payment$external(payment) && (($author$project$Api$Payment$status(payment) === 'paid') && A2(
									$elm$core$List$all,
									function (r) {
										return $author$project$Api$Refund$status(r) === 'failed';
									},
									refunds_))) ? A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textRight]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{mm: 'Delete payment'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$sm,
													$author$project$Ui$Button$onClick(
													$author$project$Components$PaymentsList$DeleteExternalPayment(payment))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Delete')
												]))
										])) : $author$project$Utils$Html$empty
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(2)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textRight]),
									_List_fromArray(
										[
											_Utils_eq(
											$author$project$Api$Payment$attemptedInCents(payment),
											$author$project$Api$Payment$amountInCents(payment)) ? $author$project$Utils$Html$empty : A2(
											$author$project$Ui$Element$view,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$text,
													_List_fromArray(
														[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$strike]),
													$author$project$Utils$Currency$fromInt(
														$author$project$Api$Payment$attemptedInCents(payment)))
												])),
											A2(
											$author$project$Ui$Typography$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Utils$Currency$fromInt(
														$author$project$Api$Payment$amountInCents(payment)))
												]))
										])),
									A2(
									$elm$core$Maybe$withDefault,
									false,
									A2($elm$core$Maybe$map, $author$project$Api$Common$Source$Shared$oneTimeUse, source)) ? A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[
											$author$project$Ui$Typography$small,
											$author$project$Ui$Typography$muted,
											$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
										]),
									'One time use') : $author$project$Utils$Html$empty
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(1)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('')
								]))
						])),
					$elm$core$List$isEmpty(refunds_) ? $author$project$Utils$Html$empty : A2(
					$elm$html$Html$div,
					_List_Nil,
					A2(
						$elm$core$List$map,
						A4($author$project$Components$PaymentsList$viewRefund, timeFormatter, source, optionsRecord, payment),
						refunds_))
				]));
	});
var $author$project$Components$PaymentsList$view = F3(
	function (options, payments, _v0) {
		var timeFormatter = _v0.J7;
		var session = _v0.aa4;
		var optionsRecord = $author$project$Components$PaymentsList$optionsToRecord(options);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('payments-list')
						]),
					A2(
						$elm$core$List$map,
						A3($author$project$Components$PaymentsList$viewPayment, timeFormatter, optionsRecord, session),
						payments))
				]));
	});
var $author$project$Ui$Popover$viewAsClickable = F4(
	function (options, displayedContent, sections, _v0) {
		var model = _v0;
		return A4(
			$author$project$Ui$Popover$popoverView,
			options,
			displayedContent,
			sections,
			$elm$core$Maybe$Just(model));
	});
var $author$project$Ui$Popover$Visible = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Popover$visible = $author$project$Ui$Popover$Visible;
var $author$project$Components$Invoice$PaymentsHistory$view = F2(
	function (_v0, model) {
		var allowRefunds = _v0.aeV;
		var showRefundMemo = _v0.alx;
		var isHintAdmin = _v0.Ij;
		var allowDisputes = _v0.aeS;
		var payments = _v0.Zi;
		return $elm$core$List$isEmpty(payments) ? $author$project$Utils$Html$empty : A4(
			$author$project$Ui$Popover$viewAsClickable,
			_List_fromArray(
				[
					$author$project$Ui$Popover$lg,
					$author$project$Ui$Popover$visible(
					$author$project$Ui$Popover$isOpen(model.aT))
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{mm: 'View payment\'s history'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$onClick($author$project$Components$Invoice$PaymentsHistory$Toggle)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Payment History')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Popover$heading,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Payment History')
						])),
					A2(
					$author$project$Ui$Popover$body,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Components$Invoice$PaymentsHistory$PaymentsListMsg,
							A3(
								$author$project$Components$PaymentsList$view,
								_List_fromArray(
									[
										$author$project$Components$PaymentsList$allowRefunds(allowRefunds),
										$author$project$Components$PaymentsList$showRefundMemo(showRefundMemo),
										$author$project$Components$PaymentsList$isHintAdmin(isHintAdmin),
										$author$project$Components$PaymentsList$allowDisputes(allowDisputes)
									]),
								payments,
								model.kD))
						]))
				]),
			model.aT);
	});
var $elm$html$Html$ol = _VirtualDom_node('ol');
var $author$project$Ui$Breadcrumb$itemOptionToAttributes = function (option) {
	var bool = option;
	return _List_fromArray(
		[
			$elm$html$Html$Attributes$classList(
			_List_fromArray(
				[
					_Utils_Tuple2('active', bool)
				]))
		]);
};
var $author$project$Ui$Breadcrumb$itemOptionsToAttributes = function (options) {
	return A2(
		$elm$core$List$map,
		$elm$html$Html$Attributes$map($elm$core$Basics$never),
		A2($elm$core$List$concatMap, $author$project$Ui$Breadcrumb$itemOptionToAttributes, options));
};
var $author$project$Ui$Breadcrumb$viewItem = function (_v0) {
	var options = _v0.a;
	var contents = _v0.b;
	return A2(
		$elm$html$Html$li,
		$author$project$Ui$Breadcrumb$itemOptionsToAttributes(options),
		contents);
};
var $author$project$Ui$Breadcrumb$view = F2(
	function (_v0, items) {
		return A2(
			$elm$html$Html$ol,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('breadcrumb')
				]),
			A2($elm$core$List$map, $author$project$Ui$Breadcrumb$viewItem, items));
	});
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Delete = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Issue = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$OpenAdjustModal = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Pay = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$RecordPayment = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Void = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$PracticeInvoice$Meta$adjustAction = function (_v0) {
	var meta = _v0;
	return meta.vy.La;
};
var $author$project$Ui$Icon$ArrowLeft = 65;
var $author$project$Ui$Icon$arrowLeft = $author$project$Ui$Icon$viewIcon(65);
var $author$project$Ui$Link$ButtonSuccess = 1;
var $author$project$Ui$Link$buttonSuccess = $author$project$Ui$Link$Style(1);
var $author$project$Ui$Dropdown$Button = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Dropdown$Warning = 2;
var $author$project$Ui$Dropdown$buttonWarning = $author$project$Ui$Dropdown$Button(2);
var $author$project$Api$Provider$PracticeInvoice$Meta$cancelAction = function (_v0) {
	var meta = _v0;
	return meta.vy.Nl;
};
var $author$project$Api$Provider$PracticeInvoice$Meta$destroyAction = function (_v0) {
	var meta = _v0;
	return meta.vy.Qu;
};
var $author$project$Ui$Icon$Dollar = 56;
var $author$project$Ui$Icon$dollarSign = $author$project$Ui$Icon$viewIcon(56);
var $author$project$Ui$Dropdown$view = F4(
	function (options, content, items, model) {
		var toMsg = model.al6;
		var optionsRecord = $author$project$Ui$Dropdown$optionsToRecord(options);
		if (optionsRecord.V8) {
			return $author$project$Ui$Skeleton$input(
				_List_fromArray(
					[
						$author$project$Ui$Skeleton$span(2)
					]));
		} else {
			var errorDescription = $elm$core$List$isEmpty(optionsRecord.agX) ? _List_Nil : _List_fromArray(
				[
					A2(
					$elm$html$Html$Attributes$attribute,
					'aria-describedby',
					A2($elm$core$String$join, '. ', optionsRecord.agX))
				]);
			var ariaInvalid = (optionsRecord.sM || (!$elm$core$List$isEmpty(optionsRecord.agX))) ? _List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'aria-invalid', 'true')
				]) : _List_Nil;
			var buttonAttributes = A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('dropdown__trigger'),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$tabindex(0),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$id(model.ahP + '-trigger'),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$type_('button'),
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$class(
									A2(
										$elm$core$String$join,
										' ',
										_Utils_ap(optionsRecord.mA, optionsRecord.xH))),
								A2(
									$elm$core$List$cons,
									$elm$core$String$isEmpty(optionsRecord.mm) ? $elm$html$Html$Attributes$class('') : A2($elm$html$Html$Attributes$attribute, 'aria-label', optionsRecord.mm),
									_Utils_ap(
										optionsRecord.ep ? _List_fromArray(
											[
												A2($elm$html$Html$Attributes$attribute, 'aria-disabled', 'true')
											]) : (optionsRecord.ua ? _List_fromArray(
											[
												$elm$html$Html$Attributes$readonly(true)
											]) : _List_fromArray(
											[
												$author$project$Ui$Dropdown$triggerKeyHandlers(toMsg),
												$elm$html$Html$Events$onClick(
												toMsg($author$project$Ui$Dropdown$DropdownButtonClicked))
											])),
										_Utils_ap(errorDescription, ariaInvalid))))))));
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dropdown'),
						$elm$html$Html$Attributes$id(model.ahP),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('dropdown--open', model.Yn && (!optionsRecord.ep)),
								_Utils_Tuple2('dropdown--invalid', optionsRecord.sM),
								_Utils_Tuple2('dropdown--disabled', optionsRecord.ep)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						buttonAttributes,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('inline-flex gap-1 items-center')
									]),
								A2(
									$elm$core$List$map,
									$elm$html$Html$map($elm$core$Basics$never),
									content)),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('dropdown__trigger__chevron'),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'ml-1 ',
												!$elm$core$List$isEmpty(content))
											]))
									]),
								_List_fromArray(
									[
										$author$project$Ui$Icon$chevronDown(
										_List_fromArray(
											[$author$project$Ui$Icon$xs]))
									]))
							])),
						optionsRecord.ep ? $elm$html$Html$text('') : A3($author$project$Ui$Dropdown$viewMenu, toMsg, model, items)
					]));
		}
	});
var $author$project$Ui$HinterOnly$dropdown = F4(
	function (options, content, items, dropdownModel) {
		return A4(
			$author$project$Ui$Dropdown$view,
			options,
			A2(
				$elm$core$List$cons,
				$author$project$Ui$HinterOnly$icon(
					_List_fromArray(
						[$author$project$Ui$Icon$spacedRight])),
				content),
			items,
			dropdownModel);
	});
var $author$project$Ui$Icon$Eraser = 105;
var $author$project$Ui$Icon$eraser = $author$project$Ui$Icon$viewIcon(105);
var $author$project$Api$Common$Source$Shared$external = function (_v0) {
	var record = _v0;
	return record.R5;
};
var $author$project$Ui$Element$InlineBlock = 1;
var $author$project$Ui$Element$inlineBlock = A2($author$project$Ui$Element$Display, 0, 1);
var $author$project$Api$Provider$PracticeInvoice$Meta$issueAction = function (_v0) {
	var meta = _v0;
	return meta.vy.Vm;
};
var $author$project$Api$Provider$PracticeInvoice$Shared$meta = function (_v0) {
	var record = _v0;
	return record.W4;
};
var $author$project$Api$Provider$PracticeInvoice$One$meta = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PracticeInvoice$Shared$meta(shared);
};
var $author$project$Ui$Element$mr4 = $author$project$Ui$Element$Margin('mr-4');
var $author$project$Api$Provider$PracticeInvoice$Meta$paymentsProcessAction = function (_v0) {
	var meta = _v0;
	return meta.vy.Zk;
};
var $author$project$Api$Provider$PracticeInvoice$Meta$refundAction = function (_v0) {
	var meta = _v0;
	return meta.vy.$m;
};
var $author$project$Api$Provider$PracticeInvoice$One$securePdfInlineToken = function (_v0) {
	var record = _v0.b;
	return record.aaE;
};
var $author$project$Ui$Button$success = $author$project$Ui$Button$Styled(3);
var $author$project$Ui$Icon$Export = 53;
var $author$project$Ui$Icon$export = $author$project$Ui$Icon$viewIcon(53);
var $author$project$Components$Invoice$DownloadFile$defaultOptions = {ahO: true, aih: $elm$core$Maybe$Nothing, FS: true};
var $author$project$Components$Invoice$DownloadFile$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				if (!option.$) {
					var string = option.a;
					return _Utils_update(
						record,
						{
							aih: $elm$core$Maybe$Just(string)
						});
				} else {
					var bool = option.a;
					return _Utils_update(
						record,
						{FS: bool});
				}
			}),
		$author$project$Components$Invoice$DownloadFile$defaultOptions,
		options);
};
var $author$project$Components$Invoice$DownloadFile$viewModal = A3(
	$author$project$Ui$Modal$view,
	$author$project$Components$Invoice$DownloadFile$CloseModal,
	_List_Nil,
	_List_fromArray(
		[
			$author$project$Ui$Modal$header(
			_List_fromArray(
				[
					$author$project$Ui$Modal$title('In Progress')
				])),
			$author$project$Ui$Modal$body(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Your file is being processed and may take a few seconds.')
						])),
					$author$project$Ui$Spinner$view(_List_Nil)
				]))
		]));
var $author$project$Components$Invoice$DownloadFile$view = F4(
	function (model, token, options, buttonOptions) {
		var optionsRecord = $author$project$Components$Invoice$DownloadFile$optionsToRecord(options);
		var _v0 = _Utils_Tuple2('Download', $author$project$Ui$Icon$export);
		var verb = _v0.a;
		var icon_ = _v0.b;
		var buttonLabel = function () {
			var _v1 = optionsRecord.aih;
			if (!_v1.$) {
				var label_ = _v1.a;
				return label_;
			} else {
				return verb;
			}
		}();
		var link = A3(
			$author$project$Ui$Button$view,
			{mm: buttonLabel},
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Button$onClick(
					$author$project$Components$Invoice$DownloadFile$DownloadFileClicked(token)),
				A2(
					$elm$core$List$cons,
					$author$project$Ui$Button$icon(icon_),
					buttonOptions)),
			_List_fromArray(
				[
					$elm$html$Html$text(buttonLabel)
				]));
		var button = optionsRecord.FS ? A3(
			$author$project$Ui$Tooltip$view,
			_List_Nil,
			verb + ' PDF',
			_List_fromArray(
				[link])) : link;
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('inline text-left')
				]),
			_List_fromArray(
				[
					button,
					model.U5 ? $author$project$Components$Invoice$DownloadFile$viewModal : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$viewActions = F5(
	function (practiceInvoice, isHintAdmin, saveRequest, dropdownMenu, downloadInvoice) {
		var meta = $author$project$Api$Provider$PracticeInvoice$One$meta(practiceInvoice);
		var actions = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					function () {
					if ($author$project$Api$Provider$PracticeInvoice$Meta$cancelAction(meta)) {
						var voidText = function () {
							var _v1 = $author$project$Api$Provider$PracticeInvoice$One$status(practiceInvoice);
							if (!_v1) {
								return 'Void & Refund';
							} else {
								return 'Void';
							}
						}();
						return $elm$core$Maybe$Just(
							A2(
								$author$project$Ui$Dropdown$item,
								_List_fromArray(
									[
										$author$project$Ui$Dropdown$onSelect(
										$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Void(practiceInvoice))
									]),
								A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
									_List_fromArray(
										[
											$author$project$Ui$Icon$eraser(_List_Nil),
											$elm$html$Html$text(voidText)
										]))));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}(),
					$author$project$Api$Provider$PracticeInvoice$Meta$issueAction(meta) ? $elm$core$Maybe$Just(
					A2(
						$author$project$Ui$Dropdown$item,
						_List_fromArray(
							[
								$author$project$Ui$Dropdown$onSelect(
								$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Issue(practiceInvoice))
							]),
						A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									$author$project$Ui$Icon$arrowLeft(_List_Nil),
									$elm$html$Html$text('Return To Issued')
								])))) : $elm$core$Maybe$Nothing,
					$author$project$Api$Provider$PracticeInvoice$Meta$adjustAction(meta) ? $elm$core$Maybe$Just(
					A2(
						$author$project$Ui$Dropdown$item,
						_List_fromArray(
							[
								$author$project$Ui$Dropdown$onSelect(
								$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$OpenAdjustModal(practiceInvoice))
							]),
						A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									$author$project$Ui$Icon$dollarSign(_List_Nil),
									$elm$html$Html$text('Add Charge or Credit')
								])))) : $elm$core$Maybe$Nothing,
					$author$project$Api$Provider$PracticeInvoice$Meta$refundAction(meta) ? $elm$core$Maybe$Just(
					A2(
						$author$project$Ui$Dropdown$item,
						_List_fromArray(
							[
								$author$project$Ui$Dropdown$onSelect(
								$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$OpenAdjustModal(practiceInvoice))
							]),
						A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									$author$project$Ui$Icon$dollarSign(_List_Nil),
									$elm$html$Html$text('Add Credit & Refund')
								])))) : $elm$core$Maybe$Nothing
				]));
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mr4]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$DownloadInvoiceMsg,
						A4(
							$author$project$Components$Invoice$DownloadFile$view,
							downloadInvoice,
							$author$project$Api$Provider$PracticeInvoice$One$securePdfInlineToken(practiceInvoice),
							_List_Nil,
							_List_fromArray(
								[$author$project$Ui$Button$link])))
					])),
				((!$elm$core$List$isEmpty(actions)) && isHintAdmin) ? A4(
				$author$project$Ui$HinterOnly$dropdown,
				_List_fromArray(
					[
						$author$project$Ui$Dropdown$disabled(
						_Utils_eq(saveRequest, $author$project$Api$Data$Loading)),
						$author$project$Ui$Dropdown$buttonWarning
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$inlineBlock, $author$project$Ui$Element$ml1]),
						_List_fromArray(
							[
								$elm$html$Html$text('Revise Invoice')
							]))
					]),
				actions,
				dropdownMenu) : $author$project$Utils$Html$empty,
				($author$project$Api$Provider$PracticeInvoice$Meta$destroyAction(meta) && isHintAdmin) ? A3(
				$author$project$Ui$HinterOnly$button,
				{mm: 'Delete practice invoice'},
				_List_fromArray(
					[
						$author$project$Ui$Button$danger,
						$author$project$Ui$Button$onClick(
						$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Delete(practiceInvoice)),
						$author$project$Ui$Button$loading(
						_Utils_eq(saveRequest, $author$project$Api$Data$Loading)),
						$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Delete')
					])) : $author$project$Utils$Html$empty,
				($author$project$Api$Provider$PracticeInvoice$Meta$paymentsProcessAction(meta) && (!$author$project$Utils$Maybe$toBool(
				$author$project$Api$Provider$PracticeInvoice$One$source(practiceInvoice)))) ? A3(
				$author$project$Ui$Link$route,
				$author$project$Spa$Generated$Route$Admin__PaymentSources,
				_List_fromArray(
					[$author$project$Ui$Link$buttonSuccess]),
				_List_fromArray(
					[
						$elm$html$Html$text('Add Payment Source')
					])) : $author$project$Utils$Html$empty,
				($author$project$Api$Provider$PracticeInvoice$Meta$paymentsProcessAction(meta) && isHintAdmin) ? A3(
				$author$project$Ui$HinterOnly$button,
				{mm: 'Record payment'},
				_List_fromArray(
					[
						$author$project$Ui$Button$secondary,
						$author$project$Ui$Button$loading(
						_Utils_eq(saveRequest, $author$project$Api$Data$Loading)),
						$author$project$Ui$Button$onClick(
						$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$RecordPayment(practiceInvoice))
					]),
				_List_fromArray(
					[
						$author$project$Utils$Html$noBreakSpace,
						$elm$html$Html$text('Record Payment')
					])) : $author$project$Utils$Html$empty,
				function () {
				var _v0 = _Utils_Tuple2(
					$author$project$Api$Provider$PracticeInvoice$Meta$paymentsProcessAction(meta),
					$author$project$Api$Provider$PracticeInvoice$One$source(practiceInvoice));
				if (_v0.a && (!_v0.b.$)) {
					var source = _v0.b.a;
					return (!$author$project$Api$Common$Source$Shared$external(source)) ? A3(
						$author$project$Ui$Button$view,
						{mm: 'Pay now'},
						_List_fromArray(
							[
								$author$project$Ui$Button$success,
								$author$project$Ui$Button$loading(
								_Utils_eq(saveRequest, $author$project$Api$Data$Loading)),
								$author$project$Ui$Button$onClick(
								$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Pay(practiceInvoice)),
								$author$project$Ui$Button$icon($author$project$Ui$Icon$bolt)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Pay now')
							])) : $author$project$Utils$Html$empty;
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]);
	});
var $author$project$Api$Provider$PracticeInvoice$One$invoiceType = function (_v0) {
	var record = _v0.b;
	return record.Uv;
};
var $author$project$Ui$Form$Static$Phi = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$Static$phi = $author$project$Ui$Form$Static$Phi;
var $author$project$Api$Provider$PracticeCharge$Shared$serviceDescription = function (_v0) {
	var record = _v0;
	return record.aa0;
};
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$viewCharge = F2(
	function (practiceInvoice, practiceCharge) {
		var showUsageInfo = ($author$project$Api$Provider$PracticeInvoice$One$invoiceType(practiceInvoice) === 'pmpm') && ($author$project$Api$Provider$PracticeCharge$Shared$quantity(practiceCharge) > 1);
		return A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$span(6)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Provider$PracticeCharge$Shared$description(practiceCharge))
										])),
									$author$project$Utils$Html$noBreakSpace,
									showUsageInfo ? A3(
									$author$project$Ui$Tooltip$view,
									_List_Nil,
									'Usage charges are based on the preceding billing period',
									_List_fromArray(
										[
											$author$project$Ui$Icon$help(_List_Nil)
										])) : $author$project$Utils$Html$empty,
									function () {
									var _v0 = $author$project$Api$Provider$PracticeCharge$Shared$serviceDescription(practiceCharge);
									if (!_v0.$) {
										var serviceDescription = _v0.a;
										return A2(
											$author$project$Ui$Form$Static$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Static$phi(true)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(serviceDescription)
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								]))
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$span(2)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textRight]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(
										$author$project$Api$Provider$PracticeCharge$Shared$quantity(practiceCharge)))
								]))
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$span(2)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textRight]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromFloat(
										$author$project$Api$Provider$PracticeCharge$Shared$priceInCents(practiceCharge)))
								]))
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$span(2)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textRight]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$PracticeCharge$Shared$subtotalInCents(practiceCharge)))
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$viewFixedFeeItem = function (practiceCharge) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'padding-left', '2em')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Utils$Currency$fromInt(
					$author$project$Api$Provider$PracticeCharge$Shared$subtotalInCents(practiceCharge)) + (' for ' + $author$project$Api$Provider$PracticeCharge$Shared$description(practiceCharge)))
			]));
};
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$viewFixedFeesCharges = function (practiceCharges) {
	if ($elm$core$List$length(practiceCharges) > 0) {
		var itemsDescriptions = A2($elm$core$List$map, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$viewFixedFeeItem, practiceCharges);
		var fixedFeeSubtotalInCents = $elm$core$List$sum(
			A2($elm$core$List$map, $author$project$Api$Provider$PracticeCharge$Shared$subtotalInCents, practiceCharges));
		return A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$span(6)
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Fixed Fees')
								])),
						itemsDescriptions)),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$span(2)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textRight]),
							_List_fromArray(
								[
									$elm$html$Html$text('1')
								]))
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$span(2)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textRight]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(fixedFeeSubtotalInCents))
								]))
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$span(2)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textRight]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(fixedFeeSubtotalInCents))
								]))
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Api$Provider$PracticeInvoice$One$partner = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PracticeInvoice$Shared$partner(shared);
};
var $author$project$Api$Provider$Partner$Shared$statementDescriptor = function (_v0) {
	var record = _v0;
	return record.acc;
};
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$viewPartnerNote = function (practiceInvoice) {
	var _v0 = $author$project$Api$Provider$PracticeInvoice$One$partner(practiceInvoice);
	if (!_v0.$) {
		var partnerRecord = _v0.a;
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mb4]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Alert$info,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							function () {
								var _v1 = $author$project$Api$Provider$Partner$Shared$statementDescriptor(partnerRecord);
								if (!_v1.$) {
									var descriptor = _v1.a;
									return 'Appears as \'' + (descriptor + '\' on your statement.');
								} else {
									return 'This charge is processed by ' + ($author$project$Api$Provider$Partner$Shared$name(partnerRecord) + '.');
								}
							}())
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$HiConfirm$CustomMessage = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$HiConfirm$customMessage = $author$project$Components$HiConfirm$CustomMessage;
var $author$project$Components$HiConfirm$CustomTitle = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$HiConfirm$customTitle = $author$project$Components$HiConfirm$CustomTitle;
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$voidInvoiceConfirm = F2(
	function (practiceInvoice, voidRequest) {
		var _v0 = $author$project$Api$Provider$PracticeInvoice$One$status(practiceInvoice);
		if (!_v0) {
			var paidInCents = $author$project$Utils$Currency$fromInt(
				$author$project$Api$Provider$PracticeInvoice$One$paidInCents(practiceInvoice));
			var customMessage = $elm$html$Html$text(
				'You are about to void and refund Invoice #' + ($elm$core$String$fromInt(
					$author$project$Api$Provider$PracticeInvoice$One$number(practiceInvoice)) + (' and refund ' + (paidInCents + ' to the practice.'))));
			return A2(
				$author$project$Components$HiConfirm$modal,
				$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$VoidHiConfirmClosed(practiceInvoice),
				_List_fromArray(
					[
						$author$project$Components$HiConfirm$verb('void'),
						$author$project$Components$HiConfirm$customTitle('Void & Refund'),
						$author$project$Components$HiConfirm$customMessage(
						_List_fromArray(
							[
								customMessage,
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								$elm$html$Html$text('This action cannot be undone.')
							])),
						$author$project$Components$HiConfirm$noun('& Refund ' + paidInCents),
						$author$project$Components$HiConfirm$loading(
						_Utils_eq(voidRequest, $author$project$Api$Data$Loading))
					]));
		} else {
			var customMessage = $elm$html$Html$text(
				'You are about to void Invoice #' + ($elm$core$String$fromInt(
					$author$project$Api$Provider$PracticeInvoice$One$number(practiceInvoice)) + '.'));
			return A2(
				$author$project$Components$HiConfirm$modal,
				$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$VoidHiConfirmClosed(practiceInvoice),
				_List_fromArray(
					[
						$author$project$Components$HiConfirm$verb('void'),
						$author$project$Components$HiConfirm$customMessage(
						_List_fromArray(
							[
								customMessage,
								$author$project$Utils$Html$noBreakSpace,
								$elm$html$Html$text('This action cannot be undone.')
							])),
						$author$project$Components$HiConfirm$noun('Invoice'),
						$author$project$Components$HiConfirm$loading(
						_Utils_eq(voidRequest, $author$project$Api$Data$Loading))
					]));
		}
	});
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$viewBody = function (model) {
	return _List_fromArray(
		[
			function () {
			var _v0 = model.i9;
			if (!_v0.$) {
				var _v1 = _v0.a;
				var practiceInvoice = _v1.a;
				var deleteRequest = _v1.b;
				return A2(
					$author$project$Components$HiConfirm$modal,
					$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$DeleteHiConfirmClosed(practiceInvoice),
					_List_fromArray(
						[
							$author$project$Components$HiConfirm$verb('delete'),
							$author$project$Components$HiConfirm$noun(
							'Invoice #' + $elm$core$String$fromInt(
								$author$project$Api$Provider$PracticeInvoice$One$number(practiceInvoice))),
							$author$project$Components$HiConfirm$detail(
							'for ' + $author$project$Utils$Currency$fromInt(
								$author$project$Api$Provider$PracticeInvoice$One$totalInCents(practiceInvoice))),
							$author$project$Components$HiConfirm$loading(
							_Utils_eq(deleteRequest, $author$project$Api$Data$Loading))
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			function () {
			var _v2 = model.vp;
			if (!_v2.$) {
				var _v3 = _v2.a;
				var practiceInvoice = _v3.a;
				var voidRequest = _v3.b;
				return A2($author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$voidInvoiceConfirm, practiceInvoice, voidRequest);
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			function () {
			var _v4 = model.m$;
			if (!_v4.$) {
				var createPaymentModal = _v4.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$CreatePaymentModalMsg,
					$author$project$Components$Invoice$CreatePaymentModal$view(createPaymentModal));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			function () {
			var _v5 = model.iV;
			if (!_v5.$) {
				var modal = _v5.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$CreateChargeModalMsg,
					A2(
						$author$project$Components$HintBilling$CreateChargeModal$view,
						modal,
						$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$chargeModalTitle(model.tV)));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			A2(
			$elm$html$Html$map,
			$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$PaymentsHistoryMsg,
			$author$project$Components$Invoice$PaymentsHistory$modal(model.kC)),
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					function () {
						var _v6 = model.tV;
						if (_v6.$ === 3) {
							var practiceInvoice = _v6.a;
							var _v7 = A2(
								$elm$core$List$partition,
								function (item) {
									return $author$project$Api$Provider$PracticeCharge$Shared$fromRecurringCharge(item);
								},
								$author$project$Api$Provider$PracticeInvoice$One$charges(practiceInvoice));
							var fixedFeeCharges = _v7.a;
							var nonFixedFeeCharges = _v7.b;
							return $elm$core$List$concat(
								_List_fromArray(
									[
										_List_fromArray(
										[
											A2(
											$elm$html$Html$map,
											$elm$core$Basics$never,
											A2(
												$author$project$Ui$Breadcrumb$view,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Breadcrumb$item,
														_List_Nil,
														_List_fromArray(
															[
																A3(
																$author$project$Ui$Link$route,
																$author$project$Spa$Generated$Route$Admin__Billing,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('Billing')
																	]))
															])),
														A2(
														$author$project$Ui$Breadcrumb$item,
														_List_fromArray(
															[
																$author$project$Ui$Breadcrumb$active(true)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																'#' + $elm$core$String$fromInt(
																	$author$project$Api$Provider$PracticeInvoice$One$number(practiceInvoice)))
															]))
													]))),
											$author$project$Ui$HorizontalRule$view(_List_Nil),
											$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$viewPartnerNote(practiceInvoice),
											A2(
											$author$project$Ui$Grid$row,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Grid$column,
													_List_fromArray(
														[
															$author$project$Ui$Grid$span(6)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Element$view,
															_List_fromArray(
																[$author$project$Ui$Element$mb2]),
															_List_fromArray(
																[
																	$author$project$Ui$Typography$heading(
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Invoice '),
																			$elm$html$Html$text(
																			'#' + $elm$core$String$fromInt(
																				$author$project$Api$Provider$PracticeInvoice$One$number(practiceInvoice)))
																		]))
																])),
															$author$project$Ui$Typography$headingSm(
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Utils$Currency$fromInt(
																		$author$project$Api$Provider$PracticeInvoice$One$totalInCents(practiceInvoice))),
																	$author$project$Utils$Html$noBreakSpace,
																	$author$project$Api$Provider$PracticeInvoice$Status$toBadge(
																	$author$project$Api$Provider$PracticeInvoice$One$status(practiceInvoice))
																]))
														])),
													A2(
													$author$project$Ui$Grid$column,
													_List_fromArray(
														[
															$author$project$Ui$Grid$span(6)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Element$view,
															_List_fromArray(
																[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
															A5($author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$viewActions, practiceInvoice, model.Ij, model.k9, model.no, model.jt))
														]))
												])),
											A2(
											$author$project$Ui$Grid$row,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Grid$column,
													_List_fromArray(
														[
															$author$project$Ui$Grid$span(6)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Form$Group$view,
															_List_fromArray(
																[
																	$author$project$Ui$Form$Group$label('Payer'),
																	$author$project$Ui$Form$Group$labelSpan(4),
																	$author$project$Ui$Form$Group$inputSpan(8)
																]),
															_List_fromArray(
																[
																	A2(
																	$author$project$Ui$Form$Static$view,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Api$Provider$Practice$One$name(model.ZV)),
																			function () {
																			var _v8 = A2(
																				$elm$core$Maybe$andThen,
																				$author$project$Api$Common$Phone$Shared$number,
																				$elm$core$List$head(
																					$author$project$Api$Provider$Practice$One$phones(model.ZV)));
																			if (!_v8.$) {
																				var phoneNumber = _v8.a;
																				return A2(
																					$author$project$Ui$Element$view,
																					_List_fromArray(
																						[$author$project$Ui$Element$phi]),
																					_List_fromArray(
																						[
																							$elm$html$Html$text(
																							$author$project$Formatters$Phone$format(phoneNumber))
																						]));
																			} else {
																				return $author$project$Utils$Html$empty;
																			}
																		}(),
																			function () {
																			var _v9 = $author$project$Api$Provider$Practice$One$address(model.ZV);
																			if (!_v9.$) {
																				var address = _v9.a;
																				return $author$project$Components$AddressDisplay$view(address);
																			} else {
																				return $author$project$Utils$Html$empty;
																			}
																		}()
																		]))
																]))
														])),
													A2(
													$author$project$Ui$Grid$column,
													_List_fromArray(
														[
															$author$project$Ui$Grid$span(6)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Form$Group$view,
															_List_fromArray(
																[
																	$author$project$Ui$Form$Group$label('Invoice Date'),
																	$author$project$Ui$Form$Group$labelSpan(4),
																	$author$project$Ui$Form$Group$inputSpan(8)
																]),
															_List_fromArray(
																[
																	A2(
																	$author$project$Ui$Form$Static$view,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			A2(
																				$author$project$Formatters$Date$toString,
																				$author$project$Formatters$Date$Full,
																				$author$project$Api$Provider$PracticeInvoice$One$date(practiceInvoice)))
																		]))
																])),
															function () {
															var _v10 = $author$project$Api$Provider$PracticeInvoice$One$purchaseOrderNumber(practiceInvoice);
															if (!_v10.$) {
																var purchaseOrderNumber = _v10.a;
																return A2(
																	$author$project$Ui$Form$Group$view,
																	_List_fromArray(
																		[
																			$author$project$Ui$Form$Group$label('PO #'),
																			$author$project$Ui$Form$Group$labelSpan(4),
																			$author$project$Ui$Form$Group$inputSpan(8)
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$author$project$Ui$Form$Static$view,
																			_List_Nil,
																			_List_fromArray(
																				[
																					$elm$html$Html$text(purchaseOrderNumber)
																				]))
																		]));
															} else {
																return $author$project$Utils$Html$empty;
															}
														}(),
															A2(
															$author$project$Ui$Form$Group$view,
															_List_fromArray(
																[
																	$author$project$Ui$Form$Group$label('Autopay'),
																	$author$project$Ui$Form$Group$labelSpan(4),
																	$author$project$Ui$Form$Group$inputSpan(8)
																]),
															_List_fromArray(
																[
																	A2(
																	$author$project$Ui$Form$Static$view,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Formatters$Bool$toString(
																				$author$project$Api$Provider$PracticeInvoice$One$autoPayEnabled(practiceInvoice)))
																		]))
																])),
															$author$project$Api$Provider$PracticeInvoice$One$autoPayEnabled(practiceInvoice) ? A2(
															$author$project$Ui$Form$Group$view,
															_List_fromArray(
																[
																	$author$project$Ui$Form$Group$label('Autopay On'),
																	$author$project$Ui$Form$Group$labelSpan(4),
																	$author$project$Ui$Form$Group$inputSpan(8)
																]),
															_List_fromArray(
																[
																	A2(
																	$author$project$Ui$Form$Static$view,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			A2(
																				$elm$core$Maybe$withDefault,
																				'',
																				A2(
																					$elm$core$Maybe$map,
																					$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
																					$author$project$Api$Provider$PracticeInvoice$One$autoPayDate(practiceInvoice))))
																		]))
																])) : $author$project$Utils$Html$empty,
															A2(
															$author$project$Ui$Form$Group$view,
															_List_fromArray(
																[
																	$author$project$Ui$Form$Group$label('Payment Source'),
																	$author$project$Ui$Form$Group$labelSpan(4),
																	$author$project$Ui$Form$Group$inputSpan(8)
																]),
															_List_fromArray(
																[
																	A2(
																	$author$project$Ui$Form$Static$view,
																	_List_Nil,
																	_List_fromArray(
																		[
																			function () {
																			var _v11 = $author$project$Api$Provider$PracticeInvoice$One$source(practiceInvoice);
																			if (!_v11.$) {
																				var source = _v11.a;
																				return A2(
																					$author$project$Components$PaymentSourceDisplayer$view,
																					model.J7,
																					_List_fromArray(
																						[
																							$author$project$Components$PaymentSourceDisplayer$source(
																							$elm$core$Maybe$Just(
																								$author$project$Api$Source$Source(source))),
																							$author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus(true),
																							$author$project$Components$PaymentSourceDisplayer$limitedView(true)
																						]));
																			} else {
																				return A2($author$project$Ui$Badge$fromString, _List_Nil, 'none');
																			}
																		}()
																		]))
																])),
															A2(
															$author$project$Ui$Form$Group$view,
															_List_fromArray(
																[
																	$author$project$Ui$Form$Group$label('Total Paid'),
																	$author$project$Ui$Form$Group$labelSpan(4),
																	$author$project$Ui$Form$Group$inputSpan(8)
																]),
															_List_fromArray(
																[
																	A2(
																	$author$project$Ui$Form$Static$view,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			$author$project$Ui$Typography$strong,
																			_List_Nil,
																			_List_fromArray(
																				[
																					$elm$html$Html$text(
																					$author$project$Utils$Currency$fromInt(
																						$author$project$Api$Provider$PracticeInvoice$One$paidInCents(practiceInvoice))),
																					function () {
																					if (!$author$project$Api$Provider$PracticeInvoice$One$status(practiceInvoice)) {
																						var showPaymentTime = true;
																						var format = showPaymentTime ? 2 : 6;
																						return $elm$html$Html$text(
																							' on ' + A2(
																								$elm$core$Maybe$withDefault,
																								'N/A',
																								A2(
																									$elm$core$Maybe$map,
																									model.J7(format),
																									$author$project$Api$Provider$PracticeInvoice$One$paidAt(practiceInvoice))));
																					} else {
																						return $author$project$Utils$Html$empty;
																					}
																				}()
																				]))
																		])),
																	A2(
																	$elm$html$Html$map,
																	$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$PaymentsHistoryMsg,
																	A2(
																		$author$project$Components$Invoice$PaymentsHistory$view,
																		{
																			aeS: model.Ij,
																			aeV: model.Ij,
																			Ij: model.Ij,
																			Zi: A2(
																				$elm$core$List$map,
																				$author$project$Api$Payment$Provider_One,
																				$author$project$Api$Provider$PracticeInvoice$One$payments(practiceInvoice)),
																			alx: false
																		},
																		model.kC))
																])),
															A2(
															$author$project$Ui$Form$Group$view,
															_List_fromArray(
																[
																	$author$project$Ui$Form$Group$label('Total Due'),
																	$author$project$Ui$Form$Group$labelSpan(4),
																	$author$project$Ui$Form$Group$inputSpan(8)
																]),
															_List_fromArray(
																[
																	A2(
																	$author$project$Ui$Form$Static$view,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			$author$project$Ui$Typography$strong,
																			_List_Nil,
																			_List_fromArray(
																				[
																					$elm$html$Html$text(
																					$author$project$Utils$Currency$fromInt(
																						$author$project$Api$Provider$PracticeInvoice$One$dueInCents(practiceInvoice)))
																				]))
																		]))
																]))
														]))
												])),
											$author$project$Ui$HorizontalRule$view(_List_Nil),
											A2(
											$author$project$Ui$Grid$row,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Grid$column,
													_List_fromArray(
														[
															$author$project$Ui$Grid$span(6)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Typography$text,
															_List_fromArray(
																[$author$project$Ui$Typography$hintLabel, $author$project$Ui$Typography$muted]),
															'Charges')
														])),
													A2(
													$author$project$Ui$Grid$column,
													_List_fromArray(
														[
															$author$project$Ui$Grid$span(2)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Element$view,
															_List_fromArray(
																[$author$project$Ui$Element$textRight]),
															_List_fromArray(
																[
																	A2(
																	$author$project$Ui$Typography$text,
																	_List_fromArray(
																		[$author$project$Ui$Typography$hintLabel]),
																	'Qty')
																]))
														])),
													A2(
													$author$project$Ui$Grid$column,
													_List_fromArray(
														[
															$author$project$Ui$Grid$span(2)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Element$view,
															_List_fromArray(
																[$author$project$Ui$Element$textRight]),
															_List_fromArray(
																[
																	A2(
																	$author$project$Ui$Typography$text,
																	_List_fromArray(
																		[$author$project$Ui$Typography$hintLabel]),
																	'Price')
																]))
														])),
													A2(
													$author$project$Ui$Grid$column,
													_List_fromArray(
														[
															$author$project$Ui$Grid$span(2)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Element$view,
															_List_fromArray(
																[$author$project$Ui$Element$textRight]),
															_List_fromArray(
																[
																	A2(
																	$author$project$Ui$Typography$text,
																	_List_fromArray(
																		[$author$project$Ui$Typography$hintLabel]),
																	'Amount')
																]))
														]))
												]))
										]),
										A2(
										$elm$core$List$cons,
										$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$viewFixedFeesCharges(fixedFeeCharges),
										A2(
											$elm$core$List$map,
											$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$viewCharge(practiceInvoice),
											nonFixedFeeCharges)),
										_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Group$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Group$label('Total'),
													$author$project$Ui$Form$Group$labelSpan(10),
													$author$project$Ui$Form$Group$inputSpan(2)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Form$Static$view,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Element$view,
															_List_fromArray(
																[$author$project$Ui$Element$textRight]),
															_List_fromArray(
																[
																	A2(
																	$author$project$Ui$Typography$strong,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Utils$Currency$fromInt(
																				$author$project$Api$Provider$PracticeInvoice$One$totalInCents(practiceInvoice)))
																		]))
																]))
														]))
												]))
										])
									]));
						} else {
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textCenter]),
									_List_fromArray(
										[
											$author$project$Ui$Spinner$view(_List_Nil)
										]))
								]);
						}
					}())
				]))
		]);
};
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$view = function (model) {
	return {
		fO: $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$viewBody(model),
		ac9: 'Admin | Billing'
	};
};
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$init, aiq: $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$load, k8: $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$save, alO: $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$subscriptions, adT: $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$update, amo: $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$view});
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $author$project$Pages$Admin$CancellationReasons$GotItems = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$CancellationReason$cancellationReasonsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['cancellation_reasons']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$CancellationReason$All$CancellationReason = $elm$core$Basics$identity;
var $author$project$Api$Provider$CancellationReason$Shared$CancellationReason = $elm$core$Basics$identity;
var $author$project$Api$Provider$CancellationReason$Shared$Record = F3(
	function (id, description, meta) {
		return {Qr: description, ahP: id, W4: meta};
	});
var $author$project$Api$Provider$CancellationReason$Meta$Meta = $elm$core$Basics$identity;
var $author$project$Api$Provider$CancellationReason$Meta$MetaRecord = function (editable) {
	return {Q4: editable};
};
var $author$project$Api$Provider$CancellationReason$Meta$metaRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'editable',
	$elm$json$Json$Decode$bool,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$CancellationReason$Meta$MetaRecord));
var $author$project$Api$Provider$CancellationReason$Meta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CancellationReason$Meta$metaRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CancellationReason$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'meta',
	$author$project$Api$Provider$CancellationReason$Meta$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'description',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$CancellationReason$Shared$Record))));
var $author$project$Api$Provider$CancellationReason$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CancellationReason$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CancellationReason$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CancellationReason$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CancellationReason$listDefaults = {ajJ: $author$project$Api$Pagination$init};
var $author$project$Api$Provider$CancellationReason$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$CancellationReason$listDefaults);
	return $author$project$Api$Pagination$toApiParams(options.ajJ);
};
var $author$project$Api$Provider$CancellationReason$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$CancellationReason$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$CancellationReason$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$CancellationReason$cancellationReasonsPath)));
	});
var $author$project$Pages$Admin$CancellationReasons$fetchItems = function (model) {
	return A3(
		$author$project$Api$Provider$CancellationReason$list,
		model.Gv,
		function (d) {
			return _Utils_update(
				d,
				{ajJ: model.ajJ});
		},
		$author$project$Pages$Admin$CancellationReasons$GotItems);
};
var $author$project$Pages$Admin$CancellationReasons$init = F4(
	function (_v0, _v1, _v2, _v3) {
		var apiClient = _v2.Gv;
		var model = {Gv: apiClient, je: $elm$core$Maybe$Nothing, eg: $elm$core$Set$empty, Io: $elm$core$Maybe$Nothing, j4: $author$project$Api$Data$Loading, ajJ: $author$project$Api$Pagination$init};
		return _Utils_Tuple2(
			model,
			$author$project$Pages$Admin$CancellationReasons$fetchItems(model));
	});
var $author$project$Pages$Admin$CancellationReasons$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$CancellationReasons$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$CancellationReasons$CancelEdit = {$: 2};
var $author$project$Pages$Admin$CancellationReasons$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Pages$Admin$CancellationReasons$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Admin$CancellationReasons$CancelEdit)),
					model.Io)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$CancellationReasons$HiConfirmClosed),
					model.je))
			]));
};
var $author$project$Pages$Admin$CancellationReasons$Deleted = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Api$Provider$CancellationReason$cancellationReasonPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$CancellationReason$cancellationReasonsPath);
};
var $author$project$Api$Provider$CancellationReason$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$CancellationReason$cancellationReasonPath(id_)));
	});
var $author$project$Api$Provider$CancellationReason$Shared$description = function (_v0) {
	var record = _v0;
	return record.Qr;
};
var $author$project$Api$Provider$CancellationReason$All$description = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CancellationReason$Shared$description(shared);
};
var $author$project$Pages$Admin$CancellationReasons$formFieldsFromItem = function (item) {
	return $author$project$Api$Provider$CancellationReason$All$description(item);
};
var $author$project$Pages$Admin$CancellationReasons$formFieldsInit = '';
var $author$project$Pages$Admin$CancellationReasons$formFieldsUpdate = F2(
	function (field, _v0) {
		var description = field;
		return description;
	});
var $author$project$Pages$Admin$CancellationReasons$DescriptionValidation = 0;
var $rtfeldman$elm_validate$Validate$isWhitespaceChar = function (_char) {
	return (_char === ' ') || ((_char === '\n') || ((_char === '\t') || (_char === '\u000D')));
};
var $rtfeldman$elm_validate$Validate$isBlank = function (str) {
	isBlank:
	while (true) {
		var _v0 = $elm$core$String$uncons(str);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var _char = _v1.a;
			var rest = _v1.b;
			if ($rtfeldman$elm_validate$Validate$isWhitespaceChar(_char)) {
				var $temp$str = rest;
				str = $temp$str;
				continue isBlank;
			} else {
				return false;
			}
		} else {
			return true;
		}
	}
};
var $rtfeldman$elm_validate$Validate$ifBlank = F2(
	function (subjectToString, error) {
		return A2(
			$rtfeldman$elm_validate$Validate$ifTrue,
			function (subject) {
				return $rtfeldman$elm_validate$Validate$isBlank(
					subjectToString(subject));
			},
			error);
	});
var $author$project$Pages$Admin$CancellationReasons$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			$elm$core$Basics$identity,
			_Utils_Tuple2(0, 'Please enter a description.'))
		]));
var $author$project$Api$Provider$CancellationReason$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$CancellationReason$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CancellationReason$Shared$id(shared);
};
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$core$Set$remove = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$remove, key, dict);
	});
var $author$project$Pages$Admin$CancellationReasons$Created = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$CancellationReason$One$CancellationReason = 0;
var $author$project$Api$Provider$CancellationReason$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Provider$CancellationReason$create = F3(
	function (apiClient, description_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'cancellation_reason',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'description',
								$elm$json$Json$Encode$string(description_))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CancellationReason$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$CancellationReason$cancellationReasonsPath)));
	});
var $author$project$Pages$Admin$CancellationReasons$createItem = F2(
	function (apiClient, formFields) {
		var description = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A3($author$project$Api$Provider$CancellationReason$create, apiClient, description, $author$project$Pages$Admin$CancellationReasons$Created);
	});
var $author$project$Pages$Admin$CancellationReasons$Updated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$CancellationReason$update = F4(
	function (apiClient, id_, description_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'cancellation_reason',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'description',
								$elm$json$Json$Encode$string(description_))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$CancellationReason$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$CancellationReason$cancellationReasonPath(id_))));
	});
var $author$project$Pages$Admin$CancellationReasons$updateItem = F3(
	function (apiClient, id, formFields) {
		var description = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4($author$project$Api$Provider$CancellationReason$update, apiClient, id, description, $author$project$Pages$Admin$CancellationReasons$Updated);
	});
var $author$project$Pages$Admin$CancellationReasons$saveItem = F3(
	function (apiClient, maybeId, formFields) {
		if (!maybeId.$) {
			var id = maybeId.a;
			return A3($author$project$Pages$Admin$CancellationReasons$updateItem, apiClient, id, formFields);
		} else {
			return A2($author$project$Pages$Admin$CancellationReasons$createItem, apiClient, formFields);
		}
	});
var $author$project$Pages$Admin$CancellationReasons$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							Io: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init($author$project$Pages$Admin$CancellationReasons$formFieldsInit),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var field = msg.a;
				var _v1 = model.Io;
				if (!_v1.$) {
					var _v2 = _v1.a;
					var id = _v2.a;
					var form = _v2.b;
					var item = _v2.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$CancellationReasons$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Io: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, item))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				var form = msg.a;
				var id = msg.b;
				var _v3 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$CancellationReasons$formFieldsValidator, form);
				if (!_v3.$) {
					var _v4 = _v3.a;
					var newForm = _v4.a;
					var validFormFields = _v4.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Io: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, $author$project$Api$Data$Loading))
							}),
						A3($author$project$Pages$Admin$CancellationReasons$saveItem, model.Gv, id, validFormFields),
						_List_Nil);
				} else {
					var newForm = _v3.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Io: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 1:
				var item = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							Io: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(
										$author$project$Api$Provider$CancellationReason$All$id(item)),
									$author$project$Utils$Form$init(
										$author$project$Pages$Admin$CancellationReasons$formFieldsFromItem(item)),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Io: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								j4: response,
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{j4: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 6:
				var response = msg.a;
				var _v6 = model.Io;
				if (!_v6.$) {
					var _v7 = _v6.a;
					var id = _v7.a;
					var form = _v7.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{Io: $elm$core$Maybe$Nothing}),
							$author$project$Pages$Admin$CancellationReasons$fetchItems(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Cancellation reason successfully created')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									Io: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var response = msg.a;
				var _v9 = model.Io;
				if (!_v9.$) {
					var _v10 = _v9.a;
					var id = _v10.a;
					var form = _v10.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{Io: $elm$core$Maybe$Nothing}),
							$author$project$Pages$Admin$CancellationReasons$fetchItems(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Cancellation reason successfully updated')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									Io: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 8:
				var id = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									eg: A2($elm$core$Set$remove, id, model.eg),
									j4: $author$project$Api$Data$Loading
								}),
							$author$project$Pages$Admin$CancellationReasons$fetchItems(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Cancellation reason successfully deleted')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									eg: A2($elm$core$Set$remove, id, model.eg)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					$author$project$Pages$Admin$CancellationReasons$fetchItems(newModel),
					_List_Nil);
			case 10:
				var id = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							je: $elm$core$Maybe$Just(id)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var id = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							je: $elm$core$Maybe$Nothing,
							eg: A2($elm$core$Set$insert, id, model.eg)
						}),
					A3(
						$author$project$Api$Provider$CancellationReason$delete,
						model.Gv,
						id,
						$author$project$Pages$Admin$CancellationReasons$Deleted(id)),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{je: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
		}
	});
var $author$project$Pages$Admin$CancellationReasons$New = {$: 0};
var $author$project$Pages$Admin$CancellationReasons$PaginationMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Ui$Button$default = $author$project$Ui$Button$Styled(0);
var $author$project$Ui$Panel$Footer = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Ui$Panel$footer = $author$project$Ui$Panel$Footer;
var $author$project$Api$Data$isSuccess = function (data) {
	if (data.$ === 3) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Ui$Pagination$List$Loading = function (a) {
	return {$: 7, a: a};
};
var $author$project$Ui$Pagination$List$loading = $author$project$Ui$Pagination$List$Loading;
var $author$project$Components$HiConfirm$Sentence = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$HiConfirm$sentence = $author$project$Components$HiConfirm$Sentence;
var $author$project$Pages$Admin$CancellationReasons$Description = $elm$core$Basics$identity;
var $author$project$Pages$Admin$CancellationReasons$FormUpdated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$CancellationReasons$Save = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Ui$Form$Input$Autofocus = function (a) {
	return {$: 20, a: a};
};
var $author$project$Ui$Form$Input$autofocus = $author$project$Ui$Form$Input$Autofocus;
var $author$project$Pages$Admin$CancellationReasons$viewItemModal = F3(
	function (maybeId, item, form) {
		var modalConfig = {
			Tq: $elm$core$Maybe$Nothing,
			aih: 'Cancellation Reason',
			V8: _Utils_eq(item, $author$project$Api$Data$Loading),
			WG: maybeId,
			WH: $elm$core$Maybe$Just('This update will be effective for future and historical terminations.'),
			Yd: $author$project$Pages$Admin$CancellationReasons$CancelEdit,
			Yf: $author$project$Pages$Admin$CancellationReasons$Save(form)
		};
		var description = $author$project$Utils$Form$fields(form);
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(4),
							$author$project$Ui$Form$Group$required(true),
							$author$project$Ui$Form$Group$label('Description')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(description),
									$author$project$Ui$Form$Input$phi(true),
									$author$project$Ui$Form$Input$placeholder('Add a reason'),
									$author$project$Ui$Form$Input$autofocus(true),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$CancellationReasons$FormUpdated, $elm$core$Basics$identity)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form))
								])),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						]))
				]));
	});
var $author$project$Ui$Table$VerticalCentered = {$: 1};
var $author$project$Ui$Table$verticalCentered = $author$project$Ui$Table$VerticalCentered;
var $author$project$Pages$Admin$CancellationReasons$Edit = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$CancellationReasons$OpenHiConfirm = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Provider$CancellationReason$Meta$editable = function (_v0) {
	var meta = _v0;
	return meta.Q4;
};
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$member, key, dict);
	});
var $author$project$Api$Provider$CancellationReason$Shared$meta = function (_v0) {
	var record = _v0;
	return record.W4;
};
var $author$project$Api$Provider$CancellationReason$All$meta = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CancellationReason$Shared$meta(shared);
};
var $author$project$Pages$Admin$CancellationReasons$viewItem = F2(
	function (deletingItems, item) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[
									$author$project$Ui$Typography$phi(true)
								]),
							$author$project$Api$Provider$CancellationReason$All$description(item))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					function () {
						if ($author$project$Api$Provider$CancellationReason$Meta$editable(
							$author$project$Api$Provider$CancellationReason$All$meta(item))) {
							var id = $author$project$Api$Provider$CancellationReason$All$id(item);
							var loading = A2($elm$core$Set$member, id, deletingItems);
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$gap2, $author$project$Ui$Element$justifyRight]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{mm: 'Edit cancellation reason'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$sm,
													$author$project$Ui$Button$disabled(loading),
													$author$project$Ui$Button$onClick(
													$author$project$Pages$Admin$CancellationReasons$Edit(item)),
													$author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Edit')
												])),
											A3(
											$author$project$Ui$Button$view,
											{mm: 'Delete cancellation reason'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$sm,
													$author$project$Ui$Button$loading(loading),
													$author$project$Ui$Button$onClick(
													$author$project$Pages$Admin$CancellationReasons$OpenHiConfirm(id)),
													$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Delete')
												]))
										]))
								]);
						} else {
							return _List_Nil;
						}
					}())
				]));
	});
var $author$project$Pages$Admin$CancellationReasons$viewPanelBody = function (model) {
	var _v0 = function () {
		var _v1 = model.j4;
		if (_v1.$ === 3) {
			var items_ = _v1.a;
			return _Utils_Tuple2(false, items_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var items = _v0.b;
	return A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$verticalCentered,
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('Add a reason to start tracking why patients end their memberships.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Description')
					])),
				A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
			]),
		A2(
			$elm$core$List$map,
			$author$project$Pages$Admin$CancellationReasons$viewItem(model.eg),
			items),
		_List_Nil);
};
var $author$project$Pages$Admin$CancellationReasons$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				function () {
				var _v0 = model.Io;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var id = _v1.a;
					var form = _v1.b;
					var item = _v1.c;
					return A3($author$project$Pages$Admin$CancellationReasons$viewItemModal, id, item, form);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v2 = model.je;
				if (!_v2.$) {
					var id = _v2.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Admin$CancellationReasons$HiConfirmClosed(id),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('delete'),
								$author$project$Components$HiConfirm$noun('cancellation reason'),
								$author$project$Components$HiConfirm$sentence('If a membership currently has this cancellation reason, it will not have it afterwards.')
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween]),
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Reasons for Membership Cancellation')
											])),
										A3(
										$author$project$Ui$Button$view,
										{mm: 'New cancellation reason'},
										_List_fromArray(
											[
												$author$project$Ui$Button$default,
												$author$project$Ui$Button$onClick($author$project$Pages$Admin$CancellationReasons$New),
												$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('New Cancellation Reason')
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Pages$Admin$CancellationReasons$viewPanelBody(model)
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Admin$CancellationReasons$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(
											!$author$project$Api$Data$isSuccess(model.j4))
										]),
									model.ajJ))
							]))
					]))
			]),
		ac9: 'Admin | Cancellation Reasons'
	};
};
var $author$project$Pages$Admin$CancellationReasons$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$CancellationReasons$init, aiq: $author$project$Pages$Admin$CancellationReasons$load, k8: $author$project$Pages$Admin$CancellationReasons$save, alO: $author$project$Pages$Admin$CancellationReasons$subscriptions, adT: $author$project$Pages$Admin$CancellationReasons$update, amo: $author$project$Pages$Admin$CancellationReasons$view});
var $author$project$Pages$Admin$CardReaders$GotCardReaderConfiguration = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Admin$CardReaders$None = {$: 2};
var $author$project$Api$Provider$CardReaderConfiguration$cardReaderConfigurationPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['card_reader_configuration']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$CardReaderConfiguration$One$CardReaderConfiguration = $elm$core$Basics$identity;
var $author$project$Api$Provider$CardReaderConfiguration$Shared$CardReaderConfiguration = $elm$core$Basics$identity;
var $author$project$Api$Provider$CardReaderConfiguration$Shared$Record = function (status) {
	return {alH: status};
};
var $author$project$Api$Provider$CardReaderConfiguration$Shared$Active = 0;
var $author$project$Api$Provider$CardReaderConfiguration$Shared$Inactive = 1;
var $author$project$Api$Provider$CardReaderConfiguration$Shared$statusDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'active':
				return $elm$json$Json$Decode$succeed(0);
			case 'inactive':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Unsupported Card Reader Configuration status: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$CardReaderConfiguration$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'status',
	$author$project$Api$Provider$CardReaderConfiguration$Shared$statusDecoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$CardReaderConfiguration$Shared$Record));
var $author$project$Api$Provider$CardReaderConfiguration$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CardReaderConfiguration$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CardReaderConfiguration$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CardReaderConfiguration$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CardReaderConfiguration$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$CardReaderConfiguration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$CardReaderConfiguration$cardReaderConfigurationPath));
	});
var $author$project$Pages$Admin$CardReaders$init = F4(
	function (session, practice, shared, _v0) {
		var model = {
			Gv: shared.Gv,
			aft: $author$project$Pages$Admin$CardReaders$None,
			mD: $author$project$Api$Data$Loading,
			iE: $author$project$Api$Data$Loading,
			ja: $elm$core$Maybe$Nothing,
			f8: $elm$core$Set$empty,
			jn: false,
			sF: shared.sF,
			Ij: $author$project$Shared$isHintAdmin(shared),
			ZV: practice,
			aa4: session
		};
		return _Utils_Tuple2(
			model,
			A2($author$project$Api$Provider$CardReaderConfiguration$retrieve, shared.Gv, $author$project$Pages$Admin$CardReaders$GotCardReaderConfiguration));
	});
var $author$project$Pages$Admin$CardReaders$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$CardReaders$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$CardReaders$Cancel = {$: 6};
var $author$project$Pages$Admin$CardReaders$DeleteCardReaderHiConfirmClosed = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Pages$Admin$CardReaders$DisableIntegrationHiConfirmClosed = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Admin$CardReaders$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				function () {
				var _v0 = model.aft;
				if (_v0.$ === 2) {
					return $elm$core$Platform$Sub$none;
				} else {
					return $author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Admin$CardReaders$Cancel);
				}
			}(),
				model.jn ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Admin$CardReaders$DisableIntegrationHiConfirmClosed) : $elm$core$Platform$Sub$none,
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$CardReaders$DeleteCardReaderHiConfirmClosed),
					model.ja))
			]));
};
var $author$project$Pages$Admin$CardReaders$Adding = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$CardReaders$CardReadersActivated = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Admin$CardReaders$DeletedCardReader = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Pages$Admin$CardReaders$Editing = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$CardReaderConfiguration$activate = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CardReaderConfiguration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['activate']),
					$author$project$Api$Provider$CardReaderConfiguration$cardReaderConfigurationPath)));
	});
var $author$project$Pages$Admin$CardReaders$CreatedCardReader = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$CardReader$create = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'card_reader',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'label',
								$elm$json$Json$Encode$string(fields.aih)),
								_Utils_Tuple2(
								'registration_code',
								$elm$json$Json$Encode$string(fields.NN))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CardReader$Shared$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$CardReader$cardReadersPath)));
	});
var $author$project$Pages$Admin$CardReaders$create = F2(
	function (apiClient, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var apiFields = {NN: fields.NN, aih: fields.aih};
		return A3($author$project$Api$Provider$CardReader$create, apiClient, apiFields, $author$project$Pages$Admin$CardReaders$CreatedCardReader);
	});
var $author$project$Pages$Admin$CardReaders$CardReadersDeactivated = function (a) {
	return {$: 12, a: a};
};
var $author$project$Api$Provider$CardReaderConfiguration$deactivate = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CardReaderConfiguration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['deactivate']),
					$author$project$Api$Provider$CardReaderConfiguration$cardReaderConfigurationPath)));
	});
var $author$project$Pages$Admin$CardReaders$deactivateIntegration = function (model) {
	return _Utils_Tuple3(
		model,
		function (fn) {
			return fn($author$project$Pages$Admin$CardReaders$CardReadersDeactivated);
		}(
			$author$project$Api$Provider$CardReaderConfiguration$deactivate(model.Gv)),
		_List_Nil);
};
var $author$project$Api$Provider$CardReader$delete = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$CardReader$cardReaderPath(id)));
	});
var $author$project$Pages$Admin$CardReaders$editFormFieldsUpdate = F2(
	function (field, _v0) {
		if (field.$ === 1) {
			var string = field.a;
			return string;
		} else {
			return '';
		}
	});
var $author$project$Pages$Admin$CardReaders$EditLabelValidation = 0;
var $author$project$Pages$Admin$CardReaders$editFormFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			$elm$core$Basics$identity,
			_Utils_Tuple2(0, 'Please enter a label.'))
		]));
var $author$project$Pages$Admin$CardReaders$GotCardReaders = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$CardReaders$fetchCardReaders = function (apiClient) {
	return A3($author$project$Api$Provider$CardReader$list, apiClient, $elm$core$Basics$identity, $author$project$Pages$Admin$CardReaders$GotCardReaders);
};
var $author$project$Pages$Admin$CardReaders$formFieldsFromCardReader = function (cardReader) {
	return $author$project$Api$Provider$CardReader$All$label(cardReader);
};
var $author$project$Pages$Admin$CardReaders$formFieldsInit = {NN: '', aih: ''};
var $author$project$Pages$Admin$CardReaders$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var string = field.a;
			return _Utils_update(
				fields,
				{NN: string});
		} else {
			var string = field.a;
			return _Utils_update(
				fields,
				{aih: string});
		}
	});
var $author$project$Pages$Admin$CardReaders$CodeValidation = 0;
var $author$project$Pages$Admin$CardReaders$LabelValidation = 1;
var $author$project$Pages$Admin$CardReaders$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.aih;
			},
			_Utils_Tuple2(1, 'Please enter a label.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.NN;
			},
			_Utils_Tuple2(0, 'Please enter a code.'))
		]));
var $author$project$Ports$Intercom$intercomPortOpen = _Platform_outgoingPort(
	'intercomPortOpen',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$Intercom$open = function (session) {
	return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : $author$project$Ports$Intercom$intercomPortOpen(0);
};
var $author$project$Api$Provider$CardReaderConfiguration$Shared$status = function (_v0) {
	var shared = _v0;
	return shared.alH;
};
var $author$project$Api$Provider$CardReaderConfiguration$One$status = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CardReaderConfiguration$Shared$status(shared);
};
var $author$project$Pages$Admin$CardReaders$UpdatedCardReader = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$CardReader$update = F4(
	function (apiClient, id, label_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'card_reader',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'label',
								$elm$json$Json$Encode$string(label_))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$CardReader$Shared$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$CardReader$cardReaderPath(id))));
	});
var $author$project$Pages$Admin$CardReaders$updateCardReader = F3(
	function (apiClient, id, validForm) {
		var validLabel = $rtfeldman$elm_validate$Validate$fromValid(validForm);
		return A4($author$project$Api$Provider$CardReader$update, apiClient, id, validLabel, $author$project$Pages$Admin$CardReaders$UpdatedCardReader);
	});
var $author$project$Pages$Admin$CardReaders$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(
					model,
					function (fn) {
						return fn($author$project$Pages$Admin$CardReaders$CardReadersActivated);
					}(
						$author$project$Api$Provider$CardReaderConfiguration$activate(model.Gv)),
					_List_Nil);
			case 13:
				var cardReaderConfiguration = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{mD: cardReaderConfiguration}),
					function () {
						if (cardReaderConfiguration.$ === 3) {
							var conf = cardReaderConfiguration.a;
							var _v2 = $author$project$Api$Provider$CardReaderConfiguration$One$status(conf);
							if (!_v2) {
								return $author$project$Pages$Admin$CardReaders$fetchCardReaders(model.Gv);
							} else {
								return $elm$core$Platform$Cmd$none;
							}
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}(),
					$author$project$OutMsg$reportDecodeError(cardReaderConfiguration));
			case 1:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{iE: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$reportDecodeError(response));
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aft: $author$project$Pages$Admin$CardReaders$Adding(
								_Utils_Tuple2(
									$author$project$Utils$Form$init($author$project$Pages$Admin$CardReaders$formFieldsInit),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var cardReader = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aft: $author$project$Pages$Admin$CardReaders$Editing(
								_Utils_Tuple3(
									$author$project$Api$Provider$CardReader$All$id(cardReader),
									$author$project$Utils$Form$init(
										$author$project$Pages$Admin$CardReaders$formFieldsFromCardReader(cardReader)),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var field = msg.a;
				var _v3 = model.aft;
				switch (_v3.$) {
					case 0:
						var _v4 = _v3.a;
						var form = _v4.a;
						var cardReader = _v4.b;
						var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$CardReaders$formFieldsUpdate, field, form);
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aft: $author$project$Pages$Admin$CardReaders$Adding(
										_Utils_Tuple2(newForm, cardReader))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					case 1:
						var _v5 = _v3.a;
						var id = _v5.a;
						var form = _v5.b;
						var editingCardReader = _v5.c;
						var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$CardReaders$editFormFieldsUpdate, field, form);
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aft: $author$project$Pages$Admin$CardReaders$Editing(
										_Utils_Tuple3(id, newForm, editingCardReader))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				var saveCardReader = msg.a;
				if (!saveCardReader.$) {
					var form = saveCardReader.a;
					var _v7 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$CardReaders$formFieldsValidator, form);
					if (!_v7.$) {
						var _v8 = _v7.a;
						var newForm = _v8.a;
						var validFormFields = _v8.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aft: $author$project$Pages$Admin$CardReaders$Adding(
										_Utils_Tuple2(newForm, $author$project$Api$Data$Loading))
								}),
							A2($author$project$Pages$Admin$CardReaders$create, model.Gv, validFormFields),
							_List_Nil);
					} else {
						var newForm = _v7.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aft: $author$project$Pages$Admin$CardReaders$Adding(
										_Utils_Tuple2(newForm, $author$project$Api$Data$NotAsked))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					var form = saveCardReader.a;
					var id = saveCardReader.b;
					var _v9 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$CardReaders$editFormFieldsValidator, form);
					if (!_v9.$) {
						var _v10 = _v9.a;
						var newForm = _v10.a;
						var validFormFields = _v10.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aft: $author$project$Pages$Admin$CardReaders$Editing(
										_Utils_Tuple3(id, newForm, $author$project$Api$Data$Loading))
								}),
							A3($author$project$Pages$Admin$CardReaders$updateCardReader, model.Gv, id, validFormFields),
							_List_Nil);
					} else {
						var newForm = _v9.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aft: $author$project$Pages$Admin$CardReaders$Editing(
										_Utils_Tuple3(id, newForm, $author$project$Api$Data$NotAsked))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				}
			case 6:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aft: $author$project$Pages$Admin$CardReaders$None}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 7:
				var response = msg.a;
				var _v11 = model.aft;
				if (!_v11.$) {
					var _v12 = _v11.a;
					var form = _v12.a;
					if (response.$ === 3) {
						var cardReader = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{aft: $author$project$Pages$Admin$CardReaders$None, iE: $author$project$Api$Data$Loading}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Admin$CardReaders$fetchCardReaders(model.Gv),
										A2(
										$author$project$Ports$LocalStorage$setItem,
										'last-used-card-reader',
										$author$project$Api$Provider$CardReader$Shared$id(cardReader))
									])),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									'Successfully created ' + $author$project$Api$Provider$CardReader$Shared$label(cardReader))
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aft: $author$project$Pages$Admin$CardReaders$Adding(
										_Utils_Tuple2(form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 8:
				var response = msg.a;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{aft: $author$project$Pages$Admin$CardReaders$None, iE: $author$project$Api$Data$Loading}),
							$author$project$Pages$Admin$CardReaders$fetchCardReaders(model.Gv),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Card reader updated')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{aft: $author$project$Pages$Admin$CardReaders$None}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var cardReader = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ja: $elm$core$Maybe$Just(cardReader)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 10:
				var cardReader = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									iE: $author$project$Api$Data$Loading,
									f8: A2(
										$elm$core$Set$remove,
										$author$project$Api$Provider$CardReader$All$id(cardReader),
										model.f8)
								}),
							$author$project$Pages$Admin$CardReaders$fetchCardReaders(model.Gv),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Provider$CardReader$All$label(cardReader) + ' was successfully removed.')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									f8: A2(
										$elm$core$Set$remove,
										$author$project$Api$Provider$CardReader$All$id(cardReader),
										model.f8)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 11:
				var configurationData = msg.a;
				switch (configurationData.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{mD: configurationData}),
							$author$project$Pages$Admin$CardReaders$fetchCardReaders(model.Gv),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Card reader integration activated. Please add your card reader now.')
								]));
					case 2:
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(configurationData));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 12:
				var configurationData = msg.a;
				switch (configurationData.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{mD: configurationData}),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Card reader integration deactivated.')
								]));
					case 2:
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(configurationData));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 14:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{jn: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 15:
				var confirmed = msg.a;
				return confirmed ? $author$project$Pages$Admin$CardReaders$deactivateIntegration(
					_Utils_update(
						model,
						{jn: false})) : _Utils_Tuple3(
					_Utils_update(
						model,
						{jn: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 16:
				var cardReader = msg.a;
				var confirmed = msg.b;
				if (confirmed) {
					var id = $author$project$Api$Provider$CardReader$All$id(cardReader);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ja: $elm$core$Maybe$Nothing,
								f8: A2($elm$core$Set$insert, id, model.f8)
							}),
						A3(
							$author$project$Api$Provider$CardReader$delete,
							model.Gv,
							id,
							$author$project$Pages$Admin$CardReaders$DeletedCardReader(cardReader)),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ja: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			default:
				return _Utils_Tuple3(
					model,
					$author$project$Ports$Intercom$open(model.aa4),
					_List_Nil);
		}
	});
var $author$project$Pages$Admin$CardReaders$AddCardReaderButtonClicked = {$: 2};
var $author$project$Api$Feature$AllowStripeCardReaders = 14;
var $author$project$Pages$Admin$CardReaders$DisableIntegrationHiConfirmOpened = {$: 14};
var $author$project$Ui$Form$Static$Flex = {$: 4};
var $author$project$Ui$Form$Static$flex = $author$project$Ui$Form$Static$Flex;
var $author$project$Ui$Form$Static$ItemsCenter = {$: 6};
var $author$project$Ui$Form$Static$itemsCenter = $author$project$Ui$Form$Static$ItemsCenter;
var $author$project$Pages$Admin$CardReaders$ShowSupportChat = {$: 17};
var $author$project$Pages$Admin$CardReaders$rainforestSetupStepTwo = _List_fromArray(
	[
		$elm$html$Html$text('Set up your new card readers once they arrive by clicking \'Add Card Reader\' above. If you need assistance, please '),
		A3(
		$author$project$Ui$Button$view,
		{mm: 'Contact support'},
		_List_fromArray(
			[
				$author$project$Ui$Button$link,
				$author$project$Ui$Button$onClick($author$project$Pages$Admin$CardReaders$ShowSupportChat)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('contact Support')
			]))
	]);
var $author$project$Pages$Admin$CardReaders$stripeSetupStepTwo = _List_fromArray(
	[
		$elm$html$Html$text('Please click on \"Add Card Reader\" above to initiate the process. If you need more assistance such as setting up Wi-Fi, please refer to these'),
		A3(
		$author$project$Ui$Link$externalHref,
		'https://docs.stripe.com/terminal/payments/setup-reader',
		_List_fromArray(
			[$author$project$Ui$Link$targetBlank]),
		_List_fromArray(
			[
				$elm$html$Html$text(' guides.')
			]))
	]);
var $author$project$Pages$Admin$CardReaders$setupStepTwo = function (practice) {
	return ($author$project$Api$Provider$Practice$One$paymentProcessor(practice) === 'stripe') ? $author$project$Pages$Admin$CardReaders$stripeSetupStepTwo : $author$project$Pages$Admin$CardReaders$rainforestSetupStepTwo;
};
var $author$project$Ui$Form$Static$SpaceBetween = {$: 5};
var $author$project$Ui$Form$Static$spaceBetween = $author$project$Ui$Form$Static$SpaceBetween;
var $author$project$Pages$Admin$CardReaders$DeleteCardReaderButtonClicked = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Admin$CardReaders$EditCardReaderButtonClicked = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$ListGroup$Item = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Ui$ListGroup$item = $author$project$Ui$ListGroup$Item;
var $author$project$Api$Provider$CardReader$Shared$serialNumber = function (_v0) {
	var record = _v0;
	return record.aaY;
};
var $author$project$Api$Provider$CardReader$All$serialNumber = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CardReader$Shared$serialNumber(shared);
};
var $author$project$Pages$Admin$CardReaders$viewCardReader = F2(
	function (showProcessor, cardReader) {
		return A2(
			$author$project$Ui$ListGroup$item,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(9)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$core$Maybe$withDefault,
											$author$project$Utils$Html$empty,
											A4(
												$author$project$Utils$PaymentProcessor$toBadge,
												showProcessor,
												showProcessor,
												cardReader,
												A2($elm$core$Basics$composeR, $author$project$Api$Provider$CardReader$All$paymentProcessor, $elm$core$Maybe$Just))),
											$elm$html$Html$text(
											$author$project$Api$Provider$CardReader$All$label(cardReader))
										])),
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
									' - SN: ' + $author$project$Api$Provider$CardReader$All$serialNumber(cardReader))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(1)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{mm: 'edit card reader'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Admin$CardReaders$EditCardReaderButtonClicked(cardReader)),
											$author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit')
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(1)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Delete card reader'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Admin$CardReaders$DeleteCardReaderButtonClicked(cardReader)),
											$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Delete')
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$CardReaders$viewMigrationAlert = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('m-0'),
			A2($elm$html$Html$Attributes$style, 'padding-top', '1em')
		]),
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Alert$warning,
			_List_fromArray(
				[
					$author$project$Ui$Alert$alignment($author$project$Ui$Alignment$textLeft)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Card readers purchased from Stripe are not compatible with Hint Payments. Please order a new reader as part of Hint Payments setup.'),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('list-align-left')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'list-style-position', 'inside')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Hint will cover the cost if you want to replace your card reader.')
								])),
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'list-style-position', 'inside')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Please complete this '),
									A3(
									$author$project$Ui$Link$externalHref,
									'https://hinthealth.typeform.com/to/xgWqDFVc',
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('form')
										])),
									$elm$html$Html$text(' to place an order and we\'ll take care of the rest.')
								]))
						]))
				]))
		]));
var $author$project$Ui$Tooltip$Active = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Tooltip$active = $author$project$Ui$Tooltip$Active;
var $author$project$Pages$Admin$CardReaders$withDisabledIFStripeTooltip = F2(
	function (usingStripe, contents) {
		return A3(
			$author$project$Ui$Tooltip$view,
			_List_fromArray(
				[
					$author$project$Ui$Tooltip$active(usingStripe),
					$author$project$Ui$Tooltip$wide
				]),
			'Card readers are only supported on Hint Payments',
			contents);
	});
var $author$project$Pages$Admin$CardReaders$viewActiveAccount = function (model) {
	var usingStripe = $author$project$Api$Provider$Practice$One$paymentProcessor(model.ZV) === 'stripe';
	var allowAddingReader = (!usingStripe) || A2($author$project$Api$Provider$Practice$One$featureEnabled, 14, model.ZV);
	return _List_fromArray(
		[
			usingStripe ? A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label(''),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[$author$project$Pages$Admin$CardReaders$viewMigrationAlert])) : $author$project$Utils$Html$empty,
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Status'),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_fromArray(
						[$author$project$Ui$Form$Static$flex, $author$project$Ui$Form$Static$spaceBetween, $author$project$Ui$Form$Static$itemsCenter]),
					_List_fromArray(
						[
							A2($author$project$Ui$Badge$fromString, _List_Nil, 'active'),
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Deactivate the integration'},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$onClick($author$project$Pages$Admin$CardReaders$DisableIntegrationHiConfirmOpened)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Deactivate the integration')
								]))
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$muted]),
					_List_fromArray(
						[
							$elm$html$Html$text('You can now allow patients to pay in-person with credit or '),
							$elm$html$Html$text('debit cards directly using your connected card readers.')
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Card Readers'),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Pages$Admin$CardReaders$withDisabledIFStripeTooltip,
					!allowAddingReader,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Add card reader'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Pages$Admin$CardReaders$AddCardReaderButtonClicked),
									$author$project$Ui$Button$icon($author$project$Ui$Icon$add),
									$author$project$Ui$Button$disabled(!allowAddingReader)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Add Card Reader')
								]))
						])),
					function () {
					var _v0 = model.iE;
					if (_v0.$ === 3) {
						var cardReaders = _v0.a;
						return $elm$core$List$isEmpty(cardReaders) ? $author$project$Utils$Html$empty : A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'padding-top', '1em')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$ListGroup$view,
									_List_Nil,
									A2(
										$elm$core$List$map,
										$author$project$Pages$Admin$CardReaders$viewCardReader(model.Ij),
										cardReaders))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				])),
			usingStripe ? $author$project$Utils$Html$empty : A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Setup Information'),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$ol,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'padding-left', '1em')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$title,
									_List_fromArray(
										[$author$project$Ui$Typography$bold]),
									_List_fromArray(
										[
											$elm$html$Html$text('Order your reader')
										]))
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Select and order reader(s) through Hint Support ('),
									A3(
									$author$project$Ui$Link$externalHref,
									'https://support.hint.com/en/articles/10967048-ordering-a-card-reader',
									_List_fromArray(
										[$author$project$Ui$Link$targetBlank]),
									_List_fromArray(
										[
											$elm$html$Html$text('Instructions here')
										])),
									$elm$html$Html$text(').')
								])),
							A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$title,
									_List_fromArray(
										[$author$project$Ui$Typography$bold]),
									_List_fromArray(
										[
											$elm$html$Html$text('Set up your new card reader')
										]))
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							$author$project$Pages$Admin$CardReaders$setupStepTwo(model.ZV))
						]))
				]))
		]);
};
var $author$project$Pages$Admin$CardReaders$FormUpdated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$CardReaders$Label = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$CardReaders$Save = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$CardReaders$Updating = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Pages$Admin$CardReaders$viewEditModal = F3(
	function (id, form, cardReader) {
		var modalConfig = {
			Tq: $elm$core$Maybe$Nothing,
			aih: 'Card Reader',
			V8: _Utils_eq(cardReader, $author$project$Api$Data$Loading),
			WG: $elm$core$Maybe$Just(id),
			WH: $elm$core$Maybe$Nothing,
			Yd: $author$project$Pages$Admin$CardReaders$Cancel,
			Yf: function (_v0) {
				return $author$project$Pages$Admin$CardReaders$Save(
					A2($author$project$Pages$Admin$CardReaders$Updating, form, id));
			}
		};
		var label = $author$project$Utils$Form$fields(form);
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Reader Name'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(label),
									$author$project$Ui$Form$Input$placeholder('e.g. Lobby Computer'),
									$author$project$Ui$Form$Input$autofocus(true),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$CardReaders$FormUpdated, $author$project$Pages$Admin$CardReaders$Label)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 0, form))
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$CardReaders$ActivateIntegrationClicked = {$: 0};
var $author$project$Api$Provider$Practice$Shared$hasPaymentProcessorAccount = function (_v0) {
	var record = _v0;
	return record.Tg;
};
var $author$project$Api$Provider$Practice$One$hasPaymentProcessorAccount = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$hasPaymentProcessorAccount(shared);
};
var $author$project$Api$Common$Address$Shared$isAddressIncomplete = function (_v0) {
	var record = _v0;
	return A2(
		$elm$core$List$any,
		$elm$core$Basics$identity,
		A2(
			$elm$core$List$map,
			$elm$core$String$isEmpty,
			A2(
				$elm$core$List$map,
				$elm$core$Maybe$withDefault(''),
				_List_fromArray(
					[record.s$, record.rE, record.uP, record.vv, record.rK]))));
};
var $author$project$Api$Provider$Practice$One$hasValidAddress = function (_v0) {
	var record = _v0.b;
	var _v1 = record.K2;
	if (!_v1.$) {
		var address_ = _v1.a;
		return !$author$project$Api$Common$Address$Shared$isAddressIncomplete(address_);
	} else {
		return false;
	}
};
var $author$project$Pages$Admin$CardReaders$renderHtmlIf = F2(
	function (condition, element) {
		return condition ? element : $elm$html$Html$text('');
	});
var $author$project$Pages$Admin$CardReaders$viewRequirementsAlert = function (practice) {
	var hasValidAddress = $author$project$Api$Provider$Practice$One$hasValidAddress(practice);
	var hasPaymentProcessorAccount = $author$project$Api$Provider$Practice$One$hasPaymentProcessorAccount(practice);
	return (hasPaymentProcessorAccount && hasValidAddress) ? $author$project$Utils$Html$empty : A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('m-0'),
				A2($elm$html$Html$Attributes$style, 'padding-top', '1em')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Alert$warning,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('The card reader integration requires ')
							])),
						A2(
						$author$project$Pages$Admin$CardReaders$renderHtmlIf,
						!hasValidAddress,
						A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Admin__Practice,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('an up-to-date address')
								]))),
						A2(
						$author$project$Pages$Admin$CardReaders$renderHtmlIf,
						(!hasPaymentProcessorAccount) && (!hasValidAddress),
						A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(' and ')
								]))),
						A2(
						$author$project$Pages$Admin$CardReaders$renderHtmlIf,
						!hasPaymentProcessorAccount,
						function () {
							var _v0 = $author$project$Api$Provider$Practice$One$paymentProcessor(practice);
							if (_v0 === 'stripe') {
								return A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Admin__Stripe,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('an active Stripe account')
										]));
							} else {
								return A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Admin__PaymentProcessing,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('an active Payment Processing account')
										]));
							}
						}()),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('.')
							]))
					]))
			]));
};
var $author$project$Pages$Admin$CardReaders$viewInactiveAccount = function (practice) {
	var usingStripe = $author$project$Api$Provider$Practice$One$paymentProcessor(practice) === 'stripe';
	var hasValidAddress = $author$project$Api$Provider$Practice$One$hasValidAddress(practice);
	var hasPaymentProcessorAccount = $author$project$Api$Provider$Practice$One$hasPaymentProcessorAccount(practice);
	return _List_fromArray(
		[
			usingStripe ? $author$project$Utils$Html$empty : A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label(''),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					$author$project$Pages$Admin$CardReaders$viewRequirementsAlert(practice)
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Status'),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Ui$Badge$fromString, _List_Nil, 'inactive')
						])),
					A2(
					$author$project$Pages$Admin$CardReaders$withDisabledIFStripeTooltip,
					usingStripe,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Enable Card Readers Integration'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$disabled((!hasPaymentProcessorAccount) || ((!hasValidAddress) || usingStripe)),
									$author$project$Ui$Button$onClick($author$project$Pages$Admin$CardReaders$ActivateIntegrationClicked)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Enable Card Readers Integration')
								]))
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('About'),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Customers can swipe or insert their cards into our reader for storing and processing payments.')
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('How it works'),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ol,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'padding-left', '1em')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Enable the card reader integration.')
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Order your card reader(s) through Hint Support ('),
											A3(
											$author$project$Ui$Link$externalHref,
											'https://support.hint.com/en/articles/10967048-ordering-a-card-reader',
											_List_fromArray(
												[$author$project$Ui$Link$targetBlank]),
											_List_fromArray(
												[
													$elm$html$Html$text('Instructions here')
												])),
											$elm$html$Html$text(').')
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Connect your card reader(s) in Hint once they arrive.')
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Start accepting payments using your card reader(s).')
										]))
								]))
						]))
				]))
		]);
};
var $author$project$Pages$Admin$CardReaders$Code = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$CardReaders$Creating = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Image$RainforestCardReaderSplash = 6;
var $author$project$Ui$Popover$Footer = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Ui$Popover$footer = $author$project$Ui$Popover$Footer;
var $author$project$Ui$Image$Height = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Image$height = $author$project$Ui$Image$Height;
var $author$project$Ui$Image$Cdn = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Image$Local = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Image$imageToSource = function (image) {
	switch (image) {
		case 0:
			return $author$project$Ui$Image$Local('find-ga-code');
		case 1:
			return $author$project$Ui$Image$Local('elationemr-logo');
		case 2:
			return $author$project$Ui$Image$Local('stripe-logo');
		case 3:
			return $author$project$Ui$Image$Local('mailgun-logo');
		case 4:
			return $author$project$Ui$Image$Local('sample-check');
		case 5:
			return $author$project$Ui$Image$Local('stripe-terminal-verifone-default-splash');
		case 6:
			return $author$project$Ui$Image$Local('rainforest-terminal-splash');
		case 13:
			return $author$project$Ui$Image$Local('help-circle');
		case 7:
			return $author$project$Ui$Image$Local('elationemr-blue-logo');
		case 8:
			return $author$project$Ui$Image$Cdn('partners/quickbooks/QuickBooks%20Logo_Horz.png');
		case 9:
			return $author$project$Ui$Image$Cdn('partners/quickbooks/C2QB_green_btn_lg_default.png');
		case 10:
			return $author$project$Ui$Image$Cdn('marketing-whitelabel-attribution.svg');
		case 11:
			return $author$project$Ui$Image$Cdn('logo-mark.svg');
		case 12:
			return $author$project$Ui$Image$Cdn('full-logo.svg');
		case 14:
			return $author$project$Ui$Image$Cdn('onboarding-complete.png');
		case 15:
			return $author$project$Ui$Image$Local('product-highlight-image-placeholder');
		default:
			return $author$project$Ui$Image$Local('marketplace-icon-placeholder');
	}
};
var $author$project$Ui$Image$nameToCdnSrc = function (imagePath) {
	return 'https://cdn2.hubspot.net/hubfs/2562809/production-app/web/' + imagePath;
};
var $author$project$Ui$Image$nameToLocalSrc = F2(
	function (_v0, image) {
		var store = _v0;
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$second,
				A2(
					$elm_community$list_extra$List$Extra$find,
					function (_v1) {
						var imagePath = _v1.a;
						return _Utils_eq(imagePath, image);
					},
					store)));
	});
var $author$project$Ui$Image$imageToSrc = F2(
	function (store, image) {
		var _v0 = $author$project$Ui$Image$imageToSource(image);
		if (!_v0.$) {
			var nameString = _v0.a;
			return A2($author$project$Ui$Image$nameToLocalSrc, store, nameString);
		} else {
			var nameString = _v0.a;
			return $author$project$Ui$Image$nameToCdnSrc(nameString);
		}
	});
var $author$project$Ui$Image$Alt = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$img = _VirtualDom_node('img');
var $elm$html$Html$Attributes$alt = $elm$html$Html$Attributes$stringProperty('alt');
var $author$project$Ui$Image$defaultOptions = {xr: _List_Nil};
var $elm$html$Html$Attributes$height = function (n) {
	return A2(
		_VirtualDom_attribute,
		'height',
		$elm$core$String$fromInt(n));
};
var $author$project$Ui$Image$screenSizeToHeightAutoClass = function (screenSize) {
	return $author$project$Ui$ScreenSize$toClassPrefix(screenSize) + 'h-auto';
};
var $elm$html$Html$Attributes$width = function (n) {
	return A2(
		_VirtualDom_attribute,
		'width',
		$elm$core$String$fromInt(n));
};
var $author$project$Ui$Image$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var _int = option.a;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$width(_int),
									record.xr)
							});
					case 1:
						var string = option.a;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$alt(string),
									record.xr)
							});
					case 2:
						var string = option.a;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class(string),
									record.xr)
							});
					case 3:
						var _int = option.a;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$height(_int),
									record.xr)
							});
					case 4:
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class('w-full block'),
									record.xr)
							});
					case 5:
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class('rounded-lg'),
									record.xr)
							});
					default:
						var screenSize = option.a;
						var sizeClass = $author$project$Ui$Image$screenSizeToHeightAutoClass(screenSize);
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class(sizeClass),
									record.xr)
							});
				}
			}),
		$author$project$Ui$Image$defaultOptions,
		options);
};
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $author$project$Ui$Image$viewImg = F3(
	function (_v0, stringSrc, optionsMinusAlt) {
		var alt = _v0.LD;
		var options = A2(
			$elm$core$List$cons,
			$author$project$Ui$Image$Alt(alt),
			optionsMinusAlt);
		var optionsRecord = $author$project$Ui$Image$optionsToRecord(options);
		return A2(
			$elm$html$Html$img,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$src(stringSrc),
				optionsRecord.xr),
			_List_Nil);
	});
var $author$project$Ui$Image$view = F4(
	function (store, accessibilityOptions, options, source) {
		return A3(
			$author$project$Ui$Image$viewImg,
			accessibilityOptions,
			A2($author$project$Ui$Image$imageToSrc, store, source),
			options);
	});
var $author$project$Ui$Image$Width = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Image$width = $author$project$Ui$Image$Width;
var $author$project$Pages$Admin$CardReaders$viewRainforestConnectInstructions = function (imageStore) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Popover$view,
					_List_fromArray(
						[$author$project$Ui$Popover$dark]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Make sure the reader is on standby mode ')
										])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Ui$Icon$help(_List_Nil)
										]))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Popover$body,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('The standby reader screen should look like this:')
								])),
							A2(
							$author$project$Ui$Popover$footer,
							_List_Nil,
							_List_fromArray(
								[
									A4(
									$author$project$Ui$Image$view,
									imageStore,
									{LD: 'Rainforest card reader standby screen displaying 6-digit registration code'},
									_List_fromArray(
										[
											$author$project$Ui$Image$width(320),
											$author$project$Ui$Image$height(320)
										]),
									6)
								]))
						]))
				])),
			A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'margin-bottom', '3px')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Identify the reader\'s registration code.')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Registration codes are the 6 digits displayed on the reader screen.')
								]))
						]))
				])),
			A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Fill in the registration code below')
				]))
		]);
};
var $author$project$Ui$Image$StripeCardReaderSplash = 5;
var $author$project$Pages$Admin$CardReaders$viewStripeConnectInstructions = function (imageStore) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Popover$view,
					_List_fromArray(
						[$author$project$Ui$Popover$dark]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Make sure the reader is on standby mode ')
										])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Ui$Icon$help(_List_Nil)
										]))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Popover$body,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('The standby reader screen should look like this:')
								])),
							A2(
							$author$project$Ui$Popover$footer,
							_List_Nil,
							_List_fromArray(
								[
									A4(
									$author$project$Ui$Image$view,
									imageStore,
									{LD: 'Stripe card reader standby screen showing welcome message'},
									_List_Nil,
									5)
								]))
						]))
				])),
			A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'margin-bottom', '3px')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Generate a pairing code.')
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'margin-bottom', '3px')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Keypad: ')
								])),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Enter the key sequence 0-7-1-3-9.')
								]))
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'margin-bottom', '3px')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Touchscreen: ')
								])),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Swipe right from the left edge of the reader screen to reveal a settings button. '),
									$elm$html$Html$text('Tap the settings button and enter the admin PIN 0-7-1-3-9. Tap the generate pairing code button.')
								]))
						]))
				])),
			A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Fill in the pairing code below')
				]))
		]);
};
var $author$project$Pages$Admin$CardReaders$viewConnectInstructions = F2(
	function (imageStore, practice) {
		var _v0 = $author$project$Api$Provider$Practice$One$paymentProcessor(practice);
		if (_v0 === 'stripe') {
			return $author$project$Pages$Admin$CardReaders$viewStripeConnectInstructions(imageStore);
		} else {
			return $author$project$Pages$Admin$CardReaders$viewRainforestConnectInstructions(imageStore);
		}
	});
var $author$project$Pages$Admin$CardReaders$viewModal = F4(
	function (imageStore, practice, form, cardReader) {
		var modalConfig = {
			Tq: $elm$core$Maybe$Nothing,
			aih: 'Card Reader',
			V8: _Utils_eq(cardReader, $author$project$Api$Data$Loading),
			WG: $elm$core$Maybe$Nothing,
			WH: $elm$core$Maybe$Nothing,
			Yd: $author$project$Pages$Admin$CardReaders$Cancel,
			Yf: function (_v1) {
				return $author$project$Pages$Admin$CardReaders$Save(
					$author$project$Pages$Admin$CardReaders$Creating(form));
			}
		};
		var _v0 = $author$project$Utils$Form$fields(form);
		var label = _v0.aih;
		var code = _v0.NN;
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('How it works'),
							$author$project$Ui$Form$Group$labelSpanSm(4),
							$author$project$Ui$Form$Group$inputSpanSm(8)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$ol,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'padding-left', '1em')
										]),
									A2($author$project$Pages$Admin$CardReaders$viewConnectInstructions, imageStore, practice))
								]))
						])),
					$author$project$Ui$HorizontalRule$view(_List_Nil),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Code'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(code),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$CardReaders$FormUpdated, $author$project$Pages$Admin$CardReaders$Code)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 0, form))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Reader Name'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(label),
									$author$project$Ui$Form$Input$placeholder('e.g. Lobby Computer'),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$CardReaders$FormUpdated, $author$project$Pages$Admin$CardReaders$Label)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 1, form))
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$CardReaders$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				function () {
				var _v0 = model.aft;
				switch (_v0.$) {
					case 0:
						var _v1 = _v0.a;
						var form = _v1.a;
						var cardReader = _v1.b;
						return A4($author$project$Pages$Admin$CardReaders$viewModal, model.sF, model.ZV, form, cardReader);
					case 1:
						var _v2 = _v0.a;
						var id = _v2.a;
						var form = _v2.b;
						var cardReader = _v2.c;
						return A3($author$project$Pages$Admin$CardReaders$viewEditModal, id, form, cardReader);
					default:
						return $author$project$Utils$Html$empty;
				}
			}(),
				model.jn ? A2(
				$author$project$Components$HiConfirm$modal,
				$author$project$Pages$Admin$CardReaders$DisableIntegrationHiConfirmClosed,
				_List_fromArray(
					[
						$author$project$Components$HiConfirm$customMessage(
						_List_fromArray(
							[
								$elm$html$Html$text('Please confirm you would like to deactivate this card reader integration. '),
								$elm$html$Html$text('Your card readers may need to be synced again manually in the future.')
							]))
					])) : $author$project$Utils$Html$empty,
				function () {
				var _v3 = model.ja;
				if (!_v3.$) {
					var cardReader = _v3.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Admin$CardReaders$DeleteCardReaderHiConfirmClosed(cardReader),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('delete'),
								$author$project$Components$HiConfirm$noun('card reader')
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Form$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Card Readers')
											]))
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								function () {
									var _v4 = model.mD;
									switch (_v4.$) {
										case 3:
											var conf = _v4.a;
											var _v5 = $author$project$Api$Provider$CardReaderConfiguration$One$status(conf);
											if (!_v5) {
												return $author$project$Pages$Admin$CardReaders$viewActiveAccount(model);
											} else {
												return $author$project$Pages$Admin$CardReaders$viewInactiveAccount(model.ZV);
											}
										case 1:
											return _List_fromArray(
												[
													$author$project$Ui$Spinner$view(_List_Nil)
												]);
										default:
											return _List_Nil;
									}
								}())
							]))
					]))
			]),
		ac9: 'Admin | Card Readers'
	};
};
var $author$project$Pages$Admin$CardReaders$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$CardReaders$init, aiq: $author$project$Pages$Admin$CardReaders$load, k8: $author$project$Pages$Admin$CardReaders$save, alO: $author$project$Pages$Admin$CardReaders$subscriptions, adT: $author$project$Pages$Admin$CardReaders$update, amo: $author$project$Pages$Admin$CardReaders$view});
var $author$project$Pages$Admin$Categories$GotCategories = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Common$Category$ListOptionals$ThisMonthChargesAggregates = 0;
var $author$project$Api$Provider$Category$categoriesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['categories']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Category$All$Category = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Category$Shared$Category = $elm$core$Basics$identity;
var $author$project$Api$Provider$Category$Shared$Record = F3(
	function (id, name, defaultForMemberships) {
		return {Ho: defaultForMemberships, ahP: id, Bq: name};
	});
var $author$project$Api$Provider$Category$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'default_for_memberships',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Category$Shared$Record))));
var $author$project$Api$Provider$Category$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Category$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Category$All$Record = F3(
	function (lastUsedAt, chargesThisMonthCount, chargesThisMonthAmountInCents) {
		return {NB: chargesThisMonthAmountInCents, NC: chargesThisMonthCount, VO: lastUsedAt};
	});
var $author$project$Api$Provider$Category$All$recordDecoder = A3(
	$author$project$Api$Expandable$expandable,
	'charges_this_month_amount_in_cents',
	$elm$json$Json$Decode$int,
	A3(
		$author$project$Api$Expandable$expandable,
		'charges_this_month_count',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'last_used_at',
			$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Category$All$Record))));
var $author$project$Api$Provider$Category$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Category$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Category$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Category$All$Category)));
var $author$project$Api$Param$Bool = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Api$Param$bool = $author$project$Api$Param$Bool;
var $author$project$Api$Common$Category$ListOptionals$defaults = {Ho: $elm$core$Maybe$Nothing, HE: _List_Nil, ahP: $elm$core$Maybe$Nothing, ajJ: $author$project$Api$Pagination$init, akl: $elm$core$Maybe$Nothing, alA: $author$project$Api$Sort$init};
var $author$project$Api$Common$Category$ListOptionals$expandToString = function (expand) {
	return 'this_month_charges_aggregates';
};
var $author$project$Api$Expandable$toParam = F2(
	function (toString, expand) {
		return _List_fromArray(
			[
				A2(
				$author$project$Api$Param$list,
				'expand',
				A2($elm$core$List$map, toString, expand))
			]);
	});
var $author$project$Api$Common$Category$ListOptionals$toParams = function (optionals) {
	var options = optionals($author$project$Api$Common$Category$ListOptionals$defaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.akl;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.ahP;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.Ho;
				if (!_v2.$) {
					var bool = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$bool, 'default_for_memberships', bool)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$elm$core$List$isEmpty(options.HE) ? _List_Nil : A2($author$project$Api$Expandable$toParam, $author$project$Api$Common$Category$ListOptionals$expandToString, options.HE),
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$Provider$Category$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Category$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Common$Category$ListOptionals$toParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Category$categoriesPath)));
	});
var $author$project$Pages$Admin$Categories$fetchCategories = function (model) {
	return A3(
		$author$project$Api$Provider$Category$list,
		model.Gv,
		function (d) {
			return _Utils_update(
				d,
				{
					HE: _List_fromArray(
						[0]),
					ajJ: model.ajJ
				});
		},
		$author$project$Pages$Admin$Categories$GotCategories);
};
var $author$project$Pages$Admin$Categories$init = F4(
	function (_v0, practice, shared, _v1) {
		var model = {Gv: shared.Gv, Nr: $author$project$Api$Data$Loading, GW: $elm$core$Maybe$Nothing, ea: $elm$core$Set$empty, cu: $elm$core$Maybe$Nothing, ajJ: $author$project$Api$Pagination$init, ZV: practice, J7: shared.J7};
		return _Utils_Tuple2(
			model,
			$author$project$Pages$Admin$Categories$fetchCategories(model));
	});
var $author$project$Pages$Admin$Categories$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Categories$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Categories$CancelCategoryEdit = {$: 2};
var $author$project$Pages$Admin$Categories$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Api$Provider$Category$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Category$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Category$Shared$id(shared);
};
var $author$project$Pages$Admin$Categories$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Admin$Categories$CancelCategoryEdit)),
					model.GW)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$Categories$HiConfirmClosed),
						$author$project$Api$Provider$Category$All$id),
					model.cu))
			]));
};
var $author$project$Pages$Admin$Categories$CategoryDeleted = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Api$Provider$Category$categoryPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$Category$categoriesPath);
};
var $author$project$Api$Provider$Category$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Category$categoryPath(id_)));
	});
var $author$project$Api$Provider$Category$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$Category$All$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Category$Shared$name(shared);
};
var $author$project$Pages$Admin$Categories$formFieldsFromCategory = function (category) {
	return $author$project$Api$Provider$Category$All$name(category);
};
var $author$project$Pages$Admin$Categories$formFieldsInit = '';
var $author$project$Pages$Admin$Categories$formFieldsUpdate = F2(
	function (field, _v0) {
		var string = field;
		return string;
	});
var $author$project$Pages$Admin$Categories$NameValidation = 0;
var $author$project$Pages$Admin$Categories$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			$elm$core$Basics$identity,
			_Utils_Tuple2(0, 'Please enter a name.'))
		]));
var $author$project$Pages$Admin$Categories$CategoryCreated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$Category$One$Category = 0;
var $author$project$Api$Provider$Category$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Provider$Category$create = F3(
	function (apiClient, name_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'category',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(name_))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Category$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Category$categoriesPath)));
	});
var $author$project$Pages$Admin$Categories$createCategory = F2(
	function (apiClient, formFields) {
		var name = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A3($author$project$Api$Provider$Category$create, apiClient, name, $author$project$Pages$Admin$Categories$CategoryCreated);
	});
var $author$project$Pages$Admin$Categories$CategoryUpdated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$Category$update = F4(
	function (apiClient, id_, name_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'category',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(name_))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Category$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Category$categoryPath(id_))));
	});
var $author$project$Pages$Admin$Categories$updateCategory = F3(
	function (apiClient, id, formFields) {
		var name = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4($author$project$Api$Provider$Category$update, apiClient, id, name, $author$project$Pages$Admin$Categories$CategoryUpdated);
	});
var $author$project$Pages$Admin$Categories$saveCategory = F3(
	function (apiClient, maybeId, formFields) {
		if (!maybeId.$) {
			var id = maybeId.a;
			return A3($author$project$Pages$Admin$Categories$updateCategory, apiClient, id, formFields);
		} else {
			return A2($author$project$Pages$Admin$Categories$createCategory, apiClient, formFields);
		}
	});
var $author$project$Pages$Admin$Categories$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							GW: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init($author$project$Pages$Admin$Categories$formFieldsInit),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var field = msg.a;
				var _v1 = model.GW;
				if (!_v1.$) {
					var _v2 = _v1.a;
					var id = _v2.a;
					var form = _v2.b;
					var category = _v2.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$Categories$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								GW: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, category))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				var form = msg.a;
				var id = msg.b;
				var _v3 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$Categories$formFieldsValidator, form);
				if (!_v3.$) {
					var _v4 = _v3.a;
					var newForm = _v4.a;
					var validFormFields = _v4.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								GW: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, $author$project$Api$Data$Loading))
							}),
						A3($author$project$Pages$Admin$Categories$saveCategory, model.Gv, id, validFormFields),
						_List_Nil);
				} else {
					var newForm = _v3.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								GW: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 1:
				var category = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							GW: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(
										$author$project$Api$Provider$Category$All$id(category)),
									$author$project$Utils$Form$init(
										$author$project$Pages$Admin$Categories$formFieldsFromCategory(category)),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{GW: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Nr: response,
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Nr: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 6:
				var response = msg.a;
				var _v6 = model.GW;
				if (!_v6.$) {
					var _v7 = _v6.a;
					var id = _v7.a;
					var form = _v7.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{GW: $elm$core$Maybe$Nothing}),
							$author$project$Pages$Admin$Categories$fetchCategories(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Charge category successfully created')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									GW: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var response = msg.a;
				var _v9 = model.GW;
				if (!_v9.$) {
					var _v10 = _v9.a;
					var id = _v10.a;
					var form = _v10.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{GW: $elm$core$Maybe$Nothing}),
							$author$project$Pages$Admin$Categories$fetchCategories(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Charge category successfully updated')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									GW: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 8:
				var id = msg.a;
				var dataCategory = msg.b;
				switch (dataCategory.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									Nr: $author$project$Api$Data$Loading,
									ea: A2($elm$core$Set$remove, id, model.ea)
								}),
							$author$project$Pages$Admin$Categories$fetchCategories(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Charge category successfully deleted')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ea: A2($elm$core$Set$remove, id, model.ea)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(dataCategory));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					$author$project$Pages$Admin$Categories$fetchCategories(newModel),
					_List_Nil);
			case 10:
				var category = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							cu: $elm$core$Maybe$Just(category)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var id = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ea: A2($elm$core$Set$insert, id, model.ea),
							cu: $elm$core$Maybe$Nothing
						}),
					A3(
						$author$project$Api$Provider$Category$delete,
						model.Gv,
						id,
						$author$project$Pages$Admin$Categories$CategoryDeleted(id)),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{cu: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
		}
	});
var $author$project$Pages$Admin$Categories$NewCategory = {$: 0};
var $author$project$Pages$Admin$Categories$PaginationMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Admin$Categories$FormUpdated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$Categories$Name = $elm$core$Basics$identity;
var $author$project$Pages$Admin$Categories$SaveCategory = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$Admin$Categories$viewCategoryModal = F3(
	function (maybeId, category, form) {
		var name = $author$project$Utils$Form$fields(form);
		var modalConfig = {
			Tq: $elm$core$Maybe$Nothing,
			aih: 'Charge Category',
			V8: _Utils_eq(category, $author$project$Api$Data$Loading),
			WG: maybeId,
			WH: $elm$core$Maybe$Nothing,
			Yd: $author$project$Pages$Admin$Categories$CancelCategoryEdit,
			Yf: $author$project$Pages$Admin$Categories$SaveCategory(form)
		};
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$required(true),
							$author$project$Ui$Form$Group$label('Name')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(name),
									$author$project$Ui$Form$Input$placeholder('Diagnostics'),
									$author$project$Ui$Form$Input$autofocus(true),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Categories$FormUpdated, $elm$core$Basics$identity)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form))
								])),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						]))
				]));
	});
var $author$project$Pages$Admin$Categories$EditCategory = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Feature$JointProduct = 6;
var $author$project$Pages$Admin$Categories$OpenHiConfirm = function (a) {
	return {$: 10, a: a};
};
var $author$project$Formatters$Time$Time__AgoInWords = 1;
var $author$project$Api$Provider$Category$All$chargesThisMonthAmountInCents = function (_v0) {
	var record = _v0.b;
	return record.NB;
};
var $author$project$Api$Provider$Category$All$chargesThisMonthCount = function (_v0) {
	var record = _v0.b;
	return record.NC;
};
var $author$project$Api$Provider$Category$Shared$defaultForMemberships = function (_v0) {
	var record = _v0;
	return record.Ho;
};
var $author$project$Api$Provider$Category$All$defaultForMemberships = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Category$Shared$defaultForMemberships(shared);
};
var $author$project$Api$Provider$Category$All$lastUsedAt = function (_v0) {
	var record = _v0.b;
	return record.VO;
};
var $author$project$Ui$Link$RouteParams = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Link$routeParams = $author$project$Ui$Link$RouteParams;
var $author$project$Api$Expandable$withDefault = F2(
	function (_default, expandable_) {
		if (!expandable_.$) {
			var a = expandable_.a;
			return a;
		} else {
			return _default;
		}
	});
var $author$project$Pages$Admin$Categories$viewCategory = F4(
	function (practice, timeFormatter, deletingCategories, category) {
		var id = $author$project$Api$Provider$Category$All$id(category);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$Category$All$name(category))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							(A2(
							$author$project$Api$Expandable$withDefault,
							0,
							$author$project$Api$Provider$Category$All$chargesThisMonthCount(category)) > 0) ? A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Reports__Revenue,
							_List_fromArray(
								[
									$author$project$Ui$Link$routeParams(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'category', id)
										]))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(
										A2(
											$author$project$Api$Expandable$withDefault,
											0,
											$author$project$Api$Provider$Category$All$chargesThisMonthAmountInCents(category))) + ' this month')
								])) : $elm$html$Html$text('0')
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[$author$project$Ui$Typography$muted]),
							A2(
								$elm$core$Maybe$withDefault,
								'Never',
								A2(
									$elm$core$Maybe$map,
									timeFormatter(1),
									$author$project$Api$Provider$Category$All$lastUsedAt(category))))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					function () {
						if ($author$project$Api$Provider$Category$All$defaultForMemberships(category)) {
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$muted]),
									'Default for memberships')
								]);
						} else {
							if (A2($author$project$Api$Provider$Practice$One$featureEnabled, 6, practice) && ($author$project$Api$Provider$Category$All$name(category) === 'Medications')) {
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$text,
										_List_fromArray(
											[$author$project$Ui$Typography$muted]),
										'Default for medications')
									]);
							} else {
								if (A2($author$project$Api$Provider$Practice$One$featureEnabled, 6, practice) && ($author$project$Api$Provider$Category$All$name(category) === 'Labs')) {
									return _List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[$author$project$Ui$Typography$muted]),
											'Default for labs')
										]);
								} else {
									var loading = A2($elm$core$Set$member, id, deletingCategories);
									return _List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$gap2, $author$project$Ui$Element$justifyRight]),
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Button$view,
													{mm: 'Edit charge category '},
													_List_fromArray(
														[
															$author$project$Ui$Button$link,
															$author$project$Ui$Button$sm,
															$author$project$Ui$Button$disabled(loading),
															$author$project$Ui$Button$onClick(
															$author$project$Pages$Admin$Categories$EditCategory(category)),
															$author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Edit')
														])),
													A3(
													$author$project$Ui$Button$view,
													{mm: 'Delete charge category '},
													_List_fromArray(
														[
															$author$project$Ui$Button$link,
															$author$project$Ui$Button$sm,
															$author$project$Ui$Button$loading(loading),
															$author$project$Ui$Button$onClick(
															$author$project$Pages$Admin$Categories$OpenHiConfirm(category)),
															$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Delete')
														]))
												]))
										]);
								}
							}
						}
					}())
				]));
	});
var $author$project$Pages$Admin$Categories$viewPanelBody = function (model) {
	var _v0 = function () {
		var _v1 = model.Nr;
		if (_v1.$ === 3) {
			var categories_ = _v1.a;
			return _Utils_Tuple2(false, categories_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var categories = _v0.b;
	return A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$verticalCentered,
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('None')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Name')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Charges this month')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Last used')
					])),
				A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
			]),
		A2(
			$elm$core$List$map,
			A3($author$project$Pages$Admin$Categories$viewCategory, model.ZV, model.J7, model.ea),
			categories),
		_List_Nil);
};
var $author$project$Pages$Admin$Categories$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				function () {
				var _v0 = model.GW;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var id = _v1.a;
					var form = _v1.b;
					var category = _v1.c;
					return A3($author$project$Pages$Admin$Categories$viewCategoryModal, id, category, form);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v2 = model.cu;
				if (!_v2.$) {
					var category = _v2.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Admin$Categories$HiConfirmClosed(
							$author$project$Api$Provider$Category$All$id(category)),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('delete'),
								$author$project$Components$HiConfirm$noun('charge category'),
								$author$project$Components$HiConfirm$detail(
								$author$project$Api$Provider$Category$All$name(category) + ' and remove it from all historical charges')
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_fromArray(
							[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Charge Categories')
									])),
								A3(
								$author$project$Ui$Button$view,
								{mm: 'New charge category'},
								_List_fromArray(
									[
										$author$project$Ui$Button$default,
										$author$project$Ui$Button$onClick($author$project$Pages$Admin$Categories$NewCategory),
										$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('New Charge Category')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Pages$Admin$Categories$viewPanelBody(model)
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Admin$Categories$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(
											!$author$project$Api$Data$isSuccess(model.Nr))
										]),
									model.ajJ))
							]))
					]))
			]),
		ac9: 'Admin | Charge Categories'
	};
};
var $author$project$Pages$Admin$Categories$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Categories$init, aiq: $author$project$Pages$Admin$Categories$load, k8: $author$project$Pages$Admin$Categories$save, alO: $author$project$Pages$Admin$Categories$subscriptions, adT: $author$project$Pages$Admin$Categories$update, amo: $author$project$Pages$Admin$Categories$view});
var $author$project$Pages$Admin$ChargeItems$Id_String$ChargeItemFormMsg = $elm$core$Basics$identity;
var $author$project$Components$Admin$ChargeItems$Form$CategoryResourceFilterMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Admin$ChargeItems$Form$CodeTypeDropdownMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Admin$ChargeItems$Form$ExpirationDatePickerMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Admin$ChargeItems$Form$GotItem = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$ChargeItems$Form$GotToday = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Admin$ChargeItems$Form$Model = $elm$core$Basics$identity;
var $author$project$Api$Provider$ChargeItem$Shared$Item = 0;
var $author$project$Components$Admin$ChargeItems$Form$NoExpiration = 0;
var $author$project$Components$TranslatedRichText$DropdownMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$TranslatedRichText$init = F2(
	function (initialTranslations, dropdownId) {
		return {
			f4: $author$project$Language$english,
			gi: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: dropdownId, al6: $author$project$Components$TranslatedRichText$DropdownMsg})),
			gC: false,
			adD: initialTranslations
		};
	});
var $author$project$Components$Admin$ChargeItems$Form$revenueRecognitionItemConsumption = 'deferred';
var $author$project$Components$Admin$ChargeItems$Form$formFieldsInit = {
	Lm: $elm$core$Maybe$Nothing,
	MZ: false,
	GW: $elm$core$Maybe$Nothing,
	NN: '',
	NP: $elm$core$Maybe$Nothing,
	rQ: $elm$core$Maybe$Nothing,
	PL: $elm$core$Maybe$Nothing,
	Qr: $elm$core$Maybe$Nothing,
	jy: false,
	RW: $elm$core$Maybe$Nothing,
	RX: '1',
	ag: 0,
	RY: 'months',
	nW: 0,
	TP: $elm$core$Maybe$Nothing,
	sW: 0,
	VM: $elm$core$Maybe$Nothing,
	Wt: '',
	W4: $elm$core$Maybe$Nothing,
	Bq: '',
	YF: _List_Nil,
	Dw: $elm$core$Maybe$Nothing,
	_P: $elm$core$Maybe$Nothing,
	$0: $author$project$Components$Admin$ChargeItems$Form$revenueRecognitionItemConsumption,
	bh: A2($author$project$Components$TranslatedRichText$init, $elm$core$Dict$empty, 'rich-description-language'),
	acZ: false,
	ads: false,
	adP: 'each'
};
var $author$project$Components$ResourceFilter$All = {$: 2};
var $author$project$Components$ResourceFilter$Category$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Api$Category$All$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Category$All$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Data$employerPath = $author$project$Api$Data$newPath(
	_List_fromArray(
		['employer']));
var $author$project$Api$Employer$Category$categoriesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['categories']),
	$author$project$Api$Data$employerPath);
var $author$project$Api$Employer$Category$All$Category = $elm$core$Basics$identity;
var $author$project$Api$Employer$Category$Shared$Category = $elm$core$Basics$identity;
var $author$project$Api$Employer$Category$Shared$Record = F2(
	function (id, name) {
		return {ahP: id, Bq: name};
	});
var $author$project$Api$Employer$Category$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$Category$Shared$Record)));
var $author$project$Api$Employer$Category$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Category$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Category$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Category$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Category$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Employer$Category$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Common$Category$ListOptionals$toParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Employer$Category$categoriesPath)));
	});
var $author$project$Api$Category$list = F4(
	function (apiClient, session, optionals, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$Category$list,
			apiClient,
			optionals,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$Category$All$Employer)))) : A3(
			$author$project$Api$Provider$Category$list,
			apiClient,
			optionals,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$Category$All$Provider))));
	});
var $author$project$Components$ResourceFilter$Category$list = $author$project$Api$Category$list;
var $author$project$Api$Employer$Category$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Employer$Category$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Category$Shared$id(shared);
};
var $author$project$Api$Category$All$id = function (category) {
	if (!category.$) {
		var category_ = category.a;
		return $author$project$Api$Provider$Category$All$id(category_);
	} else {
		var category_ = category.a;
		return $author$project$Api$Employer$Category$All$id(category_);
	}
};
var $author$project$Api$Employer$Category$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Employer$Category$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Category$Shared$name(shared);
};
var $author$project$Api$Category$All$name = function (category) {
	if (!category.$) {
		var category_ = category.a;
		return $author$project$Api$Provider$Category$All$name(category_);
	} else {
		var category_ = category.a;
		return $author$project$Api$Employer$Category$All$name(category_);
	}
};
var $author$project$Components$ResourceFilter$Category$resourceFromAll = function (category) {
	return {
		ahP: $author$project$Api$Category$All$id(category),
		Bq: $author$project$Api$Category$All$name(category)
	};
};
var $author$project$Components$ResourceFilter$Category$fetchResources = F5(
	function (session, toMsg, apiClient, pagination, query) {
		return A4(
			$author$project$Components$ResourceFilter$Category$list,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{ajJ: pagination, akl: query});
			},
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Components$ResourceFilter$Category$resourceFromAll))));
	});
var $author$project$Components$ResourceFilter$DropdownMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$ResourceFilter$GotItems = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$ResourceFilter$choiceToLabel = F6(
	function (allLabel, noneLabel, freeTextPrefix, resourceName, toLabel, choice) {
		switch (choice.$) {
			case 2:
				return _List_fromArray(
					[
						$elm$html$Html$text(allLabel)
					]);
			case 3:
				return _List_fromArray(
					[
						$elm$html$Html$text(noneLabel)
					]);
			case 0:
				var item = choice.a;
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$span,
						_List_fromArray(
							[
								$author$project$Ui$Typography$phi(true)
							]),
						A2(
							$elm$core$List$map,
							$elm$html$Html$map($elm$core$Basics$never),
							toLabel(item)))
					]);
			case 1:
				var items = choice.a;
				var count = $elm$core$List$length(items);
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$text,
						_List_Nil,
						A2($author$project$Formatters$String$pluralize, resourceName, count) + ' Selected')
					]);
			case 4:
				var extraItem = choice.a;
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$text,
						_List_fromArray(
							[
								$author$project$Ui$Typography$phi(true)
							]),
						extraItem.aih)
					]);
			default:
				var string = choice.a;
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$text,
						_List_fromArray(
							[
								$author$project$Ui$Typography$phi(true)
							]),
						freeTextPrefix),
						A2(
						$author$project$Ui$Typography$text,
						_List_fromArray(
							[
								$author$project$Ui$Typography$phi(true)
							]),
						string)
					]);
		}
	});
var $author$project$Components$ResourceFilter$defaults = {
	Gp: 'All',
	Lr: true,
	aeQ: $elm$core$Maybe$Nothing,
	ag$: $elm$core$Maybe$Nothing,
	jG: $elm$core$Maybe$Nothing,
	ag0: $elm$core$Maybe$Nothing,
	gq: _List_Nil,
	ahw: false,
	ahx: 'Custom: ',
	ahG: false,
	ahH: false,
	VZ: 10,
	XY: 'None',
	ai5: false,
	ai6: $elm$core$Maybe$Just(''),
	ajB: $elm$core$Maybe$Nothing,
	akb: $elm$core$Maybe$Nothing,
	akl: $elm$core$Maybe$Nothing,
	JK: true
};
var $author$project$Components$ResourceFilter$SetPreSelected = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$ResourceFilter$setPreSelected = function (attempts) {
	return A2(
		$elm$core$Task$perform,
		function (_v0) {
			return $author$project$Components$ResourceFilter$SetPreSelected(attempts + 1);
		},
		$elm$core$Process$sleep(10));
};
var $author$project$Ui$Dropdown$TopRight = 4;
var $author$project$Ui$Dropdown$toTopRight = function (config) {
	return _Utils_update(
		config,
		{bv: 4});
};
var $author$project$Api$Pagination$withItemsPerPage = F2(
	function (itemsPerPage, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{gG: itemsPerPage});
	});
var $author$project$Components$ResourceFilter$init = F3(
	function (apiClient, required, optionals) {
		var search = required.Sk;
		var options = optionals($author$project$Components$ResourceFilter$defaults);
		var pagination = A2($author$project$Api$Pagination$withItemsPerPage, options.VZ, $author$project$Api$Pagination$init);
		var choiceToLabelFunc = A5($author$project$Components$ResourceFilter$choiceToLabel, options.Gp, options.XY, options.ahx, required.k$, required.u9);
		return _Utils_Tuple2(
			{
				GY: choiceToLabelFunc,
				bu: $elm$core$Maybe$Nothing,
				d6: $jinjor$elm_debounce$Debounce$init,
				gi: $author$project$Ui$Dropdown$init(
					function () {
						var _v0 = options.ajB;
						if (!_v0.$) {
							var _v1 = _v0.a;
							return $author$project$Ui$Dropdown$toTopRight;
						} else {
							return $elm$core$Basics$identity;
						}
					}()(
						$author$project$Ui$Dropdown$defaultConfig(
							{ahP: 'resource-filter-dropdown-' + required.ahP, al6: $author$project$Components$ResourceFilter$DropdownMsg}))),
				ag$: options.ag$,
				jG: options.jG,
				ag0: options.ag0,
				gq: options.gq,
				SI: $elm$core$Maybe$Nothing,
				s3: false,
				Cd: options,
				ajJ: pagination,
				akb: options.akb,
				akl: options.akl,
				k$: required.k$,
				uk: required.uk,
				uo: search,
				En: false,
				u9: required.u9,
				lN: required.lN,
				hX: required.hX,
				vc: $elm$core$Maybe$Nothing
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A4(
						search,
						$author$project$Components$ResourceFilter$GotItems(false),
						apiClient,
						pagination,
						options.akl),
						function () {
						var _v2 = options.akb;
						if (!_v2.$) {
							return $author$project$Components$ResourceFilter$setPreSelected(0);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}()
					])));
	});
var $author$project$Components$ResourceFilter$Category$retrieveResource = F4(
	function (session, toMsg, apiClient, id) {
		return A4(
			$author$project$Components$ResourceFilter$Category$list,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{
						ahP: $elm$core$Maybe$Just(id)
					});
			},
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Components$ResourceFilter$Category$resourceFromAll))));
	});
var $author$project$Components$ResourceFilter$Category$selectId = 'category';
var $author$project$Components$ResourceFilter$Category$toTitle = function ($) {
	return $.Bq;
};
var $author$project$Components$ResourceFilter$Category$toLabel = function (resource) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Components$ResourceFilter$Category$toTitle(resource))
		]);
};
var $author$project$Components$ResourceFilter$Category$toValue = function ($) {
	return $.ahP;
};
var $author$project$Components$ResourceFilter$Category$init = F3(
	function (apiClient, session, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{
				Sk: $author$project$Components$ResourceFilter$Category$fetchResources(session),
				ahP: $author$project$Components$ResourceFilter$Category$selectId,
				k$: 'Category',
				uk: $author$project$Components$ResourceFilter$Category$retrieveResource(session),
				u9: $author$project$Components$ResourceFilter$Category$toLabel,
				lN: $author$project$Components$ResourceFilter$Category$toTitle,
				hX: $author$project$Components$ResourceFilter$Category$toValue
			},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{Jy: $author$project$Components$ResourceFilter$All, b8: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Api$Provider$ChargeItem$chargeItemsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['charge_items']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$ChargeItem$chargeItemPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$ChargeItem$chargeItemsPath);
};
var $author$project$Api$Provider$ChargeItem$One$ChargeItem = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$ChargeItem$Shared$ChargeItem = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$ChargeItem$Min$ChargeItem = $elm$core$Basics$identity;
var $author$project$Api$Provider$ChargeItem$Min$Record = F2(
	function (id, name) {
		return {ahP: id, Bq: name};
	});
var $author$project$Api$Provider$ChargeItem$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeItem$Min$Record)));
var $author$project$Api$Provider$ChargeItem$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ChargeItem$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$ChargeItem$Shared$Record = function (description) {
	return function (lastUsedAt) {
		return function (quantityInStock) {
			return function (priceInCents) {
				return function (lastSetQuantity) {
					return function (lowInventory) {
						return function (outOfStock) {
							return function (taxable) {
								return function (buyable) {
									return function (trackInventory) {
										return function (alertQuantity) {
											return function (daysSupply) {
												return function (code) {
													return function (codeType) {
														return function (manufacturer) {
															return function (itemType) {
																return function (templatePackage) {
																	return function (richDescriptions) {
																		return function (imageUrl) {
																			return {Lm: alertQuantity, MZ: buyable, NN: code, NP: codeType, PL: daysSupply, Qr: description, TP: imageUrl, sW: itemType, VM: lastSetQuantity, VO: lastUsedAt, Wm: lowInventory, Wt: manufacturer, Yz: outOfStock, Dw: priceInCents, _P: quantityInStock, Eh: richDescriptions, acZ: taxable, qu: templatePackage, ads: trackInventory};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $author$project$Components$TranslatedRichText$decoder = function (fieldName) {
	var filterNulls = function (dict) {
		return $elm$core$Dict$fromList(
			A2(
				$elm$core$List$filterMap,
				function (_v0) {
					var key = _v0.a;
					var maybeValue = _v0.b;
					return A2(
						$elm$core$Maybe$map,
						function (value) {
							return _Utils_Tuple2(key, value);
						},
						maybeValue);
				},
				$elm$core$Dict$toList(dict)));
	};
	return A2(
		$elm$json$Json$Decode$map,
		filterNulls,
		A2(
			$elm$json$Json$Decode$field,
			fieldName,
			$elm$json$Json$Decode$dict(
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string))));
};
var $author$project$Api$Provider$ChargeItem$Shared$decodeRichDescriptions = $author$project$Components$TranslatedRichText$decoder('rich_description');
var $author$project$Api$Provider$ChargeItem$Shared$Package = 1;
var $author$project$Api$Provider$ChargeItem$Shared$stringToItemType = function (str) {
	switch (str) {
		case 'item':
			return 0;
		case 'package':
			return 1;
		default:
			return 0;
	}
};
var $author$project$Api$Provider$ChargeItem$Shared$TemplatePackage = F5(
	function (packageItems, expirationNumber, expirationUnit, expirationDate, revenueRecognition) {
		return {RW: expirationDate, RX: expirationNumber, RY: expirationUnit, YF: packageItems, $0: revenueRecognition};
	});
var $author$project$Api$Provider$ChargeItem$Shared$decodeDateString = function (str) {
	var _v0 = $justinmimbs$date$Date$fromIsoString(str);
	if (!_v0.$) {
		var date = _v0.a;
		return $elm$json$Json$Decode$succeed(date);
	} else {
		return $elm$json$Json$Decode$fail('Invalid date: ' + str);
	}
};
var $author$project$Api$Provider$PackageItem$Shared$PackageItem = F7(
	function (id, chargeItemId, chargeItemName, chargeItemTaxable, chargeItemPriceInCents, quantity, priceInCents) {
		return {afA: chargeItemId, afB: chargeItemName, afC: chargeItemPriceInCents, afD: chargeItemTaxable, ahP: id, Dw: priceInCents, Dz: quantity};
	});
var $author$project$Currency$decode = A2($elm$json$Json$Decode$map, $author$project$Currency$fromInt, $elm$json$Json$Decode$int);
var $author$project$Api$Provider$PackageItem$Shared$decoder = function () {
	var extractChargeItemTaxable = A2(
		$elm$json$Json$Decode$field,
		'charge_item',
		$elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, 'taxable', $elm$json$Json$Decode$bool)));
	var extractChargeItemPriceInCents = A2(
		$elm$json$Json$Decode$field,
		'charge_item',
		$elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, 'price_in_cents', $elm$json$Json$Decode$float)));
	var extractChargeItemName = A2(
		$elm$json$Json$Decode$field,
		'charge_item',
		$elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string)));
	var extractChargeItemId = A2(
		$elm$json$Json$Decode$field,
		'charge_item',
		A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string));
	return A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'price_in_cents',
		$author$project$Currency$decode,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'quantity',
			$elm$json$Json$Decode$int,
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				extractChargeItemPriceInCents,
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
					extractChargeItemTaxable,
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
						extractChargeItemName,
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
							extractChargeItemId,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'id',
								$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
								$elm$core$Maybe$Nothing,
								$elm$json$Json$Decode$succeed($author$project$Api$Provider$PackageItem$Shared$PackageItem))))))));
}();
var $author$project$Api$Provider$ChargeItem$Shared$templatePackageDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'revenue_recognition',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'expiration_date',
		$elm$json$Json$Decode$nullable(
			A2($elm$json$Json$Decode$andThen, $author$project$Api$Provider$ChargeItem$Shared$decodeDateString, $elm$json$Json$Decode$string)),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'expiration_unit',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'expiration_number',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'package_items',
					$elm$json$Json$Decode$list($author$project$Api$Provider$PackageItem$Shared$decoder),
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeItem$Shared$TemplatePackage))))));
var $author$project$Api$Provider$ChargeItem$Shared$recordDecoder = function () {
	var decodeTemplatePackage = $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$field,
				'package',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Api$Provider$ChargeItem$Shared$templatePackageDecoder)),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
	return A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'image_url',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			$author$project$Api$Provider$ChargeItem$Shared$decodeRichDescriptions,
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				decodeTemplatePackage,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'item_type',
					A2($elm$json$Json$Decode$map, $author$project$Api$Provider$ChargeItem$Shared$stringToItemType, $elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'manufacturer',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'code_type',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'code',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'days_supply',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'alert_quantity',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'track_inventory',
											$elm$json$Json$Decode$bool,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'buyable',
												$elm$json$Json$Decode$bool,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'taxable',
													$elm$json$Json$Decode$bool,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'out_of_stock',
														$elm$json$Json$Decode$bool,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'low_inventory',
															$elm$json$Json$Decode$bool,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'last_set_quantity',
																$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'price_in_cents',
																	$elm$json$Json$Decode$float,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'quantity_in_stock',
																		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'last_used_at',
																			$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'description',
																				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																				$elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeItem$Shared$Record))))))))))))))))))));
}();
var $author$project$Api$Provider$ChargeItem$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ChargeItem$Shared$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$ChargeItem$Min$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeItem$Shared$ChargeItem)));
var $author$project$Api$Provider$ChargeItem$One$Record = F3(
	function (category, uom, meta) {
		return {GW: category, W4: meta, adP: uom};
	});
var $author$project$Api$Provider$ChargeItem$Meta$Meta = $elm$core$Basics$identity;
var $author$project$Api$Provider$ChargeItem$Meta$MetaRecord = function (uom) {
	return {adP: uom};
};
var $author$project$Api$Provider$ChargeItem$Meta$EditableRecord = function (editable) {
	return {Q4: editable};
};
var $author$project$Api$Provider$ChargeItem$Meta$editableRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'editable',
	$elm$json$Json$Decode$bool,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeItem$Meta$EditableRecord));
var $author$project$Api$Provider$ChargeItem$Meta$metaRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'uom',
	$author$project$Api$Provider$ChargeItem$Meta$editableRecordDecoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeItem$Meta$MetaRecord));
var $author$project$Api$Provider$ChargeItem$Meta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ChargeItem$Meta$metaRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Uom$Shared$Uom = $elm$core$Basics$identity;
var $author$project$Api$Provider$Uom$Shared$Record = F7(
	function (code, name, unitClass, periodUnit, periodQuantity, type_, periodInMonths) {
		return {NN: code, Bq: name, Zs: periodInMonths, he: periodQuantity, hf: periodUnit, amg: type_, Kg: unitClass};
	});
var $author$project$Api$Provider$Uom$PeriodUnit$Days = 0;
var $author$project$Api$Provider$Uom$PeriodUnit$HalfYears = 3;
var $author$project$Api$Provider$Uom$PeriodUnit$Months = 1;
var $author$project$Api$Provider$Uom$PeriodUnit$Quarters = 2;
var $author$project$Api$Provider$Uom$PeriodUnit$Years = 4;
var $author$project$Api$Provider$Uom$PeriodUnit$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'days':
				return $elm$json$Json$Decode$succeed(0);
			case 'months':
				return $elm$json$Json$Decode$succeed(1);
			case 'quarters':
				return $elm$json$Json$Decode$succeed(2);
			case 'half_years':
				return $elm$json$Json$Decode$succeed(3);
			case 'years':
				return $elm$json$Json$Decode$succeed(4);
			default:
				var somethingElse = string;
				return $elm$json$Json$Decode$fail('Unsupported Uom -> period_unit: ' + somethingElse);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$Uom$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'period_in_months',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'type',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'period_quantity',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'period_unit',
				$elm$json$Json$Decode$nullable($author$project$Api$Provider$Uom$PeriodUnit$decode),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'unit_class',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'name',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'code',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Api$Provider$Uom$Shared$Record))))))));
var $author$project$Api$Provider$Uom$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Uom$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$ChargeItem$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'meta',
	$author$project$Api$Provider$ChargeItem$Meta$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'uom',
		$author$project$Api$Provider$Uom$Shared$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'category',
			$elm$json$Json$Decode$nullable($author$project$Api$Provider$Category$Shared$decoder),
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeItem$One$Record))));
var $author$project$Api$Provider$ChargeItem$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ChargeItem$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$ChargeItem$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeItem$One$ChargeItem)));
var $author$project$Api$Provider$ChargeItem$retrieve = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$ChargeItem$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$ChargeItem$chargeItemPath(id_)));
	});
var $author$project$Components$Admin$ChargeItems$Form$init = F4(
	function (apiClient, session, id, practice) {
		var excludedCategoryTitles = A2($author$project$Api$Provider$Practice$One$featureEnabled, 6, practice) ? $elm$core$Maybe$Just(
			_List_fromArray(
				['Labs'])) : $elm$core$Maybe$Nothing;
		var _v0 = $author$project$Components$DateInput$init;
		var expirationDatePicker = _v0.a;
		var expirationDatePickerCmd = _v0.b;
		var _v1 = function () {
			if (!id.$) {
				var id_ = id.a;
				return _Utils_Tuple2(
					$elm$core$Maybe$Nothing,
					A3($author$project$Api$Provider$ChargeItem$retrieve, apiClient, id_, $author$project$Components$Admin$ChargeItems$Form$GotItem));
			} else {
				return _Utils_Tuple2(
					$elm$core$Maybe$Just($author$project$Components$Admin$ChargeItems$Form$formFieldsInit),
					$elm$core$Platform$Cmd$none);
			}
		}();
		var formFields = _v1.a;
		var cmd = _v1.b;
		var _v3 = A3(
			$author$project$Components$ResourceFilter$Category$init,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Uncategorized', ag0: excludedCategoryTitles, ai5: false});
			});
		var categoryResourceFilter = _v3.a;
		var categoryResourceFilterCmd = _v3.b;
		return _Utils_Tuple2(
			{
				c8: categoryResourceFilter,
				fW: $elm$core$Dict$empty,
				mT: $author$project$Ui$Dropdown$init(
					$author$project$Ui$Dropdown$defaultConfig(
						{ahP: 'code-type', al6: $author$project$Components$Admin$ChargeItems$Form$CodeTypeDropdownMsg})),
				sj: expirationDatePicker,
				SD: A2($elm$core$Maybe$map, $author$project$Utils$Form$init, formFields),
				ahP: id,
				Am: false,
				b4: $elm$core$Dict$empty,
				b5: $elm$core$Dict$empty,
				ZV: practice,
				k9: $author$project$Api$Data$NotAsked,
				FR: $elm$core$Maybe$Nothing
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						cmd,
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$ChargeItems$Form$CategoryResourceFilterMsg, categoryResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$ChargeItems$Form$ExpirationDatePickerMsg, expirationDatePickerCmd),
						A2($elm$core$Task$perform, $author$project$Components$Admin$ChargeItems$Form$GotToday, $justinmimbs$date$Date$today)
					])));
	});
var $author$project$Pages$Admin$ChargeItems$Id_String$init = F4(
	function (session, practice, _v0, _v1) {
		var apiClient = _v0.Gv;
		var params = _v1.YL;
		var _v2 = A4(
			$author$project$Components$Admin$ChargeItems$Form$init,
			apiClient,
			session,
			$elm$core$Maybe$Just(params.ahP),
			practice);
		var model = _v2.a;
		var cmd = _v2.b;
		return _Utils_Tuple2(
			{Gv: apiClient, SD: model},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
	});
var $author$project$Pages$Admin$ChargeItems$Id_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$ChargeItems$Id_String$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Admin$ChargeItems$Form$PackageItemSelected = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Components$Admin$ChargeItems$Form$RichDescriptionMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$ResourceFilter$subscriptions = function (model) {
	return $author$project$Ui$Dropdown$subscriptions(model.gi);
};
var $author$project$Components$ResourceFilter$Category$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.b8));
};
var $author$project$Components$ResourceFilter$ChargeItem$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Components$ResourceFilter$ChargeItem$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.b8));
};
var $author$project$Components$TranslatedRichText$ContentChanged = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$TranslatedRichText$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				model.gC ? $author$project$Ports$CKEditor$onChange(
				F2(
					function (_v0, value) {
						return $author$project$Components$TranslatedRichText$ContentChanged(value);
					})) : $elm$core$Platform$Sub$none,
				$author$project$Ui$Dropdown$subscriptions(model.gi)
			]));
};
var $author$project$Components$Admin$ChargeItems$Form$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Admin$ChargeItems$Form$CategoryResourceFilterMsg,
				$author$project$Components$ResourceFilter$Category$subscriptions(model.c8)),
				$author$project$Ui$Dropdown$subscriptions(model.mT),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					function (form) {
						return A2(
							$elm$core$Platform$Sub$map,
							$author$project$Components$Admin$ChargeItems$Form$RichDescriptionMsg,
							$author$project$Components$TranslatedRichText$subscriptions(
								$author$project$Utils$Form$fields(form).bh));
					},
					model.SD)),
				$elm$core$Platform$Sub$batch(
				A2(
					$elm$core$List$map,
					function (_v1) {
						var key = _v1.a;
						var filter = _v1.b;
						return A2(
							$elm$core$Platform$Sub$map,
							$author$project$Components$Admin$ChargeItems$Form$PackageItemSelected(key),
							$author$project$Components$ResourceFilter$ChargeItem$subscriptions(filter));
					},
					$elm$core$Dict$toList(model.b5)))
			]));
};
var $author$project$Pages$Admin$ChargeItems$Id_String$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Admin$ChargeItems$Form$subscriptions(model.SD));
};
var $author$project$Components$Admin$ChargeItems$Form$Category = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Admin$ChargeItems$Form$CodeType = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$ResourceFilter$Extra = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$ChargeItems$Form$FormUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$ChargeItems$Form$Image = F2(
	function (a, b) {
		return {$: 26, a: a, b: b};
	});
var $author$project$Components$Admin$ChargeItems$Form$PackageItemsValidation = 5;
var $author$project$Components$Admin$ChargeItems$Form$SelectPackageItem = F5(
	function (a, b, c, d, e) {
		return {$: 19, a: a, b: b, c: c, d: d, e: e};
	});
var $author$project$Ports$Navigation$backPort = _Platform_outgoingPort(
	'backPort',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$Navigation$back = $author$project$Ports$Navigation$backPort(0);
var $author$project$Api$Provider$ChargeItem$Shared$buyable = function (_v0) {
	var record = _v0.b;
	return record.MZ;
};
var $author$project$Api$Provider$ChargeItem$One$buyable = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$buyable(shared);
};
var $author$project$Api$Provider$ChargeItem$One$category = function (_v0) {
	var record = _v0.b;
	return record.GW;
};
var $author$project$Components$Admin$ChargeItems$Form$CodeTypeValidation = 4;
var $author$project$Components$Admin$ChargeItems$Form$ExpirationValidation = 6;
var $author$project$Components$Admin$ChargeItems$Form$ImageValidation = 7;
var $author$project$Components$Admin$ChargeItems$Form$LastSetQuantityValidation = 3;
var $author$project$Components$Admin$ChargeItems$Form$NameValidation = 0;
var $author$project$Components$Admin$ChargeItems$Form$PriceInCentsValidation = 2;
var $author$project$Components$Admin$ChargeItems$Form$UomValidation = 1;
var $author$project$Utils$Form$clearGroupErrors = F2(
	function (group, _v0) {
		var originalFields = _v0.a;
		var validated_ = _v0.b;
		var fields_ = _v0.c;
		var errors_ = _v0.d;
		return A4(
			$author$project$Utils$Form$Form,
			originalFields,
			validated_,
			fields_,
			A2(
				$elm$core$List$filter,
				function (_v1) {
					var validationGroup = _v1.a;
					return !_Utils_eq(validationGroup, group);
				},
				errors_));
	});
var $author$project$Utils$FileSize$fiveMegabytes = (5 * 1024) * 1024;
var $author$project$Components$Admin$ChargeItems$Form$maxImageBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
var $author$project$Components$Admin$ChargeItems$Form$validateCodeType = function (fields) {
	return ((fields.NN !== '') && _Utils_eq(fields.NP, $elm$core$Maybe$Nothing)) ? _List_fromArray(
		[
			_Utils_Tuple2(4, 'Please pick a code type.')
		]) : _List_Nil;
};
var $author$project$Components$Admin$ChargeItems$Form$validateExpiration = function (fields) {
	if (fields.sW !== 1) {
		return _List_Nil;
	} else {
		var _v0 = fields.ag;
		switch (_v0) {
			case 0:
				return _List_Nil;
			case 1:
				var _v1 = $elm$core$String$toInt(fields.RX);
				if (!_v1.$) {
					var n = _v1.a;
					return (n > 0) ? _List_Nil : _List_fromArray(
						[
							_Utils_Tuple2(6, 'Please enter a positive number for expiration.')
						]);
				} else {
					return _List_fromArray(
						[
							_Utils_Tuple2(6, 'Please enter a valid positive number for expiration.')
						]);
				}
			default:
				var _v2 = fields.RW;
				if (_v2.$ === 1) {
					return _List_fromArray(
						[
							_Utils_Tuple2(6, 'Please select an expiration date.')
						]);
				} else {
					return _List_Nil;
				}
		}
	}
};
var $author$project$Components$Admin$ChargeItems$Form$validateLastSetQuantity = function (fields) {
	var invalid = _Utils_Tuple2(3, 'Please enter a quantity of 0 or more to track inventory for this item');
	var _v0 = _Utils_Tuple2(fields.ads, fields.VM);
	if (_v0.a) {
		if (!_v0.b.$) {
			var lastSetQuantity = _v0.b.a;
			return (lastSetQuantity < 0) ? _List_fromArray(
				[invalid]) : _List_Nil;
		} else {
			var _v1 = _v0.b;
			return _List_fromArray(
				[invalid]);
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Admin$ChargeItems$Form$validatePackageItems = function (fields) {
	if (fields.sW === 1) {
		if ($elm$core$List$isEmpty(fields.YF)) {
			return _List_fromArray(
				[
					_Utils_Tuple2(5, 'Please add at least one item to the package.')
				]);
		} else {
			var missingChargeItem = A2(
				$elm$core$List$any,
				function (item) {
					return _Utils_eq(item.afA, $elm$core$Maybe$Nothing);
				},
				fields.YF);
			return A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						missingChargeItem ? $elm$core$Maybe$Just(
						_Utils_Tuple2(5, 'Please select a charge item for each row.')) : $elm$core$Maybe$Nothing
					]));
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Admin$ChargeItems$Form$validatePriceInCents = function (fields) {
	var _v0 = fields.sW;
	if (_v0 === 1) {
		var _v1 = A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.Dw);
		if (!_v1.$) {
			var cents = _v1.a;
			return (cents > 0) ? _List_Nil : _List_fromArray(
				[
					_Utils_Tuple2(2, 'Please enter a price greater than $0.')
				]);
		} else {
			return _List_fromArray(
				[
					_Utils_Tuple2(2, 'Please enter a price.')
				]);
		}
	} else {
		return _Utils_eq(fields.Dw, $elm$core$Maybe$Nothing) ? _List_fromArray(
			[
				_Utils_Tuple2(2, 'Please enter a price.')
			]) : _List_Nil;
	}
};
var $author$project$Utils$Form$validated = function (_v0) {
	var validated_ = _v0.b;
	return validated_;
};
var $author$project$Components$Admin$ChargeItems$Form$clearErrorsIfValid = function (form) {
	if ($author$project$Utils$Form$validated(form)) {
		var fields = $author$project$Utils$Form$fields(form);
		var isCodeTypeValid = $elm$core$List$isEmpty(
			$author$project$Components$Admin$ChargeItems$Form$validateCodeType(fields));
		var isExpirationValid = $elm$core$List$isEmpty(
			$author$project$Components$Admin$ChargeItems$Form$validateExpiration(fields));
		var isImageValid = _Utils_cmp(fields.nW, $author$project$Components$Admin$ChargeItems$Form$maxImageBytesSize) < 1;
		var isLastSetQuantityValid = $elm$core$List$isEmpty(
			$author$project$Components$Admin$ChargeItems$Form$validateLastSetQuantity(fields));
		var isNameValid = !$elm$core$String$isEmpty(fields.Bq);
		var isPackageItemsValid = $elm$core$List$isEmpty(
			$author$project$Components$Admin$ChargeItems$Form$validatePackageItems(fields));
		var isPriceValid = $elm$core$List$isEmpty(
			$author$project$Components$Admin$ChargeItems$Form$validatePriceInCents(fields));
		var isUomValid = !$elm$core$String$isEmpty(fields.adP);
		return (isImageValid ? $author$project$Utils$Form$clearGroupErrors(7) : $elm$core$Basics$identity)(
			(isExpirationValid ? $author$project$Utils$Form$clearGroupErrors(6) : $elm$core$Basics$identity)(
				(isPackageItemsValid ? $author$project$Utils$Form$clearGroupErrors(5) : $elm$core$Basics$identity)(
					(isCodeTypeValid ? $author$project$Utils$Form$clearGroupErrors(4) : $elm$core$Basics$identity)(
						(isLastSetQuantityValid ? $author$project$Utils$Form$clearGroupErrors(3) : $elm$core$Basics$identity)(
							(isPriceValid ? $author$project$Utils$Form$clearGroupErrors(2) : $elm$core$Basics$identity)(
								(isUomValid ? $author$project$Utils$Form$clearGroupErrors(1) : $elm$core$Basics$identity)(
									(isNameValid ? $author$project$Utils$Form$clearGroupErrors(0) : $elm$core$Basics$identity)(form))))))));
	} else {
		return form;
	}
};
var $author$project$Components$ResourceFilter$extraItems = F2(
	function (list, model) {
		return _Utils_update(
			model,
			{gq: list});
	});
var $author$project$Components$ResourceFilter$Category$extraItems = F2(
	function (list_, model) {
		var extraItems_ = A2(
			$elm$core$List$map,
			function (item) {
				return {aih: item.Bq, aee: item.ahP};
			},
			list_);
		return _Utils_update(
			model,
			{
				b8: A2($author$project$Components$ResourceFilter$extraItems, extraItems_, model.b8)
			});
	});
var $author$project$Components$ResourceFilter$ChargeItem$extraItems = F2(
	function (list_, model) {
		var extraItems_ = A2(
			$elm$core$List$map,
			function (chargeItem) {
				return {aih: chargeItem.Bq, aee: chargeItem.ahP};
			},
			list_);
		return _Utils_update(
			model,
			{
				b8: A2($author$project$Components$ResourceFilter$extraItems, extraItems_, model.b8)
			});
	});
var $author$project$Components$Admin$ChargeItems$Form$DateExpiration = 2;
var $author$project$Components$Admin$ChargeItems$Form$DurationExpiration = 1;
var $author$project$Api$Provider$ChargeItem$Shared$alertQuantity = function (_v0) {
	var record = _v0.b;
	return record.Lm;
};
var $author$project$Api$Provider$ChargeItem$One$alertQuantity = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$alertQuantity(shared);
};
var $author$project$Api$Provider$ChargeItem$Shared$code = function (_v0) {
	var record = _v0.b;
	return record.NN;
};
var $author$project$Api$Provider$ChargeItem$One$code = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$code(shared);
};
var $author$project$Api$Provider$Uom$Shared$code = function (_v0) {
	var record = _v0;
	return record.NN;
};
var $author$project$Api$Provider$ChargeItem$Shared$codeType = function (_v0) {
	var record = _v0.b;
	return record.NP;
};
var $author$project$Api$Provider$ChargeItem$One$codeType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$codeType(shared);
};
var $author$project$Api$Provider$ChargeItem$Shared$daysSupply = function (_v0) {
	var record = _v0.b;
	return record.PL;
};
var $author$project$Api$Provider$ChargeItem$One$daysSupply = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$daysSupply(shared);
};
var $author$project$Api$Provider$ChargeItem$Shared$description = function (_v0) {
	var record = _v0.b;
	return record.Qr;
};
var $author$project$Api$Provider$ChargeItem$One$description = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$description(shared);
};
var $author$project$Api$Provider$ChargeItem$Shared$expirationDate = function (_v0) {
	var record = _v0.b;
	return A2(
		$elm$core$Maybe$andThen,
		function ($) {
			return $.RW;
		},
		record.qu);
};
var $author$project$Api$Provider$ChargeItem$One$expirationDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$expirationDate(shared);
};
var $author$project$Api$Provider$ChargeItem$Shared$expirationNumber = function (_v0) {
	var record = _v0.b;
	return A2(
		$elm$core$Maybe$andThen,
		function ($) {
			return $.RX;
		},
		record.qu);
};
var $author$project$Api$Provider$ChargeItem$One$expirationNumber = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$expirationNumber(shared);
};
var $author$project$Api$Provider$ChargeItem$Shared$expirationUnit = function (_v0) {
	var record = _v0.b;
	return A2(
		$elm$core$Maybe$andThen,
		function ($) {
			return $.RY;
		},
		record.qu);
};
var $author$project$Api$Provider$ChargeItem$One$expirationUnit = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$expirationUnit(shared);
};
var $author$project$Api$Provider$ChargeItem$Shared$imageUrl = function (_v0) {
	var record = _v0.b;
	return record.TP;
};
var $author$project$Api$Provider$ChargeItem$One$imageUrl = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$imageUrl(shared);
};
var $author$project$Api$Provider$ChargeItem$Shared$itemType = function (_v0) {
	var record = _v0.b;
	return record.sW;
};
var $author$project$Api$Provider$ChargeItem$One$itemType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$itemType(shared);
};
var $author$project$Api$Provider$ChargeItem$Shared$lastSetQuantity = function (_v0) {
	var record = _v0.b;
	return record.VM;
};
var $author$project$Api$Provider$ChargeItem$One$lastSetQuantity = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$lastSetQuantity(shared);
};
var $author$project$Api$Provider$ChargeItem$Shared$manufacturer = function (_v0) {
	var record = _v0.b;
	return record.Wt;
};
var $author$project$Api$Provider$ChargeItem$One$manufacturer = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$manufacturer(shared);
};
var $author$project$Api$Provider$ChargeItem$One$meta = function (_v0) {
	var record = _v0.b;
	return record.W4;
};
var $author$project$Api$Provider$ChargeItem$Min$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$ChargeItem$Shared$name = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Min$name(min);
};
var $author$project$Api$Provider$ChargeItem$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$name(shared);
};
var $author$project$Api$Provider$ChargeItem$Shared$packageItems = function (_v0) {
	var record = _v0.b;
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.YF;
			},
			record.qu));
};
var $author$project$Api$Provider$ChargeItem$One$packageItems = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$packageItems(shared);
};
var $author$project$Api$Provider$ChargeItem$Shared$priceInCents = function (_v0) {
	var record = _v0.b;
	return record.Dw;
};
var $author$project$Api$Provider$ChargeItem$One$priceInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$priceInCents(shared);
};
var $author$project$Api$Provider$ChargeItem$Shared$quantityInStock = function (_v0) {
	var record = _v0.b;
	return record._P;
};
var $author$project$Api$Provider$ChargeItem$One$quantityInStock = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$quantityInStock(shared);
};
var $author$project$Api$Provider$ChargeItem$Shared$revenueRecognition = function (_v0) {
	var record = _v0.b;
	return A2(
		$elm$core$Maybe$andThen,
		function ($) {
			return $.$0;
		},
		record.qu);
};
var $author$project$Api$Provider$ChargeItem$One$revenueRecognition = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$revenueRecognition(shared);
};
var $author$project$Api$Provider$ChargeItem$Shared$richDescriptions = function (_v0) {
	var record = _v0.b;
	return record.Eh;
};
var $author$project$Api$Provider$ChargeItem$One$richDescriptions = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$richDescriptions(shared);
};
var $author$project$Api$Provider$ChargeItem$Shared$taxable = function (_v0) {
	var record = _v0.b;
	return record.acZ;
};
var $author$project$Api$Provider$ChargeItem$One$taxable = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$taxable(shared);
};
var $author$project$Api$Provider$ChargeItem$Shared$trackInventory = function (_v0) {
	var record = _v0.b;
	return record.ads;
};
var $author$project$Api$Provider$ChargeItem$One$trackInventory = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$trackInventory(shared);
};
var $author$project$Api$Provider$ChargeItem$One$uom = function (_v0) {
	var record = _v0.b;
	return record.adP;
};
var $author$project$Components$Admin$ChargeItems$Form$formFieldsFromItem = function (chargeItem) {
	var packageItems = ($author$project$Api$Provider$ChargeItem$One$itemType(chargeItem) === 1) ? A2(
		$elm$core$List$indexedMap,
		F2(
			function (index, packageItem) {
				return {
					afA: $elm$core$Maybe$Just(packageItem.afA),
					afB: packageItem.afB,
					afD: packageItem.afD,
					ahP: packageItem.ahP,
					Dw: packageItem.Dw,
					Dz: packageItem.Dz,
					Y: $elm$core$String$fromInt(index)
				};
			}),
		$author$project$Api$Provider$ChargeItem$One$packageItems(chargeItem)) : _List_Nil;
	return {
		Lm: $author$project$Api$Provider$ChargeItem$One$alertQuantity(chargeItem),
		MZ: $author$project$Api$Provider$ChargeItem$One$buyable(chargeItem),
		GW: A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$Category$Shared$id,
			$author$project$Api$Provider$ChargeItem$One$category(chargeItem)),
		NN: $author$project$Api$Provider$ChargeItem$One$code(chargeItem),
		NP: $author$project$Api$Provider$ChargeItem$One$codeType(chargeItem),
		rQ: $author$project$Api$Provider$ChargeItem$One$imageUrl(chargeItem),
		PL: $author$project$Api$Provider$ChargeItem$One$daysSupply(chargeItem),
		Qr: $author$project$Api$Provider$ChargeItem$One$description(chargeItem),
		jy: false,
		RW: $author$project$Api$Provider$ChargeItem$One$expirationDate(chargeItem),
		RX: A2(
			$elm$core$Maybe$withDefault,
			'1',
			A2(
				$elm$core$Maybe$map,
				$elm$core$String$fromInt,
				$author$project$Api$Provider$ChargeItem$One$expirationNumber(chargeItem))),
		ag: (!_Utils_eq(
			$author$project$Api$Provider$ChargeItem$One$expirationDate(chargeItem),
			$elm$core$Maybe$Nothing)) ? 2 : (((!_Utils_eq(
			$author$project$Api$Provider$ChargeItem$One$expirationNumber(chargeItem),
			$elm$core$Maybe$Nothing)) || (!_Utils_eq(
			$author$project$Api$Provider$ChargeItem$One$expirationUnit(chargeItem),
			$elm$core$Maybe$Nothing))) ? 1 : 0),
		RY: A2(
			$elm$core$Maybe$withDefault,
			'months',
			$author$project$Api$Provider$ChargeItem$One$expirationUnit(chargeItem)),
		nW: 0,
		TP: $elm$core$Maybe$Nothing,
		sW: $author$project$Api$Provider$ChargeItem$One$itemType(chargeItem),
		VM: $author$project$Api$Provider$ChargeItem$One$lastSetQuantity(chargeItem),
		Wt: $author$project$Api$Provider$ChargeItem$One$manufacturer(chargeItem),
		W4: $elm$core$Maybe$Just(
			$author$project$Api$Provider$ChargeItem$One$meta(chargeItem)),
		Bq: $author$project$Api$Provider$ChargeItem$One$name(chargeItem),
		YF: packageItems,
		Dw: $elm$core$Maybe$Just(
			$author$project$Currency$fromFloat(
				$author$project$Api$Provider$ChargeItem$One$priceInCents(chargeItem))),
		_P: $author$project$Api$Provider$ChargeItem$One$quantityInStock(chargeItem),
		$0: A2(
			$elm$core$Maybe$withDefault,
			$author$project$Components$Admin$ChargeItems$Form$revenueRecognitionItemConsumption,
			$author$project$Api$Provider$ChargeItem$One$revenueRecognition(chargeItem)),
		bh: A2(
			$author$project$Components$TranslatedRichText$init,
			$author$project$Api$Provider$ChargeItem$One$richDescriptions(chargeItem),
			'rich-description-language'),
		acZ: $author$project$Api$Provider$ChargeItem$One$taxable(chargeItem),
		ads: $author$project$Api$Provider$ChargeItem$One$trackInventory(chargeItem),
		adP: $author$project$Api$Provider$Uom$Shared$code(
			$author$project$Api$Provider$ChargeItem$One$uom(chargeItem))
	};
};
var $author$project$Components$Admin$ChargeItems$Form$adjustPackageItemsPrices = F2(
	function (newPackagePrice, fields) {
		if (newPackagePrice.$ === 1) {
			return fields;
		} else {
			var newPrice = newPackagePrice.a;
			var newTotalCents = A2(
				$elm$core$Maybe$withDefault,
				0,
				$author$project$Currency$toInt(newPrice));
			var currentTotal = $elm$core$List$sum(
				A2(
					$elm$core$List$map,
					function (item) {
						var qty = (item.Dz <= 0) ? 1 : item.Dz;
						var price = A2(
							$elm$core$Maybe$withDefault,
							0,
							$author$project$Currency$toInt(item.Dw));
						return price * qty;
					},
					fields.YF));
			var adjustedRules = function () {
				if (!currentTotal) {
					var itemCount = A2(
						$elm$core$Basics$max,
						1,
						$elm$core$List$length(fields.YF));
					var pricePerItem = (newTotalCents / itemCount) | 0;
					return A2(
						$elm$core$List$map,
						function (item) {
							return _Utils_update(
								item,
								{
									Dw: $author$project$Currency$fromInt(
										(pricePerItem / ((item.Dz <= 0) ? 1 : item.Dz)) | 0)
								});
						},
						fields.YF);
				} else {
					var ratio = newTotalCents / currentTotal;
					return A2(
						$elm$core$List$map,
						function (item) {
							var currentPrice = A2(
								$elm$core$Maybe$withDefault,
								0,
								$author$project$Currency$toInt(item.Dw));
							var newItemPrice = $elm$core$Basics$round(currentPrice * ratio);
							return _Utils_update(
								item,
								{
									Dw: $author$project$Currency$fromInt(newItemPrice)
								});
						},
						fields.YF);
				}
			}();
			return _Utils_update(
				fields,
				{YF: adjustedRules, Dw: newPackagePrice});
		}
	});
var $author$project$Api$Provider$Uom$Shared$day = {
	NN: 'day',
	Bq: 'Day',
	Zs: $elm$core$Maybe$Nothing,
	he: $elm$core$Maybe$Just(1),
	hf: $elm$core$Maybe$Just(0),
	amg: 'Time',
	Kg: 'time'
};
var $author$project$Api$Provider$Uom$Shared$each = {NN: 'each', Bq: 'Each', Zs: $elm$core$Maybe$Nothing, he: $elm$core$Maybe$Nothing, hf: $elm$core$Maybe$Nothing, amg: 'Quantity', Kg: 'quantity'};
var $author$project$Api$Provider$Uom$Shared$unitClass = function (_v0) {
	var record = _v0;
	return record.Kg;
};
var $author$project$Api$Provider$Uom$filterBylistOptionals = F2(
	function (options, uom) {
		return A2(
			$elm$core$List$all,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					function () {
					var _v0 = options.Kg;
					if (!_v0.$) {
						var unitClass_ = _v0.a;
						return _Utils_eq(
							$author$project$Api$Provider$Uom$Shared$unitClass(uom),
							unitClass_);
					} else {
						return true;
					}
				}()
				]));
	});
var $author$project$Api$Provider$Uom$Shared$halfYear = {
	NN: 'half_year',
	Bq: 'Half Year',
	Zs: $elm$core$Maybe$Just(6),
	he: $elm$core$Maybe$Just(6),
	hf: $elm$core$Maybe$Just(1),
	amg: 'Time',
	Kg: 'time'
};
var $author$project$Api$Provider$Uom$listOptionalsDefaults = {Kg: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$Uom$Shared$month = {
	NN: 'month',
	Bq: 'Month',
	Zs: $elm$core$Maybe$Just(1),
	he: $elm$core$Maybe$Just(1),
	hf: $elm$core$Maybe$Just(1),
	amg: 'Time',
	Kg: 'time'
};
var $author$project$Api$Provider$Uom$Shared$quarter = {
	NN: 'quarter',
	Bq: 'Quarter',
	Zs: $elm$core$Maybe$Just(3),
	he: $elm$core$Maybe$Just(3),
	hf: $elm$core$Maybe$Just(1),
	amg: 'Time',
	Kg: 'time'
};
var $author$project$Api$Provider$Uom$Shared$year = {
	NN: 'year',
	Bq: 'Year',
	Zs: $elm$core$Maybe$Just(12),
	he: $elm$core$Maybe$Just(1),
	hf: $elm$core$Maybe$Just(4),
	amg: 'Time',
	Kg: 'time'
};
var $author$project$Api$Provider$Uom$list = function (optionals) {
	var options = optionals($author$project$Api$Provider$Uom$listOptionalsDefaults);
	return A2(
		$elm$core$List$filter,
		$author$project$Api$Provider$Uom$filterBylistOptionals(options),
		_List_fromArray(
			[$author$project$Api$Provider$Uom$Shared$each, $author$project$Api$Provider$Uom$Shared$day, $author$project$Api$Provider$Uom$Shared$month, $author$project$Api$Provider$Uom$Shared$quarter, $author$project$Api$Provider$Uom$Shared$halfYear, $author$project$Api$Provider$Uom$Shared$year]));
};
var $author$project$Utils$Uom$fromCode = function (code) {
	return A2(
		$elm_community$list_extra$List$Extra$find,
		function (uom_) {
			return _Utils_eq(
				$author$project$Api$Provider$Uom$Shared$code(uom_),
				code);
		},
		$author$project$Api$Provider$Uom$list($elm$core$Basics$identity));
};
var $author$project$Api$Provider$Uom$Shared$isTimeBased = function (_v0) {
	var record = _v0;
	return record.Kg === 'time';
};
var $author$project$Utils$Uom$isTimeBased = function (code) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$Uom$Shared$isTimeBased,
			$author$project$Utils$Uom$fromCode(code)));
};
var $elm$core$List$maximum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$max, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Admin$ChargeItems$Form$updatePackagePrice = function (fields) {
	var totalPrice = $author$project$Currency$fromInt(
		$elm$core$List$sum(
			A2(
				$elm$core$List$map,
				function (item) {
					var qty = (item.Dz <= 0) ? 1 : item.Dz;
					var price = A2(
						$elm$core$Maybe$withDefault,
						0,
						$author$project$Currency$toInt(item.Dw));
					return price * qty;
				},
				fields.YF)));
	return _Utils_update(
		fields,
		{
			Dw: $elm$core$Maybe$Just(totalPrice)
		});
};
var $author$project$Components$Admin$ChargeItems$Form$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{Bq: string});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						ads: fields.ads && $author$project$Utils$Uom$isTimeBased(fields.adP),
						adP: string
					});
			case 2:
				var maybeCurrency = field.a;
				return _Utils_update(
					fields,
					{Dw: maybeCurrency});
			case 3:
				if (fields.sW === 1) {
					var priceToUse = function () {
						var _v1 = fields.Dw;
						if (_v1.$ === 1) {
							return $elm$core$Maybe$Just($author$project$Currency$zero);
						} else {
							return fields.Dw;
						}
					}();
					return A2($author$project$Components$Admin$ChargeItems$Form$adjustPackageItemsPrices, priceToUse, fields);
				} else {
					return fields;
				}
			case 4:
				var bool = field.a;
				return _Utils_update(
					fields,
					{acZ: bool});
			case 5:
				var bool = field.a;
				return _Utils_update(
					fields,
					{MZ: bool});
			case 6:
				var maybeString = field.a;
				return _Utils_update(
					fields,
					{GW: maybeString});
			case 7:
				var bool = field.a;
				return _Utils_update(
					fields,
					{
						jy: bool && (!$author$project$Utils$Maybe$toBool(fields._P)),
						ads: bool
					});
			case 8:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						VM: $elm$core$String$toInt(string)
					});
			case 9:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Lm: $elm$core$String$toInt(string)
					});
			case 10:
				var string = field.a;
				var description = $elm$core$String$isEmpty(string) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(string);
				return _Utils_update(
					fields,
					{Qr: description});
			case 11:
				return _Utils_update(
					fields,
					{jy: true});
			case 12:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						PL: $elm$core$String$toInt(string)
					});
			case 13:
				var string = field.a;
				return _Utils_update(
					fields,
					{NN: string});
			case 14:
				var string = field.a;
				return _Utils_update(
					fields,
					{NP: string});
			case 15:
				var string = field.a;
				return _Utils_update(
					fields,
					{Wt: string});
			case 16:
				var itemType = field.a;
				var updatedFields = _Utils_update(
					fields,
					{sW: itemType});
				return (itemType === 1) ? $author$project$Components$Admin$ChargeItems$Form$updatePackagePrice(updatedFields) : updatedFields;
			case 17:
				var nextTempId = $elm$core$String$fromInt(
					1 + A2(
						$elm$core$Maybe$withDefault,
						-1,
						$elm$core$List$maximum(
							A2(
								$elm$core$List$map,
								function (item) {
									return A2(
										$elm$core$Maybe$withDefault,
										0,
										$elm$core$String$toInt(item.Y));
								},
								fields.YF))));
				var newItem = {afA: $elm$core$Maybe$Nothing, afB: $elm$core$Maybe$Nothing, afD: $elm$core$Maybe$Nothing, ahP: $elm$core$Maybe$Nothing, Dw: $author$project$Currency$zero, Dz: 1, Y: nextTempId};
				return $author$project$Components$Admin$ChargeItems$Form$updatePackagePrice(
					_Utils_update(
						fields,
						{
							YF: _Utils_ap(
								fields.YF,
								_List_fromArray(
									[newItem]))
						}));
			case 18:
				var tempId = field.a;
				return $author$project$Components$Admin$ChargeItems$Form$updatePackagePrice(
					_Utils_update(
						fields,
						{
							YF: A2(
								$elm$core$List$filter,
								function (item) {
									return !_Utils_eq(item.Y, tempId);
								},
								fields.YF)
						}));
			case 19:
				var tempId = field.a;
				var itemId = field.b;
				var itemName = field.c;
				var defaultPrice = field.d;
				var defaultTaxable = field.e;
				return $author$project$Components$Admin$ChargeItems$Form$updatePackagePrice(
					_Utils_update(
						fields,
						{
							YF: A2(
								$elm$core$List$map,
								function (item) {
									return _Utils_eq(item.Y, tempId) ? _Utils_update(
										item,
										{
											afA: $elm$core$Maybe$Just(itemId),
											afB: $elm$core$Maybe$Just(itemName),
											afD: $elm$core$Maybe$Just(defaultTaxable),
											Dw: defaultPrice,
											Dz: 1
										}) : item;
								},
								fields.YF)
						}));
			case 20:
				var tempId = field.a;
				var quantity = field.b;
				return $author$project$Components$Admin$ChargeItems$Form$updatePackagePrice(
					_Utils_update(
						fields,
						{
							YF: A2(
								$elm$core$List$map,
								function (item) {
									return _Utils_eq(item.Y, tempId) ? _Utils_update(
										item,
										{Dz: quantity}) : item;
								},
								fields.YF)
						}));
			case 21:
				var tempId = field.a;
				var maybePrice = field.b;
				return $author$project$Components$Admin$ChargeItems$Form$updatePackagePrice(
					_Utils_update(
						fields,
						{
							YF: A2(
								$elm$core$List$map,
								function (item) {
									return _Utils_eq(item.Y, tempId) ? _Utils_update(
										item,
										{
											Dw: A2($elm$core$Maybe$withDefault, $author$project$Currency$zero, maybePrice)
										}) : item;
								},
								fields.YF)
						}));
			case 22:
				var expirationType = field.a;
				return _Utils_update(
					fields,
					{ag: expirationType});
			case 23:
				var str = field.a;
				return _Utils_update(
					fields,
					{RX: str});
			case 24:
				var maybeUnit = field.a;
				if (!maybeUnit.$) {
					var unit = maybeUnit.a;
					return _Utils_update(
						fields,
						{RY: unit});
				} else {
					return fields;
				}
			case 25:
				var value = field.a;
				return _Utils_update(
					fields,
					{$0: value});
			default:
				var _int = field.a;
				var string = field.b;
				return _Utils_update(
					fields,
					{
						rQ: $elm$core$Maybe$Just(string),
						nW: _int,
						TP: $elm$core$Maybe$Just(string)
					});
		}
	});
var $author$project$Utils$Validate$ifIntGreaterThan = F3(
	function (subjectToInt, max, error) {
		return A2(
			$rtfeldman$elm_validate$Validate$ifTrue,
			function (subject) {
				return _Utils_cmp(
					subjectToInt(subject),
					max) > 0;
			},
			error);
	});
var $author$project$Components$Admin$ChargeItems$Form$imageValidator = A3(
	$author$project$Utils$Validate$ifIntGreaterThan,
	function ($) {
		return $.nW;
	},
	$author$project$Components$Admin$ChargeItems$Form$maxImageBytesSize,
	_Utils_Tuple2(7, 'That image is too large! Our maximum image size is 5 MB.'));
var $author$project$Components$Admin$ChargeItems$Form$RichDescriptionValidation = 8;
var $author$project$Components$TranslatedRichText$translations = function (model) {
	return model.adD;
};
var $author$project$Components$Admin$ChargeItems$Form$validateRichDescription = function (fields) {
	return ((fields.sW === 1) && fields.MZ) ? (A2(
		$elm$core$List$any,
		function (v) {
			return $elm$core$String$trim(v) !== '';
		},
		$elm$core$Dict$values(
			$author$project$Components$TranslatedRichText$translations(fields.bh))) ? _List_Nil : _List_fromArray(
		[
			_Utils_Tuple2(8, 'Please enter a description.')
		])) : _List_Nil;
};
var $author$project$Components$Admin$ChargeItems$Form$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.Bq;
			},
			_Utils_Tuple2(0, 'Please enter a name.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.adP;
			},
			_Utils_Tuple2(1, 'Please pick a uom.')),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$ChargeItems$Form$validatePriceInCents),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$ChargeItems$Form$validateLastSetQuantity),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$ChargeItems$Form$validateCodeType),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$ChargeItems$Form$validatePackageItems),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$ChargeItems$Form$validateExpiration),
			$author$project$Components$Admin$ChargeItems$Form$imageValidator,
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$ChargeItems$Form$validateRichDescription)
		]));
var $author$project$Api$Provider$ChargeItem$All$ChargeItem = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$ChargeItem$All$Record = F2(
	function (category, uom) {
		return {GW: category, adP: uom};
	});
var $author$project$Api$Provider$ChargeItem$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'uom',
	$author$project$Api$Provider$Uom$Shared$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'category',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Category$Shared$decoder),
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeItem$All$Record)));
var $author$project$Api$Provider$ChargeItem$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ChargeItem$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$ChargeItem$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeItem$All$ChargeItem)));
var $author$project$Api$Provider$ChargeItem$listDefaults = {GW: $elm$core$Maybe$Nothing, ahP: $elm$core$Maybe$Nothing, Ia: $elm$core$Maybe$Nothing, sW: $elm$core$Maybe$Nothing, ajJ: $author$project$Api$Pagination$init, akl: $elm$core$Maybe$Nothing, alA: $author$project$Api$Sort$init, acZ: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$ChargeItem$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$ChargeItem$listDefaults);
	return A2(
		$elm$core$List$append,
		$author$project$Api$Pagination$toApiParams(options.ajJ),
		A2(
			$elm$core$List$append,
			$author$project$Api$Sort$toParams(options.alA),
			$elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						var _v0 = options.akl;
						if (!_v0.$) {
							var string = _v0.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'q', string)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v1 = options.ahP;
						if (!_v1.$) {
							var string = _v1.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'id', string)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v2 = options.GW;
						if (!_v2.$) {
							var string = _v2.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'category', string)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v3 = options.Ia;
						if (!_v3.$) {
							var string = _v3.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'inventory', string)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v4 = options.acZ;
						if (!_v4.$) {
							var bool = _v4.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$bool, 'taxable', bool)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v5 = options.sW;
						if (!_v5.$) {
							var itemType = _v5.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'item_type', itemType)
								]);
						} else {
							return _List_Nil;
						}
					}()
					]))));
};
var $author$project$Api$Provider$ChargeItem$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$ChargeItem$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$ChargeItem$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$ChargeItem$chargeItemsPath)));
	});
var $author$project$Components$ResourceFilter$ChargeItem$list = $author$project$Api$Provider$ChargeItem$list;
var $author$project$Api$Provider$ChargeItem$All$alertQuantity = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$alertQuantity(shared);
};
var $author$project$Api$Provider$ChargeItem$All$category = function (_v0) {
	var record = _v0.b;
	return record.GW;
};
var $author$project$Api$Provider$ChargeItem$All$code = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$code(shared);
};
var $author$project$Api$Provider$ChargeItem$All$codeType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$codeType(shared);
};
var $author$project$Api$Provider$ChargeItem$All$description = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$description(shared);
};
var $author$project$Api$Provider$ChargeItem$Min$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$ChargeItem$Shared$id = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Min$id(min);
};
var $author$project$Api$Provider$ChargeItem$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$id(shared);
};
var $author$project$Api$Provider$ChargeItem$All$itemType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$itemType(shared);
};
var $author$project$Api$Provider$ChargeItem$All$manufacturer = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$manufacturer(shared);
};
var $author$project$Api$Provider$ChargeItem$All$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$name(shared);
};
var $author$project$Api$Provider$ChargeItem$All$priceInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$priceInCents(shared);
};
var $author$project$Api$Provider$ChargeItem$All$quantityInStock = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$quantityInStock(shared);
};
var $author$project$Api$Provider$ChargeItem$All$taxable = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$taxable(shared);
};
var $author$project$Api$Provider$ChargeItem$All$trackInventory = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$trackInventory(shared);
};
var $author$project$Api$Provider$ChargeItem$All$uom = function (_v0) {
	var record = _v0.b;
	return record.adP;
};
var $author$project$Components$ResourceFilter$ChargeItem$resourceFromAll = function (chargeItem) {
	return {
		Lm: $author$project$Api$Provider$ChargeItem$All$alertQuantity(chargeItem),
		GW: $author$project$Api$Provider$ChargeItem$All$category(chargeItem),
		NN: $author$project$Api$Provider$ChargeItem$All$code(chargeItem),
		NP: $author$project$Api$Provider$ChargeItem$All$codeType(chargeItem),
		Qr: $author$project$Api$Provider$ChargeItem$All$description(chargeItem),
		ahP: $author$project$Api$Provider$ChargeItem$All$id(chargeItem),
		aid: $author$project$Api$Provider$ChargeItem$All$itemType(chargeItem) === 1,
		sW: $author$project$Api$Provider$ChargeItem$All$itemType(chargeItem),
		Wt: $author$project$Api$Provider$ChargeItem$All$manufacturer(chargeItem),
		Bq: $author$project$Api$Provider$ChargeItem$All$name(chargeItem),
		Dw: $author$project$Api$Provider$ChargeItem$All$priceInCents(chargeItem),
		_P: $author$project$Api$Provider$ChargeItem$All$quantityInStock(chargeItem),
		acZ: $author$project$Api$Provider$ChargeItem$All$taxable(chargeItem),
		ads: $author$project$Api$Provider$ChargeItem$All$trackInventory(chargeItem),
		adP: $author$project$Api$Provider$ChargeItem$All$uom(chargeItem)
	};
};
var $author$project$Components$ResourceFilter$ChargeItem$fetchResources = F5(
	function (listOptionals, toMsg, apiClient, pagination, query) {
		return A3(
			$author$project$Components$ResourceFilter$ChargeItem$list,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{ajJ: pagination, akl: query});
				}),
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Components$ResourceFilter$ChargeItem$resourceFromAll))));
	});
var $author$project$Components$ResourceFilter$ChargeItem$retrieveResource = F4(
	function (listOptionals, toMsg, apiClient, id) {
		return A3(
			$author$project$Components$ResourceFilter$ChargeItem$list,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{
							ahP: $elm$core$Maybe$Just(id)
						});
				}),
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Components$ResourceFilter$ChargeItem$resourceFromAll))));
	});
var $author$project$Components$ResourceFilter$ChargeItem$selectId = 'charge_items';
var $author$project$Components$ResourceFilter$ChargeItem$itemTypeLabel = function (itemType_) {
	if (!itemType_) {
		return 'item';
	} else {
		return 'package';
	}
};
var $author$project$Api$Provider$Uom$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Formatters$ChargeItemCode$CodeTypeAndCode = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$ChargeItem$ForCharge$code = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$code(shared);
};
var $author$project$Formatters$ChargeItemCode$code = function (chargeItem) {
	if (!chargeItem.$) {
		var _v1 = chargeItem.a;
		var code_ = _v1.b;
		return code_;
	} else {
		var chargeItemForCharge = chargeItem.a;
		return $author$project$Api$Provider$ChargeItem$ForCharge$code(chargeItemForCharge);
	}
};
var $author$project$Api$Provider$ChargeItem$ForCharge$codeType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$codeType(shared);
};
var $author$project$Formatters$ChargeItemCode$codeTypes = _List_fromArray(
	[
		_Utils_Tuple2('cpt', 'CPT'),
		_Utils_Tuple2('loinc', 'LOINC'),
		_Utils_Tuple2('ndc', 'NDC'),
		_Utils_Tuple2('snowmed', 'Snowmed'),
		_Utils_Tuple2('other', 'Other')
	]);
var $author$project$Formatters$ChargeItemCode$formatCodeType = function (codeType_) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Dict$get,
			codeType_,
			$elm$core$Dict$fromList($author$project$Formatters$ChargeItemCode$codeTypes)));
};
var $author$project$Formatters$ChargeItemCode$codeType = function (chargeItem) {
	if (!chargeItem.$) {
		var _v1 = chargeItem.a;
		var codeType_ = _v1.a;
		return $author$project$Formatters$ChargeItemCode$formatCodeType(
			A2($elm$core$Maybe$withDefault, '', codeType_));
	} else {
		var chargeItemForCharge = chargeItem.a;
		return $author$project$Formatters$ChargeItemCode$formatCodeType(
			A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Api$Provider$ChargeItem$ForCharge$codeType(chargeItemForCharge)));
	}
};
var $author$project$Formatters$ChargeItemCode$toString = function (chargeItem) {
	var codeTypeName = $author$project$Formatters$ChargeItemCode$codeType(chargeItem);
	return (codeTypeName === '') ? '' : (codeTypeName + (' ' + $author$project$Formatters$ChargeItemCode$code(chargeItem)));
};
var $author$project$Components$ResourceFilter$ChargeItem$titleBase = function (resource) {
	var formattedCode = $author$project$Formatters$ChargeItemCode$toString(
		$author$project$Formatters$ChargeItemCode$CodeTypeAndCode(
			_Utils_Tuple2(resource.NP, resource.NN)));
	return _Utils_ap(
		resource.Bq,
		_Utils_ap(
			(formattedCode !== '') ? (' - ' + formattedCode) : '',
			(resource.Wt !== '') ? (' - ' + resource.Wt) : ''));
};
var $author$project$Components$ResourceFilter$ChargeItem$toLabel = F2(
	function (showItemType, resource) {
		var titleWithItemType = showItemType ? _List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Components$ResourceFilter$ChargeItem$titleBase(resource)),
				$elm$html$Html$text(' '),
				A2(
				$author$project$Ui$Typography$text,
				_List_fromArray(
					[
						$author$project$Ui$Typography$attrs(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-muted')
							]))
					]),
				$author$project$Components$ResourceFilter$ChargeItem$itemTypeLabel(resource.sW))
			]) : _List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Components$ResourceFilter$ChargeItem$titleBase(resource))
			]);
		var timeBasedUom = $author$project$Api$Provider$Uom$Shared$unitClass(resource.adP) === 'time';
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$spaceBetween]),
				_List_fromArray(
					[
						A2($author$project$Ui$Element$prose, _List_Nil, titleWithItemType),
						A2(
						$author$project$Ui$Element$prose,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Utils$Currency$fromFloat(resource.Dw)),
								timeBasedUom ? A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										' per ' + $author$project$Api$Provider$Uom$Shared$name(resource.adP))
									])) : $author$project$Utils$Html$empty
							]))
					])),
				function () {
				var _v0 = resource.Qr;
				if (!_v0.$) {
					var description = _v0.a;
					return A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
						_List_fromArray(
							[
								$elm$html$Html$text(description)
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]);
	});
var $author$project$Components$ResourceFilter$ChargeItem$toTitle = function (resource) {
	return $author$project$Components$ResourceFilter$ChargeItem$titleBase(resource);
};
var $author$project$Components$ResourceFilter$ChargeItem$toValue = function ($) {
	return $.ahP;
};
var $author$project$Components$ResourceFilter$ChargeItem$initWithItemType = F4(
	function (showItemTypeInTitle, apiClient, listOptionals, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{
				Sk: $author$project$Components$ResourceFilter$ChargeItem$fetchResources(listOptionals),
				ahP: $author$project$Components$ResourceFilter$ChargeItem$selectId,
				k$: 'Item',
				uk: $author$project$Components$ResourceFilter$ChargeItem$retrieveResource(listOptionals),
				u9: $author$project$Components$ResourceFilter$ChargeItem$toLabel(showItemTypeInTitle),
				lN: $author$project$Components$ResourceFilter$ChargeItem$toTitle,
				hX: $author$project$Components$ResourceFilter$ChargeItem$toValue
			},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{Jy: $author$project$Components$ResourceFilter$All, b8: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$ResourceFilter$ChargeItem$init = $author$project$Components$ResourceFilter$ChargeItem$initWithItemType(false);
var $author$project$Api$Provider$ChargeItem$One$isLab = function (chargeItem) {
	var _v0 = A2(
		$elm$core$Maybe$map,
		$author$project$Api$Provider$Category$Shared$name,
		$author$project$Api$Provider$ChargeItem$One$category(chargeItem));
	if (!_v0.$) {
		var categoryName_ = _v0.a;
		return categoryName_ === 'Labs';
	} else {
		return false;
	}
};
var $author$project$Components$ResourceFilter$preSelectedId = F2(
	function (id, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{akb: id}),
			$author$project$Components$ResourceFilter$setPreSelected(0));
	});
var $author$project$Components$ResourceFilter$Category$preSelectedId = F2(
	function (id, model) {
		var _v0 = A2($author$project$Components$ResourceFilter$preSelectedId, id, model.b8);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{b8: resourceFilter}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$Admin$ChargeItems$Form$Created = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$ChargeItem$Shared$itemTypeToString = function (itemType_) {
	if (!itemType_) {
		return 'item';
	} else {
		return 'package';
	}
};
var $author$project$Api$Provider$ChargeItem$create = F3(
	function (apiClient, fields, toMsg) {
		var uom = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'code',
					$elm$json$Json$Encode$string(fields.adP))
				]));
		var encodePackageItem = function (item) {
			return $elm$json$Json$Encode$object(
				$elm$core$List$concat(
					_List_fromArray(
						[
							function () {
							var _v3 = item.ahP;
							if (!_v3.$) {
								var packageItemId = _v3.a;
								return _List_fromArray(
									[
										_Utils_Tuple2(
										'id',
										$elm$json$Json$Encode$string(packageItemId))
									]);
							} else {
								return _List_Nil;
							}
						}(),
							_List_fromArray(
							[
								_Utils_Tuple2(
								'charge_item',
								$author$project$Utils$Encode$typedAssociation(item.mL)),
								_Utils_Tuple2(
								'quantity',
								$elm$json$Json$Encode$int(item.Dz)),
								_Utils_Tuple2(
								'price_in_cents',
								$author$project$Currency$encodeFloat(item.Dw))
							])
						])));
		};
		var encodePackage = function (pkg) {
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'package_items',
						A2($elm$json$Json$Encode$list, encodePackageItem, pkg.YF)),
						_Utils_Tuple2(
						'expiration_number',
						A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, pkg.RX)),
						_Utils_Tuple2(
						'expiration_unit',
						A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, pkg.RY)),
						_Utils_Tuple2(
						'expiration_date',
						A2(
							$author$project$Utils$Encode$nullable,
							A2($elm$core$Basics$composeR, $justinmimbs$date$Date$toIsoString, $elm$json$Json$Encode$string),
							pkg.RW)),
						_Utils_Tuple2(
						'revenue_recognition',
						$elm$json$Json$Encode$string(pkg.$0))
					]));
		};
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'charge_item',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(fields.Bq)),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'price_in_cents',
									$author$project$Currency$encodeFloat(fields.Dw)),
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										'description',
										A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Qr)),
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(
											'rich_description',
											$elm$json$Json$Encode$object(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'en',
														A2(
															$author$project$Utils$Encode$nullable,
															$elm$json$Json$Encode$string,
															A2($elm$core$Dict$get, 'en', fields.Eh))),
														_Utils_Tuple2(
														'es',
														A2(
															$author$project$Utils$Encode$nullable,
															$elm$json$Json$Encode$string,
															A2($elm$core$Dict$get, 'es', fields.Eh)))
													]))),
										A2(
											$elm$core$List$cons,
											_Utils_Tuple2(
												'track_inventory',
												$elm$json$Json$Encode$bool(fields.ads)),
											A2(
												$elm$core$List$cons,
												_Utils_Tuple2(
													'alert_quantity',
													A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Lm)),
												A2(
													$elm$core$List$cons,
													_Utils_Tuple2(
														'taxable',
														$elm$json$Json$Encode$bool(fields.acZ)),
													A2(
														$elm$core$List$cons,
														_Utils_Tuple2(
															'buyable',
															$elm$json$Json$Encode$bool(fields.MZ)),
														A2(
															$elm$core$List$cons,
															_Utils_Tuple2(
																'category',
																A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.GW)),
															A2(
																$elm$core$List$cons,
																_Utils_Tuple2('uom', uom),
																A2(
																	$elm$core$List$cons,
																	_Utils_Tuple2(
																		'days_supply',
																		A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.PL)),
																	A2(
																		$elm$core$List$cons,
																		_Utils_Tuple2(
																			'code',
																			$elm$json$Json$Encode$string(fields.NN)),
																		A2(
																			$elm$core$List$cons,
																			_Utils_Tuple2(
																				'code_type',
																				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.NP)),
																			A2(
																				$elm$core$List$cons,
																				_Utils_Tuple2(
																					'manufacturer',
																					$elm$json$Json$Encode$string(fields.Wt)),
																				A2(
																					$elm$core$List$cons,
																					_Utils_Tuple2(
																						'item_type',
																						$elm$json$Json$Encode$string(
																							$author$project$Api$Provider$ChargeItem$Shared$itemTypeToString(fields.sW))),
																					_Utils_ap(
																						function () {
																							var _v0 = fields.VM;
																							if (!_v0.$) {
																								var lastSetQuantity_ = _v0.a;
																								return _List_fromArray(
																									[
																										_Utils_Tuple2(
																										'last_set_quantity',
																										$elm$json$Json$Encode$int(lastSetQuantity_))
																									]);
																							} else {
																								return _List_Nil;
																							}
																						}(),
																						_Utils_ap(
																							function () {
																								var _v1 = fields.YE;
																								if (!_v1.$) {
																									var pkg = _v1.a;
																									return _List_fromArray(
																										[
																											_Utils_Tuple2(
																											'package',
																											encodePackage(pkg))
																										]);
																								} else {
																									return _List_Nil;
																								}
																							}(),
																							function () {
																								var _v2 = fields.TP;
																								if (!_v2.$) {
																									var url = _v2.a;
																									return _List_fromArray(
																										[
																											_Utils_Tuple2(
																											'image',
																											$elm$json$Json$Encode$string(url))
																										]);
																								} else {
																									return _List_Nil;
																								}
																							}())))))))))))))))))))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$ChargeItem$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$ChargeItem$chargeItemsPath)));
	});
var $author$project$Components$Admin$ChargeItems$Form$createItem = F2(
	function (apiClient, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var _package = function () {
			if (fields.sW === 1) {
				var packageItems = A2(
					$elm$core$List$filterMap,
					function (item) {
						return A2(
							$elm$core$Maybe$map,
							function (chargeItemId) {
								return {
									mL: {
										ahP: $elm$core$Maybe$Just(chargeItemId),
										amg: $elm$core$Maybe$Just('charge_item')
									},
									ahP: item.ahP,
									Dw: item.Dw,
									Dz: item.Dz
								};
							},
							item.afA);
					},
					fields.YF);
				return $elm$core$Maybe$Just(
					{
						RW: function () {
							var _v0 = fields.ag;
							if (_v0 === 2) {
								return fields.RW;
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}(),
						RX: function () {
							var _v1 = fields.ag;
							if (_v1 === 1) {
								return A2(
									$elm$core$Maybe$map,
									$elm$core$Basics$max(1),
									$elm$core$String$toInt(fields.RX));
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}(),
						RY: function () {
							var _v2 = fields.ag;
							if (_v2 === 1) {
								return $elm$core$Maybe$Just(fields.RY);
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}(),
						YF: packageItems,
						$0: fields.$0
					});
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var apiFields = {
			Lm: fields.Lm,
			MZ: fields.MZ,
			GW: fields.GW,
			NN: fields.NN,
			NP: fields.NP,
			PL: fields.PL,
			Qr: fields.Qr,
			TP: fields.TP,
			sW: fields.sW,
			VM: fields.VM,
			Wt: fields.Wt,
			Bq: fields.Bq,
			YE: _package,
			Dw: A2($elm$core$Maybe$withDefault, $author$project$Currency$zero, fields.Dw),
			Eh: $author$project$Components$TranslatedRichText$translations(fields.bh),
			acZ: fields.acZ,
			ads: fields.ads,
			adP: fields.adP
		};
		return A3($author$project$Api$Provider$ChargeItem$create, apiClient, apiFields, $author$project$Components$Admin$ChargeItems$Form$Created);
	});
var $author$project$Components$Admin$ChargeItems$Form$Updated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$ChargeItem$update = F4(
	function (apiClient, id_, fields, toMsg) {
		var uom = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'code',
					$elm$json$Json$Encode$string(fields.adP))
				]));
		var encodePackageItem = function (item) {
			return $elm$json$Json$Encode$object(
				$elm$core$List$concat(
					_List_fromArray(
						[
							function () {
							var _v2 = item.ahP;
							if (!_v2.$) {
								var packageItemId = _v2.a;
								return _List_fromArray(
									[
										_Utils_Tuple2(
										'id',
										$elm$json$Json$Encode$string(packageItemId))
									]);
							} else {
								return _List_Nil;
							}
						}(),
							_List_fromArray(
							[
								_Utils_Tuple2(
								'charge_item',
								$author$project$Utils$Encode$typedAssociation(item.mL)),
								_Utils_Tuple2(
								'quantity',
								$elm$json$Json$Encode$int(item.Dz)),
								_Utils_Tuple2(
								'price_in_cents',
								$author$project$Currency$encodeFloat(item.Dw))
							])
						])));
		};
		var encodePackage = function (pkg) {
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'package_items',
						A2($elm$json$Json$Encode$list, encodePackageItem, pkg.YF)),
						_Utils_Tuple2(
						'expiration_number',
						A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, pkg.RX)),
						_Utils_Tuple2(
						'expiration_unit',
						A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, pkg.RY)),
						_Utils_Tuple2(
						'expiration_date',
						A2(
							$author$project$Utils$Encode$nullable,
							A2($elm$core$Basics$composeR, $justinmimbs$date$Date$toIsoString, $elm$json$Json$Encode$string),
							pkg.RW)),
						_Utils_Tuple2(
						'revenue_recognition',
						$elm$json$Json$Encode$string(pkg.$0))
					]));
		};
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'charge_item',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(fields.Bq)),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'price_in_cents',
									$author$project$Currency$encodeFloat(fields.Dw)),
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										'description',
										A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Qr)),
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(
											'rich_description',
											$elm$json$Json$Encode$object(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'en',
														A2(
															$author$project$Utils$Encode$nullable,
															$elm$json$Json$Encode$string,
															A2($elm$core$Dict$get, 'en', fields.Eh))),
														_Utils_Tuple2(
														'es',
														A2(
															$author$project$Utils$Encode$nullable,
															$elm$json$Json$Encode$string,
															A2($elm$core$Dict$get, 'es', fields.Eh)))
													]))),
										A2(
											$elm$core$List$cons,
											_Utils_Tuple2(
												'track_inventory',
												$elm$json$Json$Encode$bool(fields.ads)),
											A2(
												$elm$core$List$cons,
												_Utils_Tuple2(
													'alert_quantity',
													A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Lm)),
												A2(
													$elm$core$List$cons,
													_Utils_Tuple2(
														'taxable',
														$elm$json$Json$Encode$bool(fields.acZ)),
													A2(
														$elm$core$List$cons,
														_Utils_Tuple2(
															'buyable',
															$elm$json$Json$Encode$bool(fields.MZ)),
														A2(
															$elm$core$List$cons,
															_Utils_Tuple2(
																'category',
																A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.GW)),
															A2(
																$elm$core$List$cons,
																_Utils_Tuple2('uom', uom),
																A2(
																	$elm$core$List$cons,
																	_Utils_Tuple2(
																		'days_supply',
																		A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.PL)),
																	A2(
																		$elm$core$List$cons,
																		_Utils_Tuple2(
																			'code',
																			$elm$json$Json$Encode$string(fields.NN)),
																		A2(
																			$elm$core$List$cons,
																			_Utils_Tuple2(
																				'code_type',
																				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.NP)),
																			A2(
																				$elm$core$List$cons,
																				_Utils_Tuple2(
																					'manufacturer',
																					$elm$json$Json$Encode$string(fields.Wt)),
																				A2(
																					$elm$core$List$cons,
																					_Utils_Tuple2(
																						'item_type',
																						$elm$json$Json$Encode$string(
																							$author$project$Api$Provider$ChargeItem$Shared$itemTypeToString(fields.sW))),
																					_Utils_ap(
																						A3($author$project$Utils$Encode$optional, 'last_set_quantity', $elm$json$Json$Encode$int, fields.VM),
																						_Utils_ap(
																							function () {
																								var _v0 = fields.YE;
																								if (!_v0.$) {
																									var pkg = _v0.a;
																									return _List_fromArray(
																										[
																											_Utils_Tuple2(
																											'package',
																											encodePackage(pkg))
																										]);
																								} else {
																									return _List_Nil;
																								}
																							}(),
																							function () {
																								var _v1 = fields.TP;
																								if (!_v1.$) {
																									var url = _v1.a;
																									return _List_fromArray(
																										[
																											_Utils_Tuple2(
																											'image',
																											$elm$json$Json$Encode$string(url))
																										]);
																								} else {
																									return _List_Nil;
																								}
																							}())))))))))))))))))))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$ChargeItem$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$ChargeItem$chargeItemPath(id_))));
	});
var $author$project$Components$Admin$ChargeItems$Form$updateItem = F3(
	function (apiClient, id, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var _package = function () {
			if (fields.sW === 1) {
				var packageItems = A2(
					$elm$core$List$filterMap,
					function (item) {
						return A2(
							$elm$core$Maybe$map,
							function (chargeItemId) {
								return {
									mL: {
										ahP: $elm$core$Maybe$Just(chargeItemId),
										amg: $elm$core$Maybe$Just('charge_item')
									},
									ahP: item.ahP,
									Dw: item.Dw,
									Dz: item.Dz
								};
							},
							item.afA);
					},
					fields.YF);
				return $elm$core$Maybe$Just(
					{
						RW: function () {
							var _v0 = fields.ag;
							if (_v0 === 2) {
								return fields.RW;
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}(),
						RX: function () {
							var _v1 = fields.ag;
							if (_v1 === 1) {
								return A2(
									$elm$core$Maybe$map,
									$elm$core$Basics$max(1),
									$elm$core$String$toInt(fields.RX));
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}(),
						RY: function () {
							var _v2 = fields.ag;
							if (_v2 === 1) {
								return $elm$core$Maybe$Just(fields.RY);
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}(),
						YF: packageItems,
						$0: fields.$0
					});
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var apiFields = {
			Lm: fields.Lm,
			MZ: fields.MZ,
			GW: fields.GW,
			NN: fields.NN,
			NP: fields.NP,
			PL: fields.PL,
			Qr: fields.Qr,
			TP: fields.TP,
			sW: fields.sW,
			VM: fields.jy ? fields.VM : $elm$core$Maybe$Nothing,
			Wt: fields.Wt,
			Bq: fields.Bq,
			YE: _package,
			Dw: A2($elm$core$Maybe$withDefault, $author$project$Currency$zero, fields.Dw),
			Eh: $author$project$Components$TranslatedRichText$translations(fields.bh),
			acZ: fields.acZ,
			ads: fields.ads,
			adP: fields.adP
		};
		return A4($author$project$Api$Provider$ChargeItem$update, apiClient, id, apiFields, $author$project$Components$Admin$ChargeItems$Form$Updated);
	});
var $author$project$Components$Admin$ChargeItems$Form$saveItem = F3(
	function (apiClient, maybeId, formFields) {
		if (!maybeId.$) {
			var id_ = maybeId.a;
			return A3($author$project$Components$Admin$ChargeItems$Form$updateItem, apiClient, id_, formFields);
		} else {
			return A2($author$project$Components$Admin$ChargeItems$Form$createItem, apiClient, formFields);
		}
	});
var $author$project$Utils$Form$set = F2(
	function (fields_, _v0) {
		var originalFields = _v0.a;
		var validated_ = _v0.b;
		var errors_ = _v0.d;
		return A4($author$project$Utils$Form$Form, originalFields, validated_, fields_, errors_);
	});
var $author$project$Components$ResourceFilter$ChargeItem$setValue = F2(
	function (resource, model) {
		return _Utils_update(
			model,
			{Jy: resource});
	});
var $elm$file$File$size = _File_size;
var $author$project$Components$TranslatedRichText$startEditingCmd = F3(
	function (editorId, placeholder, model) {
		var content = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Dict$get,
				$author$project$Language$toValue(model.f4),
				model.adD));
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{gC: true}),
			A4($author$project$Ports$CKEditor$replace, editorId, content, _List_Nil, placeholder));
	});
var $elm$file$File$toUrl = _File_toUrl;
var $author$project$Components$ResourceFilter$GotPreselectedItem = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$ResourceFilter$ItemSelected = $elm$core$Basics$identity;
var $author$project$Components$ResourceFilter$Many = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$ResourceFilter$None = {$: 3};
var $author$project$Components$ResourceFilter$One = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$ResourceFilter$DebouncedMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$ResourceFilter$debounceConfig = {
	alK: $jinjor$elm_debounce$Debounce$later(300),
	ame: $author$project$Components$ResourceFilter$DebouncedMsg
};
var $author$project$Components$ResourceFilter$DropdownSearchDebounced = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$ResourceFilter$debounceText = function (text) {
	return A2(
		$elm$core$Task$perform,
		$author$project$Components$ResourceFilter$DropdownSearchDebounced,
		$elm$core$Task$succeed(text));
};
var $author$project$Components$ResourceFilter$itemChecked = F2(
	function (model, many) {
		return {
			GZ: $elm$core$Platform$Cmd$none,
			agZ: $elm$core$Maybe$Just(many),
			aiO: model,
			aR: _List_Nil
		};
	});
var $author$project$Components$ResourceFilter$itemSelected = F3(
	function (apiClient, model, selected) {
		return {
			GZ: A4(
				model.uo,
				$author$project$Components$ResourceFilter$GotItems(false),
				apiClient,
				model.ajJ,
				$elm$core$Maybe$Nothing),
			agZ: $elm$core$Maybe$Just(
				A2($elm$core$Maybe$withDefault, $author$project$Components$ResourceFilter$None, selected)),
			aiO: _Utils_update(
				model,
				{akl: $elm$core$Maybe$Nothing}),
			aR: _List_Nil
		};
	});
var $author$project$Api$Pagination$nextPage = function (_v0) {
	var model = _v0;
	return _Utils_update(
		model,
		{bX: model.bX + 1});
};
var $author$project$Api$Pagination$reset = function (_v0) {
	var model = _v0;
	return _Utils_update(
		model,
		{bX: 1});
};
var $author$project$Components$ResourceFilter$setPreselectedLimit = 20;
var $author$project$Components$ResourceFilter$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 8:
				var pagination = $author$project$Api$Pagination$nextPage(model.ajJ);
				return {
					GZ: A4(
						model.uo,
						$author$project$Components$ResourceFilter$GotItems(true),
						apiClient,
						pagination,
						model.akl),
					agZ: $elm$core$Maybe$Nothing,
					aiO: _Utils_update(
						model,
						{s3: true, ajJ: pagination}),
					aR: _List_Nil
				};
			case 4:
				var a = msg.a;
				return function (newModel) {
					return A3($author$project$Components$ResourceFilter$itemSelected, apiClient, newModel, a);
				}(
					_Utils_update(
						model,
						{
							ajJ: $author$project$Api$Pagination$reset(model.ajJ)
						}));
			case 5:
				var a = msg.a;
				return A2($author$project$Components$ResourceFilter$itemChecked, model, a);
			case 3:
				var dropdownMsg = msg.a;
				var _v1 = A2($author$project$Ui$Dropdown$update, dropdownMsg, model.gi);
				var dropdown = _v1.a;
				var dropdownCmd = _v1.b;
				return {
					GZ: dropdownCmd,
					agZ: $elm$core$Maybe$Nothing,
					aiO: _Utils_update(
						model,
						{gi: dropdown}),
					aR: _List_Nil
				};
			case 2:
				var attempts = msg.a;
				var _v2 = model.bu;
				if (!_v2.$) {
					var items = _v2.a;
					var _v3 = A2(
						$elm$core$Maybe$withDefault,
						_Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none),
						A2(
							$elm$core$Maybe$map,
							function (preSelectedId_) {
								var selected = A2(
									$elm$core$Maybe$map,
									$author$project$Components$ResourceFilter$One,
									A2(
										$elm_community$list_extra$List$Extra$find,
										function (item) {
											return _Utils_eq(
												model.hX(item),
												preSelectedId_);
										},
										items));
								var extraSelected = A2(
									$elm$core$Maybe$map,
									$author$project$Components$ResourceFilter$Extra,
									A2(
										$elm_community$list_extra$List$Extra$find,
										function (extraItem) {
											return _Utils_eq(extraItem.aee, preSelectedId_);
										},
										model.gq));
								var _v4 = _Utils_Tuple3(selected, extraSelected, preSelectedId_);
								if (!_v4.a.$) {
									var selected_ = _v4.a.a;
									return _Utils_Tuple2(
										$elm$core$Maybe$Just(selected_),
										$elm$core$Platform$Cmd$none);
								} else {
									if (!_v4.b.$) {
										var extraSelected_ = _v4.b.a;
										return _Utils_Tuple2(
											$elm$core$Maybe$Just(extraSelected_),
											$elm$core$Platform$Cmd$none);
									} else {
										var anyString = _v4.c;
										return ($elm$core$String$isEmpty(anyString) && model.Cd.ai5) ? _Utils_Tuple2(
											$elm$core$Maybe$Just($author$project$Components$ResourceFilter$None),
											$elm$core$Platform$Cmd$none) : ((!$elm$core$String$isEmpty(anyString)) ? _Utils_Tuple2(
											$elm$core$Maybe$Nothing,
											A3(
												model.uk,
												$author$project$Components$ResourceFilter$GotPreselectedItem(anyString),
												apiClient,
												anyString)) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none));
									}
								}
							},
							model.akb));
					var event = _v3.a;
					var cmd = _v3.b;
					return {
						GZ: cmd,
						agZ: event,
						aiO: _Utils_update(
							model,
							{akb: $elm$core$Maybe$Nothing}),
						aR: _List_Nil
					};
				} else {
					return {
						GZ: (_Utils_cmp(attempts, $author$project$Components$ResourceFilter$setPreselectedLimit) > 0) ? $elm$core$Platform$Cmd$none : $author$project$Components$ResourceFilter$setPreSelected(attempts),
						agZ: $elm$core$Maybe$Nothing,
						aiO: model,
						aR: _List_Nil
					};
				}
			case 0:
				var append = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var items = response.a;
					var headers = response.b;
					var afterExcludedId = function () {
						var _v8 = model.ag$;
						if (!_v8.$) {
							var excludedId_ = _v8.a;
							return A2(
								$elm$core$List$filter,
								function (item) {
									return !_Utils_eq(
										model.hX(item),
										excludedId_);
								},
								items);
						} else {
							return items;
						}
					}();
					var afterExcludedIds = function () {
						var _v7 = model.jG;
						if (!_v7.$) {
							var excludedIds_ = _v7.a;
							return A2(
								$elm$core$List$filter,
								function (item) {
									return !A2(
										$elm$core$List$member,
										model.hX(item),
										excludedIds_);
								},
								afterExcludedId);
						} else {
							return afterExcludedId;
						}
					}();
					var dataItems = function () {
						var _v6 = model.ag0;
						if (!_v6.$) {
							var excludedTitles_ = _v6.a;
							return A2(
								$elm$core$List$filter,
								function (item) {
									return !A2(
										$elm$core$List$member,
										model.lN(item),
										excludedTitles_);
								},
								afterExcludedIds);
						} else {
							return afterExcludedIds;
						}
					}();
					return {
						GZ: $author$project$Components$ResourceFilter$setPreSelected(0),
						agZ: $elm$core$Maybe$Nothing,
						aiO: _Utils_update(
							model,
							{
								bu: $elm$core$Maybe$Just(
									append ? _Utils_ap(
										A2($elm$core$Maybe$withDefault, _List_Nil, model.bu),
										dataItems) : dataItems),
								s3: false,
								En: false,
								vc: A2(
									$elm$core$Maybe$withDefault,
									$elm$core$Maybe$Nothing,
									A2(
										$elm$core$Maybe$map,
										$elm$core$String$toInt,
										A2($elm$core$Dict$get, 'x-total-count', headers)))
							}),
						aR: _List_Nil
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $elm$core$Maybe$Nothing,
						aiO: _Utils_update(
							model,
							{bu: $elm$core$Maybe$Nothing, s3: false, En: false, vc: $elm$core$Maybe$Nothing}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 1:
				var preSelectedId_ = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var items = response.a;
					var preSelectedItem = A2(
						$elm$core$List$filter,
						function (item) {
							return A2(
								$elm$core$List$member,
								model.hX(item),
								A2($elm$core$String$split, ',', preSelectedId_));
						},
						items);
					if (preSelectedItem.b) {
						if (!preSelectedItem.b.b) {
							var preSelectedItem_ = preSelectedItem.a;
							return {
								GZ: $author$project$Components$ResourceFilter$setPreSelected(0),
								agZ: $elm$core$Maybe$Just(
									$author$project$Components$ResourceFilter$One(preSelectedItem_)),
								aiO: _Utils_update(
									model,
									{
										bu: $elm$core$Maybe$Just(
											_Utils_ap(
												A2($elm$core$Maybe$withDefault, _List_Nil, model.bu),
												_List_fromArray(
													[preSelectedItem_])))
									}),
								aR: _List_Nil
							};
						} else {
							var preselectedItems = preSelectedItem;
							return {
								GZ: $author$project$Components$ResourceFilter$setPreSelected(0),
								agZ: $elm$core$Maybe$Just(
									$author$project$Components$ResourceFilter$Many(preselectedItems)),
								aiO: _Utils_update(
									model,
									{
										bu: $elm$core$Maybe$Just(
											A2($elm$core$Maybe$withDefault, _List_Nil, model.bu))
									}),
								aR: _List_Nil
							};
						}
					} else {
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: $elm$core$Maybe$Nothing,
							aiO: model,
							aR: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $elm$core$Maybe$Nothing,
						aiO: model,
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 7:
				var text = msg.a;
				var _v11 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Components$ResourceFilter$debounceConfig, text, model.d6);
				var newDebouncer = _v11.a;
				var cmd = _v11.b;
				return {
					GZ: cmd,
					agZ: $elm$core$Maybe$Nothing,
					aiO: _Utils_update(
						model,
						{
							d6: newDebouncer,
							akl: $elm$core$Maybe$Just(text)
						}),
					aR: _List_Nil
				};
			case 9:
				var debounceMsg = msg.a;
				var _v12 = A4(
					$jinjor$elm_debounce$Debounce$update,
					$author$project$Components$ResourceFilter$debounceConfig,
					$jinjor$elm_debounce$Debounce$takeLast($author$project$Components$ResourceFilter$debounceText),
					debounceMsg,
					model.d6);
				var newDebouncer = _v12.a;
				var cmd = _v12.b;
				return {
					GZ: cmd,
					agZ: $elm$core$Maybe$Nothing,
					aiO: _Utils_update(
						model,
						{d6: newDebouncer}),
					aR: _List_Nil
				};
			default:
				var text = msg.a;
				var pagination = $author$project$Api$Pagination$reset(model.ajJ);
				return {
					GZ: A4(
						model.uo,
						$author$project$Components$ResourceFilter$GotItems(false),
						apiClient,
						pagination,
						$elm$core$Maybe$Just(text)),
					agZ: $elm$core$Maybe$Nothing,
					aiO: _Utils_update(
						model,
						{
							ajJ: pagination,
							akl: $elm$core$Maybe$Just(text)
						}),
					aR: _List_Nil
				};
		}
	});
var $author$project$Components$ResourceFilter$Category$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.b8);
		var modelAfterEvent = function () {
			var _v1 = result.agZ;
			if (!_v1.$) {
				var selected = _v1.a;
				return _Utils_update(
					model,
					{Jy: selected});
			} else {
				return model;
			}
		}();
		return {
			GZ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.GZ),
			agZ: result.agZ,
			aiO: _Utils_update(
				modelAfterEvent,
				{b8: result.aiO}),
			aR: result.aR
		};
	});
var $author$project$Components$ResourceFilter$ChargeItem$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.b8);
		var modelAfterEvent = function () {
			var _v1 = result.agZ;
			if (!_v1.$) {
				var selected = _v1.a;
				return _Utils_update(
					model,
					{Jy: selected});
			} else {
				return model;
			}
		}();
		return {
			GZ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.GZ),
			agZ: result.agZ,
			aiO: _Utils_update(
				modelAfterEvent,
				{b8: result.aiO}),
			aR: result.aR
		};
	});
var $author$project$Components$TranslatedRichText$update = F4(
	function (editorId, placeholder, msg, model) {
		switch (msg.$) {
			case 0:
				var content = msg.a;
				var langKey = $author$project$Language$toValue(model.f4);
				var newTranslations = $elm$core$String$isEmpty(content) ? A2($elm$core$Dict$remove, langKey, model.adD) : A3($elm$core$Dict$insert, langKey, content, model.adD);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{adD: newTranslations}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var content = A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Dict$get,
						$author$project$Language$toValue(model.f4),
						model.adD));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{gC: true}),
					A4($author$project$Ports$CKEditor$replace, editorId, content, _List_Nil, placeholder));
			case 2:
				var language = msg.a;
				var content = A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Dict$get,
						$author$project$Language$toValue(language),
						model.adD));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{f4: language}),
					A2($author$project$Ports$CKEditor$setData, editorId, content));
			default:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Ui$Dropdown$update, subMsg, model.gi);
				var newDropdown = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{gi: newDropdown}),
					cmd);
		}
	});
var $author$project$Components$ResourceFilter$choiceToValue = F2(
	function (model, choice) {
		switch (choice.$) {
			case 2:
				return model.Cd.aeQ;
			case 3:
				return model.Cd.ai6;
			case 0:
				var item = choice.a;
				return $elm$core$Maybe$Just(
					model.hX(item));
			case 1:
				var items = choice.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$String$join,
						',',
						A2($elm$core$List$map, model.hX, items)));
			case 4:
				var extraItem = choice.a;
				return $elm$core$Maybe$Just(extraItem.aee);
			default:
				var string = choice.a;
				return $elm$core$Maybe$Just(string);
		}
	});
var $author$project$Components$ResourceFilter$Category$value = function (model) {
	return A2($author$project$Components$ResourceFilter$choiceToValue, model.b8, model.Jy);
};
var $author$project$Components$Admin$ChargeItems$Form$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var chargeItem = response.a;
					var formFields = $author$project$Components$Admin$ChargeItems$Form$formFieldsFromItem(chargeItem);
					var category = $author$project$Api$Provider$ChargeItem$One$category(chargeItem);
					var _v3 = function () {
						if (($author$project$Api$Provider$ChargeItem$One$itemType(chargeItem) === 1) && $author$project$Api$Provider$ChargeItem$One$buyable(chargeItem)) {
							var _v4 = A3(
								$author$project$Components$TranslatedRichText$startEditingCmd,
								'charge-item-rich-description-editor',
								$elm$core$Maybe$Just('Ex: Unlimited visits and direct access to your care team.'),
								formFields.bh);
							var newRichDescription = _v4.a;
							var cmd = _v4.b;
							return _Utils_Tuple2(
								_Utils_update(
									formFields,
									{bh: newRichDescription}),
								cmd);
						} else {
							return _Utils_Tuple2(formFields, $elm$core$Platform$Cmd$none);
						}
					}();
					var richDescFields = _v3.a;
					var richDescCmd = _v3.b;
					var _v5 = function () {
						if ($author$project$Api$Provider$ChargeItem$One$itemType(chargeItem) === 1) {
							var packageItems = $author$project$Api$Provider$ChargeItem$One$packageItems(chargeItem);
							var originalPrices = $elm$core$Dict$fromList(
								A2(
									$elm$core$List$filterMap,
									$elm$core$Basics$identity,
									A2(
										$elm$core$List$indexedMap,
										F2(
											function (index, item) {
												return A2(
													$elm$core$Maybe$andThen,
													function (price) {
														return (price > 0) ? $elm$core$Maybe$Just(
															_Utils_Tuple2(
																$elm$core$String$fromInt(index),
																$author$project$Currency$fromFloat(price))) : $elm$core$Maybe$Nothing;
													},
													item.afC);
											}),
										packageItems)));
							return A3(
								$elm$core$List$foldl,
								F2(
									function (rule, _v8) {
										var _v9 = _v8.a;
										var filters = _v9.a;
										var cmds = _v9.b;
										var _v10 = _v8.b;
										var tMap = _v10.a;
										var _v11 = A3(
											$author$project$Components$ResourceFilter$ChargeItem$init,
											apiClient,
											function (opts) {
												return _Utils_update(
													opts,
													{
														sW: $elm$core$Maybe$Just('item')
													});
											},
											function (d) {
												return _Utils_update(
													d,
													{Gp: 'Select a Charge Item'});
											});
										var resourceFilter = _v11.a;
										var cmd = _v11.b;
										var finalResourceFilter = function () {
											var _v12 = _Utils_Tuple2(rule.afA, rule.afB);
											if (!_v12.a.$) {
												var id = _v12.a.a;
												var maybeName = _v12.b;
												var name = A2($elm$core$Maybe$withDefault, id, maybeName);
												return A2(
													$author$project$Components$ResourceFilter$ChargeItem$setValue,
													$author$project$Components$ResourceFilter$Extra(
														{aih: name, aee: id}),
													A2(
														$author$project$Components$ResourceFilter$ChargeItem$extraItems,
														_List_fromArray(
															[
																{ahP: id, Bq: name}
															]),
														resourceFilter));
											} else {
												return resourceFilter;
											}
										}();
										return _Utils_Tuple2(
											_Utils_Tuple2(
												A3($elm$core$Dict$insert, rule.Y, finalResourceFilter, filters),
												A2(
													$elm$core$List$cons,
													A2(
														$elm$core$Platform$Cmd$map,
														$author$project$Components$Admin$ChargeItems$Form$PackageItemSelected(rule.Y),
														cmd),
													cmds)),
											_Utils_Tuple2(tMap, originalPrices));
									}),
								_Utils_Tuple2(
									_Utils_Tuple2($elm$core$Dict$empty, _List_Nil),
									_Utils_Tuple2($elm$core$Dict$empty, originalPrices)),
								formFields.YF);
						} else {
							return _Utils_Tuple2(
								_Utils_Tuple2($elm$core$Dict$empty, _List_Nil),
								_Utils_Tuple2($elm$core$Dict$empty, $elm$core$Dict$empty));
						}
					}();
					var _v6 = _v5.a;
					var packageItemFilters = _v6.a;
					var filterCmds = _v6.b;
					var _v7 = _v5.b;
					var taxableMap = _v7.a;
					var originalPricesMap = _v7.b;
					var _v13 = A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Components$ResourceFilter$Category$extraItems(
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function (category_) {
										return _List_fromArray(
											[
												{
												ahP: $author$project$Api$Provider$Category$Shared$id(category_),
												Bq: $author$project$Api$Provider$Category$Shared$name(category_)
											}
											]);
									},
									category))),
						A2(
							$author$project$Components$ResourceFilter$Category$preSelectedId,
							A2($elm$core$Maybe$map, $author$project$Api$Provider$Category$Shared$id, category),
							model.c8));
					var categoryResourceFilter = _v13.a;
					var categoryResourceFilterCmd = _v13.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								c8: categoryResourceFilter,
								fW: taxableMap,
								SD: $elm$core$Maybe$Just(
									$author$project$Utils$Form$init(richDescFields)),
								Am: $author$project$Api$Provider$ChargeItem$One$isLab(chargeItem),
								b4: originalPricesMap,
								b5: packageItemFilters
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$ChargeItems$Form$CategoryResourceFilterMsg, categoryResourceFilterCmd),
									$elm$core$Platform$Cmd$batch(filterCmds),
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$ChargeItems$Form$RichDescriptionMsg, richDescCmd)
								])),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$reportDecodeError(response));
				}
			case 10:
				var subMsg = msg.a;
				var _v14 = model.SD;
				if (!_v14.$) {
					var form = _v14.a;
					var fields = $author$project$Utils$Form$fields(form);
					var _v15 = A4(
						$author$project$Components$TranslatedRichText$update,
						'charge-item-rich-description-editor',
						$elm$core$Maybe$Just('Ex: Unlimited visits and direct access to your care team.'),
						subMsg,
						fields.bh);
					var newRichDescription = _v15.a;
					var richDescCmd = _v15.b;
					var newForm = A2(
						$author$project$Utils$Form$set,
						_Utils_update(
							fields,
							{bh: newRichDescription}),
						form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								SD: $elm$core$Maybe$Just(newForm)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$ChargeItems$Form$RichDescriptionMsg, richDescCmd),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 1:
				var field = msg.a;
				var _v16 = model.SD;
				if (!_v16.$) {
					var form = _v16.a;
					var updatedOriginalPrices = function () {
						if (field.$ === 18) {
							var tempId = field.a;
							return A2($elm$core$Dict$remove, tempId, model.b4);
						} else {
							return model.b4;
						}
					}();
					var newForm = function () {
						if (field.$ === 17) {
							return $author$project$Utils$Form$clearGroupErrors(5);
						} else {
							return $elm$core$Basics$identity;
						}
					}()(
						$author$project$Components$Admin$ChargeItems$Form$clearErrorsIfValid(
							A3($author$project$Utils$Form$update, $author$project$Components$Admin$ChargeItems$Form$formFieldsUpdate, field, form)));
					var _v17 = function () {
						if ((field.$ === 5) && field.a) {
							var fields = $author$project$Utils$Form$fields(newForm);
							var _v19 = A3(
								$author$project$Components$TranslatedRichText$startEditingCmd,
								'charge-item-rich-description-editor',
								$elm$core$Maybe$Just('Ex: Unlimited visits and direct access to your care team.'),
								fields.bh);
							var newRichDescription = _v19.a;
							var cmd = _v19.b;
							return _Utils_Tuple2(
								A2(
									$author$project$Utils$Form$set,
									_Utils_update(
										fields,
										{bh: newRichDescription}),
									newForm),
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$ChargeItems$Form$RichDescriptionMsg, cmd));
						} else {
							return _Utils_Tuple2(newForm, $elm$core$Platform$Cmd$none);
						}
					}();
					var richDescForm = _v17.a;
					var richDescCmd = _v17.b;
					var _v20 = function () {
						switch (field.$) {
							case 17:
								var formFields = $author$project$Utils$Form$fields(newForm);
								var tempId = A2(
									$elm$core$Maybe$withDefault,
									'0',
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.Y;
										},
										$elm$core$List$head(
											$elm$core$List$reverse(formFields.YF))));
								var _v22 = A3(
									$author$project$Components$ResourceFilter$ChargeItem$init,
									apiClient,
									function (opts) {
										return _Utils_update(
											opts,
											{
												sW: $elm$core$Maybe$Just('item')
											});
									},
									function (d) {
										return _Utils_update(
											d,
											{Gp: 'Select a Charge Item'});
									});
								var resourceFilter = _v22.a;
								var cmd = _v22.b;
								return _Utils_Tuple2(
									A3($elm$core$Dict$insert, tempId, resourceFilter, model.b5),
									A2(
										$elm$core$Platform$Cmd$map,
										$author$project$Components$Admin$ChargeItems$Form$PackageItemSelected(tempId),
										cmd));
							case 18:
								var tempId = field.a;
								return _Utils_Tuple2(
									A2($elm$core$Dict$remove, tempId, model.b5),
									$elm$core$Platform$Cmd$none);
							default:
								return _Utils_Tuple2(model.b5, $elm$core$Platform$Cmd$none);
						}
					}();
					var updatedFilters = _v20.a;
					var filterCmd = _v20.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								SD: $elm$core$Maybe$Just(richDescForm),
								b4: updatedOriginalPrices,
								b5: updatedFilters
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[filterCmd, richDescCmd])),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				var _v25 = model.SD;
				if (!_v25.$) {
					var form = _v25.a;
					var _v26 = A2($author$project$Utils$Form$validate, $author$project$Components$Admin$ChargeItems$Form$formFieldsValidator, form);
					if (!_v26.$) {
						var _v27 = _v26.a;
						var newForm = _v27.a;
						var validFormFields = _v27.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									SD: $elm$core$Maybe$Just(newForm),
									k9: $author$project$Api$Data$Loading
								}),
							A3($author$project$Components$Admin$ChargeItems$Form$saveItem, apiClient, model.ahP, validFormFields),
							_List_Nil);
					} else {
						var newForm = _v26.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									SD: $elm$core$Maybe$Just(newForm),
									k9: $author$project$Api$Data$NotAsked
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var response = msg.a;
				var _v28 = model.SD;
				if (!_v28.$) {
					if (response.$ === 3) {
						var chargeItem = response.a;
						return _Utils_Tuple3(
							model,
							A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__ChargeItems__Top),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									'Successfully created ' + $author$project$Api$Provider$ChargeItem$One$name(chargeItem))
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{k9: response}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				var response = msg.a;
				var _v30 = model.SD;
				if (!_v30.$) {
					if (response.$ === 3) {
						var chargeItem = response.a;
						return _Utils_Tuple3(
							model,
							A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__ChargeItems__Top),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Provider$ChargeItem$One$name(chargeItem) + ' was successfully updated.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{k9: response}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				var subMsg = msg.a;
				var categoryResourceResult = A3($author$project$Components$ResourceFilter$Category$update, apiClient, subMsg, model.c8);
				var _v32 = model.SD;
				if (!_v32.$) {
					var form = _v32.a;
					var newForm = function () {
						var _v33 = categoryResourceResult.agZ;
						if (!_v33.$) {
							return A3(
								$author$project$Utils$Form$update,
								$author$project$Components$Admin$ChargeItems$Form$formFieldsUpdate,
								$author$project$Components$Admin$ChargeItems$Form$Category(
									$author$project$Components$ResourceFilter$Category$value(categoryResourceResult.aiO)),
								form);
						} else {
							return form;
						}
					}();
					var newModel = _Utils_update(
						model,
						{
							c8: categoryResourceResult.aiO,
							SD: $elm$core$Maybe$Just(newForm)
						});
					return _Utils_Tuple3(
						newModel,
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$ChargeItems$Form$CategoryResourceFilterMsg, categoryResourceResult.GZ),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{c8: categoryResourceResult.aiO}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$ChargeItems$Form$CategoryResourceFilterMsg, categoryResourceResult.GZ),
						_List_Nil);
				}
			case 6:
				var tempId = msg.a;
				var subMsg = msg.b;
				var maybeFilter = A2($elm$core$Dict$get, tempId, model.b5);
				var _v34 = function () {
					if (!maybeFilter.$) {
						var resourceFilter = maybeFilter.a;
						var chargeItemResourceResult = A3($author$project$Components$ResourceFilter$ChargeItem$update, apiClient, subMsg, resourceFilter);
						var updatedFilters = A3($elm$core$Dict$insert, tempId, chargeItemResourceResult.aiO, model.b5);
						var _v36 = function () {
							var _v37 = chargeItemResourceResult.agZ;
							_v37$2:
							while (true) {
								if (!_v37.$) {
									switch (_v37.a.$) {
										case 0:
											var chargeItem = _v37.a.a;
											var _v38 = model.SD;
											if (!_v38.$) {
												var form = _v38.a;
												var originalPrice = $author$project$Currency$fromFloat(chargeItem.Dw);
												var selectedItem = A5($author$project$Components$Admin$ChargeItems$Form$SelectPackageItem, tempId, chargeItem.ahP, chargeItem.Bq, originalPrice, chargeItem.acZ);
												var selectedForm = A3($author$project$Utils$Form$update, $author$project$Components$Admin$ChargeItems$Form$formFieldsUpdate, selectedItem, form);
												var newTaxableMap = A3($elm$core$Dict$insert, chargeItem.ahP, chargeItem.acZ, model.fW);
												var newOriginalPrices = A3($elm$core$Dict$insert, tempId, originalPrice, model.b4);
												return _Utils_Tuple3(
													$elm$core$Maybe$Just(
														$author$project$Components$Admin$ChargeItems$Form$clearErrorsIfValid(selectedForm)),
													newTaxableMap,
													newOriginalPrices);
											} else {
												return _Utils_Tuple3($elm$core$Maybe$Nothing, model.fW, model.b4);
											}
										case 4:
											return _Utils_Tuple3(model.SD, model.fW, model.b4);
										default:
											break _v37$2;
									}
								} else {
									break _v37$2;
								}
							}
							return _Utils_Tuple3(model.SD, model.fW, model.b4);
						}();
						var updatedForm = _v36.a;
						var updatedTaxableMap = _v36.b;
						var updatedOriginalPrices = _v36.c;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{fW: updatedTaxableMap, SD: updatedForm, b4: updatedOriginalPrices, b5: updatedFilters}),
							A2(
								$elm$core$Platform$Cmd$map,
								$author$project$Components$Admin$ChargeItems$Form$PackageItemSelected(tempId),
								chargeItemResourceResult.GZ));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				}();
				var updatedModel = _v34.a;
				var cmd = _v34.b;
				return _Utils_Tuple3(updatedModel, cmd, _List_Nil);
			case 7:
				var subMsg = msg.a;
				var _v39 = A2($author$project$Ui$Dropdown$update, subMsg, model.mT);
				var newDropdown = _v39.a;
				var cmd = _v39.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{mT: newDropdown}),
					cmd,
					_List_Nil);
			case 8:
				var selectedCodeType = msg.a;
				var newForm = A2(
					$elm$core$Maybe$map,
					function (form) {
						return $author$project$Components$Admin$ChargeItems$Form$clearErrorsIfValid(
							A3(
								$author$project$Utils$Form$update,
								$author$project$Components$Admin$ChargeItems$Form$formFieldsUpdate,
								$author$project$Components$Admin$ChargeItems$Form$CodeType(selectedCodeType),
								form));
					},
					model.SD);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: newForm}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 11:
				var pictures = msg.a;
				var cmd = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						function (_v40) {
							var task = _v40.a;
							var size = _v40.b;
							return A2(
								$elm$core$Task$perform,
								A2(
									$elm$core$Basics$composeL,
									$author$project$Components$Admin$ChargeItems$Form$FormUpdated,
									$author$project$Components$Admin$ChargeItems$Form$Image(size)),
								task);
						},
						A2(
							$elm$core$Maybe$map,
							function (picture) {
								return _Utils_Tuple2(
									$elm$file$File$toUrl(picture),
									$elm$file$File$size(picture));
							},
							$elm$core$List$head(pictures))));
				return _Utils_Tuple3(model, cmd, _List_Nil);
			case 12:
				var subMsg = msg.a;
				var _v41 = A2($author$project$Components$DateInput$update, subMsg, model.sj);
				var newDatePicker = _v41.a;
				var event = _v41.c;
				var newModel = _Utils_update(
					model,
					{sj: newDatePicker});
				if (event.$ === 1) {
					var maybeDate = event.a;
					var newForm = A2(
						$elm$core$Maybe$map,
						function (form) {
							var fields = $author$project$Utils$Form$fields(form);
							return $author$project$Components$Admin$ChargeItems$Form$clearErrorsIfValid(
								A2(
									$author$project$Utils$Form$set,
									_Utils_update(
										fields,
										{RW: maybeDate}),
									form));
						},
						model.SD);
					return _Utils_Tuple3(
						_Utils_update(
							newModel,
							{SD: newForm}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 13:
				var today = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							FR: $elm$core$Maybe$Just(today)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				return _Utils_Tuple3(model, $author$project$Ports$Navigation$back, _List_Nil);
		}
	});
var $author$project$Pages$Admin$ChargeItems$Id_String$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Admin$ChargeItems$Form$update, model.Gv, subMsg, model.SD);
		var newForm = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{SD: newForm}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Components$Admin$ChargeItems$Form$BackButtonClicked = {$: 9};
var $author$project$Components$Admin$ChargeItems$Form$Save = {$: 2};
var $author$project$Ui$Form$Autocomplete = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$autocomplete = $author$project$Ui$Form$Autocomplete;
var $author$project$Ui$Form$NoValidate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$noValidate = $author$project$Ui$Form$NoValidate;
var $author$project$Api$FeatureGate$Packages = 14;
var $author$project$Api$Feature$SelfBuy = 22;
var $author$project$Api$Employer$Practice$One$featureGates = function (_v0) {
	var record = _v0;
	return record.Sd;
};
var $author$project$Api$Provider$Practice$One$featureGates = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Sd;
	});
var $author$project$Api$Practice$featureGates = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$featureGates(practice_);
	} else {
		var practice_ = practice.a;
		return $author$project$Api$Employer$Practice$One$featureGates(practice_);
	}
};
var $author$project$Api$FeatureGate$codeToString = function (code_) {
	switch (code_) {
		case 0:
			return 'multiple_signup_pages';
		case 1:
			return 'charge_uploader';
		case 2:
			return 'inventory_and_sales_tax';
		case 3:
			return 'sponsor_adhoc_invoices';
		case 4:
			return 'patient_credits';
		case 5:
			return 'patient_portal';
		case 6:
			return 'membership_pricing_schedule_plan_changes';
		case 7:
			return 'membership_pricing_advance_pricing_rules';
		case 8:
			return 'employee_uploads';
		case 9:
			return 'manage_employers';
		case 10:
			return 'customize_dunning_schedule';
		case 11:
			return 'engagement_tracking';
		case 12:
			return 'scheduled_partial_payments';
		case 13:
			return 'multiple_retail_memberships';
		default:
			return 'packages';
	}
};
var $author$project$Api$Common$FeatureGate$Shared$hasCode = F2(
	function (one, _v0) {
		var code = _v0.NN;
		return _Utils_eq(
			$author$project$Api$FeatureGate$codeToString(one),
			code);
	});
var $author$project$Utils$FeatureGate$findByCode = F2(
	function (code_, list) {
		return A2(
			$elm_community$list_extra$List$Extra$find,
			function (featureGate) {
				return A2($author$project$Api$Common$FeatureGate$Shared$hasCode, code_, featureGate);
			},
			list);
	});
var $author$project$Utils$FeatureGate$gateAvailable = F2(
	function (code, practice) {
		var _v0 = A2(
			$author$project$Utils$FeatureGate$findByCode,
			code,
			$author$project$Api$Practice$featureGates(practice));
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $author$project$Components$TranslatedRichText$EditToggled = {$: 1};
var $author$project$Ui$Form$Group$LabelClass = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Form$Group$labelClass = $author$project$Ui$Form$Group$LabelClass;
var $author$project$Ui$Form$Group$offsetLabel = $author$project$Ui$Form$Group$LabelGrid(
	_List_fromArray(
		['ml-1/12']));
var $hecrj$html_parser$Html$Parser$Element = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $hecrj$html_parser$Html$Parser$chompOneOrMore = function (fn) {
	return A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$chompIf(fn),
		$elm$parser$Parser$chompWhile(fn));
};
var $hecrj$html_parser$Html$Parser$isSpaceCharacter = function (c) {
	return (c === ' ') || ((c === '\t') || ((c === '\n') || ((c === '\u000D') || ((c === '\u000C') || (c === '\u00A0')))));
};
var $hecrj$html_parser$Html$Parser$closingTag = function (name) {
	var chompName = A2(
		$elm$parser$Parser$andThen,
		function (closingName) {
			return _Utils_eq(
				$elm$core$String$toLower(closingName),
				name) ? $elm$parser$Parser$succeed(0) : $elm$parser$Parser$problem('closing tag does not match opening tag: ' + name);
		},
		$elm$parser$Parser$getChompedString(
			$hecrj$html_parser$Html$Parser$chompOneOrMore(
				function (c) {
					return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && (c !== '>');
				})));
	return A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('<')),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('/'))),
				chompName),
			$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('>')));
};
var $hecrj$html_parser$Html$Parser$Comment = function (a) {
	return {$: 2, a: a};
};
var $elm$parser$Parser$Advanced$findSubString = _Parser_findSubString;
var $elm$parser$Parser$Advanced$fromInfo = F4(
	function (row, col, x, context) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, row, col, x, context));
	});
var $elm$parser$Parser$Advanced$chompUntil = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$findSubString, str, s.g, s.pL, s.NQ, s.uN);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A4($elm$parser$Parser$Advanced$fromInfo, newRow, newCol, expecting, s.a3)) : A3(
			$elm$parser$Parser$Advanced$Good,
			_Utils_cmp(s.g, newOffset) < 0,
			0,
			{NQ: newCol, a3: s.a3, ahY: s.ahY, g: newOffset, pL: newRow, uN: s.uN});
	};
};
var $elm$parser$Parser$chompUntil = function (str) {
	return $elm$parser$Parser$Advanced$chompUntil(
		$elm$parser$Parser$toToken(str));
};
var $hecrj$html_parser$Html$Parser$commentString = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$token('<!')),
		$elm$parser$Parser$token('--')),
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$getChompedString(
			$elm$parser$Parser$chompUntil('-->')),
		$elm$parser$Parser$token('-->')));
var $hecrj$html_parser$Html$Parser$comment = A2($elm$parser$Parser$map, $hecrj$html_parser$Html$Parser$Comment, $hecrj$html_parser$Html$Parser$commentString);
var $hecrj$html_parser$Html$Parser$voidElements = _List_fromArray(
	['area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'link', 'meta', 'param', 'source', 'track', 'wbr']);
var $hecrj$html_parser$Html$Parser$isVoidElement = function (name) {
	return A2($elm$core$List$member, name, $hecrj$html_parser$Html$Parser$voidElements);
};
var $hecrj$html_parser$Html$Parser$many = function (parser_) {
	return A2(
		$elm$parser$Parser$loop,
		_List_Nil,
		function (list) {
			return $elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$map,
						function (_new) {
							return $elm$parser$Parser$Loop(
								A2($elm$core$List$cons, _new, list));
						},
						parser_),
						$elm$parser$Parser$succeed(
						$elm$parser$Parser$Done(
							$elm$core$List$reverse(list)))
					]));
		});
};
var $hecrj$html_parser$Html$Parser$isTagAttributeCharacter = function (c) {
	return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && ((c !== '\"') && ((c !== '\'') && ((c !== '>') && ((c !== '/') && (c !== '=')))));
};
var $hecrj$html_parser$Html$Parser$tagAttributeName = A2(
	$elm$parser$Parser$map,
	$elm$core$String$toLower,
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($hecrj$html_parser$Html$Parser$isTagAttributeCharacter)));
var $hecrj$html_parser$Html$Parser$chompSemicolon = $elm$parser$Parser$chompIf(
	$elm$core$Basics$eq(';'));
var $hecrj$html_parser$Html$Parser$NamedCharacterReferences$dict = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('Aacute', 'Á'),
			_Utils_Tuple2('aacute', 'á'),
			_Utils_Tuple2('Abreve', 'Ă'),
			_Utils_Tuple2('abreve', 'ă'),
			_Utils_Tuple2('ac', '∾'),
			_Utils_Tuple2('acd', '∿'),
			_Utils_Tuple2('acE', '∾̳'),
			_Utils_Tuple2('Acirc', 'Â'),
			_Utils_Tuple2('acirc', 'â'),
			_Utils_Tuple2('acute', '´'),
			_Utils_Tuple2('Acy', 'А'),
			_Utils_Tuple2('acy', 'а'),
			_Utils_Tuple2('AElig', 'Æ'),
			_Utils_Tuple2('aelig', 'æ'),
			_Utils_Tuple2('af', '\u2061'),
			_Utils_Tuple2('Afr', '\uD835\uDD04'),
			_Utils_Tuple2('afr', '\uD835\uDD1E'),
			_Utils_Tuple2('Agrave', 'À'),
			_Utils_Tuple2('agrave', 'à'),
			_Utils_Tuple2('alefsym', 'ℵ'),
			_Utils_Tuple2('aleph', 'ℵ'),
			_Utils_Tuple2('Alpha', 'Α'),
			_Utils_Tuple2('alpha', 'α'),
			_Utils_Tuple2('Amacr', 'Ā'),
			_Utils_Tuple2('amacr', 'ā'),
			_Utils_Tuple2('amalg', '⨿'),
			_Utils_Tuple2('amp', '&'),
			_Utils_Tuple2('AMP', '&'),
			_Utils_Tuple2('andand', '⩕'),
			_Utils_Tuple2('And', '⩓'),
			_Utils_Tuple2('and', '∧'),
			_Utils_Tuple2('andd', '⩜'),
			_Utils_Tuple2('andslope', '⩘'),
			_Utils_Tuple2('andv', '⩚'),
			_Utils_Tuple2('ang', '∠'),
			_Utils_Tuple2('ange', '⦤'),
			_Utils_Tuple2('angle', '∠'),
			_Utils_Tuple2('angmsdaa', '⦨'),
			_Utils_Tuple2('angmsdab', '⦩'),
			_Utils_Tuple2('angmsdac', '⦪'),
			_Utils_Tuple2('angmsdad', '⦫'),
			_Utils_Tuple2('angmsdae', '⦬'),
			_Utils_Tuple2('angmsdaf', '⦭'),
			_Utils_Tuple2('angmsdag', '⦮'),
			_Utils_Tuple2('angmsdah', '⦯'),
			_Utils_Tuple2('angmsd', '∡'),
			_Utils_Tuple2('angrt', '∟'),
			_Utils_Tuple2('angrtvb', '⊾'),
			_Utils_Tuple2('angrtvbd', '⦝'),
			_Utils_Tuple2('angsph', '∢'),
			_Utils_Tuple2('angst', 'Å'),
			_Utils_Tuple2('angzarr', '⍼'),
			_Utils_Tuple2('Aogon', 'Ą'),
			_Utils_Tuple2('aogon', 'ą'),
			_Utils_Tuple2('Aopf', '\uD835\uDD38'),
			_Utils_Tuple2('aopf', '\uD835\uDD52'),
			_Utils_Tuple2('apacir', '⩯'),
			_Utils_Tuple2('ap', '≈'),
			_Utils_Tuple2('apE', '⩰'),
			_Utils_Tuple2('ape', '≊'),
			_Utils_Tuple2('apid', '≋'),
			_Utils_Tuple2('apos', '\''),
			_Utils_Tuple2('ApplyFunction', '\u2061'),
			_Utils_Tuple2('approx', '≈'),
			_Utils_Tuple2('approxeq', '≊'),
			_Utils_Tuple2('Aring', 'Å'),
			_Utils_Tuple2('aring', 'å'),
			_Utils_Tuple2('Ascr', '\uD835\uDC9C'),
			_Utils_Tuple2('ascr', '\uD835\uDCB6'),
			_Utils_Tuple2('Assign', '≔'),
			_Utils_Tuple2('ast', '*'),
			_Utils_Tuple2('asymp', '≈'),
			_Utils_Tuple2('asympeq', '≍'),
			_Utils_Tuple2('Atilde', 'Ã'),
			_Utils_Tuple2('atilde', 'ã'),
			_Utils_Tuple2('Auml', 'Ä'),
			_Utils_Tuple2('auml', 'ä'),
			_Utils_Tuple2('awconint', '∳'),
			_Utils_Tuple2('awint', '⨑'),
			_Utils_Tuple2('backcong', '≌'),
			_Utils_Tuple2('backepsilon', '϶'),
			_Utils_Tuple2('backprime', '‵'),
			_Utils_Tuple2('backsim', '∽'),
			_Utils_Tuple2('backsimeq', '⋍'),
			_Utils_Tuple2('Backslash', '∖'),
			_Utils_Tuple2('Barv', '⫧'),
			_Utils_Tuple2('barvee', '⊽'),
			_Utils_Tuple2('barwed', '⌅'),
			_Utils_Tuple2('Barwed', '⌆'),
			_Utils_Tuple2('barwedge', '⌅'),
			_Utils_Tuple2('bbrk', '⎵'),
			_Utils_Tuple2('bbrktbrk', '⎶'),
			_Utils_Tuple2('bcong', '≌'),
			_Utils_Tuple2('Bcy', 'Б'),
			_Utils_Tuple2('bcy', 'б'),
			_Utils_Tuple2('bdquo', '„'),
			_Utils_Tuple2('becaus', '∵'),
			_Utils_Tuple2('because', '∵'),
			_Utils_Tuple2('Because', '∵'),
			_Utils_Tuple2('bemptyv', '⦰'),
			_Utils_Tuple2('bepsi', '϶'),
			_Utils_Tuple2('bernou', 'ℬ'),
			_Utils_Tuple2('Bernoullis', 'ℬ'),
			_Utils_Tuple2('Beta', 'Β'),
			_Utils_Tuple2('beta', 'β'),
			_Utils_Tuple2('beth', 'ℶ'),
			_Utils_Tuple2('between', '≬'),
			_Utils_Tuple2('Bfr', '\uD835\uDD05'),
			_Utils_Tuple2('bfr', '\uD835\uDD1F'),
			_Utils_Tuple2('bigcap', '⋂'),
			_Utils_Tuple2('bigcirc', '◯'),
			_Utils_Tuple2('bigcup', '⋃'),
			_Utils_Tuple2('bigodot', '⨀'),
			_Utils_Tuple2('bigoplus', '⨁'),
			_Utils_Tuple2('bigotimes', '⨂'),
			_Utils_Tuple2('bigsqcup', '⨆'),
			_Utils_Tuple2('bigstar', '★'),
			_Utils_Tuple2('bigtriangledown', '▽'),
			_Utils_Tuple2('bigtriangleup', '△'),
			_Utils_Tuple2('biguplus', '⨄'),
			_Utils_Tuple2('bigvee', '⋁'),
			_Utils_Tuple2('bigwedge', '⋀'),
			_Utils_Tuple2('bkarow', '⤍'),
			_Utils_Tuple2('blacklozenge', '⧫'),
			_Utils_Tuple2('blacksquare', '▪'),
			_Utils_Tuple2('blacktriangle', '▴'),
			_Utils_Tuple2('blacktriangledown', '▾'),
			_Utils_Tuple2('blacktriangleleft', '◂'),
			_Utils_Tuple2('blacktriangleright', '▸'),
			_Utils_Tuple2('blank', '␣'),
			_Utils_Tuple2('blk12', '▒'),
			_Utils_Tuple2('blk14', '░'),
			_Utils_Tuple2('blk34', '▓'),
			_Utils_Tuple2('block', '█'),
			_Utils_Tuple2('bne', '=⃥'),
			_Utils_Tuple2('bnequiv', '≡⃥'),
			_Utils_Tuple2('bNot', '⫭'),
			_Utils_Tuple2('bnot', '⌐'),
			_Utils_Tuple2('Bopf', '\uD835\uDD39'),
			_Utils_Tuple2('bopf', '\uD835\uDD53'),
			_Utils_Tuple2('bot', '⊥'),
			_Utils_Tuple2('bottom', '⊥'),
			_Utils_Tuple2('bowtie', '⋈'),
			_Utils_Tuple2('boxbox', '⧉'),
			_Utils_Tuple2('boxdl', '┐'),
			_Utils_Tuple2('boxdL', '╕'),
			_Utils_Tuple2('boxDl', '╖'),
			_Utils_Tuple2('boxDL', '╗'),
			_Utils_Tuple2('boxdr', '┌'),
			_Utils_Tuple2('boxdR', '╒'),
			_Utils_Tuple2('boxDr', '╓'),
			_Utils_Tuple2('boxDR', '╔'),
			_Utils_Tuple2('boxh', '─'),
			_Utils_Tuple2('boxH', '═'),
			_Utils_Tuple2('boxhd', '┬'),
			_Utils_Tuple2('boxHd', '╤'),
			_Utils_Tuple2('boxhD', '╥'),
			_Utils_Tuple2('boxHD', '╦'),
			_Utils_Tuple2('boxhu', '┴'),
			_Utils_Tuple2('boxHu', '╧'),
			_Utils_Tuple2('boxhU', '╨'),
			_Utils_Tuple2('boxHU', '╩'),
			_Utils_Tuple2('boxminus', '⊟'),
			_Utils_Tuple2('boxplus', '⊞'),
			_Utils_Tuple2('boxtimes', '⊠'),
			_Utils_Tuple2('boxul', '┘'),
			_Utils_Tuple2('boxuL', '╛'),
			_Utils_Tuple2('boxUl', '╜'),
			_Utils_Tuple2('boxUL', '╝'),
			_Utils_Tuple2('boxur', '└'),
			_Utils_Tuple2('boxuR', '╘'),
			_Utils_Tuple2('boxUr', '╙'),
			_Utils_Tuple2('boxUR', '╚'),
			_Utils_Tuple2('boxv', '│'),
			_Utils_Tuple2('boxV', '║'),
			_Utils_Tuple2('boxvh', '┼'),
			_Utils_Tuple2('boxvH', '╪'),
			_Utils_Tuple2('boxVh', '╫'),
			_Utils_Tuple2('boxVH', '╬'),
			_Utils_Tuple2('boxvl', '┤'),
			_Utils_Tuple2('boxvL', '╡'),
			_Utils_Tuple2('boxVl', '╢'),
			_Utils_Tuple2('boxVL', '╣'),
			_Utils_Tuple2('boxvr', '├'),
			_Utils_Tuple2('boxvR', '╞'),
			_Utils_Tuple2('boxVr', '╟'),
			_Utils_Tuple2('boxVR', '╠'),
			_Utils_Tuple2('bprime', '‵'),
			_Utils_Tuple2('breve', '˘'),
			_Utils_Tuple2('Breve', '˘'),
			_Utils_Tuple2('brvbar', '¦'),
			_Utils_Tuple2('bscr', '\uD835\uDCB7'),
			_Utils_Tuple2('Bscr', 'ℬ'),
			_Utils_Tuple2('bsemi', '⁏'),
			_Utils_Tuple2('bsim', '∽'),
			_Utils_Tuple2('bsime', '⋍'),
			_Utils_Tuple2('bsolb', '⧅'),
			_Utils_Tuple2('bsol', '\\'),
			_Utils_Tuple2('bsolhsub', '⟈'),
			_Utils_Tuple2('bull', '•'),
			_Utils_Tuple2('bullet', '•'),
			_Utils_Tuple2('bump', '≎'),
			_Utils_Tuple2('bumpE', '⪮'),
			_Utils_Tuple2('bumpe', '≏'),
			_Utils_Tuple2('Bumpeq', '≎'),
			_Utils_Tuple2('bumpeq', '≏'),
			_Utils_Tuple2('Cacute', 'Ć'),
			_Utils_Tuple2('cacute', 'ć'),
			_Utils_Tuple2('capand', '⩄'),
			_Utils_Tuple2('capbrcup', '⩉'),
			_Utils_Tuple2('capcap', '⩋'),
			_Utils_Tuple2('cap', '∩'),
			_Utils_Tuple2('Cap', '⋒'),
			_Utils_Tuple2('capcup', '⩇'),
			_Utils_Tuple2('capdot', '⩀'),
			_Utils_Tuple2('CapitalDifferentialD', 'ⅅ'),
			_Utils_Tuple2('caps', '∩︀'),
			_Utils_Tuple2('caret', '⁁'),
			_Utils_Tuple2('caron', 'ˇ'),
			_Utils_Tuple2('Cayleys', 'ℭ'),
			_Utils_Tuple2('ccaps', '⩍'),
			_Utils_Tuple2('Ccaron', 'Č'),
			_Utils_Tuple2('ccaron', 'č'),
			_Utils_Tuple2('Ccedil', 'Ç'),
			_Utils_Tuple2('ccedil', 'ç'),
			_Utils_Tuple2('Ccirc', 'Ĉ'),
			_Utils_Tuple2('ccirc', 'ĉ'),
			_Utils_Tuple2('Cconint', '∰'),
			_Utils_Tuple2('ccups', '⩌'),
			_Utils_Tuple2('ccupssm', '⩐'),
			_Utils_Tuple2('Cdot', 'Ċ'),
			_Utils_Tuple2('cdot', 'ċ'),
			_Utils_Tuple2('cedil', '¸'),
			_Utils_Tuple2('Cedilla', '¸'),
			_Utils_Tuple2('cemptyv', '⦲'),
			_Utils_Tuple2('cent', '¢'),
			_Utils_Tuple2('centerdot', '·'),
			_Utils_Tuple2('CenterDot', '·'),
			_Utils_Tuple2('cfr', '\uD835\uDD20'),
			_Utils_Tuple2('Cfr', 'ℭ'),
			_Utils_Tuple2('CHcy', 'Ч'),
			_Utils_Tuple2('chcy', 'ч'),
			_Utils_Tuple2('check', '✓'),
			_Utils_Tuple2('checkmark', '✓'),
			_Utils_Tuple2('Chi', 'Χ'),
			_Utils_Tuple2('chi', 'χ'),
			_Utils_Tuple2('circ', 'ˆ'),
			_Utils_Tuple2('circeq', '≗'),
			_Utils_Tuple2('circlearrowleft', '↺'),
			_Utils_Tuple2('circlearrowright', '↻'),
			_Utils_Tuple2('circledast', '⊛'),
			_Utils_Tuple2('circledcirc', '⊚'),
			_Utils_Tuple2('circleddash', '⊝'),
			_Utils_Tuple2('CircleDot', '⊙'),
			_Utils_Tuple2('circledR', '®'),
			_Utils_Tuple2('circledS', 'Ⓢ'),
			_Utils_Tuple2('CircleMinus', '⊖'),
			_Utils_Tuple2('CirclePlus', '⊕'),
			_Utils_Tuple2('CircleTimes', '⊗'),
			_Utils_Tuple2('cir', '○'),
			_Utils_Tuple2('cirE', '⧃'),
			_Utils_Tuple2('cire', '≗'),
			_Utils_Tuple2('cirfnint', '⨐'),
			_Utils_Tuple2('cirmid', '⫯'),
			_Utils_Tuple2('cirscir', '⧂'),
			_Utils_Tuple2('ClockwiseContourIntegral', '∲'),
			_Utils_Tuple2('CloseCurlyDoubleQuote', '”'),
			_Utils_Tuple2('CloseCurlyQuote', '’'),
			_Utils_Tuple2('clubs', '♣'),
			_Utils_Tuple2('clubsuit', '♣'),
			_Utils_Tuple2('colon', ':'),
			_Utils_Tuple2('Colon', '∷'),
			_Utils_Tuple2('Colone', '⩴'),
			_Utils_Tuple2('colone', '≔'),
			_Utils_Tuple2('coloneq', '≔'),
			_Utils_Tuple2('comma', ','),
			_Utils_Tuple2('commat', '@'),
			_Utils_Tuple2('comp', '∁'),
			_Utils_Tuple2('compfn', '∘'),
			_Utils_Tuple2('complement', '∁'),
			_Utils_Tuple2('complexes', 'ℂ'),
			_Utils_Tuple2('cong', '≅'),
			_Utils_Tuple2('congdot', '⩭'),
			_Utils_Tuple2('Congruent', '≡'),
			_Utils_Tuple2('conint', '∮'),
			_Utils_Tuple2('Conint', '∯'),
			_Utils_Tuple2('ContourIntegral', '∮'),
			_Utils_Tuple2('copf', '\uD835\uDD54'),
			_Utils_Tuple2('Copf', 'ℂ'),
			_Utils_Tuple2('coprod', '∐'),
			_Utils_Tuple2('Coproduct', '∐'),
			_Utils_Tuple2('copy', '©'),
			_Utils_Tuple2('COPY', '©'),
			_Utils_Tuple2('copysr', '℗'),
			_Utils_Tuple2('CounterClockwiseContourIntegral', '∳'),
			_Utils_Tuple2('crarr', '↵'),
			_Utils_Tuple2('cross', '✗'),
			_Utils_Tuple2('Cross', '⨯'),
			_Utils_Tuple2('Cscr', '\uD835\uDC9E'),
			_Utils_Tuple2('cscr', '\uD835\uDCB8'),
			_Utils_Tuple2('csub', '⫏'),
			_Utils_Tuple2('csube', '⫑'),
			_Utils_Tuple2('csup', '⫐'),
			_Utils_Tuple2('csupe', '⫒'),
			_Utils_Tuple2('ctdot', '⋯'),
			_Utils_Tuple2('cudarrl', '⤸'),
			_Utils_Tuple2('cudarrr', '⤵'),
			_Utils_Tuple2('cuepr', '⋞'),
			_Utils_Tuple2('cuesc', '⋟'),
			_Utils_Tuple2('cularr', '↶'),
			_Utils_Tuple2('cularrp', '⤽'),
			_Utils_Tuple2('cupbrcap', '⩈'),
			_Utils_Tuple2('cupcap', '⩆'),
			_Utils_Tuple2('CupCap', '≍'),
			_Utils_Tuple2('cup', '∪'),
			_Utils_Tuple2('Cup', '⋓'),
			_Utils_Tuple2('cupcup', '⩊'),
			_Utils_Tuple2('cupdot', '⊍'),
			_Utils_Tuple2('cupor', '⩅'),
			_Utils_Tuple2('cups', '∪︀'),
			_Utils_Tuple2('curarr', '↷'),
			_Utils_Tuple2('curarrm', '⤼'),
			_Utils_Tuple2('curlyeqprec', '⋞'),
			_Utils_Tuple2('curlyeqsucc', '⋟'),
			_Utils_Tuple2('curlyvee', '⋎'),
			_Utils_Tuple2('curlywedge', '⋏'),
			_Utils_Tuple2('curren', '¤'),
			_Utils_Tuple2('curvearrowleft', '↶'),
			_Utils_Tuple2('curvearrowright', '↷'),
			_Utils_Tuple2('cuvee', '⋎'),
			_Utils_Tuple2('cuwed', '⋏'),
			_Utils_Tuple2('cwconint', '∲'),
			_Utils_Tuple2('cwint', '∱'),
			_Utils_Tuple2('cylcty', '⌭'),
			_Utils_Tuple2('dagger', '†'),
			_Utils_Tuple2('Dagger', '‡'),
			_Utils_Tuple2('daleth', 'ℸ'),
			_Utils_Tuple2('darr', '↓'),
			_Utils_Tuple2('Darr', '↡'),
			_Utils_Tuple2('dArr', '⇓'),
			_Utils_Tuple2('dash', '‐'),
			_Utils_Tuple2('Dashv', '⫤'),
			_Utils_Tuple2('dashv', '⊣'),
			_Utils_Tuple2('dbkarow', '⤏'),
			_Utils_Tuple2('dblac', '˝'),
			_Utils_Tuple2('Dcaron', 'Ď'),
			_Utils_Tuple2('dcaron', 'ď'),
			_Utils_Tuple2('Dcy', 'Д'),
			_Utils_Tuple2('dcy', 'д'),
			_Utils_Tuple2('ddagger', '‡'),
			_Utils_Tuple2('ddarr', '⇊'),
			_Utils_Tuple2('DD', 'ⅅ'),
			_Utils_Tuple2('dd', 'ⅆ'),
			_Utils_Tuple2('DDotrahd', '⤑'),
			_Utils_Tuple2('ddotseq', '⩷'),
			_Utils_Tuple2('deg', '°'),
			_Utils_Tuple2('Del', '∇'),
			_Utils_Tuple2('Delta', 'Δ'),
			_Utils_Tuple2('delta', 'δ'),
			_Utils_Tuple2('demptyv', '⦱'),
			_Utils_Tuple2('dfisht', '⥿'),
			_Utils_Tuple2('Dfr', '\uD835\uDD07'),
			_Utils_Tuple2('dfr', '\uD835\uDD21'),
			_Utils_Tuple2('dHar', '⥥'),
			_Utils_Tuple2('dharl', '⇃'),
			_Utils_Tuple2('dharr', '⇂'),
			_Utils_Tuple2('DiacriticalAcute', '´'),
			_Utils_Tuple2('DiacriticalDot', '˙'),
			_Utils_Tuple2('DiacriticalDoubleAcute', '˝'),
			_Utils_Tuple2('DiacriticalGrave', '`'),
			_Utils_Tuple2('DiacriticalTilde', '˜'),
			_Utils_Tuple2('diam', '⋄'),
			_Utils_Tuple2('diamond', '⋄'),
			_Utils_Tuple2('Diamond', '⋄'),
			_Utils_Tuple2('diamondsuit', '♦'),
			_Utils_Tuple2('diams', '♦'),
			_Utils_Tuple2('die', '¨'),
			_Utils_Tuple2('DifferentialD', 'ⅆ'),
			_Utils_Tuple2('digamma', 'ϝ'),
			_Utils_Tuple2('disin', '⋲'),
			_Utils_Tuple2('div', '÷'),
			_Utils_Tuple2('divide', '÷'),
			_Utils_Tuple2('divideontimes', '⋇'),
			_Utils_Tuple2('divonx', '⋇'),
			_Utils_Tuple2('DJcy', 'Ђ'),
			_Utils_Tuple2('djcy', 'ђ'),
			_Utils_Tuple2('dlcorn', '⌞'),
			_Utils_Tuple2('dlcrop', '⌍'),
			_Utils_Tuple2('dollar', '$'),
			_Utils_Tuple2('Dopf', '\uD835\uDD3B'),
			_Utils_Tuple2('dopf', '\uD835\uDD55'),
			_Utils_Tuple2('Dot', '¨'),
			_Utils_Tuple2('dot', '˙'),
			_Utils_Tuple2('DotDot', '⃜'),
			_Utils_Tuple2('doteq', '≐'),
			_Utils_Tuple2('doteqdot', '≑'),
			_Utils_Tuple2('DotEqual', '≐'),
			_Utils_Tuple2('dotminus', '∸'),
			_Utils_Tuple2('dotplus', '∔'),
			_Utils_Tuple2('dotsquare', '⊡'),
			_Utils_Tuple2('doublebarwedge', '⌆'),
			_Utils_Tuple2('DoubleContourIntegral', '∯'),
			_Utils_Tuple2('DoubleDot', '¨'),
			_Utils_Tuple2('DoubleDownArrow', '⇓'),
			_Utils_Tuple2('DoubleLeftArrow', '⇐'),
			_Utils_Tuple2('DoubleLeftRightArrow', '⇔'),
			_Utils_Tuple2('DoubleLeftTee', '⫤'),
			_Utils_Tuple2('DoubleLongLeftArrow', '⟸'),
			_Utils_Tuple2('DoubleLongLeftRightArrow', '⟺'),
			_Utils_Tuple2('DoubleLongRightArrow', '⟹'),
			_Utils_Tuple2('DoubleRightArrow', '⇒'),
			_Utils_Tuple2('DoubleRightTee', '⊨'),
			_Utils_Tuple2('DoubleUpArrow', '⇑'),
			_Utils_Tuple2('DoubleUpDownArrow', '⇕'),
			_Utils_Tuple2('DoubleVerticalBar', '∥'),
			_Utils_Tuple2('DownArrowBar', '⤓'),
			_Utils_Tuple2('downarrow', '↓'),
			_Utils_Tuple2('DownArrow', '↓'),
			_Utils_Tuple2('Downarrow', '⇓'),
			_Utils_Tuple2('DownArrowUpArrow', '⇵'),
			_Utils_Tuple2('DownBreve', '̑'),
			_Utils_Tuple2('downdownarrows', '⇊'),
			_Utils_Tuple2('downharpoonleft', '⇃'),
			_Utils_Tuple2('downharpoonright', '⇂'),
			_Utils_Tuple2('DownLeftRightVector', '⥐'),
			_Utils_Tuple2('DownLeftTeeVector', '⥞'),
			_Utils_Tuple2('DownLeftVectorBar', '⥖'),
			_Utils_Tuple2('DownLeftVector', '↽'),
			_Utils_Tuple2('DownRightTeeVector', '⥟'),
			_Utils_Tuple2('DownRightVectorBar', '⥗'),
			_Utils_Tuple2('DownRightVector', '⇁'),
			_Utils_Tuple2('DownTeeArrow', '↧'),
			_Utils_Tuple2('DownTee', '⊤'),
			_Utils_Tuple2('drbkarow', '⤐'),
			_Utils_Tuple2('drcorn', '⌟'),
			_Utils_Tuple2('drcrop', '⌌'),
			_Utils_Tuple2('Dscr', '\uD835\uDC9F'),
			_Utils_Tuple2('dscr', '\uD835\uDCB9'),
			_Utils_Tuple2('DScy', 'Ѕ'),
			_Utils_Tuple2('dscy', 'ѕ'),
			_Utils_Tuple2('dsol', '⧶'),
			_Utils_Tuple2('Dstrok', 'Đ'),
			_Utils_Tuple2('dstrok', 'đ'),
			_Utils_Tuple2('dtdot', '⋱'),
			_Utils_Tuple2('dtri', '▿'),
			_Utils_Tuple2('dtrif', '▾'),
			_Utils_Tuple2('duarr', '⇵'),
			_Utils_Tuple2('duhar', '⥯'),
			_Utils_Tuple2('dwangle', '⦦'),
			_Utils_Tuple2('DZcy', 'Џ'),
			_Utils_Tuple2('dzcy', 'џ'),
			_Utils_Tuple2('dzigrarr', '⟿'),
			_Utils_Tuple2('Eacute', 'É'),
			_Utils_Tuple2('eacute', 'é'),
			_Utils_Tuple2('easter', '⩮'),
			_Utils_Tuple2('Ecaron', 'Ě'),
			_Utils_Tuple2('ecaron', 'ě'),
			_Utils_Tuple2('Ecirc', 'Ê'),
			_Utils_Tuple2('ecirc', 'ê'),
			_Utils_Tuple2('ecir', '≖'),
			_Utils_Tuple2('ecolon', '≕'),
			_Utils_Tuple2('Ecy', 'Э'),
			_Utils_Tuple2('ecy', 'э'),
			_Utils_Tuple2('eDDot', '⩷'),
			_Utils_Tuple2('Edot', 'Ė'),
			_Utils_Tuple2('edot', 'ė'),
			_Utils_Tuple2('eDot', '≑'),
			_Utils_Tuple2('ee', 'ⅇ'),
			_Utils_Tuple2('efDot', '≒'),
			_Utils_Tuple2('Efr', '\uD835\uDD08'),
			_Utils_Tuple2('efr', '\uD835\uDD22'),
			_Utils_Tuple2('eg', '⪚'),
			_Utils_Tuple2('Egrave', 'È'),
			_Utils_Tuple2('egrave', 'è'),
			_Utils_Tuple2('egs', '⪖'),
			_Utils_Tuple2('egsdot', '⪘'),
			_Utils_Tuple2('el', '⪙'),
			_Utils_Tuple2('Element', '∈'),
			_Utils_Tuple2('elinters', '⏧'),
			_Utils_Tuple2('ell', 'ℓ'),
			_Utils_Tuple2('els', '⪕'),
			_Utils_Tuple2('elsdot', '⪗'),
			_Utils_Tuple2('Emacr', 'Ē'),
			_Utils_Tuple2('emacr', 'ē'),
			_Utils_Tuple2('empty', '∅'),
			_Utils_Tuple2('emptyset', '∅'),
			_Utils_Tuple2('EmptySmallSquare', '◻'),
			_Utils_Tuple2('emptyv', '∅'),
			_Utils_Tuple2('EmptyVerySmallSquare', '▫'),
			_Utils_Tuple2('emsp13', '\u2004'),
			_Utils_Tuple2('emsp14', '\u2005'),
			_Utils_Tuple2('emsp', '\u2003'),
			_Utils_Tuple2('ENG', 'Ŋ'),
			_Utils_Tuple2('eng', 'ŋ'),
			_Utils_Tuple2('ensp', '\u2002'),
			_Utils_Tuple2('Eogon', 'Ę'),
			_Utils_Tuple2('eogon', 'ę'),
			_Utils_Tuple2('Eopf', '\uD835\uDD3C'),
			_Utils_Tuple2('eopf', '\uD835\uDD56'),
			_Utils_Tuple2('epar', '⋕'),
			_Utils_Tuple2('eparsl', '⧣'),
			_Utils_Tuple2('eplus', '⩱'),
			_Utils_Tuple2('epsi', 'ε'),
			_Utils_Tuple2('Epsilon', 'Ε'),
			_Utils_Tuple2('epsilon', 'ε'),
			_Utils_Tuple2('epsiv', 'ϵ'),
			_Utils_Tuple2('eqcirc', '≖'),
			_Utils_Tuple2('eqcolon', '≕'),
			_Utils_Tuple2('eqsim', '≂'),
			_Utils_Tuple2('eqslantgtr', '⪖'),
			_Utils_Tuple2('eqslantless', '⪕'),
			_Utils_Tuple2('Equal', '⩵'),
			_Utils_Tuple2('equals', '='),
			_Utils_Tuple2('EqualTilde', '≂'),
			_Utils_Tuple2('equest', '≟'),
			_Utils_Tuple2('Equilibrium', '⇌'),
			_Utils_Tuple2('equiv', '≡'),
			_Utils_Tuple2('equivDD', '⩸'),
			_Utils_Tuple2('eqvparsl', '⧥'),
			_Utils_Tuple2('erarr', '⥱'),
			_Utils_Tuple2('erDot', '≓'),
			_Utils_Tuple2('escr', 'ℯ'),
			_Utils_Tuple2('Escr', 'ℰ'),
			_Utils_Tuple2('esdot', '≐'),
			_Utils_Tuple2('Esim', '⩳'),
			_Utils_Tuple2('esim', '≂'),
			_Utils_Tuple2('Eta', 'Η'),
			_Utils_Tuple2('eta', 'η'),
			_Utils_Tuple2('ETH', 'Ð'),
			_Utils_Tuple2('eth', 'ð'),
			_Utils_Tuple2('Euml', 'Ë'),
			_Utils_Tuple2('euml', 'ë'),
			_Utils_Tuple2('euro', '€'),
			_Utils_Tuple2('excl', '!'),
			_Utils_Tuple2('exist', '∃'),
			_Utils_Tuple2('Exists', '∃'),
			_Utils_Tuple2('expectation', 'ℰ'),
			_Utils_Tuple2('exponentiale', 'ⅇ'),
			_Utils_Tuple2('ExponentialE', 'ⅇ'),
			_Utils_Tuple2('fallingdotseq', '≒'),
			_Utils_Tuple2('Fcy', 'Ф'),
			_Utils_Tuple2('fcy', 'ф'),
			_Utils_Tuple2('female', '♀'),
			_Utils_Tuple2('ffilig', 'ﬃ'),
			_Utils_Tuple2('fflig', 'ﬀ'),
			_Utils_Tuple2('ffllig', 'ﬄ'),
			_Utils_Tuple2('Ffr', '\uD835\uDD09'),
			_Utils_Tuple2('ffr', '\uD835\uDD23'),
			_Utils_Tuple2('filig', 'ﬁ'),
			_Utils_Tuple2('FilledSmallSquare', '◼'),
			_Utils_Tuple2('FilledVerySmallSquare', '▪'),
			_Utils_Tuple2('fjlig', 'fj'),
			_Utils_Tuple2('flat', '♭'),
			_Utils_Tuple2('fllig', 'ﬂ'),
			_Utils_Tuple2('fltns', '▱'),
			_Utils_Tuple2('fnof', 'ƒ'),
			_Utils_Tuple2('Fopf', '\uD835\uDD3D'),
			_Utils_Tuple2('fopf', '\uD835\uDD57'),
			_Utils_Tuple2('forall', '∀'),
			_Utils_Tuple2('ForAll', '∀'),
			_Utils_Tuple2('fork', '⋔'),
			_Utils_Tuple2('forkv', '⫙'),
			_Utils_Tuple2('Fouriertrf', 'ℱ'),
			_Utils_Tuple2('fpartint', '⨍'),
			_Utils_Tuple2('frac12', '½'),
			_Utils_Tuple2('frac13', '⅓'),
			_Utils_Tuple2('frac14', '¼'),
			_Utils_Tuple2('frac15', '⅕'),
			_Utils_Tuple2('frac16', '⅙'),
			_Utils_Tuple2('frac18', '⅛'),
			_Utils_Tuple2('frac23', '⅔'),
			_Utils_Tuple2('frac25', '⅖'),
			_Utils_Tuple2('frac34', '¾'),
			_Utils_Tuple2('frac35', '⅗'),
			_Utils_Tuple2('frac38', '⅜'),
			_Utils_Tuple2('frac45', '⅘'),
			_Utils_Tuple2('frac56', '⅚'),
			_Utils_Tuple2('frac58', '⅝'),
			_Utils_Tuple2('frac78', '⅞'),
			_Utils_Tuple2('frasl', '⁄'),
			_Utils_Tuple2('frown', '⌢'),
			_Utils_Tuple2('fscr', '\uD835\uDCBB'),
			_Utils_Tuple2('Fscr', 'ℱ'),
			_Utils_Tuple2('gacute', 'ǵ'),
			_Utils_Tuple2('Gamma', 'Γ'),
			_Utils_Tuple2('gamma', 'γ'),
			_Utils_Tuple2('Gammad', 'Ϝ'),
			_Utils_Tuple2('gammad', 'ϝ'),
			_Utils_Tuple2('gap', '⪆'),
			_Utils_Tuple2('Gbreve', 'Ğ'),
			_Utils_Tuple2('gbreve', 'ğ'),
			_Utils_Tuple2('Gcedil', 'Ģ'),
			_Utils_Tuple2('Gcirc', 'Ĝ'),
			_Utils_Tuple2('gcirc', 'ĝ'),
			_Utils_Tuple2('Gcy', 'Г'),
			_Utils_Tuple2('gcy', 'г'),
			_Utils_Tuple2('Gdot', 'Ġ'),
			_Utils_Tuple2('gdot', 'ġ'),
			_Utils_Tuple2('ge', '≥'),
			_Utils_Tuple2('gE', '≧'),
			_Utils_Tuple2('gEl', '⪌'),
			_Utils_Tuple2('gel', '⋛'),
			_Utils_Tuple2('geq', '≥'),
			_Utils_Tuple2('geqq', '≧'),
			_Utils_Tuple2('geqslant', '⩾'),
			_Utils_Tuple2('gescc', '⪩'),
			_Utils_Tuple2('ges', '⩾'),
			_Utils_Tuple2('gesdot', '⪀'),
			_Utils_Tuple2('gesdoto', '⪂'),
			_Utils_Tuple2('gesdotol', '⪄'),
			_Utils_Tuple2('gesl', '⋛︀'),
			_Utils_Tuple2('gesles', '⪔'),
			_Utils_Tuple2('Gfr', '\uD835\uDD0A'),
			_Utils_Tuple2('gfr', '\uD835\uDD24'),
			_Utils_Tuple2('gg', '≫'),
			_Utils_Tuple2('Gg', '⋙'),
			_Utils_Tuple2('ggg', '⋙'),
			_Utils_Tuple2('gimel', 'ℷ'),
			_Utils_Tuple2('GJcy', 'Ѓ'),
			_Utils_Tuple2('gjcy', 'ѓ'),
			_Utils_Tuple2('gla', '⪥'),
			_Utils_Tuple2('gl', '≷'),
			_Utils_Tuple2('glE', '⪒'),
			_Utils_Tuple2('glj', '⪤'),
			_Utils_Tuple2('gnap', '⪊'),
			_Utils_Tuple2('gnapprox', '⪊'),
			_Utils_Tuple2('gne', '⪈'),
			_Utils_Tuple2('gnE', '≩'),
			_Utils_Tuple2('gneq', '⪈'),
			_Utils_Tuple2('gneqq', '≩'),
			_Utils_Tuple2('gnsim', '⋧'),
			_Utils_Tuple2('Gopf', '\uD835\uDD3E'),
			_Utils_Tuple2('gopf', '\uD835\uDD58'),
			_Utils_Tuple2('grave', '`'),
			_Utils_Tuple2('GreaterEqual', '≥'),
			_Utils_Tuple2('GreaterEqualLess', '⋛'),
			_Utils_Tuple2('GreaterFullEqual', '≧'),
			_Utils_Tuple2('GreaterGreater', '⪢'),
			_Utils_Tuple2('GreaterLess', '≷'),
			_Utils_Tuple2('GreaterSlantEqual', '⩾'),
			_Utils_Tuple2('GreaterTilde', '≳'),
			_Utils_Tuple2('Gscr', '\uD835\uDCA2'),
			_Utils_Tuple2('gscr', 'ℊ'),
			_Utils_Tuple2('gsim', '≳'),
			_Utils_Tuple2('gsime', '⪎'),
			_Utils_Tuple2('gsiml', '⪐'),
			_Utils_Tuple2('gtcc', '⪧'),
			_Utils_Tuple2('gtcir', '⩺'),
			_Utils_Tuple2('gt', '>'),
			_Utils_Tuple2('GT', '>'),
			_Utils_Tuple2('Gt', '≫'),
			_Utils_Tuple2('gtdot', '⋗'),
			_Utils_Tuple2('gtlPar', '⦕'),
			_Utils_Tuple2('gtquest', '⩼'),
			_Utils_Tuple2('gtrapprox', '⪆'),
			_Utils_Tuple2('gtrarr', '⥸'),
			_Utils_Tuple2('gtrdot', '⋗'),
			_Utils_Tuple2('gtreqless', '⋛'),
			_Utils_Tuple2('gtreqqless', '⪌'),
			_Utils_Tuple2('gtrless', '≷'),
			_Utils_Tuple2('gtrsim', '≳'),
			_Utils_Tuple2('gvertneqq', '≩︀'),
			_Utils_Tuple2('gvnE', '≩︀'),
			_Utils_Tuple2('Hacek', 'ˇ'),
			_Utils_Tuple2('hairsp', '\u200A'),
			_Utils_Tuple2('half', '½'),
			_Utils_Tuple2('hamilt', 'ℋ'),
			_Utils_Tuple2('HARDcy', 'Ъ'),
			_Utils_Tuple2('hardcy', 'ъ'),
			_Utils_Tuple2('harrcir', '⥈'),
			_Utils_Tuple2('harr', '↔'),
			_Utils_Tuple2('hArr', '⇔'),
			_Utils_Tuple2('harrw', '↭'),
			_Utils_Tuple2('Hat', '^'),
			_Utils_Tuple2('hbar', 'ℏ'),
			_Utils_Tuple2('Hcirc', 'Ĥ'),
			_Utils_Tuple2('hcirc', 'ĥ'),
			_Utils_Tuple2('hearts', '♥'),
			_Utils_Tuple2('heartsuit', '♥'),
			_Utils_Tuple2('hellip', '…'),
			_Utils_Tuple2('hercon', '⊹'),
			_Utils_Tuple2('hfr', '\uD835\uDD25'),
			_Utils_Tuple2('Hfr', 'ℌ'),
			_Utils_Tuple2('HilbertSpace', 'ℋ'),
			_Utils_Tuple2('hksearow', '⤥'),
			_Utils_Tuple2('hkswarow', '⤦'),
			_Utils_Tuple2('hoarr', '⇿'),
			_Utils_Tuple2('homtht', '∻'),
			_Utils_Tuple2('hookleftarrow', '↩'),
			_Utils_Tuple2('hookrightarrow', '↪'),
			_Utils_Tuple2('hopf', '\uD835\uDD59'),
			_Utils_Tuple2('Hopf', 'ℍ'),
			_Utils_Tuple2('horbar', '―'),
			_Utils_Tuple2('HorizontalLine', '─'),
			_Utils_Tuple2('hscr', '\uD835\uDCBD'),
			_Utils_Tuple2('Hscr', 'ℋ'),
			_Utils_Tuple2('hslash', 'ℏ'),
			_Utils_Tuple2('Hstrok', 'Ħ'),
			_Utils_Tuple2('hstrok', 'ħ'),
			_Utils_Tuple2('HumpDownHump', '≎'),
			_Utils_Tuple2('HumpEqual', '≏'),
			_Utils_Tuple2('hybull', '⁃'),
			_Utils_Tuple2('hyphen', '‐'),
			_Utils_Tuple2('Iacute', 'Í'),
			_Utils_Tuple2('iacute', 'í'),
			_Utils_Tuple2('ic', '\u2063'),
			_Utils_Tuple2('Icirc', 'Î'),
			_Utils_Tuple2('icirc', 'î'),
			_Utils_Tuple2('Icy', 'И'),
			_Utils_Tuple2('icy', 'и'),
			_Utils_Tuple2('Idot', 'İ'),
			_Utils_Tuple2('IEcy', 'Е'),
			_Utils_Tuple2('iecy', 'е'),
			_Utils_Tuple2('iexcl', '¡'),
			_Utils_Tuple2('iff', '⇔'),
			_Utils_Tuple2('ifr', '\uD835\uDD26'),
			_Utils_Tuple2('Ifr', 'ℑ'),
			_Utils_Tuple2('Igrave', 'Ì'),
			_Utils_Tuple2('igrave', 'ì'),
			_Utils_Tuple2('ii', 'ⅈ'),
			_Utils_Tuple2('iiiint', '⨌'),
			_Utils_Tuple2('iiint', '∭'),
			_Utils_Tuple2('iinfin', '⧜'),
			_Utils_Tuple2('iiota', '℩'),
			_Utils_Tuple2('IJlig', 'Ĳ'),
			_Utils_Tuple2('ijlig', 'ĳ'),
			_Utils_Tuple2('Imacr', 'Ī'),
			_Utils_Tuple2('imacr', 'ī'),
			_Utils_Tuple2('image', 'ℑ'),
			_Utils_Tuple2('ImaginaryI', 'ⅈ'),
			_Utils_Tuple2('imagline', 'ℐ'),
			_Utils_Tuple2('imagpart', 'ℑ'),
			_Utils_Tuple2('imath', 'ı'),
			_Utils_Tuple2('Im', 'ℑ'),
			_Utils_Tuple2('imof', '⊷'),
			_Utils_Tuple2('imped', 'Ƶ'),
			_Utils_Tuple2('Implies', '⇒'),
			_Utils_Tuple2('incare', '℅'),
			_Utils_Tuple2('in', '∈'),
			_Utils_Tuple2('infin', '∞'),
			_Utils_Tuple2('infintie', '⧝'),
			_Utils_Tuple2('inodot', 'ı'),
			_Utils_Tuple2('intcal', '⊺'),
			_Utils_Tuple2('int', '∫'),
			_Utils_Tuple2('Int', '∬'),
			_Utils_Tuple2('integers', 'ℤ'),
			_Utils_Tuple2('Integral', '∫'),
			_Utils_Tuple2('intercal', '⊺'),
			_Utils_Tuple2('Intersection', '⋂'),
			_Utils_Tuple2('intlarhk', '⨗'),
			_Utils_Tuple2('intprod', '⨼'),
			_Utils_Tuple2('InvisibleComma', '\u2063'),
			_Utils_Tuple2('InvisibleTimes', '\u2062'),
			_Utils_Tuple2('IOcy', 'Ё'),
			_Utils_Tuple2('iocy', 'ё'),
			_Utils_Tuple2('Iogon', 'Į'),
			_Utils_Tuple2('iogon', 'į'),
			_Utils_Tuple2('Iopf', '\uD835\uDD40'),
			_Utils_Tuple2('iopf', '\uD835\uDD5A'),
			_Utils_Tuple2('Iota', 'Ι'),
			_Utils_Tuple2('iota', 'ι'),
			_Utils_Tuple2('iprod', '⨼'),
			_Utils_Tuple2('iquest', '¿'),
			_Utils_Tuple2('iscr', '\uD835\uDCBE'),
			_Utils_Tuple2('Iscr', 'ℐ'),
			_Utils_Tuple2('isin', '∈'),
			_Utils_Tuple2('isindot', '⋵'),
			_Utils_Tuple2('isinE', '⋹'),
			_Utils_Tuple2('isins', '⋴'),
			_Utils_Tuple2('isinsv', '⋳'),
			_Utils_Tuple2('isinv', '∈'),
			_Utils_Tuple2('it', '\u2062'),
			_Utils_Tuple2('Itilde', 'Ĩ'),
			_Utils_Tuple2('itilde', 'ĩ'),
			_Utils_Tuple2('Iukcy', 'І'),
			_Utils_Tuple2('iukcy', 'і'),
			_Utils_Tuple2('Iuml', 'Ï'),
			_Utils_Tuple2('iuml', 'ï'),
			_Utils_Tuple2('Jcirc', 'Ĵ'),
			_Utils_Tuple2('jcirc', 'ĵ'),
			_Utils_Tuple2('Jcy', 'Й'),
			_Utils_Tuple2('jcy', 'й'),
			_Utils_Tuple2('Jfr', '\uD835\uDD0D'),
			_Utils_Tuple2('jfr', '\uD835\uDD27'),
			_Utils_Tuple2('jmath', 'ȷ'),
			_Utils_Tuple2('Jopf', '\uD835\uDD41'),
			_Utils_Tuple2('jopf', '\uD835\uDD5B'),
			_Utils_Tuple2('Jscr', '\uD835\uDCA5'),
			_Utils_Tuple2('jscr', '\uD835\uDCBF'),
			_Utils_Tuple2('Jsercy', 'Ј'),
			_Utils_Tuple2('jsercy', 'ј'),
			_Utils_Tuple2('Jukcy', 'Є'),
			_Utils_Tuple2('jukcy', 'є'),
			_Utils_Tuple2('Kappa', 'Κ'),
			_Utils_Tuple2('kappa', 'κ'),
			_Utils_Tuple2('kappav', 'ϰ'),
			_Utils_Tuple2('Kcedil', 'Ķ'),
			_Utils_Tuple2('kcedil', 'ķ'),
			_Utils_Tuple2('Kcy', 'К'),
			_Utils_Tuple2('kcy', 'к'),
			_Utils_Tuple2('Kfr', '\uD835\uDD0E'),
			_Utils_Tuple2('kfr', '\uD835\uDD28'),
			_Utils_Tuple2('kgreen', 'ĸ'),
			_Utils_Tuple2('KHcy', 'Х'),
			_Utils_Tuple2('khcy', 'х'),
			_Utils_Tuple2('KJcy', 'Ќ'),
			_Utils_Tuple2('kjcy', 'ќ'),
			_Utils_Tuple2('Kopf', '\uD835\uDD42'),
			_Utils_Tuple2('kopf', '\uD835\uDD5C'),
			_Utils_Tuple2('Kscr', '\uD835\uDCA6'),
			_Utils_Tuple2('kscr', '\uD835\uDCC0'),
			_Utils_Tuple2('lAarr', '⇚'),
			_Utils_Tuple2('Lacute', 'Ĺ'),
			_Utils_Tuple2('lacute', 'ĺ'),
			_Utils_Tuple2('laemptyv', '⦴'),
			_Utils_Tuple2('lagran', 'ℒ'),
			_Utils_Tuple2('Lambda', 'Λ'),
			_Utils_Tuple2('lambda', 'λ'),
			_Utils_Tuple2('lang', '⟨'),
			_Utils_Tuple2('Lang', '⟪'),
			_Utils_Tuple2('langd', '⦑'),
			_Utils_Tuple2('langle', '⟨'),
			_Utils_Tuple2('lap', '⪅'),
			_Utils_Tuple2('Laplacetrf', 'ℒ'),
			_Utils_Tuple2('laquo', '«'),
			_Utils_Tuple2('larrb', '⇤'),
			_Utils_Tuple2('larrbfs', '⤟'),
			_Utils_Tuple2('larr', '←'),
			_Utils_Tuple2('Larr', '↞'),
			_Utils_Tuple2('lArr', '⇐'),
			_Utils_Tuple2('larrfs', '⤝'),
			_Utils_Tuple2('larrhk', '↩'),
			_Utils_Tuple2('larrlp', '↫'),
			_Utils_Tuple2('larrpl', '⤹'),
			_Utils_Tuple2('larrsim', '⥳'),
			_Utils_Tuple2('larrtl', '↢'),
			_Utils_Tuple2('latail', '⤙'),
			_Utils_Tuple2('lAtail', '⤛'),
			_Utils_Tuple2('lat', '⪫'),
			_Utils_Tuple2('late', '⪭'),
			_Utils_Tuple2('lates', '⪭︀'),
			_Utils_Tuple2('lbarr', '⤌'),
			_Utils_Tuple2('lBarr', '⤎'),
			_Utils_Tuple2('lbbrk', '❲'),
			_Utils_Tuple2('lbrace', '{'),
			_Utils_Tuple2('lbrack', '['),
			_Utils_Tuple2('lbrke', '⦋'),
			_Utils_Tuple2('lbrksld', '⦏'),
			_Utils_Tuple2('lbrkslu', '⦍'),
			_Utils_Tuple2('Lcaron', 'Ľ'),
			_Utils_Tuple2('lcaron', 'ľ'),
			_Utils_Tuple2('Lcedil', 'Ļ'),
			_Utils_Tuple2('lcedil', 'ļ'),
			_Utils_Tuple2('lceil', '⌈'),
			_Utils_Tuple2('lcub', '{'),
			_Utils_Tuple2('Lcy', 'Л'),
			_Utils_Tuple2('lcy', 'л'),
			_Utils_Tuple2('ldca', '⤶'),
			_Utils_Tuple2('ldquo', '“'),
			_Utils_Tuple2('ldquor', '„'),
			_Utils_Tuple2('ldrdhar', '⥧'),
			_Utils_Tuple2('ldrushar', '⥋'),
			_Utils_Tuple2('ldsh', '↲'),
			_Utils_Tuple2('le', '≤'),
			_Utils_Tuple2('lE', '≦'),
			_Utils_Tuple2('LeftAngleBracket', '⟨'),
			_Utils_Tuple2('LeftArrowBar', '⇤'),
			_Utils_Tuple2('leftarrow', '←'),
			_Utils_Tuple2('LeftArrow', '←'),
			_Utils_Tuple2('Leftarrow', '⇐'),
			_Utils_Tuple2('LeftArrowRightArrow', '⇆'),
			_Utils_Tuple2('leftarrowtail', '↢'),
			_Utils_Tuple2('LeftCeiling', '⌈'),
			_Utils_Tuple2('LeftDoubleBracket', '⟦'),
			_Utils_Tuple2('LeftDownTeeVector', '⥡'),
			_Utils_Tuple2('LeftDownVectorBar', '⥙'),
			_Utils_Tuple2('LeftDownVector', '⇃'),
			_Utils_Tuple2('LeftFloor', '⌊'),
			_Utils_Tuple2('leftharpoondown', '↽'),
			_Utils_Tuple2('leftharpoonup', '↼'),
			_Utils_Tuple2('leftleftarrows', '⇇'),
			_Utils_Tuple2('leftrightarrow', '↔'),
			_Utils_Tuple2('LeftRightArrow', '↔'),
			_Utils_Tuple2('Leftrightarrow', '⇔'),
			_Utils_Tuple2('leftrightarrows', '⇆'),
			_Utils_Tuple2('leftrightharpoons', '⇋'),
			_Utils_Tuple2('leftrightsquigarrow', '↭'),
			_Utils_Tuple2('LeftRightVector', '⥎'),
			_Utils_Tuple2('LeftTeeArrow', '↤'),
			_Utils_Tuple2('LeftTee', '⊣'),
			_Utils_Tuple2('LeftTeeVector', '⥚'),
			_Utils_Tuple2('leftthreetimes', '⋋'),
			_Utils_Tuple2('LeftTriangleBar', '⧏'),
			_Utils_Tuple2('LeftTriangle', '⊲'),
			_Utils_Tuple2('LeftTriangleEqual', '⊴'),
			_Utils_Tuple2('LeftUpDownVector', '⥑'),
			_Utils_Tuple2('LeftUpTeeVector', '⥠'),
			_Utils_Tuple2('LeftUpVectorBar', '⥘'),
			_Utils_Tuple2('LeftUpVector', '↿'),
			_Utils_Tuple2('LeftVectorBar', '⥒'),
			_Utils_Tuple2('LeftVector', '↼'),
			_Utils_Tuple2('lEg', '⪋'),
			_Utils_Tuple2('leg', '⋚'),
			_Utils_Tuple2('leq', '≤'),
			_Utils_Tuple2('leqq', '≦'),
			_Utils_Tuple2('leqslant', '⩽'),
			_Utils_Tuple2('lescc', '⪨'),
			_Utils_Tuple2('les', '⩽'),
			_Utils_Tuple2('lesdot', '⩿'),
			_Utils_Tuple2('lesdoto', '⪁'),
			_Utils_Tuple2('lesdotor', '⪃'),
			_Utils_Tuple2('lesg', '⋚︀'),
			_Utils_Tuple2('lesges', '⪓'),
			_Utils_Tuple2('lessapprox', '⪅'),
			_Utils_Tuple2('lessdot', '⋖'),
			_Utils_Tuple2('lesseqgtr', '⋚'),
			_Utils_Tuple2('lesseqqgtr', '⪋'),
			_Utils_Tuple2('LessEqualGreater', '⋚'),
			_Utils_Tuple2('LessFullEqual', '≦'),
			_Utils_Tuple2('LessGreater', '≶'),
			_Utils_Tuple2('lessgtr', '≶'),
			_Utils_Tuple2('LessLess', '⪡'),
			_Utils_Tuple2('lesssim', '≲'),
			_Utils_Tuple2('LessSlantEqual', '⩽'),
			_Utils_Tuple2('LessTilde', '≲'),
			_Utils_Tuple2('lfisht', '⥼'),
			_Utils_Tuple2('lfloor', '⌊'),
			_Utils_Tuple2('Lfr', '\uD835\uDD0F'),
			_Utils_Tuple2('lfr', '\uD835\uDD29'),
			_Utils_Tuple2('lg', '≶'),
			_Utils_Tuple2('lgE', '⪑'),
			_Utils_Tuple2('lHar', '⥢'),
			_Utils_Tuple2('lhard', '↽'),
			_Utils_Tuple2('lharu', '↼'),
			_Utils_Tuple2('lharul', '⥪'),
			_Utils_Tuple2('lhblk', '▄'),
			_Utils_Tuple2('LJcy', 'Љ'),
			_Utils_Tuple2('ljcy', 'љ'),
			_Utils_Tuple2('llarr', '⇇'),
			_Utils_Tuple2('ll', '≪'),
			_Utils_Tuple2('Ll', '⋘'),
			_Utils_Tuple2('llcorner', '⌞'),
			_Utils_Tuple2('Lleftarrow', '⇚'),
			_Utils_Tuple2('llhard', '⥫'),
			_Utils_Tuple2('lltri', '◺'),
			_Utils_Tuple2('Lmidot', 'Ŀ'),
			_Utils_Tuple2('lmidot', 'ŀ'),
			_Utils_Tuple2('lmoustache', '⎰'),
			_Utils_Tuple2('lmoust', '⎰'),
			_Utils_Tuple2('lnap', '⪉'),
			_Utils_Tuple2('lnapprox', '⪉'),
			_Utils_Tuple2('lne', '⪇'),
			_Utils_Tuple2('lnE', '≨'),
			_Utils_Tuple2('lneq', '⪇'),
			_Utils_Tuple2('lneqq', '≨'),
			_Utils_Tuple2('lnsim', '⋦'),
			_Utils_Tuple2('loang', '⟬'),
			_Utils_Tuple2('loarr', '⇽'),
			_Utils_Tuple2('lobrk', '⟦'),
			_Utils_Tuple2('longleftarrow', '⟵'),
			_Utils_Tuple2('LongLeftArrow', '⟵'),
			_Utils_Tuple2('Longleftarrow', '⟸'),
			_Utils_Tuple2('longleftrightarrow', '⟷'),
			_Utils_Tuple2('LongLeftRightArrow', '⟷'),
			_Utils_Tuple2('Longleftrightarrow', '⟺'),
			_Utils_Tuple2('longmapsto', '⟼'),
			_Utils_Tuple2('longrightarrow', '⟶'),
			_Utils_Tuple2('LongRightArrow', '⟶'),
			_Utils_Tuple2('Longrightarrow', '⟹'),
			_Utils_Tuple2('looparrowleft', '↫'),
			_Utils_Tuple2('looparrowright', '↬'),
			_Utils_Tuple2('lopar', '⦅'),
			_Utils_Tuple2('Lopf', '\uD835\uDD43'),
			_Utils_Tuple2('lopf', '\uD835\uDD5D'),
			_Utils_Tuple2('loplus', '⨭'),
			_Utils_Tuple2('lotimes', '⨴'),
			_Utils_Tuple2('lowast', '∗'),
			_Utils_Tuple2('lowbar', '_'),
			_Utils_Tuple2('LowerLeftArrow', '↙'),
			_Utils_Tuple2('LowerRightArrow', '↘'),
			_Utils_Tuple2('loz', '◊'),
			_Utils_Tuple2('lozenge', '◊'),
			_Utils_Tuple2('lozf', '⧫'),
			_Utils_Tuple2('lpar', '('),
			_Utils_Tuple2('lparlt', '⦓'),
			_Utils_Tuple2('lrarr', '⇆'),
			_Utils_Tuple2('lrcorner', '⌟'),
			_Utils_Tuple2('lrhar', '⇋'),
			_Utils_Tuple2('lrhard', '⥭'),
			_Utils_Tuple2('lrm', '\u200E'),
			_Utils_Tuple2('lrtri', '⊿'),
			_Utils_Tuple2('lsaquo', '‹'),
			_Utils_Tuple2('lscr', '\uD835\uDCC1'),
			_Utils_Tuple2('Lscr', 'ℒ'),
			_Utils_Tuple2('lsh', '↰'),
			_Utils_Tuple2('Lsh', '↰'),
			_Utils_Tuple2('lsim', '≲'),
			_Utils_Tuple2('lsime', '⪍'),
			_Utils_Tuple2('lsimg', '⪏'),
			_Utils_Tuple2('lsqb', '['),
			_Utils_Tuple2('lsquo', '‘'),
			_Utils_Tuple2('lsquor', '‚'),
			_Utils_Tuple2('Lstrok', 'Ł'),
			_Utils_Tuple2('lstrok', 'ł'),
			_Utils_Tuple2('ltcc', '⪦'),
			_Utils_Tuple2('ltcir', '⩹'),
			_Utils_Tuple2('lt', '<'),
			_Utils_Tuple2('LT', '<'),
			_Utils_Tuple2('Lt', '≪'),
			_Utils_Tuple2('ltdot', '⋖'),
			_Utils_Tuple2('lthree', '⋋'),
			_Utils_Tuple2('ltimes', '⋉'),
			_Utils_Tuple2('ltlarr', '⥶'),
			_Utils_Tuple2('ltquest', '⩻'),
			_Utils_Tuple2('ltri', '◃'),
			_Utils_Tuple2('ltrie', '⊴'),
			_Utils_Tuple2('ltrif', '◂'),
			_Utils_Tuple2('ltrPar', '⦖'),
			_Utils_Tuple2('lurdshar', '⥊'),
			_Utils_Tuple2('luruhar', '⥦'),
			_Utils_Tuple2('lvertneqq', '≨︀'),
			_Utils_Tuple2('lvnE', '≨︀'),
			_Utils_Tuple2('macr', '¯'),
			_Utils_Tuple2('male', '♂'),
			_Utils_Tuple2('malt', '✠'),
			_Utils_Tuple2('maltese', '✠'),
			_Utils_Tuple2('Map', '⤅'),
			_Utils_Tuple2('map', '↦'),
			_Utils_Tuple2('mapsto', '↦'),
			_Utils_Tuple2('mapstodown', '↧'),
			_Utils_Tuple2('mapstoleft', '↤'),
			_Utils_Tuple2('mapstoup', '↥'),
			_Utils_Tuple2('marker', '▮'),
			_Utils_Tuple2('mcomma', '⨩'),
			_Utils_Tuple2('Mcy', 'М'),
			_Utils_Tuple2('mcy', 'м'),
			_Utils_Tuple2('mdash', '—'),
			_Utils_Tuple2('mDDot', '∺'),
			_Utils_Tuple2('measuredangle', '∡'),
			_Utils_Tuple2('MediumSpace', '\u205F'),
			_Utils_Tuple2('Mellintrf', 'ℳ'),
			_Utils_Tuple2('Mfr', '\uD835\uDD10'),
			_Utils_Tuple2('mfr', '\uD835\uDD2A'),
			_Utils_Tuple2('mho', '℧'),
			_Utils_Tuple2('micro', 'µ'),
			_Utils_Tuple2('midast', '*'),
			_Utils_Tuple2('midcir', '⫰'),
			_Utils_Tuple2('mid', '∣'),
			_Utils_Tuple2('middot', '·'),
			_Utils_Tuple2('minusb', '⊟'),
			_Utils_Tuple2('minus', '−'),
			_Utils_Tuple2('minusd', '∸'),
			_Utils_Tuple2('minusdu', '⨪'),
			_Utils_Tuple2('MinusPlus', '∓'),
			_Utils_Tuple2('mlcp', '⫛'),
			_Utils_Tuple2('mldr', '…'),
			_Utils_Tuple2('mnplus', '∓'),
			_Utils_Tuple2('models', '⊧'),
			_Utils_Tuple2('Mopf', '\uD835\uDD44'),
			_Utils_Tuple2('mopf', '\uD835\uDD5E'),
			_Utils_Tuple2('mp', '∓'),
			_Utils_Tuple2('mscr', '\uD835\uDCC2'),
			_Utils_Tuple2('Mscr', 'ℳ'),
			_Utils_Tuple2('mstpos', '∾'),
			_Utils_Tuple2('Mu', 'Μ'),
			_Utils_Tuple2('mu', 'μ'),
			_Utils_Tuple2('multimap', '⊸'),
			_Utils_Tuple2('mumap', '⊸'),
			_Utils_Tuple2('nabla', '∇'),
			_Utils_Tuple2('Nacute', 'Ń'),
			_Utils_Tuple2('nacute', 'ń'),
			_Utils_Tuple2('nang', '∠⃒'),
			_Utils_Tuple2('nap', '≉'),
			_Utils_Tuple2('napE', '⩰̸'),
			_Utils_Tuple2('napid', '≋̸'),
			_Utils_Tuple2('napos', 'ŉ'),
			_Utils_Tuple2('napprox', '≉'),
			_Utils_Tuple2('natural', '♮'),
			_Utils_Tuple2('naturals', 'ℕ'),
			_Utils_Tuple2('natur', '♮'),
			_Utils_Tuple2('nbsp', '\u00A0'),
			_Utils_Tuple2('nbump', '≎̸'),
			_Utils_Tuple2('nbumpe', '≏̸'),
			_Utils_Tuple2('ncap', '⩃'),
			_Utils_Tuple2('Ncaron', 'Ň'),
			_Utils_Tuple2('ncaron', 'ň'),
			_Utils_Tuple2('Ncedil', 'Ņ'),
			_Utils_Tuple2('ncedil', 'ņ'),
			_Utils_Tuple2('ncong', '≇'),
			_Utils_Tuple2('ncongdot', '⩭̸'),
			_Utils_Tuple2('ncup', '⩂'),
			_Utils_Tuple2('Ncy', 'Н'),
			_Utils_Tuple2('ncy', 'н'),
			_Utils_Tuple2('ndash', '–'),
			_Utils_Tuple2('nearhk', '⤤'),
			_Utils_Tuple2('nearr', '↗'),
			_Utils_Tuple2('neArr', '⇗'),
			_Utils_Tuple2('nearrow', '↗'),
			_Utils_Tuple2('ne', '≠'),
			_Utils_Tuple2('nedot', '≐̸'),
			_Utils_Tuple2('NegativeMediumSpace', '\u200B'),
			_Utils_Tuple2('NegativeThickSpace', '\u200B'),
			_Utils_Tuple2('NegativeThinSpace', '\u200B'),
			_Utils_Tuple2('NegativeVeryThinSpace', '\u200B'),
			_Utils_Tuple2('nequiv', '≢'),
			_Utils_Tuple2('nesear', '⤨'),
			_Utils_Tuple2('nesim', '≂̸'),
			_Utils_Tuple2('NestedGreaterGreater', '≫'),
			_Utils_Tuple2('NestedLessLess', '≪'),
			_Utils_Tuple2('NewLine', '\n'),
			_Utils_Tuple2('nexist', '∄'),
			_Utils_Tuple2('nexists', '∄'),
			_Utils_Tuple2('Nfr', '\uD835\uDD11'),
			_Utils_Tuple2('nfr', '\uD835\uDD2B'),
			_Utils_Tuple2('ngE', '≧̸'),
			_Utils_Tuple2('nge', '≱'),
			_Utils_Tuple2('ngeq', '≱'),
			_Utils_Tuple2('ngeqq', '≧̸'),
			_Utils_Tuple2('ngeqslant', '⩾̸'),
			_Utils_Tuple2('nges', '⩾̸'),
			_Utils_Tuple2('nGg', '⋙̸'),
			_Utils_Tuple2('ngsim', '≵'),
			_Utils_Tuple2('nGt', '≫⃒'),
			_Utils_Tuple2('ngt', '≯'),
			_Utils_Tuple2('ngtr', '≯'),
			_Utils_Tuple2('nGtv', '≫̸'),
			_Utils_Tuple2('nharr', '↮'),
			_Utils_Tuple2('nhArr', '⇎'),
			_Utils_Tuple2('nhpar', '⫲'),
			_Utils_Tuple2('ni', '∋'),
			_Utils_Tuple2('nis', '⋼'),
			_Utils_Tuple2('nisd', '⋺'),
			_Utils_Tuple2('niv', '∋'),
			_Utils_Tuple2('NJcy', 'Њ'),
			_Utils_Tuple2('njcy', 'њ'),
			_Utils_Tuple2('nlarr', '↚'),
			_Utils_Tuple2('nlArr', '⇍'),
			_Utils_Tuple2('nldr', '‥'),
			_Utils_Tuple2('nlE', '≦̸'),
			_Utils_Tuple2('nle', '≰'),
			_Utils_Tuple2('nleftarrow', '↚'),
			_Utils_Tuple2('nLeftarrow', '⇍'),
			_Utils_Tuple2('nleftrightarrow', '↮'),
			_Utils_Tuple2('nLeftrightarrow', '⇎'),
			_Utils_Tuple2('nleq', '≰'),
			_Utils_Tuple2('nleqq', '≦̸'),
			_Utils_Tuple2('nleqslant', '⩽̸'),
			_Utils_Tuple2('nles', '⩽̸'),
			_Utils_Tuple2('nless', '≮'),
			_Utils_Tuple2('nLl', '⋘̸'),
			_Utils_Tuple2('nlsim', '≴'),
			_Utils_Tuple2('nLt', '≪⃒'),
			_Utils_Tuple2('nlt', '≮'),
			_Utils_Tuple2('nltri', '⋪'),
			_Utils_Tuple2('nltrie', '⋬'),
			_Utils_Tuple2('nLtv', '≪̸'),
			_Utils_Tuple2('nmid', '∤'),
			_Utils_Tuple2('NoBreak', '\u2060'),
			_Utils_Tuple2('NonBreakingSpace', '\u00A0'),
			_Utils_Tuple2('nopf', '\uD835\uDD5F'),
			_Utils_Tuple2('Nopf', 'ℕ'),
			_Utils_Tuple2('Not', '⫬'),
			_Utils_Tuple2('not', '¬'),
			_Utils_Tuple2('NotCongruent', '≢'),
			_Utils_Tuple2('NotCupCap', '≭'),
			_Utils_Tuple2('NotDoubleVerticalBar', '∦'),
			_Utils_Tuple2('NotElement', '∉'),
			_Utils_Tuple2('NotEqual', '≠'),
			_Utils_Tuple2('NotEqualTilde', '≂̸'),
			_Utils_Tuple2('NotExists', '∄'),
			_Utils_Tuple2('NotGreater', '≯'),
			_Utils_Tuple2('NotGreaterEqual', '≱'),
			_Utils_Tuple2('NotGreaterFullEqual', '≧̸'),
			_Utils_Tuple2('NotGreaterGreater', '≫̸'),
			_Utils_Tuple2('NotGreaterLess', '≹'),
			_Utils_Tuple2('NotGreaterSlantEqual', '⩾̸'),
			_Utils_Tuple2('NotGreaterTilde', '≵'),
			_Utils_Tuple2('NotHumpDownHump', '≎̸'),
			_Utils_Tuple2('NotHumpEqual', '≏̸'),
			_Utils_Tuple2('notin', '∉'),
			_Utils_Tuple2('notindot', '⋵̸'),
			_Utils_Tuple2('notinE', '⋹̸'),
			_Utils_Tuple2('notinva', '∉'),
			_Utils_Tuple2('notinvb', '⋷'),
			_Utils_Tuple2('notinvc', '⋶'),
			_Utils_Tuple2('NotLeftTriangleBar', '⧏̸'),
			_Utils_Tuple2('NotLeftTriangle', '⋪'),
			_Utils_Tuple2('NotLeftTriangleEqual', '⋬'),
			_Utils_Tuple2('NotLess', '≮'),
			_Utils_Tuple2('NotLessEqual', '≰'),
			_Utils_Tuple2('NotLessGreater', '≸'),
			_Utils_Tuple2('NotLessLess', '≪̸'),
			_Utils_Tuple2('NotLessSlantEqual', '⩽̸'),
			_Utils_Tuple2('NotLessTilde', '≴'),
			_Utils_Tuple2('NotNestedGreaterGreater', '⪢̸'),
			_Utils_Tuple2('NotNestedLessLess', '⪡̸'),
			_Utils_Tuple2('notni', '∌'),
			_Utils_Tuple2('notniva', '∌'),
			_Utils_Tuple2('notnivb', '⋾'),
			_Utils_Tuple2('notnivc', '⋽'),
			_Utils_Tuple2('NotPrecedes', '⊀'),
			_Utils_Tuple2('NotPrecedesEqual', '⪯̸'),
			_Utils_Tuple2('NotPrecedesSlantEqual', '⋠'),
			_Utils_Tuple2('NotReverseElement', '∌'),
			_Utils_Tuple2('NotRightTriangleBar', '⧐̸'),
			_Utils_Tuple2('NotRightTriangle', '⋫'),
			_Utils_Tuple2('NotRightTriangleEqual', '⋭'),
			_Utils_Tuple2('NotSquareSubset', '⊏̸'),
			_Utils_Tuple2('NotSquareSubsetEqual', '⋢'),
			_Utils_Tuple2('NotSquareSuperset', '⊐̸'),
			_Utils_Tuple2('NotSquareSupersetEqual', '⋣'),
			_Utils_Tuple2('NotSubset', '⊂⃒'),
			_Utils_Tuple2('NotSubsetEqual', '⊈'),
			_Utils_Tuple2('NotSucceeds', '⊁'),
			_Utils_Tuple2('NotSucceedsEqual', '⪰̸'),
			_Utils_Tuple2('NotSucceedsSlantEqual', '⋡'),
			_Utils_Tuple2('NotSucceedsTilde', '≿̸'),
			_Utils_Tuple2('NotSuperset', '⊃⃒'),
			_Utils_Tuple2('NotSupersetEqual', '⊉'),
			_Utils_Tuple2('NotTilde', '≁'),
			_Utils_Tuple2('NotTildeEqual', '≄'),
			_Utils_Tuple2('NotTildeFullEqual', '≇'),
			_Utils_Tuple2('NotTildeTilde', '≉'),
			_Utils_Tuple2('NotVerticalBar', '∤'),
			_Utils_Tuple2('nparallel', '∦'),
			_Utils_Tuple2('npar', '∦'),
			_Utils_Tuple2('nparsl', '⫽⃥'),
			_Utils_Tuple2('npart', '∂̸'),
			_Utils_Tuple2('npolint', '⨔'),
			_Utils_Tuple2('npr', '⊀'),
			_Utils_Tuple2('nprcue', '⋠'),
			_Utils_Tuple2('nprec', '⊀'),
			_Utils_Tuple2('npreceq', '⪯̸'),
			_Utils_Tuple2('npre', '⪯̸'),
			_Utils_Tuple2('nrarrc', '⤳̸'),
			_Utils_Tuple2('nrarr', '↛'),
			_Utils_Tuple2('nrArr', '⇏'),
			_Utils_Tuple2('nrarrw', '↝̸'),
			_Utils_Tuple2('nrightarrow', '↛'),
			_Utils_Tuple2('nRightarrow', '⇏'),
			_Utils_Tuple2('nrtri', '⋫'),
			_Utils_Tuple2('nrtrie', '⋭'),
			_Utils_Tuple2('nsc', '⊁'),
			_Utils_Tuple2('nsccue', '⋡'),
			_Utils_Tuple2('nsce', '⪰̸'),
			_Utils_Tuple2('Nscr', '\uD835\uDCA9'),
			_Utils_Tuple2('nscr', '\uD835\uDCC3'),
			_Utils_Tuple2('nshortmid', '∤'),
			_Utils_Tuple2('nshortparallel', '∦'),
			_Utils_Tuple2('nsim', '≁'),
			_Utils_Tuple2('nsime', '≄'),
			_Utils_Tuple2('nsimeq', '≄'),
			_Utils_Tuple2('nsmid', '∤'),
			_Utils_Tuple2('nspar', '∦'),
			_Utils_Tuple2('nsqsube', '⋢'),
			_Utils_Tuple2('nsqsupe', '⋣'),
			_Utils_Tuple2('nsub', '⊄'),
			_Utils_Tuple2('nsubE', '⫅̸'),
			_Utils_Tuple2('nsube', '⊈'),
			_Utils_Tuple2('nsubset', '⊂⃒'),
			_Utils_Tuple2('nsubseteq', '⊈'),
			_Utils_Tuple2('nsubseteqq', '⫅̸'),
			_Utils_Tuple2('nsucc', '⊁'),
			_Utils_Tuple2('nsucceq', '⪰̸'),
			_Utils_Tuple2('nsup', '⊅'),
			_Utils_Tuple2('nsupE', '⫆̸'),
			_Utils_Tuple2('nsupe', '⊉'),
			_Utils_Tuple2('nsupset', '⊃⃒'),
			_Utils_Tuple2('nsupseteq', '⊉'),
			_Utils_Tuple2('nsupseteqq', '⫆̸'),
			_Utils_Tuple2('ntgl', '≹'),
			_Utils_Tuple2('Ntilde', 'Ñ'),
			_Utils_Tuple2('ntilde', 'ñ'),
			_Utils_Tuple2('ntlg', '≸'),
			_Utils_Tuple2('ntriangleleft', '⋪'),
			_Utils_Tuple2('ntrianglelefteq', '⋬'),
			_Utils_Tuple2('ntriangleright', '⋫'),
			_Utils_Tuple2('ntrianglerighteq', '⋭'),
			_Utils_Tuple2('Nu', 'Ν'),
			_Utils_Tuple2('nu', 'ν'),
			_Utils_Tuple2('num', '#'),
			_Utils_Tuple2('numero', '№'),
			_Utils_Tuple2('numsp', '\u2007'),
			_Utils_Tuple2('nvap', '≍⃒'),
			_Utils_Tuple2('nvdash', '⊬'),
			_Utils_Tuple2('nvDash', '⊭'),
			_Utils_Tuple2('nVdash', '⊮'),
			_Utils_Tuple2('nVDash', '⊯'),
			_Utils_Tuple2('nvge', '≥⃒'),
			_Utils_Tuple2('nvgt', '>⃒'),
			_Utils_Tuple2('nvHarr', '⤄'),
			_Utils_Tuple2('nvinfin', '⧞'),
			_Utils_Tuple2('nvlArr', '⤂'),
			_Utils_Tuple2('nvle', '≤⃒'),
			_Utils_Tuple2('nvlt', '<⃒'),
			_Utils_Tuple2('nvltrie', '⊴⃒'),
			_Utils_Tuple2('nvrArr', '⤃'),
			_Utils_Tuple2('nvrtrie', '⊵⃒'),
			_Utils_Tuple2('nvsim', '∼⃒'),
			_Utils_Tuple2('nwarhk', '⤣'),
			_Utils_Tuple2('nwarr', '↖'),
			_Utils_Tuple2('nwArr', '⇖'),
			_Utils_Tuple2('nwarrow', '↖'),
			_Utils_Tuple2('nwnear', '⤧'),
			_Utils_Tuple2('Oacute', 'Ó'),
			_Utils_Tuple2('oacute', 'ó'),
			_Utils_Tuple2('oast', '⊛'),
			_Utils_Tuple2('Ocirc', 'Ô'),
			_Utils_Tuple2('ocirc', 'ô'),
			_Utils_Tuple2('ocir', '⊚'),
			_Utils_Tuple2('Ocy', 'О'),
			_Utils_Tuple2('ocy', 'о'),
			_Utils_Tuple2('odash', '⊝'),
			_Utils_Tuple2('Odblac', 'Ő'),
			_Utils_Tuple2('odblac', 'ő'),
			_Utils_Tuple2('odiv', '⨸'),
			_Utils_Tuple2('odot', '⊙'),
			_Utils_Tuple2('odsold', '⦼'),
			_Utils_Tuple2('OElig', 'Œ'),
			_Utils_Tuple2('oelig', 'œ'),
			_Utils_Tuple2('ofcir', '⦿'),
			_Utils_Tuple2('Ofr', '\uD835\uDD12'),
			_Utils_Tuple2('ofr', '\uD835\uDD2C'),
			_Utils_Tuple2('ogon', '˛'),
			_Utils_Tuple2('Ograve', 'Ò'),
			_Utils_Tuple2('ograve', 'ò'),
			_Utils_Tuple2('ogt', '⧁'),
			_Utils_Tuple2('ohbar', '⦵'),
			_Utils_Tuple2('ohm', 'Ω'),
			_Utils_Tuple2('oint', '∮'),
			_Utils_Tuple2('olarr', '↺'),
			_Utils_Tuple2('olcir', '⦾'),
			_Utils_Tuple2('olcross', '⦻'),
			_Utils_Tuple2('oline', '‾'),
			_Utils_Tuple2('olt', '⧀'),
			_Utils_Tuple2('Omacr', 'Ō'),
			_Utils_Tuple2('omacr', 'ō'),
			_Utils_Tuple2('Omega', 'Ω'),
			_Utils_Tuple2('omega', 'ω'),
			_Utils_Tuple2('Omicron', 'Ο'),
			_Utils_Tuple2('omicron', 'ο'),
			_Utils_Tuple2('omid', '⦶'),
			_Utils_Tuple2('ominus', '⊖'),
			_Utils_Tuple2('Oopf', '\uD835\uDD46'),
			_Utils_Tuple2('oopf', '\uD835\uDD60'),
			_Utils_Tuple2('opar', '⦷'),
			_Utils_Tuple2('OpenCurlyDoubleQuote', '“'),
			_Utils_Tuple2('OpenCurlyQuote', '‘'),
			_Utils_Tuple2('operp', '⦹'),
			_Utils_Tuple2('oplus', '⊕'),
			_Utils_Tuple2('orarr', '↻'),
			_Utils_Tuple2('Or', '⩔'),
			_Utils_Tuple2('or', '∨'),
			_Utils_Tuple2('ord', '⩝'),
			_Utils_Tuple2('order', 'ℴ'),
			_Utils_Tuple2('orderof', 'ℴ'),
			_Utils_Tuple2('ordf', 'ª'),
			_Utils_Tuple2('ordm', 'º'),
			_Utils_Tuple2('origof', '⊶'),
			_Utils_Tuple2('oror', '⩖'),
			_Utils_Tuple2('orslope', '⩗'),
			_Utils_Tuple2('orv', '⩛'),
			_Utils_Tuple2('oS', 'Ⓢ'),
			_Utils_Tuple2('Oscr', '\uD835\uDCAA'),
			_Utils_Tuple2('oscr', 'ℴ'),
			_Utils_Tuple2('Oslash', 'Ø'),
			_Utils_Tuple2('oslash', 'ø'),
			_Utils_Tuple2('osol', '⊘'),
			_Utils_Tuple2('Otilde', 'Õ'),
			_Utils_Tuple2('otilde', 'õ'),
			_Utils_Tuple2('otimesas', '⨶'),
			_Utils_Tuple2('Otimes', '⨷'),
			_Utils_Tuple2('otimes', '⊗'),
			_Utils_Tuple2('Ouml', 'Ö'),
			_Utils_Tuple2('ouml', 'ö'),
			_Utils_Tuple2('ovbar', '⌽'),
			_Utils_Tuple2('OverBar', '‾'),
			_Utils_Tuple2('OverBrace', '⏞'),
			_Utils_Tuple2('OverBracket', '⎴'),
			_Utils_Tuple2('OverParenthesis', '⏜'),
			_Utils_Tuple2('para', '¶'),
			_Utils_Tuple2('parallel', '∥'),
			_Utils_Tuple2('par', '∥'),
			_Utils_Tuple2('parsim', '⫳'),
			_Utils_Tuple2('parsl', '⫽'),
			_Utils_Tuple2('part', '∂'),
			_Utils_Tuple2('PartialD', '∂'),
			_Utils_Tuple2('Pcy', 'П'),
			_Utils_Tuple2('pcy', 'п'),
			_Utils_Tuple2('percnt', '%'),
			_Utils_Tuple2('period', '.'),
			_Utils_Tuple2('permil', '‰'),
			_Utils_Tuple2('perp', '⊥'),
			_Utils_Tuple2('pertenk', '‱'),
			_Utils_Tuple2('Pfr', '\uD835\uDD13'),
			_Utils_Tuple2('pfr', '\uD835\uDD2D'),
			_Utils_Tuple2('Phi', 'Φ'),
			_Utils_Tuple2('phi', 'φ'),
			_Utils_Tuple2('phiv', 'ϕ'),
			_Utils_Tuple2('phmmat', 'ℳ'),
			_Utils_Tuple2('phone', '☎'),
			_Utils_Tuple2('Pi', 'Π'),
			_Utils_Tuple2('pi', 'π'),
			_Utils_Tuple2('pitchfork', '⋔'),
			_Utils_Tuple2('piv', 'ϖ'),
			_Utils_Tuple2('planck', 'ℏ'),
			_Utils_Tuple2('planckh', 'ℎ'),
			_Utils_Tuple2('plankv', 'ℏ'),
			_Utils_Tuple2('plusacir', '⨣'),
			_Utils_Tuple2('plusb', '⊞'),
			_Utils_Tuple2('pluscir', '⨢'),
			_Utils_Tuple2('plus', '+'),
			_Utils_Tuple2('plusdo', '∔'),
			_Utils_Tuple2('plusdu', '⨥'),
			_Utils_Tuple2('pluse', '⩲'),
			_Utils_Tuple2('PlusMinus', '±'),
			_Utils_Tuple2('plusmn', '±'),
			_Utils_Tuple2('plussim', '⨦'),
			_Utils_Tuple2('plustwo', '⨧'),
			_Utils_Tuple2('pm', '±'),
			_Utils_Tuple2('Poincareplane', 'ℌ'),
			_Utils_Tuple2('pointint', '⨕'),
			_Utils_Tuple2('popf', '\uD835\uDD61'),
			_Utils_Tuple2('Popf', 'ℙ'),
			_Utils_Tuple2('pound', '£'),
			_Utils_Tuple2('prap', '⪷'),
			_Utils_Tuple2('Pr', '⪻'),
			_Utils_Tuple2('pr', '≺'),
			_Utils_Tuple2('prcue', '≼'),
			_Utils_Tuple2('precapprox', '⪷'),
			_Utils_Tuple2('prec', '≺'),
			_Utils_Tuple2('preccurlyeq', '≼'),
			_Utils_Tuple2('Precedes', '≺'),
			_Utils_Tuple2('PrecedesEqual', '⪯'),
			_Utils_Tuple2('PrecedesSlantEqual', '≼'),
			_Utils_Tuple2('PrecedesTilde', '≾'),
			_Utils_Tuple2('preceq', '⪯'),
			_Utils_Tuple2('precnapprox', '⪹'),
			_Utils_Tuple2('precneqq', '⪵'),
			_Utils_Tuple2('precnsim', '⋨'),
			_Utils_Tuple2('pre', '⪯'),
			_Utils_Tuple2('prE', '⪳'),
			_Utils_Tuple2('precsim', '≾'),
			_Utils_Tuple2('prime', '′'),
			_Utils_Tuple2('Prime', '″'),
			_Utils_Tuple2('primes', 'ℙ'),
			_Utils_Tuple2('prnap', '⪹'),
			_Utils_Tuple2('prnE', '⪵'),
			_Utils_Tuple2('prnsim', '⋨'),
			_Utils_Tuple2('prod', '∏'),
			_Utils_Tuple2('Product', '∏'),
			_Utils_Tuple2('profalar', '⌮'),
			_Utils_Tuple2('profline', '⌒'),
			_Utils_Tuple2('profsurf', '⌓'),
			_Utils_Tuple2('prop', '∝'),
			_Utils_Tuple2('Proportional', '∝'),
			_Utils_Tuple2('Proportion', '∷'),
			_Utils_Tuple2('propto', '∝'),
			_Utils_Tuple2('prsim', '≾'),
			_Utils_Tuple2('prurel', '⊰'),
			_Utils_Tuple2('Pscr', '\uD835\uDCAB'),
			_Utils_Tuple2('pscr', '\uD835\uDCC5'),
			_Utils_Tuple2('Psi', 'Ψ'),
			_Utils_Tuple2('psi', 'ψ'),
			_Utils_Tuple2('puncsp', '\u2008'),
			_Utils_Tuple2('Qfr', '\uD835\uDD14'),
			_Utils_Tuple2('qfr', '\uD835\uDD2E'),
			_Utils_Tuple2('qint', '⨌'),
			_Utils_Tuple2('qopf', '\uD835\uDD62'),
			_Utils_Tuple2('Qopf', 'ℚ'),
			_Utils_Tuple2('qprime', '⁗'),
			_Utils_Tuple2('Qscr', '\uD835\uDCAC'),
			_Utils_Tuple2('qscr', '\uD835\uDCC6'),
			_Utils_Tuple2('quaternions', 'ℍ'),
			_Utils_Tuple2('quatint', '⨖'),
			_Utils_Tuple2('quest', '?'),
			_Utils_Tuple2('questeq', '≟'),
			_Utils_Tuple2('quot', '\"'),
			_Utils_Tuple2('QUOT', '\"'),
			_Utils_Tuple2('rAarr', '⇛'),
			_Utils_Tuple2('race', '∽̱'),
			_Utils_Tuple2('Racute', 'Ŕ'),
			_Utils_Tuple2('racute', 'ŕ'),
			_Utils_Tuple2('radic', '√'),
			_Utils_Tuple2('raemptyv', '⦳'),
			_Utils_Tuple2('rang', '⟩'),
			_Utils_Tuple2('Rang', '⟫'),
			_Utils_Tuple2('rangd', '⦒'),
			_Utils_Tuple2('range', '⦥'),
			_Utils_Tuple2('rangle', '⟩'),
			_Utils_Tuple2('raquo', '»'),
			_Utils_Tuple2('rarrap', '⥵'),
			_Utils_Tuple2('rarrb', '⇥'),
			_Utils_Tuple2('rarrbfs', '⤠'),
			_Utils_Tuple2('rarrc', '⤳'),
			_Utils_Tuple2('rarr', '→'),
			_Utils_Tuple2('Rarr', '↠'),
			_Utils_Tuple2('rArr', '⇒'),
			_Utils_Tuple2('rarrfs', '⤞'),
			_Utils_Tuple2('rarrhk', '↪'),
			_Utils_Tuple2('rarrlp', '↬'),
			_Utils_Tuple2('rarrpl', '⥅'),
			_Utils_Tuple2('rarrsim', '⥴'),
			_Utils_Tuple2('Rarrtl', '⤖'),
			_Utils_Tuple2('rarrtl', '↣'),
			_Utils_Tuple2('rarrw', '↝'),
			_Utils_Tuple2('ratail', '⤚'),
			_Utils_Tuple2('rAtail', '⤜'),
			_Utils_Tuple2('ratio', '∶'),
			_Utils_Tuple2('rationals', 'ℚ'),
			_Utils_Tuple2('rbarr', '⤍'),
			_Utils_Tuple2('rBarr', '⤏'),
			_Utils_Tuple2('RBarr', '⤐'),
			_Utils_Tuple2('rbbrk', '❳'),
			_Utils_Tuple2('rbrace', '}'),
			_Utils_Tuple2('rbrack', ']'),
			_Utils_Tuple2('rbrke', '⦌'),
			_Utils_Tuple2('rbrksld', '⦎'),
			_Utils_Tuple2('rbrkslu', '⦐'),
			_Utils_Tuple2('Rcaron', 'Ř'),
			_Utils_Tuple2('rcaron', 'ř'),
			_Utils_Tuple2('Rcedil', 'Ŗ'),
			_Utils_Tuple2('rcedil', 'ŗ'),
			_Utils_Tuple2('rceil', '⌉'),
			_Utils_Tuple2('rcub', '}'),
			_Utils_Tuple2('Rcy', 'Р'),
			_Utils_Tuple2('rcy', 'р'),
			_Utils_Tuple2('rdca', '⤷'),
			_Utils_Tuple2('rdldhar', '⥩'),
			_Utils_Tuple2('rdquo', '”'),
			_Utils_Tuple2('rdquor', '”'),
			_Utils_Tuple2('rdsh', '↳'),
			_Utils_Tuple2('real', 'ℜ'),
			_Utils_Tuple2('realine', 'ℛ'),
			_Utils_Tuple2('realpart', 'ℜ'),
			_Utils_Tuple2('reals', 'ℝ'),
			_Utils_Tuple2('Re', 'ℜ'),
			_Utils_Tuple2('rect', '▭'),
			_Utils_Tuple2('reg', '®'),
			_Utils_Tuple2('REG', '®'),
			_Utils_Tuple2('ReverseElement', '∋'),
			_Utils_Tuple2('ReverseEquilibrium', '⇋'),
			_Utils_Tuple2('ReverseUpEquilibrium', '⥯'),
			_Utils_Tuple2('rfisht', '⥽'),
			_Utils_Tuple2('rfloor', '⌋'),
			_Utils_Tuple2('rfr', '\uD835\uDD2F'),
			_Utils_Tuple2('Rfr', 'ℜ'),
			_Utils_Tuple2('rHar', '⥤'),
			_Utils_Tuple2('rhard', '⇁'),
			_Utils_Tuple2('rharu', '⇀'),
			_Utils_Tuple2('rharul', '⥬'),
			_Utils_Tuple2('Rho', 'Ρ'),
			_Utils_Tuple2('rho', 'ρ'),
			_Utils_Tuple2('rhov', 'ϱ'),
			_Utils_Tuple2('RightAngleBracket', '⟩'),
			_Utils_Tuple2('RightArrowBar', '⇥'),
			_Utils_Tuple2('rightarrow', '→'),
			_Utils_Tuple2('RightArrow', '→'),
			_Utils_Tuple2('Rightarrow', '⇒'),
			_Utils_Tuple2('RightArrowLeftArrow', '⇄'),
			_Utils_Tuple2('rightarrowtail', '↣'),
			_Utils_Tuple2('RightCeiling', '⌉'),
			_Utils_Tuple2('RightDoubleBracket', '⟧'),
			_Utils_Tuple2('RightDownTeeVector', '⥝'),
			_Utils_Tuple2('RightDownVectorBar', '⥕'),
			_Utils_Tuple2('RightDownVector', '⇂'),
			_Utils_Tuple2('RightFloor', '⌋'),
			_Utils_Tuple2('rightharpoondown', '⇁'),
			_Utils_Tuple2('rightharpoonup', '⇀'),
			_Utils_Tuple2('rightleftarrows', '⇄'),
			_Utils_Tuple2('rightleftharpoons', '⇌'),
			_Utils_Tuple2('rightrightarrows', '⇉'),
			_Utils_Tuple2('rightsquigarrow', '↝'),
			_Utils_Tuple2('RightTeeArrow', '↦'),
			_Utils_Tuple2('RightTee', '⊢'),
			_Utils_Tuple2('RightTeeVector', '⥛'),
			_Utils_Tuple2('rightthreetimes', '⋌'),
			_Utils_Tuple2('RightTriangleBar', '⧐'),
			_Utils_Tuple2('RightTriangle', '⊳'),
			_Utils_Tuple2('RightTriangleEqual', '⊵'),
			_Utils_Tuple2('RightUpDownVector', '⥏'),
			_Utils_Tuple2('RightUpTeeVector', '⥜'),
			_Utils_Tuple2('RightUpVectorBar', '⥔'),
			_Utils_Tuple2('RightUpVector', '↾'),
			_Utils_Tuple2('RightVectorBar', '⥓'),
			_Utils_Tuple2('RightVector', '⇀'),
			_Utils_Tuple2('ring', '˚'),
			_Utils_Tuple2('risingdotseq', '≓'),
			_Utils_Tuple2('rlarr', '⇄'),
			_Utils_Tuple2('rlhar', '⇌'),
			_Utils_Tuple2('rlm', '\u200F'),
			_Utils_Tuple2('rmoustache', '⎱'),
			_Utils_Tuple2('rmoust', '⎱'),
			_Utils_Tuple2('rnmid', '⫮'),
			_Utils_Tuple2('roang', '⟭'),
			_Utils_Tuple2('roarr', '⇾'),
			_Utils_Tuple2('robrk', '⟧'),
			_Utils_Tuple2('ropar', '⦆'),
			_Utils_Tuple2('ropf', '\uD835\uDD63'),
			_Utils_Tuple2('Ropf', 'ℝ'),
			_Utils_Tuple2('roplus', '⨮'),
			_Utils_Tuple2('rotimes', '⨵'),
			_Utils_Tuple2('RoundImplies', '⥰'),
			_Utils_Tuple2('rpar', ')'),
			_Utils_Tuple2('rpargt', '⦔'),
			_Utils_Tuple2('rppolint', '⨒'),
			_Utils_Tuple2('rrarr', '⇉'),
			_Utils_Tuple2('Rrightarrow', '⇛'),
			_Utils_Tuple2('rsaquo', '›'),
			_Utils_Tuple2('rscr', '\uD835\uDCC7'),
			_Utils_Tuple2('Rscr', 'ℛ'),
			_Utils_Tuple2('rsh', '↱'),
			_Utils_Tuple2('Rsh', '↱'),
			_Utils_Tuple2('rsqb', ']'),
			_Utils_Tuple2('rsquo', '’'),
			_Utils_Tuple2('rsquor', '’'),
			_Utils_Tuple2('rthree', '⋌'),
			_Utils_Tuple2('rtimes', '⋊'),
			_Utils_Tuple2('rtri', '▹'),
			_Utils_Tuple2('rtrie', '⊵'),
			_Utils_Tuple2('rtrif', '▸'),
			_Utils_Tuple2('rtriltri', '⧎'),
			_Utils_Tuple2('RuleDelayed', '⧴'),
			_Utils_Tuple2('ruluhar', '⥨'),
			_Utils_Tuple2('rx', '℞'),
			_Utils_Tuple2('Sacute', 'Ś'),
			_Utils_Tuple2('sacute', 'ś'),
			_Utils_Tuple2('sbquo', '‚'),
			_Utils_Tuple2('scap', '⪸'),
			_Utils_Tuple2('Scaron', 'Š'),
			_Utils_Tuple2('scaron', 'š'),
			_Utils_Tuple2('Sc', '⪼'),
			_Utils_Tuple2('sc', '≻'),
			_Utils_Tuple2('sccue', '≽'),
			_Utils_Tuple2('sce', '⪰'),
			_Utils_Tuple2('scE', '⪴'),
			_Utils_Tuple2('Scedil', 'Ş'),
			_Utils_Tuple2('scedil', 'ş'),
			_Utils_Tuple2('Scirc', 'Ŝ'),
			_Utils_Tuple2('scirc', 'ŝ'),
			_Utils_Tuple2('scnap', '⪺'),
			_Utils_Tuple2('scnE', '⪶'),
			_Utils_Tuple2('scnsim', '⋩'),
			_Utils_Tuple2('scpolint', '⨓'),
			_Utils_Tuple2('scsim', '≿'),
			_Utils_Tuple2('Scy', 'С'),
			_Utils_Tuple2('scy', 'с'),
			_Utils_Tuple2('sdotb', '⊡'),
			_Utils_Tuple2('sdot', '⋅'),
			_Utils_Tuple2('sdote', '⩦'),
			_Utils_Tuple2('searhk', '⤥'),
			_Utils_Tuple2('searr', '↘'),
			_Utils_Tuple2('seArr', '⇘'),
			_Utils_Tuple2('searrow', '↘'),
			_Utils_Tuple2('sect', '§'),
			_Utils_Tuple2('semi', ';'),
			_Utils_Tuple2('seswar', '⤩'),
			_Utils_Tuple2('setminus', '∖'),
			_Utils_Tuple2('setmn', '∖'),
			_Utils_Tuple2('sext', '✶'),
			_Utils_Tuple2('Sfr', '\uD835\uDD16'),
			_Utils_Tuple2('sfr', '\uD835\uDD30'),
			_Utils_Tuple2('sfrown', '⌢'),
			_Utils_Tuple2('sharp', '♯'),
			_Utils_Tuple2('SHCHcy', 'Щ'),
			_Utils_Tuple2('shchcy', 'щ'),
			_Utils_Tuple2('SHcy', 'Ш'),
			_Utils_Tuple2('shcy', 'ш'),
			_Utils_Tuple2('ShortDownArrow', '↓'),
			_Utils_Tuple2('ShortLeftArrow', '←'),
			_Utils_Tuple2('shortmid', '∣'),
			_Utils_Tuple2('shortparallel', '∥'),
			_Utils_Tuple2('ShortRightArrow', '→'),
			_Utils_Tuple2('ShortUpArrow', '↑'),
			_Utils_Tuple2('shy', '\u00AD'),
			_Utils_Tuple2('Sigma', 'Σ'),
			_Utils_Tuple2('sigma', 'σ'),
			_Utils_Tuple2('sigmaf', 'ς'),
			_Utils_Tuple2('sigmav', 'ς'),
			_Utils_Tuple2('sim', '∼'),
			_Utils_Tuple2('simdot', '⩪'),
			_Utils_Tuple2('sime', '≃'),
			_Utils_Tuple2('simeq', '≃'),
			_Utils_Tuple2('simg', '⪞'),
			_Utils_Tuple2('simgE', '⪠'),
			_Utils_Tuple2('siml', '⪝'),
			_Utils_Tuple2('simlE', '⪟'),
			_Utils_Tuple2('simne', '≆'),
			_Utils_Tuple2('simplus', '⨤'),
			_Utils_Tuple2('simrarr', '⥲'),
			_Utils_Tuple2('slarr', '←'),
			_Utils_Tuple2('SmallCircle', '∘'),
			_Utils_Tuple2('smallsetminus', '∖'),
			_Utils_Tuple2('smashp', '⨳'),
			_Utils_Tuple2('smeparsl', '⧤'),
			_Utils_Tuple2('smid', '∣'),
			_Utils_Tuple2('smile', '⌣'),
			_Utils_Tuple2('smt', '⪪'),
			_Utils_Tuple2('smte', '⪬'),
			_Utils_Tuple2('smtes', '⪬︀'),
			_Utils_Tuple2('SOFTcy', 'Ь'),
			_Utils_Tuple2('softcy', 'ь'),
			_Utils_Tuple2('solbar', '⌿'),
			_Utils_Tuple2('solb', '⧄'),
			_Utils_Tuple2('sol', '/'),
			_Utils_Tuple2('Sopf', '\uD835\uDD4A'),
			_Utils_Tuple2('sopf', '\uD835\uDD64'),
			_Utils_Tuple2('spades', '♠'),
			_Utils_Tuple2('spadesuit', '♠'),
			_Utils_Tuple2('spar', '∥'),
			_Utils_Tuple2('sqcap', '⊓'),
			_Utils_Tuple2('sqcaps', '⊓︀'),
			_Utils_Tuple2('sqcup', '⊔'),
			_Utils_Tuple2('sqcups', '⊔︀'),
			_Utils_Tuple2('Sqrt', '√'),
			_Utils_Tuple2('sqsub', '⊏'),
			_Utils_Tuple2('sqsube', '⊑'),
			_Utils_Tuple2('sqsubset', '⊏'),
			_Utils_Tuple2('sqsubseteq', '⊑'),
			_Utils_Tuple2('sqsup', '⊐'),
			_Utils_Tuple2('sqsupe', '⊒'),
			_Utils_Tuple2('sqsupset', '⊐'),
			_Utils_Tuple2('sqsupseteq', '⊒'),
			_Utils_Tuple2('square', '□'),
			_Utils_Tuple2('Square', '□'),
			_Utils_Tuple2('SquareIntersection', '⊓'),
			_Utils_Tuple2('SquareSubset', '⊏'),
			_Utils_Tuple2('SquareSubsetEqual', '⊑'),
			_Utils_Tuple2('SquareSuperset', '⊐'),
			_Utils_Tuple2('SquareSupersetEqual', '⊒'),
			_Utils_Tuple2('SquareUnion', '⊔'),
			_Utils_Tuple2('squarf', '▪'),
			_Utils_Tuple2('squ', '□'),
			_Utils_Tuple2('squf', '▪'),
			_Utils_Tuple2('srarr', '→'),
			_Utils_Tuple2('Sscr', '\uD835\uDCAE'),
			_Utils_Tuple2('sscr', '\uD835\uDCC8'),
			_Utils_Tuple2('ssetmn', '∖'),
			_Utils_Tuple2('ssmile', '⌣'),
			_Utils_Tuple2('sstarf', '⋆'),
			_Utils_Tuple2('Star', '⋆'),
			_Utils_Tuple2('star', '☆'),
			_Utils_Tuple2('starf', '★'),
			_Utils_Tuple2('straightepsilon', 'ϵ'),
			_Utils_Tuple2('straightphi', 'ϕ'),
			_Utils_Tuple2('strns', '¯'),
			_Utils_Tuple2('sub', '⊂'),
			_Utils_Tuple2('Sub', '⋐'),
			_Utils_Tuple2('subdot', '⪽'),
			_Utils_Tuple2('subE', '⫅'),
			_Utils_Tuple2('sube', '⊆'),
			_Utils_Tuple2('subedot', '⫃'),
			_Utils_Tuple2('submult', '⫁'),
			_Utils_Tuple2('subnE', '⫋'),
			_Utils_Tuple2('subne', '⊊'),
			_Utils_Tuple2('subplus', '⪿'),
			_Utils_Tuple2('subrarr', '⥹'),
			_Utils_Tuple2('subset', '⊂'),
			_Utils_Tuple2('Subset', '⋐'),
			_Utils_Tuple2('subseteq', '⊆'),
			_Utils_Tuple2('subseteqq', '⫅'),
			_Utils_Tuple2('SubsetEqual', '⊆'),
			_Utils_Tuple2('subsetneq', '⊊'),
			_Utils_Tuple2('subsetneqq', '⫋'),
			_Utils_Tuple2('subsim', '⫇'),
			_Utils_Tuple2('subsub', '⫕'),
			_Utils_Tuple2('subsup', '⫓'),
			_Utils_Tuple2('succapprox', '⪸'),
			_Utils_Tuple2('succ', '≻'),
			_Utils_Tuple2('succcurlyeq', '≽'),
			_Utils_Tuple2('Succeeds', '≻'),
			_Utils_Tuple2('SucceedsEqual', '⪰'),
			_Utils_Tuple2('SucceedsSlantEqual', '≽'),
			_Utils_Tuple2('SucceedsTilde', '≿'),
			_Utils_Tuple2('succeq', '⪰'),
			_Utils_Tuple2('succnapprox', '⪺'),
			_Utils_Tuple2('succneqq', '⪶'),
			_Utils_Tuple2('succnsim', '⋩'),
			_Utils_Tuple2('succsim', '≿'),
			_Utils_Tuple2('SuchThat', '∋'),
			_Utils_Tuple2('sum', '∑'),
			_Utils_Tuple2('Sum', '∑'),
			_Utils_Tuple2('sung', '♪'),
			_Utils_Tuple2('sup1', '¹'),
			_Utils_Tuple2('sup2', '²'),
			_Utils_Tuple2('sup3', '³'),
			_Utils_Tuple2('sup', '⊃'),
			_Utils_Tuple2('Sup', '⋑'),
			_Utils_Tuple2('supdot', '⪾'),
			_Utils_Tuple2('supdsub', '⫘'),
			_Utils_Tuple2('supE', '⫆'),
			_Utils_Tuple2('supe', '⊇'),
			_Utils_Tuple2('supedot', '⫄'),
			_Utils_Tuple2('Superset', '⊃'),
			_Utils_Tuple2('SupersetEqual', '⊇'),
			_Utils_Tuple2('suphsol', '⟉'),
			_Utils_Tuple2('suphsub', '⫗'),
			_Utils_Tuple2('suplarr', '⥻'),
			_Utils_Tuple2('supmult', '⫂'),
			_Utils_Tuple2('supnE', '⫌'),
			_Utils_Tuple2('supne', '⊋'),
			_Utils_Tuple2('supplus', '⫀'),
			_Utils_Tuple2('supset', '⊃'),
			_Utils_Tuple2('Supset', '⋑'),
			_Utils_Tuple2('supseteq', '⊇'),
			_Utils_Tuple2('supseteqq', '⫆'),
			_Utils_Tuple2('supsetneq', '⊋'),
			_Utils_Tuple2('supsetneqq', '⫌'),
			_Utils_Tuple2('supsim', '⫈'),
			_Utils_Tuple2('supsub', '⫔'),
			_Utils_Tuple2('supsup', '⫖'),
			_Utils_Tuple2('swarhk', '⤦'),
			_Utils_Tuple2('swarr', '↙'),
			_Utils_Tuple2('swArr', '⇙'),
			_Utils_Tuple2('swarrow', '↙'),
			_Utils_Tuple2('swnwar', '⤪'),
			_Utils_Tuple2('szlig', 'ß'),
			_Utils_Tuple2('Tab', '\t'),
			_Utils_Tuple2('target', '⌖'),
			_Utils_Tuple2('Tau', 'Τ'),
			_Utils_Tuple2('tau', 'τ'),
			_Utils_Tuple2('tbrk', '⎴'),
			_Utils_Tuple2('Tcaron', 'Ť'),
			_Utils_Tuple2('tcaron', 'ť'),
			_Utils_Tuple2('Tcedil', 'Ţ'),
			_Utils_Tuple2('tcedil', 'ţ'),
			_Utils_Tuple2('Tcy', 'Т'),
			_Utils_Tuple2('tcy', 'т'),
			_Utils_Tuple2('tdot', '⃛'),
			_Utils_Tuple2('telrec', '⌕'),
			_Utils_Tuple2('Tfr', '\uD835\uDD17'),
			_Utils_Tuple2('tfr', '\uD835\uDD31'),
			_Utils_Tuple2('there4', '∴'),
			_Utils_Tuple2('therefore', '∴'),
			_Utils_Tuple2('Therefore', '∴'),
			_Utils_Tuple2('Theta', 'Θ'),
			_Utils_Tuple2('theta', 'θ'),
			_Utils_Tuple2('thetasym', 'ϑ'),
			_Utils_Tuple2('thetav', 'ϑ'),
			_Utils_Tuple2('thickapprox', '≈'),
			_Utils_Tuple2('thicksim', '∼'),
			_Utils_Tuple2('ThickSpace', '\u205F\u200A'),
			_Utils_Tuple2('ThinSpace', '\u2009'),
			_Utils_Tuple2('thinsp', '\u2009'),
			_Utils_Tuple2('thkap', '≈'),
			_Utils_Tuple2('thksim', '∼'),
			_Utils_Tuple2('THORN', 'Þ'),
			_Utils_Tuple2('thorn', 'þ'),
			_Utils_Tuple2('tilde', '˜'),
			_Utils_Tuple2('Tilde', '∼'),
			_Utils_Tuple2('TildeEqual', '≃'),
			_Utils_Tuple2('TildeFullEqual', '≅'),
			_Utils_Tuple2('TildeTilde', '≈'),
			_Utils_Tuple2('timesbar', '⨱'),
			_Utils_Tuple2('timesb', '⊠'),
			_Utils_Tuple2('times', '×'),
			_Utils_Tuple2('timesd', '⨰'),
			_Utils_Tuple2('tint', '∭'),
			_Utils_Tuple2('toea', '⤨'),
			_Utils_Tuple2('topbot', '⌶'),
			_Utils_Tuple2('topcir', '⫱'),
			_Utils_Tuple2('top', '⊤'),
			_Utils_Tuple2('Topf', '\uD835\uDD4B'),
			_Utils_Tuple2('topf', '\uD835\uDD65'),
			_Utils_Tuple2('topfork', '⫚'),
			_Utils_Tuple2('tosa', '⤩'),
			_Utils_Tuple2('tprime', '‴'),
			_Utils_Tuple2('trade', '™'),
			_Utils_Tuple2('TRADE', '™'),
			_Utils_Tuple2('triangle', '▵'),
			_Utils_Tuple2('triangledown', '▿'),
			_Utils_Tuple2('triangleleft', '◃'),
			_Utils_Tuple2('trianglelefteq', '⊴'),
			_Utils_Tuple2('triangleq', '≜'),
			_Utils_Tuple2('triangleright', '▹'),
			_Utils_Tuple2('trianglerighteq', '⊵'),
			_Utils_Tuple2('tridot', '◬'),
			_Utils_Tuple2('trie', '≜'),
			_Utils_Tuple2('triminus', '⨺'),
			_Utils_Tuple2('TripleDot', '⃛'),
			_Utils_Tuple2('triplus', '⨹'),
			_Utils_Tuple2('trisb', '⧍'),
			_Utils_Tuple2('tritime', '⨻'),
			_Utils_Tuple2('trpezium', '⏢'),
			_Utils_Tuple2('Tscr', '\uD835\uDCAF'),
			_Utils_Tuple2('tscr', '\uD835\uDCC9'),
			_Utils_Tuple2('TScy', 'Ц'),
			_Utils_Tuple2('tscy', 'ц'),
			_Utils_Tuple2('TSHcy', 'Ћ'),
			_Utils_Tuple2('tshcy', 'ћ'),
			_Utils_Tuple2('Tstrok', 'Ŧ'),
			_Utils_Tuple2('tstrok', 'ŧ'),
			_Utils_Tuple2('twixt', '≬'),
			_Utils_Tuple2('twoheadleftarrow', '↞'),
			_Utils_Tuple2('twoheadrightarrow', '↠'),
			_Utils_Tuple2('Uacute', 'Ú'),
			_Utils_Tuple2('uacute', 'ú'),
			_Utils_Tuple2('uarr', '↑'),
			_Utils_Tuple2('Uarr', '↟'),
			_Utils_Tuple2('uArr', '⇑'),
			_Utils_Tuple2('Uarrocir', '⥉'),
			_Utils_Tuple2('Ubrcy', 'Ў'),
			_Utils_Tuple2('ubrcy', 'ў'),
			_Utils_Tuple2('Ubreve', 'Ŭ'),
			_Utils_Tuple2('ubreve', 'ŭ'),
			_Utils_Tuple2('Ucirc', 'Û'),
			_Utils_Tuple2('ucirc', 'û'),
			_Utils_Tuple2('Ucy', 'У'),
			_Utils_Tuple2('ucy', 'у'),
			_Utils_Tuple2('udarr', '⇅'),
			_Utils_Tuple2('Udblac', 'Ű'),
			_Utils_Tuple2('udblac', 'ű'),
			_Utils_Tuple2('udhar', '⥮'),
			_Utils_Tuple2('ufisht', '⥾'),
			_Utils_Tuple2('Ufr', '\uD835\uDD18'),
			_Utils_Tuple2('ufr', '\uD835\uDD32'),
			_Utils_Tuple2('Ugrave', 'Ù'),
			_Utils_Tuple2('ugrave', 'ù'),
			_Utils_Tuple2('uHar', '⥣'),
			_Utils_Tuple2('uharl', '↿'),
			_Utils_Tuple2('uharr', '↾'),
			_Utils_Tuple2('uhblk', '▀'),
			_Utils_Tuple2('ulcorn', '⌜'),
			_Utils_Tuple2('ulcorner', '⌜'),
			_Utils_Tuple2('ulcrop', '⌏'),
			_Utils_Tuple2('ultri', '◸'),
			_Utils_Tuple2('Umacr', 'Ū'),
			_Utils_Tuple2('umacr', 'ū'),
			_Utils_Tuple2('uml', '¨'),
			_Utils_Tuple2('UnderBar', '_'),
			_Utils_Tuple2('UnderBrace', '⏟'),
			_Utils_Tuple2('UnderBracket', '⎵'),
			_Utils_Tuple2('UnderParenthesis', '⏝'),
			_Utils_Tuple2('Union', '⋃'),
			_Utils_Tuple2('UnionPlus', '⊎'),
			_Utils_Tuple2('Uogon', 'Ų'),
			_Utils_Tuple2('uogon', 'ų'),
			_Utils_Tuple2('Uopf', '\uD835\uDD4C'),
			_Utils_Tuple2('uopf', '\uD835\uDD66'),
			_Utils_Tuple2('UpArrowBar', '⤒'),
			_Utils_Tuple2('uparrow', '↑'),
			_Utils_Tuple2('UpArrow', '↑'),
			_Utils_Tuple2('Uparrow', '⇑'),
			_Utils_Tuple2('UpArrowDownArrow', '⇅'),
			_Utils_Tuple2('updownarrow', '↕'),
			_Utils_Tuple2('UpDownArrow', '↕'),
			_Utils_Tuple2('Updownarrow', '⇕'),
			_Utils_Tuple2('UpEquilibrium', '⥮'),
			_Utils_Tuple2('upharpoonleft', '↿'),
			_Utils_Tuple2('upharpoonright', '↾'),
			_Utils_Tuple2('uplus', '⊎'),
			_Utils_Tuple2('UpperLeftArrow', '↖'),
			_Utils_Tuple2('UpperRightArrow', '↗'),
			_Utils_Tuple2('upsi', 'υ'),
			_Utils_Tuple2('Upsi', 'ϒ'),
			_Utils_Tuple2('upsih', 'ϒ'),
			_Utils_Tuple2('Upsilon', 'Υ'),
			_Utils_Tuple2('upsilon', 'υ'),
			_Utils_Tuple2('UpTeeArrow', '↥'),
			_Utils_Tuple2('UpTee', '⊥'),
			_Utils_Tuple2('upuparrows', '⇈'),
			_Utils_Tuple2('urcorn', '⌝'),
			_Utils_Tuple2('urcorner', '⌝'),
			_Utils_Tuple2('urcrop', '⌎'),
			_Utils_Tuple2('Uring', 'Ů'),
			_Utils_Tuple2('uring', 'ů'),
			_Utils_Tuple2('urtri', '◹'),
			_Utils_Tuple2('Uscr', '\uD835\uDCB0'),
			_Utils_Tuple2('uscr', '\uD835\uDCCA'),
			_Utils_Tuple2('utdot', '⋰'),
			_Utils_Tuple2('Utilde', 'Ũ'),
			_Utils_Tuple2('utilde', 'ũ'),
			_Utils_Tuple2('utri', '▵'),
			_Utils_Tuple2('utrif', '▴'),
			_Utils_Tuple2('uuarr', '⇈'),
			_Utils_Tuple2('Uuml', 'Ü'),
			_Utils_Tuple2('uuml', 'ü'),
			_Utils_Tuple2('uwangle', '⦧'),
			_Utils_Tuple2('vangrt', '⦜'),
			_Utils_Tuple2('varepsilon', 'ϵ'),
			_Utils_Tuple2('varkappa', 'ϰ'),
			_Utils_Tuple2('varnothing', '∅'),
			_Utils_Tuple2('varphi', 'ϕ'),
			_Utils_Tuple2('varpi', 'ϖ'),
			_Utils_Tuple2('varpropto', '∝'),
			_Utils_Tuple2('varr', '↕'),
			_Utils_Tuple2('vArr', '⇕'),
			_Utils_Tuple2('varrho', 'ϱ'),
			_Utils_Tuple2('varsigma', 'ς'),
			_Utils_Tuple2('varsubsetneq', '⊊︀'),
			_Utils_Tuple2('varsubsetneqq', '⫋︀'),
			_Utils_Tuple2('varsupsetneq', '⊋︀'),
			_Utils_Tuple2('varsupsetneqq', '⫌︀'),
			_Utils_Tuple2('vartheta', 'ϑ'),
			_Utils_Tuple2('vartriangleleft', '⊲'),
			_Utils_Tuple2('vartriangleright', '⊳'),
			_Utils_Tuple2('vBar', '⫨'),
			_Utils_Tuple2('Vbar', '⫫'),
			_Utils_Tuple2('vBarv', '⫩'),
			_Utils_Tuple2('Vcy', 'В'),
			_Utils_Tuple2('vcy', 'в'),
			_Utils_Tuple2('vdash', '⊢'),
			_Utils_Tuple2('vDash', '⊨'),
			_Utils_Tuple2('Vdash', '⊩'),
			_Utils_Tuple2('VDash', '⊫'),
			_Utils_Tuple2('Vdashl', '⫦'),
			_Utils_Tuple2('veebar', '⊻'),
			_Utils_Tuple2('vee', '∨'),
			_Utils_Tuple2('Vee', '⋁'),
			_Utils_Tuple2('veeeq', '≚'),
			_Utils_Tuple2('vellip', '⋮'),
			_Utils_Tuple2('verbar', '|'),
			_Utils_Tuple2('Verbar', '‖'),
			_Utils_Tuple2('vert', '|'),
			_Utils_Tuple2('Vert', '‖'),
			_Utils_Tuple2('VerticalBar', '∣'),
			_Utils_Tuple2('VerticalLine', '|'),
			_Utils_Tuple2('VerticalSeparator', '❘'),
			_Utils_Tuple2('VerticalTilde', '≀'),
			_Utils_Tuple2('VeryThinSpace', '\u200A'),
			_Utils_Tuple2('Vfr', '\uD835\uDD19'),
			_Utils_Tuple2('vfr', '\uD835\uDD33'),
			_Utils_Tuple2('vltri', '⊲'),
			_Utils_Tuple2('vnsub', '⊂⃒'),
			_Utils_Tuple2('vnsup', '⊃⃒'),
			_Utils_Tuple2('Vopf', '\uD835\uDD4D'),
			_Utils_Tuple2('vopf', '\uD835\uDD67'),
			_Utils_Tuple2('vprop', '∝'),
			_Utils_Tuple2('vrtri', '⊳'),
			_Utils_Tuple2('Vscr', '\uD835\uDCB1'),
			_Utils_Tuple2('vscr', '\uD835\uDCCB'),
			_Utils_Tuple2('vsubnE', '⫋︀'),
			_Utils_Tuple2('vsubne', '⊊︀'),
			_Utils_Tuple2('vsupnE', '⫌︀'),
			_Utils_Tuple2('vsupne', '⊋︀'),
			_Utils_Tuple2('Vvdash', '⊪'),
			_Utils_Tuple2('vzigzag', '⦚'),
			_Utils_Tuple2('Wcirc', 'Ŵ'),
			_Utils_Tuple2('wcirc', 'ŵ'),
			_Utils_Tuple2('wedbar', '⩟'),
			_Utils_Tuple2('wedge', '∧'),
			_Utils_Tuple2('Wedge', '⋀'),
			_Utils_Tuple2('wedgeq', '≙'),
			_Utils_Tuple2('weierp', '℘'),
			_Utils_Tuple2('Wfr', '\uD835\uDD1A'),
			_Utils_Tuple2('wfr', '\uD835\uDD34'),
			_Utils_Tuple2('Wopf', '\uD835\uDD4E'),
			_Utils_Tuple2('wopf', '\uD835\uDD68'),
			_Utils_Tuple2('wp', '℘'),
			_Utils_Tuple2('wr', '≀'),
			_Utils_Tuple2('wreath', '≀'),
			_Utils_Tuple2('Wscr', '\uD835\uDCB2'),
			_Utils_Tuple2('wscr', '\uD835\uDCCC'),
			_Utils_Tuple2('xcap', '⋂'),
			_Utils_Tuple2('xcirc', '◯'),
			_Utils_Tuple2('xcup', '⋃'),
			_Utils_Tuple2('xdtri', '▽'),
			_Utils_Tuple2('Xfr', '\uD835\uDD1B'),
			_Utils_Tuple2('xfr', '\uD835\uDD35'),
			_Utils_Tuple2('xharr', '⟷'),
			_Utils_Tuple2('xhArr', '⟺'),
			_Utils_Tuple2('Xi', 'Ξ'),
			_Utils_Tuple2('xi', 'ξ'),
			_Utils_Tuple2('xlarr', '⟵'),
			_Utils_Tuple2('xlArr', '⟸'),
			_Utils_Tuple2('xmap', '⟼'),
			_Utils_Tuple2('xnis', '⋻'),
			_Utils_Tuple2('xodot', '⨀'),
			_Utils_Tuple2('Xopf', '\uD835\uDD4F'),
			_Utils_Tuple2('xopf', '\uD835\uDD69'),
			_Utils_Tuple2('xoplus', '⨁'),
			_Utils_Tuple2('xotime', '⨂'),
			_Utils_Tuple2('xrarr', '⟶'),
			_Utils_Tuple2('xrArr', '⟹'),
			_Utils_Tuple2('Xscr', '\uD835\uDCB3'),
			_Utils_Tuple2('xscr', '\uD835\uDCCD'),
			_Utils_Tuple2('xsqcup', '⨆'),
			_Utils_Tuple2('xuplus', '⨄'),
			_Utils_Tuple2('xutri', '△'),
			_Utils_Tuple2('xvee', '⋁'),
			_Utils_Tuple2('xwedge', '⋀'),
			_Utils_Tuple2('Yacute', 'Ý'),
			_Utils_Tuple2('yacute', 'ý'),
			_Utils_Tuple2('YAcy', 'Я'),
			_Utils_Tuple2('yacy', 'я'),
			_Utils_Tuple2('Ycirc', 'Ŷ'),
			_Utils_Tuple2('ycirc', 'ŷ'),
			_Utils_Tuple2('Ycy', 'Ы'),
			_Utils_Tuple2('ycy', 'ы'),
			_Utils_Tuple2('yen', '¥'),
			_Utils_Tuple2('Yfr', '\uD835\uDD1C'),
			_Utils_Tuple2('yfr', '\uD835\uDD36'),
			_Utils_Tuple2('YIcy', 'Ї'),
			_Utils_Tuple2('yicy', 'ї'),
			_Utils_Tuple2('Yopf', '\uD835\uDD50'),
			_Utils_Tuple2('yopf', '\uD835\uDD6A'),
			_Utils_Tuple2('Yscr', '\uD835\uDCB4'),
			_Utils_Tuple2('yscr', '\uD835\uDCCE'),
			_Utils_Tuple2('YUcy', 'Ю'),
			_Utils_Tuple2('yucy', 'ю'),
			_Utils_Tuple2('yuml', 'ÿ'),
			_Utils_Tuple2('Yuml', 'Ÿ'),
			_Utils_Tuple2('Zacute', 'Ź'),
			_Utils_Tuple2('zacute', 'ź'),
			_Utils_Tuple2('Zcaron', 'Ž'),
			_Utils_Tuple2('zcaron', 'ž'),
			_Utils_Tuple2('Zcy', 'З'),
			_Utils_Tuple2('zcy', 'з'),
			_Utils_Tuple2('Zdot', 'Ż'),
			_Utils_Tuple2('zdot', 'ż'),
			_Utils_Tuple2('zeetrf', 'ℨ'),
			_Utils_Tuple2('ZeroWidthSpace', '\u200B'),
			_Utils_Tuple2('Zeta', 'Ζ'),
			_Utils_Tuple2('zeta', 'ζ'),
			_Utils_Tuple2('zfr', '\uD835\uDD37'),
			_Utils_Tuple2('Zfr', 'ℨ'),
			_Utils_Tuple2('ZHcy', 'Ж'),
			_Utils_Tuple2('zhcy', 'ж'),
			_Utils_Tuple2('zigrarr', '⇝'),
			_Utils_Tuple2('zopf', '\uD835\uDD6B'),
			_Utils_Tuple2('Zopf', 'ℤ'),
			_Utils_Tuple2('Zscr', '\uD835\uDCB5'),
			_Utils_Tuple2('zscr', '\uD835\uDCCF'),
			_Utils_Tuple2('zwj', '\u200D'),
			_Utils_Tuple2('zwnj', '\u200C')
		]));
var $hecrj$html_parser$Html$Parser$namedCharacterReference = A2(
	$elm$parser$Parser$map,
	function (reference) {
		return A2(
			$elm$core$Maybe$withDefault,
			'&' + (reference + ';'),
			A2($elm$core$Dict$get, reference, $hecrj$html_parser$Html$Parser$NamedCharacterReferences$dict));
	},
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($elm$core$Char$isAlpha)));
var $elm$core$Basics$pow = _Basics_pow;
var $rtfeldman$elm_hex$Hex$fromStringHelp = F3(
	function (position, chars, accumulated) {
		fromStringHelp:
		while (true) {
			if (!chars.b) {
				return $elm$core$Result$Ok(accumulated);
			} else {
				var _char = chars.a;
				var rest = chars.b;
				switch (_char) {
					case '0':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated;
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '1':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + A2($elm$core$Basics$pow, 16, position);
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '2':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (2 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '3':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (3 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '4':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (4 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '5':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (5 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '6':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (6 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '7':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (7 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '8':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (8 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '9':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (9 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'a':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (10 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'b':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (11 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'c':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (12 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'd':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (13 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'e':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (14 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'f':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (15 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					default:
						var nonHex = _char;
						return $elm$core$Result$Err(
							$elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
				}
			}
		}
	});
var $rtfeldman$elm_hex$Hex$fromString = function (str) {
	if ($elm$core$String$isEmpty(str)) {
		return $elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
	} else {
		var result = function () {
			if (A2($elm$core$String$startsWith, '-', str)) {
				var list = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$elm$core$List$tail(
						$elm$core$String$toList(str)));
				return A2(
					$elm$core$Result$map,
					$elm$core$Basics$negate,
					A3(
						$rtfeldman$elm_hex$Hex$fromStringHelp,
						$elm$core$List$length(list) - 1,
						list,
						0));
			} else {
				return A3(
					$rtfeldman$elm_hex$Hex$fromStringHelp,
					$elm$core$String$length(str) - 1,
					$elm$core$String$toList(str),
					0);
			}
		}();
		var formatError = function (err) {
			return A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					['\"' + (str + '\"'), 'is not a valid hexadecimal string because', err]));
		};
		return A2($elm$core$Result$mapError, formatError, result);
	}
};
var $elm$core$Char$isHexDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return ((48 <= code) && (code <= 57)) || (((65 <= code) && (code <= 70)) || ((97 <= code) && (code <= 102)));
};
var $hecrj$html_parser$Html$Parser$hexadecimal = A2(
	$elm$parser$Parser$andThen,
	function (hex) {
		var _v0 = $rtfeldman$elm_hex$Hex$fromString(
			$elm$core$String$toLower(hex));
		if (!_v0.$) {
			var value = _v0.a;
			return $elm$parser$Parser$succeed(value);
		} else {
			var error = _v0.a;
			return $elm$parser$Parser$problem(error);
		}
	},
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($elm$core$Char$isHexDigit)));
var $elm$parser$Parser$ExpectingInt = {$: 1};
var $elm$parser$Parser$Advanced$consumeBase = _Parser_consumeBase;
var $elm$parser$Parser$Advanced$consumeBase16 = _Parser_consumeBase16;
var $elm$parser$Parser$Advanced$bumpOffset = F2(
	function (newOffset, s) {
		return {NQ: s.NQ + (newOffset - s.g), a3: s.a3, ahY: s.ahY, g: newOffset, pL: s.pL, uN: s.uN};
	});
var $elm$parser$Parser$Advanced$chompBase10 = _Parser_chompBase10;
var $elm$parser$Parser$Advanced$isAsciiCode = _Parser_isAsciiCode;
var $elm$parser$Parser$Advanced$consumeExp = F2(
	function (offset, src) {
		if (A3($elm$parser$Parser$Advanced$isAsciiCode, 101, offset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 69, offset, src)) {
			var eOffset = offset + 1;
			var expOffset = (A3($elm$parser$Parser$Advanced$isAsciiCode, 43, eOffset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 45, eOffset, src)) ? (eOffset + 1) : eOffset;
			var newOffset = A2($elm$parser$Parser$Advanced$chompBase10, expOffset, src);
			return _Utils_eq(expOffset, newOffset) ? (-newOffset) : newOffset;
		} else {
			return offset;
		}
	});
var $elm$parser$Parser$Advanced$consumeDotAndExp = F2(
	function (offset, src) {
		return A3($elm$parser$Parser$Advanced$isAsciiCode, 46, offset, src) ? A2(
			$elm$parser$Parser$Advanced$consumeExp,
			A2($elm$parser$Parser$Advanced$chompBase10, offset + 1, src),
			src) : A2($elm$parser$Parser$Advanced$consumeExp, offset, src);
	});
var $elm$parser$Parser$Advanced$finalizeInt = F5(
	function (invalid, handler, startOffset, _v0, s) {
		var endOffset = _v0.a;
		var n = _v0.b;
		if (handler.$ === 1) {
			var x = handler.a;
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				true,
				A2($elm$parser$Parser$Advanced$fromState, s, x));
		} else {
			var toValue = handler.a;
			return _Utils_eq(startOffset, endOffset) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				_Utils_cmp(s.g, startOffset) < 0,
				A2($elm$parser$Parser$Advanced$fromState, s, invalid)) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				toValue(n),
				A2($elm$parser$Parser$Advanced$bumpOffset, endOffset, s));
		}
	});
var $elm$parser$Parser$Advanced$finalizeFloat = F6(
	function (invalid, expecting, intSettings, floatSettings, intPair, s) {
		var intOffset = intPair.a;
		var floatOffset = A2($elm$parser$Parser$Advanced$consumeDotAndExp, intOffset, s.uN);
		if (floatOffset < 0) {
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				true,
				A4($elm$parser$Parser$Advanced$fromInfo, s.pL, s.NQ - (floatOffset + s.g), invalid, s.a3));
		} else {
			if (_Utils_eq(s.g, floatOffset)) {
				return A2(
					$elm$parser$Parser$Advanced$Bad,
					false,
					A2($elm$parser$Parser$Advanced$fromState, s, expecting));
			} else {
				if (_Utils_eq(intOffset, floatOffset)) {
					return A5($elm$parser$Parser$Advanced$finalizeInt, invalid, intSettings, s.g, intPair, s);
				} else {
					if (floatSettings.$ === 1) {
						var x = floatSettings.a;
						return A2(
							$elm$parser$Parser$Advanced$Bad,
							true,
							A2($elm$parser$Parser$Advanced$fromState, s, invalid));
					} else {
						var toValue = floatSettings.a;
						var _v1 = $elm$core$String$toFloat(
							A3($elm$core$String$slice, s.g, floatOffset, s.uN));
						if (_v1.$ === 1) {
							return A2(
								$elm$parser$Parser$Advanced$Bad,
								true,
								A2($elm$parser$Parser$Advanced$fromState, s, invalid));
						} else {
							var n = _v1.a;
							return A3(
								$elm$parser$Parser$Advanced$Good,
								true,
								toValue(n),
								A2($elm$parser$Parser$Advanced$bumpOffset, floatOffset, s));
						}
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$number = function (c) {
	return function (s) {
		if (A3($elm$parser$Parser$Advanced$isAsciiCode, 48, s.g, s.uN)) {
			var zeroOffset = s.g + 1;
			var baseOffset = zeroOffset + 1;
			return A3($elm$parser$Parser$Advanced$isAsciiCode, 120, zeroOffset, s.uN) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.sM,
				c.ahE,
				baseOffset,
				A2($elm$parser$Parser$Advanced$consumeBase16, baseOffset, s.uN),
				s) : (A3($elm$parser$Parser$Advanced$isAsciiCode, 111, zeroOffset, s.uN) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.sM,
				c.X9,
				baseOffset,
				A3($elm$parser$Parser$Advanced$consumeBase, 8, baseOffset, s.uN),
				s) : (A3($elm$parser$Parser$Advanced$isAsciiCode, 98, zeroOffset, s.uN) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.sM,
				c.MJ,
				baseOffset,
				A3($elm$parser$Parser$Advanced$consumeBase, 2, baseOffset, s.uN),
				s) : A6(
				$elm$parser$Parser$Advanced$finalizeFloat,
				c.sM,
				c.RV,
				c.T6,
				c.SA,
				_Utils_Tuple2(zeroOffset, 0),
				s)));
		} else {
			return A6(
				$elm$parser$Parser$Advanced$finalizeFloat,
				c.sM,
				c.RV,
				c.T6,
				c.SA,
				A3($elm$parser$Parser$Advanced$consumeBase, 10, s.g, s.uN),
				s);
		}
	};
};
var $elm$parser$Parser$Advanced$int = F2(
	function (expecting, invalid) {
		return $elm$parser$Parser$Advanced$number(
			{
				MJ: $elm$core$Result$Err(invalid),
				RV: expecting,
				SA: $elm$core$Result$Err(invalid),
				ahE: $elm$core$Result$Err(invalid),
				T6: $elm$core$Result$Ok($elm$core$Basics$identity),
				sM: invalid,
				X9: $elm$core$Result$Err(invalid)
			});
	});
var $elm$parser$Parser$int = A2($elm$parser$Parser$Advanced$int, $elm$parser$Parser$ExpectingInt, $elm$parser$Parser$ExpectingInt);
var $hecrj$html_parser$Html$Parser$numericCharacterReference = function () {
	var codepoint = $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompIf(
						function (c) {
							return (c === 'x') || (c === 'X');
						})),
				$hecrj$html_parser$Html$Parser$hexadecimal),
				A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq('0'))),
				$elm$parser$Parser$int)
			]));
	return A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq('#'))),
		A2(
			$elm$parser$Parser$map,
			A2($elm$core$Basics$composeR, $elm$core$Char$fromCode, $elm$core$String$fromChar),
			codepoint));
}();
var $hecrj$html_parser$Html$Parser$characterReference = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('&'))),
	$elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$backtrackable($hecrj$html_parser$Html$Parser$namedCharacterReference),
				$hecrj$html_parser$Html$Parser$chompSemicolon),
				A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$backtrackable($hecrj$html_parser$Html$Parser$numericCharacterReference),
				$hecrj$html_parser$Html$Parser$chompSemicolon),
				$elm$parser$Parser$succeed('&')
			])));
var $hecrj$html_parser$Html$Parser$tagAttributeQuotedValue = function (quote) {
	var isQuotedValueChar = function (c) {
		return (!_Utils_eq(c, quote)) && (c !== '&');
	};
	return A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq(quote))),
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$map,
				$elm$core$String$join(''),
				$hecrj$html_parser$Html$Parser$many(
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$elm$parser$Parser$getChompedString(
								$hecrj$html_parser$Html$Parser$chompOneOrMore(isQuotedValueChar)),
								$hecrj$html_parser$Html$Parser$characterReference
							])))),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq(quote))));
};
var $hecrj$html_parser$Html$Parser$oneOrMore = F2(
	function (type_, parser_) {
		return A2(
			$elm$parser$Parser$loop,
			_List_Nil,
			function (list) {
				return $elm$parser$Parser$oneOf(
					_List_fromArray(
						[
							A2(
							$elm$parser$Parser$map,
							function (_new) {
								return $elm$parser$Parser$Loop(
									A2($elm$core$List$cons, _new, list));
							},
							parser_),
							$elm$core$List$isEmpty(list) ? $elm$parser$Parser$problem('expecting at least one ' + type_) : $elm$parser$Parser$succeed(
							$elm$parser$Parser$Done(
								$elm$core$List$reverse(list)))
						]));
			});
	});
var $hecrj$html_parser$Html$Parser$tagAttributeUnquotedValue = function () {
	var isUnquotedValueChar = function (c) {
		return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && ((c !== '\"') && ((c !== '\'') && ((c !== '=') && ((c !== '<') && ((c !== '>') && ((c !== '`') && (c !== '&')))))));
	};
	return A2(
		$elm$parser$Parser$map,
		$elm$core$String$join(''),
		A2(
			$hecrj$html_parser$Html$Parser$oneOrMore,
			'attribute value',
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$getChompedString(
						$hecrj$html_parser$Html$Parser$chompOneOrMore(isUnquotedValueChar)),
						$hecrj$html_parser$Html$Parser$characterReference
					]))));
}();
var $hecrj$html_parser$Html$Parser$tagAttributeValue = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('='))),
				$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$hecrj$html_parser$Html$Parser$tagAttributeUnquotedValue,
						$hecrj$html_parser$Html$Parser$tagAttributeQuotedValue('\"'),
						$hecrj$html_parser$Html$Parser$tagAttributeQuotedValue('\'')
					]))),
			$elm$parser$Parser$succeed('')
		]));
var $hecrj$html_parser$Html$Parser$tagAttribute = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Tuple$pair),
		A2(
			$elm$parser$Parser$ignorer,
			$hecrj$html_parser$Html$Parser$tagAttributeName,
			$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter))),
	A2(
		$elm$parser$Parser$ignorer,
		$hecrj$html_parser$Html$Parser$tagAttributeValue,
		$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)));
var $hecrj$html_parser$Html$Parser$tagAttributes = $hecrj$html_parser$Html$Parser$many($hecrj$html_parser$Html$Parser$tagAttribute);
var $hecrj$html_parser$Html$Parser$tagName = A2(
	$elm$parser$Parser$map,
	$elm$core$String$toLower,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$chompIf($elm$core$Char$isAlphaNum),
			$elm$parser$Parser$chompWhile(
				function (c) {
					return $elm$core$Char$isAlphaNum(c) || (c === '-');
				}))));
var $hecrj$html_parser$Html$Parser$Text = function (a) {
	return {$: 0, a: a};
};
var $hecrj$html_parser$Html$Parser$text = A2(
	$elm$parser$Parser$map,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$String$join(''),
		$hecrj$html_parser$Html$Parser$Text),
	A2(
		$hecrj$html_parser$Html$Parser$oneOrMore,
		'text element',
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$getChompedString(
					$hecrj$html_parser$Html$Parser$chompOneOrMore(
						function (c) {
							return (c !== '<') && (c !== '&');
						})),
					$hecrj$html_parser$Html$Parser$characterReference
				]))));
function $hecrj$html_parser$Html$Parser$cyclic$node() {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$hecrj$html_parser$Html$Parser$text,
				$hecrj$html_parser$Html$Parser$comment,
				$hecrj$html_parser$Html$Parser$cyclic$element()
			]));
}
function $hecrj$html_parser$Html$Parser$cyclic$element() {
	return A2(
		$elm$parser$Parser$andThen,
		function (_v0) {
			var name = _v0.a;
			var attributes = _v0.b;
			return $hecrj$html_parser$Html$Parser$isVoidElement(name) ? A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A3($hecrj$html_parser$Html$Parser$Element, name, attributes, _List_Nil)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$elm$parser$Parser$chompIf(
								$elm$core$Basics$eq('/')),
								$elm$parser$Parser$succeed(0)
							]))),
				$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq('>'))) : A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A2($hecrj$html_parser$Html$Parser$Element, name, attributes)),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('>'))),
				A2(
					$elm$parser$Parser$ignorer,
					$hecrj$html_parser$Html$Parser$many(
						$elm$parser$Parser$backtrackable(
							$hecrj$html_parser$Html$Parser$cyclic$node())),
					$hecrj$html_parser$Html$Parser$closingTag(name)));
		},
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Tuple$pair),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('<'))),
				A2(
					$elm$parser$Parser$ignorer,
					$hecrj$html_parser$Html$Parser$tagName,
					$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter))),
			$hecrj$html_parser$Html$Parser$tagAttributes));
}
var $hecrj$html_parser$Html$Parser$node = $hecrj$html_parser$Html$Parser$cyclic$node();
$hecrj$html_parser$Html$Parser$cyclic$node = function () {
	return $hecrj$html_parser$Html$Parser$node;
};
var $hecrj$html_parser$Html$Parser$element = $hecrj$html_parser$Html$Parser$cyclic$element();
$hecrj$html_parser$Html$Parser$cyclic$element = function () {
	return $hecrj$html_parser$Html$Parser$element;
};
var $hecrj$html_parser$Html$Parser$run = function (str) {
	return $elm$core$String$isEmpty(str) ? $elm$core$Result$Ok(_List_Nil) : A2(
		$elm$parser$Parser$run,
		A2($hecrj$html_parser$Html$Parser$oneOrMore, 'node', $hecrj$html_parser$Html$Parser$node),
		str);
};
var $hecrj$html_parser$Html$Parser$Util$toAttribute = function (_v0) {
	var name = _v0.a;
	var value = _v0.b;
	return A2($elm$html$Html$Attributes$attribute, name, value);
};
var $hecrj$html_parser$Html$Parser$Util$toVirtualDom = function (nodes) {
	return A2($elm$core$List$map, $hecrj$html_parser$Html$Parser$Util$toVirtualDomEach, nodes);
};
var $hecrj$html_parser$Html$Parser$Util$toVirtualDomEach = function (node) {
	switch (node.$) {
		case 1:
			var name = node.a;
			var attrs = node.b;
			var children = node.c;
			return A3(
				$elm$html$Html$node,
				name,
				A2($elm$core$List$map, $hecrj$html_parser$Html$Parser$Util$toAttribute, attrs),
				$hecrj$html_parser$Html$Parser$Util$toVirtualDom(children));
		case 0:
			var s = node.a;
			return $elm$html$Html$text(s);
		default:
			return $elm$html$Html$text('');
	}
};
var $author$project$Utils$Dom$textToHtml = function (htmlString) {
	var _v0 = $hecrj$html_parser$Html$Parser$run(htmlString);
	if (!_v0.$) {
		var nodes = _v0.a;
		return $hecrj$html_parser$Html$Parser$Util$toVirtualDom(nodes);
	} else {
		return _List_Nil;
	}
};
var $author$project$Ui$Form$Textarea$Value = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Form$Textarea$value = $author$project$Ui$Form$Textarea$Value;
var $author$project$Components$TranslatedRichText$LanguageSelected = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Icon$Translate = 69;
var $author$project$Ui$Icon$translate = $author$project$Ui$Icon$viewIcon(69);
var $author$project$Components$TranslatedRichText$viewLanguageDropdown = F2(
	function (currentLanguage, dropdown) {
		var languageToItem = function (lang) {
			return A2(
				$author$project$Ui$Dropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$Dropdown$selected(
						_Utils_eq(lang, currentLanguage)),
						$author$project$Ui$Dropdown$onSelect(
						$author$project$Components$TranslatedRichText$LanguageSelected(lang))
					]),
				$elm$html$Html$text(
					$author$project$Language$toLabel(lang)));
		};
		var items = A2(
			$elm$core$List$map,
			languageToItem,
			_List_fromArray(
				[$author$project$Language$english, $author$project$Language$spanish]));
		return A3(
			$author$project$Ui$Element$custom,
			'absolute top-2 right-2 z-50 flex items-center',
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mr2]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$label,
							_List_fromArray(
								[$author$project$Ui$Typography$hintLabel]),
							_List_fromArray(
								[
									$author$project$Ui$Icon$translate(_List_Nil),
									$elm$html$Html$text('\u00A0'),
									$elm$html$Html$text('Now editing')
								]))
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							A4(
							$author$project$Ui$Dropdown$viewSelect,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pr-2')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Language$toLabel(currentLanguage))
										]))
								]),
							items,
							dropdown)
						]))
				]));
	});
var $author$project$Components$TranslatedRichText$view = F2(
	function (config, model) {
		var groupArgs = _Utils_ap(
			config.aja ? _List_fromArray(
				[
					$author$project$Ui$Form$Group$offsetLabel,
					$author$project$Ui$Form$Group$labelSpanSm(5),
					$author$project$Ui$Form$Group$inputSpanSm(6),
					$author$project$Ui$Form$Group$label('Plan Description'),
					$author$project$Ui$Form$Group$labelClass('')
				]) : _List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8),
					$author$project$Ui$Form$Group$label(config.aih)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$required(config.akR)
				]));
		return A2(
			$author$project$Ui$Form$Group$view,
			groupArgs,
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Element$custom,
					'relative',
					_List_Nil,
					function () {
						var currentDescription = A2(
							$elm$core$Dict$get,
							$author$project$Language$toValue(model.f4),
							model.adD);
						return _List_fromArray(
							[
								function () {
								if (model.gC) {
									return $author$project$Ui$Form$Textarea$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Textarea$rows(10),
												$author$project$Ui$Form$Textarea$id(config.agG),
												$author$project$Ui$Form$Textarea$value(
												A2($elm$core$Maybe$withDefault, '', currentDescription))
											]));
								} else {
									var fallbackDescription = function () {
										var _v1 = A2($elm$core$Maybe$andThen, $author$project$Utils$String$toMaybe, currentDescription);
										if (_v1.$ === 1) {
											return A2($elm$core$Dict$get, 'es', model.adD);
										} else {
											return currentDescription;
										}
									}();
									return A2(
										$author$project$Ui$Element$view,
										_List_Nil,
										_List_fromArray(
											[
												function () {
												if (!fallbackDescription.$) {
													var desc = fallbackDescription.a;
													return A2(
														$author$project$Ui$Element$view,
														_List_Nil,
														_List_fromArray(
															[
																A3(
																$author$project$Ui$Button$view,
																{mm: 'Edit ' + config.aih},
																_List_fromArray(
																	[
																		$author$project$Ui$Button$link,
																		$author$project$Ui$Button$onClick($author$project$Components$TranslatedRichText$EditToggled)
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Edit')
																	])),
																A2(
																$author$project$Ui$Element$view,
																_List_Nil,
																A2(
																	$elm$core$List$map,
																	$elm$html$Html$map($elm$core$Basics$never),
																	$author$project$Utils$Dom$textToHtml(desc)))
															]));
												} else {
													return A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('flex items-center gap-x-2')
															]),
														_List_fromArray(
															[
																A3(
																$author$project$Ui$Button$view,
																{mm: 'Edit ' + config.aih},
																_List_fromArray(
																	[
																		$author$project$Ui$Button$link,
																		$author$project$Ui$Button$onClick($author$project$Components$TranslatedRichText$EditToggled)
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Edit')
																	])),
																A2(
																$author$project$Ui$Typography$text,
																_List_fromArray(
																	[$author$project$Ui$Typography$muted]),
																'No description')
															]));
												}
											}()
											]));
								}
							}(),
								model.gC ? A2($author$project$Components$TranslatedRichText$viewLanguageDropdown, model.f4, model.gi) : $elm$html$Html$text('')
							]);
					}()),
					$author$project$Utils$FormErrors$view(config.agX),
					function () {
					var _v2 = _Utils_Tuple2(model.gC, config.ahD);
					if (_v2.a && (!_v2.b.$)) {
						var helperText = _v2.b.a;
						return A2(
							$author$project$Ui$Typography$p,
							_List_fromArray(
								[$author$project$Ui$Typography$helpBlock]),
							_List_fromArray(
								[
									$elm$html$Html$text(helperText)
								]));
					} else {
						return $elm$html$Html$text('');
					}
				}()
				]));
	});
var $author$project$Ui$Element$gap4 = $author$project$Ui$Element$Gap(4);
var $author$project$Components$Admin$ChargeItems$Form$revenueRecognitionInitialPurchase = 'immediate';
var $author$project$Components$Admin$ChargeItems$Form$RevenueRecognition = function (a) {
	return {$: 25, a: a};
};
var $author$project$Components$Admin$ChargeItems$Form$viewRevenueRecognitionOption = F3(
	function (selectedValue, optionValue, labelText) {
		return A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('radio-inline')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('radio'),
							$elm$html$Html$Attributes$name('revenue-recognition'),
							$elm$html$Html$Attributes$value(optionValue),
							$elm$html$Html$Attributes$checked(
							_Utils_eq(selectedValue, optionValue)),
							$elm$html$Html$Events$onClick(
							$author$project$Components$Admin$ChargeItems$Form$FormUpdated(
								$author$project$Components$Admin$ChargeItems$Form$RevenueRecognition(optionValue)))
						]),
					_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ml-2')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(labelText)
						]))
				]));
	});
var $author$project$Ui$Element$FlexWrap = {$: 12};
var $author$project$Ui$Element$wrap = $author$project$Ui$Element$FlexWrap;
var $author$project$Components$Admin$ChargeItems$Form$viewRevenueRecognition = function (fields) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('Revenue Recognition')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$wrap, $author$project$Ui$Element$gap4, $author$project$Ui$Element$itemsCenter]),
				_List_fromArray(
					[
						A3($author$project$Components$Admin$ChargeItems$Form$viewRevenueRecognitionOption, fields.$0, $author$project$Components$Admin$ChargeItems$Form$revenueRecognitionItemConsumption, 'Upon item consumption (default)'),
						A3($author$project$Components$Admin$ChargeItems$Form$viewRevenueRecognitionOption, fields.$0, $author$project$Components$Admin$ChargeItems$Form$revenueRecognitionInitialPurchase, 'Upon initial purchase')
					]))
			]));
};
var $author$project$Components$Admin$ChargeItems$Form$viewAdvancedSettings = function (fields) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$mt8]),
		_List_fromArray(
			[
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mb2]),
				_List_fromArray(
					[
						$author$project$Ui$Typography$headingSm(
						_List_fromArray(
							[
								$elm$html$Html$text('Advanced Settings')
							]))
					])),
				$author$project$Components$Admin$ChargeItems$Form$viewRevenueRecognition(fields)
			]));
};
var $author$project$Components$Admin$ChargeItems$Form$Buyable = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Admin$ChargeItems$Form$viewBuyableCheckbox = F2(
	function (fields, disable) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Can be Purchased on the Patient Portal')
				]),
			_List_fromArray(
				[
					$author$project$Ui$ToggleSwitch$view(
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$on(fields.MZ),
							$author$project$Ui$ToggleSwitch$onChange(
							A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$Buyable)),
							$author$project$Ui$ToggleSwitch$disabled(disable)
						]))
				]));
	});
var $author$project$Components$ResourceFilter$Disabled = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$ResourceFilter$disabled = $author$project$Components$ResourceFilter$Disabled;
var $author$project$Components$ResourceFilter$Value = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$ResourceFilter$value = $author$project$Components$ResourceFilter$Value;
var $author$project$Components$ResourceFilter$DropdownItemChecked = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$ResourceFilter$DropdownItemSelected = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$ResourceFilter$DropdownSearched = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$ResourceFilter$FreeText = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Dropdown$AriaLabel = function (a) {
	return {$: 6, a: a};
};
var $author$project$Ui$Dropdown$ariaLabel = $author$project$Ui$Dropdown$AriaLabel;
var $author$project$Ui$Dropdown$Checkbox = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Ui$Dropdown$checkbox = $author$project$Ui$Dropdown$Checkbox;
var $author$project$Ui$Dropdown$Item$Checked = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Dropdown$checked = $author$project$Ui$Dropdown$Item$Checked;
var $author$project$Components$ResourceFilter$choiceToTitle = F6(
	function (allLabel, noneLabel, freeTextPrefix, resourceName, toTitle, choice) {
		switch (choice.$) {
			case 2:
				return allLabel;
			case 3:
				return noneLabel;
			case 0:
				var item = choice.a;
				return toTitle(item);
			case 1:
				var items = choice.a;
				var count = $elm$core$List$length(items);
				return A2($author$project$Formatters$String$pluralize, resourceName, count) + ' Selected';
			case 4:
				var extraItem = choice.a;
				return extraItem.aih;
			default:
				var string = choice.a;
				return _Utils_ap(freeTextPrefix, string);
		}
	});
var $elm_community$list_extra$List$Extra$filterNot = F2(
	function (pred, list) {
		return A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, pred),
			list);
	});
var $author$project$Components$ResourceFilter$DropdownLoadedMore = {$: 8};
var $author$project$Ui$Dropdown$Item$OnSelectKeepOpen = {$: 10};
var $author$project$Ui$Dropdown$onSelectKeepOpen = $author$project$Ui$Dropdown$Item$OnSelectKeepOpen;
var $author$project$Ui$Button$Tabindex = function (a) {
	return {$: 17, a: a};
};
var $author$project$Ui$Button$preventFocus = $author$project$Ui$Button$Tabindex(-1);
var $author$project$Components$ResourceFilter$infoItem2 = F3(
	function (items, totalItemsCount, options) {
		if ($elm$core$List$isEmpty(items)) {
			return options.ahG ? _List_Nil : _List_fromArray(
				[
					A2(
					$author$project$Ui$Dropdown$item,
					_List_Nil,
					$elm$html$Html$text('No results found'))
				]);
		} else {
			var _v0 = _Utils_Tuple2(options.JK, totalItemsCount);
			if (_v0.a && (!_v0.b.$)) {
				var totalCount = _v0.b.a;
				var currentCount = $elm$core$List$length(items);
				return (_Utils_cmp(totalCount, currentCount) > 0) ? _List_fromArray(
					[
						A2(
						$author$project$Ui$Dropdown$item,
						_List_fromArray(
							[
								$author$project$Ui$Dropdown$onSelect($author$project$Components$ResourceFilter$DropdownLoadedMore),
								$author$project$Ui$Dropdown$onSelectKeepOpen
							]),
						A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{mm: 'See more'},
									_List_fromArray(
										[$author$project$Ui$Button$link, $author$project$Ui$Button$preventFocus]),
									_List_fromArray(
										[
											$elm$html$Html$text('See '),
											$elm$html$Html$text(
											$elm$core$String$fromInt(options.VZ)),
											$elm$html$Html$text(' more')
										])),
									$elm$html$Html$text(' or type to search')
								])))
					]) : _List_Nil;
			} else {
				return _List_Nil;
			}
		}
	});
var $author$project$Components$ResourceFilter$isChecked = F2(
	function (choice, item) {
		switch (choice.$) {
			case 0:
				var other = choice.a;
				return _Utils_eq(item, other);
			case 1:
				var items = choice.a;
				return A2($elm$core$List$member, item, items);
			default:
				return false;
		}
	});
var $author$project$Ui$Dropdown$Item$OnCheck = function (a) {
	return {$: 6, a: a};
};
var $author$project$Ui$Dropdown$onCheck = $author$project$Ui$Dropdown$Item$OnCheck;
var $author$project$Components$ResourceFilter$Input = 0;
var $author$project$Components$ResourceFilter$defaultOptions = {
	mm: '',
	rF: _List_fromArray(
		['resource-filter']),
	ep: false,
	agX: _List_Nil,
	sM: false,
	V8: false,
	Bn: false,
	JZ: 0,
	aee: $author$project$Components$ResourceFilter$All
};
var $author$project$Components$ResourceFilter$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var value_ = option.a;
						return _Utils_update(
							record,
							{aee: value_});
					case 1:
						var bool = option.a;
						return _Utils_update(
							record,
							{sM: bool});
					case 2:
						var bool = option.a;
						return _Utils_update(
							record,
							{ep: bool});
					case 3:
						var list = option.a;
						return _Utils_update(
							record,
							{agX: list});
					case 4:
						var style_ = option.a;
						return _Utils_update(
							record,
							{JZ: style_});
					case 5:
						var bool = option.a;
						return _Utils_update(
							record,
							{V8: bool});
					case 6:
						return _Utils_update(
							record,
							{Bn: true});
					default:
						var label = option.a;
						return _Utils_update(
							record,
							{mm: label});
				}
			}),
		$author$project$Components$ResourceFilter$defaultOptions,
		options);
};
var $author$project$Components$ResourceFilter$toggleItemSelection = F2(
	function (currentChoice, item) {
		switch (currentChoice.$) {
			case 0:
				var other = currentChoice.a;
				return _Utils_eq(other, item) ? $author$project$Components$ResourceFilter$All : $author$project$Components$ResourceFilter$Many(
					_List_fromArray(
						[other, item]));
			case 1:
				var items = currentChoice.a;
				if (A2($elm$core$List$member, item, items)) {
					var remainingItems = A2(
						$elm$core$List$filter,
						$elm$core$Basics$neq(item),
						items);
					if (!remainingItems.b) {
						return $author$project$Components$ResourceFilter$All;
					} else {
						if (!remainingItems.b.b) {
							var singleItem = remainingItems.a;
							return $author$project$Components$ResourceFilter$One(singleItem);
						} else {
							return $author$project$Components$ResourceFilter$Many(remainingItems);
						}
					}
				} else {
					return $author$project$Components$ResourceFilter$Many(
						A2($elm$core$List$cons, item, items));
				}
			case 3:
				return $author$project$Components$ResourceFilter$One(item);
			case 2:
				return $author$project$Components$ResourceFilter$One(item);
			case 4:
				return $author$project$Components$ResourceFilter$One(item);
			default:
				return $author$project$Components$ResourceFilter$One(item);
		}
	});
var $author$project$Components$ResourceFilter$view = F2(
	function (options, model) {
		var toLabel_ = function (choice) {
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-full')
					]),
				A2(
					$elm$core$List$map,
					$elm$html$Html$map($elm$core$Basics$never),
					model.GY(choice)));
		};
		var optionsRecord = $author$project$Components$ResourceFilter$optionsToRecord(options);
		var items = function () {
			var _v0 = model.bu;
			if (!_v0.$) {
				var list = _v0.a;
				var apiItemsValues = A2($elm$core$List$map, model.hX, list);
				return A2(
					$elm$core$List$cons,
					$author$project$Ui$Dropdown$input(
						_List_fromArray(
							[
								$author$project$Ui$Dropdown$onInput($author$project$Components$ResourceFilter$DropdownSearched),
								$author$project$Ui$Dropdown$value(
								A2($elm$core$Maybe$withDefault, '', model.akl)),
								model.Cd.ahw ? $author$project$Ui$Dropdown$placeholder('Search or type your own...') : $author$project$Ui$Dropdown$placeholder('Search...'),
								function () {
								if (model.Cd.ahw) {
									return $author$project$Ui$Dropdown$onEnter(
										$author$project$Components$ResourceFilter$DropdownItemSelected(
											$elm$core$Maybe$Just(
												$author$project$Components$ResourceFilter$FreeText(
													A2($elm$core$Maybe$withDefault, '', model.akl)))));
								} else {
									if (list.b) {
										var x = list.a;
										return $author$project$Ui$Dropdown$onEnter(
											$author$project$Components$ResourceFilter$DropdownItemSelected(
												$elm$core$Maybe$Just(
													$author$project$Components$ResourceFilter$One(x))));
									} else {
										return $author$project$Ui$Dropdown$placeholder('Search...');
									}
								}
							}()
							])),
					A2(
						$elm$core$List$cons,
						$author$project$Ui$Dropdown$separator,
						_Utils_ap(
							function (allAndNone) {
								if (!allAndNone.b) {
									return _List_Nil;
								} else {
									return _Utils_ap(
										allAndNone,
										_List_fromArray(
											[$author$project$Ui$Dropdown$separator]));
								}
							}(
								A2(
									$elm$core$List$map,
									function (_v2) {
										var label = _v2.a;
										var choice = _v2.b;
										return A2(
											$author$project$Ui$Dropdown$item,
											_List_fromArray(
												[
													$author$project$Ui$Dropdown$selected(
													_Utils_eq(optionsRecord.aee, choice)),
													$author$project$Ui$Dropdown$onSelect(
													$author$project$Components$ResourceFilter$DropdownItemSelected(
														$elm$core$Maybe$Just(choice)))
												]),
											$elm$html$Html$text(label));
									},
									A2(
										$elm$core$List$map,
										$elm$core$Tuple$second,
										A2(
											$elm$core$List$filter,
											$elm$core$Tuple$first,
											_List_fromArray(
												[
													_Utils_Tuple2(
													model.Cd.Lr,
													_Utils_Tuple2(model.Cd.Gp, $author$project$Components$ResourceFilter$All)),
													_Utils_Tuple2(
													model.Cd.ai5,
													_Utils_Tuple2(model.Cd.XY, $author$project$Components$ResourceFilter$None))
												]))))),
							_Utils_ap(
								function () {
									var _v4 = optionsRecord.aee;
									if (_v4.$ === 5) {
										var string = _v4.a;
										return _List_fromArray(
											[
												A2(
												$author$project$Ui$Dropdown$item,
												_List_fromArray(
													[
														$author$project$Ui$Dropdown$selected(
														_Utils_eq(
															optionsRecord.aee,
															$author$project$Components$ResourceFilter$FreeText(string))),
														$author$project$Ui$Dropdown$onSelect(
														$author$project$Components$ResourceFilter$DropdownItemSelected(
															$elm$core$Maybe$Just(
																$author$project$Components$ResourceFilter$FreeText(string))))
													]),
												$elm$html$Html$text(string))
											]);
									} else {
										return _List_Nil;
									}
								}(),
								_Utils_ap(
									function () {
										var _v5 = _Utils_Tuple2(model.Cd.ahw, model.akl);
										_v5$2:
										while (true) {
											if (!_v5.b.$) {
												if (_v5.b.a === '') {
													return _List_Nil;
												} else {
													if (_v5.a) {
														var string = _v5.b.a;
														return _Utils_eq(
															optionsRecord.aee,
															$author$project$Components$ResourceFilter$FreeText(string)) ? _List_Nil : _List_fromArray(
															[
																A2(
																$author$project$Ui$Dropdown$item,
																_List_fromArray(
																	[
																		$author$project$Ui$Dropdown$onSelect(
																		$author$project$Components$ResourceFilter$DropdownItemSelected(
																			$elm$core$Maybe$Just(
																				$author$project$Components$ResourceFilter$FreeText(string))))
																	]),
																$elm$html$Html$text('Select \"' + (string + '\"')))
															]);
													} else {
														break _v5$2;
													}
												}
											} else {
												break _v5$2;
											}
										}
										return _List_Nil;
									}(),
									_Utils_ap(
										A2(
											$elm$core$List$map,
											function (item) {
												return optionsRecord.Bn ? A2(
													$author$project$Ui$Dropdown$checkbox,
													_List_fromArray(
														[
															$author$project$Ui$Dropdown$checked(
															A2($author$project$Components$ResourceFilter$isChecked, optionsRecord.aee, item)),
															$author$project$Ui$Dropdown$onCheck(
															$elm$core$Basics$always(
																$author$project$Components$ResourceFilter$DropdownItemChecked(
																	A2($author$project$Components$ResourceFilter$toggleItemSelection, optionsRecord.aee, item))))
														]),
													toLabel_(
														$author$project$Components$ResourceFilter$One(item))) : A2(
													$author$project$Ui$Dropdown$item,
													_List_fromArray(
														[
															$author$project$Ui$Dropdown$selected(
															_Utils_eq(
																optionsRecord.aee,
																$author$project$Components$ResourceFilter$One(item))),
															$author$project$Ui$Dropdown$onSelect(
															$author$project$Components$ResourceFilter$DropdownItemSelected(
																$elm$core$Maybe$Just(
																	$author$project$Components$ResourceFilter$One(item))))
														]),
													toLabel_(
														$author$project$Components$ResourceFilter$One(item)));
											},
											list),
										_Utils_ap(
											A2(
												$elm$core$List$map,
												function (item) {
													return A2(
														$author$project$Ui$Dropdown$item,
														_List_fromArray(
															[
																$author$project$Ui$Dropdown$selected(
																_Utils_eq(
																	optionsRecord.aee,
																	$author$project$Components$ResourceFilter$Extra(item))),
																$author$project$Ui$Dropdown$onSelect(
																$author$project$Components$ResourceFilter$DropdownItemSelected(
																	$elm$core$Maybe$Just(
																		$author$project$Components$ResourceFilter$Extra(item))))
															]),
														toLabel_(
															$author$project$Components$ResourceFilter$Extra(item)));
												},
												A2(
													$elm_community$list_extra$List$Extra$filterNot,
													function (extraItem) {
														return A2($elm$core$List$member, extraItem.aee, apiItemsValues);
													},
													model.gq)),
											A3($author$project$Components$ResourceFilter$infoItem2, list, model.vc, model.Cd))))))));
			} else {
				return _List_Nil;
			}
		}();
		var choiceToTitle_ = A5($author$project$Components$ResourceFilter$choiceToTitle, model.Cd.Gp, model.Cd.XY, model.Cd.ahx, model.k$, model.lN);
		return A4(
			$author$project$Ui$Dropdown$viewSelect,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$disabled(optionsRecord.ep),
					$author$project$Ui$Dropdown$errors(optionsRecord.agX),
					$author$project$Ui$Dropdown$invalid(optionsRecord.sM),
					$author$project$Ui$Dropdown$ariaLabel(optionsRecord.mm)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					choiceToTitle_(optionsRecord.aee))
				]),
			items,
			model.gi);
	});
var $author$project$Components$ResourceFilter$Category$view = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$view,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.Jy),
					options),
				model.b8));
	});
var $author$project$Components$Admin$ChargeItems$Form$viewCategoryInput = F2(
	function (categoryResourceFilter, disabled) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Category')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Components$Admin$ChargeItems$Form$CategoryResourceFilterMsg,
					A2(
						$author$project$Components$ResourceFilter$Category$view,
						_List_fromArray(
							[
								$author$project$Components$ResourceFilter$disabled(disabled)
							]),
						categoryResourceFilter))
				]));
	});
var $author$project$Components$Admin$ChargeItems$Form$Code = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Admin$ChargeItems$Form$CodeTypeSelected = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Admin$ChargeItems$Form$viewCodeInput = F4(
	function (fields, form, codeTypeDropdown, disabled) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Code')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(8)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(fields.NN),
											$author$project$Ui$Form$Input$onInput(
											A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$Code)),
											$author$project$Ui$Form$Input$invalid(
											A2($author$project$Utils$Form$hasValidationErrors, 4, form)),
											$author$project$Ui$Form$Input$errors(
											A2($author$project$Utils$Form$validationErrors, 4, form)),
											$author$project$Ui$Form$Input$disabled(disabled)
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(4)
								]),
							_List_fromArray(
								[
									function () {
									var items = A2(
										$elm$core$List$map,
										function (_v2) {
											var codeTypeId = _v2.a;
											var label = _v2.b;
											return A2(
												$author$project$Ui$Dropdown$item,
												_List_fromArray(
													[
														$author$project$Ui$Dropdown$onSelect(
														$author$project$Components$Admin$ChargeItems$Form$CodeTypeSelected(
															$elm$core$Maybe$Just(codeTypeId))),
														$author$project$Ui$Dropdown$selected(
														_Utils_eq(
															fields.NP,
															$elm$core$Maybe$Just(codeTypeId)))
													]),
												$elm$html$Html$text(label));
										},
										$author$project$Formatters$ChargeItemCode$codeTypes);
									var currentLabel = function () {
										var _v0 = fields.NP;
										if (!_v0.$) {
											var codeType = _v0.a;
											return A2(
												$elm$core$Maybe$withDefault,
												'Code Type',
												A2(
													$elm$core$Maybe$map,
													$elm$core$Tuple$second,
													$elm$core$List$head(
														A2(
															$elm$core$List$filter,
															function (_v1) {
																var id = _v1.a;
																return _Utils_eq(id, codeType);
															},
															$author$project$Formatters$ChargeItemCode$codeTypes))));
										} else {
											return 'Code Type';
										}
									}();
									return A4(
										$author$project$Ui$Dropdown$viewSelect,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(currentLabel)
											]),
										items,
										codeTypeDropdown);
								}()
								]))
						]))
				]));
	});
var $author$project$Components$Admin$ChargeItems$Form$DaysSupply = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Admin$ChargeItems$Form$viewDaysSupplyInput = F2(
	function (fields, disabled) {
		return $author$project$Utils$Uom$isTimeBased(fields.adP) ? $author$project$Utils$Html$empty : A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Days Supply')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(4)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$number,
											$author$project$Ui$Form$Input$value(
											A2(
												$elm$core$Maybe$withDefault,
												'',
												A2($elm$core$Maybe$map, $elm$core$String$fromInt, fields.PL))),
											$author$project$Ui$Form$Input$onInput(
											A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$DaysSupply)),
											$author$project$Ui$Form$Input$disabled(disabled)
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Admin$ChargeItems$Form$Description = function (a) {
	return {$: 10, a: a};
};
var $author$project$Ui$Form$Textarea$Disabled = function (a) {
	return {$: 9, a: a};
};
var $author$project$Ui$Form$Textarea$disabled = $author$project$Ui$Form$Textarea$Disabled;
var $author$project$Ui$Form$Textarea$OnInput = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Form$Textarea$onInput = $author$project$Ui$Form$Textarea$OnInput;
var $author$project$Ui$Form$Textarea$Placeholder = function (a) {
	return {$: 8, a: a};
};
var $author$project$Ui$Form$Textarea$placeholder = $author$project$Ui$Form$Textarea$Placeholder;
var $author$project$Components$Admin$ChargeItems$Form$viewDescriptionInput = F3(
	function (label, fields, disabled) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label(label)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Textarea$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Textarea$value(
							A2($elm$core$Maybe$withDefault, '', fields.Qr)),
							$author$project$Ui$Form$Textarea$phi(true),
							$author$project$Ui$Form$Textarea$placeholder('Additional details for receipt'),
							$author$project$Ui$Form$Textarea$onInput(
							A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$Description)),
							$author$project$Ui$Form$Textarea$disabled(disabled)
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$helpBlock]),
					_List_fromArray(
						[
							$elm$html$Html$text('Additional detail that will appear on both printed and emailed receipts (e.g. ICD-10 Codes)')
						]))
				]));
	});
var $author$project$Components$Admin$ChargeItems$Form$ExpirationNumber = function (a) {
	return {$: 23, a: a};
};
var $author$project$Components$Admin$ChargeItems$Form$ExpirationUnit = function (a) {
	return {$: 24, a: a};
};
var $author$project$Components$Admin$ChargeItems$Form$SetExpirationType = function (a) {
	return {$: 22, a: a};
};
var $author$project$Ui$Form$Input$CustomAttributes = function (a) {
	return {$: 23, a: a};
};
var $author$project$Ui$Form$Input$customAttributes = $author$project$Ui$Form$Input$CustomAttributes;
var $author$project$Components$DateInput$Disabled = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$DateInput$disabled = $author$project$Components$DateInput$Disabled;
var $author$project$Ui$Form$Radio$Disabled = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Form$Radio$disabled = $author$project$Ui$Form$Radio$Disabled;
var $author$project$Utils$Date$isAfter = F2(
	function (date, otherDate) {
		return A2($justinmimbs$date$Date$compare, date, otherDate) === 2;
	});
var $elm$html$Html$Attributes$min = $elm$html$Html$Attributes$stringProperty('min');
var $author$project$Ui$Element$pl5 = $author$project$Ui$Element$Padding('pl-5');
var $author$project$Ui$Element$Width = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Element$w12 = $author$project$Ui$Element$Width('w-12');
var $author$project$Ui$Element$w32 = $author$project$Ui$Element$Width('w-32');
var $author$project$Ui$Element$w40 = $author$project$Ui$Element$Width('w-40');
var $author$project$Components$Admin$ChargeItems$Form$viewExpirationSection = F4(
	function (model, fields, form, disable) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Expiration')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Radio$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Radio$value(!fields.ag),
							$author$project$Ui$Form$Radio$onCheck(
							function (_v0) {
								return $author$project$Components$Admin$ChargeItems$Form$FormUpdated(
									$author$project$Components$Admin$ChargeItems$Form$SetExpirationType(0));
							}),
							$author$project$Ui$Form$Radio$disabled(disable)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Don\'t expire')
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mt1]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Radio$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Radio$value(fields.ag === 2),
											$author$project$Ui$Form$Radio$onCheck(
											function (_v1) {
												return $author$project$Components$Admin$ChargeItems$Form$FormUpdated(
													$author$project$Components$Admin$ChargeItems$Form$SetExpirationType(2));
											}),
											$author$project$Ui$Form$Radio$disabled(disable)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Package will expire on')
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$inlineBlock, $author$project$Ui$Element$w40]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$map,
											$author$project$Components$Admin$ChargeItems$Form$ExpirationDatePickerMsg,
											A2(
												$author$project$Components$DateInput$view,
												_List_fromArray(
													[
														$author$project$Components$DateInput$value(fields.RW),
														$author$project$Components$DateInput$disabled(disable || (fields.ag !== 2)),
														$author$project$Components$DateInput$invalid(
														A2($author$project$Utils$Form$hasValidationErrors, 6, form)),
														$author$project$Components$DateInput$disabledPickerDates(
														function (date) {
															var _v2 = model.FR;
															if (!_v2.$) {
																var today = _v2.a;
																return !A2($author$project$Utils$Date$isAfter, date, today);
															} else {
																return false;
															}
														})
													]),
												model.sj))
										]))
								]))
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mt1]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Radio$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Radio$value(fields.ag === 1),
											$author$project$Ui$Form$Radio$onCheck(
											function (_v3) {
												return $author$project$Components$Admin$ChargeItems$Form$FormUpdated(
													$author$project$Components$Admin$ChargeItems$Form$SetExpirationType(1));
											}),
											$author$project$Ui$Form$Radio$disabled(disable)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Expires after')
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$inlineBlock, $author$project$Ui$Element$w12]),
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$value(fields.RX),
													$author$project$Ui$Form$Input$onInput(
													A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$ExpirationNumber)),
													$author$project$Ui$Form$Input$onBlur(
													$author$project$Components$Admin$ChargeItems$Form$FormUpdated(
														$author$project$Components$Admin$ChargeItems$Form$ExpirationNumber(
															((fields.RX === '') || (fields.RX === '0')) ? '1' : fields.RX))),
													$author$project$Ui$Form$Input$disabled(disable || (fields.ag !== 1)),
													$author$project$Ui$Form$Input$number,
													$author$project$Ui$Form$Input$customAttributes(
													_List_fromArray(
														[
															$elm$html$Html$Attributes$min('1')
														]))
												]))
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$inlineBlock, $author$project$Ui$Element$w32]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Select$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Select$value(
													$elm$core$Maybe$Just(fields.RY)),
													$author$project$Ui$Form$Select$onChange(
													function (unit) {
														return $author$project$Components$Admin$ChargeItems$Form$FormUpdated(
															$author$project$Components$Admin$ChargeItems$Form$ExpirationUnit(
																$elm$core$Maybe$Just(unit)));
													}),
													$author$project$Ui$Form$Select$disabled(disable || (fields.ag !== 1))
												]),
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Form$Select$option,
													_List_Nil,
													$elm$core$Maybe$Just('days'),
													'Days'),
													A3(
													$author$project$Ui$Form$Select$option,
													_List_Nil,
													$elm$core$Maybe$Just('weeks'),
													'Weeks'),
													A3(
													$author$project$Ui$Form$Select$option,
													_List_Nil,
													$elm$core$Maybe$Just('months'),
													'Months'),
													A3(
													$author$project$Ui$Form$Select$option,
													_List_Nil,
													$elm$core$Maybe$Just('years'),
													'Years')
												]))
										])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('from purchase date')
										]))
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$mt1]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$pl5]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[$author$project$Ui$Typography$helpBlock]),
											'Package will expire for patients ' + (fields.RX + (' ' + (((fields.RX === '1') ? A2($elm$core$String$dropRight, 1, fields.RY) : fields.RY) + ' after the date of purchase.'))))
										]))
								]))
						])),
					$author$project$Utils$FormErrors$view(
					A2($author$project$Utils$Form$validationErrors, 6, form))
				]));
	});
var $author$project$Ui$Form$File$Image = 0;
var $author$project$Components$Admin$ChargeItems$Form$ImageUploaded = function (a) {
	return {$: 11, a: a};
};
var $author$project$Ui$Form$File$Accept = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$File$accept = $author$project$Ui$Form$File$Accept;
var $author$project$Ui$Image$fromSrc = $author$project$Ui$Image$viewImg;
var $author$project$Ui$Form$File$OnInput = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Form$File$onInput = $author$project$Ui$Form$File$OnInput;
var $elm$html$Html$Attributes$accept = $elm$html$Html$Attributes$stringProperty('accept');
var $author$project$Ui$Form$File$acceptedToString = function (accepted) {
	switch (accepted) {
		case 1:
			return '.csv';
		case 0:
			return 'image/*';
		case 2:
			return 'application/pdf';
		case 3:
			return '.txt';
		case 4:
			return '.zip';
		default:
			return 'application/xml';
	}
};
var $elm$file$File$decoder = _File_decoder;
var $author$project$Ui$Form$File$filesDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'files']),
	$elm$json$Json$Decode$list($elm$file$File$decoder));
var $elm$html$Html$Attributes$multiple = $elm$html$Html$Attributes$boolProperty('multiple');
var $author$project$Ui$Form$File$defaultOptions = {
	Kz: _List_Nil,
	xs: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('button')
		]),
	ze: false,
	ep: false,
	zs: false,
	sI: false,
	At: $elm$core$Maybe$Nothing,
	Bo: false,
	ajm: $elm$core$Maybe$Nothing
};
var $author$project$Ui$Form$File$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var bool = option.a;
						return _Utils_update(
							record,
							{ep: bool});
					case 1:
						var accepted = option.a;
						return _Utils_update(
							record,
							{
								Kz: A2($elm$core$List$cons, accepted, record.Kz)
							});
					case 2:
						var bool = option.a;
						return _Utils_update(
							record,
							{Bo: bool});
					case 3:
						var toMsg = option.a;
						return _Utils_update(
							record,
							{
								ajm: $elm$core$Maybe$Just(toMsg)
							});
					case 4:
						var bool = option.a;
						return _Utils_update(
							record,
							{zs: bool});
					case 5:
						var bool = option.a;
						return _Utils_update(
							record,
							{ze: bool});
					case 6:
						return _Utils_update(
							record,
							{
								xs: _List_fromArray(
									[
										$elm$html$Html$Attributes$class('sr-only'),
										$elm$html$Html$Attributes$tabindex(-1)
									])
							});
					case 7:
						return _Utils_update(
							record,
							{sI: true});
					default:
						var k = option.a;
						return _Utils_update(
							record,
							{
								At: $elm$core$Maybe$Just(k)
							});
				}
			}),
		$author$project$Ui$Form$File$defaultOptions,
		options);
};
var $author$project$Ui$Form$File$view = function (options) {
	var optionsRecord = $author$project$Ui$Form$File$optionsToRecord(options);
	return function (input) {
		var _v1 = optionsRecord.At;
		if (!_v1.$) {
			var k = _v1.a;
			return A3(
				$elm$html$Html$Keyed$node,
				'span',
				_List_Nil,
				_List_fromArray(
					[
						_Utils_Tuple2(k, input)
					]));
		} else {
			return input;
		}
	}(
		A2(
			$elm$html$Html$input,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$type_('file'),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$disabled(optionsRecord.ep),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$multiple(optionsRecord.Bo),
						_Utils_ap(
							optionsRecord.ze ? _List_fromArray(
								[
									A2(
									$elm$html$Html$Attributes$property,
									'webkitdirectory',
									$elm$json$Json$Encode$bool(true)),
									A2(
									$elm$html$Html$Attributes$property,
									'directory',
									$elm$json$Json$Encode$bool(true)),
									A2(
									$elm$html$Html$Attributes$property,
									'mozdirectory',
									$elm$json$Json$Encode$bool(true))
								]) : _List_Nil,
							_Utils_ap(
								A2(
									$elm$core$List$map,
									$elm$html$Html$Attributes$map($elm$core$Basics$never),
									optionsRecord.xs),
								_Utils_ap(
									$elm$core$List$isEmpty(optionsRecord.Kz) ? _List_Nil : _List_fromArray(
										[
											$elm$html$Html$Attributes$accept(
											A2(
												$elm$core$String$join,
												',',
												A2($elm$core$List$map, $author$project$Ui$Form$File$acceptedToString, optionsRecord.Kz)))
										]),
									_Utils_ap(
										function () {
											var _v0 = optionsRecord.ajm;
											if (!_v0.$) {
												var onInput_ = _v0.a;
												return _List_fromArray(
													[
														A2(
														$elm$html$Html$Events$on,
														'change',
														A2($elm$json$Json$Decode$map, onInput_, $author$project$Ui$Form$File$filesDecoder))
													]);
											} else {
												return _List_Nil;
											}
										}(),
										optionsRecord.zs ? _List_fromArray(
											[
												$elm$html$Html$Attributes$value('')
											]) : _List_Nil))))))),
			_List_Nil));
};
var $author$project$Components$Admin$ChargeItems$Form$viewImageField = F2(
	function (errors, currentImageUrl) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Image')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$File$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$File$accept(0),
							$author$project$Ui$Form$File$onInput($author$project$Components$Admin$ChargeItems$Form$ImageUploaded)
						])),
					function () {
					if (!currentImageUrl.$) {
						if (currentImageUrl.a === '') {
							return $author$project$Utils$Html$empty;
						} else {
							var url = currentImageUrl.a;
							return A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$mt2]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Image$fromSrc,
										{LD: 'Charge item image'},
										url,
										_List_fromArray(
											[
												$author$project$Ui$Image$height(100)
											]))
									]));
						}
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					$author$project$Utils$FormErrors$view(errors)
				]));
	});
var $author$project$Components$Admin$ChargeItems$Form$AddPackageItem = {$: 17};
var $author$project$Ui$Table$Colspan = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Table$colspan = $author$project$Ui$Table$Colspan;
var $author$project$Ui$Table$ContainerClasses = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Table$containerClasses = $author$project$Ui$Table$ContainerClasses;
var $author$project$Ui$Table$CellAlignment = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Table$textCenter = $author$project$Ui$Table$CellAlignment($author$project$Ui$Alignment$textCenter);
var $author$project$Ui$Table$textRight = $author$project$Ui$Table$CellAlignment($author$project$Ui$Alignment$textRight);
var $author$project$Components$Admin$ChargeItems$Form$RemovePackageItem = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$Admin$ChargeItems$Form$UpdatePackageItemPrice = F2(
	function (a, b) {
		return {$: 21, a: a, b: b};
	});
var $author$project$Components$Admin$ChargeItems$Form$UpdatePackageItemQuantity = F2(
	function (a, b) {
		return {$: 20, a: a, b: b};
	});
var $author$project$Ui$Table$MinWidth = function (a) {
	return {$: 8, a: a};
};
var $author$project$Ui$Table$minWidth = $author$project$Ui$Table$MinWidth;
var $author$project$Ui$Form$CurrencyInput$Placeholder = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Form$CurrencyInput$placeholder = $author$project$Ui$Form$CurrencyInput$Placeholder;
var $author$project$Ui$Typography$Success = 2;
var $author$project$Ui$Typography$success = $author$project$Ui$Typography$Color(2);
var $author$project$Ui$Form$Input$text = $author$project$Ui$Form$Input$Type($author$project$Ui$Form$Input$Text);
var $author$project$Components$ResourceFilter$ChargeItem$view = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$view,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.Jy),
					options),
				model.b8));
	});
var $author$project$Components$Admin$ChargeItems$Form$viewPackageItemRow = F2(
	function (model, item) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = A2($elm$core$Dict$get, item.Y, model.b5);
							if (!_v0.$) {
								var resourceFilter = _v0.a;
								var updatedResourceFilter = function () {
									var _v2 = _Utils_Tuple2(item.afA, item.afB);
									if ((!_v2.a.$) && (!_v2.b.$)) {
										var id = _v2.a.a;
										var name = _v2.b.a;
										return A2(
											$author$project$Components$ResourceFilter$ChargeItem$extraItems,
											_List_fromArray(
												[
													{ahP: id, Bq: name}
												]),
											resourceFilter);
									} else {
										return resourceFilter;
									}
								}();
								return A2(
									$elm$html$Html$map,
									$author$project$Components$Admin$ChargeItems$Form$PackageItemSelected(item.Y),
									A2(
										$author$project$Components$ResourceFilter$ChargeItem$view,
										_List_fromArray(
											[
												$author$project$Components$ResourceFilter$value(
												function () {
													var _v1 = item.afA;
													if (!_v1.$) {
														var id = _v1.a;
														return $author$project$Components$ResourceFilter$Extra(
															{
																aih: A2($elm$core$Maybe$withDefault, '', item.afB),
																aee: id
															});
													} else {
														return $author$project$Components$ResourceFilter$All;
													}
												}())
											]),
										updatedResourceFilter));
							} else {
								return $elm$html$Html$text('');
							}
						}()
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[
							$author$project$Ui$Table$minWidth('6em')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$text,
									$author$project$Ui$Form$Input$value(
									(!item.Dz) ? '' : $elm$core$String$fromInt(item.Dz)),
									$author$project$Ui$Form$Input$onInput(
									function (val) {
										var qty = function () {
											if ($elm$core$String$isEmpty(val)) {
												return 0;
											} else {
												var _v3 = $elm$core$String$toInt(val);
												if (!_v3.$) {
													var n = _v3.a;
													return (n >= 0) ? n : item.Dz;
												} else {
													return item.Dz;
												}
											}
										}();
										return $author$project$Components$Admin$ChargeItems$Form$FormUpdated(
											A2($author$project$Components$Admin$ChargeItems$Form$UpdatePackageItemQuantity, item.Y, qty));
									}),
									$author$project$Ui$Form$Input$onBlur(
									$author$project$Components$Admin$ChargeItems$Form$FormUpdated(
										A2(
											$author$project$Components$Admin$ChargeItems$Form$UpdatePackageItemQuantity,
											item.Y,
											(!item.Dz) ? 1 : item.Dz))),
									$author$project$Ui$Form$Input$customAttributes(
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('number'),
											$elm$html$Html$Attributes$min('1')
										]))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$row,
							_List_fromArray(
								[$author$project$Ui$Grid$rowItemsCenter]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(6)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$CurrencyInput$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$CurrencyInput$value(
													($author$project$Currency$toString(item.Dw) === '0') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(item.Dw)),
													$author$project$Ui$Form$CurrencyInput$placeholder('0.00'),
													$author$project$Ui$Form$CurrencyInput$onInput(
													function (val) {
														return $author$project$Components$Admin$ChargeItems$Form$FormUpdated(
															A2($author$project$Components$Admin$ChargeItems$Form$UpdatePackageItemPrice, item.Y, val));
													})
												]))
										])),
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(6)
										]),
									_List_fromArray(
										[
											function () {
											var _v4 = _Utils_Tuple2(
												item.afA,
												A2($elm$core$Dict$get, item.Y, model.b4));
											if ((!_v4.a.$) && (!_v4.b.$)) {
												var originalPrice = _v4.b.a;
												return (!_Utils_eq(originalPrice, item.Dw)) ? A2(
													$author$project$Ui$Typography$text,
													_List_fromArray(
														[$author$project$Ui$Typography$strike, $author$project$Ui$Typography$muted]),
													$author$project$Currency$format(originalPrice)) : $elm$html$Html$text('');
											} else {
												return $elm$html$Html$text('');
											}
										}()
										]))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$textCenter]),
					_List_fromArray(
						[
							function () {
							var _v5 = item.afD;
							if (!_v5.$) {
								if (_v5.a) {
									return A2(
										$author$project$Ui$Typography$span,
										_List_fromArray(
											[$author$project$Ui$Typography$success]),
										_List_fromArray(
											[
												$author$project$Ui$Icon$check(
												_List_fromArray(
													[$author$project$Ui$Icon$success]))
											]));
								} else {
									return A2(
										$author$project$Ui$Typography$span,
										_List_fromArray(
											[$author$project$Ui$Typography$danger]),
										_List_fromArray(
											[
												$author$project$Ui$Icon$cross(
												_List_fromArray(
													[$author$project$Ui$Icon$danger]))
											]));
								}
							} else {
								return A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$danger]),
									_List_fromArray(
										[
											$author$project$Ui$Icon$cross(
											_List_fromArray(
												[$author$project$Ui$Icon$danger]))
										]));
							}
						}()
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$textRight]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Remove item from package'},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$sm,
									$author$project$Ui$Button$onClick(
									$author$project$Components$Admin$ChargeItems$Form$FormUpdated(
										$author$project$Components$Admin$ChargeItems$Form$RemovePackageItem(item.Y))),
									$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Delete')
								]))
						]))
				]));
	});
var $author$project$Components$Admin$ChargeItems$Form$viewIncludesTable = F3(
	function (model, fields, form) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$required(true),
					$author$project$Ui$Form$Group$label('Includes')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							A4(
							$author$project$Ui$Table$view,
							_List_fromArray(
								[
									$author$project$Ui$Table$containerClasses(
									_List_fromArray(
										['table-wrapper', 'bg-white']))
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Table$header,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Charge Item')
										])),
									A2(
									$author$project$Ui$Table$header,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Quantity')
										])),
									A2(
									$author$project$Ui$Table$header,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Price per Item')
										])),
									A2(
									$author$project$Ui$Table$header,
									_List_fromArray(
										[$author$project$Ui$Table$textCenter]),
									_List_fromArray(
										[
											$elm$html$Html$text('Taxable')
										])),
									A2(
									$author$project$Ui$Table$header,
									_List_fromArray(
										[$author$project$Ui$Table$textRight]),
									_List_fromArray(
										[
											$elm$html$Html$text('')
										]))
								]),
							$elm$core$List$isEmpty(fields.YF) ? _List_fromArray(
								[
									A2(
									$author$project$Ui$Table$row,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Table$cell,
											_List_fromArray(
												[
													$author$project$Ui$Table$colspan(5),
													$author$project$Ui$Table$textCenter
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$p,
													_List_fromArray(
														[$author$project$Ui$Typography$muted]),
													_List_fromArray(
														[
															$elm$html$Html$text('No items added to this package yet.')
														]))
												]))
										]))
								]) : A2(
								$elm$core$List$map,
								$author$project$Components$Admin$ChargeItems$Form$viewPackageItemRow(model),
								fields.YF),
							_List_Nil),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$mt2]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Add item to package'},
									_List_fromArray(
										[
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$onClick(
											$author$project$Components$Admin$ChargeItems$Form$FormUpdated($author$project$Components$Admin$ChargeItems$Form$AddPackageItem)),
											$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Add to Package')
										]))
								]))
						])),
					$author$project$Utils$FormErrors$view(
					A2($author$project$Utils$Form$validationErrors, 5, form))
				]));
	});
var $author$project$Api$FeatureGate$InventoryAndSalesTax = 2;
var $author$project$Components$Admin$ChargeItems$Form$TrackInventory = function (a) {
	return {$: 7, a: a};
};
var $author$project$Ui$Form$Checkbox$Disabled = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Form$Checkbox$disabled = $author$project$Ui$Form$Checkbox$Disabled;
var $author$project$Utils$FeatureGate$customGate = F3(
	function (code, practice, gated) {
		var _v0 = A2(
			$author$project$Utils$FeatureGate$findByCode,
			code,
			$author$project$Api$Practice$featureGates(practice));
		if (!_v0.$) {
			return $elm$core$Maybe$Just(gated);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Utils$FeatureGate$gate = F3(
	function (code, practice, htmlMsg) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Utils$Html$empty,
			A3($author$project$Utils$FeatureGate$customGate, code, practice, htmlMsg));
	});
var $author$project$Ui$Typography$Info = 3;
var $author$project$Ui$Typography$info = $author$project$Ui$Typography$Color(3);
var $author$project$Components$Admin$ChargeItems$Form$viewInventoryCheckbox = F3(
	function (fields, practice, disabled) {
		return A3(
			$author$project$Utils$FeatureGate$gate,
			2,
			$author$project$Api$Practice$Provider(practice),
			A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpan(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Inventory')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Checkbox$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Checkbox$value(fields.ads),
								$author$project$Ui$Form$Checkbox$onCheck(
								A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$TrackInventory)),
								$author$project$Ui$Form$Checkbox$disabled(
								$author$project$Utils$Uom$isTimeBased(fields.adP) || disabled)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Track inventory for this item')
							])),
						$author$project$Utils$Uom$isTimeBased(fields.adP) ? A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$info]),
						_List_fromArray(
							[
								$elm$html$Html$text('Inventory tracking is not available for time based charge items.')
							])) : $author$project$Utils$Html$empty
					])));
	});
var $author$project$Components$Admin$ChargeItems$Form$EditQuantity = {$: 11};
var $author$project$Components$Admin$ChargeItems$Form$LastSetQuantity = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Admin$ChargeItems$Form$viewInventoryInput = F3(
	function (fields, form, disabled) {
		return fields.ads ? A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Current inventory')
				]),
			_List_fromArray(
				[
					fields.jy ? $author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$number,
							$author$project$Ui$Form$Input$value(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2($elm$core$Maybe$map, $elm$core$String$fromInt, fields.VM))),
							$author$project$Ui$Form$Input$onInput(
							A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$LastSetQuantity)),
							$author$project$Ui$Form$Input$placeholder('37'),
							$author$project$Ui$Form$Input$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 3, form)),
							$author$project$Ui$Form$Input$errors(
							A2($author$project$Utils$Form$validationErrors, 3, form)),
							$author$project$Ui$Form$Input$disabled(disabled)
						])) : A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_Utils_ap(
						function () {
							var _v0 = _Utils_Tuple2(fields._P, fields.VM);
							if ((!_v0.a.$) && (!_v0.b.$)) {
								var quantityInStock = _v0.a.a;
								var lastSetQuantity = _v0.b.a;
								return _List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(quantityInStock)),
										$elm$html$Html$text('/'),
										$elm$html$Html$text(
										$elm$core$String$fromInt(lastSetQuantity))
									]);
							} else {
								return _List_fromArray(
									[
										$elm$html$Html$text('N/A')
									]);
							}
						}(),
						_List_fromArray(
							[
								$author$project$Utils$Html$noBreakSpace,
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Edit charge item'},
								_List_fromArray(
									[
										$author$project$Ui$Button$sm,
										$author$project$Ui$Button$onClick(
										$author$project$Components$Admin$ChargeItems$Form$FormUpdated($author$project$Components$Admin$ChargeItems$Form$EditQuantity))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Edit')
									]))
							])))
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Components$Admin$ChargeItems$Form$AlertQuantity = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Admin$ChargeItems$Form$viewInventoryShowWarningInput = F2(
	function (fields, disabled) {
		return fields.ads ? A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Show a warning if the quantity in inventory is below')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$number,
							$author$project$Ui$Form$Input$value(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2($elm$core$Maybe$map, $elm$core$String$fromInt, fields.Lm))),
							$author$project$Ui$Form$Input$onInput(
							A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$AlertQuantity)),
							$author$project$Ui$Form$Input$placeholder('10'),
							$author$project$Ui$Form$Input$disabled(disabled)
						]))
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Components$Admin$ChargeItems$Form$Manufacturer = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Admin$ChargeItems$Form$viewManufacturerInput = F2(
	function (fields, disabled) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Facility / Manufacturer')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$value(fields.Wt),
							$author$project$Ui$Form$Input$onInput(
							A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$Manufacturer)),
							$author$project$Ui$Form$Input$disabled(disabled)
						]))
				]));
	});
var $author$project$Components$Admin$ChargeItems$Form$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$ChargeItems$Form$viewNameInput = F3(
	function (fields, form, disabled) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$required(true),
					$author$project$Ui$Form$Group$label('Name')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$value(fields.Bq),
							$author$project$Ui$Form$Input$placeholder(
							(fields.sW === 1) ? 'Package Name' : '800mg Ibuprofen'),
							$author$project$Ui$Form$Input$autofocus(true),
							$author$project$Ui$Form$Input$onInput(
							A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$Name)),
							$author$project$Ui$Form$Input$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
							$author$project$Ui$Form$Input$errors(
							A2($author$project$Utils$Form$validationErrors, 0, form)),
							$author$project$Ui$Form$Input$disabled(disabled)
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$helpBlock]),
					_List_fromArray(
						[
							$elm$html$Html$text('What is being charged for on the invoice or receipt.')
						]))
				]));
	});
var $author$project$Components$Admin$ChargeItems$Form$ApplyPackagePriceAdjustment = {$: 3};
var $author$project$Components$Admin$ChargeItems$Form$PriceInCents = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Form$CurrencyInput$Postfix = function (a) {
	return {$: 6, a: a};
};
var $author$project$Ui$Form$CurrencyInput$postfix = $author$project$Ui$Form$CurrencyInput$Postfix;
var $author$project$Api$Provider$Uom$Shared$periodQuantity = function (_v0) {
	var record = _v0;
	return record.he;
};
var $author$project$Components$Admin$ChargeItems$Form$uomPeriodQuantity = function (code) {
	return A2(
		$elm$core$Maybe$andThen,
		$author$project$Api$Provider$Uom$Shared$periodQuantity,
		$author$project$Utils$Uom$fromCode(code));
};
var $author$project$Api$Provider$Uom$Shared$periodUnit = function (_v0) {
	var record = _v0;
	return record.hf;
};
var $author$project$Api$Provider$Uom$PeriodUnit$toString = function (periodUnit_) {
	switch (periodUnit_) {
		case 0:
			return 'days';
		case 1:
			return 'months';
		case 2:
			return 'quarters';
		case 3:
			return 'half_years';
		default:
			return 'years';
	}
};
var $author$project$Components$Admin$ChargeItems$Form$uomPeriodUnit = function (code) {
	return A2(
		$elm$core$Maybe$map,
		$author$project$Api$Provider$Uom$PeriodUnit$toString,
		A2(
			$elm$core$Maybe$andThen,
			$author$project$Api$Provider$Uom$Shared$periodUnit,
			$author$project$Utils$Uom$fromCode(code)));
};
var $author$project$Components$Admin$ChargeItems$Form$viewPackagePriceInput = F2(
	function (fields, form) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$required(true),
					$author$project$Ui$Form$Group$label('Package Price')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_fromArray(
						[$author$project$Ui$Grid$rowItemsCenter]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(4)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$CurrencyInput$view(
									A2(
										$elm$core$List$cons,
										$author$project$Ui$Form$CurrencyInput$value(fields.Dw),
										A2(
											$elm$core$List$cons,
											$author$project$Ui$Form$CurrencyInput$placeholder('0.00'),
											A2(
												$elm$core$List$cons,
												$author$project$Ui$Form$CurrencyInput$onInput(
													A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$PriceInCents)),
												A2(
													$elm$core$List$cons,
													$author$project$Ui$Form$CurrencyInput$onBlur(
														$author$project$Components$Admin$ChargeItems$Form$FormUpdated($author$project$Components$Admin$ChargeItems$Form$ApplyPackagePriceAdjustment)),
													A2(
														$elm$core$List$cons,
														$author$project$Ui$Form$CurrencyInput$invalid(
															A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
														function () {
															var _v0 = _Utils_Tuple3(
																$author$project$Utils$Uom$isTimeBased(fields.adP),
																$author$project$Components$Admin$ChargeItems$Form$uomPeriodUnit(fields.adP),
																$author$project$Components$Admin$ChargeItems$Form$uomPeriodQuantity(fields.adP));
															if ((_v0.a && (!_v0.b.$)) && (!_v0.c.$)) {
																var periodUnit = _v0.b.a;
																var periodQuantity = _v0.c.a;
																return _List_fromArray(
																	[
																		$author$project$Ui$Form$CurrencyInput$postfix(
																		'per ' + A2($author$project$Formatters$String$pluralize, periodUnit, periodQuantity))
																	]);
															} else {
																return _List_Nil;
															}
														}()))))))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(3)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('+ tax')
								]))
						])),
					$author$project$Utils$FormErrors$view(
					A2($author$project$Utils$Form$validationErrors, 2, form))
				]));
	});
var $author$project$Components$Admin$ChargeItems$Form$Taxable = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$ChargeItems$Form$viewPriceInput = F4(
	function (fields, form, practice, disabled) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$required(true),
					$author$project$Ui$Form$Group$label('Price')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(9)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$CurrencyInput$view(
									A2(
										$elm$core$List$cons,
										$author$project$Ui$Form$CurrencyInput$value(
											A2(
												$elm$core$Maybe$andThen,
												function (price) {
													return ($author$project$Currency$toString(price) === '0') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(price);
												},
												fields.Dw)),
										A2(
											$elm$core$List$cons,
											$author$project$Ui$Form$CurrencyInput$placeholder('0.00'),
											A2(
												$elm$core$List$cons,
												$author$project$Ui$Form$CurrencyInput$onInput(
													A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$PriceInCents)),
												A2(
													$elm$core$List$cons,
													$author$project$Ui$Form$CurrencyInput$invalid(
														A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
													function () {
														var _v0 = _Utils_Tuple3(
															$author$project$Utils$Uom$isTimeBased(fields.adP),
															$author$project$Components$Admin$ChargeItems$Form$uomPeriodUnit(fields.adP),
															$author$project$Components$Admin$ChargeItems$Form$uomPeriodQuantity(fields.adP));
														if ((_v0.a && (!_v0.b.$)) && (!_v0.c.$)) {
															var periodUnit = _v0.b.a;
															var periodQuantity = _v0.c.a;
															return _List_fromArray(
																[
																	$author$project$Ui$Form$CurrencyInput$postfix(
																	'per ' + A2($author$project$Formatters$String$pluralize, periodUnit, periodQuantity))
																]);
														} else {
															return _List_Nil;
														}
													}()))))),
									$author$project$Utils$FormErrors$view(
									A2($author$project$Utils$Form$validationErrors, 2, form)),
									fields.acZ ? A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$helpBlock]),
									_List_fromArray(
										[
											$elm$html$Html$text('Taxes will be added '),
											A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[$author$project$Ui$Typography$italic]),
											'on top of '),
											$elm$html$Html$text('this price, at invoice-time.')
										])) : $author$project$Utils$Html$empty
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(3)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Utils$FeatureGate$gate,
									2,
									$author$project$Api$Practice$Provider(practice),
									A2(
										$author$project$Ui$Form$Checkbox$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Checkbox$value(fields.acZ),
												$author$project$Ui$Form$Checkbox$onCheck(
												A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$Taxable)),
												$author$project$Ui$Form$Checkbox$disabled(disabled)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Taxable')
											])))
								]))
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$helpBlock]),
					_List_fromArray(
						[
							$elm$html$Html$text('Do your members receive a discount for this product or service? '),
							A3(
							$author$project$Ui$Link$externalHref,
							'https://support.hint.com/en/articles/5921503-configuring-coverage-plans',
							_List_fromArray(
								[$author$project$Ui$Link$targetBlank]),
							_List_fromArray(
								[
									$elm$html$Html$text('Configure a coverage rule')
								]))
						]))
				]));
	});
var $author$project$Components$Admin$ChargeItems$Form$ItemType = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Admin$ChargeItems$Form$viewTypeToggle = function (fields) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$required(true),
				$author$project$Ui$Form$Group$label('Type')
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$ButtonSelect$view(
				{
					ajd: A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$ItemType),
					Cd: _List_fromArray(
						[
							A2($author$project$Ui$Form$ButtonSelect$option, 0, 'Item'),
							A2($author$project$Ui$Form$ButtonSelect$option, 1, 'Package')
						]),
					aee: fields.sW
				})
			]));
};
var $author$project$Components$Admin$ChargeItems$Form$Uom = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$ChargeItem$Meta$uomEditable = function (_v0) {
	var meta = _v0;
	return meta.adP.Q4;
};
var $elm_community$list_extra$List$Extra$gatherWith = F2(
	function (testFn, list) {
		var helper = F2(
			function (scattered, gathered) {
				if (!scattered.b) {
					return $elm$core$List$reverse(gathered);
				} else {
					var toGather = scattered.a;
					var population = scattered.b;
					var _v1 = A2(
						$elm$core$List$partition,
						testFn(toGather),
						population);
					var gathering = _v1.a;
					var remaining = _v1.b;
					return A2(
						helper,
						remaining,
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(toGather, gathering),
							gathered));
				}
			});
		return A2(helper, list, _List_Nil);
	});
var $elm_community$list_extra$List$Extra$gatherEqualsBy = F2(
	function (extract, list) {
		return A2(
			$elm_community$list_extra$List$Extra$gatherWith,
			F2(
				function (a, b) {
					return _Utils_eq(
						extract(a),
						extract(b));
				}),
			list);
	});
var $author$project$Ui$Form$Select$Group = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Ui$Form$Select$group = $author$project$Ui$Form$Select$Group;
var $author$project$Api$Provider$Uom$Shared$type_ = function (_v0) {
	var record = _v0;
	return record.amg;
};
var $author$project$Components$Admin$ChargeItems$Form$uomGroupOptions = function (uoms) {
	return A2(
		$elm$core$List$map,
		function (uom_) {
			return A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(
					$author$project$Api$Provider$Uom$Shared$code(uom_)),
				$author$project$Api$Provider$Uom$Shared$name(uom_));
		},
		uoms);
};
var $author$project$Components$Admin$ChargeItems$Form$uomOptions = A2(
	$elm$core$List$map,
	function (_v0) {
		var uom = _v0.a;
		var uoms = _v0.b;
		return A2(
			$author$project$Ui$Form$Select$group,
			$author$project$Api$Provider$Uom$Shared$type_(uom),
			$author$project$Components$Admin$ChargeItems$Form$uomGroupOptions(
				A2($elm$core$List$cons, uom, uoms)));
	},
	A2(
		$elm_community$list_extra$List$Extra$gatherEqualsBy,
		$author$project$Api$Provider$Uom$Shared$type_,
		$author$project$Api$Provider$Uom$list($elm$core$Basics$identity)));
var $author$project$Components$Admin$ChargeItems$Form$viewUnitOfMeasureSelect = F3(
	function (fields, form, disabled) {
		var uomEditable = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$ChargeItem$Meta$uomEditable, fields.W4));
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$required(true),
					$author$project$Ui$Form$Group$label('Unit of Measure')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Select$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Select$value(
							$elm$core$Maybe$Just(fields.adP)),
							$author$project$Ui$Form$Select$onChange(
							A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$Uom)),
							$author$project$Ui$Form$Select$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
							$author$project$Ui$Form$Select$errors(
							A2($author$project$Utils$Form$validationErrors, 1, form)),
							$author$project$Ui$Form$Select$disabled((!uomEditable) || disabled)
						]),
					$author$project$Components$Admin$ChargeItems$Form$uomOptions),
					uomEditable ? $author$project$Utils$Html$empty : A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$info]),
					_List_fromArray(
						[
							$elm$html$Html$text('Cannot be edited while this charge is recurring on memberships.')
						]))
				]));
	});
var $author$project$Components$Admin$ChargeItems$Form$viewForm = F2(
	function (model, form) {
		var fields = $author$project$Utils$Form$fields(form);
		var typeToggle = A2(
			$author$project$Utils$FeatureGate$gateAvailable,
			14,
			$author$project$Api$Practice$Provider(model.ZV)) ? _List_fromArray(
			[
				$author$project$Components$Admin$ChargeItems$Form$viewTypeToggle(fields)
			]) : _List_Nil;
		var disable = A2($author$project$Api$Provider$Practice$One$featureEnabled, 6, model.ZV) && model.Am;
		if (fields.sW === 1) {
			var buyableEditable = A2($author$project$Api$Provider$Practice$One$featureEnabled, 22, model.ZV);
			return $elm$core$List$concat(
				_List_fromArray(
					[
						typeToggle,
						A2(
						$elm$core$List$cons,
						A3($author$project$Components$Admin$ChargeItems$Form$viewNameInput, fields, form, disable),
						A2(
							$elm$core$List$cons,
							buyableEditable ? A2($author$project$Components$Admin$ChargeItems$Form$viewBuyableCheckbox, fields, disable) : $author$project$Utils$Html$empty,
							_Utils_ap(
								(buyableEditable && fields.MZ) ? _List_fromArray(
									[
										A2(
										$author$project$Components$Admin$ChargeItems$Form$viewImageField,
										A2($author$project$Utils$Form$validationErrors, 7, form),
										fields.rQ),
										A2(
										$elm$html$Html$map,
										$author$project$Components$Admin$ChargeItems$Form$RichDescriptionMsg,
										A2(
											$author$project$Components$TranslatedRichText$view,
											{
												agG: 'charge-item-rich-description-editor',
												agX: A2($author$project$Utils$Form$validationErrors, 8, form),
												ahD: $elm$core$Maybe$Just('Describe what patients get with this offering'),
												aih: 'Marketing Description',
												aja: false,
												aj3: $elm$core$Maybe$Just('Ex: Unlimited visits and direct access to your care team.'),
												akR: true
											},
											fields.bh))
									]) : _List_Nil,
								_List_fromArray(
									[
										A3($author$project$Components$Admin$ChargeItems$Form$viewIncludesTable, model, fields, form),
										A2($author$project$Components$Admin$ChargeItems$Form$viewPackagePriceInput, fields, form),
										A4($author$project$Components$Admin$ChargeItems$Form$viewExpirationSection, model, fields, form, disable),
										A3(
										$author$project$Components$Admin$ChargeItems$Form$viewDescriptionInput,
										buyableEditable ? 'Invoice Description' : 'Description',
										fields,
										disable),
										A2($author$project$Components$Admin$ChargeItems$Form$viewCategoryInput, model.c8, disable),
										$author$project$Components$Admin$ChargeItems$Form$viewAdvancedSettings(fields)
									]))))
					]));
		} else {
			return $elm$core$List$concat(
				_List_fromArray(
					[
						typeToggle,
						_List_fromArray(
						[
							A3($author$project$Components$Admin$ChargeItems$Form$viewNameInput, fields, form, disable),
							A3($author$project$Components$Admin$ChargeItems$Form$viewUnitOfMeasureSelect, fields, form, disable),
							A2($author$project$Components$Admin$ChargeItems$Form$viewDaysSupplyInput, fields, disable),
							A4($author$project$Components$Admin$ChargeItems$Form$viewPriceInput, fields, form, model.ZV, disable),
							A2($author$project$Components$Admin$ChargeItems$Form$viewCategoryInput, model.c8, disable),
							A3($author$project$Components$Admin$ChargeItems$Form$viewInventoryCheckbox, fields, model.ZV, disable),
							A3($author$project$Components$Admin$ChargeItems$Form$viewInventoryInput, fields, form, disable),
							A2($author$project$Components$Admin$ChargeItems$Form$viewInventoryShowWarningInput, fields, disable),
							A4($author$project$Components$Admin$ChargeItems$Form$viewCodeInput, fields, form, model.mT, disable),
							A2($author$project$Components$Admin$ChargeItems$Form$viewManufacturerInput, fields, disable),
							A3($author$project$Components$Admin$ChargeItems$Form$viewDescriptionInput, 'Description', fields, disable)
						])
					]));
		}
	});
var $author$project$Components$Admin$ChargeItems$Form$view = function (_v0) {
	var model = _v0;
	return A2(
		$author$project$Ui$Form$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$noValidate(true),
				$author$project$Ui$Form$autocomplete(false)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												function () {
												var _v1 = model.ahP;
												if (!_v1.$) {
													return $elm$html$Html$text('Edit');
												} else {
													return $elm$html$Html$text('New Item');
												}
											}()
											])),
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Delete charge item'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$onClick($author$project$Components$Admin$ChargeItems$Form$BackButtonClicked),
												$author$project$Ui$Button$icon($author$project$Ui$Icon$cross)
											]),
										_List_Nil)
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$muted]),
								_List_fromArray(
									[
										function () {
										var _v2 = model.ahP;
										if (!_v2.$) {
											return $elm$html$Html$text('Any changes will affect current recurring charges and future created charges.');
										} else {
											return $elm$html$Html$text('Create a new charge item that can be selected from a saved menu.');
										}
									}()
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						function () {
							var _v3 = model.SD;
							if (!_v3.$) {
								var form = _v3.a;
								return A2($author$project$Components$Admin$ChargeItems$Form$viewForm, model, form);
							} else {
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$textCenter]),
										_List_fromArray(
											[
												$author$project$Ui$Spinner$view(_List_Nil)
											]))
									]);
							}
						}()),
						A2(
						$author$project$Ui$Panel$footer,
						_List_fromArray(
							[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$wrap]),
						_List_fromArray(
							[
								function () {
								var _v4 = model.SD;
								if (!_v4.$) {
									var form = _v4.a;
									return $author$project$Utils$Form$hasAnyValidationError(form) ? A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$fullWidth, $author$project$Ui$Element$justifyCenter]),
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Element$custom,
												'w-1/2',
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Alert$danger,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Please review the errors above')
															]))
													]))
											])) : $author$project$Utils$Html$empty;
								} else {
									return $author$project$Utils$Html$empty;
								}
							}(),
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Go back'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$onClick($author$project$Components$Admin$ChargeItems$Form$BackButtonClicked)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Back')
									])),
								function () {
								var verb = function () {
									var _v5 = model.ahP;
									if (!_v5.$) {
										return 'Update';
									} else {
										return 'Create';
									}
								}();
								return A3(
									$author$project$Ui$Button$view,
									{mm: verb + ' Charge'},
									_List_fromArray(
										[
											$author$project$Ui$Button$primary,
											$author$project$Ui$Button$loading(
											_Utils_eq(model.k9, $author$project$Api$Data$Loading)),
											$author$project$Ui$Button$onClick($author$project$Components$Admin$ChargeItems$Form$Save)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(verb)
										]));
							}()
							]))
					]))
			]));
};
var $author$project$Pages$Admin$ChargeItems$Id_String$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Admin$ChargeItems$Form$view(model.SD))
			]),
		ac9: 'Admin | Charge Items'
	};
};
var $author$project$Pages$Admin$ChargeItems$Id_String$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$ChargeItems$Id_String$init, aiq: $author$project$Pages$Admin$ChargeItems$Id_String$load, k8: $author$project$Pages$Admin$ChargeItems$Id_String$save, alO: $author$project$Pages$Admin$ChargeItems$Id_String$subscriptions, adT: $author$project$Pages$Admin$ChargeItems$Id_String$update, amo: $author$project$Pages$Admin$ChargeItems$Id_String$view});
var $author$project$Pages$Admin$ChargeItems$New$ChargeItemFormMsg = $elm$core$Basics$identity;
var $author$project$Pages$Admin$ChargeItems$New$init = F4(
	function (session, practice, _v0, _v1) {
		var apiClient = _v0.Gv;
		var _v2 = A4($author$project$Components$Admin$ChargeItems$Form$init, apiClient, session, $elm$core$Maybe$Nothing, practice);
		var form = _v2.a;
		var cmd = _v2.b;
		return _Utils_Tuple2(
			{Gv: apiClient, SD: form},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
	});
var $author$project$Pages$Admin$ChargeItems$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$ChargeItems$New$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$ChargeItems$New$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Admin$ChargeItems$Form$subscriptions(model.SD));
};
var $author$project$Pages$Admin$ChargeItems$New$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Admin$ChargeItems$Form$update, model.Gv, subMsg, model.SD);
		var newForm = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{SD: newForm}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Pages$Admin$ChargeItems$New$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Admin$ChargeItems$Form$view(model.SD))
			]),
		ac9: 'Admin | Charge Items'
	};
};
var $author$project$Pages$Admin$ChargeItems$New$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$ChargeItems$New$init, aiq: $author$project$Pages$Admin$ChargeItems$New$load, k8: $author$project$Pages$Admin$ChargeItems$New$save, alO: $author$project$Pages$Admin$ChargeItems$New$subscriptions, adT: $author$project$Pages$Admin$ChargeItems$New$update, amo: $author$project$Pages$Admin$ChargeItems$New$view});
var $author$project$Pages$Admin$ChargeItems$Top$CategoryResourceFilterMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Admin$ChargeItems$Top$InventoryDropdownMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Admin$ChargeItems$Top$ItemTypeDropdownMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Admin$ChargeItems$Top$GotChargeItems = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$ChargeItems$Top$stockStatusToString = function (status) {
	switch (status) {
		case 0:
			return 'in_stock';
		case 1:
			return 'low_inventory';
		default:
			return 'out_of_stock';
	}
};
var $author$project$Pages$Admin$ChargeItems$Top$fetchParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				GW: model.iF,
				Ia: A2($elm$core$Maybe$map, $author$project$Pages$Admin$ChargeItems$Top$stockStatusToString, model.Ia),
				sW: A2($elm$core$Maybe$map, $author$project$Api$Provider$ChargeItem$Shared$itemTypeToString, model.sW),
				ajJ: model.ajJ,
				akl: model.akl,
				alA: model.alA
			});
	};
};
var $author$project$Pages$Admin$ChargeItems$Top$fetchItems = function (model) {
	return A3(
		$author$project$Api$Provider$ChargeItem$list,
		model.Gv,
		$author$project$Pages$Admin$ChargeItems$Top$fetchParams(model),
		$author$project$Pages$Admin$ChargeItems$Top$GotChargeItems);
};
var $author$project$Ui$SearchInput$Model = $elm$core$Basics$identity;
var $author$project$Ui$SearchInput$init = function (text) {
	return {d6: $jinjor$elm_debounce$Debounce$init, ac3: text};
};
var $author$project$Utils$Report$CategoryResourceFilter$init = F3(
	function (apiClient, session, categoryId) {
		return A3(
			$author$project$Components$ResourceFilter$Category$init,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'All Categories', XY: 'Unassigned', ai5: true, akb: categoryId});
			});
	});
var $author$project$Api$Column$Column = $elm$core$Basics$identity;
var $author$project$Api$Column$init = F3(
	function (id, sortable, name) {
		return {ahP: id, Bq: name, Cd: _List_Nil, JP: sortable};
	});
var $author$project$Pages$Admin$ChargeItems$Top$initColumns = function (practice) {
	var taxableColumn = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A3(
			$author$project$Utils$FeatureGate$customGate,
			2,
			$author$project$Api$Practice$Provider(practice),
			_List_fromArray(
				[
					A3($author$project$Api$Column$init, 'taxable', false, 'Taxable')
				])));
	var itemTypeColumn = A2(
		$author$project$Utils$FeatureGate$gateAvailable,
		14,
		$author$project$Api$Practice$Provider(practice)) ? _List_fromArray(
		[
			A3($author$project$Api$Column$init, 'item_type', true, 'Item Type')
		]) : _List_Nil;
	return $elm$core$List$concat(
		_List_fromArray(
			[
				_List_fromArray(
				[
					A3($author$project$Api$Column$init, 'name', true, 'Name'),
					A3($author$project$Api$Column$init, 'price_in_cents', true, 'Price'),
					A3($author$project$Api$Column$init, 'category', true, 'Category')
				]),
				itemTypeColumn,
				taxableColumn
			]));
};
var $author$project$Api$Pagination$pageParamName = function (prefix) {
	return prefix + 'page';
};
var $author$project$Api$Pagination$fromQuery = F2(
	function (query, _v0) {
		var model = _v0;
		var currentPage = A2(
			$elm$core$Maybe$withDefault,
			1,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$String$toInt,
				A2(
					$elm$core$Dict$get,
					$author$project$Api$Pagination$pageParamName(model.t1),
					query)));
		return _Utils_update(
			model,
			{bX: currentPage});
	});
var $author$project$Api$Pagination$initFromQuery = function (query) {
	return A2($author$project$Api$Pagination$fromQuery, query, $author$project$Api$Pagination$init);
};
var $author$project$Api$Sort$Asc = 0;
var $author$project$Api$Sort$Desc = 1;
var $author$project$Api$Sort$fromQuery = F2(
	function (query, _v0) {
		var model = _v0;
		var _v1 = A2(
			$elm$core$Dict$get,
			$author$project$Api$Sort$pageParamName(model.t1),
			query);
		if (!_v1.$) {
			var sort = _v1.a;
			var direction = A2($elm$core$String$startsWith, '-', sort) ? 1 : 0;
			return _Utils_update(
				model,
				{
					PW: $elm$core$Maybe$Nothing,
					aee: $elm$core$Maybe$Just(
						_Utils_Tuple2(
							A3($elm$core$String$replace, '-', '', sort),
							direction))
				});
		} else {
			return model;
		}
	});
var $author$project$Api$Sort$initFromQuery = function (query) {
	return A2($author$project$Api$Sort$fromQuery, query, $author$project$Api$Sort$init);
};
var $author$project$Pages$Admin$ChargeItems$Top$stringToItemType = function (str) {
	switch (str) {
		case 'item':
			return $elm$core$Maybe$Just(0);
		case 'package':
			return $elm$core$Maybe$Just(1);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$Admin$ChargeItems$Top$InStock = 0;
var $author$project$Pages$Admin$ChargeItems$Top$LowInventory = 1;
var $author$project$Pages$Admin$ChargeItems$Top$OutOfStock = 2;
var $author$project$Pages$Admin$ChargeItems$Top$stringToStockStatus = function (str) {
	switch (str) {
		case 'in_stock':
			return $elm$core$Maybe$Just(0);
		case 'low_inventory':
			return $elm$core$Maybe$Just(1);
		case 'out_of_stock':
			return $elm$core$Maybe$Just(2);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $elm$url$Url$Builder$relative = F2(
	function (pathSegments, parameters) {
		return _Utils_ap(
			A2($elm$core$String$join, '/', pathSegments),
			$elm$url$Url$Builder$toQuery(parameters));
	});
var $elm$url$Url$Builder$int = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$core$String$fromInt(value));
	});
var $author$project$Api$Pagination$perPageParamName = function (prefix) {
	return prefix + 'per_page';
};
var $author$project$Api$Pagination$toPageQuery = function (_v0) {
	var model = _v0;
	return _List_fromArray(
		[
			A2(
			$elm$url$Url$Builder$int,
			$author$project$Api$Pagination$pageParamName(model.t1),
			model.bX),
			A2(
			$elm$url$Url$Builder$int,
			$author$project$Api$Pagination$perPageParamName(model.t1),
			model.gG)
		]);
};
var $author$project$Api$Sort$toQuery = function (_v0) {
	var model = _v0;
	return A2(
		$elm$core$List$concatMap,
		$author$project$Api$Param$toQuery,
		A2($author$project$Api$Sort$toPrefixeddParams, model.t1, model));
};
var $author$project$Pages$Admin$ChargeItems$Top$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('q'),
			model.akl),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('category'),
			model.iF),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('inventory'),
			A2($elm$core$Maybe$map, $author$project$Pages$Admin$ChargeItems$Top$stockStatusToString, model.Ia)),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('item_type'),
			A2($elm$core$Maybe$map, $author$project$Api$Provider$ChargeItem$Shared$itemTypeToString, model.sW))
		]);
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Admin__ChargeItems__Top)
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.ajJ),
				A2(
					$elm$core$List$append,
					$author$project$Api$Sort$toQuery(model.alA),
					A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
};
var $author$project$Pages$Admin$ChargeItems$Top$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.DE;
		var q = A2($elm$core$Dict$get, 'q', query);
		var categoryId = A2($elm$core$Dict$get, 'category', query);
		var apiClient = shared.Gv;
		var _v1 = A3($author$project$Utils$Report$CategoryResourceFilter$init, apiClient, session, categoryId);
		var categoryResourceFilter = _v1.a;
		var categoryResourceFilterCmd = _v1.b;
		var model = {
			Gv: apiClient,
			iF: categoryId,
			c8: categoryResourceFilter,
			bS: $author$project$Api$Data$Loading,
			N3: $author$project$Pages$Admin$ChargeItems$Top$initColumns(practice),
			jb: $elm$core$Maybe$Nothing,
			eb: $elm$core$Set$empty,
			agP: shared.ahq.agP,
			Ia: A2(
				$elm$core$Maybe$andThen,
				$author$project$Pages$Admin$ChargeItems$Top$stringToStockStatus,
				A2($elm$core$Dict$get, 'inventory', query)),
			n0: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'inventory-dropdown-filter', al6: $author$project$Pages$Admin$ChargeItems$Top$InventoryDropdownMsg})),
			Ij: $author$project$Shared$isHintAdmin(shared),
			sW: A2(
				$elm$core$Maybe$andThen,
				$author$project$Pages$Admin$ChargeItems$Top$stringToItemType,
				A2($elm$core$Dict$get, 'item_type', query)),
			oe: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'item-type-dropdown-filter', al6: $author$project$Pages$Admin$ChargeItems$Top$ItemTypeDropdownMsg})),
			ajG: shared.ahq.ajG,
			ajJ: $author$project$Api$Pagination$initFromQuery(query),
			ZV: practice,
			akl: q,
			up: $author$project$Ui$SearchInput$init(q),
			alA: $author$project$Api$Sort$initFromQuery(query),
			J7: shared.J7
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$ChargeItems$Top$CategoryResourceFilterMsg, categoryResourceFilterCmd),
						$author$project$Pages$Admin$ChargeItems$Top$fetchItems(model),
						$author$project$Pages$Admin$ChargeItems$Top$updateUrl(model)
					])));
	});
var $author$project$Pages$Admin$ChargeItems$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$ChargeItems$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$ChargeItems$Top$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Pages$Admin$ChargeItems$Top$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$ChargeItems$Top$HiConfirmClosed),
						$author$project$Api$Provider$ChargeItem$All$id),
					model.jb)),
				$author$project$Ui$Dropdown$subscriptions(model.n0),
				$author$project$Ui$Dropdown$subscriptions(model.oe),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$ChargeItems$Top$CategoryResourceFilterMsg,
				$author$project$Components$ResourceFilter$Category$subscriptions(model.c8))
			]));
};
var $author$project$Pages$Admin$ChargeItems$Top$Deleted = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Pages$Admin$ChargeItems$Top$ExportFileMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Admin$ChargeItems$Top$SearchInputMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$ChargeItem$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$ChargeItem$chargeItemPath(id_)));
	});
var $author$project$Api$Sort$update = F2(
	function (column, _v0) {
		var model = _v0;
		var _v1 = function () {
			var _v2 = $author$project$Api$Sort$valueOrDefault(model);
			if (!_v2.$) {
				var _v3 = _v2.a;
				var currentColumn = _v3.a;
				var currentDirection = _v3.b;
				return _Utils_eq(currentColumn, column) ? ((currentDirection === 1) ? _Utils_Tuple2(column, 0) : _Utils_Tuple2(column, 1)) : _Utils_Tuple2(column, 0);
			} else {
				return _Utils_Tuple2(column, 0);
			}
		}();
		var newColumn = _v1.a;
		var newDirection = _v1.b;
		return _Utils_update(
			model,
			{
				aee: $elm$core$Maybe$Just(
					_Utils_Tuple2(newColumn, newDirection))
			});
	});
var $author$project$Components$FileLink$GotFile = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$file$File$Download$bytes = F3(
	function (name, mime, content) {
		return A2(
			$elm$core$Task$perform,
			$elm$core$Basics$never,
			A3(
				_File_download,
				name,
				mime,
				_File_makeBytesSafeForInternetExplorer(content)));
	});
var $author$project$Api$Data$formatToMimeType = function (format) {
	return 'text/csv';
};
var $elm$http$Http$expectBytesResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'arraybuffer',
			_Http_toDataView,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $author$project$Api$Data$handleBytesResponse = function (response) {
	if (response.$ === 4) {
		var metadata = response.a;
		var body = response.b;
		return $elm$core$Result$Ok(
			_Utils_Tuple2(body, metadata.jP));
	} else {
		return $elm$core$Result$Err($author$project$Api$Data$BadUrl);
	}
};
var $author$project$Api$Data$expectString = function (toMsg) {
	return A2(
		$elm$http$Http$expectBytesResponse,
		A2($elm$core$Basics$composeR, $author$project$Api$Data$fromResult, toMsg),
		$author$project$Api$Data$handleBytesResponse);
};
var $author$project$Api$Data$getFile = F3(
	function (client, url, toMsg) {
		return $elm$http$Http$request(
			{
				fO: $elm$http$Http$emptyBody,
				RT: $author$project$Api$Data$expectString(toMsg),
				jP: $author$project$Api$Data$clientHeaders(client),
				IA: $elm$core$String$toUpper('get'),
				J9: $elm$core$Maybe$Just(61 * 1000),
				vd: $elm$core$Maybe$Nothing,
				adY: url
			});
	});
var $author$project$Api$Data$getFileNameFromHeaders = function (headers) {
	return A2(
		$elm$core$Maybe$map,
		A2($elm$core$String$replace, '\"', ''),
		A2(
			$elm$core$Maybe$andThen,
			$elm$core$List$head,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$List$tail,
				A2(
					$elm$core$Maybe$map,
					$elm$core$String$split(' filename='),
					A2(
						$elm$core$Maybe$andThen,
						$elm$core$List$head,
						A2(
							$elm$core$Maybe$map,
							$elm$core$String$split('; filename*'),
							A2($elm$core$Dict$get, 'content-disposition', headers)))))));
};
var $author$project$Components$FileLink$update = function (msg) {
	if (!msg.$) {
		var client = msg.a;
		var url = msg.b;
		var format = msg.c;
		var fetchFile = A3(
			$author$project$Api$Data$getFile,
			client,
			url,
			$author$project$Components$FileLink$GotFile(format));
		return _Utils_Tuple2(fetchFile, _List_Nil);
	} else {
		var format = msg.a;
		var response = msg.b;
		if (response.$ === 3) {
			var file = response.a;
			var headers = response.b;
			var fileName = A2(
				$elm$core$Maybe$withDefault,
				'export.' + $author$project$Api$Data$formatToString(format),
				$author$project$Api$Data$getFileNameFromHeaders(headers));
			return _Utils_Tuple2(
				A3(
					$elm$file$File$Download$bytes,
					fileName,
					$author$project$Api$Data$formatToMimeType(format),
					file),
				_List_Nil);
		} else {
			return _Utils_Tuple2(
				$elm$core$Platform$Cmd$none,
				$author$project$OutMsg$handleErrorResponse(response));
		}
	}
};
var $author$project$Ui$SearchInput$None = {$: 0};
var $author$project$Ui$SearchInput$SearchChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$SearchInput$DebouncedMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$SearchInput$debounceConfig = {
	alK: $jinjor$elm_debounce$Debounce$later(300),
	ame: $author$project$Ui$SearchInput$DebouncedMsg
};
var $author$project$Ui$SearchInput$TextDebounced = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$SearchInput$debounceText = function (text) {
	return A2(
		$elm$core$Task$perform,
		$author$project$Ui$SearchInput$TextDebounced,
		$elm$core$Task$succeed(text));
};
var $author$project$Ui$SearchInput$emitSearchChanged = function (text) {
	return $author$project$Ui$SearchInput$SearchChanged(
		$author$project$Utils$String$toMaybe(text));
};
var $author$project$Ui$SearchInput$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var isImmediate = msg.a;
				var text = msg.b;
				if (isImmediate) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ac3: $author$project$Utils$String$toMaybe(text)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Ui$SearchInput$emitSearchChanged(text));
				} else {
					var _v2 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Ui$SearchInput$debounceConfig, text, model.d6);
					var newDebouncer = _v2.a;
					var cmd = _v2.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								d6: newDebouncer,
								ac3: $author$project$Utils$String$toMaybe(text)
							}),
						cmd,
						$author$project$Ui$SearchInput$None);
				}
			case 1:
				var debounceMsg = msg.a;
				var _v3 = A4(
					$jinjor$elm_debounce$Debounce$update,
					$author$project$Ui$SearchInput$debounceConfig,
					$jinjor$elm_debounce$Debounce$takeLast($author$project$Ui$SearchInput$debounceText),
					debounceMsg,
					model.d6);
				var newDebouncer = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{d6: newDebouncer}),
					cmd,
					$author$project$Ui$SearchInput$None);
			case 2:
				var text = msg.a;
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$Ui$SearchInput$emitSearchChanged(text));
			default:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ac3: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					$author$project$Ui$SearchInput$SearchChanged($elm$core$Maybe$Nothing));
		}
	});
var $author$project$Pages$Admin$ChargeItems$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 1:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bS: response,
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bS: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 2:
				var id = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bS: $author$project$Api$Data$Loading,
									eb: A2($elm$core$Set$remove, id, model.eb)
								}),
							$author$project$Pages$Admin$ChargeItems$Top$fetchItems(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Charge item successfully deleted')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									eb: A2($elm$core$Set$remove, id, model.eb)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Admin$ChargeItems$Top$fetchItems(newModel),
								$author$project$Pages$Admin$ChargeItems$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 4:
				var chargeItem = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							jb: $elm$core$Maybe$Just(chargeItem)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var id = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							jb: $elm$core$Maybe$Nothing,
							eb: A2($elm$core$Set$insert, id, model.eb)
						}),
					A3(
						$author$project$Api$Provider$ChargeItem$delete,
						model.Gv,
						id,
						$author$project$Pages$Admin$ChargeItems$Top$Deleted(id)),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{jb: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 0:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						alA: A2($author$project$Api$Sort$update, columnId, model.alA)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Admin$ChargeItems$Top$fetchItems(newModel),
								$author$project$Pages$Admin$ChargeItems$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 6:
				var subMsg = msg.a;
				var _v3 = A2($author$project$Ui$SearchInput$update, subMsg, model.up);
				var searchInput = _v3.a;
				var searchInputCmd = _v3.b;
				var searchInputEvent = _v3.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.akl;
					}
				}();
				var _v4 = function () {
					if (_Utils_eq(q, model.akl)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								bS: $author$project$Api$Data$Loading,
								ajJ: $author$project$Api$Pagination$reset(model.ajJ),
								akl: q
							});
						return _Utils_Tuple2(
							qModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Admin$ChargeItems$Top$fetchItems(qModel),
										$author$project$Pages$Admin$ChargeItems$Top$updateUrl(qModel)
									])));
					}
				}();
				var newModel = _v4.a;
				var cmd = _v4.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{up: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$ChargeItems$Top$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
			case 7:
				var subMsg = msg.a;
				var categoryResourceResult = A3($author$project$Components$ResourceFilter$Category$update, model.Gv, subMsg, model.c8);
				var categoryId = function () {
					var _v7 = categoryResourceResult.agZ;
					if (!_v7.$) {
						return $author$project$Components$ResourceFilter$Category$value(categoryResourceResult.aiO);
					} else {
						return model.iF;
					}
				}();
				var newModel = _Utils_update(
					model,
					{iF: categoryId, c8: categoryResourceResult.aiO});
				var _v6 = _Utils_eq(model.iF, newModel.iF) ? _Utils_Tuple2(model.bS, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					$author$project$Api$Data$Loading,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Admin$ChargeItems$Top$fetchItems(newModel),
								$author$project$Pages$Admin$ChargeItems$Top$updateUrl(newModel)
							])));
				var chargeItems = _v6.a;
				var cmd = _v6.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{bS: chargeItems}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$ChargeItems$Top$CategoryResourceFilterMsg, categoryResourceResult.GZ),
								cmd
							])),
					categoryResourceResult.aR);
			case 8:
				var subMsg = msg.a;
				var _v8 = A2($author$project$Ui$Dropdown$update, subMsg, model.n0);
				var inventoryDropdown = _v8.a;
				var cmd = _v8.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{n0: inventoryDropdown}),
					cmd,
					_List_Nil);
			case 9:
				var selectedStatus = msg.a;
				var newModel = _Utils_update(
					model,
					{
						bS: $author$project$Api$Data$Loading,
						Ia: selectedStatus,
						ajJ: $author$project$Api$Pagination$reset(model.ajJ)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Admin$ChargeItems$Top$fetchItems(newModel),
								$author$project$Pages$Admin$ChargeItems$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 10:
				var subMsg = msg.a;
				var _v9 = A2($author$project$Ui$Dropdown$update, subMsg, model.oe);
				var itemTypeDropdown = _v9.a;
				var cmd = _v9.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oe: itemTypeDropdown}),
					cmd,
					_List_Nil);
			case 11:
				var selectedType = msg.a;
				var newModel = _Utils_update(
					model,
					{
						bS: $author$project$Api$Data$Loading,
						sW: selectedType,
						ajJ: $author$project$Api$Pagination$reset(model.ajJ)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Admin$ChargeItems$Top$fetchItems(newModel),
								$author$project$Pages$Admin$ChargeItems$Top$updateUrl(newModel)
							])),
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v10 = $author$project$Components$FileLink$update(subMsg);
				var getFileCmdMsg = _v10.a;
				var outMsgs = _v10.b;
				return _Utils_Tuple3(
					model,
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$ChargeItems$Top$ExportFileMsg, getFileCmdMsg),
					outMsgs);
		}
	});
var $author$project$Pages$Admin$ChargeItems$Top$PaginationMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Link$ButtonDefault = 2;
var $author$project$Ui$Link$buttonDefault = $author$project$Ui$Link$Style(2);
var $author$project$Ui$Link$Icon = function (a) {
	return {$: 13, a: a};
};
var $author$project$Ui$Link$icon = $author$project$Ui$Link$Icon;
var $author$project$Ui$SearchInput$Clear = {$: 3};
var $author$project$Ui$SearchInput$InputChanged = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Ui$Form$Input$AutoCapitalize = function (a) {
	return {$: 16, a: a};
};
var $author$project$Ui$Form$Input$autoCapitalize = $author$project$Ui$Form$Input$AutoCapitalize;
var $author$project$Ui$Form$Input$AutoComplete = function (a) {
	return {$: 14, a: a};
};
var $author$project$Ui$Form$Input$autoComplete = $author$project$Ui$Form$Input$AutoComplete;
var $author$project$Ui$Form$Input$Id = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$Input$id = $author$project$Ui$Form$Input$Id;
var $author$project$Ui$SearchInput$defaultOptions = {xu: false, ahP: $elm$core$Maybe$Nothing, z8: false, V8: false, Da: false, aj3: 'Search'};
var $author$project$Ui$SearchInput$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var string = option.a;
						return _Utils_update(
							record,
							{aj3: string});
					case 1:
						var bool = option.a;
						return _Utils_update(
							record,
							{Da: bool});
					case 2:
						var bool = option.a;
						return _Utils_update(
							record,
							{V8: bool});
					case 3:
						var bool = option.a;
						return _Utils_update(
							record,
							{xu: bool});
					case 4:
						var string = option.a;
						return _Utils_update(
							record,
							{
								ahP: $elm$core$Maybe$Just(string)
							});
					default:
						return _Utils_update(
							record,
							{z8: true});
				}
			}),
		$author$project$Ui$SearchInput$defaultOptions,
		options);
};
var $author$project$Ui$Form$Input$Wrapped = function (a) {
	return {$: 22, a: a};
};
var $author$project$Ui$Form$Input$wrapped = $author$project$Ui$Form$Input$Wrapped;
var $author$project$Ui$SearchInput$view = F2(
	function (options, _v0) {
		var model = _v0;
		var optionsRecord = $author$project$Ui$SearchInput$optionsToRecord(options);
		return $author$project$Ui$Form$Input$view(
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							$author$project$Ui$Form$Input$value(
							A2($elm$core$Maybe$withDefault, '', model.ac3)),
							$author$project$Ui$Form$Input$placeholder(optionsRecord.aj3),
							$author$project$Ui$Form$Input$phi(optionsRecord.Da),
							$author$project$Ui$Form$Input$onInput(
							$author$project$Ui$SearchInput$InputChanged(optionsRecord.z8)),
							$author$project$Ui$Form$Input$autofocus(optionsRecord.xu),
							$author$project$Ui$Form$Input$autoComplete(false),
							$author$project$Ui$Form$Input$autoCapitalize(false),
							$author$project$Ui$Form$Input$test('search-input'),
							$author$project$Ui$Form$Input$wrapped(
							_List_fromArray(
								[
									function () {
									var _v1 = model.ac3;
									if (!_v1.$) {
										return A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('input-wrapper__icon cursor-pointer'),
													$elm$html$Html$Events$onClick($author$project$Ui$SearchInput$Clear)
												]),
											_List_fromArray(
												[
													$author$project$Ui$Icon$cross(_List_Nil)
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								]))
						]),
						function () {
						var _v2 = optionsRecord.ahP;
						if (!_v2.$) {
							var idValue = _v2.a;
							return _List_fromArray(
								[
									$author$project$Ui$Form$Input$id(idValue)
								]);
						} else {
							return _List_Nil;
						}
					}()
					])));
	});
var $author$project$Pages$Admin$ChargeItems$Top$viewCategoryResourceFilter = function (categoryResourceFilter) {
	return A2(
		$elm$html$Html$map,
		$author$project$Pages$Admin$ChargeItems$Top$CategoryResourceFilterMsg,
		A2($author$project$Components$ResourceFilter$Category$view, _List_Nil, categoryResourceFilter));
};
var $author$project$Pages$Admin$ChargeItems$Top$InventoryStatusSelected = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Admin$ChargeItems$Top$stockStatusToLabel = function (status) {
	switch (status) {
		case 0:
			return 'In Stock';
		case 1:
			return 'Low Inventory';
		default:
			return 'Out of Stock';
	}
};
var $author$project$Pages$Admin$ChargeItems$Top$viewInventoryDropdown = function (model) {
	var currentLabel = function () {
		var _v0 = model.Ia;
		if (!_v0.$) {
			var status = _v0.a;
			return $author$project$Pages$Admin$ChargeItems$Top$stockStatusToLabel(status);
		} else {
			return 'All Inventory';
		}
	}();
	var allStatuses = _List_fromArray(
		[0, 1, 2]);
	var items = A2(
		$elm$core$List$cons,
		A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Pages$Admin$ChargeItems$Top$InventoryStatusSelected($elm$core$Maybe$Nothing))
				]),
			$elm$html$Html$text('All Inventory')),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$Dropdown$separator,
			A2(
				$elm$core$List$map,
				function (status) {
					return A2(
						$author$project$Ui$Dropdown$item,
						_List_fromArray(
							[
								$author$project$Ui$Dropdown$onSelect(
								$author$project$Pages$Admin$ChargeItems$Top$InventoryStatusSelected(
									$elm$core$Maybe$Just(status)))
							]),
						$elm$html$Html$text(
							$author$project$Pages$Admin$ChargeItems$Top$stockStatusToLabel(status)));
				},
				allStatuses)));
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(currentLabel)
			]),
		items,
		model.n0);
};
var $author$project$Pages$Admin$ChargeItems$Top$ItemTypeSelected = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Admin$ChargeItems$Top$itemTypeToLabel = function (itemType) {
	if (!itemType) {
		return 'Items';
	} else {
		return 'Packages';
	}
};
var $author$project$Pages$Admin$ChargeItems$Top$viewItemTypeDropdown = function (model) {
	var itemTypes = _List_fromArray(
		[1, 0]);
	var items = A2(
		$elm$core$List$cons,
		A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Pages$Admin$ChargeItems$Top$ItemTypeSelected($elm$core$Maybe$Nothing))
				]),
			$elm$html$Html$text('All Item Types')),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$Dropdown$separator,
			A2(
				$elm$core$List$map,
				function (itemType) {
					return A2(
						$author$project$Ui$Dropdown$item,
						_List_fromArray(
							[
								$author$project$Ui$Dropdown$onSelect(
								$author$project$Pages$Admin$ChargeItems$Top$ItemTypeSelected(
									$elm$core$Maybe$Just(itemType)))
							]),
						$elm$html$Html$text(
							$author$project$Pages$Admin$ChargeItems$Top$itemTypeToLabel(itemType)));
				},
				itemTypes)));
	var currentLabel = function () {
		var _v0 = model.sW;
		if (!_v0.$) {
			var itemType = _v0.a;
			return $author$project$Pages$Admin$ChargeItems$Top$itemTypeToLabel(itemType);
		} else {
			return 'All Item Types';
		}
	}();
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(currentLabel)
			]),
		items,
		model.oe);
};
var $author$project$Api$Data$CSV = 0;
var $author$project$Ui$Tooltip$Left = 2;
var $author$project$Pages$Admin$ChargeItems$Top$SortTable = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Column$Sortable = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Ui$Link$AriaLabel = function (a) {
	return {$: 15, a: a};
};
var $author$project$Ui$Link$ariaLabel = $author$project$Ui$Link$AriaLabel;
var $author$project$Api$Data$downloadUrl = F4(
	function (_v0, path, format, queryParams) {
		var client = _v0;
		var absolutePath = A2(
			$elm$url$Url$Builder$crossOrigin,
			client.Du,
			A2(
				$elm$core$List$cons,
				'api',
				A2(
					$author$project$Api$Data$pathToPieces,
					$elm$core$Maybe$Just(format),
					path)));
		return absolutePath(queryParams);
	});
var $author$project$Pages$Admin$ChargeItems$Top$exportCsvPath = function (model) {
	var csvParams = A2(
		$elm$core$List$concatMap,
		$author$project$Api$Param$toQuery,
		$author$project$Api$Provider$ChargeItem$listOptionsToParams(
			$author$project$Pages$Admin$ChargeItems$Top$fetchParams(model)));
	return A4($author$project$Api$Data$downloadUrl, model.Gv, $author$project$Api$Provider$ChargeItem$chargeItemsPath, 0, csvParams);
};
var $author$project$Ui$Panel$Table = F4(
	function (a, b, c, d) {
		return {$: 3, a: a, b: b, c: c, d: d};
	});
var $author$project$Ui$Panel$table = $author$project$Ui$Panel$Table;
var $author$project$Ui$Icon$Upload = 52;
var $author$project$Ui$Icon$upload = $author$project$Ui$Icon$viewIcon(52);
var $author$project$Ui$Table$OnClick = function (a) {
	return {$: 11, a: a};
};
var $author$project$Ui$Table$onClick = $author$project$Ui$Table$OnClick;
var $author$project$Ui$Table$Sortable = function (a) {
	return {$: 13, a: a};
};
var $author$project$Ui$Table$sortable = $author$project$Ui$Table$Sortable;
var $author$project$Ui$Table$Asc = 0;
var $author$project$Ui$Table$Desc = 1;
var $author$project$Api$Sort$directionToTable = function (direction) {
	if (!direction) {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$Ui$Table$SortDirection = function (a) {
	return {$: 14, a: a};
};
var $author$project$Ui$Table$sortDirection = $author$project$Ui$Table$SortDirection;
var $author$project$Api$Sort$toTable = F2(
	function (column, _v0) {
		var model = _v0;
		var _v1 = $author$project$Api$Sort$valueOrDefault(model);
		if (!_v1.$) {
			var _v2 = _v1.a;
			var currentColumn = _v2.a;
			var currentDirection = _v2.b;
			return _Utils_eq(currentColumn, column) ? _List_fromArray(
				[
					$author$project$Ui$Table$sortDirection(
					$author$project$Api$Sort$directionToTable(currentDirection))
				]) : _List_Nil;
		} else {
			return _List_Nil;
		}
	});
var $author$project$Api$Column$view = F2(
	function (type_, _v0) {
		var column = _v0;
		var atributtesFromType = function () {
			if (!type_.$) {
				var sort = type_.a;
				var toMsg = type_.b;
				return $elm$core$List$concat(
					_List_fromArray(
						[
							_List_fromArray(
							[
								$author$project$Ui$Table$sortable(column.JP)
							]),
							column.JP ? _List_fromArray(
							[
								$author$project$Ui$Table$onClick(
								toMsg(column.ahP))
							]) : _List_Nil,
							A2($author$project$Api$Sort$toTable, column.ahP, sort)
						]));
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$author$project$Ui$Table$header,
			_Utils_ap(atributtesFromType, column.Cd),
			_List_fromArray(
				[
					$elm$html$Html$text(column.Bq)
				]));
	});
var $author$project$Components$FileLink$ExportClicked = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Components$FileLink$view = F3(
	function (_v0, linkOptions, linkContent) {
		var client = _v0.NJ;
		var url = _v0.adY;
		var format = _v0.SG;
		return A3(
			$author$project$Ui$Link$externalHref,
			'#',
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Link$onClick(
					A3($author$project$Components$FileLink$ExportClicked, client, url, format)),
				linkOptions),
			linkContent);
	});
var $author$project$Pages$Admin$ChargeItems$Top$OpenHiConfirm = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Feature$UnifiedExperience = 19;
var $author$project$Utils$Clinical$getHost = F3(
	function (isUnifiedExperience, origin, emrHost) {
		return isUnifiedExperience ? origin : emrHost;
	});
var $author$project$Utils$Clinical$getInventoryUrl = F4(
	function (isUnifiedExperience, origin, emrHost, searchTerm) {
		return A3($author$project$Utils$Clinical$getHost, isUnifiedExperience, origin, emrHost) + ('/inventory/list?search=' + searchTerm);
	});
var $author$project$Api$Provider$ChargeItem$All$isMedication = function (chargeItem) {
	var _v0 = A2(
		$elm$core$Maybe$map,
		$author$project$Api$Provider$Category$Shared$name,
		$author$project$Api$Provider$ChargeItem$All$category(chargeItem));
	if (!_v0.$) {
		var categoryName_ = _v0.a;
		return categoryName_ === 'Medications';
	} else {
		return false;
	}
};
var $author$project$Api$Provider$ChargeItem$All$lastSetQuantity = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$lastSetQuantity(shared);
};
var $author$project$Api$Provider$ChargeItem$Shared$lastUsedAt = function (_v0) {
	var record = _v0.b;
	return record.VO;
};
var $author$project$Api$Provider$ChargeItem$All$lastUsedAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$lastUsedAt(shared);
};
var $author$project$Api$Provider$ChargeItem$Shared$lowInventory = function (_v0) {
	var record = _v0.b;
	return record.Wm;
};
var $author$project$Api$Provider$ChargeItem$All$lowInventory = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$lowInventory(shared);
};
var $author$project$Api$Provider$ChargeItem$Shared$outOfStock = function (_v0) {
	var record = _v0.b;
	return record.Yz;
};
var $author$project$Api$Provider$ChargeItem$All$outOfStock = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$outOfStock(shared);
};
var $author$project$Pages$Admin$ChargeItems$Top$viewItem = F6(
	function (practice, origin, emrHost, timeFormatter, deletingChargeItems, chargeItem) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$ChargeItem$All$name(chargeItem)),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									function () {
									var _v0 = $author$project$Api$Provider$ChargeItem$All$lastUsedAt(chargeItem);
									if (!_v0.$) {
										var lastUsedAt = _v0.a;
										return A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
											'Last charged ' + A2(timeFormatter, 1, lastUsedAt));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$formatFromFloat(
										$author$project$Api$Provider$ChargeItem$All$priceInCents(chargeItem))),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
									'per '),
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
									$author$project$Api$Provider$Uom$Shared$name(
										$author$project$Api$Provider$ChargeItem$All$uom(chargeItem))),
									function () {
									var _v1 = _Utils_Tuple2(
										$author$project$Api$Provider$ChargeItem$All$lastSetQuantity(chargeItem),
										$author$project$Api$Provider$ChargeItem$All$quantityInStock(chargeItem));
									if ((!_v1.a.$) && (!_v1.b.$)) {
										var lastSetQuantity = _v1.a.a;
										var quantityInStock = _v1.b.a;
										return A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$elm$core$String$fromInt(quantityInStock)),
													$elm$html$Html$text('/'),
													$elm$html$Html$text(
													$elm$core$String$fromInt(lastSetQuantity))
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}(),
									function () {
									var _v2 = _Utils_Tuple2(
										$author$project$Api$Provider$ChargeItem$All$lowInventory(chargeItem),
										$author$project$Api$Provider$ChargeItem$All$quantityInStock(chargeItem));
									if (_v2.a) {
										if (_v2.b.$ === 1) {
											var _v3 = _v2.b;
											return $author$project$Utils$Html$empty;
										} else {
											if (!_v2.b.a) {
												return $author$project$Utils$Html$empty;
											} else {
												return A2(
													$author$project$Ui$Typography$label,
													_List_fromArray(
														[$author$project$Ui$Typography$warning]),
													_List_fromArray(
														[
															$elm$html$Html$text('Low Inventory')
														]));
											}
										}
									} else {
										return $author$project$Utils$Html$empty;
									}
								}(),
									$author$project$Api$Provider$ChargeItem$All$outOfStock(chargeItem) ? A2(
									$author$project$Ui$Typography$label,
									_List_fromArray(
										[$author$project$Ui$Typography$danger]),
									_List_fromArray(
										[
											$elm$html$Html$text('Out of Stock')
										])) : $author$project$Utils$Html$empty
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										A2(
											$elm$core$Maybe$map,
											$author$project$Api$Provider$Category$Shared$name,
											$author$project$Api$Provider$ChargeItem$All$category(chargeItem))))
								]))
						]),
						A2(
						$author$project$Utils$FeatureGate$gateAvailable,
						14,
						$author$project$Api$Practice$Provider(practice)) ? _List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm_community$string_extra$String$Extra$toTitleCase(
										$author$project$Api$Provider$ChargeItem$Shared$itemTypeToString(
											$author$project$Api$Provider$ChargeItem$All$itemType(chargeItem))))
								]))
						]) : _List_Nil,
						A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A3(
							$author$project$Utils$FeatureGate$customGate,
							2,
							$author$project$Api$Practice$Provider(practice),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Table$cell,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$span,
											_List_fromArray(
												[$author$project$Ui$Typography$italic]),
											_List_fromArray(
												[
													$author$project$Api$Provider$ChargeItem$All$taxable(chargeItem) ? $author$project$Ui$Icon$check(
													_List_fromArray(
														[$author$project$Ui$Icon$success])) : $author$project$Ui$Icon$cross(
													_List_fromArray(
														[$author$project$Ui$Icon$danger]))
												]))
										]))
								]))),
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$gap2, $author$project$Ui$Element$justifyRight]),
									function () {
										if (A2($author$project$Api$Provider$Practice$One$featureEnabled, 6, practice) && $author$project$Api$Provider$ChargeItem$All$isMedication(chargeItem)) {
											var isUnifiedExperience = A2($author$project$Api$Provider$Practice$One$featureEnabled, 19, practice);
											var chargeItemName = $author$project$Api$Provider$ChargeItem$All$name(chargeItem);
											if (isUnifiedExperience) {
												return _List_fromArray(
													[
														A3(
														$author$project$Ui$Link$route,
														$author$project$Spa$Generated$Route$Inventory__List,
														_List_fromArray(
															[
																$author$project$Ui$Link$sm,
																$author$project$Ui$Link$icon($author$project$Ui$Icon$edit),
																$author$project$Ui$Link$routeParams(
																_List_fromArray(
																	[
																		A2($elm$url$Url$Builder$string, 'search', chargeItemName)
																	]))
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Edit')
															]))
													]);
											} else {
												var emrInventoryUrl = A4($author$project$Utils$Clinical$getInventoryUrl, false, origin, emrHost, chargeItemName);
												return _List_fromArray(
													[
														A3(
														$author$project$Ui$Link$externalHref,
														emrInventoryUrl,
														_List_fromArray(
															[
																$author$project$Ui$Link$sm,
																$author$project$Ui$Link$targetBlank,
																$author$project$Ui$Link$icon($author$project$Ui$Icon$launch)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Edit in Clinical')
															]))
													]);
											}
										} else {
											var id = $author$project$Api$Provider$ChargeItem$All$id(chargeItem);
											var loading = A2($elm$core$Set$member, id, deletingChargeItems);
											return _List_fromArray(
												[
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Admin__ChargeItems__Id_String(
														{ahP: id}),
													_List_fromArray(
														[
															$author$project$Ui$Link$sm,
															$author$project$Ui$Link$icon($author$project$Ui$Icon$edit)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Edit')
														])),
													A3(
													$author$project$Ui$Button$view,
													{mm: 'Delete charge item'},
													_List_fromArray(
														[
															$author$project$Ui$Button$link,
															$author$project$Ui$Button$sm,
															$author$project$Ui$Button$loading(loading),
															$author$project$Ui$Button$onClick(
															$author$project$Pages$Admin$ChargeItems$Top$OpenHiConfirm(chargeItem)),
															$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Delete')
														]))
												]);
										}
									}())
								]))
						])
					])));
	});
var $author$project$Pages$Admin$ChargeItems$Top$viewPanelTable = function (model) {
	var zeroStateText = A2(
		$author$project$Utils$FeatureGate$gateAvailable,
		14,
		$author$project$Api$Practice$Provider(model.ZV)) ? 'No charge items or packages found.' : 'No charge items found.';
	var _v0 = function () {
		var _v1 = model.bS;
		if (_v1.$ === 3) {
			var chargeItems_ = _v1.a;
			return _Utils_Tuple2(false, chargeItems_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var chargeItems = _v0.b;
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$verticalCentered,
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text(zeroStateText)
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$map,
					$author$project$Api$Column$view(
						A2($author$project$Api$Column$Sortable, model.alA, $author$project$Pages$Admin$ChargeItems$Top$SortTable)),
					model.N3),
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[$author$project$Ui$Table$textRight]),
						_List_fromArray(
							[
								((!A2($author$project$Api$Provider$Practice$One$featureEnabled, 6, model.ZV)) || model.Ij) ? A3(
								$author$project$Ui$Tooltip$view,
								_List_fromArray(
									[
										$author$project$Ui$Tooltip$placement(2)
									]),
								'Upload from CSV',
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Admin__ChargeItems__Upload,
										_List_fromArray(
											[
												$author$project$Ui$Link$icon($author$project$Ui$Icon$upload),
												$author$project$Ui$Link$ariaLabel('Upload')
											]),
										_List_Nil)
									])) : $elm$html$Html$text(''),
								A3(
								$author$project$Ui$Tooltip$view,
								_List_fromArray(
									[
										$author$project$Ui$Tooltip$placement(2)
									]),
								'Export to CSV',
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Pages$Admin$ChargeItems$Top$ExportFileMsg,
										A3(
											$author$project$Components$FileLink$view,
											{
												NJ: model.Gv,
												SG: 0,
												adY: $author$project$Pages$Admin$ChargeItems$Top$exportCsvPath(model)
											},
											_List_fromArray(
												[
													$author$project$Ui$Link$ariaLabel('Export CSV'),
													$author$project$Ui$Link$icon($author$project$Ui$Icon$export)
												]),
											_List_Nil))
									]))
							]))
					])
				])),
		A2(
			$elm$core$List$map,
			A5($author$project$Pages$Admin$ChargeItems$Top$viewItem, model.ZV, model.ajG, model.agP, model.J7, model.eb),
			chargeItems),
		_List_Nil);
};
var $author$project$Pages$Admin$ChargeItems$Top$view = function (model) {
	var packagesEnabled = A2(
		$author$project$Utils$FeatureGate$gateAvailable,
		14,
		$author$project$Api$Practice$Provider(model.ZV));
	return {
		fO: _List_fromArray(
			[
				function () {
				var _v0 = model.jb;
				if (!_v0.$) {
					var chargeItem = _v0.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Admin$ChargeItems$Top$HiConfirmClosed(
							$author$project$Api$Provider$ChargeItem$All$id(chargeItem)),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('delete'),
								$author$project$Components$HiConfirm$noun('charge item'),
								$author$project$Components$HiConfirm$detail(
								$author$project$Api$Provider$ChargeItem$All$name(chargeItem) + ' and remove it from all existing charges')
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_fromArray(
							[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text(
										packagesEnabled ? 'Charge Items & Packages' : 'Charge Items')
									])),
								A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Admin__ChargeItems__New,
								_List_fromArray(
									[
										$author$project$Ui$Link$buttonDefault,
										$author$project$Ui$Link$icon($author$project$Ui$Icon$add)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										packagesEnabled ? 'New Item or Package' : 'New Item')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$row,
								_List_Nil,
								$elm$core$List$concat(
									_List_fromArray(
										[
											_List_fromArray(
											[
												A2(
												$author$project$Ui$Grid$column,
												_List_fromArray(
													[
														$author$project$Ui$Grid$span(4)
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$map,
														$author$project$Pages$Admin$ChargeItems$Top$SearchInputMsg,
														A2($author$project$Ui$SearchInput$view, _List_Nil, model.up))
													])),
												A2(
												$author$project$Ui$Grid$column,
												_List_fromArray(
													[
														$author$project$Ui$Grid$span(3)
													]),
												_List_fromArray(
													[
														$author$project$Pages$Admin$ChargeItems$Top$viewCategoryResourceFilter(model.c8)
													]))
											]),
											A2(
											$author$project$Utils$FeatureGate$gateAvailable,
											14,
											$author$project$Api$Practice$Provider(model.ZV)) ? _List_fromArray(
											[
												A2(
												$author$project$Ui$Grid$column,
												_List_fromArray(
													[
														$author$project$Ui$Grid$span(2)
													]),
												_List_fromArray(
													[
														$author$project$Pages$Admin$ChargeItems$Top$viewItemTypeDropdown(model)
													]))
											]) : _List_Nil,
											_List_fromArray(
											[
												A2(
												$author$project$Ui$Grid$column,
												_List_fromArray(
													[
														$author$project$Ui$Grid$span(3)
													]),
												_List_fromArray(
													[
														A3(
														$author$project$Utils$FeatureGate$gate,
														2,
														$author$project$Api$Practice$Provider(model.ZV),
														$author$project$Pages$Admin$ChargeItems$Top$viewInventoryDropdown(model))
													]))
											])
										])))
							])),
						$author$project$Pages$Admin$ChargeItems$Top$viewPanelTable(model),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Admin$ChargeItems$Top$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(
											!$author$project$Api$Data$isSuccess(model.bS))
										]),
									model.ajJ))
							]))
					]))
			]),
		ac9: packagesEnabled ? 'Admin | Charge Items & Packages' : 'Admin | Charge Items'
	};
};
var $author$project$Pages$Admin$ChargeItems$Top$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$ChargeItems$Top$init, aiq: $author$project$Pages$Admin$ChargeItems$Top$load, k8: $author$project$Pages$Admin$ChargeItems$Top$save, alO: $author$project$Pages$Admin$ChargeItems$Top$subscriptions, adT: $author$project$Pages$Admin$ChargeItems$Top$update, amo: $author$project$Pages$Admin$ChargeItems$Top$view});
var $author$project$Api$Upload$Resource$ChargeItem = 1;
var $author$project$Pages$Admin$ChargeItems$Upload$UploadFormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Upload$Form$GotPendingUploads = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Upload$Form$GotUploadColumns = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Common$Upload$ListOptionals$Pending = 0;
var $author$project$Api$Provider$Upload$All$Upload = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Common$Upload$Shared$Upload = $elm$core$Basics$identity;
var $author$project$Api$Common$Upload$Shared$Record = function (id) {
	return function (name) {
		return function (createdAt) {
			return function (status) {
				return function (rowsTotal) {
					return function (rowsProcessedOrIgnored) {
						return function (rowsFailed) {
							return function (rowsSupressed) {
								return function (errorMessage) {
									return function (startedAt) {
										return function (finishedAt) {
											return function (uploaderType) {
												return {O1: createdAt, RM: errorMessage, Ss: finishedAt, ahP: id, Bq: name, aad: rowsFailed, aaf: rowsProcessedOrIgnored, aag: rowsSupressed, aah: rowsTotal, aca: startedAt, alH: status, adW: uploaderType};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Upload$Status$Cancelled = 13;
var $author$project$Api$Upload$Status$Downloading = 1;
var $author$project$Api$Upload$Status$EnqueuedForPreprocessing = 2;
var $author$project$Api$Upload$Status$EnqueuedForProcessing = 7;
var $author$project$Api$Upload$Status$Failed = 12;
var $author$project$Api$Upload$Status$Postprocessing = 10;
var $author$project$Api$Upload$Status$Preprocessing = 4;
var $author$project$Api$Upload$Status$Processed = 11;
var $author$project$Api$Upload$Status$Processing = 9;
var $author$project$Api$Upload$Status$ReadyToPreprocess = 3;
var $author$project$Api$Upload$Status$ReadyToProcess = 8;
var $author$project$Api$Upload$Status$ReviewDataMatches = 5;
var $author$project$Api$Upload$Status$ReviewFileSize = 6;
var $author$project$Api$Upload$Status$Unattempted = 0;
var $author$project$Api$Upload$Status$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'unattempted':
				return $elm$json$Json$Decode$succeed(0);
			case 'downloading':
				return $elm$json$Json$Decode$succeed(1);
			case 'enqueued_for_preprocessing':
				return $elm$json$Json$Decode$succeed(2);
			case 'ready_to_preprocess':
				return $elm$json$Json$Decode$succeed(3);
			case 'preprocessing':
				return $elm$json$Json$Decode$succeed(4);
			case 'review_data_matches':
				return $elm$json$Json$Decode$succeed(5);
			case 'review_file_size':
				return $elm$json$Json$Decode$succeed(6);
			case 'enqueued_for_processing':
				return $elm$json$Json$Decode$succeed(7);
			case 'ready_to_process':
				return $elm$json$Json$Decode$succeed(8);
			case 'processing':
				return $elm$json$Json$Decode$succeed(9);
			case 'postprocessing':
				return $elm$json$Json$Decode$succeed(10);
			case 'processed':
				return $elm$json$Json$Decode$succeed(11);
			case 'failed':
				return $elm$json$Json$Decode$succeed(12);
			case 'cancelled':
				return $elm$json$Json$Decode$succeed(13);
			default:
				return $elm$json$Json$Decode$fail('Unsupported upload status: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Upload$UploaderType$Other = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Upload$UploaderType$SponsorAutosync = {$: 0};
var $author$project$Api$Upload$UploaderType$SponsorManual = {$: 1};
var $author$project$Api$Upload$UploaderType$SponsorManualV2 = {$: 2};
var $author$project$Api$Upload$UploaderType$decoder = A2(
	$elm$json$Json$Decode$map,
	function (string) {
		switch (string) {
			case 'sponsor_autosync':
				return $author$project$Api$Upload$UploaderType$SponsorAutosync;
			case 'sponsor_manual':
				return $author$project$Api$Upload$UploaderType$SponsorManual;
			case 'sponsor_manual_v2':
				return $author$project$Api$Upload$UploaderType$SponsorManualV2;
			default:
				var somethingElse = string;
				return $author$project$Api$Upload$UploaderType$Other(somethingElse);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Common$Upload$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'uploader_type',
	$author$project$Api$Upload$UploaderType$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'finished_at',
		$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'started_at',
			$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'error_message',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'rows_supressed',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'rows_failed',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'rows_processed_or_ignored',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'rows_total',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'status',
									$author$project$Api$Upload$Status$decoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'created_at',
										$elm_community$json_extra$Json$Decode$Extra$datetime,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'name',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'id',
												$elm$json$Json$Decode$string,
												$elm$json$Json$Decode$succeed($author$project$Api$Common$Upload$Shared$Record)))))))))))));
var $author$project$Api$Common$Upload$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Upload$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Upload$All$Record = function (meta) {
	return {W4: meta};
};
var $author$project$Api$Provider$Upload$Meta$Meta = $elm$core$Basics$identity;
var $author$project$Api$Provider$Upload$Meta$Record = function (actions) {
	return {vy: actions};
};
var $author$project$Api$Provider$Upload$Meta$ActionsRecord = F4(
	function (preprocess, process, duplicate, cancel) {
		return {Nl: cancel, QZ: duplicate, _f: preprocess, _p: process};
	});
var $author$project$Api$Provider$Upload$Meta$actionsRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'cancel',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'duplicate',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'process',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'preprocess',
				$elm$json$Json$Decode$bool,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$Upload$Meta$ActionsRecord)))));
var $author$project$Api$Provider$Upload$Meta$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'actions',
	$author$project$Api$Provider$Upload$Meta$actionsRecordDecoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Upload$Meta$Record));
var $author$project$Api$Provider$Upload$Meta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Upload$Meta$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Upload$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'meta',
	$author$project$Api$Provider$Upload$Meta$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Upload$All$Record));
var $author$project$Api$Provider$Upload$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Upload$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Common$Upload$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Upload$All$Upload)));
var $author$project$Api$Common$Upload$ListOptionals$defaults = {HM: $elm$core$Maybe$Nothing, ajJ: $author$project$Api$Pagination$init, akl: $elm$core$Maybe$Nothing, Jy: $elm$core$Maybe$Nothing};
var $author$project$Api$Common$Upload$ListOptionals$filterToString = function (filter) {
	return 'pending';
};
var $author$project$Api$Upload$Resource$toString = function (resource) {
	switch (resource) {
		case 0:
			return 'credit';
		case 1:
			return 'chargeitem';
		case 2:
			return 'practitioner';
		case 3:
			return 'patient';
		case 5:
			return 'membership';
		case 4:
			return 'charge';
		case 6:
			return 'payment_method_import';
		default:
			return 'patient_note';
	}
};
var $author$project$Api$Common$Upload$ListOptionals$toParams = function (optionals) {
	var options = optionals($author$project$Api$Common$Upload$ListOptionals$defaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.HM;
				if (!_v0.$) {
					var filter = _v0.a;
					return _List_fromArray(
						[
							A2(
							$author$project$Api$Param$string,
							'filter',
							$author$project$Api$Common$Upload$ListOptionals$filterToString(filter))
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.Jy;
				if (!_v1.$) {
					var resource = _v1.a;
					return _List_fromArray(
						[
							A2(
							$author$project$Api$Param$string,
							'type',
							$author$project$Api$Upload$Resource$toString(resource))
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.akl;
				if (!_v2.$) {
					var string = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$Provider$Upload$uploadsPath = function (basePath) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['uploads']),
		basePath);
};
var $author$project$Api$Provider$Upload$list = F4(
	function (basePath, apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Upload$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Common$Upload$ListOptionals$toParams(optionals),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Upload$uploadsPath(basePath))));
	});
var $author$project$Api$Provider$Upload$Column$UploadColumns = $elm$core$Basics$identity;
var $author$project$Api$Provider$Upload$Column$UploadColumnsRecord = F2(
	function (columns, ignoredColumns) {
		return {N3: columns, TN: ignoredColumns};
	});
var $author$project$Api$Provider$Upload$Column$Column = $elm$core$Basics$identity;
var $author$project$Api$Provider$Upload$Column$ColumnRecord = F6(
	function (name, aliases, help, required, allowedValues, _default) {
		return {Ln: aliases, LB: allowedValues, PW: _default, Tp: help, Bq: name, akR: required};
	});
var $author$project$Api$Provider$Upload$Column$columnRecordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'default',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'allowed_values',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'required',
			$elm$json$Json$Decode$bool,
			false,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'help',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'aliases',
					$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'name',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$Upload$Column$ColumnRecord)))))));
var $author$project$Api$Provider$Upload$Column$columnDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Upload$Column$columnRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Upload$Column$uploadColumnsRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'ignored_columns',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'columns',
		$elm$json$Json$Decode$list($author$project$Api$Provider$Upload$Column$columnDecoder),
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Upload$Column$UploadColumnsRecord)));
var $author$project$Api$Provider$Upload$Column$uploadColumnsDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Upload$Column$uploadColumnsRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Upload$Column$uploadColumnsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['uploads', 'columns']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Upload$Column$retrieve = F3(
	function (apiClient, resource, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Upload$Column$uploadColumnsDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2(
						$author$project$Api$Param$string,
						'type',
						$author$project$Api$Upload$Resource$toString(resource))
					]),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Upload$Column$uploadColumnsPath)));
	});
var $author$project$Components$Upload$Form$init = F4(
	function (timeFormatter, apiClient, resource, companyId) {
		return _Utils_Tuple2(
			{xR: true, fZ: companyId, U5: $author$project$Api$Data$NotAsked, C9: $author$project$Api$Data$Loading, Jy: resource, p2: false, uE: false, J7: timeFormatter, FZ: $author$project$Api$Data$NotAsked, F_: $author$project$Api$Data$Loading, h5: $elm$core$Maybe$Nothing},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3($author$project$Api$Provider$Upload$Column$retrieve, apiClient, resource, $author$project$Components$Upload$Form$GotUploadColumns),
						A4(
						$author$project$Api$Provider$Upload$list,
						$author$project$Api$Data$providerPath,
						apiClient,
						function (d) {
							return _Utils_update(
								d,
								{
									HM: $elm$core$Maybe$Just(0),
									Jy: $elm$core$Maybe$Just(resource)
								});
						},
						$author$project$Components$Upload$Form$GotPendingUploads)
					])));
	});
var $author$project$Pages$Admin$ChargeItems$Upload$init = F4(
	function (_v0, practice, shared, _v1) {
		var _v2 = A4($author$project$Components$Upload$Form$init, shared.J7, shared.Gv, 1, $elm$core$Maybe$Nothing);
		var uploadForm = _v2.a;
		var uploadFormCmd = _v2.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, ne: false, SD: uploadForm, ZV: practice},
			A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$ChargeItems$Upload$UploadFormMsg, uploadFormCmd));
	});
var $author$project$Pages$Admin$ChargeItems$Upload$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$ChargeItems$Upload$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Upload$Form$CloseCannotUploadModal = {$: 8};
var $author$project$Components$Upload$Form$UploadResultMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Upload$CannotUploadModal$subscribeToEscapeKeyPress = function (onClose) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress(onClose);
};
var $author$project$Components$Upload$Result$ExportCsvMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Upload$Result$ModalClosed = {$: 4};
var $author$project$Components$ExportCsv$CloseModal = {$: 1};
var $author$project$Components$ExportCsv$subscriptions = function (model) {
	return model.Ao ? $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$ExportCsv$CloseModal) : $elm$core$Platform$Sub$none;
};
var $author$project$Components$Upload$Result$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Upload$Result$ExportCsvMsg,
				$author$project$Components$ExportCsv$subscriptions(model.nD)),
				$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Upload$Result$ModalClosed)
			]));
};
var $author$project$Components$Upload$Form$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Upload$Form$UploadResultMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Upload$Result$subscriptions, model.h5))),
				model.p2 ? $author$project$Components$Upload$CannotUploadModal$subscribeToEscapeKeyPress($author$project$Components$Upload$Form$CloseCannotUploadModal) : $elm$core$Platform$Sub$none
			]));
};
var $author$project$Pages$Admin$ChargeItems$Upload$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$Admin$ChargeItems$Upload$UploadFormMsg,
		$author$project$Components$Upload$Form$subscriptions(model.SD));
};
var $author$project$Pages$Admin$ChargeItems$Upload$GotChargeDestroyAll = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$ChargeItem$destroyAll = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$ChargeItem$chargeItemsPath));
	});
var $author$project$Components$Upload$Form$ExportFileMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Upload$Form$GotIsProcessing = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$Upload$Form$GotUpload = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Upload$One$Upload = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Upload$One$Record = function (results) {
	return {$X: results};
};
var $author$project$Api$Common$Upload$Results$Invalid = {$: 2};
var $author$project$Api$Common$Upload$Results$Other = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Api$Common$Upload$Results$TooManyUnenrollments = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Common$Upload$Results$TooManyUnenrollmentsRecord = F2(
	function (message, registrations) {
		return {aiH: message, akF: registrations};
	});
var $author$project$Api$Common$Upload$Results$RegistrationRecord = F3(
	function (company, count, idents) {
		return {afQ: company, OK: count, ahR: idents};
	});
var $author$project$Api$Common$Upload$Results$UploadWarningsRow = F6(
	function (ident, firstName, lastName, companyName, dob, externalId) {
		return {Og: companyName, agC: dob, ag7: externalId, Sv: firstName, ahQ: ident, VH: lastName};
	});
var $author$project$Api$Common$Upload$Results$oldUploadWarningDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
	'',
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
		'',
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
			'',
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
				'',
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
					'',
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Api$Common$Upload$Results$UploadWarningsRow)))))));
var $author$project$Api$Common$Upload$Results$uploadWarningDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'external_id',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'dob',
		$elm$json$Json$Decode$string,
		'',
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'company_name',
			$elm$json$Json$Decode$string,
			'',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'last_name',
				$elm$json$Json$Decode$string,
				'',
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'first_name',
					$elm$json$Json$Decode$string,
					'',
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'ident',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Api$Common$Upload$Results$UploadWarningsRow)))))));
var $author$project$Api$Common$Upload$Results$uploadWarningsDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[$author$project$Api$Common$Upload$Results$uploadWarningDecoder, $author$project$Api$Common$Upload$Results$oldUploadWarningDecoder]));
var $author$project$Api$Common$Upload$Results$registrationRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'idents',
	$elm$json$Json$Decode$list($author$project$Api$Common$Upload$Results$uploadWarningsDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'count',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'company',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Common$Upload$Results$RegistrationRecord))));
var $author$project$Api$Common$Upload$Results$tooManyUnenrollmentsRecordDeocder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'registrations',
	$elm$json$Json$Decode$list($author$project$Api$Common$Upload$Results$registrationRecordDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'message',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Common$Upload$Results$TooManyUnenrollmentsRecord)));
var $author$project$Api$Common$Upload$Results$decoder = A2(
	$elm$json$Json$Decode$map,
	function (list) {
		return A2(
			$elm$core$List$map,
			function (_v0) {
				var key = _v0.a;
				var value = _v0.b;
				if (key === 'too_many_unenrollments') {
					var _v2 = A2($elm$json$Json$Decode$decodeValue, $author$project$Api$Common$Upload$Results$tooManyUnenrollmentsRecordDeocder, value);
					if (!_v2.$) {
						var record = _v2.a;
						return $author$project$Api$Common$Upload$Results$TooManyUnenrollments(record);
					} else {
						return $author$project$Api$Common$Upload$Results$Invalid;
					}
				} else {
					var _v3 = A2(
						$elm$json$Json$Decode$decodeValue,
						$elm$json$Json$Decode$list($author$project$Api$Common$Upload$Results$uploadWarningsDecoder),
						value);
					if (!_v3.$) {
						var list_ = _v3.a;
						return A2($author$project$Api$Common$Upload$Results$Other, key, list_);
					} else {
						return $author$project$Api$Common$Upload$Results$Invalid;
					}
				}
			},
			list);
	},
	$elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$value));
var $author$project$Api$Provider$Upload$One$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'results',
	$author$project$Api$Common$Upload$Results$decoder,
	_List_Nil,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Upload$One$Record));
var $author$project$Api$Provider$Upload$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Upload$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Common$Upload$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Upload$One$Upload)));
var $author$project$Api$Data$Files = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Api$Data$requestWithFile = F3(
	function (name, file, _v0) {
		var request = _v0;
		return _Utils_update(
			request,
			{
				fO: $elm$core$Maybe$Just(
					A2(
						$author$project$Api$Data$Files,
						name,
						_List_fromArray(
							[file])))
			});
	});
var $author$project$Api$Provider$Upload$create = F4(
	function (apiClient, resource, file, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Upload$One$decoder,
			toMsg,
			A3(
				$author$project$Api$Data$requestWithFile,
				'file',
				file,
				A2(
					$author$project$Api$Data$requestWithQuery,
					_List_fromArray(
						[
							A2(
							$author$project$Api$Param$string,
							'type',
							$author$project$Api$Upload$Resource$toString(resource))
						]),
					$author$project$Api$Data$requestTo(
						$author$project$Api$Provider$Upload$uploadsPath($author$project$Api$Data$providerPath)))));
	});
var $author$project$Api$Common$Upload$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Upload$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$id(shared);
};
var $author$project$Api$Provider$Upload$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$id(shared);
};
var $author$project$Components$Upload$Result$GotUpload = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Report$UploadRowManual = 17;
var $author$project$Components$ExportCsv$Practice = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$ExportCsv$emptyModel = function (tenant) {
	return {m1: $author$project$Api$Data$NotAsked, gp: false, Ao: false, cR: $author$project$Api$Data$NotAsked, aC: $elm$core$Set$empty, fn: tenant};
};
var $author$project$Components$ExportCsv$initForPractice = function (resource) {
	return $author$project$Components$ExportCsv$emptyModel(
		$author$project$Components$ExportCsv$Practice(resource));
};
var $author$project$Api$Provider$Upload$uploadPath = F2(
	function (basePath, id_) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id_]),
			$author$project$Api$Provider$Upload$uploadsPath(basePath));
	});
var $author$project$Api$Provider$Upload$retrieve = F4(
	function (basePath, apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Upload$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Provider$Upload$uploadPath, basePath, id_)));
	});
var $author$project$Components$Upload$Result$init = F2(
	function (apiClient, id) {
		return _Utils_Tuple2(
			{
				nD: $author$project$Components$ExportCsv$initForPractice(17),
				ahP: id,
				ajJ: $author$project$Api$Pagination$init,
				FZ: $author$project$Api$Data$Loading,
				vk: $author$project$Api$Data$NotAsked
			},
			A4($author$project$Api$Provider$Upload$retrieve, $author$project$Api$Data$providerPath, apiClient, id, $author$project$Components$Upload$Result$GotUpload));
	});
var $author$project$Api$Provider$Company$Upload$companyUploadsPath = function (companyId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['uploads']),
		$author$project$Api$Provider$Company$companyPath(companyId));
};
var $author$project$Api$Provider$Company$Upload$companyUploadsIsProcessingPath = function (companyId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['is_processing']),
		$author$project$Api$Provider$Company$Upload$companyUploadsPath(companyId));
};
var $author$project$Api$Provider$Company$Upload$isProcessingDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['is_processing']),
	$elm$json$Json$Decode$bool);
var $author$project$Api$Provider$Company$Upload$isProcessing = F3(
	function (apiClient, companyId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Company$Upload$isProcessingDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Company$Upload$companyUploadsIsProcessingPath(companyId)));
	});
var $author$project$Components$Upload$Result$Closed = 1;
var $author$project$Components$Upload$Result$None = 0;
var $author$project$Components$Upload$Result$Result = F4(
	function (model, cmd, outMsgs, event) {
		return {GZ: cmd, agZ: event, aiO: model, aR: outMsgs};
	});
var $author$project$Api$Provider$Report$UploadRowCharge = 18;
var $author$project$Api$Provider$Report$UploadRowMembership = 20;
var $author$project$Api$Common$UploadRow$ListOptionals$Failed = 0;
var $author$project$Components$Upload$Result$GotUploadRows = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$UploadRow$All$UploadRow = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$UploadRow$Shared$UploadRow = $elm$core$Basics$identity;
var $author$project$Api$Provider$UploadRow$Shared$Record = F6(
	function (id, rowNumber, status, reviewed, isSupressed, csvRow) {
		return {Pb: csvRow, ahP: id, Ve: isSupressed, $3: reviewed, aab: rowNumber, alH: status};
	});
var $author$project$Api$Provider$UploadRow$Status$Created = 0;
var $author$project$Api$Provider$UploadRow$Status$Enqueued = 2;
var $author$project$Api$Provider$UploadRow$Status$Failed = 5;
var $author$project$Api$Provider$UploadRow$Status$Ignored = 6;
var $author$project$Api$Provider$UploadRow$Status$MappingRequired = 7;
var $author$project$Api$Provider$UploadRow$Status$Processed = 4;
var $author$project$Api$Provider$UploadRow$Status$Processing = 3;
var $author$project$Api$Provider$UploadRow$Status$RequiredFieldMappingRequired = 8;
var $author$project$Api$Provider$UploadRow$Status$Validated = 1;
var $author$project$Api$Provider$UploadRow$Status$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'created':
				return $elm$json$Json$Decode$succeed(0);
			case 'validated':
				return $elm$json$Json$Decode$succeed(1);
			case 'enqueued':
				return $elm$json$Json$Decode$succeed(2);
			case 'processing':
				return $elm$json$Json$Decode$succeed(3);
			case 'processed':
				return $elm$json$Json$Decode$succeed(4);
			case 'failed':
				return $elm$json$Json$Decode$succeed(5);
			case 'ignored':
				return $elm$json$Json$Decode$succeed(6);
			case 'mapping_required':
				return $elm$json$Json$Decode$succeed(7);
			case 'required_field_mapping_required':
				return $elm$json$Json$Decode$succeed(8);
			default:
				return $elm$json$Json$Decode$fail('Unsupported upload status: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$UploadRow$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'csv_row',
	$elm$json$Json$Decode$dict(
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'is_supressed',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'reviewed',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'status',
				$author$project$Api$Provider$UploadRow$Status$decoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'row_number',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$UploadRow$Shared$Record)))))));
var $author$project$Api$Provider$UploadRow$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$UploadRow$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$UploadRow$All$Record = F2(
	function (resultData, uploadRowResults) {
		return {$V: resultData, adU: uploadRowResults};
	});
var $author$project$Api$Common$UploadRowResult$Data$Data = $elm$core$Basics$identity;
var $author$project$Api$Common$UploadRowResult$Data$Record = F7(
	function (value, field, patientIdent, externalId, firstName, lastName, currentDob) {
		return {Pf: currentDob, ag7: externalId, Sl: field, Sv: firstName, VH: lastName, Y_: patientIdent, aee: value};
	});
var $author$project$Api$Common$UploadRowResult$Data$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'current_dob',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'last_name',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'first_name',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'external_id',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'patient_ident',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'field',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'value',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							$elm$core$Maybe$Nothing,
							$elm$json$Json$Decode$succeed($author$project$Api$Common$UploadRowResult$Data$Record))))))));
var $author$project$Api$Common$UploadRowResult$Data$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$UploadRowResult$Data$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$UploadRowResult$Shared$UploadRowResult = $elm$core$Basics$identity;
var $author$project$Api$Provider$UploadRowResult$Shared$Record = F4(
	function (rowNumber, message, resultType, data) {
		return {Pw: data, aiH: message, $W: resultType, aab: rowNumber};
	});
var $author$project$Api$Provider$UploadRowResult$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'data',
	$elm$json$Json$Decode$nullable($author$project$Api$Common$UploadRowResult$Data$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'result_type',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'message',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'row_number',
				$elm$json$Json$Decode$int,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$UploadRowResult$Shared$Record)))));
var $author$project$Api$Provider$UploadRowResult$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$UploadRowResult$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$UploadRow$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'upload_row_results',
	$elm$json$Json$Decode$list($author$project$Api$Provider$UploadRowResult$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'result_data',
		$elm$json$Json$Decode$nullable($author$project$Api$Common$UploadRowResult$Data$decoder),
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$UploadRow$All$Record)));
var $author$project$Api$Provider$UploadRow$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$UploadRow$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$UploadRow$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$UploadRow$All$UploadRow)));
var $author$project$Api$Sort$withDefault = F3(
	function (column, direction, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				PW: $elm$core$Maybe$Just(
					_Utils_Tuple2(column, direction))
			});
	});
var $author$project$Api$Common$UploadRow$ListOptionals$defaults = {
	HM: $elm$core$Maybe$Nothing,
	ajJ: $author$project$Api$Pagination$init,
	akl: $elm$core$Maybe$Nothing,
	Jy: $elm$core$Maybe$Nothing,
	alA: A3($author$project$Api$Sort$withDefault, 'row_number', 0, $author$project$Api$Sort$init),
	J1: $elm$core$Maybe$Nothing,
	Kk: $elm$core$Maybe$Nothing
};
var $author$project$Api$Common$UploadRow$ListOptionals$filterToString = function (filter) {
	switch (filter) {
		case 0:
			return 'failed';
		case 1:
			return 'warning';
		default:
			return 'processed';
	}
};
var $author$project$Api$Common$UploadRow$ListOptionals$toParams = function (optionals) {
	var options = optionals($author$project$Api$Common$UploadRow$ListOptionals$defaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.HM;
				if (!_v0.$) {
					var filter = _v0.a;
					return _List_fromArray(
						[
							A2(
							$author$project$Api$Param$string,
							'filter',
							$author$project$Api$Common$UploadRow$ListOptionals$filterToString(filter))
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.Jy;
				if (!_v1.$) {
					var resource = _v1.a;
					return _List_fromArray(
						[
							A2(
							$author$project$Api$Param$string,
							'type',
							$author$project$Api$Upload$Resource$toString(resource))
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.Kk;
				if (!_v2.$) {
					var string = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'upload_row_results_result_type', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v3 = options.J1;
				if (!_v3.$) {
					var string = _v3.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'supress_filter', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v4 = options.akl;
				if (!_v4.$) {
					var string = _v4.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$Provider$UploadRow$uploadRowsPath = function (uploadId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['upload_rows']),
		A2($author$project$Api$Provider$Upload$uploadPath, $author$project$Api$Data$providerPath, uploadId));
};
var $author$project$Api$Provider$UploadRow$list = F4(
	function (apiClient, uploadId, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$UploadRow$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Common$UploadRow$ListOptionals$toParams(optionals),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$UploadRow$uploadRowsPath(uploadId))));
	});
var $author$project$Components$Upload$Result$fetchUploadRows = F2(
	function (apiClient, model) {
		return A4(
			$author$project$Api$Provider$UploadRow$list,
			apiClient,
			model.ahP,
			function (d) {
				return _Utils_update(
					d,
					{
						HM: $elm$core$Maybe$Just(0),
						ajJ: model.ajJ
					});
			},
			$author$project$Components$Upload$Result$GotUploadRows);
	});
var $author$project$Api$Common$Upload$Shared$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Api$Provider$Upload$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$status(shared);
};
var $author$project$Components$Upload$Result$finishProcessing = function (upload) {
	var _v0 = $author$project$Api$Provider$Upload$One$status(upload);
	switch (_v0) {
		case 11:
			return true;
		case 12:
			return true;
		default:
			return false;
	}
};
var $author$project$Components$Upload$Result$PollUpload = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Upload$Result$pollUpload = function (upload) {
	return A2(
		$elm$core$Task$perform,
		function (_v0) {
			return $author$project$Components$Upload$Result$PollUpload(upload);
		},
		$elm$core$Process$sleep(2000));
};
var $author$project$Components$ExportCsv$DefaultColumnsSaved = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$ExportCsv$ExportFileMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Api$Provider$ReportExport$Shared$Generated = 3;
var $author$project$Components$ExportCsv$GotCsvReport = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$ExportCsv$GotReportExport = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Common$CsvReport$Shared$columns = function (_v0) {
	var record = _v0;
	return record.N3;
};
var $author$project$Api$Common$CsvReport$One$columns = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Common$CsvReport$Shared$columns(shared);
};
var $author$project$Api$Provider$ReportExport$All$ReportExport = $elm$core$Basics$identity;
var $author$project$Api$Provider$ReportExport$Shared$ReportExport = $elm$core$Basics$identity;
var $author$project$Api$Provider$ReportExport$Shared$Record = F4(
	function (id, status, totalCount, generatedCount) {
		return {SU: generatedCount, ahP: id, alH: status, qC: totalCount};
	});
var $author$project$Api$Provider$ReportExport$Shared$Enqueued = 1;
var $author$project$Api$Provider$ReportExport$Shared$Generating = 2;
var $author$project$Api$Provider$ReportExport$Shared$Pending = 0;
var $author$project$Api$Provider$ReportExport$Shared$decodeStatus = function (string) {
	switch (string) {
		case 'pending':
			return $elm$json$Json$Decode$succeed(0);
		case 'enqueued':
			return $elm$json$Json$Decode$succeed(1);
		case 'generating':
			return $elm$json$Json$Decode$succeed(2);
		case 'generated':
			return $elm$json$Json$Decode$succeed(3);
		default:
			return $elm$json$Json$Decode$fail('Unsupported report export status: ' + string);
	}
};
var $author$project$Api$Provider$ReportExport$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'generated_count',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'total_count',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'status',
			A2($elm$json$Json$Decode$andThen, $author$project$Api$Provider$ReportExport$Shared$decodeStatus, $elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$ReportExport$Shared$Record)))));
var $author$project$Api$Provider$ReportExport$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ReportExport$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$ReportExport$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ReportExport$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Data$partnerPath = $author$project$Api$Data$newPath(
	_List_fromArray(
		['partner']));
var $author$project$Api$Partner$ReportExport$reportExportsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['reports', 'exports']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$Report$resourceToString = function (resource) {
	return 'Deposit';
};
var $author$project$Api$Param$toValue = function (params) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$map,
			function (param) {
				switch (param.$) {
					case 0:
						var key = param.a;
						var string_ = param.b;
						return _Utils_Tuple2(
							key,
							$elm$json$Json$Encode$string(string_));
					case 1:
						var key = param.a;
						var bool_ = param.b;
						return _Utils_Tuple2(
							key,
							$elm$json$Json$Encode$bool(bool_));
					case 2:
						var key = param.a;
						var date_ = param.b;
						return _Utils_Tuple2(
							key,
							$elm$json$Json$Encode$string(
								$author$project$Utils$Date$toQuery(date_)));
					default:
						var key = param.a;
						var list_ = param.b;
						var _v1 = _Utils_Tuple2(
							$elm$core$List$length(list_) > 1,
							$elm$core$List$head(list_));
						if ((!_v1.a) && (!_v1.b.$)) {
							var string_ = _v1.b.a;
							return _Utils_Tuple2(
								key,
								$elm$json$Json$Encode$string(string_));
						} else {
							return _Utils_Tuple2(
								key,
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, list_));
						}
				}
			},
			params));
};
var $author$project$Api$Partner$ReportExport$create = F5(
	function (apiClient, resource, params, columns, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'export',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'resource',
								$elm$json$Json$Encode$string(
									$author$project$Api$Partner$Report$resourceToString(resource))),
								_Utils_Tuple2(
								'columns',
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, columns)),
								_Utils_Tuple2(
								'report_params',
								$author$project$Api$Param$toValue(params))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$ReportExport$All$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Partner$ReportExport$reportExportsPath)));
	});
var $author$project$Api$Provider$ReportExport$reportExportsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['reports', 'exports']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Report$resourceToString = function (resource) {
	switch (resource) {
		case 0:
			return 'Patient';
		case 1:
			return 'SignupAttempt';
		case 2:
			return 'StatementLine';
		case 3:
			return 'Invoice';
		case 6:
			return 'RevenueLine';
		case 7:
			return 'DeferredRevenueLine';
		case 8:
			return 'TaxLine';
		case 9:
			return 'PaymentApplicationLine';
		case 10:
			return 'MembershipPatient';
		case 11:
			return 'Membership';
		case 12:
			return 'CustomerInvoice';
		case 13:
			return 'Deposit';
		case 14:
			return 'CreditLine';
		case 15:
			return 'Credit';
		case 16:
			return 'PatientPackage';
		case 17:
			return 'UploadRowManual';
		case 18:
			return 'UploadRowCharge';
		case 19:
			return 'UploadRowSponsor';
		case 20:
			return 'UploadRowMembership';
		case 21:
			return 'Location';
		case 4:
			return 'InvoiceLine';
		case 5:
			return 'AffiliateBillLine';
		case 22:
			return 'Dispute';
		case 23:
			return 'AffiliateAncillaryCharge';
		case 24:
			return 'CompanyRegistration';
		default:
			return 'PaymentMethodImport';
	}
};
var $author$project$Api$Provider$ReportExport$create = F5(
	function (apiClient, resource, params, columns, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'export',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'resource',
								$elm$json$Json$Encode$string(
									$author$project$Api$Provider$Report$resourceToString(resource))),
								_Utils_Tuple2(
								'columns',
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, columns)),
								_Utils_Tuple2(
								'report_params',
								$author$project$Api$Param$toValue(params))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$ReportExport$All$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$ReportExport$reportExportsPath)));
	});
var $author$project$Api$Common$CsvReport$CsvReport$employerPath = function (resource) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[
				'csv_reports',
				$author$project$Api$Provider$Report$resourceToString(resource)
			]),
		$author$project$Api$Data$employerPath);
};
var $author$project$Api$Common$CsvReport$CsvReport$partnerPath = function (resource) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[
				'csv_reports',
				$author$project$Api$Partner$Report$resourceToString(resource)
			]),
		$author$project$Api$Data$partnerPath);
};
var $author$project$Api$Common$CsvReport$CsvReport$practicePath = function (resource) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[
				'csv_reports',
				$author$project$Api$Provider$Report$resourceToString(resource)
			]),
		$author$project$Api$Data$providerPath);
};
var $author$project$Components$ExportCsv$csvReportPath = function (model) {
	var _v0 = model.fn;
	switch (_v0.$) {
		case 0:
			var resource = _v0.a;
			return $author$project$Api$Common$CsvReport$CsvReport$practicePath(resource);
		case 1:
			var resource = _v0.a;
			return $author$project$Api$Common$CsvReport$CsvReport$employerPath(resource);
		default:
			var resource = _v0.a;
			return $author$project$Api$Common$CsvReport$CsvReport$partnerPath(resource);
	}
};
var $elm$core$Set$fromList = function (list) {
	return A3($elm$core$List$foldl, $elm$core$Set$insert, $elm$core$Set$empty, list);
};
var $author$project$Api$Provider$ReportExport$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$ReportExport$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ReportExport$Shared$id(shared);
};
var $author$project$Api$Common$CsvReport$CsvReportColumn$name = function (_v0) {
	var record = _v0;
	return record.x8.Bq;
};
var $author$project$Components$ExportCsv$PollReportExport = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$ExportCsv$pollReportExport = function (reportExport) {
	return A2(
		$elm$core$Task$perform,
		function (_v0) {
			return $author$project$Components$ExportCsv$PollReportExport(reportExport);
		},
		$elm$core$Process$sleep(2000));
};
var $author$project$Components$ExportCsv$resetModel = function (model) {
	return {m1: $author$project$Api$Data$NotAsked, gp: false, Ao: false, cR: $author$project$Api$Data$NotAsked, aC: $elm$core$Set$empty, fn: model.fn};
};
var $author$project$Api$Common$CsvReport$One$CsvReport = $elm$core$Basics$identity;
var $author$project$Api$Common$CsvReport$Shared$CsvReport = $elm$core$Basics$identity;
var $author$project$Api$Common$CsvReport$Shared$Record = function (columns) {
	return {N3: columns};
};
var $author$project$Api$Common$CsvReport$CsvReportColumn$CsvReportColumn = $elm$core$Basics$identity;
var $author$project$Api$Common$CsvReport$CsvReportColumn$WrapperRecord = function (column) {
	return {x8: column};
};
var $author$project$Api$Common$CsvReport$CsvReportColumn$Record = F3(
	function (name, title, includeByDefault) {
		return {TV: includeByDefault, Bq: name, ac9: title};
	});
var $author$project$Api$Common$CsvReport$CsvReportColumn$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'include_by_default',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'title',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Common$CsvReport$CsvReportColumn$Record))));
var $author$project$Api$Common$CsvReport$CsvReportColumn$wrapperRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'column',
	$author$project$Api$Common$CsvReport$CsvReportColumn$recordDecoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Common$CsvReport$CsvReportColumn$WrapperRecord));
var $author$project$Api$Common$CsvReport$CsvReportColumn$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$CsvReport$CsvReportColumn$wrapperRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$CsvReport$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'columns',
	$elm$json$Json$Decode$list($author$project$Api$Common$CsvReport$CsvReportColumn$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Common$CsvReport$Shared$Record));
var $author$project$Api$Common$CsvReport$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$CsvReport$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$CsvReport$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$CsvReport$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$CsvReport$CsvReport$retrieve = F3(
	function (apiClient, path, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Common$CsvReport$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(path));
	});
var $author$project$Api$Partner$ReportExport$reportExportPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Partner$ReportExport$reportExportsPath);
};
var $author$project$Api$Partner$ReportExport$retrieve = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$ReportExport$All$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Partner$ReportExport$reportExportPath(id_)));
	});
var $author$project$Api$Provider$ReportExport$reportExportPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$ReportExport$reportExportsPath);
};
var $author$project$Api$Provider$ReportExport$retrieve = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$ReportExport$All$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$ReportExport$reportExportPath(id_)));
	});
var $author$project$Api$Common$CsvReport$CsvReport$saveColumns = F4(
	function (apiClient, path, defaultColumns, toMsg) {
		var defaultColumnsString = A2(
			$elm$core$String$join,
			',',
			$elm$core$Set$toList(defaultColumns));
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'default_columns',
					$elm$json$Json$Encode$string(defaultColumnsString))
				]));
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['update_default_columns']),
						path))));
	});
var $author$project$Api$Common$CsvReport$CsvReportColumn$includeByDefault = function (_v0) {
	var record = _v0;
	return record.x8.TV;
};
var $author$project$Components$ExportCsv$selectDefaultColumns = function (csvReport) {
	return $elm$core$Set$fromList(
		A2(
			$elm$core$List$map,
			$author$project$Api$Common$CsvReport$CsvReportColumn$name,
			A2(
				$elm$core$List$filter,
				$author$project$Api$Common$CsvReport$CsvReportColumn$includeByDefault,
				$author$project$Api$Common$CsvReport$One$columns(csvReport))));
};
var $author$project$Api$Provider$ReportExport$Shared$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Api$Provider$ReportExport$All$status = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ReportExport$Shared$status(shared);
};
var $author$project$Components$ExportCsv$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Ao: true}),
					A3(
						$author$project$Api$Common$CsvReport$CsvReport$retrieve,
						apiClient,
						$author$project$Components$ExportCsv$csvReportPath(model),
						$author$project$Components$ExportCsv$GotCsvReport),
					_List_Nil);
			case 1:
				return _Utils_Tuple3(
					$author$project$Components$ExportCsv$resetModel(model),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var dataCsvReport = msg.a;
				if (dataCsvReport.$ === 3) {
					var csvReport = dataCsvReport.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								m1: dataCsvReport,
								aC: $author$project$Components$ExportCsv$selectDefaultColumns(csvReport)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{m1: dataCsvReport}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$reportDecodeError(dataCsvReport));
				}
			case 3:
				var csvReport = msg.a;
				var selectedColumns = $elm$core$Set$fromList(
					A2(
						$elm$core$List$map,
						$author$project$Api$Common$CsvReport$CsvReportColumn$name,
						$author$project$Api$Common$CsvReport$One$columns(csvReport)));
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aC: selectedColumns}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aC: $elm$core$Set$empty}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 10:
				return _Utils_Tuple3(
					model,
					A4(
						$author$project$Api$Common$CsvReport$CsvReport$saveColumns,
						apiClient,
						$author$project$Components$ExportCsv$csvReportPath(model),
						model.aC,
						$author$project$Components$ExportCsv$DefaultColumnsSaved),
					_List_Nil);
			case 5:
				var columnName = msg.a;
				var selected = msg.b;
				var selectedColumns = (!selected) ? A2($elm$core$Set$remove, columnName, model.aC) : A2($elm$core$Set$insert, columnName, model.aC);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aC: selectedColumns}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 6:
				var reportParams_ = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{gp: true, cR: $author$project$Api$Data$Loading}),
					function () {
						var _v2 = model.fn;
						switch (_v2.$) {
							case 0:
								var resource = _v2.a;
								return A5(
									$author$project$Api$Provider$ReportExport$create,
									apiClient,
									resource,
									reportParams_,
									$elm$core$Set$toList(model.aC),
									$author$project$Components$ExportCsv$GotReportExport);
							case 1:
								var resource = _v2.a;
								return A5(
									$author$project$Api$Provider$ReportExport$create,
									apiClient,
									resource,
									reportParams_,
									$elm$core$Set$toList(model.aC),
									$author$project$Components$ExportCsv$GotReportExport);
							default:
								var resource = _v2.a;
								return A5(
									$author$project$Api$Partner$ReportExport$create,
									apiClient,
									resource,
									reportParams_,
									$elm$core$Set$toList(model.aC),
									$author$project$Components$ExportCsv$GotReportExport);
						}
					}(),
					_List_Nil);
			case 7:
				var dataReportExport = msg.a;
				if (!model.gp) {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				} else {
					var cmd = function () {
						if (dataReportExport.$ === 3) {
							var reportExport = dataReportExport.a;
							return ($author$project$Api$Provider$ReportExport$All$status(reportExport) !== 3) ? $author$project$Components$ExportCsv$pollReportExport(reportExport) : $elm$core$Platform$Cmd$none;
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cR: dataReportExport}),
						cmd,
						$author$project$OutMsg$reportDecodeError(dataReportExport));
				}
			case 8:
				var reportExport = msg.a;
				return (!model.gp) ? _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil) : _Utils_Tuple3(
					model,
					function () {
						var _v4 = model.fn;
						switch (_v4.$) {
							case 0:
								return A3(
									$author$project$Api$Provider$ReportExport$retrieve,
									apiClient,
									$author$project$Api$Provider$ReportExport$All$id(reportExport),
									$author$project$Components$ExportCsv$GotReportExport);
							case 1:
								return A3(
									$author$project$Api$Provider$ReportExport$retrieve,
									apiClient,
									$author$project$Api$Provider$ReportExport$All$id(reportExport),
									$author$project$Components$ExportCsv$GotReportExport);
							default:
								return A3(
									$author$project$Api$Partner$ReportExport$retrieve,
									apiClient,
									$author$project$Api$Provider$ReportExport$All$id(reportExport),
									$author$project$Components$ExportCsv$GotReportExport);
						}
					}(),
					_List_Nil);
			case 9:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var subMsg = msg.a;
				var _v6 = $author$project$Components$FileLink$update(subMsg);
				var getFileCmdMsg = _v6.a;
				var outMsgs = _v6.b;
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$ExportCsv$ExportFileMsg, getFileCmdMsg),
								A2(
								$elm$core$Task$perform,
								function (_v7) {
									return $author$project$Components$ExportCsv$CloseModal;
								},
								$elm$core$Task$succeed(0))
							])),
					outMsgs);
		}
	});
var $author$project$Api$Common$Upload$Shared$uploaderType = function (_v0) {
	var record = _v0;
	return record.adW;
};
var $author$project$Api$Provider$Upload$One$uploaderType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$uploaderType(shared);
};
var $author$project$Components$Upload$Result$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var upload = response.a;
					var resource = function () {
						var _v2 = $author$project$Api$Provider$Upload$One$uploaderType(upload);
						_v2$2:
						while (true) {
							if (_v2.$ === 3) {
								switch (_v2.a) {
									case 'charge':
										return 18;
									case 'membership':
										return 20;
									default:
										break _v2$2;
								}
							} else {
								break _v2$2;
							}
						}
						return 17;
					}();
					var exportCsv = $author$project$Components$ExportCsv$initForPractice(resource);
					var cmd = $author$project$Components$Upload$Result$finishProcessing(upload) ? A2($author$project$Components$Upload$Result$fetchUploadRows, apiClient, model) : $author$project$Components$Upload$Result$pollUpload(upload);
					return A4(
						$author$project$Components$Upload$Result$Result,
						_Utils_update(
							model,
							{nD: exportCsv, FZ: response}),
						cmd,
						_List_Nil,
						0);
				} else {
					return A4(
						$author$project$Components$Upload$Result$Result,
						_Utils_update(
							model,
							{FZ: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response),
						0);
				}
			case 1:
				var upload = msg.a;
				return A4(
					$author$project$Components$Upload$Result$Result,
					model,
					A4(
						$author$project$Api$Provider$Upload$retrieve,
						$author$project$Api$Data$providerPath,
						apiClient,
						$author$project$Api$Provider$Upload$One$id(upload),
						$author$project$Components$Upload$Result$GotUpload),
					_List_Nil,
					0);
			case 2:
				var response = msg.a;
				var pagination = function () {
					if (response.$ === 3) {
						var headers = response.b;
						return A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ);
					} else {
						return model.ajJ;
					}
				}();
				return A4(
					$author$project$Components$Upload$Result$Result,
					_Utils_update(
						model,
						{ajJ: pagination, vk: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response),
					0);
			case 3:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{ajJ: pagination});
				return A4(
					$author$project$Components$Upload$Result$Result,
					newModel,
					A2($author$project$Components$Upload$Result$fetchUploadRows, apiClient, newModel),
					_List_Nil,
					0);
			case 4:
				return A4($author$project$Components$Upload$Result$Result, model, $elm$core$Platform$Cmd$none, _List_Nil, 1);
			default:
				var subMsg = msg.a;
				var _v4 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.nD);
				var exportCsv = _v4.a;
				var subCmd = _v4.b;
				var subOutMsg = _v4.c;
				var newModel = _Utils_update(
					model,
					{nD: exportCsv});
				return A4(
					$author$project$Components$Upload$Result$Result,
					newModel,
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Upload$Result$ExportCsvMsg, subCmd),
					subOutMsg,
					0);
		}
	});
var $author$project$Components$Upload$Form$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{F_: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{uE: !model.uE}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var files = msg.a;
				var _v1 = $elm$core$List$head(files);
				if (!_v1.$) {
					var file = _v1.a;
					var _v2 = model.fZ;
					if (!_v2.$) {
						var companyId = _v2.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{U5: $author$project$Api$Data$Loading}),
							A3(
								$author$project$Api$Provider$Company$Upload$isProcessing,
								apiClient,
								companyId,
								$author$project$Components$Upload$Form$GotIsProcessing(file)),
							_List_Nil);
					} else {
						return _Utils_Tuple3(
							model,
							A4($author$project$Api$Provider$Upload$create, apiClient, model.Jy, file, $author$project$Components$Upload$Form$GotUpload),
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				var file = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var isProcessing = response.a;
					var cmd = isProcessing ? $elm$core$Platform$Cmd$none : A4($author$project$Api$Provider$Upload$create, apiClient, model.Jy, file, $author$project$Components$Upload$Form$GotUpload);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{U5: response, p2: isProcessing}),
						cmd,
						$author$project$OutMsg$handleErrorResponse(response));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{U5: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					var upload = response.a;
					var _v5 = A2(
						$author$project$Components$Upload$Result$init,
						apiClient,
						$author$project$Api$Provider$Upload$One$id(upload));
					var uploadResult = _v5.a;
					var uploadResultCmd = _v5.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								FZ: response,
								h5: $elm$core$Maybe$Just(uploadResult)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Upload$Form$UploadResultMsg, uploadResultCmd),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{FZ: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 5:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{C9: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 6:
				var subMsg = msg.a;
				var _v6 = model.h5;
				if (!_v6.$) {
					var uploadResult = _v6.a;
					var result = A3($author$project$Components$Upload$Result$update, apiClient, subMsg, uploadResult);
					var uploadResult_ = function () {
						var _v7 = result.agZ;
						if (!_v7) {
							return $elm$core$Maybe$Just(result.aiO);
						} else {
							return $elm$core$Maybe$Nothing;
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{h5: uploadResult_}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Upload$Form$UploadResultMsg, result.GZ),
						result.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var upload = msg.a;
				var _v8 = A2(
					$author$project$Components$Upload$Result$init,
					apiClient,
					$author$project$Api$Provider$Upload$All$id(upload));
				var uploadResult = _v8.a;
				var uploadResultCmd = _v8.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							h5: $elm$core$Maybe$Just(uploadResult)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Upload$Form$UploadResultMsg, uploadResultCmd),
					_List_Nil);
			case 8:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{p2: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v9 = $author$project$Components$FileLink$update(subMsg);
				var getFileCmdMsg = _v9.a;
				var outMsgs = _v9.b;
				return _Utils_Tuple3(
					model,
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Upload$Form$ExportFileMsg, getFileCmdMsg),
					outMsgs);
		}
	});
var $author$project$Pages$Admin$ChargeItems$Upload$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A3($author$project$Components$Upload$Form$update, model.Gv, subMsg, model.SD);
				var uploadForm = _v1.a;
				var subCmd = _v1.b;
				var subOutMsgs = _v1.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: uploadForm}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$ChargeItems$Upload$UploadFormMsg, subCmd),
					subOutMsgs);
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ne: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var confirmed = msg.a;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{ne: false}),
					A2($author$project$Api$Provider$ChargeItem$destroyAll, model.Gv, $author$project$Pages$Admin$ChargeItems$Upload$GotChargeDestroyAll),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{ne: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Charges were successfully removed.')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Admin$ChargeItems$Upload$HiConfirmChargesClosed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Common$Upload$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$Upload$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$name(shared);
};
var $author$project$Components$ExportCsv$OpenModal = {$: 0};
var $author$project$Components$ExportCsv$customButton = F2(
	function (options, children) {
		return A3(
			$author$project$Ui$Button$view,
			{mm: 'Export to csv'},
			_Utils_ap(
				options,
				_List_fromArray(
					[
						$author$project$Ui$Button$onClick($author$project$Components$ExportCsv$OpenModal),
						$author$project$Ui$Button$icon($author$project$Ui$Icon$export)
					])),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Tooltip$view,
					_List_fromArray(
						[
							$author$project$Ui$Tooltip$placement(2)
						]),
					'Export to CSV',
					A2(
						$elm$core$List$map,
						$elm$html$Html$map($elm$core$Basics$never),
						children))
				]));
	});
var $author$project$Components$ExportCsv$button = A2(
	$author$project$Components$ExportCsv$customButton,
	_List_fromArray(
		[$author$project$Ui$Button$link]),
	_List_Nil);
var $author$project$Components$Upload$Result$failed = F2(
	function (upload, uploadRows) {
		var _v0 = _Utils_Tuple2(
			$author$project$Api$Provider$Upload$One$status(upload),
			$elm$core$List$isEmpty(uploadRows));
		if (_v0.a === 12) {
			var _v1 = _v0.a;
			return true;
		} else {
			if (!_v0.b) {
				return true;
			} else {
				return false;
			}
		}
	});
var $author$project$Api$Common$Upload$Shared$rowsProcessedOrIgnored = function (_v0) {
	var record = _v0;
	return record.aaf;
};
var $author$project$Api$Provider$Upload$One$rowsProcessedOrIgnored = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$rowsProcessedOrIgnored(shared);
};
var $author$project$Api$Common$Upload$Shared$rowsTotal = function (_v0) {
	var record = _v0;
	return record.aah;
};
var $author$project$Api$Provider$Upload$One$rowsTotal = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$rowsTotal(shared);
};
var $author$project$Ui$Alert$success = $author$project$Ui$Alert$view(0);
var $author$project$Components$Upload$Result$exportParams = function (upload) {
	var _v0 = $author$project$Api$Provider$Upload$One$uploaderType(upload);
	if (_v0.$ === 3) {
		return _List_fromArray(
			[
				A2($author$project$Api$Param$string, 'filter', '')
			]);
	} else {
		return _List_fromArray(
			[
				A2($author$project$Api$Param$string, 'filter', 'failed')
			]);
	}
};
var $author$project$Components$ExportCsv$Filter = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$ExportCsv$filter = $author$project$Components$ExportCsv$Filter;
var $author$project$Components$ExportCsv$DeselectAllColumns = {$: 4};
var $author$project$Components$ExportCsv$SaveDefaultColumns = {$: 10};
var $author$project$Components$ExportCsv$SelectAllColumns = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$ExportCsv$StartExport = function (a) {
	return {$: 6, a: a};
};
var $author$project$Ui$Link$ButtonPrimary = 0;
var $author$project$Ui$Link$buttonPrimary = $author$project$Ui$Link$Style(0);
var $author$project$Components$ExportCsv$canSaveDefaultColumns = function (model) {
	var _v0 = model.fn;
	switch (_v0.$) {
		case 0:
			return true;
		case 1:
			return false;
		default:
			return true;
	}
};
var $author$project$Components$ExportCsv$paramsForCsv = F2(
	function (optionsRecord, selectedColumns) {
		return A2(
			$elm$core$List$concatMap,
			$author$project$Api$Param$toQuery,
			A2(
				$elm$core$List$append,
				function () {
					var _v0 = optionsRecord.HM;
					if (!_v0.$) {
						var filter_ = _v0.a;
						return _List_fromArray(
							[
								A2($author$project$Api$Param$string, 'filter', filter_)
							]);
					} else {
						return _List_Nil;
					}
				}(),
				A2(
					$elm$core$List$append,
					_List_fromArray(
						[
							A2($author$project$Api$Param$list, 'columns', selectedColumns)
						]),
					optionsRecord.YL)));
	});
var $author$project$Components$ExportCsv$downloadCsvHref = F3(
	function (apiClient, optionsRecord, selectedColumns) {
		return A2(
			$elm$core$Maybe$map,
			function (path_) {
				return A4(
					$author$project$Api$Data$downloadUrl,
					apiClient,
					path_,
					0,
					A2($author$project$Components$ExportCsv$paramsForCsv, optionsRecord, selectedColumns));
			},
			optionsRecord.YX);
	});
var $author$project$Formatters$Int$formatNumber = function (number) {
	return A2($cuducos$elm_format_number$FormatNumber$format, $author$project$Formatters$Locales$noDecimalLocale, number);
};
var $author$project$Ui$Link$FullWidth = {$: 7};
var $author$project$Ui$Link$fullWidth = $author$project$Ui$Link$FullWidth;
var $author$project$Api$Provider$ReportExport$Shared$generatedCount = function (_v0) {
	var record = _v0;
	return record.SU;
};
var $author$project$Api$Provider$ReportExport$All$generatedCount = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ReportExport$Shared$generatedCount(shared);
};
var $author$project$Components$ExportCsv$totalCountLimit = 200 * 1000;
var $author$project$Components$ExportCsv$isInvalid = function (totalCount) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (count) {
				return _Utils_cmp(count, $author$project$Components$ExportCsv$totalCountLimit) > 0;
			},
			totalCount));
};
var $author$project$Components$ExportCsv$defaultOptions = {HM: $elm$core$Maybe$Nothing, YL: _List_Nil, YX: $elm$core$Maybe$Nothing, kV: false, DP: _List_Nil, qC: $elm$core$Maybe$Nothing};
var $author$project$Components$ExportCsv$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var totalCount = option.a;
						return _Utils_update(
							record,
							{kV: true, qC: totalCount});
					case 1:
						var dict = option.a;
						return _Utils_update(
							record,
							{YL: dict});
					case 2:
						var dict = option.a;
						return _Utils_update(
							record,
							{DP: dict});
					case 3:
						var string = option.a;
						return _Utils_update(
							record,
							{
								HM: $elm$core$Maybe$Just(string)
							});
					default:
						var path_ = option.a;
						return _Utils_update(
							record,
							{
								YX: $elm$core$Maybe$Just(path_)
							});
				}
			}),
		$author$project$Components$ExportCsv$defaultOptions,
		options);
};
var $author$project$Components$ExportCsv$reportExportGenerated = function (dataReportExport) {
	if (dataReportExport.$ === 3) {
		var reportExport = dataReportExport.a;
		return $author$project$Api$Provider$ReportExport$All$status(reportExport) === 3;
	} else {
		return false;
	}
};
var $author$project$Components$ExportCsv$reportExportHref = F2(
	function (apiClient, model) {
		return A2(
			$elm$core$Maybe$map,
			function (reportExport) {
				var reportExportPath = function () {
					var _v0 = model.fn;
					switch (_v0.$) {
						case 0:
							return $author$project$Api$Provider$ReportExport$reportExportPath(
								$author$project$Api$Provider$ReportExport$All$id(reportExport));
						case 1:
							return $author$project$Api$Provider$ReportExport$reportExportPath(
								$author$project$Api$Provider$ReportExport$All$id(reportExport));
						default:
							return $author$project$Api$Partner$ReportExport$reportExportPath(
								$author$project$Api$Provider$ReportExport$All$id(reportExport));
					}
				}();
				return A4($author$project$Api$Data$downloadUrl, apiClient, reportExportPath, 0, _List_Nil);
			},
			$author$project$Api$Data$toMaybe(model.cR));
	});
var $elm$core$Dict$sizeHelp = F2(
	function (n, dict) {
		sizeHelp:
		while (true) {
			if (dict.$ === -2) {
				return n;
			} else {
				var left = dict.d;
				var right = dict.e;
				var $temp$n = A2($elm$core$Dict$sizeHelp, n + 1, right),
					$temp$dict = left;
				n = $temp$n;
				dict = $temp$dict;
				continue sizeHelp;
			}
		}
	});
var $elm$core$Dict$size = function (dict) {
	return A2($elm$core$Dict$sizeHelp, 0, dict);
};
var $elm$core$Set$size = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$size(dict);
};
var $author$project$Api$Provider$ReportExport$Shared$totalCount = function (_v0) {
	var record = _v0;
	return record.qC;
};
var $author$project$Api$Provider$ReportExport$All$totalCount = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ReportExport$Shared$totalCount(shared);
};
var $author$project$Components$ExportCsv$ToggleColumn = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Ui$Form$Checkbox$Attr = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Form$Checkbox$attr = function (attributes) {
	return $author$project$Ui$Form$Checkbox$Attr(attributes);
};
var $author$project$Api$Common$CsvReport$CsvReportColumn$title = function (_v0) {
	var record = _v0;
	return record.x8.ac9;
};
var $author$project$Components$ExportCsv$viewColumn = F2(
	function (selectedColumns, column) {
		var columnName = $author$project$Api$Common$CsvReport$CsvReportColumn$name(column);
		return A2(
			$author$project$Ui$Form$Checkbox$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Checkbox$value(
					A2($elm$core$Set$member, columnName, selectedColumns)),
					$author$project$Ui$Form$Checkbox$attr(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-left')
						])),
					$author$project$Ui$Form$Checkbox$onCheck(
					$author$project$Components$ExportCsv$ToggleColumn(columnName))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Api$Common$CsvReport$CsvReportColumn$title(column))
				]));
	});
var $author$project$Components$ExportCsv$viewModal = F3(
	function (apiClient, options, model) {
		var optionsRecord = $author$project$Components$ExportCsv$optionsToRecord(options);
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$ExportCsv$CloseModal,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('Export to CSV')
								]))
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							function () {
							if (model.gp) {
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-center')
										]),
									$elm$core$List$concat(
										_List_fromArray(
											[
												((!$author$project$Components$ExportCsv$reportExportGenerated(model.cR)) || (!optionsRecord.kV)) ? _List_fromArray(
												[
													$author$project$Ui$Spinner$view(_List_Nil),
													A2($elm$html$Html$br, _List_Nil, _List_Nil)
												]) : _List_Nil,
												optionsRecord.kV ? ($author$project$Components$ExportCsv$reportExportGenerated(model.cR) ? _List_fromArray(
												[
													A2(
													$author$project$Ui$Alert$success,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Your export was generated successfully.')
														]))
												]) : _List_fromArray(
												[
													$elm$html$Html$text('Your export may take a few minutes to generate.'),
													A2($elm$html$Html$br, _List_Nil, _List_Nil),
													function () {
													var _v0 = A2(
														$elm$core$Maybe$andThen,
														$author$project$Api$Provider$ReportExport$All$totalCount,
														$author$project$Api$Data$toMaybe(model.cR));
													if (!_v0.$) {
														var totalCount = _v0.a;
														return A2(
															$elm$html$Html$span,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	'Generated ' + ($elm$core$String$fromInt(
																		A2(
																			$elm$core$Maybe$withDefault,
																			0,
																			A2(
																				$elm$core$Maybe$andThen,
																				$author$project$Api$Provider$ReportExport$All$generatedCount,
																				$author$project$Api$Data$toMaybe(model.cR)))) + (' out of ' + $elm$core$String$fromInt(totalCount))))
																]));
													} else {
														return $author$project$Utils$Html$empty;
													}
												}()
												])) : _List_Nil
											])));
							} else {
								var _v1 = model.m1;
								if (_v1.$ === 3) {
									var csvReport = _v1.a;
									var flexItemClass = 'relative after:absolute after:content-[\'|\'] after:-right-2 after:translate-x-1/2';
									return A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('You\'re about to export and download the report. Please select the columns below:'),
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('well well--sm'),
																A2($elm$html$Html$Attributes$style, 'overflow-y', 'scroll'),
																A2($elm$html$Html$Attributes$style, 'max-height', '212px')
															]),
														A2(
															$elm$core$List$map,
															$author$project$Components$ExportCsv$viewColumn(model.aC),
															$author$project$Api$Common$CsvReport$One$columns(csvReport)))
													])),
												A2(
												$elm$html$Html$p,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('flex justify-end gap-4')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class(flexItemClass)
															]),
														_List_fromArray(
															[
																A3(
																$author$project$Ui$Button$view,
																{mm: 'Select all'},
																_List_fromArray(
																	[
																		$author$project$Ui$Button$link,
																		$author$project$Ui$Button$onClick(
																		$author$project$Components$ExportCsv$SelectAllColumns(csvReport))
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Select All')
																	]))
															])),
														A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class(flexItemClass)
															]),
														_List_fromArray(
															[
																A3(
																$author$project$Ui$Button$view,
																{mm: 'Select all'},
																_List_fromArray(
																	[
																		$author$project$Ui$Button$link,
																		$author$project$Ui$Button$onClick($author$project$Components$ExportCsv$DeselectAllColumns)
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Unselect All')
																	]))
															])),
														$author$project$Components$ExportCsv$canSaveDefaultColumns(model) ? A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class(flexItemClass)
															]),
														_List_fromArray(
															[
																A3(
																$author$project$Ui$Button$view,
																{mm: 'Save selection'},
																_List_fromArray(
																	[
																		$author$project$Ui$Button$link,
																		$author$project$Ui$Button$onClick($author$project$Components$ExportCsv$SaveDefaultColumns)
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Save Selection')
																	]))
															])) : $author$project$Utils$Html$empty,
														A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('text-muted')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																$elm$core$String$fromInt(
																	$elm$core$Set$size(model.aC)) + (' of ' + ($elm$core$String$fromInt(
																	$elm$core$List$length(
																		$author$project$Api$Common$CsvReport$One$columns(csvReport))) + ' columns to be exported')))
															]))
													])),
												A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														$author$project$Components$ExportCsv$isInvalid(optionsRecord.qC) ? $author$project$Utils$FormErrors$view(
														_List_fromArray(
															[
																'Your report exceeds the  ' + ($author$project$Formatters$Int$formatNumber($author$project$Components$ExportCsv$totalCountLimit) + ' items limit and cannot be exported. Please refine your search criteria (e.g., adjust date ranges or filters) to reduce the number of records, then try again.')
															])) : $author$project$Utils$Html$empty
													]))
											]));
								} else {
									return A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-center')
											]),
										_List_fromArray(
											[
												$author$project$Ui$Spinner$view(_List_Nil)
											]));
								}
							}
						}()
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							(optionsRecord.kV && $author$project$Components$ExportCsv$reportExportGenerated(model.cR)) ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-center')
								]),
							_List_fromArray(
								[
									function () {
									var _v2 = A2($author$project$Components$ExportCsv$reportExportHref, apiClient, model);
									if (!_v2.$) {
										var reportExportHref_ = _v2.a;
										return A2(
											$elm$html$Html$map,
											$author$project$Components$ExportCsv$ExportFileMsg,
											A3(
												$author$project$Components$FileLink$view,
												{NJ: apiClient, SG: 0, adY: reportExportHref_},
												_List_fromArray(
													[$author$project$Ui$Link$buttonPrimary]),
												_List_fromArray(
													[
														$elm$html$Html$text('Download')
													])));
									} else {
										return A3(
											$author$project$Ui$Button$view,
											{mm: 'Download'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$disabled(true)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Download')
												]));
									}
								}()
								])) : A2(
							$author$project$Ui$Grid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(6)
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{mm: 'Cancel'},
											_List_fromArray(
												[
													$author$project$Ui$Button$fullWidth(true),
													$author$project$Ui$Button$onClick($author$project$Components$ExportCsv$CloseModal)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Cancel')
												]))
										])),
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(6)
										]),
									function () {
										if (optionsRecord.kV) {
											return _List_fromArray(
												[
													A3(
													$author$project$Ui$Button$view,
													{mm: 'Export'},
													_List_fromArray(
														[
															$author$project$Ui$Button$fullWidth(true),
															$author$project$Ui$Button$primary,
															$author$project$Ui$Button$disabled(
															model.gp || $author$project$Components$ExportCsv$isInvalid(optionsRecord.qC)),
															$author$project$Ui$Button$onClick(
															$author$project$Components$ExportCsv$StartExport(optionsRecord.DP)),
															$author$project$Ui$Button$loading(
															_Utils_eq(optionsRecord.qC, $elm$core$Maybe$Nothing))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Export')
														]))
												]);
										} else {
											var _v3 = A3(
												$author$project$Components$ExportCsv$downloadCsvHref,
												apiClient,
												optionsRecord,
												$elm$core$Set$toList(model.aC));
											if (!_v3.$) {
												var downloadCsvHref_ = _v3.a;
												return _List_fromArray(
													[
														A2(
														$elm$html$Html$map,
														$author$project$Components$ExportCsv$ExportFileMsg,
														A3(
															$author$project$Components$FileLink$view,
															{NJ: apiClient, SG: 0, adY: downloadCsvHref_},
															_List_fromArray(
																[$author$project$Ui$Link$buttonPrimary, $author$project$Ui$Link$fullWidth]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Export')
																])))
													]);
											} else {
												return _List_fromArray(
													[
														A3(
														$author$project$Ui$Button$view,
														{mm: 'Export'},
														_List_fromArray(
															[
																$author$project$Ui$Button$link,
																$author$project$Ui$Button$disabled(true)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Export')
															]))
													]);
											}
										}
									}())
								]))
						]))
				]));
	});
var $author$project$Components$ExportCsv$modal = F3(
	function (apiClient, options, model) {
		return model.Ao ? A3($author$project$Components$ExportCsv$viewModal, apiClient, options, model) : $author$project$Utils$Html$empty;
	});
var $author$project$Components$ExportCsv$Params = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$ExportCsv$params = $author$project$Components$ExportCsv$Params;
var $author$project$Components$ExportCsv$Path = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$ExportCsv$path = $author$project$Components$ExportCsv$Path;
var $author$project$Components$Upload$Result$viewExportToCsvModal = F3(
	function (apiClient, upload, model) {
		return A2(
			$elm$html$Html$map,
			$author$project$Components$Upload$Result$ExportCsvMsg,
			A3(
				$author$project$Components$ExportCsv$modal,
				apiClient,
				_List_fromArray(
					[
						$author$project$Components$ExportCsv$params(
						$author$project$Components$Upload$Result$exportParams(upload)),
						$author$project$Components$ExportCsv$path(
						$author$project$Api$Provider$UploadRow$uploadRowsPath(
							$author$project$Api$Provider$Upload$One$id(upload))),
						$author$project$Components$ExportCsv$filter('upload')
					]),
				model.nD));
	});
var $author$project$Components$Upload$Result$PaginationMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Panel$Danger = 4;
var $author$project$Ui$Panel$Styling = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Panel$danger = $author$project$Ui$Panel$Styling(4);
var $author$project$Api$Common$Upload$Shared$errorMessage = function (_v0) {
	var record = _v0;
	return record.RM;
};
var $author$project$Api$Provider$Upload$One$errorMessage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$errorMessage(shared);
};
var $author$project$Components$Upload$Result$errorMessages = function (upload) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			$elm$core$String$split('\n'),
			$author$project$Api$Provider$Upload$One$errorMessage(upload)));
};
var $author$project$Api$Provider$UploadRow$All$uploadRowResults = function (_v0) {
	var record = _v0.b;
	return record.adU;
};
var $author$project$Api$Provider$UploadRowResult$Shared$data = function (_v0) {
	var record = _v0;
	return record.Pw;
};
var $author$project$Api$Common$UploadRowResult$Data$field = function (_v0) {
	var record = _v0;
	return record.Sl;
};
var $author$project$Components$Upload$Result$errorField = function (uploadRowResult) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$andThen,
			$author$project$Api$Common$UploadRowResult$Data$field,
			$author$project$Api$Provider$UploadRowResult$Shared$data(uploadRowResult)));
};
var $author$project$Api$Common$UploadRowResult$Data$value = function (_v0) {
	var record = _v0;
	return record.aee;
};
var $author$project$Components$Upload$Result$errorFieldValue = function (uploadRowResult) {
	return A2(
		$elm$core$Maybe$andThen,
		$author$project$Api$Common$UploadRowResult$Data$value,
		$author$project$Api$Provider$UploadRowResult$Shared$data(uploadRowResult));
};
var $author$project$Api$Provider$UploadRowResult$Shared$message = function (_v0) {
	var record = _v0;
	return record.aiH;
};
var $author$project$Api$Provider$UploadRowResult$Shared$rowNumber = function (_v0) {
	var record = _v0;
	return record.aab;
};
var $author$project$Components$Upload$Result$viewUploadRowResult = function (uploadRowResult) {
	return A2(
		$author$project$Ui$Table$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$fromInt(
							$author$project$Api$Provider$UploadRowResult$Shared$rowNumber(uploadRowResult)))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Components$Upload$Result$errorField(uploadRowResult))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$text,
						_List_fromArray(
							[
								$author$project$Ui$Typography$phi(true)
							]),
						function () {
							var _v0 = $author$project$Components$Upload$Result$errorFieldValue(uploadRowResult);
							if (!_v0.$) {
								var value = _v0.a;
								return value;
							} else {
								return 'Blank';
							}
						}())
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$text,
						_List_fromArray(
							[
								$author$project$Ui$Typography$phi(true)
							]),
						A2(
							$elm$core$Maybe$withDefault,
							'',
							$author$project$Api$Provider$UploadRowResult$Shared$message(uploadRowResult)))
					])),
				A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil)
			]));
};
var $author$project$Components$Upload$Result$viewUploadRow = function (uploadRow) {
	return A2(
		$elm$core$List$map,
		$author$project$Components$Upload$Result$viewUploadRowResult,
		$author$project$Api$Provider$UploadRow$All$uploadRowResults(uploadRow));
};
var $author$project$Components$Upload$Result$viewUploadErrors = F2(
	function (model, upload) {
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_fromArray(
					[$author$project$Ui$Panel$danger]),
				A2(
					$elm$core$List$cons,
					A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (message) {
								return A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(message)
										]));
							},
							$author$project$Components$Upload$Result$errorMessages(upload))),
					function () {
						var _v0 = model.vk;
						if (_v0.$ === 3) {
							var list = _v0.a;
							return $elm$core$List$isEmpty(list) ? _List_Nil : _List_fromArray(
								[
									A4(
									$author$project$Ui$Panel$table,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Table$header,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Row #')
												])),
											A2(
											$author$project$Ui$Table$header,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Field')
												])),
											A2(
											$author$project$Ui$Table$header,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Value')
												])),
											A2(
											$author$project$Ui$Table$header,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Error')
												])),
											A2(
											$author$project$Ui$Table$header,
											_List_fromArray(
												[$author$project$Ui$Table$textRight]),
											_List_fromArray(
												[
													A2($elm$html$Html$map, $author$project$Components$Upload$Result$ExportCsvMsg, $author$project$Components$ExportCsv$button)
												]))
										]),
									A2($elm$core$List$concatMap, $author$project$Components$Upload$Result$viewUploadRow, list),
									_List_Nil),
									A2(
									$author$project$Ui$Panel$footer,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$map,
											$author$project$Components$Upload$Result$PaginationMsg,
											A2($author$project$Api$Pagination$view, _List_Nil, model.ajJ))
										]))
								]);
						} else {
							return _List_Nil;
						}
					}()))
			]);
	});
var $author$project$Components$Upload$Result$viewModalBody = F3(
	function (apiClient, model, upload) {
		var _v0 = _Utils_Tuple2(
			$author$project$Components$Upload$Result$finishProcessing(upload),
			model.vk);
		if (_v0.a && (_v0.b.$ === 3)) {
			var _v1 = _v0.b;
			var uploadRows = _v1.a;
			return A2(
				$elm$core$List$cons,
				A3($author$project$Components$Upload$Result$viewExportToCsvModal, apiClient, upload, model),
				A2($author$project$Components$Upload$Result$failed, upload, uploadRows) ? A2($author$project$Components$Upload$Result$viewUploadErrors, model, upload) : _List_fromArray(
					[
						A2(
						$author$project$Ui$Alert$success,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Your file was uploaded successfully.'),
								function () {
								var _v2 = $author$project$Api$Provider$Upload$One$uploaderType(upload);
								if (_v2.$ === 3) {
									return A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Export results: '),
												A2($elm$html$Html$map, $author$project$Components$Upload$Result$ExportCsvMsg, $author$project$Components$ExportCsv$button)
											]));
								} else {
									return $author$project$Utils$Html$empty;
								}
							}()
							]))
					]));
		} else {
			return _List_fromArray(
				[
					$author$project$Ui$Spinner$view(_List_Nil),
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					$elm$html$Html$text('Your upload is processing and may take a few minutes.'),
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					($author$project$Api$Provider$Upload$One$rowsTotal(upload) > 0) ? $elm$html$Html$text(
					'Processed ' + (A2($elm$core$Basics$composeL, $elm$core$String$fromInt, $author$project$Api$Provider$Upload$One$rowsProcessedOrIgnored)(upload) + (' out of ' + A2($elm$core$Basics$composeL, $elm$core$String$fromInt, $author$project$Api$Provider$Upload$One$rowsTotal)(upload)))) : $author$project$Utils$Html$empty
				]);
		}
	});
var $author$project$Components$Upload$Result$modal = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$Upload$Result$ModalClosed,
			_List_fromArray(
				[$author$project$Ui$Modal$lg]),
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							function () {
							var _v0 = model.FZ;
							if (_v0.$ === 3) {
								var upload = _v0.a;
								return $author$project$Ui$Modal$title(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										$author$project$Api$Provider$Upload$One$name(upload)));
							} else {
								return $author$project$Ui$Spinner$view(_List_Nil);
							}
						}()
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-center')
								]),
							function () {
								var _v1 = model.FZ;
								if (_v1.$ === 3) {
									var upload = _v1.a;
									return A3($author$project$Components$Upload$Result$viewModalBody, apiClient, model, upload);
								} else {
									return _List_fromArray(
										[
											$author$project$Ui$Spinner$view(_List_Nil)
										]);
								}
							}())
						]))
				]));
	});
var $author$project$Components$Upload$CannotUploadModal$view = function (onClose) {
	return A3(
		$author$project$Ui$Modal$view,
		onClose,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('There is an upload currently in process. Please wait for it to be done before starting another.')
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Understood'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick(onClose)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('OK')
							]))
					]))
			]));
};
var $author$project$Components$Upload$Form$modal = F2(
	function (apiClient, model) {
		var _v0 = _Utils_Tuple2(model.p2, model.h5);
		if (!_v0.b.$) {
			var uploadResult = _v0.b.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Components$Upload$Form$UploadResultMsg,
				A2($author$project$Components$Upload$Result$modal, apiClient, uploadResult));
		} else {
			if (_v0.a) {
				return $author$project$Components$Upload$CannotUploadModal$view($author$project$Components$Upload$Form$CloseCannotUploadModal);
			} else {
				return $author$project$Utils$Html$empty;
			}
		}
	});
var $author$project$Pages$Admin$ChargeItems$Upload$DeleteAllCharges = {$: 1};
var $author$project$Ui$Form$File$Csv = 1;
var $author$project$Components$Upload$Form$FileUploaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Upload$Resource$Membership = 5;
var $author$project$Api$Provider$Upload$Column$columns = function (_v0) {
	var uploadColumns = _v0;
	return uploadColumns.N3;
};
var $author$project$Ui$Form$File$Disabled = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$File$disabled = $author$project$Ui$Form$File$Disabled;
var $author$project$Ui$Form$File$Empty = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Form$File$empty = $author$project$Ui$Form$File$Empty;
var $author$project$Api$Provider$Upload$templatePath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['template']),
	$author$project$Api$Provider$Upload$uploadsPath($author$project$Api$Data$providerPath));
var $author$project$Components$Upload$Form$exportCsvPath = F2(
	function (apiClient, model) {
		return A4(
			$author$project$Api$Data$downloadUrl,
			apiClient,
			$author$project$Api$Provider$Upload$templatePath,
			0,
			_List_fromArray(
				[
					A2(
					$elm$url$Url$Builder$string,
					'type',
					$author$project$Api$Upload$Resource$toString(model.Jy))
				]));
	});
var $author$project$Api$Provider$Upload$Column$ignoredColumns = function (_v0) {
	var uploadColumns = _v0;
	return uploadColumns.TN;
};
var $author$project$Api$Provider$Upload$Column$columnAliases = function (_v0) {
	var column = _v0;
	return column.Ln;
};
var $author$project$Api$Provider$Upload$Column$columnAllowedValues = function (_v0) {
	var column = _v0;
	return column.LB;
};
var $author$project$Api$Provider$Upload$Column$columnDefault = function (_v0) {
	var column = _v0;
	return column.PW;
};
var $author$project$Api$Provider$Upload$Column$columnHelp = function (_v0) {
	var column = _v0;
	return column.Tp;
};
var $author$project$Api$Provider$Upload$Column$columnName = function (_v0) {
	var column = _v0;
	return column.Bq;
};
var $author$project$Api$Provider$Upload$Column$columnRequired = function (_v0) {
	var column = _v0;
	return column.akR;
};
var $author$project$Ui$Typography$em = F2(
	function (options, content) {
		return A2(
			$elm$html$Html$em,
			$author$project$Ui$Typography$optionsToAttributes(options),
			A2(
				$elm$core$List$map,
				$elm$html$Html$map($elm$core$Basics$never),
				content));
	});
var $author$project$Components$Upload$Form$formatAliases = function (column) {
	return A2(
		$elm$core$String$join,
		', ',
		A2(
			$elm$core$List$map,
			function (columnAlias) {
				return '\"' + (columnAlias + '\"');
			},
			$author$project$Api$Provider$Upload$Column$columnAliases(column)));
};
var $author$project$Components$Upload$Form$viewColumn = function (column) {
	return A2(
		$elm$html$Html$li,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Api$Provider$Upload$Column$columnName(column)),
				$author$project$Api$Provider$Upload$Column$columnRequired(column) ? A2(
				$author$project$Ui$Typography$em,
				_List_fromArray(
					[$author$project$Ui$Typography$danger, $author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
				_List_fromArray(
					[
						$elm$html$Html$text(' * required')
					])) : $author$project$Utils$Html$empty,
				function () {
				var _v0 = $author$project$Api$Provider$Upload$Column$columnAllowedValues(column);
				if (!_v0.$) {
					var allowedValues = _v0.a;
					return A2(
						$author$project$Ui$Typography$em,
						_List_fromArray(
							[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
						_List_fromArray(
							[
								$elm$html$Html$text(allowedValues)
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v1 = $author$project$Api$Provider$Upload$Column$columnDefault(column);
				if (!_v1.$) {
					var _default = _v1.a;
					return A2(
						$author$project$Ui$Typography$em,
						_List_fromArray(
							[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
						_List_fromArray(
							[
								$elm$html$Html$text(' Default: ' + _default)
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				$elm$core$List$isEmpty(
				$author$project$Api$Provider$Upload$Column$columnAliases(column)) ? $author$project$Utils$Html$empty : A2(
				$author$project$Ui$Typography$em,
				_List_fromArray(
					[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						' Aliases: ' + $author$project$Components$Upload$Form$formatAliases(column))
					])),
				function () {
				var _v2 = $author$project$Api$Provider$Upload$Column$columnHelp(column);
				if (!_v2.$) {
					var help = _v2.a;
					return A3(
						$author$project$Ui$Tooltip$view,
						_List_Nil,
						help,
						_List_fromArray(
							[
								$author$project$Utils$Html$noBreakSpace,
								$author$project$Ui$Icon$help(_List_Nil)
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]));
};
var $author$project$Components$Upload$Form$ToggleIgnored = {$: 1};
var $author$project$Components$Upload$Form$viewIgnoredColumns = F2(
	function (showIgnored, ignoredColumns) {
		return A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Click'),
					$author$project$Utils$Html$noBreakSpace,
					A3(
					$author$project$Ui$Button$view,
					{mm: 'see list of extra columns accepted'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$onClick($author$project$Components$Upload$Form$ToggleIgnored)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('here')
						])),
					$author$project$Utils$Html$noBreakSpace,
					$elm$html$Html$text('to see the list of extra columns that are accepted but its value will be ignored.'),
					showIgnored ? A2(
					$elm$html$Html$ul,
					_List_Nil,
					A2(
						$elm$core$List$map,
						function (ignoredColumn) {
							return A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(ignoredColumn)
									]));
						},
						ignoredColumns)) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$Upload$Form$ViewUploadResult = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Common$Upload$Shared$createdAt = function (_v0) {
	var record = _v0;
	return record.O1;
};
var $author$project$Api$Provider$Upload$All$createdAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$createdAt(shared);
};
var $author$project$Api$Provider$Upload$All$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$name(shared);
};
var $author$project$Components$Upload$Form$viewPendingUpload = F2(
	function (timeFormatter, pendingUpload) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								$author$project$Api$Provider$Upload$All$name(pendingUpload)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								timeFormatter,
								0,
								$author$project$Api$Provider$Upload$All$createdAt(pendingUpload)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'View progress'},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$onClick(
									$author$project$Components$Upload$Form$ViewUploadResult(pendingUpload))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('View Progress')
								]))
						]))
				]));
	});
var $author$project$Components$Upload$Form$viewPendingUploads = F2(
	function (timeFormatter, pendingUploads) {
		if (pendingUploads.$ === 3) {
			var pendingUploads_ = pendingUploads.a;
			return $elm$core$List$isEmpty(pendingUploads_) ? $author$project$Utils$Html$empty : A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Pending uploads')
							])),
						A4(
						$author$project$Ui$Panel$table,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Table$header,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('File Name')
									])),
								A2(
								$author$project$Ui$Table$header,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Uploaded at')
									])),
								A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
							]),
						A2(
							$elm$core$List$map,
							$author$project$Components$Upload$Form$viewPendingUpload(timeFormatter),
							pendingUploads_),
						_List_Nil)
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$Upload$Form$view = F2(
	function (apiClient, model) {
		var _v0 = model.F_;
		if (_v0.$ === 3) {
			var uploadColumns = _v0.a;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$title,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Step 2. Create a CSV file.')
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('It should include these exact headers:')
							])),
						A2(
						$elm$html$Html$ul,
						_List_Nil,
						A2(
							$elm$core$List$map,
							$author$project$Components$Upload$Form$viewColumn,
							$author$project$Api$Provider$Upload$Column$columns(uploadColumns))),
						$elm$core$List$isEmpty(
						$author$project$Api$Provider$Upload$Column$ignoredColumns(uploadColumns)) ? $author$project$Utils$Html$empty : A2(
						$author$project$Components$Upload$Form$viewIgnoredColumns,
						model.uE,
						$author$project$Api$Provider$Upload$Column$ignoredColumns(uploadColumns)),
						A2(
						$author$project$Ui$Typography$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Get started with our ready-to-go template'),
								$author$project$Utils$Html$noBreakSpace,
								(model.Jy === 5) ? A3(
								$author$project$Ui$Link$externalHref,
								'https://docs.google.com/spreadsheets/d/1gOlyMYkKwCRuI682gvS2Z8VJq9LdChM_px-4g28MXZs/edit?gid=2103379914',
								_List_fromArray(
									[$author$project$Ui$Link$targetBlank]),
								_List_fromArray(
									[
										$elm$html$Html$text('here.')
									])) : A2(
								$elm$html$Html$map,
								$author$project$Components$Upload$Form$ExportFileMsg,
								A3(
									$author$project$Components$FileLink$view,
									{
										NJ: apiClient,
										SG: 0,
										adY: A2($author$project$Components$Upload$Form$exportCsvPath, apiClient, model)
									},
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('here.')
										])))
							])),
						A2($elm$html$Html$br, _List_Nil, _List_Nil),
						A2(
						$author$project$Ui$Typography$title,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Step 3. Upload the file.')
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_Nil,
						_List_fromArray(
							[
								model.xR ? $elm$html$Html$text('Don\'t worry, once it\'s uploaded you\'ll be able to fix any errors.') : $elm$html$Html$text('There is an upload in process. Uploading will be available when it is complete.')
							])),
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$noValidate(true),
								$author$project$Ui$Form$autocomplete(false)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Form$File$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$File$disabled(!model.xR),
												$author$project$Ui$Form$File$accept(1),
												$author$project$Ui$Form$File$onInput($author$project$Components$Upload$Form$FileUploaded),
												$author$project$Ui$Form$File$empty(true)
											]))
									]))
							])),
						A2($author$project$Components$Upload$Form$viewPendingUploads, model.J7, model.C9)
					]));
		} else {
			return $author$project$Ui$Spinner$view(_List_Nil);
		}
	});
var $author$project$Pages$Admin$ChargeItems$Upload$viewBody = function (model) {
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_fromArray(
					[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
				_List_fromArray(
					[
						$author$project$Ui$Panel$title(
						_List_fromArray(
							[
								$elm$html$Html$text('Upload Charge Items')
							])),
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Admin__ChargeItems__Top,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Icon$cross(_List_Nil)
							]))
					])),
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						(!A2($author$project$Api$Provider$Practice$One$featureEnabled, 6, model.ZV)) ? A2(
						$author$project$Ui$Well$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Want to Start Over?')
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Click the button below to remove existing charge items.')
									])),
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Delete all charge items'},
								_List_fromArray(
									[
										$author$project$Ui$Button$danger,
										$author$project$Ui$Button$onClick($author$project$Pages$Admin$ChargeItems$Upload$DeleteAllCharges)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Delete All Charge Items')
									]))
							])) : $author$project$Utils$Html$empty,
						A2(
						$elm$html$Html$map,
						$author$project$Pages$Admin$ChargeItems$Upload$UploadFormMsg,
						A2($author$project$Components$Upload$Form$view, model.Gv, model.SD))
					])),
				A2(
				$author$project$Ui$Panel$footer,
				_List_fromArray(
					[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$gap2]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Admin__ChargeItems__Top,
						_List_fromArray(
							[$author$project$Ui$Link$buttonDefault]),
						_List_fromArray(
							[
								$elm$html$Html$text('Back')
							]))
					]))
			]));
};
var $author$project$Pages$Admin$ChargeItems$Upload$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				model.ne ? A2(
				$author$project$Components$HiConfirm$modal,
				$author$project$Pages$Admin$ChargeItems$Upload$HiConfirmChargesClosed,
				_List_fromArray(
					[
						$author$project$Components$HiConfirm$verb('Delete All Charges'),
						$author$project$Components$HiConfirm$customMessage(
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Warning: ')
									])),
								$elm$html$Html$text('this will delete all the charges from the practice.')
							]))
					])) : $author$project$Utils$Html$empty,
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Admin$ChargeItems$Upload$UploadFormMsg,
				A2($author$project$Components$Upload$Form$modal, model.Gv, model.SD)),
				$author$project$Pages$Admin$ChargeItems$Upload$viewBody(model)
			]),
		ac9: 'Admin | Charge Items'
	};
};
var $author$project$Pages$Admin$ChargeItems$Upload$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$ChargeItems$Upload$init, aiq: $author$project$Pages$Admin$ChargeItems$Upload$load, k8: $author$project$Pages$Admin$ChargeItems$Upload$save, alO: $author$project$Pages$Admin$ChargeItems$Upload$subscriptions, adT: $author$project$Pages$Admin$ChargeItems$Upload$update, amo: $author$project$Pages$Admin$ChargeItems$Upload$view});
var $author$project$Pages$Admin$Commissions$init = F4(
	function (session, practice, shared, _v0) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, ZV: practice, aa4: session},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Commissions$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Commissions$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Commissions$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$Commissions$GotPractice = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Practice$enableCommissions = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$Practice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['enable_commissions']),
					$author$project$Api$Provider$Practice$practicePath)));
	});
var $author$project$Pages$Admin$Commissions$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(
					model,
					A2($author$project$Api$Provider$Practice$enableCommissions, model.Gv, $author$project$Pages$Admin$Commissions$GotPractice),
					_List_Nil);
			case 1:
				var response = msg.a;
				if (response.$ === 3) {
					var practice = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ZV: practice}),
						A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__Top),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Commissions successfully enabled'),
								$author$project$OutMsg$PracticeUpdated(response)
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				return _Utils_Tuple3(
					model,
					$author$project$Ports$Intercom$open(model.aa4),
					_List_Nil);
		}
	});
var $author$project$Formatters$Date$MonthAndYear = {$: 2};
var $author$project$Api$Provider$Practice$One$commissionsEnabled = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.N6;
	});
var $author$project$Api$Provider$Practice$One$commissionsTrackingFrom = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.N7;
	});
var $author$project$Api$Feature$CommissionsTracking = 0;
var $author$project$Pages$Admin$Commissions$Enable = {$: 0};
var $author$project$Pages$Admin$Commissions$ShowSupportChat = {$: 2};
var $author$project$Pages$Admin$Commissions$viewEnableForm = function (model) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Form$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$noValidate(true),
					$author$project$Ui$Form$autocomplete(false),
					$author$project$Ui$Form$onSubmit($author$project$Pages$Admin$Commissions$Enable)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpanSm(4),
							$author$project$Ui$Form$Group$inputSpanSm(8),
							$author$project$Ui$Form$Group$label('Description')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Once enabled, We will allow a broker to be associated with a retail membership and/or employers. '),
									$elm$html$Html$text('Commissions will be automatically calculated for these relationships.')
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpanSm(4),
							$author$project$Ui$Form$Group$inputSpanSm(8),
							$author$project$Ui$Form$Group$label('')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Enable commissions'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$submit,
									$author$project$Ui$Button$disabled(
									!A2($author$project$Api$Provider$Practice$One$featureEnabled, 0, model.ZV))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Enable commissions')
								])),
							A2($author$project$Api$Provider$Practice$One$featureEnabled, 0, model.ZV) ? $author$project$Utils$Html$empty : A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textMuted]),
									_List_fromArray(
										[
											$elm$html$Html$text('Commissions is not yet available for your account, please '),
											A3(
											$author$project$Ui$Button$view,
											{mm: 'contact us'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick($author$project$Pages$Admin$Commissions$ShowSupportChat)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('contact us')
												])),
											$elm$html$Html$text(' to learn more.')
										]))
								]))
						]))
				]))
		]);
};
var $author$project$Pages$Admin$Commissions$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$author$project$Api$Provider$Practice$One$commissionsEnabled(model.ZV) ? $elm$html$Html$text('Commissions set-up') : $elm$html$Html$text('Enable commissions for this practice')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						$author$project$Api$Provider$Practice$One$commissionsEnabled(model.ZV) ? _List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$labelSpanSm(4),
										$author$project$Ui$Form$Group$inputSpanSm(8),
										$author$project$Ui$Form$Group$label('Commission Status')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Static$view,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Tracking started in '),
												$elm$html$Html$text(
												A2(
													$elm$core$Maybe$withDefault,
													'',
													A2(
														$elm$core$Maybe$map,
														$author$project$Formatters$Date$toString($author$project$Formatters$Date$MonthAndYear),
														$author$project$Api$Provider$Practice$One$commissionsTrackingFrom(model.ZV))))
											]))
									]))
							]) : $author$project$Pages$Admin$Commissions$viewEnableForm(model))
					]))
			]),
		ac9: 'Admin | Commissions'
	};
};
var $author$project$Pages$Admin$Commissions$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Commissions$init, aiq: $author$project$Pages$Admin$Commissions$load, k8: $author$project$Pages$Admin$Commissions$save, alO: $author$project$Pages$Admin$Commissions$subscriptions, adT: $author$project$Pages$Admin$Commissions$update, amo: $author$project$Pages$Admin$Commissions$view});
var $author$project$Components$Plan$Form$Model = $elm$core$Basics$identity;
var $author$project$Components$Plan$Form$PlanChangeChangeOnDateInputMsg = function (a) {
	return {$: 21, a: a};
};
var $author$project$Api$Feature$TobaccoSurcharge = 2;
var $author$project$Api$Provider$Plan$CoveragePlan = 1;
var $author$project$Components$Plan$Form$GotItem = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Plan$McePricing = 2;
var $author$project$Api$Provider$Plan$One$Plan = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Plan$Shared$Plan = $elm$core$Basics$identity;
var $author$project$Api$Provider$Plan$Shared$Record = function (id) {
	return function (name) {
		return function (_default) {
			return function (addon) {
				return function (activeMembershipPatientsCount) {
					return function (activeCompaniesCount) {
						return function (planType) {
							return function (allowedBillingPeriodCodes) {
								return function (defaultPeriodInMonths) {
									return function (groupPricingType) {
										return function (groupDiscountRules) {
											return function (tobaccoSurchargeType) {
												return function (tobaccoSurchargeInCents) {
													return function (tobaccoSurchargePercentage) {
														return function (billsAtEndOfPeriod) {
															return function (maximumAge) {
																return function (minimumAge) {
																	return function (isMcePlan) {
																		return function (minimumEnrollmentPeriodInMonths) {
																			return function (isDestroyable) {
																				return function (ageRateRules) {
																					return function (individualRateRule) {
																						return function (coupleRateRule) {
																							return function (singleParentWithSingleChildRateRuleEnabled) {
																								return function (singleParentWithSingleChildRateRule) {
																									return function (singleParentRateRule) {
																										return function (familyWithSingleChildRateRuleEnabled) {
																											return function (familyWithSingleChildRateRule) {
																												return function (additionalAdultRateRule) {
																													return function (additionalChildRateRule) {
																														return function (familyRateRule) {
																															return function (discountRules) {
																																return function (coupleDiscountRule) {
																																	return function (singleParentDiscountRule) {
																																		return function (familyDiscountRule) {
																																			return function (additionalAdultDiscountRule) {
																																				return function (additionalChildDiscountRule) {
																																					return function (childrenOnlyDiscountRule) {
																																						return function (specialRates) {
																																							return function (pricingFrom) {
																																								return function (sponsorFeeDeal) {
																																									return function (coveragePlan) {
																																										return {KO: activeCompaniesCount, KR: activeMembershipPatientsCount, vB: additionalAdultDiscountRule, KZ: additionalAdultRateRule, vC: additionalChildDiscountRule, K_: additionalChildRateRule, K$: addon, Lk: ageRateRules, Gq: allowedBillingPeriodCodes, MI: billsAtEndOfPeriod, x3: childrenOnlyDiscountRule, yS: coupleDiscountRule, ON: coupleRateRule, OT: coveragePlan, PW: _default, P7: defaultPeriodInMonths, QG: discountRules, zB: familyDiscountRule, R9: familyRateRule, Sb: familyWithSingleChildRateRule, Sc: familyWithSingleChildRateRuleEnabled, SZ: groupDiscountRules, S1: groupPricingType, ahP: id, TX: individualRateRule, UN: isDestroyable, UW: isMcePlan, WF: maximumAge, Xd: minimumAge, Xf: minimumEnrollmentPeriodInMonths, Bq: name, ZF: planType, _k: pricingFrom, EG: singleParentDiscountRule, abC: singleParentRateRule, abE: singleParentWithSingleChildRateRule, abF: singleParentWithSingleChildRateRuleEnabled, abT: specialRates, abZ: sponsorFeeDeal, adf: tobaccoSurchargeInCents, adg: tobaccoSurchargePercentage, adh: tobaccoSurchargeType};
																																									};
																																								};
																																							};
																																						};
																																					};
																																				};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$PlanType$AffiliateDependable = 4;
var $author$project$Api$PlanType$Company = 0;
var $author$project$Api$PlanType$Mce = 3;
var $author$project$Api$PlanType$Retail = 2;
var $author$project$Api$PlanType$SponsorFixedFee = 1;
var $author$project$Api$PlanType$decodePlanType = function (string) {
	switch (string) {
		case 'company':
			return $elm$json$Json$Decode$succeed(0);
		case 'sponsor_fixed_fee':
			return $elm$json$Json$Decode$succeed(1);
		case 'retail':
			return $elm$json$Json$Decode$succeed(2);
		case 'mce':
			return $elm$json$Json$Decode$succeed(3);
		case 'affiliate_dependable':
			return $elm$json$Json$Decode$succeed(4);
		default:
			return $elm$json$Json$Decode$fail('Unsupported plan type: ' + string);
	}
};
var $author$project$Api$PlanType$decoder = A2($elm$json$Json$Decode$andThen, $author$project$Api$PlanType$decodePlanType, $elm$json$Json$Decode$string);
var $author$project$Api$Provider$CoveragePlan$One$CoveragePlan = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$CoveragePlan$Shared$CoveragePlan = $elm$core$Basics$identity;
var $author$project$Api$Provider$CoveragePlan$Shared$Record = F3(
	function (id, name, coverageRules) {
		return {afY: coverageRules, ahP: id, Bq: name};
	});
var $author$project$Api$Provider$CoverageRule$One$CoverageRule = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$CoverageRule$Shared$CoverageRule = $elm$core$Basics$identity;
var $author$project$Api$Provider$CoverageRule$Shared$Record = function (id) {
	return function (ruleType) {
		return function (amountInCents) {
			return function (timePeriod) {
				return function (quantity) {
					return function (percentage) {
						return function (patientContributionPercentage) {
							return function (sponsorContributionPercentage) {
								return function (item) {
									return function (published) {
										return function (category) {
											return {LE: amountInCents, GW: category, ahP: id, Io: item, ajS: patientContributionPercentage, ajZ: percentage, _I: published, Dz: quantity, ak7: ruleType, alE: sponsorContributionPercentage, al4: timePeriod};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$CoverageRule$Shared$Category = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$CoverageRule$Shared$categoryDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Category$Shared$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$CoverageRule$Shared$Category));
var $author$project$Api$Provider$CoverageRule$Shared$ChargeItem = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$CoverageRule$Shared$chargeItemDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ChargeItem$Shared$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$CoverageRule$Shared$ChargeItem));
var $author$project$Api$Provider$Category$Min$Category = $elm$core$Basics$identity;
var $author$project$Api$Provider$Category$Min$Record = F2(
	function (id, name) {
		return {ahP: id, Bq: name};
	});
var $author$project$Api$Provider$Category$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Category$Min$Record)));
var $author$project$Api$Provider$Category$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Category$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CoverageRule$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'category',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Category$Min$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'published',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'item',
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[$author$project$Api$Provider$CoverageRule$Shared$chargeItemDecoder, $author$project$Api$Provider$CoverageRule$Shared$categoryDecoder])),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'sponsor_contribution_percentage',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'patient_contribution_percentage',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'percentage',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'quantity',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'time_period',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'amount_in_cents',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'rule_type',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'id',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$Api$Provider$CoverageRule$Shared$Record))))))))))));
var $author$project$Api$Provider$CoverageRule$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CoverageRule$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CoverageRule$One$Record = function (unpublishedRule) {
	return {Kh: unpublishedRule};
};
var $author$project$Api$Provider$CoverageRule$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'unpublished_rule',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$CoverageRule$Shared$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$CoverageRule$One$Record));
var $author$project$Api$Provider$CoverageRule$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CoverageRule$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$CoverageRule$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$CoverageRule$One$CoverageRule)));
var $author$project$Api$Provider$CoveragePlan$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'coverage_rules',
	$elm$json$Json$Decode$list($author$project$Api$Provider$CoverageRule$One$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$CoveragePlan$Shared$Record))));
var $author$project$Api$Provider$CoveragePlan$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CoveragePlan$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CoveragePlan$One$Record = F2(
	function (plans, coverageDocuments) {
		return {OS: coverageDocuments, ZG: plans};
	});
var $author$project$Api$Provider$CoverageDocument$Shared$CoverageDocument = $elm$core$Basics$identity;
var $author$project$Api$Provider$CoverageDocument$Shared$Record = F3(
	function (id, fileName, url) {
		return {Sn: fileName, ahP: id, adY: url};
	});
var $author$project$Api$Provider$CoverageDocument$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'url',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'file_name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$CoverageDocument$Shared$Record))));
var $author$project$Api$Provider$CoverageDocument$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CoverageDocument$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Plan$Min$Plan = $elm$core$Basics$identity;
var $author$project$Api$Provider$Plan$Min$Record = F5(
	function (id, maximumAge, minimumAge, name, tobaccoSurchargeType) {
		return {ahP: id, WF: maximumAge, Xd: minimumAge, Bq: name, adh: tobaccoSurchargeType};
	});
var $author$project$Api$Provider$Plan$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'tobacco_surcharge_type',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'minimum_age',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'maximum_age',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$Plan$Min$Record))))));
var $author$project$Api$Provider$Plan$Min$decoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $author$project$Api$Provider$Plan$Min$recordDecoder);
var $author$project$Api$Provider$CoveragePlan$One$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'coverage_documents',
	$elm$json$Json$Decode$list($author$project$Api$Provider$CoverageDocument$Shared$decoder),
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'plans',
		$elm$json$Json$Decode$list($author$project$Api$Provider$Plan$Min$decoder),
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$CoveragePlan$One$Record)));
var $author$project$Api$Provider$CoveragePlan$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CoveragePlan$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$CoveragePlan$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$CoveragePlan$One$CoveragePlan)));
var $author$project$Api$Provider$DiscountRule$Shared$DiscountRule = $elm$core$Basics$identity;
var $author$project$Api$Provider$DiscountRule$Shared$Record = function (fromSize) {
	return function (toSize) {
		return function (calculatedBy) {
			return function (monthMaximumInCents) {
				return function (monthMaximumInCentsEdited) {
					return function (quarterMaximumInCents) {
						return function (quarterMaximumInCentsEdited) {
							return function (semiAnnualMaximumInCents) {
								return function (semiAnnualMaximumInCentsEdited) {
									return function (annualMaximumInCents) {
										return function (annualMaximumInCentsEdited) {
											return function (monthAmountOffInCents) {
												return function (monthAmountOffInCentsEdited) {
													return function (quarterAmountOffInCents) {
														return function (quarterAmountOffInCentsEdited) {
															return function (semiAnnualAmountOffInCents) {
																return function (semiAnnualAmountOffInCentsEdited) {
																	return function (annualAmountOffInCents) {
																		return function (annualAmountOffInCentsEdited) {
																			return function (monthPercentOff) {
																				return function (monthPercentOffEdited) {
																					return function (quarterPercentOff) {
																						return function (quarterPercentOffEdited) {
																							return function (semiAnnualPercentOff) {
																								return function (semiAnnualPercentOffEdited) {
																									return function (annualPercentOff) {
																										return function (annualPercentOffEdited) {
																											return {LJ: annualAmountOffInCents, LK: annualAmountOffInCentsEdited, LL: annualMaximumInCents, LM: annualMaximumInCentsEdited, LP: annualPercentOff, LQ: annualPercentOffEdited, M2: calculatedBy, SM: fromSize, Xl: monthAmountOffInCents, Xm: monthAmountOffInCentsEdited, Xn: monthMaximumInCents, Xo: monthMaximumInCentsEdited, Xs: monthPercentOff, Xt: monthPercentOffEdited, _S: quarterAmountOffInCents, _T: quarterAmountOffInCentsEdited, _U: quarterMaximumInCents, _V: quarterMaximumInCentsEdited, _Y: quarterPercentOff, _Z: quarterPercentOffEdited, aaL: semiAnnualAmountOffInCents, aaM: semiAnnualAmountOffInCentsEdited, aaN: semiAnnualMaximumInCents, aaO: semiAnnualMaximumInCentsEdited, aaR: semiAnnualPercentOff, aaS: semiAnnualPercentOffEdited, add: toSize};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$DiscountRule$Shared$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'annual_percent_off_edited',
	$elm$json$Json$Decode$bool,
	false,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'annual_percent_off',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'semi_annual_percent_off_edited',
			$elm$json$Json$Decode$bool,
			false,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'semi_annual_percent_off',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'quarter_percent_off_edited',
					$elm$json$Json$Decode$bool,
					false,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'quarter_percent_off',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'month_percent_off_edited',
							$elm$json$Json$Decode$bool,
							false,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'month_percent_off',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'annual_amount_off_in_cents_edited',
									$elm$json$Json$Decode$bool,
									false,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'annual_amount_off_in_cents',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
										$elm$core$Maybe$Nothing,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'semi_annual_amount_off_in_cents_edited',
											$elm$json$Json$Decode$bool,
											false,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'semi_annual_amount_off_in_cents',
												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
												$elm$core$Maybe$Nothing,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'quarter_amount_off_in_cents_edited',
													$elm$json$Json$Decode$bool,
													false,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'quarter_amount_off_in_cents',
														$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
														$elm$core$Maybe$Nothing,
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'month_amount_off_in_cents_edited',
															$elm$json$Json$Decode$bool,
															false,
															A4(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																'month_amount_off_in_cents',
																$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																$elm$core$Maybe$Nothing,
																A4(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																	'annual_maximum_in_cents_edited',
																	$elm$json$Json$Decode$bool,
																	false,
																	A4(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																		'annual_maximum_in_cents',
																		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																		$elm$core$Maybe$Nothing,
																		A4(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																			'semi_annual_maximum_in_cents_edited',
																			$elm$json$Json$Decode$bool,
																			false,
																			A4(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																				'semi_annual_maximum_in_cents',
																				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																				$elm$core$Maybe$Nothing,
																				A4(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																					'quarter_maximum_in_cents_edited',
																					$elm$json$Json$Decode$bool,
																					false,
																					A4(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																						'quarter_maximum_in_cents',
																						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																						$elm$core$Maybe$Nothing,
																						A4(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																							'month_maximum_in_cents_edited',
																							$elm$json$Json$Decode$bool,
																							false,
																							A4(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																								'month_maximum_in_cents',
																								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																								$elm$core$Maybe$Nothing,
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'calculated_by',
																									$elm$json$Json$Decode$string,
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'to_size',
																										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'from_size',
																											$elm$json$Json$Decode$int,
																											$elm$json$Json$Decode$succeed($author$project$Api$Provider$DiscountRule$Shared$Record))))))))))))))))))))))))))));
var $author$project$Api$Provider$DiscountRule$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$DiscountRule$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$RateRule$Shared$RateRule = $elm$core$Basics$identity;
var $author$project$Api$Provider$RateRule$Shared$Record = F6(
	function (type_, fromAge, toAge, unit, periodRates, coupleAgeRateRule) {
		return {OM: coupleAgeRateRule, SK: fromAge, dE: periodRates, adb: toAge, amg: type_, adL: unit};
	});
var $author$project$Api$Provider$RateRule$Shared$CoupleAgeRateRule = function (periodRates) {
	return {dE: periodRates};
};
var $author$project$Api$Provider$RateRule$Shared$PeriodRates = F8(
	function (monthAmountInCents, monthAmountInCentsEdited, quarterAmountInCents, quarterAmountInCentsEdited, semiAnnualAmountInCents, semiAnnualAmountInCentsEdited, annualAmountInCents, annualAmountInCentsEdited) {
		return {LH: annualAmountInCents, fE: annualAmountInCentsEdited, Xk: monthAmountInCents, gX: monthAmountInCentsEdited, _Q: quarterAmountInCents, ho: quarterAmountInCentsEdited, aaJ: semiAnnualAmountInCents, hz: semiAnnualAmountInCentsEdited};
	});
var $author$project$Api$Provider$RateRule$Shared$periodRatesDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'annual_amount_in_cents_edited',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'annual_amount_in_cents',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'semi_annual_amount_in_cents_edited',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'semi_annual_amount_in_cents',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'quarter_amount_in_cents_edited',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'quarter_amount_in_cents',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'month_amount_in_cents_edited',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'month_amount_in_cents',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
								$elm$json$Json$Decode$succeed($author$project$Api$Provider$RateRule$Shared$PeriodRates)))))))));
var $author$project$Api$Provider$RateRule$Shared$coupleAgeRateRuleDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$RateRule$Shared$periodRatesDecoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$RateRule$Shared$CoupleAgeRateRule));
var $author$project$Api$RateRuleType$AdditionalAdult = {$: 6};
var $author$project$Api$RateRuleType$AdditionalChild = {$: 7};
var $author$project$Api$RateRuleType$AgeBased = {$: 8};
var $author$project$Api$RateRuleType$AgeBasedCouple = {$: 9};
var $author$project$Api$RateRuleType$Couple = {$: 1};
var $author$project$Api$RateRuleType$Family = {$: 3};
var $author$project$Api$RateRuleType$FamilyWithSingleChild = {$: 5};
var $author$project$Api$RateRuleType$Individual = {$: 0};
var $author$project$Api$RateRuleType$SingleParent = {$: 2};
var $author$project$Api$RateRuleType$SingleParentWithSingleChild = {$: 4};
var $author$project$Api$RateRuleType$Unknown = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$RateRuleType$decode = A2(
	$elm$json$Json$Decode$map,
	function (string) {
		switch (string) {
			case 'individual':
				return $author$project$Api$RateRuleType$Individual;
			case 'couple':
				return $author$project$Api$RateRuleType$Couple;
			case 'single_parent':
				return $author$project$Api$RateRuleType$SingleParent;
			case 'family':
				return $author$project$Api$RateRuleType$Family;
			case 'single_parent_with_single_child':
				return $author$project$Api$RateRuleType$SingleParentWithSingleChild;
			case 'family_with_single_child':
				return $author$project$Api$RateRuleType$FamilyWithSingleChild;
			case 'additional_adult':
				return $author$project$Api$RateRuleType$AdditionalAdult;
			case 'additional_child':
				return $author$project$Api$RateRuleType$AdditionalChild;
			case 'age_based':
				return $author$project$Api$RateRuleType$AgeBased;
			case 'age_based_couple':
				return $author$project$Api$RateRuleType$AgeBasedCouple;
			default:
				var somethingElse = string;
				return $author$project$Api$RateRuleType$Unknown(somethingElse);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$RateRule$Shared$Months = 1;
var $author$project$Api$Provider$RateRule$Shared$Years = 0;
var $author$project$Api$Provider$RateRule$Shared$stringToUnit = function (str) {
	switch (str) {
		case 'years':
			return 0;
		case 'months':
			return 1;
		default:
			return 0;
	}
};
var $author$project$Api$Provider$RateRule$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'couple_age_rate',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$coupleAgeRateRuleDecoder),
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$RateRule$Shared$periodRatesDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'unit',
			A2($elm$json$Json$Decode$map, $author$project$Api$Provider$RateRule$Shared$stringToUnit, $elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'to_age',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'from_age',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'type',
						$author$project$Api$RateRuleType$decode,
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$RateRule$Shared$Record)))))));
var $author$project$Api$Provider$RateRule$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$RateRule$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$SpecialRate$Shared$SpecialRate = $elm$core$Basics$identity;
var $author$project$Api$Provider$SpecialRate$Shared$Record = function (id) {
	return function (name) {
		return function (monthAmountInCents) {
			return function (monthAmountInCentsEdited) {
				return function (quarterAmountInCents) {
					return function (quarterAmountInCentsEdited) {
						return function (semiAnnualAmountInCents) {
							return function (semiAnnualAmountInCentsEdited) {
								return function (annualAmountInCents) {
									return function (annualAmountInCentsEdited) {
										return function (isDestroyable) {
											return {LH: annualAmountInCents, fE: annualAmountInCentsEdited, ahP: id, UN: isDestroyable, Xk: monthAmountInCents, gX: monthAmountInCentsEdited, Bq: name, _Q: quarterAmountInCents, ho: quarterAmountInCentsEdited, aaJ: semiAnnualAmountInCents, hz: semiAnnualAmountInCentsEdited};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$SpecialRate$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'is_destroyable',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'annual_amount_in_cents_edited',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'annual_amount_in_cents',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'semi_annual_amount_in_cents_edited',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'semi_annual_amount_in_cents',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'quarter_amount_in_cents_edited',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'quarter_amount_in_cents',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'month_amount_in_cents_edited',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'month_amount_in_cents',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'name',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'id',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$Api$Provider$SpecialRate$Shared$Record))))))))))));
var $author$project$Api$Provider$SpecialRate$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$SpecialRate$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$SponsorFeeDeal$Shared$SponsorFeeDeal = $elm$core$Basics$identity;
var $author$project$Api$Provider$SponsorFeeDeal$Shared$Record = function (amountInCents) {
	return {LE: amountInCents};
};
var $author$project$Api$Provider$SponsorFeeDeal$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'amount_in_cents',
	$elm$json$Json$Decode$int,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$SponsorFeeDeal$Shared$Record));
var $author$project$Api$Provider$SponsorFeeDeal$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$SponsorFeeDeal$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Plan$Shared$recordDecoder = A3(
	$author$project$Api$Expandable$expandable,
	'coverage_plan',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$CoveragePlan$One$decoder),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'sponsor_fee_deal',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$SponsorFeeDeal$Shared$decoder),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'pricing_from',
			$elm$json$Json$Decode$nullable($author$project$Api$Provider$PricingStructure$Shared$decoder),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'special_rates',
				$elm$json$Json$Decode$list($author$project$Api$Provider$SpecialRate$Shared$decoder),
				_List_Nil,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'children_only_discount_rule',
					$elm$json$Json$Decode$nullable($author$project$Api$Provider$DiscountRule$Shared$decoder),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'additional_child_discount_rule',
						$elm$json$Json$Decode$nullable($author$project$Api$Provider$DiscountRule$Shared$decoder),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'additional_adult_discount_rule',
							$elm$json$Json$Decode$nullable($author$project$Api$Provider$DiscountRule$Shared$decoder),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'family_discount_rule',
								$elm$json$Json$Decode$nullable($author$project$Api$Provider$DiscountRule$Shared$decoder),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'single_parent_discount_rule',
									$elm$json$Json$Decode$nullable($author$project$Api$Provider$DiscountRule$Shared$decoder),
									$elm$core$Maybe$Nothing,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'couple_discount_rule',
										$elm$json$Json$Decode$nullable($author$project$Api$Provider$DiscountRule$Shared$decoder),
										$elm$core$Maybe$Nothing,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'discount_rules',
											$elm$json$Json$Decode$list($author$project$Api$Provider$DiscountRule$Shared$decoder),
											_List_Nil,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'family_rate_rule',
												$elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder),
												$elm$core$Maybe$Nothing,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'additional_child_rate_rule',
													$elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder),
													$elm$core$Maybe$Nothing,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'additional_adult_rate_rule',
														$elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder),
														$elm$core$Maybe$Nothing,
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'family_with_single_child_rate_rule',
															$elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder),
															$elm$core$Maybe$Nothing,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'family_with_single_child_rate_rule_enabled',
																$elm$json$Json$Decode$bool,
																A4(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																	'single_parent_rate_rule',
																	$elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder),
																	$elm$core$Maybe$Nothing,
																	A4(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																		'single_parent_with_single_child_rate_rule',
																		$elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder),
																		$elm$core$Maybe$Nothing,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'single_parent_with_single_child_rate_rule_enabled',
																			$elm$json$Json$Decode$bool,
																			A4(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																				'couple_rate_rule',
																				$elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder),
																				$elm$core$Maybe$Nothing,
																				A4(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																					'individual_rate_rule',
																					$elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder),
																					$elm$core$Maybe$Nothing,
																					A4(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																						'age_rate_rules',
																						$elm$json$Json$Decode$list($author$project$Api$Provider$RateRule$Shared$decoder),
																						_List_Nil,
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'is_destroyable',
																							$elm$json$Json$Decode$bool,
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'minimum_enrollment_period_in_months',
																								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'is_mce_plan',
																									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'minimum_age',
																										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'maximum_age',
																											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																											A3(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																												'bills_at_end_of_period',
																												$elm$json$Json$Decode$bool,
																												A3(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																													'tobacco_surcharge_percentage',
																													$elm$json$Json$Decode$float,
																													A3(
																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																														'tobacco_surcharge_in_cents',
																														$elm$json$Json$Decode$int,
																														A3(
																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																															'tobacco_surcharge_type',
																															$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																															A4(
																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																'group_discount_rules',
																																$elm$json$Json$Decode$list($author$project$Api$Provider$DiscountRule$Shared$decoder),
																																_List_Nil,
																																A3(
																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																	'group_pricing_type',
																																	$elm$json$Json$Decode$string,
																																	A3(
																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																		'default_period_in_months',
																																		$elm$json$Json$Decode$int,
																																		A3(
																																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																			'allowed_billing_period_codes',
																																			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
																																			A3(
																																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																				'plan_type',
																																				$author$project$Api$PlanType$decoder,
																																				A3(
																																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																					'active_companies_count',
																																					$elm$json$Json$Decode$int,
																																					A3(
																																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																						'active_membership_patients_count',
																																						$elm$json$Json$Decode$int,
																																						A3(
																																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																							'addon',
																																							$elm$json$Json$Decode$bool,
																																							A3(
																																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																								'default',
																																								$elm$json$Json$Decode$bool,
																																								A3(
																																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																									'name',
																																									$elm$json$Json$Decode$string,
																																									A3(
																																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																										'id',
																																										$elm$json$Json$Decode$string,
																																										$elm$json$Json$Decode$succeed($author$project$Api$Provider$Plan$Shared$Record)))))))))))))))))))))))))))))))))))))))))));
var $author$project$Api$Provider$Plan$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Plan$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Plan$One$Record = function (defaultPeriod) {
	return function (maxRegistrationFeeInCents) {
		return function (individualRegistrationFeeInCents) {
			return function (defaultChargeName) {
				return function (defaultChargeDescription) {
					return function (contractExpires) {
						return function (contractPeriodInMonths) {
							return function (contractType) {
								return function (contractEmailsEnabled) {
									return function (contractRenewalEmailLeadTime) {
										return function (iua) {
											return function (monthAdjustmentPercent) {
												return function (monthAllowed) {
													return function (quarterAdjustmentPercent) {
														return function (quarterAllowed) {
															return function (semiAnnualAdjustmentPercent) {
																return function (semiAnnualAllowed) {
																	return function (annualAdjustmentPercent) {
																		return function (annualAllowed) {
																			return function (familyNumAdultsIncluded) {
																				return function (familyNumChildrenIncluded) {
																					return function (groupPricingFamilyNumChildrenIncluded) {
																						return function (numberAdditionalChildrenAllowed) {
																							return function (childrenAgeLimit) {
																								return function (splitRevenueType) {
																									return function (fixedChildrenAgeLimit) {
																										return function (appliesGroupDiscountInTiers) {
																											return function (discountsEnabled) {
																												return function (registrationFeeName) {
																													return function (registrationFeeDescription) {
																														return function (registrationFeeCategory) {
																															return function (descriptions) {
																																return function (meta) {
																																	return function (mcePricing) {
																																		return function (upcomingPricingVersion) {
																																			return function (pricingEffectivenessType) {
																																				return function (usedInScheduledPlanChanges) {
																																					return function (buyable) {
																																						return function (imageUrl) {
																																							return {xk: annualAdjustmentPercent, xl: annualAllowed, LW: appliesGroupDiscountInTiers, MZ: buyable, x2: childrenAgeLimit, OA: contractEmailsEnabled, OB: contractExpires, OC: contractPeriodInMonths, OD: contractRenewalEmailLeadTime, G3: contractType, y6: defaultChargeDescription, y7: defaultChargeName, P6: defaultPeriod, Hs: descriptions, zi: discountsEnabled, R8: familyNumAdultsIncluded, zC: familyNumChildrenIncluded, Sw: fixedChildrenAgeLimit, S0: groupPricingFamilyNumChildrenIncluded, TP: imageUrl, TZ: individualRegistrationFeeInCents, Vu: iua, WC: maxRegistrationFeeInCents, WJ: mcePricing, W4: meta, Bi: monthAdjustmentPercent, Bj: monthAllowed, BR: numberAdditionalChildrenAllowed, _j: pricingEffectivenessType, DB: quarterAdjustmentPercent, DC: quarterAllowed, $o: registrationFeeCategory, DM: registrationFeeDescription, DN: registrationFeeName, Es: semiAnnualAdjustmentPercent, Et: semiAnnualAllowed, abW: splitRevenueType, adS: upcomingPricingVersion, ad$: usedInScheduledPlanChanges};
																																						};
																																					};
																																				};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$ContractType$AutoRenew = 1;
var $author$project$Api$ContractType$Terminate = 0;
var $author$project$Api$ContractType$fromString = function (string) {
	switch (string) {
		case 'terminate':
			return $elm$core$Maybe$Just(0);
		case 'auto-renew':
			return $elm$core$Maybe$Just(1);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$ContractType$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$json$Json$Decode$fail('Unsupported contract type: ' + string),
			A2(
				$elm$core$Maybe$map,
				$elm$json$Json$Decode$succeed,
				$author$project$Api$ContractType$fromString(string)));
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$PricingEffectivenessType$Anniversary = 2;
var $author$project$Api$PricingEffectivenessType$ContractRenewal = 1;
var $author$project$Api$PricingEffectivenessType$FirstBillAfter = 0;
var $author$project$Api$PricingEffectivenessType$fromString = function (string) {
	switch (string) {
		case 'first_bill_after':
			return $elm$core$Maybe$Just(0);
		case 'contract_renewal':
			return $elm$core$Maybe$Just(1);
		case 'anniversary':
			return $elm$core$Maybe$Just(2);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$PricingEffectivenessType$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$json$Json$Decode$fail('Unsupported pricing effectiveness type: ' + string),
			A2(
				$elm$core$Maybe$map,
				$elm$json$Json$Decode$succeed,
				$author$project$Api$PricingEffectivenessType$fromString(string)));
	},
	$elm$json$Json$Decode$string);
var $elm$core$Dict$singleton = F2(
	function (key, value) {
		return A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
	});
var $author$project$Components$TranslatedRichText$decoderWithFallback = function (fieldName) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$author$project$Components$TranslatedRichText$decoder(fieldName),
				A2(
				$elm$json$Json$Decode$map,
				function (s) {
					return A2($elm$core$Dict$singleton, 'en', s);
				},
				A2($elm$json$Json$Decode$field, fieldName, $elm$json$Json$Decode$string)),
				$elm$json$Json$Decode$succeed($elm$core$Dict$empty)
			]));
};
var $author$project$Api$Provider$Plan$One$decodeDescriptions = $author$project$Components$TranslatedRichText$decoderWithFallback('description');
var $author$project$Api$Provider$McePricing$One$McePricing = $elm$core$Basics$identity;
var $author$project$Api$Provider$McePricing$One$Record = F4(
	function (coupleRates, familyRates, individualRates, singleParentWithChildrenRates) {
		return {OO: coupleRates, Sa: familyRates, TY: individualRates, abD: singleParentWithChildrenRates};
	});
var $author$project$Api$Provider$McePricing$One$AgeBand = F3(
	function (fromAge, toAge, priceInCents) {
		return {SK: fromAge, Dw: priceInCents, adb: toAge};
	});
var $elm$json$Json$Decode$map3 = _Json_map3;
var $author$project$Api$Provider$McePricing$One$ageBandDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Api$Provider$McePricing$One$AgeBand,
	A2($elm$json$Json$Decode$field, 'from_age', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'to_age', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'price_in_cents', $elm$json$Json$Decode$int));
var $elm$json$Json$Decode$map4 = _Json_map4;
var $author$project$Api$Provider$McePricing$One$recordDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Api$Provider$McePricing$One$Record,
	A2(
		$elm$json$Json$Decode$field,
		'single_parent_with_children_rates',
		$elm$json$Json$Decode$list($author$project$Api$Provider$McePricing$One$ageBandDecoder)),
	A2(
		$elm$json$Json$Decode$field,
		'family_rates',
		$elm$json$Json$Decode$list($author$project$Api$Provider$McePricing$One$ageBandDecoder)),
	A2(
		$elm$json$Json$Decode$field,
		'individual_rates',
		$elm$json$Json$Decode$list($author$project$Api$Provider$McePricing$One$ageBandDecoder)),
	A2(
		$elm$json$Json$Decode$field,
		'couple_rates',
		$elm$json$Json$Decode$list($author$project$Api$Provider$McePricing$One$ageBandDecoder)));
var $author$project$Api$Provider$McePricing$One$decoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $author$project$Api$Provider$McePricing$One$recordDecoder);
var $author$project$Api$Provider$Plan$Meta$Meta = $elm$core$Basics$identity;
var $author$project$Api$Provider$Plan$Meta$MetaRecord = F6(
	function (allPeriodCodes, allowedPeriodCodes, rules, iuaOptions, allowedPeriodsInMonths, contractTypes) {
		return {Ls: allPeriodCodes, Lz: allowedPeriodCodes, LA: allowedPeriodsInMonths, OE: contractTypes, Vv: iuaOptions, aak: rules};
	});
var $author$project$Api$Provider$Plan$Meta$RulesRecord = function (individualRegistrationFeeInCents) {
	return function (minimumEnrollmentPeriodInMonths) {
		return function (maxRegistrationFeeInCents) {
			return function (fixedChildrenAgeLimit) {
				return function (familyNumAdultsIncluded) {
					return function (familyNumChildrenIncluded) {
						return function (groupPricingFamilyNumChildrenIncluded) {
							return function (coupleDiscountRule) {
								return function (familyDiscountRule) {
									return function (singleParentDiscountRule) {
										return function (additionalChildDiscountRule) {
											return function (additionalAdultDiscountRule) {
												return function (childrenOnlyDiscountRule) {
													return function (numberAdditionalChildrenAllowed) {
														return function (childrenAgeLimit) {
															return {vB: additionalAdultDiscountRule, vC: additionalChildDiscountRule, x2: childrenAgeLimit, x3: childrenOnlyDiscountRule, yS: coupleDiscountRule, zB: familyDiscountRule, R8: familyNumAdultsIncluded, zC: familyNumChildrenIncluded, Sw: fixedChildrenAgeLimit, S0: groupPricingFamilyNumChildrenIncluded, TZ: individualRegistrationFeeInCents, WC: maxRegistrationFeeInCents, Xf: minimumEnrollmentPeriodInMonths, BR: numberAdditionalChildrenAllowed, EG: singleParentDiscountRule};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Plan$Meta$RuleRecord = function (enabled) {
	return {Ro: enabled};
};
var $author$project$Api$Provider$Plan$Meta$ruleRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'enabled',
	$elm$json$Json$Decode$bool,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Plan$Meta$RuleRecord));
var $author$project$Api$Provider$Plan$Meta$rulesRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'children_age_limit',
	$author$project$Api$Provider$Plan$Meta$ruleRecordDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'number_additional_children_allowed',
		$author$project$Api$Provider$Plan$Meta$ruleRecordDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'children_only_discount_rule',
			$author$project$Api$Provider$Plan$Meta$ruleRecordDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'additional_adult_discount_rule',
				$author$project$Api$Provider$Plan$Meta$ruleRecordDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'additional_child_discount_rule',
					$author$project$Api$Provider$Plan$Meta$ruleRecordDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'single_parent_discount_rule',
						$author$project$Api$Provider$Plan$Meta$ruleRecordDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'family_discount_rule',
							$author$project$Api$Provider$Plan$Meta$ruleRecordDecoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'couple_discount_rule',
								$author$project$Api$Provider$Plan$Meta$ruleRecordDecoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'group_pricing_family_num_children_included',
									$author$project$Api$Provider$Plan$Meta$ruleRecordDecoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'family_num_children_included',
										$author$project$Api$Provider$Plan$Meta$ruleRecordDecoder,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'family_num_adults_included',
											$author$project$Api$Provider$Plan$Meta$ruleRecordDecoder,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'fixed_children_age_limit',
												$author$project$Api$Provider$Plan$Meta$ruleRecordDecoder,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'max_registration_fee_in_cents',
													$author$project$Api$Provider$Plan$Meta$ruleRecordDecoder,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'minimum_enrollment_period_in_months',
														$author$project$Api$Provider$Plan$Meta$ruleRecordDecoder,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'individual_registration_fee_in_cents',
															$author$project$Api$Provider$Plan$Meta$ruleRecordDecoder,
															$elm$json$Json$Decode$succeed($author$project$Api$Provider$Plan$Meta$RulesRecord))))))))))))))));
var $author$project$Api$Provider$Plan$Meta$metaRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'contract_types',
	$elm$json$Json$Decode$list($author$project$Api$ContractType$decode),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'allowed_periods_in_months',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$int),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'iua_options',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'rules',
				$author$project$Api$Provider$Plan$Meta$rulesRecordDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'allowed_period_codes',
					$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'all_period_codes',
						$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$Plan$Meta$MetaRecord)))))));
var $author$project$Api$Provider$Plan$Meta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Plan$Meta$metaRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PricingVersion$Shared$PricingVersion = $elm$core$Basics$identity;
var $author$project$Api$Provider$PricingVersion$Shared$Record = function (id) {
	return function (appliesGroupDiscountInTiers) {
		return function (childrenAgeLimit) {
			return function (discountsEnabled) {
				return function (effectiveDate) {
					return function (familyNumAdultsIncluded) {
						return function (familyNumChildrenIncluded) {
							return function (familyWithSingleChildRateRuleEnabled) {
								return function (fixedChildrenAgeLimit) {
									return function (groupPricingFamilyNumChildrenIncluded) {
										return function (groupPricingType) {
											return function (individualRegistrationFeeInCents) {
												return function (maxRegistrationFeeInCents) {
													return function (name) {
														return function (numberAdditionalChildrenAllowed) {
															return function (registrationFeeName) {
																return function (singleParentWithSingleChildRateRuleEnabled) {
																	return function (splitRevenueType) {
																		return function (additionalAdultDiscountRule) {
																			return function (additionalChildDiscountRule) {
																				return function (ageRateRules) {
																					return function (individualRateRule) {
																						return function (coupleRateRule) {
																							return function (singleParentRateRule) {
																								return function (familyWithSingleChildRateRule) {
																									return function (additionalAdultRateRule) {
																										return function (additionalChildRateRule) {
																											return function (familyRateRule) {
																												return function (childrenOnlyDiscountRule) {
																													return function (coupleDiscountRule) {
																														return function (familyDiscountRule) {
																															return function (groupDiscountRules) {
																																return function (singleParentWithSingleChildRateRule) {
																																	return function (singleParentDiscountRule) {
																																		return function (specialRates) {
																																			return function (registrationFeeDescription) {
																																				return function (registrationFeeCategoryId) {
																																					return {vB: additionalAdultDiscountRule, KZ: additionalAdultRateRule, vC: additionalChildDiscountRule, K_: additionalChildRateRule, Lk: ageRateRules, LW: appliesGroupDiscountInTiers, x2: childrenAgeLimit, x3: childrenOnlyDiscountRule, yS: coupleDiscountRule, ON: coupleRateRule, zi: discountsEnabled, Q7: effectiveDate, zB: familyDiscountRule, R8: familyNumAdultsIncluded, zC: familyNumChildrenIncluded, R9: familyRateRule, Sb: familyWithSingleChildRateRule, Sc: familyWithSingleChildRateRuleEnabled, Sw: fixedChildrenAgeLimit, SZ: groupDiscountRules, S0: groupPricingFamilyNumChildrenIncluded, S1: groupPricingType, ahP: id, TX: individualRateRule, TZ: individualRegistrationFeeInCents, WC: maxRegistrationFeeInCents, Bq: name, BR: numberAdditionalChildrenAllowed, DL: registrationFeeCategoryId, DM: registrationFeeDescription, DN: registrationFeeName, EG: singleParentDiscountRule, abC: singleParentRateRule, abE: singleParentWithSingleChildRateRule, abF: singleParentWithSingleChildRateRuleEnabled, abT: specialRates, abW: splitRevenueType};
																																				};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$PricingVersion$Shared$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'registration_fee_category',
	$elm$json$Json$Decode$nullable(
		A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string)),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'registration_fee_description',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'special_rates',
			$elm$json$Json$Decode$list($author$project$Api$Provider$SpecialRate$Shared$decoder),
			_List_Nil,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'single_parent_discount_rule',
				$elm$json$Json$Decode$nullable($author$project$Api$Provider$DiscountRule$Shared$decoder),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'single_parent_with_single_child_rate_rule',
					$elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'group_discount_rules',
						$elm$json$Json$Decode$list($author$project$Api$Provider$DiscountRule$Shared$decoder),
						_List_Nil,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'family_discount_rule',
							$elm$json$Json$Decode$nullable($author$project$Api$Provider$DiscountRule$Shared$decoder),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'couple_discount_rule',
								$elm$json$Json$Decode$nullable($author$project$Api$Provider$DiscountRule$Shared$decoder),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'children_only_discount_rule',
									$elm$json$Json$Decode$nullable($author$project$Api$Provider$DiscountRule$Shared$decoder),
									$elm$core$Maybe$Nothing,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'family_rate_rule',
										$elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder),
										$elm$core$Maybe$Nothing,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'additional_child_rate_rule',
											$elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder),
											$elm$core$Maybe$Nothing,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'additional_adult_rate_rule',
												$elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder),
												$elm$core$Maybe$Nothing,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'family_with_single_child_rate_rule',
													$elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder),
													$elm$core$Maybe$Nothing,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'single_parent_rate_rule',
														$elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder),
														$elm$core$Maybe$Nothing,
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'couple_rate_rule',
															$elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder),
															$elm$core$Maybe$Nothing,
															A4(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																'individual_rate_rule',
																$elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder),
																$elm$core$Maybe$Nothing,
																A4(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																	'age_rate_rules',
																	$elm$json$Json$Decode$list($author$project$Api$Provider$RateRule$Shared$decoder),
																	_List_Nil,
																	A4(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																		'additional_child_discount_rule',
																		$elm$json$Json$Decode$nullable($author$project$Api$Provider$DiscountRule$Shared$decoder),
																		$elm$core$Maybe$Nothing,
																		A4(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																			'additional_adult_discount_rule',
																			$elm$json$Json$Decode$nullable($author$project$Api$Provider$DiscountRule$Shared$decoder),
																			$elm$core$Maybe$Nothing,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'split_revenue_type',
																				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'single_parent_with_single_child_rate_rule_enabled',
																					$elm$json$Json$Decode$bool,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'registration_fee_name',
																						$elm$json$Json$Decode$string,
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'number_additional_children_allowed',
																							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'name',
																								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'max_registration_fee_in_cents',
																									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'individual_registration_fee_in_cents',
																										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'group_pricing_type',
																											$elm$json$Json$Decode$string,
																											A3(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																												'group_pricing_family_num_children_included',
																												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																												A3(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																													'fixed_children_age_limit',
																													$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																													A3(
																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																														'family_with_single_child_rate_rule_enabled',
																														$elm$json$Json$Decode$bool,
																														A3(
																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																															'family_num_children_included',
																															$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																															A3(
																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																'family_num_adults_included',
																																$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																																A3(
																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																	'effective_date',
																																	$author$project$Utils$Date$decode,
																																	A3(
																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																		'discounts_enabled',
																																		$elm$json$Json$Decode$bool,
																																		A3(
																																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																			'children_age_limit',
																																			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																																			A3(
																																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																				'applies_group_discount_in_tiers',
																																				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
																																				A3(
																																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																					'id',
																																					$elm$json$Json$Decode$string,
																																					$elm$json$Json$Decode$succeed($author$project$Api$Provider$PricingVersion$Shared$Record))))))))))))))))))))))))))))))))))))));
var $author$project$Api$Provider$PricingVersion$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PricingVersion$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Plan$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'image_url',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'buyable',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'used_in_scheduled_plan_changes',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'pricing_effectiveness_type',
				$author$project$Api$PricingEffectivenessType$decode,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'upcoming_pricing_version',
					$elm$json$Json$Decode$nullable($author$project$Api$Provider$PricingVersion$Shared$decoder),
					A3(
						$author$project$Api$Expandable$expandable,
						'mce_pricing',
						$elm$json$Json$Decode$nullable($author$project$Api$Provider$McePricing$One$decoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'meta',
							$author$project$Api$Provider$Plan$Meta$decoder,
							A2(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
								$author$project$Api$Provider$Plan$One$decodeDescriptions,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'registration_fee_category',
									$elm$json$Json$Decode$nullable($author$project$Api$Provider$Category$Min$decoder),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'registration_fee_description',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'registration_fee_name',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'discounts_enabled',
												$elm$json$Json$Decode$bool,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'applies_group_discount_in_tiers',
													$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'fixed_children_age_limit',
														$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'split_revenue_type',
															$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'children_age_limit',
																$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'number_additional_children_allowed',
																	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'group_pricing_family_num_children_included',
																		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'family_num_children_included',
																			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'family_num_adults_included',
																				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'annual_allowed',
																					$elm$json$Json$Decode$bool,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'annual_adjustment_percent',
																						$elm$json$Json$Decode$float,
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'semi_annual_allowed',
																							$elm$json$Json$Decode$bool,
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'semi_annual_adjustment_percent',
																								$elm$json$Json$Decode$float,
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'quarter_allowed',
																									$elm$json$Json$Decode$bool,
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'quarter_adjustment_percent',
																										$elm$json$Json$Decode$float,
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'month_allowed',
																											$elm$json$Json$Decode$bool,
																											A3(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																												'month_adjustment_percent',
																												$elm$json$Json$Decode$float,
																												A3(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																													'iua',
																													$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																													A3(
																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																														'contract_renewal_email_lead_time',
																														$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																														A3(
																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																															'contract_emails_enabled',
																															$elm$json$Json$Decode$bool,
																															A3(
																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																'contract_type',
																																$elm$json$Json$Decode$nullable($author$project$Api$ContractType$decode),
																																A3(
																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																	'contract_period_in_months',
																																	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																																	A3(
																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																		'contract_expires',
																																		$elm$json$Json$Decode$bool,
																																		A3(
																																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																			'default_charge_description',
																																			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																			A3(
																																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																				'default_charge_name',
																																				$elm$json$Json$Decode$string,
																																				A3(
																																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																					'individual_registration_fee_in_cents',
																																					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																																					A3(
																																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																						'max_registration_fee_in_cents',
																																						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																																						A3(
																																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																							'default_period',
																																							$elm$json$Json$Decode$string,
																																							$elm$json$Json$Decode$succeed($author$project$Api$Provider$Plan$One$Record))))))))))))))))))))))))))))))))))))))));
var $author$project$Api$Provider$Plan$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Plan$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Plan$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Plan$One$Plan)));
var $author$project$Api$Provider$Plan$expandToString = function (expand) {
	switch (expand) {
		case 0:
			return 'pricing';
		case 1:
			return 'coverage_plan';
		case 2:
			return 'mce_pricing';
		default:
			return 'special_rates';
	}
};
var $author$project$Api$Provider$Plan$plansPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['plans']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Plan$planPath = function (planId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[planId]),
		$author$project$Api$Provider$Plan$plansPath);
};
var $author$project$Api$Provider$Plan$retrieve = F4(
	function (apiClient, planId, expand, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Plan$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2(
						$author$project$Api$Param$list,
						'expand',
						A2($elm$core$List$map, $author$project$Api$Provider$Plan$expandToString, expand))
					]),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Plan$planPath(planId))));
	});
var $author$project$Components$Plan$Form$fetchPlan = F3(
	function (apiClient, id, loadSubsequentPlan) {
		return A4(
			$author$project$Api$Provider$Plan$retrieve,
			apiClient,
			id,
			_List_fromArray(
				[1, 2]),
			$author$project$Components$Plan$Form$GotItem(loadSubsequentPlan));
	});
var $author$project$Components$Plan$Form$init = F9(
	function (apiClient, _v0, currentDate, session, practice, _v1, listRoute, id, settings) {
		var _v2 = $author$project$Components$DateInput$init;
		var planChangeChangeOnDateInput = _v2.a;
		var planChangeChangeOnDateInputCmd = _v2.b;
		return _Utils_Tuple2(
			{
				ie: $elm$core$Maybe$Nothing,
				iO: $elm$core$Maybe$Nothing,
				dd: currentDate,
				f7: $elm$core$Maybe$Nothing,
				SD: $elm$core$Maybe$Nothing,
				ahK: settings.ahK,
				ahP: id,
				Io: $author$project$Api$Data$Loading,
				Is: listRoute,
				tS: planChangeChangeOnDateInput,
				kH: false,
				eT: $elm$core$Maybe$Nothing,
				ZV: practice,
				ZX: settings.ZX,
				akd: _Utils_Tuple2(0, $author$project$Api$Data$NotAsked),
				eW: $jinjor$elm_debounce$Debounce$init,
				k9: $author$project$Api$Data$NotAsked,
				aa4: session,
				qa: false,
				qy: A2($author$project$Api$Provider$Practice$One$featureEnabled, 2, practice)
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3($author$project$Components$Plan$Form$fetchPlan, apiClient, id, true),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$PlanChangeChangeOnDateInputMsg, planChangeChangeOnDateInputCmd)
					])));
	});
var $author$project$Pages$Admin$CompanyPlans$Id_String$init = F4(
	function (session, practice, _v0, _v1) {
		var apiClient = _v0.Gv;
		var timeZone = _v0.J8;
		var currentDate = _v0.dd;
		var hinterViewOff = _v0.ahK;
		var query = _v1.DE;
		var params = _v1.YL;
		return A2(
			$elm$core$Tuple$mapFirst,
			function (planForm) {
				return {Gv: apiClient, pd: planForm};
			},
			A9(
				$author$project$Components$Plan$Form$init,
				apiClient,
				timeZone,
				currentDate,
				session,
				practice,
				query,
				$author$project$Spa$Generated$Route$Admin__CompanyPlans__Top,
				params.ahP,
				{ahK: hinterViewOff, ZX: false}));
	});
var $author$project$Pages$Admin$CompanyPlans$Id_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$CompanyPlans$Id_String$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Plan$Form$AddCoveragePlanModalMsg = function (a) {
	return {$: 20, a: a};
};
var $author$project$Components$Plan$Form$BasicPlanFormUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Plan$Form$ConfirmUpdateModalMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Plan$Form$DeleteHiConfirmClosed = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Components$Plan$Form$PlanChangeToPlanResourceFilterMsg = function (a) {
	return {$: 22, a: a};
};
var $author$project$Components$Plan$BasicForm$DescriptionMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Plan$BasicForm$RegistrationFeePricingFieldsMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$CategoryResourceFilterMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$subscriptions = function (_v0) {
	var form = _v0;
	var fields = $author$project$Utils$Form$fields(form);
	var _v1 = fields.c8;
	if (!_v1.$) {
		var categoryResourceFilter = _v1.a;
		return A2(
			$elm$core$Platform$Sub$map,
			$author$project$Components$Plan$Form$RegistrationFeePricingFields$CategoryResourceFilterMsg,
			$author$project$Components$ResourceFilter$Category$subscriptions(categoryResourceFilter));
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Components$Plan$BasicForm$subscriptions = function (_v0) {
	var form = _v0.b;
	var fields = $author$project$Utils$Form$fields(form);
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Plan$BasicForm$RegistrationFeePricingFieldsMsg,
				$author$project$Components$Plan$Form$RegistrationFeePricingFields$subscriptions(fields.dH)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Plan$BasicForm$DescriptionMsg,
				$author$project$Components$TranslatedRichText$subscriptions(fields.Qr))
			]));
};
var $author$project$Components$Plan$Form$AddCoveragePlanModal$Close = {$: 1};
var $author$project$Components$Plan$Form$AddCoveragePlanModal$CoveragePlanResourceFilterMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$ResourceFilter$CoveragePlan$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Components$ResourceFilter$CoveragePlan$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.b8));
};
var $author$project$Components$Plan$Form$AddCoveragePlanModal$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Plan$Form$AddCoveragePlanModal$Close),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Plan$Form$AddCoveragePlanModal$CoveragePlanResourceFilterMsg,
				$author$project$Components$ResourceFilter$CoveragePlan$subscriptions(model.rM))
			]));
};
var $author$project$Components$Plan$Form$ConfirmUpdateModal$Close = {$: 2};
var $author$project$Components$Plan$Form$ConfirmUpdateModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Plan$Form$ConfirmUpdateModal$Close);
};
var $author$project$Components$ResourceFilter$Plan$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Components$ResourceFilter$Plan$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.b8));
};
var $author$project$Components$Plan$Form$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					function (_v1) {
						var form = _v1.b;
						var fields = $author$project$Utils$Form$fields(form);
						return A2(
							$elm$core$Platform$Sub$map,
							$author$project$Components$Plan$Form$BasicPlanFormUpdated,
							$author$project$Components$Plan$BasicForm$subscriptions(fields.ab));
					},
					model.SD)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Plan$Form$ConfirmUpdateModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2(
						$elm$core$Maybe$map,
						function (_v2) {
							var confirmUpdateModal = _v2.b;
							return $author$project$Components$Plan$Form$ConfirmUpdateModal$subscriptions(confirmUpdateModal);
						},
						model.iO))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Plan$Form$AddCoveragePlanModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Plan$Form$AddCoveragePlanModal$subscriptions, model.ie))),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Plan$Form$DeleteHiConfirmClosed),
					A2($elm$core$Maybe$map, $elm$core$Tuple$first, model.f7))),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$ResourceFilter$Plan$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Components$Plan$Form$PlanChangeToPlanResourceFilterMsg)),
					model.eT))
			]));
};
var $author$project$Pages$Admin$CompanyPlans$Id_String$subscriptions = function (model) {
	return $author$project$Components$Plan$Form$subscriptions(model.pd);
};
var $author$project$Components$Plan$Form$BasicPlan = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$MembershipScheduledChange$Type$Contract = 2;
var $author$project$Components$Plan$Form$CoveragePlan = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$Plan$Form$CoveragePlanAll = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$MembershipScheduledChange$Type$Duration = 1;
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Plan$Form$FamilyMembershipPricingFieldsUpdated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Plan$Form$GotPreview = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Components$Plan$Form$GroupPricingType = function (a) {
	return {$: 28, a: a};
};
var $author$project$Components$Plan$Form$GroupTierPricingFields = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Plan$Form$GroupTierPricingFieldsUpdated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Plan$Form$IndividualMembershipPricingFieldsUpdated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Plan$Form$MembershipPricingFields = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Plan$Form$PlanChange = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Plan$Form$PlanChangeChangeOnDate = function (a) {
	return {$: 22, a: a};
};
var $author$project$Components$Plan$Form$PlanChangeToPlan = function (a) {
	return {$: 23, a: a};
};
var $author$project$Components$Plan$Form$PlanDeleted = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Components$Plan$Form$SpecialRatesFieldsUpdated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Plan$Form$SubsequentPlanUpdated = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Plan$Form$ToggleFixedMembershipPricing = {$: 27};
var $author$project$Api$ContractType$toString = function (contractType) {
	if (!contractType) {
		return 'terminate';
	} else {
		return 'auto-renew';
	}
};
var $author$project$Api$ContractType$encode = A2($elm$core$Basics$composeR, $author$project$Api$ContractType$toString, $elm$json$Json$Encode$string);
var $author$project$Api$PricingEffectivenessType$toString = function (pricingEffectivenessType) {
	switch (pricingEffectivenessType) {
		case 0:
			return 'first_bill_after';
		case 1:
			return 'contract_renewal';
		default:
			return 'anniversary';
	}
};
var $author$project$Api$PricingEffectivenessType$encode = A2($elm$core$Basics$composeR, $author$project$Api$PricingEffectivenessType$toString, $elm$json$Json$Encode$string);
var $author$project$Percentage$toFloat = function (_v0) {
	var string = _v0;
	return $elm$core$String$toFloat(string);
};
var $author$project$Percentage$encode = A2(
	$elm$core$Basics$composeR,
	$author$project$Percentage$toFloat,
	$author$project$Utils$Encode$nullable($elm$json$Json$Encode$float));
var $author$project$Api$Provider$Plan$encodeCoupleAgeRateRuleFields = function (fields) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'month_amount_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.Xk)),
				_Utils_Tuple2(
				'month_amount_in_cents_edited',
				$elm$json$Json$Encode$bool(fields.gX)),
				_Utils_Tuple2(
				'quarter_amount_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields._Q)),
				_Utils_Tuple2(
				'quarter_amount_in_cents_edited',
				$elm$json$Json$Encode$bool(fields.ho)),
				_Utils_Tuple2(
				'semi_annual_amount_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.aaJ)),
				_Utils_Tuple2(
				'semi_annual_amount_in_cents_edited',
				$elm$json$Json$Encode$bool(fields.hz)),
				_Utils_Tuple2(
				'annual_amount_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.LH)),
				_Utils_Tuple2(
				'annual_amount_in_cents_edited',
				$elm$json$Json$Encode$bool(fields.fE))
			]));
};
var $author$project$Api$Provider$RateRule$Shared$unitToString = function (unit_) {
	if (!unit_) {
		return 'years';
	} else {
		return 'months';
	}
};
var $author$project$Api$Provider$Plan$encodeAgeRateRuleFields = function (fields) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'from_age',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.SK)),
				_Utils_Tuple2(
				'to_age',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.adb)),
				_Utils_Tuple2(
				'unit',
				$elm$json$Json$Encode$string(
					$author$project$Api$Provider$RateRule$Shared$unitToString(fields.adL))),
				_Utils_Tuple2(
				'month_amount_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.Xk)),
				_Utils_Tuple2(
				'month_amount_in_cents_edited',
				$elm$json$Json$Encode$bool(fields.gX)),
				_Utils_Tuple2(
				'quarter_amount_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields._Q)),
				_Utils_Tuple2(
				'quarter_amount_in_cents_edited',
				$elm$json$Json$Encode$bool(fields.ho)),
				_Utils_Tuple2(
				'semi_annual_amount_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.aaJ)),
				_Utils_Tuple2(
				'semi_annual_amount_in_cents_edited',
				$elm$json$Json$Encode$bool(fields.hz)),
				_Utils_Tuple2(
				'annual_amount_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.LH)),
				_Utils_Tuple2(
				'annual_amount_in_cents_edited',
				$elm$json$Json$Encode$bool(fields.fE)),
				_Utils_Tuple2(
				'couple_age_rate_rule',
				A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeCoupleAgeRateRuleFields, fields.OM))
			]));
};
var $author$project$Api$Provider$Plan$encodeFamilyDiscountRule = function (fields) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'month_maximum_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.Xn)),
				_Utils_Tuple2(
				'month_maximum_in_cents_edited',
				$elm$json$Json$Encode$bool(fields.Xo)),
				_Utils_Tuple2(
				'quarter_maximum_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields._U)),
				_Utils_Tuple2(
				'quarter_maximum_in_cents_edited',
				$elm$json$Json$Encode$bool(fields._V)),
				_Utils_Tuple2(
				'semi_annual_maximum_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.aaN)),
				_Utils_Tuple2(
				'semi_annual_maximum_in_cents_edited',
				$elm$json$Json$Encode$bool(fields.aaO)),
				_Utils_Tuple2(
				'annual_maximum_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.LL)),
				_Utils_Tuple2(
				'annual_maximum_in_cents_edited',
				$elm$json$Json$Encode$bool(fields.LM))
			]));
};
var $author$project$Api$Provider$Plan$encodeFixedRateRule = function (fields) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'month_amount_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.Xk)),
				_Utils_Tuple2(
				'month_amount_in_cents_edited',
				$elm$json$Json$Encode$bool(fields.gX)),
				_Utils_Tuple2(
				'quarter_amount_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields._Q)),
				_Utils_Tuple2(
				'quarter_amount_in_cents_edited',
				$elm$json$Json$Encode$bool(fields.ho)),
				_Utils_Tuple2(
				'semi_annual_amount_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.aaJ)),
				_Utils_Tuple2(
				'semi_annual_amount_in_cents_edited',
				$elm$json$Json$Encode$bool(fields.hz)),
				_Utils_Tuple2(
				'annual_amount_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.LH)),
				_Utils_Tuple2(
				'annual_amount_in_cents_edited',
				$elm$json$Json$Encode$bool(fields.fE))
			]));
};
var $author$project$Api$Provider$Plan$encodeGroupDiscountRuleFields = function (fields) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'from_size',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.SM)),
				_Utils_Tuple2(
				'to_size',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.add)),
				_Utils_Tuple2(
				'calculated_by',
				$elm$json$Json$Encode$string(fields.M2)),
				_Utils_Tuple2(
				'month_amount_off_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.Xl)),
				_Utils_Tuple2(
				'month_amount_off_in_cents_edited',
				$elm$json$Json$Encode$bool(fields.Xm)),
				_Utils_Tuple2(
				'quarter_amount_off_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields._S)),
				_Utils_Tuple2(
				'quarter_amount_off_in_cents_edited',
				$elm$json$Json$Encode$bool(fields._T)),
				_Utils_Tuple2(
				'semi_annual_amount_off_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.aaL)),
				_Utils_Tuple2(
				'semi_annual_amount_off_in_cents_edited',
				$elm$json$Json$Encode$bool(fields.aaM)),
				_Utils_Tuple2(
				'annual_amount_off_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.LJ)),
				_Utils_Tuple2(
				'annual_amount_off_in_cents_edited',
				$elm$json$Json$Encode$bool(fields.LK)),
				_Utils_Tuple2(
				'month_percent_off',
				A2($author$project$Utils$Encode$nullable, $author$project$Percentage$encode, fields.Xs)),
				_Utils_Tuple2(
				'month_percent_off_edited',
				$elm$json$Json$Encode$bool(fields.Xt)),
				_Utils_Tuple2(
				'quarter_percent_off',
				A2($author$project$Utils$Encode$nullable, $author$project$Percentage$encode, fields._Y)),
				_Utils_Tuple2(
				'quarter_percent_off_edited',
				$elm$json$Json$Encode$bool(fields._Z)),
				_Utils_Tuple2(
				'semi_annual_percent_off',
				A2($author$project$Utils$Encode$nullable, $author$project$Percentage$encode, fields.aaR)),
				_Utils_Tuple2(
				'semi_annual_percent_off_edited',
				$elm$json$Json$Encode$bool(fields.aaS)),
				_Utils_Tuple2(
				'annual_percent_off',
				A2($author$project$Utils$Encode$nullable, $author$project$Percentage$encode, fields.LP)),
				_Utils_Tuple2(
				'annual_percent_off_edited',
				$elm$json$Json$Encode$bool(fields.LQ))
			]));
};
var $author$project$Api$Provider$Plan$encodeSpecialRateFields = function (fields) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ahP)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(fields.Bq)),
				_Utils_Tuple2(
				'month_amount_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.Xk)),
				_Utils_Tuple2(
				'month_amount_in_cents_edited',
				$elm$json$Json$Encode$bool(fields.gX)),
				_Utils_Tuple2(
				'quarter_amount_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields._Q)),
				_Utils_Tuple2(
				'quarter_amount_in_cents_edited',
				$elm$json$Json$Encode$bool(fields.ho)),
				_Utils_Tuple2(
				'semi_annual_amount_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.aaJ)),
				_Utils_Tuple2(
				'semi_annual_amount_in_cents_edited',
				$elm$json$Json$Encode$bool(fields.hz)),
				_Utils_Tuple2(
				'annual_amount_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.LH)),
				_Utils_Tuple2(
				'annual_amount_in_cents_edited',
				$elm$json$Json$Encode$bool(fields.fE)),
				_Utils_Tuple2(
				'_create',
				$elm$json$Json$Encode$bool(fields.O0)),
				_Utils_Tuple2(
				'_destroy',
				$elm$json$Json$Encode$bool(fields.Qv))
			]));
};
var $author$project$Api$Provider$Plan$encodeUpdateFields = function (fields) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(fields.Bq)),
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'addon',
					$elm$json$Json$Encode$bool(fields.K$)),
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						'buyable',
						$elm$json$Json$Encode$bool(fields.MZ)),
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'default_period',
							$elm$json$Json$Encode$string(fields.P6)),
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'bills_at_end_of_period',
								$elm$json$Json$Encode$bool(fields.MI)),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'discounts_enabled',
									$elm$json$Json$Encode$bool(fields.zi)),
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										'registration_fee_name',
										$elm$json$Json$Encode$string(fields.DN)),
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(
											'registration_fee_description',
											$elm$json$Json$Encode$string(fields.DM)),
										A2(
											$elm$core$List$cons,
											_Utils_Tuple2(
												'individual_registration_fee_in_cents',
												A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.TZ)),
											A2(
												$elm$core$List$cons,
												_Utils_Tuple2(
													'minimum_enrollment_period_in_months',
													A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Xf)),
												A2(
													$elm$core$List$cons,
													_Utils_Tuple2(
														'default_charge_name',
														$elm$json$Json$Encode$string(fields.y7)),
													A2(
														$elm$core$List$cons,
														_Utils_Tuple2(
															'default_charge_description',
															A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.y6)),
														A2(
															$elm$core$List$cons,
															_Utils_Tuple2(
																'registration_fee_category',
																A2(
																	$author$project$Utils$Encode$nullable,
																	function (id) {
																		return $elm$json$Json$Encode$object(
																			_List_fromArray(
																				[
																					_Utils_Tuple2(
																					'id',
																					$elm$json$Json$Encode$string(id))
																				]));
																	},
																	fields.DL)),
															A2(
																$elm$core$List$cons,
																_Utils_Tuple2(
																	'max_registration_fee_in_cents',
																	A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.WC)),
																A2(
																	$elm$core$List$cons,
																	_Utils_Tuple2(
																		'iua',
																		A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Vu)),
																	A2(
																		$elm$core$List$cons,
																		_Utils_Tuple2(
																			'month_adjustment_percent',
																			$author$project$Percentage$encode(fields.Bi)),
																		A2(
																			$elm$core$List$cons,
																			_Utils_Tuple2(
																				'month_allowed',
																				$elm$json$Json$Encode$bool(fields.Bj)),
																			A2(
																				$elm$core$List$cons,
																				_Utils_Tuple2(
																					'quarter_adjustment_percent',
																					$author$project$Percentage$encode(fields.DB)),
																				A2(
																					$elm$core$List$cons,
																					_Utils_Tuple2(
																						'quarter_allowed',
																						$elm$json$Json$Encode$bool(fields.DC)),
																					A2(
																						$elm$core$List$cons,
																						_Utils_Tuple2(
																							'semi_annual_adjustment_percent',
																							$author$project$Percentage$encode(fields.Es)),
																						A2(
																							$elm$core$List$cons,
																							_Utils_Tuple2(
																								'semi_annual_allowed',
																								$elm$json$Json$Encode$bool(fields.Et)),
																							A2(
																								$elm$core$List$cons,
																								_Utils_Tuple2(
																									'annual_adjustment_percent',
																									$author$project$Percentage$encode(fields.xk)),
																								A2(
																									$elm$core$List$cons,
																									_Utils_Tuple2(
																										'annual_allowed',
																										$elm$json$Json$Encode$bool(fields.xl)),
																									A2(
																										$elm$core$List$cons,
																										_Utils_Tuple2(
																											'tobacco_surcharge_type',
																											A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.adh)),
																										A2(
																											$elm$core$List$cons,
																											_Utils_Tuple2(
																												'tobacco_surcharge_percentage',
																												$author$project$Percentage$encode(fields.adg)),
																											A2(
																												$elm$core$List$cons,
																												_Utils_Tuple2(
																													'tobacco_surcharge_in_cents',
																													$author$project$Currency$encode(fields.adf)),
																												A2(
																													$elm$core$List$cons,
																													_Utils_Tuple2(
																														'contract_expires',
																														$elm$json$Json$Encode$bool(fields.OB)),
																													A2(
																														$elm$core$List$cons,
																														_Utils_Tuple2(
																															'contract_period_in_months',
																															A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.OC)),
																														A2(
																															$elm$core$List$cons,
																															_Utils_Tuple2(
																																'contract_type',
																																A2($author$project$Utils$Encode$nullable, $author$project$Api$ContractType$encode, fields.G3)),
																															A2(
																																$elm$core$List$cons,
																																_Utils_Tuple2(
																																	'contract_emails_enabled',
																																	$elm$json$Json$Encode$bool(fields.OA)),
																																A2(
																																	$elm$core$List$cons,
																																	_Utils_Tuple2(
																																		'contract_renewal_email_lead_time',
																																		A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.OD)),
																																	A2(
																																		$elm$core$List$cons,
																																		_Utils_Tuple2(
																																			'minimum_age',
																																			A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Xd)),
																																		A2(
																																			$elm$core$List$cons,
																																			_Utils_Tuple2(
																																				'maximum_age',
																																				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.WF)),
																																			A2(
																																				$elm$core$List$cons,
																																				_Utils_Tuple2(
																																					'coverage_plan',
																																					A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.OT)),
																																				A2(
																																					$elm$core$List$cons,
																																					_Utils_Tuple2(
																																						'sponsor_fee_deal',
																																						$elm$json$Json$Encode$object(
																																							_List_fromArray(
																																								[
																																									_Utils_Tuple2(
																																									'amount_in_cents',
																																									A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.JS))
																																								]))),
																																					A2(
																																						$elm$core$List$cons,
																																						_Utils_Tuple2(
																																							'age_rate_rules',
																																							A2($elm$json$Json$Encode$list, $author$project$Api$Provider$Plan$encodeAgeRateRuleFields, fields.Lk)),
																																						A2(
																																							$elm$core$List$cons,
																																							_Utils_Tuple2(
																																								'group_pricing_type',
																																								$elm$json$Json$Encode$string(fields.S1)),
																																							A2(
																																								$elm$core$List$cons,
																																								_Utils_Tuple2(
																																									'fixed_children_age_limit',
																																									A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Sw)),
																																								A2(
																																									$elm$core$List$cons,
																																									_Utils_Tuple2(
																																										'family_num_adults_included',
																																										A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.R8)),
																																									A2(
																																										$elm$core$List$cons,
																																										_Utils_Tuple2(
																																											'family_num_children_included',
																																											A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.zC)),
																																										A2(
																																											$elm$core$List$cons,
																																											_Utils_Tuple2(
																																												'group_pricing_family_num_children_included',
																																												A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.S0)),
																																											A2(
																																												$elm$core$List$cons,
																																												_Utils_Tuple2(
																																													'number_additional_children_allowed',
																																													A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.BR)),
																																												A2(
																																													$elm$core$List$cons,
																																													_Utils_Tuple2(
																																														'children_age_limit',
																																														A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.x2)),
																																													A2(
																																														$elm$core$List$cons,
																																														_Utils_Tuple2(
																																															'split_revenue_type',
																																															$elm$json$Json$Encode$string(fields.abW)),
																																														A2(
																																															$elm$core$List$cons,
																																															_Utils_Tuple2(
																																																'applies_group_discount_in_tiers',
																																																$elm$json$Json$Encode$bool(fields.LW)),
																																															A2(
																																																$elm$core$List$cons,
																																																_Utils_Tuple2(
																																																	'single_parent_with_single_child_rate_rule_enabled',
																																																	$elm$json$Json$Encode$bool(fields.abF)),
																																																A2(
																																																	$elm$core$List$cons,
																																																	_Utils_Tuple2(
																																																		'family_with_single_child_rate_rule_enabled',
																																																		$elm$json$Json$Encode$bool(fields.Sc)),
																																																	A2(
																																																		$elm$core$List$cons,
																																																		_Utils_Tuple2(
																																																			'couple_rate_rule',
																																																			A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, fields.ON)),
																																																		A2(
																																																			$elm$core$List$cons,
																																																			_Utils_Tuple2(
																																																				'family_rate_rule',
																																																				A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, fields.R9)),
																																																			A2(
																																																				$elm$core$List$cons,
																																																				_Utils_Tuple2(
																																																					'individual_rate_rule',
																																																					A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, fields.TX)),
																																																				A2(
																																																					$elm$core$List$cons,
																																																					_Utils_Tuple2(
																																																						'single_parent_rate_rule',
																																																						A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, fields.abC)),
																																																					A2(
																																																						$elm$core$List$cons,
																																																						_Utils_Tuple2(
																																																							'single_parent_with_single_child_rate_rule',
																																																							A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, fields.abE)),
																																																						A2(
																																																							$elm$core$List$cons,
																																																							_Utils_Tuple2(
																																																								'family_with_single_child_rate_rule',
																																																								A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, fields.Sb)),
																																																							A2(
																																																								$elm$core$List$cons,
																																																								_Utils_Tuple2(
																																																									'additional_adult_rate_rule',
																																																									A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, fields.KZ)),
																																																								A2(
																																																									$elm$core$List$cons,
																																																									_Utils_Tuple2(
																																																										'additional_child_rate_rule',
																																																										A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, fields.K_)),
																																																									A2(
																																																										$elm$core$List$cons,
																																																										_Utils_Tuple2(
																																																											'couple_discount_rule',
																																																											A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, fields.yS)),
																																																										A2(
																																																											$elm$core$List$cons,
																																																											_Utils_Tuple2(
																																																												'family_discount_rule',
																																																												A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, fields.zB)),
																																																											A2(
																																																												$elm$core$List$cons,
																																																												_Utils_Tuple2(
																																																													'single_parent_discount_rule',
																																																													A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, fields.EG)),
																																																												A2(
																																																													$elm$core$List$cons,
																																																													_Utils_Tuple2(
																																																														'additional_adult_discount_rule',
																																																														A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, fields.vB)),
																																																													A2(
																																																														$elm$core$List$cons,
																																																														_Utils_Tuple2(
																																																															'additional_child_discount_rule',
																																																															A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, fields.vC)),
																																																														A2(
																																																															$elm$core$List$cons,
																																																															_Utils_Tuple2(
																																																																'children_only_discount_rule',
																																																																A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, fields.x3)),
																																																															A2(
																																																																$elm$core$List$cons,
																																																																_Utils_Tuple2(
																																																																	'group_discount_rules',
																																																																	A2($elm$json$Json$Encode$list, $author$project$Api$Provider$Plan$encodeGroupDiscountRuleFields, fields.SZ)),
																																																																A2(
																																																																	$elm$core$List$cons,
																																																																	_Utils_Tuple2(
																																																																		'special_rates',
																																																																		A2($elm$json$Json$Encode$list, $author$project$Api$Provider$Plan$encodeSpecialRateFields, fields.abT)),
																																																																	A2(
																																																																		$elm$core$List$cons,
																																																																		_Utils_Tuple2(
																																																																			'description',
																																																																			$elm$json$Json$Encode$object(
																																																																				_List_fromArray(
																																																																					[
																																																																						_Utils_Tuple2(
																																																																						'en',
																																																																						A2(
																																																																							$author$project$Utils$Encode$nullable,
																																																																							$elm$json$Json$Encode$string,
																																																																							A2($elm$core$Dict$get, 'en', fields.Hs))),
																																																																						_Utils_Tuple2(
																																																																						'es',
																																																																						A2(
																																																																							$author$project$Utils$Encode$nullable,
																																																																							$elm$json$Json$Encode$string,
																																																																							A2($elm$core$Dict$get, 'es', fields.Hs)))
																																																																					]))),
																																																																		A2(
																																																																			$elm$core$List$cons,
																																																																			_Utils_Tuple2(
																																																																				'pricing_effectiveness_type',
																																																																				$author$project$Api$PricingEffectivenessType$encode(fields._j)),
																																																																			function () {
																																																																				var _v0 = fields.TP;
																																																																				if (!_v0.$) {
																																																																					var url = _v0.a;
																																																																					return _List_fromArray(
																																																																						[
																																																																							_Utils_Tuple2(
																																																																							'image',
																																																																							$elm$json$Json$Encode$string(url))
																																																																						]);
																																																																				} else {
																																																																					return _List_Nil;
																																																																				}
																																																																			}()))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
};
var $author$project$Api$Data$requestWithTracker = F2(
	function (tracker, _v0) {
		var request = _v0;
		return _Utils_update(
			request,
			{
				vd: $elm$core$Maybe$Just(tracker)
			});
	});
var $author$project$Api$Provider$Plan$calculate = F6(
	function (apiClient, expand, tracker, id, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'plan',
					$author$project$Api$Provider$Plan$encodeUpdateFields(fields))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Plan$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				A2(
					$author$project$Api$Data$requestWithTracker,
					tracker,
					A2(
						$author$project$Api$Data$requestWithQuery,
						_List_fromArray(
							[
								A2(
								$author$project$Api$Param$list,
								'expand',
								A2($elm$core$List$map, $author$project$Api$Provider$Plan$expandToString, expand))
							]),
						$author$project$Api$Data$requestTo(
							A2(
								$author$project$Api$Data$pathAppend,
								_List_fromArray(
									['calculate']),
								$author$project$Api$Provider$Plan$planPath(id)))))));
	});
var $author$project$Components$Plan$Form$BasicPlanFieldValidation = {$: 10};
var $author$project$Components$Plan$BasicForm$hasErrors = function (_v0) {
	var form = _v0.b;
	return $author$project$Utils$Form$hasAnyValidationError(form);
};
var $author$project$Components$Plan$Form$validateBasicPlanFormFields = function (_v0) {
	var basicPlan = _v0.ab;
	return $author$project$Components$Plan$BasicForm$hasErrors(basicPlan) ? _List_fromArray(
		[
			_Utils_Tuple2($author$project$Components$Plan$Form$BasicPlanFieldValidation, '')
		]) : _List_Nil;
};
var $author$project$Components$Plan$Form$ContractPeriodInMonthsValidation = {$: 2};
var $author$project$Components$Plan$Form$ContractRenewalEmailLeadTimeValidation = {$: 4};
var $author$project$Components$Plan$Form$ContractTypeValidation = {$: 3};
var $author$project$Api$Provider$Plan$Meta$allowedPeriodsInMonths = function (_v0) {
	var meta = _v0;
	return meta.LA;
};
var $author$project$Api$Provider$Plan$One$meta = function (_v0) {
	var record = _v0.b;
	return record.W4;
};
var $author$project$Components$Plan$Form$isContractPeriodInMonthsInvalid = F2(
	function (plan, contractPeriodInMonths) {
		var maxPeriod = $elm$core$List$maximum(
			$author$project$Api$Provider$Plan$Meta$allowedPeriodsInMonths(
				$author$project$Api$Provider$Plan$One$meta(plan)));
		var _v0 = _Utils_Tuple2(contractPeriodInMonths, maxPeriod);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var contractPeriodInMonths_ = _v0.a.a;
			var maxPeriod_ = _v0.b.a;
			return !(!(contractPeriodInMonths_ % maxPeriod_));
		} else {
			return false;
		}
	});
var $author$project$Api$Provider$Plan$Shared$isMcePlan = function (_v0) {
	var record = _v0;
	return A2($elm$core$Maybe$withDefault, false, record.UW);
};
var $author$project$Api$Provider$Plan$One$isMcePlan = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$isMcePlan(shared);
};
var $author$project$Utils$Validate$isOutsideIntRange = F2(
	function (options, _int) {
		var _v0 = _Utils_Tuple3(_int, options.W9, options.AU);
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				if (!_v0.c.$) {
					var int_ = _v0.a.a;
					var min = _v0.b.a;
					var max = _v0.c.a;
					return (_Utils_cmp(int_, min) < 0) || (_Utils_cmp(int_, max) > 0);
				} else {
					var int_ = _v0.a.a;
					var min = _v0.b.a;
					var _v1 = _v0.c;
					return _Utils_cmp(int_, min) < 0;
				}
			} else {
				if (!_v0.c.$) {
					var int_ = _v0.a.a;
					var _v2 = _v0.b;
					var max = _v0.c.a;
					return _Utils_cmp(int_, max) > 0;
				} else {
					var _v3 = _v0.b;
					var _v4 = _v0.c;
					return false;
				}
			}
		} else {
			var _v5 = _v0.a;
			return !options.aeU;
		}
	});
var $author$project$Api$Provider$Plan$Shared$planType = function (_v0) {
	var record = _v0;
	return record.ZF;
};
var $author$project$Api$Provider$Plan$One$planType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$planType(shared);
};
var $author$project$Components$Plan$Form$validateContract = F2(
	function (plan, fields) {
		var planType = $author$project$Api$Provider$Plan$One$planType(plan);
		var isMcePlan = $author$project$Api$Provider$Plan$One$isMcePlan(plan);
		var forCompany = !$author$project$Api$Provider$Plan$One$planType(plan);
		return ((planType !== 1) && ((!isMcePlan) && (!forCompany))) ? $elm$core$List$concat(
			_List_fromArray(
				[
					(fields.OB && A2(
					$author$project$Utils$Validate$isOutsideIntRange,
					{
						aeU: false,
						AU: $elm$core$Maybe$Just(48),
						W9: $elm$core$Maybe$Just(1)
					},
					fields.OC)) ? _List_fromArray(
					[
						_Utils_Tuple2($author$project$Components$Plan$Form$ContractPeriodInMonthsValidation, 'Please enter a number between 1 and 48.')
					]) : ((fields.OB && A2($author$project$Components$Plan$Form$isContractPeriodInMonthsInvalid, plan, fields.OC)) ? _List_fromArray(
					[
						_Utils_Tuple2($author$project$Components$Plan$Form$ContractPeriodInMonthsValidation, '')
					]) : _List_Nil),
					(fields.OB && _Utils_eq(fields.G3, $elm$core$Maybe$Nothing)) ? _List_fromArray(
					[
						_Utils_Tuple2($author$project$Components$Plan$Form$ContractTypeValidation, 'Please pick an action.')
					]) : _List_Nil,
					(fields.OB && (fields.OA && A2(
					$author$project$Utils$Validate$isOutsideIntRange,
					{
						aeU: false,
						AU: $elm$core$Maybe$Just(365),
						W9: $elm$core$Maybe$Just(1)
					},
					fields.OD))) ? _List_fromArray(
					[
						_Utils_Tuple2($author$project$Components$Plan$Form$ContractRenewalEmailLeadTimeValidation, 'Please enter a number between 1 and 365.')
					]) : _List_Nil
				])) : _List_Nil;
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFieldsValidation = {$: 11};
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$hasErrors = function (_v0) {
	var form = _v0;
	return $author$project$Utils$Form$hasAnyValidationError(form);
};
var $author$project$Components$Plan$Form$validateFamilyMembershipPricingFields = function (_v0) {
	var familyMembershipPricingForm = _v0.dm;
	return $author$project$Components$Plan$Form$FamilyMembershipPricingFields$hasErrors(familyMembershipPricingForm) ? _List_fromArray(
		[
			_Utils_Tuple2($author$project$Components$Plan$Form$FamilyMembershipPricingFieldsValidation, '')
		]) : _List_Nil;
};
var $author$project$Components$Plan$Form$GroupDiscountRuleAmountOffInCentsValidation = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Components$Plan$Form$GroupDiscountRulePercentOffValidation = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Components$Plan$Form$validatePricingRuleAmountInCents = F3(
	function (defaultPeriod, pricingRule, validationGroup) {
		var min = 0;
		var max = 999999999;
		return $elm$core$List$concat(
			_List_fromArray(
				[
					(((defaultPeriod === 'month') || pricingRule.gX) && A2(
					$author$project$Utils$Validate$isInvalidCurrency,
					{
						aeU: false,
						AU: $elm$core$Maybe$Just(max),
						W9: $elm$core$Maybe$Just(min)
					},
					pricingRule.Xk)) ? _List_fromArray(
					[
						_Utils_Tuple2(
						validationGroup('month'),
						'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
					]) : _List_Nil,
					(((defaultPeriod === 'quarter') || pricingRule.ho) && A2(
					$author$project$Utils$Validate$isInvalidCurrency,
					{
						aeU: false,
						AU: $elm$core$Maybe$Just(max),
						W9: $elm$core$Maybe$Just(min)
					},
					pricingRule._Q)) ? _List_fromArray(
					[
						_Utils_Tuple2(
						validationGroup('quarter'),
						'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
					]) : _List_Nil,
					(((defaultPeriod === 'semi_annual') || pricingRule.hz) && A2(
					$author$project$Utils$Validate$isInvalidCurrency,
					{
						aeU: false,
						AU: $elm$core$Maybe$Just(max),
						W9: $elm$core$Maybe$Just(min)
					},
					pricingRule.aaJ)) ? _List_fromArray(
					[
						_Utils_Tuple2(
						validationGroup('semi_annual'),
						'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
					]) : _List_Nil,
					(((defaultPeriod === 'annual') || pricingRule.fE) && A2(
					$author$project$Utils$Validate$isInvalidCurrency,
					{
						aeU: false,
						AU: $elm$core$Maybe$Just(max),
						W9: $elm$core$Maybe$Just(min)
					},
					pricingRule.LH)) ? _List_fromArray(
					[
						_Utils_Tuple2(
						validationGroup('annual'),
						'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
					]) : _List_Nil
				]));
	});
var $author$project$Percentage$isValid = F2(
	function (options, percentage) {
		var _v0 = $author$project$Percentage$toFloat(percentage);
		if (!_v0.$) {
			var _float = _v0.a;
			var _v1 = _Utils_Tuple2(options.W9, options.AU);
			if (!_v1.a.$) {
				if (!_v1.b.$) {
					var min = _v1.a.a;
					var max = _v1.b.a;
					return !((_Utils_cmp(_float, min) < 0) || (_Utils_cmp(_float, max) > 0));
				} else {
					var min = _v1.a.a;
					var _v2 = _v1.b;
					return _Utils_cmp(_float, min) > -1;
				}
			} else {
				if (!_v1.b.$) {
					var _v3 = _v1.a;
					var max = _v1.b.a;
					return _Utils_cmp(_float, max) < 1;
				} else {
					var _v4 = _v1.a;
					var _v5 = _v1.b;
					return true;
				}
			}
		} else {
			return false;
		}
	});
var $author$project$Utils$Validate$isInvalidPercentage = F2(
	function (options, percentage) {
		if (!percentage.$) {
			var percentage_ = percentage.a;
			return !A2(
				$author$project$Percentage$isValid,
				{AU: options.AU, W9: options.W9},
				percentage_);
		} else {
			return !options.aeU;
		}
	});
var $author$project$Components$Plan$Form$validatePricingRulePercentage = F3(
	function (defaultPeriod, pricingRule, validationGroup) {
		var min = 0;
		var max = 100;
		return $elm$core$List$concat(
			_List_fromArray(
				[
					(((defaultPeriod === 'month') || pricingRule.Xr) && A2(
					$author$project$Utils$Validate$isInvalidPercentage,
					{
						aeU: false,
						AU: $elm$core$Maybe$Just(max),
						W9: $elm$core$Maybe$Just(min)
					},
					pricingRule.Xq)) ? _List_fromArray(
					[
						_Utils_Tuple2(
						validationGroup('month'),
						'Please enter a percentage between ' + ($author$project$Formatters$Float$toPercentage(min) + (' and ' + ($author$project$Formatters$Float$toPercentage(max) + '.'))))
					]) : _List_Nil,
					(((defaultPeriod === 'quarter') || pricingRule._X) && A2(
					$author$project$Utils$Validate$isInvalidPercentage,
					{
						aeU: false,
						AU: $elm$core$Maybe$Just(max),
						W9: $elm$core$Maybe$Just(min)
					},
					pricingRule._W)) ? _List_fromArray(
					[
						_Utils_Tuple2(
						validationGroup('quarter'),
						'Please enter an a percentage between ' + ($author$project$Formatters$Float$toPercentage(min) + (' and ' + ($author$project$Formatters$Float$toPercentage(max) + '.'))))
					]) : _List_Nil,
					(((defaultPeriod === 'semi_annual') || pricingRule.aaQ) && A2(
					$author$project$Utils$Validate$isInvalidPercentage,
					{
						aeU: false,
						AU: $elm$core$Maybe$Just(max),
						W9: $elm$core$Maybe$Just(min)
					},
					pricingRule.aaP)) ? _List_fromArray(
					[
						_Utils_Tuple2(
						validationGroup('semi_annual'),
						'Please enter an a percentage between ' + ($author$project$Formatters$Float$toPercentage(min) + (' and ' + ($author$project$Formatters$Float$toPercentage(max) + '.'))))
					]) : _List_Nil,
					(((defaultPeriod === 'annual') || pricingRule.LO) && A2(
					$author$project$Utils$Validate$isInvalidPercentage,
					{
						aeU: false,
						AU: $elm$core$Maybe$Just(max),
						W9: $elm$core$Maybe$Just(min)
					},
					pricingRule.LN)) ? _List_fromArray(
					[
						_Utils_Tuple2(
						validationGroup('annual'),
						'Please enter an a percentage between ' + ($author$project$Formatters$Float$toPercentage(min) + (' and ' + ($author$project$Formatters$Float$toPercentage(max) + '.'))))
					]) : _List_Nil
				]));
	});
var $author$project$Components$Plan$Form$validateGroupDiscountRule = F3(
	function (defaultPeriod, index, fields) {
		var _v0 = fields.M2;
		switch (_v0) {
			case 'amount_off_in_cents':
				return A3(
					$author$project$Components$Plan$Form$validatePricingRuleAmountInCents,
					defaultPeriod,
					{LH: fields.LJ, fE: fields.LK, Xk: fields.Xl, gX: fields.Xm, _Q: fields._S, ho: fields._T, aaJ: fields.aaL, hz: fields.aaM},
					$author$project$Components$Plan$Form$GroupDiscountRuleAmountOffInCentsValidation(index));
			case 'percent_off':
				return A3(
					$author$project$Components$Plan$Form$validatePricingRulePercentage,
					defaultPeriod,
					{LN: fields.LP, LO: fields.LQ, Xq: fields.Xs, Xr: fields.Xt, _W: fields._Y, _X: fields._Z, aaP: fields.aaR, aaQ: fields.aaS},
					$author$project$Components$Plan$Form$GroupDiscountRulePercentOffValidation(index));
			default:
				return _List_Nil;
		}
	});
var $author$project$Components$Plan$Form$validateGroupMembershipPricingFields = F3(
	function (sharedFields, plan, fields) {
		var planType = $author$project$Api$Provider$Plan$One$planType(plan);
		var isMcePlan = $author$project$Api$Provider$Plan$One$isMcePlan(plan);
		return ((planType !== 1) && ((!isMcePlan) && (fields.S1 === 'group'))) ? $elm$core$List$concat(
			A2(
				$elm$core$List$indexedMap,
				$author$project$Components$Plan$Form$validateGroupDiscountRule(sharedFields.P6),
				fields.SZ)) : _List_Nil;
	});
var $author$project$Components$Plan$Form$GroupTierPricingFieldsValidation = {$: 13};
var $author$project$Components$Plan$Form$GroupTierPricingFields$hasErrors = function (_v0) {
	var form = _v0;
	return $author$project$Utils$Form$hasAnyValidationError(form);
};
var $author$project$Components$Plan$Form$validateGroupTierPricingFields = function (_v0) {
	var groupTierPricingForm = _v0.k;
	return $author$project$Components$Plan$Form$GroupTierPricingFields$hasErrors(groupTierPricingForm) ? _List_fromArray(
		[
			_Utils_Tuple2($author$project$Components$Plan$Form$GroupTierPricingFieldsValidation, '')
		]) : _List_Nil;
};
var $author$project$Components$Plan$Form$IndividualMembershipPricingFieldsValidation = {$: 12};
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$hasErrors = function (_v0) {
	var form = _v0;
	return $author$project$Utils$Form$hasAnyValidationError(form);
};
var $author$project$Components$Plan$Form$validateIndividualMembershipPricingFields = function (_v0) {
	var membershipPricingForm = _v0.dq;
	return $author$project$Components$Plan$Form$IndividualMembershipPricingFields$hasErrors(membershipPricingForm) ? _List_fromArray(
		[
			_Utils_Tuple2($author$project$Components$Plan$Form$IndividualMembershipPricingFieldsValidation, '')
		]) : _List_Nil;
};
var $author$project$Api$Provider$MembershipScheduledChange$Type$Date = 0;
var $author$project$Components$Plan$Form$PlanChangeChangeAfterMonthsValidation = {$: 5};
var $author$project$Components$Plan$Form$PlanChangeChangeOnDateValidation = {$: 6};
var $author$project$Components$Plan$Form$PlanChangeToPlanValidation = {$: 7};
var $author$project$Utils$Validate$isOutsideDateRange = F2(
	function (options, date) {
		var _v0 = _Utils_Tuple3(date, options.W9, options.AU);
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				if (!_v0.c.$) {
					var date_ = _v0.a.a;
					var min = _v0.b.a;
					var max = _v0.c.a;
					return A2($author$project$Utils$Date$isBefore, date_, min) || A2($author$project$Utils$Date$isAfter, date_, max);
				} else {
					var date_ = _v0.a.a;
					var min = _v0.b.a;
					var _v1 = _v0.c;
					return A2($author$project$Utils$Date$isBefore, date_, min);
				}
			} else {
				if (!_v0.c.$) {
					var date_ = _v0.a.a;
					var _v2 = _v0.b;
					var max = _v0.c.a;
					return A2($author$project$Utils$Date$isAfter, date_, max);
				} else {
					var _v3 = _v0.b;
					var _v4 = _v0.c;
					return false;
				}
			}
		} else {
			var _v5 = _v0.a;
			return !options.aeU;
		}
	});
var $author$project$Components$Plan$Form$validatePlanChange = F3(
	function (currentDate, planChangeEnabled, _v0) {
		var planChange = _v0.kG;
		if (planChangeEnabled) {
			var yesterdayDate = A3($justinmimbs$date$Date$add, 3, -1, currentDate);
			var params = planChange.YL;
			return $elm$core$List$concat(
				_List_fromArray(
					[
						(planChange.cs && _Utils_eq(params.adc, $elm$core$Maybe$Nothing)) ? _List_fromArray(
						[
							_Utils_Tuple2($author$project$Components$Plan$Form$PlanChangeToPlanValidation, 'Please pick a plan.')
						]) : _List_Nil,
						(planChange.cs && ((!params.amg) && A2(
						$author$project$Utils$Validate$isOutsideDateRange,
						{
							aeU: false,
							AU: $elm$core$Maybe$Nothing,
							W9: $elm$core$Maybe$Just(yesterdayDate)
						},
						params.Nu))) ? _List_fromArray(
						[
							_Utils_Tuple2($author$project$Components$Plan$Form$PlanChangeChangeOnDateValidation, 'Please enter a date greater or equal than yesterday')
						]) : _List_Nil,
						(planChange.cs && ((params.amg === 1) && A2(
						$author$project$Utils$Validate$isOutsideIntRange,
						{
							aeU: false,
							AU: $elm$core$Maybe$Just(48),
							W9: $elm$core$Maybe$Just(1)
						},
						params.Nt))) ? _List_fromArray(
						[
							_Utils_Tuple2($author$project$Components$Plan$Form$PlanChangeChangeAfterMonthsValidation, 'Please enter a number between 1 and 48.')
						]) : _List_Nil
					]));
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Plan$Form$SpecialRatesFieldsValidation = {$: 14};
var $author$project$Components$Plan$Form$SpecialRatesFields$hasErrors = function (_v0) {
	var form = _v0;
	return $author$project$Utils$Form$hasAnyValidationError(form);
};
var $author$project$Components$Plan$Form$validateSpecialRatesFields = function (_v0) {
	var specialRatesForm = _v0.dL;
	return $author$project$Components$Plan$Form$SpecialRatesFields$hasErrors(specialRatesForm) ? _List_fromArray(
		[
			_Utils_Tuple2($author$project$Components$Plan$Form$SpecialRatesFieldsValidation, '')
		]) : _List_Nil;
};
var $author$project$Components$Plan$Form$TobaccoSurchargeInCentsValidation = {$: 0};
var $author$project$Components$Plan$Form$TobaccoSurchargePercentageValidation = {$: 1};
var $author$project$Components$Plan$Form$validateTobaccoSurcharge = F3(
	function (tobaccoSurchargeEnabled, plan, fields) {
		var planType = $author$project$Api$Provider$Plan$One$planType(plan);
		if ((planType !== 1) && (tobaccoSurchargeEnabled && (!_Utils_eq(fields.adh, $elm$core$Maybe$Nothing)))) {
			var percentageTobaccoSurchargeType = _Utils_eq(
				fields.adh,
				$elm$core$Maybe$Just('percentage_per_member')) || _Utils_eq(
				fields.adh,
				$elm$core$Maybe$Just('percentage_per_membership'));
			if (percentageTobaccoSurchargeType && A2(
				$author$project$Utils$Validate$isInvalidPercentage,
				{
					aeU: false,
					AU: $elm$core$Maybe$Nothing,
					W9: $elm$core$Maybe$Just(0)
				},
				fields.adg)) {
				return _List_fromArray(
					[
						_Utils_Tuple2($author$project$Components$Plan$Form$TobaccoSurchargePercentageValidation, 'Please enter a number between 0 and 100.')
					]);
			} else {
				var minAmountInCents = 0;
				var maxAmountInCents = 999999999;
				return ((!percentageTobaccoSurchargeType) && A2(
					$author$project$Utils$Validate$isInvalidCurrency,
					{
						aeU: false,
						AU: $elm$core$Maybe$Just(maxAmountInCents),
						W9: $elm$core$Maybe$Just(minAmountInCents)
					},
					fields.adf)) ? _List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$Components$Plan$Form$TobaccoSurchargeInCentsValidation,
						'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(minAmountInCents) + (' and ' + ($author$project$Utils$Currency$fromInt(maxAmountInCents) + '.'))))
					]) : _List_Nil;
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Plan$Form$formFieldsValidator = F5(
	function (sharedField, currentDate, tobaccoSurchargeEnabled, planChangeEnabled, plan) {
		return $rtfeldman$elm_validate$Validate$all(
			_List_fromArray(
				[
					$rtfeldman$elm_validate$Validate$fromErrors(
					$author$project$Components$Plan$Form$validateContract(plan)),
					$rtfeldman$elm_validate$Validate$fromErrors(
					A2($author$project$Components$Plan$Form$validatePlanChange, currentDate, planChangeEnabled)),
					$rtfeldman$elm_validate$Validate$fromErrors(
					A2($author$project$Components$Plan$Form$validateTobaccoSurcharge, tobaccoSurchargeEnabled, plan)),
					$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Plan$Form$validateIndividualMembershipPricingFields),
					$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Plan$Form$validateGroupTierPricingFields),
					$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Plan$Form$validateSpecialRatesFields),
					$rtfeldman$elm_validate$Validate$fromErrors(
					A2($author$project$Components$Plan$Form$validateGroupMembershipPricingFields, sharedField, plan)),
					$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Plan$Form$validateBasicPlanFormFields),
					$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Plan$Form$validateFamilyMembershipPricingFields)
				]));
	});
var $author$project$Components$Plan$BasicForm$formFields = function (_v0) {
	var form = _v0.b;
	return $author$project$Utils$Form$fields(form);
};
var $author$project$Components$Plan$Form$initSharedFields = F2(
	function (plan, form) {
		var _v0 = $author$project$Utils$Form$fields(form);
		var groupPricingType = _v0.S1;
		var basicPlan = _v0.ab;
		var _v1 = $author$project$Components$Plan$BasicForm$formFields(basicPlan);
		var defaultPeriod = _v1.P6;
		return {
			P6: defaultPeriod,
			S1: groupPricingType,
			Jb: $elm$core$Maybe$Just(plan)
		};
	});
var $author$project$Components$Plan$Form$PreviewDebouncedMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Plan$Form$previewDebounceConfig = {
	alK: $jinjor$elm_debounce$Debounce$later(1000),
	ame: $author$project$Components$Plan$Form$PreviewDebouncedMsg
};
var $author$project$Components$Plan$BasicForm$BasicPlanForm = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$RegistrationFeePricingForm = $elm$core$Basics$identity;
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$IndividualRegistrationFeeInCentsValidation = 0;
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$MaxRegistrationFeeInCentsValidation = 1;
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$validateRegistrationFeePricing = function (fields) {
	return $elm$core$List$concat(
		_List_fromArray(
			[
				(fields.aak.TZ.Ro && A2(
				$author$project$Utils$Validate$isInvalidCurrency,
				{
					aeU: false,
					AU: $elm$core$Maybe$Nothing,
					W9: $elm$core$Maybe$Just(1)
				},
				fields.TZ)) ? _List_fromArray(
				[
					_Utils_Tuple2(0, 'Please enter a number greater than 0.')
				]) : _List_Nil,
				(fields.aak.WC.Ro && A2(
				$author$project$Utils$Validate$isInvalidCurrency,
				{
					aeU: false,
					AU: $elm$core$Maybe$Nothing,
					W9: $elm$core$Maybe$Just(1)
				},
				fields.WC)) ? _List_fromArray(
				[
					_Utils_Tuple2(1, 'Please enter a number greater than 0.')
				]) : _List_Nil
			]));
};
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$validator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Plan$Form$RegistrationFeePricingFields$validateRegistrationFeePricing)
		]));
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$validate = function (_v0) {
	var form = _v0;
	var fields = $author$project$Utils$Form$fields(form);
	return A2(
		$elm$core$Result$mapError,
		$elm$core$Basics$identity,
		A2(
			$elm$core$Result$map,
			$elm$core$Tuple$mapFirst($elm$core$Basics$identity),
			A2(
				$author$project$Utils$Form$validate,
				$author$project$Components$Plan$Form$RegistrationFeePricingFields$validator,
				A2($author$project$Utils$Form$set, fields, form))));
};
var $author$project$Components$Plan$BasicForm$NameValidation = 0;
var $author$project$Components$Plan$BasicForm$RegistrationFeeNameValidation = 8;
var $author$project$Components$Plan$BasicForm$ImageValidation = 10;
var $author$project$Components$Plan$BasicForm$maxImageBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
var $author$project$Components$Plan$BasicForm$imageValidator = A3(
	$author$project$Utils$Validate$ifIntGreaterThan,
	function ($) {
		return $.nW;
	},
	$author$project$Components$Plan$BasicForm$maxImageBytesSize,
	_Utils_Tuple2(10, 'That image is too large! Our maximum image size is 5 MB.'));
var $author$project$Components$Plan$BasicForm$DefaultChargeNameValidation = 6;
var $author$project$Components$Plan$BasicForm$MinimumEnrollmentPeriodInMonthsValidation = 5;
var $author$project$Components$Plan$BasicForm$AnnualAdjustmentPercentValidation = 4;
var $author$project$Components$Plan$BasicForm$MonthAdjustmentPercentValidation = 1;
var $author$project$Components$Plan$BasicForm$QuarterAdjustmentPercentValidation = 2;
var $author$project$Components$Plan$BasicForm$SemiAnnualAdjustmentPercentValidation = 3;
var $author$project$Components$Plan$BasicForm$validateBillingPeriod = F3(
	function (periodAllowed, adjustmentPercent, validationGroup) {
		return (periodAllowed && A2(
			$author$project$Utils$Validate$isInvalidPercentage,
			{
				aeU: false,
				AU: $elm$core$Maybe$Nothing,
				W9: $elm$core$Maybe$Just(0)
			},
			adjustmentPercent)) ? _List_fromArray(
			[
				_Utils_Tuple2(validationGroup, 'Please enter a number between 0 and 100.')
			]) : _List_Nil;
	});
var $author$project$Components$Plan$BasicForm$validateBillingPeriods = function (fields) {
	return fields.MI ? _List_Nil : $elm$core$List$concat(
		_List_fromArray(
			[
				A3($author$project$Components$Plan$BasicForm$validateBillingPeriod, fields.Bj, fields.Bi, 1),
				A3($author$project$Components$Plan$BasicForm$validateBillingPeriod, fields.DC, fields.DB, 2),
				A3($author$project$Components$Plan$BasicForm$validateBillingPeriod, fields.Et, fields.Es, 3),
				A3($author$project$Components$Plan$BasicForm$validateBillingPeriod, fields.xl, fields.xk, 4)
			]));
};
var $author$project$Components$Plan$BasicForm$validateBillingOptions = F2(
	function (maybePlan, fields) {
		var planType = A2(
			$elm$core$Maybe$withDefault,
			2,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Plan$One$planType, maybePlan));
		var isMcePlan = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Plan$One$isMcePlan, maybePlan));
		if ((planType !== 1) && (!isMcePlan)) {
			var forCompany = A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function (plan) {
						return !$author$project$Api$Provider$Plan$One$planType(plan);
					},
					maybePlan));
			return $elm$core$List$concat(
				_List_fromArray(
					[
						(fields.aak.Xf.Ro && ((!forCompany) && A2(
						$author$project$Utils$Validate$isOutsideIntRange,
						{
							aeU: false,
							AU: $elm$core$Maybe$Just(12),
							W9: $elm$core$Maybe$Just(1)
						},
						fields.Xf))) ? _List_fromArray(
						[
							_Utils_Tuple2(5, 'Please enter a number between 1 and 12.')
						]) : _List_Nil,
						$rtfeldman$elm_validate$Validate$isBlank(fields.y7) ? _List_fromArray(
						[
							_Utils_Tuple2(6, 'Please enter a name.')
						]) : _List_Nil,
						$author$project$Components$Plan$BasicForm$validateBillingPeriods(fields)
					]));
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Plan$BasicForm$RegistrationFeePricingValidation = 9;
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$hasErrors = function (_v0) {
	var form = _v0;
	return $author$project$Utils$Form$hasAnyValidationError(form);
};
var $author$project$Components$Plan$BasicForm$validateRegistrationFeePricing = function (fields) {
	return $author$project$Components$Plan$Form$RegistrationFeePricingFields$hasErrors(fields.dH) ? _List_fromArray(
		[
			_Utils_Tuple2(9, 'Please fix the registration fee validation errors.')
		]) : _List_Nil;
};
var $author$project$Components$Plan$BasicForm$SponsorFeeDealAmountInCentsValidation = 7;
var $author$project$Components$Plan$BasicForm$validateSponsorFeeDeal = F2(
	function (maybePlan, fields) {
		var planType = A2(
			$elm$core$Maybe$withDefault,
			2,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Plan$One$planType, maybePlan));
		return ((planType === 1) && A2(
			$author$project$Utils$Validate$isInvalidCurrency,
			{
				aeU: false,
				AU: $elm$core$Maybe$Nothing,
				W9: $elm$core$Maybe$Just(1)
			},
			fields.JS)) ? _List_fromArray(
			[
				_Utils_Tuple2(7, 'Please enter a number greater than 0.')
			]) : _List_Nil;
	});
var $author$project$Components$Plan$BasicForm$validator = F2(
	function (_v0, maybePlan) {
		return $rtfeldman$elm_validate$Validate$all(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_validate$Validate$ifBlank,
					function ($) {
						return $.Bq;
					},
					_Utils_Tuple2(0, 'Please enter a name.')),
					A2(
					$rtfeldman$elm_validate$Validate$ifBlank,
					function ($) {
						return $.DN;
					},
					_Utils_Tuple2(8, 'Please enter a registration fee name.')),
					$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Plan$BasicForm$validateRegistrationFeePricing),
					$rtfeldman$elm_validate$Validate$fromErrors(
					$author$project$Components$Plan$BasicForm$validateBillingOptions(maybePlan)),
					$rtfeldman$elm_validate$Validate$fromErrors(
					$author$project$Components$Plan$BasicForm$validateSponsorFeeDeal(maybePlan)),
					$author$project$Components$Plan$BasicForm$imageValidator
				]));
	});
var $author$project$Components$Plan$BasicForm$validate = F2(
	function (_v0, maybePlan) {
		var settings = _v0.a;
		var form = _v0.b;
		var fields = $author$project$Utils$Form$fields(form);
		var validatedRegistrationFeeForm = function () {
			var _v1 = $author$project$Components$Plan$Form$RegistrationFeePricingFields$validate(fields.dH);
			if (!_v1.$) {
				var _v2 = _v1.a;
				var newForm_ = _v2.a;
				return newForm_;
			} else {
				var newForm_ = _v1.a;
				return newForm_;
			}
		}();
		var updatedFields = _Utils_update(
			fields,
			{dH: validatedRegistrationFeeForm});
		return A2(
			$elm$core$Result$mapError,
			function (f) {
				return A2($author$project$Components$Plan$BasicForm$BasicPlanForm, settings, f);
			},
			A2(
				$elm$core$Result$map,
				$elm$core$Tuple$mapFirst(
					function (f) {
						return A2($author$project$Components$Plan$BasicForm$BasicPlanForm, settings, f);
					}),
				A2(
					$author$project$Utils$Form$validate,
					A2($author$project$Components$Plan$BasicForm$validator, settings, maybePlan),
					A2($author$project$Utils$Form$set, updatedFields, form))));
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyMembershipPricingForm = $elm$core$Basics$identity;
var $author$project$Api$DiscountRuleType$AdditionalAdult = 3;
var $author$project$Api$DiscountRuleType$AdditionalChild = 4;
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$ChildrenAgeLimitValidation = {$: 1};
var $author$project$Api$DiscountRuleType$ChildrenOnly = 5;
var $author$project$Api$DiscountRuleType$Couple = 0;
var $author$project$Api$DiscountRuleType$Family = 2;
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyNumChildrenIncludedValidation = {$: 0};
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$NumberAdditionalChildrenAllowedValidation = {$: 2};
var $author$project$Api$DiscountRuleType$SingleParent = 1;
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyDiscountRuleMaximumInCentsValidation = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyDiscountRuleRuleMaximumInCents = F3(
	function (defaultPeriod, discountRule, validationGroup) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (discountRule_) {
					var min = 0;
					var max = 9999900;
					return $elm$core$List$concat(
						_List_fromArray(
							[
								(((defaultPeriod === 'month') || discountRule_.Xo) && A2(
								$author$project$Utils$Validate$isInvalidCurrency,
								{
									aeU: false,
									AU: $elm$core$Maybe$Just(max),
									W9: $elm$core$Maybe$Just(min)
								},
								discountRule_.Xn)) ? _List_fromArray(
								[
									_Utils_Tuple2(
									validationGroup('month'),
									'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
								]) : _List_Nil,
								(((defaultPeriod === 'quarter') || discountRule_._V) && A2(
								$author$project$Utils$Validate$isInvalidCurrency,
								{
									aeU: false,
									AU: $elm$core$Maybe$Just(max),
									W9: $elm$core$Maybe$Just(min)
								},
								discountRule_._U)) ? _List_fromArray(
								[
									_Utils_Tuple2(
									validationGroup('quarter'),
									'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
								]) : _List_Nil,
								(((defaultPeriod === 'semi_annual') || discountRule_.aaO) && A2(
								$author$project$Utils$Validate$isInvalidCurrency,
								{
									aeU: false,
									AU: $elm$core$Maybe$Just(max),
									W9: $elm$core$Maybe$Just(min)
								},
								discountRule_.aaN)) ? _List_fromArray(
								[
									_Utils_Tuple2(
									validationGroup('semi_annual'),
									'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
								]) : _List_Nil,
								(((defaultPeriod === 'annual') || discountRule_.LM) && A2(
								$author$project$Utils$Validate$isInvalidCurrency,
								{
									aeU: false,
									AU: $elm$core$Maybe$Just(max),
									W9: $elm$core$Maybe$Just(min)
								},
								discountRule_.LL)) ? _List_fromArray(
								[
									_Utils_Tuple2(
									validationGroup('annual'),
									'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
								]) : _List_Nil
							]));
				},
				discountRule));
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyDiscountRule = F3(
	function (defaultPeriod, type_, fields) {
		switch (type_) {
			case 0:
				return A3(
					$author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyDiscountRuleRuleMaximumInCents,
					defaultPeriod,
					fields.yS,
					$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyDiscountRuleMaximumInCentsValidation(type_));
			case 1:
				return A3(
					$author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyDiscountRuleRuleMaximumInCents,
					defaultPeriod,
					fields.EG,
					$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyDiscountRuleMaximumInCentsValidation(type_));
			case 2:
				return A3(
					$author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyDiscountRuleRuleMaximumInCents,
					defaultPeriod,
					fields.zB,
					$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyDiscountRuleMaximumInCentsValidation(type_));
			case 3:
				return A3(
					$author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyDiscountRuleRuleMaximumInCents,
					defaultPeriod,
					fields.vB,
					$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyDiscountRuleMaximumInCentsValidation(type_));
			case 4:
				return A3(
					$author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyDiscountRuleRuleMaximumInCents,
					defaultPeriod,
					fields.vC,
					$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyDiscountRuleMaximumInCentsValidation(type_));
			default:
				return A3(
					$author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyDiscountRuleRuleMaximumInCents,
					defaultPeriod,
					fields.x3,
					$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyDiscountRuleMaximumInCentsValidation(type_));
		}
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyMembershipPricingFields = F3(
	function (sharedFields, maybePlan, fields) {
		var planType = A2(
			$elm$core$Maybe$withDefault,
			2,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Plan$One$planType, maybePlan));
		var isMcePlan = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Plan$One$isMcePlan, maybePlan));
		if ((planType !== 1) && ((!isMcePlan) && (sharedFields.S1 === 'family'))) {
			var _v0 = fields;
			var rules = _v0.aak;
			return $elm$core$List$concat(
				_List_fromArray(
					[
						rules.yS.Ro ? A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyDiscountRule, sharedFields.P6, 0, fields) : _List_Nil,
						rules.zB.Ro ? A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyDiscountRule, sharedFields.P6, 2, fields) : _List_Nil,
						rules.EG.Ro ? A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyDiscountRule, sharedFields.P6, 1, fields) : _List_Nil,
						(rules.zB.Ro || rules.EG.Ro) ? $elm$core$List$concat(
						_List_fromArray(
							[
								(rules.zC.Ro && A2(
								$author$project$Utils$Validate$isOutsideIntRange,
								{
									aeU: false,
									AU: $elm$core$Maybe$Nothing,
									W9: $elm$core$Maybe$Just(0)
								},
								fields.zC)) ? _List_fromArray(
								[
									_Utils_Tuple2($author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyNumChildrenIncludedValidation, 'Please enter a number greater than or equal to 0.')
								]) : _List_Nil,
								(rules.zC.Ro && rules.vC.Ro) ? A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyDiscountRule, sharedFields.P6, 4, fields) : _List_Nil,
								(rules.zC.Ro && (rules.BR.Ro && A2(
								$author$project$Utils$Validate$isOutsideIntRange,
								{
									aeU: false,
									AU: $elm$core$Maybe$Nothing,
									W9: $elm$core$Maybe$Just(0)
								},
								fields.BR))) ? _List_fromArray(
								[
									_Utils_Tuple2($author$project$Components$Plan$Form$FamilyMembershipPricingFields$NumberAdditionalChildrenAllowedValidation, 'Please enter a number greater than or equal to 0.')
								]) : _List_Nil,
								rules.vB.Ro ? A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyDiscountRule, sharedFields.P6, 3, fields) : _List_Nil,
								rules.x3.Ro ? A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyDiscountRule, sharedFields.P6, 5, fields) : _List_Nil,
								(rules.x2.Ro && A2(
								$author$project$Utils$Validate$isOutsideIntRange,
								{
									aeU: false,
									AU: $elm$core$Maybe$Nothing,
									W9: $elm$core$Maybe$Just(1)
								},
								fields.x2)) ? _List_fromArray(
								[
									_Utils_Tuple2($author$project$Components$Plan$Form$FamilyMembershipPricingFields$ChildrenAgeLimitValidation, 'Please enter a number greater than or equal to 1.')
								]) : _List_Nil
							])) : _List_Nil
					]));
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$validator = F2(
	function (sharedFields, maybePlan) {
		return $rtfeldman$elm_validate$Validate$all(
			_List_fromArray(
				[
					$rtfeldman$elm_validate$Validate$fromErrors(
					A2($author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyMembershipPricingFields, sharedFields, maybePlan))
				]));
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$validate = F3(
	function (_v0, sharedFields, maybePlan) {
		var form = _v0;
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$elm$core$Result$mapError,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Result$map,
				$elm$core$Tuple$mapFirst($elm$core$Basics$identity),
				A2(
					$author$project$Utils$Form$validate,
					A2($author$project$Components$Plan$Form$FamilyMembershipPricingFields$validator, sharedFields, maybePlan),
					A2($author$project$Utils$Form$set, fields, form))));
	});
var $author$project$Components$Plan$Form$GroupTierPricingFields$GroupTierPricingForm = $elm$core$Basics$identity;
var $author$project$Components$Plan$Form$GroupTierPricingFields$FamilyNumAdultsIncludedValidation = {$: 2};
var $author$project$Components$Plan$Form$GroupTierPricingFields$FixedChildrenAgeLimitValidation = {$: 1};
var $author$project$Components$Plan$Form$GroupTierPricingFields$GroupPricingFamilyNumChildrenIncludedValidation = {$: 3};
var $author$project$Components$Plan$Form$GroupTierPricingFields$FixedRateRuleAmountInCentsValidation = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Plan$Form$GroupTierPricingFields$validatePricingRuleAmountInCents = F3(
	function (defaultPeriod, pricingRule, validationGroup) {
		var min = 0;
		var max = 999999999;
		return $elm$core$List$concat(
			_List_fromArray(
				[
					(((defaultPeriod === 'month') || pricingRule.gX) && A2(
					$author$project$Utils$Validate$isInvalidCurrency,
					{
						aeU: false,
						AU: $elm$core$Maybe$Just(max),
						W9: $elm$core$Maybe$Just(min)
					},
					pricingRule.Xk)) ? _List_fromArray(
					[
						_Utils_Tuple2(
						validationGroup('month'),
						'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
					]) : _List_Nil,
					(((defaultPeriod === 'quarter') || pricingRule.ho) && A2(
					$author$project$Utils$Validate$isInvalidCurrency,
					{
						aeU: false,
						AU: $elm$core$Maybe$Just(max),
						W9: $elm$core$Maybe$Just(min)
					},
					pricingRule._Q)) ? _List_fromArray(
					[
						_Utils_Tuple2(
						validationGroup('quarter'),
						'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
					]) : _List_Nil,
					(((defaultPeriod === 'semi_annual') || pricingRule.hz) && A2(
					$author$project$Utils$Validate$isInvalidCurrency,
					{
						aeU: false,
						AU: $elm$core$Maybe$Just(max),
						W9: $elm$core$Maybe$Just(min)
					},
					pricingRule.aaJ)) ? _List_fromArray(
					[
						_Utils_Tuple2(
						validationGroup('semi_annual'),
						'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
					]) : _List_Nil,
					(((defaultPeriod === 'annual') || pricingRule.fE) && A2(
					$author$project$Utils$Validate$isInvalidCurrency,
					{
						aeU: false,
						AU: $elm$core$Maybe$Just(max),
						W9: $elm$core$Maybe$Just(min)
					},
					pricingRule.LH)) ? _List_fromArray(
					[
						_Utils_Tuple2(
						validationGroup('annual'),
						'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
					]) : _List_Nil
				]));
	});
var $author$project$Components$Plan$Form$GroupTierPricingFields$validateFixedRateRule = F3(
	function (defaultPeriod, rateRuleType, rateRule) {
		var createValidationGroup = function (period) {
			return A2($author$project$Components$Plan$Form$GroupTierPricingFields$FixedRateRuleAmountInCentsValidation, rateRuleType, period);
		};
		return A3($author$project$Components$Plan$Form$GroupTierPricingFields$validatePricingRuleAmountInCents, defaultPeriod, rateRule, createValidationGroup);
	});
var $author$project$Components$Plan$Form$GroupTierPricingFields$validateGroupTierPricing = F3(
	function (sharedFields, maybePlan, fields) {
		var planType = A2(
			$elm$core$Maybe$withDefault,
			2,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Plan$One$planType, maybePlan));
		var isMcePlan = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Plan$One$isMcePlan, maybePlan));
		return ((planType !== 1) && ((!isMcePlan) && (sharedFields.S1 === 'fixed_pricing'))) ? $elm$core$List$concat(
			_List_fromArray(
				[
					A3($author$project$Components$Plan$Form$GroupTierPricingFields$validateFixedRateRule, sharedFields.P6, $author$project$Api$RateRuleType$Individual, fields.TX),
					A3($author$project$Components$Plan$Form$GroupTierPricingFields$validateFixedRateRule, sharedFields.P6, $author$project$Api$RateRuleType$Couple, fields.ON),
					A3($author$project$Components$Plan$Form$GroupTierPricingFields$validateFixedRateRule, sharedFields.P6, $author$project$Api$RateRuleType$SingleParent, fields.abC),
					A3($author$project$Components$Plan$Form$GroupTierPricingFields$validateFixedRateRule, sharedFields.P6, $author$project$Api$RateRuleType$Family, fields.R9),
					fields.abF ? A3($author$project$Components$Plan$Form$GroupTierPricingFields$validateFixedRateRule, sharedFields.P6, $author$project$Api$RateRuleType$SingleParentWithSingleChild, fields.abE) : _List_Nil,
					fields.Sc ? A3($author$project$Components$Plan$Form$GroupTierPricingFields$validateFixedRateRule, sharedFields.P6, $author$project$Api$RateRuleType$FamilyWithSingleChild, fields.Sb) : _List_Nil,
					fields.aak.R8.Ro ? A3($author$project$Components$Plan$Form$GroupTierPricingFields$validateFixedRateRule, sharedFields.P6, $author$project$Api$RateRuleType$AdditionalAdult, fields.KZ) : _List_Nil,
					fields.aak.S0.Ro ? A3($author$project$Components$Plan$Form$GroupTierPricingFields$validateFixedRateRule, sharedFields.P6, $author$project$Api$RateRuleType$AdditionalChild, fields.K_) : _List_Nil,
					(fields.aak.Sw.Ro && A2(
					$author$project$Utils$Validate$isOutsideIntRange,
					{
						aeU: false,
						AU: $elm$core$Maybe$Nothing,
						W9: $elm$core$Maybe$Just(1)
					},
					fields.Sw)) ? _List_fromArray(
					[
						_Utils_Tuple2($author$project$Components$Plan$Form$GroupTierPricingFields$FixedChildrenAgeLimitValidation, 'Please enter a number greater or equal than 1.')
					]) : _List_Nil,
					(fields.aak.R8.Ro && A2(
					$author$project$Utils$Validate$isOutsideIntRange,
					{
						aeU: false,
						AU: $elm$core$Maybe$Nothing,
						W9: $elm$core$Maybe$Just(2)
					},
					fields.R8)) ? _List_fromArray(
					[
						_Utils_Tuple2($author$project$Components$Plan$Form$GroupTierPricingFields$FamilyNumAdultsIncludedValidation, 'Please enter a number greater or equal than 2.')
					]) : _List_Nil,
					(fields.aak.S0.Ro && A2(
					$author$project$Utils$Validate$isOutsideIntRange,
					{
						aeU: false,
						AU: $elm$core$Maybe$Nothing,
						W9: $elm$core$Maybe$Just(0)
					},
					fields.S0)) ? _List_fromArray(
					[
						_Utils_Tuple2($author$project$Components$Plan$Form$GroupTierPricingFields$GroupPricingFamilyNumChildrenIncludedValidation, 'Please enter a number greater than 0.')
					]) : _List_Nil
				])) : _List_Nil;
	});
var $author$project$Components$Plan$Form$GroupTierPricingFields$validator = F2(
	function (sharedFields, maybePlan) {
		return $rtfeldman$elm_validate$Validate$all(
			_List_fromArray(
				[
					$rtfeldman$elm_validate$Validate$fromErrors(
					A2($author$project$Components$Plan$Form$GroupTierPricingFields$validateGroupTierPricing, sharedFields, maybePlan))
				]));
	});
var $author$project$Components$Plan$Form$GroupTierPricingFields$validate = F3(
	function (sharedFields, _v0, maybePlan) {
		var form = _v0;
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$elm$core$Result$mapError,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Result$map,
				$elm$core$Tuple$mapFirst($elm$core$Basics$identity),
				A2(
					$author$project$Utils$Form$validate,
					A2($author$project$Components$Plan$Form$GroupTierPricingFields$validator, sharedFields, maybePlan),
					A2($author$project$Utils$Form$set, fields, form))));
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$IndividualMembershipPricingForm = $elm$core$Basics$identity;
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleAmountInCentsValidation = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$CoupleAgeRateRuleAmountInCentsValidation = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$validatePricingRuleAmountInCents = F3(
	function (defaultPeriod, pricingRule, validationGroup) {
		var min = 0;
		var max = 999999999;
		return $elm$core$List$concat(
			_List_fromArray(
				[
					(((defaultPeriod === 'month') || pricingRule.gX) && A2(
					$author$project$Utils$Validate$isInvalidCurrency,
					{
						aeU: false,
						AU: $elm$core$Maybe$Just(max),
						W9: $elm$core$Maybe$Just(min)
					},
					pricingRule.Xk)) ? _List_fromArray(
					[
						_Utils_Tuple2(
						validationGroup('month'),
						'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
					]) : _List_Nil,
					(((defaultPeriod === 'quarter') || pricingRule.ho) && A2(
					$author$project$Utils$Validate$isInvalidCurrency,
					{
						aeU: false,
						AU: $elm$core$Maybe$Just(max),
						W9: $elm$core$Maybe$Just(min)
					},
					pricingRule._Q)) ? _List_fromArray(
					[
						_Utils_Tuple2(
						validationGroup('quarter'),
						'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
					]) : _List_Nil,
					(((defaultPeriod === 'semi_annual') || pricingRule.hz) && A2(
					$author$project$Utils$Validate$isInvalidCurrency,
					{
						aeU: false,
						AU: $elm$core$Maybe$Just(max),
						W9: $elm$core$Maybe$Just(min)
					},
					pricingRule.aaJ)) ? _List_fromArray(
					[
						_Utils_Tuple2(
						validationGroup('semi_annual'),
						'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
					]) : _List_Nil,
					(((defaultPeriod === 'annual') || pricingRule.fE) && A2(
					$author$project$Utils$Validate$isInvalidCurrency,
					{
						aeU: false,
						AU: $elm$core$Maybe$Just(max),
						W9: $elm$core$Maybe$Just(min)
					},
					pricingRule.LH)) ? _List_fromArray(
					[
						_Utils_Tuple2(
						validationGroup('annual'),
						'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
					]) : _List_Nil
				]));
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$validateIndividualMembershipPricing = F3(
	function (sharedFields, maybePlan, fields) {
		var planType = A2(
			$elm$core$Maybe$withDefault,
			2,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Plan$One$planType, maybePlan));
		var isMcePlan = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Plan$One$isMcePlan, maybePlan));
		return ((planType !== 1) && ((!isMcePlan) && (sharedFields.S1 !== 'fixed_pricing'))) ? $elm$core$List$concat(
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (index, ageRateRule) {
						var flatAgeRateRule = {LH: ageRateRule.dE.LH, fE: ageRateRule.dE.fE, Xk: ageRateRule.dE.Xk, gX: ageRateRule.dE.gX, _Q: ageRateRule.dE._Q, ho: ageRateRule.dE.ho, aaJ: ageRateRule.dE.aaJ, hz: ageRateRule.dE.hz};
						var individualValidation = A3(
							$author$project$Components$Plan$Form$IndividualMembershipPricingFields$validatePricingRuleAmountInCents,
							sharedFields.P6,
							flatAgeRateRule,
							$author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleAmountInCentsValidation(index));
						var coupleValidation = function () {
							var _v0 = ageRateRule.OM;
							if (!_v0.$) {
								var coupleRule = _v0.a;
								var flatCoupleRule = {LH: coupleRule.dE.LH, fE: coupleRule.dE.fE, Xk: coupleRule.dE.Xk, gX: coupleRule.dE.gX, _Q: coupleRule.dE._Q, ho: coupleRule.dE.ho, aaJ: coupleRule.dE.aaJ, hz: coupleRule.dE.hz};
								return A3(
									$author$project$Components$Plan$Form$IndividualMembershipPricingFields$validatePricingRuleAmountInCents,
									sharedFields.P6,
									flatCoupleRule,
									$author$project$Components$Plan$Form$IndividualMembershipPricingFields$CoupleAgeRateRuleAmountInCentsValidation(index));
							} else {
								return _List_Nil;
							}
						}();
						return _Utils_ap(individualValidation, coupleValidation);
					}),
				fields.Lk)) : _List_Nil;
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$validator = F2(
	function (sharedFields, maybePlan) {
		return $rtfeldman$elm_validate$Validate$all(
			_List_fromArray(
				[
					$rtfeldman$elm_validate$Validate$fromErrors(
					A2($author$project$Components$Plan$Form$IndividualMembershipPricingFields$validateIndividualMembershipPricing, sharedFields, maybePlan))
				]));
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$validate = F3(
	function (sharedFields, _v0, maybePlan) {
		var form = _v0;
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$elm$core$Result$mapError,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Result$map,
				$elm$core$Tuple$mapFirst($elm$core$Basics$identity),
				A2(
					$author$project$Utils$Form$validate,
					A2($author$project$Components$Plan$Form$IndividualMembershipPricingFields$validator, sharedFields, maybePlan),
					A2($author$project$Utils$Form$set, fields, form))));
	});
var $author$project$Components$Plan$Form$SpecialRatesFields$SpecialRatesForm = $elm$core$Basics$identity;
var $author$project$Api$FeatureGate$MembershipPricingAdvancePricingRules = 7;
var $author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateAmountInCentsValidation = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateNameValidation = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Plan$Form$SpecialRatesFields$validatePricingRuleAmountInCents = F3(
	function (defaultPeriod, pricingRule, validationGroup) {
		var min = 0;
		var max = 999999999;
		return $elm$core$List$concat(
			_List_fromArray(
				[
					(((defaultPeriod === 'month') || pricingRule.gX) && A2(
					$author$project$Utils$Validate$isInvalidCurrency,
					{
						aeU: false,
						AU: $elm$core$Maybe$Just(max),
						W9: $elm$core$Maybe$Just(min)
					},
					pricingRule.Xk)) ? _List_fromArray(
					[
						_Utils_Tuple2(
						validationGroup('month'),
						'Please enter an amount between $0.00 and $9,999,999.99.')
					]) : _List_Nil,
					(((defaultPeriod === 'quarter') || pricingRule.ho) && A2(
					$author$project$Utils$Validate$isInvalidCurrency,
					{
						aeU: false,
						AU: $elm$core$Maybe$Just(max),
						W9: $elm$core$Maybe$Just(min)
					},
					pricingRule._Q)) ? _List_fromArray(
					[
						_Utils_Tuple2(
						validationGroup('quarter'),
						'Please enter an amount between $0.00 and $9,999,999.99.')
					]) : _List_Nil,
					(((defaultPeriod === 'semi_annual') || pricingRule.hz) && A2(
					$author$project$Utils$Validate$isInvalidCurrency,
					{
						aeU: false,
						AU: $elm$core$Maybe$Just(max),
						W9: $elm$core$Maybe$Just(min)
					},
					pricingRule.aaJ)) ? _List_fromArray(
					[
						_Utils_Tuple2(
						validationGroup('semi_annual'),
						'Please enter an amount between $0.00 and $9,999,999.99.')
					]) : _List_Nil,
					(((defaultPeriod === 'annual') || pricingRule.fE) && A2(
					$author$project$Utils$Validate$isInvalidCurrency,
					{
						aeU: false,
						AU: $elm$core$Maybe$Just(max),
						W9: $elm$core$Maybe$Just(min)
					},
					pricingRule.LH)) ? _List_fromArray(
					[
						_Utils_Tuple2(
						validationGroup('annual'),
						'Please enter an amount between $0.00 and $9,999,999.99.')
					]) : _List_Nil
				]));
	});
var $author$project$Components$Plan$Form$SpecialRatesFields$validateSpecialRate = F3(
	function (defaultPeriod, index, fields) {
		return fields.Qv ? _List_Nil : $elm$core$List$concat(
			_List_fromArray(
				[
					$elm$core$String$isEmpty(fields.Bq) ? _List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateNameValidation(index),
						'Please enter a name.')
					]) : _List_Nil,
					A3(
					$author$project$Components$Plan$Form$SpecialRatesFields$validatePricingRuleAmountInCents,
					defaultPeriod,
					fields,
					$author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateAmountInCentsValidation(index))
				]));
	});
var $author$project$Components$Plan$Form$SpecialRatesFields$validateSpecialRates = F4(
	function (sharedFields, practice, maybePlan, fields) {
		var planType = A2(
			$elm$core$Maybe$withDefault,
			2,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Plan$One$planType, maybePlan));
		var isMcePlan = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Plan$One$isMcePlan, maybePlan));
		return ((planType !== 1) && ((!isMcePlan) && A2(
			$author$project$Utils$FeatureGate$gateAvailable,
			7,
			$author$project$Api$Practice$Provider(practice)))) ? $elm$core$List$concat(
			A2(
				$elm$core$List$indexedMap,
				$author$project$Components$Plan$Form$SpecialRatesFields$validateSpecialRate(sharedFields.P6),
				fields.abT)) : _List_Nil;
	});
var $author$project$Components$Plan$Form$SpecialRatesFields$validator = F3(
	function (sharedFields, practice, maybePlan) {
		return $rtfeldman$elm_validate$Validate$all(
			_List_fromArray(
				[
					$rtfeldman$elm_validate$Validate$fromErrors(
					A3($author$project$Components$Plan$Form$SpecialRatesFields$validateSpecialRates, sharedFields, practice, maybePlan))
				]));
	});
var $author$project$Components$Plan$Form$SpecialRatesFields$validate = F4(
	function (sharedFields, practice, _v0, maybePlan) {
		var form = _v0;
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$elm$core$Result$mapError,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Result$map,
				$elm$core$Tuple$mapFirst($elm$core$Basics$identity),
				A2(
					$author$project$Utils$Form$validate,
					A3($author$project$Components$Plan$Form$SpecialRatesFields$validator, sharedFields, practice, maybePlan),
					A2($author$project$Utils$Form$set, fields, form))));
	});
var $author$project$Components$Plan$Form$validateFormFields = F3(
	function (plan, practice, form) {
		var sharedFields = A2($author$project$Components$Plan$Form$initSharedFields, plan, form);
		var fields = $author$project$Utils$Form$fields(form);
		var validatedFamilyMembershipPricingForm = function () {
			var _v8 = A3(
				$author$project$Components$Plan$Form$FamilyMembershipPricingFields$validate,
				fields.dm,
				sharedFields,
				$elm$core$Maybe$Just(plan));
			if (!_v8.$) {
				var _v9 = _v8.a;
				var newForm_ = _v9.a;
				return newForm_;
			} else {
				var newForm_ = _v8.a;
				return newForm_;
			}
		}();
		var validatedGroupTierPricingForm = function () {
			var _v6 = A3(
				$author$project$Components$Plan$Form$GroupTierPricingFields$validate,
				sharedFields,
				fields.k,
				$elm$core$Maybe$Just(plan));
			if (!_v6.$) {
				var _v7 = _v6.a;
				var newForm_ = _v7.a;
				return newForm_;
			} else {
				var newForm_ = _v6.a;
				return newForm_;
			}
		}();
		var validatedMembershipPricingForm = function () {
			var _v4 = A3(
				$author$project$Components$Plan$Form$IndividualMembershipPricingFields$validate,
				sharedFields,
				fields.dq,
				$elm$core$Maybe$Just(plan));
			if (!_v4.$) {
				var _v5 = _v4.a;
				var newForm_ = _v5.a;
				return newForm_;
			} else {
				var newForm_ = _v4.a;
				return newForm_;
			}
		}();
		var validatedSpecialRatesForm = function () {
			var _v2 = A4(
				$author$project$Components$Plan$Form$SpecialRatesFields$validate,
				sharedFields,
				practice,
				fields.dL,
				$elm$core$Maybe$Just(plan));
			if (!_v2.$) {
				var _v3 = _v2.a;
				var newForm_ = _v3.a;
				return newForm_;
			} else {
				var newForm_ = _v2.a;
				return newForm_;
			}
		}();
		var basicPlanForm = function () {
			var _v0 = A2(
				$author$project$Components$Plan$BasicForm$validate,
				fields.ab,
				$elm$core$Maybe$Just(plan));
			if (!_v0.$) {
				var _v1 = _v0.a;
				var newForm_ = _v1.a;
				return newForm_;
			} else {
				var newForm_ = _v0.a;
				return newForm_;
			}
		}();
		return A2(
			$author$project$Utils$Form$set,
			_Utils_update(
				fields,
				{ab: basicPlanForm, dm: validatedFamilyMembershipPricingForm, k: validatedGroupTierPricingForm, dq: validatedMembershipPricingForm, dL: validatedSpecialRatesForm}),
			form);
	});
var $author$project$Components$Plan$Form$calculate = F4(
	function (plan, form, opts, model) {
		var newValidForm = A3($author$project$Components$Plan$Form$validateFormFields, plan, model.ZV, form);
		var sharedFields = A2($author$project$Components$Plan$Form$initSharedFields, plan, newValidForm);
		var isValid = (!opts.aed) || $author$project$Utils$Maybe$toBool(
			$elm$core$Result$toMaybe(
				A2(
					$author$project$Utils$Form$validate,
					A5($author$project$Components$Plan$Form$formFieldsValidator, sharedFields, model.dd, model.qy, model.kH, plan),
					newValidForm)));
		var _v0 = (opts.abg && isValid) ? A3(
			$jinjor$elm_debounce$Debounce$push,
			$author$project$Components$Plan$Form$previewDebounceConfig,
			$author$project$Utils$Form$fields(form),
			model.eW) : _Utils_Tuple2(model.eW, $elm$core$Platform$Cmd$none);
		var newDebouncer = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			function () {
				if (opts.abg && isValid) {
					return _Utils_update(
						model,
						{eW: newDebouncer});
				} else {
					if (!isValid) {
						var previewId = model.akd.a + 1;
						return _Utils_update(
							model,
							{
								akd: _Utils_Tuple2(previewId, $author$project$Api$Data$NotAsked),
								eW: newDebouncer
							});
					} else {
						return _Utils_update(
							model,
							{eW: newDebouncer});
					}
				}
			}(),
			cmd);
	});
var $author$project$Components$Plan$Form$calculateAfterValidation = F5(
	function (model, plan, form, opts, showWarningModal) {
		var validatedForm = A3($author$project$Components$Plan$Form$validateFormFields, plan, model.ZV, form);
		var sharedFields = A2($author$project$Components$Plan$Form$initSharedFields, plan, validatedForm);
		var _v0 = A2(
			$author$project$Utils$Form$validate,
			A5($author$project$Components$Plan$Form$formFieldsValidator, sharedFields, model.dd, model.qy, model.kH, plan),
			validatedForm);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var newForm_ = _v1.a;
			return A4(
				$author$project$Components$Plan$Form$calculate,
				plan,
				newForm_,
				opts,
				_Utils_update(
					model,
					{
						SD: $elm$core$Maybe$Just(
							_Utils_Tuple2(plan, newForm_)),
						qa: showWarningModal
					}));
		} else {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						SD: $elm$core$Maybe$Just(
							_Utils_Tuple2(plan, form)),
						qa: showWarningModal
					}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$calculateOpts = function (field) {
	var _v0 = function () {
		switch (field.$) {
			case 0:
				return _Utils_Tuple2(false, false);
			case 1:
				return _Utils_Tuple2(false, false);
			default:
				return _Utils_Tuple2(false, false);
		}
	}();
	var shouldCalculate_ = _v0.a;
	var validateCalculateFields = _v0.b;
	return {abg: shouldCalculate_, aed: validateCalculateFields};
};
var $author$project$Components$Plan$BasicForm$calculateOpts = function (field) {
	var _v0 = function () {
		switch (field.$) {
			case 0:
				return _Utils_Tuple2(false, false);
			case 20:
				return _Utils_Tuple2(false, false);
			case 21:
				return _Utils_Tuple2(false, false);
			case 1:
				return _Utils_Tuple2(false, false);
			case 2:
				return _Utils_Tuple2(false, false);
			case 17:
				return _Utils_Tuple2(false, false);
			case 5:
				return _Utils_Tuple2(false, false);
			case 6:
				return _Utils_Tuple2(false, false);
			case 19:
				return _Utils_Tuple2(false, false);
			case 3:
				return _Utils_Tuple2(true, false);
			case 4:
				return _Utils_Tuple2(true, false);
			case 9:
				return _Utils_Tuple2(true, true);
			case 10:
				return _Utils_Tuple2(true, true);
			case 11:
				return _Utils_Tuple2(true, true);
			case 12:
				return _Utils_Tuple2(true, true);
			case 13:
				return _Utils_Tuple2(true, true);
			case 14:
				return _Utils_Tuple2(true, true);
			case 15:
				return _Utils_Tuple2(true, false);
			case 16:
				return _Utils_Tuple2(true, true);
			case 7:
				return _Utils_Tuple2(false, false);
			case 22:
				return _Utils_Tuple2(false, false);
			case 8:
				return _Utils_Tuple2(false, false);
			case 18:
				return _Utils_Tuple2(false, false);
			case 23:
				var registrationField = field.a;
				var opts = $author$project$Components$Plan$Form$RegistrationFeePricingFields$calculateOpts(registrationField);
				return _Utils_Tuple2(opts.abg, opts.aed);
			default:
				return _Utils_Tuple2(false, false);
		}
	}();
	var shouldCalculate_ = _v0.a;
	var validateCalculateFields = _v0.b;
	return {abg: shouldCalculate_, aed: validateCalculateFields};
};
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$calculateOpts = function (field) {
	var _v0 = function () {
		switch (field.$) {
			case 2:
				return _Utils_Tuple2(false, true);
			case 3:
				return _Utils_Tuple2(false, true);
			case 4:
				return _Utils_Tuple2(false, true);
			case 5:
				return _Utils_Tuple2(true, true);
			case 6:
				return _Utils_Tuple2(false, true);
			case 7:
				return _Utils_Tuple2(true, true);
			case 0:
				return _Utils_Tuple2(false, true);
			case 1:
				return _Utils_Tuple2(false, false);
			default:
				return _Utils_Tuple2(false, false);
		}
	}();
	var shouldCalculate_ = _v0.a;
	var validateCalculateFields = _v0.b;
	return {abg: shouldCalculate_, aed: validateCalculateFields};
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$calculateOpts = function (field) {
	var _v0 = function () {
		switch (field.$) {
			case 0:
				return _Utils_Tuple2(true, false);
			case 1:
				return _Utils_Tuple2(true, false);
			case 2:
				return _Utils_Tuple2(true, false);
			case 3:
				return _Utils_Tuple2(true, false);
			case 4:
				return _Utils_Tuple2(true, false);
			case 5:
				return _Utils_Tuple2(true, false);
			case 6:
				return _Utils_Tuple2(true, false);
			case 7:
				return _Utils_Tuple2(true, false);
			case 8:
				return _Utils_Tuple2(false, true);
			case 9:
				return _Utils_Tuple2(false, true);
			case 10:
				return _Utils_Tuple2(false, true);
			case 11:
				return _Utils_Tuple2(false, true);
			case 12:
				return _Utils_Tuple2(false, false);
			case 13:
				return _Utils_Tuple2(true, false);
			case 14:
				return _Utils_Tuple2(false, false);
			case 15:
				return _Utils_Tuple2(false, false);
			case 16:
				return _Utils_Tuple2(true, false);
			case 17:
				return _Utils_Tuple2(false, false);
			case 18:
				return _Utils_Tuple2(true, false);
			default:
				return _Utils_Tuple2(true, false);
		}
	}();
	var shouldCalculate_ = _v0.a;
	var validateCalculateFields = _v0.b;
	return {abg: shouldCalculate_, aed: validateCalculateFields};
};
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$calculateOpts = function (field) {
	var _v0 = function () {
		switch (field.$) {
			case 0:
				return _Utils_Tuple2(true, true);
			case 1:
				return _Utils_Tuple2(true, true);
			case 2:
				return _Utils_Tuple2(false, true);
			case 3:
				return _Utils_Tuple2(true, true);
			case 4:
				return _Utils_Tuple2(true, true);
			case 5:
				return _Utils_Tuple2(false, true);
			case 6:
				return _Utils_Tuple2(true, true);
			case 7:
				return _Utils_Tuple2(true, true);
			case 8:
				return _Utils_Tuple2(false, true);
			case 9:
				return _Utils_Tuple2(true, true);
			case 10:
				return _Utils_Tuple2(true, false);
			default:
				return _Utils_Tuple2(false, false);
		}
	}();
	var shouldCalculate_ = _v0.a;
	var validateCalculateFields = _v0.b;
	return {abg: shouldCalculate_, aed: validateCalculateFields};
};
var $author$project$Components$Plan$Form$SpecialRatesFields$calculateOpts = function (field) {
	var _v0 = function () {
		switch (field.$) {
			case 0:
				return _Utils_Tuple2(true, true);
			case 1:
				return _Utils_Tuple2(true, true);
			case 2:
				return _Utils_Tuple2(false, true);
			case 3:
				return _Utils_Tuple2(true, true);
			case 4:
				return _Utils_Tuple2(false, true);
			default:
				return _Utils_Tuple2(true, true);
		}
	}();
	var shouldCalculate_ = _v0.a;
	var validateCalculateFields = _v0.b;
	return {abg: shouldCalculate_, aed: validateCalculateFields};
};
var $elm$http$Http$cancel = function (tracker) {
	return $elm$http$Http$command(
		$elm$http$Http$Cancel(tracker));
};
var $author$project$Api$Provider$CoveragePlan$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$CoveragePlan$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CoveragePlan$Shared$id(shared);
};
var $author$project$Api$Provider$CoveragePlan$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CoveragePlan$Shared$id(shared);
};
var $author$project$Components$Plan$Form$coveragePlanId = function (coveragePlan) {
	if (!coveragePlan.$) {
		var coveragePlan_ = coveragePlan.a;
		return $author$project$Api$Provider$CoveragePlan$One$id(coveragePlan_);
	} else {
		var coveragePlan_ = coveragePlan.a;
		return $author$project$Api$Provider$CoveragePlan$All$id(coveragePlan_);
	}
};
var $author$project$Components$Plan$Form$PreviewDebounced = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Plan$Form$debounceCalculate = function (formFields) {
	return A2(
		$elm$core$Task$perform,
		$author$project$Components$Plan$Form$PreviewDebounced,
		$elm$core$Task$succeed(formFields));
};
var $author$project$Api$Provider$Plan$delete = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Plan$planPath(id)));
	});
var $author$project$Components$Plan$Form$GotSubsequentPlan = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$SubsequentPlan$One$SubsequentPlan = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$SubsequentPlan$Min$SubsequentPlan = $elm$core$Basics$identity;
var $author$project$Api$Provider$SubsequentPlan$Min$Record = F2(
	function (id, type_) {
		return {ahP: id, amg: type_};
	});
var $author$project$Api$Provider$MembershipScheduledChange$Type$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'date':
				return $elm$json$Json$Decode$succeed(0);
			case 'duration':
				return $elm$json$Json$Decode$succeed(1);
			case 'contract':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Unsupported membership scheduled change type: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$SubsequentPlan$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'type',
	$author$project$Api$Provider$MembershipScheduledChange$Type$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$SubsequentPlan$Min$Record)));
var $author$project$Api$Provider$SubsequentPlan$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$SubsequentPlan$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$SubsequentPlan$One$Record = F3(
	function (changeAfterMonths, changeOnDate, toPlan) {
		return {Nt: changeAfterMonths, Nu: changeOnDate, adc: toPlan};
	});
var $author$project$Api$Provider$SubsequentPlan$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'to_plan',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Plan$Min$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'change_on_date',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'change_after_months',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$SubsequentPlan$One$Record))));
var $author$project$Api$Provider$SubsequentPlan$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$SubsequentPlan$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$SubsequentPlan$Min$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$SubsequentPlan$One$SubsequentPlan)));
var $author$project$Api$Provider$Plan$SubsequentPlan$subsequentPlansPath = function (planId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['subsequent_plan']),
		$author$project$Api$Provider$Plan$planPath(planId));
};
var $author$project$Api$Provider$Plan$SubsequentPlan$retrieve = F3(
	function (apiClient, planId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$SubsequentPlan$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Plan$SubsequentPlan$subsequentPlansPath(planId)));
	});
var $author$project$Components$Plan$Form$fetchSubsequentPlan = F2(
	function (apiClient, id) {
		return A3($author$project$Api$Provider$Plan$SubsequentPlan$retrieve, apiClient, id, $author$project$Components$Plan$Form$GotSubsequentPlan);
	});
var $author$project$Api$Provider$Plan$Shared$ageRateRules = function (_v0) {
	var record = _v0;
	return record.Lk;
};
var $author$project$Api$Provider$Plan$One$ageRateRules = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$ageRateRules(shared);
};
var $author$project$Components$Plan$Form$PlanChange$clean = function (planChange) {
	var params = planChange.YL;
	return (planChange.YL.amg === 2) ? _Utils_update(
		planChange,
		{
			YL: _Utils_update(
				params,
				{Nt: $elm$core$Maybe$Nothing, Nu: $elm$core$Maybe$Nothing})
		}) : ((!planChange.YL.amg) ? _Utils_update(
		planChange,
		{
			YL: _Utils_update(
				params,
				{Nt: $elm$core$Maybe$Nothing})
		}) : _Utils_update(
		planChange,
		{
			YL: _Utils_update(
				params,
				{Nu: $elm$core$Maybe$Nothing})
		}));
};
var $author$project$Components$Plan$Form$exclusiveRanges = F5(
	function (fromGetter, fromSetter, toGetter, toSetter, range) {
		if ($elm$core$List$isEmpty(range)) {
			return range;
		} else {
			var minimum = A2(
				$elm$core$Maybe$withDefault,
				0,
				A2(
					$elm$core$Maybe$map,
					fromGetter,
					$elm$core$List$head(range)));
			return A2(
				$elm$core$List$indexedMap,
				F2(
					function (index, current) {
						var prev = A2($elm_community$list_extra$List$Extra$getAt, index - 1, range);
						var next = A2($elm_community$list_extra$List$Extra$getAt, index + 1, range);
						var newTo = function () {
							var _v1 = _Utils_Tuple2(
								next,
								toGetter(current));
							if (_v1.a.$ === 1) {
								var _v2 = _v1.a;
								return $elm$core$Maybe$Nothing;
							} else {
								if (_v1.b.$ === 1) {
									var _v3 = _v1.b;
									return toGetter(current);
								} else {
									var currentTo = _v1.b.a;
									var currentFrom = fromGetter(current);
									return (_Utils_cmp(currentTo, currentFrom) < 1) ? $elm$core$Maybe$Just(currentFrom) : toGetter(current);
								}
							}
						}();
						var newFrom = function () {
							var _v0 = A2($elm$core$Maybe$andThen, toGetter, prev);
							if (!_v0.$) {
								var _int = _v0.a;
								return _int + 1;
							} else {
								return minimum;
							}
						}();
						return A2(
							toSetter,
							newTo,
							A2(fromSetter, newFrom, current));
					}),
				range);
		}
	});
var $author$project$Components$Plan$Form$exclusiveSizeRanges = A4(
	$author$project$Components$Plan$Form$exclusiveRanges,
	function ($) {
		return $.SM;
	},
	F2(
		function (from, item) {
			return _Utils_update(
				item,
				{SM: from});
		}),
	function ($) {
		return $.add;
	},
	F2(
		function (to, item) {
			return _Utils_update(
				item,
				{add: to});
		}));
var $author$project$Api$Provider$RateRule$Shared$fromAge = function (_v0) {
	var record = _v0;
	return record.SK;
};
var $author$project$Api$Employer$Plan$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Employer$Plan$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$id(shared);
};
var $author$project$Api$Employer$Plan$One$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$id(shared);
};
var $author$project$Api$Provider$Plan$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Plan$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$id(shared);
};
var $author$project$Api$Provider$Plan$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$id(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$id(shared);
};
var $author$project$Api$Plan$id = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$Shared$id(plan_);
		case 1:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$SharedWithContractInfo$id(plan_);
		case 4:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$Shared$id(plan_);
		case 2:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$All$id(plan_);
		case 6:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$All$id(plan_);
		case 3:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$One$id(plan_);
		default:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$One$id(plan_);
	}
};
var $elm_community$list_extra$List$Extra$last = function (items) {
	last:
	while (true) {
		if (!items.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!items.b.b) {
				var x = items.a;
				return $elm$core$Maybe$Just(x);
			} else {
				var rest = items.b;
				var $temp$items = rest;
				items = $temp$items;
				continue last;
			}
		}
	}
};
var $author$project$Components$Plan$Form$maxGroupFromSize = 10;
var $author$project$Api$Employer$Plan$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Employer$Plan$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$name(shared);
};
var $author$project$Api$Employer$Plan$One$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$name(shared);
};
var $author$project$Api$Provider$Plan$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$Plan$All$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$name(shared);
};
var $author$project$Api$Provider$Plan$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$name(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$name(shared);
};
var $author$project$Api$Plan$name = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$Shared$name(plan_);
		case 1:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$SharedWithContractInfo$name(plan_);
		case 4:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$Shared$name(plan_);
		case 2:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$All$name(plan_);
		case 6:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$All$name(plan_);
		case 3:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$One$name(plan_);
		default:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$One$name(plan_);
	}
};
var $author$project$Utils$List$prepend = F2(
	function (xs, ys) {
		return _Utils_ap(ys, xs);
	});
var $author$project$Api$Provider$SpecialRate$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$Plan$Shared$specialRates = function (_v0) {
	var record = _v0;
	return record.abT;
};
var $author$project$Api$Provider$Plan$All$specialRates = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$specialRates(shared);
};
var $author$project$Api$Provider$Plan$One$specialRates = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$specialRates(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$specialRates = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$specialRates(shared);
};
var $author$project$Api$Plan$specialRateNames = function (plan) {
	var toNames = $elm$core$List$map($author$project$Api$Provider$SpecialRate$Shared$name);
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return toNames(
				$author$project$Api$Provider$Plan$Shared$specialRates(plan_));
		case 1:
			var plan_ = plan.a;
			return toNames(
				$author$project$Api$Provider$Plan$SharedWithContractInfo$specialRates(plan_));
		case 2:
			var plan_ = plan.a;
			return toNames(
				$author$project$Api$Provider$Plan$All$specialRates(plan_));
		case 3:
			var plan_ = plan.a;
			return toNames(
				$author$project$Api$Provider$Plan$One$specialRates(plan_));
		case 4:
			return _List_Nil;
		case 6:
			return _List_Nil;
		default:
			return _List_Nil;
	}
};
var $author$project$Components$Plan$Form$GroupDiscountRuleField$default = function (defaultPeriod) {
	return function (groupDiscountRule) {
		switch (defaultPeriod) {
			case 'month':
				return _Utils_update(
					groupDiscountRule,
					{
						Xl: $elm$core$Maybe$Just($author$project$Currency$zero)
					});
			case 'quarter':
				return _Utils_update(
					groupDiscountRule,
					{
						_S: $elm$core$Maybe$Just($author$project$Currency$zero)
					});
			case 'semi_annual':
				return _Utils_update(
					groupDiscountRule,
					{
						aaL: $elm$core$Maybe$Just($author$project$Currency$zero)
					});
			case 'annual':
				return _Utils_update(
					groupDiscountRule,
					{
						LJ: $elm$core$Maybe$Just($author$project$Currency$zero)
					});
			default:
				return groupDiscountRule;
		}
	}(
		{LJ: $elm$core$Maybe$Nothing, LK: false, Gs: false, LP: $elm$core$Maybe$Nothing, LQ: false, rj: false, M2: 'amount_off_in_cents', SM: 2, Xl: $elm$core$Maybe$Nothing, Xm: false, IC: false, Xs: $elm$core$Maybe$Nothing, Xt: false, oH: false, _S: $elm$core$Maybe$Nothing, _T: false, Jq: false, _Y: $elm$core$Maybe$Nothing, _Z: false, t7: false, aaL: $elm$core$Maybe$Nothing, aaM: false, JG: false, aaR: $elm$core$Maybe$Nothing, aaS: false, uv: false, add: $elm$core$Maybe$Nothing});
};
var $author$project$Components$Plan$Form$GroupDiscountRuleField$startingFrom = F2(
	function (defaultPeriod, base) {
		return function (groupDiscountRule) {
			var _v0 = _Utils_Tuple2(base.M2, defaultPeriod);
			_v0$8:
			while (true) {
				switch (_v0.a) {
					case 'amount_off_in_cents':
						switch (_v0.b) {
							case 'month':
								return _Utils_update(
									groupDiscountRule,
									{Xl: base.Xl, Xm: true});
							case 'quarter':
								return _Utils_update(
									groupDiscountRule,
									{_S: base._S, _T: true});
							case 'semi_annual':
								return _Utils_update(
									groupDiscountRule,
									{aaL: base.aaL, aaM: true});
							case 'annual':
								return _Utils_update(
									groupDiscountRule,
									{LJ: base.LJ, LK: true});
							default:
								break _v0$8;
						}
					case 'percent_off':
						switch (_v0.b) {
							case 'month':
								return _Utils_update(
									groupDiscountRule,
									{Xs: base.Xs, Xt: true});
							case 'quarter':
								return _Utils_update(
									groupDiscountRule,
									{_Y: base._Y, _Z: true});
							case 'semi_annual':
								return _Utils_update(
									groupDiscountRule,
									{aaR: base.aaR, aaS: true});
							case 'annual':
								return _Utils_update(
									groupDiscountRule,
									{LP: base.LP, LQ: true});
							default:
								break _v0$8;
						}
					default:
						break _v0$8;
				}
			}
			return groupDiscountRule;
		}(
			function (groupDiscountRule) {
				return _Utils_update(
					groupDiscountRule,
					{
						M2: base.M2,
						SM: A2($elm$core$Maybe$withDefault, 0, base.add) + 1
					});
			}(
				$author$project$Components$Plan$Form$GroupDiscountRuleField$default(defaultPeriod)));
	});
var $author$project$Api$Provider$RateRule$Shared$toAge = function (_v0) {
	var record = _v0;
	return record.adb;
};
var $author$project$Utils$List$updateLast = F2(
	function (f, xs) {
		if (!xs.b) {
			return xs;
		} else {
			return A3(
				$elm_community$list_extra$List$Extra$updateAt,
				$elm$core$List$length(xs) - 1,
				f,
				xs);
		}
	});
var $author$project$Components$Plan$Form$formFieldsUpdate = F3(
	function (plan, field, fields) {
		switch (field.$) {
			case 0:
				var basicPlanForm = field.a;
				return _Utils_update(
					fields,
					{ab: basicPlanForm});
			case 1:
				var membershipPricingForm = field.a;
				return _Utils_update(
					fields,
					{dq: membershipPricingForm});
			case 2:
				var familyMembershipPricingForm = field.a;
				return _Utils_update(
					fields,
					{dm: familyMembershipPricingForm});
			case 3:
				var groupTierPricingForm = field.a;
				return _Utils_update(
					fields,
					{k: groupTierPricingForm});
			case 4:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Vu: $author$project$Utils$String$toMaybe(string)
					});
			case 5:
				var string = field.a;
				return _Utils_update(
					fields,
					{adh: string});
			case 6:
				var currency = field.a;
				return _Utils_update(
					fields,
					{adf: currency});
			case 7:
				var percentage = field.a;
				return _Utils_update(
					fields,
					{adg: percentage});
			case 8:
				var bool = field.a;
				var planChange = function () {
					if (_Utils_eq(fields.kG.YL.ahP, $elm$core$Maybe$Nothing)) {
						var planChangeType = bool ? 2 : 1;
						return $author$project$Components$Plan$Form$PlanChange$clean(
							function (planChange_) {
								var params = fields.kG.YL;
								return _Utils_update(
									planChange_,
									{
										YL: _Utils_update(
											params,
											{amg: planChangeType})
									});
							}(fields.kG));
					} else {
						return fields.kG;
					}
				}();
				return _Utils_update(
					fields,
					{OB: bool, kG: planChange, _j: 0});
			case 9:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						OC: $elm$core$String$toInt(string)
					});
			case 10:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						G3: $author$project$Api$ContractType$fromString(string)
					});
			case 11:
				var bool = field.a;
				return _Utils_update(
					fields,
					{OA: bool});
			case 12:
				var bool = field.a;
				return _Utils_update(
					fields,
					{zi: bool});
			case 13:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						OD: $elm$core$String$toInt(string)
					});
			case 14:
				var bool = field.a;
				var ageRateRules = $author$project$Api$Provider$Plan$One$ageRateRules(plan);
				var minimumAge = (bool && ($elm$core$List$length(ageRateRules) > 1)) ? A2(
					$elm$core$Maybe$andThen,
					$author$project$Api$Provider$RateRule$Shared$toAge,
					$elm$core$List$head(ageRateRules)) : $elm$core$Maybe$Just(0);
				return _Utils_update(
					fields,
					{zm: bool, Xd: minimumAge});
			case 15:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Xd: $elm$core$String$toInt(string)
					});
			case 16:
				var bool = field.a;
				var ageRateRules = $author$project$Api$Provider$Plan$One$ageRateRules(plan);
				var maximumAge = (bool && ($elm$core$List$length(ageRateRules) > 1)) ? A2(
					$elm$core$Maybe$map,
					$author$project$Api$Provider$RateRule$Shared$fromAge,
					$elm_community$list_extra$List$Extra$last(ageRateRules)) : $elm$core$Maybe$Nothing;
				return _Utils_update(
					fields,
					{zl: bool, WF: maximumAge});
			case 17:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						WF: $elm$core$String$toInt(string)
					});
			case 18:
				var coveragePlan = field.a;
				return _Utils_update(
					fields,
					{OT: coveragePlan});
			case 19:
				var planChange = field.a;
				return _Utils_update(
					fields,
					{kG: planChange});
			case 20:
				var type_ = field.a;
				var planChange = fields.kG;
				var params = planChange.YL;
				return _Utils_update(
					fields,
					{
						kG: $author$project$Components$Plan$Form$PlanChange$clean(
							_Utils_update(
								planChange,
								{
									YL: _Utils_update(
										params,
										{amg: type_})
								}))
					});
			case 21:
				var string = field.a;
				var planChange = fields.kG;
				var params = planChange.YL;
				return _Utils_update(
					fields,
					{
						kG: _Utils_update(
							planChange,
							{
								YL: _Utils_update(
									params,
									{
										Nt: $elm$core$String$toInt(string)
									})
							})
					});
			case 22:
				var date = field.a;
				var planChange = fields.kG;
				var params = planChange.YL;
				return _Utils_update(
					fields,
					{
						kG: _Utils_update(
							planChange,
							{
								YL: _Utils_update(
									params,
									{Nu: date})
							})
					});
			case 23:
				var newPlan = field.a;
				var toPlan = A2(
					$elm$core$Maybe$map,
					function (newPlan_) {
						return {
							ahP: $author$project$Api$Plan$id(newPlan_),
							Bq: $author$project$Api$Plan$name(newPlan_),
							alC: $elm$core$Maybe$Just(
								$author$project$Api$Plan$specialRateNames(newPlan_))
						};
					},
					newPlan);
				var planChange = fields.kG;
				var params = planChange.YL;
				return _Utils_update(
					fields,
					{
						kG: _Utils_update(
							planChange,
							{
								YL: _Utils_update(
									params,
									{adc: toPlan})
							})
					});
			case 24:
				var planChange = fields.kG;
				return _Utils_update(
					fields,
					{
						kG: _Utils_update(
							planChange,
							{cs: true})
					});
			case 25:
				var planChange = fields.kG;
				var newPlanChange = _Utils_eq(planChange.YL.ahP, $elm$core$Maybe$Nothing) ? _Utils_update(
					planChange,
					{cs: false}) : _Utils_update(
					planChange,
					{ud: true});
				return _Utils_update(
					fields,
					{kG: newPlanChange});
			case 26:
				var planChange = fields.kG;
				return _Utils_update(
					fields,
					{
						kG: _Utils_update(
							planChange,
							{ud: false})
					});
			case 27:
				var groupPricingType = (fields.S1 === 'fixed_pricing') ? 'family' : 'fixed_pricing';
				return _Utils_update(
					fields,
					{S1: groupPricingType});
			case 29:
				var bool = field.a;
				return _Utils_update(
					fields,
					{LW: bool});
			case 30:
				var bool = field.a;
				var groupDiscountRulesCalculatedBy = bool ? 'percent_off' : 'amount_off_in_cents';
				return _Utils_update(
					fields,
					{
						SZ: A2(
							$elm$core$List$map,
							function (groupDiscountRule) {
								return _Utils_update(
									groupDiscountRule,
									{M2: groupDiscountRulesCalculatedBy});
							},
							fields.SZ)
					});
			case 28:
				var string = field.a;
				return _Utils_update(
					fields,
					{S1: string});
			case 31:
				return A2(
					$elm$core$Maybe$withDefault,
					fields,
					A2(
						$elm$core$Maybe$map,
						function (_v2) {
							var newGroupDiscountRule = _v2.a;
							var newLastGroupDiscountRule = _v2.b;
							return _Utils_update(
								fields,
								{
									SZ: A2(
										$author$project$Utils$List$prepend,
										_List_fromArray(
											[newGroupDiscountRule]),
										A2(
											$author$project$Utils$List$updateLast,
											function (last) {
												return A2($elm$core$Maybe$withDefault, last, newLastGroupDiscountRule);
											},
											fields.SZ))
								});
						},
						A2(
							$elm$core$Maybe$map,
							function (lastGroupDiscountRule) {
								var lastToSize = (_Utils_cmp(lastGroupDiscountRule.SM + 1, $author$project$Components$Plan$Form$maxGroupFromSize - 1) > 0) ? ($author$project$Components$Plan$Form$maxGroupFromSize - 1) : (lastGroupDiscountRule.SM + 1);
								var newLastGroupDiscountRule_ = _Utils_update(
									lastGroupDiscountRule,
									{
										add: $elm$core$Maybe$Just(lastToSize)
									});
								var _v1 = $author$project$Components$Plan$BasicForm$formFields(fields.ab);
								var defaultPeriod = _v1.P6;
								return _Utils_Tuple2(
									A2($author$project$Components$Plan$Form$GroupDiscountRuleField$startingFrom, defaultPeriod, newLastGroupDiscountRule_),
									$elm$core$Maybe$Just(newLastGroupDiscountRule_));
							},
							$elm_community$list_extra$List$Extra$last(fields.SZ))));
			case 32:
				var index = field.a;
				return _Utils_update(
					fields,
					{
						SZ: $author$project$Components$Plan$Form$exclusiveSizeRanges(
							A2($elm_community$list_extra$List$Extra$removeAt, index, fields.SZ))
					});
			case 33:
				var index = field.a;
				var string = field.b;
				return _Utils_update(
					fields,
					{
						SZ: $author$project$Components$Plan$Form$exclusiveSizeRanges(
							A3(
								$elm_community$list_extra$List$Extra$updateAt,
								index,
								function (groupDiscountRule) {
									return _Utils_update(
										groupDiscountRule,
										{
											SM: A2(
												$elm$core$Maybe$withDefault,
												0,
												$elm$core$String$toInt(string))
										});
								},
								fields.SZ))
					});
			case 34:
				var index = field.a;
				var string = field.b;
				return _Utils_update(
					fields,
					{
						SZ: $author$project$Components$Plan$Form$exclusiveSizeRanges(
							A3(
								$elm_community$list_extra$List$Extra$updateAt,
								index,
								function (groupDiscountRule) {
									return _Utils_update(
										groupDiscountRule,
										{
											add: $elm$core$String$toInt(string)
										});
								},
								fields.SZ))
					});
			case 35:
				var index = field.a;
				var period = field.b;
				var currency = field.c;
				return _Utils_update(
					fields,
					{
						SZ: A3(
							$elm_community$list_extra$List$Extra$updateAt,
							index,
							function (groupDiscountRule) {
								switch (period) {
									case 'month':
										return _Utils_update(
											groupDiscountRule,
											{Xl: currency, Xm: true});
									case 'quarter':
										return _Utils_update(
											groupDiscountRule,
											{_S: currency, _T: true});
									case 'semi_annual':
										return _Utils_update(
											groupDiscountRule,
											{aaL: currency, aaM: true});
									case 'annual':
										return _Utils_update(
											groupDiscountRule,
											{LJ: currency, LK: true});
									default:
										return groupDiscountRule;
								}
							},
							fields.SZ)
					});
			case 36:
				var index = field.a;
				var period = field.b;
				return _Utils_update(
					fields,
					{
						SZ: A3(
							$elm_community$list_extra$List$Extra$updateAt,
							index,
							function (groupDiscountRule) {
								switch (period) {
									case 'month':
										return _Utils_update(
											groupDiscountRule,
											{IC: true});
									case 'quarter':
										return _Utils_update(
											groupDiscountRule,
											{Jq: true});
									case 'semi_annual':
										return _Utils_update(
											groupDiscountRule,
											{JG: true});
									case 'annual':
										return _Utils_update(
											groupDiscountRule,
											{Gs: true});
									default:
										return groupDiscountRule;
								}
							},
							fields.SZ)
					});
			case 37:
				var index = field.a;
				var period = field.b;
				return _Utils_update(
					fields,
					{
						SZ: A3(
							$elm_community$list_extra$List$Extra$updateAt,
							index,
							function (groupDiscountRule) {
								switch (period) {
									case 'month':
										return _Utils_update(
											groupDiscountRule,
											{Xm: false, IC: false});
									case 'quarter':
										return _Utils_update(
											groupDiscountRule,
											{_T: false, Jq: false});
									case 'semi_annual':
										return _Utils_update(
											groupDiscountRule,
											{aaM: false, JG: false});
									case 'annual':
										return _Utils_update(
											groupDiscountRule,
											{LK: false, Gs: false});
									default:
										return groupDiscountRule;
								}
							},
							fields.SZ)
					});
			case 38:
				var index = field.a;
				var period = field.b;
				var percent = field.c;
				return _Utils_update(
					fields,
					{
						SZ: A3(
							$elm_community$list_extra$List$Extra$updateAt,
							index,
							function (groupDiscountRule) {
								switch (period) {
									case 'month':
										return _Utils_update(
											groupDiscountRule,
											{Xs: percent, Xt: true});
									case 'quarter':
										return _Utils_update(
											groupDiscountRule,
											{_Y: percent, _Z: true});
									case 'semi_annual':
										return _Utils_update(
											groupDiscountRule,
											{aaR: percent, aaS: true});
									case 'annual':
										return _Utils_update(
											groupDiscountRule,
											{LP: percent, LQ: true});
									default:
										return groupDiscountRule;
								}
							},
							fields.SZ)
					});
			case 39:
				var index = field.a;
				var period = field.b;
				return _Utils_update(
					fields,
					{
						SZ: A3(
							$elm_community$list_extra$List$Extra$updateAt,
							index,
							function (groupDiscountRule) {
								switch (period) {
									case 'month':
										return _Utils_update(
											groupDiscountRule,
											{oH: true});
									case 'quarter':
										return _Utils_update(
											groupDiscountRule,
											{t7: true});
									case 'semi_annual':
										return _Utils_update(
											groupDiscountRule,
											{uv: true});
									case 'annual':
										return _Utils_update(
											groupDiscountRule,
											{rj: true});
									default:
										return groupDiscountRule;
								}
							},
							fields.SZ)
					});
			case 40:
				var index = field.a;
				var period = field.b;
				return _Utils_update(
					fields,
					{
						SZ: A3(
							$elm_community$list_extra$List$Extra$updateAt,
							index,
							function (groupDiscountRule) {
								switch (period) {
									case 'month':
										return _Utils_update(
											groupDiscountRule,
											{Xt: false, oH: false});
									case 'quarter':
										return _Utils_update(
											groupDiscountRule,
											{_Z: false, t7: false});
									case 'semi_annual':
										return _Utils_update(
											groupDiscountRule,
											{aaS: false, uv: false});
									case 'annual':
										return _Utils_update(
											groupDiscountRule,
											{LQ: false, rj: false});
									default:
										return groupDiscountRule;
								}
							},
							fields.SZ)
					});
			default:
				var pricingEffectivenessType = field.a;
				return _Utils_update(
					fields,
					{_j: pricingEffectivenessType});
		}
	});
var $author$project$Api$Provider$PricingVersion$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Components$Plan$Form$AddCoveragePlanModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Plan$Form$AddCoveragePlanModal$formFieldsInit = {OT: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$CoveragePlan$coveragePlansPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['coverage_plans']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$CoveragePlan$All$CoveragePlan = $elm$core$Basics$identity;
var $author$project$Api$Provider$CoveragePlan$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CoveragePlan$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CoveragePlan$listDefaults = {ahP: $elm$core$Maybe$Nothing, ajJ: $author$project$Api$Pagination$init, akl: $elm$core$Maybe$Nothing, alA: $author$project$Api$Sort$init};
var $author$project$Api$Provider$CoveragePlan$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$CoveragePlan$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.akl;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.ahP;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$Provider$CoveragePlan$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$CoveragePlan$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$CoveragePlan$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$CoveragePlan$coveragePlansPath)));
	});
var $author$project$Components$ResourceFilter$CoveragePlan$list = $author$project$Api$Provider$CoveragePlan$list;
var $author$project$Components$ResourceFilter$CoveragePlan$fetchResources = F4(
	function (toMsg, apiClient, pagination, query) {
		return A3(
			$author$project$Components$ResourceFilter$CoveragePlan$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{ajJ: pagination, akl: query});
			},
			toMsg);
	});
var $author$project$Components$ResourceFilter$CoveragePlan$retrieveResource = F3(
	function (toMsg, apiClient, id) {
		return A3(
			$author$project$Components$ResourceFilter$CoveragePlan$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						ahP: $elm$core$Maybe$Just(id)
					});
			},
			toMsg);
	});
var $author$project$Components$ResourceFilter$CoveragePlan$selectId = 'coverage-plans';
var $author$project$Api$Provider$CoveragePlan$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$CoveragePlan$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CoveragePlan$Shared$name(shared);
};
var $author$project$Components$ResourceFilter$CoveragePlan$toTitle = $author$project$Api$Provider$CoveragePlan$All$name;
var $author$project$Components$ResourceFilter$CoveragePlan$toLabel = function (resource) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Components$ResourceFilter$CoveragePlan$toTitle(resource))
		]);
};
var $author$project$Components$ResourceFilter$CoveragePlan$toValue = $author$project$Api$Provider$CoveragePlan$All$id;
var $author$project$Components$ResourceFilter$CoveragePlan$init = F2(
	function (apiClient, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{Sk: $author$project$Components$ResourceFilter$CoveragePlan$fetchResources, ahP: $author$project$Components$ResourceFilter$CoveragePlan$selectId, k$: 'Coverage Plan', uk: $author$project$Components$ResourceFilter$CoveragePlan$retrieveResource, u9: $author$project$Components$ResourceFilter$CoveragePlan$toLabel, lN: $author$project$Components$ResourceFilter$CoveragePlan$toTitle, hX: $author$project$Components$ResourceFilter$CoveragePlan$toValue},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{Jy: $author$project$Components$ResourceFilter$All, b8: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$Plan$Form$AddCoveragePlanModal$init = F2(
	function (apiClient, id) {
		var _v0 = A2(
			$author$project$Components$ResourceFilter$CoveragePlan$init,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Select a Coverage Plan', ag$: id});
			});
		var coveragePlanResourceFilter = _v0.a;
		var coveragePlanResourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{
				rM: coveragePlanResourceFilter,
				SD: $author$project$Utils$Form$init($author$project$Components$Plan$Form$AddCoveragePlanModal$formFieldsInit),
				ahP: id
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$AddCoveragePlanModal$CoveragePlanResourceFilterMsg, coveragePlanResourceFilterCmd));
	});
var $author$project$Components$Plan$Form$ConfirmUpdateModal$GotPatientsCount = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Plan$SubsequentPlan$encodeUpdateFields = function (fields) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'subsequent_plan',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'change_after_months',
							A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Nt)),
							_Utils_Tuple2(
							'change_on_date',
							A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.Nu)),
							_Utils_Tuple2(
							'to_plan',
							A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.adc))
						])))
			]));
};
var $author$project$Api$Provider$Plan$SubsequentPlan$patientsCountDecoder = A2(
	$elm$json$Json$Decode$field,
	'patients_count',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int));
var $author$project$Api$Provider$Plan$SubsequentPlan$patientsCount = F4(
	function (apiClient, planId, fields, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Plan$SubsequentPlan$patientsCountDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Provider$Plan$SubsequentPlan$encodeUpdateFields(fields),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['patients_count']),
						$author$project$Api$Provider$Plan$SubsequentPlan$subsequentPlansPath(planId)))));
	});
var $author$project$Components$Plan$Form$ConfirmUpdateModal$init = F5(
	function (apiClient, practice, plan, params, planChange) {
		var _v0 = function () {
			if (planChange.cs) {
				var apiFields = {
					Nt: planChange.YL.Nt,
					Nu: planChange.YL.Nu,
					adc: A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.ahP;
						},
						planChange.YL.adc)
				};
				return _Utils_Tuple2(
					$author$project$Api$Data$Loading,
					A4(
						$author$project$Api$Provider$Plan$SubsequentPlan$patientsCount,
						apiClient,
						$author$project$Api$Provider$Plan$One$id(plan),
						apiFields,
						$author$project$Components$Plan$Form$ConfirmUpdateModal$GotPatientsCount));
			} else {
				return _Utils_Tuple2($author$project$Api$Data$NotAsked, $elm$core$Platform$Cmd$none);
			}
		}();
		var patientsCount = _v0.a;
		var patientsCountCmd = _v0.b;
		return _Utils_Tuple2(
			{YL: params, Y2: patientsCount, Jb: plan, kG: planChange, ZV: practice},
			patientsCountCmd);
	});
var $author$project$Utils$Tuple3$mapSecond = F2(
	function (mapFunc, _v0) {
		var first_ = _v0.a;
		var second_ = _v0.b;
		var third_ = _v0.c;
		return _Utils_Tuple3(
			first_,
			mapFunc(second_),
			third_);
	});
var $author$project$Api$FeatureGate$MembershipPricingSchedulePlanChanges = 6;
var $author$project$Components$Plan$Form$CoveragePlanOne = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Plan$One$appliesGroupDiscountInTiers = function (_v0) {
	var record = _v0.b;
	return record.LW;
};
var $author$project$Api$Provider$Plan$One$contractEmailsEnabled = function (_v0) {
	var record = _v0.b;
	return record.OA;
};
var $author$project$Api$Provider$Plan$One$contractExpires = function (_v0) {
	var record = _v0.b;
	return record.OB;
};
var $author$project$Api$Provider$Plan$One$contractPeriodInMonths = function (_v0) {
	var record = _v0.b;
	return record.OC;
};
var $author$project$Api$Provider$Plan$One$contractRenewalEmailLeadTime = function (_v0) {
	var record = _v0.b;
	return record.OD;
};
var $author$project$Api$Provider$Plan$One$contractType = function (_v0) {
	var record = _v0.b;
	return record.G3;
};
var $author$project$Api$Provider$Plan$Shared$coveragePlan = function (_v0) {
	var record = _v0;
	return record.OT;
};
var $author$project$Api$Provider$Plan$One$coveragePlan = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$coveragePlan(shared);
};
var $author$project$Components$Plan$Form$defaultGroupRules = function (defaultPeriod) {
	return _List_fromArray(
		[
			$author$project$Components$Plan$Form$GroupDiscountRuleField$default(defaultPeriod)
		]);
};
var $author$project$Api$Provider$Plan$One$defaultPeriod = function (_v0) {
	var record = _v0.b;
	return record.P6;
};
var $author$project$Api$Provider$Plan$One$discountsEnabled = function (_v0) {
	var record = _v0.b;
	return record.zi;
};
var $author$project$Api$Provider$Plan$Shared$addon = function (_v0) {
	var record = _v0;
	return record.K$;
};
var $author$project$Api$Provider$Plan$One$addon = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$addon(shared);
};
var $author$project$Api$Provider$SponsorFeeDeal$Shared$amountInCents = function (_v0) {
	var record = _v0;
	return record.LE;
};
var $author$project$Api$Provider$Plan$One$annualAdjustmentPercent = function (_v0) {
	var record = _v0.b;
	return record.xk;
};
var $author$project$Api$Provider$Plan$One$annualAllowed = function (_v0) {
	var record = _v0.b;
	return record.xl;
};
var $author$project$Api$Provider$Plan$Shared$billsAtEndOfPeriod = function (_v0) {
	var record = _v0;
	return record.MI;
};
var $author$project$Api$Provider$Plan$One$billsAtEndOfPeriod = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$billsAtEndOfPeriod(shared);
};
var $author$project$Api$Provider$Plan$One$buyable = function (_v0) {
	var record = _v0.b;
	return record.MZ;
};
var $author$project$Api$Provider$Plan$One$defaultChargeDescription = function (_v0) {
	var record = _v0.b;
	return record.y6;
};
var $author$project$Api$Provider$Plan$One$defaultChargeName = function (_v0) {
	var record = _v0.b;
	return record.y7;
};
var $author$project$Api$Provider$Plan$One$descriptions = function (_v0) {
	var record = _v0.b;
	return record.Hs;
};
var $author$project$Api$Provider$PricingVersion$Shared$individualRegistrationFeeInCents = function (_v0) {
	var record = _v0;
	return record.TZ;
};
var $author$project$Api$Provider$PricingVersion$One$individualRegistrationFeeInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$individualRegistrationFeeInCents(shared);
};
var $author$project$Api$Provider$Plan$Meta$individualRegistrationFeeInCentsRuleEnabled = function (_v0) {
	var meta = _v0;
	return meta.aak.TZ.Ro;
};
var $author$project$Api$Provider$PricingVersion$Shared$maxRegistrationFeeInCents = function (_v0) {
	var record = _v0;
	return record.WC;
};
var $author$project$Api$Provider$PricingVersion$One$maxRegistrationFeeInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$maxRegistrationFeeInCents(shared);
};
var $author$project$Api$Provider$Plan$Meta$maxRegistrationFeeInCentsRuleEnabled = function (_v0) {
	var meta = _v0;
	return meta.aak.WC.Ro;
};
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$initRules = F2(
	function (meta, maybePricingVersion) {
		if (!maybePricingVersion.$) {
			var pv = maybePricingVersion.a;
			return {
				TZ: {
					Ro: !_Utils_eq(
						$author$project$Api$Provider$PricingVersion$One$individualRegistrationFeeInCents(pv),
						$elm$core$Maybe$Nothing)
				},
				WC: {
					Ro: !_Utils_eq(
						$author$project$Api$Provider$PricingVersion$One$maxRegistrationFeeInCents(pv),
						$elm$core$Maybe$Nothing)
				}
			};
		} else {
			return {
				TZ: {
					Ro: $author$project$Api$Provider$Plan$Meta$individualRegistrationFeeInCentsRuleEnabled(meta)
				},
				WC: {
					Ro: $author$project$Api$Provider$Plan$Meta$maxRegistrationFeeInCentsRuleEnabled(meta)
				}
			};
		}
	});
var $author$project$Api$Provider$Plan$One$individualRegistrationFeeInCents = function (_v0) {
	var record = _v0.b;
	return record.TZ;
};
var $author$project$Api$Provider$Plan$One$maxRegistrationFeeInCents = function (_v0) {
	var record = _v0.b;
	return record.WC;
};
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$registrationFees = F2(
	function (plan, maybePricingVersion) {
		if (!maybePricingVersion.$) {
			var pv = maybePricingVersion.a;
			return {
				z9: A2(
					$elm$core$Maybe$map,
					$author$project$Currency$fromInt,
					$author$project$Api$Provider$PricingVersion$One$individualRegistrationFeeInCents(pv)),
				AU: A2(
					$elm$core$Maybe$map,
					$author$project$Currency$fromInt,
					$author$project$Api$Provider$PricingVersion$One$maxRegistrationFeeInCents(pv))
			};
		} else {
			return {
				z9: A2(
					$elm$core$Maybe$map,
					$author$project$Currency$fromInt,
					$author$project$Api$Provider$Plan$One$individualRegistrationFeeInCents(plan)),
				AU: A2(
					$elm$core$Maybe$map,
					$author$project$Currency$fromInt,
					$author$project$Api$Provider$Plan$One$maxRegistrationFeeInCents(plan))
			};
		}
	});
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$fill = F2(
	function (plan, maybePricingVersion) {
		var fees = A2($author$project$Components$Plan$Form$RegistrationFeePricingFields$registrationFees, plan, maybePricingVersion);
		return $author$project$Utils$Form$init(
			{
				c8: $elm$core$Maybe$Nothing,
				TZ: fees.z9,
				WC: fees.AU,
				aak: A2(
					$author$project$Components$Plan$Form$RegistrationFeePricingFields$initRules,
					$author$project$Api$Provider$Plan$One$meta(plan),
					maybePricingVersion)
			});
	});
var $author$project$Api$Provider$Category$Min$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Plan$One$registrationFeeCategory = function (_v0) {
	var record = _v0.b;
	return record.$o;
};
var $author$project$Api$Provider$PricingVersion$Shared$registrationFeeCategoryId = function (_v0) {
	var record = _v0;
	return record.DL;
};
var $author$project$Api$Provider$PricingVersion$One$registrationFeeCategoryId = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$registrationFeeCategoryId(shared);
};
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$fillAsync = F4(
	function (plan, maybePricingVersion, apiClient, session) {
		var meta = $author$project$Api$Provider$Plan$One$meta(plan);
		var fees = A2($author$project$Components$Plan$Form$RegistrationFeePricingFields$registrationFees, plan, maybePricingVersion);
		var categoryId = function () {
			if (!maybePricingVersion.$) {
				var pv = maybePricingVersion.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Maybe$withDefault,
						'',
						$author$project$Api$Provider$PricingVersion$One$registrationFeeCategoryId(pv)));
			} else {
				return A2(
					$elm$core$Maybe$map,
					$author$project$Api$Provider$Category$Min$id,
					$author$project$Api$Provider$Plan$One$registrationFeeCategory(plan));
			}
		}();
		var _v0 = A3(
			$author$project$Components$ResourceFilter$Category$init,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{
						Lr: false,
						XY: 'Unassigned',
						ai5: true,
						ai6: $elm$core$Maybe$Just('')
					});
			});
		var categoryResourceFilter = _v0.a;
		var categoryResourceFilterInitCmd = _v0.b;
		var _v1 = A2($author$project$Components$ResourceFilter$Category$preSelectedId, categoryId, categoryResourceFilter);
		var categoryResourceFilterWithPreselected = _v1.a;
		var categoryResourceFilterCmd = _v1.b;
		return _Utils_Tuple2(
			$author$project$Utils$Form$init(
				{
					c8: $elm$core$Maybe$Just(categoryResourceFilterWithPreselected),
					TZ: fees.z9,
					WC: fees.AU,
					aak: A2($author$project$Components$Plan$Form$RegistrationFeePricingFields$initRules, meta, maybePricingVersion)
				}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$RegistrationFeePricingFields$CategoryResourceFilterMsg, categoryResourceFilterInitCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$RegistrationFeePricingFields$CategoryResourceFilterMsg, categoryResourceFilterCmd)
					])));
	});
var $author$project$Percentage$Percentage = $elm$core$Basics$identity;
var $author$project$Percentage$fromFloat = function (_float) {
	return $elm$core$String$fromFloat(_float);
};
var $author$project$Api$Provider$Plan$One$imageUrl = function (_v0) {
	var record = _v0.b;
	return record.TP;
};
var $author$project$Api$Provider$Plan$Meta$minimumEnrollmentPeriodInMonthsRuleEnabled = function (_v0) {
	var meta = _v0;
	return meta.aak.Xf.Ro;
};
var $author$project$Components$Plan$BasicForm$initRules = function (meta) {
	return {
		Xf: {
			Ro: $author$project$Api$Provider$Plan$Meta$minimumEnrollmentPeriodInMonthsRuleEnabled(meta)
		}
	};
};
var $author$project$Api$Provider$Plan$Shared$minimumEnrollmentPeriodInMonths = function (_v0) {
	var record = _v0;
	return record.Xf;
};
var $author$project$Api$Provider$Plan$One$minimumEnrollmentPeriodInMonths = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$minimumEnrollmentPeriodInMonths(shared);
};
var $author$project$Api$Provider$Plan$One$monthAdjustmentPercent = function (_v0) {
	var record = _v0.b;
	return record.Bi;
};
var $author$project$Api$Provider$Plan$One$monthAllowed = function (_v0) {
	var record = _v0.b;
	return record.Bj;
};
var $author$project$Api$Provider$Category$Min$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$Plan$One$quarterAdjustmentPercent = function (_v0) {
	var record = _v0.b;
	return record.DB;
};
var $author$project$Api$Provider$Plan$One$quarterAllowed = function (_v0) {
	var record = _v0.b;
	return record.DC;
};
var $author$project$Api$Provider$Plan$One$registrationFeeDescription = function (_v0) {
	var record = _v0.b;
	return record.DM;
};
var $author$project$Api$Provider$PricingVersion$Shared$registrationFeeDescription = function (_v0) {
	var record = _v0;
	return record.DM;
};
var $author$project$Api$Provider$PricingVersion$One$registrationFeeDescription = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$registrationFeeDescription(shared);
};
var $author$project$Api$Provider$Plan$One$registrationFeeName = function (_v0) {
	var record = _v0.b;
	return record.DN;
};
var $author$project$Api$Provider$PricingVersion$Shared$registrationFeeName = function (_v0) {
	var record = _v0;
	return record.DN;
};
var $author$project$Api$Provider$PricingVersion$One$registrationFeeName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$registrationFeeName(shared);
};
var $author$project$Api$Provider$Plan$One$semiAnnualAdjustmentPercent = function (_v0) {
	var record = _v0.b;
	return record.Es;
};
var $author$project$Api$Provider$Plan$One$semiAnnualAllowed = function (_v0) {
	var record = _v0.b;
	return record.Et;
};
var $author$project$Api$Provider$Plan$Shared$sponsorFeeDeal = function (_v0) {
	var record = _v0;
	return record.abZ;
};
var $author$project$Api$Provider$Plan$One$sponsorFeeDeal = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$sponsorFeeDeal(shared);
};
var $author$project$Components$Plan$BasicForm$fill = F6(
	function (practice, plan, practiceIsOnboarding, isViewingAsHinter, maybeApiContext, maybePricingVersion) {
		var settings = {Aq: isViewingAsHinter, ZV: practice, ZX: practiceIsOnboarding};
		var _v0 = function () {
			if (!maybeApiContext.$) {
				var _v2 = maybeApiContext.a;
				var apiClient = _v2.a;
				var session = _v2.b;
				return A4($author$project$Components$Plan$Form$RegistrationFeePricingFields$fillAsync, plan, maybePricingVersion, apiClient, session);
			} else {
				return _Utils_Tuple2(
					A2($author$project$Components$Plan$Form$RegistrationFeePricingFields$fill, plan, maybePricingVersion),
					$elm$core$Platform$Cmd$none);
			}
		}();
		var registrationFeePricingForm = _v0.a;
		var regCmd = _v0.b;
		return _Utils_Tuple2(
			A2(
				$author$project$Components$Plan$BasicForm$BasicPlanForm,
				settings,
				$author$project$Utils$Form$init(
					{
						K$: $author$project$Api$Provider$Plan$One$addon(plan),
						xk: $elm$core$Maybe$Just(
							$author$project$Percentage$fromFloat(
								$author$project$Api$Provider$Plan$One$annualAdjustmentPercent(plan))),
						xl: $author$project$Api$Provider$Plan$One$annualAllowed(plan),
						MI: $author$project$Api$Provider$Plan$One$billsAtEndOfPeriod(plan),
						MZ: $author$project$Api$Provider$Plan$One$buyable(plan),
						rQ: $author$project$Api$Provider$Plan$One$imageUrl(plan),
						y6: A2(
							$elm$core$Maybe$andThen,
							$author$project$Utils$String$toMaybe,
							$author$project$Api$Provider$Plan$One$defaultChargeDescription(plan)),
						y7: $author$project$Api$Provider$Plan$One$defaultChargeName(plan),
						P6: $author$project$Api$Provider$Plan$One$defaultPeriod(plan),
						Qr: A2(
							$author$project$Components$TranslatedRichText$init,
							$author$project$Api$Provider$Plan$One$descriptions(plan),
							'plan-description-language-dropdown'),
						r6: false,
						jB: false,
						nr: false,
						nW: 0,
						TP: $elm$core$Maybe$Nothing,
						Xf: $author$project$Api$Provider$Plan$One$minimumEnrollmentPeriodInMonths(plan),
						Bi: $elm$core$Maybe$Just(
							$author$project$Percentage$fromFloat(
								$author$project$Api$Provider$Plan$One$monthAdjustmentPercent(plan))),
						Bj: $author$project$Api$Provider$Plan$One$monthAllowed(plan),
						Bq: $author$project$Api$Provider$Plan$One$name(plan),
						DB: $elm$core$Maybe$Just(
							$author$project$Percentage$fromFloat(
								$author$project$Api$Provider$Plan$One$quarterAdjustmentPercent(plan))),
						DC: $author$project$Api$Provider$Plan$One$quarterAllowed(plan),
						DL: A2(
							$elm$core$Maybe$map,
							$author$project$Api$Provider$Category$Min$id,
							$author$project$Api$Provider$Plan$One$registrationFeeCategory(plan)),
						ub: A2(
							$elm$core$Maybe$withDefault,
							'Unassigned',
							A2(
								$elm$core$Maybe$map,
								$author$project$Api$Provider$Category$Min$name,
								$author$project$Api$Provider$Plan$One$registrationFeeCategory(plan))),
						DM: function () {
							if (!maybePricingVersion.$) {
								var pv = maybePricingVersion.a;
								return A2(
									$elm$core$Maybe$withDefault,
									'',
									$author$project$Api$Provider$PricingVersion$One$registrationFeeDescription(pv));
							} else {
								return $author$project$Api$Provider$Plan$One$registrationFeeDescription(plan);
							}
						}(),
						DN: A2(
							$elm$core$Maybe$withDefault,
							$author$project$Api$Provider$Plan$One$registrationFeeName(plan),
							A2($elm$core$Maybe$map, $author$project$Api$Provider$PricingVersion$One$registrationFeeName, maybePricingVersion)),
						dH: registrationFeePricingForm,
						aak: $author$project$Components$Plan$BasicForm$initRules(
							$author$project$Api$Provider$Plan$One$meta(plan)),
						Es: $elm$core$Maybe$Just(
							$author$project$Percentage$fromFloat(
								$author$project$Api$Provider$Plan$One$semiAnnualAdjustmentPercent(plan))),
						Et: $author$project$Api$Provider$Plan$One$semiAnnualAllowed(plan),
						JS: A2(
							$elm$core$Maybe$map,
							$author$project$Currency$fromInt,
							A2(
								$elm$core$Maybe$map,
								$author$project$Api$Provider$SponsorFeeDeal$Shared$amountInCents,
								$author$project$Api$Provider$Plan$One$sponsorFeeDeal(plan)))
					})),
			A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$BasicForm$RegistrationFeePricingFieldsMsg, regCmd));
	});
var $author$project$Api$Provider$Plan$One$childrenAgeLimit = function (_v0) {
	var record = _v0.b;
	return record.x2;
};
var $author$project$Api$Provider$PricingVersion$Shared$childrenAgeLimit = function (_v0) {
	var record = _v0;
	return record.x2;
};
var $author$project$Api$Provider$PricingVersion$One$childrenAgeLimit = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$childrenAgeLimit(shared);
};
var $author$project$Api$Provider$Plan$One$familyNumChildrenIncluded = function (_v0) {
	var record = _v0.b;
	return record.zC;
};
var $author$project$Api$Provider$PricingVersion$Shared$familyNumChildrenIncluded = function (_v0) {
	var record = _v0;
	return record.zC;
};
var $author$project$Api$Provider$PricingVersion$One$familyNumChildrenIncluded = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$familyNumChildrenIncluded(shared);
};
var $author$project$Api$Provider$Plan$Shared$additionalAdultDiscountRule = function (_v0) {
	var record = _v0;
	return record.vB;
};
var $author$project$Api$Provider$Plan$One$additionalAdultDiscountRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$additionalAdultDiscountRule(shared);
};
var $author$project$Api$Provider$Plan$Shared$additionalChildDiscountRule = function (_v0) {
	var record = _v0;
	return record.vC;
};
var $author$project$Api$Provider$Plan$One$additionalChildDiscountRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$additionalChildDiscountRule(shared);
};
var $author$project$Api$Provider$DiscountRule$Shared$annualMaximumInCents = function (_v0) {
	var record = _v0;
	return record.LL;
};
var $author$project$Api$Provider$DiscountRule$Shared$annualMaximumInCentsEdited = function (_v0) {
	var record = _v0;
	return record.LM;
};
var $author$project$Api$Provider$Plan$Shared$childrenOnlyDiscountRule = function (_v0) {
	var record = _v0;
	return record.x3;
};
var $author$project$Api$Provider$Plan$One$childrenOnlyDiscountRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$childrenOnlyDiscountRule(shared);
};
var $author$project$Api$Provider$Plan$Shared$coupleDiscountRule = function (_v0) {
	var record = _v0;
	return record.yS;
};
var $author$project$Api$Provider$Plan$One$coupleDiscountRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$coupleDiscountRule(shared);
};
var $author$project$Components$Plan$Form$FamilyDiscountRuleField$empty = function (type_) {
	return {LL: $elm$core$Maybe$Nothing, LM: false, xm: false, Xn: $elm$core$Maybe$Nothing, Xo: false, Bl: false, _U: $elm$core$Maybe$Nothing, _V: false, DD: false, aaN: $elm$core$Maybe$Nothing, aaO: false, Eu: false, amg: type_};
};
var $author$project$Api$Provider$Plan$Shared$familyDiscountRule = function (_v0) {
	var record = _v0;
	return record.zB;
};
var $author$project$Api$Provider$Plan$One$familyDiscountRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$familyDiscountRule(shared);
};
var $author$project$Api$Provider$DiscountRule$Shared$monthMaximumInCents = function (_v0) {
	var record = _v0;
	return record.Xn;
};
var $author$project$Api$Provider$DiscountRule$Shared$monthMaximumInCentsEdited = function (_v0) {
	var record = _v0;
	return record.Xo;
};
var $author$project$Api$Provider$DiscountRule$Shared$quarterMaximumInCents = function (_v0) {
	var record = _v0;
	return record._U;
};
var $author$project$Api$Provider$DiscountRule$Shared$quarterMaximumInCentsEdited = function (_v0) {
	var record = _v0;
	return record._V;
};
var $author$project$Api$Provider$DiscountRule$Shared$semiAnnualMaximumInCents = function (_v0) {
	var record = _v0;
	return record.aaN;
};
var $author$project$Api$Provider$DiscountRule$Shared$semiAnnualMaximumInCentsEdited = function (_v0) {
	var record = _v0;
	return record.aaO;
};
var $author$project$Api$Provider$Plan$Shared$singleParentDiscountRule = function (_v0) {
	var record = _v0;
	return record.EG;
};
var $author$project$Api$Provider$Plan$One$singleParentDiscountRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$singleParentDiscountRule(shared);
};
var $author$project$Components$Plan$Form$FamilyDiscountRuleField$initFromServer = F3(
	function (type_, defaultIfMissing, maybePlan) {
		return function (_v1) {
			var discountRule = _v1.a;
			var defaultIfMissing_ = _v1.b;
			var _v2 = _Utils_Tuple2(discountRule, defaultIfMissing_);
			if (!_v2.a.$) {
				var discountRule_ = _v2.a.a;
				return $elm$core$Maybe$Just(
					{
						LL: A2(
							$elm$core$Maybe$map,
							$author$project$Currency$fromInt,
							$author$project$Api$Provider$DiscountRule$Shared$annualMaximumInCents(discountRule_)),
						LM: $author$project$Api$Provider$DiscountRule$Shared$annualMaximumInCentsEdited(discountRule_),
						xm: false,
						Xn: A2(
							$elm$core$Maybe$map,
							$author$project$Currency$fromInt,
							$author$project$Api$Provider$DiscountRule$Shared$monthMaximumInCents(discountRule_)),
						Xo: $author$project$Api$Provider$DiscountRule$Shared$monthMaximumInCentsEdited(discountRule_),
						Bl: false,
						_U: A2(
							$elm$core$Maybe$map,
							$author$project$Currency$fromInt,
							$author$project$Api$Provider$DiscountRule$Shared$quarterMaximumInCents(discountRule_)),
						_V: $author$project$Api$Provider$DiscountRule$Shared$quarterMaximumInCentsEdited(discountRule_),
						DD: false,
						aaN: A2(
							$elm$core$Maybe$map,
							$author$project$Currency$fromInt,
							$author$project$Api$Provider$DiscountRule$Shared$semiAnnualMaximumInCents(discountRule_)),
						aaO: $author$project$Api$Provider$DiscountRule$Shared$semiAnnualMaximumInCentsEdited(discountRule_),
						Eu: false,
						amg: type_
					});
			} else {
				if (_v2.b) {
					var _v3 = _v2.a;
					return $elm$core$Maybe$Just(
						$author$project$Components$Plan$Form$FamilyDiscountRuleField$empty(type_));
				} else {
					var _v4 = _v2.a;
					return $elm$core$Maybe$Nothing;
				}
			}
		}(
			function () {
				switch (type_) {
					case 0:
						return _Utils_Tuple2(
							A2($elm$core$Maybe$andThen, $author$project$Api$Provider$Plan$One$coupleDiscountRule, maybePlan),
							defaultIfMissing);
					case 1:
						return _Utils_Tuple2(
							A2($elm$core$Maybe$andThen, $author$project$Api$Provider$Plan$One$singleParentDiscountRule, maybePlan),
							defaultIfMissing);
					case 2:
						return _Utils_Tuple2(
							A2($elm$core$Maybe$andThen, $author$project$Api$Provider$Plan$One$familyDiscountRule, maybePlan),
							defaultIfMissing);
					case 3:
						return _Utils_Tuple2(
							A2($elm$core$Maybe$andThen, $author$project$Api$Provider$Plan$One$additionalAdultDiscountRule, maybePlan),
							defaultIfMissing);
					case 4:
						return _Utils_Tuple2(
							A2($elm$core$Maybe$andThen, $author$project$Api$Provider$Plan$One$additionalChildDiscountRule, maybePlan),
							defaultIfMissing);
					default:
						return _Utils_Tuple2(
							A2($elm$core$Maybe$andThen, $author$project$Api$Provider$Plan$One$childrenOnlyDiscountRule, maybePlan),
							defaultIfMissing);
				}
			}());
	});
var $author$project$Api$Provider$PricingVersion$Shared$additionalAdultDiscountRule = function (_v0) {
	var record = _v0;
	return record.vB;
};
var $author$project$Api$Provider$PricingVersion$One$additionalAdultDiscountRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$additionalAdultDiscountRule(shared);
};
var $author$project$Api$Provider$PricingVersion$Shared$additionalChildDiscountRule = function (_v0) {
	var record = _v0;
	return record.vC;
};
var $author$project$Api$Provider$PricingVersion$One$additionalChildDiscountRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$additionalChildDiscountRule(shared);
};
var $author$project$Api$Provider$PricingVersion$Shared$childrenOnlyDiscountRule = function (_v0) {
	var record = _v0;
	return record.x3;
};
var $author$project$Api$Provider$PricingVersion$One$childrenOnlyDiscountRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$childrenOnlyDiscountRule(shared);
};
var $author$project$Api$Provider$PricingVersion$Shared$coupleDiscountRule = function (_v0) {
	var record = _v0;
	return record.yS;
};
var $author$project$Api$Provider$PricingVersion$One$coupleDiscountRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$coupleDiscountRule(shared);
};
var $author$project$Api$Provider$PricingVersion$Shared$familyDiscountRule = function (_v0) {
	var record = _v0;
	return record.zB;
};
var $author$project$Api$Provider$PricingVersion$One$familyDiscountRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$familyDiscountRule(shared);
};
var $author$project$Api$Provider$PricingVersion$Shared$singleParentDiscountRule = function (_v0) {
	var record = _v0;
	return record.EG;
};
var $author$project$Api$Provider$PricingVersion$One$singleParentDiscountRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$singleParentDiscountRule(shared);
};
var $author$project$Components$Plan$Form$FamilyDiscountRuleField$initFromServerAndPricingVersion = F3(
	function (type_, defaultIfMissing, pricingVersion) {
		return function (_v1) {
			var discountRule = _v1.a;
			var defaultIfMissing_ = _v1.b;
			var _v2 = _Utils_Tuple2(discountRule, defaultIfMissing_);
			if (!_v2.a.$) {
				var discountRule_ = _v2.a.a;
				return $elm$core$Maybe$Just(
					{
						LL: A2(
							$elm$core$Maybe$map,
							$author$project$Currency$fromInt,
							$author$project$Api$Provider$DiscountRule$Shared$annualMaximumInCents(discountRule_)),
						LM: $author$project$Api$Provider$DiscountRule$Shared$annualMaximumInCentsEdited(discountRule_),
						xm: false,
						Xn: A2(
							$elm$core$Maybe$map,
							$author$project$Currency$fromInt,
							$author$project$Api$Provider$DiscountRule$Shared$monthMaximumInCents(discountRule_)),
						Xo: $author$project$Api$Provider$DiscountRule$Shared$monthMaximumInCentsEdited(discountRule_),
						Bl: false,
						_U: A2(
							$elm$core$Maybe$map,
							$author$project$Currency$fromInt,
							$author$project$Api$Provider$DiscountRule$Shared$quarterMaximumInCents(discountRule_)),
						_V: $author$project$Api$Provider$DiscountRule$Shared$quarterMaximumInCentsEdited(discountRule_),
						DD: false,
						aaN: A2(
							$elm$core$Maybe$map,
							$author$project$Currency$fromInt,
							$author$project$Api$Provider$DiscountRule$Shared$semiAnnualMaximumInCents(discountRule_)),
						aaO: $author$project$Api$Provider$DiscountRule$Shared$semiAnnualMaximumInCentsEdited(discountRule_),
						Eu: false,
						amg: type_
					});
			} else {
				if (_v2.b) {
					var _v3 = _v2.a;
					return $elm$core$Maybe$Just(
						$author$project$Components$Plan$Form$FamilyDiscountRuleField$empty(type_));
				} else {
					var _v4 = _v2.a;
					return $elm$core$Maybe$Nothing;
				}
			}
		}(
			function () {
				switch (type_) {
					case 0:
						return _Utils_Tuple2(
							$author$project$Api$Provider$PricingVersion$One$coupleDiscountRule(pricingVersion),
							defaultIfMissing);
					case 1:
						return _Utils_Tuple2(
							$author$project$Api$Provider$PricingVersion$One$singleParentDiscountRule(pricingVersion),
							defaultIfMissing);
					case 2:
						return _Utils_Tuple2(
							$author$project$Api$Provider$PricingVersion$One$familyDiscountRule(pricingVersion),
							defaultIfMissing);
					case 3:
						return _Utils_Tuple2(
							$author$project$Api$Provider$PricingVersion$One$additionalAdultDiscountRule(pricingVersion),
							defaultIfMissing);
					case 4:
						return _Utils_Tuple2(
							$author$project$Api$Provider$PricingVersion$One$additionalChildDiscountRule(pricingVersion),
							defaultIfMissing);
					default:
						return _Utils_Tuple2(
							$author$project$Api$Provider$PricingVersion$One$childrenOnlyDiscountRule(pricingVersion),
							defaultIfMissing);
				}
			}());
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$getDiscountRule = F3(
	function (maybePricingVersion, discountRuleType, plan) {
		if (!maybePricingVersion.$) {
			var pricingVersion = maybePricingVersion.a;
			return A3($author$project$Components$Plan$Form$FamilyDiscountRuleField$initFromServerAndPricingVersion, discountRuleType, false, pricingVersion);
		} else {
			return A3(
				$author$project$Components$Plan$Form$FamilyDiscountRuleField$initFromServer,
				discountRuleType,
				false,
				$elm$core$Maybe$Just(plan));
		}
	});
var $author$project$Api$Provider$Plan$Meta$additionalAdultDiscountRuleRuleEnabled = function (_v0) {
	var meta = _v0;
	return meta.aak.vB.Ro;
};
var $author$project$Api$Provider$Plan$Meta$additionalChildDiscountRuleRuleEnabled = function (_v0) {
	var meta = _v0;
	return meta.aak.vC.Ro;
};
var $author$project$Api$Provider$Plan$Meta$childrenAgeLimitRuleEnabled = function (_v0) {
	var meta = _v0;
	return meta.aak.x2.Ro;
};
var $author$project$Api$Provider$Plan$Meta$childrenOnlyDiscountRuleRuleEnabled = function (_v0) {
	var meta = _v0;
	return meta.aak.x3.Ro;
};
var $author$project$Api$Provider$Plan$Meta$coupleDiscountRuleRuleEnabled = function (_v0) {
	var meta = _v0;
	return meta.aak.yS.Ro;
};
var $author$project$Api$Provider$Plan$Meta$familyDiscountRuleRuleEnabled = function (_v0) {
	var meta = _v0;
	return meta.aak.zB.Ro;
};
var $author$project$Api$Provider$Plan$Meta$familyNumChildrenIncludedRuleEnabled = function (_v0) {
	var meta = _v0;
	return meta.aak.zC.Ro;
};
var $author$project$Api$Provider$PricingVersion$Shared$numberAdditionalChildrenAllowed = function (_v0) {
	var record = _v0;
	return record.BR;
};
var $author$project$Api$Provider$PricingVersion$One$numberAdditionalChildrenAllowed = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$numberAdditionalChildrenAllowed(shared);
};
var $author$project$Api$Provider$Plan$Meta$numberAdditionalChildrenAllowedRuleEnabled = function (_v0) {
	var meta = _v0;
	return meta.aak.BR.Ro;
};
var $author$project$Api$Provider$Plan$Meta$singleParentDiscountRuleRuleEnabled = function (_v0) {
	var meta = _v0;
	return meta.aak.EG.Ro;
};
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$initRules = F2(
	function (meta, maybePricingVersion) {
		var pricingVersionHas = function (accessor) {
			if (!maybePricingVersion.$) {
				var pv = maybePricingVersion.a;
				var _v2 = accessor(pv);
				if (!_v2.$) {
					return true;
				} else {
					return false;
				}
			} else {
				return false;
			}
		};
		if (!maybePricingVersion.$) {
			return {
				vB: {
					Ro: pricingVersionHas($author$project$Api$Provider$PricingVersion$One$additionalAdultDiscountRule)
				},
				vC: {
					Ro: pricingVersionHas($author$project$Api$Provider$PricingVersion$One$additionalChildDiscountRule)
				},
				x2: {
					Ro: pricingVersionHas($author$project$Api$Provider$PricingVersion$One$childrenAgeLimit)
				},
				x3: {
					Ro: pricingVersionHas($author$project$Api$Provider$PricingVersion$One$childrenOnlyDiscountRule)
				},
				yS: {
					Ro: pricingVersionHas($author$project$Api$Provider$PricingVersion$One$coupleDiscountRule)
				},
				zB: {
					Ro: pricingVersionHas($author$project$Api$Provider$PricingVersion$One$familyDiscountRule)
				},
				zC: {
					Ro: pricingVersionHas($author$project$Api$Provider$PricingVersion$One$familyNumChildrenIncluded)
				},
				BR: {
					Ro: pricingVersionHas($author$project$Api$Provider$PricingVersion$One$numberAdditionalChildrenAllowed)
				},
				EG: {
					Ro: pricingVersionHas($author$project$Api$Provider$PricingVersion$One$singleParentDiscountRule)
				}
			};
		} else {
			return {
				vB: {
					Ro: $author$project$Api$Provider$Plan$Meta$additionalAdultDiscountRuleRuleEnabled(meta)
				},
				vC: {
					Ro: $author$project$Api$Provider$Plan$Meta$additionalChildDiscountRuleRuleEnabled(meta)
				},
				x2: {
					Ro: $author$project$Api$Provider$Plan$Meta$childrenAgeLimitRuleEnabled(meta)
				},
				x3: {
					Ro: $author$project$Api$Provider$Plan$Meta$childrenOnlyDiscountRuleRuleEnabled(meta)
				},
				yS: {
					Ro: $author$project$Api$Provider$Plan$Meta$coupleDiscountRuleRuleEnabled(meta)
				},
				zB: {
					Ro: $author$project$Api$Provider$Plan$Meta$familyDiscountRuleRuleEnabled(meta)
				},
				zC: {
					Ro: $author$project$Api$Provider$Plan$Meta$familyNumChildrenIncludedRuleEnabled(meta)
				},
				BR: {
					Ro: $author$project$Api$Provider$Plan$Meta$numberAdditionalChildrenAllowedRuleEnabled(meta)
				},
				EG: {
					Ro: $author$project$Api$Provider$Plan$Meta$singleParentDiscountRuleRuleEnabled(meta)
				}
			};
		}
	});
var $author$project$Api$Provider$Plan$One$numberAdditionalChildrenAllowed = function (_v0) {
	var record = _v0.b;
	return record.BR;
};
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$resolveIntField = F3(
	function (maybePricingVersion, pricingVersionGetter, planValue) {
		if (!maybePricingVersion.$) {
			var pricingVersion = maybePricingVersion.a;
			return pricingVersionGetter(pricingVersion);
		} else {
			return planValue;
		}
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$fill = F2(
	function (plan, maybePricingVersion) {
		var singleParentDiscountRule = A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$getDiscountRule, maybePricingVersion, 1, plan);
		var numberAdditionalChildrenAllowed = A3(
			$author$project$Components$Plan$Form$FamilyMembershipPricingFields$resolveIntField,
			maybePricingVersion,
			$author$project$Api$Provider$PricingVersion$One$numberAdditionalChildrenAllowed,
			$author$project$Api$Provider$Plan$One$numberAdditionalChildrenAllowed(plan));
		var familyNumChildrenIncluded = A3(
			$author$project$Components$Plan$Form$FamilyMembershipPricingFields$resolveIntField,
			maybePricingVersion,
			$author$project$Api$Provider$PricingVersion$One$familyNumChildrenIncluded,
			$author$project$Api$Provider$Plan$One$familyNumChildrenIncluded(plan));
		var familyDiscountRule = A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$getDiscountRule, maybePricingVersion, 2, plan);
		var coupleDiscountRule = A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$getDiscountRule, maybePricingVersion, 0, plan);
		var childrenOnlyDiscountRule = A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$getDiscountRule, maybePricingVersion, 5, plan);
		var childrenAgeLimit = A3(
			$author$project$Components$Plan$Form$FamilyMembershipPricingFields$resolveIntField,
			maybePricingVersion,
			$author$project$Api$Provider$PricingVersion$One$childrenAgeLimit,
			$author$project$Api$Provider$Plan$One$childrenAgeLimit(plan));
		var additionalChildDiscountRule = A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$getDiscountRule, maybePricingVersion, 4, plan);
		var additionalAdultDiscountRule = A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$getDiscountRule, maybePricingVersion, 3, plan);
		return $author$project$Utils$Form$init(
			{
				vB: additionalAdultDiscountRule,
				vC: additionalChildDiscountRule,
				x2: childrenAgeLimit,
				x3: childrenOnlyDiscountRule,
				yS: coupleDiscountRule,
				zB: familyDiscountRule,
				zC: familyNumChildrenIncluded,
				BR: numberAdditionalChildrenAllowed,
				aak: A2(
					$author$project$Components$Plan$Form$FamilyMembershipPricingFields$initRules,
					$author$project$Api$Provider$Plan$One$meta(plan),
					maybePricingVersion),
				EG: singleParentDiscountRule
			});
	});
var $author$project$Api$Provider$PricingVersion$Shared$appliesGroupDiscountInTiers = function (_v0) {
	var record = _v0;
	return record.LW;
};
var $author$project$Api$Provider$PricingVersion$One$appliesGroupDiscountInTiers = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$appliesGroupDiscountInTiers(shared);
};
var $author$project$Api$Provider$Plan$One$familyNumAdultsIncluded = function (_v0) {
	var record = _v0.b;
	return record.R8;
};
var $author$project$Api$Provider$PricingVersion$Shared$familyNumAdultsIncluded = function (_v0) {
	var record = _v0;
	return record.R8;
};
var $author$project$Api$Provider$PricingVersion$One$familyNumAdultsIncluded = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$familyNumAdultsIncluded(shared);
};
var $author$project$Api$Provider$Plan$Shared$familyWithSingleChildRateRuleEnabled = function (_v0) {
	var record = _v0;
	return record.Sc;
};
var $author$project$Api$Provider$Plan$One$familyWithSingleChildRateRuleEnabled = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$familyWithSingleChildRateRuleEnabled(shared);
};
var $author$project$Api$Provider$PricingVersion$Shared$familyWithSingleChildRateRuleEnabled = function (_v0) {
	var record = _v0;
	return record.Sc;
};
var $author$project$Api$Provider$PricingVersion$One$familyWithSingleChildRateRuleEnabled = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$familyWithSingleChildRateRuleEnabled(shared);
};
var $author$project$Api$Provider$Plan$One$fixedChildrenAgeLimit = function (_v0) {
	var record = _v0.b;
	return record.Sw;
};
var $author$project$Api$Provider$PricingVersion$Shared$fixedChildrenAgeLimit = function (_v0) {
	var record = _v0;
	return record.Sw;
};
var $author$project$Api$Provider$PricingVersion$One$fixedChildrenAgeLimit = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$fixedChildrenAgeLimit(shared);
};
var $author$project$Api$Provider$Plan$One$groupPricingFamilyNumChildrenIncluded = function (_v0) {
	var record = _v0.b;
	return record.S0;
};
var $author$project$Api$Provider$PricingVersion$Shared$groupPricingFamilyNumChildrenIncluded = function (_v0) {
	var record = _v0;
	return record.S0;
};
var $author$project$Api$Provider$PricingVersion$One$groupPricingFamilyNumChildrenIncluded = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$groupPricingFamilyNumChildrenIncluded(shared);
};
var $author$project$Api$Provider$Plan$Shared$additionalAdultRateRule = function (_v0) {
	var record = _v0;
	return record.KZ;
};
var $author$project$Api$Provider$Plan$One$additionalAdultRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$additionalAdultRateRule(shared);
};
var $author$project$Api$Provider$PricingVersion$Shared$additionalAdultRateRule = function (_v0) {
	var record = _v0;
	return record.KZ;
};
var $author$project$Api$Provider$PricingVersion$One$additionalAdultRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$additionalAdultRateRule(shared);
};
var $author$project$Api$Provider$Plan$Shared$additionalChildRateRule = function (_v0) {
	var record = _v0;
	return record.K_;
};
var $author$project$Api$Provider$Plan$One$additionalChildRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$additionalChildRateRule(shared);
};
var $author$project$Api$Provider$PricingVersion$Shared$additionalChildRateRule = function (_v0) {
	var record = _v0;
	return record.K_;
};
var $author$project$Api$Provider$PricingVersion$One$additionalChildRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$additionalChildRateRule(shared);
};
var $author$project$Api$Provider$RateRule$Shared$annualAmountInCents = function (_v0) {
	var record = _v0;
	return record.dE.LH;
};
var $author$project$Api$Provider$RateRule$Shared$annualAmountInCentsEdited = function (_v0) {
	var record = _v0;
	return record.dE.fE;
};
var $author$project$Api$Provider$Plan$Shared$coupleRateRule = function (_v0) {
	var record = _v0;
	return record.ON;
};
var $author$project$Api$Provider$Plan$One$coupleRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$coupleRateRule(shared);
};
var $author$project$Api$Provider$PricingVersion$Shared$coupleRateRule = function (_v0) {
	var record = _v0;
	return record.ON;
};
var $author$project$Api$Provider$PricingVersion$One$coupleRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$coupleRateRule(shared);
};
var $author$project$Api$Provider$Plan$Shared$familyRateRule = function (_v0) {
	var record = _v0;
	return record.R9;
};
var $author$project$Api$Provider$Plan$One$familyRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$familyRateRule(shared);
};
var $author$project$Api$Provider$PricingVersion$Shared$familyRateRule = function (_v0) {
	var record = _v0;
	return record.R9;
};
var $author$project$Api$Provider$PricingVersion$One$familyRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$familyRateRule(shared);
};
var $author$project$Api$Provider$Plan$Shared$familyWithSingleChildRateRule = function (_v0) {
	var record = _v0;
	return record.Sb;
};
var $author$project$Api$Provider$Plan$One$familyWithSingleChildRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$familyWithSingleChildRateRule(shared);
};
var $author$project$Api$Provider$PricingVersion$Shared$familyWithSingleChildRateRule = function (_v0) {
	var record = _v0;
	return record.Sb;
};
var $author$project$Api$Provider$PricingVersion$One$familyWithSingleChildRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$familyWithSingleChildRateRule(shared);
};
var $author$project$Components$Plan$Form$FixedRateRuleField$getRateRule = F4(
	function (planGetter, pricingVersionGetter, plan, maybePricingVersion) {
		if (!maybePricingVersion.$) {
			var pricingVersion = maybePricingVersion.a;
			return pricingVersionGetter(pricingVersion);
		} else {
			return planGetter(plan);
		}
	});
var $author$project$Api$Provider$Plan$Shared$individualRateRule = function (_v0) {
	var record = _v0;
	return record.TX;
};
var $author$project$Api$Provider$Plan$One$individualRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$individualRateRule(shared);
};
var $author$project$Api$Provider$PricingVersion$Shared$individualRateRule = function (_v0) {
	var record = _v0;
	return record.TX;
};
var $author$project$Api$Provider$PricingVersion$One$individualRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$individualRateRule(shared);
};
var $author$project$Api$Provider$RateRule$Shared$monthAmountInCents = function (_v0) {
	var record = _v0;
	return record.dE.Xk;
};
var $author$project$Api$Provider$RateRule$Shared$monthAmountInCentsEdited = function (_v0) {
	var record = _v0;
	return record.dE.gX;
};
var $author$project$Api$Provider$RateRule$Shared$quarterAmountInCents = function (_v0) {
	var record = _v0;
	return record.dE._Q;
};
var $author$project$Api$Provider$RateRule$Shared$quarterAmountInCentsEdited = function (_v0) {
	var record = _v0;
	return record.dE.ho;
};
var $author$project$Api$Provider$RateRule$Shared$semiAnnualAmountInCents = function (_v0) {
	var record = _v0;
	return record.dE.aaJ;
};
var $author$project$Api$Provider$RateRule$Shared$semiAnnualAmountInCentsEdited = function (_v0) {
	var record = _v0;
	return record.dE.hz;
};
var $author$project$Api$Provider$Plan$Shared$singleParentRateRule = function (_v0) {
	var record = _v0;
	return record.abC;
};
var $author$project$Api$Provider$Plan$One$singleParentRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$singleParentRateRule(shared);
};
var $author$project$Api$Provider$PricingVersion$Shared$singleParentRateRule = function (_v0) {
	var record = _v0;
	return record.abC;
};
var $author$project$Api$Provider$PricingVersion$One$singleParentRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$singleParentRateRule(shared);
};
var $author$project$Api$Provider$Plan$Shared$singleParentWithSingleChildRateRule = function (_v0) {
	var record = _v0;
	return record.abE;
};
var $author$project$Api$Provider$Plan$One$singleParentWithSingleChildRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$singleParentWithSingleChildRateRule(shared);
};
var $author$project$Api$Provider$PricingVersion$Shared$singleParentWithSingleChildRateRule = function (_v0) {
	var record = _v0;
	return record.abE;
};
var $author$project$Api$Provider$PricingVersion$One$singleParentWithSingleChildRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$singleParentWithSingleChildRateRule(shared);
};
var $author$project$Components$Plan$Form$FixedRateRuleField$initFromServer = F4(
	function (defaultPeriod, type_, plan, maybePricingVersion) {
		var rateRule = function () {
			switch (type_.$) {
				case 0:
					return A4($author$project$Components$Plan$Form$FixedRateRuleField$getRateRule, $author$project$Api$Provider$Plan$One$individualRateRule, $author$project$Api$Provider$PricingVersion$One$individualRateRule, plan, maybePricingVersion);
				case 1:
					return A4($author$project$Components$Plan$Form$FixedRateRuleField$getRateRule, $author$project$Api$Provider$Plan$One$coupleRateRule, $author$project$Api$Provider$PricingVersion$One$coupleRateRule, plan, maybePricingVersion);
				case 2:
					return A4($author$project$Components$Plan$Form$FixedRateRuleField$getRateRule, $author$project$Api$Provider$Plan$One$singleParentRateRule, $author$project$Api$Provider$PricingVersion$One$singleParentRateRule, plan, maybePricingVersion);
				case 3:
					return A4($author$project$Components$Plan$Form$FixedRateRuleField$getRateRule, $author$project$Api$Provider$Plan$One$familyRateRule, $author$project$Api$Provider$PricingVersion$One$familyRateRule, plan, maybePricingVersion);
				case 4:
					return A4($author$project$Components$Plan$Form$FixedRateRuleField$getRateRule, $author$project$Api$Provider$Plan$One$singleParentWithSingleChildRateRule, $author$project$Api$Provider$PricingVersion$One$singleParentWithSingleChildRateRule, plan, maybePricingVersion);
				case 5:
					return A4($author$project$Components$Plan$Form$FixedRateRuleField$getRateRule, $author$project$Api$Provider$Plan$One$familyWithSingleChildRateRule, $author$project$Api$Provider$PricingVersion$One$familyWithSingleChildRateRule, plan, maybePricingVersion);
				case 6:
					return A4($author$project$Components$Plan$Form$FixedRateRuleField$getRateRule, $author$project$Api$Provider$Plan$One$additionalAdultRateRule, $author$project$Api$Provider$PricingVersion$One$additionalAdultRateRule, plan, maybePricingVersion);
				case 7:
					return A4($author$project$Components$Plan$Form$FixedRateRuleField$getRateRule, $author$project$Api$Provider$Plan$One$additionalChildRateRule, $author$project$Api$Provider$PricingVersion$One$additionalChildRateRule, plan, maybePricingVersion);
				case 8:
					return $elm$core$Maybe$Nothing;
				case 9:
					return $elm$core$Maybe$Nothing;
				default:
					return $elm$core$Maybe$Nothing;
			}
		}();
		return function (fixedRateRule) {
			var baseAmountInCents = function () {
				switch (type_.$) {
					case 0:
						return 8000;
					case 1:
						return 10000;
					case 2:
						return 13000;
					case 3:
						return 20000;
					case 4:
						return 11000;
					case 5:
						return 16000;
					case 6:
						return 10000;
					case 7:
						return 10000;
					case 8:
						return 0;
					case 9:
						return 0;
					default:
						return 0;
				}
			}();
			switch (defaultPeriod) {
				case 'month':
					return _Utils_update(
						fixedRateRule,
						{
							Xk: $elm$core$Maybe$Just(
								A2(
									$elm$core$Maybe$withDefault,
									$author$project$Currency$fromInt(baseAmountInCents),
									fixedRateRule.Xk))
						});
				case 'annual':
					return _Utils_update(
						fixedRateRule,
						{
							LH: $elm$core$Maybe$Just(
								A2(
									$elm$core$Maybe$withDefault,
									$author$project$Currency$fromInt(baseAmountInCents * 12),
									fixedRateRule.LH))
						});
				default:
					return fixedRateRule;
			}
		}(
			{
				LH: A2(
					$elm$core$Maybe$map,
					$author$project$Currency$fromInt,
					A2($elm$core$Maybe$andThen, $author$project$Api$Provider$RateRule$Shared$annualAmountInCents, rateRule)),
				fE: A2(
					$elm$core$Maybe$withDefault,
					false,
					A2($elm$core$Maybe$map, $author$project$Api$Provider$RateRule$Shared$annualAmountInCentsEdited, rateRule)),
				LI: false,
				Xk: A2(
					$elm$core$Maybe$map,
					$author$project$Currency$fromInt,
					A2($elm$core$Maybe$andThen, $author$project$Api$Provider$RateRule$Shared$monthAmountInCents, rateRule)),
				gX: A2(
					$elm$core$Maybe$withDefault,
					false,
					A2($elm$core$Maybe$map, $author$project$Api$Provider$RateRule$Shared$monthAmountInCentsEdited, rateRule)),
				IB: false,
				_Q: A2(
					$elm$core$Maybe$map,
					$author$project$Currency$fromInt,
					A2($elm$core$Maybe$andThen, $author$project$Api$Provider$RateRule$Shared$quarterAmountInCents, rateRule)),
				ho: A2(
					$elm$core$Maybe$withDefault,
					false,
					A2($elm$core$Maybe$map, $author$project$Api$Provider$RateRule$Shared$quarterAmountInCentsEdited, rateRule)),
				_R: false,
				aaJ: A2(
					$elm$core$Maybe$map,
					$author$project$Currency$fromInt,
					A2($elm$core$Maybe$andThen, $author$project$Api$Provider$RateRule$Shared$semiAnnualAmountInCents, rateRule)),
				hz: A2(
					$elm$core$Maybe$withDefault,
					false,
					A2($elm$core$Maybe$map, $author$project$Api$Provider$RateRule$Shared$semiAnnualAmountInCentsEdited, rateRule)),
				aaK: false,
				amg: type_
			});
	});
var $author$project$Api$Provider$Plan$Meta$familyNumAdultsIncludedRuleEnabled = function (_v0) {
	var meta = _v0;
	return meta.aak.R8.Ro;
};
var $author$project$Api$Provider$Plan$Meta$fixedChildrenAgeLimitRuleEnabled = function (_v0) {
	var meta = _v0;
	return meta.aak.Sw.Ro;
};
var $author$project$Api$Provider$Plan$Meta$groupPricingFamilyNumChildrenIncludedRuleEnabled = function (_v0) {
	var meta = _v0;
	return meta.aak.S0.Ro;
};
var $author$project$Api$Provider$Plan$Shared$singleParentWithSingleChildRateRuleEnabled = function (_v0) {
	var record = _v0;
	return record.abF;
};
var $author$project$Api$Provider$Plan$One$singleParentWithSingleChildRateRuleEnabled = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$singleParentWithSingleChildRateRuleEnabled(shared);
};
var $author$project$Api$Provider$PricingVersion$Shared$singleParentWithSingleChildRateRuleEnabled = function (_v0) {
	var record = _v0;
	return record.abF;
};
var $author$project$Api$Provider$PricingVersion$One$singleParentWithSingleChildRateRuleEnabled = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$singleParentWithSingleChildRateRuleEnabled(shared);
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$initRules = F2(
	function (plan, maybePricingVersion) {
		var ruleEnabled = F2(
			function (pvAccessor, planDefault) {
				if (!maybePricingVersion.$) {
					var pv = maybePricingVersion.a;
					return pvAccessor(pv);
				} else {
					return planDefault;
				}
			});
		var meta = $author$project$Api$Provider$Plan$One$meta(plan);
		return {
			R8: {
				Ro: A2(
					ruleEnabled,
					function (pv) {
						return !_Utils_eq(
							$author$project$Api$Provider$PricingVersion$One$familyNumAdultsIncluded(pv),
							$elm$core$Maybe$Nothing);
					},
					$author$project$Api$Provider$Plan$Meta$familyNumAdultsIncludedRuleEnabled(meta))
			},
			Sb: {
				Ro: A2(
					ruleEnabled,
					$author$project$Api$Provider$PricingVersion$One$familyWithSingleChildRateRuleEnabled,
					$author$project$Api$Provider$Plan$One$familyWithSingleChildRateRuleEnabled(plan))
			},
			Sw: {
				Ro: A2(
					ruleEnabled,
					function (pv) {
						return !_Utils_eq(
							$author$project$Api$Provider$PricingVersion$One$fixedChildrenAgeLimit(pv),
							$elm$core$Maybe$Nothing);
					},
					$author$project$Api$Provider$Plan$Meta$fixedChildrenAgeLimitRuleEnabled(meta))
			},
			S0: {
				Ro: A2(
					ruleEnabled,
					function (pv) {
						return !_Utils_eq(
							$author$project$Api$Provider$PricingVersion$One$groupPricingFamilyNumChildrenIncluded(pv),
							$elm$core$Maybe$Nothing);
					},
					$author$project$Api$Provider$Plan$Meta$groupPricingFamilyNumChildrenIncludedRuleEnabled(meta))
			},
			abE: {
				Ro: A2(
					ruleEnabled,
					$author$project$Api$Provider$PricingVersion$One$singleParentWithSingleChildRateRuleEnabled,
					$author$project$Api$Provider$Plan$One$singleParentWithSingleChildRateRuleEnabled(plan))
			}
		};
	});
var $author$project$Api$Provider$Plan$One$splitRevenueType = function (_v0) {
	var record = _v0.b;
	return record.abW;
};
var $author$project$Api$Provider$PricingVersion$Shared$splitRevenueType = function (_v0) {
	var record = _v0;
	return record.abW;
};
var $author$project$Api$Provider$PricingVersion$One$splitRevenueType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$splitRevenueType(shared);
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$initFromServer = F2(
	function (plan, maybePricingVersion) {
		var defaultPeriod = $author$project$Api$Provider$Plan$One$defaultPeriod(plan);
		var familyRateRule = A4($author$project$Components$Plan$Form$FixedRateRuleField$initFromServer, defaultPeriod, $author$project$Api$RateRuleType$Family, plan, maybePricingVersion);
		var familyWithSingleChildRateRule = A4($author$project$Components$Plan$Form$FixedRateRuleField$initFromServer, defaultPeriod, $author$project$Api$RateRuleType$FamilyWithSingleChild, plan, maybePricingVersion);
		var individualRateRule = A4($author$project$Components$Plan$Form$FixedRateRuleField$initFromServer, defaultPeriod, $author$project$Api$RateRuleType$Individual, plan, maybePricingVersion);
		var singleParentRateRule = A4($author$project$Components$Plan$Form$FixedRateRuleField$initFromServer, defaultPeriod, $author$project$Api$RateRuleType$SingleParent, plan, maybePricingVersion);
		var singleParentWithSingleChildRateRule = A4($author$project$Components$Plan$Form$FixedRateRuleField$initFromServer, defaultPeriod, $author$project$Api$RateRuleType$SingleParentWithSingleChild, plan, maybePricingVersion);
		var coupleRateRule = A4($author$project$Components$Plan$Form$FixedRateRuleField$initFromServer, defaultPeriod, $author$project$Api$RateRuleType$Couple, plan, maybePricingVersion);
		var additionalChildRateRule = A4($author$project$Components$Plan$Form$FixedRateRuleField$initFromServer, defaultPeriod, $author$project$Api$RateRuleType$AdditionalChild, plan, maybePricingVersion);
		var additionalAdultRateRule = A4($author$project$Components$Plan$Form$FixedRateRuleField$initFromServer, defaultPeriod, $author$project$Api$RateRuleType$AdditionalAdult, plan, maybePricingVersion);
		return $author$project$Utils$Form$init(
			{
				KZ: additionalAdultRateRule,
				K_: additionalChildRateRule,
				LW: function () {
					if (!maybePricingVersion.$) {
						var pv = maybePricingVersion.a;
						return A2(
							$elm$core$Maybe$withDefault,
							false,
							$author$project$Api$Provider$PricingVersion$One$appliesGroupDiscountInTiers(pv));
					} else {
						return A2(
							$elm$core$Maybe$withDefault,
							false,
							$author$project$Api$Provider$Plan$One$appliesGroupDiscountInTiers(plan));
					}
				}(),
				ON: coupleRateRule,
				R8: function () {
					if (!maybePricingVersion.$) {
						var pv = maybePricingVersion.a;
						return $author$project$Api$Provider$PricingVersion$One$familyNumAdultsIncluded(pv);
					} else {
						return $author$project$Api$Provider$Plan$One$familyNumAdultsIncluded(plan);
					}
				}(),
				R9: familyRateRule,
				Sb: familyWithSingleChildRateRule,
				Sc: A2(
					$elm$core$Maybe$withDefault,
					$author$project$Api$Provider$Plan$One$familyWithSingleChildRateRuleEnabled(plan),
					A2($elm$core$Maybe$map, $author$project$Api$Provider$PricingVersion$One$familyWithSingleChildRateRuleEnabled, maybePricingVersion)),
				Sw: function () {
					if (!maybePricingVersion.$) {
						var pv = maybePricingVersion.a;
						return $author$project$Api$Provider$PricingVersion$One$fixedChildrenAgeLimit(pv);
					} else {
						return $author$project$Api$Provider$Plan$One$fixedChildrenAgeLimit(plan);
					}
				}(),
				S0: function () {
					if (!maybePricingVersion.$) {
						var pv = maybePricingVersion.a;
						return $author$project$Api$Provider$PricingVersion$One$groupPricingFamilyNumChildrenIncluded(pv);
					} else {
						return $author$project$Api$Provider$Plan$One$groupPricingFamilyNumChildrenIncluded(plan);
					}
				}(),
				TX: individualRateRule,
				aak: A2($author$project$Components$Plan$Form$GroupTierPricingFields$initRules, plan, maybePricingVersion),
				abC: singleParentRateRule,
				abE: singleParentWithSingleChildRateRule,
				abF: A2(
					$elm$core$Maybe$withDefault,
					$author$project$Api$Provider$Plan$One$singleParentWithSingleChildRateRuleEnabled(plan),
					A2($elm$core$Maybe$map, $author$project$Api$Provider$PricingVersion$One$singleParentWithSingleChildRateRuleEnabled, maybePricingVersion)),
				abW: function () {
					if (!maybePricingVersion.$) {
						var pv = maybePricingVersion.a;
						return A2(
							$elm$core$Maybe$withDefault,
							'even_children',
							$author$project$Api$Provider$PricingVersion$One$splitRevenueType(pv));
					} else {
						return A2(
							$elm$core$Maybe$withDefault,
							'even_children',
							$author$project$Api$Provider$Plan$One$splitRevenueType(plan));
					}
				}()
			});
	});
var $author$project$Components$Plan$Form$GroupTierPricingFields$fill = F2(
	function (plan, maybePricingVersion) {
		return A2($author$project$Components$Plan$Form$GroupTierPricingFields$initFromServer, plan, maybePricingVersion);
	});
var $author$project$Api$Provider$PricingVersion$Shared$ageRateRules = function (_v0) {
	var record = _v0;
	return record.Lk;
};
var $author$project$Api$Provider$PricingVersion$One$ageRateRules = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$ageRateRules(shared);
};
var $author$project$Components$Plan$Form$AgeRateRuleField$empty = {
	OM: $elm$core$Maybe$Nothing,
	SK: 0,
	dE: {
		LH: $elm$core$Maybe$Nothing,
		fE: false,
		LI: false,
		Xk: $elm$core$Maybe$Just($author$project$Currency$zero),
		gX: false,
		IB: false,
		_Q: $elm$core$Maybe$Nothing,
		ho: false,
		_R: false,
		aaJ: $elm$core$Maybe$Nothing,
		hz: false,
		aaK: false
	},
	adb: $elm$core$Maybe$Nothing,
	adL: 0
};
var $author$project$Currency$multiply = F2(
	function (_int, currency) {
		return A2(
			$elm$core$Maybe$withDefault,
			currency,
			A2(
				$elm$core$Maybe$map,
				$author$project$Currency$fromInt,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$mul(_int),
					$author$project$Currency$toInt(currency))));
	});
var $author$project$Components$Plan$Form$AgeRateRuleField$default = function (defaultPeriod) {
	var defaultAmount = $author$project$Currency$fromInt(5000);
	if (defaultPeriod === 'month') {
		var updatedPeriodRates = $author$project$Components$Plan$Form$AgeRateRuleField$empty.dE;
		return _Utils_update(
			$author$project$Components$Plan$Form$AgeRateRuleField$empty,
			{
				dE: _Utils_update(
					updatedPeriodRates,
					{
						Xk: $elm$core$Maybe$Just(defaultAmount)
					})
			});
	} else {
		var updatedPeriodRates = $author$project$Components$Plan$Form$AgeRateRuleField$empty.dE;
		return _Utils_update(
			$author$project$Components$Plan$Form$AgeRateRuleField$empty,
			{
				dE: _Utils_update(
					updatedPeriodRates,
					{
						LH: $elm$core$Maybe$Just(
							A2($author$project$Currency$multiply, 12, defaultAmount))
					})
			});
	}
};
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$defaultAgeRules = function (defaultPeriod) {
	return _List_fromArray(
		[
			$author$project$Components$Plan$Form$AgeRateRuleField$default(defaultPeriod)
		]);
};
var $author$project$Components$Plan$Form$AgeRateRuleField$convertCoupleAgeRateRule = function (serverCoupleRule) {
	return {
		dE: {
			LH: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, serverCoupleRule.dE.LH),
			fE: serverCoupleRule.dE.fE,
			LI: false,
			Xk: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, serverCoupleRule.dE.Xk),
			gX: serverCoupleRule.dE.gX,
			IB: false,
			_Q: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, serverCoupleRule.dE._Q),
			ho: serverCoupleRule.dE.ho,
			_R: false,
			aaJ: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, serverCoupleRule.dE.aaJ),
			hz: serverCoupleRule.dE.hz,
			aaK: false
		}
	};
};
var $author$project$Api$Provider$RateRule$Shared$coupleAgeRateRule = function (_v0) {
	var record = _v0;
	return record.OM;
};
var $author$project$Api$Provider$RateRule$Shared$unit = function (_v0) {
	var record = _v0;
	return record.adL;
};
var $author$project$Components$Plan$Form$AgeRateRuleField$initFromServer = function (ageRateRule) {
	return {
		OM: A2(
			$elm$core$Maybe$map,
			$author$project$Components$Plan$Form$AgeRateRuleField$convertCoupleAgeRateRule,
			$author$project$Api$Provider$RateRule$Shared$coupleAgeRateRule(ageRateRule)),
		SK: $author$project$Api$Provider$RateRule$Shared$fromAge(ageRateRule),
		dE: {
			LH: A2(
				$elm$core$Maybe$map,
				$author$project$Currency$fromInt,
				$author$project$Api$Provider$RateRule$Shared$annualAmountInCents(ageRateRule)),
			fE: $author$project$Api$Provider$RateRule$Shared$annualAmountInCentsEdited(ageRateRule),
			LI: false,
			Xk: A2(
				$elm$core$Maybe$map,
				$author$project$Currency$fromInt,
				$author$project$Api$Provider$RateRule$Shared$monthAmountInCents(ageRateRule)),
			gX: $author$project$Api$Provider$RateRule$Shared$monthAmountInCentsEdited(ageRateRule),
			IB: false,
			_Q: A2(
				$elm$core$Maybe$map,
				$author$project$Currency$fromInt,
				$author$project$Api$Provider$RateRule$Shared$quarterAmountInCents(ageRateRule)),
			ho: $author$project$Api$Provider$RateRule$Shared$quarterAmountInCentsEdited(ageRateRule),
			_R: false,
			aaJ: A2(
				$elm$core$Maybe$map,
				$author$project$Currency$fromInt,
				$author$project$Api$Provider$RateRule$Shared$semiAnnualAmountInCents(ageRateRule)),
			hz: $author$project$Api$Provider$RateRule$Shared$semiAnnualAmountInCentsEdited(ageRateRule),
			aaK: false
		},
		adb: $author$project$Api$Provider$RateRule$Shared$toAge(ageRateRule),
		adL: $author$project$Api$Provider$RateRule$Shared$unit(ageRateRule)
	};
};
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$fill = F2(
	function (plan, maybePricingVersion) {
		var planType = $author$project$Api$Provider$Plan$One$planType(plan);
		var ageRateRules = function () {
			if (!maybePricingVersion.$) {
				var pricingVersion = maybePricingVersion.a;
				return A2(
					$elm$core$List$map,
					$author$project$Components$Plan$Form$AgeRateRuleField$initFromServer,
					$author$project$Api$Provider$PricingVersion$One$ageRateRules(pricingVersion));
			} else {
				return A2(
					$elm$core$List$map,
					$author$project$Components$Plan$Form$AgeRateRuleField$initFromServer,
					$author$project$Api$Provider$Plan$One$ageRateRules(plan));
			}
		}();
		return $author$project$Utils$Form$init(
			{
				Lk: function () {
					if ((planType !== 1) && $elm$core$List$isEmpty(ageRateRules)) {
						var defaultPeriod = $author$project$Api$Provider$Plan$One$defaultPeriod(plan);
						return $author$project$Components$Plan$Form$IndividualMembershipPricingFields$defaultAgeRules(defaultPeriod);
					} else {
						return ageRateRules;
					}
				}()
			});
	});
var $author$project$Api$Provider$SpecialRate$Shared$annualAmountInCents = function (_v0) {
	var record = _v0;
	return record.LH;
};
var $author$project$Api$Provider$SpecialRate$Shared$annualAmountInCentsEdited = function (_v0) {
	var record = _v0;
	return record.fE;
};
var $author$project$Api$Provider$SpecialRate$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$SpecialRate$Shared$isDestroyable = function (_v0) {
	var record = _v0;
	return record.UN;
};
var $author$project$Api$Provider$SpecialRate$Shared$monthAmountInCents = function (_v0) {
	var record = _v0;
	return record.Xk;
};
var $author$project$Api$Provider$SpecialRate$Shared$monthAmountInCentsEdited = function (_v0) {
	var record = _v0;
	return record.gX;
};
var $author$project$Api$Provider$SpecialRate$Shared$quarterAmountInCents = function (_v0) {
	var record = _v0;
	return record._Q;
};
var $author$project$Api$Provider$SpecialRate$Shared$quarterAmountInCentsEdited = function (_v0) {
	var record = _v0;
	return record.ho;
};
var $author$project$Api$Provider$SpecialRate$Shared$semiAnnualAmountInCents = function (_v0) {
	var record = _v0;
	return record.aaJ;
};
var $author$project$Api$Provider$SpecialRate$Shared$semiAnnualAmountInCentsEdited = function (_v0) {
	var record = _v0;
	return record.hz;
};
var $author$project$Components$Plan$Form$SpecialRateField$initFromServer = function (specialRate) {
	return {
		LH: A2(
			$elm$core$Maybe$map,
			$author$project$Currency$fromInt,
			$author$project$Api$Provider$SpecialRate$Shared$annualAmountInCents(specialRate)),
		fE: $author$project$Api$Provider$SpecialRate$Shared$annualAmountInCentsEdited(specialRate),
		LI: false,
		O0: false,
		Qv: false,
		ahP: $elm$core$Maybe$Just(
			$author$project$Api$Provider$SpecialRate$Shared$id(specialRate)),
		UN: $author$project$Api$Provider$SpecialRate$Shared$isDestroyable(specialRate),
		Xk: A2(
			$elm$core$Maybe$map,
			$author$project$Currency$fromInt,
			$author$project$Api$Provider$SpecialRate$Shared$monthAmountInCents(specialRate)),
		gX: $author$project$Api$Provider$SpecialRate$Shared$monthAmountInCentsEdited(specialRate),
		IB: false,
		Bq: $author$project$Api$Provider$SpecialRate$Shared$name(specialRate),
		_Q: A2(
			$elm$core$Maybe$map,
			$author$project$Currency$fromInt,
			$author$project$Api$Provider$SpecialRate$Shared$quarterAmountInCents(specialRate)),
		ho: $author$project$Api$Provider$SpecialRate$Shared$quarterAmountInCentsEdited(specialRate),
		_R: false,
		aaJ: A2(
			$elm$core$Maybe$map,
			$author$project$Currency$fromInt,
			$author$project$Api$Provider$SpecialRate$Shared$semiAnnualAmountInCents(specialRate)),
		hz: $author$project$Api$Provider$SpecialRate$Shared$semiAnnualAmountInCentsEdited(specialRate),
		aaK: false
	};
};
var $author$project$Api$Provider$PricingVersion$Shared$specialRates = function (_v0) {
	var record = _v0;
	return record.abT;
};
var $author$project$Api$Provider$PricingVersion$One$specialRates = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$specialRates(shared);
};
var $author$project$Components$Plan$Form$SpecialRateField$updateFromServer = F2(
	function (serverSpecialRates, specialRate) {
		var matchingServerSpecialRate = A2(
			$elm_community$list_extra$List$Extra$find,
			function (serverSpecialRate) {
				return _Utils_eq(
					specialRate.Bq,
					$author$project$Api$Provider$SpecialRate$Shared$name(serverSpecialRate));
			},
			serverSpecialRates);
		if (!matchingServerSpecialRate.$) {
			var matchingServerSpecialRate_ = matchingServerSpecialRate.a;
			return _Utils_update(
				specialRate,
				{
					LH: A2(
						$elm$core$Maybe$map,
						$author$project$Currency$fromInt,
						$author$project$Api$Provider$SpecialRate$Shared$annualAmountInCents(matchingServerSpecialRate_)),
					fE: $author$project$Api$Provider$SpecialRate$Shared$annualAmountInCentsEdited(matchingServerSpecialRate_),
					LI: false,
					ahP: $elm$core$Maybe$Just(
						$author$project$Api$Provider$SpecialRate$Shared$id(matchingServerSpecialRate_)),
					UN: $author$project$Api$Provider$SpecialRate$Shared$isDestroyable(matchingServerSpecialRate_),
					Xk: A2(
						$elm$core$Maybe$map,
						$author$project$Currency$fromInt,
						$author$project$Api$Provider$SpecialRate$Shared$monthAmountInCents(matchingServerSpecialRate_)),
					gX: $author$project$Api$Provider$SpecialRate$Shared$monthAmountInCentsEdited(matchingServerSpecialRate_),
					IB: false,
					_Q: A2(
						$elm$core$Maybe$map,
						$author$project$Currency$fromInt,
						$author$project$Api$Provider$SpecialRate$Shared$quarterAmountInCents(matchingServerSpecialRate_)),
					ho: $author$project$Api$Provider$SpecialRate$Shared$quarterAmountInCentsEdited(matchingServerSpecialRate_),
					_R: false,
					aaJ: A2(
						$elm$core$Maybe$map,
						$author$project$Currency$fromInt,
						$author$project$Api$Provider$SpecialRate$Shared$semiAnnualAmountInCents(matchingServerSpecialRate_)),
					hz: $author$project$Api$Provider$SpecialRate$Shared$semiAnnualAmountInCentsEdited(matchingServerSpecialRate_),
					aaK: false
				});
		} else {
			return specialRate;
		}
	});
var $author$project$Components$Plan$Form$SpecialRatesFields$initFromServer = F3(
	function (currentSpecialRates, plan, maybePricingVersion) {
		var serverSpecialRates = function () {
			if (!maybePricingVersion.$) {
				var pricingVersion = maybePricingVersion.a;
				return $author$project$Api$Provider$PricingVersion$One$specialRates(pricingVersion);
			} else {
				return $author$project$Api$Provider$Plan$One$specialRates(plan);
			}
		}();
		var specialRates = function () {
			if (!currentSpecialRates.$) {
				var currentSpecialRates_ = currentSpecialRates.a;
				return A2(
					$elm$core$List$map,
					$author$project$Components$Plan$Form$SpecialRateField$updateFromServer(serverSpecialRates),
					currentSpecialRates_);
			} else {
				return A2($elm$core$List$map, $author$project$Components$Plan$Form$SpecialRateField$initFromServer, serverSpecialRates);
			}
		}();
		return $author$project$Utils$Form$init(
			{abT: specialRates});
	});
var $author$project$Components$Plan$Form$SpecialRatesFields$fill = F2(
	function (plan, maybePricingVersion) {
		return A3($author$project$Components$Plan$Form$SpecialRatesFields$initFromServer, $elm$core$Maybe$Nothing, plan, maybePricingVersion);
	});
var $author$project$Components$Plan$Form$SpecialRatesFields$fillWithCurrent = F3(
	function (currentSpecialRates, plan, maybePricingVersion) {
		return A3(
			$author$project$Components$Plan$Form$SpecialRatesFields$initFromServer,
			$elm$core$Maybe$Just(currentSpecialRates),
			plan,
			maybePricingVersion);
	});
var $author$project$Components$Plan$Form$SpecialRatesFields$formFields = function (_v0) {
	var form = _v0;
	return $author$project$Utils$Form$fields(form);
};
var $author$project$Components$Plan$Form$SpecialRatesFields$fillFromCurrentForm = F3(
	function (maybeCurrentForm, plan, maybePricingVersion) {
		if (!maybeCurrentForm.$) {
			var currentForm = maybeCurrentForm.a;
			var currentSpecialRates = $author$project$Components$Plan$Form$SpecialRatesFields$formFields(currentForm).abT;
			return A3($author$project$Components$Plan$Form$SpecialRatesFields$fillWithCurrent, currentSpecialRates, plan, maybePricingVersion);
		} else {
			return A2($author$project$Components$Plan$Form$SpecialRatesFields$fill, plan, maybePricingVersion);
		}
	});
var $author$project$Api$Provider$Plan$Shared$groupDiscountRules = function (_v0) {
	var record = _v0;
	return record.SZ;
};
var $author$project$Api$Provider$Plan$One$groupDiscountRules = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$groupDiscountRules(shared);
};
var $author$project$Api$Provider$Plan$Shared$groupPricingType = function (_v0) {
	var record = _v0;
	return record.S1;
};
var $author$project$Api$Provider$Plan$One$groupPricingType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$groupPricingType(shared);
};
var $author$project$Components$Plan$Form$PlanChange$init = {
	cs: false,
	YL: {Nt: $elm$core$Maybe$Nothing, Nu: $elm$core$Maybe$Nothing, OC: $elm$core$Maybe$Nothing, ahP: $elm$core$Maybe$Nothing, adc: $elm$core$Maybe$Nothing, amg: 1},
	ud: false
};
var $author$project$Api$Provider$DiscountRule$Shared$annualAmountOffInCents = function (_v0) {
	var record = _v0;
	return record.LJ;
};
var $author$project$Api$Provider$DiscountRule$Shared$annualAmountOffInCentsEdited = function (_v0) {
	var record = _v0;
	return record.LK;
};
var $author$project$Api$Provider$DiscountRule$Shared$annualPercentOff = function (_v0) {
	var record = _v0;
	return record.LP;
};
var $author$project$Api$Provider$DiscountRule$Shared$annualPercentOffEdited = function (_v0) {
	var record = _v0;
	return record.LQ;
};
var $author$project$Api$Provider$DiscountRule$Shared$calculatedBy = function (_v0) {
	var record = _v0;
	return record.M2;
};
var $author$project$Api$Provider$DiscountRule$Shared$fromSize = function (_v0) {
	var record = _v0;
	return record.SM;
};
var $author$project$Api$Provider$DiscountRule$Shared$monthAmountOffInCents = function (_v0) {
	var record = _v0;
	return record.Xl;
};
var $author$project$Api$Provider$DiscountRule$Shared$monthAmountOffInCentsEdited = function (_v0) {
	var record = _v0;
	return record.Xm;
};
var $author$project$Api$Provider$DiscountRule$Shared$monthPercentOff = function (_v0) {
	var record = _v0;
	return record.Xs;
};
var $author$project$Api$Provider$DiscountRule$Shared$monthPercentOffEdited = function (_v0) {
	var record = _v0;
	return record.Xt;
};
var $author$project$Api$Provider$DiscountRule$Shared$quarterAmountOffInCents = function (_v0) {
	var record = _v0;
	return record._S;
};
var $author$project$Api$Provider$DiscountRule$Shared$quarterAmountOffInCentsEdited = function (_v0) {
	var record = _v0;
	return record._T;
};
var $author$project$Api$Provider$DiscountRule$Shared$quarterPercentOff = function (_v0) {
	var record = _v0;
	return record._Y;
};
var $author$project$Api$Provider$DiscountRule$Shared$quarterPercentOffEdited = function (_v0) {
	var record = _v0;
	return record._Z;
};
var $author$project$Api$Provider$DiscountRule$Shared$semiAnnualAmountOffInCents = function (_v0) {
	var record = _v0;
	return record.aaL;
};
var $author$project$Api$Provider$DiscountRule$Shared$semiAnnualAmountOffInCentsEdited = function (_v0) {
	var record = _v0;
	return record.aaM;
};
var $author$project$Api$Provider$DiscountRule$Shared$semiAnnualPercentOff = function (_v0) {
	var record = _v0;
	return record.aaR;
};
var $author$project$Api$Provider$DiscountRule$Shared$semiAnnualPercentOffEdited = function (_v0) {
	var record = _v0;
	return record.aaS;
};
var $author$project$Api$Provider$DiscountRule$Shared$toSize = function (_v0) {
	var record = _v0;
	return record.add;
};
var $author$project$Components$Plan$Form$GroupDiscountRuleField$initFromServer = function (groupDiscountRule) {
	return {
		LJ: A2(
			$elm$core$Maybe$map,
			$author$project$Currency$fromInt,
			$author$project$Api$Provider$DiscountRule$Shared$annualAmountOffInCents(groupDiscountRule)),
		LK: $author$project$Api$Provider$DiscountRule$Shared$annualAmountOffInCentsEdited(groupDiscountRule),
		Gs: false,
		LP: A2(
			$elm$core$Maybe$map,
			$author$project$Percentage$fromFloat,
			$author$project$Api$Provider$DiscountRule$Shared$annualPercentOff(groupDiscountRule)),
		LQ: $author$project$Api$Provider$DiscountRule$Shared$annualPercentOffEdited(groupDiscountRule),
		rj: false,
		M2: $author$project$Api$Provider$DiscountRule$Shared$calculatedBy(groupDiscountRule),
		SM: $author$project$Api$Provider$DiscountRule$Shared$fromSize(groupDiscountRule),
		Xl: A2(
			$elm$core$Maybe$map,
			$author$project$Currency$fromInt,
			$author$project$Api$Provider$DiscountRule$Shared$monthAmountOffInCents(groupDiscountRule)),
		Xm: $author$project$Api$Provider$DiscountRule$Shared$monthAmountOffInCentsEdited(groupDiscountRule),
		IC: false,
		Xs: A2(
			$elm$core$Maybe$map,
			$author$project$Percentage$fromFloat,
			$author$project$Api$Provider$DiscountRule$Shared$monthPercentOff(groupDiscountRule)),
		Xt: $author$project$Api$Provider$DiscountRule$Shared$monthPercentOffEdited(groupDiscountRule),
		oH: false,
		_S: A2(
			$elm$core$Maybe$map,
			$author$project$Currency$fromInt,
			$author$project$Api$Provider$DiscountRule$Shared$quarterAmountOffInCents(groupDiscountRule)),
		_T: $author$project$Api$Provider$DiscountRule$Shared$quarterAmountOffInCentsEdited(groupDiscountRule),
		Jq: false,
		_Y: A2(
			$elm$core$Maybe$map,
			$author$project$Percentage$fromFloat,
			$author$project$Api$Provider$DiscountRule$Shared$quarterPercentOff(groupDiscountRule)),
		_Z: $author$project$Api$Provider$DiscountRule$Shared$quarterPercentOffEdited(groupDiscountRule),
		t7: false,
		aaL: A2(
			$elm$core$Maybe$map,
			$author$project$Currency$fromInt,
			$author$project$Api$Provider$DiscountRule$Shared$semiAnnualAmountOffInCents(groupDiscountRule)),
		aaM: $author$project$Api$Provider$DiscountRule$Shared$semiAnnualAmountOffInCentsEdited(groupDiscountRule),
		JG: false,
		aaR: A2(
			$elm$core$Maybe$map,
			$author$project$Percentage$fromFloat,
			$author$project$Api$Provider$DiscountRule$Shared$semiAnnualPercentOff(groupDiscountRule)),
		aaS: $author$project$Api$Provider$DiscountRule$Shared$semiAnnualPercentOffEdited(groupDiscountRule),
		uv: false,
		add: $author$project$Api$Provider$DiscountRule$Shared$toSize(groupDiscountRule)
	};
};
var $author$project$Components$Plan$Form$initRules = function (meta) {
	return {
		R8: {
			Ro: $author$project$Api$Provider$Plan$Meta$familyNumAdultsIncludedRuleEnabled(meta)
		},
		Sw: {
			Ro: $author$project$Api$Provider$Plan$Meta$fixedChildrenAgeLimitRuleEnabled(meta)
		},
		S0: {
			Ro: $author$project$Api$Provider$Plan$Meta$groupPricingFamilyNumChildrenIncludedRuleEnabled(meta)
		}
	};
};
var $author$project$Api$Provider$Plan$One$iua = function (_v0) {
	var record = _v0.b;
	return record.Vu;
};
var $author$project$Api$Provider$Plan$Shared$maximumAge = function (_v0) {
	var record = _v0;
	return record.WF;
};
var $author$project$Api$Provider$Plan$One$maximumAge = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$maximumAge(shared);
};
var $author$project$Api$Provider$Plan$Shared$minimumAge = function (_v0) {
	var record = _v0;
	return record.Xd;
};
var $author$project$Api$Provider$Plan$One$minimumAge = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$minimumAge(shared);
};
var $author$project$Api$Provider$Plan$One$pricingEffectivenessType = function (_v0) {
	var record = _v0.b;
	return record._j;
};
var $author$project$Api$Provider$Plan$Shared$tobaccoSurchargeInCents = function (_v0) {
	var record = _v0;
	return record.adf;
};
var $author$project$Api$Provider$Plan$One$tobaccoSurchargeInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$tobaccoSurchargeInCents(shared);
};
var $author$project$Api$Provider$Plan$Shared$tobaccoSurchargePercentage = function (_v0) {
	var record = _v0;
	return record.adg;
};
var $author$project$Api$Provider$Plan$One$tobaccoSurchargePercentage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$tobaccoSurchargePercentage(shared);
};
var $author$project$Api$Provider$Plan$Shared$tobaccoSurchargeType = function (_v0) {
	var record = _v0;
	return record.adh;
};
var $author$project$Api$Provider$Plan$One$tobaccoSurchargeType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$tobaccoSurchargeType(shared);
};
var $author$project$Components$Plan$Form$initFormFields = F4(
	function (apiClient, model, currentPlanChange, plan) {
		var planType = $author$project$Api$Provider$Plan$One$planType(plan);
		var minimumAge = $author$project$Api$Provider$Plan$One$minimumAge(plan);
		var membershipPricingForm = A2($author$project$Components$Plan$Form$IndividualMembershipPricingFields$fill, plan, $elm$core$Maybe$Nothing);
		var maximumAge = $author$project$Api$Provider$Plan$One$maximumAge(plan);
		var groupTierPricingForm = A2($author$project$Components$Plan$Form$GroupTierPricingFields$fill, plan, $elm$core$Maybe$Nothing);
		var groupDiscountRules = A2(
			$elm$core$List$map,
			$author$project$Components$Plan$Form$GroupDiscountRuleField$initFromServer,
			$author$project$Api$Provider$Plan$One$groupDiscountRules(plan));
		var familyPricingForm = A2($author$project$Components$Plan$Form$FamilyMembershipPricingFields$fill, plan, $elm$core$Maybe$Nothing);
		var currentSpecialRatesForm = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.dL;
			},
			A2(
				$elm$core$Maybe$map,
				$author$project$Utils$Form$fields,
				A2($elm$core$Maybe$map, $elm$core$Tuple$second, model.SD)));
		var specialRatesForm = A3($author$project$Components$Plan$Form$SpecialRatesFields$fillFromCurrentForm, currentSpecialRatesForm, plan, $elm$core$Maybe$Nothing);
		var coveragePlan = function () {
			var _v2 = $author$project$Api$Provider$Plan$One$coveragePlan(plan);
			if ((!_v2.$) && (!_v2.a.$)) {
				var coveragePlan_ = _v2.a.a;
				return $elm$core$Maybe$Just(
					$author$project$Components$Plan$Form$CoveragePlanOne(coveragePlan_));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var _v0 = model;
		var practice = _v0.ZV;
		var _v1 = A6(
			$author$project$Components$Plan$BasicForm$fill,
			practice,
			plan,
			model.ZX,
			A2($author$project$Utils$User$isViewingAsHinter, model.aa4, model.ahK),
			$elm$core$Maybe$Just(
				_Utils_Tuple2(apiClient, model.aa4)),
			$elm$core$Maybe$Nothing);
		var basicPlanForm = _v1.a;
		var basicPlanFormCmd = _v1.b;
		return _Utils_Tuple2(
			{
				LW: A2(
					$elm$core$Maybe$withDefault,
					false,
					$author$project$Api$Provider$Plan$One$appliesGroupDiscountInTiers(plan)),
				ab: basicPlanForm,
				OA: $author$project$Api$Provider$Plan$One$contractEmailsEnabled(plan),
				OB: $author$project$Api$Provider$Plan$One$contractExpires(plan),
				OC: $author$project$Api$Provider$Plan$One$contractPeriodInMonths(plan),
				OD: $author$project$Api$Provider$Plan$One$contractRenewalEmailLeadTime(plan),
				G3: $author$project$Api$Provider$Plan$One$contractType(plan),
				OT: coveragePlan,
				zi: $author$project$Api$Provider$Plan$One$discountsEnabled(plan),
				zl: (!_Utils_eq(maximumAge, $elm$core$Maybe$Nothing)) && (!_Utils_eq(
					maximumAge,
					$elm$core$Maybe$Just(0))),
				zm: (!_Utils_eq(minimumAge, $elm$core$Maybe$Nothing)) && (!_Utils_eq(
					minimumAge,
					$elm$core$Maybe$Just(0))),
				dm: familyPricingForm,
				SZ: function () {
					if ((planType !== 1) && $elm$core$List$isEmpty(groupDiscountRules)) {
						var defaultPeriod = $author$project$Api$Provider$Plan$One$defaultPeriod(plan);
						return $author$project$Components$Plan$Form$defaultGroupRules(defaultPeriod);
					} else {
						return groupDiscountRules;
					}
				}(),
				S1: $author$project$Api$Provider$Plan$One$groupPricingType(plan),
				k: groupTierPricingForm,
				Vu: $author$project$Api$Provider$Plan$One$iua(plan),
				WF: maximumAge,
				dq: membershipPricingForm,
				Xd: minimumAge,
				kG: A2($elm$core$Maybe$withDefault, $author$project$Components$Plan$Form$PlanChange$init, currentPlanChange),
				_j: $author$project$Api$Provider$Plan$One$pricingEffectivenessType(plan),
				aak: $author$project$Components$Plan$Form$initRules(
					$author$project$Api$Provider$Plan$One$meta(plan)),
				dL: specialRatesForm,
				adf: $elm$core$Maybe$Just(
					$author$project$Currency$fromInt(
						$author$project$Api$Provider$Plan$One$tobaccoSurchargeInCents(plan))),
				adg: $elm$core$Maybe$Just(
					$author$project$Percentage$fromFloat(
						$author$project$Api$Provider$Plan$One$tobaccoSurchargePercentage(plan))),
				adh: $author$project$Api$Provider$Plan$One$tobaccoSurchargeType(plan)
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$BasicPlanFormUpdated, basicPlanFormCmd));
	});
var $author$project$Api$Provider$Plan$SpecialRates = 3;
var $author$project$Api$Plan$EmployerAll = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Plan$ProviderAll = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Employer$Plan$All$Plan = $elm$core$Basics$identity;
var $author$project$Api$Employer$Plan$Shared$Plan = $elm$core$Basics$identity;
var $author$project$Api$Employer$Plan$Shared$Record = function (id) {
	return function (name) {
		return function (planType) {
			return function (allowedBillingPeriodCodes) {
				return function (defaultPeriodInMonths) {
					return function (defaultPeriod) {
						return function (maximumAge) {
							return function (minimumAge) {
								return function (tobaccoSurchargeType) {
									return function (groupPricingType) {
										return function (maxRegistrationFeeInCents) {
											return function (individualRegistrationFeeInCents) {
												return function (billsAtEndOfPeriod) {
													return function (minimumEnrollmentPeriodInMonths) {
														return function (ageRateRules) {
															return function (individualRateRule) {
																return function (coupleRateRule) {
																	return function (singleParentWithSingleChildRateRuleEnabled) {
																		return function (singleParentWithSingleChildRateRule) {
																			return function (singleParentRateRule) {
																				return function (familyWithSingleChildRateRuleEnabled) {
																					return function (familyWithSingleChildRateRule) {
																						return function (familyRateRule) {
																							return function (sponsorFeeDeal) {
																								return {Lk: ageRateRules, Gq: allowedBillingPeriodCodes, MI: billsAtEndOfPeriod, ON: coupleRateRule, P6: defaultPeriod, P7: defaultPeriodInMonths, R9: familyRateRule, Sb: familyWithSingleChildRateRule, Sc: familyWithSingleChildRateRuleEnabled, S1: groupPricingType, ahP: id, TX: individualRateRule, TZ: individualRegistrationFeeInCents, WC: maxRegistrationFeeInCents, WF: maximumAge, Xd: minimumAge, Xf: minimumEnrollmentPeriodInMonths, Bq: name, ZF: planType, abC: singleParentRateRule, abE: singleParentWithSingleChildRateRule, abF: singleParentWithSingleChildRateRuleEnabled, abZ: sponsorFeeDeal, adh: tobaccoSurchargeType};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Employer$RateRule$Shared$RateRule = $elm$core$Basics$identity;
var $author$project$Api$Employer$RateRule$Shared$Record = F8(
	function (type_, fromAge, toAge, unit, monthAmountInCents, quarterAmountInCents, semiAnnualAmountInCents, annualAmountInCents) {
		return {LH: annualAmountInCents, SK: fromAge, Xk: monthAmountInCents, _Q: quarterAmountInCents, aaJ: semiAnnualAmountInCents, adb: toAge, amg: type_, adL: unit};
	});
var $author$project$Api$Employer$RateRule$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'annual_amount_in_cents',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'semi_annual_amount_in_cents',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'quarter_amount_in_cents',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'month_amount_in_cents',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'unit',
					A2($elm$json$Json$Decode$map, $author$project$Api$Provider$RateRule$Shared$stringToUnit, $elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'to_age',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'from_age',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'type',
								$author$project$Api$RateRuleType$decode,
								$elm$json$Json$Decode$succeed($author$project$Api$Employer$RateRule$Shared$Record)))))))));
var $author$project$Api$Employer$RateRule$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$RateRule$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$SponsorFeeDeal$Shared$SponsorFeeDeal = $elm$core$Basics$identity;
var $author$project$Api$Employer$SponsorFeeDeal$Shared$Record = function (amountInCents) {
	return {LE: amountInCents};
};
var $author$project$Api$Employer$SponsorFeeDeal$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'amount_in_cents',
	$elm$json$Json$Decode$int,
	$elm$json$Json$Decode$succeed($author$project$Api$Employer$SponsorFeeDeal$Shared$Record));
var $author$project$Api$Employer$SponsorFeeDeal$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$SponsorFeeDeal$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Plan$Shared$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'sponsor_fee_deal',
	$elm$json$Json$Decode$nullable($author$project$Api$Employer$SponsorFeeDeal$Shared$decoder),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'family_rate_rule',
		$elm$json$Json$Decode$nullable($author$project$Api$Employer$RateRule$Shared$decoder),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'family_with_single_child_rate_rule',
			$elm$json$Json$Decode$nullable($author$project$Api$Employer$RateRule$Shared$decoder),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'family_with_single_child_rate_rule_enabled',
				$elm$json$Json$Decode$bool,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'single_parent_rate_rule',
					$elm$json$Json$Decode$nullable($author$project$Api$Employer$RateRule$Shared$decoder),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'single_parent_with_single_child_rate_rule',
						$elm$json$Json$Decode$nullable($author$project$Api$Employer$RateRule$Shared$decoder),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'single_parent_with_single_child_rate_rule_enabled',
							$elm$json$Json$Decode$bool,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'couple_rate_rule',
								$elm$json$Json$Decode$nullable($author$project$Api$Employer$RateRule$Shared$decoder),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'individual_rate_rule',
									$elm$json$Json$Decode$nullable($author$project$Api$Employer$RateRule$Shared$decoder),
									$elm$core$Maybe$Nothing,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'age_rate_rules',
										$elm$json$Json$Decode$list($author$project$Api$Employer$RateRule$Shared$decoder),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'minimum_enrollment_period_in_months',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'bills_at_end_of_period',
												$elm$json$Json$Decode$bool,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'individual_registration_fee_in_cents',
													$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'max_registration_fee_in_cents',
														$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'group_pricing_type',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'tobacco_surcharge_type',
																$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'minimum_age',
																	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'maximum_age',
																		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'default_period',
																			$elm$json$Json$Decode$string,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'default_period_in_months',
																				$elm$json$Json$Decode$int,
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'allowed_billing_period_codes',
																					$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'plan_type',
																						$author$project$Api$PlanType$decoder,
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'name',
																							$elm$json$Json$Decode$string,
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'id',
																								$elm$json$Json$Decode$string,
																								$elm$json$Json$Decode$succeed($author$project$Api$Employer$Plan$Shared$Record)))))))))))))))))))))))));
var $author$project$Api$Employer$Plan$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Plan$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Plan$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Plan$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Plan$listDefaults = {akl: $elm$core$Maybe$Nothing};
var $author$project$Api$Employer$Plan$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Employer$Plan$listDefaults);
	var _v0 = options.akl;
	if (!_v0.$) {
		var string = _v0.a;
		return _List_fromArray(
			[
				A2($author$project$Api$Param$string, 'q', string)
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Api$Employer$Plan$plansPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['plans']),
	$author$project$Api$Data$employerPath);
var $author$project$Api$Employer$Plan$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Employer$Plan$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Employer$Plan$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Employer$Plan$plansPath)));
	});
var $author$project$Api$Provider$Plan$All$Plan = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Plan$All$Record = F6(
	function (defaultPeriod, maxRegistrationFeeInCents, individualRegistrationFeeInCents, contractExpires, contractPeriodInMonths, contractType) {
		return {OB: contractExpires, OC: contractPeriodInMonths, G3: contractType, P6: defaultPeriod, TZ: individualRegistrationFeeInCents, WC: maxRegistrationFeeInCents};
	});
var $author$project$Api$Provider$Plan$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'contract_type',
	$elm$json$Json$Decode$nullable($author$project$Api$ContractType$decode),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'contract_period_in_months',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'contract_expires',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'individual_registration_fee_in_cents',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'max_registration_fee_in_cents',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'default_period',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$Plan$All$Record)))))));
var $author$project$Api$Provider$Plan$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Plan$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Plan$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Plan$All$Plan)));
var $author$project$Api$Provider$Plan$listDefaults = {
	Gy: $elm$core$Maybe$Nothing,
	Gz: $elm$core$Maybe$Nothing,
	GA: $elm$core$Maybe$Nothing,
	MI: $elm$core$Maybe$Nothing,
	HE: _List_Nil,
	ahP: $elm$core$Maybe$Nothing,
	ajJ: $author$project$Api$Pagination$init,
	De: _List_Nil,
	akl: $elm$core$Maybe$Nothing,
	alA: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init)
};
var $author$project$Api$PlanType$toString = function (planType) {
	switch (planType) {
		case 0:
			return 'company';
		case 1:
			return 'sponsor_fixed_fee';
		case 2:
			return 'retail';
		case 3:
			return 'mce';
		default:
			return 'affiliate_dependable';
	}
};
var $author$project$Api$Provider$Plan$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Plan$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.akl;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.ahP;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$elm$core$List$isEmpty(options.De) ? _List_Nil : _List_fromArray(
				[
					A2(
					$author$project$Api$Param$string,
					'plan_type',
					A2(
						$elm$core$String$join,
						',',
						A2($elm$core$List$map, $author$project$Api$PlanType$toString, options.De)))
				]),
				_List_fromArray(
				[
					A2(
					$author$project$Api$Param$list,
					'expand',
					A2($elm$core$List$map, $author$project$Api$Provider$Plan$expandToString, options.HE))
				]),
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ),
				function () {
				var _v2 = options.GA;
				if (!_v2.$) {
					var coveragePlanId = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'available_for_coverage_plan', coveragePlanId)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v3 = options.Gz;
				if (!_v3.$) {
					var companyId = _v3.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'available_for_company', companyId)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v4 = options.Gy;
				if (!_v4.$) {
					var affiliateId = _v4.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'available_for_affiliation', affiliateId)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v5 = options.MI;
				if (!_v5.$) {
					var bool = _v5.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$bool, 'bills_at_end_of_period', bool)
						]);
				} else {
					return _List_Nil;
				}
			}()
			]));
};
var $author$project$Api$Provider$Plan$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Plan$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Plan$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Plan$plansPath)));
	});
var $author$project$Api$Plan$list = F4(
	function (apiClient, session, optionals, toMsg) {
		if ($author$project$Api$Platform$Session$One$organizationIsCompany(session)) {
			var options = optionals($author$project$Api$Provider$Plan$listDefaults);
			return A3(
				$author$project$Api$Employer$Plan$list,
				apiClient,
				function (d) {
					return _Utils_update(
						d,
						{akl: options.akl});
				},
				A2(
					$elm$core$Basics$composeL,
					toMsg,
					$author$project$Api$Data$map(
						$elm$core$List$map($author$project$Api$Plan$EmployerAll))));
		} else {
			return A3(
				$author$project$Api$Provider$Plan$list,
				apiClient,
				optionals,
				A2(
					$elm$core$Basics$composeL,
					toMsg,
					$author$project$Api$Data$map(
						$elm$core$List$map($author$project$Api$Plan$ProviderAll))));
		}
	});
var $author$project$Components$ResourceFilter$Plan$list = $author$project$Api$Plan$list;
var $author$project$Components$ResourceFilter$Plan$fetchResources = F6(
	function (session, listOptionals, toMsg, apiClient, pagination, query) {
		return A4(
			$author$project$Components$ResourceFilter$Plan$list,
			apiClient,
			session,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{ajJ: pagination, akl: query});
				}),
			toMsg);
	});
var $author$project$Components$ResourceFilter$Plan$retrieveResource = F5(
	function (session, listOptionals, toMsg, apiClient, id) {
		return A4(
			$author$project$Components$ResourceFilter$Plan$list,
			apiClient,
			session,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{
							ahP: $elm$core$Maybe$Just(id)
						});
				}),
			toMsg);
	});
var $author$project$Components$ResourceFilter$Plan$selectId = 'plans';
var $author$project$Components$ResourceFilter$Plan$toTitle = $author$project$Api$Plan$name;
var $author$project$Components$ResourceFilter$Plan$toLabel = function (resource) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Components$ResourceFilter$Plan$toTitle(resource))
		]);
};
var $author$project$Components$ResourceFilter$Plan$toValue = $author$project$Api$Plan$id;
var $author$project$Components$ResourceFilter$Plan$init = F4(
	function (apiClient, session, listOptionals, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{
				Sk: A2($author$project$Components$ResourceFilter$Plan$fetchResources, session, listOptionals),
				ahP: $author$project$Components$ResourceFilter$Plan$selectId,
				k$: 'Plan',
				uk: A2($author$project$Components$ResourceFilter$Plan$retrieveResource, session, listOptionals),
				u9: $author$project$Components$ResourceFilter$Plan$toLabel,
				lN: $author$project$Components$ResourceFilter$Plan$toTitle,
				hX: $author$project$Components$ResourceFilter$Plan$toValue
			},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{Jy: $author$project$Components$ResourceFilter$All, b8: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$Plan$Form$initPlanChangeToPlanResourceFilter = F3(
	function (apiClient, session, planType) {
		return A4(
			$author$project$Components$ResourceFilter$Plan$init,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{
						HE: _List_fromArray(
							[3]),
						De: _List_fromArray(
							[planType])
					});
			},
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Select a Plan'});
			});
	});
var $author$project$Components$Plan$BasicForm$preserveCatalogFields = F2(
	function (_v0, _v1) {
		var oldForm = _v0.b;
		var settings = _v1.a;
		var newForm = _v1.b;
		var old = $author$project$Utils$Form$fields(oldForm);
		var fields = $author$project$Utils$Form$fields(newForm);
		return A2(
			$author$project$Components$Plan$BasicForm$BasicPlanForm,
			settings,
			A2(
				$author$project$Utils$Form$set,
				_Utils_update(
					fields,
					{MZ: old.MZ, rQ: old.rQ, TP: old.TP}),
				newForm));
	});
var $author$project$Components$Plan$Form$resetParamsOnScope = F3(
	function (apiClient, response, model) {
		if (response.$ === 3) {
			var plan = response.a;
			var previousBasicPlan = A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.ab;
				},
				A2(
					$elm$core$Maybe$map,
					$author$project$Utils$Form$fields,
					A2($elm$core$Maybe$map, $elm$core$Tuple$second, model.SD)));
			var planType = $author$project$Api$Provider$Plan$One$planType(plan);
			var planChangeEnabled = (A2(
				$author$project$Utils$FeatureGate$gateAvailable,
				6,
				$author$project$Api$Practice$Provider(model.ZV)) && (!planType)) || ((planType === 2) || (planType === 3));
			var currentPlanChange = A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.kG;
				},
				A2(
					$elm$core$Maybe$map,
					$author$project$Utils$Form$fields,
					A2($elm$core$Maybe$map, $elm$core$Tuple$second, model.SD)));
			var _v1 = (planChangeEnabled && _Utils_eq(model.eT, $elm$core$Maybe$Nothing)) ? A2(
				$elm$core$Tuple$mapFirst,
				$elm$core$Maybe$Just,
				A3($author$project$Components$Plan$Form$initPlanChangeToPlanResourceFilter, apiClient, model.aa4, planType)) : _Utils_Tuple2(model.eT, $elm$core$Platform$Cmd$none);
			var planChangeToPlanResourceFilter = _v1.a;
			var planChangeToPlanResourceFilterCmd = _v1.b;
			var _v2 = A4($author$project$Components$Plan$Form$initFormFields, apiClient, model, currentPlanChange, plan);
			var formFields = _v2.a;
			var formFieldsCmd = _v2.b;
			var formFieldsWithCatalog = function () {
				if (!previousBasicPlan.$) {
					var oldBasicPlan = previousBasicPlan.a;
					return _Utils_update(
						formFields,
						{
							ab: A2($author$project$Components$Plan$BasicForm$preserveCatalogFields, oldBasicPlan, formFields.ab)
						});
				} else {
					return formFields;
				}
			}();
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						SD: $elm$core$Maybe$Just(
							_Utils_Tuple2(
								plan,
								$author$project$Utils$Form$init(formFieldsWithCatalog))),
						Io: response,
						kH: planChangeEnabled,
						eT: planChangeToPlanResourceFilter
					}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$PlanChangeToPlanResourceFilterMsg, planChangeToPlanResourceFilterCmd),
							formFieldsCmd
						])),
				_List_Nil);
		} else {
			return _Utils_Tuple3(
				model,
				$elm$core$Platform$Cmd$none,
				$author$project$OutMsg$handleErrorResponse(response));
		}
	});
var $author$project$Components$Plan$Form$SubsequentPlanDeleted = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Api$Provider$Plan$SubsequentPlan$delete = F3(
	function (apiClient, planId, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Plan$SubsequentPlan$subsequentPlansPath(planId)));
	});
var $author$project$Components$Plan$Form$PlanUpdated = function (a) {
	return {$: 12, a: a};
};
var $author$project$Api$Provider$Plan$update = F4(
	function (apiClient, id, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'plan',
					$author$project$Api$Provider$Plan$encodeUpdateFields(fields))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Plan$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Plan$planPath(id))));
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$formFields = function (_v0) {
	var form = _v0;
	return $author$project$Utils$Form$fields(form);
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$formFields = function (_v0) {
	var form = _v0;
	return $author$project$Utils$Form$fields(form);
};
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$formFields = function (_v0) {
	var form = _v0;
	return $author$project$Utils$Form$fields(form);
};
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$formFields = function (_v0) {
	var form = _v0;
	return $author$project$Utils$Form$fields(form);
};
var $author$project$Percentage$zero = '0';
var $author$project$Components$Plan$Form$updatePlanFields = function (formFields) {
	var membershipPricingFormFields = $author$project$Components$Plan$Form$IndividualMembershipPricingFields$formFields(formFields.dq);
	var familyMembershipPricingFormFields = $author$project$Components$Plan$Form$FamilyMembershipPricingFields$formFields(formFields.dm);
	var basicPlanFormFields = $author$project$Components$Plan$BasicForm$formFields(formFields.ab);
	var registrationFeeFields = $author$project$Components$Plan$Form$RegistrationFeePricingFields$formFields(basicPlanFormFields.dH);
	return {
		vB: A2(
			$elm$core$Maybe$map,
			function (familyDiscountRule) {
				return {LL: familyDiscountRule.LL, LM: familyDiscountRule.LM, Xn: familyDiscountRule.Xn, Xo: familyDiscountRule.Xo, _U: familyDiscountRule._U, _V: familyDiscountRule._V, aaN: familyDiscountRule.aaN, aaO: familyDiscountRule.aaO};
			},
			familyMembershipPricingFormFields.aak.vB.Ro ? familyMembershipPricingFormFields.vB : $elm$core$Maybe$Nothing),
		KZ: function () {
			if ($author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.k).aak.R8.Ro) {
				var additionalAdultRateRule = $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.k).KZ;
				return $elm$core$Maybe$Just(
					{LH: additionalAdultRateRule.LH, fE: additionalAdultRateRule.fE, Xk: additionalAdultRateRule.Xk, gX: additionalAdultRateRule.gX, _Q: additionalAdultRateRule._Q, ho: additionalAdultRateRule.ho, aaJ: additionalAdultRateRule.aaJ, hz: additionalAdultRateRule.hz});
			} else {
				if ((formFields.S1 === 'family') && (!_Utils_eq(familyMembershipPricingFormFields.vB, $elm$core$Maybe$Nothing))) {
					return A2(
						$elm$core$Maybe$map,
						function (familyDiscountRule) {
							return {LH: familyDiscountRule.LL, fE: familyDiscountRule.LM, Xk: familyDiscountRule.Xn, gX: familyDiscountRule.Xo, _Q: familyDiscountRule._U, ho: familyDiscountRule._V, aaJ: familyDiscountRule.aaN, hz: familyDiscountRule.aaO};
						},
						familyMembershipPricingFormFields.vB);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}(),
		vC: A2(
			$elm$core$Maybe$map,
			function (familyDiscountRule) {
				return {LL: familyDiscountRule.LL, LM: familyDiscountRule.LM, Xn: familyDiscountRule.Xn, Xo: familyDiscountRule.Xo, _U: familyDiscountRule._U, _V: familyDiscountRule._V, aaN: familyDiscountRule.aaN, aaO: familyDiscountRule.aaO};
			},
			familyMembershipPricingFormFields.aak.vC.Ro ? familyMembershipPricingFormFields.vC : $elm$core$Maybe$Nothing),
		K_: function () {
			if ($author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.k).aak.S0.Ro) {
				var additionalChildRateRule = $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.k).K_;
				return $elm$core$Maybe$Just(
					{LH: additionalChildRateRule.LH, fE: additionalChildRateRule.fE, Xk: additionalChildRateRule.Xk, gX: additionalChildRateRule.gX, _Q: additionalChildRateRule._Q, ho: additionalChildRateRule.ho, aaJ: additionalChildRateRule.aaJ, hz: additionalChildRateRule.hz});
			} else {
				if ((formFields.S1 === 'family') && (!_Utils_eq(familyMembershipPricingFormFields.vC, $elm$core$Maybe$Nothing))) {
					return A2(
						$elm$core$Maybe$map,
						function (familyDiscountRule) {
							return {LH: familyDiscountRule.LL, fE: familyDiscountRule.LM, Xk: familyDiscountRule.Xn, gX: familyDiscountRule.Xo, _Q: familyDiscountRule._U, ho: familyDiscountRule._V, aaJ: familyDiscountRule.aaN, hz: familyDiscountRule.aaO};
						},
						familyMembershipPricingFormFields.vC);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}(),
		K$: basicPlanFormFields.K$,
		Lk: A2(
			$elm$core$List$map,
			function (ageRateRule) {
				return {
					LH: ageRateRule.dE.LH,
					fE: ageRateRule.dE.fE,
					OM: A2(
						$elm$core$Maybe$map,
						function (coupleRule) {
							return {LH: coupleRule.dE.LH, fE: coupleRule.dE.fE, Xk: coupleRule.dE.Xk, gX: coupleRule.dE.gX, _Q: coupleRule.dE._Q, ho: coupleRule.dE.ho, aaJ: coupleRule.dE.aaJ, hz: coupleRule.dE.hz};
						},
						ageRateRule.OM),
					SK: $elm$core$Maybe$Just(ageRateRule.SK),
					Xk: ageRateRule.dE.Xk,
					gX: ageRateRule.dE.gX,
					_Q: ageRateRule.dE._Q,
					ho: ageRateRule.dE.ho,
					aaJ: ageRateRule.dE.aaJ,
					hz: ageRateRule.dE.hz,
					adb: ageRateRule.adb,
					adL: ageRateRule.adL
				};
			},
			membershipPricingFormFields.Lk),
		xk: A2($elm$core$Maybe$withDefault, $author$project$Percentage$zero, basicPlanFormFields.xk),
		xl: basicPlanFormFields.xl,
		LW: formFields.LW,
		MI: basicPlanFormFields.MI,
		MZ: basicPlanFormFields.MZ,
		x2: familyMembershipPricingFormFields.x2,
		x3: A2(
			$elm$core$Maybe$map,
			function (familyDiscountRule) {
				return {LL: familyDiscountRule.LL, LM: familyDiscountRule.LM, Xn: familyDiscountRule.Xn, Xo: familyDiscountRule.Xo, _U: familyDiscountRule._U, _V: familyDiscountRule._V, aaN: familyDiscountRule.aaN, aaO: familyDiscountRule.aaO};
			},
			familyMembershipPricingFormFields.aak.x3.Ro ? familyMembershipPricingFormFields.x3 : $elm$core$Maybe$Nothing),
		OA: formFields.OA,
		OB: formFields.OB,
		OC: formFields.OC,
		OD: formFields.OD,
		G3: formFields.G3,
		yS: A2(
			$elm$core$Maybe$map,
			function (familyDiscountRule) {
				return {LL: familyDiscountRule.LL, LM: familyDiscountRule.LM, Xn: familyDiscountRule.Xn, Xo: familyDiscountRule.Xo, _U: familyDiscountRule._U, _V: familyDiscountRule._V, aaN: familyDiscountRule.aaN, aaO: familyDiscountRule.aaO};
			},
			familyMembershipPricingFormFields.aak.yS.Ro ? familyMembershipPricingFormFields.yS : $elm$core$Maybe$Nothing),
		ON: function () {
			if (formFields.S1 === 'fixed_pricing') {
				var coupleRateRule = $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.k).ON;
				return $elm$core$Maybe$Just(
					{LH: coupleRateRule.LH, fE: coupleRateRule.fE, Xk: coupleRateRule.Xk, gX: coupleRateRule.gX, _Q: coupleRateRule._Q, ho: coupleRateRule.ho, aaJ: coupleRateRule.aaJ, hz: coupleRateRule.hz});
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}(),
		OT: A2($elm$core$Maybe$map, $author$project$Components$Plan$Form$coveragePlanId, formFields.OT),
		y6: basicPlanFormFields.y6,
		y7: basicPlanFormFields.y7,
		P6: basicPlanFormFields.P6,
		Hs: $author$project$Components$TranslatedRichText$translations(basicPlanFormFields.Qr),
		zi: formFields.zi,
		zB: A2(
			$elm$core$Maybe$map,
			function (familyDiscountRule) {
				return {LL: familyDiscountRule.LL, LM: familyDiscountRule.LM, Xn: familyDiscountRule.Xn, Xo: familyDiscountRule.Xo, _U: familyDiscountRule._U, _V: familyDiscountRule._V, aaN: familyDiscountRule.aaN, aaO: familyDiscountRule.aaO};
			},
			familyMembershipPricingFormFields.aak.zB.Ro ? familyMembershipPricingFormFields.zB : $elm$core$Maybe$Nothing),
		R8: $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.k).aak.R8.Ro ? $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.k).R8 : $elm$core$Maybe$Nothing,
		zC: familyMembershipPricingFormFields.zC,
		R9: function () {
			if (formFields.S1 === 'fixed_pricing') {
				var familyRateRule = $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.k).R9;
				return $elm$core$Maybe$Just(
					{LH: familyRateRule.LH, fE: familyRateRule.fE, Xk: familyRateRule.Xk, gX: familyRateRule.gX, _Q: familyRateRule._Q, ho: familyRateRule.ho, aaJ: familyRateRule.aaJ, hz: familyRateRule.hz});
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}(),
		Sb: function () {
			if ((formFields.S1 === 'fixed_pricing') && $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.k).Sc) {
				var familyWithSingleChildRateRule = $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.k).Sb;
				return $elm$core$Maybe$Just(
					{LH: familyWithSingleChildRateRule.LH, fE: familyWithSingleChildRateRule.fE, Xk: familyWithSingleChildRateRule.Xk, gX: familyWithSingleChildRateRule.gX, _Q: familyWithSingleChildRateRule._Q, ho: familyWithSingleChildRateRule.ho, aaJ: familyWithSingleChildRateRule.aaJ, hz: familyWithSingleChildRateRule.hz});
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}(),
		Sc: $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.k).Sc,
		Sw: $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.k).aak.Sw.Ro ? $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.k).Sw : $elm$core$Maybe$Nothing,
		SZ: A2(
			$elm$core$List$map,
			function (groupDiscountRule) {
				return {
					LJ: groupDiscountRule.LJ,
					LK: groupDiscountRule.LK,
					LP: groupDiscountRule.LP,
					LQ: groupDiscountRule.LQ,
					M2: groupDiscountRule.M2,
					SM: $elm$core$Maybe$Just(groupDiscountRule.SM),
					Xl: groupDiscountRule.Xl,
					Xm: groupDiscountRule.Xm,
					Xs: groupDiscountRule.Xs,
					Xt: groupDiscountRule.Xt,
					_S: groupDiscountRule._S,
					_T: groupDiscountRule._T,
					_Y: groupDiscountRule._Y,
					_Z: groupDiscountRule._Z,
					aaL: groupDiscountRule.aaL,
					aaM: groupDiscountRule.aaM,
					aaR: groupDiscountRule.aaR,
					aaS: groupDiscountRule.aaS,
					add: groupDiscountRule.add
				};
			},
			formFields.SZ),
		S0: $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.k).aak.S0.Ro ? $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.k).S0 : $elm$core$Maybe$Nothing,
		S1: formFields.S1,
		TP: basicPlanFormFields.TP,
		TX: function () {
			if (formFields.S1 === 'fixed_pricing') {
				var individualRateRule = $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.k).TX;
				return $elm$core$Maybe$Just(
					{LH: individualRateRule.LH, fE: individualRateRule.fE, Xk: individualRateRule.Xk, gX: individualRateRule.gX, _Q: individualRateRule._Q, ho: individualRateRule.ho, aaJ: individualRateRule.aaJ, hz: individualRateRule.hz});
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}(),
		TZ: registrationFeeFields.aak.TZ.Ro ? registrationFeeFields.TZ : $elm$core$Maybe$Nothing,
		Vu: formFields.Vu,
		WC: registrationFeeFields.aak.WC.Ro ? registrationFeeFields.WC : $elm$core$Maybe$Nothing,
		WF: formFields.WF,
		Xd: formFields.Xd,
		Xf: basicPlanFormFields.Xf,
		Bi: A2($elm$core$Maybe$withDefault, $author$project$Percentage$zero, basicPlanFormFields.Bi),
		Bj: basicPlanFormFields.Bj,
		Bq: basicPlanFormFields.Bq,
		BR: familyMembershipPricingFormFields.BR,
		_j: formFields._j,
		DB: A2($elm$core$Maybe$withDefault, $author$project$Percentage$zero, basicPlanFormFields.DB),
		DC: basicPlanFormFields.DC,
		DL: A2(
			$elm$core$Maybe$andThen,
			function (id) {
				return $elm$core$String$isEmpty(id) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(id);
			},
			basicPlanFormFields.DL),
		DM: basicPlanFormFields.DM,
		DN: basicPlanFormFields.DN,
		Es: A2($elm$core$Maybe$withDefault, $author$project$Percentage$zero, basicPlanFormFields.Es),
		Et: basicPlanFormFields.Et,
		EG: A2(
			$elm$core$Maybe$map,
			function (familyDiscountRule) {
				return {LL: familyDiscountRule.LL, LM: familyDiscountRule.LM, Xn: familyDiscountRule.Xn, Xo: familyDiscountRule.Xo, _U: familyDiscountRule._U, _V: familyDiscountRule._V, aaN: familyDiscountRule.aaN, aaO: familyDiscountRule.aaO};
			},
			familyMembershipPricingFormFields.aak.EG.Ro ? familyMembershipPricingFormFields.EG : $elm$core$Maybe$Nothing),
		abC: function () {
			if (formFields.S1 === 'fixed_pricing') {
				var singleParentRateRule = $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.k).abC;
				return $elm$core$Maybe$Just(
					{LH: singleParentRateRule.LH, fE: singleParentRateRule.fE, Xk: singleParentRateRule.Xk, gX: singleParentRateRule.gX, _Q: singleParentRateRule._Q, ho: singleParentRateRule.ho, aaJ: singleParentRateRule.aaJ, hz: singleParentRateRule.hz});
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}(),
		abE: function () {
			if ((formFields.S1 === 'fixed_pricing') && $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.k).abF) {
				var singleParentWithSingleChildRateRule = $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.k).abE;
				return $elm$core$Maybe$Just(
					{LH: singleParentWithSingleChildRateRule.LH, fE: singleParentWithSingleChildRateRule.fE, Xk: singleParentWithSingleChildRateRule.Xk, gX: singleParentWithSingleChildRateRule.gX, _Q: singleParentWithSingleChildRateRule._Q, ho: singleParentWithSingleChildRateRule.ho, aaJ: singleParentWithSingleChildRateRule.aaJ, hz: singleParentWithSingleChildRateRule.hz});
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}(),
		abF: $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.k).abF,
		abT: A2(
			$elm$core$List$map,
			function (specialRate) {
				return {LH: specialRate.LH, fE: specialRate.fE, O0: specialRate.O0, Qv: specialRate.Qv, ahP: specialRate.ahP, Xk: specialRate.Xk, gX: specialRate.gX, Bq: specialRate.Bq, _Q: specialRate._Q, ho: specialRate.ho, aaJ: specialRate.aaJ, hz: specialRate.hz};
			},
			$author$project$Components$Plan$Form$SpecialRatesFields$formFields(formFields.dL).abT),
		abW: $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.k).abW,
		JS: basicPlanFormFields.JS,
		adf: A2($elm$core$Maybe$withDefault, $author$project$Currency$zero, formFields.adf),
		adg: A2($elm$core$Maybe$withDefault, $author$project$Percentage$zero, formFields.adg),
		adh: formFields.adh
	};
};
var $author$project$Components$Plan$Form$updatePlanRequest = F3(
	function (apiClient, id, validFields) {
		return A4(
			$author$project$Api$Provider$Plan$update,
			apiClient,
			id,
			$author$project$Components$Plan$Form$updatePlanFields(
				$rtfeldman$elm_validate$Validate$fromValid(validFields)),
			$author$project$Components$Plan$Form$PlanUpdated);
	});
var $author$project$Components$Plan$Form$saveItem = F3(
	function (apiClient, id, validFormFields) {
		var _v0 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
		var planChange = _v0.kG;
		return planChange.ud ? A3(
			$author$project$Api$Provider$Plan$SubsequentPlan$delete,
			apiClient,
			id,
			$author$project$Components$Plan$Form$SubsequentPlanDeleted(validFormFields)) : A3($author$project$Components$Plan$Form$updatePlanRequest, apiClient, id, validFormFields);
	});
var $author$project$Components$Plan$BasicForm$showWarningModal = function (field) {
	switch (field.$) {
		case 0:
			return false;
		case 20:
			return false;
		case 21:
			return false;
		case 1:
			return false;
		case 5:
			return false;
		case 6:
			return false;
		case 7:
			return false;
		case 22:
			return false;
		case 8:
			return false;
		case 18:
			var rule = field.a;
			return false;
		case 17:
			return false;
		case 23:
			return false;
		case 2:
			return false;
		case 24:
			return false;
		default:
			return true;
	}
};
var $author$project$Api$Provider$Plan$One$upcomingPricingVersion = function (_v0) {
	var record = _v0.b;
	return record.adS;
};
var $author$project$Api$Provider$Plan$SubsequentPlan$update = F4(
	function (apiClient, planId, fields, toMsg) {
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$SubsequentPlan$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Provider$Plan$SubsequentPlan$encodeUpdateFields(fields),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Plan$SubsequentPlan$subsequentPlansPath(planId))));
	});
var $author$project$Components$Plan$BasicForm$FieldUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Plan$BasicForm$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Plan$BasicForm$Image = F2(
	function (a, b) {
		return {$: 24, a: a, b: b};
	});
var $author$project$Components$Plan$BasicForm$NoChange = {$: 1};
var $author$project$Components$Plan$BasicForm$RegistrationFeePricingField = function (a) {
	return {$: 23, a: a};
};
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$getCategoryId = function (_v0) {
	var form = _v0;
	return A2(
		$elm$core$Maybe$andThen,
		function (id) {
			return $elm$core$String$isEmpty(id) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(id);
		},
		A2(
			$elm$core$Maybe$andThen,
			$author$project$Components$ResourceFilter$Category$value,
			$author$project$Utils$Form$fields(form).c8));
};
var $author$project$Components$ResourceFilter$Category$selectedName = function (model) {
	var _v0 = model.Jy;
	switch (_v0.$) {
		case 3:
			return 'Unassigned';
		case 0:
			var resource = _v0.a;
			return resource.Bq;
		case 2:
			return 'All';
		default:
			return 'Unassigned';
	}
};
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$getCategoryName = function (_v0) {
	var form = _v0;
	return A2(
		$elm$core$Maybe$withDefault,
		'Unassigned',
		A2(
			$elm$core$Maybe$map,
			$author$project$Components$ResourceFilter$Category$selectedName,
			$author$project$Utils$Form$fields(form).c8));
};
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$FieldUpdated = $elm$core$Basics$identity;
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$IndividualRegistrationFeeInCents = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$updateField = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var currency = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{TZ: currency}),
					$elm$core$Platform$Cmd$none,
					field);
			case 1:
				var currency = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{WC: currency}),
					$elm$core$Platform$Cmd$none,
					field);
			default:
				var ruleType = field.a;
				if (!ruleType) {
					var bool = !fields.aak.TZ.Ro;
					return _Utils_Tuple3(
						_Utils_update(
							fields,
							{
								aak: {
									TZ: {Ro: bool},
									WC: fields.aak.WC
								}
							}),
						$elm$core$Platform$Cmd$none,
						field);
				} else {
					var bool = !fields.aak.WC.Ro;
					return _Utils_Tuple3(
						_Utils_update(
							fields,
							{
								aak: {
									TZ: fields.aak.TZ,
									WC: {Ro: bool}
								}
							}),
						$elm$core$Platform$Cmd$none,
						field);
				}
		}
	});
var $author$project$Utils$Form$updateWithCmdAndEvent = F3(
	function (updater, field_, _v0) {
		var originalFields = _v0.a;
		var validated_ = _v0.b;
		var fields_ = _v0.c;
		var errors_ = _v0.d;
		var _v1 = A2(updater, field_, fields_);
		var updated = _v1.a;
		var cmd = _v1.b;
		var event = _v1.c;
		return _Utils_Tuple3(
			A4($author$project$Utils$Form$Form, originalFields, validated_, updated, errors_),
			cmd,
			event);
	});
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$update = F3(
	function (apiClient, msg, _v0) {
		var form = _v0;
		if (!msg.$) {
			var field = msg.a;
			var _v2 = A3($author$project$Utils$Form$updateWithCmdAndEvent, $author$project$Components$Plan$Form$RegistrationFeePricingFields$updateField, field, form);
			var newForm = _v2.a;
			var newFormCmd = _v2.b;
			var event = _v2.c;
			return {GZ: newFormCmd, agZ: event, aiO: newForm, aR: _List_Nil};
		} else {
			var categoryMsg = msg.a;
			var fields = $author$project$Utils$Form$fields(form);
			var _v3 = fields.c8;
			if (!_v3.$) {
				var categoryResourceFilter = _v3.a;
				var result = A3($author$project$Components$ResourceFilter$Category$update, apiClient, categoryMsg, categoryResourceFilter);
				var newFields = _Utils_update(
					fields,
					{
						c8: $elm$core$Maybe$Just(result.aiO)
					});
				var newForm = A2($author$project$Utils$Form$set, newFields, form);
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$RegistrationFeePricingFields$CategoryResourceFilterMsg, result.GZ),
					agZ: $author$project$Components$Plan$Form$RegistrationFeePricingFields$IndividualRegistrationFeeInCents($elm$core$Maybe$Nothing),
					aiO: newForm,
					aR: result.aR
				};
			} else {
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: $author$project$Components$Plan$Form$RegistrationFeePricingFields$IndividualRegistrationFeeInCents($elm$core$Maybe$Nothing),
					aiO: form,
					aR: _List_Nil
				};
			}
		}
	});
var $author$project$Components$Plan$BasicForm$toggleRule = F4(
	function (maybePlan, rule, bool, fields) {
		var rules = fields.aak;
		var newValue = F2(
			function (enabled, getter) {
				if (!maybePlan.$) {
					var plan = maybePlan.a;
					return enabled ? getter(plan) : $elm$core$Maybe$Nothing;
				} else {
					return $elm$core$Maybe$Nothing;
				}
			});
		return _Utils_update(
			fields,
			{
				Xf: A2(newValue, bool, $author$project$Api$Provider$Plan$One$minimumEnrollmentPeriodInMonths),
				aak: _Utils_update(
					rules,
					{
						Xf: {Ro: bool}
					})
			});
	});
var $author$project$Currency$divide = F2(
	function (_int, currency) {
		return A2(
			$elm$core$Maybe$withDefault,
			currency,
			A2(
				$elm$core$Maybe$map,
				$author$project$Currency$fromInt,
				A2(
					$elm$core$Maybe$map,
					function (currency_) {
						return (currency_ / _int) | 0;
					},
					$author$project$Currency$toInt(currency))));
	});
var $author$project$Components$Plan$BasicForm$resetSponsorFeeDealAmountInCents = F2(
	function (defaultPeriod, sponsorFeeDealAmountInCents) {
		switch (defaultPeriod) {
			case 'annual':
				return A2(
					$elm$core$Maybe$map,
					$author$project$Currency$multiply(12),
					sponsorFeeDealAmountInCents);
			case 'month':
				return A2(
					$elm$core$Maybe$map,
					$author$project$Currency$divide(12),
					sponsorFeeDealAmountInCents);
			default:
				return sponsorFeeDealAmountInCents;
		}
	});
var $author$project$Components$Plan$BasicForm$updateDefaultPeriod = F3(
	function (maybePlan, defaultPeriod, fields) {
		var sponsorFeeDealAmountInCents = function () {
			if (!maybePlan.$) {
				var plan = maybePlan.a;
				return ($author$project$Api$Provider$Plan$One$planType(plan) === 1) ? A2($author$project$Components$Plan$BasicForm$resetSponsorFeeDealAmountInCents, defaultPeriod, fields.JS) : fields.JS;
			} else {
				return fields.JS;
			}
		}();
		return _Utils_Tuple2(
			_Utils_update(
				fields,
				{P6: defaultPeriod, JS: sponsorFeeDealAmountInCents}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Components$Plan$BasicForm$updateField = F5(
	function (_v0, _v1, maybePlan, field, form) {
		switch (field.$) {
			case 0:
				var name = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{Bq: name}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			case 2:
				var buyable = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{MZ: buyable}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			case 20:
				var registrationFeeName = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{DN: registrationFeeName}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			case 21:
				var registrationFeeDescription = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{DM: registrationFeeDescription}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			case 1:
				var bool = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{K$: bool}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			case 3:
				var bool = field.a;
				var defaultPeriod = bool ? 'annual' : 'month';
				var _v3 = A3($author$project$Components$Plan$BasicForm$updateDefaultPeriod, maybePlan, defaultPeriod, form);
				var fields = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple3(
					fields,
					cmd,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			case 4:
				var bool = field.a;
				var _v4 = A3(
					$author$project$Components$Plan$BasicForm$updateDefaultPeriod,
					maybePlan,
					'month',
					_Utils_update(
						form,
						{MI: bool}));
				var fields = _v4.a;
				var cmd = _v4.b;
				return _Utils_Tuple3(
					fields,
					cmd,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			case 19:
				var currency = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{JS: currency}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			case 5:
				var string = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{y7: string}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			case 6:
				var string = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{
							y6: $author$project$Utils$String$toMaybe(string)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			case 7:
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{r6: true}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			case 22:
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{nr: true}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			case 8:
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{jB: !form.jB}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			case 9:
				var percentage = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{Bi: percentage}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			case 10:
				var bool = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{Bj: bool}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			case 11:
				var percentage = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{DB: percentage}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			case 12:
				var bool = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{DC: bool}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			case 13:
				var percentage = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{Es: percentage}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			case 14:
				var bool = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{Et: bool}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			case 15:
				var percentage = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{xk: percentage}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			case 16:
				var bool = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{xl: bool}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			case 17:
				var string = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{
							Xf: $elm$core$String$toInt(string)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			case 18:
				var rule = field.a;
				var bool = field.b;
				return _Utils_Tuple3(
					A4($author$project$Components$Plan$BasicForm$toggleRule, maybePlan, rule, bool, form),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			case 23:
				return _Utils_Tuple3(
					form,
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			default:
				var _int = field.a;
				var string = field.b;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{
							rQ: $elm$core$Maybe$Just(string),
							nW: _int,
							TP: $elm$core$Maybe$Just(string)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
		}
	});
var $author$project$Components$Plan$BasicForm$update = F4(
	function (apiClient, msg, _v0, maybePlan) {
		var settings = _v0.a;
		var form = _v0.b;
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var _v2 = A3(
					$author$project$Utils$Form$updateWithCmdAndEvent,
					A3($author$project$Components$Plan$BasicForm$updateField, apiClient, settings, maybePlan),
					field,
					form);
				var newForm = _v2.a;
				var cmd = _v2.b;
				var event = _v2.c;
				return {
					GZ: cmd,
					agZ: event,
					aiO: A2($author$project$Components$Plan$BasicForm$BasicPlanForm, settings, newForm),
					aR: _List_Nil
				};
			case 1:
				var registrationFeeMsg = msg.a;
				var fields = $author$project$Utils$Form$fields(form);
				var result = A3($author$project$Components$Plan$Form$RegistrationFeePricingFields$update, apiClient, registrationFeeMsg, fields.dH);
				var updatedFields = _Utils_update(
					fields,
					{
						DL: $author$project$Components$Plan$Form$RegistrationFeePricingFields$getCategoryId(result.aiO),
						ub: $author$project$Components$Plan$Form$RegistrationFeePricingFields$getCategoryName(result.aiO),
						dH: result.aiO
					});
				var newForm = A2($author$project$Utils$Form$set, updatedFields, form);
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$BasicForm$RegistrationFeePricingFieldsMsg, result.GZ),
					agZ: function () {
						var _v3 = result.agZ;
						var field = _v3;
						return $author$project$Components$Plan$BasicForm$FieldUpdated(
							$author$project$Components$Plan$BasicForm$RegistrationFeePricingField(field));
					}(),
					aiO: A2($author$project$Components$Plan$BasicForm$BasicPlanForm, settings, newForm),
					aR: result.aR
				};
			case 3:
				var pictures = msg.a;
				var cmd = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						function (_v4) {
							var task = _v4.a;
							var size = _v4.b;
							return A2(
								$elm$core$Task$perform,
								A2(
									$elm$core$Basics$composeL,
									$author$project$Components$Plan$BasicForm$FormUpdated,
									$author$project$Components$Plan$BasicForm$Image(size)),
								task);
						},
						A2(
							$elm$core$Maybe$map,
							function (picture) {
								return _Utils_Tuple2(
									$elm$file$File$toUrl(picture),
									$elm$file$File$size(picture));
							},
							$elm$core$List$head(pictures))));
				return {
					GZ: cmd,
					agZ: $author$project$Components$Plan$BasicForm$NoChange,
					aiO: A2($author$project$Components$Plan$BasicForm$BasicPlanForm, settings, form),
					aR: _List_Nil
				};
			default:
				var subMsg = msg.a;
				var fields = $author$project$Utils$Form$fields(form);
				var _v5 = A4($author$project$Components$TranslatedRichText$update, 'plan-description-editor', $elm$core$Maybe$Nothing, subMsg, fields.Qr);
				var newDescription = _v5.a;
				var descCmd = _v5.b;
				var newForm = A2(
					$author$project$Utils$Form$set,
					_Utils_update(
						fields,
						{Qr: newDescription}),
					form);
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$BasicForm$DescriptionMsg, descCmd),
					agZ: $author$project$Components$Plan$BasicForm$NoChange,
					aiO: A2($author$project$Components$Plan$BasicForm$BasicPlanForm, settings, newForm),
					aR: _List_Nil
				};
		}
	});
var $author$project$Components$Plan$Form$AddCoveragePlanModal$Added = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Plan$Form$AddCoveragePlanModal$Closed = {$: 1};
var $author$project$Components$Plan$Form$AddCoveragePlanModal$CoveragePlan = $elm$core$Basics$identity;
var $author$project$Components$Plan$Form$AddCoveragePlanModal$None = {$: 0};
var $author$project$Components$Plan$Form$AddCoveragePlanModal$formFieldsUpdate = F2(
	function (field, fields) {
		var coveragePlan = field;
		return _Utils_update(
			fields,
			{OT: coveragePlan});
	});
var $author$project$Components$Plan$Form$AddCoveragePlanModal$CoveragePlanValidation = 0;
var $author$project$Components$Plan$Form$AddCoveragePlanModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.OT;
			},
			_Utils_Tuple2(0, 'Please pick a coverage plan'))
		]));
var $author$project$Components$ResourceFilter$CoveragePlan$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.b8);
		var modelAfterEvent = function () {
			var _v1 = result.agZ;
			if (!_v1.$) {
				var selected = _v1.a;
				return _Utils_update(
					model,
					{Jy: selected});
			} else {
				return model;
			}
		}();
		return {
			GZ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.GZ),
			agZ: result.agZ,
			aiO: _Utils_update(
				modelAfterEvent,
				{b8: result.aiO}),
			aR: result.aR
		};
	});
var $author$project$Components$Plan$Form$AddCoveragePlanModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 1:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$Plan$Form$AddCoveragePlanModal$Closed, aiO: model, aR: _List_Nil};
			case 0:
				var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$Plan$Form$AddCoveragePlanModal$formFieldsValidator, model.SD);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var newForm = _v3.a;
					var validFormFields = _v3.b;
					var _v4 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
					var coveragePlan = _v4.OT;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: A2(
							$elm$core$Maybe$withDefault,
							$author$project$Components$Plan$Form$AddCoveragePlanModal$None,
							A2($elm$core$Maybe$map, $author$project$Components$Plan$Form$AddCoveragePlanModal$Added, coveragePlan)),
						aiO: _Utils_update(
							model,
							{SD: newForm}),
						aR: _List_Nil
					};
				} else {
					var newForm = _v2.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Plan$Form$AddCoveragePlanModal$None,
						aiO: _Utils_update(
							model,
							{SD: newForm}),
						aR: _List_Nil
					};
				}
			default:
				var subMsg = msg.a;
				var coveragePlanResourceResult = A3($author$project$Components$ResourceFilter$CoveragePlan$update, apiClient, subMsg, model.rM);
				var newForm = function () {
					var _v5 = coveragePlanResourceResult.agZ;
					_v5$2:
					while (true) {
						if (!_v5.$) {
							switch (_v5.a.$) {
								case 0:
									var coveragePlan = _v5.a.a;
									return A3(
										$author$project$Utils$Form$update,
										$author$project$Components$Plan$Form$AddCoveragePlanModal$formFieldsUpdate,
										$elm$core$Maybe$Just(coveragePlan),
										model.SD);
								case 2:
									var _v6 = _v5.a;
									return A3($author$project$Utils$Form$update, $author$project$Components$Plan$Form$AddCoveragePlanModal$formFieldsUpdate, $elm$core$Maybe$Nothing, model.SD);
								default:
									break _v5$2;
							}
						} else {
							break _v5$2;
						}
					}
					return model.SD;
				}();
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$AddCoveragePlanModal$CoveragePlanResourceFilterMsg, coveragePlanResourceResult.GZ),
					agZ: $author$project$Components$Plan$Form$AddCoveragePlanModal$None,
					aiO: _Utils_update(
						model,
						{rM: coveragePlanResourceResult.aiO, SD: newForm}),
					aR: coveragePlanResourceResult.aR
				};
		}
	});
var $author$project$Components$Plan$Form$ConfirmUpdateModal$Closed = 1;
var $author$project$Components$Plan$Form$ConfirmUpdateModal$Confirmed = 2;
var $author$project$Components$Plan$Form$ConfirmUpdateModal$None = 0;
var $author$project$Components$Plan$Form$ConfirmUpdateModal$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{Y2: response}),
					aR: $author$project$OutMsg$handleErrorResponse(response)
				};
			case 2:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: 1, aiO: model, aR: _List_Nil};
			default:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: 2, aiO: model, aR: _List_Nil};
		}
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$SetPeriodMaximumInCentsEdited = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FieldUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$GroupPricingTypeToggled = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$toggleRule = F4(
	function (rule, bool, fields, maybePlan) {
		var rules = fields.aak;
		var newValue = F2(
			function (enabled, getter) {
				return enabled ? getter(maybePlan) : $elm$core$Maybe$Nothing;
			});
		switch (rule) {
			case 0:
				return _Utils_update(
					fields,
					{
						zC: A2(
							newValue,
							bool,
							$elm$core$Maybe$andThen($author$project$Api$Provider$Plan$One$familyNumChildrenIncluded)),
						aak: _Utils_update(
							rules,
							{
								zC: {Ro: bool}
							})
					});
			case 1:
				return _Utils_update(
					fields,
					{
						yS: A2(
							newValue,
							bool,
							function (_v1) {
								return A3($author$project$Components$Plan$Form$FamilyDiscountRuleField$initFromServer, 0, true, $elm$core$Maybe$Nothing);
							}),
						aak: _Utils_update(
							rules,
							{
								yS: {Ro: bool}
							})
					});
			case 2:
				return _Utils_update(
					fields,
					{
						zB: A2(
							newValue,
							bool,
							function (_v2) {
								return A3($author$project$Components$Plan$Form$FamilyDiscountRuleField$initFromServer, 2, true, $elm$core$Maybe$Nothing);
							}),
						aak: _Utils_update(
							rules,
							{
								zB: {Ro: bool}
							})
					});
			case 3:
				return _Utils_update(
					fields,
					{
						aak: _Utils_update(
							rules,
							{
								EG: {Ro: bool}
							}),
						EG: A2(
							newValue,
							bool,
							function (_v3) {
								return A3($author$project$Components$Plan$Form$FamilyDiscountRuleField$initFromServer, 1, true, $elm$core$Maybe$Nothing);
							})
					});
			case 4:
				return _Utils_update(
					fields,
					{
						vC: A2(
							newValue,
							bool,
							function (_v4) {
								return A3($author$project$Components$Plan$Form$FamilyDiscountRuleField$initFromServer, 4, true, $elm$core$Maybe$Nothing);
							}),
						aak: _Utils_update(
							rules,
							{
								vC: {Ro: bool}
							})
					});
			case 5:
				return _Utils_update(
					fields,
					{
						x3: A2(
							newValue,
							bool,
							function (_v5) {
								return A3($author$project$Components$Plan$Form$FamilyDiscountRuleField$initFromServer, 5, true, $elm$core$Maybe$Nothing);
							}),
						aak: _Utils_update(
							rules,
							{
								x3: {Ro: bool}
							})
					});
			case 6:
				return _Utils_update(
					fields,
					{
						BR: A2(
							newValue,
							bool,
							$elm$core$Maybe$andThen($author$project$Api$Provider$Plan$One$numberAdditionalChildrenAllowed)),
						aak: _Utils_update(
							rules,
							{
								BR: {Ro: bool}
							})
					});
			case 7:
				return _Utils_update(
					fields,
					{
						vB: A2(
							newValue,
							bool,
							function (_v6) {
								return A3($author$project$Components$Plan$Form$FamilyDiscountRuleField$initFromServer, 3, true, $elm$core$Maybe$Nothing);
							}),
						aak: _Utils_update(
							rules,
							{
								vB: {Ro: bool}
							})
					});
			default:
				return _Utils_update(
					fields,
					{
						x2: A2(
							newValue,
							bool,
							$elm$core$Maybe$andThen($author$project$Api$Provider$Plan$One$childrenAgeLimit)),
						aak: _Utils_update(
							rules,
							{
								x2: {Ro: bool}
							})
					});
		}
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$updateField = F3(
	function (maybePlan, field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_Tuple3(
					fields,
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$FamilyMembershipPricingFields$GroupPricingTypeToggled(string));
			case 1:
				var rule = field.a;
				var bool = field.b;
				return _Utils_Tuple3(
					A4($author$project$Components$Plan$Form$FamilyMembershipPricingFields$toggleRule, rule, bool, fields, maybePlan),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FieldUpdated(field));
			case 2:
				var string = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							zC: $elm$core$String$toInt(string)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FieldUpdated(field));
			case 3:
				var string = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							BR: $elm$core$String$toInt(string)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FieldUpdated(field));
			case 4:
				var string = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							x2: $elm$core$String$toInt(string)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FieldUpdated(field));
			case 5:
				var type_ = field.a;
				var period = field.b;
				var currency = field.c;
				return _Utils_Tuple3(
					function (_v2) {
						var getter = _v2.a;
						var setter = _v2.b;
						return setter(
							A2(
								$elm$core$Maybe$map,
								function (familyDiscountRule) {
									switch (period) {
										case 'month':
											return _Utils_update(
												familyDiscountRule,
												{Xn: currency, Xo: true});
										case 'quarter':
											return _Utils_update(
												familyDiscountRule,
												{_U: currency, _V: true});
										case 'semi_annual':
											return _Utils_update(
												familyDiscountRule,
												{aaN: currency, aaO: true});
										case 'annual':
											return _Utils_update(
												familyDiscountRule,
												{LL: currency, LM: true});
										default:
											return familyDiscountRule;
									}
								},
								getter(fields)));
					}(
						function () {
							switch (type_) {
								case 0:
									return _Utils_Tuple2(
										function ($) {
											return $.yS;
										},
										function (familyDiscountRule) {
											return _Utils_update(
												fields,
												{yS: familyDiscountRule});
										});
								case 1:
									return _Utils_Tuple2(
										function ($) {
											return $.EG;
										},
										function (familyDiscountRule) {
											return _Utils_update(
												fields,
												{EG: familyDiscountRule});
										});
								case 2:
									return _Utils_Tuple2(
										function ($) {
											return $.zB;
										},
										function (familyDiscountRule) {
											return _Utils_update(
												fields,
												{zB: familyDiscountRule});
										});
								case 3:
									return _Utils_Tuple2(
										function ($) {
											return $.vB;
										},
										function (familyDiscountRule) {
											return _Utils_update(
												fields,
												{vB: familyDiscountRule});
										});
								case 4:
									return _Utils_Tuple2(
										function ($) {
											return $.vC;
										},
										function (familyDiscountRule) {
											return _Utils_update(
												fields,
												{vC: familyDiscountRule});
										});
								default:
									return _Utils_Tuple2(
										function ($) {
											return $.x3;
										},
										function (familyDiscountRule) {
											return _Utils_update(
												fields,
												{x3: familyDiscountRule});
										});
							}
						}()),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FieldUpdated(field));
			case 8:
				var period = field.a;
				return _Utils_Tuple3(
					function (_v4) {
						var getter = _v4.a;
						var setter = _v4.b;
						return setter(
							A2(
								$elm$core$Maybe$map,
								function (familyDiscountRule) {
									switch (period) {
										case 'month':
											return _Utils_update(
												familyDiscountRule,
												{Xo: true});
										case 'quarter':
											return _Utils_update(
												familyDiscountRule,
												{_V: true});
										case 'semi_annual':
											return _Utils_update(
												familyDiscountRule,
												{aaO: true});
										case 'annual':
											return _Utils_update(
												familyDiscountRule,
												{LM: true});
										default:
											return familyDiscountRule;
									}
								},
								getter(fields)));
					}(
						_Utils_Tuple2(
							function ($) {
								return $.zB;
							},
							function (familyDiscountRule) {
								return _Utils_update(
									fields,
									{zB: familyDiscountRule});
							})),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FieldUpdated(field));
			case 6:
				var type_ = field.a;
				var period = field.b;
				return _Utils_Tuple3(
					function (_v7) {
						var getter = _v7.a;
						var setter = _v7.b;
						return setter(
							A2(
								$elm$core$Maybe$map,
								function (familyDiscountRule) {
									switch (period) {
										case 'month':
											return _Utils_update(
												familyDiscountRule,
												{Bl: true});
										case 'quarter':
											return _Utils_update(
												familyDiscountRule,
												{DD: true});
										case 'semi_annual':
											return _Utils_update(
												familyDiscountRule,
												{Eu: true});
										case 'annual':
											return _Utils_update(
												familyDiscountRule,
												{xm: true});
										default:
											return familyDiscountRule;
									}
								},
								getter(fields)));
					}(
						function () {
							switch (type_) {
								case 0:
									return _Utils_Tuple2(
										function ($) {
											return $.yS;
										},
										function (familyDiscountRule) {
											return _Utils_update(
												fields,
												{yS: familyDiscountRule});
										});
								case 1:
									return _Utils_Tuple2(
										function ($) {
											return $.EG;
										},
										function (familyDiscountRule) {
											return _Utils_update(
												fields,
												{EG: familyDiscountRule});
										});
								case 2:
									return _Utils_Tuple2(
										function ($) {
											return $.zB;
										},
										function (familyDiscountRule) {
											return _Utils_update(
												fields,
												{zB: familyDiscountRule});
										});
								case 3:
									return _Utils_Tuple2(
										function ($) {
											return $.vB;
										},
										function (familyDiscountRule) {
											return _Utils_update(
												fields,
												{vB: familyDiscountRule});
										});
								case 4:
									return _Utils_Tuple2(
										function ($) {
											return $.vC;
										},
										function (familyDiscountRule) {
											return _Utils_update(
												fields,
												{vC: familyDiscountRule});
										});
								default:
									return _Utils_Tuple2(
										function ($) {
											return $.x3;
										},
										function (familyDiscountRule) {
											return _Utils_update(
												fields,
												{x3: familyDiscountRule});
										});
							}
						}()),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FieldUpdated(field));
			default:
				var type_ = field.a;
				var period = field.b;
				return _Utils_Tuple3(
					function (_v10) {
						var getter = _v10.a;
						var setter = _v10.b;
						return setter(
							A2(
								$elm$core$Maybe$map,
								function (familyDiscountRule) {
									switch (period) {
										case 'month':
											return _Utils_update(
												familyDiscountRule,
												{Xo: false, Bl: false});
										case 'quarter':
											return _Utils_update(
												familyDiscountRule,
												{_V: false, DD: false});
										case 'semi_annual':
											return _Utils_update(
												familyDiscountRule,
												{aaO: false, Eu: false});
										case 'annual':
											return _Utils_update(
												familyDiscountRule,
												{LM: false, xm: false});
										default:
											return familyDiscountRule;
									}
								},
								getter(fields)));
					}(
						function () {
							switch (type_) {
								case 0:
									return _Utils_Tuple2(
										function ($) {
											return $.yS;
										},
										function (familyDiscountRule) {
											return _Utils_update(
												fields,
												{yS: familyDiscountRule});
										});
								case 1:
									return _Utils_Tuple2(
										function ($) {
											return $.EG;
										},
										function (familyDiscountRule) {
											return _Utils_update(
												fields,
												{EG: familyDiscountRule});
										});
								case 2:
									return _Utils_Tuple2(
										function ($) {
											return $.zB;
										},
										function (familyDiscountRule) {
											return _Utils_update(
												fields,
												{zB: familyDiscountRule});
										});
								case 3:
									return _Utils_Tuple2(
										function ($) {
											return $.vB;
										},
										function (familyDiscountRule) {
											return _Utils_update(
												fields,
												{vB: familyDiscountRule});
										});
								case 4:
									return _Utils_Tuple2(
										function ($) {
											return $.vC;
										},
										function (familyDiscountRule) {
											return _Utils_update(
												fields,
												{vC: familyDiscountRule});
										});
								default:
									return _Utils_Tuple2(
										function ($) {
											return $.x3;
										},
										function (familyDiscountRule) {
											return _Utils_update(
												fields,
												{x3: familyDiscountRule});
										});
							}
						}()),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FieldUpdated(field));
		}
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$update = F3(
	function (msg, _v0, maybePlan) {
		var form = _v0;
		if (!msg.$) {
			var field = msg.a;
			var _v2 = A3(
				$author$project$Utils$Form$updateWithCmdAndEvent,
				$author$project$Components$Plan$Form$FamilyMembershipPricingFields$updateField(maybePlan),
				field,
				form);
			var newForm = _v2.a;
			var newFormCmd = _v2.b;
			var event = _v2.c;
			return {GZ: newFormCmd, agZ: event, aiO: newForm, aR: _List_Nil};
		} else {
			var defaultPeriod = msg.a;
			var _v3 = A3(
				$author$project$Utils$Form$updateWithCmdAndEvent,
				$author$project$Components$Plan$Form$FamilyMembershipPricingFields$updateField(maybePlan),
				$author$project$Components$Plan$Form$FamilyMembershipPricingFields$SetPeriodMaximumInCentsEdited(defaultPeriod),
				form);
			var newForm = _v3.a;
			var newFormCmd = _v3.b;
			var event = _v3.c;
			return {GZ: newFormCmd, agZ: event, aiO: newForm, aR: _List_Nil};
		}
	});
var $author$project$Components$Plan$Form$GroupTierPricingFields$SetAllRateRulePeriodAmountInCentsEdited = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$AdditionalAdultRateRuleUpdated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$AdditionalChildRateRuleUpdated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$CoupleRateRuleUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$FamilyRateRuleUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$FamilyWithSingleChildRateRuleUpdated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$FixedMembershipPricingToggled = {$: 1};
var $author$project$Components$Plan$Form$GroupTierPricingFields$IndividualRateRuleUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$SingleParentRateRuleUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$SingleParentWithSingleChildRateRuleUpdated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$setRateRulePeriodEdited = F2(
	function (period, rateRule) {
		switch (period) {
			case 'month':
				return _Utils_update(
					rateRule,
					{gX: true});
			case 'quarter':
				return _Utils_update(
					rateRule,
					{ho: true});
			case 'semi_annual':
				return _Utils_update(
					rateRule,
					{hz: true});
			case 'annual':
				return _Utils_update(
					rateRule,
					{fE: true});
			default:
				return rateRule;
		}
	});
var $author$project$Components$Plan$Form$GroupTierPricingFields$updateField = F3(
	function (_v0, field, fields) {
		switch (field.$) {
			case 0:
				var rateRule = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{TX: rateRule}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
			case 1:
				var rateRule = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{ON: rateRule}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
			case 2:
				var rateRule = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{R9: rateRule}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
			case 3:
				var rateRule = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{abC: rateRule}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
			case 4:
				var rateRule = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{abE: rateRule}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
			case 5:
				var rateRule = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{Sb: rateRule}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
			case 6:
				var rateRule = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{KZ: rateRule}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
			case 7:
				var rateRule = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{K_: rateRule}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
			case 8:
				var age = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{Sw: age}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
			case 9:
				var adults = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{R8: adults}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
			case 10:
				var children = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{S0: children}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
			case 11:
				var revenueType = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{abW: revenueType}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
			case 14:
				var enabled = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{abF: enabled}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
			case 15:
				var enabled = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{Sc: enabled}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
			case 12:
				var ruleType = field.a;
				switch (ruleType) {
					case 0:
						var rules = fields.aak;
						var bool = !rules.Sw.Ro;
						return _Utils_Tuple3(
							_Utils_update(
								fields,
								{
									aak: _Utils_update(
										rules,
										{
											Sw: {Ro: bool}
										})
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
					case 1:
						var rules = fields.aak;
						var bool = !rules.R8.Ro;
						return _Utils_Tuple3(
							_Utils_update(
								fields,
								{
									aak: _Utils_update(
										rules,
										{
											R8: {Ro: bool}
										})
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
					default:
						var rules = fields.aak;
						var bool = !rules.S0.Ro;
						return _Utils_Tuple3(
							_Utils_update(
								fields,
								{
									aak: _Utils_update(
										rules,
										{
											S0: {Ro: bool}
										})
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
				}
			case 13:
				return _Utils_Tuple3(fields, $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$GroupTierPricingFields$FixedMembershipPricingToggled);
			case 16:
				var type_ = field.a;
				var period = field.b;
				var currency = field.c;
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple3(
						fields,
						$elm$core$Platform$Cmd$none,
						$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field)),
					A2(
						$elm$core$Maybe$map,
						function (_v4) {
							var getter = _v4.a;
							var setter = _v4.b;
							var fixedRateRule = getter(fields);
							var updatedFixedRateRule = function () {
								switch (period) {
									case 'month':
										return _Utils_update(
											fixedRateRule,
											{Xk: currency, gX: true});
									case 'quarter':
										return _Utils_update(
											fixedRateRule,
											{_Q: currency, ho: true});
									case 'semi_annual':
										return _Utils_update(
											fixedRateRule,
											{aaJ: currency, hz: true});
									case 'annual':
										return _Utils_update(
											fixedRateRule,
											{LH: currency, fE: true});
									default:
										return fixedRateRule;
								}
							}();
							var rateRuleUpdatedEvent = function () {
								switch (type_.$) {
									case 0:
										return $author$project$Components$Plan$Form$GroupTierPricingFields$IndividualRateRuleUpdated(updatedFixedRateRule);
									case 1:
										return $author$project$Components$Plan$Form$GroupTierPricingFields$CoupleRateRuleUpdated(updatedFixedRateRule);
									case 2:
										return $author$project$Components$Plan$Form$GroupTierPricingFields$SingleParentRateRuleUpdated(updatedFixedRateRule);
									case 3:
										return $author$project$Components$Plan$Form$GroupTierPricingFields$FamilyRateRuleUpdated(updatedFixedRateRule);
									case 4:
										return $author$project$Components$Plan$Form$GroupTierPricingFields$SingleParentWithSingleChildRateRuleUpdated(updatedFixedRateRule);
									case 5:
										return $author$project$Components$Plan$Form$GroupTierPricingFields$FamilyWithSingleChildRateRuleUpdated(updatedFixedRateRule);
									case 6:
										return $author$project$Components$Plan$Form$GroupTierPricingFields$AdditionalAdultRateRuleUpdated(updatedFixedRateRule);
									case 7:
										return $author$project$Components$Plan$Form$GroupTierPricingFields$AdditionalChildRateRuleUpdated(updatedFixedRateRule);
									default:
										return field;
								}
							}();
							return _Utils_Tuple3(
								setter(updatedFixedRateRule),
								$elm$core$Platform$Cmd$none,
								$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(rateRuleUpdatedEvent));
						},
						function () {
							switch (type_.$) {
								case 0:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $.TX;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{TX: fixedRateRule});
											}));
								case 1:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $.ON;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{ON: fixedRateRule});
											}));
								case 2:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $.abC;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{abC: fixedRateRule});
											}));
								case 3:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $.R9;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{R9: fixedRateRule});
											}));
								case 4:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $.abE;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{abE: fixedRateRule});
											}));
								case 5:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $.Sb;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{Sb: fixedRateRule});
											}));
								case 6:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $.KZ;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{KZ: fixedRateRule});
											}));
								case 7:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $.K_;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{K_: fixedRateRule});
											}));
								case 8:
									return $elm$core$Maybe$Nothing;
								case 9:
									return $elm$core$Maybe$Nothing;
								default:
									return $elm$core$Maybe$Nothing;
							}
						}()));
			case 17:
				var type_ = field.a;
				var period = field.b;
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple3(
						fields,
						$elm$core$Platform$Cmd$none,
						$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field)),
					A2(
						$elm$core$Maybe$map,
						function (_v8) {
							var getter = _v8.a;
							var setter = _v8.b;
							var fixedRateRule = getter(fields);
							var updatedFixedRateRule = function () {
								switch (period) {
									case 'month':
										return _Utils_update(
											fixedRateRule,
											{IB: true});
									case 'quarter':
										return _Utils_update(
											fixedRateRule,
											{_R: true});
									case 'semi_annual':
										return _Utils_update(
											fixedRateRule,
											{aaK: true});
									case 'annual':
										return _Utils_update(
											fixedRateRule,
											{LI: true});
									default:
										return fixedRateRule;
								}
							}();
							return _Utils_Tuple3(
								setter(updatedFixedRateRule),
								$elm$core$Platform$Cmd$none,
								$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
						},
						function () {
							switch (type_.$) {
								case 0:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $.TX;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{TX: fixedRateRule});
											}));
								case 1:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $.ON;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{ON: fixedRateRule});
											}));
								case 2:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $.abC;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{abC: fixedRateRule});
											}));
								case 3:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $.R9;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{R9: fixedRateRule});
											}));
								case 4:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $.abE;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{abE: fixedRateRule});
											}));
								case 5:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $.Sb;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{Sb: fixedRateRule});
											}));
								case 6:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $.KZ;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{KZ: fixedRateRule});
											}));
								case 7:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $.K_;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{K_: fixedRateRule});
											}));
								case 8:
									return $elm$core$Maybe$Nothing;
								case 9:
									return $elm$core$Maybe$Nothing;
								default:
									return $elm$core$Maybe$Nothing;
							}
						}()));
			case 18:
				var type_ = field.a;
				var period = field.b;
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple3(
						fields,
						$elm$core$Platform$Cmd$none,
						$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field)),
					A2(
						$elm$core$Maybe$map,
						function (_v11) {
							var getter = _v11.a;
							var setter = _v11.b;
							var fixedRateRule = getter(fields);
							var updatedFixedRateRule = function () {
								switch (period) {
									case 'month':
										return _Utils_update(
											fixedRateRule,
											{Xk: $elm$core$Maybe$Nothing, gX: false, IB: false});
									case 'quarter':
										return _Utils_update(
											fixedRateRule,
											{_Q: $elm$core$Maybe$Nothing, ho: false, _R: false});
									case 'semi_annual':
										return _Utils_update(
											fixedRateRule,
											{aaJ: $elm$core$Maybe$Nothing, hz: false, aaK: false});
									case 'annual':
										return _Utils_update(
											fixedRateRule,
											{LH: $elm$core$Maybe$Nothing, fE: false, LI: false});
									default:
										return fixedRateRule;
								}
							}();
							var rateRuleUpdatedEvent = function () {
								switch (type_.$) {
									case 0:
										return $author$project$Components$Plan$Form$GroupTierPricingFields$IndividualRateRuleUpdated(updatedFixedRateRule);
									case 1:
										return $author$project$Components$Plan$Form$GroupTierPricingFields$CoupleRateRuleUpdated(updatedFixedRateRule);
									case 2:
										return $author$project$Components$Plan$Form$GroupTierPricingFields$SingleParentRateRuleUpdated(updatedFixedRateRule);
									case 3:
										return $author$project$Components$Plan$Form$GroupTierPricingFields$FamilyRateRuleUpdated(updatedFixedRateRule);
									case 4:
										return $author$project$Components$Plan$Form$GroupTierPricingFields$SingleParentWithSingleChildRateRuleUpdated(updatedFixedRateRule);
									case 5:
										return $author$project$Components$Plan$Form$GroupTierPricingFields$FamilyWithSingleChildRateRuleUpdated(updatedFixedRateRule);
									case 6:
										return $author$project$Components$Plan$Form$GroupTierPricingFields$AdditionalAdultRateRuleUpdated(updatedFixedRateRule);
									case 7:
										return $author$project$Components$Plan$Form$GroupTierPricingFields$AdditionalChildRateRuleUpdated(updatedFixedRateRule);
									default:
										return field;
								}
							}();
							return _Utils_Tuple3(
								setter(updatedFixedRateRule),
								$elm$core$Platform$Cmd$none,
								$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(rateRuleUpdatedEvent));
						},
						function () {
							switch (type_.$) {
								case 0:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $.TX;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{TX: fixedRateRule});
											}));
								case 1:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $.ON;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{ON: fixedRateRule});
											}));
								case 2:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $.abC;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{abC: fixedRateRule});
											}));
								case 3:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $.R9;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{R9: fixedRateRule});
											}));
								case 4:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $.abE;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{abE: fixedRateRule});
											}));
								case 5:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $.Sb;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{Sb: fixedRateRule});
											}));
								case 6:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $.KZ;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{KZ: fixedRateRule});
											}));
								case 7:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $.K_;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{K_: fixedRateRule});
											}));
								case 8:
									return $elm$core$Maybe$Nothing;
								case 9:
									return $elm$core$Maybe$Nothing;
								default:
									return $elm$core$Maybe$Nothing;
							}
						}()));
			default:
				var defaultPeriod = field.a;
				var updatedFields = _Utils_update(
					fields,
					{
						KZ: A2($author$project$Components$Plan$Form$GroupTierPricingFields$setRateRulePeriodEdited, defaultPeriod, fields.KZ),
						K_: A2($author$project$Components$Plan$Form$GroupTierPricingFields$setRateRulePeriodEdited, defaultPeriod, fields.K_),
						ON: A2($author$project$Components$Plan$Form$GroupTierPricingFields$setRateRulePeriodEdited, defaultPeriod, fields.ON),
						R9: A2($author$project$Components$Plan$Form$GroupTierPricingFields$setRateRulePeriodEdited, defaultPeriod, fields.R9),
						Sb: A2($author$project$Components$Plan$Form$GroupTierPricingFields$setRateRulePeriodEdited, defaultPeriod, fields.Sb),
						TX: A2($author$project$Components$Plan$Form$GroupTierPricingFields$setRateRulePeriodEdited, defaultPeriod, fields.TX),
						abC: A2($author$project$Components$Plan$Form$GroupTierPricingFields$setRateRulePeriodEdited, defaultPeriod, fields.abC),
						abE: A2($author$project$Components$Plan$Form$GroupTierPricingFields$setRateRulePeriodEdited, defaultPeriod, fields.abE)
					});
				return _Utils_Tuple3(
					updatedFields,
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
		}
	});
var $author$project$Components$Plan$Form$GroupTierPricingFields$update = F3(
	function (sharedFields, msg, _v0) {
		var form = _v0;
		if (!msg.$) {
			var field = msg.a;
			var _v2 = A3(
				$author$project$Utils$Form$updateWithCmdAndEvent,
				$author$project$Components$Plan$Form$GroupTierPricingFields$updateField(sharedFields),
				field,
				form);
			var newForm = _v2.a;
			var newFormCmd = _v2.b;
			var event = _v2.c;
			return {GZ: newFormCmd, agZ: event, aiO: newForm, aR: _List_Nil};
		} else {
			var defaultPeriod = msg.a;
			var _v3 = A3(
				$author$project$Utils$Form$updateWithCmdAndEvent,
				$author$project$Components$Plan$Form$GroupTierPricingFields$updateField(sharedFields),
				$author$project$Components$Plan$Form$GroupTierPricingFields$SetAllRateRulePeriodAmountInCentsEdited(defaultPeriod),
				form);
			var newForm = _v3.a;
			var newFormCmd = _v3.b;
			var event = _v3.c;
			return {GZ: newFormCmd, agZ: event, aiO: newForm, aR: _List_Nil};
		}
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$SetAgeRateRulePeriodAmountInCentsEdited = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$FieldUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$FixedMembershipPricingToggled = {$: 1};
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$exclusiveRanges = F5(
	function (fromGetter, fromSetter, toGetter, toSetter, range) {
		if ($elm$core$List$isEmpty(range)) {
			return range;
		} else {
			var minimum = A2(
				$elm$core$Maybe$withDefault,
				0,
				A2(
					$elm$core$Maybe$map,
					fromGetter,
					$elm$core$List$head(range)));
			return A2(
				$elm$core$List$indexedMap,
				F2(
					function (index, current) {
						var prev = A2($elm_community$list_extra$List$Extra$getAt, index - 1, range);
						var next = A2($elm_community$list_extra$List$Extra$getAt, index + 1, range);
						var newTo = function () {
							var _v1 = _Utils_Tuple2(
								next,
								toGetter(current));
							if (_v1.a.$ === 1) {
								var _v2 = _v1.a;
								return $elm$core$Maybe$Nothing;
							} else {
								if (_v1.b.$ === 1) {
									var _v3 = _v1.b;
									return toGetter(current);
								} else {
									var currentTo = _v1.b.a;
									var currentFrom = fromGetter(current);
									return (_Utils_cmp(currentTo, currentFrom) < 1) ? $elm$core$Maybe$Just(currentFrom) : toGetter(current);
								}
							}
						}();
						var newFrom = function () {
							var _v0 = A2($elm$core$Maybe$andThen, toGetter, prev);
							if (!_v0.$) {
								var _int = _v0.a;
								return _int + 1;
							} else {
								return minimum;
							}
						}();
						return A2(
							toSetter,
							newTo,
							A2(fromSetter, newFrom, current));
					}),
				range);
		}
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$exclusiveAgeRanges = A4(
	$author$project$Components$Plan$Form$IndividualMembershipPricingFields$exclusiveRanges,
	function (item) {
		return (!item.adL) ? (item.SK * 12) : item.SK;
	},
	F2(
		function (from, item) {
			return (!item.adL) ? _Utils_update(
				item,
				{
					SK: $elm$core$Basics$ceiling(from / 12)
				}) : _Utils_update(
				item,
				{SK: from});
		}),
	function (item) {
		return (!item.adL) ? A2(
			$elm$core$Maybe$map,
			function (age) {
				return age * 12;
			},
			item.adb) : item.adb;
	},
	F2(
		function (to, item) {
			return (!item.adL) ? _Utils_update(
				item,
				{
					adb: A2(
						$elm$core$Maybe$map,
						function (age) {
							return $elm$core$Basics$ceiling(age / 12);
						},
						to)
				}) : _Utils_update(
				item,
				{adb: to});
		}));
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$lastRuleIsInYears = function (rules) {
	var _v0 = $elm_community$list_extra$List$Extra$last(rules);
	if (!_v0.$) {
		var lastRule = _v0.a;
		return (!(!lastRule.adL)) ? A2(
			$author$project$Utils$List$updateLast,
			function (rule) {
				return _Utils_update(
					rule,
					{adL: 0});
			},
			rules) : rules;
	} else {
		return rules;
	}
};
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$fixupAgeRules = function (rules) {
	return $author$project$Components$Plan$Form$IndividualMembershipPricingFields$exclusiveAgeRanges(
		$author$project$Components$Plan$Form$IndividualMembershipPricingFields$lastRuleIsInYears(rules));
};
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$maxMonths = 23;
var $author$project$Components$Plan$Form$AgeRateRuleField$startingFrom = F2(
	function (defaultPeriod, base) {
		return function (ageRateRule) {
			switch (defaultPeriod) {
				case 'month':
					var updatedPeriodRates = ageRateRule.dE;
					return _Utils_update(
						ageRateRule,
						{
							dE: _Utils_update(
								updatedPeriodRates,
								{Xk: base.dE.Xk})
						});
				case 'quarter':
					var updatedPeriodRates = ageRateRule.dE;
					return _Utils_update(
						ageRateRule,
						{
							dE: _Utils_update(
								updatedPeriodRates,
								{_Q: base.dE._Q})
						});
				case 'semi_annual':
					var updatedPeriodRates = ageRateRule.dE;
					return _Utils_update(
						ageRateRule,
						{
							dE: _Utils_update(
								updatedPeriodRates,
								{aaJ: base.dE.aaJ})
						});
				case 'annual':
					var updatedPeriodRates = ageRateRule.dE;
					return _Utils_update(
						ageRateRule,
						{
							dE: _Utils_update(
								updatedPeriodRates,
								{LH: base.dE.LH})
						});
				default:
					return ageRateRule;
			}
		}(
			{
				OM: $elm$core$Maybe$Nothing,
				SK: A2($elm$core$Maybe$withDefault, 0, base.adb) + 1,
				dE: {
					LH: $elm$core$Maybe$Nothing,
					fE: false,
					LI: false,
					Xk: $elm$core$Maybe$Just($author$project$Currency$zero),
					gX: false,
					IB: false,
					_Q: $elm$core$Maybe$Nothing,
					ho: false,
					_R: false,
					aaJ: $elm$core$Maybe$Nothing,
					hz: false,
					aaK: false
				},
				adb: $elm$core$Maybe$Nothing,
				adL: 0
			});
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$updateField = F3(
	function (sharedFields, field, fields) {
		switch (field.$) {
			case 0:
				var _v1 = function () {
					var _v2 = $elm_community$list_extra$List$Extra$last(fields.Lk);
					if (_v2.$ === 1) {
						return _Utils_Tuple2($author$project$Components$Plan$Form$AgeRateRuleField$empty, $elm$core$Maybe$Nothing);
					} else {
						var lastAgeRateRule = _v2.a;
						var newLastAgeRateRule_ = _Utils_update(
							lastAgeRateRule,
							{
								adb: $elm$core$Maybe$Just(lastAgeRateRule.SK + 19)
							});
						return _Utils_Tuple2(
							A2($author$project$Components$Plan$Form$AgeRateRuleField$startingFrom, sharedFields.P6, newLastAgeRateRule_),
							$elm$core$Maybe$Just(newLastAgeRateRule_));
					}
				}();
				var newAgeRateRule = _v1.a;
				var newLastAgeRateRule = _v1.b;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							Lk: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$fixupAgeRules(
								A2(
									$author$project$Utils$List$prepend,
									_List_fromArray(
										[newAgeRateRule]),
									A2(
										$author$project$Utils$List$updateLast,
										function (last) {
											return A2($elm$core$Maybe$withDefault, last, newLastAgeRateRule);
										},
										fields.Lk)))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$IndividualMembershipPricingFields$FieldUpdated(field));
			case 1:
				var index = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							Lk: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$fixupAgeRules(
								A2($elm_community$list_extra$List$Extra$removeAt, index, fields.Lk))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$IndividualMembershipPricingFields$FieldUpdated(field));
			case 2:
				var index = field.a;
				var string = field.b;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							Lk: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$fixupAgeRules(
								A3(
									$elm_community$list_extra$List$Extra$updateAt,
									index,
									function (ageRateRule) {
										return _Utils_update(
											ageRateRule,
											{
												adb: $elm$core$String$toInt(string)
											});
									},
									fields.Lk))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$IndividualMembershipPricingFields$FieldUpdated(field));
			case 3:
				var index = field.a;
				var string = field.b;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							Lk: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$fixupAgeRules(
								A3(
									$elm_community$list_extra$List$Extra$updateAt,
									index,
									function (ageRateRule) {
										var unit = $author$project$Api$Provider$RateRule$Shared$stringToUnit(string);
										return _Utils_update(
											ageRateRule,
											{
												adb: (unit === 1) ? A2(
													$elm$core$Maybe$map,
													function (age) {
														return A2($elm$core$Basics$min, age, $author$project$Components$Plan$Form$IndividualMembershipPricingFields$maxMonths);
													},
													ageRateRule.adb) : ageRateRule.adb,
												adL: unit
											});
									},
									fields.Lk))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$IndividualMembershipPricingFields$FieldUpdated(field));
			case 11:
				var period = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							Lk: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$fixupAgeRules(
								A2(
									$elm$core$List$map,
									function (ageRateRule) {
										var updatedPeriodRates = ageRateRule.dE;
										switch (period) {
											case 'month':
												return _Utils_update(
													ageRateRule,
													{
														dE: _Utils_update(
															updatedPeriodRates,
															{gX: true})
													});
											case 'quarter':
												return _Utils_update(
													ageRateRule,
													{
														dE: _Utils_update(
															updatedPeriodRates,
															{ho: true})
													});
											case 'semi_annual':
												return _Utils_update(
													ageRateRule,
													{
														dE: _Utils_update(
															updatedPeriodRates,
															{hz: true})
													});
											case 'annual':
												return _Utils_update(
													ageRateRule,
													{
														dE: _Utils_update(
															updatedPeriodRates,
															{fE: true})
													});
											default:
												return ageRateRule;
										}
									},
									fields.Lk))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$IndividualMembershipPricingFields$FieldUpdated(field));
			case 4:
				var index = field.a;
				var period = field.b;
				var currency = field.c;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							Lk: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$fixupAgeRules(
								A3(
									$elm_community$list_extra$List$Extra$updateAt,
									index,
									function (ageRateRule) {
										var updatedPeriodRates = ageRateRule.dE;
										switch (period) {
											case 'month':
												return _Utils_update(
													ageRateRule,
													{
														dE: _Utils_update(
															updatedPeriodRates,
															{Xk: currency, gX: true})
													});
											case 'quarter':
												return _Utils_update(
													ageRateRule,
													{
														dE: _Utils_update(
															updatedPeriodRates,
															{_Q: currency, ho: true})
													});
											case 'semi_annual':
												return _Utils_update(
													ageRateRule,
													{
														dE: _Utils_update(
															updatedPeriodRates,
															{aaJ: currency, hz: true})
													});
											case 'annual':
												return _Utils_update(
													ageRateRule,
													{
														dE: _Utils_update(
															updatedPeriodRates,
															{LH: currency, fE: true})
													});
											default:
												return ageRateRule;
										}
									},
									fields.Lk))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$IndividualMembershipPricingFields$FieldUpdated(field));
			case 5:
				var index = field.a;
				var period = field.b;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							Lk: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$fixupAgeRules(
								A3(
									$elm_community$list_extra$List$Extra$updateAt,
									index,
									function (ageRateRule) {
										var updatedPeriodRates = ageRateRule.dE;
										switch (period) {
											case 'month':
												return _Utils_update(
													ageRateRule,
													{
														dE: _Utils_update(
															updatedPeriodRates,
															{IB: true})
													});
											case 'quarter':
												return _Utils_update(
													ageRateRule,
													{
														dE: _Utils_update(
															updatedPeriodRates,
															{_R: true})
													});
											case 'semi_annual':
												return _Utils_update(
													ageRateRule,
													{
														dE: _Utils_update(
															updatedPeriodRates,
															{aaK: true})
													});
											case 'annual':
												return _Utils_update(
													ageRateRule,
													{
														dE: _Utils_update(
															updatedPeriodRates,
															{LI: true})
													});
											default:
												return ageRateRule;
										}
									},
									fields.Lk))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$IndividualMembershipPricingFields$FieldUpdated(field));
			case 6:
				var index = field.a;
				var period = field.b;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							Lk: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$fixupAgeRules(
								A3(
									$elm_community$list_extra$List$Extra$updateAt,
									index,
									function (ageRateRule) {
										var updatedPeriodRates = ageRateRule.dE;
										switch (period) {
											case 'month':
												return _Utils_update(
													ageRateRule,
													{
														dE: _Utils_update(
															updatedPeriodRates,
															{gX: false, IB: false})
													});
											case 'quarter':
												return _Utils_update(
													ageRateRule,
													{
														dE: _Utils_update(
															updatedPeriodRates,
															{ho: false, _R: false})
													});
											case 'semi_annual':
												return _Utils_update(
													ageRateRule,
													{
														dE: _Utils_update(
															updatedPeriodRates,
															{hz: false, aaK: false})
													});
											case 'annual':
												return _Utils_update(
													ageRateRule,
													{
														dE: _Utils_update(
															updatedPeriodRates,
															{fE: false, LI: false})
													});
											default:
												return ageRateRule;
										}
									},
									fields.Lk))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$IndividualMembershipPricingFields$FieldUpdated(field));
			case 7:
				var index = field.a;
				var period = field.b;
				var currency = field.c;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							Lk: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$fixupAgeRules(
								A3(
									$elm_community$list_extra$List$Extra$updateAt,
									index,
									function (ageRateRule) {
										var _v7 = ageRateRule.OM;
										if (!_v7.$) {
											var coupleRule = _v7.a;
											var updatedPeriodRates = coupleRule.dE;
											var updatedCoupleRule = function () {
												switch (period) {
													case 'month':
														return _Utils_update(
															coupleRule,
															{
																dE: _Utils_update(
																	updatedPeriodRates,
																	{Xk: currency, gX: true})
															});
													case 'quarter':
														return _Utils_update(
															coupleRule,
															{
																dE: _Utils_update(
																	updatedPeriodRates,
																	{_Q: currency, ho: true})
															});
													case 'semi_annual':
														return _Utils_update(
															coupleRule,
															{
																dE: _Utils_update(
																	updatedPeriodRates,
																	{aaJ: currency, hz: true})
															});
													case 'annual':
														return _Utils_update(
															coupleRule,
															{
																dE: _Utils_update(
																	updatedPeriodRates,
																	{LH: currency, fE: true})
															});
													default:
														return coupleRule;
												}
											}();
											return _Utils_update(
												ageRateRule,
												{
													OM: $elm$core$Maybe$Just(updatedCoupleRule)
												});
										} else {
											return ageRateRule;
										}
									},
									fields.Lk))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$IndividualMembershipPricingFields$FieldUpdated(field));
			case 8:
				var index = field.a;
				var period = field.b;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							Lk: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$fixupAgeRules(
								A3(
									$elm_community$list_extra$List$Extra$updateAt,
									index,
									function (ageRateRule) {
										var _v9 = ageRateRule.OM;
										if (!_v9.$) {
											var coupleRule = _v9.a;
											var updatedPeriodRates = coupleRule.dE;
											var updatedCoupleRule = function () {
												switch (period) {
													case 'month':
														return _Utils_update(
															coupleRule,
															{
																dE: _Utils_update(
																	updatedPeriodRates,
																	{IB: true})
															});
													case 'quarter':
														return _Utils_update(
															coupleRule,
															{
																dE: _Utils_update(
																	updatedPeriodRates,
																	{_R: true})
															});
													case 'semi_annual':
														return _Utils_update(
															coupleRule,
															{
																dE: _Utils_update(
																	updatedPeriodRates,
																	{aaK: true})
															});
													case 'annual':
														return _Utils_update(
															coupleRule,
															{
																dE: _Utils_update(
																	updatedPeriodRates,
																	{LI: true})
															});
													default:
														return coupleRule;
												}
											}();
											return _Utils_update(
												ageRateRule,
												{
													OM: $elm$core$Maybe$Just(updatedCoupleRule)
												});
										} else {
											return ageRateRule;
										}
									},
									fields.Lk))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$IndividualMembershipPricingFields$FieldUpdated(field));
			case 9:
				var index = field.a;
				var period = field.b;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							Lk: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$fixupAgeRules(
								A3(
									$elm_community$list_extra$List$Extra$updateAt,
									index,
									function (ageRateRule) {
										var _v11 = ageRateRule.OM;
										if (!_v11.$) {
											var coupleRule = _v11.a;
											var updatedPeriodRates = coupleRule.dE;
											var updatedCoupleRule = function () {
												switch (period) {
													case 'month':
														return _Utils_update(
															coupleRule,
															{
																dE: _Utils_update(
																	updatedPeriodRates,
																	{gX: false, IB: false})
															});
													case 'quarter':
														return _Utils_update(
															coupleRule,
															{
																dE: _Utils_update(
																	updatedPeriodRates,
																	{ho: false, _R: false})
															});
													case 'semi_annual':
														return _Utils_update(
															coupleRule,
															{
																dE: _Utils_update(
																	updatedPeriodRates,
																	{hz: false, aaK: false})
															});
													case 'annual':
														return _Utils_update(
															coupleRule,
															{
																dE: _Utils_update(
																	updatedPeriodRates,
																	{fE: false, LI: false})
															});
													default:
														return coupleRule;
												}
											}();
											return _Utils_update(
												ageRateRule,
												{
													OM: $elm$core$Maybe$Just(updatedCoupleRule)
												});
										} else {
											return ageRateRule;
										}
									},
									fields.Lk))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$IndividualMembershipPricingFields$FieldUpdated(field));
			default:
				return _Utils_Tuple3(fields, $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$IndividualMembershipPricingFields$FixedMembershipPricingToggled);
		}
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$update = F3(
	function (sharedFields, msg, _v0) {
		var form = _v0;
		if (!msg.$) {
			var field = msg.a;
			var _v2 = A3(
				$author$project$Utils$Form$updateWithCmdAndEvent,
				$author$project$Components$Plan$Form$IndividualMembershipPricingFields$updateField(sharedFields),
				field,
				form);
			var newForm = _v2.a;
			var newFormCmd = _v2.b;
			var event = _v2.c;
			return {GZ: newFormCmd, agZ: event, aiO: newForm, aR: _List_Nil};
		} else {
			var defaultPeriod = msg.a;
			var _v3 = A3(
				$author$project$Utils$Form$updateWithCmdAndEvent,
				$author$project$Components$Plan$Form$IndividualMembershipPricingFields$updateField(sharedFields),
				$author$project$Components$Plan$Form$IndividualMembershipPricingFields$SetAgeRateRulePeriodAmountInCentsEdited(defaultPeriod),
				form);
			var newForm = _v3.a;
			var newFormCmd = _v3.b;
			var event = _v3.c;
			return {GZ: newFormCmd, agZ: event, aiO: newForm, aR: _List_Nil};
		}
	});
var $author$project$Components$Plan$Form$SpecialRatesFields$FieldUpdated = $elm$core$Basics$identity;
var $author$project$Components$Plan$Form$SpecialRateField$empty = {LH: $elm$core$Maybe$Nothing, fE: false, LI: false, O0: true, Qv: false, ahP: $elm$core$Maybe$Nothing, UN: true, Xk: $elm$core$Maybe$Nothing, gX: false, IB: false, Bq: '', _Q: $elm$core$Maybe$Nothing, ho: false, _R: false, aaJ: $elm$core$Maybe$Nothing, hz: false, aaK: false};
var $author$project$Components$Plan$Form$SpecialRatesFields$updateField = F3(
	function (_v0, field, fields) {
		switch (field.$) {
			case 0:
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							abT: _Utils_ap(
								fields.abT,
								_List_fromArray(
									[$author$project$Components$Plan$Form$SpecialRateField$empty]))
						}),
					$elm$core$Platform$Cmd$none,
					field);
			case 1:
				var index = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							abT: A3(
								$elm_community$list_extra$List$Extra$updateAt,
								index,
								function (specialRate) {
									return _Utils_update(
										specialRate,
										{Qv: true});
								},
								fields.abT)
						}),
					$elm$core$Platform$Cmd$none,
					field);
			case 2:
				var index = field.a;
				var string = field.b;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							abT: A3(
								$elm_community$list_extra$List$Extra$updateAt,
								index,
								function (specialRate) {
									return _Utils_update(
										specialRate,
										{Bq: string});
								},
								fields.abT)
						}),
					$elm$core$Platform$Cmd$none,
					field);
			case 3:
				var index = field.a;
				var period = field.b;
				var currency = field.c;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							abT: A3(
								$elm_community$list_extra$List$Extra$updateAt,
								index,
								function (specialRate) {
									switch (period) {
										case 'month':
											return _Utils_update(
												specialRate,
												{Xk: currency, gX: true});
										case 'quarter':
											return _Utils_update(
												specialRate,
												{_Q: currency, ho: true});
										case 'semi_annual':
											return _Utils_update(
												specialRate,
												{aaJ: currency, hz: true});
										case 'annual':
											return _Utils_update(
												specialRate,
												{LH: currency, fE: true});
										default:
											return specialRate;
									}
								},
								fields.abT)
						}),
					$elm$core$Platform$Cmd$none,
					field);
			case 4:
				var index = field.a;
				var period = field.b;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							abT: A3(
								$elm_community$list_extra$List$Extra$updateAt,
								index,
								function (specialRate) {
									switch (period) {
										case 'month':
											return _Utils_update(
												specialRate,
												{IB: true});
										case 'quarter':
											return _Utils_update(
												specialRate,
												{_R: true});
										case 'semi_annual':
											return _Utils_update(
												specialRate,
												{aaK: true});
										case 'annual':
											return _Utils_update(
												specialRate,
												{LI: true});
										default:
											return specialRate;
									}
								},
								fields.abT)
						}),
					$elm$core$Platform$Cmd$none,
					field);
			default:
				var index = field.a;
				var period = field.b;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							abT: A3(
								$elm_community$list_extra$List$Extra$updateAt,
								index,
								function (specialRate) {
									switch (period) {
										case 'month':
											return _Utils_update(
												specialRate,
												{gX: false, IB: false});
										case 'quarter':
											return _Utils_update(
												specialRate,
												{ho: false, _R: false});
										case 'semi_annual':
											return _Utils_update(
												specialRate,
												{hz: false, aaK: false});
										case 'annual':
											return _Utils_update(
												specialRate,
												{fE: false, LI: false});
										default:
											return specialRate;
									}
								},
								fields.abT)
						}),
					$elm$core$Platform$Cmd$none,
					field);
		}
	});
var $author$project$Components$Plan$Form$SpecialRatesFields$update = F3(
	function (sharedFields, msg, _v0) {
		var form = _v0;
		var field = msg;
		var _v2 = A3(
			$author$project$Components$Plan$Form$SpecialRatesFields$updateField,
			sharedFields,
			field,
			$author$project$Utils$Form$fields(form));
		var updatedFields = _v2.a;
		var cmd = _v2.b;
		var event = _v2.c;
		return {
			GZ: cmd,
			agZ: event,
			aiO: A2($author$project$Utils$Form$set, updatedFields, form),
			aR: _List_Nil
		};
	});
var $author$project$Components$ResourceFilter$Plan$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.b8);
		var modelAfterEvent = function () {
			var _v1 = result.agZ;
			if (!_v1.$) {
				var selected = _v1.a;
				return _Utils_update(
					model,
					{Jy: selected});
			} else {
				return model;
			}
		}();
		return {
			GZ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.GZ),
			agZ: result.agZ,
			aiO: _Utils_update(
				modelAfterEvent,
				{b8: result.aiO}),
			aR: result.aR
		};
	});
var $author$project$Components$Plan$Form$updateDateInputFormField = F6(
	function (model, dateInputGetter, dateInputSetter, subMsg, toMsg, toField) {
		var dateInput = dateInputGetter(model);
		var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
		var newDateInput = _v0.a;
		var subCmd = _v0.b;
		var dateInputEvent = _v0.c;
		var newForm = A2(
			$elm$core$Maybe$map,
			function (_v1) {
				var plan = _v1.a;
				var form = _v1.b;
				var newForm_ = function () {
					if (dateInputEvent.$ === 1) {
						var date = dateInputEvent.a;
						var field_ = toField(date);
						return A3(
							$author$project$Utils$Form$update,
							$author$project$Components$Plan$Form$formFieldsUpdate(plan),
							field_,
							form);
					} else {
						return form;
					}
				}();
				return _Utils_Tuple2(plan, newForm_);
			},
			model.SD);
		return _Utils_Tuple3(
			A2(
				dateInputSetter,
				newDateInput,
				_Utils_update(
					model,
					{SD: newForm})),
			A2($elm$core$Platform$Cmd$map, toMsg, subCmd),
			_List_Nil);
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$DefaultPeriodUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$updateDefaultPeriod = F3(
	function (defaultPeriod, maybePlan, _v0) {
		var form = _v0;
		return A3(
			$author$project$Components$Plan$Form$FamilyMembershipPricingFields$update,
			$author$project$Components$Plan$Form$FamilyMembershipPricingFields$DefaultPeriodUpdated(defaultPeriod),
			form,
			maybePlan);
	});
var $author$project$Components$Plan$Form$GroupTierPricingFields$DefaultPeriodUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$updateDefaultPeriod = F3(
	function (sharedFields, defaultPeriod, _v0) {
		var form = _v0;
		return A3(
			$author$project$Components$Plan$Form$GroupTierPricingFields$update,
			sharedFields,
			$author$project$Components$Plan$Form$GroupTierPricingFields$DefaultPeriodUpdated(defaultPeriod),
			form);
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$DefaultPeriodUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$updateDefaultPeriod = F3(
	function (sharedFields, defaultPeriod, _v0) {
		var form = _v0;
		return A3(
			$author$project$Components$Plan$Form$IndividualMembershipPricingFields$update,
			sharedFields,
			$author$project$Components$Plan$Form$IndividualMembershipPricingFields$DefaultPeriodUpdated(defaultPeriod),
			form);
	});
var $author$project$Components$Plan$Form$calculateOpts = function (field) {
	var _v0 = function () {
		switch (field.$) {
			case 0:
				return _Utils_Tuple2(false, false);
			case 1:
				return _Utils_Tuple2(true, true);
			case 2:
				return _Utils_Tuple2(true, true);
			case 3:
				return _Utils_Tuple2(true, true);
			case 4:
				return _Utils_Tuple2(false, false);
			case 5:
				return _Utils_Tuple2(false, false);
			case 6:
				return _Utils_Tuple2(false, false);
			case 7:
				return _Utils_Tuple2(false, false);
			case 8:
				return _Utils_Tuple2(false, false);
			case 11:
				return _Utils_Tuple2(false, false);
			case 12:
				return _Utils_Tuple2(false, false);
			case 9:
				return _Utils_Tuple2(false, false);
			case 10:
				return _Utils_Tuple2(false, false);
			case 13:
				return _Utils_Tuple2(false, false);
			case 14:
				return _Utils_Tuple2(false, false);
			case 15:
				return _Utils_Tuple2(false, false);
			case 16:
				return _Utils_Tuple2(false, false);
			case 17:
				return _Utils_Tuple2(false, false);
			case 18:
				return _Utils_Tuple2(false, false);
			case 19:
				return _Utils_Tuple2(false, false);
			case 20:
				return _Utils_Tuple2(false, false);
			case 21:
				return _Utils_Tuple2(false, false);
			case 22:
				return _Utils_Tuple2(false, false);
			case 23:
				return _Utils_Tuple2(false, false);
			case 24:
				return _Utils_Tuple2(false, false);
			case 25:
				return _Utils_Tuple2(false, false);
			case 26:
				return _Utils_Tuple2(false, false);
			case 27:
				return _Utils_Tuple2(true, false);
			case 28:
				return _Utils_Tuple2(false, true);
			case 29:
				return _Utils_Tuple2(false, true);
			case 30:
				return _Utils_Tuple2(false, true);
			case 31:
				return _Utils_Tuple2(true, true);
			case 32:
				return _Utils_Tuple2(true, true);
			case 33:
				return _Utils_Tuple2(false, true);
			case 34:
				return _Utils_Tuple2(false, true);
			case 35:
				return _Utils_Tuple2(true, true);
			case 36:
				return _Utils_Tuple2(false, true);
			case 37:
				return _Utils_Tuple2(true, true);
			case 38:
				return _Utils_Tuple2(true, true);
			case 39:
				return _Utils_Tuple2(false, true);
			case 40:
				return _Utils_Tuple2(true, true);
			default:
				return _Utils_Tuple2(false, false);
		}
	}();
	var shouldCalculate_ = _v0.a;
	var validateCalculateFields = _v0.b;
	return {abg: shouldCalculate_, aed: validateCalculateFields};
};
var $author$project$Components$Plan$Form$showWarningModalIfFieldChanged = function (field) {
	switch (field.$) {
		case 0:
			return false;
		case 19:
			return false;
		default:
			return true;
	}
};
var $author$project$Components$Plan$Form$updateForm = F4(
	function (model, plan, field, form) {
		var newForm = A3(
			$author$project$Utils$Form$update,
			$author$project$Components$Plan$Form$formFieldsUpdate(plan),
			field,
			form);
		return A4(
			$author$project$Components$Plan$Form$calculate,
			plan,
			newForm,
			$author$project$Components$Plan$Form$calculateOpts(field),
			_Utils_update(
				model,
				{
					SD: $elm$core$Maybe$Just(
						_Utils_Tuple2(plan, newForm)),
					qa: $author$project$Components$Plan$Form$showWarningModalIfFieldChanged(field)
				}));
	});
var $author$project$Api$Provider$SubsequentPlan$One$changeAfterMonths = function (_v0) {
	var record = _v0.b;
	return record.Nt;
};
var $author$project$Api$Provider$SubsequentPlan$One$changeOnDate = function (_v0) {
	var record = _v0.b;
	return record.Nu;
};
var $author$project$Api$Provider$Plan$Min$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$SubsequentPlan$Min$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$SubsequentPlan$One$id = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Provider$SubsequentPlan$Min$id(min);
};
var $author$project$Api$Provider$Plan$Min$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$SubsequentPlan$One$toPlan = function (_v0) {
	var record = _v0.b;
	return record.adc;
};
var $author$project$Api$Provider$SubsequentPlan$Min$type_ = function (_v0) {
	var record = _v0;
	return record.amg;
};
var $author$project$Api$Provider$SubsequentPlan$One$type_ = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Provider$SubsequentPlan$Min$type_(min);
};
var $author$project$Components$Plan$Form$PlanChange$updateFromSubsequentPlan = F2(
	function (subsequentPlan, planChange) {
		var params = planChange.YL;
		var toPlan = $author$project$Api$Provider$SubsequentPlan$One$toPlan(subsequentPlan);
		return _Utils_update(
			planChange,
			{
				YL: _Utils_update(
					params,
					{
						Nt: $author$project$Api$Provider$SubsequentPlan$One$changeAfterMonths(subsequentPlan),
						Nu: $author$project$Api$Provider$SubsequentPlan$One$changeOnDate(subsequentPlan),
						ahP: $elm$core$Maybe$Just(
							$author$project$Api$Provider$SubsequentPlan$One$id(subsequentPlan)),
						adc: A2(
							$elm$core$Maybe$map,
							function (toPlan_) {
								return {
									ahP: $author$project$Api$Provider$Plan$Min$id(toPlan_),
									Bq: $author$project$Api$Provider$Plan$Min$name(toPlan_),
									alC: $elm$core$Maybe$Nothing
								};
							},
							toPlan),
						amg: $author$project$Api$Provider$SubsequentPlan$One$type_(subsequentPlan)
					})
			});
	});
var $author$project$Components$Plan$Form$updateSuccess = function (model) {
	var route = model.ZX ? A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Plans) : A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, model.Is);
	return _Utils_Tuple3(
		model,
		route,
		_List_fromArray(
			[
				A2($author$project$OutMsg$ShowToast, 3, 'Your pricing has been updated')
			]));
};
var $author$project$Components$Plan$Form$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var loadSubsequentPlan = msg.a;
				var response = msg.b;
				return A2(
					$author$project$Utils$Tuple3$mapSecond,
					function (cmd) {
						return $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									cmd,
									loadSubsequentPlan ? A2($author$project$Components$Plan$Form$fetchSubsequentPlan, apiClient, model.ahP) : $elm$core$Platform$Cmd$none
								]));
					},
					A3($author$project$Components$Plan$Form$resetParamsOnScope, apiClient, response, model));
			case 1:
				var response = msg.a;
				var _v2 = model.SD;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var plan = _v3.a;
					var form = _v3.b;
					var _v4 = $author$project$Utils$Form$fields(form);
					var planChange = _v4.kG;
					_v5$2:
					while (true) {
						switch (response.$) {
							case 3:
								var subsequentPlan = response.a;
								var _v6 = A4(
									$author$project$Components$Plan$Form$updateForm,
									model,
									plan,
									$author$project$Components$Plan$Form$PlanChange(
										A2($author$project$Components$Plan$Form$PlanChange$updateFromSubsequentPlan, subsequentPlan, planChange)),
									form);
								var newModel = _v6.a;
								var formCmd = _v6.b;
								return _Utils_Tuple3(newModel, formCmd, _List_Nil);
							case 2:
								if (response.a.$ === 5) {
									var _v7 = response.a;
									var params = planChange.YL;
									var _v8 = $author$project$Utils$Form$fields(form);
									var contractExpires = _v8.OB;
									var planChangeType = contractExpires ? 2 : 1;
									var newParams = _Utils_update(
										params,
										{amg: planChangeType});
									var _v9 = A4(
										$author$project$Components$Plan$Form$updateForm,
										model,
										plan,
										$author$project$Components$Plan$Form$PlanChange(
											_Utils_update(
												planChange,
												{YL: newParams})),
										form);
									var newModel = _v9.a;
									var formCmd = _v9.b;
									return _Utils_Tuple3(newModel, formCmd, _List_Nil);
								} else {
									break _v5$2;
								}
							default:
								break _v5$2;
						}
					}
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 2:
				var field = msg.a;
				var _v10 = model.SD;
				if (!_v10.$) {
					var _v11 = _v10.a;
					var plan = _v11.a;
					var form = _v11.b;
					var _v12 = A4($author$project$Components$Plan$Form$updateForm, model, plan, field, form);
					var newModel = _v12.a;
					var formCmd = _v12.b;
					return _Utils_Tuple3(newModel, formCmd, _List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var planFormMsg = msg.a;
				var _v13 = model.SD;
				if (!_v13.$) {
					var _v14 = _v13.a;
					var plan = _v14.a;
					var form = _v14.b;
					var _v15 = $author$project$Utils$Form$fields(form);
					var basicPlan = _v15.ab;
					var familyMembershipPricingForm = _v15.dm;
					var membershipPricingForm = _v15.dq;
					var groupTierPricingForm = _v15.k;
					var newBasicPlanResult = A4(
						$author$project$Components$Plan$BasicForm$update,
						apiClient,
						planFormMsg,
						basicPlan,
						$elm$core$Maybe$Just(plan));
					var _v16 = function () {
						var _v17 = newBasicPlanResult.agZ;
						if (_v17.$ === 1) {
							var newForm = A3(
								$author$project$Utils$Form$update,
								$author$project$Components$Plan$Form$formFieldsUpdate(plan),
								$author$project$Components$Plan$Form$BasicPlan(newBasicPlanResult.aiO),
								form);
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										SD: $elm$core$Maybe$Just(
											_Utils_Tuple2(plan, newForm))
									}),
								$elm$core$Platform$Cmd$none);
						} else {
							var field = _v17.a;
							if (field.$ === 3) {
								var defaultPeriod = field.a;
								var tempForm = A3(
									$author$project$Utils$Form$update,
									$author$project$Components$Plan$Form$formFieldsUpdate(plan),
									$author$project$Components$Plan$Form$BasicPlan(newBasicPlanResult.aiO),
									form);
								var sharedFields = A2($author$project$Components$Plan$Form$initSharedFields, plan, tempForm);
								var defaultPeriodString = defaultPeriod ? 'annual' : 'month';
								var familyMembershipPricingResult = A3(
									$author$project$Components$Plan$Form$FamilyMembershipPricingFields$updateDefaultPeriod,
									defaultPeriodString,
									$elm$core$Maybe$Just(plan),
									familyMembershipPricingForm);
								var groupTierPricingResult = A3($author$project$Components$Plan$Form$GroupTierPricingFields$updateDefaultPeriod, sharedFields, defaultPeriodString, groupTierPricingForm);
								var newMembershipPricingResult = A3($author$project$Components$Plan$Form$IndividualMembershipPricingFields$updateDefaultPeriod, sharedFields, defaultPeriodString, membershipPricingForm);
								var newForm = A3(
									$author$project$Utils$Form$update,
									$author$project$Components$Plan$Form$formFieldsUpdate(plan),
									$author$project$Components$Plan$Form$GroupTierPricingFields(groupTierPricingResult.aiO),
									A3(
										$author$project$Utils$Form$update,
										$author$project$Components$Plan$Form$formFieldsUpdate(plan),
										$author$project$Components$Plan$Form$MembershipPricingFields(newMembershipPricingResult.aiO),
										A3(
											$author$project$Utils$Form$update,
											$author$project$Components$Plan$Form$formFieldsUpdate(plan),
											$author$project$Components$Plan$Form$FamilyMembershipPricingFields(familyMembershipPricingResult.aiO),
											tempForm)));
								return A5(
									$author$project$Components$Plan$Form$calculateAfterValidation,
									model,
									plan,
									newForm,
									$author$project$Components$Plan$BasicForm$calculateOpts(field),
									true);
							} else {
								var newForm = A3(
									$author$project$Utils$Form$update,
									$author$project$Components$Plan$Form$formFieldsUpdate(plan),
									$author$project$Components$Plan$Form$BasicPlan(newBasicPlanResult.aiO),
									form);
								return A5(
									$author$project$Components$Plan$Form$calculateAfterValidation,
									model,
									plan,
									newForm,
									$author$project$Components$Plan$BasicForm$calculateOpts(field),
									$author$project$Components$Plan$BasicForm$showWarningModal(field));
							}
						}
					}();
					var newModel = _v16.a;
					var formCmd = _v16.b;
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									formCmd,
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$BasicPlanFormUpdated, newBasicPlanResult.GZ)
								])),
						newBasicPlanResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				var planFormMsg = msg.a;
				var _v19 = model.SD;
				if (!_v19.$) {
					var _v20 = _v19.a;
					var plan = _v20.a;
					var form = _v20.b;
					var sharedFields = A2($author$project$Components$Plan$Form$initSharedFields, plan, form);
					var _v21 = $author$project$Utils$Form$fields(form);
					var membershipPricingForm = _v21.dq;
					var newMembershipPricingResult = A3($author$project$Components$Plan$Form$IndividualMembershipPricingFields$update, sharedFields, planFormMsg, membershipPricingForm);
					var _v22 = function () {
						var _v23 = newMembershipPricingResult.agZ;
						if (!_v23.$) {
							var field = _v23.a;
							var newForm = A3(
								$author$project$Utils$Form$update,
								$author$project$Components$Plan$Form$formFieldsUpdate(plan),
								$author$project$Components$Plan$Form$MembershipPricingFields(newMembershipPricingResult.aiO),
								form);
							return A5(
								$author$project$Components$Plan$Form$calculateAfterValidation,
								model,
								plan,
								newForm,
								$author$project$Components$Plan$Form$IndividualMembershipPricingFields$calculateOpts(field),
								true);
						} else {
							return A4($author$project$Components$Plan$Form$updateForm, model, plan, $author$project$Components$Plan$Form$ToggleFixedMembershipPricing, form);
						}
					}();
					var newModel = _v22.a;
					var formCmd = _v22.b;
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									formCmd,
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$IndividualMembershipPricingFieldsUpdated, newMembershipPricingResult.GZ)
								])),
						newMembershipPricingResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				var planFormMsg = msg.a;
				var _v24 = model.SD;
				if (!_v24.$) {
					var _v25 = _v24.a;
					var plan = _v25.a;
					var form = _v25.b;
					var _v26 = $author$project$Utils$Form$fields(form);
					var familyMembershipPricingForm = _v26.dm;
					var newFamilyMembershipPricingResult = A3(
						$author$project$Components$Plan$Form$FamilyMembershipPricingFields$update,
						planFormMsg,
						familyMembershipPricingForm,
						$elm$core$Maybe$Just(plan));
					var _v27 = function () {
						var _v28 = newFamilyMembershipPricingResult.agZ;
						if (!_v28.$) {
							var groupPricingType = _v28.a;
							return A4(
								$author$project$Components$Plan$Form$updateForm,
								model,
								plan,
								$author$project$Components$Plan$Form$GroupPricingType(groupPricingType),
								form);
						} else {
							var field = _v28.a;
							var newForm = A3(
								$author$project$Utils$Form$update,
								$author$project$Components$Plan$Form$formFieldsUpdate(plan),
								$author$project$Components$Plan$Form$FamilyMembershipPricingFields(newFamilyMembershipPricingResult.aiO),
								form);
							return A5(
								$author$project$Components$Plan$Form$calculateAfterValidation,
								model,
								plan,
								newForm,
								$author$project$Components$Plan$Form$FamilyMembershipPricingFields$calculateOpts(field),
								true);
						}
					}();
					var newModel = _v27.a;
					var formCmd = _v27.b;
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									formCmd,
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$FamilyMembershipPricingFieldsUpdated, newFamilyMembershipPricingResult.GZ)
								])),
						newFamilyMembershipPricingResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var planFormMsg = msg.a;
				var _v29 = model.SD;
				if (!_v29.$) {
					var _v30 = _v29.a;
					var plan = _v30.a;
					var form = _v30.b;
					var sharedFields = A2($author$project$Components$Plan$Form$initSharedFields, plan, form);
					var _v31 = $author$project$Utils$Form$fields(form);
					var groupTierPricingForm = _v31.k;
					var newGroupTierPricingResult = A3($author$project$Components$Plan$Form$GroupTierPricingFields$update, sharedFields, planFormMsg, groupTierPricingForm);
					var _v32 = function () {
						var _v33 = newGroupTierPricingResult.agZ;
						if (!_v33.$) {
							var field = _v33.a;
							var currentFields = $author$project$Utils$Form$fields(form);
							var updatedFields = _Utils_update(
								currentFields,
								{k: newGroupTierPricingResult.aiO});
							var newForm = A2($author$project$Utils$Form$set, updatedFields, form);
							return A5(
								$author$project$Components$Plan$Form$calculateAfterValidation,
								model,
								plan,
								newForm,
								$author$project$Components$Plan$Form$GroupTierPricingFields$calculateOpts(field),
								true);
						} else {
							return A4($author$project$Components$Plan$Form$updateForm, model, plan, $author$project$Components$Plan$Form$ToggleFixedMembershipPricing, form);
						}
					}();
					var newModel = _v32.a;
					var formCmd = _v32.b;
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									formCmd,
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$GroupTierPricingFieldsUpdated, newGroupTierPricingResult.GZ)
								])),
						newGroupTierPricingResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var planFormMsg = msg.a;
				var _v34 = model.SD;
				if (!_v34.$) {
					var _v35 = _v34.a;
					var plan = _v35.a;
					var form = _v35.b;
					var sharedFields = A2($author$project$Components$Plan$Form$initSharedFields, plan, form);
					var _v36 = $author$project$Utils$Form$fields(form);
					var specialRatesForm = _v36.dL;
					var newSpecialRatesResult = A3($author$project$Components$Plan$Form$SpecialRatesFields$update, sharedFields, planFormMsg, specialRatesForm);
					var _v37 = function () {
						var _v38 = newSpecialRatesResult.agZ;
						var field = _v38;
						var currentFields = $author$project$Utils$Form$fields(form);
						var updatedFields = _Utils_update(
							currentFields,
							{dL: newSpecialRatesResult.aiO});
						var newForm = A2($author$project$Utils$Form$set, updatedFields, form);
						return A5(
							$author$project$Components$Plan$Form$calculateAfterValidation,
							model,
							plan,
							newForm,
							$author$project$Components$Plan$Form$SpecialRatesFields$calculateOpts(field),
							true);
					}();
					var newModel = _v37.a;
					var formCmd = _v37.b;
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									formCmd,
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$SpecialRatesFieldsUpdated, newSpecialRatesResult.GZ)
								])),
						newSpecialRatesResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 8:
				var plan = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							f7: $elm$core$Maybe$Just(
								_Utils_Tuple2(plan, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 9:
				var plan = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							f7: $elm$core$Maybe$Just(
								_Utils_Tuple2(plan, $author$project$Api$Data$Loading))
						}),
					A3(
						$author$project$Api$Provider$Plan$delete,
						apiClient,
						$author$project$Api$Provider$Plan$One$id(plan),
						$author$project$Components$Plan$Form$PlanDeleted(plan)),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{f7: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 10:
				var plan = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, model.Is),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Plan removed')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								f7: $elm$core$Maybe$Just(
									_Utils_Tuple2(plan, response))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 11:
				var _v40 = model.SD;
				if (!_v40.$) {
					var _v41 = _v40.a;
					var plan = _v41.a;
					var form = _v41.b;
					var newValidForm = A3($author$project$Components$Plan$Form$validateFormFields, plan, model.ZV, form);
					var sharedFields = A2($author$project$Components$Plan$Form$initSharedFields, plan, newValidForm);
					var _v42 = A2(
						$author$project$Utils$Form$validate,
						A5($author$project$Components$Plan$Form$formFieldsValidator, sharedFields, model.dd, model.qy, model.kH, plan),
						newValidForm);
					if (!_v42.$) {
						var _v43 = _v42.a;
						var newForm = _v43.a;
						var validFormFields = _v43.b;
						var _v44 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
						var planChange = _v44.kG;
						if (model.qa || planChange.cs) {
							var _v45 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
							var contractExpires = _v45.OB;
							var _v46 = A5(
								$author$project$Components$Plan$Form$ConfirmUpdateModal$init,
								apiClient,
								model.ZV,
								plan,
								{OB: contractExpires},
								planChange);
							var confirmUpdateModal = _v46.a;
							var confirmUpdateModalCmd = _v46.b;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										iO: $elm$core$Maybe$Just(
											_Utils_Tuple2(validFormFields, confirmUpdateModal)),
										SD: $elm$core$Maybe$Just(
											_Utils_Tuple2(plan, newForm))
									}),
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$ConfirmUpdateModalMsg, confirmUpdateModalCmd),
								_List_Nil);
						} else {
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										SD: $elm$core$Maybe$Just(
											_Utils_Tuple2(plan, newForm)),
										k9: $author$project$Api$Data$Loading
									}),
								A3($author$project$Components$Plan$Form$saveItem, apiClient, model.ahP, validFormFields),
								_List_Nil);
						}
					} else {
						var newForm = _v42.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									SD: $elm$core$Maybe$Just(
										_Utils_Tuple2(plan, newForm)),
									k9: $author$project$Api$Data$NotAsked
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 12:
				var response = msg.a;
				var _v47 = model.SD;
				if (!_v47.$) {
					var _v48 = _v47.a;
					var form = _v48.b;
					if (response.$ === 3) {
						var _v50 = $author$project$Utils$Form$fields(form);
						var planChange = _v50.kG;
						if (planChange.cs) {
							var apiFields = {
								Nt: planChange.YL.Nt,
								Nu: planChange.YL.Nu,
								adc: A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.ahP;
									},
									planChange.YL.adc)
							};
							return _Utils_Tuple3(
								model,
								A4($author$project$Api$Provider$Plan$SubsequentPlan$update, apiClient, model.ahP, apiFields, $author$project$Components$Plan$Form$SubsequentPlanUpdated),
								_List_Nil);
						} else {
							return $author$project$Components$Plan$Form$updateSuccess(model);
						}
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{k9: response}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 15:
				var subMsg = msg.a;
				var _v51 = model.iO;
				if (!_v51.$) {
					var _v52 = _v51.a;
					var validFormFields = _v52.a;
					var confirmUpdateModal = _v52.b;
					var confirmUpdateModalResult = A2($author$project$Components$Plan$Form$ConfirmUpdateModal$update, subMsg, confirmUpdateModal);
					var _v53 = function () {
						var _v54 = confirmUpdateModalResult.agZ;
						switch (_v54) {
							case 0:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(
										_Utils_Tuple2(validFormFields, confirmUpdateModalResult.aiO)),
									model.k9,
									$elm$core$Platform$Cmd$none);
							case 1:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.k9, $elm$core$Platform$Cmd$none);
							default:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Api$Data$Loading,
									A3($author$project$Components$Plan$Form$saveItem, apiClient, model.ahP, validFormFields));
						}
					}();
					var newConfirmUpdateModal = _v53.a;
					var saveRequest = _v53.b;
					var saveItemCmd = _v53.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{iO: newConfirmUpdateModal, k9: saveRequest}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$ConfirmUpdateModalMsg, confirmUpdateModalResult.GZ),
									saveItemCmd
								])),
						confirmUpdateModalResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 13:
				var validFormFields = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						A3($author$project$Components$Plan$Form$updatePlanRequest, apiClient, model.ahP, validFormFields),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 14:
				var response = msg.a;
				if (response.$ === 3) {
					return $author$project$Components$Plan$Form$updateSuccess(model);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 16:
				var debounceMsg = msg.a;
				var _v57 = A4(
					$jinjor$elm_debounce$Debounce$update,
					$author$project$Components$Plan$Form$previewDebounceConfig,
					$jinjor$elm_debounce$Debounce$takeLast($author$project$Components$Plan$Form$debounceCalculate),
					debounceMsg,
					model.eW);
				var newDebouncer = _v57.a;
				var cmd = _v57.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{eW: newDebouncer}),
					cmd,
					_List_Nil);
			case 17:
				var formFields = msg.a;
				var previousPreviewId = model.akd.a;
				var previewId = previousPreviewId + 1;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							akd: _Utils_Tuple2(previewId, $author$project$Api$Data$Loading)
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A6(
								$author$project$Api$Provider$Plan$calculate,
								apiClient,
								_List_fromArray(
									[1]),
								'plan_preview_' + $elm$core$String$fromInt(previewId),
								model.ahP,
								$author$project$Components$Plan$Form$updatePlanFields(formFields),
								$author$project$Components$Plan$Form$GotPreview(previewId)),
								$elm$http$Http$cancel(
								'plan_preview_' + $elm$core$String$fromInt(previousPreviewId))
							])),
					_List_Nil);
			case 18:
				var previewId = msg.a;
				var response = msg.b;
				return _Utils_eq(model.akd.a, previewId) ? A3($author$project$Components$Plan$Form$resetParamsOnScope, apiClient, response, model) : _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
			case 19:
				var _v58 = model.SD;
				if (!_v58.$) {
					var _v59 = _v58.a;
					var form = _v59.b;
					var _v60 = $author$project$Utils$Form$fields(form);
					var coveragePlan = _v60.OT;
					var _v61 = A2(
						$author$project$Components$Plan$Form$AddCoveragePlanModal$init,
						apiClient,
						A2($elm$core$Maybe$map, $author$project$Components$Plan$Form$coveragePlanId, coveragePlan));
					var addCoveragePlanModal = _v61.a;
					var addCoveragePlanModalCmd = _v61.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ie: $elm$core$Maybe$Just(addCoveragePlanModal)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$AddCoveragePlanModalMsg, addCoveragePlanModalCmd),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 20:
				var subMsg = msg.a;
				var _v62 = model.SD;
				if (!_v62.$) {
					var _v63 = _v62.a;
					var plan = _v63.a;
					var form = _v63.b;
					var _v64 = model.ie;
					if (!_v64.$) {
						var addCoveragePlanModal = _v64.a;
						var addCoveragePlanModalResult = A3($author$project$Components$Plan$Form$AddCoveragePlanModal$update, apiClient, subMsg, addCoveragePlanModal);
						var _v65 = function () {
							var _v66 = addCoveragePlanModalResult.agZ;
							switch (_v66.$) {
								case 0:
									return _Utils_Tuple3(
										model,
										$elm$core$Platform$Cmd$none,
										$elm$core$Maybe$Just(addCoveragePlanModalResult.aiO));
								case 1:
									return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
								default:
									var coveragePlan = _v66.a;
									return A2(
										$author$project$Utils$Tuple3$fromTuple2,
										$elm$core$Maybe$Nothing,
										A4(
											$author$project$Components$Plan$Form$updateForm,
											model,
											plan,
											$author$project$Components$Plan$Form$CoveragePlan(
												$elm$core$Maybe$Just(
													$author$project$Components$Plan$Form$CoveragePlanAll(coveragePlan))),
											form));
							}
						}();
						var newModel = _v65.a;
						var formCmd = _v65.b;
						var newAddCoveragePlanModal = _v65.c;
						return _Utils_Tuple3(
							_Utils_update(
								newModel,
								{ie: newAddCoveragePlanModal}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$AddCoveragePlanModalMsg, addCoveragePlanModalResult.GZ),
										formCmd
									])),
							addCoveragePlanModalResult.aR);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 21:
				var subMsg = msg.a;
				return A6(
					$author$project$Components$Plan$Form$updateDateInputFormField,
					model,
					function ($) {
						return $.tS;
					},
					F2(
						function (newDateInput, model_) {
							return _Utils_update(
								model_,
								{tS: newDateInput});
						}),
					subMsg,
					$author$project$Components$Plan$Form$PlanChangeChangeOnDateInputMsg,
					$author$project$Components$Plan$Form$PlanChangeChangeOnDate);
			case 22:
				var subMsg = msg.a;
				var _v67 = model.eT;
				if (!_v67.$) {
					var planChangeToPlanResourceFilter = _v67.a;
					var planChangeToPlanResourceFilterResult = A3($author$project$Components$ResourceFilter$Plan$update, apiClient, subMsg, planChangeToPlanResourceFilter);
					var newForm = function () {
						var _v68 = _Utils_Tuple2(model.SD, planChangeToPlanResourceFilterResult.agZ);
						if ((!_v68.a.$) && (!_v68.b.$)) {
							if (!_v68.b.a.$) {
								var _v69 = _v68.a.a;
								var plan = _v69.a;
								var form = _v69.b;
								var newPlan = _v68.b.a.a;
								return $elm$core$Maybe$Just(
									_Utils_Tuple2(
										plan,
										A3(
											$author$project$Utils$Form$update,
											$author$project$Components$Plan$Form$formFieldsUpdate(plan),
											$author$project$Components$Plan$Form$PlanChangeToPlan(
												$elm$core$Maybe$Just(newPlan)),
											form)));
							} else {
								var _v70 = _v68.a.a;
								var plan = _v70.a;
								var form = _v70.b;
								return $elm$core$Maybe$Just(
									_Utils_Tuple2(
										plan,
										A3(
											$author$project$Utils$Form$update,
											$author$project$Components$Plan$Form$formFieldsUpdate(plan),
											$author$project$Components$Plan$Form$PlanChangeToPlan($elm$core$Maybe$Nothing),
											form)));
							}
						} else {
							return model.SD;
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								SD: newForm,
								eT: $elm$core$Maybe$Just(planChangeToPlanResourceFilterResult.aiO)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$PlanChangeToPlanResourceFilterMsg, planChangeToPlanResourceFilterResult.GZ),
						planChangeToPlanResourceFilterResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 23:
				var _v71 = model.SD;
				if (!_v71.$) {
					var _v72 = _v71.a;
					var plan = _v72.a;
					return _Utils_Tuple3(
						model,
						A2(
							$author$project$Utils$Route$navigate,
							$elm$core$Dict$empty,
							$author$project$Spa$Generated$Route$Admin__Plans__Id_String__PricingVersions__New(
								{
									ahP: $author$project$Api$Provider$Plan$One$id(plan)
								})),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var _v73 = model.SD;
				if (!_v73.$) {
					var _v74 = _v73.a;
					var plan = _v74.a;
					var _v75 = $author$project$Api$Provider$Plan$One$upcomingPricingVersion(plan);
					if (!_v75.$) {
						var pricingVersion = _v75.a;
						return _Utils_Tuple3(
							model,
							A2(
								$author$project$Utils$Route$navigate,
								$elm$core$Dict$empty,
								$author$project$Spa$Generated$Route$Admin__Plans__Id_String__PricingVersions__PricingVersionId_String(
									{
										ahP: $author$project$Api$Provider$Plan$One$id(plan),
										akh: $author$project$Api$Provider$PricingVersion$Shared$id(pricingVersion)
									})),
							_List_Nil);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Admin$CompanyPlans$Id_String$update = F2(
	function (msg, model) {
		return A2(
			$author$project$Utils$Tuple3$mapFirst,
			function (planForm) {
				return _Utils_update(
					model,
					{pd: planForm});
			},
			A3($author$project$Components$Plan$Form$update, model.Gv, msg, model.pd));
	});
var $author$project$Components$Plan$Form$Save = {$: 11};
var $author$project$Ui$Panel$Hr = {$: 5};
var $author$project$Ui$Panel$hr = $author$project$Ui$Panel$Hr;
var $author$project$Api$Provider$Plan$One$usedInScheduledPlanChanges = function (_v0) {
	var record = _v0.b;
	return record.ad$;
};
var $author$project$Components$Plan$Form$AddCoveragePlanModal$Save = {$: 0};
var $author$project$Components$ResourceFilter$Errors = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$ResourceFilter$errors = $author$project$Components$ResourceFilter$Errors;
var $author$project$Components$ResourceFilter$Invalid = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$ResourceFilter$invalid = $author$project$Components$ResourceFilter$Invalid;
var $author$project$Components$ResourceFilter$CoveragePlan$view = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$view,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.Jy),
					options),
				model.b8));
	});
var $author$project$Components$Plan$Form$AddCoveragePlanModal$view = function (_v0) {
	var model = _v0;
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Plan$Form$AddCoveragePlanModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title(
						(_Utils_eq(model.ahP, $elm$core$Maybe$Nothing) ? 'Add' : 'Change') + ' Coverage Plan')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$onSubmit($author$project$Components$Plan$Form$AddCoveragePlanModal$Save)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$labelSpanSm(4),
										$author$project$Ui$Form$Group$inputSpanSm(8),
										$author$project$Ui$Form$Group$label('Coverage Plan'),
										$author$project$Ui$Form$Group$required(true)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Components$Plan$Form$AddCoveragePlanModal$CoveragePlanResourceFilterMsg,
										A2(
											$author$project$Components$ResourceFilter$CoveragePlan$view,
											_List_fromArray(
												[
													$author$project$Components$ResourceFilter$invalid(
													A2($author$project$Utils$Form$hasValidationErrors, 0, model.SD)),
													$author$project$Components$ResourceFilter$errors(
													A2($author$project$Utils$Form$validationErrors, 0, model.SD))
												]),
											model.rM))
									]))
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Cancel and close'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Plan$Form$AddCoveragePlanModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						function () {
						var verb = _Utils_eq(model.ahP, $elm$core$Maybe$Nothing) ? 'Add' : 'Update';
						return A3(
							$author$project$Ui$Button$view,
							{mm: verb},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$onClick($author$project$Components$Plan$Form$AddCoveragePlanModal$Save)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(verb)
								]));
					}()
					]))
			]));
};
var $author$project$Components$Plan$Form$ConfirmUpdateModal$Confirm = {$: 1};
var $author$project$Api$Provider$Plan$Shared$activeCompaniesCount = function (_v0) {
	var record = _v0;
	return record.KO;
};
var $author$project$Api$Provider$Plan$One$activeCompaniesCount = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$activeCompaniesCount(shared);
};
var $author$project$Api$Provider$Plan$Shared$activeMembershipPatientsCount = function (_v0) {
	var record = _v0;
	return record.KR;
};
var $author$project$Api$Provider$Plan$One$activeMembershipPatientsCount = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$activeMembershipPatientsCount(shared);
};
var $author$project$Components$Plan$Form$ConfirmUpdateModal$maxPatientsCount = 100;
var $author$project$Ui$Types$Sm = 1;
var $author$project$Ui$Spinner$small = $author$project$Ui$Spinner$Size(1);
var $author$project$Api$Provider$Practice$Shared$usesSponsors = function (_v0) {
	var record = _v0;
	return record.ad8;
};
var $author$project$Api$Provider$Practice$One$usesSponsors = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$usesSponsors(shared);
};
var $author$project$Formatters$String$sponsorize = F2(
	function (practice, string) {
		if ($author$project$Api$Provider$Practice$One$usesSponsors(practice)) {
			switch (string) {
				case 'employee':
					return 'member';
				case 'Employee':
					return 'Member';
				case 'employees':
					return 'members';
				case 'employer':
					return 'sponsor';
				case 'employers':
					return 'sponsors';
				case 'Employer':
					return 'Sponsor';
				case 'Employers':
					return 'Sponsors';
				case 'Company':
					return 'Sponsor';
				case 'Companies':
					return 'Sponsors';
				case 'Employer Invoices':
					return 'Sponsor Invoices';
				default:
					return string;
			}
		} else {
			return string;
		}
	});
var $author$project$Components$SpecialRate$PlanChangeWarning$view = function (danger) {
	var options = danger ? _List_fromArray(
		[$author$project$Ui$Typography$danger]) : _List_Nil;
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				A2(
				$author$project$Ui$Typography$label,
				options,
				_List_fromArray(
					[
						$elm$html$Html$text('Special rates will not be applied on the new plan')
					])),
				A2(
				$author$project$Ui$Typography$p,
				options,
				_List_fromArray(
					[
						$elm$html$Html$text('Members on some special rates for this plan will not keep that rate after the scheduled plan change because the new plan does not have the same special rates. They will move to the new plan’s standard pricing unless a manual rate is set.')
					]))
			]));
};
var $author$project$Components$Plan$Form$ConfirmUpdateModal$viewSpecialRatesWarning = function (model) {
	var newSpecialRateNames = A2(
		$elm$core$Maybe$andThen,
		function ($) {
			return $.alC;
		},
		model.kG.YL.adc);
	var currentSpecialRateNames = A2(
		$elm$core$List$map,
		$author$project$Api$Provider$SpecialRate$Shared$name,
		$author$project$Api$Provider$Plan$One$specialRates(model.Jb));
	var hasMissingSpecialRates = function () {
		if (newSpecialRateNames.$ === 1) {
			return false;
		} else {
			var names = newSpecialRateNames.a;
			return A2(
				$elm$core$List$any,
				function (n) {
					return !A2($elm$core$List$member, n, names);
				},
				currentSpecialRateNames);
		}
	}();
	return ((!$elm$core$List$isEmpty(currentSpecialRateNames)) && hasMissingSpecialRates) ? $author$project$Components$SpecialRate$PlanChangeWarning$view(false) : $author$project$Utils$Html$empty;
};
var $author$project$Components$Plan$Form$ConfirmUpdateModal$view = function (model) {
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Plan$Form$ConfirmUpdateModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Confirm updates')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Updated membership pricing')
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('You\'re about to update membership pricing which may affect the rates of '),
										$elm$html$Html$text(
										A2(
											$author$project$Formatters$String$pluralize,
											'patient',
											$author$project$Api$Provider$Plan$One$activeMembershipPatientsCount(model.Jb))),
										(!$author$project$Api$Provider$Plan$One$planType(model.Jb)) ? $elm$html$Html$text('across ') : $author$project$Utils$Html$empty,
										(!$author$project$Api$Provider$Plan$One$planType(model.Jb)) ? $elm$html$Html$text(
										A2(
											$author$project$Formatters$String$pluralize,
											A2($author$project$Formatters$String$sponsorize, model.ZV, 'employer'),
											$author$project$Api$Provider$Plan$One$activeCompaniesCount(model.Jb))) : $author$project$Utils$Html$empty,
										$elm$html$Html$text(' on their next bill unless they have a manual rate set.')
									])),
								model.YL.OB ? A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Note: these pricing changes will apply to patients on this plan immediately, not at the end of their contract period.')
									])) : $author$project$Utils$Html$empty
							])),
						model.kG.cs ? A2(
						$author$project$Ui$Element$view,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$HorizontalRule$view(_List_Nil),
								A2(
								$author$project$Ui$Typography$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Added plan change')
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('You have enabled a plan change effective '),
										function () {
										var _v0 = model.kG.YL.amg;
										switch (_v0) {
											case 1:
												var changeAfterMonths = A2($elm$core$Maybe$withDefault, 0, model.kG.YL.Nt);
												return A2(
													$author$project$Ui$Element$view,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2($author$project$Formatters$String$pluralize, 'month', changeAfterMonths)),
															$elm$html$Html$text(' after the membership starts.')
														]));
											case 0:
												return A2(
													$author$project$Ui$Element$view,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('on '),
															$elm$html$Html$text(
															A2(
																$elm$core$Maybe$withDefault,
																'N/A',
																A2(
																	$elm$core$Maybe$map,
																	$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
																	model.kG.YL.Nu)))
														]));
											default:
												var contractPeriodInMonths = A2($elm$core$Maybe$withDefault, 0, model.kG.YL.OC);
												return A2(
													$author$project$Ui$Element$view,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2($author$project$Formatters$String$pluralize, 'month', contractPeriodInMonths)),
															$elm$html$Html$text(' after the membership starts.')
														]));
										}
									}(),
										function () {
										var _v1 = model.Y2;
										switch (_v1.$) {
											case 3:
												var patientsCount = _v1.a;
												return A2(
													$author$project$Ui$Element$view,
													_List_Nil,
													function () {
														if (!patientsCount.$) {
															if (!patientsCount.a) {
																return _List_fromArray(
																	[
																		$author$project$Utils$Html$noBreakSpace,
																		$elm$html$Html$text('No patients with this plan will be transitioned to the new plan if you confirm this.')
																	]);
															} else {
																var count = patientsCount.a;
																return _List_fromArray(
																	[
																		$author$project$Utils$Html$noBreakSpace,
																		$elm$html$Html$text(
																		A2($author$project$Formatters$String$pluralize, 'patient', count)),
																		$elm$html$Html$text(' with this plan will be immediately transitioned to the new plan if you confirm this. '),
																		$elm$html$Html$text('You will receive an email with an attachment containing the patient ids of the patients affected.')
																	]);
															}
														} else {
															return _List_fromArray(
																[
																	$author$project$Utils$Html$noBreakSpace,
																	$elm$html$Html$text('More than '),
																	$elm$html$Html$text(
																	A2($author$project$Formatters$String$pluralize, 'patient', $author$project$Components$Plan$Form$ConfirmUpdateModal$maxPatientsCount)),
																	$elm$html$Html$text(' with this plan will be immediately transitioned to the new plan if you confirm this. '),
																	$elm$html$Html$text('You will receive an email with an attachment containing the patient ids of the patients affected.')
																]);
														}
													}());
											case 0:
												return $author$project$Utils$Html$empty;
											default:
												return $author$project$Ui$Spinner$view(
													_List_fromArray(
														[$author$project$Ui$Spinner$small]));
										}
									}()
									])),
								$author$project$Components$Plan$Form$ConfirmUpdateModal$viewSpecialRatesWarning(model)
							])) : $author$project$Utils$Html$empty,
						model.kG.ud ? A2(
						$author$project$Ui$Element$view,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$HorizontalRule$view(_List_Nil),
								A2(
								$author$project$Ui$Typography$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Removed plan change')
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('You have removed the plan change. '),
										$elm$html$Html$text('All the memberships that were already transitioned to the new plan will not be moved back.')
									]))
							])) : $author$project$Utils$Html$empty
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Plan$Form$ConfirmUpdateModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Confirm updates'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$onClick($author$project$Components$Plan$Form$ConfirmUpdateModal$Confirm)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Confirm updates')
							]))
					]))
			]));
};
var $author$project$Components$Plan$Form$modal = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				function () {
				var _v0 = model.f7;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var plan = _v1.a;
					var deleteRequest = _v1.b;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Components$Plan$Form$DeleteHiConfirmClosed(plan),
						A2(
							$elm$core$List$cons,
							$author$project$Components$HiConfirm$noun('plan'),
							A2(
								$elm$core$List$cons,
								$author$project$Components$HiConfirm$verb('delete'),
								A2(
									$elm$core$List$cons,
									$author$project$Components$HiConfirm$loading(
										_Utils_eq(deleteRequest, $author$project$Api$Data$Loading)),
									$author$project$Api$Provider$Plan$One$usedInScheduledPlanChanges(plan) ? _List_fromArray(
										[
											$author$project$Components$HiConfirm$customMessage(
											_List_fromArray(
												[
													$elm$html$Html$text('This plan is used in scheduled plan changes. Deleting it will remove those scheduled changes from existing and new memberships.')
												]))
										]) : _List_Nil))));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v2 = model.iO;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var confirmUpdateModal = _v3.b;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$Plan$Form$ConfirmUpdateModalMsg,
						$author$project$Components$Plan$Form$ConfirmUpdateModal$view(confirmUpdateModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v4 = model.ie;
				if (!_v4.$) {
					var addCoveragePlanModal = _v4.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$Plan$Form$AddCoveragePlanModalMsg,
						$author$project$Components$Plan$Form$AddCoveragePlanModal$view(addCoveragePlanModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]));
};
var $author$project$Ui$Panel$OnlyBorderLeft = {$: 3};
var $author$project$Ui$Panel$onlyBorderLeft = $author$project$Ui$Panel$OnlyBorderLeft;
var $author$project$Components$Plan$Form$DeletePlan = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$Plan$Shared$isDestroyable = function (_v0) {
	var record = _v0;
	return record.UN;
};
var $author$project$Api$Provider$Plan$One$isDestroyable = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$isDestroyable(shared);
};
var $author$project$Ui$Link$Mailto = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Link$mailto = F3(
	function (mailto_, options, content) {
		return A2(
			$author$project$Ui$Link$view,
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Link$Mailto(mailto_),
				options),
			content);
	});
var $author$project$Components$Plan$Form$viewBackButton = function (listRoute) {
	return A3(
		$author$project$Ui$Link$route,
		listRoute,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Back')
			]));
};
var $author$project$Components$Plan$Form$viewFooter = F2(
	function (model, maybePlanAndForm) {
		return A2(
			$author$project$Ui$Panel$footer,
			_List_fromArray(
				[$author$project$Ui$Element$flexCol]),
			function () {
				if (!maybePlanAndForm.$) {
					var _v1 = maybePlanAndForm.a;
					var plan = _v1.a;
					var form = _v1.b;
					return _List_fromArray(
						[
							$author$project$Utils$Form$hasAnyValidationError(form) ? A2(
							$author$project$Ui$Grid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$offsetSm(3),
											$author$project$Ui$Grid$spanSm(6)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Alert$danger,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Please review the errors above')
												]))
										]))
								])) : $author$project$Utils$Html$empty,
							$author$project$Api$Provider$Plan$One$isMcePlan(plan) ? A2(
							$author$project$Ui$Grid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$offsetSm(3),
											$author$project$Ui$Grid$spanSm(6)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Alert$danger,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('This plan requires special pricing. '),
													$elm$html$Html$text('If you have questions or need to make changes, please contact us at '),
													A3(
													$author$project$Ui$Link$mailto,
													'support@hint.com',
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('support@hint.com')
														]))
												]))
										]))
								])) : $author$project$Utils$Html$empty,
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$gap2, $author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$itemsCenter]),
							_List_fromArray(
								[
									$author$project$Components$Plan$Form$viewBackButton(model.Is),
									$author$project$Api$Provider$Plan$One$isDestroyable(plan) ? A3(
									$author$project$Ui$Button$view,
									{mm: 'Delete plan'},
									_List_fromArray(
										[
											$author$project$Ui$Button$danger,
											$author$project$Ui$Button$onClick(
											$author$project$Components$Plan$Form$DeletePlan(plan)),
											$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Delete')
										])) : $author$project$Utils$Html$empty,
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Save plan'},
									_List_fromArray(
										[
											$author$project$Ui$Button$primary,
											$author$project$Ui$Button$submit,
											$author$project$Ui$Button$loading(
											_Utils_eq(model.k9, $author$project$Api$Data$Loading))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Save Plan')
										]))
								]))
						]);
				} else {
					return _List_fromArray(
						[
							$author$project$Components$Plan$Form$viewBackButton(model.Is)
						]);
				}
			}());
	});
var $author$project$Components$Plan$BasicForm$EditRegistrationFeeCategory = {$: 8};
var $author$project$Components$Plan$BasicForm$EditRegistrationFeeDescription = {$: 22};
var $author$project$Components$Plan$BasicForm$RegistrationFeeDescription = function (a) {
	return {$: 21, a: a};
};
var $author$project$Components$Plan$BasicForm$RegistrationFeeName = function (a) {
	return {$: 20, a: a};
};
var $author$project$Components$Plan$BasicForm$Addon = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Feature$MultipleRetailMemberships = 17;
var $author$project$Ui$Form$Group$LabelHelp = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Form$Group$labelHelp = $author$project$Ui$Form$Group$LabelHelp;
var $author$project$Components$Plan$BasicForm$viewAddonPlanField = F3(
	function (form, settings, forCompany) {
		var hasMultipleMemberships = A2($author$project$Api$Provider$Practice$One$featureEnabled, 17, settings.ZV);
		var showAddonToggle = hasMultipleMemberships && (settings.Aq && (!forCompany));
		if (showAddonToggle) {
			var _v0 = $author$project$Utils$Form$fields(form);
			var addon = _v0.K$;
			return A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mb2]),
						_List_fromArray(
							[
								$author$project$Ui$Typography$headingSm(
								_List_fromArray(
									[
										$elm$html$Html$text('Enrollment Settings')
									]))
							])),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$offsetLabel,
								$author$project$Ui$Form$Group$labelSpanSm(5),
								$author$project$Ui$Form$Group$inputSpanSm(6),
								$author$project$Ui$Form$Group$label('Add-On Plan'),
								$author$project$Ui$Form$Group$labelClass(''),
								$author$project$Ui$Form$Group$labelHelp(
								$elm$html$Html$text('Patients can enroll in multiple add-ons at once'))
							]),
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$view(
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$on(addon),
										$author$project$Ui$ToggleSwitch$onChange(
										A2($elm$core$Basics$composeL, $author$project$Components$Plan$BasicForm$FormUpdated, $author$project$Components$Plan$BasicForm$Addon))
									]))
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$Plan$BasicForm$BillsAtEndOfPeriod = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Plan$BasicForm$DefaultChargeDescription = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Plan$BasicForm$DefaultChargeName = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Plan$BasicForm$EditDefaultChargeDescription = {$: 7};
var $author$project$Components$Plan$BasicForm$MinimumEnrollmentPeriodInMonths = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Plan$BasicForm$MinimumEnrollmentPeriodInMonthsRule = 0;
var $author$project$Components$Plan$BasicForm$ToggleRule = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Ui$Form$PeriodInMonthsInput$view = function (_v0) {
	var value = _v0.aee;
	var onInput = _v0.ajm;
	var invalid = _v0.sM;
	var errors = _v0.agX;
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$group(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									A2($elm$core$Maybe$map, $elm$core$String$fromInt, value))),
								$author$project$Ui$Form$Input$onInput(onInput),
								$author$project$Ui$Form$Input$invalid(invalid)
							])),
						$author$project$Ui$Form$Input$addon(
						_List_fromArray(
							[
								(A2($elm$core$Maybe$withDefault, 0, value) === 1) ? $elm$html$Html$text('month') : $elm$html$Html$text('months')
							]))
					])),
				$author$project$Utils$FormErrors$view(errors)
			]));
};
var $author$project$Ui$SupportDocumentLink$view = function (supportDocumenUrl) {
	return A3(
		$author$project$Ui$Link$externalHref,
		supportDocumenUrl,
		_List_fromArray(
			[$author$project$Ui$Link$targetBlank]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$span,
				_List_fromArray(
					[$author$project$Ui$Typography$small]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Tooltip$view,
						_List_Nil,
						'Click to Learn More',
						_List_fromArray(
							[
								$author$project$Ui$Icon$help(_List_Nil)
							]))
					]))
			]));
};
var $author$project$Components$Plan$BasicForm$DefaultPeriod = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Plan$Meta$allPeriodCodes = function (_v0) {
	var meta = _v0;
	return meta.Ls;
};
var $author$project$Api$Provider$Plan$Meta$defaultAllPeriodCodes = _List_fromArray(
	['month', 'quarter', 'semi_annual', 'annual']);
var $author$project$Components$Plan$BasicForm$AnnualAdjustmentPercent = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Plan$BasicForm$AnnualAllowed = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Plan$BasicForm$MonthAdjustmentPercent = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Plan$BasicForm$MonthAllowed = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Plan$BasicForm$QuarterAdjustmentPercent = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Plan$BasicForm$QuarterAllowed = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Plan$BasicForm$SemiAnnualAdjustmentPercent = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Plan$BasicForm$SemiAnnualAllowed = function (a) {
	return {$: 14, a: a};
};
var $author$project$Ui$Form$PercentageInput$Invalid = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Form$PercentageInput$invalid = $author$project$Ui$Form$PercentageInput$Invalid;
var $author$project$Ui$Grid$None = 0;
var $author$project$Ui$Grid$noGutter = $author$project$Ui$Grid$Gutter(0);
var $author$project$Ui$Form$PercentageInput$OnInput = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$PercentageInput$onInput = $author$project$Ui$Form$PercentageInput$OnInput;
var $author$project$Ui$Grid$rowItemsEnd = $author$project$Ui$Grid$RowElement($author$project$Ui$Element$itemsEnd);
var $author$project$Ui$Form$PercentageInput$Value = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$PercentageInput$value = $author$project$Ui$Form$PercentageInput$Value;
var $author$project$Ui$Form$PercentageInput$defaultOptions = {agX: _List_Nil, aN: _List_Nil, sM: false, aee: $elm$core$Maybe$Nothing};
var $author$project$Percentage$fromString = $elm$core$Basics$identity;
var $author$project$Ui$Form$PercentageInput$inputHandler = function (handler) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Utils$String$toMaybe,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($author$project$Percentage$fromString),
			handler));
};
var $author$project$Percentage$toString = function (_v0) {
	var string = _v0;
	return string;
};
var $author$project$Ui$Form$PercentageInput$inputValue = function (percentage) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Maybe$map, $author$project$Percentage$toString, percentage));
};
var $author$project$Ui$Form$PercentageInput$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var handler = option.a;
						return _Utils_update(
							record,
							{
								aN: A2(
									$elm$core$List$cons,
									$author$project$Ui$Form$Input$onInput(
										$author$project$Ui$Form$PercentageInput$inputHandler(handler)),
									record.aN)
							});
					case 1:
						var percentage = option.a;
						return _Utils_update(
							record,
							{
								aN: A2(
									$elm$core$List$cons,
									$author$project$Ui$Form$Input$value(
										$author$project$Ui$Form$PercentageInput$inputValue(percentage)),
									record.aN),
								aee: percentage
							});
					case 2:
						var bool = option.a;
						return _Utils_update(
							record,
							{sM: bool});
					case 3:
						var list = option.a;
						return _Utils_update(
							record,
							{agX: list});
					case 4:
						var string = option.a;
						return _Utils_update(
							record,
							{
								aN: A2(
									$elm$core$List$cons,
									$author$project$Ui$Form$Input$placeholder(string),
									record.aN)
							});
					default:
						var bool = option.a;
						return _Utils_update(
							record,
							{
								aN: A2(
									$elm$core$List$cons,
									$author$project$Ui$Form$Input$disabled(bool),
									record.aN)
							});
				}
			}),
		$author$project$Ui$Form$PercentageInput$defaultOptions,
		options);
};
var $author$project$Ui$Form$PercentageInput$view = function (options) {
	var optionsRecord = $author$project$Ui$Form$PercentageInput$optionsToRecord(options);
	return $author$project$Ui$Form$Input$group(
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				A2(
					$elm$core$List$cons,
					$author$project$Ui$Form$Input$invalid(optionsRecord.sM),
					A2(
						$elm$core$List$cons,
						$author$project$Ui$Form$Input$errors(optionsRecord.agX),
						A2($elm$core$List$cons, $author$project$Ui$Form$Input$number, optionsRecord.aN)))),
				$author$project$Ui$Form$Input$addon(
				_List_fromArray(
					[
						$elm$html$Html$text('%')
					]))
			]));
};
var $author$project$Components$Plan$BasicForm$viewPeriodField = F3(
	function (defaultPeriod, form, periodCode) {
		var fields = $author$project$Utils$Form$fields(form);
		var _v0 = function () {
			switch (periodCode) {
				case 'month':
					return _Utils_Tuple2(fields.Bj, $author$project$Components$Plan$BasicForm$MonthAllowed);
				case 'quarter':
					return _Utils_Tuple2(fields.DC, $author$project$Components$Plan$BasicForm$QuarterAllowed);
				case 'semi_annual':
					return _Utils_Tuple2(fields.Et, $author$project$Components$Plan$BasicForm$SemiAnnualAllowed);
				case 'annual':
					return _Utils_Tuple2(fields.xl, $author$project$Components$Plan$BasicForm$AnnualAllowed);
				default:
					return _Utils_Tuple2(fields.Bj, $author$project$Components$Plan$BasicForm$MonthAllowed);
			}
		}();
		var on = _v0.a;
		var field = _v0.b;
		return (!_Utils_eq(periodCode, defaultPeriod)) ? A2(
			$author$project$Ui$Typography$p,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_fromArray(
						[$author$project$Ui$Grid$rowItemsEnd, $author$project$Ui$Grid$noGutter]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(4),
									$author$project$Ui$Grid$offsetSm(2)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$label,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$textSm]),
											_List_fromArray(
												[$author$project$Utils$Html$noBreakSpace])),
											$elm$html$Html$text(
											$author$project$Formatters$String$humanize(periodCode)),
											$elm$html$Html$text('ly')
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(2),
									$author$project$Ui$Grid$justifyLeft
								]),
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$view(
									_List_fromArray(
										[
											$author$project$Ui$ToggleSwitch$on(on),
											$author$project$Ui$ToggleSwitch$onChange(
											A2($elm$core$Basics$composeL, $author$project$Components$Plan$BasicForm$FormUpdated, field))
										]))
								])),
							function () {
							if (on) {
								var _v2 = function () {
									switch (periodCode) {
										case 'month':
											return _Utils_Tuple3(fields.Bi, $author$project$Components$Plan$BasicForm$MonthAdjustmentPercent, 1);
										case 'quarter':
											return _Utils_Tuple3(fields.DB, $author$project$Components$Plan$BasicForm$QuarterAdjustmentPercent, 2);
										case 'semi_annual':
											return _Utils_Tuple3(fields.Es, $author$project$Components$Plan$BasicForm$SemiAnnualAdjustmentPercent, 3);
										case 'annual':
											return _Utils_Tuple3(fields.xk, $author$project$Components$Plan$BasicForm$AnnualAdjustmentPercent, 4);
										default:
											return _Utils_Tuple3(fields.Bi, $author$project$Components$Plan$BasicForm$MonthAdjustmentPercent, 1);
									}
								}();
								var adjustmentPercentage = _v2.a;
								var adjustmentField = _v2.b;
								var adjustmentValidation = _v2.c;
								return A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanSm(4)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
											_List_fromArray(
												[
													function () {
													switch (defaultPeriod) {
														case 'month':
															return $elm$html$Html$text('Default Discount');
														case 'annual':
															return $elm$html$Html$text('Default Surcharge');
														default:
															return $author$project$Utils$Html$empty;
													}
												}()
												])),
											$author$project$Ui$Form$PercentageInput$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$PercentageInput$value(adjustmentPercentage),
													$author$project$Ui$Form$PercentageInput$onInput(
													A2($elm$core$Basics$composeL, $author$project$Components$Plan$BasicForm$FormUpdated, adjustmentField)),
													$author$project$Ui$Form$PercentageInput$invalid(
													A2($author$project$Utils$Form$hasValidationErrors, adjustmentValidation, form))
												])),
											$author$project$Utils$FormErrors$view(
											A2($author$project$Utils$Form$validationErrors, adjustmentValidation, form))
										]));
							} else {
								return $author$project$Ui$Grid$none;
							}
						}()
						]))
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Components$Plan$BasicForm$viewBillingPeriodsFields = F3(
	function (practiceIsOnboarding, maybePlan, form) {
		var _v0 = $author$project$Utils$Form$fields(form);
		var billsAtEndOfPeriod = _v0.MI;
		var defaultPeriod = _v0.P6;
		var formGroupOptions = _Utils_ap(
			billsAtEndOfPeriod ? _List_fromArray(
				[
					$author$project$Ui$Form$Group$labelHelp(
					$elm$html$Html$text('You can only bill monthly when billing at the end of the period'))
				]) : _List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$offsetLabel,
					$author$project$Ui$Form$Group$labelSpanSm(5),
					$author$project$Ui$Form$Group$inputSpanSm(6),
					$author$project$Ui$Form$Group$label(
					practiceIsOnboarding ? 'Default Billing Period is month' : 'Default Billing Period'),
					$author$project$Ui$Form$Group$labelClass('')
				]));
		return A2(
			$elm$core$List$cons,
			A2(
				$author$project$Ui$Form$Group$view,
				formGroupOptions,
				_List_fromArray(
					[
						practiceIsOnboarding ? $author$project$Utils$Html$empty : $author$project$Ui$Button$group(
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Select annual period'},
								_List_fromArray(
									[
										$author$project$Ui$Button$disabled(billsAtEndOfPeriod),
										$author$project$Ui$Button$active(defaultPeriod === 'annual'),
										$author$project$Ui$Button$onClick(
										$author$project$Components$Plan$BasicForm$FormUpdated(
											$author$project$Components$Plan$BasicForm$DefaultPeriod(true)))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Annual')
									])),
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Select monthly period'},
								_List_fromArray(
									[
										$author$project$Ui$Button$disabled(billsAtEndOfPeriod),
										$author$project$Ui$Button$active(defaultPeriod !== 'annual'),
										$author$project$Ui$Button$onClick(
										$author$project$Components$Plan$BasicForm$FormUpdated(
											$author$project$Components$Plan$BasicForm$DefaultPeriod(false)))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Month')
									]))
							]))
					])),
			function () {
				if (!billsAtEndOfPeriod) {
					var allPeriodCodes = function () {
						if (!maybePlan.$) {
							var plan = maybePlan.a;
							var meta = $author$project$Api$Provider$Plan$One$meta(plan);
							return $author$project$Api$Provider$Plan$Meta$allPeriodCodes(meta);
						} else {
							return $author$project$Api$Provider$Plan$Meta$defaultAllPeriodCodes;
						}
					}();
					return A2(
						$elm$core$List$cons,
						A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$offsetLabel,
									$author$project$Ui$Form$Group$labelSpanSm(5),
									$author$project$Ui$Form$Group$inputSpanSm(6),
									$author$project$Ui$Form$Group$label('Additional billing periods'),
									$author$project$Ui$Form$Group$labelClass(''),
									$author$project$Ui$Form$Group$labelHelp(
									(defaultPeriod === 'month') ? $elm$html$Html$text('Offer a percentage off pre-paid memberships') : $elm$html$Html$text('Set a surcharge for shorter billing periods'))
								]),
							_List_Nil),
						A2(
							$elm$core$List$map,
							A2($author$project$Components$Plan$BasicForm$viewPeriodField, defaultPeriod, form),
							allPeriodCodes));
				} else {
					return _List_Nil;
				}
			}());
	});
var $author$project$Components$Plan$BasicForm$viewBillingOptionsFields = F3(
	function (practiceIsOnboarding, maybePlan, form) {
		var isMcePlan = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Plan$One$isMcePlan, maybePlan));
		var forCompany = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (plan) {
					return !$author$project$Api$Provider$Plan$One$planType(plan);
				},
				maybePlan));
		var editingPlan = !_Utils_eq(maybePlan, $elm$core$Maybe$Nothing);
		var showForm = (!forCompany) && (editingPlan && ((!practiceIsOnboarding) && (!isMcePlan)));
		var _v0 = $author$project$Utils$Form$fields(form);
		var billsAtEndOfPeriod = _v0.MI;
		var rules = _v0.aak;
		var minimumEnrollmentPeriodInMonths = _v0.Xf;
		var defaultPeriod = _v0.P6;
		var defaultChargeName = _v0.y7;
		var defaultChargeDescription = _v0.y6;
		var editingDefaultChargeDescription = _v0.r6;
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						$elm$core$List$singleton(
						A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flex, $author$project$Ui$Element$mb2, $author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									$author$project$Ui$Typography$headingSm(
									_List_fromArray(
										[
											$elm$html$Html$text('Do you want to allow patients to pay you in advance?')
										])),
									A2(
									$elm$html$Html$map,
									$elm$core$Basics$never,
									$author$project$Ui$SupportDocumentLink$view('https://support.hint.com/account-configuration/configuring-your-membership-rates-and-billing-options'))
								]))),
						function () {
						if (showForm) {
							var disableToggle = function () {
								if (!maybePlan.$) {
									var plan = maybePlan.a;
									return $author$project$Api$Provider$Plan$One$activeMembershipPatientsCount(plan) > 0;
								} else {
									return false;
								}
							}();
							return $elm$core$List$singleton(
								A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$offsetLabel,
											$author$project$Ui$Form$Group$labelSpanSm(5),
											$author$project$Ui$Form$Group$inputSpanSm(6),
											$author$project$Ui$Form$Group$label('Bill at the End of the Billing Period'),
											$author$project$Ui$Form$Group$labelClass(''),
											$author$project$Ui$Form$Group$labelHelp(
											$elm$html$Html$text('This will only impact newly created memberships'))
										]),
									_List_fromArray(
										[
											$author$project$Ui$ToggleSwitch$view(
											_List_fromArray(
												[
													$author$project$Ui$ToggleSwitch$on(billsAtEndOfPeriod),
													$author$project$Ui$ToggleSwitch$onChange(
													A2($elm$core$Basics$composeL, $author$project$Components$Plan$BasicForm$FormUpdated, $author$project$Components$Plan$BasicForm$BillsAtEndOfPeriod)),
													$author$project$Ui$ToggleSwitch$disabled(disableToggle)
												]))
										])));
						} else {
							return _List_Nil;
						}
					}(),
						isMcePlan ? _List_Nil : A3($author$project$Components$Plan$BasicForm$viewBillingPeriodsFields, practiceIsOnboarding, maybePlan, form),
						showForm ? $elm$core$List$singleton(
						A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$offsetLabel,
									$author$project$Ui$Form$Group$labelSpanSm(5),
									$author$project$Ui$Form$Group$inputSpanSm(6),
									$author$project$Ui$Form$Group$label('Minimum Initial Enrollment Period'),
									$author$project$Ui$Form$Group$labelClass(''),
									$author$project$Ui$Form$Group$labelHelp(
									$elm$html$Html$text('You may prevent patients from cancelling for up to 12 months')),
									$author$project$Ui$Form$Group$required(rules.Xf.Ro)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$row,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$spanSm(4)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_Nil,
													_List_fromArray(
														[
															$author$project$Ui$ToggleSwitch$view(
															_List_fromArray(
																[
																	$author$project$Ui$ToggleSwitch$on(rules.Xf.Ro),
																	$author$project$Ui$ToggleSwitch$onChange(
																	A2(
																		$elm$core$Basics$composeL,
																		$author$project$Components$Plan$BasicForm$FormUpdated,
																		$author$project$Components$Plan$BasicForm$ToggleRule(0)))
																]))
														]))
												])),
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$spanSm(8)
												]),
											_List_fromArray(
												[
													rules.Xf.Ro ? $author$project$Ui$Form$PeriodInMonthsInput$view(
													{
														agX: A2($author$project$Utils$Form$validationErrors, 5, form),
														sM: A2($author$project$Utils$Form$hasValidationErrors, 5, form),
														ajm: A2($elm$core$Basics$composeL, $author$project$Components$Plan$BasicForm$FormUpdated, $author$project$Components$Plan$BasicForm$MinimumEnrollmentPeriodInMonths),
														aee: minimumEnrollmentPeriodInMonths
													}) : $author$project$Utils$Html$empty
												]))
										]))
								]))) : _List_Nil,
						(editingPlan && (!practiceIsOnboarding)) ? $elm$core$List$singleton(
						A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$offsetLabel,
									$author$project$Ui$Form$Group$labelSpanSm(5),
									$author$project$Ui$Form$Group$inputSpanSm(6),
									$author$project$Ui$Form$Group$label('Invoice Detail'),
									$author$project$Ui$Form$Group$labelClass(''),
									$author$project$Ui$Form$Group$labelHelp(
									$elm$html$Html$text('How would you like these charges to be shown on your invoices?')),
									$author$project$Ui$Form$Group$required(rules.Xf.Ro)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$row,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$spanSm(12)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
													_List_fromArray(
														[
															$elm$html$Html$text('Charge Name')
														])),
													$author$project$Ui$Form$Input$group(
													_List_fromArray(
														[
															$author$project$Ui$Form$Input$addon(
															_List_fromArray(
																[
																	(defaultPeriod === 'month') ? $elm$html$Html$text('Monthly') : $elm$html$Html$text('Annual')
																])),
															$author$project$Ui$Form$Input$view(
															_List_fromArray(
																[
																	$author$project$Ui$Form$Input$value(defaultChargeName),
																	$author$project$Ui$Form$Input$onInput(
																	A2($elm$core$Basics$composeL, $author$project$Components$Plan$BasicForm$FormUpdated, $author$project$Components$Plan$BasicForm$DefaultChargeName)),
																	$author$project$Ui$Form$Input$invalid(
																	A2($author$project$Utils$Form$hasValidationErrors, 6, form))
																]))
														])),
													$author$project$Utils$FormErrors$view(
													A2($author$project$Utils$Form$validationErrors, 6, form))
												])),
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$spanSm(12)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
													_List_fromArray(
														[
															$elm$html$Html$text('Charge Description')
														])),
													editingDefaultChargeDescription ? $author$project$Ui$Form$Input$view(
													_List_fromArray(
														[
															$author$project$Ui$Form$Input$value(
															A2($elm$core$Maybe$withDefault, '', defaultChargeDescription)),
															$author$project$Ui$Form$Input$onInput(
															A2($elm$core$Basics$composeL, $author$project$Components$Plan$BasicForm$FormUpdated, $author$project$Components$Plan$BasicForm$DefaultChargeDescription)),
															$author$project$Ui$Form$Input$phi(true),
															$author$project$Ui$Form$Input$placeholder('None')
														])) : A2(
													$author$project$Ui$Form$Static$view,
													_List_fromArray(
														[$author$project$Ui$Form$Static$flex, $author$project$Ui$Form$Static$spaceBetween, $author$project$Ui$Form$Static$itemsCenter]),
													_List_fromArray(
														[
															function () {
															if (!defaultChargeDescription.$) {
																var defaultChargeDescription_ = defaultChargeDescription.a;
																return A2($author$project$Ui$Typography$text, _List_Nil, defaultChargeDescription_);
															} else {
																return A2(
																	$author$project$Ui$Typography$text,
																	_List_fromArray(
																		[$author$project$Ui$Typography$muted]),
																	'None');
															}
														}(),
															A3(
															$author$project$Ui$Button$view,
															{mm: 'Edit default charge description'},
															_List_fromArray(
																[
																	$author$project$Ui$Button$link,
																	$author$project$Ui$Button$onClick(
																	$author$project$Components$Plan$BasicForm$FormUpdated($author$project$Components$Plan$BasicForm$EditDefaultChargeDescription))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Edit')
																]))
														]))
												]))
										]))
								]))) : _List_Nil
					])));
	});
var $author$project$Components$Plan$BasicForm$ImageUploaded = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Plan$BasicForm$viewImageField = F2(
	function (errors, currentImageUrl) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$offsetLabel,
					$author$project$Ui$Form$Group$labelSpanSm(5),
					$author$project$Ui$Form$Group$inputSpanSm(6),
					$author$project$Ui$Form$Group$label('Plan Image'),
					$author$project$Ui$Form$Group$labelClass('')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$File$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$File$accept(0),
							$author$project$Ui$Form$File$onInput($author$project$Components$Plan$BasicForm$ImageUploaded)
						])),
					function () {
					if (!currentImageUrl.$) {
						if (currentImageUrl.a === '') {
							return $author$project$Utils$Html$empty;
						} else {
							var url = currentImageUrl.a;
							return A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$mt2]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Image$fromSrc,
										{LD: 'Plan image'},
										url,
										_List_fromArray(
											[
												$author$project$Ui$Image$height(100)
											]))
									]));
						}
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					$author$project$Utils$FormErrors$view(errors)
				]));
	});
var $author$project$Components$Plan$BasicForm$Buyable = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Plan$BasicForm$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Plan$BasicForm$viewNameAndDescriptionFields = F4(
	function (fields, nameErrors, forCompany, buyableEditable) {
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mb2]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('Plan Name & Description')
								]))
						])),
					(!forCompany) ? A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$muted]),
					_List_fromArray(
						[
							$elm$html$Html$text('This will be displayed to your patients when they enroll through online signup')
						])) : $author$project$Utils$Html$empty,
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$offsetLabel,
							$author$project$Ui$Form$Group$labelSpanSm(5),
							$author$project$Ui$Form$Group$inputSpanSm(6),
							$author$project$Ui$Form$Group$label('Plan Name'),
							$author$project$Ui$Form$Group$labelClass(''),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(fields.Bq),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$Plan$BasicForm$FormUpdated, $author$project$Components$Plan$BasicForm$Name)),
									$author$project$Ui$Form$Input$invalid(
									!$elm$core$List$isEmpty(nameErrors)),
									$author$project$Ui$Form$Input$errors(nameErrors)
								]))
						])),
					A2(
					$elm$html$Html$map,
					$author$project$Components$Plan$BasicForm$DescriptionMsg,
					A2(
						$author$project$Components$TranslatedRichText$view,
						{agG: 'plan-description-editor', agX: _List_Nil, ahD: $elm$core$Maybe$Nothing, aih: 'Plan Description', aja: true, aj3: $elm$core$Maybe$Nothing, akR: false},
						fields.Qr)),
					buyableEditable ? A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$offsetLabel,
							$author$project$Ui$Form$Group$labelSpanSm(5),
							$author$project$Ui$Form$Group$inputSpanSm(6),
							$author$project$Ui$Form$Group$label('Allow members to enroll via Patient Portal'),
							$author$project$Ui$Form$Group$labelClass(''),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$view(
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$on(fields.MZ),
									$author$project$Ui$ToggleSwitch$onChange(
									A2($elm$core$Basics$composeL, $author$project$Components$Plan$BasicForm$FormUpdated, $author$project$Components$Plan$BasicForm$Buyable))
								]))
						])) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$IndividualRegistrationFeeInCentsRule = 0;
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$MaxRegistrationFeeInCents = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$MaxRegistrationFeeInCentsRule = 1;
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$ToggleRule = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$viewRegistrationFeePricingFields = F4(
	function (parentFormData, onParentFieldMsg, onComponentMsg, _v0) {
		var form = _v0;
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$flex, $author$project$Ui$Element$mb2, $author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('Registration Fees')
								])),
							A2(
							$elm$html$Html$map,
							$elm$core$Basics$never,
							$author$project$Ui$SupportDocumentLink$view('https://support.hint.com/account-configuration/configuring-your-membership-rates-and-billing-options'))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$offsetLabel,
							$author$project$Ui$Form$Group$labelSpanSm(5),
							$author$project$Ui$Form$Group$inputSpanSm(6),
							$author$project$Ui$Form$Group$label('Fee for Individual'),
							$author$project$Ui$Form$Group$labelClass(''),
							$author$project$Ui$Form$Group$required(fields.aak.TZ.Ro)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$row,
							_List_fromArray(
								[$author$project$Ui$Grid$rowItemsCenter]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanSm(4),
											$author$project$Ui$Grid$justifyLeft
										]),
									_List_fromArray(
										[
											$author$project$Ui$ToggleSwitch$view(
											_List_fromArray(
												[
													$author$project$Ui$ToggleSwitch$on(fields.aak.TZ.Ro),
													$author$project$Ui$ToggleSwitch$onChange(
													function (_v1) {
														return onComponentMsg(
															$author$project$Components$Plan$Form$RegistrationFeePricingFields$FormUpdated(
																$author$project$Components$Plan$Form$RegistrationFeePricingFields$ToggleRule(0)));
													})
												]))
										])),
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanSm(8)
										]),
									_List_fromArray(
										[
											fields.aak.TZ.Ro ? A2(
											$author$project$Ui$Element$view,
											_List_Nil,
											_List_fromArray(
												[
													$author$project$Ui$Form$CurrencyInput$view(
													_List_fromArray(
														[
															$author$project$Ui$Form$CurrencyInput$value(fields.TZ),
															$author$project$Ui$Form$CurrencyInput$onInput(
															A2(
																$elm$core$Basics$composeL,
																A2($elm$core$Basics$composeL, onComponentMsg, $author$project$Components$Plan$Form$RegistrationFeePricingFields$FormUpdated),
																$author$project$Components$Plan$Form$RegistrationFeePricingFields$IndividualRegistrationFeeInCents)),
															$author$project$Ui$Form$CurrencyInput$invalid(
															A2($author$project$Utils$Form$hasValidationErrors, 0, form))
														])),
													$author$project$Utils$FormErrors$view(
													A2($author$project$Utils$Form$validationErrors, 0, form))
												])) : $author$project$Utils$Html$empty
										]))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$offsetLabel,
							$author$project$Ui$Form$Group$labelSpanSm(5),
							$author$project$Ui$Form$Group$inputSpanSm(6),
							$author$project$Ui$Form$Group$label('Max fee for family'),
							$author$project$Ui$Form$Group$labelClass(''),
							$author$project$Ui$Form$Group$required(fields.aak.WC.Ro)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$row,
							_List_fromArray(
								[$author$project$Ui$Grid$rowItemsCenter]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanSm(4),
											$author$project$Ui$Grid$justifyLeft
										]),
									_List_fromArray(
										[
											$author$project$Ui$ToggleSwitch$view(
											_List_fromArray(
												[
													$author$project$Ui$ToggleSwitch$on(fields.aak.WC.Ro),
													$author$project$Ui$ToggleSwitch$onChange(
													function (_v2) {
														return onComponentMsg(
															$author$project$Components$Plan$Form$RegistrationFeePricingFields$FormUpdated(
																$author$project$Components$Plan$Form$RegistrationFeePricingFields$ToggleRule(1)));
													})
												]))
										])),
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanSm(8)
										]),
									_List_fromArray(
										[
											fields.aak.WC.Ro ? A2(
											$author$project$Ui$Element$view,
											_List_Nil,
											_List_fromArray(
												[
													$author$project$Ui$Form$CurrencyInput$view(
													_List_fromArray(
														[
															$author$project$Ui$Form$CurrencyInput$value(fields.WC),
															$author$project$Ui$Form$CurrencyInput$onInput(
															A2(
																$elm$core$Basics$composeL,
																A2($elm$core$Basics$composeL, onComponentMsg, $author$project$Components$Plan$Form$RegistrationFeePricingFields$FormUpdated),
																$author$project$Components$Plan$Form$RegistrationFeePricingFields$MaxRegistrationFeeInCents)),
															$author$project$Ui$Form$CurrencyInput$invalid(
															A2($author$project$Utils$Form$hasValidationErrors, 1, form))
														])),
													$author$project$Utils$FormErrors$view(
													A2($author$project$Utils$Form$validationErrors, 1, form))
												])) : $author$project$Utils$Html$empty
										]))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$offsetLabel,
							$author$project$Ui$Form$Group$labelSpanSm(5),
							$author$project$Ui$Form$Group$inputSpanSm(6),
							$author$project$Ui$Form$Group$label('Invoice Detail'),
							$author$project$Ui$Form$Group$labelHelp(
							$elm$html$Html$text('How would you like these charges to be shown on your invoices?')),
							$author$project$Ui$Form$Group$labelClass(''),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanSm(12)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
											_List_fromArray(
												[
													$elm$html$Html$text('Charge Name')
												])),
											$author$project$Ui$Form$Input$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$value(parentFormData.DN),
													$author$project$Ui$Form$Input$onInput(
													A2($elm$core$Basics$composeL, onParentFieldMsg, parentFormData.ajs)),
													$author$project$Ui$Form$Input$invalid(parentFormData.ahC)
												])),
											$author$project$Utils$FormErrors$view(parentFormData.akE)
										]))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$offsetLabel,
							$author$project$Ui$Form$Group$labelSpanSm(5),
							$author$project$Ui$Form$Group$inputSpanSm(6),
							$author$project$Ui$Form$Group$label(''),
							$author$project$Ui$Form$Group$labelClass('')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanSm(12)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
											_List_fromArray(
												[
													$elm$html$Html$text('Charge Description')
												])),
											parentFormData.nr ? A2(
											$author$project$Ui$Element$view,
											_List_Nil,
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$view(
													_List_fromArray(
														[
															$author$project$Ui$Form$Input$value(parentFormData.DM),
															$author$project$Ui$Form$Input$onInput(
															A2($elm$core$Basics$composeL, onParentFieldMsg, parentFormData.ajr)),
															$author$project$Ui$Form$Input$invalid(false),
															$author$project$Ui$Form$Input$placeholder('None')
														])),
													$author$project$Utils$FormErrors$view(_List_Nil)
												])) : A2(
											$author$project$Ui$Form$Static$view,
											_List_fromArray(
												[$author$project$Ui$Form$Static$flex, $author$project$Ui$Form$Static$spaceBetween, $author$project$Ui$Form$Static$itemsCenter]),
											_List_fromArray(
												[
													function () {
													var _v3 = $author$project$Utils$String$toMaybe(parentFormData.DM);
													if (!_v3.$) {
														var description = _v3.a;
														return A2(
															$author$project$Ui$Typography$text,
															_List_fromArray(
																[$author$project$Ui$Typography$muted]),
															description);
													} else {
														return A2(
															$author$project$Ui$Typography$text,
															_List_fromArray(
																[$author$project$Ui$Typography$muted]),
															'None');
													}
												}(),
													A3(
													$author$project$Ui$Button$view,
													{mm: 'Edit registration fee description'},
													_List_fromArray(
														[
															$author$project$Ui$Button$link,
															$author$project$Ui$Button$onClick(
															onParentFieldMsg(parentFormData.ajh))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Edit')
														]))
												]))
										]))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$offsetLabel,
							$author$project$Ui$Form$Group$labelSpanSm(5),
							$author$project$Ui$Form$Group$inputSpanSm(6),
							$author$project$Ui$Form$Group$label(''),
							$author$project$Ui$Form$Group$labelClass('')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanSm(12)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
											_List_fromArray(
												[
													$elm$html$Html$text('Charge Category')
												])),
											function () {
											if (!parentFormData.jB) {
												return A2(
													$author$project$Ui$Form$Static$view,
													_List_fromArray(
														[$author$project$Ui$Form$Static$flex, $author$project$Ui$Form$Static$spaceBetween, $author$project$Ui$Form$Static$itemsCenter]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Typography$text,
															_List_fromArray(
																[$author$project$Ui$Typography$muted]),
															parentFormData.Ns),
															A3(
															$author$project$Ui$Button$view,
															{mm: 'Edit registration fee category'},
															_List_fromArray(
																[
																	$author$project$Ui$Button$link,
																	$author$project$Ui$Button$onClick(
																	onParentFieldMsg(parentFormData.ajg))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Edit')
																]))
														]));
											} else {
												var _v4 = fields.c8;
												if (!_v4.$) {
													var categoryResourceFilter = _v4.a;
													return A2(
														$elm$html$Html$map,
														onComponentMsg,
														A2(
															$elm$html$Html$map,
															$author$project$Components$Plan$Form$RegistrationFeePricingFields$CategoryResourceFilterMsg,
															A2($author$project$Components$ResourceFilter$Category$view, _List_Nil, categoryResourceFilter)));
												} else {
													return $author$project$Utils$Html$empty;
												}
											}
										}()
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Plan$BasicForm$SponsorFeeDealAmountInCents = function (a) {
	return {$: 19, a: a};
};
var $author$project$Api$Provider$Plan$Meta$allowedPeriodCodes = function (_v0) {
	var meta = _v0;
	return meta.Lz;
};
var $author$project$Api$Period$numberOfMonths = function (_v0) {
	var period = _v0;
	return period.ku;
};
var $author$project$Api$Period$Period = $elm$core$Basics$identity;
var $author$project$Api$Period$list = _List_fromArray(
	[
		{mu: 'monthly', NN: 'month', ku: 1, pv: 'Monthly'},
		{mu: 'quarterly', NN: 'quarter', ku: 3, pv: 'Quarterly'},
		{mu: 'semi-annually', NN: 'semi_annual', ku: 6, pv: 'Semi-Annual'},
		{mu: 'annually', NN: 'annual', ku: 12, pv: 'Annual'}
	]);
var $author$project$Api$Period$retrieve = function (code_) {
	return A2(
		$elm_community$list_extra$List$Extra$find,
		function (_v0) {
			var period = _v0;
			return _Utils_eq(period.NN, code_);
		},
		$author$project$Api$Period$list);
};
var $author$project$Components$Plan$BasicForm$fixedFeeAmountForPeriod = F4(
	function (fields, defaultPeriod, sponsorFeeDealAmountInCents, periodCode) {
		var period = $author$project$Api$Period$retrieve(periodCode);
		var periodInMonths = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $author$project$Api$Period$numberOfMonths, period));
		var amount = function (amount_) {
			return (defaultPeriod === 'annual') ? ((amount_ / 12) | 0) : amount_;
		}(
			periodInMonths * A2(
				$elm$core$Maybe$withDefault,
				0,
				A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, sponsorFeeDealAmountInCents)));
		var adjustment = _Utils_eq(defaultPeriod, periodCode) ? 0 : function (adjustment_) {
			return (defaultPeriod === 'month') ? (adjustment_ * (-1)) : adjustment_;
		}(
			function () {
				switch (periodCode) {
					case 'month':
						return A2(
							$elm$core$Maybe$withDefault,
							0,
							A2($elm$core$Maybe$andThen, $author$project$Percentage$toFloat, fields.Bi));
					case 'quarter':
						return A2(
							$elm$core$Maybe$withDefault,
							0,
							A2($elm$core$Maybe$andThen, $author$project$Percentage$toFloat, fields.DB));
					case 'semi_annual':
						return A2(
							$elm$core$Maybe$withDefault,
							0,
							A2($elm$core$Maybe$andThen, $author$project$Percentage$toFloat, fields.Es));
					case 'annual':
						return A2(
							$elm$core$Maybe$withDefault,
							0,
							A2($elm$core$Maybe$andThen, $author$project$Percentage$toFloat, fields.xk));
					default:
						return 0;
				}
			}());
		return $elm$core$Basics$round(amount * (1 + (adjustment / 100)));
	});
var $author$project$Components$Plan$BasicForm$viewPeriod = F4(
	function (fields, defaultPeriod, sponsorFeeDealAmountInCents, allowedPeriod) {
		return (!_Utils_eq(defaultPeriod, allowedPeriod)) ? A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(12)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Formatters$String$humanize(allowedPeriod)),
							$author$project$Utils$Html$noBreakSpace,
							$elm$html$Html$text(
							$author$project$Utils$Currency$fromInt(
								A4($author$project$Components$Plan$BasicForm$fixedFeeAmountForPeriod, fields, defaultPeriod, sponsorFeeDealAmountInCents, allowedPeriod)))
						]))
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Components$Plan$BasicForm$viewSponsorFeeDealFields = F3(
	function (practiceIsOnboarding, plan, form) {
		var meta = $author$project$Api$Provider$Plan$One$meta(plan);
		var allowedPeriodCodes = $author$project$Api$Provider$Plan$Meta$allowedPeriodCodes(meta);
		var fields = $author$project$Utils$Form$fields(form);
		var defaultPeriod = fields.P6;
		var sponsorFeeDealAmountInCents = fields.JS;
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$offsetLabel,
							$author$project$Ui$Form$Group$labelSpanSm(5),
							$author$project$Ui$Form$Group$inputSpanSm(6),
							$author$project$Ui$Form$Group$label('Amount'),
							$author$project$Ui$Form$Group$labelClass(''),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Formatters$String$humanize(defaultPeriod)),
									$elm$html$Html$text(' rate')
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Form$CurrencyInput$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$CurrencyInput$value(sponsorFeeDealAmountInCents),
											$author$project$Ui$Form$CurrencyInput$onInput(
											A2($elm$core$Basics$composeL, $author$project$Components$Plan$BasicForm$FormUpdated, $author$project$Components$Plan$BasicForm$SponsorFeeDealAmountInCents)),
											$author$project$Ui$Form$CurrencyInput$invalid(
											A2($author$project$Utils$Form$hasValidationErrors, 7, form))
										])),
									$author$project$Utils$FormErrors$view(
									A2($author$project$Utils$Form$validationErrors, 7, form))
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							A2(
								$elm$core$List$map,
								A3($author$project$Components$Plan$BasicForm$viewPeriod, fields, defaultPeriod, sponsorFeeDealAmountInCents),
								allowedPeriodCodes))
						])),
				A3(
					$author$project$Components$Plan$BasicForm$viewBillingPeriodsFields,
					practiceIsOnboarding,
					$elm$core$Maybe$Just(plan),
					form)));
	});
var $author$project$Components$Plan$BasicForm$view = F2(
	function (_v0, maybePlan) {
		var settings = _v0.a;
		var form = _v0.b;
		var planType = A2(
			$elm$core$Maybe$withDefault,
			2,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Plan$One$planType, maybePlan));
		var forCompany = !planType;
		var fields = $author$project$Utils$Form$fields(form);
		var errorsFor = function (group) {
			return A2($author$project$Utils$Form$validationErrors, group, form);
		};
		var buyableEditable = A2($author$project$Api$Provider$Practice$One$featureEnabled, 22, settings.ZV);
		return _List_fromArray(
			[
				A4(
				$author$project$Components$Plan$BasicForm$viewNameAndDescriptionFields,
				fields,
				errorsFor(0),
				forCompany,
				buyableEditable),
				(buyableEditable && fields.MZ) ? A2(
				$author$project$Components$Plan$BasicForm$viewImageField,
				errorsFor(10),
				fields.rQ) : $author$project$Utils$Html$empty,
				$author$project$Utils$Html$noBreakSpace,
				A3($author$project$Components$Plan$BasicForm$viewAddonPlanField, form, settings, forCompany),
				$author$project$Utils$Html$noBreakSpace,
				A4(
				$author$project$Components$Plan$Form$RegistrationFeePricingFields$viewRegistrationFeePricingFields,
				{
					Ns: fields.ub,
					jB: fields.jB,
					nr: fields.nr,
					ahC: A2($author$project$Utils$Form$hasValidationErrors, 8, form),
					ajg: $author$project$Components$Plan$BasicForm$EditRegistrationFeeCategory,
					ajh: $author$project$Components$Plan$BasicForm$EditRegistrationFeeDescription,
					ajr: $author$project$Components$Plan$BasicForm$RegistrationFeeDescription,
					ajs: $author$project$Components$Plan$BasicForm$RegistrationFeeName,
					DM: fields.DM,
					DN: fields.DN,
					akE: A2($author$project$Utils$Form$validationErrors, 8, form)
				},
				$author$project$Components$Plan$BasicForm$FormUpdated,
				$author$project$Components$Plan$BasicForm$RegistrationFeePricingFieldsMsg,
				fields.dH),
				function () {
				if (planType === 1) {
					if (!maybePlan.$) {
						var plan = maybePlan.a;
						return A3($author$project$Components$Plan$BasicForm$viewSponsorFeeDealFields, settings.ZX, plan, form);
					} else {
						return $author$project$Utils$Html$empty;
					}
				} else {
					return A2(
						$author$project$Ui$Element$view,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$HorizontalRule$view(_List_Nil),
								A3($author$project$Components$Plan$BasicForm$viewBillingOptionsFields, settings.ZX, maybePlan, form)
							]));
				}
			}()
			]);
	});
var $author$project$Components$Plan$Form$GroupTierPricingFields$FamilyNumAdultsIncludedRule = 1;
var $author$project$Components$Plan$Form$GroupTierPricingFields$FamilyWithSingleChildRateRuleEnabled = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$FixedChildrenAgeLimitRule = 0;
var $author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$GroupPricingFamilyNumChildrenIncludedRule = 2;
var $author$project$Components$Plan$Form$GroupTierPricingFields$SingleParentWithSingleChildRateRuleEnabled = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$ToggleFixedMembershipPricing = {$: 13};
var $author$project$Components$Plan$Form$GroupTierPricingFields$ToggleRule = function (a) {
	return {$: 12, a: a};
};
var $author$project$Api$Provider$McePricing$One$coupleRates = function (_v0) {
	var record = _v0;
	return record.OO;
};
var $author$project$Api$Provider$McePricing$One$familyRates = function (_v0) {
	var record = _v0;
	return record.Sa;
};
var $author$project$Utils$RateRule$groupTierCode = F2(
	function (retail, type_) {
		if (retail) {
			switch (type_.$) {
				case 0:
					return 'MEM';
				case 1:
					return 'MSP';
				case 2:
					return 'MCH';
				case 3:
					return 'FAM';
				case 4:
					return '';
				case 5:
					return '';
				case 6:
					return '';
				case 8:
					return '';
				case 9:
					return '';
				case 7:
					return '';
				default:
					return '';
			}
		} else {
			switch (type_.$) {
				case 0:
					return 'EMP';
				case 1:
					return 'ESP';
				case 2:
					return 'ECH';
				case 3:
					return 'FAM';
				case 4:
					return '';
				case 5:
					return '';
				case 6:
					return '';
				case 8:
					return '';
				case 9:
					return '';
				case 7:
					return '';
				default:
					return '';
			}
		}
	});
var $author$project$Utils$RateRule$groupTierName = function (type_) {
	switch (type_.$) {
		case 0:
			return 'Primary';
		case 1:
			return 'Primary + Spouse';
		case 2:
			return 'Primary + Children';
		case 3:
			return 'Family';
		case 4:
			return 'Primary + 1 Child';
		case 5:
			return 'Primary + Spouse + 1 Child';
		case 6:
			return 'Additional Adult Rate';
		case 7:
			return 'Additional Child Rate';
		case 8:
			return 'Age Based';
		case 9:
			return 'Age Based Couple';
		default:
			var name = type_.a;
			return name;
	}
};
var $author$project$Api$Provider$McePricing$One$individualRates = function (_v0) {
	var record = _v0;
	return record.TY;
};
var $author$project$Ui$Form$Group$Html = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$Group$labelHtml = A2($elm$core$Basics$composeR, $author$project$Ui$Form$Group$Html, $author$project$Ui$Form$Group$Label);
var $author$project$Api$Provider$McePricing$One$singleParentWithChildrenRates = function (_v0) {
	var record = _v0;
	return record.abD;
};
var $author$project$Ui$Icon$Transfer = 51;
var $author$project$Ui$Icon$transfer = $author$project$Ui$Icon$viewIcon(51);
var $author$project$Components$Plan$Form$GroupTierPricingFields$FamilyNumAdultsIncluded = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$viewAdultsLimitField = F5(
	function (label, enabled, value, form, onToggle) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$offsetLabel,
					$author$project$Ui$Form$Group$labelSpanSm(5),
					$author$project$Ui$Form$Group$inputSpanSm(6),
					$author$project$Ui$Form$Group$label(label),
					$author$project$Ui$Form$Group$labelClass(''),
					$author$project$Ui$Form$Group$labelHelp(
					$elm$html$Html$text('Turn off for no limit'))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_fromArray(
						[$author$project$Ui$Grid$rowItemsCenter]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(4),
									$author$project$Ui$Grid$justifyLeft
								]),
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$view(
									_List_fromArray(
										[
											$author$project$Ui$ToggleSwitch$on(enabled),
											$author$project$Ui$ToggleSwitch$onChange(
											A2(
												$elm$core$Basics$composeL,
												$author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated,
												$elm$core$Basics$always(onToggle)))
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(8)
								]),
							enabled ? _List_fromArray(
								[
									$author$project$Ui$Form$Input$group(
									A2(
										$author$project$Ui$Form$Input$withPreAddon,
										'Up to and including',
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$value(
												A2(
													$elm$core$Maybe$withDefault,
													'',
													A2($elm$core$Maybe$map, $elm$core$String$fromInt, value))),
												$author$project$Ui$Form$Input$onInput(
												A2(
													$elm$core$Basics$composeL,
													A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated, $author$project$Components$Plan$Form$GroupTierPricingFields$FamilyNumAdultsIncluded),
													$elm$core$String$toInt)),
												$author$project$Ui$Form$Input$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$Plan$Form$GroupTierPricingFields$FamilyNumAdultsIncludedValidation, form))
											]))),
									$author$project$Utils$FormErrors$view(
									A2($author$project$Utils$Form$validationErrors, $author$project$Components$Plan$Form$GroupTierPricingFields$FamilyNumAdultsIncludedValidation, form))
								]) : _List_Nil)
						]))
				]));
	});
var $author$project$Components$Plan$Form$GroupTierPricingFields$FixedChildrenAgeLimit = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$viewAgeLimitField = F5(
	function (label, enabled, value, form, onToggle) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$offsetLabel,
					$author$project$Ui$Form$Group$labelSpanSm(5),
					$author$project$Ui$Form$Group$inputSpanSm(6),
					$author$project$Ui$Form$Group$label(label),
					$author$project$Ui$Form$Group$labelClass(''),
					$author$project$Ui$Form$Group$labelHelp(
					$elm$html$Html$text('Turn off for no limit. Children above the age limit will be billed as adults'))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_fromArray(
						[$author$project$Ui$Grid$rowItemsCenter]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(4),
									$author$project$Ui$Grid$justifyLeft
								]),
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$view(
									_List_fromArray(
										[
											$author$project$Ui$ToggleSwitch$on(enabled),
											$author$project$Ui$ToggleSwitch$onChange(
											A2(
												$elm$core$Basics$composeL,
												$author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated,
												$elm$core$Basics$always(onToggle)))
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(8)
								]),
							enabled ? _List_fromArray(
								[
									$author$project$Ui$Form$Input$group(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$value(
													A2(
														$elm$core$Maybe$withDefault,
														'',
														A2($elm$core$Maybe$map, $elm$core$String$fromInt, value))),
													$author$project$Ui$Form$Input$onInput(
													A2(
														$elm$core$Basics$composeL,
														A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated, $author$project$Components$Plan$Form$GroupTierPricingFields$FixedChildrenAgeLimit),
														$elm$core$String$toInt)),
													$author$project$Ui$Form$Input$invalid(
													A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$Plan$Form$GroupTierPricingFields$FixedChildrenAgeLimitValidation, form))
												])),
											$author$project$Ui$Form$Input$addon(
											_List_fromArray(
												[
													$elm$html$Html$text('& under')
												]))
										])),
									$author$project$Utils$FormErrors$view(
									A2($author$project$Utils$Form$validationErrors, $author$project$Components$Plan$Form$GroupTierPricingFields$FixedChildrenAgeLimitValidation, form))
								]) : _List_Nil)
						]))
				]));
	});
var $author$project$Components$Plan$Form$GroupTierPricingFields$GroupPricingFamilyNumChildrenIncluded = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$viewChildrenLimitField = F5(
	function (label, enabled, value, form, onToggle) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$offsetLabel,
					$author$project$Ui$Form$Group$labelSpanSm(5),
					$author$project$Ui$Form$Group$inputSpanSm(6),
					$author$project$Ui$Form$Group$label(label),
					$author$project$Ui$Form$Group$labelClass(''),
					$author$project$Ui$Form$Group$labelHelp(
					$elm$html$Html$text('Turn off for no limit'))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_fromArray(
						[$author$project$Ui$Grid$rowItemsCenter]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(4),
									$author$project$Ui$Grid$justifyLeft
								]),
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$view(
									_List_fromArray(
										[
											$author$project$Ui$ToggleSwitch$on(enabled),
											$author$project$Ui$ToggleSwitch$onChange(
											A2(
												$elm$core$Basics$composeL,
												$author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated,
												$elm$core$Basics$always(onToggle)))
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(8)
								]),
							enabled ? _List_fromArray(
								[
									$author$project$Ui$Form$Input$group(
									A2(
										$author$project$Ui$Form$Input$withPreAddon,
										'Up to and including',
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$value(
												A2(
													$elm$core$Maybe$withDefault,
													'',
													A2($elm$core$Maybe$map, $elm$core$String$fromInt, value))),
												$author$project$Ui$Form$Input$onInput(
												A2(
													$elm$core$Basics$composeL,
													A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated, $author$project$Components$Plan$Form$GroupTierPricingFields$GroupPricingFamilyNumChildrenIncluded),
													$elm$core$String$toInt)),
												$author$project$Ui$Form$Input$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$Plan$Form$GroupTierPricingFields$GroupPricingFamilyNumChildrenIncludedValidation, form))
											]))),
									$author$project$Utils$FormErrors$view(
									A2($author$project$Utils$Form$validationErrors, $author$project$Components$Plan$Form$GroupTierPricingFields$GroupPricingFamilyNumChildrenIncludedValidation, form))
								]) : _List_Nil)
						]))
				]));
	});
var $author$project$Components$Plan$Form$GroupTierPricingFields$FixedRateRuleAmountInCents = F3(
	function (a, b, c) {
		return {$: 16, a: a, b: b, c: c};
	});
var $author$project$Components$Plan$Form$GroupTierPricingFields$FixedRateRuleAmountInCentsEdit = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$Components$Plan$Form$GroupTierPricingFields$FixedRateRuleAmountInCentsReset = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Components$Plan$Form$GroupTierPricingFields$viewAmountInCentsPricingRulePeriod = F5(
	function (defaultPeriod, form, rule, isDiscount, period) {
		var _v0 = function () {
			switch (period) {
				case 'month':
					return _Utils_Tuple3(rule.Xk, rule.IB, rule.gX);
				case 'quarter':
					return _Utils_Tuple3(rule._Q, rule._R, rule.ho);
				case 'semi_annual':
					return _Utils_Tuple3(rule.aaJ, rule.aaK, rule.hz);
				case 'annual':
					return _Utils_Tuple3(rule.LH, rule.LI, rule.fE);
				default:
					return _Utils_Tuple3(rule.Xk, rule.IB, rule.gX);
			}
		}();
		var periodAmountInCents = _v0.a;
		var editingPeriod = _v0.b;
		var periodEdited = _v0.c;
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			(_Utils_eq(defaultPeriod, period) || editingPeriod) ? _List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Formatters$String$humanize(period)),
							isDiscount ? $elm$html$Html$text(' discount') : $elm$html$Html$text(' rate')
						])),
					$author$project$Ui$Form$CurrencyInput$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$CurrencyInput$value(periodAmountInCents),
							$author$project$Ui$Form$CurrencyInput$onInput(
							A2(
								$elm$core$Basics$composeL,
								$author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated,
								rule.Yh(period))),
							$author$project$Ui$Form$CurrencyInput$invalid(
							A2(
								$author$project$Utils$Form$hasValidationErrors,
								rule.I9(period),
								form))
						])),
					$author$project$Utils$FormErrors$view(
					A2(
						$author$project$Utils$Form$validationErrors,
						rule.I9(period),
						form))
				]) : _List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Formatters$String$humanize(period)),
									$author$project$Utils$Html$noBreakSpace,
									$elm$html$Html$text(
									$author$project$Currency$format(
										A2($elm$core$Maybe$withDefault, $author$project$Currency$zero, periodAmountInCents))),
									isDiscount ? $elm$html$Html$text(' off') : $author$project$Utils$Html$empty
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$justifyRight]),
							_List_fromArray(
								[
									periodEdited ? A3(
									$author$project$Ui$Button$view,
									{mm: 'Reset period amount'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick(
											$author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated(
												rule.$P(period)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Reset')
										])) : $author$project$Utils$Html$empty,
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Edit period amount'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick(
											$author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated(
												rule.Q2(period)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit')
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Plan$Form$GroupTierPricingFields$viewAmountInCentsPricingRule = F5(
	function (defaultPeriod, form, periods, rule, isDiscount) {
		return A2(
			$elm$core$List$map,
			A4($author$project$Components$Plan$Form$GroupTierPricingFields$viewAmountInCentsPricingRulePeriod, defaultPeriod, form, rule, isDiscount),
			periods);
	});
var $author$project$Components$Plan$Form$GroupTierPricingFields$viewFixedRateRule = F4(
	function (defaultPeriod, plan, form, fixedRateRule) {
		var meta = $author$project$Api$Provider$Plan$One$meta(plan);
		return A5(
			$author$project$Components$Plan$Form$GroupTierPricingFields$viewAmountInCentsPricingRule,
			defaultPeriod,
			form,
			$author$project$Api$Provider$Plan$Meta$allowedPeriodCodes(meta),
			{
				LH: fixedRateRule.LH,
				fE: fixedRateRule.fE,
				LI: fixedRateRule.LI,
				Q2: $author$project$Components$Plan$Form$GroupTierPricingFields$FixedRateRuleAmountInCentsEdit(fixedRateRule.amg),
				Xk: fixedRateRule.Xk,
				gX: fixedRateRule.gX,
				IB: fixedRateRule.IB,
				Yh: $author$project$Components$Plan$Form$GroupTierPricingFields$FixedRateRuleAmountInCents(fixedRateRule.amg),
				I9: function (period) {
					return A2($author$project$Components$Plan$Form$GroupTierPricingFields$FixedRateRuleAmountInCentsValidation, fixedRateRule.amg, period);
				},
				_Q: fixedRateRule._Q,
				ho: fixedRateRule.ho,
				_R: fixedRateRule._R,
				$P: $author$project$Components$Plan$Form$GroupTierPricingFields$FixedRateRuleAmountInCentsReset(fixedRateRule.amg),
				aaJ: fixedRateRule.aaJ,
				hz: fixedRateRule.hz,
				aaK: fixedRateRule.aaK
			},
			false);
	});
var $author$project$Components$Plan$Form$GroupTierPricingFields$SplitRevenueType = function (a) {
	return {$: 11, a: a};
};
var $author$project$Ui$Typography$ControlLabel = {$: 11};
var $author$project$Ui$Typography$controlLabel = $author$project$Ui$Typography$ControlLabel;
var $author$project$Ui$Element$Bold = 4;
var $author$project$Ui$Element$fontBold = $author$project$Ui$Element$Text(4);
var $author$project$Components$Plan$Form$GroupTierPricingFields$viewRateSplitSection = F2(
	function (fields, form) {
		var currentFields = $author$project$Utils$Form$fields(form);
		var splitRevenueType = currentFields.abW;
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mt4]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mb2]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('Rate Split')
								]))
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$helpBlock]),
					_List_fromArray(
						[
							$elm$html$Html$text('For memberships with more than one member, choose how the rate will be split.')
						])),
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$offset(1)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$label,
									_List_fromArray(
										[$author$project$Ui$Typography$controlLabel]),
									_List_fromArray(
										[
											$elm$html$Html$text('With Spouse')
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Radio$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Radio$value(splitRevenueType === 'even_children'),
													$author$project$Ui$Form$Radio$onCheck(
													A2(
														$elm$core$Basics$composeL,
														$author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated,
														$elm$core$Basics$always(
															$author$project$Components$Plan$Form$GroupTierPricingFields$SplitRevenueType('even_children'))))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('The spouse receives the \"Primary + Spouse\" minus the \"Primary\" rate.'),
													function () {
													var _v0 = _Utils_Tuple2(
														A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.ON.Xk),
														A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.TX.Xk));
													if ((!_v0.a.$) && (!_v0.b.$)) {
														var coupleMonthAmountInCents = _v0.a.a;
														var individualMonthAmountInCents = _v0.b.a;
														return A2(
															$author$project$Ui$Element$view,
															_List_fromArray(
																[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted, $author$project$Ui$Element$fontBold]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Assign the primary member a rate of '),
																	$elm$html$Html$text(
																	$author$project$Utils$Currency$fromInt(individualMonthAmountInCents)),
																	$elm$html$Html$text(', and the spouse a rate of '),
																	$elm$html$Html$text(
																	$author$project$Utils$Currency$fromInt(coupleMonthAmountInCents - individualMonthAmountInCents)),
																	$elm$html$Html$text('.')
																]));
													} else {
														return $author$project$Utils$Html$empty;
													}
												}()
												]))
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Radio$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Radio$value(splitRevenueType === 'even_adult_children'),
													$author$project$Ui$Form$Radio$onCheck(
													A2(
														$elm$core$Basics$composeL,
														$author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated,
														$elm$core$Basics$always(
															$author$project$Components$Plan$Form$GroupTierPricingFields$SplitRevenueType('even_adult_children'))))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Primary and spouse split the the \"Primary + Spouse\" rate.'),
													function () {
													var _v1 = A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.ON.Xk);
													if (!_v1.$) {
														var coupleMonthAmountInCents = _v1.a;
														var halfCoupleRate = $elm$core$Basics$floor(coupleMonthAmountInCents / 2);
														return A2(
															$author$project$Ui$Element$view,
															_List_fromArray(
																[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted, $author$project$Ui$Element$fontBold]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Assign the primary member a rate of '),
																	$elm$html$Html$text(
																	$author$project$Utils$Currency$fromInt(coupleMonthAmountInCents - halfCoupleRate)),
																	$elm$html$Html$text(', and the spouse a rate of '),
																	$elm$html$Html$text(
																	$author$project$Utils$Currency$fromInt(halfCoupleRate)),
																	$elm$html$Html$text('.')
																]));
													} else {
														return $author$project$Utils$Html$empty;
													}
												}()
												]))
										])),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									A2(
									$author$project$Ui$Typography$label,
									_List_fromArray(
										[$author$project$Ui$Typography$controlLabel]),
									_List_fromArray(
										[
											$elm$html$Html$text('With Children')
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Checkbox$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Checkbox$value(splitRevenueType !== 'even_all'),
													$author$project$Ui$Form$Checkbox$disabled(true)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Split the remaining rate evenly among the children'),
													function () {
													var _v2 = _Utils_Tuple2(
														A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.TX.Xk),
														A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.abC.Xk));
													if ((!_v2.a.$) && (!_v2.b.$)) {
														var individualMonthAmountInCents = _v2.a.a;
														var singleParentMonthAmountInCents = _v2.b.a;
														return A2(
															$author$project$Ui$Element$view,
															_List_fromArray(
																[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted, $author$project$Ui$Element$fontBold]),
															_List_fromArray(
																[
																	$elm$html$Html$text('For single parents, assign the children a combined rate of '),
																	$elm$html$Html$text(
																	$author$project$Utils$Currency$fromInt(singleParentMonthAmountInCents - individualMonthAmountInCents)),
																	$elm$html$Html$text(' divided evenly between them.'),
																	$elm$html$Html$text('If there\'s only one child, assign them the entire '),
																	$elm$html$Html$text(
																	$author$project$Utils$Currency$fromInt(singleParentMonthAmountInCents - individualMonthAmountInCents)),
																	$elm$html$Html$text('.')
																]));
													} else {
														return $author$project$Utils$Html$empty;
													}
												}(),
													function () {
													var _v3 = _Utils_Tuple2(
														A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.R9.Xk),
														A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.ON.Xk));
													if ((!_v3.a.$) && (!_v3.b.$)) {
														var familyMonthAmountInCents = _v3.a.a;
														var coupleMonthAmountInCents = _v3.b.a;
														return A2(
															$author$project$Ui$Element$view,
															_List_fromArray(
																[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted, $author$project$Ui$Element$fontBold]),
															_List_fromArray(
																[
																	$elm$html$Html$text('For families, assign the children a combined rate of '),
																	$elm$html$Html$text(
																	$author$project$Utils$Currency$fromInt(familyMonthAmountInCents - coupleMonthAmountInCents)),
																	$elm$html$Html$text(' divided evenly between them.')
																]));
													} else {
														return $author$project$Utils$Html$empty;
													}
												}()
												]))
										])),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									A2(
									$author$project$Ui$Typography$label,
									_List_fromArray(
										[$author$project$Ui$Typography$controlLabel]),
									_List_fromArray(
										[
											$elm$html$Html$text('Everyone')
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Radio$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Radio$value(splitRevenueType === 'even_all'),
													$author$project$Ui$Form$Radio$onCheck(
													A2(
														$elm$core$Basics$composeL,
														$author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated,
														$elm$core$Basics$always(
															$author$project$Components$Plan$Form$GroupTierPricingFields$SplitRevenueType('even_all'))))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Divide the group rate evenly across all members.'),
													function () {
													var _v4 = A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.R9.Xk);
													if (!_v4.$) {
														var familyMonthAmountInCents = _v4.a;
														return A2(
															$author$project$Ui$Element$view,
															_List_fromArray(
																[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted, $author$project$Ui$Element$fontBold]),
															_List_fromArray(
																[
																	$elm$html$Html$text('For a family of four, they will each receive a rate of '),
																	$elm$html$Html$text(
																	$author$project$Utils$Currency$fromInt(
																		$elm$core$Basics$round(familyMonthAmountInCents / 4))),
																	$elm$html$Html$text('. If the family rate does not divide evenly, some individual rates will be '),
																	$elm$html$Html$text('adjusted by a few pennies so that the individual rates will sum to the group rate.')
																]));
													} else {
														return $author$project$Utils$Html$empty;
													}
												}()
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Api$Provider$McePricing$One$getLowestAgeBandPrice = function (ageBands) {
	return A2(
		$elm$core$Maybe$map,
		function ($) {
			return $.Dw;
		},
		$elm$core$List$head(ageBands));
};
var $author$project$Api$Provider$Plan$One$mcePricing = function (_v0) {
	var record = _v0.b;
	return record.WJ;
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$viewMceLowestAgeBandValue = function (mceLowestAgeBandValue) {
	return $author$project$Ui$Form$CurrencyInput$view(
		_List_fromArray(
			[
				function () {
				if (!mceLowestAgeBandValue.$) {
					var mceValue_ = mceLowestAgeBandValue.a;
					return $author$project$Ui$Form$CurrencyInput$value(
						$elm$core$Maybe$Just(
							$author$project$Currency$fromInt(mceValue_)));
				} else {
					return $author$project$Ui$Form$CurrencyInput$value($elm$core$Maybe$Nothing);
				}
			}(),
				$author$project$Ui$Form$CurrencyInput$disabled(true)
			]));
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$viewRateWithMcePricing = F5(
	function (plan, defaultPeriod, fixedRateRule, mceRateRule, form) {
		var _v0 = $author$project$Api$Provider$Plan$One$mcePricing(plan);
		if (!_v0.$) {
			var maybePricing = _v0.a;
			return $elm$core$List$singleton(
				$author$project$Components$Plan$Form$GroupTierPricingFields$viewMceLowestAgeBandValue(
					A2(
						$elm$core$Maybe$andThen,
						$author$project$Api$Provider$McePricing$One$getLowestAgeBandPrice,
						A2($elm$core$Maybe$map, mceRateRule, maybePricing))));
		} else {
			return A4($author$project$Components$Plan$Form$GroupTierPricingFields$viewFixedRateRule, defaultPeriod, plan, form, fixedRateRule);
		}
	});
var $author$project$Components$Plan$Form$GroupTierPricingFields$viewGroupTierPricingFieldsWithSharedFields = F3(
	function (sharedFields, plan, _v0) {
		var form = _v0;
		var forCompany = !$author$project$Api$Provider$Plan$One$planType(plan);
		var fourTierHelpUrl = forCompany ? 'https://support.hint.com/employers/four-tier-pricing' : 'https://support.hint.com/account-configuration/four-tier-pricing-for-patients';
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mb2]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('Group Tier Pricing'),
									$author$project$Utils$Html$noBreakSpace,
									A2(
									$elm$html$Html$map,
									$elm$core$Basics$never,
									$author$project$Ui$SupportDocumentLink$view(fourTierHelpUrl))
								]))
						])),
					$author$project$Api$Provider$Plan$One$isMcePlan(plan) ? $author$project$Utils$Html$empty : A3(
					$author$project$Ui$Button$view,
					{mm: ' Switch to Individual Rates with Discounts'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$onClick(
							$author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated($author$project$Components$Plan$Form$GroupTierPricingFields$ToggleFixedMembershipPricing))
						]),
					_List_fromArray(
						[
							$author$project$Ui$Icon$transfer(_List_Nil),
							$elm$html$Html$text(' Switch to Individual Rates with Discounts')
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$helpBlock]),
					_List_fromArray(
						[
							$elm$html$Html$text('Group Tier pricing assigns one of the defined tiers to every primary member and their dependents.')
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$offsetLabel,
							$author$project$Ui$Form$Group$labelSpanSm(5),
							$author$project$Ui$Form$Group$inputSpanSm(6),
							$author$project$Ui$Form$Group$labelHtml(
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$RateRule$groupTierName($author$project$Api$RateRuleType$Individual)),
									$author$project$Utils$Html$noBreakSpace,
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$hintLabel]),
									A2(
										$author$project$Utils$RateRule$groupTierCode,
										$author$project$Api$Provider$Plan$One$planType(plan) === 2,
										$author$project$Api$RateRuleType$Individual))
								])),
							$author$project$Ui$Form$Group$labelClass('')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$row,
							_List_fromArray(
								[$author$project$Ui$Grid$rowItemsCenter]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanSm(4),
											$author$project$Ui$Grid$justifyLeft
										]),
									_List_Nil),
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanSm(8)
										]),
									A5($author$project$Components$Plan$Form$GroupTierPricingFields$viewRateWithMcePricing, plan, sharedFields.P6, fields.TX, $author$project$Api$Provider$McePricing$One$individualRates, form))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$offsetLabel,
							$author$project$Ui$Form$Group$labelSpanSm(5),
							$author$project$Ui$Form$Group$inputSpanSm(6),
							$author$project$Ui$Form$Group$labelHtml(
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$RateRule$groupTierName($author$project$Api$RateRuleType$Couple)),
									$author$project$Utils$Html$noBreakSpace,
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$hintLabel]),
									A2(
										$author$project$Utils$RateRule$groupTierCode,
										$author$project$Api$Provider$Plan$One$planType(plan) === 2,
										$author$project$Api$RateRuleType$Couple))
								])),
							$author$project$Ui$Form$Group$labelClass('')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$row,
							_List_fromArray(
								[$author$project$Ui$Grid$rowItemsCenter]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanSm(4),
											$author$project$Ui$Grid$justifyLeft
										]),
									_List_Nil),
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanSm(8)
										]),
									A5($author$project$Components$Plan$Form$GroupTierPricingFields$viewRateWithMcePricing, plan, sharedFields.P6, fields.ON, $author$project$Api$Provider$McePricing$One$coupleRates, form))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$offsetLabel,
							$author$project$Ui$Form$Group$labelSpanSm(5),
							$author$project$Ui$Form$Group$inputSpanSm(6),
							$author$project$Ui$Form$Group$labelHtml(
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$RateRule$groupTierName($author$project$Api$RateRuleType$FamilyWithSingleChild)),
									$author$project$Utils$Html$noBreakSpace,
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$hintLabel]),
									A2(
										$author$project$Utils$RateRule$groupTierCode,
										$author$project$Api$Provider$Plan$One$planType(plan) === 2,
										$author$project$Api$RateRuleType$FamilyWithSingleChild))
								])),
							$author$project$Ui$Form$Group$labelClass('')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$row,
							_List_fromArray(
								[$author$project$Ui$Grid$rowItemsCenter]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanSm(4),
											$author$project$Ui$Grid$justifyLeft
										]),
									_List_fromArray(
										[
											$author$project$Ui$ToggleSwitch$view(
											_List_fromArray(
												[
													$author$project$Ui$ToggleSwitch$on(fields.Sc),
													$author$project$Ui$ToggleSwitch$onChange(
													A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated, $author$project$Components$Plan$Form$GroupTierPricingFields$FamilyWithSingleChildRateRuleEnabled)),
													$author$project$Ui$ToggleSwitch$disabled(
													$author$project$Api$Provider$Plan$One$isMcePlan(plan))
												]))
										])),
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanSm(8)
										]),
									fields.Sc ? A5($author$project$Components$Plan$Form$GroupTierPricingFields$viewRateWithMcePricing, plan, sharedFields.P6, fields.Sb, $author$project$Api$Provider$McePricing$One$familyRates, form) : _List_Nil)
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$offsetLabel,
							$author$project$Ui$Form$Group$labelSpanSm(5),
							$author$project$Ui$Form$Group$inputSpanSm(6),
							$author$project$Ui$Form$Group$labelHtml(
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$RateRule$groupTierName($author$project$Api$RateRuleType$SingleParent)),
									$author$project$Utils$Html$noBreakSpace,
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$hintLabel]),
									A2(
										$author$project$Utils$RateRule$groupTierCode,
										$author$project$Api$Provider$Plan$One$planType(plan) === 2,
										$author$project$Api$RateRuleType$SingleParent))
								])),
							$author$project$Ui$Form$Group$labelClass('')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$row,
							_List_fromArray(
								[$author$project$Ui$Grid$rowItemsCenter]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanSm(4),
											$author$project$Ui$Grid$justifyLeft
										]),
									_List_Nil),
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanSm(8)
										]),
									A5($author$project$Components$Plan$Form$GroupTierPricingFields$viewRateWithMcePricing, plan, sharedFields.P6, fields.abC, $author$project$Api$Provider$McePricing$One$singleParentWithChildrenRates, form))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$offsetLabel,
							$author$project$Ui$Form$Group$labelSpanSm(5),
							$author$project$Ui$Form$Group$inputSpanSm(6),
							$author$project$Ui$Form$Group$labelHtml(
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$RateRule$groupTierName($author$project$Api$RateRuleType$SingleParentWithSingleChild)),
									$author$project$Utils$Html$noBreakSpace,
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$hintLabel]),
									A2(
										$author$project$Utils$RateRule$groupTierCode,
										$author$project$Api$Provider$Plan$One$planType(plan) === 2,
										$author$project$Api$RateRuleType$SingleParentWithSingleChild))
								])),
							$author$project$Ui$Form$Group$labelClass('')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$row,
							_List_fromArray(
								[$author$project$Ui$Grid$rowItemsCenter]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanSm(4),
											$author$project$Ui$Grid$justifyLeft
										]),
									_List_fromArray(
										[
											$author$project$Ui$ToggleSwitch$view(
											_List_fromArray(
												[
													$author$project$Ui$ToggleSwitch$on(fields.abF),
													$author$project$Ui$ToggleSwitch$onChange(
													A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated, $author$project$Components$Plan$Form$GroupTierPricingFields$SingleParentWithSingleChildRateRuleEnabled)),
													$author$project$Ui$ToggleSwitch$disabled(
													$author$project$Api$Provider$Plan$One$isMcePlan(plan))
												]))
										])),
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanSm(8)
										]),
									fields.abF ? A5($author$project$Components$Plan$Form$GroupTierPricingFields$viewRateWithMcePricing, plan, sharedFields.P6, fields.abE, $author$project$Api$Provider$McePricing$One$singleParentWithChildrenRates, form) : _List_Nil)
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$offsetLabel,
							$author$project$Ui$Form$Group$labelSpanSm(5),
							$author$project$Ui$Form$Group$inputSpanSm(6),
							$author$project$Ui$Form$Group$labelHtml(
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$RateRule$groupTierName($author$project$Api$RateRuleType$Family)),
									$author$project$Utils$Html$noBreakSpace,
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$hintLabel]),
									A2(
										$author$project$Utils$RateRule$groupTierCode,
										$author$project$Api$Provider$Plan$One$planType(plan) === 2,
										$author$project$Api$RateRuleType$Family))
								])),
							$author$project$Ui$Form$Group$labelClass('')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$row,
							_List_fromArray(
								[$author$project$Ui$Grid$rowItemsCenter]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanSm(4),
											$author$project$Ui$Grid$justifyLeft
										]),
									_List_Nil),
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanSm(8)
										]),
									A5($author$project$Components$Plan$Form$GroupTierPricingFields$viewRateWithMcePricing, plan, sharedFields.P6, fields.R9, $author$project$Api$Provider$McePricing$One$familyRates, form))
								]))
						])),
					A5(
					$author$project$Components$Plan$Form$GroupTierPricingFields$viewAgeLimitField,
					'Children Age Limit',
					fields.aak.Sw.Ro,
					fields.Sw,
					form,
					$author$project$Components$Plan$Form$GroupTierPricingFields$ToggleRule(0)),
					A5(
					$author$project$Components$Plan$Form$GroupTierPricingFields$viewAdultsLimitField,
					'Limit Adults in Family Plan',
					fields.aak.R8.Ro,
					fields.R8,
					form,
					$author$project$Components$Plan$Form$GroupTierPricingFields$ToggleRule(1)),
					fields.aak.R8.Ro ? A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$offsetLabel,
							$author$project$Ui$Form$Group$labelSpanSm(5),
							$author$project$Ui$Form$Group$inputSpanSm(6),
							$author$project$Ui$Form$Group$labelHtml(
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$RateRule$groupTierName($author$project$Api$RateRuleType$AdditionalAdult)),
									$author$project$Utils$Html$noBreakSpace,
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$hintLabel]),
									A2(
										$author$project$Utils$RateRule$groupTierCode,
										$author$project$Api$Provider$Plan$One$planType(plan) === 2,
										$author$project$Api$RateRuleType$AdditionalAdult))
								])),
							$author$project$Ui$Form$Group$labelClass(''),
							$author$project$Ui$Form$Group$labelHelp(
							$elm$html$Html$text('For group that don\'t fall into tiers above (i.e. 3 adults)'))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$row,
							_List_fromArray(
								[$author$project$Ui$Grid$rowItemsCenter]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanSm(4),
											$author$project$Ui$Grid$justifyLeft
										]),
									_List_Nil),
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanSm(8)
										]),
									A4($author$project$Components$Plan$Form$GroupTierPricingFields$viewFixedRateRule, sharedFields.P6, plan, form, fields.KZ))
								]))
						])) : $elm$html$Html$text(''),
					A5(
					$author$project$Components$Plan$Form$GroupTierPricingFields$viewChildrenLimitField,
					'Limit Children in Family Plan',
					fields.aak.S0.Ro,
					fields.S0,
					form,
					$author$project$Components$Plan$Form$GroupTierPricingFields$ToggleRule(2)),
					fields.aak.S0.Ro ? A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$offsetLabel,
							$author$project$Ui$Form$Group$labelSpanSm(5),
							$author$project$Ui$Form$Group$inputSpanSm(6),
							$author$project$Ui$Form$Group$labelHtml(
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$RateRule$groupTierName($author$project$Api$RateRuleType$AdditionalChild)),
									$author$project$Utils$Html$noBreakSpace,
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$hintLabel]),
									A2(
										$author$project$Utils$RateRule$groupTierCode,
										$author$project$Api$Provider$Plan$One$planType(plan) === 2,
										$author$project$Api$RateRuleType$AdditionalChild))
								])),
							$author$project$Ui$Form$Group$labelClass(''),
							$author$project$Ui$Form$Group$labelHelp(
							$elm$html$Html$text('For groups that exceed the children limit'))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$row,
							_List_fromArray(
								[$author$project$Ui$Grid$rowItemsCenter]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanSm(4),
											$author$project$Ui$Grid$justifyLeft
										]),
									_List_Nil),
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanSm(8)
										]),
									A4($author$project$Components$Plan$Form$GroupTierPricingFields$viewFixedRateRule, sharedFields.P6, plan, form, fields.K_))
								]))
						])) : $elm$html$Html$text(''),
					A2($author$project$Components$Plan$Form$GroupTierPricingFields$viewRateSplitSection, fields, form)
				]));
	});
var $author$project$Components$Plan$Form$GroupTierPricingFields$view = F3(
	function (sharedFields, maybePlan, groupTierPricingForm) {
		if (!maybePlan.$) {
			var plan = maybePlan.a;
			return A3($author$project$Components$Plan$Form$GroupTierPricingFields$viewGroupTierPricingFieldsWithSharedFields, sharedFields, plan, groupTierPricingForm);
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleAdd = {$: 0};
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$ToggleFixedMembershipPricing = {$: 10};
var $elm_community$list_extra$List$Extra$zip = $elm$core$List$map2($elm$core$Tuple$pair);
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$rulesetHasGaps = function (rules) {
	if ($elm$core$List$length(rules) <= 1) {
		return false;
	} else {
		var pairs = A2(
			$elm_community$list_extra$List$Extra$zip,
			rules,
			A2($elm$core$List$drop, 1, rules));
		return A2(
			$elm$core$List$any,
			function (_v0) {
				var current = _v0.a;
				var next = _v0.b;
				var _v1 = current.adb;
				if (_v1.$ === 1) {
					return false;
				} else {
					var currentTo = _v1.a;
					if (_Utils_eq(current.adL, next.adL)) {
						return _Utils_cmp(currentTo + 1, next.SK) < 0;
					} else {
						var nextFromMonths = (!next.adL) ? (next.SK * 12) : next.SK;
						var currentToMonths = (!current.adL) ? (currentTo * 12) : currentTo;
						return _Utils_cmp(currentToMonths + 1, nextFromMonths) < 0;
					}
				}
			},
			pairs);
	}
};
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleAmountInCents = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleAmountInCentsEdit = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleAmountInCentsReset = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleRemove = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleToAge = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleUnit = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Api$Feature$AgeTieredCoupleRates = 20;
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$CoupleAgeRateRuleAmountInCents = F3(
	function (a, b, c) {
		return {$: 7, a: a, b: b, c: c};
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$CoupleAgeRateRuleAmountInCentsEdit = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$CoupleAgeRateRuleAmountInCentsReset = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$ageRateRuleToAgeOptions = function (unit) {
	var maxAge = function () {
		if (unit === 1) {
			return $author$project$Components$Plan$Form$IndividualMembershipPricingFields$maxMonths;
		} else {
			return 150;
		}
	}();
	return A2(
		$elm$core$List$map,
		function (age) {
			return A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(
					$elm$core$String$fromInt(age)),
				$elm$core$String$fromInt(age));
		},
		A2($elm$core$List$range, 0, maxAge));
};
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$ageRateRuleUnitOptions = _List_fromArray(
	[
		A3(
		$author$project$Ui$Form$Select$option,
		_List_Nil,
		$elm$core$Maybe$Just(
			$author$project$Api$Provider$RateRule$Shared$unitToString(1)),
		'Months'),
		A3(
		$author$project$Ui$Form$Select$option,
		_List_Nil,
		$elm$core$Maybe$Just(
			$author$project$Api$Provider$RateRule$Shared$unitToString(0)),
		'Years')
	]);
var $author$project$Api$Employer$Practice$One$featureEnabled = F2(
	function (feature, _v0) {
		var record = _v0;
		return A2(
			$elm$core$List$member,
			$author$project$Api$Feature$toString(feature),
			record.Sf);
	});
var $author$project$Api$Practice$featureEnabled = F2(
	function (feature, practice) {
		if (!practice.$) {
			var practice_ = practice.a;
			return A2($author$project$Api$Provider$Practice$One$featureEnabled, feature, practice_);
		} else {
			var practice_ = practice.a;
			return A2($author$project$Api$Employer$Practice$One$featureEnabled, feature, practice_);
		}
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$isUnitEditable = F2(
	function (rules, index) {
		var prevAgeRateRule = A2($elm_community$list_extra$List$Extra$getAt, index - 1, rules);
		var nextAgeRateRule = A2($elm_community$list_extra$List$Extra$getAt, index + 1, rules);
		var isPrevRuleYears = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (rule) {
					return !rule.adL;
				},
				prevAgeRateRule));
		var isNextRuleMonths = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (unit) {
					return unit === 1;
				},
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.adL;
					},
					nextAgeRateRule)));
		var isLast = _Utils_eq(
			index,
			$elm$core$List$length(rules) - 1);
		return (!isLast) && ((!isPrevRuleYears) && (!isNextRuleMonths));
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$viewAmountInCentsPricingRulePeriod = F7(
	function (_v0, form, editingPlan, rule, isDiscount, isCouplePricing, period) {
		var defaultPeriod = _v0.P6;
		var _v1 = function () {
			switch (period) {
				case 'month':
					return _Utils_Tuple3(rule.Xk, rule.IB, rule.gX);
				case 'quarter':
					return _Utils_Tuple3(rule._Q, rule._R, rule.ho);
				case 'semi_annual':
					return _Utils_Tuple3(rule.aaJ, rule.aaK, rule.hz);
				case 'annual':
					return _Utils_Tuple3(rule.LH, rule.LI, rule.fE);
				default:
					return _Utils_Tuple3(rule.Xk, rule.IB, rule.gX);
			}
		}();
		var periodAmountInCents = _v1.a;
		var editingPeriod = _v1.b;
		var periodEdited = _v1.c;
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			(_Utils_eq(defaultPeriod, period) || editingPeriod) ? _List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
					_List_fromArray(
						[
							isCouplePricing ? $elm$html$Html$text('Couple ') : $elm$html$Html$text(''),
							isCouplePricing ? $elm$html$Html$text(
							$elm$core$String$toLower(
								$author$project$Formatters$String$humanize(period))) : $elm$html$Html$text(
							$author$project$Formatters$String$humanize(period)),
							isDiscount ? $elm$html$Html$text(' discount') : $elm$html$Html$text(' rate')
						])),
					$author$project$Ui$Form$CurrencyInput$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$CurrencyInput$value(periodAmountInCents),
							$author$project$Ui$Form$CurrencyInput$onInput(
							A2(
								$elm$core$Basics$composeL,
								$author$project$Components$Plan$Form$IndividualMembershipPricingFields$FormUpdated,
								rule.Yh(period))),
							$author$project$Ui$Form$CurrencyInput$invalid(
							A2(
								$author$project$Utils$Form$hasValidationErrors,
								rule.I9(period),
								form))
						])),
					$author$project$Utils$FormErrors$view(
					A2(
						$author$project$Utils$Form$validationErrors,
						rule.I9(period),
						form))
				]) : _List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween]),
					(!editingPlan) ? _List_Nil : _List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Formatters$String$humanize(period)),
									$author$project$Utils$Html$noBreakSpace,
									$elm$html$Html$text(
									$author$project$Currency$format(
										A2($elm$core$Maybe$withDefault, $author$project$Currency$zero, periodAmountInCents))),
									isDiscount ? $elm$html$Html$text(' off') : $author$project$Utils$Html$empty
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									periodEdited ? A3(
									$author$project$Ui$Button$view,
									{mm: 'Reset period amount'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick(
											$author$project$Components$Plan$Form$IndividualMembershipPricingFields$FormUpdated(
												rule.$P(period)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Reset')
										])) : $author$project$Utils$Html$empty,
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Edit period amount'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick(
											$author$project$Components$Plan$Form$IndividualMembershipPricingFields$FormUpdated(
												rule.Q2(period)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit')
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$viewAmountInCentsPricingRule = F7(
	function (sharedFields, form, _v0, periods, rule, isDiscount, isCouplePricing) {
		var editingPlan = _v0.Q5;
		return A2(
			$elm$core$List$map,
			A6($author$project$Components$Plan$Form$IndividualMembershipPricingFields$viewAmountInCentsPricingRulePeriod, sharedFields, form, editingPlan, rule, isDiscount, isCouplePricing),
			periods);
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$viewAgeRateRule = F6(
	function (sharedFields, practice, maybePlan, form, index, ageRateRule) {
		var periodCodes = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Api$Provider$Plan$Meta$defaultAllPeriodCodes,
			A2(
				$elm$core$Maybe$map,
				function (plan) {
					return $author$project$Api$Provider$Plan$Meta$allowedPeriodCodes(
						$author$project$Api$Provider$Plan$One$meta(plan));
				},
				maybePlan));
		var isFirst = !index;
		var _v0 = $author$project$Utils$Form$fields(form);
		var ageRateRules = _v0.Lk;
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textSm]),
									_List_fromArray(
										[$author$project$Utils$Html$noBreakSpace])),
									A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$core$String$fromInt(ageRateRule.SK))
										]))
								]))
						]),
						function () {
						if (_Utils_eq(ageRateRule.adb, $elm$core$Maybe$Nothing)) {
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Table$cell,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$textSm]),
											_List_fromArray(
												[$author$project$Utils$Html$noBreakSpace])),
											A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('All')
												]))
										]))
								]);
						} else {
							var isLast = _Utils_eq(
								$elm$core$List$length(ageRateRules) - 1,
								index);
							return isLast ? _List_Nil : _List_fromArray(
								[
									A2(
									$author$project$Ui$Table$cell,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$textSm]),
											_List_fromArray(
												[$author$project$Utils$Html$noBreakSpace])),
											A2(
											$author$project$Ui$Form$Select$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Select$value(
													A2($elm$core$Maybe$map, $elm$core$String$fromInt, ageRateRule.adb)),
													$author$project$Ui$Form$Select$onChange(
													A2(
														$elm$core$Basics$composeL,
														$author$project$Components$Plan$Form$IndividualMembershipPricingFields$FormUpdated,
														$author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleToAge(index)))
												]),
											$author$project$Components$Plan$Form$IndividualMembershipPricingFields$ageRateRuleToAgeOptions(ageRateRule.adL))
										]))
								]);
						}
					}(),
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textSm]),
									_List_fromArray(
										[$author$project$Utils$Html$noBreakSpace])),
									A2($author$project$Components$Plan$Form$IndividualMembershipPricingFields$isUnitEditable, ageRateRules, index) ? A2(
									$author$project$Ui$Form$Select$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Select$value(
											$elm$core$Maybe$Just(
												$author$project$Api$Provider$RateRule$Shared$unitToString(ageRateRule.adL))),
											$author$project$Ui$Form$Select$onChange(
											A2(
												$elm$core$Basics$composeL,
												$author$project$Components$Plan$Form$IndividualMembershipPricingFields$FormUpdated,
												$author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleUnit(index)))
										]),
									$author$project$Components$Plan$Form$IndividualMembershipPricingFields$ageRateRuleUnitOptions) : A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('capitalize')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Api$Provider$RateRule$Shared$unitToString(ageRateRule.adL))
												]))
										]))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textSm]),
									_List_fromArray(
										[$author$project$Utils$Html$noBreakSpace])),
									(!isFirst) ? A3(
									$author$project$Ui$Button$view,
									{mm: 'Remove age rule'},
									_List_fromArray(
										[
											$author$project$Ui$Button$onClick(
											$author$project$Components$Plan$Form$IndividualMembershipPricingFields$FormUpdated(
												$author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleRemove(index))),
											$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Remove')
										])) : $author$project$Utils$Html$empty
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							$elm$core$List$concat(
								_List_fromArray(
									[
										A7(
										$author$project$Components$Plan$Form$IndividualMembershipPricingFields$viewAmountInCentsPricingRule,
										sharedFields,
										form,
										{
											Q5: !_Utils_eq(maybePlan, $elm$core$Maybe$Nothing)
										},
										periodCodes,
										{
											LH: ageRateRule.dE.LH,
											fE: ageRateRule.dE.fE,
											LI: ageRateRule.dE.LI,
											Q2: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleAmountInCentsEdit(index),
											Xk: ageRateRule.dE.Xk,
											gX: ageRateRule.dE.gX,
											IB: ageRateRule.dE.IB,
											Yh: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleAmountInCents(index),
											I9: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleAmountInCentsValidation(index),
											_Q: ageRateRule.dE._Q,
											ho: ageRateRule.dE.ho,
											_R: ageRateRule.dE._R,
											$P: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleAmountInCentsReset(index),
											aaJ: ageRateRule.dE.aaJ,
											hz: ageRateRule.dE.hz,
											aaK: ageRateRule.dE.aaK
										},
										false,
										false),
										function () {
										if (A2(
											$author$project$Api$Practice$featureEnabled,
											20,
											$author$project$Api$Practice$Provider(practice))) {
											var _v1 = ageRateRule.OM;
											if (!_v1.$) {
												var coupleRule = _v1.a;
												return A2(
													$elm$core$List$cons,
													A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																A2($elm$html$Html$Attributes$style, 'margin-top', '20px')
															]),
														_List_Nil),
													A7(
														$author$project$Components$Plan$Form$IndividualMembershipPricingFields$viewAmountInCentsPricingRule,
														sharedFields,
														form,
														{
															Q5: !_Utils_eq(maybePlan, $elm$core$Maybe$Nothing)
														},
														periodCodes,
														{
															LH: coupleRule.dE.LH,
															fE: coupleRule.dE.fE,
															LI: coupleRule.dE.LI,
															Q2: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$CoupleAgeRateRuleAmountInCentsEdit(index),
															Xk: coupleRule.dE.Xk,
															gX: coupleRule.dE.gX,
															IB: coupleRule.dE.IB,
															Yh: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$CoupleAgeRateRuleAmountInCents(index),
															I9: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$CoupleAgeRateRuleAmountInCentsValidation(index),
															_Q: coupleRule.dE._Q,
															ho: coupleRule.dE.ho,
															_R: coupleRule.dE._R,
															$P: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$CoupleAgeRateRuleAmountInCentsReset(index),
															aaJ: coupleRule.dE.aaJ,
															hz: coupleRule.dE.hz,
															aaK: coupleRule.dE.aaK
														},
														false,
														true));
											} else {
												return _List_Nil;
											}
										} else {
											return _List_Nil;
										}
									}()
									])))
						])
					])));
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$viewIndividualMembershipPricingFields = F4(
	function (sharedFields, practice, maybePlan, _v0) {
		var form = _v0;
		var _v1 = $author$project$Utils$Form$fields(form);
		var ageRateRules = _v1.Lk;
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mb2]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('Individual Membership Rates'),
									$author$project$Utils$Html$noBreakSpace,
									A2(
									$elm$html$Html$map,
									$elm$core$Basics$never,
									$author$project$Ui$SupportDocumentLink$view('https://support.hint.com/account-configuration/configuring-your-membership-rates-and-billing-options'))
								]))
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Utils$FeatureGate$gate,
							7,
							$author$project$Api$Practice$Provider(practice),
							function () {
								if (!maybePlan.$) {
									return A3(
										$author$project$Ui$Button$view,
										{mm: 'Switch to group tier pricing'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$onClick(
												$author$project$Components$Plan$Form$IndividualMembershipPricingFields$FormUpdated($author$project$Components$Plan$Form$IndividualMembershipPricingFields$ToggleFixedMembershipPricing))
											]),
										_List_fromArray(
											[
												$author$project$Ui$Icon$transfer(_List_Nil),
												$elm$html$Html$text(' Switch to Group tier pricing')
											]));
								} else {
									return $author$project$Utils$Html$empty;
								}
							}()),
							A2(
							$author$project$Ui$Typography$p,
							_List_fromArray(
								[$author$project$Ui$Typography$helpBlock]),
							_List_fromArray(
								[
									$elm$html$Html$text('Set one individual rate or age based rates with the option for family or group discounts.')
								]))
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var messageStyle = $author$project$Components$Plan$Form$IndividualMembershipPricingFields$rulesetHasGaps(
								$author$project$Utils$Form$fields(form).Lk) ? '' : 'invisible';
							return A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$warning]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class(messageStyle)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('We noticed a gap between your age tiers. Patients whose ages don\'t match any tier will automatically be charged the first tier price. You can adjust the ranges before saving.')
											]))
									]));
						}()
						])),
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(11),
									$author$project$Ui$Grid$offsetSm(1)
								]),
							_List_fromArray(
								[
									A4(
									$author$project$Ui$Table$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Table$header,
											_List_fromArray(
												[
													$author$project$Ui$Table$cellSpan(2)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('From Age')
												])),
											A2(
											$author$project$Ui$Table$header,
											_List_fromArray(
												[
													$author$project$Ui$Table$cellSpan(2)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('To Age')
												])),
											A2(
											$author$project$Ui$Table$header,
											_List_fromArray(
												[
													$author$project$Ui$Table$cellSpan(2)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Units')
												])),
											A2(
											$author$project$Ui$Table$header,
											_List_fromArray(
												[
													$author$project$Ui$Table$cellSpan(2)
												]),
											_List_Nil),
											A2(
											$author$project$Ui$Table$header,
											_List_fromArray(
												[
													$author$project$Ui$Table$cellSpan(4)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Rate')
												]))
										]),
									A2(
										$elm$core$List$indexedMap,
										A4($author$project$Components$Plan$Form$IndividualMembershipPricingFields$viewAgeRateRule, sharedFields, practice, maybePlan, form),
										ageRateRules),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Table$row,
											_List_Nil,
											_List_fromArray(
												[
													A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
													A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
													A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
													A2(
													$author$project$Ui$Table$cell,
													_List_Nil,
													_List_fromArray(
														[
															A3(
															$author$project$Ui$Button$view,
															{mm: 'Add age range'},
															_List_fromArray(
																[
																	$author$project$Ui$Button$onClick(
																	$author$project$Components$Plan$Form$IndividualMembershipPricingFields$FormUpdated($author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleAdd)),
																	$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Add Range')
																]))
														]))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$view = F4(
	function (sharedFields, practice, maybePlan, _v0) {
		var form = _v0;
		return A4($author$project$Components$Plan$Form$IndividualMembershipPricingFields$viewIndividualMembershipPricingFields, sharedFields, practice, maybePlan, form);
	});
var $author$project$Components$Plan$Form$SpecialRatesFields$FormUpdated = $elm$core$Basics$identity;
var $author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateAdd = {$: 0};
var $author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateAmountInCents = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateAmountInCentsEdit = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateAmountInCentsReset = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateName = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateRemove = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Icon$Minus = 75;
var $author$project$Ui$Icon$minus = $author$project$Ui$Icon$viewIcon(75);
var $author$project$Ui$Table$None = {$: 0};
var $author$project$Ui$Table$none = $author$project$Ui$Table$None;
var $author$project$Components$Plan$Form$SpecialRatesFields$viewAmountInCentsPricingRulePeriod = F5(
	function (defaultPeriod, form, rule, isDiscount, period) {
		var _v0 = function () {
			switch (period) {
				case 'month':
					return _Utils_Tuple3(rule.Xk, rule.IB, rule.gX);
				case 'quarter':
					return _Utils_Tuple3(rule._Q, rule._R, rule.ho);
				case 'semi_annual':
					return _Utils_Tuple3(rule.aaJ, rule.aaK, rule.hz);
				case 'annual':
					return _Utils_Tuple3(rule.LH, rule.LI, rule.fE);
				default:
					return _Utils_Tuple3(rule.Xk, rule.IB, rule.gX);
			}
		}();
		var periodAmountInCents = _v0.a;
		var editingPeriod = _v0.b;
		var periodEdited = _v0.c;
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			(_Utils_eq(defaultPeriod, period) || editingPeriod) ? _List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Formatters$String$humanize(period)),
							isDiscount ? $elm$html$Html$text(' discount') : $elm$html$Html$text(' rate')
						])),
					$author$project$Ui$Form$CurrencyInput$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$CurrencyInput$value(periodAmountInCents),
							$author$project$Ui$Form$CurrencyInput$onInput(
							A2(
								$elm$core$Basics$composeL,
								$elm$core$Basics$identity,
								rule.Yh(period))),
							$author$project$Ui$Form$CurrencyInput$invalid(
							A2(
								$author$project$Utils$Form$hasValidationErrors,
								rule.I9(period),
								form))
						])),
					$author$project$Utils$FormErrors$view(
					A2(
						$author$project$Utils$Form$validationErrors,
						rule.I9(period),
						form))
				]) : _List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Formatters$String$humanize(period)),
									$author$project$Utils$Html$noBreakSpace,
									$elm$html$Html$text(
									$author$project$Currency$format(
										A2($elm$core$Maybe$withDefault, $author$project$Currency$zero, periodAmountInCents))),
									isDiscount ? $elm$html$Html$text(' off') : $author$project$Utils$Html$empty
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$gap2, $author$project$Ui$Element$justifyRight]),
							_List_fromArray(
								[
									periodEdited ? A3(
									$author$project$Ui$Button$view,
									{mm: 'Reset period amount'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick(
											rule.$P(period))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Reset')
										])) : $author$project$Utils$Html$empty,
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Edit period amount'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick(
											rule.Q2(period))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit')
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Plan$Form$SpecialRatesFields$viewAmountInCentsPricingRule = F5(
	function (defaultPeriod, form, periods, rule, isDiscount) {
		return A2(
			$elm$core$List$map,
			A4($author$project$Components$Plan$Form$SpecialRatesFields$viewAmountInCentsPricingRulePeriod, defaultPeriod, form, rule, isDiscount),
			periods);
	});
var $author$project$Components$Plan$Form$SpecialRatesFields$viewSpecialRateFields = F4(
	function (plan, form, index, specialRate) {
		return specialRate.Qv ? $author$project$Ui$Table$none : A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textSm]),
							_List_fromArray(
								[$author$project$Utils$Html$noBreakSpace])),
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(specialRate.Bq),
									$author$project$Ui$Form$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										$elm$core$Basics$identity,
										$author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateName(index))),
									$author$project$Ui$Form$Input$placeholder('Student Rate'),
									$author$project$Ui$Form$Input$invalid(
									A2(
										$author$project$Utils$Form$hasValidationErrors,
										$author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateNameValidation(index),
										form)),
									$author$project$Ui$Form$Input$errors(
									A2(
										$author$project$Utils$Form$validationErrors,
										$author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateNameValidation(index),
										form))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textSm]),
							_List_fromArray(
								[$author$project$Utils$Html$noBreakSpace])),
							A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[$author$project$Ui$Typography$small]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Tooltip$view,
									_List_fromArray(
										[
											$author$project$Ui$Tooltip$active(!specialRate.UN)
										]),
									'Cannot be removed because active members are on it.',
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{mm: 'Remove special rate'},
											_List_fromArray(
												[
													$author$project$Ui$Button$disabled(!specialRate.UN),
													$author$project$Ui$Button$onClick(
													$author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateRemove(index)),
													$author$project$Ui$Button$icon($author$project$Ui$Icon$minus)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(' Remove')
												]))
										]))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					A5(
						$author$project$Components$Plan$Form$SpecialRatesFields$viewAmountInCentsPricingRule,
						$author$project$Api$Provider$Plan$One$defaultPeriod(plan),
						form,
						$author$project$Api$Provider$Plan$Meta$allowedPeriodCodes(
							$author$project$Api$Provider$Plan$One$meta(plan)),
						{
							LH: specialRate.LH,
							fE: specialRate.fE,
							LI: specialRate.LI,
							Q2: $author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateAmountInCentsEdit(index),
							Xk: specialRate.Xk,
							gX: specialRate.gX,
							IB: specialRate.IB,
							Yh: $author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateAmountInCents(index),
							I9: $author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateAmountInCentsValidation(index),
							_Q: specialRate._Q,
							ho: specialRate.ho,
							_R: specialRate._R,
							$P: $author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateAmountInCentsReset(index),
							aaJ: specialRate.aaJ,
							hz: specialRate.hz,
							aaK: specialRate.aaK
						},
						false))
				]));
	});
var $author$project$Components$Plan$Form$SpecialRatesFields$view = F2(
	function (plan, _v0) {
		var form = _v0;
		var _v1 = $author$project$Utils$Form$fields(form);
		var specialRates = _v1.abT;
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$HorizontalRule$view(_List_Nil),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mb2]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$title,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Special Rates')
								]))
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$helpBlock]),
					_List_fromArray(
						[
							$elm$html$Html$text('If the rates above do not fully cover your fee schedule, you can define special rates below (e.g., \"College Student\"). You can then manually apply these on a per-person basis. They will also be displayed on patient invoices in place of the charge\'s name.')
						])),
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(11),
									$author$project$Ui$Grid$offsetSm(1)
								]),
							_List_fromArray(
								[
									A4(
									$author$project$Ui$Table$view,
									_List_fromArray(
										[
											$author$project$Ui$Table$zeroState(
											_List_fromArray(
												[
													$elm$html$Html$text('No special rates on this plan.')
												]))
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Table$header,
											_List_fromArray(
												[
													$author$project$Ui$Table$cellSpan(6)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Name')
												])),
											A2(
											$author$project$Ui$Table$header,
											_List_fromArray(
												[
													$author$project$Ui$Table$cellSpan(2)
												]),
											_List_Nil),
											A2(
											$author$project$Ui$Table$header,
											_List_fromArray(
												[
													$author$project$Ui$Table$cellSpan(4)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Rate')
												]))
										]),
									A2(
										$elm$core$List$indexedMap,
										A2($author$project$Components$Plan$Form$SpecialRatesFields$viewSpecialRateFields, plan, form),
										specialRates),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Table$row,
											_List_Nil,
											_List_fromArray(
												[
													A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
													A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
													A2(
													$author$project$Ui$Table$cell,
													_List_Nil,
													_List_fromArray(
														[
															A3(
															$author$project$Ui$Button$view,
															{mm: 'Add special rate'},
															_List_fromArray(
																[
																	$author$project$Ui$Button$onClick($author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateAdd),
																	$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Add Special Rate')
																]))
														]))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Plan$Form$FormUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Plan$Form$MaximumAge = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Plan$Form$MinimumAge = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Plan$Form$ToggleMaximumAge = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Plan$Form$ToggleMinimumAge = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Plan$Form$ageRestrictionOptions = A2(
	$elm$core$List$map,
	function (age) {
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(
				$elm$core$String$fromInt(age)),
			$elm$core$String$fromInt(age));
	},
	A2($elm$core$List$range, 0, 150));
var $author$project$Components$Plan$Form$viewAgeRestrictionsFields = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var editMinimumAge = _v0.zm;
	var editMaximumAge = _v0.zl;
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mb2]),
				_List_fromArray(
					[
						$author$project$Ui$Typography$headingSm(
						_List_fromArray(
							[
								$elm$html$Html$text('Age restrictions')
							]))
					])),
				A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$helpBlock]),
				_List_fromArray(
					[
						$elm$html$Html$text('Patients above or below these age limits will not be able to enroll in this plan online. Your practice staff will see a warning if they try to enroll patients outside the age range.')
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$offsetLabel,
						$author$project$Ui$Form$Group$labelSpanSm(5),
						$author$project$Ui$Form$Group$inputSpanSm(6),
						$author$project$Ui$Form$Group$label('Minimum Age'),
						$author$project$Ui$Form$Group$labelClass('')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$row,
						_List_fromArray(
							[$author$project$Ui$Grid$rowItemsCenter]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanSm(4),
										$author$project$Ui$Grid$justifyLeft
									]),
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$view(
										_List_fromArray(
											[
												$author$project$Ui$ToggleSwitch$on(editMinimumAge),
												$author$project$Ui$ToggleSwitch$onChange(
												A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$ToggleMinimumAge))
											]))
									])),
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanSm(8)
									]),
								_List_fromArray(
									[
										function () {
										if (editMinimumAge) {
											var _v1 = $author$project$Utils$Form$fields(form);
											var minimumAge = _v1.Xd;
											return A2(
												$author$project$Ui$Form$Select$view,
												_List_fromArray(
													[
														$author$project$Ui$Form$Select$value(
														A2($elm$core$Maybe$map, $elm$core$String$fromInt, minimumAge)),
														$author$project$Ui$Form$Select$onChange(
														A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$MinimumAge))
													]),
												$author$project$Components$Plan$Form$ageRestrictionOptions);
										} else {
											return $author$project$Utils$Html$empty;
										}
									}()
									]))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$offsetLabel,
						$author$project$Ui$Form$Group$labelSpanSm(5),
						$author$project$Ui$Form$Group$inputSpanSm(6),
						$author$project$Ui$Form$Group$label('Maximum Age'),
						$author$project$Ui$Form$Group$labelClass('')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$row,
						_List_fromArray(
							[$author$project$Ui$Grid$rowItemsCenter]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanSm(4),
										$author$project$Ui$Grid$justifyLeft
									]),
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$view(
										_List_fromArray(
											[
												$author$project$Ui$ToggleSwitch$on(editMaximumAge),
												$author$project$Ui$ToggleSwitch$onChange(
												A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$ToggleMaximumAge))
											]))
									])),
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanSm(8)
									]),
								_List_fromArray(
									[
										function () {
										if (editMaximumAge) {
											var _v2 = $author$project$Utils$Form$fields(form);
											var maximumAge = _v2.WF;
											return A2(
												$author$project$Ui$Form$Select$view,
												_List_fromArray(
													[
														$author$project$Ui$Form$Select$value(
														A2($elm$core$Maybe$map, $elm$core$String$fromInt, maximumAge)),
														$author$project$Ui$Form$Select$onChange(
														A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$MaximumAge))
													]),
												$author$project$Components$Plan$Form$ageRestrictionOptions);
										} else {
											return $author$project$Utils$Html$empty;
										}
									}()
									]))
							]))
					]))
			]));
};
var $author$project$Components$Plan$Form$ContractExpires = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Plan$Form$ContractEmailsEnabled = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Plan$Form$ContractPeriodInMonths = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Plan$Form$ContractRenewalEmailLeadTime = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Plan$Form$ContractType = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Provider$Plan$Meta$contractTypes = function (_v0) {
	var meta = _v0;
	return meta.OE;
};
var $author$project$Components$Plan$Form$contractTypeOptions = function (planMeta) {
	var contractTypes = $author$project$Api$Provider$Plan$Meta$contractTypes(planMeta);
	return A2(
		$elm$core$List$cons,
		A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(''),
			'Choose an action'),
		A2(
			$elm$core$List$map,
			function (type_) {
				var typeString = $author$project$Api$ContractType$toString(type_);
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(typeString),
					$author$project$Formatters$String$titleize(
						$author$project$Formatters$String$humanize(typeString)));
			},
			contractTypes));
};
var $author$project$Ui$Element$mt3 = $author$project$Ui$Element$Margin('mt-3');
var $author$project$Components$Plan$Form$viewContractExpiresFields = F2(
	function (plan, form) {
		var planMeta = $author$project$Api$Provider$Plan$One$meta(plan);
		var _v0 = $author$project$Utils$Form$fields(form);
		var contractPeriodInMonths = _v0.OC;
		var contractType = _v0.G3;
		var contractEmailsEnabled = _v0.OA;
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$offsetLabel,
						$author$project$Ui$Form$Group$labelSpanSm(5),
						$author$project$Ui$Form$Group$inputSpanSm(6),
						$author$project$Ui$Form$Group$label('Contract Period'),
						$author$project$Ui$Form$Group$labelClass(''),
						$author$project$Ui$Form$Group$required(true)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$PeriodInMonthsInput$view(
						{
							agX: A2($author$project$Utils$Form$validationErrors, $author$project$Components$Plan$Form$ContractPeriodInMonthsValidation, form),
							sM: A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$Plan$Form$ContractPeriodInMonthsValidation, form),
							ajm: A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$ContractPeriodInMonths),
							aee: contractPeriodInMonths
						}),
						A2($author$project$Components$Plan$Form$isContractPeriodInMonthsInvalid, plan, contractPeriodInMonths) ? A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mt3]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Alert$danger,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$textSm]),
										_List_fromArray(
											[
												$elm$html$Html$text('The contract period should be a multiple of the longest billing period. For example, for a membership with annual billing, the contract can be 12, 24, 36, etc. months long.')
											]))
									]))
							])) : $author$project$Utils$Html$empty
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$offsetLabel,
						$author$project$Ui$Form$Group$labelSpanSm(5),
						$author$project$Ui$Form$Group$inputSpanSm(6),
						$author$project$Ui$Form$Group$label('Default Behavior at End of Contract'),
						$author$project$Ui$Form$Group$labelClass(''),
						$author$project$Ui$Form$Group$required(true)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Select$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Select$value(
								A2($elm$core$Maybe$map, $author$project$Api$ContractType$toString, contractType)),
								$author$project$Ui$Form$Select$onChange(
								A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$ContractType)),
								$author$project$Ui$Form$Select$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$Plan$Form$ContractTypeValidation, form)),
								$author$project$Ui$Form$Select$errors(
								A2($author$project$Utils$Form$validationErrors, $author$project$Components$Plan$Form$ContractTypeValidation, form))
							]),
						$author$project$Components$Plan$Form$contractTypeOptions(planMeta))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$offsetLabel,
						$author$project$Ui$Form$Group$labelSpanSm(5),
						$author$project$Ui$Form$Group$inputSpanSm(6),
						$author$project$Ui$Form$Group$label('Send Renewal Email'),
						$author$project$Ui$Form$Group$labelClass(''),
						$author$project$Ui$Form$Group$labelHelp(
						$elm$html$Html$text('If set to off, we will not email patients regarding their renewal or termination'))
					]),
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$view(
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$on(contractEmailsEnabled),
								$author$project$Ui$ToggleSwitch$onChange(
								A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$ContractEmailsEnabled))
							]))
					])),
				function () {
				if (contractEmailsEnabled) {
					var _v1 = $author$project$Utils$Form$fields(form);
					var contractRenewalEmailLeadTime = _v1.OD;
					return A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$offsetLabel,
								$author$project$Ui$Form$Group$labelSpanSm(5),
								$author$project$Ui$Form$Group$inputSpanSm(6),
								$author$project$Ui$Form$Group$label('Renewal email lead time'),
								$author$project$Ui$Form$Group$labelClass(''),
								$author$project$Ui$Form$Group$required(true)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$group(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$value(
												A2(
													$elm$core$Maybe$withDefault,
													'',
													A2($elm$core$Maybe$map, $elm$core$String$fromInt, contractRenewalEmailLeadTime))),
												$author$project$Ui$Form$Input$onInput(
												A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$ContractRenewalEmailLeadTime)),
												$author$project$Ui$Form$Input$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$Plan$Form$ContractRenewalEmailLeadTimeValidation, form))
											])),
										$author$project$Ui$Form$Input$addon(
										_List_fromArray(
											[
												(A2($elm$core$Maybe$withDefault, 0, contractRenewalEmailLeadTime) === 1) ? $elm$html$Html$text('day') : $elm$html$Html$text('days')
											]))
									])),
								$author$project$Utils$FormErrors$view(
								A2($author$project$Utils$Form$validationErrors, $author$project$Components$Plan$Form$ContractRenewalEmailLeadTimeValidation, form))
							]));
				} else {
					return $elm$html$Html$text('');
				}
			}()
			]);
	});
var $author$project$Components$Plan$Form$viewContractPeriodFields = F2(
	function (plan, form) {
		var _v0 = $author$project$Utils$Form$fields(form);
		var contractExpires = _v0.OB;
		return A2(
			$elm$core$List$cons,
			A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$flex, $author$project$Ui$Element$mb2, $author$project$Ui$Element$gap2]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$title,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Contract Period'),
								A2(
								$elm$html$Html$map,
								$elm$core$Basics$never,
								$author$project$Ui$SupportDocumentLink$view('https://support.hint.com/account-configuration/setting-a-contract-length'))
							]))
					])),
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$offsetLabel,
							$author$project$Ui$Form$Group$labelSpanSm(5),
							$author$project$Ui$Form$Group$inputSpanSm(6),
							$author$project$Ui$Form$Group$label('Contract Expiration'),
							$author$project$Ui$Form$Group$labelClass('')
						]),
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$view(
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$on(contractExpires),
									$author$project$Ui$ToggleSwitch$onChange(
									A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$ContractExpires))
								]))
						])),
				contractExpires ? A2($author$project$Components$Plan$Form$viewContractExpiresFields, plan, form) : _List_Nil));
	});
var $author$project$Components$Plan$Form$OpenCoveragePlanModal = {$: 19};
var $author$project$Api$Provider$CoveragePlan$Shared$coverageRules = function (_v0) {
	var record = _v0;
	return record.afY;
};
var $author$project$Api$Provider$CoveragePlan$All$coverageRules = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CoveragePlan$Shared$coverageRules(shared);
};
var $author$project$Api$Provider$CoveragePlan$One$coverageRules = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CoveragePlan$Shared$coverageRules(shared);
};
var $author$project$Components$Plan$Form$coveragePlanCoverageRules = function (coveragePlan) {
	if (!coveragePlan.$) {
		var coveragePlan_ = coveragePlan.a;
		return $author$project$Api$Provider$CoveragePlan$One$coverageRules(coveragePlan_);
	} else {
		var coveragePlan_ = coveragePlan.a;
		return $author$project$Api$Provider$CoveragePlan$All$coverageRules(coveragePlan_);
	}
};
var $author$project$Api$Provider$CoveragePlan$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CoveragePlan$Shared$name(shared);
};
var $author$project$Components$Plan$Form$coveragePlanName = function (coveragePlan) {
	if (!coveragePlan.$) {
		var coveragePlan_ = coveragePlan.a;
		return $author$project$Api$Provider$CoveragePlan$One$name(coveragePlan_);
	} else {
		var coveragePlan_ = coveragePlan.a;
		return $author$project$Api$Provider$CoveragePlan$All$name(coveragePlan_);
	}
};
var $author$project$Components$Plan$Form$viewCoveragePlanDeleteButton = A2(
	$author$project$Ui$Element$view,
	_List_fromArray(
		[$author$project$Ui$Element$flex, $author$project$Ui$Element$justifyRight]),
	_List_fromArray(
		[
			A3(
			$author$project$Ui$Button$view,
			{mm: 'Delete plan coverage'},
			_List_fromArray(
				[
					$author$project$Ui$Button$sm,
					$author$project$Ui$Button$link,
					$author$project$Ui$Button$onClick(
					$author$project$Components$Plan$Form$FormUpdated(
						$author$project$Components$Plan$Form$CoveragePlan($elm$core$Maybe$Nothing))),
					$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Delete')
				]))
		]));
var $author$project$Components$Plan$Form$viewCoveragePlanUndoButton = F2(
	function (originalCoveragePlan, action) {
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$flex, $author$project$Ui$Element$justifyRight]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{mm: 'Undo ' + action},
					_List_fromArray(
						[
							$author$project$Ui$Button$sm,
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$onClick(
							$author$project$Components$Plan$Form$FormUpdated(
								$author$project$Components$Plan$Form$CoveragePlan(
									$elm$core$Maybe$Just(
										$author$project$Components$Plan$Form$CoveragePlanOne(originalCoveragePlan))))),
							$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Undo '),
							$elm$html$Html$text(action)
						]))
				]));
	});
var $author$project$Components$CoverageRuleDescription$One = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$CoverageRule$Shared$patientContributionPercentage = function (_v0) {
	var record = _v0;
	return record.ajS;
};
var $author$project$Api$Provider$CoverageRule$One$patientContributionPercentage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CoverageRule$Shared$patientContributionPercentage(shared);
};
var $author$project$Api$Provider$CoverageRule$Shared$sponsorContributionPercentage = function (_v0) {
	var record = _v0;
	return record.alE;
};
var $author$project$Api$Provider$CoverageRule$One$sponsorContributionPercentage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CoverageRule$Shared$sponsorContributionPercentage(shared);
};
var $author$project$Components$CoverageRuleDescription$coveredBy = function (coverageRule) {
	var sponsorContributionPercentage = function () {
		if (!coverageRule.$) {
			var shared = coverageRule.a;
			return $author$project$Api$Provider$CoverageRule$Shared$sponsorContributionPercentage(shared);
		} else {
			var one = coverageRule.a;
			return $author$project$Api$Provider$CoverageRule$One$sponsorContributionPercentage(one);
		}
	}();
	var patientContributionPercentage = function () {
		if (!coverageRule.$) {
			var shared = coverageRule.a;
			return $author$project$Api$Provider$CoverageRule$Shared$patientContributionPercentage(shared);
		} else {
			var one = coverageRule.a;
			return $author$project$Api$Provider$CoverageRule$One$patientContributionPercentage(one);
		}
	}();
	var _v0 = _Utils_Tuple2(patientContributionPercentage, sponsorContributionPercentage);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var patientContributionPercentage_ = _v0.a.a;
		var sponsorContributionPercentage_ = _v0.b.a;
		return (_Utils_cmp(patientContributionPercentage_, sponsorContributionPercentage_) > 0) ? 'patient' : 'sponsor';
	} else {
		return 'sponsor';
	}
};
var $author$project$Ui$Typography$Underline = 0;
var $author$project$Ui$Typography$underline = $author$project$Ui$Typography$Decoration(0);
var $author$project$Components$CoverageRuleDescription$highlightText = F2(
	function (string, shouldHighlightText) {
		return shouldHighlightText ? A2(
			$author$project$Ui$Typography$strong,
			_List_fromArray(
				[$author$project$Ui$Typography$underline]),
			_List_fromArray(
				[
					$elm$html$Html$text(string)
				])) : $elm$html$Html$text(string);
	});
var $author$project$Api$Provider$CoverageRule$Shared$All = 0;
var $author$project$Api$Provider$CoverageRule$Shared$UnderPrice = 1;
var $author$project$Api$Provider$CoverageRule$Shared$includedOption = function (_v0) {
	var record = _v0;
	if (record.ak7 === 'included') {
		var _v1 = record.LE;
		if (!_v1.$) {
			return $elm$core$Maybe$Just(1);
		} else {
			return $elm$core$Maybe$Just(0);
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$CoverageRule$One$includedOption = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CoverageRule$Shared$includedOption(shared);
};
var $author$project$Api$Provider$CoverageRule$Shared$item = function (_v0) {
	var record = _v0;
	return record.Io;
};
var $author$project$Api$Provider$CoverageRule$One$item = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CoverageRule$Shared$item(shared);
};
var $author$project$Api$Provider$CoverageRule$Shared$amountInCents = function (_v0) {
	var record = _v0;
	return record.LE;
};
var $author$project$Api$Provider$CoverageRule$One$amountInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CoverageRule$Shared$amountInCents(shared);
};
var $author$project$Api$Provider$CoverageRule$Shared$percentage = function (_v0) {
	var record = _v0;
	return record.ajZ;
};
var $author$project$Api$Provider$CoverageRule$One$percentage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CoverageRule$Shared$percentage(shared);
};
var $author$project$Api$Provider$CoverageRule$Shared$quantity = function (_v0) {
	var record = _v0;
	return record.Dz;
};
var $author$project$Api$Provider$CoverageRule$One$quantity = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CoverageRule$Shared$quantity(shared);
};
var $author$project$Api$Provider$CoverageRule$Shared$ruleType = function (_v0) {
	var record = _v0;
	return record.ak7;
};
var $author$project$Api$Provider$CoverageRule$One$ruleType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CoverageRule$Shared$ruleType(shared);
};
var $author$project$Api$Provider$CoverageRule$Shared$BeginningOfYear = 0;
var $author$project$Api$Provider$CoverageRule$Shared$MembershipRenewalDate = 1;
var $author$project$Api$Provider$CoverageRule$Shared$timePeriod = function (_v0) {
	var record = _v0;
	var _v1 = record.al4;
	_v1$2:
	while (true) {
		if (!_v1.$) {
			switch (_v1.a) {
				case 'beginning_of_year':
					return $elm$core$Maybe$Just(0);
				case 'membership_renewal_date':
					return $elm$core$Maybe$Just(1);
				default:
					break _v1$2;
			}
		} else {
			break _v1$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Api$Provider$CoverageRule$One$timePeriod = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CoverageRule$Shared$timePeriod(shared);
};
var $author$project$Components$CoverageRuleDescription$ruleTypeText = F2(
	function (coverageRule, shouldHighlightText) {
		var ruleType = function () {
			if (!coverageRule.$) {
				var shared = coverageRule.a;
				return $author$project$Api$Provider$CoverageRule$Shared$ruleType(shared);
			} else {
				var one = coverageRule.a;
				return $author$project$Api$Provider$CoverageRule$One$ruleType(one);
			}
		}();
		var amountInCents = $author$project$Utils$Currency$fromInt(
			A2(
				$elm$core$Maybe$withDefault,
				0,
				function (coverageRule_) {
					if (!coverageRule_.$) {
						var shared = coverageRule_.a;
						return $author$project$Api$Provider$CoverageRule$Shared$amountInCents(shared);
					} else {
						var one = coverageRule_.a;
						return $author$project$Api$Provider$CoverageRule$One$amountInCents(one);
					}
				}(coverageRule)));
		switch (ruleType) {
			case 'pass_through':
				return _List_fromArray(
					[
						$elm$html$Html$text(' will be')
					]);
			case 'included':
				var includedOption = function () {
					if (!coverageRule.$) {
						var shared = coverageRule.a;
						return $author$project$Api$Provider$CoverageRule$Shared$includedOption(shared);
					} else {
						var one = coverageRule.a;
						return $author$project$Api$Provider$CoverageRule$One$includedOption(one);
					}
				}();
				var amountText = function () {
					if (!includedOption.$) {
						if (includedOption.a === 1) {
							var _v2 = includedOption.a;
							return ' if they cost less than ' + amountInCents;
						} else {
							var _v3 = includedOption.a;
							return '';
						}
					} else {
						return '';
					}
				}();
				return _List_fromArray(
					[
						$elm$html$Html$text(' are '),
						A2($author$project$Components$CoverageRuleDescription$highlightText, 'included', shouldHighlightText),
						$elm$html$Html$text(' in the membership at no additional charge'),
						A2($author$project$Components$CoverageRuleDescription$highlightText, amountText, shouldHighlightText)
					]);
			case 'flat_amount':
				return _List_fromArray(
					[
						$elm$html$Html$text(' will be '),
						A2($author$project$Components$CoverageRuleDescription$highlightText, amountInCents, shouldHighlightText)
					]);
			case 'discounted':
				var percentage = $author$project$Formatters$Float$toPercentage(
					A2(
						$elm$core$Maybe$withDefault,
						0.0,
						function (coverageRule_) {
							if (!coverageRule_.$) {
								var shared = coverageRule_.a;
								return $author$project$Api$Provider$CoverageRule$Shared$percentage(shared);
							} else {
								var one = coverageRule_.a;
								return $author$project$Api$Provider$CoverageRule$One$percentage(one);
							}
						}(coverageRule)));
				return _List_fromArray(
					[
						$elm$html$Html$text(' will receive a '),
						A2($author$project$Components$CoverageRuleDescription$highlightText, 'discount of ', shouldHighlightText),
						A2($author$project$Components$CoverageRuleDescription$highlightText, percentage, shouldHighlightText),
						$elm$html$Html$text(' with the amount due')
					]);
			case 'surcharge':
				return _List_fromArray(
					[
						$elm$html$Html$text(' will have a surcharge of '),
						A2($author$project$Components$CoverageRuleDescription$highlightText, amountInCents, shouldHighlightText),
						$elm$html$Html$text(' added to the charge, the amount due will be')
					]);
			case 'limited_quantity':
				var quantity = A2(
					$elm$core$Maybe$withDefault,
					0,
					function (coverageRule_) {
						if (!coverageRule_.$) {
							var shared = coverageRule_.a;
							return $author$project$Api$Provider$CoverageRule$Shared$quantity(shared);
						} else {
							var one = coverageRule_.a;
							return $author$project$Api$Provider$CoverageRule$One$quantity(one);
						}
					}(coverageRule));
				var _v6 = function () {
					var _v7 = function (coverageRule_) {
						if (!coverageRule_.$) {
							var shared = coverageRule_.a;
							return $author$project$Api$Provider$CoverageRule$Shared$timePeriod(shared);
						} else {
							var one = coverageRule_.a;
							return $author$project$Api$Provider$CoverageRule$One$timePeriod(one);
						}
					}(coverageRule);
					if (!_v7.$) {
						if (!_v7.a) {
							var _v9 = _v7.a;
							return _Utils_Tuple2('', 'Jan 1st');
						} else {
							var _v10 = _v7.a;
							return _Utils_Tuple2('patient\'s ', 'membership renewal date');
						}
					} else {
						return _Utils_Tuple2('', '');
					}
				}();
				var timePeriodSubject = _v6.a;
				var timePeriod = _v6.b;
				return _List_fromArray(
					[
						$elm$html$Html$text(' are limited to a quantity of '),
						A2(
						$author$project$Components$CoverageRuleDescription$highlightText,
						A2($author$project$Formatters$String$pluralize, 'unit', quantity),
						shouldHighlightText),
						$elm$html$Html$text(' per period resetting on '),
						$elm$html$Html$text(timePeriodSubject),
						A2($author$project$Components$CoverageRuleDescription$highlightText, timePeriod, shouldHighlightText),
						$elm$html$Html$text(', additional units will be')
					]);
			default:
				return _List_Nil;
		}
	});
var $author$project$Components$CoverageRuleDescription$view = F2(
	function (coverageRule, shouldHighlightText) {
		var item = function () {
			if (!coverageRule.$) {
				var shared = coverageRule.a;
				return $author$project$Api$Provider$CoverageRule$Shared$item(shared);
			} else {
				var one = coverageRule.a;
				return $author$project$Api$Provider$CoverageRule$One$item(one);
			}
		}();
		var itemName = function () {
			if (item.$ === 1) {
				var category = item.a;
				return 'All ' + $author$project$Formatters$String$pluralOf(
					$author$project$Api$Provider$Category$Shared$name(category));
			} else {
				var chargeItem = item.a;
				return $author$project$Formatters$String$pluralOf(
					$author$project$Api$Provider$ChargeItem$Shared$name(chargeItem));
			}
		}();
		var includedOption = function () {
			if (!coverageRule.$) {
				var shared = coverageRule.a;
				return $author$project$Api$Provider$CoverageRule$Shared$includedOption(shared);
			} else {
				var one = coverageRule.a;
				return $author$project$Api$Provider$CoverageRule$One$includedOption(one);
			}
		}();
		var coveredByText = function () {
			if (!includedOption.$) {
				var includedOption_ = includedOption.a;
				if (includedOption_ === 1) {
					return _List_fromArray(
						[
							$elm$html$Html$text(', those above are paid for by the '),
							A3(
							$elm$core$Basics$apR,
							$author$project$Components$CoverageRuleDescription$coveredBy(coverageRule),
							$author$project$Components$CoverageRuleDescription$highlightText,
							shouldHighlightText)
						]);
				} else {
					return _List_Nil;
				}
			} else {
				return _List_fromArray(
					[
						$elm$html$Html$text(' paid for by the '),
						A3(
						$elm$core$Basics$apR,
						$author$project$Components$CoverageRuleDescription$coveredBy(coverageRule),
						$author$project$Components$CoverageRuleDescription$highlightText,
						shouldHighlightText)
					]);
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2($author$project$Components$CoverageRuleDescription$highlightText, itemName, shouldHighlightText),
				_Utils_ap(
					A2($author$project$Components$CoverageRuleDescription$ruleTypeText, coverageRule, shouldHighlightText),
					coveredByText)));
	});
var $author$project$Components$Plan$Form$viewCoverageRule = function (coverageRule) {
	return A2(
		$author$project$Ui$Form$Static$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Components$CoverageRuleDescription$view,
				$author$project$Components$CoverageRuleDescription$One(coverageRule),
				true)
			]));
};
var $author$project$Components$Plan$Form$viewCoveragePlanFields = F2(
	function (plan, form) {
		var originalCoveragePlan = function () {
			var _v14 = $author$project$Api$Provider$Plan$One$coveragePlan(plan);
			if (!_v14.$) {
				var coveragePlan_ = _v14.a;
				return coveragePlan_;
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var _v0 = $author$project$Utils$Form$fields(form);
		var coveragePlan = _v0.OT;
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mb2]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('Coverage')
								]))
						])),
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(4)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Select charge items that will be covered with this plan.')
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(8)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$Admin__CoveragePlans__Top,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Manage Coverage Plans')
												])),
											((!_Utils_eq(coveragePlan, $elm$core$Maybe$Nothing)) || (!_Utils_eq(originalCoveragePlan, $elm$core$Maybe$Nothing))) ? A3(
											$author$project$Ui$Button$view,
											{mm: 'Change coverage plan'},
											_List_fromArray(
												[
													$author$project$Ui$Button$onClick($author$project$Components$Plan$Form$OpenCoveragePlanModal)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Change Coverage Plan')
												])) : A3(
											$author$project$Ui$Button$view,
											{mm: 'Add coverage plan'},
											_List_fromArray(
												[
													$author$project$Ui$Button$onClick($author$project$Components$Plan$Form$OpenCoveragePlanModal),
													$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Add Coverage Plan')
												]))
										]))
								]))
						])),
					((!_Utils_eq(coveragePlan, $elm$core$Maybe$Nothing)) || (!_Utils_eq(originalCoveragePlan, $elm$core$Maybe$Nothing))) ? A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(11),
									$author$project$Ui$Grid$offset(1)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$row,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$span(3)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$label,
													_List_fromArray(
														[$author$project$Ui$Typography$hintLabel]),
													_List_fromArray(
														[
															$elm$html$Html$text('Coverage Plan')
														]))
												])),
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$span(2)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$label,
													_List_fromArray(
														[$author$project$Ui$Typography$hintLabel]),
													_List_fromArray(
														[
															$elm$html$Html$text('Included charges')
														]))
												]))
										])),
									A2(
									$author$project$Ui$ListGroup$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$ListGroup$item,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Grid$row,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Grid$column,
															_List_fromArray(
																[
																	$author$project$Ui$Grid$span(3)
																]),
															_List_fromArray(
																[
																	A2(
																	$author$project$Ui$Form$Static$view,
																	_List_Nil,
																	_List_fromArray(
																		[
																			function () {
																			var _v1 = _Utils_Tuple2(coveragePlan, originalCoveragePlan);
																			if (!_v1.a.$) {
																				var coveragePlan_ = _v1.a.a;
																				return $elm$html$Html$text(
																					$author$project$Components$Plan$Form$coveragePlanName(coveragePlan_));
																			} else {
																				if (!_v1.b.$) {
																					var _v2 = _v1.a;
																					return $elm$html$Html$text('Removed');
																				} else {
																					var _v3 = _v1.a;
																					var _v4 = _v1.b;
																					return $author$project$Utils$Html$empty;
																				}
																			}
																		}()
																		]))
																])),
															A2(
															$author$project$Ui$Grid$column,
															_List_fromArray(
																[
																	$author$project$Ui$Grid$span(7)
																]),
															function () {
																var _v5 = _Utils_Tuple2(coveragePlan, originalCoveragePlan);
																if (!_v5.a.$) {
																	var coveragePlan_ = _v5.a.a;
																	return A2(
																		$elm$core$List$map,
																		$author$project$Components$Plan$Form$viewCoverageRule,
																		$author$project$Components$Plan$Form$coveragePlanCoverageRules(coveragePlan_));
																} else {
																	if (!_v5.b.$) {
																		var _v6 = _v5.a;
																		return _List_Nil;
																	} else {
																		var _v7 = _v5.a;
																		var _v8 = _v5.b;
																		return _List_Nil;
																	}
																}
															}()),
															A2(
															$author$project$Ui$Grid$column,
															_List_fromArray(
																[
																	$author$project$Ui$Grid$span(2)
																]),
															_List_fromArray(
																[
																	function () {
																	var _v9 = _Utils_Tuple2(coveragePlan, originalCoveragePlan);
																	if (!_v9.a.$) {
																		if (!_v9.b.$) {
																			var coveragePlan_ = _v9.a.a;
																			var originalCoveragePlan_ = _v9.b.a;
																			return (!_Utils_eq(
																				$author$project$Components$Plan$Form$coveragePlanId(coveragePlan_),
																				$author$project$Api$Provider$CoveragePlan$One$id(originalCoveragePlan_))) ? A2($author$project$Components$Plan$Form$viewCoveragePlanUndoButton, originalCoveragePlan_, 'Chgange') : $author$project$Components$Plan$Form$viewCoveragePlanDeleteButton;
																		} else {
																			var _v11 = _v9.b;
																			return $author$project$Components$Plan$Form$viewCoveragePlanDeleteButton;
																		}
																	} else {
																		if (!_v9.b.$) {
																			var _v10 = _v9.a;
																			var originalCoveragePlan_ = _v9.b.a;
																			return A2($author$project$Components$Plan$Form$viewCoveragePlanUndoButton, originalCoveragePlan_, 'Delete');
																		} else {
																			var _v12 = _v9.a;
																			var _v13 = _v9.b;
																			return $author$project$Utils$Html$empty;
																		}
																	}
																}()
																]))
														]))
												]))
										]))
								]))
						])) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$AdditionalAdultDiscountRule = 7;
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$AdditionalChildDiscountRule = 4;
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$ChildrenAgeLimit = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$ChildrenAgeLimitRule = 8;
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$ChildrenOnlyDiscountRule = 5;
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$CoupleDiscountRule = 1;
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyDiscountRule = 2;
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyNumChildrenIncluded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyNumChildrenIncludedRule = 0;
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$GroupPricingType = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$NumberAdditionalChildrenAllowed = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$NumberAdditionalChildrenAllowedRule = 6;
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$SingleParentDiscountRule = 3;
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$ToggleRule = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Ui$Element$mb1 = $author$project$Ui$Element$Margin('mb-1');
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyDiscountRuleMaximumInCents = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyDiscountRuleMaximumInCentsEdit = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyDiscountRuleMaximumInCentsReset = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$viewAmountInCentsPricingRulePeriod = F6(
	function (_v0, form, editingPlan, rule, isDiscount, period) {
		var defaultPeriod = _v0.P6;
		var _v1 = function () {
			switch (period) {
				case 'month':
					return _Utils_Tuple3(rule.Xk, rule.IB, rule.gX);
				case 'quarter':
					return _Utils_Tuple3(rule._Q, rule._R, rule.ho);
				case 'semi_annual':
					return _Utils_Tuple3(rule.aaJ, rule.aaK, rule.hz);
				case 'annual':
					return _Utils_Tuple3(rule.LH, rule.LI, rule.fE);
				default:
					return _Utils_Tuple3(rule.Xk, rule.IB, rule.gX);
			}
		}();
		var periodAmountInCents = _v1.a;
		var editingPeriod = _v1.b;
		var periodEdited = _v1.c;
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			(_Utils_eq(defaultPeriod, period) || editingPeriod) ? _List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Formatters$String$humanize(period)),
							isDiscount ? $elm$html$Html$text(' discount') : $elm$html$Html$text(' rate')
						])),
					$author$project$Ui$Form$CurrencyInput$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$CurrencyInput$value(periodAmountInCents),
							$author$project$Ui$Form$CurrencyInput$onInput(
							A2(
								$elm$core$Basics$composeL,
								$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated,
								rule.Yh(period))),
							$author$project$Ui$Form$CurrencyInput$invalid(
							A2(
								$author$project$Utils$Form$hasValidationErrors,
								rule.I9(period),
								form))
						])),
					$author$project$Utils$FormErrors$view(
					A2(
						$author$project$Utils$Form$validationErrors,
						rule.I9(period),
						form))
				]) : _List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween]),
					(!editingPlan) ? _List_Nil : _List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Formatters$String$humanize(period)),
									$author$project$Utils$Html$noBreakSpace,
									$elm$html$Html$text(
									$author$project$Currency$format(
										A2($elm$core$Maybe$withDefault, $author$project$Currency$zero, periodAmountInCents))),
									isDiscount ? $elm$html$Html$text(' off') : $author$project$Utils$Html$empty
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									periodEdited ? A3(
									$author$project$Ui$Button$view,
									{mm: 'Reset period amount'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick(
											$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated(
												rule.$P(period)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Reset')
										])) : $author$project$Utils$Html$empty,
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Edit period amount'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick(
											$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated(
												rule.Q2(period)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit')
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$viewAmountInCentsPricingRule = F6(
	function (sharedFields, form, _v0, periods, rule, isDiscount) {
		var editingPlan = _v0.Q5;
		return A2(
			$elm$core$List$map,
			A5($author$project$Components$Plan$Form$FamilyMembershipPricingFields$viewAmountInCentsPricingRulePeriod, sharedFields, form, editingPlan, rule, isDiscount),
			periods);
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$viewFamilyDiscountRule = F4(
	function (sharedFields, maybePlan, form, familyDiscountRule) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (familyDiscountRule_) {
					var periodCodes = A2(
						$elm$core$Maybe$withDefault,
						$author$project$Api$Provider$Plan$Meta$defaultAllPeriodCodes,
						A2(
							$elm$core$Maybe$map,
							$author$project$Api$Provider$Plan$Meta$allowedPeriodCodes,
							A2($elm$core$Maybe$map, $author$project$Api$Provider$Plan$One$meta, sharedFields.Jb)));
					return A6(
						$author$project$Components$Plan$Form$FamilyMembershipPricingFields$viewAmountInCentsPricingRule,
						sharedFields,
						form,
						{
							Q5: !_Utils_eq(maybePlan, $elm$core$Maybe$Nothing)
						},
						periodCodes,
						{
							LH: familyDiscountRule_.LL,
							fE: familyDiscountRule_.LM,
							LI: familyDiscountRule_.xm,
							Q2: $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyDiscountRuleMaximumInCentsEdit(familyDiscountRule_.amg),
							Xk: familyDiscountRule_.Xn,
							gX: familyDiscountRule_.Xo,
							IB: familyDiscountRule_.Bl,
							Yh: $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyDiscountRuleMaximumInCents(familyDiscountRule_.amg),
							I9: $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyDiscountRuleMaximumInCentsValidation(familyDiscountRule_.amg),
							_Q: familyDiscountRule_._U,
							ho: familyDiscountRule_._V,
							_R: familyDiscountRule_.DD,
							$P: $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyDiscountRuleMaximumInCentsReset(familyDiscountRule_.amg),
							aaJ: familyDiscountRule_.aaN,
							hz: familyDiscountRule_.aaO,
							aaK: familyDiscountRule_.Eu
						},
						false);
				},
				familyDiscountRule));
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$viewFamilyMembershipPricingFields = F3(
	function (sharedFields, maybePlan, _v0) {
		var form = _v0;
		var _v1 = $author$project$Utils$Form$fields(form);
		var rules = _v1.aak;
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					function () {
					if (!maybePlan.$) {
						return A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$mb1]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Switch to group discounts'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick(
											$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated(
												$author$project$Components$Plan$Form$FamilyMembershipPricingFields$GroupPricingType('group')))
										]),
									_List_fromArray(
										[
											$author$project$Ui$Icon$transfer(_List_Nil),
											$elm$html$Html$text(' Switch to Group Discounts')
										]))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$offsetLabel,
							$author$project$Ui$Form$Group$labelSpanSm(5),
							$author$project$Ui$Form$Group$inputSpanSm(6),
							$author$project$Ui$Form$Group$label('Couple Rate'),
							$author$project$Ui$Form$Group$labelClass(''),
							$author$project$Ui$Form$Group$labelHelp(
							$elm$html$Html$text('Up to 2 adults of any age, no children')),
							$author$project$Ui$Form$Group$required(rules.yS.Ro)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$row,
							_List_fromArray(
								[$author$project$Ui$Grid$rowItemsCenter]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanSm(4),
											$author$project$Ui$Grid$justifyLeft
										]),
									_List_fromArray(
										[
											$author$project$Ui$ToggleSwitch$view(
											_List_fromArray(
												[
													$author$project$Ui$ToggleSwitch$on(rules.yS.Ro),
													$author$project$Ui$ToggleSwitch$onChange(
													A2(
														$elm$core$Basics$composeL,
														$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated,
														$author$project$Components$Plan$Form$FamilyMembershipPricingFields$ToggleRule(1)))
												]))
										])),
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanSm(8)
										]),
									function () {
										if (rules.yS.Ro) {
											var _v3 = $author$project$Utils$Form$fields(form);
											var coupleDiscountRule = _v3.yS;
											return A4($author$project$Components$Plan$Form$FamilyMembershipPricingFields$viewFamilyDiscountRule, sharedFields, maybePlan, form, coupleDiscountRule);
										} else {
											return _List_Nil;
										}
									}())
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$offsetLabel,
							$author$project$Ui$Form$Group$labelSpanSm(5),
							$author$project$Ui$Form$Group$inputSpanSm(6),
							$author$project$Ui$Form$Group$label('Family Rate'),
							$author$project$Ui$Form$Group$labelClass(''),
							$author$project$Ui$Form$Group$labelHelp(
							$elm$html$Html$text('Up to 2 adults of any age, plus children')),
							$author$project$Ui$Form$Group$required(rules.zB.Ro)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$row,
							_List_fromArray(
								[$author$project$Ui$Grid$rowItemsCenter]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanSm(4),
											$author$project$Ui$Grid$justifyLeft
										]),
									_List_fromArray(
										[
											$author$project$Ui$ToggleSwitch$view(
											_List_fromArray(
												[
													$author$project$Ui$ToggleSwitch$on(rules.zB.Ro),
													$author$project$Ui$ToggleSwitch$onChange(
													A2(
														$elm$core$Basics$composeL,
														$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated,
														$author$project$Components$Plan$Form$FamilyMembershipPricingFields$ToggleRule(2)))
												]))
										])),
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanSm(8)
										]),
									function () {
										if (rules.zB.Ro) {
											var _v4 = $author$project$Utils$Form$fields(form);
											var familyDiscountRule = _v4.zB;
											return A4($author$project$Components$Plan$Form$FamilyMembershipPricingFields$viewFamilyDiscountRule, sharedFields, maybePlan, form, familyDiscountRule);
										} else {
											return _List_Nil;
										}
									}())
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$offsetLabel,
							$author$project$Ui$Form$Group$labelSpanSm(5),
							$author$project$Ui$Form$Group$inputSpanSm(6),
							$author$project$Ui$Form$Group$label('Single Parent Rate'),
							$author$project$Ui$Form$Group$labelClass(''),
							$author$project$Ui$Form$Group$labelHelp(
							$elm$html$Html$text('One adult of any age, plus children')),
							$author$project$Ui$Form$Group$required(rules.EG.Ro)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$row,
							_List_fromArray(
								[$author$project$Ui$Grid$rowItemsCenter]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanSm(4),
											$author$project$Ui$Grid$justifyLeft
										]),
									_List_fromArray(
										[
											$author$project$Ui$ToggleSwitch$view(
											_List_fromArray(
												[
													$author$project$Ui$ToggleSwitch$on(rules.EG.Ro),
													$author$project$Ui$ToggleSwitch$onChange(
													A2(
														$elm$core$Basics$composeL,
														$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated,
														$author$project$Components$Plan$Form$FamilyMembershipPricingFields$ToggleRule(3)))
												]))
										])),
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanSm(8)
										]),
									function () {
										if (rules.EG.Ro) {
											var _v5 = $author$project$Utils$Form$fields(form);
											var singleParentDiscountRule = _v5.EG;
											return A4($author$project$Components$Plan$Form$FamilyMembershipPricingFields$viewFamilyDiscountRule, sharedFields, maybePlan, form, singleParentDiscountRule);
										} else {
											return _List_Nil;
										}
									}())
								]))
						])),
					function () {
					if (rules.zB.Ro || rules.EG.Ro) {
						var _v6 = $author$project$Utils$Form$fields(form);
						var familyNumChildrenIncluded = _v6.zC;
						var childrenAgeLimit = _v6.x2;
						return A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$offsetLabel,
											$author$project$Ui$Form$Group$labelSpanSm(5),
											$author$project$Ui$Form$Group$inputSpanSm(6),
											$author$project$Ui$Form$Group$label('Limit Children in Family Plans'),
											$author$project$Ui$Form$Group$labelClass(''),
											$author$project$Ui$Form$Group$labelHelp(
											$elm$html$Html$text('Turn off for no limit')),
											$author$project$Ui$Form$Group$required(rules.zC.Ro)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Grid$row,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Grid$column,
													_List_fromArray(
														[
															$author$project$Ui$Grid$spanSm(4)
														]),
													_List_fromArray(
														[
															$author$project$Ui$ToggleSwitch$view(
															_List_fromArray(
																[
																	$author$project$Ui$ToggleSwitch$on(rules.zC.Ro),
																	$author$project$Ui$ToggleSwitch$onChange(
																	A2(
																		$elm$core$Basics$composeL,
																		$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated,
																		$author$project$Components$Plan$Form$FamilyMembershipPricingFields$ToggleRule(0)))
																]))
														])),
													A2(
													$author$project$Ui$Grid$column,
													_List_fromArray(
														[
															$author$project$Ui$Grid$spanSm(8)
														]),
													rules.zC.Ro ? _List_fromArray(
														[
															$author$project$Ui$Form$Input$group(
															_List_fromArray(
																[
																	$author$project$Ui$Form$Input$addon(
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Up to and including')
																		])),
																	$author$project$Ui$Form$Input$view(
																	_List_fromArray(
																		[
																			$author$project$Ui$Form$Input$value(
																			A2(
																				$elm$core$Maybe$withDefault,
																				'',
																				A2($elm$core$Maybe$map, $elm$core$String$fromInt, familyNumChildrenIncluded))),
																			$author$project$Ui$Form$Input$onInput(
																			A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyNumChildrenIncluded)),
																			$author$project$Ui$Form$Input$invalid(
																			A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyNumChildrenIncludedValidation, form))
																		]))
																])),
															$author$project$Utils$FormErrors$view(
															A2($author$project$Utils$Form$validationErrors, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyNumChildrenIncludedValidation, form))
														]) : _List_Nil)
												]))
										])),
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$offsetLabel,
											$author$project$Ui$Form$Group$labelSpanSm(5),
											$author$project$Ui$Form$Group$inputSpanSm(6),
											$author$project$Ui$Form$Group$label('Additional Child Rate'),
											$author$project$Ui$Form$Group$labelClass(''),
											$author$project$Ui$Form$Group$labelHelp(
											$elm$html$Html$text('Turn off to use the individual rate')),
											$author$project$Ui$Form$Group$required(rules.vC.Ro)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Grid$row,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Grid$column,
													_List_fromArray(
														[
															$author$project$Ui$Grid$spanSm(4)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Element$view,
															_List_fromArray(
																[$author$project$Ui$Element$textSm]),
															_List_fromArray(
																[$author$project$Utils$Html$noBreakSpace])),
															$author$project$Ui$ToggleSwitch$view(
															_List_fromArray(
																[
																	$author$project$Ui$ToggleSwitch$on(rules.vC.Ro),
																	$author$project$Ui$ToggleSwitch$onChange(
																	A2(
																		$elm$core$Basics$composeL,
																		$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated,
																		$author$project$Components$Plan$Form$FamilyMembershipPricingFields$ToggleRule(4)))
																]))
														])),
													A2(
													$author$project$Ui$Grid$column,
													_List_fromArray(
														[
															$author$project$Ui$Grid$spanSm(8)
														]),
													function () {
														if (rules.vC.Ro) {
															var _v7 = $author$project$Utils$Form$fields(form);
															var additionalChildDiscountRule = _v7.vC;
															return A4($author$project$Components$Plan$Form$FamilyMembershipPricingFields$viewFamilyDiscountRule, sharedFields, maybePlan, form, additionalChildDiscountRule);
														} else {
															return _List_fromArray(
																[$author$project$Utils$Html$empty]);
														}
													}())
												]))
										])),
									rules.zC.Ro ? A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$offsetLabel,
											$author$project$Ui$Form$Group$labelSpanSm(5),
											$author$project$Ui$Form$Group$inputSpanSm(6),
											$author$project$Ui$Form$Group$label('Number of Additional Children Allowed'),
											$author$project$Ui$Form$Group$labelClass(''),
											$author$project$Ui$Form$Group$labelHelp(
											$elm$html$Html$text('Turn off for no limit')),
											$author$project$Ui$Form$Group$required(rules.BR.Ro)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Grid$row,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Grid$column,
													_List_fromArray(
														[
															$author$project$Ui$Grid$spanSm(4)
														]),
													_List_fromArray(
														[
															$author$project$Ui$ToggleSwitch$view(
															_List_fromArray(
																[
																	$author$project$Ui$ToggleSwitch$on(rules.BR.Ro),
																	$author$project$Ui$ToggleSwitch$onChange(
																	A2(
																		$elm$core$Basics$composeL,
																		$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated,
																		$author$project$Components$Plan$Form$FamilyMembershipPricingFields$ToggleRule(6)))
																]))
														])),
													A2(
													$author$project$Ui$Grid$column,
													_List_fromArray(
														[
															$author$project$Ui$Grid$spanSm(8)
														]),
													function () {
														if (rules.BR.Ro) {
															var _v8 = $author$project$Utils$Form$fields(form);
															var numberAdditionalChildrenAllowed = _v8.BR;
															return _List_fromArray(
																[
																	$author$project$Ui$Form$Input$group(
																	_List_fromArray(
																		[
																			$author$project$Ui$Form$Input$addon(
																			_List_fromArray(
																				[
																					$elm$html$Html$text('Up to and including')
																				])),
																			$author$project$Ui$Form$Input$view(
																			_List_fromArray(
																				[
																					$author$project$Ui$Form$Input$value(
																					A2(
																						$elm$core$Maybe$withDefault,
																						'',
																						A2($elm$core$Maybe$map, $elm$core$String$fromInt, numberAdditionalChildrenAllowed))),
																					$author$project$Ui$Form$Input$onInput(
																					A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$NumberAdditionalChildrenAllowed)),
																					$author$project$Ui$Form$Input$invalid(
																					A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$NumberAdditionalChildrenAllowedValidation, form))
																				]))
																		])),
																	$author$project$Utils$FormErrors$view(
																	A2($author$project$Utils$Form$validationErrors, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$NumberAdditionalChildrenAllowedValidation, form))
																]);
														} else {
															return _List_Nil;
														}
													}())
												]))
										])) : $author$project$Utils$Html$empty,
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$offsetLabel,
											$author$project$Ui$Form$Group$labelSpanSm(5),
											$author$project$Ui$Form$Group$inputSpanSm(6),
											$author$project$Ui$Form$Group$label('Additional Adult Rate'),
											$author$project$Ui$Form$Group$labelClass(''),
											$author$project$Ui$Form$Group$labelHelp(
											$elm$html$Html$text('Turn off to use the individual rate')),
											$author$project$Ui$Form$Group$required(rules.vB.Ro)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Grid$row,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Grid$column,
													_List_fromArray(
														[
															$author$project$Ui$Grid$spanSm(4)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Element$view,
															_List_fromArray(
																[$author$project$Ui$Element$textSm]),
															_List_fromArray(
																[$author$project$Utils$Html$noBreakSpace])),
															$author$project$Ui$ToggleSwitch$view(
															_List_fromArray(
																[
																	$author$project$Ui$ToggleSwitch$on(rules.vB.Ro),
																	$author$project$Ui$ToggleSwitch$onChange(
																	A2(
																		$elm$core$Basics$composeL,
																		$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated,
																		$author$project$Components$Plan$Form$FamilyMembershipPricingFields$ToggleRule(7)))
																]))
														])),
													A2(
													$author$project$Ui$Grid$column,
													_List_fromArray(
														[
															$author$project$Ui$Grid$spanSm(8)
														]),
													function () {
														if (rules.vB.Ro) {
															var _v9 = $author$project$Utils$Form$fields(form);
															var additionalAdultDiscountRule = _v9.vB;
															return A4($author$project$Components$Plan$Form$FamilyMembershipPricingFields$viewFamilyDiscountRule, sharedFields, maybePlan, form, additionalAdultDiscountRule);
														} else {
															return _List_Nil;
														}
													}())
												]))
										])),
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$offsetLabel,
											$author$project$Ui$Form$Group$labelSpanSm(5),
											$author$project$Ui$Form$Group$inputSpanSm(6),
											$author$project$Ui$Form$Group$label('Maximum Age of Child'),
											$author$project$Ui$Form$Group$labelClass(''),
											$author$project$Ui$Form$Group$labelHelp(
											$elm$html$Html$text('Turn off for no limit')),
											$author$project$Ui$Form$Group$required(rules.x2.Ro)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Grid$row,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Grid$column,
													_List_fromArray(
														[
															$author$project$Ui$Grid$spanSm(4)
														]),
													_List_fromArray(
														[
															$author$project$Ui$ToggleSwitch$view(
															_List_fromArray(
																[
																	$author$project$Ui$ToggleSwitch$on(rules.x2.Ro),
																	$author$project$Ui$ToggleSwitch$onChange(
																	A2(
																		$elm$core$Basics$composeL,
																		$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated,
																		$author$project$Components$Plan$Form$FamilyMembershipPricingFields$ToggleRule(8)))
																]))
														])),
													A2(
													$author$project$Ui$Grid$column,
													_List_fromArray(
														[
															$author$project$Ui$Grid$spanSm(8)
														]),
													rules.x2.Ro ? _List_fromArray(
														[
															$author$project$Ui$Form$Input$group(
															_List_fromArray(
																[
																	$author$project$Ui$Form$Input$addon(
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Up to and including')
																		])),
																	$author$project$Ui$Form$Input$view(
																	_List_fromArray(
																		[
																			$author$project$Ui$Form$Input$value(
																			A2(
																				$elm$core$Maybe$withDefault,
																				'',
																				A2($elm$core$Maybe$map, $elm$core$String$fromInt, childrenAgeLimit))),
																			$author$project$Ui$Form$Input$onInput(
																			A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$ChildrenAgeLimit)),
																			$author$project$Ui$Form$Input$invalid(
																			A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$ChildrenAgeLimitValidation, form))
																		]))
																])),
															$author$project$Utils$FormErrors$view(
															A2($author$project$Utils$Form$validationErrors, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$ChildrenAgeLimitValidation, form))
														]) : _List_Nil)
												]))
										])),
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$offsetLabel,
											$author$project$Ui$Form$Group$labelSpanSm(5),
											$author$project$Ui$Form$Group$inputSpanSm(6),
											$author$project$Ui$Form$Group$label('Children Only Rate'),
											$author$project$Ui$Form$Group$labelClass(''),
											$author$project$Ui$Form$Group$labelHelp(
											$elm$html$Html$text('Children enrolling independently without an adult')),
											$author$project$Ui$Form$Group$required(rules.x3.Ro)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Grid$row,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Grid$column,
													_List_fromArray(
														[
															$author$project$Ui$Grid$spanSm(4)
														]),
													_List_fromArray(
														[
															$author$project$Ui$ToggleSwitch$view(
															_List_fromArray(
																[
																	$author$project$Ui$ToggleSwitch$on(rules.x3.Ro),
																	$author$project$Ui$ToggleSwitch$onChange(
																	A2(
																		$elm$core$Basics$composeL,
																		$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated,
																		$author$project$Components$Plan$Form$FamilyMembershipPricingFields$ToggleRule(5)))
																]))
														])),
													A2(
													$author$project$Ui$Grid$column,
													_List_fromArray(
														[
															$author$project$Ui$Grid$spanSm(8)
														]),
													function () {
														if (rules.x3.Ro) {
															var _v10 = $author$project$Utils$Form$fields(form);
															var childrenOnlyDiscountRule = _v10.x3;
															return A4($author$project$Components$Plan$Form$FamilyMembershipPricingFields$viewFamilyDiscountRule, sharedFields, maybePlan, form, childrenOnlyDiscountRule);
														} else {
															return _List_fromArray(
																[$author$project$Utils$Html$empty]);
														}
													}())
												]))
										]))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]));
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$view = F3(
	function (sharedFields, maybePlan, _v0) {
		var form = _v0;
		return A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$viewFamilyMembershipPricingFields, sharedFields, maybePlan, form);
	});
var $author$project$Components$Plan$Form$DiscountsEnabled = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Plan$Form$viewFamilyDiscountsToggle = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var discountsEnabled = _v0.zi;
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$mb2]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
				_List_fromArray(
					[
						$author$project$Ui$Typography$headingSm(
						_List_fromArray(
							[
								$elm$html$Html$text('Do you offer discounts to family members who enroll together?')
							])),
						A2(
						$elm$html$Html$map,
						$elm$core$Basics$never,
						$author$project$Ui$SupportDocumentLink$view('https://support.hint.com/account-configuration/configuring-your-membership-rates-and-billing-options'))
					])),
				$author$project$Ui$ToggleSwitch$view(
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$on(discountsEnabled),
						$author$project$Ui$ToggleSwitch$onChange(
						A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$DiscountsEnabled))
					]))
			]));
};
var $author$project$Components$Plan$Form$viewFamilyMembershipPricing = F3(
	function (sharedFields, plan, form) {
		var _v0 = $author$project$Utils$Form$fields(form);
		var familyMembershipPricingForm = _v0.dm;
		var discountsEnabled = _v0.zi;
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Components$Plan$Form$viewFamilyDiscountsToggle(form),
					discountsEnabled ? A2(
					$elm$html$Html$map,
					$author$project$Components$Plan$Form$FamilyMembershipPricingFieldsUpdated,
					A3(
						$author$project$Components$Plan$Form$FamilyMembershipPricingFields$view,
						sharedFields,
						$elm$core$Maybe$Just(plan),
						familyMembershipPricingForm)) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$Plan$Form$AppliesGroupDiscountInTiers = function (a) {
	return {$: 29, a: a};
};
var $author$project$Components$Plan$Form$GroupDiscountRuleAdd = {$: 31};
var $author$project$Components$Plan$Form$ToggleGroupDiscountRulesCalculatedBy = function (a) {
	return {$: 30, a: a};
};
var $author$project$Components$Plan$Form$GroupDiscountRuleAmountOffInCents = F3(
	function (a, b, c) {
		return {$: 35, a: a, b: b, c: c};
	});
var $author$project$Components$Plan$Form$GroupDiscountRuleAmountOffInCentsEdit = F2(
	function (a, b) {
		return {$: 36, a: a, b: b};
	});
var $author$project$Components$Plan$Form$GroupDiscountRuleAmountOffInCentsReset = F2(
	function (a, b) {
		return {$: 37, a: a, b: b};
	});
var $author$project$Components$Plan$Form$GroupDiscountRuleFromSize = F2(
	function (a, b) {
		return {$: 33, a: a, b: b};
	});
var $author$project$Components$Plan$Form$GroupDiscountRulePercentOff = F3(
	function (a, b, c) {
		return {$: 38, a: a, b: b, c: c};
	});
var $author$project$Components$Plan$Form$GroupDiscountRulePercentOffEdit = F2(
	function (a, b) {
		return {$: 39, a: a, b: b};
	});
var $author$project$Components$Plan$Form$GroupDiscountRulePercentOffReset = F2(
	function (a, b) {
		return {$: 40, a: a, b: b};
	});
var $author$project$Components$Plan$Form$GroupDiscountRuleRemove = function (a) {
	return {$: 32, a: a};
};
var $author$project$Components$Plan$Form$GroupDiscountRuleToSize = F2(
	function (a, b) {
		return {$: 34, a: a, b: b};
	});
var $author$project$Components$Plan$Form$groupDiscountRuleSizeOptions = function (start) {
	return A2(
		$elm$core$List$map,
		function (size) {
			return A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(
					$elm$core$String$fromInt(size)),
				A2($author$project$Formatters$String$pluralize, 'Member', size));
		},
		A2($elm$core$List$range, start, 9));
};
var $author$project$Components$Plan$Form$viewAmountInCentsPricingRulePeriod = F4(
	function (form, rule, isDiscount, period) {
		var _v0 = function () {
			switch (period) {
				case 'month':
					return _Utils_Tuple3(rule.Xk, rule.IB, rule.gX);
				case 'quarter':
					return _Utils_Tuple3(rule._Q, rule._R, rule.ho);
				case 'semi_annual':
					return _Utils_Tuple3(rule.aaJ, rule.aaK, rule.hz);
				case 'annual':
					return _Utils_Tuple3(rule.LH, rule.LI, rule.fE);
				default:
					return _Utils_Tuple3(rule.Xk, rule.IB, rule.gX);
			}
		}();
		var periodAmountInCents = _v0.a;
		var editingPeriod = _v0.b;
		var periodEdited = _v0.c;
		var _v2 = $author$project$Utils$Form$fields(form);
		var basicPlan = _v2.ab;
		var _v3 = $author$project$Components$Plan$BasicForm$formFields(basicPlan);
		var defaultPeriod = _v3.P6;
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			(_Utils_eq(defaultPeriod, period) || editingPeriod) ? _List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Formatters$String$humanize(period)),
							isDiscount ? $elm$html$Html$text(' discount') : $elm$html$Html$text(' rate')
						])),
					$author$project$Ui$Form$CurrencyInput$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$CurrencyInput$value(periodAmountInCents),
							$author$project$Ui$Form$CurrencyInput$onInput(
							A2(
								$elm$core$Basics$composeL,
								$author$project$Components$Plan$Form$FormUpdated,
								rule.Yh(period))),
							$author$project$Ui$Form$CurrencyInput$invalid(
							A2(
								$author$project$Utils$Form$hasValidationErrors,
								rule.I9(period),
								form))
						])),
					$author$project$Utils$FormErrors$view(
					A2(
						$author$project$Utils$Form$validationErrors,
						rule.I9(period),
						form))
				]) : _List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Formatters$String$humanize(period)),
									$elm$html$Html$text(
									$author$project$Currency$format(
										A2($elm$core$Maybe$withDefault, $author$project$Currency$zero, periodAmountInCents))),
									isDiscount ? $elm$html$Html$text('off') : $author$project$Utils$Html$empty
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$justifyRight]),
							_List_fromArray(
								[
									periodEdited ? A3(
									$author$project$Ui$Button$view,
									{mm: 'Reset period amount'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick(
											$author$project$Components$Plan$Form$FormUpdated(
												rule.$P(period)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Reset')
										])) : $author$project$Utils$Html$empty,
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Edit period amount'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick(
											$author$project$Components$Plan$Form$FormUpdated(
												rule.Q2(period)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit')
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Plan$Form$viewAmountInCentsPricingRule = F4(
	function (form, periods, rule, isDiscount) {
		return A2(
			$elm$core$List$map,
			A3($author$project$Components$Plan$Form$viewAmountInCentsPricingRulePeriod, form, rule, isDiscount),
			periods);
	});
var $author$project$Percentage$format = function (percentage) {
	var _v0 = $author$project$Percentage$toFloat(percentage);
	if (!_v0.$) {
		var _float = _v0.a;
		return $elm$core$String$fromFloat(_float) + '%';
	} else {
		return 'N/A';
	}
};
var $author$project$Components$Plan$Form$viewPercentOffPricingRulePeriod = F4(
	function (form, rule, isDiscount, period) {
		var _v0 = function () {
			switch (period) {
				case 'month':
					return _Utils_Tuple3(rule.Xs, rule.oH, rule.Xt);
				case 'quarter':
					return _Utils_Tuple3(rule._Y, rule.t7, rule._Z);
				case 'semi_annual':
					return _Utils_Tuple3(rule.aaR, rule.uv, rule.aaS);
				case 'annual':
					return _Utils_Tuple3(rule.LP, rule.rj, rule.LQ);
				default:
					return _Utils_Tuple3(rule.Xs, rule.oH, rule.Xt);
			}
		}();
		var periodPercentOff = _v0.a;
		var editingPeriod = _v0.b;
		var periodEdited = _v0.c;
		var _v2 = $author$project$Utils$Form$fields(form);
		var basicPlan = _v2.ab;
		var _v3 = $author$project$Components$Plan$BasicForm$formFields(basicPlan);
		var defaultPeriod = _v3.P6;
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			(_Utils_eq(defaultPeriod, period) || editingPeriod) ? _List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Formatters$String$humanize(period)),
							isDiscount ? $elm$html$Html$text(' discount') : $elm$html$Html$text(' rate')
						])),
					$author$project$Ui$Form$PercentageInput$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$PercentageInput$value(periodPercentOff),
							$author$project$Ui$Form$PercentageInput$onInput(
							A2(
								$elm$core$Basics$composeL,
								$author$project$Components$Plan$Form$FormUpdated,
								rule.Yi(period))),
							$author$project$Ui$Form$PercentageInput$invalid(
							A2(
								$author$project$Utils$Form$hasValidationErrors,
								rule.Ja(period),
								form))
						])),
					$author$project$Utils$FormErrors$view(
					A2(
						$author$project$Utils$Form$validationErrors,
						rule.Ja(period),
						form))
				]) : _List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$gap2]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Formatters$String$humanize(period)),
									$elm$html$Html$text(
									$author$project$Percentage$format(
										A2($elm$core$Maybe$withDefault, $author$project$Percentage$zero, periodPercentOff))),
									isDiscount ? $elm$html$Html$text('off') : $author$project$Utils$Html$empty
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									periodEdited ? A3(
									$author$project$Ui$Button$view,
									{mm: 'Reset period percent off'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick(
											$author$project$Components$Plan$Form$FormUpdated(
												rule.$Q(period)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Reset')
										])) : $author$project$Utils$Html$empty,
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Edit period percent off'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick(
											$author$project$Components$Plan$Form$FormUpdated(
												rule.Q3(period)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit')
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Plan$Form$viewPercentOffPricingRule = F4(
	function (form, periods, rule, isDiscount) {
		return A2(
			$elm$core$List$map,
			A3($author$project$Components$Plan$Form$viewPercentOffPricingRulePeriod, form, rule, isDiscount),
			periods);
	});
var $author$project$Components$Plan$Form$viewGroupDiscountRule = F4(
	function (plan, form, index, groupDiscountRule) {
		var meta = $author$project$Api$Provider$Plan$One$meta(plan);
		var isFirst = !index;
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					isFirst ? _List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textSm]),
							_List_Nil),
							A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(
									$elm$core$Maybe$Just(
										$elm$core$String$fromInt(groupDiscountRule.SM))),
									$author$project$Ui$Form$Select$onChange(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Components$Plan$Form$FormUpdated,
										$author$project$Components$Plan$Form$GroupDiscountRuleFromSize(index)))
								]),
							$author$project$Components$Plan$Form$groupDiscountRuleSizeOptions(0))
						]) : _List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textSm]),
							_List_Nil),
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(groupDiscountRule.SM))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					(!_Utils_eq(groupDiscountRule.add, $elm$core$Maybe$Nothing)) ? _List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textSm]),
							_List_Nil),
							A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(
									A2($elm$core$Maybe$map, $elm$core$String$fromInt, groupDiscountRule.add)),
									$author$project$Ui$Form$Select$onChange(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Components$Plan$Form$FormUpdated,
										$author$project$Components$Plan$Form$GroupDiscountRuleToSize(index)))
								]),
							$author$project$Components$Plan$Form$groupDiscountRuleSizeOptions(groupDiscountRule.SM))
						]) : _List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textSm]),
							_List_Nil),
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('All Members')
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textSm]),
							_List_Nil),
							(!isFirst) ? A3(
							$author$project$Ui$Button$view,
							{mm: 'Remove group disount rule'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick(
									$author$project$Components$Plan$Form$FormUpdated(
										$author$project$Components$Plan$Form$GroupDiscountRuleRemove(index))),
									$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Remove')
								])) : $author$project$Utils$Html$empty
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					function () {
						var _v0 = groupDiscountRule.M2;
						switch (_v0) {
							case 'amount_off_in_cents':
								return A4(
									$author$project$Components$Plan$Form$viewAmountInCentsPricingRule,
									form,
									$author$project$Api$Provider$Plan$Meta$allowedPeriodCodes(meta),
									{
										LH: groupDiscountRule.LJ,
										fE: groupDiscountRule.LK,
										LI: groupDiscountRule.Gs,
										Q2: $author$project$Components$Plan$Form$GroupDiscountRuleAmountOffInCentsEdit(index),
										Xk: groupDiscountRule.Xl,
										gX: groupDiscountRule.Xm,
										IB: groupDiscountRule.IC,
										Yh: $author$project$Components$Plan$Form$GroupDiscountRuleAmountOffInCents(index),
										I9: $author$project$Components$Plan$Form$GroupDiscountRuleAmountOffInCentsValidation(index),
										_Q: groupDiscountRule._S,
										ho: groupDiscountRule._T,
										_R: groupDiscountRule.Jq,
										$P: $author$project$Components$Plan$Form$GroupDiscountRuleAmountOffInCentsReset(index),
										aaJ: groupDiscountRule.aaL,
										hz: groupDiscountRule.aaM,
										aaK: groupDiscountRule.JG
									},
									true);
							case 'percent_off':
								return A4(
									$author$project$Components$Plan$Form$viewPercentOffPricingRule,
									form,
									$author$project$Api$Provider$Plan$Meta$allowedPeriodCodes(meta),
									{
										LP: groupDiscountRule.LP,
										LQ: groupDiscountRule.LQ,
										rj: groupDiscountRule.rj,
										Q3: $author$project$Components$Plan$Form$GroupDiscountRulePercentOffEdit(index),
										Xs: groupDiscountRule.Xs,
										Xt: groupDiscountRule.Xt,
										oH: groupDiscountRule.oH,
										Yi: $author$project$Components$Plan$Form$GroupDiscountRulePercentOff(index),
										Ja: $author$project$Components$Plan$Form$GroupDiscountRulePercentOffValidation(index),
										_Y: groupDiscountRule._Y,
										_Z: groupDiscountRule._Z,
										t7: groupDiscountRule.t7,
										$Q: $author$project$Components$Plan$Form$GroupDiscountRulePercentOffReset(index),
										aaR: groupDiscountRule.aaR,
										aaS: groupDiscountRule.aaS,
										uv: groupDiscountRule.uv
									},
									true);
							default:
								return _List_Nil;
						}
					}())
				]));
	});
var $author$project$Components$Plan$Form$viewGroupMembershipPricingFields = F2(
	function (plan, form) {
		var _v0 = $author$project$Utils$Form$fields(form);
		var appliesGroupDiscountInTiers = _v0.LW;
		var groupDiscountRules = _v0.SZ;
		var discountsEnabled = _v0.zi;
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Components$Plan$Form$viewFamilyDiscountsToggle(form),
					function () {
					if (discountsEnabled) {
						var groupDiscountRulesCalculatedBy = A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.M2;
							},
							$elm$core$List$head(groupDiscountRules));
						var allowNewGroupRule = A2(
							$elm$core$Maybe$withDefault,
							true,
							A2(
								$elm$core$Maybe$map,
								function (lastFromSize) {
									return _Utils_cmp(lastFromSize, $author$project$Components$Plan$Form$maxGroupFromSize) < 0;
								},
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.SM;
									},
									$elm_community$list_extra$List$Extra$last(groupDiscountRules))));
						return A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$mb1]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{mm: 'Switch to family rates'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick(
													$author$project$Components$Plan$Form$FormUpdated(
														$author$project$Components$Plan$Form$GroupPricingType('family')))
												]),
											_List_fromArray(
												[
													$author$project$Ui$Icon$transfer(_List_Nil),
													$elm$html$Html$text(' Switch to Family Rates')
												]))
										])),
									A2(
									$author$project$Ui$Grid$row,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$offset(1)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Form$Radio$view,
															_List_fromArray(
																[
																	$author$project$Ui$Form$Radio$value(appliesGroupDiscountInTiers),
																	$author$project$Ui$Form$Radio$onCheck(
																	A2(
																		$elm$core$Basics$composeL,
																		$author$project$Components$Plan$Form$FormUpdated,
																		$elm$core$Basics$always(
																			$author$project$Components$Plan$Form$AppliesGroupDiscountInTiers(true))))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Apply Discounts in Tiers.'),
																	A2(
																	$author$project$Ui$Element$view,
																	_List_fromArray(
																		[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted, $author$project$Ui$Element$fontBold]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Per member discount will apply to members depending on which range they are in')
																		]))
																]))
														])),
													A2(
													$author$project$Ui$Element$view,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Form$Radio$view,
															_List_fromArray(
																[
																	$author$project$Ui$Form$Radio$value(!appliesGroupDiscountInTiers),
																	$author$project$Ui$Form$Radio$onCheck(
																	A2(
																		$elm$core$Basics$composeL,
																		$author$project$Components$Plan$Form$FormUpdated,
																		$elm$core$Basics$always(
																			$author$project$Components$Plan$Form$AppliesGroupDiscountInTiers(false))))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Apply Same Discount to Entire Group'),
																	A2(
																	$author$project$Ui$Element$view,
																	_List_fromArray(
																		[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted, $author$project$Ui$Element$fontBold]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Per member discount from the last added member will apply to all members in group')
																		]))
																]))
														]))
												]))
										])),
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$offsetLabel,
											$author$project$Ui$Form$Group$labelSpanSm(5),
											$author$project$Ui$Form$Group$inputSpanSm(6),
											$author$project$Ui$Form$Group$label('Default Discount Type'),
											$author$project$Ui$Form$Group$labelClass('')
										]),
									_List_fromArray(
										[
											$author$project$Ui$Button$group(
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Button$view,
													{mm: 'Select percentage base discount calculation'},
													_List_fromArray(
														[
															$author$project$Ui$Button$active(
															_Utils_eq(
																groupDiscountRulesCalculatedBy,
																$elm$core$Maybe$Just('percent_off'))),
															$author$project$Ui$Button$onClick(
															$author$project$Components$Plan$Form$FormUpdated(
																$author$project$Components$Plan$Form$ToggleGroupDiscountRulesCalculatedBy(true)))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('%')
														])),
													A3(
													$author$project$Ui$Button$view,
													{mm: 'Select fixed discount rate'},
													_List_fromArray(
														[
															$author$project$Ui$Button$active(
															!_Utils_eq(
																groupDiscountRulesCalculatedBy,
																$elm$core$Maybe$Just('percent_off'))),
															$author$project$Ui$Button$onClick(
															$author$project$Components$Plan$Form$FormUpdated(
																$author$project$Components$Plan$Form$ToggleGroupDiscountRulesCalculatedBy(false)))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('$')
														]))
												]))
										])),
									A2(
									$author$project$Ui$Grid$row,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$spanSm(11),
													$author$project$Ui$Grid$offsetSm(1)
												]),
											_List_fromArray(
												[
													A4(
													$author$project$Ui$Table$view,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Table$header,
															_List_fromArray(
																[
																	$author$project$Ui$Table$cellSpan(3)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('From')
																])),
															A2(
															$author$project$Ui$Table$header,
															_List_fromArray(
																[
																	$author$project$Ui$Table$cellSpan(3)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('To')
																])),
															A2(
															$author$project$Ui$Table$header,
															_List_fromArray(
																[
																	$author$project$Ui$Table$cellSpan(2)
																]),
															_List_Nil),
															A2(
															$author$project$Ui$Table$header,
															_List_fromArray(
																[
																	$author$project$Ui$Table$cellSpan(4)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Discount per Member')
																]))
														]),
													A2(
														$elm$core$List$indexedMap,
														A2($author$project$Components$Plan$Form$viewGroupDiscountRule, plan, form),
														groupDiscountRules),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Table$row,
															_List_Nil,
															_List_fromArray(
																[
																	A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
																	A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
																	A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
																	A2(
																	$author$project$Ui$Table$cell,
																	_List_Nil,
																	_List_fromArray(
																		[
																			allowNewGroupRule ? A3(
																			$author$project$Ui$Button$view,
																			{mm: 'Add group range discount rule'},
																			_List_fromArray(
																				[
																					$author$project$Ui$Button$onClick(
																					$author$project$Components$Plan$Form$FormUpdated($author$project$Components$Plan$Form$GroupDiscountRuleAdd)),
																					$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text('Add Range')
																				])) : $author$project$Utils$Html$empty
																		]))
																]))
														]))
												]))
										]))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]));
	});
var $author$project$Components$Plan$Form$Iua = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Plan$Meta$iuaOptions = function (_v0) {
	var meta = _v0;
	return meta.Vv;
};
var $author$project$Components$Plan$Form$iuaOptions = function (meta) {
	return A2(
		$elm$core$List$map,
		function (iua) {
			return A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(iua),
				$author$project$Formatters$String$titleize(iua));
		},
		$author$project$Api$Provider$Plan$Meta$iuaOptions(meta));
};
var $author$project$Components$Plan$Form$viewIuaOptionsFields = F2(
	function (plan, form) {
		var meta = $author$project$Api$Provider$Plan$One$meta(plan);
		var _v0 = $author$project$Utils$Form$fields(form);
		var iua = _v0.Vu;
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mb2]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('Initial Unshareable Amount')
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$offsetLabel,
							$author$project$Ui$Form$Group$labelSpanSm(5),
							$author$project$Ui$Form$Group$inputSpanSm(6),
							$author$project$Ui$Form$Group$label('IUA'),
							$author$project$Ui$Form$Group$labelClass(''),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(iua),
									$author$project$Ui$Form$Select$onChange(
									A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$Iua))
								]),
							$author$project$Components$Plan$Form$iuaOptions(meta))
						]))
				]));
	});
var $author$project$Components$Plan$Form$PlanChangeAdd = {$: 24};
var $author$project$Components$Plan$Form$PlanChangeChangeAfterMonths = function (a) {
	return {$: 21, a: a};
};
var $author$project$Components$Plan$Form$PlanChangeRemove = {$: 25};
var $author$project$Components$Plan$Form$PlanChangeType = function (a) {
	return {$: 20, a: a};
};
var $author$project$Components$Plan$Form$PlanChangeUndoRemove = {$: 26};
var $author$project$Components$DateInput$Errors = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$DateInput$errors = $author$project$Components$DateInput$Errors;
var $author$project$Components$ResourceFilter$Plan$view = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$view,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.Jy),
					options),
				model.b8));
	});
var $author$project$Components$Plan$Form$viewPlanChangeFields = F3(
	function (changeOnDateInput, toPlanResourceFilter, form) {
		var _v0 = $author$project$Utils$Form$fields(form);
		var planChange = _v0.kG;
		var _v1 = planChange.YL;
		var type_ = _v1.amg;
		var changeAfterMonths = _v1.Nt;
		var changeOnDate = _v1.Nu;
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mb2]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$title,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Plan Change')
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$offsetLabel,
							$author$project$Ui$Form$Group$labelSpanSm(5),
							$author$project$Ui$Form$Group$inputSpanSm(6),
							$author$project$Ui$Form$Group$label('Plan Change'),
							$author$project$Ui$Form$Group$labelClass(''),
							$author$project$Ui$Form$Group$labelHelp(
							$elm$html$Html$text('You may schedule this membership plan to change into another existing membership plan automatically'))
						]),
					_List_fromArray(
						[
							((!_Utils_eq(planChange.YL.ahP, $elm$core$Maybe$Nothing)) || planChange.cs) ? A2(
							$author$project$Ui$Form$Static$view,
							_List_fromArray(
								[$author$project$Ui$Form$Static$flex, $author$project$Ui$Form$Static$spaceBetween, $author$project$Ui$Form$Static$itemsCenter]),
							_List_fromArray(
								[
									((!_Utils_eq(planChange.YL.ahP, $elm$core$Maybe$Nothing)) && (!planChange.ud)) ? $elm$html$Html$text('Scheduled') : $author$project$Utils$Html$empty,
									(_Utils_eq(planChange.YL.ahP, $elm$core$Maybe$Nothing) && planChange.cs) ? $elm$html$Html$text('Active') : $author$project$Utils$Html$empty,
									planChange.ud ? $elm$html$Html$text('Removed') : $author$project$Utils$Html$empty,
									planChange.ud ? A3(
									$author$project$Ui$Button$view,
									{mm: 'Undo plan removal'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick(
											$author$project$Components$Plan$Form$FormUpdated($author$project$Components$Plan$Form$PlanChangeUndoRemove))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Undo')
										])) : A3(
									$author$project$Ui$Button$view,
									{mm: 'Remove plan change'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick(
											$author$project$Components$Plan$Form$FormUpdated($author$project$Components$Plan$Form$PlanChangeRemove))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Remove')
										]))
								])) : $author$project$Utils$Html$empty,
							(_Utils_eq(planChange.YL.ahP, $elm$core$Maybe$Nothing) && (!planChange.cs)) ? A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flex, $author$project$Ui$Element$justifyRight]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Add plan change'},
									_List_fromArray(
										[
											$author$project$Ui$Button$onClick(
											$author$project$Components$Plan$Form$FormUpdated($author$project$Components$Plan$Form$PlanChangeAdd)),
											$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Add plan change')
										]))
								])) : $author$project$Utils$Html$empty
						])),
					((!planChange.ud) && ((!_Utils_eq(planChange.YL.ahP, $elm$core$Maybe$Nothing)) || planChange.cs)) ? A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$offsetLabel,
									$author$project$Ui$Form$Group$labelSpanSm(5),
									$author$project$Ui$Form$Group$inputSpanSm(6),
									$author$project$Ui$Form$Group$label('Effective date'),
									$author$project$Ui$Form$Group$labelClass('')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$row,
									_List_Nil,
									(type_ === 2) ? _List_fromArray(
										[
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$spanSm(12)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Form$Static$view,
													_List_Nil,
													function () {
														var _v2 = planChange.YL.OC;
														if (!_v2.$) {
															var contractPeriodInMonths = _v2.a;
															return _List_fromArray(
																[
																	$elm$html$Html$text(
																	A2($author$project$Formatters$String$pluralize, 'month', contractPeriodInMonths))
																]);
														} else {
															return _List_fromArray(
																[
																	$elm$html$Html$text('Contract period')
																]);
														}
													}())
												]))
										]) : ((!_Utils_eq(planChange.YL.ahP, $elm$core$Maybe$Nothing)) ? _List_fromArray(
										[
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$spanSm(12)
												]),
											_List_fromArray(
												[
													function () {
													switch (type_) {
														case 1:
															return A2(
																$author$project$Ui$Form$Static$view,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		A2(
																			$elm$core$Maybe$withDefault,
																			'N/A',
																			A2(
																				$elm$core$Maybe$map,
																				$author$project$Formatters$String$pluralize('month'),
																				changeAfterMonths))),
																		$elm$html$Html$text(' since member starts')
																	]));
														case 0:
															return A2(
																$author$project$Ui$Form$Static$view,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		A2(
																			$elm$core$Maybe$withDefault,
																			'N/A',
																			A2(
																				$elm$core$Maybe$map,
																				$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
																				changeOnDate)))
																	]));
														default:
															return $author$project$Utils$Html$empty;
													}
												}()
												]))
										]) : _List_fromArray(
										[
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$spanSm(6)
												]),
											_List_fromArray(
												[
													$author$project$Ui$Form$ButtonSelect$view(
													{
														ajd: A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$PlanChangeType),
														Cd: _List_fromArray(
															[
																A2($author$project$Ui$Form$ButtonSelect$option, 1, 'Periods of months'),
																A2($author$project$Ui$Form$ButtonSelect$option, 0, 'Date')
															]),
														aee: type_
													})
												])),
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$spanSm(6)
												]),
											_List_fromArray(
												[
													function () {
													switch (type_) {
														case 1:
															return $author$project$Ui$Form$PeriodInMonthsInput$view(
																{
																	agX: A2($author$project$Utils$Form$validationErrors, $author$project$Components$Plan$Form$PlanChangeChangeAfterMonthsValidation, form),
																	sM: A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$Plan$Form$PlanChangeChangeAfterMonthsValidation, form),
																	ajm: A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$PlanChangeChangeAfterMonths),
																	aee: changeAfterMonths
																});
														case 0:
															return A2(
																$elm$html$Html$map,
																$author$project$Components$Plan$Form$PlanChangeChangeOnDateInputMsg,
																A2(
																	$author$project$Components$DateInput$view,
																	_List_fromArray(
																		[
																			$author$project$Components$DateInput$value(changeOnDate),
																			$author$project$Components$DateInput$invalid(
																			A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$Plan$Form$PlanChangeChangeOnDateValidation, form)),
																			$author$project$Components$DateInput$errors(
																			A2($author$project$Utils$Form$validationErrors, $author$project$Components$Plan$Form$PlanChangeChangeOnDateValidation, form))
																		]),
																	changeOnDateInput));
														default:
															return $author$project$Utils$Html$empty;
													}
												}()
												]))
										])))
								])),
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$offsetLabel,
									$author$project$Ui$Form$Group$labelSpanSm(5),
									$author$project$Ui$Form$Group$inputSpanSm(6),
									$author$project$Ui$Form$Group$label('New plan'),
									$author$project$Ui$Form$Group$labelClass('')
								]),
							_List_fromArray(
								[
									function () {
									if (!_Utils_eq(planChange.YL.ahP, $elm$core$Maybe$Nothing)) {
										return A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2(
														$elm$core$Maybe$withDefault,
														'N/A',
														A2(
															$elm$core$Maybe$map,
															function ($) {
																return $.Bq;
															},
															planChange.YL.adc)))
												]));
									} else {
										if (!toPlanResourceFilter.$) {
											var toPlanResourceFilter_ = toPlanResourceFilter.a;
											return A2(
												$elm$html$Html$map,
												$author$project$Components$Plan$Form$PlanChangeToPlanResourceFilterMsg,
												A2(
													$author$project$Components$ResourceFilter$Plan$view,
													_List_fromArray(
														[
															$author$project$Components$ResourceFilter$invalid(
															A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$Plan$Form$PlanChangeToPlanValidation, form)),
															$author$project$Components$ResourceFilter$errors(
															A2($author$project$Utils$Form$validationErrors, $author$project$Components$Plan$Form$PlanChangeToPlanValidation, form))
														]),
													toPlanResourceFilter_));
										} else {
											return $author$project$Utils$Html$empty;
										}
									}
								}()
								]))
						])) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$Plan$Form$EditPricingVersion = {$: 24};
var $author$project$Components$Plan$Form$PricingEffectivenessTypeChanged = function (a) {
	return {$: 41, a: a};
};
var $author$project$Api$Feature$PricingVersions = 21;
var $author$project$Components$Plan$Form$ScheduleNewPriceChange = {$: 23};
var $author$project$Api$Provider$PricingVersion$Shared$effectiveDate = function (_v0) {
	var record = _v0;
	return record.Q7;
};
var $author$project$Components$Plan$Form$viewPriceChangeSection = F3(
	function (practice, plan, formFields) {
		if (A2($author$project$Api$Provider$Practice$One$featureEnabled, 21, practice)) {
			var _v0 = $author$project$Api$Provider$Plan$One$upcomingPricingVersion(plan);
			if (!_v0.$) {
				var pricingVersion = _v0.a;
				return A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$mb2]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$title,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Price Change')
										]))
								])),
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$offsetLabel,
									$author$project$Ui$Form$Group$labelSpanSm(5),
									$author$project$Ui$Form$Group$inputSpanSm(6),
									$author$project$Ui$Form$Group$label('Price Change'),
									$author$project$Ui$Form$Group$labelClass(''),
									$author$project$Ui$Form$Group$labelHelp(
									$elm$html$Html$text('You may schedule the pricing for this membership plan to change automatically.'))
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$flex, $author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											'Scheduled, Effective starting ' + A2(
												$author$project$Formatters$Date$toString,
												$author$project$Formatters$Date$Full,
												$author$project$Api$Provider$PricingVersion$Shared$effectiveDate(pricingVersion))),
											A3(
											$author$project$Ui$Button$view,
											{mm: 'Edit price change'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick($author$project$Components$Plan$Form$EditPricingVersion)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Edit')
												]))
										]))
								])),
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$offsetLabel,
									$author$project$Ui$Form$Group$labelSpanSm(5),
									$author$project$Ui$Form$Group$inputSpanSm(6),
									$author$project$Ui$Form$Group$label('When should members see this new pricing?'),
									$author$project$Ui$Form$Group$labelClass('')
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$ButtonSelect$view(
									{
										ajd: A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$PricingEffectivenessTypeChanged),
										Cd: _List_fromArray(
											[
												A2($author$project$Ui$Form$ButtonSelect$option, 0, 'On First Bill after Effective Date'),
												formFields.OB ? A2($author$project$Ui$Form$ButtonSelect$option, 1, 'On Contract Renewal') : A2($author$project$Ui$Form$ButtonSelect$option, 2, 'On Members\' Anniversary')
											]),
										aee: formFields._j
									})
								]))
						]));
			} else {
				return A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$mb2]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$title,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Price Change')
										]))
								])),
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$offsetLabel,
									$author$project$Ui$Form$Group$labelSpanSm(5),
									$author$project$Ui$Form$Group$inputSpanSm(6),
									$author$project$Ui$Form$Group$label('Price Change'),
									$author$project$Ui$Form$Group$labelClass(''),
									$author$project$Ui$Form$Group$labelHelp(
									$elm$html$Html$text('You may schedule the pricing for this membership plan to change automatically.'))
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$flex, $author$project$Ui$Element$justifyRight]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{mm: 'Schedule price change'},
											_List_fromArray(
												[
													$author$project$Ui$Button$onClick($author$project$Components$Plan$Form$ScheduleNewPriceChange),
													$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Schedule Price Change')
												]))
										]))
								]))
						]));
			}
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$Plan$Form$TobaccoSurchargeInCents = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Plan$Form$TobaccoSurchargePercentage = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Plan$Form$TobaccoSurchargeType = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Plan$Form$viewTobaccoSurchargeFields = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var tobaccoSurchargeType = _v0.adh;
	var percentageTobaccoSurchargeType = _Utils_eq(tobaccoSurchargeType, $elm$core$Maybe$Nothing) || (_Utils_eq(
		tobaccoSurchargeType,
		$elm$core$Maybe$Just('percentage_per_member')) || _Utils_eq(
		tobaccoSurchargeType,
		$elm$core$Maybe$Just('percentage_per_membership')));
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mb2]),
				_List_fromArray(
					[
						$author$project$Ui$Typography$headingSm(
						_List_fromArray(
							[
								$elm$html$Html$text('Tobacco Surcharge')
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$offsetLabel,
						$author$project$Ui$Form$Group$labelSpanSm(5),
						$author$project$Ui$Form$Group$inputSpanSm(6),
						$author$project$Ui$Form$Group$label('Tobacco surcharge'),
						$author$project$Ui$Form$Group$labelClass('')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$ButtonSelect$view(
						{
							ajd: A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$TobaccoSurchargeType),
							Cd: _List_fromArray(
								[
									A2($author$project$Ui$Form$ButtonSelect$option, $elm$core$Maybe$Nothing, 'Disabled'),
									A2(
									$author$project$Ui$Form$ButtonSelect$option,
									percentageTobaccoSurchargeType ? $elm$core$Maybe$Just('percentage_per_member') : $elm$core$Maybe$Just('fixed_per_member'),
									'Per member'),
									A2(
									$author$project$Ui$Form$ButtonSelect$option,
									percentageTobaccoSurchargeType ? $elm$core$Maybe$Just('percentage_per_membership') : $elm$core$Maybe$Just('fixed_per_membership'),
									'Per membership')
								]),
							aee: tobaccoSurchargeType
						})
					])),
				function () {
				if (!_Utils_eq(tobaccoSurchargeType, $elm$core$Maybe$Nothing)) {
					var perMemberTobaccoSurchargeType = _Utils_eq(
						tobaccoSurchargeType,
						$elm$core$Maybe$Just('percentage_per_member')) || _Utils_eq(
						tobaccoSurchargeType,
						$elm$core$Maybe$Just('fixed_per_member'));
					return A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$offsetLabel,
								$author$project$Ui$Form$Group$labelSpanSm(5),
								$author$project$Ui$Form$Group$inputSpanSm(6),
								$author$project$Ui$Form$Group$label('Surcharge type'),
								$author$project$Ui$Form$Group$labelClass('')
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$ButtonSelect$view(
								{
									ajd: A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$TobaccoSurchargeType),
									Cd: _List_fromArray(
										[
											A2(
											$author$project$Ui$Form$ButtonSelect$option,
											perMemberTobaccoSurchargeType ? $elm$core$Maybe$Just('percentage_per_member') : $elm$core$Maybe$Just('percentage_per_membership'),
											'Percentage'),
											A2(
											$author$project$Ui$Form$ButtonSelect$option,
											perMemberTobaccoSurchargeType ? $elm$core$Maybe$Just('fixed_per_member') : $elm$core$Maybe$Just('fixed_per_membership'),
											'Fixed')
										]),
									aee: tobaccoSurchargeType
								})
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				if (!_Utils_eq(tobaccoSurchargeType, $elm$core$Maybe$Nothing)) {
					var label = percentageTobaccoSurchargeType ? 'Percentage' : 'Amount';
					return A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$offsetLabel,
								$author$project$Ui$Form$Group$labelSpanSm(5),
								$author$project$Ui$Form$Group$inputSpanSm(6),
								$author$project$Ui$Form$Group$label(label),
								$author$project$Ui$Form$Group$labelClass(''),
								$author$project$Ui$Form$Group$required(true)
							]),
						function () {
							if (percentageTobaccoSurchargeType) {
								var _v1 = $author$project$Utils$Form$fields(form);
								var tobaccoSurchargePercentage = _v1.adg;
								return _List_fromArray(
									[
										$author$project$Ui$Form$PercentageInput$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$PercentageInput$value(tobaccoSurchargePercentage),
												$author$project$Ui$Form$PercentageInput$onInput(
												A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$TobaccoSurchargePercentage)),
												$author$project$Ui$Form$PercentageInput$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$Plan$Form$TobaccoSurchargePercentageValidation, form))
											])),
										$author$project$Utils$FormErrors$view(
										A2($author$project$Utils$Form$validationErrors, $author$project$Components$Plan$Form$TobaccoSurchargePercentageValidation, form))
									]);
							} else {
								var _v2 = $author$project$Utils$Form$fields(form);
								var tobaccoSurchargeInCents = _v2.adf;
								return _List_fromArray(
									[
										$author$project$Ui$Form$CurrencyInput$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$CurrencyInput$value(tobaccoSurchargeInCents),
												$author$project$Ui$Form$CurrencyInput$onInput(
												A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$TobaccoSurchargeInCents)),
												$author$project$Ui$Form$CurrencyInput$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$Plan$Form$TobaccoSurchargeInCentsValidation, form))
											])),
										$author$project$Utils$FormErrors$view(
										A2($author$project$Utils$Form$validationErrors, $author$project$Components$Plan$Form$TobaccoSurchargeInCentsValidation, form))
									]);
							}
						}());
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]));
};
var $author$project$Components$Plan$Form$viewForm = F3(
	function (model, plan, form) {
		var sharedFields = A2($author$project$Components$Plan$Form$initSharedFields, plan, form);
		var planType = $author$project$Api$Provider$Plan$One$planType(plan);
		var showAdvancedSections = (!model.ZX) && (planType !== 1);
		var isMce = $author$project$Api$Provider$Plan$One$isMcePlan(plan);
		var _v0 = $author$project$Utils$Form$fields(form);
		var basicPlan = _v0.ab;
		var membershipPricingForm = _v0.dq;
		var specialRatesForm = _v0.dL;
		var allBasicFields = A2(
			$elm$core$List$map,
			$elm$html$Html$map($author$project$Components$Plan$Form$BasicPlanFormUpdated),
			A2(
				$author$project$Components$Plan$BasicForm$view,
				basicPlan,
				$elm$core$Maybe$Just(plan)));
		return _List_fromArray(
			[
				_List_fromArray(
				[
					A2($author$project$Ui$Panel$body, _List_Nil, allBasicFields)
				]),
				_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							(sharedFields.S1 === 'fixed_pricing') ? A2(
							$elm$html$Html$map,
							$author$project$Components$Plan$Form$GroupTierPricingFieldsUpdated,
							A3(
								$author$project$Components$Plan$Form$GroupTierPricingFields$view,
								sharedFields,
								$elm$core$Maybe$Just(plan),
								$author$project$Utils$Form$fields(form).k)) : A2(
							$elm$html$Html$map,
							$author$project$Components$Plan$Form$IndividualMembershipPricingFieldsUpdated,
							A4(
								$author$project$Components$Plan$Form$IndividualMembershipPricingFields$view,
								sharedFields,
								model.ZV,
								$elm$core$Maybe$Just(plan),
								membershipPricingForm))
						]))
				]),
				(sharedFields.S1 === 'family') ? _List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A3($author$project$Components$Plan$Form$viewFamilyMembershipPricing, sharedFields, plan, form)
						]))
				]) : _List_Nil,
				(sharedFields.S1 === 'group') ? _List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Components$Plan$Form$viewGroupMembershipPricingFields, plan, form)
						]))
				]) : _List_Nil,
				model.ZX ? _List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Well$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$info]),
									_List_fromArray(
										[
											$elm$html$Html$text('If you\'re looking for additional options, or have more than one plan, you can access advanced settings after saving your plan.')
										]))
								]))
						]))
				]) : _List_Nil,
				(showAdvancedSections && (!isMce)) ? _List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Components$Plan$Form$viewCoveragePlanFields, plan, form)
						]))
				]) : _List_Nil,
				(showAdvancedSections && model.qy) ? _List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Components$Plan$Form$viewTobaccoSurchargeFields(form)
						]))
				]) : _List_Nil,
				(showAdvancedSections && isMce) ? _List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Components$Plan$Form$viewIuaOptionsFields, plan, form)
						]))
				]) : _List_Nil,
				(showAdvancedSections && (!isMce)) ? _List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Components$Plan$Form$viewAgeRestrictionsFields(form)
						]))
				]) : _List_Nil,
				function () {
				if (showAdvancedSections && A2(
					$author$project$Utils$FeatureGate$gateAvailable,
					7,
					$author$project$Api$Practice$Provider(model.ZV))) {
					var forCompany = !planType;
					return _List_fromArray(
						[
							A2(
							$author$project$Ui$Panel$body,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$mb2]),
									_List_fromArray(
										[
											$author$project$Ui$Typography$headingSm(
											_List_fromArray(
												[
													$elm$html$Html$text('Advanced Pricing Rules')
												]))
										])),
									((!forCompany) && (!isMce)) ? A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									A2($author$project$Components$Plan$Form$viewContractPeriodFields, plan, form)) : $author$project$Utils$Html$empty,
									model.kH ? A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											A3($author$project$Components$Plan$Form$viewPlanChangeFields, model.tS, model.eT, form)
										])) : $author$project$Utils$Html$empty,
									A3(
									$author$project$Components$Plan$Form$viewPriceChangeSection,
									model.ZV,
									plan,
									$author$project$Utils$Form$fields(form)),
									(!isMce) ? A2(
									$elm$html$Html$map,
									$author$project$Components$Plan$Form$SpecialRatesFieldsUpdated,
									A2($author$project$Components$Plan$Form$SpecialRatesFields$view, plan, specialRatesForm)) : $author$project$Utils$Html$empty
								]))
						]);
				} else {
					return _List_Nil;
				}
			}()
			]);
	});
var $author$project$Components$Plan$Form$view = function (_v0) {
	var model = _v0;
	return _List_fromArray(
		[
			$author$project$Components$Plan$Form$modal(model),
			A2(
			$author$project$Ui$Form$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$noValidate(true),
					$author$project$Ui$Form$autocomplete(false),
					$author$project$Ui$Form$onSubmit($author$project$Components$Plan$Form$Save)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$view,
					model.ZX ? _List_fromArray(
						[$author$project$Ui$Panel$onlyBorderLeft]) : _List_Nil,
					function () {
						var _v1 = model.SD;
						if (!_v1.$) {
							var _v2 = _v1.a;
							var plan = _v2.a;
							var form = _v2.b;
							return _Utils_ap(
								$elm$core$List$concat(
									A2(
										$elm$core$List$intersperse,
										_List_fromArray(
											[$author$project$Ui$Panel$hr]),
										A2(
											$elm$core$List$filter,
											A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$List$isEmpty),
											A3($author$project$Components$Plan$Form$viewForm, model, plan, form)))),
								_List_fromArray(
									[
										A2(
										$author$project$Components$Plan$Form$viewFooter,
										model,
										$elm$core$Maybe$Just(
											_Utils_Tuple2(plan, form)))
									]));
						} else {
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Panel$body,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$textCenter]),
											_List_fromArray(
												[
													$author$project$Ui$Spinner$view(_List_Nil)
												]))
										])),
									A2($author$project$Components$Plan$Form$viewFooter, model, $elm$core$Maybe$Nothing)
								]);
						}
					}())
				]))
		]);
};
var $author$project$Pages$Admin$CompanyPlans$Id_String$view = function (model) {
	return {
		fO: $author$project$Components$Plan$Form$view(model.pd),
		ac9: 'Admin | Sponsor Plans'
	};
};
var $author$project$Pages$Admin$CompanyPlans$Id_String$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$CompanyPlans$Id_String$init, aiq: $author$project$Pages$Admin$CompanyPlans$Id_String$load, k8: $author$project$Pages$Admin$CompanyPlans$Id_String$save, alO: $author$project$Pages$Admin$CompanyPlans$Id_String$subscriptions, adT: $author$project$Pages$Admin$CompanyPlans$Id_String$update, amo: $author$project$Pages$Admin$CompanyPlans$Id_String$view});
var $author$project$Pages$Admin$CompanyPlans$New$NewMsg = $elm$core$Basics$identity;
var $author$project$Components$Admin$Plans$New$Model = $elm$core$Basics$identity;
var $author$project$Components$Admin$Plans$New$PlanResourceFilterMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$Plans$New$formFieldsInit = function (type_) {
	return {OG: $elm$core$Maybe$Nothing, Bq: '', amg: type_};
};
var $author$project$Components$Admin$Plans$New$initPlanResourceFilter = F3(
	function (apiClient, session, planType) {
		return A4(
			$author$project$Components$ResourceFilter$Plan$init,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{
						De: _List_fromArray(
							[planType])
					});
			},
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'None'});
			});
	});
var $author$project$Components$Admin$Plans$New$init = F5(
	function (apiClient, session, planType, listRoute, editRoute) {
		var _v0 = A3($author$project$Components$Admin$Plans$New$initPlanResourceFilter, apiClient, session, planType);
		var planResourceFilter = _v0.a;
		var planResourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{
				Hx: editRoute,
				SD: $author$project$Utils$Form$init(
					$author$project$Components$Admin$Plans$New$formFieldsInit(planType)),
				Is: listRoute,
				Jb: $author$project$Api$Data$NotAsked,
				hi: planResourceFilter,
				ZF: planType,
				aa4: session
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$Plans$New$PlanResourceFilterMsg, planResourceFilterCmd));
	});
var $author$project$Pages$Admin$CompanyPlans$New$init = F4(
	function (session, _v0, _v1, _v2) {
		var apiClient = _v1.Gv;
		var _v3 = A5($author$project$Components$Admin$Plans$New$init, apiClient, session, 0, $author$project$Spa$Generated$Route$Admin__CompanyPlans__Top, $author$project$Spa$Generated$Route$Admin__CompanyPlans__Id_String);
		var form = _v3.a;
		var newCmd = _v3.b;
		return _Utils_Tuple2(
			{Gv: apiClient, SD: form},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, newCmd));
	});
var $author$project$Pages$Admin$CompanyPlans$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$CompanyPlans$New$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Admin$Plans$New$subscriptions = function (_v0) {
	var model = _v0;
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Components$Admin$Plans$New$PlanResourceFilterMsg,
		$author$project$Components$ResourceFilter$Plan$subscriptions(model.hi));
};
var $author$project$Pages$Admin$CompanyPlans$New$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Admin$Plans$New$subscriptions(model.SD));
};
var $author$project$Components$Admin$Plans$New$CopyFrom = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$Plans$New$Created = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$Plan$createBasic = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							_Utils_Tuple2(
							'plan',
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'plan_type',
										$elm$json$Json$Encode$string(
											$author$project$Api$PlanType$toString(fields.ZF))),
										_Utils_Tuple2(
										'name',
										$elm$json$Json$Encode$string(fields.Bq))
									])))
						]),
						function () {
						var _v0 = fields.OG;
						if (!_v0.$) {
							var id_ = _v0.a;
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'copy_from',
									$author$project$Utils$Encode$association(id_))
								]);
						} else {
							return _List_Nil;
						}
					}()
					])));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Plan$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Plan$plansPath)));
	});
var $author$project$Components$Admin$Plans$New$createPlan = F2(
	function (apiClient, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A3(
			$author$project$Api$Provider$Plan$createBasic,
			apiClient,
			{OG: fields.OG, Bq: fields.Bq, ZF: fields.amg},
			$author$project$Components$Admin$Plans$New$Created);
	});
var $author$project$Components$Admin$Plans$New$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{Bq: string});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{OG: string});
			default:
				var type_ = field.a;
				return _Utils_update(
					fields,
					{amg: type_});
		}
	});
var $author$project$Components$Admin$Plans$New$NameValidation = 0;
var $author$project$Components$Admin$Plans$New$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.Bq;
			},
			_Utils_Tuple2(0, 'Please enter a plan name.'))
		]));
var $author$project$Components$ResourceFilter$Plan$value = function (model) {
	return A2($author$project$Components$ResourceFilter$choiceToValue, model.b8, model.Jy);
};
var $author$project$Components$Admin$Plans$New$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Admin$Plans$New$formFieldsUpdate, field, model.SD);
				var _v2 = function () {
					if (field.$ === 2) {
						var planType = field.a;
						return A3($author$project$Components$Admin$Plans$New$initPlanResourceFilter, apiClient, model.aa4, planType);
					} else {
						return _Utils_Tuple2(model.hi, $elm$core$Platform$Cmd$none);
					}
				}();
				var planResourceFilter = _v2.a;
				var planResourceFilterCmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: newForm, hi: planResourceFilter}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$Plans$New$PlanResourceFilterMsg, planResourceFilterCmd),
					_List_Nil);
			case 1:
				var _v4 = A2($author$project$Utils$Form$validate, $author$project$Components$Admin$Plans$New$formFieldsValidator, model.SD);
				if (!_v4.$) {
					var _v5 = _v4.a;
					var newForm = _v5.a;
					var validFormFields = _v5.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{SD: newForm, Jb: $author$project$Api$Data$Loading}),
						A2($author$project$Components$Admin$Plans$New$createPlan, apiClient, validFormFields),
						_List_Nil);
				} else {
					var newForm = _v4.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{SD: newForm}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					var plan = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Jb: response}),
						A2(
							$author$project$Utils$Route$navigate,
							$elm$core$Dict$empty,
							model.Hx(
								{
									ahP: $author$project$Api$Provider$Plan$One$id(plan)
								})),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Plan successfully created.'),
								$author$project$OutMsg$RefreshPractice
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Jb: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var subMsg = msg.a;
				var planResourceFilterResult = A3($author$project$Components$ResourceFilter$Plan$update, apiClient, subMsg, model.hi);
				var modelAfterEvent = function () {
					var _v7 = planResourceFilterResult.agZ;
					if (!_v7.$) {
						return _Utils_update(
							model,
							{
								SD: A3(
									$author$project$Utils$Form$update,
									$author$project$Components$Admin$Plans$New$formFieldsUpdate,
									$author$project$Components$Admin$Plans$New$CopyFrom(
										$author$project$Components$ResourceFilter$Plan$value(planResourceFilterResult.aiO)),
									model.SD)
							});
					} else {
						return model;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						modelAfterEvent,
						{hi: planResourceFilterResult.aiO}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$Plans$New$PlanResourceFilterMsg, planResourceFilterResult.GZ),
					planResourceFilterResult.aR);
		}
	});
var $author$project$Pages$Admin$CompanyPlans$New$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Admin$Plans$New$update, model.Gv, subMsg, model.SD);
		var form = _v1.a;
		var newCmd = _v1.b;
		var outMsgs = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{SD: form}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, newCmd),
			outMsgs);
	});
var $author$project$Components$Admin$Plans$New$Create = {$: 1};
var $author$project$Components$Admin$Plans$New$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$Plans$New$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$Plans$New$Type = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$Plans$New$view = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.SD);
	return A2(
		$author$project$Ui$Form$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$noValidate(true),
				$author$project$Ui$Form$autocomplete(false),
				$author$project$Ui$Form$onSubmit($author$project$Components$Admin$Plans$New$Create)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Create New Plan')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Name your plan'),
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(8),
										$author$project$Ui$Form$Group$required(true)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$autofocus(true),
												$author$project$Ui$Form$Input$value(fields.Bq),
												$author$project$Ui$Form$Input$placeholder('New Membership Type'),
												$author$project$Ui$Form$Input$onInput(
												A2($elm$core$Basics$composeL, $author$project$Components$Admin$Plans$New$FormUpdated, $author$project$Components$Admin$Plans$New$Name)),
												$author$project$Ui$Form$Input$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, 0, model.SD)),
												$author$project$Ui$Form$Input$errors(
												A2($author$project$Utils$Form$validationErrors, 0, model.SD))
											]))
									])),
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Copy plan details from'),
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(8)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Components$Admin$Plans$New$PlanResourceFilterMsg,
										A2($author$project$Components$ResourceFilter$Plan$view, _List_Nil, model.hi))
									])),
								(fields.amg !== 2) ? A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Plan Type'),
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(8)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Button$group(
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Button$view,
												{mm: 'Select per member type '},
												_List_fromArray(
													[
														$author$project$Ui$Button$active(!fields.amg),
														$author$project$Ui$Button$onClick(
														$author$project$Components$Admin$Plans$New$FormUpdated(
															$author$project$Components$Admin$Plans$New$Type(0)))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Per member')
													])),
												A3(
												$author$project$Ui$Button$view,
												{mm: 'Select fixed fee type '},
												_List_fromArray(
													[
														$author$project$Ui$Button$active(fields.amg === 1),
														$author$project$Ui$Button$onClick(
														$author$project$Components$Admin$Plans$New$FormUpdated(
															$author$project$Components$Admin$Plans$New$Type(1)))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Fixed fee')
													]))
											]))
									])) : $author$project$Utils$Html$empty
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_fromArray(
							[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$itemsCenter]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Link$route,
								model.Is,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Cancel')
									])),
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Create new plan'},
								_List_fromArray(
									[
										$author$project$Ui$Button$primary,
										$author$project$Ui$Button$submit,
										$author$project$Ui$Button$loading(
										_Utils_eq(model.Jb, $author$project$Api$Data$Loading))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Create New Plan')
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Admin$CompanyPlans$New$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Admin$Plans$New$view(model.SD))
			]),
		ac9: 'Admin | Sponsor Plans'
	};
};
var $author$project$Pages$Admin$CompanyPlans$New$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$CompanyPlans$New$init, aiq: $author$project$Pages$Admin$CompanyPlans$New$load, k8: $author$project$Pages$Admin$CompanyPlans$New$save, alO: $author$project$Pages$Admin$CompanyPlans$New$subscriptions, adT: $author$project$Pages$Admin$CompanyPlans$New$update, amo: $author$project$Pages$Admin$CompanyPlans$New$view});
var $author$project$Pages$Admin$CompanyPlans$Top$ListMsg = $elm$core$Basics$identity;
var $author$project$Components$Admin$Plans$List$GotPlans = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Plan$Pricing = 0;
var $author$project$Components$Admin$Plans$List$fetchPlans = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Api$Provider$Plan$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						HE: _List_fromArray(
							[0]),
						ajJ: model.ajJ,
						De: model.De,
						akl: model.akl
					});
			},
			$author$project$Components$Admin$Plans$List$GotPlans);
	});
var $author$project$Components$Admin$Plans$List$init = function (apiClient) {
	return function (session) {
		return function (userIsAdmin) {
			return function (planTypes) {
				return function (listRoute) {
					return function (newRoute) {
						return function (editRoute) {
							return function (help) {
								return function (query) {
									return function (_v0) {
										return function (practice) {
											var isOnboarding = _v0.bb;
											var q = A2($elm$core$Dict$get, 'q', query);
											var allowMultipleRetailMemberships = A2(
												$elm$core$Maybe$withDefault,
												false,
												A2($elm$core$Maybe$map, $author$project$Api$Provider$Practice$One$allowMultipleRetailMemberships, practice));
											var model = {
												Lw: allowMultipleRetailMemberships,
												Hx: editRoute,
												Tp: help,
												bb: isOnboarding,
												Is: listRoute,
												II: newRoute,
												ajJ: $author$project$Api$Pagination$initFromQuery(query),
												De: planTypes,
												ZG: $author$project$Api$Data$Loading,
												ZV: practice,
												akl: q,
												up: $author$project$Ui$SearchInput$init(q),
												aa4: session,
												F1: userIsAdmin
											};
											return _Utils_Tuple2(
												model,
												A2($author$project$Components$Admin$Plans$List$fetchPlans, apiClient, model));
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Admin$CompanyPlans$Top$init = F4(
	function (session, practice, _v0, _v1) {
		var apiClient = _v0.Gv;
		var query = _v1.DE;
		var _v2 = $author$project$Components$Admin$Plans$List$init(apiClient)(session)(
			$author$project$Api$Platform$User$Shared$isAdmin(
				$author$project$Api$Platform$Session$One$user(session)))(
			_List_fromArray(
				[0, 1, 3]))($author$project$Spa$Generated$Route$Admin__CompanyPlans__Top)($author$project$Spa$Generated$Route$Admin__CompanyPlans__New)($author$project$Spa$Generated$Route$Admin__CompanyPlans__Id_String)(_List_Nil)(query)(
			{bb: false})(
			$elm$core$Maybe$Just(practice));
		var list = _v2.a;
		var listCmd = _v2.b;
		return _Utils_Tuple2(
			{Gv: apiClient, s1: list},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, listCmd));
	});
var $author$project$Pages$Admin$CompanyPlans$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$CompanyPlans$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$CompanyPlans$Top$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Components$Admin$Plans$List$AllowMultipleRetailMembershipsUpdated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Admin$Plans$List$SearchInputMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$PracticeOnboarding$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Practice$One$practiceOnboarding = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.ZZ;
	});
var $author$project$Api$Provider$PracticeOnboarding$AccountStep$toString = function (stepType) {
	switch (stepType) {
		case 0:
			return 'not_started';
		case 1:
			return 'contact_info';
		case 2:
			return 'membership_pricing';
		case 3:
			return 'patient_agreements';
		case 4:
			return 'users_setup';
		case 5:
			return 'communications_setup';
		case 6:
			return 'legal_setup';
		case 7:
			return 'setup_completed';
		default:
			return 'setup_completed';
	}
};
var $author$project$Components$Admin$Plans$List$PracticeOnboardingUpdated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$PracticeOnboarding$practiceOnboardingsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['practice_onboardings']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$PracticeOnboarding$practiceOnboardingPath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		$author$project$Api$Provider$PracticeOnboarding$practiceOnboardingsPath);
};
var $author$project$Api$Provider$PracticeOnboarding$updateAccountStep = F4(
	function (apiClient, accountStep, id, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practice_onboarding',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'account_step',
								$elm$json$Json$Encode$string(accountStep))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$PracticeOnboarding$practiceOnboardingPath(id))));
	});
var $author$project$Components$Admin$Plans$List$updatePracticeOnboarding = F3(
	function (apiClient, onboardId, accountStep) {
		return A4($author$project$Api$Provider$PracticeOnboarding$updateAccountStep, apiClient, accountStep, onboardId, $author$project$Components$Admin$Plans$List$PracticeOnboardingUpdated);
	});
var $author$project$Components$Admin$Plans$List$completePlansStep = F2(
	function (apiClient, practice) {
		var _v0 = A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$PracticeOnboarding$Shared$id,
			$author$project$Api$Provider$Practice$One$practiceOnboarding(practice));
		if (!_v0.$) {
			var onboardId = _v0.a;
			return A3(
				$author$project$Components$Admin$Plans$List$updatePracticeOnboarding,
				apiClient,
				onboardId,
				$author$project$Api$Provider$PracticeOnboarding$AccountStep$toString(2));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Api$Provider$Practice$disableMultipleRetailMemberships = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['multiple_retail_memberships', 'disable']),
					$author$project$Api$Provider$Practice$practicePath)));
	});
var $author$project$Api$Provider$Practice$enableMultipleRetailMemberships = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['multiple_retail_memberships', 'enable']),
					$author$project$Api$Provider$Practice$practicePath)));
	});
var $author$project$Components$Admin$Plans$List$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('q'),
			model.akl)
		]);
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString(model.Is)
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.ajJ),
				A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams))));
};
var $author$project$Components$Admin$Plans$List$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ),
								ZG: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ZG: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Ui$SearchInput$update, subMsg, model.up);
				var searchInput = _v2.a;
				var searchInputCmd = _v2.b;
				var searchInputEvent = _v2.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.akl;
					}
				}();
				var _v3 = function () {
					if (_Utils_eq(q, model.akl)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								ajJ: $author$project$Api$Pagination$reset(model.ajJ),
								ZG: $author$project$Api$Data$Loading,
								akl: q
							});
						return _Utils_Tuple2(
							qModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($author$project$Components$Admin$Plans$List$fetchPlans, apiClient, qModel),
										$author$project$Components$Admin$Plans$List$updateUrl(qModel)
									])));
					}
				}();
				var newModel = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{up: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$Plans$List$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
			case 2:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{ajJ: pagination, ZG: $author$project$Api$Data$Loading});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Admin$Plans$List$fetchPlans, apiClient, newModel),
								$author$project$Components$Admin$Plans$List$updateUrl(newModel)
							])),
					_List_Nil);
			case 3:
				var _v5 = model.ZV;
				if (!_v5.$) {
					var practice = _v5.a;
					return _Utils_Tuple3(
						model,
						A2($author$project$Components$Admin$Plans$List$completePlansStep, apiClient, practice),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Documents),
						_List_Nil);
				}
			case 4:
				return _Utils_Tuple3(
					model,
					A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Plans__New),
					_List_Nil);
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Documents),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 6:
				var enabled = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Lw: enabled}),
					enabled ? A2($author$project$Api$Provider$Practice$enableMultipleRetailMemberships, apiClient, $author$project$Components$Admin$Plans$List$AllowMultipleRetailMembershipsUpdated) : A2($author$project$Api$Provider$Practice$disableMultipleRetailMemberships, apiClient, $author$project$Components$Admin$Plans$List$AllowMultipleRetailMembershipsUpdated),
					_List_Nil);
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[$author$project$OutMsg$RefreshPractice]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Lw: !model.Lw}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Admin$CompanyPlans$Top$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Admin$Plans$List$update, model.Gv, subMsg, model.s1);
		var list = _v1.a;
		var listCmd = _v1.b;
		var outMsgs = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{s1: list}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, listCmd),
			outMsgs);
	});
var $author$project$Components$Admin$Plans$List$AddAnother = {$: 4};
var $author$project$Components$Admin$Plans$List$NextStep = {$: 3};
var $author$project$Components$Admin$Plans$List$PaginationMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Skeleton$card = $author$project$Ui$Skeleton$view('card');
var $author$project$Ui$Grid$mt2 = $author$project$Ui$Grid$RowElement($author$project$Ui$Element$mt2);
var $author$project$Api$FeatureGate$MultipleRetailMemberships = 13;
var $author$project$Components$Admin$Plans$List$ToggleAllowMultipleRetailMemberships = function (a) {
	return {$: 6, a: a};
};
var $author$project$Ui$Grid$mt4 = $author$project$Ui$Grid$RowElement($author$project$Ui$Element$mt4);
var $author$project$Components$Admin$Plans$List$viewAllowMultipleRetailMembershipsSetting = function (model) {
	var isGateAvailable = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Api$Practice$Provider,
				$author$project$Utils$FeatureGate$gateAvailable(13)),
			model.ZV));
	if (isGateAvailable) {
		var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
			_List_fromArray(
				[
					$author$project$Ui$ToggleSwitch$on(model.Lw),
					$author$project$Ui$ToggleSwitch$onChange($author$project$Components$Admin$Plans$List$ToggleAllowMultipleRetailMemberships)
				]));
		var labelHelp = A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Patients can join more than one active retail membership at the same time, each with its own billing rules and member settings.')
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
					_List_fromArray(
						[
							$elm$html$Html$text('Note: Multiple employer-sponsored memberships, networks, and affiliate practices are not yet supported.')
						]))
				]));
		return A2(
			$author$project$Ui$Grid$row,
			_List_fromArray(
				[$author$project$Ui$Grid$mt4, $author$project$Ui$Grid$mb4]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$span(8)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Allow patients to enroll in multiple retail memberships'),
									$author$project$Ui$Form$Group$labelHelp(labelHelp),
									$author$project$Ui$Form$Group$labelClass(''),
									$author$project$Ui$Form$Group$labelSpan(8),
									$author$project$Ui$Form$Group$inputSpan(4)
								]),
							_List_Nil)
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$span(4),
							$author$project$Ui$Grid$justifyRight
						]),
					_List_fromArray(
						[toggleSwitch]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Api$Period$billName = function (_v0) {
	var period = _v0;
	return period.mu;
};
var $author$project$Api$Provider$Plan$Shared$default = function (_v0) {
	var record = _v0;
	return record.PW;
};
var $author$project$Api$Provider$Plan$All$default = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$default(shared);
};
var $elm_community$string_extra$String$Extra$ellipsisWith = F3(
	function (howLong, append, string) {
		return (_Utils_cmp(
			$elm$core$String$length(string),
			howLong) < 1) ? string : _Utils_ap(
			A2(
				$elm$core$String$left,
				howLong - $elm$core$String$length(append),
				string),
			append);
	});
var $elm_community$string_extra$String$Extra$ellipsis = F2(
	function (howLong, string) {
		return A3($elm_community$string_extra$String$Extra$ellipsisWith, howLong, '...', string);
	});
var $author$project$Formatters$String$ellipsis = $elm_community$string_extra$String$Extra$ellipsis;
var $author$project$Api$Provider$Plan$Shared$periods = function (_v0) {
	var record = _v0;
	return A2($elm$core$List$filterMap, $author$project$Api$Period$retrieve, record.Gq);
};
var $author$project$Api$Provider$Plan$All$periods = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$periods(shared);
};
var $elm_community$string_extra$String$Extra$toSentenceBaseCase = function (list) {
	_v0$2:
	while (true) {
		if (list.b) {
			if (!list.b.b) {
				var x = list.a;
				return x;
			} else {
				if (!list.b.b.b) {
					var x = list.a;
					var _v1 = list.b;
					var y = _v1.a;
					return x + (' and ' + y);
				} else {
					break _v0$2;
				}
			}
		} else {
			break _v0$2;
		}
	}
	return '';
};
var $elm_community$string_extra$String$Extra$toSentenceHelper = F3(
	function (lastPart, sentence, list) {
		toSentenceHelper:
		while (true) {
			if (!list.b) {
				return sentence;
			} else {
				if (!list.b.b) {
					var x = list.a;
					return _Utils_ap(
						sentence,
						_Utils_ap(lastPart, x));
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$lastPart = lastPart,
						$temp$sentence = sentence + (', ' + x),
						$temp$list = xs;
					lastPart = $temp$lastPart;
					sentence = $temp$sentence;
					list = $temp$list;
					continue toSentenceHelper;
				}
			}
		}
	});
var $elm_community$string_extra$String$Extra$toSentence = function (list) {
	if ((list.b && list.b.b) && list.b.b.b) {
		var x = list.a;
		var _v1 = list.b;
		var y = _v1.a;
		var _v2 = _v1.b;
		var z = _v2.a;
		var more = _v2.b;
		return A3(
			$elm_community$string_extra$String$Extra$toSentenceHelper,
			' and ',
			x + (', ' + y),
			A2($elm$core$List$cons, z, more));
	} else {
		return $elm_community$string_extra$String$Extra$toSentenceBaseCase(list);
	}
};
var $author$project$Formatters$String$toSentence = $elm_community$string_extra$String$Extra$toSentence;
var $author$project$Api$RateRule$Shared$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$RateRule$Shared$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$Plan$Shared$ageRateRules = function (_v0) {
	var record = _v0;
	return record.Lk;
};
var $author$project$Api$Employer$Plan$All$ageRateRules = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$ageRateRules(shared);
};
var $author$project$Api$Employer$Plan$One$ageRateRules = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$ageRateRules(shared);
};
var $author$project$Api$Provider$Plan$All$ageRateRules = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$ageRateRules(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$ageRateRules = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$ageRateRules(shared);
};
var $author$project$Api$Plan$ageRateRules = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return A2(
				$elm$core$List$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$Shared$ageRateRules(plan_));
		case 1:
			var plan_ = plan.a;
			return A2(
				$elm$core$List$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$SharedWithContractInfo$ageRateRules(plan_));
		case 4:
			var plan_ = plan.a;
			return A2(
				$elm$core$List$map,
				$author$project$Api$RateRule$Shared$Employer,
				$author$project$Api$Employer$Plan$Shared$ageRateRules(plan_));
		case 2:
			var plan_ = plan.a;
			return A2(
				$elm$core$List$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$All$ageRateRules(plan_));
		case 6:
			var plan_ = plan.a;
			return A2(
				$elm$core$List$map,
				$author$project$Api$RateRule$Shared$Employer,
				$author$project$Api$Employer$Plan$All$ageRateRules(plan_));
		case 3:
			var plan_ = plan.a;
			return A2(
				$elm$core$List$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$One$ageRateRules(plan_));
		default:
			var plan_ = plan.a;
			return A2(
				$elm$core$List$map,
				$author$project$Api$RateRule$Shared$Employer,
				$author$project$Api$Employer$Plan$One$ageRateRules(plan_));
	}
};
var $author$project$Api$Employer$Company$One$billAffiliateRate = function (_v0) {
	var record = _v0.b;
	return record.MC;
};
var $author$project$Api$Provider$Company$Shared$billAffiliateRate = function (_v0) {
	var record = _v0;
	return record.MC;
};
var $author$project$Api$Provider$Company$One$billAffiliateRate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$billAffiliateRate(shared);
};
var $author$project$Api$Company$billAffiliateRate = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$billAffiliateRate(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$billAffiliateRate(company_);
	}
};
var $author$project$Api$Network$Shared$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Network$Shared$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$Practice$One$network = function (_v0) {
	var record = _v0;
	return record.Xz;
};
var $author$project$Api$Provider$Practice$One$network = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Xz;
	});
var $author$project$Api$Practice$network = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Network$Shared$Provider,
			$author$project$Api$Provider$Practice$One$network(practice_));
	} else {
		var practice_ = practice.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Network$Shared$Employer,
			$author$project$Api$Employer$Practice$One$network(practice_));
	}
};
var $author$project$Api$Employer$Network$Shared$ratesFromAffiliate = function (_v0) {
	var record = _v0;
	return record._5;
};
var $author$project$Api$Provider$Network$Shared$ratesFromAffiliate = function (_v0) {
	var record = _v0;
	return record._5;
};
var $author$project$Api$Network$Shared$ratesFromAffiliate = function (network) {
	if (!network.$) {
		var network_ = network.a;
		return $author$project$Api$Provider$Network$Shared$ratesFromAffiliate(network_);
	} else {
		var network_ = network.a;
		return $author$project$Api$Employer$Network$Shared$ratesFromAffiliate(network_);
	}
};
var $author$project$Components$Plan$Summary$Pricing$billAffiliateRate = F2(
	function (practice, company) {
		var network = A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Maybe$Nothing,
			A2($elm$core$Maybe$map, $author$project$Api$Practice$network, practice));
		var ratesFromAffiliate = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, $author$project$Api$Network$Shared$ratesFromAffiliate, network));
		var billAffiliateRateCompanySetting = function () {
			if (!company.$) {
				var company_ = company.a;
				return $author$project$Api$Company$billAffiliateRate(company_);
			} else {
				return false;
			}
		}();
		return ratesFromAffiliate && billAffiliateRateCompanySetting;
	});
var $author$project$Api$Employer$Plan$Shared$coupleRateRule = function (_v0) {
	var record = _v0;
	return record.ON;
};
var $author$project$Api$Employer$Plan$All$coupleRateRule = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$coupleRateRule(shared);
};
var $author$project$Api$Employer$Plan$One$coupleRateRule = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$coupleRateRule(shared);
};
var $author$project$Api$Provider$Plan$All$coupleRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$coupleRateRule(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$coupleRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$coupleRateRule(shared);
};
var $author$project$Api$Plan$coupleRateRule = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$Shared$coupleRateRule(plan_));
		case 1:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$SharedWithContractInfo$coupleRateRule(plan_));
		case 4:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Employer,
				$author$project$Api$Employer$Plan$Shared$coupleRateRule(plan_));
		case 2:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$All$coupleRateRule(plan_));
		case 6:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Employer,
				$author$project$Api$Employer$Plan$All$coupleRateRule(plan_));
		case 3:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$One$coupleRateRule(plan_));
		default:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Employer,
				$author$project$Api$Employer$Plan$One$coupleRateRule(plan_));
	}
};
var $author$project$Api$Employer$Plan$Shared$familyRateRule = function (_v0) {
	var record = _v0;
	return record.R9;
};
var $author$project$Api$Employer$Plan$All$familyRateRule = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$familyRateRule(shared);
};
var $author$project$Api$Employer$Plan$One$familyRateRule = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$familyRateRule(shared);
};
var $author$project$Api$Provider$Plan$All$familyRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$familyRateRule(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$familyRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$familyRateRule(shared);
};
var $author$project$Api$Plan$familyRateRule = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$Shared$familyRateRule(plan_));
		case 1:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$SharedWithContractInfo$familyRateRule(plan_));
		case 4:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Employer,
				$author$project$Api$Employer$Plan$Shared$familyRateRule(plan_));
		case 2:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$All$familyRateRule(plan_));
		case 6:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Employer,
				$author$project$Api$Employer$Plan$All$familyRateRule(plan_));
		case 3:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$One$familyRateRule(plan_));
		default:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Employer,
				$author$project$Api$Employer$Plan$One$familyRateRule(plan_));
	}
};
var $author$project$Api$Employer$Plan$Shared$familyWithSingleChildRateRule = function (_v0) {
	var record = _v0;
	return record.Sb;
};
var $author$project$Api$Employer$Plan$All$familyWithSingleChildRateRule = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$familyWithSingleChildRateRule(shared);
};
var $author$project$Api$Employer$Plan$One$familyWithSingleChildRateRule = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$familyWithSingleChildRateRule(shared);
};
var $author$project$Api$Provider$Plan$All$familyWithSingleChildRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$familyWithSingleChildRateRule(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$familyWithSingleChildRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$familyWithSingleChildRateRule(shared);
};
var $author$project$Api$Plan$familyWithSingleChildRateRule = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$Shared$familyWithSingleChildRateRule(plan_));
		case 1:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$SharedWithContractInfo$familyWithSingleChildRateRule(plan_));
		case 4:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Employer,
				$author$project$Api$Employer$Plan$Shared$familyWithSingleChildRateRule(plan_));
		case 2:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$All$familyWithSingleChildRateRule(plan_));
		case 6:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Employer,
				$author$project$Api$Employer$Plan$All$familyWithSingleChildRateRule(plan_));
		case 3:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$One$familyWithSingleChildRateRule(plan_));
		default:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Employer,
				$author$project$Api$Employer$Plan$One$familyWithSingleChildRateRule(plan_));
	}
};
var $author$project$Api$Employer$Plan$Shared$familyWithSingleChildRateRuleEnabled = function (_v0) {
	var record = _v0;
	return record.Sc;
};
var $author$project$Api$Employer$Plan$All$familyWithSingleChildRateRuleEnabled = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$familyWithSingleChildRateRuleEnabled(shared);
};
var $author$project$Api$Employer$Plan$One$familyWithSingleChildRateRuleEnabled = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$familyWithSingleChildRateRuleEnabled(shared);
};
var $author$project$Api$Provider$Plan$All$familyWithSingleChildRateRuleEnabled = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$familyWithSingleChildRateRuleEnabled(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$familyWithSingleChildRateRuleEnabled = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$familyWithSingleChildRateRuleEnabled(shared);
};
var $author$project$Api$Plan$familyWithSingleChildRateRuleEnabled = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$Shared$familyWithSingleChildRateRuleEnabled(plan_);
		case 1:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$SharedWithContractInfo$familyWithSingleChildRateRuleEnabled(plan_);
		case 4:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$Shared$familyWithSingleChildRateRuleEnabled(plan_);
		case 2:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$All$familyWithSingleChildRateRuleEnabled(plan_);
		case 6:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$All$familyWithSingleChildRateRuleEnabled(plan_);
		case 3:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$One$familyWithSingleChildRateRuleEnabled(plan_);
		default:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$One$familyWithSingleChildRateRuleEnabled(plan_);
	}
};
var $author$project$Api$Employer$Plan$Shared$groupPricingType = function (_v0) {
	var record = _v0;
	return record.S1;
};
var $author$project$Api$Employer$Plan$All$groupPricingType = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$groupPricingType(shared);
};
var $author$project$Api$Employer$Plan$One$groupPricingType = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$groupPricingType(shared);
};
var $author$project$Api$Provider$Plan$All$groupPricingType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$groupPricingType(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$groupPricingType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$groupPricingType(shared);
};
var $author$project$Api$Plan$groupPricingType = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$Shared$groupPricingType(plan_);
		case 1:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$SharedWithContractInfo$groupPricingType(plan_);
		case 4:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$Shared$groupPricingType(plan_);
		case 2:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$All$groupPricingType(plan_);
		case 6:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$All$groupPricingType(plan_);
		case 3:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$One$groupPricingType(plan_);
		default:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$One$groupPricingType(plan_);
	}
};
var $author$project$Api$Provider$Plan$Shared$discountRules = function (_v0) {
	var record = _v0;
	return record.QG;
};
var $author$project$Api$Provider$Plan$All$discountRules = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$discountRules(shared);
};
var $author$project$Api$Provider$Plan$One$discountRules = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$discountRules(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$discountRules = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$discountRules(shared);
};
var $author$project$Api$Plan$hasDiscountRules = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return !$elm$core$List$isEmpty(
				$author$project$Api$Provider$Plan$Shared$discountRules(plan_));
		case 1:
			var plan_ = plan.a;
			return !$elm$core$List$isEmpty(
				$author$project$Api$Provider$Plan$SharedWithContractInfo$discountRules(plan_));
		case 4:
			return false;
		case 2:
			var plan_ = plan.a;
			return !$elm$core$List$isEmpty(
				$author$project$Api$Provider$Plan$All$discountRules(plan_));
		case 6:
			return false;
		case 3:
			var plan_ = plan.a;
			return !$elm$core$List$isEmpty(
				$author$project$Api$Provider$Plan$One$discountRules(plan_));
		default:
			return false;
	}
};
var $author$project$Api$Plan$hasSpecialRates = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return !$elm$core$List$isEmpty(
				$author$project$Api$Provider$Plan$Shared$specialRates(plan_));
		case 1:
			var plan_ = plan.a;
			return !$elm$core$List$isEmpty(
				$author$project$Api$Provider$Plan$SharedWithContractInfo$specialRates(plan_));
		case 4:
			return false;
		case 2:
			var plan_ = plan.a;
			return !$elm$core$List$isEmpty(
				$author$project$Api$Provider$Plan$All$specialRates(plan_));
		case 6:
			return false;
		case 3:
			var plan_ = plan.a;
			return !$elm$core$List$isEmpty(
				$author$project$Api$Provider$Plan$One$specialRates(plan_));
		default:
			return false;
	}
};
var $author$project$Api$Employer$Plan$Shared$individualRateRule = function (_v0) {
	var record = _v0;
	return record.TX;
};
var $author$project$Api$Employer$Plan$All$individualRateRule = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$individualRateRule(shared);
};
var $author$project$Api$Employer$Plan$One$individualRateRule = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$individualRateRule(shared);
};
var $author$project$Api$Provider$Plan$All$individualRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$individualRateRule(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$individualRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$individualRateRule(shared);
};
var $author$project$Api$Plan$individualRateRule = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$Shared$individualRateRule(plan_));
		case 1:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$SharedWithContractInfo$individualRateRule(plan_));
		case 4:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Employer,
				$author$project$Api$Employer$Plan$Shared$individualRateRule(plan_));
		case 2:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$All$individualRateRule(plan_));
		case 6:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Employer,
				$author$project$Api$Employer$Plan$All$individualRateRule(plan_));
		case 3:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$One$individualRateRule(plan_));
		default:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Employer,
				$author$project$Api$Employer$Plan$One$individualRateRule(plan_));
	}
};
var $author$project$Api$Employer$Plan$Shared$individualRegistrationFeeInCents = function (_v0) {
	var record = _v0;
	return record.TZ;
};
var $author$project$Api$Employer$Plan$All$individualRegistrationFeeInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$individualRegistrationFeeInCents(shared);
};
var $author$project$Api$Employer$Plan$One$individualRegistrationFeeInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$individualRegistrationFeeInCents(shared);
};
var $author$project$Api$Provider$Plan$All$individualRegistrationFeeInCents = function (_v0) {
	var record = _v0.b;
	return record.TZ;
};
var $author$project$Api$Plan$individualRegistrationFeeInCents = function (plan) {
	switch (plan.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Nothing;
		case 4:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$Shared$individualRegistrationFeeInCents(plan_);
		case 2:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$All$individualRegistrationFeeInCents(plan_);
		case 6:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$All$individualRegistrationFeeInCents(plan_);
		case 3:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$One$individualRegistrationFeeInCents(plan_);
		default:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$One$individualRegistrationFeeInCents(plan_);
	}
};
var $author$project$Api$Employer$Plan$Shared$maxRegistrationFeeInCents = function (_v0) {
	var record = _v0;
	return record.WC;
};
var $author$project$Api$Employer$Plan$All$maxRegistrationFeeInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$maxRegistrationFeeInCents(shared);
};
var $author$project$Api$Employer$Plan$One$maxRegistrationFeeInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$maxRegistrationFeeInCents(shared);
};
var $author$project$Api$Provider$Plan$All$maxRegistrationFeeInCents = function (_v0) {
	var record = _v0.b;
	return record.WC;
};
var $author$project$Api$Plan$maxRegistrationFeeInCents = function (plan) {
	switch (plan.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Nothing;
		case 4:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$Shared$maxRegistrationFeeInCents(plan_);
		case 2:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$All$maxRegistrationFeeInCents(plan_);
		case 6:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$All$maxRegistrationFeeInCents(plan_);
		case 3:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$One$maxRegistrationFeeInCents(plan_);
		default:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$One$maxRegistrationFeeInCents(plan_);
	}
};
var $author$project$Api$Employer$Plan$Shared$periods = function (_v0) {
	var record = _v0;
	return A2($elm$core$List$filterMap, $author$project$Api$Period$retrieve, record.Gq);
};
var $author$project$Api$Employer$Plan$All$periods = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$periods(shared);
};
var $author$project$Api$Employer$Plan$One$periods = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$periods(shared);
};
var $author$project$Api$Provider$Plan$One$periods = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$periods(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$periods = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$periods(shared);
};
var $author$project$Api$Plan$periods = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$Shared$periods(plan_);
		case 1:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$SharedWithContractInfo$periods(plan_);
		case 4:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$Shared$periods(plan_);
		case 2:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$All$periods(plan_);
		case 6:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$All$periods(plan_);
		case 3:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$One$periods(plan_);
		default:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$One$periods(plan_);
	}
};
var $author$project$Api$Employer$Plan$Shared$planType = function (_v0) {
	var record = _v0;
	return record.ZF;
};
var $author$project$Api$Employer$Plan$All$planType = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$planType(shared);
};
var $author$project$Api$Employer$Plan$One$planType = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$planType(shared);
};
var $author$project$Api$Provider$Plan$All$planType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$planType(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$planType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$planType(shared);
};
var $author$project$Api$Plan$planType = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$Shared$planType(plan_);
		case 1:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$SharedWithContractInfo$planType(plan_);
		case 4:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$Shared$planType(plan_);
		case 2:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$All$planType(plan_);
		case 6:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$All$planType(plan_);
		case 3:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$One$planType(plan_);
		default:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$One$planType(plan_);
	}
};
var $author$project$Api$Period$rateName = function (_v0) {
	var period = _v0;
	return period.pv;
};
var $author$project$Api$Employer$Plan$Shared$singleParentRateRule = function (_v0) {
	var record = _v0;
	return record.abC;
};
var $author$project$Api$Employer$Plan$All$singleParentRateRule = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$singleParentRateRule(shared);
};
var $author$project$Api$Employer$Plan$One$singleParentRateRule = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$singleParentRateRule(shared);
};
var $author$project$Api$Provider$Plan$All$singleParentRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$singleParentRateRule(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$singleParentRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$singleParentRateRule(shared);
};
var $author$project$Api$Plan$singleParentRateRule = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$Shared$singleParentRateRule(plan_));
		case 1:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$SharedWithContractInfo$singleParentRateRule(plan_));
		case 4:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Employer,
				$author$project$Api$Employer$Plan$Shared$singleParentRateRule(plan_));
		case 2:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$All$singleParentRateRule(plan_));
		case 6:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Employer,
				$author$project$Api$Employer$Plan$All$singleParentRateRule(plan_));
		case 3:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$One$singleParentRateRule(plan_));
		default:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Employer,
				$author$project$Api$Employer$Plan$One$singleParentRateRule(plan_));
	}
};
var $author$project$Api$Employer$Plan$Shared$singleParentWithSingleChildRateRule = function (_v0) {
	var record = _v0;
	return record.abE;
};
var $author$project$Api$Employer$Plan$All$singleParentWithSingleChildRateRule = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$singleParentWithSingleChildRateRule(shared);
};
var $author$project$Api$Employer$Plan$One$singleParentWithSingleChildRateRule = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$singleParentWithSingleChildRateRule(shared);
};
var $author$project$Api$Provider$Plan$All$singleParentWithSingleChildRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$singleParentWithSingleChildRateRule(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$singleParentWithSingleChildRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$singleParentWithSingleChildRateRule(shared);
};
var $author$project$Api$Plan$singleParentWithSingleChildRateRule = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$Shared$singleParentWithSingleChildRateRule(plan_));
		case 1:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$SharedWithContractInfo$singleParentWithSingleChildRateRule(plan_));
		case 4:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Employer,
				$author$project$Api$Employer$Plan$Shared$singleParentWithSingleChildRateRule(plan_));
		case 2:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$All$singleParentWithSingleChildRateRule(plan_));
		case 6:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Employer,
				$author$project$Api$Employer$Plan$All$singleParentWithSingleChildRateRule(plan_));
		case 3:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$One$singleParentWithSingleChildRateRule(plan_));
		default:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Employer,
				$author$project$Api$Employer$Plan$One$singleParentWithSingleChildRateRule(plan_));
	}
};
var $author$project$Api$Employer$Plan$Shared$singleParentWithSingleChildRateRuleEnabled = function (_v0) {
	var record = _v0;
	return record.abF;
};
var $author$project$Api$Employer$Plan$All$singleParentWithSingleChildRateRuleEnabled = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$singleParentWithSingleChildRateRuleEnabled(shared);
};
var $author$project$Api$Employer$Plan$One$singleParentWithSingleChildRateRuleEnabled = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$singleParentWithSingleChildRateRuleEnabled(shared);
};
var $author$project$Api$Provider$Plan$All$singleParentWithSingleChildRateRuleEnabled = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$singleParentWithSingleChildRateRuleEnabled(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$singleParentWithSingleChildRateRuleEnabled = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$singleParentWithSingleChildRateRuleEnabled(shared);
};
var $author$project$Api$Plan$singleParentWithSingleChildRateRuleEnabled = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$Shared$singleParentWithSingleChildRateRuleEnabled(plan_);
		case 1:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$SharedWithContractInfo$singleParentWithSingleChildRateRuleEnabled(plan_);
		case 4:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$Shared$singleParentWithSingleChildRateRuleEnabled(plan_);
		case 2:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$All$singleParentWithSingleChildRateRuleEnabled(plan_);
		case 6:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$All$singleParentWithSingleChildRateRuleEnabled(plan_);
		case 3:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$One$singleParentWithSingleChildRateRuleEnabled(plan_);
		default:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$One$singleParentWithSingleChildRateRuleEnabled(plan_);
	}
};
var $author$project$Api$Provider$PricingStructure$Shared$fixedAmountInCents = function (_v0) {
	var record = _v0;
	return record.ahn;
};
var $author$project$Api$PricingStructure$fixedAmountInCents = function (pricingStructure) {
	var pricingStructure_ = pricingStructure;
	return $author$project$Api$Provider$PricingStructure$Shared$fixedAmountInCents(pricingStructure_);
};
var $author$project$Api$Provider$PricingStructure$Shared$percentage = function (_v0) {
	var record = _v0;
	return record.ajZ;
};
var $author$project$Api$PricingStructure$percentage = function (pricingStructure) {
	var pricingStructure_ = pricingStructure;
	return $author$project$Api$Provider$PricingStructure$Shared$percentage(pricingStructure_);
};
var $author$project$Api$PricingStructure$ProviderShared = $elm$core$Basics$identity;
var $author$project$Api$Provider$Plan$Shared$pricingFrom = function (_v0) {
	var record = _v0;
	return record._k;
};
var $author$project$Api$Provider$Plan$All$pricingFrom = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$pricingFrom(shared);
};
var $author$project$Api$Provider$Plan$One$pricingFrom = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$pricingFrom(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$pricingFrom = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$pricingFrom(shared);
};
var $author$project$Api$Plan$pricingFrom = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$identity,
				$author$project$Api$Provider$Plan$Shared$pricingFrom(plan_));
		case 1:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$identity,
				$author$project$Api$Provider$Plan$SharedWithContractInfo$pricingFrom(plan_));
		case 4:
			return $elm$core$Maybe$Nothing;
		case 2:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$identity,
				$author$project$Api$Provider$Plan$All$pricingFrom(plan_));
		case 6:
			return $elm$core$Maybe$Nothing;
		case 3:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$identity,
				$author$project$Api$Provider$Plan$One$pricingFrom(plan_));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Plan$Summary$Percentage$view = function (plan) {
	var pricingFrom = $author$project$Api$Plan$pricingFrom(plan);
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Typography$text,
			_List_Nil,
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeR, $author$project$Api$PricingStructure$percentage, $author$project$Formatters$Float$toPercentage),
					pricingFrom))),
			function () {
			var _v0 = A2($elm$core$Maybe$map, $author$project$Api$PricingStructure$fixedAmountInCents, pricingFrom);
			if (!_v0.$) {
				var fixedAmountInCents = _v0.a;
				return A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							(fixedAmountInCents >= 0) ? $elm$html$Html$text(' + ') : $elm$html$Html$text(' - '),
							$elm$html$Html$text(
							$author$project$Utils$Currency$fromInt(
								$elm$core$Basics$abs(fixedAmountInCents)))
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			A2(
			$author$project$Ui$Typography$text,
			_List_fromArray(
				[$author$project$Ui$Typography$muted]),
			' per member')
		]);
};
var $author$project$Api$Employer$SponsorFeeDeal$Shared$amountInCents = function (_v0) {
	var record = _v0;
	return record.LE;
};
var $author$project$Api$SponsorFeeDeal$Shared$amountInCents = function (sponsorFeeDeal) {
	if (!sponsorFeeDeal.$) {
		var sponsorFeeDeal_ = sponsorFeeDeal.a;
		return $author$project$Api$Provider$SponsorFeeDeal$Shared$amountInCents(sponsorFeeDeal_);
	} else {
		var sponsorFeeDeal_ = sponsorFeeDeal.a;
		return $author$project$Api$Employer$SponsorFeeDeal$Shared$amountInCents(sponsorFeeDeal_);
	}
};
var $author$project$Api$SponsorFeeDeal$Shared$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$SponsorFeeDeal$Shared$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$Plan$Shared$sponsorFeeDeal = function (_v0) {
	var record = _v0;
	return record.abZ;
};
var $author$project$Api$Employer$Plan$All$sponsorFeeDeal = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$sponsorFeeDeal(shared);
};
var $author$project$Api$Employer$Plan$One$sponsorFeeDeal = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$sponsorFeeDeal(shared);
};
var $author$project$Api$Provider$Plan$All$sponsorFeeDeal = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$sponsorFeeDeal(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$sponsorFeeDeal = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$sponsorFeeDeal(shared);
};
var $author$project$Api$Plan$sponsorFeeDeal = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$SponsorFeeDeal$Shared$Provider,
				$author$project$Api$Provider$Plan$Shared$sponsorFeeDeal(plan_));
		case 1:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$SponsorFeeDeal$Shared$Provider,
				$author$project$Api$Provider$Plan$SharedWithContractInfo$sponsorFeeDeal(plan_));
		case 4:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$SponsorFeeDeal$Shared$Employer,
				$author$project$Api$Employer$Plan$Shared$sponsorFeeDeal(plan_));
		case 2:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$SponsorFeeDeal$Shared$Provider,
				$author$project$Api$Provider$Plan$All$sponsorFeeDeal(plan_));
		case 6:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$SponsorFeeDeal$Shared$Employer,
				$author$project$Api$Employer$Plan$All$sponsorFeeDeal(plan_));
		case 3:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$SponsorFeeDeal$Shared$Provider,
				$author$project$Api$Provider$Plan$One$sponsorFeeDeal(plan_));
		default:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$SponsorFeeDeal$Shared$Employer,
				$author$project$Api$Employer$Plan$One$sponsorFeeDeal(plan_));
	}
};
var $author$project$Components$Plan$Summary$SponsorFeeDeal$view = F2(
	function (companyPricing, plan) {
		var fixedFee = A2(
			$author$project$Ui$Typography$p,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$strong,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Fixed Fee')
						]))
				]));
		return _List_fromArray(
			[
				companyPricing ? A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(5)
							]),
						_List_fromArray(
							[fixedFee]))
					])) : fixedFee,
				A2(
				$author$project$Ui$Typography$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeR, $author$project$Api$SponsorFeeDeal$Shared$amountInCents, $author$project$Utils$Currency$fromInt),
								$author$project$Api$Plan$sponsorFeeDeal(plan))))
					]))
			]);
	});
var $author$project$Formatters$Int$ageRangeMonths = F2(
	function (fromAge, toAge) {
		if (_Utils_eq(
			$elm$core$Maybe$Just(fromAge),
			toAge)) {
			return (!fromAge) ? 'First month' : ($elm$core$String$fromInt(fromAge) + ' months');
		} else {
			if ((!fromAge) && _Utils_eq(toAge, $elm$core$Maybe$Nothing)) {
				return 'All ages';
			} else {
				var ageRange_ = (!fromAge) ? 'Birth' : (((fromAge === 1) && _Utils_eq(toAge, $elm$core$Maybe$Nothing)) ? ($elm$core$String$fromInt(fromAge) + ' month') : ($elm$core$String$fromInt(fromAge) + ' months'));
				if (!toAge.$) {
					var toAge_ = toAge.a;
					return ageRange_ + (' to ' + ($elm$core$String$fromInt(toAge_) + ' months'));
				} else {
					return ageRange_ + ' and up';
				}
			}
		}
	});
var $author$project$Formatters$Int$ageRangeYears = F2(
	function (fromAge, toAge) {
		if (_Utils_eq(
			$elm$core$Maybe$Just(fromAge),
			toAge)) {
			return (!fromAge) ? 'First year' : ('Age ' + $elm$core$String$fromInt(fromAge));
		} else {
			if ((!fromAge) && _Utils_eq(toAge, $elm$core$Maybe$Nothing)) {
				return 'All ages';
			} else {
				var ageRange_ = (!fromAge) ? 'Birth' : (((fromAge === 1) && _Utils_eq(toAge, $elm$core$Maybe$Nothing)) ? ('Age ' + $elm$core$String$fromInt(fromAge)) : ('Ages ' + $elm$core$String$fromInt(fromAge)));
				if (!toAge.$) {
					var toAge_ = toAge.a;
					return ageRange_ + (' to ' + $elm$core$String$fromInt(toAge_));
				} else {
					return ageRange_ + ' and up';
				}
			}
		}
	});
var $author$project$Formatters$Int$ageRange = F3(
	function (fromAge, toAge, unit) {
		if (!unit) {
			return A2($author$project$Formatters$Int$ageRangeYears, fromAge, toAge);
		} else {
			return A2($author$project$Formatters$Int$ageRangeMonths, fromAge, toAge);
		}
	});
var $author$project$Api$Employer$Plan$Shared$allowedBillingPeriodCodes = function (_v0) {
	var record = _v0;
	return record.Gq;
};
var $author$project$Api$Employer$Plan$All$allowedBillingPeriodCodes = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$allowedBillingPeriodCodes(shared);
};
var $author$project$Api$Employer$Plan$One$allowedBillingPeriodCodes = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$allowedBillingPeriodCodes(shared);
};
var $author$project$Api$Provider$Plan$Shared$allowedBillingPeriodCodes = function (_v0) {
	var record = _v0;
	return record.Gq;
};
var $author$project$Api$Provider$Plan$All$allowedBillingPeriodCodes = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$allowedBillingPeriodCodes(shared);
};
var $author$project$Api$Provider$Plan$One$allowedBillingPeriodCodes = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$allowedBillingPeriodCodes(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$allowedBillingPeriodCodes = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$allowedBillingPeriodCodes(shared);
};
var $author$project$Api$Plan$allowedBillingPeriodCodes = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$Shared$allowedBillingPeriodCodes(plan_);
		case 1:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$SharedWithContractInfo$allowedBillingPeriodCodes(plan_);
		case 4:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$Shared$allowedBillingPeriodCodes(plan_);
		case 2:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$All$allowedBillingPeriodCodes(plan_);
		case 6:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$All$allowedBillingPeriodCodes(plan_);
		case 3:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$One$allowedBillingPeriodCodes(plan_);
		default:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$One$allowedBillingPeriodCodes(plan_);
	}
};
var $author$project$Api$Employer$RateRule$Shared$annualAmountInCents = function (_v0) {
	var record = _v0;
	return record.LH;
};
var $author$project$Api$RateRule$Shared$annualAmountInCents = function (rateRule) {
	if (!rateRule.$) {
		var rateRule_ = rateRule.a;
		return $author$project$Api$Provider$RateRule$Shared$annualAmountInCents(rateRule_);
	} else {
		var rateRule_ = rateRule.a;
		return $author$project$Api$Employer$RateRule$Shared$annualAmountInCents(rateRule_);
	}
};
var $author$project$Api$Employer$RateRule$Shared$monthAmountInCents = function (_v0) {
	var record = _v0;
	return record.Xk;
};
var $author$project$Api$RateRule$Shared$monthAmountInCents = function (rateRule) {
	if (!rateRule.$) {
		var rateRule_ = rateRule.a;
		return $author$project$Api$Provider$RateRule$Shared$monthAmountInCents(rateRule_);
	} else {
		var rateRule_ = rateRule.a;
		return $author$project$Api$Employer$RateRule$Shared$monthAmountInCents(rateRule_);
	}
};
var $author$project$Api$Employer$RateRule$Shared$quarterAmountInCents = function (_v0) {
	var record = _v0;
	return record._Q;
};
var $author$project$Api$RateRule$Shared$quarterAmountInCents = function (rateRule) {
	if (!rateRule.$) {
		var rateRule_ = rateRule.a;
		return $author$project$Api$Provider$RateRule$Shared$quarterAmountInCents(rateRule_);
	} else {
		var rateRule_ = rateRule.a;
		return $author$project$Api$Employer$RateRule$Shared$quarterAmountInCents(rateRule_);
	}
};
var $author$project$Api$Employer$RateRule$Shared$semiAnnualAmountInCents = function (_v0) {
	var record = _v0;
	return record.aaJ;
};
var $author$project$Api$RateRule$Shared$semiAnnualAmountInCents = function (rateRule) {
	if (!rateRule.$) {
		var rateRule_ = rateRule.a;
		return $author$project$Api$Provider$RateRule$Shared$semiAnnualAmountInCents(rateRule_);
	} else {
		var rateRule_ = rateRule.a;
		return $author$project$Api$Employer$RateRule$Shared$semiAnnualAmountInCents(rateRule_);
	}
};
var $author$project$Components$Plan$Summary$Pricing$amountForPeriodCode = F2(
	function (ageRateRule, code) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			function () {
				switch (code) {
					case 'month':
						return $author$project$Api$RateRule$Shared$monthAmountInCents(ageRateRule);
					case 'quarter':
						return $author$project$Api$RateRule$Shared$quarterAmountInCents(ageRateRule);
					case 'semi_annual':
						return $author$project$Api$RateRule$Shared$semiAnnualAmountInCents(ageRateRule);
					case 'annual':
						return $author$project$Api$RateRule$Shared$annualAmountInCents(ageRateRule);
					default:
						return $elm$core$Maybe$Nothing;
				}
			}());
	});
var $author$project$Api$Period$code = function (_v0) {
	var period = _v0;
	return period.NN;
};
var $author$project$Api$Employer$RateRule$Shared$fromAge = function (_v0) {
	var record = _v0;
	return record.SK;
};
var $author$project$Api$RateRule$Shared$fromAge = function (rateRule) {
	if (!rateRule.$) {
		var rateRule_ = rateRule.a;
		return $author$project$Api$Provider$RateRule$Shared$fromAge(rateRule_);
	} else {
		var rateRule_ = rateRule.a;
		return $author$project$Api$Employer$RateRule$Shared$fromAge(rateRule_);
	}
};
var $author$project$Api$Employer$Plan$Shared$period = function (_v0) {
	var record = _v0;
	return $author$project$Api$Period$retrieve(record.P6);
};
var $author$project$Api$Employer$Plan$All$period = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$period(shared);
};
var $author$project$Api$Employer$Plan$One$period = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$period(shared);
};
var $author$project$Api$Provider$Plan$All$period = function (_v0) {
	var record = _v0.b;
	return $author$project$Api$Period$retrieve(record.P6);
};
var $author$project$Api$Provider$Plan$One$period = function (_v0) {
	var record = _v0.b;
	return $author$project$Api$Period$retrieve(record.P6);
};
var $author$project$Api$Plan$period = function (plan) {
	switch (plan.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Nothing;
		case 4:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$Shared$period(plan_);
		case 2:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$All$period(plan_);
		case 6:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$All$period(plan_);
		case 3:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$One$period(plan_);
		default:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$One$period(plan_);
	}
};
var $author$project$Api$Employer$RateRule$Shared$toAge = function (_v0) {
	var record = _v0;
	return record.adb;
};
var $author$project$Api$RateRule$Shared$toAge = function (rateRule) {
	if (!rateRule.$) {
		var rateRule_ = rateRule.a;
		return $author$project$Api$Provider$RateRule$Shared$toAge(rateRule_);
	} else {
		var rateRule_ = rateRule.a;
		return $author$project$Api$Employer$RateRule$Shared$toAge(rateRule_);
	}
};
var $author$project$Api$Employer$RateRule$Shared$unit = function (_v0) {
	var record = _v0;
	return record.adL;
};
var $author$project$Api$RateRule$Shared$unit = function (rateRule) {
	if (!rateRule.$) {
		var rateRule_ = rateRule.a;
		return $author$project$Api$Provider$RateRule$Shared$unit(rateRule_);
	} else {
		var rateRule_ = rateRule.a;
		return $author$project$Api$Employer$RateRule$Shared$unit(rateRule_);
	}
};
var $author$project$Components$Plan$Summary$Pricing$viewAgeRateRule = F2(
	function (plan, ageRateRule) {
		return A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$span(8)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A3(
								$author$project$Formatters$Int$ageRange,
								$author$project$Api$RateRule$Shared$fromAge(ageRateRule),
								$author$project$Api$RateRule$Shared$toAge(ageRateRule),
								$author$project$Api$RateRule$Shared$unit(ageRateRule)))
						])),
					function () {
					var _v0 = _Utils_Tuple2(
						$author$project$Api$Plan$period(plan),
						$elm$core$List$head(
							$author$project$Api$Plan$allowedBillingPeriodCodes(plan)));
					if (!_v0.a.$) {
						var period = _v0.a.a;
						var amountInCents = A2(
							$author$project$Components$Plan$Summary$Pricing$amountForPeriodCode,
							ageRateRule,
							$author$project$Api$Period$code(period));
						return A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(4)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('numeric')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Utils$Currency$fromInt(amountInCents))
										]))
								]));
					} else {
						if (!_v0.b.$) {
							var _v1 = _v0.a;
							var allowedBillingPeriodCode = _v0.b.a;
							var amountInCents = A2($author$project$Components$Plan$Summary$Pricing$amountForPeriodCode, ageRateRule, allowedBillingPeriodCode);
							return A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$span(4)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('numeric')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Utils$Currency$fromInt(amountInCents))
											]))
									]));
						} else {
							var _v2 = _v0.a;
							var _v3 = _v0.b;
							return $author$project$Ui$Grid$none;
						}
					}
				}()
				]));
	});
var $author$project$Api$Employer$RateRule$Shared$type_ = function (_v0) {
	var record = _v0;
	return record.amg;
};
var $author$project$Api$Provider$RateRule$Shared$type_ = function (_v0) {
	var record = _v0;
	return record.amg;
};
var $author$project$Api$RateRule$Shared$type_ = function (rateRule) {
	if (!rateRule.$) {
		var rateRule_ = rateRule.a;
		return $author$project$Api$Provider$RateRule$Shared$type_(rateRule_);
	} else {
		var rateRule_ = rateRule.a;
		return $author$project$Api$Employer$RateRule$Shared$type_(rateRule_);
	}
};
var $author$project$Components$Plan$Summary$Pricing$viewGroupTierPricingRule = F2(
	function (retailPlan, rateRule) {
		return A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$span(8)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									$author$project$Utils$RateRule$groupTierName,
									A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$type_, rateRule)))),
							$author$project$Utils$Html$noBreakSpace,
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-label-md text-muted')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											$author$project$Utils$RateRule$groupTierCode(retailPlan),
											A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$type_, rateRule))))
								]))
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$span(4)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('numeric')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(
										A2(
											$elm$core$Maybe$withDefault,
											0,
											A2($elm$core$Maybe$andThen, $author$project$Api$RateRule$Shared$monthAmountInCents, rateRule))))
								]))
						]))
				]));
	});
var $author$project$Components$Plan$Summary$Pricing$viewRegistrationFee = F2(
	function (individualRegistrationFeeInCents, maxRegistrationFeeInCents) {
		var hasMaxRegistrationFeeInCents = $author$project$Utils$Maybe$toBool(maxRegistrationFeeInCents);
		var hasIndividualRegistrationFeeInCents = $author$project$Utils$Maybe$toBool(individualRegistrationFeeInCents);
		return (hasIndividualRegistrationFeeInCents || hasMaxRegistrationFeeInCents) ? A2(
			$author$project$Ui$Typography$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Registration Fees: '),
					function () {
					if (!individualRegistrationFeeInCents.$) {
						var individualRegistrationFeeInCents_ = individualRegistrationFeeInCents.a;
						return A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(individualRegistrationFeeInCents_)),
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$muted]),
									' per individual')
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					(hasIndividualRegistrationFeeInCents && hasMaxRegistrationFeeInCents) ? $elm$html$Html$text(' or ') : $author$project$Utils$Html$empty,
					function () {
					if (!maxRegistrationFeeInCents.$) {
						var maxRegistrationFeeInCents_ = maxRegistrationFeeInCents.a;
						return A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(maxRegistrationFeeInCents_)),
									$elm$html$Html$text(' Max')
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Components$Plan$Summary$Pricing$view = F3(
	function (plan, practice, company) {
		var _v0 = $author$project$Api$Plan$planType(plan);
		switch (_v0) {
			case 4:
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					$elm$core$List$concat(
						_List_fromArray(
							[
								_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Percentage Retainer Pricing')
												]))
										]))
								]),
								$author$project$Components$Plan$Summary$Percentage$view(plan)
							])));
			case 1:
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					A2($author$project$Components$Plan$Summary$SponsorFeeDeal$view, false, plan));
			default:
				var showbillAffiliateRateText = A2($author$project$Components$Plan$Summary$Pricing$billAffiliateRate, practice, company);
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							if ($author$project$Api$Plan$groupPricingType(plan) !== 'fixed_pricing') {
								var ageRateRules = $author$project$Api$Plan$ageRateRules(plan);
								return A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									$elm$core$List$concat(
										_List_fromArray(
											[
												_List_fromArray(
												[
													($elm$core$List$length(ageRateRules) > 1) ? A2(
													$author$project$Ui$Grid$row,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Grid$column,
															_List_fromArray(
																[
																	$author$project$Ui$Grid$span(8)
																]),
															_List_fromArray(
																[
																	A2(
																	$author$project$Ui$Typography$strong,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			A2(
																				$elm$core$Maybe$withDefault,
																				'',
																				A2(
																					$elm$core$Maybe$map,
																					A2($elm$core$Basics$composeR, $author$project$Api$Period$rateName, $author$project$Formatters$String$titleize),
																					$elm$core$List$head(
																						$author$project$Api$Plan$periods(plan))))),
																			$elm$html$Html$text(' Age Based Pricing')
																		]))
																])),
															showbillAffiliateRateText ? A2(
															$author$project$Ui$Grid$column,
															_List_fromArray(
																[
																	$author$project$Ui$Grid$span(4)
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('numeric')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Will be billed the affiliate rate')
																		]))
																])) : A2(
															$author$project$Ui$Grid$column,
															_List_fromArray(
																[
																	$author$project$Ui$Grid$span(4)
																]),
															_List_Nil)
														])) : (($elm$core$List$length(ageRateRules) === 1) ? A2(
													$author$project$Ui$Grid$row,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Grid$column,
															_List_fromArray(
																[
																	$author$project$Ui$Grid$span(8)
																]),
															_List_fromArray(
																[
																	A2(
																	$author$project$Ui$Typography$strong,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Individual Pricing')
																		]))
																])),
															showbillAffiliateRateText ? A2(
															$author$project$Ui$Grid$column,
															_List_fromArray(
																[
																	$author$project$Ui$Grid$span(4)
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('numeric')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Will be billed the affiliate rate')
																		]))
																])) : A2(
															$author$project$Ui$Grid$column,
															_List_fromArray(
																[
																	$author$project$Ui$Grid$span(4)
																]),
															_List_Nil)
														])) : $author$project$Utils$Html$empty)
												]),
												(!showbillAffiliateRateText) ? A2(
												$elm$core$List$map,
												$author$project$Components$Plan$Summary$Pricing$viewAgeRateRule(plan),
												ageRateRules) : _List_Nil
											])));
							} else {
								return A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Grid$row,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Grid$column,
													_List_fromArray(
														[
															$author$project$Ui$Grid$span(8)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Typography$strong,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Group Tier Pricing')
																]))
														])),
													showbillAffiliateRateText ? A2(
													$author$project$Ui$Grid$column,
													_List_fromArray(
														[
															$author$project$Ui$Grid$span(4)
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('numeric')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Will be billed the affiliate rate')
																]))
														])) : A2(
													$author$project$Ui$Grid$column,
													_List_fromArray(
														[
															$author$project$Ui$Grid$span(4)
														]),
													_List_Nil)
												])),
											function () {
											if (showbillAffiliateRateText) {
												return $author$project$Utils$Html$empty;
											} else {
												var retailPlan = $author$project$Api$Plan$planType(plan) === 2;
												return A2(
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Components$Plan$Summary$Pricing$viewGroupTierPricingRule,
															retailPlan,
															$author$project$Api$Plan$individualRateRule(plan)),
															A2(
															$author$project$Components$Plan$Summary$Pricing$viewGroupTierPricingRule,
															retailPlan,
															$author$project$Api$Plan$coupleRateRule(plan)),
															$author$project$Api$Plan$singleParentWithSingleChildRateRuleEnabled(plan) ? A2(
															$author$project$Components$Plan$Summary$Pricing$viewGroupTierPricingRule,
															retailPlan,
															$author$project$Api$Plan$singleParentWithSingleChildRateRule(plan)) : $author$project$Utils$Html$empty,
															A2(
															$author$project$Components$Plan$Summary$Pricing$viewGroupTierPricingRule,
															retailPlan,
															$author$project$Api$Plan$singleParentRateRule(plan)),
															$author$project$Api$Plan$familyWithSingleChildRateRuleEnabled(plan) ? A2(
															$author$project$Components$Plan$Summary$Pricing$viewGroupTierPricingRule,
															retailPlan,
															$author$project$Api$Plan$familyWithSingleChildRateRule(plan)) : $author$project$Utils$Html$empty,
															A2(
															$author$project$Components$Plan$Summary$Pricing$viewGroupTierPricingRule,
															retailPlan,
															$author$project$Api$Plan$familyRateRule(plan))
														]));
											}
										}()
										]));
							}
						}(),
							($author$project$Api$Plan$hasDiscountRules(plan) && ($author$project$Api$Plan$groupPricingType(plan) === 'family')) ? A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Family Discounts Available')
								])) : $author$project$Utils$Html$empty,
							($author$project$Api$Plan$hasDiscountRules(plan) && ($author$project$Api$Plan$groupPricingType(plan) === 'group')) ? A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Group Discounts Available')
								])) : $author$project$Utils$Html$empty,
							$author$project$Api$Plan$hasSpecialRates(plan) ? A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Special Rates Available')
								])) : $author$project$Utils$Html$empty,
							A2(
							$author$project$Components$Plan$Summary$Pricing$viewRegistrationFee,
							$author$project$Api$Plan$individualRegistrationFeeInCents(plan),
							$author$project$Api$Plan$maxRegistrationFeeInCents(plan))
						]));
		}
	});
var $author$project$Api$Provider$Plan$All$activeCompaniesCount = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$activeCompaniesCount(shared);
};
var $author$project$Api$Provider$Plan$All$activeMembershipPatientsCount = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$activeMembershipPatientsCount(shared);
};
var $author$project$Ui$Typography$Badge = {$: 10};
var $author$project$Ui$Typography$badge = $author$project$Ui$Typography$Badge;
var $author$project$Components$Admin$Plans$List$viewBadge = function (plan) {
	var _v0 = function () {
		var _v1 = $author$project$Api$Provider$Plan$All$planType(plan);
		switch (_v1) {
			case 2:
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$Plan$All$activeMembershipPatientsCount(plan)),
					'Active patients on this plan');
			case 0:
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$Plan$All$activeCompaniesCount(plan)),
					'Active companies on this plan');
			default:
				return _Utils_Tuple2($elm$core$Maybe$Nothing, '');
		}
	}();
	var count = _v0.a;
	var tooltip = _v0.b;
	if (!count.$) {
		var count_ = count.a;
		return A3(
			$author$project$Ui$Tooltip$view,
			_List_Nil,
			tooltip,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$text,
					_List_fromArray(
						[$author$project$Ui$Typography$badge]),
					$elm$core$String$fromInt(count_))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Ui$Link$Disabled = function (a) {
	return {$: 9, a: a};
};
var $author$project$Ui$Link$disabled = $author$project$Ui$Link$Disabled;
var $author$project$Api$Provider$Plan$Shared$isAffiliate = function (_v0) {
	return false;
};
var $author$project$Api$Provider$Plan$All$isAffiliate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$isAffiliate(shared);
};
var $author$project$Components$Admin$Plans$List$viewEditLink = F2(
	function (model, plan) {
		var disableEdit = $author$project$Api$Provider$Plan$All$isAffiliate(plan) && (!model.F1);
		var editLink = A3(
			$author$project$Ui$Link$route,
			model.Hx(
				{
					ahP: $author$project$Api$Provider$Plan$All$id(plan)
				}),
			_List_fromArray(
				[
					$author$project$Ui$Link$buttonDefault,
					$author$project$Ui$Link$disabled(disableEdit)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('View / Edit')
				]));
		return disableEdit ? A3(
			$author$project$Ui$Tooltip$view,
			_List_Nil,
			'Contact us to change this plan',
			_List_fromArray(
				[editLink])) : editLink;
	});
var $author$project$Components$Admin$Plans$List$viewPlanSummary = F2(
	function (model, plan) {
		var name_ = $author$project$Api$Provider$Plan$All$name(plan);
		var maxLength = $author$project$Api$Provider$Plan$All$default(plan) ? 32 : 40;
		var name = (_Utils_cmp(
			$elm$core$String$length(name_),
			maxLength) > 0) ? A3(
			$author$project$Ui$Tooltip$view,
			_List_Nil,
			name_,
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2($author$project$Formatters$String$ellipsis, maxLength, name_))
				])) : $elm$html$Html$text(name_);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mb2, $author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									$author$project$Ui$Typography$headingSm(
									_List_fromArray(
										[name])),
									$author$project$Components$Admin$Plans$List$viewBadge(plan)
								])),
							$author$project$Api$Provider$Plan$All$default(plan) ? A2(
							$author$project$Ui$Badge$view,
							_List_fromArray(
								[$author$project$Ui$Badge$primary]),
							_List_fromArray(
								[
									$elm$html$Html$text('Default')
								])) : $author$project$Utils$Html$empty
						])),
					A2(
					$author$project$Ui$Panel$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Panel$body,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Can bill '),
											$elm$html$Html$text(
											$author$project$Formatters$String$toSentence(
												A2(
													$elm$core$List$map,
													$author$project$Api$Period$billName,
													$author$project$Api$Provider$Plan$All$periods(plan))))
										])),
									A3(
									$author$project$Components$Plan$Summary$Pricing$view,
									$author$project$Api$Plan$ProviderAll(plan),
									$elm$core$Maybe$Nothing,
									$elm$core$Maybe$Nothing),
									model.bb ? $author$project$Utils$Html$empty : A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$flex, $author$project$Ui$Element$justifyRight]),
									_List_fromArray(
										[
											A2($author$project$Components$Admin$Plans$List$viewEditLink, model, plan)
										])),
									$author$project$Api$Provider$Plan$All$default(plan) ? A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
									_List_fromArray(
										[
											$elm$html$Html$text('This is your default for new memberships and online signup')
										])) : $author$project$Utils$Html$empty
								]))
						]))
				]));
	});
var $author$project$Components$Admin$Plans$List$viewPlan = F2(
	function (model, plan) {
		return A2(
			$author$project$Ui$Grid$column,
			_List_fromArray(
				[
					$author$project$Ui$Grid$spanMd(6)
				]),
			_List_fromArray(
				[
					A2($author$project$Components$Admin$Plans$List$viewPlanSummary, model, plan)
				]));
	});
var $author$project$Components$Admin$Plans$List$view = function (model) {
	return A2(
		$author$project$Ui$Panel$view,
		model.bb ? _List_fromArray(
			[$author$project$Ui$Panel$onlyBorderLeft]) : _List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$spaceBetween]),
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Membership pricing plans')
									])),
								model.bb ? $author$project$Utils$Html$empty : A3(
								$author$project$Ui$Link$route,
								model.II,
								_List_fromArray(
									[
										$author$project$Ui$Link$buttonDefault,
										$author$project$Ui$Link$icon($author$project$Ui$Icon$add)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('New Plan')
									]))
							])),
						$elm$core$List$isEmpty(model.Tp) ? $author$project$Utils$Html$empty : A2(
						$elm$html$Html$map,
						$elm$core$Basics$never,
						A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
							model.Tp)),
						model.bb ? $author$project$Utils$Html$empty : $author$project$Components$Admin$Plans$List$viewAllowMultipleRetailMembershipsSetting(model),
						model.bb ? $author$project$Utils$Html$empty : A2(
						$author$project$Ui$Grid$row,
						_List_fromArray(
							[$author$project$Ui$Grid$mt2]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$span(12)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Group$view,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Components$Admin$Plans$List$SearchInputMsg,
												A2($author$project$Ui$SearchInput$view, _List_Nil, model.up))
											]))
									]))
							]))
					])),
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$row,
						_List_Nil,
						function () {
							var _v0 = model.ZG;
							if (_v0.$ === 3) {
								var plans = _v0.a;
								return A2(
									$elm$core$List$map,
									$author$project$Components$Admin$Plans$List$viewPlan(model),
									plans);
							} else {
								return A2(
									$elm$core$List$repeat,
									10,
									A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$spanMd(6)
											]),
										_List_fromArray(
											[
												$author$project$Ui$Panel$title(
												_List_fromArray(
													[
														$author$project$Ui$Skeleton$text(
														_List_fromArray(
															[
																$author$project$Ui$Skeleton$span(4)
															])),
														$author$project$Ui$Skeleton$card(_List_Nil)
													]))
											])));
							}
						}())
					])),
				model.bb ? A2(
				$author$project$Ui$Panel$footer,
				_List_fromArray(
					[$author$project$Ui$Element$spaceBetween]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Add another plan'},
						_List_fromArray(
							[
								$author$project$Ui$Button$secondary,
								$author$project$Ui$Button$onClick($author$project$Components$Admin$Plans$List$AddAnother)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Add Another')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Go to next step'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$onClick($author$project$Components$Admin$Plans$List$NextStep)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Next')
							]))
					])) : A2(
				$author$project$Ui$Panel$footer,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Components$Admin$Plans$List$PaginationMsg,
						A2(
							$author$project$Api$Pagination$view,
							_List_fromArray(
								[
									$author$project$Ui$Pagination$List$loading(
									!$author$project$Api$Data$isSuccess(model.ZG))
								]),
							model.ajJ))
					]))
			]));
};
var $author$project$Pages$Admin$CompanyPlans$Top$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Admin$Plans$List$view(model.s1))
			]),
		ac9: 'Admin | Sponsor Plans'
	};
};
var $author$project$Pages$Admin$CompanyPlans$Top$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$CompanyPlans$Top$init, aiq: $author$project$Pages$Admin$CompanyPlans$Top$load, k8: $author$project$Pages$Admin$CompanyPlans$Top$save, alO: $author$project$Pages$Admin$CompanyPlans$Top$subscriptions, adT: $author$project$Pages$Admin$CompanyPlans$Top$update, amo: $author$project$Pages$Admin$CompanyPlans$Top$view});
var $author$project$Pages$Admin$Coupons$ArchivedDropdownMsg = function (a) {
	return {$: 15, a: a};
};
var $elm_community$string_extra$String$Extra$replaceSlice = F4(
	function (substitution, start, end, string) {
		return _Utils_ap(
			A3($elm$core$String$slice, 0, start, string),
			_Utils_ap(
				substitution,
				A3(
					$elm$core$String$slice,
					end,
					$elm$core$String$length(string),
					string)));
	});
var $author$project$Utils$Url$addParams = F2(
	function (url, qparams) {
		var urlDoesNotHaveQueryParams = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				$elm$core$String$isEmpty,
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.DE;
					},
					$elm$url$Url$fromString(url))));
		var querySeparator = urlDoesNotHaveQueryParams ? '?' : '&';
		var queryString = A4(
			$elm_community$string_extra$String$Extra$replaceSlice,
			querySeparator,
			0,
			1,
			$elm$url$Url$Builder$toQuery(qparams));
		return _Utils_ap(url, queryString);
	});
var $author$project$Pages$Admin$Coupons$buildCouponUrl = F2(
	function (memberPortalSignupUrl, code) {
		return A2(
			$author$project$Utils$Url$addParams,
			memberPortalSignupUrl,
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'coupon', code)
				]));
	});
var $author$project$Pages$Admin$Coupons$GotCoupons = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Coupon$couponsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['coupons']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Coupon$All$Coupon = $elm$core$Basics$identity;
var $author$project$Api$Common$Coupon$Shared$Coupon = $elm$core$Basics$identity;
var $author$project$Api$Common$Coupon$Shared$Record = function (id) {
	return function (code) {
		return function (description) {
			return function (percentOff) {
				return function (amountOffInCents) {
					return function (applyToEachPatient) {
						return function (createdAt) {
							return function (isRedeemable) {
								return function (redeemableFrom) {
									return function (redeemableUntil) {
										return function (durationInMonths) {
											return function (isArchived) {
												return {LF: amountOffInCents, LY: applyToEachPatient, NN: code, O1: createdAt, Qr: description, Q_: durationInMonths, ahP: id, UB: isArchived, U7: isRedeemable, Zr: percentOff, $i: redeemableFrom, $j: redeemableUntil};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Common$Coupon$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'is_archived',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'duration_in_months',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'redeemable_until',
			$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'redeemable_from',
				$author$project$Utils$Date$decode,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'is_redeemable',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'created_at',
						$elm_community$json_extra$Json$Decode$Extra$datetime,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'apply_to_each_patient',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'amount_off_in_cents',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'percent_off',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'description',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'code',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'id',
												$elm$json$Json$Decode$string,
												$elm$json$Json$Decode$succeed($author$project$Api$Common$Coupon$Shared$Record)))))))))))));
var $author$project$Api$Common$Coupon$Shared$decode = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Coupon$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Coupon$All$decode = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Coupon$Shared$decode,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Coupon$listDefaults = {
	L_: $elm$core$Maybe$Nothing,
	HM: $elm$core$Maybe$Nothing,
	ahP: $elm$core$Maybe$Nothing,
	ajJ: $author$project$Api$Pagination$init,
	akl: $elm$core$Maybe$Nothing,
	Jt: $elm$core$Maybe$Nothing,
	alA: A3($author$project$Api$Sort$withDefault, 'code', 0, $author$project$Api$Sort$init)
};
var $author$project$Api$Provider$Coupon$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Coupon$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.L_;
				if (!_v0.$) {
					var bool = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$bool, 'archived', bool)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.Jt;
				if (!_v1.$) {
					var bool = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$bool, 'redeemable', bool)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.akl;
				if (!_v2.$) {
					var string = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}()
			]));
};
var $author$project$Api$Provider$Coupon$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Coupon$All$decode),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Coupon$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Coupon$couponsPath)));
	});
var $author$project$Pages$Admin$Coupons$fetchCoupons = function (model) {
	return A3(
		$author$project$Api$Provider$Coupon$list,
		model.Gv,
		function (d) {
			return _Utils_update(
				d,
				{
					L_: $elm$core$Maybe$Just(model.L_)
				});
		},
		$author$project$Pages$Admin$Coupons$GotCoupons);
};
var $author$project$Utils$Bool$fromString = function (string) {
	switch (string) {
		case 'true':
			return $elm$core$Maybe$Just(true);
		case 'false':
			return $elm$core$Maybe$Just(false);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$Practice$One$memberPortalSignupUrl = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.WM;
	});
var $author$project$Pages$Admin$Coupons$init = F4(
	function (_v0, practice, shared, _v1) {
		var query = _v1.DE;
		var archived = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$andThen,
				$author$project$Utils$Bool$fromString,
				A2($elm$core$Dict$get, 'archived', query)));
		var model = {
			Gv: shared.Gv,
			L_: archived,
			ml: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'archived-dropdown-filter', al6: $author$project$Pages$Admin$Coupons$ArchivedDropdownMsg})),
			ir: $elm$core$Maybe$Nothing,
			bp: $elm$core$Set$empty,
			OP: $elm$core$Maybe$Nothing,
			G4: $author$project$Pages$Admin$Coupons$buildCouponUrl(
				$author$project$Api$Provider$Practice$One$memberPortalSignupUrl(practice)),
			yT: $author$project$Api$Data$Loading,
			dd: shared.dd
		};
		return _Utils_Tuple2(
			model,
			$author$project$Pages$Admin$Coupons$fetchCoupons(model));
	});
var $author$project$Pages$Admin$Coupons$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Coupons$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Coupons$CancelEdit = {$: 3};
var $author$project$Pages$Admin$Coupons$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Pages$Admin$Coupons$subscriptions = function (_v0) {
	var coupon = _v0.OP;
	var archivingCoupon = _v0.ir;
	var archivedDropdown = _v0.ml;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Admin$Coupons$CancelEdit)),
					coupon)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$Coupons$HiConfirmClosed),
					archivingCoupon)),
				$author$project$Ui$Dropdown$subscriptions(archivedDropdown)
			]));
};
var $author$project$Pages$Admin$Coupons$Archived = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Pages$Admin$Coupons$GotCoupon = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$Coupons$RedeemableFrom = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Pages$Admin$Coupons$RedeemableFromDateInputMsg = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Pages$Admin$Coupons$RedeemableUntil = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Pages$Admin$Coupons$RedeemableUntilDateInputMsg = F2(
	function (a, b) {
		return {$: 14, a: a, b: b};
	});
var $author$project$Pages$Admin$Coupons$Unarchived = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Api$Provider$Coupon$couponPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$Coupon$couponsPath);
};
var $author$project$Api$Provider$Coupon$couponArchivePath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['archive']),
		$author$project$Api$Provider$Coupon$couponPath(id_));
};
var $author$project$Api$Provider$Coupon$One$Coupon = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Coupon$One$Record = function (meta) {
	return {W4: meta};
};
var $author$project$Api$Provider$Coupon$Meta$Meta = $elm$core$Basics$identity;
var $author$project$Api$Provider$Coupon$Meta$MetaRecord = F5(
	function (code, percentOff, durationInMonths, redeemableFrom, redeemableUntil) {
		return {NN: code, Q_: durationInMonths, Zr: percentOff, $i: redeemableFrom, $j: redeemableUntil};
	});
var $author$project$Api$Provider$Coupon$Meta$EditableRecord = function (editable) {
	return {Q4: editable};
};
var $author$project$Api$Provider$Coupon$Meta$editableRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'editable',
	$elm$json$Json$Decode$bool,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Coupon$Meta$EditableRecord));
var $author$project$Api$Provider$Coupon$Meta$metaRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'redeemable_until',
	$author$project$Api$Provider$Coupon$Meta$editableRecordDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'redeemable_from',
		$author$project$Api$Provider$Coupon$Meta$editableRecordDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'duration_in_months',
			$author$project$Api$Provider$Coupon$Meta$editableRecordDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'percent_off',
				$author$project$Api$Provider$Coupon$Meta$editableRecordDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'code',
					$author$project$Api$Provider$Coupon$Meta$editableRecordDecoder,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$Coupon$Meta$MetaRecord))))));
var $author$project$Api$Provider$Coupon$Meta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Coupon$Meta$metaRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Coupon$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'meta',
	$author$project$Api$Provider$Coupon$Meta$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Coupon$One$Record));
var $author$project$Api$Provider$Coupon$One$decode = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Coupon$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Common$Coupon$Shared$decode,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Coupon$One$Coupon)));
var $author$project$Api$Provider$Coupon$archive = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Coupon$One$decode,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Coupon$couponArchivePath(id_)));
	});
var $author$project$Api$Common$Coupon$Shared$amountOffInCents = function (_v0) {
	var record = _v0;
	return record.LF;
};
var $author$project$Api$Provider$Coupon$One$amountOffInCents = function (_v0) {
	var common = _v0.a;
	return $author$project$Api$Common$Coupon$Shared$amountOffInCents(common);
};
var $author$project$Api$Common$Coupon$Shared$applyToEachPatient = function (_v0) {
	var record = _v0;
	return record.LY;
};
var $author$project$Api$Provider$Coupon$One$applyToEachPatient = function (_v0) {
	var common = _v0.a;
	return $author$project$Api$Common$Coupon$Shared$applyToEachPatient(common);
};
var $author$project$Api$Common$Coupon$Shared$code = function (_v0) {
	var record = _v0;
	return record.NN;
};
var $author$project$Api$Provider$Coupon$One$code = function (_v0) {
	var common = _v0.a;
	return $author$project$Api$Common$Coupon$Shared$code(common);
};
var $author$project$Api$Common$Coupon$Shared$description = function (_v0) {
	var record = _v0;
	return record.Qr;
};
var $author$project$Api$Provider$Coupon$One$description = function (_v0) {
	var common = _v0.a;
	return $author$project$Api$Common$Coupon$Shared$description(common);
};
var $author$project$Api$Common$Coupon$Shared$durationInMonths = function (_v0) {
	var record = _v0;
	return record.Q_;
};
var $author$project$Api$Provider$Coupon$One$durationInMonths = function (_v0) {
	var common = _v0.a;
	return $author$project$Api$Common$Coupon$Shared$durationInMonths(common);
};
var $author$project$Api$Common$Coupon$Shared$percentOff = function (_v0) {
	var record = _v0;
	return record.Zr;
};
var $author$project$Api$Provider$Coupon$One$percentOff = function (_v0) {
	var common = _v0.a;
	return $author$project$Api$Common$Coupon$Shared$percentOff(common);
};
var $author$project$Api$Common$Coupon$Shared$redeemableFrom = function (_v0) {
	var record = _v0;
	return record.$i;
};
var $author$project$Api$Provider$Coupon$One$redeemableFrom = function (_v0) {
	var common = _v0.a;
	return $author$project$Api$Common$Coupon$Shared$redeemableFrom(common);
};
var $author$project$Api$Common$Coupon$Shared$redeemableUntil = function (_v0) {
	var record = _v0;
	return record.$j;
};
var $author$project$Api$Provider$Coupon$One$redeemableUntil = function (_v0) {
	var common = _v0.a;
	return $author$project$Api$Common$Coupon$Shared$redeemableUntil(common);
};
var $author$project$Pages$Admin$Coupons$formFieldsFromCoupon = function (coupon) {
	var _v0 = $author$project$Components$DateInput$init;
	var redeemableUntilDateInput = _v0.a;
	var redeemableUntilDateInputCmd = _v0.b;
	var _v1 = $author$project$Components$DateInput$init;
	var redeemableFromDateInput = _v1.a;
	var redeemableFromDateInputCmd = _v1.b;
	return _Utils_Tuple2(
		{
			LF: A2(
				$elm$core$Maybe$map,
				$author$project$Currency$fromInt,
				$author$project$Api$Provider$Coupon$One$amountOffInCents(coupon)),
			LY: $author$project$Api$Provider$Coupon$One$applyToEachPatient(coupon),
			NN: $author$project$Api$Provider$Coupon$One$code(coupon),
			Qr: A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Api$Provider$Coupon$One$description(coupon)),
			Q_: $author$project$Api$Provider$Coupon$One$durationInMonths(coupon),
			Zr: A2(
				$elm$core$Maybe$map,
				$author$project$Percentage$fromFloat,
				$author$project$Api$Provider$Coupon$One$percentOff(coupon)),
			$i: $elm$core$Maybe$Just(
				$author$project$Api$Provider$Coupon$One$redeemableFrom(coupon)),
			pw: redeemableFromDateInput,
			$j: $author$project$Api$Provider$Coupon$One$redeemableUntil(coupon),
			px: redeemableUntilDateInput
		},
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Pages$Admin$Coupons$RedeemableFromDateInputMsg(redeemableFromDateInput),
					redeemableFromDateInputCmd),
					A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Pages$Admin$Coupons$RedeemableUntilDateInputMsg(redeemableUntilDateInput),
					redeemableUntilDateInputCmd)
				])));
};
var $author$project$Pages$Admin$Coupons$formFieldsInit = function (today) {
	var _v0 = $author$project$Components$DateInput$init;
	var redeemableUntilDateInput = _v0.a;
	var redeemableUntilDateInputCmd = _v0.b;
	var _v1 = $author$project$Components$DateInput$init;
	var redeemableFromDateInput = _v1.a;
	var redeemableFromDateInputCmd = _v1.b;
	return _Utils_Tuple2(
		{
			LF: $elm$core$Maybe$Nothing,
			LY: true,
			NN: '',
			Qr: '',
			Q_: $elm$core$Maybe$Nothing,
			Zr: $elm$core$Maybe$Nothing,
			$i: $elm$core$Maybe$Just(today),
			pw: redeemableFromDateInput,
			$j: $elm$core$Maybe$Nothing,
			px: redeemableUntilDateInput
		},
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Pages$Admin$Coupons$RedeemableFromDateInputMsg(redeemableFromDateInput),
					redeemableFromDateInputCmd),
					A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Pages$Admin$Coupons$RedeemableUntilDateInputMsg(redeemableUntilDateInput),
					redeemableUntilDateInputCmd)
				])));
};
var $author$project$Pages$Admin$Coupons$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{NN: string});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{Qr: string});
			case 2:
				var _float = field.a;
				return _Utils_update(
					fields,
					{Zr: _float});
			case 3:
				var _int = field.a;
				return _Utils_update(
					fields,
					{LF: _int});
			case 4:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						LY: A2(
							$elm$core$Maybe$withDefault,
							true,
							$author$project$Utils$Bool$fromString(string))
					});
			case 5:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Q_: $elm$core$String$toInt(string)
					});
			case 6:
				var dateInput = field.a;
				var date = field.b;
				return _Utils_update(
					fields,
					{$i: date, pw: dateInput});
			default:
				var dateInput = field.a;
				var date = field.b;
				return _Utils_update(
					fields,
					{$j: date, px: dateInput});
		}
	});
var $author$project$Pages$Admin$Coupons$RedeemableFromValidation = 2;
var $author$project$Pages$Admin$Coupons$CodeValidation = 0;
var $elm$regex$Regex$contains = _Regex_contains;
var $author$project$Utils$Regex$matches = F2(
	function (userRegex, string) {
		var _v0 = $elm$regex$Regex$fromString(userRegex);
		if (_v0.$ === 1) {
			return false;
		} else {
			var regex = _v0.a;
			return A2($elm$regex$Regex$contains, regex, string);
		}
	});
var $author$project$Utils$Validate$doesNotMatchRegex = F2(
	function (string, regex) {
		return !A2($author$project$Utils$Regex$matches, regex, string);
	});
var $author$project$Pages$Admin$Coupons$validateCode = function (fields) {
	return $rtfeldman$elm_validate$Validate$isBlank(fields.NN) ? _List_fromArray(
		[
			_Utils_Tuple2(0, 'Please enter a code.')
		]) : (A2($author$project$Utils$Validate$doesNotMatchRegex, fields.NN, '^[a-zA-Z\\d]+$') ? _List_fromArray(
		[
			_Utils_Tuple2(0, 'Coupons can only include numbers and letters. Please remove any spaces or punctuation.')
		]) : _List_Nil);
};
var $author$project$Pages$Admin$Coupons$DiscountValidation = 1;
var $author$project$Pages$Admin$Coupons$validateDiscount = function (fields) {
	var _v0 = _Utils_Tuple2(fields.LF, fields.Zr);
	if ((_v0.a.$ === 1) && (_v0.b.$ === 1)) {
		var _v1 = _v0.a;
		var _v2 = _v0.b;
		return _List_fromArray(
			[
				_Utils_Tuple2(1, 'Please enter a discount.')
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Pages$Admin$Coupons$RedeemableUntilValidation = 3;
var $author$project$Pages$Admin$Coupons$validateRedeemableUntil = function (fields) {
	var _v0 = _Utils_Tuple2(fields.$i, fields.$j);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var redeemableFrom = _v0.a.a;
		var redeemableUntil = _v0.b.a;
		return (A2($justinmimbs$date$Date$compare, redeemableUntil, redeemableFrom) !== 2) ? _List_fromArray(
			[
				_Utils_Tuple2(3, 'Coupon must be active for at least one day.')
			]) : _List_Nil;
	} else {
		return _List_Nil;
	}
};
var $author$project$Pages$Admin$Coupons$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Admin$Coupons$validateCode),
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.$i;
			},
			_Utils_Tuple2(2, 'Please enter an start date.')),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Admin$Coupons$validateDiscount),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Admin$Coupons$validateRedeemableUntil)
		]));
var $author$project$Api$Common$Coupon$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Coupon$All$id = function (_v0) {
	var common = _v0;
	return $author$project$Api$Common$Coupon$Shared$id(common);
};
var $author$project$Api$Common$Coupon$Shared$isArchived = function (_v0) {
	var record = _v0;
	return record.UB;
};
var $author$project$Api$Provider$Coupon$All$isArchived = function (_v0) {
	var common = _v0;
	return $author$project$Api$Common$Coupon$Shared$isArchived(common);
};
var $author$project$Api$Provider$Coupon$retrieve = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Coupon$One$decode,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Coupon$couponPath(id_)));
	});
var $author$project$Pages$Admin$Coupons$Created = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Admin$Coupons$apiFields = function (fields) {
	return {
		LF: fields.LF,
		LY: fields.LY,
		NN: fields.NN,
		Qr: fields.Qr,
		Q_: fields.Q_,
		Zr: A2($elm$core$Maybe$andThen, $author$project$Percentage$toFloat, fields.Zr),
		$i: fields.$i,
		$j: fields.$j
	};
};
var $author$project$Api$Provider$Coupon$create = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'coupon',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'code',
								$elm$json$Json$Encode$string(fields.NN)),
								_Utils_Tuple2(
								'description',
								$elm$json$Json$Encode$string(fields.Qr)),
								_Utils_Tuple2(
								'percent_off',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$float, fields.Zr)),
								_Utils_Tuple2(
								'amount_off_in_cents',
								A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.LF)),
								_Utils_Tuple2(
								'redeemable_from',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.$i)),
								_Utils_Tuple2(
								'redeemable_until',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.$j)),
								_Utils_Tuple2(
								'duration_in_months',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Q_)),
								_Utils_Tuple2(
								'apply_to_each_patient',
								$elm$json$Json$Encode$bool(fields.LY))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Coupon$One$decode,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Coupon$couponsPath)));
	});
var $author$project$Pages$Admin$Coupons$createCoupon = F2(
	function (apiClient, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A3(
			$author$project$Api$Provider$Coupon$create,
			apiClient,
			$author$project$Pages$Admin$Coupons$apiFields(fields),
			$author$project$Pages$Admin$Coupons$Created);
	});
var $author$project$Api$Provider$Coupon$One$id = function (_v0) {
	var common = _v0.a;
	return $author$project$Api$Common$Coupon$Shared$id(common);
};
var $author$project$Pages$Admin$Coupons$Updated = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$Coupon$update = F4(
	function (apiClient, id_, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'coupon',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'code',
								$elm$json$Json$Encode$string(fields.NN)),
								_Utils_Tuple2(
								'description',
								$elm$json$Json$Encode$string(fields.Qr)),
								_Utils_Tuple2(
								'percent_off',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$float, fields.Zr)),
								_Utils_Tuple2(
								'amount_off_in_cents',
								A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.LF)),
								_Utils_Tuple2(
								'redeemable_from',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.$i)),
								_Utils_Tuple2(
								'redeemable_until',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.$j)),
								_Utils_Tuple2(
								'duration_in_months',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Q_)),
								_Utils_Tuple2(
								'apply_to_each_patient',
								$elm$json$Json$Encode$bool(fields.LY))
							])))
				]));
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$Coupon$One$decode,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Coupon$couponPath(id_))));
	});
var $author$project$Pages$Admin$Coupons$updateCoupon = F3(
	function (apiClient, id, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4(
			$author$project$Api$Provider$Coupon$update,
			apiClient,
			id,
			$author$project$Pages$Admin$Coupons$apiFields(fields),
			$author$project$Pages$Admin$Coupons$Updated);
	});
var $author$project$Pages$Admin$Coupons$saveCoupon = F3(
	function (apiClient, coupon, formFields) {
		if (!coupon.$) {
			var coupon_ = coupon.a;
			return A3(
				$author$project$Pages$Admin$Coupons$updateCoupon,
				apiClient,
				$author$project$Api$Provider$Coupon$One$id(coupon_),
				formFields);
		} else {
			return A2($author$project$Pages$Admin$Coupons$createCoupon, apiClient, formFields);
		}
	});
var $author$project$Api$Provider$Coupon$couponUnarchivePath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['unarchive']),
		$author$project$Api$Provider$Coupon$couponPath(id_));
};
var $author$project$Api$Provider$Coupon$unarchive = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Coupon$One$decode,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Coupon$couponUnarchivePath(id_)));
	});
var $author$project$Pages$Admin$Coupons$updateDateInputFormField = F6(
	function (model, dateInput, subMsg, toMsg, field, fieldGetter) {
		var _v0 = model.OP;
		if (!_v0.$) {
			var _v1 = _v0.a;
			var id = _v1.a;
			var form = _v1.b;
			var coupon = _v1.c;
			var _v2 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
			var newDateInput = _v2.a;
			var subCmd = _v2.b;
			var event = _v2.c;
			var newForm = function () {
				if (event.$ === 1) {
					var date = event.a;
					return A3(
						$author$project$Utils$Form$update,
						$author$project$Pages$Admin$Coupons$formFieldsUpdate,
						A2(field, newDateInput, date),
						form);
				} else {
					var fields = $author$project$Utils$Form$fields(form);
					return A3(
						$author$project$Utils$Form$update,
						$author$project$Pages$Admin$Coupons$formFieldsUpdate,
						A2(
							field,
							newDateInput,
							fieldGetter(fields)),
						form);
				}
			}();
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						OP: $elm$core$Maybe$Just(
							_Utils_Tuple3(id, newForm, coupon))
					}),
				A2(
					$elm$core$Platform$Cmd$map,
					toMsg(newDateInput),
					subCmd),
				_List_Nil);
		} else {
			return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Ports$Navigation$replaceUrl = _Platform_outgoingPort('replaceUrl', $elm$json$Json$Encode$string);
var $author$project$Pages$Admin$Coupons$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$url$Url$Builder$string,
			'archived',
			$author$project$Utils$Bool$toString(model.L_))
		]);
	return $author$project$Ports$Navigation$replaceUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Admin__Coupons)
				]),
			queryParams));
};
var $author$project$Pages$Admin$Coupons$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var _v1 = $author$project$Pages$Admin$Coupons$formFieldsInit(model.dd);
				var fields = _v1.a;
				var fieldsCmd = _v1.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							OP: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init(fields),
									$author$project$Api$Data$NotAsked))
						}),
					fieldsCmd,
					_List_Nil);
			case 6:
				var field = msg.a;
				var _v2 = model.OP;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var id = _v3.a;
					var form = _v3.b;
					var coupon = _v3.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$Coupons$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								OP: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, coupon))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				var form = msg.a;
				var coupon = msg.b;
				var _v4 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$Coupons$formFieldsValidator, form);
				if (!_v4.$) {
					var _v5 = _v4.a;
					var newForm = _v5.a;
					var validFormFields = _v5.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								OP: $elm$core$Maybe$Just(
									_Utils_Tuple3(coupon, newForm, $author$project$Api$Data$Loading))
							}),
						A3($author$project$Pages$Admin$Coupons$saveCoupon, model.Gv, coupon, validFormFields),
						_List_Nil);
				} else {
					var newForm = _v4.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								OP: $elm$core$Maybe$Just(
									_Utils_Tuple3(coupon, newForm, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 1:
				var coupon = msg.a;
				return _Utils_Tuple3(
					model,
					A3(
						$author$project$Api$Provider$Coupon$retrieve,
						model.Gv,
						$author$project$Api$Provider$Coupon$All$id(coupon),
						$author$project$Pages$Admin$Coupons$GotCoupon),
					_List_Nil);
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					var coupon = response.a;
					var _v7 = $author$project$Pages$Admin$Coupons$formFieldsFromCoupon(coupon);
					var fields = _v7.a;
					var fieldsCmd = _v7.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								OP: $elm$core$Maybe$Just(
									_Utils_Tuple3(
										$elm$core$Maybe$Just(coupon),
										$author$project$Utils$Form$init(fields),
										$author$project$Api$Data$NotAsked))
							}),
						fieldsCmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{OP: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{yT: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 7:
				var response = msg.a;
				var _v8 = model.OP;
				if (!_v8.$) {
					var _v9 = _v8.a;
					var id = _v9.a;
					var form = _v9.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{OP: $elm$core$Maybe$Nothing}),
							$author$project$Pages$Admin$Coupons$fetchCoupons(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Coupon successfully created')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									OP: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 8:
				var response = msg.a;
				var _v11 = model.OP;
				if (!_v11.$) {
					var _v12 = _v11.a;
					var id = _v12.a;
					var form = _v12.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{OP: $elm$core$Maybe$Nothing}),
							$author$project$Pages$Admin$Coupons$fetchCoupons(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Coupon successfully updated')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									OP: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var id = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bp: A2($elm$core$Set$remove, id, model.bp),
									yT: $author$project$Api$Data$Loading
								}),
							$author$project$Pages$Admin$Coupons$fetchCoupons(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'The coupon was successfully archived')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bp: A2($elm$core$Set$remove, id, model.bp)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 10:
				var id = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bp: A2($elm$core$Set$remove, id, model.bp),
									yT: $author$project$Api$Data$Loading
								}),
							$author$project$Pages$Admin$Coupons$fetchCoupons(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'The coupon was successfully unarchived')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bp: A2($elm$core$Set$remove, id, model.bp)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 11:
				var coupon = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ir: $elm$core$Maybe$Just(coupon)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 12:
				var coupon = msg.a;
				var confirmed = msg.b;
				if (confirmed) {
					var id = $author$project$Api$Provider$Coupon$All$id(coupon);
					var cmd = $author$project$Api$Provider$Coupon$All$isArchived(coupon) ? A3(
						$author$project$Api$Provider$Coupon$unarchive,
						model.Gv,
						id,
						$author$project$Pages$Admin$Coupons$Unarchived(id)) : A3(
						$author$project$Api$Provider$Coupon$archive,
						model.Gv,
						id,
						$author$project$Pages$Admin$Coupons$Archived(id));
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ir: $elm$core$Maybe$Nothing,
								bp: A2($elm$core$Set$insert, id, model.bp)
							}),
						cmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ir: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 13:
				var dateInput = msg.a;
				var subMsg = msg.b;
				return A6(
					$author$project$Pages$Admin$Coupons$updateDateInputFormField,
					model,
					dateInput,
					subMsg,
					$author$project$Pages$Admin$Coupons$RedeemableFromDateInputMsg,
					$author$project$Pages$Admin$Coupons$RedeemableFrom,
					function ($) {
						return $.$i;
					});
			case 14:
				var dateInput = msg.a;
				var subMsg = msg.b;
				return A6(
					$author$project$Pages$Admin$Coupons$updateDateInputFormField,
					model,
					dateInput,
					subMsg,
					$author$project$Pages$Admin$Coupons$RedeemableUntilDateInputMsg,
					$author$project$Pages$Admin$Coupons$RedeemableUntil,
					function ($) {
						return $.$j;
					});
			case 15:
				var subMsg = msg.a;
				var _v16 = A2($author$project$Ui$Dropdown$update, subMsg, model.ml);
				var dropdown = _v16.a;
				var dropdownCmd = _v16.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ml: dropdown}),
					dropdownCmd,
					_List_Nil);
			default:
				var archived = msg.a;
				var newModel = _Utils_update(
					model,
					{L_: archived, yT: $author$project$Api$Data$Loading});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Admin$Coupons$fetchCoupons(newModel),
								$author$project$Pages$Admin$Coupons$updateUrl(newModel)
							])),
					_List_Nil);
		}
	});
var $author$project$Pages$Admin$Coupons$New = {$: 0};
var $author$project$Pages$Admin$Coupons$ArchivedSelected = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Admin$Coupons$archivedDropdownOptions = function (archived) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$selected(!archived),
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Pages$Admin$Coupons$ArchivedSelected(false))
				]),
			$elm$html$Html$text('Current')),
			A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$selected(archived),
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Pages$Admin$Coupons$ArchivedSelected(true))
				]),
			$elm$html$Html$text('Archived'))
		]);
};
var $author$project$Pages$Admin$Coupons$viewArchivedDropdown = function (model) {
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				model.L_ ? 'Archived' : 'Current')
			]),
		$author$project$Pages$Admin$Coupons$archivedDropdownOptions(model.L_),
		model.ml);
};
var $author$project$Pages$Admin$Coupons$AmountOffInCents = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Admin$Coupons$ApplyToEachPatient = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$Coupons$Code = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$Coupons$Description = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$Coupons$DurationInMonths = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$Coupons$FormUpdated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Admin$Coupons$PercentOff = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$Coupons$Save = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Pages$Admin$Coupons$applyToEachPatientOptions = _List_fromArray(
	[
		A3(
		$author$project$Ui$Form$Select$option,
		_List_Nil,
		$elm$core$Maybe$Just('true'),
		'once for each patient'),
		A3(
		$author$project$Ui$Form$Select$option,
		_List_Nil,
		$elm$core$Maybe$Just('false'),
		'once per membership')
	]);
var $author$project$Api$Provider$Coupon$Meta$codeEditable = function (_v0) {
	var meta = _v0;
	return meta.NN.Q4;
};
var $author$project$Ui$Form$PercentageInput$Disabled = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Form$PercentageInput$disabled = $author$project$Ui$Form$PercentageInput$Disabled;
var $author$project$Api$Provider$Coupon$Meta$durationInMonthsEditable = function (_v0) {
	var meta = _v0;
	return meta.Q_.Q4;
};
var $author$project$Ui$Form$Select$Inline = {$: 7};
var $author$project$Ui$Form$Select$inline = $author$project$Ui$Form$Select$Inline;
var $author$project$Api$Provider$Coupon$One$meta = function (_v0) {
	var record = _v0.b;
	return record.W4;
};
var $author$project$Api$Provider$Coupon$Meta$percentOffEditable = function (_v0) {
	var meta = _v0;
	return meta.Zr.Q4;
};
var $author$project$Ui$Form$PercentageInput$Placeholder = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Form$PercentageInput$placeholder = $author$project$Ui$Form$PercentageInput$Placeholder;
var $author$project$Api$Provider$Coupon$Meta$redeemableFromEditable = function (_v0) {
	var meta = _v0;
	return meta.$i.Q4;
};
var $author$project$Api$Provider$Coupon$Meta$redeemableUntilEditable = function (_v0) {
	var meta = _v0;
	return meta.$j.Q4;
};
var $author$project$Ui$Form$PeriodInMonthsSelect$selectOptions = F2(
	function (noneLabel, options) {
		return A2(
			$elm$core$List$cons,
			A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(''),
				noneLabel),
			A2(
				$elm$core$List$map,
				function (month) {
					return A3(
						$author$project$Ui$Form$Select$option,
						_List_Nil,
						$elm$core$Maybe$Just(
							$elm$core$String$fromInt(month)),
						$elm$core$String$fromInt(month));
				},
				options));
	});
var $author$project$Ui$Form$PeriodInMonthsSelect$view = function (_v0) {
	var value = _v0.aee;
	var onChange = _v0.ajd;
	var noneLabel = _v0.XY;
	var options = _v0.Cd;
	return $author$project$Ui$Form$Input$group(
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Select$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Select$value(
						A2($elm$core$Maybe$map, $elm$core$String$fromInt, value)),
						$author$project$Ui$Form$Select$onChange(onChange)
					]),
				A2($author$project$Ui$Form$PeriodInMonthsSelect$selectOptions, noneLabel, options)),
				$author$project$Ui$Form$Input$addon(
				_List_fromArray(
					[
						(A2($elm$core$Maybe$withDefault, 0, value) === 1) ? $elm$html$Html$text('month') : $elm$html$Html$text('months')
					]))
			]));
};
var $author$project$Pages$Admin$Coupons$viewDiscount = F3(
	function (percentOff, amountOffInCents, applyToEachPatient) {
		var _v0 = _Utils_Tuple2(percentOff, amountOffInCents);
		if (!_v0.a.$) {
			var percentOff_ = _v0.a.a;
			return _List_fromArray(
				[
					$elm$html$Html$text(
					$elm$core$String$fromFloat(percentOff_) + '% off')
				]);
		} else {
			if (!_v0.b.$) {
				var _v1 = _v0.a;
				var amountOffInCents_ = _v0.b.a;
				return _List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Currency$format(amountOffInCents_)),
						$elm$html$Html$text(' / '),
						applyToEachPatient ? $elm$html$Html$text('patient') : $elm$html$Html$text('membership')
					]);
			} else {
				var _v2 = _v0.a;
				var _v3 = _v0.b;
				return _List_Nil;
			}
		}
	});
var $author$project$Pages$Admin$Coupons$viewDuration = function (durationInMonths) {
	if (!durationInMonths.$) {
		var durationInMonths_ = durationInMonths.a;
		return $elm$html$Html$text(
			A2($author$project$Formatters$String$pluralize, 'month', durationInMonths_));
	} else {
		return $elm$html$Html$text('unlimited');
	}
};
var $author$project$Pages$Admin$Coupons$viewCouponModal = F4(
	function (couponUrl, coupon, saveRequest, form) {
		var modalConfig = {
			Tq: $elm$core$Maybe$Nothing,
			aih: 'Coupon',
			V8: _Utils_eq(saveRequest, $author$project$Api$Data$Loading),
			WG: A2($elm$core$Maybe$map, $author$project$Api$Provider$Coupon$One$id, coupon),
			WH: $elm$core$Maybe$Nothing,
			Yd: $author$project$Pages$Admin$Coupons$CancelEdit,
			Yf: $elm$core$Basics$always(
				A2($author$project$Pages$Admin$Coupons$Save, form, coupon))
		};
		var isNew = !$author$project$Utils$Maybe$toBool(coupon);
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$required(isNew),
							$author$project$Ui$Form$Group$label('Coupon Code')
						]),
					A2(
						$elm$core$Maybe$withDefault,
						true,
						A2(
							$elm$core$Maybe$map,
							$author$project$Api$Provider$Coupon$Meta$codeEditable,
							A2($elm$core$Maybe$map, $author$project$Api$Provider$Coupon$One$meta, coupon))) ? _List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(fields.NN),
									$author$project$Ui$Form$Input$placeholder('gethealthy'),
									$author$project$Ui$Form$Input$autofocus(true),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Coupons$FormUpdated, $author$project$Pages$Admin$Coupons$Code)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form))
								])),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						]) : _List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(fields.NN)
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Description')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(fields.Qr),
									$author$project$Ui$Form$Input$placeholder('Marketing Campaign in Get Healthy Magazine'),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Coupons$FormUpdated, $author$project$Pages$Admin$Coupons$Description))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Monthly Discount'),
							$author$project$Ui$Form$Group$required(isNew)
						]),
					A2(
						$elm$core$Maybe$withDefault,
						true,
						A2(
							$elm$core$Maybe$map,
							$author$project$Api$Provider$Coupon$Meta$percentOffEditable,
							A2($elm$core$Maybe$map, $author$project$Api$Provider$Coupon$One$meta, coupon))) ? _List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(5)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$PercentageInput$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$PercentageInput$value(fields.Zr),
													$author$project$Ui$Form$PercentageInput$placeholder('5.5'),
													$author$project$Ui$Form$PercentageInput$onInput(
													A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Coupons$FormUpdated, $author$project$Pages$Admin$Coupons$PercentOff)),
													$author$project$Ui$Form$PercentageInput$invalid(
													A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
													$author$project$Ui$Form$PercentageInput$disabled(
													$author$project$Utils$Maybe$toBool(fields.LF))
												]))
										])),
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(2)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$em,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('or')
														]))
												]))
										])),
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(5)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$CurrencyInput$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$CurrencyInput$value(fields.LF),
													$author$project$Ui$Form$CurrencyInput$placeholder('7.50'),
													$author$project$Ui$Form$CurrencyInput$onInput(
													A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Coupons$FormUpdated, $author$project$Pages$Admin$Coupons$AmountOffInCents)),
													$author$project$Ui$Form$CurrencyInput$invalid(
													A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
													$author$project$Ui$Form$CurrencyInput$disabled(
													$author$project$Utils$Maybe$toBool(fields.Zr))
												]))
										]))
								])),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 1, form)),
							function () {
							var _v0 = fields.LF;
							if (!_v0.$) {
								return A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[$author$project$Ui$Typography$helpBlock]),
											'This coupon to apply'),
											A2(
											$author$project$Ui$Form$Select$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Select$value(
													$elm$core$Maybe$Just(
														$author$project$Utils$Bool$toString(fields.LY))),
													$author$project$Ui$Form$Select$onChange(
													A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Coupons$FormUpdated, $author$project$Pages$Admin$Coupons$ApplyToEachPatient)),
													$author$project$Ui$Form$Select$inline
												]),
											$author$project$Pages$Admin$Coupons$applyToEachPatientOptions)
										]));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						]) : _List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							A3(
								$author$project$Pages$Admin$Coupons$viewDiscount,
								A2($elm$core$Maybe$andThen, $author$project$Percentage$toFloat, fields.Zr),
								fields.LF,
								fields.LY))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Coupon Duration')
						]),
					_Utils_ap(
						A2(
							$elm$core$Maybe$withDefault,
							true,
							A2(
								$elm$core$Maybe$map,
								$author$project$Api$Provider$Coupon$Meta$durationInMonthsEditable,
								A2($elm$core$Maybe$map, $author$project$Api$Provider$Coupon$One$meta, coupon))) ? _List_fromArray(
							[
								$author$project$Ui$Form$PeriodInMonthsSelect$view(
								{
									XY: 'Unlimited',
									ajd: A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Coupons$FormUpdated, $author$project$Pages$Admin$Coupons$DurationInMonths),
									Cd: A2($elm$core$List$range, 1, 12),
									aee: fields.Q_
								})
							]) : _List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Static$view,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Pages$Admin$Coupons$viewDuration(fields.Q_)
									]))
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpBlock]),
								_List_fromArray(
									[
										$elm$html$Html$text('Time period monthly discount is applied.')
									]))
							]))),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$required(isNew),
							$author$project$Ui$Form$Group$label('Start Date')
						]),
					_Utils_ap(
						A2(
							$elm$core$Maybe$withDefault,
							true,
							A2(
								$elm$core$Maybe$map,
								$author$project$Api$Provider$Coupon$Meta$redeemableFromEditable,
								A2($elm$core$Maybe$map, $author$project$Api$Provider$Coupon$One$meta, coupon))) ? _List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Admin$Coupons$RedeemableFromDateInputMsg(fields.pw),
								A2(
									$author$project$Components$DateInput$view,
									_List_fromArray(
										[
											$author$project$Components$DateInput$value(fields.$i),
											$author$project$Components$DateInput$invalid(
											A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
											$author$project$Components$DateInput$errors(
											A2($author$project$Utils$Form$validationErrors, 2, form))
										]),
									fields.pw))
							]) : _List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Static$view,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Maybe$map,
												$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
												fields.$i)))
									]))
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpBlock]),
								_List_fromArray(
									[
										$elm$html$Html$text('Date coupon can first be redeemed.')
									]))
							]))),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('End Date')
						]),
					_Utils_ap(
						A2(
							$elm$core$Maybe$withDefault,
							true,
							A2(
								$elm$core$Maybe$map,
								$author$project$Api$Provider$Coupon$Meta$redeemableUntilEditable,
								A2($elm$core$Maybe$map, $author$project$Api$Provider$Coupon$One$meta, coupon))) ? _List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Admin$Coupons$RedeemableUntilDateInputMsg(fields.px),
								A2(
									$author$project$Components$DateInput$view,
									_List_fromArray(
										[
											$author$project$Components$DateInput$value(fields.$j),
											$author$project$Components$DateInput$invalid(
											A2($author$project$Utils$Form$hasValidationErrors, 3, form)),
											$author$project$Components$DateInput$errors(
											A2($author$project$Utils$Form$validationErrors, 3, form))
										]),
									fields.px))
							]) : _List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Static$view,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2(
											$elm$core$Maybe$withDefault,
											'none',
											A2(
												$elm$core$Maybe$map,
												$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
												fields.$j)))
									]))
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpBlock]),
								_List_fromArray(
									[
										$elm$html$Html$text('Last day coupon can be redeemed. Leave blank for no end date.')
									]))
							]))),
					($elm$core$String$length(fields.NN) > 0) ? A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Signup URL')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$externalHref,
									couponUrl(fields.NN),
									_List_fromArray(
										[$author$project$Ui$Link$targetBlank]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											couponUrl(fields.NN))
										])),
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$helpBlock]),
									_List_fromArray(
										[
											$elm$html$Html$text('Link to your Online Signup page with this coupon applied')
										]))
								]))
						])) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Api$Common$Coupon$Shared$createdAt = function (_v0) {
	var record = _v0;
	return record.O1;
};
var $author$project$Api$Provider$Coupon$All$createdAt = function (_v0) {
	var common = _v0;
	return $author$project$Api$Common$Coupon$Shared$createdAt(common);
};
var $author$project$Pages$Admin$Coupons$sortCoupons = function (coupons) {
	return $elm$core$List$reverse(
		A2(
			$elm$core$List$sortBy,
			A2($elm$core$Basics$composeR, $author$project$Api$Provider$Coupon$All$createdAt, $elm$time$Time$posixToMillis),
			coupons));
};
var $author$project$Pages$Admin$Coupons$Archive = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Admin$Coupons$Edit = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Coupon$All$amountOffInCents = function (_v0) {
	var common = _v0;
	return $author$project$Api$Common$Coupon$Shared$amountOffInCents(common);
};
var $author$project$Api$Provider$Coupon$All$applyToEachPatient = function (_v0) {
	var common = _v0;
	return $author$project$Api$Common$Coupon$Shared$applyToEachPatient(common);
};
var $author$project$Api$Provider$Coupon$All$code = function (_v0) {
	var common = _v0;
	return $author$project$Api$Common$Coupon$Shared$code(common);
};
var $author$project$Api$Provider$Coupon$All$durationInMonths = function (_v0) {
	var common = _v0;
	return $author$project$Api$Common$Coupon$Shared$durationInMonths(common);
};
var $author$project$Api$Common$Coupon$Shared$isRedeemable = function (_v0) {
	var record = _v0;
	return record.U7;
};
var $author$project$Api$Provider$Coupon$All$isRedeemable = function (_v0) {
	var common = _v0;
	return $author$project$Api$Common$Coupon$Shared$isRedeemable(common);
};
var $author$project$Api$Provider$Coupon$All$percentOff = function (_v0) {
	var common = _v0;
	return $author$project$Api$Common$Coupon$Shared$percentOff(common);
};
var $author$project$Api$Provider$Coupon$All$redeemableFrom = function (_v0) {
	var common = _v0;
	return $author$project$Api$Common$Coupon$Shared$redeemableFrom(common);
};
var $author$project$Api$Provider$Coupon$All$redeemableUntil = function (_v0) {
	var common = _v0;
	return $author$project$Api$Common$Coupon$Shared$redeemableUntil(common);
};
var $author$project$Pages$Admin$Coupons$viewCoupon = F2(
	function (archivingCoupons, coupon) {
		var status = $author$project$Api$Provider$Coupon$All$isRedeemable(coupon) ? 'redeemable' : 'not_redeemable';
		var id = $author$project$Api$Provider$Coupon$All$id(coupon);
		var loading = A2($elm$core$Set$member, id, archivingCoupons);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$Coupon$All$code(coupon))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					A3(
						$author$project$Pages$Admin$Coupons$viewDiscount,
						$author$project$Api$Provider$Coupon$All$percentOff(coupon),
						A2(
							$elm$core$Maybe$map,
							$author$project$Currency$fromInt,
							$author$project$Api$Provider$Coupon$All$amountOffInCents(coupon)),
						$author$project$Api$Provider$Coupon$All$applyToEachPatient(coupon))),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$author$project$Formatters$Date$toString,
								$author$project$Formatters$Date$Full,
								$author$project$Api$Provider$Coupon$All$redeemableFrom(coupon)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = $author$project$Api$Provider$Coupon$All$redeemableUntil(coupon);
							if (!_v0.$) {
								var redeemableUntil = _v0.a;
								return $elm$html$Html$text(
									A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, redeemableUntil));
							} else {
								return $elm$html$Html$text('none');
							}
						}()
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Admin$Coupons$viewDuration(
							$author$project$Api$Provider$Coupon$All$durationInMonths(coupon))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Ui$Badge$fromString, _List_Nil, status)
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Edit coupon'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$disabled(loading),
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Admin$Coupons$Edit(coupon)),
											$author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit')
										])),
									function () {
									var verb = $author$project$Api$Provider$Coupon$All$isArchived(coupon) ? 'Unarchive' : 'Archive';
									return A3(
										$author$project$Ui$Button$view,
										{mm: verb + ' coupon'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$sm,
												$author$project$Ui$Button$loading(loading),
												$author$project$Ui$Button$onClick(
												$author$project$Pages$Admin$Coupons$Archive(coupon))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(verb)
											]));
								}()
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$Coupons$viewPanelTable = function (model) {
	var action = model.L_ ? 'archived' : 'unarchived';
	var _v0 = function () {
		var _v1 = model.yT;
		if (_v1.$ === 3) {
			var coupons_ = _v1.a;
			return _Utils_Tuple2(false, coupons_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var coupons = _v0.b;
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$verticalCentered,
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You dont have any ' + (action + ' coupons.'))
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Coupon Code')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Amount Off')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Start Date')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('End Date')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Duration')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Status')
					])),
				A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
			]),
		A2(
			$elm$core$List$map,
			$author$project$Pages$Admin$Coupons$viewCoupon(model.bp),
			$author$project$Pages$Admin$Coupons$sortCoupons(coupons)),
		_List_Nil);
};
var $author$project$Pages$Admin$Coupons$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				function () {
				var _v0 = model.OP;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var coupon = _v1.a;
					var form = _v1.b;
					var saveRequest = _v1.c;
					return A4($author$project$Pages$Admin$Coupons$viewCouponModal, model.G4, coupon, saveRequest, form);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v2 = model.ir;
				if (!_v2.$) {
					var coupon = _v2.a;
					var action = $author$project$Api$Provider$Coupon$All$isArchived(coupon) ? 'unarchive' : 'archive';
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Admin$Coupons$HiConfirmClosed(coupon),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$customMessage(
								_List_fromArray(
									[
										$elm$html$Html$text('You\'re about to ' + (action + ' this coupon'))
									]))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween]),
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Coupons')
											])),
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Create new coupon'},
										_List_fromArray(
											[
												$author$project$Ui$Button$default,
												$author$project$Ui$Button$onClick($author$project$Pages$Admin$Coupons$New),
												$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('New Coupon')
											]))
									])),
								A2(
								$author$project$Ui$Grid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(4),
												$author$project$Ui$Grid$spanSm(2),
												$author$project$Ui$Grid$spanMd(3)
											]),
										_List_fromArray(
											[
												$author$project$Pages$Admin$Coupons$viewArchivedDropdown(model)
											]))
									]))
							])),
						$author$project$Pages$Admin$Coupons$viewPanelTable(model)
					]))
			]),
		ac9: 'Admin | Coupons'
	};
};
var $author$project$Pages$Admin$Coupons$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Coupons$init, aiq: $author$project$Pages$Admin$Coupons$load, k8: $author$project$Pages$Admin$Coupons$save, alO: $author$project$Pages$Admin$Coupons$subscriptions, adT: $author$project$Pages$Admin$Coupons$update, amo: $author$project$Pages$Admin$Coupons$view});
var $author$project$Pages$Admin$CoveragePlans$Id_String$CoveragePlanFormMsg = $elm$core$Basics$identity;
var $author$project$Components$Admin$CoveragePlans$Form$CoverageRulesMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Admin$CoveragePlans$Form$GotCoveragePlan = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$CoveragePlans$Form$Model = $elm$core$Basics$identity;
var $author$project$Components$Admin$CoveragePlans$Form$GotPlans = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Admin$CoveragePlans$Form$fetchPlans = F2(
	function (apiClient, model) {
		var params = function (d) {
			return _Utils_update(
				d,
				{
					GA: $elm$core$Maybe$Just(
						A2($elm$core$Maybe$withDefault, '', model.ahP)),
					ajJ: model.ajJ,
					akl: model.tT,
					alA: $author$project$Api$Sort$init
				});
		};
		return A3($author$project$Api$Provider$Plan$list, apiClient, params, $author$project$Components$Admin$CoveragePlans$Form$GotPlans);
	});
var $author$project$Components$Admin$CoveragePlans$Form$formFieldsInit = {aeP: false, Bq: '', ZG: _List_Nil};
var $author$project$Components$Admin$CoveragePlans$Rules$CoverageRuleFormMsg = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm_community$list_extra$List$Extra$indexedFoldr = F3(
	function (func, acc, list) {
		var step = F2(
			function (x, _v0) {
				var i = _v0.a;
				var thisAcc = _v0.b;
				return _Utils_Tuple2(
					i - 1,
					A3(func, i, x, thisAcc));
			});
		return A3(
			$elm$core$List$foldr,
			step,
			_Utils_Tuple2(
				$elm$core$List$length(list) - 1,
				acc),
			list).b;
	});
var $author$project$Components$Admin$CoverageRules$Form$CategoryResourceFilterMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$CoverageRules$Form$ChargeItemResourceFilterMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$CoverageRules$Form$Creating = 0;
var $author$project$Components$Admin$CoverageRules$Form$Model = $elm$core$Basics$identity;
var $author$project$Components$Admin$CoverageRules$Form$ResourceFilterPreSelected = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Admin$CoverageRules$Form$RuleTypeDropdownMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$CoverageRules$Form$Viewing = 2;
var $author$project$Api$Provider$CoverageRule$Shared$category = function (_v0) {
	var record = _v0;
	return record.GW;
};
var $author$project$Api$Provider$CoverageRule$One$category = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CoverageRule$Shared$category(shared);
};
var $author$project$Api$Provider$CoverageRule$Shared$Patient = 0;
var $author$project$Components$Admin$CoverageRules$Form$initFormFields = {LE: $elm$core$Maybe$Nothing, d2: 0, ahP: $elm$core$Maybe$Nothing, Io: $elm$core$Maybe$Nothing, sW: 'charge_category', ajZ: $elm$core$Maybe$Nothing, Dz: $elm$core$Maybe$Nothing, ak7: $elm$core$Maybe$Nothing, al4: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$CoverageRule$Shared$Sponsor = 1;
var $author$project$Api$Provider$CoverageRule$Shared$buildCoveredBy = F2(
	function (patientPercentage, sponsorPercentage) {
		var _v0 = _Utils_Tuple2(patientPercentage, sponsorPercentage);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var patientContributionPercentage_ = _v0.a.a;
			var sponsorContributionPercentage_ = _v0.b.a;
			return (_Utils_cmp(patientContributionPercentage_, sponsorContributionPercentage_) > 0) ? 0 : 1;
		} else {
			return 0;
		}
	});
var $author$project$Api$Provider$CoverageRule$Shared$coveredBy = function (_v0) {
	var record = _v0;
	return A2($author$project$Api$Provider$CoverageRule$Shared$buildCoveredBy, record.ajS, record.alE);
};
var $author$project$Api$Provider$CoverageRule$One$coveredBy = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CoverageRule$Shared$coveredBy(shared);
};
var $author$project$Api$Provider$CoverageRule$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$CoverageRule$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CoverageRule$Shared$id(shared);
};
var $author$project$Components$Admin$CoverageRules$Form$ruleTypeIdToValue = function (ruleTypeOption) {
	var id = ruleTypeOption.ahP;
	return $elm$core$Maybe$Just(id);
};
var $author$project$Components$Admin$CoverageRules$Form$ruleTypeIncludedOption = function (ruleTypeOption) {
	var includedOption = ruleTypeOption.ez;
	return includedOption;
};
var $author$project$Components$Admin$CoverageRules$Form$RuleType = $elm$core$Basics$identity;
var $author$project$Components$Admin$CoverageRules$Form$ruleTypeOptions = _List_fromArray(
	[
		{
		ahP: 'included',
		ez: $elm$core$Maybe$Just(0),
		Bq: 'Included at no additional cost'
	},
		{
		ahP: 'included',
		ez: $elm$core$Maybe$Just(1),
		Bq: 'Included if they cost less than'
	},
		{ahP: 'discounted', ez: $elm$core$Maybe$Nothing, Bq: 'Discounted'},
		{ahP: 'surcharge', ez: $elm$core$Maybe$Nothing, Bq: 'Surcharged'},
		{ahP: 'flat_amount', ez: $elm$core$Maybe$Nothing, Bq: 'Charged a flat amount'},
		{ahP: 'pass_through', ez: $elm$core$Maybe$Nothing, Bq: 'Passed through at cost'},
		{ahP: 'limited_quantity', ez: $elm$core$Maybe$Nothing, Bq: 'Limited to a quantity'}
	]);
var $author$project$Components$Admin$CoverageRules$Form$initFormFieldsFromRule = function (coverageRule) {
	var timePeriod = $author$project$Api$Provider$CoverageRule$One$timePeriod(coverageRule);
	var ruleType = $elm$core$List$head(
		A2(
			$elm$core$List$filter,
			function (option) {
				return _Utils_eq(
					A2(
						$elm$core$Maybe$withDefault,
						'',
						$author$project$Components$Admin$CoverageRules$Form$ruleTypeIdToValue(option)),
					$author$project$Api$Provider$CoverageRule$One$ruleType(coverageRule)) && _Utils_eq(
					$author$project$Components$Admin$CoverageRules$Form$ruleTypeIncludedOption(option),
					$author$project$Api$Provider$CoverageRule$One$includedOption(coverageRule));
			},
			$author$project$Components$Admin$CoverageRules$Form$ruleTypeOptions));
	var quantity = $author$project$Api$Provider$CoverageRule$One$quantity(coverageRule);
	var percentage = $author$project$Api$Provider$CoverageRule$One$percentage(coverageRule);
	var id = $author$project$Api$Provider$CoverageRule$One$id(coverageRule);
	var coveredBy = $author$project$Api$Provider$CoverageRule$One$coveredBy(coverageRule);
	var amountInCents = A2(
		$elm$core$Maybe$map,
		$author$project$Currency$fromInt,
		$author$project$Api$Provider$CoverageRule$One$amountInCents(coverageRule));
	var _v0 = function () {
		var _v1 = $author$project$Api$Provider$CoverageRule$One$item(coverageRule);
		if (_v1.$ === 1) {
			var category_ = _v1.a;
			return _Utils_Tuple2(
				$elm$core$Maybe$Just(
					{
						ahP: $author$project$Api$Provider$Category$Shared$id(category_),
						Bq: $author$project$Api$Provider$Category$Shared$name(category_)
					}),
				'charge_category');
		} else {
			var chargeItem = _v1.a;
			return _Utils_Tuple2(
				$elm$core$Maybe$Just(
					{
						ahP: $author$project$Api$Provider$ChargeItem$Shared$id(chargeItem),
						Bq: $author$project$Api$Provider$ChargeItem$Shared$name(chargeItem)
					}),
				'charge_item');
		}
	}();
	var item = _v0.a;
	var itemType = _v0.b;
	return {
		LE: amountInCents,
		d2: coveredBy,
		ahP: $elm$core$Maybe$Just(id),
		Io: item,
		sW: itemType,
		ajZ: percentage,
		Dz: quantity,
		ak7: ruleType,
		al4: timePeriod
	};
};
var $author$project$Api$Provider$CoverageRule$One$unpublishedCoveredBy = function (_v0) {
	var record = _v0.b;
	var _v1 = record.Kh;
	if (!_v1.$) {
		var unpublishedRule_ = _v1.a;
		return A2(
			$author$project$Api$Provider$CoverageRule$Shared$buildCoveredBy,
			$author$project$Api$Provider$CoverageRule$Shared$patientContributionPercentage(unpublishedRule_),
			$author$project$Api$Provider$CoverageRule$Shared$sponsorContributionPercentage(unpublishedRule_));
	} else {
		return 0;
	}
};
var $author$project$Api$Provider$CoverageRule$One$unpublishedRule = function (_v0) {
	var record = _v0.b;
	return record.Kh;
};
var $author$project$Components$Admin$CoverageRules$Form$initUnpublishedRuleForm = function (coverageRule) {
	var coverageRuleFields = $author$project$Components$Admin$CoverageRules$Form$initFormFieldsFromRule(coverageRule);
	var initForm = function (unpublishedRule) {
		var unpublishedRuleId = $author$project$Api$Provider$CoverageRule$Shared$id(unpublishedRule);
		return _Utils_eq(
			coverageRuleFields.ahP,
			$elm$core$Maybe$Just(unpublishedRuleId)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			$author$project$Utils$Form$init(
				_Utils_update(
					coverageRuleFields,
					{
						LE: A2(
							$elm$core$Maybe$map,
							$author$project$Currency$fromInt,
							$author$project$Api$Provider$CoverageRule$Shared$amountInCents(unpublishedRule)),
						d2: $author$project$Api$Provider$CoverageRule$One$unpublishedCoveredBy(coverageRule),
						ahP: $elm$core$Maybe$Just(unpublishedRuleId),
						ajZ: $author$project$Api$Provider$CoverageRule$Shared$percentage(unpublishedRule)
					})));
	};
	return A2(
		$elm$core$Maybe$andThen,
		initForm,
		$author$project$Api$Provider$CoverageRule$One$unpublishedRule(coverageRule));
};
var $author$project$Api$Provider$CoverageRule$Shared$isPublished = function (_v0) {
	var record = _v0;
	return record._I;
};
var $author$project$Api$Provider$CoverageRule$One$isPublished = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CoverageRule$Shared$isPublished(shared);
};
var $author$project$Components$Admin$CoverageRules$Form$ruleIsUnpublished = function (coverageRule) {
	return $elm$core$Maybe$Just(
		!$author$project$Api$Provider$CoverageRule$One$isPublished(coverageRule));
};
var $author$project$Components$Admin$CoverageRules$Form$wasCreatedWithoutPublishing = function (coverageRule) {
	return $elm$core$Maybe$Just(
		_Utils_eq(
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function (r) {
						return $author$project$Api$Provider$CoverageRule$Shared$id(r);
					},
					$author$project$Api$Provider$CoverageRule$One$unpublishedRule(coverageRule))),
			$author$project$Api$Provider$CoverageRule$One$id(coverageRule)));
};
var $author$project$Components$Admin$CoverageRules$Form$init = F6(
	function (apiClient, session, maybeCoverageRule, coveragePlanId, _v0, coverageRuleUsage) {
		var readOnly = _v0._6;
		var ruleTypeDropdown = $author$project$Ui$Dropdown$init(
			$author$project$Ui$Dropdown$defaultConfig(
				{ahP: 'rule-type-dropdown', al6: $author$project$Components$Admin$CoverageRules$Form$RuleTypeDropdownMsg}));
		var newUnpublishedRule = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2($elm$core$Maybe$andThen, $author$project$Components$Admin$CoverageRules$Form$wasCreatedWithoutPublishing, maybeCoverageRule));
		var wasDeleted = (!newUnpublishedRule) && A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$andThen, $author$project$Components$Admin$CoverageRules$Form$ruleIsUnpublished, maybeCoverageRule));
		var editMode = _Utils_eq(maybeCoverageRule, $elm$core$Maybe$Nothing) ? 0 : 2;
		var category_ = A2(
			$elm$core$Maybe$map,
			function (categoryMin) {
				return {
					ahP: $author$project$Api$Provider$Category$Min$id(categoryMin),
					Bq: $author$project$Api$Provider$Category$Min$name(categoryMin)
				};
			},
			A2($elm$core$Maybe$andThen, $author$project$Api$Provider$CoverageRule$One$category, maybeCoverageRule));
		var _v1 = function () {
			if (!maybeCoverageRule.$) {
				var coverageRule = maybeCoverageRule.a;
				return _Utils_Tuple3(
					$author$project$Utils$Form$init(
						$author$project$Components$Admin$CoverageRules$Form$initFormFieldsFromRule(coverageRule)),
					$author$project$Components$Admin$CoverageRules$Form$initUnpublishedRuleForm(coverageRule),
					A2(
						$elm$core$Task$perform,
						$author$project$Components$Admin$CoverageRules$Form$ResourceFilterPreSelected,
						$elm$core$Task$succeed(coverageRule)));
			} else {
				return _Utils_Tuple3(
					$author$project$Utils$Form$init($author$project$Components$Admin$CoverageRules$Form$initFormFields),
					$elm$core$Maybe$Nothing,
					$elm$core$Platform$Cmd$none);
			}
		}();
		var form = _v1.a;
		var editedForm = _v1.b;
		var resourceFilterPreSelectCmd = _v1.c;
		var _v3 = A3(
			$author$project$Components$ResourceFilter$ChargeItem$init,
			apiClient,
			function (opts) {
				return _Utils_update(
					opts,
					{
						sW: $elm$core$Maybe$Just('item')
					});
			},
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Select a Charge Item'});
			});
		var chargeItemResourceFilter = _v3.a;
		var chargeItemResourceFilterCmd = _v3.b;
		var _v4 = A3(
			$author$project$Components$ResourceFilter$Category$init,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Select a Category'});
			});
		var categoryResourceFilter = _v4.a;
		var categoryResourceFilterCmd = _v4.b;
		return _Utils_Tuple2(
			{GW: category_, c8: categoryResourceFilter, cq: chargeItemResourceFilter, yV: coveragePlanId, OU: maybeCoverageRule, G5: coverageRuleUsage, a7: wasDeleted, a9: editMode, SD: form, cM: newUnpublishedRule, _6: readOnly, pM: ruleTypeDropdown, pN: '', aa4: session, Z: editedForm},
			(editMode === 2) ? resourceFilterPreSelectCmd : $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoverageRules$Form$ChargeItemResourceFilterMsg, chargeItemResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoverageRules$Form$CategoryResourceFilterMsg, categoryResourceFilterCmd),
						resourceFilterPreSelectCmd
					])));
	});
var $author$project$Api$Provider$CoverageRuleUsage$Shared$coverageRule = function (_v0) {
	var record = _v0;
	return record.OU;
};
var $author$project$Api$Provider$CoverageRuleUsage$All$coverageRule = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CoverageRuleUsage$Shared$coverageRule(shared);
};
var $author$project$Components$Admin$CoveragePlans$Rules$selectCoverageRuleUsage = F2(
	function (coverageRule, coverageRuleUsages) {
		return A2(
			$elm$core$Maybe$andThen,
			function (coverageRuleUsages_) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (usage) {
							return _Utils_eq(
								$author$project$Api$Provider$CoverageRule$One$id(
									$author$project$Api$Provider$CoverageRuleUsage$All$coverageRule(usage)),
								$author$project$Api$Provider$CoverageRule$One$id(coverageRule));
						},
						coverageRuleUsages_));
			},
			coverageRuleUsages);
	});
var $author$project$Components$Admin$CoveragePlans$Rules$init = F6(
	function (apiClient, session, coveragePlanId, coverageRules, coverageRuleUsages, _v0) {
		var readOnly = _v0._6;
		var filteredRules = readOnly ? A2($elm$core$List$filter, $author$project$Api$Provider$CoverageRule$One$isPublished, coverageRules) : coverageRules;
		var _v1 = A3(
			$elm_community$list_extra$List$Extra$indexedFoldr,
			F3(
				function (index, rule, _v2) {
					var forms = _v2.a;
					var cmds = _v2.b;
					var _v3 = A6(
						$author$project$Components$Admin$CoverageRules$Form$init,
						apiClient,
						session,
						$elm$core$Maybe$Just(rule),
						coveragePlanId,
						{_6: readOnly},
						A2($author$project$Components$Admin$CoveragePlans$Rules$selectCoverageRuleUsage, rule, coverageRuleUsages));
					var form = _v3.a;
					var cmd = _v3.b;
					var cmd_ = A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Components$Admin$CoveragePlans$Rules$CoverageRuleFormMsg(index),
						cmd);
					return _Utils_Tuple2(
						A2($elm$core$List$cons, form, forms),
						A2($elm$core$List$cons, cmd_, cmds));
				}),
			_Utils_Tuple2(_List_Nil, _List_Nil),
			filteredRules);
		var coverageRuleForms = _v1.a;
		var cmds_ = _v1.b;
		return _Utils_Tuple2(
			{yV: coveragePlanId, OV: coverageRuleUsages, afY: coverageRuleForms, _6: readOnly, aa4: session},
			$elm$core$Platform$Cmd$batch(cmds_));
	});
var $author$project$Components$Admin$CoveragePlans$Form$initPagination = A2($author$project$Api$Pagination$withItemsPerPage, 5, $author$project$Api$Pagination$init);
var $author$project$Api$Provider$CoveragePlan$coveragePlanPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$CoveragePlan$coveragePlansPath);
};
var $author$project$Api$Provider$CoveragePlan$retrieve = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$CoveragePlan$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$CoveragePlan$coveragePlanPath(id_)));
	});
var $author$project$Components$Admin$CoveragePlans$Form$init = F4(
	function (apiClient, session, practice, id) {
		var _v0 = function () {
			if (!id.$) {
				var id_ = id.a;
				var cmd = A3($author$project$Api$Provider$CoveragePlan$retrieve, apiClient, id_, $author$project$Components$Admin$CoveragePlans$Form$GotCoveragePlan);
				return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, cmd);
			} else {
				var _v2 = A6(
					$author$project$Components$Admin$CoveragePlans$Rules$init,
					apiClient,
					session,
					$elm$core$Maybe$Nothing,
					_List_Nil,
					$elm$core$Maybe$Nothing,
					{_6: false});
				var coverageRulesModel_ = _v2.a;
				var coverageRulesCmd_ = _v2.b;
				var cmd = A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoveragePlans$Form$CoverageRulesMsg, coverageRulesCmd_);
				return _Utils_Tuple3(
					$elm$core$Maybe$Just($author$project$Components$Admin$CoveragePlans$Form$formFieldsInit),
					$elm$core$Maybe$Just(coverageRulesModel_),
					cmd);
			}
		}();
		var formFields = _v0.a;
		var coverageRules = _v0.b;
		var command = _v0.c;
		var model = {
			OS: $elm$core$Maybe$Nothing,
			OT: $elm$core$Maybe$Nothing,
			afY: coverageRules,
			i5: $jinjor$elm_debounce$Debounce$init,
			SD: A2($elm$core$Maybe$map, $author$project$Utils$Form$init, formFields),
			ahP: id,
			ajJ: $author$project$Components$Admin$CoveragePlans$Form$initPagination,
			hh: _List_Nil,
			tT: $elm$core$Maybe$Nothing,
			ZG: $author$project$Api$Data$Loading,
			ZV: practice,
			El: false,
			us: false,
			aa4: session
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						command,
						A2($author$project$Components$Admin$CoveragePlans$Form$fetchPlans, apiClient, model)
					])));
	});
var $author$project$Pages$Admin$CoveragePlans$Id_String$init = F4(
	function (session, practice, _v0, _v1) {
		var apiClient = _v0.Gv;
		var params = _v1.YL;
		var _v2 = A4(
			$author$project$Components$Admin$CoveragePlans$Form$init,
			apiClient,
			session,
			practice,
			$elm$core$Maybe$Just(params.ahP));
		var form = _v2.a;
		var cmd = _v2.b;
		return _Utils_Tuple2(
			{Gv: apiClient, SD: form},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
	});
var $author$project$Pages$Admin$CoveragePlans$Id_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $elm$core$Basics$xor = _Basics_xor;
var $author$project$Components$Admin$CoverageRules$Form$isUnpublished = function (_v0) {
	var model = _v0;
	return (!_Utils_eq(model.Z, $elm$core$Maybe$Nothing)) || (model.cM !== model.a7);
};
var $author$project$Components$Admin$CoveragePlans$Rules$unpublishedRulesExists = function (model) {
	return A2(
		$elm$core$List$any,
		function (rule) {
			return $author$project$Components$Admin$CoverageRules$Form$isUnpublished(rule);
		},
		model.afY);
};
var $author$project$Components$Admin$CoveragePlans$Form$save = F2(
	function (_v0, shared) {
		var model = _v0;
		var pendingChangesExists = (!model.El) && A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, $author$project$Components$Admin$CoveragePlans$Rules$unpublishedRulesExists, model.afY));
		return _Utils_update(
			shared,
			{
				ajY: pendingChangesExists ? $elm$core$Maybe$Just('You have draft changes to your coverage plan. If you would like to publish these changes, click the publish button at the bottom of the page.') : $elm$core$Maybe$Nothing
			});
	});
var $author$project$Pages$Admin$CoveragePlans$Id_String$save = F2(
	function (_v0, shared) {
		var form = _v0.SD;
		return A2($author$project$Components$Admin$CoveragePlans$Form$save, form, shared);
	});
var $author$project$Components$Admin$CoveragePlans$Form$CoverageDocumentsMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Admin$CoverageDocuments$Form$DeleteHiConfirmClosed = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Admin$CoverageDocuments$Form$DocumentUploadModalMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$CoverageDocuments$UploadModal$Close = {$: 0};
var $author$project$Components$Admin$CoverageDocuments$UploadModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$CoverageDocuments$UploadModal$Close);
};
var $author$project$Components$Admin$CoverageDocuments$Form$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Admin$CoverageDocuments$Form$DocumentUploadModalMsg,
				$author$project$Components$Admin$CoverageDocuments$UploadModal$subscriptions(model.da)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Admin$CoverageDocuments$Form$DeleteHiConfirmClosed),
					A2($elm$core$Maybe$map, $elm$core$Tuple$first, model.f7)))
			]));
};
var $author$project$Components$Admin$CoverageRules$Form$AttemptedCancel = {$: 15};
var $author$project$Components$Admin$CoverageRules$Form$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				function () {
				var _v1 = model.a9;
				switch (_v1) {
					case 0:
						return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$CoverageRules$Form$AttemptedCancel);
					case 1:
						return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$CoverageRules$Form$AttemptedCancel);
					default:
						return $elm$core$Platform$Sub$none;
				}
			}(),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Admin$CoverageRules$Form$CategoryResourceFilterMsg,
				$author$project$Components$ResourceFilter$Category$subscriptions(model.c8)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Admin$CoverageRules$Form$ChargeItemResourceFilterMsg,
				$author$project$Components$ResourceFilter$ChargeItem$subscriptions(model.cq)),
				$author$project$Ui$Dropdown$subscriptions(model.pM)
			]));
};
var $author$project$Components$Admin$CoveragePlans$Rules$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		A2(
			$elm$core$List$indexedMap,
			F2(
				function (index, rule) {
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Components$Admin$CoveragePlans$Rules$CoverageRuleFormMsg(index),
						$author$project$Components$Admin$CoverageRules$Form$subscriptions(rule));
				}),
			model.afY));
};
var $author$project$Components$Admin$CoveragePlans$Form$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Admin$CoveragePlans$Form$CoverageRulesMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Admin$CoveragePlans$Rules$subscriptions, model.afY))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Admin$CoveragePlans$Form$CoverageDocumentsMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Admin$CoverageDocuments$Form$subscriptions, model.OS)))
			]));
};
var $author$project$Pages$Admin$CoveragePlans$Id_String$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Admin$CoveragePlans$Form$subscriptions(model.SD));
};
var $author$project$Components$Admin$CoveragePlans$Form$AllPlans = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$CoveragePlans$Form$PlanAdd = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$CoveragePlans$Form$PlanRemove = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$CoveragePlan$One$coverageDocuments = function (_v0) {
	var record = _v0.b;
	return record.OS;
};
var $author$project$Components$Admin$CoveragePlans$Form$DebounceMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Admin$CoveragePlans$Form$debounceConfig = {
	alK: $jinjor$elm_debounce$Debounce$later(300),
	ame: $author$project$Components$Admin$CoveragePlans$Form$DebounceMsg
};
var $author$project$Components$Admin$CoveragePlans$Form$TextDebounced = {$: 12};
var $author$project$Components$Admin$CoveragePlans$Form$debounceText = function (text) {
	return A2(
		$elm$core$Task$perform,
		function (_v0) {
			return $author$project$Components$Admin$CoveragePlans$Form$TextDebounced;
		},
		$elm$core$Task$succeed(text));
};
var $author$project$Api$Provider$CoveragePlan$One$plans = function (_v0) {
	var record = _v0.b;
	return record.ZG;
};
var $author$project$Components$Admin$CoveragePlans$Form$formFieldsFromItem = function (coveragePlan) {
	return {
		aeP: false,
		Bq: $author$project$Api$Provider$CoveragePlan$One$name(coveragePlan),
		ZG: A2(
			$elm$core$List$map,
			function (plan) {
				return {
					ahP: $author$project$Api$Provider$Plan$Min$id(plan),
					Bq: $author$project$Api$Provider$Plan$Min$name(plan)
				};
			},
			$author$project$Api$Provider$CoveragePlan$One$plans(coveragePlan))
	};
};
var $author$project$Components$Admin$CoveragePlans$Form$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{Bq: string});
			case 1:
				var plan = field.a;
				var plan_ = A2(
					$elm_community$list_extra$List$Extra$find,
					function (plan__) {
						return _Utils_eq(plan__.ahP, plan.ahP);
					},
					fields.ZG);
				var plans = function () {
					if (!plan_.$) {
						return fields.ZG;
					} else {
						return A2(
							$elm$core$List$cons,
							{ahP: plan.ahP, Bq: plan.Bq},
							fields.ZG);
					}
				}();
				return _Utils_update(
					fields,
					{ZG: plans});
			case 2:
				var id = field.a;
				return _Utils_update(
					fields,
					{
						ZG: A2(
							$elm_community$list_extra$List$Extra$filterNot,
							function (plan) {
								return _Utils_eq(plan.ahP, id);
							},
							fields.ZG)
					});
			default:
				var bool = field.a;
				return _Utils_update(
					fields,
					{aeP: bool});
		}
	});
var $author$project$Components$Admin$CoveragePlans$Form$NameValidation = 0;
var $author$project$Components$Admin$CoveragePlans$Form$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.Bq;
			},
			_Utils_Tuple2(0, 'Please enter a name.'))
		]));
var $author$project$Components$Admin$CoverageDocuments$Form$Model = $elm$core$Basics$identity;
var $author$project$Components$Admin$CoverageDocuments$UploadModal$Model = $elm$core$Basics$identity;
var $author$project$Api$Provider$CoverageDocument$Shared$fileName = function (_v0) {
	var record = _v0;
	return record.Sn;
};
var $author$project$Components$Admin$CoverageDocuments$UploadModal$initFormFields = function (coverageDocument) {
	if (!coverageDocument.$) {
		var coverageDocument_ = coverageDocument.a;
		return {
			ahj: $elm$core$Maybe$Nothing,
			Sn: $author$project$Api$Provider$CoverageDocument$Shared$fileName(coverageDocument_)
		};
	} else {
		return {ahj: $elm$core$Maybe$Nothing, Sn: ''};
	}
};
var $author$project$Components$Admin$CoverageDocuments$UploadModal$init = F2(
	function (coveragePlanId, coverageDocument) {
		var fields = $author$project$Components$Admin$CoverageDocuments$UploadModal$initFormFields(coverageDocument);
		return {
			rL: coverageDocument,
			yV: coveragePlanId,
			SD: $author$project$Utils$Form$init(fields),
			k9: $author$project$Api$Data$NotAsked
		};
	});
var $author$project$Components$Admin$CoverageDocuments$Form$init = F5(
	function (_v0, session, coveragePlanId, coverageDocuments, displayUploadModal) {
		return _Utils_Tuple2(
			{
				da: A2($author$project$Components$Admin$CoverageDocuments$UploadModal$init, coveragePlanId, $elm$core$Maybe$Nothing),
				OS: coverageDocuments,
				yV: coveragePlanId,
				f7: $elm$core$Maybe$Nothing,
				jr: displayUploadModal,
				aa4: session
			},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Components$Admin$CoveragePlans$Form$onSaved = F3(
	function (response, model, successMsg) {
		var _v0 = model.SD;
		if (!_v0.$) {
			if (response.$ === 3) {
				var coveragePlan = response.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{El: true}),
					A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__CoveragePlans__Top),
					_List_fromArray(
						[
							A2(
							$author$project$OutMsg$ShowToast,
							3,
							_Utils_ap(
								$author$project$Api$Provider$CoveragePlan$One$name(coveragePlan),
								successMsg))
						]));
			} else {
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			}
		} else {
			return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Components$Admin$CoveragePlans$Form$Created = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$CoveragePlans$Form$Updated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$CoveragePlan$save = F4(
	function (apiClient, maybeId, fields, toMsg) {
		var encodeCoverageRule = function (coverageRule) {
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'id',
						A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, coverageRule.ahP)),
						_Utils_Tuple2(
						'amount_in_cents',
						A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, coverageRule.LE)),
						_Utils_Tuple2(
						'time_period',
						A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, coverageRule.al4)),
						_Utils_Tuple2(
						'quantity',
						A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, coverageRule.Dz)),
						_Utils_Tuple2(
						'percentage',
						$elm$json$Json$Encode$string(coverageRule.ajZ)),
						_Utils_Tuple2(
						'patient_contribution_percentage',
						$elm$json$Json$Encode$string(coverageRule.ajS)),
						_Utils_Tuple2(
						'sponsor_contribution_percentage',
						$elm$json$Json$Encode$string(coverageRule.alE)),
						_Utils_Tuple2(
						'rule_type',
						$elm$json$Json$Encode$string(coverageRule.ak7)),
						_Utils_Tuple2(
						'item',
						$author$project$Utils$Encode$typedAssociation(coverageRule.Io))
					]));
		};
		var encodedCoverageRules = function () {
			if (!maybeId.$) {
				return _List_Nil;
			} else {
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'coverage_rules',
						A2($elm$json$Json$Encode$list, encodeCoverageRule, fields.afY))
					]);
			}
		}();
		var body_ = $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(fields.Bq)),
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						'plans',
						A2($elm$json$Json$Encode$list, $author$project$Utils$Encode$association, fields.ZG)),
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'all_plans',
							$elm$json$Json$Encode$bool(fields.aeP)),
						encodedCoverageRules))));
		if (!maybeId.$) {
			var id_ = maybeId.a;
			return A4(
				$author$project$Api$Data$put,
				apiClient,
				$author$project$Api$Provider$CoveragePlan$One$decoder,
				toMsg,
				A2(
					$author$project$Api$Data$requestWithJson,
					body_,
					$author$project$Api$Data$requestTo(
						$author$project$Api$Provider$CoveragePlan$coveragePlanPath(id_))));
		} else {
			return A4(
				$author$project$Api$Data$post,
				apiClient,
				$author$project$Api$Provider$CoveragePlan$One$decoder,
				toMsg,
				A2(
					$author$project$Api$Data$requestWithJson,
					body_,
					$author$project$Api$Data$requestTo($author$project$Api$Provider$CoveragePlan$coveragePlansPath)));
		}
	});
var $author$project$Components$Admin$CoverageRules$Form$isDeleted = function (_v0) {
	var model = _v0;
	return model.a7;
};
var $author$project$Components$Admin$CoverageRules$Form$formToParams = F3(
	function (form, deleted, publishedRule) {
		var fields = $author$project$Utils$Form$fields(form);
		var itemId = function () {
			var _v5 = fields.Io;
			if (!_v5.$) {
				var item = _v5.a;
				return item.ahP;
			} else {
				return '';
			}
		}();
		var percentage = $elm$core$String$fromFloat(
			A2($elm$core$Maybe$withDefault, 0.0, fields.ajZ));
		var ruleType = function () {
			var _v4 = fields.ak7;
			if (!_v4.$) {
				var ruleType_ = _v4.a;
				return A2(
					$elm$core$Maybe$withDefault,
					'',
					$author$project$Components$Admin$CoverageRules$Form$ruleTypeIdToValue(ruleType_));
			} else {
				return '';
			}
		}();
		var timePeriod = function () {
			var _v1 = fields.al4;
			if (!_v1.$) {
				if (!_v1.a) {
					var _v2 = _v1.a;
					return $elm$core$Maybe$Just('beginning_of_year');
				} else {
					var _v3 = _v1.a;
					return $elm$core$Maybe$Just('membership_renewal_date');
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var typeIncludedOption = A2($elm$core$Maybe$andThen, $author$project$Components$Admin$CoverageRules$Form$ruleTypeIncludedOption, fields.ak7);
		var amountInCents = ((ruleType === 'included') && _Utils_eq(
			typeIncludedOption,
			$elm$core$Maybe$Just(0))) ? $elm$core$Maybe$Nothing : fields.LE;
		var _v0 = (!fields.d2) ? _Utils_Tuple2('100', '0') : _Utils_Tuple2('0', '100');
		var patientContribution = _v0.a;
		var sponsorContribution = _v0.b;
		return {
			LE: amountInCents,
			Qu: deleted,
			ahP: fields.ahP,
			Io: {
				ahP: $elm$core$Maybe$Just(itemId),
				amg: $elm$core$Maybe$Just(fields.sW)
			},
			ajS: patientContribution,
			ajZ: percentage,
			_J: publishedRule,
			Dz: fields.Dz,
			ak7: ruleType,
			alE: sponsorContribution,
			al4: timePeriod
		};
	});
var $author$project$Components$Admin$CoverageRules$Form$toParams = function (_v0) {
	var model = _v0;
	return A3($author$project$Components$Admin$CoverageRules$Form$formToParams, model.SD, model.a7, $elm$core$Maybe$Nothing);
};
var $author$project$Components$Admin$CoveragePlans$Rules$toParams = function (model) {
	var notDeletedRules = A2(
		$elm$core$List$filter,
		function (rule) {
			return !$author$project$Components$Admin$CoverageRules$Form$isDeleted(rule);
		},
		model.afY);
	return A2($elm$core$List$map, $author$project$Components$Admin$CoverageRules$Form$toParams, notDeletedRules);
};
var $author$project$Components$Admin$CoveragePlans$Form$saveCoveragePlan = F4(
	function (apiClient, maybeId, formFields, coverageRules) {
		var msg = function () {
			if (!maybeId.$) {
				return $author$project$Components$Admin$CoveragePlans$Form$Updated;
			} else {
				return $author$project$Components$Admin$CoveragePlans$Form$Created;
			}
		}();
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var apiFields = {
			aeP: fields.aeP,
			afY: $author$project$Components$Admin$CoveragePlans$Rules$toParams(coverageRules),
			Bq: fields.Bq,
			ZG: A2(
				$elm$core$List$map,
				function (plan) {
					return plan.ahP;
				},
				fields.ZG)
		};
		return A4($author$project$Api$Provider$CoveragePlan$save, apiClient, maybeId, apiFields, msg);
	});
var $author$project$Components$Admin$CoverageDocuments$Form$DeletedCoverageDocument = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Admin$CoverageDocuments$Form$DocumentDeleted = 1;
var $author$project$Components$Admin$CoverageDocuments$Form$DocumentSaved = 2;
var $author$project$Components$Admin$CoverageDocuments$Form$None = 0;
var $author$project$Api$Provider$CoverageDocument$coverageDocumentsPath = function (coveragePlanId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['coverage_documents']),
		A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[coveragePlanId]),
			A2(
				$author$project$Api$Data$pathAppend,
				_List_fromArray(
					['coverage_plans']),
				$author$project$Api$Data$providerPath)));
};
var $author$project$Api$Provider$CoverageDocument$delete = F4(
	function (apiClient, coveragePlanId, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						[id]),
					$author$project$Api$Provider$CoverageDocument$coverageDocumentsPath(coveragePlanId))));
	});
var $author$project$Api$Provider$CoverageDocument$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Components$Admin$CoverageDocuments$UploadModal$Closed = 0;
var $author$project$Components$Admin$CoverageDocuments$UploadModal$File = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$CoverageDocuments$UploadModal$FileNameValidation = 1;
var $author$project$Components$Admin$CoverageDocuments$UploadModal$FileValidation = 0;
var $author$project$Components$Admin$CoverageDocuments$UploadModal$None = 1;
var $author$project$Components$Admin$CoverageDocuments$UploadModal$UploadCreated = 2;
var $author$project$Components$Admin$CoverageDocuments$UploadModal$UploadUpdated = 3;
var $author$project$Components$Admin$CoverageDocuments$UploadModal$Created = function (a) {
	return {$: 4, a: a};
};
var $elm_community$string_extra$String$Extra$clean = function (string) {
	return $elm$core$String$trim(
		A3(
			$elm$regex$Regex$replace,
			$elm_community$string_extra$String$Extra$regexFromString('\\s\\s+'),
			$elm$core$Basics$always(' '),
			string));
};
var $author$project$Api$Data$Multipart = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Data$requestMultipartBody = F2(
	function (parts, _v0) {
		var request = _v0;
		return _Utils_update(
			request,
			{
				fO: $elm$core$Maybe$Just(
					$author$project$Api$Data$Multipart(parts))
			});
	});
var $elm$http$Http$stringPart = _Http_pair;
var $author$project$Api$Provider$CoverageDocument$createUpload = F4(
	function (apiClient, coveragePlanId, fields, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestMultipartBody,
				function () {
					var _v0 = fields.ahj;
					if (!_v0.$) {
						var file = _v0.a;
						return _List_fromArray(
							[
								A2($elm$http$Http$filePart, 'coverage_document[pdf_upload]', file),
								A2($elm$http$Http$stringPart, 'coverage_document[file_name]', fields.Sn)
							]);
					} else {
						return _List_Nil;
					}
				}(),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$CoverageDocument$coverageDocumentsPath(coveragePlanId))));
	});
var $author$project$Components$Admin$CoverageDocuments$UploadModal$createUpload = F3(
	function (apiClient, coveragePlanId, validFormFields) {
		var _v0 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
		var file = _v0.ahj;
		var fileName = _v0.Sn;
		return A4(
			$author$project$Api$Provider$CoverageDocument$createUpload,
			apiClient,
			coveragePlanId,
			{
				ahj: file,
				Sn: $elm_community$string_extra$String$Extra$clean(fileName)
			},
			$author$project$Components$Admin$CoverageDocuments$UploadModal$Created);
	});
var $author$project$Components$Admin$CoverageDocuments$UploadModal$Updated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$CoverageDocument$update = F5(
	function (apiClient, coveragePlanId, id, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'coverage_document',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'file_name',
								$elm$json$Json$Encode$string(fields.Sn))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							[id]),
						$author$project$Api$Provider$CoverageDocument$coverageDocumentsPath(coveragePlanId)))));
	});
var $author$project$Components$Admin$CoverageDocuments$UploadModal$editUpload = F4(
	function (apiClient, coveragePlanId, coverageDocument, validFormFields) {
		var _v0 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
		var fileName = _v0.Sn;
		return A5(
			$author$project$Api$Provider$CoverageDocument$update,
			apiClient,
			coveragePlanId,
			$author$project$Api$Provider$CoverageDocument$Shared$id(coverageDocument),
			{
				Sn: $elm_community$string_extra$String$Extra$clean(fileName)
			},
			$author$project$Components$Admin$CoverageDocuments$UploadModal$Updated);
	});
var $elm$file$File$name = _File_name;
var $author$project$Components$Admin$CoverageDocuments$UploadModal$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var file = field.a;
			var newFileName = $rtfeldman$elm_validate$Validate$isBlank(fields.Sn) ? A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Maybe$map, $elm$file$File$name, file)) : fields.Sn;
			return _Utils_update(
				fields,
				{ahj: file, Sn: newFileName});
		} else {
			var fileName = field.a;
			return _Utils_update(
				fields,
				{Sn: fileName});
		}
	});
var $author$project$Components$Admin$CoverageDocuments$UploadModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.ahj;
			},
			_Utils_Tuple2(0, 'Please select a file.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.Sn;
			},
			_Utils_Tuple2(1, 'Please enter a file name.'))
		]));
var $author$project$Components$Admin$CoverageDocuments$UploadModal$formFieldsValidatorForEdit = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.Sn;
			},
			_Utils_Tuple2(1, 'Please enter a file name.'))
		]));
var $author$project$Components$Admin$CoverageDocuments$UploadModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
			case 2:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Admin$CoverageDocuments$UploadModal$formFieldsUpdate, field, model.SD);
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 1,
					aiO: _Utils_update(
						model,
						{SD: newForm}),
					aR: _List_Nil
				};
			case 1:
				var files = msg.a;
				var file = $elm$core$List$head(files);
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Admin$CoverageDocuments$UploadModal$formFieldsUpdate,
					$author$project$Components$Admin$CoverageDocuments$UploadModal$File(file),
					model.SD);
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 1,
					aiO: _Utils_update(
						model,
						{SD: newForm}),
					aR: _List_Nil
				};
			case 3:
				var _v2 = function () {
					var _v3 = model.rL;
					if (!_v3.$) {
						var coverageDocument_ = _v3.a;
						return _Utils_Tuple2(
							A2($author$project$Utils$Form$validate, $author$project$Components$Admin$CoverageDocuments$UploadModal$formFieldsValidatorForEdit, model.SD),
							A3($author$project$Components$Admin$CoverageDocuments$UploadModal$editUpload, apiClient, model.yV, coverageDocument_));
					} else {
						return _Utils_Tuple2(
							A2($author$project$Utils$Form$validate, $author$project$Components$Admin$CoverageDocuments$UploadModal$formFieldsValidator, model.SD),
							A2($author$project$Components$Admin$CoverageDocuments$UploadModal$createUpload, apiClient, model.yV));
					}
				}();
				var formValidationResult = _v2.a;
				var cmdToExecute = _v2.b;
				if (!formValidationResult.$) {
					var _v5 = formValidationResult.a;
					var newForm = _v5.a;
					var validFormFields = _v5.b;
					return {
						GZ: cmdToExecute(validFormFields),
						agZ: 1,
						aiO: _Utils_update(
							model,
							{SD: newForm, k9: $author$project$Api$Data$Loading}),
						aR: _List_Nil
					};
				} else {
					var newForm = formValidationResult.a;
					var errorList = A2(
						$elm$core$List$append,
						A2($author$project$Utils$Form$validationErrors, 1, newForm),
						A2($author$project$Utils$Form$validationErrors, 0, newForm));
					var errorMsg = A2(
						$elm$core$Maybe$withDefault,
						'',
						$elm$core$List$head(errorList));
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 1,
						aiO: _Utils_update(
							model,
							{SD: newForm}),
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 1, errorMsg)
							])
					};
				}
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 2,
						aiO: _Utils_update(
							model,
							{k9: $author$project$Api$Data$NotAsked}),
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Document successfully uploaded.')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 1,
						aiO: _Utils_update(
							model,
							{k9: response}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 3,
						aiO: _Utils_update(
							model,
							{k9: $author$project$Api$Data$NotAsked}),
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Document successfully updated.')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 1,
						aiO: _Utils_update(
							model,
							{k9: response}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
		}
	});
var $author$project$Components$Admin$CoverageDocuments$Form$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var coverageDocument = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							f7: $elm$core$Maybe$Just(
								_Utils_Tuple2(coverageDocument, $author$project$Api$Data$NotAsked))
						}),
					aR: _List_Nil
				};
			case 1:
				var coverageDocument = msg.a;
				var confirmed = msg.b;
				return confirmed ? {
					GZ: A4(
						$author$project$Api$Provider$CoverageDocument$delete,
						apiClient,
						model.yV,
						$author$project$Api$Provider$CoverageDocument$Shared$id(coverageDocument),
						$author$project$Components$Admin$CoverageDocuments$Form$DeletedCoverageDocument(coverageDocument)),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							f7: $elm$core$Maybe$Just(
								_Utils_Tuple2(coverageDocument, $author$project$Api$Data$Loading))
						}),
					aR: _List_Nil
				} : {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{f7: $elm$core$Maybe$Nothing}),
					aR: _List_Nil
				};
			case 2:
				var coverageDocument = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 1,
						aiO: model,
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Document removed')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{
								f7: $elm$core$Maybe$Just(
									_Utils_Tuple2(coverageDocument, response))
							}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 3:
				var subMsg = msg.a;
				var uploadModalResult = A3($author$project$Components$Admin$CoverageDocuments$UploadModal$update, apiClient, subMsg, model.da);
				var _v3 = uploadModalResult.agZ;
				switch (_v3) {
					case 0:
						return {
							GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoverageDocuments$Form$DocumentUploadModalMsg, uploadModalResult.GZ),
							agZ: 0,
							aiO: _Utils_update(
								model,
								{da: uploadModalResult.aiO, jr: false}),
							aR: uploadModalResult.aR
						};
					case 1:
						return {
							GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoverageDocuments$Form$DocumentUploadModalMsg, uploadModalResult.GZ),
							agZ: 0,
							aiO: _Utils_update(
								model,
								{da: uploadModalResult.aiO}),
							aR: uploadModalResult.aR
						};
					case 2:
						return {
							GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoverageDocuments$Form$DocumentUploadModalMsg, uploadModalResult.GZ),
							agZ: 2,
							aiO: _Utils_update(
								model,
								{da: uploadModalResult.aiO, jr: false}),
							aR: uploadModalResult.aR
						};
					default:
						return {
							GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoverageDocuments$Form$DocumentUploadModalMsg, uploadModalResult.GZ),
							agZ: 2,
							aiO: _Utils_update(
								model,
								{da: uploadModalResult.aiO, jr: false}),
							aR: uploadModalResult.aR
						};
				}
			default:
				var coverageDocument = msg.a;
				var newModdal = A2(
					$author$project$Components$Admin$CoverageDocuments$UploadModal$init,
					model.yV,
					$elm$core$Maybe$Just(coverageDocument));
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{da: newModdal, jr: true}),
					aR: _List_Nil
				};
		}
	});
var $elm_community$list_extra$List$Extra$setAt = F2(
	function (index, value) {
		return A2(
			$elm_community$list_extra$List$Extra$updateAt,
			index,
			$elm$core$Basics$always(value));
	});
var $author$project$Components$Admin$CoverageRules$Form$Editing = 1;
var $author$project$Components$Admin$CoverageRules$Form$Id = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$CoverageRules$Form$ItemAdd = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$CoverageRules$Form$Restored = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Admin$CoverageRules$Form$RuleTypeUpdate = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$CoverageRules$Form$Deleted = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Api$Provider$CoverageRule$coverageRulesPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['coverage_rules']),
		A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id_]),
			A2(
				$author$project$Api$Data$pathAppend,
				_List_fromArray(
					['coverage_plans']),
				$author$project$Api$Data$providerPath)));
};
var $author$project$Api$Provider$CoverageRule$coverageRulePath = F2(
	function (coveragePlanId, coverageRuleId) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[coverageRuleId]),
			$author$project$Api$Provider$CoverageRule$coverageRulesPath(coveragePlanId));
	});
var $author$project$Api$Provider$CoverageRule$delete = F4(
	function (apiClient, coveragePlanId, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Provider$CoverageRule$coverageRulePath, coveragePlanId, id_)));
	});
var $author$project$Api$Provider$CoverageRule$unpublish = F4(
	function (apiClient, coveragePlanId, id_, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['unpublish']),
					A2($author$project$Api$Provider$CoverageRule$coverageRulePath, coveragePlanId, id_))));
	});
var $author$project$Components$Admin$CoverageRules$Form$deleteRule = F4(
	function (apiClient, model, coveragePlanId, coverageRuleId) {
		var fields = $author$project$Utils$Form$fields(model.SD);
		var _v0 = fields.ahP;
		if (!_v0.$) {
			var id_ = _v0.a;
			return (model.cM || (!_Utils_eq(coverageRuleId, id_))) ? A4(
				$author$project$Api$Provider$CoverageRule$delete,
				apiClient,
				coveragePlanId,
				coverageRuleId,
				$author$project$Components$Admin$CoverageRules$Form$Deleted(coverageRuleId)) : A4(
				$author$project$Api$Provider$CoverageRule$unpublish,
				apiClient,
				coveragePlanId,
				coverageRuleId,
				$author$project$Components$Admin$CoverageRules$Form$Deleted(coverageRuleId));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Components$Admin$CoverageRules$Form$ruleTypeId = function (ruleType) {
	if (!ruleType.$) {
		var ruleTypeOption = ruleType.a;
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			$author$project$Components$Admin$CoverageRules$Form$ruleTypeIdToValue(ruleTypeOption));
	} else {
		return '';
	}
};
var $author$project$Components$Admin$CoverageRules$Form$formFieldsUpdate = F2(
	function (field, form) {
		switch (field.$) {
			case 0:
				var id = field.a;
				return _Utils_update(
					form,
					{ahP: id});
			case 1:
				var ruleTypeOption = field.a;
				var timePeriod = ($author$project$Components$Admin$CoverageRules$Form$ruleTypeId(ruleTypeOption) === 'limited_quantity') ? $elm$core$Maybe$Just(0) : $elm$core$Maybe$Nothing;
				var itemType = ($author$project$Components$Admin$CoverageRules$Form$ruleTypeId(ruleTypeOption) === 'limited_quantity') ? 'charge_item' : form.sW;
				return _Utils_update(
					form,
					{sW: itemType, ak7: ruleTypeOption, al4: timePeriod});
			case 6:
				var coveredBy = field.a;
				return _Utils_update(
					form,
					{d2: coveredBy});
			case 7:
				var timePeriod = field.a;
				return _Utils_update(
					form,
					{
						al4: $elm$core$Maybe$Just(timePeriod)
					});
			case 8:
				var quantity = field.a;
				return _Utils_update(
					form,
					{
						Dz: $elm$core$String$toInt(quantity)
					});
			case 3:
				var amountInCents = field.a;
				return _Utils_update(
					form,
					{LE: amountInCents});
			case 4:
				var percentage = field.a;
				return _Utils_update(
					form,
					{
						ajZ: $elm$core$String$toFloat(percentage)
					});
			case 2:
				var item = field.a;
				return _Utils_update(
					form,
					{Io: item});
			default:
				var itemType = field.a;
				return _Utils_update(
					form,
					{Io: $elm$core$Maybe$Nothing, sW: itemType});
		}
	});
var $author$project$Components$Admin$CoverageRules$Form$RuleTypeValidation = 0;
var $author$project$Components$Admin$CoverageRules$Form$AmountInCentsValidation = 4;
var $author$project$Components$Admin$CoverageRules$Form$validateAmountInCents = function (_v0) {
	var ruleType = _v0.ak7;
	var amountInCents = _v0.LE;
	var typeIncludedOption = A2($elm$core$Maybe$andThen, $author$project$Components$Admin$CoverageRules$Form$ruleTypeIncludedOption, ruleType);
	var typeId = $author$project$Components$Admin$CoverageRules$Form$ruleTypeId(ruleType);
	var isUnderPriceIncluded = (typeId === 'included') && _Utils_eq(
		typeIncludedOption,
		$elm$core$Maybe$Just(1));
	var isRequired = isUnderPriceIncluded || ((typeId === 'flat_amount') || (typeId === 'surcharge'));
	return A2(
		$author$project$Utils$Validate$isInvalidCurrency,
		{
			aeU: !isRequired,
			AU: $elm$core$Maybe$Nothing,
			W9: $elm$core$Maybe$Just(0)
		},
		amountInCents) ? _List_fromArray(
		[
			_Utils_Tuple2(4, 'Please enter a valid amount.')
		]) : _List_Nil;
};
var $author$project$Components$Admin$CoverageRules$Form$CategoryValidation = 2;
var $author$project$Components$Admin$CoverageRules$Form$ChargeItemValidation = 1;
var $author$project$Components$Admin$CoverageRules$Form$ItemTypeValidation = 3;
var $author$project$Components$Admin$CoverageRules$Form$validateForm = function (form) {
	var _v0 = _Utils_Tuple2(form.sW, form.Io);
	_v0$3:
	while (true) {
		if (_v0.b.$ === 1) {
			switch (_v0.a) {
				case 'charge_category':
					var _v1 = _v0.b;
					return _List_fromArray(
						[
							_Utils_Tuple2(2, 'Please pick a category.')
						]);
				case 'charge_item':
					var _v2 = _v0.b;
					return _List_fromArray(
						[
							_Utils_Tuple2(1, 'Please pick a charge item.')
						]);
				case '':
					var _v3 = _v0.b;
					return _List_fromArray(
						[
							_Utils_Tuple2(3, 'Please pick a category or item.')
						]);
				default:
					break _v0$3;
			}
		} else {
			break _v0$3;
		}
	}
	return _List_Nil;
};
var $author$project$Components$Admin$CoverageRules$Form$PercentageValidation = 6;
var $author$project$Components$Admin$CoverageRules$Form$validatePercentage = function (_v0) {
	var ruleType = _v0.ak7;
	var percentage = _v0.ajZ;
	var typeId = $author$project$Components$Admin$CoverageRules$Form$ruleTypeId(ruleType);
	var _v1 = _Utils_Tuple2(typeId, percentage);
	if ((_v1.a === 'discounted') && (_v1.b.$ === 1)) {
		var _v2 = _v1.b;
		return _List_fromArray(
			[
				_Utils_Tuple2(6, 'Please pick a valid quantity.')
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Admin$CoverageRules$Form$QuantityValidation = 5;
var $author$project$Components$Admin$CoverageRules$Form$validateQuantity = function (_v0) {
	var ruleType = _v0.ak7;
	var quantity = _v0.Dz;
	var typeId = $author$project$Components$Admin$CoverageRules$Form$ruleTypeId(ruleType);
	var _v1 = _Utils_Tuple2(typeId, quantity);
	if ((_v1.a === 'limited_quantity') && (_v1.b.$ === 1)) {
		var _v2 = _v1.b;
		return _List_fromArray(
			[
				_Utils_Tuple2(5, 'Please pick a valid quantity.')
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Admin$CoverageRules$Form$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.ak7;
			},
			_Utils_Tuple2(0, 'Please pick a coverage rule.')),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$CoverageRules$Form$validateAmountInCents),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$CoverageRules$Form$validateQuantity),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$CoverageRules$Form$validatePercentage),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$CoverageRules$Form$validateForm)
		]));
var $author$project$Components$ResourceFilter$ChargeItem$preSelectedId = F2(
	function (id, model) {
		var _v0 = A2($author$project$Components$ResourceFilter$preSelectedId, id, model.b8);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{b8: resourceFilter}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Api$Provider$CoverageRule$publish = F4(
	function (apiClient, coveragePlanId, id_, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['publish']),
					A2($author$project$Api$Provider$CoverageRule$coverageRulePath, coveragePlanId, id_))));
	});
var $author$project$Components$Admin$CoverageRules$Form$GotChargeItem = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Admin$CoverageRules$Form$Updated = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Admin$CoverageRules$Form$formChanged = F2(
	function (form, updatedForm) {
		var unpublishedFields = $author$project$Utils$Form$fields(updatedForm);
		var publishedFields = $author$project$Utils$Form$fields(form);
		var original = _Utils_update(
			publishedFields,
			{ahP: $elm$core$Maybe$Nothing});
		var changed = _Utils_update(
			unpublishedFields,
			{ahP: $elm$core$Maybe$Nothing});
		return !_Utils_eq(original, changed);
	});
var $author$project$Api$Provider$CoverageRule$save = F5(
	function (apiClient, coveragePlanId, maybeId, coverageRule, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, coverageRule.ahP)),
					_Utils_Tuple2(
					'amount_in_cents',
					A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, coverageRule.LE)),
					_Utils_Tuple2(
					'percentage',
					$elm$json$Json$Encode$string(coverageRule.ajZ)),
					_Utils_Tuple2(
					'time_period',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, coverageRule.al4)),
					_Utils_Tuple2(
					'quantity',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, coverageRule.Dz)),
					_Utils_Tuple2(
					'patient_contribution_percentage',
					$elm$json$Json$Encode$string(coverageRule.ajS)),
					_Utils_Tuple2(
					'sponsor_contribution_percentage',
					$elm$json$Json$Encode$string(coverageRule.alE)),
					_Utils_Tuple2(
					'rule_type',
					$elm$json$Json$Encode$string(coverageRule.ak7)),
					_Utils_Tuple2(
					'item',
					$author$project$Utils$Encode$typedAssociation(coverageRule.Io)),
					_Utils_Tuple2(
					'published_rule',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'id',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, coverageRule._J))
							])))
				]));
		if (!maybeId.$) {
			var id_ = maybeId.a;
			return A4(
				$author$project$Api$Data$put,
				apiClient,
				$author$project$Api$Provider$CoverageRule$One$decoder,
				toMsg,
				A2(
					$author$project$Api$Data$requestWithJson,
					body,
					$author$project$Api$Data$requestTo(
						A2($author$project$Api$Provider$CoverageRule$coverageRulePath, coveragePlanId, id_))));
		} else {
			return A4(
				$author$project$Api$Data$post,
				apiClient,
				$author$project$Api$Provider$CoverageRule$One$decoder,
				toMsg,
				A2(
					$author$project$Api$Data$requestWithJson,
					body,
					$author$project$Api$Data$requestTo(
						$author$project$Api$Provider$CoverageRule$coverageRulesPath(coveragePlanId))));
		}
	});
var $author$project$Components$Admin$CoverageRules$Form$saveOrDeleteUnpublishedRule = F3(
	function (apiClient, model, form) {
		var fields = $author$project$Utils$Form$fields(form);
		var _v0 = _Utils_Tuple2(model.yV, model.Z);
		_v0$2:
		while (true) {
			if (!_v0.a.$) {
				if (!_v0.b.$) {
					var coveragePlanId = _v0.a.a;
					var unpublishedForm = _v0.b.a;
					var unpublishedFields = $author$project$Utils$Form$fields(unpublishedForm);
					var fieldsChanged = A2($author$project$Components$Admin$CoverageRules$Form$formChanged, model.SD, unpublishedForm);
					var revertedChanges = (!fieldsChanged) && ((!_Utils_eq(unpublishedFields.ahP, $elm$core$Maybe$Nothing)) && (!model.cM));
					var cmd = function () {
						if (revertedChanges) {
							return A4(
								$author$project$Components$Admin$CoverageRules$Form$deleteRule,
								apiClient,
								model,
								coveragePlanId,
								A2($elm$core$Maybe$withDefault, '', unpublishedFields.ahP));
						} else {
							if (fieldsChanged) {
								var coverageRule = A3(
									$author$project$Components$Admin$CoverageRules$Form$formToParams,
									form,
									model.a7,
									$author$project$Utils$Form$fields(model.SD).ahP);
								return A5($author$project$Api$Provider$CoverageRule$save, apiClient, coveragePlanId, fields.ahP, coverageRule, $author$project$Components$Admin$CoverageRules$Form$Updated);
							} else {
								return $elm$core$Platform$Cmd$none;
							}
						}
					}();
					return _Utils_Tuple3(model, cmd, _List_Nil);
				} else {
					break _v0$2;
				}
			} else {
				if (!_v0.b.$) {
					var _v1 = _v0.a;
					var unpublishedForm = _v0.b.a;
					var _v2 = function () {
						var _v3 = fields.Io;
						if (!_v3.$) {
							var item = _v3.a;
							return (fields.sW === 'charge_item') ? _Utils_Tuple2(
								A3($author$project$Api$Provider$ChargeItem$retrieve, apiClient, item.ahP, $author$project$Components$Admin$CoverageRules$Form$GotChargeItem),
								$elm$core$Maybe$Nothing) : _Utils_Tuple2(
								$elm$core$Platform$Cmd$none,
								$elm$core$Maybe$Just(
									{ahP: item.ahP, Bq: item.Bq}));
						} else {
							return _Utils_Tuple2($elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
						}
					}();
					var cmd = _v2.a;
					var category_ = _v2.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{GW: category_, a9: 2, SD: unpublishedForm, Z: $elm$core$Maybe$Nothing}),
						cmd,
						_List_Nil);
				} else {
					break _v0$2;
				}
			}
		}
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Components$Admin$CoverageRules$Form$updateForms = F2(
	function (model, field) {
		var updateField = function (form) {
			return A3($author$project$Utils$Form$update, $author$project$Components$Admin$CoverageRules$Form$formFieldsUpdate, field, form);
		};
		if (model.a9 === 2) {
			return _Utils_update(
				model,
				{
					SD: updateField(model.SD)
				});
		} else {
			var initEditForm = function () {
				var _v0 = model.Z;
				if (!_v0.$) {
					var editForm = _v0.a;
					return editForm;
				} else {
					var idUpdate = model.cM ? $author$project$Components$Admin$CoverageRules$Form$Id(
						$author$project$Utils$Form$fields(model.SD).ahP) : $author$project$Components$Admin$CoverageRules$Form$Id($elm$core$Maybe$Nothing);
					return A3($author$project$Utils$Form$update, $author$project$Components$Admin$CoverageRules$Form$formFieldsUpdate, idUpdate, model.SD);
				}
			}();
			var updatedForm = updateField(initEditForm);
			return _Utils_update(
				model,
				{
					Z: $elm$core$Maybe$Just(updatedForm)
				});
		}
	});
var $author$project$Components$Admin$CoverageRules$Form$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 5:
				var field = msg.a;
				var updatedForm = A2($author$project$Components$Admin$CoverageRules$Form$updateForms, model, field);
				var _v2 = A3(
					$author$project$Components$ResourceFilter$ChargeItem$init,
					apiClient,
					function (opts) {
						return _Utils_update(
							opts,
							{
								sW: $elm$core$Maybe$Just('item')
							});
					},
					function (d) {
						return _Utils_update(
							d,
							{Gp: 'Select a Charge Item'});
					});
				var chargeItemResourceFilter = _v2.a;
				var chargeItemResourceFilterCmd = _v2.b;
				var _v3 = A3(
					$author$project$Components$ResourceFilter$Category$init,
					apiClient,
					model.aa4,
					function (d) {
						return _Utils_update(
							d,
							{Gp: 'Select a Category'});
					});
				var categoryResourceFilter = _v3.a;
				var categoryResourceFilterCmd = _v3.b;
				var _v4 = function () {
					if (field.$ === 5) {
						return _Utils_Tuple2(
							_Utils_update(
								updatedForm,
								{c8: categoryResourceFilter, cq: chargeItemResourceFilter}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoverageRules$Form$ChargeItemResourceFilterMsg, chargeItemResourceFilterCmd),
										A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoverageRules$Form$CategoryResourceFilterMsg, categoryResourceFilterCmd)
									])));
					} else {
						return _Utils_Tuple2(updatedForm, $elm$core$Platform$Cmd$none);
					}
				}();
				var newModel = _v4.a;
				var cmd = _v4.b;
				return _Utils_Tuple3(newModel, cmd, _List_Nil);
			case 14:
				var response = msg.a;
				if (response.$ === 3) {
					var chargeItem = response.a;
					var _v7 = $author$project$Api$Provider$ChargeItem$One$category(chargeItem);
					if (!_v7.$) {
						var oneCategory = _v7.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									GW: $elm$core$Maybe$Just(
										{
											ahP: $author$project$Api$Provider$Category$Shared$id(oneCategory),
											Bq: $author$project$Api$Provider$Category$Shared$name(oneCategory)
										})
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$reportDecodeError(response));
				}
			case 6:
				var _v8 = A2(
					$author$project$Utils$Form$validate,
					$author$project$Components$Admin$CoverageRules$Form$formFieldsValidator,
					A2($elm$core$Maybe$withDefault, model.SD, model.Z));
				if (!_v8.$) {
					var _v9 = _v8.a;
					var form = _v9.a;
					return A3($author$project$Components$Admin$CoverageRules$Form$saveOrDeleteUnpublishedRule, apiClient, model, form);
				} else {
					var form = _v8.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Z: $elm$core$Maybe$Just(form)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 8:
				var resourceFilterPreSelectCmd = function () {
					var _v12 = model.OU;
					if (!_v12.$) {
						var coverageRule = _v12.a;
						return A2(
							$elm$core$Task$perform,
							$author$project$Components$Admin$CoverageRules$Form$ResourceFilterPreSelected,
							$elm$core$Task$succeed(coverageRule));
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				var _v10 = A3(
					$author$project$Components$ResourceFilter$ChargeItem$init,
					apiClient,
					function (opts) {
						return _Utils_update(
							opts,
							{
								sW: $elm$core$Maybe$Just('item')
							});
					},
					function (d) {
						return _Utils_update(
							d,
							{Gp: 'Select a Charge Item'});
					});
				var chargeItemResourceFilter = _v10.a;
				var chargeItemResourceFilterCmd = _v10.b;
				var _v11 = A3(
					$author$project$Components$ResourceFilter$Category$init,
					apiClient,
					model.aa4,
					function (d) {
						return _Utils_update(
							d,
							{Gp: 'Select a Category'});
					});
				var categoryResourceFilter = _v11.a;
				var categoryResourceFilterCmd = _v11.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{c8: categoryResourceFilter, cq: chargeItemResourceFilter, a9: 1}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoverageRules$Form$ChargeItemResourceFilterMsg, chargeItemResourceFilterCmd),
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoverageRules$Form$CategoryResourceFilterMsg, categoryResourceFilterCmd),
								resourceFilterPreSelectCmd
							])),
					_List_Nil);
			case 9:
				var maybeCoverageRuleId = msg.a;
				var deleted = _Utils_eq(model.yV, $elm$core$Maybe$Nothing) && _Utils_eq(maybeCoverageRuleId, $elm$core$Maybe$Nothing);
				var cmd = function () {
					var _v13 = _Utils_Tuple2(model.yV, maybeCoverageRuleId);
					if ((!_v13.a.$) && (!_v13.b.$)) {
						var coveragePlanId = _v13.a.a;
						var coverageRuleId = _v13.b.a;
						return A4($author$project$Components$Admin$CoverageRules$Form$deleteRule, apiClient, model, coveragePlanId, coverageRuleId);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{a7: deleted, Z: $elm$core$Maybe$Nothing}),
					cmd,
					_List_Nil);
			case 0:
				var dropdownMsg = msg.a;
				var _v14 = A2($author$project$Ui$Dropdown$update, dropdownMsg, model.pM);
				var dropdown = _v14.a;
				var cmd = _v14.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{pM: dropdown}),
					cmd,
					_List_Nil);
			case 1:
				var str = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{pN: str}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var maybeRuleType = msg.a;
				var updatedModel = A2(
					$author$project$Components$Admin$CoverageRules$Form$updateForms,
					model,
					$author$project$Components$Admin$CoverageRules$Form$RuleTypeUpdate(maybeRuleType));
				return _Utils_Tuple3(
					_Utils_update(
						updatedModel,
						{pN: ''}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 7:
				var coverageRule = msg.a;
				var _v15 = $author$project$Api$Provider$CoverageRule$One$item(coverageRule);
				if (_v15.$ === 1) {
					var category_ = _v15.a;
					var _v16 = A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Components$ResourceFilter$Category$extraItems(
							_List_fromArray(
								[
									{
									ahP: $author$project$Api$Provider$Category$Shared$id(category_),
									Bq: $author$project$Api$Provider$Category$Shared$name(category_)
								}
								])),
						A2(
							$author$project$Components$ResourceFilter$Category$preSelectedId,
							$elm$core$Maybe$Just(
								$author$project$Api$Provider$Category$Shared$id(category_)),
							model.c8));
					var categoryResourceFilter = _v16.a;
					var categoryResourceFilterCmd = _v16.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{c8: categoryResourceFilter}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoverageRules$Form$CategoryResourceFilterMsg, categoryResourceFilterCmd),
						_List_Nil);
				} else {
					var chargeItem = _v15.a;
					var _v17 = A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Components$ResourceFilter$ChargeItem$extraItems(
							_List_fromArray(
								[
									{
									ahP: $author$project$Api$Provider$ChargeItem$Shared$id(chargeItem),
									Bq: $author$project$Api$Provider$ChargeItem$Shared$name(chargeItem)
								}
								])),
						A2(
							$author$project$Components$ResourceFilter$ChargeItem$preSelectedId,
							$elm$core$Maybe$Just(
								$author$project$Api$Provider$ChargeItem$Shared$id(chargeItem)),
							model.cq));
					var chargeItemResourceFilter = _v17.a;
					var chargeItemResourceFilterCmd = _v17.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cq: chargeItemResourceFilter}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoverageRules$Form$ChargeItemResourceFilterMsg, chargeItemResourceFilterCmd),
						_List_Nil);
				}
			case 3:
				var subMsg = msg.a;
				var categoryResourceResult = A3($author$project$Components$ResourceFilter$Category$update, apiClient, subMsg, model.c8);
				var newModelForms = function () {
					var _v18 = categoryResourceResult.agZ;
					_v18$2:
					while (true) {
						if (!_v18.$) {
							switch (_v18.a.$) {
								case 0:
									var category_ = _v18.a.a;
									var item = $elm$core$Maybe$Just(
										{ahP: category_.ahP, Bq: category_.Bq});
									return A2(
										$author$project$Components$Admin$CoverageRules$Form$updateForms,
										model,
										$author$project$Components$Admin$CoverageRules$Form$ItemAdd(item));
								case 4:
									var preSelectedItem = _v18.a.a;
									var item = $elm$core$Maybe$Just(
										{ahP: preSelectedItem.aee, Bq: preSelectedItem.aih});
									return A2(
										$author$project$Components$Admin$CoverageRules$Form$updateForms,
										model,
										$author$project$Components$Admin$CoverageRules$Form$ItemAdd(item));
								default:
									break _v18$2;
							}
						} else {
							break _v18$2;
						}
					}
					return model;
				}();
				var newModel = _Utils_update(
					newModelForms,
					{c8: categoryResourceResult.aiO});
				return _Utils_Tuple3(
					newModel,
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoverageRules$Form$CategoryResourceFilterMsg, categoryResourceResult.GZ),
					categoryResourceResult.aR);
			case 4:
				var subMsg = msg.a;
				var chargeItemResourceResult = A3($author$project$Components$ResourceFilter$ChargeItem$update, apiClient, subMsg, model.cq);
				var newModelForms = function () {
					var _v19 = chargeItemResourceResult.agZ;
					_v19$2:
					while (true) {
						if (!_v19.$) {
							switch (_v19.a.$) {
								case 0:
									var chargeItem = _v19.a.a;
									var item = $elm$core$Maybe$Just(
										{ahP: chargeItem.ahP, Bq: chargeItem.Bq});
									return A2(
										$author$project$Components$Admin$CoverageRules$Form$updateForms,
										model,
										$author$project$Components$Admin$CoverageRules$Form$ItemAdd(item));
								case 4:
									var preSelectedItem = _v19.a.a;
									var item = $elm$core$Maybe$Just(
										{ahP: preSelectedItem.aee, Bq: preSelectedItem.aih});
									return A2(
										$author$project$Components$Admin$CoverageRules$Form$updateForms,
										model,
										$author$project$Components$Admin$CoverageRules$Form$ItemAdd(item));
								default:
									break _v19$2;
							}
						} else {
							break _v19$2;
						}
					}
					return model;
				}();
				var newModel = _Utils_update(
					newModelForms,
					{cq: chargeItemResourceResult.aiO});
				return _Utils_Tuple3(
					newModel,
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoverageRules$Form$ChargeItemResourceFilterMsg, chargeItemResourceResult.GZ),
					chargeItemResourceResult.aR);
			case 10:
				var response = msg.a;
				if (response.$ === 3) {
					var coverageRule = response.a;
					var _v21 = model.Z;
					if (!_v21.$) {
						var editedForm_ = _v21.a;
						var updatedForm = A3(
							$author$project$Utils$Form$update,
							$author$project$Components$Admin$CoverageRules$Form$formFieldsUpdate,
							$author$project$Components$Admin$CoverageRules$Form$Id(
								$elm$core$Maybe$Just(
									$author$project$Api$Provider$CoverageRule$One$id(coverageRule))),
							editedForm_);
						var newModel = _Utils_update(
							model,
							{a9: 2});
						var coverageRuleCategory = A2(
							$elm$core$Maybe$map,
							function (category_) {
								return {
									ahP: $author$project$Api$Provider$Category$Min$id(category_),
									Bq: $author$project$Api$Provider$Category$Min$name(category_)
								};
							},
							$author$project$Api$Provider$CoverageRule$One$category(coverageRule));
						return model.cM ? _Utils_Tuple3(
							_Utils_update(
								newModel,
								{GW: coverageRuleCategory, SD: updatedForm, cM: true, Z: $elm$core$Maybe$Nothing}),
							$elm$core$Platform$Cmd$none,
							_List_Nil) : _Utils_Tuple3(
							_Utils_update(
								newModel,
								{
									GW: coverageRuleCategory,
									Z: $elm$core$Maybe$Just(updatedForm)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 11:
				var id_ = msg.a;
				var response = msg.b;
				var publishedFields = $author$project$Utils$Form$fields(model.SD);
				var _v22 = _Utils_Tuple2(response, publishedFields.ahP);
				if ((_v22.a.$ === 3) && (!_v22.b.$)) {
					var _v23 = _v22.a;
					var coverageRuleId = _v22.b.a;
					if (_Utils_eq(coverageRuleId, id_)) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{a7: true}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						var _v24 = model.Z;
						if (!_v24.$) {
							var editedForm_ = _v24.a;
							var unpublishedFields = $author$project$Utils$Form$fields(editedForm_);
							return _Utils_eq(
								A2($elm$core$Maybe$withDefault, '', unpublishedFields.ahP),
								id_) ? _Utils_Tuple3(
								_Utils_update(
									model,
									{Z: $elm$core$Maybe$Nothing}),
								$elm$core$Platform$Cmd$none,
								_List_Nil) : _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
						} else {
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
						}
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 12:
				var coverageRuleId = msg.a;
				var cmd = function () {
					var _v25 = model.yV;
					if (!_v25.$) {
						var coveragePlanId = _v25.a;
						return A4($author$project$Api$Provider$CoverageRule$publish, apiClient, coveragePlanId, coverageRuleId, $author$project$Components$Admin$CoverageRules$Form$Restored);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return _Utils_Tuple3(model, cmd, _List_Nil);
			case 13:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{a7: false}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			default:
				var _v26 = model.a9;
				switch (_v26) {
					case 0:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{a7: true, a9: 2}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					case 1:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{a9: 2, Z: $elm$core$Maybe$Nothing}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Components$Admin$CoveragePlans$Rules$update = F3(
	function (apiClient, msg, model) {
		if (!msg.$) {
			var index = msg.a;
			var subMsg = msg.b;
			var _v1 = A2($elm_community$list_extra$List$Extra$getAt, index, model.afY);
			if (!_v1.$) {
				var coverageRuleForm = _v1.a;
				var _v2 = A3($author$project$Components$Admin$CoverageRules$Form$update, apiClient, subMsg, coverageRuleForm);
				var updatedCoverageRuleForm = _v2.a;
				var subCmd = _v2.b;
				var subOutMsg = _v2.c;
				var coverageRules = A3($elm_community$list_extra$List$Extra$setAt, index, updatedCoverageRuleForm, model.afY);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{afY: coverageRules}),
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Components$Admin$CoveragePlans$Rules$CoverageRuleFormMsg(index),
						subCmd),
					subOutMsg);
			} else {
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
			}
		} else {
			var _v3 = A6(
				$author$project$Components$Admin$CoverageRules$Form$init,
				apiClient,
				model.aa4,
				$elm$core$Maybe$Nothing,
				model.yV,
				{_6: model._6},
				$elm$core$Maybe$Nothing);
			var newForm = _v3.a;
			var cmd = _v3.b;
			var coverageRules = _Utils_ap(
				model.afY,
				_List_fromArray(
					[newForm]));
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{afY: coverageRules}),
				A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Components$Admin$CoveragePlans$Rules$CoverageRuleFormMsg(
						$elm$core$List$length(model.afY)),
					cmd),
				_List_Nil);
		}
	});
var $author$project$Api$Pagination$withTotalCount = F2(
	function (totalCount, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{qC: totalCount});
	});
var $author$project$Components$Admin$CoveragePlans$Form$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var coveragePlan = response.a;
					var _v3 = A6(
						$author$project$Components$Admin$CoveragePlans$Rules$init,
						apiClient,
						model.aa4,
						model.ahP,
						$author$project$Api$Provider$CoveragePlan$One$coverageRules(coveragePlan),
						$elm$core$Maybe$Nothing,
						{_6: false});
					var coverageRules = _v3.a;
					var coverateRulesCmd = _v3.b;
					var _v4 = A5(
						$author$project$Components$Admin$CoverageDocuments$Form$init,
						apiClient,
						model.aa4,
						$author$project$Api$Provider$CoveragePlan$One$id(coveragePlan),
						$author$project$Api$Provider$CoveragePlan$One$coverageDocuments(coveragePlan),
						false);
					var coverageDocuments = _v4.a;
					var coverageDocumentsCmd = _v4.b;
					var cmd = $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoveragePlans$Form$CoverageRulesMsg, coverateRulesCmd),
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoveragePlans$Form$CoverageDocumentsMsg, coverageDocumentsCmd)
							]));
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								OS: $elm$core$Maybe$Just(coverageDocuments),
								OT: $elm$core$Maybe$Just(coveragePlan),
								afY: $elm$core$Maybe$Just(coverageRules),
								SD: $elm$core$Maybe$Just(
									$author$project$Utils$Form$init(
										$author$project$Components$Admin$CoveragePlans$Form$formFieldsFromItem(coveragePlan)))
							}),
						cmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$reportDecodeError(response));
				}
			case 1:
				var field = msg.a;
				var _v5 = model.SD;
				if (!_v5.$) {
					var form = _v5.a;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Admin$CoveragePlans$Form$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								SD: $elm$core$Maybe$Just(newForm)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				var _v6 = _Utils_Tuple2(model.SD, model.afY);
				if ((!_v6.a.$) && (!_v6.b.$)) {
					var form = _v6.a.a;
					var coverageRules = _v6.b.a;
					var _v7 = A2($author$project$Utils$Form$validate, $author$project$Components$Admin$CoveragePlans$Form$formFieldsValidator, form);
					if (!_v7.$) {
						var _v8 = _v7.a;
						var newForm = _v8.a;
						var validFormFields = _v8.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									SD: $elm$core$Maybe$Just(newForm)
								}),
							A4($author$project$Components$Admin$CoveragePlans$Form$saveCoveragePlan, apiClient, model.ahP, validFormFields, coverageRules),
							_List_Nil);
					} else {
						var newForm = _v7.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									SD: $elm$core$Maybe$Just(newForm)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var response = msg.a;
				return A3($author$project$Components$Admin$CoveragePlans$Form$onSaved, response, model, ' was successfully created.');
			case 4:
				var response = msg.a;
				return A3($author$project$Components$Admin$CoveragePlans$Form$onSaved, response, model, ' was successfully updated.');
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					var plans = response.a;
					var headers = response.b;
					var totalCount = A2(
						$elm$core$Maybe$withDefault,
						0,
						A2(
							$elm$core$Maybe$andThen,
							$elm$core$String$toInt,
							A2($elm$core$Dict$get, 'x-total-count', headers)));
					var planRecords = A2(
						$elm$core$List$map,
						function (plan) {
							return {
								ahP: $author$project$Api$Provider$Plan$All$id(plan),
								Bq: $author$project$Api$Provider$Plan$All$name(plan)
							};
						},
						plans);
					var pagination = A2($author$project$Api$Pagination$withTotalCount, totalCount, model.ajJ);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ajJ: pagination,
								hh: _Utils_ap(model.hh, planRecords),
								ZG: response
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ZG: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 6:
				var allPlans = msg.a;
				var _v10 = model.SD;
				if (!_v10.$) {
					var form = _v10.a;
					var newForm = A3(
						$author$project$Utils$Form$update,
						$author$project$Components$Admin$CoveragePlans$Form$formFieldsUpdate,
						$author$project$Components$Admin$CoveragePlans$Form$AllPlans(allPlans),
						form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								SD: $elm$core$Maybe$Just(newForm),
								us: allPlans
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var plan = msg.a;
				var enabled = msg.b;
				var newForm = enabled ? A2(
					$elm$core$Maybe$map,
					A2(
						$author$project$Utils$Form$update,
						$author$project$Components$Admin$CoveragePlans$Form$formFieldsUpdate,
						$author$project$Components$Admin$CoveragePlans$Form$PlanAdd(plan)),
					model.SD) : A2(
					$elm$core$Maybe$map,
					A2(
						$author$project$Utils$Form$update,
						$author$project$Components$Admin$CoveragePlans$Form$formFieldsUpdate,
						$author$project$Components$Admin$CoveragePlans$Form$PlanRemove(plan.ahP)),
					model.SD);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: newForm}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 8:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					A2($author$project$Components$Admin$CoveragePlans$Form$fetchPlans, apiClient, newModel),
					_List_Nil);
			case 13:
				var subMsg = msg.a;
				var _v11 = model.afY;
				if (!_v11.$) {
					var coverageRules = _v11.a;
					var _v12 = A3($author$project$Components$Admin$CoveragePlans$Rules$update, apiClient, subMsg, coverageRules);
					var newCoverageRulesForm = _v12.a;
					var coverageRulesCmd = _v12.b;
					var coverageRulesOutMsgs = _v12.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								afY: $elm$core$Maybe$Just(newCoverageRulesForm)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoveragePlans$Form$CoverageRulesMsg, coverageRulesCmd),
						coverageRulesOutMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 10:
				var query = msg.a;
				var _v13 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Components$Admin$CoveragePlans$Form$debounceConfig, query, model.i5);
				var debounce = _v13.a;
				var cmd = _v13.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							i5: debounce,
							tT: $elm$core$Maybe$Just(query)
						}),
					cmd,
					_List_Nil);
			case 11:
				var dMsg = msg.a;
				var _v14 = A4(
					$jinjor$elm_debounce$Debounce$update,
					$author$project$Components$Admin$CoveragePlans$Form$debounceConfig,
					$jinjor$elm_debounce$Debounce$takeLast($author$project$Components$Admin$CoveragePlans$Form$debounceText),
					dMsg,
					model.i5);
				var debounce = _v14.a;
				var cmd = _v14.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{i5: debounce}),
					cmd,
					_List_Nil);
			case 12:
				var newModel = _Utils_update(
					model,
					{ajJ: $author$project$Components$Admin$CoveragePlans$Form$initPagination, hh: _List_Nil});
				return _Utils_Tuple3(
					newModel,
					A2($author$project$Components$Admin$CoveragePlans$Form$fetchPlans, apiClient, newModel),
					_List_Nil);
			case 14:
				var _v15 = model.OT;
				if (!_v15.$) {
					var coveragePlan_ = _v15.a;
					var _v16 = A5(
						$author$project$Components$Admin$CoverageDocuments$Form$init,
						apiClient,
						model.aa4,
						$author$project$Api$Provider$CoveragePlan$One$id(coveragePlan_),
						$author$project$Api$Provider$CoveragePlan$One$coverageDocuments(coveragePlan_),
						true);
					var coverageDocumentForm = _v16.a;
					var coverageDocumentsCmd = _v16.b;
					var newModel = _Utils_update(
						model,
						{
							OS: $elm$core$Maybe$Just(coverageDocumentForm)
						});
					return _Utils_Tuple3(
						newModel,
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoveragePlans$Form$CoverageDocumentsMsg, coverageDocumentsCmd),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var subMsg = msg.a;
				var _v17 = model.OS;
				if (!_v17.$) {
					var coverageDocuments_ = _v17.a;
					var result = A3($author$project$Components$Admin$CoverageDocuments$Form$update, apiClient, subMsg, coverageDocuments_);
					var retrievePlan = function () {
						var _v18 = _Utils_Tuple2(model.ahP, result.agZ);
						_v18$2:
						while (true) {
							if (!_v18.a.$) {
								switch (_v18.b) {
									case 1:
										var id_ = _v18.a.a;
										var _v19 = _v18.b;
										return A3($author$project$Api$Provider$CoveragePlan$retrieve, apiClient, id_, $author$project$Components$Admin$CoveragePlans$Form$GotCoveragePlan);
									case 2:
										var id_ = _v18.a.a;
										var _v20 = _v18.b;
										return A3($author$project$Api$Provider$CoveragePlan$retrieve, apiClient, id_, $author$project$Components$Admin$CoveragePlans$Form$GotCoveragePlan);
									default:
										break _v18$2;
								}
							} else {
								break _v18$2;
							}
						}
						return $elm$core$Platform$Cmd$none;
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								OS: $elm$core$Maybe$Just(result.aiO)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoveragePlans$Form$CoverageDocumentsMsg, result.GZ),
									retrievePlan
								])),
						result.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Admin$CoveragePlans$Id_String$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Admin$CoveragePlans$Form$update, model.Gv, subMsg, model.SD);
		var form = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{SD: form}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Components$Admin$CoveragePlans$Form$AttemptedSubmit = {$: 2};
var $author$project$Components$Admin$CoveragePlans$Form$FormUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$CoveragePlans$Form$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$CoverageRules$Form$category = function (_v0) {
	var model = _v0;
	return model.GW;
};
var $elm_community$list_extra$List$Extra$uniqueHelp = F4(
	function (f, existing, remaining, accumulator) {
		uniqueHelp:
		while (true) {
			if (!remaining.b) {
				return $elm$core$List$reverse(accumulator);
			} else {
				var first = remaining.a;
				var rest = remaining.b;
				var computedFirst = f(first);
				if (A2($elm$core$Set$member, computedFirst, existing)) {
					var $temp$f = f,
						$temp$existing = existing,
						$temp$remaining = rest,
						$temp$accumulator = accumulator;
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				} else {
					var $temp$f = f,
						$temp$existing = A2($elm$core$Set$insert, computedFirst, existing),
						$temp$remaining = rest,
						$temp$accumulator = A2($elm$core$List$cons, first, accumulator);
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$uniqueBy = F2(
	function (f, list) {
		return A4($elm_community$list_extra$List$Extra$uniqueHelp, f, $elm$core$Set$empty, list, _List_Nil);
	});
var $author$project$Components$Admin$CoveragePlans$Rules$allCategories = function (coverageRuleFormsWithIndex) {
	return A2(
		$elm$core$List$sortBy,
		function ($) {
			return $.Bq;
		},
		A2(
			$elm_community$list_extra$List$Extra$uniqueBy,
			function ($) {
				return $.ahP;
			},
			A2(
				$elm$core$List$filterMap,
				$author$project$Components$Admin$CoverageRules$Form$category,
				A2(
					$elm$core$List$map,
					function (tuple) {
						return tuple.a;
					},
					coverageRuleFormsWithIndex))));
};
var $author$project$Components$Admin$CoverageRules$Form$isReallyDeleted = function (_v0) {
	var model = _v0;
	return model.a7 && (_Utils_eq(model.yV, $elm$core$Maybe$Nothing) || model.cM);
};
var $author$project$Components$Admin$CoveragePlans$Rules$CoverageRuleAdded = {$: 1};
var $author$project$Components$Admin$CoveragePlans$Rules$viewAddCoverageRuleButton = A2(
	$author$project$Ui$ListGroup$item,
	_List_Nil,
	_List_fromArray(
		[
			A3(
			$author$project$Ui$Button$view,
			{mm: 'Add coverage rule'},
			_List_fromArray(
				[
					$author$project$Ui$Button$onClick($author$project$Components$Admin$CoveragePlans$Rules$CoverageRuleAdded),
					$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Add Coverage Rule')
				]))
		]));
var $author$project$Ui$ListGroup$Header = 4;
var $author$project$Components$Admin$CoveragePlans$Rules$isRuleInCategory = F2(
	function (ruleForm, categoryId) {
		var _v0 = $author$project$Components$Admin$CoverageRules$Form$category(ruleForm);
		if (!_v0.$) {
			var cat = _v0.a;
			return _Utils_eq(cat.ahP, categoryId);
		} else {
			return false;
		}
	});
var $author$project$Ui$ListGroup$Style = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$ListGroup$style = $author$project$Ui$ListGroup$Style;
var $author$project$Components$Admin$CoverageRules$Form$AttemptedSubmit = {$: 6};
var $author$project$Components$Admin$CoverageRules$Form$editingForm = function (model) {
	var _v0 = model.Z;
	if (!_v0.$) {
		var editedForm = _v0.a;
		return editedForm;
	} else {
		return model.SD;
	}
};
var $author$project$Components$Admin$CoverageRules$Form$AmountInCents = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$CoverageRules$Form$FormUpdated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Admin$CoverageRules$Form$Percentage = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$CoverageRules$Form$viewAmountOrPercentageInput = F2(
	function (fields, form) {
		var _v0 = fields.ak7;
		if (!_v0.$) {
			var ruleType = _v0.a;
			var currencyInput = A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(3),
						$author$project$Ui$Form$Group$inputSpanSm(9),
						$author$project$Ui$Form$Group$required(true),
						$author$project$Ui$Form$Group$label('Amount')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$CurrencyInput$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$CurrencyInput$value(fields.LE),
								$author$project$Ui$Form$CurrencyInput$placeholder('0.00'),
								$author$project$Ui$Form$CurrencyInput$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 4, form)),
								$author$project$Ui$Form$CurrencyInput$onInput(
								A2($elm$core$Basics$composeL, $author$project$Components$Admin$CoverageRules$Form$FormUpdated, $author$project$Components$Admin$CoverageRules$Form$AmountInCents))
							]))
					]));
			var _v1 = $author$project$Components$Admin$CoverageRules$Form$ruleTypeIdToValue(ruleType);
			_v1$4:
			while (true) {
				if (!_v1.$) {
					switch (_v1.a) {
						case 'flat_amount':
							return currencyInput;
						case 'surcharge':
							return currencyInput;
						case 'discounted':
							return A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$labelSpanSm(3),
										$author$project$Ui$Form$Group$inputSpanSm(9),
										$author$project$Ui$Form$Group$label('Percentage')
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$group(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$view(
												_List_fromArray(
													[
														$author$project$Ui$Form$Input$value(
														$elm$core$String$fromFloat(
															A2($elm$core$Maybe$withDefault, 0, fields.ajZ))),
														$author$project$Ui$Form$Input$onInput(
														A2($elm$core$Basics$composeL, $author$project$Components$Admin$CoverageRules$Form$FormUpdated, $author$project$Components$Admin$CoverageRules$Form$Percentage)),
														$author$project$Ui$Form$Input$invalid(
														A2($author$project$Utils$Form$hasValidationErrors, 6, form))
													])),
												$author$project$Ui$Form$Input$addon(
												_List_fromArray(
													[
														$elm$html$Html$text('%')
													]))
											]))
									]));
						case 'included':
							var typeIncludedOption = A2($elm$core$Maybe$andThen, $author$project$Components$Admin$CoverageRules$Form$ruleTypeIncludedOption, fields.ak7);
							return _Utils_eq(
								typeIncludedOption,
								$elm$core$Maybe$Just(1)) ? currencyInput : $author$project$Utils$Html$empty;
						default:
							break _v1$4;
					}
				} else {
					break _v1$4;
				}
			}
			return $author$project$Utils$Html$empty;
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$Admin$CoverageRules$Form$viewCategoryResourceFilter = F2(
	function (categoryResourceFilter, form) {
		return A2(
			$elm$html$Html$map,
			$author$project$Components$Admin$CoverageRules$Form$CategoryResourceFilterMsg,
			A2(
				$author$project$Components$ResourceFilter$Category$view,
				_List_fromArray(
					[
						$author$project$Components$ResourceFilter$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 2, form))
					]),
				categoryResourceFilter));
	});
var $author$project$Components$Admin$CoverageRules$Form$viewChargeItemResourceFilter = F2(
	function (chargeItemResourceFilter, form) {
		return A2(
			$elm$html$Html$map,
			$author$project$Components$Admin$CoverageRules$Form$ChargeItemResourceFilterMsg,
			A2(
				$author$project$Components$ResourceFilter$ChargeItem$view,
				_List_fromArray(
					[
						$author$project$Components$ResourceFilter$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 1, form))
					]),
				chargeItemResourceFilter));
	});
var $author$project$Components$Admin$CoverageRules$Form$viewChargeItemOrCategoryFilter = F3(
	function (model, form, isEditing) {
		var fields = $author$project$Utils$Form$fields(form);
		var isCategory = fields.sW === 'charge_category';
		var chargeLabel = isCategory ? 'Charge category' : 'Charge Item';
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$required(true),
					$author$project$Ui$Form$Group$label(chargeLabel)
				]),
			_List_fromArray(
				[
					isEditing ? (isCategory ? A2(
					$elm$html$Html$map,
					$author$project$Components$Admin$CoverageRules$Form$CategoryResourceFilterMsg,
					A2(
						$author$project$Components$ResourceFilter$Category$view,
						_List_fromArray(
							[
								$author$project$Components$ResourceFilter$disabled(isEditing)
							]),
						model.c8)) : A2(
					$elm$html$Html$map,
					$author$project$Components$Admin$CoverageRules$Form$ChargeItemResourceFilterMsg,
					A2(
						$author$project$Components$ResourceFilter$ChargeItem$view,
						_List_fromArray(
							[
								$author$project$Components$ResourceFilter$disabled(isEditing)
							]),
						model.cq))) : (isCategory ? A2($author$project$Components$Admin$CoverageRules$Form$viewCategoryResourceFilter, model.c8, form) : A2($author$project$Components$Admin$CoverageRules$Form$viewChargeItemResourceFilter, model.cq, form))
				]));
	});
var $author$project$Components$Admin$CoverageRules$Form$CoveredBy = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Admin$CoverageRules$Form$viewCoveredBy = function (coveredBy) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9),
				$author$project$Ui$Form$Group$required(true),
				$author$project$Ui$Form$Group$label('Amount Due Paid For By')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Radio$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Radio$value(!coveredBy),
								$author$project$Ui$Form$Radio$onCheck(
								A2(
									$elm$core$Basics$composeL,
									$author$project$Components$Admin$CoverageRules$Form$FormUpdated,
									$elm$core$Basics$always(
										$author$project$Components$Admin$CoverageRules$Form$CoveredBy(0))))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Patient')
							])),
						A2(
						$author$project$Ui$Form$Radio$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Radio$value(coveredBy === 1),
								$author$project$Ui$Form$Radio$onCheck(
								A2(
									$elm$core$Basics$composeL,
									$author$project$Components$Admin$CoverageRules$Form$FormUpdated,
									$elm$core$Basics$always(
										$author$project$Components$Admin$CoverageRules$Form$CoveredBy(1))))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Sponsor')
							]))
					]))
			]));
};
var $author$project$Components$Admin$CoverageRules$Form$ItemType = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Admin$CoverageRules$Form$viewItemType = F2(
	function (form, isEditing) {
		var fields = $author$project$Utils$Form$fields(form);
		var typeIncludedOption = A2($elm$core$Maybe$andThen, $author$project$Components$Admin$CoverageRules$Form$ruleTypeIncludedOption, fields.ak7);
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$required(true),
					$author$project$Ui$Form$Group$label('Applies To')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Radio$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Radio$value(fields.sW === 'charge_category'),
									$author$project$Ui$Form$Radio$onCheck(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Components$Admin$CoverageRules$Form$FormUpdated,
										$elm$core$Basics$always(
											$author$project$Components$Admin$CoverageRules$Form$ItemType('charge_category')))),
									$author$project$Ui$Form$Radio$disabled(
									isEditing || ($author$project$Components$Admin$CoverageRules$Form$ruleTypeId(fields.ak7) === 'limited_quantity'))
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Charge Category')
										]))
								])),
							A2(
							$author$project$Ui$Form$Radio$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Radio$value(fields.sW === 'charge_item'),
									$author$project$Ui$Form$Radio$onCheck(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Components$Admin$CoverageRules$Form$FormUpdated,
										$elm$core$Basics$always(
											$author$project$Components$Admin$CoverageRules$Form$ItemType('charge_item')))),
									$author$project$Ui$Form$Radio$disabled(
									isEditing || _Utils_eq(
										typeIncludedOption,
										$elm$core$Maybe$Just(1)))
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Charge Item')
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Admin$CoverageRules$Form$Quantity = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Admin$CoverageRules$Form$viewQuantity = F3(
	function (quantity, form, isEditing) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$required(true),
					$author$project$Ui$Form$Group$label('Quantity')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$value(
							$elm$core$String$fromInt(
								A2($elm$core$Maybe$withDefault, 0, quantity))),
							$author$project$Ui$Form$Input$phi(true),
							$author$project$Ui$Form$Input$disabled(isEditing),
							$author$project$Ui$Form$Input$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 5, form)),
							$author$project$Ui$Form$Input$onInput(
							A2($elm$core$Basics$composeL, $author$project$Components$Admin$CoverageRules$Form$FormUpdated, $author$project$Components$Admin$CoverageRules$Form$Quantity))
						]))
				]));
	});
var $author$project$Components$Admin$CoverageRules$Form$RuleTypeSearchChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$CoverageRules$Form$RuleTypeSelected = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$CoverageRules$Form$disableSelectItem = F2(
	function (itemType, ruleTypeOption) {
		var _v0 = _Utils_Tuple3(
			itemType,
			$author$project$Components$Admin$CoverageRules$Form$ruleTypeId(
				$elm$core$Maybe$Just(ruleTypeOption)),
			$author$project$Components$Admin$CoverageRules$Form$ruleTypeIncludedOption(ruleTypeOption));
		_v0$2:
		while (true) {
			switch (_v0.a) {
				case 'charge_item':
					if (((_v0.b === 'included') && (!_v0.c.$)) && (_v0.c.a === 1)) {
						var _v1 = _v0.c.a;
						return true;
					} else {
						break _v0$2;
					}
				case 'charge_category':
					if (_v0.b === 'limited_quantity') {
						return true;
					} else {
						break _v0$2;
					}
				default:
					break _v0$2;
			}
		}
		return false;
	});
var $author$project$Components$Admin$CoverageRules$Form$ruleTypeOptionToTitle = function (ruleTypeOption) {
	var name = ruleTypeOption.Bq;
	return name;
};
var $author$project$Components$Admin$CoverageRules$Form$viewRuleType = F3(
	function (model, form, isEditing) {
		var fields = $author$project$Utils$Form$fields(form);
		var triggerContent = function () {
			var _v0 = fields.ak7;
			if (!_v0.$) {
				var ruleType = _v0.a;
				return _List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Components$Admin$CoverageRules$Form$ruleTypeOptionToTitle(ruleType))
					]);
			} else {
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$text,
						_List_fromArray(
							[$author$project$Ui$Typography$muted]),
						'Select Coverage Rule')
					]);
			}
		}();
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$required(true),
					$author$project$Ui$Form$Group$label('Coverage Rule')
				]),
			_List_fromArray(
				[
					A4(
					$author$project$Ui$Dropdown$viewSelect,
					_List_fromArray(
						[
							$author$project$Ui$Dropdown$disabled(isEditing),
							$author$project$Ui$Dropdown$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
							$author$project$Ui$Dropdown$errors(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						]),
					triggerContent,
					function () {
						if (isEditing) {
							return _List_Nil;
						} else {
							var query = $elm$core$String$toLower(model.pN);
							return A2(
								$elm$core$List$cons,
								$author$project$Ui$Dropdown$input(
									_List_fromArray(
										[
											$author$project$Ui$Dropdown$onInput($author$project$Components$Admin$CoverageRules$Form$RuleTypeSearchChanged),
											$author$project$Ui$Dropdown$value(model.pN),
											$author$project$Ui$Dropdown$placeholder('Search...')
										])),
								A2(
									$elm$core$List$map,
									function (option) {
										return A2(
											$author$project$Ui$Dropdown$item,
											_List_fromArray(
												[
													$author$project$Ui$Dropdown$onSelect(
													$author$project$Components$Admin$CoverageRules$Form$RuleTypeSelected(
														$elm$core$Maybe$Just(option))),
													$author$project$Ui$Dropdown$selected(
													_Utils_eq(
														fields.ak7,
														$elm$core$Maybe$Just(option)))
												]),
											$elm$html$Html$text(
												$author$project$Components$Admin$CoverageRules$Form$ruleTypeOptionToTitle(option)));
									},
									A2(
										$elm$core$List$filter,
										function (option) {
											return $elm$core$String$isEmpty(query) || A2(
												$elm$core$String$contains,
												query,
												$elm$core$String$toLower(
													$author$project$Components$Admin$CoverageRules$Form$ruleTypeOptionToTitle(option)));
										},
										A2(
											$elm$core$List$filter,
											function (option) {
												return !A2($author$project$Components$Admin$CoverageRules$Form$disableSelectItem, fields.sW, option);
											},
											$author$project$Components$Admin$CoverageRules$Form$ruleTypeOptions))));
						}
					}(),
					model.pM)
				]));
	});
var $author$project$Components$Admin$CoverageRules$Form$sentenceRecordBuilder = F2(
	function (shouldUnderlineText, form) {
		var fields = $author$project$Utils$Form$fields(form);
		var includedOption = A2($elm$core$Maybe$andThen, $author$project$Components$Admin$CoverageRules$Form$ruleTypeIncludedOption, fields.ak7);
		var itemName = function () {
			var _v1 = fields.Io;
			if (!_v1.$) {
				var item = _v1.a;
				return item.Bq;
			} else {
				return '';
			}
		}();
		var ruleType = function () {
			var _v0 = fields.ak7;
			if (!_v0.$) {
				var ruleType_ = _v0.a;
				return A2(
					$elm$core$Maybe$withDefault,
					'',
					$author$project$Components$Admin$CoverageRules$Form$ruleTypeIdToValue(ruleType_));
			} else {
				return '';
			}
		}();
		return {
			LE: fields.LE,
			d2: (!fields.d2) ? 'patient' : 'sponsor',
			ez: includedOption,
			aig: itemName,
			sW: fields.sW,
			ajZ: fields.ajZ,
			Dz: fields.Dz,
			ak7: ruleType,
			alt: shouldUnderlineText,
			al4: fields.al4
		};
	});
var $author$project$Components$CoverageRuleSentence$formatPercentage = function (percentage) {
	if (!percentage.$) {
		var percentage_ = percentage.a;
		return $author$project$Formatters$Float$toPercentage(percentage_);
	} else {
		return '___%';
	}
};
var $author$project$Components$CoverageRuleSentence$formatRuleItemName = function (record) {
	var pluralName = $author$project$Formatters$String$pluralOf(record.aig);
	return (record.sW === 'charge_category') ? ('All ' + pluralName) : pluralName;
};
var $author$project$Components$CoverageRuleSentence$spanText = function (string) {
	return A2(
		$elm$html$Html$span,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Utils$Html$noBreakSpace,
				$elm$html$Html$text(string),
				$author$project$Utils$Html$noBreakSpace
			]));
};
var $author$project$Components$CoverageRuleSentence$strongText = F2(
	function (string, shouldUnderlineText) {
		return shouldUnderlineText ? A2(
			$author$project$Ui$Typography$strong,
			_List_fromArray(
				[$author$project$Ui$Typography$underline]),
			_List_fromArray(
				[
					$elm$html$Html$text(string)
				])) : A2(
			$author$project$Ui$Typography$strong,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(string)
				]));
	});
var $author$project$Components$CoverageRuleSentence$viewDiscounted = function (record) {
	return _List_fromArray(
		[
			A2(
			$author$project$Components$CoverageRuleSentence$strongText,
			$author$project$Components$CoverageRuleSentence$formatRuleItemName(record),
			record.alt),
			$author$project$Components$CoverageRuleSentence$spanText('will receive a'),
			A2(
			$author$project$Components$CoverageRuleSentence$strongText,
			'discount of ' + $author$project$Components$CoverageRuleSentence$formatPercentage(record.ajZ),
			record.alt),
			$author$project$Components$CoverageRuleSentence$spanText('with the amount due paid for by the'),
			A2($author$project$Components$CoverageRuleSentence$strongText, record.d2, record.alt)
		]);
};
var $author$project$Components$CoverageRuleSentence$formatAmount = function (amountInCents) {
	if (!amountInCents.$) {
		var amountInCents_ = amountInCents.a;
		return $author$project$Currency$format(amountInCents_);
	} else {
		return '$___';
	}
};
var $author$project$Components$CoverageRuleSentence$viewFlatAmount = function (record) {
	return _List_fromArray(
		[
			A2(
			$author$project$Components$CoverageRuleSentence$strongText,
			$author$project$Components$CoverageRuleSentence$formatRuleItemName(record),
			record.alt),
			$author$project$Components$CoverageRuleSentence$spanText('will be'),
			A2(
			$author$project$Components$CoverageRuleSentence$strongText,
			$author$project$Components$CoverageRuleSentence$formatAmount(record.LE),
			record.alt),
			$author$project$Components$CoverageRuleSentence$spanText('paid for by the'),
			A2($author$project$Components$CoverageRuleSentence$strongText, record.d2, record.alt)
		]);
};
var $author$project$Components$CoverageRuleSentence$viewIncludedAll = function (record) {
	return _List_fromArray(
		[
			A2(
			$author$project$Components$CoverageRuleSentence$strongText,
			$author$project$Components$CoverageRuleSentence$formatRuleItemName(record),
			record.alt),
			$author$project$Components$CoverageRuleSentence$spanText('are'),
			A2($author$project$Components$CoverageRuleSentence$strongText, 'included', record.alt),
			$author$project$Components$CoverageRuleSentence$spanText('in the membership at no additional charge')
		]);
};
var $author$project$Components$CoverageRuleSentence$noBreakSpaceRight = function (string) {
	return $elm$html$Html$text(
		_Utils_ap(string, $author$project$Utils$String$noBreakSpace));
};
var $author$project$Components$CoverageRuleSentence$viewIncludedUnderPrice = function (record) {
	return _List_fromArray(
		[
			A2(
			$author$project$Components$CoverageRuleSentence$strongText,
			$author$project$Components$CoverageRuleSentence$formatRuleItemName(record),
			record.alt),
			$author$project$Components$CoverageRuleSentence$spanText('are'),
			A2($author$project$Components$CoverageRuleSentence$strongText, 'included', record.alt),
			$author$project$Components$CoverageRuleSentence$spanText('in the membership at no additional charge if they cost less than'),
			A2(
			$author$project$Components$CoverageRuleSentence$strongText,
			$author$project$Components$CoverageRuleSentence$formatAmount(record.LE),
			record.alt),
			$author$project$Components$CoverageRuleSentence$noBreakSpaceRight(','),
			$author$project$Components$CoverageRuleSentence$noBreakSpaceRight('those above are paid for by the'),
			A2($author$project$Components$CoverageRuleSentence$strongText, record.d2, record.alt)
		]);
};
var $author$project$Components$CoverageRuleSentence$viewIncluded = function (record) {
	var _v0 = record.ez;
	if (!_v0.$) {
		if (!_v0.a) {
			var _v1 = _v0.a;
			return $author$project$Components$CoverageRuleSentence$viewIncludedAll(record);
		} else {
			var _v2 = _v0.a;
			return $author$project$Components$CoverageRuleSentence$viewIncludedUnderPrice(record);
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$CoverageRuleSentence$viewLimitedQuantity = function (record) {
	var quantity = function () {
		var _v4 = record.Dz;
		if (!_v4.$) {
			var quantity_ = _v4.a;
			return A2($author$project$Formatters$String$pluralize, 'unit', quantity_);
		} else {
			return '___ units';
		}
	}();
	var _v0 = function () {
		var _v1 = record.al4;
		if (!_v1.$) {
			if (!_v1.a) {
				var _v2 = _v1.a;
				return _Utils_Tuple2('', 'Jan 1st,');
			} else {
				var _v3 = _v1.a;
				return _Utils_Tuple2(' the patient\'s', 'membership renewal date,');
			}
		} else {
			return _Utils_Tuple2('', '');
		}
	}();
	var subject = _v0.a;
	var timePeriod = _v0.b;
	return _List_fromArray(
		[
			A2(
			$author$project$Components$CoverageRuleSentence$strongText,
			$author$project$Components$CoverageRuleSentence$formatRuleItemName(record),
			record.alt),
			$author$project$Components$CoverageRuleSentence$spanText('are'),
			A2($author$project$Components$CoverageRuleSentence$strongText, 'limited to a quantity', record.alt),
			$author$project$Components$CoverageRuleSentence$spanText('of'),
			A2($author$project$Components$CoverageRuleSentence$strongText, quantity, record.alt),
			$author$project$Components$CoverageRuleSentence$spanText('per period resetting on' + subject),
			A2($author$project$Components$CoverageRuleSentence$strongText, timePeriod, record.alt),
			$author$project$Components$CoverageRuleSentence$spanText('additional units will be paid for by the'),
			A2($author$project$Components$CoverageRuleSentence$strongText, record.d2, record.alt)
		]);
};
var $author$project$Components$CoverageRuleSentence$viewPassThrough = function (record) {
	return _List_fromArray(
		[
			A2(
			$author$project$Components$CoverageRuleSentence$strongText,
			$author$project$Components$CoverageRuleSentence$formatRuleItemName(record),
			record.alt),
			$author$project$Components$CoverageRuleSentence$spanText('will be paid for by the'),
			A2($author$project$Components$CoverageRuleSentence$strongText, record.d2, record.alt)
		]);
};
var $author$project$Components$CoverageRuleSentence$viewSurcharge = function (record) {
	return _List_fromArray(
		[
			A2(
			$author$project$Components$CoverageRuleSentence$strongText,
			$author$project$Components$CoverageRuleSentence$formatRuleItemName(record),
			record.alt),
			$author$project$Components$CoverageRuleSentence$spanText('will have a surcharge of'),
			A2(
			$author$project$Components$CoverageRuleSentence$strongText,
			$author$project$Components$CoverageRuleSentence$formatAmount(record.LE),
			record.alt),
			$author$project$Components$CoverageRuleSentence$spanText('added to the charge, the amount due will be paid for by the'),
			A2($author$project$Components$CoverageRuleSentence$strongText, record.d2, record.alt)
		]);
};
var $author$project$Components$CoverageRuleSentence$view = function (record) {
	return A2(
		$elm$html$Html$span,
		_List_Nil,
		function () {
			var _v0 = record.ak7;
			switch (_v0) {
				case 'included':
					return $author$project$Components$CoverageRuleSentence$viewIncluded(record);
				case 'flat_amount':
					return $author$project$Components$CoverageRuleSentence$viewFlatAmount(record);
				case 'discounted':
					return $author$project$Components$CoverageRuleSentence$viewDiscounted(record);
				case 'surcharge':
					return $author$project$Components$CoverageRuleSentence$viewSurcharge(record);
				case 'pass_through':
					return $author$project$Components$CoverageRuleSentence$viewPassThrough(record);
				case 'limited_quantity':
					return $author$project$Components$CoverageRuleSentence$viewLimitedQuantity(record);
				default:
					return _List_Nil;
			}
		}());
};
var $author$project$Components$Admin$CoverageRules$Form$viewSentencePreview = F2(
	function (fields, form) {
		var _v0 = _Utils_Tuple2(fields.Io, fields.ak7);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$HorizontalRule$view(_List_Nil),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpanSm(3),
								$author$project$Ui$Form$Group$inputSpanSm(9),
								$author$project$Ui$Form$Group$label('Preview')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Static$view,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Components$CoverageRuleSentence$view(
										A2($author$project$Components$Admin$CoverageRules$Form$sentenceRecordBuilder, false, form))
									]))
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$Admin$CoverageRules$Form$TimePeriod = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Admin$CoverageRules$Form$viewTimePeriod = F2(
	function (timePeriod, isEditing) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$required(true),
					$author$project$Ui$Form$Group$label('Time period')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Time-period resetting on:'),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Radio$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Radio$value(
									_Utils_eq(
										timePeriod,
										$elm$core$Maybe$Just(0))),
									$author$project$Ui$Form$Radio$onCheck(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Components$Admin$CoverageRules$Form$FormUpdated,
										$elm$core$Basics$always(
											$author$project$Components$Admin$CoverageRules$Form$TimePeriod(0)))),
									$author$project$Ui$Form$Radio$disabled(isEditing)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Jan 1st')
								])),
							A2(
							$author$project$Ui$Form$Radio$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Radio$value(
									_Utils_eq(
										timePeriod,
										$elm$core$Maybe$Just(1))),
									$author$project$Ui$Form$Radio$onCheck(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Components$Admin$CoverageRules$Form$FormUpdated,
										$elm$core$Basics$always(
											$author$project$Components$Admin$CoverageRules$Form$TimePeriod(1)))),
									$author$project$Ui$Form$Radio$disabled(isEditing)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Renewal Date')
								]))
						]))
				]));
	});
var $author$project$Components$Admin$CoverageRules$Form$viewCreateOrEditForm = function (model) {
	var submitVerb = function () {
		var _v1 = model.a9;
		switch (_v1) {
			case 0:
				return 'Create';
			case 1:
				return 'Save';
			default:
				return '';
		}
	}();
	var modalTitle = function () {
		var _v0 = model.a9;
		switch (_v0) {
			case 0:
				return 'Add Coverage Rule';
			case 1:
				return 'Edit Coverage Rule';
			default:
				return '';
		}
	}();
	var isEditing = model.a9 === 1;
	var form = $author$project$Components$Admin$CoverageRules$Form$editingForm(model);
	var fields = $author$project$Utils$Form$fields(form);
	var typeId = $author$project$Components$Admin$CoverageRules$Form$ruleTypeId(fields.ak7);
	var typeIncludedOption = A2($elm$core$Maybe$andThen, $author$project$Components$Admin$CoverageRules$Form$ruleTypeIncludedOption, fields.ak7);
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Admin$CoverageRules$Form$AttemptedCancel,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title(modalTitle)
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2($author$project$Components$Admin$CoverageRules$Form$viewItemType, form, isEditing),
						A3($author$project$Components$Admin$CoverageRules$Form$viewChargeItemOrCategoryFilter, model, form, isEditing),
						A3($author$project$Components$Admin$CoverageRules$Form$viewRuleType, model, form, isEditing),
						A2($author$project$Components$Admin$CoverageRules$Form$viewAmountOrPercentageInput, fields, form),
						(typeId === 'limited_quantity') ? A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A3($author$project$Components$Admin$CoverageRules$Form$viewQuantity, fields.Dz, form, isEditing),
								A2($author$project$Components$Admin$CoverageRules$Form$viewTimePeriod, fields.al4, isEditing)
							])) : $author$project$Utils$Html$empty,
						((typeId === '') || ((typeId === 'included') && (!_Utils_eq(
						typeIncludedOption,
						$elm$core$Maybe$Just(1))))) ? $author$project$Utils$Html$empty : $author$project$Components$Admin$CoverageRules$Form$viewCoveredBy(fields.d2),
						A2($author$project$Components$Admin$CoverageRules$Form$viewSentencePreview, fields, form)
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Cancel and close'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Admin$CoverageRules$Form$AttemptedCancel)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Close')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: submitVerb},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$onClick($author$project$Components$Admin$CoverageRules$Form$AttemptedSubmit)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(submitVerb)
							]))
					]))
			]));
};
var $author$project$Components$Admin$CoverageRules$Form$AttemptedCancelDelete = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Admin$CoverageRules$Form$cancelDelete = function (form) {
	var fields = $author$project$Utils$Form$fields(form);
	var _v0 = fields.ahP;
	if (!_v0.$) {
		var id_ = _v0.a;
		return _List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Cancel deletion'},
				_List_fromArray(
					[
						$author$project$Ui$Button$link,
						$author$project$Ui$Button$sm,
						$author$project$Ui$Button$onClick(
						$author$project$Components$Admin$CoverageRules$Form$AttemptedCancelDelete(id_))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Cancel Deletion')
					]))
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Admin$CoverageRules$Form$AttemptedDelete = function (a) {
	return {$: 9, a: a};
};
var $author$project$Ui$Icon$UnpublishedRuleArrow = 2;
var $author$project$Ui$Icon$unpublishedRuleArrow = $author$project$Ui$Icon$viewIcon(2);
var $author$project$Ui$Element$InlineFlex = 3;
var $author$project$Ui$Element$inline = A2($author$project$Ui$Element$Display, 0, 3);
var $author$project$Components$Admin$CoverageRules$Form$unpublishedTag = A2(
	$author$project$Ui$Element$view,
	_List_fromArray(
		[$author$project$Ui$Element$inline, $author$project$Ui$Element$ml1]),
	_List_fromArray(
		[
			A2($author$project$Ui$Badge$fromString, _List_Nil, 'unpublished_change')
		]));
var $author$project$Components$Admin$CoverageRules$Form$unpublishedSentence = function (editedForm) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('coverage-rule__unpublished')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('coverage-rule__unpublished__arrow')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Icon$unpublishedRuleArrow(_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('coverage-rule__unpublished__warning')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Alert$warning,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$spanMd(10)
											]),
										_List_fromArray(
											[
												$author$project$Components$CoverageRuleSentence$view(
												A2($author$project$Components$Admin$CoverageRules$Form$sentenceRecordBuilder, true, editedForm)),
												$author$project$Components$Admin$CoverageRules$Form$unpublishedTag
											])),
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$spanMd(2),
												$author$project$Ui$Grid$justifyRight
											]),
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Button$view,
												{mm: 'Cancel change'},
												_List_fromArray(
													[
														$author$project$Ui$Button$link,
														$author$project$Ui$Button$sm,
														$author$project$Ui$Button$onClick(
														$author$project$Components$Admin$CoverageRules$Form$AttemptedDelete(
															$author$project$Utils$Form$fields(editedForm).ahP))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Cancel Change')
													]))
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Api$Provider$CoverageRuleUsage$Shared$coveredCharges = function (_v0) {
	var record = _v0;
	return record.OX;
};
var $author$project$Api$Provider$CoverageRuleUsage$All$coveredCharges = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CoverageRuleUsage$Shared$coveredCharges(shared);
};
var $author$project$Api$Provider$CoverageRule$Shared$itemName = function (_v0) {
	var record = _v0;
	var _v1 = record.Io;
	if (!_v1.$) {
		var i = _v1.a;
		return $author$project$Api$Provider$ChargeItem$Shared$name(i);
	} else {
		var cat = _v1.a;
		return $author$project$Api$Provider$Category$Shared$name(cat);
	}
};
var $author$project$Api$Provider$CoverageRule$One$itemName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CoverageRule$Shared$itemName(shared);
};
var $author$project$Api$Provider$CoverageRuleUsage$Shared$remainingItems = function (_v0) {
	var record = _v0;
	return record.$r;
};
var $author$project$Api$Provider$CoverageRuleUsage$All$remainingItems = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CoverageRuleUsage$Shared$remainingItems(shared);
};
var $author$project$Api$Provider$CoverageRuleUsage$Shared$remainingItemsUntil = function (_v0) {
	var record = _v0;
	return record.$s;
};
var $author$project$Api$Provider$CoverageRuleUsage$All$remainingItemsUntil = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CoverageRuleUsage$Shared$remainingItemsUntil(shared);
};
var $author$project$Api$Provider$CoveredCharge$Min$coveredDate = function (_v0) {
	var record = _v0;
	return record.OY;
};
var $author$project$Api$Provider$CoveredCharge$Min$quantity = function (_v0) {
	var record = _v0;
	return record.Dz;
};
var $author$project$Components$CoverageRuleUsage$viewCoveredCharge = function (coveredCharge) {
	var quantity = $author$project$Api$Provider$CoveredCharge$Min$quantity(coveredCharge);
	var date = $author$project$Api$Provider$CoveredCharge$Min$coveredDate(coveredCharge);
	var string = $justinmimbs$date$Date$toIsoString(date) + (' - ' + (A2($author$project$Formatters$String$pluralize, 'unit', quantity) + ' utilized'));
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('timeline__item')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(string)
			]));
};
var $author$project$Components$CoverageRuleUsage$viewCoveredCharges = function (coveredCharges) {
	return $elm$core$List$isEmpty(coveredCharges) ? $author$project$Utils$Html$empty : A3(
		$author$project$Ui$Popover$view,
		_List_fromArray(
			[$author$project$Ui$Popover$dark, $author$project$Ui$Popover$sm]),
		_List_fromArray(
			[
				$author$project$Ui$Icon$help(_List_Nil)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Popover$body,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('timeline mt-05 ml-1')
							]),
						A2($elm$core$List$map, $author$project$Components$CoverageRuleUsage$viewCoveredCharge, coveredCharges))
					]))
			]));
};
var $author$project$Components$CoverageRuleUsage$view = function (coverageRuleUsage) {
	var remainingQuantity = A2(
		$elm$core$Maybe$withDefault,
		0,
		$author$project$Api$Provider$CoverageRuleUsage$All$remainingItems(coverageRuleUsage));
	var itemName = $author$project$Api$Provider$CoverageRule$One$itemName(
		$author$project$Api$Provider$CoverageRuleUsage$All$coverageRule(coverageRuleUsage));
	var remainingDescriptionPrefix = $elm$core$String$fromInt(remainingQuantity) + (' included ' + itemName);
	var description = function () {
		switch (remainingQuantity) {
			case 0:
				var remainingItemsUntil = A2(
					$elm$core$Maybe$withDefault,
					'',
					$author$project$Api$Provider$CoverageRuleUsage$All$remainingItemsUntil(coverageRuleUsage));
				return 'All included ' + (itemName + (' have been used until ' + remainingItemsUntil));
			case 1:
				return remainingDescriptionPrefix + ' remains';
			default:
				return remainingDescriptionPrefix + ' remain';
		}
	}();
	return A2(
		$elm$html$Html$span,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$text,
				_List_fromArray(
					[$author$project$Ui$Typography$small]),
				description),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Components$CoverageRuleUsage$viewCoveredCharges(
				$author$project$Api$Provider$CoverageRuleUsage$All$coveredCharges(coverageRuleUsage))
			]));
};
var $author$project$Components$Admin$CoverageRules$Form$AttemptedEdit = {$: 8};
var $author$project$Components$Admin$CoverageRules$Form$cannotBeEdited = F2(
	function (form, unpublishedForm) {
		var fields = $author$project$Utils$Form$fields(form);
		var ruleType = A2($elm$core$Maybe$andThen, $author$project$Components$Admin$CoverageRules$Form$ruleTypeIdToValue, fields.ak7);
		var isIncluded = A2(
			$elm$core$Maybe$map,
			function (r) {
				return r === 'included';
			},
			ruleType);
		return (A2($elm$core$Maybe$withDefault, false, isIncluded) && (fields.sW === 'charge_item')) || (!_Utils_eq(unpublishedForm, $elm$core$Maybe$Nothing));
	});
var $author$project$Components$Admin$CoverageRules$Form$viewRuleActions = F2(
	function (form, unpublishedForm) {
		var fields = $author$project$Utils$Form$fields(form);
		return _List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Edit rule'},
				_List_fromArray(
					[
						$author$project$Ui$Button$link,
						$author$project$Ui$Button$sm,
						$author$project$Ui$Button$onClick($author$project$Components$Admin$CoverageRules$Form$AttemptedEdit),
						$author$project$Ui$Button$disabled(
						A2($author$project$Components$Admin$CoverageRules$Form$cannotBeEdited, form, unpublishedForm)),
						$author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Edit')
					])),
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Delete rule'},
				_List_fromArray(
					[
						$author$project$Ui$Button$link,
						$author$project$Ui$Button$sm,
						$author$project$Ui$Button$onClick(
						$author$project$Components$Admin$CoverageRules$Form$AttemptedDelete(fields.ahP)),
						$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Delete')
					]))
			]);
	});
var $author$project$Components$Admin$CoverageRules$Form$viewSentence = function (model) {
	var unpublishedTagIfUnpublished = (model.a7 || model.cM) ? $author$project$Components$Admin$CoverageRules$Form$unpublishedTag : $author$project$Utils$Html$empty;
	var sentenceOptions = model.a7 ? _List_fromArray(
		[$author$project$Ui$Typography$strike, $author$project$Ui$Typography$gray]) : _List_Nil;
	var emptySecondRow = A2($author$project$Ui$Grid$row, _List_Nil, _List_Nil);
	var _v0 = _Utils_Tuple2(model.SD, model.Z);
	var form = _v0.a;
	var editedForm = _v0.b;
	var sentenceRow = _List_fromArray(
		[
			$author$project$Components$CoverageRuleSentence$view(
			A2($author$project$Components$Admin$CoverageRules$Form$sentenceRecordBuilder, true, form))
		]);
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$spaceBetween]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Ui$Typography$span, sentenceOptions, sentenceRow),
								unpublishedTagIfUnpublished,
								function () {
								var _v1 = model.G5;
								if (!_v1.$) {
									var coverageRuleUsage = _v1.a;
									return A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Components$CoverageRuleUsage$view(coverageRuleUsage)
											]));
								} else {
									return $author$project$Utils$Html$empty;
								}
							}()
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$gap2]),
						model.a7 ? $author$project$Components$Admin$CoverageRules$Form$cancelDelete(form) : ((!model._6) ? A2($author$project$Components$Admin$CoverageRules$Form$viewRuleActions, form, editedForm) : _List_Nil))
					])),
				function () {
				if (!editedForm.$) {
					var editedForm_ = editedForm.a;
					return model.cM ? emptySecondRow : ((!model._6) ? $author$project$Components$Admin$CoverageRules$Form$unpublishedSentence(editedForm_) : emptySecondRow);
				} else {
					return emptySecondRow;
				}
			}()
			]));
};
var $author$project$Components$Admin$CoverageRules$Form$view = function (_v0) {
	var model = _v0;
	var _v1 = model.a9;
	switch (_v1) {
		case 0:
			return $author$project$Components$Admin$CoverageRules$Form$viewCreateOrEditForm(model);
		case 1:
			return $author$project$Components$Admin$CoverageRules$Form$viewCreateOrEditForm(model);
		default:
			return $author$project$Components$Admin$CoverageRules$Form$viewSentence(model);
	}
};
var $author$project$Components$Admin$CoveragePlans$Rules$viewRuleFormRow = F2(
	function (ruleForm, index) {
		return A2(
			$author$project$Ui$ListGroup$item,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Components$Admin$CoveragePlans$Rules$CoverageRuleFormMsg(index),
					$author$project$Components$Admin$CoverageRules$Form$view(ruleForm))
				]));
	});
var $author$project$Components$Admin$CoveragePlans$Rules$viewCategorizedCoverageRuleForms = F2(
	function (categories, coverageRuleFormsWithIndex) {
		return A2(
			$elm$core$List$concatMap,
			function (category) {
				var rulesInThisCategory = A2(
					$elm$core$List$filter,
					function (tuple) {
						return A2($author$project$Components$Admin$CoveragePlans$Rules$isRuleInCategory, tuple.a, category.ahP);
					},
					coverageRuleFormsWithIndex);
				return A2(
					$elm$core$List$cons,
					A2(
						$author$project$Ui$ListGroup$item,
						_List_fromArray(
							[
								$author$project$Ui$ListGroup$style(4)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$toUpper(category.Bq))
							])),
					A2(
						$elm$core$List$map,
						function (tuple) {
							return A2($author$project$Components$Admin$CoveragePlans$Rules$viewRuleFormRow, tuple.a, tuple.b);
						},
						rulesInThisCategory));
			},
			categories);
	});
var $author$project$Ui$FontWeight$Normal = 1;
var $author$project$Ui$Typography$FontWeight = function (a) {
	return {$: 14, a: a};
};
var $author$project$Ui$Typography$fontWeight = $author$project$Ui$Typography$FontWeight;
var $author$project$Components$Admin$CoveragePlans$Rules$viewUncategorizedCoverageTooltip = A2(
	$author$project$Ui$Element$view,
	_List_fromArray(
		[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$gap]),
	_List_fromArray(
		[
			A3(
			$author$project$Ui$Tooltip$view,
			_List_Nil,
			'Uncategorized rules are charge items that are not associated with a charge category. You can assign a category to your charge items under Admin -> Charges & Taxes.',
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$span,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Icon$help(_List_Nil)
						]))
				])),
			A2(
			$author$project$Ui$Typography$text,
			_List_fromArray(
				[
					$author$project$Ui$Typography$fontWeight(1)
				]),
			'What are uncategorized coverage rules?')
		]));
var $author$project$Components$Admin$CoveragePlans$Rules$viewUncategorizedCoverageRuleForms = function (ruleForms) {
	return $elm$core$List$isEmpty(ruleForms) ? _List_Nil : A2(
		$elm$core$List$cons,
		A2(
			$author$project$Ui$ListGroup$item,
			_List_fromArray(
				[
					$author$project$Ui$ListGroup$style(4)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween]),
					_List_fromArray(
						[
							$elm$html$Html$text('UNCATEGORIZED'),
							$author$project$Components$Admin$CoveragePlans$Rules$viewUncategorizedCoverageTooltip
						]))
				])),
		A2(
			$elm$core$List$map,
			function (tuple) {
				return A2($author$project$Components$Admin$CoveragePlans$Rules$viewRuleFormRow, tuple.a, tuple.b);
			},
			ruleForms));
};
var $author$project$Components$Admin$CoveragePlans$Rules$view = function (model) {
	var activeCoverageRuleFormsWithIndex = A2(
		$elm$core$List$filter,
		function (tuple) {
			return !$author$project$Components$Admin$CoverageRules$Form$isReallyDeleted(tuple.a);
		},
		A2(
			$elm$core$List$indexedMap,
			F2(
				function (index, rule) {
					return _Utils_Tuple2(rule, index);
				}),
			model.afY));
	var categories = $author$project$Components$Admin$CoveragePlans$Rules$allCategories(activeCoverageRuleFormsWithIndex);
	var uncategorizedCoverageRuleFormsWithIndex = A2(
		$elm$core$List$filter,
		function (tuple) {
			return _Utils_eq(
				$author$project$Components$Admin$CoverageRules$Form$category(tuple.a),
				$elm$core$Maybe$Nothing);
		},
		activeCoverageRuleFormsWithIndex);
	return A2(
		$author$project$Ui$ListGroup$view,
		_List_Nil,
		_Utils_ap(
			A2($author$project$Components$Admin$CoveragePlans$Rules$viewCategorizedCoverageRuleForms, categories, activeCoverageRuleFormsWithIndex),
			_Utils_ap(
				$author$project$Components$Admin$CoveragePlans$Rules$viewUncategorizedCoverageRuleForms(uncategorizedCoverageRuleFormsWithIndex),
				model._6 ? _List_Nil : _List_fromArray(
					[$author$project$Components$Admin$CoveragePlans$Rules$viewAddCoverageRuleButton]))));
};
var $author$project$Components$Admin$CoveragePlans$Form$AddDocumentUpload = {$: 14};
var $author$project$Components$Admin$CoverageDocuments$UploadModal$FileName = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$CoverageDocuments$UploadModal$FileUploaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$CoverageDocuments$UploadModal$FormUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Form$File$Pdf = 2;
var $author$project$Components$Admin$CoverageDocuments$UploadModal$Save = {$: 3};
var $author$project$Ui$Form$Group$static = $author$project$Ui$Form$Static$view(_List_Nil);
var $author$project$Components$Admin$CoverageDocuments$UploadModal$view = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.SD);
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Admin$CoverageDocuments$UploadModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title(
						_Utils_eq(model.rL, $elm$core$Maybe$Nothing) ? 'Upload PDF Document' : 'Edit PDF Document')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$onSubmit($author$project$Components$Admin$CoverageDocuments$UploadModal$Save)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('File'),
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(4)
									]),
								_List_fromArray(
									[
										function () {
										var _v1 = model.rL;
										if (!_v1.$) {
											var coverageDocument_ = _v1.a;
											return $author$project$Ui$Form$Group$static(
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Element$view,
														_List_fromArray(
															[$author$project$Ui$Element$ml2]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																$author$project$Api$Provider$CoverageDocument$Shared$fileName(coverageDocument_))
															]))
													]));
										} else {
											return $author$project$Ui$Form$File$view(
												_List_fromArray(
													[
														$author$project$Ui$Form$File$accept(2),
														$author$project$Ui$Form$File$onInput($author$project$Components$Admin$CoverageDocuments$UploadModal$FileUploaded)
													]));
										}
									}()
									])),
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(4),
										$author$project$Ui$Form$Group$required(true),
										$author$project$Ui$Form$Group$label('Visible PDF File Name')
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$value(fields.Sn),
												$author$project$Ui$Form$Input$phi(true),
												$author$project$Ui$Form$Input$placeholder('File Name'),
												$author$project$Ui$Form$Input$autofocus(true),
												$author$project$Ui$Form$Input$onInput(
												A2($elm$core$Basics$composeL, $author$project$Components$Admin$CoverageDocuments$UploadModal$FormUpdated, $author$project$Components$Admin$CoverageDocuments$UploadModal$FileName)),
												$author$project$Ui$Form$Input$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, 1, model.SD))
											])),
										$author$project$Utils$FormErrors$view(
										A2($author$project$Utils$Form$validationErrors, 1, model.SD))
									]))
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Admin$CoverageDocuments$UploadModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Save upload'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Admin$CoverageDocuments$UploadModal$Save),
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$loading(
								_Utils_eq(model.k9, $author$project$Api$Data$Loading))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Save')
							]))
					]))
			]));
};
var $author$project$Components$Admin$CoverageDocuments$Form$modal = function (_v0) {
	var model = _v0;
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				function () {
				var _v1 = model.f7;
				if (!_v1.$) {
					var _v2 = _v1.a;
					var coverageDocument = _v2.a;
					var deleteRequest = _v2.b;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Components$Admin$CoverageDocuments$Form$DeleteHiConfirmClosed(coverageDocument),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$noun('document'),
								$author$project$Components$HiConfirm$verb('delete'),
								$author$project$Components$HiConfirm$customMessage(
								_List_fromArray(
									[
										$elm$html$Html$text(
										'Are you sure you want to delete ' + $author$project$Api$Provider$CoverageDocument$Shared$fileName(coverageDocument))
									])),
								$author$project$Components$HiConfirm$loading(
								_Utils_eq(deleteRequest, $author$project$Api$Data$Loading))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				model.jr ? A2(
				$elm$html$Html$map,
				$author$project$Components$Admin$CoverageDocuments$Form$DocumentUploadModalMsg,
				$author$project$Components$Admin$CoverageDocuments$UploadModal$view(model.da)) : $author$project$Utils$Html$empty
			]));
};
var $author$project$Components$Admin$CoverageDocuments$Form$Delete = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$CoverageDocuments$Form$Edit = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$CoverageDocuments$Form$viewListActions = function (coverageDocument) {
	return A2(
		$author$project$Ui$Grid$column,
		_List_fromArray(
			[
				$author$project$Ui$Grid$spanSm(2)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$gap2]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Edit coverage document'},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$sm,
								$author$project$Ui$Button$icon($author$project$Ui$Icon$edit),
								$author$project$Ui$Button$onClick(
								$author$project$Components$Admin$CoverageDocuments$Form$Edit(coverageDocument))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Edit')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Delete coverage document'},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$sm,
								$author$project$Ui$Button$icon($author$project$Ui$Icon$delete),
								$author$project$Ui$Button$onClick(
								$author$project$Components$Admin$CoverageDocuments$Form$Delete(coverageDocument))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Delete')
							]))
					]))
			]));
};
var $author$project$Api$Provider$CoverageDocument$Shared$url = function (_v0) {
	var record = _v0;
	return record.adY;
};
var $author$project$Components$Admin$CoverageDocuments$Form$viewListItems = function (coverageDocument) {
	return A2(
		$author$project$Ui$Grid$column,
		_List_fromArray(
			[
				$author$project$Ui$Grid$spanSm(10)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$externalHref,
						$author$project$Api$Provider$CoverageDocument$Shared$url(coverageDocument),
						_List_fromArray(
							[$author$project$Ui$Link$targetBlank]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Api$Provider$CoverageDocument$Shared$fileName(coverageDocument)),
								$elm$html$Html$text('  '),
								$author$project$Ui$Icon$launch(
								_List_fromArray(
									[$author$project$Ui$Icon$sm]))
							]))
					]))
			]));
};
var $author$project$Components$Admin$CoverageDocuments$Form$view = function (_v0) {
	var model = _v0;
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Components$Admin$CoverageDocuments$Form$modal(model),
				$elm$core$List$isEmpty(model.OS) ? $author$project$Utils$Html$empty : A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (coverageDocument) {
								return A2(
									$author$project$Ui$Grid$row,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Components$Admin$CoverageDocuments$Form$viewListItems(coverageDocument),
											$author$project$Components$Admin$CoverageDocuments$Form$viewListActions(coverageDocument)
										]));
							},
							model.OS))
					]))
			]));
};
var $author$project$Components$Admin$CoveragePlans$Form$viewCoverageDocuments = function (model) {
	var _v0 = model.ahP;
	if (!_v0.$) {
		var coverageDocumentList = function () {
			var _v1 = _Utils_Tuple2(model.OS, model.OT);
			if ((!_v1.a.$) && (!_v1.b.$)) {
				var coveragePlan = _v1.b.a;
				return $author$project$Api$Provider$CoveragePlan$One$coverageDocuments(coveragePlan);
			} else {
				return _List_Nil;
			}
		}();
		var addButton = A2(
			$author$project$Ui$ListGroup$item,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Upload pdf document'},
							_List_fromArray(
								[
									$author$project$Ui$Button$icon($author$project$Ui$Icon$add),
									$author$project$Ui$Button$onClick($author$project$Components$Admin$CoveragePlans$Form$AddDocumentUpload)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Upload Pdf Document')
								]))
						]))
				]));
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$HorizontalRule$view(_List_Nil),
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Benefit Overview Documents')
						])),
					A2(
					$elm$html$Html$map,
					$author$project$Components$Admin$CoveragePlans$Form$CoverageDocumentsMsg,
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$Utils$Html$empty,
						A2($elm$core$Maybe$map, $author$project$Components$Admin$CoverageDocuments$Form$modal, model.OS))),
					A2(
					$author$project$Ui$ListGroup$view,
					_List_Nil,
					$elm$core$List$isEmpty(coverageDocumentList) ? _List_fromArray(
						[addButton]) : _List_fromArray(
						[
							A2(
							$author$project$Ui$ListGroup$item,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Components$Admin$CoveragePlans$Form$CoverageDocumentsMsg,
									A2(
										$elm$core$Maybe$withDefault,
										$author$project$Utils$Html$empty,
										A2($elm$core$Maybe$map, $author$project$Components$Admin$CoverageDocuments$Form$view, model.OS)))
								])),
							addButton
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Admin$CoveragePlans$Form$PlanSearched = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Admin$CoveragePlans$Form$searchInput = function (planSearchQuery) {
	return A2(
		$author$project$Ui$ListGroup$item,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$onInput($author$project$Components$Admin$CoveragePlans$Form$PlanSearched),
						$author$project$Ui$Form$Input$placeholder('Search...'),
						$author$project$Ui$Form$Input$value(
						A2($elm$core$Maybe$withDefault, '', planSearchQuery))
					]))
			]));
};
var $author$project$Components$Admin$CoveragePlans$Form$SelectedAllPlans = function (a) {
	return {$: 6, a: a};
};
var $elm$html$Html$b = _VirtualDom_node('b');
var $author$project$Components$Admin$CoveragePlans$Form$selectAllOption = function (selectAllPlans) {
	return A2(
		$author$project$Ui$ListGroup$item,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Checkbox$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Checkbox$value(selectAllPlans),
						$author$project$Ui$Form$Checkbox$onCheck($author$project$Components$Admin$CoveragePlans$Form$SelectedAllPlans)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$b,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								selectAllPlans ? 'Unselect All' : 'Select All')
							]))
					]))
			]));
};
var $author$project$Components$Admin$CoveragePlans$Form$PaginationMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Ui$Pagination$More$CurrentPage = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Pagination$More$currentPage = $author$project$Ui$Pagination$More$CurrentPage;
var $author$project$Ui$Pagination$More$ItemsPerPage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Pagination$More$itemsPerPage = $author$project$Ui$Pagination$More$ItemsPerPage;
var $author$project$Ui$Pagination$More$OnClick = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Pagination$More$onClick = $author$project$Ui$Pagination$More$OnClick;
var $author$project$Ui$Pagination$More$TotalCount = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Pagination$More$totalCount = $author$project$Ui$Pagination$More$TotalCount;
var $author$project$Ui$Pagination$More$defaultOptions = {bX: 0, gG: 0, V8: false, IS: $elm$core$Maybe$Nothing, qC: 0};
var $author$project$Ui$Pagination$More$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var _int = option.a;
						return _Utils_update(
							record,
							{qC: _int});
					case 1:
						var _int = option.a;
						return _Utils_update(
							record,
							{gG: _int});
					case 2:
						var _int = option.a;
						return _Utils_update(
							record,
							{bX: _int});
					case 3:
						var toMsg = option.a;
						return _Utils_update(
							record,
							{
								IS: $elm$core$Maybe$Just(toMsg)
							});
					default:
						var bool = option.a;
						return _Utils_update(
							record,
							{V8: bool});
				}
			}),
		$author$project$Ui$Pagination$More$defaultOptions,
		options);
};
var $author$project$Ui$Pagination$More$viewPageSpan = F3(
	function (label, maybeMsg, pageNumber) {
		var attributes = function () {
			if (!maybeMsg.$) {
				var msg = maybeMsg.a;
				return _List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						msg(pageNumber))
					]);
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$elm$html$Html$span,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('clickable'),
				attributes),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Ui$Pagination$More$view = function (options) {
	var optionsRecord = $author$project$Ui$Pagination$More$optionsToRecord(options);
	if (optionsRecord.V8) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Spinner$view(
					_List_fromArray(
						[$author$project$Ui$Spinner$small]))
				]));
	} else {
		var totalRemaining = optionsRecord.qC - (optionsRecord.bX * optionsRecord.gG);
		if (totalRemaining < 0) {
			return $author$project$Utils$Html$empty;
		} else {
			var linkText = 'Show more (' + ($elm$core$String$fromInt(totalRemaining) + ' hidden)');
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A3($author$project$Ui$Pagination$More$viewPageSpan, linkText, optionsRecord.IS, optionsRecord.bX + 1)
					]));
		}
	}
};
var $author$project$Api$Pagination$viewAsShowMore = F2(
	function (options, _v0) {
		var model = _v0;
		return $author$project$Ui$Pagination$More$view(
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Pagination$More$totalCount(model.qC),
				A2(
					$elm$core$List$cons,
					$author$project$Ui$Pagination$More$itemsPerPage(model.gG),
					A2(
						$elm$core$List$cons,
						$author$project$Ui$Pagination$More$currentPage(model.bX),
						A2(
							$elm$core$List$cons,
							$author$project$Ui$Pagination$More$onClick($author$project$Api$Pagination$CurrentPageChanged),
							options)))));
	});
var $author$project$Components$Admin$CoveragePlans$Form$showMoreItem = F2(
	function (totalRemaining, pagination) {
		return (!(!totalRemaining)) ? _List_fromArray(
			[
				A2(
				$author$project$Ui$ListGroup$item,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Components$Admin$CoveragePlans$Form$PaginationMsg,
						A2($author$project$Api$Pagination$viewAsShowMore, _List_Nil, pagination))
					]))
			]) : _List_Nil;
	});
var $author$project$Components$Admin$CoveragePlans$Form$SelectedPlan = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Components$Admin$CoveragePlans$Form$planInCoveragePlan = F2(
	function (plans, plan) {
		return A2(
			$elm$core$List$member,
			plan.ahP,
			A2(
				$elm$core$List$map,
				function (planRecord) {
					return planRecord.ahP;
				},
				plans));
	});
var $author$project$Components$Admin$CoveragePlans$Form$viewPlan = F3(
	function (fields, selectAllPlans, plan) {
		return A2(
			$author$project$Ui$ListGroup$item,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Checkbox$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Checkbox$value(
							selectAllPlans || A2($author$project$Components$Admin$CoveragePlans$Form$planInCoveragePlan, fields.ZG, plan)),
							$author$project$Ui$Form$Checkbox$onCheck(
							$author$project$Components$Admin$CoveragePlans$Form$SelectedPlan(plan))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(plan.Bq)
						]))
				]));
	});
var $author$project$Components$Admin$CoveragePlans$Form$viewPlans = F2(
	function (model, form) {
		var _v0 = model.ZG;
		if (_v0.$ === 3) {
			var headers = _v0.b;
			var searchItem = $author$project$Components$Admin$CoveragePlans$Form$searchInput(model.tT);
			if ($elm$core$List$length(model.hh) > 0) {
				var totalCount = A2(
					$elm$core$Maybe$withDefault,
					0,
					A2(
						$elm$core$Maybe$andThen,
						$elm$core$String$toInt,
						A2($elm$core$Dict$get, 'x-total-count', headers)));
				var totalRemaining = totalCount - $elm$core$List$length(model.hh);
				var fields = $author$project$Utils$Form$fields(form);
				return A2(
					$author$project$Ui$ListGroup$view,
					_List_Nil,
					$elm$core$List$concat(
						_List_fromArray(
							[
								_List_fromArray(
								[
									searchItem,
									$author$project$Components$Admin$CoveragePlans$Form$selectAllOption(model.us)
								]),
								A2(
								$elm$core$List$map,
								A2($author$project$Components$Admin$CoveragePlans$Form$viewPlan, fields, model.us),
								model.hh),
								A2($author$project$Components$Admin$CoveragePlans$Form$showMoreItem, totalRemaining, model.ajJ)
							])));
			} else {
				return A2(
					$author$project$Ui$ListGroup$view,
					_List_Nil,
					_List_fromArray(
						[
							searchItem,
							A2(
							$author$project$Ui$ListGroup$item,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('No plans found')
								]))
						]));
			}
		} else {
			return A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$textCenter]),
				_List_fromArray(
					[
						$author$project$Ui$Spinner$view(_List_Nil)
					]));
		}
	});
var $author$project$Components$Admin$CoveragePlans$Form$viewForm = F2(
	function (model, form) {
		var fields = $author$project$Utils$Form$fields(form);
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpan(3),
						$author$project$Ui$Form$Group$inputSpan(9),
						$author$project$Ui$Form$Group$required(true),
						$author$project$Ui$Form$Group$label('Coverage Plan Name')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(fields.Bq),
								$author$project$Ui$Form$Input$autofocus(true),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Components$Admin$CoveragePlans$Form$FormUpdated, $author$project$Components$Admin$CoveragePlans$Form$Name)),
								$author$project$Ui$Form$Input$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
								$author$project$Ui$Form$Input$errors(
								A2($author$project$Utils$Form$validationErrors, 0, form))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpan(3),
						$author$project$Ui$Form$Group$inputSpan(9),
						$author$project$Ui$Form$Group$label('Connected Membership Plans')
					]),
				_List_fromArray(
					[
						A2($author$project$Components$Admin$CoveragePlans$Form$viewPlans, model, form)
					])),
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mb4]),
				_List_fromArray(
					[
						$author$project$Ui$Typography$headingSm(
						_List_fromArray(
							[
								$elm$html$Html$text('Covered Charge Categories & Items')
							]))
					])),
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					$elm$html$Html$map($author$project$Components$Admin$CoveragePlans$Form$CoverageRulesMsg),
					A2($elm$core$Maybe$map, $author$project$Components$Admin$CoveragePlans$Rules$view, model.afY))),
				$author$project$Components$Admin$CoveragePlans$Form$viewCoverageDocuments(model)
			]);
	});
var $author$project$Components$Admin$CoveragePlans$Form$view = function (_v0) {
	var model = _v0;
	var newRecord = function () {
		var _v2 = model.ahP;
		if (!_v2.$) {
			return false;
		} else {
			return true;
		}
	}();
	return A2(
		$author$project$Ui$Form$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$noValidate(true),
				$author$project$Ui$Form$autocomplete(false),
				$author$project$Ui$Form$onSubmit($author$project$Components$Admin$CoveragePlans$Form$AttemptedSubmit)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text(
										newRecord ? 'New Coverage Plan' : 'Edit Coverage Plan')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						function () {
							var _v1 = model.SD;
							if (!_v1.$) {
								var form = _v1.a;
								return A2($author$project$Components$Admin$CoveragePlans$Form$viewForm, model, form);
							} else {
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$textCenter]),
										_List_fromArray(
											[
												$author$project$Ui$Spinner$view(_List_Nil)
											]))
									]);
							}
						}()),
						A2(
						$author$project$Ui$Panel$footer,
						_List_fromArray(
							[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$justifyCenter]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Admin__CoveragePlans__Top,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Cancel')
									])),
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Publish coverage plan'},
								_List_fromArray(
									[$author$project$Ui$Button$primary, $author$project$Ui$Button$submit]),
								_List_fromArray(
									[
										$elm$html$Html$text('Publish')
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Admin$CoveragePlans$Id_String$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Admin$CoveragePlans$Form$view(model.SD))
			]),
		ac9: 'Admin | Coverage Plans'
	};
};
var $author$project$Pages$Admin$CoveragePlans$Id_String$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$CoveragePlans$Id_String$init, aiq: $author$project$Pages$Admin$CoveragePlans$Id_String$load, k8: $author$project$Pages$Admin$CoveragePlans$Id_String$save, alO: $author$project$Pages$Admin$CoveragePlans$Id_String$subscriptions, adT: $author$project$Pages$Admin$CoveragePlans$Id_String$update, amo: $author$project$Pages$Admin$CoveragePlans$Id_String$view});
var $author$project$Pages$Admin$CoveragePlans$New$CoveragePlanFormMsg = $elm$core$Basics$identity;
var $author$project$Pages$Admin$CoveragePlans$New$init = F4(
	function (session, practice, _v0, _v1) {
		var apiClient = _v0.Gv;
		var _v2 = A4($author$project$Components$Admin$CoveragePlans$Form$init, apiClient, session, practice, $elm$core$Maybe$Nothing);
		var form = _v2.a;
		var cmd = _v2.b;
		return _Utils_Tuple2(
			{Gv: apiClient, SD: form},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
	});
var $author$project$Pages$Admin$CoveragePlans$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$CoveragePlans$New$save = F2(
	function (_v0, shared) {
		var form = _v0.SD;
		return A2($author$project$Components$Admin$CoveragePlans$Form$save, form, shared);
	});
var $author$project$Pages$Admin$CoveragePlans$New$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Admin$CoveragePlans$Form$subscriptions(model.SD));
};
var $author$project$Pages$Admin$CoveragePlans$New$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Admin$CoveragePlans$Form$update, model.Gv, subMsg, model.SD);
		var form = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{SD: form}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Pages$Admin$CoveragePlans$New$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Admin$CoveragePlans$Form$view(model.SD))
			]),
		ac9: 'Admin | Coverage Plans'
	};
};
var $author$project$Pages$Admin$CoveragePlans$New$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$CoveragePlans$New$init, aiq: $author$project$Pages$Admin$CoveragePlans$New$load, k8: $author$project$Pages$Admin$CoveragePlans$New$save, alO: $author$project$Pages$Admin$CoveragePlans$New$subscriptions, adT: $author$project$Pages$Admin$CoveragePlans$New$update, amo: $author$project$Pages$Admin$CoveragePlans$New$view});
var $author$project$Pages$Admin$CoveragePlans$Top$GotList = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$CoveragePlans$Top$fetchList = function (model) {
	return A3(
		$author$project$Api$Provider$CoveragePlan$list,
		model.Gv,
		function (d) {
			return _Utils_update(
				d,
				{ajJ: model.ajJ, akl: model.akl, alA: model.alA});
		},
		$author$project$Pages$Admin$CoveragePlans$Top$GotList);
};
var $author$project$Pages$Admin$CoveragePlans$Top$init = F4(
	function (_v0, _v1, _v2, _v3) {
		var apiClient = _v2.Gv;
		var query = _v3.DE;
		var q = A2($elm$core$Dict$get, 'q', query);
		var model = {
			Gv: apiClient,
			je: $elm$core$Maybe$Nothing,
			eg: $elm$core$Set$empty,
			j4: $author$project$Api$Data$Loading,
			ajJ: $author$project$Api$Pagination$initFromQuery(query),
			akl: q,
			up: $author$project$Ui$SearchInput$init(q),
			alA: $author$project$Api$Sort$initFromQuery(query)
		};
		return _Utils_Tuple2(
			model,
			$author$project$Pages$Admin$CoveragePlans$Top$fetchList(model));
	});
var $author$project$Pages$Admin$CoveragePlans$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$CoveragePlans$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$CoveragePlans$Top$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Pages$Admin$CoveragePlans$Top$subscriptions = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Platform$Sub$none,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$CoveragePlans$Top$HiConfirmClosed),
				$author$project$Api$Provider$CoveragePlan$All$id),
			model.je));
};
var $author$project$Pages$Admin$CoveragePlans$Top$Deleted = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Pages$Admin$CoveragePlans$Top$SearchInputMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$CoveragePlan$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$CoveragePlan$coveragePlanPath(id_)));
	});
var $author$project$Pages$Admin$CoveragePlans$Top$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('q'),
			model.akl)
		]);
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Admin__CoveragePlans__Top)
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.ajJ),
				A2(
					$elm$core$List$append,
					$author$project$Api$Sort$toQuery(model.alA),
					A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
};
var $author$project$Pages$Admin$CoveragePlans$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								j4: response,
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{j4: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var id = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									eg: A2($elm$core$Set$remove, id, model.eg),
									j4: $author$project$Api$Data$Loading
								}),
							$author$project$Pages$Admin$CoveragePlans$Top$fetchList(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Coverage plan successfully deleted')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									eg: A2($elm$core$Set$remove, id, model.eg)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Admin$CoveragePlans$Top$fetchList(newModel),
								$author$project$Pages$Admin$CoveragePlans$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 3:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						alA: A2($author$project$Api$Sort$update, columnId, model.alA)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Admin$CoveragePlans$Top$fetchList(newModel),
								$author$project$Pages$Admin$CoveragePlans$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 4:
				var deletingItem = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							je: $elm$core$Maybe$Just(deletingItem)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var id = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							je: $elm$core$Maybe$Nothing,
							eg: A2($elm$core$Set$insert, id, model.eg)
						}),
					A3(
						$author$project$Api$Provider$CoveragePlan$delete,
						model.Gv,
						id,
						$author$project$Pages$Admin$CoveragePlans$Top$Deleted(id)),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{je: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v3 = A2($author$project$Ui$SearchInput$update, subMsg, model.up);
				var searchInput = _v3.a;
				var searchInputCmd = _v3.b;
				var searchInputEvent = _v3.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.akl;
					}
				}();
				var _v4 = function () {
					if (_Utils_eq(q, model.akl)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								j4: $author$project$Api$Data$Loading,
								ajJ: $author$project$Api$Pagination$reset(model.ajJ),
								akl: q
							});
						return _Utils_Tuple2(
							qModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Admin$CoveragePlans$Top$fetchList(qModel),
										$author$project$Pages$Admin$CoveragePlans$Top$updateUrl(qModel)
									])));
					}
				}();
				var newModel = _v4.a;
				var cmd = _v4.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{up: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$CoveragePlans$Top$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
		}
	});
var $author$project$Pages$Admin$CoveragePlans$Top$PaginationMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$CoveragePlans$Top$SortTable = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Admin$CoveragePlans$Top$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'name', false, 'Name'),
		A3($author$project$Api$Column$init, 'charges', false, 'Included charges')
	]);
var $author$project$Pages$Admin$CoveragePlans$Top$Delete = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$CoveragePlans$Top$viewCoverageRule = function (coverageRule) {
	return A2(
		$author$project$Ui$Form$Static$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Components$CoverageRuleDescription$view,
				$author$project$Components$CoverageRuleDescription$One(coverageRule),
				false)
			]));
};
var $author$project$Pages$Admin$CoveragePlans$Top$viewItem = F2(
	function (deletingItems, coveragePlan) {
		var id = $author$project$Api$Provider$CoveragePlan$All$id(coveragePlan);
		var loading = A2($elm$core$Set$member, id, deletingItems);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$CoveragePlan$All$name(coveragePlan))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$author$project$Pages$Admin$CoveragePlans$Top$viewCoverageRule,
						$author$project$Api$Provider$CoveragePlan$All$coverageRules(coveragePlan))),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(2)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$gap2, $author$project$Ui$Element$justifyRight]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Admin__CoveragePlans__Id_String(
										{ahP: id}),
									_List_fromArray(
										[
											$author$project$Ui$Link$sm,
											$author$project$Ui$Link$icon($author$project$Ui$Icon$edit)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit')
										])),
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Delete coverage plan'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$loading(loading),
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Admin$CoveragePlans$Top$Delete(coveragePlan)),
											$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Delete')
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$CoveragePlans$Top$viewPanelTable = function (model) {
	var _v0 = function () {
		var _v1 = model.j4;
		if (_v1.$ === 3) {
			var items_ = _v1.a;
			return _Utils_Tuple2(false, items_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var items = _v0.b;
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$verticalCentered,
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('No coverage plans found.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$map,
					$author$project$Api$Column$view(
						A2($author$project$Api$Column$Sortable, model.alA, $author$project$Pages$Admin$CoveragePlans$Top$SortTable)),
					$author$project$Pages$Admin$CoveragePlans$Top$columns),
					_List_fromArray(
					[
						A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
					])
				])),
		A2(
			$elm$core$List$map,
			$author$project$Pages$Admin$CoveragePlans$Top$viewItem(model.eg),
			items),
		_List_Nil);
};
var $author$project$Pages$Admin$CoveragePlans$Top$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				function () {
				var _v0 = model.je;
				if (!_v0.$) {
					var item = _v0.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Admin$CoveragePlans$Top$HiConfirmClosed(
							$author$project$Api$Provider$CoveragePlan$All$id(item)),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('delete'),
								$author$project$Components$HiConfirm$noun('coverage plan'),
								$author$project$Components$HiConfirm$detail(
								$author$project$Api$Provider$CoveragePlan$All$name(item) + ' and remove it from all existing plans')
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Coverage Plans')
											])),
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Admin__CoveragePlans__New,
										_List_fromArray(
											[
												$author$project$Ui$Link$buttonDefault,
												$author$project$Ui$Link$icon($author$project$Ui$Icon$add)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('New Coverage Plan')
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(12)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Group$view,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$map,
														$author$project$Pages$Admin$CoveragePlans$Top$SearchInputMsg,
														A2($author$project$Ui$SearchInput$view, _List_Nil, model.up))
													]))
											]))
									]))
							])),
						$author$project$Pages$Admin$CoveragePlans$Top$viewPanelTable(model),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Admin$CoveragePlans$Top$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(
											!$author$project$Api$Data$isSuccess(model.j4))
										]),
									model.ajJ))
							]))
					]))
			]),
		ac9: 'Admin | Coverage Plans'
	};
};
var $author$project$Pages$Admin$CoveragePlans$Top$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$CoveragePlans$Top$init, aiq: $author$project$Pages$Admin$CoveragePlans$Top$load, k8: $author$project$Pages$Admin$CoveragePlans$Top$save, alO: $author$project$Pages$Admin$CoveragePlans$Top$subscriptions, adT: $author$project$Pages$Admin$CoveragePlans$Top$update, amo: $author$project$Pages$Admin$CoveragePlans$Top$view});
var $author$project$Pages$Admin$CreditCategories$GotCreditCategories = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$CreditCategory$creditCategoriesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['credit_categories']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$CreditCategory$All$CreditCategory = $elm$core$Basics$identity;
var $author$project$Api$Provider$CreditCategory$Shared$CreditCategory = $elm$core$Basics$identity;
var $author$project$Api$Provider$CreditCategory$Shared$Record = F7(
	function (id, name, canSetAmount, amountInCents, canSetExpiration, expiresInDays, isDestroyable) {
		return {LE: amountInCents, Ni: canSetAmount, Nj: canSetExpiration, R$: expiresInDays, ahP: id, UN: isDestroyable, Bq: name};
	});
var $author$project$Api$Provider$CreditCategory$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'is_destroyable',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'expires_in_days',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'can_set_expiration',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'amount_in_cents',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'can_set_amount',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'name',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Api$Provider$CreditCategory$Shared$Record))))))));
var $author$project$Api$Provider$CreditCategory$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CreditCategory$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CreditCategory$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CreditCategory$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CreditCategory$listDefaults = {
	ahP: $elm$core$Maybe$Nothing,
	ajJ: $author$project$Api$Pagination$init,
	akl: $elm$core$Maybe$Nothing,
	alA: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init)
};
var $author$project$Api$Provider$CreditCategory$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$CreditCategory$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.akl;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.ahP;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$Provider$CreditCategory$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$CreditCategory$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$CreditCategory$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$CreditCategory$creditCategoriesPath)));
	});
var $author$project$Pages$Admin$CreditCategories$fetchCreditCategories = function (model) {
	return A3(
		$author$project$Api$Provider$CreditCategory$list,
		model.Gv,
		function (d) {
			return _Utils_update(
				d,
				{ajJ: model.ajJ, akl: model.akl, alA: model.alA});
		},
		$author$project$Pages$Admin$CreditCategories$GotCreditCategories);
};
var $author$project$Pages$Admin$CreditCategories$init = F4(
	function (_v0, _v1, _v2, _v3) {
		var apiClient = _v2.Gv;
		var query = _v3.DE;
		var model = {
			Gv: apiClient,
			db: $author$project$Api$Data$Loading,
			O5: $elm$core$Maybe$Nothing,
			ec: $elm$core$Set$empty,
			jc: $elm$core$Maybe$Nothing,
			ajJ: $author$project$Api$Pagination$initFromQuery(query),
			akl: A2($elm$core$Dict$get, 'q', query),
			up: $author$project$Ui$SearchInput$init(
				A2($elm$core$Dict$get, 'q', query)),
			alA: A3(
				$author$project$Api$Sort$withDefault,
				'name',
				0,
				$author$project$Api$Sort$initFromQuery(query))
		};
		return _Utils_Tuple2(
			model,
			$author$project$Pages$Admin$CreditCategories$fetchCreditCategories(model));
	});
var $author$project$Pages$Admin$CreditCategories$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$CreditCategories$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$CreditCategories$CancelCreditCategoryEdit = {$: 3};
var $author$project$Pages$Admin$CreditCategories$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Pages$Admin$CreditCategories$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Admin$CreditCategories$CancelCreditCategoryEdit)),
					model.O5)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$CreditCategories$HiConfirmClosed),
					model.jc))
			]));
};
var $author$project$Pages$Admin$CreditCategories$CreditCategoryDeleted = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Pages$Admin$CreditCategories$SearchInputMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Api$Provider$CreditCategory$creditCategoryPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$CreditCategory$creditCategoriesPath);
};
var $author$project$Api$Provider$CreditCategory$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$CreditCategory$creditCategoryPath(id_)));
	});
var $author$project$Api$Provider$CreditCategory$Shared$amountInCents = function (_v0) {
	var record = _v0;
	return record.LE;
};
var $author$project$Api$Provider$CreditCategory$All$amountInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CreditCategory$Shared$amountInCents(shared);
};
var $author$project$Api$Provider$CreditCategory$Shared$canSetAmount = function (_v0) {
	var record = _v0;
	return record.Ni;
};
var $author$project$Api$Provider$CreditCategory$All$canSetAmount = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CreditCategory$Shared$canSetAmount(shared);
};
var $author$project$Api$Provider$CreditCategory$Shared$canSetExpiration = function (_v0) {
	var record = _v0;
	return record.Nj;
};
var $author$project$Api$Provider$CreditCategory$All$canSetExpiration = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CreditCategory$Shared$canSetExpiration(shared);
};
var $author$project$Api$Provider$CreditCategory$Shared$expiresInDays = function (_v0) {
	var record = _v0;
	return record.R$;
};
var $author$project$Api$Provider$CreditCategory$All$expiresInDays = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CreditCategory$Shared$expiresInDays(shared);
};
var $author$project$Api$Provider$CreditCategory$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$CreditCategory$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CreditCategory$Shared$name(shared);
};
var $author$project$Pages$Admin$CreditCategories$formFieldsFromCreditCategory = function (creditCategory) {
	return {
		LE: A2(
			$elm$core$Maybe$map,
			$author$project$Currency$fromInt,
			$author$project$Api$Provider$CreditCategory$All$amountInCents(creditCategory)),
		Ni: $author$project$Api$Provider$CreditCategory$All$canSetAmount(creditCategory),
		Nj: $author$project$Api$Provider$CreditCategory$All$canSetExpiration(creditCategory),
		R$: $author$project$Api$Provider$CreditCategory$All$expiresInDays(creditCategory),
		Bq: $author$project$Api$Provider$CreditCategory$All$name(creditCategory)
	};
};
var $author$project$Pages$Admin$CreditCategories$formFieldsInit = {LE: $elm$core$Maybe$Nothing, Ni: true, Nj: true, R$: $elm$core$Maybe$Nothing, Bq: ''};
var $author$project$Pages$Admin$CreditCategories$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{Bq: string});
			case 1:
				var _int = field.a;
				return _Utils_update(
					fields,
					{LE: _int});
			default:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						R$: $elm$core$String$toInt(string)
					});
		}
	});
var $author$project$Pages$Admin$CreditCategories$NameValidation = 0;
var $author$project$Pages$Admin$CreditCategories$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.Bq;
			},
			_Utils_Tuple2(0, 'Please enter a name.'))
		]));
var $author$project$Api$Provider$CreditCategory$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$CreditCategory$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CreditCategory$Shared$id(shared);
};
var $author$project$Api$Provider$CreditCategory$One$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CreditCategory$Shared$name(shared);
};
var $author$project$Pages$Admin$CreditCategories$CreditCategoryCreated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$CreditCategory$One$CreditCategory = $elm$core$Basics$identity;
var $author$project$Api$Provider$CreditCategory$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CreditCategory$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CreditCategory$create = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'credit_category',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(fields.Bq)),
							_Utils_ap(
								function () {
									var _v0 = fields.LE;
									if (!_v0.$) {
										var amountInCents_ = _v0.a;
										return _List_fromArray(
											[
												_Utils_Tuple2(
												'amount_in_cents',
												$author$project$Currency$encode(amountInCents_))
											]);
									} else {
										return _List_Nil;
									}
								}(),
								function () {
									var _v1 = fields.R$;
									if (!_v1.$) {
										var expiresInDays_ = _v1.a;
										return _List_fromArray(
											[
												_Utils_Tuple2(
												'expires_in_days',
												$elm$json$Json$Encode$int(expiresInDays_))
											]);
									} else {
										return _List_Nil;
									}
								}()))))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CreditCategory$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$CreditCategory$creditCategoriesPath)));
	});
var $author$project$Pages$Admin$CreditCategories$createCreditCategory = F2(
	function (apiClient, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var apiFields = {LE: fields.LE, R$: fields.R$, Bq: fields.Bq};
		return A3($author$project$Api$Provider$CreditCategory$create, apiClient, apiFields, $author$project$Pages$Admin$CreditCategories$CreditCategoryCreated);
	});
var $author$project$Pages$Admin$CreditCategories$CreditCategoryUpdated = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$CreditCategory$update = F4(
	function (apiClient, id_, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'credit_category',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(fields.Bq)),
								_Utils_Tuple2(
								'amount_in_cents',
								A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.LE)),
								_Utils_Tuple2(
								'expires_in_days',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.R$))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$CreditCategory$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$CreditCategory$creditCategoryPath(id_))));
	});
var $author$project$Pages$Admin$CreditCategories$updateCreditCategory = F3(
	function (apiClient, id, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var apiFields = {LE: fields.LE, R$: fields.R$, Bq: fields.Bq};
		return A4($author$project$Api$Provider$CreditCategory$update, apiClient, id, apiFields, $author$project$Pages$Admin$CreditCategories$CreditCategoryUpdated);
	});
var $author$project$Pages$Admin$CreditCategories$saveCreditCategory = F3(
	function (apiClient, maybeId, formFields) {
		if (!maybeId.$) {
			var id_ = maybeId.a;
			return A3($author$project$Pages$Admin$CreditCategories$updateCreditCategory, apiClient, id_, formFields);
		} else {
			return A2($author$project$Pages$Admin$CreditCategories$createCreditCategory, apiClient, formFields);
		}
	});
var $author$project$Pages$Admin$CreditCategories$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('q'),
			model.akl)
		]);
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Admin__CreditCategories)
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.ajJ),
				A2(
					$elm$core$List$append,
					$author$project$Api$Sort$toQuery(model.alA),
					A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
};
var $author$project$Pages$Admin$CreditCategories$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								db: response,
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{db: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$reportDecodeError(response));
				}
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							O5: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init($author$project$Pages$Admin$CreditCategories$formFieldsInit),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var creditCategory = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							O5: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(
										$author$project$Api$Provider$CreditCategory$All$id(creditCategory)),
									$author$project$Utils$Form$init(
										$author$project$Pages$Admin$CreditCategories$formFieldsFromCreditCategory(creditCategory)),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{O5: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var field = msg.a;
				var _v2 = model.O5;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var id = _v3.a;
					var form = _v3.b;
					var creditCategory = _v3.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$CreditCategories$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								O5: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, creditCategory))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var form = msg.a;
				var id = msg.b;
				var _v4 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$CreditCategories$formFieldsValidator, form);
				if (!_v4.$) {
					var _v5 = _v4.a;
					var newForm = _v5.a;
					var validFormFields = _v5.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								O5: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, $author$project$Api$Data$Loading))
							}),
						A3($author$project$Pages$Admin$CreditCategories$saveCreditCategory, model.Gv, id, validFormFields),
						_List_Nil);
				} else {
					var newForm = _v4.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								O5: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 5:
				var creditCategory = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							jc: $elm$core$Maybe$Just(creditCategory)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 7:
				var response = msg.a;
				var _v6 = model.O5;
				if (!_v6.$) {
					var _v7 = _v6.a;
					var id = _v7.a;
					var form = _v7.b;
					if (response.$ === 3) {
						var creditCategory = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{db: $author$project$Api$Data$Loading, O5: $elm$core$Maybe$Nothing}),
							$author$project$Pages$Admin$CreditCategories$fetchCreditCategories(model),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									'Successfully created ' + $author$project$Api$Provider$CreditCategory$One$name(creditCategory))
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									O5: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 8:
				var response = msg.a;
				var _v9 = model.O5;
				if (!_v9.$) {
					var _v10 = _v9.a;
					var id = _v10.a;
					var form = _v10.b;
					if (response.$ === 3) {
						var creditCategory = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{db: $author$project$Api$Data$Loading, O5: $elm$core$Maybe$Nothing}),
							$author$project$Pages$Admin$CreditCategories$fetchCreditCategories(model),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Provider$CreditCategory$One$name(creditCategory) + ' was successfully updated.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									O5: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var creditCategory = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									db: $author$project$Api$Data$Loading,
									ec: A2(
										$elm$core$Set$remove,
										$author$project$Api$Provider$CreditCategory$All$id(creditCategory),
										model.ec)
								}),
							$author$project$Pages$Admin$CreditCategories$fetchCreditCategories(model),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Provider$CreditCategory$All$name(creditCategory) + ' was successfully removed.')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ec: A2(
										$elm$core$Set$remove,
										$author$project$Api$Provider$CreditCategory$All$id(creditCategory),
										model.ec)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 10:
				var creditCategory = msg.a;
				var confirmed = msg.b;
				if (confirmed) {
					var id = $author$project$Api$Provider$CreditCategory$All$id(creditCategory);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ec: A2($elm$core$Set$insert, id, model.ec),
								jc: $elm$core$Maybe$Nothing
							}),
						A3(
							$author$project$Api$Provider$CreditCategory$delete,
							model.Gv,
							id,
							$author$project$Pages$Admin$CreditCategories$CreditCategoryDeleted(creditCategory)),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jc: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 11:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{db: $author$project$Api$Data$Loading, ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Admin$CreditCategories$fetchCreditCategories(newModel),
								$author$project$Pages$Admin$CreditCategories$updateUrl(newModel)
							])),
					_List_Nil);
			case 13:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						alA: A2($author$project$Api$Sort$update, columnId, model.alA)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Admin$CreditCategories$fetchCreditCategories(newModel),
								$author$project$Pages$Admin$CreditCategories$updateUrl(newModel)
							])),
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v13 = A2($author$project$Ui$SearchInput$update, subMsg, model.up);
				var searchInput = _v13.a;
				var searchInputCmd = _v13.b;
				var searchInputEvent = _v13.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.akl;
					}
				}();
				var _v14 = function () {
					if (_Utils_eq(q, model.akl)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								db: $author$project$Api$Data$Loading,
								ajJ: $author$project$Api$Pagination$reset(model.ajJ),
								akl: q
							});
						return _Utils_Tuple2(
							qModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Admin$CreditCategories$fetchCreditCategories(qModel),
										$author$project$Pages$Admin$CreditCategories$updateUrl(qModel)
									])));
					}
				}();
				var newModel = _v14.a;
				var cmd = _v14.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{up: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$CreditCategories$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
		}
	});
var $author$project$Pages$Admin$CreditCategories$NewCreditCategory = {$: 1};
var $author$project$Pages$Admin$CreditCategories$PaginationMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Admin$CreditCategories$AmountInCents = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$CreditCategories$ExpiresInDays = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$CreditCategories$FormUpdated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$CreditCategories$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$CreditCategories$SaveCreditCategory = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Pages$Admin$CreditCategories$viewCreditCategoryModal = F3(
	function (id, form, creditCategory) {
		var modalConfig = {
			Tq: $elm$core$Maybe$Nothing,
			aih: 'Credit Category',
			V8: _Utils_eq(creditCategory, $author$project$Api$Data$Loading),
			WG: id,
			WH: $elm$core$Maybe$Nothing,
			Yd: $author$project$Pages$Admin$CreditCategories$CancelCreditCategoryEdit,
			Yf: $author$project$Pages$Admin$CreditCategories$SaveCreditCategory(form)
		};
		var _v0 = $author$project$Utils$Form$fields(form);
		var name = _v0.Bq;
		var amountInCents = _v0.LE;
		var expiresInDays = _v0.R$;
		var canSetAmount = _v0.Ni;
		var canSetExpiration = _v0.Nj;
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Name'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(name),
									$author$project$Ui$Form$Input$placeholder('Refer a Friend'),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$CreditCategories$FormUpdated, $author$project$Pages$Admin$CreditCategories$Name)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form))
								])),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Amount')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$CurrencyInput$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$CurrencyInput$value(amountInCents),
									$author$project$Ui$Form$CurrencyInput$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$CreditCategories$FormUpdated, $author$project$Pages$Admin$CreditCategories$AmountInCents)),
									$author$project$Ui$Form$CurrencyInput$placeholder('25.00'),
									$author$project$Ui$Form$CurrencyInput$disabled(!canSetAmount)
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Expiration')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$group(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(
											A2(
												$elm$core$Maybe$withDefault,
												'',
												A2($elm$core$Maybe$map, $elm$core$String$fromInt, expiresInDays))),
											$author$project$Ui$Form$Input$placeholder('60'),
											$author$project$Ui$Form$Input$onInput(
											A2($elm$core$Basics$composeL, $author$project$Pages$Admin$CreditCategories$FormUpdated, $author$project$Pages$Admin$CreditCategories$ExpiresInDays)),
											$author$project$Ui$Form$Input$disabled(!canSetExpiration)
										])),
									$author$project$Ui$Form$Input$addon(
									_List_fromArray(
										[
											$elm$html$Html$text('days')
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$CreditCategories$SortTable = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Admin$CreditCategories$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'name', true, 'Name'),
		A3($author$project$Api$Column$init, 'amount', false, 'Amount'),
		A3($author$project$Api$Column$init, 'expiration', false, 'Expiration')
	]);
var $author$project$Pages$Admin$CreditCategories$help = _List_fromArray(
	[
		$elm$html$Html$text('Credit categories let you easily create and track similar credits by prefilling repeated fields. '),
		$elm$html$Html$text('You cannot add credits to an account without first adding credit categories. '),
		$elm$html$Html$text('Amount and expiration are optional fields. '),
		$elm$html$Html$text('For more information see our '),
		A3(
		$author$project$Ui$Link$externalHref,
		'https://support.hint.com/account-configuration/adding-and-applying-credits',
		_List_fromArray(
			[$author$project$Ui$Link$targetBlank]),
		_List_fromArray(
			[
				$elm$html$Html$text('help docs')
			])),
		$elm$html$Html$text('.')
	]);
var $author$project$Pages$Admin$CreditCategories$DeleteCreditCategory = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$CreditCategories$EditCreditCategory = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$CreditCategory$Shared$isDestroyable = function (_v0) {
	var record = _v0;
	return record.UN;
};
var $author$project$Api$Provider$CreditCategory$All$isDestroyable = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CreditCategory$Shared$isDestroyable(shared);
};
var $author$project$Pages$Admin$CreditCategories$viewCreditCategory = F2(
	function (deletingCreditCategories, creditCategory) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$CreditCategory$All$name(creditCategory))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = $author$project$Api$Provider$CreditCategory$All$amountInCents(creditCategory);
							if (!_v0.$) {
								var amountInCents = _v0.a;
								return $elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(amountInCents));
							} else {
								return $elm$html$Html$text('No prefilled amount');
							}
						}()
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v1 = $author$project$Api$Provider$CreditCategory$All$expiresInDays(creditCategory);
							if (!_v1.$) {
								var expiresInDays = _v1.a;
								return $elm$html$Html$text(
									A2($author$project$Formatters$String$pluralize, 'day', expiresInDays));
							} else {
								return $elm$html$Html$text('Does not expire');
							}
						}()
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Edit credit category'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Admin$CreditCategories$EditCreditCategory(creditCategory)),
											$author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit')
										])),
									function () {
									if ($author$project$Api$Provider$CreditCategory$All$isDestroyable(creditCategory)) {
										var id = $author$project$Api$Provider$CreditCategory$All$id(creditCategory);
										var loading = A2($elm$core$Set$member, id, deletingCreditCategories);
										return A3(
											$author$project$Ui$Button$view,
											{mm: 'Delete credit category'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$sm,
													$author$project$Ui$Button$loading(loading),
													$author$project$Ui$Button$onClick(
													$author$project$Pages$Admin$CreditCategories$DeleteCreditCategory(creditCategory)),
													$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Delete')
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$CreditCategories$viewPanelBody = function (model) {
	var _v0 = function () {
		var _v1 = model.db;
		if (_v1.$ === 3) {
			var creditCategories_ = _v1.a;
			return _Utils_Tuple2(false, creditCategories_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var creditCategories = _v0.b;
	return _List_fromArray(
		[
			A2($author$project$Ui$Typography$p, _List_Nil, $author$project$Pages$Admin$CreditCategories$help),
			A2(
			$author$project$Ui$Grid$row,
			_List_fromArray(
				[$author$project$Ui$Grid$mb2]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Pages$Admin$CreditCategories$SearchInputMsg,
							A2($author$project$Ui$SearchInput$view, _List_Nil, model.up))
						]))
				])),
			A4(
			$author$project$Ui$Table$view,
			_List_fromArray(
				[
					$author$project$Ui$Table$verticalCentered,
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('None, add a category to be able to create credits.')
						])),
					$author$project$Ui$Table$loading(loading)
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						A2(
						$elm$core$List$map,
						$author$project$Api$Column$view(
							A2($author$project$Api$Column$Sortable, model.alA, $author$project$Pages$Admin$CreditCategories$SortTable)),
						$author$project$Pages$Admin$CreditCategories$columns),
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$header,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textRight]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Tooltip$view,
											_List_Nil,
											'Upload from CSV',
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Admin__Credits__Upload,
													_List_fromArray(
														[
															$author$project$Ui$Link$icon($author$project$Ui$Icon$upload),
															$author$project$Ui$Link$ariaLabel('Upload')
														]),
													_List_Nil)
												]))
										]))
								]))
						])
					])),
			A2(
				$elm$core$List$map,
				$author$project$Pages$Admin$CreditCategories$viewCreditCategory(model.ec),
				creditCategories),
			_List_Nil)
		]);
};
var $author$project$Pages$Admin$CreditCategories$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				function () {
				var _v0 = model.O5;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var id = _v1.a;
					var form = _v1.b;
					var creditCategory = _v1.c;
					return A3($author$project$Pages$Admin$CreditCategories$viewCreditCategoryModal, id, form, creditCategory);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v2 = model.jc;
				if (!_v2.$) {
					var creditCategory = _v2.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Admin$CreditCategories$HiConfirmClosed(creditCategory),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('delete'),
								$author$project$Components$HiConfirm$noun('credit category'),
								$author$project$Components$HiConfirm$detail(
								$author$project$Api$Provider$CreditCategory$All$name(creditCategory) + '. This will not affect outstanding credits')
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_fromArray(
							[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Credit Categories')
									])),
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Create new credit category'},
								_List_fromArray(
									[
										$author$project$Ui$Button$default,
										$author$project$Ui$Button$onClick($author$project$Pages$Admin$CreditCategories$NewCreditCategory),
										$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('New Credit Category')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						$author$project$Pages$Admin$CreditCategories$viewPanelBody(model)),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Admin$CreditCategories$PaginationMsg,
								A2($author$project$Api$Pagination$view, _List_Nil, model.ajJ))
							]))
					]))
			]),
		ac9: 'Admin | Credit Categories'
	};
};
var $author$project$Pages$Admin$CreditCategories$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$CreditCategories$init, aiq: $author$project$Pages$Admin$CreditCategories$load, k8: $author$project$Pages$Admin$CreditCategories$save, alO: $author$project$Pages$Admin$CreditCategories$subscriptions, adT: $author$project$Pages$Admin$CreditCategories$update, amo: $author$project$Pages$Admin$CreditCategories$view});
var $author$project$Api$Upload$Resource$Credit = 0;
var $author$project$Pages$Admin$Credits$Upload$UploadFormMsg = $elm$core$Basics$identity;
var $author$project$Pages$Admin$Credits$Upload$init = F4(
	function (_v0, _v1, shared, _v2) {
		var _v3 = A4($author$project$Components$Upload$Form$init, shared.J7, shared.Gv, 0, $elm$core$Maybe$Nothing);
		var uploadForm = _v3.a;
		var uploadFormCmd = _v3.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, SD: uploadForm},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, uploadFormCmd));
	});
var $author$project$Pages$Admin$Credits$Upload$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Credits$Upload$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Credits$Upload$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Upload$Form$subscriptions(model.SD));
};
var $author$project$Pages$Admin$Credits$Upload$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Upload$Form$update, model.Gv, subMsg, model.SD);
		var uploadForm = _v1.a;
		var subCmd = _v1.b;
		var subOutMsgs = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{SD: uploadForm}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsgs);
	});
var $author$project$Pages$Admin$Credits$Upload$viewBody = function (model) {
	return A2(
		$author$project$Ui$Grid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$span(12)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Import Patient Credits Information')
											]))
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$elm$core$Basics$identity,
										A2($author$project$Components$Upload$Form$view, model.Gv, model.SD))
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Admin$Credits$Upload$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				A2($author$project$Components$Upload$Form$modal, model.Gv, model.SD)),
				$author$project$Pages$Admin$Credits$Upload$viewBody(model)
			]),
		ac9: 'Admin | Credits'
	};
};
var $author$project$Pages$Admin$Credits$Upload$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Credits$Upload$init, aiq: $author$project$Pages$Admin$Credits$Upload$load, k8: $author$project$Pages$Admin$Credits$Upload$save, alO: $author$project$Pages$Admin$Credits$Upload$subscriptions, adT: $author$project$Pages$Admin$Credits$Upload$update, amo: $author$project$Pages$Admin$Credits$Upload$view});
var $author$project$Pages$Admin$DataExport$Id_String$GotDataExports = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$DataExportGroup$dataExportGroupsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['data_export_groups']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$DataExportGroup$dataExportGroupPath = function (dataExportGroupId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[dataExportGroupId]),
		$author$project$Api$Provider$DataExportGroup$dataExportGroupsPath);
};
var $author$project$Api$Provider$DataExportGroup$DataExport$dataExportsPath = function (dataExportGroupId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['data_exports']),
		$author$project$Api$Provider$DataExportGroup$dataExportGroupPath(dataExportGroupId));
};
var $author$project$Api$Provider$DataExport$All$DataExport = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$DataExport$Shared$DataExport = $elm$core$Basics$identity;
var $author$project$Api$Provider$DataExport$Shared$Record = F8(
	function (id, exportFileName, encrypted, status, exportedAt, errorMessage, exportGenerated, dataExportConfiguration) {
		return {Px: dataExportConfiguration, Rr: encrypted, RM: errorMessage, R2: exportFileName, R3: exportGenerated, R4: exportedAt, ahP: id, alH: status};
	});
var $author$project$Api$Provider$DataExportConfiguration$Shared$DataExportConfiguration = $elm$core$Basics$identity;
var $author$project$Api$Provider$DataExportConfiguration$Shared$Record = function (id) {
	return function (enabled) {
		return function (contactEmail) {
			return function (contactPhone) {
				return function (destination) {
					return function (sftpHost) {
						return function (sftpPort) {
							return function (sftpUsername) {
								return function (s3Bucket) {
									return function (s3Region) {
										return function (encryptionKey) {
											return function (encryptionRecipient) {
												return function (testExportFileName) {
													return function (incrementalMode) {
														return function (excludeDefaultTables) {
															return function (manualExportPerformed) {
																return function (fileNameFormat) {
																	return {Ow: contactEmail, Oy: contactPhone, Qt: destination, Ro: enabled, Rs: encryptionKey, Rt: encryptionRecipient, RR: excludeDefaultTables, So: fileNameFormat, ahP: id, TW: incrementalMode, Ws: manualExportPerformed, aal: s3Bucket, aam: s3Region, aa9: sftpHost, aba: sftpPort, abb: sftpUsername, ac2: testExportFileName};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$DataExportConfiguration$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'file_name_format',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'manual_export_performed',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'exclude_default_tables',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'incremental_mode',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'test_export_file_name',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'encryption_recipient',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'encryption_key',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								's3_region',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									's3_bucket',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'sftp_username',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'sftp_port',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'sftp_host',
												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'destination',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'contact_phone',
														$elm$json$Json$Decode$nullable($author$project$Api$Common$Phone$Shared$decoder),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'contact_email',
															$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'enabled',
																$elm$json$Json$Decode$bool,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'id',
																	$elm$json$Json$Decode$string,
																	$elm$json$Json$Decode$succeed($author$project$Api$Provider$DataExportConfiguration$Shared$Record))))))))))))))))));
var $author$project$Api$Provider$DataExportConfiguration$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$DataExportConfiguration$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$DataExport$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'data_export_configuration',
	$author$project$Api$Provider$DataExportConfiguration$Shared$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'export_generated',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'error_message',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'exported_at',
				$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'status',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'encrypted',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'export_file_name',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Api$Provider$DataExport$Shared$Record)))))))));
var $author$project$Api$Provider$DataExport$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$DataExport$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$DataExport$All$Record = function (entityName) {
	return {RH: entityName};
};
var $author$project$Api$Provider$DataExport$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'entity_name',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$DataExport$All$Record));
var $author$project$Api$Provider$DataExport$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$DataExport$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$DataExport$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$DataExport$All$DataExport)));
var $author$project$Api$Provider$DataExportGroup$DataExport$listDefaults = {ajJ: $author$project$Api$Pagination$init, alA: $author$project$Api$Sort$init};
var $author$project$Api$Provider$DataExportGroup$DataExport$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$DataExportGroup$DataExport$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$Provider$DataExportGroup$DataExport$list = F4(
	function (apiClient, dataExportGroupId, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$DataExport$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$DataExportGroup$DataExport$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$DataExportGroup$DataExport$dataExportsPath(dataExportGroupId))));
	});
var $author$project$Pages$Admin$DataExport$Id_String$fetchDataExports = function (model) {
	return A4(
		$author$project$Api$Provider$DataExportGroup$DataExport$list,
		model.Gv,
		model.ahP,
		function (d) {
			return _Utils_update(
				d,
				{ajJ: model.ajJ, alA: model.alA});
		},
		$author$project$Pages$Admin$DataExport$Id_String$GotDataExports);
};
var $author$project$Pages$Admin$DataExport$Id_String$init = F4(
	function (_v0, _v1, shared, _v2) {
		var query = _v2.DE;
		var params = _v2.YL;
		var q = A2($elm$core$Dict$get, 'q', query);
		var model = {
			Gv: shared.Gv,
			Pz: $author$project$Api$Data$Loading,
			ahP: params.ahP,
			Ij: $author$project$Shared$isHintAdmin(shared),
			ajJ: $author$project$Api$Pagination$initFromQuery(query),
			akl: q,
			kT: $elm$core$Maybe$Nothing,
			up: $author$project$Ui$SearchInput$init(q),
			alA: $author$project$Api$Sort$initFromQuery(query),
			J7: shared.J7
		};
		return _Utils_Tuple2(
			model,
			$author$project$Pages$Admin$DataExport$Id_String$fetchDataExports(model));
	});
var $author$project$Pages$Admin$DataExport$Id_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$DataExport$Id_String$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$DataExport$Id_String$RemoveFromDestinationModalMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$Close = {$: 0};
var $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$DataExport$RemoveFromDestinationModal$Close);
};
var $author$project$Pages$Admin$DataExport$Id_String$subscriptions = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Platform$Sub$none,
		A2(
			$elm$core$Maybe$map,
			$elm$core$Platform$Sub$map($author$project$Pages$Admin$DataExport$Id_String$RemoveFromDestinationModalMsg),
			A2($elm$core$Maybe$map, $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$subscriptions, model.kT)));
};
var $author$project$Pages$Admin$DataExport$Id_String$GotSignedFileUrl = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$init = F2(
	function (dataExportGroupId, dataExport) {
		return {iN: false, y3: dataExport, Hg: dataExportGroupId, pC: $author$project$Api$Data$NotAsked};
	});
var $author$project$Api$Provider$DataExportGroup$DataExport$dataExportPath = F2(
	function (dataExportGroupId, id) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id]),
			$author$project$Api$Provider$DataExportGroup$DataExport$dataExportsPath(dataExportGroupId));
	});
var $author$project$Api$Provider$DataExportGroup$DataExport$signedFileUrlDecoder = A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string);
var $author$project$Api$Provider$DataExportGroup$DataExport$signedFileUrl = F4(
	function (apiClient, dataExportGroupId, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$DataExportGroup$DataExport$signedFileUrlDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['signed_file_url']),
					A2($author$project$Api$Provider$DataExportGroup$DataExport$dataExportPath, dataExportGroupId, id_))));
	});
var $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$Closed = 1;
var $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$GotRemoveResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$None = 0;
var $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$Removed = 2;
var $author$project$Api$Provider$DataExport$Shared$record = function (_v0) {
	var record_ = _v0;
	return record_;
};
var $author$project$Api$Provider$DataExport$Shared$id = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExport$Shared$record,
	function ($) {
		return $.ahP;
	});
var $author$project$Api$Provider$DataExport$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$DataExport$Shared$id(shared);
};
var $author$project$Api$Provider$DataExport$One$DataExport = 0;
var $author$project$Api$Provider$DataExport$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Provider$DataExportGroup$DataExport$removeFromDestination = F4(
	function (apiClient, dataExportGroupId, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$DataExport$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['remove_from_destination']),
					A2($author$project$Api$Provider$DataExportGroup$DataExport$dataExportPath, dataExportGroupId, id))));
	});
var $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: 1, aiO: model, aR: _List_Nil};
			case 1:
				return model.iN ? {
					GZ: A4(
						$author$project$Api$Provider$DataExportGroup$DataExport$removeFromDestination,
						apiClient,
						model.Hg,
						$author$project$Api$Provider$DataExport$All$id(model.y3),
						$author$project$Components$Admin$DataExport$RemoveFromDestinationModal$GotRemoveResponse),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{pC: $author$project$Api$Data$Loading}),
					aR: _List_Nil
				} : {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 2,
						aiO: _Utils_update(
							model,
							{pC: response}),
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Export removed.')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{pC: response}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			default:
				var bool = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{iN: bool}),
					aR: _List_Nil
				};
		}
	});
var $author$project$Pages$Admin$DataExport$Id_String$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('q'),
			model.akl)
		]);
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString(
					$author$project$Spa$Generated$Route$Admin__DataExport__Id_String(
						{ahP: model.ahP}))
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.ajJ),
				A2(
					$elm$core$List$append,
					$author$project$Api$Sort$toQuery(model.alA),
					A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
};
var $author$project$Pages$Admin$DataExport$Id_String$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Pz: response,
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Pz: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Admin$DataExport$Id_String$fetchDataExports(newModel),
								$author$project$Pages$Admin$DataExport$Id_String$updateUrl(newModel)
							])),
					_List_Nil);
			case 2:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						alA: A2($author$project$Api$Sort$update, columnId, model.alA)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Admin$DataExport$Id_String$fetchDataExports(newModel),
								$author$project$Pages$Admin$DataExport$Id_String$updateUrl(newModel)
							])),
					_List_Nil);
			case 3:
				var dataExportId = msg.a;
				return _Utils_Tuple3(
					model,
					A4($author$project$Api$Provider$DataExportGroup$DataExport$signedFileUrl, model.Gv, model.ahP, dataExportId, $author$project$Pages$Admin$DataExport$Id_String$GotSignedFileUrl),
					_List_Nil);
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					var url = response.a;
					return _Utils_Tuple3(
						model,
						$author$project$Ports$Navigation$openInNewWindow(url),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 5:
				var dataExport = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							kT: $elm$core$Maybe$Just(
								A2($author$project$Components$Admin$DataExport$RemoveFromDestinationModal$init, model.ahP, dataExport))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v3 = model.kT;
				if (!_v3.$) {
					var removeFromDestinationModal = _v3.a;
					var result = A3($author$project$Components$Admin$DataExport$RemoveFromDestinationModal$update, model.Gv, subMsg, removeFromDestinationModal);
					var _v4 = function () {
						var _v5 = result.agZ;
						switch (_v5) {
							case 0:
								return _Utils_Tuple2(
									$elm$core$Maybe$Just(result.aiO),
									$elm$core$Platform$Cmd$none);
							case 1:
								return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
							default:
								return _Utils_Tuple2(
									$elm$core$Maybe$Nothing,
									$author$project$Pages$Admin$DataExport$Id_String$fetchDataExports(model));
						}
					}();
					var updatedRemoveFromDestinationModal = _v4.a;
					var cmd = _v4.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{kT: updatedRemoveFromDestinationModal}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									cmd,
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$DataExport$Id_String$RemoveFromDestinationModalMsg, result.GZ)
								])),
						result.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Admin$DataExport$Id_String$PaginationMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$Remove = {$: 1};
var $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$ConfirmUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$viewConfirmInput = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Checkbox$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Checkbox$value(model.iN),
						$author$project$Ui$Form$Checkbox$required(true),
						$author$project$Ui$Form$Checkbox$onCheck($author$project$Components$Admin$DataExport$RemoveFromDestinationModal$ConfirmUpdated)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('By checking this box I confirm that I have verified that the files to be removed'),
								$elm$html$Html$text('and the destination server accurate.')
							]))
					])),
				$author$project$Utils$FormErrors$view(
				model.iN ? _List_Nil : _List_fromArray(
					['Please confirm that the files to be removed and the destination server and path are accurate.']))
			]));
};
var $author$project$Api$Provider$DataExport$Shared$dataExportConfiguration = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExport$Shared$record,
	function ($) {
		return $.Px;
	});
var $author$project$Api$Provider$DataExport$All$dataExportConfiguration = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$DataExport$Shared$dataExportConfiguration(shared);
};
var $author$project$Api$Provider$DataExportConfiguration$Shared$record = function (_v0) {
	var record_ = _v0;
	return record_;
};
var $author$project$Api$Provider$DataExportConfiguration$Shared$destination = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExportConfiguration$Shared$record,
	function ($) {
		return $.Qt;
	});
var $author$project$Api$Provider$DataExportConfiguration$Shared$s3Bucket = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExportConfiguration$Shared$record,
	function ($) {
		return $.aal;
	});
var $author$project$Api$Provider$DataExportConfiguration$Shared$s3Region = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExportConfiguration$Shared$record,
	function ($) {
		return $.aam;
	});
var $author$project$Api$Provider$DataExportConfiguration$Shared$sftpHost = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExportConfiguration$Shared$record,
	function ($) {
		return $.aa9;
	});
var $author$project$Api$Provider$DataExportConfiguration$Shared$sftpPort = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExportConfiguration$Shared$record,
	function ($) {
		return $.aba;
	});
var $author$project$Api$Provider$DataExportConfiguration$Shared$sftpUsername = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExportConfiguration$Shared$record,
	function ($) {
		return $.abb;
	});
var $author$project$Components$Admin$DataExportConfiguration$Utils$destinationDescription = function (dataExportConfiguration) {
	var _v0 = $author$project$Api$Provider$DataExportConfiguration$Shared$destination(dataExportConfiguration);
	switch (_v0) {
		case 'sftp':
			return 'sftp://' + (A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Api$Provider$DataExportConfiguration$Shared$sftpUsername(dataExportConfiguration)) + ('@' + (A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Api$Provider$DataExportConfiguration$Shared$sftpHost(dataExportConfiguration)) + (':' + A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					$elm$core$String$fromInt,
					$author$project$Api$Provider$DataExportConfiguration$Shared$sftpPort(dataExportConfiguration)))))));
		case 's3':
			return 's3://' + (A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Api$Provider$DataExportConfiguration$Shared$s3Region(dataExportConfiguration)) + ('/' + A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Api$Provider$DataExportConfiguration$Shared$s3Bucket(dataExportConfiguration))));
		default:
			return 'unknown destination';
	}
};
var $author$project$Api$Provider$DataExport$All$entityName = function (_v0) {
	var record = _v0.b;
	return record.RH;
};
var $author$project$Api$Provider$DataExport$Shared$exportFileName = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExport$Shared$record,
	function ($) {
		return $.R2;
	});
var $author$project$Api$Provider$DataExport$All$exportFileName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$DataExport$Shared$exportFileName(shared);
};
var $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$viewPreview = function (dataExport) {
	var dataExportConfiguration = $author$project$Api$Provider$DataExport$All$dataExportConfiguration(dataExport);
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mb-2')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('The platform will remove the following files from the given destination.')
					])),
				A2(
				$author$project$Ui$Typography$strong,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Entity Name: ')
					])),
				$elm$html$Html$text(
				$author$project$Api$Provider$DataExport$All$entityName(dataExport)),
				A2($elm$html$Html$br, _List_Nil, _List_Nil),
				A2(
				$author$project$Ui$Typography$strong,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Destination: ')
					])),
				$elm$html$Html$text(
				$author$project$Components$Admin$DataExportConfiguration$Utils$destinationDescription(dataExportConfiguration)),
				A2($elm$html$Html$br, _List_Nil, _List_Nil),
				A2(
				$author$project$Ui$Typography$strong,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Files: ')
					])),
				A2(
				$elm$html$Html$ul,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$li,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$elm$core$Maybe$withDefault,
									'N/A',
									$author$project$Api$Provider$DataExport$All$exportFileName(dataExport)))
							]))
					]))
			]));
};
var $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$view = function (_v0) {
	var model = _v0;
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Admin$DataExport$RemoveFromDestinationModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Remove From Destination')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						$author$project$Components$Admin$DataExport$RemoveFromDestinationModal$viewPreview(model.y3),
						$author$project$Components$Admin$DataExport$RemoveFromDestinationModal$viewConfirmInput(model)
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Admin$DataExport$RemoveFromDestinationModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Close')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Remove From Destination'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$onClick($author$project$Components$Admin$DataExport$RemoveFromDestinationModal$Remove),
								$author$project$Ui$Button$icon($author$project$Ui$Icon$add),
								$author$project$Ui$Button$disabled(!model.iN),
								$author$project$Ui$Button$loading(
								_Utils_eq(model.pC, $author$project$Api$Data$Loading))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Remove From Destination')
							]))
					]))
			]));
};
var $author$project$Pages$Admin$DataExport$Id_String$SortTable = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$DataExport$Id_String$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'destination', false, 'Destination'),
		A3($author$project$Api$Column$init, 'export_file_name', true, 'Export File Name'),
		A3($author$project$Api$Column$init, 'encrypted', true, 'Encrypted'),
		A3($author$project$Api$Column$init, 'status', true, 'Status'),
		A3($author$project$Api$Column$init, 'exported_at', true, 'Exported At'),
		A3($author$project$Api$Column$init, 'error_message', false, 'Error Message')
	]);
var $author$project$Components$Admin$DataExportConfiguration$Help$view = A2(
	$author$project$Ui$Typography$p,
	_List_fromArray(
		[$author$project$Ui$Typography$muted]),
	_List_fromArray(
		[
			$elm$html$Html$text('See our '),
			A3(
			$author$project$Ui$Link$externalHref,
			'https://docs.google.com/document/d/1s8wgwrN-Ltlw6r0w_g7WflS7DLZS4SFARQBgKxCYvfs/edit?tab=t.0',
			_List_fromArray(
				[$author$project$Ui$Link$targetBlank]),
			_List_fromArray(
				[
					$elm$html$Html$text('developer documentation')
				])),
			$elm$html$Html$text(' and'),
			A3(
			$author$project$Ui$Link$externalHref,
			'https://miro.com/app/board/uXjVIg-hLbw=/?moveToWidget=3458764635611947784&cot=14',
			_List_fromArray(
				[$author$project$Ui$Link$targetBlank]),
			_List_fromArray(
				[
					$elm$html$Html$text('ERD Schema')
				])),
			$elm$html$Html$text(' for standard Data Exporter tables.')
		]));
var $author$project$Formatters$Time$DateTime__Full = 4;
var $author$project$Pages$Admin$DataExport$Id_String$OpenFileDocument = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Admin$DataExport$Id_String$OpenRemoveFromDestinationModal = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$DataExport$Shared$encrypted = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExport$Shared$record,
	function ($) {
		return $.Rr;
	});
var $author$project$Api$Provider$DataExport$All$encrypted = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$DataExport$Shared$encrypted(shared);
};
var $author$project$Api$Provider$DataExport$Shared$errorMessage = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExport$Shared$record,
	function ($) {
		return $.RM;
	});
var $author$project$Api$Provider$DataExport$All$errorMessage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$DataExport$Shared$errorMessage(shared);
};
var $author$project$Api$Provider$DataExport$Shared$exportGenerated = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExport$Shared$record,
	function ($) {
		return $.R3;
	});
var $author$project$Api$Provider$DataExport$All$exportGenerated = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$DataExport$Shared$exportGenerated(shared);
};
var $author$project$Api$Provider$DataExport$Shared$exportedAt = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExport$Shared$record,
	function ($) {
		return $.R4;
	});
var $author$project$Api$Provider$DataExport$All$exportedAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$DataExport$Shared$exportedAt(shared);
};
var $author$project$Api$Provider$DataExport$Shared$status = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExport$Shared$record,
	function ($) {
		return $.alH;
	});
var $author$project$Api$Provider$DataExport$All$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$DataExport$Shared$status(shared);
};
var $author$project$Pages$Admin$DataExport$Id_String$viewDataExport = F3(
	function (timeFormatter, isHintAdmin, dataExport) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Components$Admin$DataExportConfiguration$Utils$destinationDescription(
								$author$project$Api$Provider$DataExport$All$dataExportConfiguration(dataExport)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'N/A',
								$author$project$Api$Provider$DataExport$All$exportFileName(dataExport)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Formatters$Bool$toString(
										$author$project$Api$Provider$DataExport$All$encrypted(dataExport)))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Badge$fromString,
									_List_Nil,
									$author$project$Api$Provider$DataExport$All$status(dataExport))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'N/A',
								A2(
									$elm$core$Maybe$map,
									timeFormatter(4),
									$author$project$Api$Provider$DataExport$All$exportedAt(dataExport))))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										$author$project$Api$Provider$DataExport$All$errorMessage(dataExport)))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							(isHintAdmin && $author$project$Api$Provider$DataExport$All$exportGenerated(dataExport)) ? A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flex, $author$project$Ui$Element$justifyRight]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Tooltip$view,
									_List_Nil,
									'Download file',
									_List_fromArray(
										[
											A3(
											$author$project$Ui$HinterOnly$button,
											{mm: 'Download file'},
											_List_fromArray(
												[
													$author$project$Ui$Button$onClick(
													$author$project$Pages$Admin$DataExport$Id_String$OpenFileDocument(
														$author$project$Api$Provider$DataExport$All$id(dataExport))),
													$author$project$Ui$Button$icon($author$project$Ui$Icon$export)
												]),
											_List_Nil)
										]))
								])) : $author$project$Utils$Html$empty,
							(isHintAdmin && ($author$project$Api$Provider$DataExport$All$status(dataExport) === 'exported')) ? A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flex, $author$project$Ui$Element$justifyRight]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Tooltip$view,
									_List_Nil,
									'Remove from destination',
									_List_fromArray(
										[
											A3(
											$author$project$Ui$HinterOnly$button,
											{mm: 'Remove from destination'},
											_List_fromArray(
												[
													$author$project$Ui$Button$onClick(
													$author$project$Pages$Admin$DataExport$Id_String$OpenRemoveFromDestinationModal(dataExport))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Remove from destination')
												]))
										]))
								])) : $author$project$Utils$Html$empty
						]))
				]));
	});
var $author$project$Pages$Admin$DataExport$Id_String$viewPanelBody = function (model) {
	var _v0 = function () {
		var _v1 = model.Pz;
		if (_v1.$ === 3) {
			var dataExports_ = _v1.a;
			return _Utils_Tuple2(false, dataExports_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var dataExports = _v0.b;
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mb4]),
			_List_fromArray(
				[
					$elm$html$Html$text('Manage exports.'),
					$author$project$Components$Admin$DataExportConfiguration$Help$view
				])),
			A4(
			$author$project$Ui$Table$view,
			_List_fromArray(
				[
					$author$project$Ui$Table$verticalCentered,
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('No exports found.')
						])),
					$author$project$Ui$Table$loading(loading)
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						A2(
						$elm$core$List$map,
						$author$project$Api$Column$view(
							A2($author$project$Api$Column$Sortable, model.alA, $author$project$Pages$Admin$DataExport$Id_String$SortTable)),
						$author$project$Pages$Admin$DataExport$Id_String$columns),
						_List_fromArray(
						[
							A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
						])
					])),
			A2(
				$elm$core$List$map,
				A2($author$project$Pages$Admin$DataExport$Id_String$viewDataExport, model.J7, model.Ij),
				dataExports),
			_List_Nil)
		]);
};
var $author$project$Pages$Admin$DataExport$Id_String$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					$elm$html$Html$map($author$project$Pages$Admin$DataExport$Id_String$RemoveFromDestinationModalMsg),
					A2($elm$core$Maybe$map, $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$view, model.kT))),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$elm$core$Basics$never,
								A2(
									$author$project$Ui$Breadcrumb$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Breadcrumb$item,
											_List_Nil,
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Admin__DataExport__Top,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Exports')
														]))
												])),
											A2(
											$author$project$Ui$Breadcrumb$item,
											_List_fromArray(
												[
													$author$project$Ui$Breadcrumb$active(true)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(model.ahP)
												]))
										])))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						$author$project$Pages$Admin$DataExport$Id_String$viewPanelBody(model)),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								function () {
								var _v0 = model.Pz;
								if (_v0.$ === 3) {
									return A2(
										$elm$html$Html$map,
										$author$project$Pages$Admin$DataExport$Id_String$PaginationMsg,
										A2($author$project$Api$Pagination$view, _List_Nil, model.ajJ));
								} else {
									return $author$project$Utils$Html$empty;
								}
							}()
							]))
					]))
			]),
		ac9: 'Admin | Data Exporter | Exports'
	};
};
var $author$project$Pages$Admin$DataExport$Id_String$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$DataExport$Id_String$init, aiq: $author$project$Pages$Admin$DataExport$Id_String$load, k8: $author$project$Pages$Admin$DataExport$Id_String$save, alO: $author$project$Pages$Admin$DataExport$Id_String$subscriptions, adT: $author$project$Pages$Admin$DataExport$Id_String$update, amo: $author$project$Pages$Admin$DataExport$Id_String$view});
var $author$project$Pages$Admin$DataExport$Top$GotDataExportGroups = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$DataExportGroup$All$DataExportGroup = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$DataExportGroup$Shared$DataExportGroup = $elm$core$Basics$identity;
var $author$project$Api$Provider$DataExportGroup$Shared$Record = F3(
	function (id, timestamp, dataExportConfiguration) {
		return {Px: dataExportConfiguration, ahP: id, ac7: timestamp};
	});
var $author$project$Api$Provider$DataExportGroup$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'data_export_configuration',
	$author$project$Api$Provider$DataExportConfiguration$Shared$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'timestamp',
		$elm_community$json_extra$Json$Decode$Extra$datetime,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$DataExportGroup$Shared$Record))));
var $author$project$Api$Provider$DataExportGroup$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$DataExportGroup$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$DataExportGroup$All$Record = F2(
	function (entityName, dataExports) {
		return {Pz: dataExports, RH: entityName};
	});
var $author$project$Api$Provider$DataExportGroup$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'data_exports',
	$elm$json$Json$Decode$list($author$project$Api$Provider$DataExport$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'entity_name',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$DataExportGroup$All$Record)));
var $author$project$Api$Provider$DataExportGroup$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$DataExportGroup$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$DataExportGroup$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$DataExportGroup$All$DataExportGroup)));
var $author$project$Api$Provider$DataExportGroup$listDefaults = {ajJ: $author$project$Api$Pagination$init, alA: $author$project$Api$Sort$init};
var $author$project$Api$Provider$DataExportGroup$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$DataExportGroup$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$Provider$DataExportGroup$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$DataExportGroup$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$DataExportGroup$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$DataExportGroup$dataExportGroupsPath)));
	});
var $author$project$Pages$Admin$DataExport$Top$fetchDataExportGroups = function (model) {
	return A3(
		$author$project$Api$Provider$DataExportGroup$list,
		model.Gv,
		function (d) {
			return _Utils_update(
				d,
				{ajJ: model.ajJ, alA: model.alA});
		},
		$author$project$Pages$Admin$DataExport$Top$GotDataExportGroups);
};
var $author$project$Pages$Admin$DataExport$Top$init = F4(
	function (_v0, _v1, shared, _v2) {
		var query = _v2.DE;
		var q = A2($elm$core$Dict$get, 'q', query);
		var model = {
			Gv: shared.Gv,
			m8: $author$project$Api$Data$Loading,
			Ij: $author$project$Shared$isHintAdmin(shared),
			ajJ: $author$project$Api$Pagination$initFromQuery(query),
			akl: q,
			kT: $elm$core$Maybe$Nothing,
			up: $author$project$Ui$SearchInput$init(q),
			alA: A3(
				$author$project$Api$Sort$withDefault,
				'timestamp',
				1,
				$author$project$Api$Sort$initFromQuery(query)),
			J7: shared.J7
		};
		return _Utils_Tuple2(
			model,
			$author$project$Pages$Admin$DataExport$Top$fetchDataExportGroups(model));
	});
var $author$project$Pages$Admin$DataExport$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$DataExport$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$DataExport$Top$RemoveFromDestinationModalMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$Close = {$: 0};
var $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$Close);
};
var $author$project$Pages$Admin$DataExport$Top$subscriptions = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Platform$Sub$none,
		A2(
			$elm$core$Maybe$map,
			$elm$core$Platform$Sub$map($author$project$Pages$Admin$DataExport$Top$RemoveFromDestinationModalMsg),
			A2($elm$core$Maybe$map, $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$subscriptions, model.kT)));
};
var $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$init = function (dataExportGroup) {
	return {iN: false, y4: dataExportGroup, pC: $author$project$Api$Data$NotAsked};
};
var $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$Closed = 1;
var $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$GotRemoveResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$None = 0;
var $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$Removed = 2;
var $author$project$Api$Provider$DataExportGroup$Shared$record = function (_v0) {
	var record_ = _v0;
	return record_;
};
var $author$project$Api$Provider$DataExportGroup$Shared$id = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExportGroup$Shared$record,
	function ($) {
		return $.ahP;
	});
var $author$project$Api$Provider$DataExportGroup$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$DataExportGroup$Shared$id(shared);
};
var $author$project$Api$Provider$DataExportGroup$One$DataExportGroup = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$DataExportGroup$One$Record = F2(
	function (entityName, dataExports) {
		return {Pz: dataExports, RH: entityName};
	});
var $author$project$Api$Provider$DataExportGroup$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'data_exports',
	$elm$json$Json$Decode$list($author$project$Api$Provider$DataExport$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'entity_name',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$DataExportGroup$One$Record)));
var $author$project$Api$Provider$DataExportGroup$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$DataExportGroup$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$DataExportGroup$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$DataExportGroup$One$DataExportGroup)));
var $author$project$Api$Provider$DataExportGroup$removeFromDestination = F3(
	function (apiClient, dataExportGroupId, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$DataExportGroup$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['remove_from_destination']),
					$author$project$Api$Provider$DataExportGroup$dataExportGroupPath(dataExportGroupId))));
	});
var $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: 1, aiO: model, aR: _List_Nil};
			case 1:
				return model.iN ? {
					GZ: A3(
						$author$project$Api$Provider$DataExportGroup$removeFromDestination,
						apiClient,
						$author$project$Api$Provider$DataExportGroup$All$id(model.y4),
						$author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$GotRemoveResponse),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{pC: $author$project$Api$Data$Loading}),
					aR: _List_Nil
				} : {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 2,
						aiO: _Utils_update(
							model,
							{pC: response}),
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Export removed.')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{pC: response}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			default:
				var bool = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{iN: bool}),
					aR: _List_Nil
				};
		}
	});
var $author$project$Pages$Admin$DataExport$Top$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('q'),
			model.akl)
		]);
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Admin__DataExport__Top)
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.ajJ),
				A2(
					$elm$core$List$append,
					$author$project$Api$Sort$toQuery(model.alA),
					A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
};
var $author$project$Pages$Admin$DataExport$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								m8: response,
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{m8: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Admin$DataExport$Top$fetchDataExportGroups(newModel),
								$author$project$Pages$Admin$DataExport$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 2:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						alA: A2($author$project$Api$Sort$update, columnId, model.alA)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Admin$DataExport$Top$fetchDataExportGroups(newModel),
								$author$project$Pages$Admin$DataExport$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 3:
				var dataExportGroup = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							kT: $elm$core$Maybe$Just(
								$author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$init(dataExportGroup))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v2 = model.kT;
				if (!_v2.$) {
					var removeFromDestinationModal = _v2.a;
					var result = A3($author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$update, model.Gv, subMsg, removeFromDestinationModal);
					var updatedRemoveFromDestinationModal = function () {
						var _v3 = result.agZ;
						switch (_v3) {
							case 0:
								return $elm$core$Maybe$Just(result.aiO);
							case 1:
								return $elm$core$Maybe$Nothing;
							default:
								return $elm$core$Maybe$Nothing;
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{kT: updatedRemoveFromDestinationModal}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$DataExport$Top$RemoveFromDestinationModalMsg, result.GZ),
						result.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Admin$DataExport$Top$PaginationMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$Remove = {$: 1};
var $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$ConfirmUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$viewConfirmInput = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Checkbox$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Checkbox$value(model.iN),
						$author$project$Ui$Form$Checkbox$required(true),
						$author$project$Ui$Form$Checkbox$onCheck($author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$ConfirmUpdated)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('By checking this box I confirm that I have verified that the files to be removed'),
								$elm$html$Html$text('and the destination server accurate.')
							]))
					])),
				$author$project$Utils$FormErrors$view(
				model.iN ? _List_Nil : _List_fromArray(
					['Please confirm that the files to be removed and the destination server and path are accurate.']))
			]));
};
var $author$project$Api$Provider$DataExportGroup$Shared$dataExportConfiguration = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExportGroup$Shared$record,
	function ($) {
		return $.Px;
	});
var $author$project$Api$Provider$DataExportGroup$All$dataExportConfiguration = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$DataExportGroup$Shared$dataExportConfiguration(shared);
};
var $author$project$Api$Provider$DataExportGroup$All$dataExports = function (_v0) {
	var record = _v0.b;
	return record.Pz;
};
var $author$project$Api$Provider$DataExportGroup$All$entityName = function (_v0) {
	var record = _v0.b;
	return record.RH;
};
var $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$viewDataExport = function (dataExport) {
	return A2(
		$elm$html$Html$li,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				A2(
					$elm$core$Maybe$withDefault,
					'N/A',
					$author$project$Api$Provider$DataExport$Shared$exportFileName(dataExport)))
			]));
};
var $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$viewPreview = function (dataExportGroup) {
	var dataExportConfiguration = $author$project$Api$Provider$DataExportGroup$All$dataExportConfiguration(dataExportGroup);
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mb-2')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('The platform will remove the following files from the given destination.')
					])),
				A2(
				$author$project$Ui$Typography$strong,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Entity Name: ')
					])),
				$elm$html$Html$text(
				$author$project$Api$Provider$DataExportGroup$All$entityName(dataExportGroup)),
				A2($elm$html$Html$br, _List_Nil, _List_Nil),
				A2(
				$author$project$Ui$Typography$strong,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Destination: ')
					])),
				$elm$html$Html$text(
				$author$project$Components$Admin$DataExportConfiguration$Utils$destinationDescription(dataExportConfiguration)),
				A2($elm$html$Html$br, _List_Nil, _List_Nil),
				A2(
				$author$project$Ui$Typography$strong,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Files: ')
					])),
				A2(
				$elm$html$Html$ul,
				_List_Nil,
				A2(
					$elm$core$List$map,
					$author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$viewDataExport,
					$author$project$Api$Provider$DataExportGroup$All$dataExports(dataExportGroup)))
			]));
};
var $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$view = function (_v0) {
	var model = _v0;
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Remove From Destination')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						$author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$viewPreview(model.y4),
						$author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$viewConfirmInput(model)
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Close')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Remove From Destination'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$onClick($author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$Remove),
								$author$project$Ui$Button$icon($author$project$Ui$Icon$add),
								$author$project$Ui$Button$disabled(!model.iN),
								$author$project$Ui$Button$loading(
								_Utils_eq(model.pC, $author$project$Api$Data$Loading))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Remove From Destination')
							]))
					]))
			]));
};
var $author$project$Pages$Admin$DataExport$Top$SortTable = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$DataExport$Top$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'destination', false, 'Destination'),
		A3($author$project$Api$Column$init, 'timestamp', true, 'Exported At')
	]);
var $author$project$Pages$Admin$DataExport$Top$OpenRemoveFromDestinationModal = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$DataExportGroup$Shared$timestamp = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExportGroup$Shared$record,
	function ($) {
		return $.ac7;
	});
var $author$project$Api$Provider$DataExportGroup$All$timestamp = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$DataExportGroup$Shared$timestamp(shared);
};
var $author$project$Pages$Admin$DataExport$Top$viewDataExportGroup = F3(
	function (timeFormatter, isHintAdmin, dataExportGroup) {
		var withLink = function (contents) {
			return A3(
				$author$project$Ui$Link$route,
				$author$project$Spa$Generated$Route$Admin__DataExport__Id_String(
					{
						ahP: $author$project$Api$Provider$DataExportGroup$All$id(dataExportGroup)
					}),
				_List_Nil,
				contents);
		};
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							withLink(
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Components$Admin$DataExportConfiguration$Utils$destinationDescription(
										$author$project$Api$Provider$DataExportGroup$All$dataExportConfiguration(dataExportGroup)))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							withLink(
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										timeFormatter,
										4,
										$author$project$Api$Provider$DataExportGroup$All$timestamp(dataExportGroup)))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							isHintAdmin ? A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flex, $author$project$Ui$Element$justifyRight]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Tooltip$view,
									_List_Nil,
									'Remove from destination',
									_List_fromArray(
										[
											A3(
											$author$project$Ui$HinterOnly$button,
											{mm: 'Remove from destination'},
											_List_fromArray(
												[
													$author$project$Ui$Button$onClick(
													$author$project$Pages$Admin$DataExport$Top$OpenRemoveFromDestinationModal(dataExportGroup))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Remove from destination')
												]))
										]))
								])) : $author$project$Utils$Html$empty
						]))
				]));
	});
var $author$project$Pages$Admin$DataExport$Top$viewPanelBody = function (model) {
	var _v0 = function () {
		var _v1 = model.m8;
		if (_v1.$ === 3) {
			var dataExportGroups_ = _v1.a;
			return _Utils_Tuple2(false, dataExportGroups_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var dataExportGroups = _v0.b;
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mb4]),
			_List_fromArray(
				[
					$elm$html$Html$text('Manage exports.'),
					$author$project$Components$Admin$DataExportConfiguration$Help$view
				])),
			A4(
			$author$project$Ui$Table$view,
			_List_fromArray(
				[
					$author$project$Ui$Table$verticalCentered,
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('No exports found.')
						])),
					$author$project$Ui$Table$loading(loading)
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						A2(
						$elm$core$List$map,
						$author$project$Api$Column$view(
							A2($author$project$Api$Column$Sortable, model.alA, $author$project$Pages$Admin$DataExport$Top$SortTable)),
						$author$project$Pages$Admin$DataExport$Top$columns),
						_List_fromArray(
						[
							A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
						])
					])),
			A2(
				$elm$core$List$map,
				A2($author$project$Pages$Admin$DataExport$Top$viewDataExportGroup, model.J7, model.Ij),
				dataExportGroups),
			_List_Nil)
		]);
};
var $author$project$Pages$Admin$DataExport$Top$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					$elm$html$Html$map($author$project$Pages$Admin$DataExport$Top$RemoveFromDestinationModalMsg),
					A2($elm$core$Maybe$map, $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$view, model.kT))),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Exports')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						$author$project$Pages$Admin$DataExport$Top$viewPanelBody(model)),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								function () {
								var _v0 = model.m8;
								if (_v0.$ === 3) {
									return A2(
										$elm$html$Html$map,
										$author$project$Pages$Admin$DataExport$Top$PaginationMsg,
										A2($author$project$Api$Pagination$view, _List_Nil, model.ajJ));
								} else {
									return $author$project$Utils$Html$empty;
								}
							}()
							]))
					]))
			]),
		ac9: 'Admin | Data Exporter | Exports'
	};
};
var $author$project$Pages$Admin$DataExport$Top$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$DataExport$Top$init, aiq: $author$project$Pages$Admin$DataExport$Top$load, k8: $author$project$Pages$Admin$DataExport$Top$save, alO: $author$project$Pages$Admin$DataExport$Top$subscriptions, adT: $author$project$Pages$Admin$DataExport$Top$update, amo: $author$project$Pages$Admin$DataExport$Top$view});
var $author$project$Pages$Admin$DataExportSettings$Id_String$DataExportConfigurationFormMsg = $elm$core$Basics$identity;
var $author$project$Components$Admin$DataExportConfiguration$Form$GotDataExportConfiguration = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$Form$Model = $elm$core$Basics$identity;
var $author$project$Components$PhoneInput$US = 0;
var $author$project$Components$PhoneInput$International = 1;
var $author$project$Api$Common$Phone$Shared$type_ = function (_v0) {
	var record = _v0;
	return record.amg;
};
var $author$project$Api$Common$Phone$Shared$usFormattable = function (_v0) {
	var record = _v0;
	return record.Kl;
};
var $author$project$Utils$Phone$fromApi = function (phone) {
	var region = $author$project$Api$Common$Phone$Shared$usFormattable(phone) ? 0 : 1;
	return {
		IO: A2(
			$elm$core$Maybe$withDefault,
			'',
			$author$project$Api$Common$Phone$Shared$number(phone)),
		akD: region,
		amg: $author$project$Api$Common$Phone$Shared$type_(phone)
	};
};
var $author$project$Components$PhoneInput$Model = $elm$core$Basics$identity;
var $author$project$Components$PhoneInput$PhoneRegionDropdownMsg = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$PhoneInput$PhoneTypeDropdownMsg = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$PhoneInput$defaults = {
	Gh: false,
	aeW: true,
	agl: $author$project$Api$Common$Phone$Shared$Mobile,
	agy: false,
	nS: false,
	AU: 5,
	pz: _List_fromArray(
		[0, 1]),
	akR: false,
	amh: _List_fromArray(
		[$author$project$Api$Common$Phone$Shared$Mobile, $author$project$Api$Common$Phone$Shared$Home, $author$project$Api$Common$Phone$Shared$Office])
};
var $author$project$Components$PhoneInput$initPhone = F3(
	function (type_, region, number) {
		return {IO: number, akD: region, amg: type_};
	});
var $author$project$Components$PhoneInput$emptyPhone = function (type_) {
	return A3($author$project$Components$PhoneInput$initPhone, type_, 0, '');
};
var $author$project$Components$PhoneInput$phoneRegionDropdownId = F2(
	function (id, index) {
		return id + ('phone-input-phone-region' + $elm$core$String$fromInt(index));
	});
var $author$project$Components$PhoneInput$phoneTypeDropdownId = F2(
	function (id, index) {
		return id + ('phone-input-phone-type' + $elm$core$String$fromInt(index));
	});
var $author$project$Components$PhoneInput$init = F3(
	function (id, phones, optionals) {
		var options = optionals($author$project$Components$PhoneInput$defaults);
		var phones_ = ($elm$core$List$isEmpty(phones) && options.Gh) ? _List_fromArray(
			[
				$author$project$Components$PhoneInput$emptyPhone(options.agl)
			]) : phones;
		return {
			aeW: options.aeW,
			agl: options.agl,
			agy: options.agy,
			SD: $author$project$Utils$Form$init(
				A2(
					$elm$core$List$indexedMap,
					F2(
						function (index, phone) {
							return _Utils_Tuple3(
								phone,
								$author$project$Ui$Dropdown$init(
									$author$project$Ui$Dropdown$defaultConfig(
										{
											ahP: A2($author$project$Components$PhoneInput$phoneTypeDropdownId, id, index),
											al6: $author$project$Components$PhoneInput$PhoneTypeDropdownMsg(index)
										})),
								$author$project$Ui$Dropdown$init(
									$author$project$Ui$Dropdown$defaultConfig(
										{
											ahP: A2($author$project$Components$PhoneInput$phoneRegionDropdownId, id, index),
											al6: $author$project$Components$PhoneInput$PhoneRegionDropdownMsg(index)
										})));
						}),
					phones_)),
			nS: options.nS,
			ahP: id,
			AU: options.AU,
			pz: options.pz,
			akR: options.akR,
			amh: options.amh
		};
	});
var $author$project$Components$PhoneInput$require = F2(
	function (required, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{akR: required});
	});
var $author$project$Components$Admin$DataExportConfiguration$Form$initPhoneInput = function (maybePhone) {
	return A2(
		$author$project$Components$PhoneInput$require,
		true,
		A3(
			$author$project$Components$PhoneInput$init,
			'data-export-configuration-contact-phone-input',
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$withDefault,
					{IO: '', akD: 0, amg: $author$project$Api$Common$Phone$Shared$Mobile},
					A2($elm$core$Maybe$map, $author$project$Utils$Phone$fromApi, maybePhone))
				]),
			function (opts) {
				return _Utils_update(
					opts,
					{aeW: false, AU: 1});
			}));
};
var $author$project$Components$Admin$DataExportConfiguration$Form$emptyFormFieldsInit = function (isHintAdmin) {
	return {
		Ow: $elm$core$Maybe$Nothing,
		Oy: $author$project$Components$Admin$DataExportConfiguration$Form$initPhoneInput($elm$core$Maybe$Nothing),
		Qt: $elm$core$Maybe$Nothing,
		Ro: false,
		jD: false,
		Rs: $elm$core$Maybe$Nothing,
		Rt: $elm$core$Maybe$Nothing,
		RR: !isHintAdmin,
		So: $elm$core$Maybe$Just(':timestamp:/:file_name:'),
		nY: false,
		Ws: false,
		aal: $elm$core$Maybe$Nothing,
		aam: $elm$core$Maybe$Nothing,
		aa9: $elm$core$Maybe$Nothing,
		aba: $elm$core$Maybe$Nothing,
		JJ: $elm$core$Maybe$Nothing,
		ux: false,
		abb: $elm$core$Maybe$Nothing
	};
};
var $author$project$Api$Provider$DataExportConfiguration$dataExportConfigurationsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['data_export_configurations']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$DataExportConfiguration$dataExportConfigurationPath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		$author$project$Api$Provider$DataExportConfiguration$dataExportConfigurationsPath);
};
var $author$project$Api$Provider$DataExportConfiguration$One$DataExportConfiguration = $elm$core$Basics$identity;
var $author$project$Api$Provider$DataExportConfiguration$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$DataExportConfiguration$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$DataExportConfiguration$retrieve = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$DataExportConfiguration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$DataExportConfiguration$dataExportConfigurationPath(id)));
	});
var $author$project$Components$Admin$DataExportConfiguration$Form$init = F4(
	function (apiClient, isHintAdmin, id, singleton) {
		var _v0 = function () {
			if (!id.$) {
				var id_ = id.a;
				return _Utils_Tuple3(
					$elm$core$Maybe$Nothing,
					$author$project$Api$Data$Loading,
					A3($author$project$Api$Provider$DataExportConfiguration$retrieve, apiClient, id_, $author$project$Components$Admin$DataExportConfiguration$Form$GotDataExportConfiguration));
			} else {
				return _Utils_Tuple3(
					$elm$core$Maybe$Just(
						$author$project$Utils$Form$init(
							$author$project$Components$Admin$DataExportConfiguration$Form$emptyFormFieldsInit(isHintAdmin))),
					$author$project$Api$Data$NotAsked,
					$elm$core$Platform$Cmd$none);
			}
		}();
		var form = _v0.a;
		var dataExportConfiguration = _v0.b;
		var retrieveCmd = _v0.c;
		var model = {Px: dataExportConfiguration, jI: $elm$core$Maybe$Nothing, SD: form, ahP: id, Ij: isHintAdmin, k9: $author$project$Api$Data$NotAsked, uL: singleton, lL: $elm$core$Maybe$Nothing};
		return _Utils_Tuple2(model, retrieveCmd);
	});
var $author$project$Pages$Admin$DataExportSettings$Id_String$init = F4(
	function (_v0, _v1, shared, _v2) {
		var params = _v2.YL;
		var query = _v2.DE;
		var singleton = _Utils_eq(
			A2($elm$core$Dict$get, 'singleton', query),
			$elm$core$Maybe$Just('true'));
		var _v3 = A4(
			$author$project$Components$Admin$DataExportConfiguration$Form$init,
			shared.Gv,
			$author$project$Shared$isHintAdmin(shared),
			$elm$core$Maybe$Just(params.ahP),
			singleton);
		var form = _v3.a;
		var cmd = _v3.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, SD: form},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
	});
var $author$project$Pages$Admin$DataExportSettings$Id_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$DataExportSettings$Id_String$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Admin$DataExportConfiguration$Form$ContactPhoneInputMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$Form$ExportModalMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$Form$TestConnectionModalMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$ExportModal$Close = {$: 0};
var $author$project$Components$Admin$DataExportConfiguration$ExportModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$DataExportConfiguration$ExportModal$Close);
};
var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$Close = {$: 0};
var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$Close);
};
var $author$project$Components$PhoneInput$subscriptions = function (_v0) {
	var model = _v0;
	var phones = $author$project$Utils$Form$fields(model.SD);
	return $elm$core$Platform$Sub$batch(
		A2(
			$elm$core$List$map,
			function (_v1) {
				var typeDropdown = _v1.b;
				var regionDropdown = _v1.c;
				return $elm$core$Platform$Sub$batch(
					_List_fromArray(
						[
							$author$project$Ui$Dropdown$subscriptions(typeDropdown),
							$author$project$Ui$Dropdown$subscriptions(regionDropdown)
						]));
			},
			phones));
};
var $author$project$Components$Admin$DataExportConfiguration$Form$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Platform$Sub$map($author$project$Components$Admin$DataExportConfiguration$Form$TestConnectionModalMsg),
					A2($elm$core$Maybe$map, $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$subscriptions, model.lL))),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Platform$Sub$map($author$project$Components$Admin$DataExportConfiguration$Form$ExportModalMsg),
					A2($elm$core$Maybe$map, $author$project$Components$Admin$DataExportConfiguration$ExportModal$subscriptions, model.jI))),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Platform$Sub$map($author$project$Components$Admin$DataExportConfiguration$Form$ContactPhoneInputMsg),
					A2(
						$elm$core$Maybe$map,
						$author$project$Components$PhoneInput$subscriptions,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.Oy;
							},
							A2($elm$core$Maybe$map, $author$project$Utils$Form$fields, model.SD)))))
			]));
};
var $author$project$Pages$Admin$DataExportSettings$Id_String$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Admin$DataExportConfiguration$Form$subscriptions(model.SD));
};
var $author$project$Components$Admin$DataExportConfiguration$Form$ContactPhone = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$Form$GotDataExportConfigurationSaved = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$Form$None = {$: 0};
var $author$project$Components$Admin$DataExportConfiguration$Form$Saved = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Common$Phone$Shared$typeEncoder = function (type__) {
	switch (type__.$) {
		case 0:
			return $elm$json$Json$Encode$string('mobile');
		case 1:
			return $elm$json$Json$Encode$string('home');
		case 2:
			return $elm$json$Json$Encode$string('office');
		default:
			var otherDescription = type__.a;
			return $elm$json$Json$Encode$string(otherDescription);
	}
};
var $author$project$Api$Common$Phone$Shared$encode = function (phone) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$author$project$Api$Common$Phone$Shared$typeEncoder(phone.amg)),
				_Utils_Tuple2(
				'number',
				$elm$json$Json$Encode$string(phone.IO)),
				_Utils_Tuple2(
				'us_formattable',
				$elm$json$Json$Encode$bool(phone.Kl))
			]));
};
var $author$project$Api$Provider$DataExportConfiguration$create = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'data_export_configuration',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'enabled',
								$elm$json$Json$Encode$bool(fields.Ro)),
								_Utils_Tuple2(
								'contact_email',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Ow)),
								_Utils_Tuple2(
								'contact_phone',
								A2($author$project$Utils$Encode$nullable, $author$project$Api$Common$Phone$Shared$encode, fields.Oy)),
								_Utils_Tuple2(
								'destination',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Qt)),
								_Utils_Tuple2(
								'sftp_host',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.aa9)),
								_Utils_Tuple2(
								'sftp_port',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.aba)),
								_Utils_Tuple2(
								'sftp_username',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.abb)),
								_Utils_Tuple2(
								'sftp_private_key',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.JJ)),
								_Utils_Tuple2(
								's3_bucket',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.aal)),
								_Utils_Tuple2(
								's3_region',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.aam)),
								_Utils_Tuple2(
								'encryption_key',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Rs)),
								_Utils_Tuple2(
								'encryption_recipient',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Rt)),
								_Utils_Tuple2(
								'incremental_mode',
								$elm$json$Json$Encode$bool(fields.TW)),
								_Utils_Tuple2(
								'exclude_default_tables',
								$elm$json$Json$Encode$bool(fields.RR)),
								_Utils_Tuple2(
								'file_name_format',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.So))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$DataExportConfiguration$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$DataExportConfiguration$dataExportConfigurationsPath)));
	});
var $author$project$Components$Admin$DataExportConfiguration$Form$destinationToString = function (destination) {
	if (!destination) {
		return 'sftp';
	} else {
		return 's3';
	}
};
var $author$project$Api$Provider$DataExportConfiguration$Shared$contactEmail = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExportConfiguration$Shared$record,
	function ($) {
		return $.Ow;
	});
var $author$project$Api$Provider$DataExportConfiguration$One$contactEmail = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$DataExportConfiguration$Shared$contactEmail(shared);
};
var $author$project$Api$Provider$DataExportConfiguration$Shared$contactPhone = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExportConfiguration$Shared$record,
	function ($) {
		return $.Oy;
	});
var $author$project$Api$Provider$DataExportConfiguration$One$contactPhone = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$DataExportConfiguration$Shared$contactPhone(shared);
};
var $author$project$Api$Provider$DataExportConfiguration$One$destination = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$DataExportConfiguration$Shared$destination(shared);
};
var $author$project$Components$Admin$DataExportConfiguration$Form$S3 = 1;
var $author$project$Components$Admin$DataExportConfiguration$Form$Sftp = 0;
var $author$project$Components$Admin$DataExportConfiguration$Form$destinationFromString = function (string) {
	switch (string) {
		case 'sftp':
			return $elm$core$Maybe$Just(0);
		case 's3':
			return $elm$core$Maybe$Just(1);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$DataExportConfiguration$Shared$enabled = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExportConfiguration$Shared$record,
	function ($) {
		return $.Ro;
	});
var $author$project$Api$Provider$DataExportConfiguration$One$enabled = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$DataExportConfiguration$Shared$enabled(shared);
};
var $author$project$Api$Provider$DataExportConfiguration$Shared$encryptionKey = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExportConfiguration$Shared$record,
	function ($) {
		return $.Rs;
	});
var $author$project$Api$Provider$DataExportConfiguration$One$encryptionKey = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$DataExportConfiguration$Shared$encryptionKey(shared);
};
var $author$project$Api$Provider$DataExportConfiguration$Shared$encryptionRecipient = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExportConfiguration$Shared$record,
	function ($) {
		return $.Rt;
	});
var $author$project$Api$Provider$DataExportConfiguration$One$encryptionRecipient = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$DataExportConfiguration$Shared$encryptionRecipient(shared);
};
var $author$project$Api$Provider$DataExportConfiguration$Shared$excludeDefaultTables = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExportConfiguration$Shared$record,
	function ($) {
		return $.RR;
	});
var $author$project$Api$Provider$DataExportConfiguration$One$excludeDefaultTables = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$DataExportConfiguration$Shared$excludeDefaultTables(shared);
};
var $author$project$Api$Provider$DataExportConfiguration$Shared$fileNameFormat = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExportConfiguration$Shared$record,
	function ($) {
		return $.So;
	});
var $author$project$Api$Provider$DataExportConfiguration$One$fileNameFormat = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$DataExportConfiguration$Shared$fileNameFormat(shared);
};
var $author$project$Api$Provider$DataExportConfiguration$Shared$incrementalMode = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExportConfiguration$Shared$record,
	function ($) {
		return $.TW;
	});
var $author$project$Api$Provider$DataExportConfiguration$One$incrementalMode = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$DataExportConfiguration$Shared$incrementalMode(shared);
};
var $author$project$Api$Provider$DataExportConfiguration$Shared$manualExportPerformed = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExportConfiguration$Shared$record,
	function ($) {
		return $.Ws;
	});
var $author$project$Api$Provider$DataExportConfiguration$One$manualExportPerformed = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$DataExportConfiguration$Shared$manualExportPerformed(shared);
};
var $author$project$Api$Provider$DataExportConfiguration$One$s3Bucket = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$DataExportConfiguration$Shared$s3Bucket(shared);
};
var $author$project$Api$Provider$DataExportConfiguration$One$s3Region = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$DataExportConfiguration$Shared$s3Region(shared);
};
var $author$project$Api$Provider$DataExportConfiguration$One$sftpHost = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$DataExportConfiguration$Shared$sftpHost(shared);
};
var $author$project$Api$Provider$DataExportConfiguration$One$sftpPort = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$DataExportConfiguration$Shared$sftpPort(shared);
};
var $author$project$Api$Provider$DataExportConfiguration$One$sftpUsername = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$DataExportConfiguration$Shared$sftpUsername(shared);
};
var $author$project$Components$Admin$DataExportConfiguration$Form$formFieldsInit = function (dataExportConfiguration) {
	var encryptionKey = $author$project$Api$Provider$DataExportConfiguration$One$encryptionKey(dataExportConfiguration);
	return {
		Ow: $author$project$Api$Provider$DataExportConfiguration$One$contactEmail(dataExportConfiguration),
		Oy: $author$project$Components$Admin$DataExportConfiguration$Form$initPhoneInput(
			$author$project$Api$Provider$DataExportConfiguration$One$contactPhone(dataExportConfiguration)),
		Qt: $author$project$Components$Admin$DataExportConfiguration$Form$destinationFromString(
			$author$project$Api$Provider$DataExportConfiguration$One$destination(dataExportConfiguration)),
		Ro: $author$project$Api$Provider$DataExportConfiguration$One$enabled(dataExportConfiguration),
		jD: !_Utils_eq(encryptionKey, $elm$core$Maybe$Nothing),
		Rs: encryptionKey,
		Rt: $author$project$Api$Provider$DataExportConfiguration$One$encryptionRecipient(dataExportConfiguration),
		RR: $author$project$Api$Provider$DataExportConfiguration$One$excludeDefaultTables(dataExportConfiguration),
		So: $elm$core$Maybe$Just(
			$author$project$Api$Provider$DataExportConfiguration$One$fileNameFormat(dataExportConfiguration)),
		nY: $author$project$Api$Provider$DataExportConfiguration$One$incrementalMode(dataExportConfiguration),
		Ws: $author$project$Api$Provider$DataExportConfiguration$One$manualExportPerformed(dataExportConfiguration),
		aal: $author$project$Api$Provider$DataExportConfiguration$One$s3Bucket(dataExportConfiguration),
		aam: $author$project$Api$Provider$DataExportConfiguration$One$s3Region(dataExportConfiguration),
		aa9: $author$project$Api$Provider$DataExportConfiguration$One$sftpHost(dataExportConfiguration),
		aba: $author$project$Api$Provider$DataExportConfiguration$One$sftpPort(dataExportConfiguration),
		JJ: $elm$core$Maybe$Nothing,
		ux: true,
		abb: $author$project$Api$Provider$DataExportConfiguration$One$sftpUsername(dataExportConfiguration)
	};
};
var $author$project$Components$Admin$DataExportConfiguration$Form$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var bool = field.a;
				return _Utils_update(
					fields,
					{Ro: bool});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Ow: $author$project$Utils$String$toMaybe(string)
					});
			case 2:
				var phone = field.a;
				return _Utils_update(
					fields,
					{Oy: phone});
			case 3:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Qt: $author$project$Components$Admin$DataExportConfiguration$Form$destinationFromString(string)
					});
			case 4:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						aa9: $author$project$Utils$String$toMaybe(string)
					});
			case 5:
				var _int = field.a;
				return _Utils_update(
					fields,
					{
						aba: $elm$core$String$toInt(_int)
					});
			case 6:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						abb: $author$project$Utils$String$toMaybe(string)
					});
			case 7:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						JJ: $author$project$Utils$String$toMaybe(string)
					});
			case 8:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						aal: $author$project$Utils$String$toMaybe(string)
					});
			case 9:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						aam: $author$project$Utils$String$toMaybe(string)
					});
			case 10:
				var bool = field.a;
				return _Utils_update(
					fields,
					{jD: bool});
			case 11:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Rs: $author$project$Utils$String$toMaybe(string)
					});
			case 12:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Rt: $author$project$Utils$String$toMaybe(string)
					});
			case 13:
				var bool = field.a;
				return _Utils_update(
					fields,
					{nY: bool});
			case 14:
				var bool = field.a;
				return _Utils_update(
					fields,
					{RR: bool});
			default:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						So: $author$project$Utils$String$toMaybe(string)
					});
		}
	});
var $author$project$Components$PhoneInput$PhoneValidation = $elm$core$Basics$identity;
var $author$project$Components$PhoneInput$phoneMask = '(###) ###-####';
var $author$project$Components$PhoneInput$phonePattern = $agustinrhcp$elm_mask$Mask$fromString($author$project$Components$PhoneInput$phoneMask);
var $author$project$Components$PhoneInput$phoneIncomplete = F2(
	function (phoneNumber, phoneRegion) {
		if (!phoneRegion) {
			var maskedPhone = A2($agustinrhcp$elm_mask$Mask$mask, $author$project$Components$PhoneInput$phonePattern, phoneNumber);
			return ($elm$core$String$length(maskedPhone) > 0) && (!_Utils_eq(
				$elm$core$String$length($author$project$Components$PhoneInput$phoneMask),
				$elm$core$String$length(maskedPhone)));
		} else {
			return false;
		}
	});
var $author$project$Components$PhoneInput$validatePhone = F3(
	function (isRequired, index, _v0) {
		var phone = _v0.a;
		return A2($author$project$Components$PhoneInput$phoneIncomplete, phone.IO, phone.akD) ? _List_fromArray(
			[
				_Utils_Tuple2(index, 'Please enter a valid phone number.')
			]) : (((!index) && (isRequired && $elm$core$String$isEmpty(phone.IO))) ? _List_fromArray(
			[
				_Utils_Tuple2(index, 'Please enter a phone number.')
			]) : _List_Nil);
	});
var $author$project$Components$PhoneInput$validatePhones = F2(
	function (isRequired, phones) {
		return $elm$core$List$concat(
			A2(
				$elm$core$List$indexedMap,
				$author$project$Components$PhoneInput$validatePhone(isRequired),
				phones));
	});
var $author$project$Components$PhoneInput$formFieldsValidator = function (isRequired) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$PhoneInput$validatePhones(isRequired))
			]));
};
var $author$project$Components$PhoneInput$getPhones = function (_v0) {
	var model = _v0;
	var _v1 = A2(
		$author$project$Utils$Form$validate,
		$author$project$Components$PhoneInput$formFieldsValidator(model.akR),
		model.SD);
	if (!_v1.$) {
		var _v2 = _v1.a;
		var formFields = _v2.b;
		return $elm$core$Maybe$Just(
			A2(
				$elm$core$List$map,
				function (_v3) {
					var phone = _v3.a;
					return phone;
				},
				$rtfeldman$elm_validate$Validate$fromValid(formFields)));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Admin$DataExportConfiguration$ExportModal$GotPreview = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$ExportModal$Model = $elm$core$Basics$identity;
var $author$project$Api$Provider$DataExportConfiguration$export = F4(
	function (apiClient, id, _v0, toMsg) {
		var preview = _v0.akd;
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'preview',
					$elm$json$Json$Encode$bool(preview))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$DataExportGroup$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['export']),
						$author$project$Api$Provider$DataExportConfiguration$dataExportConfigurationPath(id)))));
	});
var $author$project$Components$Admin$DataExportConfiguration$ExportModal$init = F2(
	function (apiClient, dataExportConfigurationId) {
		return _Utils_Tuple2(
			{iN: false, Hf: dataExportConfigurationId, nE: $author$project$Api$Data$NotAsked, t2: $author$project$Api$Data$Loading},
			A4(
				$author$project$Api$Provider$DataExportConfiguration$export,
				apiClient,
				dataExportConfigurationId,
				{akd: true},
				$author$project$Components$Admin$DataExportConfiguration$ExportModal$GotPreview));
	});
var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$NotTested = {$: 0};
var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$init = function (dataExportConfiguration) {
	return {Px: dataExportConfiguration, lM: $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$NotTested};
};
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $author$project$Utils$Phone$toRecord = function (phone) {
	var usFormattable = function () {
		var _v0 = phone.akD;
		if (!_v0) {
			return true;
		} else {
			return false;
		}
	}();
	return {IO: phone.IO, amg: phone.amg, Kl: usFormattable};
};
var $author$project$Api$Provider$DataExportConfiguration$One$toShared = function (_v0) {
	var shared = _v0;
	return shared;
};
var $author$project$Api$Provider$DataExportConfiguration$update = F4(
	function (apiClient, id, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'data_export_configuration',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'enabled',
								$elm$json$Json$Encode$bool(fields.Ro)),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'contact_email',
									A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Ow)),
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										'contact_phone',
										A2($author$project$Utils$Encode$nullable, $author$project$Api$Common$Phone$Shared$encode, fields.Oy)),
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(
											'destination',
											A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Qt)),
										A2(
											$elm$core$List$cons,
											_Utils_Tuple2(
												'sftp_host',
												A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.aa9)),
											A2(
												$elm$core$List$cons,
												_Utils_Tuple2(
													'sftp_port',
													A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.aba)),
												A2(
													$elm$core$List$cons,
													_Utils_Tuple2(
														'sftp_username',
														A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.abb)),
													A2(
														$elm$core$List$cons,
														_Utils_Tuple2(
															's3_bucket',
															A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.aal)),
														A2(
															$elm$core$List$cons,
															_Utils_Tuple2(
																's3_region',
																A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.aam)),
															A2(
																$elm$core$List$cons,
																_Utils_Tuple2(
																	'encryption_key',
																	A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Rs)),
																A2(
																	$elm$core$List$cons,
																	_Utils_Tuple2(
																		'encryption_recipient',
																		A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Rt)),
																	A2(
																		$elm$core$List$cons,
																		_Utils_Tuple2(
																			'incremental_mode',
																			$elm$json$Json$Encode$bool(fields.TW)),
																		A2(
																			$elm$core$List$cons,
																			_Utils_Tuple2(
																				'exclude_default_tables',
																				$elm$json$Json$Encode$bool(fields.RR)),
																			A2(
																				$elm$core$List$cons,
																				_Utils_Tuple2(
																					'file_name_format',
																					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.So)),
																				_Utils_eq(fields.JJ, $elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray(
																					[
																						_Utils_Tuple2(
																						'sftp_private_key',
																						A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.JJ))
																					])))))))))))))))))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$DataExportConfiguration$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$DataExportConfiguration$dataExportConfigurationPath(id))));
	});
var $author$project$Components$Admin$DataExportConfiguration$ExportModal$Closed = 1;
var $author$project$Components$Admin$DataExportConfiguration$ExportModal$Exported = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$ExportModal$Exporting = 2;
var $author$project$Components$Admin$DataExportConfiguration$ExportModal$None = 0;
var $author$project$Components$Admin$DataExportConfiguration$ExportModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: 1, aiO: model, aR: _List_Nil};
			case 2:
				var response = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{t2: response}),
					aR: $author$project$OutMsg$handleErrorResponse(response)
				};
			case 1:
				return model.iN ? {
					GZ: A4(
						$author$project$Api$Provider$DataExportConfiguration$export,
						apiClient,
						model.Hf,
						{akd: false},
						$author$project$Components$Admin$DataExportConfiguration$ExportModal$Exported),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{nE: $author$project$Api$Data$Loading}),
					aR: _List_Nil
				} : {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 2,
						aiO: _Utils_update(
							model,
							{nE: response}),
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Export is being generated.')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{nE: response}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			default:
				var bool = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{iN: bool}),
					aR: _List_Nil
				};
		}
	});
var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$Closed = 1;
var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$Failed = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$None = 0;
var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$Success = {$: 2};
var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$Testing = {$: 1};
var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$TestConnectionResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$DataExportConfiguration$Shared$id = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExportConfiguration$Shared$record,
	function ($) {
		return $.ahP;
	});
var $author$project$Api$Provider$DataExportConfiguration$testConnection = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$elm$json$Json$Decode$bool,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['test_connection']),
					$author$project$Api$Provider$DataExportConfiguration$dataExportConfigurationPath(id))));
	});
var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$testConnectionCmd = F2(
	function (apiClient, dataExportConfiguration) {
		return A3(
			$author$project$Api$Provider$DataExportConfiguration$testConnection,
			apiClient,
			$author$project$Api$Provider$DataExportConfiguration$Shared$id(dataExportConfiguration),
			$author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$TestConnectionResponse);
	});
var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: 1, aiO: model, aR: _List_Nil};
			case 1:
				return {
					GZ: A2($author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$testConnectionCmd, apiClient, model.Px),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{lM: $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$Testing}),
					aR: _List_Nil
				};
			default:
				var response = msg.a;
				switch (response.$) {
					case 3:
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 0,
							aiO: _Utils_update(
								model,
								{lM: $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$Success}),
							aR: _List_Nil
						};
					case 2:
						var error = response.a;
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 0,
							aiO: _Utils_update(
								model,
								{
									lM: $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$Failed(
										$author$project$Api$Data$errorToString(error))
								}),
							aR: _List_Nil
						};
					default:
						return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
		}
	});
var $author$project$Components$PhoneInput$Phones = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$PhoneInput$numPhoneMaskDigits = $elm$core$String$length(
	A2(
		$elm$core$String$filter,
		function (c) {
			return c === '#';
		},
		$author$project$Components$PhoneInput$phoneMask));
var $author$project$Components$PhoneInput$clipPhoneNumberToMask = F2(
	function (phoneNumber, phoneRegion) {
		return ((!phoneRegion) && (_Utils_cmp(
			$elm$core$String$length(phoneNumber),
			$author$project$Components$PhoneInput$numPhoneMaskDigits) > 0)) ? A2($elm$core$String$left, $author$project$Components$PhoneInput$numPhoneMaskDigits, phoneNumber) : phoneNumber;
	});
var $author$project$Formatters$PhoneType$fromString = function (string) {
	switch (string) {
		case 'Mobile':
			return $author$project$Api$Common$Phone$Shared$Mobile;
		case 'Home':
			return $author$project$Api$Common$Phone$Shared$Home;
		case 'Office':
			return $author$project$Api$Common$Phone$Shared$Office;
		default:
			var otherDescription = string;
			return $author$project$Api$Common$Phone$Shared$Other(otherDescription);
	}
};
var $author$project$Components$PhoneInput$formFieldsUpdate = F2(
	function (field, phones) {
		switch (field.$) {
			case 0:
				var phones_ = field.a;
				return phones_;
			case 1:
				var index = field.a;
				var type_ = field.b;
				return A3(
					$elm_community$list_extra$List$Extra$updateAt,
					index,
					function (_v1) {
						var phone = _v1.a;
						var typeDropdown = _v1.b;
						var regionDropdown = _v1.c;
						return _Utils_Tuple3(
							_Utils_update(
								phone,
								{
									amg: $author$project$Formatters$PhoneType$fromString(type_)
								}),
							typeDropdown,
							regionDropdown);
					},
					phones);
			case 2:
				var index = field.a;
				var region = field.b;
				return A3(
					$elm_community$list_extra$List$Extra$updateAt,
					index,
					function (_v2) {
						var phone = _v2.a;
						var typeDropdown = _v2.b;
						var regionDropdown = _v2.c;
						return _Utils_Tuple3(
							_Utils_update(
								phone,
								{
									IO: A2($author$project$Components$PhoneInput$clipPhoneNumberToMask, phone.IO, region),
									akD: region
								}),
							typeDropdown,
							regionDropdown);
					},
					phones);
			default:
				var index = field.a;
				var number = field.b;
				return A3(
					$elm_community$list_extra$List$Extra$updateAt,
					index,
					function (_v3) {
						var phone = _v3.a;
						var typeDropdown = _v3.b;
						var regionDropdown = _v3.c;
						return _Utils_Tuple3(
							_Utils_update(
								phone,
								{IO: number}),
							typeDropdown,
							regionDropdown);
					},
					phones);
		}
	});
var $author$project$Components$PhoneInput$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var phones = $author$project$Utils$Form$fields(model.SD);
				var lastIndex = $elm$core$List$length(phones);
				var newPhones = _Utils_ap(
					phones,
					_List_fromArray(
						[
							_Utils_Tuple3(
							$author$project$Components$PhoneInput$emptyPhone(model.agl),
							$author$project$Ui$Dropdown$init(
								$author$project$Ui$Dropdown$defaultConfig(
									{
										ahP: A2($author$project$Components$PhoneInput$phoneTypeDropdownId, model.ahP, lastIndex),
										al6: $author$project$Components$PhoneInput$PhoneTypeDropdownMsg(lastIndex)
									})),
							$author$project$Ui$Dropdown$init(
								$author$project$Ui$Dropdown$defaultConfig(
									{
										ahP: A2($author$project$Components$PhoneInput$phoneRegionDropdownId, model.ahP, lastIndex),
										al6: $author$project$Components$PhoneInput$PhoneRegionDropdownMsg(lastIndex)
									})))
						]));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							SD: A3(
								$author$project$Utils$Form$update,
								$author$project$Components$PhoneInput$formFieldsUpdate,
								$author$project$Components$PhoneInput$Phones(newPhones),
								model.SD)
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var index = msg.a;
				var phones = $author$project$Utils$Form$fields(model.SD);
				var newPhones = A2($elm_community$list_extra$List$Extra$removeAt, index, phones);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							SD: A3(
								$author$project$Utils$Form$update,
								$author$project$Components$PhoneInput$formFieldsUpdate,
								$author$project$Components$PhoneInput$Phones(newPhones),
								model.SD)
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$PhoneInput$formFieldsUpdate, field, model.SD);
				var validatedForm = function () {
					var _v2 = A2(
						$author$project$Utils$Form$validate,
						$author$project$Components$PhoneInput$formFieldsValidator(model.akR),
						newForm);
					if (!_v2.$) {
						var _v3 = _v2.a;
						var form = _v3.a;
						return form;
					} else {
						var form = _v2.a;
						return form;
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{SD: validatedForm}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var index = msg.a;
				var dropdownMsg = msg.b;
				var phones = $author$project$Utils$Form$fields(model.SD);
				var maybePhone = A2($elm_community$list_extra$List$Extra$getAt, index, phones);
				var _v4 = function () {
					if (!maybePhone.$) {
						var _v6 = maybePhone.a;
						var phone = _v6.a;
						var typeDropdown = _v6.b;
						var regionDropdown = _v6.c;
						var _v7 = A2($author$project$Ui$Dropdown$update, dropdownMsg, typeDropdown);
						var updatedTypeDropdown = _v7.a;
						var dropdownCmd = _v7.b;
						var updatedPhonesList = A3(
							$elm_community$list_extra$List$Extra$setAt,
							index,
							_Utils_Tuple3(phone, updatedTypeDropdown, regionDropdown),
							phones);
						return _Utils_Tuple2(updatedPhonesList, dropdownCmd);
					} else {
						return _Utils_Tuple2(phones, $elm$core$Platform$Cmd$none);
					}
				}();
				var updatedPhones = _v4.a;
				var cmd = _v4.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							SD: A3(
								$author$project$Utils$Form$update,
								$author$project$Components$PhoneInput$formFieldsUpdate,
								$author$project$Components$PhoneInput$Phones(updatedPhones),
								model.SD)
						}),
					cmd);
			default:
				var index = msg.a;
				var dropdownMsg = msg.b;
				var phones = $author$project$Utils$Form$fields(model.SD);
				var maybePhone = A2($elm_community$list_extra$List$Extra$getAt, index, phones);
				var _v8 = function () {
					if (!maybePhone.$) {
						var _v10 = maybePhone.a;
						var phone = _v10.a;
						var typeDropdown = _v10.b;
						var regionDropdown = _v10.c;
						var _v11 = A2($author$project$Ui$Dropdown$update, dropdownMsg, regionDropdown);
						var updatedRegionDropdown = _v11.a;
						var dropdownCmd = _v11.b;
						var updatedPhonesList = A3(
							$elm_community$list_extra$List$Extra$setAt,
							index,
							_Utils_Tuple3(phone, typeDropdown, updatedRegionDropdown),
							phones);
						return _Utils_Tuple2(updatedPhonesList, dropdownCmd);
					} else {
						return _Utils_Tuple2(phones, $elm$core$Platform$Cmd$none);
					}
				}();
				var updatedPhones = _v8.a;
				var cmd = _v8.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							SD: A3(
								$author$project$Utils$Form$update,
								$author$project$Components$PhoneInput$formFieldsUpdate,
								$author$project$Components$PhoneInput$Phones(updatedPhones),
								model.SD)
						}),
					cmd);
		}
	});
var $author$project$Components$Admin$DataExportConfiguration$Form$ContactEmailValidation = 0;
var $author$project$Components$Admin$DataExportConfiguration$Form$DestinationValidation = 2;
var $author$project$Components$Admin$DataExportConfiguration$Form$EncryptionKeyValidation = 9;
var $author$project$Components$Admin$DataExportConfiguration$Form$EncryptionRecipientValidation = 10;
var $author$project$Components$Admin$DataExportConfiguration$Form$S3BucketValidation = 7;
var $author$project$Components$Admin$DataExportConfiguration$Form$S3RegionValidation = 8;
var $author$project$Components$Admin$DataExportConfiguration$Form$SftpHostValidation = 3;
var $author$project$Components$Admin$DataExportConfiguration$Form$SftpPortValidation = 4;
var $author$project$Components$Admin$DataExportConfiguration$Form$SftpUsernameValidation = 5;
var $rtfeldman$elm_validate$Validate$validEmail = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	A2(
		$elm$regex$Regex$fromStringWith,
		{afu: true, aiR: false},
		'^[a-zA-Z0-9.!#$%&\'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$'));
var $rtfeldman$elm_validate$Validate$isValidEmail = function (email) {
	return A2($elm$regex$Regex$contains, $rtfeldman$elm_validate$Validate$validEmail, email);
};
var $author$project$Utils$Validate$isInvalidEmail = F2(
	function (options, email) {
		if (!email.$) {
			var email_ = email.a;
			return $rtfeldman$elm_validate$Validate$isBlank(email_) ? (!options.aeT) : (!$rtfeldman$elm_validate$Validate$isValidEmail(email_));
		} else {
			return !options.aeT;
		}
	});
var $author$project$Utils$Validate$ifInvalidEmail = F3(
	function (options, subjectToEmail, error) {
		return A2(
			$rtfeldman$elm_validate$Validate$ifTrue,
			function (subject) {
				return A2(
					$author$project$Utils$Validate$isInvalidEmail,
					options,
					subjectToEmail(subject));
			},
			error);
	});
var $author$project$Components$Admin$DataExportConfiguration$Form$ContactPhoneValidation = 1;
var $author$project$Components$PhoneInput$hasErrors = function (_v0) {
	var model = _v0;
	return $author$project$Utils$Form$hasAnyValidationError(model.SD);
};
var $author$project$Components$Admin$DataExportConfiguration$Form$validatePhone = function (_v0) {
	var contactPhone = _v0.Oy;
	return $author$project$Components$PhoneInput$hasErrors(contactPhone) ? _List_fromArray(
		[
			_Utils_Tuple2(1, '')
		]) : _List_Nil;
};
var $author$project$Components$Admin$DataExportConfiguration$Form$SftpPrivateKeyValidation = 6;
var $author$project$Components$Admin$DataExportConfiguration$Form$validateSftpPrivateKey = function (_v0) {
	var sftpPrivateKey = _v0.JJ;
	var sftpPrivateKeyAlreadySaved = _v0.ux;
	return (_Utils_eq(sftpPrivateKey, $elm$core$Maybe$Nothing) && (!sftpPrivateKeyAlreadySaved)) ? _List_fromArray(
		[
			_Utils_Tuple2(6, 'Please enter an SFTP private key.')
		]) : _List_Nil;
};
var $author$project$Components$Admin$DataExportConfiguration$Form$formFieldsValidator = F2(
	function (destination, encryptionEnabled) {
		return $rtfeldman$elm_validate$Validate$all(
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A3(
							$author$project$Utils$Validate$ifInvalidEmail,
							{aeT: false},
							function ($) {
								return $.Ow;
							},
							_Utils_Tuple2(0, 'Please enter a contact email.')),
							$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$DataExportConfiguration$Form$validatePhone),
							A2(
							$rtfeldman$elm_validate$Validate$ifNothing,
							function ($) {
								return $.Qt;
							},
							_Utils_Tuple2(2, 'Please select a destination.'))
						]),
						function () {
						if (!destination.$) {
							if (!destination.a) {
								var _v1 = destination.a;
								return _List_fromArray(
									[
										A2(
										$rtfeldman$elm_validate$Validate$ifNothing,
										function ($) {
											return $.aa9;
										},
										_Utils_Tuple2(3, 'Please enter an SFTP host.')),
										A2(
										$rtfeldman$elm_validate$Validate$ifNothing,
										function ($) {
											return $.aba;
										},
										_Utils_Tuple2(4, 'Please enter an SFTP port.')),
										A2(
										$rtfeldman$elm_validate$Validate$ifNothing,
										function ($) {
											return $.abb;
										},
										_Utils_Tuple2(5, 'Please enter an SFTP username.')),
										$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$DataExportConfiguration$Form$validateSftpPrivateKey)
									]);
							} else {
								var _v2 = destination.a;
								return _List_fromArray(
									[
										A2(
										$rtfeldman$elm_validate$Validate$ifNothing,
										function ($) {
											return $.aal;
										},
										_Utils_Tuple2(7, 'Please enter an S3 bucket.')),
										A2(
										$rtfeldman$elm_validate$Validate$ifNothing,
										function ($) {
											return $.aam;
										},
										_Utils_Tuple2(8, 'Please enter an S3 region.'))
									]);
							}
						} else {
							return _List_Nil;
						}
					}(),
						encryptionEnabled ? _List_fromArray(
						[
							A2(
							$rtfeldman$elm_validate$Validate$ifNothing,
							function ($) {
								return $.Rs;
							},
							_Utils_Tuple2(9, 'Please enter an encryption key.')),
							A2(
							$rtfeldman$elm_validate$Validate$ifNothing,
							function ($) {
								return $.Rt;
							},
							_Utils_Tuple2(10, 'Please enter an encryption recipient.'))
						]) : _List_Nil
					])));
	});
var $author$project$Utils$Result$merge = function (result) {
	if (!result.$) {
		var ok = result.a;
		return ok;
	} else {
		var err = result.a;
		return err;
	}
};
var $author$project$Components$PhoneInput$validate = function (_v0) {
	var model = _v0;
	return $author$project$Utils$Result$merge(
		A2(
			$elm$core$Result$map,
			function (_v1) {
				var form = _v1.a;
				return _Utils_update(
					model,
					{SD: form});
			},
			A2(
				$elm$core$Result$mapError,
				function (form) {
					return _Utils_update(
						model,
						{SD: form});
				},
				A2(
					$author$project$Utils$Form$validate,
					$author$project$Components$PhoneInput$formFieldsValidator(model.akR),
					model.SD))));
};
var $author$project$Components$Admin$DataExportConfiguration$Form$validate = function (model) {
	var _v0 = model.SD;
	if (!_v0.$) {
		var form = _v0.a;
		var fields = $author$project$Utils$Form$fields(form);
		var formWithValidatedPhone = A2(
			$author$project$Utils$Form$set,
			_Utils_update(
				fields,
				{
					Oy: $author$project$Components$PhoneInput$validate(fields.Oy)
				}),
			form);
		var _v1 = fields;
		var destination = _v1.Qt;
		var encryptionEnabled = _v1.jD;
		return A2(
			$elm$core$Result$mapError,
			function (validatedForm) {
				return _Utils_update(
					model,
					{
						SD: $elm$core$Maybe$Just(validatedForm)
					});
			},
			A2(
				$elm$core$Result$map,
				function (_v2) {
					var validatedForm = _v2.a;
					var validFormFields = _v2.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								SD: $elm$core$Maybe$Just(validatedForm)
							}),
						validFormFields);
				},
				A2(
					$author$project$Utils$Form$validate,
					A2($author$project$Components$Admin$DataExportConfiguration$Form$formFieldsValidator, destination, encryptionEnabled),
					formWithValidatedPhone)));
	} else {
		return $elm$core$Result$Err(model);
	}
};
var $author$project$Components$Admin$DataExportConfiguration$Form$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var dataExportConfiguration = response.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Admin$DataExportConfiguration$Form$None,
						aiO: _Utils_update(
							model,
							{
								Px: response,
								SD: $elm$core$Maybe$Just(
									$author$project$Utils$Form$init(
										$author$project$Components$Admin$DataExportConfiguration$Form$formFieldsInit(dataExportConfiguration)))
							}),
						aR: _List_Nil
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Admin$DataExportConfiguration$Form$None,
						aiO: model,
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 1:
				var field = msg.a;
				var _v3 = model.SD;
				if (!_v3.$) {
					var form = _v3.a;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Admin$DataExportConfiguration$Form$formFieldsUpdate, field, form);
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Admin$DataExportConfiguration$Form$None,
						aiO: _Utils_update(
							model,
							{
								SD: $elm$core$Maybe$Just(newForm)
							}),
						aR: _List_Nil
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$Admin$DataExportConfiguration$Form$None, aiO: model, aR: _List_Nil};
				}
			case 2:
				var _v4 = $author$project$Components$Admin$DataExportConfiguration$Form$validate(model);
				if (!_v4.$) {
					var _v5 = _v4.a;
					var newModel = _v5.a;
					var validFormFields = _v5.b;
					var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
					var phoneNumber = A2(
						$elm$core$Maybe$map,
						$author$project$Utils$Phone$toRecord,
						$elm$core$List$head(
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								$author$project$Components$PhoneInput$getPhones(fields.Oy))));
					var apiFields = {
						Ow: fields.Ow,
						Oy: phoneNumber,
						Qt: A2($elm$core$Maybe$map, $author$project$Components$Admin$DataExportConfiguration$Form$destinationToString, fields.Qt),
						Ro: fields.Ro,
						Rs: fields.Rs,
						Rt: fields.Rt,
						RR: fields.RR,
						So: fields.So,
						TW: fields.nY,
						aal: fields.aal,
						aam: fields.aam,
						aa9: fields.aa9,
						aba: fields.aba,
						JJ: fields.JJ,
						abb: fields.abb
					};
					var cmd = function () {
						var _v6 = model.ahP;
						if (!_v6.$) {
							var id = _v6.a;
							return A4($author$project$Api$Provider$DataExportConfiguration$update, apiClient, id, apiFields, $author$project$Components$Admin$DataExportConfiguration$Form$GotDataExportConfigurationSaved);
						} else {
							return A3($author$project$Api$Provider$DataExportConfiguration$create, apiClient, apiFields, $author$project$Components$Admin$DataExportConfiguration$Form$GotDataExportConfigurationSaved);
						}
					}();
					return {
						GZ: cmd,
						agZ: $author$project$Components$Admin$DataExportConfiguration$Form$None,
						aiO: _Utils_update(
							newModel,
							{k9: $author$project$Api$Data$Loading}),
						aR: _List_Nil
					};
				} else {
					var newModel = _v4.a;
					return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$Admin$DataExportConfiguration$Form$None, aiO: newModel, aR: _List_Nil};
				}
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					var dataExportConfiguration = response.a;
					var successMsg = function () {
						var _v8 = model.ahP;
						if (!_v8.$) {
							return 'Settings updated successfully';
						} else {
							return 'Settings created successfully';
						}
					}();
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Admin$DataExportConfiguration$Form$Saved(dataExportConfiguration),
						aiO: _Utils_update(
							model,
							{
								SD: $elm$core$Maybe$Just(
									$author$project$Utils$Form$init(
										$author$project$Components$Admin$DataExportConfiguration$Form$formFieldsInit(dataExportConfiguration))),
								k9: response
							}),
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, successMsg)
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Admin$DataExportConfiguration$Form$None,
						aiO: _Utils_update(
							model,
							{k9: response}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 4:
				var _v9 = model.Px;
				if (_v9.$ === 3) {
					var dataExportConfiguration = _v9.a;
					var modalModel = $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$init(
						$author$project$Api$Provider$DataExportConfiguration$One$toShared(dataExportConfiguration));
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Admin$DataExportConfiguration$Form$None,
						aiO: _Utils_update(
							model,
							{
								lL: $elm$core$Maybe$Just(modalModel)
							}),
						aR: _List_Nil
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$Admin$DataExportConfiguration$Form$None, aiO: model, aR: _List_Nil};
				}
			case 5:
				var subMsg = msg.a;
				var _v10 = model.lL;
				if (!_v10.$) {
					var modalModel = _v10.a;
					var testConnectionModalResult = A3($author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$update, apiClient, subMsg, modalModel);
					var testConnectionModal = function () {
						var _v11 = testConnectionModalResult.agZ;
						if (!_v11) {
							return $elm$core$Maybe$Just(testConnectionModalResult.aiO);
						} else {
							return $elm$core$Maybe$Nothing;
						}
					}();
					return {
						GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$DataExportConfiguration$Form$TestConnectionModalMsg, testConnectionModalResult.GZ),
						agZ: $author$project$Components$Admin$DataExportConfiguration$Form$None,
						aiO: _Utils_update(
							model,
							{lL: testConnectionModal}),
						aR: testConnectionModalResult.aR
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$Admin$DataExportConfiguration$Form$None, aiO: model, aR: _List_Nil};
				}
			case 6:
				var subMsg = msg.a;
				var _v12 = model.SD;
				if (!_v12.$) {
					var form = _v12.a;
					var _v13 = $author$project$Utils$Form$fields(form);
					var contactPhone = _v13.Oy;
					var _v14 = A2($author$project$Components$PhoneInput$update, subMsg, contactPhone);
					var phoneInput = _v14.a;
					var cmd = _v14.b;
					var newForm = A3(
						$author$project$Utils$Form$update,
						$author$project$Components$Admin$DataExportConfiguration$Form$formFieldsUpdate,
						$author$project$Components$Admin$DataExportConfiguration$Form$ContactPhone(phoneInput),
						form);
					return {
						GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$DataExportConfiguration$Form$ContactPhoneInputMsg, cmd),
						agZ: $author$project$Components$Admin$DataExportConfiguration$Form$None,
						aiO: _Utils_update(
							model,
							{
								SD: $elm$core$Maybe$Just(newForm)
							}),
						aR: _List_Nil
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$Admin$DataExportConfiguration$Form$None, aiO: model, aR: _List_Nil};
				}
			case 7:
				var _v15 = function () {
					var _v16 = model.ahP;
					if (!_v16.$) {
						var id = _v16.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Platform$Cmd$map($author$project$Components$Admin$DataExportConfiguration$Form$ExportModalMsg),
							A2(
								$elm$core$Tuple$mapFirst,
								$elm$core$Maybe$Just,
								A2($author$project$Components$Admin$DataExportConfiguration$ExportModal$init, apiClient, id)));
					} else {
						return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
					}
				}();
				var exportModal = _v15.a;
				var exportModalCmd = _v15.b;
				return {
					GZ: exportModalCmd,
					agZ: $author$project$Components$Admin$DataExportConfiguration$Form$None,
					aiO: _Utils_update(
						model,
						{jI: exportModal}),
					aR: _List_Nil
				};
			default:
				var subMsg = msg.a;
				var _v17 = model.jI;
				if (!_v17.$) {
					var exportModal = _v17.a;
					var exportModalResult = A3($author$project$Components$Admin$DataExportConfiguration$ExportModal$update, apiClient, subMsg, exportModal);
					var updatedExportModal = function () {
						var _v18 = exportModalResult.agZ;
						switch (_v18) {
							case 0:
								return $elm$core$Maybe$Just(exportModalResult.aiO);
							case 1:
								return $elm$core$Maybe$Nothing;
							default:
								return $elm$core$Maybe$Nothing;
						}
					}();
					return {
						GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$DataExportConfiguration$Form$ExportModalMsg, exportModalResult.GZ),
						agZ: $author$project$Components$Admin$DataExportConfiguration$Form$None,
						aiO: _Utils_update(
							model,
							{jI: updatedExportModal}),
						aR: exportModalResult.aR
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$Admin$DataExportConfiguration$Form$None, aiO: model, aR: _List_Nil};
				}
		}
	});
var $author$project$Pages$Admin$DataExportSettings$Id_String$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var dataExportConfigurationFormResult = A3($author$project$Components$Admin$DataExportConfiguration$Form$update, model.Gv, subMsg, model.SD);
		var cmd = function () {
			var _v1 = dataExportConfigurationFormResult.agZ;
			if (_v1.$ === 1) {
				return $elm$core$Platform$Cmd$none;
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		}();
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{SD: dataExportConfigurationFormResult.aiO}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, dataExportConfigurationFormResult.GZ),
						cmd
					])),
			dataExportConfigurationFormResult.aR);
	});
var $author$project$Components$Admin$DataExportConfiguration$Form$UpdateDataExportConfiguration = {$: 2};
var $author$project$Components$Admin$DataExportConfiguration$Form$backRoute = function (model) {
	return model.uL ? $author$project$Spa$Generated$Route$Admin__DataExport__Top : $author$project$Spa$Generated$Route$Admin__DataExportSettings__Top;
};
var $author$project$Components$Admin$DataExportConfiguration$ExportModal$Export = {$: 1};
var $author$project$Components$Admin$DataExportConfiguration$ExportModal$ConfirmUpdated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$ExportModal$viewConfirmInput = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Checkbox$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Checkbox$value(model.iN),
						$author$project$Ui$Form$Checkbox$required(true),
						$author$project$Ui$Form$Checkbox$onCheck($author$project$Components$Admin$DataExportConfiguration$ExportModal$ConfirmUpdated)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('By checking this box I confirm that I have verified that both'),
								$elm$html$Html$text(' the files to be sent and the destination server and path are accurate')
							]))
					]))
			]));
};
var $author$project$Api$Provider$DataExportGroup$One$dataExportConfiguration = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$DataExportGroup$Shared$dataExportConfiguration(shared);
};
var $author$project$Api$Provider$DataExportGroup$One$dataExports = function (_v0) {
	var record = _v0.b;
	return record.Pz;
};
var $author$project$Api$Provider$DataExportGroup$One$entityName = function (_v0) {
	var record = _v0.b;
	return record.RH;
};
var $author$project$Components$Admin$DataExportConfiguration$ExportModal$viewDataExport = function (dataExport) {
	return A2(
		$elm$html$Html$li,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				A2(
					$elm$core$Maybe$withDefault,
					'N/A',
					$author$project$Api$Provider$DataExport$Shared$exportFileName(dataExport)))
			]));
};
var $author$project$Components$Admin$DataExportConfiguration$ExportModal$viewPreview = function (previewRequest) {
	if (previewRequest.$ === 3) {
		var dataExportGroup = previewRequest.a;
		var dataExportConfiguration = $author$project$Api$Provider$DataExportGroup$One$dataExportConfiguration(dataExportGroup);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-2')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('The platform will send the following files to the given destination.')
						])),
					A2(
					$author$project$Ui$Typography$strong,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Entity Name: ')
						])),
					$elm$html$Html$text(
					$author$project$Api$Provider$DataExportGroup$One$entityName(dataExportGroup)),
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					A2(
					$author$project$Ui$Typography$strong,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Destination: ')
						])),
					$elm$html$Html$text(
					$author$project$Components$Admin$DataExportConfiguration$Utils$destinationDescription(dataExportConfiguration)),
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					A2(
					$author$project$Ui$Typography$strong,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Files: ')
						])),
					A2(
					$elm$html$Html$ul,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$author$project$Components$Admin$DataExportConfiguration$ExportModal$viewDataExport,
						$author$project$Api$Provider$DataExportGroup$One$dataExports(dataExportGroup)))
				]));
	} else {
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$textCenter]),
			_List_fromArray(
				[
					$author$project$Ui$Spinner$view(_List_Nil)
				]));
	}
};
var $author$project$Components$Admin$DataExportConfiguration$ExportModal$view = function (_v0) {
	var model = _v0;
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Admin$DataExportConfiguration$ExportModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Export Now')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						$author$project$Components$Admin$DataExportConfiguration$ExportModal$viewPreview(model.t2),
						$author$project$Components$Admin$DataExportConfiguration$ExportModal$viewConfirmInput(model)
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Admin$DataExportConfiguration$ExportModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Close')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Export Now'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$onClick($author$project$Components$Admin$DataExportConfiguration$ExportModal$Export),
								$author$project$Ui$Button$icon($author$project$Ui$Icon$add),
								$author$project$Ui$Button$disabled(!model.iN),
								$author$project$Ui$Button$loading(
								_Utils_eq(model.nE, $author$project$Api$Data$Loading) || _Utils_eq(model.t2, $author$project$Api$Data$Loading))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Export Now')
							]))
					]))
			]));
};
var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$TestConnection = {$: 1};
var $author$project$Ui$Typography$b = F2(
	function (options, content) {
		return A2(
			$elm$html$Html$b,
			$author$project$Ui$Typography$optionsToAttributes(options),
			content);
	});
var $author$project$Ui$OrderedList$Item = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Ui$OrderedList$item = $author$project$Ui$OrderedList$Item;
var $elm$html$Html$pre = _VirtualDom_node('pre');
var $author$project$Ui$Typography$pre = F2(
	function (options, content) {
		return A2(
			$elm$html$Html$pre,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('pre'),
				$author$project$Ui$Typography$optionsToAttributes(options)),
			A2(
				$elm$core$List$map,
				$elm$html$Html$map($elm$core$Basics$never),
				content));
	});
var $author$project$Ui$Typography$PreWrap = {$: 12};
var $author$project$Ui$Typography$preWrap = $author$project$Ui$Typography$PreWrap;
var $author$project$Components$Admin$DataExportConfiguration$ConfigurationGuide$s3BucketPolicy = function (bucketName) {
	return A3($elm$core$String$replace, 'NAME_OF_BUCKET', bucketName, '\n{\n  "Version": "2012-10-17",\n  "Statement": [\n    {\n      "Sid": "HintDataExport",\n      "Effect": "Allow",\n      "Principal": {\n        "AWS": "arn:aws:iam::540645937361:root"\n      },\n      "Action": [\n        "s3:GetObject",\n        "s3:PutObject"\n      ],\n      "Resource": [\n        "arn:aws:s3:::NAME_OF_BUCKET",\n        "arn:aws:s3:::NAME_OF_BUCKET/*"\n      ]\n    }\n  ]\n}\n    ');
};
var $author$project$Ui$OrderedList$defaultOptions = {
	xr: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('ordered-list')
		])
};
var $author$project$Ui$OrderedList$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				return _Utils_update(
					record,
					{
						xr: A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class('ordered-list--roman'),
							record.xr)
					});
			}),
		$author$project$Ui$OrderedList$defaultOptions,
		options);
};
var $author$project$Ui$OrderedList$itemOptionToAttributes = function (option) {
	return _List_Nil;
};
var $author$project$Ui$OrderedList$itemOptionsToAttributes = function (options) {
	return A2(
		$elm$core$List$map,
		$elm$html$Html$Attributes$map($elm$core$Basics$never),
		A2($elm$core$List$concatMap, $author$project$Ui$OrderedList$itemOptionToAttributes, options));
};
var $author$project$Ui$OrderedList$viewItem = function (item_) {
	var options = item_.a;
	var contents = item_.b;
	return A2(
		$elm$html$Html$li,
		$author$project$Ui$OrderedList$itemOptionsToAttributes(options),
		_List_fromArray(
			[
				A2($elm$html$Html$span, _List_Nil, contents)
			]));
};
var $author$project$Ui$OrderedList$view = F2(
	function (options, items) {
		var optionsRecord = $author$project$Ui$OrderedList$optionsToRecord(options);
		return A2(
			$elm$html$Html$ol,
			optionsRecord.xr,
			A2($elm$core$List$map, $author$project$Ui$OrderedList$viewItem, items));
	});
var $author$project$Components$Admin$DataExportConfiguration$ConfigurationGuide$s3Guide = function (dataExportConfiguration) {
	var bucketName = A2(
		$elm$core$Maybe$withDefault,
		'NAME_OF_BUCKET',
		$author$project$Api$Provider$DataExportConfiguration$Shared$s3Bucket(dataExportConfiguration));
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$title,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('S3 Configuration Steps')
					])),
				A2(
				$author$project$Ui$OrderedList$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$OrderedList$item,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Create an S3 bucket named \"'),
								$elm$html$Html$text(bucketName),
								$elm$html$Html$text('\". '),
								A2(
								$author$project$Ui$Typography$b,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Do not use Access Control Lists (ACLS). ')
									])),
								A2(
								$author$project$Ui$Alert$warning,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('You are responsible for the security of your bucket, including requiring encryption at rest, '),
										$elm$html$Html$text('object locks and replication as appropriate.')
									]))
							])),
						A2(
						$author$project$Ui$OrderedList$item,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Apply the IAM policy below to the bucket'),
								A2(
								$author$project$Ui$Typography$pre,
								_List_fromArray(
									[$author$project$Ui$Typography$preWrap]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Components$Admin$DataExportConfiguration$ConfigurationGuide$s3BucketPolicy(bucketName))
									]))
							]))
					]))
			]));
};
var $author$project$Components$Admin$DataExportConfiguration$ConfigurationGuide$view = function (dataExportConfiguration) {
	var _v0 = $author$project$Api$Provider$DataExportConfiguration$Shared$destination(dataExportConfiguration);
	switch (_v0) {
		case 's3':
			return $author$project$Components$Admin$DataExportConfiguration$ConfigurationGuide$s3Guide(dataExportConfiguration);
		case 'sftp':
			return $author$project$Utils$Html$empty;
		default:
			return $author$project$Utils$Html$empty;
	}
};
var $author$project$Api$Provider$DataExportConfiguration$Shared$testExportFileName = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExportConfiguration$Shared$record,
	function ($) {
		return $.ac2;
	});
var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$viewTestFileDetails = function (dataExportConfiguration) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mb-2')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('The platform will try to send a test to verify your data export configuration.')
					])),
				A2(
				$author$project$Ui$Typography$strong,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Destination: ')
					])),
				$elm$html$Html$text(
				$author$project$Components$Admin$DataExportConfiguration$Utils$destinationDescription(dataExportConfiguration)),
				A2($elm$html$Html$br, _List_Nil, _List_Nil),
				A2(
				$author$project$Ui$Typography$strong,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Path: ')
					])),
				$elm$html$Html$text(
				$author$project$Api$Provider$DataExportConfiguration$Shared$testExportFileName(dataExportConfiguration))
			]));
};
var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$viewTestStatus = function (testResult) {
	switch (testResult.$) {
		case 0:
			return $author$project$Utils$Html$empty;
		case 1:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mb-4')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Alert$info,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Testing connection...')
							]))
					]));
		case 2:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mb-4')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Alert$success,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Connection test successful!')
							]))
					]));
		default:
			var message = testResult.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mb-4')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Alert$danger,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Connection test failed. Please check your configuration and try again.'),
								A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Error: ')
											])),
										$elm$html$Html$text(message)
									]))
							]))
					]));
	}
};
var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$view = function (model) {
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Test Connection')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						$author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$viewTestFileDetails(model.Px),
						$author$project$Components$Admin$DataExportConfiguration$ConfigurationGuide$view(model.Px),
						$author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$viewTestStatus(model.lM)
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Close')
							])),
						function () {
						var _v0 = model.lM;
						if (_v0.$ === 1) {
							return A3(
								$author$project$Ui$Button$view,
								{mm: 'Testing connection'},
								_List_fromArray(
									[
										$author$project$Ui$Button$primary,
										$author$project$Ui$Button$loading(true),
										$author$project$Ui$Button$disabled(true)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Testing...')
									]));
						} else {
							return A3(
								$author$project$Ui$Button$view,
								{mm: 'Test connection'},
								_List_fromArray(
									[
										$author$project$Ui$Button$primary,
										$author$project$Ui$Button$onClick($author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$TestConnection)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Test Connection')
									]));
						}
					}()
					]))
			]));
};
var $author$project$Components$Admin$DataExportConfiguration$Form$OpenExportModal = {$: 7};
var $author$project$Utils$Form$dirty = function (_v0) {
	var originalFields = _v0.a;
	var fields_ = _v0.c;
	return !_Utils_eq(originalFields, fields_);
};
var $author$project$Ui$Button$md = $author$project$Ui$Button$Size(1);
var $author$project$Components$Admin$DataExportConfiguration$Form$viewExportButton = function (model) {
	var disabled = _Utils_eq(model.ahP, $elm$core$Maybe$Nothing) || A2(
		$elm$core$Maybe$withDefault,
		false,
		A2($elm$core$Maybe$map, $author$project$Utils$Form$dirty, model.SD));
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$ml2]),
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Tooltip$view,
				_List_fromArray(
					[
						$author$project$Ui$Tooltip$placement(0),
						$author$project$Ui$Tooltip$active(disabled),
						$author$project$Ui$Tooltip$wide
					]),
				'You must save the settings before you can export data.',
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Export Now'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Admin$DataExportConfiguration$Form$OpenExportModal),
								$author$project$Ui$Button$icon($author$project$Ui$Icon$add),
								$author$project$Ui$Button$disabled(disabled),
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$md
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Export Now')
							]))
					]))
			]));
};
var $author$project$Components$Admin$DataExportConfiguration$Form$ContactEmail = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$Input$Email = {$: 4};
var $author$project$Ui$Form$Input$email = $author$project$Ui$Form$Input$Type($author$project$Ui$Form$Input$Email);
var $author$project$Components$Admin$DataExportConfiguration$Form$viewContactEmailInput = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var contactEmail = _v0.Ow;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('Contact Email'),
				$author$project$Ui$Form$Group$required(true)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$value(
						A2($elm$core$Maybe$withDefault, '', contactEmail)),
						$author$project$Ui$Form$Input$placeholder('example@example.com'),
						$author$project$Ui$Form$Input$email,
						$author$project$Ui$Form$Input$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated, $author$project$Components$Admin$DataExportConfiguration$Form$ContactEmail)),
						$author$project$Ui$Form$Input$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
						$author$project$Ui$Form$Input$errors(
						A2($author$project$Utils$Form$validationErrors, 0, form))
					]))
			]));
};
var $author$project$Components$PhoneInput$PhoneAdded = {$: 0};
var $author$project$Formatters$PhoneType$toString = function (type_) {
	switch (type_.$) {
		case 0:
			return 'Mobile';
		case 1:
			return 'Home';
		case 2:
			return 'Office';
		default:
			var otherDescription = type_.a;
			return otherDescription;
	}
};
var $author$project$Components$PhoneInput$viewAddMore = F2(
	function (phones, max) {
		return _Utils_cmp(
			$elm$core$List$length(phones),
			max) < 0;
	});
var $author$project$Components$PhoneInput$FormFieldUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$PhoneInput$PhoneRemoved = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$PhoneInput$PhoneType = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Ui$Grid$justifyCenter = $author$project$Ui$Grid$Element($author$project$Ui$Element$justifyCenter);
var $author$project$Components$PhoneInput$PhoneNumber = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$PhoneInput$PhoneRegion = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Ui$Form$Input$AutoCorrect = function (a) {
	return {$: 15, a: a};
};
var $author$project$Ui$Form$Input$autoCorrect = $author$project$Ui$Form$Input$AutoCorrect;
var $author$project$Ui$Form$Input$MaskedValue = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Ui$Form$Input$maskedValue = $author$project$Ui$Form$Input$MaskedValue;
var $author$project$Components$PhoneInput$phonePlaceholder = A3($elm$core$String$replace, '#', '5', $author$project$Components$PhoneInput$phoneMask);
var $author$project$Components$PhoneInput$regionToString = function (region) {
	if (!region) {
		return 'US';
	} else {
		return 'Int\'l';
	}
};
var $author$project$Ui$Form$Input$SpellCheck = function (a) {
	return {$: 17, a: a};
};
var $author$project$Ui$Form$Input$spellCheck = $author$project$Ui$Form$Input$SpellCheck;
var $author$project$Ui$Form$Input$Tel = {$: 0};
var $author$project$Ui$Form$Input$tel = $author$project$Ui$Form$Input$Type($author$project$Ui$Form$Input$Tel);
var $author$project$Ui$Form$Input$WithFeedback = function (a) {
	return {$: 18, a: a};
};
var $author$project$Ui$Form$Input$withFeedback = $author$project$Ui$Form$Input$WithFeedback;
var $author$project$Components$PhoneInput$viewNumberInput = F5(
	function (regions, form, regionDropdown, index, phone) {
		var phoneNumber = phone.IO;
		return $author$project$Ui$Form$Input$group(
			_List_fromArray(
				[
					A4(
					$author$project$Ui$Dropdown$viewSelect,
					_List_fromArray(
						[
							$author$project$Ui$Dropdown$ariaLabel('Phone region')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Components$PhoneInput$regionToString(phone.akD))
						]),
					A2(
						$elm$core$List$map,
						function (region) {
							return A2(
								$author$project$Ui$Dropdown$item,
								_List_fromArray(
									[
										$author$project$Ui$Dropdown$onSelect(
										$author$project$Components$PhoneInput$FormFieldUpdated(
											A2($author$project$Components$PhoneInput$PhoneRegion, index, region))),
										$author$project$Ui$Dropdown$selected(
										_Utils_eq(region, phone.akD))
									]),
								$elm$html$Html$text(
									$author$project$Components$PhoneInput$regionToString(region)));
						},
						regions),
					regionDropdown),
					function () {
					var _v0 = phone.akD;
					if (!_v0) {
						return $author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									A2($author$project$Ui$Form$Input$maskedValue, $author$project$Components$PhoneInput$phonePattern, phoneNumber),
									$author$project$Ui$Form$Input$placeholder($author$project$Components$PhoneInput$phonePlaceholder),
									$author$project$Ui$Form$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										A2(
											$elm$core$Basics$composeL,
											A2(
												$elm$core$Basics$composeL,
												$author$project$Components$PhoneInput$FormFieldUpdated,
												$author$project$Components$PhoneInput$PhoneNumber(index)),
											$elm$core$String$filter($elm$core$Char$isDigit)),
										$elm$core$String$left(14))),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, index, form)),
									$author$project$Ui$Form$Input$autoComplete(false),
									$author$project$Ui$Form$Input$autoCorrect(false),
									$author$project$Ui$Form$Input$autoCapitalize(false),
									$author$project$Ui$Form$Input$spellCheck(false),
									$author$project$Ui$Form$Input$tel,
									$author$project$Ui$Form$Input$phi(true),
									$author$project$Ui$Form$Input$withFeedback(
									$author$project$Utils$Form$validated(form))
								]));
					} else {
						return $author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(phoneNumber),
									$author$project$Ui$Form$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Components$PhoneInput$FormFieldUpdated,
										$author$project$Components$PhoneInput$PhoneNumber(index))),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, index, form)),
									$author$project$Ui$Form$Input$autoComplete(false),
									$author$project$Ui$Form$Input$autoCorrect(false),
									$author$project$Ui$Form$Input$autoCapitalize(false),
									$author$project$Ui$Form$Input$spellCheck(false),
									$author$project$Ui$Form$Input$tel,
									$author$project$Ui$Form$Input$phi(true),
									$author$project$Ui$Form$Input$withFeedback(
									$author$project$Utils$Form$validated(form))
								]));
					}
				}()
				]));
	});
var $author$project$Components$PhoneInput$viewPhone = function (max) {
	return function (isRequired) {
		return function (allowRemove) {
			return function (phoneTypes) {
				return function (regions) {
					return function (disablePhoneType) {
						return function (hidePhoneType) {
							return function (form) {
								return function (index) {
									return function (_v0) {
										var phone = _v0.a;
										var typeDropdown = _v0.b;
										var regionDropdown = _v0.c;
										var phoneInputGridAttrs = hidePhoneType ? ((((max > 1) || (!isRequired)) && allowRemove) ? _List_fromArray(
											[
												$author$project$Ui$Grid$spanSm(11),
												$author$project$Ui$Grid$span(10)
											]) : _List_fromArray(
											[
												$author$project$Ui$Grid$spanSm(11),
												$author$project$Ui$Grid$span(12)
											])) : ((((max === 1) && isRequired) || (!allowRemove)) ? _List_fromArray(
											[
												$author$project$Ui$Grid$spanSm(8),
												$author$project$Ui$Grid$span(12)
											]) : _List_fromArray(
											[
												$author$project$Ui$Grid$spanSm(7),
												$author$project$Ui$Grid$span(10)
											]));
										return A2(
											$author$project$Ui$Grid$row,
											_List_fromArray(
												[$author$project$Ui$Grid$rowItemsCenter]),
											$elm$core$List$concat(
												_List_fromArray(
													[
														(!hidePhoneType) ? _List_fromArray(
														[
															A2(
															$author$project$Ui$Grid$column,
															_List_fromArray(
																[
																	$author$project$Ui$Grid$spanSm(4),
																	$author$project$Ui$Grid$span(12)
																]),
															_List_fromArray(
																[
																	A4(
																	$author$project$Ui$Dropdown$viewSelect,
																	_List_fromArray(
																		[
																			$author$project$Ui$Dropdown$disabled(disablePhoneType),
																			$author$project$Ui$Dropdown$ariaLabel('Phone type')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Formatters$PhoneType$toString(phone.amg))
																		]),
																	A2(
																		$elm$core$List$map,
																		function (phoneType) {
																			return A2(
																				$author$project$Ui$Dropdown$item,
																				_List_fromArray(
																					[
																						$author$project$Ui$Dropdown$onSelect(
																						$author$project$Components$PhoneInput$FormFieldUpdated(
																							A2(
																								$author$project$Components$PhoneInput$PhoneType,
																								index,
																								$author$project$Formatters$PhoneType$toString(phoneType)))),
																						$author$project$Ui$Dropdown$selected(
																						_Utils_eq(phoneType, phone.amg))
																					]),
																				$elm$html$Html$text(
																					$author$project$Formatters$PhoneType$toString(phoneType)));
																		},
																		phoneTypes),
																	typeDropdown)
																])),
															A2(
															$author$project$Ui$Grid$column,
															phoneInputGridAttrs,
															_List_fromArray(
																[
																	A5($author$project$Components$PhoneInput$viewNumberInput, regions, form, regionDropdown, index, phone)
																]))
														]) : _List_fromArray(
														[
															A2(
															$author$project$Ui$Grid$column,
															phoneInputGridAttrs,
															_List_fromArray(
																[
																	A5($author$project$Components$PhoneInput$viewNumberInput, regions, form, regionDropdown, index, phone)
																]))
														]),
														(((max > 1) || (!isRequired)) && allowRemove) ? _List_fromArray(
														[
															A2(
															$author$project$Ui$Grid$column,
															_List_fromArray(
																[
																	$author$project$Ui$Grid$spanSm(1),
																	$author$project$Ui$Grid$span(2),
																	$author$project$Ui$Grid$justifyCenter
																]),
															((!index) && isRequired) ? _List_Nil : _List_fromArray(
																[
																	A3(
																	$author$project$Ui$Button$view,
																	{mm: 'Remove phone'},
																	_List_fromArray(
																		[
																			$author$project$Ui$Button$link,
																			$author$project$Ui$Button$icon($author$project$Ui$Icon$delete),
																			$author$project$Ui$Button$onClick(
																			$author$project$Components$PhoneInput$PhoneRemoved(index))
																		]),
																	_List_Nil)
																]))
														]) : _List_Nil
													])));
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$PhoneInput$view = function (_v0) {
	var model = _v0;
	var phones = $author$project$Utils$Form$fields(model.SD);
	var phoneTypes = A2(
		$elm_community$list_extra$List$Extra$uniqueBy,
		$author$project$Formatters$PhoneType$toString,
		$elm$core$List$concat(
			_List_fromArray(
				[
					model.amh,
					A2(
					$elm$core$List$map,
					function (_v1) {
						var phone = _v1.a;
						return phone.amg;
					},
					phones)
				])));
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$indexedMap,
					A8($author$project$Components$PhoneInput$viewPhone, model.AU, model.akR, model.aeW, phoneTypes, model.pz, model.agy, model.nS, model.SD),
					phones),
					A2($author$project$Components$PhoneInput$viewAddMore, phones, model.AU) ? _List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								function () {
								var label = A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[
											'Add',
											(!$elm$core$List$isEmpty(phones)) ? 'Another' : '',
											' Phone'
										]));
								return A3(
									$author$project$Ui$Button$view,
									{mm: label},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick($author$project$Components$PhoneInput$PhoneAdded)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(label)
										]));
							}()
							]))
					]) : _List_Nil
				])));
};
var $author$project$Components$Admin$DataExportConfiguration$Form$viewContactPhoneInput = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var contactPhone = _v0.Oy;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('Contact Phone'),
				$author$project$Ui$Form$Group$required(true)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Admin$DataExportConfiguration$Form$ContactPhoneInputMsg,
				$author$project$Components$PhoneInput$view(contactPhone))
			]));
};
var $author$project$Components$Admin$DataExportConfiguration$Form$Destination = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$Form$destinationOptions = A2(
	$elm$core$List$map,
	function (_v0) {
		var destination = _v0.a;
		var label = _v0.b;
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			A2($elm$core$Maybe$map, $author$project$Components$Admin$DataExportConfiguration$Form$destinationToString, destination),
			label);
	},
	_List_fromArray(
		[
			_Utils_Tuple2($elm$core$Maybe$Nothing, 'Select a destination'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just(0),
			'SFTP'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just(1),
			'S3')
		]));
var $author$project$Components$Admin$DataExportConfiguration$Form$viewDestinationInput = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var destination = _v0.Qt;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('Destination')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Select$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Select$value(
						A2($elm$core$Maybe$map, $author$project$Components$Admin$DataExportConfiguration$Form$destinationToString, destination)),
						$author$project$Ui$Form$Select$onChange(
						A2($elm$core$Basics$composeL, $author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated, $author$project$Components$Admin$DataExportConfiguration$Form$Destination)),
						$author$project$Ui$Form$Select$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
						$author$project$Ui$Form$Select$errors(
						A2($author$project$Utils$Form$validationErrors, 2, form))
					]),
				$author$project$Components$Admin$DataExportConfiguration$Form$destinationOptions)
			]));
};
var $author$project$Components$Admin$DataExportConfiguration$Form$Enabled = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$Form$viewEnabledInput = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var enabled = _v0.Ro;
	var manualExportPerformed = _v0.Ws;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('Enabled')
			]),
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$view(
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$on(enabled),
						$author$project$Ui$ToggleSwitch$onChange(
						A2($elm$core$Basics$composeL, $author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated, $author$project$Components$Admin$DataExportConfiguration$Form$Enabled)),
						$author$project$Ui$ToggleSwitch$disabled(!manualExportPerformed)
					])),
				A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$helpBlock]),
				_List_fromArray(
					[
						$elm$html$Html$text('Enables data export files to send daily.')
					])),
				(!manualExportPerformed) ? A2(
				$author$project$Ui$Alert$warning,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('A manual export has to be performed before enabling daily exports.'),
						A2($elm$html$Html$br, _List_Nil, _List_Nil),
						$elm$html$Html$text('Click the '),
						A2(
						$author$project$Ui$Typography$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('\"Export Now\"')
							])),
						$elm$html$Html$text(' button below to perform a manual export.')
					])) : $author$project$Utils$Html$empty
			]));
};
var $author$project$Components$Admin$DataExportConfiguration$Form$EncryptionEnabled = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$Form$viewEncryptionEnabledInput = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var encryptionEnabled = _v0.jD;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('Encryption Enabled')
			]),
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$view(
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$on(encryptionEnabled),
						$author$project$Ui$ToggleSwitch$onChange(
						A2($elm$core$Basics$composeL, $author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated, $author$project$Components$Admin$DataExportConfiguration$Form$EncryptionEnabled))
					])),
				A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$helpBlock]),
				_List_fromArray(
					[
						$elm$html$Html$text('When encryption is enabled, the data will be encrypted before it is sent to the destination.')
					]))
			]));
};
var $author$project$Components$Admin$DataExportConfiguration$Form$EncryptionKey = function (a) {
	return {$: 11, a: a};
};
var $author$project$Ui$Form$Textarea$Errors = function (a) {
	return {$: 6, a: a};
};
var $author$project$Ui$Form$Textarea$errors = $author$project$Ui$Form$Textarea$Errors;
var $author$project$Ui$Form$Textarea$Invalid = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Form$Textarea$invalid = $author$project$Ui$Form$Textarea$Invalid;
var $author$project$Components$Admin$DataExportConfiguration$Form$viewEncryptionKeyInput = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var encryptionKey = _v0.Rs;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('Encryption Key'),
				$author$project$Ui$Form$Group$required(true)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Textarea$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Textarea$value(
						A2($elm$core$Maybe$withDefault, '', encryptionKey)),
						$author$project$Ui$Form$Textarea$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated, $author$project$Components$Admin$DataExportConfiguration$Form$EncryptionKey)),
						$author$project$Ui$Form$Textarea$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 9, form)),
						$author$project$Ui$Form$Textarea$errors(
						A2($author$project$Utils$Form$validationErrors, 9, form))
					]))
			]));
};
var $author$project$Components$Admin$DataExportConfiguration$Form$EncryptionRecipient = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$Form$viewEncryptionRecipientInput = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var encryptionRecipient = _v0.Rt;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('Encryption Recipient'),
				$author$project$Ui$Form$Group$required(true)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$value(
						A2($elm$core$Maybe$withDefault, '', encryptionRecipient)),
						$author$project$Ui$Form$Input$placeholder('example@example.com'),
						$author$project$Ui$Form$Input$autofocus(true),
						$author$project$Ui$Form$Input$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated, $author$project$Components$Admin$DataExportConfiguration$Form$EncryptionRecipient)),
						$author$project$Ui$Form$Input$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 10, form)),
						$author$project$Ui$Form$Input$errors(
						A2($author$project$Utils$Form$validationErrors, 10, form))
					]))
			]));
};
var $author$project$Components$Admin$DataExportConfiguration$Form$ExcludeDefaultTables = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$Form$viewExcludeDefaultTablesInput = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var excludeDefaultTables = _v0.RR;
	return A2(
		$author$project$Ui$HinterOnly$formGroup,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('Exclude Default Tables')
			]),
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$view(
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$on(excludeDefaultTables),
						$author$project$Ui$ToggleSwitch$onChange(
						A2($elm$core$Basics$composeL, $author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated, $author$project$Components$Admin$DataExportConfiguration$Form$ExcludeDefaultTables))
					])),
				A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$helpBlock]),
				_List_fromArray(
					[
						$elm$html$Html$text('By default, all tables from data export will be sent.'),
						$author$project$Utils$Html$noBreakSpace,
						$elm$html$Html$text('When this is enabled, only the custom tables will be sent.')
					]))
			]));
};
var $author$project$Components$Admin$DataExportConfiguration$Form$FileNameFormat = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$Form$FileNameFormatValidation = 11;
var $author$project$Components$Admin$DataExportConfiguration$Form$viewFileNameFormatInput = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var fileNameFormat = _v0.So;
	var destination = _v0.Qt;
	return A2(
		$author$project$Ui$HinterOnly$formGroup,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('File Name Format')
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$value(
						A2($elm$core$Maybe$withDefault, '', fileNameFormat)),
						$author$project$Ui$Form$Input$placeholder(':timestamp:/:file_name:'),
						$author$project$Ui$Form$Input$autofocus(true),
						$author$project$Ui$Form$Input$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated, $author$project$Components$Admin$DataExportConfiguration$Form$FileNameFormat)),
						$author$project$Ui$Form$Input$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 11, form)),
						$author$project$Ui$Form$Input$errors(
						A2($author$project$Utils$Form$validationErrors, 11, form))
					])),
				function () {
				if (!destination.$) {
					var destination_ = destination.a;
					return A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$helpBlock]),
						_List_fromArray(
							[
								$elm$html$Html$text('By default, the export will be placed in '),
								function () {
								if (!destination_) {
									return $elm$html$Html$text('the home directory of the SFTP user.');
								} else {
									return $elm$html$Html$text('the root of the S3 bucket.');
								}
							}(),
								$author$project$Utils$Html$noBreakSpace,
								$elm$html$Html$text('Only change this if the customers request the file to be placed in a specific directory.'),
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								$elm$html$Html$text('If that happens add the requested path as prefix to whats already there.'),
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								$elm$html$Html$text('Example: '),
								A2(
								$author$project$Ui$Typography$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(':timestamp:/:file_name:')
									])),
								$elm$html$Html$text(' becomes '),
								A2(
								$author$project$Ui$Typography$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('/requested/path/:timestamp:/:file_name:')
									]))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]));
};
var $author$project$Components$Admin$DataExportConfiguration$Form$Incremental = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$Form$viewIncrementalInput = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var incremental = _v0.nY;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('Sync Mode')
			]),
		_List_fromArray(
			[
				$author$project$Ui$Button$group(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Full'},
						_List_fromArray(
							[
								$author$project$Ui$Button$active(!incremental),
								$author$project$Ui$Button$onClick(
								$author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated(
									$author$project$Components$Admin$DataExportConfiguration$Form$Incremental(false)))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Full')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Incremental'},
						_List_fromArray(
							[
								$author$project$Ui$Button$active(incremental),
								$author$project$Ui$Button$onClick(
								$author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated(
									$author$project$Components$Admin$DataExportConfiguration$Form$Incremental(true)))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Incremental')
							]))
					])),
				A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$helpBlock]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Full: ')
							])),
						$elm$html$Html$text('Each daily file includes all records.')
					])),
				A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$helpBlock]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Incremental: ')
							])),
						$elm$html$Html$text('Each daily file includes records that have been created, updated, or deleted within the past 7 days. The first export of the month includes all records.')
					]))
			]));
};
var $author$project$Components$Admin$DataExportConfiguration$Form$S3Bucket = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$Form$viewS3BucketInput = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var s3Bucket = _v0.aal;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('S3 Bucket'),
				$author$project$Ui$Form$Group$required(true)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$value(
						A2($elm$core$Maybe$withDefault, '', s3Bucket)),
						$author$project$Ui$Form$Input$placeholder('S3 Bucket'),
						$author$project$Ui$Form$Input$autofocus(true),
						$author$project$Ui$Form$Input$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated, $author$project$Components$Admin$DataExportConfiguration$Form$S3Bucket)),
						$author$project$Ui$Form$Input$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 7, form)),
						$author$project$Ui$Form$Input$errors(
						A2($author$project$Utils$Form$validationErrors, 7, form))
					]))
			]));
};
var $author$project$Components$Admin$DataExportConfiguration$Form$S3Region = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$Form$s3RegionOptions = A2(
	$elm$core$List$map,
	function (_v0) {
		var region = _v0.a;
		var label = _v0.b;
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			region,
			_Utils_ap(
				label,
				A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						function (region_) {
							return ' (' + (region_ + ')');
						},
						region))));
	},
	_List_fromArray(
		[
			_Utils_Tuple2($elm$core$Maybe$Nothing, 'Select a region'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('us-east-1'),
			'US East (N. Virginia)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('us-east-2'),
			'US East (Ohio)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('us-west-1'),
			'US West (N. California)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('us-west-2'),
			'US West (Oregon)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('af-south-1'),
			'Africa (Cape Town)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('ap-east-1'),
			'Asia Pacific (Hong Kong)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('ap-south-2'),
			'Asia Pacific (Hyderabad)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('ap-southeast-3'),
			'Asia Pacific (Jakarta)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('ap-southeast-5'),
			'Asia Pacific (Malaysia)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('ap-southeast-4'),
			'Asia Pacific (Melbourne)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('ap-south-1'),
			'Asia Pacific (Mumbai)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('ap-northeast-3'),
			'Asia Pacific (Osaka)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('ap-northeast-2'),
			'Asia Pacific (Seoul)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('ap-southeast-1'),
			'Asia Pacific (Singapore)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('ap-southeast-2'),
			'Asia Pacific (Sydney)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('ap-east-2'),
			'Asia Pacific (Taipei)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('ap-southeast-7'),
			'Asia Pacific (Thailand)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('ap-northeast-1'),
			'Asia Pacific (Tokyo)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('ca-central-1'),
			'Canada (Central)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('ca-west-1'),
			'Canada West (Calgary)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('eu-central-1'),
			'Europe (Frankfurt)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('eu-west-1'),
			'Europe (Ireland)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('eu-west-2'),
			'Europe (London)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('eu-south-1'),
			'Europe (Milan)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('eu-west-3'),
			'Europe (Paris)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('eu-south-2'),
			'Europe (Spain)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('eu-north-1'),
			'Europe (Stockholm)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('eu-central-2'),
			'Europe (Zurich)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('il-central-1'),
			'Israel (Tel Aviv)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('mx-central-1'),
			'Mexico (Central)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('me-south-1'),
			'Middle East (Bahrain)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('me-central-1'),
			'Middle East (UAE)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('sa-east-1'),
			'South America (São Paulo)')
		]));
var $author$project$Components$Admin$DataExportConfiguration$Form$viewS3RegionInput = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var s3Region = _v0.aam;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('S3 Region'),
				$author$project$Ui$Form$Group$required(true)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Select$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Select$value(s3Region),
						$author$project$Ui$Form$Select$onChange(
						A2($elm$core$Basics$composeL, $author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated, $author$project$Components$Admin$DataExportConfiguration$Form$S3Region)),
						$author$project$Ui$Form$Select$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 8, form)),
						$author$project$Ui$Form$Select$errors(
						A2($author$project$Utils$Form$validationErrors, 8, form))
					]),
				$author$project$Components$Admin$DataExportConfiguration$Form$s3RegionOptions)
			]));
};
var $author$project$Components$Admin$DataExportConfiguration$Form$SftpHost = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$Form$viewSftpHostInput = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var sftpHost = _v0.aa9;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('SFTP Host'),
				$author$project$Ui$Form$Group$required(true)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$value(
						A2($elm$core$Maybe$withDefault, '', sftpHost)),
						$author$project$Ui$Form$Input$placeholder('sftp.example.com'),
						$author$project$Ui$Form$Input$autofocus(true),
						$author$project$Ui$Form$Input$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated, $author$project$Components$Admin$DataExportConfiguration$Form$SftpHost)),
						$author$project$Ui$Form$Input$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 3, form)),
						$author$project$Ui$Form$Input$errors(
						A2($author$project$Utils$Form$validationErrors, 3, form))
					]))
			]));
};
var $author$project$Components$Admin$DataExportConfiguration$Form$SftpPort = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$Form$viewSftpPortInput = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var sftpPort = _v0.aba;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('SFTP Port'),
				$author$project$Ui$Form$Group$required(true)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$value(
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2($elm$core$Maybe$map, $elm$core$String$fromInt, sftpPort))),
						$author$project$Ui$Form$Input$placeholder('22'),
						$author$project$Ui$Form$Input$autofocus(true),
						$author$project$Ui$Form$Input$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated, $author$project$Components$Admin$DataExportConfiguration$Form$SftpPort)),
						$author$project$Ui$Form$Input$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 4, form)),
						$author$project$Ui$Form$Input$errors(
						A2($author$project$Utils$Form$validationErrors, 4, form))
					]))
			]));
};
var $author$project$Components$Admin$DataExportConfiguration$Form$SftpPrivateKey = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$Form$viewSftpPrivateKeyInput = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var sftpPrivateKey = _v0.JJ;
	var sftpPrivateKeyAlreadySaved = _v0.ux;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('SFTP Private Key'),
				$author$project$Ui$Form$Group$required(!sftpPrivateKeyAlreadySaved)
			]),
		_List_fromArray(
			[
				sftpPrivateKeyAlreadySaved ? A2(
				$author$project$Ui$Alert$warning,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Your SFTP private key is saved. Use the space below to edit or change the key.')
					])) : $author$project$Utils$Html$empty,
				$author$project$Ui$Form$Textarea$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Textarea$value(
						A2($elm$core$Maybe$withDefault, '', sftpPrivateKey)),
						$author$project$Ui$Form$Textarea$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated, $author$project$Components$Admin$DataExportConfiguration$Form$SftpPrivateKey)),
						$author$project$Ui$Form$Textarea$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 6, form)),
						$author$project$Ui$Form$Textarea$errors(
						A2($author$project$Utils$Form$validationErrors, 6, form))
					]))
			]));
};
var $author$project$Components$Admin$DataExportConfiguration$Form$SftpUsername = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$Form$viewSftpUsernameInput = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var sftpUsername = _v0.abb;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('SFTP Username'),
				$author$project$Ui$Form$Group$required(true)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$value(
						A2($elm$core$Maybe$withDefault, '', sftpUsername)),
						$author$project$Ui$Form$Input$placeholder('username'),
						$author$project$Ui$Form$Input$autofocus(true),
						$author$project$Ui$Form$Input$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated, $author$project$Components$Admin$DataExportConfiguration$Form$SftpUsername)),
						$author$project$Ui$Form$Input$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 5, form)),
						$author$project$Ui$Form$Input$errors(
						A2($author$project$Utils$Form$validationErrors, 5, form))
					]))
			]));
};
var $author$project$Components$Admin$DataExportConfiguration$Form$viewForm = F2(
	function (isHintAdmin, form) {
		var _v0 = $author$project$Utils$Form$fields(form);
		var destination = _v0.Qt;
		var encryptionEnabled = _v0.jD;
		return $elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						$author$project$Components$Admin$DataExportConfiguration$Form$viewEnabledInput(form),
						$author$project$Components$Admin$DataExportConfiguration$Form$viewContactEmailInput(form),
						$author$project$Components$Admin$DataExportConfiguration$Form$viewContactPhoneInput(form),
						$author$project$Components$Admin$DataExportConfiguration$Form$viewDestinationInput(form)
					]),
					function () {
					if (!destination.$) {
						if (!destination.a) {
							var _v2 = destination.a;
							return _List_fromArray(
								[
									$author$project$Components$Admin$DataExportConfiguration$Form$viewSftpHostInput(form),
									$author$project$Components$Admin$DataExportConfiguration$Form$viewSftpPortInput(form),
									$author$project$Components$Admin$DataExportConfiguration$Form$viewSftpUsernameInput(form),
									$author$project$Components$Admin$DataExportConfiguration$Form$viewSftpPrivateKeyInput(form)
								]);
						} else {
							var _v3 = destination.a;
							return _List_fromArray(
								[
									$author$project$Components$Admin$DataExportConfiguration$Form$viewS3BucketInput(form),
									$author$project$Components$Admin$DataExportConfiguration$Form$viewS3RegionInput(form)
								]);
						}
					} else {
						return _List_Nil;
					}
				}(),
					_List_fromArray(
					[
						$author$project$Components$Admin$DataExportConfiguration$Form$viewEncryptionEnabledInput(form)
					]),
					encryptionEnabled ? _List_fromArray(
					[
						$author$project$Components$Admin$DataExportConfiguration$Form$viewEncryptionKeyInput(form),
						$author$project$Components$Admin$DataExportConfiguration$Form$viewEncryptionRecipientInput(form)
					]) : _List_Nil,
					_List_fromArray(
					[
						$author$project$Components$Admin$DataExportConfiguration$Form$viewIncrementalInput(form)
					]),
					isHintAdmin ? _List_fromArray(
					[
						$author$project$Components$Admin$DataExportConfiguration$Form$viewExcludeDefaultTablesInput(form),
						$author$project$Components$Admin$DataExportConfiguration$Form$viewFileNameFormatInput(form)
					]) : _List_Nil
				]));
	});
var $author$project$Components$Admin$DataExportConfiguration$Form$viewSaveButton = function (model) {
	return A3(
		$author$project$Ui$Button$view,
		{mm: 'Save settings'},
		_List_fromArray(
			[
				$author$project$Ui$Button$primary,
				$author$project$Ui$Button$submit,
				$author$project$Ui$Button$loading(
				_Utils_eq(model.k9, $author$project$Api$Data$Loading))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Save')
			]));
};
var $author$project$Components$Admin$DataExportConfiguration$Form$TestConnection = {$: 4};
var $author$project$Ui$Icon$TestConnection = 76;
var $author$project$Ui$Icon$testConnection = $author$project$Ui$Icon$viewIcon(76);
var $author$project$Components$Admin$DataExportConfiguration$Form$viewTestConnectionButton = function (model) {
	var disabled = function () {
		var _v0 = model.ahP;
		if (!_v0.$) {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2($elm$core$Maybe$map, $author$project$Utils$Form$dirty, model.SD));
		} else {
			return true;
		}
	}();
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$ml2]),
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Tooltip$view,
				_List_fromArray(
					[
						$author$project$Ui$Tooltip$placement(0),
						$author$project$Ui$Tooltip$active(disabled),
						$author$project$Ui$Tooltip$wide
					]),
				'You must save the settings before you can test the connection.',
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Test Connection'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Admin$DataExportConfiguration$Form$TestConnection),
								$author$project$Ui$Button$sm,
								$author$project$Ui$Button$icon($author$project$Ui$Icon$testConnection),
								$author$project$Ui$Button$disabled(disabled)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Test Connection')
							]))
					]))
			]));
};
var $author$project$Components$Admin$DataExportConfiguration$Form$view = function (_v0) {
	var model = _v0;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					$elm$html$Html$map($author$project$Components$Admin$DataExportConfiguration$Form$TestConnectionModalMsg),
					A2($elm$core$Maybe$map, $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$view, model.lL))),
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					$elm$html$Html$map($author$project$Components$Admin$DataExportConfiguration$Form$ExportModalMsg),
					A2($elm$core$Maybe$map, $author$project$Components$Admin$DataExportConfiguration$ExportModal$view, model.jI))),
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$noValidate(true),
						$author$project$Ui$Form$autocomplete(false),
						$author$project$Ui$Form$onSubmit($author$project$Components$Admin$DataExportConfiguration$Form$UpdateDataExportConfiguration)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_fromArray(
									[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												function () {
												var _v1 = _Utils_Tuple2(model.ahP, model.uL);
												if (!_v1.a.$) {
													if (_v1.b) {
														return $author$project$Utils$Html$empty;
													} else {
														return $elm$html$Html$text('Edit');
													}
												} else {
													var _v2 = _v1.a;
													return $elm$html$Html$text('Add data export settings');
												}
											}()
											])),
										model.uL ? $author$project$Utils$Html$empty : A3(
										$author$project$Ui$Link$route,
										$author$project$Components$Admin$DataExportConfiguration$Form$backRoute(model),
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Ui$Icon$cross(_List_Nil)
											]))
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								function () {
									var _v3 = model.SD;
									if (!_v3.$) {
										var form = _v3.a;
										return A2($author$project$Components$Admin$DataExportConfiguration$Form$viewForm, model.Ij, form);
									} else {
										return _List_fromArray(
											[
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$textCenter]),
												_List_fromArray(
													[
														$author$project$Ui$Spinner$view(_List_Nil)
													]))
											]);
									}
								}()),
								A2(
								$author$project$Ui$Panel$footer,
								_List_fromArray(
									[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$itemsCenter]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										$author$project$Components$Admin$DataExportConfiguration$Form$backRoute(model),
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Back')
											])),
										$author$project$Components$Admin$DataExportConfiguration$Form$viewSaveButton(model),
										$author$project$Components$Admin$DataExportConfiguration$Form$viewTestConnectionButton(model),
										$author$project$Components$Admin$DataExportConfiguration$Form$viewExportButton(model)
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Admin$DataExportSettings$Id_String$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Admin$DataExportConfiguration$Form$view(model.SD))
			]),
		ac9: 'Admin | Data Exporter | Settings'
	};
};
var $author$project$Pages$Admin$DataExportSettings$Id_String$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$DataExportSettings$Id_String$init, aiq: $author$project$Pages$Admin$DataExportSettings$Id_String$load, k8: $author$project$Pages$Admin$DataExportSettings$Id_String$save, alO: $author$project$Pages$Admin$DataExportSettings$Id_String$subscriptions, adT: $author$project$Pages$Admin$DataExportSettings$Id_String$update, amo: $author$project$Pages$Admin$DataExportSettings$Id_String$view});
var $author$project$Pages$Admin$DataExportSettings$New$DataExportConfigurationFormMsg = $elm$core$Basics$identity;
var $author$project$Pages$Admin$DataExportSettings$New$init = F4(
	function (_v0, _v1, shared, _v2) {
		var query = _v2.DE;
		var singleton = _Utils_eq(
			A2($elm$core$Dict$get, 'singleton', query),
			$elm$core$Maybe$Just('true'));
		var _v3 = A4(
			$author$project$Components$Admin$DataExportConfiguration$Form$init,
			shared.Gv,
			$author$project$Shared$isHintAdmin(shared),
			$elm$core$Maybe$Nothing,
			singleton);
		var form = _v3.a;
		var cmd = _v3.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, SD: form, uL: singleton},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
	});
var $author$project$Pages$Admin$DataExportSettings$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$DataExportSettings$New$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$DataExportSettings$New$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Admin$DataExportConfiguration$Form$subscriptions(model.SD));
};
var $author$project$Api$Provider$DataExportConfiguration$One$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$DataExportConfiguration$Shared$id(shared);
};
var $author$project$Pages$Admin$DataExportSettings$New$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var dataExportConfigurationFormResult = A3($author$project$Components$Admin$DataExportConfiguration$Form$update, model.Gv, subMsg, model.SD);
		var cmd = function () {
			var _v1 = dataExportConfigurationFormResult.agZ;
			if (_v1.$ === 1) {
				var dataExportConfiguration = _v1.a;
				return A2(
					$author$project$Utils$Route$navigate,
					$elm$core$Dict$fromList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'singleton',
								model.uL ? 'true' : 'false')
							])),
					$author$project$Spa$Generated$Route$Admin__DataExportSettings__Id_String(
						{
							ahP: $author$project$Api$Provider$DataExportConfiguration$One$id(dataExportConfiguration)
						}));
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		}();
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{SD: dataExportConfigurationFormResult.aiO}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, dataExportConfigurationFormResult.GZ),
						cmd
					])),
			dataExportConfigurationFormResult.aR);
	});
var $author$project$Pages$Admin$DataExportSettings$New$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Admin$DataExportConfiguration$Form$view(model.SD))
			]),
		ac9: 'Admin | Data Exporter | Settings'
	};
};
var $author$project$Pages$Admin$DataExportSettings$New$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$DataExportSettings$New$init, aiq: $author$project$Pages$Admin$DataExportSettings$New$load, k8: $author$project$Pages$Admin$DataExportSettings$New$save, alO: $author$project$Pages$Admin$DataExportSettings$New$subscriptions, adT: $author$project$Pages$Admin$DataExportSettings$New$update, amo: $author$project$Pages$Admin$DataExportSettings$New$view});
var $author$project$Pages$Admin$DataExportSettings$Top$GotDataExportConfigurations = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$DataExportConfiguration$All$DataExportConfiguration = $elm$core$Basics$identity;
var $author$project$Api$Provider$DataExportConfiguration$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$DataExportConfiguration$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$DataExportConfiguration$listDefaults = {ajJ: $author$project$Api$Pagination$init};
var $author$project$Api$Provider$DataExportConfiguration$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$DataExportConfiguration$listDefaults);
	return $author$project$Api$Pagination$toApiParams(options.ajJ);
};
var $author$project$Api$Provider$DataExportConfiguration$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$DataExportConfiguration$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$DataExportConfiguration$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$DataExportConfiguration$dataExportConfigurationsPath)));
	});
var $author$project$Pages$Admin$DataExportSettings$Top$fetchDataExportConfigurations = function (model) {
	return A3(
		$author$project$Api$Provider$DataExportConfiguration$list,
		model.Gv,
		function (d) {
			return _Utils_update(
				d,
				{ajJ: model.ajJ});
		},
		$author$project$Pages$Admin$DataExportSettings$Top$GotDataExportConfigurations);
};
var $author$project$Pages$Admin$DataExportSettings$Top$init = F4(
	function (_v0, _v1, _v2, _v3) {
		var apiClient = _v2.Gv;
		var query = _v3.DE;
		var model = {
			Gv: apiClient,
			rY: $author$project$Api$Data$NotAsked,
			jI: $elm$core$Maybe$Nothing,
			ajJ: $author$project$Api$Pagination$initFromQuery(query),
			lL: $elm$core$Maybe$Nothing
		};
		return _Utils_Tuple2(
			model,
			$author$project$Pages$Admin$DataExportSettings$Top$fetchDataExportConfigurations(model));
	});
var $author$project$Pages$Admin$DataExportSettings$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$DataExportSettings$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$DataExportSettings$Top$ExportModalMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$DataExportSettings$Top$TestConnectionModalMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Admin$DataExportSettings$Top$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Platform$Sub$map($author$project$Pages$Admin$DataExportSettings$Top$TestConnectionModalMsg),
					A2($elm$core$Maybe$map, $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$subscriptions, model.lL))),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Platform$Sub$map($author$project$Pages$Admin$DataExportSettings$Top$ExportModalMsg),
					A2($elm$core$Maybe$map, $author$project$Components$Admin$DataExportConfiguration$ExportModal$subscriptions, model.jI)))
			]));
};
var $author$project$Api$Provider$DataExportConfiguration$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$DataExportConfiguration$Shared$id(shared);
};
var $author$project$Api$Provider$DataExportConfiguration$All$toShared = function (_v0) {
	var shared = _v0;
	return shared;
};
var $author$project$Pages$Admin$DataExportSettings$Top$updateUrl = function (model) {
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Admin__DataExportSettings__Top)
				]),
			$author$project$Api$Pagination$toPageQuery(model.ajJ)));
};
var $author$project$Pages$Admin$DataExportSettings$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var dataExportConfigurations = response.a;
					var headers = response.b;
					var cmd = function () {
						var _v2 = _Utils_Tuple2(
							$elm$core$List$length(dataExportConfigurations),
							$elm$core$List$head(dataExportConfigurations));
						_v2$2:
						while (true) {
							switch (_v2.a) {
								case 0:
									return A2(
										$author$project$Utils$Route$navigate,
										$elm$core$Dict$fromList(
											_List_fromArray(
												[
													_Utils_Tuple2('singleton', 'true')
												])),
										$author$project$Spa$Generated$Route$Admin__DataExportSettings__New);
								case 1:
									if (!_v2.b.$) {
										var dataExportConfiguration = _v2.b.a;
										return A2(
											$author$project$Utils$Route$navigate,
											$elm$core$Dict$fromList(
												_List_fromArray(
													[
														_Utils_Tuple2('singleton', 'true')
													])),
											$author$project$Spa$Generated$Route$Admin__DataExportSettings__Id_String(
												{
													ahP: $author$project$Api$Provider$DataExportConfiguration$All$id(dataExportConfiguration)
												}));
									} else {
										break _v2$2;
									}
								default:
									break _v2$2;
							}
						}
						return $elm$core$Platform$Cmd$none;
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								rY: response,
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
							}),
						cmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Admin$DataExportSettings$Top$fetchDataExportConfigurations(newModel),
								$author$project$Pages$Admin$DataExportSettings$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 2:
				var dataExportConfiguration = msg.a;
				var modalModel = $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$init(
					$author$project$Api$Provider$DataExportConfiguration$All$toShared(dataExportConfiguration));
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							lL: $elm$core$Maybe$Just(modalModel)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var subMsg = msg.a;
				var _v3 = model.lL;
				if (!_v3.$) {
					var modalModel = _v3.a;
					var testConnectionModalResult = A3($author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$update, model.Gv, subMsg, modalModel);
					var testConnectionModal = function () {
						var _v4 = testConnectionModalResult.agZ;
						if (!_v4) {
							return $elm$core$Maybe$Just(testConnectionModalResult.aiO);
						} else {
							return $elm$core$Maybe$Nothing;
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{lL: testConnectionModal}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$DataExportSettings$Top$TestConnectionModalMsg, testConnectionModalResult.GZ),
						testConnectionModalResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				var id = msg.a;
				var _v5 = A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Pages$Admin$DataExportSettings$Top$ExportModalMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						$elm$core$Maybe$Just,
						A2($author$project$Components$Admin$DataExportConfiguration$ExportModal$init, model.Gv, id)));
				var exportModal = _v5.a;
				var exportModalCmd = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{jI: exportModal}),
					exportModalCmd,
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v6 = model.jI;
				if (!_v6.$) {
					var exportModal = _v6.a;
					var exportModalResult = A3($author$project$Components$Admin$DataExportConfiguration$ExportModal$update, model.Gv, subMsg, exportModal);
					var updatedExportModal = function () {
						var _v7 = exportModalResult.agZ;
						switch (_v7) {
							case 0:
								return $elm$core$Maybe$Just(exportModalResult.aiO);
							case 1:
								return $elm$core$Maybe$Nothing;
							default:
								return $elm$core$Maybe$Nothing;
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jI: updatedExportModal}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$DataExportSettings$Top$ExportModalMsg, exportModalResult.GZ),
						exportModalResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Admin$DataExportSettings$Top$PaginationMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Column$NonSortable = {$: 1};
var $author$project$Pages$Admin$DataExportSettings$Top$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'destination', false, 'Destination'),
		A3($author$project$Api$Column$init, 'enabled', false, 'Enabled')
	]);
var $author$project$Pages$Admin$DataExportSettings$Top$OpenExportModal = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$DataExportSettings$Top$TestConnection = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$DataExportConfiguration$All$enabled = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$DataExportConfiguration$Shared$enabled(shared);
};
var $author$project$Pages$Admin$DataExportSettings$Top$viewDataExportConfiguration = function (dataExportConfiguration) {
	var id = $author$project$Api$Provider$DataExportConfiguration$All$id(dataExportConfiguration);
	return A2(
		$author$project$Ui$Table$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Components$Admin$DataExportConfiguration$Utils$destinationDescription(
							$author$project$Api$Provider$DataExportConfiguration$All$toShared(dataExportConfiguration)))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Formatters$Bool$toString(
									$author$project$Api$Provider$DataExportConfiguration$All$enabled(dataExportConfiguration)))
							]))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_fromArray(
					[
						$author$project$Ui$Table$minWidth('11rem'),
						$author$project$Ui$Table$textRight
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Admin__DataExportSettings__Id_String(
							{ahP: id}),
						_List_fromArray(
							[
								$author$project$Ui$Link$sm,
								$author$project$Ui$Link$icon($author$project$Ui$Icon$edit)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Edit')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Test Connection'},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$onClick(
								$author$project$Pages$Admin$DataExportSettings$Top$TestConnection(dataExportConfiguration)),
								$author$project$Ui$Button$sm,
								$author$project$Ui$Button$icon($author$project$Ui$Icon$testConnection)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Test Connection')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Export Now'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick(
								$author$project$Pages$Admin$DataExportSettings$Top$OpenExportModal(id)),
								$author$project$Ui$Button$icon($author$project$Ui$Icon$add),
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$sm
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Export Now')
							]))
					]))
			]));
};
var $author$project$Pages$Admin$DataExportSettings$Top$viewPanelBody = function (model) {
	var _v0 = function () {
		var _v1 = model.rY;
		if (_v1.$ === 3) {
			var dataExportConfigurations_ = _v1.a;
			return _Utils_Tuple2(false, dataExportConfigurations_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var dataExportConfigurations = _v0.b;
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mb4]),
			_List_fromArray(
				[
					$elm$html$Html$text('Manage settings.')
				])),
			A4(
			$author$project$Ui$Table$view,
			_List_fromArray(
				[
					$author$project$Ui$Table$verticalCentered,
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('No settings found.')
						])),
					$author$project$Ui$Table$loading(loading)
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						A2(
						$elm$core$List$map,
						$author$project$Api$Column$view($author$project$Api$Column$NonSortable),
						$author$project$Pages$Admin$DataExportSettings$Top$columns),
						_List_fromArray(
						[
							A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
						])
					])),
			A2($elm$core$List$map, $author$project$Pages$Admin$DataExportSettings$Top$viewDataExportConfiguration, dataExportConfigurations),
			_List_Nil)
		]);
};
var $author$project$Pages$Admin$DataExportSettings$Top$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					$elm$html$Html$map($author$project$Pages$Admin$DataExportSettings$Top$TestConnectionModalMsg),
					A2($elm$core$Maybe$map, $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$view, model.lL))),
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					$elm$html$Html$map($author$project$Pages$Admin$DataExportSettings$Top$ExportModalMsg),
					A2($elm$core$Maybe$map, $author$project$Components$Admin$DataExportConfiguration$ExportModal$view, model.jI))),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$flex, $author$project$Ui$Element$justifyRight]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Admin__DataExportSettings__New,
										_List_fromArray(
											[
												$author$project$Ui$Link$buttonDefault,
												$author$project$Ui$Link$icon($author$project$Ui$Icon$add)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('New Data Exporter')
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						$author$project$Pages$Admin$DataExportSettings$Top$viewPanelBody(model)),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								function () {
								var _v0 = model.rY;
								if (_v0.$ === 3) {
									return A2(
										$elm$html$Html$map,
										$author$project$Pages$Admin$DataExportSettings$Top$PaginationMsg,
										A2($author$project$Api$Pagination$view, _List_Nil, model.ajJ));
								} else {
									return $author$project$Utils$Html$empty;
								}
							}()
							]))
					]))
			]),
		ac9: 'Admin | Data Exporter | Settings'
	};
};
var $author$project$Pages$Admin$DataExportSettings$Top$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$DataExportSettings$Top$init, aiq: $author$project$Pages$Admin$DataExportSettings$Top$load, k8: $author$project$Pages$Admin$DataExportSettings$Top$save, alO: $author$project$Pages$Admin$DataExportSettings$Top$subscriptions, adT: $author$project$Pages$Admin$DataExportSettings$Top$update, amo: $author$project$Pages$Admin$DataExportSettings$Top$view});
var $author$project$Pages$Admin$Developers$ApiKeys$GotManagedPartner = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Practice$One$hasManagedPartner = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Td;
	});
var $author$project$Api$Provider$ManagedPartner$One$ManagedPartner = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$ManagedPartner$Shared$ManagedPartner = $elm$core$Basics$identity;
var $author$project$Api$Provider$ManagedPartner$Shared$Record = F4(
	function (id, webhooksSignatureApiKey, sandboxEnabled, appEnabled) {
		return {ae_: appEnabled, ahP: id, aao: sandboxEnabled, aeu: webhooksSignatureApiKey};
	});
var $author$project$Api$Provider$ApiKey$Shared$ApiKey = $elm$core$Basics$identity;
var $author$project$Api$Provider$ApiKey$Shared$Record = F6(
	function (id, token, label, createdAt, lastUsedAt, deactivatedAt) {
		return {O1: createdAt, PR: deactivatedAt, ahP: id, aih: label, VO: lastUsedAt, adi: token};
	});
var $author$project$Api$Provider$ApiKey$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'deactivated_at',
	$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'last_used_at',
		$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'created_at',
			$elm_community$json_extra$Json$Decode$Extra$datetime,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'label',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'token',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$ApiKey$Shared$Record)))))));
var $author$project$Api$Provider$ApiKey$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ApiKey$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$ManagedPartner$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'app_enabled',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'sandbox_enabled',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'webhooks_signature_api_key',
			$elm$json$Json$Decode$nullable($author$project$Api$Provider$ApiKey$Shared$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$ManagedPartner$Shared$Record)))));
var $author$project$Api$Provider$ManagedPartner$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ManagedPartner$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$ManagedPartner$One$Record = F2(
	function (integration, sandboxWebhooksSignatureApiKey) {
		return {T8: integration, aaq: sandboxWebhooksSignatureApiKey};
	});
var $author$project$Api$Provider$Integration$Shared$Integration = $elm$core$Basics$identity;
var $author$project$Api$Provider$Integration$Shared$Record = F4(
	function (id, status, authorizationCode, productName) {
		return {Me: authorizationCode, ahP: id, _x: productName, alH: status};
	});
var $author$project$Api$Provider$Integration$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'product_name',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'authorization_code',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'status',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$Integration$Shared$Record)))));
var $author$project$Api$Provider$Integration$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Integration$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$ManagedPartner$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'sandbox_webhooks_signature_api_key',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$ApiKey$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'integration',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Integration$Shared$decoder),
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$ManagedPartner$One$Record)));
var $author$project$Api$Provider$ManagedPartner$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ManagedPartner$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$ManagedPartner$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$ManagedPartner$One$ManagedPartner)));
var $author$project$Api$Provider$ManagedPartner$managedPartnerPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['managed_partner']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$ManagedPartner$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$ManagedPartner$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$managedPartnerPath));
	});
var $author$project$Pages$Admin$Developers$ApiKeys$init = F4(
	function (_v0, practice, shared, _v1) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, ka: $elm$core$Maybe$Nothing, s6: $author$project$Api$Data$Loading, k4: $elm$core$Maybe$Nothing, J7: shared.J7},
			$author$project$Api$Provider$Practice$One$hasManagedPartner(practice) ? A2($author$project$Api$Provider$ManagedPartner$retrieve, shared.Gv, $author$project$Pages$Admin$Developers$ApiKeys$GotManagedPartner) : A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Developers__GetStarted));
	});
var $author$project$Pages$Admin$Developers$ApiKeys$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Developers$ApiKeys$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Developers$ApiKeys$LiveMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$Developers$ApiKeys$SandboxMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Developers$ManageApiKeys$CancelEdit = {$: 5};
var $author$project$Components$Developers$ManageApiKeys$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Components$Developers$ManageApiKeys$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Developers$ManageApiKeys$CancelEdit)),
					model.Io)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Developers$ManageApiKeys$HiConfirmClosed),
					model.je))
			]));
};
var $author$project$Pages$Admin$Developers$ApiKeys$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Developers$ManageApiKeys$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Pages$Admin$Developers$ApiKeys$LiveMsg)),
					model.ka)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Developers$ManageApiKeys$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Pages$Admin$Developers$ApiKeys$SandboxMsg)),
					model.k4))
			]));
};
var $author$project$Components$Developers$ManageApiKeys$Integration = 1;
var $author$project$Components$Developers$ManageApiKeys$SandboxIntegration = 2;
var $author$project$Components$Developers$ManageApiKeys$GotManagedPartner = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Developers$ManageApiKeys$GotSandboxPractices = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Developers$ManageApiKeys$Model = $elm$core$Basics$identity;
var $author$project$Components$Developers$ManageApiKeys$GotApiKeys = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$ApiKey$Shared$createdAt = function (_v0) {
	var record = _v0;
	return record.O1;
};
var $author$project$Api$Provider$ApiKey$All$createdAt = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ApiKey$Shared$createdAt(shared);
};
var $author$project$Api$Provider$ApiKey$Shared$deactivatedAt = function (_v0) {
	var record = _v0;
	return record.PR;
};
var $author$project$Api$Provider$ApiKey$All$deactivatedAt = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ApiKey$Shared$deactivatedAt(shared);
};
var $author$project$Api$Provider$ApiKey$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$ApiKey$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ApiKey$Shared$id(shared);
};
var $author$project$Api$Provider$ApiKey$Shared$label = function (_v0) {
	var record = _v0;
	return record.aih;
};
var $author$project$Api$Provider$ApiKey$All$label = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ApiKey$Shared$label(shared);
};
var $author$project$Api$Provider$ApiKey$Shared$lastUsedAt = function (_v0) {
	var record = _v0;
	return record.VO;
};
var $author$project$Api$Provider$ApiKey$All$lastUsedAt = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ApiKey$Shared$lastUsedAt(shared);
};
var $author$project$Api$Provider$ApiKey$Shared$token = function (_v0) {
	var record = _v0;
	return record.adi;
};
var $author$project$Api$Provider$ApiKey$All$token = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ApiKey$Shared$token(shared);
};
var $author$project$Components$Developers$ManageApiKeys$fromAllApiKey = function (apiKey) {
	return {
		O1: $author$project$Api$Provider$ApiKey$All$createdAt(apiKey),
		PR: $author$project$Api$Provider$ApiKey$All$deactivatedAt(apiKey),
		ahP: $author$project$Api$Provider$ApiKey$All$id(apiKey),
		aih: $author$project$Api$Provider$ApiKey$All$label(apiKey),
		VO: $author$project$Api$Provider$ApiKey$All$lastUsedAt(apiKey),
		ZV: $elm$core$Maybe$Nothing,
		adi: $author$project$Api$Provider$ApiKey$All$token(apiKey)
	};
};
var $author$project$Api$Provider$ApiKey$Managed$createdAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ApiKey$Shared$createdAt(shared);
};
var $author$project$Api$Provider$ApiKey$Managed$deactivatedAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ApiKey$Shared$deactivatedAt(shared);
};
var $author$project$Api$Provider$ApiKey$Managed$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ApiKey$Shared$id(shared);
};
var $author$project$Api$Provider$ApiKey$Managed$label = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ApiKey$Shared$label(shared);
};
var $author$project$Api$Provider$ApiKey$Managed$lastUsedAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ApiKey$Shared$lastUsedAt(shared);
};
var $author$project$Api$Provider$ApiKey$Managed$practice = function (_v0) {
	var record = _v0.b;
	return record.ZV;
};
var $author$project$Api$Provider$ApiKey$Managed$token = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ApiKey$Shared$token(shared);
};
var $author$project$Components$Developers$ManageApiKeys$fromManagedApiKey = function (apiKey) {
	return {
		O1: $author$project$Api$Provider$ApiKey$Managed$createdAt(apiKey),
		PR: $author$project$Api$Provider$ApiKey$Managed$deactivatedAt(apiKey),
		ahP: $author$project$Api$Provider$ApiKey$Managed$id(apiKey),
		aih: $author$project$Api$Provider$ApiKey$Managed$label(apiKey),
		VO: $author$project$Api$Provider$ApiKey$Managed$lastUsedAt(apiKey),
		ZV: $elm$core$Maybe$Just(
			$author$project$Api$Provider$ApiKey$Managed$practice(apiKey)),
		adi: $author$project$Api$Provider$ApiKey$Managed$token(apiKey)
	};
};
var $author$project$Api$Provider$ManagedPartner$ApiKey$apiKeysPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['managed_partner', 'api_keys']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$ApiKey$All$ApiKey = $elm$core$Basics$identity;
var $author$project$Api$Provider$ApiKey$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ApiKey$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$ManagedPartner$ApiKey$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$ApiKey$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$ApiKey$apiKeysPath));
	});
var $author$project$Api$Provider$ManagedPartner$Integration$ApiKey$apiKeysPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['managed_partner', 'integration', 'api_keys']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$ManagedPartner$Integration$ApiKey$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$ApiKey$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$Integration$ApiKey$apiKeysPath));
	});
var $author$project$Api$Provider$ManagedPartner$Sandbox$ApiKey$apiKeysPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['managed_partner', 'sandboxes', 'api_keys']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$ApiKey$Managed$ApiKey = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$ApiKey$Managed$Record = function (practice) {
	return {ZV: practice};
};
var $author$project$Api$Provider$Practice$IdAndName$Practice = $elm$core$Basics$identity;
var $author$project$Api$Provider$Practice$IdAndName$Record = F2(
	function (id, name) {
		return {ahP: id, Bq: name};
	});
var $author$project$Api$Provider$Practice$IdAndName$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Practice$IdAndName$Record)));
var $author$project$Api$Provider$Practice$IdAndName$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Practice$IdAndName$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$ApiKey$Managed$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'practice',
	$author$project$Api$Provider$Practice$IdAndName$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$ApiKey$Managed$Record));
var $author$project$Api$Provider$ApiKey$Managed$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ApiKey$Managed$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$ApiKey$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$ApiKey$Managed$ApiKey)));
var $author$project$Api$Provider$ManagedPartner$Sandbox$ApiKey$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$ApiKey$Managed$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$Sandbox$ApiKey$apiKeysPath));
	});
var $author$project$Components$Developers$ManageApiKeys$fetchApiKeys = F2(
	function (apiClient, owner) {
		switch (owner) {
			case 0:
				return A2(
					$author$project$Api$Provider$ManagedPartner$ApiKey$list,
					apiClient,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Api$Data$map(
							$elm$core$List$map($author$project$Components$Developers$ManageApiKeys$fromAllApiKey)),
						$author$project$Components$Developers$ManageApiKeys$GotApiKeys));
			case 1:
				return A2(
					$author$project$Api$Provider$ManagedPartner$Integration$ApiKey$list,
					apiClient,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Api$Data$map(
							$elm$core$List$map($author$project$Components$Developers$ManageApiKeys$fromAllApiKey)),
						$author$project$Components$Developers$ManageApiKeys$GotApiKeys));
			default:
				return A2(
					$author$project$Api$Provider$ManagedPartner$Sandbox$ApiKey$list,
					apiClient,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Api$Data$map(
							$elm$core$List$map($author$project$Components$Developers$ManageApiKeys$fromManagedApiKey)),
						$author$project$Components$Developers$ManageApiKeys$GotApiKeys));
		}
	});
var $author$project$Api$Provider$Practice$All$Practice = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Practice$Min$Practice = $elm$core$Basics$identity;
var $author$project$Api$Provider$Practice$Min$Record = F2(
	function (id, name) {
		return {ahP: id, Bq: name};
	});
var $author$project$Api$Provider$Practice$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Practice$Min$Record)));
var $author$project$Api$Provider$Practice$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Practice$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Practice$All$Record = function (organizationId) {
	return {ajD: organizationId};
};
var $author$project$Api$Provider$Practice$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'organization_id',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Practice$All$Record));
var $author$project$Api$Provider$Practice$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Practice$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Practice$Min$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Practice$All$Practice)));
var $author$project$Api$Provider$ManagedPartner$Sandbox$Practice$sandboxPracticesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['managed_partner', 'sandboxes', 'practices']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$ManagedPartner$Sandbox$Practice$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Practice$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$Sandbox$Practice$sandboxPracticesPath));
	});
var $author$project$Components$Developers$ManageApiKeys$init = F3(
	function (apiClient, timeFormatter, owner) {
		var model = {
			ck: $author$project$Api$Data$Loading,
			je: $elm$core$Maybe$Nothing,
			Io: $elm$core$Maybe$Nothing,
			s6: $author$project$Api$Data$NotAsked,
			YD: owner,
			pP: (owner === 2) ? $author$project$Api$Data$Loading : $author$project$Api$Data$NotAsked,
			J7: timeFormatter,
			cd: $elm$core$Set$empty,
			dR: $elm$core$Set$empty
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Components$Developers$ManageApiKeys$fetchApiKeys, apiClient, owner),
						function () {
						switch (owner) {
							case 0:
								return A2($author$project$Api$Provider$ManagedPartner$retrieve, apiClient, $author$project$Components$Developers$ManageApiKeys$GotManagedPartner);
							case 1:
								return $elm$core$Platform$Cmd$none;
							default:
								return A2($author$project$Api$Provider$ManagedPartner$Sandbox$Practice$list, apiClient, $author$project$Components$Developers$ManageApiKeys$GotSandboxPractices);
						}
					}()
					])));
	});
var $author$project$Api$Provider$ManagedPartner$One$integration = function (_v0) {
	var record = _v0.b;
	return record.T8;
};
var $author$project$Components$Developers$ManageApiKeys$WebhooksSignatureApiKeyUpdated = F2(
	function (a, b) {
		return {$: 14, a: a, b: b};
	});
var $author$project$Ports$Clipboard$clipboardCopyPort = _Platform_outgoingPort('clipboardCopyPort', $elm$json$Json$Encode$string);
var $author$project$Ports$Clipboard$copy = function (string) {
	return $author$project$Ports$Clipboard$clipboardCopyPort(string);
};
var $author$project$Api$Provider$Practice$Min$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Practice$All$id = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Provider$Practice$Min$id(min);
};
var $author$project$Components$Developers$ManageApiKeys$defaultPracticeId = function (model) {
	var _v0 = model.pP;
	if ((_v0.$ === 3) && _v0.a.b) {
		var _v1 = _v0.a;
		var first = _v1.a;
		return $author$project$Api$Provider$Practice$All$id(first);
	} else {
		return '';
	}
};
var $author$project$Components$Developers$ManageApiKeys$Deleted = function (a) {
	return {$: 12, a: a};
};
var $author$project$Api$Provider$ManagedPartner$ApiKey$apiKeyPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$ManagedPartner$ApiKey$apiKeysPath);
};
var $author$project$Api$Provider$ManagedPartner$ApiKey$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$ManagedPartner$ApiKey$apiKeyPath(id_)));
	});
var $author$project$Api$Provider$ManagedPartner$Integration$ApiKey$apiKeyPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$ManagedPartner$Integration$ApiKey$apiKeysPath);
};
var $author$project$Api$Provider$ManagedPartner$Integration$ApiKey$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$ManagedPartner$Integration$ApiKey$apiKeyPath(id_)));
	});
var $author$project$Api$Provider$ManagedPartner$Sandbox$ApiKey$apiKeyPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$ManagedPartner$Sandbox$ApiKey$apiKeysPath);
};
var $author$project$Api$Provider$ManagedPartner$Sandbox$ApiKey$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$ManagedPartner$Sandbox$ApiKey$apiKeyPath(id_)));
	});
var $author$project$Components$Developers$ManageApiKeys$deleteCmd = F3(
	function (apiClient, owner, id_) {
		switch (owner) {
			case 0:
				return A3($author$project$Api$Provider$ManagedPartner$ApiKey$delete, apiClient, id_, $author$project$Components$Developers$ManageApiKeys$Deleted);
			case 1:
				return A3($author$project$Api$Provider$ManagedPartner$Integration$ApiKey$delete, apiClient, id_, $author$project$Components$Developers$ManageApiKeys$Deleted);
			default:
				return A3($author$project$Api$Provider$ManagedPartner$Sandbox$ApiKey$delete, apiClient, id_, $author$project$Components$Developers$ManageApiKeys$Deleted);
		}
	});
var $author$project$Api$Provider$Practice$IdAndName$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Components$Developers$ManageApiKeys$formFieldsFromItem = function (row) {
	return {
		aih: A2($elm$core$Maybe$withDefault, '', row.aih),
		Ji: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Practice$IdAndName$id, row.ZV))
	};
};
var $author$project$Components$Developers$ManageApiKeys$formFieldsInit = function (defaultPractice) {
	return {aih: '', Ji: defaultPractice};
};
var $author$project$Components$Developers$ManageApiKeys$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var string = field.a;
			return _Utils_update(
				fields,
				{aih: string});
		} else {
			var string = field.a;
			return _Utils_update(
				fields,
				{Ji: string});
		}
	});
var $author$project$Components$Developers$ManageApiKeys$ApiKeyLabelValidation = 0;
var $author$project$Components$Developers$ManageApiKeys$ApiKeyPracticeIdValidation = 1;
var $author$project$Components$Developers$ManageApiKeys$formFieldsValidator = function (owner) {
	return $rtfeldman$elm_validate$Validate$all(
		$elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						A2(
						$rtfeldman$elm_validate$Validate$ifBlank,
						function ($) {
							return $.aih;
						},
						_Utils_Tuple2(0, 'Please enter a label.'))
					]),
					(owner === 2) ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_validate$Validate$ifBlank,
						function ($) {
							return $.Ji;
						},
						_Utils_Tuple2(1, 'Please pick a sandbox practice.'))
					]) : _List_Nil
				])));
};
var $author$project$Components$Developers$ManageApiKeys$Created = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Developers$ManageApiKeys$Updated = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Provider$ApiKey$One$ApiKey = 0;
var $author$project$Api$Provider$ApiKey$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Provider$ManagedPartner$ApiKey$create = F3(
	function (apiClient, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'api_key',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'label',
								$elm$json$Json$Encode$string(params.aih))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$ApiKey$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$ApiKey$apiKeysPath)));
	});
var $author$project$Api$Provider$ManagedPartner$Integration$ApiKey$create = F3(
	function (apiClient, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'api_key',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'label',
								$elm$json$Json$Encode$string(params.aih))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$ApiKey$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$Integration$ApiKey$apiKeysPath)));
	});
var $author$project$Api$Provider$ManagedPartner$Sandbox$ApiKey$create = F3(
	function (apiClient, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'api_key',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'label',
								$elm$json$Json$Encode$string(params.aih)),
								_Utils_Tuple2(
								'practice_id',
								$elm$json$Json$Encode$string(params.Ji))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$ApiKey$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$Sandbox$ApiKey$apiKeysPath)));
	});
var $author$project$Api$Provider$ManagedPartner$ApiKey$update = F4(
	function (apiClient, id_, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'api_key',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'label',
								$elm$json$Json$Encode$string(params.aih))
							])))
				]));
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$ApiKey$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$ManagedPartner$ApiKey$apiKeyPath(id_))));
	});
var $author$project$Api$Provider$ManagedPartner$Integration$ApiKey$update = F4(
	function (apiClient, id_, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'api_key',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'label',
								$elm$json$Json$Encode$string(params.aih))
							])))
				]));
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$ApiKey$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$ManagedPartner$Integration$ApiKey$apiKeyPath(id_))));
	});
var $author$project$Api$Provider$ManagedPartner$Sandbox$ApiKey$update = F4(
	function (apiClient, id_, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'api_key',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'label',
								$elm$json$Json$Encode$string(params.aih))
							])))
				]));
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$ApiKey$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$ManagedPartner$Sandbox$ApiKey$apiKeyPath(id_))));
	});
var $author$project$Components$Developers$ManageApiKeys$saveCmd = F4(
	function (apiClient, owner, maybeRow, fields) {
		var _v0 = _Utils_Tuple2(maybeRow, owner);
		if (_v0.a.$ === 1) {
			switch (_v0.b) {
				case 0:
					var _v1 = _v0.a;
					var _v2 = _v0.b;
					return A3(
						$author$project$Api$Provider$ManagedPartner$ApiKey$create,
						apiClient,
						{aih: fields.aih},
						$author$project$Components$Developers$ManageApiKeys$Created);
				case 1:
					var _v3 = _v0.a;
					var _v4 = _v0.b;
					return A3(
						$author$project$Api$Provider$ManagedPartner$Integration$ApiKey$create,
						apiClient,
						{aih: fields.aih},
						$author$project$Components$Developers$ManageApiKeys$Created);
				default:
					var _v5 = _v0.a;
					var _v6 = _v0.b;
					return A3(
						$author$project$Api$Provider$ManagedPartner$Sandbox$ApiKey$create,
						apiClient,
						{aih: fields.aih, Ji: fields.Ji},
						$author$project$Components$Developers$ManageApiKeys$Created);
			}
		} else {
			switch (_v0.b) {
				case 0:
					var row = _v0.a.a;
					var _v7 = _v0.b;
					return A4(
						$author$project$Api$Provider$ManagedPartner$ApiKey$update,
						apiClient,
						row.ahP,
						{aih: fields.aih},
						$author$project$Components$Developers$ManageApiKeys$Updated);
				case 1:
					var row = _v0.a.a;
					var _v8 = _v0.b;
					return A4(
						$author$project$Api$Provider$ManagedPartner$Integration$ApiKey$update,
						apiClient,
						row.ahP,
						{aih: fields.aih},
						$author$project$Components$Developers$ManageApiKeys$Updated);
				default:
					var row = _v0.a.a;
					var _v9 = _v0.b;
					return A4(
						$author$project$Api$Provider$ManagedPartner$Sandbox$ApiKey$update,
						apiClient,
						row.ahP,
						{aih: fields.aih},
						$author$project$Components$Developers$ManageApiKeys$Updated);
			}
		}
	});
var $author$project$Api$Provider$ManagedPartner$updateWebhooksSignatureApiKey = F3(
	function (apiClient, id_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'webhooks_signature_api_key',
					$author$project$Utils$Encode$association(id_))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$ManagedPartner$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['webhooks_signature_api_key']),
						$author$project$Api$Provider$ManagedPartner$managedPartnerPath))));
	});
var $author$project$Components$Developers$ManageApiKeys$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ck: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{s6: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 2:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{pP: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							Io: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init(
										$author$project$Components$Developers$ManageApiKeys$formFieldsInit(
											$author$project$Components$Developers$ManageApiKeys$defaultPracticeId(model))),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var row = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							Io: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(row),
									$author$project$Utils$Form$init(
										$author$project$Components$Developers$ManageApiKeys$formFieldsFromItem(row)),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Io: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 6:
				var field = msg.a;
				var _v2 = model.Io;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var maybeRow = _v3.a;
					var form = _v3.b;
					var request = _v3.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Io: $elm$core$Maybe$Just(
									_Utils_Tuple3(
										maybeRow,
										A3($author$project$Utils$Form$update, $author$project$Components$Developers$ManageApiKeys$formFieldsUpdate, field, form),
										request))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var maybeRow = msg.a;
				var form = msg.b;
				var _v4 = A2(
					$author$project$Utils$Form$validate,
					$author$project$Components$Developers$ManageApiKeys$formFieldsValidator(model.YD),
					form);
				if (!_v4.$) {
					var _v5 = _v4.a;
					var validatedForm = _v5.a;
					var validFormFields = _v5.b;
					var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
					var cmd = A4($author$project$Components$Developers$ManageApiKeys$saveCmd, apiClient, model.YD, maybeRow, fields);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Io: $elm$core$Maybe$Just(
									_Utils_Tuple3(maybeRow, validatedForm, $author$project$Api$Data$Loading))
							}),
						cmd,
						_List_Nil);
				} else {
					var validatedForm = _v4.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Io: $elm$core$Maybe$Just(
									_Utils_Tuple3(maybeRow, validatedForm, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 8:
				var response = msg.a;
				var _v6 = model.Io;
				if (!_v6.$) {
					var _v7 = _v6.a;
					var maybeRow = _v7.a;
					var form = _v7.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{ck: $author$project$Api$Data$Loading, Io: $elm$core$Maybe$Nothing}),
							A2($author$project$Components$Developers$ManageApiKeys$fetchApiKeys, apiClient, model.YD),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'API key created.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									Io: $elm$core$Maybe$Just(
										_Utils_Tuple3(maybeRow, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var response = msg.a;
				var _v9 = model.Io;
				if (!_v9.$) {
					var _v10 = _v9.a;
					var maybeRow = _v10.a;
					var form = _v10.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{ck: $author$project$Api$Data$Loading, Io: $elm$core$Maybe$Nothing}),
							A2($author$project$Components$Developers$ManageApiKeys$fetchApiKeys, apiClient, model.YD),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'API key updated.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									Io: $elm$core$Maybe$Just(
										_Utils_Tuple3(maybeRow, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 10:
				var row = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							je: $elm$core$Maybe$Just(row)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 11:
				var row = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{je: $elm$core$Maybe$Nothing}),
					A3($author$project$Components$Developers$ManageApiKeys$deleteCmd, apiClient, model.YD, row.ahP),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{je: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 12:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ck: $author$project$Api$Data$Loading}),
						A2($author$project$Components$Developers$ManageApiKeys$fetchApiKeys, apiClient, model.YD),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'API key deleted.')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 13:
				var row = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							cd: A2($elm$core$Set$insert, row.ahP, model.cd)
						}),
					A3(
						$author$project$Api$Provider$ManagedPartner$updateWebhooksSignatureApiKey,
						apiClient,
						row.ahP,
						$author$project$Components$Developers$ManageApiKeys$WebhooksSignatureApiKeyUpdated(row)),
					_List_Nil);
			case 14:
				var row = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								s6: response,
								cd: A2($elm$core$Set$remove, row.ahP, model.cd)
							}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Webhooks signature API key updated.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cd: A2($elm$core$Set$remove, row.ahP, model.cd)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 15:
				var tokenStr = msg.a;
				var visibleApiKeyTokens = A2($elm$core$Set$member, tokenStr, model.dR) ? A2($elm$core$Set$remove, tokenStr, model.dR) : A2($elm$core$Set$insert, tokenStr, model.dR);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dR: visibleApiKeyTokens}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var tokenStr = msg.a;
				return _Utils_Tuple3(
					model,
					$author$project$Ports$Clipboard$copy(tokenStr),
					_List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 3, 'Copied to clipboard.')
						]));
		}
	});
var $author$project$Pages$Admin$Developers$ApiKeys$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var managedPartner = response.a;
					var _v2 = $author$project$Api$Provider$ManagedPartner$One$integration(managedPartner);
					if (!_v2.$) {
						var _v3 = A3($author$project$Components$Developers$ManageApiKeys$init, model.Gv, model.J7, 2);
						var sandboxKeys = _v3.a;
						var sandboxCmd = _v3.b;
						var _v4 = A3($author$project$Components$Developers$ManageApiKeys$init, model.Gv, model.J7, 1);
						var liveKeys = _v4.a;
						var liveCmd = _v4.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ka: $elm$core$Maybe$Just(liveKeys),
									s6: response,
									k4: $elm$core$Maybe$Just(sandboxKeys)
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Developers$ApiKeys$LiveMsg, liveCmd),
										A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Developers$ApiKeys$SandboxMsg, sandboxCmd)
									])),
							_List_Nil);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{s6: response}),
							A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Developers__GetStarted),
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{s6: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var _v5 = model.ka;
				if (!_v5.$) {
					var liveKeys = _v5.a;
					var _v6 = A3($author$project$Components$Developers$ManageApiKeys$update, model.Gv, subMsg, liveKeys);
					var updated = _v6.a;
					var cmd = _v6.b;
					var outMsgs = _v6.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ka: $elm$core$Maybe$Just(updated)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Developers$ApiKeys$LiveMsg, cmd),
						outMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var subMsg = msg.a;
				var _v7 = model.k4;
				if (!_v7.$) {
					var sandboxKeys = _v7.a;
					var _v8 = A3($author$project$Components$Developers$ManageApiKeys$update, model.Gv, subMsg, sandboxKeys);
					var updated = _v8.a;
					var cmd = _v8.b;
					var outMsgs = _v8.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								k4: $elm$core$Maybe$Just(updated)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Developers$ApiKeys$SandboxMsg, cmd),
						outMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Components$Developers$ManageApiKeys$CopyToken = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Developers$ManageApiKeys$Delete = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Developers$ManageApiKeys$Edit = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Developers$ManageApiKeys$New = {$: 3};
var $author$project$Components$Developers$ManageApiKeys$ToggleToken = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Developers$ManageApiKeys$UseForWebhooksSignature = function (a) {
	return {$: 13, a: a};
};
var $author$project$Ui$Icon$Copy = 15;
var $author$project$Ui$Icon$copy = $author$project$Ui$Icon$viewIcon(15);
var $author$project$Api$Provider$Practice$IdAndName$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Components$Developers$ManageApiKeys$viewDeleteButton = F4(
	function (disabled, loading, row, onDelete) {
		return A3(
			$author$project$Ui$Tooltip$view,
			_List_fromArray(
				[
					$author$project$Ui$Tooltip$active(disabled)
				]),
			'Can\'t remove the API key used for webhooks signature.',
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{mm: 'Delete API key'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$sm,
							$author$project$Ui$Button$loading(loading),
							$author$project$Ui$Button$onClick(
							onDelete(row)),
							$author$project$Ui$Button$icon($author$project$Ui$Icon$delete),
							$author$project$Ui$Button$disabled(disabled)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Delete')
						]))
				]));
	});
var $author$project$Components$Developers$ManageApiKeys$viewEditButton = F3(
	function (loading, row, onEdit) {
		return A3(
			$author$project$Ui$Button$view,
			{mm: 'Edit API key'},
			_List_fromArray(
				[
					$author$project$Ui$Button$link,
					$author$project$Ui$Button$sm,
					$author$project$Ui$Button$onClick(
					onEdit(row)),
					$author$project$Ui$Button$icon($author$project$Ui$Icon$edit),
					$author$project$Ui$Button$loading(loading)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Edit')
				]));
	});
var $author$project$Ui$Icon$Visibility = 54;
var $author$project$Ui$Icon$visibility = $author$project$Ui$Icon$viewIcon(54);
var $author$project$Ui$Icon$VisibilityOff = 55;
var $author$project$Ui$Icon$visibilityOff = $author$project$Ui$Icon$viewIcon(55);
var $author$project$Components$Developers$ManageApiKeys$viewApiKeyRow = F2(
	function (config, row) {
		var tokenStr = row.adi;
		var visible = A2($elm$core$Set$member, tokenStr, config.dR);
		var statusBadge = function () {
			var _v2 = row.PR;
			if (!_v2.$) {
				return A2(
					$author$project$Ui$Badge$view,
					_List_fromArray(
						[$author$project$Ui$Badge$danger]),
					_List_fromArray(
						[
							$elm$html$Html$text('Deactivated')
						]));
			} else {
				return A2(
					$author$project$Ui$Badge$view,
					_List_fromArray(
						[$author$project$Ui$Badge$success]),
					_List_fromArray(
						[
							$elm$html$Html$text('Active')
						]));
			}
		}();
		var practiceCell = config.ED ? _List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$elm$core$Maybe$withDefault,
							'—',
							A2($elm$core$Maybe$map, $author$project$Api$Provider$Practice$IdAndName$name, row.ZV)))
					]))
			]) : _List_Nil;
		var loading = A2($elm$core$Set$member, row.ahP, config.cd);
		var _v0 = visible ? _Utils_Tuple2($author$project$Ui$Icon$visibilityOff, 'Hide token') : _Utils_Tuple2($author$project$Ui$Icon$visibility, 'Show token');
		var visibleIcon = _v0.a;
		var visibleAriaLabel = _v0.b;
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						practiceCell,
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($elm$core$Maybe$withDefault, '—', row.aih))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$gap2]),
									_List_fromArray(
										[
											visible ? A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[$author$project$Ui$Typography$muted]),
											tokenStr) : A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[$author$project$Ui$Typography$muted]),
											$elm$core$String$concat(
												_List_fromArray(
													[
														A2(
														$elm$core$String$repeat,
														$elm$core$String$length(tokenStr) - 4,
														'•'),
														A2($elm$core$String$right, 4, tokenStr)
													]))),
											A3(
											$author$project$Ui$Button$view,
											{mm: visibleAriaLabel},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick(
													config.IU(tokenStr)),
													$author$project$Ui$Button$icon(visibleIcon)
												]),
											_List_Nil),
											A3(
											$author$project$Ui$Button$view,
											{mm: 'Copy token'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick(
													config.IT(tokenStr)),
													$author$project$Ui$Button$icon($author$project$Ui$Icon$copy)
												]),
											_List_Nil)
										]))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(config.J7, 5, row.O1))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'Never',
										A2(
											$elm$core$Maybe$map,
											config.J7(5),
											row.VO)))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[statusBadge])),
							A2(
							$author$project$Ui$Table$cell,
							_List_fromArray(
								[$author$project$Ui$Table$textRight]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$justifyRight, $author$project$Ui$Element$gap2]),
									function () {
										var _v1 = config.IV;
										if (!_v1.$) {
											var onUseForWebhooksSignature = _v1.a;
											var isWebhooksSignatureKey = _Utils_eq(
												$elm$core$Maybe$Just(row.ahP),
												config.Kr);
											return isWebhooksSignatureKey ? _List_fromArray(
												[
													A2(
													$author$project$Ui$Badge$view,
													_List_fromArray(
														[$author$project$Ui$Badge$info]),
													_List_fromArray(
														[
															$elm$html$Html$text('Webhooks Signature')
														])),
													A3($author$project$Components$Developers$ManageApiKeys$viewEditButton, loading, row, config.tq),
													A4($author$project$Components$Developers$ManageApiKeys$viewDeleteButton, true, loading, row, config.tp)
												]) : _List_fromArray(
												[
													A3(
													$author$project$Ui$Button$view,
													{mm: 'Use API key for webhooks signature'},
													_List_fromArray(
														[
															$author$project$Ui$Button$secondary,
															$author$project$Ui$Button$sm,
															$author$project$Ui$Button$onClick(
															onUseForWebhooksSignature(row)),
															$author$project$Ui$Button$loading(loading)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Use for webhooks signature')
														])),
													A3($author$project$Components$Developers$ManageApiKeys$viewEditButton, loading, row, config.tq),
													A4($author$project$Components$Developers$ManageApiKeys$viewDeleteButton, false, loading, row, config.tp)
												]);
										} else {
											return _List_fromArray(
												[
													A3($author$project$Components$Developers$ManageApiKeys$viewEditButton, loading, row, config.tq),
													A4($author$project$Components$Developers$ManageApiKeys$viewDeleteButton, false, loading, row, config.tp)
												]);
										}
									}())
								]))
						])
					])));
	});
var $author$project$Components$Developers$ManageApiKeys$viewApiKeysTable = function (config) {
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any API keys yet.')
					])),
				$author$project$Ui$Table$loading(config.V8)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					config.ED ? _List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Practice')
							]))
					]) : _List_Nil,
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Label')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Token')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Created')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Last Used')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Status')
							])),
						A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
					])
				])),
		A2(
			$elm$core$List$map,
			$author$project$Components$Developers$ManageApiKeys$viewApiKeyRow(config),
			config.ck),
		_List_Nil);
};
var $author$project$Components$Developers$ManageApiKeys$ApiKeyLabel = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Developers$ManageApiKeys$ApiKeyPracticeId = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Developers$ManageApiKeys$FormUpdated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Developers$ManageApiKeys$Save = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Api$Provider$Practice$Min$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$Practice$All$name = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Provider$Practice$Min$name(min);
};
var $author$project$Components$Developers$ManageApiKeys$viewCreateEditModal = F5(
	function (owner, sandboxPractices, maybeRow, form, request) {
		var modalConfig = {
			Tq: $elm$core$Maybe$Nothing,
			aih: 'API Key',
			V8: _Utils_eq(request, $author$project$Api$Data$Loading),
			WG: A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.ahP;
				},
				maybeRow),
			WH: $elm$core$Maybe$Nothing,
			Yd: $author$project$Components$Developers$ManageApiKeys$CancelEdit,
			Yf: $elm$core$Basics$always(
				A2($author$project$Components$Developers$ManageApiKeys$Save, maybeRow, form))
		};
		var fields = $author$project$Utils$Form$fields(form);
		var practicePicker = function () {
			var _v0 = _Utils_Tuple2(owner, maybeRow);
			if ((_v0.a === 2) && (_v0.b.$ === 1)) {
				var _v1 = _v0.a;
				var _v2 = _v0.b;
				var practices = function () {
					if (sandboxPractices.$ === 3) {
						var ps = sandboxPractices.a;
						return ps;
					} else {
						return _List_Nil;
					}
				}();
				return A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Sandbox practice')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(
									$elm$core$Maybe$Just(fields.Ji)),
									$author$project$Ui$Form$Select$onChange(
									A2($elm$core$Basics$composeL, $author$project$Components$Developers$ManageApiKeys$FormUpdated, $author$project$Components$Developers$ManageApiKeys$ApiKeyPracticeId)),
									$author$project$Ui$Form$Select$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 1, form))
								]),
							A2(
								$elm$core$List$map,
								function (practice) {
									return A3(
										$author$project$Ui$Form$Select$option,
										_List_Nil,
										$elm$core$Maybe$Just(
											$author$project$Api$Provider$Practice$All$id(practice)),
										$author$project$Api$Provider$Practice$All$name(practice));
								},
								practices)),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 1, form))
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}();
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					practicePicker,
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Label')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(fields.aih),
									$author$project$Ui$Form$Input$placeholder('e.g. Production'),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$Developers$ManageApiKeys$FormUpdated, $author$project$Components$Developers$ManageApiKeys$ApiKeyLabel)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form))
								])),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						]))
				]));
	});
var $author$project$Api$Provider$ManagedPartner$Shared$webhooksSignatureApiKey = function (_v0) {
	var record = _v0;
	return record.aeu;
};
var $author$project$Api$Provider$ManagedPartner$One$webhooksSignatureApiKey = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ManagedPartner$Shared$webhooksSignatureApiKey(shared);
};
var $author$project$Components$Developers$ManageApiKeys$view = function (_v0) {
	var model = _v0;
	var webhooksSignatureId = function () {
		var _v7 = model.s6;
		if (_v7.$ === 3) {
			var mp = _v7.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$ApiKey$Shared$id,
				$author$project$Api$Provider$ManagedPartner$One$webhooksSignatureApiKey(mp));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	var newDisabled = (model.YD === 2) && ((!_Utils_eq(model.pP, $author$project$Api$Data$Loading)) && ($author$project$Components$Developers$ManageApiKeys$defaultPracticeId(model) === ''));
	var _v1 = function () {
		var _v2 = model.YD;
		switch (_v2) {
			case 0:
				return _Utils_Tuple2(
					'API Keys',
					$elm$core$Maybe$Just($author$project$Components$Developers$ManageApiKeys$UseForWebhooksSignature));
			case 1:
				return _Utils_Tuple2('API Keys', $elm$core$Maybe$Nothing);
			default:
				return _Utils_Tuple2('Sandbox API Keys', $elm$core$Maybe$Nothing);
		}
	}();
	var panelTitle = _v1.a;
	var onUseForWebhooksSignature = _v1.b;
	return _List_fromArray(
		[
			function () {
			var _v3 = model.Io;
			if (!_v3.$) {
				var _v4 = _v3.a;
				var maybeRow = _v4.a;
				var form = _v4.b;
				var request = _v4.c;
				return A5($author$project$Components$Developers$ManageApiKeys$viewCreateEditModal, model.YD, model.pP, maybeRow, form, request);
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			function () {
			var _v5 = model.je;
			if (!_v5.$) {
				var row = _v5.a;
				return A2(
					$author$project$Components$HiConfirm$modal,
					$author$project$Components$Developers$ManageApiKeys$HiConfirmClosed(row),
					_List_fromArray(
						[
							$author$project$Components$HiConfirm$verb('delete'),
							$author$project$Components$HiConfirm$noun('API key'),
							$author$project$Components$HiConfirm$detail(
							A2($elm$core$Maybe$withDefault, 'API Key', row.aih))
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_fromArray(
						[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
					_List_fromArray(
						[
							$author$project$Ui$Panel$title(
							_List_fromArray(
								[
									$elm$html$Html$text(panelTitle)
								])),
							A3(
							$author$project$Ui$Button$view,
							{mm: 'New API key'},
							_List_fromArray(
								[
									$author$project$Ui$Button$default,
									$author$project$Ui$Button$onClick($author$project$Components$Developers$ManageApiKeys$New),
									$author$project$Ui$Button$icon($author$project$Ui$Icon$add),
									$author$project$Ui$Button$disabled(newDisabled)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('New API Key')
								]))
						])),
					$author$project$Components$Developers$ManageApiKeys$viewApiKeysTable(
					{
						ck: function () {
							var _v6 = model.ck;
							if (_v6.$ === 3) {
								var keys = _v6.a;
								return keys;
							} else {
								return _List_Nil;
							}
						}(),
						V8: _Utils_eq(model.ck, $author$project$Api$Data$Loading),
						IT: $author$project$Components$Developers$ManageApiKeys$CopyToken,
						tp: $author$project$Components$Developers$ManageApiKeys$Delete,
						tq: $author$project$Components$Developers$ManageApiKeys$Edit,
						IU: $author$project$Components$Developers$ManageApiKeys$ToggleToken,
						IV: onUseForWebhooksSignature,
						ED: model.YD === 2,
						J7: model.J7,
						cd: model.cd,
						dR: model.dR,
						Kr: webhooksSignatureId
					})
				]))
		]);
};
var $author$project$Ui$Skeleton$spanSm = $author$project$Ui$Skeleton$Span(1);
var $author$project$Components$Developers$ManageApiKeys$skeleton = A2(
	$author$project$Ui$Panel$view,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Panel$heading,
			_List_fromArray(
				[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
			_List_fromArray(
				[
					$author$project$Ui$Panel$title(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$spanMd(5)
								]))
						])),
					$author$project$Ui$Skeleton$input(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$spanSm(3)
						]))
				])),
			A2(
			$author$project$Ui$Panel$body,
			_List_Nil,
			A2(
				$elm$core$List$repeat,
				3,
				$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[$author$project$Ui$Skeleton$block]))))
		]));
var $author$project$Pages$Admin$Developers$ApiKeys$viewSkeleton = A2($elm$core$List$repeat, 2, $author$project$Components$Developers$ManageApiKeys$skeleton);
var $author$project$Pages$Admin$Developers$ApiKeys$view = function (model) {
	return {
		fO: function () {
			var _v0 = model.s6;
			if (_v0.$ === 1) {
				return $author$project$Pages$Admin$Developers$ApiKeys$viewSkeleton;
			} else {
				return $elm$core$List$concat(
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Components$Developers$ManageApiKeys$view,
									$elm$core$List$map(
										$elm$html$Html$map($author$project$Pages$Admin$Developers$ApiKeys$LiveMsg))),
								model.ka)),
							A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Components$Developers$ManageApiKeys$view,
									$elm$core$List$map(
										$elm$html$Html$map($author$project$Pages$Admin$Developers$ApiKeys$SandboxMsg))),
								model.k4))
						]));
			}
		}(),
		ac9: 'Admin | Developers | API Keys'
	};
};
var $author$project$Pages$Admin$Developers$ApiKeys$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Developers$ApiKeys$init, aiq: $author$project$Pages$Admin$Developers$ApiKeys$load, k8: $author$project$Pages$Admin$Developers$ApiKeys$save, alO: $author$project$Pages$Admin$Developers$ApiKeys$subscriptions, adT: $author$project$Pages$Admin$Developers$ApiKeys$update, amo: $author$project$Pages$Admin$Developers$ApiKeys$view});
var $author$project$Pages$Admin$Developers$App$GotApp = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$Developers$App$GotManagedPartner = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$ManagedPartner$App$appPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['managed_partner', 'app']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$App$One$App = 0;
var $author$project$Api$Provider$App$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Provider$ManagedPartner$App$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$App$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$App$appPath));
	});
var $author$project$Pages$Admin$Developers$App$init = F4(
	function (session, practice, shared, _v0) {
		var hasManagedPartner = $author$project$Api$Provider$Practice$One$hasManagedPartner(practice);
		return _Utils_Tuple2(
			{
				Gv: shared.Gv,
				rl: $author$project$Api$Data$Loading,
				m0: $author$project$Api$Data$NotAsked,
				Ik: A2($author$project$Utils$User$isViewingAsHinter, session, shared.ahK),
				s6: $author$project$Api$Data$Loading
			},
			hasManagedPartner ? $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Api$Provider$ManagedPartner$retrieve, shared.Gv, $author$project$Pages$Admin$Developers$App$GotManagedPartner),
						A2($author$project$Api$Provider$ManagedPartner$App$retrieve, shared.Gv, $author$project$Pages$Admin$Developers$App$GotApp)
					])) : A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Developers__GetStarted));
	});
var $author$project$Pages$Admin$Developers$App$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Developers$App$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Developers$App$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$Developers$App$GotCreateApp = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$ManagedPartner$Shared$appEnabled = function (_v0) {
	var record = _v0;
	return record.ae_;
};
var $author$project$Api$Provider$ManagedPartner$One$appEnabled = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ManagedPartner$Shared$appEnabled(shared);
};
var $author$project$Api$Provider$ManagedPartner$App$create = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$App$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$App$appPath));
	});
var $author$project$Pages$Admin$Developers$App$isNotFound = function (data) {
	if ((data.$ === 2) && (data.a.$ === 5)) {
		var _v1 = data.a;
		return true;
	} else {
		return false;
	}
};
var $author$project$Pages$Admin$Developers$App$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var managedPartner = response.a;
					return ($author$project$Api$Provider$ManagedPartner$One$appEnabled(managedPartner) || model.Ik) ? _Utils_Tuple3(
						_Utils_update(
							model,
							{s6: response}),
						$elm$core$Platform$Cmd$none,
						_List_Nil) : _Utils_Tuple3(
						_Utils_update(
							model,
							{s6: response}),
						A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Developers__GetStarted),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{s6: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{rl: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$Pages$Admin$Developers$App$isNotFound(response) ? _List_Nil : $author$project$OutMsg$handleErrorResponse(response));
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{m0: $author$project$Api$Data$Loading}),
					A2($author$project$Api$Provider$ManagedPartner$App$create, model.Gv, $author$project$Pages$Admin$Developers$App$GotCreateApp),
					_List_Nil);
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					var app = response.a;
					var rels = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								rl: A2($author$project$Api$Data$Success, app, rels),
								m0: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Created your custom app.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{m0: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var text = msg.a;
				return _Utils_Tuple3(
					model,
					$author$project$Ports$Clipboard$copy(text),
					_List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 3, 'Copied to clipboard.')
						]));
		}
	});
var $author$project$Components$Developers$MarketplaceSkillSteps$BringCode = 0;
var $author$project$Pages$Admin$Developers$App$CopyClicked = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Developers$MarketplaceSkillSteps$KeyReady = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Developers$MarketplaceSkillSteps$NoKey = {$: 2};
var $author$project$Api$Provider$ManagedPartner$One$sandboxWebhooksSignatureApiKey = function (_v0) {
	var record = _v0.b;
	return record.aaq;
};
var $author$project$Pages$Admin$Developers$App$skillStepsConfig = function (managedPartner) {
	return {
		LU: function () {
			var _v0 = $author$project$Api$Provider$ManagedPartner$One$sandboxWebhooksSignatureApiKey(managedPartner);
			if (!_v0.$) {
				var key = _v0.a;
				return $author$project$Components$Developers$MarketplaceSkillSteps$KeyReady(
					$author$project$Api$Provider$ApiKey$Shared$token(key));
			} else {
				return $author$project$Components$Developers$MarketplaceSkillSteps$NoKey;
			}
		}(),
		SB: 0,
		Wo: $elm$core$Maybe$Just($author$project$Spa$Generated$Route$Admin__Developers__ApiKeys),
		Wp: true,
		g$: $author$project$Pages$Admin$Developers$App$CopyClicked
	};
};
var $author$project$Components$Developers$MarketplaceSkillSteps$flowText = F2(
	function (flow, managed) {
		var managedPrefix = managed ? 'managed ' : '';
		if (!flow) {
			return {zQ: 'Use the marketplace skill to package your repo and deploy it on our infrastructure via the Partner API.', zR: 'Bring your code, we host it', sX: 'Use the marketplace skill in ' + (managedPrefix + 'hosted mode'), Au: 'The skill audits your project for everything the marketplace contract needs, scaffolds anything missing, packages it, and pushes through the Partner API. Starting from an empty folder works too — it\'ll build the app from scratch.'};
		} else {
			return {zQ: 'Run the marketplace skill against your deployed app. It registers your handshake, connect, and anchor URLs through the Partner API.', zR: 'Bring everything', sX: 'Use the marketplace skill in ' + (managedPrefix + 'self-hosted mode'), Au: 'The skill audits your project, scaffolds anything missing for the marketplace contract, then prompts for your deployed URLs and registers them. Starting from an empty folder works too — it\'ll build the app from scratch first.'};
		}
	});
var $author$project$Components$Developers$MarketplaceSkillSteps$viewFlowHeader = function (flow) {
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Panel$title(
						_List_fromArray(
							[
								A2($author$project$Ui$Typography$text, _List_Nil, flow.zR)
							]))
					])),
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$muted]),
						_List_fromArray(
							[
								A2($author$project$Ui$Typography$text, _List_Nil, flow.zQ)
							]))
					]))
			]));
};
var $author$project$Components$Developers$MarketplaceSkillSteps$maskApiKey = function (token) {
	var len = $elm$core$String$length(token);
	return (len <= 12) ? token : _Utils_ap(
		A2($elm$core$String$left, 8, token),
		_Utils_ap(
			A2(
				$elm$core$String$repeat,
				A2($elm$core$Basics$max, 4, len - 12),
				'•'),
			A2($elm$core$String$right, 4, token)));
};
var $author$project$Components$Developers$MarketplaceSkillSteps$viewCopyableLine = function (_v0) {
	var onCopy = _v0.g$;
	var ariaLabel = _v0.mm;
	var display = _v0.zj;
	var value = _v0.aee;
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$gap2]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$pre,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$Ui$Typography$text, _List_Nil, display)
					])),
				A3(
				$author$project$Ui$Button$view,
				{mm: ariaLabel},
				_List_fromArray(
					[
						$author$project$Ui$Button$secondary,
						$author$project$Ui$Button$sm,
						$author$project$Ui$Button$icon($author$project$Ui$Icon$copy),
						$author$project$Ui$Button$onClick(
						onCopy(value))
					]),
				_List_fromArray(
					[
						A2($author$project$Ui$Typography$text, _List_Nil, 'Copy')
					]))
			]));
};
var $author$project$Components$Developers$MarketplaceSkillSteps$viewNoApiKey = A2(
	$author$project$Ui$Typography$p,
	_List_fromArray(
		[$author$project$Ui$Typography$muted]),
	_List_fromArray(
		[
			A2($author$project$Ui$Typography$text, _List_Nil, 'No API keys yet. Create one from the API Keys page, then come back here.')
		]));
var $author$project$Components$Developers$MarketplaceSkillSteps$viewStepApiKey = function (config) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap2]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$muted]),
				_List_fromArray(
					[
						A2($author$project$Ui$Typography$text, _List_Nil, 'Authenticates the marketplace skill against the Partner API.')
					])),
				function () {
				var _v0 = config.LU;
				switch (_v0.$) {
					case 0:
						return A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$span(6)
										])),
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$span(2)
										]))
								]));
					case 1:
						var token = _v0.a;
						return $author$project$Components$Developers$MarketplaceSkillSteps$viewCopyableLine(
							{
								mm: 'Copy API key',
								zj: $author$project$Components$Developers$MarketplaceSkillSteps$maskApiKey(token),
								g$: config.g$,
								aee: token
							});
					default:
						return $author$project$Components$Developers$MarketplaceSkillSteps$viewNoApiKey;
				}
			}(),
				function () {
				var _v1 = config.Wo;
				if (!_v1.$) {
					var route = _v1.a;
					return A3(
						$author$project$Ui$Link$route,
						route,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Ui$Typography$text, _List_Nil, 'Manage API keys')
							]));
				} else {
					return $elm$html$Html$text('');
				}
			}()
			]));
};
var $author$project$Components$Developers$MarketplaceSkillSteps$skillUrl = 'https://raw.githubusercontent.com/hinthealth/marketplace-skill/main/SKILL.md';
var $author$project$Components$Developers$MarketplaceSkillSteps$skillInstallPrompt = 'Install this marketplace skill: ' + $author$project$Components$Developers$MarketplaceSkillSteps$skillUrl;
var $author$project$Components$Developers$MarketplaceSkillSteps$viewStepInstall = function (config) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap2]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$muted]),
				_List_fromArray(
					[
						A2($author$project$Ui$Typography$text, _List_Nil, 'Give this prompt to your agent — it\'ll fetch the skill and drop it wherever your editor reads prompts from.')
					])),
				$author$project$Components$Developers$MarketplaceSkillSteps$viewCopyableLine(
				{mm: 'Copy install prompt', zj: $author$project$Components$Developers$MarketplaceSkillSteps$skillInstallPrompt, g$: config.g$, aee: $author$project$Components$Developers$MarketplaceSkillSteps$skillInstallPrompt}),
				A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
				_List_fromArray(
					[
						A2($author$project$Ui$Typography$text, _List_Nil, 'Works with any agent that can fetch URLs and write files. Every run, the skill checks for a newer version and asks before updating.')
					]))
			]));
};
var $author$project$Components$Developers$MarketplaceSkillSteps$viewStepPanel = function (opts) {
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Panel$title(
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$text,
								_List_fromArray(
									[$author$project$Ui$Typography$muted]),
								'Step ' + (opts.IO + ' · ')),
								A2($author$project$Ui$Typography$text, _List_Nil, opts.ac9)
							]))
					])),
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[opts.fO]))
			]));
};
var $author$project$Components$Developers$MarketplaceSkillSteps$viewStepRun = F2(
	function (config, flow) {
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap2]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$muted]),
					_List_fromArray(
						[
							A2($author$project$Ui$Typography$text, _List_Nil, 'Open your agent inside your project (or an empty folder if you\'re starting fresh) and tell it:')
						])),
					$author$project$Components$Developers$MarketplaceSkillSteps$viewCopyableLine(
					{mm: 'Copy kickoff prompt', zj: flow.sX, g$: config.g$, aee: flow.sX}),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$muted]),
					_List_fromArray(
						[
							A2($author$project$Ui$Typography$text, _List_Nil, flow.Au)
						]))
				]));
	});
var $author$project$Components$Developers$MarketplaceSkillSteps$view = function (config) {
	var flow = A2($author$project$Components$Developers$MarketplaceSkillSteps$flowText, config.SB, config.Wp);
	return _List_fromArray(
		[
			$author$project$Components$Developers$MarketplaceSkillSteps$viewFlowHeader(flow),
			$author$project$Components$Developers$MarketplaceSkillSteps$viewStepPanel(
			{
				fO: $author$project$Components$Developers$MarketplaceSkillSteps$viewStepInstall(config),
				IO: '1',
				ac9: 'Install the marketplace skill'
			}),
			$author$project$Components$Developers$MarketplaceSkillSteps$viewStepPanel(
			{
				fO: $author$project$Components$Developers$MarketplaceSkillSteps$viewStepApiKey(config),
				IO: '2',
				ac9: 'Copy your API key'
			}),
			$author$project$Components$Developers$MarketplaceSkillSteps$viewStepPanel(
			{
				fO: A2($author$project$Components$Developers$MarketplaceSkillSteps$viewStepRun, config, flow),
				IO: '3',
				ac9: 'Run the skill in your project'
			})
		]);
};
var $author$project$Pages$Admin$Developers$App$ClickedCreateApp = {$: 2};
var $author$project$Pages$Admin$Developers$App$isPending = function (data) {
	if (data.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Pages$Admin$Developers$App$viewCreateCta = function (model) {
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Panel$title(
						_List_fromArray(
							[
								A2($author$project$Ui$Typography$text, _List_Nil, 'Build a marketplace app')
							]))
					])),
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$muted]),
						_List_fromArray(
							[
								A2($author$project$Ui$Typography$text, _List_Nil, 'Create your custom app to get started. We\'ll set up your sandbox so you can run the marketplace skill against it.')
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mt3]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Create your custom app'},
								_List_fromArray(
									[
										$author$project$Ui$Button$primary,
										$author$project$Ui$Button$onClick($author$project$Pages$Admin$Developers$App$ClickedCreateApp),
										$author$project$Ui$Button$disabled(
										$author$project$Pages$Admin$Developers$App$isPending(model.m0))
									]),
								_List_fromArray(
									[
										A2($author$project$Ui$Typography$text, _List_Nil, 'Create your custom app')
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Admin$Developers$App$viewSkeleton = A2(
	$author$project$Ui$Panel$view,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Panel$body,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap2]),
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$span(6)
								])),
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$span(4)
								])),
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$span(3)
								]))
						]))
				]))
		]));
var $author$project$Pages$Admin$Developers$App$view = function (model) {
	return {
		fO: function () {
			var _v0 = _Utils_Tuple2(model.s6, model.rl);
			_v0$2:
			while (true) {
				if (_v0.a.$ === 3) {
					switch (_v0.b.$) {
						case 3:
							var _v1 = _v0.a;
							var managedPartner = _v1.a;
							var _v2 = _v0.b;
							return $author$project$Components$Developers$MarketplaceSkillSteps$view(
								$author$project$Pages$Admin$Developers$App$skillStepsConfig(managedPartner));
						case 2:
							if (_v0.b.a.$ === 5) {
								var _v3 = _v0.a;
								var _v4 = _v0.b.a;
								return _List_fromArray(
									[
										$author$project$Pages$Admin$Developers$App$viewCreateCta(model)
									]);
							} else {
								break _v0$2;
							}
						default:
							break _v0$2;
					}
				} else {
					break _v0$2;
				}
			}
			return _List_fromArray(
				[$author$project$Pages$Admin$Developers$App$viewSkeleton]);
		}(),
		ac9: 'Admin | Developers | Custom App'
	};
};
var $author$project$Pages$Admin$Developers$App$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Developers$App$init, aiq: $author$project$Pages$Admin$Developers$App$load, k8: $author$project$Pages$Admin$Developers$App$save, alO: $author$project$Pages$Admin$Developers$App$subscriptions, adT: $author$project$Pages$Admin$Developers$App$update, amo: $author$project$Pages$Admin$Developers$App$view});
var $author$project$Pages$Admin$Developers$GetStarted$GotManagedPartner = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$Developers$GetStarted$init = F4(
	function (session, practice, shared, _v0) {
		var hasManagedPartner = $author$project$Api$Provider$Practice$One$hasManagedPartner(practice);
		return _Utils_Tuple2(
			{
				Gv: shared.Gv,
				iX: $elm$core$Maybe$Nothing,
				m0: $author$project$Api$Data$NotAsked,
				Td: hasManagedPartner,
				Ij: A2($author$project$Utils$User$isViewingAsHinter, session, shared.ahK),
				s6: hasManagedPartner ? $author$project$Api$Data$Loading : $author$project$Api$Data$NotAsked
			},
			hasManagedPartner ? A2($author$project$Api$Provider$ManagedPartner$retrieve, shared.Gv, $author$project$Pages$Admin$Developers$GetStarted$GotManagedPartner) : $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Developers$GetStarted$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Developers$GetStarted$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Developers$GetStarted$PracticeUserResourceFilterMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$ResourceFilter$PracticeUser$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Components$ResourceFilter$PracticeUser$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.b8));
};
var $author$project$Pages$Admin$Developers$GetStarted$subscriptions = function (model) {
	var _v0 = model.iX;
	if (!_v0.$) {
		var modal = _v0.a;
		return A2(
			$elm$core$Platform$Sub$map,
			$author$project$Pages$Admin$Developers$GetStarted$PracticeUserResourceFilterMsg,
			$author$project$Components$ResourceFilter$PracticeUser$subscriptions(modal.b8));
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Pages$Admin$Developers$GetStarted$GotCreateIntegration = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$Developers$GetStarted$GotCreateManagedPartner = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$ManagedPartner$create = F3(
	function (apiClient, practiceUserIds, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'managed_partner',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'practice_user_ids',
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, practiceUserIds))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$ManagedPartner$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$managedPartnerPath)));
	});
var $author$project$Api$Provider$ManagedPartner$Integration$integrationPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['managed_partner', 'integration']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$ManagedPartner$Integration$create = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Integration$Shared$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$Integration$integrationPath));
	});
var $author$project$Api$Provider$TeamMember$Accepted = 0;
var $author$project$Api$Provider$PracticeUser$All$PracticeUser = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$PracticeUser$Shared$PracticeUser = $elm$core$Basics$identity;
var $author$project$Api$Provider$PracticeUser$Shared$Record = function (id) {
	return function (email) {
		return function (role) {
			return function (notificationsEnabled) {
				return function (invitationPending) {
					return function (isOwner) {
						return function (isDestroyable) {
							return function (restrictedByGroups) {
								return function (user) {
									return function (reportRestricted) {
										return {Rj: email, ahP: id, Ui: invitationPending, UN: isDestroyable, U0: isOwner, X$: notificationsEnabled, $x: reportRestricted, $T: restrictedByGroups, ak3: role, ad0: user};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$User$One$User = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$User$One$Record = function (mfaStatus) {
	return {W6: mfaStatus};
};
var $author$project$Api$Provider$User$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'mfa_status',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$User$One$Record));
var $author$project$Api$Provider$User$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$User$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$User$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$User$One$User)));
var $author$project$Api$Provider$PracticeUser$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'report_restricted',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'user',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$User$One$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'restricted_by_groups',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'is_destroyable',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'is_owner',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'invitation_pending',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'notifications_enabled',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'role',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'email',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticeUser$Shared$Record)))))))))));
var $author$project$Api$Provider$PracticeUser$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PracticeUser$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PracticeUser$All$Record = F2(
	function (invitationUrl, locationGroups) {
		return {Uj: invitationUrl, Wa: locationGroups};
	});
var $author$project$Api$Provider$LocationGroup$Min$LocationGroup = $elm$core$Basics$identity;
var $author$project$Api$Provider$LocationGroup$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$LocationGroup$Min$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PracticeUser$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'location_groups',
	$elm$json$Json$Decode$list($author$project$Api$Provider$LocationGroup$Min$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'invitation_url',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticeUser$All$Record)));
var $author$project$Api$Provider$PracticeUser$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PracticeUser$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$PracticeUser$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticeUser$All$PracticeUser)));
var $author$project$Api$Provider$TeamMember$filterToString = function (filter) {
	return 'accepted';
};
var $author$project$Api$Provider$TeamMember$listOptionalsDefaults = {HM: $elm$core$Maybe$Nothing, ahP: $elm$core$Maybe$Nothing, ajJ: $author$project$Api$Pagination$init, akl: $elm$core$Maybe$Nothing, alA: $author$project$Api$Sort$init};
var $author$project$Api$Provider$TeamMember$listOptionalsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$TeamMember$listOptionalsDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.akl;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.ahP;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.HM;
				if (!_v2.$) {
					var filter = _v2.a;
					return _List_fromArray(
						[
							A2(
							$author$project$Api$Param$string,
							'filter',
							$author$project$Api$Provider$TeamMember$filterToString(filter))
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$Provider$TeamMember$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$PracticeUser$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$TeamMember$listOptionalsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$TeamMember$teamMembersPath)));
	});
var $author$project$Components$ResourceFilter$PracticeUser$list = $author$project$Api$Provider$TeamMember$list;
var $author$project$Components$ResourceFilter$PracticeUser$fetchResources = F5(
	function (listOptionals, toMsg, apiClient, pagination, query) {
		return A3(
			$author$project$Components$ResourceFilter$PracticeUser$list,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{ajJ: pagination, akl: query});
				}),
			toMsg);
	});
var $author$project$Components$ResourceFilter$PracticeUser$retrieveResource = F4(
	function (listOptionals, toMsg, apiClient, id) {
		return A3(
			$author$project$Components$ResourceFilter$PracticeUser$list,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{
							ahP: $elm$core$Maybe$Just(id)
						});
				}),
			toMsg);
	});
var $author$project$Components$ResourceFilter$PracticeUser$selectId = 'practice-users';
var $author$project$Api$Provider$PracticeUser$Shared$email = function (_v0) {
	var record = _v0;
	return record.Rj;
};
var $author$project$Api$Provider$PracticeUser$All$email = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PracticeUser$Shared$email(shared);
};
var $author$project$Api$Provider$User$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$User$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$User$Shared$name(shared);
};
var $author$project$Api$Provider$PracticeUser$Shared$user = function (_v0) {
	var record = _v0;
	return record.ad0;
};
var $author$project$Api$Provider$PracticeUser$All$user = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PracticeUser$Shared$user(shared);
};
var $author$project$Components$ResourceFilter$PracticeUser$toTitle = function (resource) {
	var user = $author$project$Api$Provider$PracticeUser$All$user(resource);
	if (!user.$) {
		var user_ = user.a;
		return $author$project$Api$Provider$User$One$name(user_);
	} else {
		return $author$project$Api$Provider$PracticeUser$All$email(resource);
	}
};
var $author$project$Components$ResourceFilter$PracticeUser$toLabel = function (resource) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Components$ResourceFilter$PracticeUser$toTitle(resource))
		]);
};
var $author$project$Api$Provider$PracticeUser$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$PracticeUser$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PracticeUser$Shared$id(shared);
};
var $author$project$Components$ResourceFilter$PracticeUser$toValue = $author$project$Api$Provider$PracticeUser$All$id;
var $author$project$Components$ResourceFilter$PracticeUser$init = F3(
	function (apiClient, listOptionals, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{
				Sk: $author$project$Components$ResourceFilter$PracticeUser$fetchResources(listOptionals),
				ahP: $author$project$Components$ResourceFilter$PracticeUser$selectId,
				k$: 'User',
				uk: $author$project$Components$ResourceFilter$PracticeUser$retrieveResource(listOptionals),
				u9: $author$project$Components$ResourceFilter$PracticeUser$toLabel,
				lN: $author$project$Components$ResourceFilter$PracticeUser$toTitle,
				hX: $author$project$Components$ResourceFilter$PracticeUser$toValue
			},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{Jy: $author$project$Components$ResourceFilter$All, b8: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Pages$Admin$Developers$GetStarted$initResourceFilter = function (apiClient) {
	return A2(
		$elm$core$Tuple$mapSecond,
		$elm$core$Platform$Cmd$map($author$project$Pages$Admin$Developers$GetStarted$PracticeUserResourceFilterMsg),
		A3(
			$author$project$Components$ResourceFilter$PracticeUser$init,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						HM: $elm$core$Maybe$Just(0)
					});
			},
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Select practice users', Lr: false, ai5: false});
			}));
};
var $elm$core$Set$singleton = function (key) {
	return A2($elm$core$Dict$singleton, key, 0);
};
var $author$project$Pages$Admin$Developers$GetStarted$selectionFromChoice = function (choice) {
	switch (choice.$) {
		case 0:
			var practiceUser = choice.a;
			return $elm$core$Set$singleton(
				$author$project$Api$Provider$PracticeUser$All$id(practiceUser));
		case 1:
			var practiceUsers = choice.a;
			return $elm$core$Set$fromList(
				A2($elm$core$List$map, $author$project$Api$Provider$PracticeUser$All$id, practiceUsers));
		default:
			return $elm$core$Set$empty;
	}
};
var $author$project$Components$ResourceFilter$PracticeUser$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.b8);
		var modelAfterEvent = function () {
			var _v1 = result.agZ;
			if (!_v1.$) {
				var selected = _v1.a;
				return _Utils_update(
					model,
					{Jy: selected});
			} else {
				return model;
			}
		}();
		return {
			GZ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.GZ),
			agZ: result.agZ,
			aiO: _Utils_update(
				modelAfterEvent,
				{b8: result.aiO}),
			aR: result.aR
		};
	});
var $author$project$Pages$Admin$Developers$GetStarted$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var managedPartner = response.a;
					var _v2 = $author$project$Api$Provider$ManagedPartner$One$integration(managedPartner);
					if (!_v2.$) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{s6: response}),
							A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Developers__ApiKeys),
							_List_Nil);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{s6: response}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{s6: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{m0: $author$project$Api$Data$Loading}),
					A2($author$project$Api$Provider$ManagedPartner$Integration$create, model.Gv, $author$project$Pages$Admin$Developers$GetStarted$GotCreateIntegration),
					_List_Nil);
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{m0: response}),
						A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Developers__ApiKeys),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{m0: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 3:
				var _v4 = $author$project$Pages$Admin$Developers$GetStarted$initResourceFilter(model.Gv);
				var resourceFilter = _v4.a;
				var resourceFilterCmd = _v4.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							iX: $elm$core$Maybe$Just(
								{uf: $author$project$Api$Data$NotAsked, b8: resourceFilter, pU: $elm$core$Set$empty})
						}),
					resourceFilterCmd,
					_List_Nil);
			case 4:
				var subMsg = msg.a;
				var _v5 = model.iX;
				if (!_v5.$) {
					var modal = _v5.a;
					var result = A3($author$project$Components$ResourceFilter$PracticeUser$update, model.Gv, subMsg, modal.b8);
					var nextSelected = function () {
						var _v6 = result.agZ;
						if (!_v6.$) {
							var choice = _v6.a;
							return $author$project$Pages$Admin$Developers$GetStarted$selectionFromChoice(choice);
						} else {
							return modal.pU;
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								iX: $elm$core$Maybe$Just(
									_Utils_update(
										modal,
										{b8: result.aiO, pU: nextSelected}))
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Developers$GetStarted$PracticeUserResourceFilterMsg, result.GZ),
						result.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{iX: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 6:
				var _v7 = model.iX;
				if (!_v7.$) {
					var modal = _v7.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								iX: $elm$core$Maybe$Just(
									_Utils_update(
										modal,
										{uf: $author$project$Api$Data$Loading}))
							}),
						A3(
							$author$project$Api$Provider$ManagedPartner$create,
							model.Gv,
							$elm$core$Set$toList(modal.pU),
							$author$project$Pages$Admin$Developers$GetStarted$GotCreateManagedPartner),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{iX: $elm$core$Maybe$Nothing, Td: true, s6: $author$project$Api$Data$Loading}),
						A2($author$project$Api$Provider$ManagedPartner$retrieve, model.Gv, $author$project$Pages$Admin$Developers$GetStarted$GotManagedPartner),
						_List_fromArray(
							[
								$author$project$OutMsg$RefreshPractice,
								A2($author$project$OutMsg$ShowToast, 3, 'Managed partner created')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								iX: A2(
									$elm$core$Maybe$map,
									function (m) {
										return _Utils_update(
											m,
											{uf: response});
									},
									model.iX)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Admin$Developers$GetStarted$ClickedActivateIntegration = {$: 1};
var $author$project$Pages$Admin$Developers$GetStarted$activateIntegrationButton = function (model) {
	return A3(
		$author$project$Ui$HinterOnly$button,
		{mm: 'Activate integration'},
		_List_fromArray(
			[
				$author$project$Ui$Button$onClick($author$project$Pages$Admin$Developers$GetStarted$ClickedActivateIntegration),
				$author$project$Ui$Button$loading(
				_Utils_eq(model.m0, $author$project$Api$Data$Loading))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Activate Integration')
			]));
};
var $author$project$Pages$Admin$Developers$GetStarted$ClickedCreateManagedPartner = {$: 3};
var $author$project$Pages$Admin$Developers$GetStarted$createManagedPartnerButton = A3(
	$author$project$Ui$HinterOnly$button,
	{mm: 'Create managed partner'},
	_List_fromArray(
		[
			$author$project$Ui$Button$onClick($author$project$Pages$Admin$Developers$GetStarted$ClickedCreateManagedPartner)
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('Create Managed Partner')
		]));
var $author$project$Pages$Admin$Developers$GetStarted$headerButton = function (model) {
	return (!model.Ij) ? $author$project$Utils$Html$empty : (model.Td ? $author$project$Pages$Admin$Developers$GetStarted$activateIntegrationButton(model) : $author$project$Pages$Admin$Developers$GetStarted$createManagedPartnerButton);
};
var $author$project$Pages$Admin$Developers$GetStarted$CloseCreateModal = {$: 5};
var $author$project$Pages$Admin$Developers$GetStarted$SubmitCreateManagedPartner = {$: 6};
var $elm$core$Dict$isEmpty = function (dict) {
	if (dict.$ === -2) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Set$isEmpty = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$isEmpty(dict);
};
var $author$project$Components$ResourceFilter$Multi = {$: 6};
var $author$project$Components$ResourceFilter$multi = $author$project$Components$ResourceFilter$Multi;
var $author$project$Components$ResourceFilter$PracticeUser$view = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$view,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.Jy),
					options),
				model.b8));
	});
var $author$project$Ui$Button$Attrs = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Button$mb2 = $author$project$Ui$Button$Attrs(
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mb-1')
		]));
var $author$project$Ui$Icon$SpacedLeft = {$: 3};
var $author$project$Ui$Icon$spacedLeft = $author$project$Ui$Icon$SpacedLeft;
var $author$project$Components$ResourceFilter$viewMultiSelected_ = F2(
	function (model, items) {
		return A2(
			$elm$core$List$map,
			function (item) {
				return A3(
					$author$project$Ui$Button$view,
					{mm: 'Remove selection'},
					_List_fromArray(
						[
							$author$project$Ui$Button$onClick(
							$author$project$Components$ResourceFilter$DropdownItemChecked(
								A2(
									$author$project$Components$ResourceFilter$toggleItemSelection,
									$author$project$Components$ResourceFilter$Many(items),
									item))),
							$author$project$Ui$Button$sm,
							$author$project$Ui$Button$mb2
						]),
					A2(
						$elm$core$List$map,
						$elm$html$Html$map($elm$core$Basics$never),
						_List_fromArray(
							[
								$elm$html$Html$text(
								model.lN(item)),
								$author$project$Ui$Icon$cross(
								_List_fromArray(
									[$author$project$Ui$Icon$xs, $author$project$Ui$Icon$spacedLeft]))
							])));
			},
			items);
	});
var $author$project$Components$ResourceFilter$viewMultiSelected = F2(
	function (choice, model) {
		switch (choice.$) {
			case 3:
				return _List_fromArray(
					[
						$elm$html$Html$text('No ' + model.k$),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Remove selection'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick(
								$author$project$Components$ResourceFilter$DropdownItemChecked($author$project$Components$ResourceFilter$All)),
								$author$project$Ui$Button$sm,
								$author$project$Ui$Button$mb2
							]),
						_List_fromArray(
							[
								$author$project$Ui$Icon$cross(
								_List_fromArray(
									[$author$project$Ui$Icon$xs, $author$project$Ui$Icon$spacedLeft]))
							]))
					]);
			case 2:
				return _List_Nil;
			case 4:
				return _List_Nil;
			case 0:
				var item = choice.a;
				return A2(
					$author$project$Components$ResourceFilter$viewMultiSelected_,
					model,
					_List_fromArray(
						[item]));
			case 5:
				return _List_Nil;
			default:
				var items = choice.a;
				return A2($author$project$Components$ResourceFilter$viewMultiSelected_, model, items);
		}
	});
var $author$project$Components$ResourceFilter$PracticeUser$viewMultiSelected = function (model) {
	return A2(
		$elm$core$List$map,
		$elm$html$Html$map($elm$core$Basics$identity),
		A2($author$project$Components$ResourceFilter$viewMultiSelected, model.Jy, model.b8));
};
var $author$project$Pages$Admin$Developers$GetStarted$viewCreateModalBody = function (modal) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$spaceY4]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Select the practice users who should be added as admin partner users on the new managed partner. A sandbox partner and sandbox practice will also be created with an active integration between them.')
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$map,
						$author$project$Pages$Admin$Developers$GetStarted$PracticeUserResourceFilterMsg,
						A2(
							$author$project$Components$ResourceFilter$PracticeUser$view,
							_List_fromArray(
								[$author$project$Components$ResourceFilter$multi]),
							modal.b8)),
					A2(
						$elm$core$List$map,
						$elm$html$Html$map($author$project$Pages$Admin$Developers$GetStarted$PracticeUserResourceFilterMsg),
						$author$project$Components$ResourceFilter$PracticeUser$viewMultiSelected(modal.b8))))
			]));
};
var $author$project$Pages$Admin$Developers$GetStarted$viewCreateModal = function (modal) {
	var submitting = _Utils_eq(modal.uf, $author$project$Api$Data$Loading);
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Pages$Admin$Developers$GetStarted$CloseCreateModal,
		_List_fromArray(
			[
				$author$project$Ui$Modal$onSubmit($author$project$Pages$Admin$Developers$GetStarted$SubmitCreateManagedPartner)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Create Managed Partner')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						$author$project$Pages$Admin$Developers$GetStarted$viewCreateModalBody(modal)
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Cancel'},
						_List_fromArray(
							[
								$author$project$Ui$Button$default,
								$author$project$Ui$Button$onClick($author$project$Pages$Admin$Developers$GetStarted$CloseCreateModal),
								$author$project$Ui$Button$disabled(submitting)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Create managed partner'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$submit,
								$author$project$Ui$Button$loading(submitting),
								$author$project$Ui$Button$disabled(
								$elm$core$Set$isEmpty(modal.pU))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Create Managed Partner')
							]))
					]))
			]));
};
var $author$project$Ui$Link$Test = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Link$test = $author$project$Ui$Link$Test;
var $author$project$Pages$Admin$Developers$GetStarted$viewRequestAccess = A2(
	$elm$html$Html$div,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Typography$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Your practice doesn\'t have a developer integration yet. Request sandbox and API access to get started.')
				])),
			A3(
			$author$project$Ui$Link$externalHref,
			'https://developers.hint.com/docs/requesting-a-sandbox-and-api-access',
			_List_fromArray(
				[
					$author$project$Ui$Link$buttonPrimary,
					$author$project$Ui$Link$targetBlank,
					$author$project$Ui$Link$ariaLabel('Request sandbox and API access'),
					$author$project$Ui$Link$test('request-sandbox-and-api-access')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Request sandbox and API access')
				]))
		]));
var $author$project$Pages$Admin$Developers$GetStarted$viewRequestActivation = A2(
	$author$project$Ui$Typography$p,
	_List_Nil,
	_List_fromArray(
		[
			$elm$html$Html$text('Your integration is not set up yet. Please reach out to Hint support to have your API keys activated.')
		]));
var $author$project$Pages$Admin$Developers$GetStarted$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween]),
								_List_fromArray(
									[
										$author$project$Ui$Typography$headingSm(
										_List_fromArray(
											[
												$elm$html$Html$text('Get Started with Developer Settings')
											])),
										$author$project$Pages$Admin$Developers$GetStarted$headerButton(model)
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								model.Td ? $author$project$Pages$Admin$Developers$GetStarted$viewRequestActivation : $author$project$Pages$Admin$Developers$GetStarted$viewRequestAccess
							]))
					])),
				function () {
				var _v0 = model.iX;
				if (!_v0.$) {
					var modal = _v0.a;
					return $author$project$Pages$Admin$Developers$GetStarted$viewCreateModal(modal);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]),
		ac9: 'Admin | Developers | Get Started'
	};
};
var $author$project$Pages$Admin$Developers$GetStarted$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Developers$GetStarted$init, aiq: $author$project$Pages$Admin$Developers$GetStarted$load, k8: $author$project$Pages$Admin$Developers$GetStarted$save, alO: $author$project$Pages$Admin$Developers$GetStarted$subscriptions, adT: $author$project$Pages$Admin$Developers$GetStarted$update, amo: $author$project$Pages$Admin$Developers$GetStarted$view});
var $author$project$Pages$Admin$Developers$Hinter$GotManagedPartner = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$Developers$Hinter$init = F4(
	function (_v0, practice, shared, _v1) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, s6: $author$project$Api$Data$Loading, g4: $elm$core$Maybe$Nothing, g7: $elm$core$Maybe$Nothing, J7: shared.J7, qB: false},
			$author$project$Api$Provider$Practice$One$hasManagedPartner(practice) ? A2($author$project$Api$Provider$ManagedPartner$retrieve, shared.Gv, $author$project$Pages$Admin$Developers$Hinter$GotManagedPartner) : A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Developers__GetStarted));
	});
var $author$project$Pages$Admin$Developers$Hinter$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Developers$Hinter$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Developers$Hinter$ApiKeysMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$Developers$Hinter$WebhookEndpointsMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Developers$ManageWebhookEndpoints$CancelEdit = {$: 10};
var $author$project$Components$Developers$ManageWebhookEndpoints$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Components$Developers$ManageWebhookEndpoints$RegenerateSignatureKeyConfirmed = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Developers$ManageWebhookEndpoints$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Developers$ManageWebhookEndpoints$CancelEdit)),
					model.Io)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Developers$ManageWebhookEndpoints$HiConfirmClosed),
					model.je)),
				model.iR ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$Developers$ManageWebhookEndpoints$RegenerateSignatureKeyConfirmed) : $elm$core$Platform$Sub$none
			]));
};
var $author$project$Pages$Admin$Developers$Hinter$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Developers$ManageApiKeys$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Pages$Admin$Developers$Hinter$ApiKeysMsg)),
					model.g4)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Developers$ManageWebhookEndpoints$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Pages$Admin$Developers$Hinter$WebhookEndpointsMsg)),
					model.g7))
			]));
};
var $author$project$Pages$Admin$Developers$Hinter$GotToggledAppEnabled = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Developers$ManageApiKeys$Partner = 0;
var $author$project$Components$Developers$ManageWebhookEndpoints$Partner = 0;
var $author$project$Components$Developers$ManageWebhookEndpoints$GotManagedPartner = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Developers$ManageWebhookEndpoints$GotSandboxPractices = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Developers$ManageWebhookEndpoints$Model = $elm$core$Basics$identity;
var $author$project$Components$Developers$ManageWebhookEndpoints$SandboxIntegration = 2;
var $author$project$Components$Developers$ManageWebhookEndpoints$GotWebhookEndpoints = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$WebhookEndpoint$Shared$createdAt = function (_v0) {
	var record = _v0;
	return record.O1;
};
var $author$project$Api$Provider$WebhookEndpoint$All$createdAt = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$WebhookEndpoint$Shared$createdAt(shared);
};
var $author$project$Api$Provider$WebhookEndpoint$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$WebhookEndpoint$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$WebhookEndpoint$Shared$id(shared);
};
var $author$project$Api$Provider$WebhookEndpoint$Shared$lastDeliveredAt = function (_v0) {
	var record = _v0;
	return record.VE;
};
var $author$project$Api$Provider$WebhookEndpoint$All$lastDeliveredAt = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$WebhookEndpoint$Shared$lastDeliveredAt(shared);
};
var $author$project$Api$Provider$WebhookEndpoint$Shared$webhookUrl = function (_v0) {
	var record = _v0;
	return record.aer;
};
var $author$project$Api$Provider$WebhookEndpoint$All$webhookUrl = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$WebhookEndpoint$Shared$webhookUrl(shared);
};
var $author$project$Components$Developers$ManageWebhookEndpoints$fromAllWebhookEndpoint = function (endpoint) {
	return {
		O1: $author$project$Api$Provider$WebhookEndpoint$All$createdAt(endpoint),
		ahP: $author$project$Api$Provider$WebhookEndpoint$All$id(endpoint),
		VE: $author$project$Api$Provider$WebhookEndpoint$All$lastDeliveredAt(endpoint),
		ZV: $elm$core$Maybe$Nothing,
		aer: $author$project$Api$Provider$WebhookEndpoint$All$webhookUrl(endpoint)
	};
};
var $author$project$Api$Provider$WebhookEndpoint$Managed$createdAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$WebhookEndpoint$Shared$createdAt(shared);
};
var $author$project$Api$Provider$WebhookEndpoint$Managed$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$WebhookEndpoint$Shared$id(shared);
};
var $author$project$Api$Provider$WebhookEndpoint$Managed$lastDeliveredAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$WebhookEndpoint$Shared$lastDeliveredAt(shared);
};
var $author$project$Api$Provider$WebhookEndpoint$Managed$practice = function (_v0) {
	var record = _v0.b;
	return record.ZV;
};
var $author$project$Api$Provider$WebhookEndpoint$Managed$webhookUrl = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$WebhookEndpoint$Shared$webhookUrl(shared);
};
var $author$project$Components$Developers$ManageWebhookEndpoints$fromManagedWebhookEndpoint = function (endpoint) {
	return {
		O1: $author$project$Api$Provider$WebhookEndpoint$Managed$createdAt(endpoint),
		ahP: $author$project$Api$Provider$WebhookEndpoint$Managed$id(endpoint),
		VE: $author$project$Api$Provider$WebhookEndpoint$Managed$lastDeliveredAt(endpoint),
		ZV: $elm$core$Maybe$Just(
			$author$project$Api$Provider$WebhookEndpoint$Managed$practice(endpoint)),
		aer: $author$project$Api$Provider$WebhookEndpoint$Managed$webhookUrl(endpoint)
	};
};
var $author$project$Api$Provider$WebhookEndpoint$All$WebhookEndpoint = $elm$core$Basics$identity;
var $author$project$Api$Provider$WebhookEndpoint$Shared$WebhookEndpoint = $elm$core$Basics$identity;
var $author$project$Api$Provider$WebhookEndpoint$Shared$Record = F4(
	function (id, webhookUrl, createdAt, lastDeliveredAt) {
		return {O1: createdAt, ahP: id, VE: lastDeliveredAt, aer: webhookUrl};
	});
var $author$project$Api$Provider$WebhookEndpoint$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'last_delivered_at',
	$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'created_at',
		$elm_community$json_extra$Json$Decode$Extra$datetime,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'webhook_url',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$WebhookEndpoint$Shared$Record)))));
var $author$project$Api$Provider$WebhookEndpoint$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$WebhookEndpoint$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$WebhookEndpoint$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$WebhookEndpoint$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$ManagedPartner$Integration$WebhookEndpoint$webhookEndpointsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['managed_partner', 'integration', 'webhook_endpoints']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$ManagedPartner$Integration$WebhookEndpoint$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$WebhookEndpoint$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$Integration$WebhookEndpoint$webhookEndpointsPath));
	});
var $author$project$Api$Provider$WebhookEndpoint$Managed$WebhookEndpoint = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$WebhookEndpoint$Managed$Record = function (practice) {
	return {ZV: practice};
};
var $author$project$Api$Provider$WebhookEndpoint$Managed$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'practice',
	$author$project$Api$Provider$Practice$IdAndName$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$WebhookEndpoint$Managed$Record));
var $author$project$Api$Provider$WebhookEndpoint$Managed$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$WebhookEndpoint$Managed$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$WebhookEndpoint$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$WebhookEndpoint$Managed$WebhookEndpoint)));
var $author$project$Api$Provider$ManagedPartner$Sandbox$WebhookEndpoint$webhookEndpointsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['managed_partner', 'sandboxes', 'webhook_endpoints']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$ManagedPartner$Sandbox$WebhookEndpoint$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$WebhookEndpoint$Managed$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$Sandbox$WebhookEndpoint$webhookEndpointsPath));
	});
var $author$project$Api$Provider$ManagedPartner$WebhookEndpoint$webhookEndpointsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['managed_partner', 'webhook_endpoints']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$ManagedPartner$WebhookEndpoint$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$WebhookEndpoint$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$WebhookEndpoint$webhookEndpointsPath));
	});
var $author$project$Components$Developers$ManageWebhookEndpoints$fetchWebhookEndpoints = F2(
	function (apiClient, owner) {
		switch (owner) {
			case 0:
				return A2(
					$author$project$Api$Provider$ManagedPartner$WebhookEndpoint$list,
					apiClient,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Api$Data$map(
							$elm$core$List$map($author$project$Components$Developers$ManageWebhookEndpoints$fromAllWebhookEndpoint)),
						$author$project$Components$Developers$ManageWebhookEndpoints$GotWebhookEndpoints));
			case 1:
				return A2(
					$author$project$Api$Provider$ManagedPartner$Integration$WebhookEndpoint$list,
					apiClient,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Api$Data$map(
							$elm$core$List$map($author$project$Components$Developers$ManageWebhookEndpoints$fromAllWebhookEndpoint)),
						$author$project$Components$Developers$ManageWebhookEndpoints$GotWebhookEndpoints));
			default:
				return A2(
					$author$project$Api$Provider$ManagedPartner$Sandbox$WebhookEndpoint$list,
					apiClient,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Api$Data$map(
							$elm$core$List$map($author$project$Components$Developers$ManageWebhookEndpoints$fromManagedWebhookEndpoint)),
						$author$project$Components$Developers$ManageWebhookEndpoints$GotWebhookEndpoints));
		}
	});
var $author$project$Components$Developers$ManageWebhookEndpoints$init = F3(
	function (apiClient, timeFormatter, owner) {
		return _Utils_Tuple2(
			{
				iR: false,
				je: $elm$core$Maybe$Nothing,
				Io: $elm$core$Maybe$Nothing,
				s6: $author$project$Api$Data$Loading,
				YD: owner,
				py: false,
				pP: (owner === 2) ? $author$project$Api$Data$Loading : $author$project$Api$Data$NotAsked,
				lq: false,
				J7: timeFormatter,
				ia: $author$project$Api$Data$Loading
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Components$Developers$ManageWebhookEndpoints$fetchWebhookEndpoints, apiClient, owner),
						A2($author$project$Api$Provider$ManagedPartner$retrieve, apiClient, $author$project$Components$Developers$ManageWebhookEndpoints$GotManagedPartner),
						(owner === 2) ? A2($author$project$Api$Provider$ManagedPartner$Sandbox$Practice$list, apiClient, $author$project$Components$Developers$ManageWebhookEndpoints$GotSandboxPractices) : $elm$core$Platform$Cmd$none
					])));
	});
var $author$project$Api$Provider$ManagedPartner$update = F3(
	function (apiClient, _v0, toMsg) {
		var appEnabled = _v0.ae_;
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'managed_partner',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'app_enabled',
								$elm$json$Json$Encode$bool(appEnabled))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$ManagedPartner$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$managedPartnerPath)));
	});
var $author$project$Components$Developers$ManageWebhookEndpoints$RegeneratedSignatureKey = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Developers$ManageWebhookEndpoints$defaultPracticeId = function (model) {
	var _v0 = model.pP;
	if ((_v0.$ === 3) && _v0.a.b) {
		var _v1 = _v0.a;
		var first = _v1.a;
		return $author$project$Api$Provider$Practice$All$id(first);
	} else {
		return '';
	}
};
var $author$project$Components$Developers$ManageWebhookEndpoints$Deleted = function (a) {
	return {$: 17, a: a};
};
var $author$project$Api$Provider$ManagedPartner$Integration$WebhookEndpoint$webhookEndpointPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$ManagedPartner$Integration$WebhookEndpoint$webhookEndpointsPath);
};
var $author$project$Api$Provider$ManagedPartner$Integration$WebhookEndpoint$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$ManagedPartner$Integration$WebhookEndpoint$webhookEndpointPath(id_)));
	});
var $author$project$Api$Provider$ManagedPartner$Sandbox$WebhookEndpoint$webhookEndpointPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$ManagedPartner$Sandbox$WebhookEndpoint$webhookEndpointsPath);
};
var $author$project$Api$Provider$ManagedPartner$Sandbox$WebhookEndpoint$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$ManagedPartner$Sandbox$WebhookEndpoint$webhookEndpointPath(id_)));
	});
var $author$project$Api$Provider$ManagedPartner$WebhookEndpoint$webhookEndpointPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$ManagedPartner$WebhookEndpoint$webhookEndpointsPath);
};
var $author$project$Api$Provider$ManagedPartner$WebhookEndpoint$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$ManagedPartner$WebhookEndpoint$webhookEndpointPath(id_)));
	});
var $author$project$Components$Developers$ManageWebhookEndpoints$deleteCmd = F3(
	function (apiClient, owner, id_) {
		switch (owner) {
			case 0:
				return A3($author$project$Api$Provider$ManagedPartner$WebhookEndpoint$delete, apiClient, id_, $author$project$Components$Developers$ManageWebhookEndpoints$Deleted);
			case 1:
				return A3($author$project$Api$Provider$ManagedPartner$Integration$WebhookEndpoint$delete, apiClient, id_, $author$project$Components$Developers$ManageWebhookEndpoints$Deleted);
			default:
				return A3($author$project$Api$Provider$ManagedPartner$Sandbox$WebhookEndpoint$delete, apiClient, id_, $author$project$Components$Developers$ManageWebhookEndpoints$Deleted);
		}
	});
var $author$project$Components$Developers$ManageWebhookEndpoints$formFieldsFromItem = function (row) {
	return {
		Ji: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Practice$IdAndName$id, row.ZV)),
		aer: row.aer
	};
};
var $author$project$Components$Developers$ManageWebhookEndpoints$formFieldsInit = function (defaultPractice) {
	return {Ji: defaultPractice, aer: ''};
};
var $author$project$Components$Developers$ManageWebhookEndpoints$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var string = field.a;
			return _Utils_update(
				fields,
				{aer: string});
		} else {
			var string = field.a;
			return _Utils_update(
				fields,
				{Ji: string});
		}
	});
var $author$project$Components$Developers$ManageWebhookEndpoints$WebhookPracticeIdValidation = 1;
var $author$project$Components$Developers$ManageWebhookEndpoints$WebhookUrlValidation = 0;
var $author$project$Components$Developers$ManageWebhookEndpoints$formFieldsValidator = function (owner) {
	return $rtfeldman$elm_validate$Validate$all(
		$elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						A2(
						$rtfeldman$elm_validate$Validate$ifBlank,
						function ($) {
							return $.aer;
						},
						_Utils_Tuple2(0, 'Please enter a URL.')),
						A2(
						$rtfeldman$elm_validate$Validate$ifFalse,
						function (f) {
							return $elm$core$String$isEmpty(f.aer) || A2($elm$core$String$startsWith, 'https://', f.aer);
						},
						_Utils_Tuple2(0, 'URL must start with https://.'))
					]),
					(owner === 2) ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_validate$Validate$ifBlank,
						function ($) {
							return $.Ji;
						},
						_Utils_Tuple2(1, 'Please pick a sandbox practice.'))
					]) : _List_Nil
				])));
};
var $author$project$Api$Provider$ManagedPartner$regenerateSandboxWebhooksSignatureApiKey = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$ManagedPartner$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['sandbox_webhooks_signature_api_key', 'regenerate']),
					$author$project$Api$Provider$ManagedPartner$managedPartnerPath)));
	});
var $author$project$Api$Provider$ManagedPartner$regenerateWebhooksSignatureApiKey = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$ManagedPartner$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['webhooks_signature_api_key', 'regenerate']),
					$author$project$Api$Provider$ManagedPartner$managedPartnerPath)));
	});
var $author$project$Components$Developers$ManageWebhookEndpoints$Created = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Developers$ManageWebhookEndpoints$Updated = function (a) {
	return {$: 14, a: a};
};
var $author$project$Api$Provider$WebhookEndpoint$One$WebhookEndpoint = 0;
var $author$project$Api$Provider$WebhookEndpoint$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Provider$ManagedPartner$Integration$WebhookEndpoint$create = F3(
	function (apiClient, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'webhook_endpoint',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'webhook_url',
								$elm$json$Json$Encode$string(params.aer))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$WebhookEndpoint$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$Integration$WebhookEndpoint$webhookEndpointsPath)));
	});
var $author$project$Api$Provider$ManagedPartner$Sandbox$WebhookEndpoint$create = F3(
	function (apiClient, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'webhook_endpoint',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'webhook_url',
								$elm$json$Json$Encode$string(params.aer)),
								_Utils_Tuple2(
								'practice_id',
								$elm$json$Json$Encode$string(params.Ji))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$WebhookEndpoint$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$Sandbox$WebhookEndpoint$webhookEndpointsPath)));
	});
var $author$project$Api$Provider$ManagedPartner$WebhookEndpoint$create = F3(
	function (apiClient, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'webhook_endpoint',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'webhook_url',
								$elm$json$Json$Encode$string(params.aer))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$WebhookEndpoint$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$WebhookEndpoint$webhookEndpointsPath)));
	});
var $author$project$Api$Provider$ManagedPartner$Integration$WebhookEndpoint$update = F4(
	function (apiClient, id_, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'webhook_endpoint',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'webhook_url',
								$elm$json$Json$Encode$string(params.aer))
							])))
				]));
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$WebhookEndpoint$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$ManagedPartner$Integration$WebhookEndpoint$webhookEndpointPath(id_))));
	});
var $author$project$Api$Provider$ManagedPartner$Sandbox$WebhookEndpoint$update = F4(
	function (apiClient, id_, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'webhook_endpoint',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'webhook_url',
								$elm$json$Json$Encode$string(params.aer))
							])))
				]));
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$WebhookEndpoint$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$ManagedPartner$Sandbox$WebhookEndpoint$webhookEndpointPath(id_))));
	});
var $author$project$Api$Provider$ManagedPartner$WebhookEndpoint$update = F4(
	function (apiClient, id_, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'webhook_endpoint',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'webhook_url',
								$elm$json$Json$Encode$string(params.aer))
							])))
				]));
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$WebhookEndpoint$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$ManagedPartner$WebhookEndpoint$webhookEndpointPath(id_))));
	});
var $author$project$Components$Developers$ManageWebhookEndpoints$saveCmd = F4(
	function (apiClient, owner, maybeRow, fields) {
		var _v0 = _Utils_Tuple2(maybeRow, owner);
		if (_v0.a.$ === 1) {
			switch (_v0.b) {
				case 0:
					var _v1 = _v0.a;
					var _v2 = _v0.b;
					return A3(
						$author$project$Api$Provider$ManagedPartner$WebhookEndpoint$create,
						apiClient,
						{aer: fields.aer},
						$author$project$Components$Developers$ManageWebhookEndpoints$Created);
				case 1:
					var _v3 = _v0.a;
					var _v4 = _v0.b;
					return A3(
						$author$project$Api$Provider$ManagedPartner$Integration$WebhookEndpoint$create,
						apiClient,
						{aer: fields.aer},
						$author$project$Components$Developers$ManageWebhookEndpoints$Created);
				default:
					var _v5 = _v0.a;
					var _v6 = _v0.b;
					return A3(
						$author$project$Api$Provider$ManagedPartner$Sandbox$WebhookEndpoint$create,
						apiClient,
						{Ji: fields.Ji, aer: fields.aer},
						$author$project$Components$Developers$ManageWebhookEndpoints$Created);
			}
		} else {
			switch (_v0.b) {
				case 0:
					var row = _v0.a.a;
					var _v7 = _v0.b;
					return A4(
						$author$project$Api$Provider$ManagedPartner$WebhookEndpoint$update,
						apiClient,
						row.ahP,
						{aer: fields.aer},
						$author$project$Components$Developers$ManageWebhookEndpoints$Updated);
				case 1:
					var row = _v0.a.a;
					var _v8 = _v0.b;
					return A4(
						$author$project$Api$Provider$ManagedPartner$Integration$WebhookEndpoint$update,
						apiClient,
						row.ahP,
						{aer: fields.aer},
						$author$project$Components$Developers$ManageWebhookEndpoints$Updated);
				default:
					var row = _v0.a.a;
					var _v9 = _v0.b;
					return A4(
						$author$project$Api$Provider$ManagedPartner$Sandbox$WebhookEndpoint$update,
						apiClient,
						row.ahP,
						{aer: fields.aer},
						$author$project$Components$Developers$ManageWebhookEndpoints$Updated);
			}
		}
	});
var $author$project$Components$Developers$ManageWebhookEndpoints$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ia: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{pP: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 2:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{s6: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{lq: !model.lq}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var token = msg.a;
				return _Utils_Tuple3(
					model,
					$author$project$Ports$Clipboard$copy(token),
					_List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 3, 'Copied to clipboard.')
						]));
			case 5:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{iR: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 6:
				var confirmed = msg.a;
				if (confirmed) {
					var regenerateCmd = function () {
						var _v2 = model.YD;
						if (_v2 === 2) {
							return A2($author$project$Api$Provider$ManagedPartner$regenerateSandboxWebhooksSignatureApiKey, apiClient, $author$project$Components$Developers$ManageWebhookEndpoints$RegeneratedSignatureKey);
						} else {
							return A2($author$project$Api$Provider$ManagedPartner$regenerateWebhooksSignatureApiKey, apiClient, $author$project$Components$Developers$ManageWebhookEndpoints$RegeneratedSignatureKey);
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{iR: false, py: true}),
						regenerateCmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{iR: false}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 7:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{s6: response, py: false, lq: false}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Webhooks signature key regenerated.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{py: false}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 8:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							Io: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init(
										$author$project$Components$Developers$ManageWebhookEndpoints$formFieldsInit(
											$author$project$Components$Developers$ManageWebhookEndpoints$defaultPracticeId(model))),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 9:
				var row = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							Io: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(row),
									$author$project$Utils$Form$init(
										$author$project$Components$Developers$ManageWebhookEndpoints$formFieldsFromItem(row)),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 10:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Io: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 11:
				var field = msg.a;
				var _v4 = model.Io;
				if (!_v4.$) {
					var _v5 = _v4.a;
					var maybeRow = _v5.a;
					var form = _v5.b;
					var request = _v5.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Io: $elm$core$Maybe$Just(
									_Utils_Tuple3(
										maybeRow,
										A3($author$project$Utils$Form$update, $author$project$Components$Developers$ManageWebhookEndpoints$formFieldsUpdate, field, form),
										request))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 12:
				var maybeRow = msg.a;
				var form = msg.b;
				var _v6 = A2(
					$author$project$Utils$Form$validate,
					$author$project$Components$Developers$ManageWebhookEndpoints$formFieldsValidator(model.YD),
					form);
				if (!_v6.$) {
					var _v7 = _v6.a;
					var validatedForm = _v7.a;
					var validFormFields = _v7.b;
					var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
					var cmd = A4($author$project$Components$Developers$ManageWebhookEndpoints$saveCmd, apiClient, model.YD, maybeRow, fields);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Io: $elm$core$Maybe$Just(
									_Utils_Tuple3(maybeRow, validatedForm, $author$project$Api$Data$Loading))
							}),
						cmd,
						_List_Nil);
				} else {
					var validatedForm = _v6.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Io: $elm$core$Maybe$Just(
									_Utils_Tuple3(maybeRow, validatedForm, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 13:
				var response = msg.a;
				var _v8 = model.Io;
				if (!_v8.$) {
					var _v9 = _v8.a;
					var maybeRow = _v9.a;
					var form = _v9.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{Io: $elm$core$Maybe$Nothing, ia: $author$project$Api$Data$Loading}),
							A2($author$project$Components$Developers$ManageWebhookEndpoints$fetchWebhookEndpoints, apiClient, model.YD),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Webhook endpoint added.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									Io: $elm$core$Maybe$Just(
										_Utils_Tuple3(maybeRow, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 14:
				var response = msg.a;
				var _v11 = model.Io;
				if (!_v11.$) {
					var _v12 = _v11.a;
					var maybeRow = _v12.a;
					var form = _v12.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{Io: $elm$core$Maybe$Nothing, ia: $author$project$Api$Data$Loading}),
							A2($author$project$Components$Developers$ManageWebhookEndpoints$fetchWebhookEndpoints, apiClient, model.YD),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Webhook endpoint updated.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									Io: $elm$core$Maybe$Just(
										_Utils_Tuple3(maybeRow, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 15:
				var row = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							je: $elm$core$Maybe$Just(row)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 16:
				var row = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{je: $elm$core$Maybe$Nothing}),
					A3($author$project$Components$Developers$ManageWebhookEndpoints$deleteCmd, apiClient, model.YD, row.ahP),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{je: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ia: $author$project$Api$Data$Loading}),
						A2($author$project$Components$Developers$ManageWebhookEndpoints$fetchWebhookEndpoints, apiClient, model.YD),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Webhook endpoint deleted.')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Admin$Developers$Hinter$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var _v2 = A3($author$project$Components$Developers$ManageWebhookEndpoints$init, model.Gv, model.J7, 0);
					var partnerWebhookEndpoints = _v2.a;
					var webhookEndpointsCmd = _v2.b;
					var _v3 = A3($author$project$Components$Developers$ManageApiKeys$init, model.Gv, model.J7, 0);
					var partnerApiKeys = _v3.a;
					var apiKeysCmd = _v3.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								s6: response,
								g4: $elm$core$Maybe$Just(partnerApiKeys),
								g7: $elm$core$Maybe$Just(partnerWebhookEndpoints)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Developers$Hinter$ApiKeysMsg, apiKeysCmd),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Developers$Hinter$WebhookEndpointsMsg, webhookEndpointsCmd)
								])),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{s6: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var _v4 = model.g4;
				if (!_v4.$) {
					var partnerApiKeys = _v4.a;
					var _v5 = A3($author$project$Components$Developers$ManageApiKeys$update, model.Gv, subMsg, partnerApiKeys);
					var updated = _v5.a;
					var cmd = _v5.b;
					var outMsgs = _v5.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								g4: $elm$core$Maybe$Just(updated)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Developers$Hinter$ApiKeysMsg, cmd),
						outMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				var subMsg = msg.a;
				var _v6 = model.g7;
				if (!_v6.$) {
					var partnerWebhookEndpoints = _v6.a;
					var _v7 = A3($author$project$Components$Developers$ManageWebhookEndpoints$update, model.Gv, subMsg, partnerWebhookEndpoints);
					var updated = _v7.a;
					var cmd = _v7.b;
					var outMsgs = _v7.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								g7: $elm$core$Maybe$Just(updated)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Developers$Hinter$WebhookEndpointsMsg, cmd),
						outMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var appEnabled = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qB: true}),
					A3(
						$author$project$Api$Provider$ManagedPartner$update,
						model.Gv,
						{ae_: appEnabled},
						$author$project$Pages$Admin$Developers$Hinter$GotToggledAppEnabled),
					_List_Nil);
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{s6: response, qB: false}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Updated App access.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{qB: false}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Components$Developers$ManageWebhookEndpoints$New = {$: 8};
var $author$project$Components$HiConfirm$ButtonStyle = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$HiConfirm$buttonStyle = $author$project$Components$HiConfirm$ButtonStyle;
var $author$project$Components$Developers$ManageWebhookEndpoints$FormUpdated = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Developers$ManageWebhookEndpoints$Save = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Components$Developers$ManageWebhookEndpoints$WebhookPracticeId = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Developers$ManageWebhookEndpoints$WebhookUrl = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Developers$ManageWebhookEndpoints$viewCreateEditModal = F5(
	function (owner, sandboxPractices, maybeRow, form, request) {
		var modalConfig = {
			Tq: $elm$core$Maybe$Nothing,
			aih: 'Webhook Endpoint',
			V8: _Utils_eq(request, $author$project$Api$Data$Loading),
			WG: A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.ahP;
				},
				maybeRow),
			WH: $elm$core$Maybe$Nothing,
			Yd: $author$project$Components$Developers$ManageWebhookEndpoints$CancelEdit,
			Yf: $elm$core$Basics$always(
				A2($author$project$Components$Developers$ManageWebhookEndpoints$Save, maybeRow, form))
		};
		var fields = $author$project$Utils$Form$fields(form);
		var practicePicker = function () {
			var _v0 = _Utils_Tuple2(owner, maybeRow);
			if ((_v0.a === 2) && (_v0.b.$ === 1)) {
				var _v1 = _v0.a;
				var _v2 = _v0.b;
				var practices = function () {
					if (sandboxPractices.$ === 3) {
						var ps = sandboxPractices.a;
						return ps;
					} else {
						return _List_Nil;
					}
				}();
				return A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Sandbox practice')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(
									$elm$core$Maybe$Just(fields.Ji)),
									$author$project$Ui$Form$Select$onChange(
									A2($elm$core$Basics$composeL, $author$project$Components$Developers$ManageWebhookEndpoints$FormUpdated, $author$project$Components$Developers$ManageWebhookEndpoints$WebhookPracticeId)),
									$author$project$Ui$Form$Select$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 1, form))
								]),
							A2(
								$elm$core$List$map,
								function (practice) {
									return A3(
										$author$project$Ui$Form$Select$option,
										_List_Nil,
										$elm$core$Maybe$Just(
											$author$project$Api$Provider$Practice$All$id(practice)),
										$author$project$Api$Provider$Practice$All$name(practice));
								},
								practices)),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 1, form))
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}();
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					practicePicker,
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('URL')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(fields.aer),
									$author$project$Ui$Form$Input$placeholder('https://example.com/webhook'),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$Developers$ManageWebhookEndpoints$FormUpdated, $author$project$Components$Developers$ManageWebhookEndpoints$WebhookUrl)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form))
								])),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						]))
				]));
	});
var $author$project$Components$Developers$ManageWebhookEndpoints$CopySignatureKey = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Developers$ManageWebhookEndpoints$RegenerateSignatureKeyClicked = {$: 5};
var $author$project$Components$Developers$ManageWebhookEndpoints$ToggleSignatureKey = {$: 3};
var $author$project$Ui$Form$Static$Muted = {$: 2};
var $author$project$Ui$Form$Static$muted = $author$project$Ui$Form$Static$Muted;
var $author$project$Ui$Icon$Repeat = 46;
var $author$project$Ui$Icon$repeat = $author$project$Ui$Icon$viewIcon(46);
var $author$project$Components$Developers$ManageWebhookEndpoints$viewSignatureKeySection = function (model) {
	var _v0 = model.s6;
	if (_v0.$ === 3) {
		var managedPartner = _v0.a;
		var signatureKey = function () {
			var _v3 = model.YD;
			if (_v3 === 2) {
				return $author$project$Api$Provider$ManagedPartner$One$sandboxWebhooksSignatureApiKey(managedPartner);
			} else {
				return $author$project$Api$Provider$ManagedPartner$One$webhooksSignatureApiKey(managedPartner);
			}
		}();
		if (!signatureKey.$) {
			var apiKey = signatureKey.a;
			var token = $author$project$Api$Provider$ApiKey$Shared$token(apiKey);
			var display = model.lq ? token : _Utils_ap(
				A2(
					$elm$core$String$repeat,
					$elm$core$String$length(token) - 4,
					'•'),
				A2($elm$core$String$right, 4, token));
			var _v2 = model.lq ? _Utils_Tuple2($author$project$Ui$Icon$visibilityOff, 'Hide webhooks signature key') : _Utils_Tuple2($author$project$Ui$Icon$visibility, 'Show webhooks signature key');
			var visibilityIcon = _v2.a;
			var visibilityAriaLabel = _v2.b;
			return A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Webhooks Signature Key'),
								$author$project$Ui$Form$Group$labelSpan(2),
								$author$project$Ui$Form$Group$inputSpan(8),
								$author$project$Ui$Form$Group$labelClass('control-label text-left')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Static$view,
										_List_fromArray(
											[$author$project$Ui$Form$Static$muted]),
										_List_fromArray(
											[
												$elm$html$Html$text(display)
											])),
										A3(
										$author$project$Ui$Button$view,
										{mm: visibilityAriaLabel},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$icon(visibilityIcon),
												$author$project$Ui$Button$onClick($author$project$Components$Developers$ManageWebhookEndpoints$ToggleSignatureKey)
											]),
										_List_Nil),
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Copy webhooks signature key'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$icon($author$project$Ui$Icon$copy),
												$author$project$Ui$Button$onClick(
												$author$project$Components$Developers$ManageWebhookEndpoints$CopySignatureKey(token))
											]),
										_List_Nil),
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Regenerate webhooks signature key'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$icon($author$project$Ui$Icon$repeat),
												$author$project$Ui$Button$onClick($author$project$Components$Developers$ManageWebhookEndpoints$RegenerateSignatureKeyClicked),
												$author$project$Ui$Button$loading(model.py)
											]),
										_List_Nil)
									]))
							]))
					]));
		} else {
			return A2($author$project$Ui$Panel$body, _List_Nil, _List_Nil);
		}
	} else {
		return A2($author$project$Ui$Panel$body, _List_Nil, _List_Nil);
	}
};
var $author$project$Components$Developers$ManageWebhookEndpoints$Delete = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Developers$ManageWebhookEndpoints$Edit = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Developers$ManageWebhookEndpoints$viewWebhookRow = F3(
	function (showPracticeColumn, timeFormatter, row) {
		var practiceCell = showPracticeColumn ? _List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$elm$core$Maybe$withDefault,
							'—',
							A2($elm$core$Maybe$map, $author$project$Api$Provider$Practice$IdAndName$name, row.ZV)))
					]))
			]) : _List_Nil;
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						practiceCell,
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(row.aer)
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(timeFormatter, 5, row.O1))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'Never',
										A2(
											$elm$core$Maybe$map,
											timeFormatter(5),
											row.VE)))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_fromArray(
								[$author$project$Ui$Table$textRight]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$justifyRight, $author$project$Ui$Element$gap2]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{mm: 'Edit webhook endpoint'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$sm,
													$author$project$Ui$Button$onClick(
													$author$project$Components$Developers$ManageWebhookEndpoints$Edit(row)),
													$author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Edit')
												])),
											A3(
											$author$project$Ui$Button$view,
											{mm: 'Delete webhook endpoint'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$sm,
													$author$project$Ui$Button$onClick(
													$author$project$Components$Developers$ManageWebhookEndpoints$Delete(row)),
													$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Delete')
												]))
										]))
								]))
						])
					])));
	});
var $author$project$Components$Developers$ManageWebhookEndpoints$view = function (_v0) {
	var model = _v0;
	var showPracticeColumn = model.YD === 2;
	var panelTitle = function () {
		var _v5 = model.YD;
		switch (_v5) {
			case 0:
				return 'Webhook Endpoints';
			case 1:
				return 'Webhook Endpoints';
			default:
				return 'Sandbox Webhook Endpoints';
		}
	}();
	var newDisabled = (model.YD === 2) && ((!_Utils_eq(model.pP, $author$project$Api$Data$Loading)) && ($author$project$Components$Developers$ManageWebhookEndpoints$defaultPracticeId(model) === ''));
	return _List_fromArray(
		[
			function () {
			var _v1 = model.Io;
			if (!_v1.$) {
				var _v2 = _v1.a;
				var maybeRow = _v2.a;
				var form = _v2.b;
				var request = _v2.c;
				return A5($author$project$Components$Developers$ManageWebhookEndpoints$viewCreateEditModal, model.YD, model.pP, maybeRow, form, request);
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			function () {
			var _v3 = model.je;
			if (!_v3.$) {
				var row = _v3.a;
				return A2(
					$author$project$Components$HiConfirm$modal,
					$author$project$Components$Developers$ManageWebhookEndpoints$HiConfirmClosed(row),
					_List_fromArray(
						[
							$author$project$Components$HiConfirm$verb('delete'),
							$author$project$Components$HiConfirm$noun('webhook endpoint'),
							$author$project$Components$HiConfirm$detail(row.aer)
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			model.iR ? A2(
			$author$project$Components$HiConfirm$modal,
			$author$project$Components$Developers$ManageWebhookEndpoints$RegenerateSignatureKeyConfirmed,
			_List_fromArray(
				[
					$author$project$Components$HiConfirm$verb('regenerate'),
					$author$project$Components$HiConfirm$noun('webhooks signature key'),
					$author$project$Components$HiConfirm$sentence('The current key will be replaced. Any webhook receiver still verifying with the old key will fail to validate payloads until you update it.'),
					$author$project$Components$HiConfirm$buttonStyle(6)
				])) : $author$project$Utils$Html$empty,
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_fromArray(
						[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
					_List_fromArray(
						[
							$author$project$Ui$Panel$title(
							_List_fromArray(
								[
									$elm$html$Html$text(panelTitle)
								])),
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Add webhook endpoint'},
							_List_fromArray(
								[
									$author$project$Ui$Button$default,
									$author$project$Ui$Button$onClick($author$project$Components$Developers$ManageWebhookEndpoints$New),
									$author$project$Ui$Button$icon($author$project$Ui$Icon$add),
									$author$project$Ui$Button$disabled(newDisabled)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Add Endpoint')
								]))
						])),
					$author$project$Components$Developers$ManageWebhookEndpoints$viewSignatureKeySection(model),
					A4(
					$author$project$Ui$Panel$table,
					_List_fromArray(
						[
							$author$project$Ui$Table$zeroState(
							_List_fromArray(
								[
									$elm$html$Html$text('You don\'t have any webhook endpoints yet.')
								])),
							$author$project$Ui$Table$loading(
							_Utils_eq(model.ia, $author$project$Api$Data$Loading))
						]),
					$elm$core$List$concat(
						_List_fromArray(
							[
								showPracticeColumn ? _List_fromArray(
								[
									A2(
									$author$project$Ui$Table$header,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Practice')
										]))
								]) : _List_Nil,
								_List_fromArray(
								[
									A2(
									$author$project$Ui$Table$header,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('URL')
										])),
									A2(
									$author$project$Ui$Table$header,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Created')
										])),
									A2(
									$author$project$Ui$Table$header,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Last Delivered')
										])),
									A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
								])
							])),
					function () {
						var _v4 = model.ia;
						if (_v4.$ === 3) {
							var endpoints = _v4.a;
							return A2(
								$elm$core$List$map,
								A2($author$project$Components$Developers$ManageWebhookEndpoints$viewWebhookRow, showPracticeColumn, model.J7),
								endpoints);
						} else {
							return _List_Nil;
						}
					}(),
					_List_Nil)
				]))
		]);
};
var $author$project$Pages$Admin$Developers$Hinter$ToggledAppEnabled = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Admin$Developers$Hinter$viewAppEnabledPanel = F2(
	function (model, managedPartner) {
		return A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Panel$title(
							_List_fromArray(
								[
									A2($author$project$Ui$Typography$text, _List_Nil, 'App access')
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$muted]),
									_List_fromArray(
										[
											A2($author$project$Ui$Typography$text, _List_Nil, 'Enables the App tab so this practice can build a marketplace app via the managed partner.')
										])),
									$author$project$Ui$ToggleSwitch$view(
									_List_fromArray(
										[
											$author$project$Ui$ToggleSwitch$on(
											$author$project$Api$Provider$ManagedPartner$One$appEnabled(managedPartner)),
											$author$project$Ui$ToggleSwitch$onChange($author$project$Pages$Admin$Developers$Hinter$ToggledAppEnabled),
											$author$project$Ui$ToggleSwitch$disabled(model.qB)
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Developers$ManageWebhookEndpoints$skeleton = A2(
	$author$project$Ui$Panel$view,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Panel$heading,
			_List_fromArray(
				[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
			_List_fromArray(
				[
					$author$project$Ui$Panel$title(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$spanMd(5)
								]))
						])),
					$author$project$Ui$Skeleton$input(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$spanSm(3)
						]))
				])),
			A2(
			$author$project$Ui$Panel$body,
			_List_Nil,
			A2(
				$elm$core$List$repeat,
				3,
				$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[$author$project$Ui$Skeleton$block]))))
		]));
var $author$project$Pages$Admin$Developers$Hinter$viewSkeleton = _List_fromArray(
	[$author$project$Components$Developers$ManageApiKeys$skeleton, $author$project$Components$Developers$ManageWebhookEndpoints$skeleton]);
var $author$project$Pages$Admin$Developers$Hinter$view = function (model) {
	return {
		fO: function () {
			var _v0 = model.s6;
			switch (_v0.$) {
				case 1:
					return $author$project$Pages$Admin$Developers$Hinter$viewSkeleton;
				case 3:
					var managedPartner = _v0.a;
					return $elm$core$List$concat(
						_List_fromArray(
							[
								_List_fromArray(
								[
									A2($author$project$Pages$Admin$Developers$Hinter$viewAppEnabledPanel, model, managedPartner)
								]),
								A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Components$Developers$ManageApiKeys$view,
										$elm$core$List$map(
											$elm$html$Html$map($author$project$Pages$Admin$Developers$Hinter$ApiKeysMsg))),
									model.g4)),
								A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Components$Developers$ManageWebhookEndpoints$view,
										$elm$core$List$map(
											$elm$html$Html$map($author$project$Pages$Admin$Developers$Hinter$WebhookEndpointsMsg))),
									model.g7))
							]));
				default:
					return $elm$core$List$concat(
						_List_fromArray(
							[
								A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Components$Developers$ManageApiKeys$view,
										$elm$core$List$map(
											$elm$html$Html$map($author$project$Pages$Admin$Developers$Hinter$ApiKeysMsg))),
									model.g4)),
								A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Components$Developers$ManageWebhookEndpoints$view,
										$elm$core$List$map(
											$elm$html$Html$map($author$project$Pages$Admin$Developers$Hinter$WebhookEndpointsMsg))),
									model.g7))
							]));
			}
		}(),
		ac9: 'Admin | Developers | Hinter'
	};
};
var $author$project$Pages$Admin$Developers$Hinter$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Developers$Hinter$init, aiq: $author$project$Pages$Admin$Developers$Hinter$load, k8: $author$project$Pages$Admin$Developers$Hinter$save, alO: $author$project$Pages$Admin$Developers$Hinter$subscriptions, adT: $author$project$Pages$Admin$Developers$Hinter$update, amo: $author$project$Pages$Admin$Developers$Hinter$view});
var $author$project$Pages$Admin$Developers$Sandboxes$SandboxesMsg = $elm$core$Basics$identity;
var $author$project$Components$Developers$ManageSandboxes$GotManagedPartner = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Developers$ManageSandboxes$GotSandboxPractices = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Developers$ManageSandboxes$Model = $elm$core$Basics$identity;
var $author$project$Components$Developers$ManageSandboxes$init = F2(
	function (apiClient, isHintAdmin) {
		return _Utils_Tuple2(
			{ci: $elm$core$Maybe$Nothing, Ij: isHintAdmin, s6: $author$project$Api$Data$Loading, pP: $author$project$Api$Data$Loading},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Api$Provider$ManagedPartner$retrieve, apiClient, $author$project$Components$Developers$ManageSandboxes$GotManagedPartner),
						A2($author$project$Api$Provider$ManagedPartner$Sandbox$Practice$list, apiClient, $author$project$Components$Developers$ManageSandboxes$GotSandboxPractices)
					])));
	});
var $author$project$Pages$Admin$Developers$Sandboxes$init = F4(
	function (session, practice, shared, _v0) {
		if ($author$project$Api$Provider$Practice$One$hasManagedPartner(practice)) {
			var isHintAdmin = A2($author$project$Utils$User$isViewingAsHinter, session, shared.ahK);
			var _v1 = A2($author$project$Components$Developers$ManageSandboxes$init, shared.Gv, isHintAdmin);
			var sandboxesModel = _v1.a;
			var sandboxesCmd = _v1.b;
			return _Utils_Tuple2(
				{
					Gv: shared.Gv,
					k7: $elm$core$Maybe$Just(sandboxesModel)
				},
				A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, sandboxesCmd));
		} else {
			return _Utils_Tuple2(
				{Gv: shared.Gv, k7: $elm$core$Maybe$Nothing},
				A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Developers__GetStarted));
		}
	});
var $author$project$Pages$Admin$Developers$Sandboxes$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Developers$Sandboxes$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Developers$ManageSandboxes$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$Developers$Sandboxes$subscriptions = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Platform$Sub$none,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Components$Developers$ManageSandboxes$subscriptions,
				$elm$core$Platform$Sub$map($elm$core$Basics$identity)),
			model.k7));
};
var $author$project$OutMsg$GoToRouteAndReloadAction = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Developers$ManageSandboxes$SandboxPracticeCreated = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$OutMsg$SwitchToOrganization = F3(
	function (a, b, c) {
		return {$: 16, a: a, b: b, c: c};
	});
var $author$project$Api$Provider$ManagedPartner$Sandbox$Practice$create = F3(
	function (apiClient, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practice',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(params.Bq))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Practice$IdAndName$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$Sandbox$Practice$sandboxPracticesPath)));
	});
var $author$project$Components$Developers$ManageSandboxes$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{s6: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{pP: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ci: $elm$core$Maybe$Just(
								_Utils_Tuple2(
									$elm$core$Maybe$Just('Sandbox Practice'),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ci: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var name = msg.a;
				var _v2 = model.ci;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var request = _v3.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ci: $elm$core$Maybe$Just(
									_Utils_Tuple2(
										$author$project$Utils$String$toMaybe(name),
										request))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				var _v4 = model.ci;
				if ((!_v4.$) && (!_v4.a.a.$)) {
					var _v5 = _v4.a;
					var name = _v5.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ci: $elm$core$Maybe$Just(
									_Utils_Tuple2(
										$elm$core$Maybe$Just(name),
										$author$project$Api$Data$Loading))
							}),
						A3(
							$author$project$Api$Provider$ManagedPartner$Sandbox$Practice$create,
							apiClient,
							{Bq: name},
							$author$project$Components$Developers$ManageSandboxes$SandboxPracticeCreated(name)),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var name = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ci: $elm$core$Maybe$Nothing, pP: $author$project$Api$Data$Loading}),
						A2($author$project$Api$Provider$ManagedPartner$Sandbox$Practice$list, apiClient, $author$project$Components$Developers$ManageSandboxes$GotSandboxPractices),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Sandbox practice added')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ci: $elm$core$Maybe$Just(
									_Utils_Tuple2(
										$elm$core$Maybe$Just(name),
										response))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var organizationId = msg.a;
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					_List_fromArray(
						[
							A3(
							$author$project$OutMsg$SwitchToOrganization,
							organizationId,
							$elm$core$Maybe$Nothing,
							$author$project$OutMsg$GoToRouteAndReloadAction($author$project$Spa$Generated$Route$Patients__Top))
						]));
		}
	});
var $author$project$Pages$Admin$Developers$Sandboxes$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = model.k7;
		if (!_v1.$) {
			var sandboxes = _v1.a;
			var _v2 = A3($author$project$Components$Developers$ManageSandboxes$update, model.Gv, subMsg, sandboxes);
			var updated = _v2.a;
			var cmd = _v2.b;
			var outMsgs = _v2.c;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						k7: $elm$core$Maybe$Just(updated)
					}),
				A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd),
				outMsgs);
		} else {
			return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Components$Developers$ManageSandboxes$skeleton = A2(
	$author$project$Ui$Panel$view,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Panel$heading,
			_List_fromArray(
				[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
			_List_fromArray(
				[
					$author$project$Ui$Panel$title(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$spanMd(5)
								]))
						])),
					$author$project$Ui$Skeleton$input(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$spanSm(3)
						]))
				])),
			A2(
			$author$project$Ui$Panel$body,
			_List_Nil,
			A2(
				$elm$core$List$repeat,
				3,
				$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[$author$project$Ui$Skeleton$block]))))
		]));
var $author$project$Components$Developers$ManageSandboxes$NewSandboxPracticeClosed = {$: 3};
var $author$project$Components$Developers$ManageSandboxes$NewSandboxPracticeNameUpdated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Developers$ManageSandboxes$SaveSandboxPractice = {$: 5};
var $author$project$Components$Developers$ManageSandboxes$viewAddSandboxPracticeModal = F2(
	function (name, request) {
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$Developers$ManageSandboxes$NewSandboxPracticeClosed,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('Add Sandbox Practice')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Name'),
									$author$project$Ui$Form$Group$required(true),
									$author$project$Ui$Form$Group$labelSpanSm(4),
									$author$project$Ui$Form$Group$inputSpanSm(8)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(
											A2($elm$core$Maybe$withDefault, '', name)),
											$author$project$Ui$Form$Input$onInput($author$project$Components$Developers$ManageSandboxes$NewSandboxPracticeNameUpdated),
											$author$project$Ui$Form$Input$invalid(
											_Utils_eq(name, $elm$core$Maybe$Nothing)),
											$author$project$Ui$Form$Input$errors(
											_Utils_eq(name, $elm$core$Maybe$Nothing) ? _List_fromArray(
												['Name is required']) : _List_Nil)
										]))
								]))
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Cancel and close modal'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Components$Developers$ManageSandboxes$NewSandboxPracticeClosed)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Add Sandbox Practice'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$onClick($author$project$Components$Developers$ManageSandboxes$SaveSandboxPractice),
									$author$project$Ui$Button$loading(
									_Utils_eq(request, $author$project$Api$Data$Loading))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Add Sandbox Practice')
								]))
						]))
				]));
	});
var $author$project$Components$Developers$ManageSandboxes$NewSandboxPractice = {$: 2};
var $author$project$Api$Provider$ManagedPartner$Shared$sandboxEnabled = function (_v0) {
	var record = _v0;
	return record.aao;
};
var $author$project$Api$Provider$ManagedPartner$One$sandboxEnabled = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ManagedPartner$Shared$sandboxEnabled(shared);
};
var $author$project$Components$Developers$ManageSandboxes$SwitchToSandbox = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$ManagedPartner$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$ManagedPartner$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ManagedPartner$Shared$id(shared);
};
var $author$project$Api$Provider$Practice$All$organizationId = function (_v0) {
	var record = _v0.b;
	return record.ajD;
};
var $author$project$Components$Developers$ManageSandboxes$viewSandboxPracticeRow = F2(
	function (managedPartner, sandboxPractice) {
		var sandboxName = $author$project$Api$Provider$Practice$All$name(sandboxPractice);
		var isCurrentSandbox = _Utils_eq(
			$author$project$Api$Provider$Practice$All$id(sandboxPractice),
			$author$project$Api$Provider$ManagedPartner$One$id(managedPartner));
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(sandboxName)
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$textRight]),
					_List_fromArray(
						[
							isCurrentSandbox ? $author$project$Utils$Html$empty : A3(
							$author$project$Ui$Button$view,
							{mm: 'Switch' + sandboxName},
							_List_fromArray(
								[
									$author$project$Ui$Button$default,
									$author$project$Ui$Button$sm,
									$author$project$Ui$Button$onClick(
									$author$project$Components$Developers$ManageSandboxes$SwitchToSandbox(
										$author$project$Api$Provider$Practice$All$organizationId(sandboxPractice)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Switch')
								]))
						]))
				]));
	});
var $author$project$Components$Developers$ManageSandboxes$viewSandboxPracticesTable = F2(
	function (managedPartner, model) {
		var _v0 = function () {
			var _v1 = model.pP;
			if (_v1.$ === 3) {
				var practices = _v1.a;
				return _Utils_Tuple2(false, practices);
			} else {
				return _Utils_Tuple2(true, _List_Nil);
			}
		}();
		var loading = _v0.a;
		var sandboxPractices = _v0.b;
		return A4(
			$author$project$Ui$Panel$table,
			_List_fromArray(
				[
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('You don\'t have any sandbox practices')
						])),
					$author$project$Ui$Table$loading(loading)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$header,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Name')
						])),
					A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
				]),
			A2(
				$elm$core$List$map,
				$author$project$Components$Developers$ManageSandboxes$viewSandboxPracticeRow(managedPartner),
				sandboxPractices),
			_List_Nil);
	});
var $author$project$Components$Developers$ManageSandboxes$viewSandboxPractices = F2(
	function (managedPartner, model) {
		return A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_fromArray(
						[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
					_List_fromArray(
						[
							$author$project$Ui$Panel$title(
							_List_fromArray(
								[
									$elm$html$Html$text('Sandbox Practices')
								])),
							$author$project$Api$Provider$ManagedPartner$One$sandboxEnabled(managedPartner) ? A3(
							$author$project$Ui$Button$view,
							{mm: 'Add sandbox practice'},
							_List_fromArray(
								[
									$author$project$Ui$Button$default,
									$author$project$Ui$Button$onClick($author$project$Components$Developers$ManageSandboxes$NewSandboxPractice)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Add Sandbox Practice')
								])) : $author$project$Utils$Html$empty
						])),
					A2($author$project$Components$Developers$ManageSandboxes$viewSandboxPracticesTable, managedPartner, model)
				]));
	});
var $author$project$Components$Developers$ManageSandboxes$view = function (_v0) {
	var model = _v0;
	return _List_fromArray(
		[
			function () {
			var _v1 = model.ci;
			if (!_v1.$) {
				var _v2 = _v1.a;
				var name = _v2.a;
				var request = _v2.b;
				return A2($author$project$Components$Developers$ManageSandboxes$viewAddSandboxPracticeModal, name, request);
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			function () {
			var _v3 = model.s6;
			if (_v3.$ === 3) {
				var managedPartner = _v3.a;
				return A2($author$project$Components$Developers$ManageSandboxes$viewSandboxPractices, managedPartner, model);
			} else {
				return $author$project$Components$Developers$ManageSandboxes$skeleton;
			}
		}()
		]);
};
var $author$project$Pages$Admin$Developers$Sandboxes$view = function (model) {
	return {
		fO: function () {
			var _v0 = model.k7;
			if (_v0.$ === 1) {
				return _List_fromArray(
					[$author$project$Components$Developers$ManageSandboxes$skeleton]);
			} else {
				var sandboxes = _v0.a;
				return A2(
					$elm$core$List$map,
					$elm$html$Html$map($elm$core$Basics$identity),
					$author$project$Components$Developers$ManageSandboxes$view(sandboxes));
			}
		}(),
		ac9: 'Admin | Developers | Sandboxes'
	};
};
var $author$project$Pages$Admin$Developers$Sandboxes$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Developers$Sandboxes$init, aiq: $author$project$Pages$Admin$Developers$Sandboxes$load, k8: $author$project$Pages$Admin$Developers$Sandboxes$save, alO: $author$project$Pages$Admin$Developers$Sandboxes$subscriptions, adT: $author$project$Pages$Admin$Developers$Sandboxes$update, amo: $author$project$Pages$Admin$Developers$Sandboxes$view});
var $author$project$Pages$Admin$Developers$WebhookEndpoints$GotManagedPartner = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$Developers$WebhookEndpoints$init = F4(
	function (_v0, practice, shared, _v1) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, j9: $elm$core$Maybe$Nothing, s6: $author$project$Api$Data$Loading, k3: $elm$core$Maybe$Nothing, J7: shared.J7},
			$author$project$Api$Provider$Practice$One$hasManagedPartner(practice) ? A2($author$project$Api$Provider$ManagedPartner$retrieve, shared.Gv, $author$project$Pages$Admin$Developers$WebhookEndpoints$GotManagedPartner) : A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Developers__GetStarted));
	});
var $author$project$Pages$Admin$Developers$WebhookEndpoints$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Developers$WebhookEndpoints$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Developers$WebhookEndpoints$LiveMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$Developers$WebhookEndpoints$SandboxMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$Developers$WebhookEndpoints$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Developers$ManageWebhookEndpoints$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Pages$Admin$Developers$WebhookEndpoints$LiveMsg)),
					model.j9)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Developers$ManageWebhookEndpoints$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Pages$Admin$Developers$WebhookEndpoints$SandboxMsg)),
					model.k3))
			]));
};
var $author$project$Components$Developers$ManageWebhookEndpoints$Integration = 1;
var $author$project$Pages$Admin$Developers$WebhookEndpoints$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var managedPartner = response.a;
					var _v2 = $author$project$Api$Provider$ManagedPartner$One$integration(managedPartner);
					if (!_v2.$) {
						var _v3 = A3($author$project$Components$Developers$ManageWebhookEndpoints$init, model.Gv, model.J7, 2);
						var sandboxEndpoints = _v3.a;
						var sandboxCmd = _v3.b;
						var _v4 = A3($author$project$Components$Developers$ManageWebhookEndpoints$init, model.Gv, model.J7, 1);
						var liveEndpoints = _v4.a;
						var liveCmd = _v4.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									j9: $elm$core$Maybe$Just(liveEndpoints),
									s6: response,
									k3: $elm$core$Maybe$Just(sandboxEndpoints)
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Developers$WebhookEndpoints$LiveMsg, liveCmd),
										A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Developers$WebhookEndpoints$SandboxMsg, sandboxCmd)
									])),
							_List_Nil);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{s6: response}),
							A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Developers__GetStarted),
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{s6: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var _v5 = model.j9;
				if (!_v5.$) {
					var liveEndpoints = _v5.a;
					var _v6 = A3($author$project$Components$Developers$ManageWebhookEndpoints$update, model.Gv, subMsg, liveEndpoints);
					var updated = _v6.a;
					var cmd = _v6.b;
					var outMsgs = _v6.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								j9: $elm$core$Maybe$Just(updated)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Developers$WebhookEndpoints$LiveMsg, cmd),
						outMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var subMsg = msg.a;
				var _v7 = model.k3;
				if (!_v7.$) {
					var sandboxEndpoints = _v7.a;
					var _v8 = A3($author$project$Components$Developers$ManageWebhookEndpoints$update, model.Gv, subMsg, sandboxEndpoints);
					var updated = _v8.a;
					var cmd = _v8.b;
					var outMsgs = _v8.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								k3: $elm$core$Maybe$Just(updated)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Developers$WebhookEndpoints$SandboxMsg, cmd),
						outMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Admin$Developers$WebhookEndpoints$viewSkeleton = A2($elm$core$List$repeat, 2, $author$project$Components$Developers$ManageWebhookEndpoints$skeleton);
var $author$project$Pages$Admin$Developers$WebhookEndpoints$view = function (model) {
	return {
		fO: function () {
			var _v0 = model.s6;
			if (_v0.$ === 1) {
				return $author$project$Pages$Admin$Developers$WebhookEndpoints$viewSkeleton;
			} else {
				return $elm$core$List$concat(
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Components$Developers$ManageWebhookEndpoints$view,
									$elm$core$List$map(
										$elm$html$Html$map($author$project$Pages$Admin$Developers$WebhookEndpoints$LiveMsg))),
								model.j9)),
							A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Components$Developers$ManageWebhookEndpoints$view,
									$elm$core$List$map(
										$elm$html$Html$map($author$project$Pages$Admin$Developers$WebhookEndpoints$SandboxMsg))),
								model.k3))
						]));
			}
		}(),
		ac9: 'Admin | Developers | Webhook Endpoints'
	};
};
var $author$project$Pages$Admin$Developers$WebhookEndpoints$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Developers$WebhookEndpoints$init, aiq: $author$project$Pages$Admin$Developers$WebhookEndpoints$load, k8: $author$project$Pages$Admin$Developers$WebhookEndpoints$save, alO: $author$project$Pages$Admin$Developers$WebhookEndpoints$subscriptions, adT: $author$project$Pages$Admin$Developers$WebhookEndpoints$update, amo: $author$project$Pages$Admin$Developers$WebhookEndpoints$view});
var $author$project$Pages$Admin$Documents$Id_String$DocumentFormMsg = $elm$core$Basics$identity;
var $author$project$Components$Admin$Documents$Form$GotItem = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$Documents$Form$LanguageDropdownMsg = function (a) {
	return {$: 20, a: a};
};
var $author$project$Components$Admin$Documents$Form$LocationResourceFilterMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Admin$Documents$Form$Model = $elm$core$Basics$identity;
var $author$project$Api$Feature$MultiLanguage = 10;
var $author$project$Components$Admin$Documents$Form$PlanResourceFilterMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Provider$DocumentVersion$DocumentVersionType$File = 1;
var $author$project$Api$Provider$Document$AcceptanceType$TypeName = 1;
var $author$project$Components$Admin$Documents$Form$formFieldsInit = function (practice) {
	return _Utils_Tuple2(
		{
			Kx: 'I have read and agree to the ' + $author$project$Api$Provider$Practice$One$name(practice),
			Ky: 1,
			KN: true,
			G1: $elm$core$Maybe$Nothing,
			er: $elm$core$Maybe$Nothing,
			QT: _List_Nil,
			QU: $elm$core$Maybe$Just('Agreement'),
			zk: 1,
			sp: 0,
			Sp: $elm$core$Maybe$Nothing,
			sw: false,
			V4: $elm$core$Maybe$Nothing,
			Bq: '',
			ZF: 2,
			akR: true,
			abo: true,
			alH: 'published',
			adD: _List_Nil
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Components$ResourceFilter$Location$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Api$Provider$Location$PracticeExtras = 1;
var $author$project$Api$Provider$Location$All$Location = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Location$Shared$Location = $elm$core$Basics$identity;
var $author$project$Api$Provider$Location$Shared$Record = function (id) {
	return function (name) {
		return function (onlineSignupVisibility) {
			return function (businessLocation) {
				return function (virtual) {
					return function (phoneNumber) {
						return function (address) {
							return function (locationGroup) {
								return function (affiliation) {
									return function (isMaster) {
										return function (isSynced) {
											return function (practiceName) {
												return function (locationType) {
													return {K2: address, Li: affiliation, MY: businessLocation, ahP: id, UV: isMaster, Vf: isSynced, s4: locationGroup, Wf: locationType, Bq: name, Ym: onlineSignupVisibility, Zx: phoneNumber, ZY: practiceName, aej: virtual};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Affiliate$AffiliateMin$Affiliate = $elm$core$Basics$identity;
var $author$project$Api$Provider$Affiliate$AffiliateMin$Record = F2(
	function (id, name) {
		return {ahP: id, Bq: name};
	});
var $author$project$Api$Provider$Affiliate$AffiliateMin$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Affiliate$AffiliateMin$Record)));
var $author$project$Api$Provider$Affiliate$AffiliateMin$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Affiliate$AffiliateMin$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Location$Shared$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'location_type',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'practice_name',
		$elm$json$Json$Decode$string,
		'',
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'is_synced',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'is_master',
				$elm$json$Json$Decode$bool,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'affiliation',
					$elm$json$Json$Decode$nullable($author$project$Api$Provider$Affiliate$AffiliateMin$decoder),
					$elm$core$Maybe$Nothing,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'location_group',
						$elm$json$Json$Decode$nullable($author$project$Api$Common$LocationGroup$Shared$decoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'address',
							$elm$json$Json$Decode$nullable($author$project$Api$Common$Address$Shared$decoder),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'phone_number',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'virtual',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'business_location',
										$elm$json$Json$Decode$bool,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'online_signup_visibility',
											$elm$json$Json$Decode$bool,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'name',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'id',
													$elm$json$Json$Decode$string,
													$elm$json$Json$Decode$succeed($author$project$Api$Provider$Location$Shared$Record))))))))))))));
var $author$project$Api$Provider$Location$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Location$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Location$All$Record = F2(
	function (hasPatients, meta) {
		return {Te: hasPatients, W4: meta};
	});
var $author$project$Api$Provider$Location$Meta$Meta = $elm$core$Basics$identity;
var $author$project$Api$Provider$Location$Meta$MetaRecord = function (actions) {
	return {vy: actions};
};
var $author$project$Api$Provider$Location$Meta$ActionsRecord = function (_delete) {
	return {Qi: _delete};
};
var $author$project$Api$Provider$Location$Meta$actionsRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'delete',
	$elm$json$Json$Decode$bool,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Location$Meta$ActionsRecord));
var $author$project$Api$Provider$Location$Meta$metaRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'actions',
	$author$project$Api$Provider$Location$Meta$actionsRecordDecoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Location$Meta$MetaRecord));
var $author$project$Api$Provider$Location$Meta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Location$Meta$metaRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Location$All$recordDecoder = A3(
	$author$project$Api$Expandable$expandable,
	'meta',
	$author$project$Api$Provider$Location$Meta$decoder,
	A3(
		$author$project$Api$Expandable$expandable,
		'has_patients',
		$elm$json$Json$Decode$bool,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Location$All$Record)));
var $author$project$Api$Provider$Location$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Location$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Location$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Location$All$Location)));
var $author$project$Api$Provider$Location$expandToString = function (expand) {
	if (!expand) {
		return 'meta';
	} else {
		return 'practice_extras';
	}
};
var $author$project$Api$Provider$Location$listDefaults = {
	Gn: $elm$core$Maybe$Nothing,
	HE: _List_Nil,
	ahP: $elm$core$Maybe$Nothing,
	s4: $elm$core$Maybe$Nothing,
	IW: $elm$core$Maybe$Nothing,
	ajJ: $elm$core$Maybe$Nothing,
	aka: $elm$core$Maybe$Nothing,
	akl: $elm$core$Maybe$Nothing,
	JM: $elm$core$Maybe$Nothing,
	alA: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init)
};
var $author$project$Api$Provider$Location$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Location$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.akl;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.ahP;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.s4;
				if (!_v2.$) {
					var string = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'location_group', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v3 = options.ajJ;
				if (!_v3.$) {
					var pagination = _v3.a;
					return $author$project$Api$Pagination$toApiParams(pagination);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.alA),
				function () {
				var _v4 = options.IW;
				if (!_v4.$) {
					var bool = _v4.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$bool, 'online_signup', bool)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v5 = options.JM;
				if (!_v5.$) {
					var ident = _v5.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'signup_page', ident)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v6 = options.aka;
				if (!_v6.$) {
					var ident = _v6.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'practitioner', ident)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v7 = options.Gn;
				if (!_v7.$) {
					var ident = _v7.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'affiliate', ident)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				A2($author$project$Api$Expandable$toParam, $author$project$Api$Provider$Location$expandToString, options.HE)
			]));
};
var $author$project$Api$Provider$Location$locationsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['locations']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Location$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Location$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Location$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Location$locationsPath)));
	});
var $author$project$Components$ResourceFilter$Location$list = $author$project$Api$Provider$Location$list;
var $author$project$Api$Affiliate$AffiliateMin$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Location$Shared$affiliation = function (_v0) {
	var record = _v0;
	return record.Li;
};
var $author$project$Api$Provider$Location$All$affiliation = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Location$Shared$affiliation(shared);
};
var $author$project$Api$Provider$Location$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Location$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Location$Shared$id(shared);
};
var $author$project$Api$Provider$Location$Shared$isMaster = function (_v0) {
	var record = _v0;
	return record.UV;
};
var $author$project$Api$Provider$Location$All$isMaster = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Location$Shared$isMaster(shared);
};
var $author$project$Api$Provider$Location$Shared$isSynced = function (_v0) {
	var record = _v0;
	return record.Vf;
};
var $author$project$Api$Provider$Location$All$isSynced = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Location$Shared$isSynced(shared);
};
var $author$project$Api$Provider$Location$Shared$locationType = function (_v0) {
	var record = _v0;
	return record.Wf;
};
var $author$project$Api$Provider$Location$All$locationType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Location$Shared$locationType(shared);
};
var $author$project$Api$Provider$Location$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$Location$All$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Location$Shared$name(shared);
};
var $author$project$Api$Provider$Location$Shared$practiceName = function (_v0) {
	var record = _v0;
	return record.ZY;
};
var $author$project$Api$Provider$Location$All$practiceName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Location$Shared$practiceName(shared);
};
var $author$project$Components$ResourceFilter$Location$resourceFromAll = function (location) {
	return {
		Li: A2(
			$elm$core$Maybe$map,
			$author$project$Api$Affiliate$AffiliateMin$Provider,
			$author$project$Api$Provider$Location$All$affiliation(location)),
		ahP: $author$project$Api$Provider$Location$All$id(location),
		UV: $author$project$Api$Provider$Location$All$isMaster(location),
		Vf: $author$project$Api$Provider$Location$All$isSynced(location),
		Wf: $author$project$Api$Provider$Location$All$locationType(location),
		Bq: $author$project$Api$Provider$Location$All$name(location),
		ZY: $author$project$Api$Provider$Location$All$practiceName(location)
	};
};
var $author$project$Components$ResourceFilter$Location$fetchResources = F6(
	function (locationGroupId, listOptionals, toMsg, apiClient, pagination, query) {
		return A3(
			$author$project$Components$ResourceFilter$Location$list,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{
							HE: A2($elm$core$List$cons, 1, d.HE),
							s4: locationGroupId,
							ajJ: $elm$core$Maybe$Just(pagination),
							akl: query
						});
				}),
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Components$ResourceFilter$Location$resourceFromAll))));
	});
var $author$project$Components$ResourceFilter$Location$retrieveResource = F5(
	function (locationGroupId, listOptionals, toMsg, apiClient, id) {
		return A3(
			$author$project$Components$ResourceFilter$Location$list,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{
							HE: A2($elm$core$List$cons, 1, d.HE),
							ahP: $elm$core$Maybe$Just(id),
							s4: locationGroupId,
							ajJ: $elm$core$Maybe$Just($author$project$Api$Pagination$init)
						});
				}),
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Components$ResourceFilter$Location$resourceFromAll))));
	});
var $author$project$Components$ResourceFilter$Location$selectId = 'locations';
var $author$project$Ui$Typography$Ellipsis = {$: 13};
var $author$project$Ui$Typography$ellipsis = $author$project$Ui$Typography$Ellipsis;
var $author$project$Components$ResourceFilter$Location$extraText = function (resource) {
	var practiceName_ = resource.ZY;
	var locationType_ = resource.Wf;
	var parts = A2(
		$elm$core$List$filter,
		A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
		_List_fromArray(
			[
				locationType_,
				A2($elm$core$String$left, 50, practiceName_)
			]));
	return $elm$core$List$isEmpty(parts) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		A2($elm$core$String$join, ' | ', parts));
};
var $author$project$Components$SyncedIcon$Master = 0;
var $author$project$Components$SyncedIcon$Role = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$SyncedIcon$master = $author$project$Components$SyncedIcon$Role(0);
var $author$project$Components$SyncedIcon$SyncStatus = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$SyncedIcon$status = $author$project$Components$SyncedIcon$SyncStatus;
var $author$project$Components$SyncedIcon$Synced = 1;
var $author$project$Components$SyncedIcon$synced = $author$project$Components$SyncedIcon$Role(1);
var $author$project$Components$ResourceFilter$Location$toTitle = function ($) {
	return $.Bq;
};
var $author$project$Ui$Icon$Current = 4;
var $author$project$Ui$Icon$currentColor = $author$project$Ui$Icon$IconColor(4);
var $author$project$Ui$Icon$SyncedTo = 0;
var $author$project$Ui$Icon$syncedTo = $author$project$Ui$Icon$viewIcon(0);
var $author$project$Components$SyncedIcon$defaultOptions = {iL: $author$project$Ui$Icon$currentColor, ahO: $author$project$Ui$Icon$syncedTo, V8: false, aly: $author$project$Ui$Icon$base};
var $author$project$Ui$Icon$Primary = 1;
var $author$project$Ui$Icon$primary = $author$project$Ui$Icon$IconColor(1);
var $author$project$Ui$Icon$SyncedFrom = 1;
var $author$project$Ui$Icon$syncedFrom = $author$project$Ui$Icon$viewIcon(1);
var $author$project$Components$SyncedIcon$optionToRecord = F2(
	function (option, record) {
		switch (option.$) {
			case 2:
				var _v1 = option.a;
				return _Utils_update(
					record,
					{aly: $author$project$Ui$Icon$base});
			case 0:
				if (!option.a) {
					var _v2 = option.a;
					return _Utils_update(
						record,
						{ahO: $author$project$Ui$Icon$syncedTo});
				} else {
					var _v3 = option.a;
					return _Utils_update(
						record,
						{ahO: $author$project$Ui$Icon$syncedFrom});
				}
			default:
				if (option.a.$ === 1) {
					var _v4 = option.a;
					return record;
				} else {
					var status_ = option.a.a;
					switch (status_) {
						case 2:
							return _Utils_update(
								record,
								{iL: $author$project$Ui$Icon$primary});
						case 1:
							return _Utils_update(
								record,
								{iL: $author$project$Ui$Icon$currentColor});
						case 3:
							return _Utils_update(
								record,
								{iL: $author$project$Ui$Icon$danger});
						default:
							return _Utils_update(
								record,
								{iL: $author$project$Ui$Icon$info});
					}
				}
		}
	});
var $author$project$Components$SyncedIcon$view = function (options) {
	var optionsRecord = A3($elm$core$List$foldl, $author$project$Components$SyncedIcon$optionToRecord, $author$project$Components$SyncedIcon$defaultOptions, options);
	return optionsRecord.V8 ? $author$project$Utils$Html$empty : A2(
		$elm$html$Html$map,
		$elm$core$Basics$never,
		optionsRecord.ahO(
			_List_fromArray(
				[optionsRecord.iL, optionsRecord.aly])));
};
var $author$project$Components$ResourceFilter$Location$toLabel = function (resource) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceX2]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceX2]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[
									$author$project$Ui$Typography$phi(true)
								]),
							$author$project$Components$ResourceFilter$Location$toTitle(resource)),
							resource.UV ? $author$project$Components$SyncedIcon$view(
							_List_fromArray(
								[
									$author$project$Components$SyncedIcon$master,
									$author$project$Components$SyncedIcon$status($elm$core$Maybe$Nothing)
								])) : $elm$html$Html$text(''),
							resource.Vf ? $author$project$Components$SyncedIcon$view(
							_List_fromArray(
								[
									$author$project$Components$SyncedIcon$synced,
									$author$project$Components$SyncedIcon$status($elm$core$Maybe$Nothing)
								])) : $elm$html$Html$text('')
						])),
					A2(
					$elm$core$Maybe$withDefault,
					$elm$html$Html$text(''),
					A2(
						$elm$core$Maybe$map,
						function (info) {
							return A2(
								$author$project$Ui$Typography$text,
								_List_fromArray(
									[$author$project$Ui$Typography$small, $author$project$Ui$Typography$ellipsis]),
								info);
						},
						$author$project$Components$ResourceFilter$Location$extraText(resource)))
				]))
		]);
};
var $author$project$Components$ResourceFilter$Location$toValue = function ($) {
	return $.ahP;
};
var $author$project$Components$ResourceFilter$Location$init = F4(
	function (apiClient, locationGroupId, listOptionals, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{
				Sk: A2($author$project$Components$ResourceFilter$Location$fetchResources, locationGroupId, listOptionals),
				ahP: $author$project$Components$ResourceFilter$Location$selectId,
				k$: 'Location',
				uk: A2($author$project$Components$ResourceFilter$Location$retrieveResource, locationGroupId, listOptionals),
				u9: $author$project$Components$ResourceFilter$Location$toLabel,
				lN: $author$project$Components$ResourceFilter$Location$toTitle,
				hX: $author$project$Components$ResourceFilter$Location$toValue
			},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{Jy: $author$project$Components$ResourceFilter$All, b8: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$Admin$Documents$Form$initPlanResourceFilter = F3(
	function (apiClient, session, planType) {
		var planTypes = (!planType) ? _List_fromArray(
			[0, 1]) : _List_fromArray(
			[2, 3]);
		return A4(
			$author$project$Components$ResourceFilter$Plan$init,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{De: planTypes});
			},
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Select a Plan'});
			});
	});
var $author$project$Api$Provider$Document$One$Document = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Document$Shared$Document = $elm$core$Basics$identity;
var $author$project$Api$Provider$Document$Shared$Record = function (id) {
	return function (documentType) {
		return function (name) {
			return function (active) {
				return function (showOnSignup) {
					return function (required) {
						return function (documentAgreementsCount) {
							return function (acceptanceText) {
								return function (acceptanceType) {
									return function (status) {
										return {Kx: acceptanceText, Ky: acceptanceType, KN: active, QS: documentAgreementsCount, QU: documentType, ahP: id, Bq: name, akR: required, abo: showOnSignup, alH: status};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Document$AcceptanceType$ClickBox = 0;
var $author$project$Api$Provider$Document$AcceptanceType$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'click_box':
				return $elm$json$Json$Decode$succeed(0);
			case 'type_name':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Unsupported document -> acceptance type: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$Document$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'status',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'acceptance_type',
		$author$project$Api$Provider$Document$AcceptanceType$decode,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'acceptance_text',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'document_agreements_count',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'required',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'show_on_signup',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'active',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'name',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'document_type',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Api$Provider$Document$Shared$Record)))))))))));
var $author$project$Api$Provider$Document$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Document$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Document$One$Record = F3(
	function (currentDocumentVersion, documentScopes, translations) {
		return {af1: currentDocumentVersion, QT: documentScopes, adD: translations};
	});
var $author$project$Api$Provider$DocumentVersion$Shared$DocumentVersion = $elm$core$Basics$identity;
var $author$project$Api$Provider$DocumentVersion$Shared$Record = F5(
	function (id, documentVersionType, content, linkUrl, createdAt) {
		return {G1: content, O1: createdAt, zk: documentVersionType, ahP: id, V4: linkUrl};
	});
var $author$project$Api$Provider$DocumentVersion$DocumentVersionType$Link = 0;
var $author$project$Api$Provider$DocumentVersion$DocumentVersionType$Text = 2;
var $author$project$Api$Provider$DocumentVersion$DocumentVersionType$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'file':
				return $elm$json$Json$Decode$succeed(1);
			case 'text':
				return $elm$json$Json$Decode$succeed(2);
			case 'link':
				return $elm$json$Json$Decode$succeed(0);
			default:
				return $elm$json$Json$Decode$fail('Unsupported document version -> document version type: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$DocumentVersion$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'created_at',
	$elm_community$json_extra$Json$Decode$Extra$datetime,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'link_url',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'content',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'document_version_type',
				$author$project$Api$Provider$DocumentVersion$DocumentVersionType$decoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$DocumentVersion$Shared$Record))))));
var $author$project$Api$Provider$DocumentVersion$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$DocumentVersion$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Translation$All$Record = F4(
	function (id, content, field, language) {
		return {G1: content, Sl: field, ahP: id, Ay: language};
	});
var $author$project$Api$Provider$Translation$All$Translation = $elm$core$Basics$identity;
var $author$project$Api$Provider$Translation$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'language',
		$author$project$Language$decode,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'field',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'content',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$Translation$All$Record))))),
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$DocumentScope$Shared$DocumentScope = $elm$core$Basics$identity;
var $author$project$Api$Provider$DocumentScope$Shared$Record = F3(
	function (scopeIdent, scopeName, scopeType) {
		return {aax: scopeIdent, aay: scopeName, aaz: scopeType};
	});
var $author$project$Api$Provider$DocumentScope$Shared$Location = 1;
var $author$project$Api$Provider$DocumentScope$Shared$Plan = 0;
var $author$project$Api$Provider$DocumentScope$Shared$scopeTypeDecoder = function (string) {
	switch (string) {
		case 'Plan':
			return $elm$json$Json$Decode$succeed(0);
		case 'Location':
			return $elm$json$Json$Decode$succeed(1);
		default:
			return $elm$json$Json$Decode$fail('Unsupported document scope -> scope type: ' + string);
	}
};
var $author$project$Api$Provider$DocumentScope$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'scope_type',
	A2($elm$json$Json$Decode$andThen, $author$project$Api$Provider$DocumentScope$Shared$scopeTypeDecoder, $elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'scope_name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'scope_ident',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$DocumentScope$Shared$Record))));
var $author$project$Api$Provider$DocumentScope$Shared$sharedDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$DocumentScope$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Document$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'translations',
	$elm$json$Json$Decode$list($author$project$Api$Provider$Translation$All$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'document_scopes',
		$elm$json$Json$Decode$list($author$project$Api$Provider$DocumentScope$Shared$sharedDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'current_document_version',
			$author$project$Api$Provider$DocumentVersion$Shared$decoder,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Document$One$Record))));
var $author$project$Api$Provider$Document$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Document$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Document$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Document$One$Document)));
var $author$project$Api$Provider$Document$documentsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['documents']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Document$documentPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$Document$documentsPath);
};
var $author$project$Api$Provider$Document$retrieve = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Document$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Document$documentPath(id_)));
	});
var $author$project$Components$Admin$Documents$Form$init = F5(
	function (apiClient, session, id, practice, _v0) {
		var isOnboarding = _v0.bb;
		var multiLanguage = A2($author$project$Api$Provider$Practice$One$featureEnabled, 10, practice);
		var _v1 = A3($author$project$Components$Admin$Documents$Form$initPlanResourceFilter, apiClient, session, 2);
		var planResourceFilter = _v1.a;
		var planResourceFilterCmd = _v1.b;
		var _v2 = A4(
			$author$project$Components$ResourceFilter$Location$init,
			apiClient,
			$elm$core$Maybe$Nothing,
			$elm$core$Basics$identity,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Select a Location'});
			});
		var locationResourceFilter = _v2.a;
		var locationResourceFilterCmd = _v2.b;
		var _v3 = function () {
			if (!id.$) {
				var id_ = id.a;
				return _Utils_Tuple2(
					$elm$core$Maybe$Nothing,
					A3($author$project$Api$Provider$Document$retrieve, apiClient, id_, $author$project$Components$Admin$Documents$Form$GotItem));
			} else {
				return A2(
					$elm$core$Tuple$mapFirst,
					$elm$core$Maybe$Just,
					$author$project$Components$Admin$Documents$Form$formFieldsInit(practice));
			}
		}();
		var formFields = _v3.a;
		var cmd = _v3.b;
		return _Utils_Tuple2(
			{
				y_: $elm$core$Maybe$Nothing,
				nj: multiLanguage ? $elm$core$Maybe$Just(
					$author$project$Ui$Dropdown$init(
						$author$project$Ui$Dropdown$defaultConfig(
							{ahP: 'document-content-language-dropdown', al6: $author$project$Components$Admin$Documents$Form$LanguageDropdownMsg}))) : $elm$core$Maybe$Nothing,
				gh: $author$project$Language$english,
				SD: A2($elm$core$Maybe$map, $author$project$Utils$Form$init, formFields),
				ahP: id,
				UB: false,
				bb: isOnboarding,
				os: locationResourceFilter,
				hi: planResourceFilter,
				ZV: practice,
				k9: $author$project$Api$Data$NotAsked,
				aa4: session,
				alH: 'published',
				h_: $elm$core$Maybe$Nothing
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						cmd,
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$Documents$Form$PlanResourceFilterMsg, planResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$Documents$Form$LocationResourceFilterMsg, locationResourceFilterCmd)
					])));
	});
var $author$project$Pages$Admin$Documents$Id_String$init = F4(
	function (session, practice, _v0, _v1) {
		var apiClient = _v0.Gv;
		var params = _v1.YL;
		var _v2 = A5(
			$author$project$Components$Admin$Documents$Form$init,
			apiClient,
			session,
			$elm$core$Maybe$Just(params.ahP),
			practice,
			{bb: false});
		var form = _v2.a;
		var cmd = _v2.b;
		return _Utils_Tuple2(
			{Gv: apiClient, SD: form},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
	});
var $author$project$Pages$Admin$Documents$Id_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Documents$Id_String$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Admin$Documents$Form$Content = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$Admin$Documents$Form$FormUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$Documents$Form$Ignore = {$: 0};
var $author$project$Components$Admin$Documents$Form$TranslationsInputMsg = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Admin$Documents$Form$documentContentEditorId = 'document-content-editor';
var $author$project$Components$ResourceFilter$Location$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.b8));
};
var $author$project$Components$TranslationsInput$ModalClosed = {$: 0};
var $author$project$Components$TranslationsInput$subscriptions = function (_v0) {
	var open = _v0.Yn;
	var languageDropdown = _v0.oh;
	return open ? (languageDropdown.Yn ? $author$project$Ui$Dropdown$subscriptions(languageDropdown) : $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$TranslationsInput$ModalClosed)) : $elm$core$Platform$Sub$none;
};
var $author$project$Components$Admin$Documents$Form$subscriptions = function (_v0) {
	var translationInput = _v0.h_;
	var documentTranslationLanguage = _v0.gh;
	var documentTranslationDropdown = _v0.nj;
	var locationResourceFilter = _v0.os;
	var planResourceFilter = _v0.hi;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$TranslationsInput$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Components$Admin$Documents$Form$TranslationsInputMsg)),
					translationInput)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2($elm$core$Maybe$map, $author$project$Ui$Dropdown$subscriptions, documentTranslationDropdown)),
				$author$project$Ports$CKEditor$onChange(
				F2(
					function (elementId, value) {
						return _Utils_eq(elementId, $author$project$Components$Admin$Documents$Form$documentContentEditorId) ? A2(
							$elm$core$Basics$composeL,
							$author$project$Components$Admin$Documents$Form$FormUpdated,
							$author$project$Components$Admin$Documents$Form$Content(documentTranslationLanguage))(value) : $author$project$Components$Admin$Documents$Form$Ignore;
					})),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Admin$Documents$Form$LocationResourceFilterMsg,
				$author$project$Components$ResourceFilter$Location$subscriptions(locationResourceFilter)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Admin$Documents$Form$PlanResourceFilterMsg,
				$author$project$Components$ResourceFilter$Plan$subscriptions(planResourceFilter))
			]));
};
var $author$project$Pages$Admin$Documents$Id_String$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Admin$Documents$Form$subscriptions(model.SD));
};
var $author$project$Components$Admin$Documents$Form$Archived = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Admin$Documents$Form$DocumentScopeAdd = F3(
	function (a, b, c) {
		return {$: 10, a: a, b: b, c: c};
	});
var $author$project$Components$Admin$Documents$Form$DocumentVersionType = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$Documents$Form$File = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Admin$Documents$Form$GotSignedFileUrl = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Admin$Documents$Form$Save = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$Documents$Form$Unarchived = function (a) {
	return {$: 16, a: a};
};
var $author$project$Api$Provider$Document$documentArchivePath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['archive']),
		$author$project$Api$Provider$Document$documentPath(id_));
};
var $author$project$Api$Provider$Document$archive = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Document$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Document$documentArchivePath(id_)));
	});
var $author$project$Components$Admin$Documents$Form$contentByLanguage = F2(
	function (language, form) {
		var _v0 = $author$project$Utils$Form$fields(form);
		var content = _v0.G1;
		var translations = _v0.adD;
		return _Utils_eq(language, $author$project$Language$english) ? content : A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.G1;
			},
			A2(
				$elm_community$list_extra$List$Extra$find,
				function (t) {
					return _Utils_eq(t.Ay, language) && (t.Sl === 'content');
				},
				translations));
	});
var $author$project$Api$Provider$Document$One$currentDocumentVersion = function (_v0) {
	var record = _v0.b;
	return record.af1;
};
var $author$project$Components$TranslationsInput$Document = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$TranslationsInput$document = $author$project$Components$TranslationsInput$Document;
var $author$project$Api$Provider$Document$Shared$acceptanceText = function (_v0) {
	var record = _v0;
	return record.Kx;
};
var $author$project$Api$Provider$Document$One$acceptanceText = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Document$Shared$acceptanceText(shared);
};
var $author$project$Api$Provider$Document$Shared$acceptanceType = function (_v0) {
	var record = _v0;
	return record.Ky;
};
var $author$project$Api$Provider$Document$One$acceptanceType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Document$Shared$acceptanceType(shared);
};
var $author$project$Api$Provider$Document$Shared$active = function (_v0) {
	var record = _v0;
	return record.KN;
};
var $author$project$Api$Provider$Document$One$active = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Document$Shared$active(shared);
};
var $author$project$Api$Provider$DocumentVersion$Shared$content = function (_v0) {
	var record = _v0;
	return record.G1;
};
var $author$project$Api$Provider$Translation$All$content = function (_v0) {
	var translation = _v0;
	return translation.G1;
};
var $author$project$Api$Provider$Document$One$documentScopes = function (_v0) {
	var record = _v0.b;
	return record.QT;
};
var $author$project$Api$Provider$Document$Shared$documentType = function (_v0) {
	var record = _v0;
	return record.QU;
};
var $author$project$Api$Provider$Document$One$documentType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Document$Shared$documentType(shared);
};
var $author$project$Api$Provider$DocumentVersion$Shared$documentVersionType = function (_v0) {
	var record = _v0;
	return record.zk;
};
var $author$project$Api$Provider$Translation$All$field = function (_v0) {
	var translation = _v0;
	return translation.Sl;
};
var $author$project$Api$Provider$Translation$All$language = function (_v0) {
	var translation = _v0;
	return translation.Ay;
};
var $author$project$Api$Provider$DocumentVersion$Shared$linkUrl = function (_v0) {
	var record = _v0;
	return record.V4;
};
var $author$project$Api$Provider$Document$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$Document$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Document$Shared$name(shared);
};
var $author$project$Api$Provider$Document$Shared$required = function (_v0) {
	var record = _v0;
	return record.akR;
};
var $author$project$Api$Provider$Document$One$required = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Document$Shared$required(shared);
};
var $author$project$Api$Provider$DocumentScope$Shared$scopeIdent = function (_v0) {
	var record = _v0;
	return record.aax;
};
var $author$project$Api$Provider$DocumentScope$Shared$scopeName = function (_v0) {
	var record = _v0;
	return record.aay;
};
var $author$project$Api$Provider$DocumentScope$Shared$scopeType = function (_v0) {
	var record = _v0;
	return record.aaz;
};
var $author$project$Api$Provider$Document$Shared$showOnSignup = function (_v0) {
	var record = _v0;
	return record.abo;
};
var $author$project$Api$Provider$Document$One$showOnSignup = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Document$Shared$showOnSignup(shared);
};
var $author$project$Api$Provider$Document$Shared$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Api$Provider$Document$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Document$Shared$status(shared);
};
var $author$project$Api$Provider$Document$One$translations = function (_v0) {
	var record = _v0.b;
	return record.adD;
};
var $author$project$Components$Admin$Documents$Form$formFieldsFromItem = function (document) {
	var documentScopes = A2(
		$elm$core$List$map,
		function (documentScope) {
			return {
				aax: $author$project$Api$Provider$DocumentScope$Shared$scopeIdent(documentScope),
				aay: $author$project$Api$Provider$DocumentScope$Shared$scopeName(documentScope),
				aaz: $author$project$Api$Provider$DocumentScope$Shared$scopeType(documentScope)
			};
		},
		$author$project$Api$Provider$Document$One$documentScopes(document));
	var currentDocumentVersion = $author$project$Api$Provider$Document$One$currentDocumentVersion(document);
	var documentVersionType = $author$project$Api$Provider$DocumentVersion$Shared$documentVersionType(currentDocumentVersion);
	var content = $author$project$Api$Provider$DocumentVersion$Shared$content(currentDocumentVersion);
	var cmd = (documentVersionType === 2) ? A4(
		$author$project$Ports$CKEditor$replace,
		$author$project$Components$Admin$Documents$Form$documentContentEditorId,
		A2($elm$core$Maybe$withDefault, '', content),
		_List_Nil,
		$elm$core$Maybe$Nothing) : $elm$core$Platform$Cmd$none;
	return _Utils_Tuple2(
		{
			Kx: $author$project$Api$Provider$Document$One$acceptanceText(document),
			Ky: $author$project$Api$Provider$Document$One$acceptanceType(document),
			KN: $author$project$Api$Provider$Document$One$active(document),
			G1: content,
			er: A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$DocumentScope$Shared$scopeType,
				$elm$core$List$head(
					$author$project$Api$Provider$Document$One$documentScopes(document))),
			QT: documentScopes,
			QU: $elm$core$Maybe$Just(
				$author$project$Api$Provider$Document$One$documentType(document)),
			zk: documentVersionType,
			sp: 0,
			Sp: $elm$core$Maybe$Nothing,
			sw: documentVersionType === 1,
			V4: $author$project$Api$Provider$DocumentVersion$Shared$linkUrl(currentDocumentVersion),
			Bq: $author$project$Api$Provider$Document$One$name(document),
			ZF: 2,
			akR: $author$project$Api$Provider$Document$One$required(document),
			abo: $author$project$Api$Provider$Document$One$showOnSignup(document),
			alH: $author$project$Api$Provider$Document$One$status(document),
			adD: A2(
				$elm$core$List$map,
				function (t) {
					return {
						G1: $author$project$Api$Provider$Translation$All$content(t),
						Sl: $author$project$Api$Provider$Translation$All$field(t),
						Ay: $author$project$Api$Provider$Translation$All$language(t)
					};
				},
				$author$project$Api$Provider$Document$One$translations(document))
		},
		cmd);
};
var $author$project$Components$Admin$Documents$Form$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						QU: $author$project$Utils$String$toMaybe(string)
					});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{Bq: string});
			case 2:
				var documentVersionType = field.a;
				return _Utils_update(
					fields,
					{zk: documentVersionType});
			case 3:
				var _int = field.a;
				var string = field.b;
				return _Utils_update(
					fields,
					{
						sp: _int,
						Sp: $elm$core$Maybe$Just(string),
						sw: true
					});
			case 4:
				var language = field.a;
				var string = field.b;
				if (_Utils_eq(language, $author$project$Language$english)) {
					return _Utils_update(
						fields,
						{
							G1: $author$project$Utils$String$toMaybe(string)
						});
				} else {
					var translations = A2(
						$elm$core$List$cons,
						{G1: string, Sl: 'content', Ay: language},
						A2(
							$elm$core$List$filter,
							function (t) {
								return !(_Utils_eq(t.Ay, language) && (t.Sl === 'content'));
							},
							fields.adD));
					return _Utils_update(
						fields,
						{adD: translations});
				}
			case 5:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						V4: $author$project$Utils$String$toMaybe(string)
					});
			case 6:
				var bool = field.a;
				return _Utils_update(
					fields,
					{KN: bool});
			case 7:
				var bool = field.a;
				return _Utils_update(
					fields,
					{abo: bool});
			case 8:
				var documentScopeType = field.a;
				return _Utils_update(
					fields,
					{er: documentScopeType, QT: _List_Nil});
			case 9:
				var planType = field.a;
				return _Utils_update(
					fields,
					{ZF: planType});
			case 10:
				var scopeType = field.a;
				var id = field.b;
				var name = field.c;
				var documentScope = A2(
					$elm_community$list_extra$List$Extra$find,
					function (documentScope_) {
						return _Utils_eq(documentScope_.aaz, scopeType) && _Utils_eq(documentScope_.aax, id);
					},
					fields.QT);
				var documentScopes = function () {
					if (!documentScope.$) {
						return fields.QT;
					} else {
						return A2(
							$elm$core$List$cons,
							{aax: id, aay: name, aaz: scopeType},
							fields.QT);
					}
				}();
				return _Utils_update(
					fields,
					{QT: documentScopes});
			case 11:
				var scopeType = field.a;
				var id = field.b;
				var documentScopes = A2(
					$elm_community$list_extra$List$Extra$filterNot,
					function (documentScope) {
						return _Utils_eq(documentScope.aaz, scopeType) && _Utils_eq(documentScope.aax, id);
					},
					fields.QT);
				return _Utils_update(
					fields,
					{QT: documentScopes});
			case 12:
				var bool = field.a;
				return _Utils_update(
					fields,
					{akR: bool, abo: bool || fields.abo});
			case 13:
				var string = field.a;
				return _Utils_update(
					fields,
					{Ky: string});
			default:
				var string = field.a;
				return _Utils_update(
					fields,
					{Kx: string});
		}
	});
var $author$project$Components$Admin$Documents$Form$DocumentTypeValidation = 0;
var $author$project$Components$Admin$Documents$Form$NameValidation = 1;
var $author$project$Components$Admin$Documents$Form$ContentValidation = 4;
var $author$project$Components$Admin$Documents$Form$validateContent = function (fields) {
	var invalid = _Utils_Tuple2(4, 'Please enter some text');
	var _v0 = _Utils_Tuple2(fields.zk, fields.G1);
	if (_v0.a === 2) {
		if (!_v0.b.$) {
			var _v1 = _v0.a;
			var content = _v0.b.a;
			return $elm$core$String$isEmpty(content) ? _List_fromArray(
				[invalid]) : _List_Nil;
		} else {
			var _v2 = _v0.a;
			var _v3 = _v0.b;
			return _List_fromArray(
				[invalid]);
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Admin$Documents$Form$DocumentScopesValidation = 5;
var $author$project$Components$Admin$Documents$Form$validateDocumentScopes = function (fields) {
	var invalid = function (scopeName) {
		return _Utils_Tuple2(5, 'Please specify at least one ' + (scopeName + '.'));
	};
	var _v0 = _Utils_Tuple2(
		fields.er,
		$elm$core$List$isEmpty(fields.QT));
	_v0$2:
	while (true) {
		if (!_v0.a.$) {
			if (!_v0.a.a) {
				if (_v0.b) {
					var _v1 = _v0.a.a;
					return _List_fromArray(
						[
							invalid('plan')
						]);
				} else {
					break _v0$2;
				}
			} else {
				if (_v0.b) {
					var _v2 = _v0.a.a;
					return _List_fromArray(
						[
							invalid('location')
						]);
				} else {
					break _v0$2;
				}
			}
		} else {
			break _v0$2;
		}
	}
	return _List_Nil;
};
var $author$project$Components$Admin$Documents$Form$FileValidation = 3;
var $author$project$Components$Admin$Documents$Form$maxFileBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
var $author$project$Components$Admin$Documents$Form$validateFile = function (fields) {
	var _v0 = _Utils_Tuple2(fields.zk, fields.sw);
	if (_v0.a === 1) {
		if (_v0.b) {
			var _v1 = _v0.a;
			return (_Utils_cmp(fields.sp, $author$project$Components$Admin$Documents$Form$maxFileBytesSize) > 0) ? _List_fromArray(
				[
					_Utils_Tuple2(3, 'That file is too large! Our maximum file size is 5 mb.')
				]) : _List_Nil;
		} else {
			var _v2 = _v0.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(3, 'Please upload a file')
				]);
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Admin$Documents$Form$UrlValidation = 2;
var $author$project$Components$Admin$Documents$Form$validateUrl = function (fields) {
	var invalid = _Utils_Tuple2(2, 'URL must start with https://');
	var _v0 = _Utils_Tuple2(fields.zk, fields.V4);
	if (!_v0.a) {
		if (!_v0.b.$) {
			var _v1 = _v0.a;
			var linkUrl = _v0.b.a;
			return A2($elm$core$String$startsWith, 'https://', linkUrl) ? _List_Nil : _List_fromArray(
				[invalid]);
		} else {
			var _v2 = _v0.a;
			var _v3 = _v0.b;
			return _List_fromArray(
				[invalid]);
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Admin$Documents$Form$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.QU;
			},
			_Utils_Tuple2(0, 'Please pick a document type.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.Bq;
			},
			_Utils_Tuple2(1, 'Please enter a name.')),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$Documents$Form$validateUrl),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$Documents$Form$validateFile),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$Documents$Form$validateContent),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$Documents$Form$validateDocumentScopes)
		]));
var $author$project$Api$Provider$Document$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Document$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Document$Shared$id(shared);
};
var $author$project$Api$Provider$DocumentVersion$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Components$TranslationsInput$LanguageDropdownMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$TranslationsInput$init = function (translatable_) {
	var availableLanguages = _List_fromArray(
		[$author$project$Language$spanish]);
	return {
		xv: availableLanguages,
		SD: $elm$core$Maybe$Nothing,
		Ay: A2(
			$elm$core$Maybe$withDefault,
			$author$project$Language$spanish,
			$elm$core$List$head(availableLanguages)),
		oh: $author$project$Ui$Dropdown$init(
			$author$project$Ui$Dropdown$defaultConfig(
				{ahP: 'translations-language-dropdown', al6: $author$project$Components$TranslationsInput$LanguageDropdownMsg})),
		Yn: false,
		hZ: translatable_,
		adD: $author$project$Api$Data$NotAsked
	};
};
var $author$project$Components$Admin$Documents$Form$isDocumentArchived = function (status) {
	return status === 'archived';
};
var $author$project$Components$Admin$Documents$Form$Created = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Admin$Documents$Form$ResetAndAddAnother = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Admin$Documents$Form$apiFields = function (fields) {
	return {
		Kx: fields.Kx,
		Ky: fields.Ky,
		KN: fields.KN,
		G1: fields.G1,
		QT: A2(
			$elm$core$List$map,
			function (documentScope) {
				return {aax: documentScope.aax, aaz: documentScope.aaz};
			},
			fields.QT),
		QU: A2($elm$core$Maybe$withDefault, '', fields.QU),
		zk: fields.zk,
		ahj: fields.Sp,
		Bq: fields.Bq,
		akR: fields.akR,
		abo: fields.abo,
		alH: fields.alH,
		adD: fields.adD,
		adY: fields.V4
	};
};
var $author$project$Api$Provider$Document$encodeTranslations = $elm$json$Json$Encode$list(
	function (t) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'field',
					$elm$json$Json$Encode$string(t.Sl)),
					_Utils_Tuple2(
					'content',
					$elm$json$Json$Encode$string(t.G1)),
					_Utils_Tuple2(
					'language',
					$elm$json$Json$Encode$string(
						$author$project$Language$toValue(t.Ay)))
				]));
	});
var $author$project$Api$Provider$DocumentScope$Shared$scopeTypeToString = function (scopeType_) {
	if (!scopeType_) {
		return 'Plan';
	} else {
		return 'Location';
	}
};
var $author$project$Api$Provider$Document$AcceptanceType$toString = function (acceptanceType_) {
	if (!acceptanceType_) {
		return 'click_box';
	} else {
		return 'type_name';
	}
};
var $author$project$Api$Provider$DocumentVersion$DocumentVersionType$toString = function (documentVersionType_) {
	switch (documentVersionType_) {
		case 0:
			return 'link';
		case 1:
			return 'file';
		default:
			return 'text';
	}
};
var $author$project$Api$Provider$Document$create = F3(
	function (apiClient, fields, toMsg) {
		var documentVersion = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'document_version_type',
					$elm$json$Json$Encode$string(
						$author$project$Api$Provider$DocumentVersion$DocumentVersionType$toString(fields.zk))),
					function () {
					var _v1 = fields.zk;
					switch (_v1) {
						case 1:
							return _Utils_Tuple2(
								'file',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ahj));
						case 0:
							return _Utils_Tuple2(
								'url',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.adY));
						default:
							return _Utils_Tuple2(
								'content',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.G1));
					}
				}()
				]));
		var documentScopes_ = A2(
			$elm$json$Json$Encode$list,
			function (_v0) {
				var scopeType = _v0.aaz;
				var scopeIdent = _v0.aax;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'scope_type',
							$elm$json$Json$Encode$string(
								$author$project$Api$Provider$DocumentScope$Shared$scopeTypeToString(scopeType))),
							_Utils_Tuple2(
							'scope_ident',
							$elm$json$Json$Encode$string(scopeIdent))
						]));
			},
			fields.QT);
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'document',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(fields.Bq)),
								_Utils_Tuple2(
								'required',
								$elm$json$Json$Encode$bool(fields.akR)),
								_Utils_Tuple2(
								'active',
								$elm$json$Json$Encode$bool(fields.KN)),
								_Utils_Tuple2(
								'show_on_signup',
								$elm$json$Json$Encode$bool(fields.abo)),
								_Utils_Tuple2(
								'acceptance_text',
								$elm$json$Json$Encode$string(fields.Kx)),
								_Utils_Tuple2(
								'document_type',
								$elm$json$Json$Encode$string(fields.QU)),
								_Utils_Tuple2(
								'acceptance_type',
								$elm$json$Json$Encode$string(
									$author$project$Api$Provider$Document$AcceptanceType$toString(fields.Ky))),
								_Utils_Tuple2('document_scopes', documentScopes_),
								_Utils_Tuple2('document_version', documentVersion),
								_Utils_Tuple2(
								'status',
								$elm$json$Json$Encode$string(fields.alH)),
								_Utils_Tuple2(
								'translations',
								$author$project$Api$Provider$Document$encodeTranslations(fields.adD))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Document$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Document$documentsPath)));
	});
var $author$project$Components$Admin$Documents$Form$createItem = F3(
	function (apiClient, formFields, addAnother) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var createMsg = addAnother ? $author$project$Components$Admin$Documents$Form$ResetAndAddAnother : $author$project$Components$Admin$Documents$Form$Created;
		return A3(
			$author$project$Api$Provider$Document$create,
			apiClient,
			$author$project$Components$Admin$Documents$Form$apiFields(fields),
			createMsg);
	});
var $author$project$Components$Admin$Documents$Form$Updated = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$Document$update = F4(
	function (apiClient, id_, fields, toMsg) {
		var documentVersion = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'document_version_type',
					$elm$json$Json$Encode$string(
						$author$project$Api$Provider$DocumentVersion$DocumentVersionType$toString(fields.zk))),
					function () {
					var _v1 = fields.zk;
					switch (_v1) {
						case 1:
							return _Utils_Tuple2(
								'file',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ahj));
						case 0:
							return _Utils_Tuple2(
								'url',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.adY));
						default:
							return _Utils_Tuple2(
								'content',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.G1));
					}
				}()
				]));
		var documentScopes_ = A2(
			$elm$json$Json$Encode$list,
			function (_v0) {
				var scopeType = _v0.aaz;
				var scopeIdent = _v0.aax;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'scope_type',
							$elm$json$Json$Encode$string(
								$author$project$Api$Provider$DocumentScope$Shared$scopeTypeToString(scopeType))),
							_Utils_Tuple2(
							'scope_ident',
							$elm$json$Json$Encode$string(scopeIdent))
						]));
			},
			fields.QT);
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'document',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(fields.Bq)),
								_Utils_Tuple2(
								'required',
								$elm$json$Json$Encode$bool(fields.akR)),
								_Utils_Tuple2(
								'active',
								$elm$json$Json$Encode$bool(fields.KN)),
								_Utils_Tuple2(
								'show_on_signup',
								$elm$json$Json$Encode$bool(fields.abo)),
								_Utils_Tuple2(
								'acceptance_text',
								$elm$json$Json$Encode$string(fields.Kx)),
								_Utils_Tuple2(
								'document_type',
								$elm$json$Json$Encode$string(fields.QU)),
								_Utils_Tuple2(
								'acceptance_type',
								$elm$json$Json$Encode$string(
									$author$project$Api$Provider$Document$AcceptanceType$toString(fields.Ky))),
								_Utils_Tuple2('document_scopes', documentScopes_),
								_Utils_Tuple2('document_version', documentVersion),
								_Utils_Tuple2(
								'translations',
								$author$project$Api$Provider$Document$encodeTranslations(fields.adD))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Document$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Document$documentPath(id_))));
	});
var $author$project$Components$Admin$Documents$Form$updateItem = F3(
	function (apiClient, id, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4(
			$author$project$Api$Provider$Document$update,
			apiClient,
			id,
			$author$project$Components$Admin$Documents$Form$apiFields(fields),
			$author$project$Components$Admin$Documents$Form$Updated);
	});
var $author$project$Components$Admin$Documents$Form$saveItem = F4(
	function (apiClient, maybeId, formFields, addAnother) {
		if (!maybeId.$) {
			var id_ = maybeId.a;
			return A3($author$project$Components$Admin$Documents$Form$updateItem, apiClient, id_, formFields);
		} else {
			return A3($author$project$Components$Admin$Documents$Form$createItem, apiClient, formFields, addAnother);
		}
	});
var $author$project$Api$Provider$DocumentVersion$documentVersionsPath = function (documentId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['document_versions']),
		$author$project$Api$Provider$Document$documentPath(documentId));
};
var $author$project$Api$Provider$DocumentVersion$documentVersionPath = F2(
	function (documentId, id) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id]),
			$author$project$Api$Provider$DocumentVersion$documentVersionsPath(documentId));
	});
var $author$project$Api$Provider$DocumentVersion$signedFileUrlDecoder = A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string);
var $author$project$Api$Provider$DocumentVersion$signedFileUrl = F4(
	function (apiClient, documentId, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$DocumentVersion$signedFileUrlDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['signed_file_url']),
					A2($author$project$Api$Provider$DocumentVersion$documentVersionPath, documentId, id_))));
	});
var $author$project$Components$Admin$Documents$Form$PracticeOnboardingUpdated = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$Admin$Documents$Form$updatePracticeOnboarding = F3(
	function (apiClient, onboardId, accountStep) {
		return A4($author$project$Api$Provider$PracticeOnboarding$updateAccountStep, apiClient, accountStep, onboardId, $author$project$Components$Admin$Documents$Form$PracticeOnboardingUpdated);
	});
var $author$project$Components$Admin$Documents$Form$skipDocumentsSetup = F2(
	function (apiClient, practice) {
		var onboardId = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$PracticeOnboarding$Shared$id,
				$author$project$Api$Provider$Practice$One$practiceOnboarding(practice)));
		return A3(
			$author$project$Components$Admin$Documents$Form$updatePracticeOnboarding,
			apiClient,
			onboardId,
			$author$project$Api$Provider$PracticeOnboarding$AccountStep$toString(3));
	});
var $author$project$Api$Provider$Document$documentUnarchivePath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['unarchive']),
		$author$project$Api$Provider$Document$documentPath(id_));
};
var $author$project$Api$Provider$Document$unarchive = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Document$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Document$documentUnarchivePath(id_)));
	});
var $author$project$Components$ResourceFilter$Location$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.b8);
		var modelAfterEvent = function () {
			var _v1 = result.agZ;
			if (!_v1.$) {
				var selected = _v1.a;
				return _Utils_update(
					model,
					{Jy: selected});
			} else {
				return model;
			}
		}();
		return {
			GZ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.GZ),
			agZ: result.agZ,
			aiO: _Utils_update(
				modelAfterEvent,
				{b8: result.aiO}),
			aR: result.aR
		};
	});
var $author$project$Api$Translation$Content = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$TranslationsInput$Content = $elm$core$Basics$identity;
var $author$project$Api$Translation$Field = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Translation$Language_ = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Translation$TranslatableId = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Translation$TranslatableType = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$TranslationsInput$TranslationCreated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$TranslationsInput$TranslationDeleted = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$TranslationsInput$TranslationUpdated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$TranslationsInput$findTranslation = F3(
	function (lang, field, translations) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (t) {
					return _Utils_eq(
						$author$project$Api$Provider$Translation$All$language(t),
						lang) && _Utils_eq(
						$author$project$Api$Provider$Translation$All$field(t),
						field);
				},
				translations));
	});
var $author$project$Api$Provider$Translation$All$id = function (_v0) {
	var translation = _v0;
	return translation.ahP;
};
var $author$project$Components$TranslationsInput$andInitForm = F4(
	function (field, defaultContent, translations, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		var translation = A3($author$project$Components$TranslationsInput$findTranslation, model.Ay, field, translations);
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					SD: $elm$core$Maybe$Just(
						$author$project$Utils$Form$init(
							{
								G1: A2(
									$elm$core$Maybe$withDefault,
									defaultContent,
									A2($elm$core$Maybe$map, $author$project$Api$Provider$Translation$All$content, translation)),
								Sl: field,
								ahP: A2($elm$core$Maybe$map, $author$project$Api$Provider$Translation$All$id, translation)
							})),
					Yn: true
				}),
			cmd);
	});
var $author$project$Components$TranslationsInput$GotTranslations = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Api$Translation$listOptionsToParams = function (params) {
	return _List_fromArray(
		[
			A2($author$project$Api$Param$string, 'translatable_id', params.adB),
			A2($author$project$Api$Param$string, 'translatable_type', params.adC)
		]);
};
var $author$project$Api$Translation$translationsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['translations']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Translation$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Translation$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Translation$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Translation$translationsPath)));
	});
var $author$project$Components$TranslationsInput$translatableToId = function (translatable_) {
	switch (translatable_.$) {
		case 0:
			var id = translatable_.a;
			return id;
		case 1:
			var id = translatable_.a;
			return id;
		default:
			return '';
	}
};
var $author$project$Components$TranslationsInput$translatableToResource = function (translatable_) {
	switch (translatable_.$) {
		case 0:
			return 'lead_sources';
		case 1:
			return 'documents';
		default:
			return 'practices';
	}
};
var $author$project$Components$TranslationsInput$andOpenModal = F4(
	function (client, field, defaultContent, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		var _v1 = model.adD;
		switch (_v1.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{Yn: true}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								cmd,
								A3(
								$author$project$Api$Translation$list,
								client,
								{
									adB: $author$project$Components$TranslationsInput$translatableToId(model.hZ),
									adC: $author$project$Components$TranslationsInput$translatableToResource(model.hZ)
								},
								A2($author$project$Components$TranslationsInput$GotTranslations, field, defaultContent))
							])));
			case 3:
				var translations = _v1.a;
				return A4(
					$author$project$Components$TranslationsInput$andInitForm,
					field,
					defaultContent,
					translations,
					_Utils_Tuple2(
						_Utils_update(
							model,
							{Yn: true}),
						cmd));
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{Yn: true}),
					cmd);
		}
	});
var $author$project$Api$Translation$encodePermittedFields = function (permittedFields) {
	var encodedFields = A3(
		$elm$core$List$foldl,
		F2(
			function (field, acc) {
				switch (field.$) {
					case 0:
						var id = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'translatable_id',
								$elm$json$Json$Encode$string(id)),
							acc);
					case 1:
						var type_ = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'translatable_type',
								$elm$json$Json$Encode$string(type_)),
							acc);
					case 2:
						var f = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'field',
								$elm$json$Json$Encode$string(f)),
							acc);
					case 3:
						var c = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'content',
								$elm$json$Json$Encode$string(c)),
							acc);
					default:
						var lang = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'language',
								$elm$json$Json$Encode$string(
									$author$project$Language$toValue(lang))),
							acc);
				}
			}),
		_List_Nil,
		permittedFields);
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'translation',
				$elm$json$Json$Encode$object(encodedFields))
			]));
};
var $author$project$Api$Translation$create = F3(
	function (apiClient, permittedFields, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Translation$All$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Translation$encodePermittedFields(permittedFields),
				$author$project$Api$Data$requestTo($author$project$Api$Translation$translationsPath)));
	});
var $author$project$Api$Translation$delete = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Provider$Translation$All$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						[id]),
					$author$project$Api$Translation$translationsPath)));
	});
var $author$project$Api$Translation$update = F4(
	function (apiClient, id, permittedFields, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$Translation$All$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Translation$encodePermittedFields(permittedFields),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							[id]),
						$author$project$Api$Translation$translationsPath))));
	});
var $author$project$Components$TranslationsInput$updateFormFields = F2(
	function (field, form) {
		var content = field;
		return _Utils_update(
			form,
			{G1: content});
	});
var $author$project$Components$TranslationsInput$update = F3(
	function (client, msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{Yn: false}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var field = msg.a;
				var defaultContent = msg.b;
				return A4(
					$author$project$Components$TranslationsInput$andOpenModal,
					client,
					field,
					defaultContent,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
			case 2:
				var field = msg.a;
				var defaultContent = msg.b;
				var response = msg.c;
				return function (modelCmd) {
					if (response.$ === 3) {
						var translations = response.a;
						return A4($author$project$Components$TranslationsInput$andInitForm, field, defaultContent, translations, modelCmd);
					} else {
						return modelCmd;
					}
				}(
					_Utils_Tuple2(
						_Utils_update(
							model,
							{adD: response}),
						$elm$core$Platform$Cmd$none));
			case 7:
				var translationId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{Yn: false}),
					A3($author$project$Api$Translation$delete, client, translationId, $author$project$Components$TranslationsInput$TranslationDeleted));
			case 3:
				var content = msg.a;
				var _v2 = model.SD;
				if (!_v2.$) {
					var form = _v2.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								SD: $elm$core$Maybe$Just(
									A3($author$project$Utils$Form$update, $author$project$Components$TranslationsInput$updateFormFields, content, form))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 5:
				var translation = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							SD: $elm$core$Maybe$Nothing,
							Yn: false,
							adD: function () {
								if (translation.$ === 3) {
									var translation_ = translation.a;
									return A2(
										$author$project$Api$Data$map,
										function (translations) {
											return A2($elm$core$List$cons, translation_, translations);
										},
										model.adD);
								} else {
									return model.adD;
								}
							}()
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var translation = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							SD: $elm$core$Maybe$Nothing,
							Yn: false,
							adD: function () {
								if (translation.$ === 3) {
									var translation_ = translation.a;
									return A2(
										$author$project$Api$Data$map,
										function (translations) {
											return A2(
												$elm$core$List$map,
												function (t) {
													return _Utils_eq(
														$author$project$Api$Provider$Translation$All$id(t),
														$author$project$Api$Provider$Translation$All$id(translation_)) ? translation_ : t;
												},
												translations);
										},
										model.adD);
								} else {
									return model.adD;
								}
							}()
						}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var translation = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							adD: function () {
								if (translation.$ === 3) {
									var translation_ = translation.a;
									return A2(
										$author$project$Api$Data$map,
										function (translations) {
											return A2(
												$elm$core$List$filterMap,
												function (t) {
													return _Utils_eq(
														$author$project$Api$Provider$Translation$All$id(t),
														$author$project$Api$Provider$Translation$All$id(translation_)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(t);
												},
												translations);
										},
										model.adD);
								} else {
									return model.adD;
								}
							}()
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var _v6 = model.SD;
				if (!_v6.$) {
					var form = _v6.a;
					return A2(
						$elm$core$Tuple$pair,
						model,
						function (_v7) {
							var id = _v7.ahP;
							var content = _v7.G1;
							var field = _v7.Sl;
							if (!id.$) {
								var id_ = id.a;
								return A4(
									$author$project$Api$Translation$update,
									client,
									id_,
									_List_fromArray(
										[
											$author$project$Api$Translation$Content(content),
											$author$project$Api$Translation$Field(field),
											$author$project$Api$Translation$Language_(model.Ay)
										]),
									$author$project$Components$TranslationsInput$TranslationUpdated);
							} else {
								return A3(
									$author$project$Api$Translation$create,
									client,
									_List_fromArray(
										[
											$author$project$Api$Translation$TranslatableId(
											$author$project$Components$TranslationsInput$translatableToId(model.hZ)),
											$author$project$Api$Translation$TranslatableType(
											$author$project$Components$TranslationsInput$translatableToResource(model.hZ)),
											$author$project$Api$Translation$Content(content),
											$author$project$Api$Translation$Field(field),
											$author$project$Api$Translation$Language_(model.Ay)
										]),
									$author$project$Components$TranslationsInput$TranslationCreated);
							}
						}(
							$author$project$Utils$Form$fields(form)));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 9:
				var dropdownMsg = msg.a;
				var _v9 = A2($author$project$Ui$Dropdown$update, dropdownMsg, model.oh);
				var dropdown = _v9.a;
				var dropdownCmd = _v9.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{oh: dropdown}),
					dropdownCmd);
			default:
				var language = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{SD: $elm$core$Maybe$Nothing, Ay: language}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Components$Admin$Documents$Form$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
			case 1:
				var response = msg.a;
				if (response.$ === 3) {
					var document = response.a;
					var translationInput = $author$project$Components$TranslationsInput$init(
						$author$project$Components$TranslationsInput$document(
							$author$project$Api$Provider$Document$One$id(document)));
					var status = $author$project$Api$Provider$Document$One$status(document);
					var currentDocumentVersion = $author$project$Api$Provider$Document$One$currentDocumentVersion(document);
					var _v3 = $author$project$Components$Admin$Documents$Form$formFieldsFromItem(document);
					var formFields = _v3.a;
					var cmd = _v3.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								y_: $elm$core$Maybe$Just(
									$author$project$Api$Provider$DocumentVersion$Shared$id(currentDocumentVersion)),
								SD: $elm$core$Maybe$Just(
									$author$project$Utils$Form$init(formFields)),
								UB: $author$project$Components$Admin$Documents$Form$isDocumentArchived(status),
								alH: status,
								h_: $elm$core$Maybe$Just(translationInput)
							}),
						cmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$reportDecodeError(response));
				}
			case 2:
				var field = msg.a;
				var _v4 = model.SD;
				if (!_v4.$) {
					var form = _v4.a;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Admin$Documents$Form$formFieldsUpdate, field, form);
					var cmd = function () {
						if (_Utils_eq(
							field,
							$author$project$Components$Admin$Documents$Form$DocumentVersionType(2))) {
							var content = A2($author$project$Components$Admin$Documents$Form$contentByLanguage, model.gh, newForm);
							return A4(
								$author$project$Ports$CKEditor$replace,
								$author$project$Components$Admin$Documents$Form$documentContentEditorId,
								A2($elm$core$Maybe$withDefault, '', content),
								_List_Nil,
								$elm$core$Maybe$Nothing);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}();
					var _v5 = function () {
						if (field.$ === 9) {
							var planType = field.a;
							return A3($author$project$Components$Admin$Documents$Form$initPlanResourceFilter, apiClient, model.aa4, planType);
						} else {
							return _Utils_Tuple2(model.hi, $elm$core$Platform$Cmd$none);
						}
					}();
					var planResourceFilter = _v5.a;
					var planResourceFilterCmd = _v5.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								SD: $elm$core$Maybe$Just(newForm),
								hi: planResourceFilter
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									cmd,
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$Documents$Form$PlanResourceFilterMsg, planResourceFilterCmd)
								])),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var files = msg.a;
				var cmd = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						function (_v7) {
							var task = _v7.a;
							var size = _v7.b;
							return A2(
								$elm$core$Task$perform,
								A2(
									$elm$core$Basics$composeL,
									$author$project$Components$Admin$Documents$Form$FormUpdated,
									$author$project$Components$Admin$Documents$Form$File(size)),
								task);
						},
						A2(
							$elm$core$Maybe$map,
							function (file) {
								return _Utils_Tuple2(
									$elm$file$File$toUrl(file),
									$elm$file$File$size(file));
							},
							$elm$core$List$head(files))));
				return _Utils_Tuple3(model, cmd, _List_Nil);
			case 4:
				var addAnother = msg.a;
				var _v8 = model.SD;
				if (!_v8.$) {
					var form = _v8.a;
					var _v9 = A2($author$project$Utils$Form$validate, $author$project$Components$Admin$Documents$Form$formFieldsValidator, form);
					if (!_v9.$) {
						var _v10 = _v9.a;
						var newForm = _v10.a;
						var validFormFields = _v10.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									SD: $elm$core$Maybe$Just(newForm),
									k9: $author$project$Api$Data$Loading
								}),
							A4($author$project$Components$Admin$Documents$Form$saveItem, apiClient, model.ahP, validFormFields, addAnother),
							_List_Nil);
					} else {
						var newForm = _v9.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									SD: $elm$core$Maybe$Just(newForm),
									k9: $author$project$Api$Data$NotAsked
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				return _Utils_Tuple3(
					model,
					A2(
						$elm$core$Task$perform,
						$elm$core$Basics$always(
							$author$project$Components$Admin$Documents$Form$Save(true)),
						$elm$core$Task$succeed($elm$core$Basics$identity)),
					_List_Nil);
			case 6:
				var response = msg.a;
				var _v11 = model.SD;
				if (!_v11.$) {
					if (response.$ === 3) {
						var document = response.a;
						return _Utils_Tuple3(
							model,
							model.bb ? A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Team) : A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Documents__Top),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									'Successfully created ' + $author$project$Api$Provider$Document$One$name(document))
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{k9: response}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var response = msg.a;
				var _v13 = model.SD;
				if (!_v13.$) {
					if (response.$ === 3) {
						var document = response.a;
						var _v15 = A2(
							$elm$core$Tuple$mapFirst,
							$elm$core$Maybe$Just,
							$author$project$Components$Admin$Documents$Form$formFieldsInit(model.ZV));
						var formFields = _v15.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									SD: A2($elm$core$Maybe$map, $author$project$Utils$Form$init, formFields),
									k9: response
								}),
							A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Documents),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									'Successfully created ' + $author$project$Api$Provider$Document$One$name(document))
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{k9: response}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 8:
				var response = msg.a;
				var _v16 = model.SD;
				if (!_v16.$) {
					if (response.$ === 3) {
						var document = response.a;
						return _Utils_Tuple3(
							model,
							A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Documents__Top),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Provider$Document$One$name(document) + ' was successfully updated.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{k9: response}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var subMsg = msg.a;
				var planResourceResult = A3($author$project$Components$ResourceFilter$Plan$update, apiClient, subMsg, model.hi);
				var newForm = function () {
					var _v18 = planResourceResult.agZ;
					if ((!_v18.$) && (!_v18.a.$)) {
						var plan = _v18.a.a;
						var field = A3(
							$author$project$Components$Admin$Documents$Form$DocumentScopeAdd,
							0,
							$author$project$Api$Plan$id(plan),
							$author$project$Api$Plan$name(plan));
						return A2(
							$elm$core$Maybe$map,
							A2($author$project$Utils$Form$update, $author$project$Components$Admin$Documents$Form$formFieldsUpdate, field),
							model.SD);
					} else {
						return model.SD;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: newForm, hi: planResourceResult.aiO}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$Documents$Form$PlanResourceFilterMsg, planResourceResult.GZ),
					planResourceResult.aR);
			case 10:
				var subMsg = msg.a;
				var locationResourceResult = A3($author$project$Components$ResourceFilter$Location$update, apiClient, subMsg, model.os);
				var newForm = function () {
					var _v19 = locationResourceResult.agZ;
					if ((!_v19.$) && (!_v19.a.$)) {
						var location = _v19.a.a;
						var field = A3($author$project$Components$Admin$Documents$Form$DocumentScopeAdd, 1, location.ahP, location.Bq);
						return A2(
							$elm$core$Maybe$map,
							A2($author$project$Utils$Form$update, $author$project$Components$Admin$Documents$Form$formFieldsUpdate, field),
							model.SD);
					} else {
						return model.SD;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: newForm, os: locationResourceResult.aiO}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$Documents$Form$LocationResourceFilterMsg, locationResourceResult.GZ),
					locationResourceResult.aR);
			case 11:
				var documentId = msg.a;
				var documentVersionId = msg.b;
				return _Utils_Tuple3(
					model,
					A4($author$project$Api$Provider$DocumentVersion$signedFileUrl, apiClient, documentId, documentVersionId, $author$project$Components$Admin$Documents$Form$GotSignedFileUrl),
					_List_Nil);
			case 12:
				var response = msg.a;
				if (response.$ === 3) {
					var url = response.a;
					return _Utils_Tuple3(
						model,
						$author$project$Ports$Navigation$openInNewWindow(url),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 13:
				var _v21 = model.ahP;
				if (!_v21.$) {
					var id_ = _v21.a;
					return _Utils_Tuple3(
						model,
						A3($author$project$Api$Provider$Document$archive, apiClient, id_, $author$project$Components$Admin$Documents$Form$Archived),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 14:
				var response = msg.a;
				var _v22 = model.SD;
				if (!_v22.$) {
					if (response.$ === 3) {
						var document = response.a;
						return _Utils_Tuple3(
							model,
							A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Documents__Top),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Provider$Document$One$name(document) + ' was successfully archived.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{k9: response}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 15:
				var _v24 = model.ahP;
				if (!_v24.$) {
					var id_ = _v24.a;
					return _Utils_Tuple3(
						model,
						A3($author$project$Api$Provider$Document$unarchive, apiClient, id_, $author$project$Components$Admin$Documents$Form$Unarchived),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 16:
				var response = msg.a;
				var _v25 = model.SD;
				if (!_v25.$) {
					if (response.$ === 3) {
						var document = response.a;
						return _Utils_Tuple3(
							model,
							A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Documents__Top),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Provider$Document$One$name(document) + ' was successfully unarchived.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{k9: response}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 17:
				return _Utils_Tuple3(
					model,
					A2($author$project$Components$Admin$Documents$Form$skipDocumentsSetup, apiClient, model.ZV),
					_List_Nil);
			case 18:
				var response = msg.a;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							model,
							A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Team),
							_List_Nil);
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error)),
								$author$project$OutMsg$reportDecodeError(response)));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 19:
				var msg_ = msg.a;
				var _v28 = A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model.h_, $elm$core$Platform$Cmd$none),
					A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$mapFirst($elm$core$Maybe$Just),
						A2(
							$elm$core$Maybe$map,
							A2($author$project$Components$TranslationsInput$update, apiClient, msg_),
							model.h_)));
				var translationInput = _v28.a;
				var translationsCmd = _v28.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{h_: translationInput}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$Documents$Form$TranslationsInputMsg, translationsCmd),
					_List_Nil);
			case 20:
				var dropdownMsg = msg.a;
				var _v29 = model.nj;
				if (!_v29.$) {
					var dropdown = _v29.a;
					var _v30 = A2($author$project$Ui$Dropdown$update, dropdownMsg, dropdown);
					var newDropdown = _v30.a;
					var dropdownCmd = _v30.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								nj: $elm$core$Maybe$Just(newDropdown)
							}),
						dropdownCmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var lang = msg.a;
				var _v31 = model.SD;
				if (!_v31.$) {
					var form = _v31.a;
					var fields = $author$project$Utils$Form$fields(form);
					var ckEditorCmd = function () {
						if (fields.zk === 2) {
							var content = A2($author$project$Components$Admin$Documents$Form$contentByLanguage, lang, form);
							return A2(
								$author$project$Ports$CKEditor$setData,
								$author$project$Components$Admin$Documents$Form$documentContentEditorId,
								A2($elm$core$Maybe$withDefault, '', content));
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{gh: lang}),
						ckEditorCmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{gh: lang}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
		}
	});
var $author$project$Pages$Admin$Documents$Id_String$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Admin$Documents$Form$update, model.Gv, subMsg, model.SD);
		var form = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{SD: form}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Components$Admin$Documents$Form$Archive = {$: 13};
var $author$project$Ui$Button$warning = $author$project$Ui$Button$Styled(4);
var $author$project$Components$Admin$Documents$Form$viewArchiveButton = function (model) {
	var _v0 = model.alH;
	if (_v0 === 'unpublished') {
		return A3(
			$author$project$Ui$Button$view,
			{mm: 'Archive document'},
			_List_fromArray(
				[
					$author$project$Ui$Button$warning,
					$author$project$Ui$Button$loading(
					_Utils_eq(model.k9, $author$project$Api$Data$Loading)),
					$author$project$Ui$Button$onClick($author$project$Components$Admin$Documents$Form$Archive)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Archive')
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Admin$Documents$Form$AcceptanceText = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Admin$Documents$Form$Active = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Admin$Documents$Form$DocumentType = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$Documents$Form$FileUploaded = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$Documents$Form$LanguageSelected = function (a) {
	return {$: 21, a: a};
};
var $author$project$Components$Admin$Documents$Form$LinkUrl = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Admin$Documents$Form$Name = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$Documents$Form$OpenFileDocument = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Components$Admin$Documents$Form$Required = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Admin$Documents$Form$ShowOnSignup = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$TranslationsInput$DefaultContent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$TranslationsInput$default = $author$project$Components$TranslationsInput$DefaultContent;
var $author$project$Components$Admin$Documents$Form$documentTypes = _List_fromArray(
	['Contract', 'Agreement', 'Terms and Conditions']);
var $author$project$Components$Admin$Documents$Form$documentTypeOptions = A2(
	$elm$core$List$cons,
	A3(
		$author$project$Ui$Form$Select$option,
		_List_Nil,
		$elm$core$Maybe$Just(''),
		'Select a Document Type'),
	A2(
		$elm$core$List$map,
		function (documentType) {
			return A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(documentType),
				documentType);
		},
		$author$project$Components$Admin$Documents$Form$documentTypes));
var $author$project$Ui$Well$Size = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Well$small = $author$project$Ui$Well$Size(1);
var $author$project$Components$ResourceFilter$Location$view = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$view,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.Jy),
					options),
				model.b8));
	});
var $author$project$Components$TranslationsInput$ModalOpened = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$TranslationsInput$String = 0;
var $author$project$Components$TranslationsInput$defaultOptions = {yO: 0, y8: ''};
var $author$project$Components$TranslationsInput$ContentChanged = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$TranslationsInput$RemovedTranslation = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$TranslationsInput$TranslationSubmitted = {$: 4};
var $author$project$Components$TranslationsInput$LanguageSelected = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$TranslationsInput$viewLanguageSelect = function (_v0) {
	var languageDropdown = _v0.oh;
	var language = _v0.Ay;
	var availableLanguages = _v0.xv;
	var languageToItem = function (lang) {
		return A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(lang, language)),
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Components$TranslationsInput$LanguageSelected(lang))
				]),
			$elm$html$Html$text(
				$author$project$Language$toLabel(lang)));
	};
	var items = A2($elm$core$List$map, languageToItem, availableLanguages);
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Language$toLabel(language))
			]),
		items,
		languageDropdown);
};
var $author$project$Components$TranslationsInput$viewForm = F3(
	function (optionsRecord, form, model) {
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$author$project$Ui$Form$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$onSubmit($author$project$Components$TranslationsInput$TranslationSubmitted)
				]),
			_List_fromArray(
				[
					($elm$core$List$length(model.xv) > 1) ? A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$inputSpan(4),
							$author$project$Ui$Form$Group$label('Now Editing')
						]),
					_List_fromArray(
						[
							$author$project$Components$TranslationsInput$viewLanguageSelect(model)
						])) : $elm$html$Html$text(''),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = optionsRecord.yO;
							if (!_v0) {
								return $author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(fields.G1),
											$author$project$Ui$Form$Input$onInput($author$project$Components$TranslationsInput$ContentChanged)
										]));
							} else {
								return $author$project$Ui$Form$Textarea$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Textarea$value(fields.G1),
											$author$project$Ui$Form$Textarea$onInput($author$project$Components$TranslationsInput$ContentChanged)
										]));
							}
						}()
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$spaceBetween]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Cancel and close modal'},
									_List_fromArray(
										[
											$author$project$Ui$Button$onClick($author$project$Components$TranslationsInput$ModalClosed)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Cancel')
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											function () {
											var _v1 = fields.ahP;
											if (!_v1.$) {
												var translationId = _v1.a;
												return A3(
													$author$project$Ui$Button$view,
													{mm: 'Remove translation'},
													_List_fromArray(
														[
															$author$project$Ui$Button$danger,
															$author$project$Ui$Button$onClick(
															$author$project$Components$TranslationsInput$RemovedTranslation(translationId))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Remove')
														]));
											} else {
												return $elm$html$Html$text('');
											}
										}(),
											A3(
											$author$project$Ui$Button$view,
											{mm: 'Save translation'},
											_List_fromArray(
												[$author$project$Ui$Button$submit, $author$project$Ui$Button$primary]),
											_List_fromArray(
												[
													$elm$html$Html$text('Save')
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$TranslationsInput$viewModal = F2(
	function (optionsRecord, model) {
		return model.Yn ? A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$TranslationsInput$ModalClosed,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title(
							'Edit ' + ($author$project$Language$toLabel(model.Ay) + ' Translation'))
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							function () {
							var _v0 = model.SD;
							if (!_v0.$) {
								var form_ = _v0.a;
								return A3($author$project$Components$TranslationsInput$viewForm, optionsRecord, form_, model);
							} else {
								return $elm$html$Html$text('');
							}
						}()
						]))
				])) : $elm$html$Html$text('');
	});
var $author$project$Components$TranslationsInput$view = F3(
	function (field, options, model) {
		var optionsRecord = A3(
			$elm$core$List$foldl,
			F2(
				function (option, acc) {
					if (!option.$) {
						var defaultContent = option.a;
						return _Utils_update(
							acc,
							{y8: defaultContent});
					} else {
						var contentType = option.a;
						return _Utils_update(
							acc,
							{yO: contentType});
					}
				}),
			$author$project$Components$TranslationsInput$defaultOptions,
			options);
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$inlineBlock]),
			_List_fromArray(
				[
					A2($author$project$Components$TranslationsInput$viewModal, optionsRecord, model),
					A3(
					$author$project$Ui$Button$view,
					{mm: 'Edit translation'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$onClick(
							A2($author$project$Components$TranslationsInput$ModalOpened, field, optionsRecord.y8)),
							$author$project$Ui$Button$icon($author$project$Ui$Icon$translate)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Edit Translation')
						]))
				]));
	});
var $author$project$Components$Admin$Documents$Form$AcceptanceType = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Admin$Documents$Form$viewAcceptanceTypeButton = F4(
	function (currentAcceptanceType, acceptanceType, label, isDisabled) {
		return A3(
			$author$project$Ui$Button$view,
			{mm: 'Select ' + label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(currentAcceptanceType, acceptanceType)),
					$author$project$Ui$Button$onClick(
					$author$project$Components$Admin$Documents$Form$FormUpdated(
						$author$project$Components$Admin$Documents$Form$AcceptanceType(acceptanceType))),
					$author$project$Ui$Button$disabled(isDisabled)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Components$Admin$Documents$Form$DocumentScopeRemove = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Components$Admin$Documents$Form$viewDocumentScope = function (documentScope) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(documentScope.aay),
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Remove ' + documentScope.aay},
				_List_fromArray(
					[
						$author$project$Ui$Button$link,
						$author$project$Ui$Button$sm,
						$author$project$Ui$Button$onClick(
						$author$project$Components$Admin$Documents$Form$FormUpdated(
							A2($author$project$Components$Admin$Documents$Form$DocumentScopeRemove, documentScope.aaz, documentScope.aax))),
						$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
					]),
				_List_Nil)
			]));
};
var $author$project$Components$Admin$Documents$Form$DocumentScopeType = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Admin$Documents$Form$viewDocumentScopeTypeButton = F4(
	function (currentDocumentScopeType, documentScopeType, label, isDisabled) {
		return A3(
			$author$project$Ui$Button$view,
			{mm: 'Select ' + label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(currentDocumentScopeType, documentScopeType)),
					$author$project$Ui$Button$onClick(
					$author$project$Components$Admin$Documents$Form$FormUpdated(
						$author$project$Components$Admin$Documents$Form$DocumentScopeType(documentScopeType))),
					$author$project$Ui$Button$disabled(isDisabled)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Components$Admin$Documents$Form$viewDocumentVersionTypeButton = F4(
	function (currentDocumentVersionType, documentVersionType, label, isDisabled) {
		return A3(
			$author$project$Ui$Button$view,
			{mm: 'Select ' + label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(currentDocumentVersionType, documentVersionType)),
					$author$project$Ui$Button$onClick(
					$author$project$Components$Admin$Documents$Form$FormUpdated(
						$author$project$Components$Admin$Documents$Form$DocumentVersionType(documentVersionType))),
					$author$project$Ui$Button$disabled(isDisabled)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Components$Admin$Documents$Form$PlanType = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Admin$Documents$Form$viewPlanTypeButton = F4(
	function (currentPlanType, planType, label, isDisabled) {
		return A3(
			$author$project$Ui$Button$view,
			{mm: 'Select ' + label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(currentPlanType, planType)),
					$author$project$Ui$Button$onClick(
					$author$project$Components$Admin$Documents$Form$FormUpdated(
						$author$project$Components$Admin$Documents$Form$PlanType(planType))),
					$author$project$Ui$Button$disabled(isDisabled)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Components$Admin$Documents$Form$viewForm = F2(
	function (model, form) {
		var isFormDisabled = model.UB;
		var fields = $author$project$Utils$Form$fields(form);
		return $elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpan(4),
								$author$project$Ui$Form$Group$inputSpan(8),
								$author$project$Ui$Form$Group$required(true),
								$author$project$Ui$Form$Group$label('Document')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(4)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Select$view,
												_List_fromArray(
													[
														$author$project$Ui$Form$Select$value(fields.QU),
														$author$project$Ui$Form$Select$onChange(
														A2($elm$core$Basics$composeL, $author$project$Components$Admin$Documents$Form$FormUpdated, $author$project$Components$Admin$Documents$Form$DocumentType)),
														$author$project$Ui$Form$Select$invalid(
														A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
														$author$project$Ui$Form$Select$errors(
														A2($author$project$Utils$Form$validationErrors, 0, form)),
														$author$project$Ui$Form$Select$disabled(isFormDisabled)
													]),
												$author$project$Components$Admin$Documents$Form$documentTypeOptions)
											])),
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(8)
											]),
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$view(
												_List_fromArray(
													[
														$author$project$Ui$Form$Input$value(fields.Bq),
														$author$project$Ui$Form$Input$placeholder('Name of Document, e.g. \"Member Contract\"'),
														$author$project$Ui$Form$Input$autofocus(true),
														$author$project$Ui$Form$Input$onInput(
														A2($elm$core$Basics$composeL, $author$project$Components$Admin$Documents$Form$FormUpdated, $author$project$Components$Admin$Documents$Form$Name)),
														$author$project$Ui$Form$Input$invalid(
														A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
														$author$project$Ui$Form$Input$errors(
														A2($author$project$Utils$Form$validationErrors, 1, form)),
														$author$project$Ui$Form$Input$disabled(isFormDisabled)
													]))
											]))
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpBlock]),
								_List_fromArray(
									[
										$elm$html$Html$text('Choose the type of document and how it will be shown throughout the application, e.g. \" Member contract \".')
									]))
							])),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpan(4),
								$author$project$Ui$Form$Group$inputSpan(8),
								$author$project$Ui$Form$Group$required(true),
								$author$project$Ui$Form$Group$label('Upload Document')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$spanMd(9)
											]),
										_List_fromArray(
											[
												$author$project$Ui$Button$group(
												_List_fromArray(
													[
														A4($author$project$Components$Admin$Documents$Form$viewDocumentVersionTypeButton, fields.zk, 1, 'Upload a PDF document', isFormDisabled),
														A4($author$project$Components$Admin$Documents$Form$viewDocumentVersionTypeButton, fields.zk, 2, 'Copy & paste text', isFormDisabled),
														A4($author$project$Components$Admin$Documents$Form$viewDocumentVersionTypeButton, fields.zk, 0, 'Link to a document', isFormDisabled)
													]))
											])),
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$spanMd(3)
											]),
										_List_fromArray(
											[
												function () {
												var _v0 = _Utils_Tuple2(model.nj, fields.zk === 2);
												if ((!_v0.a.$) && _v0.b) {
													var dropdown = _v0.a.a;
													var languageToItem = function (lang) {
														return A2(
															$author$project$Ui$Dropdown$item,
															_List_fromArray(
																[
																	$author$project$Ui$Dropdown$selected(
																	_Utils_eq(lang, model.gh)),
																	$author$project$Ui$Dropdown$onSelect(
																	$author$project$Components$Admin$Documents$Form$LanguageSelected(lang))
																]),
															$elm$html$Html$text(
																$author$project$Language$toLabel(lang)));
													};
													var items = A2(
														$elm$core$List$map,
														languageToItem,
														_List_fromArray(
															[$author$project$Language$english, $author$project$Language$spanish]));
													return A2(
														$author$project$Ui$Element$view,
														_List_fromArray(
															[$author$project$Ui$Element$flexMd, $author$project$Ui$Element$flexAuto, $author$project$Ui$Element$itemsCenter]),
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Element$view,
																_List_fromArray(
																	[$author$project$Ui$Element$mr2]),
																_List_fromArray(
																	[
																		A2(
																		$author$project$Ui$Typography$label,
																		_List_fromArray(
																			[$author$project$Ui$Typography$hintLabel]),
																		_List_fromArray(
																			[
																				$author$project$Ui$Icon$translate(_List_Nil),
																				$author$project$Utils$Html$noBreakSpace,
																				$elm$html$Html$text('Now editing')
																			]))
																	])),
																A2(
																$author$project$Ui$Element$view,
																_List_fromArray(
																	[$author$project$Ui$Element$flexAuto]),
																_List_fromArray(
																	[
																		A4(
																		$author$project$Ui$Dropdown$viewSelect,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$elm$html$Html$text(
																				$author$project$Language$toLabel(model.gh))
																			]),
																		items,
																		dropdown)
																	]))
															]));
												} else {
													return $elm$html$Html$text('');
												}
											}()
											]))
									]))
							])),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpan(4),
								$author$project$Ui$Form$Group$inputSpan(8),
								$author$project$Ui$Form$Group$label('')
							]),
						_List_fromArray(
							[
								function () {
								var _v1 = fields.zk;
								switch (_v1) {
									case 1:
										return A2(
											$author$project$Ui$Grid$row,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Grid$column,
													_List_fromArray(
														[
															$author$project$Ui$Grid$span(6)
														]),
													_List_fromArray(
														[
															$author$project$Ui$Form$File$view(
															_List_fromArray(
																[
																	$author$project$Ui$Form$File$accept(2),
																	$author$project$Ui$Form$File$onInput($author$project$Components$Admin$Documents$Form$FileUploaded),
																	$author$project$Ui$Form$File$disabled(isFormDisabled)
																])),
															$author$project$Utils$FormErrors$view(
															A2($author$project$Utils$Form$validationErrors, 3, form))
														])),
													A2(
													$author$project$Ui$Grid$column,
													_List_fromArray(
														[
															$author$project$Ui$Grid$span(6)
														]),
													_List_fromArray(
														[
															function () {
															var _v2 = _Utils_Tuple3(model.ahP, model.y_, fields.Sp);
															if (((!_v2.a.$) && (!_v2.b.$)) && (_v2.c.$ === 1)) {
																var id = _v2.a.a;
																var currentDocumentVersionId = _v2.b.a;
																var _v3 = _v2.c;
																return A3(
																	$author$project$Ui$Button$view,
																	{mm: 'View file'},
																	_List_fromArray(
																		[
																			$author$project$Ui$Button$link,
																			$author$project$Ui$Button$onClick(
																			A2($author$project$Components$Admin$Documents$Form$OpenFileDocument, id, currentDocumentVersionId))
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('View file')
																		]));
															} else {
																return $author$project$Utils$Html$empty;
															}
														}()
														]))
												]));
									case 2:
										return A2(
											$author$project$Ui$Grid$row,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Grid$column,
													_List_fromArray(
														[
															$author$project$Ui$Grid$span(12)
														]),
													_List_fromArray(
														[
															$author$project$Ui$Form$Textarea$view(
															_List_fromArray(
																[
																	$author$project$Ui$Form$Textarea$id($author$project$Components$Admin$Documents$Form$documentContentEditorId),
																	$author$project$Ui$Form$Textarea$disabled(isFormDisabled)
																])),
															$author$project$Utils$FormErrors$view(
															A2($author$project$Utils$Form$validationErrors, 4, form))
														]))
												]));
									default:
										return A2(
											$author$project$Ui$Grid$row,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Grid$column,
													_List_fromArray(
														[
															$author$project$Ui$Grid$span(12)
														]),
													_List_fromArray(
														[
															$author$project$Ui$Form$Input$view(
															_List_fromArray(
																[
																	$author$project$Ui$Form$Input$value(
																	A2($elm$core$Maybe$withDefault, '', fields.V4)),
																	$author$project$Ui$Form$Input$placeholder('https://www.practice.com/patient-terms-and-conditions'),
																	$author$project$Ui$Form$Input$onInput(
																	A2($elm$core$Basics$composeL, $author$project$Components$Admin$Documents$Form$FormUpdated, $author$project$Components$Admin$Documents$Form$LinkUrl)),
																	$author$project$Ui$Form$Input$invalid(
																	A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
																	$author$project$Ui$Form$Input$errors(
																	A2($author$project$Utils$Form$validationErrors, 2, form)),
																	$author$project$Ui$Form$Input$disabled(isFormDisabled)
																]))
														]))
												]));
								}
							}()
							])),
						model.bb ? $author$project$Utils$Html$empty : A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpan(4),
								$author$project$Ui$Form$Group$inputSpan(8),
								$author$project$Ui$Form$Group$label('Published')
							]),
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$view(
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$on(fields.KN),
										$author$project$Ui$ToggleSwitch$onChange(
										A2($elm$core$Basics$composeL, $author$project$Components$Admin$Documents$Form$FormUpdated, $author$project$Components$Admin$Documents$Form$Active)),
										$author$project$Ui$ToggleSwitch$disabled(isFormDisabled)
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpBlock]),
								_List_fromArray(
									[
										$elm$html$Html$text('Only published documents can be viewed and accepted within this platform.')
									]))
							])),
						$author$project$Ui$HorizontalRule$view(_List_Nil),
						model.bb ? $author$project$Utils$Html$empty : A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpan(4),
								$author$project$Ui$Form$Group$inputSpan(8),
								$author$project$Ui$Form$Group$label('Show on Online Signup')
							]),
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$view(
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$on(fields.abo),
										$author$project$Ui$ToggleSwitch$onChange(
										A2($elm$core$Basics$composeL, $author$project$Components$Admin$Documents$Form$FormUpdated, $author$project$Components$Admin$Documents$Form$ShowOnSignup)),
										$author$project$Ui$ToggleSwitch$disabled((!fields.KN) || (fields.akR || isFormDisabled))
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpBlock]),
								_List_fromArray(
									[
										$elm$html$Html$text('Enable this to allow acceptance of the document through Online Signup.')
									]))
							])),
						model.bb ? $author$project$Utils$Html$empty : A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpan(4),
								$author$project$Ui$Form$Group$inputSpan(8),
								$author$project$Ui$Form$Group$label('Visible')
							]),
						_List_fromArray(
							[
								$author$project$Ui$Button$group(
								_List_fromArray(
									[
										A4($author$project$Components$Admin$Documents$Form$viewDocumentScopeTypeButton, fields.er, $elm$core$Maybe$Nothing, 'Everyone', isFormDisabled),
										A4(
										$author$project$Components$Admin$Documents$Form$viewDocumentScopeTypeButton,
										fields.er,
										$elm$core$Maybe$Just(0),
										'Specific Plans',
										isFormDisabled),
										A4(
										$author$project$Components$Admin$Documents$Form$viewDocumentScopeTypeButton,
										fields.er,
										$elm$core$Maybe$Just(1),
										'Specific Locations',
										isFormDisabled)
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpBlock]),
								_List_fromArray(
									[
										$elm$html$Html$text('Show this document all the time, or only to people enrolling for specific plans / locations')
									]))
							]))
					]),
					function () {
					var _v4 = _Utils_Tuple2(fields.er, model.bb);
					if (_v4.b) {
						return _List_fromArray(
							[$author$project$Utils$Html$empty]);
					} else {
						if (!_v4.a.$) {
							if (!_v4.a.a) {
								var _v5 = _v4.a.a;
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$labelSpan(4),
												$author$project$Ui$Form$Group$inputSpan(8),
												$author$project$Ui$Form$Group$label('Plans Type')
											]),
										_List_fromArray(
											[
												$author$project$Ui$Button$group(
												_List_fromArray(
													[
														A4($author$project$Components$Admin$Documents$Form$viewPlanTypeButton, fields.ZF, 2, 'Retail', isFormDisabled),
														A4($author$project$Components$Admin$Documents$Form$viewPlanTypeButton, fields.ZF, 0, 'Employers', isFormDisabled)
													]))
											])),
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$labelSpan(4),
												$author$project$Ui$Form$Group$inputSpan(8),
												$author$project$Ui$Form$Group$label('Restrict To Plans')
											]),
										A2(
											$elm$core$List$cons,
											A2(
												$elm$html$Html$map,
												$author$project$Components$Admin$Documents$Form$PlanResourceFilterMsg,
												A2(
													$author$project$Components$ResourceFilter$Plan$view,
													_List_fromArray(
														[
															$author$project$Components$ResourceFilter$invalid(
															A2($author$project$Utils$Form$hasValidationErrors, 5, form)),
															$author$project$Components$ResourceFilter$errors(
															A2($author$project$Utils$Form$validationErrors, 5, form)),
															$author$project$Components$ResourceFilter$disabled(isFormDisabled)
														]),
													model.hi)),
											A2($elm$core$List$map, $author$project$Components$Admin$Documents$Form$viewDocumentScope, fields.QT)))
									]);
							} else {
								var _v6 = _v4.a.a;
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$labelSpan(4),
												$author$project$Ui$Form$Group$inputSpan(8),
												$author$project$Ui$Form$Group$label('Restrict To Locations')
											]),
										A2(
											$elm$core$List$cons,
											A2(
												$elm$html$Html$map,
												$author$project$Components$Admin$Documents$Form$LocationResourceFilterMsg,
												A2(
													$author$project$Components$ResourceFilter$Location$view,
													_List_fromArray(
														[
															$author$project$Components$ResourceFilter$invalid(
															A2($author$project$Utils$Form$hasValidationErrors, 5, form)),
															$author$project$Components$ResourceFilter$errors(
															A2($author$project$Utils$Form$validationErrors, 5, form)),
															$author$project$Components$ResourceFilter$disabled(isFormDisabled)
														]),
													model.os)),
											A2($elm$core$List$map, $author$project$Components$Admin$Documents$Form$viewDocumentScope, fields.QT)))
									]);
							}
						} else {
							return _List_Nil;
						}
					}
				}(),
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpan(4),
								$author$project$Ui$Form$Group$inputSpan(8),
								$author$project$Ui$Form$Group$label('Required for Online Signup')
							]),
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$view(
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$on(fields.akR),
										$author$project$Ui$ToggleSwitch$onChange(
										A2($elm$core$Basics$composeL, $author$project$Components$Admin$Documents$Form$FormUpdated, $author$project$Components$Admin$Documents$Form$Required)),
										$author$project$Ui$ToggleSwitch$disabled((!fields.KN) || isFormDisabled)
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpBlock]),
								_List_fromArray(
									[
										$elm$html$Html$text('Block online signup unless document is accepted.')
									]))
							])),
						model.bb ? $author$project$Utils$Html$empty : A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpan(4),
								$author$project$Ui$Form$Group$inputSpan(8),
								$author$project$Ui$Form$Group$label('Acceptance type')
							]),
						_List_fromArray(
							[
								$author$project$Ui$Button$group(
								_List_fromArray(
									[
										A4($author$project$Components$Admin$Documents$Form$viewAcceptanceTypeButton, fields.Ky, 0, 'Checking a checkbox', isFormDisabled),
										A4($author$project$Components$Admin$Documents$Form$viewAcceptanceTypeButton, fields.Ky, 1, 'Typing patient name', isFormDisabled)
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpBlock]),
								_List_fromArray(
									[
										$elm$html$Html$text('Choose how the document can be accepted through Online Signup')
									]))
							])),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpan(4),
								$author$project$Ui$Form$Group$inputSpan(8),
								$author$project$Ui$Form$Group$label('Acceptance text')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$mr2, $author$project$Ui$Element$flexAuto]),
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$view(
												_List_fromArray(
													[
														$author$project$Ui$Form$Input$value(fields.Kx),
														$author$project$Ui$Form$Input$onInput(
														A2($elm$core$Basics$composeL, $author$project$Components$Admin$Documents$Form$FormUpdated, $author$project$Components$Admin$Documents$Form$AcceptanceText)),
														$author$project$Ui$Form$Input$disabled(isFormDisabled)
													]))
											])),
										A2(
										$elm$html$Html$map,
										$author$project$Components$Admin$Documents$Form$TranslationsInputMsg,
										A2(
											$elm$core$Maybe$withDefault,
											$author$project$Utils$Html$empty,
											A2(
												$elm$core$Maybe$map,
												A2(
													$author$project$Components$TranslationsInput$view,
													'acceptance_text',
													_List_fromArray(
														[
															$author$project$Components$TranslationsInput$default(fields.Kx)
														])),
												model.h_)))
									])),
								model.bb ? $author$project$Utils$Html$empty : A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpBlock]),
								_List_fromArray(
									[
										$elm$html$Html$text('You can change the text we use on the signup page.'),
										A2($elm$html$Html$br, _List_Nil, _List_Nil),
										$elm$html$Html$text('Here\'s how it will look: ')
									])),
								model.bb ? $author$project$Utils$Html$empty : A2(
								$author$project$Ui$Well$view,
								_List_fromArray(
									[$author$project$Ui$Well$small]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Checkbox$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Checkbox$disabled(true)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(fields.Kx),
												$author$project$Utils$Html$noBreakSpace,
												A3(
												$author$project$Ui$Button$view,
												{mm: fields.Bq},
												_List_fromArray(
													[$author$project$Ui$Button$link]),
												_List_fromArray(
													[
														$elm$html$Html$text(fields.Bq)
													]))
											]))
									]))
							]))
					])
				]));
	});
var $author$project$Components$Admin$Documents$Form$SaveAndAddAnother = {$: 5};
var $author$project$Components$Admin$Documents$Form$SkipDocumentsSetup = {$: 17};
var $author$project$Components$Admin$Documents$Form$viewOnboardingButtons = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$spaceBetween]),
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Skip documents setup'},
				_List_fromArray(
					[
						$author$project$Ui$Button$secondary,
						$author$project$Ui$Button$onClick($author$project$Components$Admin$Documents$Form$SkipDocumentsSetup)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Skip')
					])),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$itemsEnd]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Save and add another document'},
						_List_fromArray(
							[
								$author$project$Ui$Button$secondary,
								$author$project$Ui$Button$loading(
								_Utils_eq(model.k9, $author$project$Api$Data$Loading)),
								$author$project$Ui$Button$onClick($author$project$Components$Admin$Documents$Form$SaveAndAddAnother)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Save & Add Another')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Save document'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$loading(
								_Utils_eq(model.k9, $author$project$Api$Data$Loading)),
								$author$project$Ui$Button$onClick(
								$author$project$Components$Admin$Documents$Form$Save(false))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Save')
							]))
					]))
			]));
};
var $author$project$Components$Admin$Documents$Form$viewSaveButton = function (model) {
	return model.UB ? $author$project$Utils$Html$empty : A3(
		$author$project$Ui$Button$view,
		{
			mm: function () {
				var _v0 = model.ahP;
				if (!_v0.$) {
					return 'Update document';
				} else {
					return 'Create document';
				}
			}()
		},
		_List_fromArray(
			[
				$author$project$Ui$Button$primary,
				$author$project$Ui$Button$loading(
				_Utils_eq(model.k9, $author$project$Api$Data$Loading)),
				$author$project$Ui$Button$onClick(
				$author$project$Components$Admin$Documents$Form$Save(false))
			]),
		_List_fromArray(
			[
				function () {
				var _v1 = model.ahP;
				if (!_v1.$) {
					return $elm$html$Html$text('Update');
				} else {
					return $elm$html$Html$text('Create');
				}
			}()
			]));
};
var $author$project$Components$Admin$Documents$Form$Unarchive = {$: 15};
var $author$project$Components$Admin$Documents$Form$viewUnarchiveButton = function (model) {
	return model.UB ? A3(
		$author$project$Ui$Button$view,
		{mm: 'Unarchive document'},
		_List_fromArray(
			[
				$author$project$Ui$Button$warning,
				$author$project$Ui$Button$loading(
				_Utils_eq(model.k9, $author$project$Api$Data$Loading)),
				$author$project$Ui$Button$onClick($author$project$Components$Admin$Documents$Form$Unarchive)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Unarchive')
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Components$Admin$Documents$Form$view = function (_v0) {
	var model = _v0;
	return A2(
		$author$project$Ui$Form$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$noValidate(true),
				$author$project$Ui$Form$autocomplete(false)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				model.bb ? _List_fromArray(
					[$author$project$Ui$Panel$onlyBorderLeft]) : _List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												function () {
												var _v1 = model.ahP;
												if (!_v1.$) {
													return $elm$html$Html$text('Edit');
												} else {
													return $elm$html$Html$text('Add your patient agreement');
												}
											}()
											])),
										model.bb ? $author$project$Utils$Html$empty : A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Admin__Documents__Top,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Ui$Icon$cross(_List_Nil)
											]))
									])),
								function () {
								var _v2 = model.ahP;
								if (!_v2.$) {
									return $author$project$Utils$Html$empty;
								} else {
									return A2(
										$author$project$Ui$Typography$p,
										_List_fromArray(
											[$author$project$Ui$Typography$muted]),
										_List_fromArray(
											[
												$elm$html$Html$text('Add a document that can be e-signed by patient during Online Signup. Don\'t have an agreement yet? Click '),
												A3(
												$author$project$Ui$Link$externalHref,
												'https://support.hint.com/en/articles/4045458-sample-patient-agreement',
												_List_fromArray(
													[$author$project$Ui$Link$targetBlank]),
												_List_fromArray(
													[
														$elm$html$Html$text('here')
													])),
												$elm$html$Html$text(' to download our sample patient agreement.')
											]));
								}
							}()
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						function () {
							var _v3 = model.SD;
							if (!_v3.$) {
								var form = _v3.a;
								return A2($author$project$Components$Admin$Documents$Form$viewForm, model, form);
							} else {
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$textCenter]),
										_List_fromArray(
											[
												$author$project$Ui$Spinner$view(_List_Nil)
											]))
									]);
							}
						}()),
						model.bb ? A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Components$Admin$Documents$Form$viewOnboardingButtons(model)
							])) : A2(
						$author$project$Ui$Panel$footer,
						_List_fromArray(
							[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$itemsCenter]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Admin__Documents__Top,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Back')
									])),
								$author$project$Components$Admin$Documents$Form$viewSaveButton(model),
								$author$project$Components$Admin$Documents$Form$viewArchiveButton(model),
								$author$project$Components$Admin$Documents$Form$viewUnarchiveButton(model)
							]))
					]))
			]));
};
var $author$project$Pages$Admin$Documents$Id_String$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Admin$Documents$Form$view(model.SD))
			]),
		ac9: 'Admin | Documents'
	};
};
var $author$project$Pages$Admin$Documents$Id_String$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Documents$Id_String$init, aiq: $author$project$Pages$Admin$Documents$Id_String$load, k8: $author$project$Pages$Admin$Documents$Id_String$save, alO: $author$project$Pages$Admin$Documents$Id_String$subscriptions, adT: $author$project$Pages$Admin$Documents$Id_String$update, amo: $author$project$Pages$Admin$Documents$Id_String$view});
var $author$project$Pages$Admin$Documents$New$DocumentFormMsg = $elm$core$Basics$identity;
var $author$project$Pages$Admin$Documents$New$init = F4(
	function (session, practice, _v0, _v1) {
		var apiClient = _v0.Gv;
		var _v2 = A5(
			$author$project$Components$Admin$Documents$Form$init,
			apiClient,
			session,
			$elm$core$Maybe$Nothing,
			practice,
			{bb: false});
		var form = _v2.a;
		var cmd = _v2.b;
		return _Utils_Tuple2(
			{Gv: apiClient, SD: form},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
	});
var $author$project$Pages$Admin$Documents$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Documents$New$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Documents$New$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Admin$Documents$Form$subscriptions(model.SD));
};
var $author$project$Pages$Admin$Documents$New$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Admin$Documents$Form$update, model.Gv, subMsg, model.SD);
		var form = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{SD: form}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Pages$Admin$Documents$New$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Admin$Documents$Form$view(model.SD))
			]),
		ac9: 'Admin | Documents'
	};
};
var $author$project$Pages$Admin$Documents$New$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Documents$New$init, aiq: $author$project$Pages$Admin$Documents$New$load, k8: $author$project$Pages$Admin$Documents$New$save, alO: $author$project$Pages$Admin$Documents$New$subscriptions, adT: $author$project$Pages$Admin$Documents$New$update, amo: $author$project$Pages$Admin$Documents$New$view});
var $author$project$Pages$Admin$Documents$Top$GotDocuments = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Document$All$Document = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Document$All$Record = F2(
	function (currentDocumentVersion, documentScopes) {
		return {af1: currentDocumentVersion, QT: documentScopes};
	});
var $author$project$Api$Provider$Document$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'document_scopes',
	$elm$json$Json$Decode$list($author$project$Api$Provider$DocumentScope$Shared$sharedDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'current_document_version',
		$author$project$Api$Provider$DocumentVersion$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Document$All$Record)));
var $author$project$Api$Provider$Document$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Document$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Document$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Document$All$Document)));
var $author$project$Api$Provider$Document$listDefaults = {ajJ: $author$project$Api$Pagination$init, akl: $elm$core$Maybe$Nothing, alA: $author$project$Api$Sort$init};
var $author$project$Api$Provider$Document$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Document$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.akl;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$Provider$Document$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Document$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Document$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Document$documentsPath)));
	});
var $author$project$Pages$Admin$Documents$Top$fetchDocuments = function (model) {
	return A3(
		$author$project$Api$Provider$Document$list,
		model.Gv,
		function (d) {
			return _Utils_update(
				d,
				{ajJ: model.ajJ, akl: model.akl, alA: model.alA});
		},
		$author$project$Pages$Admin$Documents$Top$GotDocuments);
};
var $author$project$Pages$Admin$Documents$Top$init = F4(
	function (_v0, _v1, _v2, _v3) {
		var apiClient = _v2.Gv;
		var query = _v3.DE;
		var q = A2($elm$core$Dict$get, 'q', query);
		var model = {
			Gv: apiClient,
			cv: $elm$core$Maybe$Nothing,
			f9: $elm$core$Set$empty,
			bZ: $author$project$Api$Data$Loading,
			ajJ: $author$project$Api$Pagination$initFromQuery(query),
			akl: q,
			up: $author$project$Ui$SearchInput$init(q),
			alA: $author$project$Api$Sort$initFromQuery(query)
		};
		return _Utils_Tuple2(
			model,
			$author$project$Pages$Admin$Documents$Top$fetchDocuments(model));
	});
var $author$project$Pages$Admin$Documents$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Documents$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Documents$Top$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Api$Provider$Document$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Document$Shared$id(shared);
};
var $author$project$Pages$Admin$Documents$Top$subscriptions = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Platform$Sub$none,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$Documents$Top$HiConfirmClosed),
				$author$project$Api$Provider$Document$All$id),
			model.cv));
};
var $author$project$Pages$Admin$Documents$Top$DocumentDeleted = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Pages$Admin$Documents$Top$SearchInputMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$Document$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Document$documentPath(id_)));
	});
var $author$project$Pages$Admin$Documents$Top$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('q'),
			model.akl)
		]);
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Admin__Documents__Top)
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.ajJ),
				A2(
					$elm$core$List$append,
					$author$project$Api$Sort$toQuery(model.alA),
					A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
};
var $author$project$Pages$Admin$Documents$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bZ: response,
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bZ: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var id = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									f9: A2($elm$core$Set$remove, id, model.f9),
									bZ: $author$project$Api$Data$Loading
								}),
							$author$project$Pages$Admin$Documents$Top$fetchDocuments(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Document successfully deleted')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									f9: A2($elm$core$Set$remove, id, model.f9)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Admin$Documents$Top$fetchDocuments(newModel),
								$author$project$Pages$Admin$Documents$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 3:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						alA: A2($author$project$Api$Sort$update, columnId, model.alA)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Admin$Documents$Top$fetchDocuments(newModel),
								$author$project$Pages$Admin$Documents$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 4:
				var id = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							cv: $elm$core$Maybe$Nothing,
							f9: A2($elm$core$Set$insert, id, model.f9)
						}),
					A3(
						$author$project$Api$Provider$Document$delete,
						model.Gv,
						id,
						$author$project$Pages$Admin$Documents$Top$DocumentDeleted(id)),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{cv: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v3 = A2($author$project$Ui$SearchInput$update, subMsg, model.up);
				var searchInput = _v3.a;
				var searchInputCmd = _v3.b;
				var searchInputEvent = _v3.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.akl;
					}
				}();
				var _v4 = function () {
					if (_Utils_eq(q, model.akl)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								bZ: $author$project$Api$Data$Loading,
								ajJ: $author$project$Api$Pagination$reset(model.ajJ),
								akl: q
							});
						return _Utils_Tuple2(
							qModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Admin$Documents$Top$fetchDocuments(qModel),
										$author$project$Pages$Admin$Documents$Top$updateUrl(qModel)
									])));
					}
				}();
				var newModel = _v4.a;
				var cmd = _v4.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{up: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Documents$Top$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
		}
	});
var $author$project$Pages$Admin$Documents$Top$PaginationMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$Document$Shared$documentAgreementsCount = function (_v0) {
	var record = _v0;
	return record.QS;
};
var $author$project$Api$Provider$Document$All$documentAgreementsCount = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Document$Shared$documentAgreementsCount(shared);
};
var $author$project$Api$Provider$Document$All$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Document$Shared$name(shared);
};
var $author$project$Pages$Admin$Documents$Top$deleteMessage = function (document) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('You\'re about to delete document '),
							A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$Document$All$name(document))
								]))
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('This will permanently delete '),
							A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(
										$author$project$Api$Provider$Document$All$documentAgreementsCount(document)))
								])),
							$elm$html$Html$text(' signed agreement(s) from patients. If you\'d like to retain your existing patient documents, please unpublish this document instead.')
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Are you sure you want to delete this document?')
						]))
				]))
		]);
};
var $author$project$Pages$Admin$Documents$Top$SortTable = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Admin$Documents$Top$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'name', true, 'Document Name'),
		A3($author$project$Api$Column$init, 'visible', false, 'Visible'),
		A3($author$project$Api$Column$init, 'show_on_signup', true, 'Shown on Signup'),
		A3($author$project$Api$Column$init, 'required', true, 'Required'),
		A3($author$project$Api$Column$init, 'status', true, 'Status')
	]);
var $author$project$Pages$Admin$Documents$Top$documentScopeToString = function (scopeType) {
	if (scopeType === 1) {
		return 'Locations: ';
	} else {
		return 'Plans: ';
	}
};
var $author$project$Api$Provider$Document$All$documentScopes = function (_v0) {
	var all = _v0.b;
	return all.QT;
};
var $author$project$Pages$Admin$Documents$Top$listDocumentScopes = function (documentScopes) {
	return A2(
		$elm$core$String$join,
		', ',
		A2($elm$core$List$map, $author$project$Api$Provider$DocumentScope$Shared$scopeName, documentScopes));
};
var $author$project$Api$Provider$Document$All$required = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Document$Shared$required(shared);
};
var $author$project$Api$Provider$Document$All$showOnSignup = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Document$Shared$showOnSignup(shared);
};
var $author$project$Api$Provider$Document$All$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Document$Shared$status(shared);
};
var $author$project$Pages$Admin$Documents$Top$viewDocument = function (document) {
	var id = $author$project$Api$Provider$Document$All$id(document);
	return A2(
		$author$project$Ui$Table$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Provider$Document$All$name(document))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						function () {
							var _v0 = $elm$core$List$head(
								$author$project$Api$Provider$Document$All$documentScopes(document));
							if (!_v0.$) {
								var documentScope = _v0.a;
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Pages$Admin$Documents$Top$documentScopeToString(
													$author$project$Api$Provider$DocumentScope$Shared$scopeType(documentScope)))
											])),
										$elm$html$Html$text(
										$author$project$Pages$Admin$Documents$Top$listDocumentScopes(
											$author$project$Api$Provider$Document$All$documentScopes(document)))
									]);
							} else {
								return _List_fromArray(
									[
										$elm$html$Html$text('Everyone')
									]);
							}
						}())
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Formatters$Bool$toString(
									$author$project$Api$Provider$Document$All$showOnSignup(document)))
							]))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Formatters$Bool$toString(
									$author$project$Api$Provider$Document$All$required(document)))
							]))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Badge$fromString,
								_List_Nil,
								$author$project$Api$Provider$Document$All$status(document))
							]))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_fromArray(
					[
						$author$project$Ui$Table$minWidth('11rem'),
						$author$project$Ui$Table$textRight
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Admin__Documents__Id_String(
							{ahP: id}),
						_List_fromArray(
							[
								$author$project$Ui$Link$sm,
								$author$project$Ui$Link$icon($author$project$Ui$Icon$edit)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Edit')
							]))
					]))
			]));
};
var $author$project$Pages$Admin$Documents$Top$viewPanelBody = function (model) {
	var _v0 = function () {
		var _v1 = model.bZ;
		if (_v1.$ === 3) {
			var documents_ = _v1.a;
			return _Utils_Tuple2(false, documents_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var documents = _v0.b;
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mb4]),
			_List_fromArray(
				[
					$elm$html$Html$text('Manage who can see your documents - published documents are available to all users in the app, and each document can be configured to be viewable and/or required during online signup. To learn more, see our '),
					A3(
					$author$project$Ui$Link$externalHref,
					'https://support.hint.com/online-signup/adding-multiple-patient-contracts-or-agreements',
					_List_fromArray(
						[$author$project$Ui$Link$targetBlank]),
					_List_fromArray(
						[
							$elm$html$Html$text('support article.')
						]))
				])),
			A2(
			$author$project$Ui$Grid$row,
			_List_fromArray(
				[$author$project$Ui$Grid$mb2]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$span(12)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Pages$Admin$Documents$Top$SearchInputMsg,
									A2($author$project$Ui$SearchInput$view, _List_Nil, model.up))
								]))
						]))
				])),
			A4(
			$author$project$Ui$Table$view,
			_List_fromArray(
				[
					$author$project$Ui$Table$verticalCentered,
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('No documents found.')
						])),
					$author$project$Ui$Table$loading(loading)
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						A2(
						$elm$core$List$map,
						$author$project$Api$Column$view(
							A2($author$project$Api$Column$Sortable, model.alA, $author$project$Pages$Admin$Documents$Top$SortTable)),
						$author$project$Pages$Admin$Documents$Top$columns),
						_List_fromArray(
						[
							A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
						])
					])),
			A2($elm$core$List$map, $author$project$Pages$Admin$Documents$Top$viewDocument, documents),
			_List_Nil)
		]);
};
var $author$project$Pages$Admin$Documents$Top$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				function () {
				var _v0 = model.cv;
				if (!_v0.$) {
					var document = _v0.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Admin$Documents$Top$HiConfirmClosed(
							$author$project$Api$Provider$Document$All$id(document)),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('delete'),
								$author$project$Components$HiConfirm$noun('document'),
								$author$project$Components$HiConfirm$customMessage(
								$author$project$Pages$Admin$Documents$Top$deleteMessage(document))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_fromArray(
							[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Documents')
									])),
								A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Admin__Documents__New,
								_List_fromArray(
									[
										$author$project$Ui$Link$buttonDefault,
										$author$project$Ui$Link$icon($author$project$Ui$Icon$add)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('New Document')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						$author$project$Pages$Admin$Documents$Top$viewPanelBody(model)),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								function () {
								var _v1 = model.bZ;
								if (_v1.$ === 3) {
									return A2(
										$elm$html$Html$map,
										$author$project$Pages$Admin$Documents$Top$PaginationMsg,
										A2($author$project$Api$Pagination$view, _List_Nil, model.ajJ));
								} else {
									return $author$project$Utils$Html$empty;
								}
							}()
							]))
					]))
			]),
		ac9: 'Admin | Documents'
	};
};
var $author$project$Pages$Admin$Documents$Top$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Documents$Top$init, aiq: $author$project$Pages$Admin$Documents$Top$load, k8: $author$project$Pages$Admin$Documents$Top$save, alO: $author$project$Pages$Admin$Documents$Top$subscriptions, adT: $author$project$Pages$Admin$Documents$Top$update, amo: $author$project$Pages$Admin$Documents$Top$view});
var $author$project$Pages$Admin$Elation$Link$init = F4(
	function (_v0, _v1, shared, _v2) {
		return _Utils_Tuple2(
			{Gv: shared.Gv},
			A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Marketplace__Elation__Manage__Settings));
	});
var $author$project$Pages$Admin$Elation$Link$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Elation$Link$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Elation$Link$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$Elation$Link$update = F2(
	function (msg, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Admin$Elation$Link$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Redirecting...'};
};
var $author$project$Pages$Admin$Elation$Link$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Elation$Link$init, aiq: $author$project$Pages$Admin$Elation$Link$load, k8: $author$project$Pages$Admin$Elation$Link$save, alO: $author$project$Pages$Admin$Elation$Link$subscriptions, adT: $author$project$Pages$Admin$Elation$Link$update, amo: $author$project$Pages$Admin$Elation$Link$view});
var $author$project$Pages$Admin$Elation$Overview$init = F4(
	function (_v0, _v1, shared, _v2) {
		return _Utils_Tuple2(
			{Gv: shared.Gv},
			A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Marketplace__Elation__Manage__Settings));
	});
var $author$project$Pages$Admin$Elation$Overview$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Elation$Overview$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Elation$Overview$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$Elation$Overview$update = F2(
	function (msg, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Admin$Elation$Overview$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Redirecting...'};
};
var $author$project$Pages$Admin$Elation$Overview$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Elation$Overview$init, aiq: $author$project$Pages$Admin$Elation$Overview$load, k8: $author$project$Pages$Admin$Elation$Overview$save, alO: $author$project$Pages$Admin$Elation$Overview$subscriptions, adT: $author$project$Pages$Admin$Elation$Overview$update, amo: $author$project$Pages$Admin$Elation$Overview$view});
var $author$project$Pages$Admin$Elation$Providers$init = F4(
	function (_v0, _v1, shared, _v2) {
		return _Utils_Tuple2(
			{Gv: shared.Gv},
			A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Marketplace__Elation__Manage__Settings));
	});
var $author$project$Pages$Admin$Elation$Providers$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Elation$Providers$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Elation$Providers$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$Elation$Providers$update = F2(
	function (msg, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Admin$Elation$Providers$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Redirecting...'};
};
var $author$project$Pages$Admin$Elation$Providers$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Elation$Providers$init, aiq: $author$project$Pages$Admin$Elation$Providers$load, k8: $author$project$Pages$Admin$Elation$Providers$save, alO: $author$project$Pages$Admin$Elation$Providers$subscriptions, adT: $author$project$Pages$Admin$Elation$Providers$update, amo: $author$project$Pages$Admin$Elation$Providers$view});
var $author$project$Pages$Admin$Elation$Top$init = F4(
	function (_v0, _v1, shared, _v2) {
		return _Utils_Tuple2(
			{Gv: shared.Gv},
			A2(
				$author$project$Utils$Route$navigate,
				$elm$core$Dict$empty,
				$author$project$Spa$Generated$Route$Marketplace__Slug_String(
					{abG: 'elation'})));
	});
var $author$project$Pages$Admin$Elation$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Elation$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Elation$Top$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$Elation$Top$update = F2(
	function (msg, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Admin$Elation$Top$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Redirecting...'};
};
var $author$project$Pages$Admin$Elation$Top$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Elation$Top$init, aiq: $author$project$Pages$Admin$Elation$Top$load, k8: $author$project$Pages$Admin$Elation$Top$save, alO: $author$project$Pages$Admin$Elation$Top$subscriptions, adT: $author$project$Pages$Admin$Elation$Top$update, amo: $author$project$Pages$Admin$Elation$Top$view});
var $author$project$Pages$Admin$ElationLegacy$GotElation = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Elation$One$Elation = $elm$core$Basics$identity;
var $author$project$Api$Provider$Elation$One$Record = F3(
	function (status, userName, isSyncing) {
		return {Vg: isSyncing, alH: status, amm: userName};
	});
var $author$project$Api$Provider$Elation$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'is_syncing',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'username',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'status',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Elation$One$Record))));
var $author$project$Api$Provider$Elation$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Elation$One$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Elation$elationPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['elation']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Elation$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Elation$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Elation$elationPath));
	});
var $author$project$Pages$Admin$ElationLegacy$init = F4(
	function (_v0, _v1, shared, _v2) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, ge: false, gl: $author$project$Api$Data$Loading, SD: $elm$core$Maybe$Nothing, sF: shared.sF, qr: $author$project$Api$Data$NotAsked},
			A2($author$project$Api$Provider$Elation$retrieve, shared.Gv, $author$project$Pages$Admin$ElationLegacy$GotElation));
	});
var $author$project$Pages$Admin$ElationLegacy$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$ElationLegacy$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$ElationLegacy$HiConfirmClosed = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Admin$ElationLegacy$subscriptions = function (_v0) {
	var disabling = _v0.ge;
	return disabling ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Admin$ElationLegacy$HiConfirmClosed) : $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$ElationLegacy$Disabled = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Admin$ElationLegacy$Synced = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Admin$ElationLegacy$Created = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Elation$create = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'elation',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'username',
								$elm$json$Json$Encode$string(fields.amm)),
								_Utils_Tuple2(
								'password',
								$elm$json$Json$Encode$string(fields.ajR))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Elation$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Elation$elationPath)));
	});
var $author$project$Pages$Admin$ElationLegacy$createElation = F2(
	function (apiClient, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A3($author$project$Api$Provider$Elation$create, apiClient, fields, $author$project$Pages$Admin$ElationLegacy$Created);
	});
var $author$project$Api$Provider$Elation$delete = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Provider$Elation$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Elation$elationPath));
	});
var $author$project$Api$Provider$Elation$One$userName = function (_v0) {
	var record = _v0;
	return record.amm;
};
var $author$project$Pages$Admin$ElationLegacy$formFieldsInit = function (elation) {
	return {
		ajR: '',
		amm: A2(
			$elm$core$Maybe$withDefault,
			'',
			$author$project$Api$Provider$Elation$One$userName(elation))
	};
};
var $author$project$Pages$Admin$ElationLegacy$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var string = field.a;
			return _Utils_update(
				fields,
				{amm: string});
		} else {
			var string = field.a;
			return _Utils_update(
				fields,
				{ajR: string});
		}
	});
var $author$project$Pages$Admin$ElationLegacy$PasswordValidation = 1;
var $author$project$Pages$Admin$ElationLegacy$UserNameValidation = 0;
var $author$project$Pages$Admin$ElationLegacy$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.amm;
			},
			_Utils_Tuple2(0, 'Please enter an api key')),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.ajR;
			},
			_Utils_Tuple2(1, 'Please enter a password'))
		]));
var $author$project$Pages$Admin$ElationLegacy$Poll = {$: 1};
var $author$project$Api$Provider$Elation$One$isSyncing = function (_v0) {
	var record = _v0;
	return record.Vg;
};
var $author$project$Pages$Admin$ElationLegacy$poll = function (elation) {
	return $author$project$Api$Provider$Elation$One$isSyncing(elation) ? A2(
		$elm$core$Task$perform,
		function (_v0) {
			return $author$project$Pages$Admin$ElationLegacy$Poll;
		},
		$elm$core$Process$sleep(2000)) : $elm$core$Platform$Cmd$none;
};
var $author$project$Api$Provider$Elation$One$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Api$Provider$Elation$sync = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Elation$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['sync']),
					$author$project$Api$Provider$Elation$elationPath)));
	});
var $author$project$Pages$Admin$ElationLegacy$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var elation = response.a;
					var form = ($author$project$Api$Provider$Elation$One$status(elation) === 'disabled') ? $elm$core$Maybe$Just(
						_Utils_Tuple2(
							$author$project$Utils$Form$init(
								$author$project$Pages$Admin$ElationLegacy$formFieldsInit(elation)),
							$author$project$Api$Data$NotAsked)) : $elm$core$Maybe$Nothing;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{gl: response, SD: form}),
						$author$project$Pages$Admin$ElationLegacy$poll(elation),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{gl: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				return _Utils_Tuple3(
					model,
					A2($author$project$Api$Provider$Elation$retrieve, model.Gv, $author$project$Pages$Admin$ElationLegacy$GotElation),
					_List_Nil);
			case 2:
				var field = msg.a;
				var _v2 = model.SD;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var form = _v3.a;
					var saveRequest = _v3.b;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$ElationLegacy$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								SD: $elm$core$Maybe$Just(
									_Utils_Tuple2(newForm, saveRequest))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var _v4 = model.SD;
				if (!_v4.$) {
					var _v5 = _v4.a;
					var form = _v5.a;
					var saveRequest = _v5.b;
					var _v6 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$ElationLegacy$formFieldsValidator, form);
					if (!_v6.$) {
						var _v7 = _v6.a;
						var newForm = _v7.a;
						var validFormFields = _v7.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									SD: $elm$core$Maybe$Just(
										_Utils_Tuple2(newForm, $author$project$Api$Data$Loading))
								}),
							A2($author$project$Pages$Admin$ElationLegacy$createElation, model.Gv, validFormFields),
							_List_Nil);
					} else {
						var newForm = _v6.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									SD: $elm$core$Maybe$Just(
										_Utils_Tuple2(newForm, saveRequest))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{gl: response, SD: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your elation credentials have been saved.')
							]));
				} else {
					var _v9 = model.SD;
					if (!_v9.$) {
						var _v10 = _v9.a;
						var form = _v10.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									SD: $elm$core$Maybe$Just(
										_Utils_Tuple2(form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					} else {
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				}
			case 5:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qr: $author$project$Api$Data$Loading}),
					A2($author$project$Api$Provider$Elation$sync, model.Gv, $author$project$Pages$Admin$ElationLegacy$Synced),
					_List_Nil);
			case 6:
				var response = msg.a;
				if (response.$ === 3) {
					var elation = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{qr: $author$project$Api$Data$NotAsked}),
						$author$project$Pages$Admin$ElationLegacy$poll(elation),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{qr: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 7:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ge: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 8:
				var confirmed = msg.a;
				return confirmed ? _Utils_Tuple3(
					model,
					A2($author$project$Api$Provider$Elation$delete, model.Gv, $author$project$Pages$Admin$ElationLegacy$Disabled),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{ge: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var elation = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ge: false,
								gl: response,
								SD: $elm$core$Maybe$Just(
									_Utils_Tuple2(
										$author$project$Utils$Form$init(
											$author$project$Pages$Admin$ElationLegacy$formFieldsInit(elation)),
										$author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your elation integration has been disabled.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ge: false}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Ui$Image$ElationEMRLogo = 1;
var $author$project$Pages$Admin$ElationLegacy$Save = {$: 3};
var $author$project$Ui$Panel$None = {$: 6};
var $author$project$Ui$Panel$none = $author$project$Ui$Panel$None;
var $author$project$Pages$Admin$ElationLegacy$FormUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$ElationLegacy$Password = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$ElationLegacy$UserName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$PasswordInput$Errors = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Form$PasswordInput$errors = $author$project$Ui$Form$PasswordInput$Errors;
var $author$project$Ui$Form$PasswordInput$Invalid = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Form$PasswordInput$invalid = $author$project$Ui$Form$PasswordInput$Invalid;
var $author$project$Ui$Form$PasswordInput$OnInput = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$PasswordInput$onInput = $author$project$Ui$Form$PasswordInput$OnInput;
var $author$project$Ui$Form$PasswordInput$Value = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$PasswordInput$value = $author$project$Ui$Form$PasswordInput$Value;
var $author$project$Ui$Form$PasswordInput$defaultOptions = {agX: _List_Nil, aN: _List_Nil, sM: false, aj3: 'Password', EN: $elm$core$Maybe$Nothing, aee: $elm$core$Maybe$Nothing, Gb: false};
var $author$project$Ui$Form$PasswordInput$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var handler = option.a;
						return _Utils_update(
							record,
							{
								aN: A2(
									$elm$core$List$cons,
									$author$project$Ui$Form$Input$onInput(handler),
									record.aN)
							});
					case 1:
						var string = option.a;
						return _Utils_update(
							record,
							{
								aN: A2(
									$elm$core$List$cons,
									$author$project$Ui$Form$Input$value(string),
									record.aN),
								aee: $elm$core$Maybe$Just(string)
							});
					case 2:
						var bool = option.a;
						return _Utils_update(
							record,
							{sM: bool});
					case 3:
						var list = option.a;
						return _Utils_update(
							record,
							{agX: list});
					case 4:
						var maybeStrength = option.a;
						return _Utils_update(
							record,
							{EN: maybeStrength});
					case 5:
						var string = option.a;
						return _Utils_update(
							record,
							{aj3: string});
					default:
						var bool = option.a;
						return _Utils_update(
							record,
							{Gb: bool});
				}
			}),
		$author$project$Ui$Form$PasswordInput$defaultOptions,
		options);
};
var $author$project$Ui$Form$Input$Password = {$: 5};
var $author$project$Ui$Form$Input$password = $author$project$Ui$Form$Input$Type($author$project$Ui$Form$Input$Password);
var $author$project$Utils$PasswordStrength$suggestions = function (_v0) {
	var record = _v0;
	return record.alP;
};
var $author$project$Ui$ProgressBar$Danger = {$: 3};
var $author$project$Ui$ProgressBar$danger = $author$project$Ui$ProgressBar$Danger;
var $author$project$Utils$PasswordStrength$strength = function (_v0) {
	var record = _v0;
	return record.alL;
};
var $author$project$Ui$ProgressBar$Success = {$: 2};
var $author$project$Ui$ProgressBar$success = $author$project$Ui$ProgressBar$Success;
var $author$project$Ui$ProgressBar$Bar = $elm$core$Basics$identity;
var $author$project$Ui$ProgressBar$bar = function (options) {
	return options;
};
var $author$project$Ui$ProgressBar$defaultOptions = {rF: _List_Nil, aih: $elm$core$Maybe$Nothing, EE: false, ams: 0};
var $author$project$Ui$ProgressBar$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						return _Utils_update(
							record,
							{
								rF: A2($elm$core$List$cons, 'progress__bar--striped', record.rF)
							});
					case 1:
						return _Utils_update(
							record,
							{
								rF: A2($elm$core$List$cons, 'progress__bar--animated', record.rF)
							});
					case 2:
						return _Utils_update(
							record,
							{
								rF: A2($elm$core$List$cons, 'progress__bar--success', record.rF)
							});
					case 3:
						return _Utils_update(
							record,
							{
								rF: A2($elm$core$List$cons, 'progress__bar--danger', record.rF)
							});
					case 4:
						return _Utils_update(
							record,
							{
								rF: A2($elm$core$List$cons, 'progress__bar--warning', record.rF)
							});
					case 5:
						return _Utils_update(
							record,
							{EE: true});
					case 6:
						var _float = option.a;
						return _Utils_update(
							record,
							{ams: _float});
					case 7:
						var string = option.a;
						return _Utils_update(
							record,
							{
								aih: $elm$core$Maybe$Just(string)
							});
					default:
						return record;
				}
			}),
		$author$project$Ui$ProgressBar$defaultOptions,
		options);
};
var $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty('title');
var $author$project$Ui$ProgressBar$viewBar = function (_v0) {
	var options = _v0;
	var optionsRecord = $author$project$Ui$ProgressBar$optionsToRecord(options);
	var width_ = optionsRecord.ams;
	var labelAttr = function () {
		var _v1 = optionsRecord.aih;
		if (!_v1.$) {
			var l = _v1.a;
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$title(l),
					A2($elm$html$Html$Attributes$attribute, 'aria-label', l)
				]);
		} else {
			return _List_Nil;
		}
	}();
	return A2(
		$elm$html$Html$div,
		A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$class('progress__bar'),
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class(
					A2($elm$core$String$join, ' ', optionsRecord.rF)),
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$Attributes$style,
						'width',
						$elm$core$String$fromFloat(width_) + '%'),
					A2(
						$elm$core$List$cons,
						A2($elm$html$Html$Attributes$attribute, 'role', 'progressbar'),
						A2(
							$elm$core$List$cons,
							A2(
								$elm$html$Html$Attributes$attribute,
								'aria-valuenow',
								$elm$core$String$fromFloat(width_)),
							A2(
								$elm$core$List$cons,
								A2($elm$html$Html$Attributes$attribute, 'aria-valuemin', '0'),
								A2(
									$elm$core$List$cons,
									A2($elm$html$Html$Attributes$attribute, 'aria-valuemax', '100'),
									labelAttr))))))),
		optionsRecord.EE ? _List_fromArray(
			[
				$elm$html$Html$text(
				A2($myrho$elm_round$Round$round, 2, width_) + '%')
			]) : _List_Nil);
};
var $author$project$Ui$ProgressBar$stacked = function (bars) {
	var hasSlim = A2(
		$elm$core$List$any,
		function (_v0) {
			var options = _v0;
			return A2(
				$elm$core$List$any,
				function (opt) {
					if (opt.$ === 8) {
						return true;
					} else {
						return false;
					}
				},
				options);
		},
		bars);
	var classes = hasSlim ? _List_fromArray(
		[
			$elm$html$Html$Attributes$class('progress'),
			$elm$html$Html$Attributes$class('progress--slim')
		]) : _List_fromArray(
		[
			$elm$html$Html$Attributes$class('progress')
		]);
	return A2(
		$elm$html$Html$div,
		classes,
		A2($elm$core$List$map, $author$project$Ui$ProgressBar$viewBar, bars));
};
var $author$project$Ui$ProgressBar$view = function (options) {
	return $author$project$Ui$ProgressBar$stacked(
		_List_fromArray(
			[
				$author$project$Ui$ProgressBar$bar(options)
			]));
};
var $author$project$Ui$ProgressBar$Warning = {$: 4};
var $author$project$Ui$ProgressBar$warning = $author$project$Ui$ProgressBar$Warning;
var $author$project$Ui$ProgressBar$Width = function (a) {
	return {$: 6, a: a};
};
var $author$project$Ui$ProgressBar$width = $author$project$Ui$ProgressBar$Width;
var $author$project$Ui$Form$PasswordInput$viewProgressBar = function (passwordStrength) {
	var _v0 = function () {
		var _v1 = $author$project$Utils$PasswordStrength$strength(passwordStrength);
		switch (_v1) {
			case 1:
				return _Utils_Tuple2(1, $author$project$Ui$ProgressBar$danger);
			case 2:
				return _Utils_Tuple2(2, $author$project$Ui$ProgressBar$danger);
			case 3:
				return _Utils_Tuple2(3, $author$project$Ui$ProgressBar$warning);
			case 4:
				return _Utils_Tuple2(4, $author$project$Ui$ProgressBar$success);
			default:
				return _Utils_Tuple2(0, $author$project$Ui$ProgressBar$danger);
		}
	}();
	var width = _v0.a;
	var style = _v0.b;
	return $author$project$Ui$ProgressBar$view(
		_List_fromArray(
			[
				$author$project$Ui$ProgressBar$width((25 * width) + 5),
				style
			]));
};
var $author$project$Ui$Form$PasswordInput$view = function (options) {
	var optionsRecord = $author$project$Ui$Form$PasswordInput$optionsToRecord(options);
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		$elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						A2(
							$elm$core$List$cons,
							$author$project$Ui$Form$Input$phi(true),
							A2(
								$elm$core$List$cons,
								$author$project$Ui$Form$Input$withFeedback(optionsRecord.Gb),
								A2(
									$elm$core$List$cons,
									$author$project$Ui$Form$Input$password,
									A2(
										$elm$core$List$cons,
										$author$project$Ui$Form$Input$invalid(optionsRecord.sM),
										A2(
											$elm$core$List$cons,
											$author$project$Ui$Form$Input$errors(optionsRecord.agX),
											A2(
												$elm$core$List$cons,
												$author$project$Ui$Form$Input$placeholder(optionsRecord.aj3),
												optionsRecord.aN)))))))
					]),
					function () {
					var _v0 = optionsRecord.EN;
					if (_v0.$ === 1) {
						return _List_Nil;
					} else {
						var passwordStrength = _v0.a;
						return _List_fromArray(
							[
								$author$project$Ui$Form$PasswordInput$viewProgressBar(passwordStrength),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Link$externalHref,
										'https://support.hint.com/user-account-setup/password-creation-and-reset',
										_List_fromArray(
											[$author$project$Ui$Link$targetBlank]),
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Tooltip$view,
												_List_fromArray(
													[
														$author$project$Ui$Tooltip$placement(0)
													]),
												'Click to Learn More',
												_List_fromArray(
													[
														$author$project$Ui$Icon$help(_List_Nil)
													]))
											])),
										$elm$core$List$isEmpty(
										$author$project$Utils$PasswordStrength$suggestions(passwordStrength)) ? $author$project$Utils$Html$empty : A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												'Tip: ' + A2(
													$elm$core$String$join,
													' ',
													$author$project$Utils$PasswordStrength$suggestions(passwordStrength)))
											]))
									]))
							]);
					}
				}()
				])));
};
var $author$project$Pages$Admin$ElationLegacy$viewDisabledBody = function (form) {
	var fields = $author$project$Utils$Form$fields(form);
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Status'),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Ui$Badge$fromString, _List_Nil, 'inactive')
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Elation API Key'),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8),
					$author$project$Ui$Form$Group$required(true)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$value(fields.amm),
							$author$project$Ui$Form$Input$onInput(
							A2($elm$core$Basics$composeL, $author$project$Pages$Admin$ElationLegacy$FormUpdated, $author$project$Pages$Admin$ElationLegacy$UserName)),
							$author$project$Ui$Form$Input$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
							$author$project$Ui$Form$Input$errors(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Password'),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8),
					$author$project$Ui$Form$Group$required(true)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$PasswordInput$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$PasswordInput$value(fields.ajR),
							$author$project$Ui$Form$PasswordInput$onInput(
							A2($elm$core$Basics$composeL, $author$project$Pages$Admin$ElationLegacy$FormUpdated, $author$project$Pages$Admin$ElationLegacy$Password)),
							$author$project$Ui$Form$PasswordInput$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
							$author$project$Ui$Form$PasswordInput$errors(
							A2($author$project$Utils$Form$validationErrors, 1, form))
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label(''),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Used by physicians to manage every aspects of patient care, '),
									A3(
									$author$project$Ui$Link$externalHref,
									'https://www.elationemr.com',
									_List_fromArray(
										[$author$project$Ui$Link$targetBlank]),
									_List_fromArray(
										[
											$elm$html$Html$text('Elation')
										])),
									$elm$html$Html$text(' is an intuitive, easy to use solution that helps you quickly find, digest, and act upon relevant clinical information to care for your patients.')
								])),
							A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Our integration with Elation will automatically create and synchronize patient demographic, membership, and insurance information created here with Elation.'),
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('To configure this integration, contact the Elation team and ask for your Elation API Key & Password.')
										]))
								])),
							A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('We provide this integration only as a convenience to you. Elation is solely responsible for its service, content and policies, including those related to privacy and security. Please review Elation\'s Terms of Service, and Privacy Policy to ensure they meet your business and legal requirements.')
								]))
						]))
				]))
		]);
};
var $author$project$Pages$Admin$ElationLegacy$viewDisabledFooter = function (saveRequest) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$textCenter]),
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Edit and enable'},
				_List_fromArray(
					[
						$author$project$Ui$Button$submit,
						$author$project$Ui$Button$primary,
						$author$project$Ui$Button$loading(
						_Utils_eq(saveRequest, $author$project$Api$Data$Loading))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Save & Enable')
					]))
			]));
};
var $author$project$Pages$Admin$ElationLegacy$Disable = {$: 7};
var $author$project$Pages$Admin$ElationLegacy$Sync = {$: 5};
var $author$project$Pages$Admin$ElationLegacy$viewEnabledBody = F2(
	function (model, elation) {
		var status = ($author$project$Api$Provider$Elation$One$status(elation) === 'enabled') ? 'connected' : $author$project$Api$Provider$Elation$One$status(elation);
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Status'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Ui$Badge$fromString, _List_Nil, status)
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$helpBlock]),
						_List_fromArray(
							[
								$elm$html$Html$text('To stop syncing or change your credentials please '),
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Disable integration'},
								_List_fromArray(
									[
										$author$project$Ui$Button$onClick($author$project$Pages$Admin$ElationLegacy$Disable),
										$author$project$Ui$Button$link
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('disable this integration.')
									]))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Elation API Key'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									$author$project$Api$Provider$Elation$One$userName(elation)))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Password'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('************')
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Failures'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Patients__Top,
								_List_fromArray(
									[
										$author$project$Ui$Link$routeParams(
										_List_fromArray(
											[
												A2($elm$url$Url$Builder$string, 'filter', 'with_failed_sync')
											]))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('See failed records here.')
									]))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Push to Elation'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Push out of sync records'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$loading(
								_Utils_eq(model.qr, $author$project$Api$Data$Loading)),
								$author$project$Ui$Button$onClick($author$project$Pages$Admin$ElationLegacy$Sync)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Push out of sync records')
							]))
					]))
			]);
	});
var $author$project$Pages$Admin$ElationLegacy$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				model.ge ? A2(
				$author$project$Components$HiConfirm$modal,
				$author$project$Pages$Admin$ElationLegacy$HiConfirmClosed,
				_List_fromArray(
					[
						$author$project$Components$HiConfirm$verb('disable'),
						$author$project$Components$HiConfirm$noun('elation integration')
					])) : $author$project$Utils$Html$empty,
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$noValidate(true),
						$author$project$Ui$Form$autocomplete(false),
						$author$project$Ui$Form$onSubmit($author$project$Pages$Admin$ElationLegacy$Save)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										A4(
										$author$project$Ui$Image$view,
										model.sF,
										{LD: 'ElationEMR Logo'},
										_List_fromArray(
											[
												$author$project$Ui$Image$width(200)
											]),
										1)
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								function () {
									var _v0 = model.gl;
									if (_v0.$ === 3) {
										var elation = _v0.a;
										var _v1 = model.SD;
										if (!_v1.$) {
											var _v2 = _v1.a;
											var form = _v2.a;
											return $author$project$Pages$Admin$ElationLegacy$viewDisabledBody(form);
										} else {
											return A2($author$project$Pages$Admin$ElationLegacy$viewEnabledBody, model, elation);
										}
									} else {
										return _List_fromArray(
											[
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$textCenter]),
												_List_fromArray(
													[
														$author$project$Ui$Spinner$view(_List_Nil)
													]))
											]);
									}
								}()),
								function () {
								var _v3 = model.gl;
								if (_v3.$ === 3) {
									var _v4 = model.SD;
									if (!_v4.$) {
										var _v5 = _v4.a;
										var saveRequest = _v5.b;
										return A2(
											$author$project$Ui$Panel$footer,
											_List_Nil,
											_List_fromArray(
												[
													$author$project$Pages$Admin$ElationLegacy$viewDisabledFooter(saveRequest)
												]));
									} else {
										return $author$project$Ui$Panel$none;
									}
								} else {
									return $author$project$Ui$Panel$none;
								}
							}()
							]))
					]))
			]),
		ac9: 'Integrations | Elation Health'
	};
};
var $author$project$Pages$Admin$ElationLegacy$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$ElationLegacy$init, aiq: $author$project$Pages$Admin$ElationLegacy$load, k8: $author$project$Pages$Admin$ElationLegacy$save, alO: $author$project$Pages$Admin$ElationLegacy$subscriptions, adT: $author$project$Pages$Admin$ElationLegacy$update, amo: $author$project$Pages$Admin$ElationLegacy$view});
var $author$project$Pages$Admin$Features$BetaFeaturesMsg = $elm$core$Basics$identity;
var $author$project$Components$Hinter$BetaFeatures$Practice = 0;
var $author$project$Components$Hinter$BetaFeatures$GotFeatures = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Hinter$BetaFeatures$Model = $elm$core$Basics$identity;
var $author$project$Components$Hinter$BetaFeatures$basePath = function (owner) {
	return $author$project$Api$Data$providerPath;
};
var $author$project$Api$Common$Feature$Shared$Feature = $elm$core$Basics$identity;
var $author$project$Api$Common$Feature$Shared$Record = F3(
	function (id, name, enabled) {
		return {Ro: enabled, ahP: id, Bq: name};
	});
var $author$project$Api$Common$Feature$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'enabled',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Common$Feature$Shared$Record))));
var $author$project$Api$Common$Feature$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Feature$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$Feature$featuresPath = function (basePath) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['features']),
		basePath);
};
var $author$project$Api$Common$Feature$list = F3(
	function (basePath, apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Common$Feature$Shared$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Common$Feature$featuresPath(basePath)));
	});
var $author$project$Components$Hinter$BetaFeatures$init = F2(
	function (apiClient, owner) {
		return _Utils_Tuple2(
			{
				Sf: $author$project$Api$Data$Loading,
				YD: owner,
				akl: $elm$core$Maybe$Nothing,
				up: $author$project$Ui$SearchInput$init($elm$core$Maybe$Nothing)
			},
			A3(
				$author$project$Api$Common$Feature$list,
				$author$project$Components$Hinter$BetaFeatures$basePath(owner),
				apiClient,
				$author$project$Components$Hinter$BetaFeatures$GotFeatures));
	});
var $author$project$Pages$Admin$Features$init = F4(
	function (_v0, _v1, _v2, _v3) {
		var apiClient = _v2.Gv;
		var _v4 = A2($author$project$Components$Hinter$BetaFeatures$init, apiClient, 0);
		var betaFeatures = _v4.a;
		var betaFeaturesCmd = _v4.b;
		return _Utils_Tuple2(
			{Gv: apiClient, ms: betaFeatures},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, betaFeaturesCmd));
	});
var $author$project$Pages$Admin$Features$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Features$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Hinter$BetaFeatures$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$Features$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Hinter$BetaFeatures$subscriptions(model.ms));
};
var $author$project$Components$Hinter$BetaFeatures$GotEnableResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Hinter$BetaFeatures$SearchInputMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Common$Feature$enable = F5(
	function (basePath, apiClient, featureId, enabledStatus, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'feature',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'id',
								$elm$json$Json$Encode$string(featureId)),
								_Utils_Tuple2(
								'enabled',
								$elm$json$Json$Encode$bool(enabledStatus))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Common$Feature$Shared$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							[featureId]),
						$author$project$Api$Common$Feature$featuresPath(basePath)))));
	});
var $author$project$Api$Common$Feature$Shared$enabled = function (_v0) {
	var record = _v0;
	return record.Ro;
};
var $elm$browser$Browser$Navigation$reload = _Browser_reload(false);
var $author$project$Api$Common$Feature$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Components$Hinter$BetaFeatures$replaceUpdated = F2(
	function (newFeature, feature) {
		return _Utils_eq(
			$author$project$Api$Common$Feature$Shared$id(feature),
			$author$project$Api$Common$Feature$Shared$id(newFeature)) ? newFeature : feature;
	});
var $author$project$Components$Hinter$BetaFeatures$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var id = msg.a;
				var enabled = msg.b;
				return _Utils_Tuple3(
					model,
					A5(
						$author$project$Api$Common$Feature$enable,
						$author$project$Components$Hinter$BetaFeatures$basePath(model.YD),
						apiClient,
						id,
						enabled,
						$author$project$Components$Hinter$BetaFeatures$GotEnableResponse),
					_List_Nil);
			case 1:
				var response = msg.a;
				if (response.$ === 3) {
					var feature = response.a;
					var newFeatures = A2(
						$author$project$Api$Data$map,
						$elm$core$List$map(
							$author$project$Components$Hinter$BetaFeatures$replaceUpdated(feature)),
						model.Sf);
					var newModel = _Utils_update(
						model,
						{Sf: newFeatures});
					var message = $author$project$Api$Common$Feature$Shared$enabled(feature) ? 'Feature enabled!' : 'Feature disabled!';
					return _Utils_Tuple3(
						newModel,
						$elm$browser$Browser$Navigation$reload,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, message),
								function () {
								var _v3 = model.YD;
								return $author$project$OutMsg$RefreshPractice;
							}()
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 2:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Sf: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			default:
				var subMsg = msg.a;
				var _v4 = A2($author$project$Ui$SearchInput$update, subMsg, model.up);
				var searchInput = _v4.a;
				var cmd = _v4.b;
				var event = _v4.c;
				var q = function () {
					if (event.$ === 1) {
						var query = event.a;
						return query;
					} else {
						return model.akl;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{akl: q, up: searchInput}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Hinter$BetaFeatures$SearchInputMsg, cmd),
					_List_Nil);
		}
	});
var $author$project$Pages$Admin$Features$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Hinter$BetaFeatures$update, model.Gv, subMsg, model.ms);
		var betaFeatures = _v1.a;
		var cmd = _v1.b;
		var outMsgs = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{ms: betaFeatures}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd),
			outMsgs);
	});
var $author$project$Ui$SearchInput$Immediate = {$: 5};
var $author$project$Ui$SearchInput$immediate = $author$project$Ui$SearchInput$Immediate;
var $author$project$Api$Common$Feature$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Components$Hinter$BetaFeatures$matches = F2(
	function (query, feature) {
		var needle = $elm$core$String$toLower(query);
		var haystack = function (field) {
			return A2(
				$elm$core$String$contains,
				needle,
				$elm$core$String$toLower(field));
		};
		return haystack(
			$author$project$Api$Common$Feature$Shared$name(feature)) || haystack(
			$author$project$Api$Common$Feature$Shared$id(feature));
	});
var $author$project$Ui$SearchInput$Placeholder = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$SearchInput$placeholder = $author$project$Ui$SearchInput$Placeholder;
var $author$project$Components$Hinter$BetaFeatures$ChangeFeature = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Hinter$BetaFeatures$viewFeature = function (feature) {
	return A2(
		$author$project$Ui$Table$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Common$Feature$Shared$name(feature))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Button$group(
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$view(
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$on(
										$author$project$Api$Common$Feature$Shared$enabled(feature)),
										$author$project$Ui$ToggleSwitch$onChange(
										$author$project$Components$Hinter$BetaFeatures$ChangeFeature(
											$author$project$Api$Common$Feature$Shared$id(feature)))
									]))
							]))
					]))
			]));
};
var $author$project$Components$Hinter$BetaFeatures$view = function (_v0) {
	var model = _v0;
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_fromArray(
					[$author$project$Ui$Element$flex, $author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
				_List_fromArray(
					[
						$author$project$Ui$Panel$title(
						_List_fromArray(
							[
								$elm$html$Html$text('Beta Features')
							])),
						A2(
						$elm$html$Html$map,
						$author$project$Components$Hinter$BetaFeatures$SearchInputMsg,
						A2(
							$author$project$Ui$SearchInput$view,
							_List_fromArray(
								[
									$author$project$Ui$SearchInput$placeholder('Search features…'),
									$author$project$Ui$SearchInput$immediate
								]),
							model.up))
					])),
				A4(
				$author$project$Ui$Panel$table,
				_List_fromArray(
					[
						$author$project$Ui$Table$loading(
						!$author$project$Api$Data$isSuccess(model.Sf))
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Name')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Enabled')
							]))
					]),
				function () {
					var _v1 = model.Sf;
					if (_v1.$ === 3) {
						var features = _v1.a;
						return A2(
							$elm$core$List$map,
							$author$project$Components$Hinter$BetaFeatures$viewFeature,
							function () {
								var _v2 = model.akl;
								if (!_v2.$) {
									var q = _v2.a;
									return $elm$core$List$filter(
										$author$project$Components$Hinter$BetaFeatures$matches(q));
								} else {
									return $elm$core$Basics$identity;
								}
							}()(features));
					} else {
						return _List_Nil;
					}
				}(),
				_List_Nil)
			]));
};
var $author$project$Pages$Admin$Features$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Hinter$BetaFeatures$view(model.ms))
			]),
		ac9: 'Admin | Beta Features'
	};
};
var $author$project$Pages$Admin$Features$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Features$init, aiq: $author$project$Pages$Admin$Features$load, k8: $author$project$Pages$Admin$Features$save, alO: $author$project$Pages$Admin$Features$subscriptions, adT: $author$project$Pages$Admin$Features$update, amo: $author$project$Pages$Admin$Features$view});
var $author$project$Pages$Admin$HipaaAuthorizations$None = {$: 0};
var $author$project$Pages$Admin$HipaaAuthorizations$GotPatients = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Patient$WithoutHipaaAuthorization = {$: 5};
var $author$project$Api$Provider$Patient$All$Patient = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Patient$Shared$Patient = $elm$core$Basics$identity;
var $author$project$Api$Provider$Patient$Shared$Record = function (id) {
	return function (age) {
		return function (archived) {
			return function (autopay) {
				return function (chosenFirstName) {
					return function (chosenLastName) {
						return function (chosenMiddleName) {
							return function (chosenTitle) {
								return function (chosenSuffix) {
									return function (dob) {
										return function (email) {
											return function (firstName) {
												return function (gender) {
													return function (genderIdentity) {
														return function (genderOther) {
															return function (hipaaAuthorizationAccepted) {
																return function (hipaaAuthorizationAcceptedAt) {
																	return function (joinedPracticeDate) {
																		return function (lastName) {
																			return function (leadSourceOther) {
																				return function (membershipStatus) {
																					return function (middleName) {
																						return function (name) {
																							return function (phones) {
																								return function (pronoun) {
																									return function (sex) {
																										return function (syncToEmr) {
																											return function (usesTobacco) {
																												return function (engagementStatus) {
																													return {Lj: age, L_: archived, Mm: autopay, ND: chosenFirstName, NE: chosenLastName, NF: chosenMiddleName, NG: chosenSuffix, NH: chosenTitle, agC: dob, Rj: email, Ry: engagementStatus, Sv: firstName, SR: gender, SS: genderIdentity, ST: genderOther, TB: hipaaAuthorizationAccepted, TC: hipaaAuthorizationAcceptedAt, ahP: id, Vw: joinedPracticeDate, VH: lastName, VT: leadSourceOther, WX: membershipStatus, W7: middleName, Bq: name, Zy: phones, _B: pronoun, aa8: sex, acM: syncToEmr, ad9: usesTobacco};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Patient$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'engagement_status',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'uses_tobacco',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'sync_to_emr',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'sex',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'pronoun',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$author$project$Api$Expandable$expandable,
						'phones',
						$elm$json$Json$Decode$list($author$project$Api$Common$Phone$Shared$decoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'name',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'middle_name',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'membership_status',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'lead_source_other',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'last_name',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'joined_practice_date',
												$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'hipaa_authorization_accepted_at',
													$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'hipaa_authorization_accepted',
														$elm$json$Json$Decode$bool,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'gender_other',
															$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'gender_identity',
																$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'gender',
																	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'first_name',
																		$elm$json$Json$Decode$string,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'email',
																			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'dob',
																				$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'chosen_suffix',
																					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'chosen_title',
																						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'chosen_middle_name',
																							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'chosen_last_name',
																								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'chosen_first_name',
																									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'autopay',
																										$elm$json$Json$Decode$bool,
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'archived',
																											$elm$json$Json$Decode$bool,
																											A3(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																												'age',
																												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																												A3(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																													'id',
																													$elm$json$Json$Decode$string,
																													$elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$Shared$Record))))))))))))))))))))))))))))));
var $author$project$Api$Provider$Patient$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Patient$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Patient$All$Record = function (sponsorName) {
	return function (flaggedNotesCount) {
		return function (isMaster) {
			return function (isSynced) {
				return function (isAffiliated) {
					return function (affiliateSyncStatus) {
						return function (networkSyncStatus) {
							return function (practitioner) {
								return function (location) {
									return function (membershipPatients) {
										return function (membershipThrough) {
											return {Lh: affiliateSyncStatus, Sz: flaggedNotesCount, UA: isAffiliated, UV: isMaster, Vf: isSynced, ais: location, WR: membershipPatients, WY: membershipThrough, XG: networkSyncStatus, aka: practitioner, ab1: sponsorName};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$MembershipPatient$ForPatientAll$MembershipPatient = $elm$core$Basics$identity;
var $author$project$Api$Provider$MembershipPatient$ForPatientAll$Record = F4(
	function (status, startDate, membership, plan) {
		return {kk: membership, Jb: plan, ab7: startDate, alH: status};
	});
var $author$project$Api$Provider$Membership$Min$Membership = $elm$core$Basics$identity;
var $author$project$Api$Provider$Membership$Min$Record = F3(
	function (id, status, isPrimary) {
		return {ahP: id, aie: isPrimary, alH: status};
	});
var $author$project$Api$Provider$Membership$Min$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'is_primary',
	$elm$json$Json$Decode$bool,
	false,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'status',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$Min$Record))));
var $author$project$Api$Provider$Membership$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Membership$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$MembershipPatient$ForPatientAll$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'plan',
	$author$project$Api$Provider$Plan$Min$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'membership',
		$author$project$Api$Provider$Membership$Min$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'start_date',
			$author$project$Utils$Date$decode,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'status',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$MembershipPatient$ForPatientAll$Record)))));
var $author$project$Api$Provider$MembershipPatient$ForPatientAll$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$MembershipPatient$ForPatientAll$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Patient$Min$Patient = $elm$core$Basics$identity;
var $author$project$Api$Provider$Patient$Min$Record = F5(
	function (id, name, email, dob, age) {
		return {Lj: age, agC: dob, Rj: email, ahP: id, Bq: name};
	});
var $author$project$Api$Provider$Patient$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'age',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'dob',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'email',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$Min$Record))))));
var $author$project$Api$Provider$Patient$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Patient$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Patient$SyncStatus$Failed = 3;
var $author$project$Api$Provider$Patient$SyncStatus$Inactive = 0;
var $author$project$Api$Provider$Patient$SyncStatus$Pending = 1;
var $author$project$Api$Provider$Patient$SyncStatus$Synced = 2;
var $author$project$Api$Provider$Patient$SyncStatus$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'inactive':
				return $elm$json$Json$Decode$succeed(0);
			case 'pending':
				return $elm$json$Json$Decode$succeed(1);
			case 'synced':
				return $elm$json$Json$Decode$succeed(2);
			case 'failed':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('Unexpected sync status ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$Practitioner$Min$Practitioner = $elm$core$Basics$identity;
var $author$project$Api$Provider$Practitioner$Min$Record = F2(
	function (id, name) {
		return {ahP: id, Bq: name};
	});
var $author$project$Api$Provider$Practitioner$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Practitioner$Min$Record)));
var $author$project$Api$Provider$Practitioner$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Practitioner$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Patient$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'membership_through',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Min$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'membership_patients',
		$elm$json$Json$Decode$list($author$project$Api$Provider$MembershipPatient$ForPatientAll$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'location',
			$elm$json$Json$Decode$nullable($author$project$Api$Provider$Location$Min$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'practitioner',
				$elm$json$Json$Decode$nullable($author$project$Api$Provider$Practitioner$Min$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'network_sync_status',
					$elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$SyncStatus$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'affiliate_sync_status',
						$elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$SyncStatus$decoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'is_affiliated',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'is_synced',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'is_master',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'flagged_notes_count',
										$elm$json$Json$Decode$int,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'sponsor_name',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
											$elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$All$Record))))))))))));
var $author$project$Api$Provider$Patient$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Patient$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Patient$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$All$Patient)));
var $author$project$Api$Provider$Patient$filterToString = function (filter) {
	switch (filter.$) {
		case 0:
			switch (filter.a) {
				case 0:
					var _v1 = filter.a;
					return 'current_membership';
				case 2:
					var _v2 = filter.a;
					return 'future_membership';
				case 3:
					var _v3 = filter.a;
					return 'with_unconfirmed_membership';
				case 1:
					var _v4 = filter.a;
					return 'inactive';
				default:
					var _v5 = filter.a;
					return 'archived';
			}
		case 1:
			if (filter.a) {
				return 'with_autopay';
			} else {
				return 'without_autopay';
			}
		case 2:
			return 'active_membership';
		case 3:
			return 'past_due_customer_invoices';
		case 4:
			return 'account_owner_without_payment_info';
		case 5:
			return 'without_hipaa_authorization';
		case 6:
			return 'without_email';
		case 7:
			return 'with_flagged_notes';
		case 8:
			return 'with_failed_integrations';
		case 9:
			return 'with_unsynced_integrations';
		case 10:
			return 'new_activations_since_date';
		case 11:
			return 'new_terminations_since_date';
		case 12:
			return 'with_upcoming_birthday';
		case 13:
			switch (filter.a) {
				case 0:
					var _v6 = filter.a;
					return 'currently_engaged';
				case 1:
					var _v7 = filter.a;
					return 'previously_engaged';
				default:
					var _v8 = filter.a;
					return 'never_engaged';
			}
		case 14:
			return 'with_bounced_emails';
		default:
			return 'with_unsubscribed_emails';
	}
};
var $author$project$Api$Provider$Patient$listDefaults = {Li: $elm$core$Maybe$Nothing, afQ: $elm$core$Maybe$Nothing, HM: _List_Nil, ahP: $elm$core$Maybe$Nothing, ais: $elm$core$Maybe$Nothing, s4: $elm$core$Maybe$Nothing, ajJ: $author$project$Api$Pagination$init, Jb: $elm$core$Maybe$Nothing, aka: $elm$core$Maybe$Nothing, akl: $elm$core$Maybe$Nothing, alA: $author$project$Api$Sort$init};
var $author$project$Api$Provider$Patient$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Patient$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.HM;
				if (!_v0.b) {
					return _List_Nil;
				} else {
					var filters = _v0;
					return _List_fromArray(
						[
							A2(
							$author$project$Api$Param$string,
							'filter',
							A2(
								$elm$core$String$join,
								',',
								A2($elm$core$List$map, $author$project$Api$Provider$Patient$filterToString, filters)))
						]);
				}
			}(),
				function () {
				var _v1 = options.akl;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.ahP;
				if (!_v2.$) {
					var string = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v3 = options.afQ;
				if (!_v3.$) {
					var string = _v3.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'company', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v4 = options.Jb;
				if (!_v4.$) {
					var string = _v4.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'plan', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v5 = options.s4;
				if (!_v5.$) {
					var string = _v5.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'location_group', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v6 = options.ais;
				if (!_v6.$) {
					var string = _v6.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'location', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v7 = options.aka;
				if (!_v7.$) {
					var string = _v7.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'practitioner', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ),
				function () {
				var _v8 = options.Li;
				if (!_v8.$) {
					var string = _v8.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'affiliation', string)
						]);
				} else {
					return _List_Nil;
				}
			}()
			]));
};
var $author$project$Api$Provider$Patient$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Patient$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Patient$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Patient$patientsPath)));
	});
var $author$project$Pages$Admin$HipaaAuthorizations$fetchPatients = function (model) {
	return A3(
		$author$project$Api$Provider$Patient$list,
		model.Gv,
		function (d) {
			return _Utils_update(
				d,
				{
					HM: _List_fromArray(
						[$author$project$Api$Provider$Patient$WithoutHipaaAuthorization]),
					ajJ: model.ajJ
				});
		},
		$author$project$Pages$Admin$HipaaAuthorizations$GotPatients);
};
var $author$project$Pages$Admin$HipaaAuthorizations$init = F4(
	function (_v0, _v1, _v2, _v3) {
		var apiClient = _v2.Gv;
		var model = {bn: $author$project$Pages$Admin$HipaaAuthorizations$None, Gv: apiClient, tn: 0, ajJ: $author$project$Api$Pagination$init, CM: $author$project$Api$Data$Loading, pe: false};
		return _Utils_Tuple2(
			model,
			$author$project$Pages$Admin$HipaaAuthorizations$fetchPatients(model));
	});
var $author$project$Pages$Admin$HipaaAuthorizations$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$HipaaAuthorizations$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$HipaaAuthorizations$AcceptModalClosed = {$: 4};
var $author$project$Pages$Admin$HipaaAuthorizations$subscriptions = function (_v0) {
	var acceptingFor = _v0.bn;
	if (!acceptingFor.$) {
		return $elm$core$Platform$Sub$none;
	} else {
		return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Pages$Admin$HipaaAuthorizations$AcceptModalClosed);
	}
};
var $author$project$Pages$Admin$HipaaAuthorizations$AcceptedForAll = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Admin$HipaaAuthorizations$AcceptedForOne = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Pages$Admin$HipaaAuthorizations$All = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$HipaaAuthorizations$One = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Api$Provider$Patient$One$Patient = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Patient$One$Record = function (requestPayInfoSentAt) {
	return function (requestPendingDocumentsAcceptanceSentAt) {
		return function (location) {
			return function (practitioner) {
				return function (company) {
					return function (companyAccounts) {
						return function (payer) {
							return function (payees) {
								return function (age) {
									return function (membershipThrough) {
										return function (flaggedNotesCount) {
											return function (isMaster) {
												return function (isSynced) {
													return function (isAffiliated) {
														return function (syncedRecordId) {
															return function (network) {
																return function (masterRecordId) {
																	return function (affiliate) {
																		return function (affiliateSyncStatus) {
																			return function (networkSyncStatus) {
																				return function (overdueAmountInCents) {
																					return function (title) {
																						return function (stripeLink) {
																							return function (phones) {
																								return function (usesBillingAddress) {
																									return function (address) {
																										return function (billingAddress) {
																											return function (ssn) {
																												return function (knownPractice) {
																													return function (dpcPatient) {
																														return function (assignedAffiliation) {
																															return function (preferredLanguage) {
																																return function (leadSource) {
																																	return function (accountAccessSentAt) {
																																		return function (lastPortalAccessedAt) {
																																			return function (mergedInto) {
																																				return function (healthInsurance) {
																																					return function (companyRegistrations) {
																																						return function (owedInCents) {
																																							return function (creditInCents) {
																																								return function (creditExpiresSoon) {
																																									return function (defaultSource) {
																																										return function (sourcesCount) {
																																											return function (integrations) {
																																												return function (customForms) {
																																													return function (hasPaymentMethod) {
																																														return function (profilePictureUrl) {
																																															return function (createdAt) {
																																																return function (suffix) {
																																																	return function (emergencyContact) {
																																																		return function (exemptFromCreditCardFees) {
																																																			return function (shouldChargeCreditCardFees) {
																																																				return {KG: accountAccessSentAt, K2: address, Gn: affiliate, Lh: affiliateSyncStatus, Lj: age, L0: assignedAffiliation, MF: billingAddress, afQ: company, Od: companyAccounts, Oj: companyRegistrations, O1: createdAt, O6: creditExpiresSoon, O7: creditInCents, Pn: customForms, Qc: defaultSource, QW: dpcPatient, Rl: emergencyContact, RS: exemptFromCreditCardFees, Sz: flaggedNotesCount, Tf: hasPaymentMethod, Tm: healthInsurance, Ud: integrations, UA: isAffiliated, UV: isMaster, Vf: isSynced, Vy: knownPractice, VJ: lastPortalAccessedAt, VR: leadSource, ais: location, Wz: masterRecordId, WY: membershipThrough, W3: mergedInto, Xz: network, XG: networkSyncStatus, YA: overdueAmountInCents, YC: owedInCents, Y4: payees, I6: payer, Zy: phones, aka: practitioner, Z9: preferredLanguage, _A: profilePictureUrl, $B: requestPayInfoSentAt, $C: requestPendingDocumentsAcceptanceSentAt, abh: shouldChargeCreditCardFees, abQ: sourcesCount, ab5: ssn, acq: stripeLink, acE: suffix, acP: syncedRecordId, ac9: title, ad3: usesBillingAddress};
																																																			};
																																																		};
																																																	};
																																																};
																																															};
																																														};
																																													};
																																												};
																																											};
																																										};
																																									};
																																								};
																																							};
																																						};
																																					};
																																				};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Patient$One$BankAccount_ = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Patient$One$bankAccountDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$BankAccount$One$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$One$BankAccount_));
var $author$project$Api$Provider$Patient$One$Card_ = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Patient$One$cardDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Card$One$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$One$Card_));
var $author$project$Api$Common$EmergencyContact$Shared$EmergencyContact = $elm$core$Basics$identity;
var $author$project$Api$Common$EmergencyContact$Shared$Record = F7(
	function (id, name, firstName, lastName, relationship, email, phone) {
		return {Rj: email, Sv: firstName, ahP: id, VH: lastName, Bq: name, Zw: phone, $q: relationship};
	});
var $author$project$Api$Common$EmergencyContact$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'phone',
	$elm$json$Json$Decode$nullable($author$project$Api$Common$Phone$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'email',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'relationship',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'last_name',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'first_name',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'name',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Api$Common$EmergencyContact$Shared$Record))))))));
var $author$project$Api$Common$EmergencyContact$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$EmergencyContact$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$SocialSecurityNumber$Masked$SocialSecurityNumber = $elm$core$Basics$identity;
var $author$project$Api$Common$SocialSecurityNumber$Masked$MaskedRecord = function (maskedNumber) {
	return {Wy: maskedNumber};
};
var $author$project$Api$Common$SocialSecurityNumber$Masked$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'masked_number',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$json$Json$Decode$succeed($author$project$Api$Common$SocialSecurityNumber$Masked$MaskedRecord));
var $author$project$Api$Common$SocialSecurityNumber$Masked$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$SocialSecurityNumber$Masked$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Company$Min$Company = $elm$core$Basics$identity;
var $author$project$Api$Provider$Company$Min$Record = F3(
	function (id, name, companyType) {
		return {Ok: companyType, ahP: id, Bq: name};
	});
var $author$project$Api$Company$CompanyType$Child = 1;
var $author$project$Api$Company$CompanyType$Network = 0;
var $author$project$Api$Company$CompanyType$Parent = 2;
var $author$project$Api$Company$CompanyType$Standalone = 3;
var $author$project$Api$Company$CompanyType$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'network':
				return $elm$json$Json$Decode$succeed(0);
			case 'child':
				return $elm$json$Json$Decode$succeed(1);
			case 'parent':
				return $elm$json$Json$Decode$succeed(2);
			case 'standalone':
				return $elm$json$Json$Decode$succeed(3);
			default:
				var somethingElse = string;
				return $elm$json$Json$Decode$fail('Unknown Company -> company_type: ' + somethingElse);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$Company$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'company_type',
	$author$project$Api$Company$CompanyType$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Company$Min$Record))));
var $author$project$Api$Provider$Company$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Company$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CompanyAccount$ForPatient$CompanyAccount = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$CompanyAccount$Shared$CompanyAccount = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$CompanyAccount$Min$CompanyAccount = $elm$core$Basics$identity;
var $author$project$Api$Provider$CompanyAccount$Min$Record = function (id) {
	return {ahP: id};
};
var $author$project$Api$Provider$CompanyAccount$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'id',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAccount$Min$Record));
var $author$project$Api$Provider$CompanyAccount$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CompanyAccount$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CompanyAccount$Shared$Record = F5(
	function (isEligible, terminationRequestedAt, eligibilityStartDate, eligibilityEndDate, needsApproval) {
		return {Rf: eligibilityEndDate, Rg: eligibilityStartDate, UO: isEligible, Xx: needsApproval, al0: terminationRequestedAt};
	});
var $author$project$Api$Provider$CompanyAccount$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'needs_approval',
	$elm$json$Json$Decode$bool,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'eligibility_end_date',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'eligibility_start_date',
			$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'termination_requested_at',
				$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'is_eligible',
					$elm$json$Json$Decode$bool,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAccount$Shared$Record))))));
var $author$project$Api$Provider$CompanyAccount$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CompanyAccount$Shared$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$CompanyAccount$Min$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAccount$Shared$CompanyAccount)));
var $author$project$Api$Provider$CompanyAccount$ForPatient$Record = F3(
	function (company, subscriber, companyRegistrations) {
		return {afQ: company, Oj: companyRegistrations, acy: subscriber};
	});
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$CompanyRegistration = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$CompanyRegistration$Shared$CompanyRegistration = $elm$core$Basics$identity;
var $author$project$Api$Provider$CompanyRegistration$Shared$Record = F8(
	function (id, type_, isSubscriber, externalId, terminationRequestedAt, eligibilityStartDate, eligibilityEndDate, membershipEndDate) {
		return {Rf: eligibilityEndDate, Rg: eligibilityStartDate, ag7: externalId, ahP: id, Vd: isSubscriber, WQ: membershipEndDate, al0: terminationRequestedAt, amg: type_};
	});
var $author$project$Api$Provider$CompanyRegistration$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'membership_end_date',
	$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'eligibility_end_date',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'eligibility_start_date',
			$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'termination_requested_at',
				$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'external_id',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'is_subscriber',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'type',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyRegistration$Shared$Record)))))))));
var $author$project$Api$Provider$CompanyRegistration$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CompanyRegistration$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$Record = F2(
	function (patient, isCurrentMember) {
		return {UI: isCurrentMember, YY: patient};
	});
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'is_current_member',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'patient',
		$author$project$Api$Provider$Patient$Min$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$Record)));
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$CompanyRegistration$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$CompanyRegistration)));
var $author$project$Api$Provider$CompanyAccount$ForPatient$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'company_registrations',
	$elm$json$Json$Decode$list($author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'subscriber',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Min$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'company',
			$author$project$Api$Provider$Company$Min$decoder,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAccount$ForPatient$Record))));
var $author$project$Api$Provider$CompanyAccount$ForPatient$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CompanyAccount$ForPatient$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$CompanyAccount$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAccount$ForPatient$CompanyAccount)));
var $author$project$Api$Provider$CompanyRegistration$ForPatientOne$CompanyRegistration = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$CompanyRegistration$ForPatientOne$Record = function (account) {
	return {KF: account};
};
var $author$project$Api$Provider$CompanyRegistration$ForPatientOne$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'account',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$CompanyAccount$Min$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyRegistration$ForPatientOne$Record));
var $author$project$Api$Provider$CompanyRegistration$ForPatientOne$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CompanyRegistration$ForPatientOne$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$CompanyRegistration$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyRegistration$ForPatientOne$CompanyRegistration)));
var $author$project$Api$Provider$FormResponse$One$FormResponse = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$FormResponse$Shared$FormResponse = $elm$core$Basics$identity;
var $author$project$Api$Provider$FormResponse$Shared$Record = function (id) {
	return {ahP: id};
};
var $author$project$Api$Provider$FormResponse$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'id',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$FormResponse$Shared$Record));
var $author$project$Api$Provider$FormResponse$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$FormResponse$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$FormResponse$One$Record = F2(
	function (form, formResponseItems) {
		return {SD: form, SF: formResponseItems};
	});
var $author$project$Api$Provider$FormResponseItem$Shared$FormResponseItem = $elm$core$Basics$identity;
var $author$project$Api$Provider$FormResponseItem$Shared$Record = F3(
	function (id, formItemId, answer) {
		return {LR: answer, HQ: formItemId, ahP: id};
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt = F3(
	function (path, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$at, path, valDecoder),
			decoder);
	});
var $author$project$Api$Provider$FormResponseItem$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'answer',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
		_List_fromArray(
			['form_item', 'id']),
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$FormResponseItem$Shared$Record))));
var $author$project$Api$Provider$FormResponseItem$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$FormResponseItem$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$FormResponse$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'form_response_items',
	$elm$json$Json$Decode$nullable(
		$elm$json$Json$Decode$list($author$project$Api$Provider$FormResponseItem$Shared$decoder)),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'form',
		$author$project$Api$Provider$Form$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$FormResponse$One$Record)));
var $author$project$Api$Provider$FormResponse$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$FormResponse$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$FormResponse$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$FormResponse$One$FormResponse)));
var $author$project$Api$Provider$HealthInsurance$Shared$HealthInsurance = $elm$core$Basics$identity;
var $author$project$Api$Provider$HealthInsurance$Shared$Record = F5(
	function (memberId, groupId, payerName, highDeductible, carrier) {
		return {Np: carrier, S$: groupId, Tt: highDeductible, WL: memberId, Y5: payerName};
	});
var $author$project$Api$Provider$HealthInsuranceCarrier$Shared$HealthInsuranceCarrier = $elm$core$Basics$identity;
var $author$project$Api$Provider$HealthInsuranceCarrier$Shared$Record = F4(
	function (id, collectGroupId, collectHighDeductible, collectMemberId) {
		return {NU: collectGroupId, NV: collectHighDeductible, NY: collectMemberId, ahP: id};
	});
var $author$project$Api$Provider$HealthInsuranceCarrier$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'collect_member_id',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'collect_high_deductible',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'collect_group_id',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$HealthInsuranceCarrier$Shared$Record)))));
var $author$project$Api$Provider$HealthInsuranceCarrier$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$HealthInsuranceCarrier$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$HealthInsurance$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'carrier',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$HealthInsuranceCarrier$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'high_deductible',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'payer_name',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'group_id',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'member_id',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$HealthInsurance$Shared$Record))))));
var $author$project$Api$Provider$HealthInsurance$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$HealthInsurance$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$KnownPractice$Shared$KnownPractice = $elm$core$Basics$identity;
var $author$project$Api$Provider$KnownPractice$Shared$Record = F2(
	function (id, name) {
		return {ahP: id, Bq: name};
	});
var $author$project$Api$Provider$KnownPractice$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$KnownPractice$Shared$Record)));
var $author$project$Api$Provider$KnownPractice$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$KnownPractice$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$LeadSource$Shared$LeadSource = $elm$core$Basics$identity;
var $author$project$Api$Provider$LeadSource$Shared$SharedRecord = F4(
	function (id, name, showOnOnlineSignup, patientsCount) {
		return {ahP: id, Bq: name, Y2: patientsCount, abn: showOnOnlineSignup};
	});
var $author$project$Api$Provider$LeadSource$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'patients_count',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'show_on_online_signup',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$LeadSource$Shared$SharedRecord)))));
var $author$project$Api$Provider$LeadSource$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$LeadSource$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Organization$Shared$Organization = $elm$core$Basics$identity;
var $author$project$Api$Provider$Organization$Min$Organization = $elm$core$Basics$identity;
var $author$project$Api$Provider$Organization$Min$Record = F3(
	function (type_, id, name) {
		return {ahP: id, Bq: name, amg: type_};
	});
var $author$project$Api$Provider$Organization$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'type',
			$author$project$Api$OrganizationType$decoder,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Organization$Min$Record))));
var $author$project$Api$Provider$Organization$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Organization$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Organization$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Organization$Min$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Patient$DpcPatient$Patient = $elm$core$Basics$identity;
var $author$project$Api$Provider$Patient$DpcPatient$Record = function (status) {
	return {alH: status};
};
var $author$project$Api$Provider$Patient$DpcPatient$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'status',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$DpcPatient$Record));
var $author$project$Api$Provider$Patient$DpcPatient$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Patient$DpcPatient$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Practitioner$Shared$Practitioner = $elm$core$Basics$identity;
var $author$project$Api$Provider$Practitioner$Shared$Record = function (id) {
	return function (name) {
		return function (isMaster) {
			return function (isSynced) {
				return function (onlineSignupVisibility) {
					return function (isProvider) {
						return function (acceptsEnrollmentsFromEmployer) {
							return function (acceptsEnrollmentsFromRetail) {
								return function (panelSize) {
									return function (panelSizeLimit) {
										return function (status) {
											return function (waitlistEnabled) {
												return function (email) {
													return function (autoDetermineOnlineSignupVisibilityFromPanelSize) {
														return function (maxPatientAge) {
															return function (minPatientAge) {
																return function (education) {
																	return function (syncedPatientsCount) {
																		return function (elationPhysicianId) {
																			return function (bio) {
																				return function (photoUrl) {
																					return function (gender) {
																						return function (genderOther) {
																							return function (npi) {
																								return function (openingsSize) {
																									return function (meta) {
																										return function (affiliation) {
																											return function (practiceName) {
																												return function (practitionerType) {
																													return {q5: acceptsEnrollmentsFromEmployer, q6: acceptsEnrollmentsFromRetail, Li: affiliation, Mh: autoDetermineOnlineSignupVisibilityFromPanelSize, MK: bio, Q6: education, Rb: elationPhysicianId, Rj: email, SR: gender, ST: genderOther, ahP: id, UV: isMaster, U6: isProvider, Vf: isSynced, WB: maxPatientAge, W4: meta, Xb: minPatientAge, Bq: name, X0: npi, Ym: onlineSignupVisibility, Yp: openingsSize, YJ: panelSize, YK: panelSizeLimit, ZA: photoUrl, ZY: practiceName, Z3: practitionerType, alH: status, acO: syncedPatientsCount, aen: waitlistEnabled};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Practitioner$Meta$Meta = $elm$core$Basics$identity;
var $author$project$Api$Provider$Practitioner$Meta$MetaFields = function (bio) {
	return function (education) {
		return function (email) {
			return function (gender) {
				return function (treatsAge) {
					return function (name) {
						return function (npi) {
							return function (photo) {
								return function (panelSizeLimit) {
									return function (specialtyNames) {
										return function (locations) {
											return {MK: bio, Q6: education, Rj: email, SR: gender, Wg: locations, Bq: name, X0: npi, YK: panelSizeLimit, Zz: photo, abV: specialtyNames, adE: treatsAge};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Utils$MetaFields$Editable = {$: 0};
var $author$project$Utils$MetaFields$NonEditable = function (a) {
	return {$: 1, a: a};
};
var $author$project$Utils$MetaFields$decodeEditable = A2(
	$elm$json$Json$Decode$andThen,
	function (editable) {
		return editable ? $elm$json$Json$Decode$succeed($author$project$Utils$MetaFields$Editable) : A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'explanation',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			$elm$json$Json$Decode$succeed($author$project$Utils$MetaFields$NonEditable));
	},
	A2($elm$json$Json$Decode$field, 'editable', $elm$json$Json$Decode$bool));
var $author$project$Api$Provider$Practitioner$Meta$decodeMetaFields = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'locations',
	$author$project$Utils$MetaFields$decodeEditable,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'specialty_names',
		$author$project$Utils$MetaFields$decodeEditable,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'panel_size_limit',
			$author$project$Utils$MetaFields$decodeEditable,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'photo',
				$author$project$Utils$MetaFields$decodeEditable,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'npi',
					$author$project$Utils$MetaFields$decodeEditable,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'name',
						$author$project$Utils$MetaFields$decodeEditable,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'treats_age',
							$author$project$Utils$MetaFields$decodeEditable,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'gender',
								$author$project$Utils$MetaFields$decodeEditable,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'email',
									$author$project$Utils$MetaFields$decodeEditable,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'education',
										$author$project$Utils$MetaFields$decodeEditable,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'bio',
											$author$project$Utils$MetaFields$decodeEditable,
											$elm$json$Json$Decode$succeed($author$project$Api$Provider$Practitioner$Meta$MetaFields))))))))))));
var $author$project$Api$Provider$Practitioner$Meta$decode = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Practitioner$Meta$decodeMetaFields,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Gender$Female = 1;
var $author$project$Api$Gender$Intersex = 2;
var $author$project$Api$Gender$Male = 0;
var $author$project$Api$Gender$Other = 3;
var $author$project$Api$Gender$genderDecoder = function (string) {
	switch (string) {
		case 'male':
			return $elm$json$Json$Decode$succeed(0);
		case 'female':
			return $elm$json$Json$Decode$succeed(1);
		case 'intersex':
			return $elm$json$Json$Decode$succeed(2);
		case 'other':
			return $elm$json$Json$Decode$succeed(3);
		default:
			return $elm$json$Json$Decode$fail('Unsupported gender: ' + string);
	}
};
var $author$project$Api$Gender$decoder = A2($elm$json$Json$Decode$andThen, $author$project$Api$Gender$genderDecoder, $elm$json$Json$Decode$string);
var $author$project$Api$Provider$Npi$Shared$Npi = $elm$core$Basics$identity;
var $author$project$Api$Provider$Npi$Shared$Record = F5(
	function (number, type_, organizationName, firstName, lastName) {
		return {Sv: firstName, VH: lastName, IO: number, Ys: organizationName, amg: type_};
	});
var $author$project$Api$Provider$Npi$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'last_name',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'first_name',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'organization_name',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'type',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'number',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$Npi$Shared$Record))))));
var $author$project$Api$Provider$Npi$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Npi$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Practitioner$Shared$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'practitioner_type',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'practice_name',
		$elm$json$Json$Decode$string,
		'',
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'affiliation',
			$elm$json$Json$Decode$nullable($author$project$Api$Provider$Affiliate$AffiliateMin$decoder),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'meta',
				$author$project$Api$Provider$Practitioner$Meta$decode,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'openings_size',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'npi',
						$elm$json$Json$Decode$nullable($author$project$Api$Provider$Npi$Shared$decoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'gender_other',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'gender',
								$elm$json$Json$Decode$nullable($author$project$Api$Gender$decoder),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'photo_url',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'bio',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'elation_physician_id',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'synced_patients_count',
												$elm$json$Json$Decode$int,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'education',
													$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
													_List_Nil,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'min_patient_age',
														$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'max_patient_age',
															$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'auto_determine_online_signup_visibility_from_panel_size',
																$elm$json$Json$Decode$bool,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'email',
																	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																	A4(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																		'waitlist_enabled',
																		$elm$json$Json$Decode$bool,
																		false,
																		A4(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																			'status',
																			$elm$json$Json$Decode$string,
																			'accepting_patients',
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'panel_size_limit',
																				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'panel_size',
																					$elm$json$Json$Decode$int,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'accepts_enrollments_from_retail',
																						$elm$json$Json$Decode$bool,
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'accepts_enrollments_from_employer',
																							$elm$json$Json$Decode$bool,
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'is_provider',
																								$elm$json$Json$Decode$bool,
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'online_signup_visibility',
																									$elm$json$Json$Decode$bool,
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'is_synced',
																										$elm$json$Json$Decode$bool,
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'is_master',
																											$elm$json$Json$Decode$bool,
																											A3(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																												'name',
																												$elm$json$Json$Decode$string,
																												A3(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																													'id',
																													$elm$json$Json$Decode$string,
																													$elm$json$Json$Decode$succeed($author$project$Api$Provider$Practitioner$Shared$Record))))))))))))))))))))))))))))));
var $author$project$Api$Provider$Practitioner$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Practitioner$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$FormResponse$One$form = function (_v0) {
	var record = _v0.b;
	return record.SD;
};
var $author$project$Api$Provider$CustomForm$FormAnswer = $elm$core$Basics$identity;
var $author$project$Api$Provider$FormResponseItem$Shared$answer = function (_v0) {
	var record = _v0;
	return record.LR;
};
var $author$project$Api$Provider$FormResponseItem$Shared$formItemId = function (_v0) {
	var record = _v0;
	return record.HQ;
};
var $author$project$Api$Provider$FormResponse$One$formResponseItems = function (_v0) {
	var record = _v0.b;
	return record.SF;
};
var $author$project$Api$Provider$FormResponseItem$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$CustomForm$formItemToFormQuestion = F2(
	function (formResponse, formItem) {
		var allResponseItems = $author$project$Api$Provider$FormResponse$One$formResponseItems(formResponse);
		var responseItems = function () {
			if (!allResponseItems.$) {
				var responseItems_ = allResponseItems.a;
				return A2(
					$elm$core$List$filter,
					function (responseItem) {
						return _Utils_eq(
							$author$project$Api$Provider$FormResponseItem$Shared$formItemId(responseItem),
							$author$project$Api$Provider$FormItem$Shared$id(formItem));
					},
					responseItems_);
			} else {
				return _List_Nil;
			}
		}();
		if ($elm$core$List$isEmpty(responseItems)) {
			return {
				rk: _List_Nil,
				ahP: $author$project$Api$Provider$FormItem$Shared$id(formItem),
				ac9: $author$project$Api$Provider$FormItem$Shared$title(formItem),
				amg: $author$project$Api$Provider$CustomForm$itemTypeToQuestionType(
					$author$project$Api$Provider$FormItem$Shared$type_(formItem))
			};
		} else {
			var toFormAnswer = F2(
				function (id_, answer) {
					return {Qu: $elm$core$Maybe$Nothing, ahP: id_, ac3: answer};
				});
			var answers_ = A2(
				$elm$core$List$map,
				function (item) {
					return A2(
						toFormAnswer,
						$author$project$Api$Provider$FormResponseItem$Shared$id(item),
						$author$project$Api$Provider$FormResponseItem$Shared$answer(item));
				},
				responseItems);
			return {
				rk: answers_,
				ahP: $author$project$Api$Provider$FormItem$Shared$id(formItem),
				ac9: $author$project$Api$Provider$FormItem$Shared$title(formItem),
				amg: $author$project$Api$Provider$CustomForm$itemTypeToQuestionType(
					$author$project$Api$Provider$FormItem$Shared$type_(formItem))
			};
		}
	});
var $author$project$Api$Provider$FormResponse$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$FormResponse$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$FormResponse$Shared$id(shared);
};
var $author$project$Api$Provider$CustomForm$initFromFormResponse = function (formResponse) {
	var form = $author$project$Api$Provider$FormResponse$One$form(formResponse);
	var formItems = $author$project$Api$Provider$Form$Shared$items(form);
	var questions_ = A2(
		$elm$core$List$map,
		function (formItem) {
			return A2($author$project$Api$Provider$CustomForm$formItemToFormQuestion, formResponse, formItem);
		},
		formItems);
	return {
		zJ: $author$project$Api$Provider$FormResponse$One$id(formResponse),
		ahP: $author$project$Api$Provider$Form$Shared$id(form),
		Bq: $author$project$Api$Provider$Form$Shared$name(form),
		DF: questions_
	};
};
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt = F4(
	function (path, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				A2($elm$json$Json$Decode$at, path, $elm$json$Json$Decode$value),
				valDecoder,
				fallback),
			decoder);
	});
var $author$project$Api$Provider$ExternalRecord$ExternalRecord = $elm$core$Basics$identity;
var $author$project$Api$Provider$ExternalRecord$Record = F4(
	function (conflicts, errorMessage, source, status) {
		return {Or: conflicts, RM: errorMessage, JQ: source, alH: status};
	});
var $author$project$Api$Provider$ExternalRecord$Conflict = F3(
	function (name, ours, theirs) {
		return {Bq: name, ajH: ours, al1: theirs};
	});
var $author$project$Api$Provider$ExternalRecord$conflictDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'theirs',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'ours',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$ExternalRecord$Conflict))));
var $author$project$Api$Provider$ExternalRecord$Failed = 2;
var $author$project$Api$Provider$ExternalRecord$Inactive = 1;
var $author$project$Api$Provider$ExternalRecord$Pending = 3;
var $author$project$Api$Provider$ExternalRecord$Processing = 5;
var $author$project$Api$Provider$ExternalRecord$Skipped = 4;
var $author$project$Api$Provider$ExternalRecord$Successful = 0;
var $author$project$Api$Provider$ExternalRecord$statusCodeDecoder = function (string) {
	switch (string) {
		case 'successful':
			return $elm$json$Json$Decode$succeed(0);
		case 'inactive':
			return $elm$json$Json$Decode$succeed(1);
		case 'failed':
			return $elm$json$Json$Decode$succeed(2);
		case 'pending':
			return $elm$json$Json$Decode$succeed(3);
		case 'skipped':
			return $elm$json$Json$Decode$succeed(4);
		case 'processing':
			return $elm$json$Json$Decode$succeed(5);
		default:
			return $elm$json$Json$Decode$fail('Unsupported external record status: ' + string);
	}
};
var $author$project$Api$Provider$ExternalRecord$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'status',
	A2($elm$json$Json$Decode$andThen, $author$project$Api$Provider$ExternalRecord$statusCodeDecoder, $elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'source',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'error_message',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'conflicts',
				$elm$json$Json$Decode$nullable(
					$elm$json$Json$Decode$list($author$project$Api$Provider$ExternalRecord$conflictDecoder)),
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$ExternalRecord$Record)))));
var $author$project$Api$Provider$ExternalRecord$statusDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ExternalRecord$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Patient$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'should_charge_credit_card_fees',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'exempt_from_credit_card_fees',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'emergency_contact',
			$elm$json$Json$Decode$nullable($author$project$Api$Common$EmergencyContact$Shared$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'suffix',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'created_at',
					$elm_community$json_extra$Json$Decode$Extra$datetime,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'profile_picture_url',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'has_payment_method',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'form_responses',
								A2(
									$elm$json$Json$Decode$map,
									$elm$core$List$map($author$project$Api$Provider$CustomForm$initFromFormResponse),
									$elm$json$Json$Decode$list($author$project$Api$Provider$FormResponse$One$decoder)),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'integrations',
									$elm$json$Json$Decode$list($author$project$Api$Provider$ExternalRecord$statusDecoder),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'sources_count',
										$elm$json$Json$Decode$int,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'default_source',
											$elm$json$Json$Decode$nullable(
												$elm$json$Json$Decode$oneOf(
													_List_fromArray(
														[$author$project$Api$Provider$Patient$One$cardDecoder, $author$project$Api$Provider$Patient$One$bankAccountDecoder]))),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'credit_expires_soon',
												$elm$json$Json$Decode$bool,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'credit_in_cents',
													$elm$json$Json$Decode$int,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'owed_in_cents',
														$elm$json$Json$Decode$int,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'company_registrations',
															$elm$json$Json$Decode$list($author$project$Api$Provider$CompanyRegistration$ForPatientOne$decoder),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'health_insurance',
																$elm$json$Json$Decode$nullable($author$project$Api$Provider$HealthInsurance$Shared$decoder),
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'merged_into',
																	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Min$decoder),
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'last_portal_accessed_at',
																		$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'account_access_sent_at',
																			$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'lead_source',
																				$elm$json$Json$Decode$nullable($author$project$Api$Provider$LeadSource$Shared$decoder),
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'preferred_language',
																					$author$project$Language$decode,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'assigned_affiliation',
																						$elm$json$Json$Decode$nullable($author$project$Api$Provider$Affiliate$AffiliateMin$decoder),
																						A4(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																							'dpc_patient',
																							$elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$DpcPatient$decoder),
																							$elm$core$Maybe$Nothing,
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'known_practice',
																								$elm$json$Json$Decode$nullable($author$project$Api$Provider$KnownPractice$Shared$decoder),
																								A4(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																									'ssn',
																									$elm$json$Json$Decode$nullable($author$project$Api$Common$SocialSecurityNumber$Masked$decoder),
																									$elm$core$Maybe$Nothing,
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'billing_address',
																										$elm$json$Json$Decode$nullable($author$project$Api$Common$Address$Shared$decoder),
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'address',
																											$elm$json$Json$Decode$nullable($author$project$Api$Common$Address$Shared$decoder),
																											A3(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																												'uses_billing_address',
																												$elm$json$Json$Decode$bool,
																												A3(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																													'phones',
																													$elm$json$Json$Decode$list($author$project$Api$Common$Phone$Shared$decoder),
																													A3(
																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																														'stripe_link',
																														$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																														A3(
																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																															'title',
																															$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																															A3(
																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																'overdue_in_cents',
																																$elm$json$Json$Decode$int,
																																A4(
																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																	'network_sync_status',
																																	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$SyncStatus$decoder),
																																	$elm$core$Maybe$Nothing,
																																	A4(
																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																		'affiliate_sync_status',
																																		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$SyncStatus$decoder),
																																		$elm$core$Maybe$Nothing,
																																		A4(
																																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																			'affiliate',
																																			$elm$json$Json$Decode$nullable($author$project$Api$Provider$Organization$Shared$decoder),
																																			$elm$core$Maybe$Nothing,
																																			A4(
																																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
																																				_List_fromArray(
																																					['master_record', 'id']),
																																				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																				$elm$core$Maybe$Nothing,
																																				A4(
																																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																					'network',
																																					$elm$json$Json$Decode$nullable($author$project$Api$Provider$Organization$Shared$decoder),
																																					$elm$core$Maybe$Nothing,
																																					A4(
																																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
																																						_List_fromArray(
																																							['synced_record', 'id']),
																																						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																						$elm$core$Maybe$Nothing,
																																						A3(
																																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																							'is_affiliated',
																																							$elm$json$Json$Decode$bool,
																																							A3(
																																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																								'is_synced',
																																								$elm$json$Json$Decode$bool,
																																								A3(
																																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																									'is_master',
																																									$elm$json$Json$Decode$bool,
																																									A3(
																																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																										'flagged_notes_count',
																																										$elm$json$Json$Decode$int,
																																										A3(
																																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																											'membership_through',
																																											$elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Min$decoder),
																																											A3(
																																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																												'age',
																																												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																																												A3(
																																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																													'payees',
																																													$elm$json$Json$Decode$list($author$project$Api$Provider$Patient$Shared$decoder),
																																													A3(
																																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																														'payer',
																																														$elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Min$decoder),
																																														A3(
																																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																															'company_accounts',
																																															$elm$json$Json$Decode$list($author$project$Api$Provider$CompanyAccount$ForPatient$decoder),
																																															A3(
																																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																'company',
																																																$elm$json$Json$Decode$nullable($author$project$Api$Provider$Company$Min$decoder),
																																																A3(
																																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																	'practitioner',
																																																	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Practitioner$Shared$decoder),
																																																	A3(
																																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																		'location',
																																																		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Location$Shared$decoder),
																																																		A3(
																																																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																			'request_pending_documents_acceptance_sent_at',
																																																			$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
																																																			A3(
																																																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																				'request_pay_info_sent_at',
																																																				$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
																																																				$elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$One$Record)))))))))))))))))))))))))))))))))))))))))))))))))))));
var $author$project$Api$Provider$Patient$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Patient$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Patient$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$One$Patient)));
var $author$project$Api$Provider$Patient$acceptHipaaAuthorization = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Patient$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['accept_hipaa_authorization']),
					$author$project$Api$Provider$Patient$patientPath(id_))));
	});
var $author$project$Api$Provider$Patient$acceptHipaaAuthorizationAll = F2(
	function (apiClient, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'do_all',
					$elm$json$Json$Encode$bool(true))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['accept_hipaa_authorization']),
						$author$project$Api$Provider$Patient$patientsPath))));
	});
var $author$project$Api$Provider$Patient$Shared$id = function (_v0) {
	var shared = _v0;
	return shared.ahP;
};
var $author$project$Api$Provider$Patient$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$id(shared);
};
var $author$project$Api$Provider$Patient$Shared$name = function (_v0) {
	var shared = _v0;
	return shared.Bq;
};
var $author$project$Api$Provider$Patient$All$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$name(shared);
};
var $author$project$Pages$Admin$HipaaAuthorizations$FetchPatients = {$: 9};
var $author$project$Pages$Admin$HipaaAuthorizations$pollPatients = A2(
	$elm$core$Task$perform,
	function (_v0) {
		return $author$project$Pages$Admin$HipaaAuthorizations$FetchPatients;
	},
	$elm$core$Process$sleep(1000));
var $author$project$Pages$Admin$HipaaAuthorizations$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					var totalCount = A2(
						$elm$core$Maybe$withDefault,
						0,
						A2(
							$elm$core$Maybe$andThen,
							$elm$core$String$toInt,
							A2($elm$core$Dict$get, 'x-total-count', headers)));
					var cmd = (model.pe && (totalCount > 0)) ? $author$project$Pages$Admin$HipaaAuthorizations$pollPatients : $elm$core$Platform$Cmd$none;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								tn: totalCount,
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ),
								CM: response,
								pe: model.pe && (totalCount > 0)
							}),
						cmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{CM: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$reportDecodeError(response));
				}
			case 1:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					$author$project$Pages$Admin$HipaaAuthorizations$fetchPatients(newModel),
					_List_Nil);
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bn: $author$project$Pages$Admin$HipaaAuthorizations$All($author$project$Api$Data$NotAsked)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var patient = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bn: A2($author$project$Pages$Admin$HipaaAuthorizations$One, patient, $author$project$Api$Data$NotAsked)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bn: $author$project$Pages$Admin$HipaaAuthorizations$None}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bn: $author$project$Pages$Admin$HipaaAuthorizations$All($author$project$Api$Data$Loading)
						}),
					A2($author$project$Api$Provider$Patient$acceptHipaaAuthorizationAll, model.Gv, $author$project$Pages$Admin$HipaaAuthorizations$AcceptedForAll),
					_List_Nil);
			case 6:
				var patient = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bn: A2($author$project$Pages$Admin$HipaaAuthorizations$One, patient, $author$project$Api$Data$Loading)
						}),
					A3(
						$author$project$Api$Provider$Patient$acceptHipaaAuthorization,
						model.Gv,
						$author$project$Api$Provider$Patient$All$id(patient),
						$author$project$Pages$Admin$HipaaAuthorizations$AcceptedForOne(patient)),
					_List_Nil);
			case 8:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bn: $author$project$Pages$Admin$HipaaAuthorizations$None, CM: $author$project$Api$Data$Loading, pe: true}),
						$author$project$Pages$Admin$HipaaAuthorizations$fetchPatients(model),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Accepting HIPAA for all patients. This may take a couple moments...')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bn: $author$project$Pages$Admin$HipaaAuthorizations$All(response)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 7:
				var patient = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bn: $author$project$Pages$Admin$HipaaAuthorizations$None, CM: $author$project$Api$Data$Loading}),
						$author$project$Pages$Admin$HipaaAuthorizations$fetchPatients(model),
						_List_fromArray(
							[
								A2(
								$author$project$OutMsg$ShowToast,
								3,
								'You successfully accepted the ePHI waiver. ' + ($author$project$Api$Provider$Patient$All$name(patient) + ' will now receive notifications.'))
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bn: A2($author$project$Pages$Admin$HipaaAuthorizations$One, patient, response)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{CM: $author$project$Api$Data$Loading}),
					$author$project$Pages$Admin$HipaaAuthorizations$fetchPatients(model),
					_List_Nil);
		}
	});
var $author$project$Pages$Admin$HipaaAuthorizations$AcceptForAll = {$: 5};
var $author$project$Pages$Admin$HipaaAuthorizations$AcceptForOne = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Admin$HipaaAuthorizations$viewAcceptModal = F3(
	function (numberPatientsNotAuthorized, patient, response) {
		var _v0 = function () {
			if (!patient.$) {
				var patient_ = patient.a;
				return _Utils_Tuple2(
					$author$project$Pages$Admin$HipaaAuthorizations$AcceptForOne(patient_),
					A2(
						$author$project$Ui$Typography$text,
						_List_fromArray(
							[
								$author$project$Ui$Typography$phi(true)
							]),
						$author$project$Api$Provider$Patient$All$name(patient_)));
			} else {
				return _Utils_Tuple2(
					$author$project$Pages$Admin$HipaaAuthorizations$AcceptForAll,
					$elm$html$Html$text('All'));
			}
		}();
		var buttonMsg = _v0.a;
		var buttonSubject = _v0.b;
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Pages$Admin$HipaaAuthorizations$AcceptModalClosed,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('Authorization to commmunicate over non-encrypted media')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$title,
							_List_Nil,
							function () {
								if (!patient.$) {
									var patient_ = patient.a;
									return _List_fromArray(
										[
											$elm$html$Html$text('You have received authorization from '),
											A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[
													$author$project$Ui$Typography$phi(true)
												]),
											$author$project$Api$Provider$Patient$All$name(patient_)),
											$elm$html$Html$text(' that allow us to send non-encrypted communications to '),
											A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[
													$author$project$Ui$Typography$phi(true)
												]),
											$author$project$Api$Provider$Patient$All$name(patient_)),
											$elm$html$Html$text(' that may include Protected Health Information. '),
											$elm$html$Html$text('This is not reversible.')
										]);
								} else {
									return _List_fromArray(
										[
											$elm$html$Html$text('You have received authorization from '),
											$elm$html$Html$text(
											A2($author$project$Formatters$String$pluralize, 'patient', numberPatientsNotAuthorized)),
											$elm$html$Html$text(' that allow us to send non-encrypted communications to each of them that may include Protected Health Information. '),
											$elm$html$Html$text('This is not reversible.')
										]);
								}
							}()),
							A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Do you have a signed copy of the non-encrypted communications waiver from '),
									function () {
									if (!patient.$) {
										var patient_ = patient.a;
										return A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[
													$author$project$Ui$Typography$phi(true)
												]),
											$author$project$Api$Provider$Patient$All$name(patient_));
									} else {
										return $elm$html$Html$text('all of these patients');
									}
								}()
								]))
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Cancel and close modal'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Pages$Admin$HipaaAuthorizations$AcceptModalClosed)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Accept ePHI'},
							_List_fromArray(
								[
									$author$project$Ui$Button$success,
									$author$project$Ui$Button$onClick(buttonMsg),
									$author$project$Ui$Button$loading(
									_Utils_eq(response, $author$project$Api$Data$Loading))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Yes, Accept for '),
									buttonSubject
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$HipaaAuthorizations$AcceptingForAll = {$: 2};
var $author$project$Pages$Admin$HipaaAuthorizations$PaginationMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$HipaaAuthorizations$AcceptingForOne = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Patient$Shared$email = function (_v0) {
	var shared = _v0;
	return shared.Rj;
};
var $author$project$Api$Provider$Patient$All$email = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$email(shared);
};
var $author$project$Pages$Admin$HipaaAuthorizations$viewPatient = function (patient) {
	return A2(
		$author$project$Ui$Table$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$text,
						_List_fromArray(
							[
								$author$project$Ui$Typography$phi(true)
							]),
						$author$project$Api$Provider$Patient$All$name(patient))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$text,
						_List_fromArray(
							[
								$author$project$Ui$Typography$phi(true)
							]),
						A2(
							$elm$core$Maybe$withDefault,
							'',
							$author$project$Api$Provider$Patient$All$email(patient)))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$flex, $author$project$Ui$Element$justifyRight]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{mm: 'accept ePHI waiver'},
								_List_fromArray(
									[
										$author$project$Ui$Button$primary,
										$author$project$Ui$Button$onClick(
										$author$project$Pages$Admin$HipaaAuthorizations$AcceptingForOne(patient))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Accept ePHI waiver')
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Admin$HipaaAuthorizations$viewPanel = function (model) {
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_fromArray(
					[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
				_List_fromArray(
					[
						$author$project$Ui$Panel$title(
						_List_fromArray(
							[
								$elm$html$Html$text('ePHI Communication Waivers')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Accept for all patients'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$onClick($author$project$Pages$Admin$HipaaAuthorizations$AcceptingForAll)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Accept for All Patients')
							]))
					])),
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						function () {
						var _v0 = model.CM;
						if (_v0.$ === 3) {
							var patients = _v0.a;
							return $elm$core$List$isEmpty(patients) ? $author$project$Utils$Html$empty : A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('The following patients have not authorized our system to send them unencrypted electronic '),
										$elm$html$Html$text('communications which may contain Protected Health Information, such as emails about invoices and receipts.'),
										A2($elm$html$Html$br, _List_Nil, _List_Nil),
										$elm$html$Html$text('We will not send emails or other electronic notifications which '),
										$elm$html$Html$text('may contain Protected Health Information to these patients.')
									]));
						} else {
							return $author$project$Ui$Spinner$view(_List_Nil);
						}
					}(),
						A4(
						$author$project$Ui$Table$view,
						_List_fromArray(
							[
								$author$project$Ui$Table$zeroState(
								_List_fromArray(
									[
										$elm$html$Html$text('All of your active patients have agreed to allow all email communications from this platform, so they should be receiving notifications from our system.')
									])),
								$author$project$Ui$Table$loading(
								_Utils_eq(model.CM, $author$project$Api$Data$Loading))
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Table$header,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Patient')
									])),
								A2(
								$author$project$Ui$Table$header,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Email')
									])),
								A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
							]),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								$elm$core$List$map($author$project$Pages$Admin$HipaaAuthorizations$viewPatient),
								$author$project$Api$Data$toMaybe(model.CM))),
						_List_Nil)
					])),
				A2(
				$author$project$Ui$Panel$footer,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Pages$Admin$HipaaAuthorizations$PaginationMsg,
						A2(
							$author$project$Api$Pagination$view,
							_List_fromArray(
								[
									$author$project$Ui$Pagination$List$loading(
									!$author$project$Api$Data$isSuccess(model.CM))
								]),
							model.ajJ))
					]))
			]));
};
var $author$project$Pages$Admin$HipaaAuthorizations$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				function () {
				var _v0 = model.bn;
				switch (_v0.$) {
					case 1:
						var id = _v0.a;
						var response = _v0.b;
						return A3(
							$author$project$Pages$Admin$HipaaAuthorizations$viewAcceptModal,
							model.tn,
							$elm$core$Maybe$Just(id),
							response);
					case 2:
						var response = _v0.a;
						return A3($author$project$Pages$Admin$HipaaAuthorizations$viewAcceptModal, model.tn, $elm$core$Maybe$Nothing, response);
					default:
						return $author$project$Utils$Html$empty;
				}
			}(),
				$author$project$Pages$Admin$HipaaAuthorizations$viewPanel(model)
			]),
		ac9: 'Admin | ePHI Waivers'
	};
};
var $author$project$Pages$Admin$HipaaAuthorizations$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$HipaaAuthorizations$init, aiq: $author$project$Pages$Admin$HipaaAuthorizations$load, k8: $author$project$Pages$Admin$HipaaAuthorizations$save, alO: $author$project$Pages$Admin$HipaaAuthorizations$subscriptions, adT: $author$project$Pages$Admin$HipaaAuthorizations$update, amo: $author$project$Pages$Admin$HipaaAuthorizations$view});
var $author$project$Pages$Admin$Integrations$Slug_String$init = F4(
	function (session, _v0, _v1, _v2) {
		var apiClient = _v1.Gv;
		var params = _v2.YL;
		return _Utils_Tuple2(
			{Gv: apiClient, aa4: session},
			A2(
				$author$project$Utils$Route$navigate,
				$elm$core$Dict$empty,
				$author$project$Spa$Generated$Route$Marketplace__Slug_String(
					{abG: params.abG})));
	});
var $author$project$Pages$Admin$Integrations$Slug_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Integrations$Slug_String$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Integrations$Slug_String$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$Integrations$Slug_String$update = F2(
	function (msg, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Admin$Integrations$Slug_String$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Integrations'};
};
var $author$project$Pages$Admin$Integrations$Slug_String$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Integrations$Slug_String$init, aiq: $author$project$Pages$Admin$Integrations$Slug_String$load, k8: $author$project$Pages$Admin$Integrations$Slug_String$save, alO: $author$project$Pages$Admin$Integrations$Slug_String$subscriptions, adT: $author$project$Pages$Admin$Integrations$Slug_String$update, amo: $author$project$Pages$Admin$Integrations$Slug_String$view});
var $author$project$Pages$Admin$InternalSettings$GotCurrentGroup = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$InternalSettings$GotGroups = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$ManagementGroup$listPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['management_groups']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$ManagementGroup$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$ManagementGroup$Shared$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$ManagementGroup$listPath));
	});
var $author$project$Pages$Admin$InternalSettings$init = F4(
	function (_v0, practice, _v1, _v2) {
		var apiClient = _v1.Gv;
		return _Utils_Tuple2(
			{
				Gv: apiClient,
				x6: $author$project$Api$Provider$Practice$One$hasClinicalAccount(practice),
				mR: false,
				rP: $elm$core$Maybe$Nothing,
				zN: _List_Nil
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Api$Provider$ManagementGroup$getCurrent, apiClient, $author$project$Pages$Admin$InternalSettings$GotCurrentGroup),
						A2($author$project$Api$Provider$ManagementGroup$list, apiClient, $author$project$Pages$Admin$InternalSettings$GotGroups)
					])));
	});
var $author$project$Pages$Admin$InternalSettings$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$InternalSettings$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$InternalSettings$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$InternalSettings$GotToggleClinicalResponse = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$InternalSettings$ManagementGroupSaved = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$ManagementGroup$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$Practice$toggleClinical = F3(
	function (apiClient, enabled, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'enabled',
					$elm$json$Json$Encode$bool(enabled))
				]));
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$Practice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['toggle_clinical']),
						$author$project$Api$Provider$Practice$practicePath))));
	});
var $author$project$Api$Provider$ManagementGroup$update = F3(
	function (apiClient, id, toMsg) {
		var params = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(id))
				]));
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$elm$json$Json$Decode$maybe($author$project$Api$Provider$ManagementGroup$Shared$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				params,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$ManagementGroup$resourcePath)));
	});
var $author$project$Pages$Admin$InternalSettings$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var dataGroup = msg.a;
				switch (dataGroup.$) {
					case 3:
						var group = dataGroup.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									rP: $elm$core$Maybe$Just(group)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					case 2:
						var error = dataGroup.a;
						if (error.$ === 5) {
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{rP: $elm$core$Maybe$Nothing}),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
						} else {
							return _Utils_Tuple3(
								model,
								$elm$core$Platform$Cmd$none,
								$author$project$OutMsg$handleErrorResponse(dataGroup));
						}
					default:
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(dataGroup));
				}
			case 1:
				var dataGroups = msg.a;
				if (dataGroups.$ === 3) {
					var groups = dataGroups.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{zN: groups}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(dataGroups));
				}
			case 2:
				var groupId = msg.a;
				return _Utils_Tuple3(
					model,
					A3($author$project$Api$Provider$ManagementGroup$update, model.Gv, groupId, $author$project$Pages$Admin$InternalSettings$ManagementGroupSaved),
					_List_Nil);
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					if (!response.a.$) {
						var group = response.a.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									'Successfully updated management group to ' + $author$project$Api$Provider$ManagementGroup$Shared$name(group))
								]));
					} else {
						var _v5 = response.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Successfully removed management group')
								]));
					}
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 4:
				var enabled = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{mR: true}),
					A3($author$project$Api$Provider$Practice$toggleClinical, model.Gv, enabled, $author$project$Pages$Admin$InternalSettings$GotToggleClinicalResponse),
					_List_Nil);
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var practice = response.a;
					var enabled = $author$project$Api$Provider$Practice$One$hasClinicalAccount(practice);
					var label = enabled ? 'enabled' : 'disabled';
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{x6: enabled, mR: false}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Clinical successfully ' + label)
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{mR: false}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Admin$InternalSettings$ToggleClinical = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$InternalSettings$viewClinicalToggle = function (model) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Clinical'),
				$author$project$Ui$Form$Group$labelSpanMd(3),
				$author$project$Ui$Form$Group$inputSpanMd(4)
			]),
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$view(
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$on(model.x6),
						$author$project$Ui$ToggleSwitch$onChange($author$project$Pages$Admin$InternalSettings$ToggleClinical),
						$author$project$Ui$ToggleSwitch$disabled(model.mR)
					]))
			]));
};
var $author$project$Pages$Admin$InternalSettings$ManagementGroupSelected = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$ManagementGroup$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Pages$Admin$InternalSettings$managementGroupOptions = function (model) {
	return A2(
		$elm$core$List$cons,
		A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, 'None'),
		A2(
			$elm$core$List$map,
			function (managementGroup) {
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$ManagementGroup$Shared$id(managementGroup)),
					$author$project$Api$Provider$ManagementGroup$Shared$name(managementGroup));
			},
			model.zN));
};
var $author$project$Pages$Admin$InternalSettings$viewManagementGroupSelection = function (model) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Management Group'),
				$author$project$Ui$Form$Group$labelSpanMd(3),
				$author$project$Ui$Form$Group$inputSpanMd(4),
				$author$project$Ui$Form$Group$required(true)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Select$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Select$value(
						A2($elm$core$Maybe$map, $author$project$Api$Provider$ManagementGroup$Shared$id, model.rP)),
						$author$project$Ui$Form$Select$onChange($author$project$Pages$Admin$InternalSettings$ManagementGroupSelected)
					]),
				$author$project$Pages$Admin$InternalSettings$managementGroupOptions(model))
			]));
};
var $author$project$Pages$Admin$InternalSettings$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Internal Settings')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Pages$Admin$InternalSettings$viewManagementGroupSelection(model),
								$author$project$Pages$Admin$InternalSettings$viewClinicalToggle(model)
							]))
					]))
			]),
		ac9: 'Admin | Internal Settings'
	};
};
var $author$project$Pages$Admin$InternalSettings$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$InternalSettings$init, aiq: $author$project$Pages$Admin$InternalSettings$load, k8: $author$project$Pages$Admin$InternalSettings$save, alO: $author$project$Pages$Admin$InternalSettings$subscriptions, adT: $author$project$Pages$Admin$InternalSettings$update, amo: $author$project$Pages$Admin$InternalSettings$view});
var $author$project$Pages$Admin$InvoiceSettings$GotCompanyInvoiceSetting = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$InvoiceSettings$GotPaymentSourceSetting = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Practice$One$companyInvoiceSetting = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Oe;
	});
var $author$project$Api$Provider$CompanyInvoiceSetting$Shared$id = function (_v0) {
	var shared = _v0;
	return shared.ahP;
};
var $author$project$Api$Provider$PaymentSourceSetting$Shared$id = function (_v0) {
	var shared = _v0;
	return shared.ahP;
};
var $author$project$Api$Provider$Practice$One$paymentSourceSetting = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Zh;
	});
var $author$project$Api$Provider$CompanyInvoiceSetting$Shared$companyInvoiceSettingsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['company_invoice_settings']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$CompanyInvoiceSetting$Shared$companyInvoiceSettingPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$CompanyInvoiceSetting$Shared$companyInvoiceSettingsPath);
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$ForPractice = $elm$core$Basics$identity;
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$Record = function (invoiceUpcomingAutoSend) {
	return function (invoiceAutoSend) {
		return function (invoiceAutoSendDay) {
			return function (invoiceAutoSendMonth) {
				return function (invoiceAutoIssue) {
					return function (invoiceAutoIssueDay) {
						return function (invoiceAutoIssueMonth) {
							return function (invoiceDueDay) {
								return function (invoiceDueMonth) {
									return function (invoiceAutoPay) {
										return function (invoiceAutoPayDay) {
											return function (invoiceAutoPayMonth) {
												return function (invoiceGracePeriodDays) {
													return function (chargePhiDetailsEnabled) {
														return function (chargePhiDetailsUpdatedAt) {
															return function (chargePhiDetailsUpdatedBy) {
																return function (chargeRouteToRecurringInvoice) {
																	return function (billingEnabled) {
																		return function (billingStartDate) {
																			return function (hideSponsorInvoices) {
																				return {GF: billingEnabled, MH: billingStartDate, Nx: chargePhiDetailsEnabled, Ny: chargePhiDetailsUpdatedAt, Nz: chargePhiDetailsUpdatedBy, GX: chargeRouteToRecurringInvoice, Ts: hideSponsorInvoices, Ul: invoiceAutoIssue, Um: invoiceAutoIssueDay, Ic: invoiceAutoIssueMonth, Un: invoiceAutoPay, Id: invoiceAutoPayDay, Ie: invoiceAutoPayMonth, Uo: invoiceAutoSend, Up: invoiceAutoSendDay, If: invoiceAutoSendMonth, Ur: invoiceDueDay, Ig: invoiceDueMonth, Ih: invoiceGracePeriodDays, Ii: invoiceUpcomingAutoSend};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$MonthAfter = 2;
var $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$MonthBefore = 0;
var $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$MonthOfTheInvoice = 1;
var $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$fromString = function (option) {
	switch (option) {
		case 'month_before':
			return $elm$core$Maybe$Just(0);
		case 'month_of_the_invoice':
			return $elm$core$Maybe$Just(1);
		case 'month_after':
			return $elm$core$Maybe$Just(2);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		var _v0 = $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$fromString(string);
		if (!_v0.$) {
			var option = _v0.a;
			return $elm$json$Json$Decode$succeed(option);
		} else {
			return $elm$json$Json$Decode$fail('Unsupported month configuration option: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'hide_sponsor_invoices',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'billing_start_date',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'billing_enabled',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'charge_route_to_recurring_invoice',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'charge_phi_details_updated_by',
					$elm$json$Json$Decode$nullable($author$project$Api$Provider$User$Min$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'charge_phi_details_updated_at',
						$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'charge_phi_details_enabled',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'invoice_grace_period_days',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'invoice_auto_pay_month',
									$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$decoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'invoice_auto_pay_day',
										$elm$json$Json$Decode$int,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'invoice_auto_pay',
											$elm$json$Json$Decode$bool,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'invoice_due_month',
												$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$decoder,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'invoice_due_day',
													$elm$json$Json$Decode$int,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'invoice_auto_issue_month',
														$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$decoder,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'invoice_auto_issue_day',
															$elm$json$Json$Decode$int,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'invoice_auto_issue',
																$elm$json$Json$Decode$bool,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'invoice_auto_send_month',
																	$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$decoder,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'invoice_auto_send_day',
																		$elm$json$Json$Decode$int,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'invoice_auto_send',
																			$elm$json$Json$Decode$bool,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'invoice_upcoming_auto_send',
																				$elm$json$Json$Decode$bool,
																				$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$Record)))))))))))))))))))));
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$retrieve = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$CompanyInvoiceSetting$Shared$companyInvoiceSettingPath(id_)));
	});
var $author$project$Api$Provider$PaymentSourceSetting$ForPractice$ForPractice = $elm$core$Basics$identity;
var $author$project$Api$Provider$PaymentSourceSetting$ForPractice$Record = F3(
	function (acceptsAch, acceptsCards, acceptsAmex) {
		return {KA: acceptsAch, KB: acceptsAmex, KC: acceptsCards};
	});
var $author$project$Api$Provider$PaymentSourceSetting$ForPractice$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'accepts_amex',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'accepts_cards',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'accepts_ach',
			$elm$json$Json$Decode$bool,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$PaymentSourceSetting$ForPractice$Record))));
var $author$project$Api$Provider$PaymentSourceSetting$ForPractice$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PaymentSourceSetting$ForPractice$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PaymentSourceSetting$Shared$paymentSourceSettingsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['payment_source_settings']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$PaymentSourceSetting$Shared$paymentSourceSettingPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$PaymentSourceSetting$Shared$paymentSourceSettingsPath);
};
var $author$project$Api$Provider$PaymentSourceSetting$ForPractice$retrieve = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$PaymentSourceSetting$ForPractice$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$PaymentSourceSetting$Shared$paymentSourceSettingPath(id_)));
	});
var $author$project$Pages$Admin$InvoiceSettings$init = F4(
	function (_v0, practice, shared, _v1) {
		var paymentSettingId = $author$project$Api$Provider$PaymentSourceSetting$Shared$id(
			$author$project$Api$Provider$Practice$One$paymentSourceSetting(practice));
		var companySettingId = $author$project$Api$Provider$CompanyInvoiceSetting$Shared$id(
			$author$project$Api$Provider$Practice$One$companyInvoiceSetting(practice));
		return _Utils_Tuple2(
			{
				Gv: shared.Gv,
				Oe: $author$project$Api$Data$Loading,
				dd: shared.dd,
				SD: $elm$core$Maybe$Nothing,
				jQ: false,
				ahP: companySettingId,
				Ij: $author$project$Shared$isHintAdmin(shared),
				be: $elm$core$Maybe$Nothing,
				tL: paymentSettingId,
				Zh: $author$project$Api$Data$Loading,
				ZV: practice
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3($author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$retrieve, shared.Gv, companySettingId, $author$project$Pages$Admin$InvoiceSettings$GotCompanyInvoiceSetting),
						A3($author$project$Api$Provider$PaymentSourceSetting$ForPractice$retrieve, shared.Gv, paymentSettingId, $author$project$Pages$Admin$InvoiceSettings$GotPaymentSourceSetting)
					])));
	});
var $author$project$Pages$Admin$InvoiceSettings$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{dd: shared.dd}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$InvoiceSettings$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$InvoiceSettings$HiConfirmClosed = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Admin$InvoiceSettings$subscriptions = function (_v0) {
	var hiConfirmOpen = _v0.jQ;
	return hiConfirmOpen ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Admin$InvoiceSettings$HiConfirmClosed) : $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$InvoiceSettings$updateMonthOptionField = F3(
	function (monthOption, updateField, fields) {
		return A2(
			$elm$core$Maybe$withDefault,
			fields,
			A2(
				$elm$core$Maybe$map,
				updateField,
				$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$fromString(monthOption)));
	});
var $author$project$Pages$Admin$InvoiceSettings$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var bool = field.a;
				return _Utils_update(
					fields,
					{Ii: bool});
			case 1:
				var bool = field.a;
				return _Utils_update(
					fields,
					{Uo: bool});
			case 2:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Up: A2(
							$elm$core$Maybe$withDefault,
							1,
							$elm$core$String$toInt(string))
					});
			case 3:
				var monthOption = field.a;
				return A2(
					$elm$core$Maybe$withDefault,
					fields,
					A2(
						$elm$core$Maybe$map,
						function (option) {
							return _Utils_update(
								fields,
								{If: option});
						},
						$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$fromString(monthOption)));
			case 4:
				var bool = field.a;
				return _Utils_update(
					fields,
					{Ul: bool});
			case 5:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Um: A2(
							$elm$core$Maybe$withDefault,
							1,
							$elm$core$String$toInt(string))
					});
			case 6:
				var monthOption = field.a;
				return A2(
					$elm$core$Maybe$withDefault,
					fields,
					A2(
						$elm$core$Maybe$map,
						function (option) {
							return _Utils_update(
								fields,
								{Ic: option});
						},
						$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$fromString(monthOption)));
			case 7:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Ur: A2(
							$elm$core$Maybe$withDefault,
							1,
							$elm$core$String$toInt(string))
					});
			case 8:
				var monthOption = field.a;
				return A2(
					$elm$core$Maybe$withDefault,
					fields,
					A2(
						$elm$core$Maybe$map,
						function (option) {
							return _Utils_update(
								fields,
								{Ig: option});
						},
						$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$fromString(monthOption)));
			case 9:
				var bool = field.a;
				return _Utils_update(
					fields,
					{Un: bool});
			case 10:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Id: A2(
							$elm$core$Maybe$withDefault,
							1,
							$elm$core$String$toInt(string))
					});
			case 11:
				var monthOption = field.a;
				return A3(
					$author$project$Pages$Admin$InvoiceSettings$updateMonthOptionField,
					monthOption,
					function (option) {
						return _Utils_update(
							fields,
							{Ie: option});
					},
					fields);
			case 12:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Ih: A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$String$toInt(string))
					});
			case 13:
				var bool = field.a;
				return _Utils_update(
					fields,
					{Nx: bool});
			case 14:
				var bool = field.a;
				return _Utils_update(
					fields,
					{GX: bool});
			case 15:
				var bool = field.a;
				return _Utils_update(
					fields,
					{GF: bool});
			default:
				var bool = field.a;
				return _Utils_update(
					fields,
					{Ts: bool});
		}
	});
var $author$project$Pages$Admin$InvoiceSettings$IssueDateValidation = 0;
var $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toInt = function (option) {
	switch (option) {
		case 0:
			return -1;
		case 1:
			return 0;
		default:
			return 1;
	}
};
var $author$project$Pages$Admin$InvoiceSettings$isOnOrAfter = F2(
	function (_v0, _v1) {
		var firstDay = _v0.a;
		var firstMonth = _v0.b;
		var secondDay = _v1.a;
		var secondMonth = _v1.b;
		var secondMonthInt = $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toInt(secondMonth);
		var firstMonthInt = $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toInt(firstMonth);
		return _Utils_eq(firstMonthInt, secondMonthInt) ? (_Utils_cmp(firstDay, secondDay) < 1) : (_Utils_cmp(firstMonthInt, secondMonthInt) < 0);
	});
var $author$project$Pages$Admin$InvoiceSettings$autoPayDateIsOnOrAfterAutoIssueDate = function (form) {
	return (form.Un && form.Ul) ? A2(
		$author$project$Pages$Admin$InvoiceSettings$isOnOrAfter,
		_Utils_Tuple2(form.Um, form.Ic),
		_Utils_Tuple2(form.Id, form.Ie)) : true;
};
var $author$project$Pages$Admin$InvoiceSettings$autoPayDateIsOnOrAfterAutoIssueDateValidator = A2(
	$rtfeldman$elm_validate$Validate$ifFalse,
	$author$project$Pages$Admin$InvoiceSettings$autoPayDateIsOnOrAfterAutoIssueDate,
	_Utils_Tuple2(0, 'The Issue date must be before or on the autopay date'));
var $author$project$Pages$Admin$InvoiceSettings$AutoPayDateValidation = 1;
var $author$project$Pages$Admin$InvoiceSettings$autoPayDateIsOnOrAfterAutoSendDate = function (form) {
	return (form.Uo && form.Un) ? A2(
		$author$project$Pages$Admin$InvoiceSettings$isOnOrAfter,
		_Utils_Tuple2(form.Up, form.If),
		_Utils_Tuple2(form.Id, form.Ie)) : true;
};
var $author$project$Pages$Admin$InvoiceSettings$autoPayDateIsOnOrAfterAutoSendDateValidator = A2(
	$rtfeldman$elm_validate$Validate$ifFalse,
	$author$project$Pages$Admin$InvoiceSettings$autoPayDateIsOnOrAfterAutoSendDate,
	_Utils_Tuple2(1, 'The autopay date must be on or after the Invoice Created notification date'));
var $author$project$Pages$Admin$InvoiceSettings$DueDateValidation = 2;
var $author$project$Pages$Admin$InvoiceSettings$dueDateIsOnOrAfterAutoPayDate = function (form) {
	return form.Un ? A2(
		$author$project$Pages$Admin$InvoiceSettings$isOnOrAfter,
		_Utils_Tuple2(form.Id, form.Ie),
		_Utils_Tuple2(form.Ur, form.Ig)) : true;
};
var $author$project$Pages$Admin$InvoiceSettings$dueDateIsOnOrAfterAutoPayDateValidator = A2(
	$rtfeldman$elm_validate$Validate$ifFalse,
	$author$project$Pages$Admin$InvoiceSettings$dueDateIsOnOrAfterAutoPayDate,
	_Utils_Tuple2(2, 'The invoice must be due on or after the autopay date'));
var $author$project$Pages$Admin$InvoiceSettings$dueDateIsOnOrAfterAutoSendDate = function (form) {
	return (form.Un || (!form.Uo)) ? true : A2(
		$author$project$Pages$Admin$InvoiceSettings$isOnOrAfter,
		_Utils_Tuple2(form.Up, form.If),
		_Utils_Tuple2(form.Ur, form.Ig));
};
var $author$project$Pages$Admin$InvoiceSettings$dueDateIsOnOrAfterAutoSendDateValidator = A2(
	$rtfeldman$elm_validate$Validate$ifFalse,
	$author$project$Pages$Admin$InvoiceSettings$dueDateIsOnOrAfterAutoSendDate,
	_Utils_Tuple2(2, 'The invoice must be due on or after the Invoice Created notification date'));
var $author$project$Pages$Admin$InvoiceSettings$InvoiceUpcomingValidation = 3;
var $author$project$Pages$Admin$InvoiceSettings$invoiceCreatedIsEnabledIfInvoiceUpcomingIsEnabledValidator = A2(
	$rtfeldman$elm_validate$Validate$ifFalse,
	function (_v0) {
		var invoiceUpcomingAutoSend = _v0.Ii;
		var invoiceAutoSend = _v0.Uo;
		return invoiceUpcomingAutoSend ? invoiceAutoSend : true;
	},
	_Utils_Tuple2(3, 'This notification can only be enabled if the Invoice Created notification is also enabled'));
var $author$project$Pages$Admin$InvoiceSettings$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[$author$project$Pages$Admin$InvoiceSettings$invoiceCreatedIsEnabledIfInvoiceUpcomingIsEnabledValidator, $author$project$Pages$Admin$InvoiceSettings$autoPayDateIsOnOrAfterAutoSendDateValidator, $author$project$Pages$Admin$InvoiceSettings$autoPayDateIsOnOrAfterAutoIssueDateValidator, $author$project$Pages$Admin$InvoiceSettings$dueDateIsOnOrAfterAutoPayDateValidator, $author$project$Pages$Admin$InvoiceSettings$dueDateIsOnOrAfterAutoSendDateValidator]));
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$billingEnabled = function (_v0) {
	var forPractice = _v0;
	return forPractice.GF;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$chargePhiDetailsEnabled = function (_v0) {
	var forPractice = _v0;
	return forPractice.Nx;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$chargeRouteToRecurringInvoice = function (_v0) {
	var forPractice = _v0;
	return forPractice.GX;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$hideSponsorInvoices = function (_v0) {
	var forPractice = _v0;
	return forPractice.Ts;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoIssue = function (_v0) {
	var forPractice = _v0;
	return forPractice.Ul;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoIssueDay = function (_v0) {
	var forPractice = _v0;
	return forPractice.Um;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoIssueMonth = function (_v0) {
	var forPractice = _v0;
	return forPractice.Ic;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoPay = function (_v0) {
	var forPractice = _v0;
	return forPractice.Un;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoPayDay = function (_v0) {
	var forPractice = _v0;
	return forPractice.Id;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoPayMonth = function (_v0) {
	var forPractice = _v0;
	return forPractice.Ie;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoSend = function (_v0) {
	var forPractice = _v0;
	return forPractice.Uo;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoSendDay = function (_v0) {
	var forPractice = _v0;
	return forPractice.Up;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoSendMonth = function (_v0) {
	var forPractice = _v0;
	return forPractice.If;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceDueDay = function (_v0) {
	var forPractice = _v0;
	return forPractice.Ur;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceDueMonth = function (_v0) {
	var forPractice = _v0;
	return forPractice.Ig;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceGracePeriodDays = function (_v0) {
	var forPractice = _v0;
	return forPractice.Ih;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceUpcomingAutoSend = function (_v0) {
	var forPractice = _v0;
	return forPractice.Ii;
};
var $author$project$Pages$Admin$InvoiceSettings$initFormFields = function (companyInvoiceSetting) {
	return _Utils_Tuple2(
		{
			GF: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$billingEnabled(companyInvoiceSetting),
			Nx: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$chargePhiDetailsEnabled(companyInvoiceSetting),
			GX: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$chargeRouteToRecurringInvoice(companyInvoiceSetting),
			Ts: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$hideSponsorInvoices(companyInvoiceSetting),
			Ul: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoIssue(companyInvoiceSetting),
			Um: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoIssueDay(companyInvoiceSetting),
			Ic: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoIssueMonth(companyInvoiceSetting),
			Un: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoPay(companyInvoiceSetting),
			Id: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoPayDay(companyInvoiceSetting),
			Ie: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoPayMonth(companyInvoiceSetting),
			Uo: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoSend(companyInvoiceSetting),
			Up: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoSendDay(companyInvoiceSetting),
			If: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoSendMonth(companyInvoiceSetting),
			Ur: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceDueDay(companyInvoiceSetting),
			Ig: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceDueMonth(companyInvoiceSetting),
			Ih: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceGracePeriodDays(companyInvoiceSetting),
			Ii: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceUpcomingAutoSend(companyInvoiceSetting)
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Api$Provider$PaymentSourceSetting$ForPractice$acceptsAch = function (_v0) {
	var forPractice = _v0;
	return forPractice.KA;
};
var $author$project$Api$Provider$PaymentSourceSetting$ForPractice$acceptsAmex = function (_v0) {
	var forPractice = _v0;
	return forPractice.KB;
};
var $author$project$Api$Provider$PaymentSourceSetting$ForPractice$acceptsCards = function (_v0) {
	var forPractice = _v0;
	return forPractice.KC;
};
var $author$project$Pages$Admin$InvoiceSettings$initPaymentFormFields = function (paymentSourceSetting) {
	return {
		KA: $author$project$Api$Provider$PaymentSourceSetting$ForPractice$acceptsAch(paymentSourceSetting),
		KB: $author$project$Api$Provider$PaymentSourceSetting$ForPractice$acceptsAmex(paymentSourceSetting),
		KC: $author$project$Api$Provider$PaymentSourceSetting$ForPractice$acceptsCards(paymentSourceSetting)
	};
};
var $author$project$Pages$Admin$InvoiceSettings$paymentFormFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var bool = field.a;
				return _Utils_update(
					fields,
					{KA: bool});
			case 1:
				var bool = field.a;
				return _Utils_update(
					fields,
					{KB: bool, KC: bool});
			default:
				var bool = field.a;
				return _Utils_update(
					fields,
					{KB: bool});
		}
	});
var $author$project$Pages$Admin$InvoiceSettings$AcceptsAmexValidation = 0;
var $author$project$Pages$Admin$InvoiceSettings$sponsorAcceptsAllCards = function (form) {
	return !((!form.KC) && form.KB);
};
var $author$project$Pages$Admin$InvoiceSettings$acceptsAmexValidator = A2(
	$rtfeldman$elm_validate$Validate$ifFalse,
	$author$project$Pages$Admin$InvoiceSettings$sponsorAcceptsAllCards,
	_Utils_Tuple2(0, 'If the sponsor does not accept cards they cannot accept Amex'));
var $author$project$Pages$Admin$InvoiceSettings$paymentFormFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[$author$project$Pages$Admin$InvoiceSettings$acceptsAmexValidator]));
var $author$project$Pages$Admin$InvoiceSettings$CompanyInvoiceSettingUpdated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString = function (option) {
	switch (option) {
		case 0:
			return 'month_before';
		case 1:
			return 'month_of_the_invoice';
		default:
			return 'month_after';
	}
};
var $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$encoder = function (monthOption) {
	return $elm$json$Json$Encode$string(
		$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(monthOption));
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$update = F4(
	function (apiClient, id, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'company_invoice_setting',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'invoice_upcoming_auto_send',
								$elm$json$Json$Encode$bool(fields.Ii)),
								_Utils_Tuple2(
								'invoice_auto_send',
								$elm$json$Json$Encode$bool(fields.Uo)),
								_Utils_Tuple2(
								'invoice_auto_send_day',
								$elm$json$Json$Encode$int(fields.Up)),
								_Utils_Tuple2(
								'invoice_auto_send_month',
								$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$encoder(fields.If)),
								_Utils_Tuple2(
								'invoice_auto_issue',
								$elm$json$Json$Encode$bool(fields.Ul)),
								_Utils_Tuple2(
								'invoice_auto_issue_day',
								$elm$json$Json$Encode$int(fields.Um)),
								_Utils_Tuple2(
								'invoice_auto_issue_month',
								$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$encoder(fields.Ic)),
								_Utils_Tuple2(
								'invoice_due_day',
								$elm$json$Json$Encode$int(fields.Ur)),
								_Utils_Tuple2(
								'invoice_due_month',
								$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$encoder(fields.Ig)),
								_Utils_Tuple2(
								'invoice_auto_pay',
								$elm$json$Json$Encode$bool(fields.Un)),
								_Utils_Tuple2(
								'invoice_auto_pay_day',
								$elm$json$Json$Encode$int(fields.Id)),
								_Utils_Tuple2(
								'invoice_auto_pay_month',
								$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$encoder(fields.Ie)),
								_Utils_Tuple2(
								'invoice_grace_period_days',
								$elm$json$Json$Encode$int(fields.Ih)),
								_Utils_Tuple2(
								'charge_phi_details_enabled',
								$elm$json$Json$Encode$bool(fields.Nx)),
								_Utils_Tuple2(
								'charge_route_to_recurring_invoice',
								$elm$json$Json$Encode$bool(fields.GX)),
								_Utils_Tuple2(
								'billing_enabled',
								$elm$json$Json$Encode$bool(fields.GF)),
								_Utils_Tuple2(
								'hide_sponsor_invoices',
								$elm$json$Json$Encode$bool(fields.Ts))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$CompanyInvoiceSetting$Shared$companyInvoiceSettingPath(id))));
	});
var $author$project$Pages$Admin$InvoiceSettings$updateCompanyInvoiceSetting = F3(
	function (apiClient, id, formFields) {
		var validated = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var flattenedForm = {GF: validated.GF, Nx: validated.Nx, GX: validated.GX, Ts: validated.Ts, Ul: validated.Ul, Um: validated.Um, Ic: validated.Ic, Un: validated.Un, Id: validated.Id, Ie: validated.Ie, Uo: validated.Uo, Up: validated.Up, If: validated.If, Ur: validated.Ur, Ig: validated.Ig, Ih: validated.Ih, Ii: validated.Ii};
		return A4($author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$update, apiClient, id, flattenedForm, $author$project$Pages$Admin$InvoiceSettings$CompanyInvoiceSettingUpdated);
	});
var $author$project$Pages$Admin$InvoiceSettings$PaymentSourceSettingUpdated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$PaymentSourceSetting$ForPractice$update = F4(
	function (apiClient, id, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'payment_source_setting',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'accepts_ach',
								$elm$json$Json$Encode$bool(fields.KA)),
								_Utils_Tuple2(
								'accepts_cards',
								$elm$json$Json$Encode$bool(fields.KC)),
								_Utils_Tuple2(
								'accepts_amex',
								$elm$json$Json$Encode$bool(fields.KB))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$PaymentSourceSetting$ForPractice$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$PaymentSourceSetting$Shared$paymentSourceSettingPath(id))));
	});
var $author$project$Pages$Admin$InvoiceSettings$updatePaymentSourceSetting = F3(
	function (apiClient, id, formFields) {
		return A4(
			$author$project$Api$Provider$PaymentSourceSetting$ForPractice$update,
			apiClient,
			id,
			$rtfeldman$elm_validate$Validate$fromValid(formFields),
			$author$project$Pages$Admin$InvoiceSettings$PaymentSourceSettingUpdated);
	});
var $author$project$Pages$Admin$InvoiceSettings$submitCompanyInvoiceAndPaymentSetting = function (model) {
	var _v0 = _Utils_Tuple2(model.SD, model.be);
	if (!_v0.a.$) {
		if (_v0.b.$ === 1) {
			var form = _v0.a.a;
			var _v1 = _v0.b;
			var _v2 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$InvoiceSettings$formFieldsValidator, form);
			if (!_v2.$) {
				var _v3 = _v2.a;
				var newForm = _v3.a;
				var validFormFields = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							Oe: $author$project$Api$Data$Loading,
							SD: $elm$core$Maybe$Just(newForm)
						}),
					A3($author$project$Pages$Admin$InvoiceSettings$updateCompanyInvoiceSetting, model.Gv, model.ahP, validFormFields),
					_List_Nil);
			} else {
				var newForm = _v2.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							SD: $elm$core$Maybe$Just(newForm)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			}
		} else {
			var form = _v0.a.a;
			var paymentForm = _v0.b.a;
			var _v4 = _Utils_Tuple2(
				A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$InvoiceSettings$formFieldsValidator, form),
				A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$InvoiceSettings$paymentFormFieldsValidator, paymentForm));
			if (!_v4.a.$) {
				if (!_v4.b.$) {
					var _v5 = _v4.a.a;
					var newForm = _v5.a;
					var validFormFields = _v5.b;
					var _v6 = _v4.b.a;
					var newPaymentForm = _v6.a;
					var validPaymentFormFields = _v6.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Oe: $author$project$Api$Data$Loading,
								SD: $elm$core$Maybe$Just(newForm),
								be: $elm$core$Maybe$Just(newPaymentForm),
								Zh: $author$project$Api$Data$Loading
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A3($author$project$Pages$Admin$InvoiceSettings$updateCompanyInvoiceSetting, model.Gv, model.ahP, validFormFields),
									A3($author$project$Pages$Admin$InvoiceSettings$updatePaymentSourceSetting, model.Gv, model.tL, validPaymentFormFields)
								])),
						_List_Nil);
				} else {
					var _v7 = _v4.a.a;
					var newForm = _v7.a;
					var validFormFields = _v7.b;
					var newPaymentForm = _v4.b.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Oe: $author$project$Api$Data$Loading,
								SD: $elm$core$Maybe$Just(newForm),
								be: $elm$core$Maybe$Just(newPaymentForm)
							}),
						A3($author$project$Pages$Admin$InvoiceSettings$updateCompanyInvoiceSetting, model.Gv, model.ahP, validFormFields),
						_List_Nil);
				}
			} else {
				if (!_v4.b.$) {
					var newForm = _v4.a.a;
					var _v8 = _v4.b.a;
					var newPaymentForm = _v8.a;
					var validPaymentFormFields = _v8.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								SD: $elm$core$Maybe$Just(newForm),
								be: $elm$core$Maybe$Just(newPaymentForm),
								Zh: $author$project$Api$Data$Loading
							}),
						A3($author$project$Pages$Admin$InvoiceSettings$updatePaymentSourceSetting, model.Gv, model.tL, validPaymentFormFields),
						_List_Nil);
				} else {
					var newForm = _v4.a.a;
					var newPaymentForm = _v4.b.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								SD: $elm$core$Maybe$Just(newForm),
								be: $elm$core$Maybe$Just(newPaymentForm)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			}
		}
	} else {
		if (!_v0.b.$) {
			var _v9 = _v0.a;
			var paymentForm = _v0.b.a;
			var _v10 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$InvoiceSettings$paymentFormFieldsValidator, paymentForm);
			if (!_v10.$) {
				var _v11 = _v10.a;
				var newForm = _v11.a;
				var validFormFields = _v11.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							be: $elm$core$Maybe$Just(newForm),
							Zh: $author$project$Api$Data$Loading
						}),
					A3($author$project$Pages$Admin$InvoiceSettings$updatePaymentSourceSetting, model.Gv, model.tL, validFormFields),
					_List_Nil);
			} else {
				var newForm = _v10.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							be: $elm$core$Maybe$Just(newForm)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			}
		} else {
			var _v12 = _v0.a;
			return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	}
};
var $author$project$Pages$Admin$InvoiceSettings$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var companyInvoiceSetting = response.a;
					var _v2 = $author$project$Pages$Admin$InvoiceSettings$initFormFields(companyInvoiceSetting);
					var fields = _v2.a;
					var cmd = _v2.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Oe: response,
								SD: $elm$core$Maybe$Just(
									$author$project$Utils$Form$init(fields))
							}),
						cmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Oe: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var response = msg.a;
				if (response.$ === 3) {
					var paymentSourceSetting = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								be: $elm$core$Maybe$Just(
									$author$project$Utils$Form$init(
										$author$project$Pages$Admin$InvoiceSettings$initPaymentFormFields(paymentSourceSetting))),
								Zh: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Zh: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					var companyInvoiceSetting = response.a;
					var _v5 = $author$project$Pages$Admin$InvoiceSettings$initFormFields(companyInvoiceSetting);
					var fields = _v5.a;
					var cmd = _v5.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Oe: response,
								SD: $elm$core$Maybe$Just(
									$author$project$Utils$Form$init(fields))
							}),
						cmd,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Invoice settings updated')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Oe: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					var paymentSourceSetting = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								be: $elm$core$Maybe$Just(
									$author$project$Utils$Form$init(
										$author$project$Pages$Admin$InvoiceSettings$initPaymentFormFields(paymentSourceSetting))),
								Zh: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Payment options settings updated')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Zh: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 2:
				var field = msg.a;
				var _v7 = model.SD;
				if (!_v7.$) {
					var form = _v7.a;
					return function (newForm) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									SD: $elm$core$Maybe$Just(newForm)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}(
						$author$project$Utils$Form$fromValidateResult(
							A2(
								$author$project$Utils$Form$validate,
								$author$project$Pages$Admin$InvoiceSettings$formFieldsValidator,
								A3($author$project$Utils$Form$update, $author$project$Pages$Admin$InvoiceSettings$formFieldsUpdate, field, form))));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var field = msg.a;
				var _v8 = model.be;
				if (!_v8.$) {
					var form = _v8.a;
					return function (newForm) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									be: $elm$core$Maybe$Just(newForm)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}(
						A3($author$project$Utils$Form$update, $author$project$Pages$Admin$InvoiceSettings$paymentFormFieldsUpdate, field, form));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{jQ: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var confirmed = msg.a;
				return confirmed ? $author$project$Pages$Admin$InvoiceSettings$submitCompanyInvoiceAndPaymentSetting(
					_Utils_update(
						model,
						{jQ: false})) : _Utils_Tuple3(
					_Utils_update(
						model,
						{jQ: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
		}
	});
var $author$project$Pages$Admin$InvoiceSettings$HiConfirmOpened = {$: 6};
var $author$project$Ui$Link$ButtonSecondary = 3;
var $author$project$Ui$Link$buttonSecondary = $author$project$Ui$Link$Style(3);
var $author$project$Api$Feature$DisableSponsorBilling = 7;
var $author$project$Api$FeatureGate$SponsorAdHocInvoices = 3;
var $author$project$Pages$Admin$InvoiceSettings$ChargeRouteToRecurringInvoice = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Grid$offsetMd = $author$project$Ui$Grid$Offset(2);
var $author$project$Pages$Admin$InvoiceSettings$viewChargeRouteToRecurringInvoice = function (fields) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				$author$project$Ui$Typography$headingSm(
				_List_fromArray(
					[
						$elm$html$Html$text('Add Service Charges to Membership Invoices')
					])),
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(6)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('When point-of-care service charges are paid for by the employer, '),
										$elm$html$Html$text('automatically add these charges to the employer\'s next draft membership invoice. If this setting is disabled, '),
										$elm$html$Html$text('service charges will be added to a separate service invoice.')
									]))
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(6)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$row,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Grid$column,
												_List_fromArray(
													[
														$author$project$Ui$Grid$offsetMd(9),
														$author$project$Ui$Grid$spanMd(3),
														$author$project$Ui$Grid$justifyRight
													]),
												_List_fromArray(
													[
														$author$project$Ui$ToggleSwitch$view(
														_List_fromArray(
															[
																$author$project$Ui$ToggleSwitch$on(fields.GX),
																$author$project$Ui$ToggleSwitch$onChange(
																A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$ChargeRouteToRecurringInvoice))
															]))
													]))
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Admin$InvoiceSettings$BillingEnabled = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Admin$InvoiceSettings$viewEnableBillingToggle = F2(
	function (isHintAdmin, form) {
		var fields = $author$project$Utils$Form$fields(form);
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$justifyRight]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$view(
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$on(fields.GF),
										$author$project$Ui$ToggleSwitch$disabled(!isHintAdmin),
										$author$project$Ui$ToggleSwitch$onChange(
										A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$BillingEnabled))
									]))
							]))
					]))
			]);
	});
var $author$project$Pages$Admin$InvoiceSettings$viewEnableBilling = F2(
	function (isHintAdmin, form) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Billing (Hinter only)')
						])),
					A2(
					$author$project$Ui$Grid$row,
					_List_fromArray(
						[$author$project$Ui$Grid$mb4]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanMd(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('We will bill sponsors when this setting is enabled. When this setting is disabled, we will not bill sponsors, but are still tracking employee eligibility')
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanMd(6)
								]),
							A2($author$project$Pages$Admin$InvoiceSettings$viewEnableBillingToggle, isHintAdmin, form))
						])),
					$author$project$Ui$HorizontalRule$view(_List_Nil)
				]));
	});
var $author$project$Pages$Admin$InvoiceSettings$HideSponsorInvoices = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Admin$InvoiceSettings$viewHideSponsorInvoicesToggle = F2(
	function (isHintAdmin, form) {
		var fields = $author$project$Utils$Form$fields(form);
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$justifyRight]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$view(
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$on(fields.Ts),
										$author$project$Ui$ToggleSwitch$disabled(!isHintAdmin),
										$author$project$Ui$ToggleSwitch$onChange(
										A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$HideSponsorInvoices))
									]))
							]))
					]))
			]);
	});
var $author$project$Pages$Admin$InvoiceSettings$viewHideSponsorInvoices = F2(
	function (isHintAdmin, form) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Hide Sponsor Invoice Tab (Hinter only)')
						])),
					A2(
					$author$project$Ui$Grid$row,
					_List_fromArray(
						[$author$project$Ui$Grid$mb4]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanMd(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('When billing is disabled for sponsors, the Invoices tab will be hidden in the employer portal.')
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanMd(6)
								]),
							A2($author$project$Pages$Admin$InvoiceSettings$viewHideSponsorInvoicesToggle, isHintAdmin, form))
						])),
					$author$project$Ui$HorizontalRule$view(_List_Nil)
				]));
	});
var $author$project$Pages$Admin$InvoiceSettings$ChargePhiDetailsEnabled = function (a) {
	return {$: 13, a: a};
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$chargePhiDetailsUpdatedAt = function (_v0) {
	var forPractice = _v0;
	return forPractice.Ny;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$chargePhiDetailsUpdatedBy = function (_v0) {
	var forPractice = _v0;
	return forPractice.Nz;
};
var $author$project$Api$Provider$User$Min$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Pages$Admin$InvoiceSettings$viewIncludeChargeDetails = F3(
	function (fields, model, sponsorized) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Include Full Charge Details')
						])),
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanMd(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Allow the '),
											$elm$html$Html$text(sponsorized),
											$elm$html$Html$text(' to see full charge details and patient names when viewing or downloading the invoice. '),
											$elm$html$Html$text('Since these details may contain protected health information, this setting is off by default.')
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanMd(6)
								]),
							_List_fromArray(
								[
									function () {
									var _v0 = $author$project$Api$Data$toMaybe(model.Oe);
									if (!_v0.$) {
										var companyInvoiceSetting = _v0.a;
										var _v1 = $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$chargePhiDetailsUpdatedAt(companyInvoiceSetting);
										if (!_v1.$) {
											var chargePhiDetailsUpdatedAt = _v1.a;
											return A2(
												$author$project$Ui$Grid$row,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Grid$column,
														_List_fromArray(
															[
																$author$project$Ui$Grid$spanMd(12)
															]),
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Typography$p,
																_List_fromArray(
																	[
																		$author$project$Ui$Typography$muted,
																		$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Updated by '),
																		$elm$html$Html$text(
																		A2(
																			$elm$core$Maybe$withDefault,
																			'N/A',
																			A2(
																				$elm$core$Maybe$map,
																				$author$project$Api$Provider$User$Min$name,
																				$author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$chargePhiDetailsUpdatedBy(companyInvoiceSetting)))),
																		$elm$html$Html$text(' on '),
																		$elm$html$Html$text(
																		A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, chargePhiDetailsUpdatedAt))
																	]))
															]))
													]));
										} else {
											return $author$project$Utils$Html$empty;
										}
									} else {
										return $author$project$Utils$Html$empty;
									}
								}(),
									A2(
									$author$project$Ui$Grid$row,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[$author$project$Ui$Grid$justifyRight]),
											_List_fromArray(
												[
													$author$project$Ui$ToggleSwitch$view(
													_List_fromArray(
														[
															$author$project$Ui$ToggleSwitch$on(fields.Nx),
															$author$project$Ui$ToggleSwitch$onChange(
															A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$ChargePhiDetailsEnabled))
														]))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoPay = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoPayDay = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoPayMonth = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Admin$InvoiceSettings$daysOfMonth = A2($elm$core$List$range, 1, 31);
var $author$project$Formatters$Int$ordinal = function (_int) {
	var ordinalSuffix = function (n) {
		var n_ = $elm$core$Basics$abs(n);
		if (((A2($elm$core$Basics$modBy, 100, n_) / 10) | 0) === 1) {
			return 'th';
		} else {
			var _v0 = A2($elm$core$Basics$modBy, 10, n_);
			switch (_v0) {
				case 1:
					return 'st';
				case 2:
					return 'nd';
				case 3:
					return 'rd';
				default:
					return 'th';
			}
		}
	};
	return _Utils_ap(
		$elm$core$String$fromInt(_int),
		ordinalSuffix(_int));
};
var $author$project$Pages$Admin$InvoiceSettings$invoiceAutoSendDayOptions = A2(
	$elm$core$List$map,
	function (day) {
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(
				$elm$core$String$fromInt(day)),
			$author$project$Formatters$Int$ordinal(day));
	},
	$author$project$Pages$Admin$InvoiceSettings$daysOfMonth);
var $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$enumerate = _List_fromArray(
	[0, 1, 2]);
var $author$project$Pages$Admin$InvoiceSettings$monthOptions = A2(
	$elm$core$List$map,
	function (option) {
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(
				$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(option)),
			$author$project$Formatters$String$humanize(
				$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(option)));
	},
	$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$enumerate);
var $author$project$Pages$Admin$InvoiceSettings$viewErrorRow = function (message) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'padding-top', '10px')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(12)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[
										$author$project$Ui$Typography$danger,
										$author$project$Ui$Typography$small,
										$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(message)
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Admin$InvoiceSettings$viewInvoiceAutoPayDate = F3(
	function (fields, form, sponsorized) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Scheduled Autopay Date')
						])),
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanMd(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Payment for the full amount of all issued invoices will be automatically attempted on the specified date. ' + ('Payments will not be processed for non-issued invoices. This date is visible to the  ' + (sponsorized + '.')))
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanMd(6)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Grid$row,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Grid$column,
													_List_fromArray(
														[
															$author$project$Ui$Grid$offsetMd(1),
															$author$project$Ui$Grid$spanMd(5)
														]),
													_List_fromArray(
														[
															fields.Un ? A2(
															$author$project$Ui$Form$Select$view,
															_List_fromArray(
																[
																	$author$project$Ui$Form$Select$value(
																	$elm$core$Maybe$Just(
																		$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(fields.Ie))),
																	$author$project$Ui$Form$Select$onChange(
																	A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoPayMonth)),
																	$author$project$Ui$Form$Select$invalid(
																	A2($author$project$Utils$Form$hasValidationErrors, 1, form))
																]),
															$author$project$Pages$Admin$InvoiceSettings$monthOptions) : $author$project$Utils$Html$empty
														])),
													A2(
													$author$project$Ui$Grid$column,
													_List_fromArray(
														[
															$author$project$Ui$Grid$spanMd(3)
														]),
													_List_fromArray(
														[
															fields.Un ? A2(
															$author$project$Ui$Form$Select$view,
															_List_fromArray(
																[
																	$author$project$Ui$Form$Select$value(
																	$elm$core$Maybe$Just(
																		$elm$core$String$fromInt(fields.Id))),
																	$author$project$Ui$Form$Select$onChange(
																	A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoPayDay)),
																	$author$project$Ui$Form$Select$invalid(
																	A2($author$project$Utils$Form$hasValidationErrors, 1, form))
																]),
															$author$project$Pages$Admin$InvoiceSettings$invoiceAutoSendDayOptions) : $author$project$Utils$Html$empty
														])),
													A2(
													$author$project$Ui$Grid$column,
													_List_fromArray(
														[
															$author$project$Ui$Grid$spanMd(3)
														]),
													_List_fromArray(
														[
															$author$project$Ui$ToggleSwitch$view(
															_List_fromArray(
																[
																	$author$project$Ui$ToggleSwitch$on(fields.Un),
																	$author$project$Ui$ToggleSwitch$onChange(
																	A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoPay))
																]))
														]))
												])),
											A2($author$project$Utils$Form$hasValidationErrors, 1, form) ? A2(
											$elm$html$Html$div,
											_List_Nil,
											A2(
												$elm$core$List$map,
												$author$project$Pages$Admin$InvoiceSettings$viewErrorRow,
												A2($author$project$Utils$Form$validationErrors, 1, form))) : $author$project$Utils$Html$empty
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoSend = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoSendDay = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoSendMonth = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Admin$InvoiceSettings$viewInvoiceCreated = F2(
	function (fields, sponsorized) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Notification: Invoice Created')
						])),
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanMd(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Sent to '),
											$elm$html$Html$text(
											$author$project$Formatters$String$pluralOf(sponsorized)),
											$elm$html$Html$text(' on the specified day. Invoices can be sent regardless'),
											$elm$html$Html$text(' of whether they are still in draft or have been issued.')
										])),
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Admin__Notifications__Company,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('View and customize the notification')
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanMd(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$row,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$offsetMd(1),
													$author$project$Ui$Grid$spanMd(5)
												]),
											_List_fromArray(
												[
													fields.Uo ? A2(
													$author$project$Ui$Form$Select$view,
													_List_fromArray(
														[
															$author$project$Ui$Form$Select$value(
															$elm$core$Maybe$Just(
																$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(fields.If))),
															$author$project$Ui$Form$Select$onChange(
															A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoSendMonth))
														]),
													$author$project$Pages$Admin$InvoiceSettings$monthOptions) : $author$project$Utils$Html$empty
												])),
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$spanMd(3)
												]),
											_List_fromArray(
												[
													fields.Uo ? A2(
													$author$project$Ui$Form$Select$view,
													_List_fromArray(
														[
															$author$project$Ui$Form$Select$value(
															$elm$core$Maybe$Just(
																$elm$core$String$fromInt(fields.Up))),
															$author$project$Ui$Form$Select$onChange(
															A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoSendDay))
														]),
													$author$project$Pages$Admin$InvoiceSettings$invoiceAutoSendDayOptions) : $author$project$Utils$Html$empty
												])),
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$spanMd(3)
												]),
											_List_fromArray(
												[
													$author$project$Ui$ToggleSwitch$view(
													_List_fromArray(
														[
															$author$project$Ui$ToggleSwitch$on(fields.Uo),
															$author$project$Ui$ToggleSwitch$onChange(
															A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoSend))
														]))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$InvoiceSettings$InvoiceDueDay = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Admin$InvoiceSettings$InvoiceDueMonth = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Admin$InvoiceSettings$invoiceDueDayOptions = $author$project$Pages$Admin$InvoiceSettings$invoiceAutoSendDayOptions;
var $author$project$Pages$Admin$InvoiceSettings$viewInvoiceDueDate = F3(
	function (fields, form, sponsorized) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Due Date')
						])),
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanMd(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('The day when the invoice is considered \"due\". This date is visible to the ' + (sponsorized + ' and printed on the invoice.'))
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanMd(6)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Grid$row,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Grid$column,
													_List_fromArray(
														[
															$author$project$Ui$Grid$offsetMd(4),
															$author$project$Ui$Grid$spanMd(5)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Form$Select$view,
															_List_fromArray(
																[
																	$author$project$Ui$Form$Select$value(
																	$elm$core$Maybe$Just(
																		$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(fields.Ig))),
																	$author$project$Ui$Form$Select$onChange(
																	A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$InvoiceDueMonth)),
																	$author$project$Ui$Form$Select$invalid(
																	A2($author$project$Utils$Form$hasValidationErrors, 2, form))
																]),
															$author$project$Pages$Admin$InvoiceSettings$monthOptions)
														])),
													A2(
													$author$project$Ui$Grid$column,
													_List_fromArray(
														[
															$author$project$Ui$Grid$spanMd(3)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Form$Select$view,
															_List_fromArray(
																[
																	$author$project$Ui$Form$Select$value(
																	$elm$core$Maybe$Just(
																		$elm$core$String$fromInt(fields.Ur))),
																	$author$project$Ui$Form$Select$onChange(
																	A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$InvoiceDueDay)),
																	$author$project$Ui$Form$Select$invalid(
																	A2($author$project$Utils$Form$hasValidationErrors, 2, form))
																]),
															$author$project$Pages$Admin$InvoiceSettings$invoiceDueDayOptions)
														]))
												])),
											A2($author$project$Utils$Form$hasValidationErrors, 2, form) ? A2(
											$elm$html$Html$div,
											_List_Nil,
											A2(
												$elm$core$List$map,
												$author$project$Pages$Admin$InvoiceSettings$viewErrorRow,
												A2($author$project$Utils$Form$validationErrors, 2, form))) : $author$project$Utils$Html$empty
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$InvoiceSettings$InvoiceGracePeriodDays = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Admin$InvoiceSettings$viewInvoiceGracePeriod = function (fields) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Typography$headingSm(
				_List_fromArray(
					[
						$elm$html$Html$text('Grace Period')
					])),
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(6)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('If the invoice is not yet paid after the grace period passes, '),
										$elm$html$Html$text('each employee\'s membership status will be set to \"unpaid\" '),
										$elm$html$Html$text('and the invoice will be considered \"overdue\". The grace period starts after the due date.')
									]))
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(6)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$row,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Grid$column,
												_List_fromArray(
													[
														$author$project$Ui$Grid$offsetMd(6),
														$author$project$Ui$Grid$spanMd(6)
													]),
												_List_fromArray(
													[
														$author$project$Ui$Form$Input$group(
														A2(
															$author$project$Ui$Form$Input$withPreAddon,
															'# of days',
															_List_fromArray(
																[
																	$author$project$Ui$Form$Input$value(
																	$elm$core$String$fromInt(fields.Ih)),
																	$author$project$Ui$Form$Input$onInput(
																	A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$InvoiceGracePeriodDays))
																])))
													]))
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoIssue = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoIssueDay = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoIssueMonth = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Admin$InvoiceSettings$invoiceAutoIssueDayOptions = $author$project$Pages$Admin$InvoiceSettings$invoiceAutoSendDayOptions;
var $author$project$Pages$Admin$InvoiceSettings$viewInvoiceIssueDate = F3(
	function (fields, form, sponsorized) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Scheduled Issue Date')
						])),
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanMd(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											'Invoices will be automatically issued on the specified date, locking charges in place and preventing ' + ($author$project$Formatters$String$pluralOf(sponsorized) + (' from making any changes. Once issued, ' + (sponsorized + ' can pay invoices manually, or invoices will be automatically processed based on the Scheduled Autopay Date settings.'))))
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanMd(6)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Grid$row,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Grid$column,
													_List_fromArray(
														[
															$author$project$Ui$Grid$offsetMd(1),
															$author$project$Ui$Grid$spanMd(5)
														]),
													_List_fromArray(
														[
															fields.Ul ? A2(
															$author$project$Ui$Form$Select$view,
															_List_fromArray(
																[
																	$author$project$Ui$Form$Select$value(
																	$elm$core$Maybe$Just(
																		$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(fields.Ic))),
																	$author$project$Ui$Form$Select$onChange(
																	A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoIssueMonth)),
																	$author$project$Ui$Form$Select$invalid(
																	A2($author$project$Utils$Form$hasValidationErrors, 0, form))
																]),
															$author$project$Pages$Admin$InvoiceSettings$monthOptions) : $author$project$Utils$Html$empty
														])),
													A2(
													$author$project$Ui$Grid$column,
													_List_fromArray(
														[
															$author$project$Ui$Grid$spanMd(3)
														]),
													_List_fromArray(
														[
															fields.Ul ? A2(
															$author$project$Ui$Form$Select$view,
															_List_fromArray(
																[
																	$author$project$Ui$Form$Select$value(
																	$elm$core$Maybe$Just(
																		$elm$core$String$fromInt(fields.Um))),
																	$author$project$Ui$Form$Select$onChange(
																	A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoIssueDay)),
																	$author$project$Ui$Form$Select$invalid(
																	A2($author$project$Utils$Form$hasValidationErrors, 0, form))
																]),
															$author$project$Pages$Admin$InvoiceSettings$invoiceAutoIssueDayOptions) : $author$project$Utils$Html$empty
														])),
													A2(
													$author$project$Ui$Grid$column,
													_List_fromArray(
														[
															$author$project$Ui$Grid$spanMd(3)
														]),
													_List_fromArray(
														[
															$author$project$Ui$ToggleSwitch$view(
															_List_fromArray(
																[
																	$author$project$Ui$ToggleSwitch$on(fields.Ul),
																	$author$project$Ui$ToggleSwitch$onChange(
																	A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoIssue))
																]))
														]))
												])),
											A2($author$project$Utils$Form$hasValidationErrors, 0, form) ? A2(
											$elm$html$Html$div,
											_List_Nil,
											A2(
												$elm$core$List$map,
												$author$project$Pages$Admin$InvoiceSettings$viewErrorRow,
												A2($author$project$Utils$Form$validationErrors, 0, form))) : $author$project$Utils$Html$empty
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$InvoiceSettings$InvoiceUpcomingAutoSend = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$InvoiceSettings$viewInvoiceUpcoming = F3(
	function (fields, form, sponsorized) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Notification: Invoice Upcoming')
						])),
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanMd(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Sent to '),
											$elm$html$Html$text(
											$author$project$Formatters$String$pluralOf(sponsorized)),
											$elm$html$Html$text(' to let them know when to expect an invoice. '),
											$elm$html$Html$text('This notification is sent 1 week prior to the “Invoice Created” notification')
										])),
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Admin__Notifications__Company,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('View and customize the notification')
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanMd(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$row,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$offsetMd(9),
													$author$project$Ui$Grid$spanMd(3),
													$author$project$Ui$Grid$justifyRight
												]),
											_List_fromArray(
												[
													$author$project$Ui$ToggleSwitch$view(
													_List_fromArray(
														[
															$author$project$Ui$ToggleSwitch$on(fields.Ii),
															$author$project$Ui$ToggleSwitch$onChange(
															A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$InvoiceUpcomingAutoSend))
														]))
												]))
										])),
									A2($author$project$Utils$Form$hasValidationErrors, 3, form) ? A2(
									$elm$html$Html$div,
									_List_Nil,
									A2(
										$elm$core$List$map,
										$author$project$Pages$Admin$InvoiceSettings$viewErrorRow,
										A2($author$project$Utils$Form$validationErrors, 3, form))) : $author$project$Utils$Html$empty
								]))
						]))
				]));
	});
var $author$project$Components$InvoiceSetting$Timeline$createTimelineDate = F3(
	function (today, eventMonth, eventDay) {
		return function (date) {
			return A3(
				$justinmimbs$date$Date$fromCalendarDate,
				$justinmimbs$date$Date$year(date),
				$justinmimbs$date$Date$month(date),
				eventDay);
		}(
			A3(
				$justinmimbs$date$Date$add,
				1,
				$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toInt(eventMonth) + 1,
				today));
	});
var $author$project$Pages$Admin$InvoiceSettings$createTimelineEventAttributes = F2(
	function (form, today) {
		var createTimelineDate = $author$project$Components$InvoiceSetting$Timeline$createTimelineDate(today);
		var dueDate = A2(createTimelineDate, form.Ig, form.Ur);
		var unpaidDate = A3(
			$justinmimbs$date$Date$add,
			3,
			form.Ih,
			A2(createTimelineDate, form.Ig, form.Ur));
		var upcomingDate = A3(
			$justinmimbs$date$Date$add,
			2,
			-1,
			A2(createTimelineDate, form.If, form.Up));
		var autopayDate = A2(createTimelineDate, form.Ie, form.Id);
		var autoSendDate = A2(createTimelineDate, form.If, form.Up);
		var autoIssueDate = A2(createTimelineDate, form.Ic, form.Um);
		return _List_fromArray(
			[
				_Utils_Tuple3(form.Ii && form.Uo, upcomingDate, 'Send \"Upcoming\" email'),
				_Utils_Tuple3(form.Uo, autoSendDate, 'Send \"Created\" email'),
				_Utils_Tuple3(form.Ul, autoIssueDate, 'Issue Invoice'),
				_Utils_Tuple3(form.Un, autopayDate, 'Autopay Invoice'),
				_Utils_Tuple3(true, dueDate, 'Due Date'),
				_Utils_Tuple3(true, unpaidDate, 'Employees show as unpaid')
			]);
	});
var $author$project$Components$InvoiceSetting$Timeline$createTimelineEvent = function (_v0) {
	var eventDate = _v0.a;
	var event = _v0.b;
	return {
		G1: $elm$html$Html$text(event),
		PB: eventDate,
		af6: $elm$core$Maybe$Nothing
	};
};
var $author$project$Components$InvoiceSetting$Timeline$isEnabled = function (_v0) {
	var bool = _v0.a;
	var date = _v0.b;
	var string = _v0.c;
	return bool ? $elm$core$Maybe$Just(
		_Utils_Tuple2(date, string)) : $elm$core$Maybe$Nothing;
};
var $author$project$Components$InvoiceSetting$Timeline$createTimelineEvents = function (eventsData) {
	return A2(
		$elm$core$List$map,
		$author$project$Components$InvoiceSetting$Timeline$createTimelineEvent,
		A2($elm$core$List$filterMap, $author$project$Components$InvoiceSetting$Timeline$isEnabled, eventsData));
};
var $author$project$Ui$Timeline$Lg = {$: 1};
var $author$project$Ui$Timeline$lg = $author$project$Ui$Timeline$Lg;
var $author$project$Ui$Timeline$ASC = 0;
var $author$project$Ui$Timeline$defaultOptions = {AB: false, EI: 0, vn: false};
var $author$project$Ui$Timeline$mergeByDate = function (events) {
	return A3(
		$elm$core$List$foldr,
		F2(
			function (event, acc) {
				if (!acc.b) {
					return _List_fromArray(
						[event]);
				} else {
					var head = acc.a;
					var tail = acc.b;
					return _Utils_eq(event.PB, head.PB) ? A2(
						$elm$core$List$cons,
						_Utils_update(
							head,
							{
								G1: A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											event.G1,
											$elm$html$Html$text(', '),
											head.G1
										]))
							}),
						tail) : A2($elm$core$List$cons, event, acc);
				}
			}),
		_List_Nil,
		events);
};
var $author$project$Ui$Timeline$compareEvents = F2(
	function (event1, event2) {
		return A2($justinmimbs$date$Date$compare, event1.PB, event2.PB);
	});
var $elm$core$List$sortWith = _List_sortWith;
var $author$project$Ui$Timeline$sort = F2(
	function (s, events) {
		if (!s) {
			return A2($elm$core$List$sortWith, $author$project$Ui$Timeline$compareEvents, events);
		} else {
			return $elm$core$List$reverse(
				A2($elm$core$List$sortWith, $author$project$Ui$Timeline$compareEvents, events));
		}
	});
var $author$project$Formatters$Date$MonthAndDay = {$: 1};
var $author$project$Ui$Timeline$viewTimelineEvent = F2(
	function (isVertical, event) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('timeline__item')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('timeline__item-content')
						]),
					isVertical ? _List_fromArray(
						[event.G1]) : _List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
							function () {
								var _v0 = event.af6;
								if (!_v0.$) {
									var dateDescription = _v0.a;
									return dateDescription;
								} else {
									return A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$MonthAndDay, event.PB);
								}
							}()),
							event.G1
						]))
				]));
	});
var $author$project$Ui$Timeline$view = F2(
	function (options, events) {
		var opts = A3(
			$elm$core$List$foldl,
			F2(
				function (option, record) {
					switch (option.$) {
						case 0:
							return _Utils_update(
								record,
								{vn: true});
						case 1:
							return _Utils_update(
								record,
								{AB: true});
						default:
							var s = option.a;
							return _Utils_update(
								record,
								{EI: s});
					}
				}),
			$author$project$Ui$Timeline$defaultOptions,
			options);
		var classes = A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						$elm$core$Maybe$Just('timeline'),
						opts.vn ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('timeline--horizontal'),
						opts.AB ? $elm$core$Maybe$Just('timeline--lg') : $elm$core$Maybe$Nothing
					])));
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(classes)
				]),
			A2(
				$elm$core$List$map,
				$author$project$Ui$Timeline$viewTimelineEvent(opts.vn),
				$author$project$Ui$Timeline$mergeByDate(
					A2($author$project$Ui$Timeline$sort, opts.EI, events))));
	});
var $author$project$Pages$Admin$InvoiceSettings$viewTimeline = F2(
	function (currentDate, fields) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanMd(12)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Timeline$view,
									_List_fromArray(
										[$author$project$Ui$Timeline$lg]),
									$author$project$Components$InvoiceSetting$Timeline$createTimelineEvents(
										A2($author$project$Pages$Admin$InvoiceSettings$createTimelineEventAttributes, fields, currentDate)))
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$InvoiceSettings$viewForm = F2(
	function (model, form) {
		var sponsorized = A2($author$project$Formatters$String$sponsorize, model.ZV, 'employer');
		var fields = $author$project$Utils$Form$fields(form);
		var hideSponsorInvoicesSection = (!fields.GF) ? A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Pages$Admin$InvoiceSettings$viewHideSponsorInvoices, model.Ij, form)
				])) : $author$project$Utils$Html$empty;
		var enableBillingSection = A2($author$project$Api$Provider$Practice$One$featureEnabled, 7, model.ZV) ? (((!model.Ij) && fields.GF) ? $author$project$Utils$Html$empty : A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Pages$Admin$InvoiceSettings$viewEnableBilling, model.Ij, form)
				]))) : $author$project$Utils$Html$empty;
		return _List_fromArray(
			[
				A2($author$project$Pages$Admin$InvoiceSettings$viewTimeline, model.dd, fields),
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				enableBillingSection,
				hideSponsorInvoicesSection,
				A3($author$project$Pages$Admin$InvoiceSettings$viewInvoiceUpcoming, fields, form, sponsorized),
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				A2($author$project$Pages$Admin$InvoiceSettings$viewInvoiceCreated, fields, sponsorized),
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				A3($author$project$Pages$Admin$InvoiceSettings$viewInvoiceIssueDate, fields, form, sponsorized),
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				A3($author$project$Pages$Admin$InvoiceSettings$viewInvoiceAutoPayDate, fields, form, sponsorized),
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				A3($author$project$Pages$Admin$InvoiceSettings$viewInvoiceDueDate, fields, form, sponsorized),
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				$author$project$Pages$Admin$InvoiceSettings$viewInvoiceGracePeriod(fields),
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				A3($author$project$Pages$Admin$InvoiceSettings$viewIncludeChargeDetails, fields, model, sponsorized),
				A3(
				$author$project$Utils$FeatureGate$gate,
				3,
				$author$project$Api$Practice$Provider(model.ZV),
				$author$project$Pages$Admin$InvoiceSettings$viewChargeRouteToRecurringInvoice(fields))
			]);
	});
var $author$project$Pages$Admin$InvoiceSettings$AcceptsAch = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$InvoiceSettings$AcceptsAmex = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$InvoiceSettings$AcceptsCards = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$InvoiceSettings$PaymentFormFieldUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Typography$titleSm = F2(
	function (options, content) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$never,
			A2(
				$elm$html$Html$h5,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('text-title-sm text-main'),
					$author$project$Ui$Typography$optionsToAttributes(options)),
				content));
	});
var $author$project$Pages$Admin$InvoiceSettings$viewPaymentOptions = F3(
	function (fields, form, sponsorized) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Payment Options')
						])),
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanMd(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Choose payment options available to  ' + (sponsorized + 's.'))
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ml-1 pl-1')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanMd(6)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$titleSm,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Accept Bank Accounts')
												]))
										])),
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanMd(6)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pt-05')
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Grid$row,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Grid$column,
															_List_fromArray(
																[
																	$author$project$Ui$Grid$offsetMd(9),
																	$author$project$Ui$Grid$spanMd(3),
																	$author$project$Ui$Grid$justifyRight
																]),
															_List_fromArray(
																[
																	$author$project$Ui$ToggleSwitch$view(
																	_List_fromArray(
																		[
																			$author$project$Ui$ToggleSwitch$on(fields.KA),
																			$author$project$Ui$ToggleSwitch$onChange(
																			A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$PaymentFormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$AcceptsAch))
																		]))
																]))
														]))
												]))
										]))
								])),
							A2(
							$author$project$Ui$Grid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanMd(6)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$titleSm,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Accept Credit Cards')
												]))
										])),
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanMd(6)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pt-05')
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Grid$row,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Grid$column,
															_List_fromArray(
																[
																	$author$project$Ui$Grid$offsetMd(9),
																	$author$project$Ui$Grid$spanMd(3),
																	$author$project$Ui$Grid$justifyRight
																]),
															_List_fromArray(
																[
																	$author$project$Ui$ToggleSwitch$view(
																	_List_fromArray(
																		[
																			$author$project$Ui$ToggleSwitch$on(fields.KC),
																			$author$project$Ui$ToggleSwitch$onChange(
																			A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$PaymentFormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$AcceptsCards))
																		]))
																]))
														]))
												]))
										]))
								])),
							A2(
							$author$project$Ui$Grid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanMd(6)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$titleSm,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Accept American Express')
												]))
										])),
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanMd(6)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pt-05')
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Grid$row,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Grid$column,
															_List_fromArray(
																[
																	$author$project$Ui$Grid$offsetMd(9),
																	$author$project$Ui$Grid$spanMd(3),
																	$author$project$Ui$Grid$justifyRight
																]),
															_List_fromArray(
																[
																	$author$project$Ui$ToggleSwitch$view(
																	_List_fromArray(
																		[
																			$author$project$Ui$ToggleSwitch$on(fields.KB),
																			$author$project$Ui$ToggleSwitch$onChange(
																			A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$PaymentFormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$AcceptsAmex)),
																			$author$project$Ui$ToggleSwitch$disabled(!fields.KC)
																		]))
																]))
														])),
													A2($author$project$Utils$Form$hasValidationErrors, 0, form) ? A2(
													$elm$html$Html$div,
													_List_Nil,
													A2(
														$elm$core$List$map,
														$author$project$Pages$Admin$InvoiceSettings$viewErrorRow,
														A2($author$project$Utils$Form$validationErrors, 0, form))) : $author$project$Utils$Html$empty
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$InvoiceSettings$viewPaymentSettingsForm = F2(
	function (model, form) {
		var sponsorized = A2($author$project$Formatters$String$sponsorize, model.ZV, 'employer');
		var fields = $author$project$Utils$Form$fields(form);
		return _List_fromArray(
			[
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				A3($author$project$Pages$Admin$InvoiceSettings$viewPaymentOptions, fields, form, sponsorized)
			]);
	});
var $author$project$Pages$Admin$InvoiceSettings$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$view,
				_List_Nil,
				_List_fromArray(
					[
						model.jQ ? A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Admin$InvoiceSettings$HiConfirmClosed,
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('Confirm'),
								$author$project$Components$HiConfirm$noun('Global Settings'),
								$author$project$Components$HiConfirm$customMessage(
								_List_fromArray(
									[
										$elm$html$Html$text(
										'You are changing the global ' + (A2($author$project$Formatters$String$sponsorize, model.ZV, 'employer') + (' settings only. This will not affect any ' + (A2($author$project$Formatters$String$sponsorize, model.ZV, 'employers') + ' that have setting overrides in place.'))))
									]))
							])) : $author$project$Utils$Html$empty,
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Typography$headingSm(
										_List_fromArray(
											[
												$elm$html$Html$text('Example of Upcoming Month')
											]))
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_Nil,
										function () {
											var _v0 = model.SD;
											if (!_v0.$) {
												var form = _v0.a;
												return A2($author$project$Pages$Admin$InvoiceSettings$viewForm, model, form);
											} else {
												return _List_fromArray(
													[
														A2(
														$author$project$Ui$Element$view,
														_List_fromArray(
															[$author$project$Ui$Element$textCenter]),
														_List_fromArray(
															[
																$author$project$Ui$Spinner$view(_List_Nil)
															]))
													]);
											}
										}()),
										A2(
										$elm$html$Html$div,
										_List_Nil,
										function () {
											var _v1 = model.be;
											if (!_v1.$) {
												var form = _v1.a;
												return A2($author$project$Pages$Admin$InvoiceSettings$viewPaymentSettingsForm, model, form);
											} else {
												return _List_fromArray(
													[
														A2(
														$author$project$Ui$Element$view,
														_List_fromArray(
															[$author$project$Ui$Element$textCenter]),
														_List_fromArray(
															[
																$author$project$Ui$Spinner$view(_List_Nil)
															]))
													]);
											}
										}())
									])),
								A2(
								$author$project$Ui$Panel$footer,
								_List_fromArray(
									[$author$project$Ui$Element$justifyCenter]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Admin__Practice,
										_List_fromArray(
											[$author$project$Ui$Link$buttonSecondary]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cancel')
											])),
										function () {
										if ($author$project$Utils$Maybe$toBool(model.SD)) {
											var nonSubmittable = function () {
												var _v2 = model.SD;
												if (!_v2.$) {
													var form = _v2.a;
													return $author$project$Utils$Form$hasAnyValidationError(form);
												} else {
													return true;
												}
											}();
											return A3(
												$author$project$Ui$Button$view,
												{mm: 'Update invoice settings'},
												_List_fromArray(
													[
														$author$project$Ui$Button$primary,
														$author$project$Ui$Button$loading(
														_Utils_eq(model.Oe, $author$project$Api$Data$Loading)),
														$author$project$Ui$Button$onClick($author$project$Pages$Admin$InvoiceSettings$HiConfirmOpened),
														$author$project$Ui$Button$disabled(nonSubmittable)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Update')
													]));
										} else {
											return $author$project$Utils$Html$empty;
										}
									}()
									]))
							]))
					]))
			]),
		ac9: 'Admin | Invoice Settings'
	};
};
var $author$project$Pages$Admin$InvoiceSettings$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$InvoiceSettings$init, aiq: $author$project$Pages$Admin$InvoiceSettings$load, k8: $author$project$Pages$Admin$InvoiceSettings$save, alO: $author$project$Pages$Admin$InvoiceSettings$subscriptions, adT: $author$project$Pages$Admin$InvoiceSettings$update, amo: $author$project$Pages$Admin$InvoiceSettings$view});
var $author$project$Pages$Admin$LeadSources$GotItems = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$LeadSource$All$LeadSource = $elm$core$Basics$identity;
var $author$project$Api$Provider$LeadSource$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$LeadSource$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$LeadSource$leadSourcesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['lead_sources']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$LeadSource$listDefaults = {ahP: $elm$core$Maybe$Nothing, ajJ: $author$project$Api$Pagination$init, akl: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$LeadSource$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$LeadSource$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.akl;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.ahP;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$Provider$LeadSource$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$LeadSource$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$LeadSource$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$LeadSource$leadSourcesPath)));
	});
var $author$project$Pages$Admin$LeadSources$fetchItems = function (model) {
	return A3(
		$author$project$Api$Provider$LeadSource$list,
		model.Gv,
		function (d) {
			return _Utils_update(
				d,
				{ajJ: model.ajJ});
		},
		$author$project$Pages$Admin$LeadSources$GotItems);
};
var $author$project$Pages$Admin$LeadSources$init = F4(
	function (_v0, _v1, _v2, _v3) {
		var apiClient = _v2.Gv;
		var model = {Gv: apiClient, je: $elm$core$Maybe$Nothing, eg: $elm$core$Set$empty, Io: $elm$core$Maybe$Nothing, j4: $author$project$Api$Data$Loading, ajJ: $author$project$Api$Pagination$init, fo: _List_Nil};
		return _Utils_Tuple2(
			model,
			$author$project$Pages$Admin$LeadSources$fetchItems(model));
	});
var $author$project$Pages$Admin$LeadSources$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$LeadSources$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$LeadSources$CancelEdit = {$: 3};
var $author$project$Pages$Admin$LeadSources$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Pages$Admin$LeadSources$TranslationsInputMsg = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Pages$Admin$LeadSources$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Admin$LeadSources$CancelEdit)),
					model.Io)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$LeadSources$HiConfirmClosed),
					model.je)),
				$elm$core$Platform$Sub$batch(
				A2(
					$elm$core$List$map,
					function (input) {
						return A2(
							$elm$core$Platform$Sub$map,
							$author$project$Pages$Admin$LeadSources$TranslationsInputMsg(input.hZ),
							$author$project$Components$TranslationsInput$subscriptions(input));
					},
					model.fo))
			]));
};
var $author$project$Pages$Admin$LeadSources$Deleted = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Api$Provider$LeadSource$leadSourcePath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$LeadSource$leadSourcesPath);
};
var $author$project$Api$Provider$LeadSource$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$LeadSource$leadSourcePath(id_)));
	});
var $author$project$Api$Provider$LeadSource$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$LeadSource$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$LeadSource$Shared$name(shared);
};
var $author$project$Api$Provider$LeadSource$Shared$showOnOnlineSignup = function (_v0) {
	var record = _v0;
	return record.abn;
};
var $author$project$Api$Provider$LeadSource$All$showOnOnlineSignup = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$LeadSource$Shared$showOnOnlineSignup(shared);
};
var $author$project$Pages$Admin$LeadSources$formFieldsFromItem = function (item) {
	return {
		Bq: $author$project$Api$Provider$LeadSource$All$name(item),
		abn: $author$project$Api$Provider$LeadSource$All$showOnOnlineSignup(item)
	};
};
var $author$project$Pages$Admin$LeadSources$formFieldsInit = {Bq: '', abn: false};
var $author$project$Pages$Admin$LeadSources$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var string = field.a;
			return _Utils_update(
				fields,
				{Bq: string});
		} else {
			var bool = field.a;
			return _Utils_update(
				fields,
				{abn: bool});
		}
	});
var $author$project$Pages$Admin$LeadSources$NameValidation = 0;
var $author$project$Pages$Admin$LeadSources$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.Bq;
			},
			_Utils_Tuple2(0, 'Please enter a name.'))
		]));
var $author$project$Api$Provider$LeadSource$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$LeadSource$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$LeadSource$Shared$id(shared);
};
var $author$project$Components$TranslationsInput$LeadSource = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$TranslationsInput$leadSource = $author$project$Components$TranslationsInput$LeadSource;
var $author$project$Api$Provider$LeadSource$One$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$LeadSource$Shared$name(shared);
};
var $author$project$Pages$Admin$LeadSources$Created = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$LeadSource$One$LeadSource = $elm$core$Basics$identity;
var $author$project$Api$Provider$LeadSource$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$LeadSource$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$LeadSource$create = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'lead_source',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(fields.Bq)),
								_Utils_Tuple2(
								'show_on_online_signup',
								$elm$json$Json$Encode$bool(fields.abn))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$LeadSource$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$LeadSource$leadSourcesPath)));
	});
var $author$project$Pages$Admin$LeadSources$createItem = F2(
	function (apiClient, formFields) {
		return A3(
			$author$project$Api$Provider$LeadSource$create,
			apiClient,
			$rtfeldman$elm_validate$Validate$fromValid(formFields),
			$author$project$Pages$Admin$LeadSources$Created);
	});
var $author$project$Pages$Admin$LeadSources$Updated = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$LeadSource$update = F4(
	function (apiClient, id_, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'lead_source',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(fields.Bq)),
								_Utils_Tuple2(
								'show_on_online_signup',
								$elm$json$Json$Encode$bool(fields.abn))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$LeadSource$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$LeadSource$leadSourcePath(id_))));
	});
var $author$project$Pages$Admin$LeadSources$updateItem = F3(
	function (apiClient, id, formFields) {
		return A4(
			$author$project$Api$Provider$LeadSource$update,
			apiClient,
			id,
			$rtfeldman$elm_validate$Validate$fromValid(formFields),
			$author$project$Pages$Admin$LeadSources$Updated);
	});
var $author$project$Pages$Admin$LeadSources$saveItem = F3(
	function (apiClient, maybeId, formFields) {
		if (!maybeId.$) {
			var id_ = maybeId.a;
			return A3($author$project$Pages$Admin$LeadSources$updateItem, apiClient, id_, formFields);
		} else {
			return A2($author$project$Pages$Admin$LeadSources$createItem, apiClient, formFields);
		}
	});
var $author$project$Components$TranslationsInput$translatable = function ($) {
	return $.hZ;
};
var $author$project$Pages$Admin$LeadSources$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var items = response.a;
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								j4: response,
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ),
								fo: A2(
									$elm$core$List$map,
									function (item) {
										return $author$project$Components$TranslationsInput$init(
											$author$project$Components$TranslationsInput$leadSource(
												$author$project$Api$Provider$LeadSource$All$id(item)));
									},
									items)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{j4: response, fo: _List_Nil}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							Io: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init($author$project$Pages$Admin$LeadSources$formFieldsInit),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var item = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							Io: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(
										$author$project$Api$Provider$LeadSource$All$id(item)),
									$author$project$Utils$Form$init(
										$author$project$Pages$Admin$LeadSources$formFieldsFromItem(item)),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Io: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var field = msg.a;
				var _v2 = model.Io;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var id = _v3.a;
					var form = _v3.b;
					var item = _v3.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$LeadSources$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Io: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, item))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var form = msg.a;
				var id = msg.b;
				var _v4 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$LeadSources$formFieldsValidator, form);
				if (!_v4.$) {
					var _v5 = _v4.a;
					var newForm = _v5.a;
					var validFormFields = _v5.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Io: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, $author$project$Api$Data$Loading))
							}),
						A3($author$project$Pages$Admin$LeadSources$saveItem, model.Gv, id, validFormFields),
						_List_Nil);
				} else {
					var newForm = _v4.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Io: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 5:
				var item = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							je: $elm$core$Maybe$Just(item)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 7:
				var response = msg.a;
				var _v6 = model.Io;
				if (!_v6.$) {
					var _v7 = _v6.a;
					var id = _v7.a;
					var form = _v7.b;
					if (response.$ === 3) {
						var item = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{Io: $elm$core$Maybe$Nothing, j4: $author$project$Api$Data$Loading}),
							$author$project$Pages$Admin$LeadSources$fetchItems(model),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									'Successfully created ' + $author$project$Api$Provider$LeadSource$One$name(item))
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									Io: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 8:
				var response = msg.a;
				var _v9 = model.Io;
				if (!_v9.$) {
					var _v10 = _v9.a;
					var id = _v10.a;
					var form = _v10.b;
					if (response.$ === 3) {
						var item = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{Io: $elm$core$Maybe$Nothing, j4: $author$project$Api$Data$Loading}),
							$author$project$Pages$Admin$LeadSources$fetchItems(model),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Provider$LeadSource$One$name(item) + ' was successfully updated.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									Io: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var item = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									eg: A2(
										$elm$core$Set$remove,
										$author$project$Api$Provider$LeadSource$All$id(item),
										model.eg),
									j4: $author$project$Api$Data$Loading
								}),
							$author$project$Pages$Admin$LeadSources$fetchItems(model),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Provider$LeadSource$All$name(item) + ' was successfully removed.')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									eg: A2(
										$elm$core$Set$remove,
										$author$project$Api$Provider$LeadSource$All$id(item),
										model.eg)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 10:
				var item = msg.a;
				var confirmed = msg.b;
				if (confirmed) {
					var id = $author$project$Api$Provider$LeadSource$All$id(item);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								je: $elm$core$Maybe$Nothing,
								eg: A2($elm$core$Set$insert, id, model.eg)
							}),
						A3(
							$author$project$Api$Provider$LeadSource$delete,
							model.Gv,
							id,
							$author$project$Pages$Admin$LeadSources$Deleted(item)),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{je: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 11:
				var translatable = msg.a;
				var msg_ = msg.b;
				var maybeUpdate = A2(
					$elm$core$Maybe$map,
					A2($author$project$Components$TranslationsInput$update, model.Gv, msg_),
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (input) {
								return _Utils_eq(
									$author$project$Components$TranslationsInput$translatable(input),
									translatable);
							},
							model.fo)));
				if (maybeUpdate.$ === 1) {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				} else {
					var _v14 = maybeUpdate.a;
					var translationInput = _v14.a;
					var translationsCmd = _v14.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								fo: A2(
									$elm$core$List$map,
									function (input) {
										return _Utils_eq(
											$author$project$Components$TranslationsInput$translatable(translationInput),
											$author$project$Components$TranslationsInput$translatable(input)) ? translationInput : input;
									},
									model.fo)
							}),
						A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Pages$Admin$LeadSources$TranslationsInputMsg(translatable),
							translationsCmd),
						_List_Nil);
				}
			default:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					$author$project$Pages$Admin$LeadSources$fetchItems(newModel),
					_List_Nil);
		}
	});
var $author$project$Pages$Admin$LeadSources$New = {$: 1};
var $author$project$Pages$Admin$LeadSources$PaginationMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Admin$LeadSources$FormUpdated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$LeadSources$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$LeadSources$Save = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Pages$Admin$LeadSources$ShowOnOnlineSignup = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$LeadSources$viewEditModal = F3(
	function (id, form, item) {
		var modalConfig = {
			Tq: $elm$core$Maybe$Nothing,
			aih: 'Lead Source',
			V8: _Utils_eq(item, $author$project$Api$Data$Loading),
			WG: id,
			WH: $elm$core$Maybe$Nothing,
			Yd: $author$project$Pages$Admin$LeadSources$CancelEdit,
			Yf: $author$project$Pages$Admin$LeadSources$Save(form)
		};
		var _v0 = $author$project$Utils$Form$fields(form);
		var name = _v0.Bq;
		var showOnOnlineSignup = _v0.abn;
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Name'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(name),
									$author$project$Ui$Form$Input$placeholder('Online Ad'),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$LeadSources$FormUpdated, $author$project$Pages$Admin$LeadSources$Name)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form))
								])),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Show On Online Signup')
						]),
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$view(
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$on(showOnOnlineSignup),
									$author$project$Ui$ToggleSwitch$onChange(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$LeadSources$FormUpdated, $author$project$Pages$Admin$LeadSources$ShowOnOnlineSignup))
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$LeadSources$help = $elm$core$String$concat(
	_List_fromArray(
		['Use lead sources to track where new patients are coming from, whether they were a former patient, ', 'heard about you from a friend, from a website, or from specific marketing. The lead sources ', 'can be chosen on online signup or assigned directly to a patient. Our signup pages also allow ', 'specifying a specific lead source using a custom URL, which allows you to track signups ', 'from a specific email or landing page.']));
var $author$project$Pages$Admin$LeadSources$Delete = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$LeadSources$Edit = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$TranslationsInput$forTranslatable = F2(
	function (translatable_, inputs) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (input) {
					return _Utils_eq(input.hZ, translatable_);
				},
				inputs));
	});
var $author$project$Pages$Admin$LeadSources$isOther = function (item) {
	return $author$project$Api$Provider$LeadSource$All$name(item) === 'Other';
};
var $author$project$Api$Provider$LeadSource$Shared$patientsCount = function (_v0) {
	var record = _v0;
	return record.Y2;
};
var $author$project$Api$Provider$LeadSource$All$patientsCount = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$LeadSource$Shared$patientsCount(shared);
};
var $author$project$Pages$Admin$LeadSources$viewItem = F3(
	function (deletingItems, translationInputs, item) {
		var id = $author$project$Api$Provider$LeadSource$All$id(item);
		var translatable = $author$project$Components$TranslationsInput$leadSource(id);
		var translationInput = A2($author$project$Components$TranslationsInput$forTranslatable, translatable, translationInputs);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$LeadSource$All$name(item)),
							function () {
							if (!translationInput.$) {
								var input = translationInput.a;
								return A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$inlineBlock, $author$project$Ui$Element$ml2]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$map,
											$author$project$Pages$Admin$LeadSources$TranslationsInputMsg(input.hZ),
											A3(
												$author$project$Components$TranslationsInput$view,
												'name',
												_List_fromArray(
													[
														$author$project$Components$TranslationsInput$default(
														$author$project$Api$Provider$LeadSource$All$name(item))
													]),
												input))
										]));
							} else {
								return $elm$html$Html$text('');
							}
						}()
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Formatters$String$titleize(
								$author$project$Formatters$Bool$toString(
									$author$project$Api$Provider$LeadSource$All$showOnOnlineSignup(item))))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(
								$author$project$Api$Provider$LeadSource$All$patientsCount(item)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					function () {
						if ($author$project$Pages$Admin$LeadSources$isOther(item)) {
							return _List_Nil;
						} else {
							var loading = A2($elm$core$Set$member, id, deletingItems);
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$gap2, $author$project$Ui$Element$justifyRight]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{mm: 'Edit lead source'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$sm,
													$author$project$Ui$Button$onClick(
													$author$project$Pages$Admin$LeadSources$Edit(item)),
													$author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Edit')
												])),
											A3(
											$author$project$Ui$Button$view,
											{mm: 'Delete lead source'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$sm,
													$author$project$Ui$Button$loading(loading),
													$author$project$Ui$Button$onClick(
													$author$project$Pages$Admin$LeadSources$Delete(item)),
													$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Delete')
												]))
										]))
								]);
						}
					}())
				]));
	});
var $author$project$Pages$Admin$LeadSources$viewPanelBody = function (model) {
	var _v0 = function () {
		var _v1 = model.j4;
		if (_v1.$ === 3) {
			var items_ = _v1.a;
			return _Utils_Tuple2(false, items_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var items = _v0.b;
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Typography$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text($author$project$Pages$Admin$LeadSources$help)
				])),
			A4(
			$author$project$Ui$Table$view,
			_List_fromArray(
				[
					$author$project$Ui$Table$verticalCentered,
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('There are no lead sources.')
						])),
					$author$project$Ui$Table$loading(loading)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$header,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Name')
						])),
					A2(
					$author$project$Ui$Table$header,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Show on online signup')
						])),
					A2(
					$author$project$Ui$Table$header,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Patients count')
						])),
					A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
				]),
			A2(
				$elm$core$List$map,
				A2($author$project$Pages$Admin$LeadSources$viewItem, model.eg, model.fo),
				items),
			_List_Nil)
		]);
};
var $author$project$Pages$Admin$LeadSources$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				function () {
				var _v0 = model.Io;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var id = _v1.a;
					var form = _v1.b;
					var item = _v1.c;
					return A3($author$project$Pages$Admin$LeadSources$viewEditModal, id, form, item);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v2 = model.je;
				if (!_v2.$) {
					var item = _v2.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Admin$LeadSources$HiConfirmClosed(item),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('delete'),
								$author$project$Components$HiConfirm$noun('lead source'),
								$author$project$Components$HiConfirm$detail(
								$author$project$Api$Provider$LeadSource$All$name(item))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Lead Source')
											])),
										A3(
										$author$project$Ui$Button$view,
										{mm: 'New lead source'},
										_List_fromArray(
											[
												$author$project$Ui$Button$default,
												$author$project$Ui$Button$onClick($author$project$Pages$Admin$LeadSources$New),
												$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('New Lead Source')
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						$author$project$Pages$Admin$LeadSources$viewPanelBody(model)),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Admin$LeadSources$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(
											!$author$project$Api$Data$isSuccess(model.j4))
										]),
									model.ajJ))
							]))
					]))
			]),
		ac9: 'Admin | Lead Sources'
	};
};
var $author$project$Pages$Admin$LeadSources$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$LeadSources$init, aiq: $author$project$Pages$Admin$LeadSources$load, k8: $author$project$Pages$Admin$LeadSources$save, alO: $author$project$Pages$Admin$LeadSources$subscriptions, adT: $author$project$Pages$Admin$LeadSources$update, amo: $author$project$Pages$Admin$LeadSources$view});
var $author$project$Pages$Admin$Locations$GotLocationGroups = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Report$Location = 21;
var $author$project$Pages$Admin$Locations$urlParams = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('q'),
			model.akl)
		]);
	return A2(
		$elm$core$List$append,
		$author$project$Api$Pagination$toPageQuery(model.ajJ),
		A2(
			$elm$core$List$append,
			$author$project$Api$Sort$toQuery(model.alA),
			A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)));
};
var $author$project$Pages$Admin$Locations$buildUrl = function (model) {
	return A2(
		$elm$url$Url$Builder$relative,
		_List_fromArray(
			[
				$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Admin__Locations)
			]),
		$author$project$Pages$Admin$Locations$urlParams(model));
};
var $author$project$Pages$Admin$Locations$GotList = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Location$Meta = 0;
var $author$project$Pages$Admin$Locations$fetchParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				HE: _List_fromArray(
					[0]),
				ajJ: $elm$core$Maybe$Just(model.ajJ),
				akl: model.akl,
				alA: model.alA
			});
	};
};
var $author$project$Pages$Admin$Locations$fetchList = function (model) {
	return A3(
		$author$project$Api$Provider$Location$list,
		model.Gv,
		$author$project$Pages$Admin$Locations$fetchParams(model),
		$author$project$Pages$Admin$Locations$GotList);
};
var $author$project$Components$Admin$Location$DeleteModal$Closed = {$: 0};
var $author$project$Components$Admin$Location$DeleteModal$init = $author$project$Components$Admin$Location$DeleteModal$Closed;
var $author$project$Components$LinkedRecords$Closed = {$: 0};
var $author$project$Components$LinkedRecords$init = $author$project$Components$LinkedRecords$Closed;
var $author$project$Api$Provider$LocationGroup$All$LocationGroup = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$LocationGroup$All$AllRecord = F2(
	function (locationsCount, integrationRecords) {
		return {Ub: integrationRecords, Wh: locationsCount};
	});
var $author$project$Api$Provider$IntegrationRecord$One$IntegrationRecord = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$IntegrationRecord$Shared$IntegrationRecord = $elm$core$Basics$identity;
var $author$project$Api$Provider$IntegrationRecord$Shared$Record = F7(
	function (integrationSyncStatus, integrationLastSyncedAt, integrationRecordId, unsyncedReason, errorMessage, webLink, meta) {
		return {RM: errorMessage, T9: integrationLastSyncedAt, Ua: integrationRecordId, Uc: integrationSyncStatus, W4: meta, adO: unsyncedReason, aep: webLink};
	});
var $author$project$Api$IntegrationRecord$Status$Enabled = 3;
var $author$project$Api$IntegrationRecord$Status$Errored = 2;
var $author$project$Api$IntegrationRecord$Status$Synced = 0;
var $author$project$Api$IntegrationRecord$Status$Unsynced = 1;
var $author$project$Api$IntegrationRecord$Status$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'synced':
				return $elm$json$Json$Decode$succeed(0);
			case 'unsynced':
				return $elm$json$Json$Decode$succeed(1);
			case 'errored':
				return $elm$json$Json$Decode$succeed(2);
			case 'enabled':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('Unsupported integration record status: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$IntegrationRecord$Meta$Meta = $elm$core$Basics$identity;
var $author$project$Api$Provider$IntegrationRecord$Meta$Record = function (actions) {
	return {vy: actions};
};
var $author$project$Api$Provider$IntegrationRecord$Meta$Action = F3(
	function (name, description, available) {
		return {ae4: available, Qr: description, Bq: name};
	});
var $author$project$Api$Provider$IntegrationRecord$Meta$CopyToClipboard = 1;
var $author$project$Api$Provider$IntegrationRecord$Meta$EditPartnerId = 3;
var $author$project$Api$Provider$IntegrationRecord$Meta$ForcePushData = 2;
var $author$project$Api$Provider$IntegrationRecord$Meta$Unlink = 0;
var $author$project$Api$Provider$IntegrationRecord$Meta$actionNameDecoder = function (string) {
	switch (string) {
		case 'unlink':
			return $elm$json$Json$Decode$succeed(0);
		case 'copy_to_clipboard':
			return $elm$json$Json$Decode$succeed(1);
		case 'force_push_data':
			return $elm$json$Json$Decode$succeed(2);
		case 'edit_partner_id':
			return $elm$json$Json$Decode$succeed(3);
		default:
			return $elm$json$Json$Decode$fail('Unsupported integration record action: ' + string);
	}
};
var $author$project$Api$Provider$IntegrationRecord$Meta$actionDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'available',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'description',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			A2($elm$json$Json$Decode$andThen, $author$project$Api$Provider$IntegrationRecord$Meta$actionNameDecoder, $elm$json$Json$Decode$string),
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$IntegrationRecord$Meta$Action))));
var $author$project$Api$Provider$IntegrationRecord$Meta$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'actions',
	$elm$json$Json$Decode$list($author$project$Api$Provider$IntegrationRecord$Meta$actionDecoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$IntegrationRecord$Meta$Record));
var $author$project$Api$Provider$IntegrationRecord$Meta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$IntegrationRecord$Meta$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$IntegrationRecord$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'meta',
	$author$project$Api$Provider$IntegrationRecord$Meta$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'integration_web_link',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'error_message',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'unsynced_reason',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'integration_record_id',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'integration_last_synced_at',
						$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'integration_sync_status',
							$author$project$Api$IntegrationRecord$Status$decode,
							$elm$json$Json$Decode$succeed($author$project$Api$Provider$IntegrationRecord$Shared$Record))))))));
var $author$project$Api$Provider$IntegrationRecord$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$IntegrationRecord$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$IntegrationRecord$One$Athena = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$IntegrationRecord$One$None = {$: 1};
var $author$project$Api$Provider$IntegrationRecord$One$Record = F2(
	function (integration, metadata) {
		return {T8: integration, W5: metadata};
	});
var $author$project$Api$Provider$Integration$SharedWithInlinePartner$Integration = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Integration$SharedWithInlinePartner$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Partner$Shared$decoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Integration$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Integration$SharedWithInlinePartner$Integration)));
var $author$project$Api$Provider$IntegrationRecord$One$MetadataRecord = function (localPatientId) {
	return {air: localPatientId};
};
var $author$project$Api$Provider$IntegrationRecord$One$metadataDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'athena_local_patient_id',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$IntegrationRecord$One$MetadataRecord));
var $author$project$Api$Provider$IntegrationRecord$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'metadata',
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $author$project$Api$Provider$IntegrationRecord$One$Athena, $author$project$Api$Provider$IntegrationRecord$One$metadataDecoder),
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$IntegrationRecord$One$None)
			])),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'integration',
		$author$project$Api$Provider$Integration$SharedWithInlinePartner$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$IntegrationRecord$One$Record)));
var $author$project$Api$Provider$IntegrationRecord$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$IntegrationRecord$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$IntegrationRecord$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$IntegrationRecord$One$IntegrationRecord)));
var $author$project$Api$Provider$LocationGroup$All$recordDecoder = A3(
	$author$project$Api$Expandable$expandable,
	'integration_records',
	$elm$json$Json$Decode$list($author$project$Api$Provider$IntegrationRecord$One$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'locations_count',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$LocationGroup$All$AllRecord)));
var $author$project$Api$Provider$LocationGroup$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$LocationGroup$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Common$LocationGroup$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$LocationGroup$All$LocationGroup)));
var $author$project$Api$Provider$LocationGroup$expandToString = function (expand) {
	return 'integration_records';
};
var $author$project$Api$Provider$LocationGroup$listDefaults = {
	HE: _List_Nil,
	ahP: $elm$core$Maybe$Nothing,
	ajJ: $author$project$Api$Pagination$init,
	akl: $elm$core$Maybe$Nothing,
	alA: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init)
};
var $author$project$Api$Provider$LocationGroup$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$LocationGroup$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.akl;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.ahP;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				A2($author$project$Api$Expandable$toParam, $author$project$Api$Provider$LocationGroup$expandToString, options.HE),
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$Provider$LocationGroup$locationGroupsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['location_groups']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$LocationGroup$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$LocationGroup$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$LocationGroup$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$LocationGroup$locationGroupsPath)));
	});
var $author$project$Pages$Admin$Locations$init = F4(
	function (_v0, practice, shared, _v1) {
		var query = _v1.DE;
		var q = A2($elm$core$Dict$get, 'q', query);
		var model = {
			Gv: shared.Gv,
			i8: $author$project$Components$Admin$Location$DeleteModal$init,
			je: $elm$core$Maybe$Nothing,
			eg: $elm$core$Set$empty,
			nD: $author$project$Components$ExportCsv$initForPractice(21),
			Ij: $author$project$Shared$isHintAdmin(shared),
			Io: $elm$core$Maybe$Nothing,
			j4: $author$project$Api$Data$Loading,
			oo: $author$project$Components$LinkedRecords$init,
			Wa: $author$project$Api$Data$Loading,
			ajJ: $author$project$Api$Pagination$initFromQuery(query),
			ZV: practice,
			akl: q,
			up: $author$project$Ui$SearchInput$init(q),
			alA: A3(
				$author$project$Api$Sort$withDefault,
				'name',
				0,
				$author$project$Api$Sort$initFromQuery(query))
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Pages$Admin$Locations$fetchList(model),
						A2($elm$core$Basics$composeR, $author$project$Pages$Admin$Locations$buildUrl, $author$project$Ports$Navigation$replaceUrl)(model),
						A3($author$project$Api$Provider$LocationGroup$list, model.Gv, $elm$core$Basics$identity, $author$project$Pages$Admin$Locations$GotLocationGroups)
					])));
	});
var $author$project$Pages$Admin$Locations$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					Ij: $author$project$Shared$isHintAdmin(shared)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Locations$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Locations$AddressInputMsg = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$Admin$Locations$CancelEdit = {$: 9};
var $author$project$Pages$Admin$Locations$DeleteModalMsg = function (a) {
	return {$: 20, a: a};
};
var $author$project$Pages$Admin$Locations$ExportCsvMsg = function (a) {
	return {$: 21, a: a};
};
var $author$project$Pages$Admin$Locations$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Pages$Admin$Locations$LinkedRecordsMsg = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$Admin$Locations$PhoneInputMsg = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$AddressInput$AddressSuggestionsReceived = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Components$AddressInput$PlaceDetailsReceived = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Ports$GooglePlaces$googlePlacesAutocompleteSuggestionsResponse = _Platform_incomingPort(
	'googlePlacesAutocompleteSuggestionsResponse',
	A2(
		$elm$json$Json$Decode$andThen,
		function (suggestions) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (id) {
					return $elm$json$Json$Decode$succeed(
						{ahP: id, alP: suggestions});
				},
				A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'suggestions', $elm$json$Json$Decode$value)));
var $author$project$Ports$GooglePlaces$autocompleteSuggestionsResponse = function (decoder) {
	return $author$project$Ports$GooglePlaces$googlePlacesAutocompleteSuggestionsResponse(decoder);
};
var $author$project$Api$GoogleMaps$AutocompleteSuggestion$AutocompleteSuggestion = F3(
	function (description, placeId, types) {
		return {Qr: description, ZC: placeId, amh: types};
	});
var $author$project$Api$GoogleMaps$AutocompleteSuggestion$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'types',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'place_id',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'description',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$GoogleMaps$AutocompleteSuggestion$AutocompleteSuggestion))));
var $author$project$Api$GoogleMaps$AutocompleteSuggestion$decodeList = $elm$json$Json$Decode$list($author$project$Api$GoogleMaps$AutocompleteSuggestion$decoder);
var $author$project$Api$GoogleMaps$AutocompleteSuggestion$onGetAutocompleteSuggestionsResponse = function (toMsg) {
	return $author$project$Ports$GooglePlaces$autocompleteSuggestionsResponse(
		function (_v0) {
			var id = _v0.ahP;
			var suggestions = _v0.alP;
			return A2(
				toMsg,
				id,
				A2(
					$elm$core$Result$mapError,
					$elm$json$Json$Decode$errorToString,
					A2($elm$json$Json$Decode$decodeValue, $author$project$Api$GoogleMaps$AutocompleteSuggestion$decodeList, suggestions)));
		});
};
var $author$project$Api$GoogleMaps$Place$Place = F5(
	function (addressComponents, formattedAddress, name, placeId, types) {
		return {Gj: addressComponents, ahs: formattedAddress, Bq: name, ZC: placeId, amh: types};
	});
var $author$project$Api$GoogleMaps$Place$AddressComponent = F3(
	function (longName, shortName, types) {
		return {Wl: longName, abe: shortName, amh: types};
	});
var $author$project$Api$GoogleMaps$Place$OtherComponent = 37;
var $author$project$Api$GoogleMaps$Place$AdministrativeAreaLevel1 = 5;
var $author$project$Api$GoogleMaps$Place$AdministrativeAreaLevel2 = 6;
var $author$project$Api$GoogleMaps$Place$AdministrativeAreaLevel3 = 7;
var $author$project$Api$GoogleMaps$Place$AdministrativeAreaLevel4 = 8;
var $author$project$Api$GoogleMaps$Place$AdministrativeAreaLevel5 = 9;
var $author$project$Api$GoogleMaps$Place$Airport = 23;
var $author$project$Api$GoogleMaps$Place$BusStation = 33;
var $author$project$Api$GoogleMaps$Place$ColloquialArea = 10;
var $author$project$Api$GoogleMaps$Place$Country = 4;
var $author$project$Api$GoogleMaps$Place$Establishment = 29;
var $author$project$Api$GoogleMaps$Place$Floor = 27;
var $author$project$Api$GoogleMaps$Place$Intersection = 2;
var $author$project$Api$GoogleMaps$Place$Locality = 11;
var $author$project$Api$GoogleMaps$Place$NaturalFeature = 22;
var $author$project$Api$GoogleMaps$Place$Neighborhood = 18;
var $author$project$Api$GoogleMaps$Place$Park = 24;
var $author$project$Api$GoogleMaps$Place$Parking = 31;
var $author$project$Api$GoogleMaps$Place$PointOfInterest = 30;
var $author$project$Api$GoogleMaps$Place$Political = 3;
var $author$project$Api$GoogleMaps$Place$PostBox = 25;
var $author$project$Api$GoogleMaps$Place$PostalCode = 21;
var $author$project$Api$GoogleMaps$Place$PostalCodeSuffix = 36;
var $author$project$Api$GoogleMaps$Place$PostalTown = 32;
var $author$project$Api$GoogleMaps$Place$Premise = 19;
var $author$project$Api$GoogleMaps$Place$Room = 28;
var $author$project$Api$GoogleMaps$Place$Route = 1;
var $author$project$Api$GoogleMaps$Place$StreetAddress = 0;
var $author$project$Api$GoogleMaps$Place$StreetNumber = 26;
var $author$project$Api$GoogleMaps$Place$Sublocality = 12;
var $author$project$Api$GoogleMaps$Place$SublocalityLevel1 = 13;
var $author$project$Api$GoogleMaps$Place$SublocalityLevel2 = 14;
var $author$project$Api$GoogleMaps$Place$SublocalityLevel3 = 15;
var $author$project$Api$GoogleMaps$Place$SublocalityLevel4 = 16;
var $author$project$Api$GoogleMaps$Place$SublocalityLevel5 = 17;
var $author$project$Api$GoogleMaps$Place$Subpremise = 20;
var $author$project$Api$GoogleMaps$Place$TrainStation = 34;
var $author$project$Api$GoogleMaps$Place$TransitStation = 35;
var $author$project$Api$GoogleMaps$Place$componentTypeList = _List_fromArray(
	[
		_Utils_Tuple2('street_address', 0),
		_Utils_Tuple2('route', 1),
		_Utils_Tuple2('intersection', 2),
		_Utils_Tuple2('political', 3),
		_Utils_Tuple2('country', 4),
		_Utils_Tuple2('administrative_area_level_1', 5),
		_Utils_Tuple2('administrative_area_level_2', 6),
		_Utils_Tuple2('administrative_area_level_3', 7),
		_Utils_Tuple2('administrative_area_level_4', 8),
		_Utils_Tuple2('administrative_area_level_5', 9),
		_Utils_Tuple2('colloquial_area', 10),
		_Utils_Tuple2('locality', 11),
		_Utils_Tuple2('sublocality', 12),
		_Utils_Tuple2('sublocality_level_1', 13),
		_Utils_Tuple2('sublocality_level_2', 14),
		_Utils_Tuple2('sublocality_level_3', 15),
		_Utils_Tuple2('sublocality_level_4', 16),
		_Utils_Tuple2('sublocality_level_5', 17),
		_Utils_Tuple2('neighborhood', 18),
		_Utils_Tuple2('premise', 19),
		_Utils_Tuple2('subpremise', 20),
		_Utils_Tuple2('postal_code', 21),
		_Utils_Tuple2('natural_feature', 22),
		_Utils_Tuple2('airport', 23),
		_Utils_Tuple2('park', 24),
		_Utils_Tuple2('post_box', 25),
		_Utils_Tuple2('street_number', 26),
		_Utils_Tuple2('floor', 27),
		_Utils_Tuple2('room', 28),
		_Utils_Tuple2('establishment', 29),
		_Utils_Tuple2('point_of_interest', 30),
		_Utils_Tuple2('parking', 31),
		_Utils_Tuple2('postal_town', 32),
		_Utils_Tuple2('bus_station', 33),
		_Utils_Tuple2('train_station', 34),
		_Utils_Tuple2('transit_station', 35),
		_Utils_Tuple2('postal_code_suffix', 36)
	]);
var $author$project$Api$GoogleMaps$Place$componentTypeMap = $elm$core$Dict$fromList($author$project$Api$GoogleMaps$Place$componentTypeList);
var $author$project$Api$GoogleMaps$Place$stringToComponentType = function (str) {
	return A2(
		$elm$core$Maybe$withDefault,
		37,
		A2($elm$core$Dict$get, str, $author$project$Api$GoogleMaps$Place$componentTypeMap));
};
var $author$project$Api$GoogleMaps$Place$mapComponentType = A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $author$project$Api$GoogleMaps$Place$stringToComponentType);
var $author$project$Api$GoogleMaps$Place$typeDecoder = A2($elm$json$Json$Decode$andThen, $author$project$Api$GoogleMaps$Place$mapComponentType, $elm$json$Json$Decode$string);
var $author$project$Api$GoogleMaps$Place$typeListDecoder = $elm$json$Json$Decode$list($author$project$Api$GoogleMaps$Place$typeDecoder);
var $author$project$Api$GoogleMaps$Place$decodeAddressComponent = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'types',
	$author$project$Api$GoogleMaps$Place$typeListDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'short_name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'long_name',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$GoogleMaps$Place$AddressComponent))));
var $author$project$Api$GoogleMaps$Place$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'types',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'place_id',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'formatted_address',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'address_components',
					$elm$json$Json$Decode$list($author$project$Api$GoogleMaps$Place$decodeAddressComponent),
					$elm$json$Json$Decode$succeed($author$project$Api$GoogleMaps$Place$Place))))));
var $author$project$Ports$GooglePlaces$googlePlacesPlaceDetailsResponse = _Platform_incomingPort(
	'googlePlacesPlaceDetailsResponse',
	A2(
		$elm$json$Json$Decode$andThen,
		function (id) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (address) {
					return $elm$json$Json$Decode$succeed(
						{K2: address, ahP: id});
				},
				A2($elm$json$Json$Decode$field, 'address', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string)));
var $author$project$Ports$GooglePlaces$placeDetailsResponse = function (handler) {
	return $author$project$Ports$GooglePlaces$googlePlacesPlaceDetailsResponse(handler);
};
var $author$project$Api$GoogleMaps$Place$onGetPlaceDetailsResponse = function (toMsg) {
	return $author$project$Ports$GooglePlaces$placeDetailsResponse(
		function (_v0) {
			var id = _v0.ahP;
			var address = _v0.K2;
			return A2(
				toMsg,
				id,
				A2(
					$elm$core$Result$mapError,
					$elm$json$Json$Decode$errorToString,
					A2($elm$json$Json$Decode$decodeString, $author$project$Api$GoogleMaps$Place$decoder, address)));
		});
};
var $author$project$Components$AddressInput$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$Dropdown$subscriptions(model.ij),
				$author$project$Api$GoogleMaps$AutocompleteSuggestion$onGetAutocompleteSuggestionsResponse($author$project$Components$AddressInput$AddressSuggestionsReceived),
				$author$project$Api$GoogleMaps$Place$onGetPlaceDetailsResponse($author$project$Components$AddressInput$PlaceDetailsReceived)
			]));
};
var $author$project$Components$Admin$Location$DeleteModal$CloseModal = {$: 0};
var $author$project$Components$Admin$Location$DeleteModal$subscriptions = function (model) {
	if (model.$ === 1) {
		return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$Location$DeleteModal$CloseModal);
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Components$LinkedRecords$CloseModal = {$: 1};
var $author$project$Components$LinkedRecords$subscriptions = function (model) {
	if (model.$ === 1) {
		return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$LinkedRecords$CloseModal);
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Pages$Admin$Locations$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				function () {
				var _v0 = model.Io;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var form = _v1.b;
					var _v2 = $author$project$Utils$Form$fields(form);
					var phone = _v2.Zw;
					var address = _v2.K2;
					return $elm$core$Platform$Sub$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Platform$Sub$map,
								$author$project$Pages$Admin$Locations$PhoneInputMsg,
								$author$project$Components$PhoneInput$subscriptions(phone)),
								A2(
								$elm$core$Platform$Sub$map,
								$author$project$Pages$Admin$Locations$AddressInputMsg,
								A2(
									$elm$core$Maybe$withDefault,
									$elm$core$Platform$Sub$none,
									A2($elm$core$Maybe$map, $author$project$Components$AddressInput$subscriptions, address)))
							]));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$Locations$ExportCsvMsg,
				$author$project$Components$ExportCsv$subscriptions(model.nD)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$Locations$LinkedRecordsMsg,
				$author$project$Components$LinkedRecords$subscriptions(model.oo)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$Locations$DeleteModalMsg,
				$author$project$Components$Admin$Location$DeleteModal$subscriptions(model.i8)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Admin$Locations$CancelEdit)),
					model.Io)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$Locations$HiConfirmClosed),
					model.je))
			]));
};
var $author$project$Pages$Admin$Locations$Address = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$Locations$Deleted = F2(
	function (a, b) {
		return {$: 15, a: a, b: b};
	});
var $author$project$Pages$Admin$Locations$Phone = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$Locations$SearchInputMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Location$locationPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$Location$locationsPath);
};
var $author$project$Api$Provider$Location$delete = F4(
	function (apiClient, id_, reassignToLocation, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				function () {
					if (!reassignToLocation.$) {
						var string = reassignToLocation.a;
						return _List_fromArray(
							[
								A2($author$project$Api$Param$string, 'reassign_to_location_id', string)
							]);
					} else {
						return _List_Nil;
					}
				}(),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Location$locationPath(id_))));
	});
var $author$project$Pages$Admin$Locations$initPhoneInput = function (phoneNumber) {
	var phone = A2(
		$elm$core$Maybe$map,
		A2($author$project$Components$PhoneInput$initPhone, $author$project$Api$Common$Phone$Shared$Office, 0),
		phoneNumber);
	return A3(
		$author$project$Components$PhoneInput$init,
		'location-phone-input',
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2($elm$core$Maybe$map, $elm$core$List$singleton, phone)),
		function (d) {
			return _Utils_update(
				d,
				{
					Gh: true,
					aeW: false,
					agl: $author$project$Api$Common$Phone$Shared$Office,
					AU: 1,
					pz: _List_fromArray(
						[0])
				});
		});
};
var $author$project$Pages$Admin$Locations$formFieldsForBusinessLocation = function (name) {
	return _Utils_Tuple2(
		{
			K2: $elm$core$Maybe$Nothing,
			MY: true,
			s4: $elm$core$Maybe$Nothing,
			Bq: name,
			Ym: true,
			Zw: $author$project$Pages$Admin$Locations$initPhoneInput($elm$core$Maybe$Nothing),
			aej: false
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Api$Provider$Location$Shared$businessLocation = function (_v0) {
	var record = _v0;
	return record.MY;
};
var $author$project$Api$Provider$Location$All$businessLocation = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Location$Shared$businessLocation(shared);
};
var $author$project$Api$Common$LocationGroup$Min$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Common$LocationGroup$Shared$id = function (_v0) {
	var min = _v0;
	return $author$project$Api$Common$LocationGroup$Min$id(min);
};
var $author$project$Api$Provider$Location$Shared$locationGroup = function (_v0) {
	var record = _v0;
	return record.s4;
};
var $author$project$Api$Provider$Location$All$locationGroup = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Location$Shared$locationGroup(shared);
};
var $author$project$Api$Provider$Location$Shared$onlineSignupVisibility = function (_v0) {
	var record = _v0;
	return record.Ym;
};
var $author$project$Api$Provider$Location$All$onlineSignupVisibility = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Location$Shared$onlineSignupVisibility(shared);
};
var $author$project$Api$Provider$Location$Shared$virtual = function (_v0) {
	var record = _v0;
	return record.aej;
};
var $author$project$Api$Provider$Location$All$virtual = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Location$Shared$virtual(shared);
};
var $author$project$Pages$Admin$Locations$formFieldsFromBusinessLocation = function (location) {
	return _Utils_Tuple2(
		{
			K2: $elm$core$Maybe$Nothing,
			MY: $author$project$Api$Provider$Location$All$businessLocation(location),
			s4: A2(
				$elm$core$Maybe$map,
				$author$project$Api$Common$LocationGroup$Shared$id,
				$author$project$Api$Provider$Location$All$locationGroup(location)),
			Bq: $author$project$Api$Provider$Location$All$name(location),
			Ym: $author$project$Api$Provider$Location$All$onlineSignupVisibility(location),
			Zw: $author$project$Pages$Admin$Locations$initPhoneInput($elm$core$Maybe$Nothing),
			aej: $author$project$Api$Provider$Location$All$virtual(location)
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Api$Provider$Location$Shared$address = function (_v0) {
	var record = _v0;
	return record.K2;
};
var $author$project$Api$Provider$Location$All$address = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Location$Shared$address(shared);
};
var $author$project$Api$Common$Address$Shared$country = function (_v0) {
	var record = _v0;
	return record.rK;
};
var $author$project$Components$AddressInput$formFieldsFromMaybeAddress = function (address) {
	return {
		cZ: A2($elm$core$Maybe$andThen, $author$project$Api$Common$Address$Shared$line1, address),
		fA: A2($elm$core$Maybe$andThen, $author$project$Api$Common$Address$Shared$line2, address),
		rE: A2($elm$core$Maybe$andThen, $author$project$Api$Common$Address$Shared$city, address),
		rK: A2($elm$core$Maybe$andThen, $author$project$Api$Common$Address$Shared$country, address),
		uP: A2($elm$core$Maybe$andThen, $author$project$Api$Common$Address$Shared$state, address),
		vv: A2($elm$core$Maybe$andThen, $author$project$Api$Common$Address$Shared$zip, address)
	};
};
var $author$project$Components$AddressInput$Address1DropdownMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$AddressInput$Model = $elm$core$Basics$identity;
var $author$project$Components$AddressInput$initFromFields = F2(
	function (id, fields) {
		return _Utils_Tuple2(
			{
				ij: $author$project$Ui$Dropdown$init(
					$author$project$Ui$Dropdown$defaultConfig(
						{ahP: id + '-address1-dropdown', al6: $author$project$Components$AddressInput$Address1DropdownMsg})),
				i5: $jinjor$elm_debounce$Debounce$init,
				SD: $author$project$Utils$Form$init(fields),
				ahP: id,
				akR: false,
				bj: true,
				alP: _List_Nil
			},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Components$AddressInput$initFromApi = F2(
	function (id, address) {
		return A2(
			$author$project$Components$AddressInput$initFromFields,
			id,
			$author$project$Components$AddressInput$formFieldsFromMaybeAddress(address));
	});
var $author$project$Api$Provider$Location$Shared$phoneNumber = function (_v0) {
	var record = _v0;
	return record.Zx;
};
var $author$project$Api$Provider$Location$All$phoneNumber = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Location$Shared$phoneNumber(shared);
};
var $author$project$Components$AddressInput$withRequired = F2(
	function (required_, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{akR: required_});
	});
var $author$project$Pages$Admin$Locations$formFieldsFromItem = function (location) {
	var _v0 = A2(
		$author$project$Components$AddressInput$initFromApi,
		'location-' + $author$project$Api$Provider$Location$All$id(location),
		$author$project$Api$Provider$Location$All$address(location));
	var addressInput = _v0.a;
	var addressInputCmd = _v0.b;
	return _Utils_Tuple2(
		{
			K2: $elm$core$Maybe$Just(
				A2(
					$author$project$Components$AddressInput$withRequired,
					!$author$project$Api$Provider$Location$All$virtual(location),
					addressInput)),
			MY: $author$project$Api$Provider$Location$All$businessLocation(location),
			s4: A2(
				$elm$core$Maybe$map,
				$author$project$Api$Common$LocationGroup$Shared$id,
				$author$project$Api$Provider$Location$All$locationGroup(location)),
			Bq: $author$project$Api$Provider$Location$All$name(location),
			Ym: $author$project$Api$Provider$Location$All$onlineSignupVisibility(location),
			Zw: $author$project$Pages$Admin$Locations$initPhoneInput(
				$author$project$Api$Provider$Location$All$phoneNumber(location)),
			aej: $author$project$Api$Provider$Location$All$virtual(location)
		},
		A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Locations$AddressInputMsg, addressInputCmd));
};
var $author$project$Components$AddressInput$formFieldsInit = {cZ: $elm$core$Maybe$Nothing, fA: $elm$core$Maybe$Nothing, rE: $elm$core$Maybe$Nothing, rK: $elm$core$Maybe$Nothing, uP: $elm$core$Maybe$Nothing, vv: $elm$core$Maybe$Nothing};
var $author$project$Components$AddressInput$init = function (id) {
	return A2($author$project$Components$AddressInput$initFromFields, id, $author$project$Components$AddressInput$formFieldsInit);
};
var $author$project$Pages$Admin$Locations$formFieldsInit = function () {
	var _v0 = $author$project$Components$AddressInput$init('new-location');
	var addressInput = _v0.a;
	var addressInputCmd = _v0.b;
	return _Utils_Tuple2(
		{
			K2: $elm$core$Maybe$Just(
				A2($author$project$Components$AddressInput$withRequired, true, addressInput)),
			MY: false,
			s4: $elm$core$Maybe$Nothing,
			Bq: '',
			Ym: true,
			Zw: $author$project$Pages$Admin$Locations$initPhoneInput($elm$core$Maybe$Nothing),
			aej: false
		},
		A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Locations$AddressInputMsg, addressInputCmd));
}();
var $author$project$Pages$Admin$Locations$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{Bq: string});
			case 1:
				var bool = field.a;
				return _Utils_update(
					fields,
					{
						K2: A2(
							$elm$core$Maybe$map,
							$author$project$Components$AddressInput$withRequired(!bool),
							fields.K2),
						aej: bool
					});
			case 3:
				var string = field.a;
				var locationGroup = $elm$core$String$isEmpty(string) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(string);
				return _Utils_update(
					fields,
					{s4: locationGroup});
			case 2:
				var bool = field.a;
				return _Utils_update(
					fields,
					{Ym: bool});
			case 4:
				var phone = field.a;
				return _Utils_update(
					fields,
					{Zw: phone});
			default:
				var address = field.a;
				return _Utils_update(
					fields,
					{
						K2: $elm$core$Maybe$Just(address)
					});
		}
	});
var $author$project$Pages$Admin$Locations$NameValidation = 0;
var $author$project$Pages$Admin$Locations$AddressValidation = 2;
var $author$project$Components$AddressInput$AddressValidation = 0;
var $author$project$Components$AddressInput$hasAnyAddressData = F2(
	function (showCountry, fields) {
		return $author$project$Utils$Maybe$toBool(fields.cZ) || ($author$project$Utils$Maybe$toBool(fields.rE) || ($author$project$Utils$Maybe$toBool(fields.uP) || ($author$project$Utils$Maybe$toBool(fields.vv) || (showCountry && $author$project$Utils$Maybe$toBool(fields.rK)))));
	});
var $author$project$Components$AddressInput$validateAddress1 = F2(
	function (config, fields) {
		var effectiveRequired = config.n8 || A2($author$project$Components$AddressInput$hasAnyAddressData, config.bj, fields);
		return (effectiveRequired && (!$author$project$Utils$Maybe$toBool(fields.cZ))) ? _List_fromArray(
			[
				_Utils_Tuple2(0, 'Please enter an address.')
			]) : _List_Nil;
	});
var $author$project$Components$AddressInput$validateAddress1MaxLength = function (_v0) {
	var address1 = _v0.cZ;
	if (!address1.$) {
		var value = address1.a;
		return ($elm$core$String$length(value) > 50) ? _List_fromArray(
			[
				_Utils_Tuple2(0, 'Address line 1 must be 50 characters or less.')
			]) : _List_Nil;
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$AddressInput$validateAddress2MaxLength = function (_v0) {
	var address2 = _v0.fA;
	if (!address2.$) {
		var value = address2.a;
		return ($elm$core$String$length(value) > 50) ? _List_fromArray(
			[
				_Utils_Tuple2(0, 'Address line 2 must be 50 characters or less.')
			]) : _List_Nil;
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$AddressInput$CityValidation = 1;
var $author$project$Components$AddressInput$validateCity = F2(
	function (config, fields) {
		var effectiveRequired = config.n8 || A2($author$project$Components$AddressInput$hasAnyAddressData, config.bj, fields);
		return (effectiveRequired && (!$author$project$Utils$Maybe$toBool(fields.rE))) ? _List_fromArray(
			[
				_Utils_Tuple2(1, 'Please enter a city.')
			]) : _List_Nil;
	});
var $author$project$Components$AddressInput$StateValidation = 2;
var $author$project$Components$AddressInput$validateState = F2(
	function (config, fields) {
		var effectiveRequired = config.n8 || A2($author$project$Components$AddressInput$hasAnyAddressData, config.bj, fields);
		return (effectiveRequired && (!$author$project$Utils$Maybe$toBool(fields.uP))) ? _List_fromArray(
			[
				_Utils_Tuple2(2, 'Please enter a state.')
			]) : _List_Nil;
	});
var $author$project$Components$AddressInput$ZipValidation = 3;
var $author$project$Components$AddressInput$validateZip = F2(
	function (config, fields) {
		var effectiveRequired = config.n8 || A2($author$project$Components$AddressInput$hasAnyAddressData, config.bj, fields);
		return (effectiveRequired && (!$author$project$Utils$Maybe$toBool(fields.vv))) ? _List_fromArray(
			[
				_Utils_Tuple2(3, 'Please enter a zip code.')
			]) : _List_Nil;
	});
var $author$project$Components$AddressInput$formFieldsValidator = function (config) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$AddressInput$validateAddress1(config)),
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$AddressInput$validateAddress1MaxLength),
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$AddressInput$validateAddress2MaxLength),
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$AddressInput$validateCity(config)),
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$AddressInput$validateState(config)),
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$AddressInput$validateZip(config))
			]));
};
var $author$project$Components$AddressInput$validateForm = function (model) {
	var config = {n8: model.akR, bj: model.bj};
	var _v0 = A2(
		$author$project$Utils$Form$validate,
		$author$project$Components$AddressInput$formFieldsValidator(config),
		model.SD);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var form = _v1.a;
		return _Utils_Tuple2(form, true);
	} else {
		var form = _v0.a;
		return _Utils_Tuple2(form, false);
	}
};
var $author$project$Components$AddressInput$isValid = function (_v0) {
	var model = _v0;
	return $author$project$Components$AddressInput$validateForm(model).b;
};
var $author$project$Pages$Admin$Locations$validateAddress = function (fields) {
	var _v0 = A2($elm$core$Maybe$map, $author$project$Components$AddressInput$isValid, fields.K2);
	if ((!_v0.$) && (!_v0.a)) {
		return _List_fromArray(
			[
				_Utils_Tuple2(2, 'Please enter an address')
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Pages$Admin$Locations$LocationGroupValidation = 1;
var $author$project$Pages$Admin$Locations$validateLocationGroup = F2(
	function (requireGroupForLocations, fields) {
		var _v0 = _Utils_Tuple2(requireGroupForLocations, fields.s4);
		if (_v0.a && (_v0.b.$ === 1)) {
			var _v1 = _v0.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(1, 'Please pick a location group')
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Pages$Admin$Locations$PhoneValidation = 3;
var $author$project$Pages$Admin$Locations$validatePhone = function (fields) {
	var _v0 = $author$project$Components$PhoneInput$getPhones(fields.Zw);
	if (!_v0.$) {
		return _List_Nil;
	} else {
		return _List_fromArray(
			[
				_Utils_Tuple2(3, 'Please enter a valid phone')
			]);
	}
};
var $author$project$Pages$Admin$Locations$formFieldsValidator = function (requireGroupForLocations) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_validate$Validate$ifBlank,
				function ($) {
					return $.Bq;
				},
				_Utils_Tuple2(0, 'Please enter a name.')),
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Pages$Admin$Locations$validateLocationGroup(requireGroupForLocations)),
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Admin$Locations$validateAddress),
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Admin$Locations$validatePhone)
			]));
};
var $author$project$Api$Provider$Location$All$hasPatients = function (_v0) {
	var record = _v0.b;
	return record.Te;
};
var $author$project$Api$Provider$Location$One$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Location$Shared$name(shared);
};
var $author$project$Components$Admin$Location$DeleteModal$Open = F4(
	function (a, b, c, d) {
		return {$: 1, a: a, b: b, c: c, d: d};
	});
var $author$project$Components$Admin$Location$DeleteModal$Reassign = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$Location$DeleteModal$RemoveAssignment = {$: 1};
var $author$project$Components$Admin$Location$DeleteModal$open = F2(
	function (location, remainingLocations) {
		var action = $elm$core$List$isEmpty(remainingLocations) ? $author$project$Components$Admin$Location$DeleteModal$RemoveAssignment : $author$project$Components$Admin$Location$DeleteModal$Reassign($elm$core$Maybe$Nothing);
		return A4($author$project$Components$Admin$Location$DeleteModal$Open, location, remainingLocations, action, $author$project$Api$Data$NotAsked);
	});
var $author$project$Api$Provider$Practice$One$requireGroupForLocations = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.akQ;
	});
var $author$project$Pages$Admin$Locations$Created = function (a) {
	return {$: 13, a: a};
};
var $author$project$Api$Provider$Location$One$Location = $elm$core$Basics$identity;
var $author$project$Api$Provider$Location$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Location$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$Address$Shared$encode = function (address) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'line1',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address.s$)),
				_Utils_Tuple2(
				'line2',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address.AD)),
				_Utils_Tuple2(
				'city',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address.rE)),
				_Utils_Tuple2(
				'state',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address.uP)),
				_Utils_Tuple2(
				'zip',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address.vv)),
				_Utils_Tuple2(
				'country',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address.rK))
			]));
};
var $author$project$Api$Provider$Location$create = F3(
	function (apiClient, fields, toMsg) {
		var addressField = function () {
			var _v0 = fields.K2;
			if (!_v0.$) {
				var address__ = _v0.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'address',
						$author$project$Api$Common$Address$Shared$encode(address__))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'location',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(fields.Bq)),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'online_signup_visibility',
									$elm$json$Json$Encode$bool(fields.Ym)),
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										'phone_number',
										A2(
											$author$project$Utils$Encode$nullable,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.IO;
												},
												$elm$json$Json$Encode$string),
											fields.Zw)),
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(
											'virtual',
											$elm$json$Json$Encode$bool(fields.aej)),
										A2(
											$elm$core$List$cons,
											_Utils_Tuple2(
												'business_location',
												$elm$json$Json$Encode$bool(fields.MY)),
											A2(
												$elm$core$List$cons,
												_Utils_Tuple2(
													'location_group',
													A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.s4)),
												addressField))))))))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Location$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Location$locationsPath)));
	});
var $author$project$Components$AddressInput$getAddress = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.SD);
	return {rE: fields.rE, rK: fields.rK, s$: fields.cZ, AD: fields.fA, uP: fields.uP, vv: fields.vv};
};
var $author$project$Pages$Admin$Locations$locationFromFields = function (fields) {
	var phone = A2(
		$elm$core$Maybe$andThen,
		$elm$core$List$head,
		$author$project$Components$PhoneInput$getPhones(fields.Zw));
	var address = A2($elm$core$Maybe$map, $author$project$Components$AddressInput$getAddress, fields.K2);
	return {K2: address, MY: fields.MY, s4: fields.s4, Bq: fields.Bq, Ym: fields.Ym, Zw: phone, aej: fields.aej};
};
var $author$project$Pages$Admin$Locations$createItem = F2(
	function (apiClient, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A3(
			$author$project$Api$Provider$Location$create,
			apiClient,
			$author$project$Pages$Admin$Locations$locationFromFields(fields),
			$author$project$Pages$Admin$Locations$Created);
	});
var $author$project$Pages$Admin$Locations$Updated = function (a) {
	return {$: 14, a: a};
};
var $author$project$Api$Provider$Location$update = F4(
	function (apiClient, id_, fields, toMsg) {
		var addressField = function () {
			var _v0 = fields.K2;
			if (!_v0.$) {
				var address__ = _v0.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'address',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'line1',
									A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address__.s$)),
									_Utils_Tuple2(
									'line2',
									A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address__.AD)),
									_Utils_Tuple2(
									'city',
									A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address__.rE)),
									_Utils_Tuple2(
									'state',
									A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address__.uP)),
									_Utils_Tuple2(
									'zip',
									A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address__.vv)),
									_Utils_Tuple2(
									'country',
									A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address__.rK))
								])))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'location',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(fields.Bq)),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'online_signup_visibility',
									$elm$json$Json$Encode$bool(fields.Ym)),
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										'phone_number',
										A2(
											$author$project$Utils$Encode$nullable,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.IO;
												},
												$elm$json$Json$Encode$string),
											fields.Zw)),
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(
											'virtual',
											$elm$json$Json$Encode$bool(fields.aej)),
										A2(
											$elm$core$List$cons,
											_Utils_Tuple2(
												'business_location',
												$elm$json$Json$Encode$bool(fields.MY)),
											A2(
												$elm$core$List$cons,
												_Utils_Tuple2(
													'location_group',
													A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.s4)),
												addressField))))))))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Location$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Location$locationPath(id_))));
	});
var $author$project$Pages$Admin$Locations$updateItem = F3(
	function (apiClient, id, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4(
			$author$project$Api$Provider$Location$update,
			apiClient,
			id,
			$author$project$Pages$Admin$Locations$locationFromFields(fields),
			$author$project$Pages$Admin$Locations$Updated);
	});
var $author$project$Pages$Admin$Locations$saveItem = F3(
	function (apiClient, maybeId, formFields) {
		if (!maybeId.$) {
			var id_ = maybeId.a;
			return A3($author$project$Pages$Admin$Locations$updateItem, apiClient, id_, formFields);
		} else {
			return A2($author$project$Pages$Admin$Locations$createItem, apiClient, formFields);
		}
	});
var $author$project$Api$Provider$Practice$One$trackPatientsByLocation = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.adt;
	});
var $author$project$Components$AddressInput$Address1 = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$AddressInput$PerformSearch = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$AddressInput$debounceAddress = function (address) {
	return A2(
		$elm$core$Task$perform,
		$author$project$Components$AddressInput$PerformSearch,
		$elm$core$Task$succeed(address));
};
var $author$project$Components$AddressInput$DebounceMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$AddressInput$debounceConfig = {
	alK: $jinjor$elm_debounce$Debounce$later(300),
	ame: $author$project$Components$AddressInput$DebounceMsg
};
var $author$project$Components$AddressInput$formFieldsUpdate = F2(
	function (field, form) {
		switch (field.$) {
			case 0:
				var address1 = field.a;
				return _Utils_update(
					form,
					{cZ: address1});
			case 1:
				var address2 = field.a;
				return _Utils_update(
					form,
					{fA: address2});
			case 2:
				var city = field.a;
				return _Utils_update(
					form,
					{rE: city});
			case 3:
				var state = field.a;
				return _Utils_update(
					form,
					{uP: state});
			case 4:
				var zip = field.a;
				return _Utils_update(
					form,
					{vv: zip});
			default:
				var country = field.a;
				return _Utils_update(
					form,
					{rK: country});
		}
	});
var $author$project$Ports$GooglePlaces$AddressWithId = F2(
	function (address, id) {
		return {K2: address, ahP: id};
	});
var $author$project$Ports$GooglePlaces$googlePlacesGetAutocompleteSuggestions = _Platform_outgoingPort(
	'googlePlacesGetAutocompleteSuggestions',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'address',
					$elm$json$Json$Encode$string($.K2)),
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string($.ahP))
				]));
	});
var $author$project$Ports$GooglePlaces$getAutocompleteSuggestions = function (addressQuery) {
	return $author$project$Ports$GooglePlaces$googlePlacesGetAutocompleteSuggestions(addressQuery);
};
var $author$project$Api$GoogleMaps$AutocompleteSuggestion$getAutocompleteSuggestions = function (_v0) {
	var searchTerm = _v0.alf;
	var id = _v0.ahP;
	return $author$project$Ports$GooglePlaces$getAutocompleteSuggestions(
		A2($author$project$Ports$GooglePlaces$AddressWithId, searchTerm, id));
};
var $author$project$Ports$GooglePlaces$PlaceWithId = F2(
	function (placeId, id) {
		return {ahP: id, ZC: placeId};
	});
var $author$project$Ports$GooglePlaces$googlePlacesGetPlaceDetails = _Platform_outgoingPort(
	'googlePlacesGetPlaceDetails',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string($.ahP)),
					_Utils_Tuple2(
					'placeId',
					$elm$json$Json$Encode$string($.ZC))
				]));
	});
var $author$project$Ports$GooglePlaces$getPlaceDetails = function (details) {
	return $author$project$Ports$GooglePlaces$googlePlacesGetPlaceDetails(details);
};
var $author$project$Api$GoogleMaps$Place$getPlaceDetails = function (_v0) {
	var placeId = _v0.ZC;
	var id = _v0.ahP;
	return $author$project$Ports$GooglePlaces$getPlaceDetails(
		A2($author$project$Ports$GooglePlaces$PlaceWithId, placeId, id));
};
var $author$project$Api$GoogleMaps$AutocompleteSuggestion$placeId = function (suggestion) {
	return suggestion.ZC;
};
var $author$project$Components$AddressInput$Address2 = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$AddressInput$City = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$AddressInput$Country = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$AddressInput$State = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$AddressInput$Zip = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$GoogleMaps$Place$getComponentLongName = F2(
	function (place, componentType) {
		return A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.Wl;
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (c) {
						return A2($elm$core$List$member, componentType, c.amh);
					},
					place.Gj)));
	});
var $author$project$Utils$String$ifEmptyThen = F2(
	function (thenStr, str) {
		return $author$project$Utils$String$isBlank(str) ? thenStr : str;
	});
var $author$project$Components$AddressInput$cityString = function (place) {
	var subLocality = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($author$project$Api$GoogleMaps$Place$getComponentLongName, place, 12));
	var locality = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($author$project$Api$GoogleMaps$Place$getComponentLongName, place, 11));
	return A2($author$project$Utils$String$ifEmptyThen, subLocality, locality);
};
var $author$project$Components$AddressInput$countryString = function (place) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($author$project$Api$GoogleMaps$Place$getComponentLongName, place, 4));
};
var $author$project$Api$GoogleMaps$Place$getComponentShortName = F2(
	function (place, componentType) {
		return A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.abe;
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (c) {
						return A2($elm$core$List$member, componentType, c.amh);
					},
					place.Gj)));
	});
var $author$project$Components$AddressInput$stateString = function (place) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($author$project$Api$GoogleMaps$Place$getComponentShortName, place, 5));
};
var $author$project$Components$AddressInput$zipString = function (place) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($author$project$Api$GoogleMaps$Place$getComponentLongName, place, 21));
};
var $author$project$Components$AddressInput$updateFormByPlace = F3(
	function (place, form, showCountry) {
		return (showCountry ? A2(
			$author$project$Utils$Form$update,
			$author$project$Components$AddressInput$formFieldsUpdate,
			$author$project$Components$AddressInput$Country(
				$author$project$Utils$String$toMaybe(
					$author$project$Components$AddressInput$countryString(place)))) : $elm$core$Basics$identity)(
			A3(
				$author$project$Utils$Form$update,
				$author$project$Components$AddressInput$formFieldsUpdate,
				$author$project$Components$AddressInput$Zip(
					$author$project$Utils$String$toMaybe(
						$author$project$Components$AddressInput$zipString(place))),
				A3(
					$author$project$Utils$Form$update,
					$author$project$Components$AddressInput$formFieldsUpdate,
					$author$project$Components$AddressInput$State(
						$author$project$Utils$String$toMaybe(
							$author$project$Components$AddressInput$stateString(place))),
					A3(
						$author$project$Utils$Form$update,
						$author$project$Components$AddressInput$formFieldsUpdate,
						$author$project$Components$AddressInput$City(
							$author$project$Utils$String$toMaybe(
								$author$project$Components$AddressInput$cityString(place))),
						A3(
							$author$project$Utils$Form$update,
							$author$project$Components$AddressInput$formFieldsUpdate,
							$author$project$Components$AddressInput$Address2(
								$author$project$Utils$String$toMaybe('')),
							A3(
								$author$project$Utils$Form$update,
								$author$project$Components$AddressInput$formFieldsUpdate,
								$author$project$Components$AddressInput$Address1(
									$author$project$Utils$String$toMaybe(place.Bq)),
								form))))));
	});
var $author$project$Components$AddressInput$validate = function (_v0) {
	var model = _v0;
	return _Utils_update(
		model,
		{
			SD: $author$project$Components$AddressInput$validateForm(model).a
		});
};
var $author$project$Components$AddressInput$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var address = msg.a.a;
					var updatedModel = _Utils_update(
						model,
						{
							SD: A3(
								$author$project$Utils$Form$update,
								$author$project$Components$AddressInput$formFieldsUpdate,
								$author$project$Components$AddressInput$Address1(address),
								model.SD)
						});
					var _v2 = function () {
						if (!address.$) {
							var addressText = address.a;
							return A3($jinjor$elm_debounce$Debounce$push, $author$project$Components$AddressInput$debounceConfig, addressText, model.i5);
						} else {
							return _Utils_Tuple2(model.i5, $elm$core$Platform$Cmd$none);
						}
					}();
					var debounce = _v2.a;
					var cmd = _v2.b;
					return _Utils_Tuple3(
						_Utils_update(
							updatedModel,
							{i5: debounce}),
						cmd,
						_List_Nil);
				} else {
					var field = msg.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								SD: A3($author$project$Utils$Form$update, $author$project$Components$AddressInput$formFieldsUpdate, field, model.SD)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 1:
				return _Utils_Tuple3(
					$author$project$Components$AddressInput$validate(model),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var subMsg = msg.a;
				var wasOpen = model.ij.Yn;
				var _v4 = A2($author$project$Ui$Dropdown$update, subMsg, model.ij);
				var address1Dropdown = _v4.a;
				var cmd = _v4.b;
				var updatedModel = _Utils_update(
					model,
					{ij: address1Dropdown});
				return (wasOpen && (!address1Dropdown.Yn)) ? _Utils_Tuple3(
					$author$project$Components$AddressInput$validate(updatedModel),
					cmd,
					_List_Nil) : _Utils_Tuple3(updatedModel, cmd, _List_Nil);
			case 4:
				var debounceMsg = msg.a;
				var _v5 = A4(
					$jinjor$elm_debounce$Debounce$update,
					$author$project$Components$AddressInput$debounceConfig,
					$jinjor$elm_debounce$Debounce$takeLast($author$project$Components$AddressInput$debounceAddress),
					debounceMsg,
					model.i5);
				var debounce = _v5.a;
				var cmd = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{i5: debounce}),
					cmd,
					_List_Nil);
			case 5:
				var searchTerm = msg.a;
				return _Utils_Tuple3(
					model,
					$author$project$Api$GoogleMaps$AutocompleteSuggestion$getAutocompleteSuggestions(
						{ahP: model.ahP, alf: searchTerm}),
					_List_Nil);
			case 2:
				var id = msg.a;
				var placeResult = msg.b;
				if (_Utils_eq(id, model.ahP)) {
					if (!placeResult.$) {
						var place = placeResult.a;
						var newForm = A3($author$project$Components$AddressInput$updateFormByPlace, place, model.SD, model.bj);
						var newModel = _Utils_update(
							model,
							{SD: newForm});
						return _Utils_Tuple3(
							$author$project$Components$AddressInput$validate(newModel),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						var error = placeResult.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									$author$project$OutMsg$DecodeFailed(error)
								]));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var id = msg.a;
				var suggestionsResult = msg.b;
				if (_Utils_eq(id, model.ahP)) {
					if (!suggestionsResult.$) {
						var suggestions = suggestionsResult.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{alP: suggestions}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						var error = suggestionsResult.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{alP: _List_Nil}),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									$author$project$OutMsg$DecodeFailed(error)
								]));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var suggestion = msg.a;
				var updatedModel = _Utils_update(
					model,
					{
						SD: A3(
							$author$project$Utils$Form$update,
							$author$project$Components$AddressInput$formFieldsUpdate,
							$author$project$Components$AddressInput$Address1(
								$elm$core$Maybe$Just(suggestion.Qr)),
							model.SD),
						alP: _List_Nil
					});
				return _Utils_Tuple3(
					updatedModel,
					$author$project$Api$GoogleMaps$Place$getPlaceDetails(
						{
							ahP: model.ahP,
							ZC: $author$project$Api$GoogleMaps$AutocompleteSuggestion$placeId(suggestion)
						}),
					_List_Nil);
		}
	});
var $author$project$Components$Admin$Location$DeleteModal$Deleted = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Admin$Location$DeleteModal$LocationDeleted = 1;
var $author$project$Components$Admin$Location$DeleteModal$None = 0;
var $author$project$Components$Admin$Location$DeleteModal$isValid = function (action) {
	if (!action.$) {
		var newLocation = action.a;
		return $author$project$Utils$Maybe$toBool(newLocation);
	} else {
		return true;
	}
};
var $author$project$Components$Admin$Location$DeleteModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: $author$project$Components$Admin$Location$DeleteModal$Closed, aR: _List_Nil};
			case 2:
				var action = msg.a;
				if (model.$ === 1) {
					var location = model.a;
					var remainingLocations = model.b;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: A4($author$project$Components$Admin$Location$DeleteModal$Open, location, remainingLocations, action, $author$project$Api$Data$NotAsked),
						aR: _List_Nil
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: $author$project$Components$Admin$Location$DeleteModal$Closed, aR: _List_Nil};
				}
			case 4:
				var id = msg.a;
				if (model.$ === 1) {
					var location = model.a;
					var remainingLocations = model.b;
					var action = model.c;
					var response = model.d;
					if (!action.$) {
						var newLocation = A2(
							$elm_community$list_extra$List$Extra$find,
							function (location_) {
								return _Utils_eq(
									id,
									$author$project$Api$Provider$Location$All$id(location_));
							},
							remainingLocations);
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 0,
							aiO: A4(
								$author$project$Components$Admin$Location$DeleteModal$Open,
								location,
								remainingLocations,
								$author$project$Components$Admin$Location$DeleteModal$Reassign(newLocation),
								response),
							aR: _List_Nil
						};
					} else {
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 0,
							aiO: A4($author$project$Components$Admin$Location$DeleteModal$Open, location, remainingLocations, $author$project$Components$Admin$Location$DeleteModal$RemoveAssignment, response),
							aR: _List_Nil
						};
					}
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: $author$project$Components$Admin$Location$DeleteModal$Closed, aR: _List_Nil};
				}
			case 1:
				if (model.$ === 1) {
					var location = model.a;
					var remainingLocations = model.b;
					var action = model.c;
					if ($author$project$Components$Admin$Location$DeleteModal$isValid(action)) {
						var newLocation = function () {
							if (!action.$) {
								var newLocation_ = action.a;
								return newLocation_;
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}();
						return {
							GZ: A4(
								$author$project$Api$Provider$Location$delete,
								apiClient,
								$author$project$Api$Provider$Location$All$id(location),
								A2($elm$core$Maybe$map, $author$project$Api$Provider$Location$All$id, newLocation),
								$author$project$Components$Admin$Location$DeleteModal$Deleted(newLocation)),
							agZ: 0,
							aiO: A4($author$project$Components$Admin$Location$DeleteModal$Open, location, remainingLocations, action, $author$project$Api$Data$Loading),
							aR: _List_Nil
						};
					} else {
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 0,
							aiO: A4($author$project$Components$Admin$Location$DeleteModal$Open, location, remainingLocations, action, $author$project$Api$Data$NotAsked),
							aR: _List_Nil
						};
					}
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: $author$project$Components$Admin$Location$DeleteModal$Closed, aR: _List_Nil};
				}
			default:
				var newLocation = msg.a;
				var response = msg.b;
				if (model.$ === 1) {
					var location = model.a;
					var remainingLocations = model.b;
					var action = model.c;
					switch (response.$) {
						case 3:
							var message = function () {
								if (!newLocation.$) {
									var newLocation_ = newLocation.a;
									return $elm$core$String$concat(
										_List_fromArray(
											[
												' All patients currently assigned to ',
												$author$project$Api$Provider$Location$All$name(location),
												' will be assigned to ',
												$author$project$Api$Provider$Location$All$name(newLocation_),
												'.',
												'For large volumes of patients, this may take a few minutes behind the scenes.'
											]));
								} else {
									return '';
								}
							}();
							return {
								GZ: $elm$core$Platform$Cmd$none,
								agZ: 1,
								aiO: $author$project$Components$Admin$Location$DeleteModal$Closed,
								aR: _List_fromArray(
									[
										A2(
										$author$project$OutMsg$ShowToast,
										3,
										$author$project$Api$Provider$Location$All$name(location) + (' was successfully removed.' + message)),
										$author$project$OutMsg$RefreshPractice
									])
							};
						case 2:
							return {
								GZ: $elm$core$Platform$Cmd$none,
								agZ: 0,
								aiO: A4($author$project$Components$Admin$Location$DeleteModal$Open, location, remainingLocations, action, response),
								aR: $author$project$OutMsg$handleErrorResponse(response)
							};
						default:
							return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
					}
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: $author$project$Components$Admin$Location$DeleteModal$Closed, aR: _List_Nil};
				}
		}
	});
var $author$project$Components$LinkedRecords$GotLinkedRecords = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$LinkedRecords$Open = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$LinkedRecord$All$LinkedRecord = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$LinkedRecord$Shared$LinkedRecord = $elm$core$Basics$identity;
var $author$project$Api$Provider$LinkedRecord$Shared$Record = function (id) {
	return {ahP: id};
};
var $author$project$Api$Provider$LinkedRecord$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'id',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$LinkedRecord$Shared$Record));
var $author$project$Api$Provider$LinkedRecord$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$LinkedRecord$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$LinkedRecord$All$AllRecord = function (practice) {
	return {ZV: practice};
};
var $author$project$Api$Provider$LinkedRecord$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'practice',
	$author$project$Api$Provider$Practice$Min$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$LinkedRecord$All$AllRecord));
var $author$project$Api$Provider$LinkedRecord$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$LinkedRecord$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$LinkedRecord$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$LinkedRecord$All$LinkedRecord)));
var $author$project$Api$Provider$LinkedRecord$linkablePath = function (linkable) {
	var id_ = linkable;
	return $author$project$Api$Provider$Location$locationPath(id_);
};
var $author$project$Api$Provider$LinkedRecord$linkedRecordsPath = function (linkable) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['linked_records']),
		$author$project$Api$Provider$LinkedRecord$linkablePath(linkable));
};
var $author$project$Api$Provider$LinkedRecord$list = F3(
	function (apiClient, linkable, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$LinkedRecord$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$LinkedRecord$linkedRecordsPath(linkable)));
	});
var $author$project$Components$LinkedRecords$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var linkable = msg.a;
				return _Utils_Tuple3(
					$author$project$Components$LinkedRecords$Open($author$project$Api$Data$Loading),
					A3($author$project$Api$Provider$LinkedRecord$list, apiClient, linkable, $author$project$Components$LinkedRecords$GotLinkedRecords),
					_List_Nil);
			case 1:
				return _Utils_Tuple3($author$project$Components$LinkedRecords$Closed, $elm$core$Platform$Cmd$none, _List_Nil);
			default:
				var response = msg.a;
				if (model.$ === 1) {
					return _Utils_Tuple3(
						$author$project$Components$LinkedRecords$Open(response),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Admin$Locations$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								j4: response,
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{j4: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$reportDecodeError(response));
				}
			case 1:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Ui$SearchInput$update, subMsg, model.up);
				var searchInput = _v2.a;
				var searchInputCmd = _v2.b;
				var searchInputEvent = _v2.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.akl;
					}
				}();
				var _v3 = function () {
					if (_Utils_eq(q, model.akl)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								j4: $author$project$Api$Data$Loading,
								ajJ: $author$project$Api$Pagination$reset(model.ajJ),
								akl: q
							});
						return _Utils_Tuple2(
							qModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Admin$Locations$fetchList(qModel),
										A2($elm$core$Basics$composeR, $author$project$Pages$Admin$Locations$buildUrl, $author$project$Ports$Navigation$pushUrl)(qModel)
									])));
					}
				}();
				var newModel = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{up: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Locations$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
			case 2:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						j4: $author$project$Api$Data$Loading,
						alA: A2($author$project$Api$Sort$update, columnId, model.alA)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Admin$Locations$fetchList(newModel),
								A2($elm$core$Basics$composeR, $author$project$Pages$Admin$Locations$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 3:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{j4: $author$project$Api$Data$Loading, ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Admin$Locations$fetchList(newModel),
								A2($elm$core$Basics$composeR, $author$project$Pages$Admin$Locations$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 4:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Wa: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$reportDecodeError(response));
			case 5:
				var _v5 = $author$project$Pages$Admin$Locations$formFieldsInit;
				var formFields = _v5.a;
				var cmd = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							Io: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init(formFields),
									$author$project$Api$Data$NotAsked))
						}),
					cmd,
					_List_Nil);
			case 6:
				var _v6 = $author$project$Pages$Admin$Locations$formFieldsForBusinessLocation(
					$author$project$Api$Provider$Practice$One$name(model.ZV));
				var formFields = _v6.a;
				var cmd = _v6.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							Io: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init(formFields),
									$author$project$Api$Data$NotAsked))
						}),
					cmd,
					_List_Nil);
			case 8:
				var item = msg.a;
				var _v7 = $author$project$Pages$Admin$Locations$formFieldsFromItem(item);
				var formFields = _v7.a;
				var cmd = _v7.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							Io: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(
										$author$project$Api$Provider$Location$All$id(item)),
									$author$project$Utils$Form$init(formFields),
									$author$project$Api$Data$NotAsked))
						}),
					cmd,
					_List_Nil);
			case 7:
				var item = msg.a;
				var _v8 = $author$project$Pages$Admin$Locations$formFieldsFromBusinessLocation(item);
				var formFields = _v8.a;
				var cmd = _v8.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							Io: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(
										$author$project$Api$Provider$Location$All$id(item)),
									$author$project$Utils$Form$init(formFields),
									$author$project$Api$Data$NotAsked))
						}),
					cmd,
					_List_Nil);
			case 9:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Io: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 10:
				var field = msg.a;
				var _v9 = model.Io;
				if (!_v9.$) {
					var _v10 = _v9.a;
					var id = _v10.a;
					var form = _v10.b;
					var item = _v10.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$Locations$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Io: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, item))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 12:
				var form = msg.a;
				var id = msg.b;
				var fields = $author$project$Utils$Form$fields(form);
				var address = A2($elm$core$Maybe$map, $author$project$Components$AddressInput$validate, fields.K2);
				var newForm = function () {
					if (!address.$) {
						var address_ = address.a;
						return A3(
							$author$project$Utils$Form$update,
							$author$project$Pages$Admin$Locations$formFieldsUpdate,
							$author$project$Pages$Admin$Locations$Address(address_),
							form);
					} else {
						return form;
					}
				}();
				var _v11 = A2(
					$author$project$Utils$Form$validate,
					$author$project$Pages$Admin$Locations$formFieldsValidator(
						$author$project$Api$Provider$Practice$One$requireGroupForLocations(model.ZV)),
					newForm);
				if (!_v11.$) {
					var _v12 = _v11.a;
					var validatedForm = _v12.a;
					var validFormFields = _v12.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Io: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, validatedForm, $author$project$Api$Data$Loading))
							}),
						A3($author$project$Pages$Admin$Locations$saveItem, model.Gv, id, validFormFields),
						_List_Nil);
				} else {
					var validatedForm = _v11.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Io: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, validatedForm, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 11:
				var item = msg.a;
				var locations = msg.b;
				if (($elm$core$List$length(locations) === 1) && $author$project$Api$Provider$Practice$One$trackPatientsByLocation(model.ZV)) {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 1, 'Practice tracks patients by locations. Can\'t delete last one.')
							]));
				} else {
					var _v14 = _Utils_Tuple2(
						A2(
							$author$project$Api$Expandable$withDefault,
							true,
							$author$project$Api$Provider$Location$All$hasPatients(item)),
						$author$project$Api$Provider$Location$All$isMaster(item) || $author$project$Api$Provider$Location$All$isSynced(item));
					if (_v14.a) {
						if (_v14.b) {
							return _Utils_Tuple3(
								model,
								$elm$core$Platform$Cmd$none,
								_List_fromArray(
									[
										A2($author$project$OutMsg$ShowToast, 2, 'This location is currently part of an affiliation. Please contact us to unlink this location prior to deletion')
									]));
						} else {
							var remainingLocations = A2(
								$elm$core$List$filter,
								function (remainingLocation) {
									return !_Utils_eq(
										$author$project$Api$Provider$Location$All$id(item),
										$author$project$Api$Provider$Location$All$id(remainingLocation));
								},
								locations);
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										i8: A2($author$project$Components$Admin$Location$DeleteModal$open, item, remainingLocations)
									}),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
						}
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									je: $elm$core$Maybe$Just(item)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				}
			case 13:
				var response = msg.a;
				var _v15 = model.Io;
				if (!_v15.$) {
					var _v16 = _v15.a;
					var id = _v16.a;
					var form = _v16.b;
					if (response.$ === 3) {
						var item = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{Io: $elm$core$Maybe$Nothing, j4: $author$project$Api$Data$Loading}),
							$author$project$Pages$Admin$Locations$fetchList(model),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									'Successfully created ' + $author$project$Api$Provider$Location$One$name(item)),
									$author$project$OutMsg$RefreshPractice
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									Io: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 14:
				var response = msg.a;
				var _v18 = model.Io;
				if (!_v18.$) {
					var _v19 = _v18.a;
					var id = _v19.a;
					var form = _v19.b;
					if (response.$ === 3) {
						var item = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{Io: $elm$core$Maybe$Nothing, j4: $author$project$Api$Data$Loading}),
							$author$project$Pages$Admin$Locations$fetchList(model),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Provider$Location$One$name(item) + ' was successfully updated.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									Io: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 15:
				var item = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									eg: A2(
										$elm$core$Set$remove,
										$author$project$Api$Provider$Location$All$id(item),
										model.eg),
									j4: $author$project$Api$Data$Loading
								}),
							$author$project$Pages$Admin$Locations$fetchList(model),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Provider$Location$All$name(item) + ' was successfully removed.'),
									$author$project$OutMsg$RefreshPractice
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									eg: A2(
										$elm$core$Set$remove,
										$author$project$Api$Provider$Location$All$id(item),
										model.eg)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 16:
				var item = msg.a;
				var confirmed = msg.b;
				if (confirmed) {
					var id = $author$project$Api$Provider$Location$All$id(item);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								je: $elm$core$Maybe$Nothing,
								eg: A2($elm$core$Set$insert, id, model.eg)
							}),
						A4(
							$author$project$Api$Provider$Location$delete,
							model.Gv,
							id,
							$elm$core$Maybe$Nothing,
							$author$project$Pages$Admin$Locations$Deleted(item)),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{je: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 17:
				var subMsg = msg.a;
				var _v22 = A3($author$project$Components$LinkedRecords$update, model.Gv, subMsg, model.oo);
				var linkedRecords = _v22.a;
				var subCmd = _v22.b;
				var subOutMsg = _v22.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oo: linkedRecords}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Locations$LinkedRecordsMsg, subCmd),
					subOutMsg);
			case 18:
				var subMsg = msg.a;
				var _v23 = model.Io;
				if (!_v23.$) {
					var _v24 = _v23.a;
					var id = _v24.a;
					var form = _v24.b;
					var item = _v24.c;
					var _v25 = $author$project$Utils$Form$fields(form);
					var phone = _v25.Zw;
					var _v26 = A2($author$project$Components$PhoneInput$update, subMsg, phone);
					var phoneInput = _v26.a;
					var phoneCmd = _v26.b;
					var newForm = A3(
						$author$project$Utils$Form$update,
						$author$project$Pages$Admin$Locations$formFieldsUpdate,
						$author$project$Pages$Admin$Locations$Phone(phoneInput),
						form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Io: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, item))
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Locations$PhoneInputMsg, phoneCmd),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 19:
				var subMsg = msg.a;
				var _v27 = model.Io;
				if (!_v27.$) {
					var _v28 = _v27.a;
					var id = _v28.a;
					var form = _v28.b;
					var item = _v28.c;
					var _v29 = $author$project$Utils$Form$fields(form);
					var address = _v29.K2;
					if (!address.$) {
						var address_ = address.a;
						var _v31 = A2($author$project$Components$AddressInput$update, subMsg, address_);
						var addressInputModel = _v31.a;
						var addressInputCmd = _v31.b;
						var outMsgs = _v31.c;
						var newForm = A3(
							$author$project$Utils$Form$update,
							$author$project$Pages$Admin$Locations$formFieldsUpdate,
							$author$project$Pages$Admin$Locations$Address(addressInputModel),
							form);
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									Io: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, newForm, item))
								}),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Locations$AddressInputMsg, addressInputCmd),
							outMsgs);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 20:
				var subMsg = msg.a;
				var result = A3($author$project$Components$Admin$Location$DeleteModal$update, model.Gv, subMsg, model.i8);
				var _v32 = function () {
					var _v33 = result.agZ;
					if (_v33 === 1) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{j4: $author$project$Api$Data$Loading}),
							$author$project$Pages$Admin$Locations$fetchList(model));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				}();
				var newModel = _v32.a;
				var cmd = _v32.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{i8: result.aiO}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								cmd,
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Locations$DeleteModalMsg, result.GZ)
							])),
					result.aR);
			default:
				var subMsg = msg.a;
				var _v34 = A3($author$project$Components$ExportCsv$update, model.Gv, subMsg, model.nD);
				var exportCsv = _v34.a;
				var subCmd = _v34.b;
				var subOutMsg = _v34.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nD: exportCsv}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Locations$ExportCsvMsg, subCmd),
					subOutMsg);
		}
	});
var $author$project$Pages$Admin$Locations$New = {$: 5};
var $author$project$Pages$Admin$Locations$NewBusinessAddress = {$: 6};
var $author$project$Pages$Admin$Locations$PaginationMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Practice$One$hasBusinessLocation = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.MY;
		},
		$author$project$Utils$Maybe$toBool));
var $author$project$Api$Provider$LinkedRecord$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$LinkedRecord$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$LinkedRecord$Shared$id(shared);
};
var $author$project$Api$Provider$LinkedRecord$All$practice = function (_v0) {
	var record = _v0.b;
	return record.ZV;
};
var $author$project$Components$LinkedRecords$viewLinkedRecord = function (linkedRecord) {
	return A2(
		$author$project$Ui$Table$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Provider$Practice$Min$name(
							$author$project$Api$Provider$LinkedRecord$All$practice(linkedRecord)))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Provider$LinkedRecord$All$id(linkedRecord))
					]))
			]));
};
var $author$project$Components$LinkedRecords$viewTable = function (linkedRecords) {
	var _v0 = function () {
		if (linkedRecords.$ === 3) {
			var list = linkedRecords.a;
			return _Utils_Tuple2(false, list);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var linkedRecords_ = _v0.b;
	return A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$loading(loading),
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('No linked records.')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Practice Name')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Linked Record ID')
					]))
			]),
		A2($elm$core$List$map, $author$project$Components$LinkedRecords$viewLinkedRecord, linkedRecords_),
		_List_Nil);
};
var $author$project$Components$LinkedRecords$modal = function (model) {
	if (model.$ === 1) {
		var linkedRecords = model.a;
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$LinkedRecords$CloseModal,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('Linked Records')
								]))
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							$author$project$Components$LinkedRecords$viewTable(linkedRecords)
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Cancel and close modal'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$onClick($author$project$Components$LinkedRecords$CloseModal)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Close')
								]))
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Admin$Location$DeleteModal$Delete = {$: 1};
var $author$project$Components$Admin$Location$DeleteModal$UpdateAction = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$Location$DeleteModal$UpdateNewLocation = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$Location$DeleteModal$locationOptions = function (locations) {
	return A2(
		$elm$core$List$cons,
		A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(''),
			'Choose a location...'),
		A2(
			$elm$core$List$map,
			function (location) {
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$Location$All$id(location)),
					$author$project$Api$Provider$Location$All$name(location));
			},
			locations));
};
var $author$project$Components$Admin$Location$DeleteModal$viewModal = F4(
	function (location, remainingLocations, action, request) {
		var _v0 = function () {
			if (!action.$) {
				return _Utils_Tuple2(true, false);
			} else {
				return _Utils_Tuple2(false, true);
			}
		}();
		var reassignActive = _v0.a;
		var removeAssignmentActive = _v0.b;
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$Admin$Location$DeleteModal$CloseModal,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('What would you like to do with patients assigned to this location?')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Action'),
									$author$project$Ui$Form$Group$labelSpan(2),
									$author$project$Ui$Form$Group$inputSpan(10)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Button$group(
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{mm: 'Reasign to new location'},
											_List_fromArray(
												[
													$author$project$Ui$Button$active(reassignActive),
													$author$project$Ui$Button$disabled(
													$elm$core$List$isEmpty(remainingLocations)),
													$author$project$Ui$Button$onClick(
													$author$project$Components$Admin$Location$DeleteModal$UpdateAction(
														$author$project$Components$Admin$Location$DeleteModal$Reassign($elm$core$Maybe$Nothing)))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Reassign')
												])),
											A3(
											$author$project$Ui$Button$view,
											{mm: 'Remove location assignment'},
											_List_fromArray(
												[
													$author$project$Ui$Button$active(removeAssignmentActive),
													$author$project$Ui$Button$onClick(
													$author$project$Components$Admin$Location$DeleteModal$UpdateAction($author$project$Components$Admin$Location$DeleteModal$RemoveAssignment))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Remove assignment')
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pt-05')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
											_List_fromArray(
												[
													function () {
													if (!action.$) {
														return $elm$html$Html$text(
															'All patients currently assigned to ' + ($author$project$Api$Provider$Location$All$name(location) + ' will be assigned to the location selected below'));
													} else {
														return $elm$html$Html$text(
															'All patients currently assigned to ' + ($author$project$Api$Provider$Location$All$name(location) + ' will no longer be assigned to a location'));
													}
												}()
												]))
										])),
									function () {
									if (!action.$) {
										var newLocation = action.a;
										var newLocationInvalid = !$author$project$Utils$Maybe$toBool(newLocation);
										return A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pt-05')
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Form$Select$view,
													_List_fromArray(
														[
															$author$project$Ui$Form$Select$value(
															A2($elm$core$Maybe$map, $author$project$Api$Provider$Location$All$id, newLocation)),
															$author$project$Ui$Form$Select$onChange($author$project$Components$Admin$Location$DeleteModal$UpdateNewLocation),
															$author$project$Ui$Form$Select$invalid(newLocationInvalid),
															$author$project$Ui$Form$Select$errors(
															newLocationInvalid ? _List_fromArray(
																['Please pick a location for reassignment']) : _List_Nil)
														]),
													$author$project$Components$Admin$Location$DeleteModal$locationOptions(remainingLocations))
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								]))
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Cancel and close modal'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Components$Admin$Location$DeleteModal$CloseModal)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Delete location'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$loading(
									_Utils_eq(request, $author$project$Api$Data$Loading)),
									$author$project$Ui$Button$onClick($author$project$Components$Admin$Location$DeleteModal$Delete),
									$author$project$Ui$Button$icon($author$project$Ui$Icon$check)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Delete')
								]))
						]))
				]));
	});
var $author$project$Components$Admin$Location$DeleteModal$view = function (model) {
	if (model.$ === 1) {
		var location = model.a;
		var remainingLocations = model.b;
		var action = model.c;
		var request = model.d;
		return A4($author$project$Components$Admin$Location$DeleteModal$viewModal, location, remainingLocations, action, request);
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Admin$Locations$FormUpdated = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Admin$Locations$LocationGroup = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Admin$Locations$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$Locations$OnlineSignupVisibility = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$Locations$Save = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Pages$Admin$Locations$Virtual = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$Select$Loading = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Form$Select$loading = $author$project$Ui$Form$Select$Loading;
var $author$project$Api$Provider$LocationGroup$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$LocationGroup$Shared$id(shared);
};
var $author$project$Api$Common$LocationGroup$Min$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Common$LocationGroup$Shared$name = function (_v0) {
	var min = _v0;
	return $author$project$Api$Common$LocationGroup$Min$name(min);
};
var $author$project$Api$Provider$LocationGroup$All$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$LocationGroup$Shared$name(shared);
};
var $author$project$Pages$Admin$Locations$locationGroupOptions = function (locationGroups) {
	return A2(
		$elm$core$List$cons,
		A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(''),
			'None'),
		A2(
			$elm$core$List$map,
			function (locationGroup) {
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$LocationGroup$All$id(locationGroup)),
					$author$project$Api$Provider$LocationGroup$All$name(locationGroup));
			},
			locationGroups));
};
var $author$project$Components$AddressInput$CountryValidation = 4;
var $author$project$Components$AddressInput$FieldBlurred = {$: 1};
var $author$project$Components$AddressInput$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$AddressInput$SuggestionSelected = function (a) {
	return {$: 7, a: a};
};
var $author$project$Ui$Form$Input$AriaLabel = function (a) {
	return {$: 24, a: a};
};
var $author$project$Ui$Form$Input$ariaLabel = $author$project$Ui$Form$Input$AriaLabel;
var $author$project$Ui$Dropdown$ComboboxPlaceholder = function (a) {
	return {$: 7, a: a};
};
var $author$project$Ui$Dropdown$comboboxPlaceholder = $author$project$Ui$Dropdown$ComboboxPlaceholder;
var $author$project$Ui$Form$Input$MaxLength = function (a) {
	return {$: 21, a: a};
};
var $author$project$Ui$Form$Input$maxLength = $author$project$Ui$Form$Input$MaxLength;
var $author$project$Components$AddressInput$defaultOptions = {ep: false};
var $author$project$Components$AddressInput$updateOptionsRecord = F2(
	function (option, options) {
		var bool = option;
		return _Utils_update(
			options,
			{ep: bool});
	});
var $author$project$Components$AddressInput$optionsListToRecord = function (optionsList) {
	return A3($elm$core$List$foldl, $author$project$Components$AddressInput$updateOptionsRecord, $author$project$Components$AddressInput$defaultOptions, optionsList);
};
var $author$project$Components$AddressInput$validationGroupElementId = F2(
	function (modelId, validationGroup) {
		switch (validationGroup) {
			case 0:
				return modelId + '-address';
			case 1:
				return modelId + '-city';
			case 2:
				return modelId + '-state';
			case 3:
				return modelId + '-zip';
			default:
				return modelId + '-country';
		}
	});
var $author$project$Ui$Dropdown$ComboboxInputFocused = {$: 2};
var $author$project$Ui$Dropdown$ComboboxInputTyped = {$: 1};
var $author$project$Ui$Dropdown$comboboxTriggerKeyHandlers = F2(
	function (onEnterMsg, toMsg) {
		return A2(
			$elm$html$Html$Events$custom,
			'keydown',
			A2(
				$elm$json$Json$Decode$andThen,
				function (key) {
					var andPreventDefault = $elm$json$Json$Decode$map(
						function (msg_) {
							return {aiH: msg_, akc: true, alJ: true};
						});
					switch (key) {
						case 'ArrowDown':
							return andPreventDefault(
								$elm$json$Json$Decode$succeed(
									toMsg(
										$author$project$Ui$Dropdown$ArrowPressed(1))));
						case 'ArrowUp':
							return andPreventDefault(
								$elm$json$Json$Decode$succeed(
									toMsg(
										$author$project$Ui$Dropdown$ArrowPressed(0))));
						case 'Enter':
							if (!onEnterMsg.$) {
								var msg = onEnterMsg.a;
								return andPreventDefault(
									$elm$json$Json$Decode$succeed(msg));
							} else {
								return $elm$json$Json$Decode$fail('ignore');
							}
						default:
							return $elm$json$Json$Decode$succeed(
								{
									aiH: toMsg($author$project$Ui$Dropdown$ComboboxInputTyped),
									akc: false,
									alJ: false
								});
					}
				},
				A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string)));
	});
var $author$project$Ui$Dropdown$decodePressedKey = F2(
	function (expectedKey, toMsg) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (key) {
				return _Utils_eq(key, expectedKey) ? $elm$json$Json$Decode$succeed(toMsg) : $elm$json$Json$Decode$fail('ignore');
			},
			A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
	});
var $author$project$Ui$Dropdown$onEnterUp = function (msg) {
	return A2(
		$elm$html$Html$Events$custom,
		'keyup',
		A2(
			$elm$json$Json$Decode$map,
			function (msg_) {
				return {aiH: msg_, akc: true, alJ: true};
			},
			A2($author$project$Ui$Dropdown$decodePressedKey, 'Enter', msg)));
};
var $author$project$Ui$Dropdown$viewCombobox = F4(
	function (options, inputOptions, items, model) {
		var toMsg = model.al6;
		var optionsRecord = $author$project$Ui$Dropdown$optionsToRecord(options);
		var errorDescription = $elm$core$List$isEmpty(optionsRecord.agX) ? _List_Nil : _List_fromArray(
			[
				A2(
				$elm$html$Html$Attributes$attribute,
				'aria-describedby',
				A2($elm$core$String$join, '. ', optionsRecord.agX))
			]);
		var ariaInvalid = (optionsRecord.sM || (!$elm$core$List$isEmpty(optionsRecord.agX))) ? _List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'aria-invalid', 'true')
			]) : _List_Nil;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('dropdown'),
					$elm$html$Html$Attributes$id(model.ahP),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('dropdown--open', model.Yn && ((!optionsRecord.ep) && (!optionsRecord.ua))),
							_Utils_Tuple2(
							'dropdown--invalid',
							optionsRecord.sM || (!$elm$core$List$isEmpty(optionsRecord.agX))),
							_Utils_Tuple2('dropdown--disabled', optionsRecord.ep),
							_Utils_Tuple2('dropdown--readonly', optionsRecord.ua)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('dropdown__trigger dropdown__trigger--input'),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$id(model.ahP + '-trigger'),
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$type_('text'),
								A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$autocomplete(false),
									A2(
										$elm$core$List$cons,
										A2($elm$html$Html$Attributes$attribute, 'aria-haspopup', 'listbox'),
										A2(
											$elm$core$List$cons,
											$elm$html$Html$Events$onFocus(
												toMsg($author$project$Ui$Dropdown$ComboboxInputFocused)),
											A2(
												$elm$core$List$cons,
												$elm$html$Html$Attributes$type_('combobox'),
												A2(
													$elm$core$List$cons,
													$elm$html$Html$Events$onInput(inputOptions.ajm),
													A2(
														$elm$core$List$cons,
														$elm$html$Html$Attributes$placeholder(optionsRecord.x9),
														A2(
															$elm$core$List$cons,
															$elm$html$Html$Attributes$value(inputOptions.aee),
															A2(
																$elm$core$List$cons,
																A2(
																	$elm$html$Html$Attributes$attribute,
																	'aria-expanded',
																	model.Yn ? 'true' : 'false'),
																A2(
																	$elm$core$List$cons,
																	$elm$core$String$isEmpty(optionsRecord.mm) ? $elm$html$Html$Attributes$class('') : A2($elm$html$Html$Attributes$attribute, 'aria-label', optionsRecord.mm),
																	A2(
																		$elm$core$List$cons,
																		A2($elm$html$Html$Attributes$attribute, 'aria-controls', 'options-list'),
																		A2(
																			$elm$core$List$cons,
																			model.Yn ? A2(
																				$elm$html$Html$Attributes$map,
																				toMsg,
																				$author$project$Ui$Dropdown$onEnterUp($author$project$Ui$Dropdown$DropdownButtonClicked)) : $elm$html$Html$Attributes$class(''),
																			_Utils_ap(
																				optionsRecord.ep ? _List_fromArray(
																					[
																						A2($elm$html$Html$Attributes$attribute, 'aria-disabled', 'true'),
																						$elm$html$Html$Attributes$disabled(true)
																					]) : (optionsRecord.ua ? _List_fromArray(
																					[
																						$elm$html$Html$Attributes$readonly(true)
																					]) : _List_fromArray(
																					[
																						A2(
																						$author$project$Ui$Dropdown$comboboxTriggerKeyHandlers,
																						model.Yn ? inputOptions.aji : $elm$core$Maybe$Nothing,
																						toMsg)
																					])),
																				_Utils_ap(errorDescription, ariaInvalid)))))))))))))))),
					_List_Nil),
					(optionsRecord.ep || optionsRecord.ua) ? $elm$html$Html$text('') : ($elm$core$List$isEmpty(items) ? $elm$html$Html$text('') : A3($author$project$Ui$Dropdown$viewMenu, toMsg, model, items))
				]));
	});
var $author$project$Components$AddressInput$view = F2(
	function (options, _v0) {
		var model = _v0;
		var optionsRecord = $author$project$Components$AddressInput$optionsListToRecord(options);
		var _v1 = model.bj ? _Utils_Tuple3(7, 5, 4) : _Utils_Tuple3(5, 4, 3);
		var cityColumnSize = _v1.a;
		var stateColumnSize = _v1.b;
		var zipColumnSize = _v1.c;
		var _v2 = $author$project$Utils$Form$fields(model.SD);
		var address1 = _v2.cZ;
		var address2 = _v2.fA;
		var city = _v2.rE;
		var state = _v2.uP;
		var zip = _v2.vv;
		var country = _v2.rK;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id(model.ahP)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('select')
										]),
									_List_fromArray(
										[
											A4(
											$author$project$Ui$Dropdown$viewCombobox,
											_List_fromArray(
												[
													$author$project$Ui$Dropdown$invalid(
													A2($author$project$Utils$Form$hasValidationErrors, 0, model.SD)),
													$author$project$Ui$Dropdown$disabled(optionsRecord.ep),
													$author$project$Ui$Dropdown$comboboxPlaceholder('Address line 1')
												]),
											{
												aji: A2(
													$elm$core$Maybe$map,
													$author$project$Components$AddressInput$SuggestionSelected,
													$elm$core$List$head(model.alP)),
												ajm: A2(
													$elm$core$Basics$composeL,
													A2($elm$core$Basics$composeL, $author$project$Components$AddressInput$FormUpdated, $author$project$Components$AddressInput$Address1),
													$author$project$Utils$String$toMaybe),
												aee: A2($elm$core$Maybe$withDefault, '', address1)
											},
											A2(
												$elm$core$List$map,
												function (suggestion) {
													return A2(
														$author$project$Ui$Dropdown$item,
														_List_fromArray(
															[
																$author$project$Ui$Dropdown$onSelect(
																$author$project$Components$AddressInput$SuggestionSelected(suggestion))
															]),
														$elm$html$Html$text(suggestion.Qr));
												},
												model.alP),
											model.ij)
										])),
									$author$project$Utils$FormErrors$view(
									A2($author$project$Utils$Form$validationErrors, 0, model.SD))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(
											A2($elm$core$Maybe$withDefault, '', address2)),
											$author$project$Ui$Form$Input$onInput(
											A2(
												$elm$core$Basics$composeL,
												A2($elm$core$Basics$composeL, $author$project$Components$AddressInput$FormUpdated, $author$project$Components$AddressInput$Address2),
												$author$project$Utils$String$toMaybe)),
											$author$project$Ui$Form$Input$onBlur($author$project$Components$AddressInput$FieldBlurred),
											$author$project$Ui$Form$Input$disabled(optionsRecord.ep),
											$author$project$Ui$Form$Input$placeholder('Address line 2'),
											$author$project$Ui$Form$Input$ariaLabel('Address line 2'),
											$author$project$Ui$Form$Input$maxLength(50),
											$author$project$Ui$Form$Input$autoComplete(false),
											$author$project$Ui$Form$Input$autoCorrect(false),
											$author$project$Ui$Form$Input$autoCapitalize(false),
											$author$project$Ui$Form$Input$spellCheck(false),
											$author$project$Ui$Form$Input$phi(true)
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanMd(cityColumnSize)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$id(
											A2($author$project$Components$AddressInput$validationGroupElementId, model.ahP, 1)),
											$author$project$Ui$Form$Input$value(
											A2($elm$core$Maybe$withDefault, '', city)),
											$author$project$Ui$Form$Input$onInput(
											A2(
												$elm$core$Basics$composeL,
												A2($elm$core$Basics$composeL, $author$project$Components$AddressInput$FormUpdated, $author$project$Components$AddressInput$City),
												$author$project$Utils$String$toMaybe)),
											$author$project$Ui$Form$Input$onBlur($author$project$Components$AddressInput$FieldBlurred),
											$author$project$Ui$Form$Input$invalid(
											A2($author$project$Utils$Form$hasValidationErrors, 1, model.SD)),
											$author$project$Ui$Form$Input$disabled(optionsRecord.ep),
											$author$project$Ui$Form$Input$placeholder('City'),
											$author$project$Ui$Form$Input$ariaLabel('City')
										])),
									$author$project$Utils$FormErrors$view(
									A2($author$project$Utils$Form$validationErrors, 1, model.SD))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanMd(stateColumnSize)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$id(
											A2($author$project$Components$AddressInput$validationGroupElementId, model.ahP, 2)),
											$author$project$Ui$Form$Input$value(
											A2($elm$core$Maybe$withDefault, '', state)),
											$author$project$Ui$Form$Input$onInput(
											A2(
												$elm$core$Basics$composeL,
												A2($elm$core$Basics$composeL, $author$project$Components$AddressInput$FormUpdated, $author$project$Components$AddressInput$State),
												$author$project$Utils$String$toMaybe)),
											$author$project$Ui$Form$Input$onBlur($author$project$Components$AddressInput$FieldBlurred),
											$author$project$Ui$Form$Input$invalid(
											A2($author$project$Utils$Form$hasValidationErrors, 2, model.SD)),
											$author$project$Ui$Form$Input$disabled(optionsRecord.ep),
											$author$project$Ui$Form$Input$placeholder('State'),
											$author$project$Ui$Form$Input$ariaLabel('State')
										])),
									$author$project$Utils$FormErrors$view(
									A2($author$project$Utils$Form$validationErrors, 2, model.SD))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanMd(zipColumnSize)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$id(
											A2($author$project$Components$AddressInput$validationGroupElementId, model.ahP, 3)),
											$author$project$Ui$Form$Input$value(
											A2($elm$core$Maybe$withDefault, '', zip)),
											$author$project$Ui$Form$Input$onInput(
											A2(
												$elm$core$Basics$composeL,
												A2($elm$core$Basics$composeL, $author$project$Components$AddressInput$FormUpdated, $author$project$Components$AddressInput$Zip),
												$author$project$Utils$String$toMaybe)),
											$author$project$Ui$Form$Input$onBlur($author$project$Components$AddressInput$FieldBlurred),
											$author$project$Ui$Form$Input$invalid(
											A2($author$project$Utils$Form$hasValidationErrors, 3, model.SD)),
											$author$project$Ui$Form$Input$disabled(optionsRecord.ep),
											$author$project$Ui$Form$Input$placeholder('Zip Code'),
											$author$project$Ui$Form$Input$ariaLabel('Zip Code'),
											$author$project$Ui$Form$Input$autoComplete(false),
											$author$project$Ui$Form$Input$autoCorrect(false),
											$author$project$Ui$Form$Input$autoCapitalize(false),
											$author$project$Ui$Form$Input$spellCheck(false)
										])),
									$author$project$Utils$FormErrors$view(
									A2($author$project$Utils$Form$validationErrors, 3, model.SD))
								])),
							model.bj ? A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanMd(8)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$id(
											A2($author$project$Components$AddressInput$validationGroupElementId, model.ahP, 4)),
											$author$project$Ui$Form$Input$value(
											A2($elm$core$Maybe$withDefault, '', country)),
											$author$project$Ui$Form$Input$onInput(
											A2(
												$elm$core$Basics$composeL,
												A2($elm$core$Basics$composeL, $author$project$Components$AddressInput$FormUpdated, $author$project$Components$AddressInput$Country),
												$author$project$Utils$String$toMaybe)),
											$author$project$Ui$Form$Input$onBlur($author$project$Components$AddressInput$FieldBlurred),
											$author$project$Ui$Form$Input$invalid(
											A2($author$project$Utils$Form$hasValidationErrors, 4, model.SD)),
											$author$project$Ui$Form$Input$disabled(optionsRecord.ep),
											$author$project$Ui$Form$Input$placeholder('Country'),
											$author$project$Ui$Form$Input$ariaLabel('Country')
										])),
									$author$project$Utils$FormErrors$view(
									A2($author$project$Utils$Form$validationErrors, 4, model.SD))
								])) : A2(
							$author$project$Ui$Grid$column,
							_List_Nil,
							_List_fromArray(
								[$author$project$Utils$Html$empty]))
						]))
				]));
	});
var $author$project$Pages$Admin$Locations$viewModal = F4(
	function (model, id, form, item) {
		var modalConfig = {
			Tq: $elm$core$Maybe$Nothing,
			aih: 'Location',
			V8: _Utils_eq(item, $author$project$Api$Data$Loading),
			WG: id,
			WH: $elm$core$Maybe$Nothing,
			Yd: $author$project$Pages$Admin$Locations$CancelEdit,
			Yf: $author$project$Pages$Admin$Locations$Save(form)
		};
		var fields = $author$project$Utils$Form$fields(form);
		var _v0 = function () {
			var _v1 = model.Wa;
			if (_v1.$ === 3) {
				var locationGroups_ = _v1.a;
				return _Utils_Tuple2(false, locationGroups_);
			} else {
				return _Utils_Tuple2(true, _List_Nil);
			}
		}();
		var locationGroupsLoading = _v0.a;
		var locationGroups = _v0.b;
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Name'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(fields.Bq),
									$author$project$Ui$Form$Input$placeholder('Location Name'),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Locations$FormUpdated, $author$project$Pages$Admin$Locations$Name)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 0, form))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Virtual')
						]),
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$view(
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$on(fields.aej),
									$author$project$Ui$ToggleSwitch$onChange(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Locations$FormUpdated, $author$project$Pages$Admin$Locations$Virtual))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Address'),
							$author$project$Ui$Form$Group$required(!fields.aej)
						]),
					_List_fromArray(
						[
							function () {
							var _v2 = fields.K2;
							if (!_v2.$) {
								var addressInput = _v2.a;
								return A2(
									$elm$html$Html$map,
									$author$project$Pages$Admin$Locations$AddressInputMsg,
									A2($author$project$Components$AddressInput$view, _List_Nil, addressInput));
							} else {
								return A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$core$Maybe$withDefault,
											$author$project$Utils$Html$empty,
											A2(
												$elm$core$Maybe$map,
												$author$project$Components$AddressDisplay$view,
												$author$project$Api$Provider$Practice$One$address(model.ZV))),
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$textMuted]),
											_List_fromArray(
												[
													$elm$html$Html$text('You can edit this address on the '),
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Admin__Practice,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Admin > Account page')
														]))
												]))
										]));
							}
						}()
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Group'),
							$author$project$Ui$Form$Group$required(
							$author$project$Api$Provider$Practice$One$requireGroupForLocations(model.ZV))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(fields.s4),
									$author$project$Ui$Form$Select$onChange(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Locations$FormUpdated, $author$project$Pages$Admin$Locations$LocationGroup)),
									$author$project$Ui$Form$Select$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
									$author$project$Ui$Form$Select$errors(
									A2($author$project$Utils$Form$validationErrors, 1, form)),
									$author$project$Ui$Form$Select$loading(locationGroupsLoading)
								]),
							$author$project$Pages$Admin$Locations$locationGroupOptions(locationGroups))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Phone')
						]),
					function () {
						var _v3 = _Utils_Tuple2(
							fields.MY,
							$elm$core$List$head(
								$author$project$Api$Provider$Practice$One$phones(model.ZV)));
						if (_v3.a) {
							if (!_v3.b.$) {
								var phone = _v3.b.a;
								var _v4 = $author$project$Api$Common$Phone$Shared$number(phone);
								if (!_v4.$) {
									var number = _v4.a;
									return _List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Formatters$Phone$format(number)),
													$elm$html$Html$text(
													' (' + ($author$project$Formatters$PhoneType$toString(
														$author$project$Api$Common$Phone$Shared$type_(phone)) + ')'))
												]))
										]);
								} else {
									return _List_Nil;
								}
							} else {
								var _v5 = _v3.b;
								return _List_Nil;
							}
						} else {
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Pages$Admin$Locations$PhoneInputMsg,
									$author$project$Components$PhoneInput$view(fields.Zw)),
									$author$project$Utils$FormErrors$view(
									A2($author$project$Utils$Form$validationErrors, 3, form))
								]);
						}
					}()),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Allow Online Signup')
						]),
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$view(
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$on(fields.Ym),
									$author$project$Ui$ToggleSwitch$onChange(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Locations$FormUpdated, $author$project$Pages$Admin$Locations$OnlineSignupVisibility))
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$Locations$SortTable = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$Locations$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'name', true, 'Name'),
		A3($author$project$Api$Column$init, '', false, 'Address'),
		A3($author$project$Api$Column$init, '', false, 'Phone'),
		A3($author$project$Api$Column$init, '', false, 'Group'),
		A3($author$project$Api$Column$init, 'online_signup_visibility', true, 'Online signup')
	]);
var $author$project$Pages$Admin$Locations$Delete = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Pages$Admin$Locations$Edit = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Admin$Locations$EditBusinessItemClicked = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$LinkedRecord$Location = $elm$core$Basics$identity;
var $author$project$Components$LinkedRecords$OpenModal = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Icon$Link = 104;
var $author$project$Ui$Icon$link = $author$project$Ui$Icon$viewIcon(104);
var $author$project$Components$LinkedRecords$button = function (linkable) {
	return A3(
		$author$project$Ui$Button$view,
		{mm: 'Link record'},
		_List_fromArray(
			[
				$author$project$Ui$Button$sm,
				$author$project$Ui$Button$onClick(
				$author$project$Components$LinkedRecords$OpenModal(linkable)),
				$author$project$Ui$Button$icon($author$project$Ui$Icon$link)
			]),
		_List_Nil);
};
var $author$project$Api$Provider$Location$Meta$deleteAction = function (_v0) {
	var meta = _v0;
	return meta.vy.Qi;
};
var $author$project$Api$Expandable$map = F2(
	function (f, expandable_) {
		if (!expandable_.$) {
			var a = expandable_.a;
			return $author$project$Api$Expandable$Expanded(
				f(a));
		} else {
			return $author$project$Api$Expandable$NotExpanded;
		}
	});
var $author$project$Api$Provider$Location$All$meta = function (_v0) {
	var record = _v0.b;
	return record.W4;
};
var $author$project$Pages$Admin$Locations$viewItem = F3(
	function (model, items, item) {
		var id = $author$project$Api$Provider$Location$All$id(item);
		var loading = A2($elm$core$Set$member, id, model.eg);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$Location$All$name(item)),
							$author$project$Utils$Html$noBreakSpace,
							model.Ij ? A2(
							$elm$html$Html$map,
							$author$project$Pages$Admin$Locations$LinkedRecordsMsg,
							$author$project$Components$LinkedRecords$button(id)) : $author$project$Utils$Html$empty,
							$author$project$Api$Provider$Location$All$businessLocation(item) ? A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Utils$Html$noBreakSpace,
									$elm$html$Html$text('Business Location')
								])) : $author$project$Utils$Html$empty
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = _Utils_Tuple2(
								$author$project$Api$Provider$Location$All$virtual(item),
								$author$project$Api$Provider$Location$All$address(item));
							if (_v0.a) {
								return A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$muted]),
									_List_fromArray(
										[
											$elm$html$Html$text('Virtual location')
										]));
							} else {
								if (!_v0.b.$) {
									var address = _v0.b.a;
									return $author$project$Components$AddressDisplay$view(address);
								} else {
									var _v1 = _v0.b;
									return $elm$html$Html$text('N/A');
								}
							}
						}()
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[
									$author$project$Ui$Typography$phi(true)
								]),
							A2(
								$elm$core$Maybe$withDefault,
								'N/A',
								A2(
									$elm$core$Maybe$map,
									$author$project$Formatters$Phone$format,
									$author$project$Api$Provider$Location$All$phoneNumber(item))))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'N/A',
								A2(
									$elm$core$Maybe$map,
									$author$project$Api$Common$LocationGroup$Shared$name,
									$author$project$Api$Provider$Location$All$locationGroup(item))))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Api$Provider$Location$All$onlineSignupVisibility(item) ? $author$project$Ui$Icon$check(
							_List_fromArray(
								[$author$project$Ui$Icon$success])) : $author$project$Ui$Icon$cross(
							_List_fromArray(
								[$author$project$Ui$Icon$danger]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Edit location'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$sm,
											$author$project$Api$Provider$Location$All$businessLocation(item) ? $author$project$Ui$Button$onClick(
											$author$project$Pages$Admin$Locations$EditBusinessItemClicked(item)) : $author$project$Ui$Button$onClick(
											$author$project$Pages$Admin$Locations$Edit(item)),
											$author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit')
										])),
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Delete location'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$loading(loading),
											$author$project$Ui$Button$onClick(
											A2($author$project$Pages$Admin$Locations$Delete, item, items)),
											$author$project$Ui$Button$disabled(
											!A2(
												$author$project$Api$Expandable$withDefault,
												false,
												A2(
													$author$project$Api$Expandable$map,
													$author$project$Api$Provider$Location$Meta$deleteAction,
													$author$project$Api$Provider$Location$All$meta(item)))),
											$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Delete')
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$Locations$viewPanelTable = function (model) {
	var _v0 = function () {
		var _v1 = model.j4;
		if (_v1.$ === 3) {
			var items_ = _v1.a;
			return _Utils_Tuple2(false, items_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var items = _v0.b;
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$verticalCentered,
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You have no locations.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$map,
					$author$project$Api$Column$view(
						A2($author$project$Api$Column$Sortable, model.alA, $author$project$Pages$Admin$Locations$SortTable)),
					$author$project$Pages$Admin$Locations$columns),
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$justifyRight]),
								_List_fromArray(
									[
										A2($elm$html$Html$map, $author$project$Pages$Admin$Locations$ExportCsvMsg, $author$project$Components$ExportCsv$button)
									]))
							]))
					])
				])),
		A2(
			$elm$core$List$map,
			A2($author$project$Pages$Admin$Locations$viewItem, model, items),
			items),
		_List_Nil);
};
var $author$project$Pages$Admin$Locations$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Admin$Locations$LinkedRecordsMsg,
				$author$project$Components$LinkedRecords$modal(model.oo)),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Admin$Locations$ExportCsvMsg,
				A3(
					$author$project$Components$ExportCsv$modal,
					model.Gv,
					_List_fromArray(
						[
							$author$project$Components$ExportCsv$path($author$project$Api$Provider$Location$locationsPath),
							$author$project$Components$ExportCsv$params(
							A2($elm$core$Basics$composeL, $author$project$Api$Provider$Location$listOptionsToParams, $author$project$Pages$Admin$Locations$fetchParams)(model))
						]),
					model.nD)),
				function () {
				var _v0 = model.Io;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var id = _v1.a;
					var form = _v1.b;
					var item = _v1.c;
					return A4($author$project$Pages$Admin$Locations$viewModal, model, id, form, item);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v2 = model.je;
				if (!_v2.$) {
					var item = _v2.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Admin$Locations$HiConfirmClosed(item),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('delete'),
								$author$project$Components$HiConfirm$noun('location'),
								$author$project$Components$HiConfirm$detail(
								$author$project$Api$Provider$Location$All$name(item))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Admin$Locations$DeleteModalMsg,
				$author$project$Components$Admin$Location$DeleteModal$view(model.i8)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Locations')
											])),
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$gap2]),
										_List_fromArray(
											[
												$author$project$Api$Provider$Practice$One$hasBusinessLocation(model.ZV) ? $author$project$Utils$Html$empty : A3(
												$author$project$Ui$Button$view,
												{mm: 'Include primary business address as a location'},
												_List_fromArray(
													[
														$author$project$Ui$Button$onClick($author$project$Pages$Admin$Locations$NewBusinessAddress)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Include primary business address as a location')
													])),
												A3(
												$author$project$Ui$Button$view,
												{mm: 'Add new location'},
												_List_fromArray(
													[
														$author$project$Ui$Button$default,
														$author$project$Ui$Button$onClick($author$project$Pages$Admin$Locations$New),
														$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('New Location')
													]))
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Group$view,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$map,
														$author$project$Pages$Admin$Locations$SearchInputMsg,
														A2($author$project$Ui$SearchInput$view, _List_Nil, model.up))
													]))
											]))
									]))
							])),
						$author$project$Pages$Admin$Locations$viewPanelTable(model),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Admin$Locations$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(
											!$author$project$Api$Data$isSuccess(model.j4))
										]),
									model.ajJ))
							]))
					]))
			]),
		ac9: 'Admin | Locations'
	};
};
var $author$project$Pages$Admin$Locations$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Locations$init, aiq: $author$project$Pages$Admin$Locations$load, k8: $author$project$Pages$Admin$Locations$save, alO: $author$project$Pages$Admin$Locations$subscriptions, adT: $author$project$Pages$Admin$Locations$update, amo: $author$project$Pages$Admin$Locations$view});
var $author$project$Pages$Admin$Mailgun$GotMailgun = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$Mailgun$formFieldsInit = {Rj: '', zo: ''};
var $author$project$Api$Provider$Mailgun$One$Mailgun = $elm$core$Basics$identity;
var $author$project$Api$Provider$Mailgun$One$Record = F5(
	function (status, domain, email, sendingDnsRecords, meta) {
		return {QV: domain, Rj: email, W4: meta, aaV: sendingDnsRecords, alH: status};
	});
var $author$project$Api$Provider$Mailgun$Meta$Meta = $elm$core$Basics$identity;
var $author$project$Api$Provider$Mailgun$Meta$MetaRecord = function (actions) {
	return {vy: actions};
};
var $author$project$Api$Provider$Mailgun$Meta$ActionsRecord = F2(
	function (setup, verify) {
		return {aa6: setup, aeg: verify};
	});
var $author$project$Api$Provider$Mailgun$Meta$actionsRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'verify',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'setup',
		$elm$json$Json$Decode$bool,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Mailgun$Meta$ActionsRecord)));
var $author$project$Api$Provider$Mailgun$Meta$metaRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'actions',
	$author$project$Api$Provider$Mailgun$Meta$actionsRecordDecoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Mailgun$Meta$MetaRecord));
var $author$project$Api$Provider$Mailgun$Meta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Mailgun$Meta$metaRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Mailgun$SendingDnsRecord$SendingDnsRecord = $elm$core$Basics$identity;
var $author$project$Api$Provider$Mailgun$SendingDnsRecord$Record = F4(
	function (valid, recordType, name, value) {
		return {Bq: name, $f: recordType, aec: valid, aee: value};
	});
var $author$project$Api$Provider$Mailgun$SendingDnsRecord$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'value',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'record_type',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'valid',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$Mailgun$SendingDnsRecord$Record)))));
var $author$project$Api$Provider$Mailgun$SendingDnsRecord$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Mailgun$SendingDnsRecord$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Mailgun$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'meta',
	$author$project$Api$Provider$Mailgun$Meta$decoder,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'sending_dns_records',
		$elm$json$Json$Decode$list($author$project$Api$Provider$Mailgun$SendingDnsRecord$decoder),
		_List_Nil,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'email',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'domain',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'status',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$Mailgun$One$Record))))));
var $author$project$Api$Provider$Mailgun$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Mailgun$One$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Mailgun$mailgunPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['mailgun']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Mailgun$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Mailgun$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Mailgun$mailgunPath));
	});
var $author$project$Api$Provider$Practice$Shared$url = function (_v0) {
	var record = _v0;
	return record.adY;
};
var $author$project$Api$Provider$Practice$One$url = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$url(shared);
};
var $author$project$Pages$Admin$Mailgun$init = F4(
	function (_v0, practice, shared, _v1) {
		var domain = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.ahL;
			},
			A2(
				$elm$core$Maybe$andThen,
				$elm$url$Url$fromString,
				$author$project$Api$Provider$Practice$One$url(practice)));
		return _Utils_Tuple2(
			{
				Gv: shared.Gv,
				QV: domain,
				C: false,
				SD: $author$project$Utils$Form$init($author$project$Pages$Admin$Mailgun$formFieldsInit),
				sF: shared.sF,
				Ij: $author$project$Shared$isHintAdmin(shared),
				ot: $author$project$Api$Data$Loading,
				p$: $author$project$Api$Data$NotAsked,
				q$: $author$project$Api$Data$NotAsked
			},
			A2($author$project$Api$Provider$Mailgun$retrieve, shared.Gv, $author$project$Pages$Admin$Mailgun$GotMailgun));
	});
var $author$project$Pages$Admin$Mailgun$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					Ij: $author$project$Shared$isHintAdmin(shared)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Mailgun$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Mailgun$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$Mailgun$Verified = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$Mailgun$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var string = field.a;
			return _Utils_update(
				fields,
				{Rj: string});
		} else {
			var domain = field.a;
			var string = field.b;
			return _Utils_update(
				fields,
				{Rj: string + ('@' + domain), zo: string});
		}
	});
var $author$project$Pages$Admin$Mailgun$EmailValidation = 0;
var $author$project$Pages$Admin$Mailgun$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A3(
			$author$project$Utils$Validate$ifInvalidEmail,
			{aeT: false},
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.Rj;
				},
				$elm$core$Maybe$Just),
			_Utils_Tuple2(0, 'Please enter a valid email'))
		]));
var $author$project$Pages$Admin$Mailgun$GotSetup = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Mailgun$setup = F3(
	function (apiClient, email_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string(email_))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Mailgun$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['setup']),
						$author$project$Api$Provider$Mailgun$mailgunPath))));
	});
var $author$project$Pages$Admin$Mailgun$setupMailgun = F2(
	function (apiClient, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A3($author$project$Api$Provider$Mailgun$setup, apiClient, fields.Rj, $author$project$Pages$Admin$Mailgun$GotSetup);
	});
var $author$project$Api$Provider$Mailgun$verify = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Mailgun$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['verify']),
					$author$project$Api$Provider$Mailgun$mailgunPath)));
	});
var $author$project$Pages$Admin$Mailgun$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ot: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$Mailgun$formFieldsUpdate, field, model.SD);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: newForm}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var _v1 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$Mailgun$formFieldsValidator, model.SD);
				if (!_v1.$) {
					var _v2 = _v1.a;
					var newForm = _v2.a;
					var validFormFields = _v2.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{SD: newForm, p$: $author$project$Api$Data$Loading}),
						A2($author$project$Pages$Admin$Mailgun$setupMailgun, model.Gv, validFormFields),
						_List_Nil);
				} else {
					var newForm = _v1.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{SD: newForm}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								C: false,
								SD: $author$project$Utils$Form$init($author$project$Pages$Admin$Mailgun$formFieldsInit),
								ot: response,
								p$: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your mailgun credentials have been saved.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{p$: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{q$: $author$project$Api$Data$Loading}),
					A2($author$project$Api$Provider$Mailgun$verify, model.Gv, $author$project$Pages$Admin$Mailgun$Verified),
					_List_Nil);
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ot: response, q$: response}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your dns records are being verified.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{q$: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{C: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
		}
	});
var $author$project$Ui$Image$MailgunLogo = 3;
var $author$project$Pages$Admin$Mailgun$EditEmail = {$: 6};
var $author$project$Pages$Admin$Mailgun$Email = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$Mailgun$EmailLocalPart = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Pages$Admin$Mailgun$FormUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$Mailgun$Setup = {$: 2};
var $author$project$Pages$Admin$Mailgun$Verify = {$: 4};
var $author$project$Api$Provider$Mailgun$One$domain = function (_v0) {
	var record = _v0;
	return record.QV;
};
var $author$project$Api$Provider$Mailgun$One$email = function (_v0) {
	var record = _v0;
	return record.Rj;
};
var $author$project$Api$Provider$Mailgun$One$meta = function (_v0) {
	var record = _v0;
	return record.W4;
};
var $author$project$Api$Provider$Mailgun$One$sendingDnsRecords = function (_v0) {
	var record = _v0;
	return record.aaV;
};
var $author$project$Api$Provider$Mailgun$Meta$setupAaction = function (_v0) {
	var meta = _v0;
	return meta.vy.aa6;
};
var $author$project$Api$Provider$Mailgun$One$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Api$Provider$Mailgun$Meta$verifyAction = function (_v0) {
	var meta = _v0;
	return meta.vy.aeg;
};
var $author$project$Api$Provider$Mailgun$SendingDnsRecord$name = function (_v0) {
	var sendingDnsRecord = _v0;
	return sendingDnsRecord.Bq;
};
var $author$project$Api$Provider$Mailgun$SendingDnsRecord$recordType = function (_v0) {
	var sendingDnsRecord = _v0;
	return sendingDnsRecord.$f;
};
var $author$project$Api$Provider$Mailgun$SendingDnsRecord$valid = function (_v0) {
	var sendingDnsRecord = _v0;
	return sendingDnsRecord.aec;
};
var $author$project$Api$Provider$Mailgun$SendingDnsRecord$value = function (_v0) {
	var sendingDnsRecord = _v0;
	return sendingDnsRecord.aee;
};
var $author$project$Pages$Admin$Mailgun$viewSendingDnsRecord = function (sendingDnsRecord) {
	return _List_fromArray(
		[
			$author$project$Ui$HorizontalRule$view(_List_Nil),
			A2(
			$author$project$Ui$Form$Static$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Record Configured: '),
							($author$project$Api$Provider$Mailgun$SendingDnsRecord$valid(sendingDnsRecord) === 'valid') ? $author$project$Ui$Icon$check(
							_List_fromArray(
								[$author$project$Ui$Icon$success])) : $author$project$Ui$Icon$cross(
							_List_fromArray(
								[$author$project$Ui$Icon$danger]))
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Record Type: '),
							A2(
							$author$project$Ui$Typography$pre,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$Mailgun$SendingDnsRecord$recordType(sendingDnsRecord))
								]))
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Hostname: '),
							A2(
							$author$project$Ui$Typography$pre,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$Mailgun$SendingDnsRecord$name(sendingDnsRecord))
								]))
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Value: '),
							A2(
							$author$project$Ui$Typography$pre,
							_List_fromArray(
								[$author$project$Ui$Typography$preWrap]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$Mailgun$SendingDnsRecord$value(sendingDnsRecord))
								]))
						]))
				]))
		]);
};
var $author$project$Pages$Admin$Mailgun$viewPanelBody = F2(
	function (model, mailgun) {
		var meta = $author$project$Api$Provider$Mailgun$One$meta(mailgun);
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Status'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Badge$fromString,
								_List_Nil,
								$author$project$Api$Provider$Mailgun$One$status(mailgun)),
								function () {
								var _v0 = model.QV;
								if (_v0.$ === 1) {
									return A2(
										$author$project$Ui$Typography$p,
										_List_fromArray(
											[$author$project$Ui$Typography$helpBlock]),
										_List_fromArray(
											[
												$elm$html$Html$text('You do not have a website setup on your practice, please add that '),
												A3(
												$author$project$Ui$Link$route,
												$author$project$Spa$Generated$Route$Admin__Practice,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('here')
													])),
												$elm$html$Html$text(' before configuring Mailgun.')
											]));
								} else {
									return $author$project$Utils$Html$empty;
								}
							}()
							])),
						($author$project$Api$Provider$Mailgun$Meta$setupAaction(meta) && ((!model.C) && $author$project$Utils$Maybe$toBool(model.QV))) ? A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Integrate with mailgun'},
								_List_fromArray(
									[
										$author$project$Ui$Button$primary,
										$author$project$Ui$Button$onClick($author$project$Pages$Admin$Mailgun$EditEmail)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Integrate with Mailgun')
									]))
							])) : $author$project$Utils$Html$empty
					])),
				function () {
				var _v1 = _Utils_Tuple2(
					$author$project$Api$Provider$Mailgun$One$status(mailgun) === 'active',
					$author$project$Api$Provider$Mailgun$Meta$verifyAction(meta));
				if (_v1.a) {
					return A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('DNS Settings'),
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Static$view,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Icon$check(
										_List_fromArray(
											[$author$project$Ui$Icon$success])),
										$elm$html$Html$text(' Correctly configured')
									]))
							]));
				} else {
					if (_v1.b) {
						return A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('DNS Settings'),
									$author$project$Ui$Form$Group$labelSpanSm(4),
									$author$project$Ui$Form$Group$inputSpanSm(8)
								]),
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Please set the following DNS records up on your website\'s DNS server.  For more information on how to do that '),
											A3(
											$author$project$Ui$Link$externalHref,
											'https://support.hint.com/integrations/mailgun-integration',
											_List_fromArray(
												[$author$project$Ui$Link$targetBlank]),
											_List_fromArray(
												[
													$elm$html$Html$text('click here')
												])),
											$elm$html$Html$text(' . This may take 24-48 hours for the changes to take effect.')
										])),
								A2(
									$elm$core$List$cons,
									A3(
										$author$project$Ui$Button$view,
										{mm: 'Check dns records'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$onClick($author$project$Pages$Admin$Mailgun$Verify),
												$author$project$Ui$Button$loading(
												_Utils_eq(model.q$, $author$project$Api$Data$Loading))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Check DNS records now')
											])),
									A2(
										$elm$core$List$concatMap,
										$author$project$Pages$Admin$Mailgun$viewSendingDnsRecord,
										$author$project$Api$Provider$Mailgun$One$sendingDnsRecords(mailgun)))));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}
			}(),
				function () {
				var _v2 = $author$project$Api$Provider$Mailgun$One$domain(mailgun);
				if (!_v2.$) {
					var domain = _v2.a;
					return A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Domain'),
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Static$view,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(domain)
									]))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				($author$project$Utils$Maybe$toBool(
				$author$project$Api$Provider$Mailgun$One$email(mailgun)) || model.C) ? A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Email'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						function () {
						var _v3 = _Utils_Tuple2(model.C, model.QV);
						if (_v3.a && (!_v3.b.$)) {
							var domain = _v3.b.a;
							var fields = $author$project$Utils$Form$fields(model.SD);
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_fromArray(
											[$author$project$Ui$Typography$helpBlock]),
										_List_fromArray(
											[
												$elm$html$Html$text('You must be able to receive email at this address for patients to be able to reply to emails. '),
												$elm$html$Html$text('If you want to use another email address and it is at a domain you own (not @gmail.com, @outlook.com, etc) contact us.')
											])),
										model.Ij ? $author$project$Ui$Form$Input$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$value(fields.Rj),
												$author$project$Ui$Form$Input$autoComplete(false),
												$author$project$Ui$Form$Input$placeholder('billing@example.com'),
												$author$project$Ui$Form$Input$onInput(
												A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Mailgun$FormUpdated, $author$project$Pages$Admin$Mailgun$Email)),
												$author$project$Ui$Form$Input$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, 0, model.SD))
											])) : $author$project$Ui$Form$Input$group(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$view(
												_List_fromArray(
													[
														$author$project$Ui$Form$Input$value(fields.zo),
														$author$project$Ui$Form$Input$autoComplete(false),
														$author$project$Ui$Form$Input$placeholder('billing'),
														$author$project$Ui$Form$Input$onInput(
														A2(
															$elm$core$Basics$composeL,
															$author$project$Pages$Admin$Mailgun$FormUpdated,
															$author$project$Pages$Admin$Mailgun$EmailLocalPart(domain))),
														$author$project$Ui$Form$Input$invalid(
														A2($author$project$Utils$Form$hasValidationErrors, 0, model.SD))
													])),
												$author$project$Ui$Form$Input$addon(
												_List_fromArray(
													[
														$elm$html$Html$text('@' + domain)
													]))
											])),
										$author$project$Utils$FormErrors$view(
										A2($author$project$Utils$Form$validationErrors, 0, model.SD)),
										A2(
										$author$project$Ui$Form$Static$view,
										_List_Nil,
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Button$view,
												{mm: 'Setup mailgun integration'},
												_List_fromArray(
													[
														$author$project$Ui$Button$primary,
														$author$project$Ui$Button$onClick($author$project$Pages$Admin$Mailgun$Setup),
														$author$project$Ui$Button$loading(
														_Utils_eq(model.p$, $author$project$Api$Data$Loading))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Setup')
													]))
											]))
									]));
						} else {
							return $author$project$Utils$Html$empty;
						}
					}(),
						(!model.C) ? A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									$author$project$Api$Provider$Mailgun$One$email(mailgun)))
							])) : $author$project$Utils$Html$empty
					])) : $author$project$Utils$Html$empty,
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('About'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Our Mailgun integration allows you to customize the domain and email address for notifications that are sent from our platform.')
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Learn more '),
										A3(
										$author$project$Ui$Link$externalHref,
										'https://support.hint.com/integrations/mailgun-integration',
										_List_fromArray(
											[$author$project$Ui$Link$targetBlank]),
										_List_fromArray(
											[
												$elm$html$Html$text('here')
											])),
										$elm$html$Html$text('.')
									]))
							]))
					]))
			]);
	});
var $author$project$Pages$Admin$Mailgun$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$noValidate(true),
						$author$project$Ui$Form$autocomplete(false)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										A4(
										$author$project$Ui$Image$view,
										model.sF,
										{LD: 'Mailgun Logo'},
										_List_fromArray(
											[
												$author$project$Ui$Image$width(200)
											]),
										3)
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								function () {
									var _v0 = model.ot;
									if (_v0.$ === 3) {
										var mailgun = _v0.a;
										return A2($author$project$Pages$Admin$Mailgun$viewPanelBody, model, mailgun);
									} else {
										return _List_fromArray(
											[
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$textCenter]),
												_List_fromArray(
													[
														$author$project$Ui$Spinner$view(_List_Nil)
													]))
											]);
									}
								}())
							]))
					]))
			]),
		ac9: 'Integrations | Mailgun'
	};
};
var $author$project$Pages$Admin$Mailgun$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Mailgun$init, aiq: $author$project$Pages$Admin$Mailgun$load, k8: $author$project$Pages$Admin$Mailgun$save, alO: $author$project$Pages$Admin$Mailgun$subscriptions, adT: $author$project$Pages$Admin$Mailgun$update, amo: $author$project$Pages$Admin$Mailgun$view});
var $author$project$Pages$Admin$Notes$NotesMsg = $elm$core$Basics$identity;
var $author$project$Api$Provider$Note$Practice = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Notes$FlaggedDropdownMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Notes$Model = $elm$core$Basics$identity;
var $author$project$Components$Notes$GotNotes = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Note$All$Note = $elm$core$Basics$identity;
var $author$project$Api$Provider$Note$Shared$Note = $elm$core$Basics$identity;
var $author$project$Api$Provider$Note$Shared$Record = F6(
	function (id, content, flagged, createdAt, createdBy, meta) {
		return {G1: content, O1: createdAt, O2: createdBy, HN: flagged, ahP: id, W4: meta};
	});
var $author$project$Api$Provider$Note$Meta$Meta = $elm$core$Basics$identity;
var $author$project$Api$Provider$Note$Meta$MetaRecord = function (editable) {
	return {Q4: editable};
};
var $author$project$Api$Provider$Note$Meta$metaRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'editable',
	$elm$json$Json$Decode$bool,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Note$Meta$MetaRecord));
var $author$project$Api$Provider$Note$Meta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Note$Meta$metaRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Note$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'meta',
	$author$project$Api$Provider$Note$Meta$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'created_by',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$User$Shared$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'created_at',
			$elm_community$json_extra$Json$Decode$Extra$datetime,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'flagged',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'content',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$Note$Shared$Record)))))));
var $author$project$Api$Provider$Note$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Note$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Note$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Note$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Note$listDefaults = {HN: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$Note$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Note$listDefaults);
	var _v0 = options.HN;
	if (!_v0.$) {
		var bool = _v0.a;
		return _List_fromArray(
			[
				A2($author$project$Api$Param$bool, 'flagged', bool)
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Api$Provider$Note$practicePath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['practice', id_]),
		$author$project$Api$Data$providerPath);
};
var $author$project$Api$Provider$Note$notablePath = function (notable) {
	switch (notable.$) {
		case 0:
			var id_ = notable.a;
			return $author$project$Api$Provider$Note$practicePath(id_);
		case 1:
			var id_ = notable.a;
			return $author$project$Api$Provider$Company$companyPath(id_);
		default:
			var id_ = notable.a;
			return $author$project$Api$Provider$Patient$patientPath(id_);
	}
};
var $author$project$Api$Provider$Note$notesPath = function (notable) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['notes']),
		$author$project$Api$Provider$Note$notablePath(notable));
};
var $author$project$Api$Provider$Note$list = F4(
	function (apiClient, notable, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Note$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Note$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Note$notesPath(notable))));
	});
var $author$project$Components$Notes$fetchNotes = F2(
	function (apiClient, model) {
		return A4($author$project$Api$Provider$Note$list, apiClient, model.ks, $elm$core$Basics$identity, $author$project$Components$Notes$GotNotes);
	});
var $author$project$Components$Notes$FlaggedOption$All = 0;
var $author$project$Components$Notes$FlaggedOption$Flagged = 1;
var $author$project$Components$Notes$FlaggedOption$Unflagged = 2;
var $author$project$Components$Notes$FlaggedOption$queryKey = 'flagged';
var $author$project$Components$Notes$FlaggedOption$fromQuery = function (query) {
	var _v0 = A2($elm$core$Dict$get, $author$project$Components$Notes$FlaggedOption$queryKey, query);
	_v0$2:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'flagged':
					return 1;
				case 'unflagged':
					return 2;
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return 0;
};
var $author$project$Components$Notes$init = F6(
	function (apiClient, timeFormatter, baseRoute, query, notable, isPracticeAdmin) {
		var model = {
			GC: baseRoute,
			jg: $elm$core$Maybe$Nothing,
			ei: $elm$core$Set$empty,
			HN: $author$project$Components$Notes$FlaggedOption$fromQuery(query),
			nM: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'flagged-dropdown-filter', al6: $author$project$Components$Notes$FlaggedDropdownMsg})),
			ex: $elm$core$Set$empty,
			Im: isPracticeAdmin,
			ks: notable,
			al: $elm$core$Maybe$Nothing,
			kt: $author$project$Api$Data$Loading,
			J7: timeFormatter
		};
		return _Utils_Tuple2(
			model,
			A2($author$project$Components$Notes$fetchNotes, apiClient, model));
	});
var $author$project$Pages$Admin$Notes$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.DE;
		var _v1 = A6(
			$author$project$Components$Notes$init,
			shared.Gv,
			shared.J7,
			$author$project$Spa$Generated$Route$Admin__Notes,
			query,
			$author$project$Api$Provider$Note$Practice(
				$author$project$Api$Provider$Practice$One$id(practice)),
			$author$project$Api$Platform$Session$One$userIsPracticeAdmin(session));
		var notes = _v1.a;
		var notesCmd = _v1.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, s1: notes},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, notesCmd));
	});
var $author$project$Pages$Admin$Notes$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Notes$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Notes$CancelNoteEdit = {$: 11};
var $author$project$Components$Notes$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Components$Notes$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				function () {
				var _v1 = model.al;
				if (!_v1.$) {
					return $author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Notes$CancelNoteEdit);
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Notes$HiConfirmClosed),
					model.jg)),
				$author$project$Ui$Dropdown$subscriptions(model.nM)
			]));
};
var $author$project$Pages$Admin$Notes$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Notes$subscriptions(model.s1));
};
var $author$project$Components$Notes$NoteDeleted = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Components$Notes$NoteFlagged = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Api$Provider$Note$notePath = F2(
	function (notable, id_) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id_]),
			$author$project$Api$Provider$Note$notesPath(notable));
	});
var $author$project$Api$Provider$Note$delete = F4(
	function (apiClient, notable, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Provider$Note$notePath, notable, id_)));
	});
var $author$project$Api$Provider$Note$One$Note = 0;
var $author$project$Api$Provider$Note$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Provider$Note$flag = F5(
	function (apiClient, notable, id_, flagged_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'note',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'flagged',
								$elm$json$Json$Encode$bool(flagged_))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Note$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Provider$Note$notePath, notable, id_))));
	});
var $author$project$Api$Provider$Note$Shared$content = function (_v0) {
	var record = _v0;
	return record.G1;
};
var $author$project$Api$Provider$Note$All$content = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Note$Shared$content(shared);
};
var $author$project$Components$Notes$formFieldsFromNote = function (note) {
	return $author$project$Api$Provider$Note$All$content(note);
};
var $author$project$Components$Notes$formFieldsInit = '';
var $author$project$Components$Notes$formFieldsUpdate = F2(
	function (field, _v0) {
		var string = field;
		return string;
	});
var $author$project$Components$Notes$ContentValidation = 0;
var $author$project$Components$Notes$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			$elm$core$Basics$identity,
			_Utils_Tuple2(0, 'Please enter some content.'))
		]));
var $author$project$Api$Provider$Note$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Note$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Note$Shared$id(shared);
};
var $author$project$Components$Notes$NoteCreated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$Note$create = F4(
	function (apiClient, notable, content_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'note',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'content',
								$elm$json$Json$Encode$string(content_))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Note$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Note$notesPath(notable))));
	});
var $author$project$Components$Notes$createNote = F3(
	function (apiClient, notable, formFields) {
		var content = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4($author$project$Api$Provider$Note$create, apiClient, notable, content, $author$project$Components$Notes$NoteCreated);
	});
var $author$project$Components$Notes$NoteUpdated = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$Note$update = F5(
	function (apiClient, notable, id_, content_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'note',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'content',
								$elm$json$Json$Encode$string(content_))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Note$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Provider$Note$notePath, notable, id_))));
	});
var $author$project$Components$Notes$updateNote = F4(
	function (apiClient, notable, id, formFields) {
		var content = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A5($author$project$Api$Provider$Note$update, apiClient, notable, id, content, $author$project$Components$Notes$NoteUpdated);
	});
var $author$project$Components$Notes$saveNote = F4(
	function (apiClient, notable, maybeId, formFields) {
		if (!maybeId.$) {
			var id = maybeId.a;
			return A4($author$project$Components$Notes$updateNote, apiClient, notable, id, formFields);
		} else {
			return A3($author$project$Components$Notes$createNote, apiClient, notable, formFields);
		}
	});
var $author$project$Components$Notes$FlaggedOption$toValue = function (option) {
	switch (option) {
		case 1:
			return 'flagged';
		case 2:
			return 'unflagged';
		default:
			return '';
	}
};
var $author$project$Components$Notes$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			function () {
			var _v0 = model.HN;
			if (!_v0) {
				return $elm$core$Maybe$Nothing;
			} else {
				return $elm$core$Maybe$Just(
					A2(
						$elm$url$Url$Builder$string,
						$author$project$Components$Notes$FlaggedOption$queryKey,
						$author$project$Components$Notes$FlaggedOption$toValue(model.HN)));
			}
		}()
		]);
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString(model.GC)
				]),
			A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)));
};
var $author$project$Components$Notes$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{kt: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							al: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init($author$project$Components$Notes$formFieldsInit),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var field = msg.a;
				var _v2 = model.al;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var id = _v3.a;
					var form = _v3.b;
					var note = _v3.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Notes$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								al: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, note))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var id = msg.a;
				var bool = msg.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ex: A2($elm$core$Set$insert, id, model.ex)
						}),
					A5(
						$author$project$Api$Provider$Note$flag,
						apiClient,
						model.ks,
						id,
						bool,
						$author$project$Components$Notes$NoteFlagged(id)),
					_List_Nil);
			case 4:
				var note = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							al: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(
										$author$project$Api$Provider$Note$All$id(note)),
									$author$project$Utils$Form$init(
										$author$project$Components$Notes$formFieldsFromNote(note)),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var id = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							jg: $elm$core$Maybe$Just(id)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 6:
				var response = msg.a;
				var _v4 = model.al;
				if (!_v4.$) {
					var _v5 = _v4.a;
					var id = _v5.a;
					var form = _v5.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{al: $elm$core$Maybe$Nothing}),
							A2($author$project$Components$Notes$fetchNotes, apiClient, model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Note successfully created')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									al: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var id = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ex: A2($elm$core$Set$remove, id, model.ex),
									kt: $author$project$Api$Data$Loading
								}),
							A2($author$project$Components$Notes$fetchNotes, apiClient, model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Note successfully updated')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ex: A2($elm$core$Set$remove, id, model.ex)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 8:
				var response = msg.a;
				var _v8 = model.al;
				if (!_v8.$) {
					var _v9 = _v8.a;
					var id = _v9.a;
					var form = _v9.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{al: $elm$core$Maybe$Nothing}),
							A2($author$project$Components$Notes$fetchNotes, apiClient, model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Note successfully updated')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									al: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var id = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ei: A2($elm$core$Set$remove, id, model.ei),
									kt: $author$project$Api$Data$Loading
								}),
							A2($author$project$Components$Notes$fetchNotes, apiClient, model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Note successfully deleted')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ei: A2($elm$core$Set$remove, id, model.ei)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 10:
				var id = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							jg: $elm$core$Maybe$Nothing,
							ei: A2($elm$core$Set$insert, id, model.ei)
						}),
					A4(
						$author$project$Api$Provider$Note$delete,
						apiClient,
						model.ks,
						id,
						$author$project$Components$Notes$NoteDeleted(id)),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{jg: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 11:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{al: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 12:
				var form = msg.a;
				var id = msg.b;
				var _v12 = A2($author$project$Utils$Form$validate, $author$project$Components$Notes$formFieldsValidator, form);
				if (!_v12.$) {
					var _v13 = _v12.a;
					var newForm = _v13.a;
					var validFormFields = _v13.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								al: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, $author$project$Api$Data$Loading))
							}),
						A4($author$project$Components$Notes$saveNote, apiClient, model.ks, id, validFormFields),
						_List_Nil);
				} else {
					var newForm = _v12.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								al: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 13:
				var subMsg = msg.a;
				var _v14 = A2($author$project$Ui$Dropdown$update, subMsg, model.nM);
				var dropdown = _v14.a;
				var dropdownCmd = _v14.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nM: dropdown}),
					dropdownCmd,
					_List_Nil);
			default:
				var flagged = msg.a;
				var newModel = _Utils_update(
					model,
					{HN: flagged, kt: $author$project$Api$Data$Loading});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Notes$fetchNotes, apiClient, newModel),
								$author$project$Components$Notes$updateUrl(newModel)
							])),
					_List_Nil);
		}
	});
var $author$project$Pages$Admin$Notes$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Notes$update, model.Gv, subMsg, model.s1);
		var notes = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{s1: notes}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Components$Notes$NewNote = {$: 1};
var $author$project$Api$Provider$Note$Shared$flagged = function (_v0) {
	var record = _v0;
	return record.HN;
};
var $author$project$Api$Provider$Note$All$flagged = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Note$Shared$flagged(shared);
};
var $author$project$Components$Notes$filterNotes = F2(
	function (flagged, notes) {
		return A2(
			$elm$core$List$filter,
			function (note) {
				switch (flagged) {
					case 0:
						return true;
					case 1:
						return $author$project$Api$Provider$Note$All$flagged(note);
					default:
						return !$author$project$Api$Provider$Note$All$flagged(note);
				}
			},
			notes);
	});
var $author$project$Components$Notes$FlaggedFiltered = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Notes$FlaggedOption$toLabel = function (option) {
	switch (option) {
		case 1:
			return 'Flagged';
		case 2:
			return 'Unflagged';
		default:
			return 'All Notes';
	}
};
var $author$project$Components$Notes$flaggedDropdownOptions = function (currentFlaggedOption) {
	var flaggedOptionToItem = function (option) {
		return A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(currentFlaggedOption, option)),
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Components$Notes$FlaggedFiltered(option))
				]),
			$elm$html$Html$text(
				$author$project$Components$Notes$FlaggedOption$toLabel(option)));
	};
	return A2(
		$elm$core$List$cons,
		flaggedOptionToItem(0),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$Dropdown$separator,
			A2(
				$elm$core$List$map,
				flaggedOptionToItem,
				_List_fromArray(
					[1, 2]))));
};
var $author$project$Components$Notes$viewFlaggedDropdown = function (model) {
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Components$Notes$FlaggedOption$toLabel(model.HN))
			]),
		$author$project$Components$Notes$flaggedDropdownOptions(model.HN),
		model.nM);
};
var $author$project$Components$Notes$DeleteNote = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Notes$EditNote = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Notes$FlagNote = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Api$Provider$Note$Shared$createdAt = function (_v0) {
	var record = _v0;
	return record.O1;
};
var $author$project$Api$Provider$Note$All$createdAt = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Note$Shared$createdAt(shared);
};
var $author$project$Api$Provider$Note$Shared$createdBy = function (_v0) {
	var record = _v0;
	return record.O2;
};
var $author$project$Api$Provider$Note$All$createdBy = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Note$Shared$createdBy(shared);
};
var $author$project$Ui$ListGroup$Dashed = {$: 1};
var $author$project$Ui$ListGroup$dashed = $author$project$Ui$ListGroup$Dashed;
var $author$project$Api$Provider$Note$Meta$editable = function (_v0) {
	var meta = _v0;
	return meta.Q4;
};
var $author$project$Ui$Icon$Flag = 44;
var $author$project$Ui$Icon$flag = $author$project$Ui$Icon$viewIcon(44);
var $author$project$Api$Provider$Note$Shared$meta = function (_v0) {
	var record = _v0;
	return record.W4;
};
var $author$project$Api$Provider$Note$All$meta = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Note$Shared$meta(shared);
};
var $author$project$Components$Notes$viewNote = F5(
	function (timeFormatter, flaggingNotes, deletingNotes, note, isPracticeAdmin) {
		var id = $author$project$Api$Provider$Note$All$id(note);
		var loading = A2($elm$core$Set$member, id, flaggingNotes) || A2($elm$core$Set$member, id, deletingNotes);
		return A2(
			$author$project$Ui$ListGroup$item,
			_List_fromArray(
				[$author$project$Ui$ListGroup$dashed]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(12)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[
											$author$project$Ui$Typography$phi(true),
											$author$project$Ui$Typography$overflowWrap($author$project$Ui$OverflowWrap$breakWord),
											$author$project$Ui$Typography$preWrap
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Provider$Note$All$content(note))
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[$author$project$Ui$Typography$muted]),
											A2(
												$elm$core$Maybe$withDefault,
												'N/A',
												A2(
													$elm$core$Maybe$map,
													$author$project$Api$Provider$User$Shared$name,
													$author$project$Api$Provider$Note$All$createdBy(note))) + (' commented on ' + A2(
												timeFormatter,
												5,
												$author$project$Api$Provider$Note$All$createdAt(note)))),
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap2]),
											_List_fromArray(
												[
													function () {
													var noteFlagged = $author$project$Api$Provider$Note$All$flagged(note);
													var verb = noteFlagged ? 'Unflag' : 'Flag';
													return A3(
														$author$project$Ui$Button$view,
														{mm: verb + ' note'},
														_List_fromArray(
															[
																$author$project$Ui$Button$sm,
																$author$project$Ui$Button$loading(loading),
																$author$project$Ui$Button$onClick(
																A2($author$project$Components$Notes$FlagNote, id, !noteFlagged)),
																$author$project$Ui$Button$styled(
																noteFlagged ? 1 : 0),
																$author$project$Ui$Button$icon($author$project$Ui$Icon$flag)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(verb)
															]));
												}(),
													$author$project$Api$Provider$Note$Meta$editable(
													$author$project$Api$Provider$Note$All$meta(note)) ? A3(
													$author$project$Ui$Button$view,
													{mm: 'Edit note'},
													_List_fromArray(
														[
															$author$project$Ui$Button$sm,
															$author$project$Ui$Button$onClick(
															$author$project$Components$Notes$EditNote(note)),
															$author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Edit')
														])) : $author$project$Utils$Html$empty,
													($author$project$Api$Provider$Note$Meta$editable(
													$author$project$Api$Provider$Note$All$meta(note)) || isPracticeAdmin) ? A3(
													$author$project$Ui$Button$view,
													{mm: 'Delete note'},
													_List_fromArray(
														[
															$author$project$Ui$Button$sm,
															$author$project$Ui$Button$danger,
															$author$project$Ui$Button$loading(loading),
															$author$project$Ui$Button$onClick(
															$author$project$Components$Notes$DeleteNote(id))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Delete')
														])) : $author$project$Utils$Html$empty
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Notes$Content = $elm$core$Basics$identity;
var $author$project$Components$Notes$FormUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Notes$SaveNote = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Components$Notes$viewNoteModal = F3(
	function (maybeId, note, form) {
		var modalConfig = {
			Tq: $elm$core$Maybe$Nothing,
			aih: 'Note',
			V8: _Utils_eq(note, $author$project$Api$Data$Loading),
			WG: maybeId,
			WH: $elm$core$Maybe$Nothing,
			Yd: $author$project$Components$Notes$CancelNoteEdit,
			Yf: $author$project$Components$Notes$SaveNote(form)
		};
		var content = $author$project$Utils$Form$fields(form);
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$required(true),
							$author$project$Ui$Form$Group$label('Content')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Textarea$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Textarea$value(content),
									$author$project$Ui$Form$Textarea$phi(true),
									$author$project$Ui$Form$Textarea$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$Notes$FormUpdated, $elm$core$Basics$identity)),
									$author$project$Ui$Form$Textarea$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form))
								])),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						]))
				]));
	});
var $author$project$Components$Notes$viewNoteSkeleton = A2(
	$author$project$Ui$ListGroup$item,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$span(3)
						]))
				])),
			A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$span(6)
						]))
				])),
			A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$span(7)
						]))
				])),
			A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$span(6)
						]))
				]))
		]));
var $author$project$Components$Notes$noun = function (notable) {
	switch (notable.$) {
		case 0:
			return 'practice';
		case 1:
			return 'company';
		default:
			return 'patient';
	}
};
var $author$project$Components$Notes$zeroStateText = F2(
	function (notable, flagged) {
		return 'This ' + ($author$project$Components$Notes$noun(notable) + (' has no ' + ($author$project$Components$Notes$FlaggedOption$toValue(flagged) + ' notes')));
	});
var $author$project$Components$Notes$view = function (_v0) {
	var model = _v0;
	return _List_fromArray(
		[
			function () {
			var _v1 = model.al;
			if (!_v1.$) {
				var _v2 = _v1.a;
				var id = _v2.a;
				var form = _v2.b;
				var note = _v2.c;
				return A3($author$project$Components$Notes$viewNoteModal, id, note, form);
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			function () {
			var _v3 = model.jg;
			if (!_v3.$) {
				var id = _v3.a;
				return A2(
					$author$project$Components$HiConfirm$modal,
					$author$project$Components$Notes$HiConfirmClosed(id),
					_List_fromArray(
						[
							$author$project$Components$HiConfirm$verb('delete'),
							$author$project$Components$HiConfirm$noun('note')
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
							_List_fromArray(
								[
									$author$project$Ui$Panel$title(
									_List_fromArray(
										[
											$elm$html$Html$text('Notes')
										])),
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Add new note'},
									_List_fromArray(
										[
											$author$project$Ui$Button$default,
											$author$project$Ui$Button$onClick($author$project$Components$Notes$NewNote),
											$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('New Note')
										]))
								]))
						])),
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(4)
										]),
									_List_fromArray(
										[
											$author$project$Components$Notes$viewFlaggedDropdown(model)
										]))
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v4 = model.kt;
							if (_v4.$ === 3) {
								var notes = _v4.a;
								var filteredNotes = A2($author$project$Components$Notes$filterNotes, model.HN, notes);
								return $elm$core$List$isEmpty(filteredNotes) ? A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textCenter]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2($author$project$Components$Notes$zeroStateText, model.ks, model.HN))
										])) : A2(
									$author$project$Ui$ListGroup$view,
									_List_Nil,
									A2(
										$elm$core$List$map,
										function (note) {
											return A5($author$project$Components$Notes$viewNote, model.J7, model.ex, model.ei, note, model.Im);
										},
										filteredNotes));
							} else {
								return A2(
									$author$project$Ui$ListGroup$view,
									_List_Nil,
									A2($elm$core$List$repeat, 5, $author$project$Components$Notes$viewNoteSkeleton));
							}
						}()
						]))
				]))
		]);
};
var $author$project$Pages$Admin$Notes$view = function (model) {
	return {
		fO: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			$author$project$Components$Notes$view(model.s1)),
		ac9: 'Admin | Notes'
	};
};
var $author$project$Pages$Admin$Notes$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Notes$init, aiq: $author$project$Pages$Admin$Notes$load, k8: $author$project$Pages$Admin$Notes$save, alO: $author$project$Pages$Admin$Notes$subscriptions, adT: $author$project$Pages$Admin$Notes$update, amo: $author$project$Pages$Admin$Notes$view});
var $author$project$Pages$Admin$Notifications$Company$AdminTableMsg = $elm$core$Basics$identity;
var $author$project$Api$Provider$NotificationSetting$Company = 3;
var $author$project$Components$Admin$NotificationSetting$AdminTable$GotNotificationSettings = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$NotificationSetting$AdminTable$GotPracticeNotificationSettings = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$NotificationSetting$Membership = 1;
var $author$project$Api$Provider$NotificationSetting$All$NotificationSetting = $elm$core$Basics$identity;
var $author$project$Api$Provider$NotificationSetting$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$NotificationSetting$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Company$NotificationSetting$list = F3(
	function (apiClient, companyId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$NotificationSetting$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Company$NotificationSetting$notificationSettingsPath(companyId)));
	});
var $author$project$Api$Provider$NotificationSetting$categoryToString = function (category) {
	switch (category) {
		case 0:
			return 'patient';
		case 1:
			return 'membership';
		case 2:
			return 'practice';
		case 3:
			return 'company';
		default:
			return 'employee';
	}
};
var $author$project$Api$Provider$NotificationSetting$categoryToParams = function (category) {
	if (category === 2) {
		return _List_fromArray(
			[
				A2($author$project$Api$Param$string, 'category_name', 'practice')
			]);
	} else {
		return _List_fromArray(
			[
				A2(
				$author$project$Api$Param$string,
				'category_name',
				$author$project$Api$Provider$NotificationSetting$categoryToString(category)),
				A2($author$project$Api$Param$string, 'sender_type', 'practice')
			]);
	}
};
var $author$project$Api$Provider$NotificationSetting$listDefaults = {GW: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$NotificationSetting$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$NotificationSetting$listDefaults);
	var _v0 = options.GW;
	if (!_v0.$) {
		var category = _v0.a;
		return $author$project$Api$Provider$NotificationSetting$categoryToParams(category);
	} else {
		return _List_Nil;
	}
};
var $author$project$Api$Provider$NotificationSetting$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$NotificationSetting$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$NotificationSetting$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$NotificationSetting$notificationSettingsPath)));
	});
var $author$project$Components$Admin$NotificationSetting$AdminTable$fetchAllNotificationSettings = F2(
	function (apiClient, model) {
		var _v0 = model.a3;
		if (_v0.$ === 1) {
			var companyId = _v0.a;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3(
						$author$project$Api$Provider$NotificationSetting$list,
						apiClient,
						function (d) {
							return _Utils_update(
								d,
								{
									GW: $elm$core$Maybe$Just(1)
								});
						},
						$author$project$Components$Admin$NotificationSetting$AdminTable$GotPracticeNotificationSettings),
						A3($author$project$Api$Provider$Company$NotificationSetting$list, apiClient, companyId, $author$project$Components$Admin$NotificationSetting$AdminTable$GotNotificationSettings)
					]));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Components$Admin$NotificationSetting$AdminTable$fetchNotificationSettings = F2(
	function (apiClient, model) {
		var _v0 = model.a3;
		if (_v0.$ === 1) {
			var id = _v0.a;
			return A3($author$project$Api$Provider$Company$NotificationSetting$list, apiClient, id, $author$project$Components$Admin$NotificationSetting$AdminTable$GotNotificationSettings);
		} else {
			return A3(
				$author$project$Api$Provider$NotificationSetting$list,
				apiClient,
				function (d) {
					return _Utils_update(
						d,
						{
							GW: $elm$core$Maybe$Just(model.GW)
						});
				},
				$author$project$Components$Admin$NotificationSetting$AdminTable$GotNotificationSettings);
		}
	});
var $author$project$Components$Admin$NotificationSetting$MassEmail$Closed = {$: 0};
var $author$project$Components$Admin$NotificationSetting$MassEmail$init = $author$project$Components$Admin$NotificationSetting$MassEmail$Closed;
var $author$project$Components$Admin$NotificationSetting$AdminTable$init = F4(
	function (apiClient, session, context, category) {
		var model = {GW: category, a3: context, V8: true, oA: $author$project$Components$Admin$NotificationSetting$MassEmail$init, tc: false, X_: $elm$core$Maybe$Nothing, bI: _List_Nil, tW: $author$project$Api$Data$Loading, akd: $elm$core$Maybe$Nothing, aa4: session, EB: false};
		return _Utils_Tuple2(
			model,
			function () {
				if (!context.$) {
					return A2($author$project$Components$Admin$NotificationSetting$AdminTable$fetchNotificationSettings, apiClient, model);
				} else {
					return A2($author$project$Components$Admin$NotificationSetting$AdminTable$fetchAllNotificationSettings, apiClient, model);
				}
			}());
	});
var $author$project$Pages$Admin$Notifications$Company$init = F4(
	function (session, _v0, _v1, _v2) {
		var apiClient = _v1.Gv;
		var _v3 = A4($author$project$Components$Admin$NotificationSetting$AdminTable$init, apiClient, session, $author$project$Api$Provider$Notification$PracticeContext, 3);
		var adminTable = _v3.a;
		var adminTableCmd = _v3.b;
		return _Utils_Tuple2(
			{Gv: apiClient, s1: adminTable},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, adminTableCmd));
	});
var $author$project$Pages$Admin$Notifications$Company$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Notifications$Company$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Admin$NotificationSetting$AdminTable$CustomizeNotificationMsg = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Admin$NotificationSetting$AdminTable$MassEmailMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Admin$NotificationSetting$AdminTable$PreviewMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Admin$NotificationSetting$MassEmail$Close = {$: 1};
var $author$project$Components$Admin$NotificationSetting$MassEmail$subscriptions = function (model) {
	switch (model.$) {
		case 0:
			return $elm$core$Platform$Sub$none;
		case 1:
			return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$NotificationSetting$MassEmail$Close);
		default:
			return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$NotificationSetting$MassEmail$Close);
	}
};
var $author$project$Components$Admin$NotificationSetting$Preview$CloseModal = {$: 0};
var $author$project$Components$Admin$NotificationSetting$Preview$subscriptions = function (model) {
	return model.Yn ? $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				function () {
				var _v0 = A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.Yn;
					},
					model.gi);
				if ((!_v0.$) && _v0.a) {
					return $elm$core$Platform$Sub$none;
				} else {
					return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$NotificationSetting$Preview$CloseModal);
				}
			}(),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2($elm$core$Maybe$map, $author$project$Ui$Dropdown$subscriptions, model.gi))
			])) : $elm$core$Platform$Sub$none;
};
var $author$project$Components$Admin$NotificationSetting$AdminTable$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				function () {
				var _v0 = model.akd;
				if (!_v0.$) {
					var preview = _v0.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Components$Admin$NotificationSetting$AdminTable$PreviewMsg,
						$author$project$Components$Admin$NotificationSetting$Preview$subscriptions(preview));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Admin$NotificationSetting$AdminTable$MassEmailMsg,
				$author$project$Components$Admin$NotificationSetting$MassEmail$subscriptions(model.oA)),
				$elm$core$Platform$Sub$batch(
				A2(
					$elm$core$List$map,
					function (_v2) {
						var setting = _v2.a;
						var customize = _v2.b;
						return A2(
							$elm$core$Platform$Sub$map,
							$author$project$Components$Admin$NotificationSetting$AdminTable$CustomizeNotificationMsg(setting),
							$author$project$Components$Admin$NotificationSetting$Customize$subscriptions(customize));
					},
					A2(
						$elm$core$List$map,
						function (_v1) {
							var setting = _v1.a;
							var customize = _v1.c;
							return A2($elm$core$Tuple$pair, setting, customize);
						},
						model.bI)))
			]));
};
var $author$project$Pages$Admin$Notifications$Company$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Admin$NotificationSetting$AdminTable$subscriptions(model.s1));
};
var $author$project$Components$Admin$NotificationSetting$AdminTable$OverrideCreated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Admin$NotificationSetting$AdminTable$OverrideRemoved = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Admin$NotificationSetting$AdminTable$ToggleNotificationMsg = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $author$project$Api$Provider$NotificationSetting$All$disableable = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$NotificationSetting$Shared$disableable(shared);
};
var $author$project$Api$Provider$NotificationSetting$All$enabled = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$NotificationSetting$Shared$enabled(shared);
};
var $author$project$Api$Provider$NotificationSetting$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$NotificationSetting$Shared$id(shared);
};
var $author$project$Components$Admin$NotificationSetting$Toggle$allGetters = {QC: $author$project$Api$Provider$NotificationSetting$All$disableable, Ro: $author$project$Api$Provider$NotificationSetting$All$enabled, ahP: $author$project$Api$Provider$NotificationSetting$All$id};
var $author$project$Api$Provider$NotificationSetting$Shared$customEnabled = function (_v0) {
	var record = _v0;
	return record.Pm;
};
var $author$project$Api$Provider$NotificationSetting$All$customEnabled = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$NotificationSetting$Shared$customEnabled(shared);
};
var $author$project$Components$Admin$NotificationSetting$Preview$LanguageDropdownMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$NotificationSetting$All$isTranslatable = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$NotificationSetting$Shared$isTranslatable(shared);
};
var $author$project$Components$Admin$NotificationSetting$Preview$GotPreview = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Admin$NotificationSetting$Preview$previewNotificationSetting = F3(
	function (client, language, model) {
		var _v0 = model.a3;
		if (_v0.$ === 1) {
			var companyId = _v0.a;
			return A5(
				$author$project$Api$Provider$Company$NotificationSetting$preview,
				client,
				companyId,
				$author$project$Api$Provider$NotificationSetting$All$id(model.X_),
				{fO: $elm$core$Maybe$Nothing, Ay: language, J_: $elm$core$Maybe$Nothing},
				$author$project$Components$Admin$NotificationSetting$Preview$GotPreview(language));
		} else {
			return A4(
				$author$project$Api$Provider$NotificationSetting$preview,
				client,
				$author$project$Api$Provider$NotificationSetting$All$id(model.X_),
				{fO: $elm$core$Maybe$Nothing, Ay: language, J_: $elm$core$Maybe$Nothing},
				$author$project$Components$Admin$NotificationSetting$Preview$GotPreview(language));
		}
	});
var $author$project$Components$Admin$NotificationSetting$Preview$init = F4(
	function (client, multiLanguage, notificationSetting, context) {
		var language = $author$project$Language$english;
		var model = {
			a3: context,
			gi: (multiLanguage && $author$project$Api$Provider$NotificationSetting$All$isTranslatable(notificationSetting)) ? $elm$core$Maybe$Just(
				$author$project$Ui$Dropdown$init(
					$author$project$Ui$Dropdown$defaultConfig(
						{ahP: 'preview-language-dropdown', al6: $author$project$Components$Admin$NotificationSetting$Preview$LanguageDropdownMsg}))) : $elm$core$Maybe$Nothing,
			Ay: language,
			X_: notificationSetting,
			Yn: true,
			akd: A2(
				$elm$core$Dict$singleton,
				$author$project$Language$toValue(language),
				$author$project$Api$Data$Loading)
		};
		return _Utils_Tuple2(
			model,
			A3($author$project$Components$Admin$NotificationSetting$Preview$previewNotificationSetting, client, language, model));
	});
var $author$project$Api$Provider$NotificationSetting$All$toShared = function (_v0) {
	var shared = _v0;
	return shared;
};
var $author$project$Components$Admin$NotificationSetting$Customize$initFromAll = F2(
	function (notificationSettingAll, context) {
		return A2(
			$author$project$Components$Admin$NotificationSetting$Customize$init,
			$author$project$Api$Provider$NotificationSetting$All$toShared(notificationSettingAll),
			context);
	});
var $author$project$Components$Admin$NotificationSetting$AdminTable$patientMembershipEndedId = 'patient_membership_ended';
var $author$project$Components$Admin$NotificationSetting$AdminTable$patientMembershipMemberRemovedId = 'patient_membership_member_removed';
var $author$project$Components$Admin$NotificationSetting$AdminTable$overridableCompanyToggleIds = _List_fromArray(
	[$author$project$Components$Admin$NotificationSetting$AdminTable$patientMembershipEndedId, $author$project$Components$Admin$NotificationSetting$AdminTable$patientMembershipMemberRemovedId]);
var $author$project$Components$Admin$NotificationSetting$AdminTable$isOverridableCompanyToggle = function (id) {
	return A2($elm$core$List$member, id, $author$project$Components$Admin$NotificationSetting$AdminTable$overridableCompanyToggleIds);
};
var $author$project$Components$Admin$NotificationSetting$MassEmail$Previewing = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Components$Admin$NotificationSetting$MassEmail$SelectingSegments = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Admin$NotificationSetting$MassEmail$GotPatientsWithoutEmail = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$Patient$WithoutEmail = {$: 6};
var $author$project$Api$Pagination$empty = A2($author$project$Api$Pagination$withItemsPerPage, 0, $author$project$Api$Pagination$init);
var $author$project$Components$Admin$NotificationSetting$MassEmail$fetchPatientsWithoutEmail = function (apiClient) {
	return A3(
		$author$project$Api$Provider$Patient$list,
		apiClient,
		function (d) {
			return _Utils_update(
				d,
				{
					HM: _List_fromArray(
						[$author$project$Api$Provider$Patient$WithoutEmail]),
					ajJ: $author$project$Api$Pagination$empty
				});
		},
		$author$project$Components$Admin$NotificationSetting$MassEmail$GotPatientsWithoutEmail);
};
var $author$project$Components$Admin$NotificationSetting$MassEmail$initSegment = function (selected) {
	return {ali: $elm$core$Maybe$Nothing, aB: selected};
};
var $author$project$Components$Admin$NotificationSetting$MassEmail$initNotificationFormFields = {
	ic: $author$project$Components$Admin$NotificationSetting$MassEmail$initSegment(false),
	id: $author$project$Components$Admin$NotificationSetting$MassEmail$initSegment(false),
	jV: $author$project$Components$Admin$NotificationSetting$MassEmail$initSegment(false),
	jW: $author$project$Components$Admin$NotificationSetting$MassEmail$initSegment(false)
};
var $author$project$Components$Admin$NotificationSetting$MassEmail$notificationSettingFormFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var bool = field.a;
				return _Utils_update(
					fields,
					{
						ic: $author$project$Components$Admin$NotificationSetting$MassEmail$initSegment(bool)
					});
			case 1:
				var string = field.a;
				var _v1 = fields;
				var activeRetail = _v1.ic;
				return _Utils_update(
					fields,
					{
						ic: _Utils_update(
							activeRetail,
							{
								ali: $elm$core$Maybe$Just(string)
							})
					});
			case 2:
				var bool = field.a;
				return _Utils_update(
					fields,
					{
						id: $author$project$Components$Admin$NotificationSetting$MassEmail$initSegment(bool)
					});
			case 3:
				var string = field.a;
				var _v2 = fields;
				var activeSponsored = _v2.id;
				return _Utils_update(
					fields,
					{
						id: _Utils_update(
							activeSponsored,
							{
								ali: $elm$core$Maybe$Just(string)
							})
					});
			case 4:
				var bool = field.a;
				return _Utils_update(
					fields,
					{
						jV: $author$project$Components$Admin$NotificationSetting$MassEmail$initSegment(bool)
					});
			case 5:
				var string = field.a;
				var _v3 = fields;
				var inactiveRetail = _v3.jV;
				return _Utils_update(
					fields,
					{
						jV: _Utils_update(
							inactiveRetail,
							{
								ali: $elm$core$Maybe$Just(string)
							})
					});
			case 6:
				var bool = field.a;
				return _Utils_update(
					fields,
					{
						jW: $author$project$Components$Admin$NotificationSetting$MassEmail$initSegment(bool)
					});
			default:
				var string = field.a;
				var _v4 = fields;
				var inactiveSponsored = _v4.jW;
				return _Utils_update(
					fields,
					{
						jW: _Utils_update(
							inactiveSponsored,
							{
								ali: $elm$core$Maybe$Just(string)
							})
					});
		}
	});
var $author$project$Components$Admin$NotificationSetting$MassEmail$SegmentsValidation = 0;
var $author$project$Components$Admin$NotificationSetting$MassEmail$ActiveRetailValidation = 1;
var $author$project$Components$Admin$NotificationSetting$MassEmail$ActiveSponsoredValidation = 2;
var $author$project$Components$Admin$NotificationSetting$MassEmail$InactiveRetailValidation = 3;
var $author$project$Components$Admin$NotificationSetting$MassEmail$InactiveSponsoredValidation = 4;
var $author$project$Components$Admin$NotificationSetting$MassEmail$selectedSegments = function (fields) {
	return A2(
		$elm$core$List$filterMap,
		function (_v0) {
			var segment = _v0.a;
			var validationGroup = _v0.b;
			return segment.aB ? $elm$core$Maybe$Just(
				_Utils_Tuple2(segment, validationGroup)) : $elm$core$Maybe$Nothing;
		},
		_List_fromArray(
			[
				_Utils_Tuple2(fields.ic, 1),
				_Utils_Tuple2(fields.id, 2),
				_Utils_Tuple2(fields.jV, 3),
				_Utils_Tuple2(fields.jW, 4)
			]));
};
var $author$project$Components$Admin$NotificationSetting$MassEmail$validatePatientsOneOffEmailSegments = function (fields) {
	var selectedSegments_ = $author$project$Components$Admin$NotificationSetting$MassEmail$selectedSegments(fields);
	return $elm$core$List$isEmpty(selectedSegments_) ? _List_fromArray(
		[
			_Utils_Tuple2(0, 'Please check at least one.')
		]) : A2(
		$elm$core$List$filterMap,
		function (_v0) {
			var segment = _v0.a;
			var validationGroup = _v0.b;
			return (segment.aB && _Utils_eq(segment.ali, $elm$core$Maybe$Nothing)) ? $elm$core$Maybe$Just(
				_Utils_Tuple2(validationGroup, 'Please pick one.')) : $elm$core$Maybe$Nothing;
		},
		selectedSegments_);
};
var $author$project$Components$Admin$NotificationSetting$MassEmail$notificationSettingFormFieldsValidator = function (type_) {
	return $rtfeldman$elm_validate$Validate$all(
		(type_ === 'patients_one_off_email') ? _List_fromArray(
			[
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$NotificationSetting$MassEmail$validatePatientsOneOffEmailSegments)
			]) : _List_Nil);
};
var $author$project$Components$Admin$NotificationSetting$MassEmail$GotBulkNotification = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$Company$Notification$notificationsPath = function (companyId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['notifications']),
		$author$project$Api$Provider$Company$companyPath(companyId));
};
var $author$project$Api$Provider$Company$Notification$bulk = F5(
	function (apiClient, type_, segments, companyId, toMsg) {
		var body_ = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'notification',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'type',
								$elm$json$Json$Encode$string(type_)),
								_Utils_Tuple2(
								'segments',
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, segments))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body_,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['bulk']),
						$author$project$Api$Provider$Company$Notification$notificationsPath(companyId)))));
	});
var $author$project$Api$Provider$Notification$notificationsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['notifications']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Notification$bulk = F4(
	function (apiClient, type_, segments, toMsg) {
		var body_ = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'notification',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'type',
								$elm$json$Json$Encode$string(type_)),
								_Utils_Tuple2(
								'segments',
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, segments))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body_,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['bulk']),
						$author$project$Api$Provider$Notification$notificationsPath))));
	});
var $author$project$Components$Admin$NotificationSetting$MassEmail$sendBulkNotification = F3(
	function (client, shared, segments) {
		var _v0 = shared.a3;
		if (_v0.$ === 1) {
			var id = _v0.a;
			return A5(
				$author$project$Api$Provider$Company$Notification$bulk,
				client,
				$author$project$Api$Provider$NotificationSetting$All$id(shared.X_),
				segments,
				id,
				$author$project$Components$Admin$NotificationSetting$MassEmail$GotBulkNotification);
		} else {
			return A4(
				$author$project$Api$Provider$Notification$bulk,
				client,
				$author$project$Api$Provider$NotificationSetting$All$id(shared.X_),
				segments,
				$author$project$Components$Admin$NotificationSetting$MassEmail$GotBulkNotification);
		}
	});
var $author$project$Components$Admin$NotificationSetting$MassEmail$update = F4(
	function (apiClient, msg, model, context) {
		switch (msg.$) {
			case 0:
				var session = msg.a;
				var notificationSetting = msg.b;
				var shared = {a3: context, X_: notificationSetting, oZ: $author$project$Api$Data$Loading, aa4: session};
				var formFields = $author$project$Components$Admin$NotificationSetting$MassEmail$initNotificationFormFields;
				return _Utils_Tuple3(
					A2(
						$author$project$Components$Admin$NotificationSetting$MassEmail$SelectingSegments,
						shared,
						$author$project$Utils$Form$init(formFields)),
					$author$project$Components$Admin$NotificationSetting$MassEmail$fetchPatientsWithoutEmail(apiClient),
					_List_Nil);
			case 6:
				var response = msg.a;
				var _v1 = _Utils_Tuple2(model, response);
				if (_v1.a.$ === 1) {
					var _v2 = _v1.a;
					var shared = _v2.a;
					var notificationForm = _v2.b;
					return _Utils_Tuple3(
						A2(
							$author$project$Components$Admin$NotificationSetting$MassEmail$SelectingSegments,
							_Utils_update(
								shared,
								{oZ: response}),
							notificationForm),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 1:
				return _Utils_Tuple3($author$project$Components$Admin$NotificationSetting$MassEmail$Closed, $elm$core$Platform$Cmd$none, _List_Nil);
			case 2:
				if (model.$ === 1) {
					var shared = model.a;
					var notificationForm = model.b;
					var _v4 = A2(
						$author$project$Utils$Form$validate,
						$author$project$Components$Admin$NotificationSetting$MassEmail$notificationSettingFormFieldsValidator(
							$author$project$Api$Provider$NotificationSetting$All$id(shared.X_)),
						notificationForm);
					if (!_v4.$) {
						var _v5 = _v4.a;
						var validFormFields = _v5.b;
						var segments = A2(
							$elm$core$List$filterMap,
							function ($) {
								return $.ali;
							},
							A2(
								$elm$core$List$map,
								$elm$core$Tuple$first,
								$author$project$Components$Admin$NotificationSetting$MassEmail$selectedSegments(
									$rtfeldman$elm_validate$Validate$fromValid(validFormFields))));
						return _Utils_Tuple3(
							A3($author$project$Components$Admin$NotificationSetting$MassEmail$Previewing, shared, segments, $author$project$Api$Data$NotAsked),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						var newForm = _v4.a;
						return _Utils_Tuple3(
							A2($author$project$Components$Admin$NotificationSetting$MassEmail$SelectingSegments, shared, newForm),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				var field = msg.a;
				if (model.$ === 1) {
					var shared = model.a;
					var notificationForm = model.b;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Admin$NotificationSetting$MassEmail$notificationSettingFormFieldsUpdate, field, notificationForm);
					return _Utils_Tuple3(
						A2($author$project$Components$Admin$NotificationSetting$MassEmail$SelectingSegments, shared, newForm),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				if (model.$ === 2) {
					var shared = model.a;
					var formFields = $author$project$Components$Admin$NotificationSetting$MassEmail$initNotificationFormFields;
					return _Utils_Tuple3(
						A2(
							$author$project$Components$Admin$NotificationSetting$MassEmail$SelectingSegments,
							shared,
							$author$project$Utils$Form$init(formFields)),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				if (model.$ === 2) {
					var shared = model.a;
					var segments = model.b;
					return _Utils_Tuple3(
						A3($author$project$Components$Admin$NotificationSetting$MassEmail$Previewing, shared, segments, $author$project$Api$Data$Loading),
						A3($author$project$Components$Admin$NotificationSetting$MassEmail$sendBulkNotification, apiClient, shared, segments),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var response = msg.a;
				if (model.$ === 2) {
					var shared = model.a;
					var segments = model.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							$author$project$Components$Admin$NotificationSetting$MassEmail$Closed,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Notifications are being sent.')
								]));
					} else {
						return _Utils_Tuple3(
							A3($author$project$Components$Admin$NotificationSetting$MassEmail$Previewing, shared, segments, response),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Components$Admin$NotificationSetting$Preview$update = F3(
	function (client, msg, model) {
		switch (msg.$) {
			case 3:
				var dropdownMsg = msg.a;
				var _v1 = model.gi;
				if (!_v1.$) {
					var dropdown = _v1.a;
					var _v2 = A2($author$project$Ui$Dropdown$update, dropdownMsg, dropdown);
					var newDropdown = _v2.a;
					var dropdownCmd = _v2.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								gi: $elm$core$Maybe$Just(newDropdown)
							}),
						dropdownCmd);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{Yn: false}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var language = msg.a;
				var _v3 = function () {
					var _v4 = A2(
						$elm$core$Dict$get,
						$author$project$Language$toValue(language),
						model.akd);
					if (_v4.$ === 1) {
						return _Utils_Tuple2(
							A3(
								$elm$core$Dict$insert,
								$author$project$Language$toValue(language),
								$author$project$Api$Data$Loading,
								model.akd),
							A3($author$project$Components$Admin$NotificationSetting$Preview$previewNotificationSetting, client, language, model));
					} else {
						return _Utils_Tuple2(model.akd, $elm$core$Platform$Cmd$none);
					}
				}();
				var preview = _v3.a;
				var previewCmd = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{Ay: language, akd: preview}),
					previewCmd);
			default:
				var language = msg.a;
				var preview = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							akd: A3(
								$elm$core$Dict$insert,
								$author$project$Language$toValue(language),
								preview,
								model.akd)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $elm_community$list_extra$List$Extra$updateIf = F3(
	function (predicate, update, list) {
		return A2(
			$elm$core$List$map,
			function (item) {
				return predicate(item) ? update(item) : item;
			},
			list);
	});
var $author$project$Components$Admin$NotificationSetting$Customize$withAdminUser = F2(
	function (isAdmin, model) {
		return _Utils_update(
			model,
			{F1: isAdmin});
	});
var $author$project$Components$Admin$NotificationSetting$Customize$withMultiLanguage = F2(
	function (multiLanguage, model) {
		return _Utils_update(
			model,
			{tc: multiLanguage});
	});
var $author$project$Components$Admin$NotificationSetting$AdminTable$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var notificationSettings = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								V8: false,
								bI: A2(
									$elm$core$List$map,
									function (notificationSetting) {
										return _Utils_Tuple3(
											notificationSetting,
											A2($author$project$Components$Admin$NotificationSetting$Toggle$init, $author$project$Components$Admin$NotificationSetting$Toggle$allGetters, notificationSetting),
											A2(
												$author$project$Components$Admin$NotificationSetting$Customize$withMultiLanguage,
												model.tc,
												A2(
													$author$project$Components$Admin$NotificationSetting$Customize$withAdminUser,
													$author$project$Api$Platform$User$Shared$isAdmin(
														$author$project$Api$Platform$Session$One$user(model.aa4)),
													A2($author$project$Components$Admin$NotificationSetting$Customize$initFromAll, notificationSetting, model.a3))));
									},
									notificationSettings)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{V8: false, bI: _List_Nil}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{tW: response}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				var notificationSetting = msg.a;
				var _v3 = A4($author$project$Components$Admin$NotificationSetting$Preview$init, apiClient, model.tc, notificationSetting, model.a3);
				var preview = _v3.a;
				var previewCmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							akd: $elm$core$Maybe$Just(preview)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$NotificationSetting$AdminTable$PreviewMsg, previewCmd),
					_List_Nil);
			case 3:
				var currentSetting = msg.a;
				var subMsg = msg.b;
				var id = $author$project$Api$Provider$NotificationSetting$All$id(currentSetting);
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil),
					A2(
						$elm$core$Maybe$map,
						function (_v5) {
							var customizeNotification = _v5.c;
							var result = A3($author$project$Components$Admin$NotificationSetting$Customize$update, apiClient, subMsg, customizeNotification);
							var _v6 = function () {
								var _v7 = result.agZ;
								if (_v7 === 1) {
									return _Utils_Tuple2(
										true,
										A2($author$project$Components$Admin$NotificationSetting$AdminTable$fetchNotificationSettings, apiClient, model));
								} else {
									return _Utils_Tuple2(false, $elm$core$Platform$Cmd$none);
								}
							}();
							var loading = _v6.a;
							var cmd = _v6.b;
							return function (settings) {
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{V8: loading, bI: settings}),
									$elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[
												A2(
												$elm$core$Platform$Cmd$map,
												$author$project$Components$Admin$NotificationSetting$AdminTable$CustomizeNotificationMsg(currentSetting),
												result.GZ),
												cmd
											])),
									result.aR);
							}(
								A3(
									$elm_community$list_extra$List$Extra$updateIf,
									function (_v8) {
										var notificationSetting_ = _v8.a;
										return _Utils_eq(
											$author$project$Api$Provider$NotificationSetting$All$id(notificationSetting_),
											id);
									},
									function (_v9) {
										var notificationSetting_ = _v9.a;
										var toggleNotification = _v9.b;
										return _Utils_Tuple3(notificationSetting_, toggleNotification, result.aiO);
									},
									model.bI));
						},
						A2(
							$elm_community$list_extra$List$Extra$find,
							function (_v4) {
								var notificationSetting = _v4.a;
								return _Utils_eq(
									$author$project$Api$Provider$NotificationSetting$All$id(notificationSetting),
									id);
							},
							model.bI)));
			case 4:
				var id = msg.a;
				var toggleNotification = msg.b;
				var subMsg = msg.c;
				var refetchCmd = function () {
					if ($author$project$Components$Admin$NotificationSetting$AdminTable$isOverridableCompanyToggle(id)) {
						var _v13 = model.a3;
						if (_v13.$ === 1) {
							var companyId = _v13.a;
							return A3($author$project$Api$Provider$Company$NotificationSetting$list, apiClient, companyId, $author$project$Components$Admin$NotificationSetting$AdminTable$GotNotificationSettings);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				var _v10 = A4($author$project$Components$Admin$NotificationSetting$Toggle$update, apiClient, model.a3, subMsg, toggleNotification);
				var toggleNotification_ = _v10.a;
				var subCmd = _v10.b;
				var subOutMsg = _v10.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bI: A3(
								$elm_community$list_extra$List$Extra$updateIf,
								function (_v11) {
									var notificationSetting_ = _v11.a;
									return _Utils_eq(
										$author$project$Api$Provider$NotificationSetting$All$id(notificationSetting_),
										id);
								},
								function (_v12) {
									var notificationSetting_ = _v12.a;
									var translateInput = _v12.c;
									return _Utils_Tuple3(notificationSetting_, toggleNotification_, translateInput);
								},
								model.bI)
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Platform$Cmd$map,
								A2($author$project$Components$Admin$NotificationSetting$AdminTable$ToggleNotificationMsg, id, toggleNotification_),
								subCmd),
								refetchCmd
							])),
					subOutMsg);
			case 5:
				var id = msg.a;
				var companySetting = A2(
					$elm$core$Maybe$map,
					function (_v18) {
						var ns = _v18.a;
						return ns;
					},
					A2(
						$elm_community$list_extra$List$Extra$find,
						function (_v17) {
							var ns = _v17.a;
							return _Utils_eq(
								$author$project$Api$Provider$NotificationSetting$All$id(ns),
								id);
						},
						model.bI));
				var hasOverride = function () {
					if (!companySetting.$) {
						var company = companySetting.a;
						return !_Utils_eq(
							$author$project$Api$Provider$NotificationSetting$All$customEnabled(company),
							$elm$core$Maybe$Nothing);
					} else {
						return false;
					}
				}();
				var cmd = function () {
					if (hasOverride) {
						var _v14 = model.a3;
						if (_v14.$ === 1) {
							var companyId = _v14.a;
							return A5(
								$author$project$Api$Provider$Company$NotificationSetting$reset,
								apiClient,
								companyId,
								id,
								{Ay: $author$project$Language$english},
								$author$project$Components$Admin$NotificationSetting$AdminTable$OverrideRemoved);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					} else {
						var _v15 = _Utils_Tuple2(model.a3, companySetting);
						if ((_v15.a.$ === 1) && (!_v15.b.$)) {
							var companyId = _v15.a.a;
							var company = _v15.b.a;
							var currentValue = $author$project$Api$Provider$NotificationSetting$All$enabled(company);
							return A5($author$project$Api$Provider$Company$NotificationSetting$toggle, apiClient, companyId, id, currentValue, $author$project$Components$Admin$NotificationSetting$AdminTable$OverrideCreated);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}
				}();
				return _Utils_Tuple3(model, cmd, _List_Nil);
			case 8:
				var subMsg = msg.a;
				var _v19 = A4($author$project$Components$Admin$NotificationSetting$MassEmail$update, apiClient, subMsg, model.oA, model.a3);
				var massEmail = _v19.a;
				var massEmailCmd = _v19.b;
				var massEmailOutMsgs = _v19.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{V8: false, oA: massEmail}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$NotificationSetting$AdminTable$MassEmailMsg, massEmailCmd),
					massEmailOutMsgs);
			case 9:
				var previewMsg = msg.a;
				var _v20 = model.akd;
				if (!_v20.$) {
					var preview = _v20.a;
					return A2(
						$author$project$Utils$Tuple3$fromTuple2,
						_List_Nil,
						A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Platform$Cmd$map($author$project$Components$Admin$NotificationSetting$AdminTable$PreviewMsg),
							A2(
								$elm$core$Tuple$mapFirst,
								function (prev) {
									return _Utils_update(
										model,
										{
											akd: $elm$core$Maybe$Just(prev)
										});
								},
								A3($author$project$Components$Admin$NotificationSetting$Preview$update, apiClient, previewMsg, preview))));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var response = msg.a;
				if (response.$ === 3) {
					var refetchCmd = function () {
						var _v22 = model.a3;
						if (_v22.$ === 1) {
							var companyId = _v22.a;
							return A3($author$project$Api$Provider$Company$NotificationSetting$list, apiClient, companyId, $author$project$Components$Admin$NotificationSetting$AdminTable$GotNotificationSettings);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}();
					return _Utils_Tuple3(
						model,
						refetchCmd,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Override created. You can now customize this setting.')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var refetchCmd = function () {
						var _v24 = model.a3;
						if (_v24.$ === 1) {
							var companyId = _v24.a;
							return A3($author$project$Api$Provider$Company$NotificationSetting$list, apiClient, companyId, $author$project$Components$Admin$NotificationSetting$AdminTable$GotNotificationSettings);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}();
					return _Utils_Tuple3(
						model,
						refetchCmd,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Override removed. Now using practice default.')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Admin$Notifications$Company$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Admin$NotificationSetting$AdminTable$update, model.Gv, subMsg, model.s1);
		var adminTable = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{s1: adminTable}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Api$Provider$NotificationSetting$Shared$bodyExample = function (_v0) {
	var record = _v0;
	return record.ML;
};
var $author$project$Api$Provider$NotificationSetting$All$bodyExample = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$NotificationSetting$Shared$bodyExample(shared);
};
var $author$project$Api$Provider$NotificationSetting$Shared$subjectExample = function (_v0) {
	var record = _v0;
	return record.acv;
};
var $author$project$Api$Provider$NotificationSetting$All$subjectExample = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$NotificationSetting$Shared$subjectExample(shared);
};
var $author$project$Components$Admin$NotificationSetting$MassEmail$ActiveRetailSegment = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$NotificationSetting$MassEmail$NotificationFormFieldUpdated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$NotificationSetting$MassEmail$ToggleActiveRetail = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$Checkbox$Errors = function (a) {
	return {$: 8, a: a};
};
var $author$project$Ui$Form$Checkbox$errors = $author$project$Ui$Form$Checkbox$Errors;
var $author$project$Components$Admin$NotificationSetting$MassEmail$viewActiveRetailPatients = F2(
	function (form, activeRetail) {
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Checkbox$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Checkbox$value(activeRetail.aB),
										$author$project$Ui$Form$Checkbox$onCheck(
										A2($elm$core$Basics$composeL, $author$project$Components$Admin$NotificationSetting$MassEmail$NotificationFormFieldUpdated, $author$project$Components$Admin$NotificationSetting$MassEmail$ToggleActiveRetail)),
										$author$project$Ui$Form$Checkbox$errors(
										A2($author$project$Utils$Form$validationErrors, 1, form))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Retail patients')
									]))
							]))
					])),
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(11),
								$author$project$Ui$Grid$offset(1)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Radio$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Radio$value(
										_Utils_eq(
											activeRetail.ali,
											$elm$core$Maybe$Just('all_active_retail'))),
										$author$project$Ui$Form$Radio$onCheck(
										A2(
											$elm$core$Basics$composeL,
											$author$project$Components$Admin$NotificationSetting$MassEmail$NotificationFormFieldUpdated,
											$elm$core$Basics$always(
												$author$project$Components$Admin$NotificationSetting$MassEmail$ActiveRetailSegment('all_active_retail')))),
										$author$project$Ui$Form$Radio$disabled(!activeRetail.aB)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('All retail patients.'),
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
												_List_fromArray(
													[
														$elm$html$Html$text('Primary and dependent patients associated with an active/pending retail membership.')
													]))
											]))
									]))
							]))
					])),
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(11),
								$author$project$Ui$Grid$offset(1)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Radio$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Radio$value(
										_Utils_eq(
											activeRetail.ali,
											$elm$core$Maybe$Just('active_retail_membership_owners'))),
										$author$project$Ui$Form$Radio$onCheck(
										A2(
											$elm$core$Basics$composeL,
											$author$project$Components$Admin$NotificationSetting$MassEmail$NotificationFormFieldUpdated,
											$elm$core$Basics$always(
												$author$project$Components$Admin$NotificationSetting$MassEmail$ActiveRetailSegment('active_retail_membership_owners')))),
										$author$project$Ui$Form$Radio$disabled(!activeRetail.aB)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Membership owners only.'),
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
												_List_fromArray(
													[
														$elm$html$Html$text('Only the patients who pay for an active/pending retail membership (includes membership owners who are only payers).')
													]))
											]))
									]))
							]))
					]))
			]);
	});
var $author$project$Components$Admin$NotificationSetting$MassEmail$ActiveSponsoredSegment = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$NotificationSetting$MassEmail$ToggleActiveSponsored = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$NotificationSetting$MassEmail$viewActiveSponsoredPatients = F2(
	function (form, activeSponsored) {
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(12)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Checkbox$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Checkbox$value(activeSponsored.aB),
										$author$project$Ui$Form$Checkbox$onCheck(
										A2($elm$core$Basics$composeL, $author$project$Components$Admin$NotificationSetting$MassEmail$NotificationFormFieldUpdated, $author$project$Components$Admin$NotificationSetting$MassEmail$ToggleActiveSponsored)),
										$author$project$Ui$Form$Checkbox$errors(
										A2($author$project$Utils$Form$validationErrors, 2, form))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Sponsored patients')
									]))
							]))
					])),
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(11),
								$author$project$Ui$Grid$offset(1)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Radio$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Radio$value(
										_Utils_eq(
											activeSponsored.ali,
											$elm$core$Maybe$Just('all_active_sponsored'))),
										$author$project$Ui$Form$Radio$onCheck(
										A2(
											$elm$core$Basics$composeL,
											$author$project$Components$Admin$NotificationSetting$MassEmail$NotificationFormFieldUpdated,
											$elm$core$Basics$always(
												$author$project$Components$Admin$NotificationSetting$MassEmail$ActiveSponsoredSegment('all_active_sponsored')))),
										$author$project$Ui$Form$Radio$disabled(!activeSponsored.aB)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('All sponsored patients.'),
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
												_List_fromArray(
													[
														$elm$html$Html$text('Primary and dependent patients associated with an active/pending employer- or network-sponsored membership.')
													]))
											]))
									]))
							]))
					])),
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(11),
								$author$project$Ui$Grid$offset(1)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Radio$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Radio$value(
										_Utils_eq(
											activeSponsored.ali,
											$elm$core$Maybe$Just('active_sponsored_membership_owners'))),
										$author$project$Ui$Form$Radio$onCheck(
										A2(
											$elm$core$Basics$composeL,
											$author$project$Components$Admin$NotificationSetting$MassEmail$NotificationFormFieldUpdated,
											$elm$core$Basics$always(
												$author$project$Components$Admin$NotificationSetting$MassEmail$ActiveSponsoredSegment('active_sponsored_membership_owners')))),
										$author$project$Ui$Form$Radio$disabled(!activeSponsored.aB)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Membership owners only.'),
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
												_List_fromArray(
													[
														$elm$html$Html$text('Only primary active employee or primary member of the network-sponsored membership.')
													]))
											]))
									]))
							]))
					]))
			]);
	});
var $author$project$Components$Admin$NotificationSetting$MassEmail$InactiveRetailSegment = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Admin$NotificationSetting$MassEmail$ToggleInactiveRetail = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$NotificationSetting$MassEmail$viewInactiveRetailPatients = F2(
	function (form, inactiveRetail) {
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(12)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Checkbox$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Checkbox$value(inactiveRetail.aB),
										$author$project$Ui$Form$Checkbox$onCheck(
										A2($elm$core$Basics$composeL, $author$project$Components$Admin$NotificationSetting$MassEmail$NotificationFormFieldUpdated, $author$project$Components$Admin$NotificationSetting$MassEmail$ToggleInactiveRetail)),
										$author$project$Ui$Form$Checkbox$errors(
										A2($author$project$Utils$Form$validationErrors, 3, form))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Retail patients')
									]))
							]))
					])),
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(11),
								$author$project$Ui$Grid$offset(1)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Radio$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Radio$value(
										_Utils_eq(
											inactiveRetail.ali,
											$elm$core$Maybe$Just('all_inactive_retail'))),
										$author$project$Ui$Form$Radio$onCheck(
										A2(
											$elm$core$Basics$composeL,
											$author$project$Components$Admin$NotificationSetting$MassEmail$NotificationFormFieldUpdated,
											$elm$core$Basics$always(
												$author$project$Components$Admin$NotificationSetting$MassEmail$InactiveRetailSegment('all_inactive_retail')))),
										$author$project$Ui$Form$Radio$disabled(!inactiveRetail.aB)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('All retail patients.'),
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
												_List_fromArray(
													[
														$elm$html$Html$text('Primary and dependent inactive patients on an inactive retail membership.')
													]))
											]))
									]))
							]))
					])),
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(11),
								$author$project$Ui$Grid$offset(1)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Radio$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Radio$value(
										_Utils_eq(
											inactiveRetail.ali,
											$elm$core$Maybe$Just('inactive_retail_membership_owners'))),
										$author$project$Ui$Form$Radio$onCheck(
										A2(
											$elm$core$Basics$composeL,
											$author$project$Components$Admin$NotificationSetting$MassEmail$NotificationFormFieldUpdated,
											$elm$core$Basics$always(
												$author$project$Components$Admin$NotificationSetting$MassEmail$InactiveRetailSegment('inactive_retail_membership_owners')))),
										$author$project$Ui$Form$Radio$disabled(!inactiveRetail.aB)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Membership owners only.'),
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
												_List_fromArray(
													[
														$elm$html$Html$text('Only inactive patients who have previously owned a membership or are a payer on an active membership.')
													]))
											]))
									]))
							]))
					]))
			]);
	});
var $author$project$Components$Admin$NotificationSetting$MassEmail$InactiveSponsoredSegment = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Admin$NotificationSetting$MassEmail$ToggleInactiveSponsored = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Admin$NotificationSetting$MassEmail$viewInactiveSponsoredPatients = F2(
	function (form, inactiveSponsored) {
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(12)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Checkbox$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Checkbox$value(inactiveSponsored.aB),
										$author$project$Ui$Form$Checkbox$onCheck(
										A2($elm$core$Basics$composeL, $author$project$Components$Admin$NotificationSetting$MassEmail$NotificationFormFieldUpdated, $author$project$Components$Admin$NotificationSetting$MassEmail$ToggleInactiveSponsored)),
										$author$project$Ui$Form$Checkbox$errors(
										A2($author$project$Utils$Form$validationErrors, 4, form))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Sponsored patients')
									]))
							]))
					])),
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(11),
								$author$project$Ui$Grid$offset(1)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Radio$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Radio$value(
										_Utils_eq(
											inactiveSponsored.ali,
											$elm$core$Maybe$Just('all_inactive_sponsored'))),
										$author$project$Ui$Form$Radio$onCheck(
										A2(
											$elm$core$Basics$composeL,
											$author$project$Components$Admin$NotificationSetting$MassEmail$NotificationFormFieldUpdated,
											$elm$core$Basics$always(
												$author$project$Components$Admin$NotificationSetting$MassEmail$InactiveSponsoredSegment('all_inactive_sponsored')))),
										$author$project$Ui$Form$Radio$disabled(!inactiveSponsored.aB)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('All sponsored patients.'),
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
												_List_fromArray(
													[
														$elm$html$Html$text('Primary and dependent inactive patients associated with a network or employer sponsor.')
													]))
											]))
									]))
							]))
					])),
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(11),
								$author$project$Ui$Grid$offset(1)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Radio$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Radio$value(
										_Utils_eq(
											inactiveSponsored.ali,
											$elm$core$Maybe$Just('inactive_sponsored_membership_owners'))),
										$author$project$Ui$Form$Radio$onCheck(
										A2(
											$elm$core$Basics$composeL,
											$author$project$Components$Admin$NotificationSetting$MassEmail$NotificationFormFieldUpdated,
											$elm$core$Basics$always(
												$author$project$Components$Admin$NotificationSetting$MassEmail$InactiveSponsoredSegment('inactive_sponsored_membership_owners')))),
										$author$project$Ui$Form$Radio$disabled(!inactiveSponsored.aB)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Membership owners only.'),
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
												_List_fromArray(
													[
														$elm$html$Html$text('Only primary inactive employee or primary member of the network-sponsored membership.')
													]))
											]))
									]))
							]))
					]))
			]);
	});
var $author$project$Components$Admin$NotificationSetting$MassEmail$viewSegmentsSelection = F2(
	function (patientsWithoutEmail, segments) {
		var patientsWithoutEmailCount = function () {
			if (patientsWithoutEmail.$ === 3) {
				var headers = patientsWithoutEmail.b;
				return A2(
					$elm$core$Maybe$withDefault,
					0,
					A2(
						$elm$core$Maybe$andThen,
						$elm$core$String$toInt,
						A2($elm$core$Dict$get, 'x-total-count', headers)));
			} else {
				return 0;
			}
		}();
		return A2(
			$elm$core$List$cons,
			A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						(patientsWithoutEmailCount > 0) ? A2(
						$author$project$Ui$Alert$danger,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Note:')
									])),
								$elm$html$Html$text(' We cannot email patients who are missing an email address. You have '),
								A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Patients__Top,
								_List_fromArray(
									[
										$author$project$Ui$Link$routeParams(
										_List_fromArray(
											[
												A2($elm$url$Url$Builder$string, 'filter', 'without_email')
											]))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2($author$project$Formatters$String$pluralize, 'patient', patientsWithoutEmailCount))
									])),
								$elm$html$Html$text(' without an email address.')
							])) : $author$project$Utils$Html$empty,
						A2(
						$author$project$Ui$Typography$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Select the recipients of your email')
							]))
					])),
			segments);
	});
var $author$project$Components$Admin$NotificationSetting$MassEmail$viewPatientsOneOffEmailContent = F2(
	function (form, shared) {
		var resource = shared.a3;
		var _v0 = $author$project$Utils$Form$fields(form);
		var activeRetail = _v0.ic;
		var inactiveRetail = _v0.jV;
		var activeSponsored = _v0.id;
		var inactiveSponsored = _v0.jW;
		return A2(
			$author$project$Components$Admin$NotificationSetting$MassEmail$viewSegmentsSelection,
			shared.oZ,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$title,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Active Patients')
						])),
					_Utils_eq(resource, $author$project$Api$Provider$Notification$PracticeContext) ? A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					A2($author$project$Components$Admin$NotificationSetting$MassEmail$viewActiveRetailPatients, form, activeRetail)) : $author$project$Utils$Html$empty,
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					A2($author$project$Components$Admin$NotificationSetting$MassEmail$viewActiveSponsoredPatients, form, activeSponsored)),
					A2(
					$author$project$Ui$Typography$title,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Inactive Patients')
						])),
					_Utils_eq(resource, $author$project$Api$Provider$Notification$PracticeContext) ? A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					A2($author$project$Components$Admin$NotificationSetting$MassEmail$viewInactiveRetailPatients, form, inactiveRetail)) : $author$project$Utils$Html$empty,
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					A2($author$project$Components$Admin$NotificationSetting$MassEmail$viewInactiveSponsoredPatients, form, inactiveSponsored))
				]));
	});
var $author$project$Components$Admin$NotificationSetting$MassEmail$viewPreview = F2(
	function (subject, body) {
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Subject Line')
					]),
				_List_fromArray(
					[subject])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Body')
					]),
				_List_fromArray(
					[body]))
			]);
	});
var $author$project$Components$Admin$NotificationSetting$MassEmail$viewModalBody = function (model) {
	switch (model.$) {
		case 0:
			return _List_Nil;
		case 2:
			var shared = model.a;
			var delivery = model.c;
			return _Utils_ap(
				A2(
					$author$project$Components$Admin$NotificationSetting$MassEmail$viewPreview,
					A2(
						$author$project$Ui$Well$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[
										$author$project$Ui$Typography$phi(true)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Api$Provider$NotificationSetting$All$subjectExample(shared.X_))
									]))
							])),
					A2(
						$author$project$Ui$Well$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('notification-email-layout')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Api$HtmlTemplate$view,
										$author$project$Api$Phi$displayAttr,
										$author$project$Api$Provider$NotificationSetting$All$bodyExample(shared.X_))
									]))
							]))),
				_List_fromArray(
					[
						function () {
						if (delivery.$ === 2) {
							var error = delivery.a;
							return A2(
								$author$project$Ui$Alert$danger,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Error sending email')
											])),
										A2($elm$html$Html$br, _List_Nil, _List_Nil),
										$elm$html$Html$text(
										$author$project$Api$Data$errorToString(error))
									]));
						} else {
							return $author$project$Utils$Html$empty;
						}
					}()
					]));
		default:
			var shared = model.a;
			var form = model.b;
			var _v2 = $author$project$Api$Provider$NotificationSetting$All$id(shared.X_);
			switch (_v2) {
				case 'patient_setup_payment_information':
					return A2(
						$author$project$Components$Admin$NotificationSetting$MassEmail$viewSegmentsSelection,
						shared.oZ,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(12)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Checkbox$view,
												_List_fromArray(
													[
														$author$project$Ui$Form$Checkbox$disabled(true)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Employees')
													])),
												A2(
												$author$project$Ui$Form$Checkbox$view,
												_List_fromArray(
													[
														$author$project$Ui$Form$Checkbox$disabled(true)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Patients')
													])),
												A2(
												$author$project$Ui$Form$Checkbox$view,
												_List_fromArray(
													[
														$author$project$Ui$Form$Checkbox$disabled(true),
														$author$project$Ui$Form$Checkbox$value(true)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Membership Owners')
													])),
												A2(
												$author$project$Ui$Form$Checkbox$view,
												_List_fromArray(
													[
														$author$project$Ui$Form$Checkbox$disabled(true),
														$author$project$Ui$Form$Checkbox$value(true)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Missing Payment Information')
													]))
											]))
									]))
							]));
				case 'provider_and_location_selection_request':
					var patientsWithoutEmailCount = function () {
						var _v3 = shared.oZ;
						if (_v3.$ === 3) {
							var headers = _v3.b;
							return A2(
								$elm$core$Maybe$withDefault,
								0,
								A2(
									$elm$core$Maybe$andThen,
									$elm$core$String$toInt,
									A2($elm$core$Dict$get, 'x-total-count', headers)));
						} else {
							return 0;
						}
					}();
					return _List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									(patientsWithoutEmailCount > 0) ? A2(
									$author$project$Ui$Alert$danger,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Note:')
												])),
											$elm$html$Html$text(' We cannot email patients who are missing an email address. You have '),
											A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$Patients__Top,
											_List_fromArray(
												[
													$author$project$Ui$Link$routeParams(
													_List_fromArray(
														[
															A2($elm$url$Url$Builder$string, 'filter', 'without_email')
														]))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2($author$project$Formatters$String$pluralize, 'patient', patientsWithoutEmailCount))
												])),
											$elm$html$Html$text(' without an email address.')
										])) : $author$project$Utils$Html$empty
								]))
						]);
				case 'patients_one_off_email':
					return A2($author$project$Components$Admin$NotificationSetting$MassEmail$viewPatientsOneOffEmailContent, form, shared);
				default:
					return _List_Nil;
			}
	}
};
var $author$project$Components$Admin$NotificationSetting$MassEmail$Preview = {$: 2};
var $author$project$Components$Admin$NotificationSetting$MassEmail$SelectSegments = {$: 3};
var $author$project$Components$Admin$NotificationSetting$MassEmail$Send = {$: 5};
var $author$project$Utils$FormErrors$alert = F2(
	function (style, errorList) {
		return $elm$core$List$isEmpty(errorList) ? $author$project$Utils$Html$empty : A3(
			$author$project$Ui$Alert$view,
			style,
			_List_fromArray(
				[
					$author$project$Ui$Alert$alignment($author$project$Ui$Alignment$textCenter)
				]),
			A2($elm$core$List$map, $elm$html$Html$text, errorList));
	});
var $author$project$Ui$Icon$rotate270 = $author$project$Ui$Icon$Rotate(270);
var $author$project$Components$Admin$NotificationSetting$MassEmail$viewModalFooter = function (model) {
	return $elm$core$List$singleton(
		A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$gap2]),
			function () {
				switch (model.$) {
					case 0:
						return _List_Nil;
					case 2:
						var request = model.c;
						var loading = function () {
							if (request.$ === 1) {
								return true;
							} else {
								return false;
							}
						}();
						return _List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Cancel and close modal'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$onClick($author$project$Components$Admin$NotificationSetting$MassEmail$SelectSegments)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Icon$chevronDown(
										_List_fromArray(
											[$author$project$Ui$Icon$rotate90])),
										$elm$html$Html$text('Back')
									])),
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Email patients'},
								_List_fromArray(
									[
										$author$project$Ui$Button$primary,
										$author$project$Ui$Button$submit,
										$author$project$Ui$Button$onClick($author$project$Components$Admin$NotificationSetting$MassEmail$Send),
										$author$project$Ui$Button$loading(loading),
										$author$project$Ui$Button$icon($author$project$Ui$Icon$check)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Email Patients')
									]))
							]);
					default:
						var form = model.b;
						return _List_fromArray(
							[
								A2(
								$author$project$Utils$FormErrors$alert,
								2,
								A2($author$project$Utils$Form$validationErrors, 0, form)),
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Preview before sending'},
								_List_fromArray(
									[
										$author$project$Ui$Button$primary,
										$author$project$Ui$Button$onClick($author$project$Components$Admin$NotificationSetting$MassEmail$Preview)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Icon$chevronDown(
										_List_fromArray(
											[$author$project$Ui$Icon$rotate270])),
										$elm$html$Html$text(' Preview Before Sending')
									]))
							]);
				}
			}()));
};
var $author$project$Components$Admin$NotificationSetting$MassEmail$viewModal = function (model) {
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Admin$NotificationSetting$MassEmail$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Send Mass Email')
					])),
				$author$project$Ui$Modal$body(
				$author$project$Components$Admin$NotificationSetting$MassEmail$viewModalBody(model)),
				$author$project$Ui$Modal$footer(
				$author$project$Components$Admin$NotificationSetting$MassEmail$viewModalFooter(model))
			]));
};
var $author$project$Components$Admin$NotificationSetting$MassEmail$modal = function (model) {
	switch (model.$) {
		case 0:
			return $author$project$Utils$Html$empty;
		case 1:
			return $author$project$Components$Admin$NotificationSetting$MassEmail$viewModal(model);
		default:
			return $author$project$Components$Admin$NotificationSetting$MassEmail$viewModal(model);
	}
};
var $author$project$Components$Admin$NotificationSetting$Preview$LanguageSelected = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$NotificationSetting$All$description = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$NotificationSetting$Shared$description(shared);
};
var $author$project$Api$Provider$NotificationSetting$All$shortDescriptionHtml = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$NotificationSetting$Shared$shortDescriptionHtml(shared);
};
var $author$project$Ui$Form$Group$labelSkeleton = function (text) {
	return $author$project$Ui$Form$Group$Label(
		$author$project$Ui$Form$Group$Html(
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$spanFromText(text)
						]))
				])));
};
var $author$project$Components$Admin$NotificationSetting$Preview$viewSkeleton = _List_fromArray(
	[
		$author$project$Ui$Skeleton$text(_List_Nil),
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSkeleton('Subject Line')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Well$view,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Skeleton$text(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$spanFromText('Skeleton subject')
							]))
					]))
			])),
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSkeleton('Body')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Well$view,
				_List_Nil,
				A2(
					$elm$core$List$repeat,
					10,
					$author$project$Ui$Skeleton$text(_List_Nil)))
			]))
	]);
var $author$project$Components$Admin$NotificationSetting$Preview$view = function (model) {
	return model.Yn ? A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Admin$NotificationSetting$Preview$CloseModal,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title(
						$author$project$Api$Provider$NotificationSetting$All$shortDescriptionHtml(model.X_))
					])),
				$author$project$Ui$Modal$body(
				A2(
					$elm$core$List$cons,
					A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mb2]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Api$Provider$NotificationSetting$All$description(model.X_))
							])),
					A2(
						$elm$core$List$cons,
						function () {
							var _v0 = model.gi;
							if (!_v0.$) {
								var dropdown = _v0.a;
								var languageToItem = function (lang) {
									return A2(
										$author$project$Ui$Dropdown$item,
										_List_fromArray(
											[
												$author$project$Ui$Dropdown$selected(
												_Utils_eq(lang, model.Ay)),
												$author$project$Ui$Dropdown$onSelect(
												$author$project$Components$Admin$NotificationSetting$Preview$LanguageSelected(lang))
											]),
										$elm$html$Html$text(
											$author$project$Language$toLabel(lang)));
								};
								var items = A2(
									$elm$core$List$map,
									languageToItem,
									_List_fromArray(
										[$author$project$Language$english, $author$project$Language$spanish]));
								return A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$label('Viewing'),
											$author$project$Ui$Form$Group$labelSpan(2),
											$author$project$Ui$Form$Group$inputSpan(4)
										]),
									_List_fromArray(
										[
											A4(
											$author$project$Ui$Dropdown$viewSelect,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Language$toLabel(model.Ay))
												]),
											items,
											dropdown)
										]));
							} else {
								return $elm$html$Html$text('');
							}
						}(),
						function () {
							var _v1 = A2(
								$elm$core$Dict$get,
								$author$project$Language$toValue(model.Ay),
								model.akd);
							if ((!_v1.$) && (_v1.a.$ === 3)) {
								var _v2 = _v1.a;
								var preview = _v2.a;
								var subject = $author$project$Api$Provider$NotificationSettingPreview$subject(preview);
								var body = $author$project$Api$Provider$NotificationSettingPreview$body(preview);
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$label('Subject'),
												$author$project$Ui$Form$Group$labelSpan(2)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Well$view,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(subject)
													]))
											])),
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$label('Body'),
												$author$project$Ui$Form$Group$labelSpan(2)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Well$view,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('notification-email-layout')
															]),
														_List_fromArray(
															[
																A2($author$project$Api$HtmlTemplate$view, _List_Nil, body)
															]))
													]))
											]))
									]);
							} else {
								return $author$project$Components$Admin$NotificationSetting$Preview$viewSkeleton;
							}
						}()))),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Admin$NotificationSetting$Preview$CloseModal)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Close')
							]))
					]))
			])) : $elm$html$Html$text('');
};
var $author$project$Components$Admin$NotificationSetting$AdminTable$ViewNotificationSetting = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$NotificationSetting$MassEmail$OpenModal = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Admin$NotificationSetting$MassEmail$supportedNotificationTypeIds = _List_fromArray(
	['patient_setup_payment_information', 'patients_one_off_email', 'provider_and_location_selection_request']);
var $author$project$Components$Admin$NotificationSetting$MassEmail$button = F2(
	function (session, notificationSetting) {
		var canSendMassEmail = A2(
			$elm$core$List$member,
			$author$project$Api$Provider$NotificationSetting$All$id(notificationSetting),
			$author$project$Components$Admin$NotificationSetting$MassEmail$supportedNotificationTypeIds);
		return canSendMassEmail ? A3(
			$author$project$Ui$Button$view,
			{mm: 'Send Email'},
			_List_fromArray(
				[
					$author$project$Ui$Button$link,
					$author$project$Ui$Button$onClick(
					A2($author$project$Components$Admin$NotificationSetting$MassEmail$OpenModal, session, notificationSetting))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Send Email')
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Components$Admin$NotificationSetting$AdminTable$viewDunningScheduleLink = F2(
	function (notificationSettingId, showCustomizeDunningFeature) {
		var invoiceSettingLink = A3(
			$author$project$Ui$Link$route,
			$author$project$Spa$Generated$Route$Admin__Notifications__Patient__DunningSchedule,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Schedule')
				]));
		var _v0 = _Utils_Tuple2(notificationSettingId, showCustomizeDunningFeature);
		_v0$2:
		while (true) {
			if (_v0.b) {
				switch (_v0.a) {
					case 'patient_charge_failed':
						return invoiceSettingLink;
					case 'patient_charge_failed_followup':
						return invoiceSettingLink;
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return $author$project$Utils$Html$empty;
	});
var $author$project$Components$Admin$NotificationSetting$AdminTable$ToggleOverrideToggleVisibility = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Admin$NotificationSetting$AdminTable$getNotificationSettingById = F2(
	function (id, data) {
		if (data.$ === 3) {
			var settings = data.a;
			return A2(
				$elm_community$list_extra$List$Extra$find,
				function (setting) {
					return _Utils_eq(
						$author$project$Api$Provider$NotificationSetting$All$id(setting),
						id);
				},
				settings);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Admin$NotificationSetting$AdminTable$viewCompanyOverrideToggle = F3(
	function (id, toggleNotification, model) {
		var viewToggle = A2(
			$elm$html$Html$map,
			A2($author$project$Components$Admin$NotificationSetting$AdminTable$ToggleNotificationMsg, id, toggleNotification),
			$author$project$Components$Admin$NotificationSetting$Toggle$view(toggleNotification));
		var practiceSettingsLoaded = function () {
			var _v4 = model.tW;
			if (_v4.$ === 3) {
				return true;
			} else {
				return false;
			}
		}();
		if (!practiceSettingsLoaded) {
			return viewToggle;
		} else {
			var companySetting = A2(
				$elm$core$Maybe$map,
				function (_v3) {
					var ns = _v3.a;
					return ns;
				},
				A2(
					$elm_community$list_extra$List$Extra$find,
					function (_v2) {
						var ns = _v2.a;
						return _Utils_eq(
							$author$project$Api$Provider$NotificationSetting$All$id(ns),
							id);
					},
					model.bI));
			if (companySetting.$ === 1) {
				return $author$project$Utils$Html$empty;
			} else {
				var company = companySetting.a;
				var hasOverride = !_Utils_eq(
					$author$project$Api$Provider$NotificationSetting$All$customEnabled(company),
					$elm$core$Maybe$Nothing);
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col items-start gap-2')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									function () {
									if (hasOverride) {
										return viewToggle;
									} else {
										var practiceSetting = A2($author$project$Components$Admin$NotificationSetting$AdminTable$getNotificationSettingById, id, model.tW);
										if (!practiceSetting.$) {
											var practice = practiceSetting.a;
											return A2(
												$author$project$Ui$Typography$title,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Api$Provider$NotificationSetting$All$enabled(practice) ? 'On' : 'Off')
													]));
										} else {
											return $author$project$Utils$Html$empty;
										}
									}
								}()
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('w-36')
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{
										mm: hasOverride ? 'Remove override' : 'Override'
									},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick(
											$author$project$Components$Admin$NotificationSetting$AdminTable$ToggleOverrideToggleVisibility(id))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											hasOverride ? 'Remove override' : 'Override')
										]))
								]))
						]));
			}
		}
	});
var $author$project$Components$Admin$NotificationSetting$AdminTable$viewOverrideToggle = F3(
	function (id, toggleNotification, model) {
		var _v0 = model.a3;
		if (_v0.$ === 1) {
			return $author$project$Components$Admin$NotificationSetting$AdminTable$isOverridableCompanyToggle(id) ? A3($author$project$Components$Admin$NotificationSetting$AdminTable$viewCompanyOverrideToggle, id, toggleNotification, model) : A2(
				$elm$html$Html$map,
				A2($author$project$Components$Admin$NotificationSetting$AdminTable$ToggleNotificationMsg, id, toggleNotification),
				$author$project$Components$Admin$NotificationSetting$Toggle$view(toggleNotification));
		} else {
			return A2(
				$elm$html$Html$map,
				A2($author$project$Components$Admin$NotificationSetting$AdminTable$ToggleNotificationMsg, id, toggleNotification),
				$author$project$Components$Admin$NotificationSetting$Toggle$view(toggleNotification));
		}
	});
var $author$project$Components$Admin$NotificationSetting$AdminTable$viewSettingsLink = function (notificationSettingId) {
	var invoiceSettingLink = A3(
		$author$project$Ui$Link$route,
		$author$project$Spa$Generated$Route$Admin__InvoiceSettings,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Manage Sponsor Invoice Settings')
			]));
	switch (notificationSettingId) {
		case 'employer_invoice_created':
			return invoiceSettingLink;
		case 'employer_invoice_generating':
			return invoiceSettingLink;
		default:
			return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Admin$NotificationSetting$AdminTable$viewNotificationSetting = F5(
	function (session, showCustomizeDunningFeature, index, _v0, model) {
		var notificationSetting = _v0.a;
		var toggleNotification = _v0.b;
		var customizeModel = _v0.c;
		var id = $author$project$Api$Provider$NotificationSetting$All$id(notificationSetting);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id(id)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Typography$headingSm(
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$core$String$fromInt(index + 1) + (' - ' + $author$project$Api$Provider$NotificationSetting$All$shortDescriptionHtml(notificationSetting)))
										]))
								])),
							A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$NotificationSetting$All$description(notificationSetting)),
									($author$project$Api$Provider$NotificationSetting$All$id(notificationSetting) === 'patients_one_off_email') ? A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Learn how to customize a message '),
											A3(
											$author$project$Ui$Link$externalHref,
											'http://support.hint.com/en/articles/3864748-custom-notifications',
											_List_fromArray(
												[$author$project$Ui$Link$targetBlank]),
											_List_fromArray(
												[
													$elm$html$Html$text('here')
												]))
										])) : $author$project$Utils$Html$empty
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{mm: 'View notification setting'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick(
											$author$project$Components$Admin$NotificationSetting$AdminTable$ViewNotificationSetting(notificationSetting))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('View')
										])),
									A2(
									$elm$html$Html$map,
									$author$project$Components$Admin$NotificationSetting$AdminTable$CustomizeNotificationMsg(notificationSetting),
									$author$project$Components$Admin$NotificationSetting$Customize$button(customizeModel)),
									A2(
									$elm$html$Html$map,
									$author$project$Components$Admin$NotificationSetting$AdminTable$MassEmailMsg,
									A2($author$project$Components$Admin$NotificationSetting$MassEmail$button, session, notificationSetting)),
									A2(
									$author$project$Components$Admin$NotificationSetting$AdminTable$viewDunningScheduleLink,
									$author$project$Api$Provider$NotificationSetting$All$id(notificationSetting),
									showCustomizeDunningFeature)
								])),
							A2(
							$elm$html$Html$map,
							$author$project$Components$Admin$NotificationSetting$AdminTable$CustomizeNotificationMsg(notificationSetting),
							$author$project$Components$Admin$NotificationSetting$Customize$modal(customizeModel))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A3($author$project$Components$Admin$NotificationSetting$AdminTable$viewOverrideToggle, id, toggleNotification, model),
							$author$project$Components$Admin$NotificationSetting$AdminTable$viewSettingsLink(
							$author$project$Api$Provider$NotificationSetting$All$id(notificationSetting))
						]))
				]));
	});
var $author$project$Components$Admin$NotificationSetting$AdminTable$viewTable = function (model) {
	return A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$loading(model.V8)
			]),
		_List_Nil,
		A2(
			$elm$core$List$indexedMap,
			F2(
				function (index, item) {
					return A5($author$project$Components$Admin$NotificationSetting$AdminTable$viewNotificationSetting, model.aa4, model.EB, index, item, model);
				}),
			model.bI),
		_List_Nil);
};
var $author$project$Components$Admin$NotificationSetting$AdminTable$view = function (model) {
	return _List_fromArray(
		[
			function () {
			var _v0 = model.akd;
			if (!_v0.$) {
				var preview = _v0.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Components$Admin$NotificationSetting$AdminTable$PreviewMsg,
					$author$project$Components$Admin$NotificationSetting$Preview$view(preview));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			A2(
			$elm$html$Html$map,
			$author$project$Components$Admin$NotificationSetting$AdminTable$MassEmailMsg,
			$author$project$Components$Admin$NotificationSetting$MassEmail$modal(model.oA)),
			$author$project$Components$Admin$NotificationSetting$AdminTable$viewTable(model)
		]);
};
var $author$project$Pages$Admin$Notifications$Company$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Employer Notifications')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						A2(
							$elm$core$List$cons,
							A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('These are emails that will be sent to any employers who are sponsoring employee memberships.')
									])),
							A2(
								$elm$core$List$map,
								$elm$html$Html$map($elm$core$Basics$identity),
								$author$project$Components$Admin$NotificationSetting$AdminTable$view(model.s1))))
					]))
			]),
		ac9: 'Admin | Notifications'
	};
};
var $author$project$Pages$Admin$Notifications$Company$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Notifications$Company$init, aiq: $author$project$Pages$Admin$Notifications$Company$load, k8: $author$project$Pages$Admin$Notifications$Company$save, alO: $author$project$Pages$Admin$Notifications$Company$subscriptions, adT: $author$project$Pages$Admin$Notifications$Company$update, amo: $author$project$Pages$Admin$Notifications$Company$view});
var $author$project$Pages$Admin$Notifications$Employee$AdminTableMsg = $elm$core$Basics$identity;
var $author$project$Api$Provider$NotificationSetting$Employee = 4;
var $author$project$Components$Admin$NotificationSetting$AdminTable$withMultiLanguageFeature = F2(
	function (multiLanguage, model) {
		return _Utils_update(
			model,
			{tc: multiLanguage});
	});
var $author$project$Pages$Admin$Notifications$Employee$init = F4(
	function (session, practice, _v0, _v1) {
		var apiClient = _v0.Gv;
		var multilanguageEnabled = A2(
			$author$project$Api$Practice$featureEnabled,
			10,
			$author$project$Api$Practice$Provider(practice));
		var _v2 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Components$Admin$NotificationSetting$AdminTable$withMultiLanguageFeature(multilanguageEnabled),
			A4($author$project$Components$Admin$NotificationSetting$AdminTable$init, apiClient, session, $author$project$Api$Provider$Notification$PracticeContext, 4));
		var adminTable = _v2.a;
		var adminTableCmd = _v2.b;
		return _Utils_Tuple2(
			{Gv: apiClient, s1: adminTable},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, adminTableCmd));
	});
var $author$project$Pages$Admin$Notifications$Employee$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Notifications$Employee$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Notifications$Employee$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Admin$NotificationSetting$AdminTable$subscriptions(model.s1));
};
var $author$project$Pages$Admin$Notifications$Employee$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Admin$NotificationSetting$AdminTable$update, model.Gv, subMsg, model.s1);
		var adminTable = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{s1: adminTable}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Pages$Admin$Notifications$Employee$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Employee Notifications')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						A2(
							$elm$core$List$cons,
							A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('These are emails that will be sent to any patients who are being sponsored by their employers. '),
										$elm$html$Html$text('They will also receive any patient emails that don\'t relate to payment of their memberships.')
									])),
							A2(
								$elm$core$List$map,
								$elm$html$Html$map($elm$core$Basics$identity),
								$author$project$Components$Admin$NotificationSetting$AdminTable$view(model.s1))))
					]))
			]),
		ac9: 'Admin | Notifications'
	};
};
var $author$project$Pages$Admin$Notifications$Employee$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Notifications$Employee$init, aiq: $author$project$Pages$Admin$Notifications$Employee$load, k8: $author$project$Pages$Admin$Notifications$Employee$save, alO: $author$project$Pages$Admin$Notifications$Employee$subscriptions, adT: $author$project$Pages$Admin$Notifications$Employee$update, amo: $author$project$Pages$Admin$Notifications$Employee$view});
var $author$project$Pages$Admin$Notifications$Membership$AdminTableMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Practice$One$sendZeroRevenueMembershipNotification = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.aaU;
	});
var $author$project$Pages$Admin$Notifications$Membership$init = F4(
	function (session, practice, _v0, _v1) {
		var apiClient = _v0.Gv;
		var multilanguageEnabled = A2(
			$author$project$Api$Practice$featureEnabled,
			10,
			$author$project$Api$Practice$Provider(practice));
		var _v2 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Components$Admin$NotificationSetting$AdminTable$withMultiLanguageFeature(multilanguageEnabled),
			A4($author$project$Components$Admin$NotificationSetting$AdminTable$init, apiClient, session, $author$project$Api$Provider$Notification$PracticeContext, 1));
		var adminTable = _v2.a;
		var adminTableCmd = _v2.b;
		return _Utils_Tuple2(
			{
				md: adminTable,
				Gv: apiClient,
				ZV: $author$project$Api$Data$NotAsked,
				aaU: $author$project$Api$Provider$Practice$One$sendZeroRevenueMembershipNotification(practice)
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Notifications$Membership$AdminTableMsg, adminTableCmd));
	});
var $author$project$Pages$Admin$Notifications$Membership$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Notifications$Membership$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Notifications$Membership$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$Admin$Notifications$Membership$AdminTableMsg,
		$author$project$Components$Admin$NotificationSetting$AdminTable$subscriptions(model.md));
};
var $author$project$Pages$Admin$Notifications$Membership$GotPractice = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$Practice$updateSendZeroRevenueMembershipNotification = F3(
	function (apiClient, bool, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practice',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'send_zero_revenue_membership_notification',
								$elm$json$Json$Encode$bool(bool))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Practice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$practicePath)));
	});
var $author$project$Pages$Admin$Notifications$Membership$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A3($author$project$Components$Admin$NotificationSetting$AdminTable$update, model.Gv, subMsg, model.md);
				var adminTable = _v1.a;
				var subCmd = _v1.b;
				var subOutMsg = _v1.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{md: adminTable}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Notifications$Membership$AdminTableMsg, subCmd),
					subOutMsg);
			case 1:
				var bool = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ZV: $author$project$Api$Data$Loading}),
					A3($author$project$Api$Provider$Practice$updateSendZeroRevenueMembershipNotification, model.Gv, !bool, $author$project$Pages$Admin$Notifications$Membership$GotPractice),
					_List_Nil);
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var practice = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ZV: response,
								aaU: $author$project$Api$Provider$Practice$One$sendZeroRevenueMembershipNotification(practice)
							}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your membership notifications have been updated'),
								$author$project$OutMsg$PracticeUpdated(response)
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ZV: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Admin$Notifications$Membership$SendZeroRevenueMembershipNotificationChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$Checkbox$Loading = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Form$Checkbox$loading = $author$project$Ui$Form$Checkbox$Loading;
var $author$project$Pages$Admin$Notifications$Membership$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Membership Notifications')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						A2(
							$elm$core$List$cons,
							A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('These are emails that will be sent to your patients automatically. Please remember, we do not send emails to patients without an ePHI waiver. '),
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Admin__HipaaAuthorizations,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('See who hasn\'t signed an ePHI waiver here.')
											]))
									])),
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$Ui$Form$Checkbox$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Checkbox$value(!model.aaU),
											$author$project$Ui$Form$Checkbox$onCheck($author$project$Pages$Admin$Notifications$Membership$SendZeroRevenueMembershipNotificationChanged),
											$author$project$Ui$Form$Checkbox$loading(
											_Utils_eq(model.ZV, $author$project$Api$Data$Loading))
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Don\'t send membership payment notifications to $0 memberships')
												]))
										])),
								A2(
									$elm$core$List$map,
									$elm$html$Html$map($author$project$Pages$Admin$Notifications$Membership$AdminTableMsg),
									$author$project$Components$Admin$NotificationSetting$AdminTable$view(model.md)))))
					]))
			]),
		ac9: 'Admin | Notifications'
	};
};
var $author$project$Pages$Admin$Notifications$Membership$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Notifications$Membership$init, aiq: $author$project$Pages$Admin$Notifications$Membership$load, k8: $author$project$Pages$Admin$Notifications$Membership$save, alO: $author$project$Pages$Admin$Notifications$Membership$subscriptions, adT: $author$project$Pages$Admin$Notifications$Membership$update, amo: $author$project$Pages$Admin$Notifications$Membership$view});
var $author$project$Pages$Admin$Notifications$Patient$AdminTableMsg = $elm$core$Basics$identity;
var $author$project$Api$FeatureGate$CustomizeDunningSchedule = 10;
var $author$project$Api$Provider$NotificationSetting$Patient = 0;
var $author$project$Components$Admin$NotificationSetting$AdminTable$withCustomizeDunningFeature = F2(
	function (showCustomizeDunningFeature, model) {
		return _Utils_update(
			model,
			{EB: showCustomizeDunningFeature});
	});
var $author$project$Pages$Admin$Notifications$Patient$init = F4(
	function (session, practice, _v0, _v1) {
		var apiClient = _v0.Gv;
		var multiLanguageEnable = A2(
			$author$project$Api$Practice$featureEnabled,
			10,
			$author$project$Api$Practice$Provider(practice));
		var customDunningEnabled = A2(
			$author$project$Utils$FeatureGate$gateAvailable,
			10,
			$author$project$Api$Practice$Provider(practice));
		var _v2 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Components$Admin$NotificationSetting$AdminTable$withMultiLanguageFeature(multiLanguageEnable),
			A2(
				$elm$core$Tuple$mapFirst,
				$author$project$Components$Admin$NotificationSetting$AdminTable$withCustomizeDunningFeature(customDunningEnabled),
				A4($author$project$Components$Admin$NotificationSetting$AdminTable$init, apiClient, session, $author$project$Api$Provider$Notification$PracticeContext, 0)));
		var adminTable = _v2.a;
		var adminTableCmd = _v2.b;
		return _Utils_Tuple2(
			{Gv: apiClient, s1: adminTable},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, adminTableCmd));
	});
var $author$project$Pages$Admin$Notifications$Patient$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Notifications$Patient$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Notifications$Patient$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Admin$NotificationSetting$AdminTable$subscriptions(model.s1));
};
var $author$project$Pages$Admin$Notifications$Patient$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Admin$NotificationSetting$AdminTable$update, model.Gv, subMsg, model.s1);
		var adminTable = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{s1: adminTable}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Pages$Admin$Notifications$Patient$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Patient Notifications')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						A2(
							$elm$core$List$cons,
							A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('These are emails that will be sent to your patients automatically. '),
										$elm$html$Html$text('Please remember, we will not automatically send emails that contain personal information to patients without the ePHI waiver. '),
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Admin__HipaaAuthorizations,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('See who hasn\'t signed an ePHI waiver here.')
											]))
									])),
							A2(
								$elm$core$List$map,
								$elm$html$Html$map($elm$core$Basics$identity),
								$author$project$Components$Admin$NotificationSetting$AdminTable$view(model.s1))))
					]))
			]),
		ac9: 'Admin | Notifications'
	};
};
var $author$project$Pages$Admin$Notifications$Patient$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Notifications$Patient$init, aiq: $author$project$Pages$Admin$Notifications$Patient$load, k8: $author$project$Pages$Admin$Notifications$Patient$save, alO: $author$project$Pages$Admin$Notifications$Patient$subscriptions, adT: $author$project$Pages$Admin$Notifications$Patient$update, amo: $author$project$Pages$Admin$Notifications$Patient$view});
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$GotDunningSchedule = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$DunningSchedule$One$DunningSchedule = $elm$core$Basics$identity;
var $author$project$Api$Provider$DunningSchedule$Shared$DunningSchedule = $elm$core$Basics$identity;
var $author$project$Api$Provider$DunningSchedule$Shared$Record = function (ruleList) {
	return {aai: ruleList};
};
var $author$project$Api$Provider$DunningSchedule$ScheduleBreakDown$ScheduleBreakDown = F2(
	function (action, delayInDaysFromDunningStart) {
		return {Gg: action, ago: delayInDaysFromDunningStart};
	});
var $author$project$Api$Provider$DunningSchedule$ScheduleAction$AttemptInvoicePayment = 0;
var $author$project$Api$Provider$DunningSchedule$ScheduleAction$DunningFailed = 3;
var $author$project$Api$Provider$DunningSchedule$ScheduleAction$SendDunningNotification = 1;
var $author$project$Api$Provider$DunningSchedule$ScheduleAction$SendDunningNotificationFollowup = 2;
var $author$project$Api$Provider$DunningSchedule$ScheduleAction$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (stringAction) {
		switch (stringAction) {
			case 'AttemptInvoicePayment':
				return $elm$json$Json$Decode$succeed(0);
			case 'SendDunningNotification':
				return $elm$json$Json$Decode$succeed(1);
			case 'SendDunningNotificationFollowup':
				return $elm$json$Json$Decode$succeed(2);
			case 'DunningFailed':
				return $elm$json$Json$Decode$succeed(3);
			default:
				var unsupported = stringAction;
				return $elm$json$Json$Decode$fail('unsupported action type ' + unsupported);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$DunningSchedule$ScheduleBreakDown$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'delay_in_days_from_dunning_start',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'action',
		$author$project$Api$Provider$DunningSchedule$ScheduleAction$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$DunningSchedule$ScheduleBreakDown$ScheduleBreakDown)));
var $author$project$Api$Provider$DunningSchedule$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'schedule',
	$elm$json$Json$Decode$list($author$project$Api$Provider$DunningSchedule$ScheduleBreakDown$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$DunningSchedule$Shared$Record));
var $author$project$Api$Provider$DunningSchedule$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$DunningSchedule$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$DunningSchedule$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$DunningSchedule$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$DunningSchedule$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$DunningSchedule$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['dunning_schedules']),
					$author$project$Api$Data$providerPath)));
	});
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$fetchDunningSchedule = function (apiClient) {
	return A2($author$project$Api$Provider$DunningSchedule$retrieve, apiClient, $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$GotDunningSchedule);
};
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$init = F4(
	function (session, practice, _v0, _v1) {
		var apiClient = _v0.Gv;
		return _Utils_Tuple2(
			{Gv: apiClient, aG: _List_Nil, ad: _List_Nil, agX: _List_Nil, ZV: practice, fb: $author$project$Api$Data$Loading, aa4: session},
			$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$fetchDunningSchedule(apiClient));
	});
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$Failed = 0;
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$BothEmailsSameDay = {$: 1};
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$bothEmailsSameDayValidation = F2(
	function (chargeFailedList, chargeFailedFollowupToValidateList) {
		var chargeFailedDelaysInDays = A2(
			$elm$core$List$map,
			function ($) {
				return $.ago;
			},
			A2($elm$core$List$map, $elm$core$Tuple$first, chargeFailedList));
		var onSameDay = function (item) {
			return A2($elm$core$List$member, item.ago, chargeFailedDelaysInDays);
		};
		return A2(
			$elm$core$List$map,
			function (_v0) {
				var item = _v0.a;
				var errors = _v0.b;
				return _Utils_Tuple2(
					item,
					_Utils_ap(
						errors,
						onSameDay(item) ? _List_fromArray(
							[$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$BothEmailsSameDay]) : _List_Nil));
			},
			chargeFailedFollowupToValidateList);
	});
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$ScheduleCreated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$DunningSchedule$scheduleActionToStringEncoder = function (action) {
	return $elm$json$Json$Encode$string(
		function () {
			switch (action) {
				case 0:
					return 'AttemptInvoicePayment';
				case 1:
					return 'SendDunningNotification';
				case 2:
					return 'SendDunningNotificationFollowup';
				default:
					return 'DunningFailed';
			}
		}());
};
var $author$project$Api$Provider$DunningSchedule$create = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'dunning_schedule',
					A2(
						$elm$json$Json$Encode$list,
						function (_v0) {
							var action = _v0.Gg;
							var delayInDaysFromDunningStart = _v0.ago;
							return $elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'action',
										$author$project$Api$Provider$DunningSchedule$scheduleActionToStringEncoder(action)),
										_Utils_Tuple2(
										'delay_in_days_from_dunning_start',
										$elm$json$Json$Encode$int(delayInDaysFromDunningStart))
									]));
						},
						fields))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$DunningSchedule$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['dunning_schedules']),
						$author$project$Api$Data$providerPath))));
	});
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$filterScheduleByAction = F2(
	function (schedule, action) {
		return A2(
			$elm$core$List$map,
			function (item) {
				return _Utils_Tuple2(item, _List_Nil);
			},
			A2(
				$elm$core$List$filter,
				function (listItem) {
					return _Utils_eq(listItem.Gg, action);
				},
				schedule));
	});
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$sortingFunction = F2(
	function (a, b) {
		var _v0 = _Utils_Tuple2(a.Gg, b.Gg);
		if (_v0.a === 3) {
			var _v1 = _v0.a;
			return 2;
		} else {
			if (_v0.b === 3) {
				var _v2 = _v0.b;
				return 0;
			} else {
				return (_Utils_cmp(a.ago, b.ago) < 0) ? 0 : ((_Utils_cmp(a.ago, b.ago) > 0) ? 2 : ((!a.Gg) ? 0 : 2));
			}
		}
	});
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$createSchedule = F4(
	function (apiClient, currentSchedule, chargeFailedSchedule, chargeFailedFollowupSchedule) {
		var dunningFailedSchedule = A2($author$project$Pages$Admin$Notifications$Patient$DunningSchedule$filterScheduleByAction, currentSchedule, 3);
		var attemptPaymentSchedule = A2($author$project$Pages$Admin$Notifications$Patient$DunningSchedule$filterScheduleByAction, currentSchedule, 0);
		var unorderedSchedule = _Utils_ap(
			attemptPaymentSchedule,
			_Utils_ap(
				chargeFailedSchedule,
				_Utils_ap(chargeFailedFollowupSchedule, dunningFailedSchedule)));
		var newSchedule = A2(
			$elm$core$List$sortWith,
			$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$sortingFunction,
			A2($elm$core$List$map, $elm$core$Tuple$first, unorderedSchedule));
		return A3($author$project$Api$Provider$DunningSchedule$create, apiClient, newSchedule, $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$ScheduleCreated);
	});
var $author$project$Api$Provider$DunningSchedule$Shared$ruleList = function (_v0) {
	var record = _v0;
	return record.aai;
};
var $author$project$Api$Provider$DunningSchedule$One$ruleList = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$DunningSchedule$Shared$ruleList(shared);
};
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$SameEmailForSameDay = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$validateSameDayEmail = F2(
	function (validatingItem, list) {
		return function (errors) {
			return _Utils_Tuple2(validatingItem, errors);
		}(
			A2(
				$elm$core$List$map,
				function (_v1) {
					var index = _v1.a;
					return $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$SameEmailForSameDay(
						$elm$core$String$fromInt(index));
				},
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var item = _v0.b;
						return _Utils_eq(item.ago, validatingItem.ago);
					},
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (index, item) {
								return _Utils_Tuple2(index + 1, item);
							}),
						$elm$core$List$reverse(list)))));
	});
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$sameEmailForSameDayValidation = function (scheduleList) {
	var _v0 = $elm$core$List$reverse(scheduleList);
	if (!_v0.b) {
		return _List_Nil;
	} else {
		var last = _v0.a;
		var rest = _v0.b;
		var validatedLast = A2(
			$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$validateSameDayEmail,
			last.a,
			A2($elm$core$List$map, $elm$core$Tuple$first, rest));
		var unReversed = $elm$core$List$reverse(rest);
		return _Utils_ap(
			$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$sameEmailForSameDayValidation(unReversed),
			_List_fromArray(
				[validatedLast]));
	}
};
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var schedule = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aG: A2(
									$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$filterScheduleByAction,
									$author$project$Api$Provider$DunningSchedule$One$ruleList(schedule),
									2),
								ad: A2(
									$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$filterScheduleByAction,
									$author$project$Api$Provider$DunningSchedule$One$ruleList(schedule),
									1),
								fb: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{fb: response}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 1:
				var index = msg.a;
				var newDelayInDaysString = msg.b;
				var newRule = {
					Gg: 1,
					ago: A2(
						$elm$core$Maybe$withDefault,
						0,
						$elm$core$String$toInt(newDelayInDaysString))
				};
				var newSchedule = A3(
					$elm_community$list_extra$List$Extra$setAt,
					index,
					_Utils_Tuple2(newRule, _List_Nil),
					model.ad);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ad: newSchedule}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var index = msg.a;
				var newDelayInDaysString = msg.b;
				var newRule = {
					Gg: 2,
					ago: A2(
						$elm$core$Maybe$withDefault,
						0,
						$elm$core$String$toInt(newDelayInDaysString))
				};
				var newSchedule = A3(
					$elm_community$list_extra$List$Extra$setAt,
					index,
					_Utils_Tuple2(newRule, _List_Nil),
					model.aG);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aG: newSchedule}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 6:
				var validatedChargeFailedSchedule = $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$sameEmailForSameDayValidation(model.ad);
				var validatedChargeFailedFollowupScheedule = A2(
					$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$bothEmailsSameDayValidation,
					model.ad,
					$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$sameEmailForSameDayValidation(model.aG));
				var chargeFailedScheduleErrors = A2($elm$core$List$concatMap, $elm$core$Tuple$second, validatedChargeFailedSchedule);
				var chargeFailedFollowupScheduleErrors = A2($elm$core$List$concatMap, $elm$core$Tuple$second, validatedChargeFailedFollowupScheedule);
				var _v2 = function () {
					var _v3 = _Utils_Tuple2(chargeFailedScheduleErrors, chargeFailedFollowupScheduleErrors);
					if ((!_v3.a.b) && (!_v3.b.b)) {
						var currentSchedule = function () {
							var _v4 = model.fb;
							if (_v4.$ === 3) {
								var schedule = _v4.a;
								return $author$project$Api$Provider$DunningSchedule$One$ruleList(schedule);
							} else {
								return _List_Nil;
							}
						}();
						return _Utils_Tuple2(
							A4($author$project$Pages$Admin$Notifications$Patient$DunningSchedule$createSchedule, model.Gv, currentSchedule, validatedChargeFailedSchedule, validatedChargeFailedFollowupScheedule),
							_List_Nil);
					} else {
						return _Utils_Tuple2(
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 1, 'Unable to save the schedule. Please check the errors.')
								]));
					}
				}();
				var createCmd = _v2.a;
				var outMsgs = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aG: validatedChargeFailedFollowupScheedule, ad: validatedChargeFailedSchedule}),
					createCmd,
					outMsgs);
			case 3:
				var response = msg.a;
				switch (response.$) {
					case 3:
						var schedule = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aG: A2(
										$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$filterScheduleByAction,
										$author$project$Api$Provider$DunningSchedule$One$ruleList(schedule),
										2),
									ad: A2(
										$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$filterScheduleByAction,
										$author$project$Api$Provider$DunningSchedule$One$ruleList(schedule),
										1),
									fb: response
								}),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Schedule succesfully updated')
								]));
					case 2:
						var errors = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{fb: response}),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Api$Data$errorToString(errors))
								]));
					default:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{fb: response}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
				}
			case 4:
				var scheduleType = msg.a;
				if (!scheduleType) {
					var initialDelay = A2(
						$elm$core$Maybe$withDefault,
						0,
						A2(
							$elm$core$Maybe$map,
							$elm$core$Basics$add(1),
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.ago;
								},
								A2(
									$elm$core$Maybe$map,
									$elm$core$Tuple$first,
									$elm$core$List$head(
										$elm$core$List$reverse(model.ad))))));
					var chargeFailedSchedule = _Utils_ap(
						model.ad,
						_List_fromArray(
							[
								_Utils_Tuple2(
								{Gg: 1, ago: initialDelay},
								_List_Nil)
							]));
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ad: chargeFailedSchedule}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					var chargeFailedFollowupSchedule = _Utils_ap(
						model.aG,
						_List_fromArray(
							[
								_Utils_Tuple2(
								{Gg: 2, ago: 0},
								_List_Nil)
							]));
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{aG: chargeFailedFollowupSchedule}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			default:
				var index = msg.a;
				var scheduleType = msg.b;
				if (!scheduleType) {
					var chargeFailedSchedule = A2($elm_community$list_extra$List$Extra$removeAt, index, model.ad);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ad: chargeFailedSchedule}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					var chargeFailedFollowupSchedule = A2($elm_community$list_extra$List$Extra$removeAt, index, model.aG);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{aG: chargeFailedFollowupSchedule}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
		}
	});
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$ValidateAndCreateSchedule = {$: 6};
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$sortingFunctionOnlyByDelayInDays = F2(
	function (a, b) {
		return (_Utils_cmp(a.ago, b.ago) < 0) ? 0 : ((_Utils_cmp(a.ago, b.ago) > 0) ? 2 : 1);
	});
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$didScheduleChange = F3(
	function (original, chargeFailedSchedule, chargeFailedFollowupSchedule) {
		var orderedOriginalFollowup = A2(
			$elm$core$List$sortWith,
			$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$sortingFunctionOnlyByDelayInDays,
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2(
					$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$filterScheduleByAction,
					$author$project$Api$Provider$DunningSchedule$One$ruleList(original),
					2)));
		var orderedOriginalChargeFailed = A2(
			$elm$core$List$sortWith,
			$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$sortingFunctionOnlyByDelayInDays,
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2(
					$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$filterScheduleByAction,
					$author$project$Api$Provider$DunningSchedule$One$ruleList(original),
					1)));
		var orderedNewFollowup = A2($elm$core$List$sortWith, $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$sortingFunctionOnlyByDelayInDays, chargeFailedFollowupSchedule);
		var orderedNewChargeFailed = A2($elm$core$List$sortWith, $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$sortingFunctionOnlyByDelayInDays, chargeFailedSchedule);
		return (!_Utils_eq(orderedOriginalChargeFailed, orderedNewChargeFailed)) || (!_Utils_eq(orderedOriginalFollowup, orderedNewFollowup));
	});
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$viewBreadcrumbs = A2(
	$elm$html$Html$map,
	$elm$core$Basics$never,
	A2(
		$author$project$Ui$Breadcrumb$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Breadcrumb$item,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Admin__Notifications__Patient,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Patient Notifications')
							]))
					])),
				A2(
				$author$project$Ui$Breadcrumb$item,
				_List_fromArray(
					[
						$author$project$Ui$Breadcrumb$active(true)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Schedule \"Charge Failed\" emails and follow-ups')
					]))
			])));
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$AddEmailToScheduleButtonClicked = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$Followup = 1;
var $author$project$Api$Provider$DunningSchedule$One$delayInDaysFromDunningStart = function (rule) {
	return rule.ago;
};
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$UpdateChargeFailedFollowupSchedule = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$UpdateChargeFailedSchedule = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$errorText = function (error) {
	if (!error.$) {
		var emailName = error.a;
		return 'You have already scheduled the Email #' + (emailName + ' to go out on this day.');
	} else {
		return 'You have scheduled both emails to go out on this day. Please adjust the schedule and update.';
	}
};
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$viewFirstNotification = F2(
	function (delayInDays, _v0) {
		var scheduleAction = _v0.a;
		var errors = _v0.b;
		var updateSchedule = (scheduleAction === 1) ? $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$UpdateChargeFailedSchedule(0) : $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$UpdateChargeFailedFollowupSchedule(0);
		return A2(
			$author$project$Ui$Grid$row,
			_List_fromArray(
				[$author$project$Ui$Grid$mt2]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$span(12)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									'Email #' + $elm$core$String$fromInt(1))
								])),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$group(
									A2(
										$author$project$Ui$Form$Input$withPreAddon,
										'# of days after a failed charge',
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$value(
												$elm$core$String$fromInt(delayInDays)),
												$author$project$Ui$Form$Input$onInput(updateSchedule),
												$author$project$Ui$Form$Input$number
											]))),
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									A2(
										$elm$core$List$map,
										function (error) {
											return A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$textDanger]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$errorText(error))
													]));
										},
										errors))
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$DeleteEmailFromScheduleButtonClicked = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$viewNotification = F3(
	function (index, delayInDays, _v0) {
		var scheduleAction = _v0.a;
		var errors = _v0.b;
		var _v1 = (scheduleAction === 1) ? _Utils_Tuple2(
			$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$UpdateChargeFailedSchedule(index + 1),
			0) : _Utils_Tuple2(
			$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$UpdateChargeFailedFollowupSchedule(index + 1),
			1);
		var updateSchedule = _v1.a;
		var emailType = _v1.b;
		return A2(
			$author$project$Ui$Grid$row,
			_List_fromArray(
				[$author$project$Ui$Grid$mt2]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$span(12)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									'Email #' + $elm$core$String$fromInt(index + 2))
								])),
							A2(
							$author$project$Ui$Grid$row,
							_List_fromArray(
								[$author$project$Ui$Grid$mt2]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(11)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$group(
													A2(
														$author$project$Ui$Form$Input$withPreAddon,
														'# of days after a failed charge',
														_List_fromArray(
															[
																$author$project$Ui$Form$Input$value(
																$elm$core$String$fromInt(delayInDays)),
																$author$project$Ui$Form$Input$onInput(updateSchedule),
																$author$project$Ui$Form$Input$number
															])))
												]))
										])),
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(1)
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{mm: 'Delete email from schedule'},
											_List_fromArray(
												[
													$author$project$Ui$Button$secondary,
													$author$project$Ui$Button$sm,
													$author$project$Ui$Button$icon($author$project$Ui$Icon$delete),
													$author$project$Ui$Button$onClick(
													A2($author$project$Pages$Admin$Notifications$Patient$DunningSchedule$DeleteEmailFromScheduleButtonClicked, index + 1, emailType))
												]),
											_List_Nil)
										]))
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							A2(
								$elm$core$List$map,
								function (error) {
									return A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$textDanger]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$errorText(error))
											]));
								},
								errors))
						]))
				]));
	});
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$viewNotifications = F2(
	function (notifications, notificationType) {
		var _v0 = (notificationType === 1) ? _Utils_Tuple3('1 - Charge Failed', 'Sent to patients if they have a failed charge.', 0) : _Utils_Tuple3('2 - Charge Failed (Follow-up)', 'Sent to patients if they have a failed charge and we have already sent them an email, but received no response. This email is usually sent as a final reminder prior to membership termination.', 1);
		var headerText = _v0.a;
		var helpText = _v0.b;
		var scheduleType = _v0.c;
		var _v1 = function () {
			if (!notifications.b) {
				return _Utils_Tuple2($elm$core$Maybe$Nothing, _List_Nil);
			} else {
				var first_ = notifications.a;
				var rest_ = notifications.b;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(first_),
					rest_);
			}
		}();
		var maybeFirst = _v1.a;
		var rest = _v1.b;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$HorizontalRule$view(_List_Nil),
					A2(
					$author$project$Ui$Grid$row,
					_List_fromArray(
						[$author$project$Ui$Grid$mb4]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(12)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$mb2]),
									_List_fromArray(
										[
											$author$project$Ui$Typography$heading(
											_List_fromArray(
												[
													$elm$html$Html$text(headerText)
												]))
										])),
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$helpText]),
									helpText)
								]))
						])),
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(2)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$hintLabel]),
									'Schedule')
								])),
							function () {
							if (!maybeFirst.$) {
								var _v4 = maybeFirst.a;
								var first = _v4.a;
								var errors = _v4.b;
								return A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(10)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$viewFirstNotification,
											$author$project$Api$Provider$DunningSchedule$One$delayInDaysFromDunningStart(first),
											_Utils_Tuple2(first.Gg, errors))
										]));
							} else {
								return A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(10)
										]),
									_List_Nil);
							}
						}(),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(2)
								]),
							_List_Nil),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(10)
								]),
							A2(
								$elm$core$List$indexedMap,
								F2(
									function (index, _v5) {
										var item = _v5.a;
										var errors = _v5.b;
										return A3(
											$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$viewNotification,
											index,
											$author$project$Api$Provider$DunningSchedule$One$delayInDaysFromDunningStart(item),
											_Utils_Tuple2(item.Gg, errors));
									}),
								rest))
						])),
					A2(
					$author$project$Ui$Grid$row,
					_List_fromArray(
						[$author$project$Ui$Grid$rowItemsCenter]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanMd(2)
								]),
							_List_Nil),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanMd(2)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Add email to schedule'},
									_List_fromArray(
										[
											$author$project$Ui$Button$secondary,
											$author$project$Ui$Button$icon($author$project$Ui$Icon$add),
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$AddEmailToScheduleButtonClicked(scheduleType))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Add Email to Schedule')
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$createTimelineEvent = function (_v0) {
	var eventDate = _v0.a;
	var eventDay = _v0.b;
	var event = _v0.c;
	return {
		G1: $elm$html$Html$text(event),
		PB: eventDate,
		af6: $elm$core$Maybe$Just(
			$elm$core$String$fromInt(eventDay) + ' days after a failed charge')
	};
};
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$createTimelineEventAttributes = function (scheduleBreakdown) {
	var eventDescription = function () {
		var _v0 = scheduleBreakdown.Gg;
		switch (_v0) {
			case 1:
				return 'Send \"Charge Failed\"';
			case 2:
				return 'Send \"Charge Failed (Follow-up)\"';
			default:
				return 'Unknown';
		}
	}();
	var eventDate = $justinmimbs$date$Date$fromRataDie(scheduleBreakdown.ago);
	return _Utils_Tuple3(eventDate, scheduleBreakdown.ago, eventDescription);
};
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$viewTimeline = F2(
	function (chargeFailedSchedule, chargeFailedFollowupSchedule) {
		var chargeFailedFollowupEvents = A2(
			$elm$core$List$map,
			$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$createTimelineEvent,
			A2($elm$core$List$map, $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$createTimelineEventAttributes, chargeFailedFollowupSchedule));
		var chargeFailedEvents = A2(
			$elm$core$List$map,
			$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$createTimelineEvent,
			A2($elm$core$List$map, $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$createTimelineEventAttributes, chargeFailedSchedule));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mt-6 -mb-8')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Timeline$view,
					_List_fromArray(
						[$author$project$Ui$Timeline$lg]),
					_Utils_ap(chargeFailedEvents, chargeFailedFollowupEvents))
				]));
	});
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$viewBody = function (model) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$viewBreadcrumbs,
							$author$project$Ui$Panel$title(
							_List_fromArray(
								[
									$elm$html$Html$text('Schedule \"Charge Failed\" emails and follow-ups')
								])),
							A2(
							$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$viewTimeline,
							A2($elm$core$List$map, $elm$core$Tuple$first, model.ad),
							A2($elm$core$List$map, $elm$core$Tuple$first, model.aG))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Pages$Admin$Notifications$Patient$DunningSchedule$viewNotifications, model.ad, 1),
							A2($author$project$Pages$Admin$Notifications$Patient$DunningSchedule$viewNotifications, model.aG, 2)
						])),
					A2(
					$author$project$Ui$Panel$footer,
					_List_fromArray(
						[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$itemsCenter]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Admin__Notifications__Patient,
							_List_fromArray(
								[$author$project$Ui$Link$buttonDefault]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							function () {
							var _v0 = model.fb;
							if (_v0.$ === 3) {
								var schedule = _v0.a;
								var scheduleChanged = A3(
									$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$didScheduleChange,
									schedule,
									A2($elm$core$List$map, $elm$core$Tuple$first, model.ad),
									A2($elm$core$List$map, $elm$core$Tuple$first, model.aG));
								return A3(
									$author$project$Ui$Button$view,
									{mm: 'Update schedule'},
									_List_fromArray(
										[
											$author$project$Ui$Button$primary,
											$author$project$Ui$Button$onClick($author$project$Pages$Admin$Notifications$Patient$DunningSchedule$ValidateAndCreateSchedule),
											$author$project$Ui$Button$disabled(!scheduleChanged)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Update Schedule')
										]));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						]))
				]))
		]);
};
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$view = function (model) {
	return {
		fO: $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$viewBody(model),
		ac9: 'Admin | Notifications'
	};
};
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$init, aiq: $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$load, k8: $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$save, alO: $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$subscriptions, adT: $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$update, amo: $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$view});
var $author$project$Pages$Admin$Notifications$Practice$AdminTableMsg = $elm$core$Basics$identity;
var $author$project$Api$Provider$NotificationSetting$Practice = 2;
var $author$project$Pages$Admin$Notifications$Practice$init = F4(
	function (session, _v0, _v1, _v2) {
		var apiClient = _v1.Gv;
		var _v3 = A4($author$project$Components$Admin$NotificationSetting$AdminTable$init, apiClient, session, $author$project$Api$Provider$Notification$PracticeContext, 2);
		var adminTable = _v3.a;
		var adminTableCmd = _v3.b;
		return _Utils_Tuple2(
			{Gv: apiClient, s1: adminTable},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, adminTableCmd));
	});
var $author$project$Pages$Admin$Notifications$Practice$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Notifications$Practice$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Notifications$Practice$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Admin$NotificationSetting$AdminTable$subscriptions(model.s1));
};
var $author$project$Pages$Admin$Notifications$Practice$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Admin$NotificationSetting$AdminTable$update, model.Gv, subMsg, model.s1);
		var adminTable = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{s1: adminTable}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Pages$Admin$Notifications$Practice$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Practice Notifications')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						A2(
							$elm$core$List$cons,
							A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('These are emails that will be sent to members of your team.')
									])),
							A2(
								$elm$core$List$cons,
								A2(
									$elm$html$Html$ul,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$li,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Admins, Managers, Staff and Staff Limited users are expected to receive all of the following email notifications, if enabled.')
												])),
											A2(
											$elm$html$Html$li,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Reports Only users will not receive any of the following email notifications.')
												])),
											A2(
											$elm$html$Html$li,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Read Only users will only receive the new patient email notifications.')
												]))
										])),
								A2(
									$elm$core$List$cons,
									A2(
										$author$project$Ui$Typography$p,
										_List_fromArray(
											[$author$project$Ui$Typography$italic]),
										_List_fromArray(
											[
												$elm$html$Html$text('Note: If a role is restricted by location groups, the user will only receive the emails with content relevant to their assigned location groups. If the role is not restricted by location groups, they are expected to receive all email notifications.')
											])),
									A2(
										$elm$core$List$map,
										$elm$html$Html$map($elm$core$Basics$identity),
										$author$project$Components$Admin$NotificationSetting$AdminTable$view(model.s1))))))
					]))
			]),
		ac9: 'Admin | Notifications'
	};
};
var $author$project$Pages$Admin$Notifications$Practice$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Notifications$Practice$init, aiq: $author$project$Pages$Admin$Notifications$Practice$load, k8: $author$project$Pages$Admin$Notifications$Practice$save, alO: $author$project$Pages$Admin$Notifications$Practice$subscriptions, adT: $author$project$Pages$Admin$Notifications$Practice$update, amo: $author$project$Pages$Admin$Notifications$Practice$view});
var $author$project$Api$Provider$Practice$Shared$email = function (_v0) {
	var record = _v0;
	return record.Rj;
};
var $author$project$Api$Provider$Practice$One$email = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$email(shared);
};
var $author$project$Api$Provider$Practice$One$emailReplyAddress = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.agK;
	});
var $author$project$Api$Provider$Practice$One$footer = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.ahr;
	});
var $author$project$Api$Provider$Practice$One$greetsFormally = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.ahA;
	});
var $author$project$Api$Provider$Practice$One$salutation = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.ak9;
	});
var $author$project$Pages$Admin$Notifications$Settings$initPracticeFormFields = function (practice) {
	return {
		agK: $author$project$Api$Provider$Practice$One$emailReplyAddress(practice),
		ahr: $author$project$Api$Provider$Practice$One$footer(practice),
		ahA: $author$project$Api$Provider$Practice$One$greetsFormally(practice),
		ak9: $author$project$Api$Provider$Practice$One$salutation(practice)
	};
};
var $author$project$Components$TranslationsInput$Practice = {$: 2};
var $author$project$Components$TranslationsInput$practice = $author$project$Components$TranslationsInput$Practice;
var $author$project$Pages$Admin$Notifications$Settings$init = F4(
	function (_v0, practice, _v1, _v2) {
		var apiClient = _v1.Gv;
		return _Utils_Tuple2(
			{
				Gv: apiClient,
				gk: false,
				SD: $author$project$Utils$Form$init(
					$author$project$Pages$Admin$Notifications$Settings$initPracticeFormFields(practice)),
				IG: A2(
					$author$project$Api$Practice$featureEnabled,
					10,
					$author$project$Api$Practice$Provider(practice)),
				ZV: $author$project$Api$Data$NotAsked,
				tU: $author$project$Api$Provider$Practice$One$email(practice),
				qF: $author$project$Components$TranslationsInput$init($author$project$Components$TranslationsInput$practice)
			},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Notifications$Settings$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Notifications$Settings$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Notifications$Settings$TranslationsInputMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$Notifications$Settings$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$Admin$Notifications$Settings$TranslationsInputMsg,
		$author$project$Components$TranslationsInput$subscriptions(model.qF));
};
var $author$project$Pages$Admin$Notifications$Settings$practiceFormFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						agK: $elm$core$String$isEmpty(string) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(string)
					});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{ak9: string});
			case 2:
				var bool = field.a;
				return _Utils_update(
					fields,
					{ahA: bool});
			default:
				var string = field.a;
				return _Utils_update(
					fields,
					{ahr: string});
		}
	});
var $author$project$Pages$Admin$Notifications$Settings$EmailValidation = 0;
var $author$project$Pages$Admin$Notifications$Settings$practiceFormFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A3(
			$author$project$Utils$Validate$ifInvalidEmail,
			{aeT: true},
			function ($) {
				return $.agK;
			},
			_Utils_Tuple2(0, 'Please enter a valid email.'))
		]));
var $author$project$Pages$Admin$Notifications$Settings$GotPractice = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Practice$resetPracticeEmailReplyAddress = F2(
	function (apiClient, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practice',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2('email_reply_address', $elm$json$Json$Encode$null)
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Practice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$practicePath)));
	});
var $author$project$Pages$Admin$Notifications$Settings$resetPracticeEmailReplyAddress = function (apiClient) {
	return A2($author$project$Api$Provider$Practice$resetPracticeEmailReplyAddress, apiClient, $author$project$Pages$Admin$Notifications$Settings$GotPractice);
};
var $author$project$Api$Provider$Practice$updateNotificationsSettings = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practice',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'email_reply_address',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.agK)),
								_Utils_Tuple2(
								'salutation',
								$elm$json$Json$Encode$string(fields.ak9)),
								_Utils_Tuple2(
								'greets_formally',
								$elm$json$Json$Encode$bool(fields.ahA)),
								_Utils_Tuple2(
								'footer',
								$elm$json$Json$Encode$string(fields.ahr))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Practice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$practicePath)));
	});
var $author$project$Pages$Admin$Notifications$Settings$updatePractice = F2(
	function (apiClient, formFields) {
		return A3(
			$author$project$Api$Provider$Practice$updateNotificationsSettings,
			apiClient,
			$rtfeldman$elm_validate$Validate$fromValid(formFields),
			$author$project$Pages$Admin$Notifications$Settings$GotPractice);
	});
var $author$project$Pages$Admin$Notifications$Settings$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{gk: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ZV: $author$project$Api$Data$Loading}),
					$author$project$Pages$Admin$Notifications$Settings$resetPracticeEmailReplyAddress(model.Gv),
					_List_Nil);
			case 2:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$Notifications$Settings$practiceFormFieldsUpdate, field, model.SD);
				var validatedForm = function () {
					var _v1 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$Notifications$Settings$practiceFormFieldsValidator, newForm);
					if (!_v1.$) {
						var _v2 = _v1.a;
						var form = _v2.a;
						return form;
					} else {
						var form = _v1.a;
						return form;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: validatedForm}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var _v3 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$Notifications$Settings$practiceFormFieldsValidator, model.SD);
				if (!_v3.$) {
					var _v4 = _v3.a;
					var newForm = _v4.a;
					var validFormFields = _v4.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{SD: newForm, ZV: $author$project$Api$Data$Loading}),
						A2($author$project$Pages$Admin$Notifications$Settings$updatePractice, model.Gv, validFormFields),
						_List_Nil);
				} else {
					var newForm = _v3.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{SD: newForm}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					var practice = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								gk: false,
								SD: $author$project$Utils$Form$init(
									$author$project$Pages$Admin$Notifications$Settings$initPracticeFormFields(practice)),
								ZV: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your practice\'s notification settings have been updated'),
								$author$project$OutMsg$PracticeUpdated(response)
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var subMsg = msg.a;
				var _v6 = A3($author$project$Components$TranslationsInput$update, model.Gv, subMsg, model.qF);
				var translationsInput = _v6.a;
				var translationsInputCmd = _v6.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qF: translationsInput}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Notifications$Settings$TranslationsInputMsg, translationsInputCmd),
					_List_Nil);
		}
	});
var $author$project$Pages$Admin$Notifications$Settings$EditEmailReplyAddress = {$: 0};
var $author$project$Pages$Admin$Notifications$Settings$EmailReplyAddress = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$Notifications$Settings$Footer = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Admin$Notifications$Settings$GreetsFormally = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$Notifications$Settings$PracticeFormFieldUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$Notifications$Settings$ResetEmailReplyAddress = {$: 1};
var $author$project$Pages$Admin$Notifications$Settings$Salutation = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$Notifications$Settings$UpdatePractice = {$: 3};
var $author$project$Pages$Admin$Notifications$Settings$canEditEmail = F2(
	function (emailReplyAddress, model) {
		var practiceEmailIsEmpty = $elm$core$String$isEmpty(
			A2($elm$core$Maybe$withDefault, '', model.tU));
		var emailReplyAddressIsEmpty = $elm$core$String$isEmpty(
			A2($elm$core$Maybe$withDefault, '', emailReplyAddress));
		var _v0 = _Utils_Tuple3(model.gk, emailReplyAddressIsEmpty, practiceEmailIsEmpty);
		if (_v0.a) {
			return false;
		} else {
			if (_v0.b && _v0.c) {
				return false;
			} else {
				return true;
			}
		}
	});
var $author$project$Pages$Admin$Notifications$Settings$greetsFormallyDescription = function (greetsFormally) {
	return $elm$html$Html$text(
		greetsFormally ? $elm$core$String$concat(
			_List_fromArray(
				['Recipient will be addressed using their title if it has been specified. ', 'If title has not been specified, but gender has been specified, they will be addressed using \"Mr.\" or \"Ms.\". ', 'If neither title or gender has been specified, they will be addressed using their first name.'])) : 'Recipient will be addressed by their first name.');
};
var $author$project$Pages$Admin$Notifications$Settings$hintDefaultEmail = 'hello@hint.com';
var $author$project$Components$TranslationsInput$ContentType = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$TranslationsInput$Text = 1;
var $author$project$Components$TranslationsInput$textarea = $author$project$Components$TranslationsInput$ContentType(1);
var $author$project$Pages$Admin$Notifications$Settings$viewPanel = function (model) {
	var _v0 = $author$project$Utils$Form$fields(model.SD);
	var emailReplyAddress = _v0.agK;
	var salutation = _v0.ak9;
	var greetsFormally = _v0.ahA;
	var footer = _v0.ahr;
	var email = function () {
		var _v6 = _Utils_Tuple3(model.gk, emailReplyAddress, model.tU);
		if (_v6.a) {
			return A2($elm$core$Maybe$withDefault, '', emailReplyAddress);
		} else {
			if (!_v6.b.$) {
				var emailReplyAddress_ = _v6.b.a;
				return emailReplyAddress_;
			} else {
				if (!_v6.c.$) {
					var practiceEmail = _v6.c.a;
					return practiceEmail;
				} else {
					var _v7 = _v6.b;
					var _v8 = _v6.c;
					return $author$project$Pages$Admin$Notifications$Settings$hintDefaultEmail;
				}
			}
		}
	}();
	return A2(
		$author$project$Ui$Form$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Notification Settings')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Typography$headingSm(
								_List_fromArray(
									[
										$elm$html$Html$text('Email Address')
									])),
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Reply-to Email Address'),
										$author$project$Ui$Form$Group$labelSpanSm(4),
										$author$project$Ui$Form$Group$offsetLabel,
										$author$project$Ui$Form$Group$inputSpanSm(7)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$group(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$view(
												_List_fromArray(
													[
														$author$project$Ui$Form$Input$placeholder('example@mail.com'),
														$author$project$Ui$Form$Input$value(email),
														$author$project$Ui$Form$Input$disabled(!model.gk),
														$author$project$Ui$Form$Input$onInput(
														A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Notifications$Settings$PracticeFormFieldUpdated, $author$project$Pages$Admin$Notifications$Settings$EmailReplyAddress)),
														$author$project$Ui$Form$Input$invalid(
														A2($author$project$Utils$Form$hasValidationErrors, 0, model.SD))
													])),
												$author$project$Ui$Form$Input$addon(
												_List_fromArray(
													[
														A2($author$project$Pages$Admin$Notifications$Settings$canEditEmail, emailReplyAddress, model) ? A3(
														$author$project$Ui$Button$view,
														{mm: 'Edit email replay address'},
														_List_fromArray(
															[
																$author$project$Ui$Button$link,
																$author$project$Ui$Button$sm,
																$author$project$Ui$Button$onClick($author$project$Pages$Admin$Notifications$Settings$EditEmailReplyAddress)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Edit')
															])) : $author$project$Utils$Html$empty
													]))
											])),
										$author$project$Utils$FormErrors$view(
										A2($author$project$Utils$Form$validationErrors, 0, model.SD)),
										function () {
										if (model.gk) {
											return $author$project$Utils$Html$empty;
										} else {
											var emailDescription = function () {
												var _v1 = _Utils_Tuple2(emailReplyAddress, model.tU);
												if (_v1.b.$ === 1) {
													if (_v1.a.$ === 1) {
														var _v2 = _v1.a;
														var _v3 = _v1.b;
														return _List_fromArray(
															[
																$elm$html$Html$text('You do not have a contact email set for your practice. '),
																$elm$html$Html$text('Once set, we will send emails from this address on your behalf. '),
																$elm$html$Html$text('You can set this email on the '),
																A3(
																$author$project$Ui$Link$route,
																$author$project$Spa$Generated$Route$Admin__Practice,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('Admin > General')
																	])),
																$elm$html$Html$text(' settings page.')
															]);
													} else {
														var _v5 = _v1.b;
														return _List_fromArray(
															[
																$elm$html$Html$text('We are sending emails from a custom email address.  You can edit this address above.'),
																A2($elm$html$Html$br, _List_Nil, _List_Nil),
																$elm$html$Html$text('You do not have a contact email set for your practice. Please set one on the '),
																A3(
																$author$project$Ui$Link$route,
																$author$project$Spa$Generated$Route$Admin__Practice,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('Admin > General')
																	])),
																$elm$html$Html$text(' settings page. '),
																$elm$html$Html$text('Once set you can return here to configure emails to be sent from your practice’s contact email.')
															]);
													}
												} else {
													if (_v1.a.$ === 1) {
														var _v4 = _v1.a;
														return _List_fromArray(
															[
																$elm$html$Html$text('We are sending emails from your practice\'s email address on your behalf. '),
																$elm$html$Html$text('You can change this email on the '),
																A3(
																$author$project$Ui$Link$route,
																$author$project$Spa$Generated$Route$Admin__Practice,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('Admin > General')
																	])),
																$elm$html$Html$text(' settings page.'),
																A2($elm$html$Html$br, _List_Nil, _List_Nil),
																$elm$html$Html$text('If you want to use a different email address to send emails click the edit button above.')
															]);
													} else {
														var practiceEmail_ = _v1.b.a;
														return _List_fromArray(
															[
																$elm$html$Html$text('We are sending emails from an email that is different than your practice’s contact email address. '),
																$elm$html$Html$text('You can edit this email above, or reset it to use your practice’s contact email. '),
																A3(
																$author$project$Ui$Button$view,
																{mm: 'Reset to ' + practiceEmail_},
																_List_fromArray(
																	[
																		$author$project$Ui$Button$link,
																		$author$project$Ui$Button$onClick($author$project$Pages$Admin$Notifications$Settings$ResetEmailReplyAddress)
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Reset to ' + practiceEmail_)
																	]))
															]);
													}
												}
											}();
											return A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
												emailDescription);
										}
									}()
									])),
								$author$project$Ui$Typography$headingSm(
								_List_fromArray(
									[
										$elm$html$Html$text('Greeting')
									])),
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Salutation'),
										$author$project$Ui$Form$Group$labelSpanSm(4),
										$author$project$Ui$Form$Group$offsetLabel,
										$author$project$Ui$Form$Group$inputSpanSm(7)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$value(salutation),
												$author$project$Ui$Form$Input$onInput(
												A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Notifications$Settings$PracticeFormFieldUpdated, $author$project$Pages$Admin$Notifications$Settings$Salutation))
											]))
									])),
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Use recipient\'s title and last name?'),
										$author$project$Ui$Form$Group$labelSpanSm(4),
										$author$project$Ui$Form$Group$offsetLabel,
										$author$project$Ui$Form$Group$inputSpanSm(7)
									]),
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$view(
										_List_fromArray(
											[
												$author$project$Ui$ToggleSwitch$on(greetsFormally),
												$author$project$Ui$ToggleSwitch$onChange(
												A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Notifications$Settings$PracticeFormFieldUpdated, $author$project$Pages$Admin$Notifications$Settings$GreetsFormally))
											])),
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
										_List_fromArray(
											[
												$author$project$Pages$Admin$Notifications$Settings$greetsFormallyDescription(greetsFormally)
											]))
									])),
								$author$project$Ui$Typography$headingSm(
								_List_fromArray(
									[
										$elm$html$Html$text('Closing')
									])),
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Content'),
										$author$project$Ui$Form$Group$labelSpanSm(4),
										$author$project$Ui$Form$Group$offsetLabel,
										$author$project$Ui$Form$Group$inputSpanSm(7)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$Textarea$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Textarea$rows(5),
												$author$project$Ui$Form$Textarea$value(footer),
												$author$project$Ui$Form$Textarea$onInput(
												A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Notifications$Settings$PracticeFormFieldUpdated, $author$project$Pages$Admin$Notifications$Settings$Footer))
											])),
										model.IG ? A2(
										$elm$html$Html$map,
										$author$project$Pages$Admin$Notifications$Settings$TranslationsInputMsg,
										A3(
											$author$project$Components$TranslationsInput$view,
											'footer',
											_List_fromArray(
												[
													$author$project$Components$TranslationsInput$default(footer),
													$author$project$Components$TranslationsInput$textarea
												]),
											model.qF)) : $elm$html$Html$text('')
									]))
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_fromArray(
							[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$gap2]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Admin__Practice,
								_List_fromArray(
									[$author$project$Ui$Link$buttonSecondary]),
								_List_fromArray(
									[
										$elm$html$Html$text('Cancel')
									])),
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Save settings'},
								_List_fromArray(
									[
										$author$project$Ui$Button$primary,
										$author$project$Ui$Button$loading(
										_Utils_eq(model.ZV, $author$project$Api$Data$Loading)),
										$author$project$Ui$Button$onClick($author$project$Pages$Admin$Notifications$Settings$UpdatePractice)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Save')
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Admin$Notifications$Settings$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				$author$project$Pages$Admin$Notifications$Settings$viewPanel(model)
			]),
		ac9: 'Admin | Notifications'
	};
};
var $author$project$Pages$Admin$Notifications$Settings$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Notifications$Settings$init, aiq: $author$project$Pages$Admin$Notifications$Settings$load, k8: $author$project$Pages$Admin$Notifications$Settings$save, alO: $author$project$Pages$Admin$Notifications$Settings$subscriptions, adT: $author$project$Pages$Admin$Notifications$Settings$update, amo: $author$project$Pages$Admin$Notifications$Settings$view});
var $author$project$Pages$Admin$Patients$PassthroughFeesCutoffDateInputMsg = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Api$Provider$Practice$One$chargePatientsCreditCardFees = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.afE;
	});
var $author$project$Api$Provider$Practice$One$collectLocationOnSignup = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.afO;
	});
var $author$project$Api$Provider$Practice$One$collectPractitionerOnSignup = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.N_;
	});
var $author$project$Api$Provider$Practice$One$collectSSNOnSignup = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.N$;
	});
var $author$project$Api$Provider$Practice$One$defaultPatientsPreferredLanguage = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.P5;
	});
var $author$project$Api$Provider$Practice$One$defaultToActivePatientsFilter = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.agn;
	});
var $author$project$Api$Provider$Practice$One$engagementThreshold = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.agV;
	});
var $author$project$Api$Provider$Practice$One$passthroughFeesCutoffDate = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.ajP;
	});
var $author$project$Api$Provider$Practice$One$passthroughFeesCutoffEnabled = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.ajQ;
	});
var $author$project$Api$Provider$Practice$One$requiresDefaultLocationForCompanies = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.akU;
	});
var $author$project$Api$Provider$Practice$One$requiresLocation = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.$G;
	});
var $author$project$Api$Provider$Practice$One$requiresPatientEmail = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.$I;
	});
var $author$project$Api$Provider$Practice$One$requiresPatientMobile = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.$J;
	});
var $author$project$Api$Provider$Practice$One$requiresPractitioner = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.$M;
	});
var $author$project$Api$Provider$Practice$One$requiresSSN = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.$N;
	});
var $author$project$Api$Provider$Practice$One$ssnEnabled = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.ab6;
	});
var $author$project$Pages$Admin$Patients$mapFormFields = function (practice) {
	return {
		afE: $author$project$Api$Provider$Practice$One$chargePatientsCreditCardFees(practice),
		afO: $author$project$Api$Provider$Practice$One$collectLocationOnSignup(practice),
		N_: $author$project$Api$Provider$Practice$One$collectPractitionerOnSignup(practice),
		N$: $author$project$Api$Provider$Practice$One$collectSSNOnSignup(practice),
		agm: $author$project$Api$Provider$Practice$One$defaultPatientsPreferredLanguage(practice),
		agn: $author$project$Api$Provider$Practice$One$defaultToActivePatientsFilter(practice),
		agV: $elm$core$String$fromInt(
			$author$project$Api$Provider$Practice$One$engagementThreshold(practice)),
		ajP: $author$project$Api$Provider$Practice$One$passthroughFeesCutoffDate(practice),
		ajQ: $author$project$Api$Provider$Practice$One$passthroughFeesCutoffEnabled(practice),
		akQ: $author$project$Api$Provider$Practice$One$requireGroupForLocations(practice),
		akU: $author$project$Api$Provider$Practice$One$requiresDefaultLocationForCompanies(practice),
		$G: $author$project$Api$Provider$Practice$One$requiresLocation(practice),
		$I: $author$project$Api$Provider$Practice$One$requiresPatientEmail(practice),
		$J: $author$project$Api$Provider$Practice$One$requiresPatientMobile(practice),
		$M: $author$project$Api$Provider$Practice$One$requiresPractitioner(practice),
		$N: $author$project$Api$Provider$Practice$One$requiresSSN(practice),
		ab6: $author$project$Api$Provider$Practice$One$ssnEnabled(practice),
		adt: $author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice)
	};
};
var $author$project$Pages$Admin$Patients$init = F4(
	function (_v0, practice, _v1, _v2) {
		var apiClient = _v1.Gv;
		var _v3 = function () {
			var _v4 = $author$project$Api$Provider$Practice$One$passthroughFeesCutoffDate(practice);
			if (!_v4.$) {
				var date = _v4.a;
				return _Utils_Tuple2(
					$author$project$Components$DateInput$initFromDate(date),
					$elm$core$Platform$Cmd$none);
			} else {
				return $author$project$Components$DateInput$init;
			}
		}();
		var dateInputModel = _v3.a;
		var dateInputMsg = _v3.b;
		var model = {
			Gv: apiClient,
			nz: $jinjor$elm_debounce$Debounce$init,
			ahi: $author$project$Pages$Admin$Patients$mapFormFields(practice),
			tE: dateInputModel,
			ZV: practice
		};
		return _Utils_Tuple2(
			model,
			A2(
				$elm$core$Platform$Cmd$map,
				$author$project$Pages$Admin$Patients$PassthroughFeesCutoffDateInputMsg(dateInputModel),
				dateInputMsg));
	});
var $author$project$Pages$Admin$Patients$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Patients$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Patients$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$Patients$ChargePatientsCreditCardFees = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Admin$Patients$GotEnableResponse = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Admin$Patients$PassthroughFeesCutoffDate = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Admin$Patients$EngagementThresholdDebounced = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$Patients$debouncePriceCheck = function (cmd) {
	return A2(
		$elm$core$Task$perform,
		$author$project$Pages$Admin$Patients$EngagementThresholdDebounced,
		$elm$core$Task$succeed(cmd));
};
var $author$project$Pages$Admin$Patients$EngagementThresholdDebouncedMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$Patients$engagementThresholdDebounceConfig = {
	alK: $jinjor$elm_debounce$Debounce$later(300),
	ame: $author$project$Pages$Admin$Patients$EngagementThresholdDebouncedMsg
};
var $author$project$Pages$Admin$Patients$updateField = F2(
	function (field, fields) {
		switch (field.$) {
			case 1:
				var enabled = field.a;
				return _Utils_update(
					fields,
					{
						N$: enabled ? 2 : fields.N$,
						$N: enabled
					});
			case 2:
				var enabled = field.a;
				return _Utils_update(
					fields,
					{
						afO: enabled ? 2 : fields.afO,
						$G: enabled
					});
			case 5:
				var enabled = field.a;
				return _Utils_update(
					fields,
					{
						N_: enabled ? 2 : fields.N_,
						$M: enabled
					});
			case 6:
				var enabled = field.a;
				return _Utils_update(
					fields,
					{
						afO: enabled ? fields.afO : 0,
						$G: enabled && fields.$G,
						adt: enabled
					});
			case 0:
				var enabled = field.a;
				return _Utils_update(
					fields,
					{
						N$: enabled ? fields.N$ : 0,
						$N: enabled && fields.$N,
						ab6: enabled
					});
			case 7:
				var enabled = field.a;
				return _Utils_update(
					fields,
					{afE: enabled});
			case 3:
				var enabled = field.a;
				return _Utils_update(
					fields,
					{$I: enabled});
			case 4:
				var enabled = field.a;
				return _Utils_update(
					fields,
					{$J: enabled});
			case 8:
				var enabled = field.a;
				return _Utils_update(
					fields,
					{akU: enabled});
			case 9:
				var enabled = field.a;
				return _Utils_update(
					fields,
					{ajQ: enabled});
			case 10:
				var date = field.a;
				return _Utils_update(
					fields,
					{ajP: date});
			case 11:
				var enabled = field.a;
				return _Utils_update(
					fields,
					{akQ: enabled});
			case 12:
				var threshold = field.a;
				return _Utils_update(
					fields,
					{agV: threshold});
			case 13:
				var language = field.a;
				return _Utils_update(
					fields,
					{agm: language});
			default:
				var enabled = field.a;
				return _Utils_update(
					fields,
					{agn: enabled});
		}
	});
var $author$project$Api$CollectOnSignup$encoder = function (customType) {
	return $elm$json$Json$Encode$string(
		function () {
			switch (customType) {
				case 0:
					return 'no';
				case 1:
					return 'optional';
				case 2:
					return 'require';
				case 3:
					return 'default';
				default:
					return 'yes';
			}
		}());
};
var $author$project$Api$Provider$Practice$updateSettings = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practice',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'ssn_enabled',
								$elm$json$Json$Encode$bool(fields.ab6)),
								_Utils_Tuple2(
								'requires_ssn',
								$elm$json$Json$Encode$bool(fields.$N)),
								_Utils_Tuple2(
								'requires_patient_email',
								$elm$json$Json$Encode$bool(fields.$I)),
								_Utils_Tuple2(
								'requires_patient_mobile',
								$elm$json$Json$Encode$bool(fields.$J)),
								_Utils_Tuple2(
								'requires_practitioner',
								$elm$json$Json$Encode$bool(fields.$M)),
								_Utils_Tuple2(
								'requires_location',
								$elm$json$Json$Encode$bool(fields.$G)),
								_Utils_Tuple2(
								'require_default_location_for_companies',
								$elm$json$Json$Encode$bool(fields.akU)),
								_Utils_Tuple2(
								'require_group_for_locations',
								$elm$json$Json$Encode$bool(fields.akQ)),
								_Utils_Tuple2(
								'track_patients_by_location',
								$elm$json$Json$Encode$bool(fields.adt)),
								_Utils_Tuple2(
								'charge_patients_credit_card_fees',
								$elm$json$Json$Encode$bool(fields.afE)),
								_Utils_Tuple2(
								'passthrough_fees_cutoff_enabled',
								$elm$json$Json$Encode$bool(fields.ajQ)),
								_Utils_Tuple2(
								'passthrough_fees_cutoff_date',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.ajP)),
								_Utils_Tuple2(
								'engagement_threshold',
								$elm$json$Json$Encode$int(
									A2(
										$elm$core$Maybe$withDefault,
										0,
										$elm$core$String$toInt(fields.agV)))),
								_Utils_Tuple2(
								'collect_ssn_on_signup',
								$author$project$Api$CollectOnSignup$encoder(fields.N$)),
								_Utils_Tuple2(
								'collect_practitioner_on_signup',
								$author$project$Api$CollectOnSignup$encoder(fields.N_)),
								_Utils_Tuple2(
								'collect_location_on_signup',
								$author$project$Api$CollectOnSignup$encoder(fields.afO)),
								_Utils_Tuple2(
								'default_patients_preferred_language',
								$elm$json$Json$Encode$string(
									$author$project$Language$toValue(fields.agm))),
								_Utils_Tuple2(
								'default_to_active_patients_filter',
								$elm$json$Json$Encode$bool(fields.agn))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Practice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$practicePath)));
	});
var $author$project$Pages$Admin$Patients$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var newFields = A2(
					$author$project$Pages$Admin$Patients$updateField,
					field,
					$author$project$Pages$Admin$Patients$mapFormFields(model.ZV));
				if (field.$ === 12) {
					var threshold = field.a;
					var updateSettingsCmd = ($elm$core$String$length(threshold) > 0) ? A3($author$project$Api$Provider$Practice$updateSettings, model.Gv, newFields, $author$project$Pages$Admin$Patients$GotEnableResponse) : $elm$core$Platform$Cmd$none;
					var _v2 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Pages$Admin$Patients$engagementThresholdDebounceConfig, updateSettingsCmd, model.nz);
					var newDebouncer = _v2.a;
					var cmd = _v2.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{nz: newDebouncer, ahi: newFields}),
						cmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ahi: newFields}),
						A3($author$project$Api$Provider$Practice$updateSettings, model.Gv, newFields, $author$project$Pages$Admin$Patients$GotEnableResponse),
						_List_Nil);
				}
			case 1:
				var debounceMsg = msg.a;
				var _v3 = A4(
					$jinjor$elm_debounce$Debounce$update,
					$author$project$Pages$Admin$Patients$engagementThresholdDebounceConfig,
					$jinjor$elm_debounce$Debounce$takeLast($author$project$Pages$Admin$Patients$debouncePriceCheck),
					debounceMsg,
					model.nz);
				var newDebouncer = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nz: newDebouncer}),
					cmd,
					_List_Nil);
			case 2:
				var cmd = msg.a;
				return _Utils_Tuple3(model, cmd, _List_Nil);
			case 3:
				var response = msg.a;
				switch (response.$) {
					case 3:
						var practice = response.a;
						var message = 'Your practice has been updated';
						var _v5 = function () {
							var _v6 = $author$project$Api$Provider$Practice$One$passthroughFeesCutoffDate(practice);
							if (!_v6.$) {
								var date = _v6.a;
								return _Utils_Tuple2(
									$author$project$Components$DateInput$initFromDate(date),
									$elm$core$Platform$Cmd$none);
							} else {
								return $author$project$Components$DateInput$init;
							}
						}();
						var dateInputModel = _v5.a;
						var dateInputMsg = _v5.b;
						var newModel = _Utils_update(
							model,
							{
								ahi: $author$project$Pages$Admin$Patients$mapFormFields(practice),
								tE: dateInputModel,
								ZV: practice
							});
						return _Utils_Tuple3(
							newModel,
							A2(
								$elm$core$Platform$Cmd$map,
								$author$project$Pages$Admin$Patients$PassthroughFeesCutoffDateInputMsg(dateInputModel),
								dateInputMsg),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, message),
									$author$project$OutMsg$PracticeUpdated(response)
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ahi: $author$project$Pages$Admin$Patients$mapFormFields(model.ZV)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
				}
			case 4:
				var newFields = A2(
					$author$project$Pages$Admin$Patients$updateField,
					$author$project$Pages$Admin$Patients$ChargePatientsCreditCardFees(true),
					model.ahi);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ahi: newFields}),
					A3($author$project$Api$Provider$Practice$updateSettings, model.Gv, newFields, $author$project$Pages$Admin$Patients$GotEnableResponse),
					_List_Nil);
			case 5:
				return _Utils_Tuple3(
					model,
					A3($author$project$Api$Provider$Practice$updateSettings, model.Gv, model.ahi, $author$project$Pages$Admin$Patients$GotEnableResponse),
					_List_Nil);
			default:
				var dateInput = msg.a;
				var subMsg = msg.b;
				var _v7 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
				var newDateInput = _v7.a;
				var subCmd = _v7.b;
				var event = _v7.c;
				var updatedDate = function () {
					if (event.$ === 1) {
						var date = event.a;
						return date;
					} else {
						return model.ahi.ajP;
					}
				}();
				var newFields = A2(
					$author$project$Pages$Admin$Patients$updateField,
					$author$project$Pages$Admin$Patients$PassthroughFeesCutoffDate(updatedDate),
					model.ahi);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ahi: newFields, tE: newDateInput}),
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Pages$Admin$Patients$PassthroughFeesCutoffDateInputMsg(newDateInput),
						subCmd),
					_List_Nil);
		}
	});
var $author$project$Pages$Admin$Patients$FieldChanged = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$Patients$PassthroughCreditCardFeesAgreeAndEnableClicked = {$: 4};
var $author$project$Pages$Admin$Patients$settingToggleWithContentAndOffset = F5(
	function (offset, label, labelHelp, toggleSwitch, content) {
		return A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$span(8 - offset),
							$author$project$Ui$Grid$offset(offset)
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label(label),
									$author$project$Ui$Form$Group$labelHelp(labelHelp),
									$author$project$Ui$Form$Group$labelClass(''),
									$author$project$Ui$Form$Group$labelSpan(8),
									$author$project$Ui$Form$Group$inputSpan(4)
								]),
							_List_Nil),
						content)),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$span(4),
							$author$project$Ui$Grid$justifyRight
						]),
					_List_fromArray(
						[toggleSwitch]))
				]));
	});
var $author$project$Pages$Admin$Patients$settingToggleWithContent = F4(
	function (label, labelHelp, toggleSwitch, content) {
		return A5($author$project$Pages$Admin$Patients$settingToggleWithContentAndOffset, 0, label, labelHelp, toggleSwitch, content);
	});
var $author$project$Pages$Admin$Patients$settingToggle = F3(
	function (label, labelHelp, toggleSwitch) {
		return A4($author$project$Pages$Admin$Patients$settingToggleWithContent, label, labelHelp, toggleSwitch, _List_Nil);
	});
var $author$project$Api$Feature$PassthroughCreditCardFees = 13;
var $author$project$Pages$Admin$Patients$showChargePatientsCreditCardFees = function (practice) {
	return A2($author$project$Api$Provider$Practice$One$featureEnabled, 13, practice) || ($author$project$Api$Provider$Practice$One$chargePatientsCreditCardFees(practice) || ($author$project$Api$Provider$Practice$One$paymentProcessor(practice) === 'rainforest'));
};
var $author$project$Ui$Icon$Circled = {$: 7};
var $author$project$Ui$Icon$circled = $author$project$Ui$Icon$Circled;
var $author$project$Ui$Panel$Subtle = {$: 4};
var $author$project$Ui$Panel$subtle = $author$project$Ui$Panel$Subtle;
var $author$project$Pages$Admin$Patients$viewExpandedWarningWell = F3(
	function (enabled, message, extraHtmlBody) {
		return A2(
			$author$project$Ui$Grid$row,
			_List_fromArray(
				[$author$project$Ui$Grid$mb4]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$span(8)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Panel$view,
							_List_fromArray(
								[$author$project$Ui$Panel$subtle]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Panel$body,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap4]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_Nil,
													_List_fromArray(
														[
															enabled ? $author$project$Ui$Icon$crossCircle(_List_Nil) : $author$project$Ui$Icon$check(
															_List_fromArray(
																[$author$project$Ui$Icon$circled, $author$project$Ui$Icon$success]))
														])),
													A2(
													$author$project$Ui$Element$view,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(message),
															A2(
															$elm$core$Maybe$withDefault,
															$elm$html$Html$text(''),
															extraHtmlBody)
														]))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$Patients$PassthroughFeesCutoffDateUpdateButtonClicked = {$: 5};
var $author$project$Pages$Admin$Patients$PassthroughFeesCutoffEnabled = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Admin$Patients$viewPassthroughFeesCutoff = F3(
	function (practice, fields, passthroughFeesCutoffDateInput) {
		if ($author$project$Api$Provider$Practice$One$chargePatientsCreditCardFees(practice)) {
			var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$on(fields.ajQ),
						$author$project$Ui$ToggleSwitch$onChange(
						A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Patients$FieldChanged, $author$project$Pages$Admin$Patients$PassthroughFeesCutoffEnabled))
					]));
			var labelHelp = $elm$html$Html$text('When enabled, patients created prior to this date will not be surcharged for credit card fees.');
			var dateDirty = _Utils_eq(
				fields.ajP,
				$author$project$Api$Provider$Practice$One$passthroughFeesCutoffDate(practice));
			return A5(
				$author$project$Pages$Admin$Patients$settingToggleWithContentAndOffset,
				1,
				'Apply only to new patients',
				A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp),
				toggleSwitch,
				$elm$core$List$singleton(
					A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap4, $author$project$Ui$Element$mb4]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Admin$Patients$PassthroughFeesCutoffDateInputMsg(passthroughFeesCutoffDateInput),
								A2(
									$author$project$Components$DateInput$view,
									_List_fromArray(
										[
											$author$project$Components$DateInput$value(fields.ajP)
										]),
									passthroughFeesCutoffDateInput)),
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Update cutoff date'},
								_List_fromArray(
									[
										$author$project$Ui$Button$styled(2),
										$author$project$Ui$Button$onClick($author$project$Pages$Admin$Patients$PassthroughFeesCutoffDateUpdateButtonClicked),
										$author$project$Ui$Button$disabled(dateDirty)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Update Cutoff Date')
									]))
							]))));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Pages$Admin$Patients$viewChargePatientsCreditCardFees = F3(
	function (practice, fields, passthroughFeesCutoffDateInput) {
		if ($author$project$Pages$Admin$Patients$showChargePatientsCreditCardFees(practice)) {
			var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$on(fields.afE),
						$author$project$Ui$ToggleSwitch$disabled(!fields.afE),
						$author$project$Ui$ToggleSwitch$onChange(
						A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Patients$FieldChanged, $author$project$Pages$Admin$Patients$ChargePatientsCreditCardFees))
					]));
			var labelHelp = $elm$html$Html$text('Patients paying with a credit card will be responsible for any applicable credit card fees.');
			return _List_fromArray(
				[
					A3(
					$author$project$Pages$Admin$Patients$settingToggle,
					'Surcharge patients for credit card fees',
					A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp),
					toggleSwitch),
					A3($author$project$Pages$Admin$Patients$viewPassthroughFeesCutoff, practice, fields, passthroughFeesCutoffDateInput),
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_Nil,
							_List_fromArray(
								[
									A3(
									$author$project$Pages$Admin$Patients$viewExpandedWarningWell,
									!fields.afE,
									' To enable this, you must first agree to our legal terms.',
									$elm$core$Maybe$Just(
										A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$mt2]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Grid$row,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Grid$column,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('By enabling this feature, I affirm that our surcharge policy will comply with applicable laws and credit card network regulations.')
																]))
														])),
													A2(
													$author$project$Ui$Grid$row,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Grid$column,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('I acknowledge that Hint Health is not responsible for compliance of our surcharge policy. Hint Health advises that we seek the advice of a competent attorney or accountant licensed to practice in our jurisdiction before implementing a surcharge policy.')
																]))
														])),
													A2(
													$author$project$Ui$Grid$row,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Grid$column,
															_List_fromArray(
																[
																	$author$project$Ui$Grid$span(3)
																]),
															_List_fromArray(
																[
																	A3(
																	$author$project$Ui$Button$view,
																	{mm: 'Agree and enable'},
																	_List_fromArray(
																		[
																			$author$project$Ui$Button$disabled(fields.afE),
																			$author$project$Ui$Button$styled(2),
																			$author$project$Ui$Button$onClick($author$project$Pages$Admin$Patients$PassthroughCreditCardFeesAgreeAndEnableClicked)
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Agree & Enable')
																		]))
																]))
														]))
												]))))
								]))
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Pages$Admin$Patients$DefaultPreferredLanguage = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$LanguageInput$OnChange = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$LanguageInput$onChange = $author$project$Components$LanguageInput$OnChange;
var $author$project$Components$LanguageInput$Value = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$LanguageInput$value = $author$project$Components$LanguageInput$Value;
var $author$project$Language$fromString = function (string) {
	switch (string) {
		case 'en':
			return 0;
		case 'es':
			return 1;
		default:
			return 0;
	}
};
var $author$project$Components$LanguageInput$OptionsRecord = F2(
	function (value, onChange) {
		return {ajd: onChange, aee: value};
	});
var $author$project$Components$LanguageInput$optionsToRecord = A2(
	$elm$core$List$foldl,
	F2(
		function (option, record) {
			if (!option.$) {
				var val = option.a;
				return _Utils_update(
					record,
					{
						aee: $elm$core$Maybe$Just(val)
					});
			} else {
				var handler = option.a;
				return _Utils_update(
					record,
					{
						ajd: $elm$core$Maybe$Just(handler)
					});
			}
		}),
	A2($author$project$Components$LanguageInput$OptionsRecord, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing));
var $author$project$Components$LanguageInput$view = function (options) {
	var optionsRecord = $author$project$Components$LanguageInput$optionsToRecord(options);
	return A2(
		$author$project$Ui$Form$Select$view,
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Language$toValue,
						A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $author$project$Ui$Form$Select$value)),
					optionsRecord.aee),
					A2(
					$elm$core$Maybe$map,
					$author$project$Ui$Form$Select$onChange,
					A2(
						$elm$core$Maybe$map,
						function (handler) {
							return A2($elm$core$Basics$composeL, handler, $author$project$Language$fromString);
						},
						optionsRecord.ajd))
				])),
		A2(
			$elm$core$List$map,
			function (option) {
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(
						$author$project$Language$toValue(option)),
					$author$project$Language$toLabel(option));
			},
			_List_fromArray(
				[$author$project$Language$english, $author$project$Language$spanish])));
};
var $author$project$Pages$Admin$Patients$viewDefaultPreferredLanguage = F2(
	function (practice, fields) {
		return A2($author$project$Api$Provider$Practice$One$featureEnabled, 10, practice) ? A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanMd(12)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$required(true),
									$author$project$Ui$Form$Group$label('Default preferred language'),
									$author$project$Ui$Form$Group$labelClass(''),
									$author$project$Ui$Form$Group$labelHelp(
									A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Default preferred language for new patients')
											]))),
									$author$project$Ui$Form$Group$labelSpan(10),
									$author$project$Ui$Form$Group$inputSpan(2),
									$author$project$Ui$Form$Group$labelHelp(
									$elm$html$Html$text('This language will be set, by default, on all new patients created. Changing the default language will not impact any existing patients language settings and will only be used moving forward.\n                            '))
								]),
							_List_fromArray(
								[
									$author$project$Components$LanguageInput$view(
									_List_fromArray(
										[
											$author$project$Components$LanguageInput$value(fields.agm),
											$author$project$Components$LanguageInput$onChange(
											A2($elm$core$Basics$composeR, $author$project$Pages$Admin$Patients$DefaultPreferredLanguage, $author$project$Pages$Admin$Patients$FieldChanged))
										]))
								]))
						]))
				])) : $elm$html$Html$text('');
	});
var $author$project$Pages$Admin$Patients$DefaultToActivePatientsFilter = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Admin$Patients$viewDefaultToActivePatientsFilter = function (fields) {
	var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$on(fields.agn),
				$author$project$Ui$ToggleSwitch$onChange(
				A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Patients$FieldChanged, $author$project$Pages$Admin$Patients$DefaultToActivePatientsFilter))
			]));
	var labelHelp = A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Whether or not the patient list will default to showing only active patients.')
			]));
	return A3(
		$author$project$Pages$Admin$Patients$settingToggle,
		'Default to active patients filter',
		A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp),
		toggleSwitch);
};
var $author$project$Pages$Admin$Patients$SSNEnabled = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$Patients$viewEnableSSN = function (fields) {
	var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$on(fields.ab6),
				$author$project$Ui$ToggleSwitch$onChange(
				A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Patients$FieldChanged, $author$project$Pages$Admin$Patients$SSNEnabled))
			]));
	var labelHelp = fields.ab6 ? A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Collection of SSN for patients is enabled')
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('To change signup SSN collection see ')
							])),
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Admin__Signup,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('here')
							]))
					]))
			])) : A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Collection of SSN for patients is disabled')
			]));
	return A3(
		$author$project$Pages$Admin$Patients$settingToggle,
		'Enable SSN',
		A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp),
		toggleSwitch);
};
var $author$project$Pages$Admin$Patients$EngagementThreshold = function (a) {
	return {$: 12, a: a};
};
var $author$project$Api$FeatureGate$EngagementTracking = 11;
var $author$project$Api$Provider$Practice$Shared$isAffiliate = function (_v0) {
	var record = _v0;
	return record.Uz;
};
var $author$project$Api$Provider$Practice$One$isAffiliate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$isAffiliate(shared);
};
var $author$project$Api$Provider$Practice$Shared$isNetwork = function (_v0) {
	var record = _v0;
	return record.U_;
};
var $author$project$Api$Provider$Practice$One$isNetwork = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$isNetwork(shared);
};
var $author$project$Pages$Admin$Patients$viewEngagementThreshold = F2(
	function (practice, fields) {
		var practiceIsAffiliateOrNetwork = $author$project$Api$Provider$Practice$One$isNetwork(practice) || $author$project$Api$Provider$Practice$One$isAffiliate(practice);
		var gateIsAvailable = A2(
			$author$project$Utils$FeatureGate$gateAvailable,
			11,
			$author$project$Api$Practice$Provider(practice));
		if (gateIsAvailable || practiceIsAffiliateOrNetwork) {
			var labelHelp = A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('\n                        Set the number of months after receiving a service that the patient will\n                        switch from Currently Engaged to Previously Engaged.\n                        ')
					]));
			var disableInput = (!gateIsAvailable) && practiceIsAffiliateOrNetwork;
			var inputValue = disableInput ? '12' : fields.agV;
			return A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(12)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$required(true),
										$author$project$Ui$Form$Group$label('Engagement Threshold'),
										$author$project$Ui$Form$Group$labelClass(''),
										$author$project$Ui$Form$Group$labelHelp(labelHelp),
										$author$project$Ui$Form$Group$labelSpan(10),
										$author$project$Ui$Form$Group$inputSpan(2)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$group(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$view(
												_List_fromArray(
													[
														$author$project$Ui$Form$Input$value(inputValue),
														$author$project$Ui$Form$Input$number,
														$author$project$Ui$Form$Input$onInput(
														A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Patients$FieldChanged, $author$project$Pages$Admin$Patients$EngagementThreshold)),
														$author$project$Ui$Form$Input$withFeedback(true),
														$author$project$Ui$Form$Input$disabled(disableInput)
													])),
												$author$project$Ui$Form$Input$addon(
												_List_fromArray(
													[
														$elm$html$Html$text('months')
													]))
											]))
									]))
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Api$Provider$Practice$One$hasLocations = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.W4;
		},
		function ($) {
			return $.Tb;
		}));
var $author$project$Pages$Admin$Patients$viewLocationsWarning = function (practice) {
	return ($author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice) && (!$author$project$Api$Provider$Practice$One$hasLocations(practice))) ? A2(
		$author$project$Ui$Grid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$spanMd(12)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Alert$warning,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('You are tracking patients by location but don\'t have any locations setup yet. Go ')
									])),
								A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Admin__Locations,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('here')
									])),
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(' to setup locations.')
									]))
							]))
					]))
			])) : $elm$html$Html$text('');
};
var $author$project$Pages$Admin$Patients$RequiresDefaultLocationForCompanies = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$Practice$One$hasCompaniesWithoutDefaultLocation = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.S6;
	});
var $author$project$Pages$Admin$Patients$viewWarningWell = F2(
	function (enabled, message) {
		return A3(
			$author$project$Pages$Admin$Patients$viewExpandedWarningWell,
			enabled,
			message,
			$elm$core$Maybe$Just($author$project$Utils$Html$empty));
	});
var $author$project$Pages$Admin$Patients$viewRequireCompanyDefaultLocation = F2(
	function (practice, fields) {
		if (fields.adt) {
			var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$on(fields.akU),
						$author$project$Ui$ToggleSwitch$onChange(
						A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Patients$FieldChanged, $author$project$Pages$Admin$Patients$RequiresDefaultLocationForCompanies)),
						$author$project$Ui$ToggleSwitch$disabled(
						$author$project$Api$Provider$Practice$One$hasCompaniesWithoutDefaultLocation(practice))
					]));
			var labelHelp = fields.akU ? A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$muted]),
				_List_fromArray(
					[
						$elm$html$Html$text('A default location is required on all companies.')
					])) : A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$muted]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('A default location can optionally be set on a company. When a patient is created without a location no location will be assigned. ')
							])),
						A2(
						$elm$html$Html$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Patients without a location assigned may not be synced to partners')
							])),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(' until one is assigned.')
							]))
					]));
			return _List_fromArray(
				[
					A3(
					$author$project$Pages$Admin$Patients$settingToggle,
					'Require companies to have a default location',
					A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp),
					toggleSwitch),
					A2(
					$author$project$Pages$Admin$Patients$viewWarningWell,
					$author$project$Api$Provider$Practice$One$hasCompaniesWithoutDefaultLocation(practice),
					' To enable this, ensure that every company has a default location assigned.')
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Pages$Admin$Patients$RequireGroupForLocations = function (a) {
	return {$: 11, a: a};
};
var $author$project$Api$Provider$Practice$One$hasLocationsWithoutGroup = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Tc;
	});
var $author$project$Pages$Admin$Patients$viewRequireGroupInLocations = F2(
	function (practice, fields) {
		if (fields.adt) {
			var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$on(fields.akQ),
						$author$project$Ui$ToggleSwitch$onChange(
						A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Patients$FieldChanged, $author$project$Pages$Admin$Patients$RequireGroupForLocations)),
						$author$project$Ui$ToggleSwitch$disabled(
						$author$project$Api$Provider$Practice$One$hasLocationsWithoutGroup(practice))
					]));
			var labelHelp = fields.akQ ? A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$muted]),
				_List_fromArray(
					[
						$elm$html$Html$text('A group is required on all locations.')
					])) : A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$muted]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('A group can optionally be set on a location. ')
							])),
						A2(
						$elm$html$Html$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Patient in locations without a group assigned may not be synced to partners')
							])),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(' until one is assigned.')
							]))
					]));
			return _List_fromArray(
				[
					A3($author$project$Pages$Admin$Patients$settingToggle, 'Require every location to have a group assigned', labelHelp, toggleSwitch),
					A2(
					$author$project$Pages$Admin$Patients$viewWarningWell,
					$author$project$Api$Provider$Practice$One$hasLocationsWithoutGroup(practice),
					' To enable this, ensure that every location has a group assigned.')
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Pages$Admin$Patients$RequiresLocation = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$Patients$viewRequireLocationSelection = F2(
	function (practice, fields) {
		if (fields.adt) {
			var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$on(fields.$G),
						$author$project$Ui$ToggleSwitch$onChange(
						A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Patients$FieldChanged, $author$project$Pages$Admin$Patients$RequiresLocation)),
						$author$project$Ui$ToggleSwitch$disabled(
						!$author$project$Api$Provider$Practice$One$hasLocations(practice))
					]));
			var labelHelpRequiresLocation = $author$project$Api$Provider$Practice$One$requiresLocation(practice) ? A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Locations will be collected and required always.')
					])) : A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						function () {
						var _v0 = fields.afO;
						switch (_v0) {
							case 0:
								return $elm$html$Html$text('Locations are optional. If enabled, this will enforce collection on signup.');
							case 2:
								return $elm$html$Html$text('Locations are required during online signup.');
							default:
								return $elm$html$Html$text('');
						}
					}()
					]));
			var labelHelpHasLocations = (!$author$project$Api$Provider$Practice$One$hasLocations(practice)) ? A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('This practice has no locations. You need to add some ')
							])),
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Admin__Locations,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('here')
							])),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(' to enable this feature.')
							]))
					])) : $elm$html$Html$text('');
			var labelHelp = A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[labelHelpHasLocations, labelHelpRequiresLocation]));
			return A3(
				$author$project$Pages$Admin$Patients$settingToggle,
				'Require location selection for every patient',
				A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp),
				toggleSwitch);
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Pages$Admin$Patients$RequiresPatientEmail = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Admin$Patients$viewRequirePatientEmailSelection = function (fields) {
	var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$on(fields.$I),
				$author$project$Ui$ToggleSwitch$onChange(
				A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Patients$FieldChanged, $author$project$Pages$Admin$Patients$RequiresPatientEmail))
			]));
	var labelHelp = fields.$I ? A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Email is required when creating or updating any patient in app or on signup.')
			])) : A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Email can be collected but is not required for all patients.')
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Email is required only for the primary member on signup.')
					]))
			]));
	return A3(
		$author$project$Pages$Admin$Patients$settingToggle,
		'Require email for every patient',
		A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp),
		toggleSwitch);
};
var $author$project$Pages$Admin$Patients$RequiresPatientMobile = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$Patients$viewRequirePatientMobileSelection = function (fields) {
	var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$on(fields.$J),
				$author$project$Ui$ToggleSwitch$onChange(
				A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Patients$FieldChanged, $author$project$Pages$Admin$Patients$RequiresPatientMobile))
			]));
	var labelHelp = fields.$J ? A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Mobile phone is required when creating or updating any patient in app or on signup.')
			])) : A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Mobile phone can be collected but is not required for all patients.')
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Any phone type is required only for the primary member on signup.')
					]))
			]));
	return A3(
		$author$project$Pages$Admin$Patients$settingToggle,
		'Require a mobile phone number for every patient',
		A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp),
		toggleSwitch);
};
var $author$project$Pages$Admin$Patients$RequiresPractitioner = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$Practice$One$hasPractitioners = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.W4;
		},
		function ($) {
			return $.Th;
		}));
var $author$project$Pages$Admin$Patients$viewRequireProviderSelection = F2(
	function (practice, fields) {
		var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
			_List_fromArray(
				[
					$author$project$Ui$ToggleSwitch$on(fields.$M),
					$author$project$Ui$ToggleSwitch$onChange(
					A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Patients$FieldChanged, $author$project$Pages$Admin$Patients$RequiresPractitioner)),
					$author$project$Ui$ToggleSwitch$disabled(
					!$author$project$Api$Provider$Practice$One$hasPractitioners(practice))
				]));
		var labelHelp = fields.$M ? A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Providers will be collected and required.')
				])) : ($author$project$Api$Provider$Practice$One$hasPractitioners(practice) ? A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = fields.N_;
							switch (_v0) {
								case 0:
									return $elm$html$Html$text('Providers will not be collected during signup.');
								case 1:
									return $elm$html$Html$text('Providers are optional during signup.');
								case 2:
									return $elm$html$Html$text('Providers are required during signup only.');
								default:
									return $elm$html$Html$text('');
							}
						}()
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('If enabled, this will enforce collection. ')
								])),
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Admin__Signup,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('See here')
								]))
						]))
				])) : A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('This practice has no providers. You need to add some')
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Admin__Providers__Top,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('here')
								])),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(' to enable this feature.')
								]))
						]))
				])));
		return A3(
			$author$project$Pages$Admin$Patients$settingToggle,
			'Require provider selection for every patient',
			A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp),
			toggleSwitch);
	});
var $author$project$Pages$Admin$Patients$RequiresSSN = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$Patients$viewRequireSSNSelection = function (fields) {
	if (fields.ab6) {
		var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
			_List_fromArray(
				[
					$author$project$Ui$ToggleSwitch$on(fields.$N),
					$author$project$Ui$ToggleSwitch$onChange(
					A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Patients$FieldChanged, $author$project$Pages$Admin$Patients$RequiresSSN))
				]));
		var labelHelp = fields.$N ? A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('When editing a patient, entering a SSN will be always required')
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('SSN collection will be enforced on signup.')
						]))
				])) : A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('SSN on patients is optional.')
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = fields.N$;
							switch (_v0) {
								case 0:
									return $elm$html$Html$text('SSN collection is disabled on signup.');
								case 1:
									return $elm$html$Html$text('SSN collection is optional on signup.');
								case 2:
									return $elm$html$Html$text('SSN collection is required on signup.');
								default:
									return $elm$html$Html$text('');
							}
						}()
						]))
				]));
		return A3(
			$author$project$Pages$Admin$Patients$settingToggle,
			'Require SSN selection for every patient',
			A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp),
			toggleSwitch);
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Pages$Admin$Patients$TrackPatientsByLocation = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Admin$Patients$viewTrackLocation = function (fields) {
	var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$on(fields.adt),
				$author$project$Ui$ToggleSwitch$onChange(
				A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Patients$FieldChanged, $author$project$Pages$Admin$Patients$TrackPatientsByLocation))
			]));
	var labelHelp = fields.adt ? A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						function () {
						var _v0 = fields.afO;
						switch (_v0) {
							case 0:
								return $elm$html$Html$text('Locations for patients can be assigned but are not collected during signup.');
							case 2:
								return $elm$html$Html$text('Locations for patients can be assigned and are required during signup.');
							default:
								return $elm$html$Html$text('');
						}
					}()
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('To change signup location collection see  ')
							])),
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Admin__Signup,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('here')
							]))
					]))
			])) : A2(
		$elm$html$Html$span,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Location support is not enabled. If toggled, you can track patients by location.')
			]));
	return A3(
		$author$project$Pages$Admin$Patients$settingToggle,
		'Track patients by location',
		A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp),
		toggleSwitch);
};
var $author$project$Pages$Admin$Patients$view = function (_v0) {
	var practice = _v0.ZV;
	var fields = _v0.ahi;
	var passthroughFeesCutoffDateInput = _v0.tE;
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Patients')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						A2(
							$elm$core$List$cons,
							$author$project$Pages$Admin$Patients$viewLocationsWarning(practice),
							A2(
								$elm$core$List$cons,
								$author$project$Pages$Admin$Patients$viewEnableSSN(fields),
								A2(
									$elm$core$List$cons,
									$author$project$Pages$Admin$Patients$viewRequireSSNSelection(fields),
									A2(
										$elm$core$List$cons,
										$author$project$Pages$Admin$Patients$viewRequirePatientEmailSelection(fields),
										A2(
											$elm$core$List$cons,
											$author$project$Pages$Admin$Patients$viewRequirePatientMobileSelection(fields),
											A2(
												$elm$core$List$cons,
												A2($author$project$Pages$Admin$Patients$viewRequireProviderSelection, practice, fields),
												_Utils_ap(
													A3($author$project$Pages$Admin$Patients$viewChargePatientsCreditCardFees, practice, fields, passthroughFeesCutoffDateInput),
													A2(
														$elm$core$List$cons,
														$author$project$Pages$Admin$Patients$viewTrackLocation(fields),
														A2(
															$elm$core$List$cons,
															A2($author$project$Pages$Admin$Patients$viewRequireLocationSelection, practice, fields),
															_Utils_ap(
																A2($author$project$Pages$Admin$Patients$viewRequireCompanyDefaultLocation, practice, fields),
																_Utils_ap(
																	A2($author$project$Pages$Admin$Patients$viewRequireGroupInLocations, practice, fields),
																	_List_fromArray(
																		[
																			A2($author$project$Pages$Admin$Patients$viewEngagementThreshold, practice, fields),
																			A2($author$project$Pages$Admin$Patients$viewDefaultPreferredLanguage, practice, fields),
																			$author$project$Pages$Admin$Patients$viewDefaultToActivePatientsFilter(fields)
																		])))))))))))))
					]))
			]),
		ac9: 'Admin | Patient Settings'
	};
};
var $author$project$Pages$Admin$Patients$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Patients$init, aiq: $author$project$Pages$Admin$Patients$load, k8: $author$project$Pages$Admin$Patients$save, alO: $author$project$Pages$Admin$Patients$subscriptions, adT: $author$project$Pages$Admin$Patients$update, amo: $author$project$Pages$Admin$Patients$view});
var $author$project$Api$Provider$Report$PaymentMethodImport = 25;
var $author$project$Pages$Admin$PaymentMethodImport$Pending = 1;
var $author$project$Pages$Admin$PaymentMethodImport$StatusDropdownMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Admin$PaymentMethodImport$GotPaymentMethodImports = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$PaymentMethodMigration$All$PaymentMethodMigration = $elm$core$Basics$identity;
var $author$project$Api$Provider$PaymentMethodMigration$One$PaymentMethodMigration = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$PaymentMethodMigration$Shared$PaymentMethodMigration = $elm$core$Basics$identity;
var $author$project$Api$Provider$PaymentMethodMigration$Shared$Record = F7(
	function (id, status, sourceProcessor, migrationId, sourceCustomerId, sourcePaymentMethodId, description) {
		return {Qr: description, ahP: id, W8: migrationId, abL: sourceCustomerId, abM: sourcePaymentMethodId, abN: sourceProcessor, alH: status};
	});
var $author$project$Api$Provider$PaymentMethodMigration$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'description',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'source_payment_method_id',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'source_customer_id',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'migration_id',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'source_processor',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'status',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Api$Provider$PaymentMethodMigration$Shared$Record))))))));
var $author$project$Api$Provider$PaymentMethodMigration$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PaymentMethodMigration$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PaymentMethodMigration$One$Record = F2(
	function (owner, metadata) {
		return {W5: metadata, YD: owner};
	});
var $author$project$Api$Common$Payable$Owner$Min$Owner = $elm$core$Basics$identity;
var $author$project$Api$Common$Payable$Owner$Min$Record = F3(
	function (id, name, type_) {
		return {ahP: id, Bq: name, amg: type_};
	});
var $author$project$Api$Common$Payable$Owner$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'type',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Common$Payable$Owner$Min$Record))));
var $author$project$Api$Common$Payable$Owner$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Payable$Owner$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PaymentMethodMigration$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'metadata',
	$elm$json$Json$Decode$value,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'owner',
		$elm$json$Json$Decode$nullable($author$project$Api$Common$Payable$Owner$Min$decoder),
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$PaymentMethodMigration$One$Record)));
var $author$project$Api$Provider$PaymentMethodMigration$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PaymentMethodMigration$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$PaymentMethodMigration$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$PaymentMethodMigration$One$PaymentMethodMigration)));
var $author$project$Api$Provider$PaymentMethodMigration$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PaymentMethodMigration$One$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PaymentMethodImport$listDefaults = {ajJ: $author$project$Api$Pagination$init, alA: $author$project$Api$Sort$init, alH: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$PaymentMethodImport$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$PaymentMethodImport$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.alH;
				if (!_v0.$) {
					var status = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'status', status)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$Provider$PaymentMethodImport$paymentMethodImportsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['payment_method_imports']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$PaymentMethodImport$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$PaymentMethodMigration$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$PaymentMethodImport$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$PaymentMethodImport$paymentMethodImportsPath)));
	});
var $author$project$Pages$Admin$PaymentMethodImport$statusOptionToValue = function (option) {
	switch (option) {
		case 1:
			return $elm$core$Maybe$Just('pending');
		case 2:
			return $elm$core$Maybe$Just('imported');
		case 3:
			return $elm$core$Maybe$Just('ignored');
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$Admin$PaymentMethodImport$retrievePaymentMethodMigrations = F2(
	function (apiClient, model) {
		var optionals = function (d) {
			return _Utils_update(
				d,
				{
					ajJ: model.ajJ,
					alA: model.alA,
					alH: $author$project$Pages$Admin$PaymentMethodImport$statusOptionToValue(model.alH)
				});
		};
		return A3($author$project$Api$Provider$PaymentMethodImport$list, apiClient, optionals, $author$project$Pages$Admin$PaymentMethodImport$GotPaymentMethodImports);
	});
var $author$project$Pages$Admin$PaymentMethodImport$init = F4(
	function (session, _v0, shared, _v1) {
		var model = {
			Gv: shared.Gv,
			GP: A3($author$project$Permission$canGoTo, session, shared.ahK, 18),
			GQ: A3($author$project$Permission$canGoTo, session, shared.ahK, 50),
			nD: $author$project$Components$ExportCsv$initForPractice(25),
			ey: $elm$core$Maybe$Nothing,
			jU: $elm$core$Maybe$Nothing,
			Ij: $author$project$Shared$isHintAdmin(shared),
			ajJ: $author$project$Api$Pagination$init,
			cN: $author$project$Api$Data$Loading,
			alA: $author$project$Api$Sort$init,
			alH: 1,
			qn: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'status-dropdown-filter', al6: $author$project$Pages$Admin$PaymentMethodImport$StatusDropdownMsg}))
		};
		return _Utils_Tuple2(
			model,
			A2($author$project$Pages$Admin$PaymentMethodImport$retrievePaymentMethodMigrations, shared.Gv, model));
	});
var $author$project$Pages$Admin$PaymentMethodImport$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					Ij: $author$project$Shared$isHintAdmin(shared)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$PaymentMethodImport$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$PaymentMethodImport$ExportCsvMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Admin$PaymentMethodImport$IgnoreHiConfirmClosed = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Pages$Admin$PaymentMethodImport$ImportModalMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$Close = {$: 0};
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$CompanyResourceFilterMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$PatientResourceFilterMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$ResourceFilter$Company$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Components$ResourceFilter$Company$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.b8));
};
var $author$project$Components$ResourceFilter$Patient$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Components$ResourceFilter$Patient$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.b8));
};
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$PaymentMethodImport$ImportModal$Close),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Admin$PaymentMethodImport$ImportModal$CompanyResourceFilterMsg,
				$author$project$Components$ResourceFilter$Company$subscriptions(model.mZ)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Admin$PaymentMethodImport$ImportModal$PatientResourceFilterMsg,
				$author$project$Components$ResourceFilter$Patient$subscriptions(model.oY))
			]));
};
var $author$project$Pages$Admin$PaymentMethodImport$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					function (_v0) {
						var paymentMethodMigration = _v0.a;
						return $author$project$Components$HiConfirm$subscribeToEscapeKeyPress(
							$author$project$Pages$Admin$PaymentMethodImport$IgnoreHiConfirmClosed(paymentMethodMigration));
					},
					model.ey)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Platform$Sub$map($author$project$Pages$Admin$PaymentMethodImport$ImportModalMsg),
					A2(
						$elm$core$Maybe$map,
						function (importModal) {
							return $author$project$Components$Admin$PaymentMethodImport$ImportModal$subscriptions(importModal);
						},
						model.jU))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$PaymentMethodImport$ExportCsvMsg,
				$author$project$Components$ExportCsv$subscriptions(model.nD))
			]));
};
var $author$project$Pages$Admin$PaymentMethodImport$GotIgnoreResponse = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Api$Provider$PaymentMethodMigration$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$PaymentMethodMigration$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PaymentMethodMigration$Shared$id(shared);
};
var $author$project$Api$Provider$PaymentMethodMigration$All$id = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$PaymentMethodMigration$One$id(one);
};
var $author$project$Api$Provider$PaymentMethodImport$paymentMethodImportPath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		$author$project$Api$Provider$PaymentMethodImport$paymentMethodImportsPath);
};
var $author$project$Api$Provider$PaymentMethodImport$ignore = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$PaymentMethodMigration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['ignore']),
					$author$project$Api$Provider$PaymentMethodImport$paymentMethodImportPath(id))));
	});
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$Model = $elm$core$Basics$identity;
var $author$project$Api$Provider$Company$All$Company = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Company$Shared$Company = $elm$core$Basics$identity;
var $author$project$Api$Provider$Company$Shared$Record = function (id) {
	return function (name) {
		return function (companyType) {
			return function (createdAt) {
				return function (periodInMonths) {
					return function (allowCustomMembershipPlan) {
						return function (postSignupButtonLabel) {
							return function (postSignupMessage) {
								return function (postSignupRedirectUrl) {
									return function (redirectsPostSignup) {
										return function (requiresEmployeeDivisions) {
											return function (showPostSignupFooterButton) {
												return function (customPostSignupPage) {
													return function (stripeLink) {
														return function (nextInvoiceDate) {
															return function (inactive) {
																return function (backBillPeriods) {
																	return function (limitBackBill) {
																		return function (billAffiliateRate) {
																			return {Lv: allowCustomMembershipPlan, Mt: backBillPeriods, MC: billAffiliateRate, Ok: companyType, O1: createdAt, Ps: customPostSignupPage, ahP: id, TU: inactive, V1: limitBackBill, Bq: name, XS: nextInvoiceDate, Zs: periodInMonths, ZR: postSignupButtonLabel, ZS: postSignupMessage, ZT: postSignupRedirectUrl, $l: redirectsPostSignup, $F: requiresEmployeeDivisions, abp: showPostSignupFooterButton, acq: stripeLink};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Company$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'bill_affiliate_rate',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'limit_back_bill',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'back_bill_periods',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'inactive',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'next_invoice_date',
					$elm$json$Json$Decode$maybe($author$project$Utils$Date$decode),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'stripe_link',
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'custom_post_signup_page',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'show_post_signup_footer_button',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'requires_employee_divisions',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'redirects_post_signup',
										$elm$json$Json$Decode$bool,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'post_signup_redirect_url',
											$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'post_signup_message',
												$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'post_signup_button_label',
													$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'allow_custom_membership_plan',
														$elm$json$Json$Decode$bool,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'period_in_months',
															$elm$json$Json$Decode$int,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'created_at',
																$elm_community$json_extra$Json$Decode$Extra$datetime,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'company_type',
																	$author$project$Api$Company$CompanyType$decoder,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'name',
																		$elm$json$Json$Decode$string,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'id',
																			$elm$json$Json$Decode$string,
																			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Company$Shared$Record))))))))))))))))))));
var $author$project$Api$Provider$Company$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Company$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Company$All$Record = F8(
	function (status, flaggedNotesCount, usesEmployeeDivisions, eligibleCount, enrolledCount, needsApprovalCount, owedInCents, plans) {
		return {Ri: eligibleCount, RC: enrolledCount, Sz: flaggedNotesCount, Xy: needsApprovalCount, YC: owedInCents, ZG: plans, alH: status, ad6: usesEmployeeDivisions};
	});
var $author$project$Api$Provider$Company$All$recordDecoder = A3(
	$author$project$Api$Expandable$expandable,
	'plans',
	$elm$json$Json$Decode$list($author$project$Api$Provider$Plan$Shared$decoder),
	A3(
		$author$project$Api$Expandable$expandable,
		'owed_in_cents',
		$elm$json$Json$Decode$int,
		A3(
			$author$project$Api$Expandable$expandable,
			'needs_approval_count',
			$elm$json$Json$Decode$int,
			A3(
				$author$project$Api$Expandable$expandable,
				'enrolled_count',
				$elm$json$Json$Decode$int,
				A3(
					$author$project$Api$Expandable$expandable,
					'eligible_count',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'uses_employee_divisions',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'flagged_notes_count',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'status',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Api$Provider$Company$All$Record)))))))));
var $author$project$Api$Provider$Company$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Company$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Company$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Company$All$Company)));
var $author$project$Api$Provider$Company$expandToString = function (expand) {
	switch (expand) {
		case 0:
			return 'plans';
		case 1:
			return 'eligible_count';
		case 2:
			return 'enrolled_count';
		case 3:
			return 'needs_approval_count';
		default:
			return 'owed_in_cents';
	}
};
var $author$project$Api$Provider$Company$listDefaults = {
	HE: _List_Nil,
	HM: $elm$core$Maybe$Nothing,
	ahP: $elm$core$Maybe$Nothing,
	ajJ: $author$project$Api$Pagination$init,
	Jb: $elm$core$Maybe$Nothing,
	akl: $elm$core$Maybe$Nothing,
	alA: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init),
	JT: $elm$core$Maybe$Nothing
};
var $author$project$Api$Provider$Company$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Company$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.akl;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.ahP;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.HM;
				if (!_v2.$) {
					var string = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'filter', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v3 = options.Jb;
				if (!_v3.$) {
					var string = _v3.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'plans', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v4 = options.JT;
				if (!_v4.$) {
					var string = _v4.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'sponsor_type', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				A2($author$project$Api$Expandable$toParam, $author$project$Api$Provider$Company$expandToString, options.HE),
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$Provider$Company$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Company$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Company$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Company$companiesPath)));
	});
var $author$project$Components$ResourceFilter$Company$list = $author$project$Api$Provider$Company$list;
var $author$project$Components$ResourceFilter$Company$fetchResources = F4(
	function (toMsg, apiClient, pagination, query) {
		return A3(
			$author$project$Components$ResourceFilter$Company$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{ajJ: pagination, akl: query});
			},
			toMsg);
	});
var $author$project$Components$ResourceFilter$Company$retrieveResource = F3(
	function (toMsg, apiClient, id) {
		return A3(
			$author$project$Components$ResourceFilter$Company$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						ahP: $elm$core$Maybe$Just(id)
					});
			},
			toMsg);
	});
var $author$project$Components$ResourceFilter$Company$selectId = 'companies';
var $author$project$Api$Provider$Company$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$Company$All$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$name(shared);
};
var $author$project$Components$ResourceFilter$Company$toTitle = $author$project$Api$Provider$Company$All$name;
var $author$project$Components$ResourceFilter$Company$toLabel = function (resource) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Components$ResourceFilter$Company$toTitle(resource))
		]);
};
var $author$project$Api$Provider$Company$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Company$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$id(shared);
};
var $author$project$Components$ResourceFilter$Company$toValue = $author$project$Api$Provider$Company$All$id;
var $author$project$Components$ResourceFilter$Company$init = F2(
	function (apiClient, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{Sk: $author$project$Components$ResourceFilter$Company$fetchResources, ahP: $author$project$Components$ResourceFilter$Company$selectId, k$: 'Sponsor', uk: $author$project$Components$ResourceFilter$Company$retrieveResource, u9: $author$project$Components$ResourceFilter$Company$toLabel, lN: $author$project$Components$ResourceFilter$Company$toTitle, hX: $author$project$Components$ResourceFilter$Company$toValue},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{Jy: $author$project$Components$ResourceFilter$All, b8: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$ResourceFilter$Patient$list = $author$project$Api$Provider$Patient$list;
var $author$project$Components$ResourceFilter$Patient$fetchResources = F4(
	function (toMsg, apiClient, pagination, query) {
		return A3(
			$author$project$Components$ResourceFilter$Patient$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{ajJ: pagination, akl: query});
			},
			toMsg);
	});
var $author$project$Components$ResourceFilter$Patient$retrieveResource = F3(
	function (toMsg, apiClient, id) {
		return A3(
			$author$project$Components$ResourceFilter$Patient$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						ahP: $elm$core$Maybe$Just(id)
					});
			},
			toMsg);
	});
var $author$project$Api$Provider$Patient$Shared$age = function (_v0) {
	var shared = _v0;
	return shared.Lj;
};
var $author$project$Api$Provider$Patient$All$age = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$age(shared);
};
var $author$project$Api$Provider$Patient$Shared$membershipStatus = function (_v0) {
	var shared = _v0;
	return shared.WX;
};
var $author$project$Api$Provider$Patient$All$membershipStatus = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$membershipStatus(shared);
};
var $author$project$Ui$Badge$SizeSm = {$: 2};
var $author$project$Ui$Badge$sm = $author$project$Ui$Badge$SizeSm;
var $author$project$Components$ResourceFilter$Patient$toLabel = function (resource) {
	return A2(
		$elm$core$List$intersperse,
		A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mr-2')
				]),
			_List_Nil),
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					$elm$html$Html$text(
						$author$project$Api$Provider$Patient$All$name(resource))),
					A2(
					$elm$core$Maybe$map,
					function (age) {
						return $elm$html$Html$text(age);
					},
					A2(
						$elm$core$Maybe$map,
						$elm$core$String$fromInt,
						$author$project$Api$Provider$Patient$All$age(resource))),
					$elm$core$Maybe$Just(
					A2(
						$author$project$Ui$Badge$fromString,
						_List_fromArray(
							[$author$project$Ui$Badge$sm]),
						$author$project$Api$Provider$Patient$All$membershipStatus(resource)))
				])));
};
var $author$project$Components$ResourceFilter$Patient$toTitle = function (resource) {
	return _Utils_ap(
		$author$project$Api$Provider$Patient$All$name(resource),
		_Utils_ap(
			function () {
				var _v0 = $author$project$Api$Provider$Patient$All$age(resource);
				if (!_v0.$) {
					var age = _v0.a;
					return ' - ' + $elm$core$String$fromInt(age);
				} else {
					return '';
				}
			}(),
			(!$elm$core$String$isEmpty(
				$author$project$Api$Provider$Patient$All$membershipStatus(resource))) ? (' - ' + $author$project$Formatters$String$humanize(
				$author$project$Api$Provider$Patient$All$membershipStatus(resource))) : ''));
};
var $author$project$Components$ResourceFilter$Patient$toValue = $author$project$Api$Provider$Patient$All$id;
var $author$project$Components$ResourceFilter$Patient$initWithId = F3(
	function (selectId_, apiClient, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{Sk: $author$project$Components$ResourceFilter$Patient$fetchResources, ahP: selectId_, k$: 'Patient', uk: $author$project$Components$ResourceFilter$Patient$retrieveResource, u9: $author$project$Components$ResourceFilter$Patient$toLabel, lN: $author$project$Components$ResourceFilter$Patient$toTitle, hX: $author$project$Components$ResourceFilter$Patient$toValue},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{Jy: $author$project$Components$ResourceFilter$All, b8: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$ResourceFilter$Patient$selectId = 'patients';
var $author$project$Components$ResourceFilter$Patient$init = $author$project$Components$ResourceFilter$Patient$initWithId($author$project$Components$ResourceFilter$Patient$selectId);
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$PatientOwnerType = 1;
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$initFormFields = {afQ: $elm$core$Maybe$Nothing, TS: false, eN: 1, YY: $elm$core$Maybe$Nothing};
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$init = F2(
	function (apiClient, paymentMethodMigration) {
		var _v0 = A2(
			$author$project$Components$ResourceFilter$Patient$init,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Select a Patient'});
			});
		var patientResourceFilter = _v0.a;
		var patientResourceFilterCmd = _v0.b;
		var _v1 = A2(
			$author$project$Components$ResourceFilter$Company$init,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Select an Employer'});
			});
		var companyResourceFilter = _v1.a;
		var companyResourceFilterCmd = _v1.b;
		return _Utils_Tuple2(
			{
				mZ: companyResourceFilter,
				SD: $author$project$Utils$Form$init($author$project$Components$Admin$PaymentMethodImport$ImportModal$initFormFields),
				nX: $author$project$Api$Data$NotAsked,
				oY: patientResourceFilter,
				tJ: paymentMethodMigration
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$PaymentMethodImport$ImportModal$CompanyResourceFilterMsg, companyResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$PaymentMethodImport$ImportModal$PatientResourceFilterMsg, patientResourceFilterCmd)
					])));
	});
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$Closed = 1;
var $author$project$Api$Provider$PaymentMethodImport$Company = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$Company = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$GotImportReponse = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$Imported = 2;
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$None = 0;
var $author$project$Api$Provider$PaymentMethodImport$Patient = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$Patient = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var ownerType = field.a;
				return _Utils_update(
					fields,
					{eN: ownerType});
			case 1:
				var company = field.a;
				return _Utils_update(
					fields,
					{afQ: company});
			case 2:
				var patient = field.a;
				return _Utils_update(
					fields,
					{YY: patient});
			default:
				var importAllForOwner = field.a;
				return _Utils_update(
					fields,
					{TS: importAllForOwner});
		}
	});
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$CompanyValidation = 0;
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$validateCompany = function (fields) {
	var _v0 = _Utils_Tuple2(fields.eN, fields.afQ);
	if (!_v0.a) {
		if (_v0.b.$ === 1) {
			var _v1 = _v0.a;
			var _v2 = _v0.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(0, 'Please select an employer.')
				]);
		} else {
			var _v3 = _v0.a;
			return _List_Nil;
		}
	} else {
		var _v4 = _v0.a;
		return _List_Nil;
	}
};
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$PatientValidation = 1;
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$validatePatient = function (fields) {
	var _v0 = _Utils_Tuple2(fields.eN, fields.YY);
	if (_v0.a === 1) {
		if (_v0.b.$ === 1) {
			var _v1 = _v0.a;
			var _v2 = _v0.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(1, 'Please select a patient.')
				]);
		} else {
			var _v3 = _v0.a;
			return _List_Nil;
		}
	} else {
		var _v4 = _v0.a;
		return _List_Nil;
	}
};
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$PaymentMethodImport$ImportModal$validatePatient),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$PaymentMethodImport$ImportModal$validateCompany)
		]));
var $author$project$Api$Provider$PaymentMethodImport$import_ = F4(
	function (apiClient, id, _v0, toMsg) {
		var owner = _v0.YD;
		var importAllForOwner = _v0.TS;
		var _v1 = function () {
			if (!owner.$) {
				var patientId = owner.a;
				return _Utils_Tuple2('patient', patientId);
			} else {
				var companyId = owner.a;
				return _Utils_Tuple2('company', companyId);
			}
		}();
		var ownerType = _v1.a;
		var ownerId = _v1.b;
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'owner',
					$author$project$Utils$Encode$typedAssociation(
						{
							ahP: $elm$core$Maybe$Just(ownerId),
							amg: $elm$core$Maybe$Just(ownerType)
						})),
					_Utils_Tuple2(
					'import_all_for_owner',
					$elm$json$Json$Encode$bool(importAllForOwner))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$PaymentMethodMigration$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['import']),
						$author$project$Api$Provider$PaymentMethodImport$paymentMethodImportPath(id)))));
	});
var $author$project$Components$ResourceFilter$Company$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.b8);
		var modelAfterEvent = function () {
			var _v1 = result.agZ;
			if (!_v1.$) {
				var selected = _v1.a;
				return _Utils_update(
					model,
					{Jy: selected});
			} else {
				return model;
			}
		}();
		return {
			GZ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.GZ),
			agZ: result.agZ,
			aiO: _Utils_update(
				modelAfterEvent,
				{b8: result.aiO}),
			aR: result.aR
		};
	});
var $author$project$Components$ResourceFilter$Patient$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.b8);
		var modelAfterEvent = function () {
			var _v1 = result.agZ;
			if (!_v1.$) {
				var selected = _v1.a;
				return _Utils_update(
					model,
					{Jy: selected});
			} else {
				return model;
			}
		}();
		return {
			GZ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.GZ),
			agZ: result.agZ,
			aiO: _Utils_update(
				modelAfterEvent,
				{b8: result.aiO}),
			aR: result.aR
		};
	});
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: 1, aiO: model, aR: _List_Nil};
			case 1:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Admin$PaymentMethodImport$ImportModal$formFieldsUpdate, field, model.SD);
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{SD: newForm}),
					aR: _List_Nil
				};
			case 2:
				var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$Admin$PaymentMethodImport$ImportModal$formFieldsValidator, model.SD);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var newForm = _v3.a;
					var validFormFields = _v3.b;
					var id = $author$project$Api$Provider$PaymentMethodMigration$All$id(model.tJ);
					var _v4 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
					var ownerType = _v4.eN;
					var company = _v4.afQ;
					var patient = _v4.YY;
					var importAllForOwner = _v4.TS;
					var owner = function () {
						if (ownerType === 1) {
							var patientId = A2(
								$elm$core$Maybe$withDefault,
								'',
								A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$All$id, patient));
							return $author$project$Api$Provider$PaymentMethodImport$Patient(patientId);
						} else {
							var companyId = A2(
								$elm$core$Maybe$withDefault,
								'',
								A2($elm$core$Maybe$map, $author$project$Api$Provider$Company$All$id, company));
							return $author$project$Api$Provider$PaymentMethodImport$Company(companyId);
						}
					}();
					var importParams = {TS: importAllForOwner, YD: owner};
					return {
						GZ: A4($author$project$Api$Provider$PaymentMethodImport$import_, apiClient, id, importParams, $author$project$Components$Admin$PaymentMethodImport$ImportModal$GotImportReponse),
						agZ: 0,
						aiO: _Utils_update(
							model,
							{SD: newForm, nX: $author$project$Api$Data$Loading}),
						aR: _List_Nil
					};
				} else {
					var newForm = _v2.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{SD: newForm}),
						aR: _List_Nil
					};
				}
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 2,
						aiO: _Utils_update(
							model,
							{nX: response}),
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Payment method was successfully imported.')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{nX: $author$project$Api$Data$NotAsked}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 4:
				var subMsg = msg.a;
				var companyResourceResult = A3($author$project$Components$ResourceFilter$Company$update, apiClient, subMsg, model.mZ);
				var newForm = function () {
					var _v7 = companyResourceResult.agZ;
					_v7$2:
					while (true) {
						if (!_v7.$) {
							switch (_v7.a.$) {
								case 0:
									var company = _v7.a.a;
									return A3(
										$author$project$Utils$Form$update,
										$author$project$Components$Admin$PaymentMethodImport$ImportModal$formFieldsUpdate,
										$author$project$Components$Admin$PaymentMethodImport$ImportModal$Company(
											$elm$core$Maybe$Just(company)),
										model.SD);
								case 2:
									var _v8 = _v7.a;
									return A3(
										$author$project$Utils$Form$update,
										$author$project$Components$Admin$PaymentMethodImport$ImportModal$formFieldsUpdate,
										$author$project$Components$Admin$PaymentMethodImport$ImportModal$Company($elm$core$Maybe$Nothing),
										model.SD);
								default:
									break _v7$2;
							}
						} else {
							break _v7$2;
						}
					}
					return model.SD;
				}();
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$PaymentMethodImport$ImportModal$CompanyResourceFilterMsg, companyResourceResult.GZ),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{mZ: companyResourceResult.aiO, SD: newForm}),
					aR: companyResourceResult.aR
				};
			default:
				var subMsg = msg.a;
				var patientResourceResult = A3($author$project$Components$ResourceFilter$Patient$update, apiClient, subMsg, model.oY);
				var newForm = function () {
					var _v9 = patientResourceResult.agZ;
					_v9$2:
					while (true) {
						if (!_v9.$) {
							switch (_v9.a.$) {
								case 0:
									var patient = _v9.a.a;
									return A3(
										$author$project$Utils$Form$update,
										$author$project$Components$Admin$PaymentMethodImport$ImportModal$formFieldsUpdate,
										$author$project$Components$Admin$PaymentMethodImport$ImportModal$Patient(
											$elm$core$Maybe$Just(patient)),
										model.SD);
								case 2:
									var _v10 = _v9.a;
									return A3(
										$author$project$Utils$Form$update,
										$author$project$Components$Admin$PaymentMethodImport$ImportModal$formFieldsUpdate,
										$author$project$Components$Admin$PaymentMethodImport$ImportModal$Patient($elm$core$Maybe$Nothing),
										model.SD);
								default:
									break _v9$2;
							}
						} else {
							break _v9$2;
						}
					}
					return model.SD;
				}();
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$PaymentMethodImport$ImportModal$PatientResourceFilterMsg, patientResourceResult.GZ),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{SD: newForm, oY: patientResourceResult.aiO}),
					aR: patientResourceResult.aR
				};
		}
	});
var $author$project$Pages$Admin$PaymentMethodImport$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ),
								cN: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cN: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ajJ: A2($author$project$Api$Pagination$update, subMsg, model.ajJ)
					});
				return _Utils_Tuple3(
					newModel,
					A2($author$project$Pages$Admin$PaymentMethodImport$retrievePaymentMethodMigrations, model.Gv, newModel),
					_List_Nil);
			case 2:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						alA: A2($author$project$Api$Sort$update, columnId, model.alA)
					});
				return _Utils_Tuple3(
					newModel,
					A2($author$project$Pages$Admin$PaymentMethodImport$retrievePaymentMethodMigrations, model.Gv, newModel),
					_List_Nil);
			case 3:
				var paymentMethodMigration = msg.a;
				var _v2 = A2($author$project$Components$Admin$PaymentMethodImport$ImportModal$init, model.Gv, paymentMethodMigration);
				var importModal = _v2.a;
				var importModalCmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							jU: $elm$core$Maybe$Just(importModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$PaymentMethodImport$ImportModalMsg, importModalCmd),
					_List_Nil);
			case 4:
				var importModalMsg = msg.a;
				var _v3 = model.jU;
				if (!_v3.$) {
					var importModal = _v3.a;
					var importModalResult = A3($author$project$Components$Admin$PaymentMethodImport$ImportModal$update, model.Gv, importModalMsg, importModal);
					var _v4 = function () {
						var _v5 = importModalResult.agZ;
						switch (_v5) {
							case 0:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(importModalResult.aiO),
									model.cN,
									$elm$core$Platform$Cmd$none);
							case 1:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.cN, $elm$core$Platform$Cmd$none);
							default:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Api$Data$Loading,
									A2($author$project$Pages$Admin$PaymentMethodImport$retrievePaymentMethodMigrations, model.Gv, model));
						}
					}();
					var newImportModal = _v4.a;
					var paymentMethodImports = _v4.b;
					var paymentMethodImportsCmd = _v4.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jU: newImportModal, cN: paymentMethodImports}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$PaymentMethodImport$ImportModalMsg, importModalResult.GZ),
									paymentMethodImportsCmd
								])),
						importModalResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				var paymentMethodMigration = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ey: $elm$core$Maybe$Just(
								_Utils_Tuple2(paymentMethodMigration, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 6:
				var paymentMethodMigration = msg.a;
				var confirmed = msg.b;
				if (confirmed) {
					var id = $author$project$Api$Provider$PaymentMethodMigration$All$id(paymentMethodMigration);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ey: $elm$core$Maybe$Just(
									_Utils_Tuple2(paymentMethodMigration, $author$project$Api$Data$Loading))
							}),
						A3(
							$author$project$Api$Provider$PaymentMethodImport$ignore,
							model.Gv,
							id,
							$author$project$Pages$Admin$PaymentMethodImport$GotIgnoreResponse(paymentMethodMigration)),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ey: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 7:
				var paymentMethodMigration = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ey: $elm$core$Maybe$Nothing, cN: $author$project$Api$Data$Loading}),
						A2($author$project$Pages$Admin$PaymentMethodImport$retrievePaymentMethodMigrations, model.Gv, model),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Payment method was successfully ignored.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ey: $elm$core$Maybe$Just(
									_Utils_Tuple2(paymentMethodMigration, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 8:
				var subMsg = msg.a;
				var _v7 = A2($author$project$Ui$Dropdown$update, subMsg, model.qn);
				var dropdown = _v7.a;
				var dropdownCmd = _v7.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qn: dropdown}),
					dropdownCmd,
					_List_Nil);
			case 9:
				var status = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ajJ: $author$project$Api$Pagination$reset(model.ajJ),
						cN: $author$project$Api$Data$Loading,
						alH: status
					});
				return _Utils_Tuple3(
					newModel,
					A2($author$project$Pages$Admin$PaymentMethodImport$retrievePaymentMethodMigrations, model.Gv, newModel),
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v8 = A3($author$project$Components$ExportCsv$update, model.Gv, subMsg, model.nD);
				var exportCsv = _v8.a;
				var subCmd = _v8.b;
				var subOutMsgs = _v8.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nD: exportCsv}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$PaymentMethodImport$ExportCsvMsg, subCmd),
					subOutMsgs);
		}
	});
var $author$project$Pages$Admin$PaymentMethodImport$PaginationMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$PaymentMethodImport$SortTable = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$PaymentMethodImport$paymentMethodImportsColumns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, '', false, 'Status'),
		A3($author$project$Api$Column$init, '', false, 'Owner'),
		A3($author$project$Api$Column$init, '', false, 'Source Processor'),
		A3($author$project$Api$Column$init, '', false, 'Migration ID'),
		A3($author$project$Api$Column$init, '', false, 'Source Customer ID'),
		A3($author$project$Api$Column$init, '', false, 'Source Payment Method ID'),
		A3($author$project$Api$Column$init, '', false, 'Description'),
		A3($author$project$Api$Column$init, '', false, 'Metadata')
	]);
var $author$project$Components$ExportCsv$Report = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$ExportCsv$report = $author$project$Components$ExportCsv$Report;
var $author$project$Api$Data$totalCount = function (data) {
	if (data.$ === 3) {
		var headers = data.b;
		return A2(
			$elm$core$Maybe$andThen,
			$elm$core$String$toInt,
			A2($elm$core$Dict$get, 'x-total-count', headers));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$CompanyOwnerType = 0;
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$FormUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$Import = {$: 2};
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$ImportAllForOwner = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$PaymentMethodMigration$Shared$sourceCustomerId = function (_v0) {
	var record = _v0;
	return record.abL;
};
var $author$project$Api$Provider$PaymentMethodMigration$One$sourceCustomerId = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PaymentMethodMigration$Shared$sourceCustomerId(shared);
};
var $author$project$Api$Provider$PaymentMethodMigration$All$sourceCustomerId = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$PaymentMethodMigration$One$sourceCustomerId(one);
};
var $author$project$Api$Provider$PaymentMethodMigration$Shared$sourcePaymentMethodId = function (_v0) {
	var record = _v0;
	return record.abM;
};
var $author$project$Api$Provider$PaymentMethodMigration$One$sourcePaymentMethodId = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PaymentMethodMigration$Shared$sourcePaymentMethodId(shared);
};
var $author$project$Api$Provider$PaymentMethodMigration$All$sourcePaymentMethodId = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$PaymentMethodMigration$One$sourcePaymentMethodId(one);
};
var $author$project$Components$ResourceFilter$Company$view = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$view,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.Jy),
					options),
				model.b8));
	});
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$viewCompanyResourceFilter = F2(
	function (companyResourceFilter, form) {
		return A2(
			$elm$html$Html$map,
			$author$project$Components$Admin$PaymentMethodImport$ImportModal$CompanyResourceFilterMsg,
			A2(
				$author$project$Components$ResourceFilter$Company$view,
				_List_fromArray(
					[
						$author$project$Components$ResourceFilter$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
						$author$project$Components$ResourceFilter$errors(
						A2($author$project$Utils$Form$validationErrors, 0, form))
					]),
				companyResourceFilter));
	});
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$OwnerType = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$viewOwnerTypeButton = F3(
	function (currentOwnerType, ownerType, label) {
		return A3(
			$author$project$Ui$Button$view,
			{mm: 'Select owner type ' + label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(currentOwnerType, ownerType)),
					$author$project$Ui$Button$onClick(
					$author$project$Components$Admin$PaymentMethodImport$ImportModal$FormUpdated(
						$author$project$Components$Admin$PaymentMethodImport$ImportModal$OwnerType(ownerType)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Components$ResourceFilter$Patient$view = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$view,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.Jy),
					options),
				model.b8));
	});
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$viewPatientResourceFilter = F2(
	function (patientResourceFilter, form) {
		return A2(
			$elm$html$Html$map,
			$author$project$Components$Admin$PaymentMethodImport$ImportModal$PatientResourceFilterMsg,
			A2(
				$author$project$Components$ResourceFilter$Patient$view,
				_List_fromArray(
					[
						$author$project$Components$ResourceFilter$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
						$author$project$Components$ResourceFilter$errors(
						A2($author$project$Utils$Form$validationErrors, 1, form))
					]),
				patientResourceFilter));
	});
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$view = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.SD);
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Admin$PaymentMethodImport$ImportModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Typography$headingSm(
						_List_fromArray(
							[
								$elm$html$Html$text('Import Payment Method '),
								$elm$html$Html$text(
								A2(
									$elm$core$Maybe$withDefault,
									'N/A',
									$author$project$Api$Provider$PaymentMethodMigration$All$sourcePaymentMethodId(model.tJ)))
							]))
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$onSubmit($author$project$Components$Admin$PaymentMethodImport$ImportModal$Import)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Owner Type'),
										$author$project$Ui$Form$Group$labelSpan(3),
										$author$project$Ui$Form$Group$inputSpan(9)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Button$group(
										_List_fromArray(
											[
												A3($author$project$Components$Admin$PaymentMethodImport$ImportModal$viewOwnerTypeButton, fields.eN, 1, 'Patient'),
												A3($author$project$Components$Admin$PaymentMethodImport$ImportModal$viewOwnerTypeButton, fields.eN, 0, 'Employer')
											]))
									])),
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Owner'),
										$author$project$Ui$Form$Group$labelSpan(3),
										$author$project$Ui$Form$Group$inputSpan(9),
										$author$project$Ui$Form$Group$required(true)
									]),
								_List_fromArray(
									[
										function () {
										var _v1 = fields.eN;
										if (_v1 === 1) {
											return A2($author$project$Components$Admin$PaymentMethodImport$ImportModal$viewPatientResourceFilter, model.oY, model.SD);
										} else {
											return A2($author$project$Components$Admin$PaymentMethodImport$ImportModal$viewCompanyResourceFilter, model.mZ, model.SD);
										}
									}()
									])),
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$labelSpan(3),
										$author$project$Ui$Form$Group$inputSpan(9),
										$author$project$Ui$Form$Group$label('')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Checkbox$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Checkbox$value(fields.TS),
												$author$project$Ui$Form$Checkbox$onCheck(
												A2($elm$core$Basics$composeL, $author$project$Components$Admin$PaymentMethodImport$ImportModal$FormUpdated, $author$project$Components$Admin$PaymentMethodImport$ImportModal$ImportAllForOwner))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Apply same owner for all '),
												$elm$html$Html$text(
												A2(
													$elm$core$Maybe$withDefault,
													'N/A',
													$author$project$Api$Provider$PaymentMethodMigration$All$sourceCustomerId(model.tJ)))
											]))
									]))
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$span(6)
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Cancel action'},
										_List_fromArray(
											[
												$author$project$Ui$Button$fullWidth(true),
												$author$project$Ui$Button$onClick($author$project$Components$Admin$PaymentMethodImport$ImportModal$Close)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cancel')
											]))
									])),
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$span(6)
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Import payment method'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$onClick($author$project$Components$Admin$PaymentMethodImport$ImportModal$Import),
												$author$project$Ui$Button$icon($author$project$Ui$Icon$add),
												$author$project$Ui$Button$loading(
												_Utils_eq(model.nX, $author$project$Api$Data$Loading))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Import')
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Admin$PaymentMethodImport$Ignore = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$PaymentMethodImport$Import = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$PaymentMethodMigration$Shared$description = function (_v0) {
	var record = _v0;
	return record.Qr;
};
var $author$project$Api$Provider$PaymentMethodMigration$One$description = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PaymentMethodMigration$Shared$description(shared);
};
var $author$project$Api$Provider$PaymentMethodMigration$All$description = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$PaymentMethodMigration$One$description(one);
};
var $author$project$Api$Common$Payable$Owner$Min$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$PaymentMethodMigration$One$metadata = function (_v0) {
	var record = _v0.b;
	return record.W5;
};
var $author$project$Api$Provider$PaymentMethodMigration$All$metadata = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$PaymentMethodMigration$One$metadata(one);
};
var $author$project$Api$Provider$PaymentMethodMigration$Shared$migrationId = function (_v0) {
	var record = _v0;
	return record.W8;
};
var $author$project$Api$Provider$PaymentMethodMigration$One$migrationId = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PaymentMethodMigration$Shared$migrationId(shared);
};
var $author$project$Api$Provider$PaymentMethodMigration$All$migrationId = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$PaymentMethodMigration$One$migrationId(one);
};
var $author$project$Api$Common$Payable$Owner$Min$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$PaymentMethodMigration$One$owner = function (_v0) {
	var record = _v0.b;
	return record.YD;
};
var $author$project$Api$Provider$PaymentMethodMigration$All$owner = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$PaymentMethodMigration$One$owner(one);
};
var $the_sett$elm_pretty_printer$Pretty$Text = function (a) {
	return {$: 3, a: a};
};
var $the_sett$elm_pretty_printer$Pretty$string = $the_sett$elm_pretty_printer$Pretty$Text;
var $ThinkAlexandria$elm_pretty_print_json$Json$Print$boolToDoc = function (bool) {
	return bool ? $the_sett$elm_pretty_printer$Pretty$string('true') : $the_sett$elm_pretty_printer$Pretty$string('false');
};
var $the_sett$elm_pretty_printer$Pretty$Concatenate = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $the_sett$elm_pretty_printer$Pretty$append = F2(
	function (doc1, doc2) {
		return A2(
			$the_sett$elm_pretty_printer$Pretty$Concatenate,
			function (_v0) {
				return doc1;
			},
			function (_v1) {
				return doc2;
			});
	});
var $the_sett$elm_pretty_printer$Pretty$char = function (c) {
	return $the_sett$elm_pretty_printer$Pretty$Text(
		$elm$core$String$fromChar(c));
};
var $the_sett$elm_pretty_printer$Pretty$Line = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $the_sett$elm_pretty_printer$Pretty$line = A2($the_sett$elm_pretty_printer$Pretty$Line, ' ', '');
var $ThinkAlexandria$elm_pretty_print_json$Json$Print$closeBracket = A2(
	$the_sett$elm_pretty_printer$Pretty$append,
	$the_sett$elm_pretty_printer$Pretty$line,
	$the_sett$elm_pretty_printer$Pretty$char(']'));
var $ThinkAlexandria$elm_pretty_print_json$Json$Print$commaLine = A2(
	$the_sett$elm_pretty_printer$Pretty$append,
	$the_sett$elm_pretty_printer$Pretty$char(','),
	$the_sett$elm_pretty_printer$Pretty$line);
var $the_sett$elm_pretty_printer$Pretty$Empty = {$: 0};
var $the_sett$elm_pretty_printer$Pretty$empty = $the_sett$elm_pretty_printer$Pretty$Empty;
var $the_sett$elm_pretty_printer$Pretty$join = F2(
	function (sep, docs) {
		join:
		while (true) {
			if (!docs.b) {
				return $the_sett$elm_pretty_printer$Pretty$empty;
			} else {
				if (!docs.a.$) {
					var _v1 = docs.a;
					var ds = docs.b;
					var $temp$sep = sep,
						$temp$docs = ds;
					sep = $temp$sep;
					docs = $temp$docs;
					continue join;
				} else {
					var d = docs.a;
					var ds = docs.b;
					var step = F2(
						function (x, rest) {
							if (!x.$) {
								return rest;
							} else {
								var doc = x;
								return A2(
									$the_sett$elm_pretty_printer$Pretty$append,
									sep,
									A2($the_sett$elm_pretty_printer$Pretty$append, doc, rest));
							}
						});
					var spersed = A3($elm$core$List$foldr, step, $the_sett$elm_pretty_printer$Pretty$empty, ds);
					return A2($the_sett$elm_pretty_printer$Pretty$append, d, spersed);
				}
			}
		}
	});
var $the_sett$elm_pretty_printer$Pretty$Nest = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $the_sett$elm_pretty_printer$Pretty$nest = F2(
	function (depth, doc) {
		return A2(
			$the_sett$elm_pretty_printer$Pretty$Nest,
			depth,
			function (_v0) {
				return doc;
			});
	});
var $ThinkAlexandria$elm_pretty_print_json$Json$Print$openBracket = A2(
	$the_sett$elm_pretty_printer$Pretty$append,
	$the_sett$elm_pretty_printer$Pretty$char('['),
	$the_sett$elm_pretty_printer$Pretty$line);
var $ThinkAlexandria$elm_pretty_print_json$Json$Print$listToDoc = F2(
	function (indent, list) {
		return $elm$core$List$isEmpty(list) ? $the_sett$elm_pretty_printer$Pretty$string('[]') : A2(
			$the_sett$elm_pretty_printer$Pretty$append,
			A2(
				$the_sett$elm_pretty_printer$Pretty$nest,
				indent,
				A2(
					$the_sett$elm_pretty_printer$Pretty$append,
					$ThinkAlexandria$elm_pretty_print_json$Json$Print$openBracket,
					A2($the_sett$elm_pretty_printer$Pretty$join, $ThinkAlexandria$elm_pretty_print_json$Json$Print$commaLine, list))),
			$ThinkAlexandria$elm_pretty_print_json$Json$Print$closeBracket);
	});
var $ThinkAlexandria$elm_pretty_print_json$Json$Print$nullToDoc = function (maybeDoc) {
	if (!maybeDoc.$) {
		var doc = maybeDoc.a;
		return doc;
	} else {
		return $the_sett$elm_pretty_printer$Pretty$string('null');
	}
};
var $ThinkAlexandria$elm_pretty_print_json$Json$Print$numberToDoc = function (num) {
	return $the_sett$elm_pretty_printer$Pretty$string(
		$elm$core$String$fromFloat(num));
};
var $ThinkAlexandria$elm_pretty_print_json$Json$Print$closeBrace = A2(
	$the_sett$elm_pretty_printer$Pretty$append,
	$the_sett$elm_pretty_printer$Pretty$line,
	$the_sett$elm_pretty_printer$Pretty$char('}'));
var $the_sett$elm_pretty_printer$Pretty$space = $the_sett$elm_pretty_printer$Pretty$char(' ');
var $ThinkAlexandria$elm_pretty_print_json$Json$Print$colonSpace = A2(
	$the_sett$elm_pretty_printer$Pretty$append,
	$the_sett$elm_pretty_printer$Pretty$char(':'),
	$the_sett$elm_pretty_printer$Pretty$space);
var $ThinkAlexandria$elm_pretty_print_json$Json$Print$openBrace = A2(
	$the_sett$elm_pretty_printer$Pretty$append,
	$the_sett$elm_pretty_printer$Pretty$char('{'),
	$the_sett$elm_pretty_printer$Pretty$line);
var $the_sett$elm_pretty_printer$Pretty$surround = F3(
	function (left, right, doc) {
		return A2(
			$the_sett$elm_pretty_printer$Pretty$append,
			A2($the_sett$elm_pretty_printer$Pretty$append, left, doc),
			right);
	});
var $ThinkAlexandria$elm_pretty_print_json$Json$Print$stringToDoc = function (s) {
	return A3(
		$the_sett$elm_pretty_printer$Pretty$surround,
		$the_sett$elm_pretty_printer$Pretty$char('\"'),
		$the_sett$elm_pretty_printer$Pretty$char('\"'),
		$the_sett$elm_pretty_printer$Pretty$string(s));
};
var $ThinkAlexandria$elm_pretty_print_json$Json$Print$objectToDoc = F2(
	function (indent, pairs) {
		return $elm$core$List$isEmpty(pairs) ? $the_sett$elm_pretty_printer$Pretty$string('{}') : A2(
			$the_sett$elm_pretty_printer$Pretty$append,
			A2(
				$the_sett$elm_pretty_printer$Pretty$nest,
				indent,
				A2(
					$the_sett$elm_pretty_printer$Pretty$append,
					$ThinkAlexandria$elm_pretty_print_json$Json$Print$openBrace,
					A2(
						$the_sett$elm_pretty_printer$Pretty$join,
						A2(
							$the_sett$elm_pretty_printer$Pretty$append,
							$the_sett$elm_pretty_printer$Pretty$char(','),
							$the_sett$elm_pretty_printer$Pretty$line),
						A2(
							$elm$core$List$map,
							function (_v0) {
								var key = _v0.a;
								var doc = _v0.b;
								return A2(
									$the_sett$elm_pretty_printer$Pretty$append,
									$ThinkAlexandria$elm_pretty_print_json$Json$Print$stringToDoc(key),
									A2($the_sett$elm_pretty_printer$Pretty$append, $ThinkAlexandria$elm_pretty_print_json$Json$Print$colonSpace, doc));
							},
							pairs)))),
			$ThinkAlexandria$elm_pretty_print_json$Json$Print$closeBrace);
	});
var $ThinkAlexandria$elm_pretty_print_json$Json$Print$decodeDoc = function (indent) {
	return A2(
		$elm$json$Json$Decode$map,
		$ThinkAlexandria$elm_pretty_print_json$Json$Print$nullToDoc,
		$elm$json$Json$Decode$maybe(
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2($elm$json$Json$Decode$map, $ThinkAlexandria$elm_pretty_print_json$Json$Print$stringToDoc, $elm$json$Json$Decode$string),
						A2($elm$json$Json$Decode$map, $ThinkAlexandria$elm_pretty_print_json$Json$Print$numberToDoc, $elm$json$Json$Decode$float),
						A2($elm$json$Json$Decode$map, $ThinkAlexandria$elm_pretty_print_json$Json$Print$boolToDoc, $elm$json$Json$Decode$bool),
						A2(
						$elm$json$Json$Decode$map,
						$ThinkAlexandria$elm_pretty_print_json$Json$Print$listToDoc(indent),
						$elm$json$Json$Decode$lazy(
							function (_v0) {
								return $elm$json$Json$Decode$list(
									$ThinkAlexandria$elm_pretty_print_json$Json$Print$decodeDoc(indent));
							})),
						A2(
						$elm$json$Json$Decode$map,
						$ThinkAlexandria$elm_pretty_print_json$Json$Print$objectToDoc(indent),
						$elm$json$Json$Decode$lazy(
							function (_v1) {
								return $elm$json$Json$Decode$keyValuePairs(
									$ThinkAlexandria$elm_pretty_print_json$Json$Print$decodeDoc(indent));
							}))
					]))));
};
var $the_sett$elm_pretty_printer$Pretty$NLine = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $the_sett$elm_pretty_printer$Pretty$NNil = {$: 0};
var $the_sett$elm_pretty_printer$Pretty$NText = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $the_sett$elm_pretty_printer$Pretty$fits = F2(
	function (w, normal) {
		fits:
		while (true) {
			if (w < 0) {
				return false;
			} else {
				switch (normal.$) {
					case 0:
						return true;
					case 1:
						var text = normal.a;
						var innerNormal = normal.b;
						var $temp$w = w - $elm$core$String$length(text),
							$temp$normal = innerNormal(0);
						w = $temp$w;
						normal = $temp$normal;
						continue fits;
					default:
						return true;
				}
			}
		}
	});
var $the_sett$elm_pretty_printer$Pretty$better = F4(
	function (w, k, doc, doc2Fn) {
		return A2($the_sett$elm_pretty_printer$Pretty$fits, w - k, doc) ? doc : doc2Fn(0);
	});
var $the_sett$elm_pretty_printer$Pretty$best = F3(
	function (width, startCol, x) {
		var be = F3(
			function (w, k, docs) {
				be:
				while (true) {
					if (!docs.b) {
						return $the_sett$elm_pretty_printer$Pretty$NNil;
					} else {
						switch (docs.a.b.$) {
							case 0:
								var _v1 = docs.a;
								var i = _v1.a;
								var _v2 = _v1.b;
								var ds = docs.b;
								var $temp$w = w,
									$temp$k = k,
									$temp$docs = ds;
								w = $temp$w;
								k = $temp$k;
								docs = $temp$docs;
								continue be;
							case 1:
								var _v3 = docs.a;
								var i = _v3.a;
								var _v4 = _v3.b;
								var doc = _v4.a;
								var doc2 = _v4.b;
								var ds = docs.b;
								var $temp$w = w,
									$temp$k = k,
									$temp$docs = A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										i,
										doc(0)),
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(
											i,
											doc2(0)),
										ds));
								w = $temp$w;
								k = $temp$k;
								docs = $temp$docs;
								continue be;
							case 2:
								var _v5 = docs.a;
								var i = _v5.a;
								var _v6 = _v5.b;
								var j = _v6.a;
								var doc = _v6.b;
								var ds = docs.b;
								var $temp$w = w,
									$temp$k = k,
									$temp$docs = A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										i + j,
										doc(0)),
									ds);
								w = $temp$w;
								k = $temp$k;
								docs = $temp$docs;
								continue be;
							case 3:
								var _v7 = docs.a;
								var i = _v7.a;
								var text = _v7.b.a;
								var ds = docs.b;
								return A2(
									$the_sett$elm_pretty_printer$Pretty$NText,
									text,
									function (_v8) {
										return A3(
											be,
											w,
											k + $elm$core$String$length(text),
											ds);
									});
							case 4:
								var _v9 = docs.a;
								var i = _v9.a;
								var _v10 = _v9.b;
								var vsep = _v10.b;
								var ds = docs.b;
								return A3(
									$the_sett$elm_pretty_printer$Pretty$NLine,
									i,
									vsep,
									function (_v11) {
										return A3(
											be,
											w,
											i + $elm$core$String$length(vsep),
											ds);
									});
							case 5:
								var _v12 = docs.a;
								var i = _v12.a;
								var _v13 = _v12.b;
								var doc = _v13.a;
								var doc2 = _v13.b;
								var ds = docs.b;
								return A4(
									$the_sett$elm_pretty_printer$Pretty$better,
									w,
									k,
									A3(
										be,
										w,
										k,
										A2(
											$elm$core$List$cons,
											_Utils_Tuple2(i, doc),
											ds)),
									function (_v14) {
										return A3(
											be,
											w,
											k,
											A2(
												$elm$core$List$cons,
												_Utils_Tuple2(i, doc2),
												ds));
									});
							case 6:
								var _v15 = docs.a;
								var i = _v15.a;
								var fn = _v15.b.a;
								var ds = docs.b;
								var $temp$w = w,
									$temp$k = k,
									$temp$docs = A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										i,
										fn(i)),
									ds);
								w = $temp$w;
								k = $temp$k;
								docs = $temp$docs;
								continue be;
							default:
								var _v16 = docs.a;
								var i = _v16.a;
								var fn = _v16.b.a;
								var ds = docs.b;
								var $temp$w = w,
									$temp$k = k,
									$temp$docs = A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										i,
										fn(k)),
									ds);
								w = $temp$w;
								k = $temp$k;
								docs = $temp$docs;
								continue be;
						}
					}
				}
			});
		return A3(
			be,
			width,
			startCol,
			_List_fromArray(
				[
					_Utils_Tuple2(0, x)
				]));
	});
var $the_sett$elm_pretty_printer$Pretty$copy = F2(
	function (i, s) {
		return (!i) ? '' : _Utils_ap(
			s,
			A2($the_sett$elm_pretty_printer$Pretty$copy, i - 1, s));
	});
var $the_sett$elm_pretty_printer$Pretty$layout = function (normal) {
	var layoutInner = F2(
		function (normal2, acc) {
			layoutInner:
			while (true) {
				switch (normal2.$) {
					case 0:
						return acc;
					case 1:
						var text = normal2.a;
						var innerNormal = normal2.b;
						var $temp$normal2 = innerNormal(0),
							$temp$acc = A2($elm$core$List$cons, text, acc);
						normal2 = $temp$normal2;
						acc = $temp$acc;
						continue layoutInner;
					default:
						var i = normal2.a;
						var sep = normal2.b;
						var innerNormal = normal2.c;
						var norm = innerNormal(0);
						if (norm.$ === 2) {
							var $temp$normal2 = innerNormal(0),
								$temp$acc = A2($elm$core$List$cons, '\n' + sep, acc);
							normal2 = $temp$normal2;
							acc = $temp$acc;
							continue layoutInner;
						} else {
							var $temp$normal2 = innerNormal(0),
								$temp$acc = A2(
								$elm$core$List$cons,
								'\n' + (A2($the_sett$elm_pretty_printer$Pretty$copy, i, ' ') + sep),
								acc);
							normal2 = $temp$normal2;
							acc = $temp$acc;
							continue layoutInner;
						}
				}
			}
		});
	return $elm$core$String$concat(
		$elm$core$List$reverse(
			A2(layoutInner, normal, _List_Nil)));
};
var $the_sett$elm_pretty_printer$Pretty$pretty = F2(
	function (w, doc) {
		return $the_sett$elm_pretty_printer$Pretty$layout(
			A3($the_sett$elm_pretty_printer$Pretty$best, w, 0, doc));
	});
var $ThinkAlexandria$elm_pretty_print_json$Json$Print$prettyValue = F2(
	function (_v0, json) {
		var columns = _v0.N3;
		var indent = _v0.ahY;
		return A2(
			$elm$core$Result$mapError,
			$elm$json$Json$Decode$errorToString,
			A2(
				$elm$core$Result$map,
				$the_sett$elm_pretty_printer$Pretty$pretty(columns),
				A2(
					$elm$json$Json$Decode$decodeValue,
					$ThinkAlexandria$elm_pretty_print_json$Json$Print$decodeDoc(indent),
					json)));
	});
var $author$project$Api$Provider$PaymentMethodMigration$Shared$sourceProcessor = function (_v0) {
	var record = _v0;
	return record.abN;
};
var $author$project$Api$Provider$PaymentMethodMigration$One$sourceProcessor = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PaymentMethodMigration$Shared$sourceProcessor(shared);
};
var $author$project$Api$Provider$PaymentMethodMigration$All$sourceProcessor = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$PaymentMethodMigration$One$sourceProcessor(one);
};
var $author$project$Api$Provider$PaymentMethodMigration$Shared$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Api$Provider$PaymentMethodMigration$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PaymentMethodMigration$Shared$status(shared);
};
var $author$project$Api$Provider$PaymentMethodMigration$All$status = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$PaymentMethodMigration$One$status(one);
};
var $author$project$Api$Common$Payable$Owner$Min$type_ = function (_v0) {
	var record = _v0;
	return record.amg;
};
var $author$project$Pages$Admin$PaymentMethodImport$viewPaymentMethodImport = F3(
	function (canGoToPatients, canGoToCompany, paymentMethodMigration) {
		var owner = $author$project$Api$Provider$PaymentMethodMigration$All$owner(paymentMethodMigration);
		var ownerName = A2(
			$elm$core$Maybe$withDefault,
			'N/A',
			A2($elm$core$Maybe$map, $author$project$Api$Common$Payable$Owner$Min$name, owner));
		var ownerPath = A2(
			$elm$core$Maybe$andThen,
			function (owner_) {
				var _v1 = $author$project$Api$Common$Payable$Owner$Min$type_(owner_);
				switch (_v1) {
					case 'Patient':
						return canGoToPatients ? $elm$core$Maybe$Just(
							$author$project$Spa$Generated$Route$Patients__PatientId_String__Accounts__Top(
								{
									YZ: $author$project$Api$Common$Payable$Owner$Min$id(owner_)
								})) : $elm$core$Maybe$Nothing;
					case 'Company':
						return canGoToCompany ? $elm$core$Maybe$Just(
							$author$project$Spa$Generated$Route$Companies__CompanyId_String__PaymentSources(
								{
									fZ: $author$project$Api$Common$Payable$Owner$Min$id(owner_)
								})) : $elm$core$Maybe$Nothing;
					default:
						return $elm$core$Maybe$Nothing;
				}
			},
			owner);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Badge$fromString,
							_List_Nil,
							$author$project$Api$Provider$PaymentMethodMigration$All$status(paymentMethodMigration))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							if (!ownerPath.$) {
								var ownerPath_ = ownerPath.a;
								return A3(
									$author$project$Ui$Link$route,
									ownerPath_,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(ownerName)
										]));
							} else {
								return $elm$html$Html$text(ownerName);
							}
						}()
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$PaymentMethodMigration$All$sourceProcessor(paymentMethodMigration))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'N/A',
								$author$project$Api$Provider$PaymentMethodMigration$All$migrationId(paymentMethodMigration)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'N/A',
								$author$project$Api$Provider$PaymentMethodMigration$All$sourceCustomerId(paymentMethodMigration)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'N/A',
								$author$project$Api$Provider$PaymentMethodMigration$All$sourcePaymentMethodId(paymentMethodMigration)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'N/A',
								$author$project$Api$Provider$PaymentMethodMigration$All$description(paymentMethodMigration)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$pre,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'max-width', '400px'),
									A2($elm$html$Html$Attributes$style, 'max-height', '100px')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Result$withDefault,
										'',
										A2(
											$ThinkAlexandria$elm_pretty_print_json$Json$Print$prettyValue,
											{N3: 10, ahY: 2},
											$author$project$Api$Provider$PaymentMethodMigration$All$metadata(paymentMethodMigration))))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									(($author$project$Api$Provider$PaymentMethodMigration$All$status(paymentMethodMigration) === 'missing_in_hint') || ($author$project$Api$Provider$PaymentMethodMigration$All$status(paymentMethodMigration) === 'ignored')) ? A3(
									$author$project$Ui$Button$view,
									{mm: 'Import payment method'},
									_List_fromArray(
										[
											$author$project$Ui$Button$primary,
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Admin$PaymentMethodImport$Import(paymentMethodMigration)),
											$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Import')
										])) : $author$project$Utils$Html$empty,
									($author$project$Api$Provider$PaymentMethodMigration$All$status(paymentMethodMigration) === 'missing_in_hint') ? A3(
									$author$project$Ui$Button$view,
									{mm: 'Ignore payment method'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Admin$PaymentMethodImport$Ignore(paymentMethodMigration)),
											$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Ignore')
										])) : $author$project$Utils$Html$empty
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$PaymentMethodImport$All = 0;
var $author$project$Pages$Admin$PaymentMethodImport$Ignored = 3;
var $author$project$Pages$Admin$PaymentMethodImport$Imported = 2;
var $author$project$Pages$Admin$PaymentMethodImport$StatusFiltered = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Admin$PaymentMethodImport$statusOptionToLabel = function (option) {
	switch (option) {
		case 1:
			return 'Pending';
		case 2:
			return 'Imported';
		case 3:
			return 'Ignored';
		default:
			return 'All';
	}
};
var $author$project$Pages$Admin$PaymentMethodImport$statusDropdownOptions = function (currentStatusOption) {
	var statusOptionToItem = function (option) {
		return A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(currentStatusOption, option)),
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Pages$Admin$PaymentMethodImport$StatusFiltered(option))
				]),
			$elm$html$Html$text(
				$author$project$Pages$Admin$PaymentMethodImport$statusOptionToLabel(option)));
	};
	return A2(
		$elm$core$List$cons,
		statusOptionToItem(0),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$Dropdown$separator,
			A2(
				$elm$core$List$map,
				statusOptionToItem,
				_List_fromArray(
					[1, 2, 3]))));
};
var $author$project$Pages$Admin$PaymentMethodImport$viewStatusDropdown = function (model) {
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Pages$Admin$PaymentMethodImport$statusOptionToLabel(model.alH))
			]),
		$author$project$Pages$Admin$PaymentMethodImport$statusDropdownOptions(model.alH),
		model.qn);
};
var $author$project$Pages$Admin$PaymentMethodImport$viewBody = function (model) {
	var _v0 = function () {
		var _v1 = model.cN;
		if (_v1.$ === 3) {
			var paymentMethodImports_ = _v1.a;
			return _Utils_Tuple2(false, paymentMethodImports_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var paymentMethodImports = _v0.b;
	return _List_fromArray(
		[
			function () {
			var _v2 = model.jU;
			if (!_v2.$) {
				var importModal = _v2.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$Admin$PaymentMethodImport$ImportModalMsg,
					$author$project$Components$Admin$PaymentMethodImport$ImportModal$view(importModal));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			function () {
			var _v3 = model.ey;
			if (!_v3.$) {
				var _v4 = _v3.a;
				var paymentMethodMigration = _v4.a;
				var ignoreRequest = _v4.b;
				return A2(
					$author$project$Components$HiConfirm$modal,
					$author$project$Pages$Admin$PaymentMethodImport$IgnoreHiConfirmClosed(paymentMethodMigration),
					_List_fromArray(
						[
							$author$project$Components$HiConfirm$verb('ignore'),
							$author$project$Components$HiConfirm$noun('payment method migration'),
							$author$project$Components$HiConfirm$loading(
							_Utils_eq(ignoreRequest, $author$project$Api$Data$Loading)),
							$author$project$Components$HiConfirm$customMessage(
							_List_fromArray(
								[
									$elm$html$Html$text('You are about to ignore this payment method migration. You can review and import ignored payment methods later.')
								]))
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			A2(
			$elm$html$Html$map,
			$author$project$Pages$Admin$PaymentMethodImport$ExportCsvMsg,
			A3(
				$author$project$Components$ExportCsv$modal,
				model.Gv,
				_List_fromArray(
					[
						$author$project$Components$ExportCsv$report(
						$author$project$Api$Data$totalCount(model.cN))
					]),
				model.nD)),
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Panel$title(
							_List_fromArray(
								[
									$elm$html$Html$text('Payment Method Import')
								]))
						])),
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(4)
										]),
									_List_fromArray(
										[
											$author$project$Pages$Admin$PaymentMethodImport$viewStatusDropdown(model)
										]))
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A4(
							$author$project$Ui$Table$view,
							_List_fromArray(
								[
									$author$project$Ui$Table$loading(loading),
									$author$project$Ui$Table$zeroState(
									_List_fromArray(
										[
											$elm$html$Html$text('All payment methods are migrated to Hint Payments!')
										]))
								]),
							_Utils_ap(
								A2(
									$elm$core$List$map,
									$author$project$Api$Column$view(
										A2($author$project$Api$Column$Sortable, model.alA, $author$project$Pages$Admin$PaymentMethodImport$SortTable)),
									$author$project$Pages$Admin$PaymentMethodImport$paymentMethodImportsColumns),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Table$header,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$gap2]),
												_List_fromArray(
													[
														A2($elm$html$Html$map, $author$project$Pages$Admin$PaymentMethodImport$ExportCsvMsg, $author$project$Components$ExportCsv$button),
														A3(
														$author$project$Ui$Link$route,
														$author$project$Spa$Generated$Route$Admin__PaymentMethodImport__Upload,
														_List_fromArray(
															[
																$author$project$Ui$Link$icon($author$project$Ui$Icon$upload),
																$author$project$Ui$Link$ariaLabel('Import from CSV')
															]),
														_List_Nil)
													]))
											]))
									])),
							A2(
								$elm$core$List$map,
								A2($author$project$Pages$Admin$PaymentMethodImport$viewPaymentMethodImport, model.GQ, model.GP),
								paymentMethodImports),
							_List_Nil)
						])),
					A2(
					$author$project$Ui$Panel$footer,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Pages$Admin$PaymentMethodImport$PaginationMsg,
							A2(
								$author$project$Api$Pagination$view,
								_List_fromArray(
									[
										$author$project$Ui$Pagination$List$loading(loading)
									]),
								model.ajJ))
						]))
				]))
		]);
};
var $author$project$Pages$Admin$PaymentMethodImport$view = function (model) {
	return {
		fO: $author$project$Pages$Admin$PaymentMethodImport$viewBody(model),
		ac9: 'Admin | Payment Method Import'
	};
};
var $author$project$Pages$Admin$PaymentMethodImport$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$PaymentMethodImport$init, aiq: $author$project$Pages$Admin$PaymentMethodImport$load, k8: $author$project$Pages$Admin$PaymentMethodImport$save, alO: $author$project$Pages$Admin$PaymentMethodImport$subscriptions, adT: $author$project$Pages$Admin$PaymentMethodImport$update, amo: $author$project$Pages$Admin$PaymentMethodImport$view});
var $author$project$Api$Upload$Resource$PaymentMethodImport = 6;
var $author$project$Pages$Admin$PaymentMethodImport$Upload$UploadFormMsg = $elm$core$Basics$identity;
var $author$project$Pages$Admin$PaymentMethodImport$Upload$init = F4(
	function (_v0, _v1, shared, _v2) {
		var _v3 = A4($author$project$Components$Upload$Form$init, shared.J7, shared.Gv, 6, $elm$core$Maybe$Nothing);
		var uploadForm = _v3.a;
		var uploadFormCmd = _v3.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, SD: uploadForm},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, uploadFormCmd));
	});
var $author$project$Pages$Admin$PaymentMethodImport$Upload$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$PaymentMethodImport$Upload$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$PaymentMethodImport$Upload$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Upload$Form$subscriptions(model.SD));
};
var $author$project$Pages$Admin$PaymentMethodImport$Upload$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Upload$Form$update, model.Gv, subMsg, model.SD);
		var uploadForm = _v1.a;
		var subCmd = _v1.b;
		var subOutMsgs = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{SD: uploadForm}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsgs);
	});
var $author$project$Pages$Admin$PaymentMethodImport$Upload$viewBody = function (model) {
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_fromArray(
					[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
				_List_fromArray(
					[
						$author$project$Ui$Panel$title(
						_List_fromArray(
							[
								$elm$html$Html$text('Upload Payment Method Imports')
							])),
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Admin__PaymentMethodImport,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Icon$cross(_List_Nil)
							]))
					])),
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$elm$core$Basics$identity,
						A2($author$project$Components$Upload$Form$view, model.Gv, model.SD))
					])),
				A2(
				$author$project$Ui$Panel$footer,
				_List_fromArray(
					[$author$project$Ui$Element$justifyCenter]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Admin__PaymentMethodImport,
						_List_fromArray(
							[$author$project$Ui$Link$buttonDefault]),
						_List_fromArray(
							[
								$elm$html$Html$text('Back')
							]))
					]))
			]));
};
var $author$project$Pages$Admin$PaymentMethodImport$Upload$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				A2($author$project$Components$Upload$Form$modal, model.Gv, model.SD)),
				$author$project$Pages$Admin$PaymentMethodImport$Upload$viewBody(model)
			]),
		ac9: 'Admin | Payment Method Import'
	};
};
var $author$project$Pages$Admin$PaymentMethodImport$Upload$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$PaymentMethodImport$Upload$init, aiq: $author$project$Pages$Admin$PaymentMethodImport$Upload$load, k8: $author$project$Pages$Admin$PaymentMethodImport$Upload$save, alO: $author$project$Pages$Admin$PaymentMethodImport$Upload$subscriptions, adT: $author$project$Pages$Admin$PaymentMethodImport$Upload$update, amo: $author$project$Pages$Admin$PaymentMethodImport$Upload$view});
var $author$project$Pages$Admin$PaymentProcessing$PaymentProcessingMsg = $elm$core$Basics$identity;
var $author$project$Components$PaymentProcessing$CreateAccount = {$: 2};
var $author$project$Components$PaymentProcessing$GotRainforestAccount = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$PaymentProcessing$GotStripeOnboardingStatus = function (a) {
	return {$: 46, a: a};
};
var $author$project$Components$PaymentProcessing$Loading = {$: 0};
var $author$project$Components$PaymentProcessing$Model = $elm$core$Basics$identity;
var $author$project$Components$PaymentProcessing$StripeConnecting = {$: 3};
var $author$project$Api$Feature$StripeEmbeddedOnboarding = 26;
var $author$project$Api$Provider$Practice$Shared$hasStripeAccount = function (_v0) {
	var record = _v0;
	return record.Tl;
};
var $author$project$Api$Provider$Practice$One$hasStripeAccount = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$hasStripeAccount(shared);
};
var $author$project$Api$Provider$Practice$StripeAccount$OnboardingStatus = F4(
	function (detailsSubmitted, chargesEnabled, disabledReason, clientSecret) {
		return {afG: chargesEnabled, afI: clientSecret, agu: detailsSubmitted, agz: disabledReason};
	});
var $author$project$Api$Provider$Practice$StripeAccount$onboardingStatusDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Api$Provider$Practice$StripeAccount$OnboardingStatus,
	A2($elm$json$Json$Decode$field, 'details_submitted', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'charges_enabled', $elm$json$Json$Decode$bool),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'disabled_reason', $elm$json$Json$Decode$string)),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'client_secret', $elm$json$Json$Decode$string)));
var $author$project$Api$Provider$Practice$StripeAccount$onboardingStatus = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Practice$StripeAccount$onboardingStatusDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['onboarding_status']),
					$author$project$Api$Provider$Practice$StripeAccount$stripeAccountPath)));
	});
var $author$project$Api$Provider$RainforestAccount$One$RainforestAccount = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$RainforestAccount$Shared$RainforestAccount = $elm$core$Basics$identity;
var $author$project$Api$Provider$RainforestAccount$Shared$Record = function (status) {
	return {alH: status};
};
var $author$project$Api$Provider$RainforestAccount$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'status',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$RainforestAccount$Shared$Record));
var $author$project$Api$Provider$RainforestAccount$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$RainforestAccount$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$RainforestAccount$One$Record = function (merchantId) {
	return function (merchantApplicationId) {
		return function (merchantApplicationStatus) {
			return function (statementDescriptor) {
				return function (depositAccountLast4) {
					return function (depositAccountRoutingNumber) {
						return function (depositAccountBankName) {
							return function (depositAccountAccountType) {
								return function (platformTokenMigrationCompletedAt) {
									return function (depositFrequency) {
										return {Qn: depositAccountAccountType, Qo: depositAccountBankName, Qp: depositAccountLast4, Qq: depositAccountRoutingNumber, ags: depositFrequency, W$: merchantApplicationId, W0: merchantApplicationStatus, W1: merchantId, ZI: platformTokenMigrationCompletedAt, acc: statementDescriptor};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$RainforestAccount$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'deposit_frequency',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'platform_token_migration_completed_at',
		$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'deposit_account_account_type',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'deposit_account_bank_name',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'deposit_account_routing_number',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'deposit_account_last_4',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'statement_descriptor',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'merchant_application_status',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'merchant_application_id',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'merchant_id',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
										$elm$json$Json$Decode$succeed($author$project$Api$Provider$RainforestAccount$One$Record)))))))))));
var $author$project$Api$Provider$RainforestAccount$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$RainforestAccount$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$RainforestAccount$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$RainforestAccount$One$RainforestAccount)));
var $author$project$Api$Provider$Practice$RainforestAccount$rainforestAccountPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['rainforest_account']),
	$author$project$Api$Provider$Practice$practicePath);
var $author$project$Api$Provider$Practice$RainforestAccount$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$RainforestAccount$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$RainforestAccount$rainforestAccountPath));
	});
var $author$project$Components$PaymentProcessing$GotBankAccountsOnStripe = function (a) {
	return {$: 17, a: a};
};
var $author$project$Api$Provider$StripePaymentMethodMigration$All$StripePaymentMethodMigration = $elm$core$Basics$identity;
var $author$project$Api$Provider$StripePaymentMethodMigration$All$Record = function (id) {
	return function (type_) {
		return function (sourceBrand) {
			return function (lastFour) {
				return function (isDefault) {
					return function (lastUsedAt) {
						return function (requestPayInfoSentAt) {
							return function (owner) {
								return function (createdAt) {
									return function (label) {
										return function (name) {
											return function (expMonth) {
												return function (expYear) {
													return function (errorMessage) {
														return function (lastPaymentErrorMessage) {
															return function (zip) {
																return function (createdVia) {
																	return function (status) {
																		return function (createdByName) {
																			return function (funding) {
																				return function (paymentProcessor) {
																					return {O1: createdAt, O3: createdByName, O4: createdVia, RM: errorMessage, ag3: expMonth, ag4: expYear, SN: funding, ahP: id, UM: isDefault, aih: label, VG: lastFour, VI: lastPaymentErrorMessage, VO: lastUsedAt, Bq: name, YD: owner, Zd: paymentProcessor, $B: requestPayInfoSentAt, abK: sourceBrand, alH: status, amg: type_, vv: zip};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$StripePaymentMethodMigration$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'payment_processor',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'funding',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'created_by_name',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'status',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'created_via',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'zip',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'last_payment_error_message',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'error_message',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'exp_year',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'exp_month',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'name',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'label',
												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'created_at',
													$elm_community$json_extra$Json$Decode$Extra$datetime,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'owner',
														$elm$json$Json$Decode$nullable($author$project$Api$Common$Payable$Owner$Min$decoder),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'request_pay_info_sent_at',
															$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'last_used_at',
																$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'is_default',
																	$elm$json$Json$Decode$bool,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'last_four',
																		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'payment_method_brand',
																			$elm$json$Json$Decode$string,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'type',
																				$elm$json$Json$Decode$string,
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'id',
																					$elm$json$Json$Decode$string,
																					$elm$json$Json$Decode$succeed($author$project$Api$Provider$StripePaymentMethodMigration$All$Record))))))))))))))))))))));
var $author$project$Api$Provider$StripePaymentMethodMigration$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$StripePaymentMethodMigration$All$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$StripePaymentMethodMigration$listDefaults = {ajJ: $author$project$Api$Pagination$init, alA: $author$project$Api$Sort$init};
var $author$project$Api$Provider$StripePaymentMethodMigration$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$StripePaymentMethodMigration$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$Provider$StripePaymentMethodMigration$stripePaymentMethodMigrationsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['stripe_payment_method_migrations']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$StripePaymentMethodMigration$bankAccounts = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$StripePaymentMethodMigration$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$StripePaymentMethodMigration$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['bank_accounts']),
						$author$project$Api$Provider$StripePaymentMethodMigration$stripePaymentMethodMigrationsPath))));
	});
var $author$project$Components$PaymentProcessing$retrieveBankAccountsOnStripe = F2(
	function (apiClient, model) {
		var optionals = function (d) {
			return _Utils_update(
				d,
				{ajJ: model.fM, alA: model.mr});
		};
		return A3($author$project$Api$Provider$StripePaymentMethodMigration$bankAccounts, apiClient, optionals, $author$project$Components$PaymentProcessing$GotBankAccountsOnStripe);
	});
var $author$project$Components$PaymentProcessing$GotCardsOnStripe = function (a) {
	return {$: 16, a: a};
};
var $author$project$Api$Provider$StripePaymentMethodMigration$cards = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$StripePaymentMethodMigration$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$StripePaymentMethodMigration$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['cards']),
						$author$project$Api$Provider$StripePaymentMethodMigration$stripePaymentMethodMigrationsPath))));
	});
var $author$project$Components$PaymentProcessing$retrieveCardsOnStripe = F2(
	function (apiClient, model) {
		var optionals = function (d) {
			return _Utils_update(
				d,
				{ajJ: model.fT, alA: model.mG});
		};
		return A3($author$project$Api$Provider$StripePaymentMethodMigration$cards, apiClient, optionals, $author$project$Components$PaymentProcessing$GotCardsOnStripe);
	});
var $author$project$Components$PaymentProcessing$init = F5(
	function (session, practice, shared, _v0, _v1) {
		var isOnboarding = _v1.bb;
		var isStripeEmbedded = A2($author$project$Api$Provider$Practice$One$featureEnabled, 26, practice);
		var _v2 = isStripeEmbedded ? ($author$project$Api$Provider$Practice$One$hasStripeAccount(practice) ? _Utils_Tuple2(
			$author$project$Components$PaymentProcessing$StripeConnecting,
			A2($author$project$Api$Provider$Practice$StripeAccount$onboardingStatus, shared.Gv, $author$project$Components$PaymentProcessing$GotStripeOnboardingStatus)) : _Utils_Tuple2($author$project$Components$PaymentProcessing$CreateAccount, $elm$core$Platform$Cmd$none)) : _Utils_Tuple2(
			$author$project$Components$PaymentProcessing$Loading,
			A2($author$project$Api$Provider$Practice$RainforestAccount$retrieve, shared.Gv, $author$project$Components$PaymentProcessing$GotRainforestAccount));
		var initialStatus = _v2.a;
		var initialCmd = _v2.b;
		var model = {
			c0: $author$project$Api$Data$Loading,
			fM: $author$project$Api$Pagination$init,
			mr: A3($author$project$Api$Sort$withDefault, 'last_used_at', 1, $author$project$Api$Sort$init),
			GP: A3($author$project$Permission$canGoTo, session, shared.ahK, 18),
			GQ: A3($author$project$Permission$canGoTo, session, shared.ahK, 50),
			c7: $author$project$Api$Data$Loading,
			fT: $author$project$Api$Pagination$init,
			mG: A3($author$project$Api$Sort$withDefault, 'last_used_at', 1, $author$project$Api$Sort$init),
			d7: $elm$core$Maybe$Nothing,
			f7: $author$project$Api$Data$NotAsked,
			ek: $elm$core$Maybe$Nothing,
			nx: $author$project$Api$Data$NotAsked,
			nE: $author$project$Api$Data$NotAsked,
			sF: shared.sF,
			Ij: $author$project$Shared$isHintAdmin(shared),
			bb: isOnboarding,
			AX: false,
			kn: $elm$core$Maybe$Nothing,
			ZV: practice,
			cQ: $author$project$Api$Data$Loading,
			DH: $author$project$Rainforest$isSandbox(shared.t9),
			e2: $elm$core$Maybe$Nothing,
			e3: $elm$core$Maybe$Nothing,
			k_: $elm$core$Maybe$Nothing,
			pO: $author$project$Api$Data$NotAsked,
			aa4: session,
			Ey: $elm$core$Maybe$Nothing,
			uG: true,
			lr: $elm$core$Maybe$Nothing,
			alH: initialStatus,
			EP: false,
			EQ: $elm$core$Maybe$Nothing,
			hP: false,
			qr: $author$project$Api$Data$NotAsked,
			J7: shared.J7,
			qP: $author$project$Api$Data$NotAsked,
			ad0: $author$project$Api$Platform$Session$One$user(session)
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						initialCmd,
						A2($author$project$Components$PaymentProcessing$retrieveCardsOnStripe, shared.Gv, model),
						A2($author$project$Components$PaymentProcessing$retrieveBankAccountsOnStripe, shared.Gv, model)
					])));
	});
var $author$project$Pages$Admin$PaymentProcessing$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.DE;
		var _v1 = A5(
			$author$project$Components$PaymentProcessing$init,
			session,
			practice,
			shared,
			query,
			{bb: false});
		var paymentProcessing = _v1.a;
		var paymentProcessingCmd = _v1.b;
		return _Utils_Tuple2(
			{
				Gv: shared.Gv,
				Ij: $author$project$Shared$isHintAdmin(shared),
				o2: paymentProcessing
			},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, paymentProcessingCmd));
	});
var $author$project$Pages$Admin$PaymentProcessing$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					Ij: $author$project$Shared$isHintAdmin(shared)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$PaymentProcessing$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$PaymentProcessing$DeleteHiConfirmClosed = F3(
	function (a, b, c) {
		return {$: 22, a: a, b: b, c: c};
	});
var $author$project$Components$PaymentProcessing$MigrateBackToStripeModalMsg = function (a) {
	return {$: 41, a: a};
};
var $author$project$Components$PaymentProcessing$RequestPaymentInfoHiConfirmClosed = F3(
	function (a, b, c) {
		return {$: 24, a: a, b: b, c: c};
	});
var $author$project$Components$PaymentProcessing$ResetAccountModalMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$PaymentProcessing$SimulateApplicationEventModalMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$PaymentProcessing$StripeHiConfirmClosed = function (a) {
	return {$: 51, a: a};
};
var $author$project$Components$PaymentProcessing$StripeOnboardingExited = {$: 48};
var $author$project$Components$PaymentProcessing$StripeOnboardingStepChanged = {$: 49};
var $author$project$Ports$Stripe$stripePortOnboardingExited = _Platform_incomingPort(
	'stripePortOnboardingExited',
	$elm$json$Json$Decode$null(0));
var $author$project$Ports$Stripe$onOnboardingExited = function (msg) {
	return $author$project$Ports$Stripe$stripePortOnboardingExited(
		$elm$core$Basics$always(msg));
};
var $author$project$Ports$Stripe$stripePortOnboardingStepChanged = _Platform_incomingPort(
	'stripePortOnboardingStepChanged',
	$elm$json$Json$Decode$null(0));
var $author$project$Ports$Stripe$onOnboardingStepChanged = function (msg) {
	return $author$project$Ports$Stripe$stripePortOnboardingStepChanged(
		$elm$core$Basics$always(msg));
};
var $author$project$Components$Rainforest$MigrateBackToStripeModal$CloseModal = {$: 0};
var $author$project$Components$Rainforest$MigrateBackToStripeModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Rainforest$MigrateBackToStripeModal$CloseModal);
};
var $author$project$Components$Rainforest$ResetAccountModal$Close = {$: 0};
var $author$project$Components$Rainforest$ResetAccountModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Rainforest$ResetAccountModal$Close);
};
var $author$project$Components$Rainforest$SimulateApplicationEventModal$Close = {$: 0};
var $author$project$Components$Rainforest$SimulateApplicationEventModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Rainforest$SimulateApplicationEventModal$Close);
};
var $author$project$Components$PaymentProcessing$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Rainforest$SimulateApplicationEventModal$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Components$PaymentProcessing$SimulateApplicationEventModalMsg)),
					model.lr)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Rainforest$ResetAccountModal$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Components$PaymentProcessing$ResetAccountModalMsg)),
					model.k_)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					function (_v1) {
						var deletingPaymentMethodType = _v1.a;
						var deletingPaymentMethod = _v1.b;
						return $author$project$Components$HiConfirm$subscribeToEscapeKeyPress(
							A2($author$project$Components$PaymentProcessing$DeleteHiConfirmClosed, deletingPaymentMethodType, deletingPaymentMethod));
					},
					model.ek)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					function (_v2) {
						var requestingUpdatePaymentMethodType = _v2.a;
						var requestingUpdatePaymentMethod = _v2.b;
						return $author$project$Components$HiConfirm$subscribeToEscapeKeyPress(
							A2($author$project$Components$PaymentProcessing$RequestPaymentInfoHiConfirmClosed, requestingUpdatePaymentMethodType, requestingUpdatePaymentMethod));
					},
					model.e3)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Rainforest$MigrateBackToStripeModal$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Components$PaymentProcessing$MigrateBackToStripeModalMsg)),
					model.kn)),
				function () {
				var _v3 = model.alH;
				if (_v3.$ === 4) {
					return $elm$core$Platform$Sub$batch(
						_List_fromArray(
							[
								$author$project$Ports$Stripe$onOnboardingExited($author$project$Components$PaymentProcessing$StripeOnboardingExited),
								$author$project$Ports$Stripe$onOnboardingStepChanged($author$project$Components$PaymentProcessing$StripeOnboardingStepChanged)
							]));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				model.hP ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$PaymentProcessing$StripeHiConfirmClosed) : $elm$core$Platform$Sub$none
			]));
};
var $author$project$Pages$Admin$PaymentProcessing$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$PaymentProcessing$subscriptions(model.o2));
};
var $author$project$Components$PaymentProcessing$Deleted = F3(
	function (a, b, c) {
		return {$: 21, a: a, b: b, c: c};
	});
var $author$project$Components$PaymentProcessing$DeletedAll = F2(
	function (a, b) {
		return {$: 28, a: a, b: b};
	});
var $author$project$Components$PaymentProcessing$DepositFrequencyUpdated = function (a) {
	return {$: 43, a: a};
};
var $author$project$Components$PaymentProcessing$GotConnectedToStripe = function (a) {
	return {$: 45, a: a};
};
var $author$project$Components$PaymentProcessing$GotDeleteRainforestAccount = function (a) {
	return {$: 39, a: a};
};
var $author$project$Components$PaymentProcessing$GotExportRainforestMapping = function (a) {
	return {$: 35, a: a};
};
var $author$project$Components$PaymentProcessing$GotPractice = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$PaymentProcessing$GotRainforestAccountCreated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$PaymentProcessing$GotRainforestAccountEnabled = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$PaymentProcessing$GotRunPlatformMigration = function (a) {
	return {$: 37, a: a};
};
var $author$project$Components$PaymentProcessing$GotStripeSession = function (a) {
	return {$: 47, a: a};
};
var $author$project$Components$PaymentProcessing$HasRainforestAccountAccount = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$PaymentProcessing$PaymentInfoUpdated = F3(
	function (a, b, c) {
		return {$: 25, a: a, b: b, c: c};
	});
var $author$project$Components$PaymentProcessing$RequestedPaymentInfoUpdateAll = F2(
	function (a, b) {
		return {$: 31, a: a, b: b};
	});
var $author$project$Components$PaymentProcessing$StripeConnected = {$: 5};
var $author$project$Components$PaymentProcessing$StripeDisconnected = function (a) {
	return {$: 52, a: a};
};
var $author$project$Components$PaymentProcessing$StripeEmbeddedOnboarding = {$: 4};
var $author$project$Components$PaymentProcessing$Synced = function (a) {
	return {$: 33, a: a};
};
var $author$project$Api$Provider$StripePaymentMethodMigration$bulkDelete = F3(
	function (apiClient, paymentMethodType, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'payment_method_type',
					$elm$json$Json$Encode$string(paymentMethodType))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['bulk_delete']),
						$author$project$Api$Provider$StripePaymentMethodMigration$stripePaymentMethodMigrationsPath))));
	});
var $author$project$Api$Provider$StripePaymentMethodMigration$bulkRequestPayInfoUpdate = F3(
	function (apiClient, paymentMethodType, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'payment_method_type',
					$elm$json$Json$Encode$string(paymentMethodType))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['bulk_request_pay_info']),
						$author$project$Api$Provider$StripePaymentMethodMigration$stripePaymentMethodMigrationsPath))));
	});
var $author$project$Components$PaymentProcessing$PracticeOnboardingUpdated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$PracticeOnboarding$complete = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['complete']),
					$author$project$Api$Provider$PracticeOnboarding$practiceOnboardingPath(id))));
	});
var $author$project$Components$PaymentProcessing$completeSetup = F2(
	function (apiClient, practice) {
		var onboardId = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$PracticeOnboarding$Shared$id,
				$author$project$Api$Provider$Practice$One$practiceOnboarding(practice)));
		return A3($author$project$Api$Provider$PracticeOnboarding$complete, apiClient, onboardId, $author$project$Components$PaymentProcessing$PracticeOnboardingUpdated);
	});
var $author$project$Api$Provider$Practice$RainforestAccount$create = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$RainforestAccount$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$RainforestAccount$rainforestAccountPath));
	});
var $author$project$Api$Provider$Practice$StripeAccount$createAccount = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Practice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$StripeAccount$stripeAccountPath));
	});
var $author$project$Api$Provider$BankAccount$bankAccountPath = F2(
	function (basePath, id_) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id_]),
			$author$project$Api$Provider$BankAccount$bankAccountsPath(basePath));
	});
var $author$project$Api$Provider$BankAccount$delete = F4(
	function (basePath, apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Provider$BankAccount$bankAccountPath, basePath, id_)));
	});
var $author$project$Api$Provider$Card$cardPath = F2(
	function (basePath, id_) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id_]),
			$author$project$Api$Provider$Card$cardsPath(basePath));
	});
var $author$project$Api$Provider$Card$delete = F4(
	function (basePath, apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Provider$Card$cardPath, basePath, id_)));
	});
var $author$project$Api$Provider$Practice$RainforestAccount$delete = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$RainforestAccount$rainforestAccountPath));
	});
var $author$project$Api$Provider$Practice$StripeAccount$disconnect = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Practice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['disconnect']),
					$author$project$Api$Provider$Practice$StripeAccount$stripeAccountPath)));
	});
var $author$project$Api$Provider$Practice$RainforestAccount$enable = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$RainforestAccount$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['enable']),
					$author$project$Api$Provider$Practice$RainforestAccount$rainforestAccountPath)));
	});
var $author$project$Api$Provider$Practice$RainforestAccount$exportPaymentMethods = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			A2($elm$json$Json$Decode$field, 'csv', $elm$json$Json$Decode$string),
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['export_payment_methods']),
					$author$project$Api$Provider$Practice$RainforestAccount$rainforestAccountPath)));
	});
var $author$project$Api$Provider$StripePaymentMethodMigration$All$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Components$Rainforest$MigrateBackToStripeModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Rainforest$MigrateBackToStripeModal$init = {oF: $author$project$Api$Data$NotAsked, s8: false};
var $author$project$Components$Rainforest$ResetAccountModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Rainforest$ResetAccountModal$init = function (reset) {
	return _Utils_Tuple2(
		{km: $elm$core$Maybe$Nothing, uf: $author$project$Api$Data$NotAsked, Jx: reset},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Components$Rainforest$SimulateApplicationEventModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Rainforest$SimulateApplicationEventModal$defaultStatus = 'COMPLETED';
var $author$project$Components$Rainforest$SimulateApplicationEventModal$reviewTypes = _List_fromArray(
	['BUSINESS_NAME_TIN', 'BUSINESS_VERIFICATION', 'FINANCIAL_1', 'FINANCIAL_2', 'DEPOSIT_METHOD_1', 'OWNER_1_NAME_SSN', 'OWNER_2_NAME_SSN', 'OWNER_3_NAME_SSN', 'OWNER_4_NAME_SSN']);
var $author$project$Components$Rainforest$SimulateApplicationEventModal$init = function (simulateStatusChange) {
	return _Utils_Tuple2(
		{
			uf: $author$project$Api$Data$NotAsked,
			pJ: $elm$core$Dict$fromList(
				A2(
					$elm$core$List$map,
					function (reviewType) {
						return _Utils_Tuple2(reviewType, false);
					},
					$author$project$Components$Rainforest$SimulateApplicationEventModal$reviewTypes)),
			JN: simulateStatusChange,
			alH: $author$project$Components$Rainforest$SimulateApplicationEventModal$defaultStatus
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Ports$Stripe$stripePortMountAccountManagementComponent = _Platform_outgoingPort(
	'stripePortMountAccountManagementComponent',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'selector',
					$elm$json$Json$Encode$string($.aW)),
					_Utils_Tuple2(
					'stripeClientSecret',
					$elm$json$Json$Encode$string($.hO))
				]));
	});
var $author$project$Ports$Stripe$mountAccountManagementComponent = F2(
	function (selector, stripeClientSecret) {
		return $author$project$Ports$Stripe$stripePortMountAccountManagementComponent(
			{aW: selector, hO: stripeClientSecret});
	});
var $author$project$Ports$Stripe$stripePortMountAccountOnboardingComponent = _Platform_outgoingPort(
	'stripePortMountAccountOnboardingComponent',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'selector',
					$elm$json$Json$Encode$string($.aW)),
					_Utils_Tuple2(
					'stripeClientSecret',
					$elm$json$Json$Encode$string($.hO))
				]));
	});
var $author$project$Ports$Stripe$mountAccountOnboardingComponent = F2(
	function (selector, stripeClientSecret) {
		return $author$project$Ports$Stripe$stripePortMountAccountOnboardingComponent(
			{aW: selector, hO: stripeClientSecret});
	});
var $author$project$Api$Provider$StripePaymentMethodMigration$All$owner = function (_v0) {
	var record = _v0;
	return record.YD;
};
var $author$project$Components$PaymentProcessing$PrefilledWithFakeData = function (a) {
	return {$: 15, a: a};
};
var $author$project$Api$Provider$Practice$RainforestAccount$fakePrefill = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$RainforestAccount$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['fake_prefill']),
					$author$project$Api$Provider$Practice$RainforestAccount$rainforestAccountPath)));
	});
var $author$project$Components$PaymentProcessing$prefillWithFakeData = function (apiClient) {
	return A2($author$project$Api$Provider$Practice$RainforestAccount$fakePrefill, apiClient, $author$project$Components$PaymentProcessing$PrefilledWithFakeData);
};
var $author$project$Api$Provider$Patient$RequestPaymentInfoOne$RequestPaymentInfo = $elm$core$Basics$identity;
var $author$project$Api$Provider$Patient$RequestPaymentInfoOne$Record = function (requestPayInfoSentAt) {
	return {$B: requestPayInfoSentAt};
};
var $author$project$Api$Provider$Patient$RequestPaymentInfoOne$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'request_pay_info_sent_at',
	$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$RequestPaymentInfoOne$Record));
var $author$project$Api$Provider$Patient$RequestPaymentInfoOne$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Patient$RequestPaymentInfoOne$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Patient$requestPaymentInfo = F4(
	function (apiClient, id_, replacesPaymentMethodId, toMsg) {
		var body = $elm$json$Json$Encode$object(
			function () {
				if (!replacesPaymentMethodId.$) {
					var replacesPaymentMethodId_ = replacesPaymentMethodId.a;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'replaces_payment_method_id',
							$elm$json$Json$Encode$string(replacesPaymentMethodId_))
						]);
				} else {
					return _List_Nil;
				}
			}());
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Patient$RequestPaymentInfoOne$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['request_payment_info']),
						$author$project$Api$Provider$Patient$patientPath(id_)))));
	});
var $author$project$Api$Provider$Practice$RainforestAccount$reset = F3(
	function (apiClient, merchantName, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'merchant_name',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, merchantName))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$RainforestAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['reset']),
						$author$project$Api$Provider$Practice$RainforestAccount$rainforestAccountPath))));
	});
var $author$project$Api$Provider$Practice$expandToString = function (expand) {
	if (!expand) {
		return 'signup_settings';
	} else {
		return 'default_plan';
	}
};
var $author$project$Api$Provider$Practice$retrieveDefaults = {HE: _List_Nil};
var $author$project$Api$Provider$Practice$retrieveOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Practice$retrieveDefaults);
	return _List_fromArray(
		[
			A2(
			$author$project$Api$Param$list,
			'expand',
			A2($elm$core$List$map, $author$project$Api$Provider$Practice$expandToString, options.HE))
		]);
};
var $author$project$Api$Provider$Practice$retrieve = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Practice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Practice$retrieveOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$practicePath)));
	});
var $author$project$Components$PaymentProcessing$GotSetupSessionKey = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$RainforestAccount$One$record = function (_v0) {
	var record_ = _v0.b;
	return record_;
};
var $author$project$Api$Provider$RainforestAccount$One$merchantApplicationStatus = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$RainforestAccount$One$record,
	function ($) {
		return $.W0;
	});
var $author$project$Api$Provider$Practice$RainforestAccount$setup = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			A2($elm$json$Json$Decode$field, 'session_key', $elm$json$Json$Decode$string),
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['setup']),
					$author$project$Api$Provider$Practice$RainforestAccount$rainforestAccountPath)));
	});
var $author$project$Components$PaymentProcessing$retrieveSetupSessionKey = F2(
	function (apiClient, rainforestAccount) {
		return ($author$project$Api$Provider$RainforestAccount$One$merchantApplicationStatus(rainforestAccount) !== 'completed') ? A2($author$project$Api$Provider$Practice$RainforestAccount$setup, apiClient, $author$project$Components$PaymentProcessing$GotSetupSessionKey) : $elm$core$Platform$Cmd$none;
	});
var $author$project$Api$Provider$Practice$RainforestAccount$runPlatformMigration = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$RainforestAccount$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['run_platform_migration']),
					$author$project$Api$Provider$Practice$RainforestAccount$rainforestAccountPath)));
	});
var $author$project$Api$Provider$Practice$RainforestAccount$simulateStatusChange = F4(
	function (apiClient, status, reviewTypes, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'status',
					$elm$json$Json$Encode$string(status)),
					_Utils_Tuple2(
					'review_types',
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, reviewTypes))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$RainforestAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['simulate_status_change']),
						$author$project$Api$Provider$Practice$RainforestAccount$rainforestAccountPath))));
	});
var $elm$file$File$Download$string = F3(
	function (name, mime, content) {
		return A2(
			$elm$core$Task$perform,
			$elm$core$Basics$never,
			A3(_File_download, name, mime, content));
	});
var $author$project$Api$Provider$Practice$RainforestAccount$sync = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$RainforestAccount$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['sync']),
					$author$project$Api$Provider$Practice$RainforestAccount$rainforestAccountPath)));
	});
var $author$project$Api$Provider$Practice$RainforestAccount$update = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'rainforest_account',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'deposit_frequency',
								$elm$json$Json$Encode$string(fields.ags))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$RainforestAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$RainforestAccount$rainforestAccountPath)));
	});
var $author$project$Components$Rainforest$MigrateBackToStripeModal$Closed = 2;
var $author$project$Components$Rainforest$MigrateBackToStripeModal$GotMigrateBackToStripeResponse = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Rainforest$MigrateBackToStripeModal$MigratedBackToStripe = 1;
var $author$project$Components$Rainforest$MigrateBackToStripeModal$None = 0;
var $author$project$Api$Provider$Practice$RainforestAccount$migrateBackToStripe = F3(
	function (apiClient, migratePaymentMethods, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'migrate_payment_methods',
					$elm$json$Json$Encode$bool(migratePaymentMethods))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$RainforestAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['migrate_back_to_stripe']),
						$author$project$Api$Provider$Practice$RainforestAccount$rainforestAccountPath))));
	});
var $author$project$Components$Rainforest$MigrateBackToStripeModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: 2, aiO: model, aR: _List_Nil};
			case 1:
				var migratePaymentMethods = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{s8: migratePaymentMethods}),
					aR: _List_Nil
				};
			case 2:
				return {
					GZ: A3($author$project$Api$Provider$Practice$RainforestAccount$migrateBackToStripe, apiClient, model.s8, $author$project$Components$Rainforest$MigrateBackToStripeModal$GotMigrateBackToStripeResponse),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{oF: $author$project$Api$Data$Loading}),
					aR: _List_Nil
				};
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 1,
						aiO: _Utils_update(
							model,
							{oF: response}),
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Reverted to Stripe successfully')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{oF: response}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
		}
	});
var $author$project$Components$Rainforest$ResetAccountModal$Closed = {$: 1};
var $author$project$Components$Rainforest$ResetAccountModal$GotReset = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Rainforest$ResetAccountModal$None = {$: 0};
var $author$project$Components$Rainforest$ResetAccountModal$Reseted = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Rainforest$ResetAccountModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 1:
				var string = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: $author$project$Components$Rainforest$ResetAccountModal$None,
					aiO: _Utils_update(
						model,
						{
							km: $author$project$Utils$String$toMaybe(string)
						}),
					aR: _List_Nil
				};
			case 2:
				return {
					GZ: A3(model.Jx, apiClient, model.km, $author$project$Components$Rainforest$ResetAccountModal$GotReset),
					agZ: $author$project$Components$Rainforest$ResetAccountModal$None,
					aiO: _Utils_update(
						model,
						{uf: $author$project$Api$Data$Loading}),
					aR: _List_Nil
				};
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					var rainforestAccount = response.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: A2($author$project$Components$Rainforest$ResetAccountModal$Reseted, rainforestAccount, response),
						aiO: _Utils_update(
							model,
							{uf: response}),
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Application Status Changed')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Rainforest$ResetAccountModal$None,
						aiO: _Utils_update(
							model,
							{uf: response}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			default:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$Rainforest$ResetAccountModal$Closed, aiO: model, aR: _List_Nil};
		}
	});
var $author$project$Components$Rainforest$SimulateApplicationEventModal$Closed = 1;
var $author$project$Components$Rainforest$SimulateApplicationEventModal$GotSimulate = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Rainforest$SimulateApplicationEventModal$None = 0;
var $author$project$Components$Rainforest$SimulateApplicationEventModal$Simulated = 2;
var $author$project$Components$Rainforest$SimulateApplicationEventModal$statuses = _List_fromArray(
	['COMPLETED', 'DECLINED', 'NEEDS_INFORMATION']);
var $author$project$Components$Rainforest$SimulateApplicationEventModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 1:
				var inputStatus = msg.a;
				var selectedStatus = A2(
					$elm_community$list_extra$List$Extra$find,
					function (status_) {
						return _Utils_eq(status_, inputStatus);
					},
					$author$project$Components$Rainforest$SimulateApplicationEventModal$statuses);
				var status = A2($elm$core$Maybe$withDefault, $author$project$Components$Rainforest$SimulateApplicationEventModal$defaultStatus, selectedStatus);
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{alH: status}),
					aR: _List_Nil
				};
			case 2:
				var reviewType = msg.a;
				var value = msg.b;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							pJ: A3($elm$core$Dict$insert, reviewType, value, model.pJ)
						}),
					aR: _List_Nil
				};
			case 3:
				var reviewTypes_ = function () {
					var _v2 = model.alH;
					if (_v2 === 'NEEDS_INFORMATION') {
						return A2(
							$elm$core$List$filterMap,
							function (_v3) {
								var reviewType = _v3.a;
								var value = _v3.b;
								return value ? $elm$core$Maybe$Just(reviewType) : $elm$core$Maybe$Nothing;
							},
							$elm$core$Dict$toList(model.pJ));
					} else {
						return _List_Nil;
					}
				}();
				return {
					GZ: A4(model.JN, apiClient, model.alH, reviewTypes_, $author$project$Components$Rainforest$SimulateApplicationEventModal$GotSimulate),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{uf: $author$project$Api$Data$Loading}),
					aR: _List_Nil
				};
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 2,
						aiO: _Utils_update(
							model,
							{uf: response}),
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Application Status Changed')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{uf: response}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			default:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: 1, aiO: model, aR: _List_Nil};
		}
	});
var $author$project$Components$PaymentProcessing$update = F3(
	function (msg, _v0, apiClient) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				_v2$2:
				while (true) {
					switch (response.$) {
						case 3:
							var rainforestAccount = response.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										cQ: response,
										alH: $author$project$Components$PaymentProcessing$HasRainforestAccountAccount(rainforestAccount)
									}),
								A2($author$project$Components$PaymentProcessing$retrieveSetupSessionKey, apiClient, rainforestAccount),
								_List_fromArray(
									[$author$project$OutMsg$RefreshPractice]));
						case 2:
							if (response.a.$ === 5) {
								var _v3 = response.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{alH: $author$project$Components$PaymentProcessing$CreateAccount}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							} else {
								break _v2$2;
							}
						default:
							break _v2$2;
					}
				}
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{alH: $author$project$Components$PaymentProcessing$Loading}),
					A2($author$project$Api$Provider$Practice$RainforestAccount$create, apiClient, $author$project$Components$PaymentProcessing$GotRainforestAccountCreated),
					_List_Nil);
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					var rainforestAccount = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cQ: response,
								alH: $author$project$Components$PaymentProcessing$HasRainforestAccountAccount(rainforestAccount)
							}),
						A2($author$project$Components$PaymentProcessing$retrieveSetupSessionKey, apiClient, rainforestAccount),
						_List_fromArray(
							[$author$project$OutMsg$RefreshPractice]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{alH: $author$project$Components$PaymentProcessing$CreateAccount}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					var sessionKey = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Ey: $elm$core$Maybe$Just(sessionKey)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 5:
				return _Utils_Tuple3(
					model,
					A2($author$project$Components$PaymentProcessing$completeSetup, apiClient, model.ZV),
					_List_Nil);
			case 6:
				var response = msg.a;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							model,
							A2($author$project$Utils$Route$navigateAndReload, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Complete),
							_List_Nil);
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error)),
								$author$project$OutMsg$reportDecodeError(response)));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{AX: true}),
					model.bb ? $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Complete),
								A2($author$project$Components$PaymentProcessing$completeSetup, apiClient, model.ZV)
							])) : $elm$core$Platform$Cmd$none,
					_List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 3, 'Payment Processing Application submited')
						]));
			case 10:
				var _v7 = $author$project$Components$Rainforest$SimulateApplicationEventModal$init($author$project$Api$Provider$Practice$RainforestAccount$simulateStatusChange);
				var simulateApplicationEventModal = _v7.a;
				var simulateApplicationEventModalCmd = _v7.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							lr: $elm$core$Maybe$Just(simulateApplicationEventModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentProcessing$SimulateApplicationEventModalMsg, simulateApplicationEventModalCmd),
					_List_Nil);
			case 11:
				var simulateApplicationEventModalMsg = msg.a;
				var _v8 = model.lr;
				if (!_v8.$) {
					var simulateApplicationEventModal = _v8.a;
					var simulateApplicationEventModalResult = A3($author$project$Components$Rainforest$SimulateApplicationEventModal$update, apiClient, simulateApplicationEventModalMsg, simulateApplicationEventModal);
					var simulateApplicationEventModal_ = function () {
						var _v9 = simulateApplicationEventModalResult.agZ;
						switch (_v9) {
							case 1:
								return $elm$core$Maybe$Nothing;
							case 2:
								return $elm$core$Maybe$Nothing;
							default:
								return $elm$core$Maybe$Just(simulateApplicationEventModalResult.aiO);
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{lr: simulateApplicationEventModal_}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentProcessing$SimulateApplicationEventModalMsg, simulateApplicationEventModalResult.GZ),
						simulateApplicationEventModalResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 12:
				var _v10 = $author$project$Components$Rainforest$ResetAccountModal$init($author$project$Api$Provider$Practice$RainforestAccount$reset);
				var resetAccountModal = _v10.a;
				var resetAccountModalCmd = _v10.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							k_: $elm$core$Maybe$Just(resetAccountModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentProcessing$ResetAccountModalMsg, resetAccountModalCmd),
					_List_Nil);
			case 13:
				var resetAccountModalMsg = msg.a;
				var _v11 = model.k_;
				if (!_v11.$) {
					var resetAccountModal = _v11.a;
					var resetAccountModalResult = A3($author$project$Components$Rainforest$ResetAccountModal$update, apiClient, resetAccountModalMsg, resetAccountModal);
					var _v12 = function () {
						var _v13 = resetAccountModalResult.agZ;
						switch (_v13.$) {
							case 1:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.alH, model.cQ);
							case 2:
								var rainforestAccount_ = _v13.a;
								var rainforestAccountResponse = _v13.b;
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Components$PaymentProcessing$HasRainforestAccountAccount(rainforestAccount_),
									rainforestAccountResponse);
							default:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(resetAccountModalResult.aiO),
									model.alH,
									model.cQ);
						}
					}();
					var resetAccountModal_ = _v12.a;
					var status = _v12.b;
					var rainforestAccount = _v12.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cQ: rainforestAccount, k_: resetAccountModal_, alH: status}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentProcessing$ResetAccountModalMsg, resetAccountModalResult.GZ),
						resetAccountModalResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nx: $author$project$Api$Data$Loading}),
					A2($author$project$Api$Provider$Practice$RainforestAccount$enable, apiClient, $author$project$Components$PaymentProcessing$GotRainforestAccountEnabled),
					_List_Nil);
			case 8:
				var response = msg.a;
				if (response.$ === 3) {
					var rainforestAccount = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								nx: $author$project$Api$Data$NotAsked,
								cQ: response,
								alH: $author$project$Components$PaymentProcessing$HasRainforestAccountAccount(rainforestAccount)
							}),
						A3($author$project$Api$Provider$Practice$retrieve, apiClient, $elm$core$Basics$identity, $author$project$Components$PaymentProcessing$GotPractice),
						_List_fromArray(
							[
								$author$project$OutMsg$RefreshPractice,
								A2($author$project$OutMsg$ShowToast, 3, 'Rainforest account enabled')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{nx: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 9:
				var response = msg.a;
				if (response.$ === 3) {
					var practice = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ZV: practice}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								$author$project$OutMsg$PracticeUpdated(response)
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 14:
				return _Utils_Tuple3(
					model,
					$author$project$Components$PaymentProcessing$prefillWithFakeData(apiClient),
					_List_Nil);
			case 15:
				var response = msg.a;
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 17:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								c0: response,
								fM: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.fM)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{c0: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 16:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								c7: response,
								fT: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.fT)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{c7: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 18:
				var paymentMethodType = msg.a;
				var subMsg = msg.b;
				var newModel = function () {
					if (!paymentMethodType) {
						return _Utils_update(
							model,
							{
								fT: A2($author$project$Api$Pagination$update, subMsg, model.fT)
							});
					} else {
						return _Utils_update(
							model,
							{
								fM: A2($author$project$Api$Pagination$update, subMsg, model.fM)
							});
					}
				}();
				return _Utils_Tuple3(
					newModel,
					function () {
						if (!paymentMethodType) {
							return A2($author$project$Components$PaymentProcessing$retrieveCardsOnStripe, apiClient, newModel);
						} else {
							return A2($author$project$Components$PaymentProcessing$retrieveBankAccountsOnStripe, apiClient, newModel);
						}
					}(),
					_List_Nil);
			case 19:
				var paymentMethodType = msg.a;
				var columnId = msg.b;
				var newModel = function () {
					if (!paymentMethodType) {
						return _Utils_update(
							model,
							{
								mG: A2($author$project$Api$Sort$update, columnId, model.mG)
							});
					} else {
						return _Utils_update(
							model,
							{
								mr: A2($author$project$Api$Sort$update, columnId, model.mr)
							});
					}
				}();
				return _Utils_Tuple3(
					newModel,
					function () {
						if (!paymentMethodType) {
							return A2($author$project$Components$PaymentProcessing$retrieveCardsOnStripe, apiClient, newModel);
						} else {
							return A2($author$project$Components$PaymentProcessing$retrieveBankAccountsOnStripe, apiClient, newModel);
						}
					}(),
					_List_Nil);
			case 20:
				var paymentMethodType = msg.a;
				var paymentMethod = msg.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ek: $elm$core$Maybe$Just(
								_Utils_Tuple3(paymentMethodType, paymentMethod, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 22:
				var paymentMethodType = msg.a;
				var paymentMethod = msg.b;
				var confirmed = msg.c;
				if (confirmed) {
					var owner = $author$project$Api$Provider$StripePaymentMethodMigration$All$owner(paymentMethod);
					var ownerPath = A2(
						$elm$core$Maybe$andThen,
						function (owner_) {
							var _v25 = $author$project$Api$Common$Payable$Owner$Min$type_(owner_);
							switch (_v25) {
								case 'Patient':
									return $elm$core$Maybe$Just(
										$author$project$Api$Provider$Patient$patientPath(
											$author$project$Api$Common$Payable$Owner$Min$id(owner_)));
								case 'Company':
									return $elm$core$Maybe$Just(
										$author$project$Api$Provider$Company$companyPath(
											$author$project$Api$Common$Payable$Owner$Min$id(owner_)));
								default:
									return $elm$core$Maybe$Nothing;
							}
						},
						owner);
					var id = $author$project$Api$Provider$StripePaymentMethodMigration$All$id(paymentMethod);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ek: $elm$core$Maybe$Just(
									_Utils_Tuple3(paymentMethodType, paymentMethod, $author$project$Api$Data$Loading))
							}),
						function () {
							var _v22 = _Utils_Tuple2(ownerPath, paymentMethodType);
							if (!_v22.a.$) {
								if (!_v22.b) {
									var ownerPath_ = _v22.a.a;
									var _v23 = _v22.b;
									return A4(
										$author$project$Api$Provider$Card$delete,
										ownerPath_,
										apiClient,
										id,
										A2($author$project$Components$PaymentProcessing$Deleted, paymentMethodType, paymentMethod));
								} else {
									var ownerPath_ = _v22.a.a;
									var _v24 = _v22.b;
									return A4(
										$author$project$Api$Provider$BankAccount$delete,
										ownerPath_,
										apiClient,
										id,
										A2($author$project$Components$PaymentProcessing$Deleted, paymentMethodType, paymentMethod));
								}
							} else {
								return $elm$core$Platform$Cmd$none;
							}
						}(),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ek: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 21:
				var paymentMethodType = msg.a;
				var paymentMethod = msg.b;
				var response = msg.c;
				if (response.$ === 3) {
					var newModel = function () {
						if (!paymentMethodType) {
							return _Utils_update(
								model,
								{c7: $author$project$Api$Data$Loading});
						} else {
							return _Utils_update(
								model,
								{c0: $author$project$Api$Data$Loading});
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							newModel,
							{ek: $elm$core$Maybe$Nothing}),
						function () {
							if (!paymentMethodType) {
								return A2($author$project$Components$PaymentProcessing$retrieveCardsOnStripe, apiClient, model);
							} else {
								return A2($author$project$Components$PaymentProcessing$retrieveBankAccountsOnStripe, apiClient, model);
							}
						}(),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Payment method was successfully removed.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ek: $elm$core$Maybe$Just(
									_Utils_Tuple3(paymentMethodType, paymentMethod, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 23:
				var paymentMethodType = msg.a;
				var paymentMethod = msg.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							e3: $elm$core$Maybe$Just(
								_Utils_Tuple3(paymentMethodType, paymentMethod, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 24:
				var paymentMethodType = msg.a;
				var paymentMethod = msg.b;
				var confirmed = msg.c;
				if (confirmed) {
					var owner = $author$project$Api$Provider$StripePaymentMethodMigration$All$owner(paymentMethod);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								e3: $elm$core$Maybe$Just(
									_Utils_Tuple3(paymentMethodType, paymentMethod, $author$project$Api$Data$Loading))
							}),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$Maybe$map,
								function (owner_) {
									var _v29 = $author$project$Api$Common$Payable$Owner$Min$type_(owner_);
									switch (_v29) {
										case 'Patient':
											var id = $author$project$Api$Provider$StripePaymentMethodMigration$All$id(paymentMethod);
											return A4(
												$author$project$Api$Provider$Patient$requestPaymentInfo,
												apiClient,
												$author$project$Api$Common$Payable$Owner$Min$id(owner_),
												$elm$core$Maybe$Just(id),
												A2($author$project$Components$PaymentProcessing$PaymentInfoUpdated, paymentMethodType, paymentMethod));
										case 'Company':
											return $elm$core$Platform$Cmd$none;
										default:
											return $elm$core$Platform$Cmd$none;
									}
								},
								owner)),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{e3: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 25:
				var paymentMethodType = msg.a;
				var paymentMethod = msg.b;
				var response = msg.c;
				if (response.$ === 3) {
					var newModel = function () {
						if (!paymentMethodType) {
							return _Utils_update(
								model,
								{c7: $author$project$Api$Data$Loading});
						} else {
							return _Utils_update(
								model,
								{c0: $author$project$Api$Data$Loading});
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							newModel,
							{e3: $elm$core$Maybe$Nothing}),
						function () {
							if (!paymentMethodType) {
								return A2($author$project$Components$PaymentProcessing$retrieveCardsOnStripe, apiClient, newModel);
							} else {
								return A2($author$project$Components$PaymentProcessing$retrieveBankAccountsOnStripe, apiClient, newModel);
							}
						}(),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Request to update payment method was successfully sent.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								e3: $elm$core$Maybe$Just(
									_Utils_Tuple3(paymentMethodType, paymentMethod, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 26:
				var paymentMethodType = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							d7: $elm$core$Maybe$Just(
								_Utils_Tuple2(paymentMethodType, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 27:
				var paymentMethodType = msg.a;
				var confirmed = msg.b;
				if (confirmed) {
					var paymentMethodType_ = function () {
						if (!paymentMethodType) {
							return 'card';
						} else {
							return 'bank_account';
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								d7: $elm$core$Maybe$Just(
									_Utils_Tuple2(paymentMethodType, $author$project$Api$Data$Loading))
							}),
						A3(
							$author$project$Api$Provider$StripePaymentMethodMigration$bulkDelete,
							apiClient,
							paymentMethodType_,
							$author$project$Components$PaymentProcessing$DeletedAll(paymentMethodType)),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{d7: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 28:
				var paymentMethodType = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var newModel = function () {
						if (!paymentMethodType) {
							return _Utils_update(
								model,
								{c7: $author$project$Api$Data$Loading});
						} else {
							return _Utils_update(
								model,
								{c0: $author$project$Api$Data$Loading});
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							newModel,
							{d7: $elm$core$Maybe$Nothing}),
						function () {
							if (!paymentMethodType) {
								return A2($author$project$Components$PaymentProcessing$retrieveCardsOnStripe, apiClient, model);
							} else {
								return A2($author$project$Components$PaymentProcessing$retrieveBankAccountsOnStripe, apiClient, model);
							}
						}(),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Deleting all payment methods . This may take a couple moments...')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								d7: $elm$core$Maybe$Just(
									_Utils_Tuple2(paymentMethodType, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 29:
				var paymentMethodType = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							e2: $elm$core$Maybe$Just(
								_Utils_Tuple2(paymentMethodType, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 30:
				var paymentMethodType = msg.a;
				var confirmed = msg.b;
				if (confirmed) {
					var paymentMethodType_ = function () {
						if (!paymentMethodType) {
							return 'card';
						} else {
							return 'bank_account';
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								e2: $elm$core$Maybe$Just(
									_Utils_Tuple2(paymentMethodType, $author$project$Api$Data$Loading))
							}),
						A3(
							$author$project$Api$Provider$StripePaymentMethodMigration$bulkRequestPayInfoUpdate,
							apiClient,
							paymentMethodType_,
							$author$project$Components$PaymentProcessing$RequestedPaymentInfoUpdateAll(paymentMethodType)),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{e2: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 31:
				var paymentMethodType = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var newModel = function () {
						if (!paymentMethodType) {
							return _Utils_update(
								model,
								{c7: $author$project$Api$Data$Loading});
						} else {
							return _Utils_update(
								model,
								{c0: $author$project$Api$Data$Loading});
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							newModel,
							{e2: $elm$core$Maybe$Nothing}),
						function () {
							if (!paymentMethodType) {
								return A2($author$project$Components$PaymentProcessing$retrieveCardsOnStripe, apiClient, model);
							} else {
								return A2($author$project$Components$PaymentProcessing$retrieveBankAccountsOnStripe, apiClient, model);
							}
						}(),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Sending request to update all payment methods . This may take a couple moments...')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								e2: $elm$core$Maybe$Just(
									_Utils_Tuple2(paymentMethodType, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 32:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qr: $author$project$Api$Data$Loading}),
					A2($author$project$Api$Provider$Practice$RainforestAccount$sync, apiClient, $author$project$Components$PaymentProcessing$Synced),
					_List_Nil);
			case 33:
				var response = msg.a;
				if (response.$ === 3) {
					var rainforestAccount = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cQ: response,
								alH: $author$project$Components$PaymentProcessing$HasRainforestAccountAccount(rainforestAccount),
								qr: $author$project$Api$Data$NotAsked
							}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Sync with Rainforest was successful.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{qr: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 34:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nE: $author$project$Api$Data$Loading}),
					A2($author$project$Api$Provider$Practice$RainforestAccount$exportPaymentMethods, apiClient, $author$project$Components$PaymentProcessing$GotExportRainforestMapping),
					_List_Nil);
			case 35:
				var response = msg.a;
				if (response.$ === 3) {
					var csv = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{nE: $author$project$Api$Data$NotAsked}),
						A3($elm$file$File$Download$string, 'rainforest-payment-methods.csv', 'text/csv', csv),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Rainforest mapping exported.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{nE: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 36:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{pO: $author$project$Api$Data$Loading}),
					A2($author$project$Api$Provider$Practice$RainforestAccount$runPlatformMigration, apiClient, $author$project$Components$PaymentProcessing$GotRunPlatformMigration),
					_List_Nil);
			case 37:
				var response = msg.a;
				if (response.$ === 3) {
					var rainforestAccount = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								pO: response,
								alH: $author$project$Components$PaymentProcessing$HasRainforestAccountAccount(rainforestAccount)
							}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Platform migration was started.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{pO: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 38:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{f7: $author$project$Api$Data$Loading}),
					A2($author$project$Api$Provider$Practice$RainforestAccount$delete, apiClient, $author$project$Components$PaymentProcessing$GotDeleteRainforestAccount),
					_List_Nil);
			case 39:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{f7: $author$project$Api$Data$NotAsked, alH: $author$project$Components$PaymentProcessing$CreateAccount}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Rainforest account was successfully deleted.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{f7: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 40:
				var migrateBackToStripeModal = $author$project$Components$Rainforest$MigrateBackToStripeModal$init;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							kn: $elm$core$Maybe$Just(migrateBackToStripeModal)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 41:
				var subMsg = msg.a;
				var _v45 = model.kn;
				if (!_v45.$) {
					var migrateBackToStripeModal = _v45.a;
					var migrateBackToStripeModalResult = A3($author$project$Components$Rainforest$MigrateBackToStripeModal$update, apiClient, subMsg, migrateBackToStripeModal);
					var _v46 = function () {
						var _v47 = migrateBackToStripeModalResult.agZ;
						switch (_v47) {
							case 0:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(migrateBackToStripeModalResult.aiO),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							case 2:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none, _List_Nil);
							default:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									A3($author$project$Api$Provider$Practice$retrieve, apiClient, $elm$core$Basics$identity, $author$project$Components$PaymentProcessing$GotPractice),
									_List_fromArray(
										[$author$project$OutMsg$RefreshPractice]));
						}
					}();
					var updatedMigrateBackToStripeModal = _v46.a;
					var cmd = _v46.b;
					var outMsgs = _v46.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{kn: updatedMigrateBackToStripeModal}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									cmd,
									A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentProcessing$MigrateBackToStripeModalMsg, migrateBackToStripeModalResult.GZ)
								])),
						_Utils_ap(outMsgs, migrateBackToStripeModalResult.aR));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 42:
				var depositFrequency = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qP: $author$project$Api$Data$Loading}),
					A3(
						$author$project$Api$Provider$Practice$RainforestAccount$update,
						apiClient,
						{ags: depositFrequency},
						$author$project$Components$PaymentProcessing$DepositFrequencyUpdated),
					_List_Nil);
			case 43:
				var response = msg.a;
				if (response.$ === 3) {
					var rainforestAccount = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cQ: response,
								alH: $author$project$Components$PaymentProcessing$HasRainforestAccountAccount(rainforestAccount),
								qP: $author$project$Api$Data$NotAsked
							}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Deposit frequency was successfully updated.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{qP: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 44:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{alH: $author$project$Components$PaymentProcessing$StripeConnecting}),
					A2($author$project$Api$Provider$Practice$StripeAccount$createAccount, apiClient, $author$project$Components$PaymentProcessing$GotConnectedToStripe),
					_List_Nil);
			case 45:
				var response = msg.a;
				if (response.$ === 3) {
					var practice = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ZV: practice, alH: $author$project$Components$PaymentProcessing$StripeConnecting}),
						A2($author$project$Api$Provider$Practice$StripeAccount$onboardingStatus, apiClient, $author$project$Components$PaymentProcessing$GotStripeOnboardingStatus),
						_List_fromArray(
							[
								$author$project$OutMsg$PracticeUpdated(response)
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{alH: $author$project$Components$PaymentProcessing$CreateAccount}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 46:
				var response = msg.a;
				if (response.$ === 3) {
					var detailsSubmitted = response.a.agu;
					var chargesEnabled = response.a.afG;
					var disabledReason = response.a.agz;
					var clientSecret = response.a.afI;
					if (detailsSubmitted) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{alH: $author$project$Components$PaymentProcessing$StripeConnected, EP: chargesEnabled, EQ: disabledReason}),
							A2($author$project$Api$Provider$Practice$StripeAccount$session, apiClient, $author$project$Components$PaymentProcessing$GotStripeSession),
							_List_Nil);
					} else {
						if (!clientSecret.$) {
							var secret = clientSecret.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{uG: true, alH: $author$project$Components$PaymentProcessing$StripeEmbeddedOnboarding}),
								A2($author$project$Ports$Stripe$mountAccountOnboardingComponent, '#stripe-account-onboarding', secret),
								_List_Nil);
						} else {
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
						}
					}
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{alH: $author$project$Components$PaymentProcessing$CreateAccount}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 47:
				var response = msg.a;
				if (response.$ === 3) {
					var secret = response.a;
					return _Utils_Tuple3(
						model,
						A2($author$project$Ports$Stripe$mountAccountManagementComponent, '#stripe-account-management', secret),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 48:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{alH: $author$project$Components$PaymentProcessing$StripeConnecting}),
					A2($author$project$Api$Provider$Practice$StripeAccount$onboardingStatus, apiClient, $author$project$Components$PaymentProcessing$GotStripeOnboardingStatus),
					_List_Nil);
			case 49:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{uG: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 50:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{hP: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 51:
				var confirmed = msg.a;
				return confirmed ? _Utils_Tuple3(
					model,
					A2($author$project$Api$Provider$Practice$StripeAccount$disconnect, apiClient, $author$project$Components$PaymentProcessing$StripeDisconnected),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{hP: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 52:
				var response = msg.a;
				if (response.$ === 3) {
					var practice = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ZV: practice, alH: $author$project$Components$PaymentProcessing$CreateAccount, hP: false}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your stripe integration has been disconnected.'),
								$author$project$OutMsg$PracticeUpdated(response)
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{hP: false}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				return _Utils_Tuple3(
					model,
					$author$project$Ports$Intercom$open(model.aa4),
					_List_Nil);
		}
	});
var $author$project$Pages$Admin$PaymentProcessing$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$PaymentProcessing$update, subMsg, model.o2, model.Gv);
		var paymentProcessing = _v1.a;
		var paymentProcessingCmd = _v1.b;
		var outMsgs = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{o2: paymentProcessing}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, paymentProcessingCmd),
			outMsgs);
	});
var $author$project$Components$PaymentProcessing$DeleteAllHiConfirmClosed = F2(
	function (a, b) {
		return {$: 27, a: a, b: b};
	});
var $author$project$Components$PaymentProcessing$DeleteRainforestAccount = {$: 38};
var $author$project$Components$PaymentProcessing$ExportRainforestMapping = {$: 34};
var $author$project$Components$PaymentProcessing$OpenResetAccountModal = {$: 12};
var $author$project$Components$PaymentProcessing$RequestPaymentInfoUpdateAllHiConfirmClosed = F2(
	function (a, b) {
		return {$: 30, a: a, b: b};
	});
var $author$project$Components$PaymentProcessing$Sync = {$: 32};
var $author$project$Api$Provider$RainforestAccount$Shared$record = function (_v0) {
	var record_ = _v0;
	return record_;
};
var $author$project$Api$Provider$RainforestAccount$Shared$status = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$RainforestAccount$Shared$record,
	function ($) {
		return $.alH;
	});
var $author$project$Api$Provider$RainforestAccount$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$RainforestAccount$Shared$status(shared);
};
var $author$project$Components$Rainforest$MigrateBackToStripeModal$MigrateBackToStripe = {$: 2};
var $author$project$Components$Rainforest$MigrateBackToStripeModal$MigratePaymentMethodsChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Rainforest$MigrateBackToStripeModal$view = function (_v0) {
	var model = _v0;
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Rainforest$MigrateBackToStripeModal$CloseModal,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Migrate back to Stripe')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$muted]),
						_List_fromArray(
							[
								$elm$html$Html$text('Migrate the practice back to to Stripe.')
							])),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Migrate Payment Methods'),
								$author$project$Ui$Form$Group$labelSpan(4),
								$author$project$Ui$Form$Group$inputSpan(8)
							]),
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$view(
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$on(model.s8),
										$author$project$Ui$ToggleSwitch$onChange($author$project$Components$Rainforest$MigrateBackToStripeModal$MigratePaymentMethodsChanged)
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpBlock]),
								_List_fromArray(
									[
										$elm$html$Html$text('Also migrate payment methods to back to Stripe.')
									]))
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Cancel'},
						_List_fromArray(
							[
								$author$project$Ui$Button$secondary,
								$author$project$Ui$Button$onClick($author$project$Components$Rainforest$MigrateBackToStripeModal$CloseModal)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Revert to Stripe'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$onClick($author$project$Components$Rainforest$MigrateBackToStripeModal$MigrateBackToStripe),
								$author$project$Ui$Button$loading(
								_Utils_eq(model.oF, $author$project$Api$Data$Loading))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Migrate back to Stripe')
							]))
					]))
			]));
};
var $author$project$Components$Rainforest$ResetAccountModal$MerchantNameChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Rainforest$ResetAccountModal$Reset = {$: 2};
var $author$project$Components$Rainforest$ResetAccountModal$view = function (_v0) {
	var model = _v0;
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Rainforest$ResetAccountModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Reset Rainforest Account')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Alert$danger,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('This will:'),
								A2(
								$elm$html$Html$ul,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$li,
										_List_fromArray(
											[
												A2($elm$html$Html$Attributes$style, 'list-style-position', 'inside')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Remove the current link between the practice and Rainforest')
											])),
										A2(
										$elm$html$Html$li,
										_List_fromArray(
											[
												A2($elm$html$Html$Attributes$style, 'list-style-position', 'inside')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Create a new Rainforest Merchant with the given name')
											])),
										A2(
										$elm$html$Html$li,
										_List_fromArray(
											[
												A2($elm$html$Html$Attributes$style, 'list-style-position', 'inside')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Link the practice to the new Rainforest Merchant')
											]))
									]))
							])),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Merchant Name'),
								$author$project$Ui$Form$Group$labelSpan(4),
								$author$project$Ui$Form$Group$inputSpan(8),
								$author$project$Ui$Form$Group$required(true)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$value(
										A2($elm$core$Maybe$withDefault, '', model.km)),
										$author$project$Ui$Form$Input$onInput($author$project$Components$Rainforest$ResetAccountModal$MerchantNameChanged),
										$author$project$Ui$Form$Input$invalid(
										_Utils_eq(model.km, $elm$core$Maybe$Nothing)),
										$author$project$Ui$Form$Input$errors(
										_Utils_eq(model.km, $elm$core$Maybe$Nothing) ? _List_fromArray(
											['Merchant name is required']) : _List_Nil)
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpBlock]),
								_List_fromArray(
									[
										$elm$html$Html$text('This is the name of the Rainforest Merchant that will be created. '),
										$elm$html$Html$text('By default we use the practice id as the merchant name but since we cannot reuse merchant names, '),
										$elm$html$Html$text('we will need provide a new name here. '),
										A2(
										$author$project$Ui$Typography$b,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Suggestion is to use the practice id followed by a dash with the number of merchants we have created for this practice.'),
												$elm$html$Html$text('Example: pra-abc1234-2')
											]))
									]))
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Rainforest$ResetAccountModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Reset Rainforest Account'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$loading(
								_Utils_eq(model.uf, $author$project$Api$Data$Loading)),
								$author$project$Ui$Button$onClick($author$project$Components$Rainforest$ResetAccountModal$Reset)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Reset')
							]))
					]))
			]));
};
var $author$project$Components$Rainforest$SimulateApplicationEventModal$ReviewTypeSelected = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Rainforest$SimulateApplicationEventModal$Simulate = {$: 3};
var $author$project$Components$Rainforest$SimulateApplicationEventModal$StatusSelected = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Rainforest$SimulateApplicationEventModal$statusOptions = A2(
	$elm$core$List$map,
	function (status) {
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(status),
			status);
	},
	$author$project$Components$Rainforest$SimulateApplicationEventModal$statuses);
var $author$project$Components$Rainforest$SimulateApplicationEventModal$view = function (_v0) {
	var model = _v0;
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Rainforest$SimulateApplicationEventModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Simulate Application Status Change')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$muted]),
						_List_fromArray(
							[
								$elm$html$Html$text('In the production environment, this step is handled through callback events. In Staging, Feature, and Dev environments, it can be simulated.')
							])),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Status'),
								$author$project$Ui$Form$Group$labelSpan(4),
								$author$project$Ui$Form$Group$inputSpan(8)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Select$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Select$value(
										$elm$core$Maybe$Just(model.alH)),
										$author$project$Ui$Form$Select$onChange($author$project$Components$Rainforest$SimulateApplicationEventModal$StatusSelected)
									]),
								$author$project$Components$Rainforest$SimulateApplicationEventModal$statusOptions)
							])),
						(model.alH === 'NEEDS_INFORMATION') ? A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Review Types'),
								$author$project$Ui$Form$Group$labelSpan(4),
								$author$project$Ui$Form$Group$inputSpan(8)
							]),
						A2(
							$elm$core$List$map,
							function (_v1) {
								var reviewType = _v1.a;
								var value = _v1.b;
								return A2(
									$author$project$Ui$Form$Checkbox$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Checkbox$value(value),
											$author$project$Ui$Form$Checkbox$onCheck(
											$author$project$Components$Rainforest$SimulateApplicationEventModal$ReviewTypeSelected(reviewType))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(reviewType)
										]));
							},
							$elm$core$Dict$toList(model.pJ))) : $author$project$Utils$Html$empty
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Rainforest$SimulateApplicationEventModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Simulate application event'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$loading(
								_Utils_eq(model.uf, $author$project$Api$Data$Loading)),
								$author$project$Ui$Button$onClick($author$project$Components$Rainforest$SimulateApplicationEventModal$Simulate)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Simulate')
							]))
					]))
			]));
};
var $author$project$Components$PaymentProcessing$viewCreateAccountBody = F2(
	function (isOnboarding, isStripeEmbedded) {
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label(
						isOnboarding ? '' : 'Status'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8),
						$author$project$Ui$Form$Group$inputSpanMd(6)
					]),
				_List_fromArray(
					[
						isOnboarding ? $author$project$Utils$Html$empty : A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Ui$Badge$fromString, _List_Nil, 'inactive')
							])),
						isStripeEmbedded ? A2(
						$author$project$Ui$Typography$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Connect your Stripe account to start accepting payments through Hint.')
							])) : A2(
						$author$project$Ui$Typography$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('This platform streamlines the process of accepting patient payments by providing a secure, compliant, and efficient solution.'),
								$elm$html$Html$text(' To configure your Payment Processing account, click \"Connect\".')
							]))
					]))
			]);
	});
var $author$project$Components$PaymentProcessing$ConnectToStripe = {$: 44};
var $author$project$Components$PaymentProcessing$CreateRainforestAccount = {$: 1};
var $author$project$Components$PaymentProcessing$SkipSetup = {$: 5};
var $author$project$Components$PaymentProcessing$viewCreateAccountFooter = function (_v0) {
	var model = _v0;
	var isStripeEmbedded = A2($author$project$Api$Provider$Practice$One$featureEnabled, 26, model.ZV);
	var connectButton = isStripeEmbedded ? A3(
		$author$project$Ui$Button$view,
		{mm: 'Connect to Stripe'},
		_List_fromArray(
			[
				$author$project$Ui$Button$primary,
				$author$project$Ui$Button$onClick($author$project$Components$PaymentProcessing$ConnectToStripe)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Connect to Stripe')
			])) : A3(
		$author$project$Ui$Button$view,
		{mm: 'Connect account'},
		_List_fromArray(
			[
				$author$project$Ui$Button$primary,
				$author$project$Ui$Button$onClick($author$project$Components$PaymentProcessing$CreateRainforestAccount)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Connect')
			]));
	return model.bb ? _List_fromArray(
		[
			A3(
			$author$project$Ui$Button$view,
			{mm: 'Skip account creation'},
			_List_fromArray(
				[
					$author$project$Ui$Button$secondary,
					$author$project$Ui$Button$onClick($author$project$Components$PaymentProcessing$SkipSetup)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Skip')
				])),
			connectButton
		]) : _List_fromArray(
		[connectButton]);
};
var $author$project$Components$PaymentProcessing$EnableRainforest = {$: 7};
var $author$project$Components$PaymentProcessing$MerchantOnboardingSubmitted = {$: 3};
var $author$project$Components$PaymentProcessing$MigrateBackToStripe = {$: 40};
var $author$project$Components$PaymentProcessing$OpenSimulateModal = {$: 10};
var $author$project$Components$PaymentProcessing$RunPlatformMigration = {$: 36};
var $author$project$Components$PaymentProcessing$applicationIsProcessing = F2(
	function (rainforestAccount, _v0) {
		var merchantOnboardingSubmitted = _v0.AX;
		return merchantOnboardingSubmitted || ('processing' === $author$project$Api$Provider$RainforestAccount$One$merchantApplicationStatus(rainforestAccount));
	});
var $author$project$Api$Provider$RainforestAccount$One$depositAccountAccountType = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$RainforestAccount$One$record,
	function ($) {
		return $.Qn;
	});
var $author$project$Api$Provider$RainforestAccount$One$depositAccountBankName = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$RainforestAccount$One$record,
	function ($) {
		return $.Qo;
	});
var $author$project$Api$Provider$RainforestAccount$One$depositAccountLast4 = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$RainforestAccount$One$record,
	function ($) {
		return $.Qp;
	});
var $author$project$Api$Provider$RainforestAccount$One$depositAccountRoutingNumber = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$RainforestAccount$One$record,
	function ($) {
		return $.Qq;
	});
var $author$project$Api$Provider$RainforestAccount$One$depositFrequency = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$RainforestAccount$One$record,
	function ($) {
		return $.ags;
	});
var $author$project$Ui$HinterOnly$linkRoute = F3(
	function (route, options, content) {
		return A3(
			$author$project$Ui$Link$route,
			route,
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Link$icon($author$project$Ui$HinterOnly$icon),
				options),
			content);
	});
var $author$project$Ui$Alert$Attrs = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Alert$mb2 = $author$project$Ui$Alert$Attrs(
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mb-2')
		]));
var $author$project$Api$Provider$RainforestAccount$One$merchantApplicationId = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$RainforestAccount$One$record,
	function ($) {
		return $.W$;
	});
var $author$project$Api$Provider$RainforestAccount$One$merchantId = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$RainforestAccount$One$record,
	function ($) {
		return $.W1;
	});
var $author$project$Api$Provider$RainforestAccount$One$platformTokenMigrationCompletedAt = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$RainforestAccount$One$record,
	function ($) {
		return $.ZI;
	});
var $author$project$Api$Provider$RainforestAccount$One$statementDescriptor = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$RainforestAccount$One$record,
	function ($) {
		return $.acc;
	});
var $author$project$Ui$Alert$textLeft = $author$project$Ui$Alert$Alignment($author$project$Ui$Alignment$textLeft);
var $author$project$WebComponents$Rainforest$MerchantOnboarding$view = F2(
	function (msg, data) {
		return A3(
			$elm$html$Html$node,
			'rainforest-merchant-onboarding',
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'session-key', data.alo),
					A2($elm$html$Html$Attributes$attribute, 'merchant-id', data.W1),
					A2($elm$html$Html$Attributes$attribute, 'merchant-application-id', data.W$),
					A2($elm$html$Html$Attributes$attribute, 'hide-display-header', ''),
					A2(
					$elm$html$Html$Events$on,
					'submitted',
					$elm$json$Json$Decode$succeed(msg)),
					A2($elm$html$Html$Attributes$attribute, 'style-button-color', 'var(--color-primary-300)'),
					A2($elm$html$Html$Attributes$attribute, 'style-button-border-radius', '9999px'),
					A2($elm$html$Html$Attributes$attribute, 'style-font-family', 'sans-serif'),
					A2($elm$html$Html$Attributes$attribute, 'terms-and-conditions-url', 'https://www.hint.com/terms-processing')
				]),
			_List_Nil);
	});
var $author$project$Components$PaymentProcessing$UpdateDepositFrequency = function (a) {
	return {$: 42, a: a};
};
var $author$project$Components$PaymentProcessing$viewDepositFrequencyButton = F4(
	function (updateRequest, currentDepositFrequency, depositFrequency, label) {
		return A3(
			$author$project$Ui$Button$view,
			{mm: label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(currentDepositFrequency, depositFrequency)),
					$author$project$Ui$Button$onClick(
					$author$project$Components$PaymentProcessing$UpdateDepositFrequency(depositFrequency)),
					$author$project$Ui$Button$loading(
					_Utils_eq(updateRequest, $author$project$Api$Data$Loading))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Components$PaymentProcessing$viewInProgressAlert = A2(
	$author$project$Ui$Alert$info,
	_List_fromArray(
		[$author$project$Ui$Alert$mb2, $author$project$Ui$Alert$textLeft]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$strong,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Setup Hint Payments')
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('To start processing payments in Hint, please complete the form below. It takes about 5–10 minutes and requires key details like your account’s contact info, tax ID, bank details, and ownership info (including SSN).')
				]))
		]));
var $author$project$Components$PaymentProcessing$viewInReviewAlert = A2(
	$author$project$Ui$Alert$info,
	_List_fromArray(
		[$author$project$Ui$Alert$mb2, $author$project$Ui$Alert$textLeft]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$strong,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Application Submitted — Under Review')
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Thank you for submitting your payment setup form! We’re currently reviewing your details — this usually takes a few business days. No action is needed right now.')
				]))
		]));
var $author$project$Components$PaymentProcessing$viewHasAccountBody = F2(
	function (rainforestAccount, _v0) {
		var model = _v0;
		return $elm$core$List$concat(
			_List_fromArray(
				[
					model.bb ? _List_Nil : _List_fromArray(
					[
						function () {
						var _v1 = $author$project$Api$Provider$RainforestAccount$One$merchantApplicationStatus(rainforestAccount);
						switch (_v1) {
							case 'created':
								return $author$project$Components$PaymentProcessing$viewInProgressAlert;
							case 'in_progress':
								return $author$project$Components$PaymentProcessing$viewInProgressAlert;
							case 'processing':
								return $author$project$Components$PaymentProcessing$viewInReviewAlert;
							case 'in_review':
								return $author$project$Components$PaymentProcessing$viewInReviewAlert;
							case 'needs_information':
								return A2(
									$author$project$Ui$Alert$info,
									_List_fromArray(
										[$author$project$Ui$Alert$mb2, $author$project$Ui$Alert$textLeft]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Action Needed — More Info Required')
												])),
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('To finish setting up Hint Payments, we need a bit more information. Please use the form below to provide the missing details. Once submitted, we’ll review and confirm your setup — usually within a few business days. We’ll notify you by email when it\'s complete.')
												]))
										]));
							case 'completed':
								return A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$label('Status'),
											$author$project$Ui$Form$Group$labelSpanSm(4),
											$author$project$Ui$Form$Group$inputSpanSm(8)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Badge$fromString,
													_List_Nil,
													$author$project$Api$Provider$RainforestAccount$One$status(rainforestAccount))
												]))
										]));
							default:
								return $elm$html$Html$text('');
						}
					}()
					]),
					function () {
					var _v2 = $author$project$Api$Provider$RainforestAccount$One$merchantApplicationStatus(rainforestAccount);
					if (_v2 === 'completed') {
						return $elm$core$List$concat(
							_List_fromArray(
								[
									_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$label('Statement Descriptor'),
												$author$project$Ui$Form$Group$labelSpanSm(4),
												$author$project$Ui$Form$Group$inputSpanSm(8)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Static$view,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2(
															$elm$core$Maybe$withDefault,
															'N/A',
															$author$project$Api$Provider$RainforestAccount$One$statementDescriptor(rainforestAccount)))
													]))
											])),
										model.Ij ? A2(
										$author$project$Ui$HinterOnly$formGroup,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$label('Deposit Frequency'),
												$author$project$Ui$Form$Group$labelSpanSm(4),
												$author$project$Ui$Form$Group$inputSpanSm(8)
											]),
										_List_fromArray(
											[
												$author$project$Ui$Button$group(
												_List_fromArray(
													[
														A4(
														$author$project$Components$PaymentProcessing$viewDepositFrequencyButton,
														model.qP,
														$author$project$Api$Provider$RainforestAccount$One$depositFrequency(rainforestAccount),
														'daily',
														'Daily'),
														A4(
														$author$project$Components$PaymentProcessing$viewDepositFrequencyButton,
														model.qP,
														$author$project$Api$Provider$RainforestAccount$One$depositFrequency(rainforestAccount),
														'weekly',
														'Weekly'),
														A4(
														$author$project$Components$PaymentProcessing$viewDepositFrequencyButton,
														model.qP,
														$author$project$Api$Provider$RainforestAccount$One$depositFrequency(rainforestAccount),
														'monthly',
														'Monthly'),
														A4(
														$author$project$Components$PaymentProcessing$viewDepositFrequencyButton,
														model.qP,
														$author$project$Api$Provider$RainforestAccount$One$depositFrequency(rainforestAccount),
														'disabled',
														'Disabled')
													])),
												A2(
												$author$project$Ui$Typography$p,
												_List_fromArray(
													[$author$project$Ui$Typography$helpBlock]),
												_List_fromArray(
													[
														$elm$html$Html$text('Deposits will be processed on '),
														function () {
														var _v3 = $author$project$Api$Provider$RainforestAccount$One$depositFrequency(rainforestAccount);
														switch (_v3) {
															case 'daily':
																return $elm$html$Html$text('each US banking day');
															case 'weekly':
																return $elm$html$Html$text('the first US banking day of the week');
															case 'monthly':
																return $elm$html$Html$text('the first US banking day of the month');
															case 'disabled':
																return $elm$html$Html$text('never');
															default:
																return $elm$html$Html$text('N/A');
														}
													}()
													]))
											])) : $author$project$Utils$Html$empty,
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$label('Deposit Account'),
												$author$project$Ui$Form$Group$labelSpanSm(4),
												$author$project$Ui$Form$Group$inputSpanSm(8)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Static$view,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$text,
														_List_fromArray(
															[$author$project$Ui$Typography$bold]),
														'Bank Name: '),
														$elm$html$Html$text(
														A2(
															$elm$core$Maybe$withDefault,
															'N/A',
															$author$project$Api$Provider$RainforestAccount$One$depositAccountBankName(rainforestAccount)))
													])),
												A2(
												$author$project$Ui$Form$Static$view,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$text,
														_List_fromArray(
															[$author$project$Ui$Typography$bold]),
														'Last 4: '),
														$elm$html$Html$text(
														A2(
															$elm$core$Maybe$withDefault,
															'N/A',
															$author$project$Api$Provider$RainforestAccount$One$depositAccountLast4(rainforestAccount)))
													])),
												A2(
												$author$project$Ui$Form$Static$view,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$text,
														_List_fromArray(
															[$author$project$Ui$Typography$bold]),
														'Routing Number: '),
														$elm$html$Html$text(
														A2(
															$elm$core$Maybe$withDefault,
															'N/A',
															$author$project$Api$Provider$RainforestAccount$One$depositAccountRoutingNumber(rainforestAccount)))
													])),
												A2(
												$author$project$Ui$Form$Static$view,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$text,
														_List_fromArray(
															[$author$project$Ui$Typography$bold]),
														'Account Type: '),
														$elm$html$Html$text(
														A2(
															$elm$core$Maybe$withDefault,
															'N/A',
															$author$project$Api$Provider$RainforestAccount$One$depositAccountAccountType(rainforestAccount)))
													]))
											]))
									]),
									model.Ij ? _List_fromArray(
									[
										A2(
										$author$project$Ui$HinterOnly$formGroup,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$label('Payment Processor'),
												$author$project$Ui$Form$Group$labelSpanSm(4),
												$author$project$Ui$Form$Group$inputSpanSm(8)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Static$view,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$core$Maybe$withDefault,
														$author$project$Utils$Html$empty,
														A4(
															$author$project$Utils$PaymentProcessor$toBadge,
															true,
															true,
															model.ZV,
															A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$paymentProcessor, $elm$core$Maybe$Just))),
														($author$project$Api$Provider$Practice$One$paymentProcessor(model.ZV) !== 'rainforest') ? A3(
														$author$project$Ui$HinterOnly$button,
														{mm: 'Switch payment processor to rainforest'},
														_List_fromArray(
															[
																$author$project$Ui$Button$secondary,
																$author$project$Ui$Button$sm,
																$author$project$Ui$Button$loading(
																_Utils_eq(model.nx, $author$project$Api$Data$Loading)),
																$author$project$Ui$Button$onClick($author$project$Components$PaymentProcessing$EnableRainforest)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Switch to Rainforest')
															])) : ($author$project$Api$Provider$Practice$One$hasStripeAccount(model.ZV) ? A3(
														$author$project$Ui$HinterOnly$button,
														{mm: 'Migrate back to stripe'},
														_List_fromArray(
															[
																$author$project$Ui$Button$secondary,
																$author$project$Ui$Button$sm,
																$author$project$Ui$Button$onClick($author$project$Components$PaymentProcessing$MigrateBackToStripe)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Migrate back to Stripe')
															])) : $author$project$Utils$Html$empty),
														A3(
														$author$project$Ui$HinterOnly$linkRoute,
														$author$project$Spa$Generated$Route$Admin__PaymentMethodImport,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Manage Payment Sources Import')
															]))
													]))
											])),
										A2(
										$author$project$Ui$HinterOnly$formGroup,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$label('Rainforest Merchant ID'),
												$author$project$Ui$Form$Group$labelSpanSm(4),
												$author$project$Ui$Form$Group$inputSpanSm(8)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Static$view,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2(
															$elm$core$Maybe$withDefault,
															'',
															$author$project$Api$Provider$RainforestAccount$One$merchantId(rainforestAccount)))
													]))
											])),
										A2(
										$author$project$Ui$HinterOnly$formGroup,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$label('Platform Migration Completed At'),
												$author$project$Ui$Form$Group$labelSpanSm(4),
												$author$project$Ui$Form$Group$inputSpanSm(8)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Static$view,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2(
															$elm$core$Maybe$withDefault,
															'N/A',
															A2(
																$elm$core$Maybe$map,
																model.J7(1),
																$author$project$Api$Provider$RainforestAccount$One$platformTokenMigrationCompletedAt(rainforestAccount)))),
														_Utils_eq(
														$author$project$Api$Provider$RainforestAccount$One$platformTokenMigrationCompletedAt(rainforestAccount),
														$elm$core$Maybe$Nothing) ? A3(
														$author$project$Ui$HinterOnly$button,
														{mm: 'Run platform migration'},
														_List_fromArray(
															[
																$author$project$Ui$Button$secondary,
																$author$project$Ui$Button$sm,
																$author$project$Ui$Button$loading(
																_Utils_eq(model.pO, $author$project$Api$Data$Loading)),
																$author$project$Ui$Button$onClick($author$project$Components$PaymentProcessing$RunPlatformMigration)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Run platform migration')
															])) : $author$project$Utils$Html$empty
													]))
											]))
									]) : _List_Nil
								]));
					} else {
						return _List_fromArray(
							[
								model.bb ? $author$project$Utils$Html$empty : A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Application Status'),
										$author$project$Ui$Form$Group$labelSpanSm(4),
										$author$project$Ui$Form$Group$inputSpanSm(8)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Static$view,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Badge$fromString,
												_List_Nil,
												$author$project$Api$Provider$RainforestAccount$One$merchantApplicationStatus(rainforestAccount))
											]))
									])),
								(model.Ij && (model.DH && A2($author$project$Components$PaymentProcessing$applicationIsProcessing, rainforestAccount, model))) ? A2(
								$author$project$Ui$HinterOnly$formGroup,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$labelSpanSm(4),
										$author$project$Ui$Form$Group$inputSpanSm(8),
										$author$project$Ui$Form$Group$label('')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Static$view,
										_List_Nil,
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Button$view,
												{mm: 'Simulate status change'},
												_List_fromArray(
													[
														$author$project$Ui$Button$secondary,
														$author$project$Ui$Button$sm,
														$author$project$Ui$Button$onClick($author$project$Components$PaymentProcessing$OpenSimulateModal)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Simulate Status Change')
													]))
											]))
									])) : $author$project$Utils$Html$empty
							]);
					}
				}(),
					function () {
					var _v4 = _Utils_Tuple3(
						A2($author$project$Components$PaymentProcessing$applicationIsProcessing, rainforestAccount, model),
						$author$project$Api$Provider$RainforestAccount$One$merchantApplicationStatus(rainforestAccount),
						model.Ey);
					_v4$1:
					while (true) {
						if (_v4.a) {
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$label(''),
											$author$project$Ui$Form$Group$labelSpanSm(4),
											$author$project$Ui$Form$Group$inputSpanMd(12),
											$author$project$Ui$Form$Group$inputSpanSm(8)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$p,
											_List_fromArray(
												[$author$project$Ui$Typography$helpBlock]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Your payment processing account is under review, we will notify you when it\'s approved or if more information is needed.')
														]))
												]))
										]))
								]);
						} else {
							if (!_v4.c.$) {
								if (_v4.b === 'completed') {
									break _v4$1;
								} else {
									var setupSessionKey = _v4.c.a;
									return _List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Group$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Group$label(''),
													model.bb ? $author$project$Ui$Form$Group$labelSpanSm(0) : $author$project$Ui$Form$Group$labelSpanSm(4),
													model.bb ? $author$project$Ui$Form$Group$inputSpanMd(12) : $author$project$Ui$Form$Group$inputSpanMd(8)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$WebComponents$Rainforest$MerchantOnboarding$view,
													$author$project$Components$PaymentProcessing$MerchantOnboardingSubmitted,
													{
														W$: A2(
															$elm$core$Maybe$withDefault,
															'',
															$author$project$Api$Provider$RainforestAccount$One$merchantApplicationId(rainforestAccount)),
														W1: A2(
															$elm$core$Maybe$withDefault,
															'',
															$author$project$Api$Provider$RainforestAccount$One$merchantId(rainforestAccount)),
														alo: setupSessionKey
													})
												]))
										]);
								}
							} else {
								if (_v4.b === 'completed') {
									break _v4$1;
								} else {
									var _v5 = _v4.c;
									return _List_Nil;
								}
							}
						}
					}
					return _List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label(''),
									$author$project$Ui$Form$Group$labelSpanSm(4),
									$author$project$Ui$Form$Group$inputSpanMd(12),
									$author$project$Ui$Form$Group$inputSpanSm(8)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$helpBlock]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('You can review your patient payment report ')
												])),
											A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$Reports__PaymentApplications,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('here')
												])),
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('.')
												]))
										]))
								]))
						]);
				}()
				]));
	});
var $author$project$Components$PaymentProcessing$PrefillWithFakeDataClicked = {$: 14};
var $author$project$Components$PaymentProcessing$viewHasAccountFooter = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				function () {
				var _v0 = _Utils_Tuple2(
					model.Ij && model.DH,
					A2($author$project$Api$Data$map, $author$project$Api$Provider$RainforestAccount$One$status, model.cQ));
				if ((_v0.a && (_v0.b.$ === 3)) && (_v0.b.a === 'pending')) {
					var _v1 = _v0.b;
					return A3(
						$author$project$Ui$HinterOnly$button,
						{mm: 'Prefill with fake data'},
						_List_fromArray(
							[
								$author$project$Ui$Button$secondary,
								$author$project$Ui$Button$onClick($author$project$Components$PaymentProcessing$PrefillWithFakeDataClicked)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Prefill')
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				model.bb ? A3(
				$author$project$Ui$Button$view,
				{mm: 'Skip and finish later'},
				_List_fromArray(
					[
						$author$project$Ui$Button$secondary,
						$author$project$Ui$Button$onClick($author$project$Components$PaymentProcessing$SkipSetup)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Finish Later')
					])) : $author$project$Utils$Html$empty
			]));
};
var $author$project$Components$PaymentProcessing$viewLoadingBody = _List_fromArray(
	[
		A2(
		$author$project$Ui$Typography$p,
		_List_fromArray(
			[
				$author$project$Ui$Typography$helpBlock,
				$author$project$Ui$Typography$muted,
				$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Spinner$view(_List_Nil)
			]))
	]);
var $author$project$Components$PaymentProcessing$DisconnectStripe = {$: 50};
var $author$project$Components$PaymentProcessing$ShowStripeSupportChat = {$: 53};
var $author$project$Ui$HinterOnly$linkHref = F3(
	function (externalHref_, options, content) {
		return A3(
			$author$project$Ui$Link$externalHref,
			externalHref_,
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Link$icon($author$project$Ui$HinterOnly$icon),
				options),
			content);
	});
var $author$project$Components$Stripe$ConnectedView$ActionRequired = 2;
var $author$project$Components$Stripe$ConnectedView$Connected = 0;
var $author$project$Components$Stripe$ConnectedView$UnderReview = 1;
var $author$project$Components$Stripe$ConnectedView$stripeStatus = function (config) {
	if (config.afG) {
		return 0;
	} else {
		var _v0 = config.agz;
		_v0$2:
		while (true) {
			if (!_v0.$) {
				switch (_v0.a) {
					case 'requirements.pending_verification':
						return 1;
					case 'under_review':
						return 1;
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return 2;
	}
};
var $author$project$Components$Stripe$ConnectedView$statusBadge = function (config) {
	var _v0 = $author$project$Components$Stripe$ConnectedView$stripeStatus(config);
	switch (_v0) {
		case 0:
			return A2($author$project$Ui$Badge$fromString, _List_Nil, 'connected');
		case 1:
			return A2(
				$author$project$Ui$Badge$view,
				_List_fromArray(
					[$author$project$Ui$Badge$warning]),
				_List_fromArray(
					[
						$elm$html$Html$text('Under Review')
					]));
		default:
			return A2(
				$author$project$Ui$Badge$view,
				_List_fromArray(
					[$author$project$Ui$Badge$danger]),
				_List_fromArray(
					[
						$elm$html$Html$text('Action Required')
					]));
	}
};
var $author$project$Components$Stripe$ConnectedView$statusHelpText = function (config) {
	var _v0 = $author$project$Components$Stripe$ConnectedView$stripeStatus(config);
	switch (_v0) {
		case 0:
			return A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$helpBlock]),
				_List_fromArray(
					[
						$elm$html$Html$text('You can review your patient payment report '),
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Reports__PaymentApplications,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('here')
							])),
						$elm$html$Html$text(' and our latest negotiated transaction fees '),
						A3(
						$author$project$Ui$Link$externalHref,
						'http://www.hint.com/pricing#stripe',
						_List_fromArray(
							[$author$project$Ui$Link$targetBlank]),
						_List_fromArray(
							[
								$elm$html$Html$text('here')
							])),
						$elm$html$Html$text('.'),
						$elm$html$Html$text('If you would like to disable this integration please '),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'contact us'},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$onClick(config.ajv)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('contact us')
							])),
						$elm$html$Html$text('.')
					]));
		case 1:
			return A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$helpBlock]),
				_List_fromArray(
					[
						$elm$html$Html$text('Your Stripe account is currently under review. This process typically takes 1-2 business days. You\'ll be notified by Stripe once your account is approved.')
					]));
		default:
			return A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$helpBlock]),
				_List_fromArray(
					[
						$elm$html$Html$text('Your Stripe account requires action before it can process payments. Please '),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'contact us'},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$onClick(config.ajv)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('contact us')
							])),
						$elm$html$Html$text(' or visit your Stripe Dashboard for more details.')
					]));
	}
};
var $author$project$Api$Provider$Practice$Shared$stripeLink = function (_v0) {
	var record = _v0;
	return record.acq;
};
var $author$project$Api$Provider$Practice$One$stripeLink = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$stripeLink(shared);
};
var $author$project$Components$Stripe$ConnectedView$view = function (config) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Status'),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_fromArray(
						[$author$project$Ui$Form$Static$flex, $author$project$Ui$Form$Static$spaceBetween, $author$project$Ui$Form$Static$itemsCenter]),
					_List_fromArray(
						[
							$author$project$Components$Stripe$ConnectedView$statusBadge(config),
							config.Ij ? A3(
							$author$project$Ui$HinterOnly$button,
							{mm: 'Disconnect from stripe'},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$onClick(config.ajf)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Disconnect From Stripe')
								])) : $author$project$Utils$Html$empty
						])),
					$author$project$Components$Stripe$ConnectedView$statusHelpText(config),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween]),
					function () {
						if (config.Ij) {
							var stripeLink = A2(
								$elm$core$Maybe$withDefault,
								'',
								$author$project$Api$Provider$Practice$One$stripeLink(config.ZV));
							return _List_fromArray(
								[
									A3(
									$author$project$Ui$HinterOnly$linkHref,
									stripeLink,
									_List_fromArray(
										[$author$project$Ui$Link$targetBlank]),
									_List_fromArray(
										[
											$elm$html$Html$text(' View on Stripe')
										]))
								]);
						} else {
							return _List_Nil;
						}
					}())
				]))
		]);
};
var $author$project$Components$PaymentProcessing$viewStripeConnectedBody = function (model) {
	return _Utils_ap(
		$author$project$Components$Stripe$ConnectedView$view(
			{afG: model.EP, agz: model.EQ, Ij: model.Ij, ajf: $author$project$Components$PaymentProcessing$DisconnectStripe, ajv: $author$project$Components$PaymentProcessing$ShowStripeSupportChat, ZV: model.ZV}),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id('stripe-account-management')
					]),
				_List_Nil)
			]));
};
var $author$project$Components$PaymentProcessing$viewStripeConnectingBody = _List_fromArray(
	[
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Status'),
				$author$project$Ui$Form$Group$labelSpanSm(4),
				$author$project$Ui$Form$Group$inputSpanSm(8)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$Ui$Badge$fromString, _List_Nil, 'connecting')
					])),
				A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$helpBlock, $author$project$Ui$Typography$muted]),
				_List_fromArray(
					[
						$author$project$Ui$Spinner$view(_List_Nil)
					]))
			]))
	]);
var $elm$html$Html$Attributes$hidden = $elm$html$Html$Attributes$boolProperty('hidden');
var $author$project$Components$PaymentProcessing$viewStripeEmbeddedOnboardingBody = function (showStepOneAlert) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$hidden(!showStepOneAlert)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Alert$warning,
					_List_fromArray(
						[$author$project$Ui$Alert$mb2, $author$project$Ui$Alert$textLeft]),
					_List_fromArray(
						[
							$elm$html$Html$text('STEP ONE: To get started, verify your new Stripe account through the link sent to your practice\'s email address. Then proceed to complete the form below.')
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('stripe-account-onboarding')
				]),
			_List_Nil)
		]);
};
var $author$project$Components$PaymentProcessing$BankAccount = 1;
var $author$project$Components$PaymentProcessing$Card = 0;
var $author$project$Ui$Element$mb3 = $author$project$Ui$Element$Margin('mb-3');
var $author$project$Components$PaymentProcessing$DeleteAll = function (a) {
	return {$: 26, a: a};
};
var $author$project$Components$PaymentProcessing$PaginationMsg = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Components$PaymentProcessing$RequestPaymentInfoUpdateAll = function (a) {
	return {$: 29, a: a};
};
var $author$project$Components$PaymentProcessing$SortTable = F2(
	function (a, b) {
		return {$: 19, a: a, b: b};
	});
var $author$project$Api$Data$getIntFromHeaders = F2(
	function (data, headerName) {
		if (data.$ === 3) {
			var headers = data.b;
			return A2(
				$elm$core$Maybe$andThen,
				$elm$core$String$toInt,
				A2($elm$core$Dict$get, headerName, headers));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$PaymentProcessing$paymentMethodsOnStripeColumns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, '', false, 'Owner'),
		A3($author$project$Api$Column$init, '', false, 'Payment Method'),
		A3($author$project$Api$Column$init, '', false, 'Status'),
		A3($author$project$Api$Column$init, 'last_used_at', true, 'Last Used'),
		A3($author$project$Api$Column$init, '', false, '')
	]);
var $author$project$Components$PaymentProcessing$Delete = F2(
	function (a, b) {
		return {$: 20, a: a, b: b};
	});
var $author$project$Components$PaymentProcessing$RequestPaymentInfoUpdate = F2(
	function (a, b) {
		return {$: 23, a: a, b: b};
	});
var $author$project$Api$Provider$StripePaymentMethodMigration$All$isDefault = function (_v0) {
	var record = _v0;
	return record.UM;
};
var $author$project$Api$Provider$StripePaymentMethodMigration$All$lastUsedAt = function (_v0) {
	var record = _v0;
	return record.VO;
};
var $author$project$Api$Provider$StripePaymentMethodMigration$All$paymentMethodBrand = function (_v0) {
	var record = _v0;
	return record.abK;
};
var $author$project$Api$Provider$StripePaymentMethodMigration$All$requestPayInfoSentAt = function (_v0) {
	var record = _v0;
	return record.$B;
};
var $author$project$Components$PaymentSourceDisplayer$StripePaymentMethodMigration = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$PaymentSourceDisplayer$stripePaymentMethodMigration = $author$project$Components$PaymentSourceDisplayer$StripePaymentMethodMigration;
var $author$project$Components$PaymentProcessing$viewPaymentMethodOnStripe = F5(
	function (timeFormatter, canGoToPatients, canGoToCompany, paymentMethodType, paymentMethod) {
		var owner = $author$project$Api$Provider$StripePaymentMethodMigration$All$owner(paymentMethod);
		var ownerName = A2(
			$elm$core$Maybe$withDefault,
			'N/A',
			A2($elm$core$Maybe$map, $author$project$Api$Common$Payable$Owner$Min$name, owner));
		var ownerPath = A2(
			$elm$core$Maybe$andThen,
			function (owner_) {
				var _v3 = $author$project$Api$Common$Payable$Owner$Min$type_(owner_);
				switch (_v3) {
					case 'Patient':
						return canGoToPatients ? $elm$core$Maybe$Just(
							$author$project$Spa$Generated$Route$Patients__PatientId_String__Accounts__Top(
								{
									YZ: $author$project$Api$Common$Payable$Owner$Min$id(owner_)
								})) : $elm$core$Maybe$Nothing;
					case 'Company':
						return canGoToCompany ? $elm$core$Maybe$Just(
							$author$project$Spa$Generated$Route$Companies__CompanyId_String__PaymentSources(
								{
									fZ: $author$project$Api$Common$Payable$Owner$Min$id(owner_)
								})) : $elm$core$Maybe$Nothing;
					default:
						return $elm$core$Maybe$Nothing;
				}
			},
			owner);
		var lastFour = A2(
			$elm$core$Maybe$withDefault,
			'',
			$author$project$Api$Provider$StripePaymentMethodMigration$All$lastFour(paymentMethod));
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							if (!ownerPath.$) {
								var ownerPath_ = ownerPath.a;
								return A3(
									$author$project$Ui$Link$route,
									ownerPath_,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(ownerName)
										]));
							} else {
								return $elm$html$Html$text(ownerName);
							}
						}()
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$StripePaymentMethodMigration$All$paymentMethodBrand(paymentMethod) + (' ' + lastFour))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Components$PaymentSourceDisplayer$view,
							timeFormatter,
							_List_fromArray(
								[
									$author$project$Components$PaymentSourceDisplayer$stripePaymentMethodMigration(paymentMethod),
									$author$project$Components$PaymentSourceDisplayer$showProcessor(false)
								])),
							$author$project$Api$Provider$StripePaymentMethodMigration$All$isDefault(paymentMethod) ? A2($author$project$Ui$Badge$fromString, _List_Nil, 'default') : $author$project$Utils$Html$empty
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[$author$project$Ui$Typography$muted]),
							A2(
								$elm$core$Maybe$withDefault,
								'Never',
								A2(
									$elm$core$Maybe$map,
									timeFormatter(1),
									$author$project$Api$Provider$StripePaymentMethodMigration$All$lastUsedAt(paymentMethod))))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$textRight]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Delete payment method'},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$sm,
									$author$project$Ui$Button$onClick(
									A2($author$project$Components$PaymentProcessing$Delete, paymentMethodType, paymentMethod)),
									$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Delete')
								])),
							function () {
							var _v1 = A2($elm$core$Maybe$map, $author$project$Api$Common$Payable$Owner$Min$type_, owner);
							_v1$2:
							while (true) {
								if (!_v1.$) {
									switch (_v1.a) {
										case 'Patient':
											var lastRequestSent = function () {
												var _v2 = $author$project$Api$Provider$StripePaymentMethodMigration$All$requestPayInfoSentAt(paymentMethod);
												if (!_v2.$) {
													var patientRequestInfoSentAt_ = _v2.a;
													var sentAt = A2(timeFormatter, 1, patientRequestInfoSentAt_);
													return A2(
														$author$project$Ui$Typography$text,
														_List_fromArray(
															[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
														'Last request sent ' + (sentAt + '.'));
												} else {
													return $author$project$Utils$Html$empty;
												}
											}();
											return A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$justifyRight]),
												_List_fromArray(
													[
														A3(
														$author$project$Ui$Button$view,
														{mm: 'Request new payment information'},
														_List_fromArray(
															[
																$author$project$Ui$Button$link,
																$author$project$Ui$Button$sm,
																$author$project$Ui$Button$onClick(
																A2($author$project$Components$PaymentProcessing$RequestPaymentInfoUpdate, paymentMethodType, paymentMethod)),
																$author$project$Ui$Button$icon($author$project$Ui$Icon$send)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Request new payment information')
															])),
														A2($elm$html$Html$br, _List_Nil, _List_Nil),
														lastRequestSent
													]));
										case 'Company':
											return A3(
												$author$project$Ui$Tooltip$view,
												_List_Nil,
												'Please reach out to the company directly',
												_List_fromArray(
													[
														A3(
														$author$project$Ui$Button$view,
														{mm: 'Request new payment information'},
														_List_fromArray(
															[
																$author$project$Ui$Button$link,
																$author$project$Ui$Button$sm,
																$author$project$Ui$Button$disabled(true),
																$author$project$Ui$Button$icon($author$project$Ui$Icon$send)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Request new payment information')
															]))
													]));
										default:
											break _v1$2;
									}
								} else {
									break _v1$2;
								}
							}
							return $author$project$Utils$Html$empty;
						}()
						]))
				]));
	});
var $author$project$Components$PaymentProcessing$viewPaymentMethodsOnStripe = F2(
	function (model, paymentMethodType) {
		var _v0 = function () {
			if (!paymentMethodType) {
				return _Utils_Tuple3(model.c7, model.mG, model.fT);
			} else {
				return _Utils_Tuple3(model.c0, model.mr, model.fM);
			}
		}();
		var paymentMethodsOnStripe = _v0.a;
		var sort = _v0.b;
		var pagination = _v0.c;
		var onStripeCount = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($author$project$Api$Data$getIntFromHeaders, paymentMethodsOnStripe, 'x-total-count'));
		if (onStripeCount > 0) {
			var title = function () {
				if (!paymentMethodType) {
					return 'Cards';
				} else {
					return 'Bank Accounts';
				}
			}();
			var onRainforestCount = A2(
				$elm$core$Maybe$withDefault,
				0,
				A2($author$project$Api$Data$getIntFromHeaders, paymentMethodsOnStripe, 'x-on-rainforest-count'));
			var totalCount = onStripeCount + onRainforestCount;
			var _v2 = function () {
				if (paymentMethodsOnStripe.$ === 3) {
					var list_ = paymentMethodsOnStripe.a;
					return _Utils_Tuple2(false, list_);
				} else {
					return _Utils_Tuple2(true, _List_Nil);
				}
			}();
			var loading = _v2.a;
			var list = _v2.b;
			return A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap2]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$spaceBetween]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$text,
										_List_fromArray(
											[$author$project$Ui$Typography$bold]),
										title),
										$elm$html$Html$text(' - '),
										A2(
										$author$project$Ui$Typography$text,
										_List_fromArray(
											[$author$project$Ui$Typography$info]),
										'Total Payment Methods: '),
										A2(
										$author$project$Ui$Typography$text,
										_List_fromArray(
											[$author$project$Ui$Typography$info]),
										$elm$core$String$fromInt(totalCount)),
										$elm$html$Html$text(' - '),
										A2(
										$author$project$Ui$Typography$text,
										_List_fromArray(
											[$author$project$Ui$Typography$success]),
										'Live on Hint Payments: '),
										A2(
										$author$project$Ui$Typography$text,
										_List_fromArray(
											[$author$project$Ui$Typography$success]),
										$elm$core$String$fromInt(onRainforestCount)),
										$elm$html$Html$text(' - '),
										A2(
										$author$project$Ui$Typography$text,
										_List_fromArray(
											[$author$project$Ui$Typography$danger]),
										'Remaining on Stripe: '),
										A2(
										$author$project$Ui$Typography$text,
										_List_fromArray(
											[$author$project$Ui$Typography$danger]),
										$elm$core$String$fromInt(onStripeCount))
									])),
								A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Request all payment methods'},
										_List_fromArray(
											[
												$author$project$Ui$Button$sm,
												$author$project$Ui$Button$loading(
												_Utils_eq(
													$elm$core$Maybe$Just($author$project$Api$Data$Loading),
													A2($elm$core$Maybe$map, $elm$core$Tuple$second, model.e2))),
												$author$project$Ui$Button$onClick(
												$author$project$Components$PaymentProcessing$RequestPaymentInfoUpdateAll(paymentMethodType)),
												$author$project$Ui$Button$icon($author$project$Ui$Icon$send)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Request All')
											])),
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Delete all payment methods'},
										_List_fromArray(
											[
												$author$project$Ui$Button$sm,
												$author$project$Ui$Button$loading(
												_Utils_eq(
													$elm$core$Maybe$Just($author$project$Api$Data$Loading),
													A2($elm$core$Maybe$map, $elm$core$Tuple$second, model.d7))),
												$author$project$Ui$Button$onClick(
												$author$project$Components$PaymentProcessing$DeleteAll(paymentMethodType)),
												$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Delete All')
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										A4(
										$author$project$Ui$Table$view,
										_List_fromArray(
											[
												$author$project$Ui$Table$loading(loading),
												$author$project$Ui$Table$zeroState(
												_List_fromArray(
													[
														$elm$html$Html$text('All payment methods are migrated to Hint Payments!')
													]))
											]),
										A2(
											$elm$core$List$map,
											$author$project$Api$Column$view(
												A2(
													$author$project$Api$Column$Sortable,
													sort,
													$author$project$Components$PaymentProcessing$SortTable(paymentMethodType))),
											$author$project$Components$PaymentProcessing$paymentMethodsOnStripeColumns),
										A2(
											$elm$core$List$map,
											A4($author$project$Components$PaymentProcessing$viewPaymentMethodOnStripe, model.J7, model.GQ, model.GP, paymentMethodType),
											list),
										_List_Nil)
									])),
								A2(
								$author$project$Ui$Panel$footer,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Components$PaymentProcessing$PaginationMsg(paymentMethodType),
										A2(
											$author$project$Api$Pagination$view,
											_List_fromArray(
												[
													$author$project$Ui$Pagination$List$loading(loading)
												]),
											pagination))
									]))
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$PaymentProcessing$viewStripePaymentSourceMigration = function (model) {
	var hasPaymentMethodsOnStripe = function () {
		var _v0 = _Utils_Tuple2(model.c7, model.c0);
		if ((_v0.a.$ === 3) && (_v0.b.$ === 3)) {
			var _v1 = _v0.a;
			var cardsOnStripe_ = _v1.a;
			var _v2 = _v0.b;
			var bankAccountsOnStripe_ = _v2.a;
			return (!$elm$core$List$isEmpty(cardsOnStripe_)) || (!$elm$core$List$isEmpty(bankAccountsOnStripe_));
		} else {
			return false;
		}
	}();
	return hasPaymentMethodsOnStripe ? A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('')
			]),
		_List_fromArray(
			[
				$author$project$Ui$Typography$headingSm(
				_List_fromArray(
					[
						$elm$html$Html$text('Stripe Payment Source Migration')
					])),
				A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$helpText]),
				_List_fromArray(
					[
						$elm$html$Html$text('Your transition to Hint Payments is nearly complete.'),
						A2($elm$html$Html$br, _List_Nil, _List_Nil),
						$elm$html$Html$text('Some patient payment sources are still on Stripe and may process there until migration is finished. '),
						$elm$html$Html$text('Use this dashboard to review or delete outdated sources, or request updated info to help wrap up your migration sooner.')
					])),
				A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$muted]),
				_List_fromArray(
					[
						$elm$html$Html$text('Note: This list excludes archived patients and companies')
					])),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mb3]),
				_List_fromArray(
					[
						A2($author$project$Components$PaymentProcessing$viewPaymentMethodsOnStripe, model, 0)
					])),
				A2($author$project$Components$PaymentProcessing$viewPaymentMethodsOnStripe, model, 1)
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Components$PaymentProcessing$view = function (_v0) {
	var model = _v0;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				function () {
				var _v1 = model.ek;
				if (!_v1.$) {
					var _v2 = _v1.a;
					var paymentMethodType = _v2.a;
					var paymentMethod = _v2.b;
					var deletingRequest = _v2.c;
					return A2(
						$author$project$Components$HiConfirm$modal,
						A2($author$project$Components$PaymentProcessing$DeleteHiConfirmClosed, paymentMethodType, paymentMethod),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('delete'),
								$author$project$Components$HiConfirm$noun('payment method'),
								$author$project$Components$HiConfirm$loading(
								_Utils_eq(deletingRequest, $author$project$Api$Data$Loading))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v3 = model.e3;
				if (!_v3.$) {
					var _v4 = _v3.a;
					var paymentMethodType = _v4.a;
					var paymentMethod = _v4.b;
					var requestingRequest = _v4.c;
					return A2(
						$author$project$Components$HiConfirm$modal,
						A2($author$project$Components$PaymentProcessing$RequestPaymentInfoHiConfirmClosed, paymentMethodType, paymentMethod),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('request'),
								$author$project$Components$HiConfirm$noun('payment info update'),
								$author$project$Components$HiConfirm$customMessage(
								_List_fromArray(
									[
										$elm$html$Html$text('You are about to send an email asking the patient to update this payment method.')
									])),
								$author$project$Components$HiConfirm$loading(
								_Utils_eq(requestingRequest, $author$project$Api$Data$Loading))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v5 = model.d7;
				if (!_v5.$) {
					var _v6 = _v5.a;
					var paymentMethodType = _v6.a;
					var deletingRequest = _v6.b;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Components$PaymentProcessing$DeleteAllHiConfirmClosed(paymentMethodType),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('delete all'),
								$author$project$Components$HiConfirm$noun('payment methods'),
								$author$project$Components$HiConfirm$buttonStyle(6),
								$author$project$Components$HiConfirm$loading(
								_Utils_eq(deletingRequest, $author$project$Api$Data$Loading))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v7 = model.e2;
				if (!_v7.$) {
					var _v8 = _v7.a;
					var paymentMethodType = _v8.a;
					var requestingRequest = _v8.b;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Components$PaymentProcessing$RequestPaymentInfoUpdateAllHiConfirmClosed(paymentMethodType),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('request'),
								$author$project$Components$HiConfirm$noun('payment info update'),
								$author$project$Components$HiConfirm$customMessage(
								_List_fromArray(
									[
										$elm$html$Html$text('You are about to send emails asking patients to update all payment methods .')
									])),
								$author$project$Components$HiConfirm$loading(
								_Utils_eq(requestingRequest, $author$project$Api$Data$Loading))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Rainforest$SimulateApplicationEventModal$view,
						$elm$html$Html$map($author$project$Components$PaymentProcessing$SimulateApplicationEventModalMsg)),
					model.lr)),
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Rainforest$ResetAccountModal$view,
						$elm$html$Html$map($author$project$Components$PaymentProcessing$ResetAccountModalMsg)),
					model.k_)),
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Rainforest$MigrateBackToStripeModal$view,
						$elm$html$Html$map($author$project$Components$PaymentProcessing$MigrateBackToStripeModalMsg)),
					model.kn)),
				model.hP ? A2(
				$author$project$Components$HiConfirm$modal,
				$author$project$Components$PaymentProcessing$StripeHiConfirmClosed,
				_List_fromArray(
					[
						$author$project$Components$HiConfirm$customMessage(
						_List_fromArray(
							[
								$elm$html$Html$text('WARNING: You\'re about to remove your ability to process credit cards and bank accounts! Please be sure this is what you want to do. If you reconnect the same Stripe account, then all existing cards / bank accounts will remain intact. Otherwise, they will not. Either way, this application will not be able to process any electronic transactions for you while you\'re account is disconnected.')
							]))
					])) : $author$project$Utils$Html$empty,
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$noValidate(true),
						$author$project$Ui$Form$autocomplete(false)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						model.bb ? _List_fromArray(
							[$author$project$Ui$Panel$onlyBorderLeft]) : _List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
										_List_fromArray(
											[
												$author$project$Ui$Panel$title(
												_List_fromArray(
													[
														model.bb ? $elm$html$Html$text('Setup Payment Processing') : $elm$html$Html$text('Payment Processing')
													])),
												function () {
												if (model.Ij) {
													var _v9 = model.alH;
													if (_v9.$ === 1) {
														var rainforestAccount = _v9.a;
														return A2(
															$author$project$Ui$Element$view,
															_List_fromArray(
																[$author$project$Ui$Element$gap2, $author$project$Ui$Element$justifyRight]),
															_List_fromArray(
																[
																	A3(
																	$author$project$Ui$HinterOnly$button,
																	{mm: 'Export Rainforest Mapping'},
																	_List_fromArray(
																		[
																			$author$project$Ui$Button$secondary,
																			$author$project$Ui$Button$onClick($author$project$Components$PaymentProcessing$ExportRainforestMapping),
																			$author$project$Ui$Button$loading(
																			_Utils_eq(model.nE, $author$project$Api$Data$Loading))
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Export Rainforest Mapping')
																		])),
																	A3(
																	$author$project$Ui$HinterOnly$button,
																	{mm: 'Sync with Rainforest'},
																	_List_fromArray(
																		[
																			$author$project$Ui$Button$secondary,
																			$author$project$Ui$Button$onClick($author$project$Components$PaymentProcessing$Sync),
																			$author$project$Ui$Button$loading(
																			_Utils_eq(model.qr, $author$project$Api$Data$Loading))
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Sync with Rainforest')
																		])),
																	A3(
																	$author$project$Ui$HinterOnly$button,
																	{mm: 'Reset Rainforest account'},
																	_List_fromArray(
																		[
																			$author$project$Ui$Button$secondary,
																			$author$project$Ui$Button$onClick($author$project$Components$PaymentProcessing$OpenResetAccountModal)
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Reset Rainforest account')
																		])),
																	($author$project$Api$Provider$RainforestAccount$One$status(rainforestAccount) === 'canceled') ? A3(
																	$author$project$Ui$HinterOnly$button,
																	{mm: 'Delete Rainforest account'},
																	_List_fromArray(
																		[
																			$author$project$Ui$Button$danger,
																			$author$project$Ui$Button$onClick($author$project$Components$PaymentProcessing$DeleteRainforestAccount),
																			$author$project$Ui$Button$loading(
																			_Utils_eq(model.f7, $author$project$Api$Data$Loading))
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Delete Rainforest account')
																		])) : $author$project$Utils$Html$empty
																]));
													} else {
														return $author$project$Utils$Html$empty;
													}
												} else {
													return $author$project$Utils$Html$empty;
												}
											}()
											])),
										model.bb ? A2(
										$author$project$Ui$Typography$p,
										_List_fromArray(
											[$author$project$Ui$Typography$muted]),
										_List_fromArray(
											[
												$elm$html$Html$text('Set up your Payment Processing account to start accepting payments.')
											])) : $author$project$Utils$Html$empty
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_Utils_ap(
									function () {
										var _v10 = model.alH;
										switch (_v10.$) {
											case 0:
												return $author$project$Components$PaymentProcessing$viewLoadingBody;
											case 1:
												var rainforestAccount = _v10.a;
												return A2($author$project$Components$PaymentProcessing$viewHasAccountBody, rainforestAccount, model);
											case 2:
												return A2(
													$author$project$Components$PaymentProcessing$viewCreateAccountBody,
													model.bb,
													A2($author$project$Api$Provider$Practice$One$featureEnabled, 26, model.ZV));
											case 3:
												return $author$project$Components$PaymentProcessing$viewStripeConnectingBody;
											case 4:
												return $author$project$Components$PaymentProcessing$viewStripeEmbeddedOnboardingBody(model.uG);
											default:
												return $author$project$Components$PaymentProcessing$viewStripeConnectedBody(model);
										}
									}(),
									(($author$project$Api$Provider$Practice$One$paymentProcessor(model.ZV) === 'rainforest') && (!model.bb)) ? _List_fromArray(
										[
											$author$project$Components$PaymentProcessing$viewStripePaymentSourceMigration(model)
										]) : _List_Nil)),
								function () {
								var _v11 = model.alH;
								switch (_v11.$) {
									case 2:
										return A2(
											$author$project$Ui$Panel$footer,
											_List_fromArray(
												[
													model.bb ? $author$project$Ui$Element$spaceBetween : $author$project$Ui$Element$justifyCenter,
													$author$project$Ui$Element$gap4
												]),
											$author$project$Components$PaymentProcessing$viewCreateAccountFooter(model));
									case 1:
										return A2(
											$author$project$Ui$Panel$footer,
											_List_fromArray(
												[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$gap4]),
											_List_fromArray(
												[
													$author$project$Components$PaymentProcessing$viewHasAccountFooter(model)
												]));
									default:
										return $author$project$Ui$Panel$none;
								}
							}()
							]))
					]))
			]));
};
var $author$project$Pages$Admin$PaymentProcessing$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$PaymentProcessing$view(model.o2))
			]),
		ac9: 'Admin | Payment Processing'
	};
};
var $author$project$Pages$Admin$PaymentProcessing$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$PaymentProcessing$init, aiq: $author$project$Pages$Admin$PaymentProcessing$load, k8: $author$project$Pages$Admin$PaymentProcessing$save, alO: $author$project$Pages$Admin$PaymentProcessing$subscriptions, adT: $author$project$Pages$Admin$PaymentProcessing$update, amo: $author$project$Pages$Admin$PaymentProcessing$view});
var $author$project$Pages$Admin$PaymentSources$Network = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$PaymentSources$NetworkPaymentsMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Admin$PaymentSources$Standard = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$PaymentSources$StandardPaymentsMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$Closed = {$: 0};
var $author$project$Components$CreatePaymentMethodModal$init = $author$project$Components$CreatePaymentMethodModal$Closed;
var $author$project$Components$Practice$PaymentSources$Network$init = F6(
	function (session, practice, imageStore, timeFormatter, isHintAdmin, rainforestEnv) {
		return _Utils_Tuple2(
			{rs: $author$project$Api$Data$Loading, rC: $author$project$Api$Data$Loading, i_: $author$project$Components$CreatePaymentMethodModal$init, gc: $elm$core$Maybe$Nothing, el: $elm$core$Set$empty, sF: imageStore, Ij: isHintAdmin, ZV: practice, t9: rainforestEnv, aa4: session, J7: timeFormatter},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Components$Practice$PaymentSources$Standard$init = F6(
	function (session, practice, imageStore, timeFormatter, isHintAdmin, rainforestEnv) {
		return _Utils_Tuple2(
			{rs: $author$project$Api$Data$Loading, rC: $author$project$Api$Data$Loading, i_: $author$project$Components$CreatePaymentMethodModal$init, gc: $elm$core$Maybe$Nothing, el: $elm$core$Set$empty, sF: imageStore, Ij: isHintAdmin, ZV: practice, t9: rainforestEnv, aa4: session, pZ: $elm$core$Maybe$Nothing, J7: timeFormatter},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Api$Platform$Organization$Shared$isNetwork = function (_v0) {
	var record = _v0.b;
	return record.U_;
};
var $author$project$Pages$Admin$PaymentSources$GotBankAccounts = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$PaymentSources$GotCards = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$PaymentSources$loadData = function (apiClient) {
	return _Utils_Tuple3(
		$author$project$Api$Data$Loading,
		$author$project$Api$Data$Loading,
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A3($author$project$Api$Provider$Card$list, $author$project$Api$Data$providerPath, apiClient, $author$project$Pages$Admin$PaymentSources$GotCards),
					A3($author$project$Api$Provider$BankAccount$list, $author$project$Api$Data$providerPath, apiClient, $author$project$Pages$Admin$PaymentSources$GotBankAccounts)
				])));
};
var $author$project$Pages$Admin$PaymentSources$init = F4(
	function (session, practice, shared, _v0) {
		var isNetwork = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Platform$Organization$Shared$isNetwork,
				$author$project$Api$Platform$Session$One$organization(session)));
		var isHintAdmin = $author$project$Shared$isHintAdmin(shared);
		var _v1 = function () {
			if (isNetwork) {
				var _v2 = A6($author$project$Components$Practice$PaymentSources$Network$init, session, practice, shared.sF, shared.J7, isHintAdmin, shared.t9);
				var m = _v2.a;
				var c = _v2.b;
				return _Utils_Tuple2(
					$author$project$Pages$Admin$PaymentSources$Network(m),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$PaymentSources$NetworkPaymentsMsg, c));
			} else {
				var _v3 = A6($author$project$Components$Practice$PaymentSources$Standard$init, session, practice, shared.sF, shared.J7, isHintAdmin, shared.t9);
				var m = _v3.a;
				var c = _v3.b;
				return _Utils_Tuple2(
					$author$project$Pages$Admin$PaymentSources$Standard(m),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$PaymentSources$StandardPaymentsMsg, c));
			}
		}();
		var practicePaymentSources = _v1.a;
		var practicePaymentSourcesCmd = _v1.b;
		var _v4 = $author$project$Pages$Admin$PaymentSources$loadData(shared.Gv);
		var cards = _v4.a;
		var bankAccounts = _v4.b;
		var cmd = _v4.c;
		return _Utils_Tuple2(
			{Gv: shared.Gv, rs: bankAccounts, rC: cards, Ij: isHintAdmin, U_: isNetwork, bd: $elm$core$Maybe$Nothing, ZV: practice, bK: practicePaymentSources, aa4: session, J7: shared.J7},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[cmd, practicePaymentSourcesCmd])));
	});
var $author$project$Pages$Admin$PaymentSources$load = F2(
	function (shared, model) {
		var _v0 = shared.aa4;
		if (_v0.$ === 3) {
			var session = _v0.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{aa4: session}),
				$elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Admin$PaymentSources$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$PaymentSources$CancelEdit = {$: 4};
var $author$project$Components$Practice$PaymentSources$Network$CreatePaymentMethodModalMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$Close = {$: 1};
var $author$project$Components$CreatePaymentMethodModal$ConnectingModalMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$GotLocalStorageItem = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$GotStripeCardPaymentMethod = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$StripeElementTypeChanged = function (a) {
	return {$: 17, a: a};
};
var $author$project$Ports$Stripe$stripePortOnSetupIntentChange = _Platform_incomingPort('stripePortOnSetupIntentChange', $elm$json$Json$Decode$string);
var $author$project$Ports$Stripe$onSetupIntentChanged = function (elementType) {
	return $author$project$Ports$Stripe$stripePortOnSetupIntentChange(elementType);
};
var $author$project$Ports$Stripe$StripeSetupIntentResponse = F3(
	function (selector, paymentMethod, error) {
		return {RK: error, Za: paymentMethod, aW: selector};
	});
var $author$project$Ports$Stripe$StripeCardPaymentMethod = function (id) {
	return {ahP: id};
};
var $author$project$Ports$Stripe$stripePaymentMethodFromSetupIntentDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'payment_method',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Ports$Stripe$StripeCardPaymentMethod));
var $author$project$Ports$Stripe$stripeSetupIntentResponseDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'error',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'setup_intent',
		$elm$json$Json$Decode$maybe($author$project$Ports$Stripe$stripePaymentMethodFromSetupIntentDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'selector',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Ports$Stripe$StripeSetupIntentResponse))));
var $author$project$Ports$Stripe$decodeStripeSetupIntentResponse = F2(
	function (msg, response) {
		var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Ports$Stripe$stripeSetupIntentResponseDecoder, response);
		if (!_v0.$) {
			var setupIntentResponse = _v0.a;
			var _v1 = setupIntentResponse.Za;
			if (_v1.$ === 1) {
				var _v2 = setupIntentResponse.RK;
				if (_v2.$ === 1) {
					return msg(
						$elm$core$Result$Err(''));
				} else {
					var error = _v2.a;
					return msg(
						$elm$core$Result$Err(error));
				}
			} else {
				var setupIntent = _v1.a;
				return msg(
					$elm$core$Result$Ok(setupIntent));
			}
		} else {
			return msg(
				$elm$core$Result$Err('Something went wrong, please try again.'));
		}
	});
var $author$project$Ports$Stripe$stripePortOnSetupIntentConfirmed = _Platform_incomingPort('stripePortOnSetupIntentConfirmed', $elm$json$Json$Decode$value);
var $author$project$Ports$Stripe$onSetupIntentConfirmed = function (response) {
	return $author$project$Ports$Stripe$stripePortOnSetupIntentConfirmed(
		$author$project$Ports$Stripe$decodeStripeSetupIntentResponse(response));
};
var $author$project$Components$CreatePaymentMethodModal$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				function () {
				if (model.$ === 1) {
					return $author$project$Ports$Stripe$onSetupIntentConfirmed($author$project$Components$CreatePaymentMethodModal$GotStripeCardPaymentMethod);
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				function () {
				if (model.$ === 1) {
					var connectingModal = model.a.iS;
					if (!connectingModal.$) {
						var justConnectingModal = connectingModal.a;
						return A2(
							$elm$core$Platform$Sub$map,
							$author$project$Components$CreatePaymentMethodModal$ConnectingModalMsg,
							$author$project$Components$CardReader$ConnectingModal$subscriptions(justConnectingModal));
					} else {
						return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$CreatePaymentMethodModal$Close);
					}
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				$author$project$Ports$LocalStorage$gotItem($author$project$Components$CreatePaymentMethodModal$GotLocalStorageItem),
				$author$project$Ports$Stripe$onSetupIntentChanged($author$project$Components$CreatePaymentMethodModal$StripeElementTypeChanged)
			]));
};
var $author$project$Components$Practice$PaymentSources$Network$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Components$Practice$PaymentSources$Network$CreatePaymentMethodModalMsg,
		$author$project$Components$CreatePaymentMethodModal$subscriptions(model.i_));
};
var $author$project$Components$Practice$PaymentSources$Standard$CreatePaymentMethodModalMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Practice$PaymentSources$Standard$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Components$Practice$PaymentSources$Standard$CreatePaymentMethodModalMsg,
		$author$project$Components$CreatePaymentMethodModal$subscriptions(model.i_));
};
var $author$project$Pages$Admin$PaymentSources$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				function () {
				var _v0 = model.bK;
				if (!_v0.$) {
					var m = _v0.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Pages$Admin$PaymentSources$StandardPaymentsMsg,
						$author$project$Components$Practice$PaymentSources$Standard$subscriptions(m));
				} else {
					var m = _v0.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Pages$Admin$PaymentSources$NetworkPaymentsMsg,
						$author$project$Components$Practice$PaymentSources$Network$subscriptions(m));
				}
			}(),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Admin$PaymentSources$CancelEdit)),
					model.bd))
			]));
};
var $author$project$Pages$Admin$PaymentSources$formFieldsFromPaymentCategory = function (paymentCategory) {
	return {GW: paymentCategory.GW, JQ: paymentCategory.Qc};
};
var $author$project$Pages$Admin$PaymentSources$formFieldsUpdate = F3(
	function (sources, field, fields) {
		var string = field;
		return _Utils_update(
			fields,
			{
				JQ: A2(
					$elm_community$list_extra$List$Extra$find,
					function (source) {
						return _Utils_eq(
							$author$project$Api$Source$id(source),
							string);
					},
					sources)
			});
	});
var $author$project$Pages$Admin$PaymentSources$SourceValidation = 0;
var $author$project$Pages$Admin$PaymentSources$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.JQ;
			},
			_Utils_Tuple2(0, 'Please pick a source.'))
		]));
var $author$project$Components$Practice$PaymentSources$Network$initBankAccounts = F2(
	function (bankAccounts, model) {
		return _Utils_update(
			model,
			{rs: bankAccounts});
	});
var $author$project$Components$Practice$PaymentSources$Standard$initBankAccounts = F2(
	function (bankAccounts, model) {
		return _Utils_update(
			model,
			{rs: bankAccounts});
	});
var $author$project$Pages$Admin$PaymentSources$propagateBankAccounts = F2(
	function (response, variant) {
		if (!variant.$) {
			var m = variant.a;
			return $author$project$Pages$Admin$PaymentSources$Standard(
				A2($author$project$Components$Practice$PaymentSources$Standard$initBankAccounts, response, m));
		} else {
			var m = variant.a;
			return $author$project$Pages$Admin$PaymentSources$Network(
				A2($author$project$Components$Practice$PaymentSources$Network$initBankAccounts, response, m));
		}
	});
var $author$project$Components$Practice$PaymentSources$Network$initCards = F2(
	function (cards, model) {
		return _Utils_update(
			model,
			{rC: cards});
	});
var $author$project$Components$Practice$PaymentSources$Standard$initCards = F2(
	function (cards, model) {
		return _Utils_update(
			model,
			{rC: cards});
	});
var $author$project$Pages$Admin$PaymentSources$propagateCards = F2(
	function (response, variant) {
		if (!variant.$) {
			var m = variant.a;
			return $author$project$Pages$Admin$PaymentSources$Standard(
				A2($author$project$Components$Practice$PaymentSources$Standard$initCards, response, m));
		} else {
			var m = variant.a;
			return $author$project$Pages$Admin$PaymentSources$Network(
				A2($author$project$Components$Practice$PaymentSources$Network$initCards, response, m));
		}
	});
var $author$project$Components$Practice$PaymentSources$Network$Deleted = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Practice$PaymentSources$Network$None = 2;
var $author$project$Components$Practice$PaymentSources$Network$PaymentMethodCreated = 0;
var $author$project$Components$Practice$PaymentSources$Network$PaymentMethodDeleted = 1;
var $author$project$Api$Employer$BankAccount$bankAccountPath = F2(
	function (basePath, id_) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id_]),
			$author$project$Api$Employer$BankAccount$bankAccountsPath(basePath));
	});
var $author$project$Api$Employer$BankAccount$delete = F4(
	function (basePath, apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Employer$BankAccount$bankAccountPath, basePath, id_)));
	});
var $author$project$Api$BankAccount$delete = F5(
	function (basePath, apiClient, session, bankAccount, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4(
			$author$project$Api$Employer$BankAccount$delete,
			basePath,
			apiClient,
			$author$project$Api$BankAccount$id(bankAccount),
			toMsg) : A4(
			$author$project$Api$Provider$BankAccount$delete,
			basePath,
			apiClient,
			$author$project$Api$BankAccount$id(bankAccount),
			toMsg);
	});
var $author$project$Api$Employer$Card$cardPath = F2(
	function (basePath, id_) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id_]),
			$author$project$Api$Employer$Card$cardsPath(basePath));
	});
var $author$project$Api$Employer$Card$delete = F4(
	function (basePath, apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Employer$Card$cardPath, basePath, id_)));
	});
var $author$project$Api$Card$delete = F5(
	function (basePath, apiClient, session, card, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4(
			$author$project$Api$Employer$Card$delete,
			basePath,
			apiClient,
			$author$project$Api$Card$id(card),
			toMsg) : A4(
			$author$project$Api$Provider$Card$delete,
			basePath,
			apiClient,
			$author$project$Api$Card$id(card),
			toMsg);
	});
var $author$project$Api$Source$delete = F5(
	function (basePath, apiClient, session, source, toMsg) {
		switch (source.$) {
			case 0:
				var card = source.a;
				return A5($author$project$Api$Card$delete, basePath, apiClient, session, card, toMsg);
			case 1:
				var bankAccount = source.a;
				return A5($author$project$Api$BankAccount$delete, basePath, apiClient, session, bankAccount, toMsg);
			default:
				return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Components$CreatePaymentMethodModal$BankAccount = 0;
var $author$project$Components$CreatePaymentMethodModal$Card = 1;
var $author$project$Components$CreatePaymentMethodModal$CardReader = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$GotCardReaders = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$GotPaymentInfoUpdate = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$GotSetupConfig = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$Loading = {$: 0};
var $author$project$Components$CreatePaymentMethodModal$None = 1;
var $author$project$Components$CreatePaymentMethodModal$Open = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$PaymentMethodCreatedEvent = 0;
var $author$project$Components$CreatePaymentMethodModal$Rainforest = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$Stripe = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$UpdateDefaultsFailed = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$UpdateDefaultsFinished = {$: 9};
var $author$project$Components$CreatePaymentMethodModal$UpdateDefaultsUpdated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Employer$Company$One$acceptsAmex = function (_v0) {
	var one = _v0.b;
	return one.KB;
};
var $author$project$Api$Provider$Company$One$acceptsAmex = function (_v0) {
	var record = _v0.b;
	return record.KB;
};
var $author$project$Api$Company$acceptsAmex = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$acceptsAmex(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$acceptsAmex(company_);
	}
};
var $author$project$Components$CreatePaymentMethodModal$acceptsAmex = F2(
	function (owner, session) {
		if (!$author$project$Api$Platform$Session$One$organizationIsCompany(session)) {
			return true;
		} else {
			if (!owner.$) {
				var company = owner.a;
				return $author$project$Api$Company$acceptsAmex(company);
			} else {
				return true;
			}
		}
	});
var $author$project$Components$CreatePaymentMethodModal$andNoop = function (model) {
	return {GZ: $elm$core$Platform$Cmd$none, agZ: 1, aiO: model, aR: _List_Nil};
};
var $0ui$elm_task_parallel$Task$Parallel$ItemLoaded = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $0ui$elm_task_parallel$Task$Parallel$ListState = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $0ui$elm_task_parallel$Task$Parallel$routeTo = F2(
	function (successMsg, failureMsg) {
		return A2(
			$elm$core$Basics$composeR,
			$elm$core$Task$andThen(
				A2($elm$core$Basics$composeL, $elm$core$Task$succeed, $elm$core$Result$Ok)),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Task$onError(
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, $elm$core$Result$Err)),
				$elm$core$Task$perform(
					function (result) {
						if (!result.$) {
							var a = result.a;
							return successMsg(a);
						} else {
							var err = result.a;
							return failureMsg(err);
						}
					})));
	});
var $0ui$elm_task_parallel$Task$Parallel$attemptList = function (_v0) {
	var tasks = _v0.acT;
	var onUpdates = _v0.Yj;
	var onSuccess = _v0.Yg;
	var onFailure = _v0.Ye;
	return _Utils_Tuple2(
		A2(
			$0ui$elm_task_parallel$Task$Parallel$ListState,
			onSuccess,
			A2(
				$elm$core$List$map,
				$elm$core$Basics$always($elm$core$Maybe$Nothing),
				tasks)),
		$elm$core$Platform$Cmd$batch(
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (index, task) {
						return A3(
							$0ui$elm_task_parallel$Task$Parallel$routeTo,
							A2(
								$elm$core$Basics$composeL,
								onUpdates,
								$0ui$elm_task_parallel$Task$Parallel$ItemLoaded(index)),
							onFailure,
							task);
					}),
				tasks)));
};
var $author$project$Ports$Stripe$StripeElementsOptions = {};
var $author$project$Ports$Stripe$stripePortBuildAndMountElementWithSetupIntent = _Platform_outgoingPort(
	'stripePortBuildAndMountElementWithSetupIntent',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'acceptAmex',
					$elm$json$Json$Encode$bool($.Gf)),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string($.Bq)),
					_Utils_Tuple2(
					'options',
					function ($) {
						return $elm$json$Json$Encode$object(_List_Nil);
					}($.Cd)),
					_Utils_Tuple2(
					'practiceStripePublicKey',
					function ($) {
						return A3($elm$core$Maybe$destruct, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string, $);
					}($.Jj)),
					_Utils_Tuple2(
					'selector',
					$elm$json$Json$Encode$string($.aW)),
					_Utils_Tuple2(
					'setupIntentSecret',
					$elm$json$Json$Encode$string($.JI)),
					_Utils_Tuple2(
					'zip',
					$elm$json$Json$Encode$string($.vv))
				]));
	});
var $author$project$Ports$Stripe$buildAndMountElementWithSetupIntent = F6(
	function (practiceStripePublicKey, setupIntentSecret, selector, acceptAmex, name, zip) {
		return $author$project$Ports$Stripe$stripePortBuildAndMountElementWithSetupIntent(
			{Gf: acceptAmex, Bq: name, Cd: $author$project$Ports$Stripe$StripeElementsOptions, Jj: practiceStripePublicKey, aW: selector, JI: setupIntentSecret, vv: zip});
	});
var $author$project$Api$Employer$Company$One$address = function (_v0) {
	var record = _v0.b;
	return record.K2;
};
var $author$project$Api$Provider$Company$One$address = function (_v0) {
	var record = _v0.b;
	return record.K2;
};
var $author$project$Api$Company$address = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$address(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$address(company_);
	}
};
var $author$project$Api$Employer$Practice$One$address = function (_v0) {
	var record = _v0;
	return record.K2;
};
var $author$project$Api$Practice$address = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$address(practice_);
	} else {
		var practice_ = practice.a;
		return $author$project$Api$Employer$Practice$One$address(practice_);
	}
};
var $author$project$Api$Provider$Patient$One$address = function (_v0) {
	var record = _v0.b;
	return record.K2;
};
var $author$project$Api$Provider$Patient$One$billingAddress = function (_v0) {
	var record = _v0.b;
	return record.MF;
};
var $author$project$Api$Employer$Company$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Employer$Company$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Company$Shared$name(shared);
};
var $author$project$Api$Provider$Company$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$name(shared);
};
var $author$project$Api$Company$name = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$name(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$name(company_);
	}
};
var $author$project$Api$Employer$Practice$One$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Practice$name = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$name(practice_);
	} else {
		var practice_ = practice.a;
		return $author$project$Api$Employer$Practice$One$name(practice_);
	}
};
var $author$project$Api$Provider$Patient$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$name(shared);
};
var $author$project$Components$CreatePaymentMethodModal$getNameAndZipWithOwner = function (owner) {
	switch (owner.$) {
		case 1:
			var practice = owner.a;
			var zip = A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$andThen,
					$author$project$Api$Common$Address$Shared$zip,
					$author$project$Api$Practice$address(practice)));
			return _Utils_Tuple2(
				$author$project$Api$Practice$name(practice),
				zip);
		case 0:
			var company = owner.a;
			var zip = A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$andThen,
					$author$project$Api$Common$Address$Shared$zip,
					$author$project$Api$Company$address(company)));
			return _Utils_Tuple2(
				$author$project$Api$Company$name(company),
				zip);
		default:
			var patient = owner.a;
			var billing = A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$andThen,
					$author$project$Api$Common$Address$Shared$zip,
					$author$project$Api$Provider$Patient$One$billingAddress(patient)));
			var zip = (!$elm$core$String$isEmpty(billing)) ? billing : A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$andThen,
					$author$project$Api$Common$Address$Shared$zip,
					$author$project$Api$Provider$Patient$One$address(patient)));
			return _Utils_Tuple2(
				$author$project$Api$Provider$Patient$One$name(patient),
				zip);
	}
};
var $author$project$Components$CreatePaymentMethodModal$stripeElementId = 'card-element';
var $author$project$Api$Employer$Practice$One$stripePublishableKey = function (_v0) {
	var record = _v0;
	return record.acs;
};
var $author$project$Api$Provider$Practice$Shared$stripePublishableKey = function (_v0) {
	var record = _v0;
	return record.acs;
};
var $author$project$Api$Provider$Practice$One$stripePublishableKey = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$stripePublishableKey(shared);
};
var $author$project$Api$Practice$stripePublishableKey = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$stripePublishableKey(practice_);
	} else {
		var practice_ = practice.a;
		return $author$project$Api$Employer$Practice$One$stripePublishableKey(practice_);
	}
};
var $author$project$Components$CreatePaymentMethodModal$buildStripeElement = F4(
	function (practice, clientSecret, owner, session) {
		var _v0 = $author$project$Components$CreatePaymentMethodModal$getNameAndZipWithOwner(owner);
		var name = _v0.a;
		var zip = _v0.b;
		return A6(
			$author$project$Ports$Stripe$buildAndMountElementWithSetupIntent,
			$author$project$Api$Practice$stripePublishableKey(practice),
			clientSecret,
			'#' + $author$project$Components$CreatePaymentMethodModal$stripeElementId,
			A2($author$project$Components$CreatePaymentMethodModal$acceptsAmex, owner, session),
			name,
			zip);
	});
var $author$project$Components$CreatePaymentMethodModal$cardParamsFromReader = function (readCard) {
	return {
		No: $elm$core$Maybe$Nothing,
		O4: $elm$core$Maybe$Just(readCard.O4),
		VG: $elm$core$Maybe$Nothing,
		Yl: $elm$core$Maybe$Just(readCard.Yl),
		Ze: readCard.Ze
	};
};
var $author$project$Ports$Stripe$stripePortConfirmSetupIntent = _Platform_outgoingPort(
	'stripePortConfirmSetupIntent',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'options',
					function ($) {
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'billingOptions',
									function ($) {
										return A3(
											$elm$core$Maybe$destruct,
											$elm$json$Json$Encode$null,
											function ($) {
												return $elm$json$Json$Encode$object(
													_List_fromArray(
														[
															_Utils_Tuple2(
															'name',
															$elm$json$Json$Encode$string($.Bq))
														]));
											},
											$);
									}($.afh))
								]));
					}($.Cd)),
					_Utils_Tuple2(
					'selector',
					$elm$json$Json$Encode$string($.aW))
				]));
	});
var $author$project$Ports$Stripe$confirmSetupIntent = F2(
	function (selector, options) {
		return $author$project$Ports$Stripe$stripePortConfirmSetupIntent(
			{Cd: options, aW: selector});
	});
var $author$project$Components$CreatePaymentMethodModal$Created = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Components$CreatePaymentMethodModal$createCardFromReader = F5(
	function (basePath, apiClient, session, categories, cardParams) {
		return A5(
			$author$project$Api$Card$create,
			basePath,
			apiClient,
			session,
			cardParams,
			$author$project$Components$CreatePaymentMethodModal$Created(categories));
	});
var $author$project$Components$CreatePaymentMethodModal$PaymentMethodCreated = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Api$PaymentMethod$PaymentMethod = $elm$core$Basics$identity;
var $author$project$Api$PaymentMethod$SharedRecordBankAccount = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$PaymentMethod$bankAccountOneDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2($elm$json$Json$Decode$map, $author$project$Api$PaymentMethod$SharedRecordBankAccount, $author$project$Api$Provider$BankAccount$Shared$decoder),
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$PaymentMethod$SharedRecordCard = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$PaymentMethod$cardOneDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2($elm$json$Json$Decode$map, $author$project$Api$PaymentMethod$SharedRecordCard, $author$project$Api$Provider$Card$Shared$decoder),
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$PaymentMethod$oneDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[$author$project$Api$PaymentMethod$cardOneDecoder, $author$project$Api$PaymentMethod$bankAccountOneDecoder]));
var $author$project$Api$PaymentMethod$paymentMethodsPath = function (basePath) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['payment_methods']),
		basePath);
};
var $author$project$Api$PaymentMethod$create = F5(
	function (basePath, apiClient, param, setAsDefault, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'payment_method',
					$elm$json$Json$Encode$object(
						_Utils_ap(
							$author$project$Api$PaymentProcessorParams$encode(param),
							function () {
								if (!setAsDefault.$) {
									var value = setAsDefault.a;
									return _List_fromArray(
										[
											_Utils_Tuple2(
											'set_as_default',
											$elm$json$Json$Encode$bool(value))
										]);
								} else {
									return _List_Nil;
								}
							}())))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$PaymentMethod$oneDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$PaymentMethod$paymentMethodsPath(basePath))));
	});
var $author$project$Components$CreatePaymentMethodModal$createPaymentMethod = F5(
	function (basePath, apiClient, paymentMethodParams, categories, setAsDefault) {
		return A5(
			$author$project$Api$PaymentMethod$create,
			basePath,
			apiClient,
			paymentMethodParams,
			$elm$core$Maybe$Just(setAsDefault),
			$author$project$Components$CreatePaymentMethodModal$PaymentMethodCreated(categories));
	});
var $elm_community$list_extra$List$Extra$remove = F2(
	function (x, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var y = xs.a;
			var ys = xs.b;
			return _Utils_eq(x, y) ? ys : A2(
				$elm$core$List$cons,
				y,
				A2($elm_community$list_extra$List$Extra$remove, x, ys));
		}
	});
var $author$project$Components$CreatePaymentMethodModal$formFieldsUpdate = F3(
	function (cardReaders, field, fields) {
		switch (field.$) {
			case 0:
				var cardInput = field.a;
				return _Utils_update(
					fields,
					{c6: cardInput});
			case 1:
				var id = field.a;
				return _Utils_update(
					fields,
					{
						aft: A2(
							$elm_community$list_extra$List$Extra$find,
							function (cardReader_) {
								return _Utils_eq(
									$author$project$Api$Provider$CardReader$All$id(cardReader_),
									id);
							},
							cardReaders)
					});
			case 2:
				var category = field.a;
				var bool = field.b;
				var categories = bool ? A2($elm$core$List$cons, category, fields.Nr) : A2($elm_community$list_extra$List$Extra$remove, category, fields.Nr);
				return _Utils_update(
					fields,
					{Nr: categories});
			case 3:
				var brand = field.a;
				return _Utils_update(
					fields,
					{xU: brand});
			default:
				var value = field.a;
				return _Utils_update(
					fields,
					{hC: value});
		}
	});
var $author$project$Components$CreatePaymentMethodModal$NameValidation = 0;
var $author$project$Components$CreatePaymentMethodModal$CardBrandValidation = 2;
var $author$project$Components$CreatePaymentMethodModal$validateCardBrand = F3(
	function (processorConfig, acceptsAmex_, fields) {
		var _v0 = _Utils_Tuple3(processorConfig, acceptsAmex_, fields.xU);
		if (((_v0.a.$ === 2) && (!_v0.b)) && (_v0.c === 'AMERICAN_EXPRESS')) {
			return _List_fromArray(
				[
					_Utils_Tuple2(2, 'American Express is not accepted.')
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$CreatePaymentMethodModal$CardReaderValidation = 1;
var $author$project$Components$CreatePaymentMethodModal$validateCardReader = function (fields) {
	var _v0 = _Utils_Tuple2(fields.c6, fields.aft);
	if ((_v0.a === 1) && (_v0.b.$ === 1)) {
		var _v1 = _v0.a;
		var _v2 = _v0.b;
		return _List_fromArray(
			[
				_Utils_Tuple2(1, 'Please pick a card reader.')
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$CreatePaymentMethodModal$formFieldsValidator = F2(
	function (processorConfig, acceptsAmex_) {
		return $rtfeldman$elm_validate$Validate$all(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_validate$Validate$ifBlank,
					function ($) {
						return $.Bq;
					},
					_Utils_Tuple2(0, 'Please enter a name.')),
					$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$CreatePaymentMethodModal$validateCardReader),
					$rtfeldman$elm_validate$Validate$fromErrors(
					A2($author$project$Components$CreatePaymentMethodModal$validateCardBrand, processorConfig, acceptsAmex_))
				]));
	});
var $author$project$Api$Provider$Card$All$one_ = function (_v0) {
	var one = _v0;
	return one;
};
var $author$project$Api$Provider$Card$One$shared_ = function (_v0) {
	var shared = _v0.a;
	return shared;
};
var $author$project$Api$PaymentMethod$fromCardAll = function (card) {
	return $author$project$Api$PaymentMethod$SharedRecordCard(
		$author$project$Api$Provider$Card$One$shared_(
			$author$project$Api$Provider$Card$All$one_(card)));
};
var $author$project$Api$PaymentMethod$fromCardOne = function (card) {
	return $author$project$Api$PaymentMethod$SharedRecordCard(
		$author$project$Api$Provider$Card$One$shared_(card));
};
var $author$project$Api$PaymentMethod$Rainforest = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$PaymentMethod$RainforestSetupConfig = F3(
	function (sessionKey, paymentMethodConfigId, allowedMethods) {
		return {aeX: allowedMethods, ajX: paymentMethodConfigId, alo: sessionKey};
	});
var $author$project$Api$PaymentMethod$Stripe = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$PaymentMethod$setupDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$andThen,
			function (processor) {
				switch (processor) {
					case 'stripe':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$Api$PaymentMethod$Stripe,
							A2(
								$elm$json$Json$Decode$at,
								_List_fromArray(
									['stripe_client_secret']),
								$elm$json$Json$Decode$string));
					case 'rainforest':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$Api$PaymentMethod$Rainforest,
							A4(
								$elm$json$Json$Decode$map3,
								$author$project$Api$PaymentMethod$RainforestSetupConfig,
								A2(
									$elm$json$Json$Decode$at,
									_List_fromArray(
										['session_key']),
									$elm$json$Json$Decode$string),
								A2(
									$elm$json$Json$Decode$at,
									_List_fromArray(
										['payment_method_config_id']),
									$elm$json$Json$Decode$string),
								A2(
									$elm$json$Json$Decode$at,
									_List_fromArray(
										['allowed_methods']),
									$elm$json$Json$Decode$string)));
					default:
						return $elm$json$Json$Decode$fail('Unsupported processor ' + processor);
				}
			},
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['payment_processor']),
				$elm$json$Json$Decode$string)),
			A2(
			$elm$json$Json$Decode$map,
			$author$project$Api$PaymentMethod$Stripe,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['stripe_client_secret']),
				$elm$json$Json$Decode$string))
		]));
var $author$project$Api$PaymentMethod$getClientSecret = F4(
	function (basePath, apiClient, maybePaymentProcessor, toMsg) {
		var body = function () {
			if (!maybePaymentProcessor.$) {
				var processor = maybePaymentProcessor.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'payment_processor',
							$elm$json$Json$Encode$string(processor))
						]));
			} else {
				return $elm$json$Json$Encode$object(_List_Nil);
			}
		}();
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$PaymentMethod$setupDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['setup']),
						$author$project$Api$PaymentMethod$paymentMethodsPath(basePath)))));
	});
var $author$project$Api$Employer$Company$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Employer$Company$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Company$Shared$id(shared);
};
var $author$project$Api$Provider$Company$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$id(shared);
};
var $author$project$Api$Company$id = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$id(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$id(company_);
	}
};
var $author$project$Api$Employer$Practice$One$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Practice$id = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$id(practice_);
	} else {
		var practice_ = practice.a;
		return $author$project$Api$Employer$Practice$One$id(practice_);
	}
};
var $author$project$Api$Provider$Patient$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$id(shared);
};
var $author$project$Components$CreatePaymentMethodModal$Manual = 0;
var $author$project$Api$Provider$Source$Defaults$HintCustomer = 0;
var $author$project$Api$Provider$Source$Defaults$NetworkForRainforest = 2;
var $author$project$Api$Provider$Source$Defaults$NetworkForStripe = 1;
var $author$project$Api$Practice$isNetwork = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$isNetwork(practice_);
	} else {
		return false;
	}
};
var $author$project$Components$Practice$PaymentCategoriesPicker$allCategoriesForProcessor = F2(
	function (practice, processor) {
		var _v0 = _Utils_Tuple2(
			$author$project$Api$Practice$isNetwork(practice),
			processor);
		if (!_v0.a) {
			if (!_v0.b) {
				var _v1 = _v0.b;
				return _List_Nil;
			} else {
				var _v2 = _v0.b;
				return _List_fromArray(
					[0]);
			}
		} else {
			if (!_v0.b) {
				var _v3 = _v0.b;
				return _List_fromArray(
					[1]);
			} else {
				var _v4 = _v0.b;
				return _List_fromArray(
					[0, 2]);
			}
		}
	});
var $author$project$Components$Practice$PaymentCategoriesPicker$Rainforest = 1;
var $author$project$Components$Practice$PaymentCategoriesPicker$Stripe = 0;
var $author$project$Components$CreatePaymentMethodModal$processorFromConfig = function (processorConfig) {
	switch (processorConfig.$) {
		case 1:
			return 0;
		case 2:
			return 1;
		default:
			return 1;
	}
};
var $author$project$Components$CreatePaymentMethodModal$initFormFields = F4(
	function (practice, owner, session, processorConfig) {
		var processorElement = function () {
			switch (processorConfig.$) {
				case 1:
					var clientSecret = processorConfig.a;
					return A4($author$project$Components$CreatePaymentMethodModal$buildStripeElement, practice, clientSecret, owner, session);
				case 2:
					return $elm$core$Platform$Cmd$none;
				default:
					return $elm$core$Platform$Cmd$none;
			}
		}();
		var _v0 = $author$project$Components$CreatePaymentMethodModal$getNameAndZipWithOwner(owner);
		var name = _v0.a;
		return _Utils_Tuple2(
			{
				xU: '',
				c6: 0,
				aft: $elm$core$Maybe$Nothing,
				Nr: function () {
					if (owner.$ === 1) {
						var prac = owner.a;
						return A2(
							$author$project$Components$Practice$PaymentCategoriesPicker$allCategoriesForProcessor,
							prac,
							$author$project$Components$CreatePaymentMethodModal$processorFromConfig(processorConfig));
					} else {
						return _List_Nil;
					}
				}(),
				Bq: name,
				hC: true
			},
			processorElement);
	});
var $author$project$Api$Employer$Company$One$acceptsAch = function (_v0) {
	var record = _v0.b;
	return record.KA;
};
var $author$project$Api$Provider$Company$One$acceptsAch = function (_v0) {
	var record = _v0.b;
	return record.KA;
};
var $author$project$Api$Company$acceptsAch = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$acceptsAch(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$acceptsAch(company_);
	}
};
var $author$project$Components$CreatePaymentMethodModal$acceptsAch = F2(
	function (owner, session) {
		if (!$author$project$Api$Platform$Session$One$organizationIsCompany(session)) {
			return true;
		} else {
			if (!owner.$) {
				var company = owner.a;
				return $author$project$Api$Company$acceptsAch(company);
			} else {
				return true;
			}
		}
	});
var $author$project$Api$Employer$Company$One$acceptsCards = function (_v0) {
	var record = _v0.b;
	return record.KC;
};
var $author$project$Api$Provider$Company$One$acceptsCards = function (_v0) {
	var record = _v0.b;
	return record.KC;
};
var $author$project$Api$Company$acceptsCards = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$acceptsCards(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$acceptsCards(company_);
	}
};
var $author$project$Components$CreatePaymentMethodModal$acceptsCards = F2(
	function (owner, session) {
		if (!$author$project$Api$Platform$Session$One$organizationIsCompany(session)) {
			return true;
		} else {
			if (!owner.$) {
				var company = owner.a;
				return $author$project$Api$Company$acceptsCards(company);
			} else {
				return true;
			}
		}
	});
var $author$project$Components$CreatePaymentMethodModal$isAddPaymentMethodDisabled = F2(
	function (owner, session) {
		return (!A2($author$project$Components$CreatePaymentMethodModal$acceptsCards, owner, session)) && (!A2($author$project$Components$CreatePaymentMethodModal$acceptsAch, owner, session));
	});
var $author$project$Api$Provider$Patient$One$requestPayInfoSentAt = function (_v0) {
	var record = _v0.b;
	return record.$B;
};
var $author$project$Api$Provider$Patient$RequestPaymentInfoOne$requestPayInfoSentAt = function (_v0) {
	var record = _v0;
	return record.$B;
};
var $author$project$Api$Data$stringifyPath = function (_v0) {
	var path = _v0;
	return $elm$core$String$concat(path);
};
var $author$project$Ports$Rainforest$rainforestSubmitPaymentMethod = _Platform_outgoingPort(
	'rainforestSubmitPaymentMethod',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$Rainforest$submitPaymentMethod = $author$project$Ports$Rainforest$rainforestSubmitPaymentMethod(0);
var $elm$core$Task$mapError = F2(
	function (convert, task) {
		return A2(
			$elm$core$Task$onError,
			A2($elm$core$Basics$composeL, $elm$core$Task$fail, convert),
			task);
	});
var $author$project$Api$Provider$Source$Defaults$categoryName = function (category) {
	switch (category) {
		case 0:
			return 'hint_customer';
		case 1:
			return 'network_for_stripe';
		default:
			return 'network_for_rainforest';
	}
};
var $elm$http$Http$stringResolver = A2(_Http_expect, '', $elm$core$Basics$identity);
var $elm$http$Http$resultToTask = function (result) {
	if (!result.$) {
		var a = result.a;
		return $elm$core$Task$succeed(a);
	} else {
		var x = result.a;
		return $elm$core$Task$fail(x);
	}
};
var $elm$http$Http$task = function (r) {
	return A3(
		_Http_toTask,
		0,
		$elm$http$Http$resultToTask,
		{aeR: false, fO: r.fO, RT: r.akX, jP: r.jP, IA: r.IA, J9: r.J9, vd: $elm$core$Maybe$Nothing, adY: r.adY});
};
var $author$project$Api$Data$taskResolver = F2(
	function (decoder, response) {
		var result = A2($author$project$Api$Data$handleJsonResponse, decoder, response);
		if (!result.$) {
			var _v1 = result.a;
			var value = _v1.a;
			var headers = _v1.b;
			return $elm$core$Result$Ok(
				A2($author$project$Api$Data$Success, value, headers));
		} else {
			var error = result.a;
			return $elm$core$Result$Err(
				$author$project$Api$Data$Failure(error));
		}
	});
var $author$project$Api$Data$taskRequest = F4(
	function (method, client, decoder, request) {
		return $elm$http$Http$task(
			{
				fO: $author$project$Api$Data$requestBody(request),
				jP: A2($author$project$Api$Data$requestHeaders, client, request),
				IA: $elm$core$String$toUpper(method),
				akX: $elm$http$Http$stringResolver(
					$author$project$Api$Data$taskResolver(decoder)),
				J9: $elm$core$Maybe$Nothing,
				adY: A2($author$project$Api$Data$requestToUrl, client, request)
			});
	});
var $author$project$Api$Data$postTask = $author$project$Api$Data$taskRequest('post');
var $author$project$Api$Provider$BankAccount$updateDefaultTask = F4(
	function (basePath, apiClient, id_, category) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'category',
					$elm$json$Json$Encode$string(
						$author$project$Api$Provider$Source$Defaults$categoryName(category)))
				]));
		return A3(
			$author$project$Api$Data$postTask,
			apiClient,
			$author$project$Api$Provider$BankAccount$Shared$decoder,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['default']),
						A2($author$project$Api$Provider$BankAccount$bankAccountPath, basePath, id_)))));
	});
var $author$project$Api$Provider$Card$updateDefaultTask = F4(
	function (basePath, apiClient, id_, category) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'category',
					$elm$json$Json$Encode$string(
						$author$project$Api$Provider$Source$Defaults$categoryName(category)))
				]));
		return A3(
			$author$project$Api$Data$postTask,
			apiClient,
			$author$project$Api$Provider$Card$Shared$decoder,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['default']),
						A2($author$project$Api$Provider$Card$cardPath, basePath, id_)))));
	});
var $author$project$Api$PaymentMethod$updateDefaultTask = F4(
	function (basePath, apiClient, paymentMethod, category) {
		if (!paymentMethod.$) {
			var card = paymentMethod.a;
			return A2(
				$elm$core$Task$mapError,
				function (dataSuccesCard) {
					return A2(
						$author$project$Api$Data$map,
						function (card_) {
							return $author$project$Api$PaymentMethod$SharedRecordCard(card_);
						},
						dataSuccesCard);
				},
				A2(
					$elm$core$Task$map,
					function (dataSuccesCard) {
						return A2(
							$author$project$Api$Data$map,
							function (card_) {
								return $author$project$Api$PaymentMethod$SharedRecordCard(card_);
							},
							dataSuccesCard);
					},
					A4(
						$author$project$Api$Provider$Card$updateDefaultTask,
						basePath,
						apiClient,
						$author$project$Api$Provider$Card$Shared$id(card),
						category)));
		} else {
			var bankAccount = paymentMethod.a;
			return A2(
				$elm$core$Task$mapError,
				function (dataSuccesBankAccount) {
					return A2(
						$author$project$Api$Data$map,
						function (bankAccount_) {
							return $author$project$Api$PaymentMethod$SharedRecordBankAccount(bankAccount_);
						},
						dataSuccesBankAccount);
				},
				A2(
					$elm$core$Task$map,
					function (dataSuccesBankAccount) {
						return A2(
							$author$project$Api$Data$map,
							function (bankAccount_) {
								return $author$project$Api$PaymentMethod$SharedRecordBankAccount(bankAccount_);
							},
							dataSuccesBankAccount);
					},
					A4(
						$author$project$Api$Provider$BankAccount$updateDefaultTask,
						basePath,
						apiClient,
						$author$project$Api$Provider$BankAccount$Shared$id(bankAccount),
						category)));
		}
	});
var $0ui$elm_task_parallel$Task$Parallel$toCmd = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map(
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Task$succeed,
			$elm$core$Task$perform($elm$core$Basics$identity))),
	$elm$core$Maybe$withDefault($elm$core$Platform$Cmd$none));
var $0ui$elm_task_parallel$Task$Parallel$updateList = F2(
	function (_v0, _v1) {
		var onSuccess = _v0.a;
		var items = _v0.b;
		var index = _v1.a;
		var newItem = _v1.b;
		var updatedItems = A2(
			$elm$core$List$indexedMap,
			F2(
				function (i, maybeItem) {
					return _Utils_eq(i, index) ? $elm$core$Maybe$Just(newItem) : maybeItem;
				}),
			items);
		return A2(
			$elm$core$List$any,
			$elm$core$Basics$eq($elm$core$Maybe$Nothing),
			updatedItems) ? _Utils_Tuple2(
			A2($0ui$elm_task_parallel$Task$Parallel$ListState, onSuccess, updatedItems),
			$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
			A2($0ui$elm_task_parallel$Task$Parallel$ListState, onSuccess, updatedItems),
			$0ui$elm_task_parallel$Task$Parallel$toCmd(
				$elm$core$Maybe$Just(
					onSuccess(
						A2($elm$core$List$filterMap, $elm$core$Basics$identity, updatedItems)))));
	});
var $author$project$Components$CreatePaymentMethodModal$CardBrand = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$updateRainforest = F5(
	function (apiClient, basePath, msg, config, model) {
		switch (msg.$) {
			case 0:
				var rainforestId = msg.a;
				var _v1 = $author$project$Utils$Form$fields(model.SD);
				var categories = _v1.Nr;
				var setAsDefault = _v1.hC;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aA: $author$project$Components$CreatePaymentMethodModal$Rainforest(config)
						}),
					A5(
						$author$project$Components$CreatePaymentMethodModal$createPaymentMethod,
						basePath,
						apiClient,
						$author$project$Api$PaymentProcessorParams$rainforestParams(rainforestId),
						categories,
						setAsDefault));
			case 1:
				var isValid = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aA: $author$project$Components$CreatePaymentMethodModal$Rainforest(
								_Utils_update(
									config,
									{Ap: isValid}))
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aA: $author$project$Components$CreatePaymentMethodModal$Rainforest(
								_Utils_update(
									config,
									{dp: false}))
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var elementType = msg.a;
				var selectedPaymentOption = function () {
					switch (elementType) {
						case 'ACH':
							return 0;
						case 'CARD':
							return 1;
						default:
							return 1;
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aA: $author$project$Components$CreatePaymentMethodModal$Rainforest(config),
							dK: selectedPaymentOption
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var brand = msg.a;
				var field = $author$project$Components$CreatePaymentMethodModal$CardBrand(brand);
				var cardReaders = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$author$project$Api$Data$toMaybe(model.iE));
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$CreatePaymentMethodModal$formFieldsUpdate(cardReaders),
					field,
					model.SD);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{SD: newForm}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Components$CreatePaymentMethodModal$update = F3(
	function (apiClient, msg, model) {
		if (model.$ === 1) {
			var open = model.a;
			switch (msg.$) {
				case 1:
					return $author$project$Components$CreatePaymentMethodModal$andNoop($author$project$Components$CreatePaymentMethodModal$Closed);
				case 17:
					var elementType = msg.a;
					var _v2 = open.aA;
					if (_v2.$ === 1) {
						var selectedPaymentOption = function () {
							switch (elementType) {
								case 'us_bank_account':
									return 0;
								case 'card':
									return 1;
								default:
									return 1;
							}
						}();
						return $author$project$Components$CreatePaymentMethodModal$andNoop(
							$author$project$Components$CreatePaymentMethodModal$Open(
								_Utils_update(
									open,
									{dK: selectedPaymentOption})));
					} else {
						return $author$project$Components$CreatePaymentMethodModal$andNoop(model);
					}
				case 2:
					var field = msg.a;
					var cmd = function () {
						var _v4 = _Utils_Tuple2(field, open.aA);
						if (((!_v4.a.$) && (!_v4.a.a)) && (_v4.b.$ === 1)) {
							var _v5 = _v4.a.a;
							var secret = _v4.b.a;
							return A4($author$project$Components$CreatePaymentMethodModal$buildStripeElement, open.ZV, secret, open.YD, open.aa4);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}();
					var cardReaders = A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						$author$project$Api$Data$toMaybe(open.iE));
					var newForm = A3(
						$author$project$Utils$Form$update,
						$author$project$Components$CreatePaymentMethodModal$formFieldsUpdate(cardReaders),
						field,
						open.SD);
					return {
						GZ: cmd,
						agZ: 1,
						aiO: $author$project$Components$CreatePaymentMethodModal$Open(
							_Utils_update(
								open,
								{SD: newForm})),
						aR: _List_Nil
					};
				case 3:
					var _v6 = A2(
						$author$project$Utils$Form$validate,
						A2(
							$author$project$Components$CreatePaymentMethodModal$formFieldsValidator,
							open.aA,
							A2($author$project$Components$CreatePaymentMethodModal$acceptsAmex, open.YD, open.aa4)),
						open.SD);
					if (!_v6.$) {
						var _v7 = _v6.a;
						var newForm = _v7.a;
						var validFormFields = _v7.b;
						var _v8 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
						var cardInput = _v8.c6;
						var cardReader = _v8.aft;
						var _v9 = function () {
							var _v10 = _Utils_Tuple2(cardInput, cardReader);
							if (!_v10.a) {
								var _v11 = _v10.a;
								var portCall = function () {
									var _v12 = open.aA;
									switch (_v12.$) {
										case 1:
											return A2(
												$author$project$Ports$Stripe$confirmSetupIntent,
												'#' + $author$project$Components$CreatePaymentMethodModal$stripeElementId,
												{afh: $elm$core$Maybe$Nothing});
										case 2:
											return $author$project$Ports$Rainforest$submitPaymentMethod;
										default:
											return $elm$core$Platform$Cmd$none;
									}
								}();
								return _Utils_Tuple3($elm$core$Maybe$Nothing, portCall, $author$project$Api$Data$Loading);
							} else {
								if (!_v10.b.$) {
									var _v13 = _v10.a;
									var cardReader_ = _v10.b.a;
									var owner = function () {
										var _v14 = open.YD;
										switch (_v14.$) {
											case 0:
												var company = _v14.a;
												return $author$project$Components$CardReader$ConnectingModal$Company(
													$author$project$Api$Company$id(company));
											case 1:
												var practice = _v14.a;
												return $author$project$Components$CardReader$ConnectingModal$Practice(
													$author$project$Api$Practice$id(practice));
											default:
												var patient = _v14.a;
												return $author$project$Components$CardReader$ConnectingModal$Patient(
													$author$project$Api$Provider$Patient$One$id(patient));
										}
									}();
									return A2(
										$author$project$Utils$Tuple3$fromTuple2,
										open.k9,
										A3(
											$elm$core$Tuple$mapBoth,
											$elm$core$Maybe$Just,
											$elm$core$Platform$Cmd$map($author$project$Components$CreatePaymentMethodModal$ConnectingModalMsg),
											A7($author$project$Components$CardReader$ConnectingModal$init, apiClient, open.aa4, open.Ij, open.t9, cardReader_, owner, true)));
								} else {
									var _v15 = _v10.a;
									var _v16 = _v10.b;
									return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none, open.k9);
								}
							}
						}();
						var connectingModal = _v9.a;
						var cmd = _v9.b;
						var saveRequest = _v9.c;
						return {
							GZ: cmd,
							agZ: 1,
							aiO: $author$project$Components$CreatePaymentMethodModal$Open(
								_Utils_update(
									open,
									{iS: connectingModal, SD: newForm, k9: saveRequest})),
							aR: _List_Nil
						};
					} else {
						var newForm = _v6.a;
						return $author$project$Components$CreatePaymentMethodModal$andNoop(
							$author$project$Components$CreatePaymentMethodModal$Open(
								_Utils_update(
									open,
									{SD: newForm})));
					}
				case 4:
					var cardPaymentMethodResult = msg.a;
					if (!cardPaymentMethodResult.$) {
						var stripeCardPaymentMethod = cardPaymentMethodResult.a;
						var params = $author$project$Api$PaymentProcessorParams$stripeParams(stripeCardPaymentMethod.ahP);
						var _v18 = $author$project$Utils$Form$fields(open.SD);
						var categories = _v18.Nr;
						var setAsDefault = _v18.hC;
						return {
							GZ: A5($author$project$Components$CreatePaymentMethodModal$createPaymentMethod, open.xx, apiClient, params, categories, setAsDefault),
							agZ: 1,
							aiO: model,
							aR: _List_Nil
						};
					} else {
						var errorMessage = cardPaymentMethodResult.a;
						var errorString = A2($elm$core$String$contains, 'billing_details[name]', errorMessage) ? 'Please enter a valid card holder name.' : errorMessage;
						return {
							GZ: A4($author$project$Api$PaymentMethod$getClientSecret, open.xx, apiClient, open.jY, $author$project$Components$CreatePaymentMethodModal$GotSetupConfig),
							agZ: 1,
							aiO: $author$project$Components$CreatePaymentMethodModal$Open(
								_Utils_update(
									open,
									{k9: $author$project$Api$Data$NotAsked})),
							aR: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 1, errorString)
								])
						};
					}
				case 5:
					var categories = msg.a;
					var response = msg.b;
					if (response.$ === 3) {
						var card = response.a;
						var _v20 = $author$project$Utils$Form$fields(open.SD);
						var setAsDefault = _v20.hC;
						var tasks = function () {
							if (setAsDefault) {
								switch (card.$) {
									case 0:
										var card_ = card.a;
										return A2(
											$elm$core$List$map,
											function (category) {
												return A4(
													$author$project$Api$PaymentMethod$updateDefaultTask,
													open.xx,
													apiClient,
													$author$project$Api$PaymentMethod$fromCardOne(card_),
													category);
											},
											categories);
									case 1:
										var card_ = card.a;
										return A2(
											$elm$core$List$map,
											function (category) {
												return A4(
													$author$project$Api$PaymentMethod$updateDefaultTask,
													open.xx,
													apiClient,
													$author$project$Api$PaymentMethod$fromCardAll(card_),
													category);
											},
											categories);
									case 2:
										return _List_Nil;
									default:
										return _List_Nil;
								}
							} else {
								return _List_Nil;
							}
						}();
						var _v21 = $elm$core$List$isEmpty(tasks) ? _Utils_Tuple2(
							$elm$core$Maybe$Nothing,
							A2(
								$elm$core$Task$perform,
								function (_v22) {
									return $author$project$Components$CreatePaymentMethodModal$UpdateDefaultsFinished;
								},
								$elm$time$Time$now)) : A2(
							$elm$core$Tuple$mapFirst,
							$elm$core$Maybe$Just,
							$0ui$elm_task_parallel$Task$Parallel$attemptList(
								{
									Ye: $author$project$Components$CreatePaymentMethodModal$UpdateDefaultsFailed,
									Yg: $elm$core$Basics$always($author$project$Components$CreatePaymentMethodModal$UpdateDefaultsFinished),
									Yj: $author$project$Components$CreatePaymentMethodModal$UpdateDefaultsUpdated,
									acT: tasks
								}));
						var updateDefaultsState = _v21.a;
						var updateDefaultsCmd = _v21.b;
						return {
							GZ: updateDefaultsCmd,
							agZ: 1,
							aiO: $author$project$Components$CreatePaymentMethodModal$Open(
								_Utils_update(
									open,
									{qO: updateDefaultsState})),
							aR: _List_Nil
						};
					} else {
						return $author$project$Components$CreatePaymentMethodModal$andNoop(
							$author$project$Components$CreatePaymentMethodModal$Open(
								_Utils_update(
									open,
									{k9: response})));
					}
				case 6:
					var categories = msg.a;
					var response = msg.b;
					switch (response.$) {
						case 3:
							var paymentMethod = response.a;
							var tasks = function () {
								if ($author$project$Api$Data$stringifyPath(open.xx) === 'employer') {
									return _List_Nil;
								} else {
									var _v27 = $author$project$Utils$Form$fields(open.SD);
									var setAsDefault = _v27.hC;
									return setAsDefault ? A2(
										$elm$core$List$map,
										function (category) {
											return A4($author$project$Api$PaymentMethod$updateDefaultTask, open.xx, apiClient, paymentMethod, category);
										},
										categories) : _List_Nil;
								}
							}();
							var _v25 = $elm$core$List$isEmpty(tasks) ? _Utils_Tuple2(
								$elm$core$Maybe$Nothing,
								A2(
									$elm$core$Task$perform,
									function (_v26) {
										return $author$project$Components$CreatePaymentMethodModal$UpdateDefaultsFinished;
									},
									$elm$time$Time$now)) : A2(
								$elm$core$Tuple$mapFirst,
								$elm$core$Maybe$Just,
								$0ui$elm_task_parallel$Task$Parallel$attemptList(
									{
										Ye: $author$project$Components$CreatePaymentMethodModal$UpdateDefaultsFailed,
										Yg: $elm$core$Basics$always($author$project$Components$CreatePaymentMethodModal$UpdateDefaultsFinished),
										Yj: $author$project$Components$CreatePaymentMethodModal$UpdateDefaultsUpdated,
										acT: tasks
									}));
							var updateDefaultsState = _v25.a;
							var updateDefaultsCmd = _v25.b;
							return {
								GZ: updateDefaultsCmd,
								agZ: 1,
								aiO: $author$project$Components$CreatePaymentMethodModal$Open(
									_Utils_update(
										open,
										{qO: updateDefaultsState})),
								aR: _List_Nil
							};
						case 2:
							return {
								GZ: A4($author$project$Api$PaymentMethod$getClientSecret, open.xx, apiClient, open.jY, $author$project$Components$CreatePaymentMethodModal$GotSetupConfig),
								agZ: 1,
								aiO: $author$project$Components$CreatePaymentMethodModal$Open(
									_Utils_update(
										open,
										{k9: $author$project$Api$Data$NotAsked})),
								aR: $author$project$OutMsg$handleErrorResponse(response)
							};
						default:
							return {
								GZ: $elm$core$Platform$Cmd$none,
								agZ: 1,
								aiO: model,
								aR: $author$project$OutMsg$handleErrorResponse(response)
							};
					}
				case 7:
					var updateDefaultsMsg = msg.a;
					var _v28 = function () {
						var _v29 = open.qO;
						if (!_v29.$) {
							var updateDefaultsState_ = _v29.a;
							return A2(
								$elm$core$Tuple$mapFirst,
								$elm$core$Maybe$Just,
								A2($0ui$elm_task_parallel$Task$Parallel$updateList, updateDefaultsState_, updateDefaultsMsg));
						} else {
							return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
						}
					}();
					var newUpdateDefaultsState = _v28.a;
					var updateDefaultsCmd = _v28.b;
					return {
						GZ: updateDefaultsCmd,
						agZ: 1,
						aiO: $author$project$Components$CreatePaymentMethodModal$Open(
							_Utils_update(
								open,
								{qO: newUpdateDefaultsState})),
						aR: _List_Nil
					};
				case 8:
					var response = msg.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 1,
						aiO: model,
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				case 9:
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: $author$project$Components$CreatePaymentMethodModal$Closed,
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Payment Method successfully added.')
							])
					};
				case 10:
					var response = msg.a;
					return {
						GZ: $author$project$Ports$LocalStorage$getItem('last-used-card-reader'),
						agZ: 1,
						aiO: $author$project$Components$CreatePaymentMethodModal$Open(
							_Utils_update(
								open,
								{iE: response})),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				case 11:
					var _v30 = msg.a;
					var key = _v30.a;
					var value = _v30.b;
					var _v31 = _Utils_Tuple2(key, value);
					if ((_v31.a === 'last-used-card-reader') && (!_v31.b.$)) {
						var lastUsedCardReaderId = _v31.b.a;
						var cardReaders = A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							$author$project$Api$Data$toMaybe(open.iE));
						var newForm = A3(
							$author$project$Utils$Form$update,
							$author$project$Components$CreatePaymentMethodModal$formFieldsUpdate(cardReaders),
							$author$project$Components$CreatePaymentMethodModal$CardReader(lastUsedCardReaderId),
							open.SD);
						return $author$project$Components$CreatePaymentMethodModal$andNoop(
							$author$project$Components$CreatePaymentMethodModal$Open(
								_Utils_update(
									open,
									{SD: newForm})));
					} else {
						return $author$project$Components$CreatePaymentMethodModal$andNoop(model);
					}
				case 12:
					var subMsg = msg.a;
					var _v32 = open.iS;
					if (!_v32.$) {
						var connectingModal = _v32.a;
						var connectingModalResult = A3($author$project$Components$CardReader$ConnectingModal$update, apiClient, subMsg, connectingModal);
						var _v33 = function () {
							var _v34 = connectingModalResult.agZ;
							switch (_v34.$) {
								case 1:
									var card = _v34.a;
									var cardParams = $author$project$Components$CreatePaymentMethodModal$cardParamsFromReader(card);
									var _v35 = $author$project$Utils$Form$fields(open.SD);
									var categories = _v35.Nr;
									return _Utils_Tuple3(
										$elm$core$Maybe$Nothing,
										$author$project$Api$Data$Loading,
										A5($author$project$Components$CreatePaymentMethodModal$createCardFromReader, open.xx, apiClient, open.aa4, categories, cardParams));
								case 0:
									return _Utils_Tuple3($elm$core$Maybe$Nothing, open.k9, $elm$core$Platform$Cmd$none);
								default:
									return _Utils_Tuple3(
										$elm$core$Maybe$Just(connectingModalResult.aiO),
										open.k9,
										$elm$core$Platform$Cmd$none);
							}
						}();
						var connectingModal_ = _v33.a;
						var saveRequest = _v33.b;
						var cmd = _v33.c;
						return {
							GZ: $elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($elm$core$Platform$Cmd$map, $author$project$Components$CreatePaymentMethodModal$ConnectingModalMsg, connectingModalResult.GZ),
										cmd
									])),
							agZ: 1,
							aiO: $author$project$Components$CreatePaymentMethodModal$Open(
								_Utils_update(
									open,
									{iS: connectingModal_, k9: saveRequest})),
							aR: connectingModalResult.aR
						};
					} else {
						return $author$project$Components$CreatePaymentMethodModal$andNoop(model);
					}
				case 0:
					return $author$project$Components$CreatePaymentMethodModal$andNoop(model);
				case 13:
					var response = msg.a;
					if (response.$ === 3) {
						var setup = response.a;
						var config = function () {
							if (!setup.$) {
								var secret = setup.a;
								return $author$project$Components$CreatePaymentMethodModal$Stripe(secret);
							} else {
								var sessionKey = setup.a.alo;
								var paymentMethodConfigId = setup.a.ajX;
								var allowedMethods = setup.a.aeX;
								return $author$project$Components$CreatePaymentMethodModal$Rainforest(
									{aeX: allowedMethods, dp: true, Ap: false, ajX: paymentMethodConfigId, alo: sessionKey});
							}
						}();
						var _v37 = A4($author$project$Components$CreatePaymentMethodModal$initFormFields, open.ZV, open.YD, open.aa4, config);
						var formFields = _v37.a;
						var formFieldsCmd = _v37.b;
						return {
							GZ: $elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										formFieldsCmd,
										$author$project$Ports$LocalStorage$getItem('last-used-card-reader')
									])),
							agZ: 1,
							aiO: $author$project$Components$CreatePaymentMethodModal$Open(
								_Utils_update(
									open,
									{
										SD: $author$project$Utils$Form$init(formFields),
										dp: false,
										aA: config
									})),
							aR: _List_Nil
						};
					} else {
						return function (res) {
							return _Utils_update(
								res,
								{
									aR: $author$project$OutMsg$handleErrorResponse(response)
								});
						}(
							$author$project$Components$CreatePaymentMethodModal$andNoop(
								$author$project$Components$CreatePaymentMethodModal$Open(
									_Utils_update(
										open,
										{dp: false}))));
					}
				case 16:
					var rainforestMsg = msg.a;
					var _v39 = open.aA;
					if (_v39.$ === 2) {
						var config = _v39.a;
						return function (_v40) {
							var m = _v40.a;
							var cmd = _v40.b;
							return {GZ: cmd, agZ: 1, aiO: m, aR: _List_Nil};
						}(
							A2(
								$elm$core$Tuple$mapFirst,
								$author$project$Components$CreatePaymentMethodModal$Open,
								A5($author$project$Components$CreatePaymentMethodModal$updateRainforest, apiClient, open.xx, rainforestMsg, config, open)));
					} else {
						return $author$project$Components$CreatePaymentMethodModal$andNoop(
							$author$project$Components$CreatePaymentMethodModal$Open(open));
					}
				case 14:
					var cmd = function () {
						var _v41 = open.YD;
						if (_v41.$ === 2) {
							var patient = _v41.a;
							return A4(
								$author$project$Api$Provider$Patient$requestPaymentInfo,
								apiClient,
								$author$project$Api$Provider$Patient$One$id(patient),
								$elm$core$Maybe$Nothing,
								$author$project$Components$CreatePaymentMethodModal$GotPaymentInfoUpdate);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}();
					return {GZ: cmd, agZ: 1, aiO: model, aR: _List_Nil};
				default:
					var response = msg.a;
					if (response.$ === 3) {
						var requestPayInfo = response.a;
						var _v43 = open.YD;
						if (_v43.$ === 2) {
							var patient = _v43.a;
							return {
								GZ: $elm$core$Platform$Cmd$none,
								agZ: 1,
								aiO: $author$project$Components$CreatePaymentMethodModal$Open(
									_Utils_update(
										open,
										{
											CL: $author$project$Api$Provider$Patient$RequestPaymentInfoOne$requestPayInfoSentAt(requestPayInfo)
										})),
								aR: _List_fromArray(
									[
										A2(
										$author$project$OutMsg$ShowToast,
										3,
										'An email has been sent to ' + ($author$project$Api$Provider$Patient$One$name(patient) + ' requesting new payment information.'))
									])
							};
						} else {
							return {
								GZ: $elm$core$Platform$Cmd$none,
								agZ: 1,
								aiO: model,
								aR: $author$project$OutMsg$handleErrorResponse(response)
							};
						}
					} else {
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 1,
							aiO: model,
							aR: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
			}
		} else {
			if (!msg.$) {
				var openOptions = msg.a;
				var useCardReaders = openOptions.vl && $author$project$Api$Practice$usesCardReaders(openOptions.ZV);
				var patientRequestInfoSentAt = function () {
					var _v46 = openOptions.YD;
					if (_v46.$ === 2) {
						var patient = _v46.a;
						return $author$project$Api$Provider$Patient$One$requestPayInfoSentAt(patient);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}();
				var cardReaderCmd = useCardReaders ? A3($author$project$Api$Provider$CardReader$list, apiClient, $elm$core$Basics$identity, $author$project$Components$CreatePaymentMethodModal$GotCardReaders) : $elm$core$Platform$Cmd$none;
				var _v45 = A4($author$project$Components$CreatePaymentMethodModal$initFormFields, openOptions.ZV, openOptions.YD, openOptions.aa4, $author$project$Components$CreatePaymentMethodModal$Loading);
				var formFields = _v45.a;
				var formFieldsCmd = _v45.b;
				var open = {
					xx: openOptions.xx,
					iE: $author$project$Api$Data$Loading,
					iS: $elm$core$Maybe$Nothing,
					SD: $author$project$Utils$Form$init(formFields),
					sF: openOptions.sF,
					jY: openOptions.jY,
					Ij: openOptions.Ij,
					dp: true,
					YD: openOptions.YD,
					CL: patientRequestInfoSentAt,
					ZV: openOptions.ZV,
					aA: $author$project$Components$CreatePaymentMethodModal$Loading,
					t9: openOptions.t9,
					k9: $author$project$Api$Data$NotAsked,
					dK: 1,
					aa4: openOptions.aa4,
					J7: openOptions.J7,
					qO: $elm$core$Maybe$Nothing,
					vl: useCardReaders
				};
				var setupIntentCmd = (!A2($author$project$Components$CreatePaymentMethodModal$isAddPaymentMethodDisabled, openOptions.YD, openOptions.aa4)) ? A4($author$project$Api$PaymentMethod$getClientSecret, open.xx, apiClient, openOptions.jY, $author$project$Components$CreatePaymentMethodModal$GotSetupConfig) : $elm$core$Platform$Cmd$none;
				return {
					GZ: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[formFieldsCmd, cardReaderCmd, setupIntentCmd])),
					agZ: 1,
					aiO: $author$project$Components$CreatePaymentMethodModal$Open(
						_Utils_update(
							open,
							{
								dp: !A2($author$project$Components$CreatePaymentMethodModal$isAddPaymentMethodDisabled, openOptions.YD, openOptions.aa4)
							})),
					aR: _List_Nil
				};
			} else {
				return $author$project$Components$CreatePaymentMethodModal$andNoop(model);
			}
		}
	});
var $author$project$Components$Practice$PaymentSources$Network$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var createPaymentMethodModalResult = A3($author$project$Components$CreatePaymentMethodModal$update, apiClient, subMsg, model.i_);
				var _v1 = function () {
					var _v2 = createPaymentMethodModalResult.agZ;
					if (!_v2) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{rs: $author$project$Api$Data$Loading, rC: $author$project$Api$Data$Loading}),
							$elm$core$Platform$Cmd$none,
							0);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, 2);
					}
				}();
				var newModel = _v1.a;
				var cmd = _v1.b;
				var event = _v1.c;
				return {
					GZ: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Practice$PaymentSources$Network$CreatePaymentMethodModalMsg, createPaymentMethodModalResult.GZ),
								cmd
							])),
					agZ: event,
					aiO: _Utils_update(
						newModel,
						{i_: createPaymentMethodModalResult.aiO}),
					aR: createPaymentMethodModalResult.aR
				};
			case 1:
				var source = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 2,
					aiO: _Utils_update(
						model,
						{
							gc: $elm$core$Maybe$Just(source)
						}),
					aR: _List_Nil
				};
			case 3:
				var source = msg.a;
				var confirmed = msg.b;
				return confirmed ? {
					GZ: A5(
						$author$project$Api$Source$delete,
						$author$project$Api$Data$providerPath,
						apiClient,
						model.aa4,
						source,
						$author$project$Components$Practice$PaymentSources$Network$Deleted(source)),
					agZ: 2,
					aiO: _Utils_update(
						model,
						{
							gc: $elm$core$Maybe$Nothing,
							el: A2(
								$elm$core$Set$insert,
								$author$project$Api$Source$id(source),
								model.el)
						}),
					aR: _List_Nil
				} : {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 2,
					aiO: _Utils_update(
						model,
						{gc: $elm$core$Maybe$Nothing}),
					aR: _List_Nil
				};
			default:
				var source = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 1,
							aiO: _Utils_update(
								model,
								{
									rs: $author$project$Api$Data$Loading,
									rC: $author$project$Api$Data$Loading,
									gc: $elm$core$Maybe$Nothing,
									el: A2(
										$elm$core$Set$remove,
										$author$project$Api$Source$id(source),
										model.el)
								}),
							aR: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Source successfully deleted')
								])
						};
					case 2:
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 2,
							aiO: _Utils_update(
								model,
								{
									el: A2(
										$elm$core$Set$remove,
										$author$project$Api$Source$id(source),
										model.el)
								}),
							aR: $author$project$OutMsg$handleErrorResponse(response)
						};
					default:
						return {GZ: $elm$core$Platform$Cmd$none, agZ: 2, aiO: model, aR: _List_Nil};
				}
		}
	});
var $author$project$Components$Practice$PaymentSources$Standard$Deleted = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Practice$PaymentSources$Standard$None = 3;
var $author$project$Components$Practice$PaymentSources$Standard$PaymentMethodCreated = 0;
var $author$project$Components$Practice$PaymentSources$Standard$PaymentMethodDefaultChanged = 2;
var $author$project$Components$Practice$PaymentSources$Standard$PaymentMethodDeleted = 1;
var $author$project$Components$Practice$PaymentSources$Standard$SetAsDefaultResponded = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$BankAccount$EmployerOne = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$BankAccount$ProviderOne = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$BankAccount$updateDefault = F4(
	function (basePath, apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Employer$BankAccount$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['default']),
					A2($author$project$Api$Employer$BankAccount$bankAccountPath, basePath, id_))));
	});
var $author$project$Api$Provider$BankAccount$updateDefault = F5(
	function (basePath, apiClient, id_, category, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'category',
					A2(
						$author$project$Utils$Encode$nullable,
						$elm$json$Json$Encode$string,
						A2($elm$core$Maybe$map, $author$project$Api$Provider$Source$Defaults$categoryName, category)))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$BankAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['default']),
						A2($author$project$Api$Provider$BankAccount$bankAccountPath, basePath, id_)))));
	});
var $author$project$Api$BankAccount$updateDefault = F6(
	function (basePath, apiClient, session, bankAccount, category, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4(
			$author$project$Api$Employer$BankAccount$updateDefault,
			basePath,
			apiClient,
			$author$project$Api$BankAccount$id(bankAccount),
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$BankAccount$EmployerOne))) : A5(
			$author$project$Api$Provider$BankAccount$updateDefault,
			basePath,
			apiClient,
			$author$project$Api$BankAccount$id(bankAccount),
			category,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$BankAccount$ProviderOne)));
	});
var $author$project$Api$Employer$Card$updateDefault = F4(
	function (basePath, apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Employer$Card$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['default']),
					A2($author$project$Api$Employer$Card$cardPath, basePath, id_))));
	});
var $author$project$Api$Provider$Card$updateDefault = F5(
	function (basePath, apiClient, id_, category, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'category',
					A2(
						$author$project$Utils$Encode$nullable,
						$elm$json$Json$Encode$string,
						A2($elm$core$Maybe$map, $author$project$Api$Provider$Source$Defaults$categoryName, category)))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Card$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['default']),
						A2($author$project$Api$Provider$Card$cardPath, basePath, id_)))));
	});
var $author$project$Api$Card$updateDefault = F6(
	function (basePath, apiClient, session, card, category, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4(
			$author$project$Api$Employer$Card$updateDefault,
			basePath,
			apiClient,
			$author$project$Api$Card$id(card),
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Card$EmployerOne))) : A5(
			$author$project$Api$Provider$Card$updateDefault,
			basePath,
			apiClient,
			$author$project$Api$Card$id(card),
			category,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Card$ProviderOne)));
	});
var $author$project$Api$Source$updateDefault = F6(
	function (basePath, apiClient, session, source, category, toMsg) {
		switch (source.$) {
			case 0:
				var card = source.a;
				return A6(
					$author$project$Api$Card$updateDefault,
					basePath,
					apiClient,
					session,
					card,
					category,
					A2(
						$elm$core$Basics$composeL,
						toMsg,
						$author$project$Api$Data$map($author$project$Api$Source$Card)));
			case 1:
				var bankAccount = source.a;
				return A6(
					$author$project$Api$BankAccount$updateDefault,
					basePath,
					apiClient,
					session,
					bankAccount,
					category,
					A2(
						$elm$core$Basics$composeL,
						toMsg,
						$author$project$Api$Data$map($author$project$Api$Source$BankAccount)));
			default:
				return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Components$Practice$PaymentSources$Standard$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var createPaymentMethodModalResult = A3($author$project$Components$CreatePaymentMethodModal$update, apiClient, subMsg, model.i_);
				var _v1 = function () {
					var _v2 = createPaymentMethodModalResult.agZ;
					if (!_v2) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{rs: $author$project$Api$Data$Loading, rC: $author$project$Api$Data$Loading}),
							$elm$core$Platform$Cmd$none,
							0);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, 3);
					}
				}();
				var newModel = _v1.a;
				var cmd = _v1.b;
				var event = _v1.c;
				return {
					GZ: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Practice$PaymentSources$Standard$CreatePaymentMethodModalMsg, createPaymentMethodModalResult.GZ),
								cmd
							])),
					agZ: event,
					aiO: _Utils_update(
						newModel,
						{i_: createPaymentMethodModalResult.aiO}),
					aR: createPaymentMethodModalResult.aR
				};
			case 1:
				var source = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 3,
					aiO: _Utils_update(
						model,
						{
							gc: $elm$core$Maybe$Just(source)
						}),
					aR: _List_Nil
				};
			case 3:
				var source = msg.a;
				var confirmed = msg.b;
				return confirmed ? {
					GZ: A5(
						$author$project$Api$Source$delete,
						$author$project$Api$Data$providerPath,
						apiClient,
						model.aa4,
						source,
						$author$project$Components$Practice$PaymentSources$Standard$Deleted(source)),
					agZ: 3,
					aiO: _Utils_update(
						model,
						{
							gc: $elm$core$Maybe$Nothing,
							el: A2(
								$elm$core$Set$insert,
								$author$project$Api$Source$id(source),
								model.el)
						}),
					aR: _List_Nil
				} : {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 3,
					aiO: _Utils_update(
						model,
						{gc: $elm$core$Maybe$Nothing}),
					aR: _List_Nil
				};
			case 2:
				var source = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 1,
							aiO: _Utils_update(
								model,
								{
									rs: $author$project$Api$Data$Loading,
									rC: $author$project$Api$Data$Loading,
									gc: $elm$core$Maybe$Nothing,
									el: A2(
										$elm$core$Set$remove,
										$author$project$Api$Source$id(source),
										model.el)
								}),
							aR: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Payment method deleted.')
								])
						};
					case 2:
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 3,
							aiO: _Utils_update(
								model,
								{
									el: A2(
										$elm$core$Set$remove,
										$author$project$Api$Source$id(source),
										model.el)
								}),
							aR: $author$project$OutMsg$handleErrorResponse(response)
						};
					default:
						return {GZ: $elm$core$Platform$Cmd$none, agZ: 3, aiO: model, aR: _List_Nil};
				}
			case 4:
				var source = msg.a;
				return {
					GZ: A6(
						$author$project$Api$Source$updateDefault,
						$author$project$Api$Data$providerPath,
						apiClient,
						model.aa4,
						source,
						$elm$core$Maybe$Just(0),
						$author$project$Components$Practice$PaymentSources$Standard$SetAsDefaultResponded),
					agZ: 3,
					aiO: _Utils_update(
						model,
						{
							pZ: $elm$core$Maybe$Just(
								$author$project$Api$Source$id(source))
						}),
					aR: _List_Nil
				};
			default:
				var response = msg.a;
				switch (response.$) {
					case 3:
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 2,
							aiO: _Utils_update(
								model,
								{rs: $author$project$Api$Data$Loading, rC: $author$project$Api$Data$Loading, pZ: $elm$core$Maybe$Nothing}),
							aR: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Default payment method updated.')
								])
						};
					case 2:
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 3,
							aiO: _Utils_update(
								model,
								{pZ: $elm$core$Maybe$Nothing}),
							aR: $author$project$OutMsg$handleErrorResponse(response)
						};
					default:
						return {GZ: $elm$core$Platform$Cmd$none, agZ: 3, aiO: model, aR: _List_Nil};
				}
		}
	});
var $author$project$Pages$Admin$PaymentSources$Updated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Admin$PaymentSources$updateSource = F3(
	function (apiClient, session, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var _v0 = fields.JQ;
		if (!_v0.$) {
			var source = _v0.a;
			return A6(
				$author$project$Api$Source$updateDefault,
				$author$project$Api$Data$providerPath,
				apiClient,
				session,
				source,
				$elm$core$Maybe$Just(fields.GW),
				$author$project$Pages$Admin$PaymentSources$Updated);
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Pages$Admin$PaymentSources$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							rC: response,
							bK: A2($author$project$Pages$Admin$PaymentSources$propagateCards, response, model.bK)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							rs: response,
							bK: A2($author$project$Pages$Admin$PaymentSources$propagateBankAccounts, response, model.bK)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 2:
				var sources = msg.a;
				var paymentCategory = msg.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bd: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									sources,
									$author$project$Utils$Form$init(
										$author$project$Pages$Admin$PaymentSources$formFieldsFromPaymentCategory(paymentCategory)),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var field = msg.a;
				var _v1 = model.bd;
				if (!_v1.$) {
					var _v2 = _v1.a;
					var sources = _v2.a;
					var form = _v2.b;
					var paymentCategory = _v2.c;
					var newForm = A3(
						$author$project$Utils$Form$update,
						$author$project$Pages$Admin$PaymentSources$formFieldsUpdate(sources),
						field,
						form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bd: $elm$core$Maybe$Just(
									_Utils_Tuple3(sources, newForm, paymentCategory))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bd: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var _v3 = model.bd;
				if (!_v3.$) {
					var _v4 = _v3.a;
					var sources = _v4.a;
					var form = _v4.b;
					var _v5 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$PaymentSources$formFieldsValidator, form);
					if (!_v5.$) {
						var _v6 = _v5.a;
						var newForm = _v6.a;
						var validFormFields = _v6.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bd: $elm$core$Maybe$Just(
										_Utils_Tuple3(sources, newForm, $author$project$Api$Data$Loading))
								}),
							A3($author$project$Pages$Admin$PaymentSources$updateSource, model.Gv, model.aa4, validFormFields),
							_List_Nil);
					} else {
						var newForm = _v5.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bd: $elm$core$Maybe$Just(
										_Utils_Tuple3(sources, newForm, $author$project$Api$Data$NotAsked))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var response = msg.a;
				var _v7 = model.bd;
				if (!_v7.$) {
					var _v8 = _v7.a;
					var sources = _v8.a;
					var form = _v8.b;
					if (response.$ === 3) {
						var _v10 = $author$project$Pages$Admin$PaymentSources$loadData(model.Gv);
						var cards = _v10.a;
						var bankAccounts = _v10.b;
						var cmd = _v10.c;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{rs: bankAccounts, rC: cards, bd: $elm$core$Maybe$Nothing}),
							cmd,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Default payment method updated.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bd: $elm$core$Maybe$Just(
										_Utils_Tuple3(sources, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var subMsg = msg.a;
				var _v11 = model.bK;
				if (!_v11.$) {
					var standardModel = _v11.a;
					var result = A3($author$project$Components$Practice$PaymentSources$Standard$update, model.Gv, subMsg, standardModel);
					var reload = function () {
						var _v13 = result.agZ;
						switch (_v13) {
							case 0:
								return true;
							case 1:
								return true;
							case 2:
								return true;
							default:
								return false;
						}
					}();
					var _v12 = reload ? $author$project$Pages$Admin$PaymentSources$loadData(model.Gv) : _Utils_Tuple3(model.rC, model.rs, $elm$core$Platform$Cmd$none);
					var cards = _v12.a;
					var bankAccounts = _v12.b;
					var dataCmd = _v12.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								rs: bankAccounts,
								rC: cards,
								bK: $author$project$Pages$Admin$PaymentSources$Standard(result.aiO)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$PaymentSources$StandardPaymentsMsg, result.GZ),
									dataCmd
								])),
						result.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var subMsg = msg.a;
				var _v14 = model.bK;
				if (_v14.$ === 1) {
					var networkModel = _v14.a;
					var result = A3($author$project$Components$Practice$PaymentSources$Network$update, model.Gv, subMsg, networkModel);
					var reload = function () {
						var _v16 = result.agZ;
						switch (_v16) {
							case 0:
								return true;
							case 1:
								return true;
							default:
								return false;
						}
					}();
					var _v15 = reload ? $author$project$Pages$Admin$PaymentSources$loadData(model.Gv) : _Utils_Tuple3(model.rC, model.rs, $elm$core$Platform$Cmd$none);
					var cards = _v15.a;
					var bankAccounts = _v15.b;
					var dataCmd = _v15.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								rs: bankAccounts,
								rC: cards,
								bK: $author$project$Pages$Admin$PaymentSources$Network(result.aiO)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$PaymentSources$NetworkPaymentsMsg, result.GZ),
									dataCmd
								])),
						result.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Components$CreatePaymentMethodModal$Approved = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$CardBrandUpdated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$Category = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$CreatePaymentMethodModal$FormUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$Loaded = {$: 2};
var $author$project$Components$CreatePaymentMethodModal$MethodUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$RainforestMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$Reader = 1;
var $author$project$Components$CreatePaymentMethodModal$Save = {$: 3};
var $author$project$Components$CreatePaymentMethodModal$SetAsDefault = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$ValidityChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$cardReaderLabel = F2(
	function (showProcessor, cardReader) {
		return A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A3(
						$author$project$Utils$PaymentProcessor$toLabel,
						showProcessor,
						cardReader,
						A2($elm$core$Basics$composeR, $author$project$Api$Provider$CardReader$All$paymentProcessor, $elm$core$Maybe$Just)),
						$elm$core$Maybe$Just(
						$author$project$Api$Provider$CardReader$All$label(cardReader))
					])));
	});
var $author$project$Components$CreatePaymentMethodModal$cardReaderOptions = F2(
	function (showProcessor, cardReaders) {
		return A2(
			$elm$core$List$cons,
			A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(''),
				'Choose a card reader...'),
			A2(
				$elm$core$List$map,
				function (cardReader) {
					return A3(
						$author$project$Ui$Form$Select$option,
						_List_Nil,
						$elm$core$Maybe$Just(
							$author$project$Api$Provider$CardReader$All$id(cardReader)),
						A2($author$project$Components$CreatePaymentMethodModal$cardReaderLabel, showProcessor, cardReader));
				},
				cardReaders));
	});
var $author$project$Api$Employer$Practice$One$hasPaymentProcessorAccount = function (_v0) {
	var record = _v0;
	return record.Tg;
};
var $author$project$Api$Practice$hasPaymentProcessorAccount = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$hasPaymentProcessorAccount(practice_);
	} else {
		var practice_ = practice.a;
		return $author$project$Api$Employer$Practice$One$hasPaymentProcessorAccount(practice_);
	}
};
var $author$project$Ui$Types$Lg = 3;
var $author$project$Ui$Spinner$large = $author$project$Ui$Spinner$Size(3);
var $author$project$Api$Platform$Session$One$organizationIsAdminPractice = function (_v0) {
	var record = _v0;
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$eq(0),
			A2($elm$core$Maybe$map, $author$project$Api$Platform$Organization$Shared$type_, record.Yr))) && (record.ak3 === 'practice_admin');
};
var $author$project$Utils$PaymentProcessor$toSetupAlert = F2(
	function (practice, prefix) {
		return A2(
			$author$project$Ui$Alert$warning,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						if (!prefix.$) {
							var prefix_ = prefix.a;
							return _List_fromArray(
								[
									$elm$html$Html$text(prefix_),
									$elm$html$Html$text(', please')
								]);
						} else {
							return _List_fromArray(
								[
									$elm$html$Html$text('Please')
								]);
						}
					}(),
						_List_fromArray(
						[
							$author$project$Utils$Html$noBreakSpace,
							$elm$html$Html$text('setup'),
							$author$project$Utils$Html$noBreakSpace
						]),
						(($author$project$Api$Practice$paymentProcessor(practice) === 'stripe') && (!A2($author$project$Api$Practice$featureEnabled, 26, practice))) ? _List_fromArray(
						[
							$elm$html$Html$text('your '),
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Admin__Stripe,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Stripe integration')
								])),
							$elm$html$Html$text('.')
						]) : _List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Admin__PaymentProcessing,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Payment Processing')
								])),
							$elm$html$Html$text('.')
						])
					])));
	});
var $author$project$Components$Practice$PaymentCategoriesPicker$isChecked = F2(
	function (categories, category) {
		return $author$project$Utils$Maybe$toBool(
			A2(
				$elm_community$list_extra$List$Extra$find,
				function (category_) {
					return _Utils_eq(category_, category);
				},
				categories));
	});
var $author$project$Api$Provider$Source$Defaults$categoryLabel = function (category) {
	switch (category) {
		case 0:
			return 'Hint & Marketplace Partners';
		case 1:
			return 'Affiliate Payments via Stripe';
		default:
			return 'Affiliate Payments via Hint Payments';
	}
};
var $author$project$Components$Practice$PaymentCategoriesPicker$viewPaymentCategory = F3(
	function (categories, toMsg, category) {
		return A2(
			$author$project$Ui$Form$Checkbox$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Checkbox$value(
					A2($author$project$Components$Practice$PaymentCategoriesPicker$isChecked, categories, category)),
					$author$project$Ui$Form$Checkbox$onCheck(
					toMsg(category))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Api$Provider$Source$Defaults$categoryLabel(category))
				]));
	});
var $author$project$Components$Practice$PaymentCategoriesPicker$view = F4(
	function (practice, processor, currentCategories, toMsg) {
		var applicable = A2($author$project$Components$Practice$PaymentCategoriesPicker$allCategoriesForProcessor, practice, processor);
		var _v0 = _Utils_Tuple2(
			$author$project$Api$Practice$isNetwork(practice),
			applicable);
		if (!_v0.b.b) {
			return $author$project$Utils$Html$empty;
		} else {
			if ((!_v0.a) && (!_v0.b.b.b)) {
				var _v1 = _v0.b;
				var category = _v1.a;
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$HorizontalRule$view(_List_Nil),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$mb4]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Checkbox$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Checkbox$value(
											A2($author$project$Components$Practice$PaymentCategoriesPicker$isChecked, currentCategories, category)),
											$author$project$Ui$Form$Checkbox$onCheck(
											toMsg(category))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Set as default payment method')
										]))
								]))
						]));
			} else {
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$HorizontalRule$view(_List_Nil),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Set default for following categories')
										]))
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$mb4]),
							A2(
								$elm$core$List$map,
								A2($author$project$Components$Practice$PaymentCategoriesPicker$viewPaymentCategory, currentCategories, toMsg),
								applicable))
						]));
			}
		}
	});
var $author$project$WebComponents$Rainforest$Payment$approvedDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['detail']),
	A2(
		$elm$json$Json$Decode$index,
		0,
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['data', 'payment_method_id']),
			$elm$json$Json$Decode$string)));
var $author$project$WebComponents$Rainforest$Payment$cardBrandUpdatedDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['detail']),
	A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string));
var $author$project$WebComponents$Rainforest$Payment$methodUpdatedDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['detail']),
	A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string));
var $author$project$WebComponents$Rainforest$Payment$view = F2(
	function (_v0, data) {
		var onApproved = _v0.ajb;
		var onInvalid = _v0.ajn;
		var onValid = _v0.ajy;
		var onLoaded = _v0.ajo;
		var onMethodUpdated = _v0.ajp;
		var onCardBrandUpdated = _v0.ajc;
		return A3(
			$elm$html$Html$node,
			'rainforest-payment',
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'session-key', data.alo),
					A2($elm$html$Html$Attributes$attribute, 'payment-method-config-id', data.ajX),
					A2($elm$html$Html$Attributes$attribute, 'allowed-methods', data.aeX),
					A2($elm$html$Html$Attributes$attribute, 'hide-button', ''),
					A2(
					$elm$html$Html$Events$on,
					'approved',
					A2($elm$json$Json$Decode$map, onApproved, $author$project$WebComponents$Rainforest$Payment$approvedDecoder)),
					A2(
					$elm$html$Html$Events$on,
					'valid',
					$elm$json$Json$Decode$succeed(onValid)),
					A2(
					$elm$html$Html$Events$on,
					'invalid',
					$elm$json$Json$Decode$succeed(onInvalid)),
					A2(
					$elm$html$Html$Events$on,
					'loaded',
					$elm$json$Json$Decode$succeed(onLoaded)),
					A2(
					$elm$html$Html$Events$on,
					'method-updated',
					A2($elm$json$Json$Decode$map, onMethodUpdated, $author$project$WebComponents$Rainforest$Payment$methodUpdatedDecoder)),
					A2(
					$elm$html$Html$Events$on,
					'card-brand-updated',
					A2($elm$json$Json$Decode$map, onCardBrandUpdated, $author$project$WebComponents$Rainforest$Payment$cardBrandUpdatedDecoder)),
					A2($elm$html$Html$Attributes$attribute, 'style-button-color', 'var(--color-primary-300)'),
					A2($elm$html$Html$Attributes$attribute, 'style-button-border-radius', '9999px'),
					A2($elm$html$Html$Attributes$attribute, 'style-font-family', 'sans-serif'),
					A2($elm$html$Html$Attributes$attribute, 'style-placeholder-text', 'true')
				]),
			_List_Nil);
	});
var $author$project$Components$CreatePaymentMethodModal$CardInput = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$viewCardInputButton = F3(
	function (currentCardInput, cardInput, label) {
		return A3(
			$author$project$Ui$Button$view,
			{mm: label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(currentCardInput, cardInput)),
					$author$project$Ui$Button$onClick(
					$author$project$Components$CreatePaymentMethodModal$FormUpdated(
						$author$project$Components$CreatePaymentMethodModal$CardInput(cardInput)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Ui$Image$SampleCheck = 4;
var $author$project$Components$CreatePaymentMethodModal$viewCheckTooltipHelper = function (imageStore) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$mt2]),
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Popover$view,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Where are these numbers on a check?'},
						_List_fromArray(
							[$author$project$Ui$Button$link]),
						_List_fromArray(
							[
								$elm$html$Html$text('Where are these numbers on a check?')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Popover$body,
						_List_Nil,
						_List_fromArray(
							[
								A4(
								$author$project$Ui$Image$view,
								imageStore,
								{LD: 'Example check showing routing number on bottom left and account number in center bottom'},
								_List_Nil,
								4)
							]))
					]))
			]));
};
var $author$project$Components$CreatePaymentMethodModal$viewNachaDisclaimer = A2(
	$author$project$Ui$Element$view,
	_List_fromArray(
		[$author$project$Ui$Element$mb2]),
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(12)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('To initiate an ACH charge, the Operating Rules of the National Automated '),
									$elm$html$Html$text('Clearing House Associations (NACHA) require you to have your customer\'s consent '),
									$elm$html$Html$text('to debit or credit their bank account and initiate a charge over the ACH network. '),
									$elm$html$Html$text('You must be capable of producing copies of your customer\'s authorization if requested.')
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('A breach of the NACHA rules makes you potentially liable for regulatory penalties '),
											$elm$html$Html$text('and fees, as well as a reversal of any related transaction. ')
										])),
									$elm$html$Html$text('For details on the rules that the NACHA requires, '),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href('https://www.nacha.org/newrules'),
											$elm$html$Html$Attributes$target('_blank')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('visit their site.')
										])),
									$elm$html$Html$text(' See our '),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href('https://www.hint.com/terms'),
											$elm$html$Html$Attributes$target('_blank')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('terms')
										])),
									$elm$html$Html$text(' for more information.')
								]))
						]))
				]))
		]));
var $author$project$Components$CreatePaymentMethodModal$viewSelectedPaymentMethodDisclaimer = F4(
	function (showCardDisclaimer, showHintDisclaimer, practice, selectedPaymentOption) {
		var _v0 = _Utils_Tuple3(selectedPaymentOption, showCardDisclaimer, showHintDisclaimer);
		_v0$2:
		while (true) {
			if (_v0.a === 1) {
				if (_v0.b) {
					var _v1 = _v0.a;
					return _List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$inputSpanMd(12)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[$author$project$Ui$Typography$warning, $author$project$Ui$Typography$bold]),
											'Using a credit card will cost the provider an additional 2% in processing fees for your memberships. '),
											A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[$author$project$Ui$Typography$warning]),
											'Please consider using your bank account instead.')
										]))
								])),
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$inputSpanMd(12)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
									_List_fromArray(
										[
											$elm$html$Html$text('By entering your account information you authorize '),
											$elm$html$Html$text(
											$author$project$Api$Practice$name(practice)),
											$elm$html$Html$text(' to electronically debit and credit your account on a recurring basis as set forth in the contract. '),
											$elm$html$Html$text('You understand you can contact '),
											$elm$html$Html$text(
											$author$project$Api$Practice$name(practice)),
											$elm$html$Html$text(' to revoke this authorization at any time.')
										]))
								]))
						]);
				} else {
					break _v0$2;
				}
			} else {
				if (_v0.c) {
					var _v2 = _v0.a;
					return _List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$inputSpanMd(12)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
									_List_fromArray(
										[
											$elm$html$Html$text('By entering your account information you authorize this platform to electronically debit and credit your account on '),
											$elm$html$Html$text('a recurring basis as set forth in the contract. You understand you can contact us to revoke '),
											$elm$html$Html$text('this authorization at any time.')
										]))
								]))
						]);
				} else {
					break _v0$2;
				}
			}
		}
		return _List_fromArray(
			[$author$project$Utils$Html$empty]);
	});
var $author$project$Components$CreatePaymentMethodModal$RequestForPaymentInfo = {$: 14};
var $author$project$Components$CreatePaymentMethodModal$viewSendRequestToPatient = F3(
	function (patient, patientRequestInfoSentAt, timeFormatter) {
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mb2]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(4)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Send request to patient'},
									_List_fromArray(
										[
											$author$project$Ui$Button$onClick($author$project$Components$CreatePaymentMethodModal$RequestForPaymentInfo),
											$author$project$Ui$Button$primary,
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$icon($author$project$Ui$Icon$send)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Send request to patient')
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(8)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
									_List_fromArray(
										[
											$elm$html$Html$text('We will email '),
											$elm$html$Html$text(
											$author$project$Api$Provider$Patient$One$name(patient)),
											$elm$html$Html$text(' a form to update their payment method and provide this authorization.')
										]))
								]))
						])),
					function () {
					if (!patientRequestInfoSentAt.$) {
						var requestPayInfoSentAt = patientRequestInfoSentAt.a;
						return A2(
							$author$project$Ui$Grid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanMd(12)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
											_List_fromArray(
												[
													$elm$html$Html$text('Last request for payment source sent '),
													$elm$html$Html$text(
													A2(timeFormatter, 1, requestPayInfoSentAt)),
													$elm$html$Html$text('.')
												]))
										]))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]));
	});
var $author$project$Components$CreatePaymentMethodModal$viewAddCardModal = function (open) {
	var showPaymentDisclaimers = $author$project$Api$Platform$Session$One$organizationIsCompany(open.aa4);
	var showContactPatientBox = function () {
		var _v17 = open.dK;
		if (!_v17) {
			return true;
		} else {
			return false;
		}
	}();
	var paymentProcessingEnabled = function () {
		var _v16 = open.YD;
		if (_v16.$ === 1) {
			return true;
		} else {
			return $author$project$Api$Practice$hasPaymentProcessorAccount(open.ZV);
		}
	}();
	var modalTitle = 'Add Payment Method';
	var fields = $author$project$Utils$Form$fields(open.SD);
	return A2(
		$author$project$Ui$Form$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$noValidate(true),
				$author$project$Ui$Form$autocomplete(true),
				$author$project$Ui$Form$onSubmit($author$project$Components$CreatePaymentMethodModal$Save)
			]),
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Modal$view,
				$author$project$Components$CreatePaymentMethodModal$Close,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Modal$header(
						_List_fromArray(
							[
								$author$project$Ui$Modal$title(modalTitle)
							])),
						$author$project$Ui$Modal$body(
						A2(
							$elm$core$List$cons,
							function () {
								var _v0 = _Utils_Tuple3(showContactPatientBox, paymentProcessingEnabled, showPaymentDisclaimers);
								if (!_v0.b) {
									if (!_v0.c) {
										return A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$mb4]),
											_List_fromArray(
												[
													A2(
													$author$project$Utils$PaymentProcessor$toSetupAlert,
													open.ZV,
													$elm$core$Maybe$Just('In order to add payment options'))
												]));
									} else {
										return A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$mb4]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Alert$info,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Your account is not configured to allow credit cards.')
														]))
												]));
									}
								} else {
									if (_v0.a) {
										return $author$project$Utils$Html$empty;
									} else {
										return $author$project$Utils$Html$empty;
									}
								}
							}(),
							A2(
								$elm$core$List$cons,
								function () {
									var _v1 = open.YD;
									if (_v1.$ === 2) {
										var patient = _v1.a;
										return A2(
											$author$project$Ui$Element$view,
											_List_Nil,
											_List_fromArray(
												[
													A3($author$project$Components$CreatePaymentMethodModal$viewSendRequestToPatient, patient, open.CL, open.J7),
													$author$project$Ui$HorizontalRule$view(_List_Nil)
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}(),
								A2(
									$elm$core$List$cons,
									function () {
										var _v2 = _Utils_Tuple2(open.vl, showPaymentDisclaimers);
										if (_v2.a && (!_v2.b)) {
											var manualInputOptionText = 'Enter Information Here';
											var cardReaderOptionText = 'Use Card Reader';
											return A2(
												$author$project$Ui$Element$view,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$p,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Typography$strong,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('Source')
																	]))
															])),
														A2(
														$author$project$Ui$Typography$p,
														_List_fromArray(
															[$author$project$Ui$Typography$muted]),
														_List_fromArray(
															[
																$elm$html$Html$text('How would you like to add a payment method? ')
															])),
														A2(
														$author$project$Ui$Form$Group$view,
														_List_fromArray(
															[
																$author$project$Ui$Form$Group$inputSpanMd(12)
															]),
														_List_fromArray(
															[
																$author$project$Ui$Button$group(
																_List_fromArray(
																	[
																		A3($author$project$Components$CreatePaymentMethodModal$viewCardInputButton, fields.c6, 0, manualInputOptionText),
																		A3($author$project$Components$CreatePaymentMethodModal$viewCardInputButton, fields.c6, 1, cardReaderOptionText)
																	]))
															])),
														$author$project$Ui$HorizontalRule$view(_List_Nil)
													]));
										} else {
											return $author$project$Utils$Html$empty;
										}
									}(),
									_Utils_ap(
										function () {
											var _v3 = fields.c6;
											if (!_v3) {
												var loading = open.dp || function () {
													var _v9 = open.aA;
													if (_v9.$ === 2) {
														var config = _v9.a;
														return config.dp;
													} else {
														return false;
													}
												}();
												return _List_fromArray(
													[
														$author$project$Utils$Html$empty,
														A2(
														$author$project$Ui$Form$Group$view,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('stripe-card')
																	]),
																_List_fromArray(
																	[
																		loading ? A2(
																		$elm$html$Html$div,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('spinner-modal')
																			]),
																		_List_fromArray(
																			[
																				$author$project$Ui$Spinner$view(
																				_List_fromArray(
																					[$author$project$Ui$Spinner$large]))
																			])) : $elm$html$Html$text(''),
																		function () {
																		var _v4 = open.aA;
																		switch (_v4.$) {
																			case 0:
																				return $elm$html$Html$text('');
																			case 1:
																				return A2(
																					$elm$html$Html$div,
																					_List_fromArray(
																						[
																							$elm$html$Html$Attributes$id($author$project$Components$CreatePaymentMethodModal$stripeElementId)
																						]),
																					_List_Nil);
																			default:
																				var config = _v4.a;
																				var _v5 = config;
																				var sessionKey = _v5.alo;
																				var paymentMethodConfigId = _v5.ajX;
																				var allowedMethods = _v5.aeX;
																				return A2(
																					$elm$html$Html$div,
																					_List_Nil,
																					_List_fromArray(
																						[
																							A2(
																							$author$project$WebComponents$Rainforest$Payment$view,
																							{
																								ajb: A2($elm$core$Basics$composeR, $author$project$Components$CreatePaymentMethodModal$Approved, $author$project$Components$CreatePaymentMethodModal$RainforestMsg),
																								ajc: A2($elm$core$Basics$composeR, $author$project$Components$CreatePaymentMethodModal$CardBrandUpdated, $author$project$Components$CreatePaymentMethodModal$RainforestMsg),
																								ajn: $author$project$Components$CreatePaymentMethodModal$RainforestMsg(
																									$author$project$Components$CreatePaymentMethodModal$ValidityChanged(false)),
																								ajo: $author$project$Components$CreatePaymentMethodModal$RainforestMsg($author$project$Components$CreatePaymentMethodModal$Loaded),
																								ajp: A2($elm$core$Basics$composeR, $author$project$Components$CreatePaymentMethodModal$MethodUpdated, $author$project$Components$CreatePaymentMethodModal$RainforestMsg),
																								ajy: $author$project$Components$CreatePaymentMethodModal$RainforestMsg(
																									$author$project$Components$CreatePaymentMethodModal$ValidityChanged(true))
																							},
																							{aeX: allowedMethods, ajX: paymentMethodConfigId, alo: sessionKey}),
																							$author$project$Utils$FormErrors$view(
																							A2($author$project$Utils$Form$validationErrors, 2, open.SD))
																						]));
																		}
																	}(),
																		function () {
																		var showCheckHelperText = function () {
																			var _v8 = open.YD;
																			switch (_v8.$) {
																				case 2:
																					return $author$project$Api$Platform$Session$One$organizationIsAdminPractice(open.aa4);
																				case 0:
																					return $author$project$Api$Platform$Session$One$organizationIsAdminPractice(open.aa4);
																				default:
																					return false;
																			}
																		}();
																		var _v6 = _Utils_Tuple2(open.dK, showCheckHelperText);
																		if ((!_v6.a) && _v6.b) {
																			var _v7 = _v6.a;
																			return $author$project$Components$CreatePaymentMethodModal$viewCheckTooltipHelper(open.sF);
																		} else {
																			return $author$project$Utils$Html$empty;
																		}
																	}()
																	]))
															]))
													]);
											} else {
												return $elm$core$List$singleton(
													A2(
														$author$project$Ui$Form$Group$view,
														_List_Nil,
														function () {
															var _v10 = open.iE;
															if (_v10.$ === 3) {
																var cardReaders = _v10.a;
																return $elm$core$List$isEmpty(cardReaders) ? _List_fromArray(
																	[
																		A2(
																		$author$project$Ui$Alert$danger,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$elm$html$Html$text('There are no card readers available. Please '),
																				A3(
																				$author$project$Ui$Link$route,
																				$author$project$Spa$Generated$Route$Admin__CardReaders,
																				_List_Nil,
																				_List_fromArray(
																					[
																						$elm$html$Html$text('add a card reader')
																					])),
																				$elm$html$Html$text(' now.')
																			]))
																	]) : _List_fromArray(
																	[
																		A2(
																		$author$project$Ui$Form$Select$view,
																		_List_fromArray(
																			[
																				$author$project$Ui$Form$Select$value(
																				A2($elm$core$Maybe$map, $author$project$Api$Provider$CardReader$All$id, fields.aft)),
																				$author$project$Ui$Form$Select$onChange(
																				A2($elm$core$Basics$composeL, $author$project$Components$CreatePaymentMethodModal$FormUpdated, $author$project$Components$CreatePaymentMethodModal$CardReader)),
																				$author$project$Ui$Form$Select$invalid(
																				A2($author$project$Utils$Form$hasValidationErrors, 1, open.SD)),
																				$author$project$Ui$Form$Select$errors(
																				A2($author$project$Utils$Form$validationErrors, 1, open.SD))
																			]),
																		A2($author$project$Components$CreatePaymentMethodModal$cardReaderOptions, open.Ij, cardReaders)),
																		A2(
																		$author$project$Ui$Typography$p,
																		_List_fromArray(
																			[$author$project$Ui$Typography$muted]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text('Tap payments such as Apple Pay & Google Pay are not supported at this time.')
																			]))
																	]);
															} else {
																return _List_fromArray(
																	[
																		A2(
																		$author$project$Ui$Element$view,
																		_List_fromArray(
																			[$author$project$Ui$Element$textCenter]),
																		_List_fromArray(
																			[
																				$author$project$Ui$Spinner$view(_List_Nil)
																			]))
																	]);
															}
														}()));
											}
										}(),
										_Utils_ap(
											function () {
												if (showPaymentDisclaimers) {
													var _v11 = open.YD;
													if (!_v11.$) {
														return A4($author$project$Components$CreatePaymentMethodModal$viewSelectedPaymentMethodDisclaimer, showPaymentDisclaimers, true, open.ZV, open.dK);
													} else {
														return A4($author$project$Components$CreatePaymentMethodModal$viewSelectedPaymentMethodDisclaimer, false, true, open.ZV, open.dK);
													}
												} else {
													return _List_Nil;
												}
											}(),
											function () {
												var _v12 = open.YD;
												switch (_v12.$) {
													case 2:
														var nachaDisclaimerElements = function () {
															var _v13 = open.dK;
															if (!_v13) {
																return (!fields.c6) ? _List_fromArray(
																	[
																		A2(
																		$author$project$Ui$Element$view,
																		_List_fromArray(
																			[$author$project$Ui$Element$mt4, $author$project$Ui$Element$mb2]),
																		_List_fromArray(
																			[$author$project$Components$CreatePaymentMethodModal$viewNachaDisclaimer]))
																	]) : _List_fromArray(
																	[$author$project$Utils$Html$empty]);
															} else {
																return _List_fromArray(
																	[$author$project$Utils$Html$empty]);
															}
														}();
														return A2(
															$elm$core$List$cons,
															A2(
																$author$project$Ui$Element$view,
																_List_fromArray(
																	[$author$project$Ui$Element$mt4, $author$project$Ui$Element$mb2]),
																_List_fromArray(
																	[
																		A2(
																		$author$project$Ui$Form$Checkbox$view,
																		_List_fromArray(
																			[
																				$author$project$Ui$Form$Checkbox$value(fields.hC),
																				$author$project$Ui$Form$Checkbox$onCheck(
																				A2($elm$core$Basics$composeL, $author$project$Components$CreatePaymentMethodModal$FormUpdated, $author$project$Components$CreatePaymentMethodModal$SetAsDefault))
																			]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text('Set as the default payment method for this patient')
																			]))
																	])),
															nachaDisclaimerElements);
													case 0:
														return (!$author$project$Api$Platform$Session$One$organizationIsCompany(open.aa4)) ? _List_fromArray(
															[$author$project$Components$CreatePaymentMethodModal$viewNachaDisclaimer]) : (A2($author$project$Components$CreatePaymentMethodModal$isAddPaymentMethodDisabled, open.YD, open.aa4) ? _List_fromArray(
															[
																A2(
																$author$project$Ui$Element$view,
																_List_Nil,
																_List_fromArray(
																	[
																		A2(
																		$author$project$Ui$Typography$text,
																		_List_fromArray(
																			[$author$project$Ui$Typography$bold, $author$project$Ui$Typography$warning]),
																		'The practice has disabled adding payment information for this account. Contact the practice administrator for more information.')
																	]))
															]) : _List_fromArray(
															[$author$project$Utils$Html$empty]));
													default:
														var practice = _v12.a;
														return _List_fromArray(
															[
																A2(
																$author$project$Ui$Element$view,
																_List_fromArray(
																	[$author$project$Ui$Element$mt1]),
																A2(
																	$elm$core$List$cons,
																	A4(
																		$author$project$Components$Practice$PaymentCategoriesPicker$view,
																		practice,
																		$author$project$Components$CreatePaymentMethodModal$processorFromConfig(open.aA),
																		fields.Nr,
																		F2(
																			function (c, b) {
																				return $author$project$Components$CreatePaymentMethodModal$FormUpdated(
																					A2($author$project$Components$CreatePaymentMethodModal$Category, c, b));
																			})),
																	A4($author$project$Components$CreatePaymentMethodModal$viewSelectedPaymentMethodDisclaimer, false, true, practice, open.dK)))
															]);
												}
											}())))))),
						$author$project$Ui$Modal$footer(
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Cancel and close modal'},
								_List_fromArray(
									[
										$author$project$Ui$Button$onClick($author$project$Components$CreatePaymentMethodModal$Close)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Cancel')
									])),
								function () {
								var valid = function () {
									var _v14 = _Utils_Tuple2(fields.c6, open.aA);
									if ((!_v14.a) && (_v14.b.$ === 2)) {
										var _v15 = _v14.a;
										var conf = _v14.b.a;
										return conf.Ap;
									} else {
										return true;
									}
								}();
								var disabled = (!valid) || A2($author$project$Components$CreatePaymentMethodModal$isAddPaymentMethodDisabled, open.YD, open.aa4);
								return A3(
									$author$project$Ui$Button$view,
									{mm: modalTitle},
									_List_fromArray(
										[
											$author$project$Ui$Button$primary,
											$author$project$Ui$Button$submit,
											$author$project$Ui$Button$loading(
											_Utils_eq(open.k9, $author$project$Api$Data$Loading)),
											$author$project$Ui$Button$disabled(disabled)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(modalTitle)
										]));
							}()
							]))
					]))
			]));
};
var $author$project$Components$CreatePaymentMethodModal$modal = function (model) {
	if (model.$ === 1) {
		var open = model.a;
		var _v1 = open.iS;
		if (!_v1.$) {
			var connectingModal = _v1.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Components$CreatePaymentMethodModal$ConnectingModalMsg,
				$author$project$Components$CardReader$ConnectingModal$view(connectingModal));
		} else {
			return $author$project$Components$CreatePaymentMethodModal$viewAddCardModal(open);
		}
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Practice$PaymentSources$Network$modal = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Practice$PaymentSources$Network$CreatePaymentMethodModalMsg,
				$author$project$Components$CreatePaymentMethodModal$modal(model.i_))
			]));
};
var $author$project$Components$Practice$PaymentSources$Standard$modal = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Practice$PaymentSources$Standard$CreatePaymentMethodModalMsg,
				$author$project$Components$CreatePaymentMethodModal$modal(model.i_))
			]));
};
var $author$project$Api$Source$defaultNetworkBankAccountFor = F2(
	function (predicate, bankAccounts) {
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Source$BankAccount,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$BankAccount$ProviderAll,
				A2(
					$elm_community$list_extra$List$Extra$find,
					function (bankAccount) {
						return A2(
							$elm$core$Maybe$withDefault,
							false,
							A2(
								$elm$core$Maybe$map,
								predicate,
								$author$project$Api$Provider$BankAccount$All$defaults(bankAccount)));
					},
					bankAccounts)));
	});
var $author$project$Api$Source$defaultNetworkCardFor = F2(
	function (predicate, cards) {
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Source$Card,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Card$ProviderAll,
				A2(
					$elm_community$list_extra$List$Extra$find,
					function (card) {
						return A2(
							$elm$core$Maybe$withDefault,
							false,
							A2(
								$elm$core$Maybe$map,
								predicate,
								$author$project$Api$Provider$Card$All$defaults(card)));
					},
					cards)));
	});
var $author$project$Api$Source$defaultNetworkSourceFor = F3(
	function (predicate, cards, bankAccounts) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2($author$project$Api$Source$defaultNetworkCardFor, predicate, cards),
						A2($author$project$Api$Source$defaultNetworkBankAccountFor, predicate, bankAccounts)
					])));
	});
var $author$project$Api$Provider$Source$Defaults$networkForRainforest = function (_v0) {
	var record = _v0;
	return record.XB;
};
var $author$project$Api$Source$defaultNetworkForRainforestSource = F2(
	function (cards, bankAccounts) {
		return A3($author$project$Api$Source$defaultNetworkSourceFor, $author$project$Api$Provider$Source$Defaults$networkForRainforest, cards, bankAccounts);
	});
var $author$project$Api$Provider$Source$Defaults$networkForStripe = function (_v0) {
	var record = _v0;
	return record.XC;
};
var $author$project$Api$Source$defaultNetworkForStripeSource = F2(
	function (cards, bankAccounts) {
		return A3($author$project$Api$Source$defaultNetworkSourceFor, $author$project$Api$Provider$Source$Defaults$networkForStripe, cards, bankAccounts);
	});
var $author$project$Pages$Admin$PaymentSources$paymentCategories = F3(
	function (isNetwork, cards, bankAccounts) {
		return A2(
			$elm$core$List$cons,
			{
				GW: 0,
				Qc: A2($author$project$Api$Source$defaultPracticeSource, cards, bankAccounts)
			},
			isNetwork ? _List_fromArray(
				[
					{
					GW: 2,
					Qc: A2($author$project$Api$Source$defaultNetworkForRainforestSource, cards, bankAccounts)
				},
					{
					GW: 1,
					Qc: A2($author$project$Api$Source$defaultNetworkForStripeSource, cards, bankAccounts)
				}
				]) : _List_Nil);
	});
var $author$project$Components$Practice$PaymentSources$Network$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$CreatePaymentMethodModal$Practice = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Practice$PaymentSources$Network$aboutProcessorsBanner = A2(
	$author$project$Ui$Element$view,
	_List_fromArray(
		[$author$project$Ui$Element$mb4]),
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Alert$info,
			_List_fromArray(
				[
					$author$project$Ui$Alert$icon(5),
					$author$project$Ui$Alert$textLeft
				]),
			_List_fromArray(
				[
					A2($author$project$Ui$Typography$text, _List_Nil, 'Practices on your network may use either Hint Payments or Stripe as their payment processor. Since affiliates collect fees through their own processor, we recommend keeping an active payment method on both.')
				]))
		]));
var $author$project$Components$CreatePaymentMethodModal$OpenModal = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$button = function (openOptions) {
	return A3(
		$author$project$Ui$Button$view,
		{mm: 'Add payment method'},
		_List_fromArray(
			[
				$author$project$Ui$Button$onClick(
				$author$project$Components$CreatePaymentMethodModal$OpenModal(openOptions)),
				$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Add Payment Method')
			]));
};
var $author$project$Api$Employer$BankAccount$Shared$bankName = function (_v0) {
	var record = _v0;
	return record.Mw;
};
var $author$project$Api$Employer$BankAccount$One$bankName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$BankAccount$Shared$bankName(shared);
};
var $author$project$Api$Employer$BankAccount$All$bankName = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$BankAccount$One$bankName(one);
};
var $author$project$Api$Provider$BankAccount$Shared$bankName = function (_v0) {
	var record = _v0;
	return record.Mw;
};
var $author$project$Api$Provider$BankAccount$One$bankName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BankAccount$Shared$bankName(shared);
};
var $author$project$Api$Provider$BankAccount$All$bankName = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BankAccount$One$bankName(one);
};
var $author$project$Api$BankAccount$bankName = function (bankAccount) {
	switch (bankAccount.$) {
		case 0:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$One$bankName(bankAccount_);
		case 1:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$All$bankName(bankAccount_);
		case 2:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$One$bankName(bankAccount_);
		default:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$All$bankName(bankAccount_);
	}
};
var $author$project$Api$Employer$Card$Shared$cardType = function (_v0) {
	var record = _v0;
	return record.No;
};
var $author$project$Api$Employer$Card$One$cardType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Card$Shared$cardType(shared);
};
var $author$project$Api$Employer$Card$All$cardType = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$Card$One$cardType(one);
};
var $author$project$Api$Provider$Card$Shared$cardType = function (_v0) {
	var record = _v0;
	return record.No;
};
var $author$project$Api$Provider$Card$One$cardType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Card$Shared$cardType(shared);
};
var $author$project$Api$Provider$Card$All$cardType = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Card$One$cardType(one);
};
var $author$project$Api$Card$cardType = function (card) {
	switch (card.$) {
		case 0:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$One$cardType(card_);
		case 1:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$All$cardType(card_);
		case 2:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$One$cardType(card_);
		default:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$All$cardType(card_);
	}
};
var $author$project$Api$Source$detail = function (source) {
	var _v0 = function () {
		switch (source.$) {
			case 1:
				var bankAccount = source.a;
				return _Utils_Tuple2(
					A2(
						$elm$core$Maybe$withDefault,
						'',
						$author$project$Api$BankAccount$bankName(bankAccount)),
					A2(
						$elm$core$Maybe$withDefault,
						'',
						$author$project$Api$Source$lastFour(source)));
			case 0:
				var card = source.a;
				return _Utils_Tuple2(
					A2(
						$elm$core$Maybe$withDefault,
						'',
						$author$project$Api$Card$cardType(card)),
					A2(
						$elm$core$Maybe$withDefault,
						'',
						$author$project$Api$Source$lastFour(source)));
			default:
				var source_ = source.a;
				return _Utils_Tuple2(
					A2(
						$elm$core$Maybe$withDefault,
						'external',
						$author$project$Api$Common$Source$Shared$type_(source_)),
					A2(
						$elm$core$Maybe$withDefault,
						'',
						$author$project$Api$Source$lastFour(source)));
		}
	}();
	var prefix = _v0.a;
	var lastFour_ = _v0.b;
	return prefix + (' *' + lastFour_);
};
var $author$project$Api$Source$noun = function (source) {
	switch (source.$) {
		case 1:
			return 'bank account';
		case 0:
			return 'card';
		default:
			var source_ = source.a;
			return A2(
				$elm$core$Maybe$withDefault,
				'external',
				$author$project$Api$Common$Source$Shared$type_(source_));
	}
};
var $author$project$Components$Practice$PaymentSources$Network$partitionByProcessor = function (sources) {
	var empty = {t8: _List_Nil, uQ: _List_Nil};
	return A3(
		$elm$core$List$foldr,
		F2(
			function (source, acc) {
				var _v0 = $author$project$Api$Source$paymentProcessor(source);
				if ((!_v0.$) && (_v0.a === 'stripe')) {
					return _Utils_update(
						acc,
						{
							uQ: A2($elm$core$List$cons, source, acc.uQ)
						});
				} else {
					return _Utils_update(
						acc,
						{
							t8: A2($elm$core$List$cons, source, acc.t8)
						});
				}
			}),
		empty,
		sources);
};
var $author$project$Api$Provider$Practice$One$stripeCustomerLink = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.acn;
	});
var $author$project$Components$Practice$PaymentSources$Network$Delete = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Practice$PaymentSources$Network$canDeleteSource = F2(
	function (source, defaults) {
		var sourceId = $author$project$Api$Source$id(source);
		var matchesDefault = function (_default) {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function (d) {
						return _Utils_eq(
							$author$project$Api$Source$id(d),
							sourceId);
					},
					_default));
		};
		return !A2($elm$core$List$any, matchesDefault, defaults);
	});
var $author$project$Components$Practice$PaymentSources$Network$viewSourceRow = F3(
	function (model, opts, source) {
		return A2(
			$author$project$Ui$ListGroup$item,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(9)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Components$PaymentSourceDisplayer$view,
									model.J7,
									_List_fromArray(
										[
											$author$project$Components$PaymentSourceDisplayer$source(
											$elm$core$Maybe$Just(source)),
											$author$project$Components$PaymentSourceDisplayer$showProcessor(model.Ij)
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(3)
								]),
							_List_fromArray(
								[
									function () {
									if (opts.xP && A2($author$project$Components$Practice$PaymentSources$Network$canDeleteSource, source, opts.y9)) {
										var loading = A2(
											$elm$core$Set$member,
											$author$project$Api$Source$id(source),
											model.el);
										return A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$textRight]),
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Button$view,
													{mm: 'Delete payment method'},
													_List_fromArray(
														[
															$author$project$Ui$Button$link,
															$author$project$Ui$Button$loading(loading),
															$author$project$Ui$Button$onClick(
															$author$project$Components$Practice$PaymentSources$Network$Delete(source))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Delete')
														]))
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								]))
						]))
				]));
	});
var $author$project$Components$Practice$PaymentSources$Network$viewProcessorCard = F2(
	function (model, opts) {
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$flex, $author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mb3]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$bold]),
									opts.aih),
									opts.zS
								])),
							opts.yX
						])),
					A2(
					$author$project$Ui$ListGroup$view,
					_List_Nil,
					$elm$core$List$isEmpty(opts.abP) ? _List_fromArray(
						[
							A2(
							$author$project$Ui$ListGroup$item,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textCenter]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[$author$project$Ui$Typography$muted]),
											'No payment methods yet — add one above.')
										]))
								]))
						]) : A2(
						$elm$core$List$map,
						A2($author$project$Components$Practice$PaymentSources$Network$viewSourceRow, model, opts),
						opts.abP))
				]));
	});
var $author$project$Components$Practice$PaymentSources$Network$view = F2(
	function (model, canManageSources) {
		var loading = !($author$project$Api$Data$isSuccess(model.rC) && $author$project$Api$Data$isSuccess(model.rs));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					function () {
					var _v0 = model.gc;
					if (!_v0.$) {
						var source = _v0.a;
						return A2(
							$author$project$Components$HiConfirm$modal,
							$author$project$Components$Practice$PaymentSources$Network$HiConfirmClosed(source),
							_List_fromArray(
								[
									$author$project$Components$HiConfirm$verb('delete'),
									$author$project$Components$HiConfirm$noun(
									$author$project$Api$Source$noun(source)),
									$author$project$Components$HiConfirm$detail(
									$author$project$Api$Source$detail(source))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					A2(
					$author$project$Ui$Panel$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Panel$body,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$mb3]),
									_List_fromArray(
										[
											$author$project$Ui$Typography$headingSm(
											_List_fromArray(
												[
													$elm$html$Html$text('Payment processors')
												]))
										])),
									$author$project$Components$Practice$PaymentSources$Network$aboutProcessorsBanner,
									function () {
									if (loading) {
										return A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$textCenter]),
											_List_fromArray(
												[
													$author$project$Ui$Spinner$view(_List_Nil)
												]));
									} else {
										var stripeCustomerLink = model.Ij ? A2(
											$elm$core$Maybe$withDefault,
											$author$project$Utils$Html$empty,
											A2(
												$elm$core$Maybe$map,
												function (href) {
													return A3(
														$author$project$Ui$HinterOnly$linkHref,
														href,
														_List_fromArray(
															[$author$project$Ui$Link$targetBlank]),
														_List_fromArray(
															[
																$elm$html$Html$text('View on Stripe')
															]));
												},
												$author$project$Api$Provider$Practice$One$stripeCustomerLink(model.ZV))) : $author$project$Utils$Html$empty;
										var openOptionsFor = function (processor) {
											return {
												xx: $author$project$Api$Data$providerPath,
												sF: model.sF,
												jY: $elm$core$Maybe$Just(processor),
												Ij: model.Ij,
												YD: $author$project$Components$CreatePaymentMethodModal$Practice(
													$author$project$Api$Practice$Provider(model.ZV)),
												ZV: $author$project$Api$Practice$Provider(model.ZV),
												t9: model.t9,
												aa4: model.aa4,
												J7: model.J7,
												vl: false
											};
										};
										var createPaymentMethodButtonFor = function (processor) {
											return A2(
												$elm$html$Html$map,
												$author$project$Components$Practice$PaymentSources$Network$CreatePaymentMethodModalMsg,
												$author$project$Components$CreatePaymentMethodModal$button(
													openOptionsFor(processor)));
										};
										var _v1 = function () {
											var _v2 = _Utils_Tuple2(model.rC, model.rs);
											if ((_v2.a.$ === 3) && (_v2.b.$ === 3)) {
												var _v3 = _v2.a;
												var cards_ = _v3.a;
												var _v4 = _v2.b;
												var bankAccounts_ = _v4.a;
												return _Utils_Tuple2(cards_, bankAccounts_);
											} else {
												return _Utils_Tuple2(_List_Nil, _List_Nil);
											}
										}();
										var cards = _v1.a;
										var bankAccounts = _v1.b;
										var defaultSources = _List_fromArray(
											[
												A2($author$project$Api$Source$defaultPracticeSource, cards, bankAccounts),
												A2($author$project$Api$Source$defaultNetworkForStripeSource, cards, bankAccounts),
												A2($author$project$Api$Source$defaultNetworkForRainforestSource, cards, bankAccounts)
											]);
										var sources = $elm$core$List$reverse(
											A2(
												$elm$core$List$sortBy,
												A2(
													$elm$core$Basics$composeR,
													$author$project$Api$Source$createdAt,
													A2(
														$elm$core$Basics$composeR,
														$elm$core$Maybe$map($elm$time$Time$posixToMillis),
														$elm$core$Maybe$withDefault(0))),
												_Utils_ap(
													A2(
														$elm$core$List$map,
														A2($elm$core$Basics$composeL, $author$project$Api$Source$Card, $author$project$Api$Card$ProviderAll),
														cards),
													A2(
														$elm$core$List$map,
														A2($elm$core$Basics$composeL, $author$project$Api$Source$BankAccount, $author$project$Api$BankAccount$ProviderAll),
														bankAccounts))));
										var partitioned = $author$project$Components$Practice$PaymentSources$Network$partitionByProcessor(sources);
										return A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$mt3]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Grid$row,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Grid$column,
															_List_fromArray(
																[
																	$author$project$Ui$Grid$spanMd(6)
																]),
															_List_fromArray(
																[
																	A2(
																	$author$project$Components$Practice$PaymentSources$Network$viewProcessorCard,
																	model,
																	{
																		xP: canManageSources,
																		yX: createPaymentMethodButtonFor('rainforest'),
																		y9: defaultSources,
																		zS: $author$project$Utils$Html$empty,
																		aih: 'Hint Payments',
																		abP: partitioned.t8
																	})
																])),
															A2(
															$author$project$Ui$Grid$column,
															_List_fromArray(
																[
																	$author$project$Ui$Grid$spanMd(6)
																]),
															_List_fromArray(
																[
																	A2(
																	$author$project$Components$Practice$PaymentSources$Network$viewProcessorCard,
																	model,
																	{
																		xP: canManageSources,
																		yX: createPaymentMethodButtonFor('stripe'),
																		y9: defaultSources,
																		zS: stripeCustomerLink,
																		aih: 'Stripe',
																		abP: partitioned.uQ
																	})
																]))
														]))
												]));
									}
								}()
								]))
						]))
				]));
	});
var $author$project$Components$Practice$PaymentSources$Standard$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Practice$PaymentSources$Standard$Delete = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Practice$PaymentSources$Standard$SetAsDefault = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Practice$PaymentSources$Standard$viewSourceRow = F4(
	function (model, canManageSources, defaultPracticeSource, source) {
		var sourceId = $author$project$Api$Source$id(source);
		var isDefault = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (d) {
					return _Utils_eq(
						$author$project$Api$Source$id(d),
						$author$project$Api$Source$id(source));
				},
				defaultPracticeSource));
		return A2(
			$author$project$Ui$ListGroup$item,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(8)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
									_List_fromArray(
										[
											A2(
											$author$project$Components$PaymentSourceDisplayer$view,
											model.J7,
											_List_fromArray(
												[
													$author$project$Components$PaymentSourceDisplayer$source(
													$elm$core$Maybe$Just(source)),
													$author$project$Components$PaymentSourceDisplayer$showProcessor(model.Ij)
												])),
											isDefault ? A2(
											$author$project$Ui$Badge$fromString,
											_List_fromArray(
												[$author$project$Ui$Badge$info]),
											'DEFAULT') : $author$project$Utils$Html$empty
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(4)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap4, $author$project$Ui$Element$justifyRight]),
									_List_fromArray(
										[
											function () {
											if (canManageSources && (!isDefault)) {
												var settingThis = _Utils_eq(
													model.pZ,
													$elm$core$Maybe$Just(sourceId));
												return A3(
													$author$project$Ui$Button$view,
													{mm: 'Set as default payment method'},
													_List_fromArray(
														[
															$author$project$Ui$Button$link,
															$author$project$Ui$Button$loading(settingThis),
															$author$project$Ui$Button$onClick(
															$author$project$Components$Practice$PaymentSources$Standard$SetAsDefault(source))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Set as default')
														]));
											} else {
												return $author$project$Utils$Html$empty;
											}
										}(),
											function () {
											if (canManageSources && (!isDefault)) {
												var deleting = A2($elm$core$Set$member, sourceId, model.el);
												return A3(
													$author$project$Ui$Button$view,
													{mm: 'Delete payment method'},
													_List_fromArray(
														[
															$author$project$Ui$Button$link,
															$author$project$Ui$Button$loading(deleting),
															$author$project$Ui$Button$onClick(
															$author$project$Components$Practice$PaymentSources$Standard$Delete(source))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Delete')
														]));
											} else {
												return $author$project$Utils$Html$empty;
											}
										}()
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Practice$PaymentSources$Standard$view = F2(
	function (model, canManageSources) {
		var openOptions = {
			xx: $author$project$Api$Data$providerPath,
			sF: model.sF,
			jY: $elm$core$Maybe$Nothing,
			Ij: model.Ij,
			YD: $author$project$Components$CreatePaymentMethodModal$Practice(
				$author$project$Api$Practice$Provider(model.ZV)),
			ZV: $author$project$Api$Practice$Provider(model.ZV),
			t9: model.t9,
			aa4: model.aa4,
			J7: model.J7,
			vl: false
		};
		var loading = !($author$project$Api$Data$isSuccess(model.rC) && $author$project$Api$Data$isSuccess(model.rs));
		var _v0 = function () {
			var _v1 = _Utils_Tuple2(model.rC, model.rs);
			if ((_v1.a.$ === 3) && (_v1.b.$ === 3)) {
				var _v2 = _v1.a;
				var cards_ = _v2.a;
				var _v3 = _v1.b;
				var bankAccounts_ = _v3.a;
				return _Utils_Tuple2(cards_, bankAccounts_);
			} else {
				return _Utils_Tuple2(_List_Nil, _List_Nil);
			}
		}();
		var cards = _v0.a;
		var bankAccounts = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					function () {
					var _v4 = model.gc;
					if (!_v4.$) {
						var source = _v4.a;
						return A2(
							$author$project$Components$HiConfirm$modal,
							$author$project$Components$Practice$PaymentSources$Standard$HiConfirmClosed(source),
							_List_fromArray(
								[
									$author$project$Components$HiConfirm$verb('delete'),
									$author$project$Components$HiConfirm$noun(
									$author$project$Api$Source$noun(source)),
									$author$project$Components$HiConfirm$detail(
									$author$project$Api$Source$detail(source))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					A2(
					$author$project$Ui$Panel$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Panel$body,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$flex, $author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mb3]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_Nil,
											_List_fromArray(
												[
													$author$project$Ui$Typography$headingSm(
													_List_fromArray(
														[
															$elm$html$Html$text('Hint & Marketplace Partners')
														])),
													A2(
													$author$project$Ui$Typography$text,
													_List_fromArray(
														[$author$project$Ui$Typography$muted]),
													'Payment methods used for Hint billing and marketplace partner charges.')
												])),
											A2(
											$elm$html$Html$map,
											$author$project$Components$Practice$PaymentSources$Standard$CreatePaymentMethodModalMsg,
											$author$project$Components$CreatePaymentMethodModal$button(openOptions))
										])),
									model.Ij ? A2(
									$elm$core$Maybe$withDefault,
									$author$project$Utils$Html$empty,
									A2(
										$elm$core$Maybe$map,
										function (href) {
											return A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$mb3]),
												_List_fromArray(
													[
														A3(
														$author$project$Ui$HinterOnly$linkHref,
														href,
														_List_fromArray(
															[$author$project$Ui$Link$targetBlank]),
														_List_fromArray(
															[
																$elm$html$Html$text('View on Stripe')
															]))
													]));
										},
										$author$project$Api$Provider$Practice$One$stripeCustomerLink(model.ZV))) : $author$project$Utils$Html$empty,
									function () {
									if (loading) {
										return A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$textCenter]),
											_List_fromArray(
												[
													$author$project$Ui$Spinner$view(_List_Nil)
												]));
									} else {
										var sources = $elm$core$List$reverse(
											A2(
												$elm$core$List$sortBy,
												A2(
													$elm$core$Basics$composeR,
													$author$project$Api$Source$createdAt,
													A2(
														$elm$core$Basics$composeR,
														$elm$core$Maybe$map($elm$time$Time$posixToMillis),
														$elm$core$Maybe$withDefault(0))),
												_Utils_ap(
													A2(
														$elm$core$List$map,
														A2($elm$core$Basics$composeL, $author$project$Api$Source$Card, $author$project$Api$Card$ProviderAll),
														cards),
													A2(
														$elm$core$List$map,
														A2($elm$core$Basics$composeL, $author$project$Api$Source$BankAccount, $author$project$Api$BankAccount$ProviderAll),
														bankAccounts))));
										return A2(
											$author$project$Ui$ListGroup$view,
											_List_Nil,
											function () {
												if ($elm$core$List$isEmpty(sources)) {
													return _List_fromArray(
														[
															A2(
															$author$project$Ui$ListGroup$item,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	$author$project$Ui$Element$view,
																	_List_fromArray(
																		[$author$project$Ui$Element$textCenter]),
																	_List_fromArray(
																		[
																			A2(
																			$author$project$Ui$Typography$text,
																			_List_fromArray(
																				[$author$project$Ui$Typography$muted]),
																			'No payment methods yet — add one above.')
																		]))
																]))
														]);
												} else {
													var defaultPracticeSource = A2($author$project$Api$Source$defaultPracticeSource, cards, bankAccounts);
													return A2(
														$elm$core$List$map,
														A3($author$project$Components$Practice$PaymentSources$Standard$viewSourceRow, model, canManageSources, defaultPracticeSource),
														sources);
												}
											}());
									}
								}()
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$PaymentSources$Edit = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Api$Provider$Source$Defaults$categorySubtitle = function (category) {
	switch (category) {
		case 0:
			return 'Payments to Hint and marketplace partners';
		case 1:
			return 'Affiliate payouts processed through Stripe';
		default:
			return 'Affiliate payouts processed through Hint Payments';
	}
};
var $author$project$Pages$Admin$PaymentSources$viewPaymentCategory = F4(
	function (timeFormatter, showProcessor, sources, paymentCategory) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$bold]),
									$author$project$Api$Provider$Source$Defaults$categoryLabel(paymentCategory.GW)),
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[$author$project$Ui$Typography$muted]),
											$author$project$Api$Provider$Source$Defaults$categorySubtitle(paymentCategory.GW))
										]))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = paymentCategory.Qc;
							if (!_v0.$) {
								return A2(
									$author$project$Components$PaymentSourceDisplayer$view,
									timeFormatter,
									_List_fromArray(
										[
											$author$project$Components$PaymentSourceDisplayer$source(paymentCategory.Qc),
											$author$project$Components$PaymentSourceDisplayer$limitedView(true),
											$author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus(true),
											$author$project$Components$PaymentSourceDisplayer$showProcessor(showProcessor)
										]));
							} else {
								return A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$muted]),
									'No source selected');
							}
						}()
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$core$List$isEmpty(sources) ? $author$project$Utils$Html$empty : A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flex, $author$project$Ui$Element$justifyRight]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Edit payment method'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick(
											A2($author$project$Pages$Admin$PaymentSources$Edit, sources, paymentCategory))
										]),
									_List_fromArray(
										[
											function () {
											var _v1 = paymentCategory.Qc;
											if (!_v1.$) {
												return $elm$html$Html$text('Edit payment method');
											} else {
												return $elm$html$Html$text('Add payment method');
											}
										}()
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$PaymentSources$FormUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Admin$PaymentSources$Source = $elm$core$Basics$identity;
var $author$project$Pages$Admin$PaymentSources$Update = {$: 5};
var $author$project$Pages$Admin$PaymentSources$requiredProcessor = function (category) {
	switch (category) {
		case 1:
			return 'stripe';
		case 2:
			return 'rainforest';
		default:
			return 'rainforest';
	}
};
var $author$project$Pages$Admin$PaymentSources$filterSourcesForCategory = F2(
	function (category, sources) {
		return A2(
			$elm$core$List$filter,
			function (s) {
				return _Utils_eq(
					$author$project$Api$Source$paymentProcessor(s),
					$elm$core$Maybe$Just(
						$author$project$Pages$Admin$PaymentSources$requiredProcessor(category)));
			},
			sources);
	});
var $author$project$Pages$Admin$PaymentSources$sourceName = function (source_) {
	var _v0 = $author$project$Api$Source$name(source_);
	if (!_v0.$) {
		var label = _v0.a;
		return $elm$core$Maybe$Just(label);
	} else {
		return $author$project$Api$Source$type_(source_);
	}
};
var $author$project$Pages$Admin$PaymentSources$sourceLabel = F2(
	function (showProcessor, source) {
		return A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A3($author$project$Utils$PaymentProcessor$toLabel, showProcessor, source, $author$project$Api$Source$paymentProcessor),
						A2(
						$elm$core$Maybe$map,
						$author$project$Formatters$String$titleize,
						$author$project$Pages$Admin$PaymentSources$sourceName(source)),
						A2(
						$elm$core$Maybe$map,
						function (lastFour) {
							return ' * ' + lastFour;
						},
						$author$project$Api$Source$lastFour(source))
					])));
	});
var $author$project$Pages$Admin$PaymentSources$sourceOptions = F2(
	function (showProcessor, sources) {
		return A2(
			$elm$core$List$cons,
			A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(''),
				'Choose a source...'),
			A2(
				$elm$core$List$map,
				function (source) {
					return A3(
						$author$project$Ui$Form$Select$option,
						_List_Nil,
						$elm$core$Maybe$Just(
							$author$project$Api$Source$id(source)),
						A2($author$project$Pages$Admin$PaymentSources$sourceLabel, showProcessor, source));
				},
				sources));
	});
var $author$project$Pages$Admin$PaymentSources$viewPaymentCategoryModal = F4(
	function (showProcessor, sources, form, updateRequest) {
		var modalConfig = {
			Tq: $elm$core$Maybe$Nothing,
			aih: 'Payment Method',
			V8: _Utils_eq(updateRequest, $author$project$Api$Data$Loading),
			WG: $elm$core$Maybe$Just(''),
			WH: $elm$core$Maybe$Nothing,
			Yd: $author$project$Pages$Admin$PaymentSources$CancelEdit,
			Yf: $elm$core$Basics$always($author$project$Pages$Admin$PaymentSources$Update)
		};
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Category')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$Source$Defaults$categoryLabel(fields.GW))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Payment Method'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(
									A2($elm$core$Maybe$map, $author$project$Api$Source$id, fields.JQ)),
									$author$project$Ui$Form$Select$onChange(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$PaymentSources$FormUpdated, $elm$core$Basics$identity)),
									$author$project$Ui$Form$Select$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
									$author$project$Ui$Form$Select$errors(
									A2($author$project$Utils$Form$validationErrors, 0, form))
								]),
							A2(
								$author$project$Pages$Admin$PaymentSources$sourceOptions,
								showProcessor,
								A2($author$project$Pages$Admin$PaymentSources$filterSourcesForCategory, fields.GW, sources)))
						]))
				]));
	});
var $author$project$Pages$Admin$PaymentSources$view = function (model) {
	var practicePanel = function () {
		var _v7 = model.bK;
		if (!_v7.$) {
			var m = _v7.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Pages$Admin$PaymentSources$StandardPaymentsMsg,
				A2($author$project$Components$Practice$PaymentSources$Standard$view, m, true));
		} else {
			var m = _v7.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Pages$Admin$PaymentSources$NetworkPaymentsMsg,
				A2($author$project$Components$Practice$PaymentSources$Network$view, m, true));
		}
	}();
	var modalNode = function () {
		var _v6 = model.bK;
		if (!_v6.$) {
			var m = _v6.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Pages$Admin$PaymentSources$StandardPaymentsMsg,
				$author$project$Components$Practice$PaymentSources$Standard$modal(m));
		} else {
			var m = _v6.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Pages$Admin$PaymentSources$NetworkPaymentsMsg,
				$author$project$Components$Practice$PaymentSources$Network$modal(m));
		}
	}();
	var _v0 = function () {
		var _v1 = _Utils_Tuple2(model.rC, model.rs);
		if ((_v1.a.$ === 3) && (_v1.b.$ === 3)) {
			var _v2 = _v1.a;
			var cards = _v2.a;
			var _v3 = _v1.b;
			var bankAccounts = _v3.a;
			return _Utils_Tuple3(
				false,
				$elm$core$List$reverse(
					A2(
						$elm$core$List$sortBy,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Api$Source$createdAt,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Maybe$map($elm$time$Time$posixToMillis),
								$elm$core$Maybe$withDefault(0))),
						_Utils_ap(
							A2(
								$elm$core$List$map,
								A2($elm$core$Basics$composeL, $author$project$Api$Source$Card, $author$project$Api$Card$ProviderAll),
								cards),
							A2(
								$elm$core$List$map,
								A2($elm$core$Basics$composeL, $author$project$Api$Source$BankAccount, $author$project$Api$BankAccount$ProviderAll),
								bankAccounts)))),
				A3($author$project$Pages$Admin$PaymentSources$paymentCategories, model.U_, cards, bankAccounts));
		} else {
			return _Utils_Tuple3(true, _List_Nil, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var sources = _v0.b;
	var paymentCategories_ = _v0.c;
	return {
		fO: _List_fromArray(
			[
				modalNode,
				function () {
				var _v4 = model.bd;
				if (!_v4.$) {
					var _v5 = _v4.a;
					var sources_ = _v5.a;
					var form = _v5.b;
					var updateRequest = _v5.c;
					return A4($author$project$Pages$Admin$PaymentSources$viewPaymentCategoryModal, model.Ij, sources_, form, updateRequest);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				model.U_ ? A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$mb3]),
								_List_fromArray(
									[
										$author$project$Ui$Typography$headingSm(
										_List_fromArray(
											[
												$elm$html$Html$text('Payment categories')
											]))
									])),
								A4(
								$author$project$Ui$Table$view,
								_List_fromArray(
									[
										$author$project$Ui$Table$loading(loading)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Table$header,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Category')
											])),
										A2(
										$author$project$Ui$Table$header,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Payment method')
											])),
										A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
									]),
								A2(
									$elm$core$List$map,
									A3($author$project$Pages$Admin$PaymentSources$viewPaymentCategory, model.J7, model.Ij, sources),
									paymentCategories_),
								_List_Nil)
							]))
					])) : $author$project$Utils$Html$empty,
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mt4]),
				_List_fromArray(
					[practicePanel]))
			]),
		ac9: 'Admin | Payment Methods'
	};
};
var $author$project$Pages$Admin$PaymentSources$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$PaymentSources$init, aiq: $author$project$Pages$Admin$PaymentSources$load, k8: $author$project$Pages$Admin$PaymentSources$save, alO: $author$project$Pages$Admin$PaymentSources$subscriptions, adT: $author$project$Pages$Admin$PaymentSources$update, amo: $author$project$Pages$Admin$PaymentSources$view});
var $author$project$Pages$Admin$Plans$Id_String$init = F4(
	function (session, practice, _v0, _v1) {
		var apiClient = _v0.Gv;
		var timeZone = _v0.J8;
		var currentDate = _v0.dd;
		var hinterViewOff = _v0.ahK;
		var query = _v1.DE;
		var params = _v1.YL;
		return A2(
			$elm$core$Tuple$mapFirst,
			function (planForm) {
				return {Gv: apiClient, pd: planForm};
			},
			A9(
				$author$project$Components$Plan$Form$init,
				apiClient,
				timeZone,
				currentDate,
				session,
				practice,
				query,
				$author$project$Spa$Generated$Route$Admin__Plans__Top,
				params.ahP,
				{ahK: hinterViewOff, ZX: false}));
	});
var $author$project$Pages$Admin$Plans$Id_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Plans$Id_String$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Plans$Id_String$subscriptions = function (model) {
	return $author$project$Components$Plan$Form$subscriptions(model.pd);
};
var $author$project$Pages$Admin$Plans$Id_String$update = F2(
	function (msg, model) {
		return A2(
			$author$project$Utils$Tuple3$mapFirst,
			function (planForm) {
				return _Utils_update(
					model,
					{pd: planForm});
			},
			A3($author$project$Components$Plan$Form$update, model.Gv, msg, model.pd));
	});
var $author$project$Pages$Admin$Plans$Id_String$view = function (model) {
	return {
		fO: $author$project$Components$Plan$Form$view(model.pd),
		ac9: 'Admin | Membership Plans'
	};
};
var $author$project$Pages$Admin$Plans$Id_String$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Plans$Id_String$init, aiq: $author$project$Pages$Admin$Plans$Id_String$load, k8: $author$project$Pages$Admin$Plans$Id_String$save, alO: $author$project$Pages$Admin$Plans$Id_String$subscriptions, adT: $author$project$Pages$Admin$Plans$Id_String$update, amo: $author$project$Pages$Admin$Plans$Id_String$view});
var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$New$FormMsg = $elm$core$Basics$identity;
var $author$project$Components$PricingVersions$Form$EffectiveDateInputMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$PricingVersions$Form$GotCurrentDate = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$PricingVersions$Form$Model = $elm$core$Basics$identity;
var $author$project$Components$PricingVersions$Form$GotUpcomingPricingVersion = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$PricingVersion$One$PricingVersion = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$PricingVersion$One$Record = function (plan) {
	return {Jb: plan};
};
var $author$project$Api$Provider$PricingVersion$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'plan',
	$author$project$Api$Provider$Plan$One$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$PricingVersion$One$Record));
var $author$project$Api$Provider$PricingVersion$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PricingVersion$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$PricingVersion$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$PricingVersion$One$PricingVersion)));
var $author$project$Api$Provider$PricingVersion$pricingVersionsPath = function (planId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['plans', planId, 'pricing_versions']),
		$author$project$Api$Data$providerPath);
};
var $author$project$Api$Provider$PricingVersion$new = F3(
	function (apiClient, planId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$PricingVersion$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['new']),
					$author$project$Api$Provider$PricingVersion$pricingVersionsPath(planId))));
	});
var $author$project$Api$Provider$PricingVersion$retrieve = F4(
	function (apiClient, planId, pricingVersionId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$PricingVersion$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						[pricingVersionId]),
					$author$project$Api$Provider$PricingVersion$pricingVersionsPath(planId))));
	});
var $author$project$Components$PricingVersions$Form$fetchPricingVersion = F3(
	function (apiClient, planId, pricingVersionId) {
		if (!pricingVersionId.$) {
			var pricingVersionId_ = pricingVersionId.a;
			return A4($author$project$Api$Provider$PricingVersion$retrieve, apiClient, planId, pricingVersionId_, $author$project$Components$PricingVersions$Form$GotUpcomingPricingVersion);
		} else {
			return A3($author$project$Api$Provider$PricingVersion$new, apiClient, planId, $author$project$Components$PricingVersions$Form$GotUpcomingPricingVersion);
		}
	});
var $author$project$Components$PricingVersions$Form$init = F4(
	function (apiClient, settings, _v0, pricingVersionId) {
		var _v1 = $author$project$Components$DateInput$init;
		var effectiveDateInput = _v1.a;
		var effectiveDateCmd = _v1.b;
		return _Utils_Tuple2(
			{
				l: $author$project$Api$Data$Loading,
				My: settings.My,
				dd: $elm$core$Maybe$Nothing,
				jC: effectiveDateInput,
				SD: $elm$core$Maybe$Nothing,
				Io: $author$project$Api$Data$NotAsked,
				Is: settings.Is,
				ZV: settings.ZV,
				akd: _Utils_Tuple2(0, $author$project$Api$Data$NotAsked),
				eW: $jinjor$elm_debounce$Debounce$init,
				pl: $author$project$Api$Data$Loading,
				akh: pricingVersionId,
				aa4: settings.aa4,
				hI: false
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3($author$project$Components$PricingVersions$Form$fetchPricingVersion, apiClient, settings.My, pricingVersionId),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$PricingVersions$Form$EffectiveDateInputMsg, effectiveDateCmd),
						A2($elm$core$Task$perform, $author$project$Components$PricingVersions$Form$GotCurrentDate, $justinmimbs$date$Date$today)
					])));
	});
var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$New$init = F4(
	function (session, practice, shared, _v0) {
		var params = _v0.YL;
		var settings = {My: params.ahP, Is: $author$project$Spa$Generated$Route$Admin__Plans__Top, ZV: practice, aa4: session};
		var _v1 = A4($author$project$Components$PricingVersions$Form$init, shared.Gv, settings, params.ahP, $elm$core$Maybe$Nothing);
		var form = _v1.a;
		var cmd = _v1.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, SD: form, ZV: practice, aa4: session, lk: shared},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
	});
var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$New$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{lk: shared}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$New$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$PricingVersions$Form$BasicPlanFormUpdated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$PricingVersions$Form$subscriptions = function (_v0) {
	var model = _v0;
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Platform$Sub$none,
		A2(
			$elm$core$Maybe$map,
			function (form) {
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Components$PricingVersions$Form$BasicPlanFormUpdated,
					$author$project$Components$Plan$BasicForm$subscriptions(form.ab));
			},
			model.SD));
};
var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$New$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$PricingVersions$Form$subscriptions(model.SD));
};
var $author$project$Components$PricingVersions$Form$FamilyMembershipPricingFieldsUpdated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$PricingVersions$Form$GotPreview = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Components$PricingVersions$Form$GroupTierPricingFieldsUpdated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$PricingVersions$Form$IndividualMembershipPricingFieldsUpdated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$PricingVersions$Form$PricingVersionCreated = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$PricingVersions$Form$PricingVersionUpdated = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$PricingVersions$Form$SpecialRatesFieldsUpdated = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$PricingVersions$Form$ToggleFixedMembershipPricing = {$: 10};
var $author$project$Api$Provider$PricingVersion$encodeFields = function (fields) {
	var planFields = fields.ZD;
	var baseFields = _List_fromArray(
		[
			_Utils_Tuple2(
			'name',
			$elm$json$Json$Encode$string(fields.Bq)),
			_Utils_Tuple2(
			'effective_date',
			$elm$json$Json$Encode$string(fields.Q7)),
			_Utils_Tuple2(
			'registration_fee_name',
			$elm$json$Json$Encode$string(fields.DN)),
			_Utils_Tuple2(
			'registration_fee_description',
			$elm$json$Json$Encode$string(fields.DM)),
			_Utils_Tuple2(
			'registration_fee_category',
			A2(
				$author$project$Utils$Encode$nullable,
				function (id) {
					return $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'id',
								$elm$json$Json$Encode$string(id))
							]));
				},
				fields.DL)),
			_Utils_Tuple2(
			'discounts_enabled',
			$elm$json$Json$Encode$bool(fields.zi)),
			_Utils_Tuple2(
			'group_pricing_type',
			$elm$json$Json$Encode$string(fields.S1)),
			_Utils_Tuple2(
			'split_revenue_type',
			$elm$json$Json$Encode$string(planFields.abW)),
			_Utils_Tuple2(
			'applies_group_discount_in_tiers',
			$elm$json$Json$Encode$bool(fields.LW)),
			_Utils_Tuple2(
			'single_parent_with_single_child_rate_rule_enabled',
			$elm$json$Json$Encode$bool(planFields.abF)),
			_Utils_Tuple2(
			'family_with_single_child_rate_rule_enabled',
			$elm$json$Json$Encode$bool(planFields.Sc)),
			_Utils_Tuple2(
			'group_discount_rules_calculated_by',
			function () {
				var _v0 = fields.S_;
				if (!_v0.$) {
					var calculatedBy = _v0.a;
					return $elm$json$Json$Encode$string(calculatedBy);
				} else {
					return $elm$json$Json$Encode$string('percent_off');
				}
			}()),
			_Utils_Tuple2(
			'children_age_limit',
			A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, planFields.x2)),
			_Utils_Tuple2(
			'family_num_children_included',
			A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, planFields.zC)),
			_Utils_Tuple2(
			'family_num_adults_included',
			A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, planFields.R8)),
			_Utils_Tuple2(
			'fixed_children_age_limit',
			A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, planFields.Sw)),
			_Utils_Tuple2(
			'group_pricing_family_num_children_included',
			A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, planFields.S0)),
			_Utils_Tuple2(
			'number_additional_children_allowed',
			A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, planFields.BR)),
			_Utils_Tuple2(
			'default_charge_name',
			$elm$json$Json$Encode$string(planFields.y7)),
			_Utils_Tuple2(
			'default_charge_description',
			A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, planFields.y6)),
			_Utils_Tuple2(
			'individual_registration_fee_in_cents',
			A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, planFields.TZ)),
			_Utils_Tuple2(
			'max_registration_fee_in_cents',
			A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, planFields.WC)),
			_Utils_Tuple2(
			'minimum_enrollment_period_in_months',
			A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, planFields.Xf)),
			_Utils_Tuple2(
			'individual_rate_rule',
			A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, planFields.TX)),
			_Utils_Tuple2(
			'couple_rate_rule',
			A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, planFields.ON)),
			_Utils_Tuple2(
			'family_rate_rule',
			A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, planFields.R9)),
			_Utils_Tuple2(
			'single_parent_rate_rule',
			A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, planFields.abC)),
			_Utils_Tuple2(
			'single_parent_with_single_child_rate_rule',
			A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, planFields.abE)),
			_Utils_Tuple2(
			'family_with_single_child_rate_rule',
			A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, planFields.Sb)),
			_Utils_Tuple2(
			'additional_adult_rate_rule',
			A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, planFields.KZ)),
			_Utils_Tuple2(
			'additional_child_rate_rule',
			A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, planFields.K_)),
			_Utils_Tuple2(
			'couple_discount_rule',
			A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, planFields.yS)),
			_Utils_Tuple2(
			'family_discount_rule',
			A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, planFields.zB)),
			_Utils_Tuple2(
			'single_parent_discount_rule',
			A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, planFields.EG)),
			_Utils_Tuple2(
			'additional_adult_discount_rule',
			A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, planFields.vB)),
			_Utils_Tuple2(
			'additional_child_discount_rule',
			A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, planFields.vC)),
			_Utils_Tuple2(
			'children_only_discount_rule',
			A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, planFields.x3)),
			_Utils_Tuple2(
			'group_discount_rules',
			A2($elm$json$Json$Encode$list, $author$project$Api$Provider$Plan$encodeGroupDiscountRuleFields, planFields.SZ)),
			_Utils_Tuple2(
			'special_rates',
			A2($elm$json$Json$Encode$list, $author$project$Api$Provider$Plan$encodeSpecialRateFields, planFields.abT)),
			_Utils_Tuple2(
			'age_rate_rules',
			A2($elm$json$Json$Encode$list, $author$project$Api$Provider$Plan$encodeAgeRateRuleFields, planFields.Lk))
		]);
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'pricing_version',
				$elm$json$Json$Encode$object(baseFields))
			]));
};
var $author$project$Api$Provider$PricingVersion$calculate = F7(
	function (apiClient, planId, pricingVersionId, expand, tracker, fields, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Plan$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Provider$PricingVersion$encodeFields(fields),
				A2(
					$author$project$Api$Data$requestWithTracker,
					tracker,
					A2(
						$author$project$Api$Data$requestWithQuery,
						_List_fromArray(
							[
								A2(
								$author$project$Api$Param$list,
								'expand',
								A2($elm$core$List$map, $author$project$Api$Provider$Plan$expandToString, expand))
							]),
						$author$project$Api$Data$requestTo(
							A2(
								$author$project$Api$Data$pathAppend,
								_List_fromArray(
									[pricingVersionId, 'calculate']),
								$author$project$Api$Provider$PricingVersion$pricingVersionsPath(planId)))))));
	});
var $author$project$Components$PricingVersions$Form$formFields = function (form) {
	return {LW: form.LW, ab: form.ab, zi: form.zi, Q7: form.Q7, ba: form.ba, dm: form.dm, SZ: form.SZ, S_: form.S_, S1: form.S1, k: form.k, dq: form.dq, Bq: form.Bq, r: form.r, dL: form.dL};
};
var $author$project$Components$PricingVersions$Form$PreviewDebouncedMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$PricingVersions$Form$previewDebounceConfig = {
	alK: $jinjor$elm_debounce$Debounce$later(1000),
	ame: $author$project$Components$PricingVersions$Form$PreviewDebouncedMsg
};
var $author$project$Components$PricingVersions$Form$validateEffectiveDate = F2(
	function (touched, maybeDate) {
		if (!touched) {
			return _List_Nil;
		} else {
			if (maybeDate.$ === 1) {
				return _List_fromArray(
					['Please enter an effective date.']);
			} else {
				return _List_Nil;
			}
		}
	});
var $author$project$Components$PricingVersions$Form$validatePricingVersionName = function (name) {
	var trimmedName = $elm$core$String$trim(name);
	return $elm$core$String$isEmpty(trimmedName) ? _List_fromArray(
		['Please enter a name.']) : _List_Nil;
};
var $author$project$Components$PricingVersions$Form$validateForm = F3(
	function (_v0, _v1, form) {
		var specialRatesHasErrors = function () {
			var _v2 = form.dL;
			if (!_v2.$) {
				var specialRatesForm = _v2.a;
				return $author$project$Components$Plan$Form$SpecialRatesFields$hasErrors(specialRatesForm);
			} else {
				return false;
			}
		}();
		var nameErrors = $author$project$Components$PricingVersions$Form$validatePricingVersionName(form.Bq);
		var individualPricingHasErrors = $author$project$Components$Plan$Form$IndividualMembershipPricingFields$hasErrors(form.dq);
		var groupTierPricingHasErrors = $author$project$Components$Plan$Form$GroupTierPricingFields$hasErrors(form.k);
		var familyPricingHasErrors = $author$project$Components$Plan$Form$FamilyMembershipPricingFields$hasErrors(form.dm);
		var effectiveDateErrors = A2($author$project$Components$PricingVersions$Form$validateEffectiveDate, form.ba, form.Q7);
		var basicPlanHasErrors = $author$project$Components$Plan$BasicForm$hasErrors(form.ab);
		return $elm$core$List$isEmpty(nameErrors) && ($elm$core$List$isEmpty(effectiveDateErrors) && ((!basicPlanHasErrors) && ((!individualPricingHasErrors) && ((!familyPricingHasErrors) && ((!groupTierPricingHasErrors) && (!specialRatesHasErrors))))));
	});
var $author$project$Components$PricingVersions$Form$calculate = F4(
	function (model, plan, form, opts) {
		var isValid = (!opts.aed) || A3(
			$author$project$Components$PricingVersions$Form$validateForm,
			$elm$core$Maybe$Just(plan),
			model.ZV,
			form);
		var _v0 = (opts.abg && isValid) ? A3(
			$jinjor$elm_debounce$Debounce$push,
			$author$project$Components$PricingVersions$Form$previewDebounceConfig,
			$author$project$Components$PricingVersions$Form$formFields(form),
			model.eW) : _Utils_Tuple2(model.eW, $elm$core$Platform$Cmd$none);
		var newDebouncer = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			function () {
				if (opts.abg && isValid) {
					return _Utils_update(
						model,
						{
							SD: $elm$core$Maybe$Just(form),
							eW: newDebouncer
						});
				} else {
					if (!isValid) {
						var previewId = model.akd.a + 1;
						return _Utils_update(
							model,
							{
								SD: $elm$core$Maybe$Just(form),
								akd: _Utils_Tuple2(previewId, $author$project$Api$Data$NotAsked),
								eW: newDebouncer
							});
					} else {
						return _Utils_update(
							model,
							{
								SD: $elm$core$Maybe$Just(form),
								eW: newDebouncer
							});
					}
				}
			}(),
			cmd);
	});
var $author$project$Api$Provider$PricingVersion$create = F4(
	function (apiClient, planId, fields, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Provider$PricingVersion$encodeFields(fields),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$PricingVersion$pricingVersionsPath(planId))));
	});
var $author$project$Components$PricingVersions$Form$PreviewDebounced = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$PricingVersions$Form$debounceCalculate = function (pricingFormFields) {
	return A2(
		$elm$core$Task$perform,
		$author$project$Components$PricingVersions$Form$PreviewDebounced,
		$elm$core$Task$succeed(pricingFormFields));
};
var $author$project$Api$Provider$PricingVersion$One$effectiveDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$effectiveDate(shared);
};
var $author$project$Components$PricingVersions$Form$exclusiveRanges = F5(
	function (fromGetter, fromSetter, toGetter, toSetter, range) {
		if ($elm$core$List$isEmpty(range)) {
			return range;
		} else {
			var minimum = A2(
				$elm$core$Maybe$withDefault,
				0,
				A2(
					$elm$core$Maybe$map,
					fromGetter,
					$elm$core$List$head(range)));
			return A2(
				$elm$core$List$indexedMap,
				F2(
					function (index, current) {
						var prev = A2($elm_community$list_extra$List$Extra$getAt, index - 1, range);
						var next = A2($elm_community$list_extra$List$Extra$getAt, index + 1, range);
						var newTo = function () {
							var _v1 = _Utils_Tuple2(
								next,
								toGetter(current));
							if (_v1.a.$ === 1) {
								var _v2 = _v1.a;
								return $elm$core$Maybe$Nothing;
							} else {
								if (_v1.b.$ === 1) {
									var _v3 = _v1.b;
									return toGetter(current);
								} else {
									var currentTo = _v1.b.a;
									var currentFrom = fromGetter(current);
									return (_Utils_cmp(currentTo, currentFrom) < 1) ? $elm$core$Maybe$Just(currentFrom) : toGetter(current);
								}
							}
						}();
						var newFrom = function () {
							var _v0 = A2($elm$core$Maybe$andThen, toGetter, prev);
							if (!_v0.$) {
								var _int = _v0.a;
								return _int + 1;
							} else {
								return minimum;
							}
						}();
						return A2(
							toSetter,
							newTo,
							A2(fromSetter, newFrom, current));
					}),
				range);
		}
	});
var $author$project$Components$PricingVersions$Form$exclusiveSizeRanges = A4(
	$author$project$Components$PricingVersions$Form$exclusiveRanges,
	function ($) {
		return $.SM;
	},
	F2(
		function (from, item) {
			return _Utils_update(
				item,
				{SM: from});
		}),
	function ($) {
		return $.add;
	},
	F2(
		function (to, item) {
			return _Utils_update(
				item,
				{add: to});
		}));
var $author$project$Components$PricingVersions$Form$initFormFieldsWithSpecialRates = F6(
	function (apiClient, session, practice, plan, maybePricingVersion, currentSpecialRatesForm) {
		var specialRatesForm = $elm$core$Maybe$Just(
			A3($author$project$Components$Plan$Form$SpecialRatesFields$fillFromCurrentForm, currentSpecialRatesForm, plan, $elm$core$Maybe$Nothing));
		var membershipPricingForm = A2($author$project$Components$Plan$Form$IndividualMembershipPricingFields$fill, plan, $elm$core$Maybe$Nothing);
		var groupTierPricingForm = A2($author$project$Components$Plan$Form$GroupTierPricingFields$fill, plan, $elm$core$Maybe$Nothing);
		var groupDiscountRules = A2(
			$elm$core$List$map,
			$author$project$Components$Plan$Form$GroupDiscountRuleField$initFromServer,
			$author$project$Api$Provider$Plan$One$groupDiscountRules(plan));
		var familyMembershipPricingForm = A2($author$project$Components$Plan$Form$FamilyMembershipPricingFields$fill, plan, $elm$core$Maybe$Nothing);
		var _v0 = A6(
			$author$project$Components$Plan$BasicForm$fill,
			practice,
			plan,
			false,
			false,
			$elm$core$Maybe$Just(
				_Utils_Tuple2(apiClient, session)),
			maybePricingVersion);
		var basicPlanForm = _v0.a;
		var basicPlanCmd = _v0.b;
		return _Utils_Tuple2(
			{
				LW: A2(
					$elm$core$Maybe$withDefault,
					false,
					$author$project$Api$Provider$Plan$One$appliesGroupDiscountInTiers(plan)),
				ab: basicPlanForm,
				zi: $author$project$Api$Provider$Plan$One$discountsEnabled(plan),
				Q7: $elm$core$Maybe$Nothing,
				ba: false,
				dm: familyMembershipPricingForm,
				SZ: groupDiscountRules,
				S_: $elm$core$Maybe$Just('percent_off'),
				S1: $author$project$Api$Provider$Plan$One$groupPricingType(plan),
				k: groupTierPricingForm,
				dq: membershipPricingForm,
				Bq: '',
				r: false,
				dL: specialRatesForm
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$PricingVersions$Form$BasicPlanFormUpdated, basicPlanCmd));
	});
var $author$project$Api$Provider$PricingVersion$Shared$discountsEnabled = function (_v0) {
	var record = _v0;
	return record.zi;
};
var $author$project$Api$Provider$PricingVersion$One$discountsEnabled = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$discountsEnabled(shared);
};
var $author$project$Api$Provider$PricingVersion$Shared$groupDiscountRules = function (_v0) {
	var record = _v0;
	return record.SZ;
};
var $author$project$Api$Provider$PricingVersion$One$groupDiscountRules = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$groupDiscountRules(shared);
};
var $author$project$Api$Provider$PricingVersion$Shared$groupPricingType = function (_v0) {
	var record = _v0;
	return record.S1;
};
var $author$project$Api$Provider$PricingVersion$One$groupPricingType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$groupPricingType(shared);
};
var $author$project$Api$Provider$PricingVersion$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$PricingVersion$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$name(shared);
};
var $author$project$Api$Provider$PricingVersion$One$plan = function (_v0) {
	var record = _v0.b;
	return record.Jb;
};
var $author$project$Components$PricingVersions$Form$initFormFromPricingVersion = F6(
	function (apiClient, session, pricingVersion, plan, practice, currentDate) {
		var loadedGroupDiscountRules = A2(
			$elm$core$List$map,
			$author$project$Components$Plan$Form$GroupDiscountRuleField$initFromServer,
			$author$project$Api$Provider$PricingVersion$One$groupDiscountRules(pricingVersion));
		var groupDiscountRules = $elm$core$List$isEmpty(loadedGroupDiscountRules) ? _List_fromArray(
			[
				$author$project$Components$Plan$Form$GroupDiscountRuleField$default(
				$author$project$Api$Provider$Plan$One$defaultPeriod(
					$author$project$Api$Provider$PricingVersion$One$plan(pricingVersion)))
			]) : loadedGroupDiscountRules;
		var groupDiscountRulesCalculatedBy = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.M2;
			},
			$elm$core$List$head(groupDiscountRules));
		var defaultName = function () {
			if (!currentDate.$) {
				var date = currentDate.a;
				return $elm$core$String$fromInt(
					$justinmimbs$date$Date$year(date) + 1) + ' Pricing';
			} else {
				return '2025 Pricing';
			}
		}();
		var pricingVersionName = A2(
			$elm$core$Maybe$withDefault,
			defaultName,
			$author$project$Api$Provider$PricingVersion$One$name(pricingVersion));
		var _v0 = A6(
			$author$project$Components$Plan$BasicForm$fill,
			practice,
			plan,
			false,
			false,
			$elm$core$Maybe$Just(
				_Utils_Tuple2(apiClient, session)),
			$elm$core$Maybe$Just(pricingVersion));
		var basicPlan = _v0.a;
		var basicPlanCmd = _v0.b;
		return _Utils_Tuple2(
			{
				LW: A2(
					$elm$core$Maybe$withDefault,
					true,
					$author$project$Api$Provider$PricingVersion$One$appliesGroupDiscountInTiers(pricingVersion)),
				ab: basicPlan,
				zi: $author$project$Api$Provider$PricingVersion$One$discountsEnabled(pricingVersion),
				Q7: $elm$core$Maybe$Just(
					$author$project$Api$Provider$PricingVersion$One$effectiveDate(pricingVersion)),
				ba: false,
				dm: A2(
					$author$project$Components$Plan$Form$FamilyMembershipPricingFields$fill,
					plan,
					$elm$core$Maybe$Just(pricingVersion)),
				SZ: groupDiscountRules,
				S_: groupDiscountRulesCalculatedBy,
				S1: $author$project$Api$Provider$PricingVersion$One$groupPricingType(pricingVersion),
				k: A2(
					$author$project$Components$Plan$Form$GroupTierPricingFields$fill,
					plan,
					$elm$core$Maybe$Just(pricingVersion)),
				dq: A2(
					$author$project$Components$Plan$Form$IndividualMembershipPricingFields$fill,
					plan,
					$elm$core$Maybe$Just(pricingVersion)),
				Bq: pricingVersionName,
				r: false,
				dL: $elm$core$Maybe$Just(
					A3(
						$author$project$Components$Plan$Form$SpecialRatesFields$fillFromCurrentForm,
						$elm$core$Maybe$Nothing,
						plan,
						$elm$core$Maybe$Just(pricingVersion)))
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$PricingVersions$Form$BasicPlanFormUpdated, basicPlanCmd));
	});
var $author$project$Components$PricingVersions$Form$initSharedFields = F2(
	function (maybePlan, form) {
		var basicPlanFields = $author$project$Components$Plan$BasicForm$formFields(form.ab);
		return {P6: basicPlanFields.P6, S1: form.S1, Jb: maybePlan};
	});
var $author$project$Components$PricingVersions$Form$maxGroupFromSize = 10;
var $author$project$Components$PricingVersions$Form$planRoute = function (planId) {
	return $author$project$Spa$Generated$Route$Admin__Plans__Id_String(
		{ahP: planId});
};
var $author$project$Api$Provider$PricingVersion$update = F5(
	function (apiClient, planId, pricingVersionId, fields, toMsg) {
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Provider$PricingVersion$encodeFields(fields),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							[pricingVersionId]),
						$author$project$Api$Provider$PricingVersion$pricingVersionsPath(planId)))));
	});
var $author$project$Components$PricingVersions$Form$updatePlanFieldsForCalculate = function (pricingFormFields) {
	var specialRatesFormFields = function () {
		var _v0 = pricingFormFields.dL;
		if (!_v0.$) {
			var specialRatesForm = _v0.a;
			return $author$project$Components$Plan$Form$SpecialRatesFields$formFields(specialRatesForm);
		} else {
			return {abT: _List_Nil};
		}
	}();
	var groupTierPricingFormFields = $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(pricingFormFields.k);
	var familyMembershipPricingFormFields = $author$project$Components$Plan$Form$FamilyMembershipPricingFields$formFields(pricingFormFields.dm);
	var basicPlanFormFields = $author$project$Components$Plan$BasicForm$formFields(pricingFormFields.ab);
	var registrationFeeFields = $author$project$Components$Plan$Form$RegistrationFeePricingFields$formFields(basicPlanFormFields.dH);
	return {
		vB: A2(
			$elm$core$Maybe$map,
			function (rule) {
				return {LL: rule.LL, LM: rule.LM, Xn: rule.Xn, Xo: rule.Xo, _U: rule._U, _V: rule._V, aaN: rule.aaN, aaO: rule.aaO};
			},
			familyMembershipPricingFormFields.aak.vB.Ro ? familyMembershipPricingFormFields.vB : $elm$core$Maybe$Nothing),
		KZ: groupTierPricingFormFields.aak.R8.Ro ? $elm$core$Maybe$Just(
			{LH: groupTierPricingFormFields.KZ.LH, fE: groupTierPricingFormFields.KZ.fE, Xk: groupTierPricingFormFields.KZ.Xk, gX: groupTierPricingFormFields.KZ.gX, _Q: groupTierPricingFormFields.KZ._Q, ho: groupTierPricingFormFields.KZ.ho, aaJ: groupTierPricingFormFields.KZ.aaJ, hz: groupTierPricingFormFields.KZ.hz}) : $elm$core$Maybe$Nothing,
		vC: A2(
			$elm$core$Maybe$map,
			function (rule) {
				return {LL: rule.LL, LM: rule.LM, Xn: rule.Xn, Xo: rule.Xo, _U: rule._U, _V: rule._V, aaN: rule.aaN, aaO: rule.aaO};
			},
			familyMembershipPricingFormFields.aak.vC.Ro ? familyMembershipPricingFormFields.vC : $elm$core$Maybe$Nothing),
		K_: groupTierPricingFormFields.aak.S0.Ro ? $elm$core$Maybe$Just(
			{LH: groupTierPricingFormFields.K_.LH, fE: groupTierPricingFormFields.K_.fE, Xk: groupTierPricingFormFields.K_.Xk, gX: groupTierPricingFormFields.K_.gX, _Q: groupTierPricingFormFields.K_._Q, ho: groupTierPricingFormFields.K_.ho, aaJ: groupTierPricingFormFields.K_.aaJ, hz: groupTierPricingFormFields.K_.hz}) : $elm$core$Maybe$Nothing,
		K$: basicPlanFormFields.K$,
		Lk: function () {
			var membershipPricingFormFields = $author$project$Components$Plan$Form$IndividualMembershipPricingFields$formFields(pricingFormFields.dq);
			var ageRateRules = membershipPricingFormFields.Lk;
			return A2(
				$elm$core$List$map,
				function (ageRateRule) {
					return {
						LH: ageRateRule.dE.LH,
						fE: ageRateRule.dE.fE,
						OM: A2(
							$elm$core$Maybe$map,
							function (coupleRule) {
								return {LH: coupleRule.dE.LH, fE: coupleRule.dE.fE, Xk: coupleRule.dE.Xk, gX: coupleRule.dE.gX, _Q: coupleRule.dE._Q, ho: coupleRule.dE.ho, aaJ: coupleRule.dE.aaJ, hz: coupleRule.dE.hz};
							},
							ageRateRule.OM),
						SK: $elm$core$Maybe$Just(ageRateRule.SK),
						Xk: ageRateRule.dE.Xk,
						gX: ageRateRule.dE.gX,
						_Q: ageRateRule.dE._Q,
						ho: ageRateRule.dE.ho,
						aaJ: ageRateRule.dE.aaJ,
						hz: ageRateRule.dE.hz,
						adb: ageRateRule.adb,
						adL: ageRateRule.adL
					};
				},
				ageRateRules);
		}(),
		xk: A2($elm$core$Maybe$withDefault, $author$project$Percentage$zero, basicPlanFormFields.xk),
		xl: basicPlanFormFields.xl,
		LW: pricingFormFields.LW,
		MI: basicPlanFormFields.MI,
		MZ: basicPlanFormFields.MZ,
		x2: familyMembershipPricingFormFields.x2,
		x3: A2(
			$elm$core$Maybe$map,
			function (rule) {
				return {LL: rule.LL, LM: rule.LM, Xn: rule.Xn, Xo: rule.Xo, _U: rule._U, _V: rule._V, aaN: rule.aaN, aaO: rule.aaO};
			},
			familyMembershipPricingFormFields.aak.x3.Ro ? familyMembershipPricingFormFields.x3 : $elm$core$Maybe$Nothing),
		OA: false,
		OB: false,
		OC: $elm$core$Maybe$Nothing,
		OD: $elm$core$Maybe$Nothing,
		G3: $elm$core$Maybe$Nothing,
		yS: A2(
			$elm$core$Maybe$map,
			function (rule) {
				return {LL: rule.LL, LM: rule.LM, Xn: rule.Xn, Xo: rule.Xo, _U: rule._U, _V: rule._V, aaN: rule.aaN, aaO: rule.aaO};
			},
			familyMembershipPricingFormFields.aak.yS.Ro ? familyMembershipPricingFormFields.yS : $elm$core$Maybe$Nothing),
		ON: $elm$core$Maybe$Just(
			{LH: groupTierPricingFormFields.ON.LH, fE: groupTierPricingFormFields.ON.fE, Xk: groupTierPricingFormFields.ON.Xk, gX: groupTierPricingFormFields.ON.gX, _Q: groupTierPricingFormFields.ON._Q, ho: groupTierPricingFormFields.ON.ho, aaJ: groupTierPricingFormFields.ON.aaJ, hz: groupTierPricingFormFields.ON.hz}),
		OT: $elm$core$Maybe$Nothing,
		y6: basicPlanFormFields.y6,
		y7: basicPlanFormFields.y7,
		P6: basicPlanFormFields.P6,
		Hs: $elm$core$Dict$empty,
		zi: pricingFormFields.zi,
		zB: A2(
			$elm$core$Maybe$map,
			function (rule) {
				return {LL: rule.LL, LM: rule.LM, Xn: rule.Xn, Xo: rule.Xo, _U: rule._U, _V: rule._V, aaN: rule.aaN, aaO: rule.aaO};
			},
			familyMembershipPricingFormFields.aak.zB.Ro ? familyMembershipPricingFormFields.zB : $elm$core$Maybe$Nothing),
		R8: groupTierPricingFormFields.aak.R8.Ro ? groupTierPricingFormFields.R8 : $elm$core$Maybe$Nothing,
		zC: familyMembershipPricingFormFields.zC,
		R9: $elm$core$Maybe$Just(
			{LH: groupTierPricingFormFields.R9.LH, fE: groupTierPricingFormFields.R9.fE, Xk: groupTierPricingFormFields.R9.Xk, gX: groupTierPricingFormFields.R9.gX, _Q: groupTierPricingFormFields.R9._Q, ho: groupTierPricingFormFields.R9.ho, aaJ: groupTierPricingFormFields.R9.aaJ, hz: groupTierPricingFormFields.R9.hz}),
		Sb: groupTierPricingFormFields.Sc ? $elm$core$Maybe$Just(
			{LH: groupTierPricingFormFields.Sb.LH, fE: groupTierPricingFormFields.Sb.fE, Xk: groupTierPricingFormFields.Sb.Xk, gX: groupTierPricingFormFields.Sb.gX, _Q: groupTierPricingFormFields.Sb._Q, ho: groupTierPricingFormFields.Sb.ho, aaJ: groupTierPricingFormFields.Sb.aaJ, hz: groupTierPricingFormFields.Sb.hz}) : $elm$core$Maybe$Nothing,
		Sc: groupTierPricingFormFields.Sc,
		Sw: groupTierPricingFormFields.aak.Sw.Ro ? groupTierPricingFormFields.Sw : $elm$core$Maybe$Nothing,
		SZ: A2(
			$elm$core$List$map,
			function (groupDiscountRule) {
				return {
					LJ: groupDiscountRule.LJ,
					LK: groupDiscountRule.LK,
					LP: groupDiscountRule.LP,
					LQ: groupDiscountRule.LQ,
					M2: groupDiscountRule.M2,
					SM: $elm$core$Maybe$Just(groupDiscountRule.SM),
					Xl: groupDiscountRule.Xl,
					Xm: groupDiscountRule.Xm,
					Xs: groupDiscountRule.Xs,
					Xt: groupDiscountRule.Xt,
					_S: groupDiscountRule._S,
					_T: groupDiscountRule._T,
					_Y: groupDiscountRule._Y,
					_Z: groupDiscountRule._Z,
					aaL: groupDiscountRule.aaL,
					aaM: groupDiscountRule.aaM,
					aaR: groupDiscountRule.aaR,
					aaS: groupDiscountRule.aaS,
					add: groupDiscountRule.add
				};
			},
			pricingFormFields.SZ),
		S0: groupTierPricingFormFields.aak.S0.Ro ? groupTierPricingFormFields.S0 : $elm$core$Maybe$Nothing,
		S1: pricingFormFields.S1,
		TP: $elm$core$Maybe$Nothing,
		TX: $elm$core$Maybe$Just(
			{LH: groupTierPricingFormFields.TX.LH, fE: groupTierPricingFormFields.TX.fE, Xk: groupTierPricingFormFields.TX.Xk, gX: groupTierPricingFormFields.TX.gX, _Q: groupTierPricingFormFields.TX._Q, ho: groupTierPricingFormFields.TX.ho, aaJ: groupTierPricingFormFields.TX.aaJ, hz: groupTierPricingFormFields.TX.hz}),
		TZ: registrationFeeFields.aak.TZ.Ro ? registrationFeeFields.TZ : $elm$core$Maybe$Nothing,
		Vu: $elm$core$Maybe$Nothing,
		WC: registrationFeeFields.aak.WC.Ro ? registrationFeeFields.WC : $elm$core$Maybe$Nothing,
		WF: $elm$core$Maybe$Nothing,
		Xd: $elm$core$Maybe$Nothing,
		Xf: basicPlanFormFields.Xf,
		Bi: A2($elm$core$Maybe$withDefault, $author$project$Percentage$zero, basicPlanFormFields.Bi),
		Bj: basicPlanFormFields.Bj,
		Bq: basicPlanFormFields.Bq,
		BR: familyMembershipPricingFormFields.BR,
		_j: 0,
		DB: A2($elm$core$Maybe$withDefault, $author$project$Percentage$zero, basicPlanFormFields.DB),
		DC: basicPlanFormFields.DC,
		DL: $author$project$Components$Plan$Form$RegistrationFeePricingFields$getCategoryId(basicPlanFormFields.dH),
		DM: basicPlanFormFields.DM,
		DN: basicPlanFormFields.DN,
		Es: A2($elm$core$Maybe$withDefault, $author$project$Percentage$zero, basicPlanFormFields.Es),
		Et: basicPlanFormFields.Et,
		EG: A2(
			$elm$core$Maybe$map,
			function (rule) {
				return {LL: rule.LL, LM: rule.LM, Xn: rule.Xn, Xo: rule.Xo, _U: rule._U, _V: rule._V, aaN: rule.aaN, aaO: rule.aaO};
			},
			familyMembershipPricingFormFields.aak.EG.Ro ? familyMembershipPricingFormFields.EG : $elm$core$Maybe$Nothing),
		abC: $elm$core$Maybe$Just(
			{LH: groupTierPricingFormFields.abC.LH, fE: groupTierPricingFormFields.abC.fE, Xk: groupTierPricingFormFields.abC.Xk, gX: groupTierPricingFormFields.abC.gX, _Q: groupTierPricingFormFields.abC._Q, ho: groupTierPricingFormFields.abC.ho, aaJ: groupTierPricingFormFields.abC.aaJ, hz: groupTierPricingFormFields.abC.hz}),
		abE: groupTierPricingFormFields.abF ? $elm$core$Maybe$Just(
			{LH: groupTierPricingFormFields.abE.LH, fE: groupTierPricingFormFields.abE.fE, Xk: groupTierPricingFormFields.abE.Xk, gX: groupTierPricingFormFields.abE.gX, _Q: groupTierPricingFormFields.abE._Q, ho: groupTierPricingFormFields.abE.ho, aaJ: groupTierPricingFormFields.abE.aaJ, hz: groupTierPricingFormFields.abE.hz}) : $elm$core$Maybe$Nothing,
		abF: groupTierPricingFormFields.abF,
		abT: A2(
			$elm$core$List$map,
			function (specialRate) {
				return {LH: specialRate.LH, fE: specialRate.fE, O0: specialRate.O0, Qv: specialRate.Qv, ahP: specialRate.ahP, Xk: specialRate.Xk, gX: specialRate.gX, Bq: specialRate.Bq, _Q: specialRate._Q, ho: specialRate.ho, aaJ: specialRate.aaJ, hz: specialRate.hz};
			},
			A2(
				$elm$core$List$filter,
				function (specialRate) {
					return !specialRate.Qv;
				},
				specialRatesFormFields.abT)),
		abW: groupTierPricingFormFields.abW,
		JS: basicPlanFormFields.JS,
		adf: $author$project$Currency$zero,
		adg: $author$project$Percentage$zero,
		adh: $elm$core$Maybe$Nothing
	};
};
var $author$project$Components$PricingVersions$Form$updatePlanFieldsForSave = function (pricingFormFields) {
	var specialRatesFormFields = function () {
		var _v0 = pricingFormFields.dL;
		if (!_v0.$) {
			var specialRatesForm = _v0.a;
			return $author$project$Components$Plan$Form$SpecialRatesFields$formFields(specialRatesForm);
		} else {
			return {abT: _List_Nil};
		}
	}();
	var planFieldsForCalculate = $author$project$Components$PricingVersions$Form$updatePlanFieldsForCalculate(pricingFormFields);
	return _Utils_update(
		planFieldsForCalculate,
		{
			abT: A2(
				$elm$core$List$map,
				function (specialRate) {
					return {LH: specialRate.LH, fE: specialRate.fE, O0: specialRate.O0, Qv: specialRate.Qv, ahP: specialRate.ahP, Xk: specialRate.Xk, gX: specialRate.gX, Bq: specialRate.Bq, _Q: specialRate._Q, ho: specialRate.ho, aaJ: specialRate.aaJ, hz: specialRate.hz};
				},
				specialRatesFormFields.abT)
		});
};
var $author$project$Components$PricingVersions$Form$validateFormFields = F3(
	function (maybePlan, practice, form) {
		var validatedBasicPlan = function () {
			var _v8 = A2($author$project$Components$Plan$BasicForm$validate, form.ab, maybePlan);
			if (!_v8.$) {
				var _v9 = _v8.a;
				var newForm_ = _v9.a;
				return newForm_;
			} else {
				var newForm_ = _v8.a;
				return newForm_;
			}
		}();
		var sharedFields = A2($author$project$Components$PricingVersions$Form$initSharedFields, maybePlan, form);
		var validatedFamilyMembershipPricingForm = function () {
			var _v6 = A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$validate, form.dm, sharedFields, maybePlan);
			if (!_v6.$) {
				var _v7 = _v6.a;
				var newForm_ = _v7.a;
				return newForm_;
			} else {
				var newForm_ = _v6.a;
				return newForm_;
			}
		}();
		var validatedGroupTierPricingForm = function () {
			var _v4 = A3($author$project$Components$Plan$Form$GroupTierPricingFields$validate, sharedFields, form.k, maybePlan);
			if (!_v4.$) {
				var _v5 = _v4.a;
				var newForm_ = _v5.a;
				return newForm_;
			} else {
				var newForm_ = _v4.a;
				return newForm_;
			}
		}();
		var validatedIndividualMembershipPricingForm = function () {
			var _v2 = A3($author$project$Components$Plan$Form$IndividualMembershipPricingFields$validate, sharedFields, form.dq, maybePlan);
			if (!_v2.$) {
				var _v3 = _v2.a;
				var newForm_ = _v3.a;
				return newForm_;
			} else {
				var newForm_ = _v2.a;
				return newForm_;
			}
		}();
		var validatedSpecialRatesForm = A2(
			$elm$core$Maybe$map,
			function (specialRatesForm) {
				var _v0 = A4($author$project$Components$Plan$Form$SpecialRatesFields$validate, sharedFields, practice, specialRatesForm, maybePlan);
				if (!_v0.$) {
					var _v1 = _v0.a;
					var newForm_ = _v1.a;
					return newForm_;
				} else {
					var newForm_ = _v0.a;
					return newForm_;
				}
			},
			form.dL);
		return _Utils_update(
			form,
			{ab: validatedBasicPlan, dm: validatedFamilyMembershipPricingForm, k: validatedGroupTierPricingForm, dq: validatedIndividualMembershipPricingForm, dL: validatedSpecialRatesForm});
	});
var $author$project$Components$PricingVersions$Form$update = F3(
	function (apiClient, msg, _v0) {
		update:
		while (true) {
			var model = _v0;
			switch (msg.$) {
				case 1:
					var currentDate = msg.a;
					var currentYear = $justinmimbs$date$Date$year(currentDate);
					var nextYear = currentYear + 1;
					var newName = $elm$core$String$fromInt(nextYear) + ' Pricing';
					var newForm = A2(
						$elm$core$Maybe$map,
						function (form) {
							return _Utils_update(
								form,
								{Bq: newName});
						},
						model.SD);
					var updatedItem = function () {
						var _v2 = model.Io;
						if (_v2.$ === 3) {
							var pricingVersion = _v2.a;
							var meta = _v2.b;
							return A2(
								$author$project$Api$Data$Success,
								_Utils_update(
									pricingVersion,
									{Bq: newName}),
								meta);
						} else {
							var other = _v2;
							return other;
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								dd: $elm$core$Maybe$Just(currentDate),
								SD: newForm,
								Io: updatedItem
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				case 0:
					var pricingVersionData = msg.a;
					if (pricingVersionData.$ === 3) {
						var pricingVersion = pricingVersionData.a;
						var meta = pricingVersionData.b;
						var updatedEffectiveDateInput = function () {
							var _v7 = model.akh;
							if (!_v7.$) {
								return $author$project$Components$DateInput$initFromDate(
									$author$project$Api$Provider$PricingVersion$One$effectiveDate(pricingVersion));
							} else {
								return model.jC;
							}
						}();
						var plan = $author$project$Api$Provider$PricingVersion$One$plan(pricingVersion);
						var planData = A2($author$project$Api$Data$Success, plan, meta);
						var _v4 = A6($author$project$Components$PricingVersions$Form$initFormFromPricingVersion, apiClient, model.aa4, pricingVersion, plan, model.ZV, model.dd);
						var initialForm = _v4.a;
						var initCmd = _v4.b;
						var finalForm = function () {
							var _v5 = model.SD;
							if (!_v5.$) {
								var existingForm = _v5.a;
								return _Utils_update(
									initialForm,
									{Q7: existingForm.Q7, ba: existingForm.ba, Bq: existingForm.Bq, r: existingForm.r});
							} else {
								var _v6 = model.akh;
								if (!_v6.$) {
									return initialForm;
								} else {
									return _Utils_update(
										initialForm,
										{Q7: $elm$core$Maybe$Nothing});
								}
							}
						}();
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									l: planData,
									jC: updatedEffectiveDateInput,
									SD: $elm$core$Maybe$Just(finalForm),
									pl: pricingVersionData
								}),
							initCmd,
							_List_Nil);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									l: A2($author$project$Api$Data$map, $author$project$Api$Provider$PricingVersion$One$plan, pricingVersionData),
									pl: pricingVersionData
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				case 2:
					var name = msg.a;
					var _v8 = model.SD;
					if (!_v8.$) {
						var form = _v8.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									SD: $elm$core$Maybe$Just(
										_Utils_update(
											form,
											{Bq: name, r: false}))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				case 3:
					var subMsg = msg.a;
					var _v9 = A2($author$project$Components$DateInput$update, subMsg, model.jC);
					var newDateInput = _v9.a;
					var subCmd = _v9.b;
					var dateInputEvent = _v9.c;
					var newForm = A2(
						$elm$core$Maybe$map,
						function (form) {
							if (dateInputEvent.$ === 1) {
								var date = dateInputEvent.a;
								return _Utils_update(
									form,
									{Q7: date, ba: true});
							} else {
								return form;
							}
						},
						model.SD);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jC: newDateInput, SD: newForm}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$PricingVersions$Form$EffectiveDateInputMsg, subCmd),
						_List_Nil);
				case 9:
					var formField = msg.a;
					switch (formField.$) {
						case 0:
							var enabled = formField.a;
							var _v12 = _Utils_Tuple2(model.SD, model.l);
							if ((!_v12.a.$) && (_v12.b.$ === 3)) {
								var form = _v12.a.a;
								var _v13 = _v12.b;
								var plan = _v13.a;
								var newForm = _Utils_update(
									form,
									{zi: enabled});
								var calculateOpts = {abg: true, aed: false};
								return function (_v14) {
									var newModel = _v14.a;
									var cmd = _v14.b;
									return _Utils_Tuple3(newModel, cmd, _List_Nil);
								}(
									A4($author$project$Components$PricingVersions$Form$calculate, model, plan, newForm, calculateOpts));
							} else {
								return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
							}
						case 1:
							var groupPricingType = formField.a;
							var _v15 = _Utils_Tuple2(model.SD, model.l);
							if ((!_v15.a.$) && (_v15.b.$ === 3)) {
								var form = _v15.a.a;
								var _v16 = _v15.b;
								var plan = _v16.a;
								var newForm = _Utils_update(
									form,
									{S1: groupPricingType});
								var calculateOpts = {abg: true, aed: false};
								return function (_v17) {
									var newModel = _v17.a;
									var cmd = _v17.b;
									return _Utils_Tuple3(newModel, cmd, _List_Nil);
								}(
									A4($author$project$Components$PricingVersions$Form$calculate, model, plan, newForm, calculateOpts));
							} else {
								return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
							}
						case 2:
							var applies = formField.a;
							var _v18 = _Utils_Tuple2(model.SD, model.l);
							if ((!_v18.a.$) && (_v18.b.$ === 3)) {
								var form = _v18.a.a;
								var _v19 = _v18.b;
								var plan = _v19.a;
								var newForm = _Utils_update(
									form,
									{LW: applies});
								var calculateOpts = {abg: true, aed: false};
								return function (_v20) {
									var newModel = _v20.a;
									var cmd = _v20.b;
									return _Utils_Tuple3(newModel, cmd, _List_Nil);
								}(
									A4($author$project$Components$PricingVersions$Form$calculate, model, plan, newForm, calculateOpts));
							} else {
								return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
							}
						case 3:
							var isPercent = formField.a;
							var _v21 = model.SD;
							if (!_v21.$) {
								var form = _v21.a;
								var calculatedBy = isPercent ? 'percent_off' : 'amount_off_in_cents';
								var updatedGroupDiscountRules = A2(
									$elm$core$List$map,
									function (groupDiscountRule) {
										return _Utils_update(
											groupDiscountRule,
											{M2: calculatedBy});
									},
									form.SZ);
								var newForm = _Utils_update(
									form,
									{
										SZ: updatedGroupDiscountRules,
										S_: $elm$core$Maybe$Just(calculatedBy)
									});
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											SD: $elm$core$Maybe$Just(newForm)
										}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							} else {
								return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
							}
						case 4:
							var _v22 = model.SD;
							if (!_v22.$) {
								var form = _v22.a;
								var updatedGroupDiscountRules = A2(
									$elm$core$Maybe$withDefault,
									form.SZ,
									A2(
										$elm$core$Maybe$map,
										function (_v24) {
											var newGroupDiscountRule = _v24.a;
											var newLastGroupDiscountRule = _v24.b;
											return A2(
												$author$project$Utils$List$prepend,
												_List_fromArray(
													[newGroupDiscountRule]),
												A2(
													$author$project$Utils$List$updateLast,
													function (last) {
														return A2($elm$core$Maybe$withDefault, last, newLastGroupDiscountRule);
													},
													form.SZ));
										},
										A2(
											$elm$core$Maybe$map,
											function (lastGroupDiscountRule) {
												var lastToSize = (_Utils_cmp(lastGroupDiscountRule.SM + 1, $author$project$Components$PricingVersions$Form$maxGroupFromSize - 1) > 0) ? ($author$project$Components$PricingVersions$Form$maxGroupFromSize - 1) : (lastGroupDiscountRule.SM + 1);
												var newLastGroupDiscountRule_ = _Utils_update(
													lastGroupDiscountRule,
													{
														add: $elm$core$Maybe$Just(lastToSize)
													});
												var _v23 = $author$project$Components$Plan$BasicForm$formFields(form.ab);
												var defaultPeriod = _v23.P6;
												return _Utils_Tuple2(
													A2($author$project$Components$Plan$Form$GroupDiscountRuleField$startingFrom, defaultPeriod, newLastGroupDiscountRule_),
													$elm$core$Maybe$Just(newLastGroupDiscountRule_));
											},
											$elm_community$list_extra$List$Extra$last(form.SZ))));
								var newForm = _Utils_update(
									form,
									{SZ: updatedGroupDiscountRules, r: false});
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											SD: $elm$core$Maybe$Just(newForm)
										}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							} else {
								return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
							}
						case 8:
							var index = formField.a;
							var period = formField.b;
							var currency = formField.c;
							var _v25 = model.SD;
							if (!_v25.$) {
								var form = _v25.a;
								var updatedGroupDiscountRules = A3(
									$elm_community$list_extra$List$Extra$updateAt,
									index,
									function (groupDiscountRule) {
										switch (period) {
											case 'month':
												return _Utils_update(
													groupDiscountRule,
													{Xl: currency, Xm: true});
											case 'quarter':
												return _Utils_update(
													groupDiscountRule,
													{_S: currency, _T: true});
											case 'semi_annual':
												return _Utils_update(
													groupDiscountRule,
													{aaL: currency, aaM: true});
											case 'annual':
												return _Utils_update(
													groupDiscountRule,
													{LJ: currency, LK: true});
											default:
												return groupDiscountRule;
										}
									},
									form.SZ);
								var newForm = _Utils_update(
									form,
									{SZ: updatedGroupDiscountRules, r: false});
								var cmd = function () {
									if (currency.$ === 1) {
										return $elm$core$Platform$Cmd$none;
									} else {
										var newFormFields = $author$project$Components$PricingVersions$Form$formFields(newForm);
										return $author$project$Components$PricingVersions$Form$debounceCalculate(newFormFields);
									}
								}();
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											SD: $elm$core$Maybe$Just(newForm)
										}),
									cmd,
									_List_Nil);
							} else {
								return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
							}
						case 11:
							var index = formField.a;
							var period = formField.b;
							var percentage = formField.c;
							var _v28 = model.SD;
							if (!_v28.$) {
								var form = _v28.a;
								var updatedGroupDiscountRules = A3(
									$elm_community$list_extra$List$Extra$updateAt,
									index,
									function (groupDiscountRule) {
										switch (period) {
											case 'month':
												return _Utils_update(
													groupDiscountRule,
													{Xs: percentage, Xt: true});
											case 'quarter':
												return _Utils_update(
													groupDiscountRule,
													{_Y: percentage, _Z: true});
											case 'semi_annual':
												return _Utils_update(
													groupDiscountRule,
													{aaR: percentage, aaS: true});
											case 'annual':
												return _Utils_update(
													groupDiscountRule,
													{LP: percentage, LQ: true});
											default:
												return groupDiscountRule;
										}
									},
									form.SZ);
								var newForm = _Utils_update(
									form,
									{SZ: updatedGroupDiscountRules, r: false});
								var cmd = function () {
									if (percentage.$ === 1) {
										return $elm$core$Platform$Cmd$none;
									} else {
										var newFormFields = $author$project$Components$PricingVersions$Form$formFields(newForm);
										return $author$project$Components$PricingVersions$Form$debounceCalculate(newFormFields);
									}
								}();
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											SD: $elm$core$Maybe$Just(newForm)
										}),
									cmd,
									_List_Nil);
							} else {
								return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
							}
						case 5:
							var index = formField.a;
							var _v31 = _Utils_Tuple2(model.SD, model.l);
							if ((!_v31.a.$) && (_v31.b.$ === 3)) {
								var form = _v31.a.a;
								var _v32 = _v31.b;
								var updatedGroupDiscountRules = $author$project$Components$PricingVersions$Form$exclusiveSizeRanges(
									A2($elm_community$list_extra$List$Extra$removeAt, index, form.SZ));
								var newForm = _Utils_update(
									form,
									{SZ: updatedGroupDiscountRules, r: false});
								var newFormFields = $author$project$Components$PricingVersions$Form$formFields(newForm);
								var cmd = $author$project$Components$PricingVersions$Form$debounceCalculate(newFormFields);
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											SD: $elm$core$Maybe$Just(newForm)
										}),
									cmd,
									_List_Nil);
							} else {
								return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
							}
						case 6:
							var index = formField.a;
							var string = formField.b;
							var _v33 = _Utils_Tuple2(model.SD, model.l);
							if ((!_v33.a.$) && (_v33.b.$ === 3)) {
								var form = _v33.a.a;
								var _v34 = _v33.b;
								var updatedGroupDiscountRules = $author$project$Components$PricingVersions$Form$exclusiveSizeRanges(
									A3(
										$elm_community$list_extra$List$Extra$updateAt,
										index,
										function (groupDiscountRule) {
											return _Utils_update(
												groupDiscountRule,
												{
													SM: A2(
														$elm$core$Maybe$withDefault,
														0,
														$elm$core$String$toInt(string))
												});
										},
										form.SZ));
								var newForm = _Utils_update(
									form,
									{SZ: updatedGroupDiscountRules, r: false});
								var newFormFields = $author$project$Components$PricingVersions$Form$formFields(newForm);
								var cmd = $author$project$Components$PricingVersions$Form$debounceCalculate(newFormFields);
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											SD: $elm$core$Maybe$Just(newForm)
										}),
									cmd,
									_List_Nil);
							} else {
								return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
							}
						case 7:
							var index = formField.a;
							var string = formField.b;
							var _v35 = _Utils_Tuple2(model.SD, model.l);
							if ((!_v35.a.$) && (_v35.b.$ === 3)) {
								var form = _v35.a.a;
								var _v36 = _v35.b;
								var updatedGroupDiscountRules = $author$project$Components$PricingVersions$Form$exclusiveSizeRanges(
									A3(
										$elm_community$list_extra$List$Extra$updateAt,
										index,
										function (groupDiscountRule) {
											return _Utils_update(
												groupDiscountRule,
												{
													add: $elm$core$String$toInt(string)
												});
										},
										form.SZ));
								var newForm = _Utils_update(
									form,
									{SZ: updatedGroupDiscountRules, r: false});
								var newFormFields = $author$project$Components$PricingVersions$Form$formFields(newForm);
								var cmd = $author$project$Components$PricingVersions$Form$debounceCalculate(newFormFields);
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											SD: $elm$core$Maybe$Just(newForm)
										}),
									cmd,
									_List_Nil);
							} else {
								return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
							}
						case 9:
							var index = formField.a;
							var period = formField.b;
							var _v37 = model.SD;
							if (!_v37.$) {
								var form = _v37.a;
								var updatedGroupDiscountRules = A3(
									$elm_community$list_extra$List$Extra$updateAt,
									index,
									function (groupDiscountRule) {
										switch (period) {
											case 'month':
												return _Utils_update(
													groupDiscountRule,
													{IC: true});
											case 'quarter':
												return _Utils_update(
													groupDiscountRule,
													{Jq: true});
											case 'semi_annual':
												return _Utils_update(
													groupDiscountRule,
													{JG: true});
											case 'annual':
												return _Utils_update(
													groupDiscountRule,
													{Gs: true});
											default:
												return _Utils_update(
													groupDiscountRule,
													{IC: true});
										}
									},
									form.SZ);
								var newForm = _Utils_update(
									form,
									{SZ: updatedGroupDiscountRules, r: false});
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											SD: $elm$core$Maybe$Just(newForm)
										}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							} else {
								return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
							}
						case 12:
							var index = formField.a;
							var period = formField.b;
							var _v39 = model.SD;
							if (!_v39.$) {
								var form = _v39.a;
								var updatedGroupDiscountRules = A3(
									$elm_community$list_extra$List$Extra$updateAt,
									index,
									function (groupDiscountRule) {
										switch (period) {
											case 'month':
												return _Utils_update(
													groupDiscountRule,
													{oH: true});
											case 'quarter':
												return _Utils_update(
													groupDiscountRule,
													{t7: true});
											case 'semi_annual':
												return _Utils_update(
													groupDiscountRule,
													{uv: true});
											case 'annual':
												return _Utils_update(
													groupDiscountRule,
													{rj: true});
											default:
												return _Utils_update(
													groupDiscountRule,
													{oH: true});
										}
									},
									form.SZ);
								var newForm = _Utils_update(
									form,
									{SZ: updatedGroupDiscountRules, r: false});
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											SD: $elm$core$Maybe$Just(newForm)
										}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							} else {
								return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
							}
						case 10:
							var index = formField.a;
							var period = formField.b;
							var _v41 = _Utils_Tuple2(model.SD, model.l);
							if ((!_v41.a.$) && (_v41.b.$ === 3)) {
								var form = _v41.a.a;
								var _v42 = _v41.b;
								var plan = _v42.a;
								var updatedGroupDiscountRules = A3(
									$elm_community$list_extra$List$Extra$updateAt,
									index,
									function (groupDiscountRule) {
										switch (period) {
											case 'month':
												return _Utils_update(
													groupDiscountRule,
													{Xl: $elm$core$Maybe$Nothing, Xm: false, IC: false});
											case 'quarter':
												return _Utils_update(
													groupDiscountRule,
													{_S: $elm$core$Maybe$Nothing, _T: false, Jq: false});
											case 'semi_annual':
												return _Utils_update(
													groupDiscountRule,
													{aaL: $elm$core$Maybe$Nothing, aaM: false, JG: false});
											case 'annual':
												return _Utils_update(
													groupDiscountRule,
													{LJ: $elm$core$Maybe$Nothing, LK: false, Gs: false});
											default:
												return groupDiscountRule;
										}
									},
									form.SZ);
								var newForm = _Utils_update(
									form,
									{SZ: updatedGroupDiscountRules, r: false});
								var calculateOpts = {abg: true, aed: false};
								return function (_v43) {
									var newModel = _v43.a;
									var cmd = _v43.b;
									return _Utils_Tuple3(newModel, cmd, _List_Nil);
								}(
									A4($author$project$Components$PricingVersions$Form$calculate, model, plan, newForm, calculateOpts));
							} else {
								return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
							}
						default:
							var index = formField.a;
							var period = formField.b;
							var _v45 = _Utils_Tuple2(model.SD, model.l);
							if ((!_v45.a.$) && (_v45.b.$ === 3)) {
								var form = _v45.a.a;
								var _v46 = _v45.b;
								var plan = _v46.a;
								var updatedGroupDiscountRules = A3(
									$elm_community$list_extra$List$Extra$updateAt,
									index,
									function (groupDiscountRule) {
										switch (period) {
											case 'month':
												return _Utils_update(
													groupDiscountRule,
													{Xs: $elm$core$Maybe$Nothing, Xt: false, oH: false});
											case 'quarter':
												return _Utils_update(
													groupDiscountRule,
													{_Y: $elm$core$Maybe$Nothing, _Z: false, t7: false});
											case 'semi_annual':
												return _Utils_update(
													groupDiscountRule,
													{aaR: $elm$core$Maybe$Nothing, aaS: false, uv: false});
											case 'annual':
												return _Utils_update(
													groupDiscountRule,
													{LP: $elm$core$Maybe$Nothing, LQ: false, rj: false});
											default:
												return groupDiscountRule;
										}
									},
									form.SZ);
								var newForm = _Utils_update(
									form,
									{SZ: updatedGroupDiscountRules, r: false});
								var calculateOpts = {abg: true, aed: false};
								return function (_v47) {
									var newModel = _v47.a;
									var cmd = _v47.b;
									return _Utils_Tuple3(newModel, cmd, _List_Nil);
								}(
									A4($author$project$Components$PricingVersions$Form$calculate, model, plan, newForm, calculateOpts));
							} else {
								return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
							}
					}
				case 4:
					var planFormMsg = msg.a;
					var _v49 = _Utils_Tuple2(model.SD, model.l);
					if ((!_v49.a.$) && (_v49.b.$ === 3)) {
						var form = _v49.a.a;
						var _v50 = _v49.b;
						var plan = _v50.a;
						var newBasicPlanResult = A4(
							$author$project$Components$Plan$BasicForm$update,
							apiClient,
							planFormMsg,
							form.ab,
							$elm$core$Maybe$Just(plan));
						var _v51 = function () {
							var _v52 = newBasicPlanResult.agZ;
							if (_v52.$ === 1) {
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											SD: $elm$core$Maybe$Just(
												_Utils_update(
													form,
													{ab: newBasicPlanResult.aiO}))
										}),
									$elm$core$Platform$Cmd$none);
							} else {
								var field = _v52.a;
								var newForm = _Utils_update(
									form,
									{ab: newBasicPlanResult.aiO});
								if (field.$ === 3) {
									var defaultPeriod = field.a;
									var sharedFields = A2(
										$author$project$Components$PricingVersions$Form$initSharedFields,
										$elm$core$Maybe$Just(plan),
										newForm);
									var defaultPeriodString = defaultPeriod ? 'annual' : 'month';
									var familyMembershipPricingResult = A3(
										$author$project$Components$Plan$Form$FamilyMembershipPricingFields$updateDefaultPeriod,
										defaultPeriodString,
										$elm$core$Maybe$Just(plan),
										form.dm);
									var groupTierPricingResult = A3($author$project$Components$Plan$Form$GroupTierPricingFields$updateDefaultPeriod, sharedFields, defaultPeriodString, form.k);
									var individualMembershipPricingResult = A3($author$project$Components$Plan$Form$IndividualMembershipPricingFields$updateDefaultPeriod, sharedFields, defaultPeriodString, form.dq);
									var finalForm = _Utils_update(
										newForm,
										{dm: familyMembershipPricingResult.aiO, k: groupTierPricingResult.aiO, dq: individualMembershipPricingResult.aiO});
									var newFormFields = $author$project$Components$PricingVersions$Form$formFields(finalForm);
									var cmd = $author$project$Components$PricingVersions$Form$debounceCalculate(newFormFields);
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{
												SD: $elm$core$Maybe$Just(finalForm)
											}),
										cmd);
								} else {
									var calculateOpts = $author$project$Components$Plan$BasicForm$calculateOpts(field);
									return calculateOpts.abg ? A4($author$project$Components$PricingVersions$Form$calculate, model, plan, newForm, calculateOpts) : _Utils_Tuple2(
										_Utils_update(
											model,
											{
												SD: $elm$core$Maybe$Just(newForm)
											}),
										$elm$core$Platform$Cmd$none);
								}
							}
						}();
						var newModel = _v51.a;
						var formCmd = _v51.b;
						return _Utils_Tuple3(
							newModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										formCmd,
										A2($elm$core$Platform$Cmd$map, $author$project$Components$PricingVersions$Form$BasicPlanFormUpdated, newBasicPlanResult.GZ)
									])),
							newBasicPlanResult.aR);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				case 8:
					var planFormMsg = msg.a;
					var _v54 = _Utils_Tuple2(model.SD, model.l);
					if ((!_v54.a.$) && (_v54.b.$ === 3)) {
						var form = _v54.a.a;
						var _v55 = _v54.b;
						var plan = _v55.a;
						var specialRatesForm = function () {
							var _v58 = form.dL;
							if (!_v58.$) {
								var existingForm = _v58.a;
								return existingForm;
							} else {
								var maybePricingVersion = function () {
									var _v59 = model.pl;
									if (_v59.$ === 3) {
										var pricingVersion = _v59.a;
										return $elm$core$Maybe$Just(pricingVersion);
									} else {
										return $elm$core$Maybe$Nothing;
									}
								}();
								return A3($author$project$Components$Plan$Form$SpecialRatesFields$fillFromCurrentForm, $elm$core$Maybe$Nothing, plan, maybePricingVersion);
							}
						}();
						var sharedFields = A2(
							$author$project$Components$PricingVersions$Form$initSharedFields,
							$elm$core$Maybe$Just(plan),
							form);
						var newSpecialRatesResult = A3($author$project$Components$Plan$Form$SpecialRatesFields$update, sharedFields, planFormMsg, specialRatesForm);
						var _v56 = function () {
							var _v57 = newSpecialRatesResult.agZ;
							var field = _v57;
							var newForm = _Utils_update(
								form,
								{
									dL: $elm$core$Maybe$Just(newSpecialRatesResult.aiO)
								});
							return $author$project$Components$Plan$Form$SpecialRatesFields$calculateOpts(field).abg ? A4(
								$author$project$Components$PricingVersions$Form$calculate,
								model,
								plan,
								newForm,
								$author$project$Components$Plan$Form$SpecialRatesFields$calculateOpts(field)) : _Utils_Tuple2(
								_Utils_update(
									model,
									{
										SD: $elm$core$Maybe$Just(newForm)
									}),
								$elm$core$Platform$Cmd$none);
						}();
						var newModel = _v56.a;
						var formCmd = _v56.b;
						return _Utils_Tuple3(
							newModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($elm$core$Platform$Cmd$map, $author$project$Components$PricingVersions$Form$SpecialRatesFieldsUpdated, newSpecialRatesResult.GZ),
										formCmd
									])),
							newSpecialRatesResult.aR);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				case 5:
					var planFormMsg = msg.a;
					var _v60 = _Utils_Tuple2(model.SD, model.l);
					if ((!_v60.a.$) && (_v60.b.$ === 3)) {
						var form = _v60.a.a;
						var _v61 = _v60.b;
						var plan = _v61.a;
						var sharedFields = A2(
							$author$project$Components$PricingVersions$Form$initSharedFields,
							$elm$core$Maybe$Just(plan),
							form);
						var newMembershipPricingResult = A3($author$project$Components$Plan$Form$IndividualMembershipPricingFields$update, sharedFields, planFormMsg, form.dq);
						var _v62 = function () {
							var _v63 = newMembershipPricingResult.agZ;
							if (!_v63.$) {
								var field = _v63.a;
								var newForm = _Utils_update(
									form,
									{dq: newMembershipPricingResult.aiO});
								return $author$project$Components$Plan$Form$IndividualMembershipPricingFields$calculateOpts(field).abg ? A4(
									$author$project$Components$PricingVersions$Form$calculate,
									model,
									plan,
									newForm,
									$author$project$Components$Plan$Form$IndividualMembershipPricingFields$calculateOpts(field)) : _Utils_Tuple2(
									_Utils_update(
										model,
										{
											SD: $elm$core$Maybe$Just(newForm)
										}),
									$elm$core$Platform$Cmd$none);
							} else {
								var newForm = _Utils_update(
									form,
									{dq: newMembershipPricingResult.aiO});
								var _v64 = A3(
									$author$project$Components$PricingVersions$Form$update,
									apiClient,
									$author$project$Components$PricingVersions$Form$ToggleFixedMembershipPricing,
									_Utils_update(
										model,
										{
											SD: $elm$core$Maybe$Just(newForm)
										}));
								var updatedModel = _v64.a;
								var updatedCmd = _v64.b;
								return _Utils_Tuple2(updatedModel, updatedCmd);
							}
						}();
						var newModel = _v62.a;
						var formCmd = _v62.b;
						return _Utils_Tuple3(
							newModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($elm$core$Platform$Cmd$map, $author$project$Components$PricingVersions$Form$IndividualMembershipPricingFieldsUpdated, newMembershipPricingResult.GZ),
										formCmd
									])),
							newMembershipPricingResult.aR);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				case 6:
					var planFormMsg = msg.a;
					var _v65 = _Utils_Tuple2(model.SD, model.l);
					if ((!_v65.a.$) && (_v65.b.$ === 3)) {
						var form = _v65.a.a;
						var _v66 = _v65.b;
						var plan = _v66.a;
						var newFamilyMembershipPricingResult = A3(
							$author$project$Components$Plan$Form$FamilyMembershipPricingFields$update,
							planFormMsg,
							form.dm,
							$elm$core$Maybe$Just(plan));
						var _v67 = function () {
							var _v68 = newFamilyMembershipPricingResult.agZ;
							if (!_v68.$) {
								var groupPricingType = _v68.a;
								var newForm = _Utils_update(
									form,
									{dm: newFamilyMembershipPricingResult.aiO});
								var finalForm = _Utils_update(
									newForm,
									{S1: groupPricingType});
								return A4(
									$author$project$Components$PricingVersions$Form$calculate,
									model,
									plan,
									finalForm,
									{abg: true, aed: false});
							} else {
								var field = _v68.a;
								var newForm = _Utils_update(
									form,
									{dm: newFamilyMembershipPricingResult.aiO});
								return $author$project$Components$Plan$Form$FamilyMembershipPricingFields$calculateOpts(field).abg ? A4(
									$author$project$Components$PricingVersions$Form$calculate,
									model,
									plan,
									newForm,
									$author$project$Components$Plan$Form$FamilyMembershipPricingFields$calculateOpts(field)) : _Utils_Tuple2(
									_Utils_update(
										model,
										{
											SD: $elm$core$Maybe$Just(newForm)
										}),
									$elm$core$Platform$Cmd$none);
							}
						}();
						var newModel = _v67.a;
						var formCmd = _v67.b;
						return _Utils_Tuple3(
							newModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($elm$core$Platform$Cmd$map, $author$project$Components$PricingVersions$Form$FamilyMembershipPricingFieldsUpdated, newFamilyMembershipPricingResult.GZ),
										formCmd
									])),
							newFamilyMembershipPricingResult.aR);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				case 7:
					var planFormMsg = msg.a;
					var _v69 = model.SD;
					if (!_v69.$) {
						var form = _v69.a;
						var maybePlan = function () {
							var _v76 = model.l;
							if (_v76.$ === 3) {
								var plan = _v76.a;
								return $elm$core$Maybe$Just(plan);
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}();
						var sharedFields = A2($author$project$Components$PricingVersions$Form$initSharedFields, maybePlan, form);
						var newGroupTierPricingResult = A3($author$project$Components$Plan$Form$GroupTierPricingFields$update, sharedFields, planFormMsg, form.k);
						var newForm = _Utils_update(
							form,
							{k: newGroupTierPricingResult.aiO});
						var _v70 = newGroupTierPricingResult.agZ;
						if (_v70.$ === 1) {
							var $temp$apiClient = apiClient,
								$temp$msg = $author$project$Components$PricingVersions$Form$ToggleFixedMembershipPricing,
								$temp$_v0 = _Utils_update(
								model,
								{
									SD: $elm$core$Maybe$Just(newForm)
								});
							apiClient = $temp$apiClient;
							msg = $temp$msg;
							_v0 = $temp$_v0;
							continue update;
						} else {
							var field = _v70.a;
							var updatedModel = _Utils_update(
								model,
								{
									SD: $elm$core$Maybe$Just(newForm)
								});
							var calculateOpts = $author$project$Components$Plan$Form$GroupTierPricingFields$calculateOpts(field);
							var shouldActuallyCalculate = function () {
								if (field.$ === 12) {
									var ruleType = field.a;
									var tierFormFields = $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(newForm.k);
									switch (ruleType) {
										case 0:
											return !_Utils_eq(tierFormFields.Sw, $elm$core$Maybe$Nothing);
										case 1:
											return !_Utils_eq(tierFormFields.R8, $elm$core$Maybe$Nothing);
										default:
											return !_Utils_eq(tierFormFields.S0, $elm$core$Maybe$Nothing);
									}
								} else {
									return calculateOpts.abg;
								}
							}();
							var _v71 = function () {
								if (shouldActuallyCalculate) {
									var _v72 = model.l;
									if (_v72.$ === 3) {
										var plan = _v72.a;
										var updateResult = A3($author$project$Components$Plan$Form$GroupTierPricingFields$updateDefaultPeriod, sharedFields, sharedFields.P6, newGroupTierPricingResult.aiO);
										var calculatedForm = _Utils_update(
											newForm,
											{k: updateResult.aiO});
										var _v73 = A4($author$project$Components$PricingVersions$Form$calculate, updatedModel, plan, calculatedForm, calculateOpts);
										var calcModel = _v73.a;
										var calcCmd = _v73.b;
										return _Utils_Tuple2(
											calcModel,
											$elm$core$Platform$Cmd$batch(
												_List_fromArray(
													[
														A2($elm$core$Platform$Cmd$map, $author$project$Components$PricingVersions$Form$GroupTierPricingFieldsUpdated, newGroupTierPricingResult.GZ),
														A2($elm$core$Platform$Cmd$map, $author$project$Components$PricingVersions$Form$GroupTierPricingFieldsUpdated, updateResult.GZ),
														calcCmd
													])));
									} else {
										return _Utils_Tuple2(
											updatedModel,
											A2($elm$core$Platform$Cmd$map, $author$project$Components$PricingVersions$Form$GroupTierPricingFieldsUpdated, newGroupTierPricingResult.GZ));
									}
								} else {
									return _Utils_Tuple2(
										updatedModel,
										A2($elm$core$Platform$Cmd$map, $author$project$Components$PricingVersions$Form$GroupTierPricingFieldsUpdated, newGroupTierPricingResult.GZ));
								}
							}();
							var calculatedModel = _v71.a;
							var calculatedCmd = _v71.b;
							return _Utils_Tuple3(calculatedModel, calculatedCmd, newGroupTierPricingResult.aR);
						}
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				case 10:
					var _v77 = _Utils_Tuple2(model.SD, model.l);
					if ((!_v77.a.$) && (_v77.b.$ === 3)) {
						var form = _v77.a.a;
						var _v78 = _v77.b;
						var plan = _v78.a;
						var newGroupPricingType = (form.S1 === 'fixed_pricing') ? 'family' : 'fixed_pricing';
						var newForm = _Utils_update(
							form,
							{S1: newGroupPricingType});
						var calculateOpts = {abg: true, aed: false};
						return function (_v79) {
							var newModel = _v79.a;
							var cmd = _v79.b;
							return _Utils_Tuple3(newModel, cmd, _List_Nil);
						}(
							A4($author$project$Components$PricingVersions$Form$calculate, model, plan, newForm, calculateOpts));
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				case 11:
					return _Utils_Tuple3(
						model,
						A2(
							$author$project$Utils$Route$navigate,
							$elm$core$Dict$empty,
							$author$project$Components$PricingVersions$Form$planRoute(model.My)),
						_List_Nil);
				case 12:
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 2, 'dummy delete')
							]));
				case 13:
					var _v80 = _Utils_Tuple2(model.SD, model.l);
					if ((!_v80.a.$) && (_v80.b.$ === 3)) {
						var form = _v80.a.a;
						var _v81 = _v80.b;
						var plan = _v81.a;
						var validatedForm = A3(
							$author$project$Components$PricingVersions$Form$validateFormFields,
							$elm$core$Maybe$Just(plan),
							model.ZV,
							form);
						var specialRatesHasErrors = function () {
							var _v83 = validatedForm.dL;
							if (!_v83.$) {
								var specialRatesForm = _v83.a;
								return $author$project$Components$Plan$Form$SpecialRatesFields$hasErrors(specialRatesForm);
							} else {
								return false;
							}
						}();
						var newForm = _Utils_update(
							validatedForm,
							{ba: true, r: true});
						var nameErrors = $author$project$Components$PricingVersions$Form$validatePricingVersionName(validatedForm.Bq);
						var individualPricingHasErrors = $author$project$Components$Plan$Form$IndividualMembershipPricingFields$hasErrors(validatedForm.dq);
						var groupTierPricingHasErrors = $author$project$Components$Plan$Form$GroupTierPricingFields$hasErrors(validatedForm.k);
						var familyPricingHasErrors = $author$project$Components$Plan$Form$FamilyMembershipPricingFields$hasErrors(validatedForm.dm);
						var effectiveDateErrors = A2($author$project$Components$PricingVersions$Form$validateEffectiveDate, true, validatedForm.Q7);
						var basicPlanHasErrors = $author$project$Components$Plan$BasicForm$hasErrors(validatedForm.ab);
						var hasErrors = (!($elm$core$List$isEmpty(nameErrors) && $elm$core$List$isEmpty(effectiveDateErrors))) || (basicPlanHasErrors || (individualPricingHasErrors || (familyPricingHasErrors || (groupTierPricingHasErrors || specialRatesHasErrors))));
						if (hasErrors) {
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										SD: $elm$core$Maybe$Just(newForm),
										hI: true
									}),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
						} else {
							var pricingVersionName = newForm.Bq;
							var planUpdateFields = function () {
								var isCreate = _Utils_eq(model.akh, $elm$core$Maybe$Nothing);
								var fields = $author$project$Components$PricingVersions$Form$updatePlanFieldsForSave(
									$author$project$Components$PricingVersions$Form$formFields(newForm));
								return isCreate ? _Utils_update(
									fields,
									{
										abT: A2(
											$elm$core$List$map,
											function (sr) {
												return _Utils_update(
													sr,
													{O0: true, Qv: false, ahP: $elm$core$Maybe$Nothing});
											},
											A2(
												$elm$core$List$filter,
												function (sr) {
													return !sr.Qv;
												},
												fields.abT))
									}) : fields;
							}();
							var planId = $author$project$Api$Provider$Plan$One$id(plan);
							var effectiveDateString = A2(
								$elm$core$Maybe$withDefault,
								'',
								A2($elm$core$Maybe$map, $author$project$Utils$Date$toQuery, newForm.Q7));
							var currentBasicPlanFields = $author$project$Components$Plan$BasicForm$formFields(newForm.ab);
							var editedRegistrationFeeCategoryId = $author$project$Components$Plan$Form$RegistrationFeePricingFields$getCategoryId(currentBasicPlanFields.dH);
							var editedRegistrationFeeDescription = currentBasicPlanFields.DM;
							var editedRegistrationFeeName = currentBasicPlanFields.DN;
							var createFields = {LW: newForm.LW, zi: newForm.zi, Q7: effectiveDateString, S_: newForm.S_, S1: newForm.S1, Bq: pricingVersionName, ZD: planUpdateFields, DL: editedRegistrationFeeCategoryId, DM: editedRegistrationFeeDescription, DN: editedRegistrationFeeName};
							var saveCmd = function () {
								var _v82 = model.akh;
								if (!_v82.$) {
									var pvId = _v82.a;
									return A5($author$project$Api$Provider$PricingVersion$update, apiClient, planId, pvId, createFields, $author$project$Components$PricingVersions$Form$PricingVersionUpdated);
								} else {
									return A4($author$project$Api$Provider$PricingVersion$create, apiClient, planId, createFields, $author$project$Components$PricingVersions$Form$PricingVersionCreated);
								}
							}();
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										SD: $elm$core$Maybe$Just(newForm),
										hI: false
									}),
								saveCmd,
								_List_Nil);
						}
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				case 14:
					var response = msg.a;
					switch (response.$) {
						case 3:
							return _Utils_Tuple3(
								model,
								A2(
									$author$project$Utils$Route$navigate,
									$elm$core$Dict$empty,
									$author$project$Components$PricingVersions$Form$planRoute(model.My)),
								_List_fromArray(
									[
										A2($author$project$OutMsg$ShowToast, 3, 'Price change created successfully')
									]));
						case 2:
							var error = response.a;
							return _Utils_Tuple3(
								model,
								$elm$core$Platform$Cmd$none,
								_List_fromArray(
									[
										A2(
										$author$project$OutMsg$ShowToast,
										1,
										$author$project$Ui$Toast$serverError(error))
									]));
						default:
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				case 15:
					var response = msg.a;
					switch (response.$) {
						case 3:
							return _Utils_Tuple3(
								model,
								A2(
									$author$project$Utils$Route$navigate,
									$elm$core$Dict$empty,
									$author$project$Components$PricingVersions$Form$planRoute(model.My)),
								_List_fromArray(
									[
										A2($author$project$OutMsg$ShowToast, 3, 'Price change updated successfully')
									]));
						case 2:
							var error = response.a;
							return _Utils_Tuple3(
								model,
								$elm$core$Platform$Cmd$none,
								_List_fromArray(
									[
										A2(
										$author$project$OutMsg$ShowToast,
										1,
										$author$project$Ui$Toast$serverError(error))
									]));
						default:
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				case 16:
					var subMsg = msg.a;
					var _v86 = A4(
						$jinjor$elm_debounce$Debounce$update,
						$author$project$Components$PricingVersions$Form$previewDebounceConfig,
						$jinjor$elm_debounce$Debounce$takeLast($author$project$Components$PricingVersions$Form$debounceCalculate),
						subMsg,
						model.eW);
					var newDebouncer = _v86.a;
					var debouncerCmd = _v86.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{eW: newDebouncer}),
						debouncerCmd,
						_List_Nil);
				case 17:
					var pricingFormFields = msg.a;
					var _v87 = model.l;
					if (_v87.$ === 3) {
						var previousPreviewId = model.akd.a;
						var previewId = previousPreviewId + 1;
						var tracker = 'pricing_version_preview_' + $elm$core$String$fromInt(previewId);
						var planUpdateFields = $author$project$Components$PricingVersions$Form$updatePlanFieldsForCalculate(pricingFormFields);
						var calculateCmd = function () {
							var _v88 = model.akh;
							if (!_v88.$) {
								var pvId = _v88.a;
								var effectiveDateString = A2(
									$elm$core$Maybe$withDefault,
									'',
									A2($elm$core$Maybe$map, $author$project$Utils$Date$toQuery, pricingFormFields.Q7));
								var basicPlanFormFields = $author$project$Components$Plan$BasicForm$formFields(pricingFormFields.ab);
								var createFields = {
									LW: pricingFormFields.LW,
									zi: pricingFormFields.zi,
									Q7: effectiveDateString,
									S_: pricingFormFields.S_,
									S1: pricingFormFields.S1,
									Bq: pricingFormFields.Bq,
									ZD: planUpdateFields,
									DL: $author$project$Components$Plan$Form$RegistrationFeePricingFields$getCategoryId(basicPlanFormFields.dH),
									DM: basicPlanFormFields.DM,
									DN: basicPlanFormFields.DN
								};
								return A7(
									$author$project$Api$Provider$PricingVersion$calculate,
									apiClient,
									model.My,
									pvId,
									_List_fromArray(
										[1]),
									tracker,
									createFields,
									$author$project$Components$PricingVersions$Form$GotPreview(previewId));
							} else {
								return A6(
									$author$project$Api$Provider$Plan$calculate,
									apiClient,
									_List_fromArray(
										[1]),
									tracker,
									model.My,
									planUpdateFields,
									$author$project$Components$PricingVersions$Form$GotPreview(previewId));
							}
						}();
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									akd: _Utils_Tuple2(previewId, $author$project$Api$Data$Loading)
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										calculateCmd,
										$elm$http$Http$cancel(
										'pricing_version_preview_' + $elm$core$String$fromInt(previousPreviewId))
									])),
							_List_Nil);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				default:
					var previewId = msg.a;
					var response = msg.b;
					if (_Utils_eq(model.akd.a, previewId)) {
						switch (response.$) {
							case 3:
								var calculatedPlan = response.a;
								var maybePricingVersion = function () {
									var _v93 = model.pl;
									if (_v93.$ === 3) {
										var pv = _v93.a;
										return $elm$core$Maybe$Just(pv);
									} else {
										return $elm$core$Maybe$Nothing;
									}
								}();
								var currentSpecialRatesForm = A2(
									$elm$core$Maybe$andThen,
									function ($) {
										return $.dL;
									},
									model.SD);
								var _v90 = A6($author$project$Components$PricingVersions$Form$initFormFieldsWithSpecialRates, apiClient, model.aa4, model.ZV, calculatedPlan, maybePricingVersion, currentSpecialRatesForm);
								var calculatedForm = _v90.a;
								var calculatedFormCmd = _v90.b;
								var newForm = function () {
									var _v91 = model.SD;
									if (!_v91.$) {
										var existingForm = _v91.a;
										return _Utils_update(
											calculatedForm,
											{
												ab: existingForm.ab,
												zi: existingForm.zi,
												Q7: existingForm.Q7,
												ba: existingForm.ba,
												SZ: A3(
													$elm$core$List$map2,
													F2(
														function (calculated, existing) {
															var isPercentValid = function (maybePercent) {
																if (!maybePercent.$) {
																	var percent = maybePercent.a;
																	return A2(
																		$author$project$Percentage$isValid,
																		{
																			AU: $elm$core$Maybe$Just(100),
																			W9: $elm$core$Maybe$Just(0)
																		},
																		percent);
																} else {
																	return true;
																}
															};
															return _Utils_update(
																calculated,
																{
																	LK: existing.LK,
																	Gs: false,
																	LP: (existing.LQ && (!isPercentValid(existing.LP))) ? existing.LP : calculated.LP,
																	LQ: existing.LQ,
																	rj: false,
																	Xm: existing.Xm,
																	IC: false,
																	Xs: (existing.Xt && (!isPercentValid(existing.Xs))) ? existing.Xs : calculated.Xs,
																	Xt: existing.Xt,
																	oH: false,
																	_T: existing._T,
																	Jq: false,
																	_Y: (existing._Z && (!isPercentValid(existing._Y))) ? existing._Y : calculated._Y,
																	_Z: existing._Z,
																	t7: false,
																	aaM: existing.aaM,
																	JG: false,
																	aaR: (existing.aaS && (!isPercentValid(existing.aaR))) ? existing.aaR : calculated.aaR,
																	aaS: existing.aaS,
																	uv: false
																});
														}),
													calculatedForm.SZ,
													existingForm.SZ),
												Bq: existingForm.Bq,
												r: existingForm.r
											});
									} else {
										return calculatedForm;
									}
								}();
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											SD: $elm$core$Maybe$Just(newForm),
											akd: _Utils_Tuple2(previewId, response)
										}),
									calculatedFormCmd,
									_List_Nil);
							case 2:
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											akd: _Utils_Tuple2(previewId, response)
										}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							case 1:
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											akd: _Utils_Tuple2(previewId, response)
										}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							default:
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											akd: _Utils_Tuple2(previewId, response)
										}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
						}
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
			}
		}
	});
var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$New$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$PricingVersions$Form$update, model.Gv, subMsg, model.SD);
		var newForm = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{SD: newForm}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Components$PricingVersions$Form$Delete = {$: 12};
var $author$project$Components$PricingVersions$Form$NavigateBack = {$: 11};
var $author$project$Components$PricingVersions$Form$Save = {$: 13};
var $author$project$Ui$Button$Close = {$: 10};
var $author$project$Ui$Button$close = $author$project$Ui$Button$Close;
var $author$project$Components$PricingVersions$Form$hasAnyValidationErrors = F3(
	function (_v0, _v1, form) {
		var specialRatesHasErrors = function () {
			var _v2 = form.dL;
			if (!_v2.$) {
				var specialRatesForm = _v2.a;
				return $author$project$Components$Plan$Form$SpecialRatesFields$hasErrors(specialRatesForm);
			} else {
				return false;
			}
		}();
		var nameErrors = $author$project$Components$PricingVersions$Form$validatePricingVersionName(form.Bq);
		var individualPricingHasErrors = $author$project$Components$Plan$Form$IndividualMembershipPricingFields$hasErrors(form.dq);
		var groupTierPricingHasErrors = $author$project$Components$Plan$Form$GroupTierPricingFields$hasErrors(form.k);
		var groupDiscountRulesHaveErrors = false;
		var familyPricingHasErrors = $author$project$Components$Plan$Form$FamilyMembershipPricingFields$hasErrors(form.dm);
		var effectiveDateErrors = A2($author$project$Components$PricingVersions$Form$validateEffectiveDate, form.ba, form.Q7);
		var basicPlanHasErrors = $author$project$Components$Plan$BasicForm$hasErrors(form.ab);
		return (!($elm$core$List$isEmpty(nameErrors) && $elm$core$List$isEmpty(effectiveDateErrors))) || (basicPlanHasErrors || (individualPricingHasErrors || (familyPricingHasErrors || (groupTierPricingHasErrors || (specialRatesHasErrors || groupDiscountRulesHaveErrors)))));
	});
var $author$project$Components$PricingVersions$Form$NameChanged = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Plan$BasicForm$hasRegistrationFeeNameError = function (_v0) {
	var form = _v0.b;
	return A2($author$project$Utils$Form$hasValidationErrors, 8, form);
};
var $author$project$Components$Plan$BasicForm$registrationFeeNameErrors = function (_v0) {
	var form = _v0.b;
	return A2($author$project$Utils$Form$validationErrors, 8, form);
};
var $author$project$Components$PricingVersions$Form$viewBasicPlanFieldsForPricingVersion = F2(
	function (basicPlan, _v0) {
		var fields = $author$project$Components$Plan$BasicForm$formFields(basicPlan);
		return _List_fromArray(
			[
				A4(
				$author$project$Components$Plan$Form$RegistrationFeePricingFields$viewRegistrationFeePricingFields,
				{
					Ns: fields.ub,
					jB: fields.jB,
					nr: fields.nr,
					ahC: $author$project$Components$Plan$BasicForm$hasRegistrationFeeNameError(basicPlan),
					ajg: $author$project$Components$Plan$BasicForm$EditRegistrationFeeCategory,
					ajh: $author$project$Components$Plan$BasicForm$EditRegistrationFeeDescription,
					ajr: $author$project$Components$Plan$BasicForm$RegistrationFeeDescription,
					ajs: $author$project$Components$Plan$BasicForm$RegistrationFeeName,
					DM: fields.DM,
					DN: fields.DN,
					akE: $author$project$Components$Plan$BasicForm$registrationFeeNameErrors(basicPlan)
				},
				$author$project$Components$Plan$BasicForm$FormUpdated,
				$author$project$Components$Plan$BasicForm$RegistrationFeePricingFieldsMsg,
				fields.dH)
			]);
	});
var $author$project$Components$PricingVersions$Form$DiscountsEnabled = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$PricingVersions$Form$FormUpdated = function (a) {
	return {$: 9, a: a};
};
var $author$project$Ui$Form$Radio$Inline = {$: 2};
var $author$project$Ui$Form$Radio$inline = $author$project$Ui$Form$Radio$Inline;
var $author$project$Components$PricingVersions$Form$viewFamilyDiscountsToggle = function (form) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Typography$headingSm(
				_List_fromArray(
					[
						$elm$html$Html$text('Do you offer discounts to family members who enroll together?'),
						$author$project$Utils$Html$noBreakSpace,
						A2(
						$elm$html$Html$map,
						$elm$core$Basics$never,
						$author$project$Ui$SupportDocumentLink$view('https://support.hint.com/account-configuration/configuring-your-membership-rates-and-billing-options'))
					])),
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanSm(1)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Radio$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Radio$value(form.zi),
										$author$project$Ui$Form$Radio$onCheck(
										A2(
											$elm$core$Basics$composeL,
											$author$project$Components$PricingVersions$Form$FormUpdated,
											$elm$core$Basics$always(
												$author$project$Components$PricingVersions$Form$DiscountsEnabled(true))))
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Yes')
											]))
									]))
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanSm(1)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Radio$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Radio$value(!form.zi),
										$author$project$Ui$Form$Radio$inline,
										$author$project$Ui$Form$Radio$onCheck(
										A2(
											$elm$core$Basics$composeL,
											$author$project$Components$PricingVersions$Form$FormUpdated,
											$elm$core$Basics$always(
												$author$project$Components$PricingVersions$Form$DiscountsEnabled(false))))
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('No')
											]))
									]))
							]))
					])),
				$author$project$Utils$Html$noBreakSpace
			]));
};
var $author$project$Components$PricingVersions$Form$viewFamilyMembershipPricing = F3(
	function (sharedFields, plan, form) {
		var discountsEnabled = form.zi;
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Components$PricingVersions$Form$viewFamilyDiscountsToggle(form),
					function () {
					if (discountsEnabled) {
						var familyMembershipPricingForm = form.dm;
						return A2(
							$elm$html$Html$map,
							$author$project$Components$PricingVersions$Form$FamilyMembershipPricingFieldsUpdated,
							A3(
								$author$project$Components$Plan$Form$FamilyMembershipPricingFields$view,
								sharedFields,
								$elm$core$Maybe$Just(plan),
								familyMembershipPricingForm));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]));
	});
var $author$project$Components$PricingVersions$Form$AppliesGroupDiscountInTiers = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$PricingVersions$Form$GroupDiscountRuleAdd = {$: 4};
var $author$project$Components$PricingVersions$Form$GroupPricingType = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$PricingVersions$Form$ToggleGroupDiscountRulesCalculatedBy = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$PricingVersions$Form$GroupDiscountRuleFromSize = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Components$PricingVersions$Form$GroupDiscountRuleRemove = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$PricingVersions$Form$GroupDiscountRuleToSize = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Components$PricingVersions$Form$groupDiscountRuleSizeOptions = function (start) {
	return A2(
		$elm$core$List$map,
		function (size) {
			return A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(
					$elm$core$String$fromInt(size)),
				A2($author$project$Formatters$String$pluralize, 'Member', size));
		},
		A2($elm$core$List$range, start, 9));
};
var $author$project$Components$PricingVersions$Form$GroupDiscountRuleAmountOffInCents = F3(
	function (a, b, c) {
		return {$: 8, a: a, b: b, c: c};
	});
var $author$project$Components$PricingVersions$Form$GroupDiscountRuleAmountOffInCentsEdit = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Components$PricingVersions$Form$GroupDiscountRuleAmountOffInCentsReset = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Components$PricingVersions$Form$GroupDiscountRuleAmountOffInCentsValidation = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$PricingVersions$Form$validateGroupDiscountRuleAmountOffInCents = F3(
	function (index, period, form) {
		var groupDiscountRule = A2($elm_community$list_extra$List$Extra$getAt, index, form.SZ);
		var defaultPeriod = function () {
			var basicFields = $author$project$Components$Plan$BasicForm$formFields(form.ab);
			return (basicFields.P6 === 'annual') ? 'annual' : 'month';
		}();
		var _v0 = function () {
			var _v1 = _Utils_Tuple2(groupDiscountRule, period);
			_v1$4:
			while (true) {
				if (!_v1.a.$) {
					switch (_v1.b) {
						case 'month':
							var rule = _v1.a.a;
							return _Utils_Tuple2(rule.Xl, rule.Xm);
						case 'quarter':
							var rule = _v1.a.a;
							return _Utils_Tuple2(rule._S, rule._T);
						case 'semi_annual':
							var rule = _v1.a.a;
							return _Utils_Tuple2(rule.aaL, rule.aaM);
						case 'annual':
							var rule = _v1.a.a;
							return _Utils_Tuple2(rule.LJ, rule.LK);
						default:
							break _v1$4;
					}
				} else {
					break _v1$4;
				}
			}
			return _Utils_Tuple2($elm$core$Maybe$Nothing, false);
		}();
		var periodAmount = _v0.a;
		var periodEdited = _v0.b;
		if (_Utils_eq(defaultPeriod, period) || periodEdited) {
			if (periodAmount.$ === 1) {
				return _List_fromArray(
					['Please enter an amount.']);
			} else {
				var amount = periodAmount.a;
				var min = 0;
				var max = 999999999;
				var amountInt = A2(
					$elm$core$Maybe$withDefault,
					0,
					$author$project$Currency$toInt(amount));
				return ((_Utils_cmp(amountInt, min) < 0) || (_Utils_cmp(amountInt, max) > 0)) ? _List_fromArray(
					[
						'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.')))
					]) : _List_Nil;
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$PricingVersions$Form$validateGroupDiscountRulePercentOff = F3(
	function (index, period, form) {
		var groupDiscountRule = A2($elm_community$list_extra$List$Extra$getAt, index, form.SZ);
		var defaultPeriod = function () {
			var basicFields = $author$project$Components$Plan$BasicForm$formFields(form.ab);
			return (basicFields.P6 === 'annual') ? 'annual' : 'month';
		}();
		var _v0 = function () {
			var _v1 = _Utils_Tuple2(groupDiscountRule, period);
			_v1$4:
			while (true) {
				if (!_v1.a.$) {
					switch (_v1.b) {
						case 'month':
							var rule = _v1.a.a;
							return _Utils_Tuple2(rule.Xs, rule.Xt);
						case 'quarter':
							var rule = _v1.a.a;
							return _Utils_Tuple2(rule._Y, rule._Z);
						case 'semi_annual':
							var rule = _v1.a.a;
							return _Utils_Tuple2(rule.aaR, rule.aaS);
						case 'annual':
							var rule = _v1.a.a;
							return _Utils_Tuple2(rule.LP, rule.LQ);
						default:
							break _v1$4;
					}
				} else {
					break _v1$4;
				}
			}
			return _Utils_Tuple2($elm$core$Maybe$Nothing, false);
		}();
		var periodPercent = _v0.a;
		var periodEdited = _v0.b;
		if (_Utils_eq(defaultPeriod, period) || periodEdited) {
			if (periodPercent.$ === 1) {
				return _List_fromArray(
					['Please enter a percentage.']);
			} else {
				var percent = periodPercent.a;
				var min = 0;
				var max = 100;
				return (!A2(
					$author$project$Percentage$isValid,
					{
						AU: $elm$core$Maybe$Just(max),
						W9: $elm$core$Maybe$Just(min)
					},
					percent)) ? _List_fromArray(
					[
						'Please enter a percentage between ' + ($author$project$Formatters$Float$toPercentage(min) + (' and ' + ($author$project$Formatters$Float$toPercentage(max) + '.')))
					]) : _List_Nil;
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$PricingVersions$Form$validationErrors = F2(
	function (validationGroup, form) {
		if (!validationGroup.$) {
			var index = validationGroup.a;
			var period = validationGroup.b;
			return form.r ? A3($author$project$Components$PricingVersions$Form$validateGroupDiscountRuleAmountOffInCents, index, period, form) : _List_Nil;
		} else {
			var index = validationGroup.a;
			var period = validationGroup.b;
			return form.r ? A3($author$project$Components$PricingVersions$Form$validateGroupDiscountRulePercentOff, index, period, form) : _List_Nil;
		}
	});
var $author$project$Components$PricingVersions$Form$hasValidationErrors = F2(
	function (validationGroup, form) {
		return !$elm$core$List$isEmpty(
			A2($author$project$Components$PricingVersions$Form$validationErrors, validationGroup, form));
	});
var $author$project$Components$PricingVersions$Form$viewAmountInCentsPricingRulePeriodForPricingVersions = F5(
	function (_v0, form, index, groupDiscountRule, period) {
		var _v1 = function () {
			switch (period) {
				case 'month':
					return _Utils_Tuple3(groupDiscountRule.Xl, groupDiscountRule.IC, groupDiscountRule.Xm);
				case 'quarter':
					return _Utils_Tuple3(groupDiscountRule._S, groupDiscountRule.Jq, groupDiscountRule._T);
				case 'semi_annual':
					return _Utils_Tuple3(groupDiscountRule.aaL, groupDiscountRule.JG, groupDiscountRule.aaM);
				case 'annual':
					return _Utils_Tuple3(groupDiscountRule.LJ, groupDiscountRule.Gs, groupDiscountRule.LK);
				default:
					return _Utils_Tuple3(groupDiscountRule.Xl, groupDiscountRule.IC, groupDiscountRule.Xm);
			}
		}();
		var periodAmountInCents = _v1.a;
		var editingPeriod = _v1.b;
		var periodEdited = _v1.c;
		var _v3 = $author$project$Components$Plan$BasicForm$formFields(form.ab);
		var defaultPeriod = _v3.P6;
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			(_Utils_eq(defaultPeriod, period) || editingPeriod) ? _List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Formatters$String$humanize(period)),
							$elm$html$Html$text(' discount')
						])),
					$author$project$Ui$Form$CurrencyInput$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$CurrencyInput$value(periodAmountInCents),
							$author$project$Ui$Form$CurrencyInput$onInput(
							A2(
								$elm$core$Basics$composeL,
								$author$project$Components$PricingVersions$Form$FormUpdated,
								A2($author$project$Components$PricingVersions$Form$GroupDiscountRuleAmountOffInCents, index, period))),
							$author$project$Ui$Form$CurrencyInput$invalid(
							A2(
								$author$project$Components$PricingVersions$Form$hasValidationErrors,
								A2($author$project$Components$PricingVersions$Form$GroupDiscountRuleAmountOffInCentsValidation, index, period),
								form))
						])),
					$author$project$Utils$FormErrors$view(
					A2(
						$author$project$Components$PricingVersions$Form$validationErrors,
						A2($author$project$Components$PricingVersions$Form$GroupDiscountRuleAmountOffInCentsValidation, index, period),
						form))
				]) : _List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Formatters$String$humanize(period)),
									$author$project$Utils$Html$noBreakSpace,
									$elm$html$Html$text(
									function () {
										if (!periodAmountInCents.$) {
											var amount = periodAmountInCents.a;
											return $author$project$Currency$format(amount);
										} else {
											return '$0.00';
										}
									}()),
									$elm$html$Html$text(' off')
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									periodEdited ? A3(
									$author$project$Ui$Button$view,
									{mm: 'Reset period amount off'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick(
											$author$project$Components$PricingVersions$Form$FormUpdated(
												A2($author$project$Components$PricingVersions$Form$GroupDiscountRuleAmountOffInCentsReset, index, period)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Reset')
										])) : $author$project$Utils$Html$empty,
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Edit period amount off'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick(
											$author$project$Components$PricingVersions$Form$FormUpdated(
												A2($author$project$Components$PricingVersions$Form$GroupDiscountRuleAmountOffInCentsEdit, index, period)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit')
										]))
								]))
						]))
				]));
	});
var $author$project$Components$PricingVersions$Form$viewAmountInCentsPricingRuleForPricingVersions = F5(
	function (plan, form, periods, index, groupDiscountRule) {
		return A2(
			$elm$core$List$map,
			A4($author$project$Components$PricingVersions$Form$viewAmountInCentsPricingRulePeriodForPricingVersions, plan, form, index, groupDiscountRule),
			periods);
	});
var $author$project$Components$PricingVersions$Form$GroupDiscountRulePercentOff = F3(
	function (a, b, c) {
		return {$: 11, a: a, b: b, c: c};
	});
var $author$project$Components$PricingVersions$Form$GroupDiscountRulePercentOffEdit = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Components$PricingVersions$Form$GroupDiscountRulePercentOffReset = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Components$PricingVersions$Form$GroupDiscountRulePercentOffValidation = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$PricingVersions$Form$viewPercentOffPricingRulePeriodForPricingVersions = F5(
	function (_v0, form, index, groupDiscountRule, period) {
		var _v1 = function () {
			switch (period) {
				case 'month':
					return _Utils_Tuple3(groupDiscountRule.Xs, groupDiscountRule.oH, groupDiscountRule.Xt);
				case 'quarter':
					return _Utils_Tuple3(groupDiscountRule._Y, groupDiscountRule.t7, groupDiscountRule._Z);
				case 'semi_annual':
					return _Utils_Tuple3(groupDiscountRule.aaR, groupDiscountRule.uv, groupDiscountRule.aaS);
				case 'annual':
					return _Utils_Tuple3(groupDiscountRule.LP, groupDiscountRule.rj, groupDiscountRule.LQ);
				default:
					return _Utils_Tuple3(groupDiscountRule.Xs, groupDiscountRule.oH, groupDiscountRule.Xt);
			}
		}();
		var periodPercentOff = _v1.a;
		var editingPeriod = _v1.b;
		var periodEdited = _v1.c;
		var _v3 = $author$project$Components$Plan$BasicForm$formFields(form.ab);
		var defaultPeriod = _v3.P6;
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			(_Utils_eq(defaultPeriod, period) || editingPeriod) ? _List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Formatters$String$humanize(period)),
							$elm$html$Html$text(' discount')
						])),
					$author$project$Ui$Form$PercentageInput$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$PercentageInput$value(periodPercentOff),
							$author$project$Ui$Form$PercentageInput$onInput(
							A2(
								$elm$core$Basics$composeL,
								$author$project$Components$PricingVersions$Form$FormUpdated,
								A2($author$project$Components$PricingVersions$Form$GroupDiscountRulePercentOff, index, period))),
							$author$project$Ui$Form$PercentageInput$invalid(
							A2(
								$author$project$Components$PricingVersions$Form$hasValidationErrors,
								A2($author$project$Components$PricingVersions$Form$GroupDiscountRulePercentOffValidation, index, period),
								form))
						])),
					$author$project$Utils$FormErrors$view(
					A2(
						$author$project$Components$PricingVersions$Form$validationErrors,
						A2($author$project$Components$PricingVersions$Form$GroupDiscountRulePercentOffValidation, index, period),
						form))
				]) : _List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(12)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Formatters$String$humanize(period)),
									$author$project$Utils$Html$noBreakSpace,
									$elm$html$Html$text(
									function () {
										if (!periodPercentOff.$) {
											var percentage = periodPercentOff.a;
											return $author$project$Percentage$format(percentage);
										} else {
											return '0%';
										}
									}()),
									$elm$html$Html$text(' off'),
									periodEdited ? A3(
									$author$project$Ui$Button$view,
									{mm: 'Reset period percent off'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick(
											$author$project$Components$PricingVersions$Form$FormUpdated(
												A2($author$project$Components$PricingVersions$Form$GroupDiscountRulePercentOffReset, index, period)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Reset')
										])) : $author$project$Utils$Html$empty,
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Edit period percent off'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick(
											$author$project$Components$PricingVersions$Form$FormUpdated(
												A2($author$project$Components$PricingVersions$Form$GroupDiscountRulePercentOffEdit, index, period)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit')
										]))
								]))
						]))
				]));
	});
var $author$project$Components$PricingVersions$Form$viewPercentOffPricingRuleForPricingVersions = F5(
	function (plan, form, periods, index, groupDiscountRule) {
		return A2(
			$elm$core$List$map,
			A4($author$project$Components$PricingVersions$Form$viewPercentOffPricingRulePeriodForPricingVersions, plan, form, index, groupDiscountRule),
			periods);
	});
var $author$project$Components$PricingVersions$Form$viewGroupDiscountRule = F4(
	function (plan, form, index, groupDiscountRule) {
		var isFirst = !index;
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					isFirst ? _List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textSm]),
							_List_Nil),
							A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(
									$elm$core$Maybe$Just(
										$elm$core$String$fromInt(groupDiscountRule.SM))),
									$author$project$Ui$Form$Select$onChange(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Components$PricingVersions$Form$FormUpdated,
										$author$project$Components$PricingVersions$Form$GroupDiscountRuleFromSize(index)))
								]),
							$author$project$Components$PricingVersions$Form$groupDiscountRuleSizeOptions(0))
						]) : _List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textSm]),
							_List_Nil),
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(groupDiscountRule.SM))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					(!_Utils_eq(groupDiscountRule.add, $elm$core$Maybe$Nothing)) ? _List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textSm]),
							_List_Nil),
							A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(
									A2($elm$core$Maybe$map, $elm$core$String$fromInt, groupDiscountRule.add)),
									$author$project$Ui$Form$Select$onChange(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Components$PricingVersions$Form$FormUpdated,
										$author$project$Components$PricingVersions$Form$GroupDiscountRuleToSize(index)))
								]),
							$author$project$Components$PricingVersions$Form$groupDiscountRuleSizeOptions(groupDiscountRule.SM))
						]) : _List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textSm]),
							_List_Nil),
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('All Members')
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textSm]),
							_List_Nil),
							(!isFirst) ? A3(
							$author$project$Ui$Button$view,
							{mm: 'Remove group disount rule'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick(
									$author$project$Components$PricingVersions$Form$FormUpdated(
										$author$project$Components$PricingVersions$Form$GroupDiscountRuleRemove(index))),
									$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Remove')
								])) : $author$project$Utils$Html$empty
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					function () {
						var _v0 = groupDiscountRule.M2;
						switch (_v0) {
							case 'amount_off_in_cents':
								return A5(
									$author$project$Components$PricingVersions$Form$viewAmountInCentsPricingRuleForPricingVersions,
									plan,
									form,
									$author$project$Api$Provider$Plan$Meta$allowedPeriodCodes(
										$author$project$Api$Provider$Plan$One$meta(plan)),
									index,
									groupDiscountRule);
							case 'percent_off':
								return A5(
									$author$project$Components$PricingVersions$Form$viewPercentOffPricingRuleForPricingVersions,
									plan,
									form,
									$author$project$Api$Provider$Plan$Meta$allowedPeriodCodes(
										$author$project$Api$Provider$Plan$One$meta(plan)),
									index,
									groupDiscountRule);
							default:
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
										_List_fromArray(
											[
												$elm$html$Html$text('Not set')
											]))
									]);
						}
					}())
				]));
	});
var $author$project$Components$PricingVersions$Form$viewGroupMembershipPricingFields = F2(
	function (plan, form) {
		var discountsEnabled = form.zi;
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Components$PricingVersions$Form$viewFamilyDiscountsToggle(form),
					function () {
					if (discountsEnabled) {
						var groupDiscountRules = form.SZ;
						var groupDiscountRulesCalculatedBy = A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.M2;
							},
							$elm$core$List$head(groupDiscountRules));
						var appliesGroupDiscountInTiers = form.LW;
						var allowNewGroupRule = A2(
							$elm$core$Maybe$withDefault,
							true,
							A2(
								$elm$core$Maybe$map,
								function (lastFromSize) {
									return _Utils_cmp(lastFromSize, $author$project$Components$PricingVersions$Form$maxGroupFromSize) < 0;
								},
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.SM;
									},
									$elm_community$list_extra$List$Extra$last(groupDiscountRules))));
						return A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{mm: 'Switch to family rates'},
											_List_fromArray(
												[
													$author$project$Ui$Button$sm,
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick(
													$author$project$Components$PricingVersions$Form$FormUpdated(
														$author$project$Components$PricingVersions$Form$GroupPricingType('family')))
												]),
											_List_fromArray(
												[
													$author$project$Ui$Icon$transfer(_List_Nil),
													$elm$html$Html$text(' Switch to Family Rates')
												]))
										])),
									A2(
									$author$project$Ui$Grid$row,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$offset(1)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Form$Radio$view,
															_List_fromArray(
																[
																	$author$project$Ui$Form$Radio$value(appliesGroupDiscountInTiers),
																	$author$project$Ui$Form$Radio$onCheck(
																	A2(
																		$elm$core$Basics$composeL,
																		$author$project$Components$PricingVersions$Form$FormUpdated,
																		$elm$core$Basics$always(
																			$author$project$Components$PricingVersions$Form$AppliesGroupDiscountInTiers(true))))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Apply Discounts in Tiers.'),
																	A2(
																	$author$project$Ui$Element$view,
																	_List_fromArray(
																		[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted, $author$project$Ui$Element$fontBold]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Per member discount will apply to members depending on which range they are in')
																		]))
																]))
														])),
													A2(
													$author$project$Ui$Element$view,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Form$Radio$view,
															_List_fromArray(
																[
																	$author$project$Ui$Form$Radio$value(!appliesGroupDiscountInTiers),
																	$author$project$Ui$Form$Radio$onCheck(
																	A2(
																		$elm$core$Basics$composeL,
																		$author$project$Components$PricingVersions$Form$FormUpdated,
																		$elm$core$Basics$always(
																			$author$project$Components$PricingVersions$Form$AppliesGroupDiscountInTiers(false))))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Apply Same Discount to Entire Group'),
																	A2(
																	$author$project$Ui$Element$view,
																	_List_fromArray(
																		[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted, $author$project$Ui$Element$fontBold]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Per member discount from the last added member will apply to all members in group')
																		]))
																]))
														]))
												]))
										])),
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$offsetLabel,
											$author$project$Ui$Form$Group$labelSpanSm(5),
											$author$project$Ui$Form$Group$inputSpanSm(6),
											$author$project$Ui$Form$Group$label('Default Discount Type'),
											$author$project$Ui$Form$Group$labelClass('')
										]),
									_List_fromArray(
										[
											$author$project$Ui$Button$group(
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Button$view,
													{mm: 'Select percentage base discount calculation'},
													_List_fromArray(
														[
															$author$project$Ui$Button$active(
															_Utils_eq(
																groupDiscountRulesCalculatedBy,
																$elm$core$Maybe$Just('percent_off'))),
															$author$project$Ui$Button$onClick(
															$author$project$Components$PricingVersions$Form$FormUpdated(
																$author$project$Components$PricingVersions$Form$ToggleGroupDiscountRulesCalculatedBy(true)))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('%')
														])),
													A3(
													$author$project$Ui$Button$view,
													{mm: 'Select fixed discount rate'},
													_List_fromArray(
														[
															$author$project$Ui$Button$active(
															!_Utils_eq(
																groupDiscountRulesCalculatedBy,
																$elm$core$Maybe$Just('percent_off'))),
															$author$project$Ui$Button$onClick(
															$author$project$Components$PricingVersions$Form$FormUpdated(
																$author$project$Components$PricingVersions$Form$ToggleGroupDiscountRulesCalculatedBy(false)))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('$')
														]))
												]))
										])),
									A2(
									$author$project$Ui$Grid$row,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$spanSm(11),
													$author$project$Ui$Grid$offsetSm(1)
												]),
											_List_fromArray(
												[
													A4(
													$author$project$Ui$Table$view,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Table$header,
															_List_fromArray(
																[
																	$author$project$Ui$Table$cellSpan(3)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('From')
																])),
															A2(
															$author$project$Ui$Table$header,
															_List_fromArray(
																[
																	$author$project$Ui$Table$cellSpan(3)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('To')
																])),
															A2(
															$author$project$Ui$Table$header,
															_List_fromArray(
																[
																	$author$project$Ui$Table$cellSpan(2)
																]),
															_List_Nil),
															A2(
															$author$project$Ui$Table$header,
															_List_fromArray(
																[
																	$author$project$Ui$Table$cellSpan(4)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Discount per Member')
																]))
														]),
													A2(
														$elm$core$List$indexedMap,
														A2($author$project$Components$PricingVersions$Form$viewGroupDiscountRule, plan, form),
														groupDiscountRules),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Table$row,
															_List_Nil,
															_List_fromArray(
																[
																	A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
																	A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
																	A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
																	A2(
																	$author$project$Ui$Table$cell,
																	_List_Nil,
																	_List_fromArray(
																		[
																			allowNewGroupRule ? A3(
																			$author$project$Ui$Button$view,
																			{mm: 'Add group range discount rule'},
																			_List_fromArray(
																				[
																					$author$project$Ui$Button$onClick(
																					$author$project$Components$PricingVersions$Form$FormUpdated($author$project$Components$PricingVersions$Form$GroupDiscountRuleAdd)),
																					$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text('Add Range')
																				])) : $author$project$Utils$Html$empty
																		]))
																]))
														]))
												]))
										]))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]));
	});
var $author$project$Components$PricingVersions$Form$viewForm = F3(
	function (model, _v0, form) {
		var nameErrors = model.hI ? $author$project$Components$PricingVersions$Form$validatePricingVersionName(form.Bq) : _List_Nil;
		var maybePlan = function () {
			var _v9 = model.l;
			if (_v9.$ === 3) {
				var plan = _v9.a;
				return $elm$core$Maybe$Just(plan);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var sharedFields = A2($author$project$Components$PricingVersions$Form$initSharedFields, maybePlan, form);
		var pricingFields = _List_fromArray(
			[
				(sharedFields.S1 === 'fixed_pricing') ? A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$HorizontalRule$view(_List_Nil),
						A2(
						$elm$html$Html$map,
						$author$project$Components$PricingVersions$Form$GroupTierPricingFieldsUpdated,
						A3(
							$author$project$Components$Plan$Form$GroupTierPricingFields$view,
							sharedFields,
							function () {
								var _v3 = model.l;
								if (_v3.$ === 3) {
									var plan = _v3.a;
									return $elm$core$Maybe$Just(plan);
								} else {
									return $elm$core$Maybe$Nothing;
								}
							}(),
							form.k))
					])) : A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$HorizontalRule$view(_List_Nil),
						A2(
						$elm$html$Html$map,
						$author$project$Components$PricingVersions$Form$IndividualMembershipPricingFieldsUpdated,
						A4(
							$author$project$Components$Plan$Form$IndividualMembershipPricingFields$view,
							sharedFields,
							model.ZV,
							function () {
								var _v4 = model.l;
								if (_v4.$ === 3) {
									var plan = _v4.a;
									return $elm$core$Maybe$Just(plan);
								} else {
									return $elm$core$Maybe$Nothing;
								}
							}(),
							form.dq))
					])),
				(sharedFields.S1 === 'family') ? A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				function () {
					var _v5 = model.l;
					if (_v5.$ === 3) {
						var plan = _v5.a;
						return _List_fromArray(
							[
								$author$project$Ui$HorizontalRule$view(_List_Nil),
								A3($author$project$Components$PricingVersions$Form$viewFamilyMembershipPricing, sharedFields, plan, form)
							]);
					} else {
						return _List_Nil;
					}
				}()) : $author$project$Utils$Html$empty,
				(sharedFields.S1 === 'group') ? A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				function () {
					var _v6 = model.l;
					if (_v6.$ === 3) {
						var plan = _v6.a;
						return _List_fromArray(
							[
								$author$project$Ui$HorizontalRule$view(_List_Nil),
								A2($author$project$Components$PricingVersions$Form$viewGroupMembershipPricingFields, plan, form)
							]);
					} else {
						return _List_Nil;
					}
				}()) : $author$project$Utils$Html$empty,
				function () {
				var _v7 = _Utils_Tuple2(form.dL, model.l);
				if ((!_v7.a.$) && (_v7.b.$ === 3)) {
					var specialRatesForm = _v7.a.a;
					var _v8 = _v7.b;
					var plan = _v8.a;
					return A2(
						$author$project$Ui$Element$view,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$HorizontalRule$view(_List_Nil),
								A2(
								$elm$html$Html$map,
								$author$project$Components$PricingVersions$Form$SpecialRatesFieldsUpdated,
								A2($author$project$Components$Plan$Form$SpecialRatesFields$view, plan, specialRatesForm))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]);
		var effectiveDateErrors = model.hI ? A2($author$project$Components$PricingVersions$Form$validateEffectiveDate, true, form.Q7) : _List_Nil;
		var basicPlanFields = $elm$core$List$singleton(
			A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mt4]),
				A2(
					$elm$core$List$map,
					$elm$html$Html$map($author$project$Components$PricingVersions$Form$BasicPlanFormUpdated),
					A2(
						$author$project$Components$PricingVersions$Form$viewBasicPlanFieldsForPricingVersion,
						form.ab,
						function () {
							var _v2 = model.l;
							if (_v2.$ === 3) {
								var plan = _v2.a;
								return $elm$core$Maybe$Just(plan);
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}()))));
		var basicFields = _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$offsetLabel,
						$author$project$Ui$Form$Group$labelSpanSm(5),
						$author$project$Ui$Form$Group$inputSpanSm(6),
						$author$project$Ui$Form$Group$labelHtml(
						_List_fromArray(
							[
								$elm$html$Html$text('Name of Pricing Version '),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-danger')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('*')
									]))
							])),
						$author$project$Ui$Form$Group$labelClass(''),
						$author$project$Ui$Form$Group$labelHelp(
						$elm$html$Html$text('This will not be displayed to patients.'))
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(form.Bq),
								$author$project$Ui$Form$Input$onInput($author$project$Components$PricingVersions$Form$NameChanged),
								$author$project$Ui$Form$Input$placeholder(
								function () {
									var _v1 = model.dd;
									if (!_v1.$) {
										var currentDate = _v1.a;
										return $elm$core$String$fromInt(
											$justinmimbs$date$Date$year(currentDate) + 1) + ' Pricing';
									} else {
										return '2025 Pricing';
									}
								}()),
								$author$project$Ui$Form$Input$invalid(
								!$elm$core$List$isEmpty(nameErrors)),
								$author$project$Ui$Form$Input$errors(nameErrors)
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$offsetLabel,
						$author$project$Ui$Form$Group$labelSpanSm(5),
						$author$project$Ui$Form$Group$inputSpanSm(6),
						$author$project$Ui$Form$Group$labelHtml(
						_List_fromArray(
							[
								$elm$html$Html$text('Effective Date '),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-danger')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('*')
									]))
							])),
						$author$project$Ui$Form$Group$labelClass(''),
						$author$project$Ui$Form$Group$labelHelp(
						$elm$html$Html$text('The day your new pricing will start to go into effect.'))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Components$PricingVersions$Form$EffectiveDateInputMsg,
						A2(
							$author$project$Components$DateInput$view,
							_List_fromArray(
								[
									$author$project$Components$DateInput$value(form.Q7),
									$author$project$Components$DateInput$invalid(
									!$elm$core$List$isEmpty(effectiveDateErrors)),
									$author$project$Components$DateInput$errors(effectiveDateErrors)
								]),
							model.jC))
					]))
			]);
		return $elm$core$List$concat(
			_List_fromArray(
				[basicFields, basicPlanFields, pricingFields]));
	});
var $author$project$Components$PricingVersions$Form$view = function (_v0) {
	var model = _v0;
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Form$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$noValidate(true),
					$author$project$Ui$Form$autocomplete(false),
					$author$project$Ui$Form$onSubmit($author$project$Components$PricingVersions$Form$Save)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Panel$heading,
							_List_fromArray(
								[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
							_List_fromArray(
								[
									$author$project$Ui$Panel$title(
									_List_fromArray(
										[
											$elm$html$Html$text('Schedule Pricing Change')
										])),
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Close'},
									_List_fromArray(
										[
											$author$project$Ui$Button$close,
											$author$project$Ui$Button$onClick($author$project$Components$PricingVersions$Form$NavigateBack)
										]),
									_List_Nil)
								])),
							A2(
							$author$project$Ui$Panel$body,
							_List_Nil,
							function () {
								var _v1 = _Utils_Tuple3(model.Io, model.l, model.SD);
								_v1$2:
								while (true) {
									_v1$4:
									while (true) {
										switch (_v1.b.$) {
											case 3:
												switch (_v1.a.$) {
													case 3:
														if (!_v1.c.$) {
															var _v2 = _v1.a;
															var pricingVersion = _v2.a;
															var _v3 = _v1.b;
															var form = _v1.c.a;
															return A3($author$project$Components$PricingVersions$Form$viewForm, model, pricingVersion, form);
														} else {
															break _v1$4;
														}
													case 0:
														if (!_v1.c.$) {
															var _v4 = _v1.a;
															var _v5 = _v1.b;
															var form = _v1.c.a;
															return A3(
																$author$project$Components$PricingVersions$Form$viewForm,
																model,
																{ahP: '', Bq: form.Bq},
																form);
														} else {
															break _v1$4;
														}
													case 2:
														break _v1$2;
													default:
														break _v1$4;
												}
											case 2:
												if (_v1.a.$ === 2) {
													break _v1$2;
												} else {
													return _List_fromArray(
														[
															A2(
															$author$project$Ui$Element$view,
															_List_fromArray(
																[$author$project$Ui$Element$textCenter]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Error loading base plan')
																]))
														]);
												}
											default:
												if (_v1.a.$ === 2) {
													break _v1$2;
												} else {
													break _v1$4;
												}
										}
									}
									return _List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$textCenter]),
											_List_fromArray(
												[
													$author$project$Ui$Spinner$view(_List_Nil)
												]))
										]);
								}
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$textCenter]),
										_List_fromArray(
											[
												$elm$html$Html$text('Error loading pricing version')
											]))
									]);
							}()),
							A2(
							$author$project$Ui$Panel$footer,
							_List_fromArray(
								[$author$project$Ui$Element$flexCol]),
							function () {
								var _v6 = _Utils_Tuple3(model.Io, model.l, model.SD);
								_v6$2:
								while (true) {
									if ((_v6.b.$ === 3) && (!_v6.c.$)) {
										switch (_v6.a.$) {
											case 3:
												var _v7 = _v6.a;
												var _v8 = _v6.b;
												var plan = _v8.a;
												var form = _v6.c.a;
												return _List_fromArray(
													[
														(model.hI && A3(
														$author$project$Components$PricingVersions$Form$hasAnyValidationErrors,
														$elm$core$Maybe$Just(plan),
														model.ZV,
														form)) ? A2(
														$author$project$Ui$Grid$row,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Grid$column,
																_List_fromArray(
																	[
																		$author$project$Ui$Grid$offsetSm(3),
																		$author$project$Ui$Grid$spanSm(6)
																	]),
																_List_fromArray(
																	[
																		A2(
																		$author$project$Ui$Alert$danger,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$elm$html$Html$text('Please review the errors above')
																			]))
																	]))
															])) : $author$project$Utils$Html$empty,
														A2(
														$author$project$Ui$Element$view,
														_List_fromArray(
															[$author$project$Ui$Element$gap2, $author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$itemsCenter]),
														_List_fromArray(
															[
																A3(
																$author$project$Ui$Link$route,
																$author$project$Components$PricingVersions$Form$planRoute(model.My),
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('Back')
																	])),
																A3(
																$author$project$Ui$Button$view,
																{mm: 'Delete pricing version'},
																_List_fromArray(
																	[
																		$author$project$Ui$Button$danger,
																		$author$project$Ui$Button$onClick($author$project$Components$PricingVersions$Form$Delete),
																		$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Delete')
																	])),
																A3(
																$author$project$Ui$Button$view,
																{mm: 'Save pricing version'},
																_List_fromArray(
																	[
																		$author$project$Ui$Button$primary,
																		$author$project$Ui$Button$onClick($author$project$Components$PricingVersions$Form$Save)
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Save Changes')
																	]))
															]))
													]);
											case 0:
												var _v9 = _v6.a;
												var _v10 = _v6.b;
												var plan = _v10.a;
												var form = _v6.c.a;
												return _List_fromArray(
													[
														(model.hI && A3(
														$author$project$Components$PricingVersions$Form$hasAnyValidationErrors,
														$elm$core$Maybe$Just(plan),
														model.ZV,
														form)) ? A2(
														$author$project$Ui$Grid$row,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Grid$column,
																_List_fromArray(
																	[
																		$author$project$Ui$Grid$offsetSm(3),
																		$author$project$Ui$Grid$spanSm(6)
																	]),
																_List_fromArray(
																	[
																		A2(
																		$author$project$Ui$Alert$danger,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$elm$html$Html$text('Please review the errors above')
																			]))
																	]))
															])) : $author$project$Utils$Html$empty,
														A2(
														$author$project$Ui$Element$view,
														_List_fromArray(
															[$author$project$Ui$Element$gap2, $author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$itemsCenter]),
														_List_fromArray(
															[
																A3(
																$author$project$Ui$Link$route,
																$author$project$Components$PricingVersions$Form$planRoute(model.My),
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('Back')
																	])),
																A3(
																$author$project$Ui$Button$view,
																{mm: 'Save Change'},
																_List_fromArray(
																	[
																		$author$project$Ui$Button$primary,
																		$author$project$Ui$Button$onClick($author$project$Components$PricingVersions$Form$Save)
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Save Change')
																	]))
															]))
													]);
											default:
												break _v6$2;
										}
									} else {
										break _v6$2;
									}
								}
								return _List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										$author$project$Components$PricingVersions$Form$planRoute(model.My),
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Back')
											]))
									]);
							}())
						]))
				]))
		]);
};
var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$New$view = function (model) {
	return {
		fO: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			$author$project$Components$PricingVersions$Form$view(model.SD)),
		ac9: 'New Pricing Version'
	};
};
var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$New$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Plans$Id_String$PricingVersions$New$init, aiq: $author$project$Pages$Admin$Plans$Id_String$PricingVersions$New$load, k8: $author$project$Pages$Admin$Plans$Id_String$PricingVersions$New$save, alO: $author$project$Pages$Admin$Plans$Id_String$PricingVersions$New$subscriptions, adT: $author$project$Pages$Admin$Plans$Id_String$PricingVersions$New$update, amo: $author$project$Pages$Admin$Plans$Id_String$PricingVersions$New$view});
var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$PricingVersionId_String$FormMsg = $elm$core$Basics$identity;
var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$PricingVersionId_String$init = F4(
	function (session, practice, shared, _v0) {
		var params = _v0.YL;
		var settings = {My: params.ahP, Is: $author$project$Spa$Generated$Route$Admin__Plans__Top, ZV: practice, aa4: session};
		var _v1 = A4(
			$author$project$Components$PricingVersions$Form$init,
			shared.Gv,
			settings,
			params.ahP,
			$elm$core$Maybe$Just(params.akh));
		var form = _v1.a;
		var cmd = _v1.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, SD: form, ZV: practice, aa4: session, lk: shared},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
	});
var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$PricingVersionId_String$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{lk: shared}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$PricingVersionId_String$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$PricingVersionId_String$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$PricingVersions$Form$subscriptions(model.SD));
};
var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$PricingVersionId_String$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$PricingVersions$Form$update, model.Gv, subMsg, model.SD);
		var newForm = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{SD: newForm}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$PricingVersionId_String$view = function (model) {
	return {
		fO: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			$author$project$Components$PricingVersions$Form$view(model.SD)),
		ac9: 'Edit Pricing Version'
	};
};
var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$PricingVersionId_String$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Plans$Id_String$PricingVersions$PricingVersionId_String$init, aiq: $author$project$Pages$Admin$Plans$Id_String$PricingVersions$PricingVersionId_String$load, k8: $author$project$Pages$Admin$Plans$Id_String$PricingVersions$PricingVersionId_String$save, alO: $author$project$Pages$Admin$Plans$Id_String$PricingVersions$PricingVersionId_String$subscriptions, adT: $author$project$Pages$Admin$Plans$Id_String$PricingVersions$PricingVersionId_String$update, amo: $author$project$Pages$Admin$Plans$Id_String$PricingVersions$PricingVersionId_String$view});
var $author$project$Pages$Admin$Plans$New$NewMsg = $elm$core$Basics$identity;
var $author$project$Pages$Admin$Plans$New$init = F4(
	function (session, _v0, _v1, _v2) {
		var apiClient = _v1.Gv;
		var _v3 = A5($author$project$Components$Admin$Plans$New$init, apiClient, session, 2, $author$project$Spa$Generated$Route$Admin__Plans__Top, $author$project$Spa$Generated$Route$Admin__Plans__Id_String);
		var _new = _v3.a;
		var newCmd = _v3.b;
		return _Utils_Tuple2(
			{Gv: apiClient, SD: _new},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, newCmd));
	});
var $author$project$Pages$Admin$Plans$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Plans$New$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Plans$New$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Admin$Plans$New$subscriptions(model.SD));
};
var $author$project$Pages$Admin$Plans$New$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Admin$Plans$New$update, model.Gv, subMsg, model.SD);
		var form = _v1.a;
		var newCmd = _v1.b;
		var outMsgs = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{SD: form}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, newCmd),
			outMsgs);
	});
var $author$project$Pages$Admin$Plans$New$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Admin$Plans$New$view(model.SD))
			]),
		ac9: 'Admin | Membership Plans'
	};
};
var $author$project$Pages$Admin$Plans$New$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Plans$New$init, aiq: $author$project$Pages$Admin$Plans$New$load, k8: $author$project$Pages$Admin$Plans$New$save, alO: $author$project$Pages$Admin$Plans$New$subscriptions, adT: $author$project$Pages$Admin$Plans$New$update, amo: $author$project$Pages$Admin$Plans$New$view});
var $author$project$Pages$Admin$Plans$Top$ListMsg = $elm$core$Basics$identity;
var $author$project$Pages$Admin$Plans$Top$init = F4(
	function (session, practice, _v0, _v1) {
		var apiClient = _v0.Gv;
		var query = _v1.DE;
		var planTypes = _List_fromArray(
			[2, 3]);
		var _v2 = $author$project$Components$Admin$Plans$List$init(apiClient)(session)(
			$author$project$Api$Platform$User$Shared$isAdmin(
				$author$project$Api$Platform$Session$One$user(session)))(planTypes)($author$project$Spa$Generated$Route$Admin__Plans__Top)($author$project$Spa$Generated$Route$Admin__Plans__New)($author$project$Spa$Generated$Route$Admin__Plans__Id_String)(
			_List_fromArray(
				[
					$elm$html$Html$text('You can change your default plan by editing your default signup page '),
					A3(
					$author$project$Ui$Link$route,
					$author$project$Spa$Generated$Route$Admin__SignupPages__Top,
					_List_fromArray(
						[$author$project$Ui$Link$sm]),
					_List_fromArray(
						[
							$elm$html$Html$text('here')
						])),
					$elm$html$Html$text('.')
				]))(query)(
			{bb: false})(
			$elm$core$Maybe$Just(practice));
		var list = _v2.a;
		var listCmd = _v2.b;
		return _Utils_Tuple2(
			{Gv: apiClient, s1: list},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, listCmd));
	});
var $author$project$Pages$Admin$Plans$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Plans$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Plans$Top$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$Plans$Top$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Admin$Plans$List$update, model.Gv, subMsg, model.s1);
		var list = _v1.a;
		var listCmd = _v1.b;
		var outMsgs = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{s1: list}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, listCmd),
			outMsgs);
	});
var $author$project$Pages$Admin$Plans$Top$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Admin$Plans$List$view(model.s1))
			]),
		ac9: 'Admin | Membership Plans'
	};
};
var $author$project$Pages$Admin$Plans$Top$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Plans$Top$init, aiq: $author$project$Pages$Admin$Plans$Top$load, k8: $author$project$Pages$Admin$Plans$Top$save, alO: $author$project$Pages$Admin$Plans$Top$subscriptions, adT: $author$project$Pages$Admin$Plans$Top$update, amo: $author$project$Pages$Admin$Plans$Top$view});
var $author$project$Pages$Admin$Practice$AccountFormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$Practice$DeactivateModal$Closed = {$: 0};
var $author$project$Components$Admin$Practice$DeactivateModal$init = $author$project$Components$Admin$Practice$DeactivateModal$Closed;
var $author$project$Components$Practice$AccountForm$EmrDropdownMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Practice$AccountForm$Model = $elm$core$Basics$identity;
var $author$project$Api$Provider$Practice$One$defaultMembershipStartDate = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.P2;
	});
var $author$project$Components$Practice$AccountForm$AddressInputMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Practice$One$ein = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Q9;
	});
var $author$project$Api$Provider$Practice$One$emr = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.agO;
	});
var $author$project$Api$Provider$Practice$One$emrOther = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.agQ;
	});
var $author$project$Components$Practice$AccountForm$initPhoneInput = function (phones) {
	return A3(
		$author$project$Components$PhoneInput$init,
		'practice-phone-input',
		A2($elm$core$List$map, $author$project$Utils$Phone$fromApi, phones),
		function (d) {
			return _Utils_update(
				d,
				{Gh: true, agl: $author$project$Api$Common$Phone$Shared$Office, AU: 1, akR: true});
		});
};
var $author$project$Api$Provider$Practice$Shared$logoUrl = function (_v0) {
	var record = _v0;
	return record.Wk;
};
var $author$project$Api$Provider$Practice$One$logoUrl = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$logoUrl(shared);
};
var $author$project$Api$WhitelabelSetting$patientFacingFaviconPngUrl = function (_v0) {
	var record = _v0;
	return record.I4;
};
var $author$project$Api$Provider$Practice$One$sessionTimeoutInMinutes = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.alp;
	});
var $author$project$Components$AddressInput$withHiddenCountry = F2(
	function (hiddenCountry, _v0) {
		var model = _v0;
		return hiddenCountry ? _Utils_update(
			model,
			{bj: false}) : _Utils_update(
			model,
			{bj: true});
	});
var $author$project$Components$Practice$AccountForm$formFieldsFromPractice = F3(
	function (addressIsRequired, practice, dataWhitelabelSettings) {
		var faviconUrl = function () {
			if (dataWhitelabelSettings.$ === 3) {
				var whitelabelSettings = dataWhitelabelSettings.a;
				return $author$project$Api$WhitelabelSetting$patientFacingFaviconPngUrl(whitelabelSettings);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var _v0 = A2(
			$author$project$Components$AddressInput$initFromApi,
			'practice',
			$author$project$Api$Provider$Practice$One$address(practice));
		var addressInput = _v0.a;
		var addressInputCmd = _v0.b;
		return _Utils_Tuple2(
			{
				K2: A2(
					$author$project$Components$AddressInput$withHiddenCountry,
					true,
					A2($author$project$Components$AddressInput$withRequired, addressIsRequired, addressInput)),
				y$: faviconUrl,
				Pg: $author$project$Api$Provider$Practice$One$logoUrl(practice),
				Q9: $author$project$Api$Provider$Practice$One$ein(practice),
				Rj: $author$project$Api$Provider$Practice$One$email(practice),
				agO: $author$project$Api$Provider$Practice$One$emr(practice),
				agQ: $author$project$Api$Provider$Practice$One$emrOther(practice),
				HJ: 0,
				zD: $elm$core$Maybe$Nothing,
				Iu: 0,
				Wk: $elm$core$Maybe$Nothing,
				Bq: $author$project$Api$Provider$Practice$One$name(practice),
				Zw: $author$project$Components$Practice$AccountForm$initPhoneInput(
					$author$project$Api$Provider$Practice$One$phones(practice)),
				alp: $author$project$Api$Provider$Practice$One$sessionTimeoutInMinutes(practice),
				adY: $author$project$Api$Provider$Practice$One$url(practice)
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$Practice$AccountForm$AddressInputMsg, addressInputCmd));
	});
var $author$project$Components$Practice$AccountForm$init = F4(
	function (practice, dataWhitelabelSetting, sharedModel, _v0) {
		var isOnboarding = _v0.bb;
		var onboardingClinical = _v0.Yk;
		var hasClinical = $author$project$Api$Provider$Practice$One$hasClinicalAccount(practice) || onboardingClinical;
		var defaultMembershipStartDate = $author$project$Api$Provider$Practice$One$defaultMembershipStartDate(practice);
		var currentDate = sharedModel.dd;
		var addressIsRequired = hasClinical || (A2($justinmimbs$date$Date$compare, defaultMembershipStartDate, currentDate) !== 2);
		var _v1 = A3($author$project$Components$Practice$AccountForm$formFieldsFromPractice, addressIsRequired, practice, dataWhitelabelSetting);
		var formFields = _v1.a;
		var formFieldsCmd = _v1.b;
		return _Utils_Tuple2(
			{
				Gk: addressIsRequired,
				Gv: sharedModel.Gv,
				dd: currentDate,
				PO: $author$project$Components$Admin$Practice$DeactivateModal$init,
				i9: false,
				nw: $author$project$Ui$Dropdown$init(
					$author$project$Ui$Dropdown$defaultConfig(
						{ahP: 'emr', al6: $author$project$Components$Practice$AccountForm$EmrDropdownMsg})),
				SD: $author$project$Utils$Form$init(formFields),
				nR: hasClinical,
				Ij: $author$project$Shared$isHintAdmin(sharedModel),
				bb: isOnboarding,
				ZV: practice,
				k9: $author$project$Api$Data$NotAsked
			},
			formFieldsCmd);
	});
var $author$project$Pages$Admin$Practice$init = F4(
	function (session, practice, shared, _v0) {
		var _v1 = A4(
			$author$project$Components$Practice$AccountForm$init,
			practice,
			shared.aey,
			shared,
			{bb: false, Yk: false});
		var accountFormModel = _v1.a;
		var accountFormCmd = _v1.b;
		return _Utils_Tuple2(
			{
				cX: accountFormModel,
				Gv: shared.Gv,
				PO: $author$project$Components$Admin$Practice$DeactivateModal$init,
				i9: false,
				Ij: $author$project$Shared$isHintAdmin(shared),
				ZV: practice,
				k9: $author$project$Api$Data$NotAsked,
				aa4: session,
				lk: shared
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Practice$AccountFormMsg, accountFormCmd));
	});
var $author$project$Pages$Admin$Practice$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Practice$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Practice$DeactivateModalMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Admin$Practice$HiConfirmClosed = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$Practice$DeactivateModal$CloseModal = {$: 0};
var $author$project$Components$Admin$Practice$DeactivateModal$subscriptions = function (model) {
	if (model.$ === 1) {
		return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$Practice$DeactivateModal$CloseModal);
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Components$Practice$AccountForm$PhoneInputMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Practice$AccountForm$subscriptions = function (_v0) {
	var model = _v0;
	var _v1 = $author$project$Utils$Form$fields(model.SD);
	var phone = _v1.Zw;
	var address = _v1.K2;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Practice$AccountForm$AddressInputMsg,
				$author$project$Components$AddressInput$subscriptions(address)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Practice$AccountForm$PhoneInputMsg,
				$author$project$Components$PhoneInput$subscriptions(phone)),
				$author$project$Ui$Dropdown$subscriptions(model.nw)
			]));
};
var $author$project$Pages$Admin$Practice$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$Practice$AccountFormMsg,
				$author$project$Components$Practice$AccountForm$subscriptions(model.cX)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$Practice$DeactivateModalMsg,
				$author$project$Components$Admin$Practice$DeactivateModal$subscriptions(model.PO)),
				model.i9 ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Admin$Practice$HiConfirmClosed) : $elm$core$Platform$Sub$none
			]));
};
var $author$project$Pages$Admin$Practice$Deleted = function (a) {
	return {$: 2, a: a};
};
var $author$project$OutMsg$WhitelabelSettingsUpdated = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$Practice$delete = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$practicePath));
	});
var $author$project$Ports$Session$logoutPort = _Platform_outgoingPort(
	'logoutPort',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'redirect',
					$elm$json$Json$Encode$bool($.aku))
				]));
	});
var $author$project$Ports$Session$logout = function (options) {
	return $author$project$Ports$Session$logoutPort(options);
};
var $author$project$Components$Admin$Practice$DeactivateModal$DateInputMsg = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$Admin$Practice$DeactivateModal$Open = F6(
	function (a, b, c, d, e, f) {
		return {$: 1, a: a, b: b, c: c, d: d, e: e, f: f};
	});
var $author$project$Api$Provider$Practice$Shared$cancellationReasonOther = function (_v0) {
	var record = _v0;
	return record.afp;
};
var $author$project$Api$Provider$Practice$One$cancellationReasonOther = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$cancellationReasonOther(shared);
};
var $author$project$Api$Provider$Practice$Shared$deactivateOn = function (_v0) {
	var record = _v0;
	return record.PP;
};
var $author$project$Api$Provider$Practice$One$deactivateOn = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$deactivateOn(shared);
};
var $author$project$Components$Admin$Practice$DeactivateModal$cancellationReasons = _List_fromArray(
	['Practice closed', 'Practice closed [Retired]', 'Lost to competitor: AestheticsPro', 'Lost to competitor: Akute', 'Lost to competitor: Athena', 'Lost to competitor: AtlasMD', 'Lost to competitor: Cerbo', 'Lost to competitor: Charm', 'Lost to competitor: Dr. Chrono', 'Lost to competitor: eCW', 'Lost to competitor: Elation', 'Lost to competitor: Healthie', 'Lost to competitor: Jane', 'Lost to competitor: Optimantra', 'Lost to competitor: Practice Fusion', 'Lost to competitor: SigmaMD', 'Lost to competitor: Tebra', 'Lost to competitor: Vibrant', 'Lost to competitor: Other', 'Never onboarded', 'Merged Hint accounts', 'Abandoned membership model', 'Deactivated freemium affiliate', 'Pricing rollout 2024', 'Dormant Account', 'Unknown']);
var $author$project$Components$Admin$Practice$DeactivateModal$defaultCancellationReason = A2(
	$elm$core$Maybe$withDefault,
	'',
	$elm$core$List$head($author$project$Components$Admin$Practice$DeactivateModal$cancellationReasons));
var $author$project$Components$Admin$Practice$DeactivateModal$open = function (practice) {
	var cancellationReason = A2(
		$elm$core$Maybe$withDefault,
		$author$project$Components$Admin$Practice$DeactivateModal$defaultCancellationReason,
		$author$project$Api$Provider$Practice$One$cancellationReasonOther(practice));
	var _v0 = $author$project$Components$DateInput$init;
	var dateInput = _v0.a;
	var dateInputCmd = _v0.b;
	return _Utils_Tuple2(
		A6(
			$author$project$Components$Admin$Practice$DeactivateModal$Open,
			practice,
			false,
			$author$project$Api$Data$NotAsked,
			$author$project$Api$Provider$Practice$One$deactivateOn(practice),
			dateInput,
			cancellationReason),
		A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Components$Admin$Practice$DeactivateModal$DateInputMsg(dateInput),
			dateInputCmd));
};
var $author$project$Pages$Admin$Practice$WhitelabelSettingRetrieved = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Api$WhitelabelSetting$WhitelabelSetting = $elm$core$Basics$identity;
var $author$project$Api$WhitelabelSetting$Record = F8(
	function (practiceFacingLogoUrl, practiceFacingLogoAltText, practiceFacingFaviconIcoUrl, practiceFacingFaviconPngUrl, practiceFacingFaviconAppleUrl, patientFacingFaviconPngUrl, brandName, branded) {
		return {GJ: brandName, GK: branded, I4: patientFacingFaviconPngUrl, Jd: practiceFacingFaviconAppleUrl, Je: practiceFacingFaviconIcoUrl, Jf: practiceFacingFaviconPngUrl, Jg: practiceFacingLogoAltText, Jh: practiceFacingLogoUrl};
	});
var $author$project$Api$WhitelabelSetting$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'branded',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'brand_name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'patient_facing_favicon_png_url',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'practice_facing_favicon_apple_url',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'practice_facing_favicon_png_url',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'practice_facing_favicon_ico_url',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'practice_facing_logo_alt_text',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'practice_facing_logo_url',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								$elm$json$Json$Decode$succeed($author$project$Api$WhitelabelSetting$Record)))))))));
var $author$project$Api$WhitelabelSetting$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$WhitelabelSetting$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$WhitelabelSetting$employerWhitelabelSettingsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['whitelabel_settings']),
	$author$project$Api$Data$employerPath);
var $author$project$Api$WhitelabelSetting$employerRetrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$WhitelabelSetting$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$WhitelabelSetting$employerWhitelabelSettingsPath));
	});
var $author$project$Api$WhitelabelSetting$providerWhitelabelSettingsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['whitelabel_settings']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$WhitelabelSetting$providerRetrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$WhitelabelSetting$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$WhitelabelSetting$providerWhitelabelSettingsPath));
	});
var $author$project$Api$WhitelabelSetting$retrieve = F3(
	function (apiClient, session, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A2($author$project$Api$WhitelabelSetting$employerRetrieve, apiClient, toMsg) : A2($author$project$Api$WhitelabelSetting$providerRetrieve, apiClient, toMsg);
	});
var $author$project$Pages$Admin$Practice$retrieveWhitelabelSetting = F3(
	function (practice, apiClient, session) {
		return A3(
			$author$project$Api$WhitelabelSetting$retrieve,
			apiClient,
			session,
			$author$project$Pages$Admin$Practice$WhitelabelSettingRetrieved(practice));
	});
var $author$project$Components$Admin$Practice$DeactivateModal$Deactivated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$Practice$DeactivateModal$None = {$: 0};
var $author$project$Components$Admin$Practice$DeactivateModal$PracticeDeactivated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Practice$deactivate = F5(
	function (apiClient, removePracticeUsers, maybeDate, cancellationReason, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'remove_practice_users',
					$elm$json$Json$Encode$bool(removePracticeUsers)),
					_Utils_Tuple2(
					'deactivation_date',
					A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, maybeDate)),
					_Utils_Tuple2(
					'cancellation_reason_other',
					$elm$json$Json$Encode$string(cancellationReason))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Practice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['deactivate']),
						$author$project$Api$Provider$Practice$practicePath))));
	});
var $author$project$Components$Admin$Practice$DeactivateModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$Admin$Practice$DeactivateModal$None, aiO: $author$project$Components$Admin$Practice$DeactivateModal$Closed, aR: _List_Nil};
			case 2:
				var bool = msg.a;
				if (model.$ === 1) {
					var practitioner = model.a;
					var maybeDate = model.d;
					var dateInput = model.e;
					var cancellationReason = model.f;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Admin$Practice$DeactivateModal$None,
						aiO: A6($author$project$Components$Admin$Practice$DeactivateModal$Open, practitioner, bool, $author$project$Api$Data$NotAsked, maybeDate, dateInput, cancellationReason),
						aR: _List_Nil
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$Admin$Practice$DeactivateModal$None, aiO: $author$project$Components$Admin$Practice$DeactivateModal$Closed, aR: _List_Nil};
				}
			case 4:
				var dateInputModel = msg.a;
				var dateInputMsg = msg.b;
				var _v2 = A2($author$project$Components$DateInput$update, dateInputMsg, dateInputModel);
				var newDateInput = _v2.a;
				var subCmd = _v2.b;
				var event = _v2.c;
				if (model.$ === 1) {
					var practitioner = model.a;
					var removePracticeUsers = model.b;
					var data = model.c;
					var currentMaybeDate = model.d;
					var cancellationReason = model.f;
					if (event.$ === 1) {
						var maybeDate = event.a;
						return {
							GZ: subCmd,
							agZ: $author$project$Components$Admin$Practice$DeactivateModal$None,
							aiO: A6($author$project$Components$Admin$Practice$DeactivateModal$Open, practitioner, removePracticeUsers, data, maybeDate, newDateInput, cancellationReason),
							aR: _List_Nil
						};
					} else {
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: $author$project$Components$Admin$Practice$DeactivateModal$None,
							aiO: A6($author$project$Components$Admin$Practice$DeactivateModal$Open, practitioner, removePracticeUsers, data, currentMaybeDate, newDateInput, cancellationReason),
							aR: _List_Nil
						};
					}
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$Admin$Practice$DeactivateModal$None, aiO: $author$project$Components$Admin$Practice$DeactivateModal$Closed, aR: _List_Nil};
				}
			case 5:
				var inputReason = msg.a;
				if (model.$ === 1) {
					var practitioner = model.a;
					var removePracticeUsers = model.b;
					var maybeDate = model.d;
					var dateInput = model.e;
					var selectedCancellationReason = A2(
						$elm_community$list_extra$List$Extra$getAt,
						A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$String$toInt(inputReason)),
						$author$project$Components$Admin$Practice$DeactivateModal$cancellationReasons);
					var cancellationReason = A2($elm$core$Maybe$withDefault, $author$project$Components$Admin$Practice$DeactivateModal$defaultCancellationReason, selectedCancellationReason);
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Admin$Practice$DeactivateModal$None,
						aiO: A6($author$project$Components$Admin$Practice$DeactivateModal$Open, practitioner, removePracticeUsers, $author$project$Api$Data$NotAsked, maybeDate, dateInput, cancellationReason),
						aR: _List_Nil
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$Admin$Practice$DeactivateModal$None, aiO: $author$project$Components$Admin$Practice$DeactivateModal$Closed, aR: _List_Nil};
				}
			case 1:
				if (model.$ === 1) {
					var practitioner = model.a;
					var removePracticeUsers = model.b;
					var maybeDate = model.d;
					var dateInput = model.e;
					var cancellationReason = model.f;
					return {
						GZ: A5($author$project$Api$Provider$Practice$deactivate, apiClient, removePracticeUsers, maybeDate, cancellationReason, $author$project$Components$Admin$Practice$DeactivateModal$Deactivated),
						agZ: $author$project$Components$Admin$Practice$DeactivateModal$None,
						aiO: A6($author$project$Components$Admin$Practice$DeactivateModal$Open, practitioner, removePracticeUsers, $author$project$Api$Data$Loading, maybeDate, dateInput, cancellationReason),
						aR: _List_Nil
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$Admin$Practice$DeactivateModal$None, aiO: $author$project$Components$Admin$Practice$DeactivateModal$Closed, aR: _List_Nil};
				}
			default:
				var response = msg.a;
				if (model.$ === 1) {
					var practitioner = model.a;
					var removePracticeUsers = model.b;
					var maybeDate = model.d;
					var dateInput = model.e;
					var cancellationReason = model.f;
					switch (response.$) {
						case 3:
							var practice = response.a;
							return {
								GZ: $elm$core$Platform$Cmd$none,
								agZ: $author$project$Components$Admin$Practice$DeactivateModal$PracticeDeactivated(practice),
								aiO: $author$project$Components$Admin$Practice$DeactivateModal$Closed,
								aR: _List_fromArray(
									[
										A2($author$project$OutMsg$ShowToast, 3, 'Practice has been deactivated/scheduled for deactivation'),
										$author$project$OutMsg$PracticeUpdated(response)
									])
							};
						case 2:
							var error = response.a;
							var errorString = $author$project$Api$Data$errorToString(error);
							var errorMessage = $elm$core$String$isEmpty(errorString) ? 'This practice cannot be deactivated. Please contact us for more information.' : errorString;
							return {
								GZ: $elm$core$Platform$Cmd$none,
								agZ: $author$project$Components$Admin$Practice$DeactivateModal$None,
								aiO: A6($author$project$Components$Admin$Practice$DeactivateModal$Open, practitioner, removePracticeUsers, response, maybeDate, dateInput, cancellationReason),
								aR: _List_fromArray(
									[
										A2($author$project$OutMsg$ShowToast, 1, errorMessage)
									])
							};
						default:
							return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$Admin$Practice$DeactivateModal$None, aiO: model, aR: _List_Nil};
					}
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$Admin$Practice$DeactivateModal$None, aiO: $author$project$Components$Admin$Practice$DeactivateModal$Closed, aR: _List_Nil};
				}
		}
	});
var $author$project$Components$Practice$AccountForm$Address = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Practice$AccountForm$Emr = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Practice$AccountForm$EmrOther = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Practice$AccountForm$Favicon = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Practice$AccountForm$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Practice$AccountForm$Logo = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Practice$AccountForm$Phone = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Practice$AccountForm$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{Bq: string});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						adY: $author$project$Utils$String$toMaybe(string)
					});
			case 2:
				var _int = field.a;
				var string = field.b;
				return _Utils_update(
					fields,
					{
						Pg: $elm$core$Maybe$Just(string),
						Iu: _int,
						Wk: $elm$core$Maybe$Just(string)
					});
			case 3:
				var _int = field.a;
				var string = field.b;
				return _Utils_update(
					fields,
					{
						y$: $elm$core$Maybe$Just(string),
						HJ: _int,
						zD: $elm$core$Maybe$Just(string)
					});
			case 4:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Rj: $author$project$Utils$String$toMaybe(string)
					});
			case 5:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Q9: $author$project$Utils$String$toMaybe(string)
					});
			case 6:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						alp: $elm$core$String$toInt(string)
					});
			case 7:
				var phone = field.a;
				return _Utils_update(
					fields,
					{Zw: phone});
			case 8:
				var address = field.a;
				return _Utils_update(
					fields,
					{K2: address});
			case 9:
				var maybeEmr = field.a;
				return _Utils_update(
					fields,
					{agO: maybeEmr});
			default:
				var maybeString = field.a;
				return _Utils_update(
					fields,
					{agQ: maybeString});
		}
	});
var $author$project$Components$Practice$AccountForm$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Practice$AccountForm$formFieldsUpdate, field, model.SD);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: newForm}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var subMsg = msg.a;
				var _v2 = $author$project$Utils$Form$fields(model.SD);
				var address = _v2.K2;
				var _v3 = A2($author$project$Components$AddressInput$update, subMsg, address);
				var addressInputModel = _v3.a;
				var addressInputCmd = _v3.b;
				var outMsgs = _v3.c;
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Practice$AccountForm$formFieldsUpdate,
					$author$project$Components$Practice$AccountForm$Address(addressInputModel),
					model.SD);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: newForm}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Practice$AccountForm$AddressInputMsg, addressInputCmd),
					outMsgs);
			case 1:
				var logos = msg.a;
				var cmd = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						function (_v4) {
							var task = _v4.a;
							var size = _v4.b;
							return A2(
								$elm$core$Task$perform,
								A2(
									$elm$core$Basics$composeL,
									$author$project$Components$Practice$AccountForm$FormUpdated,
									$author$project$Components$Practice$AccountForm$Logo(size)),
								task);
						},
						A2(
							$elm$core$Maybe$map,
							function (logo) {
								return _Utils_Tuple2(
									$elm$file$File$toUrl(logo),
									$elm$file$File$size(logo));
							},
							$elm$core$List$head(logos))));
				return _Utils_Tuple3(model, cmd, _List_Nil);
			case 2:
				var favicon = msg.a;
				var cmd = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						function (_v5) {
							var task = _v5.a;
							var size = _v5.b;
							return A2(
								$elm$core$Task$perform,
								A2(
									$elm$core$Basics$composeL,
									$author$project$Components$Practice$AccountForm$FormUpdated,
									$author$project$Components$Practice$AccountForm$Favicon(size)),
								task);
						},
						A2(
							$elm$core$Maybe$map,
							function (logo) {
								return _Utils_Tuple2(
									$elm$file$File$toUrl(logo),
									$elm$file$File$size(logo));
							},
							$elm$core$List$head(favicon))));
				return _Utils_Tuple3(model, cmd, _List_Nil);
			case 4:
				var subMsg = msg.a;
				var _v6 = $author$project$Utils$Form$fields(model.SD);
				var phone = _v6.Zw;
				var _v7 = A2($author$project$Components$PhoneInput$update, subMsg, phone);
				var phoneInput = _v7.a;
				var phoneCmd = _v7.b;
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Practice$AccountForm$formFieldsUpdate,
					$author$project$Components$Practice$AccountForm$Phone(phoneInput),
					model.SD);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: newForm}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Practice$AccountForm$PhoneInputMsg, phoneCmd),
					_List_Nil);
			case 5:
				var subMsg = msg.a;
				var _v8 = A2($author$project$Ui$Dropdown$update, subMsg, model.nw);
				var newDropdown = _v8.a;
				var cmd = _v8.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nw: newDropdown}),
					cmd,
					_List_Nil);
			default:
				var emrOption = msg.a;
				var newForm = function () {
					if (!emrOption.$) {
						var emr = emrOption.a;
						return A3(
							$author$project$Utils$Form$update,
							$author$project$Components$Practice$AccountForm$formFieldsUpdate,
							$author$project$Components$Practice$AccountForm$EmrOther($elm$core$Maybe$Nothing),
							A3(
								$author$project$Utils$Form$update,
								$author$project$Components$Practice$AccountForm$formFieldsUpdate,
								$author$project$Components$Practice$AccountForm$Emr(
									$elm$core$Maybe$Just(emr)),
								model.SD));
					} else {
						return A3(
							$author$project$Utils$Form$update,
							$author$project$Components$Practice$AccountForm$formFieldsUpdate,
							$author$project$Components$Practice$AccountForm$Emr($elm$core$Maybe$Nothing),
							model.SD);
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: newForm}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
		}
	});
var $author$project$Pages$Admin$Practice$Updated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Practice$AccountForm$practiceFromFields = function (fields) {
	var phones = A2(
		$elm$core$List$map,
		$author$project$Utils$Phone$toRecord,
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			$author$project$Components$PhoneInput$getPhones(fields.Zw)));
	var address = $author$project$Components$AddressInput$getAddress(fields.K2);
	return {K2: address, Q9: fields.Q9, Rj: fields.Rj, agO: fields.agO, agQ: fields.agQ, ahf: fields.zD, Wj: fields.Wk, Bq: fields.Bq, Zy: phones, alp: fields.alp, adY: fields.adY};
};
var $author$project$Api$Provider$Practice$Emr$toValue = function (_v0) {
	var id = _v0.ahP;
	return id;
};
var $author$project$Api$Provider$Practice$update = F3(
	function (apiClient, fields, toMsg) {
		var phones_ = A2(
			$elm$json$Json$Encode$list,
			function (phone) {
				return $author$project$Api$Common$Phone$Shared$encode(phone);
			},
			fields.Zy);
		var logo_ = function () {
			var _v1 = fields.Wj;
			if (!_v1.$) {
				var base64 = _v1.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'logo',
						$elm$json$Json$Encode$string(base64))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var favicon_ = function () {
			var _v0 = fields.ahf;
			if (!_v0.$) {
				var base64 = _v0.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'favicon',
						$elm$json$Json$Encode$string(base64))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var address_ = $author$project$Api$Common$Address$Shared$encode(fields.K2);
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practice',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(fields.Bq)),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'url',
									A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.adY)),
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										'email',
										A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Rj)),
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(
											'ein',
											A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Q9)),
										A2(
											$elm$core$List$cons,
											_Utils_Tuple2(
												'session_timeout_in_minutes',
												A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.alp)),
											A2(
												$elm$core$List$cons,
												_Utils_Tuple2('address', address_),
												A2(
													$elm$core$List$cons,
													_Utils_Tuple2('phones', phones_),
													A2(
														$elm$core$List$cons,
														_Utils_Tuple2(
															'emr',
															A2(
																$author$project$Utils$Encode$nullable,
																A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$Emr$toValue, $elm$json$Json$Encode$string),
																fields.agO)),
														A2(
															$elm$core$List$cons,
															_Utils_Tuple2(
																'emr_other',
																A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.agQ)),
															_Utils_ap(logo_, favicon_))))))))))))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Practice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$practicePath)));
	});
var $author$project$Pages$Admin$Practice$updatePractice = F2(
	function (apiClient, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A3(
			$author$project$Api$Provider$Practice$update,
			apiClient,
			$author$project$Components$Practice$AccountForm$practiceFromFields(fields),
			$author$project$Pages$Admin$Practice$Updated);
	});
var $author$project$Components$Practice$AccountForm$LogoValidation = 2;
var $author$project$Components$Practice$AccountForm$NameValidation = 0;
var $author$project$Components$Practice$AccountForm$maxLogoBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
var $author$project$Components$Practice$AccountForm$AddressValidation = 6;
var $author$project$Components$Practice$AccountForm$validateAddress = F2(
	function (_v0, fields) {
		return (!$author$project$Components$AddressInput$isValid(fields.K2)) ? _List_fromArray(
			[
				_Utils_Tuple2(6, 'Please enter a valid address.')
			]) : _List_Nil;
	});
var $author$project$Components$Practice$AccountForm$EinValidation = 5;
var $author$project$Ui$Form$Ein$einFormat = '^(?!00|[01][789]|2[89]|[4678]9|7[08]|9[67])\\d\\d\\d{7}$';
var $author$project$Components$Practice$AccountForm$validateEin = function (fields) {
	var _v0 = fields.Q9;
	if (_v0.$ === 1) {
		return _List_Nil;
	} else {
		var ein = _v0.a;
		return A2($author$project$Utils$Regex$matches, $author$project$Ui$Form$Ein$einFormat, ein) ? _List_Nil : _List_fromArray(
			[
				_Utils_Tuple2(5, 'Please enter a valid EIN.')
			]);
	}
};
var $author$project$Components$Practice$AccountForm$EmailValidation = 3;
var $author$project$Components$Practice$AccountForm$validateEmail = F2(
	function (model, fields) {
		var _v0 = fields.Rj;
		if (_v0.$ === 1) {
			return (model.nR && model.bb) ? _List_fromArray(
				[
					_Utils_Tuple2(3, 'Please enter an email.')
				]) : _List_Nil;
		} else {
			var email = _v0.a;
			return $rtfeldman$elm_validate$Validate$isValidEmail(email) ? _List_Nil : _List_fromArray(
				[
					_Utils_Tuple2(3, 'Please enter a valid email.')
				]);
		}
	});
var $author$project$Components$Practice$AccountForm$SessionTimeoutInMinutesValidation = 4;
var $author$project$Components$Practice$AccountForm$validateSessionTimeout = function (fields) {
	var invalid = _List_fromArray(
		[
			_Utils_Tuple2(4, 'Please enter a number between 5 and 480.')
		]);
	var _v0 = fields.alp;
	if (!_v0.$) {
		var sessionTimeoutInMinutes = _v0.a;
		return ((sessionTimeoutInMinutes < 5) || (sessionTimeoutInMinutes > 480)) ? invalid : _List_Nil;
	} else {
		return invalid;
	}
};
var $author$project$Components$Practice$AccountForm$UrlValidation = 1;
var $author$project$Utils$Url$validUrlRegex = '^(http:\\/\\/www\\.|https:\\/\\/www\\.|http:\\/\\/|https:\\/\\/)?[a-z0-9]+([\\-\\.]{1}[a-z0-9]+)*\\.[a-z]{2,10}(:[0-9]{1,5})?(\\/.*)?$';
var $author$project$Components$Practice$AccountForm$validateUrl = F2(
	function (model, fields) {
		var _v0 = fields.adY;
		if (_v0.$ === 1) {
			return _List_Nil;
		} else {
			var url = _v0.a;
			return ((!model.bb) && ((!A2($author$project$Utils$Regex$matches, $author$project$Utils$Url$validUrlRegex, url)) && (!$elm$core$String$isEmpty(url)))) ? _List_fromArray(
				[
					_Utils_Tuple2(1, 'Please enter a valid URL.')
				]) : _List_Nil;
		}
	});
var $author$project$Components$Practice$AccountForm$formFieldsValidator = function (model) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_validate$Validate$ifBlank,
				function ($) {
					return $.Bq;
				},
				_Utils_Tuple2(0, 'Please enter a name.')),
				A3(
				$author$project$Utils$Validate$ifIntGreaterThan,
				function ($) {
					return $.Iu;
				},
				$author$project$Components$Practice$AccountForm$maxLogoBytesSize,
				_Utils_Tuple2(2, 'That image is too large! Our maximum image size is 5 mb, please choose a smaller image.')),
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$Practice$AccountForm$validateUrl(model)),
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$Practice$AccountForm$validateEmail(model)),
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$Practice$AccountForm$validateAddress(model)),
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Practice$AccountForm$validateEin),
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Practice$AccountForm$validateSessionTimeout)
			]));
};
var $author$project$Components$Practice$AccountForm$validate = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.SD);
	var address = $author$project$Components$AddressInput$validate(fields.K2);
	var newForm = A3(
		$author$project$Utils$Form$update,
		$author$project$Components$Practice$AccountForm$formFieldsUpdate,
		$author$project$Components$Practice$AccountForm$Address(address),
		model.SD);
	return A2(
		$elm$core$Result$mapError,
		function (validatedForm) {
			return _Utils_update(
				model,
				{SD: validatedForm});
		},
		A2(
			$elm$core$Result$map,
			function (_v1) {
				var validatedForm = _v1.a;
				var validFormFields = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{SD: validatedForm}),
					validFormFields);
			},
			A2(
				$author$project$Utils$Form$validate,
				$author$project$Components$Practice$AccountForm$formFieldsValidator(model),
				newForm)));
};
var $author$project$Pages$Admin$Practice$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Components$Practice$AccountForm$update, subMsg, model.cX);
				var accountFormModel = _v1.a;
				var accountFormCmd = _v1.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cX: accountFormModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Practice$AccountFormMsg, accountFormCmd),
					_List_Nil);
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{i9: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{i9: false, k9: $author$project$Api$Data$NotAsked}),
						$author$project$Ports$Session$logout(
							{aku: true}),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Practice has been deleted')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{i9: false, k9: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 3:
				var _v3 = $author$project$Components$Practice$AccountForm$validate(model.cX);
				if (!_v3.$) {
					var _v4 = _v3.a;
					var validatedForm = _v4.a;
					var validFormFields = _v4.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cX: validatedForm, k9: $author$project$Api$Data$Loading}),
						A2($author$project$Pages$Admin$Practice$updatePractice, model.Gv, validFormFields),
						_List_Nil);
				} else {
					var formErrors = _v3.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cX: formErrors, k9: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 4:
				var confirmed = msg.a;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{k9: $author$project$Api$Data$Loading}),
					A2($author$project$Api$Provider$Practice$delete, model.Gv, $author$project$Pages$Admin$Practice$Deleted),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{i9: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					var practice = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: response}),
						A3($author$project$Pages$Admin$Practice$retrieveWhitelabelSetting, practice, model.Gv, model.aa4),
						_List_fromArray(
							[
								$author$project$OutMsg$PracticeUpdated(response)
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: response}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 8:
				var practice = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var _v7 = A4(
						$author$project$Components$Practice$AccountForm$init,
						practice,
						response,
						model.lk,
						{bb: false, Yk: false});
					var form = _v7.a;
					var cmds = _v7.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cX: form}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Practice$AccountFormMsg, cmds),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your practice has been updated'),
								$author$project$OutMsg$WhitelabelSettingsUpdated(response)
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 6:
				var _v8 = $author$project$Components$Admin$Practice$DeactivateModal$open(model.ZV);
				var deactivateModalModel = _v8.a;
				var cmd = _v8.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PO: deactivateModalModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Practice$DeactivateModalMsg, cmd),
					_List_Nil);
			default:
				var subMsg = msg.a;
				var result = A3($author$project$Components$Admin$Practice$DeactivateModal$update, model.Gv, subMsg, model.PO);
				var newModel = function () {
					var _v9 = result.agZ;
					if (_v9.$ === 1) {
						var practice = _v9.a;
						return _Utils_update(
							model,
							{ZV: practice});
					} else {
						return model;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{PO: result.aiO}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Practice$DeactivateModalMsg, result.GZ),
					result.aR);
		}
	});
var $author$project$Pages$Admin$Practice$Deactivate = {$: 6};
var $author$project$Pages$Admin$Practice$Delete = {$: 1};
var $author$project$Pages$Admin$Practice$FormSubmitted = {$: 3};
var $author$project$Api$Provider$Practice$Shared$deactivated = function (_v0) {
	var record = _v0;
	return record.PQ;
};
var $author$project$Api$Provider$Practice$One$deactivated = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$deactivated(shared);
};
var $author$project$Components$Admin$Practice$DeactivateModal$CancellationReasonSelected = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Admin$Practice$DeactivateModal$Deactivate = {$: 1};
var $author$project$Components$Admin$Practice$DeactivateModal$RemovePracticeUsersUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$Practice$DeactivateModal$cancellationReasonOptions = A2(
	$elm$core$List$indexedMap,
	F2(
		function (index, reason) {
			return A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(
					$elm$core$String$fromInt(index)),
				reason);
		}),
	$author$project$Components$Admin$Practice$DeactivateModal$cancellationReasons);
var $author$project$Components$Admin$Practice$DeactivateModal$viewModal = F6(
	function (practice, removePracticeUsers, request, maybeDate, dateInput, cancellationReason) {
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$Admin$Practice$DeactivateModal$CloseModal,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('Deactivate Practice')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$phi]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[
											$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('You\'re about to deactivate Practice '),
											$elm$html$Html$text(
											$author$project$Api$Provider$Practice$One$name(practice)),
											$elm$html$Html$text(' which stops all billing, payments and notifications. Admins will still be able to login to export data and download reports. This action cannot be undone.')
										]))
								])),
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Prevent users from accessing the Practice'),
									$author$project$Ui$Form$Group$labelSpan(6),
									$author$project$Ui$Form$Group$labelSpanSm(8),
									$author$project$Ui$Form$Group$inputSpan(6),
									$author$project$Ui$Form$Group$labelSpan(4)
								]),
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$view(
									_List_fromArray(
										[
											$author$project$Ui$ToggleSwitch$on(removePracticeUsers),
											$author$project$Ui$ToggleSwitch$onChange($author$project$Components$Admin$Practice$DeactivateModal$RemovePracticeUsersUpdated)
										]))
								])),
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Schedule Deactivation Date'),
									$author$project$Ui$Form$Group$labelSpan(6),
									$author$project$Ui$Form$Group$labelSpanSm(8),
									$author$project$Ui$Form$Group$inputSpan(6),
									$author$project$Ui$Form$Group$labelSpan(4)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Components$Admin$Practice$DeactivateModal$DateInputMsg(dateInput),
									A2(
										$author$project$Components$DateInput$view,
										_List_fromArray(
											[
												$author$project$Components$DateInput$value(maybeDate)
											]),
										dateInput))
								])),
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Cancellation Reason'),
									$author$project$Ui$Form$Group$labelSpan(6),
									$author$project$Ui$Form$Group$labelSpanSm(8),
									$author$project$Ui$Form$Group$inputSpan(6),
									$author$project$Ui$Form$Group$labelSpan(4)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Select$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Select$value(
											$elm$core$Maybe$Just(cancellationReason)),
											$author$project$Ui$Form$Select$onChange($author$project$Components$Admin$Practice$DeactivateModal$CancellationReasonSelected)
										]),
									$author$project$Components$Admin$Practice$DeactivateModal$cancellationReasonOptions)
								]))
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Cancel and close modal'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Components$Admin$Practice$DeactivateModal$CloseModal)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Deactivate practice'},
							_List_fromArray(
								[
									$author$project$Ui$Button$danger,
									$author$project$Ui$Button$loading(
									_Utils_eq(request, $author$project$Api$Data$Loading)),
									$author$project$Ui$Button$onClick($author$project$Components$Admin$Practice$DeactivateModal$Deactivate)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Deactivate Practice')
								]))
						]))
				]));
	});
var $author$project$Components$Admin$Practice$DeactivateModal$view = function (model) {
	if (model.$ === 1) {
		var practitioner = model.a;
		var removePracticeUsers = model.b;
		var request = model.c;
		var maybeDate = model.d;
		var dateInput = model.e;
		var cancellationReason = model.f;
		return A6($author$project$Components$Admin$Practice$DeactivateModal$viewModal, practitioner, removePracticeUsers, request, maybeDate, dateInput, cancellationReason);
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Practice$AccountForm$Ein = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Practice$AccountForm$Email = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Practice$AccountForm$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Practice$AccountForm$SessionTimeoutInMinutes = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Practice$AccountForm$Url = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$Ein$Errors = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Form$Ein$errors = $author$project$Ui$Form$Ein$Errors;
var $author$project$Ui$Form$Ein$Invalid = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Form$Ein$invalid = function (bool) {
	return $author$project$Ui$Form$Ein$Invalid(bool);
};
var $author$project$Ui$Form$Ein$OnInput = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$Ein$onInput = $author$project$Ui$Form$Ein$OnInput;
var $author$project$Ui$Form$Ein$Value = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$Ein$value = $author$project$Ui$Form$Ein$Value;
var $author$project$Ui$Form$Ein$einMask = '##-#######';
var $author$project$Ui$Form$Ein$einPattern = $agustinrhcp$elm_mask$Mask$fromString($author$project$Ui$Form$Ein$einMask);
var $author$project$Ui$Form$Input$OnMaskedInput = F3(
	function (a, b, c) {
		return {$: 10, a: a, b: b, c: c};
	});
var $author$project$Ui$Form$Input$onMaskedInput = $author$project$Ui$Form$Input$OnMaskedInput;
var $author$project$Ui$Form$Ein$defaultOptions = {agX: _List_Nil, sM: false, ajm: $elm$core$Maybe$Nothing, aj3: $elm$core$Maybe$Nothing, aee: $elm$core$Maybe$Nothing};
var $author$project$Ui$Form$Ein$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var handler = option.a;
						return _Utils_update(
							record,
							{
								ajm: $elm$core$Maybe$Just(handler)
							});
					case 1:
						var string = option.a;
						return _Utils_update(
							record,
							{aee: string});
					case 2:
						var bool = option.a;
						return _Utils_update(
							record,
							{sM: bool});
					case 3:
						var list = option.a;
						return _Utils_update(
							record,
							{agX: list});
					default:
						var string = option.a;
						return _Utils_update(
							record,
							{
								aj3: $elm$core$Maybe$Just(string)
							});
				}
			}),
		$author$project$Ui$Form$Ein$defaultOptions,
		options);
};
var $author$project$Ui$Form$Ein$view = function (options) {
	var optionsRecord = $author$project$Ui$Form$Ein$optionsToRecord(options);
	var value_ = A2($elm$core$Maybe$withDefault, '', optionsRecord.aee);
	var onInput_ = function () {
		var _v0 = optionsRecord.ajm;
		if (!_v0.$) {
			var handler = _v0.a;
			return _List_fromArray(
				[
					A3($author$project$Ui$Form$Input$onMaskedInput, $author$project$Ui$Form$Ein$einPattern, value_, handler)
				]);
		} else {
			return _List_Nil;
		}
	}();
	return $author$project$Ui$Form$Input$view(
		A2(
			$elm$core$List$cons,
			$author$project$Ui$Form$Input$autoComplete(false),
			A2(
				$elm$core$List$cons,
				A2($author$project$Ui$Form$Input$maskedValue, $author$project$Ui$Form$Ein$einPattern, value_),
				A2(
					$elm$core$List$cons,
					$author$project$Ui$Form$Input$invalid(optionsRecord.sM),
					A2(
						$elm$core$List$cons,
						$author$project$Ui$Form$Input$errors(optionsRecord.agX),
						A2(
							$elm$core$List$cons,
							$author$project$Ui$Form$Input$placeholder(
								A2($elm$core$Maybe$withDefault, '', optionsRecord.aj3)),
							onInput_))))));
};
var $author$project$Components$Practice$AccountForm$EmrSelected = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$Practice$Emr$toLabel = function (_v0) {
	var name = _v0.Bq;
	return name;
};
var $author$project$Api$Provider$Practice$Emr$toOption = function (_v0) {
	var option = _v0.ay;
	return option;
};
var $author$project$Components$Practice$AccountForm$viewEmrSelect = F2(
	function (model, fields) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(3),
					$author$project$Ui$Form$Group$inputSpan(9),
					$author$project$Ui$Form$Group$label('EMR')
				]),
			_List_fromArray(
				[
					function () {
					var items = A2(
						$elm$core$List$map,
						function (emr) {
							return A2(
								$author$project$Ui$Dropdown$item,
								_List_fromArray(
									[
										$author$project$Ui$Dropdown$onSelect(
										$author$project$Components$Practice$AccountForm$EmrSelected(
											$elm$core$Maybe$Just(emr))),
										$author$project$Ui$Dropdown$selected(
										_Utils_eq(
											fields.agO,
											$elm$core$Maybe$Just(emr)))
									]),
								$elm$html$Html$text(
									$author$project$Api$Provider$Practice$Emr$toLabel(emr)));
						},
						$author$project$Api$Provider$Practice$Emr$options);
					var currentLabel = function () {
						var _v0 = fields.agO;
						if (!_v0.$) {
							var emr = _v0.a;
							return $author$project$Api$Provider$Practice$Emr$toLabel(emr);
						} else {
							return 'Select an EMR';
						}
					}();
					return A4(
						$author$project$Ui$Dropdown$viewSelect,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(currentLabel)
							]),
						items,
						model.nw);
				}(),
					_Utils_eq(
					A2($elm$core$Maybe$map, $author$project$Api$Provider$Practice$Emr$toOption, fields.agO),
					$elm$core$Maybe$Just(13)) ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mt-2')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(
									A2($elm$core$Maybe$withDefault, '', fields.agQ)),
									$author$project$Ui$Form$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										A2($elm$core$Basics$composeL, $author$project$Components$Practice$AccountForm$FormUpdated, $author$project$Components$Practice$AccountForm$EmrOther),
										$author$project$Utils$String$toMaybe))
								]))
						])) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$Practice$AccountForm$FaviconUploaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Practice$AccountForm$LogoUploaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Practice$AccountForm$viewLogos = F3(
	function (_v0, form, isOnboarding) {
		var currentLogoUrl = _v0.Pg;
		var currentFaviconUrl = _v0.y$;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mt-2 mb-2')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Logo')
										])),
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$helpBlock]),
									_List_fromArray(
										[
											$elm$html$Html$text('Recommended size: 400x200 px or larger.'),
											A2($elm$html$Html$br, _List_Nil, _List_Nil),
											$elm$html$Html$text('Supported image file: JPG, PNG')
										])),
									$author$project$Ui$Form$File$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$File$accept(0),
											$author$project$Ui$Form$File$onInput($author$project$Components$Practice$AccountForm$LogoUploaded),
											$author$project$Ui$Form$File$empty(true)
										])),
									function () {
									if (!currentLogoUrl.$) {
										if (currentLogoUrl.a === '') {
											return $author$project$Utils$Html$empty;
										} else {
											var url = currentLogoUrl.a;
											return A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$mt4]),
												_List_fromArray(
													[
														A3(
														$author$project$Ui$Image$fromSrc,
														{LD: 'Uploaded image'},
														url,
														_List_fromArray(
															[
																$author$project$Ui$Image$height(50)
															])),
														$author$project$Utils$FormErrors$view(
														A2($author$project$Utils$Form$validationErrors, 2, form))
													]));
										}
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								])),
							isOnboarding ? A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(6)
								]),
							_List_Nil) : A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Browser Tab Image (Favicon)')
										])),
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$helpBlock]),
									_List_fromArray(
										[
											$elm$html$Html$text('Recommended size: 260x260 px or larger.'),
											A2($elm$html$Html$br, _List_Nil, _List_Nil),
											$elm$html$Html$text('Supported image file: PNG')
										])),
									$author$project$Ui$Form$File$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$File$accept(0),
											$author$project$Ui$Form$File$onInput($author$project$Components$Practice$AccountForm$FaviconUploaded),
											$author$project$Ui$Form$File$empty(true)
										])),
									function () {
									if (!currentFaviconUrl.$) {
										if (currentFaviconUrl.a === '') {
											return $author$project$Utils$Html$empty;
										} else {
											var url = currentFaviconUrl.a;
											return A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$mt4]),
												_List_fromArray(
													[
														A3(
														$author$project$Ui$Image$fromSrc,
														{LD: 'Uploaded favicon'},
														url,
														_List_fromArray(
															[
																$author$project$Ui$Image$height(50)
															]))
													]));
										}
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								]))
						]))
				]));
	});
var $author$project$Components$Practice$AccountForm$view = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.SD);
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(3),
						$author$project$Ui$Form$Group$inputSpan(9),
						$author$project$Ui$Form$Group$label('Name'),
						$author$project$Ui$Form$Group$required(true)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(fields.Bq),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Components$Practice$AccountForm$FormUpdated, $author$project$Components$Practice$AccountForm$Name)),
								$author$project$Ui$Form$Input$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 0, model.SD)),
								$author$project$Ui$Form$Input$errors(
								A2($author$project$Utils$Form$validationErrors, 0, model.SD))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(3),
						$author$project$Ui$Form$Group$inputSpan(9),
						$author$project$Ui$Form$Group$label('Website')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(
								A2($elm$core$Maybe$withDefault, '', fields.adY)),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Components$Practice$AccountForm$FormUpdated, $author$project$Components$Practice$AccountForm$Url)),
								$author$project$Ui$Form$Input$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 1, model.SD)),
								$author$project$Ui$Form$Input$errors(
								A2($author$project$Utils$Form$validationErrors, 1, model.SD))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(3),
						$author$project$Ui$Form$Group$inputSpan(9),
						$author$project$Ui$Form$Group$label('Practice Logo'),
						$author$project$Ui$Form$Group$labelHelp(
						A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[$author$project$Ui$Typography$helpText, $author$project$Ui$Typography$small]),
							'Shown to Patients'))
					]),
				_List_fromArray(
					[
						A3($author$project$Components$Practice$AccountForm$viewLogos, fields, model.SD, model.bb)
					])),
				(model.bb && model.nR) ? $author$project$Utils$Html$empty : A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(3),
						$author$project$Ui$Form$Group$inputSpan(9),
						$author$project$Ui$Form$Group$label('Practice Phone')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Components$Practice$AccountForm$PhoneInputMsg,
						$author$project$Components$PhoneInput$view(fields.Zw))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(3),
						$author$project$Ui$Form$Group$inputSpan(9),
						$author$project$Ui$Form$Group$label('Practice Email'),
						$author$project$Ui$Form$Group$required(model.nR && model.bb)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(
								A2($elm$core$Maybe$withDefault, '', fields.Rj)),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Components$Practice$AccountForm$FormUpdated, $author$project$Components$Practice$AccountForm$Email)),
								$author$project$Ui$Form$Input$placeholder('contact@mypractice.com'),
								$author$project$Ui$Form$Input$phi(true),
								$author$project$Ui$Form$Input$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 3, model.SD)),
								$author$project$Ui$Form$Input$errors(
								A2($author$project$Utils$Form$validationErrors, 3, model.SD))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(3),
						$author$project$Ui$Form$Group$inputSpan(9),
						$author$project$Ui$Form$Group$label('Business Address'),
						$author$project$Ui$Form$Group$required(model.Gk)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Components$Practice$AccountForm$AddressInputMsg,
						A2($author$project$Components$AddressInput$view, _List_Nil, fields.K2))
					])),
				model.bb ? $author$project$Utils$Html$empty : A2($author$project$Components$Practice$AccountForm$viewEmrSelect, model, fields),
				(model.bb && model.nR) ? $author$project$Utils$Html$empty : A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpan(3),
						$author$project$Ui$Form$Group$inputSpan(9),
						$author$project$Ui$Form$Group$label('Employer Identification Number (EIN)')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Ein$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Ein$value(fields.Q9),
								$author$project$Ui$Form$Ein$onInput(
								A2($elm$core$Basics$composeL, $author$project$Components$Practice$AccountForm$FormUpdated, $author$project$Components$Practice$AccountForm$Ein)),
								$author$project$Ui$Form$Ein$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 5, model.SD)),
								$author$project$Ui$Form$Ein$errors(
								A2($author$project$Utils$Form$validationErrors, 5, model.SD))
							]))
					])),
				model.bb ? $author$project$Utils$Html$empty : A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(3),
						$author$project$Ui$Form$Group$inputSpan(9),
						$author$project$Ui$Form$Group$label('Auto Logout After'),
						$author$project$Ui$Form$Group$required(true)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$group(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$number,
										$author$project$Ui$Form$Input$value(
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2($elm$core$Maybe$map, $elm$core$String$fromInt, fields.alp))),
										$author$project$Ui$Form$Input$onInput(
										A2($elm$core$Basics$composeL, $author$project$Components$Practice$AccountForm$FormUpdated, $author$project$Components$Practice$AccountForm$SessionTimeoutInMinutes)),
										$author$project$Ui$Form$Input$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 4, model.SD))
									])),
								$author$project$Ui$Form$Input$addon(
								_List_fromArray(
									[
										$elm$html$Html$text('minutes')
									]))
							])),
						$author$project$Utils$FormErrors$view(
						A2($author$project$Utils$Form$validationErrors, 4, model.SD)),
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$helpText]),
						_List_fromArray(
							[
								$elm$html$Html$text('In order to protect your patients\' data when you are not using the app, the application will log you out after this number of minutes.')
							]))
					]))
			]));
};
var $author$project$Pages$Admin$Practice$view = function (model) {
	var loading = _Utils_eq(model.k9, $author$project$Api$Data$Loading);
	return {
		fO: _List_fromArray(
			[
				function () {
				if (model.i9) {
					var practiceName = $author$project$Api$Provider$Practice$One$name(model.ZV);
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Admin$Practice$HiConfirmClosed,
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('delete'),
								$author$project$Components$HiConfirm$noun(practiceName),
								$author$project$Components$HiConfirm$loading(loading),
								$author$project$Components$HiConfirm$detail(' and disable all login access')
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Admin$Practice$DeactivateModalMsg,
				$author$project$Components$Admin$Practice$DeactivateModal$view(model.PO)),
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$autocomplete(false),
						$author$project$Ui$Form$noValidate(true),
						$author$project$Ui$Form$onSubmit($author$project$Pages$Admin$Practice$FormSubmitted)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Practice')
											]))
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$mb4]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$text,
														_List_fromArray(
															[$author$project$Ui$Typography$muted]),
														'The practice info on this page will be used for invoicing, patient billing inquiries and automated notifications')
													])),
												A2(
												$elm$html$Html$map,
												$author$project$Pages$Admin$Practice$AccountFormMsg,
												$author$project$Components$Practice$AccountForm$view(model.cX)),
												function () {
												var _v0 = model.k9;
												if (_v0.$ === 2) {
													var error = _v0.a;
													return A2(
														$author$project$Ui$Element$view,
														_List_fromArray(
															[$author$project$Ui$Element$mt4]),
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Alert$danger,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		$author$project$Api$Data$errorToString(error))
																	]))
															]));
												} else {
													return $author$project$Utils$Html$empty;
												}
											}()
											]))
									])),
								A2(
								$author$project$Ui$Panel$footer,
								_List_fromArray(
									[$author$project$Ui$Element$justifyCenter]),
								_List_fromArray(
									[
										function () {
										var _v1 = _Utils_Tuple2(
											model.Ij,
											$author$project$Api$Provider$Practice$One$deactivated(model.ZV));
										if (_v1.a) {
											if (!_v1.b) {
												return A3(
													$author$project$Ui$HinterOnly$button,
													{mm: 'Deactivate practice'},
													_List_fromArray(
														[
															$author$project$Ui$Button$danger,
															$author$project$Ui$Button$onClick($author$project$Pages$Admin$Practice$Deactivate)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Deactivate')
														]));
											} else {
												return A3(
													$author$project$Ui$HinterOnly$button,
													{mm: 'Delete practice'},
													_List_fromArray(
														[
															$author$project$Ui$Button$danger,
															$author$project$Ui$Button$onClick($author$project$Pages$Admin$Practice$Delete)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Delete')
														]));
											}
										} else {
											return $author$project$Utils$Html$empty;
										}
									}(),
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Update practice'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$submit,
												$author$project$Ui$Button$loading(loading)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Update')
											]))
									]))
							]))
					]))
			]),
		ac9: 'Admin | Practice'
	};
};
var $author$project$Pages$Admin$Practice$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Practice$init, aiq: $author$project$Pages$Admin$Practice$load, k8: $author$project$Pages$Admin$Practice$save, alO: $author$project$Pages$Admin$Practice$subscriptions, adT: $author$project$Pages$Admin$Practice$update, amo: $author$project$Pages$Admin$Practice$view});
var $author$project$Pages$Admin$ProviderGroups$GotLocationGroups = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$LocationGroup$IntegrationRecords = 0;
var $author$project$Pages$Admin$ProviderGroups$fetchLocationGroups = function (model) {
	return A3(
		$author$project$Api$Provider$LocationGroup$list,
		model.Gv,
		function (d) {
			return _Utils_update(
				d,
				{
					HE: _List_fromArray(
						[0])
				});
		},
		$author$project$Pages$Admin$ProviderGroups$GotLocationGroups);
};
var $author$project$Pages$Admin$ProviderGroups$init = F4(
	function (_v0, practice, _v1, _v2) {
		var apiClient = _v1.Gv;
		var model = {
			Gv: apiClient,
			jf: $elm$core$Maybe$Nothing,
			eh: $elm$core$Set$empty,
			s4: $elm$core$Maybe$Nothing,
			Wa: $author$project$Api$Data$Loading,
			akQ: $author$project$Api$Provider$Practice$One$requireGroupForLocations(practice)
		};
		return _Utils_Tuple2(
			model,
			$author$project$Pages$Admin$ProviderGroups$fetchLocationGroups(model));
	});
var $author$project$Pages$Admin$ProviderGroups$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$ProviderGroups$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$ProviderGroups$CancelLocationGroupEdit = {$: 3};
var $author$project$Pages$Admin$ProviderGroups$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Pages$Admin$ProviderGroups$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Admin$ProviderGroups$CancelLocationGroupEdit)),
					model.s4)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$ProviderGroups$HiConfirmClosed),
					model.jf))
			]));
};
var $author$project$Pages$Admin$ProviderGroups$LocationGroupDeleted = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Api$Provider$LocationGroup$locationGroupPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$LocationGroup$locationGroupsPath);
};
var $author$project$Api$Provider$LocationGroup$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$LocationGroup$locationGroupPath(id_)));
	});
var $author$project$Pages$Admin$ProviderGroups$formFieldsFromLocationGroup = function (locationGroup) {
	return $author$project$Api$Provider$LocationGroup$All$name(locationGroup);
};
var $author$project$Pages$Admin$ProviderGroups$formFieldsInit = '';
var $author$project$Pages$Admin$ProviderGroups$formFieldsUpdate = F2(
	function (field, _v0) {
		var name = field;
		return name;
	});
var $author$project$Pages$Admin$ProviderGroups$NameValidation = 0;
var $author$project$Pages$Admin$ProviderGroups$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			$elm$core$Basics$identity,
			_Utils_Tuple2(0, 'Please enter a name.'))
		]));
var $author$project$Api$Provider$LocationGroup$All$locationsCount = function (_v0) {
	var record = _v0.b;
	return record.Wh;
};
var $author$project$Api$Provider$LocationGroup$One$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Common$LocationGroup$Shared$name(shared);
};
var $author$project$Pages$Admin$ProviderGroups$LocationGroupCreated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$LocationGroup$One$LocationGroup = $elm$core$Basics$identity;
var $author$project$Api$Provider$LocationGroup$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$LocationGroup$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$LocationGroup$create = F3(
	function (apiClient, name_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'location_group',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(name_))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$LocationGroup$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$LocationGroup$locationGroupsPath)));
	});
var $author$project$Pages$Admin$ProviderGroups$createLocationGroup = F2(
	function (apiClient, formFields) {
		var name = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A3($author$project$Api$Provider$LocationGroup$create, apiClient, name, $author$project$Pages$Admin$ProviderGroups$LocationGroupCreated);
	});
var $author$project$Pages$Admin$ProviderGroups$LocationGroupUpdated = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$LocationGroup$update = F4(
	function (apiClient, id_, name_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'location_group',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(name_))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$LocationGroup$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$LocationGroup$locationGroupPath(id_))));
	});
var $author$project$Pages$Admin$ProviderGroups$updateLocationGroup = F3(
	function (apiClient, id, formFields) {
		var name = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4($author$project$Api$Provider$LocationGroup$update, apiClient, id, name, $author$project$Pages$Admin$ProviderGroups$LocationGroupUpdated);
	});
var $author$project$Pages$Admin$ProviderGroups$saveLocationGroup = F3(
	function (apiClient, maybeId, formFields) {
		if (!maybeId.$) {
			var id_ = maybeId.a;
			return A3($author$project$Pages$Admin$ProviderGroups$updateLocationGroup, apiClient, id_, formFields);
		} else {
			return A2($author$project$Pages$Admin$ProviderGroups$createLocationGroup, apiClient, formFields);
		}
	});
var $author$project$Pages$Admin$ProviderGroups$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							s4: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init($author$project$Pages$Admin$ProviderGroups$formFieldsInit),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var locationGroup = msg.a;
				return (($author$project$Api$Provider$LocationGroup$All$locationsCount(locationGroup) > 0) && model.akQ) ? _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{
							jf: $elm$core$Maybe$Just(locationGroup)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 10:
				var locationGroup = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							jf: $elm$core$Maybe$Nothing,
							eh: A2(
								$elm$core$Set$insert,
								$author$project$Api$Provider$LocationGroup$All$id(locationGroup),
								model.eh)
						}),
					A3(
						$author$project$Api$Provider$LocationGroup$delete,
						model.Gv,
						$author$project$Api$Provider$LocationGroup$All$id(locationGroup),
						$author$project$Pages$Admin$ProviderGroups$LocationGroupDeleted(locationGroup)),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{jf: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var locationGroup = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							s4: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(
										$author$project$Api$Provider$LocationGroup$All$id(locationGroup)),
									$author$project$Utils$Form$init(
										$author$project$Pages$Admin$ProviderGroups$formFieldsFromLocationGroup(locationGroup)),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var form = msg.a;
				var id = msg.b;
				var _v1 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$ProviderGroups$formFieldsValidator, form);
				if (!_v1.$) {
					var _v2 = _v1.a;
					var newForm = _v2.a;
					var validFormFields = _v2.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								s4: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, $author$project$Api$Data$Loading))
							}),
						A3($author$project$Pages$Admin$ProviderGroups$saveLocationGroup, model.Gv, id, validFormFields),
						_List_Nil);
				} else {
					var newForm = _v1.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								s4: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{s4: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var dataLocationGroups = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Wa: dataLocationGroups}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$reportDecodeError(dataLocationGroups));
			case 6:
				var field = msg.a;
				var _v3 = model.s4;
				if (!_v3.$) {
					var _v4 = _v3.a;
					var id = _v4.a;
					var form = _v4.b;
					var locationGroup = _v4.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$ProviderGroups$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								s4: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, locationGroup))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var dataLocationGroup = msg.a;
				var _v5 = model.s4;
				if (!_v5.$) {
					var _v6 = _v5.a;
					var id = _v6.a;
					var form = _v6.b;
					if (dataLocationGroup.$ === 3) {
						var locationGroup = dataLocationGroup.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{s4: $elm$core$Maybe$Nothing, Wa: $author$project$Api$Data$Loading}),
							$author$project$Pages$Admin$ProviderGroups$fetchLocationGroups(model),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									'Successfully created ' + $author$project$Api$Provider$LocationGroup$One$name(locationGroup))
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									s4: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, dataLocationGroup))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(dataLocationGroup));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 8:
				var dataLocationGroup = msg.a;
				var _v8 = model.s4;
				if (!_v8.$) {
					var _v9 = _v8.a;
					var id = _v9.a;
					var form = _v9.b;
					if (dataLocationGroup.$ === 3) {
						var locationGroup = dataLocationGroup.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{s4: $elm$core$Maybe$Nothing, Wa: $author$project$Api$Data$Loading}),
							$author$project$Pages$Admin$ProviderGroups$fetchLocationGroups(model),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Provider$LocationGroup$One$name(locationGroup) + ' was successfully updated.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									s4: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, dataLocationGroup))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(dataLocationGroup));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var locationGroup = msg.a;
				var dataLocationGroup = msg.b;
				switch (dataLocationGroup.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									eh: A2(
										$elm$core$Set$remove,
										$author$project$Api$Provider$LocationGroup$All$id(locationGroup),
										model.eh),
									Wa: $author$project$Api$Data$Loading
								}),
							$author$project$Pages$Admin$ProviderGroups$fetchLocationGroups(model),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Provider$LocationGroup$All$name(locationGroup) + ' was successfully removed.')
								]));
					case 2:
						var error = dataLocationGroup.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									eh: A2(
										$elm$core$Set$remove,
										$author$project$Api$Provider$LocationGroup$All$id(locationGroup),
										model.eh)
								}),
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error)),
								$author$project$OutMsg$reportDecodeError(dataLocationGroup)));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Admin$ProviderGroups$NewLocationGroup = {$: 0};
var $author$project$Pages$Admin$ProviderGroups$FormUpdated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Admin$ProviderGroups$Name = $elm$core$Basics$identity;
var $author$project$Pages$Admin$ProviderGroups$SaveLocationGroup = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Pages$Admin$ProviderGroups$viewLocationGroupModal = F3(
	function (id, form, locationGroup) {
		var name = $author$project$Utils$Form$fields(form);
		var modalConfig = {
			Tq: $elm$core$Maybe$Nothing,
			aih: 'Location Group',
			V8: _Utils_eq(locationGroup, $author$project$Api$Data$Loading),
			WG: id,
			WH: $elm$core$Maybe$Nothing,
			Yd: $author$project$Pages$Admin$ProviderGroups$CancelLocationGroupEdit,
			Yf: $author$project$Pages$Admin$ProviderGroups$SaveLocationGroup(form)
		};
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(4),
							$author$project$Ui$Form$Group$label('Description'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(name),
									$author$project$Ui$Form$Input$placeholder('Downtown Clinic'),
									$author$project$Ui$Form$Input$autofocus(true),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$ProviderGroups$FormUpdated, $elm$core$Basics$identity)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form))
								])),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						]))
				]));
	});
var $author$project$Pages$Admin$ProviderGroups$DeleteLocationGroup = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$ProviderGroups$EditLocationGroup = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$LocationGroup$All$integrationRecords = function (_v0) {
	var record = _v0.b;
	return record.Ub;
};
var $author$project$Api$Provider$Integration$SharedWithInlinePartner$partnerName = function (_v0) {
	var inlinePartner = _v0.b;
	return $author$project$Api$Provider$Partner$Shared$name(inlinePartner);
};
var $author$project$Api$Provider$Integration$Shared$productName = function (_v0) {
	var record = _v0;
	return record._x;
};
var $author$project$Api$Provider$Integration$SharedWithInlinePartner$productName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Integration$Shared$productName(shared);
};
var $author$project$Api$Provider$Integration$SharedWithInlinePartner$displayName = function (integration) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Api$Provider$Integration$SharedWithInlinePartner$partnerName(integration),
		$author$project$Api$Provider$Integration$SharedWithInlinePartner$productName(integration));
};
var $author$project$Api$Provider$IntegrationRecord$One$integration = function (_v0) {
	var record = _v0.b;
	return record.T8;
};
var $author$project$Api$Provider$IntegrationRecord$Shared$integrationSyncStatus = function (_v0) {
	var record = _v0;
	return record.Uc;
};
var $author$project$Api$Provider$IntegrationRecord$One$integrationSyncStatus = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$IntegrationRecord$Shared$integrationSyncStatus(shared);
};
var $author$project$Api$IntegrationRecord$Status$toString = function (status) {
	switch (status) {
		case 0:
			return 'synced';
		case 1:
			return 'unsynced';
		case 2:
			return 'errored';
		default:
			return 'enabled';
	}
};
var $author$project$Pages$Admin$ProviderGroups$viewIntegrationRecord = function (integrationRecord) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('spaced-out small')
			]),
		function () {
			var _v0 = $author$project$Api$Provider$IntegrationRecord$One$integrationSyncStatus(integrationRecord);
			if (!_v0) {
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Api$Provider$Integration$SharedWithInlinePartner$displayName(
									$author$project$Api$Provider$IntegrationRecord$One$integration(integrationRecord)))
							])),
						$author$project$Utils$Html$noBreakSpace,
						A2(
						$author$project$Ui$Badge$fromString,
						_List_Nil,
						A2($elm$core$Basics$composeR, $author$project$Api$Provider$IntegrationRecord$One$integrationSyncStatus, $author$project$Api$IntegrationRecord$Status$toString)(integrationRecord))
					]);
			} else {
				return _List_Nil;
			}
		}());
};
var $author$project$Pages$Admin$ProviderGroups$viewLocationGroup = F3(
	function (requireGroupForLocations, deletingLocationGroups, locationGroup) {
		var preventDelete = ($author$project$Api$Provider$LocationGroup$All$locationsCount(locationGroup) > 0) && requireGroupForLocations;
		var integrationRecords = A2(
			$author$project$Api$Expandable$withDefault,
			_List_Nil,
			$author$project$Api$Provider$LocationGroup$All$integrationRecords(locationGroup));
		var id = $author$project$Api$Provider$LocationGroup$All$id(locationGroup);
		var deleting = A2($elm$core$Set$member, id, deletingLocationGroups);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$text(
							$author$project$Api$Provider$LocationGroup$All$name(locationGroup)),
						A2($elm$core$List$map, $author$project$Pages$Admin$ProviderGroups$viewIntegrationRecord, integrationRecords))),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$gap2, $author$project$Ui$Element$justifyRight]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Edit location group'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Admin$ProviderGroups$EditLocationGroup(locationGroup)),
											$author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit')
										])),
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Delete location group'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$disabled(preventDelete),
											$author$project$Ui$Button$loading(deleting),
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Admin$ProviderGroups$DeleteLocationGroup(locationGroup)),
											$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Delete')
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$ProviderGroups$viewPanelBody = function (model) {
	var _v0 = function () {
		var _v1 = model.Wa;
		if (_v1.$ === 3) {
			var locationGroups_ = _v1.a;
			return _Utils_Tuple2(false, locationGroups_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var locationGroups = _v0.b;
	return A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$verticalCentered,
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You have no Location Groups.'),
						A2($elm$html$Html$br, _List_Nil, _List_Nil),
						function () {
						var label = 'Add a Location Group here';
						return A3(
							$author$project$Ui$Button$view,
							{mm: label},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$onClick($author$project$Pages$Admin$ProviderGroups$NewLocationGroup)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(label)
								]));
					}()
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Name')
					])),
				A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
			]),
		A2(
			$elm$core$List$map,
			A2($author$project$Pages$Admin$ProviderGroups$viewLocationGroup, model.akQ, model.eh),
			locationGroups),
		_List_Nil);
};
var $author$project$Pages$Admin$ProviderGroups$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				function () {
				var _v0 = model.s4;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var id = _v1.a;
					var form = _v1.b;
					var locationGroup = _v1.c;
					return A3($author$project$Pages$Admin$ProviderGroups$viewLocationGroupModal, id, form, locationGroup);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v2 = model.jf;
				if (!_v2.$) {
					var locationGroup = _v2.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Admin$ProviderGroups$HiConfirmClosed(locationGroup),
						_Utils_ap(
							($author$project$Api$Provider$LocationGroup$All$locationsCount(locationGroup) > 0) ? _List_fromArray(
								[
									$author$project$Components$HiConfirm$sentence(
									'It is currently assigned to ' + (A2(
										$author$project$Formatters$String$pluralize,
										'location',
										$author$project$Api$Provider$LocationGroup$All$locationsCount(locationGroup)) + '. Are you sure?'))
								]) : _List_Nil,
							_List_fromArray(
								[
									$author$project$Components$HiConfirm$verb('delete'),
									$author$project$Components$HiConfirm$noun('location group')
								])));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Location Groups')
											])),
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Add new location group'},
										_List_fromArray(
											[
												$author$project$Ui$Button$default,
												$author$project$Ui$Button$onClick($author$project$Pages$Admin$ProviderGroups$NewLocationGroup),
												$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('New Location Group')
											]))
									])),
								A2(
								$elm$html$Html$em,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Lets you assign a group to any location')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Pages$Admin$ProviderGroups$viewPanelBody(model)
							]))
					]))
			]),
		ac9: 'Admin | Location Groups'
	};
};
var $author$project$Pages$Admin$ProviderGroups$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$ProviderGroups$init, aiq: $author$project$Pages$Admin$ProviderGroups$load, k8: $author$project$Pages$Admin$ProviderGroups$save, alO: $author$project$Pages$Admin$ProviderGroups$subscriptions, adT: $author$project$Pages$Admin$ProviderGroups$update, amo: $author$project$Pages$Admin$ProviderGroups$view});
var $author$project$Pages$Admin$Providers$Top$GotElationPhysicians = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$Providers$Top$GotLocations = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$Providers$Top$GotPracticeSettings = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$Providers$Top$GotSpecialties = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Admin$Providers$Top$GotList = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Practitioner$Locations = 0;
var $author$project$Api$Provider$Practitioner$All$Practitioner = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Practitioner$All$Record = F3(
	function (pendingInvitesCount, specialties, locations) {
		return {Wg: locations, Zo: pendingInvitesCount, abU: specialties};
	});
var $author$project$Api$Provider$Practitioner$All$recordDecoder = A3(
	$author$project$Api$Expandable$expandable,
	'locations',
	$elm$json$Json$Decode$list($author$project$Api$Provider$Location$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'specialties',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'pending_invites_count',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Practitioner$All$Record))));
var $author$project$Api$Provider$Practitioner$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Practitioner$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Practitioner$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Practitioner$All$Practitioner)));
var $author$project$Api$Provider$Practitioner$expandToString = function (expand) {
	if (!expand) {
		return 'locations';
	} else {
		return 'practice_extras';
	}
};
var $author$project$Api$Provider$Practitioner$listDefaults = {
	q5: $elm$core$Maybe$Nothing,
	q6: $elm$core$Maybe$Nothing,
	Gn: $elm$core$Maybe$Nothing,
	HE: _List_Nil,
	ahP: $elm$core$Maybe$Nothing,
	ais: $elm$core$Maybe$Nothing,
	s4: $elm$core$Maybe$Nothing,
	IW: $elm$core$Maybe$Nothing,
	ajJ: $author$project$Api$Pagination$init,
	akl: $elm$core$Maybe$Nothing,
	JM: $elm$core$Maybe$Nothing,
	alA: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init)
};
var $author$project$Api$Provider$Practitioner$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Practitioner$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.akl;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.ahP;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.s4;
				if (!_v2.$) {
					var string = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'location_group', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v3 = options.ais;
				if (!_v3.$) {
					var string = _v3.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'location', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v4 = options.IW;
				if (!_v4.$) {
					var bool = _v4.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$bool, 'online_signup', bool)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v5 = options.q5;
				if (!_v5.$) {
					var bool = _v5.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$bool, 'accepts_enrollments_from_employer', bool)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v6 = options.q6;
				if (!_v6.$) {
					var bool = _v6.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$bool, 'accepts_enrollments_from_retail', bool)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v7 = options.Gn;
				if (!_v7.$) {
					var string = _v7.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'affiliate', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v8 = options.JM;
				if (!_v8.$) {
					var ident = _v8.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'signup_page', ident)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				A2($author$project$Api$Expandable$toParam, $author$project$Api$Provider$Practitioner$expandToString, options.HE),
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$Provider$Practitioner$practitionersPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['practitioners']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Practitioner$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Practitioner$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Practitioner$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Practitioner$practitionersPath)));
	});
var $author$project$Pages$Admin$Providers$Top$fetchList = function (model) {
	return A3(
		$author$project$Api$Provider$Practitioner$list,
		model.Gv,
		function (d) {
			return _Utils_update(
				d,
				{
					HE: _List_fromArray(
						[0]),
					ajJ: model.ajJ,
					akl: model.akl
				});
		},
		$author$project$Pages$Admin$Providers$Top$GotList);
};
var $author$project$Pages$Admin$Providers$Top$GotPracticeProviderCount = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$Providers$Top$fetchPracticeProviderCount = function (model) {
	return A3(
		$author$project$Api$Provider$Practitioner$list,
		model.Gv,
		function (d) {
			return _Utils_update(
				d,
				{
					ajJ: A2($author$project$Api$Pagination$withItemsPerPage, 1, $author$project$Api$Pagination$init)
				});
		},
		$author$project$Pages$Admin$Providers$Top$GotPracticeProviderCount);
};
var $author$project$Components$Admin$Practitioner$DeleteModal$Closed = {$: 0};
var $author$project$Components$Admin$Practitioner$DeleteModal$init = $author$project$Components$Admin$Practitioner$DeleteModal$Closed;
var $author$project$Api$Provider$ElationPhysician$All$ElationPhysician = $elm$core$Basics$identity;
var $author$project$Api$Provider$ElationPhysician$All$AllRecord = F2(
	function (id, name) {
		return {ahP: id, Bq: name};
	});
var $author$project$Api$Provider$ElationPhysician$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$ElationPhysician$All$AllRecord)));
var $author$project$Api$Provider$ElationPhysician$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ElationPhysician$All$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Practitioner$ElationPhysician$elationPhysiciansPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['elation_physicians']),
	$author$project$Api$Provider$Practitioner$practitionersPath);
var $author$project$Api$Provider$Practitioner$ElationPhysician$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$ElationPhysician$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Practitioner$ElationPhysician$elationPhysiciansPath));
	});
var $author$project$Api$Provider$Specialty$All$Specialty = $elm$core$Basics$identity;
var $author$project$Api$Provider$Specialty$Shared$Specialty = $elm$core$Basics$identity;
var $author$project$Api$Provider$Specialty$Shared$Record = function (name) {
	return {Bq: name};
};
var $author$project$Api$Provider$Specialty$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Specialty$Shared$Record));
var $author$project$Api$Provider$Specialty$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Specialty$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Specialty$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Specialty$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Specialty$specialtiesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['specialties']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Specialty$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Specialty$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Specialty$specialtiesPath));
	});
var $author$project$Api$Provider$PracticeSettings$One$PracticeSettings = $elm$core$Basics$identity;
var $author$project$Api$Provider$PracticeSettings$One$Record = function (showNpi) {
	return {abm: showNpi};
};
var $author$project$Api$Provider$PracticeSettings$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'show_npi',
	$elm$json$Json$Decode$bool,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticeSettings$One$Record));
var $author$project$Api$Provider$PracticeSettings$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PracticeSettings$One$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PracticeSettings$practiceSettingsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['practice/settings']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$PracticeSettings$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$PracticeSettings$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$PracticeSettings$practiceSettingsPath));
	});
var $author$project$Pages$Admin$Providers$Top$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.DE;
		var rawUrl = _v0.akq;
		var q = A2($elm$core$Dict$get, 'q', query);
		var model = {
			bo: $elm$core$Maybe$Nothing,
			Gv: shared.Gv,
			i8: $author$project$Components$Admin$Practitioner$DeleteModal$init,
			je: $elm$core$Maybe$Nothing,
			eg: $elm$core$Set$empty,
			Qj: $elm$core$Set$empty,
			zn: $author$project$Api$Data$Loading,
			Ij: $author$project$Shared$isHintAdmin(shared),
			Io: $elm$core$Maybe$Nothing,
			j4: $author$project$Api$Data$Loading,
			oo: $author$project$Components$LinkedRecords$init,
			Wg: $author$project$Api$Data$Loading,
			ajJ: $author$project$Api$Pagination$initFromQuery(query),
			ZV: practice,
			tX: $elm$core$Maybe$Nothing,
			tY: $author$project$Api$Data$Loading,
			akl: q,
			up: $author$project$Ui$SearchInput$init(q),
			aa4: session,
			abU: $author$project$Api$Data$Loading,
			adY: rawUrl
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Pages$Admin$Providers$Top$fetchList(model),
						$author$project$Pages$Admin$Providers$Top$fetchPracticeProviderCount(model),
						A3($author$project$Api$Provider$Location$list, shared.Gv, $elm$core$Basics$identity, $author$project$Pages$Admin$Providers$Top$GotLocations),
						A2($author$project$Api$Provider$Specialty$list, shared.Gv, $author$project$Pages$Admin$Providers$Top$GotSpecialties),
						A2($author$project$Api$Provider$Practitioner$ElationPhysician$list, shared.Gv, $author$project$Pages$Admin$Providers$Top$GotElationPhysicians),
						A2($author$project$Api$Provider$PracticeSettings$retrieve, shared.Gv, $author$project$Pages$Admin$Providers$Top$GotPracticeSettings)
					])));
	});
var $author$project$Pages$Admin$Providers$Top$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					Ij: $author$project$Shared$isHintAdmin(shared)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Providers$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Providers$Top$CancelAddLocation = {$: 24};
var $author$project$Pages$Admin$Providers$Top$CancelEdit = {$: 8};
var $author$project$Pages$Admin$Providers$Top$DeleteModalMsg = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$Admin$Providers$Top$EditLocationInputMsg = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Pages$Admin$Providers$Top$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$Pages$Admin$Providers$Top$LinkedRecordsMsg = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$Admin$Providers$Top$LocationInputMsg = function (a) {
	return {$: 21, a: a};
};
var $author$project$Components$Admin$Practitioner$DeleteModal$CloseModal = {$: 0};
var $author$project$Components$Admin$Practitioner$DeleteModal$PractitionerResourceFilterMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$ResourceFilter$Practitioner$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Components$ResourceFilter$Practitioner$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.b8));
};
var $author$project$Components$Admin$Practitioner$DeleteModal$subscriptions = function (modal) {
	if (modal.$ === 1) {
		var state = modal.a;
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$Practitioner$DeleteModal$CloseModal),
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$Components$Admin$Practitioner$DeleteModal$PractitionerResourceFilterMsg,
					$author$project$Components$ResourceFilter$Practitioner$subscriptions(state.hk))
				]));
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Components$LocationInput$FilterMsg = $elm$core$Basics$identity;
var $author$project$Components$LocationInput$subscriptions = function (_v0) {
	var filter = _v0.HM;
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$Location$subscriptions(filter));
};
var $author$project$Pages$Admin$Providers$Top$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$Providers$Top$LinkedRecordsMsg,
				$author$project$Components$LinkedRecords$subscriptions(model.oo)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$Providers$Top$DeleteModalMsg,
				$author$project$Components$Admin$Practitioner$DeleteModal$subscriptions(model.i8)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					function (_v0) {
						var locationInput = _v0.b;
						return $elm$core$Platform$Sub$batch(
							_List_fromArray(
								[
									$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Pages$Admin$Providers$Top$CancelAddLocation),
									A2(
									$elm$core$Platform$Sub$map,
									$author$project$Pages$Admin$Providers$Top$LocationInputMsg,
									$author$project$Components$LocationInput$subscriptions(locationInput))
								]));
					},
					model.bo)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					function (state) {
						return $elm$core$Platform$Sub$batch(
							A2(
								$elm$core$List$cons,
								$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Admin$Providers$Top$CancelEdit),
								A2(
									$elm$core$List$indexedMap,
									F2(
										function (index, input) {
											return A2(
												$elm$core$Platform$Sub$map,
												$author$project$Pages$Admin$Providers$Top$EditLocationInputMsg(index),
												$author$project$Components$LocationInput$subscriptions(input));
										}),
									state.bF)));
					},
					model.Io)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$Providers$Top$HiConfirmClosed),
					model.je))
			]));
};
var $author$project$Pages$Admin$Providers$Top$Deleted = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Pages$Admin$Providers$Top$FormUpdated = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Admin$Providers$Top$Location = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Pages$Admin$Providers$Top$LocationAdded = function (a) {
	return {$: 23, a: a};
};
var $author$project$Pages$Admin$Providers$Top$Photo = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$Admin$Providers$Top$PracticeSettingsUpdated = function (a) {
	return {$: 28, a: a};
};
var $author$project$Pages$Admin$Providers$Top$SearchInputMsg = function (a) {
	return {$: 27, a: a};
};
var $author$project$Api$Provider$Practitioner$practitionerPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$Practitioner$practitionersPath);
};
var $author$project$Api$Provider$Practitioner$Location$locationsPath = function (practitionerId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['locations']),
		$author$project$Api$Provider$Practitioner$practitionerPath(practitionerId));
};
var $author$project$Api$Provider$Practitioner$Location$create = F4(
	function (apiClient, practitionerId, id, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'location',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'id',
								$elm$json$Json$Encode$string(id))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Location$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Practitioner$Location$locationsPath(practitionerId))));
	});
var $author$project$Api$Provider$Practitioner$delete = F4(
	function (apiClient, id_, reassignToPractitioner, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				function () {
					if (!reassignToPractitioner.$) {
						var string = reassignToPractitioner.a;
						return _List_fromArray(
							[
								A2($author$project$Api$Param$string, 'reassign_to_practitioner_id', string)
							]);
					} else {
						return _List_Nil;
					}
				}(),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Practitioner$practitionerPath(id_))));
	});
var $author$project$Components$LocationInput$empty = F2(
	function (apiClient, listOptionals) {
		var _v0 = A4(
			$author$project$Components$ResourceFilter$Location$init,
			apiClient,
			$elm$core$Maybe$Nothing,
			listOptionals,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Unassigned', ai5: false});
			});
		var filter = _v0.a;
		var filterCmd = _v0.b;
		return _Utils_Tuple2(
			{ep: false, HM: filter, akR: false, aee: $elm$core$Maybe$Nothing},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, filterCmd));
	});
var $author$project$Components$ResourceFilter$excludedIds = F2(
	function (ids, model) {
		return _Utils_update(
			model,
			{
				bu: A2(
					$elm$core$Maybe$map,
					$elm$core$List$filter(
						function (item) {
							return !A2(
								$elm$core$List$member,
								model.hX(item),
								ids);
						}),
					model.bu),
				jG: $elm$core$Maybe$Just(ids)
			});
	});
var $author$project$Components$ResourceFilter$Location$excludedIds = F2(
	function (ids, model) {
		return _Utils_update(
			model,
			{
				b8: A2($author$project$Components$ResourceFilter$excludedIds, ids, model.b8)
			});
	});
var $author$project$Components$LocationInput$excludedIds = F2(
	function (ids, input) {
		return _Utils_update(
			input,
			{
				HM: A2($author$project$Components$ResourceFilter$Location$excludedIds, ids, input.HM)
			});
	});
var $author$project$Api$Provider$Practitioner$Shared$acceptsEnrollmentsFromEmployer = function (_v0) {
	var record = _v0;
	return record.q5;
};
var $author$project$Api$Provider$Practitioner$All$acceptsEnrollmentsFromEmployer = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$acceptsEnrollmentsFromEmployer(shared);
};
var $author$project$Api$Provider$Practitioner$Shared$acceptsEnrollmentsFromRetail = function (_v0) {
	var record = _v0;
	return record.q6;
};
var $author$project$Api$Provider$Practitioner$All$acceptsEnrollmentsFromRetail = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$acceptsEnrollmentsFromRetail(shared);
};
var $author$project$Api$Provider$Practitioner$Shared$autoDetermineOnlineSignupVisibilityFromPanelSize = function (_v0) {
	var record = _v0;
	return record.Mh;
};
var $author$project$Api$Provider$Practitioner$All$autoDetermineOnlineSignupVisibilityFromPanelSize = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$autoDetermineOnlineSignupVisibilityFromPanelSize(shared);
};
var $author$project$Api$Provider$Practitioner$Shared$bio = function (_v0) {
	var record = _v0;
	return record.MK;
};
var $author$project$Api$Provider$Practitioner$All$bio = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$bio(shared);
};
var $author$project$Api$Provider$Practitioner$Shared$education = function (_v0) {
	var record = _v0;
	return record.Q6;
};
var $author$project$Api$Provider$Practitioner$All$education = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$education(shared);
};
var $author$project$Api$Provider$Practitioner$Shared$elationPhysicianId = function (_v0) {
	var record = _v0;
	return record.Rb;
};
var $author$project$Api$Provider$Practitioner$All$elationPhysicianId = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$elationPhysicianId(shared);
};
var $author$project$Api$Provider$Practitioner$Shared$email = function (_v0) {
	var record = _v0;
	return record.Rj;
};
var $author$project$Api$Provider$Practitioner$All$email = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$email(shared);
};
var $author$project$Api$Provider$Practitioner$Shared$gender = function (_v0) {
	var record = _v0;
	return record.SR;
};
var $author$project$Api$Provider$Practitioner$All$gender = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$gender(shared);
};
var $author$project$Api$Provider$Practitioner$Shared$genderOther = function (_v0) {
	var record = _v0;
	return record.ST;
};
var $author$project$Api$Provider$Practitioner$All$genderOther = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$genderOther(shared);
};
var $author$project$Api$Provider$Practitioner$Shared$isProvider = function (_v0) {
	var record = _v0;
	return record.U6;
};
var $author$project$Api$Provider$Practitioner$All$isProvider = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$isProvider(shared);
};
var $author$project$Api$Provider$Practitioner$All$locations = function (_v0) {
	var record = _v0.b;
	return record.Wg;
};
var $author$project$Api$Provider$Practitioner$Shared$maxPatientAge = function (_v0) {
	var record = _v0;
	return record.WB;
};
var $author$project$Api$Provider$Practitioner$All$maxPatientAge = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$maxPatientAge(shared);
};
var $author$project$Api$Provider$Practitioner$Shared$meta = function (_v0) {
	var record = _v0;
	return record.W4;
};
var $author$project$Api$Provider$Practitioner$All$meta = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$meta(shared);
};
var $author$project$Api$Provider$Practitioner$Shared$minPatientAge = function (_v0) {
	var record = _v0;
	return record.Xb;
};
var $author$project$Api$Provider$Practitioner$All$minPatientAge = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$minPatientAge(shared);
};
var $author$project$Api$Provider$Practitioner$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$Practitioner$All$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$name(shared);
};
var $author$project$Api$Provider$Practitioner$Shared$npi = function (_v0) {
	var record = _v0;
	return record.X0;
};
var $author$project$Api$Provider$Practitioner$All$npi = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$npi(shared);
};
var $author$project$Api$Provider$Npi$Shared$number = function (_v0) {
	var record = _v0;
	return record.IO;
};
var $author$project$Api$Provider$Practitioner$Shared$onlineSignupVisibility = function (_v0) {
	var record = _v0;
	return record.Ym;
};
var $author$project$Api$Provider$Practitioner$All$onlineSignupVisibility = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$onlineSignupVisibility(shared);
};
var $author$project$Api$Provider$Practitioner$Shared$panelSize = function (_v0) {
	var record = _v0;
	return record.YJ;
};
var $author$project$Api$Provider$Practitioner$All$panelSize = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$panelSize(shared);
};
var $author$project$Api$Provider$Practitioner$Shared$panelSizeLimit = function (_v0) {
	var record = _v0;
	return record.YK;
};
var $author$project$Api$Provider$Practitioner$All$panelSizeLimit = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$panelSizeLimit(shared);
};
var $author$project$Api$Provider$Practitioner$Shared$photoUrl = function (_v0) {
	var record = _v0;
	return record.ZA;
};
var $author$project$Api$Provider$Practitioner$All$photoUrl = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$photoUrl(shared);
};
var $author$project$Api$Provider$Practitioner$All$specialties = function (_v0) {
	var record = _v0.b;
	return record.abU;
};
var $author$project$Api$Provider$Practitioner$Shared$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Api$Provider$Practitioner$All$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$status(shared);
};
var $author$project$Api$Provider$Practitioner$Shared$syncedPatientsCount = function (_v0) {
	var record = _v0;
	return record.acO;
};
var $author$project$Api$Provider$Practitioner$All$syncedPatientsCount = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$syncedPatientsCount(shared);
};
var $author$project$Api$Provider$Practitioner$Shared$waitlistEnabled = function (_v0) {
	var record = _v0;
	return record.aen;
};
var $author$project$Api$Provider$Practitioner$All$waitlistEnabled = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$waitlistEnabled(shared);
};
var $author$project$Pages$Admin$Providers$Top$formFieldsFromItem = function (item) {
	var locationsList = A2(
		$author$project$Api$Expandable$withDefault,
		_List_Nil,
		$author$project$Api$Provider$Practitioner$All$locations(item));
	var emptyList = _List_fromArray(
		['']);
	var locations = $elm$core$List$isEmpty(locationsList) ? emptyList : A2(
		$elm$core$List$map,
		function (location) {
			return $author$project$Api$Provider$Location$Shared$id(location);
		},
		locationsList);
	var specialties = $elm$core$List$isEmpty(
		$author$project$Api$Provider$Practitioner$All$specialties(item)) ? emptyList : $author$project$Api$Provider$Practitioner$All$specialties(item);
	var education = $elm$core$List$isEmpty(
		$author$project$Api$Provider$Practitioner$All$education(item)) ? emptyList : $author$project$Api$Provider$Practitioner$All$education(item);
	return {
		q5: $author$project$Api$Provider$Practitioner$All$acceptsEnrollmentsFromEmployer(item),
		q6: $author$project$Api$Provider$Practitioner$All$acceptsEnrollmentsFromRetail(item),
		Mh: $author$project$Api$Provider$Practitioner$All$autoDetermineOnlineSignupVisibilityFromPanelSize(item),
		MK: $author$project$Api$Provider$Practitioner$All$bio(item),
		rS: $author$project$Api$Provider$Practitioner$All$photoUrl(item),
		Q6: education,
		Rb: $author$project$Api$Provider$Practitioner$All$elationPhysicianId(item),
		Rj: $author$project$Api$Provider$Practitioner$All$email(item),
		SR: $author$project$Api$Provider$Practitioner$All$gender(item),
		ST: $author$project$Api$Provider$Practitioner$All$genderOther(item),
		U6: $author$project$Api$Provider$Practitioner$All$isProvider(item),
		Wg: locations,
		WB: $author$project$Api$Provider$Practitioner$All$maxPatientAge(item),
		W4: $elm$core$Maybe$Just(
			$author$project$Api$Provider$Practitioner$All$meta(item)),
		Xb: $author$project$Api$Provider$Practitioner$All$minPatientAge(item),
		Bq: $author$project$Api$Provider$Practitioner$All$name(item),
		X0: $author$project$Api$Provider$Practitioner$All$isProvider(item) ? A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$Npi$Shared$number,
			$author$project$Api$Provider$Practitioner$All$npi(item)) : $elm$core$Maybe$Nothing,
		Ym: $author$project$Api$Provider$Practitioner$All$onlineSignupVisibility(item),
		YJ: $elm$core$Maybe$Just(
			$author$project$Api$Provider$Practitioner$All$panelSize(item)),
		YK: $author$project$Api$Provider$Practitioner$All$panelSizeLimit(item),
		tR: 0,
		ZA: $elm$core$Maybe$Nothing,
		abU: specialties,
		alH: $author$project$Api$Provider$Practitioner$All$status(item),
		acO: $author$project$Api$Provider$Practitioner$All$syncedPatientsCount(item),
		aen: $author$project$Api$Provider$Practitioner$All$waitlistEnabled(item)
	};
};
var $author$project$Pages$Admin$Providers$Top$formFieldsInit = {
	q5: true,
	q6: true,
	Mh: false,
	MK: $elm$core$Maybe$Nothing,
	rS: $elm$core$Maybe$Nothing,
	Q6: _List_fromArray(
		['']),
	Rb: $elm$core$Maybe$Nothing,
	Rj: $elm$core$Maybe$Nothing,
	SR: $elm$core$Maybe$Nothing,
	ST: $elm$core$Maybe$Nothing,
	U6: true,
	Wg: _List_fromArray(
		['']),
	WB: $elm$core$Maybe$Nothing,
	W4: $elm$core$Maybe$Nothing,
	Xb: $elm$core$Maybe$Nothing,
	Bq: '',
	X0: $elm$core$Maybe$Nothing,
	Ym: true,
	YJ: $elm$core$Maybe$Nothing,
	YK: $elm$core$Maybe$Nothing,
	tR: 0,
	ZA: $elm$core$Maybe$Nothing,
	abU: _List_fromArray(
		['']),
	alH: 'accepting_patients',
	acO: 0,
	aen: false
};
var $author$project$Pages$Admin$Providers$Top$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 23:
				var bool = field.a;
				return _Utils_update(
					fields,
					{q5: bool});
			case 24:
				var bool = field.a;
				return _Utils_update(
					fields,
					{q6: bool});
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{Bq: string});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						MK: $author$project$Utils$String$toMaybe(string)
					});
			case 2:
				var gender = field.a;
				return _Utils_update(
					fields,
					{
						SR: $elm$core$Maybe$Just(gender)
					});
			case 3:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						ST: $author$project$Utils$String$toMaybe(string)
					});
			case 4:
				var _int = field.a;
				var string = field.b;
				return _Utils_update(
					fields,
					{
						rS: $elm$core$Maybe$Just(string),
						tR: _int,
						ZA: $elm$core$Maybe$Just(string)
					});
			case 5:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Rj: $author$project$Utils$String$toMaybe(string)
					});
			case 6:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Xb: $elm$core$String$toInt(string)
					});
			case 7:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						WB: $elm$core$String$toInt(string)
					});
			case 8:
				var index = field.a;
				var string = field.b;
				return _Utils_update(
					fields,
					{
						abU: A3($elm_community$list_extra$List$Extra$setAt, index, string, fields.abU)
					});
			case 9:
				var index = field.a;
				var string = field.b;
				return _Utils_update(
					fields,
					{
						Wg: A3($elm_community$list_extra$List$Extra$setAt, index, string, fields.Wg)
					});
			case 11:
				return _Utils_update(
					fields,
					{
						Wg: _Utils_ap(
							fields.Wg,
							_List_fromArray(
								['']))
					});
			case 12:
				var index = field.a;
				return _Utils_update(
					fields,
					{
						Wg: A2($elm_community$list_extra$List$Extra$removeAt, index, fields.Wg)
					});
			case 10:
				return _Utils_update(
					fields,
					{
						abU: _Utils_ap(
							fields.abU,
							_List_fromArray(
								['']))
					});
			case 13:
				var index = field.a;
				return _Utils_update(
					fields,
					{
						abU: A2($elm_community$list_extra$List$Extra$removeAt, index, fields.abU)
					});
			case 14:
				var index = field.a;
				var string = field.b;
				return _Utils_update(
					fields,
					{
						Q6: A3($elm_community$list_extra$List$Extra$setAt, index, string, fields.Q6)
					});
			case 15:
				return _Utils_update(
					fields,
					{
						Q6: _Utils_ap(
							fields.Q6,
							_List_fromArray(
								['']))
					});
			case 16:
				var index = field.a;
				return _Utils_update(
					fields,
					{
						Q6: A2($elm_community$list_extra$List$Extra$removeAt, index, fields.Q6)
					});
			case 17:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Rb: $author$project$Utils$String$toMaybe(string)
					});
			case 18:
				var string = field.a;
				var panelSizeLimit = $elm$core$String$toInt(string);
				var onlineSignupVisibility = function () {
					var _v1 = _Utils_Tuple3(fields.Mh, fields.YJ, panelSizeLimit);
					if ((_v1.a && (!_v1.b.$)) && (!_v1.c.$)) {
						var panelSize = _v1.b.a;
						var panelSizeLimit_ = _v1.c.a;
						return _Utils_cmp(panelSize, panelSizeLimit_) < 0;
					} else {
						return fields.Ym;
					}
				}();
				return _Utils_update(
					fields,
					{Ym: onlineSignupVisibility, YK: panelSizeLimit});
			case 19:
				var bool = field.a;
				var onlineSignupVisibility = function () {
					var _v2 = _Utils_Tuple2(fields.YJ, fields.YK);
					if ((!_v2.a.$) && (!_v2.b.$)) {
						var panelSize = _v2.a.a;
						var panelSizeLimit = _v2.b.a;
						return _Utils_cmp(panelSize, panelSizeLimit) < 0;
					} else {
						return fields.Ym;
					}
				}();
				return _Utils_update(
					fields,
					{Mh: bool, Ym: onlineSignupVisibility});
			case 20:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						X0: $author$project$Utils$String$toMaybe(string)
					});
			case 21:
				var bool = field.a;
				return _Utils_update(
					fields,
					{Ym: bool});
			case 22:
				var bool = field.a;
				return _Utils_update(
					fields,
					{U6: !bool});
			case 25:
				var string = field.a;
				return _Utils_update(
					fields,
					{alH: string});
			default:
				var bool = field.a;
				return _Utils_update(
					fields,
					{aen: bool});
		}
	});
var $author$project$Pages$Admin$Providers$Top$NameValidation = 0;
var $author$project$Pages$Admin$Providers$Top$PhotoValidation = 2;
var $author$project$Pages$Admin$Providers$Top$maxPhotoBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
var $author$project$Pages$Admin$Providers$Top$LocationsValidation = 3;
var $author$project$Pages$Admin$Providers$Top$validateLocations = function (fields) {
	return _Utils_eq(
		fields.Wg,
		_List_fromArray(
			[''])) ? _List_fromArray(
		[
			_Utils_Tuple2(3, 'Please enter at least one location.')
		]) : _List_Nil;
};
var $author$project$Pages$Admin$Providers$Top$NpiValidation = 1;
var $author$project$Utils$MetaFields$alwaysEditable = $author$project$Utils$MetaFields$Editable;
var $author$project$Utils$MetaFields$isEditable = function (editable) {
	if (!editable.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Utils$MetaFields$isUneditable = A2($elm$core$Basics$composeR, $author$project$Utils$MetaFields$isEditable, $elm$core$Basics$not);
var $author$project$Api$Provider$Practitioner$Meta$npi = function (_v0) {
	var fields = _v0;
	return fields.X0;
};
var $author$project$Pages$Admin$Providers$Top$validateNpi = function (fields) {
	var npiValidationMessage = _List_fromArray(
		[
			_Utils_Tuple2(1, 'Please enter a valid npi.')
		]);
	var editable = A2(
		$elm$core$Maybe$withDefault,
		$author$project$Utils$MetaFields$alwaysEditable,
		A2($elm$core$Maybe$map, $author$project$Api$Provider$Practitioner$Meta$npi, fields.W4));
	var _v0 = _Utils_Tuple2(
		fields.X0,
		$author$project$Utils$MetaFields$isUneditable(editable));
	if (!_v0.b) {
		if (!_v0.a.$) {
			var npi = _v0.a.a;
			return (($elm$core$String$length(npi) === 10) && $ahstro$elm_luhn$Luhn$isValid('80840' + npi)) ? _List_Nil : npiValidationMessage;
		} else {
			var _v1 = _v0.a;
			return fields.U6 ? npiValidationMessage : _List_Nil;
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$Pages$Admin$Providers$Top$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.Bq;
			},
			_Utils_Tuple2(0, 'Please enter a name.')),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Admin$Providers$Top$validateNpi),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Admin$Providers$Top$validateLocations),
			A3(
			$author$project$Utils$Validate$ifIntGreaterThan,
			function ($) {
				return $.tR;
			},
			$author$project$Pages$Admin$Providers$Top$maxPhotoBytesSize,
			_Utils_Tuple2(2, 'That image is too large! Our maximum image size is 5 mb, please choose a smaller image.'))
		]));
var $author$project$Pages$Admin$Providers$Top$hasMoreThanOnePracticeProvider = F2(
	function (model, practitioners) {
		var _v0 = model.tX;
		if (!_v0.$) {
			var count = _v0.a;
			return count > 1;
		} else {
			return $elm$core$List$length(practitioners) > 1;
		}
	});
var $author$project$Api$Provider$Practitioner$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Practitioner$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$id(shared);
};
var $author$project$Api$Location$Shared$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$ResourceFilter$Location$setValue = F2(
	function (resource, model) {
		return _Utils_update(
			model,
			{
				Jy: function () {
					if (!resource.$) {
						var resource_ = resource.a;
						return $author$project$Components$ResourceFilter$One(resource_);
					} else {
						return $author$project$Components$ResourceFilter$All;
					}
				}()
			});
	});
var $author$project$Components$LocationInput$setValueWithResource = F2(
	function (resource, model) {
		return _Utils_update(
			model,
			{
				HM: A2($author$project$Components$ResourceFilter$Location$setValue, resource, model.HM),
				aee: resource
			});
	});
var $author$project$Components$LocationInput$initWithResource = F3(
	function (apiClient, listOptionals, resource) {
		return A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Components$LocationInput$setValueWithResource(resource),
			A2($author$project$Components$LocationInput$empty, apiClient, listOptionals));
	});
var $author$project$Api$Affiliate$AffiliateMin$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Employer$Location$Shared$affiliation = function (_v0) {
	var record = _v0;
	return record.Li;
};
var $author$project$Api$Location$Shared$affiliation = function (location) {
	if (!location.$) {
		var location_ = location.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Affiliate$AffiliateMin$Provider,
			$author$project$Api$Provider$Location$Shared$affiliation(location_));
	} else {
		var location_ = location.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Affiliate$AffiliateMin$Employer,
			$author$project$Api$Employer$Location$Shared$affiliation(location_));
	}
};
var $author$project$Api$Employer$Location$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Location$Shared$id = function (location) {
	if (!location.$) {
		var location_ = location.a;
		return $author$project$Api$Provider$Location$Shared$id(location_);
	} else {
		var location_ = location.a;
		return $author$project$Api$Employer$Location$Shared$id(location_);
	}
};
var $author$project$Api$Employer$Location$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Location$Shared$name = function (location) {
	if (!location.$) {
		var location_ = location.a;
		return $author$project$Api$Provider$Location$Shared$name(location_);
	} else {
		var location_ = location.a;
		return $author$project$Api$Employer$Location$Shared$name(location_);
	}
};
var $author$project$Components$ResourceFilter$Location$resourceFromShared = $elm$core$Maybe$map(
	function (location) {
		return {
			Li: $author$project$Api$Location$Shared$affiliation(location),
			ahP: $author$project$Api$Location$Shared$id(location),
			UV: false,
			Vf: false,
			Wf: '',
			Bq: $author$project$Api$Location$Shared$name(location),
			ZY: ''
		};
	});
var $author$project$Pages$Admin$Providers$Top$syncExcludedIds = F2(
	function (locationIds, inputs) {
		return A2(
			$elm$core$List$indexedMap,
			F2(
				function (index, input) {
					var siblings = A2(
						$elm$core$List$map,
						$elm$core$Tuple$second,
						A2(
							$elm$core$List$filter,
							function (_v0) {
								var i = _v0.a;
								var id_ = _v0.b;
								return (!_Utils_eq(i, index)) && (!$elm$core$String$isEmpty(id_));
							},
							A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, locationIds)));
					return A2($author$project$Components$LocationInput$excludedIds, siblings, input);
				}),
			inputs);
	});
var $author$project$Pages$Admin$Providers$Top$initLocationInputsFor = F3(
	function (apiClient, formLocationIds, existing) {
		var resourceById = function (id_) {
			return A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Maybe$Nothing,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Api$Location$Shared$Provider,
						A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $author$project$Components$ResourceFilter$Location$resourceFromShared)),
					A2(
						$elm_community$list_extra$List$Extra$find,
						function (loc) {
							return _Utils_eq(
								$author$project$Api$Provider$Location$Shared$id(loc),
								id_);
						},
						existing)));
		};
		var inputsAndCmds = A2(
			$elm$core$List$indexedMap,
			F2(
				function (index, id_) {
					var _v0 = A3(
						$author$project$Components$LocationInput$initWithResource,
						apiClient,
						$elm$core$Basics$identity,
						resourceById(id_));
					var input = _v0.a;
					var cmd = _v0.b;
					return _Utils_Tuple2(
						input,
						A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Pages$Admin$Providers$Top$EditLocationInputMsg(index),
							cmd));
				}),
			formLocationIds);
		var synced = A2(
			$author$project$Pages$Admin$Providers$Top$syncExcludedIds,
			formLocationIds,
			A2($elm$core$List$map, $elm$core$Tuple$first, inputsAndCmds));
		return _Utils_Tuple2(
			synced,
			$elm$core$Platform$Cmd$batch(
				A2($elm$core$List$map, $elm$core$Tuple$second, inputsAndCmds)));
	});
var $author$project$Api$Provider$Practitioner$Shared$isSynced = function (_v0) {
	var record = _v0;
	return record.Vf;
};
var $author$project$Api$Provider$Practitioner$All$isSynced = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$isSynced(shared);
};
var $author$project$Api$Provider$Practitioner$One$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Practitioner$Shared$name(shared);
};
var $author$project$Components$Admin$Practitioner$DeleteModal$Open = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$Practitioner$DeleteModal$Reassign = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$ResourceFilter$Practitioner$list = $author$project$Api$Provider$Practitioner$list;
var $author$project$Api$Provider$Practitioner$Shared$affiliation = function (_v0) {
	var record = _v0;
	return record.Li;
};
var $author$project$Api$Provider$Practitioner$All$affiliation = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$affiliation(shared);
};
var $author$project$Api$Provider$Practitioner$Shared$isMaster = function (_v0) {
	var record = _v0;
	return record.UV;
};
var $author$project$Api$Provider$Practitioner$All$isMaster = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$isMaster(shared);
};
var $author$project$Api$Provider$Practitioner$Shared$openingsSize = function (_v0) {
	var record = _v0;
	return record.Yp;
};
var $author$project$Api$Provider$Practitioner$All$openingsSize = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$openingsSize(shared);
};
var $author$project$Api$Provider$Practitioner$Shared$practiceName = function (_v0) {
	var record = _v0;
	return record.ZY;
};
var $author$project$Api$Provider$Practitioner$All$practiceName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$practiceName(shared);
};
var $author$project$Api$Provider$Practitioner$Shared$practitionerType = function (_v0) {
	var record = _v0;
	return record.Z3;
};
var $author$project$Api$Provider$Practitioner$All$practitionerType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$practitionerType(shared);
};
var $author$project$Components$ResourceFilter$Practitioner$resourceFromAll = function (practitioner) {
	return {
		Li: A2(
			$elm$core$Maybe$map,
			$author$project$Api$Affiliate$AffiliateMin$Provider,
			$author$project$Api$Provider$Practitioner$All$affiliation(practitioner)),
		ahP: $author$project$Api$Provider$Practitioner$All$id(practitioner),
		UV: $author$project$Api$Provider$Practitioner$All$isMaster(practitioner),
		Vf: $author$project$Api$Provider$Practitioner$All$isSynced(practitioner),
		Bq: $author$project$Api$Provider$Practitioner$All$name(practitioner),
		Yp: $author$project$Api$Provider$Practitioner$All$openingsSize(practitioner),
		ZY: $author$project$Api$Provider$Practitioner$All$practiceName(practitioner),
		Z3: $author$project$Api$Provider$Practitioner$All$practitionerType(practitioner)
	};
};
var $author$project$Components$ResourceFilter$Practitioner$fetchResources = F5(
	function (listOptionals, toMsg, apiClient, pagination, query) {
		return A3(
			$author$project$Components$ResourceFilter$Practitioner$list,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{ajJ: pagination, akl: query});
				}),
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Components$ResourceFilter$Practitioner$resourceFromAll))));
	});
var $author$project$Components$ResourceFilter$Practitioner$retrieveResource = F4(
	function (listOptionals, toMsg, apiClient, id) {
		return A3(
			$author$project$Components$ResourceFilter$Practitioner$list,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{
							ahP: $elm$core$Maybe$Just(id)
						});
				}),
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Components$ResourceFilter$Practitioner$resourceFromAll))));
	});
var $author$project$Components$ResourceFilter$Practitioner$selectId = 'practitioners';
var $author$project$Components$ResourceFilter$Practitioner$openings = function (resource) {
	var _v0 = resource.Yp;
	if (!_v0.$) {
		if (!_v0.a) {
			return 'Full';
		} else {
			var size = _v0.a;
			return A2($author$project$Formatters$String$pluralize, 'opening', size);
		}
	} else {
		return 'No panel limit';
	}
};
var $author$project$Components$ResourceFilter$Practitioner$panelLimit = function (resource) {
	var _v0 = resource.Yp;
	if (!_v0.$) {
		if (!_v0.a) {
			return 'No Slots';
		} else {
			var size = _v0.a;
			return $elm$core$String$fromInt(size) + ' Slots';
		}
	} else {
		return 'No limit';
	}
};
var $author$project$Components$ResourceFilter$Practitioner$extraText = function (resource) {
	var practitionerType_ = resource.Z3;
	var practiceName_ = resource.ZY;
	return ($elm$core$String$isEmpty(practiceName_) && $elm$core$String$isEmpty(practitionerType_)) ? $elm$core$Maybe$Just(
		$author$project$Components$ResourceFilter$Practitioner$openings(resource)) : $elm$core$Maybe$Just(
		practitionerType_ + (' | ' + (A2($elm$core$String$left, 50, practiceName_) + (' [ ' + ($author$project$Components$ResourceFilter$Practitioner$panelLimit(resource) + ' ]')))));
};
var $author$project$Components$ResourceFilter$Practitioner$toTitle = function ($) {
	return $.Bq;
};
var $author$project$Components$ResourceFilter$Practitioner$toLabel = function (resource) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceX2]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceX2]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[
									$author$project$Ui$Typography$phi(true)
								]),
							$author$project$Components$ResourceFilter$Practitioner$toTitle(resource)),
							resource.UV ? $author$project$Components$SyncedIcon$view(
							_List_fromArray(
								[
									$author$project$Components$SyncedIcon$master,
									$author$project$Components$SyncedIcon$status($elm$core$Maybe$Nothing)
								])) : $elm$html$Html$text(''),
							resource.Vf ? $author$project$Components$SyncedIcon$view(
							_List_fromArray(
								[
									$author$project$Components$SyncedIcon$synced,
									$author$project$Components$SyncedIcon$status($elm$core$Maybe$Nothing)
								])) : $elm$html$Html$text('')
						])),
					A2(
					$elm$core$Maybe$withDefault,
					$elm$html$Html$text(''),
					A2(
						$elm$core$Maybe$map,
						function (info) {
							return A2(
								$author$project$Ui$Typography$text,
								_List_fromArray(
									[$author$project$Ui$Typography$small]),
								info);
						},
						$author$project$Components$ResourceFilter$Practitioner$extraText(resource)))
				]))
		]);
};
var $author$project$Components$ResourceFilter$Practitioner$toValue = function ($) {
	return $.ahP;
};
var $author$project$Components$ResourceFilter$Practitioner$init = F3(
	function (apiClient, listOptionals, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{
				Sk: $author$project$Components$ResourceFilter$Practitioner$fetchResources(listOptionals),
				ahP: $author$project$Components$ResourceFilter$Practitioner$selectId,
				k$: 'Provider',
				uk: $author$project$Components$ResourceFilter$Practitioner$retrieveResource(listOptionals),
				u9: $author$project$Components$ResourceFilter$Practitioner$toLabel,
				lN: $author$project$Components$ResourceFilter$Practitioner$toTitle,
				hX: $author$project$Components$ResourceFilter$Practitioner$toValue
			},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{Jy: $author$project$Components$ResourceFilter$All, b8: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$Admin$Practitioner$DeleteModal$open = F4(
	function (apiClient, practitioner, hasSyncedPatients, hasMoreThanOnePractitioner) {
		var action = $author$project$Components$Admin$Practitioner$DeleteModal$Reassign($elm$core$Maybe$Nothing);
		var _v0 = A3(
			$author$project$Components$ResourceFilter$Practitioner$init,
			apiClient,
			$elm$core$Basics$identity,
			function (d) {
				return _Utils_update(
					d,
					{
						Gp: 'Choose a practitioner...',
						ag$: $elm$core$Maybe$Just(
							$author$project$Api$Provider$Practitioner$All$id(practitioner))
					});
			});
		var practitionerResourceFilter = _v0.a;
		var practitionerResourceFilterCmd = _v0.b;
		var localState = {Gg: action, zP: hasMoreThanOnePractitioner, HZ: hasSyncedPatients, aka: practitioner, hk: practitionerResourceFilter, uf: $author$project$Api$Data$NotAsked};
		return _Utils_Tuple2(
			$author$project$Components$Admin$Practitioner$DeleteModal$Open(localState),
			A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$Practitioner$DeleteModal$PractitionerResourceFilterMsg, practitionerResourceFilterCmd));
	});
var $author$project$Pages$Admin$Providers$Top$Created = function (a) {
	return {$: 14, a: a};
};
var $author$project$Api$Provider$Practitioner$One$Practitioner = $elm$core$Basics$identity;
var $author$project$Api$Provider$Practitioner$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Practitioner$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Gender$toString = function (gender) {
	switch (gender) {
		case 0:
			return 'male';
		case 1:
			return 'female';
		case 2:
			return 'intersex';
		default:
			return 'other';
	}
};
var $author$project$Api$Gender$encode = function (gender) {
	return A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$Api$Gender$toString)(gender);
};
var $author$project$Api$Provider$Practitioner$create = F3(
	function (apiClient, fields, toMsg) {
		var photo_ = function () {
			var _v1 = fields.Zz;
			if (!_v1.$) {
				var base64 = _v1.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'photo',
						$elm$json$Json$Encode$string(base64))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var npi_ = function () {
			var _v0 = fields.X0;
			if (!_v0.$) {
				var number = _v0.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'number',
							$elm$json$Json$Encode$string(number))
						]));
			} else {
				return $elm$json$Json$Encode$null;
			}
		}();
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practitioner',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(fields.Bq)),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'accepts_enrollments_from_employer',
									$elm$json$Json$Encode$bool(fields.q5)),
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										'accepts_enrollments_from_retail',
										$elm$json$Json$Encode$bool(fields.q6)),
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(
											'min_patient_age',
											A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Xb)),
										A2(
											$elm$core$List$cons,
											_Utils_Tuple2(
												'max_patient_age',
												A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.WB)),
											A2(
												$elm$core$List$cons,
												_Utils_Tuple2(
													'panel_size_limit',
													A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.YK)),
												A2(
													$elm$core$List$cons,
													_Utils_Tuple2(
														'auto_determine_online_signup_visibility_from_panel_size',
														$elm$json$Json$Encode$bool(fields.Mh)),
													A2(
														$elm$core$List$cons,
														_Utils_Tuple2(
															'elation_physician_id',
															A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Rb)),
														A2(
															$elm$core$List$cons,
															_Utils_Tuple2(
																'email',
																A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Rj)),
															A2(
																$elm$core$List$cons,
																_Utils_Tuple2(
																	'bio',
																	A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.MK)),
																A2(
																	$elm$core$List$cons,
																	_Utils_Tuple2(
																		'gender',
																		A2($author$project$Utils$Encode$nullable, $author$project$Api$Gender$encode, fields.SR)),
																	A2(
																		$elm$core$List$cons,
																		_Utils_Tuple2(
																			'gender_other',
																			A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ST)),
																		A2(
																			$elm$core$List$cons,
																			_Utils_Tuple2(
																				'education',
																				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, fields.Q6)),
																			A2(
																				$elm$core$List$cons,
																				_Utils_Tuple2(
																					'specialties',
																					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, fields.abU)),
																				A2(
																					$elm$core$List$cons,
																					_Utils_Tuple2(
																						'locations',
																						A2($elm$json$Json$Encode$list, $author$project$Utils$Encode$association, fields.Wg)),
																					A2(
																						$elm$core$List$cons,
																						_Utils_Tuple2('npi', npi_),
																						A2(
																							$elm$core$List$cons,
																							_Utils_Tuple2(
																								'online_signup_visibility',
																								$elm$json$Json$Encode$bool(fields.Ym)),
																							A2(
																								$elm$core$List$cons,
																								_Utils_Tuple2(
																									'is_provider',
																									$elm$json$Json$Encode$bool(fields.U6)),
																								A2(
																									$elm$core$List$cons,
																									_Utils_Tuple2(
																										'status',
																										$elm$json$Json$Encode$string(fields.alH)),
																									A2(
																										$elm$core$List$cons,
																										_Utils_Tuple2(
																											'waitlist_enabled',
																											$elm$json$Json$Encode$bool(fields.aen)),
																										photo_))))))))))))))))))))))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Practitioner$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Practitioner$practitionersPath)));
	});
var $author$project$Pages$Admin$Providers$Top$practitionerFromFields = function (fields) {
	return {
		q5: fields.q5,
		q6: fields.q6,
		Mh: fields.Mh,
		MK: fields.MK,
		Q6: fields.Q6,
		Rb: fields.Rb,
		Rj: fields.Rj,
		SR: fields.SR,
		ST: fields.ST,
		U6: fields.U6,
		Wg: fields.Wg,
		WB: fields.WB,
		Xb: fields.Xb,
		Bq: fields.Bq,
		X0: fields.U6 ? fields.X0 : $elm$core$Maybe$Nothing,
		Ym: fields.Ym,
		YK: fields.YK,
		Zz: fields.ZA,
		abU: fields.abU,
		alH: fields.alH,
		aen: fields.aen
	};
};
var $author$project$Pages$Admin$Providers$Top$createItem = F2(
	function (apiClient, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A3(
			$author$project$Api$Provider$Practitioner$create,
			apiClient,
			$author$project$Pages$Admin$Providers$Top$practitionerFromFields(fields),
			$author$project$Pages$Admin$Providers$Top$Created);
	});
var $author$project$Pages$Admin$Providers$Top$Updated = function (a) {
	return {$: 15, a: a};
};
var $author$project$Api$Provider$Practitioner$update = F4(
	function (apiClient, id_, fields, toMsg) {
		var photo_ = function () {
			var _v1 = fields.Zz;
			if (!_v1.$) {
				var base64 = _v1.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'photo',
						$elm$json$Json$Encode$string(base64))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var npi_ = function () {
			var _v0 = fields.X0;
			if (!_v0.$) {
				var number = _v0.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'number',
							$elm$json$Json$Encode$string(number))
						]));
			} else {
				return $elm$json$Json$Encode$null;
			}
		}();
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practitioner',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(fields.Bq)),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'accepts_enrollments_from_employer',
									$elm$json$Json$Encode$bool(fields.q5)),
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										'accepts_enrollments_from_retail',
										$elm$json$Json$Encode$bool(fields.q6)),
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(
											'min_patient_age',
											A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Xb)),
										A2(
											$elm$core$List$cons,
											_Utils_Tuple2(
												'max_patient_age',
												A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.WB)),
											A2(
												$elm$core$List$cons,
												_Utils_Tuple2(
													'panel_size_limit',
													A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.YK)),
												A2(
													$elm$core$List$cons,
													_Utils_Tuple2(
														'auto_determine_online_signup_visibility_from_panel_size',
														$elm$json$Json$Encode$bool(fields.Mh)),
													A2(
														$elm$core$List$cons,
														_Utils_Tuple2(
															'elation_physician_id',
															A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Rb)),
														A2(
															$elm$core$List$cons,
															_Utils_Tuple2(
																'email',
																A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Rj)),
															A2(
																$elm$core$List$cons,
																_Utils_Tuple2(
																	'bio',
																	A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.MK)),
																A2(
																	$elm$core$List$cons,
																	_Utils_Tuple2(
																		'gender',
																		A2($author$project$Utils$Encode$nullable, $author$project$Api$Gender$encode, fields.SR)),
																	A2(
																		$elm$core$List$cons,
																		_Utils_Tuple2(
																			'gender_other',
																			A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ST)),
																		A2(
																			$elm$core$List$cons,
																			_Utils_Tuple2(
																				'education',
																				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, fields.Q6)),
																			A2(
																				$elm$core$List$cons,
																				_Utils_Tuple2(
																					'specialties',
																					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, fields.abU)),
																				A2(
																					$elm$core$List$cons,
																					_Utils_Tuple2(
																						'locations',
																						A2($elm$json$Json$Encode$list, $author$project$Utils$Encode$association, fields.Wg)),
																					A2(
																						$elm$core$List$cons,
																						_Utils_Tuple2('npi', npi_),
																						A2(
																							$elm$core$List$cons,
																							_Utils_Tuple2(
																								'online_signup_visibility',
																								$elm$json$Json$Encode$bool(fields.Ym)),
																							A2(
																								$elm$core$List$cons,
																								_Utils_Tuple2(
																									'is_provider',
																									$elm$json$Json$Encode$bool(fields.U6)),
																								A2(
																									$elm$core$List$cons,
																									_Utils_Tuple2(
																										'status',
																										$elm$json$Json$Encode$string(fields.alH)),
																									A2(
																										$elm$core$List$cons,
																										_Utils_Tuple2(
																											'waitlist_enabled',
																											$elm$json$Json$Encode$bool(fields.aen)),
																										photo_))))))))))))))))))))))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Practitioner$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Practitioner$practitionerPath(id_))));
	});
var $author$project$Pages$Admin$Providers$Top$updateItem = F3(
	function (apiClient, id, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4(
			$author$project$Api$Provider$Practitioner$update,
			apiClient,
			id,
			$author$project$Pages$Admin$Providers$Top$practitionerFromFields(fields),
			$author$project$Pages$Admin$Providers$Top$Updated);
	});
var $author$project$Pages$Admin$Providers$Top$saveItem = F3(
	function (apiClient, maybeId, formFields) {
		if (!maybeId.$) {
			var id_ = maybeId.a;
			return A3($author$project$Pages$Admin$Providers$Top$updateItem, apiClient, id_, formFields);
		} else {
			return A2($author$project$Pages$Admin$Providers$Top$createItem, apiClient, formFields);
		}
	});
var $author$project$Components$Admin$Practitioner$DeleteModal$Deleted = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Admin$Practitioner$DeleteModal$None = 0;
var $author$project$Components$Admin$Practitioner$DeleteModal$PractitionerDeleted = 1;
var $author$project$Components$Admin$Practitioner$DeleteModal$isValid = function (action) {
	if (!action.$) {
		var practitionerId = action.a;
		return $author$project$Utils$Maybe$toBool(practitionerId);
	} else {
		return true;
	}
};
var $author$project$Components$ResourceFilter$Practitioner$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.b8);
		var modelAfterEvent = function () {
			var _v1 = result.agZ;
			if (!_v1.$) {
				var selected = _v1.a;
				return _Utils_update(
					model,
					{Jy: selected});
			} else {
				return model;
			}
		}();
		return {
			GZ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.GZ),
			agZ: result.agZ,
			aiO: _Utils_update(
				modelAfterEvent,
				{b8: result.aiO}),
			aR: result.aR
		};
	});
var $author$project$Components$Admin$Practitioner$DeleteModal$update = F3(
	function (apiClient, msg, modal) {
		switch (msg.$) {
			case 0:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, bH: $author$project$Components$Admin$Practitioner$DeleteModal$Closed, aR: _List_Nil};
			case 2:
				var action = msg.a;
				if (modal.$ === 1) {
					var state = modal.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						bH: $author$project$Components$Admin$Practitioner$DeleteModal$Open(
							_Utils_update(
								state,
								{Gg: action, uf: $author$project$Api$Data$NotAsked})),
						aR: _List_Nil
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, bH: $author$project$Components$Admin$Practitioner$DeleteModal$Closed, aR: _List_Nil};
				}
			case 1:
				if (modal.$ === 1) {
					var state = modal.a;
					if ($author$project$Components$Admin$Practitioner$DeleteModal$isValid(state.Gg)) {
						var newPractitionerId = function () {
							var _v3 = state.Gg;
							if (!_v3.$) {
								var practitionerId = _v3.a;
								return practitionerId;
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}();
						return {
							GZ: A4(
								$author$project$Api$Provider$Practitioner$delete,
								apiClient,
								$author$project$Api$Provider$Practitioner$All$id(state.aka),
								newPractitionerId,
								$author$project$Components$Admin$Practitioner$DeleteModal$Deleted(newPractitionerId)),
							agZ: 0,
							bH: $author$project$Components$Admin$Practitioner$DeleteModal$Open(
								_Utils_update(
									state,
									{uf: $author$project$Api$Data$Loading})),
							aR: _List_Nil
						};
					} else {
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 0,
							bH: $author$project$Components$Admin$Practitioner$DeleteModal$Open(
								_Utils_update(
									state,
									{uf: $author$project$Api$Data$NotAsked})),
							aR: _List_Nil
						};
					}
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, bH: $author$project$Components$Admin$Practitioner$DeleteModal$Closed, aR: _List_Nil};
				}
			case 3:
				var newPractitionerId = msg.a;
				var response = msg.b;
				if (modal.$ === 1) {
					var state = modal.a;
					switch (response.$) {
						case 3:
							var message = function () {
								if (!newPractitionerId.$) {
									var newPractitionerName = function () {
										var _v7 = state.hk.Jy;
										if (!_v7.$) {
											var resource = _v7.a;
											return resource.Bq;
										} else {
											return 'the selected provider';
										}
									}();
									return $elm$core$String$concat(
										_List_fromArray(
											[
												' All patients currently assigned to ',
												$author$project$Api$Provider$Practitioner$All$name(state.aka),
												' will be assigned to ',
												newPractitionerName,
												'.',
												'For large volumes of patients, this may take a few minutes behind the scenes.'
											]));
								} else {
									return '';
								}
							}();
							return {
								GZ: $elm$core$Platform$Cmd$none,
								agZ: 1,
								bH: $author$project$Components$Admin$Practitioner$DeleteModal$Closed,
								aR: _List_fromArray(
									[
										A2(
										$author$project$OutMsg$ShowToast,
										3,
										$author$project$Api$Provider$Practitioner$All$name(state.aka) + (' was successfully removed.' + message)),
										$author$project$OutMsg$RefreshPractice
									])
							};
						case 2:
							return {
								GZ: $elm$core$Platform$Cmd$none,
								agZ: 0,
								bH: $author$project$Components$Admin$Practitioner$DeleteModal$Open(
									_Utils_update(
										state,
										{uf: response})),
								aR: $author$project$OutMsg$handleErrorResponse(response)
							};
						default:
							return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, bH: modal, aR: _List_Nil};
					}
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, bH: $author$project$Components$Admin$Practitioner$DeleteModal$Closed, aR: _List_Nil};
				}
			default:
				var subMsg = msg.a;
				if (modal.$ === 1) {
					var state = modal.a;
					var practitionerResourceResult = A3($author$project$Components$ResourceFilter$Practitioner$update, apiClient, subMsg, state.hk);
					var newAction = function () {
						var _v9 = practitionerResourceResult.agZ;
						_v9$2:
						while (true) {
							if (!_v9.$) {
								switch (_v9.a.$) {
									case 0:
										var resource = _v9.a.a;
										return $author$project$Components$Admin$Practitioner$DeleteModal$Reassign(
											$elm$core$Maybe$Just(resource.ahP));
									case 2:
										var _v10 = _v9.a;
										return state.Gg;
									default:
										break _v9$2;
								}
							} else {
								break _v9$2;
							}
						}
						return state.Gg;
					}();
					return {
						GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$Practitioner$DeleteModal$PractitionerResourceFilterMsg, practitionerResourceResult.GZ),
						agZ: 0,
						bH: $author$project$Components$Admin$Practitioner$DeleteModal$Open(
							_Utils_update(
								state,
								{Gg: newAction, hk: practitionerResourceResult.aiO})),
						aR: practitionerResourceResult.aR
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, bH: $author$project$Components$Admin$Practitioner$DeleteModal$Closed, aR: _List_Nil};
				}
		}
	});
var $author$project$Components$LocationInput$update = F3(
	function (apiClient, msg, input) {
		var filterMsg = msg;
		var _v1 = A3($author$project$Components$ResourceFilter$Location$update, apiClient, filterMsg, input.HM);
		var model = _v1.aiO;
		var cmd = _v1.GZ;
		var event = _v1.agZ;
		return _Utils_Tuple3(
			function () {
				_v2$2:
				while (true) {
					if (!event.$) {
						switch (event.a.$) {
							case 0:
								var location = event.a.a;
								return _Utils_update(
									input,
									{
										HM: model,
										aee: $elm$core$Maybe$Just(location)
									});
							case 2:
								var _v3 = event.a;
								return _Utils_update(
									input,
									{HM: model, aee: $elm$core$Maybe$Nothing});
							default:
								break _v2$2;
						}
					} else {
						break _v2$2;
					}
				}
				return _Utils_update(
					input,
					{HM: model});
			}(),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd),
			event);
	});
var $author$project$Api$Provider$PracticeSettings$updateShowNpi = F3(
	function (apiClient, showNpi_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practice_settings',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'show_npi',
								$elm$json$Json$Encode$bool(showNpi_))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$PracticeSettings$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$PracticeSettings$practiceSettingsPath)));
	});
var $author$project$Pages$Admin$Providers$Top$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('q'),
			model.akl)
		]);
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[model.adY.YX]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.ajJ),
				A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams))));
};
var $author$project$Pages$Admin$Providers$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								j4: response,
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$reportDecodeError(response));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{j4: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$reportDecodeError(response));
				}
			case 1:
				var response = msg.a;
				var practiceProviderCount = function () {
					if (response.$ === 3) {
						var practitioners = response.a;
						var headers = response.b;
						return $elm$core$Maybe$Just(
							A2(
								$elm$core$Maybe$withDefault,
								$elm$core$List$length(practitioners),
								A2(
									$elm$core$Maybe$andThen,
									$elm$core$String$toInt,
									A2($elm$core$Dict$get, 'x-total-count', headers))));
					} else {
						return model.tX;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{tX: practiceProviderCount}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$reportDecodeError(response));
			case 2:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Wg: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$reportDecodeError(response));
			case 3:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{abU: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$reportDecodeError(response));
			case 4:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{zn: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$reportDecodeError(response));
			case 5:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{tY: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$reportDecodeError(response));
			case 6:
				var formFields = $author$project$Pages$Admin$Providers$Top$formFieldsInit;
				var form = $author$project$Utils$Form$init(formFields);
				var _v3 = A3(
					$author$project$Pages$Admin$Providers$Top$initLocationInputsFor,
					model.Gv,
					$author$project$Utils$Form$fields(form).Wg,
					_List_Nil);
				var locationInputs = _v3.a;
				var locationInputsCmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							Io: $elm$core$Maybe$Just(
								{SD: form, ahP: $elm$core$Maybe$Nothing, bF: locationInputs, uf: $author$project$Api$Data$NotAsked})
						}),
					locationInputsCmd,
					_List_Nil);
			case 7:
				var item = msg.a;
				var formFields = $author$project$Pages$Admin$Providers$Top$formFieldsFromItem(item);
				var form = $author$project$Utils$Form$init(formFields);
				var existingLocations = A2(
					$author$project$Api$Expandable$withDefault,
					_List_Nil,
					$author$project$Api$Provider$Practitioner$All$locations(item));
				var _v4 = A3(
					$author$project$Pages$Admin$Providers$Top$initLocationInputsFor,
					model.Gv,
					$author$project$Utils$Form$fields(form).Wg,
					existingLocations);
				var locationInputs = _v4.a;
				var locationInputsCmd = _v4.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							Io: $elm$core$Maybe$Just(
								{
									SD: form,
									ahP: $elm$core$Maybe$Just(
										$author$project$Api$Provider$Practitioner$All$id(item)),
									bF: locationInputs,
									uf: $author$project$Api$Data$NotAsked
								})
						}),
					locationInputsCmd,
					_List_Nil);
			case 8:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Io: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 9:
				var photos = msg.a;
				var cmd = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						function (_v5) {
							var task = _v5.a;
							var size = _v5.b;
							return A2(
								$elm$core$Task$perform,
								A2(
									$elm$core$Basics$composeL,
									$author$project$Pages$Admin$Providers$Top$FormUpdated,
									$author$project$Pages$Admin$Providers$Top$Photo(size)),
								task);
						},
						A2(
							$elm$core$Maybe$map,
							function (photo) {
								return _Utils_Tuple2(
									$elm$file$File$toUrl(photo),
									$elm$file$File$size(photo));
							},
							$elm$core$List$head(photos))));
				return _Utils_Tuple3(model, cmd, _List_Nil);
			case 10:
				var field = msg.a;
				var _v6 = model.Io;
				if (!_v6.$) {
					var state = _v6.a;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$Providers$Top$formFieldsUpdate, field, state.SD);
					var _v7 = function () {
						switch (field.$) {
							case 11:
								var appendedIndex = $elm$core$List$length(state.bF);
								var _v9 = A2($author$project$Components$LocationInput$empty, model.Gv, $elm$core$Basics$identity);
								var emptyInput = _v9.a;
								var emptyCmd = _v9.b;
								return _Utils_Tuple2(
									_Utils_ap(
										state.bF,
										_List_fromArray(
											[emptyInput])),
									A2(
										$elm$core$Platform$Cmd$map,
										$author$project$Pages$Admin$Providers$Top$EditLocationInputMsg(appendedIndex),
										emptyCmd));
							case 12:
								var index = field.a;
								return _Utils_Tuple2(
									A2($elm_community$list_extra$List$Extra$removeAt, index, state.bF),
									$elm$core$Platform$Cmd$none);
							default:
								return _Utils_Tuple2(state.bF, $elm$core$Platform$Cmd$none);
						}
					}();
					var newInputs = _v7.a;
					var newCmd = _v7.b;
					var syncedInputs = A2(
						$author$project$Pages$Admin$Providers$Top$syncExcludedIds,
						$author$project$Utils$Form$fields(newForm).Wg,
						newInputs);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Io: $elm$core$Maybe$Just(
									_Utils_update(
										state,
										{SD: newForm, bF: syncedInputs}))
							}),
						newCmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 11:
				var index = msg.a;
				var subMsg = msg.b;
				var _v10 = model.Io;
				if (!_v10.$) {
					var state = _v10.a;
					var _v11 = A2($elm_community$list_extra$List$Extra$getAt, index, state.bF);
					if (!_v11.$) {
						var input = _v11.a;
						var _v12 = A3($author$project$Components$LocationInput$update, model.Gv, subMsg, input);
						var updatedInput = _v12.a;
						var inputCmd = _v12.b;
						var event = _v12.c;
						var newForm = function () {
							_v13$2:
							while (true) {
								if (!event.$) {
									switch (event.a.$) {
										case 0:
											var resource = event.a.a;
											return A3(
												$author$project$Utils$Form$update,
												$author$project$Pages$Admin$Providers$Top$formFieldsUpdate,
												A2($author$project$Pages$Admin$Providers$Top$Location, index, resource.ahP),
												state.SD);
										case 2:
											var _v14 = event.a;
											return A3(
												$author$project$Utils$Form$update,
												$author$project$Pages$Admin$Providers$Top$formFieldsUpdate,
												A2($author$project$Pages$Admin$Providers$Top$Location, index, ''),
												state.SD);
										default:
											break _v13$2;
									}
								} else {
									break _v13$2;
								}
							}
							return state.SD;
						}();
						var inputsWithUpdate = A3($elm_community$list_extra$List$Extra$setAt, index, updatedInput, state.bF);
						var syncedInputs = A2(
							$author$project$Pages$Admin$Providers$Top$syncExcludedIds,
							$author$project$Utils$Form$fields(newForm).Wg,
							inputsWithUpdate);
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									Io: $elm$core$Maybe$Just(
										_Utils_update(
											state,
											{SD: newForm, bF: syncedInputs}))
								}),
							A2(
								$elm$core$Platform$Cmd$map,
								$author$project$Pages$Admin$Providers$Top$EditLocationInputMsg(index),
								inputCmd),
							_List_Nil);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 13:
				var form = msg.a;
				var id = msg.b;
				var _v15 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$Providers$Top$formFieldsValidator, form);
				if (!_v15.$) {
					var _v16 = _v15.a;
					var validatedForm = _v16.a;
					var validFormFields = _v16.b;
					var _v17 = model.Io;
					if (!_v17.$) {
						var state = _v17.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									Io: $elm$core$Maybe$Just(
										_Utils_update(
											state,
											{SD: validatedForm, uf: $author$project$Api$Data$Loading}))
								}),
							A3($author$project$Pages$Admin$Providers$Top$saveItem, model.Gv, id, validFormFields),
							_List_Nil);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				} else {
					var validatedForm = _v15.a;
					var _v18 = model.Io;
					if (!_v18.$) {
						var state = _v18.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									Io: $elm$core$Maybe$Just(
										_Utils_update(
											state,
											{SD: validatedForm, uf: $author$project$Api$Data$NotAsked}))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				}
			case 12:
				var item = msg.a;
				var practitioners = msg.b;
				var hasMoreThanOnePractitioner = A2($author$project$Pages$Admin$Providers$Top$hasMoreThanOnePracticeProvider, model, practitioners);
				if ((!hasMoreThanOnePractitioner) && (!(!$author$project$Api$Provider$Practice$One$collectPractitionerOnSignup(model.ZV)))) {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 1, 'Practice collects practitioners during signup. Can\'t delete last one.')
							]));
				} else {
					if ($author$project$Api$Provider$Practitioner$All$isSynced(item)) {
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 2, 'This provider is currently part of an affiliation. Please contact Hint to unlink this provider prior to deletion.')
								]));
					} else {
						var fields = $author$project$Pages$Admin$Providers$Top$formFieldsFromItem(item);
						var hasSyncedPatients = fields.acO > 0;
						var _v19 = A4($author$project$Components$Admin$Practitioner$DeleteModal$open, model.Gv, item, hasSyncedPatients, hasMoreThanOnePractitioner);
						var deleteModal = _v19.a;
						var deleteModalCmd = _v19.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{i8: deleteModal}),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Providers$Top$DeleteModalMsg, deleteModalCmd),
							_List_Nil);
					}
				}
			case 14:
				var response = msg.a;
				var _v20 = model.Io;
				if (!_v20.$) {
					var state = _v20.a;
					if (response.$ === 3) {
						var item = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{Io: $elm$core$Maybe$Nothing, j4: $author$project$Api$Data$Loading}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Admin$Providers$Top$fetchList(model),
										$author$project$Pages$Admin$Providers$Top$fetchPracticeProviderCount(model)
									])),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									'Successfully created ' + $author$project$Api$Provider$Practitioner$One$name(item)),
									$author$project$OutMsg$RefreshPractice
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									Io: $elm$core$Maybe$Just(
										_Utils_update(
											state,
											{uf: response}))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 15:
				var response = msg.a;
				var _v22 = model.Io;
				if (!_v22.$) {
					var state = _v22.a;
					if (response.$ === 3) {
						var item = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{Io: $elm$core$Maybe$Nothing, j4: $author$project$Api$Data$Loading}),
							$author$project$Pages$Admin$Providers$Top$fetchList(model),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Provider$Practitioner$One$name(item) + ' was successfully updated.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									Io: $elm$core$Maybe$Just(
										_Utils_update(
											state,
											{uf: response}))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 16:
				var item = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									eg: A2(
										$elm$core$Set$remove,
										$author$project$Api$Provider$Practitioner$All$id(item),
										model.eg),
									j4: $author$project$Api$Data$Loading
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Admin$Providers$Top$fetchList(model),
										$author$project$Pages$Admin$Providers$Top$fetchPracticeProviderCount(model)
									])),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Provider$Practitioner$All$name(item) + ' was successfully removed.'),
									$author$project$OutMsg$RefreshPractice
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									eg: A2(
										$elm$core$Set$remove,
										$author$project$Api$Provider$Practitioner$All$id(item),
										model.eg)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 20:
				var item = msg.a;
				var excludedLocationIds = A2(
					$elm$core$List$map,
					$author$project$Api$Provider$Location$Shared$id,
					A2(
						$author$project$Api$Expandable$withDefault,
						_List_Nil,
						$author$project$Api$Provider$Practitioner$All$locations(item)));
				var _v25 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Components$LocationInput$excludedIds(excludedLocationIds),
					A2($author$project$Components$LocationInput$empty, model.Gv, $elm$core$Basics$identity));
				var locationInput = _v25.a;
				var locationInputCmd = _v25.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bo: $elm$core$Maybe$Just(
								_Utils_Tuple3(item, locationInput, $author$project$Api$Data$NotAsked))
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Providers$Top$LocationInputMsg, locationInputCmd),
					_List_Nil);
			case 21:
				var subMsg = msg.a;
				var _v26 = model.bo;
				if (!_v26.$) {
					var _v27 = _v26.a;
					var item = _v27.a;
					var locationInput = _v27.b;
					var request = _v27.c;
					var _v28 = A3($author$project$Components$LocationInput$update, model.Gv, subMsg, locationInput);
					var updatedInput = _v28.a;
					var inputCmd = _v28.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bo: $elm$core$Maybe$Just(
									_Utils_Tuple3(item, updatedInput, request))
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Providers$Top$LocationInputMsg, inputCmd),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 22:
				var _v29 = model.bo;
				if (!_v29.$) {
					var _v30 = _v29.a;
					var item = _v30.a;
					var locationInput = _v30.b;
					var _v31 = locationInput.aee;
					if (!_v31.$) {
						var resource = _v31.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bo: $elm$core$Maybe$Just(
										_Utils_Tuple3(item, locationInput, $author$project$Api$Data$Loading))
								}),
							A4(
								$author$project$Api$Provider$Practitioner$Location$create,
								model.Gv,
								$author$project$Api$Provider$Practitioner$All$id(item),
								resource.ahP,
								$author$project$Pages$Admin$Providers$Top$LocationAdded),
							_List_Nil);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 23:
				var response = msg.a;
				var _v32 = model.bo;
				if (!_v32.$) {
					var _v33 = _v32.a;
					var item = _v33.a;
					var locationInput = _v33.b;
					switch (response.$) {
						case 3:
							var location = response.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{bo: $elm$core$Maybe$Nothing, j4: $author$project$Api$Data$Loading}),
								$author$project$Pages$Admin$Providers$Top$fetchList(model),
								_List_fromArray(
									[
										A2(
										$author$project$OutMsg$ShowToast,
										3,
										$author$project$Api$Provider$Location$One$name(location) + (' was successfully added to ' + ($author$project$Api$Provider$Practitioner$All$name(item) + '.')))
									]));
						case 2:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										bo: $elm$core$Maybe$Just(
											_Utils_Tuple3(item, locationInput, response))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$OutMsg$handleErrorResponse(response));
						default:
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 24:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bo: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 17:
				var item = msg.a;
				var confirmed = msg.b;
				if (confirmed) {
					var id = $author$project$Api$Provider$Practitioner$All$id(item);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								je: $elm$core$Maybe$Nothing,
								eg: A2($elm$core$Set$insert, id, model.eg)
							}),
						A4(
							$author$project$Api$Provider$Practitioner$delete,
							model.Gv,
							id,
							$elm$core$Maybe$Nothing,
							$author$project$Pages$Admin$Providers$Top$Deleted(item)),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{je: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 18:
				var subMsg = msg.a;
				var _v35 = A3($author$project$Components$LinkedRecords$update, model.Gv, subMsg, model.oo);
				var linkedRecords = _v35.a;
				var subCmd = _v35.b;
				var subOutMsg = _v35.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oo: linkedRecords}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Providers$Top$LinkedRecordsMsg, subCmd),
					subOutMsg);
			case 19:
				var subMsg = msg.a;
				var result = A3($author$project$Components$Admin$Practitioner$DeleteModal$update, model.Gv, subMsg, model.i8);
				var _v36 = function () {
					var _v37 = result.agZ;
					if (_v37 === 1) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{j4: $author$project$Api$Data$Loading}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Admin$Providers$Top$fetchList(model),
										$author$project$Pages$Admin$Providers$Top$fetchPracticeProviderCount(model)
									])));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				}();
				var newModel = _v36.a;
				var cmd = _v36.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{i8: result.bH}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								cmd,
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Providers$Top$DeleteModalMsg, result.GZ)
							])),
					result.aR);
			case 25:
				var bool = msg.a;
				return _Utils_Tuple3(
					model,
					A3($author$project$Api$Provider$PracticeSettings$updateShowNpi, model.Gv, bool, $author$project$Pages$Admin$Providers$Top$PracticeSettingsUpdated),
					_List_Nil);
			case 26:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{j4: $author$project$Api$Data$Loading, ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Admin$Providers$Top$fetchList(newModel),
								$author$project$Pages$Admin$Providers$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 27:
				var subMsg = msg.a;
				var _v38 = A2($author$project$Ui$SearchInput$update, subMsg, model.up);
				var searchInput = _v38.a;
				var searchInputCmd = _v38.b;
				var searchInputEvent = _v38.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.akl;
					}
				}();
				var _v39 = function () {
					if (_Utils_eq(q, model.akl)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								j4: $author$project$Api$Data$Loading,
								ajJ: $author$project$Api$Pagination$reset(model.ajJ),
								akl: q
							});
						return _Utils_Tuple2(
							qModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Admin$Providers$Top$fetchList(qModel),
										$author$project$Pages$Admin$Providers$Top$updateUrl(qModel)
									])));
					}
				}();
				var newModel = _v39.a;
				var cmd = _v39.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{up: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Providers$Top$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var newModel = _Utils_update(
						model,
						{tY: response});
					var message = 'Your practice has been updated';
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, message)
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Admin$Providers$Top$New = {$: 6};
var $author$project$Pages$Admin$Providers$Top$PaginationMsg = function (a) {
	return {$: 26, a: a};
};
var $author$project$Components$Admin$Practitioner$DeleteModal$Delete = {$: 1};
var $author$project$Components$Admin$Practitioner$DeleteModal$RemoveAssignment = {$: 1};
var $author$project$Components$Admin$Practitioner$DeleteModal$UpdateAction = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$ResourceFilter$Practitioner$value = function (model) {
	return A2($author$project$Components$ResourceFilter$choiceToValue, model.b8, model.Jy);
};
var $author$project$Components$ResourceFilter$Practitioner$view = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$view,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.Jy),
					options),
				model.b8));
	});
var $author$project$Components$Admin$Practitioner$DeleteModal$viewModal = function (state) {
	var action = state.zP ? state.Gg : $author$project$Components$Admin$Practitioner$DeleteModal$RemoveAssignment;
	var _v0 = function () {
		if (!action.$) {
			return _Utils_Tuple2(true, false);
		} else {
			return _Utils_Tuple2(false, true);
		}
	}();
	var reassignActive = _v0.a;
	var removeAssignmentActive = _v0.b;
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Admin$Practitioner$DeleteModal$CloseModal,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('What would you like to do with patients assigned to this provider?')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Action'),
								$author$project$Ui$Form$Group$labelSpan(2),
								$author$project$Ui$Form$Group$inputSpan(10)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Button$group(
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Reassign to a different provider'},
										_List_fromArray(
											[
												$author$project$Ui$Button$active(reassignActive),
												$author$project$Ui$Button$disabled(!state.zP),
												$author$project$Ui$Button$onClick(
												$author$project$Components$Admin$Practitioner$DeleteModal$UpdateAction(
													$author$project$Components$Admin$Practitioner$DeleteModal$Reassign($elm$core$Maybe$Nothing)))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Reassign')
											])),
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Remove assignment'},
										_List_fromArray(
											[
												$author$project$Ui$Button$active(removeAssignmentActive),
												$author$project$Ui$Button$disabled(state.HZ),
												$author$project$Ui$Button$onClick(
												$author$project$Components$Admin$Practitioner$DeleteModal$UpdateAction($author$project$Components$Admin$Practitioner$DeleteModal$RemoveAssignment))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Remove assignment')
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pt-05')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
										_List_fromArray(
											[
												function () {
												if (!action.$) {
													return $elm$html$Html$text(
														'All patients currently assigned to ' + ($author$project$Api$Provider$Practitioner$All$name(state.aka) + ' will be assigned to the provider selected below'));
												} else {
													return $elm$html$Html$text(
														'All patients currently assigned to ' + ($author$project$Api$Provider$Practitioner$All$name(state.aka) + ' will no longer be assigned to a provider'));
												}
											}()
											]))
									])),
								function () {
								if (!action.$) {
									var invalidPractitioner = function () {
										var _v4 = $author$project$Components$ResourceFilter$Practitioner$value(state.hk);
										if (!_v4.$) {
											return false;
										} else {
											return true;
										}
									}();
									return A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pt-05')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Components$Admin$Practitioner$DeleteModal$PractitionerResourceFilterMsg,
												A2(
													$author$project$Components$ResourceFilter$Practitioner$view,
													_List_fromArray(
														[
															invalidPractitioner ? $author$project$Components$ResourceFilter$errors(
															_List_fromArray(
																['Please pick a provider for reassignment'])) : $author$project$Components$ResourceFilter$errors(_List_Nil)
														]),
													state.hk))
											]));
								} else {
									return $author$project$Utils$Html$empty;
								}
							}()
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Admin$Practitioner$DeleteModal$CloseModal)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Delete provider'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$loading(
								_Utils_eq(state.uf, $author$project$Api$Data$Loading)),
								$author$project$Ui$Button$onClick($author$project$Components$Admin$Practitioner$DeleteModal$Delete),
								$author$project$Ui$Button$icon($author$project$Ui$Icon$check)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Delete')
							]))
					]))
			]));
};
var $author$project$Components$Admin$Practitioner$DeleteModal$view = function (modal) {
	if (modal.$ === 1) {
		var state = modal.a;
		return $author$project$Components$Admin$Practitioner$DeleteModal$viewModal(state);
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Admin$Providers$Top$SaveLocation = {$: 22};
var $author$project$Components$LocationInput$optionToRecord = F2(
	function (option, acc) {
		var errors_ = option;
		return _Utils_update(
			acc,
			{agX: errors_});
	});
var $author$project$Components$ResourceFilter$Style = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$ResourceFilter$style = $author$project$Components$ResourceFilter$Style;
var $author$project$Components$LocationInput$view = F2(
	function (options, _v0) {
		var filter = _v0.HM;
		var disabled = _v0.ep;
		var optionsRecord = A3(
			$elm$core$List$foldl,
			$author$project$Components$LocationInput$optionToRecord,
			{agX: _List_Nil},
			options);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$elm$core$Basics$identity,
					A2(
						$author$project$Components$ResourceFilter$Location$view,
						_List_fromArray(
							[
								$author$project$Components$ResourceFilter$style(0),
								$author$project$Components$ResourceFilter$invalid(
								!$elm$core$List$isEmpty(optionsRecord.agX)),
								$author$project$Components$ResourceFilter$disabled(disabled)
							]),
						filter)),
					$author$project$Utils$FormErrors$view(optionsRecord.agX)
				]));
	});
var $author$project$Pages$Admin$Providers$Top$viewAddLocationModal = F4(
	function (model, item, locationInput, request) {
		var locations = function () {
			var _v0 = model.Wg;
			if (_v0.$ === 3) {
				var locations_ = _v0.a;
				return locations_;
			} else {
				return _List_Nil;
			}
		}();
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Pages$Admin$Providers$Top$CancelAddLocation,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title(
							'Add location to ' + $author$project$Api$Provider$Practitioner$All$name(item))
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							$elm$core$List$isEmpty(locations) ? A2(
							$author$project$Ui$Alert$warning,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('You have no locations, '),
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Admin__Locations,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('add them here first')
										]))
								])) : A2(
							$elm$html$Html$map,
							$author$project$Pages$Admin$Providers$Top$LocationInputMsg,
							A2($author$project$Components$LocationInput$view, _List_Nil, locationInput))
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Cancel and close modal'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Pages$Admin$Providers$Top$CancelAddLocation)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Add location'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$loading(
									_Utils_eq(request, $author$project$Api$Data$Loading)),
									$author$project$Ui$Button$onClick($author$project$Pages$Admin$Providers$Top$SaveLocation),
									$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Add')
								]))
						]))
				]));
	});
var $author$project$Api$Feature$ProviderWaitlist = 28;
var $author$project$Pages$Admin$Providers$Top$Save = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Api$Provider$Practitioner$Meta$bio = function (_v0) {
	var fields = _v0;
	return fields.MK;
};
var $author$project$Api$Provider$Practitioner$Meta$education = function (_v0) {
	var fields = _v0;
	return fields.Q6;
};
var $author$project$Api$Provider$Practice$Shared$elationEnabled = function (_v0) {
	var record = _v0;
	return record.Ra;
};
var $author$project$Api$Provider$Practice$One$elationEnabled = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$elationEnabled(shared);
};
var $author$project$Api$Provider$Practitioner$Meta$email = function (_v0) {
	var fields = _v0;
	return fields.Rj;
};
var $author$project$Api$Provider$Practitioner$Meta$gender = function (_v0) {
	var fields = _v0;
	return fields.SR;
};
var $author$project$Api$Provider$Practitioner$Meta$locations = function (_v0) {
	var fields = _v0;
	return fields.Wg;
};
var $author$project$Api$Provider$Practitioner$Meta$name = function (_v0) {
	var fields = _v0;
	return fields.Bq;
};
var $author$project$Api$Provider$Practitioner$Meta$panelSizeLimit = function (_v0) {
	var fields = _v0;
	return fields.YK;
};
var $author$project$Api$Provider$Practitioner$Meta$photo = function (_v0) {
	var fields = _v0;
	return fields.Zz;
};
var $author$project$Api$Provider$Practitioner$Meta$specialtyNames = function (_v0) {
	var fields = _v0;
	return fields.abV;
};
var $author$project$Api$Provider$Practitioner$Meta$treatsAge = function (_v0) {
	var fields = _v0;
	return fields.adE;
};
var $author$project$Pages$Admin$Providers$Top$AcceptsEnrollmentsFromEmployer = function (a) {
	return {$: 23, a: a};
};
var $author$project$Pages$Admin$Providers$Top$AcceptsEnrollmentsFromRetail = function (a) {
	return {$: 24, a: a};
};
var $author$project$Pages$Admin$Providers$Top$viewAcceptsEnrollmentsForm = F2(
	function (acceptsEnrollmentsFromEmployer, acceptsEnrollmentsFromRetail) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$inputSpan(9),
					$author$project$Ui$Form$Group$labelSpan(3),
					$author$project$Ui$Form$Group$label('Accepting Enrollments From')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Checkbox$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Checkbox$value(acceptsEnrollmentsFromEmployer),
							$author$project$Ui$Form$Checkbox$onCheck(
							A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$AcceptsEnrollmentsFromEmployer))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Employer')
						])),
					A2(
					$author$project$Ui$Form$Checkbox$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Checkbox$value(acceptsEnrollmentsFromRetail),
							$author$project$Ui$Form$Checkbox$onCheck(
							A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$AcceptsEnrollmentsFromRetail))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Retail')
						]))
				]));
	});
var $author$project$Pages$Admin$Providers$Top$Bio = function (a) {
	return {$: 1, a: a};
};
var $author$project$Utils$MetaFields$explanation = function (metaField) {
	if (!metaField.$) {
		return $elm$core$Maybe$Nothing;
	} else {
		var explanation_ = metaField.a;
		return explanation_;
	}
};
var $author$project$Pages$Admin$Providers$Top$withinTooltipIf = F2(
	function (maybeExplanation, content) {
		if (!maybeExplanation.$) {
			var explanation = maybeExplanation.a;
			return A3(
				$author$project$Ui$Tooltip$view,
				_List_Nil,
				explanation,
				_List_fromArray(
					[content]));
		} else {
			return content;
		}
	});
var $author$project$Pages$Admin$Providers$Top$viewBio = F2(
	function (bio, editable) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Bio')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Pages$Admin$Providers$Top$withinTooltipIf,
					$author$project$Utils$MetaFields$explanation(editable),
					$author$project$Ui$Form$Textarea$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Textarea$value(
								A2($elm$core$Maybe$withDefault, '', bio)),
								$author$project$Ui$Form$Textarea$onInput(
								A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$Bio)),
								$author$project$Ui$Form$Textarea$disabled(
								$author$project$Utils$MetaFields$isUneditable(editable))
							])))
				]));
	});
var $author$project$Pages$Admin$Providers$Top$AddEducation = {$: 15};
var $author$project$Pages$Admin$Providers$Top$Education = F2(
	function (a, b) {
		return {$: 14, a: a, b: b};
	});
var $author$project$Pages$Admin$Providers$Top$RemoveEducation = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Admin$Providers$Top$viewEducation = F4(
	function (educations, editable, index, education) {
		var isLast = _Utils_eq(
			index,
			$elm$core$List$length(educations) - 1);
		var isFirst = !index;
		var label = isFirst ? 'Education' : '';
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label(label)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$group(
					_List_fromArray(
						[
							A2(
							$author$project$Pages$Admin$Providers$Top$withinTooltipIf,
							$author$project$Utils$MetaFields$explanation(editable),
							$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$value(education),
										$author$project$Ui$Form$Input$onInput(
										A2(
											$elm$core$Basics$composeL,
											$author$project$Pages$Admin$Providers$Top$FormUpdated,
											$author$project$Pages$Admin$Providers$Top$Education(index))),
										$author$project$Ui$Form$Input$placeholder('Stanford Medical School'),
										$author$project$Ui$Form$Input$disabled(
										$author$project$Utils$MetaFields$isUneditable(editable))
									]))),
							($elm$core$List$length(educations) > 1) ? A2(
							$author$project$Pages$Admin$Providers$Top$withinTooltipIf,
							$author$project$Utils$MetaFields$explanation(editable),
							A3(
								$author$project$Ui$Button$view,
								{mm: 'Remove education'},
								_List_fromArray(
									[
										$author$project$Ui$Button$sm,
										$author$project$Ui$Button$onClick(
										$author$project$Pages$Admin$Providers$Top$FormUpdated(
											$author$project$Pages$Admin$Providers$Top$RemoveEducation(index))),
										$author$project$Ui$Button$disabled(
										$author$project$Utils$MetaFields$isUneditable(editable)),
										$author$project$Ui$Button$icon($author$project$Ui$Icon$minus)
									]),
								_List_Nil)) : $author$project$Utils$Html$empty,
							isLast ? A2(
							$author$project$Pages$Admin$Providers$Top$withinTooltipIf,
							$author$project$Utils$MetaFields$explanation(editable),
							A3(
								$author$project$Ui$Button$view,
								{mm: 'Add education'},
								_List_fromArray(
									[
										$author$project$Ui$Button$sm,
										$author$project$Ui$Button$onClick(
										$author$project$Pages$Admin$Providers$Top$FormUpdated($author$project$Pages$Admin$Providers$Top$AddEducation)),
										$author$project$Ui$Button$disabled(
										$author$project$Utils$MetaFields$isUneditable(editable)),
										$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
									]),
								_List_Nil)) : $author$project$Utils$Html$empty
						]))
				]));
	});
var $author$project$Pages$Admin$Providers$Top$ElationPhysicianId = function (a) {
	return {$: 17, a: a};
};
var $author$project$Api$Provider$ElationPhysician$All$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$ElationPhysician$All$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Pages$Admin$Providers$Top$elationPhysicianOptions = function (elationPhysicians) {
	return A2(
		$elm$core$List$cons,
		A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(''),
			'None'),
		A2(
			$elm$core$List$map,
			function (elationPhysician) {
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$ElationPhysician$All$id(elationPhysician)),
					$author$project$Api$Provider$ElationPhysician$All$name(elationPhysician));
			},
			elationPhysicians));
};
var $author$project$Pages$Admin$Providers$Top$viewElationSync = F2(
	function (elationPhysicianId, elationPhysicians) {
		var _v0 = function () {
			if (elationPhysicians.$ === 3) {
				var physicians = elationPhysicians.a;
				return _Utils_Tuple2(false, physicians);
			} else {
				return _Utils_Tuple2(true, _List_Nil);
			}
		}();
		var elationPhysiciansLoading = _v0.a;
		var elationPhysicians_ = _v0.b;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Elation Sync')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Select$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Select$value(elationPhysicianId),
							$author$project$Ui$Form$Select$onChange(
							A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$ElationPhysicianId)),
							$author$project$Ui$Form$Select$disabled(
							$elm$core$List$isEmpty(elationPhysicians_)),
							$author$project$Ui$Form$Select$loading(elationPhysiciansLoading)
						]),
					$author$project$Pages$Admin$Providers$Top$elationPhysicianOptions(elationPhysicians_))
				]));
	});
var $author$project$Pages$Admin$Providers$Top$Email = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$Providers$Top$viewEmail = F2(
	function (email, editable) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Email')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Pages$Admin$Providers$Top$withinTooltipIf,
					$author$project$Utils$MetaFields$explanation(editable),
					$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(
								A2($elm$core$Maybe$withDefault, '', email)),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$Email)),
								$author$project$Ui$Form$Input$placeholder('dr.mccoy@example.com'),
								$author$project$Ui$Form$Input$disabled(
								$author$project$Utils$MetaFields$isUneditable(editable))
							])))
				]));
	});
var $author$project$Pages$Admin$Providers$Top$Gender = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$Providers$Top$GenderOther = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Form$Gender$Disabled = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Form$Gender$disabled = $author$project$Ui$Form$Gender$Disabled;
var $author$project$Ui$Form$Gender$Gender = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$Gender$gender = $author$project$Ui$Form$Gender$Gender;
var $author$project$Ui$Form$Gender$GenderOther = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Form$Gender$genderOther = $author$project$Ui$Form$Gender$GenderOther;
var $author$project$Ui$Form$Gender$OnGenderChange = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Form$Gender$onGenderChange = $author$project$Ui$Form$Gender$OnGenderChange;
var $author$project$Ui$Form$Gender$OnGenderOtherChange = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Form$Gender$onGenderOtherChange = $author$project$Ui$Form$Gender$OnGenderOtherChange;
var $author$project$Ui$Form$Gender$defaultOptions = {xr: _List_Nil, ep: false, agX: _List_Nil, SR: $elm$core$Maybe$Nothing, ST: $elm$core$Maybe$Nothing, sM: false, BY: $elm$core$Maybe$Nothing, BZ: $elm$core$Maybe$Nothing};
var $author$project$Ui$Form$Gender$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var string = option.a;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$id(string),
									record.xr)
							});
					case 3:
						var handler = option.a;
						return _Utils_update(
							record,
							{
								BY: $elm$core$Maybe$Just(handler)
							});
					case 4:
						var handler = option.a;
						return _Utils_update(
							record,
							{
								BZ: $elm$core$Maybe$Just(handler)
							});
					case 1:
						var gender_ = option.a;
						return _Utils_update(
							record,
							{SR: gender_});
					case 2:
						var string = option.a;
						return _Utils_update(
							record,
							{ST: string});
					case 5:
						var bool = option.a;
						return _Utils_update(
							record,
							{ep: bool});
					case 6:
						var bool = option.a;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('form-control--errored', bool)
											])),
									record.xr),
								sM: bool
							});
					default:
						var list = option.a;
						return _Utils_update(
							record,
							{agX: list});
				}
			}),
		$author$project$Ui$Form$Gender$defaultOptions,
		options);
};
var $author$project$Ui$Form$Gender$viewGenderOption = F2(
	function (options, gender_) {
		var genderString = $author$project$Api$Gender$toString(gender_);
		return A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('radio-inline')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$type_('radio'),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$name('gender'),
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$value(genderString),
								A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$checked(
										_Utils_eq(
											$elm$core$Maybe$Just(gender_),
											options.SR)),
									A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$disabled(options.ep),
										function () {
											var _v0 = options.BY;
											if (!_v0.$) {
												var handler = _v0.a;
												return _List_fromArray(
													[
														$elm$html$Html$Events$onInput(
														A2(
															$elm$core$Basics$composeL,
															handler,
															$elm$core$Basics$always(gender_)))
													]);
											} else {
												return _List_Nil;
											}
										}()))))),
					_List_Nil),
					$elm$html$Html$text(
					$author$project$Formatters$String$titleize(genderString))
				]));
	});
var $author$project$Ui$Form$Gender$view = function (options) {
	var optionsRecord = $author$project$Ui$Form$Gender$optionsToRecord(options);
	var genderOptions = _List_fromArray(
		[0, 1, 3]);
	var radios = A2(
		$elm$core$List$map,
		$author$project$Ui$Form$Gender$viewGenderOption(optionsRecord),
		genderOptions);
	var genderExplanation = $elm$core$Maybe$Nothing;
	return A2(
		$author$project$Ui$Grid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$column,
				_List_Nil,
				_List_fromArray(
					[
						function () {
						if (!genderExplanation.$) {
							var genderExplanation_ = genderExplanation.a;
							return A3($author$project$Ui$Tooltip$view, _List_Nil, genderExplanation_, radios);
						} else {
							return A2($elm$html$Html$div, _List_Nil, radios);
						}
					}()
					])),
				_Utils_eq(
				optionsRecord.SR,
				$elm$core$Maybe$Just(3)) ? A2(
				$author$project$Ui$Grid$column,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						A2(
							$elm$core$List$cons,
							$author$project$Ui$Form$Input$placeholder('Description'),
							A2(
								$elm$core$List$cons,
								$author$project$Ui$Form$Input$autoComplete(false),
								A2(
									$elm$core$List$cons,
									$author$project$Ui$Form$Input$value(
										A2($elm$core$Maybe$withDefault, '', optionsRecord.ST)),
									A2(
										$elm$core$List$cons,
										$author$project$Ui$Form$Input$disabled(optionsRecord.ep),
										A2(
											$elm$core$List$cons,
											$author$project$Ui$Form$Input$phi(true),
											function () {
												var _v1 = optionsRecord.BZ;
												if (!_v1.$) {
													var handler = _v1.a;
													return _List_fromArray(
														[
															$author$project$Ui$Form$Input$onInput(handler)
														]);
												} else {
													return _List_Nil;
												}
											}()))))))
					])) : $author$project$Ui$Grid$none
			]));
};
var $author$project$Pages$Admin$Providers$Top$viewGender = F3(
	function (gender, genderOther, editable) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Gender')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Pages$Admin$Providers$Top$withinTooltipIf,
					$author$project$Utils$MetaFields$explanation(editable),
					$author$project$Ui$Form$Gender$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Gender$gender(gender),
								$author$project$Ui$Form$Gender$genderOther(genderOther),
								$author$project$Ui$Form$Gender$onGenderChange(
								A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$Gender)),
								$author$project$Ui$Form$Gender$onGenderOtherChange(
								A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$GenderOther)),
								$author$project$Ui$Form$Gender$disabled(
								$author$project$Utils$MetaFields$isUneditable(editable))
							])))
				]));
	});
var $author$project$Pages$Admin$Providers$Top$AddLocationItem = {$: 11};
var $author$project$Pages$Admin$Providers$Top$RemoveLocationItem = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$LocationInput$disable = F2(
	function (disabled, input) {
		return _Utils_update(
			input,
			{ep: disabled});
	});
var $author$project$Components$LocationInput$Errors = $elm$core$Basics$identity;
var $author$project$Components$LocationInput$errors = $elm$core$Basics$identity;
var $author$project$Ui$Element$Fill = {$: 17};
var $author$project$Ui$Element$fill = $author$project$Ui$Element$Fill;
var $author$project$Pages$Admin$Providers$Top$viewLocationsDropdown = F5(
	function (form, inputs, editable, index, _v0) {
		var rowCount = $elm$core$List$length(inputs);
		var isLast = _Utils_eq(index, rowCount - 1);
		var isFirst = !index;
		var label = isFirst ? 'Locations' : '';
		var dropdown = function () {
			var _v1 = A2($elm_community$list_extra$List$Extra$getAt, index, inputs);
			if (!_v1.$) {
				var input = _v1.a;
				var validationErrors = isLast ? A2($author$project$Utils$Form$validationErrors, 3, form) : _List_Nil;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$Admin$Providers$Top$EditLocationInputMsg(index),
					A2(
						$author$project$Components$LocationInput$view,
						_List_fromArray(
							[
								$author$project$Components$LocationInput$errors(validationErrors)
							]),
						A2(
							$author$project$Components$LocationInput$disable,
							$author$project$Utils$MetaFields$isUneditable(editable),
							input)));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}();
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label(label),
					$author$project$Ui$Form$Group$required(true)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$group(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$fill]),
							_List_fromArray(
								[
									A2(
									$author$project$Pages$Admin$Providers$Top$withinTooltipIf,
									$author$project$Utils$MetaFields$explanation(editable),
									dropdown)
								])),
							((rowCount > 1) && $author$project$Utils$MetaFields$isEditable(editable)) ? A2(
							$author$project$Pages$Admin$Providers$Top$withinTooltipIf,
							$author$project$Utils$MetaFields$explanation(editable),
							A3(
								$author$project$Ui$Button$view,
								{mm: 'Remove Location'},
								_List_fromArray(
									[
										$author$project$Ui$Button$sm,
										$author$project$Ui$Button$disabled(
										$author$project$Utils$MetaFields$isUneditable(editable)),
										$author$project$Ui$Button$onClick(
										$author$project$Pages$Admin$Providers$Top$FormUpdated(
											$author$project$Pages$Admin$Providers$Top$RemoveLocationItem(index))),
										$author$project$Ui$Button$icon($author$project$Ui$Icon$minus)
									]),
								_List_Nil)) : $author$project$Utils$Html$empty,
							isLast ? A2(
							$author$project$Pages$Admin$Providers$Top$withinTooltipIf,
							$author$project$Utils$MetaFields$explanation(editable),
							A3(
								$author$project$Ui$Button$view,
								{mm: 'Add Location'},
								_List_fromArray(
									[
										$author$project$Ui$Button$sm,
										$author$project$Ui$Button$onClick(
										$author$project$Pages$Admin$Providers$Top$FormUpdated($author$project$Pages$Admin$Providers$Top$AddLocationItem)),
										$author$project$Ui$Button$icon($author$project$Ui$Icon$add),
										$author$project$Ui$Button$disabled(
										$author$project$Utils$MetaFields$isUneditable(editable))
									]),
								_List_Nil)) : $author$project$Utils$Html$empty
						]))
				]));
	});
var $author$project$Pages$Admin$Providers$Top$IsProvider = function (a) {
	return {$: 22, a: a};
};
var $author$project$Pages$Admin$Providers$Top$Npi = function (a) {
	return {$: 20, a: a};
};
var $author$project$Ui$Form$Checkbox$Inline = {$: 7};
var $author$project$Ui$Form$Checkbox$inline = $author$project$Ui$Form$Checkbox$Inline;
var $author$project$Pages$Admin$Providers$Top$viewNPI = F4(
	function (isProvider, npi, editable, errors) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('NPI'),
					$author$project$Ui$Form$Group$required(isProvider)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Pages$Admin$Providers$Top$withinTooltipIf,
					$author$project$Utils$MetaFields$explanation(editable),
					$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(
								A2($elm$core$Maybe$withDefault, '', npi)),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$Npi)),
								$author$project$Ui$Form$Input$maxLength(10),
								$author$project$Ui$Form$Input$invalid(
								!$elm$core$List$isEmpty(errors)),
								$author$project$Ui$Form$Input$errors(errors),
								$author$project$Ui$Form$Input$disabled(
								$author$project$Utils$MetaFields$isUneditable(editable))
							]))),
					$author$project$Utils$Html$noBreakSpace,
					A2(
					$author$project$Pages$Admin$Providers$Top$withinTooltipIf,
					$author$project$Utils$MetaFields$explanation(editable),
					A2(
						$author$project$Ui$Form$Checkbox$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Checkbox$value(!isProvider),
								$author$project$Ui$Form$Checkbox$onCheck(
								A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$IsProvider)),
								$author$project$Ui$Form$Checkbox$inline,
								$author$project$Ui$Form$Checkbox$disabled(
								$author$project$Utils$MetaFields$isUneditable(editable))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Not a provider, does not have an NPI')
							])))
				]));
	});
var $author$project$Pages$Admin$Providers$Top$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$Providers$Top$viewName = F3(
	function (name, editable, errors) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Name'),
					$author$project$Ui$Form$Group$required(true)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Pages$Admin$Providers$Top$withinTooltipIf,
					$author$project$Utils$MetaFields$explanation(editable),
					$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(name),
								$author$project$Ui$Form$Input$placeholder('Dr. Leonard McCoy, MD'),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$Name)),
								$author$project$Ui$Form$Input$invalid(
								!$elm$core$List$isEmpty(errors)),
								$author$project$Ui$Form$Input$errors(errors),
								$author$project$Ui$Form$Input$disabled(
								$author$project$Utils$MetaFields$isUneditable(editable))
							])))
				]));
	});
var $author$project$Pages$Admin$Providers$Top$AutoDetermineOnlineSignupVisibilityFromPanelSize = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$Admin$Providers$Top$OnlineSignupVisibility = function (a) {
	return {$: 21, a: a};
};
var $author$project$Pages$Admin$Providers$Top$viewOnlineSignup = F2(
	function (onlineSignupVisibility, autoDetermineOnlineSignupVisibilityFromPanelSize) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Online Signup')
				]),
			_List_fromArray(
				[
					$author$project$Ui$ToggleSwitch$view(
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$on(onlineSignupVisibility),
							$author$project$Ui$ToggleSwitch$onChange(
							A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$OnlineSignupVisibility)),
							$author$project$Ui$ToggleSwitch$disabled(autoDetermineOnlineSignupVisibilityFromPanelSize)
						])),
					$author$project$Utils$Html$noBreakSpace,
					A2(
					$author$project$Ui$Form$Checkbox$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Checkbox$value(autoDetermineOnlineSignupVisibilityFromPanelSize),
							$author$project$Ui$Form$Checkbox$onCheck(
							A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$AutoDetermineOnlineSignupVisibilityFromPanelSize)),
							$author$project$Ui$Form$Checkbox$inline
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Auto determine from panel size')
						]))
				]));
	});
var $author$project$Pages$Admin$Providers$Top$PanelSizeLimit = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$Admin$Providers$Top$viewPanelSize = F4(
	function (autoDetermineOnlineSignupVisibilityFromPanelSize, panelSizeLimit, panelSize, editable) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Panel Size Limit'),
					$author$project$Ui$Form$Group$required(autoDetermineOnlineSignupVisibilityFromPanelSize)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Pages$Admin$Providers$Top$withinTooltipIf,
					$author$project$Utils$MetaFields$explanation(editable),
					$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$number,
								$author$project$Ui$Form$Input$value(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									A2($elm$core$Maybe$map, $elm$core$String$fromInt, panelSizeLimit))),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$PanelSizeLimit)),
								$author$project$Ui$Form$Input$placeholder('No Limit'),
								$author$project$Ui$Form$Input$disabled(
								$author$project$Utils$MetaFields$isUneditable(editable))
							]))),
					A2(
					$author$project$Ui$Typography$text,
					_List_fromArray(
						[$author$project$Ui$Typography$helpText]),
					'Current Panel Size: ' + A2(
						$elm$core$Maybe$withDefault,
						'N/A',
						A2($elm$core$Maybe$map, $elm$core$String$fromInt, panelSize)))
				]));
	});
var $author$project$Pages$Admin$Providers$Top$viewPhoto = F2(
	function (currentPhotoUrl, errors) {
		if (!currentPhotoUrl.$) {
			var url = currentPhotoUrl.a;
			return $elm$core$String$isEmpty(url) ? $author$project$Utils$Html$empty : A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(3),
						$author$project$Ui$Form$Group$inputSpanSm(9),
						$author$project$Ui$Form$Group$label('')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Image$fromSrc,
						{LD: 'Provider photo'},
						url,
						_List_fromArray(
							[
								$author$project$Ui$Image$height(100)
							])),
						$author$project$Utils$FormErrors$view(errors)
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Pages$Admin$Providers$Top$PhotoUploaded = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Admin$Providers$Top$viewPhotoLabel = function (editable) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9),
				$author$project$Ui$Form$Group$label('Photo')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Pages$Admin$Providers$Top$withinTooltipIf,
				$author$project$Utils$MetaFields$explanation(editable),
				$author$project$Ui$Form$File$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$File$accept(0),
							$author$project$Ui$Form$File$onInput($author$project$Pages$Admin$Providers$Top$PhotoUploaded),
							$author$project$Ui$Form$File$empty(true),
							$author$project$Ui$Form$File$disabled(
							$author$project$Utils$MetaFields$isUneditable(editable))
						])))
			]));
};
var $author$project$Pages$Admin$Providers$Top$AddSpecialty = {$: 10};
var $author$project$Pages$Admin$Providers$Top$RemoveSpecialty = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Admin$Providers$Top$Specialty = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Api$Provider$Specialty$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$Specialty$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Specialty$Shared$name(shared);
};
var $author$project$Pages$Admin$Providers$Top$specialtyOptions = F3(
	function (allSpecialties, specialties, specialty) {
		return A2(
			$elm$core$List$cons,
			A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(''),
				''),
			A2(
				$elm$core$List$map,
				function (specialty_) {
					return A3(
						$author$project$Ui$Form$Select$option,
						_List_Nil,
						$elm$core$Maybe$Just(
							$author$project$Api$Provider$Specialty$All$name(specialty_)),
						$author$project$Api$Provider$Specialty$All$name(specialty_));
				},
				A2(
					$elm_community$list_extra$List$Extra$filterNot,
					function (specialty_) {
						return (!_Utils_eq(
							$author$project$Api$Provider$Specialty$All$name(specialty_),
							specialty)) && A2(
							$elm$core$List$member,
							$author$project$Api$Provider$Specialty$All$name(specialty_),
							specialties);
					},
					allSpecialties)));
	});
var $author$project$Pages$Admin$Providers$Top$viewSpecialty = F6(
	function (allSpecialtiesLoading, allSpecialties, specialties, editable, index, specialty) {
		var isLast = _Utils_eq(
			index,
			$elm$core$List$length(specialties) - 1);
		var isFirst = !index;
		var label = isFirst ? 'Specialties' : '';
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label(label)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex space-between')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$group(
							_List_fromArray(
								[
									A2(
									$author$project$Pages$Admin$Providers$Top$withinTooltipIf,
									$author$project$Utils$MetaFields$explanation(editable),
									A2(
										$author$project$Ui$Form$Select$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Select$value(
												$elm$core$Maybe$Just(specialty)),
												$author$project$Ui$Form$Select$onChange(
												A2(
													$elm$core$Basics$composeL,
													$author$project$Pages$Admin$Providers$Top$FormUpdated,
													$author$project$Pages$Admin$Providers$Top$Specialty(index))),
												$author$project$Ui$Form$Select$loading(allSpecialtiesLoading),
												$author$project$Ui$Form$Select$disabled(
												$author$project$Utils$MetaFields$isUneditable(editable))
											]),
										A3($author$project$Pages$Admin$Providers$Top$specialtyOptions, allSpecialties, specialties, specialty))),
									($elm$core$List$length(specialties) > 1) ? A2(
									$author$project$Pages$Admin$Providers$Top$withinTooltipIf,
									$author$project$Utils$MetaFields$explanation(editable),
									A3(
										$author$project$Ui$Button$view,
										{mm: 'Remove specialty'},
										_List_fromArray(
											[
												$author$project$Ui$Button$onClick(
												$author$project$Pages$Admin$Providers$Top$FormUpdated(
													$author$project$Pages$Admin$Providers$Top$RemoveSpecialty(index))),
												$author$project$Ui$Button$disabled(
												$author$project$Utils$MetaFields$isUneditable(editable)),
												$author$project$Ui$Button$icon($author$project$Ui$Icon$minus),
												$author$project$Ui$Button$sm
											]),
										_List_Nil)) : $author$project$Utils$Html$empty,
									isLast ? A2(
									$author$project$Pages$Admin$Providers$Top$withinTooltipIf,
									$author$project$Utils$MetaFields$explanation(editable),
									A3(
										$author$project$Ui$Button$view,
										{mm: 'Add speciality'},
										_List_fromArray(
											[
												$author$project$Ui$Button$onClick(
												$author$project$Pages$Admin$Providers$Top$FormUpdated($author$project$Pages$Admin$Providers$Top$AddSpecialty)),
												$author$project$Ui$Button$disabled(
												$author$project$Utils$MetaFields$isUneditable(editable)),
												$author$project$Ui$Button$icon($author$project$Ui$Icon$add),
												$author$project$Ui$Button$sm
											]),
										_List_Nil)) : $author$project$Utils$Html$empty
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$Providers$Top$MaxPatientAge = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Admin$Providers$Top$MinPatientAge = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Admin$Providers$Top$viewTreatsAge = F3(
	function (minPatientAge, maxPatientAge, editable) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Treats Ages')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween]),
					_List_fromArray(
						[
							A2(
							$author$project$Pages$Admin$Providers$Top$withinTooltipIf,
							$author$project$Utils$MetaFields$explanation(editable),
							$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$number,
										$author$project$Ui$Form$Input$value(
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2($elm$core$Maybe$map, $elm$core$String$fromInt, minPatientAge))),
										$author$project$Ui$Form$Input$onInput(
										A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$MinPatientAge)),
										$author$project$Ui$Form$Input$placeholder('0'),
										$author$project$Ui$Form$Input$disabled(
										$author$project$Utils$MetaFields$isUneditable(editable))
									]))),
							A2(
							$author$project$Ui$Typography$label,
							_List_fromArray(
								[$author$project$Ui$Typography$controlLabel]),
							_List_fromArray(
								[
									$elm$html$Html$text('To')
								])),
							A2(
							$author$project$Pages$Admin$Providers$Top$withinTooltipIf,
							$author$project$Utils$MetaFields$explanation(editable),
							$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$number,
										$author$project$Ui$Form$Input$value(
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2($elm$core$Maybe$map, $elm$core$String$fromInt, maxPatientAge))),
										$author$project$Ui$Form$Input$onInput(
										A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$MaxPatientAge)),
										$author$project$Ui$Form$Input$placeholder('100'),
										$author$project$Ui$Form$Input$disabled(
										$author$project$Utils$MetaFields$isUneditable(editable))
									])))
						]))
				]));
	});
var $author$project$Pages$Admin$Providers$Top$Status = function (a) {
	return {$: 25, a: a};
};
var $author$project$Pages$Admin$Providers$Top$WaitlistEnabled = function (a) {
	return {$: 26, a: a};
};
var $author$project$Pages$Admin$Providers$Top$viewWaitlistSettings = F2(
	function (waitlistEnabled, status) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$inputSpan(9),
							$author$project$Ui$Form$Group$labelSpan(3),
							$author$project$Ui$Form$Group$label('Waitlist')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Checkbox$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Checkbox$value(waitlistEnabled),
									$author$project$Ui$Form$Checkbox$onCheck(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$WaitlistEnabled))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Enable waitlist when panel is full')
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$inputSpan(9),
							$author$project$Ui$Form$Group$labelSpan(3),
							$author$project$Ui$Form$Group$label('Provider Status')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(
									$elm$core$Maybe$Just(status)),
									$author$project$Ui$Form$Select$onChange(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$Status))
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Form$Select$option,
									_List_Nil,
									$elm$core$Maybe$Just('accepting_patients'),
									'Accepting Patients'),
									A3(
									$author$project$Ui$Form$Select$option,
									_List_Nil,
									$elm$core$Maybe$Just('full_waitlisting'),
									'Full - Waitlisting'),
									A3(
									$author$project$Ui$Form$Select$option,
									_List_Nil,
									$elm$core$Maybe$Just('full'),
									'Full - No Waitlist'),
									A3(
									$author$project$Ui$Form$Select$option,
									_List_Nil,
									$elm$core$Maybe$Just('archived'),
									'Archived')
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$Providers$Top$viewModal = F2(
	function (model, state) {
		var ifTrue = F2(
			function (bool, field) {
				return bool ? field : $author$project$Utils$Html$empty;
			});
		var form = state.SD;
		var modalConfig = {
			Tq: $elm$core$Maybe$Nothing,
			aih: 'Provider',
			V8: _Utils_eq(state.uf, $author$project$Api$Data$Loading),
			WG: state.ahP,
			WH: $elm$core$Maybe$Nothing,
			Yd: $author$project$Pages$Admin$Providers$Top$CancelEdit,
			Yf: $author$project$Pages$Admin$Providers$Top$Save(form)
		};
		var fields = $author$project$Utils$Form$fields(form);
		var meta = function (accessor) {
			return A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$MetaFields$alwaysEditable,
				A2($elm$core$Maybe$map, accessor, fields.W4));
		};
		var errorsFor = function (group) {
			return A2($author$project$Utils$Form$validationErrors, group, form);
		};
		var _v0 = function () {
			var _v1 = model.abU;
			if (_v1.$ === 3) {
				var specialties_ = _v1.a;
				return _Utils_Tuple2(false, specialties_);
			} else {
				return _Utils_Tuple2(true, _List_Nil);
			}
		}();
		var specialtiesLoading = _v0.a;
		var specialties = _v0.b;
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A3(
							$author$project$Pages$Admin$Providers$Top$viewName,
							fields.Bq,
							meta($author$project$Api$Provider$Practitioner$Meta$name),
							errorsFor(0)),
							A4(
							$author$project$Pages$Admin$Providers$Top$viewNPI,
							fields.U6,
							fields.X0,
							meta($author$project$Api$Provider$Practitioner$Meta$npi),
							errorsFor(1)),
							A2(
							$author$project$Pages$Admin$Providers$Top$viewBio,
							fields.MK,
							meta($author$project$Api$Provider$Practitioner$Meta$bio)),
							A3(
							$author$project$Pages$Admin$Providers$Top$viewGender,
							fields.SR,
							fields.ST,
							meta($author$project$Api$Provider$Practitioner$Meta$gender)),
							$author$project$Pages$Admin$Providers$Top$viewPhotoLabel(
							meta($author$project$Api$Provider$Practitioner$Meta$photo)),
							A2(
							$author$project$Pages$Admin$Providers$Top$viewPhoto,
							fields.rS,
							errorsFor(2)),
							A2(
							$author$project$Pages$Admin$Providers$Top$viewEmail,
							fields.Rj,
							meta($author$project$Api$Provider$Practitioner$Meta$email)),
							A3(
							$author$project$Pages$Admin$Providers$Top$viewTreatsAge,
							fields.Xb,
							fields.WB,
							meta($author$project$Api$Provider$Practitioner$Meta$treatsAge))
						]),
						A2(
						$elm$core$List$indexedMap,
						A4(
							$author$project$Pages$Admin$Providers$Top$viewSpecialty,
							specialtiesLoading,
							specialties,
							fields.abU,
							meta($author$project$Api$Provider$Practitioner$Meta$specialtyNames)),
						fields.abU),
						A2(
						$elm$core$List$indexedMap,
						A2(
							$author$project$Pages$Admin$Providers$Top$viewEducation,
							fields.Q6,
							meta($author$project$Api$Provider$Practitioner$Meta$education)),
						fields.Q6),
						A2(
						$elm$core$List$indexedMap,
						A3(
							$author$project$Pages$Admin$Providers$Top$viewLocationsDropdown,
							form,
							state.bF,
							meta($author$project$Api$Provider$Practitioner$Meta$locations)),
						fields.Wg),
						_List_fromArray(
						[
							A2(
							ifTrue,
							$author$project$Api$Provider$Practice$One$elationEnabled(model.ZV),
							A2($author$project$Pages$Admin$Providers$Top$viewElationSync, fields.Rb, model.zn)),
							A2($author$project$Pages$Admin$Providers$Top$viewOnlineSignup, fields.Ym, fields.Mh),
							A4(
							$author$project$Pages$Admin$Providers$Top$viewPanelSize,
							fields.Mh,
							fields.YK,
							fields.YJ,
							meta($author$project$Api$Provider$Practitioner$Meta$panelSizeLimit)),
							A2(
							ifTrue,
							A2($author$project$Api$Provider$Practice$One$featureEnabled, 28, model.ZV),
							A2($author$project$Pages$Admin$Providers$Top$viewWaitlistSettings, fields.aen, fields.alH)),
							A2($author$project$Pages$Admin$Providers$Top$viewAcceptsEnrollmentsForm, fields.q5, fields.q6)
						])
					])));
	});
var $author$project$Pages$Admin$Providers$Top$NpiSettingChanged = function (a) {
	return {$: 25, a: a};
};
var $author$project$Api$Provider$PracticeSettings$One$showNpi = function (_v0) {
	var record = _v0;
	return record.abm;
};
var $author$project$Pages$Admin$Providers$Top$viewEnableNpiToggle = function (practiceSettings) {
	var labelHelp = $elm$html$Html$text('A providers\'s NPI will be displayed on invoices and other communications with customers such as patients or employers');
	var _v0 = function () {
		switch (practiceSettings.$) {
			case 2:
				return _Utils_Tuple3(false, true, false);
			case 3:
				var settings = practiceSettings.a;
				return _Utils_Tuple3(
					false,
					false,
					$author$project$Api$Provider$PracticeSettings$One$showNpi(settings));
			default:
				return _Utils_Tuple3(true, true, false);
		}
	}();
	var loading = _v0.a;
	var disabled = _v0.b;
	var on = _v0.c;
	return A2(
		$author$project$Ui$Grid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$column,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Display NPI to customers'),
								$author$project$Ui$Form$Group$labelHelp(labelHelp),
								$author$project$Ui$Form$Group$labelClass(''),
								$author$project$Ui$Form$Group$labelSpan(8),
								$author$project$Ui$Form$Group$inputSpan(4)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$justifyRight]),
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$view(
										_List_fromArray(
											[
												$author$project$Ui$ToggleSwitch$on(on),
												$author$project$Ui$ToggleSwitch$onChange($author$project$Pages$Admin$Providers$Top$NpiSettingChanged),
												$author$project$Ui$ToggleSwitch$disabled(disabled || loading)
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Admin$Providers$Top$AddLocation = function (a) {
	return {$: 20, a: a};
};
var $author$project$Pages$Admin$Providers$Top$Delete = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Pages$Admin$Providers$Top$Edit = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Admin$Providers$Top$acceptedEnrollmentTypes = function (item) {
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				$author$project$Api$Provider$Practitioner$All$acceptsEnrollmentsFromEmployer(item) ? $elm$core$Maybe$Just('Employer') : $elm$core$Maybe$Nothing,
				$author$project$Api$Provider$Practitioner$All$acceptsEnrollmentsFromRetail(item) ? $elm$core$Maybe$Just('Retail') : $elm$core$Maybe$Nothing
			]));
};
var $author$project$Api$Provider$Practice$One$companiesCount = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Oa;
	});
var $author$project$Api$Provider$Practice$Shared$subdomain = function (_v0) {
	var record = _v0;
	return record.acu;
};
var $author$project$Api$Provider$Practice$One$subdomain = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$subdomain(shared);
};
var $author$project$Pages$Admin$Providers$Top$customUrl = F2(
	function (practice, practitioner) {
		return 'https://' + ($author$project$Api$Provider$Practice$One$subdomain(practice) + ('.hint.com/signup?practitioner=' + $author$project$Api$Provider$Practitioner$All$id(practitioner)));
	});
var $author$project$Api$Provider$Practitioner$All$hasRoom = function (practitioner) {
	var _v0 = $author$project$Api$Provider$Practitioner$All$panelSizeLimit(practitioner);
	if (_v0.$ === 1) {
		return true;
	} else {
		var limit = _v0.a;
		return _Utils_cmp(
			$author$project$Api$Provider$Practitioner$All$panelSize(practitioner),
			limit) < 0;
	}
};
var $author$project$Api$Provider$Npi$Shared$firstName = function (_v0) {
	var record = _v0;
	return record.Sv;
};
var $author$project$Api$Provider$Npi$Shared$lastName = function (_v0) {
	var record = _v0;
	return record.VH;
};
var $author$project$Api$Provider$Npi$Shared$organizationName = function (_v0) {
	var record = _v0;
	return record.Ys;
};
var $author$project$Api$Provider$Npi$Shared$type_ = function (_v0) {
	var record = _v0;
	return record.amg;
};
var $author$project$Pages$Admin$Providers$Top$npiName = function (npi) {
	var _v0 = $author$project$Api$Provider$Npi$Shared$type_(npi);
	if ((!_v0.$) && (_v0.a === 'organization')) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			$author$project$Api$Provider$Npi$Shared$organizationName(npi));
	} else {
		var _v1 = _Utils_Tuple2(
			$author$project$Api$Provider$Npi$Shared$firstName(npi),
			$author$project$Api$Provider$Npi$Shared$lastName(npi));
		if ((!_v1.a.$) && (!_v1.b.$)) {
			var firstName = _v1.a.a;
			var lastName = _v1.b.a;
			return firstName + (' ' + lastName);
		} else {
			return '';
		}
	}
};
var $author$project$Api$Provider$Practitioner$All$pendingInvitesCount = function (_v0) {
	var record = _v0.b;
	return record.Zo;
};
var $author$project$Pages$Admin$Providers$Top$viewField_ = F2(
	function (labelOption, content) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					labelOption,
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$labelSpanMd(2),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$inputSpanMd(10)
				]),
			_List_fromArray(
				[
					A2($author$project$Ui$Form$Static$view, _List_Nil, content)
				]));
	});
var $author$project$Pages$Admin$Providers$Top$viewField = function (label) {
	return $author$project$Pages$Admin$Providers$Top$viewField_(
		$author$project$Ui$Form$Group$label(label));
};
var $author$project$Pages$Admin$Providers$Top$viewLocation = function (location) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$phi]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Api$Provider$Location$Shared$name(location)),
				$author$project$Utils$Html$noBreakSpace
			]));
};
var $author$project$Pages$Admin$Providers$Top$viewItem = F3(
	function (model, items, item) {
		var panelSizeLimit = A2(
			$elm$core$Maybe$map,
			$elm$core$String$fromInt,
			$author$project$Api$Provider$Practitioner$All$panelSizeLimit(item));
		var onlineSignupVisibility = $author$project$Api$Provider$Practitioner$All$onlineSignupVisibility(item);
		var locations = A2(
			$author$project$Api$Expandable$withDefault,
			_List_Nil,
			$author$project$Api$Provider$Practitioner$All$locations(item));
		var id = $author$project$Api$Provider$Practitioner$All$id(item);
		var loading = A2($elm$core$Set$member, id, model.eg);
		return A2(
			$author$project$Ui$ListGroup$item,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$mb2]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									$author$project$Ui$Typography$heading(
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Provider$Practitioner$All$name(item))
										])),
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$muted]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Tooltip$view,
											_List_Nil,
											'active patient count',
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$text,
													_List_fromArray(
														[$author$project$Ui$Typography$badge]),
													$elm$core$String$fromInt(
														$author$project$Api$Provider$Practitioner$All$panelSize(item)))
												]))
										])),
									$author$project$Api$Provider$Practitioner$All$isMaster(item) ? $author$project$Components$SyncedIcon$view(
									_List_fromArray(
										[$author$project$Components$SyncedIcon$master])) : $author$project$Utils$Html$empty,
									$author$project$Api$Provider$Practitioner$All$isSynced(item) ? $author$project$Components$SyncedIcon$view(
									_List_fromArray(
										[$author$project$Components$SyncedIcon$synced])) : $author$project$Utils$Html$empty
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Edit provider'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Admin$Providers$Top$Edit(item)),
											$author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit')
										])),
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Delete provider'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$loading(loading),
											$author$project$Ui$Button$onClick(
											A2($author$project$Pages$Admin$Providers$Top$Delete, item, items)),
											$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Delete')
										]))
								]))
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceY2]),
					_List_fromArray(
						[
							A2(
							$author$project$Pages$Admin$Providers$Top$viewField,
							'Online Signup',
							$elm$core$List$concat(
								_List_fromArray(
									[
										_List_fromArray(
										[
											onlineSignupVisibility ? $author$project$Ui$Icon$check(
											_List_fromArray(
												[$author$project$Ui$Icon$success])) : $author$project$Ui$Icon$cross(
											_List_fromArray(
												[$author$project$Ui$Icon$danger]))
										]),
										onlineSignupVisibility ? _List_fromArray(
										[
											$author$project$Api$Provider$Practitioner$All$hasRoom(item) ? A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[$author$project$Ui$Typography$success, $author$project$Ui$Typography$small]),
											' Room available') : A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[$author$project$Ui$Typography$danger, $author$project$Ui$Typography$small]),
											' At capacity')
										]) : _List_Nil,
										$author$project$Api$Provider$Practitioner$All$autoDetermineOnlineSignupVisibilityFromPanelSize(item) ? _List_fromArray(
										[
											onlineSignupVisibility ? A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[$author$project$Ui$Typography$helpText, $author$project$Ui$Typography$small]),
											' · Auto-disabled at ' + A2($elm$core$Maybe$withDefault, 'N/A', panelSizeLimit)) : A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[$author$project$Ui$Typography$helpText, $author$project$Ui$Typography$small]),
											' · Auto-enabled below ' + A2($elm$core$Maybe$withDefault, 'N/A', panelSizeLimit))
										]) : _List_Nil
									]))),
							A2($author$project$Api$Provider$Practice$One$featureEnabled, 28, model.ZV) ? A2(
							$author$project$Pages$Admin$Providers$Top$viewField,
							'Waitlist',
							$author$project$Api$Provider$Practitioner$All$waitlistEnabled(item) ? _List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$helpText, $author$project$Ui$Typography$small]),
									'Enabled — '),
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Admin__Waitlist,
									_List_fromArray(
										[
											$author$project$Ui$Link$routeParams(
											_List_fromArray(
												[
													A2(
													$elm$url$Url$Builder$string,
													'practitioner',
													$author$project$Api$Provider$Practitioner$All$id(item))
												]))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Manage Waitlist')
										])),
									($author$project$Api$Provider$Practitioner$All$pendingInvitesCount(item) > 0) ? A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$helpText, $author$project$Ui$Typography$small]),
									' · ' + ($elm$core$String$fromInt(
										$author$project$Api$Provider$Practitioner$All$pendingInvitesCount(item)) + (' invite' + ((($author$project$Api$Provider$Practitioner$All$pendingInvitesCount(item) === 1) ? '' : 's') + ' pending')))) : $author$project$Utils$Html$empty
								]) : _List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$helpText, $author$project$Ui$Typography$small]),
									'Disabled')
								])) : $author$project$Utils$Html$empty,
							A2(
							$author$project$Pages$Admin$Providers$Top$viewField,
							'Treats ages',
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'0',
										A2(
											$elm$core$Maybe$map,
											$elm$core$String$fromInt,
											$author$project$Api$Provider$Practitioner$All$minPatientAge(item))) + (' to ' + A2(
										$elm$core$Maybe$withDefault,
										'max',
										A2(
											$elm$core$Maybe$map,
											$elm$core$String$fromInt,
											$author$project$Api$Provider$Practitioner$All$maxPatientAge(item)))))
								])),
							function () {
							var _v0 = $author$project$Api$Provider$Practitioner$All$email(item);
							if (!_v0.$) {
								var email = _v0.a;
								return A2(
									$author$project$Pages$Admin$Providers$Top$viewField,
									'Email',
									_List_fromArray(
										[
											$elm$html$Html$text(email)
										]));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}(),
							$elm$core$List$isEmpty(
							$author$project$Api$Provider$Practitioner$All$specialties(item)) ? $author$project$Utils$Html$empty : A2(
							$author$project$Pages$Admin$Providers$Top$viewField,
							'Specialties',
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Formatters$String$toSentence(
										$author$project$Api$Provider$Practitioner$All$specialties(item)))
								])),
							$elm$core$List$isEmpty(
							$author$project$Api$Provider$Practitioner$All$education(item)) ? $author$project$Utils$Html$empty : A2(
							$author$project$Pages$Admin$Providers$Top$viewField,
							'Education',
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Formatters$String$toSentence(
										$author$project$Api$Provider$Practitioner$All$education(item)))
								])),
							A2(
							$author$project$Pages$Admin$Providers$Top$viewField,
							'Locations',
							_Utils_ap(
								$elm$core$List$isEmpty(locations) ? _List_fromArray(
									[
										$elm$html$Html$text('None')
									]) : A2($elm$core$List$map, $author$project$Pages$Admin$Providers$Top$viewLocation, locations),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_Nil,
										$author$project$Api$Provider$Practitioner$All$isSynced(item) ? _List_Nil : _List_fromArray(
											[
												A3(
												$author$project$Ui$Button$view,
												{mm: 'Add location'},
												_List_fromArray(
													[
														$author$project$Ui$Button$link,
														$author$project$Ui$Button$onClick(
														$author$project$Pages$Admin$Providers$Top$AddLocation(item))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Add Location')
													]))
											]))
									]))),
							A2(
							$author$project$Pages$Admin$Providers$Top$viewField,
							'Custom Signup URL',
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$externalHref,
									A2($author$project$Pages$Admin$Providers$Top$customUrl, model.ZV, item),
									_List_fromArray(
										[$author$project$Ui$Link$targetBlank]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2($author$project$Pages$Admin$Providers$Top$customUrl, model.ZV, item))
										]))
								])),
							A2(
							$author$project$Pages$Admin$Providers$Top$viewField,
							'Panel Limit',
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($elm$core$Maybe$withDefault, 'None', panelSizeLimit))
								])),
							function () {
							if ($author$project$Api$Provider$Practice$One$elationEnabled(model.ZV)) {
								var _v1 = $author$project$Api$Provider$Practitioner$All$elationPhysicianId(item);
								if (!_v1.$) {
									return A2(
										$author$project$Pages$Admin$Providers$Top$viewField,
										'Elation',
										_List_fromArray(
											[
												A2($author$project$Ui$Badge$fromString, _List_Nil, 'synced')
											]));
								} else {
									return A2(
										$author$project$Pages$Admin$Providers$Top$viewField,
										'Elation',
										_List_fromArray(
											[
												A2($author$project$Ui$Badge$fromString, _List_Nil, 'inactive')
											]));
								}
							} else {
								return $author$project$Utils$Html$empty;
							}
						}(),
							function () {
							if ($author$project$Api$Provider$Practitioner$All$isProvider(item)) {
								var _v2 = $author$project$Api$Provider$Practitioner$All$npi(item);
								if (!_v2.$) {
									var npi = _v2.a;
									return A2(
										$author$project$Pages$Admin$Providers$Top$viewField,
										'NPI',
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Api$Provider$Npi$Shared$number(npi))
													])),
												A2(
												$elm$html$Html$div,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2(
															$elm$core$Maybe$withDefault,
															'',
															A2(
																$elm$core$Maybe$map,
																$author$project$Formatters$String$humanize,
																$author$project$Api$Provider$Npi$Shared$type_(npi))))
													])),
												A2(
												$elm$html$Html$div,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Pages$Admin$Providers$Top$npiName(npi))
													]))
											]));
								} else {
									return $author$project$Utils$Html$empty;
								}
							} else {
								return $author$project$Utils$Html$empty;
							}
						}(),
							function () {
							if ($author$project$Api$Provider$Practice$One$companiesCount(model.ZV) > 0) {
								var types = $author$project$Pages$Admin$Providers$Top$acceptedEnrollmentTypes(item);
								return A2(
									$author$project$Pages$Admin$Providers$Top$viewField,
									'Accepting Enrollments From',
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$core$List$isEmpty(types) ? 'None' : $author$project$Formatters$String$toSentence(types))
										]));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						]))
				]));
	});
var $author$project$Ui$ListGroup$body = function (contents) {
	return A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('list-group__text')
			]),
		contents);
};
var $author$project$Pages$Admin$Providers$Top$viewFieldSkeleton = function (label) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$List$singleton,
		$author$project$Pages$Admin$Providers$Top$viewField_(
			$author$project$Ui$Form$Group$labelSkeleton(label)));
};
var $author$project$Pages$Admin$Providers$Top$viewItemSkeleton = A2(
	$author$project$Ui$Element$view,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$html$Html$h3,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$spanFromText('Provider Name')
						]))
				])),
			$author$project$Ui$ListGroup$body(
			_List_fromArray(
				[
					A2(
					$author$project$Pages$Admin$Providers$Top$viewFieldSkeleton,
					'Online Signup',
					$author$project$Ui$Skeleton$text(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$spanFromText('  ')
							]))),
					A2(
					$author$project$Pages$Admin$Providers$Top$viewFieldSkeleton,
					'Treats ages',
					$author$project$Ui$Skeleton$text(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$span(3)
							]))),
					A2(
					$author$project$Pages$Admin$Providers$Top$viewFieldSkeleton,
					'Location',
					$author$project$Ui$Skeleton$text(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$span(2)
							]))),
					A2(
					$author$project$Pages$Admin$Providers$Top$viewFieldSkeleton,
					'Custom Signup URL',
					$author$project$Ui$Skeleton$text(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$span(6)
							]))),
					A2(
					$author$project$Pages$Admin$Providers$Top$viewFieldSkeleton,
					'Panel Item',
					$author$project$Ui$Skeleton$text(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$spanFromText('100')
							])))
				]))
		]));
var $author$project$Pages$Admin$Providers$Top$viewSearch = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$mb2, $author$project$Ui$Element$mt2]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(8),
								$author$project$Ui$Grid$spanMd(6)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Pages$Admin$Providers$Top$SearchInputMsg,
										A2($author$project$Ui$SearchInput$view, _List_Nil, model.up))
									]))
							]))
					]))
			]));
};
var $author$project$Ui$ListGroup$ZeroState = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$ListGroup$zeroState = $author$project$Ui$ListGroup$ZeroState;
var $author$project$Pages$Admin$Providers$Top$viewPanelBody = function (model) {
	var _v0 = function () {
		var _v1 = model.j4;
		if (_v1.$ === 3) {
			var items_ = _v1.a;
			return _Utils_Tuple2(false, items_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var items = _v0.b;
	return _List_fromArray(
		[
			$author$project$Pages$Admin$Providers$Top$viewEnableNpiToggle(model.tY),
			$author$project$Pages$Admin$Providers$Top$viewSearch(model),
			loading ? A2(
			$author$project$Ui$ListGroup$view,
			_List_Nil,
			A2(
				$elm$core$List$repeat,
				10,
				A2(
					$author$project$Ui$ListGroup$item,
					_List_Nil,
					$elm$core$List$singleton($author$project$Pages$Admin$Providers$Top$viewItemSkeleton)))) : A2(
			$author$project$Ui$ListGroup$view,
			_List_fromArray(
				[
					$author$project$Ui$ListGroup$zeroState('You have no providers.')
				]),
			A2(
				$elm$core$List$map,
				A2($author$project$Pages$Admin$Providers$Top$viewItem, model, items),
				items))
		]);
};
var $author$project$Pages$Admin$Providers$Top$view = function (model) {
	return {
		fO: function () {
			var loading = function () {
				var _v4 = model.j4;
				if (_v4.$ === 3) {
					return false;
				} else {
					return true;
				}
			}();
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Pages$Admin$Providers$Top$LinkedRecordsMsg,
					$author$project$Components$LinkedRecords$modal(model.oo)),
					function () {
					var _v0 = model.Io;
					if (!_v0.$) {
						var state = _v0.a;
						return A2($author$project$Pages$Admin$Providers$Top$viewModal, model, state);
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					function () {
					var _v1 = model.je;
					if (!_v1.$) {
						var item = _v1.a;
						return A2(
							$author$project$Components$HiConfirm$modal,
							$author$project$Pages$Admin$Providers$Top$HiConfirmClosed(item),
							_List_fromArray(
								[
									$author$project$Components$HiConfirm$verb('delete'),
									$author$project$Components$HiConfirm$noun('provider'),
									$author$project$Components$HiConfirm$detail(
									$author$project$Api$Provider$Practitioner$All$name(item))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					A2(
					$elm$html$Html$map,
					$author$project$Pages$Admin$Providers$Top$DeleteModalMsg,
					$author$project$Components$Admin$Practitioner$DeleteModal$view(model.i8)),
					function () {
					var _v2 = model.bo;
					if (!_v2.$) {
						var _v3 = _v2.a;
						var item = _v3.a;
						var locationInput = _v3.b;
						var request = _v3.c;
						return A4($author$project$Pages$Admin$Providers$Top$viewAddLocationModal, model, item, locationInput, request);
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					A2(
					$author$project$Ui$Panel$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Panel$heading,
							_List_fromArray(
								[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
							_List_fromArray(
								[
									$author$project$Ui$Panel$title(
									_List_fromArray(
										[
											$elm$html$Html$text('Providers')
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$gap2]),
									_List_fromArray(
										[
											model.Ij ? A3(
											$author$project$Ui$HinterOnly$linkRoute,
											$author$project$Spa$Generated$Route$Admin__Providers__Upload,
											_List_fromArray(
												[
													$author$project$Ui$Link$buttonDefault,
													$author$project$Ui$Link$ariaLabel('Upload')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Upload from CSV')
												])) : $author$project$Utils$Html$empty,
											A3(
											$author$project$Ui$Button$view,
											{mm: 'Add new provider'},
											_List_fromArray(
												[
													$author$project$Ui$Button$default,
													$author$project$Ui$Button$onClick($author$project$Pages$Admin$Providers$Top$New),
													$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('New Provider')
												]))
										]))
								])),
							A2(
							$author$project$Ui$Panel$body,
							_List_Nil,
							$author$project$Pages$Admin$Providers$Top$viewPanelBody(model)),
							A2(
							$author$project$Ui$Panel$footer,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Pages$Admin$Providers$Top$PaginationMsg,
									A2(
										$author$project$Api$Pagination$view,
										_List_fromArray(
											[
												$author$project$Ui$Pagination$List$loading(loading)
											]),
										model.ajJ))
								]))
						]))
				]);
		}(),
		ac9: 'Admin | Providers'
	};
};
var $author$project$Pages$Admin$Providers$Top$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Providers$Top$init, aiq: $author$project$Pages$Admin$Providers$Top$load, k8: $author$project$Pages$Admin$Providers$Top$save, alO: $author$project$Pages$Admin$Providers$Top$subscriptions, adT: $author$project$Pages$Admin$Providers$Top$update, amo: $author$project$Pages$Admin$Providers$Top$view});
var $author$project$Api$Upload$Resource$Practitioner = 2;
var $author$project$Pages$Admin$Providers$Upload$UploadFormMsg = $elm$core$Basics$identity;
var $author$project$Pages$Admin$Providers$Upload$init = F4(
	function (_v0, _v1, shared, _v2) {
		var _v3 = A4($author$project$Components$Upload$Form$init, shared.J7, shared.Gv, 2, $elm$core$Maybe$Nothing);
		var uploadForm = _v3.a;
		var uploadFormCmd = _v3.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, SD: uploadForm},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, uploadFormCmd));
	});
var $author$project$Pages$Admin$Providers$Upload$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Providers$Upload$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Providers$Upload$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Upload$Form$subscriptions(model.SD));
};
var $author$project$Pages$Admin$Providers$Upload$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Upload$Form$update, model.Gv, subMsg, model.SD);
		var uploadForm = _v1.a;
		var subCmd = _v1.b;
		var subOutMsgs = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{SD: uploadForm}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsgs);
	});
var $author$project$Pages$Admin$Providers$Upload$viewBody = function (model) {
	return A2(
		$author$project$Ui$Grid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$spanSm(12)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Upload Providers')
											]))
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$elm$core$Basics$identity,
										A2($author$project$Components$Upload$Form$view, model.Gv, model.SD))
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Admin$Providers$Upload$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				A2($author$project$Components$Upload$Form$modal, model.Gv, model.SD)),
				$author$project$Pages$Admin$Providers$Upload$viewBody(model)
			]),
		ac9: 'Admin | Providers'
	};
};
var $author$project$Pages$Admin$Providers$Upload$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Providers$Upload$init, aiq: $author$project$Pages$Admin$Providers$Upload$load, k8: $author$project$Pages$Admin$Providers$Upload$save, alO: $author$project$Pages$Admin$Providers$Upload$subscriptions, adT: $author$project$Pages$Admin$Providers$Upload$update, amo: $author$project$Pages$Admin$Providers$Upload$view});
var $author$project$Pages$Admin$Quickbooks$Top$init = F4(
	function (_v0, _v1, shared, _v2) {
		var query = _v2.DE;
		return _Utils_Tuple2(
			{Gv: shared.Gv, DE: query},
			function () {
				var _v3 = A2($elm$core$Dict$get, 'code', query);
				if (!_v3.$) {
					return A2($author$project$Utils$Route$navigate, query, $author$project$Spa$Generated$Route$Marketplace__Quickbooks__Manage__Settings);
				} else {
					return A2(
						$author$project$Utils$Route$navigate,
						$elm$core$Dict$empty,
						$author$project$Spa$Generated$Route$Marketplace__Slug_String(
							{abG: 'quickbooks'}));
				}
			}());
	});
var $author$project$Pages$Admin$Quickbooks$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Quickbooks$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Quickbooks$Top$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$Quickbooks$Top$update = F2(
	function (msg, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Admin$Quickbooks$Top$view = function (_v0) {
	return {
		fO: _List_fromArray(
			[
				$elm$html$Html$text('Redirecting to marketplace...')
			]),
		ac9: 'Redirecting...'
	};
};
var $author$project$Pages$Admin$Quickbooks$Top$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Quickbooks$Top$init, aiq: $author$project$Pages$Admin$Quickbooks$Top$load, k8: $author$project$Pages$Admin$Quickbooks$Top$save, alO: $author$project$Pages$Admin$Quickbooks$Top$subscriptions, adT: $author$project$Pages$Admin$Quickbooks$Top$update, amo: $author$project$Pages$Admin$Quickbooks$Top$view});
var $author$project$Spa$Page$applicationPrivate = function (page) {
	return {
		ah_: F2(
			function (shared, url) {
				var _v0 = shared.aa4;
				switch (_v0.$) {
					case 3:
						var session = _v0.a;
						return (!A3($author$project$Spa$Page$authorizeUrl, session, shared.ahK, shared.adY)) ? _Utils_Tuple3(
							$author$project$Spa$Page$SessionLoading(url),
							A2(
								$author$project$Utils$Route$navigate,
								$elm$core$Dict$empty,
								A2($author$project$Permission$homeStateFor, session, shared.ahK)),
							_List_Nil) : A2(
							$author$project$Utils$Tuple3$mapFirst,
							$author$project$Spa$Page$SessionLoaded,
							A2(
								$author$project$Utils$Tuple3$fromTuple2,
								_List_Nil,
								A3(page.ah_, session, shared, url)));
					case 1:
						return _Utils_Tuple3(
							$author$project$Spa$Page$SessionLoading(url),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					case 0:
						return _Utils_Tuple3(
							$author$project$Spa$Page$SessionLoading(url),
							$author$project$Ports$Session$authorize(
								{aku: true}),
							_List_Nil);
					default:
						return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			}),
		aiq: F2(
			function (shared, model) {
				var _v1 = _Utils_Tuple2(shared.aa4, model);
				_v1$2:
				while (true) {
					if (!_v1.b.$) {
						switch (_v1.a.$) {
							case 3:
								var _v2 = _v1.a;
								var session = _v2.a;
								var url = _v1.b.a;
								if (!A3($author$project$Spa$Page$authorizeUrl, session, shared.ahK, shared.adY)) {
									return _Utils_Tuple3(
										$author$project$Spa$Page$SessionLoading(url),
										A2(
											$author$project$Utils$Route$navigate,
											$elm$core$Dict$empty,
											A2($author$project$Permission$homeStateFor, session, shared.ahK)),
										_List_Nil);
								} else {
									var _v3 = A3(page.ah_, session, shared, url);
									var pageModel = _v3.a;
									var cmd = _v3.b;
									return _Utils_Tuple3(
										$author$project$Spa$Page$SessionLoaded(pageModel),
										cmd,
										_List_Nil);
								}
							case 2:
								return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
							default:
								break _v1$2;
						}
					} else {
						break _v1$2;
					}
				}
				if (model.$ === 1) {
					var modelWithSession = model.a;
					return A2(
						$author$project$Utils$Tuple3$fromTuple2,
						_List_Nil,
						A2(
							$elm$core$Tuple$mapFirst,
							$author$project$Spa$Page$SessionLoaded,
							A2(
								page.aiq,
								shared,
								_Utils_update(
									modelWithSession,
									{Gv: shared.Gv}))));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			}),
		k8: F2(
			function (model, shared) {
				if (model.$ === 1) {
					var modelWithSession = model.a;
					return A2(page.k8, modelWithSession, shared);
				} else {
					return shared;
				}
			}),
		alO: function (model) {
			if (model.$ === 1) {
				var modelWithSession = model.a;
				return page.alO(modelWithSession);
			} else {
				return $elm$core$Platform$Sub$none;
			}
		},
		adT: F2(
			function (msg, model) {
				if (model.$ === 1) {
					var modelWithSession = model.a;
					return A2(
						$author$project$Utils$Tuple3$mapFirst,
						$author$project$Spa$Page$SessionLoaded,
						A2(page.adT, msg, modelWithSession));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			}),
		amo: function (model) {
			if (model.$ === 1) {
				var modelWithSession = model.a;
				return page.amo(modelWithSession);
			} else {
				return {fO: $author$project$Components$BlankPage$view, ac9: 'Loading...'};
			}
		}
	};
};
var $author$project$Pages$Admin$ScheduledJobs$GotScheduledJobs = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$ScheduledJob$ScheduledJob = $elm$core$Basics$identity;
var $author$project$Api$ScheduledJob$OptionsRecord = function (description) {
	return {Qr: description};
};
var $author$project$Api$ScheduledJob$optionsRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'description',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$ScheduledJob$OptionsRecord));
var $author$project$Api$ScheduledJob$itemDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (b) {
				return A2(
					$elm$json$Json$Decode$map,
					function (c) {
						return _Utils_Tuple3(a, b, c);
					},
					A2($elm$json$Json$Decode$index, 2, $author$project$Api$ScheduledJob$optionsRecordDecoder));
			},
			A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string));
	},
	A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string));
var $author$project$Api$ScheduledJob$scheduledJobDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$ScheduledJob$itemDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$ScheduledJob$scheduledJobsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['scheduled_jobs']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$ScheduledJob$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$ScheduledJob$scheduledJobDecoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$ScheduledJob$scheduledJobsPath));
	});
var $author$project$Pages$Admin$ScheduledJobs$init = F3(
	function (_v0, _v1, _v2) {
		var apiClient = _v1.Gv;
		return _Utils_Tuple2(
			{Gv: apiClient, un: $author$project$Api$Data$Loading, qG: $elm$core$Maybe$Nothing},
			A2($author$project$Api$ScheduledJob$list, apiClient, $author$project$Pages$Admin$ScheduledJobs$GotScheduledJobs));
	});
var $author$project$Pages$Admin$ScheduledJobs$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$ScheduledJobs$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$ScheduledJobs$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Admin$ScheduledJobs$subscriptions = function (_v0) {
	var triggerScheduledJobIndex = _v0.qG;
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Platform$Sub$none,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$ScheduledJobs$HiConfirmClosed),
			triggerScheduledJobIndex));
};
var $author$project$Pages$Admin$ScheduledJobs$GotTriggerResponse = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$ScheduledJob$trigger = F3(
	function (apiClient, scheduledJobId, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'scheduled_job',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'id',
								$elm$json$Json$Encode$int(scheduledJobId))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$ScheduledJob$scheduledJobsPath)));
	});
var $author$project$Pages$Admin$ScheduledJobs$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 2:
				var index = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							qG: $elm$core$Maybe$Just(index)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var index = msg.a;
				var confirmed = msg.b;
				var cmd = confirmed ? A3($author$project$Api$ScheduledJob$trigger, model.Gv, index, $author$project$Pages$Admin$ScheduledJobs$GotTriggerResponse) : $elm$core$Platform$Cmd$none;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qG: $elm$core$Maybe$Nothing}),
					cmd,
					_List_Nil);
			case 0:
				var response = msg.a;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Job Enqueued!')
								]));
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error)),
								$author$project$OutMsg$reportDecodeError(response)));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var dataScheduledJobs = msg.a;
				var newModel = _Utils_update(
					model,
					{un: dataScheduledJobs});
				if (dataScheduledJobs.$ === 2) {
					var error = dataScheduledJobs.a;
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$none,
						A2(
							$elm$core$List$cons,
							A2(
								$author$project$OutMsg$ShowToast,
								1,
								$author$project$Ui$Toast$serverError(error)),
							$author$project$OutMsg$reportDecodeError(dataScheduledJobs)));
				} else {
					return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Admin$ScheduledJobs$TriggerScheduledJob = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$ScheduledJob$cron = function (_v0) {
	var _v1 = _v0;
	var cron_ = _v1.a;
	return cron_;
};
var $author$project$Pages$Admin$ScheduledJobs$cronGuruLink = function (cron) {
	return 'https://crontab.guru/#' + A3($elm$core$String$replace, ' ', '_', cron);
};
var $author$project$Api$ScheduledJob$description = function (_v0) {
	var _v1 = _v0;
	var optionsRecord = _v1.c;
	return optionsRecord.Qr;
};
var $author$project$Api$ScheduledJob$name = function (_v0) {
	var _v1 = _v0;
	var name_ = _v1.b;
	return name_;
};
var $author$project$Pages$Admin$ScheduledJobs$viewScheduledJobs = F2(
	function (index, scheduledJob) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$ScheduledJob$description(scheduledJob))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$ScheduledJob$name(scheduledJob))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$externalHref,
							$author$project$Pages$Admin$ScheduledJobs$cronGuruLink(
								$author$project$Api$ScheduledJob$cron(scheduledJob)),
							_List_fromArray(
								[$author$project$Ui$Link$targetBlank]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$ScheduledJob$cron(scheduledJob))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Enqueue scheduled job now'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick(
									$author$project$Pages$Admin$ScheduledJobs$TriggerScheduledJob(index))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Enqueue Now')
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$ScheduledJobs$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				function () {
				var _v0 = model.qG;
				if (!_v0.$) {
					var index = _v0.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Admin$ScheduledJobs$HiConfirmClosed(index),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$customMessage(
								_List_fromArray(
									[
										$elm$html$Html$text('Are you sure you want to enqueue this job?')
									]))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Scheduled Jobs')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A4(
								$author$project$Ui$Table$view,
								_List_fromArray(
									[
										$author$project$Ui$Table$loading(
										!$author$project$Api$Data$isSuccess(model.un))
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Table$header,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Description')
											])),
										A2(
										$author$project$Ui$Table$header,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Worker Name')
											])),
										A2(
										$author$project$Ui$Table$header,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Cron Schedule')
											])),
										A2(
										$author$project$Ui$Table$header,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('')
											]))
									]),
								function () {
									var _v1 = model.un;
									if (_v1.$ === 3) {
										var scheduledJobs = _v1.a;
										return A2($elm$core$List$indexedMap, $author$project$Pages$Admin$ScheduledJobs$viewScheduledJobs, scheduledJobs);
									} else {
										return _List_Nil;
									}
								}(),
								_List_Nil)
							]))
					]))
			]),
		ac9: 'Admin | Scheduled Jobs'
	};
};
var $author$project$Pages$Admin$ScheduledJobs$page = $author$project$Spa$Page$applicationPrivate(
	{ah_: $author$project$Pages$Admin$ScheduledJobs$init, aiq: $author$project$Pages$Admin$ScheduledJobs$load, k8: $author$project$Pages$Admin$ScheduledJobs$save, alO: $author$project$Pages$Admin$ScheduledJobs$subscriptions, adT: $author$project$Pages$Admin$ScheduledJobs$update, amo: $author$project$Pages$Admin$ScheduledJobs$view});
var $author$project$Api$Provider$Practice$One$membershipCancellationEnabled = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.aiF;
	});
var $author$project$Pages$Admin$SelfService$mapFormFields = function (practice) {
	return {
		aiF: $author$project$Api$Provider$Practice$One$membershipCancellationEnabled(practice)
	};
};
var $author$project$Pages$Admin$SelfService$init = F4(
	function (session, practice, _v0, _v1) {
		var apiClient = _v0.Gv;
		return _Utils_Tuple2(
			{
				Gv: apiClient,
				ahi: $author$project$Pages$Admin$SelfService$mapFormFields(practice),
				ZV: practice,
				aa4: session
			},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$SelfService$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$SelfService$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$SelfService$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$SelfService$MembershipCancellationToggled = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$SelfService$updateField = F2(
	function (field, fields) {
		var enabled = field;
		return _Utils_update(
			fields,
			{aiF: enabled});
	});
var $author$project$Api$Provider$Practice$updateMembershipCancellationEnabled = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practice',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'membership_cancellation_enabled',
								$elm$json$Json$Encode$bool(fields.aiF))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Practice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$practicePath)));
	});
var $author$project$Pages$Admin$SelfService$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var field = msg.a;
			var newFields = A2(
				$author$project$Pages$Admin$SelfService$updateField,
				field,
				$author$project$Pages$Admin$SelfService$mapFormFields(model.ZV));
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{ahi: newFields}),
				A3($author$project$Api$Provider$Practice$updateMembershipCancellationEnabled, model.Gv, newFields, $author$project$Pages$Admin$SelfService$MembershipCancellationToggled),
				_List_Nil);
		} else {
			var response = msg.a;
			if (response.$ === 3) {
				var practice = response.a;
				var newModel = _Utils_update(
					model,
					{
						ahi: $author$project$Pages$Admin$SelfService$mapFormFields(practice),
						ZV: practice
					});
				var message = 'Your practice has been updated';
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$none,
					_List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 3, message),
							$author$project$OutMsg$PracticeUpdated(response)
						]));
			} else {
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			}
		}
	});
var $author$project$Api$Provider$Practice$One$selfServiceRequestAccessUrl = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.aaI;
	});
var $author$project$Pages$Admin$SelfService$selfServiceUrl = function (practice) {
	return $author$project$Api$Provider$Practice$One$selfServiceRequestAccessUrl(practice);
};
var $author$project$Pages$Admin$SelfService$FieldChanged = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$SelfService$MembershipCancellationEnabled = $elm$core$Basics$identity;
var $author$project$Pages$Admin$SelfService$settingToggle = F3(
	function (label, labelHelp, toggleSwitch) {
		return A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$span(9)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label(label),
									$author$project$Ui$Form$Group$labelHelp(labelHelp),
									$author$project$Ui$Form$Group$labelClass(''),
									$author$project$Ui$Form$Group$labelSpan(9),
									$author$project$Ui$Form$Group$inputSpan(3)
								]),
							_List_Nil)
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$span(3),
							$author$project$Ui$Grid$justifyRight
						]),
					_List_fromArray(
						[toggleSwitch]))
				]));
	});
var $author$project$Pages$Admin$SelfService$viewMembershipCancellationSetting = function (fields) {
	var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$on(fields.aiF),
				$author$project$Ui$ToggleSwitch$onChange(
				A2($elm$core$Basics$composeL, $author$project$Pages$Admin$SelfService$FieldChanged, $elm$core$Basics$identity))
			]));
	var labelHelp = A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2($author$project$Ui$Typography$text, _List_Nil, 'Some states require that canceling a subscription must be as easy as signing up. If you offer online sign-up, be sure to check your state laws to stay compliant.')
			]));
	return A3(
		$author$project$Pages$Admin$SelfService$settingToggle,
		'Allow patients to cancel via patient portal',
		A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp),
		toggleSwitch);
};
var $author$project$Pages$Admin$SelfService$view = function (_v0) {
	var practice = _v0.ZV;
	var fields = _v0.ahi;
	return {
		fO: function () {
			var url = $author$project$Pages$Admin$SelfService$selfServiceUrl(practice);
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Panel$heading,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Panel$title(
									_List_fromArray(
										[
											$elm$html$Html$text('Patient Portal')
										]))
								])),
							A2(
							$author$project$Ui$Panel$body,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Add this custom URL to your website to allow patients to manage their invoices, payment methods, plan members, and agreements.')
										])),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Group$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Group$labelSpan(3),
													$author$project$Ui$Form$Group$inputSpan(4),
													$author$project$Ui$Form$Group$label('Patient Portal Self-Service URL')
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Form$Static$view,
													_List_Nil,
													_List_fromArray(
														[
															A3(
															$author$project$Ui$Link$externalHref,
															url,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(url)
																]))
														]))
												]))
										])),
									A2(
									$author$project$Ui$Grid$row,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$span(12)
												]),
											_List_fromArray(
												[
													$author$project$Ui$HorizontalRule$view(
													_List_fromArray(
														[$author$project$Ui$HorizontalRule$thin])),
													$author$project$Utils$Html$noBreakSpace,
													$author$project$Pages$Admin$SelfService$viewMembershipCancellationSetting(fields),
													$author$project$Utils$Html$noBreakSpace
												]))
										]))
								]))
						]))
				]);
		}(),
		ac9: 'Admin | Self-Service'
	};
};
var $author$project$Pages$Admin$SelfService$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$SelfService$init, aiq: $author$project$Pages$Admin$SelfService$load, k8: $author$project$Pages$Admin$SelfService$save, alO: $author$project$Pages$Admin$SelfService$subscriptions, adT: $author$project$Pages$Admin$SelfService$update, amo: $author$project$Pages$Admin$SelfService$view});
var $author$project$Pages$Admin$Signup$GotCurrentDate = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Admin$Signup$InitPractice = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$Signup$GotDefaultSignupPage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$SignupPage$All$SignupPage = $elm$core$Basics$identity;
var $author$project$Api$Provider$SignupPage$Shared$SignupPage = $elm$core$Basics$identity;
var $author$project$Api$Provider$SignupPage$Shared$Record = function (id) {
	return function (slug) {
		return function (_default) {
			return function (active) {
				return function (type_) {
					return function (url) {
						return function (baseUrl) {
							return function (isDestroyable) {
								return function (acceptsNewSignup) {
									return function (limitAvailablePractitioners) {
										return function (limitAvailableLocations) {
											return function (limitAvailableLocationGroups) {
												return function (useCustomSettings) {
													return function (redirectsPostSignup) {
														return function (postSignupRedirectUrl) {
															return function (postSignupMessage) {
																return function (showPostSignupFooterButton) {
																	return function (postSignupButtonLabel) {
																		return function (chargeItem) {
																			return function (signupPagePlans) {
																				return function (addons) {
																					return {KD: acceptsNewSignup, KN: active, K1: addons, Mz: baseUrl, mL: chargeItem, PW: _default, ahP: id, UN: isDestroyable, V_: limitAvailableLocationGroups, V$: limitAvailableLocations, V0: limitAvailablePractitioners, ZR: postSignupButtonLabel, ZS: postSignupMessage, ZT: postSignupRedirectUrl, $l: redirectsPostSignup, abp: showPostSignupFooterButton, abz: signupPagePlans, abG: slug, amg: type_, adY: url, adZ: useCustomSettings};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Addon$Shared$Addon = $elm$core$Basics$identity;
var $author$project$Api$Provider$Addon$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Addon$Min$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$SignupPagePlan$Shared$SignupPagePlan = $elm$core$Basics$identity;
var $author$project$Api$Provider$SignupPagePlan$Shared$Record = F2(
	function (id, plan) {
		return {ahP: id, Jb: plan};
	});
var $author$project$Api$Provider$SignupPagePlan$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'plan',
	$author$project$Api$Provider$Plan$Min$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$SignupPagePlan$Shared$Record)));
var $author$project$Api$Provider$SignupPagePlan$Shared$sharedDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$SignupPagePlan$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$SignupPage$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'addons',
	$elm$json$Json$Decode$list($author$project$Api$Provider$Addon$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'signup_page_plans',
		$elm$json$Json$Decode$list($author$project$Api$Provider$SignupPagePlan$Shared$sharedDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'charge_item',
			$elm$json$Json$Decode$nullable($author$project$Api$Provider$ChargeItem$Min$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'post_signup_button_label',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'show_post_signup_footer_button',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'post_signup_message',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'post_signup_redirect_url',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'redirects_post_signup',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'use_custom_settings',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'limit_available_location_groups',
										$elm$json$Json$Decode$bool,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'limit_available_locations',
											$elm$json$Json$Decode$bool,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'limit_available_practitioners',
												$elm$json$Json$Decode$bool,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'accepts_new_signup',
													$elm$json$Json$Decode$bool,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'is_destroyable',
														$elm$json$Json$Decode$bool,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'base_url',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'url',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'type',
																	$elm$json$Json$Decode$string,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'active',
																		$elm$json$Json$Decode$bool,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'default',
																			$elm$json$Json$Decode$bool,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'slug',
																				$elm$json$Json$Decode$string,
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'id',
																					$elm$json$Json$Decode$string,
																					$elm$json$Json$Decode$succeed($author$project$Api$Provider$SignupPage$Shared$Record))))))))))))))))))))));
var $author$project$Api$Provider$SignupPage$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$SignupPage$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$SignupPage$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$SignupPage$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$SignupPage$signupPagesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['signup_pages']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$SignupPage$getDefault = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$SignupPage$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2($author$project$Api$Param$bool, 'default', true)
					]),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$SignupPage$signupPagesPath)));
	});
var $author$project$Pages$Admin$Signup$getDefaultSignupPage = function (model) {
	return A2($author$project$Api$Provider$SignupPage$getDefault, model.Gv, $author$project$Pages$Admin$Signup$GotDefaultSignupPage);
};
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$Model = $elm$core$Basics$identity;
var $author$project$Api$Provider$Practice$One$postSignupButtonLabel = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.ZR;
	});
var $author$project$Api$Provider$Practice$One$postSignupMessage = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.ZS;
	});
var $author$project$Api$Provider$Practice$One$postSignupRedirectUrl = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.ZT;
	});
var $author$project$Api$Provider$Practice$One$redirectsPostSignup = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.$l;
	});
var $author$project$Api$Provider$Practice$One$showPostSignupFooterButton = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.abp;
	});
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$formFieldsInit = function (practice) {
	return {
		ZR: A2(
			$elm$core$Maybe$withDefault,
			'',
			$author$project$Api$Provider$Practice$One$postSignupButtonLabel(practice)),
		ZS: A2(
			$elm$core$Maybe$withDefault,
			'',
			$author$project$Api$Provider$Practice$One$postSignupMessage(practice)),
		ZT: A2(
			$elm$core$Maybe$withDefault,
			'',
			$author$project$Api$Provider$Practice$One$postSignupRedirectUrl(practice)),
		$l: $author$project$Api$Provider$Practice$One$redirectsPostSignup(practice),
		abp: $author$project$Api$Provider$Practice$One$showPostSignupFooterButton(practice)
	};
};
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$init = function (practice) {
	return {
		jm: $elm$core$Set$empty,
		agX: _List_Nil,
		SD: $author$project$Utils$Form$init(
			$author$project$Components$Admin$GlobalSignupSettings$Confirmation$formFieldsInit(practice)),
		qM: $jinjor$elm_debounce$Debounce$init
	};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$Model = $elm$core$Basics$identity;
var $author$project$Api$Provider$Practice$One$allowPayerOnBehalfOnSignup = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Ly;
	});
var $author$project$Api$Provider$Practice$One$allowedZipCodesOnSignup = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.LC;
	});
var $author$project$Api$Provider$Practice$One$autoConfirmSignup = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Mg;
	});
var $author$project$Api$Provider$Practice$One$collectAddressOnSignup = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.NR;
	});
var $author$project$Api$Provider$Practice$One$collectBillingAddressOnSignup = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.NS;
	});
var $author$project$Api$Provider$Practice$One$collectBrokerOnSignup = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.NT;
	});
var $author$project$Api$Provider$Practice$One$collectInsuranceOnSignup = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.NW;
	});
var $author$project$Api$Provider$Practice$One$collectLeadSourceOnSignup = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.NX;
	});
var $author$project$Api$Provider$Practice$One$mergeDuplicatePatientsOnSignup = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.W2;
	});
var $author$project$Api$Provider$Practice$One$minEnrollAge = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Xa;
	});
var $author$project$Api$Provider$Practice$One$prepayFirstPaymentOnSignup = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $._c;
	});
var $author$project$Api$Provider$Practice$One$restrictZipCodesOnSignup = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.$S;
	});
var $author$project$Api$Provider$Practice$One$startDateSelectableOnSignup = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.ab8;
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$formFieldsInit = function (practice) {
	var minEnrollAge = $author$project$Api$Provider$Practice$One$minEnrollAge(practice);
	return {
		Ly: $author$project$Api$Provider$Practice$One$allowPayerOnBehalfOnSignup(practice),
		ri: $author$project$Api$Provider$Practice$One$allowedZipCodesOnSignup(practice),
		mo: $author$project$Api$Provider$Practice$One$autoConfirmSignup(practice),
		NR: $author$project$Api$Provider$Practice$One$collectAddressOnSignup(practice),
		NS: $author$project$Api$Provider$Practice$One$collectBillingAddressOnSignup(practice),
		NT: $author$project$Api$Provider$Practice$One$collectBrokerOnSignup(practice),
		NW: $author$project$Api$Provider$Practice$One$collectInsuranceOnSignup(practice),
		NX: $author$project$Api$Provider$Practice$One$collectLeadSourceOnSignup(practice),
		afO: $author$project$Api$Provider$Practice$One$collectLocationOnSignup(practice),
		N_: $author$project$Api$Provider$Practice$One$collectPractitionerOnSignup(practice),
		N$: $author$project$Api$Provider$Practice$One$collectSSNOnSignup(practice),
		VQ: $author$project$Api$Provider$Practice$One$defaultMembershipStartDate(practice),
		W2: $author$project$Api$Provider$Practice$One$mergeDuplicatePatientsOnSignup(practice),
		Xa: minEnrollAge,
		oG: $author$project$Utils$Maybe$toBool(minEnrollAge),
		_c: $author$project$Api$Provider$Practice$One$prepayFirstPaymentOnSignup(practice),
		hu: $author$project$Api$Provider$Practice$One$restrictZipCodesOnSignup(practice),
		ab8: $author$project$Api$Provider$Practice$One$startDateSelectableOnSignup(practice)
	};
};
var $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$Closed = {$: 0};
var $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$init = $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$Closed;
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$Model = $elm$core$Basics$identity;
var $author$project$Api$Provider$Practice$One$acceptsAch = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.KA;
	});
var $author$project$Api$Provider$Practice$Shared$acceptsAmex = function (_v0) {
	var record = _v0;
	return record.KB;
};
var $author$project$Api$Provider$Practice$One$acceptsAmex = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$acceptsAmex(shared);
};
var $author$project$Api$Provider$Practice$Shared$acceptsCards = function (_v0) {
	var record = _v0;
	return record.KC;
};
var $author$project$Api$Provider$Practice$One$acceptsCards = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$acceptsCards(shared);
};
var $author$project$Api$Provider$Practice$One$collectPaymentSourceOnSignup = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.NZ;
	});
var $author$project$Api$Provider$Practice$Shared$encourageAch = function (_v0) {
	var record = _v0;
	return record.Rq;
};
var $author$project$Api$Provider$Practice$One$encourageAch = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$encourageAch(shared);
};
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$formFieldsInit = function (practice) {
	return {
		KA: $author$project$Api$Provider$Practice$One$acceptsAch(practice),
		KB: $author$project$Api$Provider$Practice$One$acceptsAmex(practice),
		KC: $author$project$Api$Provider$Practice$One$acceptsCards(practice),
		NZ: $elm$core$Maybe$Just(
			$author$project$Api$Provider$Practice$One$collectPaymentSourceOnSignup(practice)),
		Rq: $author$project$Api$Provider$Practice$One$encourageAch(practice)
	};
};
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$init = function (practice) {
	var form = $author$project$Utils$Form$init(
		$author$project$Components$Admin$GlobalSignupSettings$PaymentSource$formFieldsInit(practice));
	var fields = $author$project$Utils$Form$fields(form);
	var model = {
		SD: form,
		ZV: practice,
		Jl: $author$project$Api$Provider$Practice$One$prepayFirstPaymentOnSignup(practice),
		uz: !fields.KB
	};
	return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
};
var $author$project$Ui$TagsInput$init = function (id) {
	return {ahP: id, sD: false, $7: '', uD: false};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$init = function (practice) {
	var _v0 = $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$init(practice);
	var paymentSourceComponentModel = _v0.a;
	return {
		mK: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$init,
		jm: $elm$core$Set$empty,
		agX: _List_Nil,
		SD: $author$project$Utils$Form$init(
			$author$project$Components$Admin$GlobalSignupSettings$Settings$formFieldsInit(practice)),
		tM: paymentSourceComponentModel,
		ZV: practice,
		u2: $author$project$Ui$TagsInput$init('restrict-by-zip-codes'),
		qM: $jinjor$elm_debounce$Debounce$init
	};
};
var $author$project$Api$Provider$SignupSettings$Min$customJavascriptText = function (_v0) {
	var record = _v0;
	return record.Po;
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$Model = $elm$core$Basics$identity;
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$formFieldsInit = function (fields) {
	return {
		rX: fields.rX,
		aby: A2($elm$core$Maybe$withDefault, '', fields.aby),
		acu: fields.acu
	};
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$init = function (fields) {
	return {
		jm: $elm$core$Set$empty,
		agX: _List_Nil,
		SD: $author$project$Utils$Form$init(
			$author$project$Components$Admin$GlobalSignupSettings$SignupPage$formFieldsInit(fields)),
		uY: $author$project$Api$Data$NotAsked,
		qM: $jinjor$elm_debounce$Debounce$init
	};
};
var $author$project$Api$Provider$Practice$One$signupPageNotFoundRedirectUrl = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.aby;
	});
var $author$project$Api$Provider$Practice$One$signupSettings = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.abA;
	});
var $author$project$Api$Expandable$toMaybe = function (expandable_) {
	if (!expandable_.$) {
		var a = expandable_.a;
		return $elm$core$Maybe$Just(a);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$Admin$Signup$initSignupPageComponent = function (practice) {
	return $author$project$Components$Admin$GlobalSignupSettings$SignupPage$init(
		{
			rX: A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					$author$project$Api$Provider$SignupSettings$Min$customJavascriptText,
					$author$project$Api$Expandable$toMaybe(
						$author$project$Api$Provider$Practice$One$signupSettings(practice)))),
			aby: $author$project$Api$Provider$Practice$One$signupPageNotFoundRedirectUrl(practice),
			acu: $author$project$Api$Provider$Practice$One$subdomain(practice)
		});
};
var $author$project$Api$Provider$Practice$SignupSettings = 0;
var $author$project$Pages$Admin$Signup$practiceOptionals = function (optionals) {
	return _Utils_update(
		optionals,
		{
			HE: _List_fromArray(
				[0])
		});
};
var $author$project$Pages$Admin$Signup$init = F4(
	function (session, practice, shared, _v0) {
		var settingsComponentModel = $author$project$Components$Admin$GlobalSignupSettings$Settings$init(practice);
		var confirmationComponentModel = $author$project$Components$Admin$GlobalSignupSettings$Confirmation$init(practice);
		var model = {
			Gv: shared.Gv,
			iP: confirmationComponentModel,
			dd: $elm$core$Maybe$Nothing,
			Qb: $elm$core$Maybe$Nothing,
			Ij: $author$project$Shared$isHintAdmin(shared),
			ZV: $author$project$Api$Data$Loading,
			aa4: session,
			lj: settingsComponentModel,
			hJ: $author$project$Pages$Admin$Signup$initSignupPageComponent(practice)
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3($author$project$Api$Provider$Practice$retrieve, shared.Gv, $author$project$Pages$Admin$Signup$practiceOptionals, $author$project$Pages$Admin$Signup$InitPractice),
						$author$project$Pages$Admin$Signup$getDefaultSignupPage(model),
						A2($elm$core$Task$perform, $author$project$Pages$Admin$Signup$GotCurrentDate, $justinmimbs$date$Date$today)
					])));
	});
var $author$project$Pages$Admin$Signup$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Signup$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Signup$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$Signup$ConfirmationComponentMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$Signup$SettingsComponentMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Admin$Signup$SignupPageComponentMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$OnChange = $elm$core$Basics$identity;
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$SaveChanges = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$applyUpdate = function (field) {
	return A2(
		$elm$core$Task$perform,
		$author$project$Components$Admin$GlobalSignupSettings$Confirmation$SaveChanges,
		$elm$core$Task$succeed(field));
};
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$clearErrors = function (model) {
	return _Utils_update(
		model,
		{agX: _List_Nil});
};
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$encodeRedirectsPostSignup = function (bool) {
	return _Utils_Tuple2(
		'redirects_post_signup',
		$elm$json$Json$Encode$bool(bool));
};
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$encodeField = F2(
	function (model, field) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'post_signup_button_label',
							$elm$json$Json$Encode$string(string))
						]));
			case 1:
				var string = field.a;
				var _v1 = $author$project$Utils$Form$fields(model.SD);
				var redirectsPostSignup = _v1.$l;
				return $elm$json$Json$Encode$object(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'post_signup_redirect_url',
							$elm$json$Json$Encode$string(string)),
						redirectsPostSignup ? _List_fromArray(
							[
								$author$project$Components$Admin$GlobalSignupSettings$Confirmation$encodeRedirectsPostSignup(redirectsPostSignup)
							]) : _List_Nil));
			case 2:
				var bool = field.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'show_post_signup_footer_button',
							$elm$json$Json$Encode$bool(bool))
						]));
			case 3:
				var bool = field.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							$author$project$Components$Admin$GlobalSignupSettings$Confirmation$encodeRedirectsPostSignup(bool)
						]));
			default:
				var string = field.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'post_signup_message',
							$elm$json$Json$Encode$string(string))
						]));
		}
	});
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$CustomButtonUrlValidation = 0;
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$PostSignupButtonLabelValidation = 1;
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$PostSignupMessageValidation = 4;
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$RedirectsPostSignupValidation = 3;
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$ShowPostSignupFooterButtonValidation = 2;
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$fieldValidationGroup = function (field) {
	switch (field.$) {
		case 1:
			return 0;
		case 0:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		default:
			return 4;
	}
};
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$errorsForGroup = F2(
	function (validation, errors) {
		return A2(
			$elm$core$List$filterMap,
			function (_v0) {
				var errValidation = _v0.a;
				var errMessage = _v0.b;
				return _Utils_eq(validation, errValidation) ? $elm$core$Maybe$Just(errMessage) : $elm$core$Maybe$Nothing;
			},
			errors);
	});
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$groupHasErrors = F2(
	function (validationGroup, errors) {
		return !$elm$core$List$isEmpty(
			A2($author$project$Components$Admin$GlobalSignupSettings$Confirmation$errorsForGroup, validationGroup, errors));
	});
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$fieldHasErrors = F2(
	function (model, field) {
		var errored = A2(
			$author$project$Components$Admin$GlobalSignupSettings$Confirmation$groupHasErrors,
			$author$project$Components$Admin$GlobalSignupSettings$Confirmation$fieldValidationGroup(field),
			model.agX);
		if (field.$ === 3) {
			var redirectsPostSignup = field.a;
			return redirectsPostSignup ? (errored || A2($author$project$Components$Admin$GlobalSignupSettings$Confirmation$groupHasErrors, 0, model.agX)) : errored;
		} else {
			return errored;
		}
	});
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$fieldName = function (field) {
	switch (field.$) {
		case 0:
			return 'postSignupButtonLabel';
		case 1:
			return 'customButtonUrl';
		case 2:
			return 'showPostSignupFooterButton';
		case 3:
			return 'redirectsPostSignup';
		default:
			return 'postSignupMessage';
	}
};
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$isFieldDirty = F2(
	function (field, model) {
		return A2(
			$elm$core$Set$member,
			$author$project$Components$Admin$GlobalSignupSettings$Confirmation$fieldName(field),
			model.jm);
	});
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$debounceUpdateForField = function (field) {
	switch (field.$) {
		case 0:
			return true;
		case 1:
			return true;
		case 2:
			return true;
		case 3:
			return true;
		default:
			return true;
	}
};
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$UpdateDebounceMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$updateDebounceConfig = {
	alK: $jinjor$elm_debounce$Debounce$later(1000),
	ame: $author$project$Components$Admin$GlobalSignupSettings$Confirmation$UpdateDebounceMsg
};
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$processUpdate = F2(
	function (field, model) {
		if ($author$project$Components$Admin$GlobalSignupSettings$Confirmation$debounceUpdateForField(field)) {
			var _v0 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Components$Admin$GlobalSignupSettings$Confirmation$updateDebounceConfig, field, model.qM);
			var debounceModel = _v0.a;
			var debounceCmd = _v0.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{qM: debounceModel}),
				debounceCmd);
		} else {
			return _Utils_Tuple2(
				model,
				$author$project$Components$Admin$GlobalSignupSettings$Confirmation$applyUpdate(field));
		}
	});
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$setFieldDirty = F2(
	function (field, model) {
		return _Utils_update(
			model,
			{
				jm: A2(
					$elm$core$Set$insert,
					$author$project$Components$Admin$GlobalSignupSettings$Confirmation$fieldName(field),
					model.jm)
			});
	});
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$setFieldPristine = F2(
	function (field, model) {
		return _Utils_update(
			model,
			{
				jm: A2(
					$elm$core$Set$remove,
					$author$project$Components$Admin$GlobalSignupSettings$Confirmation$fieldName(field),
					model.jm)
			});
	});
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{ZR: string});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{ZT: string});
			case 2:
				var bool = field.a;
				return _Utils_update(
					fields,
					{abp: bool});
			case 3:
				var bool = field.a;
				return _Utils_update(
					fields,
					{$l: bool});
			default:
				var string = field.a;
				return _Utils_update(
					fields,
					{ZS: string});
		}
	});
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$updateField = F2(
	function (field, model) {
		return _Utils_update(
			model,
			{
				SD: A3($author$project$Utils$Form$update, $author$project$Components$Admin$GlobalSignupSettings$Confirmation$formFieldsUpdate, field, model.SD)
			});
	});
var $author$project$Utils$Maybe$isNothing = function (maybe) {
	if (!maybe.$) {
		return false;
	} else {
		return true;
	}
};
var $author$project$Utils$Validate$isInvalidUrlStricter = function (url) {
	return $elm$core$String$isEmpty(url) ? false : $author$project$Utils$Maybe$isNothing(
		$elm$url$Url$fromString(url));
};
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$validateCustomButtonUrl = function (model) {
	var _v0 = $author$project$Utils$Form$fields(model.SD);
	var postSignupRedirectUrl = _v0.ZT;
	var redirectsPostSignup = _v0.$l;
	return (redirectsPostSignup && $author$project$Utils$String$isBlank(postSignupRedirectUrl)) ? _List_fromArray(
		[
			_Utils_Tuple2(0, 'cannot be blank')
		]) : ($author$project$Utils$Validate$isInvalidUrlStricter(postSignupRedirectUrl) ? _List_fromArray(
		[
			_Utils_Tuple2(0, 'is not a valid URL')
		]) : _List_Nil);
};
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$validator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$GlobalSignupSettings$Confirmation$validateCustomButtonUrl)
		]));
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$validate = function (model) {
	return $author$project$Utils$Result$merge(
		A2(
			$elm$core$Result$mapError,
			function (errors) {
				return _Utils_update(
					model,
					{agX: errors});
			},
			A2(
				$elm$core$Result$map,
				$rtfeldman$elm_validate$Validate$fromValid,
				A2(
					$rtfeldman$elm_validate$Validate$validate,
					$author$project$Components$Admin$GlobalSignupSettings$Confirmation$validator,
					$author$project$Components$Admin$GlobalSignupSettings$Confirmation$clearErrors(model)))));
};
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var modelWithForm = A2(
					$author$project$Components$Admin$GlobalSignupSettings$Confirmation$setFieldDirty,
					field,
					A2($author$project$Components$Admin$GlobalSignupSettings$Confirmation$updateField, field, model));
				var _v2 = A2($author$project$Components$Admin$GlobalSignupSettings$Confirmation$processUpdate, field, modelWithForm);
				var newModel = _v2.a;
				var updateCmd = _v2.b;
				return _Utils_Tuple3(newModel, updateCmd, $elm$core$Maybe$Nothing);
			case 1:
				var debounceMsg = msg.a;
				var _v3 = A4(
					$jinjor$elm_debounce$Debounce$update,
					$author$project$Components$Admin$GlobalSignupSettings$Confirmation$updateDebounceConfig,
					$jinjor$elm_debounce$Debounce$takeLast($author$project$Components$Admin$GlobalSignupSettings$Confirmation$applyUpdate),
					debounceMsg,
					model.qM);
				var newDebouncer = _v3.a;
				var debounceCmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qM: newDebouncer}),
					debounceCmd,
					$elm$core$Maybe$Nothing);
			default:
				var field = msg.a;
				var validatedModel = $author$project$Components$Admin$GlobalSignupSettings$Confirmation$validate(model);
				if (A2($author$project$Components$Admin$GlobalSignupSettings$Confirmation$isFieldDirty, field, model) && (!A2($author$project$Components$Admin$GlobalSignupSettings$Confirmation$fieldHasErrors, validatedModel, field))) {
					var pristineModel = $author$project$Components$Admin$GlobalSignupSettings$Confirmation$clearErrors(
						A2($author$project$Components$Admin$GlobalSignupSettings$Confirmation$setFieldPristine, field, model));
					return _Utils_Tuple3(
						pristineModel,
						$elm$core$Platform$Cmd$none,
						$elm$core$Maybe$Just(
							A2($author$project$Components$Admin$GlobalSignupSettings$Confirmation$encodeField, pristineModel, field)));
				} else {
					return _Utils_Tuple3(validatedModel, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
				}
		}
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$AllowedZipCodes = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$FormFieldUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$LaunchDate = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$MinEnrollAge = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$OnChange = $elm$core$Basics$identity;
var $author$project$Components$Admin$GlobalSignupSettings$Settings$OpenChangeDateModalMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$PaymentSourceComponentMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$SaveChanges = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$TagsInputMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$ValidateMinEnrollAge = {$: 3};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$applyUpdate = function (field) {
	_v0$2:
	while (true) {
		switch (field.$) {
			case 16:
				return A2(
					$elm$core$Task$perform,
					$elm$core$Basics$identity,
					$elm$core$Task$succeed($author$project$Components$Admin$GlobalSignupSettings$Settings$ValidateMinEnrollAge));
			case 15:
				if (field.a) {
					return $elm$core$Platform$Cmd$none;
				} else {
					break _v0$2;
				}
			default:
				break _v0$2;
		}
	}
	return A2(
		$elm$core$Task$perform,
		$author$project$Components$Admin$GlobalSignupSettings$Settings$SaveChanges,
		$elm$core$Task$succeed(field));
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$collectAddressValue = F2(
	function (forceRequire, collectAddressOption) {
		return forceRequire ? 2 : collectAddressOption;
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$encodeCollectAddress = function (collectOption) {
	return _Utils_Tuple2(
		'collect_address_on_signup',
		$author$project$Api$CollectOnSignup$encoder(collectOption));
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject = F2(
	function (key, value) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(key, value)
				]));
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$encodeField = F2(
	function (model, field) {
		switch (field.$) {
			case 0:
				var bool = field.a;
				return (!bool) ? $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'auto_confirm_signups',
							$elm$json$Json$Encode$bool(bool)),
							_Utils_Tuple2(
							'prepay_first_payment_on_signup',
							$elm$json$Json$Encode$bool(false))
						])) : A2(
					$author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject,
					'auto_confirm_signups',
					$elm$json$Json$Encode$bool(bool));
			case 1:
				var bool = field.a;
				return bool ? $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'prepay_first_payment_on_signup',
							$elm$json$Json$Encode$bool(bool)),
							_Utils_Tuple2(
							'collect_payment_source_on_signup',
							$author$project$Api$CollectOnSignup$encoder(2))
						])) : A2(
					$author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject,
					'prepay_first_payment_on_signup',
					$elm$json$Json$Encode$bool(bool));
			case 2:
				var bool = field.a;
				return A2(
					$author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject,
					'merge_duplicate_patients_on_online_signup',
					$elm$json$Json$Encode$bool(bool));
			case 3:
				var restrict = field.a;
				var _v1 = $author$project$Utils$Form$fields(model.SD);
				var collectAddressOnSignup = _v1.NR;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'restrict_zip_codes_on_signup',
							$elm$json$Json$Encode$bool(restrict)),
							$author$project$Components$Admin$GlobalSignupSettings$Settings$encodeCollectAddress(
							A2($author$project$Components$Admin$GlobalSignupSettings$Settings$collectAddressValue, restrict, collectAddressOnSignup))
						]));
			case 4:
				var zipCodes = field.a;
				return A2(
					$author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject,
					'allowed_zip_codes_on_signup',
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, zipCodes));
			case 5:
				var collectOption = field.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							$author$project$Components$Admin$GlobalSignupSettings$Settings$encodeCollectAddress(collectOption)
						]));
			case 6:
				var collectOption = field.a;
				return A2(
					$author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject,
					'collect_billing_address_on_signup',
					$author$project$Api$CollectOnSignup$encoder(collectOption));
			case 7:
				var collectOption = field.a;
				return A2(
					$author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject,
					'collect_practitioner_on_signup',
					$author$project$Api$CollectOnSignup$encoder(collectOption));
			case 8:
				var collectOption = field.a;
				return A2(
					$author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject,
					'collect_location_on_signup',
					$author$project$Api$CollectOnSignup$encoder(collectOption));
			case 9:
				var collectOption = field.a;
				return A2(
					$author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject,
					'collect_ssn_on_signup',
					$author$project$Api$CollectOnSignup$encoder(collectOption));
			case 10:
				var collectOption = field.a;
				return A2(
					$author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject,
					'collect_lead_source_on_signup',
					$author$project$Api$CollectOnSignup$encoder(collectOption));
			case 11:
				var collectOption = field.a;
				return A2(
					$author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject,
					'collect_broker_on_signup',
					$author$project$Api$CollectOnSignup$encoder(collectOption));
			case 12:
				var collectOption = field.a;
				return A2(
					$author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject,
					'allows_payer_on_behalf_on_signup',
					$author$project$Api$CollectOnSignup$encoder(collectOption));
			case 13:
				var bool = field.a;
				return A2(
					$author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject,
					'start_date_selectable_on_signup',
					$elm$json$Json$Encode$bool(bool));
			case 14:
				var collectOption = field.a;
				return A2(
					$author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject,
					'collect_insurance_on_signup',
					$author$project$Api$CollectOnSignup$encoder(collectOption));
			case 15:
				return $elm$json$Json$Encode$null;
			case 16:
				var maybeAge = field.a;
				return A2(
					$author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject,
					'min_enroll_age',
					A2(
						$author$project$Utils$Encode$nullable,
						$elm$json$Json$Encode$int,
						$elm$core$String$toInt(maybeAge)));
			default:
				var date = field.a;
				return A2(
					$author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject,
					'launch_date',
					$author$project$Utils$Date$encode(date));
		}
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$enrollAgeToString = function (minEnrollAge) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Maybe$map, $elm$core$String$fromInt, minEnrollAge));
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$MinEnrollAgeValidation = 0;
var $author$project$Components$Admin$GlobalSignupSettings$Settings$NoValidation = 1;
var $author$project$Components$Admin$GlobalSignupSettings$Settings$fieldValidationGroup = function (field) {
	if (field.$ === 16) {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$errorsForGroup = F2(
	function (validation, errors) {
		return A2(
			$elm$core$List$filterMap,
			function (_v0) {
				var errValidation = _v0.a;
				var errMessage = _v0.b;
				return _Utils_eq(validation, errValidation) ? $elm$core$Maybe$Just(errMessage) : $elm$core$Maybe$Nothing;
			},
			errors);
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$groupHasErrors = F2(
	function (validationGroup, errors) {
		return !$elm$core$List$isEmpty(
			A2($author$project$Components$Admin$GlobalSignupSettings$Settings$errorsForGroup, validationGroup, errors));
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$fieldHasErrors = F2(
	function (field, errors) {
		return A2(
			$author$project$Components$Admin$GlobalSignupSettings$Settings$groupHasErrors,
			$author$project$Components$Admin$GlobalSignupSettings$Settings$fieldValidationGroup(field),
			errors);
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$hasErrors = function (model) {
	return !$elm$core$List$isEmpty(model.agX);
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$fieldNameString = function (field) {
	if (field.$ === 16) {
		return 'minEnrollAge';
	} else {
		return '';
	}
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$isFieldDirty = F2(
	function (field, model) {
		return A2(
			$elm$core$Set$member,
			$author$project$Components$Admin$GlobalSignupSettings$Settings$fieldNameString(field),
			model.jm);
	});
var $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$DateInputMsg = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$GotToday = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$Open = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$open = function () {
	var _v0 = $author$project$Components$DateInput$init;
	var dateInput = _v0.a;
	var dateInputCmd = _v0.b;
	return _Utils_Tuple2(
		A3($author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$Open, $elm$core$Maybe$Nothing, dateInput, $elm$core$Maybe$Nothing),
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($elm$core$Task$perform, $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$GotToday, $justinmimbs$date$Date$today),
					A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$DateInputMsg(dateInput),
					dateInputCmd)
				])));
}();
var $author$project$Components$Admin$GlobalSignupSettings$Settings$debounceUpdateForField = function (field) {
	if (field.$ === 16) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$UpdateDebounceMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$updateDebounceConfig = {
	alK: $jinjor$elm_debounce$Debounce$later(1000),
	ame: $author$project$Components$Admin$GlobalSignupSettings$Settings$UpdateDebounceMsg
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$processUpdate = F2(
	function (field, model) {
		var _v0 = _Utils_Tuple2(
			$author$project$Components$Admin$GlobalSignupSettings$Settings$debounceUpdateForField(field),
			field);
		if (_v0.a) {
			var _v1 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Components$Admin$GlobalSignupSettings$Settings$updateDebounceConfig, field, model.qM);
			var debounceModel = _v1.a;
			var debounceCmd = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{qM: debounceModel}),
				debounceCmd);
		} else {
			if (_v0.b.$ === 15) {
				if (_v0.b.a) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						model,
						A2(
							$elm$core$Task$perform,
							$author$project$Components$Admin$GlobalSignupSettings$Settings$FormFieldUpdated,
							$elm$core$Task$succeed(
								$author$project$Components$Admin$GlobalSignupSettings$Settings$MinEnrollAge(''))));
				}
			} else {
				return _Utils_Tuple2(
					model,
					$author$project$Components$Admin$GlobalSignupSettings$Settings$applyUpdate(field));
			}
		}
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$setFieldDirty = F2(
	function (field, model) {
		return _Utils_update(
			model,
			{
				jm: A2(
					$elm$core$Set$insert,
					$author$project$Components$Admin$GlobalSignupSettings$Settings$fieldNameString(field),
					model.jm)
			});
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$setFieldPristine = F2(
	function (field, model) {
		return _Utils_update(
			model,
			{
				jm: A2(
					$elm$core$Set$remove,
					$author$project$Components$Admin$GlobalSignupSettings$Settings$fieldNameString(field),
					model.jm)
			});
	});
var $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$DateChanged = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$LaunchDateChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$None = {$: 0};
var $author$project$Api$Provider$Practice$changeLaunchDate = F3(
	function (apiClient, maybeDate, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'new_launch_date',
					A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, maybeDate))
				]));
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$Practice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['launch_date']),
						$author$project$Api$Provider$Practice$practicePath))));
	});
var $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$None, aiO: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$Closed, aR: _List_Nil};
			case 3:
				var dateInputModel = msg.a;
				var dateInputMsg = msg.b;
				var _v1 = A2($author$project$Components$DateInput$update, dateInputMsg, dateInputModel);
				var newDateInput = _v1.a;
				var subCmd = _v1.b;
				var event = _v1.c;
				if (model.$ === 1) {
					var maybeToday = model.c;
					if (event.$ === 1) {
						var maybeDate = event.a;
						return {
							GZ: subCmd,
							agZ: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$None,
							aiO: A3($author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$Open, maybeDate, newDateInput, maybeToday),
							aR: _List_Nil
						};
					} else {
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$None,
							aiO: A3($author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$Open, $elm$core$Maybe$Nothing, newDateInput, maybeToday),
							aR: _List_Nil
						};
					}
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$None, aiO: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$Closed, aR: _List_Nil};
				}
			case 1:
				if (model.$ === 1) {
					var maybeDate = model.a;
					var dateInput = model.b;
					var maybeToday = model.c;
					return {
						GZ: A3($author$project$Api$Provider$Practice$changeLaunchDate, apiClient, maybeDate, $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$DateChanged),
						agZ: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$None,
						aiO: A3($author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$Open, maybeDate, dateInput, maybeToday),
						aR: _List_Nil
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$None, aiO: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$Closed, aR: _List_Nil};
				}
			case 2:
				var response = msg.a;
				if (model.$ === 1) {
					var maybeDate = model.a;
					var dateInput = model.b;
					var maybeToday = model.c;
					switch (response.$) {
						case 3:
							return {
								GZ: $elm$core$Platform$Cmd$none,
								agZ: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$LaunchDateChanged(maybeDate),
								aiO: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$Closed,
								aR: _List_fromArray(
									[
										A2($author$project$OutMsg$ShowToast, 3, 'Practice launch date has been Updated')
									])
							};
						case 2:
							return {
								GZ: $elm$core$Platform$Cmd$none,
								agZ: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$None,
								aiO: A3($author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$Open, maybeDate, dateInput, maybeToday),
								aR: _List_fromArray(
									[
										A2($author$project$OutMsg$ShowToast, 1, 'Practice launch date cannot be changed. Please contact us for more information.')
									])
							};
						default:
							return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$None, aiO: model, aR: _List_Nil};
					}
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$None, aiO: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$Closed, aR: _List_Nil};
				}
			default:
				var today = msg.a;
				if (model.$ === 1) {
					var maybeDate = model.a;
					var dateInput = model.b;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$None,
						aiO: A3(
							$author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$Open,
							maybeDate,
							dateInput,
							$elm$core$Maybe$Just(today)),
						aR: _List_Nil
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$None, aiO: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$Closed, aR: _List_Nil};
				}
		}
	});
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$OnChange = $elm$core$Basics$identity;
var $author$project$Api$CollectOnSignup$encoderMaybe = function (maybeCustomType) {
	if (!maybeCustomType.$) {
		var customType = maybeCustomType.a;
		return $author$project$Api$CollectOnSignup$encoder(customType);
	} else {
		return $elm$json$Json$Encode$null;
	}
};
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$encodeForm = function (form) {
	var fields = $author$project$Utils$Form$fields(form);
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'collect_payment_source_on_signup',
				$author$project$Api$CollectOnSignup$encoderMaybe(fields.NZ)),
				_Utils_Tuple2(
				'accepts_ach',
				$elm$json$Json$Encode$bool(fields.KA)),
				_Utils_Tuple2(
				'accepts_cards',
				$elm$json$Json$Encode$bool(fields.KC)),
				_Utils_Tuple2(
				'encourage_ach',
				$elm$json$Json$Encode$bool(fields.Rq)),
				_Utils_Tuple2(
				'accepts_amex',
				$elm$json$Json$Encode$bool(fields.KB))
			]));
};
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var collectSignupRequirement = field.a;
				if (!collectSignupRequirement.$) {
					var value = collectSignupRequirement.a;
					if (!value) {
						return _Utils_update(
							fields,
							{
								KA: false,
								KB: false,
								KC: false,
								NZ: $elm$core$Maybe$Just(value),
								Rq: false
							});
					} else {
						return _Utils_update(
							fields,
							{
								KA: true,
								KC: true,
								NZ: $elm$core$Maybe$Just(value)
							});
					}
				} else {
					return fields;
				}
			case 1:
				var bool = field.a;
				return _Utils_update(
					fields,
					{KA: bool});
			case 2:
				var bool = field.a;
				return _Utils_update(
					fields,
					{KC: bool});
			case 3:
				var bool = field.a;
				return _Utils_update(
					fields,
					{Rq: bool});
			default:
				var bool = field.a;
				return _Utils_update(
					fields,
					{KB: bool});
		}
	});
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$update = F2(
	function (msg, _v0) {
		var model = _v0;
		var field = msg;
		var newModel = function () {
			if ((field.$ === 4) && (!field.a)) {
				return _Utils_update(
					model,
					{uz: true});
			} else {
				return _Utils_update(
					model,
					{uz: false});
			}
		}();
		var form = A3($author$project$Utils$Form$update, $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$formFieldsUpdate, field, model.SD);
		return _Utils_Tuple3(
			_Utils_update(
				newModel,
				{SD: form}),
			$elm$core$Platform$Cmd$none,
			$elm$core$Maybe$Just(
				$author$project$Components$Admin$GlobalSignupSettings$PaymentSource$encodeForm(form)));
	});
var $author$project$Ui$TagsInput$TagRemoved = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$TagsInput$TagAdded = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$TagsInput$mask = function (pattern_) {
	return $agustinrhcp$elm_mask$Mask$fromString(pattern_);
};
var $author$project$Ui$TagsInput$tagFitsPattern = F2(
	function (maybePattern, tag) {
		if (!maybePattern.$) {
			var pattern_ = maybePattern.a;
			var maskedTag = A2(
				$agustinrhcp$elm_mask$Mask$mask,
				$author$project$Ui$TagsInput$mask(pattern_),
				tag);
			return _Utils_eq(maskedTag, tag) && _Utils_eq(
				$elm$core$String$length(maskedTag),
				$elm$core$String$length(pattern_));
		} else {
			return true;
		}
	});
var $author$project$Ui$TagsInput$isTagValid = F3(
	function (maybePattern, tags_, tag) {
		var trimmed = $elm$core$String$trim(tag);
		return A2($author$project$Ui$TagsInput$tagFitsPattern, maybePattern, trimmed) && (!A2($elm$core$List$member, trimmed, tags_));
	});
var $author$project$Ui$TagsInput$submitInput = F4(
	function (ignoreNextInputUpdate, pattern_, tags_, model) {
		var valid = A3($author$project$Ui$TagsInput$isTagValid, pattern_, tags_, model.$7);
		var newModel = _Utils_update(
			model,
			{sD: ignoreNextInputUpdate, uD: !valid});
		return valid ? _Utils_Tuple3(
			_Utils_update(
				newModel,
				{$7: ''}),
			$elm$core$Platform$Cmd$none,
			$elm$core$Maybe$Just(
				$author$project$Ui$TagsInput$TagAdded(model.$7))) : _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
	});
var $author$project$Ui$TagsInput$updateInputValue = F2(
	function (newValue, model) {
		var modelAfterSubmit = _Utils_update(
			model,
			{sD: false});
		var newModel = model.sD ? modelAfterSubmit : _Utils_update(
			modelAfterSubmit,
			{
				$7: $elm$core$String$trim(newValue),
				uD: false
			});
		return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
	});
var $author$project$Ui$TagsInput$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 1:
				var str = msg.a;
				return A2($author$project$Ui$TagsInput$updateInputValue, str, model);
			case 0:
				var str = msg.a;
				return A2($author$project$Ui$TagsInput$updateInputValue, str, model);
			case 2:
				var pattern_ = msg.a;
				var tags_ = msg.b;
				var key = msg.c;
				switch (key) {
					case 13:
						return A4($author$project$Ui$TagsInput$submitInput, false, pattern_, tags_, model);
					case 32:
						return A4($author$project$Ui$TagsInput$submitInput, true, pattern_, tags_, model);
					case 188:
						return A4($author$project$Ui$TagsInput$submitInput, true, pattern_, tags_, model);
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
				}
			case 3:
				var pattern_ = msg.a;
				var tags_ = msg.b;
				return A4($author$project$Ui$TagsInput$submitInput, false, pattern_, tags_, model);
			default:
				var tag = msg.a;
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$elm$core$Maybe$Just(
						$author$project$Ui$TagsInput$TagRemoved(tag)));
		}
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var bool = field.a;
				return (!bool) ? _Utils_update(
					fields,
					{mo: bool, _c: false}) : _Utils_update(
					fields,
					{mo: bool});
			case 1:
				var bool = field.a;
				return _Utils_update(
					fields,
					{_c: bool});
			case 2:
				var bool = field.a;
				return _Utils_update(
					fields,
					{W2: bool});
			case 3:
				var restrict = field.a;
				return _Utils_update(
					fields,
					{hu: restrict});
			case 4:
				var zipCodes = field.a;
				return _Utils_update(
					fields,
					{ri: zipCodes});
			case 5:
				var collectAddress = field.a;
				return _Utils_update(
					fields,
					{NR: collectAddress});
			case 6:
				var collectShippingAddress = field.a;
				return _Utils_update(
					fields,
					{NS: collectShippingAddress});
			case 7:
				var collectPractitioner = field.a;
				return _Utils_update(
					fields,
					{N_: collectPractitioner});
			case 8:
				var collectLocation = field.a;
				return _Utils_update(
					fields,
					{afO: collectLocation});
			case 9:
				var collectSSN = field.a;
				return _Utils_update(
					fields,
					{N$: collectSSN});
			case 10:
				var collectLeadSource = field.a;
				return _Utils_update(
					fields,
					{NX: collectLeadSource});
			case 11:
				var collectBroker = field.a;
				return _Utils_update(
					fields,
					{NT: collectBroker});
			case 12:
				var allowPayerOnBehalfOnSignup = field.a;
				return _Utils_update(
					fields,
					{Ly: allowPayerOnBehalfOnSignup});
			case 13:
				var startDateSelectableOnSignup = field.a;
				return _Utils_update(
					fields,
					{ab8: startDateSelectableOnSignup});
			case 14:
				var collectOption = field.a;
				return _Utils_update(
					fields,
					{NW: collectOption});
			case 15:
				var bool = field.a;
				return _Utils_update(
					fields,
					{oG: bool});
			case 16:
				var age = field.a;
				return _Utils_update(
					fields,
					{
						Xa: $elm$core$String$toInt(age)
					});
			default:
				var date = field.a;
				return _Utils_update(
					fields,
					{VQ: date});
		}
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$updateField = F2(
	function (field, model) {
		return _Utils_update(
			model,
			{
				SD: A3($author$project$Utils$Form$update, $author$project$Components$Admin$GlobalSignupSettings$Settings$formFieldsUpdate, field, model.SD)
			});
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$clearErrors = function (model) {
	return _Utils_update(
		model,
		{agX: _List_Nil});
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$validateMinEnrollAge = function (model) {
	var _v0 = $author$project$Utils$Form$fields(model.SD);
	var minEnrollAge = _v0.Xa;
	var minEnrollAgeEnabled = _v0.oG;
	var _v1 = _Utils_Tuple2(minEnrollAge, minEnrollAgeEnabled);
	if ((_v1.a.$ === 1) && _v1.b) {
		var _v2 = _v1.a;
		return _List_fromArray(
			[
				_Utils_Tuple2(0, 'min enroll age is required')
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$validator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$GlobalSignupSettings$Settings$validateMinEnrollAge)
		]));
var $author$project$Components$Admin$GlobalSignupSettings$Settings$validate = function (model) {
	return $author$project$Utils$Result$merge(
		A2(
			$elm$core$Result$mapError,
			function (errors) {
				return _Utils_update(
					model,
					{agX: errors});
			},
			A2(
				$elm$core$Result$map,
				$rtfeldman$elm_validate$Validate$fromValid,
				A2(
					$rtfeldman$elm_validate$Validate$validate,
					$author$project$Components$Admin$GlobalSignupSettings$Settings$validator,
					$author$project$Components$Admin$GlobalSignupSettings$Settings$clearErrors(model)))));
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var modelWithForm = A2(
					$author$project$Components$Admin$GlobalSignupSettings$Settings$setFieldDirty,
					field,
					A2($author$project$Components$Admin$GlobalSignupSettings$Settings$updateField, field, model));
				var _v2 = A2($author$project$Components$Admin$GlobalSignupSettings$Settings$processUpdate, field, modelWithForm);
				var newModel = _v2.a;
				var updateCmd = _v2.b;
				return {GZ: updateCmd, agZ: $elm$core$Maybe$Nothing, aiO: newModel, aR: _List_Nil};
			case 5:
				var subMsg = msg.a;
				var _v3 = A2($author$project$Ui$TagsInput$update, subMsg, model.u2);
				var newTagsInput = _v3.a;
				var tagsInputMsg = _v3.b;
				var maybeEvent = _v3.c;
				var modelWithComponent = _Utils_update(
					model,
					{u2: newTagsInput});
				var _v4 = $author$project$Utils$Form$fields(modelWithComponent.SD);
				var restrictZipCodes = _v4.hu;
				var allowedZipCodes = _v4.ri;
				var _v5 = A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(modelWithComponent, $elm$core$Maybe$Nothing),
					A2(
						$elm$core$Maybe$map,
						function (event) {
							var newZips = function () {
								if (!event.$) {
									var tag = event.a;
									return _Utils_ap(
										allowedZipCodes,
										_List_fromArray(
											[tag]));
								} else {
									var tag = event.a;
									return A2($elm_community$list_extra$List$Extra$remove, tag, allowedZipCodes);
								}
							}();
							var newZipsField = $author$project$Components$Admin$GlobalSignupSettings$Settings$AllowedZipCodes(newZips);
							var modelWithField = A2($author$project$Components$Admin$GlobalSignupSettings$Settings$updateField, newZipsField, modelWithComponent);
							return _Utils_Tuple2(
								modelWithField,
								(restrictZipCodes && $elm$core$List$isEmpty(newZips)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
									A2($author$project$Components$Admin$GlobalSignupSettings$Settings$encodeField, modelWithField, newZipsField)));
						},
						maybeEvent));
				var newModel = _v5.a;
				var saveEvent = _v5.b;
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$GlobalSignupSettings$Settings$TagsInputMsg, tagsInputMsg),
					agZ: saveEvent,
					aiO: newModel,
					aR: _List_Nil
				};
			case 1:
				var subMsg = msg.a;
				var _v7 = A2($author$project$Components$Admin$GlobalSignupSettings$PaymentSource$update, subMsg, model.tM);
				var newComponentModel = _v7.a;
				var updateCmd = _v7.b;
				var maybeEvent = _v7.c;
				var event = A2(
					$elm$core$Maybe$map,
					function (event_) {
						var field = event_;
						return field;
					},
					maybeEvent);
				var modelWithComponent = _Utils_update(
					model,
					{tM: newComponentModel});
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$GlobalSignupSettings$Settings$PaymentSourceComponentMsg, updateCmd),
					agZ: event,
					aiO: modelWithComponent,
					aR: _List_Nil
				};
			case 2:
				var field = msg.a;
				var validatedModel = $author$project$Components$Admin$GlobalSignupSettings$Settings$validate(model);
				return (A2($author$project$Components$Admin$GlobalSignupSettings$Settings$isFieldDirty, field, model) && (!A2($author$project$Components$Admin$GlobalSignupSettings$Settings$fieldHasErrors, field, validatedModel.agX))) ? {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: $elm$core$Maybe$Just(
						A2($author$project$Components$Admin$GlobalSignupSettings$Settings$encodeField, validatedModel, field)),
					aiO: A2($author$project$Components$Admin$GlobalSignupSettings$Settings$setFieldPristine, field, model),
					aR: _List_Nil
				} : {GZ: $elm$core$Platform$Cmd$none, agZ: $elm$core$Maybe$Nothing, aiO: model, aR: _List_Nil};
			case 3:
				var validatedModel = $author$project$Components$Admin$GlobalSignupSettings$Settings$validate(model);
				if ($author$project$Components$Admin$GlobalSignupSettings$Settings$hasErrors(validatedModel)) {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: $elm$core$Maybe$Nothing, aiO: validatedModel, aR: _List_Nil};
				} else {
					var _v9 = $author$project$Utils$Form$fields(model.SD);
					var minEnrollAge = _v9.Xa;
					return {
						GZ: A2(
							$elm$core$Task$perform,
							$author$project$Components$Admin$GlobalSignupSettings$Settings$SaveChanges,
							$elm$core$Task$succeed(
								$author$project$Components$Admin$GlobalSignupSettings$Settings$MinEnrollAge(
									$author$project$Components$Admin$GlobalSignupSettings$Settings$enrollAgeToString(minEnrollAge)))),
						agZ: $elm$core$Maybe$Nothing,
						aiO: validatedModel,
						aR: _List_Nil
					};
				}
			case 4:
				var debounceMsg = msg.a;
				var _v10 = A4(
					$jinjor$elm_debounce$Debounce$update,
					$author$project$Components$Admin$GlobalSignupSettings$Settings$updateDebounceConfig,
					$jinjor$elm_debounce$Debounce$takeLast($author$project$Components$Admin$GlobalSignupSettings$Settings$applyUpdate),
					debounceMsg,
					model.qM);
				var newDebouncer = _v10.a;
				var debounceCmd = _v10.b;
				return {
					GZ: debounceCmd,
					agZ: $elm$core$Maybe$Nothing,
					aiO: _Utils_update(
						model,
						{qM: newDebouncer}),
					aR: _List_Nil
				};
			case 6:
				var _v11 = $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$open;
				var launchDateModal = _v11.a;
				var cmd = _v11.b;
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$GlobalSignupSettings$Settings$OpenChangeDateModalMsg, cmd),
					agZ: $elm$core$Maybe$Nothing,
					aiO: _Utils_update(
						model,
						{mK: launchDateModal}),
					aR: _List_Nil
				};
			default:
				var subMsg = msg.a;
				var result = A3($author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$update, apiClient, subMsg, model.mK);
				var cmd = function () {
					var _v12 = result.agZ;
					if ((_v12.$ === 1) && (!_v12.a.$)) {
						var dateStart = _v12.a.a;
						return A2(
							$elm$core$Task$perform,
							$author$project$Components$Admin$GlobalSignupSettings$Settings$FormFieldUpdated,
							$elm$core$Task$succeed(
								$author$project$Components$Admin$GlobalSignupSettings$Settings$LaunchDate(dateStart)));
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return {
					GZ: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								cmd,
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$GlobalSignupSettings$Settings$OpenChangeDateModalMsg, result.GZ)
							])),
					agZ: $elm$core$Maybe$Nothing,
					aiO: _Utils_update(
						model,
						{mK: result.aiO}),
					aR: result.aR
				};
		}
	});
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$OnChange = $elm$core$Basics$identity;
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$SaveChanges = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$Subdomain = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$SubdomainChecked = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$CheckSubdomain = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$applyUpdate = function (field) {
	if (!field.$) {
		return A2(
			$elm$core$Task$perform,
			$author$project$Components$Admin$GlobalSignupSettings$SignupPage$CheckSubdomain,
			$elm$core$Task$succeed(field));
	} else {
		return A2(
			$elm$core$Task$perform,
			$author$project$Components$Admin$GlobalSignupSettings$SignupPage$SaveChanges,
			$elm$core$Task$succeed(field));
	}
};
var $author$project$Api$Provider$Practice$Subdomains$subdomainsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['subdomains', 'new']),
	$author$project$Api$Provider$Practice$practicePath);
var $author$project$Api$Provider$Practice$Subdomains$checkSubdomain = F3(
	function (apiClient, toMsg, subdomain) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2($author$project$Api$Param$string, 'subdomain[name]', subdomain)
					]),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$Subdomains$subdomainsPath)));
	});
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$clearErrors = function (model) {
	return _Utils_update(
		model,
		{agX: _List_Nil});
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$fieldName = function (field) {
	switch (field.$) {
		case 0:
			return 'subdomain';
		case 1:
			return 'signup_page_not_found_redirect_url';
		default:
			return 'custom_javascript_text';
	}
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$encodeField = function (field) {
	var fieldName_ = $author$project$Components$Admin$GlobalSignupSettings$SignupPage$fieldName(field);
	switch (field.$) {
		case 0:
			var subdomain = field.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						fieldName_,
						$elm$json$Json$Encode$string(subdomain))
					]));
		case 1:
			var url = field.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						fieldName_,
						$elm$json$Json$Encode$string(url))
					]));
		default:
			var text = field.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'signup_settings',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									fieldName_,
									$elm$json$Json$Encode$string(text))
								])))
					]));
	}
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$CustomJavascriptValidation = 2;
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$SignupPageNotFoundRedirectUrlValidation = 1;
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$SubdomainValidation = 0;
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$fieldValidationGroup = function (field) {
	switch (field.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		default:
			return 2;
	}
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$errorsForGroup = F2(
	function (validation, errors) {
		return A2(
			$elm$core$List$filterMap,
			function (_v0) {
				var errValidation = _v0.a;
				var errMessage = _v0.b;
				return _Utils_eq(validation, errValidation) ? $elm$core$Maybe$Just(errMessage) : $elm$core$Maybe$Nothing;
			},
			errors);
	});
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$groupHasErrors = F2(
	function (validationGroup, errors) {
		return !$elm$core$List$isEmpty(
			A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$errorsForGroup, validationGroup, errors));
	});
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$fieldHasErrors = F2(
	function (field, errors) {
		return A2(
			$author$project$Components$Admin$GlobalSignupSettings$SignupPage$groupHasErrors,
			$author$project$Components$Admin$GlobalSignupSettings$SignupPage$fieldValidationGroup(field),
			errors);
	});
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$isFieldDirty = F2(
	function (field, model) {
		return A2(
			$elm$core$Set$member,
			$author$project$Components$Admin$GlobalSignupSettings$SignupPage$fieldName(field),
			model.jm);
	});
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$debounceUpdateForField = function (field) {
	switch (field.$) {
		case 0:
			return true;
		case 1:
			return true;
		default:
			return true;
	}
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$UpdateDebounceMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$updateDebounceConfig = {
	alK: $jinjor$elm_debounce$Debounce$later(1000),
	ame: $author$project$Components$Admin$GlobalSignupSettings$SignupPage$UpdateDebounceMsg
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$processUpdate = F2(
	function (field, model) {
		if ($author$project$Components$Admin$GlobalSignupSettings$SignupPage$debounceUpdateForField(field)) {
			var _v0 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Components$Admin$GlobalSignupSettings$SignupPage$updateDebounceConfig, field, model.qM);
			var debounceModel = _v0.a;
			var debounceCmd = _v0.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{qM: debounceModel}),
				debounceCmd);
		} else {
			return _Utils_Tuple2(
				model,
				$author$project$Components$Admin$GlobalSignupSettings$SignupPage$applyUpdate(field));
		}
	});
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$setFieldDirty = F2(
	function (field, model) {
		return _Utils_update(
			model,
			{
				jm: A2(
					$elm$core$Set$insert,
					$author$project$Components$Admin$GlobalSignupSettings$SignupPage$fieldName(field),
					model.jm)
			});
	});
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$setFieldPristine = F2(
	function (field, model) {
		return _Utils_update(
			model,
			{
				jm: A2(
					$elm$core$Set$remove,
					$author$project$Components$Admin$GlobalSignupSettings$SignupPage$fieldName(field),
					model.jm)
			});
	});
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var subdomain = field.a;
				return _Utils_update(
					fields,
					{acu: subdomain});
			case 1:
				var url = field.a;
				return _Utils_update(
					fields,
					{aby: url});
			default:
				var text = field.a;
				return _Utils_update(
					fields,
					{rX: text});
		}
	});
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$updateField = F2(
	function (field, model) {
		return _Utils_update(
			model,
			{
				SD: A3($author$project$Utils$Form$update, $author$project$Components$Admin$GlobalSignupSettings$SignupPage$formFieldsUpdate, field, model.SD)
			});
	});
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$validateCustomJavascript = function (_v0) {
	return _List_Nil;
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$validateSignupPageNotFoundRedirectUrl = function (model) {
	var _v0 = $author$project$Utils$Form$fields(model.SD);
	var signupPageNotFoundRedirectUrl = _v0.aby;
	return $author$project$Utils$Validate$isInvalidUrlStricter(signupPageNotFoundRedirectUrl) ? _List_fromArray(
		[
			_Utils_Tuple2(1, 'is not a valid URL')
		]) : _List_Nil;
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$parseErrorString = F2(
	function (token, errorString) {
		var tokenSingular = $elm$core$String$trim(token) + ' ';
		var tokenPlural = 'and ' + tokenSingular;
		return A2(
			$elm$core$List$map,
			function (err) {
				return A3($elm$core$String$replace, tokenSingular, '', err);
			},
			A2($elm$core$String$split, tokenPlural, errorString));
	});
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$validateSubdomain = function (model) {
	var _v0 = $author$project$Utils$Form$fields(model.SD);
	var subdomain = _v0.acu;
	if ($author$project$Utils$String$isBlank(subdomain)) {
		return _List_fromArray(
			[
				_Utils_Tuple2(0, 'cannot be blank')
			]);
	} else {
		var _v1 = model.uY;
		switch (_v1.$) {
			case 2:
				var error = _v1.a;
				return A2(
					$elm$core$List$map,
					function (errString) {
						return _Utils_Tuple2(0, errString);
					},
					A2(
						$author$project$Components$Admin$GlobalSignupSettings$SignupPage$parseErrorString,
						'Subdomain ',
						$author$project$Api$Data$errorToString(error)));
			case 1:
				return _List_fromArray(
					[
						_Utils_Tuple2(0, 'is being checked')
					]);
			default:
				return _List_Nil;
		}
	}
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$validator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$GlobalSignupSettings$SignupPage$validateSubdomain),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$GlobalSignupSettings$SignupPage$validateSignupPageNotFoundRedirectUrl),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$GlobalSignupSettings$SignupPage$validateCustomJavascript)
		]));
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$validate = function (model) {
	return $author$project$Utils$Result$merge(
		A2(
			$elm$core$Result$mapError,
			function (errors) {
				return _Utils_update(
					model,
					{agX: errors});
			},
			A2(
				$elm$core$Result$map,
				$rtfeldman$elm_validate$Validate$fromValid,
				A2(
					$rtfeldman$elm_validate$Validate$validate,
					$author$project$Components$Admin$GlobalSignupSettings$SignupPage$validator,
					$author$project$Components$Admin$GlobalSignupSettings$SignupPage$clearErrors(model)))));
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var modelWithForm = A2(
					$author$project$Components$Admin$GlobalSignupSettings$SignupPage$setFieldDirty,
					field,
					A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$updateField, field, model));
				var _v2 = A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$processUpdate, field, modelWithForm);
				var newModel = _v2.a;
				var updateCmd = _v2.b;
				return _Utils_Tuple3(newModel, updateCmd, $elm$core$Maybe$Nothing);
			case 1:
				var field = msg.a;
				if (A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$isFieldDirty, field, model)) {
					var _v3 = $author$project$Utils$Form$fields(model.SD);
					var subdomain = _v3.acu;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{uY: $author$project$Api$Data$Loading}),
						A3($author$project$Api$Provider$Practice$Subdomains$checkSubdomain, apiClient, $author$project$Components$Admin$GlobalSignupSettings$SignupPage$SubdomainChecked, subdomain),
						$elm$core$Maybe$Nothing);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
				}
			case 2:
				var data = msg.a;
				var modelWithData = _Utils_update(
					model,
					{uY: data});
				switch (data.$) {
					case 3:
						var _v5 = $author$project$Utils$Form$fields(modelWithData.SD);
						var subdomain = _v5.acu;
						return _Utils_Tuple3(
							modelWithData,
							A2(
								$elm$core$Task$perform,
								$author$project$Components$Admin$GlobalSignupSettings$SignupPage$SaveChanges,
								$elm$core$Task$succeed(
									$author$project$Components$Admin$GlobalSignupSettings$SignupPage$Subdomain(subdomain))),
							$elm$core$Maybe$Nothing);
					case 2:
						return _Utils_Tuple3(
							$author$project$Components$Admin$GlobalSignupSettings$SignupPage$validate(modelWithData),
							$elm$core$Platform$Cmd$none,
							$elm$core$Maybe$Nothing);
					default:
						return _Utils_Tuple3(modelWithData, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
				}
			case 3:
				var debounceMsg = msg.a;
				var _v6 = A4(
					$jinjor$elm_debounce$Debounce$update,
					$author$project$Components$Admin$GlobalSignupSettings$SignupPage$updateDebounceConfig,
					$jinjor$elm_debounce$Debounce$takeLast($author$project$Components$Admin$GlobalSignupSettings$SignupPage$applyUpdate),
					debounceMsg,
					model.qM);
				var newDebouncer = _v6.a;
				var debounceCmd = _v6.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qM: newDebouncer}),
					debounceCmd,
					$elm$core$Maybe$Nothing);
			default:
				var field = msg.a;
				var validatedModel = $author$project$Components$Admin$GlobalSignupSettings$SignupPage$validate(model);
				if (A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$isFieldDirty, field, model) && (!A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$fieldHasErrors, field, validatedModel.agX))) {
					var pristineModel = $author$project$Components$Admin$GlobalSignupSettings$SignupPage$clearErrors(
						A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$setFieldPristine, field, model));
					return _Utils_Tuple3(
						pristineModel,
						$elm$core$Platform$Cmd$none,
						$elm$core$Maybe$Just(
							$author$project$Components$Admin$GlobalSignupSettings$SignupPage$encodeField(field)));
				} else {
					return _Utils_Tuple3(validatedModel, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
				}
		}
	});
var $author$project$Pages$Admin$Signup$PracticeUpdated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$Signup$updatePractice = F2(
	function (model, encodedValue) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2('practice', encodedValue)
				]));
		return A4(
			$author$project$Api$Data$patch,
			model.Gv,
			$author$project$Api$Provider$Practice$One$decoder,
			$author$project$Pages$Admin$Signup$PracticeUpdated,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				A2(
					$author$project$Api$Data$requestWithQuery,
					$author$project$Api$Provider$Practice$retrieveOptionsToParams($author$project$Pages$Admin$Signup$practiceOptionals),
					$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$practicePath))));
	});
var $author$project$Pages$Admin$Signup$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Components$Admin$GlobalSignupSettings$Confirmation$update, subMsg, model.iP);
				var newComponentModel = _v1.a;
				var updateCmd = _v1.b;
				var maybeEvent = _v1.c;
				var modelWithComponent = _Utils_update(
					model,
					{iP: newComponentModel});
				var practiceUpdateCmd = function () {
					if (!maybeEvent.$) {
						var encodedChange = maybeEvent.a;
						return A2($author$project$Pages$Admin$Signup$updatePractice, modelWithComponent, encodedChange);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return _Utils_Tuple3(
					modelWithComponent,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Signup$ConfirmationComponentMsg, updateCmd),
								practiceUpdateCmd
							])),
					_List_Nil);
			case 1:
				var response = msg.a;
				if (response.$ === 3) {
					var signupPages = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Qb: $elm$core$List$head(signupPages)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$reportDecodeError(response));
				}
			case 2:
				var subMsg = msg.a;
				var _v4 = A3($author$project$Components$Admin$GlobalSignupSettings$SignupPage$update, model.Gv, subMsg, model.hJ);
				var newComponentModel = _v4.a;
				var componentUpdateCmd = _v4.b;
				var maybeEvent = _v4.c;
				var modelWithComponent = _Utils_update(
					model,
					{hJ: newComponentModel});
				var practiceUpdateCmd = function () {
					if (!maybeEvent.$) {
						var encodedChange = maybeEvent.a;
						return A2($author$project$Pages$Admin$Signup$updatePractice, modelWithComponent, encodedChange);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return _Utils_Tuple3(
					modelWithComponent,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Signup$SignupPageComponentMsg, componentUpdateCmd),
								practiceUpdateCmd
							])),
					_List_Nil);
			case 3:
				var subMsg = msg.a;
				var result = A3($author$project$Components$Admin$GlobalSignupSettings$Settings$update, model.Gv, subMsg, model.lj);
				var modelWithComponent = _Utils_update(
					model,
					{lj: result.aiO});
				var practiceUpdateCmd = function () {
					var _v6 = result.agZ;
					if (!_v6.$) {
						var encodedChange = _v6.a;
						return A2($author$project$Pages$Admin$Signup$updatePractice, modelWithComponent, encodedChange);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return _Utils_Tuple3(
					modelWithComponent,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Signup$SettingsComponentMsg, result.GZ),
								practiceUpdateCmd
							])),
					result.aR);
			case 4:
				var response = msg.a;
				var modelWithPractice = _Utils_update(
					model,
					{ZV: response});
				if (response.$ === 3) {
					var practice = response.a;
					var modelWithComponents = _Utils_update(
						modelWithPractice,
						{
							hJ: $author$project$Pages$Admin$Signup$initSignupPageComponent(practice)
						});
					return _Utils_Tuple3(
						modelWithComponents,
						$author$project$Pages$Admin$Signup$getDefaultSignupPage(modelWithComponents),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						modelWithPractice,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					var practice = response.a;
					var modelWithComponents = _Utils_update(
						model,
						{
							iP: $author$project$Components$Admin$GlobalSignupSettings$Confirmation$init(practice),
							ZV: response,
							lj: $author$project$Components$Admin$GlobalSignupSettings$Settings$init(practice),
							hJ: $author$project$Pages$Admin$Signup$initSignupPageComponent(practice)
						});
					return _Utils_Tuple3(
						modelWithComponents,
						$author$project$Pages$Admin$Signup$getDefaultSignupPage(modelWithComponents),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your practice has been updated'),
								$author$project$OutMsg$PracticeUpdated(response)
							]));
				} else {
					var newModel = function () {
						var _v9 = model.ZV;
						if (_v9.$ === 3) {
							var practice = _v9.a;
							return _Utils_update(
								model,
								{
									iP: $author$project$Components$Admin$GlobalSignupSettings$Confirmation$init(practice),
									lj: $author$project$Components$Admin$GlobalSignupSettings$Settings$init(practice),
									hJ: $author$project$Pages$Admin$Signup$initSignupPageComponent(practice)
								});
						} else {
							return model;
						}
					}();
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var currentDate = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							dd: $elm$core$Maybe$Just(currentDate)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
		}
	});
var $author$project$Api$Provider$SignupPage$Shared$baseUrl = function (_v0) {
	var record = _v0;
	return record.Mz;
};
var $author$project$Api$Provider$SignupPage$All$baseUrl = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$SignupPage$Shared$baseUrl(shared);
};
var $author$project$Pages$Admin$Signup$help = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$textSm]),
		_List_fromArray(
			[
				$elm$html$Html$text('at '),
				A3(
				$author$project$Ui$Link$externalHref,
				A2(
					$elm$core$Maybe$withDefault,
					'',
					A2($elm$core$Maybe$map, $author$project$Api$Provider$SignupPage$All$baseUrl, model.Qb)),
				_List_fromArray(
					[$author$project$Ui$Link$targetBlank]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2($elm$core$Maybe$map, $author$project$Api$Provider$SignupPage$All$baseUrl, model.Qb)))
					]))
			]));
};
var $author$project$Components$LoadingPage$view = _List_fromArray(
	[
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$textCenter]),
		_List_fromArray(
			[
				$author$project$Ui$Spinner$view(_List_Nil)
			]))
	]);
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$RedirectsPostSignup = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$viewSettingToggle = F3(
	function (label, labelHelp, toggleSwitch) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label(label),
					$author$project$Ui$Form$Group$labelHelp(labelHelp),
					$author$project$Ui$Form$Group$labelClass(''),
					$author$project$Ui$Form$Group$inputSpan(4),
					$author$project$Ui$Form$Group$labelSpan(7),
					$author$project$Ui$Form$Group$offsetLabel
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$justifyRight]),
					_List_fromArray(
						[toggleSwitch]))
				]));
	});
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$viewAutoRedirectToggle = function (model) {
	var _v0 = $author$project$Utils$Form$fields(model.SD);
	var redirectsPostSignup = _v0.$l;
	var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$on(redirectsPostSignup),
				$author$project$Ui$ToggleSwitch$onChange(
				A2($elm$core$Basics$composeL, $author$project$Components$Admin$GlobalSignupSettings$Confirmation$FormUpdated, $author$project$Components$Admin$GlobalSignupSettings$Confirmation$RedirectsPostSignup))
			]));
	return A3(
		$author$project$Components$Admin$GlobalSignupSettings$Confirmation$viewSettingToggle,
		'Auto Redirect to External Site',
		$elm$html$Html$text(''),
		toggleSwitch);
};
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$PostSignupButtonLabel = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$viewCustomButtonText = F4(
	function (practice, model, redirectsPostSignup, showPostSignupFooterButton) {
		if ((!redirectsPostSignup) && showPostSignupFooterButton) {
			var labelHelp = A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								'If left blank, button will read \"Go to ' + ($author$project$Api$Provider$Practice$One$name(practice) + ' Website\".'))
							]))
					]));
			var _v0 = $author$project$Utils$Form$fields(model.SD);
			var postSignupButtonLabel = _v0.ZR;
			return A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$offsetLabel,
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(7),
						$author$project$Ui$Form$Group$label('Custom Button Text'),
						$author$project$Ui$Form$Group$labelHelp(labelHelp),
						$author$project$Ui$Form$Group$labelClass('')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(postSignupButtonLabel),
								$author$project$Ui$Form$Input$placeholder(
								'Go to ' + ($author$project$Api$Provider$Practice$One$name(practice) + ' Website')),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Components$Admin$GlobalSignupSettings$Confirmation$FormUpdated, $author$project$Components$Admin$GlobalSignupSettings$Confirmation$PostSignupButtonLabel)),
								$author$project$Ui$Form$Input$onBlur(
								$author$project$Components$Admin$GlobalSignupSettings$Confirmation$SaveChanges(
									$author$project$Components$Admin$GlobalSignupSettings$Confirmation$PostSignupButtonLabel(postSignupButtonLabel))),
								$author$project$Ui$Form$Input$withFeedback(true)
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$PostSignupRedirectUrl = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Icon$alert = $author$project$Ui$Icon$viewIcon(5);
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$viewErrorRow = function (message) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'padding-top', '10px')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap]),
								_List_fromArray(
									[
										$author$project$Ui$Icon$alert(_List_Nil),
										A2(
										$author$project$Ui$Typography$text,
										_List_fromArray(
											[$author$project$Ui$Typography$muted]),
										message)
									]))
							]))
					]))
			]));
};
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$viewCustomButtonUrl = F4(
	function (practice, model, redirectsPostSignup, showPostSignupFooterButton) {
		if ((!redirectsPostSignup) && (!showPostSignupFooterButton)) {
			return $author$project$Utils$Html$empty;
		} else {
			var labelHelp = redirectsPostSignup ? $elm$html$Html$text('') : A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('If left blank, clicking the button will redirect to your practice website (under ')
							])),
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Admin__Practice,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Account')
							])),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(').')
							]))
					]));
			var _v0 = redirectsPostSignup ? _Utils_Tuple2('Redirect URL', true) : _Utils_Tuple2('Custom Button URL', false);
			var title = _v0.a;
			var required = _v0.b;
			var _v1 = $author$project$Utils$Form$fields(model.SD);
			var postSignupRedirectUrl = _v1.ZT;
			return A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$offsetLabel,
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(7),
						$author$project$Ui$Form$Group$label(title),
						$author$project$Ui$Form$Group$labelHelp(labelHelp),
						$author$project$Ui$Form$Group$required(required),
						$author$project$Ui$Form$Group$labelClass('')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(postSignupRedirectUrl),
								$author$project$Ui$Form$Input$placeholder(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									$author$project$Api$Provider$Practice$One$url(practice))),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Components$Admin$GlobalSignupSettings$Confirmation$FormUpdated, $author$project$Components$Admin$GlobalSignupSettings$Confirmation$PostSignupRedirectUrl)),
								$author$project$Ui$Form$Input$invalid(
								A2($author$project$Components$Admin$GlobalSignupSettings$Confirmation$groupHasErrors, 0, model.agX)),
								$author$project$Ui$Form$Input$onBlur(
								$author$project$Components$Admin$GlobalSignupSettings$Confirmation$SaveChanges(
									$author$project$Components$Admin$GlobalSignupSettings$Confirmation$PostSignupRedirectUrl(postSignupRedirectUrl))),
								$author$project$Ui$Form$Input$withFeedback(true)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						A2(
							$elm$core$List$map,
							$author$project$Components$Admin$GlobalSignupSettings$Confirmation$viewErrorRow,
							A2($author$project$Components$Admin$GlobalSignupSettings$Confirmation$errorsForGroup, 0, model.agX)))
					]));
		}
	});
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$PostSignupMessage = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Form$Textarea$OnBlur = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Form$Textarea$onBlur = $author$project$Ui$Form$Textarea$OnBlur;
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$viewCustomMessage = F2(
	function (model, redirectsPostSignup) {
		if (redirectsPostSignup) {
			return $author$project$Utils$Html$empty;
		} else {
			var labelHelpText = A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('If left blank, the default message is \"We are thrilled to have you as a new member! Expect to receive an invoice once your membership is confirmed.\"')
					]));
			var _v0 = $author$project$Utils$Form$fields(model.SD);
			var postSignupMessage = _v0.ZS;
			return A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$offsetLabel,
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(7),
						$author$project$Ui$Form$Group$label('Custom Message for Plan Signup Pages'),
						$author$project$Ui$Form$Group$labelClass(''),
						$author$project$Ui$Form$Group$labelHelp(labelHelpText)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Textarea$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Textarea$placeholder('If you have any questions feel free to call our office at (333) 123-4567.'),
								$author$project$Ui$Form$Textarea$value(postSignupMessage),
								$author$project$Ui$Form$Textarea$onInput(
								A2($elm$core$Basics$composeL, $author$project$Components$Admin$GlobalSignupSettings$Confirmation$FormUpdated, $author$project$Components$Admin$GlobalSignupSettings$Confirmation$PostSignupMessage)),
								$author$project$Ui$Form$Textarea$onBlur(
								$author$project$Components$Admin$GlobalSignupSettings$Confirmation$SaveChanges(
									$author$project$Components$Admin$GlobalSignupSettings$Confirmation$PostSignupMessage(postSignupMessage)))
							]))
					]));
		}
	});
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$ShowPostSignupFooterButton = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$viewPostSignupButtonToggle = F2(
	function (redirectsPostSignup, showPostSignupFooterButton) {
		if (redirectsPostSignup) {
			return $author$project$Utils$Html$empty;
		} else {
			var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$on(showPostSignupFooterButton),
						$author$project$Ui$ToggleSwitch$onChange(
						A2($elm$core$Basics$composeL, $author$project$Components$Admin$GlobalSignupSettings$Confirmation$FormUpdated, $author$project$Components$Admin$GlobalSignupSettings$Confirmation$ShowPostSignupFooterButton))
					]));
			var labelHelpText = showPostSignupFooterButton ? 'A button is displayed that can be configured below with a custom text and URL.' : 'No button will be shown, and employee should be instructed to close their current signup tab.';
			var labelHelp = A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(labelHelpText)
					]));
			return A3(
				$author$project$Components$Admin$GlobalSignupSettings$Confirmation$viewSettingToggle,
				'Show Redirect Button on Confirmation',
				A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp),
				toggleSwitch);
		}
	});
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$view = F2(
	function (practice, _v0) {
		var model = _v0;
		var fields = $author$project$Utils$Form$fields(model.SD);
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mb4]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mb2]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('Confirmation Page')
								]))
						])),
					$author$project$Components$Admin$GlobalSignupSettings$Confirmation$viewAutoRedirectToggle(model),
					A2($author$project$Components$Admin$GlobalSignupSettings$Confirmation$viewCustomMessage, model, fields.$l),
					A2($author$project$Components$Admin$GlobalSignupSettings$Confirmation$viewPostSignupButtonToggle, fields.$l, fields.abp),
					A4($author$project$Components$Admin$GlobalSignupSettings$Confirmation$viewCustomButtonText, practice, model, fields.$l, fields.abp),
					A4($author$project$Components$Admin$GlobalSignupSettings$Confirmation$viewCustomButtonUrl, practice, model, fields.$l, fields.abp)
				]));
	});
var $author$project$Pages$Admin$Signup$viewConfirmationComponent = F2(
	function (practice, confirmationComponent) {
		return A2(
			$elm$html$Html$map,
			$author$project$Pages$Admin$Signup$ConfirmationComponentMsg,
			A2($author$project$Components$Admin$GlobalSignupSettings$Confirmation$view, practice, confirmationComponent));
	});
var $author$project$Pages$Admin$Signup$viewMemberAgreementsText = A2(
	$author$project$Ui$Grid$row,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Grid$column,
			_List_fromArray(
				[
					$author$project$Ui$Grid$offset(1)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('You can add and configure your Agreements  '),
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Admin__Documents__Top,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('here')
								]))
						]))
				]))
		]));
var $author$project$Pages$Admin$Signup$viewMemberAgreementsSection = A2(
	$author$project$Ui$Element$view,
	_List_fromArray(
		[$author$project$Ui$Element$mb4]),
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mb2]),
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Member Agreements')
						]))
				])),
			$author$project$Pages$Admin$Signup$viewMemberAgreementsText
		]));
var $author$project$Components$Admin$GlobalSignupSettings$Settings$futureLaunchDate = F2(
	function (currentDate, defaultMembershipStartDate) {
		var _v0 = A2($justinmimbs$date$Date$compare, defaultMembershipStartDate, currentDate);
		if (_v0 === 2) {
			return true;
		} else {
			return false;
		}
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$StartDateSelectable = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewSettingToggle = F3(
	function (label, labelHelp, toggleSwitch) {
		return A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(11),
							$author$project$Ui$Grid$offsetSm(1)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label(label),
									$author$project$Ui$Form$Group$labelHelp(labelHelp),
									$author$project$Ui$Form$Group$labelClass(''),
									$author$project$Ui$Form$Group$labelSpan(8),
									$author$project$Ui$Form$Group$inputSpan(4)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$justifyRight]),
									_List_fromArray(
										[toggleSwitch]))
								]))
						]))
				]));
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewAllowFutureStartDate = function (startDateSelectableOnSignup) {
	var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$on(startDateSelectableOnSignup),
				$author$project$Ui$ToggleSwitch$onChange(
				A2($elm$core$Basics$composeL, $author$project$Components$Admin$GlobalSignupSettings$Settings$FormFieldUpdated, $author$project$Components$Admin$GlobalSignupSettings$Settings$StartDateSelectable))
			]));
	var labelHelpText = startDateSelectableOnSignup ? 'The patient can choose any day in the future to start their membership.' : 'The member will not get a choice and the membership will start the day the form is submitted.';
	var labelHelp = A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(labelHelpText)
			]));
	return A3(
		$author$project$Components$Admin$GlobalSignupSettings$Settings$viewSettingToggle,
		'Allow Future Start Dates',
		A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp),
		toggleSwitch);
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$AllowPayerOnBehalf = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$collectOptionsForField = function (fieldName) {
	switch (fieldName) {
		case 'CollectAddress':
			return _List_fromArray(
				[0, 1, 2]);
		case 'CollectBillingAddress':
			return _List_fromArray(
				[0, 1, 2]);
		case 'CollectPractitioner':
			return _List_fromArray(
				[0, 1, 2]);
		case 'CollectLocation':
			return _List_fromArray(
				[0, 2]);
		case 'CollectSSN':
			return _List_fromArray(
				[0, 1, 2]);
		case 'CollectLeadSource':
			return _List_fromArray(
				[0, 1, 2]);
		case 'CollectBroker':
			return _List_fromArray(
				[0, 1, 2]);
		case 'AllowPayerOnBehalf':
			return _List_fromArray(
				[0, 4, 3, 2]);
		case 'CollectInsurance':
			return _List_fromArray(
				[0, 4]);
		default:
			return _List_Nil;
	}
};
var $author$project$Api$CollectOnSignup$label = function (collectOnSignup) {
	switch (collectOnSignup) {
		case 0:
			return 'No';
		case 1:
			return 'Optional';
		case 2:
			return 'Require';
		case 3:
			return 'Yes (and set as default)';
		default:
			return 'Yes';
	}
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectOnSignupButton = F4(
	function (currentCollectOnSignup, selectedCollectOnSignup, disabled, toFieldMsg) {
		var label = $author$project$Api$CollectOnSignup$label(selectedCollectOnSignup);
		return A3(
			$author$project$Ui$Button$view,
			{mm: 'Select ' + label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(currentCollectOnSignup, selectedCollectOnSignup)),
					$author$project$Ui$Button$onClick(
					$author$project$Components$Admin$GlobalSignupSettings$Settings$FormFieldUpdated(
						toFieldMsg(selectedCollectOnSignup))),
					$author$project$Ui$Button$disabled(disabled)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectOnSignup = F6(
	function (collectOnSignup, label, labelHelp, disabled, collectOptionsList, toFieldMsg) {
		return A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(11),
							$author$project$Ui$Grid$offsetSm(1)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label(label),
									$author$project$Ui$Form$Group$labelHelp(labelHelp),
									$author$project$Ui$Form$Group$labelSpan(4),
									$author$project$Ui$Form$Group$inputSpan(8),
									$author$project$Ui$Form$Group$labelClass('')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$justifyRight]),
									_List_fromArray(
										[
											$author$project$Ui$Button$group(
											A2(
												$elm$core$List$map,
												function (option) {
													return A4($author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectOnSignupButton, collectOnSignup, option, disabled, toFieldMsg);
												},
												collectOptionsList))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewAllowNonMemberPayer = function (collectOption) {
	var labelHelpText = function () {
		switch (collectOption) {
			case 0:
				return 'The payer will be also enrolled as patient.';
			case 4:
				return 'The payer can choose to not be enrolled as a patient, but will be enrolled by default.';
			case 3:
				return 'The payer can choose to be enrolled as a patient, but will not be enrolled by default.';
			case 2:
				return 'The payer will not be enrolled as patient.';
			default:
				return '';
		}
	}();
	return A6(
		$author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectOnSignup,
		collectOption,
		'Allow non-member payers',
		$elm$html$Html$text(labelHelpText),
		false,
		$author$project$Components$Admin$GlobalSignupSettings$Settings$collectOptionsForField('AllowPayerOnBehalf'),
		$author$project$Components$Admin$GlobalSignupSettings$Settings$AllowPayerOnBehalf);
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$AutoConfirmMembership = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewAutoConfirmMembership = F3(
	function (futureLaunch, defaultMembershipStartDate, autoConfirmMembership) {
		var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
			_List_fromArray(
				[
					$author$project$Ui$ToggleSwitch$on(autoConfirmMembership),
					$author$project$Ui$ToggleSwitch$onChange(
					A2($elm$core$Basics$composeL, $author$project$Components$Admin$GlobalSignupSettings$Settings$FormFieldUpdated, $author$project$Components$Admin$GlobalSignupSettings$Settings$AutoConfirmMembership))
				]));
		var labelHelpText = function () {
			var _v0 = _Utils_Tuple2(autoConfirmMembership, futureLaunch);
			if (_v0.a) {
				if (_v0.b) {
					return 'Memberships will be charged on ' + A2($justinmimbs$date$Date$format, 'MM/dd/yyyy', defaultMembershipStartDate);
				} else {
					return 'Memberships will be charged immediately.';
				}
			} else {
				return 'Memberships will be charged once confirmed.';
			}
		}();
		var labelHelp = A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(labelHelpText)
				]));
		return A3(
			$author$project$Components$Admin$GlobalSignupSettings$Settings$viewSettingToggle,
			'Auto Confirm Memberships',
			A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp),
			toggleSwitch);
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$CollectAddress = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectAddress = F2(
	function (restrictZipCodes, collectOption) {
		var collectOptionOverride = A2($author$project$Components$Admin$GlobalSignupSettings$Settings$collectAddressValue, restrictZipCodes, collectOption);
		var labelHelpText = function () {
			switch (collectOptionOverride) {
				case 0:
					return 'Addresses will not be collected.';
				case 1:
					return 'Addresses are optional and can be left blank.';
				case 2:
					return 'An address is required for each member.';
				default:
					return '';
			}
		}();
		return A6(
			$author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectOnSignup,
			collectOptionOverride,
			'Collect Address',
			$elm$html$Html$text(labelHelpText),
			restrictZipCodes,
			$author$project$Components$Admin$GlobalSignupSettings$Settings$collectOptionsForField('CollectAddress'),
			$author$project$Components$Admin$GlobalSignupSettings$Settings$CollectAddress);
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$CollectBroker = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectBroker = function (collectOption) {
	var labelHelpText = function () {
		switch (collectOption) {
			case 0:
				return 'Brokers will not be collected.';
			case 1:
				return 'Brokers are optional and can be left blank.';
			case 2:
				return 'A broker is required for each member.';
			default:
				return '';
		}
	}();
	return A6(
		$author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectOnSignup,
		collectOption,
		'Collect Broker',
		$elm$html$Html$text(labelHelpText),
		false,
		$author$project$Components$Admin$GlobalSignupSettings$Settings$collectOptionsForField('CollectBroker'),
		$author$project$Components$Admin$GlobalSignupSettings$Settings$CollectBroker);
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$CollectInsurance = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectInsurance = function (collectOption) {
	var labelHelpText = function () {
		switch (collectOption) {
			case 0:
				return 'Insurance (or an alternative) will not be collected.';
			case 4:
				return 'Insurance (or an alternative) will be collected, patients can answer they don\'t have coverage.';
			default:
				return '';
		}
	}();
	return A6(
		$author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectOnSignup,
		collectOption,
		'Collect Insurance',
		$elm$html$Html$text(labelHelpText),
		false,
		$author$project$Components$Admin$GlobalSignupSettings$Settings$collectOptionsForField('CollectInsurance'),
		$author$project$Components$Admin$GlobalSignupSettings$Settings$CollectInsurance);
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$CollectLeadSource = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectLeadSource = function (collectOption) {
	var labelHelpText = function () {
		switch (collectOption) {
			case 0:
				return 'Lead sources will not be collected.';
			case 1:
				return 'Lead sources are optional and can be left blank.';
			case 2:
				return 'A lead source is required for each member.';
			default:
				return '';
		}
	}();
	return A6(
		$author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectOnSignup,
		collectOption,
		'Collect Lead Source',
		$elm$html$Html$text(labelHelpText),
		false,
		$author$project$Components$Admin$GlobalSignupSettings$Settings$collectOptionsForField('CollectLeadSource'),
		$author$project$Components$Admin$GlobalSignupSettings$Settings$CollectLeadSource);
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$CollectLocation = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$collectLocationHelp = F2(
	function (collectLocationEditable, collectOption) {
		if (collectLocationEditable) {
			return $elm$html$Html$text(
				function () {
					switch (collectOption) {
						case 0:
							return 'Locations will not be collected.';
						case 2:
							return 'A location is required for each member.';
						default:
							return '';
					}
				}());
		} else {
			switch (collectOption) {
				case 0:
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Ui$Typography$text, _List_Nil, 'This practice has no locations. You can add some '),
								A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Admin__Locations,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('here')
									])),
								A2($author$project$Ui$Typography$text, _List_Nil, '.')
							]));
				case 2:
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Ui$Typography$text, _List_Nil, 'This practice requires all members to have a location, you can change this setting '),
								A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Admin__Patients,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('here')
									])),
								A2($author$project$Ui$Typography$text, _List_Nil, '.')
							]));
				default:
					return $author$project$Utils$Html$empty;
			}
		}
	});
var $author$project$Api$Provider$Practice$One$isCollectLocationOnSignupEditable = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.W4;
		},
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.afO;
			},
			function ($) {
				return $.Q4;
			})));
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectLocation = F2(
	function (practice, collectOption) {
		var showCollectLocation = $author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice);
		if (showCollectLocation) {
			var collectLocationEditable = $author$project$Api$Provider$Practice$One$isCollectLocationOnSignupEditable(practice);
			var labelHelp = A2($author$project$Components$Admin$GlobalSignupSettings$Settings$collectLocationHelp, collectLocationEditable, collectOption);
			return A6(
				$author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectOnSignup,
				collectOption,
				'Collect Location',
				labelHelp,
				!collectLocationEditable,
				$author$project$Components$Admin$GlobalSignupSettings$Settings$collectOptionsForField('CollectLocation'),
				$author$project$Components$Admin$GlobalSignupSettings$Settings$CollectLocation);
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$CollectPractitioner = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$collectProviderHelp = F3(
	function (collectProviderEditable, hasProviders, collectOption) {
		return collectProviderEditable ? $elm$html$Html$text(
			function () {
				switch (collectOption) {
					case 0:
						return 'Providers will not be collected.';
					case 1:
						return 'Providers are optional and can be left blank.';
					case 2:
						return 'A provider is required for each member.';
					default:
						return '';
				}
			}()) : A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					hasProviders ? $elm$html$Html$text('') : A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Ui$Typography$text, _List_Nil, 'This practice has no providers. You can add some '),
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Admin__Providers__Top,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('here')
								])),
							A2($author$project$Ui$Typography$text, _List_Nil, '.')
						])),
					(collectOption === 2) ? A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Ui$Typography$text, _List_Nil, 'This practice requires all members to have a provider, you can change this setting '),
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Admin__Patients,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('here')
								])),
							A2($author$project$Ui$Typography$text, _List_Nil, '.')
						])) : $elm$html$Html$text('')
				]));
	});
var $author$project$Api$Provider$Practice$One$isCollectPractitionerOnSignupEditable = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.W4;
		},
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.N_;
			},
			function ($) {
				return $.Q4;
			})));
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectProvider = F2(
	function (practice, collectOption) {
		var hasProviders = $author$project$Api$Provider$Practice$One$hasPractitioners(practice);
		var collectProviderEditable = $author$project$Api$Provider$Practice$One$isCollectPractitionerOnSignupEditable(practice);
		var labelHelp = A3($author$project$Components$Admin$GlobalSignupSettings$Settings$collectProviderHelp, collectProviderEditable, hasProviders, collectOption);
		return A6(
			$author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectOnSignup,
			collectOption,
			'Collect Provider',
			labelHelp,
			!collectProviderEditable,
			$author$project$Components$Admin$GlobalSignupSettings$Settings$collectOptionsForField('CollectPractitioner'),
			$author$project$Components$Admin$GlobalSignupSettings$Settings$CollectPractitioner);
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$CollectSSN = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectSSN = F2(
	function (requiresSSN, collectOption) {
		var labelHelpText = function () {
			switch (collectOption) {
				case 0:
					return 'SSN will not be collected.';
				case 1:
					return 'SSN are optional and can be left blank.';
				case 2:
					return 'A SSN is required for each member. This will prevent people without SSNs from signing up.';
				default:
					return '';
			}
		}();
		var labelHelp = requiresSSN ? A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(labelHelpText)
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('SSN is required for every patient, you can change this setting '),
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Admin__Patients,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('here.')
								]))
						]))
				])) : $elm$html$Html$text(labelHelpText);
		return A6(
			$author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectOnSignup,
			collectOption,
			'Collect SSN',
			labelHelp,
			requiresSSN,
			$author$project$Components$Admin$GlobalSignupSettings$Settings$collectOptionsForField('CollectSSN'),
			$author$project$Components$Admin$GlobalSignupSettings$Settings$CollectSSN);
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$CollectBillingAddress = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectShippingAddress = F2(
	function (disabled, collectOption) {
		var labelHelpText = function () {
			switch (collectOption) {
				case 0:
					return 'Shipping addresses will not be collected.';
				case 1:
					return 'Shipping addresses are optional and can be left blank.';
				case 2:
					return 'A shipping address is required for each member.';
				default:
					return '';
			}
		}();
		return A6(
			$author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectOnSignup,
			collectOption,
			'Collect Shipping Address',
			$elm$html$Html$text(labelHelpText),
			disabled,
			$author$project$Components$Admin$GlobalSignupSettings$Settings$collectOptionsForField('CollectBillingAddress'),
			$author$project$Components$Admin$GlobalSignupSettings$Settings$CollectBillingAddress);
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$OpenChangeDateModal = {$: 6};
var $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$ChangeLaunchDate = {$: 1};
var $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$CloseModal = {$: 0};
var $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$viewModal = F3(
	function (maybeDate, dateInput, today) {
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$CloseModal,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('Change Launch Date')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$phi]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[
											$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Changing your launch date will not automatically change the membership start date or invoice date for any paid memberships. All pending and unpaid memberships will receive new membership start and bill dates. All unpaid membership invoices will be voided. '),
											A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$Reports__Invoices,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Click here')
												])),
											$elm$html$Html$text(' to view paid invoices.')
										]))
								])),
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Launch Date'),
									$author$project$Ui$Form$Group$labelSpan(6),
									$author$project$Ui$Form$Group$labelSpanSm(8),
									$author$project$Ui$Form$Group$inputSpan(6),
									$author$project$Ui$Form$Group$inputSpanSm(4)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$DateInputMsg(dateInput),
									A2(
										$author$project$Components$DateInput$view,
										_List_fromArray(
											[
												$author$project$Components$DateInput$value(maybeDate),
												$author$project$Components$DateInput$disabledPickerDates(
												function (date) {
													return A2($author$project$Utils$Date$isBefore, date, today);
												})
											]),
										dateInput))
								]))
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Cancel and close modal'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$CloseModal)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Change launch date'},
							_List_fromArray(
								[
									$author$project$Ui$Button$danger,
									$author$project$Ui$Button$onClick($author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$ChangeLaunchDate),
									$author$project$Ui$Button$disabled(
									_Utils_eq(maybeDate, $elm$core$Maybe$Nothing))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Change Launch Date')
								]))
						]))
				]));
	});
var $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$view = function (model) {
	if (model.$ === 1) {
		var maybeDate = model.a;
		var dateInput = model.b;
		var maybeToday = model.c;
		if (!maybeToday.$) {
			var today = maybeToday.a;
			return A3($author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$viewModal, maybeDate, dateInput, today);
		} else {
			return $author$project$Utils$Html$empty;
		}
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewModal = function (changeLaunchDateModal) {
	if (!changeLaunchDateModal.$) {
		var modal = changeLaunchDateModal.a;
		return A2(
			$elm$html$Html$map,
			$author$project$Components$Admin$GlobalSignupSettings$Settings$OpenChangeDateModalMsg,
			$author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$view(modal));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewMembershipStartDate = F4(
	function (futureLaunch, defaultMembershipStartDate, isHinter, changeLaunchDateModal) {
		var shouldShowStartDate = futureLaunch || isHinter;
		if (shouldShowStartDate) {
			var startDate = A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, defaultMembershipStartDate);
			return A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanSm(11),
								$author$project$Ui$Grid$offsetSm(1)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Membership Start Date'),
										$author$project$Ui$Form$Group$labelHelp(
										$elm$html$Html$text('Memberships will start on your launch date.')),
										$author$project$Ui$Form$Group$labelClass(''),
										$author$project$Ui$Form$Group$labelSpan(8),
										$author$project$Ui$Form$Group$inputSpan(4)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$gap2]),
										_List_fromArray(
											[
												$elm$html$Html$text(startDate),
												A3(
												$author$project$Ui$Button$view,
												{mm: 'Edit Launch Date'},
												_List_fromArray(
													[
														$author$project$Ui$Button$onClick($author$project$Components$Admin$GlobalSignupSettings$Settings$OpenChangeDateModal),
														$author$project$Ui$Button$sm,
														$author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Edit Launch Date')
													]))
											]))
									])),
								$author$project$Components$Admin$GlobalSignupSettings$Settings$viewModal(changeLaunchDateModal)
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$MergeInactivePatients = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewMergeInactivePatients = function (mergeDuplicatePatientsOnSignup) {
	var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$on(mergeDuplicatePatientsOnSignup),
				$author$project$Ui$ToggleSwitch$onChange(
				A2($elm$core$Basics$composeL, $author$project$Components$Admin$GlobalSignupSettings$Settings$FormFieldUpdated, $author$project$Components$Admin$GlobalSignupSettings$Settings$MergeInactivePatients))
			]));
	var labelHelpText = mergeDuplicatePatientsOnSignup ? '\n                If a signup matches an inactive patient by name and date of birth,\n                that patient will be re-enrolled and have their payment, contract, and insurance information updated.\n                If a signup matches an active patient,\n                an error will be shown directing the prospective patient to contact the practice.\n                ' : 'Always create new patients.';
	var labelHelp = A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(labelHelpText)
			]));
	return A3(
		$author$project$Components$Admin$GlobalSignupSettings$Settings$viewSettingToggle,
		'Merge with Matching Inactive Patients',
		A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp),
		toggleSwitch);
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewMinEnrollmentAge = F2(
	function (minEnrollmentAge, minEnrollAgeEnabled) {
		return minEnrollAgeEnabled ? A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(10),
							$author$project$Ui$Grid$offsetSm(2)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$required(true),
									$author$project$Ui$Form$Group$label('Minimum Enroll Age'),
									$author$project$Ui$Form$Group$labelClass(''),
									$author$project$Ui$Form$Group$labelSpan(9),
									$author$project$Ui$Form$Group$inputSpan(3)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$justifyRight]),
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$value(
													$author$project$Components$Admin$GlobalSignupSettings$Settings$enrollAgeToString(minEnrollmentAge)),
													$author$project$Ui$Form$Input$number,
													$author$project$Ui$Form$Input$placeholder('18'),
													$author$project$Ui$Form$Input$onInput(
													A2($elm$core$Basics$composeL, $author$project$Components$Admin$GlobalSignupSettings$Settings$FormFieldUpdated, $author$project$Components$Admin$GlobalSignupSettings$Settings$MinEnrollAge)),
													$author$project$Ui$Form$Input$onBlur($author$project$Components$Admin$GlobalSignupSettings$Settings$ValidateMinEnrollAge),
													$author$project$Ui$Form$Input$withFeedback(true)
												]))
										]))
								]))
						]))
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$CollectPaymentSourceOnSignup = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$FormUpdated = $elm$core$Basics$identity;
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewCollectOnSignupButton = F6(
	function (collectOnSignupButtonEnabled, currentCollectOnSignup, selectedCollectOnSignup, toMsg, toFieldMsg, label) {
		return A3(
			$author$project$Ui$Button$view,
			{mm: 'Select ' + label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(currentCollectOnSignup, selectedCollectOnSignup)),
					$author$project$Ui$Button$onClick(
					toMsg(
						toFieldMsg(selectedCollectOnSignup))),
					$author$project$Ui$Button$disabled(!collectOnSignupButtonEnabled)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewCollectOnSignup = F8(
	function (collectOnSignupButtonEnabled, collectOnSignup, label, labelHelp, viewPracticeDefault, childrenContent, toMsg, toFieldMsg) {
		var extraCollectOption = viewPracticeDefault ? _List_fromArray(
			[
				A6($author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewCollectOnSignupButton, collectOnSignupButtonEnabled, collectOnSignup, $elm$core$Maybe$Nothing, toMsg, toFieldMsg, 'Practice Default')
			]) : _List_Nil;
		return A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(11),
							$author$project$Ui$Grid$offsetSm(1)
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label(label),
									$author$project$Ui$Form$Group$labelHelp(labelHelp),
									$author$project$Ui$Form$Group$labelSpan(4),
									$author$project$Ui$Form$Group$inputSpan(8),
									$author$project$Ui$Form$Group$labelClass('')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$justifyRight]),
									_List_fromArray(
										[
											$author$project$Ui$Button$group(
											A2(
												$elm$core$List$cons,
												A6(
													$author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewCollectOnSignupButton,
													collectOnSignupButtonEnabled,
													collectOnSignup,
													$elm$core$Maybe$Just(0),
													toMsg,
													toFieldMsg,
													'No'),
												A2(
													$elm$core$List$cons,
													A6(
														$author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewCollectOnSignupButton,
														collectOnSignupButtonEnabled,
														collectOnSignup,
														$elm$core$Maybe$Just(1),
														toMsg,
														toFieldMsg,
														'Optional'),
													A2(
														$elm$core$List$cons,
														A6(
															$author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewCollectOnSignupButton,
															collectOnSignupButtonEnabled,
															collectOnSignup,
															$elm$core$Maybe$Just(2),
															toMsg,
															toFieldMsg,
															'Require'),
														extraCollectOption))))
										]))
								])),
						childrenContent))
				]));
	});
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$AcceptsAch = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewSettingToggle = F3(
	function (label, labelHelp, toggleSwitch) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label(label),
					$author$project$Ui$Form$Group$labelHelp(labelHelp),
					$author$project$Ui$Form$Group$labelClass(''),
					$author$project$Ui$Form$Group$offsetLabel,
					$author$project$Ui$Form$Group$labelSpan(7),
					$author$project$Ui$Form$Group$inputSpan(4)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$justifyRight]),
					_List_fromArray(
						[toggleSwitch]))
				]));
	});
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewToggleSwitch = F3(
	function (practiceSetting, disabled, toFieldMsg) {
		return $author$project$Ui$ToggleSwitch$view(
			_List_fromArray(
				[
					$author$project$Ui$ToggleSwitch$on(practiceSetting),
					$author$project$Ui$ToggleSwitch$onChange(
					A2($elm$core$Basics$composeL, $elm$core$Basics$identity, toFieldMsg)),
					$author$project$Ui$ToggleSwitch$disabled(disabled)
				]));
	});
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewAcceptsAchToggle = function (fields) {
	var disableToggle = function () {
		var _v0 = fields.NZ;
		if ((!_v0.$) && (!_v0.a)) {
			var _v1 = _v0.a;
			return true;
		} else {
			return !fields.KC;
		}
	}();
	return A3(
		$author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewSettingToggle,
		'Accept Bank Accounts',
		$elm$html$Html$text(''),
		A3($author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewToggleSwitch, fields.KA, disableToggle, $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$AcceptsAch));
};
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$AcceptsAmex = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewAmexWarning = function (showAmexWarning) {
	return showAmexWarning ? A2(
		$author$project$Ui$Alert$warning,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('If members have already added American Express cards, these will still continue to be charged, but members will not be allowed to add new American Express cards.')
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewAcceptsAmexToggle = F2(
	function (fields, showAmexWarning) {
		if (fields.KC) {
			var showDisabledToggle = function () {
				var _v0 = fields.NZ;
				if ((!_v0.$) && (!_v0.a)) {
					var _v1 = _v0.a;
					return true;
				} else {
					return false;
				}
			}();
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewSettingToggle,
						'Accept American Express',
						$elm$html$Html$text(''),
						A3($author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewToggleSwitch, fields.KB, showDisabledToggle, $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$AcceptsAmex)),
						$author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewAmexWarning(showAmexWarning)
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$AcceptsCards = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewAcceptsCardsToggle = function (fields) {
	var disableToggle = function () {
		var _v0 = fields.NZ;
		if ((!_v0.$) && (!_v0.a)) {
			var _v1 = _v0.a;
			return true;
		} else {
			return !fields.KA;
		}
	}();
	return A3(
		$author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewSettingToggle,
		'Accept Credit Cards',
		$elm$html$Html$text(''),
		A3($author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewToggleSwitch, fields.KC, disableToggle, $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$AcceptsCards));
};
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$EncourageAch = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewEncourageAchToggle = function (fields) {
	if (fields.KA && fields.KC) {
		var showDisabledToggle = function () {
			var _v0 = fields.NZ;
			if ((!_v0.$) && (!_v0.a)) {
				var _v1 = _v0.a;
				return true;
			} else {
				return false;
			}
		}();
		var encourageMembersText = fields.Rq ? 'When both bank accounts and credit cards are accepted, a small note would be added to the credit cards form on signup.' : '';
		return A3(
			$author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewSettingToggle,
			'Encourage Members to Choose Bank Account',
			$elm$html$Html$text(encourageMembersText),
			A3($author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewToggleSwitch, fields.Rq, showDisabledToggle, $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$EncourageAch));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewPaymentSourceAcceptedOptions = F3(
	function (fields, hasActivePaymentProcessorAccount, showAmexWarning) {
		return ($author$project$Utils$Maybe$isNothing(fields.NZ) || (!hasActivePaymentProcessorAccount)) ? _List_Nil : _List_fromArray(
			[
				$author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewAcceptsAchToggle(fields),
				$author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewAcceptsCardsToggle(fields),
				$author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewEncourageAchToggle(fields),
				A2($author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewAcceptsAmexToggle, fields, showAmexWarning)
			]);
	});
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewCollectPaymentSource = F4(
	function (fields, hasActivePaymentProcessorAccount, prepayFirstPayment, showAmexWarning) {
		var practiceSetting = A3($author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewPaymentSourceAcceptedOptions, fields, hasActivePaymentProcessorAccount, showAmexWarning);
		var labelHelpText = function () {
			var _v0 = fields.NZ;
			_v0$3:
			while (true) {
				if (!_v0.$) {
					switch (_v0.a) {
						case 0:
							var _v1 = _v0.a;
							return 'Payment Source will not be collected.';
						case 1:
							var _v2 = _v0.a;
							return 'Payment Source is optional and can be left blank.';
						case 2:
							var _v3 = _v0.a;
							return 'A Payment Source is required.';
						default:
							break _v0$3;
					}
				} else {
					break _v0$3;
				}
			}
			return '';
		}();
		var collectOnSignupButtonEnabled = (!prepayFirstPayment) && hasActivePaymentProcessorAccount;
		return A8(
			$author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewCollectOnSignup,
			collectOnSignupButtonEnabled,
			fields.NZ,
			'Collect Payment Source',
			$elm$html$Html$text(labelHelpText),
			false,
			practiceSetting,
			$elm$core$Basics$identity,
			$author$project$Components$Admin$GlobalSignupSettings$PaymentSource$CollectPaymentSourceOnSignup);
	});
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewStripeAccountWarning = function (practice) {
	return $author$project$Api$Provider$Practice$One$hasPaymentProcessorAccount(practice) ? $author$project$Utils$Html$empty : A2(
		$author$project$Ui$Grid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$spanSm(5),
						$author$project$Ui$Grid$offsetSm(1)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Utils$PaymentProcessor$toSetupAlert,
						$author$project$Api$Practice$Provider(practice),
						$elm$core$Maybe$Just('In order to collect payment sources'))
					]))
			]));
};
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$view = function (_v0) {
	var model = _v0;
	var hasActivePaymentProcessorAccount = $author$project$Api$Provider$Practice$One$hasPaymentProcessorAccount(model.ZV);
	var fields = $author$project$Utils$Form$fields(model.SD);
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$mb4]),
		_List_fromArray(
			[
				A4($author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewCollectPaymentSource, fields, hasActivePaymentProcessorAccount, model.Jl, model.uz),
				$author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewStripeAccountWarning(model.ZV)
			]));
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewPaymentSource = function (model) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Admin$GlobalSignupSettings$Settings$PaymentSourceComponentMsg,
		$author$project$Components$Admin$GlobalSignupSettings$PaymentSource$view(model.tM));
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$PrepayFirstPaymentOnSignup = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewSettingToggleOffset = F3(
	function (label, labelHelp, toggleSwitch) {
		return A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(11),
							$author$project$Ui$Grid$offsetSm(1)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label(label),
									$author$project$Ui$Form$Group$labelHelp(labelHelp),
									$author$project$Ui$Form$Group$labelClass(''),
									$author$project$Ui$Form$Group$labelSpan(8),
									$author$project$Ui$Form$Group$inputSpan(4),
									$author$project$Ui$Form$Group$offsetLabel
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$justifyRight]),
									_List_fromArray(
										[toggleSwitch]))
								]))
						]))
				]));
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewPrepayFirstPaymentOnSignup = F2(
	function (prepayFirstPaymentOnSignup, autoConfirmMembership) {
		var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
			_List_fromArray(
				[
					$author$project$Ui$ToggleSwitch$on(prepayFirstPaymentOnSignup),
					$author$project$Ui$ToggleSwitch$onChange(
					A2($elm$core$Basics$composeL, $author$project$Components$Admin$GlobalSignupSettings$Settings$FormFieldUpdated, $author$project$Components$Admin$GlobalSignupSettings$Settings$PrepayFirstPaymentOnSignup)),
					$author$project$Ui$ToggleSwitch$disabled(!autoConfirmMembership)
				]));
		var labelHelp = A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('This allows you to collect a prepayment when your practice is launching in the future or for patients who select a future membership start date from the sign-up form. When enabled, the patient\'s first membership invoice will be paid upon submission of the sign-up form. ')
				]));
		return A3(
			$author$project$Components$Admin$GlobalSignupSettings$Settings$viewSettingToggleOffset,
			'Prepay First Payment',
			A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp),
			toggleSwitch);
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$MinEnrollAgeEnabled = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewRestrictEnrollmentAge = function (minEnrollAgeEnabled) {
	var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$on(minEnrollAgeEnabled),
				$author$project$Ui$ToggleSwitch$onChange(
				A2($elm$core$Basics$composeL, $author$project$Components$Admin$GlobalSignupSettings$Settings$FormFieldUpdated, $author$project$Components$Admin$GlobalSignupSettings$Settings$MinEnrollAgeEnabled))
			]));
	var labelHelpText = minEnrollAgeEnabled ? 'Under-age patients cannot be enrolled into a membership without an active adult also enrolled.' : 'Do not restrict patient enrollment into a membership based on age. Plans restrictions still apply.';
	var labelHelp = A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(labelHelpText)
			]));
	return A3(
		$author$project$Components$Admin$GlobalSignupSettings$Settings$viewSettingToggle,
		'Restrict enrollment by age',
		A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp),
		toggleSwitch);
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$RestrictZipCodes = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$TagsInput$Pattern = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$TagsInput$pattern = $author$project$Ui$TagsInput$Pattern;
var $author$project$Ui$TagsInput$Required = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$TagsInput$required = $author$project$Ui$TagsInput$Required;
var $author$project$Ui$TagsInput$Tags = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$TagsInput$tags = $author$project$Ui$TagsInput$Tags;
var $author$project$Ui$TagsInput$defaultOptions = {g9: $elm$core$Maybe$Nothing, akR: false, hQ: _List_Nil};
var $author$project$Ui$TagsInput$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var tags_ = option.a;
						return _Utils_update(
							record,
							{hQ: tags_});
					case 1:
						var string = option.a;
						return _Utils_update(
							record,
							{
								g9: $elm$core$Maybe$Just(string)
							});
					default:
						var bool = option.a;
						return _Utils_update(
							record,
							{akR: bool});
				}
			}),
		$author$project$Ui$TagsInput$defaultOptions,
		options);
};
var $author$project$Ui$TagsInput$InputBlur = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Ui$TagsInput$InputChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$TagsInput$InputKeyDown = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Ui$TagsInput$MaskedInputChanged = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$Input$OnKeyDown = function (a) {
	return {$: 13, a: a};
};
var $author$project$Ui$Form$Input$onKeyDown = $author$project$Ui$Form$Input$OnKeyDown;
var $author$project$Ui$TagsInput$viewInput = F2(
	function (options, model) {
		return $author$project$Ui$Form$Input$view(
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Form$Input$onKeyDown(
					A2($author$project$Ui$TagsInput$InputKeyDown, options.g9, options.hQ)),
				A2(
					$elm$core$List$cons,
					$author$project$Ui$Form$Input$onBlur(
						A2($author$project$Ui$TagsInput$InputBlur, options.g9, options.hQ)),
					A2(
						$elm$core$List$cons,
						$author$project$Ui$Form$Input$invalid(
							model.uD && (!A3($author$project$Ui$TagsInput$isTagValid, options.g9, options.hQ, model.$7))),
						function () {
							var _v0 = options.g9;
							if (!_v0.$) {
								var pattern_ = _v0.a;
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Input$maskedValue,
										$author$project$Ui$TagsInput$mask(pattern_),
										model.$7),
										A3(
										$author$project$Ui$Form$Input$onMaskedInput,
										$author$project$Ui$TagsInput$mask(pattern_),
										model.$7,
										$author$project$Ui$TagsInput$MaskedInputChanged),
										$author$project$Ui$Form$Input$placeholder(pattern_ + ',')
									]);
							} else {
								return _List_fromArray(
									[
										$author$project$Ui$Form$Input$value(model.$7),
										$author$project$Ui$Form$Input$onInput($author$project$Ui$TagsInput$InputChanged),
										$author$project$Ui$Form$Input$placeholder('tag name,')
									]);
							}
						}()))));
	});
var $author$project$Ui$TagsInput$maskedTags = F2(
	function (maybePattern, tags_) {
		return A2(
			$elm$core$List$filter,
			$author$project$Ui$TagsInput$tagFitsPattern(maybePattern),
			tags_);
	});
var $elm_community$list_extra$List$Extra$unique = function (list) {
	return A4($elm_community$list_extra$List$Extra$uniqueHelp, $elm$core$Basics$identity, $elm$core$Set$empty, list, _List_Nil);
};
var $author$project$Ui$TagsInput$filterTags = F2(
	function (maybePattern, tags_) {
		return A2(
			$author$project$Ui$TagsInput$maskedTags,
			maybePattern,
			$elm_community$list_extra$List$Extra$unique(
				A2(
					$elm$core$List$filter,
					$author$project$Utils$String$notBlank,
					A2($elm$core$List$map, $elm$core$String$trim, tags_))));
	});
var $author$project$Ui$TagsInput$RemoveTag = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$TagsInput$viewTag = function (tag) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('tag-item')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(tag),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('ml-05'),
						$elm$html$Html$Events$onClick(
						$author$project$Ui$TagsInput$RemoveTag(tag))
					]),
				_List_fromArray(
					[
						$author$project$Ui$Icon$cross(
						_List_fromArray(
							[$author$project$Ui$Icon$xs]))
					]))
			]));
};
var $author$project$Ui$TagsInput$viewTags = function (options) {
	var filteredTags = A2($author$project$Ui$TagsInput$filterTags, options.g9, options.hQ);
	return A2($elm$core$List$map, $author$project$Ui$TagsInput$viewTag, filteredTags);
};
var $author$project$Ui$TagsInput$view = F2(
	function (options, model) {
		var optionsRecord = $author$project$Ui$TagsInput$optionsToRecord(options);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tags-list'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'invalid',
							optionsRecord.akR && $elm$core$List$isEmpty(optionsRecord.hQ))
						])),
					$elm$html$Html$Attributes$id(model.ahP)
				]),
			A2(
				$elm$core$List$cons,
				A2($author$project$Ui$TagsInput$viewInput, optionsRecord, model),
				$author$project$Ui$TagsInput$viewTags(optionsRecord)));
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewAllowedZipCodes = function (model) {
	var _v0 = $author$project$Utils$Form$fields(model.SD);
	var restrictZipCodes = _v0.hu;
	var allowedZipCodes = _v0.ri;
	return restrictZipCodes ? A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$offsetLabel,
				$author$project$Ui$Form$Group$inputSpanSm(7),
				$author$project$Ui$Form$Group$labelSpanSm(4),
				$author$project$Ui$Form$Group$label('Allowed Zip Codes'),
				$author$project$Ui$Form$Group$labelHelp(
				$elm$html$Html$text('Zip codes can be copy/pasted into this field as long as they are separated by commas.')),
				$author$project$Ui$Form$Group$labelClass(''),
				$author$project$Ui$Form$Group$required(true)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Admin$GlobalSignupSettings$Settings$TagsInputMsg,
				A2(
					$author$project$Ui$TagsInput$view,
					_List_fromArray(
						[
							$author$project$Ui$TagsInput$tags(allowedZipCodes),
							$author$project$Ui$TagsInput$pattern('#####'),
							$author$project$Ui$TagsInput$required(true)
						]),
					model.u2))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewRestrictZipCodes = function (model) {
	var _v0 = $author$project$Utils$Form$fields(model.SD);
	var restrictZipCodes = _v0.hu;
	return A2(
		$author$project$Ui$Grid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$offsetSm(1),
						$author$project$Ui$Grid$spanSm(11)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8),
								$author$project$Ui$Form$Group$label('Restrict by Zip Codes'),
								$author$project$Ui$Form$Group$labelClass('')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$justifyRight]),
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$view(
										_List_fromArray(
											[
												$author$project$Ui$ToggleSwitch$on(restrictZipCodes),
												$author$project$Ui$ToggleSwitch$onChange(
												A2($elm$core$Basics$composeL, $author$project$Components$Admin$GlobalSignupSettings$Settings$FormFieldUpdated, $author$project$Components$Admin$GlobalSignupSettings$Settings$RestrictZipCodes))
											]))
									]))
							])),
						$author$project$Components$Admin$GlobalSignupSettings$Settings$viewAllowedZipCodes(model)
					]))
			]));
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$view = F4(
	function (currentDate, practice, isHintAdmin, _v0) {
		var model = _v0;
		var requiresSSN = $author$project$Api$Provider$Practice$One$requiresSSN(practice);
		var fields = $author$project$Utils$Form$fields(model.SD);
		var defaultMembershipStartDate = $author$project$Api$Provider$Practice$One$defaultMembershipStartDate(practice);
		var futureLaunch = A2($author$project$Components$Admin$GlobalSignupSettings$Settings$futureLaunchDate, currentDate, defaultMembershipStartDate);
		var changeLaunchDateModal = model.mK;
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mb4]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mb2]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('Admin')
								]))
						])),
					A4(
					$author$project$Components$Admin$GlobalSignupSettings$Settings$viewMembershipStartDate,
					futureLaunch,
					defaultMembershipStartDate,
					isHintAdmin,
					$elm$core$Maybe$Just(changeLaunchDateModal)),
					A3($author$project$Components$Admin$GlobalSignupSettings$Settings$viewAutoConfirmMembership, futureLaunch, defaultMembershipStartDate, fields.mo),
					A2($author$project$Components$Admin$GlobalSignupSettings$Settings$viewPrepayFirstPaymentOnSignup, fields._c, fields.mo),
					$author$project$Components$Admin$GlobalSignupSettings$Settings$viewMergeInactivePatients(fields.W2),
					$author$project$Components$Admin$GlobalSignupSettings$Settings$viewPaymentSource(model),
					$author$project$Components$Admin$GlobalSignupSettings$Settings$viewRestrictZipCodes(model),
					A2($author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectAddress, fields.hu, fields.NR),
					A2($author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectShippingAddress, fields.hu, fields.NS),
					A2($author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectProvider, practice, fields.N_),
					A2($author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectLocation, practice, fields.afO),
					$author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectInsurance(fields.NW),
					A2($author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectSSN, requiresSSN, fields.N$),
					$author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectLeadSource(fields.NX),
					$author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectBroker(fields.NT),
					$author$project$Components$Admin$GlobalSignupSettings$Settings$viewAllowFutureStartDate(fields.ab8),
					$author$project$Components$Admin$GlobalSignupSettings$Settings$viewRestrictEnrollmentAge(fields.oG),
					A2($author$project$Components$Admin$GlobalSignupSettings$Settings$viewMinEnrollmentAge, fields.Xa, fields.oG),
					$author$project$Components$Admin$GlobalSignupSettings$Settings$viewAllowNonMemberPayer(fields.Ly)
				]));
	});
var $author$project$Pages$Admin$Signup$viewSettingsComponent = F4(
	function (currentDate, practice, settingsComponent, isHintAdmin) {
		return A2(
			$elm$html$Html$map,
			$author$project$Pages$Admin$Signup$SettingsComponentMsg,
			A4($author$project$Components$Admin$GlobalSignupSettings$Settings$view, currentDate, practice, isHintAdmin, settingsComponent));
	});
var $author$project$Api$Feature$CustomJsOnSignupPages = 8;
var $author$project$Utils$Html$htmlIf = F2(
	function (ifCondition, element) {
		return ifCondition ? element : $author$project$Utils$Html$empty;
	});
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$CustomJavascript = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$viewAddCustomJavascript = function (model) {
	var _v0 = $author$project$Utils$Form$fields(model.SD);
	var customJavascript = _v0.rX;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$offsetLabel,
				$author$project$Ui$Form$Group$labelSpanSm(4),
				$author$project$Ui$Form$Group$inputSpanSm(7),
				$author$project$Ui$Form$Group$label('Add Custom Javascript'),
				$author$project$Ui$Form$Group$labelHelp(
				$elm$html$Html$text('Please review your signup pages to confirm that your code is valid.')),
				$author$project$Ui$Form$Group$labelClass('')
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Textarea$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Textarea$rows(5),
						$author$project$Ui$Form$Textarea$value(customJavascript),
						$author$project$Ui$Form$Textarea$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Admin$GlobalSignupSettings$SignupPage$FormUpdated, $author$project$Components$Admin$GlobalSignupSettings$SignupPage$CustomJavascript)),
						$author$project$Ui$Form$Textarea$invalid(
						A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$groupHasErrors, 2, model.agX)),
						$author$project$Ui$Form$Textarea$onBlur(
						$author$project$Components$Admin$GlobalSignupSettings$SignupPage$SaveChanges(
							$author$project$Components$Admin$GlobalSignupSettings$SignupPage$CustomJavascript(customJavascript))),
						$author$project$Ui$Form$Textarea$errors(
						A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$errorsForGroup, 2, model.agX))
					]))
			]));
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$viewCustomUrl = function (practice) {
	var signupUrl = $author$project$Api$Provider$Practice$One$memberPortalSignupUrl(practice);
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$offsetLabel,
				$author$project$Ui$Form$Group$labelSpanSm(4),
				$author$project$Ui$Form$Group$inputSpanSm(7),
				$author$project$Ui$Form$Group$label('Custom Url'),
				$author$project$Ui$Form$Group$labelClass('')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$justifyRight]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$externalHref,
						signupUrl,
						_List_fromArray(
							[$author$project$Ui$Link$targetBlank]),
						_List_fromArray(
							[
								$elm$html$Html$text(signupUrl)
							]))
					]))
			]));
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$viewPracticeName = function (practice) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$offsetLabel,
				$author$project$Ui$Form$Group$labelSpanSm(4),
				$author$project$Ui$Form$Group$inputSpanSm(7),
				$author$project$Ui$Form$Group$label('Practice Name'),
				$author$project$Ui$Form$Group$labelClass('')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Api$Provider$Practice$One$name(practice))
			]));
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$SignupPageNotFoundRedirectUrl = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$Input$Url = {$: 3};
var $author$project$Ui$Form$Input$url = $author$project$Ui$Form$Input$Type($author$project$Ui$Form$Input$Url);
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$viewErrorRow = function (message) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'padding-top', '10px')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(12)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap]),
								_List_fromArray(
									[
										$author$project$Ui$Icon$alert(_List_Nil),
										A2(
										$author$project$Ui$Typography$text,
										_List_fromArray(
											[$author$project$Ui$Typography$muted]),
										message)
									]))
							]))
					]))
			]));
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$viewSignupPageNotFoundRedirectUrl = function (model) {
	var _v0 = $author$project$Utils$Form$fields(model.SD);
	var signupPageNotFoundRedirectUrl = _v0.aby;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$offsetLabel,
				$author$project$Ui$Form$Group$labelSpanSm(4),
				$author$project$Ui$Form$Group$inputSpanSm(7),
				$author$project$Ui$Form$Group$label('Signup Page Not Found Url'),
				$author$project$Ui$Form$Group$labelHelp(
				$elm$html$Html$text('When a patient tries to use a signup page that is no longer\n            live or never existed they will be shown a message including the practice\'s phone,\n            email and this url.')),
				$author$project$Ui$Form$Group$labelClass('')
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$value(signupPageNotFoundRedirectUrl),
						$author$project$Ui$Form$Input$url,
						$author$project$Ui$Form$Input$placeholder('https://www.mypractice.com'),
						$author$project$Ui$Form$Input$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Admin$GlobalSignupSettings$SignupPage$FormUpdated, $author$project$Components$Admin$GlobalSignupSettings$SignupPage$SignupPageNotFoundRedirectUrl)),
						$author$project$Ui$Form$Input$invalid(
						A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$groupHasErrors, 1, model.agX)),
						$author$project$Ui$Form$Input$onBlur(
						$author$project$Components$Admin$GlobalSignupSettings$SignupPage$SaveChanges(
							$author$project$Components$Admin$GlobalSignupSettings$SignupPage$SignupPageNotFoundRedirectUrl(signupPageNotFoundRedirectUrl))),
						$author$project$Ui$Form$Input$withFeedback(true)
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				A2(
					$elm$core$List$map,
					$author$project$Components$Admin$GlobalSignupSettings$SignupPage$viewErrorRow,
					A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$errorsForGroup, 1, model.agX)))
			]));
};
var $author$project$Utils$Regex$replace = F3(
	function (userRegex, newString, string) {
		var _v0 = $elm$regex$Regex$fromString(userRegex);
		if (_v0.$ === 1) {
			return string;
		} else {
			var regex = _v0.a;
			return A3(
				$elm$regex$Regex$replace,
				regex,
				function (_v1) {
					return newString;
				},
				string);
		}
	});
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$subdomainify = function (practice) {
	return A3(
		$author$project$Utils$Regex$replace,
		'[^\\w-]',
		'',
		A3(
			$author$project$Utils$Regex$replace,
			' ',
			'-',
			$elm$core$String$toLower(
				$author$project$Api$Provider$Practice$One$name(practice))));
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$viewSubdomain = F2(
	function (practice, model) {
		var _v0 = $author$project$Utils$Form$fields(model.SD);
		var subdomain = _v0.acu;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$offsetLabel,
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(7),
					$author$project$Ui$Form$Group$label('Subdomain'),
					$author$project$Ui$Form$Group$required(true),
					$author$project$Ui$Form$Group$labelClass('')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$value(subdomain),
							$author$project$Ui$Form$Input$placeholder(
							$author$project$Components$Admin$GlobalSignupSettings$SignupPage$subdomainify(practice)),
							$author$project$Ui$Form$Input$onInput(
							A2($elm$core$Basics$composeL, $author$project$Components$Admin$GlobalSignupSettings$SignupPage$FormUpdated, $author$project$Components$Admin$GlobalSignupSettings$SignupPage$Subdomain)),
							$author$project$Ui$Form$Input$invalid(
							A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$groupHasErrors, 0, model.agX)),
							$author$project$Ui$Form$Input$onBlur(
							$author$project$Components$Admin$GlobalSignupSettings$SignupPage$CheckSubdomain(
								$author$project$Components$Admin$GlobalSignupSettings$SignupPage$Subdomain(subdomain))),
							$author$project$Ui$Form$Input$withFeedback(true)
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$author$project$Components$Admin$GlobalSignupSettings$SignupPage$viewErrorRow,
						A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$errorsForGroup, 0, model.agX)))
				]));
	});
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$view = F2(
	function (practice, _v0) {
		var model = _v0;
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mb4]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mb2]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('Signup Page')
								]))
						])),
					$author$project$Components$Admin$GlobalSignupSettings$SignupPage$viewPracticeName(practice),
					A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$viewSubdomain, practice, model),
					$author$project$Components$Admin$GlobalSignupSettings$SignupPage$viewCustomUrl(practice),
					$author$project$Components$Admin$GlobalSignupSettings$SignupPage$viewSignupPageNotFoundRedirectUrl(model),
					A2(
					$author$project$Utils$Html$htmlIf,
					A2($author$project$Api$Provider$Practice$One$featureEnabled, 8, practice),
					$author$project$Components$Admin$GlobalSignupSettings$SignupPage$viewAddCustomJavascript(model))
				]));
	});
var $author$project$Pages$Admin$Signup$viewSignupPageComponent = F2(
	function (practice, signupPageComponent) {
		return A2(
			$elm$html$Html$map,
			$author$project$Pages$Admin$Signup$SignupPageComponentMsg,
			A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$view, practice, signupPageComponent));
	});
var $author$project$Pages$Admin$Signup$viewPanelBody = function (model) {
	var _v0 = _Utils_Tuple2(model.ZV, model.dd);
	if ((_v0.a.$ === 3) && (!_v0.b.$)) {
		var _v1 = _v0.a;
		var practice = _v1.a;
		var currentDate = _v0.b.a;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Pages$Admin$Signup$viewSignupPageComponent, practice, model.hJ),
					A4($author$project$Pages$Admin$Signup$viewSettingsComponent, currentDate, practice, model.lj, model.Ij),
					$author$project$Pages$Admin$Signup$viewMemberAgreementsSection,
					A2($author$project$Pages$Admin$Signup$viewConfirmationComponent, practice, model.iP)
				]));
	} else {
		return A2($elm$html$Html$div, _List_Nil, $author$project$Components$LoadingPage$view);
	}
};
var $author$project$Pages$Admin$Signup$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Member Signup Form')
									])),
								$author$project$Pages$Admin$Signup$help(model)
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Pages$Admin$Signup$viewPanelBody(model)
							]))
					]))
			]),
		ac9: 'Admin | Signup Settings'
	};
};
var $author$project$Pages$Admin$Signup$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Signup$init, aiq: $author$project$Pages$Admin$Signup$load, k8: $author$project$Pages$Admin$Signup$save, alO: $author$project$Pages$Admin$Signup$subscriptions, adT: $author$project$Pages$Admin$Signup$update, amo: $author$project$Pages$Admin$Signup$view});
var $author$project$Pages$Admin$SignupPages$Id_String$FormMsg = $elm$core$Basics$identity;
var $author$project$Components$Admin$SignupPages$Form$ChargeItemResourceFilterMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$CompanyPlan = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$CompanyPlanResourceFilterMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$GotItem = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$LocationGroupResourceFilterMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$LocationResourceFilterMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$Model = $elm$core$Basics$identity;
var $author$project$Components$Admin$SignupPages$Form$PlanResourceFilterMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$PractitionerResourceFilterMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$RetailPlan = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$formFieldsInit = function (companyId) {
	return {KN: true, K1: _List_Nil, mL: $elm$core$Maybe$Nothing, fZ: companyId, V_: false, V$: false, V0: false, Wa: _List_Nil, Wg: _List_Nil, ZR: $elm$core$Maybe$Nothing, ZS: $elm$core$Maybe$Nothing, ZT: $elm$core$Maybe$Nothing, Z4: _List_Nil, $l: false, abp: false, abz: _List_Nil, abG: '', amg: 'signup', adZ: false};
};
var $author$project$Components$ResourceFilter$CompanyPlan$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Api$CompanyPlan$EmployerAll = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$CompanyPlan$ProviderAll = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Employer$CompanyPlan$companyPlansPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['company_plans']),
	$author$project$Api$Data$employerPath);
var $author$project$Api$Employer$CompanyPlan$All$CompanyPlan = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Employer$CompanyPlan$Shared$CompanyPlan = $elm$core$Basics$identity;
var $author$project$Api$Employer$CompanyPlan$Shared$Record = F3(
	function (id, availableForEnrollment, isDefault) {
		return {Mn: availableForEnrollment, ahP: id, UM: isDefault};
	});
var $author$project$Api$Employer$CompanyPlan$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'is_default',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'available_for_enrollment',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyPlan$Shared$Record))));
var $author$project$Api$Employer$CompanyPlan$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$CompanyPlan$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$CompanyPlan$All$Record = function (plan) {
	return {Jb: plan};
};
var $author$project$Api$Employer$CompanyPlan$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'plan',
	$author$project$Api$Employer$Plan$Shared$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyPlan$All$Record));
var $author$project$Api$Employer$CompanyPlan$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$CompanyPlan$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Employer$CompanyPlan$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyPlan$All$CompanyPlan)));
var $author$project$Api$Employer$CompanyPlan$expandToString = function (expand) {
	return 'pricing';
};
var $author$project$Api$Employer$CompanyPlan$listDefaults = {HE: _List_Nil, ahP: $elm$core$Maybe$Nothing};
var $author$project$Api$Employer$CompanyPlan$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Employer$CompanyPlan$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.ahP;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				_List_fromArray(
				[
					A2(
					$author$project$Api$Param$list,
					'expand',
					A2($elm$core$List$map, $author$project$Api$Employer$CompanyPlan$expandToString, options.HE))
				])
			]));
};
var $author$project$Api$Employer$CompanyPlan$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Employer$CompanyPlan$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Employer$CompanyPlan$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Employer$CompanyPlan$companyPlansPath)));
	});
var $author$project$Api$Provider$CompanyPlan$companyPlansPath = function (companyId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['company_plans']),
		$author$project$Api$Provider$Company$companyPath(companyId));
};
var $author$project$Api$Provider$CompanyPlan$All$CompanyPlan = $elm$core$Basics$identity;
var $author$project$Api$Provider$CompanyPlan$One$CompanyPlan = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$CompanyPlan$Shared$CompanyPlan = $elm$core$Basics$identity;
var $author$project$Api$Provider$CompanyPlan$Shared$Record = F3(
	function (id, availableForEnrollment, isDefault) {
		return {Mn: availableForEnrollment, ahP: id, UM: isDefault};
	});
var $author$project$Api$Provider$CompanyPlan$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'is_default',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'available_for_enrollment',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyPlan$Shared$Record))));
var $author$project$Api$Provider$CompanyPlan$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CompanyPlan$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CompanyPlan$One$Record = function (plan) {
	return {Jb: plan};
};
var $author$project$Api$Provider$CompanyPlan$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'plan',
	$author$project$Api$Provider$Plan$Shared$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyPlan$One$Record));
var $author$project$Api$Provider$CompanyPlan$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CompanyPlan$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$CompanyPlan$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyPlan$One$CompanyPlan)));
var $author$project$Api$Provider$CompanyPlan$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CompanyPlan$One$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CompanyPlan$expandToString = function (expand) {
	return 'pricing';
};
var $author$project$Api$Provider$CompanyPlan$listDefaults = {HE: _List_Nil, ahP: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$CompanyPlan$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$CompanyPlan$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.ahP;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				_List_fromArray(
				[
					A2(
					$author$project$Api$Param$list,
					'expand',
					A2($elm$core$List$map, $author$project$Api$Provider$CompanyPlan$expandToString, options.HE))
				])
			]));
};
var $author$project$Api$Provider$CompanyPlan$list = F4(
	function (apiClient, companyId, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$CompanyPlan$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$CompanyPlan$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$CompanyPlan$companyPlansPath(companyId))));
	});
var $author$project$Api$Employer$CompanyPlan$Pricing = 0;
var $author$project$Api$CompanyPlan$expandToEmployer = function (expand) {
	return 0;
};
var $author$project$Api$CompanyPlan$listDefaults = {HE: _List_Nil, ahP: $elm$core$Maybe$Nothing};
var $author$project$Api$CompanyPlan$optionalsToEmployer = function (optionals) {
	var options = optionals($author$project$Api$CompanyPlan$listDefaults);
	return function (d) {
		return _Utils_update(
			d,
			{
				HE: A2($elm$core$List$map, $author$project$Api$CompanyPlan$expandToEmployer, options.HE),
				ahP: options.ahP
			});
	};
};
var $author$project$Api$Provider$CompanyPlan$Pricing = 0;
var $author$project$Api$CompanyPlan$expandToProvider = function (expand) {
	return 0;
};
var $author$project$Api$CompanyPlan$optionalsToProvider = function (optionals) {
	var options = optionals($author$project$Api$CompanyPlan$listDefaults);
	return function (d) {
		return _Utils_update(
			d,
			{
				HE: A2($elm$core$List$map, $author$project$Api$CompanyPlan$expandToProvider, options.HE),
				ahP: options.ahP
			});
	};
};
var $author$project$Api$CompanyPlan$list = F5(
	function (apiClient, session, companyId, optionals, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$CompanyPlan$list,
			apiClient,
			$author$project$Api$CompanyPlan$optionalsToEmployer(optionals),
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$CompanyPlan$EmployerAll)))) : A4(
			$author$project$Api$Provider$CompanyPlan$list,
			apiClient,
			companyId,
			$author$project$Api$CompanyPlan$optionalsToProvider(optionals),
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$CompanyPlan$ProviderAll))));
	});
var $author$project$Components$ResourceFilter$CompanyPlan$list = F5(
	function (apiClient, session, companyId, optionals, toMsg) {
		return A5($author$project$Api$CompanyPlan$list, apiClient, session, companyId, optionals, toMsg);
	});
var $author$project$Components$ResourceFilter$CompanyPlan$fetchResources = F6(
	function (session, companyId, toMsg, apiClient, _v0, _v1) {
		return A5($author$project$Components$ResourceFilter$CompanyPlan$list, apiClient, session, companyId, $elm$core$Basics$identity, toMsg);
	});
var $author$project$Components$ResourceFilter$CompanyPlan$retrieveResource = F5(
	function (session, companyId, toMsg, apiClient, id) {
		return A5(
			$author$project$Components$ResourceFilter$CompanyPlan$list,
			apiClient,
			session,
			companyId,
			function (d) {
				return _Utils_update(
					d,
					{
						ahP: $elm$core$Maybe$Just(id)
					});
			},
			toMsg);
	});
var $author$project$Components$ResourceFilter$CompanyPlan$selectId = 'company_plans';
var $author$project$Api$Plan$EmployerShared = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Plan$ProviderShared = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$CompanyPlan$All$plan = function (_v0) {
	var record = _v0.b;
	return record.Jb;
};
var $author$project$Api$Provider$CompanyPlan$One$plan = function (_v0) {
	var record = _v0.b;
	return record.Jb;
};
var $author$project$Api$Provider$CompanyPlan$All$plan = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$CompanyPlan$One$plan(one);
};
var $author$project$Api$CompanyPlan$plan = function (companyPlan) {
	switch (companyPlan.$) {
		case 0:
			var companyPlan_ = companyPlan.a;
			return $author$project$Api$Plan$ProviderShared(
				$author$project$Api$Provider$CompanyPlan$One$plan(companyPlan_));
		case 1:
			var companyPlan_ = companyPlan.a;
			return $author$project$Api$Plan$ProviderShared(
				$author$project$Api$Provider$CompanyPlan$All$plan(companyPlan_));
		default:
			var companyPlan_ = companyPlan.a;
			return $author$project$Api$Plan$EmployerShared(
				$author$project$Api$Employer$CompanyPlan$All$plan(companyPlan_));
	}
};
var $author$project$Components$ResourceFilter$CompanyPlan$toTitle = A2($elm$core$Basics$composeR, $author$project$Api$CompanyPlan$plan, $author$project$Api$Plan$name);
var $author$project$Components$ResourceFilter$CompanyPlan$toLabel = function (resource) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Components$ResourceFilter$CompanyPlan$toTitle(resource))
		]);
};
var $author$project$Components$ResourceFilter$CompanyPlan$toValue = A2($elm$core$Basics$composeR, $author$project$Api$CompanyPlan$plan, $author$project$Api$Plan$id);
var $author$project$Components$ResourceFilter$CompanyPlan$init = F4(
	function (apiClient, session, companyId, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{
				Sk: A2($author$project$Components$ResourceFilter$CompanyPlan$fetchResources, session, companyId),
				ahP: $author$project$Components$ResourceFilter$CompanyPlan$selectId,
				k$: 'Plan',
				uk: A2($author$project$Components$ResourceFilter$CompanyPlan$retrieveResource, session, companyId),
				u9: $author$project$Components$ResourceFilter$CompanyPlan$toLabel,
				lN: $author$project$Components$ResourceFilter$CompanyPlan$toTitle,
				hX: $author$project$Components$ResourceFilter$CompanyPlan$toValue
			},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{Jy: $author$project$Components$ResourceFilter$All, b8: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$ResourceFilter$LocationGroup$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Components$ResourceFilter$LocationGroup$list = $author$project$Api$Provider$LocationGroup$list;
var $author$project$Components$ResourceFilter$LocationGroup$fetchResources = F4(
	function (toMsg, apiClient, pagination, query) {
		return A3(
			$author$project$Components$ResourceFilter$LocationGroup$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{ajJ: pagination, akl: query});
			},
			toMsg);
	});
var $author$project$Components$ResourceFilter$LocationGroup$retrieveResource = F3(
	function (toMsg, apiClient, id) {
		return A3(
			$author$project$Components$ResourceFilter$LocationGroup$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						ahP: $elm$core$Maybe$Just(id)
					});
			},
			toMsg);
	});
var $author$project$Components$ResourceFilter$LocationGroup$selectId = 'location_groups';
var $author$project$Components$ResourceFilter$LocationGroup$toTitle = $author$project$Api$Provider$LocationGroup$All$name;
var $author$project$Components$ResourceFilter$LocationGroup$toLabel = function (resource) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Components$ResourceFilter$LocationGroup$toTitle(resource))
		]);
};
var $author$project$Components$ResourceFilter$LocationGroup$toValue = $author$project$Api$Provider$LocationGroup$All$id;
var $author$project$Components$ResourceFilter$LocationGroup$init = F2(
	function (apiClient, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{Sk: $author$project$Components$ResourceFilter$LocationGroup$fetchResources, ahP: $author$project$Components$ResourceFilter$LocationGroup$selectId, k$: 'Group', uk: $author$project$Components$ResourceFilter$LocationGroup$retrieveResource, u9: $author$project$Components$ResourceFilter$LocationGroup$toLabel, lN: $author$project$Components$ResourceFilter$LocationGroup$toTitle, hX: $author$project$Components$ResourceFilter$LocationGroup$toValue},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{Jy: $author$project$Components$ResourceFilter$All, b8: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Api$Provider$SignupPage$One$SignupPage = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$SignupPage$One$Record = F3(
	function (practitioners, locations, locationGroups) {
		return {Wa: locationGroups, Wg: locations, Z4: practitioners};
	});
var $author$project$Api$Provider$SignupPage$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'location_groups',
	$elm$json$Json$Decode$list($author$project$Api$Common$LocationGroup$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'locations',
		$elm$json$Json$Decode$list($author$project$Api$Provider$Location$Shared$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'practitioners',
			$elm$json$Json$Decode$list($author$project$Api$Provider$Practitioner$Shared$decoder),
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$SignupPage$One$Record))));
var $author$project$Api$Provider$SignupPage$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$SignupPage$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$SignupPage$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$SignupPage$One$SignupPage)));
var $author$project$Api$Provider$SignupPage$signupPagePath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$SignupPage$signupPagesPath);
};
var $author$project$Api$Provider$SignupPage$retrieve = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$SignupPage$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$SignupPage$signupPagePath(id_)));
	});
var $author$project$Components$Admin$SignupPages$Form$init = F6(
	function (apiClient, session, practice, id, companyId, query) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$Practitioner$init,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						IW: $elm$core$Maybe$Just(true)
					});
			},
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Select a Provider'});
			});
		var practitionerResourceFilter = _v0.a;
		var practitionerResourceFilterCmd = _v0.b;
		var _v1 = function () {
			if (!companyId.$) {
				var id_ = companyId.a;
				return A3(
					$elm$core$Tuple$mapBoth,
					function (companyPlanModel) {
						return $author$project$Components$Admin$SignupPages$Form$CompanyPlan(companyPlanModel);
					},
					function (companyPlanCmd) {
						return A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$Form$CompanyPlanResourceFilterMsg, companyPlanCmd);
					},
					A4(
						$author$project$Components$ResourceFilter$CompanyPlan$init,
						apiClient,
						session,
						id_,
						function (d) {
							return _Utils_update(
								d,
								{Gp: 'Select a Plan'});
						}));
			} else {
				return A3(
					$elm$core$Tuple$mapBoth,
					function (retailModel) {
						return $author$project$Components$Admin$SignupPages$Form$RetailPlan(retailModel);
					},
					function (retailCmd) {
						return A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$Form$PlanResourceFilterMsg, retailCmd);
					},
					A4(
						$author$project$Components$ResourceFilter$Plan$init,
						apiClient,
						session,
						function (d) {
							return _Utils_update(
								d,
								{
									De: _List_fromArray(
										[2, 3])
								});
						},
						function (d) {
							return _Utils_update(
								d,
								{Gp: 'Select a Plan'});
						}));
			}
		}();
		var planResourceFilter = _v1.a;
		var planResourceFilterCmd = _v1.b;
		var _v3 = A4(
			$author$project$Components$ResourceFilter$Location$init,
			apiClient,
			$elm$core$Maybe$Nothing,
			function (d) {
				return _Utils_update(
					d,
					{
						IW: $elm$core$Maybe$Just(true)
					});
			},
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Select a Location'});
			});
		var locationResourceFilter = _v3.a;
		var locationResourceFilterCmd = _v3.b;
		var _v4 = A2(
			$author$project$Components$ResourceFilter$LocationGroup$init,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Select a Location Group'});
			});
		var locationGroupResourceFilter = _v4.a;
		var locationGroupResourceFilterCmd = _v4.b;
		var _v5 = function () {
			if (!id.$) {
				var id_ = id.a;
				return _Utils_Tuple2(
					$elm$core$Maybe$Nothing,
					A3($author$project$Api$Provider$SignupPage$retrieve, apiClient, id_, $author$project$Components$Admin$SignupPages$Form$GotItem));
			} else {
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						$author$project$Utils$Form$init(
							$author$project$Components$Admin$SignupPages$Form$formFieldsInit(companyId))),
					$elm$core$Platform$Cmd$none);
			}
		}();
		var form = _v5.a;
		var cmd = _v5.b;
		var _v7 = A3(
			$author$project$Components$ResourceFilter$ChargeItem$init,
			apiClient,
			$elm$core$Basics$identity,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Select a Charge'});
			});
		var chargeItemResourceFilter = _v7.a;
		var chargeItemResourceFilterCmd = _v7.b;
		return _Utils_Tuple2(
			{cq: chargeItemResourceFilter, fZ: companyId, SD: form, ahP: id, or: locationGroupResourceFilter, os: locationResourceFilter, hi: planResourceFilter, ZV: practice, hk: practitionerResourceFilter, DE: query, k9: $author$project$Api$Data$NotAsked},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						cmd,
						planResourceFilterCmd,
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$Form$ChargeItemResourceFilterMsg, chargeItemResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$Form$PractitionerResourceFilterMsg, practitionerResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$Form$LocationResourceFilterMsg, locationResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$Form$LocationGroupResourceFilterMsg, locationGroupResourceFilterCmd)
					])));
	});
var $author$project$Pages$Admin$SignupPages$Id_String$init = F4(
	function (session, practice, _v0, _v1) {
		var apiClient = _v0.Gv;
		var params = _v1.YL;
		var query = _v1.DE;
		var _v2 = A6(
			$author$project$Components$Admin$SignupPages$Form$init,
			apiClient,
			session,
			practice,
			$elm$core$Maybe$Just(params.ahP),
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Just(query));
		var form = _v2.a;
		var cmd = _v2.b;
		return _Utils_Tuple2(
			{Gv: apiClient, SD: form},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
	});
var $author$project$Pages$Admin$SignupPages$Id_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$SignupPages$Id_String$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$ResourceFilter$CompanyPlan$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.b8));
};
var $author$project$Components$ResourceFilter$LocationGroup$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.b8));
};
var $author$project$Components$Admin$SignupPages$Form$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				function () {
				var _v1 = model.hi;
				if (_v1.$ === 1) {
					var companyPlanFilter = _v1.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Components$Admin$SignupPages$Form$CompanyPlanResourceFilterMsg,
						$author$project$Components$ResourceFilter$CompanyPlan$subscriptions(companyPlanFilter));
				} else {
					var planResourceFilter = _v1.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Components$Admin$SignupPages$Form$PlanResourceFilterMsg,
						$author$project$Components$ResourceFilter$Plan$subscriptions(planResourceFilter));
				}
			}(),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Admin$SignupPages$Form$LocationGroupResourceFilterMsg,
				$author$project$Components$ResourceFilter$LocationGroup$subscriptions(model.or)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Admin$SignupPages$Form$PractitionerResourceFilterMsg,
				$author$project$Components$ResourceFilter$Practitioner$subscriptions(model.hk)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Admin$SignupPages$Form$ChargeItemResourceFilterMsg,
				$author$project$Components$ResourceFilter$ChargeItem$subscriptions(model.cq)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Admin$SignupPages$Form$LocationResourceFilterMsg,
				$author$project$Components$ResourceFilter$Location$subscriptions(model.os))
			]));
};
var $author$project$Pages$Admin$SignupPages$Id_String$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Admin$SignupPages$Form$subscriptions(model.SD));
};
var $author$project$Components$Admin$SignupPages$Form$ChargeItem = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$CompanyPlanAdd = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$LocationAdd = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$LocationGroupAdd = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$PlanAdd = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$PractitionerAdd = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Provider$Practice$One$addons = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.K1;
	});
var $author$project$Api$Provider$SignupPage$Shared$chargeItem = function (_v0) {
	var record = _v0;
	return record.mL;
};
var $author$project$Api$Provider$SignupPage$One$chargeItem = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$SignupPage$Shared$chargeItem(shared);
};
var $author$project$Api$Provider$SignupPage$Shared$active = function (_v0) {
	var record = _v0;
	return record.KN;
};
var $author$project$Api$Provider$SignupPage$One$active = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$SignupPage$Shared$active(shared);
};
var $author$project$Api$Provider$SignupPage$Shared$addons = function (_v0) {
	var record = _v0;
	return record.K1;
};
var $author$project$Api$Provider$SignupPage$One$addons = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$SignupPage$Shared$addons(shared);
};
var $author$project$Api$Provider$Addon$Min$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Addon$Shared$id = function (_v0) {
	var min = _v0;
	return $author$project$Api$Provider$Addon$Min$id(min);
};
var $author$project$Api$Provider$SignupPagePlan$Shared$id = function (_v0) {
	var shared = _v0;
	return shared.ahP;
};
var $author$project$Api$Provider$SignupPage$Shared$limitAvailableLocationGroups = function (_v0) {
	var record = _v0;
	return record.V_;
};
var $author$project$Api$Provider$SignupPage$One$limitAvailableLocationGroups = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$SignupPage$Shared$limitAvailableLocationGroups(shared);
};
var $author$project$Api$Provider$SignupPage$Shared$limitAvailableLocations = function (_v0) {
	var record = _v0;
	return record.V$;
};
var $author$project$Api$Provider$SignupPage$One$limitAvailableLocations = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$SignupPage$Shared$limitAvailableLocations(shared);
};
var $author$project$Api$Provider$SignupPage$Shared$limitAvailablePractitioners = function (_v0) {
	var record = _v0;
	return record.V0;
};
var $author$project$Api$Provider$SignupPage$One$limitAvailablePractitioners = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$SignupPage$Shared$limitAvailablePractitioners(shared);
};
var $author$project$Api$Provider$SignupPage$One$locationGroups = function (_v0) {
	var record = _v0.b;
	return record.Wa;
};
var $author$project$Api$Provider$SignupPage$One$locations = function (_v0) {
	var record = _v0.b;
	return record.Wg;
};
var $author$project$Api$Provider$Addon$Min$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$Addon$Shared$name = function (_v0) {
	var min = _v0;
	return $author$project$Api$Provider$Addon$Min$name(min);
};
var $author$project$Api$Provider$SignupPagePlan$Shared$plan = function (_v0) {
	var shared = _v0;
	return shared.Jb;
};
var $author$project$Api$Provider$SignupPage$Shared$postSignupButtonLabel = function (_v0) {
	var record = _v0;
	return record.ZR;
};
var $author$project$Api$Provider$SignupPage$One$postSignupButtonLabel = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$SignupPage$Shared$postSignupButtonLabel(shared);
};
var $author$project$Api$Provider$SignupPage$Shared$postSignupMessage = function (_v0) {
	var record = _v0;
	return record.ZS;
};
var $author$project$Api$Provider$SignupPage$One$postSignupMessage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$SignupPage$Shared$postSignupMessage(shared);
};
var $author$project$Api$Provider$SignupPage$Shared$postSignupRedirectUrl = function (_v0) {
	var record = _v0;
	return record.ZT;
};
var $author$project$Api$Provider$SignupPage$One$postSignupRedirectUrl = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$SignupPage$Shared$postSignupRedirectUrl(shared);
};
var $author$project$Api$Provider$SignupPage$One$practitioners = function (_v0) {
	var record = _v0.b;
	return record.Z4;
};
var $author$project$Api$Provider$SignupPage$Shared$redirectsPostSignup = function (_v0) {
	var record = _v0;
	return record.$l;
};
var $author$project$Api$Provider$SignupPage$One$redirectsPostSignup = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$SignupPage$Shared$redirectsPostSignup(shared);
};
var $author$project$Api$Provider$SignupPage$Shared$showPostSignupFooterButton = function (_v0) {
	var record = _v0;
	return record.abp;
};
var $author$project$Api$Provider$SignupPage$One$showPostSignupFooterButton = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$SignupPage$Shared$showPostSignupFooterButton(shared);
};
var $author$project$Api$Provider$SignupPage$Shared$signupPagePlans = function (_v0) {
	var record = _v0;
	return record.abz;
};
var $author$project$Api$Provider$SignupPage$One$signupPagePlans = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$SignupPage$Shared$signupPagePlans(shared);
};
var $author$project$Api$Provider$SignupPage$Shared$slug = function (_v0) {
	var record = _v0;
	return record.abG;
};
var $author$project$Api$Provider$SignupPage$One$slug = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$SignupPage$Shared$slug(shared);
};
var $author$project$Api$Provider$SignupPage$Shared$type_ = function (_v0) {
	var record = _v0;
	return record.amg;
};
var $author$project$Api$Provider$SignupPage$One$type_ = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$SignupPage$Shared$type_(shared);
};
var $author$project$Api$Provider$SignupPage$Shared$useCustomSettings = function (_v0) {
	var record = _v0;
	return record.adZ;
};
var $author$project$Api$Provider$SignupPage$One$useCustomSettings = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$SignupPage$Shared$useCustomSettings(shared);
};
var $author$project$Components$Admin$SignupPages$Form$formFieldsFromItem = F2(
	function (item, companyId) {
		return {
			KN: $author$project$Api$Provider$SignupPage$One$active(item),
			K1: A2(
				$elm$core$List$map,
				function (addon) {
					return {
						ahP: $author$project$Api$Provider$Addon$Shared$id(addon),
						Bq: $author$project$Api$Provider$Addon$Shared$name(addon)
					};
				},
				$author$project$Api$Provider$SignupPage$One$addons(item)),
			mL: A2(
				$elm$core$Maybe$map,
				function (chargeItem) {
					return {
						ahP: $author$project$Api$Provider$ChargeItem$Min$id(chargeItem),
						Bq: $author$project$Api$Provider$ChargeItem$Min$name(chargeItem),
						acZ: false
					};
				},
				$author$project$Api$Provider$SignupPage$One$chargeItem(item)),
			fZ: companyId,
			V_: $author$project$Api$Provider$SignupPage$One$limitAvailableLocationGroups(item),
			V$: $author$project$Api$Provider$SignupPage$One$limitAvailableLocations(item),
			V0: $author$project$Api$Provider$SignupPage$One$limitAvailablePractitioners(item),
			Wa: A2(
				$elm$core$List$map,
				function (locationGroup) {
					return {
						ahP: $author$project$Api$Common$LocationGroup$Shared$id(locationGroup),
						Bq: $author$project$Api$Common$LocationGroup$Shared$name(locationGroup)
					};
				},
				$author$project$Api$Provider$SignupPage$One$locationGroups(item)),
			Wg: A2(
				$elm$core$List$map,
				function (location) {
					return {
						ahP: $author$project$Api$Provider$Location$Shared$id(location),
						Bq: $author$project$Api$Provider$Location$Shared$name(location)
					};
				},
				$author$project$Api$Provider$SignupPage$One$locations(item)),
			ZR: $author$project$Api$Provider$SignupPage$One$postSignupButtonLabel(item),
			ZS: $author$project$Api$Provider$SignupPage$One$postSignupMessage(item),
			ZT: $author$project$Api$Provider$SignupPage$One$postSignupRedirectUrl(item),
			Z4: A2(
				$elm$core$List$map,
				function (practitioner) {
					return {
						ahP: $author$project$Api$Provider$Practitioner$Shared$id(practitioner),
						Bq: $author$project$Api$Provider$Practitioner$Shared$name(practitioner)
					};
				},
				$author$project$Api$Provider$SignupPage$One$practitioners(item)),
			$l: $author$project$Api$Provider$SignupPage$One$redirectsPostSignup(item),
			abp: $author$project$Api$Provider$SignupPage$One$showPostSignupFooterButton(item),
			abz: A2(
				$elm$core$List$map,
				function (signupPagePlan) {
					return {
						ahP: $elm$core$Maybe$Just(
							$author$project$Api$Provider$SignupPagePlan$Shared$id(signupPagePlan)),
						aj4: $author$project$Api$Provider$Plan$Min$id(
							$author$project$Api$Provider$SignupPagePlan$Shared$plan(signupPagePlan)),
						ZE: $author$project$Api$Provider$Plan$Min$name(
							$author$project$Api$Provider$SignupPagePlan$Shared$plan(signupPagePlan))
					};
				},
				$author$project$Api$Provider$SignupPage$One$signupPagePlans(item)),
			abG: $author$project$Api$Provider$SignupPage$One$slug(item),
			amg: $author$project$Api$Provider$SignupPage$One$type_(item),
			adZ: $author$project$Api$Provider$SignupPage$One$useCustomSettings(item)
		};
	});
var $author$project$Formatters$String$slugify = function (string) {
	return A3(
		$author$project$Utils$Regex$replace,
		'-+$',
		'',
		A3(
			$author$project$Utils$Regex$replace,
			'^-+',
			'',
			A3(
				$author$project$Utils$Regex$replace,
				'\\-\\-+',
				'-',
				A3(
					$author$project$Utils$Regex$replace,
					'[^\\w\\-]+',
					'',
					A3(
						$author$project$Utils$Regex$replace,
						'\\s+',
						'-',
						$elm$core$String$toLower(string))))));
};
var $author$project$Components$Admin$SignupPages$Form$defaultSlug = F2(
	function (signupPagePlans, currentSlug) {
		var _v0 = _Utils_Tuple2(
			$elm$core$List$length(signupPagePlans),
			$elm$core$List$head(signupPagePlans));
		if ((_v0.a === 1) && (!_v0.b.$)) {
			var signupPagePlan = _v0.b.a;
			return $author$project$Formatters$String$slugify(signupPagePlan.ZE);
		} else {
			return currentSlug;
		}
	});
var $author$project$Components$Admin$SignupPages$Form$formFieldsUpdate = F3(
	function (addons, field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{amg: string});
			case 1:
				var plan = field.a;
				var plan_ = A2(
					$elm_community$list_extra$List$Extra$find,
					function (plan__) {
						return _Utils_eq(
							plan__.aj4,
							$author$project$Api$Plan$id(plan));
					},
					fields.abz);
				var signupPagePlans = function () {
					if (!plan_.$) {
						return fields.abz;
					} else {
						return A2(
							$elm$core$List$cons,
							{
								ahP: $elm$core$Maybe$Nothing,
								aj4: $author$project$Api$Plan$id(plan),
								ZE: $author$project$Api$Plan$name(plan)
							},
							fields.abz);
					}
				}();
				return _Utils_update(
					fields,
					{
						abz: signupPagePlans,
						abG: A2($author$project$Components$Admin$SignupPages$Form$defaultSlug, signupPagePlans, fields.abG)
					});
			case 2:
				var companyPlan = field.a;
				var plan = $author$project$Api$CompanyPlan$plan(companyPlan);
				var signupPagePlan = A2(
					$elm_community$list_extra$List$Extra$find,
					function (signupPagePlan_) {
						return _Utils_eq(
							signupPagePlan_.aj4,
							$author$project$Api$Plan$id(plan));
					},
					fields.abz);
				var signupPagePlans = function () {
					if (!signupPagePlan.$) {
						return fields.abz;
					} else {
						return A2(
							$elm$core$List$cons,
							{
								ahP: $elm$core$Maybe$Nothing,
								aj4: $author$project$Api$Plan$id(plan),
								ZE: $author$project$Api$Plan$name(plan)
							},
							fields.abz);
					}
				}();
				var newSlug = $elm$core$String$isEmpty(fields.abG) ? A2($author$project$Components$Admin$SignupPages$Form$defaultSlug, signupPagePlans, fields.abG) : fields.abG;
				return _Utils_update(
					fields,
					{abz: signupPagePlans, abG: newSlug});
			case 3:
				var id = field.a;
				return _Utils_update(
					fields,
					{
						abz: A2(
							$elm_community$list_extra$List$Extra$filterNot,
							function (signupPagePlan) {
								return _Utils_eq(signupPagePlan.aj4, id);
							},
							fields.abz)
					});
			case 4:
				var chargeItem = field.a;
				return _Utils_update(
					fields,
					{
						mL: A2(
							$elm$core$Maybe$map,
							function (chargeItem_) {
								return {ahP: chargeItem_.ahP, Bq: chargeItem_.Bq, acZ: chargeItem_.acZ};
							},
							chargeItem)
					});
			case 5:
				var string = field.a;
				return _Utils_update(
					fields,
					{abG: string});
			case 6:
				var bool = field.a;
				return _Utils_update(
					fields,
					{KN: bool});
			case 7:
				var id = field.a;
				var addon = A2(
					$elm_community$list_extra$List$Extra$find,
					function (addon_) {
						return _Utils_eq(
							$author$project$Api$Provider$Addon$Min$id(addon_),
							id);
					},
					addons);
				var addons_ = function () {
					if (!addon.$) {
						var addon_ = addon.a;
						return A2(
							$elm$core$List$cons,
							{
								ahP: $author$project$Api$Provider$Addon$Min$id(addon_),
								Bq: $author$project$Api$Provider$Addon$Min$name(addon_)
							},
							fields.K1);
					} else {
						return fields.K1;
					}
				}();
				return _Utils_update(
					fields,
					{K1: addons_});
			case 8:
				var id = field.a;
				return _Utils_update(
					fields,
					{
						K1: A2(
							$elm_community$list_extra$List$Extra$filterNot,
							function (addon) {
								return _Utils_eq(addon.ahP, id);
							},
							fields.K1)
					});
			case 9:
				var bool = field.a;
				return _Utils_update(
					fields,
					{V0: bool});
			case 10:
				var practitioner = field.a;
				var practitioner_ = A2(
					$elm_community$list_extra$List$Extra$find,
					function (practitioner__) {
						return _Utils_eq(practitioner__.ahP, practitioner.ahP);
					},
					fields.Z4);
				var practitioners = function () {
					if (!practitioner_.$) {
						return fields.Z4;
					} else {
						return A2(
							$elm$core$List$cons,
							{ahP: practitioner.ahP, Bq: practitioner.Bq},
							fields.Z4);
					}
				}();
				return _Utils_update(
					fields,
					{Z4: practitioners});
			case 11:
				var id = field.a;
				return _Utils_update(
					fields,
					{
						Z4: A2(
							$elm_community$list_extra$List$Extra$filterNot,
							function (practitioner) {
								return _Utils_eq(practitioner.ahP, id);
							},
							fields.Z4)
					});
			case 12:
				var bool = field.a;
				return _Utils_update(
					fields,
					{V$: bool});
			case 13:
				var bool = field.a;
				return _Utils_update(
					fields,
					{V_: bool});
			case 14:
				var location = field.a;
				var location_ = A2(
					$elm_community$list_extra$List$Extra$find,
					function (location__) {
						return _Utils_eq(location__.ahP, location.ahP);
					},
					fields.Wg);
				var locations = function () {
					if (!location_.$) {
						return fields.Wg;
					} else {
						return A2(
							$elm$core$List$cons,
							{ahP: location.ahP, Bq: location.Bq},
							fields.Wg);
					}
				}();
				return _Utils_update(
					fields,
					{Wg: locations});
			case 15:
				var locationGroup = field.a;
				var locationGroup_ = A2(
					$elm_community$list_extra$List$Extra$find,
					function (locationGroup__) {
						return _Utils_eq(
							locationGroup__.ahP,
							$author$project$Api$Provider$LocationGroup$All$id(locationGroup));
					},
					fields.Wa);
				var locationGroups = function () {
					if (!locationGroup_.$) {
						return fields.Wa;
					} else {
						return A2(
							$elm$core$List$cons,
							{
								ahP: $author$project$Api$Provider$LocationGroup$All$id(locationGroup),
								Bq: $author$project$Api$Provider$LocationGroup$All$name(locationGroup)
							},
							fields.Wa);
					}
				}();
				return _Utils_update(
					fields,
					{Wa: locationGroups});
			case 16:
				var id = field.a;
				return _Utils_update(
					fields,
					{
						Wg: A2(
							$elm_community$list_extra$List$Extra$filterNot,
							function (location) {
								return _Utils_eq(location.ahP, id);
							},
							fields.Wg)
					});
			case 17:
				var id = field.a;
				return _Utils_update(
					fields,
					{
						Wa: A2(
							$elm_community$list_extra$List$Extra$filterNot,
							function (locationGroup) {
								return _Utils_eq(locationGroup.ahP, id);
							},
							fields.Wa)
					});
			case 18:
				var bool = field.a;
				return _Utils_update(
					fields,
					{adZ: bool});
			case 19:
				var bool = field.a;
				return _Utils_update(
					fields,
					{$l: bool});
			case 20:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						ZT: $author$project$Utils$String$toMaybe(string)
					});
			case 21:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						ZS: $author$project$Utils$String$toMaybe(string)
					});
			case 22:
				var bool = field.a;
				return _Utils_update(
					fields,
					{abp: bool});
			default:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						ZR: $author$project$Utils$String$toMaybe(string)
					});
		}
	});
var $author$project$Components$Admin$SignupPages$Form$SlugValidation = 0;
var $author$project$Utils$Validate$ifShorterThan = F3(
	function (subjectToString, min, error) {
		return A2(
			$rtfeldman$elm_validate$Validate$ifTrue,
			function (subject) {
				return _Utils_cmp(
					$elm$core$String$length(
						subjectToString(subject)),
					min) < 0;
			},
			error);
	});
var $author$project$Components$Admin$SignupPages$Form$ChargeItemValidation = 2;
var $author$project$Components$Admin$SignupPages$Form$validateChargeItem = function (fields) {
	var _v0 = _Utils_Tuple2(fields.amg, fields.mL);
	if (_v0.a === 'checkout') {
		if (!_v0.b.$) {
			var chargeItem = _v0.b.a;
			return chargeItem.acZ ? _List_fromArray(
				[
					_Utils_Tuple2(2, 'We are unable to support collecting sales tax through checkout pages due to the complexity of sales & use tax laws throughout the country. Please select a different item for your signup page.')
				]) : _List_Nil;
		} else {
			var _v1 = _v0.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(2, 'Please pick a charge')
				]);
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Admin$SignupPages$Form$PostSignupRedirectUrlValidation = 3;
var $author$project$Utils$Validate$isInvalidUrl = function (url) {
	return $elm$core$String$isEmpty(url) ? false : (!(A2($elm$core$String$startsWith, 'http://', url) || A2($elm$core$String$startsWith, 'https://', url)));
};
var $author$project$Components$Admin$SignupPages$Form$validatePostSignupRedirectUrl = function (fields) {
	var _v0 = _Utils_Tuple2(fields.$l, fields.ZT);
	if (_v0.b.$ === 1) {
		if (_v0.a) {
			var _v1 = _v0.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(3, 'Please enter an url')
				]);
		} else {
			var _v2 = _v0.b;
			return _List_Nil;
		}
	} else {
		var postSignupRedirectUrl = _v0.b.a;
		return $author$project$Utils$Validate$isInvalidUrl(postSignupRedirectUrl) ? _List_fromArray(
			[
				_Utils_Tuple2(3, 'URL must start with http:// or https://')
			]) : _List_Nil;
	}
};
var $author$project$Components$Admin$SignupPages$Form$SignupPagePlansValidation = 1;
var $author$project$Components$Admin$SignupPages$Form$validateSignupPagePlans = function (fields) {
	var _v0 = _Utils_Tuple2(
		fields.amg,
		$elm$core$List$isEmpty(fields.abz));
	if ((_v0.a === 'signup') && _v0.b) {
		return _List_fromArray(
			[
				_Utils_Tuple2(1, 'Please select at least one plan')
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Admin$SignupPages$Form$validateSlugPattern = function (fields) {
	return $elm$core$String$isEmpty(fields.abG) ? _List_Nil : (A2($author$project$Utils$Regex$matches, '^[a-z0-9](?:-?[a-z0-9])*$', fields.abG) ? _List_Nil : _List_fromArray(
		[
			_Utils_Tuple2(0, 'Must have only lowercase letters, numbers and dashes')
		]));
};
var $author$project$Components$Admin$SignupPages$Form$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$SignupPages$Form$validateSignupPagePlans),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$SignupPages$Form$validateChargeItem),
			A3(
			$author$project$Utils$Validate$ifShorterThan,
			function ($) {
				return $.abG;
			},
			4,
			_Utils_Tuple2(0, 'Must be 4 or more letters')),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$SignupPages$Form$validateSlugPattern),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$SignupPages$Form$validatePostSignupRedirectUrl)
		]));
var $author$project$Components$Admin$SignupPages$Form$Created = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$SignupPage$create = F3(
	function (apiClient, fields, toMsg) {
		var encodeSignupPagePlan = function (signupPagePlan) {
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'id',
						A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, signupPagePlan.ahP)),
						_Utils_Tuple2(
						'plan',
						$author$project$Utils$Encode$association(signupPagePlan.aj4))
					]));
		};
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'signup_page',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'active',
								$elm$json$Json$Encode$bool(fields.KN)),
								_Utils_Tuple2(
								'slug',
								$elm$json$Json$Encode$string(fields.abG)),
								_Utils_Tuple2(
								'use_custom_settings',
								$elm$json$Json$Encode$bool(fields.adZ)),
								_Utils_Tuple2(
								'post_signup_message',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ZS)),
								_Utils_Tuple2(
								'post_signup_redirect_url',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ZT)),
								_Utils_Tuple2(
								'post_signup_button_label',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ZR)),
								_Utils_Tuple2(
								'redirects_post_signup',
								$elm$json$Json$Encode$bool(fields.$l)),
								_Utils_Tuple2(
								'show_post_signup_footer_button',
								$elm$json$Json$Encode$bool(fields.abp)),
								_Utils_Tuple2(
								'limit_available_practitioners',
								$elm$json$Json$Encode$bool(fields.V0)),
								_Utils_Tuple2(
								'limit_available_locations',
								$elm$json$Json$Encode$bool(fields.V$)),
								_Utils_Tuple2(
								'limit_available_location_groups',
								$elm$json$Json$Encode$bool(fields.V_)),
								_Utils_Tuple2(
								'charge_item',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.mL)),
								_Utils_Tuple2(
								'signup_page_plans',
								A2($elm$json$Json$Encode$list, encodeSignupPagePlan, fields.abz)),
								_Utils_Tuple2(
								'addons',
								A2(
									$elm$json$Json$Encode$list,
									A2(
										$elm$core$Basics$composeL,
										$author$project$Utils$Encode$association,
										function ($) {
											return $.ahP;
										}),
									fields.K1)),
								_Utils_Tuple2(
								'practitioners',
								A2($elm$json$Json$Encode$list, $author$project$Utils$Encode$association, fields.Z4)),
								_Utils_Tuple2(
								'locations',
								A2($elm$json$Json$Encode$list, $author$project$Utils$Encode$association, fields.Wg)),
								_Utils_Tuple2(
								'location_groups',
								A2($elm$json$Json$Encode$list, $author$project$Utils$Encode$association, fields.Wa)),
								_Utils_Tuple2(
								'company',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.afQ))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$SignupPage$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$SignupPage$signupPagesPath)));
	});
var $author$project$Components$Admin$SignupPages$Form$signupFormFields = function (fields) {
	return {
		KN: fields.KN,
		K1: A2(
			$elm$core$List$map,
			function (addon) {
				return {ahP: addon.ahP};
			},
			fields.K1),
		mL: A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.ahP;
			},
			fields.mL),
		afQ: fields.fZ,
		V_: fields.V_,
		V$: fields.V$,
		V0: fields.V0,
		Wa: A2(
			$elm$core$List$map,
			function ($) {
				return $.ahP;
			},
			fields.Wa),
		Wg: A2(
			$elm$core$List$map,
			function ($) {
				return $.ahP;
			},
			fields.Wg),
		ZR: fields.ZR,
		ZS: fields.ZS,
		ZT: fields.ZT,
		Z4: A2(
			$elm$core$List$map,
			function ($) {
				return $.ahP;
			},
			fields.Z4),
		$l: fields.$l,
		abp: fields.abp,
		abz: A2(
			$elm$core$List$map,
			function (signupPagePlan) {
				return {ahP: signupPagePlan.ahP, aj4: signupPagePlan.aj4};
			},
			fields.abz),
		abG: fields.abG,
		adZ: fields.adZ
	};
};
var $author$project$Components$Admin$SignupPages$Form$createItem = F2(
	function (apiClient, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A3(
			$author$project$Api$Provider$SignupPage$create,
			apiClient,
			$author$project$Components$Admin$SignupPages$Form$signupFormFields(fields),
			$author$project$Components$Admin$SignupPages$Form$Created);
	});
var $author$project$Components$Admin$SignupPages$Form$Updated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$SignupPage$update = F4(
	function (apiClient, id_, fields, toMsg) {
		var encodeSignupPagePlan = function (signupPagePlan) {
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'id',
						A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, signupPagePlan.ahP)),
						_Utils_Tuple2(
						'plan',
						$author$project$Utils$Encode$association(signupPagePlan.aj4))
					]));
		};
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'signup_page',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'active',
								$elm$json$Json$Encode$bool(fields.KN)),
								_Utils_Tuple2(
								'slug',
								$elm$json$Json$Encode$string(fields.abG)),
								_Utils_Tuple2(
								'use_custom_settings',
								$elm$json$Json$Encode$bool(fields.adZ)),
								_Utils_Tuple2(
								'post_signup_message',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ZS)),
								_Utils_Tuple2(
								'post_signup_redirect_url',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ZT)),
								_Utils_Tuple2(
								'post_signup_button_label',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ZR)),
								_Utils_Tuple2(
								'redirects_post_signup',
								$elm$json$Json$Encode$bool(fields.$l)),
								_Utils_Tuple2(
								'show_post_signup_footer_button',
								$elm$json$Json$Encode$bool(fields.abp)),
								_Utils_Tuple2(
								'limit_available_practitioners',
								$elm$json$Json$Encode$bool(fields.V0)),
								_Utils_Tuple2(
								'limit_available_locations',
								$elm$json$Json$Encode$bool(fields.V$)),
								_Utils_Tuple2(
								'limit_available_location_groups',
								$elm$json$Json$Encode$bool(fields.V_)),
								_Utils_Tuple2(
								'charge_item',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.mL)),
								_Utils_Tuple2(
								'signup_page_plans',
								A2($elm$json$Json$Encode$list, encodeSignupPagePlan, fields.abz)),
								_Utils_Tuple2(
								'addons',
								A2(
									$elm$json$Json$Encode$list,
									A2(
										$elm$core$Basics$composeL,
										$author$project$Utils$Encode$association,
										function ($) {
											return $.ahP;
										}),
									fields.K1)),
								_Utils_Tuple2(
								'practitioners',
								A2($elm$json$Json$Encode$list, $author$project$Utils$Encode$association, fields.Z4)),
								_Utils_Tuple2(
								'locations',
								A2($elm$json$Json$Encode$list, $author$project$Utils$Encode$association, fields.Wg)),
								_Utils_Tuple2(
								'location_groups',
								A2($elm$json$Json$Encode$list, $author$project$Utils$Encode$association, fields.Wa)),
								_Utils_Tuple2(
								'company',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.afQ))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$SignupPage$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$SignupPage$signupPagePath(id_))));
	});
var $author$project$Components$Admin$SignupPages$Form$updateItem = F3(
	function (apiClient, id, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4(
			$author$project$Api$Provider$SignupPage$update,
			apiClient,
			id,
			$author$project$Components$Admin$SignupPages$Form$signupFormFields(fields),
			$author$project$Components$Admin$SignupPages$Form$Updated);
	});
var $author$project$Components$Admin$SignupPages$Form$saveItem = F3(
	function (apiClient, id, formFields) {
		if (!id.$) {
			var id_ = id.a;
			return A3($author$project$Components$Admin$SignupPages$Form$updateItem, apiClient, id_, formFields);
		} else {
			return A2($author$project$Components$Admin$SignupPages$Form$createItem, apiClient, formFields);
		}
	});
var $author$project$Components$Admin$SignupPages$Form$saveRoute = function (companyId) {
	if (!companyId.$) {
		var id_ = companyId.a;
		return $author$project$Spa$Generated$Route$Companies__CompanyId_String__Signup(
			{fZ: id_});
	} else {
		return $author$project$Spa$Generated$Route$Admin__SignupPages__Top;
	}
};
var $author$project$Components$ResourceFilter$CompanyPlan$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.b8);
		var modelAfterEvent = function () {
			var _v1 = result.agZ;
			if (!_v1.$) {
				var selected = _v1.a;
				return _Utils_update(
					model,
					{Jy: selected});
			} else {
				return model;
			}
		}();
		return {
			GZ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.GZ),
			agZ: result.agZ,
			aiO: _Utils_update(
				modelAfterEvent,
				{b8: result.aiO}),
			aR: result.aR
		};
	});
var $author$project$Components$ResourceFilter$LocationGroup$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.b8);
		var modelAfterEvent = function () {
			var _v1 = result.agZ;
			if (!_v1.$) {
				var selected = _v1.a;
				return _Utils_update(
					model,
					{Jy: selected});
			} else {
				return model;
			}
		}();
		return {
			GZ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.GZ),
			agZ: result.agZ,
			aiO: _Utils_update(
				modelAfterEvent,
				{b8: result.aiO}),
			aR: result.aR
		};
	});
var $author$project$Components$Admin$SignupPages$Form$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var signupPage = response.a;
					var chargeItem = $author$project$Api$Provider$SignupPage$One$chargeItem(signupPage);
					var _v3 = A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Components$ResourceFilter$ChargeItem$extraItems(
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function (chargeItem_) {
										return _List_fromArray(
											[
												{
												ahP: $author$project$Api$Provider$ChargeItem$Min$id(chargeItem_),
												Bq: $author$project$Api$Provider$ChargeItem$Min$name(chargeItem_)
											}
											]);
									},
									chargeItem))),
						A2(
							$author$project$Components$ResourceFilter$ChargeItem$preSelectedId,
							A2($elm$core$Maybe$map, $author$project$Api$Provider$ChargeItem$Min$id, chargeItem),
							model.cq));
					var chargeItemResourceFilter = _v3.a;
					var chargeItemResourceFilterCmd = _v3.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cq: chargeItemResourceFilter,
								SD: $elm$core$Maybe$Just(
									$author$project$Utils$Form$init(
										A2($author$project$Components$Admin$SignupPages$Form$formFieldsFromItem, signupPage, model.fZ)))
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$Form$ChargeItemResourceFilterMsg, chargeItemResourceFilterCmd),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$reportDecodeError(response));
				}
			case 2:
				var _v4 = model.SD;
				if (!_v4.$) {
					var form = _v4.a;
					var _v5 = A2($author$project$Utils$Form$validate, $author$project$Components$Admin$SignupPages$Form$formFieldsValidator, form);
					if (!_v5.$) {
						var _v6 = _v5.a;
						var newForm = _v6.a;
						var validFormFields = _v6.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									SD: $elm$core$Maybe$Just(newForm),
									k9: $author$project$Api$Data$Loading
								}),
							A3($author$project$Components$Admin$SignupPages$Form$saveItem, apiClient, model.ahP, validFormFields),
							_List_Nil);
					} else {
						var newForm = _v5.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									SD: $elm$core$Maybe$Just(newForm),
									k9: $author$project$Api$Data$NotAsked
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 1:
				var field = msg.a;
				var _v7 = model.SD;
				if (!_v7.$) {
					var form = _v7.a;
					var newForm = A3(
						$author$project$Utils$Form$update,
						$author$project$Components$Admin$SignupPages$Form$formFieldsUpdate(
							$author$project$Api$Provider$Practice$One$addons(model.ZV)),
						field,
						form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								SD: $elm$core$Maybe$Just(newForm)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: response}),
						A2(
							$author$project$Utils$Route$navigate,
							$elm$core$Dict$empty,
							$author$project$Components$Admin$SignupPages$Form$saveRoute(model.fZ)),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Successfully created page')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					var queryParams = A2($elm$core$Maybe$withDefault, $elm$core$Dict$empty, model.DE);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: response}),
						A2(
							$author$project$Utils$Route$navigate,
							queryParams,
							$author$project$Components$Admin$SignupPages$Form$saveRoute(model.fZ)),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Page was successfully updated.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 5:
				var subMsg = msg.a;
				var _v10 = model.hi;
				if (!_v10.$) {
					var resourceFilter = _v10.a;
					var planResourceResult = A3($author$project$Components$ResourceFilter$Plan$update, apiClient, subMsg, resourceFilter);
					var newForm = function () {
						var _v11 = planResourceResult.agZ;
						if ((!_v11.$) && (!_v11.a.$)) {
							var plan = _v11.a.a;
							return A2(
								$elm$core$Maybe$map,
								A2(
									$author$project$Utils$Form$update,
									$author$project$Components$Admin$SignupPages$Form$formFieldsUpdate(
										$author$project$Api$Provider$Practice$One$addons(model.ZV)),
									$author$project$Components$Admin$SignupPages$Form$PlanAdd(plan)),
								model.SD);
						} else {
							return model.SD;
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								SD: newForm,
								hi: $author$project$Components$Admin$SignupPages$Form$RetailPlan(planResourceResult.aiO)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$Form$PlanResourceFilterMsg, planResourceResult.GZ),
						planResourceResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var subMsg = msg.a;
				var _v12 = model.hi;
				if (_v12.$ === 1) {
					var resourceFilter = _v12.a;
					var planResourceResult = A3($author$project$Components$ResourceFilter$CompanyPlan$update, apiClient, subMsg, resourceFilter);
					var newForm = function () {
						var _v13 = planResourceResult.agZ;
						if ((!_v13.$) && (!_v13.a.$)) {
							var companyPlan = _v13.a.a;
							return A2(
								$elm$core$Maybe$map,
								A2(
									$author$project$Utils$Form$update,
									$author$project$Components$Admin$SignupPages$Form$formFieldsUpdate(
										$author$project$Api$Provider$Practice$One$addons(model.ZV)),
									$author$project$Components$Admin$SignupPages$Form$CompanyPlanAdd(companyPlan)),
								model.SD);
						} else {
							return model.SD;
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								SD: newForm,
								hi: $author$project$Components$Admin$SignupPages$Form$CompanyPlan(planResourceResult.aiO)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$Form$CompanyPlanResourceFilterMsg, planResourceResult.GZ),
						planResourceResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var subMsg = msg.a;
				var chargeItemResourceResult = A3($author$project$Components$ResourceFilter$ChargeItem$update, apiClient, subMsg, model.cq);
				var newForm = function () {
					var _v14 = chargeItemResourceResult.agZ;
					_v14$2:
					while (true) {
						if (!_v14.$) {
							switch (_v14.a.$) {
								case 0:
									var chargeItem = _v14.a.a;
									return A2(
										$elm$core$Maybe$map,
										A2(
											$author$project$Utils$Form$update,
											$author$project$Components$Admin$SignupPages$Form$formFieldsUpdate(
												$author$project$Api$Provider$Practice$One$addons(model.ZV)),
											$author$project$Components$Admin$SignupPages$Form$ChargeItem(
												$elm$core$Maybe$Just(chargeItem))),
										model.SD);
								case 2:
									var _v15 = _v14.a;
									return A2(
										$elm$core$Maybe$map,
										A2(
											$author$project$Utils$Form$update,
											$author$project$Components$Admin$SignupPages$Form$formFieldsUpdate(
												$author$project$Api$Provider$Practice$One$addons(model.ZV)),
											$author$project$Components$Admin$SignupPages$Form$ChargeItem($elm$core$Maybe$Nothing)),
										model.SD);
								default:
									break _v14$2;
							}
						} else {
							break _v14$2;
						}
					}
					return model.SD;
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cq: chargeItemResourceResult.aiO, SD: newForm}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$Form$ChargeItemResourceFilterMsg, chargeItemResourceResult.GZ),
					chargeItemResourceResult.aR);
			case 8:
				var subMsg = msg.a;
				var practitionerResourceResult = A3($author$project$Components$ResourceFilter$Practitioner$update, apiClient, subMsg, model.hk);
				var newForm = function () {
					var _v16 = practitionerResourceResult.agZ;
					if ((!_v16.$) && (!_v16.a.$)) {
						var practitioner = _v16.a.a;
						return A2(
							$elm$core$Maybe$map,
							A2(
								$author$project$Utils$Form$update,
								$author$project$Components$Admin$SignupPages$Form$formFieldsUpdate(
									$author$project$Api$Provider$Practice$One$addons(model.ZV)),
								$author$project$Components$Admin$SignupPages$Form$PractitionerAdd(practitioner)),
							model.SD);
					} else {
						return model.SD;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: newForm, hk: practitionerResourceResult.aiO}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$Form$PractitionerResourceFilterMsg, practitionerResourceResult.GZ),
					practitionerResourceResult.aR);
			case 9:
				var subMsg = msg.a;
				var locationResourceResult = A3($author$project$Components$ResourceFilter$Location$update, apiClient, subMsg, model.os);
				var newForm = function () {
					var _v17 = locationResourceResult.agZ;
					if ((!_v17.$) && (!_v17.a.$)) {
						var location = _v17.a.a;
						return A2(
							$elm$core$Maybe$map,
							A2(
								$author$project$Utils$Form$update,
								$author$project$Components$Admin$SignupPages$Form$formFieldsUpdate(
									$author$project$Api$Provider$Practice$One$addons(model.ZV)),
								$author$project$Components$Admin$SignupPages$Form$LocationAdd(location)),
							model.SD);
					} else {
						return model.SD;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: newForm, os: locationResourceResult.aiO}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$Form$LocationResourceFilterMsg, locationResourceResult.GZ),
					locationResourceResult.aR);
			default:
				var subMsg = msg.a;
				var locationGroupResourceResult = A3($author$project$Components$ResourceFilter$LocationGroup$update, apiClient, subMsg, model.or);
				var newForm = function () {
					var _v18 = locationGroupResourceResult.agZ;
					if ((!_v18.$) && (!_v18.a.$)) {
						var locationGroup = _v18.a.a;
						return A2(
							$elm$core$Maybe$map,
							A2(
								$author$project$Utils$Form$update,
								$author$project$Components$Admin$SignupPages$Form$formFieldsUpdate(
									$author$project$Api$Provider$Practice$One$addons(model.ZV)),
								$author$project$Components$Admin$SignupPages$Form$LocationGroupAdd(locationGroup)),
							model.SD);
					} else {
						return model.SD;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: newForm, or: locationGroupResourceResult.aiO}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$Form$LocationGroupResourceFilterMsg, locationGroupResourceResult.GZ),
					locationGroupResourceResult.aR);
		}
	});
var $author$project$Pages$Admin$SignupPages$Id_String$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Admin$SignupPages$Form$update, model.Gv, subMsg, model.SD);
		var newForm = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{SD: newForm}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Components$Admin$SignupPages$Form$Save = {$: 2};
var $author$project$Components$Admin$SignupPages$Form$isChargeItemSelected = function (chargeItem) {
	return $author$project$Utils$Maybe$toBool(chargeItem);
};
var $author$project$Components$Admin$SignupPages$Form$isPlanSelected = function (signupPagePlans) {
	return !$elm$core$List$isEmpty(signupPagePlans);
};
var $author$project$Components$Admin$SignupPages$Form$isBillingOptionMethod = F2(
	function (signupPagePlans, chargeItem) {
		return $author$project$Components$Admin$SignupPages$Form$isPlanSelected(signupPagePlans) || $author$project$Components$Admin$SignupPages$Form$isChargeItemSelected(chargeItem);
	});
var $author$project$Components$Admin$SignupPages$Form$isPostSignupRedirectionCompleted = F2(
	function (redirectsPostSignup, postSignupRedirectUrl) {
		return (!redirectsPostSignup) || $author$project$Utils$Maybe$toBool(postSignupRedirectUrl);
	});
var $author$project$Components$Admin$SignupPages$Form$isSlugSelected = function (slug) {
	return !$author$project$Utils$String$isBlank(slug);
};
var $author$project$Components$Admin$SignupPages$Form$canSave = function (fields) {
	return A2($author$project$Components$Admin$SignupPages$Form$isBillingOptionMethod, fields.abz, fields.mL) && ($author$project$Components$Admin$SignupPages$Form$isSlugSelected(fields.abG) && A2($author$project$Components$Admin$SignupPages$Form$isPostSignupRedirectionCompleted, fields.$l, fields.ZT));
};
var $author$project$Components$Admin$SignupPages$Form$cancelRoute = function (companyId) {
	if (!companyId.$) {
		var id_ = companyId.a;
		return $author$project$Spa$Generated$Route$Companies__CompanyId_String__Signup(
			{fZ: id_});
	} else {
		return $author$project$Spa$Generated$Route$Admin__SignupPages__Top;
	}
};
var $author$project$Api$Provider$Practice$One$locationGroupsCount = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Wb;
	});
var $author$project$Components$ResourceFilter$CompanyPlan$view = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$view,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.Jy),
					options),
				model.b8));
	});
var $author$project$Components$Admin$SignupPages$Form$viewPlanFilter = F2(
	function (planFilter, form) {
		if (!planFilter.$) {
			var planResourceFilter = planFilter.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Components$Admin$SignupPages$Form$PlanResourceFilterMsg,
				A2(
					$author$project$Components$ResourceFilter$Plan$view,
					_List_fromArray(
						[
							$author$project$Components$ResourceFilter$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
							$author$project$Components$ResourceFilter$errors(
							A2($author$project$Utils$Form$validationErrors, 1, form))
						]),
					planResourceFilter));
		} else {
			var companyPlanFilter = planFilter.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Components$Admin$SignupPages$Form$CompanyPlanResourceFilterMsg,
				A2(
					$author$project$Components$ResourceFilter$CompanyPlan$view,
					_List_fromArray(
						[
							$author$project$Components$ResourceFilter$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
							$author$project$Components$ResourceFilter$errors(
							A2($author$project$Utils$Form$validationErrors, 1, form))
						]),
					companyPlanFilter));
		}
	});
var $author$project$Components$Admin$SignupPages$Form$FormUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$PlanRemove = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$viewSignupPagePlan = F2(
	function (signupPagePlans, signupPagePlan) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(signupPagePlan.ZE),
					($elm$core$List$length(signupPagePlans) > 1) ? A3(
					$author$project$Ui$Button$view,
					{mm: 'Delete signup page plan'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$sm,
							$author$project$Ui$Button$onClick(
							$author$project$Components$Admin$SignupPages$Form$FormUpdated(
								$author$project$Components$Admin$SignupPages$Form$PlanRemove(signupPagePlan.aj4))),
							$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
						]),
					_List_Nil) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$Admin$SignupPages$Form$viewBillingMethod = F4(
	function (fields, planResourceFilter, chargeItemResourceFilter, form) {
		return (fields.amg === 'signup') ? A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Plan'),
					$author$project$Ui$Form$Group$required(true)
				]),
			A2(
				$elm$core$List$cons,
				A2($author$project$Components$Admin$SignupPages$Form$viewPlanFilter, planResourceFilter, form),
				A2(
					$elm$core$List$map,
					$author$project$Components$Admin$SignupPages$Form$viewSignupPagePlan(fields.abz),
					fields.abz))) : A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Charge'),
					$author$project$Ui$Form$Group$required(true)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Components$Admin$SignupPages$Form$ChargeItemResourceFilterMsg,
					A2(
						$author$project$Components$ResourceFilter$ChargeItem$view,
						_List_fromArray(
							[
								$author$project$Components$ResourceFilter$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
								$author$project$Components$ResourceFilter$errors(
								A2($author$project$Utils$Form$validationErrors, 2, form))
							]),
						chargeItemResourceFilter))
				]));
	});
var $author$project$Components$Admin$SignupPages$Form$PostSignupRedirectUrl = function (a) {
	return {$: 20, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$viewCustomButtonUrl = function (postSignupRedirectUrlInput) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('Custom Button URL')
			]),
		_List_fromArray(
			[
				postSignupRedirectUrlInput,
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
				_List_fromArray(
					[
						$elm$html$Html$text('If left blank, clicking the button will redirect to your practice website (under '),
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Admin__Practice,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Account')
							])),
						$elm$html$Html$text(').')
					]))
			]));
};
var $author$project$Components$Admin$SignupPages$Form$PostSignupButtonLabel = function (a) {
	return {$: 23, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$viewPostSignupButtonLabel = F2(
	function (postSignupButtonLabel, practiceName) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Custom Button Text')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$placeholder('Go to ' + (practiceName + ' Website')),
							$author$project$Ui$Form$Input$maxLength(30),
							$author$project$Ui$Form$Input$value(
							A2($elm$core$Maybe$withDefault, '', postSignupButtonLabel)),
							$author$project$Ui$Form$Input$onInput(
							A2($elm$core$Basics$composeL, $author$project$Components$Admin$SignupPages$Form$FormUpdated, $author$project$Components$Admin$SignupPages$Form$PostSignupButtonLabel))
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
					_List_fromArray(
						[
							$elm$html$Html$text('If left blank, button will read \"Go to '),
							$elm$html$Html$text(practiceName),
							$elm$html$Html$text(' Website\".')
						]))
				]));
	});
var $author$project$Components$Admin$SignupPages$Form$ShowPostSignupFooterButton = function (a) {
	return {$: 22, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$viewPostSignupFooterButton = function (showPostSignupFooterButton) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('Show Redirect Button on Confirmation')
			]),
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$view(
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$on(showPostSignupFooterButton),
						$author$project$Ui$ToggleSwitch$onChange(
						A2($elm$core$Basics$composeL, $author$project$Components$Admin$SignupPages$Form$FormUpdated, $author$project$Components$Admin$SignupPages$Form$ShowPostSignupFooterButton))
					])),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
				_List_fromArray(
					[
						showPostSignupFooterButton ? $elm$html$Html$text('A button is displayed that can be configured below with a custom text and URL.') : $elm$html$Html$text('No button will be shown, and user should be instructed to close their current signup tab.')
					]))
			]));
};
var $author$project$Components$Admin$SignupPages$Form$PostSignupMessage = function (a) {
	return {$: 21, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$viewPostSignupMessage = function (postSignupMessage) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('Custom Message')
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Textarea$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Textarea$placeholder('If you have any questions feel free to call our office at (333) 123-4567.'),
						$author$project$Ui$Form$Textarea$value(
						A2($elm$core$Maybe$withDefault, '', postSignupMessage)),
						$author$project$Ui$Form$Textarea$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Admin$SignupPages$Form$FormUpdated, $author$project$Components$Admin$SignupPages$Form$PostSignupMessage))
					]))
			]));
};
var $author$project$Components$Admin$SignupPages$Form$RedirectsPostSignup = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$viewRedirectPostSignup = function (redirectsPostSignup) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('Auto Redirect to External Site')
			]),
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$view(
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$on(redirectsPostSignup),
						$author$project$Ui$ToggleSwitch$onChange(
						A2($elm$core$Basics$composeL, $author$project$Components$Admin$SignupPages$Form$FormUpdated, $author$project$Components$Admin$SignupPages$Form$RedirectsPostSignup))
					]))
			]));
};
var $author$project$Components$Admin$SignupPages$Form$viewRedirectUrl = function (postSignupRedirectUrlInput) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('Redirect URL'),
				$author$project$Ui$Form$Group$required(true)
			]),
		_List_fromArray(
			[postSignupRedirectUrlInput]));
};
var $author$project$Components$Admin$SignupPages$Form$viewCustomSettings = F3(
	function (fields, practice, form) {
		var postSignupRedirectUrlInput = $author$project$Ui$Form$Input$view(
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$url,
					$author$project$Ui$Form$Input$placeholder(
					A2(
						$elm$core$Maybe$withDefault,
						'',
						$author$project$Api$Provider$Practice$One$url(practice))),
					$author$project$Ui$Form$Input$value(
					A2($elm$core$Maybe$withDefault, '', fields.ZT)),
					$author$project$Ui$Form$Input$onInput(
					A2($elm$core$Basics$composeL, $author$project$Components$Admin$SignupPages$Form$FormUpdated, $author$project$Components$Admin$SignupPages$Form$PostSignupRedirectUrl)),
					$author$project$Ui$Form$Input$invalid(
					A2($author$project$Utils$Form$hasValidationErrors, 3, form)),
					$author$project$Ui$Form$Input$errors(
					A2($author$project$Utils$Form$validationErrors, 3, form))
				]));
		return A2(
			$elm$core$List$cons,
			$author$project$Components$Admin$SignupPages$Form$viewRedirectPostSignup(fields.$l),
			fields.$l ? _List_fromArray(
				[
					$author$project$Components$Admin$SignupPages$Form$viewRedirectUrl(postSignupRedirectUrlInput)
				]) : _List_fromArray(
				[
					$author$project$Components$Admin$SignupPages$Form$viewPostSignupMessage(fields.ZS),
					$author$project$Components$Admin$SignupPages$Form$viewPostSignupFooterButton(fields.abp),
					fields.abp ? A2(
					$author$project$Components$Admin$SignupPages$Form$viewPostSignupButtonLabel,
					fields.ZR,
					$author$project$Api$Provider$Practice$One$name(practice)) : $author$project$Utils$Html$empty,
					fields.abp ? $author$project$Components$Admin$SignupPages$Form$viewCustomButtonUrl(postSignupRedirectUrlInput) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$Admin$SignupPages$Form$UseCustomSettings = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$viewEnableConfirmationSettings = function (fields) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('Enable Confirmation Settings')
			]),
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$view(
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$on(fields.adZ),
						$author$project$Ui$ToggleSwitch$onChange(
						A2($elm$core$Basics$composeL, $author$project$Components$Admin$SignupPages$Form$FormUpdated, $author$project$Components$Admin$SignupPages$Form$UseCustomSettings))
					]))
			]));
};
var $author$project$Components$Admin$SignupPages$Form$LimitAvailableLocationGroups = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$ResourceFilter$LocationGroup$view = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$view,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.Jy),
					options),
				model.b8));
	});
var $author$project$Components$Admin$SignupPages$Form$LocationGroupRemove = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$viewLocationGroup = function (locationGroup) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(locationGroup.Bq),
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Remove location group'},
				_List_fromArray(
					[
						$author$project$Ui$Button$link,
						$author$project$Ui$Button$sm,
						$author$project$Ui$Button$onClick(
						$author$project$Components$Admin$SignupPages$Form$FormUpdated(
							$author$project$Components$Admin$SignupPages$Form$LocationGroupRemove(locationGroup.ahP))),
						$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
					]),
				_List_Nil)
			]));
};
var $author$project$Components$Admin$SignupPages$Form$viewLocationGroupSettings = F2(
	function (fields, locationGroupResourceFilter) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Enable Location Group Settings')
				]),
			_List_fromArray(
				[
					$author$project$Ui$ToggleSwitch$view(
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$on(fields.V_),
							$author$project$Ui$ToggleSwitch$onChange(
							A2($elm$core$Basics$composeL, $author$project$Components$Admin$SignupPages$Form$FormUpdated, $author$project$Components$Admin$SignupPages$Form$LimitAvailableLocationGroups))
						])),
					fields.V_ ? A2(
					$elm$html$Html$div,
					_List_Nil,
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Providers assigned to a location within one of the groups selected will be available during enrollment.')
								])),
						A2(
							$elm$core$List$cons,
							A2(
								$elm$html$Html$map,
								$author$project$Components$Admin$SignupPages$Form$LocationGroupResourceFilterMsg,
								A2($author$project$Components$ResourceFilter$LocationGroup$view, _List_Nil, locationGroupResourceFilter)),
							A2(
								$elm$core$List$map,
								$author$project$Components$Admin$SignupPages$Form$viewLocationGroup,
								A2(
									$elm$core$List$sortBy,
									function ($) {
										return $.Bq;
									},
									A2(
										$elm$core$List$map,
										function (p) {
											return _Utils_update(
												p,
												{
													Bq: $elm$core$String$trim(p.Bq)
												});
										},
										fields.Wa)))))) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$Admin$SignupPages$Form$LimitAvailableLocations = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$LocationRemove = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$viewLocation = function (location) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(location.Bq),
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Remove location'},
				_List_fromArray(
					[
						$author$project$Ui$Button$link,
						$author$project$Ui$Button$sm,
						$author$project$Ui$Button$onClick(
						$author$project$Components$Admin$SignupPages$Form$FormUpdated(
							$author$project$Components$Admin$SignupPages$Form$LocationRemove(location.ahP))),
						$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
					]),
				_List_Nil)
			]));
};
var $author$project$Components$Admin$SignupPages$Form$viewLocationSettings = F2(
	function (fields, locationResourceFilter) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Enable Location Settings')
				]),
			_List_fromArray(
				[
					$author$project$Ui$ToggleSwitch$view(
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$on(fields.V$),
							$author$project$Ui$ToggleSwitch$onChange(
							A2($elm$core$Basics$composeL, $author$project$Components$Admin$SignupPages$Form$FormUpdated, $author$project$Components$Admin$SignupPages$Form$LimitAvailableLocations))
						])),
					fields.V$ ? A2(
					$elm$html$Html$div,
					_List_Nil,
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Selected location(s) will display on the patient\'s enrollment page.')
								])),
						A2(
							$elm$core$List$cons,
							A2(
								$elm$html$Html$map,
								$author$project$Components$Admin$SignupPages$Form$LocationResourceFilterMsg,
								A2($author$project$Components$ResourceFilter$Location$view, _List_Nil, locationResourceFilter)),
							A2(
								$elm$core$List$map,
								$author$project$Components$Admin$SignupPages$Form$viewLocation,
								A2(
									$elm$core$List$sortBy,
									function ($) {
										return $.Bq;
									},
									A2(
										$elm$core$List$map,
										function (p) {
											return _Utils_update(
												p,
												{
													Bq: $elm$core$String$trim(p.Bq)
												});
										},
										fields.Wg)))))) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$Admin$SignupPages$Form$Type = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$buttonStyle = F2(
	function (type_, currentType_) {
		return _Utils_eq(type_, currentType_) ? 1 : 0;
	});
var $author$project$Ui$Icon$Cart = 60;
var $author$project$Ui$Icon$cart = $author$project$Ui$Icon$viewIcon(60);
var $author$project$Ui$Icon$OnlineSignup = 27;
var $author$project$Ui$Icon$onlineSignup = $author$project$Ui$Icon$viewIcon(27);
var $author$project$Components$Admin$SignupPages$Form$viewPageType = F2(
	function (id, fields) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Signup / Checkout')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{mm: 'Select plan signup page'},
					_List_fromArray(
						[
							$author$project$Ui$Button$styled(
							A2($author$project$Components$Admin$SignupPages$Form$buttonStyle, 'signup', fields.amg)),
							$author$project$Ui$Button$onClick(
							$author$project$Components$Admin$SignupPages$Form$FormUpdated(
								$author$project$Components$Admin$SignupPages$Form$Type('signup'))),
							$author$project$Ui$Button$disabled(
							$author$project$Utils$Maybe$toBool(id)),
							$author$project$Ui$Button$icon($author$project$Ui$Icon$onlineSignup)
						]),
					_List_Nil),
					A3(
					$author$project$Ui$Button$view,
					{mm: 'Select checkout page'},
					_List_fromArray(
						[
							$author$project$Ui$Button$styled(
							A2($author$project$Components$Admin$SignupPages$Form$buttonStyle, 'checkout', fields.amg)),
							$author$project$Ui$Button$onClick(
							$author$project$Components$Admin$SignupPages$Form$FormUpdated(
								$author$project$Components$Admin$SignupPages$Form$Type('checkout'))),
							$author$project$Ui$Button$disabled(
							$author$project$Utils$Maybe$toBool(id)),
							$author$project$Ui$Button$icon($author$project$Ui$Icon$cart)
						]),
					_List_Nil)
				]));
	});
var $author$project$Components$Admin$SignupPages$Form$LimitAvailablePractitioners = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$PractitionerRemove = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$viewPractitioner = function (practitioner) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(practitioner.Bq),
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Remove practitioner'},
				_List_fromArray(
					[
						$author$project$Ui$Button$link,
						$author$project$Ui$Button$sm,
						$author$project$Ui$Button$onClick(
						$author$project$Components$Admin$SignupPages$Form$FormUpdated(
							$author$project$Components$Admin$SignupPages$Form$PractitionerRemove(practitioner.ahP))),
						$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
					]),
				_List_Nil)
			]));
};
var $author$project$Components$Admin$SignupPages$Form$viewProviderSettings = F2(
	function (fields, practitionerResourceFilter) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Enable Provider Settings')
				]),
			_List_fromArray(
				[
					$author$project$Ui$ToggleSwitch$view(
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$on(fields.V0),
							$author$project$Ui$ToggleSwitch$onChange(
							A2($elm$core$Basics$composeL, $author$project$Components$Admin$SignupPages$Form$FormUpdated, $author$project$Components$Admin$SignupPages$Form$LimitAvailablePractitioners))
						])),
					fields.V0 ? A2(
					$elm$html$Html$div,
					_List_Nil,
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Selected provider(s) will display on the patient\'s enrollment page.')
								])),
						A2(
							$elm$core$List$cons,
							A2(
								$elm$html$Html$map,
								$author$project$Components$Admin$SignupPages$Form$PractitionerResourceFilterMsg,
								A2($author$project$Components$ResourceFilter$Practitioner$view, _List_Nil, practitionerResourceFilter)),
							A2(
								$elm$core$List$map,
								$author$project$Components$Admin$SignupPages$Form$viewPractitioner,
								A2(
									$elm$core$List$sortBy,
									function ($) {
										return $.Bq;
									},
									A2(
										$elm$core$List$map,
										function (p) {
											return _Utils_update(
												p,
												{
													Bq: $elm$core$String$trim(p.Bq)
												});
										},
										fields.Z4)))))) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$Admin$SignupPages$Form$Slug = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$viewSlug = F2(
	function (fields, form) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Url'),
					$author$project$Ui$Form$Group$required(true)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$group(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$addon(
							_List_fromArray(
								[
									(fields.amg === 'signup') ? $elm$html$Html$text('signup/') : $elm$html$Html$text('checkout/')
								])),
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(fields.abG),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$Admin$SignupPages$Form$FormUpdated, $author$project$Components$Admin$SignupPages$Form$Slug))
								]))
						])),
					$author$project$Utils$FormErrors$view(
					A2($author$project$Utils$Form$validationErrors, 0, form))
				]));
	});
var $author$project$Components$Admin$SignupPages$Form$Active = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$viewStatus = F2(
	function (fields, practice) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Live')
				]),
			_List_fromArray(
				[
					$author$project$Ui$ToggleSwitch$view(
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$on(fields.KN),
							$author$project$Ui$ToggleSwitch$onChange(
							A2($elm$core$Basics$composeL, $author$project$Components$Admin$SignupPages$Form$FormUpdated, $author$project$Components$Admin$SignupPages$Form$Active))
						])),
					(!$author$project$Api$Provider$Practice$One$hasPaymentProcessorAccount(practice)) ? A3(
					$author$project$Ui$Tooltip$view,
					_List_Nil,
					'The Signup Page will remain inactive until you finish setting up Payment Processing',
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[$author$project$Ui$Typography$small]),
							_List_fromArray(
								[
									$author$project$Utils$Html$noBreakSpace,
									$author$project$Ui$Icon$help(_List_Nil)
								]))
						])) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$Admin$SignupPages$Form$AddonAdd = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$addonOptions = F2(
	function (addons, currentAddons) {
		var signupPageAddonIds = A2(
			$elm$core$List$map,
			function ($) {
				return $.ahP;
			},
			currentAddons);
		return A2(
			$elm$core$List$cons,
			A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(''),
				'Select an Addon'),
			A2(
				$elm$core$List$map,
				function (addon) {
					return A3(
						$author$project$Ui$Form$Select$option,
						_List_Nil,
						$elm$core$Maybe$Just(
							$author$project$Api$Provider$Addon$Min$id(addon)),
						$author$project$Api$Provider$Addon$Min$name(addon));
				},
				A2(
					$elm_community$list_extra$List$Extra$filterNot,
					function (addon) {
						return A2(
							$elm$core$List$member,
							$author$project$Api$Provider$Addon$Min$id(addon),
							signupPageAddonIds);
					},
					addons)));
	});
var $author$project$Components$Admin$SignupPages$Form$AddonRemove = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$viewAddon = function (addon) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(addon.Bq),
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Delete addon'},
				_List_fromArray(
					[
						$author$project$Ui$Button$link,
						$author$project$Ui$Button$sm,
						$author$project$Ui$Button$onClick(
						$author$project$Components$Admin$SignupPages$Form$FormUpdated(
							$author$project$Components$Admin$SignupPages$Form$AddonRemove(addon.ahP))),
						$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
					]),
				_List_Nil)
			]));
};
var $author$project$Components$Admin$SignupPages$Form$viewWrapAround = F3(
	function (fields, companyId, practice) {
		var practiceAddons = $author$project$Api$Provider$Practice$One$addons(practice);
		return ($elm$core$List$isEmpty(practiceAddons) || $author$project$Utils$Maybe$toBool(companyId)) ? $author$project$Utils$Html$empty : A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Wrap-Arounds')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Ui$Form$Select$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Select$onChange(
							A2($elm$core$Basics$composeL, $author$project$Components$Admin$SignupPages$Form$FormUpdated, $author$project$Components$Admin$SignupPages$Form$AddonAdd))
						]),
					A2($author$project$Components$Admin$SignupPages$Form$addonOptions, practiceAddons, fields.K1)),
				A2($elm$core$List$map, $author$project$Components$Admin$SignupPages$Form$viewAddon, fields.K1)));
	});
var $author$project$Components$Admin$SignupPages$Form$viewForm = F2(
	function (model, form) {
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$elm$core$List$cons,
			$author$project$Utils$Maybe$isNothing(model.fZ) ? A2($author$project$Components$Admin$SignupPages$Form$viewPageType, model.ahP, fields) : $author$project$Utils$Html$empty,
			A2(
				$elm$core$List$cons,
				A4($author$project$Components$Admin$SignupPages$Form$viewBillingMethod, fields, model.hi, model.cq, form),
				A2(
					$elm$core$List$cons,
					A2($author$project$Components$Admin$SignupPages$Form$viewSlug, fields, form),
					A2(
						$elm$core$List$cons,
						A2($author$project$Components$Admin$SignupPages$Form$viewStatus, fields, model.ZV),
						A2(
							$elm$core$List$cons,
							A3($author$project$Components$Admin$SignupPages$Form$viewWrapAround, fields, model.fZ, model.ZV),
							A2(
								$elm$core$List$cons,
								($author$project$Api$Provider$Practice$One$locationGroupsCount(model.ZV) > 0) ? A2($author$project$Components$Admin$SignupPages$Form$viewLocationGroupSettings, fields, model.or) : $author$project$Utils$Html$empty,
								A2(
									$elm$core$List$cons,
									A2($author$project$Components$Admin$SignupPages$Form$viewLocationSettings, fields, model.os),
									A2(
										$elm$core$List$cons,
										A2($author$project$Components$Admin$SignupPages$Form$viewProviderSettings, fields, model.hk),
										A2(
											$elm$core$List$cons,
											$author$project$Components$Admin$SignupPages$Form$viewEnableConfirmationSettings(fields),
											fields.adZ ? A3($author$project$Components$Admin$SignupPages$Form$viewCustomSettings, fields, model.ZV, form) : _List_Nil)))))))));
	});
var $author$project$Components$Admin$SignupPages$Form$view = function (_v0) {
	var model = _v0;
	return A2(
		$author$project$Ui$Form$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$noValidate(true),
				$author$project$Ui$Form$autocomplete(false),
				$author$project$Ui$Form$onSubmit($author$project$Components$Admin$SignupPages$Form$Save)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_fromArray(
							[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										function () {
										var _v1 = model.ahP;
										if (!_v1.$) {
											return $elm$html$Html$text('Edit Signup Page');
										} else {
											return $elm$html$Html$text('New Signup Page');
										}
									}()
									])),
								A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Admin__SignupPages__Top,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Icon$cross(_List_Nil)
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						function () {
							var _v2 = model.SD;
							if (!_v2.$) {
								var form = _v2.a;
								return A2($author$project$Components$Admin$SignupPages$Form$viewForm, model, form);
							} else {
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$textCenter]),
										_List_fromArray(
											[
												$author$project$Ui$Spinner$view(_List_Nil)
											]))
									]);
							}
						}()),
						A2(
						$author$project$Ui$Panel$footer,
						_List_fromArray(
							[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$itemsCenter]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Link$route,
								$author$project$Components$Admin$SignupPages$Form$cancelRoute(model.fZ),
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Back')
									])),
								function () {
								var verb = function () {
									var _v4 = model.ahP;
									if (!_v4.$) {
										return 'Update';
									} else {
										return 'Create';
									}
								}();
								var allowSave = function () {
									var _v3 = model.SD;
									if (!_v3.$) {
										var form = _v3.a;
										return $author$project$Components$Admin$SignupPages$Form$canSave(
											$author$project$Utils$Form$fields(form));
									} else {
										return true;
									}
								}();
								return A3(
									$author$project$Ui$Button$view,
									{mm: verb},
									_List_fromArray(
										[
											$author$project$Ui$Button$primary,
											$author$project$Ui$Button$onClick($author$project$Components$Admin$SignupPages$Form$Save),
											$author$project$Ui$Button$loading(
											_Utils_eq(model.k9, $author$project$Api$Data$Loading)),
											$author$project$Ui$Button$disabled(!allowSave)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(verb)
										]));
							}()
							]))
					]))
			]));
};
var $author$project$Pages$Admin$SignupPages$Id_String$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Admin$SignupPages$Form$view(model.SD))
			]),
		ac9: 'Admin | Signup Pages'
	};
};
var $author$project$Pages$Admin$SignupPages$Id_String$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$SignupPages$Id_String$init, aiq: $author$project$Pages$Admin$SignupPages$Id_String$load, k8: $author$project$Pages$Admin$SignupPages$Id_String$save, alO: $author$project$Pages$Admin$SignupPages$Id_String$subscriptions, adT: $author$project$Pages$Admin$SignupPages$Id_String$update, amo: $author$project$Pages$Admin$SignupPages$Id_String$view});
var $author$project$Pages$Admin$SignupPages$New$FormMsg = $elm$core$Basics$identity;
var $author$project$Pages$Admin$SignupPages$New$init = F4(
	function (session, practice, _v0, _v1) {
		var apiClient = _v0.Gv;
		var _v2 = A6($author$project$Components$Admin$SignupPages$Form$init, apiClient, session, practice, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
		var form = _v2.a;
		var formCmd = _v2.b;
		return _Utils_Tuple2(
			{Gv: apiClient, SD: form},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, formCmd));
	});
var $author$project$Pages$Admin$SignupPages$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$SignupPages$New$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$SignupPages$New$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Admin$SignupPages$Form$subscriptions(model.SD));
};
var $author$project$Pages$Admin$SignupPages$New$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Admin$SignupPages$Form$update, model.Gv, subMsg, model.SD);
		var form = _v1.a;
		var formCmd = _v1.b;
		var outMsgs = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{SD: form}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, formCmd),
			outMsgs);
	});
var $author$project$Pages$Admin$SignupPages$New$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Admin$SignupPages$Form$view(model.SD))
			]),
		ac9: 'Admin | Signup Pages'
	};
};
var $author$project$Pages$Admin$SignupPages$New$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$SignupPages$New$init, aiq: $author$project$Pages$Admin$SignupPages$New$load, k8: $author$project$Pages$Admin$SignupPages$New$save, alO: $author$project$Pages$Admin$SignupPages$New$subscriptions, adT: $author$project$Pages$Admin$SignupPages$New$update, amo: $author$project$Pages$Admin$SignupPages$New$view});
var $author$project$Pages$Admin$SignupPages$Top$GotItems = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$SignupPage$listDefaults = {
	fZ: $elm$core$Maybe$Nothing,
	ajJ: $elm$core$Maybe$Just($author$project$Api$Pagination$init)
};
var $author$project$Api$Provider$SignupPage$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$SignupPage$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.fZ;
				if (!_v0.$) {
					var companyId = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'company_id', companyId)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.ajJ;
				if (!_v1.$) {
					var pagination = _v1.a;
					return $author$project$Api$Pagination$toApiParams(pagination);
				} else {
					return _List_Nil;
				}
			}()
			]));
};
var $author$project$Api$Provider$SignupPage$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$SignupPage$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$SignupPage$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$SignupPage$signupPagesPath)));
	});
var $author$project$Pages$Admin$SignupPages$Top$fetchItems = function (model) {
	return A3(
		$author$project$Api$Provider$SignupPage$list,
		model.Gv,
		function (d) {
			return _Utils_update(
				d,
				{
					ajJ: $elm$core$Maybe$Just(model.ajJ)
				});
		},
		$author$project$Pages$Admin$SignupPages$Top$GotItems);
};
var $author$project$Pages$Admin$SignupPages$Top$GotDefault = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$SignupPages$Top$getDefault = function (model) {
	return A2($author$project$Api$Provider$SignupPage$getDefault, model.Gv, $author$project$Pages$Admin$SignupPages$Top$GotDefault);
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$Closed = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$init = $author$project$Components$Admin$SignupPages$CustomizeUrlModal$Closed;
var $author$project$Pages$Admin$SignupPages$Top$init = F4(
	function (_v0, practice, _v1, _v2) {
		var apiClient = _v1.Gv;
		var query = _v2.DE;
		var model = {
			K1: $author$project$Api$Provider$Practice$One$addons(practice),
			Gv: apiClient,
			f5: $author$project$Components$Admin$SignupPages$CustomizeUrlModal$init(apiClient),
			Qb: $elm$core$Maybe$Nothing,
			je: $elm$core$Maybe$Nothing,
			eg: $elm$core$Set$empty,
			j4: $author$project$Api$Data$Loading,
			ajJ: $author$project$Api$Pagination$initFromQuery(query),
			ZV: practice,
			Dg: $author$project$Api$Provider$Practice$One$hasPaymentProcessorAccount(practice),
			qN: $author$project$Api$Data$NotAsked
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Pages$Admin$SignupPages$Top$fetchItems(model),
						$author$project$Pages$Admin$SignupPages$Top$getDefault(model)
					])));
	});
var $author$project$Pages$Admin$SignupPages$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$SignupPages$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$SignupPages$Top$CustomizeUrlMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Admin$SignupPages$Top$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$BrokerResourceFilterMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$CloseModal = {$: 0};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$LeadSourceResourceFilterMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$LocationResourceFilterMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$PractitionerResourceFilterMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$ResourceFilter$Broker$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Components$ResourceFilter$Broker$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.b8));
};
var $author$project$Components$ResourceFilter$LeadSource$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Components$ResourceFilter$LeadSource$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.b8));
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$subscriptions = function (model) {
	if (model.$ === 1) {
		var open_ = model.a;
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$SignupPages$CustomizeUrlModal$CloseModal),
					$author$project$Ui$Dropdown$subscriptions(open_.mv),
					$author$project$Ui$Dropdown$subscriptions(open_.m_),
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$Components$Admin$SignupPages$CustomizeUrlModal$PractitionerResourceFilterMsg,
					$author$project$Components$ResourceFilter$Practitioner$subscriptions(open_.hk)),
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$Components$Admin$SignupPages$CustomizeUrlModal$LocationResourceFilterMsg,
					$author$project$Components$ResourceFilter$Location$subscriptions(open_.os)),
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$Components$Admin$SignupPages$CustomizeUrlModal$LeadSourceResourceFilterMsg,
					$author$project$Components$ResourceFilter$LeadSource$subscriptions(open_.oi)),
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$Components$Admin$SignupPages$CustomizeUrlModal$BrokerResourceFilterMsg,
					$author$project$Components$ResourceFilter$Broker$subscriptions(open_.mx))
				]));
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Pages$Admin$SignupPages$Top$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$SignupPages$Top$CustomizeUrlMsg,
				$author$project$Components$Admin$SignupPages$CustomizeUrlModal$subscriptions(model.f5)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$SignupPages$Top$HiConfirmClosed),
					model.je))
			]));
};
var $author$project$Pages$Admin$SignupPages$Top$DefaultSignupPageUpdated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$SignupPages$Top$Deleted = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Api$Provider$SignupPage$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$SignupPage$signupPagePath(id_)));
	});
var $author$project$Api$Provider$SignupPage$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$SignupPage$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$SignupPage$Shared$id(shared);
};
var $author$project$Api$Provider$SignupPage$makeDefault = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$SignupPage$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['default']),
					$author$project$Api$Provider$SignupPage$signupPagePath(id_))));
	});
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$BillingPeriodDropdownMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$CouponDropdownMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$GotCoupons = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$GotSignupPageOne = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$Open = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$formFieldsInit = {ru: $elm$core$Maybe$Nothing, xF: $elm$core$Maybe$Nothing, OP: $elm$core$Maybe$Nothing, VR: $elm$core$Maybe$Nothing, ais: $elm$core$Maybe$Nothing, aka: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$Broker$brokersPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['brokers']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Broker$All$Broker = $elm$core$Basics$identity;
var $author$project$Api$Provider$Broker$Shared$Broker = $elm$core$Basics$identity;
var $author$project$Api$Provider$Broker$Shared$Record = F4(
	function (id, name, endedOn, brokerAccount) {
		return {xG: brokerAccount, Rw: endedOn, ahP: id, Bq: name};
	});
var $author$project$Api$Provider$BrokerAccount$Shared$BrokerAccount = $elm$core$Basics$identity;
var $author$project$Api$Provider$BrokerAccount$Shared$Record = F5(
	function (id, name, retailEnabled, multipleBrokers, ratePeriodSchedule) {
		return {ahP: id, Xw: multipleBrokers, Bq: name, _2: ratePeriodSchedule, ak0: retailEnabled};
	});
var $author$project$Api$Provider$RatePeriodSchedule$Shared$RatePeriodSchedule = $elm$core$Basics$identity;
var $author$project$Api$Provider$RatePeriodSchedule$Shared$Record = function (intervals) {
	return {ah3: intervals};
};
var $author$project$Api$Provider$RatePeriodScheduleInterval$Shared$RatePeriodScheduleInterval = $elm$core$Basics$identity;
var $author$project$Api$Provider$RatePeriodScheduleInterval$Shared$Record = F2(
	function (intervalInMonths, pricingStructure) {
		return {ah2: intervalInMonths, _l: pricingStructure};
	});
var $author$project$Api$Provider$RatePeriodScheduleInterval$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'pricing_structure',
	$author$project$Api$Provider$PricingStructure$Shared$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'interval_in_months',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$RatePeriodScheduleInterval$Shared$Record)));
var $author$project$Api$Provider$RatePeriodScheduleInterval$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$RatePeriodScheduleInterval$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$RatePeriodSchedule$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'intervals',
	$elm$json$Json$Decode$list($author$project$Api$Provider$RatePeriodScheduleInterval$Shared$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$RatePeriodSchedule$Shared$Record));
var $author$project$Api$Provider$RatePeriodSchedule$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$RatePeriodSchedule$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$BrokerAccount$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'rate_period_schedule',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$RatePeriodSchedule$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'multiple_brokers',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'retail_enabled',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$BrokerAccount$Shared$Record))))));
var $author$project$Api$Provider$BrokerAccount$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$BrokerAccount$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Broker$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'broker_account',
	$author$project$Api$Provider$BrokerAccount$Shared$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'ended_on',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$Broker$Shared$Record)))));
var $author$project$Api$Provider$Broker$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Broker$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Broker$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Broker$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Broker$listDefaults = {xG: $elm$core$Maybe$Nothing, ahP: $elm$core$Maybe$Nothing, TU: $elm$core$Maybe$Nothing, IK: $elm$core$Maybe$Nothing, ajJ: $author$project$Api$Pagination$init, akl: $elm$core$Maybe$Nothing, JA: $elm$core$Maybe$Nothing, alA: $author$project$Api$Sort$init};
var $author$project$Api$Provider$Broker$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Broker$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.akl;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.ahP;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.JA;
				if (!_v2.$) {
					var bool = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$bool, 'retail', bool)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v3 = options.TU;
				if (!_v3.$) {
					var bool = _v3.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$bool, 'inactive', bool)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v4 = options.xG;
				if (!_v4.$) {
					var string = _v4.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'broker_account', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v5 = options.IK;
				if (!_v5.$) {
					var bool = _v5.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$bool, 'no_end', bool)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$Provider$Broker$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Broker$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Broker$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Broker$brokersPath)));
	});
var $author$project$Components$ResourceFilter$Broker$list = $author$project$Api$Provider$Broker$list;
var $author$project$Components$ResourceFilter$Broker$fetchResources = F5(
	function (listOptionals, toMsg, apiClient, pagination, query) {
		return A3(
			$author$project$Components$ResourceFilter$Broker$list,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{ajJ: pagination, akl: query});
				}),
			toMsg);
	});
var $author$project$Components$ResourceFilter$Broker$retrieveResource = F4(
	function (listOptionals, toMsg, apiClient, id) {
		return A3(
			$author$project$Components$ResourceFilter$Broker$list,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{
							ahP: $elm$core$Maybe$Just(id)
						});
				}),
			toMsg);
	});
var $author$project$Components$ResourceFilter$Broker$selectId = 'brokers';
var $author$project$Api$Provider$Broker$Shared$brokerAccount = function (_v0) {
	var record = _v0;
	return record.xG;
};
var $author$project$Api$Provider$Broker$All$brokerAccount = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Broker$Shared$brokerAccount(shared);
};
var $author$project$Api$Provider$Broker$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$Broker$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Broker$Shared$name(shared);
};
var $author$project$Api$Provider$BrokerAccount$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Components$ResourceFilter$Broker$toTitle = function (resource) {
	return $author$project$Api$Provider$Broker$All$name(resource) + (' - ' + $author$project$Api$Provider$BrokerAccount$Shared$name(
		$author$project$Api$Provider$Broker$All$brokerAccount(resource)));
};
var $author$project$Components$ResourceFilter$Broker$toLabel = function (resource) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Components$ResourceFilter$Broker$toTitle(resource))
		]);
};
var $author$project$Api$Provider$Broker$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Broker$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Broker$Shared$id(shared);
};
var $author$project$Components$ResourceFilter$Broker$toValue = $author$project$Api$Provider$Broker$All$id;
var $author$project$Components$ResourceFilter$Broker$init = F3(
	function (apiClient, listOptionals, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{
				Sk: $author$project$Components$ResourceFilter$Broker$fetchResources(listOptionals),
				ahP: $author$project$Components$ResourceFilter$Broker$selectId,
				k$: 'Broker',
				uk: $author$project$Components$ResourceFilter$Broker$retrieveResource(listOptionals),
				u9: $author$project$Components$ResourceFilter$Broker$toLabel,
				lN: $author$project$Components$ResourceFilter$Broker$toTitle,
				hX: $author$project$Components$ResourceFilter$Broker$toValue
			},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{Jy: $author$project$Components$ResourceFilter$All, b8: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$ResourceFilter$LeadSource$list = $author$project$Api$Provider$LeadSource$list;
var $author$project$Components$ResourceFilter$LeadSource$fetchResources = F5(
	function (listOptionals, toMsg, apiClient, pagination, query) {
		return A3(
			$author$project$Components$ResourceFilter$LeadSource$list,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{ajJ: pagination, akl: query});
				}),
			toMsg);
	});
var $author$project$Components$ResourceFilter$LeadSource$retrieveResource = F4(
	function (listOptionals, toMsg, apiClient, id) {
		return A3(
			$author$project$Components$ResourceFilter$LeadSource$list,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{
							ahP: $elm$core$Maybe$Just(id)
						});
				}),
			toMsg);
	});
var $author$project$Components$ResourceFilter$LeadSource$selectId = 'lead-sources';
var $author$project$Components$ResourceFilter$LeadSource$toTitle = function (resource) {
	return $author$project$Api$Provider$LeadSource$All$name(resource);
};
var $author$project$Components$ResourceFilter$LeadSource$toLabel = function (resource) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Components$ResourceFilter$LeadSource$toTitle(resource))
		]);
};
var $author$project$Components$ResourceFilter$LeadSource$toValue = $author$project$Api$Provider$LeadSource$All$id;
var $author$project$Components$ResourceFilter$LeadSource$init = F3(
	function (apiClient, listOptionals, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{
				Sk: $author$project$Components$ResourceFilter$LeadSource$fetchResources(listOptionals),
				ahP: $author$project$Components$ResourceFilter$LeadSource$selectId,
				k$: 'Lead Source',
				uk: $author$project$Components$ResourceFilter$LeadSource$retrieveResource(listOptionals),
				u9: $author$project$Components$ResourceFilter$LeadSource$toLabel,
				lN: $author$project$Components$ResourceFilter$LeadSource$toTitle,
				hX: $author$project$Components$ResourceFilter$LeadSource$toValue
			},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{Jy: $author$project$Components$ResourceFilter$All, b8: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$open = F2(
	function (signupPage, model) {
		if (!model.$) {
			var apiClient = model.a;
			var _v1 = A3(
				$author$project$Components$ResourceFilter$Practitioner$init,
				apiClient,
				function (d) {
					return _Utils_update(
						d,
						{
							IW: $elm$core$Maybe$Just(true),
							JM: $elm$core$Maybe$Just(
								$author$project$Api$Provider$SignupPage$All$id(signupPage))
						});
				},
				function (d) {
					return _Utils_update(
						d,
						{Gp: 'None'});
				});
			var practitionerResourceFilter = _v1.a;
			var practitionerResourceFilterCmd = _v1.b;
			var _v2 = A4(
				$author$project$Components$ResourceFilter$Location$init,
				apiClient,
				$elm$core$Maybe$Nothing,
				function (d) {
					return _Utils_update(
						d,
						{
							IW: $elm$core$Maybe$Just(true),
							JM: $elm$core$Maybe$Just(
								$author$project$Api$Provider$SignupPage$All$id(signupPage))
						});
				},
				function (d) {
					return _Utils_update(
						d,
						{Gp: 'None'});
				});
			var locationResourceFilter = _v2.a;
			var locationResourceFilterCmd = _v2.b;
			var _v3 = A3(
				$author$project$Components$ResourceFilter$LeadSource$init,
				apiClient,
				$elm$core$Basics$identity,
				function (d) {
					return _Utils_update(
						d,
						{Gp: 'None'});
				});
			var leadSourceResourceFilter = _v3.a;
			var leadSourceResourceFilterCmd = _v3.b;
			var _v4 = A3(
				$author$project$Components$ResourceFilter$Broker$init,
				apiClient,
				function (d) {
					return _Utils_update(
						d,
						{
							JA: $elm$core$Maybe$Just(true)
						});
				},
				function (d) {
					return _Utils_update(
						d,
						{Gp: 'None'});
				});
			var brokerResourceFilter = _v4.a;
			var brokerResourceFilterCmd = _v4.b;
			return _Utils_Tuple2(
				$author$project$Components$Admin$SignupPages$CustomizeUrlModal$Open(
					{
						Lz: $elm$core$Maybe$Nothing,
						mv: $author$project$Ui$Dropdown$init(
							$author$project$Ui$Dropdown$defaultConfig(
								{ahP: 'billing-period-dropdown-filter', al6: $author$project$Components$Admin$SignupPages$CustomizeUrlModal$BillingPeriodDropdownMsg})),
						mx: brokerResourceFilter,
						m_: $author$project$Ui$Dropdown$init(
							$author$project$Ui$Dropdown$defaultConfig(
								{ahP: 'coupon-dropdown-filter', al6: $author$project$Components$Admin$SignupPages$CustomizeUrlModal$CouponDropdownMsg})),
						yT: $author$project$Api$Data$Loading,
						SD: $author$project$Utils$Form$init($author$project$Components$Admin$SignupPages$CustomizeUrlModal$formFieldsInit),
						oi: leadSourceResourceFilter,
						os: locationResourceFilter,
						hk: practitionerResourceFilter,
						JM: signupPage
					}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A3(
							$author$project$Api$Provider$Coupon$list,
							apiClient,
							function (d) {
								return _Utils_update(
									d,
									{
										Jt: $elm$core$Maybe$Just(true)
									});
							},
							$author$project$Components$Admin$SignupPages$CustomizeUrlModal$GotCoupons),
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$PractitionerResourceFilterMsg, practitionerResourceFilterCmd),
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$LocationResourceFilterMsg, locationResourceFilterCmd),
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$LeadSourceResourceFilterMsg, leadSourceResourceFilterCmd),
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$BrokerResourceFilterMsg, brokerResourceFilterCmd),
							A3(
							$author$project$Api$Provider$SignupPage$retrieve,
							apiClient,
							$author$project$Api$Provider$SignupPage$All$id(signupPage),
							$author$project$Components$Admin$SignupPages$CustomizeUrlModal$GotSignupPageOne)
						])));
		} else {
			var open_ = model.a;
			return _Utils_Tuple2(
				$author$project$Components$Admin$SignupPages$CustomizeUrlModal$Open(open_),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$BillingPeriod = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$Broker = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$Coupon = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$GotPlanAllowedCodes = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$LeadSource = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$Location = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$Practitioner = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{aka: string});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{ais: string});
			case 2:
				var string = field.a;
				return _Utils_update(
					fields,
					{ru: string});
			case 3:
				var string = field.a;
				return _Utils_update(
					fields,
					{OP: string});
			case 4:
				var string = field.a;
				return _Utils_update(
					fields,
					{VR: string});
			default:
				var string = field.a;
				return _Utils_update(
					fields,
					{xF: string});
		}
	});
var $author$project$Components$ResourceFilter$Broker$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.b8);
		var modelAfterEvent = function () {
			var _v1 = result.agZ;
			if (!_v1.$) {
				var selected = _v1.a;
				return _Utils_update(
					model,
					{Jy: selected});
			} else {
				return model;
			}
		}();
		return {
			GZ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.GZ),
			agZ: result.agZ,
			aiO: _Utils_update(
				modelAfterEvent,
				{b8: result.aiO}),
			aR: result.aR
		};
	});
var $author$project$Components$ResourceFilter$LeadSource$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.b8);
		var modelAfterEvent = function () {
			var _v1 = result.agZ;
			if (!_v1.$) {
				var selected = _v1.a;
				return _Utils_update(
					model,
					{Jy: selected});
			} else {
				return model;
			}
		}();
		return {
			GZ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.GZ),
			agZ: result.agZ,
			aiO: _Utils_update(
				modelAfterEvent,
				{b8: result.aiO}),
			aR: result.aR
		};
	});
var $author$project$Components$ResourceFilter$Broker$value = function (model) {
	return A2($author$project$Components$ResourceFilter$choiceToValue, model.b8, model.Jy);
};
var $author$project$Components$ResourceFilter$LeadSource$value = function (model) {
	return A2($author$project$Components$ResourceFilter$choiceToValue, model.b8, model.Jy);
};
var $author$project$Components$ResourceFilter$Location$value = function (model) {
	return A2($author$project$Components$ResourceFilter$choiceToValue, model.b8, model.Jy);
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$update = F3(
	function (apiClient, msg, model) {
		if (!model.$) {
			return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		} else {
			var open_ = model.a;
			switch (msg.$) {
				case 0:
					return _Utils_Tuple3(
						$author$project$Components$Admin$SignupPages$CustomizeUrlModal$Closed(apiClient),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				case 1:
					var subMsg = msg.a;
					var practitionerResourceResult = A3($author$project$Components$ResourceFilter$Practitioner$update, apiClient, subMsg, open_.hk);
					var newForm = function () {
						var _v2 = practitionerResourceResult.agZ;
						if (!_v2.$) {
							return A3(
								$author$project$Utils$Form$update,
								$author$project$Components$Admin$SignupPages$CustomizeUrlModal$formFieldsUpdate,
								$author$project$Components$Admin$SignupPages$CustomizeUrlModal$Practitioner(
									$author$project$Components$ResourceFilter$Practitioner$value(practitionerResourceResult.aiO)),
								open_.SD);
						} else {
							return open_.SD;
						}
					}();
					return _Utils_Tuple3(
						$author$project$Components$Admin$SignupPages$CustomizeUrlModal$Open(
							_Utils_update(
								open_,
								{SD: newForm, hk: practitionerResourceResult.aiO})),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$PractitionerResourceFilterMsg, practitionerResourceResult.GZ),
						practitionerResourceResult.aR);
				case 2:
					var subMsg = msg.a;
					var locationResourceResult = A3($author$project$Components$ResourceFilter$Location$update, apiClient, subMsg, open_.os);
					var newForm = function () {
						var _v3 = locationResourceResult.agZ;
						if (!_v3.$) {
							return A3(
								$author$project$Utils$Form$update,
								$author$project$Components$Admin$SignupPages$CustomizeUrlModal$formFieldsUpdate,
								$author$project$Components$Admin$SignupPages$CustomizeUrlModal$Location(
									$author$project$Components$ResourceFilter$Location$value(locationResourceResult.aiO)),
								open_.SD);
						} else {
							return open_.SD;
						}
					}();
					return _Utils_Tuple3(
						$author$project$Components$Admin$SignupPages$CustomizeUrlModal$Open(
							_Utils_update(
								open_,
								{SD: newForm, os: locationResourceResult.aiO})),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$LocationResourceFilterMsg, locationResourceResult.GZ),
						locationResourceResult.aR);
				case 3:
					var subMsg = msg.a;
					var _v4 = A2($author$project$Ui$Dropdown$update, subMsg, open_.mv);
					var billingPeriodDropdown = _v4.a;
					var cmd = _v4.b;
					return _Utils_Tuple3(
						$author$project$Components$Admin$SignupPages$CustomizeUrlModal$Open(
							_Utils_update(
								open_,
								{mv: billingPeriodDropdown})),
						cmd,
						_List_Nil);
				case 4:
					var selectedPeriod = msg.a;
					var newForm = A3(
						$author$project$Utils$Form$update,
						$author$project$Components$Admin$SignupPages$CustomizeUrlModal$formFieldsUpdate,
						$author$project$Components$Admin$SignupPages$CustomizeUrlModal$BillingPeriod(selectedPeriod),
						open_.SD);
					return _Utils_Tuple3(
						$author$project$Components$Admin$SignupPages$CustomizeUrlModal$Open(
							_Utils_update(
								open_,
								{SD: newForm})),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				case 5:
					var response = msg.a;
					return _Utils_Tuple3(
						$author$project$Components$Admin$SignupPages$CustomizeUrlModal$Open(
							_Utils_update(
								open_,
								{yT: response})),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				case 12:
					var response = msg.a;
					var planIds = function () {
						if (response.$ === 3) {
							var sp = response.a;
							return A2(
								$elm$core$List$map,
								A2($elm$core$Basics$composeR, $author$project$Api$Provider$SignupPagePlan$Shared$plan, $author$project$Api$Provider$Plan$Min$id),
								$author$project$Api$Provider$SignupPage$One$signupPagePlans(sp));
						} else {
							return _List_Nil;
						}
					}();
					var planFetchCmds = $elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$map,
							function (id_) {
								return A4($author$project$Api$Provider$Plan$retrieve, apiClient, id_, _List_Nil, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$GotPlanAllowedCodes);
							},
							planIds));
					return _Utils_Tuple3(
						$author$project$Components$Admin$SignupPages$CustomizeUrlModal$Open(open_),
						planFetchCmds,
						$author$project$OutMsg$handleErrorResponse(response));
				case 11:
					var response = msg.a;
					var newAllowed = function () {
						if (response.$ === 3) {
							var plan = response.a;
							return $elm_community$list_extra$List$Extra$unique(
								$author$project$Api$Provider$Plan$One$allowedBillingPeriodCodes(plan));
						} else {
							return _List_Nil;
						}
					}();
					var merged = function () {
						var _v6 = open_.Lz;
						if (!_v6.$) {
							var existing = _v6.a;
							return $elm_community$list_extra$List$Extra$unique(
								_Utils_ap(existing, newAllowed));
						} else {
							return newAllowed;
						}
					}();
					return _Utils_Tuple3(
						$author$project$Components$Admin$SignupPages$CustomizeUrlModal$Open(
							_Utils_update(
								open_,
								{
									Lz: $elm$core$Maybe$Just(merged)
								})),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				case 6:
					var subMsg = msg.a;
					var _v8 = A2($author$project$Ui$Dropdown$update, subMsg, open_.m_);
					var couponDropdown = _v8.a;
					var cmd = _v8.b;
					return _Utils_Tuple3(
						$author$project$Components$Admin$SignupPages$CustomizeUrlModal$Open(
							_Utils_update(
								open_,
								{m_: couponDropdown})),
						cmd,
						_List_Nil);
				case 7:
					var selectedCoupon = msg.a;
					var newForm = A3(
						$author$project$Utils$Form$update,
						$author$project$Components$Admin$SignupPages$CustomizeUrlModal$formFieldsUpdate,
						$author$project$Components$Admin$SignupPages$CustomizeUrlModal$Coupon(selectedCoupon),
						open_.SD);
					return _Utils_Tuple3(
						$author$project$Components$Admin$SignupPages$CustomizeUrlModal$Open(
							_Utils_update(
								open_,
								{SD: newForm})),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				case 8:
					var subMsg = msg.a;
					var leadSourceResourceResult = A3($author$project$Components$ResourceFilter$LeadSource$update, apiClient, subMsg, open_.oi);
					var newForm = function () {
						var _v9 = leadSourceResourceResult.agZ;
						if (!_v9.$) {
							return A3(
								$author$project$Utils$Form$update,
								$author$project$Components$Admin$SignupPages$CustomizeUrlModal$formFieldsUpdate,
								$author$project$Components$Admin$SignupPages$CustomizeUrlModal$LeadSource(
									$author$project$Components$ResourceFilter$LeadSource$value(leadSourceResourceResult.aiO)),
								open_.SD);
						} else {
							return open_.SD;
						}
					}();
					return _Utils_Tuple3(
						$author$project$Components$Admin$SignupPages$CustomizeUrlModal$Open(
							_Utils_update(
								open_,
								{SD: newForm, oi: leadSourceResourceResult.aiO})),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$LeadSourceResourceFilterMsg, leadSourceResourceResult.GZ),
						leadSourceResourceResult.aR);
				case 9:
					var subMsg = msg.a;
					var brokerResourceResult = A3($author$project$Components$ResourceFilter$Broker$update, apiClient, subMsg, open_.mx);
					var newForm = function () {
						var _v10 = brokerResourceResult.agZ;
						if (!_v10.$) {
							return A3(
								$author$project$Utils$Form$update,
								$author$project$Components$Admin$SignupPages$CustomizeUrlModal$formFieldsUpdate,
								$author$project$Components$Admin$SignupPages$CustomizeUrlModal$Broker(
									$author$project$Components$ResourceFilter$Broker$value(brokerResourceResult.aiO)),
								open_.SD);
						} else {
							return open_.SD;
						}
					}();
					return _Utils_Tuple3(
						$author$project$Components$Admin$SignupPages$CustomizeUrlModal$Open(
							_Utils_update(
								open_,
								{mx: brokerResourceResult.aiO, SD: newForm})),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$BrokerResourceFilterMsg, brokerResourceResult.GZ),
						brokerResourceResult.aR);
				default:
					var url = msg.a;
					return _Utils_Tuple3(
						model,
						$author$project$Ports$Clipboard$copy(url),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Copied to clipboard!')
							]));
			}
		}
	});
var $author$project$Pages$Admin$SignupPages$Top$updateUrl = function (model) {
	var queryParams = _List_Nil;
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Admin__SignupPages__Top)
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.ajJ),
				A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams))));
};
var $author$project$Pages$Admin$SignupPages$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								j4: response,
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{j4: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$reportDecodeError(response));
				}
			case 1:
				var response = msg.a;
				if (response.$ === 3) {
					var signupPages = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Qb: $elm$core$List$head(signupPages)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$reportDecodeError(response));
				}
			case 2:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Admin$SignupPages$Top$fetchItems(newModel),
								$author$project$Pages$Admin$SignupPages$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 3:
				var id = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qN: $author$project$Api$Data$Loading}),
					A3($author$project$Api$Provider$SignupPage$makeDefault, model.Gv, id, $author$project$Pages$Admin$SignupPages$Top$DefaultSignupPageUpdated),
					_List_Nil);
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{j4: $author$project$Api$Data$Loading, qN: response}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Pages$Admin$SignupPages$Top$fetchItems(model),
									$author$project$Pages$Admin$SignupPages$Top$getDefault(model)
								])),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Default page updated')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{qN: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$reportDecodeError(response));
				}
			case 5:
				var item = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							je: $elm$core$Maybe$Just(item)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 6:
				var item = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									eg: A2(
										$elm$core$Set$remove,
										$author$project$Api$Provider$SignupPage$All$id(item),
										model.eg),
									j4: $author$project$Api$Data$Loading
								}),
							$author$project$Pages$Admin$SignupPages$Top$fetchItems(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Page was successfully removed.')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									eg: A2(
										$elm$core$Set$remove,
										$author$project$Api$Provider$SignupPage$All$id(item),
										model.eg)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var item = msg.a;
				var confirmed = msg.b;
				if (confirmed) {
					var id = $author$project$Api$Provider$SignupPage$All$id(item);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								je: $elm$core$Maybe$Nothing,
								eg: A2($elm$core$Set$insert, id, model.eg)
							}),
						A3(
							$author$project$Api$Provider$SignupPage$delete,
							model.Gv,
							id,
							$author$project$Pages$Admin$SignupPages$Top$Deleted(item)),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{je: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 8:
				var item = msg.a;
				var _v5 = A2($author$project$Components$Admin$SignupPages$CustomizeUrlModal$open, item, model.f5);
				var customizeUrl = _v5.a;
				var customizeUrlCmd = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{f5: customizeUrl}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$SignupPages$Top$CustomizeUrlMsg, customizeUrlCmd),
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v6 = A3($author$project$Components$Admin$SignupPages$CustomizeUrlModal$update, model.Gv, subMsg, model.f5);
				var customizeUrl = _v6.a;
				var customizeUrlCmd = _v6.b;
				var outMsgs = _v6.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{f5: customizeUrl}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$SignupPages$Top$CustomizeUrlMsg, customizeUrlCmd),
					outMsgs);
		}
	});
var $author$project$Api$FeatureGate$MultipleSignupPages = 0;
var $author$project$Pages$Admin$SignupPages$Top$PaginationMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$SignupPages$Top$UpdateDefaultSignupPage = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$SignupPage$All$slug = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$SignupPage$Shared$slug(shared);
};
var $author$project$Pages$Admin$SignupPages$Top$defaultPageOptions = F2(
	function (items, _default) {
		var allItems = function () {
			if (!_default.$) {
				var defaultSignupPage = _default.a;
				return A2(
					$elm$core$List$cons,
					defaultSignupPage,
					A2(
						$elm$core$List$filter,
						function (item) {
							return !_Utils_eq(
								$author$project$Api$Provider$SignupPage$All$id(item),
								$author$project$Api$Provider$SignupPage$All$id(defaultSignupPage));
						},
						items));
			} else {
				return items;
			}
		}();
		return A2(
			$elm$core$List$map,
			function (item) {
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$SignupPage$All$id(item)),
					'/signup/' + $author$project$Api$Provider$SignupPage$All$slug(item));
			},
			allItems);
	});
var $author$project$Pages$Admin$SignupPages$Top$help = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$mt2]),
		function () {
			var _v0 = model.j4;
			if (_v0.$ === 3) {
				var items = _v0.a;
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$text,
						_List_fromArray(
							[$author$project$Ui$Typography$muted]),
						'Available at '),
						A3(
						$author$project$Ui$Link$externalHref,
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2($elm$core$Maybe$map, $author$project$Api$Provider$SignupPage$All$baseUrl, model.Qb)),
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									A2($elm$core$Maybe$map, $author$project$Api$Provider$SignupPage$All$baseUrl, model.Qb)))
							])),
						A2(
						$author$project$Ui$Typography$text,
						_List_fromArray(
							[$author$project$Ui$Typography$muted]),
						' which will redirect to '),
						($elm$core$List$length(items) > 1) ? A2(
						$author$project$Ui$Form$Select$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Select$inline,
								$author$project$Ui$Form$Select$value(
								A2($elm$core$Maybe$map, $author$project$Api$Provider$SignupPage$All$id, model.Qb)),
								$author$project$Ui$Form$Select$onChange($author$project$Pages$Admin$SignupPages$Top$UpdateDefaultSignupPage),
								$author$project$Ui$Form$Select$loading(
								_Utils_eq(model.qN, $author$project$Api$Data$Loading))
							]),
						A2($author$project$Pages$Admin$SignupPages$Top$defaultPageOptions, items, model.Qb)) : A2(
						$author$project$Ui$Typography$text,
						_List_fromArray(
							[$author$project$Ui$Typography$muted]),
						'/signup/' + A2(
							$elm$core$Maybe$withDefault,
							'',
							A2($elm$core$Maybe$map, $author$project$Api$Provider$SignupPage$All$slug, model.Qb)))
					]);
			} else {
				return _List_fromArray(
					[
						$author$project$Ui$Skeleton$text(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$spanFromText('Available at https://hint.com/signup/default which will redirect to Default')
							]))
					]);
			}
		}());
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$Copy = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Provider$SignupPage$Shared$url = function (_v0) {
	var record = _v0;
	return record.adY;
};
var $author$project$Api$Provider$SignupPage$All$url = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$SignupPage$Shared$url(shared);
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$buildUrl = F2(
	function (signupPage, fields) {
		var queryParams = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$map,
					$elm$url$Url$Builder$string('practitioner'),
					fields.aka),
					A2(
					$elm$core$Maybe$map,
					$elm$url$Url$Builder$string('location'),
					fields.ais),
					A2(
					$elm$core$Maybe$map,
					$elm$url$Url$Builder$string('billing_period'),
					fields.ru),
					A2(
					$elm$core$Maybe$map,
					$elm$url$Url$Builder$string('coupon'),
					fields.OP),
					A2(
					$elm$core$Maybe$map,
					$elm$url$Url$Builder$string('lead'),
					fields.VR),
					A2(
					$elm$core$Maybe$map,
					$elm$url$Url$Builder$string('broker'),
					fields.xF)
				]));
		if ($elm$core$List$isEmpty(queryParams)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var signupPageUrl = $author$project$Api$Provider$SignupPage$All$url(signupPage);
			return $elm$core$Maybe$Just(
				A2($author$project$Utils$Url$addParams, signupPageUrl, queryParams));
		}
	});
var $author$project$Api$Provider$SignupPage$All$type_ = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$SignupPage$Shared$type_(shared);
};
var $author$project$Components$ResourceFilter$Broker$view = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$view,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.Jy),
					options),
				model.b8));
	});
var $author$project$Components$ResourceFilter$LeadSource$view = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$view,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.Jy),
					options),
				model.b8));
	});
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$BillingPeriodSelected = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$normalizeBillName = function (billName) {
	return A3(
		$elm$core$String$replace,
		'-',
		'_',
		$elm$core$String$toLower(billName));
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$viewBillingPeriodDropdown = F2(
	function (model, billingPeriod) {
		var loading = _Utils_eq(model.Lz, $elm$core$Maybe$Nothing);
		var items = function () {
			if (loading) {
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Dropdown$item,
						_List_Nil,
						$elm$html$Html$text('Loading...'))
					]);
			} else {
				var allowedCodes = A2($elm$core$Maybe$withDefault, _List_Nil, model.Lz);
				var periods = A2(
					$elm$core$List$filter,
					function (p) {
						return A2(
							$elm$core$List$member,
							$author$project$Api$Period$code(p),
							allowedCodes);
					},
					$author$project$Api$Period$list);
				return A2(
					$elm$core$List$cons,
					A2(
						$author$project$Ui$Dropdown$item,
						_List_fromArray(
							[
								$author$project$Ui$Dropdown$onSelect(
								$author$project$Components$Admin$SignupPages$CustomizeUrlModal$BillingPeriodSelected($elm$core$Maybe$Nothing))
							]),
						$elm$html$Html$text('None')),
					A2(
						$elm$core$List$cons,
						$author$project$Ui$Dropdown$separator,
						A2(
							$elm$core$List$map,
							function (p) {
								var periodValue = $author$project$Components$Admin$SignupPages$CustomizeUrlModal$normalizeBillName(
									$author$project$Api$Period$billName(p));
								var periodLabel = $elm_community$string_extra$String$Extra$toSentenceCase(
									$author$project$Api$Period$billName(p));
								return A2(
									$author$project$Ui$Dropdown$item,
									_List_fromArray(
										[
											$author$project$Ui$Dropdown$onSelect(
											$author$project$Components$Admin$SignupPages$CustomizeUrlModal$BillingPeriodSelected(
												$elm$core$Maybe$Just(periodValue))),
											$author$project$Ui$Dropdown$selected(
											_Utils_eq(
												billingPeriod,
												$elm$core$Maybe$Just(periodValue)))
										]),
									$elm$html$Html$text(periodLabel));
							},
							periods)));
			}
		}();
		var currentLabel = function () {
			if (!billingPeriod.$) {
				var period = billingPeriod.a;
				return A2(
					$elm$core$Maybe$withDefault,
					'None',
					A2(
						$elm$core$Maybe$map,
						A2($elm$core$Basics$composeR, $author$project$Api$Period$billName, $elm_community$string_extra$String$Extra$toSentenceCase),
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (p) {
									return _Utils_eq(
										$author$project$Components$Admin$SignupPages$CustomizeUrlModal$normalizeBillName(
											$author$project$Api$Period$billName(p)),
										period);
								},
								$author$project$Api$Period$list))));
			} else {
				return 'None';
			}
		}();
		return A4(
			$author$project$Ui$Dropdown$viewSelect,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(currentLabel)
				]),
			items,
			model.mv);
	});
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$CouponSelected = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$viewCouponDropdown = F2(
	function (model, coupon) {
		var items = function () {
			var _v1 = model.yT;
			if (_v1.$ === 3) {
				var coupons = _v1.a;
				return A2(
					$elm$core$List$cons,
					A2(
						$author$project$Ui$Dropdown$item,
						_List_fromArray(
							[
								$author$project$Ui$Dropdown$onSelect(
								$author$project$Components$Admin$SignupPages$CustomizeUrlModal$CouponSelected($elm$core$Maybe$Nothing))
							]),
						$elm$html$Html$text('None')),
					A2(
						$elm$core$List$cons,
						$author$project$Ui$Dropdown$separator,
						A2(
							$elm$core$List$map,
							function (couponItem) {
								var couponCode = $author$project$Api$Provider$Coupon$All$code(couponItem);
								return A2(
									$author$project$Ui$Dropdown$item,
									_List_fromArray(
										[
											$author$project$Ui$Dropdown$onSelect(
											$author$project$Components$Admin$SignupPages$CustomizeUrlModal$CouponSelected(
												$elm$core$Maybe$Just(couponCode))),
											$author$project$Ui$Dropdown$selected(
											_Utils_eq(
												coupon,
												$elm$core$Maybe$Just(couponCode)))
										]),
									$elm$html$Html$text(couponCode));
							},
							coupons)));
			} else {
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Dropdown$item,
						_List_Nil,
						$elm$html$Html$text('Loading...'))
					]);
			}
		}();
		var currentLabel = function () {
			if (!coupon.$) {
				var couponCode = coupon.a;
				return couponCode;
			} else {
				return 'None';
			}
		}();
		return A4(
			$author$project$Ui$Dropdown$viewSelect,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(currentLabel)
				]),
			items,
			model.m_);
	});
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$viewModal = function (model) {
	var fields = $author$project$Utils$Form$fields(model.SD);
	var url = A2($author$project$Components$Admin$SignupPages$CustomizeUrlModal$buildUrl, model.JM, fields);
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Admin$SignupPages$CustomizeUrlModal$CloseModal,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Customize URL')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Edit the form below to generate a unique URL to send to your patients.')
							])),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$title,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Patient & Billing')
									])),
								A2(
								$author$project$Ui$Typography$text,
								_List_fromArray(
									[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
								'This information will be displayed to the patient, but can not be changed.')
							])),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpan(3),
								$author$project$Ui$Form$Group$inputSpan(9),
								$author$project$Ui$Form$Group$label('Practitioner')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$Admin$SignupPages$CustomizeUrlModal$PractitionerResourceFilterMsg,
								A2($author$project$Components$ResourceFilter$Practitioner$view, _List_Nil, model.hk))
							])),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpan(3),
								$author$project$Ui$Form$Group$inputSpan(9),
								$author$project$Ui$Form$Group$label('Location')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$Admin$SignupPages$CustomizeUrlModal$LocationResourceFilterMsg,
								A2($author$project$Components$ResourceFilter$Location$view, _List_Nil, model.os))
							])),
						($author$project$Api$Provider$SignupPage$All$type_(model.JM) === 'signup') ? A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpan(3),
								$author$project$Ui$Form$Group$inputSpan(9),
								$author$project$Ui$Form$Group$label('Billing Period')
							]),
						_List_fromArray(
							[
								A2($author$project$Components$Admin$SignupPages$CustomizeUrlModal$viewBillingPeriodDropdown, model, fields.ru)
							])) : $author$project$Utils$Html$empty,
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpan(3),
								$author$project$Ui$Form$Group$inputSpan(9),
								$author$project$Ui$Form$Group$label('Coupon')
							]),
						_List_fromArray(
							[
								A2($author$project$Components$Admin$SignupPages$CustomizeUrlModal$viewCouponDropdown, model, fields.OP)
							])),
						$author$project$Ui$HorizontalRule$view(_List_Nil),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$title,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Sales & Marketing')
									])),
								A2(
								$author$project$Ui$Typography$text,
								_List_fromArray(
									[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
								'This information will be recorded but will not be displayed to the patient.')
							])),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpan(3),
								$author$project$Ui$Form$Group$inputSpan(9),
								$author$project$Ui$Form$Group$label('Lead Source')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$Admin$SignupPages$CustomizeUrlModal$LeadSourceResourceFilterMsg,
								A2($author$project$Components$ResourceFilter$LeadSource$view, _List_Nil, model.oi))
							])),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpan(3),
								$author$project$Ui$Form$Group$inputSpan(9),
								$author$project$Ui$Form$Group$label('Broker')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$Admin$SignupPages$CustomizeUrlModal$BrokerResourceFilterMsg,
								A2($author$project$Components$ResourceFilter$Broker$view, _List_Nil, model.mx))
							])),
						$author$project$Ui$HorizontalRule$view(_List_Nil),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Once applying a form from above, copy the new url below or test it by '),
										function () {
										if (!url.$) {
											var url_ = url.a;
											return A3(
												$author$project$Ui$Link$externalHref,
												url_,
												_List_fromArray(
													[$author$project$Ui$Link$targetBlank]),
												_List_fromArray(
													[
														$elm$html$Html$text('clicking here')
													]));
										} else {
											return $elm$html$Html$text('clicking here');
										}
									}(),
										$elm$html$Html$text('.')
									])),
								$author$project$Ui$Form$Input$group(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$value(
												A2($elm$core$Maybe$withDefault, '', url)),
												$author$project$Ui$Form$Input$disabled(true)
											])),
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Copy url'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$disabled(
												!$author$project$Utils$Maybe$toBool(url)),
												$author$project$Ui$Button$onClick(
												$author$project$Components$Admin$SignupPages$CustomizeUrlModal$Copy(
													A2($elm$core$Maybe$withDefault, '', url)))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Copy')
											]))
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$muted]),
								_List_fromArray(
									[
										$elm$html$Html$text('The url generated below is not stored, but can be re-created here at any time.')
									]))
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$onClick($author$project$Components$Admin$SignupPages$CustomizeUrlModal$CloseModal)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Done')
							]))
					]))
			]));
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$view = function (model) {
	if (model.$ === 1) {
		var open_ = model.a;
		return $author$project$Components$Admin$SignupPages$CustomizeUrlModal$viewModal(open_);
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Admin$SignupPages$Top$viewNewSignupPageButton = A3(
	$author$project$Ui$Link$route,
	$author$project$Spa$Generated$Route$Admin__SignupPages__New,
	_List_fromArray(
		[
			$author$project$Ui$Link$buttonDefault,
			$author$project$Ui$Link$icon($author$project$Ui$Icon$add)
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('New Signup Page')
		]));
var $author$project$Pages$Admin$SignupPages$Top$CustomizeUrl = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Admin$SignupPages$Top$Delete = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$SignupPage$Shared$acceptsNewSignup = function (_v0) {
	var record = _v0;
	return record.KD;
};
var $author$project$Api$Provider$SignupPage$All$acceptsNewSignup = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$SignupPage$Shared$acceptsNewSignup(shared);
};
var $author$project$Api$Provider$SignupPage$All$active = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$SignupPage$Shared$active(shared);
};
var $author$project$Api$Provider$SignupPage$All$addons = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$SignupPage$Shared$addons(shared);
};
var $author$project$Api$Pagination$currentPageNumber = function (_v0) {
	var model = _v0;
	return model.bX;
};
var $author$project$Api$Provider$SignupPage$Shared$default = function (_v0) {
	var record = _v0;
	return record.PW;
};
var $author$project$Api$Provider$SignupPage$All$default = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$SignupPage$Shared$default(shared);
};
var $author$project$Api$Provider$SignupPage$Shared$listSignupPagePlans = function (signupPage) {
	return $author$project$Formatters$String$toSentence(
		A2(
			$elm$core$List$map,
			A2($elm$core$Basics$composeR, $author$project$Api$Provider$SignupPagePlan$Shared$plan, $author$project$Api$Provider$Plan$Min$name),
			$author$project$Api$Provider$SignupPage$Shared$signupPagePlans(signupPage)));
};
var $author$project$Api$Provider$SignupPage$Shared$displayName = function (signupPage) {
	return ($author$project$Api$Provider$SignupPage$Shared$type_(signupPage) === 'checkout') ? A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$ChargeItem$Min$name,
			$author$project$Api$Provider$SignupPage$Shared$chargeItem(signupPage))) : $author$project$Api$Provider$SignupPage$Shared$listSignupPagePlans(signupPage);
};
var $author$project$Api$Provider$SignupPage$All$displayName = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$SignupPage$Shared$displayName(shared);
};
var $author$project$Api$Provider$SignupPage$Shared$isDestroyable = function (_v0) {
	var record = _v0;
	return record.UN;
};
var $author$project$Api$Provider$SignupPage$All$isDestroyable = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$SignupPage$Shared$isDestroyable(shared);
};
var $author$project$Pages$Admin$SignupPages$Top$listSignupPageAddons = function (addons) {
	return $author$project$Formatters$String$toSentence(
		A2($elm$core$List$map, $author$project$Api$Provider$Addon$Shared$name, addons));
};
var $author$project$Ui$Element$ShrinkNone = {$: 18};
var $author$project$Ui$Element$shrinkNone = $author$project$Ui$Element$ShrinkNone;
var $author$project$Pages$Admin$SignupPages$Top$viewItem = F2(
	function (model, item) {
		var status = (model.Dg && ($author$project$Api$Provider$SignupPage$All$active(item) && $author$project$Api$Provider$SignupPage$All$acceptsNewSignup(item))) ? 'live' : ((!$author$project$Api$Provider$SignupPage$All$acceptsNewSignup(item)) ? 'error' : 'inactive');
		var id = $author$project$Api$Provider$SignupPage$All$id(item);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$shrinkNone]),
											_List_fromArray(
												[
													($author$project$Api$Provider$SignupPage$All$type_(item) === 'checkout') ? $author$project$Ui$Icon$cart(_List_Nil) : $author$project$Ui$Icon$onlineSignup(_List_Nil)
												])),
											$elm$html$Html$text(
											$author$project$Api$Provider$SignupPage$All$displayName(item))
										]))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$itemsStart, $author$project$Ui$Element$gap2]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Link$externalHref,
											$author$project$Api$Provider$SignupPage$All$url(item),
											_List_fromArray(
												[$author$project$Ui$Link$targetBlank]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Api$Provider$SignupPage$All$url(item))
												])),
											A3(
											$author$project$Ui$Button$view,
											{mm: 'Customize URL'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick(
													$author$project$Pages$Admin$SignupPages$Top$CustomizeUrl(item))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Customize URL')
												]))
										]))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$Ui$Badge$fromString, _List_Nil, status)
								]))
						]),
						$elm$core$List$isEmpty(model.K1) ? _List_Nil : _List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Pages$Admin$SignupPages$Top$listSignupPageAddons(
										$author$project$Api$Provider$SignupPage$All$addons(item)))
								]))
						]),
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$gap2, $author$project$Ui$Element$justifyRight]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$Admin__SignupPages__Id_String(
												{ahP: id}),
											_List_fromArray(
												[
													$author$project$Ui$Link$routeParams(
													_List_fromArray(
														[
															A2(
															$elm$url$Url$Builder$string,
															'page',
															$elm$core$String$fromInt(
																$author$project$Api$Pagination$currentPageNumber(model.ajJ)))
														])),
													$author$project$Ui$Link$sm,
													$author$project$Ui$Link$icon($author$project$Ui$Icon$edit)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Edit')
												])),
											$author$project$Api$Provider$SignupPage$All$default(item) ? A2(
											$author$project$Ui$Typography$span,
											_List_Nil,
											_List_fromArray(
												[
													A2($author$project$Ui$Badge$fromString, _List_Nil, 'default')
												])) : $author$project$Utils$Html$empty,
											function () {
											if ($author$project$Api$Provider$SignupPage$All$isDestroyable(item)) {
												var loading = A2($elm$core$Set$member, id, model.eg);
												return A3(
													$author$project$Ui$Button$view,
													{mm: 'Delete signup page'},
													_List_fromArray(
														[
															$author$project$Ui$Button$link,
															$author$project$Ui$Button$sm,
															$author$project$Ui$Button$loading(loading),
															$author$project$Ui$Button$onClick(
															$author$project$Pages$Admin$SignupPages$Top$Delete(item)),
															$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Delete')
														]));
											} else {
												return $author$project$Utils$Html$empty;
											}
										}()
										]))
								]))
						])
					])));
	});
var $author$project$Pages$Admin$SignupPages$Top$viewPanelBody = function (model) {
	var _v0 = function () {
		var _v1 = model.j4;
		if (_v1.$ === 3) {
			var items_ = _v1.a;
			return _Utils_Tuple2(false, items_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var items = _v0.b;
	return A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$verticalCentered,
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('There are no signup pages.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Plan / Charge')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Url')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Status')
							]))
					]),
					$elm$core$List$isEmpty(model.K1) ? _List_Nil : _List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Wrap-Arounds Enabled')
							]))
					]),
					_List_fromArray(
					[
						A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
					])
				])),
		A2(
			$elm$core$List$map,
			$author$project$Pages$Admin$SignupPages$Top$viewItem(model),
			items),
		_List_Nil);
};
var $author$project$Pages$Admin$SignupPages$Top$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				function () {
				var _v0 = model.je;
				if (!_v0.$) {
					var item = _v0.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Admin$SignupPages$Top$HiConfirmClosed(item),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('delete'),
								$author$project$Components$HiConfirm$noun('signup page'),
								$author$project$Components$HiConfirm$detail('. It will no longer be available for new patients to sign up')
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Admin$SignupPages$Top$CustomizeUrlMsg,
				$author$project$Components$Admin$SignupPages$CustomizeUrlModal$view(model.f5)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								model.Dg ? $author$project$Utils$Html$empty : A2(
								$author$project$Utils$PaymentProcessor$toSetupAlert,
								$author$project$Api$Practice$Provider(model.ZV),
								$elm$core$Maybe$Just('In order to enable signup pages')),
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Signup Pages')
											])),
										A3(
										$author$project$Utils$FeatureGate$gate,
										0,
										$author$project$Api$Practice$Provider(model.ZV),
										$author$project$Pages$Admin$SignupPages$Top$viewNewSignupPageButton)
									])),
								$author$project$Pages$Admin$SignupPages$Top$help(model)
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Pages$Admin$SignupPages$Top$viewPanelBody(model)
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Admin$SignupPages$Top$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(
											!$author$project$Api$Data$isSuccess(model.j4))
										]),
									model.ajJ))
							]))
					]))
			]),
		ac9: 'Admin | Signup Pages'
	};
};
var $author$project$Pages$Admin$SignupPages$Top$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$SignupPages$Top$init, aiq: $author$project$Pages$Admin$SignupPages$Top$load, k8: $author$project$Pages$Admin$SignupPages$Top$save, alO: $author$project$Pages$Admin$SignupPages$Top$subscriptions, adT: $author$project$Pages$Admin$SignupPages$Top$update, amo: $author$project$Pages$Admin$SignupPages$Top$view});
var $author$project$Pages$Admin$Stripe$StripeMsg = $elm$core$Basics$identity;
var $author$project$Components$Stripe$Connected = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Stripe$Connecting = {$: 0};
var $author$project$Components$Stripe$CreateStripeAccount = {$: 3};
var $author$project$Components$Stripe$FailedToConnect = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Stripe$GotStripeSession = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Stripe$HasStripeAccount = {$: 2};
var $author$project$Components$Stripe$Model = $elm$core$Basics$identity;
var $author$project$Api$Provider$PracticeOnboarding$Shared$accountStep = function (_v0) {
	var record = _v0;
	return record.KI;
};
var $author$project$Api$Provider$Practice$StripeAccount$connect = F3(
	function (apiClient, code, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'stripe_account',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'code',
								$elm$json$Json$Encode$string(code))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Practice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$StripeAccount$stripeAccountPath)));
	});
var $author$project$Components$Stripe$init = F5(
	function (session, practice, shared, query, _v0) {
		var isOnboarding = _v0.bb;
		var setupCompleted = A2(
			$elm$core$Maybe$withDefault,
			7,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$PracticeOnboarding$Shared$accountStep,
				$author$project$Api$Provider$Practice$One$practiceOnboarding(practice))) === 7;
		var shouldRedirectToPracticeSetupStripe = (!setupCompleted) && (!isOnboarding);
		var _v1 = function () {
			var _v2 = _Utils_Tuple2(
				A2($elm$core$Dict$get, 'error', query),
				shouldRedirectToPracticeSetupStripe);
			if (!_v2.b) {
				if (!_v2.a.$) {
					return _Utils_Tuple2(
						$author$project$Components$Stripe$FailedToConnect(
							A2($elm$core$Dict$get, 'error_description', query)),
						$elm$core$Platform$Cmd$none);
				} else {
					var _v3 = _v2.a;
					var _v4 = A2($elm$core$Dict$get, 'code', query);
					if (!_v4.$) {
						var string = _v4.a;
						return _Utils_Tuple2(
							$author$project$Components$Stripe$Connecting,
							A3($author$project$Api$Provider$Practice$StripeAccount$connect, shared.Gv, string, $author$project$Components$Stripe$Connected));
					} else {
						return $author$project$Api$Provider$Practice$One$hasStripeAccount(practice) ? _Utils_Tuple2(
							$author$project$Components$Stripe$HasStripeAccount,
							A2($author$project$Api$Provider$Practice$StripeAccount$session, shared.Gv, $author$project$Components$Stripe$GotStripeSession)) : _Utils_Tuple2($author$project$Components$Stripe$CreateStripeAccount, $elm$core$Platform$Cmd$none);
					}
				}
			} else {
				return _Utils_Tuple2(
					$author$project$Components$Stripe$CreateStripeAccount,
					A2($author$project$Utils$Route$navigate, query, $author$project$Spa$Generated$Route$PracticeSetup__PaymentProcessing));
			}
		}();
		var status = _v1.a;
		var cmd = _v1.b;
		return _Utils_Tuple2(
			{
				gf: false,
				sF: shared.sF,
				Ij: $author$project$Shared$isHintAdmin(shared),
				bb: isOnboarding,
				ZV: practice,
				aa4: session,
				alH: status,
				ad0: $author$project$Api$Platform$Session$One$user(session)
			},
			cmd);
	});
var $author$project$Pages$Admin$Stripe$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.DE;
		var _v1 = A5(
			$author$project$Components$Stripe$init,
			session,
			practice,
			shared,
			query,
			{bb: false});
		var stripe = _v1.a;
		var stripeCmd = _v1.b;
		return _Utils_Tuple2(
			{
				Gv: shared.Gv,
				Ij: $author$project$Shared$isHintAdmin(shared),
				uQ: stripe
			},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, stripeCmd));
	});
var $author$project$Pages$Admin$Stripe$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					Ij: $author$project$Shared$isHintAdmin(shared)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Stripe$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Stripe$HiConfirmClosed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Stripe$subscriptions = function (_v0) {
	var model = _v0;
	return model.gf ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$Stripe$HiConfirmClosed) : $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$Stripe$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Stripe$subscriptions(model.uQ));
};
var $author$project$Components$Stripe$Disconnected = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Stripe$PracticeOnboardingUpdated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Stripe$skipStripeSetup = F2(
	function (apiClient, practice) {
		var onboardId = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$PracticeOnboarding$Shared$id,
				$author$project$Api$Provider$Practice$One$practiceOnboarding(practice)));
		return A3($author$project$Api$Provider$PracticeOnboarding$complete, apiClient, onboardId, $author$project$Components$Stripe$PracticeOnboardingUpdated);
	});
var $author$project$Components$Stripe$update = F3(
	function (msg, _v0, apiClient) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				_v2$2:
				while (true) {
					switch (response.$) {
						case 3:
							var practice = response.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{ZV: practice, alH: $author$project$Components$Stripe$HasStripeAccount}),
								A2($author$project$Api$Provider$Practice$StripeAccount$session, apiClient, $author$project$Components$Stripe$GotStripeSession),
								_List_fromArray(
									[
										A2($author$project$OutMsg$ShowToast, 3, 'Your stripe integration has been connected.'),
										$author$project$OutMsg$PracticeUpdated(response)
									]));
						case 2:
							if (response.a.$ === 6) {
								var _v3 = response.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											alH: $author$project$Components$Stripe$FailedToConnect($elm$core$Maybe$Nothing)
										}),
									$elm$core$Platform$Cmd$none,
									$author$project$OutMsg$handleErrorResponse(response));
							} else {
								break _v2$2;
							}
						default:
							break _v2$2;
					}
				}
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{gf: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 6:
				return _Utils_Tuple3(
					model,
					A2($author$project$Components$Stripe$skipStripeSetup, apiClient, model.ZV),
					_List_Nil);
			case 8:
				return _Utils_Tuple3(
					model,
					A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Complete),
					_List_Nil);
			case 7:
				var response = msg.a;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							model,
							A2($author$project$Utils$Route$navigateAndReload, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Complete),
							_List_Nil);
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error)),
								$author$project$OutMsg$reportDecodeError(response)));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				var confirmed = msg.a;
				return confirmed ? _Utils_Tuple3(
					model,
					A2($author$project$Api$Provider$Practice$StripeAccount$disconnect, apiClient, $author$project$Components$Stripe$Disconnected),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{gf: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					var practice = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{gf: false, ZV: practice, alH: $author$project$Components$Stripe$CreateStripeAccount}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your stripe integration has been disconnected.'),
								$author$project$OutMsg$PracticeUpdated(response)
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{gf: false}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 4:
				return _Utils_Tuple3(
					model,
					$author$project$Ports$Intercom$open(model.aa4),
					_List_Nil);
			case 5:
				var _v6 = $author$project$Api$Provider$Practice$One$hasStripeAccount(model.ZV) ? _Utils_Tuple2(
					$author$project$Components$Stripe$HasStripeAccount,
					A2($author$project$Api$Provider$Practice$StripeAccount$session, apiClient, $author$project$Components$Stripe$GotStripeSession)) : _Utils_Tuple2($author$project$Components$Stripe$CreateStripeAccount, $elm$core$Platform$Cmd$none);
				var status = _v6.a;
				var cmd = _v6.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{alH: status}),
					cmd,
					_List_Nil);
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var secret = response.a;
					return _Utils_Tuple3(
						model,
						A2($author$project$Ports$Stripe$mountAccountManagementComponent, '#stripe-account-management', secret),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Admin$Stripe$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Stripe$update, subMsg, model.uQ, model.Gv);
		var stripe = _v1.a;
		var stripeCmd = _v1.b;
		var outMsgs = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{uQ: stripe}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, stripeCmd),
			outMsgs);
	});
var $author$project$Ui$Image$StripeLogo = 2;
var $author$project$Components$Stripe$viewConnectingBody = _List_fromArray(
	[
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Status'),
				$author$project$Ui$Form$Group$labelSpanSm(4),
				$author$project$Ui$Form$Group$inputSpanSm(8)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$Ui$Badge$fromString, _List_Nil, 'connecting')
					])),
				A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$helpBlock, $author$project$Ui$Typography$muted]),
				_List_fromArray(
					[
						$author$project$Ui$Spinner$view(_List_Nil)
					]))
			]))
	]);
var $author$project$Components$Stripe$viewCreateStripeAccountBody = _List_fromArray(
	[
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Status'),
				$author$project$Ui$Form$Group$labelSpanSm(4),
				$author$project$Ui$Form$Group$inputSpanSm(8)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$Ui$Badge$fromString, _List_Nil, 'inactive')
					])),
				A2(
				$author$project$Ui$Typography$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Stripe is a global payments platform that instantly enables business of all sizes to accept and process payments online. Our negotiated volume discount with Stripe can be reviewed '),
						A3(
						$author$project$Ui$Link$externalHref,
						'http://www.hint.com/pricing#stripe',
						_List_fromArray(
							[$author$project$Ui$Link$targetBlank]),
						_List_fromArray(
							[
								$elm$html$Html$text('here')
							])),
						$elm$html$Html$text('.')
					])),
				A2(
				$author$project$Ui$Typography$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('To configure this integration click \'Connect to Stripe\' and you will have the option of creating, or connecting to an existing Stripe account.')
					]))
			]))
	]);
var $author$project$Components$Stripe$SkipStripeSetup = {$: 6};
var $author$project$Api$Platform$User$Shared$email = function (_v0) {
	var record = _v0;
	return record.Rj;
};
var $author$project$Api$Platform$User$Shared$lastName = function (_v0) {
	var record = _v0;
	return record.VH;
};
var $author$project$Api$Provider$Practice$Shared$stripeClientId = function (_v0) {
	var record = _v0;
	return record.ack;
};
var $author$project$Api$Provider$Practice$One$stripeClientId = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$stripeClientId(shared);
};
var $author$project$Components$Stripe$stripeConnectBaseUrl = 'https://connect.stripe.com/oauth/authorize';
var $author$project$Api$Common$Address$Shared$stripeCountryCode = function (_v0) {
	var record = _v0;
	return record.acm;
};
var $author$project$Components$Stripe$stripeConnectUrl = function (_v0) {
	var model = _v0;
	var practiceAddress = $author$project$Api$Provider$Practice$One$address(model.ZV);
	var stripeUser = _List_fromArray(
		[
			_Utils_Tuple2(
			'first_name',
			$author$project$Api$Platform$User$Shared$firstName(model.ad0)),
			_Utils_Tuple2(
			'last_name',
			$author$project$Api$Platform$User$Shared$lastName(model.ad0)),
			_Utils_Tuple2(
			'email',
			$author$project$Api$Platform$User$Shared$email(model.ad0)),
			_Utils_Tuple2(
			'phone_number',
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$andThen,
					$author$project$Api$Common$Phone$Shared$number,
					$elm$core$List$head(
						$author$project$Api$Provider$Practice$One$phones(model.ZV))))),
			_Utils_Tuple2(
			'url',
			A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Api$Provider$Practice$One$url(model.ZV))),
			_Utils_Tuple2('product_description', 'Primary and urgent care services at a fixed monthly price'),
			_Utils_Tuple2(
			'business_name',
			$author$project$Api$Provider$Practice$One$name(model.ZV)),
			_Utils_Tuple2('business_type', 'sole_prop'),
			_Utils_Tuple2(
			'street_address',
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Maybe$andThen, $author$project$Api$Common$Address$Shared$line1, practiceAddress))),
			_Utils_Tuple2(
			'city',
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Maybe$andThen, $author$project$Api$Common$Address$Shared$city, practiceAddress))),
			_Utils_Tuple2(
			'zip',
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Maybe$andThen, $author$project$Api$Common$Address$Shared$zip, practiceAddress))),
			_Utils_Tuple2(
			'state',
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Maybe$andThen, $author$project$Api$Common$Address$Shared$state, practiceAddress))),
			_Utils_Tuple2(
			'country',
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Maybe$andThen, $author$project$Api$Common$Address$Shared$stripeCountryCode, practiceAddress)))
		]);
	var queryParams = A2(
		$elm$core$List$cons,
		A2(
			$elm$url$Url$Builder$string,
			'client_id',
			$author$project$Api$Provider$Practice$One$stripeClientId(model.ZV)),
		A2(
			$elm$core$List$cons,
			A2($elm$url$Url$Builder$string, 'response_type', 'code'),
			A2(
				$elm$core$List$cons,
				A2($elm$url$Url$Builder$string, 'scope', 'read_write'),
				A2(
					$elm$core$List$map,
					function (_v1) {
						var key = _v1.a;
						var value = _v1.b;
						return A2($elm$url$Url$Builder$string, 'stripe_user[' + (key + ']'), value);
					},
					stripeUser))));
	return A2(
		$elm$url$Url$Builder$relative,
		_List_fromArray(
			[$author$project$Components$Stripe$stripeConnectBaseUrl]),
		queryParams);
};
var $author$project$Components$Stripe$viewCreateStripeAccountFooter = function (model) {
	return model.bb ? _List_fromArray(
		[
			A3(
			$author$project$Ui$Button$view,
			{mm: 'Skip setting up stripe'},
			_List_fromArray(
				[
					$author$project$Ui$Button$secondary,
					$author$project$Ui$Button$onClick($author$project$Components$Stripe$SkipStripeSetup)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Skip')
				])),
			($author$project$Api$Provider$Practice$One$paymentProcessor(model.ZV) === 'stripe') ? A3(
			$author$project$Ui$Link$externalHref,
			$author$project$Components$Stripe$stripeConnectUrl(model),
			_List_fromArray(
				[$author$project$Ui$Link$buttonPrimary, $author$project$Ui$Link$targetBlank]),
			_List_fromArray(
				[
					$elm$html$Html$text('Connect to Stripe')
				])) : $author$project$Utils$Html$empty
		]) : (($author$project$Api$Provider$Practice$One$paymentProcessor(model.ZV) === 'stripe') ? _List_fromArray(
		[
			A3(
			$author$project$Ui$Link$externalHref,
			$author$project$Components$Stripe$stripeConnectUrl(model),
			_List_fromArray(
				[$author$project$Ui$Link$buttonPrimary, $author$project$Ui$Link$targetBlank]),
			_List_fromArray(
				[
					$elm$html$Html$text('Connect to Stripe')
				]))
		]) : _List_Nil);
};
var $author$project$Components$Stripe$viewFailedToConnectBody = function (errorDescription) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Status'),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Ui$Badge$fromString, _List_Nil, 'failed')
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$helpBlock]),
					_List_fromArray(
						[
							$author$project$Utils$FormErrors$view(
							_List_fromArray(
								[
									A2($elm$core$Maybe$withDefault, '', errorDescription)
								]))
						]))
				]))
		]);
};
var $author$project$Components$Stripe$Reset = {$: 5};
var $author$project$Components$Stripe$viewFailedToConnectFooter = function (model) {
	return _List_fromArray(
		[
			model.bb ? A3(
			$author$project$Ui$Button$view,
			{mm: 'Skip setting up stripe'},
			_List_fromArray(
				[
					$author$project$Ui$Button$secondary,
					$author$project$Ui$Button$onClick($author$project$Components$Stripe$SkipStripeSetup)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Skip')
				])) : A2($author$project$Ui$Element$view, _List_Nil, _List_Nil),
			A3(
			$author$project$Ui$Link$route,
			$author$project$Spa$Generated$Route$Admin__Stripe,
			_List_fromArray(
				[
					$author$project$Ui$Link$buttonPrimary,
					$author$project$Ui$Link$onClick($author$project$Components$Stripe$Reset)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Start over')
				]))
		]);
};
var $author$project$Components$Stripe$Disconnect = {$: 1};
var $author$project$Components$Stripe$ShowSupportChat = {$: 4};
var $author$project$Components$Stripe$viewHasStripeAccountBody = function (model) {
	return _Utils_ap(
		$author$project$Components$Stripe$ConnectedView$view(
			{afG: true, agz: $elm$core$Maybe$Nothing, Ij: model.Ij, ajf: $author$project$Components$Stripe$Disconnect, ajv: $author$project$Components$Stripe$ShowSupportChat, ZV: model.ZV}),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id('stripe-account-management')
					]),
				_List_Nil)
			]));
};
var $author$project$Components$Stripe$PracticeOnboardingRedirect = {$: 8};
var $author$project$Components$Stripe$viewHasStripeAccountFooter = function (model) {
	return _List_fromArray(
		[
			model.bb ? A3(
			$author$project$Ui$Button$view,
			{mm: 'Go to next step'},
			_List_fromArray(
				[
					$author$project$Ui$Button$primary,
					$author$project$Ui$Button$onClick($author$project$Components$Stripe$PracticeOnboardingRedirect)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Next')
				])) : $author$project$Utils$Html$empty
		]);
};
var $author$project$Components$Stripe$view = function (_v0) {
	var model = _v0;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				model.gf ? A2(
				$author$project$Components$HiConfirm$modal,
				$author$project$Components$Stripe$HiConfirmClosed,
				_List_fromArray(
					[
						$author$project$Components$HiConfirm$customMessage(
						_List_fromArray(
							[
								$elm$html$Html$text('WARNING: You\'re about to remove your ability to process credit cards and bank accounts! Please be sure this is what you want to do. If you reconnect the same Stripe account, then all existing cards / bank accounts will remain intact. Otherwise, they will not. Either way, this application will not be able to process any electronic transactions for you while you\'re account is disconnected.')
							]))
					])) : $author$project$Utils$Html$empty,
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$noValidate(true),
						$author$project$Ui$Form$autocomplete(false)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						model.bb ? _List_fromArray(
							[$author$project$Ui$Panel$onlyBorderLeft]) : _List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Setup Stripe Account')
											])),
										A2(
										$author$project$Ui$Typography$p,
										_List_fromArray(
											[$author$project$Ui$Typography$muted]),
										_List_fromArray(
											[
												$elm$html$Html$text('We partner with Stripe for secure payments, and setting up your Stripe account is a necessary step to ensure you can receive payments. This step takes about 10 minutes to complete.')
											])),
										($author$project$Api$Provider$Practice$One$paymentProcessor(model.ZV) !== 'stripe') ? A2(
										$author$project$Ui$Alert$warning,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Connecting to Stripe its not possible for practices using Hint Payments.')
											])) : $author$project$Utils$Html$empty,
										A4(
										$author$project$Ui$Image$view,
										model.sF,
										{LD: 'Stripe Logo'},
										_List_fromArray(
											[
												$author$project$Ui$Image$width(200)
											]),
										2)
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								function () {
									var _v1 = model.alH;
									switch (_v1.$) {
										case 0:
											return $author$project$Components$Stripe$viewConnectingBody;
										case 1:
											var description = _v1.a;
											return $author$project$Components$Stripe$viewFailedToConnectBody(description);
										case 2:
											return $author$project$Components$Stripe$viewHasStripeAccountBody(model);
										default:
											return $author$project$Components$Stripe$viewCreateStripeAccountBody;
									}
								}()),
								function () {
								var _v2 = model.alH;
								switch (_v2.$) {
									case 1:
										return A2(
											$author$project$Ui$Panel$footer,
											_List_fromArray(
												[$author$project$Ui$Element$spaceBetween]),
											$author$project$Components$Stripe$viewFailedToConnectFooter(model));
									case 3:
										return A2(
											$author$project$Ui$Panel$footer,
											_List_fromArray(
												[$author$project$Ui$Element$spaceBetween]),
											$author$project$Components$Stripe$viewCreateStripeAccountFooter(model));
									case 2:
										return A2(
											$author$project$Ui$Panel$footer,
											_List_fromArray(
												[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$gap2]),
											$author$project$Components$Stripe$viewHasStripeAccountFooter(model));
									default:
										return $author$project$Ui$Panel$none;
								}
							}()
							]))
					]))
			]));
};
var $author$project$Pages$Admin$Stripe$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Stripe$view(model.uQ))
			]),
		ac9: 'Admin | Stripe'
	};
};
var $author$project$Pages$Admin$Stripe$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Stripe$init, aiq: $author$project$Pages$Admin$Stripe$load, k8: $author$project$Pages$Admin$Stripe$save, alO: $author$project$Pages$Admin$Stripe$subscriptions, adT: $author$project$Pages$Admin$Stripe$update, amo: $author$project$Pages$Admin$Stripe$view});
var $author$project$Pages$Admin$Taxes$TaxJurisdictionsMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$Taxes$TaxProfilesMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$Taxes$TaxJurisdictions$Model = $elm$core$Basics$identity;
var $author$project$Components$Admin$Taxes$TaxJurisdictions$GotData = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$TaxJurisdiction$All$TaxJurisdiction = $elm$core$Basics$identity;
var $author$project$Api$Provider$TaxJurisdiction$Shared$TaxJurisdiction = $elm$core$Basics$identity;
var $author$project$Api$Provider$TaxJurisdiction$Shared$Record = F3(
	function (id, name, rate) {
		return {ahP: id, Bq: name, _1: rate};
	});
var $author$project$Api$Provider$TaxJurisdiction$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'rate',
	$elm$json$Json$Decode$float,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$TaxJurisdiction$Shared$Record))));
var $author$project$Api$Provider$TaxJurisdiction$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$TaxJurisdiction$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$TaxJurisdiction$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$TaxJurisdiction$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$TaxJurisdiction$taxJurisdictionsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['tax_jurisdictions']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$TaxJurisdiction$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$TaxJurisdiction$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$TaxJurisdiction$taxJurisdictionsPath));
	});
var $author$project$Components$Admin$Taxes$TaxJurisdictions$fetchTaxJurisdictions = function (apiClient) {
	return A2($author$project$Api$Provider$TaxJurisdiction$list, apiClient, $author$project$Components$Admin$Taxes$TaxJurisdictions$GotData);
};
var $author$project$Components$Admin$Taxes$TaxJurisdictions$init = function (apiClient) {
	var model = {jh: $elm$core$Maybe$Nothing, em: $elm$core$Set$empty, u4: $elm$core$Maybe$Nothing, acW: $author$project$Api$Data$Loading};
	return _Utils_Tuple2(
		model,
		$author$project$Components$Admin$Taxes$TaxJurisdictions$fetchTaxJurisdictions(apiClient));
};
var $author$project$Components$Admin$Taxes$TaxProfiles$GotTaxJurisdictions = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$Taxes$TaxProfiles$Model = $elm$core$Basics$identity;
var $author$project$Components$Admin$Taxes$TaxProfiles$GotTaxProfiles = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$TaxProfile$All$TaxProfile = $elm$core$Basics$identity;
var $author$project$Api$Provider$TaxProfile$One$TaxProfile = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$TaxProfile$Shared$TaxProfile = $elm$core$Basics$identity;
var $author$project$Api$Provider$TaxProfile$Shared$Record = F3(
	function (id, name, rate) {
		return {ahP: id, Bq: name, _1: rate};
	});
var $author$project$Api$Provider$TaxProfile$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'rate',
	$elm$json$Json$Decode$float,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$TaxProfile$Shared$Record))));
var $author$project$Api$Provider$TaxProfile$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$TaxProfile$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$TaxProfile$One$Record = function (taxJurisdictions) {
	return {acW: taxJurisdictions};
};
var $author$project$Api$Provider$TaxProfile$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'tax_jurisdictions',
	$elm$json$Json$Decode$list($author$project$Api$Provider$TaxJurisdiction$Shared$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$TaxProfile$One$Record));
var $author$project$Api$Provider$TaxProfile$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$TaxProfile$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$TaxProfile$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$TaxProfile$One$TaxProfile)));
var $author$project$Api$Provider$TaxProfile$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$TaxProfile$One$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$TaxProfile$taxProfilesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['tax_profiles']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$TaxProfile$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$TaxProfile$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$TaxProfile$taxProfilesPath));
	});
var $author$project$Components$Admin$Taxes$TaxProfiles$fetchTaxProfiles = function (apiClient) {
	return A2($author$project$Api$Provider$TaxProfile$list, apiClient, $author$project$Components$Admin$Taxes$TaxProfiles$GotTaxProfiles);
};
var $author$project$Components$Admin$Taxes$TaxProfiles$init = function (apiClient) {
	var model = {ji: $elm$core$Maybe$Nothing, en: $elm$core$Set$empty, acW: $author$project$Api$Data$Loading, acX: $elm$core$Maybe$Nothing, hU: $author$project$Api$Data$Loading};
	return _Utils_Tuple2(
		model,
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($author$project$Api$Provider$TaxJurisdiction$list, apiClient, $author$project$Components$Admin$Taxes$TaxProfiles$GotTaxJurisdictions),
					$author$project$Components$Admin$Taxes$TaxProfiles$fetchTaxProfiles(apiClient)
				])));
};
var $author$project$Pages$Admin$Taxes$init = F4(
	function (_v0, _v1, _v2, _v3) {
		var apiClient = _v2.Gv;
		var _v4 = $author$project$Components$Admin$Taxes$TaxProfiles$init(apiClient);
		var taxProfiles = _v4.a;
		var taxProfilesCmd = _v4.b;
		var _v5 = $author$project$Components$Admin$Taxes$TaxJurisdictions$init(apiClient);
		var taxJurisdictions = _v5.a;
		var taxJurisdictionsCmd = _v5.b;
		return _Utils_Tuple2(
			{Gv: apiClient, acW: taxJurisdictions, hU: taxProfiles},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Taxes$TaxProfilesMsg, taxProfilesCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Taxes$TaxJurisdictionsMsg, taxJurisdictionsCmd)
					])));
	});
var $author$project$Pages$Admin$Taxes$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Taxes$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Admin$Taxes$TaxJurisdictions$CancelEdit = {$: 2};
var $author$project$Components$Admin$Taxes$TaxJurisdictions$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Components$Admin$Taxes$TaxJurisdictions$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Admin$Taxes$TaxJurisdictions$CancelEdit)),
					model.u4)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Admin$Taxes$TaxJurisdictions$HiConfirmClosed),
					model.jh))
			]));
};
var $author$project$Components$Admin$Taxes$TaxProfiles$CancelEdit = {$: 4};
var $author$project$Components$Admin$Taxes$TaxProfiles$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Components$Admin$Taxes$TaxProfiles$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				function () {
				var _v1 = model.acX;
				if (!_v1.$) {
					return $author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Admin$Taxes$TaxProfiles$CancelEdit);
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Admin$Taxes$TaxProfiles$HiConfirmClosed),
					model.ji))
			]));
};
var $author$project$Pages$Admin$Taxes$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$Taxes$TaxJurisdictionsMsg,
				$author$project$Components$Admin$Taxes$TaxJurisdictions$subscriptions(model.acW)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$Taxes$TaxProfilesMsg,
				$author$project$Components$Admin$Taxes$TaxProfiles$subscriptions(model.hU))
			]));
};
var $author$project$Components$Admin$Taxes$TaxProfiles$taxJurisdictionsUpdated = F2(
	function (apiClient, _v0) {
		var model = _v0;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{acW: $author$project$Api$Data$Loading, hU: $author$project$Api$Data$Loading}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Api$Provider$TaxJurisdiction$list, apiClient, $author$project$Components$Admin$Taxes$TaxProfiles$GotTaxJurisdictions),
						$author$project$Components$Admin$Taxes$TaxProfiles$fetchTaxProfiles(apiClient)
					])));
	});
var $author$project$Components$Admin$Taxes$TaxJurisdictions$Deleted = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Components$Admin$Taxes$TaxJurisdictions$None = 0;
var $author$project$Components$Admin$Taxes$TaxJurisdictions$TaxJurisdictionsUpdated = 1;
var $author$project$Components$Admin$Taxes$TaxJurisdictions$Created = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$TaxJurisdiction$One$TaxJurisdiction = $elm$core$Basics$identity;
var $author$project$Api$Provider$TaxJurisdiction$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$TaxJurisdiction$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$TaxJurisdiction$create = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'tax_jurisdiction',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(fields.Bq)),
								_Utils_Tuple2(
								'rate',
								$elm$json$Json$Encode$float(fields._1))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$TaxJurisdiction$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$TaxJurisdiction$taxJurisdictionsPath)));
	});
var $author$project$Components$Admin$Taxes$TaxJurisdictions$create = F2(
	function (apiClient, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var apiFields = {
			Bq: fields.Bq,
			_1: A2(
				$elm$core$Maybe$withDefault,
				0,
				A2($elm$core$Maybe$andThen, $author$project$Percentage$toFloat, fields._1))
		};
		return A3($author$project$Api$Provider$TaxJurisdiction$create, apiClient, apiFields, $author$project$Components$Admin$Taxes$TaxJurisdictions$Created);
	});
var $author$project$Api$Provider$TaxJurisdiction$taxJurisdictionPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$TaxJurisdiction$taxJurisdictionsPath);
};
var $author$project$Api$Provider$TaxJurisdiction$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$TaxJurisdiction$taxJurisdictionPath(id_)));
	});
var $author$project$Components$Admin$Taxes$TaxJurisdictions$formFieldsInit = {Bq: '', _1: $elm$core$Maybe$Nothing};
var $author$project$Components$Admin$Taxes$TaxJurisdictions$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var string = field.a;
			return _Utils_update(
				fields,
				{Bq: string});
		} else {
			var _float = field.a;
			return _Utils_update(
				fields,
				{_1: _float});
		}
	});
var $author$project$Components$Admin$Taxes$TaxJurisdictions$NameValidation = 0;
var $author$project$Components$Admin$Taxes$TaxJurisdictions$RateValidation = 1;
var $author$project$Components$Admin$Taxes$TaxJurisdictions$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.Bq;
			},
			_Utils_Tuple2(0, 'Please enter a name.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $._1;
			},
			_Utils_Tuple2(1, 'Please enter a rate.'))
		]));
var $author$project$Api$Provider$TaxJurisdiction$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$TaxJurisdiction$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$TaxJurisdiction$Shared$id(shared);
};
var $author$project$Api$Provider$TaxJurisdiction$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$TaxJurisdiction$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$TaxJurisdiction$Shared$name(shared);
};
var $author$project$Api$Provider$TaxJurisdiction$One$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$TaxJurisdiction$Shared$name(shared);
};
var $author$project$Components$Admin$Taxes$TaxJurisdictions$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{acW: response}),
					aR: $author$project$OutMsg$reportDecodeError(response)
				};
			case 1:
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							u4: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init($author$project$Components$Admin$Taxes$TaxJurisdictions$formFieldsInit),
									$author$project$Api$Data$NotAsked))
						}),
					aR: _List_Nil
				};
			case 2:
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{u4: $elm$core$Maybe$Nothing}),
					aR: _List_Nil
				};
			case 3:
				var field = msg.a;
				var _v2 = model.u4;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var id = _v3.a;
					var form = _v3.b;
					var taxJurisdiction = _v3.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Admin$Taxes$TaxJurisdictions$formFieldsUpdate, field, form);
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{
								u4: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, taxJurisdiction))
							}),
						aR: _List_Nil
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
			case 5:
				var form = msg.a;
				var id = msg.b;
				var _v4 = A2($author$project$Utils$Form$validate, $author$project$Components$Admin$Taxes$TaxJurisdictions$formFieldsValidator, form);
				if (!_v4.$) {
					var _v5 = _v4.a;
					var newForm = _v5.a;
					var validFormFields = _v5.b;
					return {
						GZ: A2($author$project$Components$Admin$Taxes$TaxJurisdictions$create, apiClient, validFormFields),
						agZ: 0,
						aiO: _Utils_update(
							model,
							{
								u4: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, $author$project$Api$Data$Loading))
							}),
						aR: _List_Nil
					};
				} else {
					var newForm = _v4.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{
								u4: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, $author$project$Api$Data$NotAsked))
							}),
						aR: _List_Nil
					};
				}
			case 4:
				var taxJurisdiction = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							jh: $elm$core$Maybe$Just(taxJurisdiction)
						}),
					aR: _List_Nil
				};
			case 6:
				var response = msg.a;
				var _v6 = model.u4;
				if (!_v6.$) {
					var _v7 = _v6.a;
					var id = _v7.a;
					var form = _v7.b;
					if (response.$ === 3) {
						var taxJurisdiction = response.a;
						return {
							GZ: $author$project$Components$Admin$Taxes$TaxJurisdictions$fetchTaxJurisdictions(apiClient),
							agZ: 1,
							aiO: _Utils_update(
								model,
								{u4: $elm$core$Maybe$Nothing, acW: $author$project$Api$Data$Loading}),
							aR: _List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									'Successfully created ' + $author$project$Api$Provider$TaxJurisdiction$One$name(taxJurisdiction))
								])
						};
					} else {
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 0,
							aiO: _Utils_update(
								model,
								{
									u4: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							aR: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
			case 7:
				var taxJurisdiction = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return {
							GZ: $author$project$Components$Admin$Taxes$TaxJurisdictions$fetchTaxJurisdictions(apiClient),
							agZ: 1,
							aiO: _Utils_update(
								model,
								{
									em: A2(
										$elm$core$Set$remove,
										$author$project$Api$Provider$TaxJurisdiction$All$id(taxJurisdiction),
										model.em),
									acW: $author$project$Api$Data$Loading
								}),
							aR: _List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Provider$TaxJurisdiction$All$name(taxJurisdiction) + ' was successfully removed.')
								])
						};
					case 2:
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 0,
							aiO: _Utils_update(
								model,
								{
									em: A2(
										$elm$core$Set$remove,
										$author$project$Api$Provider$TaxJurisdiction$All$id(taxJurisdiction),
										model.em)
								}),
							aR: $author$project$OutMsg$handleErrorResponse(response)
						};
					default:
						return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
			default:
				var taxJurisdiction = msg.a;
				var confirmed = msg.b;
				if (confirmed) {
					var id = $author$project$Api$Provider$TaxJurisdiction$All$id(taxJurisdiction);
					return {
						GZ: A3(
							$author$project$Api$Provider$TaxJurisdiction$delete,
							apiClient,
							id,
							$author$project$Components$Admin$Taxes$TaxJurisdictions$Deleted(taxJurisdiction)),
						agZ: 0,
						aiO: _Utils_update(
							model,
							{
								jh: $elm$core$Maybe$Nothing,
								em: A2($elm$core$Set$insert, id, model.em)
							}),
						aR: _List_Nil
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{jh: $elm$core$Maybe$Nothing}),
						aR: _List_Nil
					};
				}
		}
	});
var $author$project$Components$Admin$Taxes$TaxProfiles$Deleted = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Api$Provider$TaxProfile$taxProfilePath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$TaxProfile$taxProfilesPath);
};
var $author$project$Api$Provider$TaxProfile$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$TaxProfile$taxProfilePath(id_)));
	});
var $author$project$Api$Provider$TaxProfile$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$TaxProfile$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$TaxProfile$Shared$name(shared);
};
var $author$project$Api$Provider$TaxProfile$All$name = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$TaxProfile$One$name(one);
};
var $author$project$Api$Provider$TaxProfile$One$taxJurisdictions = function (_v0) {
	var record = _v0.b;
	return record.acW;
};
var $author$project$Api$Provider$TaxProfile$All$taxJurisdictions = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$TaxProfile$One$taxJurisdictions(one);
};
var $author$project$Components$Admin$Taxes$TaxProfiles$formFieldsFromTaxProfile = function (taxProfile) {
	return {
		Bq: $author$project$Api$Provider$TaxProfile$All$name(taxProfile),
		acW: $elm$core$Set$fromList(
			A2(
				$elm$core$List$map,
				$author$project$Api$Provider$TaxJurisdiction$Shared$id,
				$author$project$Api$Provider$TaxProfile$All$taxJurisdictions(taxProfile)))
	};
};
var $author$project$Components$Admin$Taxes$TaxProfiles$formFieldsInit = {Bq: '', acW: $elm$core$Set$empty};
var $author$project$Components$Admin$Taxes$TaxProfiles$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var string = field.a;
			return _Utils_update(
				fields,
				{Bq: string});
		} else {
			var id = field.a;
			var bool = field.b;
			var taxJurisdictions = bool ? A2($elm$core$Set$insert, id, fields.acW) : A2($elm$core$Set$remove, id, fields.acW);
			return _Utils_update(
				fields,
				{acW: taxJurisdictions});
		}
	});
var $author$project$Components$Admin$Taxes$TaxProfiles$NameValidation = 0;
var $author$project$Components$Admin$Taxes$TaxProfiles$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.Bq;
			},
			_Utils_Tuple2(0, 'Please enter a name.'))
		]));
var $author$project$Api$Provider$TaxProfile$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$TaxProfile$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$TaxProfile$Shared$id(shared);
};
var $author$project$Api$Provider$TaxProfile$All$id = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$TaxProfile$One$id(one);
};
var $author$project$Components$Admin$Taxes$TaxProfiles$Created = function (a) {
	return {$: 8, a: a};
};
var $elm$core$Set$foldl = F3(
	function (func, initialState, _v0) {
		var dict = _v0;
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (key, _v1, state) {
					return A2(func, key, state);
				}),
			initialState,
			dict);
	});
var $elm$json$Json$Encode$set = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$Set$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $author$project$Api$Provider$TaxProfile$create = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'tax_profile',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(fields.Bq)),
								_Utils_Tuple2(
								'tax_jurisdictions',
								A2($elm$json$Json$Encode$set, $author$project$Utils$Encode$association, fields.acW))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$TaxProfile$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$TaxProfile$taxProfilesPath)));
	});
var $author$project$Components$Admin$Taxes$TaxProfiles$create = F2(
	function (apiClient, formFields) {
		return A3(
			$author$project$Api$Provider$TaxProfile$create,
			apiClient,
			$rtfeldman$elm_validate$Validate$fromValid(formFields),
			$author$project$Components$Admin$Taxes$TaxProfiles$Created);
	});
var $author$project$Components$Admin$Taxes$TaxProfiles$Updated = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Provider$TaxProfile$update = F4(
	function (apiClient, id_, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'tax_profile',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(fields.Bq)),
								_Utils_Tuple2(
								'tax_jurisdictions',
								A2($elm$json$Json$Encode$set, $author$project$Utils$Encode$association, fields.acW))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$TaxProfile$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$TaxProfile$taxProfilePath(id_))));
	});
var $author$project$Components$Admin$Taxes$TaxProfiles$updateTaxProfile = F3(
	function (apiClient, id, formFields) {
		return A4(
			$author$project$Api$Provider$TaxProfile$update,
			apiClient,
			id,
			$rtfeldman$elm_validate$Validate$fromValid(formFields),
			$author$project$Components$Admin$Taxes$TaxProfiles$Updated);
	});
var $author$project$Components$Admin$Taxes$TaxProfiles$save = F3(
	function (apiClient, maybeId, formFields) {
		if (!maybeId.$) {
			var id_ = maybeId.a;
			return A3($author$project$Components$Admin$Taxes$TaxProfiles$updateTaxProfile, apiClient, id_, formFields);
		} else {
			return A2($author$project$Components$Admin$Taxes$TaxProfiles$create, apiClient, formFields);
		}
	});
var $author$project$Components$Admin$Taxes$TaxProfiles$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{acW: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$reportDecodeError(response));
			case 1:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{hU: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$reportDecodeError(response));
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							acX: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init($author$project$Components$Admin$Taxes$TaxProfiles$formFieldsInit),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var taxProfile = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							acX: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(
										$author$project$Api$Provider$TaxProfile$All$id(taxProfile)),
									$author$project$Utils$Form$init(
										$author$project$Components$Admin$Taxes$TaxProfiles$formFieldsFromTaxProfile(taxProfile)),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{acX: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var field = msg.a;
				var _v2 = model.acX;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var id = _v3.a;
					var form = _v3.b;
					var taxProfile = _v3.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Admin$Taxes$TaxProfiles$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								acX: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, taxProfile))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var form = msg.a;
				var id = msg.b;
				var _v4 = A2($author$project$Utils$Form$validate, $author$project$Components$Admin$Taxes$TaxProfiles$formFieldsValidator, form);
				if (!_v4.$) {
					var _v5 = _v4.a;
					var newForm = _v5.a;
					var validFormFields = _v5.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								acX: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, $author$project$Api$Data$Loading))
							}),
						A3($author$project$Components$Admin$Taxes$TaxProfiles$save, apiClient, id, validFormFields),
						_List_Nil);
				} else {
					var newForm = _v4.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								acX: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 6:
				var taxProfile = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ji: $elm$core$Maybe$Just(taxProfile)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 8:
				var response = msg.a;
				var _v6 = model.acX;
				if (!_v6.$) {
					var _v7 = _v6.a;
					var id = _v7.a;
					var form = _v7.b;
					if (response.$ === 3) {
						var taxProfile = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{acX: $elm$core$Maybe$Nothing, hU: $author$project$Api$Data$Loading}),
							$author$project$Components$Admin$Taxes$TaxProfiles$fetchTaxProfiles(apiClient),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									'Successfully created ' + $author$project$Api$Provider$TaxProfile$One$name(taxProfile))
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									acX: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var response = msg.a;
				var _v9 = model.acX;
				if (!_v9.$) {
					var _v10 = _v9.a;
					var id = _v10.a;
					var form = _v10.b;
					if (response.$ === 3) {
						var taxProfile = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{acX: $elm$core$Maybe$Nothing, hU: $author$project$Api$Data$Loading}),
							$author$project$Components$Admin$Taxes$TaxProfiles$fetchTaxProfiles(apiClient),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Provider$TaxProfile$One$name(taxProfile) + ' was successfully updated.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									acX: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 10:
				var taxProfile = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									en: A2(
										$elm$core$Set$remove,
										$author$project$Api$Provider$TaxProfile$All$id(taxProfile),
										model.en),
									hU: $author$project$Api$Data$Loading
								}),
							$author$project$Components$Admin$Taxes$TaxProfiles$fetchTaxProfiles(apiClient),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Provider$TaxProfile$All$name(taxProfile) + ' was successfully removed.')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									en: A2(
										$elm$core$Set$remove,
										$author$project$Api$Provider$TaxProfile$All$id(taxProfile),
										model.en)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var taxProfile = msg.a;
				var confirmed = msg.b;
				if (confirmed) {
					var id = $author$project$Api$Provider$TaxProfile$All$id(taxProfile);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ji: $elm$core$Maybe$Nothing,
								en: A2($elm$core$Set$insert, id, model.en)
							}),
						A3(
							$author$project$Api$Provider$TaxProfile$delete,
							apiClient,
							id,
							$author$project$Components$Admin$Taxes$TaxProfiles$Deleted(taxProfile)),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ji: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
		}
	});
var $author$project$Pages$Admin$Taxes$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var subMsg = msg.a;
			var _v1 = A3($author$project$Components$Admin$Taxes$TaxProfiles$update, model.Gv, subMsg, model.hU);
			var taxProfiles = _v1.a;
			var subCmd = _v1.b;
			var subOutMsg = _v1.c;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{hU: taxProfiles}),
				A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Taxes$TaxProfilesMsg, subCmd),
				subOutMsg);
		} else {
			var subMsg = msg.a;
			var result = A3($author$project$Components$Admin$Taxes$TaxJurisdictions$update, model.Gv, subMsg, model.acW);
			var _v2 = function () {
				var _v3 = result.agZ;
				if (!_v3) {
					return _Utils_Tuple2(model.hU, $elm$core$Platform$Cmd$none);
				} else {
					return A2($author$project$Components$Admin$Taxes$TaxProfiles$taxJurisdictionsUpdated, model.Gv, model.hU);
				}
			}();
			var taxProfiles = _v2.a;
			var taxProfilesCmd = _v2.b;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{acW: result.aiO, hU: taxProfiles}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Taxes$TaxProfilesMsg, taxProfilesCmd),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Taxes$TaxJurisdictionsMsg, result.GZ)
						])),
				result.aR);
		}
	});
var $author$project$Components$Admin$Taxes$TaxJurisdictions$New = {$: 1};
var $author$project$Components$Admin$Taxes$TaxJurisdictions$help = _List_fromArray(
	[
		$elm$html$Html$text('Tax jurisdictions represent each individual area that levies a sales tax. '),
		$elm$html$Html$text('These include states, counties, cities, and municipalities. For more information, please refer to our '),
		A3(
		$author$project$Ui$Link$externalHref,
		'https://support.hint.com/account-configuration/creating-sales-tax-profiles-and-jurisdictions',
		_List_fromArray(
			[$author$project$Ui$Link$targetBlank]),
		_List_fromArray(
			[
				$elm$html$Html$text('help docs')
			])),
		$elm$html$Html$text('.')
	]);
var $author$project$Components$Admin$Taxes$TaxJurisdictions$FormUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$Taxes$TaxJurisdictions$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$Taxes$TaxJurisdictions$Rate = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$Taxes$TaxJurisdictions$Save = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Ui$Form$PercentageInput$Errors = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Form$PercentageInput$errors = $author$project$Ui$Form$PercentageInput$Errors;
var $author$project$Components$Admin$Taxes$TaxJurisdictions$viewModal = F3(
	function (id, form, taxJurisdiction) {
		var modalConfig = {
			Tq: $elm$core$Maybe$Nothing,
			aih: 'Sales Tax Jurisdiction',
			V8: _Utils_eq(taxJurisdiction, $author$project$Api$Data$Loading),
			WG: id,
			WH: $elm$core$Maybe$Nothing,
			Yd: $author$project$Components$Admin$Taxes$TaxJurisdictions$CancelEdit,
			Yf: $author$project$Components$Admin$Taxes$TaxJurisdictions$Save(form)
		};
		var _v0 = $author$project$Utils$Form$fields(form);
		var name = _v0.Bq;
		var rate = _v0._1;
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Name'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(name),
									$author$project$Ui$Form$Input$placeholder('City of San Francisco, CA'),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$Admin$Taxes$TaxJurisdictions$FormUpdated, $author$project$Components$Admin$Taxes$TaxJurisdictions$Name)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 0, form))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Rate'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$PercentageInput$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$PercentageInput$value(rate),
									$author$project$Ui$Form$PercentageInput$placeholder('1.25'),
									$author$project$Ui$Form$PercentageInput$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$Admin$Taxes$TaxJurisdictions$FormUpdated, $author$project$Components$Admin$Taxes$TaxJurisdictions$Rate)),
									$author$project$Ui$Form$PercentageInput$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
									$author$project$Ui$Form$PercentageInput$errors(
									A2($author$project$Utils$Form$validationErrors, 1, form))
								]))
						]))
				]));
	});
var $author$project$Components$Admin$Taxes$TaxJurisdictions$Delete = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$TaxJurisdiction$Shared$rate = function (_v0) {
	var record = _v0;
	return record._1;
};
var $author$project$Api$Provider$TaxJurisdiction$All$rate = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$TaxJurisdiction$Shared$rate(shared);
};
var $author$project$Components$Admin$Taxes$TaxJurisdictions$viewTaxJurisdiction = F2(
	function (deletingTaxJurisdictions, taxJurisdiction) {
		var id = $author$project$Api$Provider$TaxJurisdiction$All$id(taxJurisdiction);
		var loading = A2($elm$core$Set$member, id, deletingTaxJurisdictions);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$TaxJurisdiction$All$name(taxJurisdiction))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromFloat(
								$author$project$Api$Provider$TaxJurisdiction$All$rate(taxJurisdiction)) + '%')
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$textRight]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Delete tax jurisdiction'},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$sm,
									$author$project$Ui$Button$loading(loading),
									$author$project$Ui$Button$onClick(
									$author$project$Components$Admin$Taxes$TaxJurisdictions$Delete(taxJurisdiction)),
									$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Delete')
								]))
						]))
				]));
	});
var $author$project$Components$Admin$Taxes$TaxJurisdictions$viewPanelBody = function (model) {
	var _v0 = function () {
		var _v1 = model.acW;
		if (_v1.$ === 3) {
			var taxJurisdictions_ = _v1.a;
			return _Utils_Tuple2(false, taxJurisdictions_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var taxJurisdictions = _v0.b;
	return _List_fromArray(
		[
			A4(
			$author$project$Ui$Table$view,
			_List_fromArray(
				[
					$author$project$Ui$Table$verticalCentered,
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('None')
						])),
					$author$project$Ui$Table$loading(loading)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$header,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Name')
						])),
					A2(
					$author$project$Ui$Table$header,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Rate')
						])),
					A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
				]),
			A2(
				$elm$core$List$map,
				$author$project$Components$Admin$Taxes$TaxJurisdictions$viewTaxJurisdiction(model.em),
				taxJurisdictions),
			_List_Nil)
		]);
};
var $author$project$Components$Admin$Taxes$TaxJurisdictions$view = function (_v0) {
	var model = _v0;
	return _List_fromArray(
		[
			function () {
			var _v1 = model.u4;
			if (!_v1.$) {
				var _v2 = _v1.a;
				var id = _v2.a;
				var form = _v2.b;
				var taxJurisdiction = _v2.c;
				return A3($author$project$Components$Admin$Taxes$TaxJurisdictions$viewModal, id, form, taxJurisdiction);
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			function () {
			var _v3 = model.jh;
			if (!_v3.$) {
				var taxJurisdiction = _v3.a;
				return A2(
					$author$project$Components$HiConfirm$modal,
					$author$project$Components$Admin$Taxes$TaxJurisdictions$HiConfirmClosed(taxJurisdiction),
					_List_fromArray(
						[
							$author$project$Components$HiConfirm$verb('delete'),
							$author$project$Components$HiConfirm$noun('jurisdiction'),
							$author$project$Components$HiConfirm$detail(
							$author$project$Api$Provider$TaxJurisdiction$All$name(taxJurisdiction) + 'and remove it from existing profiles. This will effect draft invoices using those tax profiles.')
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_fromArray(
						[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$gap4]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Panel$title(
									_List_fromArray(
										[
											$elm$html$Html$text('Sales Tax Jurisdictions')
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
									$author$project$Components$Admin$Taxes$TaxJurisdictions$help)
								])),
							A3(
							$author$project$Ui$Button$view,
							{mm: 'New tax jurisdiction'},
							_List_fromArray(
								[
									$author$project$Ui$Button$default,
									$author$project$Ui$Button$onClick($author$project$Components$Admin$Taxes$TaxJurisdictions$New),
									$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('New Tax Jurisdiction')
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					$author$project$Components$Admin$Taxes$TaxJurisdictions$viewPanelBody(model))
				]))
		]);
};
var $author$project$Components$Admin$Taxes$TaxProfiles$New = {$: 2};
var $author$project$Components$Admin$Taxes$TaxProfiles$help = _List_fromArray(
	[
		$elm$html$Html$text('Tax profiles represent a collection of tax jurisdictions. In order to collect tax, you will assign '),
		$elm$html$Html$text('a profile to an invoice.  The profile determines the total sales tax rate that will be applied. '),
		$elm$html$Html$text('For more information, please refer to our '),
		A3(
		$author$project$Ui$Link$externalHref,
		'https://support.hint.com/account-configuration/creating-sales-tax-profiles-and-jurisdictions',
		_List_fromArray(
			[$author$project$Ui$Link$targetBlank]),
		_List_fromArray(
			[
				$elm$html$Html$text('help docs')
			])),
		$elm$html$Html$text('.')
	]);
var $author$project$Components$Admin$Taxes$TaxProfiles$FormUpdated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Admin$Taxes$TaxProfiles$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$Taxes$TaxProfiles$Save = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Components$Admin$Taxes$TaxProfiles$TaxJurisdictions = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Admin$Taxes$TaxProfiles$viewTaxJurisdictionToggleSwitch = F2(
	function (taxJurisdictions, taxJurisdiction) {
		var id = $author$project$Api$Provider$TaxJurisdiction$All$id(taxJurisdiction);
		var taxJurisdictionEnabled = A2($elm$core$Set$member, id, taxJurisdictions);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$ToggleSwitch$view(
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$on(taxJurisdictionEnabled),
							$author$project$Ui$ToggleSwitch$onChange(
							A2(
								$elm$core$Basics$composeL,
								$author$project$Components$Admin$Taxes$TaxProfiles$FormUpdated,
								$author$project$Components$Admin$Taxes$TaxProfiles$TaxJurisdictions(id)))
						])),
					$author$project$Utils$Html$noBreakSpace,
					$elm$html$Html$text(
					$author$project$Api$Provider$TaxJurisdiction$All$name(taxJurisdiction)),
					$elm$html$Html$text(' - '),
					$elm$html$Html$text(
					$elm$core$String$fromFloat(
						$author$project$Api$Provider$TaxJurisdiction$All$rate(taxJurisdiction)) + '%')
				]));
	});
var $author$project$Components$Admin$Taxes$TaxProfiles$viewModal = F4(
	function (taxJurisdictions, id, form, taxProfile) {
		var modalConfig = {
			Tq: $elm$core$Maybe$Nothing,
			aih: 'Tax Profile',
			V8: _Utils_eq(taxProfile, $author$project$Api$Data$Loading),
			WG: id,
			WH: $elm$core$Maybe$Nothing,
			Yd: $author$project$Components$Admin$Taxes$TaxProfiles$CancelEdit,
			Yf: $author$project$Components$Admin$Taxes$TaxProfiles$Save(form)
		};
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$required(true),
							$author$project$Ui$Form$Group$label('Name')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(fields.Bq),
									$author$project$Ui$Form$Input$placeholder('San Francisco'),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$Admin$Taxes$TaxProfiles$FormUpdated, $author$project$Components$Admin$Taxes$TaxProfiles$Name)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form))
								])),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Jurisdictions')
						]),
					function () {
						if (taxJurisdictions.$ === 3) {
							var taxJurisdictions_ = taxJurisdictions.a;
							return $elm$core$List$isEmpty(taxJurisdictions_) ? _List_fromArray(
								[
									$elm$html$Html$text('You have not created any tax jurisdictions. Please add the appropriate jurisdictions then select them here.')
								]) : A2(
								$elm$core$List$map,
								$author$project$Components$Admin$Taxes$TaxProfiles$viewTaxJurisdictionToggleSwitch(fields.acW),
								taxJurisdictions_);
						} else {
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textCenter]),
									_List_fromArray(
										[
											$author$project$Ui$Spinner$view(
											_List_fromArray(
												[$author$project$Ui$Spinner$small]))
										]))
								]);
						}
					}())
				]));
	});
var $author$project$Components$Admin$Taxes$TaxProfiles$Delete = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Admin$Taxes$TaxProfiles$Edit = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$TaxProfile$Shared$rate = function (_v0) {
	var record = _v0;
	return record._1;
};
var $author$project$Api$Provider$TaxProfile$One$rate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$TaxProfile$Shared$rate(shared);
};
var $author$project$Api$Provider$TaxProfile$All$rate = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$TaxProfile$One$rate(one);
};
var $author$project$Components$Admin$Taxes$TaxProfiles$viewTaxJurisdiction = function (taxJurisdiction) {
	return A2(
		$author$project$Ui$Typography$p,
		_List_fromArray(
			[$author$project$Ui$Typography$small]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Api$Provider$TaxJurisdiction$Shared$name(taxJurisdiction)),
				$elm$html$Html$text(' - '),
				$elm$html$Html$text(
				$elm$core$String$fromFloat(
					$author$project$Api$Provider$TaxJurisdiction$Shared$rate(taxJurisdiction)) + '%')
			]));
};
var $author$project$Components$Admin$Taxes$TaxProfiles$viewTaxProfile = F2(
	function (deletingTaxProfiles, taxProfile) {
		var id = $author$project$Api$Provider$TaxProfile$All$id(taxProfile);
		var loading = A2($elm$core$Set$member, id, deletingTaxProfiles);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$TaxProfile$All$name(taxProfile))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromFloat(
								$author$project$Api$Provider$TaxProfile$All$rate(taxProfile)) + '%')
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$author$project$Components$Admin$Taxes$TaxProfiles$viewTaxJurisdiction,
						$author$project$Api$Provider$TaxProfile$All$taxJurisdictions(taxProfile))),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$gap2, $author$project$Ui$Element$justifyRight]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Edit tax profile'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$onClick(
											$author$project$Components$Admin$Taxes$TaxProfiles$Edit(taxProfile)),
											$author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit')
										])),
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Edit tax profile'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$loading(loading),
											$author$project$Ui$Button$onClick(
											$author$project$Components$Admin$Taxes$TaxProfiles$Delete(taxProfile)),
											$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Delete')
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Admin$Taxes$TaxProfiles$viewPanelBody = function (model) {
	var _v0 = function () {
		var _v1 = model.hU;
		if (_v1.$ === 3) {
			var taxProfiles_ = _v1.a;
			return _Utils_Tuple2(false, taxProfiles_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var taxProfiles = _v0.b;
	return _List_fromArray(
		[
			A4(
			$author$project$Ui$Table$view,
			_List_fromArray(
				[
					$author$project$Ui$Table$verticalCentered,
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('None'),
							A2(
							$elm$core$Maybe$withDefault,
							false,
							A2(
								$elm$core$Maybe$map,
								$elm$core$List$isEmpty,
								$author$project$Api$Data$toMaybe(model.acW))) ? $elm$html$Html$text(', please add a tax jursidiction below first.') : $author$project$Utils$Html$empty
						])),
					$author$project$Ui$Table$loading(loading)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$header,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Name')
						])),
					A2(
					$author$project$Ui$Table$header,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Rate')
						])),
					A2(
					$author$project$Ui$Table$header,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Jurisdictions')
						])),
					A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
				]),
			A2(
				$elm$core$List$map,
				$author$project$Components$Admin$Taxes$TaxProfiles$viewTaxProfile(model.en),
				taxProfiles),
			_List_Nil)
		]);
};
var $author$project$Components$Admin$Taxes$TaxProfiles$view = function (_v0) {
	var model = _v0;
	return _List_fromArray(
		[
			function () {
			var _v1 = model.acX;
			if (!_v1.$) {
				var _v2 = _v1.a;
				var id = _v2.a;
				var form = _v2.b;
				var taxProfile = _v2.c;
				return A4($author$project$Components$Admin$Taxes$TaxProfiles$viewModal, model.acW, id, form, taxProfile);
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			function () {
			var _v3 = model.ji;
			if (!_v3.$) {
				var taxProfile = _v3.a;
				return A2(
					$author$project$Components$HiConfirm$modal,
					$author$project$Components$Admin$Taxes$TaxProfiles$HiConfirmClosed(taxProfile),
					_List_fromArray(
						[
							$author$project$Components$HiConfirm$verb('delete'),
							$author$project$Components$HiConfirm$noun('profile'),
							$author$project$Components$HiConfirm$detail(
							$author$project$Api$Provider$TaxProfile$All$name(taxProfile) + ' and make it unavailable as an option. This will not effect issued invoices.')
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap4]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Panel$title(
									_List_fromArray(
										[
											$elm$html$Html$text('Sales Tax Profiles')
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
									$author$project$Components$Admin$Taxes$TaxProfiles$help)
								])),
							A3(
							$author$project$Ui$Button$view,
							{mm: 'New tax profile'},
							_List_fromArray(
								[
									$author$project$Ui$Button$default,
									$author$project$Ui$Button$onClick($author$project$Components$Admin$Taxes$TaxProfiles$New),
									$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('New Tax Profile')
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					$author$project$Components$Admin$Taxes$TaxProfiles$viewPanelBody(model))
				]))
		]);
};
var $author$project$Pages$Admin$Taxes$view = function (model) {
	return {
		fO: _Utils_ap(
			A2(
				$elm$core$List$map,
				$elm$html$Html$map($author$project$Pages$Admin$Taxes$TaxProfilesMsg),
				$author$project$Components$Admin$Taxes$TaxProfiles$view(model.hU)),
			A2(
				$elm$core$List$map,
				$elm$html$Html$map($author$project$Pages$Admin$Taxes$TaxJurisdictionsMsg),
				$author$project$Components$Admin$Taxes$TaxJurisdictions$view(model.acW))),
		ac9: 'Admin | Sales Tax'
	};
};
var $author$project$Pages$Admin$Taxes$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Taxes$init, aiq: $author$project$Pages$Admin$Taxes$load, k8: $author$project$Pages$Admin$Taxes$save, alO: $author$project$Pages$Admin$Taxes$subscriptions, adT: $author$project$Pages$Admin$Taxes$update, amo: $author$project$Pages$Admin$Taxes$view});
var $author$project$Pages$Admin$Team$GotLocationGroups = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$Team$GotRoles = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$ToogleOrganizationMfa$Practice = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$Team$buildUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('q'),
			model.akl)
		]);
	return A2(
		$elm$url$Url$Builder$relative,
		_List_fromArray(
			[
				$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Admin__Team)
			]),
		A2(
			$elm$core$List$append,
			$author$project$Api$Pagination$toPageQuery(model.ajJ),
			A2(
				$elm$core$List$append,
				$author$project$Api$Sort$toQuery(model.alA),
				A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams))));
};
var $author$project$Pages$Admin$Team$GotTeamMembers = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Admin$Team$fetchTeamMembers = function (model) {
	return A3(
		$author$project$Api$Provider$TeamMember$list,
		model.Gv,
		function (d) {
			return _Utils_update(
				d,
				{ajJ: model.ajJ, akl: model.akl, alA: model.alA});
		},
		$author$project$Pages$Admin$Team$GotTeamMembers);
};
var $author$project$Api$Provider$Practice$One$hasOwner = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.YD;
		},
		$author$project$Utils$Maybe$toBool));
var $author$project$Components$Admin$ToogleOrganizationMfa$Model = $elm$core$Basics$identity;
var $author$project$Components$Admin$ToogleOrganizationMfa$init = F2(
	function (session, organization) {
		return {
			Hd: $author$project$Api$Platform$Session$One$user(session),
			Yr: organization,
			aa4: session,
			vg: $author$project$Api$Data$NotAsked,
			qR: $author$project$Api$Data$NotAsked
		};
	});
var $author$project$Api$Common$Role$All$Role = $elm$core$Basics$identity;
var $author$project$Api$Common$Role$Shared$Role = $elm$core$Basics$identity;
var $author$project$Api$Common$Role$Shared$Record = F2(
	function (name, permissionSets) {
		return {Bq: name, Zv: permissionSets};
	});
var $author$project$Api$Common$Role$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'permission_sets',
	$elm$json$Json$Decode$list($author$project$Api$Common$PermissionSet$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Common$Role$Shared$Record)));
var $author$project$Api$Common$Role$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Role$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$Role$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Role$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Role$rolesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['roles']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Role$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Common$Role$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Role$rolesPath));
	});
var $author$project$Pages$Admin$Team$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.DE;
		var q = A2($elm$core$Dict$get, 'q', query);
		var model = {
			vE: !$author$project$Api$Provider$Practice$One$hasOwner(practice),
			Gv: shared.Gv,
			Hd: $author$project$Api$Platform$Session$One$user(session),
			nf: $elm$core$Maybe$Nothing,
			eo: $elm$core$Set$empty,
			jq: $elm$core$Maybe$Nothing,
			ahJ: shared.ahJ,
			eC: false,
			Ij: $author$project$Shared$isHintAdmin(shared),
			Wa: $author$project$Api$Data$Loading,
			eI: $elm$core$Set$empty,
			ajG: shared.ahq.ajG,
			ajJ: $author$project$Api$Pagination$initFromQuery(query),
			ZV: practice,
			akl: q,
			ak4: $author$project$Api$Data$Loading,
			up: $author$project$Ui$SearchInput$init(q),
			aa4: session,
			alA: A3(
				$author$project$Api$Sort$withDefault,
				'user_first_name',
				0,
				$author$project$Api$Sort$initFromQuery(query)),
			I: $elm$core$Maybe$Nothing,
			fm: $author$project$Api$Data$Loading,
			vb: A2(
				$author$project$Components$Admin$ToogleOrganizationMfa$init,
				session,
				$author$project$Components$Admin$ToogleOrganizationMfa$Practice(practice))
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Pages$Admin$Team$fetchTeamMembers(model),
						A2($author$project$Api$Provider$Role$list, shared.Gv, $author$project$Pages$Admin$Team$GotRoles),
						A3($author$project$Api$Provider$LocationGroup$list, shared.Gv, $elm$core$Basics$identity, $author$project$Pages$Admin$Team$GotLocationGroups),
						A2($elm$core$Basics$composeR, $author$project$Pages$Admin$Team$buildUrl, $author$project$Ports$Navigation$replaceUrl)(model)
					])));
	});
var $author$project$Pages$Admin$Team$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Team$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Team$CancelTeamMemberEdit = {$: 5};
var $author$project$Pages$Admin$Team$DeleteConfirmClosed = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Pages$Admin$Team$DisableMfaConfirmClosed = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Pages$Admin$Team$subscriptions = function (_v0) {
	var teamMember = _v0.I;
	var deletingTeamMember = _v0.nf;
	var disablingMfaTeamMember = _v0.jq;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Admin$Team$CancelTeamMemberEdit)),
					teamMember)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$Team$DeleteConfirmClosed),
						$author$project$Api$Provider$PracticeUser$All$id),
					deletingTeamMember)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$Team$DisableMfaConfirmClosed),
					disablingMfaTeamMember))
			]));
};
var $author$project$Pages$Admin$Team$GotInvitation = F3(
	function (a, b, c) {
		return {$: 23, a: a, b: b, c: c};
	});
var $author$project$Pages$Admin$Team$InviteLinkMsg = function (a) {
	return {$: 22, a: a};
};
var $author$project$Pages$Admin$Team$MfaStatus = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$Team$SearchInputMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Admin$Team$TeamMemberAdminCompleted = F2(
	function (a, b) {
		return {$: 26, a: a, b: b};
	});
var $author$project$Pages$Admin$Team$TeamMemberDeleted = F2(
	function (a, b) {
		return {$: 14, a: a, b: b};
	});
var $author$project$Pages$Admin$Team$TeamMemberMfaDisabled = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$Admin$Team$ToogleOrganizationMfa = function (a) {
	return {$: 24, a: a};
};
var $author$project$Api$Provider$TeamMember$teamMemberPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$TeamMember$teamMembersPath);
};
var $author$project$Api$Provider$TeamMember$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$TeamMember$teamMemberPath(id_)));
	});
var $author$project$Api$Provider$TeamMember$disableMfa = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['mfa']),
					$author$project$Api$Provider$TeamMember$teamMemberPath(id_))));
	});
var $author$project$Api$Provider$LocationGroup$Min$id = function (_v0) {
	var common = _v0;
	return $author$project$Api$Common$LocationGroup$Min$id(common);
};
var $author$project$Api$Provider$PracticeUser$All$locationGroups = function (_v0) {
	var record = _v0.b;
	return record.Wa;
};
var $author$project$Api$Provider$User$One$mfaStatus = function (_v0) {
	var record = _v0.b;
	return record.W6;
};
var $author$project$Pages$Admin$Team$mfaStatus = function (teamMember) {
	var _v0 = A2($elm$core$Maybe$andThen, $author$project$Api$Provider$PracticeUser$All$user, teamMember);
	if (!_v0.$) {
		var user = _v0.a;
		return $author$project$Api$Provider$User$One$mfaStatus(user);
	} else {
		return 'invite pending';
	}
};
var $author$project$Api$Provider$PracticeUser$Shared$notificationsEnabled = function (_v0) {
	var record = _v0;
	return record.X$;
};
var $author$project$Api$Provider$PracticeUser$All$notificationsEnabled = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PracticeUser$Shared$notificationsEnabled(shared);
};
var $author$project$Api$Provider$PracticeUser$Shared$reportRestricted = function (_v0) {
	var record = _v0;
	return record.$x;
};
var $author$project$Api$Provider$PracticeUser$All$reportRestricted = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PracticeUser$Shared$reportRestricted(shared);
};
var $author$project$Api$Provider$PracticeUser$Shared$restrictedByGroups = function (_v0) {
	var record = _v0;
	return record.$T;
};
var $author$project$Api$Provider$PracticeUser$All$restrictedByGroups = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PracticeUser$Shared$restrictedByGroups(shared);
};
var $author$project$Api$Provider$PracticeUser$Shared$role = function (_v0) {
	var record = _v0;
	return record.ak3;
};
var $author$project$Api$Provider$PracticeUser$All$role = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PracticeUser$Shared$role(shared);
};
var $author$project$Pages$Admin$Team$formFieldsFromTeamMember = function (teamMember) {
	var locationGroups = $elm$core$Set$fromList(
		A2(
			$elm$core$List$map,
			$author$project$Api$Provider$LocationGroup$Min$id,
			$author$project$Api$Provider$PracticeUser$All$locationGroups(teamMember)));
	return {
		Mz: '',
		Rj: $author$project$Api$Provider$PracticeUser$All$email(teamMember),
		n2: false,
		Wa: locationGroups,
		W6: $author$project$Pages$Admin$Team$mfaStatus(
			$elm$core$Maybe$Just(teamMember)),
		X$: $author$project$Api$Provider$PracticeUser$All$notificationsEnabled(teamMember),
		$x: $author$project$Api$Provider$PracticeUser$All$reportRestricted(teamMember),
		$T: $author$project$Api$Provider$PracticeUser$All$restrictedByGroups(teamMember),
		ak3: $author$project$Api$Provider$PracticeUser$All$role(teamMember)
	};
};
var $author$project$Pages$Admin$Team$formFieldsInit = function (origin) {
	return {
		Mz: origin + '/join/',
		Rj: '',
		n2: true,
		Wa: $elm$core$Set$empty,
		W6: $author$project$Pages$Admin$Team$mfaStatus($elm$core$Maybe$Nothing),
		X$: true,
		$x: false,
		$T: false,
		ak3: ''
	};
};
var $author$project$Pages$Admin$Team$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{Rj: string});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{$T: fields.$T && (string !== 'admin'), ak3: string});
			case 2:
				var bool = field.a;
				return _Utils_update(
					fields,
					{X$: bool});
			case 3:
				var bool = field.a;
				return _Utils_update(
					fields,
					{$T: bool});
			case 5:
				var string = field.a;
				return _Utils_update(
					fields,
					{W6: string});
			case 6:
				var id = field.a;
				var bool = field.b;
				var locationGroups = bool ? A2($elm$core$Set$insert, id, fields.Wa) : A2($elm$core$Set$remove, id, fields.Wa);
				return _Utils_update(
					fields,
					{Wa: locationGroups});
			case 7:
				var bool = field.a;
				return _Utils_update(
					fields,
					{n2: bool});
			default:
				var bool = field.a;
				return _Utils_update(
					fields,
					{$x: bool});
		}
	});
var $author$project$Pages$Admin$Team$EmailValidation = 0;
var $author$project$Pages$Admin$Team$RoleValidation = 1;
var $author$project$Pages$Admin$Team$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A3(
			$author$project$Utils$Validate$ifInvalidEmail,
			{aeT: false},
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.Rj;
				},
				$elm$core$Maybe$Just),
			_Utils_Tuple2(0, 'Please enter a valid email.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.ak3;
			},
			_Utils_Tuple2(1, 'Please pick a role.'))
		]));
var $author$project$Api$Provider$TeamMember$invite = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$PracticeUser$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['invite']),
					$author$project$Api$Provider$TeamMember$teamMemberPath(id_))));
	});
var $author$project$Api$Provider$TeamMember$makeSuperAdmin = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$PracticeUser$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['make_super_admin']),
					$author$project$Api$Provider$TeamMember$teamMemberPath(id_))));
	});
var $author$project$Api$Provider$TeamMember$AutoAccept = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$TeamMember$BaseUrl = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$TeamMember$Email = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$TeamMember$Invite = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$TeamMember$LocationGroups = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$TeamMember$NotificationsEnabled = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$TeamMember$ReportRestricted = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$TeamMember$RestrictedByGroups = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$TeamMember$Role = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$Team$TeamMemberCreated = function (a) {
	return {$: 12, a: a};
};
var $author$project$Api$Provider$TeamMember$encodePermittedFields = function (permittedFields) {
	var _v0 = A3(
		$elm$core$List$foldl,
		F2(
			function (field, _v1) {
				var tm = _v1.a;
				var tl = _v1.b;
				switch (field.$) {
					case 0:
						var email = field.a;
						return _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'email',
									$elm$json$Json$Encode$string(email)),
								tm),
							tl);
					case 1:
						var role = field.a;
						return _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'role',
									$elm$json$Json$Encode$string(role)),
								tm),
							tl);
					case 2:
						var enabled = field.a;
						return _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'notifications_enabled',
									$elm$json$Json$Encode$bool(enabled)),
								tm),
							tl);
					case 3:
						var url = field.a;
						return _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'base_url',
									$elm$json$Json$Encode$string(url)),
								tm),
							tl);
					case 4:
						var restricted = field.a;
						return _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'restricted_by_groups',
									$elm$json$Json$Encode$bool(restricted)),
								tm),
							tl);
					case 5:
						var groups = field.a;
						return _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'location_groups',
									A2($elm$json$Json$Encode$set, $author$project$Utils$Encode$association, groups)),
								tm),
							tl);
					case 6:
						var restricted = field.a;
						return _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'report_restricted',
									$elm$json$Json$Encode$bool(restricted)),
								tm),
							tl);
					case 7:
						var inv = field.a;
						return _Utils_Tuple2(
							tm,
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'invite',
									$elm$json$Json$Encode$bool(inv)),
								tl));
					default:
						var autoAccept = field.a;
						return _Utils_Tuple2(
							tm,
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'auto_accept',
									$elm$json$Json$Encode$bool(autoAccept)),
								tl));
				}
			}),
		_Utils_Tuple2(_List_Nil, _List_Nil),
		permittedFields);
	var teamMemberFields = _v0.a;
	var topLevelFields = _v0.b;
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				'team_member',
				$elm$json$Json$Encode$object(teamMemberFields)),
			topLevelFields));
};
var $author$project$Api$Provider$TeamMember$create = F3(
	function (apiClient, permittedFields, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$PracticeUser$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Provider$TeamMember$encodePermittedFields(permittedFields),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$TeamMember$teamMembersPath)));
	});
var $author$project$Pages$Admin$Team$createTeamMember = F4(
	function (apiClient, _v0, isAddExistingUser, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var baseFields = _List_fromArray(
			[
				$author$project$Api$Provider$TeamMember$Email(fields.Rj),
				$author$project$Api$Provider$TeamMember$Role(fields.ak3),
				$author$project$Api$Provider$TeamMember$NotificationsEnabled(fields.X$),
				$author$project$Api$Provider$TeamMember$RestrictedByGroups(fields.$T),
				$author$project$Api$Provider$TeamMember$LocationGroups(fields.Wa),
				$author$project$Api$Provider$TeamMember$ReportRestricted(fields.$x)
			]);
		var permittedFields = isAddExistingUser ? _Utils_ap(
			baseFields,
			_List_fromArray(
				[
					$author$project$Api$Provider$TeamMember$AutoAccept(true)
				])) : _Utils_ap(
			baseFields,
			_List_fromArray(
				[
					$author$project$Api$Provider$TeamMember$BaseUrl(fields.Mz),
					$author$project$Api$Provider$TeamMember$Invite(fields.n2)
				]));
		return A3($author$project$Api$Provider$TeamMember$create, apiClient, permittedFields, $author$project$Pages$Admin$Team$TeamMemberCreated);
	});
var $author$project$Pages$Admin$Team$TeamMemberUpdated = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$TeamForm$providerStatusToString = function (status) {
	switch (status) {
		case 0:
			return 'full_time';
		case 1:
			return 'part_time';
		default:
			return 'no_provider';
	}
};
var $author$project$Api$Provider$TeamMember$update = F4(
	function (apiClient, id_, fields, toMsg) {
		var providerStatusValue = A2($elm$core$Maybe$map, $author$project$Components$TeamForm$providerStatusToString, fields._G);
		var encodeMaskedDate = function (stringDate) {
			return A2(
				$elm$core$Maybe$withDefault,
				$elm$json$Json$Encode$null,
				$elm$core$Result$toMaybe(
					A2(
						$elm$core$Result$map,
						$author$project$Utils$Date$encode,
						$author$project$Utils$Date$fromUsString(
							A2(
								$agustinrhcp$elm_mask$Mask$mask,
								$agustinrhcp$elm_mask$Mask$fromString('##/##/####'),
								stringDate)))));
		};
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'team_member',
					$elm$json$Json$Encode$object(
						$elm$core$List$concat(
							_List_fromArray(
								[
									A3($author$project$Utils$Encode$optional, 'role', $elm$json$Json$Encode$string, fields.ak3),
									A3($author$project$Utils$Encode$optional, 'notifications_enabled', $elm$json$Json$Encode$bool, fields.X$),
									A3($author$project$Utils$Encode$optional, 'restricted_by_groups', $elm$json$Json$Encode$bool, fields.$T),
									A3(
									$author$project$Utils$Encode$optional,
									'location_groups',
									$elm$json$Json$Encode$set($author$project$Utils$Encode$association),
									fields.Wa),
									A3($author$project$Utils$Encode$optional, 'report_restricted', $elm$json$Json$Encode$bool, fields.$x),
									A3($author$project$Utils$Encode$optional, 'phone_number', $elm$json$Json$Encode$string, fields.Zx),
									A3($author$project$Utils$Encode$optional, 'npi', $elm$json$Json$Encode$string, fields.X0),
									A3($author$project$Utils$Encode$optional, 'prescriber_type', $elm$json$Json$Encode$string, fields._g),
									A3($author$project$Utils$Encode$optional, 'dob', encodeMaskedDate, fields.PF),
									A3($author$project$Utils$Encode$optional, 'education_degree', $elm$json$Json$Encode$string, fields.Hp),
									A3(
									$author$project$Utils$Encode$optional,
									'dea_licenses',
									$elm$json$Json$Encode$list($author$project$Components$ProviderCredentials$encodeLicense),
									$elm$core$List$isEmpty(fields.nb) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(fields.nb)),
									A3($author$project$Utils$Encode$optional, 'provider_status', $elm$json$Json$Encode$string, providerStatusValue),
									A3(
									$author$project$Utils$Encode$optional,
									'state_licenses',
									$elm$json$Json$Encode$list($author$project$Components$ProviderCredentials$encodeLicense),
									$elm$core$List$isEmpty(fields.qm) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(fields.qm))
								]))))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$PracticeUser$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$TeamMember$teamMemberPath(id_))));
	});
var $author$project$Pages$Admin$Team$updateTeamMember = F3(
	function (apiClient, id, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4(
			$author$project$Api$Provider$TeamMember$update,
			apiClient,
			id,
			{
				PF: $elm$core$Maybe$Nothing,
				nb: _List_Nil,
				Hp: $elm$core$Maybe$Nothing,
				Wa: $elm$core$Maybe$Just(fields.Wa),
				X$: $elm$core$Maybe$Just(fields.X$),
				X0: $elm$core$Maybe$Nothing,
				Zx: $elm$core$Maybe$Nothing,
				_g: $elm$core$Maybe$Nothing,
				_G: $elm$core$Maybe$Nothing,
				$x: $elm$core$Maybe$Just(fields.$x),
				$T: $elm$core$Maybe$Just(fields.$T),
				ak3: $elm$core$Maybe$Just(fields.ak3),
				qm: _List_Nil
			},
			$author$project$Pages$Admin$Team$TeamMemberUpdated);
	});
var $author$project$Pages$Admin$Team$saveTeamMember = F5(
	function (apiClient, adminOnly, isAddExistingUser, maybeId, formFields) {
		if (!maybeId.$) {
			var id = maybeId.a;
			return A3($author$project$Pages$Admin$Team$updateTeamMember, apiClient, id, formFields);
		} else {
			return A4($author$project$Pages$Admin$Team$createTeamMember, apiClient, adminOnly, isAddExistingUser, formFields);
		}
	});
var $author$project$Components$Admin$ToogleOrganizationMfa$GotPartner = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$ToogleOrganizationMfa$GotPractice = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$ToogleOrganizationMfa$None = {$: 0};
var $author$project$Components$Admin$ToogleOrganizationMfa$Partner = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$ToogleOrganizationMfa$PartnerUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$OutMsg$PartnerUpdated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Admin$ToogleOrganizationMfa$PracticeUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Partner$Partner$One$Partner = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Partner$Partner$Shared$Partner = $elm$core$Basics$identity;
var $author$project$Api$Partner$Partner$Shared$Record = function (id) {
	return function (name) {
		return function (organizationId) {
			return function (requiresMfa) {
				return function (slug) {
					return function (redirectUrl) {
						return function (authType) {
							return function (logoUrl) {
								return function (email) {
									return function (technicalEmail) {
										return function (usesIntegrationRecords) {
											return function (active) {
												return function (archived) {
													return function (webhooksDisabled) {
														return function (webhooksPaused) {
															return function (maxRequestsPperMinute) {
																return function (practicesReadOnly) {
																	return function (listenedEvents) {
																		return function (unmuteSelfWebhooks) {
																			return function (postActivationRedirectUrl) {
																				return function (sandboxEnabled) {
																					return function (productType) {
																						return function (websiteUrl) {
																							return {KN: active, L_: archived, Ma: authType, Rj: email, ahP: id, V6: listenedEvents, Wk: logoUrl, WD: maxRequestsPperMinute, Bq: name, ajD: organizationId, ZQ: postActivationRedirectUrl, Z1: practicesReadOnly, Jo: productType, $k: redirectUrl, $H: requiresMfa, aao: sandboxEnabled, abG: slug, ac$: technicalEmail, adN: unmuteSelfWebhooks, ad7: usesIntegrationRecords, aes: webhooksDisabled, aet: webhooksPaused, aev: websiteUrl};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Common$Marketplace$Product$ProductType$App = 0;
var $author$project$Api$Common$Marketplace$Product$ProductType$Integration = 1;
var $author$project$Api$Common$Marketplace$Product$ProductType$Solution = 2;
var $author$project$Api$Common$Marketplace$Product$ProductType$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'app':
				return $elm$json$Json$Decode$succeed(0);
			case 'integration':
				return $elm$json$Json$Decode$succeed(1);
			case 'solution':
				return $elm$json$Json$Decode$succeed(2);
			default:
				var other = str;
				return $elm$json$Json$Decode$fail('Unknown product type: ' + other);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Partner$Partner$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'website_url',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'product_type',
		$author$project$Api$Common$Marketplace$Product$ProductType$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'sandbox_enabled',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'post_activation_redirect_url',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'unmute_self_webhooks',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'listened_events',
						$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'practices_read_only',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'max_requests_per_minute',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'webhooks_paused',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'webhooks_disabled',
										$elm$json$Json$Decode$bool,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'archived',
											$elm$json$Json$Decode$bool,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'active',
												$elm$json$Json$Decode$bool,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'uses_integration_records',
													$elm$json$Json$Decode$bool,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'technical_email',
														$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'email',
															$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'logo_url',
																$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'auth_type',
																	$elm$json$Json$Decode$string,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'redirect_url',
																		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'slug',
																			$elm$json$Json$Decode$string,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'requires_mfa',
																				$elm$json$Json$Decode$bool,
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'organization_id',
																					$elm$json$Json$Decode$string,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'name',
																						$elm$json$Json$Decode$string,
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'id',
																							$elm$json$Json$Decode$string,
																							$elm$json$Json$Decode$succeed($author$project$Api$Partner$Partner$Shared$Record))))))))))))))))))))))));
var $author$project$Api$Partner$Partner$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$Partner$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$Partner$One$Record = function (webhooksSignatureApiKey) {
	return function (sandboxOf) {
		return function (hasSandboxPartners) {
			return function (hasSandboxPractices) {
				return function (product) {
					return function (productOverview) {
						return function (productHighlights) {
							return function (productQuotes) {
								return function (productLinks) {
									return function (productDataFlows) {
										return function (managedBy) {
											return function (productCategories) {
												return function (customPartnerAgreementFileName) {
													return function (addendumAgreementFileName) {
														return function (customApiAccessAgreementFileName) {
															return function (customBaaAgreementFileName) {
																return function (partnerDocumentAgreement) {
																	return function (addendumDocumentAgreement) {
																		return function (apiAccessDocumentAgreement) {
																			return function (address) {
																				return function (baaType) {
																					return function (baaDocumentAgreement) {
																						return function (serviceFeeDocumentAgreement) {
																							return function (serviceFeeReSignatureRequired) {
																								return {KX: addendumAgreementFileName, KY: addendumDocumentAgreement, K2: address, LT: apiAccessDocumentAgreement, Mr: baaDocumentAgreement, Ms: baaType, Pk: customApiAccessAgreementFileName, Pl: customBaaAgreementFileName, Pr: customPartnerAgreementFileName, Ti: hasSandboxPartners, Tj: hasSandboxPractices, Wq: managedBy, YQ: partnerDocumentAgreement, _s: product, _t: productCategories, _u: productDataFlows, _v: productHighlights, _w: productLinks, _y: productOverview, _z: productQuotes, aap: sandboxOf, aa1: serviceFeeDocumentAgreement, aa2: serviceFeeReSignatureRequired, aeu: webhooksSignatureApiKey};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Partner$ApiKey$Shared$ApiKey = $elm$core$Basics$identity;
var $author$project$Api$Partner$ApiKey$Shared$Record = F6(
	function (id, token, createdAt, lastUsedAt, deactivatedAt, label) {
		return {O1: createdAt, PR: deactivatedAt, ahP: id, aih: label, VO: lastUsedAt, adi: token};
	});
var $author$project$Api$Partner$ApiKey$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'label',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'deactivated_at',
		$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'last_used_at',
			$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'created_at',
				$elm_community$json_extra$Json$Decode$Extra$datetime,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'token',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Api$Partner$ApiKey$Shared$Record)))))));
var $author$project$Api$Partner$ApiKey$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$ApiKey$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$BaaType$Contractor = 0;
var $author$project$Api$Partner$BaaType$Independent = 1;
var $author$project$Api$Partner$BaaType$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'contractor':
				return $elm$json$Json$Decode$succeed(0);
			case 'independent':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Unsupported BAA type: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Partner$DocumentAgreement$Shared$DocumentAgreement = $elm$core$Basics$identity;
var $author$project$Api$Partner$DocumentAgreement$Shared$Record = F2(
	function (signedAt, user) {
		return {abu: signedAt, ad0: user};
	});
var $author$project$Api$Partner$User$Shared$User = $elm$core$Basics$identity;
var $author$project$Api$Partner$User$Shared$Record = F2(
	function (name, isAdmin) {
		return {Uy: isAdmin, Bq: name};
	});
var $author$project$Api$Partner$User$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'is_admin',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Partner$User$Shared$Record)));
var $author$project$Api$Partner$User$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$User$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$DocumentAgreement$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'signed_by',
	$author$project$Api$Partner$User$Shared$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'signed_at',
		$elm_community$json_extra$Json$Decode$Extra$datetime,
		$elm$json$Json$Decode$succeed($author$project$Api$Partner$DocumentAgreement$Shared$Record)));
var $author$project$Api$Partner$DocumentAgreement$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$DocumentAgreement$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$PartnerProduct$Shared$PartnerProduct = $elm$core$Basics$identity;
var $author$project$Api$Partner$PartnerProduct$Shared$Record = function (id) {
	return function (slug) {
		return function (distributionType) {
			return function (status) {
				return function (featured) {
					return function (name) {
						return function (summary) {
							return function (builtByName) {
								return function (builtByUrl) {
									return function (type_) {
										return function (backlinkUrl) {
											return function (installsCount) {
												return function (waitlistedCount) {
													return function (iconUrl) {
														return {Mv: backlinkUrl, MV: builtByName, MW: builtByUrl, QN: distributionType, Se: featured, TJ: iconUrl, ahP: id, T5: installsCount, Bq: name, abG: slug, alH: status, acF: summary, amg: type_, aeo: waitlistedCount};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Common$Marketplace$Product$DistributionType$Public = 0;
var $author$project$Api$Common$Marketplace$Product$DistributionType$Unlisted = 1;
var $author$project$Api$Common$Marketplace$Product$DistributionType$fromString = function (string) {
	switch (string) {
		case 'public':
			return $elm$core$Maybe$Just(0);
		case 'unlisted':
			return $elm$core$Maybe$Just(1);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Common$Marketplace$Product$DistributionType$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		var _v0 = $author$project$Api$Common$Marketplace$Product$DistributionType$fromString(string);
		if (!_v0.$) {
			var distributionType = _v0.a;
			return $elm$json$Json$Decode$succeed(distributionType);
		} else {
			return $elm$json$Json$Decode$fail('Invalid distribution type: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Common$Marketplace$Product$Status$Beta = 4;
var $author$project$Api$Common$Marketplace$Product$Status$ComingSoon = 3;
var $author$project$Api$Common$Marketplace$Product$Status$Decommissioned = 8;
var $author$project$Api$Common$Marketplace$Product$Status$Deprecated = 7;
var $author$project$Api$Common$Marketplace$Product$Status$Hidden = 0;
var $author$project$Api$Common$Marketplace$Product$Status$Live = 5;
var $author$project$Api$Common$Marketplace$Product$Status$Researching = 2;
var $author$project$Api$Common$Marketplace$Product$Status$Sunsetting = 6;
var $author$project$Api$Common$Marketplace$Product$Status$Unpublished = 1;
var $author$project$Api$Common$Marketplace$Product$Status$fromString = function (string) {
	switch (string) {
		case 'hidden':
			return $elm$core$Maybe$Just(0);
		case 'unpublished':
			return $elm$core$Maybe$Just(1);
		case 'researching':
			return $elm$core$Maybe$Just(2);
		case 'coming_soon':
			return $elm$core$Maybe$Just(3);
		case 'beta':
			return $elm$core$Maybe$Just(4);
		case 'live':
			return $elm$core$Maybe$Just(5);
		case 'sunsetting':
			return $elm$core$Maybe$Just(6);
		case 'deprecated':
			return $elm$core$Maybe$Just(7);
		case 'decommissioned':
			return $elm$core$Maybe$Just(8);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Common$Marketplace$Product$Status$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		var _v0 = $author$project$Api$Common$Marketplace$Product$Status$fromString(string);
		if (!_v0.$) {
			var status = _v0.a;
			return $elm$json$Json$Decode$succeed(status);
		} else {
			return $elm$json$Json$Decode$fail('Invalid status: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Partner$PartnerProduct$Shared$decoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'icon_url',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'waitlisted_count',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'installs_count',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'backlink_url',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'type',
						$author$project$Api$Common$Marketplace$Product$ProductType$decoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'built_by_url',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'built_by_name',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'summary',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'name',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'featured',
											$elm$json$Json$Decode$bool,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'status',
												$author$project$Api$Common$Marketplace$Product$Status$decoder,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'distribution_type',
													$author$project$Api$Common$Marketplace$Product$DistributionType$decoder,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'slug',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'id',
															$elm$json$Json$Decode$string,
															$elm$json$Json$Decode$succeed($author$project$Api$Partner$PartnerProduct$Shared$Record))))))))))))))));
var $author$project$Api$Partner$PartnerProductCategory$Shared$PartnerProductCategory = $elm$core$Basics$identity;
var $author$project$Api$Partner$PartnerProductCategory$Shared$Record = F2(
	function (id, name) {
		return {ahP: id, Bq: name};
	});
var $author$project$Api$Partner$PartnerProductCategory$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Partner$PartnerProductCategory$Shared$Record)));
var $author$project$Api$Partner$PartnerProductCategory$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$PartnerProductCategory$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$PartnerProductCategory$One$decoder = $author$project$Api$Partner$PartnerProductCategory$Shared$decoder;
var $author$project$Api$Partner$PartnerProductDataFlow$Shared$PartnerProductDataFlow = $elm$core$Basics$identity;
var $author$project$Api$Partner$PartnerProductDataFlow$Shared$Record = F5(
	function (id, hintName, partnerName, syncDirection, position) {
		return {TA: hintName, ahP: id, YR: partnerName, ZP: position, acK: syncDirection};
	});
var $author$project$Api$Common$Marketplace$Product$SyncDirection$Bidirectional = 2;
var $author$project$Api$Common$Marketplace$Product$SyncDirection$FromHint = 0;
var $author$project$Api$Common$Marketplace$Product$SyncDirection$ToHint = 1;
var $author$project$Api$Common$Marketplace$Product$SyncDirection$fromString = function (string) {
	switch (string) {
		case 'from_hint':
			return $elm$core$Maybe$Just(0);
		case 'to_hint':
			return $elm$core$Maybe$Just(1);
		case 'bidirectional':
			return $elm$core$Maybe$Just(2);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Common$Marketplace$Product$SyncDirection$decoder = A2(
	$elm$json$Json$Decode$andThen,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Api$Common$Marketplace$Product$SyncDirection$fromString,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($elm$json$Json$Decode$succeed),
			$elm$core$Maybe$withDefault(
				$elm$json$Json$Decode$fail('Unsupported sync direction')))),
	$elm$json$Json$Decode$string);
var $author$project$Api$Partner$PartnerProductDataFlow$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'position',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'sync_direction',
		$author$project$Api$Common$Marketplace$Product$SyncDirection$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'partner_name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'hint_name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Partner$PartnerProductDataFlow$Shared$Record))))));
var $author$project$Api$Partner$PartnerProductDataFlow$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$PartnerProductDataFlow$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$PartnerProductHighlight$Shared$PartnerProductHighlight = $elm$core$Basics$identity;
var $author$project$Api$Partner$PartnerProductHighlight$Shared$Record = F5(
	function (id, title, description, imageUrl, position) {
		return {Qr: description, ahP: id, TP: imageUrl, ZP: position, ac9: title};
	});
var $author$project$Api$Partner$PartnerProductHighlight$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'position',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'image_url',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'description',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'title',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Partner$PartnerProductHighlight$Shared$Record))))));
var $author$project$Api$Partner$PartnerProductHighlight$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$PartnerProductHighlight$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$PartnerProductLink$Shared$PartnerProductLink = $elm$core$Basics$identity;
var $author$project$Api$Partner$PartnerProductLink$Shared$Record = F8(
	function (id, title, linkType, value, utmCampaign, utmContent, composedUrl, position) {
		return {Oq: composedUrl, ahP: id, V3: linkType, ZP: position, ac9: title, aea: utmCampaign, aeb: utmContent, aee: value};
	});
var $author$project$Api$Common$Marketplace$Product$LinkType$Email = 1;
var $author$project$Api$Common$Marketplace$Product$LinkType$Phone = 2;
var $author$project$Api$Common$Marketplace$Product$LinkType$Url = 0;
var $author$project$Api$Common$Marketplace$Product$LinkType$fromString = function (string) {
	switch (string) {
		case 'url':
			return $elm$core$Maybe$Just(0);
		case 'email':
			return $elm$core$Maybe$Just(1);
		case 'phone':
			return $elm$core$Maybe$Just(2);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Common$Marketplace$Product$LinkType$decoder = A2(
	$elm$json$Json$Decode$andThen,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Api$Common$Marketplace$Product$LinkType$fromString,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($elm$json$Json$Decode$succeed),
			$elm$core$Maybe$withDefault(
				$elm$json$Json$Decode$fail('Unsupported link type')))),
	$elm$json$Json$Decode$string);
var $author$project$Api$Partner$PartnerProductLink$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'position',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'composed_url',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'utm_content',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'utm_campaign',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'value',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'link_type',
						$author$project$Api$Common$Marketplace$Product$LinkType$decoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'title',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Api$Partner$PartnerProductLink$Shared$Record)))))))));
var $author$project$Api$Partner$PartnerProductLink$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$PartnerProductLink$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$PartnerProductOverview$Shared$ProductOverview = $elm$core$Basics$identity;
var $author$project$Api$Partner$PartnerProductOverview$Shared$Record = F2(
	function (description, images) {
		return {Qr: description, TQ: images};
	});
var $author$project$Api$Partner$ProductImage$Shared$ProductImage = $elm$core$Basics$identity;
var $author$project$Api$Partner$ProductImage$Shared$Record = F3(
	function (id, alt, url) {
		return {LD: alt, ahP: id, adY: url};
	});
var $author$project$Api$Partner$ProductImage$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'file_url',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'alt',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Partner$ProductImage$Shared$Record)))),
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$PartnerProductOverview$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'images',
	$elm$json$Json$Decode$list($author$project$Api$Partner$ProductImage$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'description',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$json$Json$Decode$succeed($author$project$Api$Partner$PartnerProductOverview$Shared$Record)));
var $author$project$Api$Partner$PartnerProductOverview$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$PartnerProductOverview$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$PartnerProductQuote$Shared$PartnerProductQuote = $elm$core$Basics$identity;
var $author$project$Api$Partner$PartnerProductQuote$Shared$Record = F5(
	function (id, text, author, authorTitle, authorImageUrl) {
		return {Mb: author, Mc: authorImageUrl, Md: authorTitle, ahP: id, ac3: text};
	});
var $author$project$Api$Partner$PartnerProductQuote$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'author_image_url',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'author_title',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'author',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'text',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Partner$PartnerProductQuote$Shared$Record))))));
var $author$project$Api$Partner$PartnerProductQuote$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$PartnerProductQuote$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$Partner$One$ManagedByManagementGroup = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Partner$Partner$One$ManagedByPractice = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Partner$ManagementGroup$Min$ManagementGroup = $elm$core$Basics$identity;
var $author$project$Api$Partner$ManagementGroup$Min$Record = F2(
	function (id, name) {
		return {ahP: id, Bq: name};
	});
var $author$project$Api$Partner$ManagementGroup$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Partner$ManagementGroup$Min$Record)));
var $author$project$Api$Partner$ManagementGroup$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$ManagementGroup$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$Practice$Min$Practice = $elm$core$Basics$identity;
var $author$project$Api$Partner$Practice$Min$Record = F2(
	function (id, name) {
		return {ahP: id, Bq: name};
	});
var $author$project$Api$Partner$Practice$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Partner$Practice$Min$Record)));
var $author$project$Api$Partner$Practice$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$Practice$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$Partner$One$managedByDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (managedByType) {
		if (managedByType.$ === 1) {
			return $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing);
		} else {
			switch (managedByType.a) {
				case 'Practice':
					return A2(
						$elm$json$Json$Decode$map,
						$elm$core$Maybe$Just,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'managed_by',
							$author$project$Api$Partner$Practice$Min$decoder,
							$elm$json$Json$Decode$succeed($author$project$Api$Partner$Partner$One$ManagedByPractice)));
				case 'ManagementGroup':
					return A2(
						$elm$json$Json$Decode$map,
						$elm$core$Maybe$Just,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'managed_by',
							$author$project$Api$Partner$ManagementGroup$Min$decoder,
							$elm$json$Json$Decode$succeed($author$project$Api$Partner$Partner$One$ManagedByManagementGroup)));
				default:
					var somethingElse = managedByType.a;
					return $elm$json$Json$Decode$fail('Unsupported managed by type ' + somethingElse);
			}
		}
	},
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['managed_by_type']),
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)));
var $author$project$Api$Partner$Partner$One$SandboxOfPartner = 1;
var $author$project$Api$Partner$Partner$One$SandboxOfPractice = 0;
var $author$project$Api$Partner$Partner$One$sandboxOfDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (sandboxOfType) {
		if (sandboxOfType.$ === 1) {
			return $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing);
		} else {
			switch (sandboxOfType.a) {
				case 'Practice':
					return $elm$json$Json$Decode$succeed(
						$elm$core$Maybe$Just(0));
				case 'Partner':
					return $elm$json$Json$Decode$succeed(
						$elm$core$Maybe$Just(1));
				default:
					var somethingElse = sandboxOfType.a;
					return $elm$json$Json$Decode$fail('Unsupported sandbox of type ' + somethingElse);
			}
		}
	},
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['sandbox_of_type']),
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)));
var $author$project$Api$Partner$Partner$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'service_fee_re_signature_required',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'service_fee_document_agreement',
		$elm$json$Json$Decode$nullable($author$project$Api$Partner$DocumentAgreement$Shared$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'baa_document_agreement',
			$elm$json$Json$Decode$nullable($author$project$Api$Partner$DocumentAgreement$Shared$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'baa_type',
				$elm$json$Json$Decode$nullable($author$project$Api$Partner$BaaType$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'address',
					$elm$json$Json$Decode$nullable($author$project$Api$Common$Address$Shared$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'api_access_document_agreement',
						$elm$json$Json$Decode$nullable($author$project$Api$Partner$DocumentAgreement$Shared$decoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'addendum_document_agreement',
							$elm$json$Json$Decode$nullable($author$project$Api$Partner$DocumentAgreement$Shared$decoder),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'partner_document_agreement',
								$elm$json$Json$Decode$nullable($author$project$Api$Partner$DocumentAgreement$Shared$decoder),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'custom_baa_agreement_file_name',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'custom_api_access_agreement_file_name',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'addendum_agreement_file_name',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'custom_partner_agreement_file_name',
												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'product_categories',
													$elm$json$Json$Decode$list($author$project$Api$Partner$PartnerProductCategory$One$decoder),
													_List_Nil,
													A2(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
														$author$project$Api$Partner$Partner$One$managedByDecoder,
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'product_data_flows',
															$elm$json$Json$Decode$list($author$project$Api$Partner$PartnerProductDataFlow$Shared$decoder),
															_List_Nil,
															A4(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																'product_links',
																$elm$json$Json$Decode$list($author$project$Api$Partner$PartnerProductLink$Shared$decoder),
																_List_Nil,
																A4(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																	'product_quotes',
																	$elm$json$Json$Decode$list($author$project$Api$Partner$PartnerProductQuote$Shared$decoder),
																	_List_Nil,
																	A4(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																		'product_highlights',
																		$elm$json$Json$Decode$list($author$project$Api$Partner$PartnerProductHighlight$Shared$decoder),
																		_List_Nil,
																		A4(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																			'product_overview',
																			$elm$json$Json$Decode$nullable($author$project$Api$Partner$PartnerProductOverview$Shared$decoder),
																			$elm$core$Maybe$Nothing,
																			A4(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																				'product',
																				$elm$json$Json$Decode$nullable($author$project$Api$Partner$PartnerProduct$Shared$decoder),
																				$elm$core$Maybe$Nothing,
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'has_sandbox_practices',
																					$elm$json$Json$Decode$bool,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'has_sandbox_partners',
																						$elm$json$Json$Decode$bool,
																						A2(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
																							$author$project$Api$Partner$Partner$One$sandboxOfDecoder,
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'webhooks_signature_api_key',
																								$elm$json$Json$Decode$nullable($author$project$Api$Partner$ApiKey$Shared$decoder),
																								$elm$json$Json$Decode$succeed($author$project$Api$Partner$Partner$One$Record)))))))))))))))))))))))));
var $author$project$Api$Partner$Partner$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$Partner$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Partner$Partner$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Partner$Partner$One$Partner)));
var $author$project$Api$Partner$Partner$partnerPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['partner']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$Partner$updateMfaRequirement = F3(
	function (apiClient, requiresMfa_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'partner',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'requires_mfa',
								$elm$json$Json$Encode$bool(requiresMfa_))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Partner$Partner$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Partner$Partner$partnerPath)));
	});
var $author$project$Api$Provider$Practice$updateMfaRequirement = F3(
	function (apiClient, requiresMfa_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practice',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'requires_mfa',
								$elm$json$Json$Encode$bool(requiresMfa_))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Practice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$practicePath)));
	});
var $author$project$Components$Admin$ToogleOrganizationMfa$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var bool = msg.a;
				var _v2 = model.Yr;
				if (!_v2.$) {
					return {
						GZ: A3($author$project$Api$Provider$Practice$updateMfaRequirement, apiClient, bool, $author$project$Components$Admin$ToogleOrganizationMfa$GotPractice),
						agZ: $author$project$Components$Admin$ToogleOrganizationMfa$None,
						aiO: _Utils_update(
							model,
							{qR: $author$project$Api$Data$Loading}),
						aR: _List_Nil
					};
				} else {
					return {
						GZ: A3($author$project$Api$Partner$Partner$updateMfaRequirement, apiClient, bool, $author$project$Components$Admin$ToogleOrganizationMfa$GotPartner),
						agZ: $author$project$Components$Admin$ToogleOrganizationMfa$None,
						aiO: _Utils_update(
							model,
							{vg: $author$project$Api$Data$Loading}),
						aR: _List_Nil
					};
				}
			case 1:
				var response = msg.a;
				if (response.$ === 3) {
					var practice = response.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Admin$ToogleOrganizationMfa$PracticeUpdated(practice),
						aiO: _Utils_update(
							model,
							{
								Yr: $author$project$Components$Admin$ToogleOrganizationMfa$Practice(practice),
								qR: response
							}),
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your practice has been updated'),
								$author$project$OutMsg$PracticeUpdated(response)
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Admin$ToogleOrganizationMfa$None,
						aiO: _Utils_update(
							model,
							{qR: response}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var partner = response.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Admin$ToogleOrganizationMfa$PartnerUpdated(partner),
						aiO: _Utils_update(
							model,
							{
								Yr: $author$project$Components$Admin$ToogleOrganizationMfa$Partner(partner),
								vg: response
							}),
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your partner has been updated'),
								$author$project$OutMsg$PartnerUpdated(response)
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Admin$ToogleOrganizationMfa$None,
						aiO: _Utils_update(
							model,
							{vg: response}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
		}
	});
var $author$project$Components$InviteLink$update = function (msg) {
	var inviteUrl = msg;
	return _Utils_Tuple2(
		$author$project$Ports$Clipboard$copy(inviteUrl),
		_List_fromArray(
			[
				A2($author$project$OutMsg$ShowToast, 3, 'Copied invite link to clipboard')
			]));
};
var $author$project$Pages$Admin$Team$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ak4: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Wa: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							eC: false,
							I: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init(
										$author$project$Pages$Admin$Team$formFieldsInit(model.ajG)),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							eC: true,
							I: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init(
										$author$project$Pages$Admin$Team$formFieldsInit(model.ajG)),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 11:
				var field = msg.a;
				var _v1 = model.I;
				if (!_v1.$) {
					var _v2 = _v1.a;
					var teamMember = _v2.a;
					var form = _v2.b;
					var request = _v2.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$Team$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								I: $elm$core$Maybe$Just(
									_Utils_Tuple3(teamMember, newForm, request))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 10:
				var form = msg.a;
				var teamMember = msg.b;
				var id = msg.c;
				var _v3 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$Team$formFieldsValidator, form);
				if (!_v3.$) {
					var _v4 = _v3.a;
					var newForm = _v4.a;
					var validFormFields = _v4.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								I: $elm$core$Maybe$Just(
									_Utils_Tuple3(teamMember, newForm, $author$project$Api$Data$Loading))
							}),
						A5($author$project$Pages$Admin$Team$saveTeamMember, model.Gv, model.vE, model.eC, id, validFormFields),
						_List_Nil);
				} else {
					var newForm = _v3.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								I: $elm$core$Maybe$Just(
									_Utils_Tuple3(teamMember, newForm, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 4:
				var teamMember = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							eC: false,
							I: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(teamMember),
									$author$project$Utils$Form$init(
										$author$project$Pages$Admin$Team$formFieldsFromTeamMember(teamMember)),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{eC: false, I: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 6:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ),
								fm: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{fm: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 7:
				var subMsg = msg.a;
				var _v6 = A2($author$project$Ui$SearchInput$update, subMsg, model.up);
				var searchInput = _v6.a;
				var searchInputCmd = _v6.b;
				var searchInputEvent = _v6.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.akl;
					}
				}();
				var _v7 = function () {
					if (_Utils_eq(q, model.akl)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								ajJ: $author$project$Api$Pagination$reset(model.ajJ),
								akl: q,
								fm: $author$project$Api$Data$Loading
							});
						return _Utils_Tuple2(
							qModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Admin$Team$fetchTeamMembers(qModel),
										A2($elm$core$Basics$composeR, $author$project$Pages$Admin$Team$buildUrl, $author$project$Ports$Navigation$pushUrl)(qModel)
									])));
					}
				}();
				var newModel = _v7.a;
				var cmd = _v7.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{up: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Team$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
			case 8:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{ajJ: pagination, fm: $author$project$Api$Data$Loading});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Admin$Team$fetchTeamMembers(newModel),
								A2($elm$core$Basics$composeR, $author$project$Pages$Admin$Team$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 9:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						alA: A2($author$project$Api$Sort$update, columnId, model.alA),
						fm: $author$project$Api$Data$Loading
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Admin$Team$fetchTeamMembers(newModel),
								A2($elm$core$Basics$composeR, $author$project$Pages$Admin$Team$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 12:
				var response = msg.a;
				var _v9 = model.I;
				if (!_v9.$) {
					var _v10 = _v9.a;
					var teamMember = _v10.a;
					var form = _v10.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{eC: false, I: $elm$core$Maybe$Nothing}),
							$author$project$Pages$Admin$Team$fetchTeamMembers(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Team member successfully added')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									I: $elm$core$Maybe$Just(
										_Utils_Tuple3(teamMember, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 13:
				var response = msg.a;
				var _v12 = model.I;
				if (!_v12.$) {
					var _v13 = _v12.a;
					var id = _v13.a;
					var form = _v13.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{I: $elm$core$Maybe$Nothing}),
							$author$project$Pages$Admin$Team$fetchTeamMembers(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Team member successfully updated')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									I: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 14:
				var id = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									eo: A2($elm$core$Set$remove, id, model.eo),
									fm: $author$project$Api$Data$Loading
								}),
							$author$project$Pages$Admin$Team$fetchTeamMembers(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Team member successfully removed')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									eo: A2($elm$core$Set$remove, id, model.eo)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 15:
				var teamMember = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							nf: $elm$core$Maybe$Just(teamMember)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 16:
				var id = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							nf: $elm$core$Maybe$Nothing,
							eo: A2($elm$core$Set$insert, id, model.eo)
						}),
					A3(
						$author$project$Api$Provider$TeamMember$delete,
						model.Gv,
						id,
						$author$project$Pages$Admin$Team$TeamMemberDeleted(id)),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{nf: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 17:
				var id = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							jq: $elm$core$Maybe$Just(id)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 18:
				var id = msg.a;
				var confirmed = msg.b;
				var _v16 = model.I;
				if (!_v16.$) {
					var _v17 = _v16.a;
					var teamMember = _v17.a;
					var form = _v17.b;
					return confirmed ? _Utils_Tuple3(
						_Utils_update(
							model,
							{
								jq: $elm$core$Maybe$Nothing,
								I: $elm$core$Maybe$Just(
									_Utils_Tuple3(teamMember, form, $author$project$Api$Data$Loading))
							}),
						A3($author$project$Api$Provider$TeamMember$disableMfa, model.Gv, id, $author$project$Pages$Admin$Team$TeamMemberMfaDisabled),
						_List_Nil) : _Utils_Tuple3(
						_Utils_update(
							model,
							{jq: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 19:
				var response = msg.a;
				var _v18 = model.I;
				if (!_v18.$) {
					var _v19 = _v18.a;
					var teamMember = _v19.a;
					var form = _v19.b;
					switch (response.$) {
						case 3:
							var newForm = A3(
								$author$project$Utils$Form$update,
								$author$project$Pages$Admin$Team$formFieldsUpdate,
								$author$project$Pages$Admin$Team$MfaStatus('inactive'),
								form);
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										I: $elm$core$Maybe$Just(
											_Utils_Tuple3(teamMember, newForm, $author$project$Api$Data$NotAsked)),
										fm: $author$project$Api$Data$Loading
									}),
								$author$project$Pages$Admin$Team$fetchTeamMembers(model),
								_List_fromArray(
									[
										A2($author$project$OutMsg$ShowToast, 3, 'Team member mfa successfully disabled')
									]));
						case 2:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										I: $elm$core$Maybe$Just(
											_Utils_Tuple3(teamMember, form, $author$project$Api$Data$NotAsked))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$OutMsg$handleErrorResponse(response));
						default:
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 20:
				var teamMember = msg.a;
				return _Utils_Tuple3(
					model,
					A3(
						$author$project$Api$Provider$TeamMember$invite,
						model.Gv,
						$author$project$Api$Provider$PracticeUser$All$id(teamMember),
						A2(
							$author$project$Pages$Admin$Team$GotInvitation,
							$author$project$Api$Provider$PracticeUser$All$email(teamMember),
							false)),
					_List_Nil);
			case 21:
				var teamMember = msg.a;
				return _Utils_Tuple3(
					model,
					A3(
						$author$project$Api$Provider$TeamMember$invite,
						model.Gv,
						$author$project$Api$Provider$PracticeUser$All$id(teamMember),
						A2(
							$author$project$Pages$Admin$Team$GotInvitation,
							$author$project$Api$Provider$PracticeUser$All$email(teamMember),
							true)),
					_List_Nil);
			case 23:
				var email = msg.a;
				var isReinvite = msg.b;
				var response = msg.c;
				if (response.$ === 3) {
					var prefix = isReinvite ? 'A new' : 'An';
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{fm: $author$project$Api$Data$Loading}),
						$author$project$Pages$Admin$Team$fetchTeamMembers(model),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, prefix + (' invitation is being sent to ' + email))
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 22:
				var subMsg = msg.a;
				var _v22 = $author$project$Components$InviteLink$update(subMsg);
				var inviteLinkCmd = _v22.a;
				var inviteLinkOutMsg = _v22.b;
				return _Utils_Tuple3(
					model,
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Team$InviteLinkMsg, inviteLinkCmd),
					inviteLinkOutMsg);
			case 24:
				var subMsg = msg.a;
				var toogleOrganizationMfaResult = A3($author$project$Components$Admin$ToogleOrganizationMfa$update, model.Gv, subMsg, model.vb);
				var newModel = function () {
					var _v23 = toogleOrganizationMfaResult.agZ;
					switch (_v23.$) {
						case 0:
							return model;
						case 1:
							var practice = _v23.a;
							return _Utils_update(
								model,
								{ZV: practice});
						default:
							return model;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{vb: toogleOrganizationMfaResult.aiO}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Team$ToogleOrganizationMfa, toogleOrganizationMfaResult.GZ),
					toogleOrganizationMfaResult.aR);
			case 25:
				var id = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							eI: A2($elm$core$Set$insert, id, model.eI)
						}),
					A3(
						$author$project$Api$Provider$TeamMember$makeSuperAdmin,
						model.Gv,
						id,
						$author$project$Pages$Admin$Team$TeamMemberAdminCompleted(id)),
					_List_Nil);
			default:
				var id = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									eI: A2($elm$core$Set$remove, id, model.eI)
								}),
							$author$project$Pages$Admin$Team$fetchTeamMembers(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Team member is now an admin')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									eI: A2($elm$core$Set$remove, id, model.eI)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Admin$Team$AddExistingMember = {$: 3};
var $author$project$Pages$Admin$Team$NewTeamMember = {$: 2};
var $author$project$Pages$Admin$Team$PaginationMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Admin$Team$buildIdentityProviderUrl = F2(
	function (hintEnv, organizationId) {
		var envPath = function () {
			_v0$2:
			while (true) {
				if (!hintEnv.$) {
					switch (hintEnv.a) {
						case 0:
							var _v1 = hintEnv.a;
							return 'production';
						case 1:
							var _v2 = hintEnv.a;
							return 'staging';
						default:
							break _v0$2;
					}
				} else {
					break _v0$2;
				}
			}
			return 'development';
		}();
		return 'https://portal.frontegg.com/' + (envPath + ('/backoffice/accounts/' + organizationId));
	});
var $author$project$Api$Provider$Practice$One$organizationId = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.ajD;
	});
var $author$project$Components$HiConfirm$TitleizeNoun = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$HiConfirm$titleizeNoun = $author$project$Components$HiConfirm$TitleizeNoun;
var $author$project$Pages$Admin$Team$SortTable = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Admin$Team$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'user_first_name', true, 'Name'),
		A3($author$project$Api$Column$init, 'email', false, 'Email'),
		A3($author$project$Api$Column$init, 'role', true, 'Role'),
		A3($author$project$Api$Column$init, 'notifications', false, 'Notifications'),
		A3($author$project$Api$Column$init, 'mfa', false, 'MFA')
	]);
var $author$project$Components$Admin$ToogleOrganizationMfa$ToogleMfa = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Platform$User$Shared$isMfaActive = function (_v0) {
	var record = _v0;
	return record.UY;
};
var $author$project$Api$Partner$Partner$Shared$requiresMfa = function (_v0) {
	var record = _v0;
	return record.$H;
};
var $author$project$Api$Partner$Partner$One$requiresMfa = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$requiresMfa(shared);
};
var $author$project$Api$Provider$Practice$One$requiresMfa = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.$H;
	});
var $author$project$Components$Admin$ToogleOrganizationMfa$view = function (_v0) {
	var model = _v0;
	var requiresMfa = function () {
		var _v1 = model.Yr;
		if (!_v1.$) {
			var practice = _v1.a;
			return $author$project$Api$Provider$Practice$One$requiresMfa(practice);
		} else {
			var partner = _v1.a;
			return $author$project$Api$Partner$Partner$One$requiresMfa(partner);
		}
	}();
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Require Multi-factor authentication (MFA)'),
				$author$project$Ui$Form$Group$labelSpanSm(4),
				$author$project$Ui$Form$Group$inputSpanSm(8)
			]),
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$view(
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$on(requiresMfa),
						$author$project$Ui$ToggleSwitch$onChange($author$project$Components$Admin$ToogleOrganizationMfa$ToogleMfa),
						$author$project$Ui$ToggleSwitch$disabled(
						(!$author$project$Api$Platform$User$Shared$isMfaActive(model.Hd)) || _Utils_eq(model.qR, $author$project$Api$Data$Loading))
					])),
				A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$helpBlock]),
				_List_fromArray(
					[
						$elm$html$Html$text('Add an extra layer of security to your account by requiring users to enter a one-time '),
						$elm$html$Html$text('authentication code in addition to their password. Enabling this will require all the '),
						$elm$html$Html$text('users to enable MFA in order to access this application.')
					])),
				(!$author$project$Api$Platform$User$Shared$isMfaActive(model.Hd)) ? A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$helpBlock]),
				_List_fromArray(
					[
						$elm$html$Html$text('You need to enable MFA before making it required. Enable it '),
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$User__Mfa,
						_List_fromArray(
							[
								$author$project$Ui$Link$routeParams(
								_List_fromArray(
									[
										A2($elm$url$Url$Builder$string, 'requiresMfaPrerequisite', 'true')
									]))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('here')
							])),
						$elm$html$Html$text('.')
					])) : $author$project$Utils$Html$empty
			]));
};
var $author$project$Pages$Admin$Team$EditTeamMember = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Table$Info = 1;
var $author$project$Pages$Admin$Team$InviteTeamMember = function (a) {
	return {$: 20, a: a};
};
var $author$project$Pages$Admin$Team$MakeSuperAdmin = function (a) {
	return {$: 25, a: a};
};
var $author$project$Pages$Admin$Team$OpenDeleteConfirm = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$InviteLink$PracticeUser = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$Team$ReInviteTeamMember = function (a) {
	return {$: 21, a: a};
};
var $author$project$Api$Provider$PracticeUser$All$isHinter = function (_v0) {
	var shared = _v0.a;
	return A2(
		$elm$core$String$contains,
		'@hint.com',
		$author$project$Api$Provider$PracticeUser$Shared$email(shared));
};
var $author$project$Api$Provider$User$Shared$isAdmin = function (_v0) {
	var record = _v0;
	return record.Uy;
};
var $author$project$Api$Provider$User$One$isAdmin = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$User$Shared$isAdmin(shared);
};
var $author$project$Api$Provider$PracticeUser$All$isSuperAdmin = function (practiceUser) {
	var _v0 = $author$project$Api$Provider$PracticeUser$All$user(practiceUser);
	if (_v0.$ === 1) {
		return false;
	} else {
		var user_ = _v0.a;
		return $author$project$Api$Provider$PracticeUser$All$isHinter(practiceUser) && $author$project$Api$Provider$User$One$isAdmin(user_);
	}
};
var $author$project$Pages$Admin$Team$canMakeSuperAdmin = F2(
	function (teamMember, isHintAdmin) {
		return isHintAdmin && ($author$project$Api$Provider$PracticeUser$All$isHinter(teamMember) && ($author$project$Utils$Maybe$toBool(
			$author$project$Api$Provider$PracticeUser$All$user(teamMember)) && (!$author$project$Api$Provider$PracticeUser$All$isSuperAdmin(teamMember))));
	});
var $author$project$Api$Provider$PracticeUser$Shared$invitationPending = function (_v0) {
	var record = _v0;
	return record.Ui;
};
var $author$project$Api$Provider$PracticeUser$All$invitationPending = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PracticeUser$Shared$invitationPending(shared);
};
var $author$project$Api$Provider$PracticeUser$Shared$isDestroyable = function (_v0) {
	var record = _v0;
	return record.UN;
};
var $author$project$Api$Provider$PracticeUser$All$isDestroyable = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PracticeUser$Shared$isDestroyable(shared);
};
var $author$project$Api$Provider$PracticeUser$Shared$isOwner = function (_v0) {
	var record = _v0;
	return record.U0;
};
var $author$project$Api$Provider$PracticeUser$All$isOwner = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PracticeUser$Shared$isOwner(shared);
};
var $author$project$Ui$Table$Styled = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Table$styled = $author$project$Ui$Table$Styled;
var $author$project$Components$InviteLink$CopyToClipboard = $elm$core$Basics$identity;
var $author$project$Api$Partner$PartnerUser$Shared$invitationPending = function (_v0) {
	var record = _v0;
	return record.Ui;
};
var $author$project$Api$Partner$PartnerUser$All$invitationPending = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$PartnerUser$Shared$invitationPending(shared);
};
var $author$project$Api$Provider$CompanyAdmin$Shared$invitationPending = function (_v0) {
	var record = _v0;
	return record.Ui;
};
var $author$project$Api$Provider$CompanyAdmin$One$invitationPending = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyAdmin$Shared$invitationPending(shared);
};
var $author$project$Api$Provider$CompanyAdmin$All$invitationPending = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$CompanyAdmin$One$invitationPending(one);
};
var $author$project$Api$Partner$PartnerUser$All$invitationUrl = function (_v0) {
	var record = _v0.b;
	return record.Uj;
};
var $author$project$Api$Provider$CompanyAdmin$One$invitationUrl = function (_v0) {
	var record = _v0.b;
	return record.Uj;
};
var $author$project$Api$Provider$CompanyAdmin$All$invitationUrl = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$CompanyAdmin$One$invitationUrl(one);
};
var $author$project$Api$Provider$PracticeUser$All$invitationUrl = function (_v0) {
	var record = _v0.b;
	return record.Uj;
};
var $author$project$Components$InviteLink$view = function (admin) {
	var _v0 = function () {
		switch (admin.$) {
			case 0:
				var companyAdmin = admin.a;
				return _Utils_Tuple2(
					$author$project$Api$Provider$CompanyAdmin$All$invitationPending(companyAdmin),
					$author$project$Api$Provider$CompanyAdmin$All$invitationUrl(companyAdmin));
			case 1:
				var practiceUser = admin.a;
				return _Utils_Tuple2(
					$author$project$Api$Provider$PracticeUser$All$invitationPending(practiceUser),
					$author$project$Api$Provider$PracticeUser$All$invitationUrl(practiceUser));
			default:
				var partnerUser = admin.a;
				return _Utils_Tuple2(
					$author$project$Api$Partner$PartnerUser$All$invitationPending(partnerUser),
					$author$project$Api$Partner$PartnerUser$All$invitationUrl(partnerUser));
		}
	}();
	var invitationPending = _v0.a;
	var invitationUrl = _v0.b;
	return (invitationPending && (!_Utils_eq(invitationUrl, $elm$core$Maybe$Nothing))) ? A3(
		$author$project$Ui$Button$view,
		{mm: 'Copy invite link'},
		_List_fromArray(
			[
				$author$project$Ui$Button$link,
				$author$project$Ui$Button$onClick(
				A2($elm$core$Maybe$withDefault, '', invitationUrl)),
				$author$project$Ui$Button$sm,
				$author$project$Ui$Button$icon($author$project$Ui$Icon$copy)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Copy Invite Link')
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Pages$Admin$Team$viewTeamMember = F5(
	function (currentUser, deletingTeamMembers, makingAdminTeamMembers, currentUserIsHintAdmin, teamMember) {
		var notificationsStatus = $author$project$Api$Provider$PracticeUser$All$notificationsEnabled(teamMember) ? 'enabled' : 'disabled';
		var memberIsOwner = $author$project$Api$Provider$PracticeUser$All$isOwner(teamMember);
		var isCurrentUser = _Utils_eq(
			$author$project$Api$Provider$PracticeUser$All$email(teamMember),
			$author$project$Api$Platform$User$Shared$email(currentUser));
		var rowOptions = isCurrentUser ? _List_fromArray(
			[
				$author$project$Ui$Table$styled(1)
			]) : _List_Nil;
		var id = $author$project$Api$Provider$PracticeUser$All$id(teamMember);
		var loading = A2($elm$core$Set$member, id, deletingTeamMembers) || A2($elm$core$Set$member, id, makingAdminTeamMembers);
		return A2(
			$author$project$Ui$Table$row,
			rowOptions,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[
							$author$project$Ui$Table$minWidth('11em')
						]),
					function () {
						var _v0 = $author$project$Api$Provider$PracticeUser$All$user(teamMember);
						if (!_v0.$) {
							var user = _v0.a;
							var memberIsHintAdmin = $author$project$Api$Provider$PracticeUser$All$isSuperAdmin(teamMember);
							var isOwnerOrAdminLabel = function () {
								var _v1 = _Utils_Tuple3(memberIsOwner, memberIsHintAdmin, currentUserIsHintAdmin);
								if (_v1.a) {
									if (_v1.b) {
										if (_v1.c) {
											return $elm$html$Html$text(' (owner | admin)');
										} else {
											return $elm$html$Html$text(' (owner)');
										}
									} else {
										return $elm$html$Html$text(' (owner)');
									}
								} else {
									if (_v1.b && _v1.c) {
										return $elm$html$Html$text(' (admin)');
									} else {
										return $author$project$Utils$Html$empty;
									}
								}
							}();
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Provider$User$One$name(user))
										])),
									isOwnerOrAdminLabel
								]);
						} else {
							var isOwnerLabel = memberIsOwner ? $elm$html$Html$text(' (owner)') : $author$project$Utils$Html$empty;
							return $author$project$Api$Provider$PracticeUser$All$invitationPending(teamMember) ? _List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$em,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Invitation Pending'),
											isOwnerLabel
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$gap2]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{mm: 'Resend invite email'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$sm,
													$author$project$Ui$Button$onClick(
													$author$project$Pages$Admin$Team$ReInviteTeamMember(teamMember)),
													$author$project$Ui$Button$icon($author$project$Ui$Icon$repeat)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Resend')
												])),
											A2(
											$elm$html$Html$map,
											$author$project$Pages$Admin$Team$InviteLinkMsg,
											$author$project$Components$InviteLink$view(
												$author$project$Components$InviteLink$PracticeUser(teamMember)))
										]))
								]) : _List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$em,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Not Invited'),
											isOwnerLabel
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$gap2]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{mm: 'Send invite email'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick(
													$author$project$Pages$Admin$Team$InviteTeamMember(teamMember)),
													$author$project$Ui$Button$icon($author$project$Ui$Icon$send),
													$author$project$Ui$Button$sm
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Send Invite')
												])),
											A2(
											$elm$html$Html$map,
											$author$project$Pages$Admin$Team$InviteLinkMsg,
											$author$project$Components$InviteLink$view(
												$author$project$Components$InviteLink$PracticeUser(teamMember)))
										]))
								]);
						}
					}()),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$PracticeUser$All$email(teamMember))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Formatters$String$titleize(
								$author$project$Formatters$String$humanize(
									$author$project$Api$Provider$PracticeUser$All$role(teamMember))))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Ui$Badge$fromString, _List_Nil, notificationsStatus)
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Badge$fromString,
							_List_Nil,
							$author$project$Pages$Admin$Team$mfaStatus(
								$elm$core$Maybe$Just(teamMember)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$justifyRight, $author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									A2($author$project$Pages$Admin$Team$canMakeSuperAdmin, teamMember, currentUserIsHintAdmin) ? A3(
									$author$project$Ui$HinterOnly$button,
									{mm: 'Make admin'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$loading(loading),
											$author$project$Ui$Button$disabled(loading),
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Admin$Team$MakeSuperAdmin(
												$author$project$Api$Provider$PracticeUser$All$id(teamMember)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Make admin')
										])) : $author$project$Utils$Html$empty,
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Edit team member'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$disabled(
											loading || (memberIsOwner && (!$author$project$Api$Platform$User$Shared$isAdmin(currentUser)))),
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Admin$Team$EditTeamMember(teamMember)),
											$author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit')
										])),
									($author$project$Api$Provider$PracticeUser$All$isDestroyable(teamMember) && (!isCurrentUser)) ? A3(
									$author$project$Ui$Button$view,
									{mm: 'Delete team member'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$loading(loading),
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Admin$Team$OpenDeleteConfirm(teamMember)),
											$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Delete')
										])) : $author$project$Utils$Html$empty
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$Team$viewPanelBody = function (model) {
	var _v0 = function () {
		var _v1 = model.fm;
		if (_v1.$ === 3) {
			var teamMembers_ = _v1.a;
			return _Utils_Tuple2(false, teamMembers_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var teamMembers = _v0.b;
	return _List_fromArray(
		[
			$author$project$Ui$Typography$headingSm(
			_List_fromArray(
				[
					$elm$html$Html$text('Security')
				])),
			A2(
			$elm$html$Html$map,
			$author$project$Pages$Admin$Team$ToogleOrganizationMfa,
			$author$project$Components$Admin$ToogleOrganizationMfa$view(model.vb)),
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mb2]),
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Members')
						]))
				])),
			A2(
			$author$project$Ui$Grid$row,
			_List_fromArray(
				[$author$project$Ui$Grid$mb2]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$span(12)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Pages$Admin$Team$SearchInputMsg,
									A2($author$project$Ui$SearchInput$view, _List_Nil, model.up))
								]))
						]))
				])),
			A4(
			$author$project$Ui$Table$view,
			_List_fromArray(
				[
					$author$project$Ui$Table$verticalCentered,
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('There are no team members.')
						])),
					$author$project$Ui$Table$loading(loading)
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						A2(
						$elm$core$List$map,
						$author$project$Api$Column$view(
							A2($author$project$Api$Column$Sortable, model.alA, $author$project$Pages$Admin$Team$SortTable)),
						$author$project$Pages$Admin$Team$columns),
						_List_fromArray(
						[
							A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
						])
					])),
			A2(
				$elm$core$List$map,
				A4($author$project$Pages$Admin$Team$viewTeamMember, model.Hd, model.eo, model.eI, model.Ij),
				teamMembers),
			_List_Nil)
		]);
};
var $author$project$Pages$Admin$Team$Email = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$Team$FormUpdated = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Admin$Team$Invite = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Admin$Team$NotificationsEnabled = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$Team$OpenDisableMfaConfirm = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$Admin$Team$RestrictedByGroups = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Admin$Team$Role = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$Team$SaveTeamMember = F3(
	function (a, b, c) {
		return {$: 10, a: a, b: b, c: c};
	});
var $author$project$Api$Common$Role$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Common$Role$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Common$Role$Shared$name(shared);
};
var $author$project$Api$Common$Role$Shared$permissionSets = function (_v0) {
	var record = _v0;
	return record.Zv;
};
var $author$project$Api$Common$Role$All$permissionSets = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Common$Role$Shared$permissionSets(shared);
};
var $author$project$Pages$Admin$Team$roleOptions = F2(
	function (adminOnly, roles) {
		return A2(
			$elm$core$List$cons,
			A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, 'Pick a role'),
			A2(
				$elm$core$List$map,
				function (role) {
					return A3(
						$author$project$Ui$Form$Select$option,
						_List_Nil,
						$elm$core$Maybe$Just(
							$author$project$Api$Common$Role$All$name(role)),
						$author$project$Formatters$String$titleize(
							$author$project$Formatters$String$humanize(
								$author$project$Api$Common$Role$All$name(role))));
				},
				A2(
					$elm$core$List$filter,
					function (role) {
						return (!adminOnly) || ($author$project$Api$Common$Role$All$name(role) === 'admin');
					},
					roles)));
	});
var $author$project$Ui$Grid$textCenter = $author$project$Ui$Grid$Element($author$project$Ui$Element$textCenter);
var $author$project$Pages$Admin$Team$LocationGroups = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Pages$Admin$Team$viewLocationGroup = F2(
	function (locationGroups, locationGroup) {
		var id = $author$project$Api$Provider$LocationGroup$All$id(locationGroup);
		var locationGroupEnabled = A2($elm$core$Set$member, id, locationGroups);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Checkbox$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Checkbox$value(locationGroupEnabled),
							$author$project$Ui$Form$Checkbox$onCheck(
							A2(
								$elm$core$Basics$composeL,
								$author$project$Pages$Admin$Team$FormUpdated,
								$author$project$Pages$Admin$Team$LocationGroups(id)))
						]),
					_List_fromArray(
						[
							$author$project$Utils$Html$noBreakSpace,
							$elm$html$Html$text(
							$author$project$Api$Provider$LocationGroup$All$name(locationGroup))
						]))
				]));
	});
var $author$project$Pages$Admin$Team$viewPermissionSet = F2(
	function (index, permissionSet) {
		var hasEvenIndex = !A2($elm$core$Basics$modBy, 2, index);
		var gridOptions = hasEvenIndex ? _List_fromArray(
			[
				$author$project$Ui$Grid$offsetSm(2),
				$author$project$Ui$Grid$spanSm(4),
				$author$project$Ui$Grid$span(6)
			]) : _List_fromArray(
			[
				$author$project$Ui$Grid$spanSm(5),
				$author$project$Ui$Grid$justifyRight
			]);
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$column,
				gridOptions,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$text,
								_List_fromArray(
									[$author$project$Ui$Typography$muted]),
								$author$project$Formatters$String$humanize(
									$author$project$Api$Common$PermissionSet$Shared$name(permissionSet))),
								$author$project$Api$Common$PermissionSet$Shared$enabled(permissionSet) ? $author$project$Ui$Icon$check(
								_List_fromArray(
									[$author$project$Ui$Icon$success])) : $author$project$Ui$Icon$cross(
								_List_fromArray(
									[$author$project$Ui$Icon$danger]))
							]))
					]))
			]);
	});
var $author$project$Api$Feature$ReportAccess = 9;
var $author$project$Pages$Admin$Team$ReportRestricted = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$Team$viewReportAccessSection = F3(
	function (practice, permissions, fields) {
		var featureIsEnabled = A2($author$project$Api$Provider$Practice$One$featureEnabled, 9, practice);
		var canViewReports = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Common$PermissionSet$Shared$enabled,
				A2(
					$elm_community$list_extra$List$Extra$find,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Api$Common$PermissionSet$Shared$name,
						$elm$core$Basics$eq('view_reports')),
					permissions)));
		return (featureIsEnabled && ((fields.ak3 !== 'admin') && canViewReports)) ? A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Restrict report access')
				]),
			_List_fromArray(
				[
					$author$project$Ui$ToggleSwitch$view(
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$on(fields.$x),
							$author$project$Ui$ToggleSwitch$onChange(
							A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Team$FormUpdated, $author$project$Pages$Admin$Team$ReportRestricted))
						]))
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Pages$Admin$Team$viewTeamMemberModal = F4(
	function (model, teamMember, request, form) {
		var modalConfig = {
			Tq: $elm$core$Maybe$Nothing,
			aih: 'Team Member',
			V8: _Utils_eq(request, $author$project$Api$Data$Loading),
			WG: A2($elm$core$Maybe$map, $author$project$Api$Provider$PracticeUser$All$id, teamMember),
			WH: $elm$core$Maybe$Nothing,
			Yd: $author$project$Pages$Admin$Team$CancelTeamMemberEdit,
			Yf: A2($author$project$Pages$Admin$Team$SaveTeamMember, form, teamMember)
		};
		var isNewTeamMember = !$author$project$Utils$Maybe$toBool(teamMember);
		var isCurrentUser = _Utils_eq(
			A2($elm$core$Maybe$map, $author$project$Api$Provider$PracticeUser$All$email, teamMember),
			$elm$core$Maybe$Just(
				$author$project$Api$Platform$User$Shared$email(model.Hd)));
		var roleDisabled = isCurrentUser || A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$PracticeUser$All$isOwner, teamMember));
		var fields = $author$project$Utils$Form$fields(form);
		var _v0 = function () {
			var _v1 = model.ak4;
			if (_v1.$ === 3) {
				var list = _v1.a;
				return _Utils_Tuple2(list, false);
			} else {
				return _Utils_Tuple2(_List_Nil, true);
			}
		}();
		var roles_ = _v0.a;
		var rolesLoading = _v0.b;
		var permissionSets = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Common$Role$All$permissionSets,
				A2(
					$elm_community$list_extra$List$Extra$find,
					function (role) {
						return _Utils_eq(
							$author$project$Api$Common$Role$All$name(role),
							fields.ak3);
					},
					roles_)));
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$required(isNewTeamMember),
							$author$project$Ui$Form$Group$label('Email')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(fields.Rj),
									$author$project$Ui$Form$Input$placeholder('email@example.com'),
									$author$project$Ui$Form$Input$autofocus(true),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Team$FormUpdated, $author$project$Pages$Admin$Team$Email)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 0, form)),
									$author$project$Ui$Form$Input$disabled(!isNewTeamMember)
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$required(true),
							$author$project$Ui$Form$Group$label('Role')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(
									$elm$core$Maybe$Just(fields.ak3)),
									$author$project$Ui$Form$Select$onChange(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Team$FormUpdated, $author$project$Pages$Admin$Team$Role)),
									$author$project$Ui$Form$Select$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
									$author$project$Ui$Form$Select$errors(
									A2($author$project$Utils$Form$validationErrors, 1, form)),
									$author$project$Ui$Form$Select$loading(rolesLoading),
									$author$project$Ui$Form$Select$disabled(roleDisabled)
								]),
							A2($author$project$Pages$Admin$Team$roleOptions, model.vE, roles_)),
							roleDisabled ? A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[$author$project$Ui$Typography$small, $author$project$Ui$Typography$info]),
							'You cannot change your own role.') : $author$project$Utils$Html$empty
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Notifications')
						]),
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$view(
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$on(fields.X$),
									$author$project$Ui$ToggleSwitch$onChange(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Team$FormUpdated, $author$project$Pages$Admin$Team$NotificationsEnabled))
								]))
						])),
					(isNewTeamMember && (!model.eC)) ? A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Send invitation')
						]),
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$view(
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$on(fields.n2),
									$author$project$Ui$ToggleSwitch$onChange(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Team$FormUpdated, $author$project$Pages$Admin$Team$Invite))
								]))
						])) : $author$project$Utils$Html$empty,
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('MFA')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$Ui$Badge$fromString, _List_Nil, fields.W6),
									$author$project$Utils$Html$noBreakSpace,
									function () {
									if (!teamMember.$) {
										var teamMember_ = teamMember.a;
										return ((fields.W6 === 'active') && (!isCurrentUser)) ? A3(
											$author$project$Ui$Button$view,
											{mm: 'Reset MFA device'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick(
													$author$project$Pages$Admin$Team$OpenDisableMfaConfirm(
														$author$project$Api$Provider$PracticeUser$All$id(teamMember_)))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Reset MFA device')
												])) : $author$project$Utils$Html$empty;
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								]))
						])),
					A2(
					$author$project$Ui$Grid$row,
					_List_fromArray(
						[$author$project$Ui$Grid$mb4, $author$project$Ui$Grid$mt4]),
					$elm$core$List$concat(
						A2($elm$core$List$indexedMap, $author$project$Pages$Admin$Team$viewPermissionSet, permissionSets))),
					(fields.ak3 !== 'admin') ? A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Restrict by location groups')
						]),
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$view(
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$on(fields.$T),
									$author$project$Ui$ToggleSwitch$onChange(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Team$FormUpdated, $author$project$Pages$Admin$Team$RestrictedByGroups))
								]))
						])) : $author$project$Utils$Html$empty,
					fields.$T ? A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$offset(4),
									$author$project$Ui$Grid$span(8)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$title,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Which location groups\' patients should they be able to see?')
										]))
								])),
						function () {
							var _v3 = model.Wa;
							if (_v3.$ === 3) {
								var locationGroups = _v3.a;
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$offset(4),
												$author$project$Ui$Grid$span(8)
											]),
										A2(
											$elm$core$List$map,
											$author$project$Pages$Admin$Team$viewLocationGroup(fields.Wa),
											locationGroups))
									]);
							} else {
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$offset(4),
												$author$project$Ui$Grid$span(8),
												$author$project$Ui$Grid$textCenter
											]),
										_List_fromArray(
											[
												$author$project$Ui$Spinner$view(_List_Nil)
											]))
									]);
							}
						}())) : $author$project$Utils$Html$empty,
					A3($author$project$Pages$Admin$Team$viewReportAccessSection, model.ZV, permissionSets, fields)
				]));
	});
var $author$project$Pages$Admin$Team$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				function () {
				var _v0 = model.I;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var teamMember = _v1.a;
					var form = _v1.b;
					var request = _v1.c;
					return A4($author$project$Pages$Admin$Team$viewTeamMemberModal, model, teamMember, request, form);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v2 = model.nf;
				if (!_v2.$) {
					var teamMember = _v2.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Admin$Team$DeleteConfirmClosed(
							$author$project$Api$Provider$PracticeUser$All$id(teamMember)),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('delete'),
								$author$project$Components$HiConfirm$noun('team member'),
								$author$project$Components$HiConfirm$detail(
								$author$project$Api$Provider$PracticeUser$All$email(teamMember))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v3 = model.jq;
				if (!_v3.$) {
					var id = _v3.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Admin$Team$DisableMfaConfirmClosed(id),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('reset'),
								$author$project$Components$HiConfirm$noun('MFA device'),
								$author$project$Components$HiConfirm$titleizeNoun(false),
								$author$project$Components$HiConfirm$customMessage(
								_List_fromArray(
									[
										$elm$html$Html$text('Resetting the MFA device for this user will log them out of all sessions and require them to setup a new MFA device the next time they login.')
									]))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Ui$Panel$title(
												_List_fromArray(
													[
														$elm$html$Html$text('Team')
													])),
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$textSm]),
												_List_fromArray(
													[
														$elm$html$Html$text('Changing settings within the Admin section requires \"Admin\" privileges. Non admin users can\n        view the settings but cannot change them.')
													]))
											])),
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$gap2]),
										_List_fromArray(
											[
												model.Ij ? A3(
												$author$project$Ui$HinterOnly$linkHref,
												A2(
													$author$project$Pages$Admin$Team$buildIdentityProviderUrl,
													model.ahJ,
													$author$project$Api$Provider$Practice$One$organizationId(model.ZV)),
												_List_fromArray(
													[
														$author$project$Ui$Link$targetBlank,
														$author$project$Ui$Link$buttonDefault,
														$author$project$Ui$Link$ariaLabel('Open Identity Provider in new tab')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Identity Provider')
													])) : $author$project$Utils$Html$empty,
												model.Ij ? A3(
												$author$project$Ui$HinterOnly$button,
												{mm: 'Add & Auto Accept member'},
												_List_fromArray(
													[
														$author$project$Ui$Button$default,
														$author$project$Ui$Button$onClick($author$project$Pages$Admin$Team$AddExistingMember)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Add & Auto Accept')
													])) : $author$project$Utils$Html$empty,
												A3(
												$author$project$Ui$Button$view,
												{mm: 'Add new member'},
												_List_fromArray(
													[
														$author$project$Ui$Button$default,
														$author$project$Ui$Button$onClick($author$project$Pages$Admin$Team$NewTeamMember),
														$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Add')
													]))
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						$author$project$Pages$Admin$Team$viewPanelBody(model)),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Admin$Team$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(
											!$author$project$Api$Data$isSuccess(model.fm))
										]),
									model.ajJ))
							]))
					]))
			]),
		ac9: 'Admin | Team'
	};
};
var $author$project$Pages$Admin$Team$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Team$init, aiq: $author$project$Pages$Admin$Team$load, k8: $author$project$Pages$Admin$Team$save, alO: $author$project$Pages$Admin$Team$subscriptions, adT: $author$project$Pages$Admin$Team$update, amo: $author$project$Pages$Admin$Team$view});
var $author$project$Pages$Admin$Team$New$TeamFormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$TeamForm$CredentialsMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$TeamForm$EmrRoleDropdownMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$TeamForm$Model = $elm$core$Basics$identity;
var $author$project$Components$TeamForm$initPhone = F2(
	function (isOnboarding, maybePhone) {
		var phoneToUse = isOnboarding ? A2(
			$elm$core$Maybe$withDefault,
			{IO: '', akD: 0, amg: $author$project$Api$Common$Phone$Shared$Mobile},
			A2($elm$core$Maybe$map, $author$project$Utils$Phone$fromApi, maybePhone)) : {IO: '', akD: 0, amg: $author$project$Api$Common$Phone$Shared$Mobile};
		return A3(
			$author$project$Components$PhoneInput$init,
			'new-team-member-phone',
			_List_fromArray(
				[phoneToUse]),
			function (opts) {
				return _Utils_update(
					opts,
					{aeW: false, agy: true, AU: 1});
			});
	});
var $author$project$Api$Platform$User$Shared$phones = function (_v0) {
	var record = _v0;
	return record.Zy;
};
var $author$project$Components$TeamForm$formFieldsFromTeamMember = F2(
	function (user, isOnboarding) {
		return {
			PF: $elm$core$Maybe$Nothing,
			Rj: isOnboarding ? $author$project$Api$Platform$User$Shared$email(user) : '',
			agR: $elm$core$Maybe$Nothing,
			Sv: isOnboarding ? $author$project$Api$Platform$User$Shared$firstName(user) : '',
			VH: isOnboarding ? $author$project$Api$Platform$User$Shared$lastName(user) : '',
			Zw: A2(
				$author$project$Components$TeamForm$initPhone,
				isOnboarding,
				$elm$core$List$head(
					$author$project$Api$Platform$User$Shared$phones(user))),
			_g: $elm$core$Maybe$Nothing,
			_G: $elm$core$Maybe$Nothing
		};
	});
var $author$project$Components$TeamForm$init = F4(
	function (today, session, practice, _v0) {
		var usingClinicalEmr = _v0.fr;
		var isOnboarding = _v0.bb;
		var formFields = A2(
			$author$project$Components$TeamForm$formFieldsFromTeamMember,
			$author$project$Api$Platform$Session$One$user(session),
			isOnboarding);
		var emrRoleDropdown = $author$project$Ui$Dropdown$init(
			$author$project$Ui$Dropdown$defaultConfig(
				{ahP: 'emr-role-dropdown', al6: $author$project$Components$TeamForm$EmrRoleDropdownMsg}));
		var _v1 = $author$project$Components$ProviderCredentials$init(today);
		var credentials = _v1.a;
		var credentialsCmd = _v1.b;
		return _Utils_Tuple2(
			{
				bW: credentials,
				sa: emrRoleDropdown,
				SD: $author$project$Utils$Form$init(formFields),
				bb: isOnboarding,
				ZV: practice,
				aa4: session,
				FR: today,
				ad0: $author$project$Api$Platform$Session$One$user(session),
				fr: usingClinicalEmr
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$TeamForm$CredentialsMsg, credentialsCmd));
	});
var $author$project$Pages$Admin$Team$New$init = F4(
	function (session, practice, shared, _v0) {
		var usingClinicalEmr = $author$project$Api$Provider$Practice$One$hasClinicalAccount(practice);
		var _v1 = A4(
			$author$project$Components$TeamForm$init,
			shared.dd,
			session,
			practice,
			{bb: false, fr: usingClinicalEmr});
		var teamFormModel = _v1.a;
		var teamFormCmd = _v1.b;
		return _Utils_Tuple2(
			{aeO: false, Gv: shared.Gv, Rk: shared.ahq.agL, SD: teamFormModel, ZV: practice, pj: 0, pr: $author$project$Api$Data$NotAsked, k9: $author$project$Api$Data$NotAsked, aa4: session, p8: false},
			A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Team$New$TeamFormMsg, teamFormCmd));
	});
var $author$project$Pages$Admin$Team$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Team$New$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Team$New$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Utils$EmrRole$Admin = 0;
var $author$project$Pages$Admin$Team$New$Created = function (a) {
	return {$: 3, a: a};
};
var $author$project$Utils$EmrRole$toString = function (role) {
	switch (role) {
		case 0:
			return 'admin';
		case 1:
			return 'provider';
		default:
			return 'employee';
	}
};
var $author$project$Api$Provider$TeamMember$encodeEmrRole = function (emrRole) {
	return $author$project$Utils$EmrRole$toString(emrRole);
};
var $author$project$Api$Provider$TeamMember$createWithClinicalData = F3(
	function (apiClient, fields, toMsg) {
		var providerStatusValue = A2($elm$core$Maybe$map, $author$project$Components$TeamForm$providerStatusToString, fields._G);
		var encodeMaskedDate = function (stringDate) {
			return A2(
				$elm$core$Maybe$withDefault,
				$elm$json$Json$Encode$null,
				$elm$core$Result$toMaybe(
					A2(
						$elm$core$Result$map,
						$author$project$Utils$Date$encode,
						$author$project$Utils$Date$fromUsString(
							A2(
								$agustinrhcp$elm_mask$Mask$mask,
								$agustinrhcp$elm_mask$Mask$fromString('##/##/####'),
								stringDate)))));
		};
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'team_member',
					$elm$json$Json$Encode$object(
						$elm$core$List$concat(
							_List_fromArray(
								[
									_List_fromArray(
									[
										_Utils_Tuple2(
										'first_name',
										$elm$json$Json$Encode$string(fields.Sv)),
										_Utils_Tuple2(
										'last_name',
										$elm$json$Json$Encode$string(fields.VH)),
										_Utils_Tuple2(
										'email',
										$elm$json$Json$Encode$string(fields.Rj)),
										_Utils_Tuple2(
										'emr_role',
										$elm$json$Json$Encode$string(
											$author$project$Api$Provider$TeamMember$encodeEmrRole(fields.agR))),
										_Utils_Tuple2(
										'agreed_to_terms',
										$elm$json$Json$Encode$bool(fields.aeO))
									]),
									A3($author$project$Utils$Encode$optional, 'phone_number', $elm$json$Json$Encode$string, fields.Zx),
									A3($author$project$Utils$Encode$optional, 'prescriber_type', $elm$json$Json$Encode$string, fields._g),
									A3($author$project$Utils$Encode$optional, 'dob', encodeMaskedDate, fields.PF),
									A3($author$project$Utils$Encode$optional, 'education_degree', $elm$json$Json$Encode$string, fields.Hp),
									A3($author$project$Utils$Encode$optional, 'npi', $elm$json$Json$Encode$string, fields.X0),
									A3(
									$author$project$Utils$Encode$optional,
									'dea_licenses',
									$elm$json$Json$Encode$list($author$project$Components$ProviderCredentials$encodeLicense),
									$elm$core$List$isEmpty(fields.nb) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(fields.nb)),
									A3($author$project$Utils$Encode$optional, 'provider_status', $elm$json$Json$Encode$string, providerStatusValue),
									A3(
									$author$project$Utils$Encode$optional,
									'state_licenses',
									$elm$json$Json$Encode$list($author$project$Components$ProviderCredentials$encodeLicense),
									$elm$core$List$isEmpty(fields.qm) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(fields.qm))
								])))),
					_Utils_Tuple2(
					'invite',
					$elm$json$Json$Encode$bool(true))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$PracticeUser$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$TeamMember$teamMembersPath)));
	});
var $author$project$Api$Provider$PracticeOnboarding$PrescriberType$toParam = function (prescriberType) {
	switch (prescriberType) {
		case 0:
			return 'Provider';
		case 1:
			return 'POBNoReview';
		case 2:
			return 'POBSomeReview';
		default:
			return 'StaffUser';
	}
};
var $author$project$Components$TeamForm$teamMemberFormFields = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.SD);
	var phone = A2(
		$elm$core$Maybe$andThen,
		$author$project$Utils$String$toMaybe,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.IO;
			},
			A2(
				$elm$core$Maybe$map,
				$author$project$Utils$Phone$toRecord,
				$elm$core$List$head(
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						$author$project$Components$PhoneInput$getPhones(fields.Zw))))));
	var prescriberTypeValue = A2($elm$core$Maybe$map, $author$project$Api$Provider$PracticeOnboarding$PrescriberType$toParam, fields._g);
	var credentials = $author$project$Components$ProviderCredentials$toApiFields(model.bW);
	return {PF: fields.PF, nb: credentials.nb, Hp: credentials.Hp, Rj: fields.Rj, agR: fields.agR, Sv: fields.Sv, VH: fields.VH, X0: credentials.X0, Zx: phone, _g: prescriberTypeValue, _G: fields._G, qm: credentials.qm};
};
var $author$project$Pages$Admin$Team$New$createTeamMember = function (model) {
	var fields = $author$project$Components$TeamForm$teamMemberFormFields(model.SD);
	return A3(
		$author$project$Api$Provider$TeamMember$createWithClinicalData,
		model.Gv,
		{
			aeO: model.aeO,
			PF: fields.PF,
			nb: fields.nb,
			Hp: fields.Hp,
			Rj: fields.Rj,
			agR: A2($elm$core$Maybe$withDefault, 0, fields.agR),
			Sv: fields.Sv,
			VH: fields.VH,
			X0: fields.X0,
			Zx: fields.Zx,
			_g: fields._g,
			_G: fields._G,
			qm: fields.qm
		},
		$author$project$Pages$Admin$Team$New$Created);
};
var $author$project$Pages$Admin$Team$New$ProductPricingReceived = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$PracticePricing$Product$ProductPricing = $elm$core$Basics$identity;
var $author$project$Api$Provider$PracticePricing$Product$Record = F2(
	function (requiresPayment, priceInCents) {
		return {Dw: priceInCents, $K: requiresPayment};
	});
var $author$project$Api$Provider$PracticePricing$Product$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'price_in_cents',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'requires_payment',
		$elm$json$Json$Decode$bool,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticePricing$Product$Record)));
var $author$project$Api$Provider$PracticePricing$Product$decoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $author$project$Api$Provider$PracticePricing$Product$recordDecoder);
var $author$project$Api$Provider$PracticePricing$Product$productsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['practice', 'pricing', 'products']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$PracticePricing$Product$productPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$PracticePricing$Product$productsPath);
};
var $author$project$Api$Provider$PracticePricing$Product$retrieve = F3(
	function (apiClient, productId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$PracticePricing$Product$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$PracticePricing$Product$productPath(productId)));
	});
var $author$project$Pages$Admin$Team$New$fetchProductPricing = function (model) {
	return A3($author$project$Api$Provider$PracticePricing$Product$retrieve, model.Gv, 'clinician', $author$project$Pages$Admin$Team$New$ProductPricingReceived);
};
var $author$project$Api$Provider$PracticePricing$Product$priceInCents = function (_v0) {
	var record = _v0;
	return record.Dw;
};
var $author$project$Api$Provider$PracticePricing$Product$requiresPayment = function (_v0) {
	var record = _v0;
	return record.$K;
};
var $author$project$Pages$Admin$Team$New$shouldFetchProductPricing = function (teamFormModel) {
	var fields = $author$project$Components$TeamForm$teamMemberFormFields(teamFormModel);
	var _v0 = _Utils_Tuple2(fields._G, fields._g);
	if ((((!_v0.a.$) && (!_v0.a.a)) && (!_v0.b.$)) && (_v0.b.a === 'Provider')) {
		var _v1 = _v0.a.a;
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$TeamForm$Phone = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$TeamForm$PhoneInputMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$PracticeOnboarding$PrescriberType$Provider = 0;
var $author$project$Api$Provider$PracticeOnboarding$PrescriberType$isProvider = function (prescriberType) {
	return !prescriberType;
};
var $author$project$Api$Provider$PracticeOnboarding$PrescriberType$provider = 0;
var $author$project$Api$Provider$PracticeOnboarding$PrescriberType$StaffUser = 3;
var $author$project$Api$Provider$PracticeOnboarding$PrescriberType$staff = 3;
var $author$project$Components$TeamForm$calculateDefaultPrescriberType = F2(
	function (currentPrescriberType, providerStatus) {
		if (providerStatus === 2) {
			return A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Maybe$Just($author$project$Api$Provider$PracticeOnboarding$PrescriberType$staff),
				A2(
					$elm$core$Maybe$map,
					function (prescriberType) {
						return $author$project$Api$Provider$PracticeOnboarding$PrescriberType$isProvider(prescriberType) ? $elm$core$Maybe$Just($author$project$Api$Provider$PracticeOnboarding$PrescriberType$staff) : currentPrescriberType;
					},
					currentPrescriberType));
		} else {
			return $author$project$Utils$Maybe$isNothing(currentPrescriberType) ? $elm$core$Maybe$Just($author$project$Api$Provider$PracticeOnboarding$PrescriberType$provider) : currentPrescriberType;
		}
	});
var $author$project$Api$Provider$PracticeOnboarding$PrescriberType$POBNoReview = 1;
var $author$project$Api$Provider$PracticeOnboarding$PrescriberType$POBSomeReview = 2;
var $author$project$Api$Provider$PracticeOnboarding$PrescriberType$fromParam = function (stepTypeParam) {
	switch (stepTypeParam) {
		case 'Provider':
			return 0;
		case 'POBNoReview':
			return 1;
		case 'POBSomeReview':
			return 2;
		default:
			return 3;
	}
};
var $author$project$Utils$EmrRole$Provider = 1;
var $author$project$Utils$EmrRole$Staff = 2;
var $author$project$Utils$EmrRole$fromString = function (str) {
	switch (str) {
		case 'admin':
			return $elm$core$Maybe$Just(0);
		case 'provider':
			return $elm$core$Maybe$Just(1);
		case 'employee':
			return $elm$core$Maybe$Just(2);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$TeamForm$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var firstName = field.a;
				return _Utils_update(
					fields,
					{Sv: firstName});
			case 1:
				var lastName = field.a;
				return _Utils_update(
					fields,
					{VH: lastName});
			case 2:
				var email = field.a;
				return _Utils_update(
					fields,
					{Rj: email});
			case 3:
				var phone = field.a;
				return _Utils_update(
					fields,
					{Zw: phone});
			case 4:
				var status = field.a;
				var prescriberType = A2($author$project$Components$TeamForm$calculateDefaultPrescriberType, fields._g, status);
				return _Utils_update(
					fields,
					{
						_g: prescriberType,
						_G: $elm$core$Maybe$Just(status)
					});
			case 5:
				var roleString = field.a;
				return _Utils_update(
					fields,
					{
						agR: $author$project$Utils$EmrRole$fromString(roleString)
					});
			case 6:
				var prescriberTypeValue = field.a;
				var prescriberType = $elm$core$String$isEmpty(prescriberTypeValue) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$author$project$Api$Provider$PracticeOnboarding$PrescriberType$fromParam(prescriberTypeValue));
				return _Utils_update(
					fields,
					{_g: prescriberType});
			default:
				var dob = field.a;
				return _Utils_update(
					fields,
					{
						PF: $elm$core$Maybe$Just(dob)
					});
		}
	});
var $author$project$Components$TeamForm$update = F3(
	function (msg, _v0, _v1) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$TeamForm$formFieldsUpdate, field, model.SD);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: newForm}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var subMsg = msg.a;
				var _v3 = $author$project$Utils$Form$fields(model.SD);
				var phone = _v3.Zw;
				var _v4 = A2($author$project$Components$PhoneInput$update, subMsg, phone);
				var phoneInput = _v4.a;
				var phoneCmd = _v4.b;
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$TeamForm$formFieldsUpdate,
					$author$project$Components$TeamForm$Phone(phoneInput),
					model.SD);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: newForm}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$TeamForm$PhoneInputMsg, phoneCmd),
					_List_Nil);
			case 2:
				var subMsg = msg.a;
				var _v5 = A2($author$project$Components$ProviderCredentials$update, subMsg, model.bW);
				var newCredentials = _v5.a;
				var cmd = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bW: newCredentials}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$TeamForm$CredentialsMsg, cmd),
					_List_Nil);
			default:
				var dropdownMsg = msg.a;
				var _v6 = A2($author$project$Ui$Dropdown$update, dropdownMsg, model.sa);
				var newDropdown = _v6.a;
				var dropdownCmd = _v6.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{sa: newDropdown}),
					dropdownCmd,
					_List_Nil);
		}
	});
var $author$project$Components$TeamForm$EmailValidation = 6;
var $author$project$Components$TeamForm$PhoneValidation = 7;
var $author$project$Components$TeamForm$DateOfBirthValidation = 1;
var $author$project$Components$TeamForm$datePattern = $agustinrhcp$elm_mask$Mask$fromString('##/##/####');
var $author$project$Components$TeamForm$validateDateOfBirth = F2(
	function (requiresDOB, _v0) {
		var dateOfBirth = _v0.PF;
		if (dateOfBirth.$ === 1) {
			return requiresDOB ? _List_fromArray(
				[
					_Utils_Tuple2(1, 'Please enter a valid date of birth.')
				]) : _List_Nil;
		} else {
			var dob = dateOfBirth.a;
			var _v2 = $author$project$Utils$Date$fromUsString(
				A2($agustinrhcp$elm_mask$Mask$mask, $author$project$Components$TeamForm$datePattern, dob));
			if (_v2.$ === 1) {
				return _List_fromArray(
					[
						_Utils_Tuple2(1, '')
					]);
			} else {
				return _List_Nil;
			}
		}
	});
var $author$project$Components$TeamForm$EmrRoleValidation = 3;
var $author$project$Components$TeamForm$validateEmrRole = F2(
	function (requiresEmrRole, fields) {
		return (requiresEmrRole && $author$project$Utils$Maybe$isNothing(fields.agR)) ? _List_fromArray(
			[
				_Utils_Tuple2(3, 'Please select an EMR role.')
			]) : _List_Nil;
	});
var $author$project$Components$TeamForm$FirstNameValidation = 4;
var $author$project$Components$TeamForm$validateFirstName = function (fields) {
	return $elm$core$String$isEmpty(fields.Sv) ? _List_fromArray(
		[
			_Utils_Tuple2(4, 'First name is required.')
		]) : _List_Nil;
};
var $author$project$Components$TeamForm$LastNameValidation = 5;
var $author$project$Components$TeamForm$validateLastName = function (fields) {
	return $elm$core$String$isEmpty(fields.VH) ? _List_fromArray(
		[
			_Utils_Tuple2(5, 'Last name is required.')
		]) : _List_Nil;
};
var $author$project$Components$TeamForm$PrescriberTypeValidation = 0;
var $author$project$Components$TeamForm$validatePrescriberType = F2(
	function (requiresPrescriberType, fields) {
		var _v0 = fields._g;
		if (!_v0.$) {
			return _List_Nil;
		} else {
			return requiresPrescriberType ? _List_fromArray(
				[
					_Utils_Tuple2(0, 'Please choose a prescriber type.')
				]) : _List_Nil;
		}
	});
var $author$project$Components$TeamForm$ProviderStatusValidation = 2;
var $author$project$Components$TeamForm$validateProviderStatus = function (fields) {
	var _v0 = fields._G;
	if (_v0.$ === 1) {
		return _List_fromArray(
			[
				_Utils_Tuple2(2, 'Please select a care provider status.')
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$TeamForm$formFieldsValidator = F2(
	function (usingClinicalEmr, isOnboarding) {
		var validatePhone = function (_v0) {
			var phone = _v0.Zw;
			return ($author$project$Components$PhoneInput$hasErrors(phone) && usingClinicalEmr) ? _List_fromArray(
				[
					_Utils_Tuple2(7, '')
				]) : _List_Nil;
		};
		return $rtfeldman$elm_validate$Validate$all(
			_List_fromArray(
				[
					$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$TeamForm$validateFirstName),
					$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$TeamForm$validateLastName),
					A3(
					$author$project$Utils$Validate$ifInvalidEmail,
					{aeT: false},
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.Rj;
						},
						$elm$core$Maybe$Just),
					_Utils_Tuple2(6, 'Please enter a valid email')),
					$rtfeldman$elm_validate$Validate$fromErrors(validatePhone),
					$rtfeldman$elm_validate$Validate$fromErrors(
					$author$project$Components$TeamForm$validateDateOfBirth(usingClinicalEmr)),
					$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$TeamForm$validateProviderStatus),
					$rtfeldman$elm_validate$Validate$fromErrors(
					$author$project$Components$TeamForm$validatePrescriberType(usingClinicalEmr)),
					$rtfeldman$elm_validate$Validate$fromErrors(
					$author$project$Components$TeamForm$validateEmrRole(usingClinicalEmr && (!isOnboarding)))
				]));
	});
var $author$project$Components$TeamForm$showCredentials = F2(
	function (fields, usingClinicalEmr) {
		return usingClinicalEmr && (!_Utils_eq(fields._g, $elm$core$Maybe$Nothing));
	});
var $author$project$Components$TeamForm$showDea = function (fields) {
	return _Utils_eq(
		fields._g,
		$elm$core$Maybe$Just(0));
};
var $author$project$Components$TeamForm$validate = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.SD);
	var form_ = A2(
		$author$project$Utils$Form$set,
		_Utils_update(
			fields,
			{
				Zw: $author$project$Components$PhoneInput$validate(fields.Zw)
			}),
		model.SD);
	var formResult = A2(
		$author$project$Utils$Form$validate,
		A2($author$project$Components$TeamForm$formFieldsValidator, model.fr, model.bb),
		form_);
	var credentialsResult = A2($author$project$Components$TeamForm$showCredentials, fields, model.fr) ? A2(
		$author$project$Components$ProviderCredentials$validate,
		{
			akP: false,
			abl: $author$project$Components$TeamForm$showDea(fields)
		},
		model.bW) : $elm$core$Result$Ok(model.bW);
	var _v1 = _Utils_Tuple2(formResult, credentialsResult);
	if (!_v1.a.$) {
		if (!_v1.b.$) {
			var _v2 = _v1.a.a;
			var validatedForm = _v2.a;
			var validFormFields = _v2.b;
			var validCredentials = _v1.b.a;
			return $elm$core$Result$Ok(
				_Utils_Tuple2(
					_Utils_update(
						model,
						{bW: validCredentials, SD: validatedForm}),
					validFormFields));
		} else {
			var _v3 = _v1.a.a;
			var validatedForm = _v3.a;
			var invalidCredentials = _v1.b.a;
			return $elm$core$Result$Err(
				_Utils_update(
					model,
					{bW: invalidCredentials, SD: validatedForm}));
		}
	} else {
		if (!_v1.b.$) {
			var invalidForm = _v1.a.a;
			var validCredentials = _v1.b.a;
			return $elm$core$Result$Err(
				_Utils_update(
					model,
					{bW: validCredentials, SD: invalidForm}));
		} else {
			var invalidForm = _v1.a.a;
			var invalidCredentials = _v1.b.a;
			return $elm$core$Result$Err(
				_Utils_update(
					model,
					{bW: invalidCredentials, SD: invalidForm}));
		}
	}
};
var $author$project$Pages$Admin$Team$New$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A3($author$project$Components$TeamForm$update, subMsg, model.SD, model.Gv);
				var teamFormModel = _v1.a;
				var teamFormCmd = _v1.b;
				var outMsgs = _v1.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: teamFormModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Team$New$TeamFormMsg, teamFormCmd),
					outMsgs);
			case 1:
				var _v2 = $author$project$Components$TeamForm$validate(model.SD);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var validatedForm = _v3.a;
					return $author$project$Pages$Admin$Team$New$shouldFetchProductPricing(validatedForm) ? _Utils_Tuple3(
						_Utils_update(
							model,
							{SD: validatedForm}),
						$author$project$Pages$Admin$Team$New$fetchProductPricing(model),
						_List_Nil) : _Utils_Tuple3(
						_Utils_update(
							model,
							{SD: validatedForm, k9: $author$project$Api$Data$Loading}),
						$author$project$Pages$Admin$Team$New$createTeamMember(
							_Utils_update(
								model,
								{SD: validatedForm})),
						_List_Nil);
				} else {
					var erroredForm = _v2.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{SD: erroredForm}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 2:
				var _v4 = $author$project$Components$TeamForm$validate(model.SD);
				if (!_v4.$) {
					var _v5 = _v4.a;
					var validatedForm = _v5.a;
					return model.aeO ? _Utils_Tuple3(
						_Utils_update(
							model,
							{SD: validatedForm, k9: $author$project$Api$Data$Loading}),
						$author$project$Pages$Admin$Team$New$createTeamMember(
							_Utils_update(
								model,
								{SD: validatedForm})),
						_List_Nil) : _Utils_Tuple3(
						_Utils_update(
							model,
							{SD: validatedForm, k9: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					var erroredForm = _v4.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{SD: erroredForm, k9: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: response}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Team member created successfully')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 4:
				var value = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aeO: value}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var pricing = response.a;
					if ($author$project$Api$Provider$PracticePricing$Product$requiresPayment(pricing)) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									pj: $author$project$Api$Provider$PracticePricing$Product$priceInCents(pricing),
									pr: response,
									p8: true
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						var _v8 = $author$project$Components$TeamForm$validate(model.SD);
						if (!_v8.$) {
							var _v9 = _v8.a;
							var validatedForm = _v9.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										SD: validatedForm,
										pj: $author$project$Api$Provider$PracticePricing$Product$priceInCents(pricing),
										pr: response,
										k9: $author$project$Api$Data$Loading,
										p8: false
									}),
								$author$project$Pages$Admin$Team$New$createTeamMember(
									_Utils_update(
										model,
										{SD: validatedForm})),
								_List_Nil);
						} else {
							var erroredForm = _v8.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{SD: erroredForm, pr: response}),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
						}
					}
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{pr: response}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 1, 'New team members cannot be added at this time. Please reach out to our Customer Success team to learn more.')
							]));
				}
		}
	});
var $author$project$Pages$Admin$Team$New$CreateTeamMember = {$: 2};
var $author$project$Pages$Admin$Team$New$FormSubmitted = {$: 1};
var $author$project$Components$TeamForm$Email = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$TeamForm$FirstName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$TeamForm$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$TeamForm$LastName = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$TeamForm$FullTimeProvider = 0;
var $author$project$Components$TeamForm$NonProvider = 2;
var $author$project$Components$TeamForm$PartTimeProvider = 1;
var $author$project$Components$TeamForm$ProviderStatus = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Typography$m0 = $author$project$Ui$Typography$Attr(
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('m-0')
		]));
var $author$project$Components$TeamForm$viewCareProviderStatusSelection = F2(
	function (form, fields) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(2),
					$author$project$Ui$Form$Group$required(true),
					$author$project$Ui$Form$Group$label('Care Provider Status'),
					$author$project$Ui$Form$Group$invalid(
					A2($author$project$Utils$Form$hasValidationErrors, 2, form))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(4)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Radio$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Radio$value(
											_Utils_eq(
												fields._G,
												$elm$core$Maybe$Just(0))),
											$author$project$Ui$Form$Radio$inline,
											$author$project$Ui$Form$Radio$onCheck(
											function (_v0) {
												return $author$project$Components$TeamForm$FormUpdated(
													$author$project$Components$TeamForm$ProviderStatus(0));
											})
										]),
									_List_fromArray(
										[
											A2($author$project$Ui$Typography$text, _List_Nil, 'Full-Time Provider'),
											A2(
											$author$project$Ui$Typography$p,
											_List_fromArray(
												[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted, $author$project$Ui$Typography$m0]),
											_List_fromArray(
												[
													$elm$html$Html$text('Sees patients 3 or more days a week')
												]))
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(4)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Radio$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Radio$value(
											_Utils_eq(
												fields._G,
												$elm$core$Maybe$Just(1))),
											$author$project$Ui$Form$Radio$inline,
											$author$project$Ui$Form$Radio$onCheck(
											function (_v1) {
												return $author$project$Components$TeamForm$FormUpdated(
													$author$project$Components$TeamForm$ProviderStatus(1));
											})
										]),
									_List_fromArray(
										[
											A2($author$project$Ui$Typography$text, _List_Nil, 'Part-Time Provider'),
											A2(
											$author$project$Ui$Typography$p,
											_List_fromArray(
												[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted, $author$project$Ui$Typography$m0]),
											_List_fromArray(
												[
													$elm$html$Html$text('Sees patients less than 3 days a week')
												]))
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(3)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Radio$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Radio$value(
											_Utils_eq(
												fields._G,
												$elm$core$Maybe$Just(2))),
											$author$project$Ui$Form$Radio$inline,
											$author$project$Ui$Form$Radio$onCheck(
											function (_v2) {
												return $author$project$Components$TeamForm$FormUpdated(
													$author$project$Components$TeamForm$ProviderStatus(2));
											})
										]),
									_List_fromArray(
										[
											A2($author$project$Ui$Typography$text, _List_Nil, 'Not a Provider')
										]))
								]))
						])),
					A2($author$project$Utils$Form$hasValidationErrors, 2, form) ? A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$danger]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$String$join,
								' ',
								A2($author$project$Utils$Form$validationErrors, 2, form)))
						])) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$TeamForm$viewCredentialsSection = F3(
	function (usingClinicalEmr, fields, credentials) {
		return A2($author$project$Components$TeamForm$showCredentials, fields, usingClinicalEmr) ? A2(
			$elm$core$List$map,
			$elm$html$Html$map($author$project$Components$TeamForm$CredentialsMsg),
			A2(
				$author$project$Components$ProviderCredentials$viewFields,
				{
					akP: false,
					abl: $author$project$Components$TeamForm$showDea(fields)
				},
				credentials)) : _List_Nil;
	});
var $author$project$Components$TeamForm$DateOfBirth = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$TeamForm$viewDobField = F3(
	function (usingClinicalEmr, form, fields) {
		return usingClinicalEmr ? A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(2),
					$author$project$Ui$Form$Group$inputSpanSm(10),
					$author$project$Ui$Form$Group$label('Date of Birth'),
					$author$project$Ui$Form$Group$required(true)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$placeholder('mm/dd/yyyy'),
							A2(
							$author$project$Ui$Form$Input$maskedValue,
							$author$project$Components$TeamForm$datePattern,
							A2($elm$core$Maybe$withDefault, '', fields.PF)),
							A3(
							$author$project$Ui$Form$Input$onMaskedInput,
							$author$project$Components$TeamForm$datePattern,
							A2($elm$core$Maybe$withDefault, '', fields.PF),
							A2($elm$core$Basics$composeL, $author$project$Components$TeamForm$FormUpdated, $author$project$Components$TeamForm$DateOfBirth)),
							$author$project$Ui$Form$Input$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
							$author$project$Ui$Form$Input$errors(
							A2($author$project$Utils$Form$validationErrors, 1, form))
						])),
					A2(
					$author$project$Ui$Typography$text,
					_List_fromArray(
						[$author$project$Ui$Typography$helpText, $author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
					'Date of birth is required for access to prescription information.')
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Components$TeamForm$EmrRole = function (a) {
	return {$: 5, a: a};
};
var $author$project$Utils$EmrRole$all = _List_fromArray(
	[0, 1, 2]);
var $author$project$Utils$EmrRole$toDisplayString = function (role) {
	switch (role) {
		case 0:
			return 'Admin';
		case 1:
			return 'Provider';
		default:
			return 'Staff';
	}
};
var $author$project$Components$TeamForm$viewEmrRoleField = F4(
	function (isOnboarding, form, fields, emrRoleDropdown) {
		if (!isOnboarding) {
			var selectedRole = A2(
				$elm$core$Maybe$withDefault,
				'Select a role',
				A2($elm$core$Maybe$map, $author$project$Utils$EmrRole$toDisplayString, fields.agR));
			var roleOptions = A2(
				$elm$core$List$map,
				function (role) {
					return A2(
						$author$project$Ui$Dropdown$item,
						_List_fromArray(
							[
								$author$project$Ui$Dropdown$onSelect(
								$author$project$Components$TeamForm$FormUpdated(
									$author$project$Components$TeamForm$EmrRole(
										$author$project$Utils$EmrRole$toString(role))))
							]),
						$elm$html$Html$text(
							$author$project$Utils$EmrRole$toDisplayString(role)));
				},
				$author$project$Utils$EmrRole$all);
			return A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(2),
						$author$project$Ui$Form$Group$required(true),
						$author$project$Ui$Form$Group$label('EMR Role'),
						$author$project$Ui$Form$Group$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 3, form))
					]),
				_List_fromArray(
					[
						A4(
						$author$project$Ui$Dropdown$viewSelect,
						_List_fromArray(
							[
								$author$project$Ui$Dropdown$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 3, form))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(selectedRole)
							]),
						roleOptions,
						emrRoleDropdown),
						A2($author$project$Utils$Form$hasValidationErrors, 3, form) ? A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$danger]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$elm$core$String$join,
									' ',
									A2($author$project$Utils$Form$validationErrors, 3, form)))
							])) : $author$project$Utils$Html$empty
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$TeamForm$PrescriberTypeField = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$PracticeOnboarding$PrescriberType$list = _List_fromArray(
	[0, 1, 2, 3]);
var $author$project$Api$Provider$PracticeOnboarding$PrescriberType$toString = function (prescriberType) {
	switch (prescriberType) {
		case 0:
			return 'Prescriber';
		case 1:
			return 'Prescribe on Behalf of (No Review Required, Non-Controlled Substances Only)';
		case 2:
			return 'Prescribe on Behalf of (Review Required, Non-Controlled Substances Only)';
		default:
			return 'Staff';
	}
};
var $author$project$Components$TeamForm$prescriberTypeOptions = function (currentProviderStatus) {
	var options = A2(
		$elm$core$Maybe$withDefault,
		$author$project$Api$Provider$PracticeOnboarding$PrescriberType$list,
		A2(
			$elm$core$Maybe$map,
			function (providerStatus) {
				return (providerStatus === 2) ? A2(
					$elm$core$List$filter,
					function (prescriberType) {
						return !$author$project$Api$Provider$PracticeOnboarding$PrescriberType$isProvider(prescriberType);
					},
					$author$project$Api$Provider$PracticeOnboarding$PrescriberType$list) : $author$project$Api$Provider$PracticeOnboarding$PrescriberType$list;
			},
			currentProviderStatus));
	return A2(
		$elm$core$List$cons,
		A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(''),
			'Select a Prescriber Type'),
		A2(
			$elm$core$List$map,
			function (prescriberType) {
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$PracticeOnboarding$PrescriberType$toParam(prescriberType)),
					$author$project$Api$Provider$PracticeOnboarding$PrescriberType$toString(prescriberType));
			},
			options));
};
var $author$project$Components$TeamForm$viewPrescriberTypeField = F3(
	function (usingClinicalEmr, form, fields) {
		var providerStatusSelected = function () {
			var _v0 = fields._G;
			if (!_v0.$) {
				return true;
			} else {
				return false;
			}
		}();
		if (usingClinicalEmr && providerStatusSelected) {
			var prescriberTypeValue = A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Maybe$map, $author$project$Api$Provider$PracticeOnboarding$PrescriberType$toParam, fields._g));
			return A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(2),
						$author$project$Ui$Form$Group$required(usingClinicalEmr),
						$author$project$Ui$Form$Group$label('Prescriber Type')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Select$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Select$value(
								$elm$core$Maybe$Just(prescriberTypeValue)),
								$author$project$Ui$Form$Select$onChange(
								A2($elm$core$Basics$composeL, $author$project$Components$TeamForm$FormUpdated, $author$project$Components$TeamForm$PrescriberTypeField)),
								$author$project$Ui$Form$Select$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
								$author$project$Ui$Form$Select$errors(
								A2($author$project$Utils$Form$validationErrors, 0, form))
							]),
						$author$project$Components$TeamForm$prescriberTypeOptions(fields._G))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$TeamForm$viewForm = function (model) {
	var fields = $author$project$Utils$Form$fields(model.SD);
	var nameGroup = A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(2),
				$author$project$Ui$Form$Group$inputSpanSm(10),
				$author$project$Ui$Form$Group$required(true),
				$author$project$Ui$Form$Group$label('Name'),
				$author$project$Ui$Form$Group$invalid(
				A2($author$project$Utils$Form$hasValidationErrors, 4, model.SD) || A2($author$project$Utils$Form$hasValidationErrors, 5, model.SD))
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanSm(6)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$value(fields.Sv),
										$author$project$Ui$Form$Input$disabled(model.bb),
										$author$project$Ui$Form$Input$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 4, model.SD)),
										$author$project$Ui$Form$Input$onInput(
										function (newFirstName) {
											return $author$project$Components$TeamForm$FormUpdated(
												$author$project$Components$TeamForm$FirstName(newFirstName));
										}),
										$author$project$Ui$Form$Input$placeholder('First Name')
									])),
								A2($author$project$Utils$Form$hasValidationErrors, 4, model.SD) ? A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$danger]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2(
											$elm$core$String$join,
											' ',
											A2($author$project$Utils$Form$validationErrors, 4, model.SD)))
									])) : $author$project$Utils$Html$empty
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanSm(6)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$value(fields.VH),
										$author$project$Ui$Form$Input$disabled(model.bb),
										$author$project$Ui$Form$Input$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 5, model.SD)),
										$author$project$Ui$Form$Input$onInput(
										function (newLastName) {
											return $author$project$Components$TeamForm$FormUpdated(
												$author$project$Components$TeamForm$LastName(newLastName));
										}),
										$author$project$Ui$Form$Input$placeholder('Last Name')
									])),
								A2($author$project$Utils$Form$hasValidationErrors, 5, model.SD) ? A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$danger]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2(
											$elm$core$String$join,
											' ',
											A2($author$project$Utils$Form$validationErrors, 5, model.SD)))
									])) : $author$project$Utils$Html$empty
							]))
					]))
			]));
	var phoneGroup = A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(2),
				$author$project$Ui$Form$Group$inputSpanSm(10),
				$author$project$Ui$Form$Group$required(model.fr),
				$author$project$Ui$Form$Group$label('Phone'),
				$author$project$Ui$Form$Group$invalid(
				$author$project$Components$PhoneInput$hasErrors(fields.Zw))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$TeamForm$PhoneInputMsg,
				$author$project$Components$PhoneInput$view(fields.Zw))
			]));
	var emailGroup = A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(2),
				$author$project$Ui$Form$Group$inputSpanSm(10),
				$author$project$Ui$Form$Group$required(true),
				$author$project$Ui$Form$Group$label('Email'),
				$author$project$Ui$Form$Group$invalid(
				A2($author$project$Utils$Form$hasValidationErrors, 6, model.SD))
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$value(fields.Rj),
						$author$project$Ui$Form$Input$disabled(model.bb),
						$author$project$Ui$Form$Input$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 6, model.SD)),
						$author$project$Ui$Form$Input$onInput(
						function (newEmail) {
							return $author$project$Components$TeamForm$FormUpdated(
								$author$project$Components$TeamForm$Email(newEmail));
						})
					])),
				A2($author$project$Utils$Form$hasValidationErrors, 6, model.SD) ? A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$danger]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$elm$core$String$join,
							' ',
							A2($author$project$Utils$Form$validationErrors, 6, model.SD)))
					])) : $author$project$Utils$Html$empty
			]));
	var baseFields = _List_fromArray(
		[
			nameGroup,
			emailGroup,
			phoneGroup,
			A3($author$project$Components$TeamForm$viewDobField, model.fr, model.SD, fields),
			A2($author$project$Components$TeamForm$viewCareProviderStatusSelection, model.SD, fields),
			A4($author$project$Components$TeamForm$viewEmrRoleField, model.bb, model.SD, fields, model.sa),
			A3($author$project$Components$TeamForm$viewPrescriberTypeField, model.fr, model.SD, fields)
		]);
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_Utils_ap(
			baseFields,
			A3($author$project$Components$TeamForm$viewCredentialsSection, model.fr, fields, model.bW)));
};
var $author$project$Components$TeamForm$view = function (_v0) {
	var model = _v0;
	return $author$project$Components$TeamForm$viewForm(model);
};
var $author$project$Ui$Element$m0 = $author$project$Ui$Element$Margin('m-0');
var $author$project$Ui$Grid$m0 = $author$project$Ui$Grid$Element($author$project$Ui$Element$m0);
var $author$project$Ui$Element$mb8 = $author$project$Ui$Element$Margin('mb-8');
var $author$project$Pages$Admin$Team$New$AgreedToTerms = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$Team$New$viewAdditionalInfoFooter = A2(
	$author$project$Ui$Element$prose,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Typography$text,
			_List_fromArray(
				[$author$project$Ui$Typography$muted]),
			'Have any questions? '),
			A3(
			$author$project$Ui$Link$externalHref,
			'mailto:sales@hint.com',
			_List_fromArray(
				[$author$project$Ui$Link$targetBlank]),
			_List_fromArray(
				[
					$elm$html$Html$text('Contact our sales team')
				])),
			A2(
			$author$project$Ui$Typography$text,
			_List_fromArray(
				[$author$project$Ui$Typography$muted]),
			' or '),
			A3(
			$author$project$Ui$Link$externalHref,
			'https://www.hint.com/clinical/pricing',
			_List_fromArray(
				[$author$project$Ui$Link$targetBlank]),
			_List_fromArray(
				[
					$elm$html$Html$text('view our pricing information')
				])),
			A2(
			$author$project$Ui$Typography$text,
			_List_fromArray(
				[$author$project$Ui$Typography$muted]),
			' on our website.')
		]));
var $author$project$Pages$Admin$Team$New$viewConfirmationCheckbox = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Checkbox$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Checkbox$value(model.aeO),
						$author$project$Ui$Form$Checkbox$required(true),
						$author$project$Ui$Form$Checkbox$onCheck(
						function (value) {
							return $author$project$Pages$Admin$Team$New$AgreedToTerms(value);
						})
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$flexMd]),
						_List_fromArray(
							[
								$elm$html$Html$text('I agree to these changes, subject to the previously agreed upon terms of service.'),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$danger]),
								_List_fromArray(
									[
										$elm$html$Html$text('*')
									]))
							]))
					])),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mt2]),
				_List_fromArray(
					[$author$project$Pages$Admin$Team$New$viewAdditionalInfoFooter]))
			]));
};
var $author$project$Pages$Admin$Team$New$viewPricing = function (model) {
	var _v0 = $author$project$Components$TeamForm$validate(model.SD);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var validatedForm = _v1.a;
		var fields = $author$project$Components$TeamForm$teamMemberFormFields(validatedForm);
		var clinicianName = fields.Sv + (' ' + fields.VH);
		return A3(
			$author$project$Ui$Element$custom,
			'h-[80vh]',
			_List_fromArray(
				[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$flexCol]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(7)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$mb2, $author$project$Ui$Element$mt4]),
									_List_fromArray(
										[
											$author$project$Ui$Typography$headingSm(
											_List_fromArray(
												[
													$elm$html$Html$text('Add ' + clinicianName)
												]))
										])),
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$muted]),
									_List_fromArray(
										[
											$elm$html$Html$text('You are at the clinician limit for your current plan.')
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(5),
									$author$project$Ui$Grid$m0
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Alert$view,
									1,
									_List_fromArray(
										[
											$author$project$Ui$Alert$alignment($author$project$Ui$Alignment$textLeft)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$mt2]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Grid$row,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Grid$column,
															_List_fromArray(
																[
																	$author$project$Ui$Grid$spanSm(9)
																]),
															_List_fromArray(
																[
																	$author$project$Ui$Typography$headingSm(
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Additional Clinician')
																		]))
																])),
															A2(
															$author$project$Ui$Grid$column,
															_List_fromArray(
																[
																	$author$project$Ui$Grid$spanSm(3),
																	$author$project$Ui$Grid$justifyRight
																]),
															_List_fromArray(
																[
																	$author$project$Ui$Typography$headingSm(
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Utils$Currency$fromIntNoDecimals(model.pj) + '/mo')
																		]))
																]))
														])),
													A2($elm$html$Html$br, _List_Nil, _List_Nil),
													A2(
													$author$project$Ui$Grid$row,
													_List_fromArray(
														[$author$project$Ui$Grid$mb4]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Grid$column,
															_List_fromArray(
																[
																	$author$project$Ui$Grid$spanSm(9)
																]),
															_List_fromArray(
																[
																	A2(
																	$author$project$Ui$Element$view,
																	_List_fromArray(
																		[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$mb8]),
																	_List_fromArray(
																		[
																			A2(
																			$author$project$Ui$Typography$text,
																			_List_fromArray(
																				[$author$project$Ui$Typography$black]),
																			'Added to your next invoice'),
																			A2(
																			$author$project$Ui$Typography$text,
																			_List_fromArray(
																				[$author$project$Ui$Typography$black]),
																			'Due today')
																		]))
																])),
															A2(
															$author$project$Ui$Grid$column,
															_List_fromArray(
																[
																	$author$project$Ui$Grid$spanSm(3)
																]),
															_List_fromArray(
																[
																	A2(
																	$author$project$Ui$Element$view,
																	_List_fromArray(
																		[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$textRight, $author$project$Ui$Element$mb8]),
																	_List_fromArray(
																		[
																			A2(
																			$author$project$Ui$Typography$text,
																			_List_Nil,
																			$author$project$Utils$Currency$fromInt(model.pj)),
																			A2(
																			$author$project$Ui$Typography$text,
																			_List_Nil,
																			$author$project$Utils$Currency$fromInt(0))
																		]))
																]))
														]))
												]))
										]))
								]))
						])),
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(12)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$mt2]),
									_List_fromArray(
										[
											$author$project$Ui$HorizontalRule$view(_List_Nil)
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Pages$Admin$Team$New$viewConfirmationCheckbox(model)
								]))
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Admin$Team$New$view = function (model) {
	var loading = _Utils_eq(model.k9, $author$project$Api$Data$Loading);
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$autocomplete(false),
						$author$project$Ui$Form$noValidate(true)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Add Team Member')
											]))
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										model.p8 ? $author$project$Pages$Admin$Team$New$viewPricing(model) : A2(
										$elm$html$Html$map,
										$author$project$Pages$Admin$Team$New$TeamFormMsg,
										$author$project$Components$TeamForm$view(model.SD))
									])),
								A2(
								$author$project$Ui$Panel$footer,
								_List_fromArray(
									[$author$project$Ui$Element$justifyCenter]),
								_List_fromArray(
									[
										model.p8 ? A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$mt4]),
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Button$view,
												{mm: 'Agree and save'},
												_List_fromArray(
													[
														$author$project$Ui$Button$primary,
														$author$project$Ui$Button$onClick($author$project$Pages$Admin$Team$New$CreateTeamMember),
														$author$project$Ui$Button$loading(loading),
														$author$project$Ui$Button$disabled(!model.aeO)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Agree & Save')
													]))
											])) : A3(
										$author$project$Ui$Button$view,
										{mm: 'Save new team member'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$loading(loading),
												$author$project$Ui$Button$onClick($author$project$Pages$Admin$Team$New$FormSubmitted)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Save')
											]))
									]))
							]))
					]))
			]),
		ac9: 'New Team Member'
	};
};
var $author$project$Pages$Admin$Team$New$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Team$New$init, aiq: $author$project$Pages$Admin$Team$New$load, k8: $author$project$Pages$Admin$Team$New$save, alO: $author$project$Pages$Admin$Team$New$subscriptions, adT: $author$project$Pages$Admin$Team$New$update, amo: $author$project$Pages$Admin$Team$New$view});
var $author$project$Pages$Admin$Waitlist$PractitionerResourceFilterMsg = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$Admin$Waitlist$GotEntries = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$WaitlistEntry$All$WaitlistEntry = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$WaitlistEntry$Shared$Record = function (id) {
	return function (firstName) {
		return function (lastName) {
			return function (email) {
				return function (phone) {
					return function (enrollCount) {
						return function (position) {
							return function (status) {
								return function (source) {
									return function (invitedAt) {
										return function (enrolledAt) {
											return function (patient) {
												return {Rj: email, RA: enrollCount, agW: enrolledAt, Sv: firstName, ahP: id, ah8: invitedAt, VH: lastName, YY: patient, Zw: phone, ZP: position, JQ: source, alH: status};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$WaitlistEntry$Shared$WaitlistEntry = $elm$core$Basics$identity;
var $author$project$Api$Provider$WaitlistEntry$Shared$decoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'patient',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Min$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'enrolled_at',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'invited_at',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'source',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'status',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'position',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'enroll_count',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'phone',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'email',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'last_name',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'first_name',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'id',
													$elm$json$Json$Decode$string,
													$elm$json$Json$Decode$succeed($author$project$Api$Provider$WaitlistEntry$Shared$Record))))))))))))));
var $author$project$Api$Provider$WaitlistEntry$All$Record = function (practitioner) {
	return {aka: practitioner};
};
var $author$project$Api$Provider$WaitlistEntry$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'practitioner',
	$author$project$Api$Provider$Practitioner$Min$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$WaitlistEntry$All$Record));
var $author$project$Api$Provider$WaitlistEntry$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$WaitlistEntry$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$WaitlistEntry$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$WaitlistEntry$All$WaitlistEntry)));
var $author$project$Api$Provider$WaitlistEntry$listDefaults = {
	ajJ: $author$project$Api$Pagination$init,
	aka: $elm$core$Maybe$Nothing,
	akl: $elm$core$Maybe$Nothing,
	alA: A3($author$project$Api$Sort$withDefault, 'position', 0, $author$project$Api$Sort$init),
	alH: $elm$core$Maybe$Nothing
};
var $author$project$Api$Provider$WaitlistEntry$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$WaitlistEntry$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.akl;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.aka;
				if (!_v1.$) {
					var id_ = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'practitioner', id_)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.alH;
				if (!_v2.$) {
					var list_ = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$list, 'status', list_)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$Provider$WaitlistEntry$waitlistEntriesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['waitlist_entries']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$WaitlistEntry$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$WaitlistEntry$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$WaitlistEntry$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$WaitlistEntry$waitlistEntriesPath)));
	});
var $author$project$Pages$Admin$Waitlist$statusFilterToParam = function (filter) {
	switch (filter) {
		case 'active':
			return $elm$core$Maybe$Just(
				_List_fromArray(
					['waiting', 'invited']));
		case 'all':
			return $elm$core$Maybe$Nothing;
		default:
			var other = filter;
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[other]));
	}
};
var $author$project$Pages$Admin$Waitlist$fetchEntries = function (model) {
	return A3(
		$author$project$Api$Provider$WaitlistEntry$list,
		model.Gv,
		function (d) {
			return _Utils_update(
				d,
				{
					ajJ: model.ajJ,
					aka: model.Z2,
					akl: model.akl,
					alA: model.alA,
					alH: $author$project$Pages$Admin$Waitlist$statusFilterToParam(model.hN)
				});
		},
		$author$project$Pages$Admin$Waitlist$GotEntries);
};
var $author$project$Pages$Admin$Waitlist$GotPractitioner = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Admin$Waitlist$fetchPractitioner = function (model) {
	var _v0 = model.Z2;
	if (!_v0.$) {
		var id = _v0.a;
		return A3(
			$author$project$Api$Provider$Practitioner$list,
			model.Gv,
			function (d) {
				return _Utils_update(
					d,
					{
						ahP: $elm$core$Maybe$Just(id)
					});
			},
			$author$project$Pages$Admin$Waitlist$GotPractitioner);
	} else {
		return $elm$core$Platform$Cmd$none;
	}
};
var $author$project$Pages$Admin$Waitlist$init = F4(
	function (_v0, _v1, shared, _v2) {
		var query = _v2.DE;
		var practitionerId = A2($elm$core$Dict$get, 'practitioner', query);
		var practitionerFromUrl = !_Utils_eq(practitionerId, $elm$core$Maybe$Nothing);
		var _v3 = A3(
			$author$project$Components$ResourceFilter$Practitioner$init,
			shared.Gv,
			$elm$core$Basics$identity,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'All Providers'});
			});
		var practitionerResourceFilter = _v3.a;
		var practitionerResourceFilterCmd = _v3.b;
		var model = {
			Gv: shared.Gv,
			ed: $elm$core$Set$empty,
			jd: $elm$core$Maybe$Nothing,
			eu: $author$project$Api$Data$Loading,
			y: $elm$core$Maybe$Nothing,
			eA: $elm$core$Set$empty,
			ajJ: $author$project$Api$Pagination$init,
			t$: practitionerFromUrl,
			Z2: practitionerId,
			t0: '',
			hk: practitionerResourceFilter,
			akl: $elm$core$Maybe$Nothing,
			up: $author$project$Ui$SearchInput$init($elm$core$Maybe$Nothing),
			alA: A3($author$project$Api$Sort$withDefault, 'position', 0, $author$project$Api$Sort$init),
			hN: 'active'
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Pages$Admin$Waitlist$fetchEntries(model),
						$author$project$Pages$Admin$Waitlist$fetchPractitioner(model),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Waitlist$PractitionerResourceFilterMsg, practitionerResourceFilterCmd)
					])));
	});
var $author$project$Pages$Admin$Waitlist$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Waitlist$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Waitlist$CancelEdit = {$: 2};
var $author$project$Pages$Admin$Waitlist$DeleteConfirmClosed = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$Pages$Admin$Waitlist$PhoneMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Api$Provider$WaitlistEntry$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$WaitlistEntry$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$WaitlistEntry$Shared$id(shared);
};
var $author$project$Pages$Admin$Waitlist$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Admin$Waitlist$CancelEdit)),
					model.y)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$Waitlist$DeleteConfirmClosed),
						$author$project$Api$Provider$WaitlistEntry$All$id),
					model.jd)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					function (_v0) {
						var form = _v0.b;
						return A2(
							$elm$core$Platform$Sub$map,
							$author$project$Pages$Admin$Waitlist$PhoneMsg,
							$author$project$Components$PhoneInput$subscriptions(
								$author$project$Utils$Form$fields(form).Zw));
					},
					model.y)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$Waitlist$PractitionerResourceFilterMsg,
				$author$project$Components$ResourceFilter$Practitioner$subscriptions(model.hk))
			]));
};
var $author$project$Pages$Admin$Waitlist$EntryDeleted = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Pages$Admin$Waitlist$EntryInvited = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Pages$Admin$Waitlist$SearchInputMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Api$Provider$WaitlistEntry$waitlistEntryPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$WaitlistEntry$waitlistEntriesPath);
};
var $author$project$Api$Provider$WaitlistEntry$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$WaitlistEntry$waitlistEntryPath(id_)));
	});
var $author$project$Api$Provider$WaitlistEntry$Shared$email = function (_v0) {
	var record = _v0;
	return record.Rj;
};
var $author$project$Api$Provider$WaitlistEntry$All$email = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$WaitlistEntry$Shared$email(shared);
};
var $author$project$Api$Provider$WaitlistEntry$Shared$enrollCount = function (_v0) {
	var record = _v0;
	return record.RA;
};
var $author$project$Api$Provider$WaitlistEntry$All$enrollCount = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$WaitlistEntry$Shared$enrollCount(shared);
};
var $author$project$Api$Provider$WaitlistEntry$Shared$firstName = function (_v0) {
	var record = _v0;
	return record.Sv;
};
var $author$project$Api$Provider$WaitlistEntry$All$firstName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$WaitlistEntry$Shared$firstName(shared);
};
var $author$project$Api$Provider$WaitlistEntry$Shared$lastName = function (_v0) {
	var record = _v0;
	return record.VH;
};
var $author$project$Api$Provider$WaitlistEntry$All$lastName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$WaitlistEntry$Shared$lastName(shared);
};
var $author$project$Api$Provider$WaitlistEntry$Shared$phone = function (_v0) {
	var record = _v0;
	return record.Zw;
};
var $author$project$Api$Provider$WaitlistEntry$All$phone = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$WaitlistEntry$Shared$phone(shared);
};
var $author$project$Pages$Admin$Waitlist$formFieldsFromEntry = function (entry) {
	var phones = function () {
		var _v0 = $author$project$Api$Provider$WaitlistEntry$All$phone(entry);
		if (!_v0.$) {
			var phoneNumber = _v0.a;
			return _List_fromArray(
				[
					A3($author$project$Components$PhoneInput$initPhone, $author$project$Api$Common$Phone$Shared$Mobile, 0, phoneNumber)
				]);
		} else {
			return _List_Nil;
		}
	}();
	return {
		Rj: $author$project$Api$Provider$WaitlistEntry$All$email(entry),
		RA: $author$project$Api$Provider$WaitlistEntry$All$enrollCount(entry),
		Sv: $author$project$Api$Provider$WaitlistEntry$All$firstName(entry),
		VH: $author$project$Api$Provider$WaitlistEntry$All$lastName(entry),
		Zw: A3(
			$author$project$Components$PhoneInput$init,
			'waitlist-phone',
			phones,
			function (d) {
				return _Utils_update(
					d,
					{Gh: true});
			})
	};
};
var $author$project$Pages$Admin$Waitlist$formFieldsInit = {
	Rj: $elm$core$Maybe$Nothing,
	RA: 1,
	Sv: '',
	VH: '',
	Zw: A3(
		$author$project$Components$PhoneInput$init,
		'waitlist-phone',
		_List_Nil,
		function (d) {
			return _Utils_update(
				d,
				{Gh: true});
		})
};
var $author$project$Pages$Admin$Waitlist$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{Sv: string});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{VH: string});
			case 2:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Rj: $author$project$Utils$String$toMaybe(string)
					});
			default:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						RA: A2(
							$elm$core$Maybe$withDefault,
							1,
							$elm$core$String$toInt(string))
					});
		}
	});
var $author$project$Pages$Admin$Waitlist$FirstNameValidation = 0;
var $author$project$Pages$Admin$Waitlist$LastNameValidation = 1;
var $author$project$Pages$Admin$Waitlist$ContactValidation = 2;
var $author$project$Pages$Admin$Waitlist$validateContact = function (fields) {
	var hasPhone = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			$elm$core$List$any(
				function (p) {
					return !$elm$core$String$isEmpty(p.IO);
				}),
			$author$project$Components$PhoneInput$getPhones(fields.Zw)));
	return (_Utils_eq(fields.Rj, $elm$core$Maybe$Nothing) && (!hasPhone)) ? _List_fromArray(
		[
			_Utils_Tuple2(2, 'Please provide at least an email or phone number.')
		]) : _List_Nil;
};
var $author$project$Pages$Admin$Waitlist$PhoneValidation = 3;
var $author$project$Pages$Admin$Waitlist$validatePhone = function (_v0) {
	var phone = _v0.Zw;
	return $author$project$Components$PhoneInput$hasErrors(phone) ? _List_fromArray(
		[
			_Utils_Tuple2(3, '')
		]) : _List_Nil;
};
var $author$project$Pages$Admin$Waitlist$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.Sv;
			},
			_Utils_Tuple2(0, 'Please enter a first name.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.VH;
			},
			_Utils_Tuple2(1, 'Please enter a last name.')),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Admin$Waitlist$validateContact),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Admin$Waitlist$validatePhone)
		]));
var $author$project$Api$Provider$WaitlistEntry$One$WaitlistEntry = $elm$core$Basics$identity;
var $author$project$Api$Provider$WaitlistEntry$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$WaitlistEntry$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$WaitlistEntry$invite = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$WaitlistEntry$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$elm$json$Json$Encode$object(_List_Nil),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['invite']),
						$author$project$Api$Provider$WaitlistEntry$waitlistEntryPath(id_)))));
	});
var $author$project$Pages$Admin$Waitlist$EntryCreated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Admin$Waitlist$EntryUpdated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$WaitlistEntry$create = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'waitlist_entry',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'practitioner_id',
								$elm$json$Json$Encode$string(fields.Z2)),
								_Utils_Tuple2(
								'first_name',
								$elm$json$Json$Encode$string(fields.Sv)),
								_Utils_Tuple2(
								'last_name',
								$elm$json$Json$Encode$string(fields.VH)),
								_Utils_Tuple2(
								'email',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Rj)),
								_Utils_Tuple2(
								'phone',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Zw)),
								_Utils_Tuple2(
								'enroll_count',
								$elm$json$Json$Encode$int(fields.RA))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$WaitlistEntry$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$WaitlistEntry$waitlistEntriesPath)));
	});
var $author$project$Api$Provider$WaitlistEntry$update = F4(
	function (apiClient, id_, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'waitlist_entry',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'first_name',
								$elm$json$Json$Encode$string(fields.Sv)),
								_Utils_Tuple2(
								'last_name',
								$elm$json$Json$Encode$string(fields.VH)),
								_Utils_Tuple2(
								'email',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Rj)),
								_Utils_Tuple2(
								'phone',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Zw)),
								_Utils_Tuple2(
								'enroll_count',
								$elm$json$Json$Encode$int(fields.RA))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$WaitlistEntry$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$WaitlistEntry$waitlistEntryPath(id_))));
	});
var $author$project$Pages$Admin$Waitlist$saveEntry = F3(
	function (model, maybeId, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var phoneString = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.IO;
			},
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$List$head,
				$author$project$Components$PhoneInput$getPhones(fields.Zw)));
		if (!maybeId.$) {
			var id = maybeId.a;
			return A4(
				$author$project$Api$Provider$WaitlistEntry$update,
				model.Gv,
				id,
				{Rj: fields.Rj, RA: fields.RA, Sv: fields.Sv, VH: fields.VH, Zw: phoneString},
				$author$project$Pages$Admin$Waitlist$EntryUpdated);
		} else {
			var _v1 = model.Z2;
			if (!_v1.$) {
				var practitionerId = _v1.a;
				return A3(
					$author$project$Api$Provider$WaitlistEntry$create,
					model.Gv,
					{Rj: fields.Rj, RA: fields.RA, Sv: fields.Sv, VH: fields.VH, Zw: phoneString, Z2: practitionerId},
					$author$project$Pages$Admin$Waitlist$EntryCreated);
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		}
	});
var $author$project$Pages$Admin$Waitlist$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							y: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init($author$project$Pages$Admin$Waitlist$formFieldsInit),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var field = msg.a;
				var _v1 = model.y;
				if (!_v1.$) {
					var _v2 = _v1.a;
					var id = _v2.a;
					var form = _v2.b;
					var entry = _v2.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$Waitlist$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								y: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, entry))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				var form = msg.a;
				var id = msg.b;
				var fields = $author$project$Utils$Form$fields(form);
				var validatedForm = A2(
					$author$project$Utils$Form$set,
					_Utils_update(
						fields,
						{
							Zw: $author$project$Components$PhoneInput$validate(fields.Zw)
						}),
					form);
				var _v3 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$Waitlist$formFieldsValidator, validatedForm);
				if (!_v3.$) {
					var _v4 = _v3.a;
					var newForm = _v4.a;
					var validFormFields = _v4.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								y: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, $author$project$Api$Data$Loading))
							}),
						A3($author$project$Pages$Admin$Waitlist$saveEntry, model, id, validFormFields),
						_List_Nil);
				} else {
					var newForm = _v3.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								y: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 1:
				var entry = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							y: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(
										$author$project$Api$Provider$WaitlistEntry$All$id(entry)),
									$author$project$Utils$Form$init(
										$author$project$Pages$Admin$Waitlist$formFieldsFromEntry(entry)),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{y: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{eu: response}),
					$elm$core$Platform$Cmd$none,
					function () {
						if (response.$ === 3) {
							return _List_Nil;
						} else {
							return $author$project$OutMsg$handleErrorResponse(response);
						}
					}());
			case 11:
				var response = msg.a;
				if (response.$ === 3) {
					var practitioners = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								t0: A2(
									$elm$core$Maybe$withDefault,
									'',
									A2(
										$elm$core$Maybe$map,
										$author$project$Api$Provider$Practitioner$All$name,
										$elm$core$List$head(practitioners)))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var response = msg.a;
				var _v7 = model.y;
				if (!_v7.$) {
					var _v8 = _v7.a;
					var id = _v8.a;
					var form = _v8.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{y: $elm$core$Maybe$Nothing}),
							$author$project$Pages$Admin$Waitlist$fetchEntries(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Added to waitlist')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									y: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var response = msg.a;
				var _v10 = model.y;
				if (!_v10.$) {
					var _v11 = _v10.a;
					var id = _v11.a;
					var form = _v11.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{y: $elm$core$Maybe$Nothing}),
							$author$project$Pages$Admin$Waitlist$fetchEntries(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Waitlist entry updated')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									y: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 8:
				var id = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ed: A2($elm$core$Set$remove, id, model.ed)
							}),
						$author$project$Pages$Admin$Waitlist$fetchEntries(model),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Removed from waitlist')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ed: A2($elm$core$Set$remove, id, model.ed)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 9:
				var entry = msg.a;
				var id = $author$project$Api$Provider$WaitlistEntry$All$id(entry);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							eA: A2($elm$core$Set$insert, id, model.eA)
						}),
					A3(
						$author$project$Api$Provider$WaitlistEntry$invite,
						model.Gv,
						id,
						$author$project$Pages$Admin$Waitlist$EntryInvited(id)),
					_List_Nil);
			case 10:
				var id = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								eA: A2($elm$core$Set$remove, id, model.eA)
							}),
						$author$project$Pages$Admin$Waitlist$fetchEntries(model),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Invitation sent')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								eA: A2($elm$core$Set$remove, id, model.eA)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 12:
				var phoneMsg = msg.a;
				var _v15 = model.y;
				if (!_v15.$) {
					var _v16 = _v15.a;
					var id = _v16.a;
					var form = _v16.b;
					var entry = _v16.c;
					var fields = $author$project$Utils$Form$fields(form);
					var _v17 = A2($author$project$Components$PhoneInput$update, phoneMsg, fields.Zw);
					var updatedPhone = _v17.a;
					var phoneCmd = _v17.b;
					var newForm = A2(
						$author$project$Utils$Form$set,
						_Utils_update(
							fields,
							{Zw: updatedPhone}),
						form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								y: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, entry))
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Waitlist$PhoneMsg, phoneCmd),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 15:
				var subMsg = msg.a;
				var _v18 = A2($author$project$Ui$SearchInput$update, subMsg, model.up);
				var searchInput = _v18.a;
				var searchInputCmd = _v18.b;
				var searchInputEvent = _v18.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.akl;
					}
				}();
				var _v19 = function () {
					if (_Utils_eq(q, model.akl)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								eu: $author$project$Api$Data$Loading,
								ajJ: $author$project$Api$Pagination$reset(model.ajJ),
								akl: q
							});
						return _Utils_Tuple2(
							qModel,
							$author$project$Pages$Admin$Waitlist$fetchEntries(qModel));
					}
				}();
				var newModel = _v19.a;
				var cmd = _v19.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{up: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Waitlist$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
			case 13:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						eu: $author$project$Api$Data$Loading,
						alA: A2($author$project$Api$Sort$update, columnId, model.alA)
					});
				return _Utils_Tuple3(
					newModel,
					$author$project$Pages$Admin$Waitlist$fetchEntries(newModel),
					_List_Nil);
			case 14:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					$author$project$Pages$Admin$Waitlist$fetchEntries(newModel),
					_List_Nil);
			case 16:
				var entry = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							jd: $elm$core$Maybe$Just(entry)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 17:
				var id = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ed: A2($elm$core$Set$insert, id, model.ed),
							jd: $elm$core$Maybe$Nothing
						}),
					A3(
						$author$project$Api$Provider$WaitlistEntry$delete,
						model.Gv,
						id,
						$author$project$Pages$Admin$Waitlist$EntryDeleted(id)),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{jd: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 18:
				var newFilter = msg.a;
				var newModel = _Utils_update(
					model,
					{eu: $author$project$Api$Data$Loading, ajJ: $author$project$Api$Pagination$init, hN: newFilter});
				return _Utils_Tuple3(
					newModel,
					$author$project$Pages$Admin$Waitlist$fetchEntries(newModel),
					_List_Nil);
			default:
				var subMsg = msg.a;
				var result = A3($author$project$Components$ResourceFilter$Practitioner$update, model.Gv, subMsg, model.hk);
				var practitionerId = function () {
					var _v22 = result.agZ;
					if (!_v22.$) {
						return $author$project$Components$ResourceFilter$Practitioner$value(result.aiO);
					} else {
						return model.Z2;
					}
				}();
				var newModel = _Utils_update(
					model,
					{Z2: practitionerId, hk: result.aiO});
				var _v21 = function () {
					if (_Utils_eq(practitionerId, model.Z2)) {
						return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
					} else {
						var resetModel = _Utils_update(
							newModel,
							{eu: $author$project$Api$Data$Loading, ajJ: $author$project$Api$Pagination$init});
						return _Utils_Tuple2(
							resetModel,
							$author$project$Pages$Admin$Waitlist$fetchEntries(resetModel));
					}
				}();
				var updatedModel = _v21.a;
				var cmd = _v21.b;
				return _Utils_Tuple3(
					updatedModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Waitlist$PractitionerResourceFilterMsg, result.GZ),
								cmd
							])),
					result.aR);
		}
	});
var $author$project$Pages$Admin$Waitlist$NewEntry = {$: 0};
var $author$project$Pages$Admin$Waitlist$PaginationMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Admin$Waitlist$StatusFilterChanged = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$Admin$Waitlist$Email = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$Waitlist$EnrollCount = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Admin$Waitlist$FirstName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$Waitlist$FormUpdated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$Waitlist$LastName = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$Waitlist$SaveEntry = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$Admin$Waitlist$viewEntryModal = F3(
	function (maybeId, entryData, form) {
		var modalConfig = {
			Tq: $elm$core$Maybe$Nothing,
			aih: 'Waitlist Entry',
			V8: _Utils_eq(entryData, $author$project$Api$Data$Loading),
			WG: maybeId,
			WH: $elm$core$Maybe$Nothing,
			Yd: $author$project$Pages$Admin$Waitlist$CancelEdit,
			Yf: $author$project$Pages$Admin$Waitlist$SaveEntry(form)
		};
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$required(true),
							$author$project$Ui$Form$Group$label('First Name')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(fields.Sv),
									$author$project$Ui$Form$Input$placeholder('Jane'),
									$author$project$Ui$Form$Input$autofocus(true),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Waitlist$FormUpdated, $author$project$Pages$Admin$Waitlist$FirstName)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form))
								])),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$required(true),
							$author$project$Ui$Form$Group$label('Last Name')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(fields.VH),
									$author$project$Ui$Form$Input$placeholder('Doe'),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Waitlist$FormUpdated, $author$project$Pages$Admin$Waitlist$LastName)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 1, form))
								])),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 1, form))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Email')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(
									A2($elm$core$Maybe$withDefault, '', fields.Rj)),
									$author$project$Ui$Form$Input$placeholder('jane@example.com'),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Waitlist$FormUpdated, $author$project$Pages$Admin$Waitlist$Email)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 2, form))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Phone')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Pages$Admin$Waitlist$PhoneMsg,
							$author$project$Components$PhoneInput$view(fields.Zw)),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 2, form))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('# to Enroll')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(
									$elm$core$String$fromInt(fields.RA)),
									$author$project$Ui$Form$Input$number,
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Waitlist$FormUpdated, $author$project$Pages$Admin$Waitlist$EnrollCount))
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$Waitlist$SortTable = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Admin$Waitlist$isFilteredToPractitioner = function (model) {
	return model.t$;
};
var $author$project$Pages$Admin$Waitlist$columns = function (model) {
	return $author$project$Pages$Admin$Waitlist$isFilteredToPractitioner(model) ? _List_fromArray(
		[
			A3($author$project$Api$Column$init, 'position', true, '#'),
			A3($author$project$Api$Column$init, 'first_name', true, 'Name'),
			A3($author$project$Api$Column$init, 'email', true, 'Email'),
			A3($author$project$Api$Column$init, 'phone', false, 'Phone'),
			A3($author$project$Api$Column$init, 'enroll_count', true, '# to Enroll'),
			A3($author$project$Api$Column$init, 'status', true, 'Status')
		]) : _List_fromArray(
		[
			A3($author$project$Api$Column$init, 'first_name', true, 'Name'),
			A3($author$project$Api$Column$init, 'practitioner', false, 'Provider'),
			A3($author$project$Api$Column$init, 'email', true, 'Email'),
			A3($author$project$Api$Column$init, 'phone', false, 'Phone'),
			A3($author$project$Api$Column$init, 'enroll_count', true, '# to Enroll'),
			A3($author$project$Api$Column$init, 'status', true, 'Status')
		]);
};
var $author$project$Pages$Admin$Waitlist$EditEntry = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$Waitlist$InviteEntry = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Admin$Waitlist$OpenDeleteConfirm = function (a) {
	return {$: 16, a: a};
};
var $author$project$Api$Provider$Patient$Min$id = function (_v0) {
	var min = _v0;
	return min.ahP;
};
var $author$project$Api$Provider$Practitioner$Min$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$WaitlistEntry$Shared$patient = function (_v0) {
	var record = _v0;
	return record.YY;
};
var $author$project$Api$Provider$WaitlistEntry$All$patient = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$WaitlistEntry$Shared$patient(shared);
};
var $author$project$Api$Provider$WaitlistEntry$Shared$position = function (_v0) {
	var record = _v0;
	return record.ZP;
};
var $author$project$Api$Provider$WaitlistEntry$All$position = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$WaitlistEntry$Shared$position(shared);
};
var $author$project$Api$Provider$WaitlistEntry$All$practitioner = function (_v0) {
	var record = _v0.b;
	return record.aka;
};
var $author$project$Api$Provider$WaitlistEntry$Shared$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Api$Provider$WaitlistEntry$All$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$WaitlistEntry$Shared$status(shared);
};
var $author$project$Pages$Admin$Waitlist$viewEntry = F2(
	function (model, entry) {
		var isWaiting = $author$project$Api$Provider$WaitlistEntry$All$status(entry) === 'waiting';
		var isActive = ($author$project$Api$Provider$WaitlistEntry$All$status(entry) === 'waiting') || ($author$project$Api$Provider$WaitlistEntry$All$status(entry) === 'invited');
		var id = $author$project$Api$Provider$WaitlistEntry$All$id(entry);
		var hasEmail = !_Utils_eq(
			$author$project$Api$Provider$WaitlistEntry$All$email(entry),
			$elm$core$Maybe$Nothing);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						$author$project$Pages$Admin$Waitlist$isFilteredToPractitioner(model) ? _List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											$elm$core$String$fromInt,
											$author$project$Api$Provider$WaitlistEntry$All$position(entry))))
								]))
						]) : _List_Nil,
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$WaitlistEntry$All$firstName(entry) + (' ' + $author$project$Api$Provider$WaitlistEntry$All$lastName(entry)))
								]))
						]),
						$author$project$Pages$Admin$Waitlist$isFilteredToPractitioner(model) ? _List_Nil : _List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$Practitioner$Min$name(
										$author$project$Api$Provider$WaitlistEntry$All$practitioner(entry)))
								]))
						]),
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'-',
										$author$project$Api$Provider$WaitlistEntry$All$email(entry)))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'-',
										A2(
											$elm$core$Maybe$map,
											$author$project$Formatters$Phone$format,
											$author$project$Api$Provider$WaitlistEntry$All$phone(entry))))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(
										$author$project$Api$Provider$WaitlistEntry$All$enrollCount(entry)))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[
											isWaiting ? $author$project$Ui$Typography$muted : $author$project$Ui$Typography$info
										]),
									$author$project$Api$Provider$WaitlistEntry$All$status(entry))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$gap2, $author$project$Ui$Element$justifyRight]),
									$elm$core$List$concat(
										_List_fromArray(
											[
												((isWaiting || ($author$project$Api$Provider$WaitlistEntry$All$status(entry) === 'invited')) && hasEmail) ? _List_fromArray(
												[
													A3(
													$author$project$Ui$Button$view,
													{mm: 'Invite'},
													_List_fromArray(
														[
															$author$project$Ui$Button$link,
															$author$project$Ui$Button$sm,
															$author$project$Ui$Button$loading(
															A2($elm$core$Set$member, id, model.eA)),
															$author$project$Ui$Button$onClick(
															$author$project$Pages$Admin$Waitlist$InviteEntry(entry))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Invite')
														]))
												]) : _List_Nil,
												isWaiting ? _List_fromArray(
												[
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Patients__Create,
													_List_fromArray(
														[
															$author$project$Ui$Link$routeParams(
															_List_fromArray(
																[
																	A2($elm$url$Url$Builder$string, 'waitlist_entry_id', id)
																]))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Enroll')
														]))
												]) : _List_Nil,
												function () {
												if (isActive) {
													var deleting = A2($elm$core$Set$member, id, model.ed);
													return _List_fromArray(
														[
															A3(
															$author$project$Ui$Button$view,
															{mm: 'Edit'},
															_List_fromArray(
																[
																	$author$project$Ui$Button$link,
																	$author$project$Ui$Button$sm,
																	$author$project$Ui$Button$disabled(deleting),
																	$author$project$Ui$Button$onClick(
																	$author$project$Pages$Admin$Waitlist$EditEntry(entry)),
																	$author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Edit')
																])),
															A3(
															$author$project$Ui$Button$view,
															{mm: 'Remove'},
															_List_fromArray(
																[
																	$author$project$Ui$Button$link,
																	$author$project$Ui$Button$sm,
																	$author$project$Ui$Button$loading(deleting),
																	$author$project$Ui$Button$onClick(
																	$author$project$Pages$Admin$Waitlist$OpenDeleteConfirm(entry)),
																	$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Remove')
																]))
														]);
												} else {
													var _v0 = $author$project$Api$Provider$WaitlistEntry$All$patient(entry);
													if (!_v0.$) {
														var patient = _v0.a;
														return _List_fromArray(
															[
																A3(
																$author$project$Ui$Link$route,
																$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
																	{
																		YZ: $author$project$Api$Provider$Patient$Min$id(patient)
																	}),
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('View Patient')
																	]))
															]);
													} else {
														return _List_Nil;
													}
												}
											}()
											])))
								]))
						])
					])));
	});
var $author$project$Pages$Admin$Waitlist$viewPanelBody = function (model) {
	var _v0 = function () {
		var _v1 = model.eu;
		if (_v1.$ === 3) {
			var entries_ = _v1.a;
			return _Utils_Tuple2(false, entries_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var entries = _v0.b;
	return A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$verticalCentered,
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('No one on the waitlist yet')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		_Utils_ap(
			A2(
				$elm$core$List$map,
				$author$project$Api$Column$view(
					A2($author$project$Api$Column$Sortable, model.alA, $author$project$Pages$Admin$Waitlist$SortTable)),
				$author$project$Pages$Admin$Waitlist$columns(model)),
			_List_fromArray(
				[
					A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
				])),
		A2(
			$elm$core$List$map,
			$author$project$Pages$Admin$Waitlist$viewEntry(model),
			entries),
		_List_Nil);
};
var $author$project$Pages$Admin$Waitlist$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				function () {
				var _v0 = model.y;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var id = _v1.a;
					var form = _v1.b;
					var entry = _v1.c;
					return A3($author$project$Pages$Admin$Waitlist$viewEntryModal, id, entry, form);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v2 = model.jd;
				if (!_v2.$) {
					var entry = _v2.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Admin$Waitlist$DeleteConfirmClosed(
							$author$project$Api$Provider$WaitlistEntry$All$id(entry)),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('remove'),
								$author$project$Components$HiConfirm$noun('waitlist entry'),
								$author$project$Components$HiConfirm$detail(
								$author$project$Api$Provider$WaitlistEntry$All$firstName(entry) + (' ' + $author$project$Api$Provider$WaitlistEntry$All$lastName(entry)))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_fromArray(
							[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$isEmpty(model.t0) ? 'Waitlist' : ('Waitlist — ' + model.t0))
									])),
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Add to waitlist'},
								_List_fromArray(
									[
										$author$project$Ui$Button$default,
										$author$project$Ui$Button$onClick($author$project$Pages$Admin$Waitlist$NewEntry),
										$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Add to Waitlist')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$row,
								_List_fromArray(
									[$author$project$Ui$Grid$mb2]),
								$elm$core$List$concat(
									_List_fromArray(
										[
											_List_fromArray(
											[
												A2(
												$author$project$Ui$Grid$column,
												_List_fromArray(
													[
														$author$project$Ui$Grid$span(
														model.t$ ? 10 : 8)
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$map,
														$author$project$Pages$Admin$Waitlist$SearchInputMsg,
														A2($author$project$Ui$SearchInput$view, _List_Nil, model.up))
													]))
											]),
											model.t$ ? _List_Nil : _List_fromArray(
											[
												A2(
												$author$project$Ui$Grid$column,
												_List_fromArray(
													[
														$author$project$Ui$Grid$span(2)
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$map,
														$author$project$Pages$Admin$Waitlist$PractitionerResourceFilterMsg,
														A2($author$project$Components$ResourceFilter$Practitioner$view, _List_Nil, model.hk))
													]))
											]),
											_List_fromArray(
											[
												A2(
												$author$project$Ui$Grid$column,
												_List_fromArray(
													[
														$author$project$Ui$Grid$span(2)
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Form$Select$view,
														_List_fromArray(
															[
																$author$project$Ui$Form$Select$value(
																$elm$core$Maybe$Just(model.hN)),
																$author$project$Ui$Form$Select$onChange($author$project$Pages$Admin$Waitlist$StatusFilterChanged)
															]),
														_List_fromArray(
															[
																A3(
																$author$project$Ui$Form$Select$option,
																_List_Nil,
																$elm$core$Maybe$Just('all'),
																'All'),
																A3(
																$author$project$Ui$Form$Select$option,
																_List_Nil,
																$elm$core$Maybe$Just('active'),
																'Active'),
																A3(
																$author$project$Ui$Form$Select$option,
																_List_Nil,
																$elm$core$Maybe$Just('waiting'),
																'Waiting'),
																A3(
																$author$project$Ui$Form$Select$option,
																_List_Nil,
																$elm$core$Maybe$Just('invited'),
																'Invited'),
																A3(
																$author$project$Ui$Form$Select$option,
																_List_Nil,
																$elm$core$Maybe$Just('enrolled'),
																'Enrolled'),
																A3(
																$author$project$Ui$Form$Select$option,
																_List_Nil,
																$elm$core$Maybe$Just('removed'),
																'Removed')
															]))
													]))
											])
										]))),
								$author$project$Pages$Admin$Waitlist$viewPanelBody(model)
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Admin$Waitlist$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(
											!$author$project$Api$Data$isSuccess(model.eu))
										]),
									model.ajJ))
							]))
					]))
			]),
		ac9: 'Admin | Waitlist'
	};
};
var $author$project$Pages$Admin$Waitlist$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Admin$Waitlist$init, aiq: $author$project$Pages$Admin$Waitlist$load, k8: $author$project$Pages$Admin$Waitlist$save, alO: $author$project$Pages$Admin$Waitlist$subscriptions, adT: $author$project$Pages$Admin$Waitlist$update, amo: $author$project$Pages$Admin$Waitlist$view});
var $author$project$Pages$AffiliateBills$Top$BillsListMsg = $elm$core$Basics$identity;
var $author$project$Components$Affiliates$BillsList$DateRangeInputMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Affiliates$BillsList$GotNetwork = function (a) {
	return {$: 1, a: a};
};
var $justinmimbs$date$Date$Month = 2;
var $author$project$Utils$DateWithDefault$toDate = F3(
	function (currentDate, monthOffset, dateWithDefault) {
		var startOfMonth = A3(
			$justinmimbs$date$Date$add,
			1,
			monthOffset,
			A2($justinmimbs$date$Date$floor, 2, currentDate));
		switch (dateWithDefault.$) {
			case 0:
				var date = dateWithDefault.a;
				return date;
			case 1:
				return startOfMonth;
			default:
				return A3(
					$justinmimbs$date$Date$add,
					3,
					-1,
					A3($justinmimbs$date$Date$add, 1, 1, startOfMonth));
		}
	});
var $author$project$Utils$DateWithDefault$toQuery = F3(
	function (currentDate, monthOffset, dateWithDefault) {
		return $author$project$Utils$Date$toQuery(
			A3($author$project$Utils$DateWithDefault$toDate, currentDate, monthOffset, dateWithDefault));
	});
var $author$project$Components$Affiliates$BillsList$buildUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('start'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.dd, 0)),
			model.JV),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('end'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.dd, 0)),
			model.HB)
		]);
	return A2(
		$elm$url$Url$Builder$relative,
		_List_fromArray(
			[
				$author$project$Spa$Generated$Route$toString(model.Is)
			]),
		A2(
			$elm$core$List$append,
			$author$project$Api$Pagination$toPageQuery(model.ajJ),
			A2(
				$elm$core$List$append,
				$author$project$Api$Sort$toQuery(model.alA),
				A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams))));
};
var $author$project$Components$DateRangeInput$defaultSettings = {
	ma: function (_v0) {
		return _List_Nil;
	},
	xj: false,
	y0: _List_fromArray(
		[
			$author$project$Ui$Grid$spanSm(4),
			$author$project$Ui$Grid$span(6)
		]),
	ahy: $elm$core$Maybe$Nothing,
	HT: false,
	HV: false,
	ID: 0,
	IE: -11,
	al5: $elm$core$Maybe$Nothing
};
var $author$project$Components$Affiliates$BillsList$dateRangeInputSettings = F2(
	function (start, end) {
		var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
		return _Utils_update(
			defaultSettings,
			{ahy: start, al5: end});
	});
var $author$project$Components$Affiliates$BillsList$GotAffiliateBills = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Affiliate$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Affiliate$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Affiliate$Shared$id(shared);
};
var $author$project$Api$Provider$AffiliateBill$affiliateBillsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['affiliate_bills']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$AffiliateBill$All$AffiliateBill = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Invoice$Shared$Invoice = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Invoice$Min$Invoice = $elm$core$Basics$identity;
var $author$project$Api$Provider$Invoice$Min$Record = F2(
	function (id, invoiceNumber) {
		return {ahP: id, Uu: invoiceNumber};
	});
var $author$project$Api$Provider$Invoice$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'invoice_number',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Invoice$Min$Record)));
var $author$project$Api$Provider$Invoice$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Invoice$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Invoice$Shared$Record = F7(
	function (invoiceDate, humanStatus, amountInCents, paidAt, paidInCents, dueInCents, dueDate) {
		return {LE: amountInCents, QX: dueDate, QY: dueInCents, TH: humanStatus, Uq: invoiceDate, YH: paidAt, YI: paidInCents};
	});
var $author$project$Api$Invoice$Status$BadDebt = {$: 4};
var $author$project$Api$Invoice$Status$Cancelled = {$: 5};
var $author$project$Api$Invoice$Status$Disputed = {$: 3};
var $author$project$Api$Invoice$Status$Draft = {$: 0};
var $author$project$Api$Invoice$Status$Issued = {$: 1};
var $author$project$Api$Invoice$Status$Other = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Invoice$Status$Overdue = {$: 6};
var $author$project$Api$Invoice$Status$Paid = {$: 2};
var $author$project$Api$Invoice$Status$Sent = {$: 8};
var $author$project$Api$Invoice$Status$Viewed = {$: 7};
var $author$project$Api$Invoice$Status$decode = A2(
	$elm$json$Json$Decode$map,
	function (string) {
		switch (string) {
			case 'draft':
				return $author$project$Api$Invoice$Status$Draft;
			case 'issued':
				return $author$project$Api$Invoice$Status$Issued;
			case 'paid':
				return $author$project$Api$Invoice$Status$Paid;
			case 'disputed':
				return $author$project$Api$Invoice$Status$Disputed;
			case 'bad_debt':
				return $author$project$Api$Invoice$Status$BadDebt;
			case 'cancelled':
				return $author$project$Api$Invoice$Status$Cancelled;
			case 'overdue':
				return $author$project$Api$Invoice$Status$Overdue;
			case 'viewed':
				return $author$project$Api$Invoice$Status$Viewed;
			case 'sent':
				return $author$project$Api$Invoice$Status$Sent;
			default:
				return $author$project$Api$Invoice$Status$Other(string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$Invoice$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'due_date',
	$author$project$Utils$Date$decode,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'due_in_cents',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'paid_in_cents',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'paid_at',
				$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'amount_in_cents',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'human_status',
						$author$project$Api$Invoice$Status$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'invoice_date',
							$author$project$Utils$Date$decode,
							$elm$json$Json$Decode$succeed($author$project$Api$Provider$Invoice$Shared$Record))))))));
var $author$project$Api$Provider$Invoice$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Invoice$Shared$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Invoice$Min$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Invoice$Shared$Invoice)));
var $author$project$Api$Provider$AffiliateBill$All$Record = F4(
	function (numberOfDependents, numberOfEmployees, affiliate, practice) {
		return {Gn: affiliate, X2: numberOfDependents, X3: numberOfEmployees, ZV: practice};
	});
var $author$project$Api$Provider$Affiliate$Shared$Affiliate = $elm$core$Basics$identity;
var $author$project$Api$Provider$Affiliate$Shared$Record = F3(
	function (id, name, status) {
		return {ahP: id, Bq: name, alH: status};
	});
var $author$project$Api$Provider$Affiliate$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'status',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Affiliate$Shared$Record))));
var $author$project$Api$Provider$Affiliate$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Affiliate$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$AffiliateBill$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'practice',
	$author$project$Api$Provider$Practice$Min$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'affiliate',
		$author$project$Api$Provider$Affiliate$Shared$decoder,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
			_List_fromArray(
				['summary', 'active_lines', 'totals', 'count']),
			$elm$json$Json$Decode$int,
			0,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
				_List_fromArray(
					['summary', 'active_lines', 'totals', 'number_of_dependents']),
				$elm$json$Json$Decode$int,
				0,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$AffiliateBill$All$Record)))));
var $author$project$Api$Provider$AffiliateBill$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$AffiliateBill$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Invoice$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$AffiliateBill$All$AffiliateBill)));
var $author$project$Api$Param$Date = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Api$Param$date = $author$project$Api$Param$Date;
var $author$project$Api$Provider$AffiliateBill$listDefaults = {Gn: $elm$core$Maybe$Nothing, HB: $elm$core$Maybe$Nothing, ajJ: $author$project$Api$Pagination$init, alA: $author$project$Api$Sort$init, JV: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$AffiliateBill$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$AffiliateBill$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.Gn;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'affiliate', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.JV;
				if (!_v1.$) {
					var start_ = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$date, 'start', start_)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.HB;
				if (!_v2.$) {
					var end_ = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$date, 'end', end_)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$Provider$AffiliateBill$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$AffiliateBill$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$AffiliateBill$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$AffiliateBill$affiliateBillsPath)));
	});
var $author$project$Components$Affiliates$BillsList$fetchAffiliateBills = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Api$Provider$AffiliateBill$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						Gn: A2($elm$core$Maybe$map, $author$project$Api$Provider$Affiliate$One$id, model.Gn),
						HB: A2(
							$elm$core$Maybe$map,
							A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
							model.HB),
						ajJ: model.ajJ,
						alA: model.alA,
						JV: A2(
							$elm$core$Maybe$map,
							A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
							model.JV)
					});
			},
			$author$project$Components$Affiliates$BillsList$GotAffiliateBills);
	});
var $author$project$Utils$DateWithDefault$DefaultEnd = {$: 2};
var $author$project$Utils$DateWithDefault$Date = function (a) {
	return {$: 0, a: a};
};
var $author$project$Utils$Date$fromIsoString = function (string) {
	return $elm$core$Result$toMaybe(
		$justinmimbs$date$Date$fromIsoString(string));
};
var $author$project$Utils$DateWithDefault$fromString = F2(
	function (_default, string) {
		if (string === 'default') {
			return $elm$core$Maybe$Just(_default);
		} else {
			return A2(
				$elm$core$Maybe$map,
				$author$project$Utils$DateWithDefault$Date,
				$author$project$Utils$Date$fromIsoString(string));
		}
	});
var $author$project$Utils$DateWithDefault$endFromQuery = function (query) {
	return A2(
		$elm$core$Maybe$andThen,
		$author$project$Utils$DateWithDefault$fromString($author$project$Utils$DateWithDefault$DefaultEnd),
		A2($elm$core$Dict$get, 'end', query));
};
var $author$project$Utils$DateWithDefault$DefaultStart = {$: 1};
var $author$project$Utils$DateWithDefault$startFromQuery = function (query) {
	return A2(
		$elm$core$Maybe$andThen,
		$author$project$Utils$DateWithDefault$fromString($author$project$Utils$DateWithDefault$DefaultStart),
		A2($elm$core$Dict$get, 'start', query));
};
var $author$project$Utils$DateWithDefault$fromQuery = function (query) {
	return _Utils_Tuple2(
		$author$project$Utils$DateWithDefault$startFromQuery(query),
		$author$project$Utils$DateWithDefault$endFromQuery(query));
};
var $author$project$Components$DateRangeInput$DropdownMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$DateRangeInput$FromDatePickerMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$DateRangeInput$GotCurrentDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$DateRangeInput$Model = $elm$core$Basics$identity;
var $author$project$Components$DateRangeInput$ToDatePickerMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$DateRangeInput$init = F2(
	function (id, settings) {
		var _v0 = $agustinrhcp$elm_datepicker$DatePicker$init;
		var toDatePicker = _v0.a;
		var toDatePickerCmd = _v0.b;
		var _v1 = $agustinrhcp$elm_datepicker$DatePicker$init;
		var fromDatePicker = _v1.a;
		var fromDatePickerCmd = _v1.b;
		return _Utils_Tuple2(
			{
				ma: $elm$core$Dict$empty,
				dd: $elm$core$Maybe$Nothing,
				gi: $author$project$Ui$Dropdown$init(
					$author$project$Ui$Dropdown$defaultConfig(
						{ahP: id + '-date-range-dropdown', al6: $author$project$Components$DateRangeInput$DropdownMsg})),
				ahy: $elm$core$Maybe$Nothing,
				su: fromDatePicker,
				IF: $elm$core$Dict$empty,
				Cd: _List_Nil,
				hy: $elm$core$Maybe$Nothing,
				cT: settings,
				al5: $elm$core$Maybe$Nothing,
				u8: toDatePicker
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$DateRangeInput$FromDatePickerMsg, fromDatePickerCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$DateRangeInput$ToDatePickerMsg, toDatePickerCmd),
						A2($elm$core$Task$perform, $author$project$Components$DateRangeInput$GotCurrentDate, $justinmimbs$date$Date$today)
					])));
	});
var $author$project$Api$Provider$Network$One$Network = $elm$core$Basics$identity;
var $author$project$Api$Provider$Network$One$Record = F2(
	function (defaultSourceForStripe, defaultSourceForRainforest) {
		return {Qd: defaultSourceForRainforest, Qe: defaultSourceForStripe};
	});
var $author$project$Api$Provider$Network$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'default_source_for_rainforest',
	$elm$json$Json$Decode$nullable($author$project$Api$Common$Source$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'default_source_for_stripe',
		$elm$json$Json$Decode$nullable($author$project$Api$Common$Source$Shared$decoder),
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Network$One$Record)));
var $author$project$Api$Provider$Network$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Network$One$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Network$networkPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['network']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Network$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Network$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Network$networkPath));
	});
var $author$project$Components$Affiliates$BillsList$init = function (config) {
	var _v0 = $author$project$Utils$DateWithDefault$fromQuery(config.DE);
	var start = _v0.a;
	var end = _v0.b;
	var _v1 = A2(
		$author$project$Components$DateRangeInput$init,
		'date-range-input',
		A2(
			$author$project$Components$Affiliates$BillsList$dateRangeInputSettings,
			A2(
				$elm$core$Maybe$map,
				A2($author$project$Utils$DateWithDefault$toDate, config.dd, 0),
				start),
			A2(
				$elm$core$Maybe$map,
				A2($author$project$Utils$DateWithDefault$toDate, config.dd, 0),
				end)));
	var dateRangeInput = _v1.a;
	var dateRangeInputCmd = _v1.b;
	var model = {
		Gn: config.Gn,
		$9: $author$project$Api$Data$Loading,
		xJ: $author$project$Utils$Maybe$toBool(config.Gn),
		dd: config.dd,
		i4: dateRangeInput,
		HB: end,
		Is: config.Is,
		Xz: $author$project$Api$Data$Loading,
		ajJ: $author$project$Api$Pagination$initFromQuery(config.DE),
		Zd: config.Zd,
		alA: $author$project$Api$Sort$initFromQuery(config.DE),
		JV: start,
		J7: config.J7
	};
	return _Utils_Tuple2(
		model,
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Affiliates$BillsList$DateRangeInputMsg, dateRangeInputCmd),
					$author$project$Utils$Maybe$toBool(config.Gn) ? $elm$core$Platform$Cmd$none : A2($author$project$Api$Provider$Network$retrieve, config.Gv, $author$project$Components$Affiliates$BillsList$GotNetwork),
					A2($author$project$Components$Affiliates$BillsList$fetchAffiliateBills, config.Gv, model),
					$author$project$Ports$Navigation$replaceUrl(
					$author$project$Components$Affiliates$BillsList$buildUrl(model))
				])));
};
var $author$project$Pages$AffiliateBills$Top$init = F4(
	function (_v0, practice, shared, _v1) {
		var query = _v1.DE;
		var _v2 = $author$project$Components$Affiliates$BillsList$init(
			{
				Gn: $elm$core$Maybe$Nothing,
				Gv: shared.Gv,
				dd: shared.dd,
				Is: $author$project$Spa$Generated$Route$AffiliateBills__Top,
				Zd: $author$project$Api$Provider$Practice$One$paymentProcessor(practice),
				DE: query,
				J7: shared.J7
			});
		var billsList = _v2.a;
		var billsListCmd = _v2.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, s1: billsList},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, billsListCmd));
	});
var $author$project$Pages$AffiliateBills$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$AffiliateBills$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$DateRangeInput$subscriptions = function (_v0) {
	var model = _v0;
	return $author$project$Ui$Dropdown$subscriptions(model.gi);
};
var $author$project$Components$Affiliates$BillsList$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Components$Affiliates$BillsList$DateRangeInputMsg,
		$author$project$Components$DateRangeInput$subscriptions(model.i4));
};
var $author$project$Pages$AffiliateBills$Top$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Affiliates$BillsList$subscriptions(model.s1));
};
var $author$project$Utils$DateWithDefault$fromDate = $author$project$Utils$DateWithDefault$Date;
var $author$project$Components$DateRangeInput$None = {$: 0};
var $author$project$Components$DateRangeInput$buildAdditionalItemOption = function (additionalItem_) {
	return _Utils_Tuple2(
		additionalItem_.ahP,
		_Utils_Tuple3(additionalItem_.aih, additionalItem_.JV, additionalItem_.HB));
};
var $author$project$Components$DateRangeInput$buildAdditionalItems = function (additionalItems) {
	return $elm$core$Dict$fromList(
		A2($elm$core$List$map, $author$project$Components$DateRangeInput$buildAdditionalItemOption, additionalItems));
};
var $author$project$Components$DateRangeInput$customId = 'custom';
var $author$project$Components$DateRangeInput$buildCustomItem = F2(
	function (startDate, endDate) {
		return {HB: endDate, ahP: $author$project$Components$DateRangeInput$customId, aih: 'Custom', JV: startDate};
	});
var $author$project$Components$DateRangeInput$OptionSelected = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Components$DateRangeInput$buildEvent = F4(
	function (model, fromDate, toDate, label) {
		return (_Utils_eq(model.ahy, fromDate) && _Utils_eq(model.al5, toDate)) ? $author$project$Components$DateRangeInput$None : A3($author$project$Components$DateRangeInput$OptionSelected, fromDate, toDate, label);
	});
var $author$project$Components$DateRangeInput$buildMonthItem = function (_v0) {
	var id = _v0.a;
	var _v1 = _v0.b;
	var label = _v1.a;
	var monthStart = _v1.b;
	var monthEnd = _v1.c;
	return {HB: monthEnd, ahP: id, aih: label, JV: monthStart};
};
var $author$project$Components$DateRangeInput$buildMonthOptions = F2(
	function (monthRanges, additionalItems) {
		return $elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						{HB: $elm$core$Maybe$Nothing, ahP: $author$project$Components$DateRangeInput$customId, aih: 'Custom', JV: $elm$core$Maybe$Nothing}
					]),
					A2(
					$elm$core$List$map,
					function (_v0) {
						var id = _v0.a;
						var _v1 = _v0.b;
						var label = _v1.a;
						var start = _v1.b;
						var end = _v1.c;
						return {HB: end, ahP: id, aih: label, JV: start};
					},
					$elm$core$Dict$toList(additionalItems)),
					A2(
					$elm$core$List$map,
					function (_v6) {
						var id = _v6.a;
						var _v7 = _v6.b;
						var label = _v7.a;
						var start = _v7.b;
						var end = _v7.c;
						return {
							HB: $elm$core$Maybe$Just(end),
							ahP: id,
							aih: label,
							JV: $elm$core$Maybe$Just(start)
						};
					},
					$elm$core$List$reverse(
						A2(
							$elm$core$List$sortWith,
							F2(
								function (_v2, _v4) {
									var _v3 = _v2.b;
									var fromDate = _v3.b;
									var _v5 = _v4.b;
									var otherFromDate = _v5.b;
									return A2($justinmimbs$date$Date$compare, fromDate, otherFromDate);
								}),
							$elm$core$Dict$toList(monthRanges))))
				]));
	});
var $author$project$Components$DateRangeInput$buildMonthRange = F2(
	function (startMonth, index) {
		var monthStart = A3($justinmimbs$date$Date$add, 1, index, startMonth);
		var monthId = A2($justinmimbs$date$Date$format, 'MMMM yyyy', monthStart);
		var monthEnd = A3(
			$justinmimbs$date$Date$add,
			3,
			-1,
			A3($justinmimbs$date$Date$add, 1, 1, monthStart));
		return _Utils_Tuple2(
			monthId,
			_Utils_Tuple3(monthId, monthStart, monthEnd));
	});
var $author$project$Components$DateRangeInput$buildMonthRanges = F2(
	function (currentDate, settings) {
		var startMonth = A2($justinmimbs$date$Date$floor, 2, currentDate);
		var _v0 = settings.HV ? _Utils_Tuple2(0, 12) : _Utils_Tuple2(settings.IE, settings.ID);
		var rangeStart = _v0.a;
		var rangeEnd = _v0.b;
		return $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				$author$project$Components$DateRangeInput$buildMonthRange(startMonth),
				$elm$core$List$reverse(
					A2($elm$core$List$range, rangeStart, rangeEnd))));
	});
var $author$project$Components$DateRangeInput$formatWeekday = function (weekday) {
	switch (weekday) {
		case 0:
			return 'Mon';
		case 1:
			return 'Tue';
		case 2:
			return 'Wed';
		case 3:
			return 'Thu';
		case 4:
			return 'Fri';
		case 5:
			return 'Sat';
		default:
			return 'Sun';
	}
};
var $author$project$Components$DateRangeInput$datePickerSettings = function () {
	var defaultSettings_ = $agustinrhcp$elm_datepicker$DatePicker$defaultSettings;
	return _Utils_update(
		defaultSettings_,
		{
			af7: $justinmimbs$date$Date$format('MM/dd/yyyy'),
			aga: $author$project$Components$DateRangeInput$formatWeekday,
			H2: _List_fromArray(
				[
					_Utils_Tuple2('form-control', true)
				]),
			ajM: $author$project$Utils$Date$fromUsString,
			aj3: 'mm/dd/yyyy'
		});
}();
var $author$project$Components$DateRangeInput$isCustomItem = function (maybeOption) {
	if (!maybeOption.$) {
		var item = maybeOption.a;
		return _Utils_eq(item.ahP, $author$project$Components$DateRangeInput$customId);
	} else {
		return false;
	}
};
var $author$project$Components$DateRangeInput$defaultDateIfCustom = F4(
	function (model, selectedOption, getter, _default) {
		if ($author$project$Components$DateRangeInput$isCustomItem(selectedOption)) {
			var _v0 = getter(model);
			if (!_v0.$) {
				var currentDate = _v0.a;
				return $elm$core$Maybe$Just(currentDate);
			} else {
				return _default;
			}
		} else {
			return _default;
		}
	});
var $author$project$Components$DateRangeInput$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var currentDate = msg.a;
				var toDate = model.cT.al5;
				var monthRanges = A2($author$project$Components$DateRangeInput$buildMonthRanges, currentDate, model.cT);
				var fromDate = model.cT.ahy;
				var additionalItems = $author$project$Components$DateRangeInput$buildAdditionalItems(
					model.cT.ma(currentDate));
				var selectedOption = function () {
					var _v2 = _Utils_Tuple2(fromDate, toDate);
					if ((_v2.a.$ === 1) && (_v2.b.$ === 1)) {
						var _v3 = _v2.a;
						var _v4 = _v2.b;
						return $elm$core$Maybe$Nothing;
					} else {
						var selectedItem = A2(
							$elm$core$Maybe$withDefault,
							A2(
								$elm$core$Maybe$map,
								function (_v9) {
									var id = _v9.a;
									var _v10 = _v9.b;
									var label = _v10.a;
									var start = _v10.b;
									var end = _v10.c;
									return _Utils_Tuple2(
										id,
										_Utils_Tuple3(
											label,
											$elm$core$Maybe$Just(start),
											$elm$core$Maybe$Just(end)));
								},
								A2(
									$elm_community$list_extra$List$Extra$find,
									function (_v7) {
										var _v8 = _v7.b;
										var start = _v8.b;
										var end = _v8.c;
										return _Utils_eq(
											$elm$core$Maybe$Just(start),
											fromDate) && _Utils_eq(
											$elm$core$Maybe$Just(end),
											toDate);
									},
									$elm$core$Dict$toList(monthRanges))),
							A2(
								$elm$core$Maybe$map,
								$elm$core$Maybe$Just,
								A2(
									$elm_community$list_extra$List$Extra$find,
									function (_v5) {
										var _v6 = _v5.b;
										var start = _v6.b;
										var end = _v6.c;
										return _Utils_eq(start, fromDate) && _Utils_eq(end, toDate);
									},
									$elm$core$Dict$toList(additionalItems))));
						return $elm$core$Maybe$Just(
							A2(
								$elm$core$Maybe$withDefault,
								A2($author$project$Components$DateRangeInput$buildCustomItem, fromDate, toDate),
								A2($elm$core$Maybe$map, $author$project$Components$DateRangeInput$buildMonthItem, selectedItem)));
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ma: additionalItems,
							dd: $elm$core$Maybe$Just(currentDate),
							ahy: fromDate,
							IF: monthRanges,
							Cd: A2($author$project$Components$DateRangeInput$buildMonthOptions, monthRanges, additionalItems),
							hy: selectedOption,
							al5: toDate
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$DateRangeInput$None);
			case 1:
				var subMsg = msg.a;
				var _v11 = A3($agustinrhcp$elm_datepicker$DatePicker$update, $author$project$Components$DateRangeInput$datePickerSettings, subMsg, model.su);
				var fromDatePicker = _v11.a;
				var fromDatePickerEvent = _v11.b;
				var fromDate = function () {
					_v12$2:
					while (true) {
						switch (fromDatePickerEvent.$) {
							case 2:
								var date = fromDatePickerEvent.a;
								return $elm$core$Maybe$Just(date);
							case 1:
								if (fromDatePickerEvent.a.$ === 1) {
									var _v13 = fromDatePickerEvent.a;
									return $elm$core$Maybe$Nothing;
								} else {
									break _v12$2;
								}
							default:
								break _v12$2;
						}
					}
					return model.ahy;
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ahy: fromDate, su: fromDatePicker}),
					$elm$core$Platform$Cmd$none,
					A4($author$project$Components$DateRangeInput$buildEvent, model, fromDate, model.al5, 'Custom'));
			case 2:
				var subMsg = msg.a;
				var _v14 = A3($agustinrhcp$elm_datepicker$DatePicker$update, $author$project$Components$DateRangeInput$datePickerSettings, subMsg, model.u8);
				var toDatePicker = _v14.a;
				var toDatePickerEvent = _v14.b;
				var toDate = function () {
					_v15$2:
					while (true) {
						switch (toDatePickerEvent.$) {
							case 2:
								var date = toDatePickerEvent.a;
								return $elm$core$Maybe$Just(date);
							case 1:
								if (toDatePickerEvent.a.$ === 1) {
									var _v16 = toDatePickerEvent.a;
									return $elm$core$Maybe$Nothing;
								} else {
									break _v15$2;
								}
							default:
								break _v15$2;
						}
					}
					return model.al5;
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{al5: toDate, u8: toDatePicker}),
					$elm$core$Platform$Cmd$none,
					A4($author$project$Components$DateRangeInput$buildEvent, model, model.ahy, toDate, 'Custom'));
			case 3:
				var subMsg = msg.a;
				var _v17 = A2($author$project$Ui$Dropdown$update, subMsg, model.gi);
				var dropdown = _v17.a;
				var cmd = _v17.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{gi: dropdown}),
					cmd,
					$author$project$Components$DateRangeInput$None);
			default:
				var maybeItem = msg.a;
				var _v18 = function () {
					if (!maybeItem.$) {
						var item = maybeItem.a;
						return _Utils_Tuple3(item.JV, item.HB, item.aih);
					} else {
						return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, '');
					}
				}();
				var optionFromDate = _v18.a;
				var optionToDate = _v18.b;
				var selectedOptionLabel = _v18.c;
				var fromDate = A4(
					$author$project$Components$DateRangeInput$defaultDateIfCustom,
					model,
					maybeItem,
					function ($) {
						return $.ahy;
					},
					optionFromDate);
				var toDate = A4(
					$author$project$Components$DateRangeInput$defaultDateIfCustom,
					model,
					maybeItem,
					function ($) {
						return $.al5;
					},
					optionToDate);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ahy: fromDate, hy: maybeItem, al5: toDate}),
					$elm$core$Platform$Cmd$none,
					A4($author$project$Components$DateRangeInput$buildEvent, model, fromDate, toDate, selectedOptionLabel));
		}
	});
var $author$project$Components$Affiliates$BillsList$updateUrl = A2($elm$core$Basics$composeR, $author$project$Components$Affiliates$BillsList$buildUrl, $author$project$Ports$Navigation$pushUrl);
var $author$project$Components$Affiliates$BillsList$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								$9: response,
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{$9: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Xz: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 2:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Affiliates$BillsList$fetchAffiliateBills, apiClient, newModel),
								$author$project$Components$Affiliates$BillsList$updateUrl(newModel)
							])),
					_List_Nil);
			case 3:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						alA: A2($author$project$Api$Sort$update, columnId, model.alA)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Affiliates$BillsList$fetchAffiliateBills, apiClient, newModel),
								$author$project$Components$Affiliates$BillsList$updateUrl(newModel)
							])),
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Components$DateRangeInput$update, subMsg, model.i4);
				var dateRangeInput = _v2.a;
				var subCmd = _v2.b;
				var event = _v2.c;
				var newModel = function () {
					if (event.$ === 1) {
						var fromDate = event.a;
						var toDate = event.b;
						return _Utils_update(
							model,
							{
								$9: $author$project$Api$Data$Loading,
								i4: dateRangeInput,
								HB: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
								ajJ: $author$project$Api$Pagination$reset(model.ajJ),
								JV: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
							});
					} else {
						return _Utils_update(
							model,
							{i4: dateRangeInput});
					}
				}();
				var cmds = (_Utils_eq(newModel.JV, model.JV) && _Utils_eq(newModel.HB, model.HB)) ? _List_Nil : _List_fromArray(
					[
						A2($author$project$Components$Affiliates$BillsList$fetchAffiliateBills, apiClient, newModel),
						$author$project$Components$Affiliates$BillsList$updateUrl(newModel)
					]);
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$cons,
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Affiliates$BillsList$DateRangeInputMsg, subCmd),
							cmds)),
					_List_Nil);
		}
	});
var $author$project$Pages$AffiliateBills$Top$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Affiliates$BillsList$update, model.Gv, subMsg, model.s1);
		var billsList = _v1.a;
		var billsListCmd = _v1.b;
		var billsListOutMsgs = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{s1: billsList}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, billsListCmd),
			billsListOutMsgs);
	});
var $author$project$Components$Affiliates$BillsList$PaginationMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Affiliates$BillsList$SortTable = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Affiliates$BillsList$columns = function (byAffiliate) {
	return $elm$core$List$concat(
		_List_fromArray(
			[
				(!byAffiliate) ? _List_fromArray(
				[
					A3($author$project$Api$Column$init, 'name', false, 'Affiliate Name')
				]) : _List_Nil,
				_List_fromArray(
				[
					A3($author$project$Api$Column$init, 'invoice_date', true, 'Invoice Date'),
					A3($author$project$Api$Column$init, 'invoice_number', false, 'Bill Number'),
					A3($author$project$Api$Column$init, 'active_lives', false, 'Active Lives'),
					A3($author$project$Api$Column$init, 'amount_in_cents', false, 'Bill Amount'),
					A3($author$project$Api$Column$init, 'bill_status', false, 'Status')
				])
			]));
};
var $author$project$Api$Provider$Affiliate$One$defaultSource = function (_v0) {
	var record = _v0.b;
	return record.Qc;
};
var $author$project$Api$Provider$Network$One$defaultSourceForProcessor = F2(
	function (processor, _v0) {
		var record = _v0;
		switch (processor) {
			case 'stripe':
				return record.Qe;
			case 'rainforest':
				return record.Qd;
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$DateRangeInput$ItemSelected = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$DateRangeInput$dropdownItems = F2(
	function (options, currentSelection) {
		return A2(
			$elm$core$List$cons,
			A2(
				$author$project$Ui$Dropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$Dropdown$onSelect(
						$author$project$Components$DateRangeInput$ItemSelected($elm$core$Maybe$Nothing)),
						$author$project$Ui$Dropdown$selected(
						_Utils_eq(currentSelection, $elm$core$Maybe$Nothing))
					]),
				$elm$html$Html$text('All time')),
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Dropdown$separator,
				A2(
					$elm$core$List$map,
					function (item) {
						return A2(
							$author$project$Ui$Dropdown$item,
							_List_fromArray(
								[
									$author$project$Ui$Dropdown$onSelect(
									$author$project$Components$DateRangeInput$ItemSelected(
										$elm$core$Maybe$Just(item))),
									$author$project$Ui$Dropdown$selected(
									_Utils_eq(
										currentSelection,
										$elm$core$Maybe$Just(item)))
								]),
							$elm$html$Html$text(item.aih));
					},
					options)));
	});
var $author$project$Ui$Grid$Sm = 1;
var $author$project$Ui$Grid$gutterSm = $author$project$Ui$Grid$Gutter(1);
var $author$project$Components$DateRangeInput$view = function (_v0) {
	var model = _v0;
	var fullWithLength = model.cT.HT ? 12 : 4;
	return A2(
		$author$project$Ui$Grid$row,
		_List_fromArray(
			[$author$project$Ui$Grid$gutterSm]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$spanSm(fullWithLength)
					]),
				_List_fromArray(
					[
						function () {
						var placeholder = function () {
							var _v1 = model.hy;
							if (!_v1.$) {
								var item = _v1.a;
								return item.aih;
							} else {
								return 'All time';
							}
						}();
						return A4(
							$author$project$Ui$Dropdown$viewSelect,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(placeholder)
								]),
							A2($author$project$Components$DateRangeInput$dropdownItems, model.Cd, model.hy),
							model.gi);
					}()
					])),
				A2(
				$author$project$Ui$Grid$column,
				model.cT.y0,
				(model.cT.xj || $author$project$Components$DateRangeInput$isCustomItem(model.hy)) ? _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('sr-only')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('From Date')
									])),
								A2(
								$elm$html$Html$map,
								$author$project$Components$DateRangeInput$FromDatePickerMsg,
								A3($agustinrhcp$elm_datepicker$DatePicker$view, model.ahy, $author$project$Components$DateRangeInput$datePickerSettings, model.su))
							]))
					]) : _List_Nil),
				(model.cT.xj || $author$project$Components$DateRangeInput$isCustomItem(model.hy)) ? A2(
				$author$project$Ui$Grid$column,
				model.cT.y0,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('sr-only')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('To Date')
							])),
						A2(
						$elm$html$Html$map,
						$author$project$Components$DateRangeInput$ToDatePickerMsg,
						A3($agustinrhcp$elm_datepicker$DatePicker$view, model.al5, $author$project$Components$DateRangeInput$datePickerSettings, model.u8))
					])) : $author$project$Ui$Grid$none
			]));
};
var $author$project$Components$Affiliates$BillsList$viewSource = F2(
	function (timeFormatter, source) {
		if (!source.$) {
			var source_ = source.a;
			return A2(
				$author$project$Components$PracticeSourceDisplayer$view,
				timeFormatter,
				$elm$core$Maybe$Just(
					$author$project$Api$Source$Source(source_)));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Api$Provider$AffiliateBill$All$numberOfDependents = function (_v0) {
	var record = _v0.b;
	return record.X2;
};
var $author$project$Api$Provider$AffiliateBill$All$numberOfEmployees = function (_v0) {
	var record = _v0.b;
	return record.X3;
};
var $author$project$Components$Affiliates$BillsList$activeLives = function (affiliateBill) {
	return $author$project$Api$Provider$AffiliateBill$All$numberOfDependents(affiliateBill) + $author$project$Api$Provider$AffiliateBill$All$numberOfEmployees(affiliateBill);
};
var $author$project$Api$Provider$AffiliateBill$All$affiliate = function (_v0) {
	var record = _v0.b;
	return record.Gn;
};
var $author$project$Api$Provider$Invoice$Shared$amountInCents = function (_v0) {
	var record = _v0.b;
	return record.LE;
};
var $author$project$Api$Provider$AffiliateBill$All$amountInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Invoice$Shared$amountInCents(shared);
};
var $author$project$Api$Provider$Invoice$Shared$humanStatus = function (_v0) {
	var record = _v0.b;
	return record.TH;
};
var $author$project$Api$Provider$AffiliateBill$All$humanStatus = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Invoice$Shared$humanStatus(shared);
};
var $author$project$Api$Provider$AffiliateBill$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Invoice$Shared$id(shared);
};
var $author$project$Api$Provider$Invoice$Shared$invoiceDate = function (_v0) {
	var record = _v0.b;
	return record.Uq;
};
var $author$project$Api$Provider$AffiliateBill$All$invoiceDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Invoice$Shared$invoiceDate(shared);
};
var $author$project$Api$Provider$Invoice$Min$invoiceNumber = function (_v0) {
	var record = _v0;
	return record.Uu;
};
var $author$project$Api$Provider$Invoice$Shared$invoiceNumber = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Provider$Invoice$Min$invoiceNumber(min);
};
var $author$project$Api$Provider$AffiliateBill$All$invoiceNumber = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Invoice$Shared$invoiceNumber(shared);
};
var $author$project$Api$Provider$AffiliateBill$All$practice = function (_v0) {
	var record = _v0.b;
	return record.ZV;
};
var $author$project$Api$Invoice$Status$toString = function (status_) {
	switch (status_.$) {
		case 0:
			return 'draft';
		case 1:
			return 'issued';
		case 2:
			return 'paid';
		case 3:
			return 'disputed';
		case 4:
			return 'bad debt';
		case 5:
			return 'cancelled';
		case 6:
			return 'overdue';
		case 7:
			return 'viewed';
		case 8:
			return 'sent';
		default:
			var string = status_.a;
			return string;
	}
};
var $author$project$Api$Invoice$Status$toBadge = function (status_) {
	var badgeOption = function () {
		switch (status_.$) {
			case 7:
				return _List_fromArray(
					[$author$project$Ui$Badge$info]);
			case 2:
				return _List_fromArray(
					[$author$project$Ui$Badge$success]);
			case 6:
				return _List_fromArray(
					[$author$project$Ui$Badge$danger]);
			case 1:
				return _List_fromArray(
					[$author$project$Ui$Badge$warning]);
			case 8:
				return _List_fromArray(
					[$author$project$Ui$Badge$warning]);
			default:
				return _List_Nil;
		}
	}();
	return A2(
		$author$project$Ui$Badge$view,
		badgeOption,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Api$Invoice$Status$toString(status_))
			]));
};
var $author$project$Components$Affiliates$BillsList$viewStatement = F2(
	function (model, affiliateBill) {
		var affiliateId = $author$project$Api$Provider$Affiliate$Shared$id(
			$author$project$Api$Provider$AffiliateBill$All$affiliate(affiliateBill));
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						(!model.xJ) ? _List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$Practice$Min$name(
										$author$project$Api$Provider$AffiliateBill$All$practice(affiliateBill)))
								]))
						]) : _List_Nil,
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Id_String(
										{
											rd: affiliateId,
											ahP: $author$project$Api$Provider$AffiliateBill$All$id(affiliateBill)
										}),
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$author$project$Formatters$Date$toString,
												$author$project$Formatters$Date$MonthAndYear,
												$author$project$Api$Provider$AffiliateBill$All$invoiceDate(affiliateBill)))
										]))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Id_String(
										{
											rd: affiliateId,
											ahP: $author$project$Api$Provider$AffiliateBill$All$id(affiliateBill)
										}),
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('#'),
											$elm$html$Html$text(
											$elm$core$String$fromInt(
												$author$project$Api$Provider$AffiliateBill$All$invoiceNumber(affiliateBill)))
										]))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(
										$author$project$Components$Affiliates$BillsList$activeLives(affiliateBill)))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$AffiliateBill$All$amountInCents(affiliateBill)))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Api$Invoice$Status$toBadge(
									$author$project$Api$Provider$AffiliateBill$All$humanStatus(affiliateBill))
								]))
						])
					])));
	});
var $author$project$Components$Affiliates$BillsList$view = function (model) {
	var _v0 = function () {
		var _v1 = model.$9;
		if (_v1.$ === 3) {
			var affiliateBills_ = _v1.a;
			return _Utils_Tuple2(false, affiliateBills_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var affiliateBills = _v0.b;
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanSm(8)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Components$Affiliates$BillsList$DateRangeInputMsg,
										$author$project$Components$DateRangeInput$view(model.i4))
									])),
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanSm(4),
										$author$project$Ui$Grid$justifyRight
									]),
								_List_fromArray(
									[
										function () {
										var _v2 = _Utils_Tuple2(model.Gn, model.Xz);
										if (!_v2.a.$) {
											var affiliate = _v2.a.a;
											return A2(
												$author$project$Components$Affiliates$BillsList$viewSource,
												model.J7,
												$author$project$Api$Provider$Affiliate$One$defaultSource(affiliate));
										} else {
											if (_v2.b.$ === 3) {
												var _v3 = _v2.a;
												var _v4 = _v2.b;
												var network = _v4.a;
												return A2(
													$author$project$Components$Affiliates$BillsList$viewSource,
													model.J7,
													A2($author$project$Api$Provider$Network$One$defaultSourceForProcessor, model.Zd, network));
											} else {
												var _v5 = _v2.a;
												return $author$project$Ui$Spinner$view(
													_List_fromArray(
														[$author$project$Ui$Spinner$small]));
											}
										}
									}()
									]))
							]))
					])),
				A4(
				$author$project$Ui$Panel$table,
				_List_fromArray(
					[
						$author$project$Ui$Table$verticalCentered,
						$author$project$Ui$Table$zeroState(
						_List_fromArray(
							[
								$elm$html$Html$text('No matching results.')
							])),
						$author$project$Ui$Table$loading(loading)
					]),
				$elm$core$List$concat(
					_List_fromArray(
						[
							A2(
							$elm$core$List$map,
							$author$project$Api$Column$view(
								A2($author$project$Api$Column$Sortable, model.alA, $author$project$Components$Affiliates$BillsList$SortTable)),
							$author$project$Components$Affiliates$BillsList$columns(model.xJ)),
							_List_fromArray(
							[
								A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
							])
						])),
				A2(
					$elm$core$List$map,
					$author$project$Components$Affiliates$BillsList$viewStatement(model),
					affiliateBills),
				_List_Nil),
				A2(
				$author$project$Ui$Panel$footer,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Components$Affiliates$BillsList$PaginationMsg,
						A2(
							$author$project$Api$Pagination$view,
							_List_fromArray(
								[
									$author$project$Ui$Pagination$List$loading(
									!$author$project$Utils$Maybe$toBool(
										$author$project$Api$Data$toMaybe(model.$9)))
								]),
							model.ajJ))
					]))
			]));
};
var $author$project$Pages$AffiliateBills$Top$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Affiliates$BillsList$view(model.s1))
			]),
		ac9: 'Affiliates | Bills'
	};
};
var $author$project$Pages$AffiliateBills$Top$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$AffiliateBills$Top$init, aiq: $author$project$Pages$AffiliateBills$Top$load, k8: $author$project$Pages$AffiliateBills$Top$save, alO: $author$project$Pages$AffiliateBills$Top$subscriptions, adT: $author$project$Pages$AffiliateBills$Top$update, amo: $author$project$Pages$AffiliateBills$Top$view});
var $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$GotAffiliate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Affiliate$affiliatesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['affiliates']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Affiliate$affiliatePath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		$author$project$Api$Provider$Affiliate$affiliatesPath);
};
var $author$project$Api$Provider$Affiliate$One$Affiliate = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Affiliate$One$Record = F4(
	function (createdFrom, defaultSource, company, affiliatePractice) {
		return {Le: affiliatePractice, afQ: company, af0: createdFrom, Qc: defaultSource};
	});
var $author$project$Api$Provider$Affiliate$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'affiliate_practice',
	$author$project$Api$Provider$Practice$One$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'company',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Company$Min$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'default_source',
			$elm$json$Json$Decode$nullable($author$project$Api$Common$Source$Shared$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'created_from',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$Affiliate$One$Record)))));
var $author$project$Api$Provider$Affiliate$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Affiliate$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Affiliate$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Affiliate$One$Affiliate)));
var $author$project$Api$Provider$Affiliate$retrieve = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Affiliate$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Affiliate$affiliatePath(id_)));
	});
var $author$project$Api$Pagination$withPrefix = F2(
	function (prefix, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{t1: prefix});
	});
var $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$init = F4(
	function (session, _v0, shared, _v1) {
		var params = _v1.YL;
		var query = _v1.DE;
		return _Utils_Tuple2(
			{
				mg: $elm$core$Maybe$Nothing,
				rd: params.rd,
				Gv: shared.Gv,
				ajJ: A2(
					$author$project$Api$Pagination$fromQuery,
					query,
					A2($author$project$Api$Pagination$withPrefix, 'affiliate_actions_', $author$project$Api$Pagination$init)),
				DE: query,
				aa4: session
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3($author$project$Api$Provider$Affiliate$retrieve, shared.Gv, params.rd, $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$GotAffiliate),
						$author$project$Shared$isHintAdmin(shared) ? $elm$core$Platform$Cmd$none : A2(
						$author$project$Utils$Route$navigate,
						$elm$core$Dict$empty,
						$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Top(
							{rd: params.rd}))
					])));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$AffiliateActionsListMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Affiliates$AffiliateActionsList$buildUrl = function (model) {
	return A2(
		$elm$url$Url$Builder$relative,
		_List_fromArray(
			[
				$author$project$Spa$Generated$Route$toString(model.Is)
			]),
		$author$project$Api$Pagination$toPageQuery(model.ajJ));
};
var $author$project$Components$Affiliates$AffiliateActionsList$GotAffiliateActions = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$AffiliateAction$affiliatePath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				['affiliates']),
			$author$project$Api$Data$providerPath));
};
var $author$project$Api$Provider$AffiliateAction$affiliateActionsPath = function (affiliationId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['affiliate_actions']),
		$author$project$Api$Provider$AffiliateAction$affiliatePath(affiliationId));
};
var $author$project$Api$Provider$AffiliateAction$All$AffiliateAction = $elm$core$Basics$identity;
var $author$project$Api$Provider$AffiliateAction$All$Record = F8(
	function (id, ident, contextMembershipIdent, targetIdent, actionType, actionData, status, errorMessage) {
		return {KL: actionData, KM: actionType, Oz: contextMembershipIdent, RM: errorMessage, ahP: id, ahQ: ident, alH: status, acR: targetIdent};
	});
var $author$project$Api$Provider$AffiliateAction$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'error_message',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'status',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'action_data',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'action_type',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'target_ident',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'context_membership_ident',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'ident',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$elm$json$Json$Decode$int,
								$elm$json$Json$Decode$succeed($author$project$Api$Provider$AffiliateAction$All$Record)))))))));
var $author$project$Api$Provider$AffiliateAction$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$AffiliateAction$All$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$AffiliateAction$listDefaults = {ajJ: $author$project$Api$Pagination$init};
var $author$project$Api$Provider$AffiliateAction$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$AffiliateAction$listDefaults);
	return $author$project$Api$Pagination$toApiParams(options.ajJ);
};
var $author$project$Api$Provider$AffiliateAction$list = F4(
	function (apiClient, affiliationId, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$AffiliateAction$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$AffiliateAction$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$AffiliateAction$affiliateActionsPath(affiliationId))));
	});
var $author$project$Components$Affiliates$AffiliateActionsList$fetchAffiliateActions = function (_v0) {
	var apiClient = _v0.Gv;
	var affiliateId = _v0.rd;
	var pagination = _v0.ajJ;
	return A4(
		$author$project$Api$Provider$AffiliateAction$list,
		apiClient,
		affiliateId,
		function (d) {
			return _Utils_update(
				d,
				{ajJ: pagination});
		},
		$author$project$Components$Affiliates$AffiliateActionsList$GotAffiliateActions);
};
var $author$project$Components$Affiliates$AffiliateActionsList$init = function (config) {
	var pagination = $author$project$Api$Pagination$initFromQuery(config.DE);
	var model = {Gn: config.Gn, mf: $author$project$Api$Data$Loading, rd: config.rd, Gv: config.Gv, Is: config.Is, ajJ: pagination};
	return _Utils_Tuple2(
		model,
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					$author$project$Components$Affiliates$AffiliateActionsList$fetchAffiliateActions(model),
					$author$project$Ports$Navigation$replaceUrl(
					$author$project$Components$Affiliates$AffiliateActionsList$buildUrl(model))
				])));
};
var $author$project$Components$Affiliates$AffiliateActionsList$updateUrl = A2($elm$core$Basics$composeR, $author$project$Components$Affiliates$AffiliateActionsList$buildUrl, $author$project$Ports$Navigation$pushUrl);
var $author$project$Components$Affiliates$AffiliateActionsList$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var response = msg.a;
			if (response.$ === 3) {
				var headers = response.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							mf: response,
							ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			} else {
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{mf: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			}
		} else {
			var subMsg = msg.a;
			var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
			var newModel = _Utils_update(
				model,
				{ajJ: pagination});
			return _Utils_Tuple3(
				newModel,
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							$author$project$Components$Affiliates$AffiliateActionsList$fetchAffiliateActions(newModel),
							$author$project$Components$Affiliates$AffiliateActionsList$updateUrl(newModel)
						])),
				_List_Nil);
		}
	});
var $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var response = msg.a;
			if (response.$ === 3) {
				var affiliate = response.a;
				var _v2 = $author$project$Components$Affiliates$AffiliateActionsList$init(
					{
						Gn: $elm$core$Maybe$Just(affiliate),
						rd: model.rd,
						Gv: model.Gv,
						Is: $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__AffiliateActions(
							{rd: model.rd}),
						DE: model.DE
					});
				var affiliateActionsList = _v2.a;
				var affiliateActionsListCmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							mg: $elm$core$Maybe$Just(affiliateActionsList)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$AffiliateActionsListMsg, affiliateActionsListCmd),
					_List_Nil);
			} else {
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			}
		} else {
			var subMsg = msg.a;
			var _v3 = model.mg;
			if (!_v3.$) {
				var affiliateActionsList = _v3.a;
				var _v4 = A2($author$project$Components$Affiliates$AffiliateActionsList$update, subMsg, affiliateActionsList);
				var affiliateActionsList_ = _v4.a;
				var affiliateActionsListCmd = _v4.b;
				var affiliateActionsListOutMsgs = _v4.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							mg: $elm$core$Maybe$Just(affiliateActionsList_)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$AffiliateActionsListMsg, affiliateActionsListCmd),
					affiliateActionsListOutMsgs);
			} else {
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
			}
		}
	});
var $author$project$Components$Affiliates$AffiliateActionsList$PaginationMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Affiliates$AffiliateActionsList$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'id', false, 'ID'),
		A3($author$project$Api$Column$init, 'ident', false, 'Ident'),
		A3($author$project$Api$Column$init, 'context_membership_ident', false, 'Context Membership Ident'),
		A3($author$project$Api$Column$init, 'target_ident', false, 'Target Ident'),
		A3($author$project$Api$Column$init, 'action_type', false, 'Action Type'),
		A3($author$project$Api$Column$init, 'action_data', false, 'Action Data'),
		A3($author$project$Api$Column$init, 'status', false, 'Status'),
		A3($author$project$Api$Column$init, 'error_message', false, 'Error Message')
	]);
var $author$project$Api$Provider$AffiliateAction$All$actionData = function (_v0) {
	var record = _v0;
	return record.KL;
};
var $author$project$Api$Provider$AffiliateAction$All$actionType = function (_v0) {
	var record = _v0;
	return record.KM;
};
var $author$project$Api$Provider$AffiliateAction$All$contextMembershipIdent = function (_v0) {
	var record = _v0;
	return record.Oz;
};
var $author$project$Api$Provider$AffiliateAction$All$errorMessage = function (_v0) {
	var record = _v0;
	return record.RM;
};
var $author$project$Api$Provider$AffiliateAction$All$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$AffiliateAction$All$ident = function (_v0) {
	var record = _v0;
	return record.ahQ;
};
var $author$project$Api$Provider$AffiliateAction$All$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Api$Provider$AffiliateAction$All$targetIdent = function (_v0) {
	var record = _v0;
	return record.acR;
};
var $author$project$Components$Affiliates$AffiliateActionsList$viewAffiliateAction = function (affiliateAction) {
	return A2(
		$author$project$Ui$Table$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$fromInt(
							$author$project$Api$Provider$AffiliateAction$All$id(affiliateAction)))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Provider$AffiliateAction$All$ident(affiliateAction))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Provider$AffiliateAction$All$contextMembershipIdent(affiliateAction))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Provider$AffiliateAction$All$targetIdent(affiliateAction))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Provider$AffiliateAction$All$actionType(affiliateAction))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Provider$AffiliateAction$All$actionData(affiliateAction))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Provider$AffiliateAction$All$status(affiliateAction))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$elm$core$Maybe$withDefault,
							'',
							$author$project$Api$Provider$AffiliateAction$All$errorMessage(affiliateAction)))
					]))
			]));
};
var $author$project$Components$Affiliates$AffiliateActionsList$view = function (model) {
	var _v0 = function () {
		var _v1 = model.mf;
		if (_v1.$ === 3) {
			var affiliateActions_ = _v1.a;
			return _Utils_Tuple2(false, affiliateActions_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var affiliateActions = _v0.b;
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Panel$title(
						_List_fromArray(
							[
								$elm$html$Html$text('Affiliate Actions')
							]))
					])),
				A4(
				$author$project$Ui$Panel$table,
				_List_fromArray(
					[
						$author$project$Ui$Table$verticalCentered,
						$author$project$Ui$Table$zeroState(
						_List_fromArray(
							[
								$elm$html$Html$text('No matching results.')
							])),
						$author$project$Ui$Table$loading(loading)
					]),
				$elm$core$List$concat(
					_List_fromArray(
						[
							A2(
							$elm$core$List$map,
							$author$project$Api$Column$view($author$project$Api$Column$NonSortable),
							$author$project$Components$Affiliates$AffiliateActionsList$columns),
							_List_fromArray(
							[
								A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
							])
						])),
				A2($elm$core$List$map, $author$project$Components$Affiliates$AffiliateActionsList$viewAffiliateAction, affiliateActions),
				_List_Nil),
				A2(
				$author$project$Ui$Panel$footer,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Components$Affiliates$AffiliateActionsList$PaginationMsg,
						A2(
							$author$project$Api$Pagination$view,
							_List_fromArray(
								[
									$author$project$Ui$Pagination$List$loading(
									!$author$project$Utils$Maybe$toBool(
										$author$project$Api$Data$toMaybe(model.mf)))
								]),
							model.ajJ))
					]))
			]));
};
var $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				function () {
				var _v0 = model.mg;
				if (!_v0.$) {
					var affiliateActionsList = _v0.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$AffiliateActionsListMsg,
						$author$project$Components$Affiliates$AffiliateActionsList$view(affiliateActionsList));
				} else {
					return A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$textCenter]),
						_List_fromArray(
							[
								$author$project$Ui$Spinner$view(_List_Nil)
							]));
				}
			}()
			]),
		ac9: 'Affiliates | Actions'
	};
};
var $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$init, aiq: $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$load, k8: $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$save, alO: $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$subscriptions, adT: $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$update, amo: $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$view});
var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$GotAffiliate = F5(
	function (a, b, c, d, e) {
		return {$: 0, a: a, b: b, c: c, d: d, e: e};
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$init = F4(
	function (session, practice, shared, _v0) {
		var params = _v0.YL;
		return _Utils_Tuple2(
			{Gv: shared.Gv, gA: $elm$core$Maybe$Nothing},
			A3(
				$author$project$Api$Provider$Affiliate$retrieve,
				shared.Gv,
				params.rd,
				A4($author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$GotAffiliate, session, practice, shared, params.ahP)));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$InvoiceComponentMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Invoice$AuditTrailLogMsg = function (a) {
	return {$: 36, a: a};
};
var $author$project$Components$Invoice$CompanyEmailModalMsg = function (a) {
	return {$: 25, a: a};
};
var $author$project$Components$Invoice$CreatePaymentModalMsg = function (a) {
	return {$: 26, a: a};
};
var $author$project$Components$Invoice$DeleteHiConfirmClosed = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Components$Invoice$DownloadInvoiceMsg = function (a) {
	return {$: 34, a: a};
};
var $author$project$Components$Invoice$DownloadUnavailableModalClosed = {$: 35};
var $author$project$Components$Invoice$InvoiceLinesTableMsg = function (a) {
	return {$: 28, a: a};
};
var $author$project$Components$Invoice$InvoiceSummaryMsg = function (a) {
	return {$: 27, a: a};
};
var $author$project$Components$Invoice$MarkAsBadDebtHiConfirmClosed = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Components$Invoice$PaymentsHistoryMsg = function (a) {
	return {$: 24, a: a};
};
var $author$project$Components$Invoice$ReturnToDraftHiConfirmClosed = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Components$Invoice$VoidHiConfirmClosed = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Components$AuditTrailLog$isOpen = function (model) {
	return $author$project$Ui$Popover$isOpen(model.aT);
};
var $author$project$Components$AuditTrailLog$subscriptions = function (model) {
	return $author$project$Ui$Popover$subscriptions(model.aT);
};
var $author$project$Components$CompanyEmailModal$Close = {$: 0};
var $author$project$Components$CompanyEmailModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$CompanyEmailModal$Close);
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModalMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$CategoryResourceFilterMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$ExportCsvMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Components$Invoice$InvoiceLinesTable$PlanResourceFilterMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CategoryResourceFilterMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ChargeItemResourceFilterMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Close = {$: 0};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CompanyRegistrationResourceFilterMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$LocationResourceFilterMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$PractitionerResourceFilterMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$ResourceFilter$CompanyRegistration$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Components$ResourceFilter$CompanyRegistration$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.b8));
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Close),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CompanyRegistrationResourceFilterMsg,
				$author$project$Components$ResourceFilter$CompanyRegistration$subscriptions(model.f_)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Utils$Form$fields,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.hk;
							},
							A2(
								$elm$core$Basics$composeR,
								$author$project$Components$ResourceFilter$Practitioner$subscriptions,
								$elm$core$Platform$Sub$map($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$PractitionerResourceFilterMsg)))),
					model.SD)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Utils$Form$fields,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.c8;
							},
							A2(
								$elm$core$Basics$composeR,
								$author$project$Components$ResourceFilter$Category$subscriptions,
								$elm$core$Platform$Sub$map($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CategoryResourceFilterMsg)))),
					model.SD)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Utils$Form$fields,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.cq;
							},
							A2(
								$elm$core$Basics$composeR,
								$author$project$Components$ResourceFilter$ChargeItem$subscriptions,
								$elm$core$Platform$Sub$map($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ChargeItemResourceFilterMsg)))),
					model.SD)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Utils$Form$fields,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.os;
							},
							A2(
								$elm$core$Basics$composeR,
								$author$project$Components$ResourceFilter$Location$subscriptions,
								$elm$core$Platform$Sub$map($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$LocationResourceFilterMsg)))),
					model.SD))
			]));
};
var $author$project$Components$Invoice$InvoiceLinesTable$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$subscriptions, model.il))),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Invoice$InvoiceLinesTable$HiConfirmClosed),
					A2($elm$core$Maybe$map, $elm$core$Tuple$first, model.gb))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Invoice$InvoiceLinesTable$ExportCsvMsg,
				$author$project$Components$ExportCsv$subscriptions(model.nD)),
				$author$project$Ui$Dropdown$subscriptions(model.nv),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Platform$Sub$map($author$project$Components$Invoice$InvoiceLinesTable$PlanResourceFilterMsg),
					A2($elm$core$Maybe$map, $author$project$Components$ResourceFilter$Plan$subscriptions, model.hi))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Invoice$InvoiceLinesTable$CategoryResourceFilterMsg,
				$author$project$Components$ResourceFilter$Category$subscriptions(model.c8))
			]));
};
var $author$project$Components$Invoice$Summary$CloseDeltaModal = {$: 5};
var $author$project$Components$Invoice$Summary$subscriptions = function (_v0) {
	var model = _v0;
	var _v1 = model.oV;
	if (!_v1.$) {
		return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Invoice$Summary$CloseDeltaModal);
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Components$Invoice$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$Dropdown$subscriptions(model.no),
				function () {
				var _v1 = model.eB;
				if (!_v1.$) {
					var invoiceLinesTable = _v1.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Components$Invoice$InvoiceLinesTableMsg,
						$author$project$Components$Invoice$InvoiceLinesTable$subscriptions(invoiceLinesTable));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				function () {
				var _v2 = model.iM;
				if (!_v2.$) {
					var companyEmailModal = _v2.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Components$Invoice$CompanyEmailModalMsg,
						$author$project$Components$CompanyEmailModal$subscriptions(companyEmailModal));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				function () {
				var _v3 = model.gB;
				if (!_v3.$) {
					var invoiceSummary = _v3.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Components$Invoice$InvoiceSummaryMsg,
						$author$project$Components$Invoice$Summary$subscriptions(invoiceSummary));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Invoice$PaymentsHistoryMsg,
				$author$project$Components$Invoice$PaymentsHistory$subscriptions(model.kC)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Invoice$CreatePaymentModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Invoice$CreatePaymentModal$subscriptions, model.m$))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Invoice$DownloadInvoiceMsg,
				$author$project$Components$Invoice$DownloadFile$subscriptions(model.jt)),
				$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Invoice$DownloadUnavailableModalClosed),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Invoice$VoidHiConfirmClosed),
					model.vp)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Invoice$ReturnToDraftHiConfirmClosed),
					model.e7)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Invoice$MarkAsBadDebtHiConfirmClosed),
					model.eJ)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Invoice$DeleteHiConfirmClosed),
					model.i9)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$andThen,
					function (auditTrailLog) {
						return $author$project$Components$AuditTrailLog$isOpen(auditTrailLog) ? $elm$core$Maybe$Just(
							A2(
								$elm$core$Platform$Sub$map,
								$author$project$Components$Invoice$AuditTrailLogMsg,
								$author$project$Components$AuditTrailLog$subscriptions(auditTrailLog))) : $elm$core$Maybe$Nothing;
					},
					model.iw))
			]));
};
var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$subscriptions = function (model) {
	var _v0 = model.gA;
	if (!_v0.$) {
		var invoiceComponent = _v0.a;
		return A2(
			$elm$core$Platform$Sub$map,
			$author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$InvoiceComponentMsg,
			$author$project$Components$Invoice$subscriptions(invoiceComponent));
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Components$Invoice$Affiliate = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Invoice$ProviderMin = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Affiliate$One$company = function (_v0) {
	var record = _v0.b;
	return record.afQ;
};
var $author$project$Components$Invoice$DropdownMenuMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Invoice$Model = $elm$core$Basics$identity;
var $author$project$Api$Feature$VirtualBankAccount = 11;
var $author$project$Components$Invoice$VirtualBankAccountsComponentMsg = function (a) {
	return {$: 37, a: a};
};
var $author$project$Api$Provider$Company$Min$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Components$Company$VirtualBankAccounts$Invoice$Model = $elm$core$Basics$identity;
var $author$project$Components$Company$VirtualBankAccounts$Invoice$GotVirtualBankAccounts = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$VirtualBankAccount$EmployerAll = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$VirtualBankAccount$ProviderAll = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$VirtualBankAccount$Shared$VirtualBankAccount = $elm$core$Basics$identity;
var $author$project$Api$Employer$VirtualBankAccount$Shared$Record = function (id) {
	return function (abaBankName) {
		return function (abaAccountNumber) {
			return function (abaRoutingtNumber) {
				return function (contactEmail) {
					return function (swiftAccountNumber) {
						return function (swiftCode) {
							return function (swiftBankName) {
								return function (balanceInCents) {
									return function (createdAt) {
										return {Ku: abaAccountNumber, Kv: abaBankName, Kw: abaRoutingtNumber, afa: balanceInCents, Ow: contactEmail, O1: createdAt, ahP: id, alQ: swiftAccountNumber, alR: swiftBankName, acG: swiftCode};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Employer$VirtualBankAccount$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'created_at',
	$elm_community$json_extra$Json$Decode$Extra$datetime,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'balance_in_cents',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'swift_bank_name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'swift_code',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'swift_account_number',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'contact_email',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'aba_routing_number',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'aba_account_number',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'aba_bank_name',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Api$Employer$VirtualBankAccount$Shared$Record)))))))))));
var $author$project$Api$Employer$VirtualBankAccount$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$VirtualBankAccount$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$VirtualBankAccount$virtualBankAccountsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['virtual_bank_accounts']),
	$author$project$Api$Data$employerPath);
var $author$project$Api$Employer$VirtualBankAccount$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Employer$VirtualBankAccount$Shared$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Employer$VirtualBankAccount$virtualBankAccountsPath));
	});
var $author$project$Api$Provider$VirtualBankAccount$Shared$VirtualBankAccount = $elm$core$Basics$identity;
var $author$project$Api$Provider$VirtualBankAccount$Shared$Record = function (id) {
	return function (abaBankName) {
		return function (abaAccountNumber) {
			return function (abaRoutingtNumber) {
				return function (contactEmail) {
					return function (swiftAccountNumber) {
						return function (swiftCode) {
							return function (swiftBankName) {
								return function (balanceInCents) {
									return function (createdAt) {
										return {Ku: abaAccountNumber, Kv: abaBankName, Kw: abaRoutingtNumber, afa: balanceInCents, Ow: contactEmail, O1: createdAt, ahP: id, alQ: swiftAccountNumber, alR: swiftBankName, acG: swiftCode};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$VirtualBankAccount$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'created_at',
	$elm_community$json_extra$Json$Decode$Extra$datetime,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'balance_in_cents',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'swift_bank_name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'swift_code',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'swift_account_number',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'contact_email',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'aba_routing_number',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'aba_account_number',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'aba_bank_name',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Api$Provider$VirtualBankAccount$Shared$Record)))))))))));
var $author$project$Api$Provider$VirtualBankAccount$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$VirtualBankAccount$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$VirtualBankAccount$virtualBankAccountsPath = function (companyId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['virtual_bank_accounts']),
		A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[companyId]),
			A2(
				$author$project$Api$Data$pathAppend,
				_List_fromArray(
					['companies']),
				$author$project$Api$Data$providerPath)));
};
var $author$project$Api$Provider$VirtualBankAccount$list = F3(
	function (apiClient, companyId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$VirtualBankAccount$Shared$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$VirtualBankAccount$virtualBankAccountsPath(companyId)));
	});
var $author$project$Api$VirtualBankAccount$list = F4(
	function (session, apiClient, companyId, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A2(
			$author$project$Api$Employer$VirtualBankAccount$list,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$VirtualBankAccount$EmployerAll)))) : A3(
			$author$project$Api$Provider$VirtualBankAccount$list,
			apiClient,
			companyId,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$VirtualBankAccount$ProviderAll))));
	});
var $author$project$Components$Company$VirtualBankAccounts$Invoice$loadData = F3(
	function (session, apiClient, companyId) {
		return _Utils_Tuple2(
			$author$project$Api$Data$Loading,
			A4($author$project$Api$VirtualBankAccount$list, session, apiClient, companyId, $author$project$Components$Company$VirtualBankAccounts$Invoice$GotVirtualBankAccounts));
	});
var $author$project$Components$Company$VirtualBankAccounts$Invoice$init = F4(
	function (companyId, session, practice, _v0) {
		var apiClient = _v0.Gv;
		var hinterViewOff = _v0.ahK;
		var _v1 = A3($author$project$Components$Company$VirtualBankAccounts$Invoice$loadData, session, apiClient, companyId);
		var virtualBankAccounts = _v1.a;
		var cmd = _v1.b;
		return _Utils_Tuple2(
			{Mx: false, fZ: companyId, ahK: hinterViewOff, ZV: practice, aa4: session, F7: virtualBankAccounts},
			cmd);
	});
var $author$project$Components$Invoice$InvoiceDateInputMsg = F2(
	function (a, b) {
		return {$: 30, a: a, b: b};
	});
var $author$project$Components$Invoice$InvoiceDueDateInputMsg = F2(
	function (a, b) {
		return {$: 32, a: a, b: b};
	});
var $author$project$Components$Invoice$initFormFields = function (today) {
	var _v0 = $author$project$Components$DateInput$init;
	var invoiceDateInput = _v0.a;
	var invoiceDateInputCmd = _v0.b;
	return _Utils_Tuple2(
		{Uq: today, n3: invoiceDateInput, j_: today, n4: invoiceDateInput},
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Cmd$map,
				$author$project$Components$Invoice$InvoiceDateInputMsg(invoiceDateInput),
				invoiceDateInputCmd),
				A2(
				$elm$core$Platform$Cmd$map,
				$author$project$Components$Invoice$InvoiceDueDateInputMsg(invoiceDateInput),
				invoiceDateInputCmd)
			]));
};
var $author$project$Api$Provider$AffiliateBill$affiliateBillPath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		$author$project$Api$Provider$AffiliateBill$affiliateBillsPath);
};
var $author$project$Api$Employer$Invoice$invoicesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['invoices']),
	$author$project$Api$Data$employerPath);
var $author$project$Api$Employer$Invoice$invoicePath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		$author$project$Api$Employer$Invoice$invoicesPath);
};
var $author$project$Api$Provider$Company$Invoice$invoicesPath = function (companyId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['invoices']),
		$author$project$Api$Provider$Company$companyPath(companyId));
};
var $author$project$Api$Provider$Company$Invoice$invoicePath = F2(
	function (companyId, id) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id]),
			$author$project$Api$Provider$Company$Invoice$invoicesPath(companyId));
	});
var $author$project$Api$Company$Invoice$invoicePath = F3(
	function (session, companyId, id) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $author$project$Api$Employer$Invoice$invoicePath(id) : A2($author$project$Api$Provider$Company$Invoice$invoicePath, companyId, id);
	});
var $author$project$Components$Invoice$paymentsBasePath = F2(
	function (session, invoiceType) {
		if (!invoiceType.$) {
			var id = invoiceType.b;
			return $author$project$Api$Provider$AffiliateBill$affiliateBillPath(id);
		} else {
			var companyId = invoiceType.a;
			var id = invoiceType.b;
			return A3($author$project$Api$Company$Invoice$invoicePath, session, companyId, id);
		}
	});
var $author$project$Components$Invoice$GotIntegrationRecords = function (a) {
	return {$: 38, a: a};
};
var $author$project$Api$Provider$IntegrationRecord$All$IntegrationRecord = $elm$core$Basics$identity;
var $author$project$Api$Provider$IntegrationRecord$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$IntegrationRecord$One$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Company$Invoice$integrationRecords = F5(
	function (apiClient, session, companyId, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$IntegrationRecord$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['integration_records']),
					A3($author$project$Api$Company$Invoice$invoicePath, session, companyId, id_))));
	});
var $author$project$Components$Invoice$retrieveIntegrationRecords = F4(
	function (isHintAdmin, apiClient, session, invoiceType) {
		var _v0 = _Utils_Tuple2(isHintAdmin, invoiceType);
		if (_v0.a && (_v0.b.$ === 1)) {
			var _v1 = _v0.b;
			var companyId = _v1.a;
			var id = _v1.b;
			return A5($author$project$Api$Company$Invoice$integrationRecords, apiClient, session, companyId, id, $author$project$Components$Invoice$GotIntegrationRecords);
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Components$Invoice$GotCompanyInvoice = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Invoice$One$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Invoice$One$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Employer$Invoice$One$Invoice = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Employer$Invoice$Shared$Invoice = $elm$core$Basics$identity;
var $author$project$Api$Employer$Invoice$Shared$Record = function (id) {
	return function (invoiceDate) {
		return function (invoiceNumber) {
			return function (humanStatus) {
				return function (amountInCents) {
					return function (paidAt) {
						return function (paidInCents) {
							return function (dueDate) {
								return function (dueInCents) {
									return function (description) {
										return {LE: amountInCents, Qr: description, QX: dueDate, QY: dueInCents, TH: humanStatus, ahP: id, Uq: invoiceDate, Uu: invoiceNumber, YH: paidAt, YI: paidInCents};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Employer$Invoice$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'description',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'due_in_cents',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'due_date',
			$author$project$Utils$Date$decode,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'paid_in_cents',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'paid_at',
					$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'amount_in_cents',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'human_status',
							$author$project$Api$Invoice$Status$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'invoice_number',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'invoice_date',
									$author$project$Utils$Date$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Api$Employer$Invoice$Shared$Record)))))))))));
var $author$project$Api$Employer$Invoice$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Invoice$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Invoice$One$Record = function (willAutoPay) {
	return function (autoPayDate) {
		return function (isPayable) {
			return function (discountSavingsInCents) {
				return function (securePdfInlineToken) {
					return function (securePdfWithChargeDetailsToken) {
						return function (source) {
							return function (payments) {
								return function (meta) {
									return function (recurring) {
										return {Mi: autoPayDate, QH: discountSavingsInCents, U2: isPayable, W4: meta, Zi: payments, $g: recurring, aaE: securePdfInlineToken, aaF: securePdfWithChargeDetailsToken, JQ: source, aeB: willAutoPay};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Employer$Invoice$Meta$Meta = $elm$core$Basics$identity;
var $author$project$Api$Employer$Invoice$Meta$Record = F2(
	function (actions, reportingPeriodIsLocked) {
		return {vy: actions, $y: reportingPeriodIsLocked};
	});
var $author$project$Api$Employer$Invoice$Meta$ActionsRecord = F6(
	function (canCancel, createPayment, markAsPaid, issue, canAdjust, hideChargeDetails) {
		return {M3: canAdjust, M4: canCancel, O_: createPayment, Tr: hideChargeDetails, Vm: issue, Wv: markAsPaid};
	});
var $author$project$Api$Employer$Invoice$Meta$actionsRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'hide_charge_details',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'can_adjust',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'issue',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'mark_as_paid',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'create_payment',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'can_cancel',
						$elm$json$Json$Decode$bool,
						$elm$json$Json$Decode$succeed($author$project$Api$Employer$Invoice$Meta$ActionsRecord)))))));
var $author$project$Api$Employer$Invoice$Meta$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'reporting_period_is_locked',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'actions',
		$author$project$Api$Employer$Invoice$Meta$actionsRecordDecoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$Invoice$Meta$Record)));
var $author$project$Api$Employer$Invoice$Meta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Invoice$Meta$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Invoice$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'recurring',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'meta',
		$author$project$Api$Employer$Invoice$Meta$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'payments',
			$elm$json$Json$Decode$list($author$project$Api$Employer$Payment$One$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'source',
				$elm$json$Json$Decode$nullable($author$project$Api$Common$Source$Shared$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'secure_pdf_with_charge_details_token',
					$author$project$Api$File$Token$decoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'secure_pdf_inline_token',
						$author$project$Api$File$Token$decoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'discount_savings_in_cents',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'is_payable',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'auto_pay_date',
									$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'will_auto_pay',
										$elm$json$Json$Decode$bool,
										$elm$json$Json$Decode$succeed($author$project$Api$Employer$Invoice$One$Record)))))))))));
var $author$project$Api$Employer$Invoice$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Invoice$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Employer$Invoice$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$Invoice$One$Invoice)));
var $author$project$Api$Employer$Invoice$retrieve = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Employer$Invoice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Employer$Invoice$invoicePath(id)));
	});
var $author$project$Api$Provider$Invoice$One$Invoice = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Invoice$One$Record = function (willAutoPay) {
	return function (autoPayDate) {
		return function (securePdfInlineToken) {
			return function (securePdfWithChargeDetailsToken) {
				return function (viewingAsAffiliate) {
					return function (isUpdating) {
						return function (isPayable) {
							return function (periodInMonths) {
								return function (discountSavingsInCents) {
									return function (source) {
										return function (payments) {
											return function (meta) {
												return function (recurring) {
													return function (createdAt) {
														return {Mi: autoPayDate, O1: createdAt, QH: discountSavingsInCents, U2: isPayable, Vl: isUpdating, W4: meta, Zi: payments, Zs: periodInMonths, $g: recurring, aaE: securePdfInlineToken, aaF: securePdfWithChargeDetailsToken, JQ: source, aei: viewingAsAffiliate, aeB: willAutoPay};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Invoice$Meta$Meta = $elm$core$Basics$identity;
var $author$project$Api$Provider$Invoice$Meta$Record = F2(
	function (actions, reportingPeriodIsLocked) {
		return {vy: actions, $y: reportingPeriodIsLocked};
	});
var $author$project$Api$Provider$Invoice$Meta$ActionsRecord = function (canCancel) {
	return function (canDraftAndDestroyCurrentDraft) {
		return function (canMarkAsBadDebt) {
			return function (canReverseBadDebt) {
				return function (issue) {
					return function (canMakeViewable) {
						return function (canNotify) {
							return function (createPayment) {
								return function (markAsPaid) {
									return function (canAdjust) {
										return function (canDelete) {
											return {M3: canAdjust, M4: canCancel, M5: canDelete, M7: canDraftAndDestroyCurrentDraft, Nd: canMakeViewable, Ne: canMarkAsBadDebt, Nf: canNotify, Nh: canReverseBadDebt, O_: createPayment, Vm: issue, Wv: markAsPaid};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Invoice$Meta$actionsRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'can_delete',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'can_adjust',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'mark_as_paid',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'create_payment',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'can_notify',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'can_make_viewable',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'issue',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'can_reverse_bad_debt',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'can_mark_as_bad_debt',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'can_draft_and_destroy_current_draft',
										$elm$json$Json$Decode$bool,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'can_cancel',
											$elm$json$Json$Decode$bool,
											$elm$json$Json$Decode$succeed($author$project$Api$Provider$Invoice$Meta$ActionsRecord))))))))))));
var $author$project$Api$Provider$Invoice$Meta$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'reporting_period_is_locked',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'actions',
		$author$project$Api$Provider$Invoice$Meta$actionsRecordDecoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Invoice$Meta$Record)));
var $author$project$Api$Provider$Invoice$Meta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Invoice$Meta$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Payment$SharedWithRefunds$Payment = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Payment$SharedWithRefunds$Record = F2(
	function (refunds, dispute) {
		return {QL: dispute, $n: refunds};
	});
var $author$project$Api$Provider$Payment$SharedWithRefunds$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'dispute',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Dispute$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'refunds',
		$elm$json$Json$Decode$list($author$project$Api$Provider$Refund$Shared$decoder),
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Payment$SharedWithRefunds$Record)));
var $author$project$Api$Provider$Payment$SharedWithRefunds$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Payment$SharedWithRefunds$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Payment$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Payment$SharedWithRefunds$Payment)));
var $author$project$Api$Provider$Invoice$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'created_at',
	$elm_community$json_extra$Json$Decode$Extra$datetime,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'recurring',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'meta',
			$author$project$Api$Provider$Invoice$Meta$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'payments',
				$elm$json$Json$Decode$list($author$project$Api$Provider$Payment$SharedWithRefunds$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'source',
					$elm$json$Json$Decode$nullable($author$project$Api$Common$Source$Shared$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'discount_savings_in_cents',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'period_in_months',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'is_payable',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'is_updating',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'viewing_as_affiliate',
										$elm$json$Json$Decode$bool,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'secure_pdf_with_charge_details_token',
											$author$project$Api$File$Token$decoder,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'secure_pdf_inline_token',
												$author$project$Api$File$Token$decoder,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'auto_pay_date',
													$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'will_auto_pay',
														$elm$json$Json$Decode$bool,
														$elm$json$Json$Decode$succeed($author$project$Api$Provider$Invoice$One$Record)))))))))))))));
var $author$project$Api$Provider$Invoice$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Invoice$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Invoice$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Invoice$One$Invoice)));
var $author$project$Api$Provider$Company$Invoice$retrieve = F4(
	function (apiClient, companyId, id, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Invoice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Provider$Company$Invoice$invoicePath, companyId, id)));
	});
var $author$project$Api$Company$Invoice$retrieve = F5(
	function (apiClient, session, companyId, id, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$Invoice$retrieve,
			apiClient,
			id,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Invoice$One$Employer))) : A4(
			$author$project$Api$Provider$Company$Invoice$retrieve,
			apiClient,
			companyId,
			id,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Invoice$One$Provider)));
	});
var $author$project$Api$Provider$AffiliateBill$retrieve = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Invoice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$AffiliateBill$affiliateBillPath(id)));
	});
var $author$project$Components$Invoice$retrieveInvoice = F3(
	function (apiClient, session, invoiceType) {
		if (!invoiceType.$) {
			var id = invoiceType.b;
			return A3(
				$author$project$Api$Provider$AffiliateBill$retrieve,
				apiClient,
				id,
				A2(
					$elm$core$Basics$composeL,
					$author$project$Components$Invoice$GotCompanyInvoice,
					$author$project$Api$Data$map($author$project$Api$Invoice$One$Provider)));
		} else {
			var companyId = invoiceType.a;
			var id = invoiceType.b;
			return A5($author$project$Api$Company$Invoice$retrieve, apiClient, session, companyId, id, $author$project$Components$Invoice$GotCompanyInvoice);
		}
	});
var $author$project$Components$Invoice$init = function (config) {
	var practice = config.ZV;
	var _v0 = function () {
		var _v1 = _Utils_Tuple2(
			config.afQ,
			A2($author$project$Api$Practice$featureEnabled, 11, practice));
		if ((!_v1.a.$) && _v1.b) {
			var company = _v1.a.a;
			var companyId = function () {
				if (!company.$) {
					var company_ = company.a;
					return $author$project$Api$Provider$Company$Min$id(company_);
				} else {
					var company_ = company.a;
					return $author$project$Api$Company$id(company_);
				}
			}();
			var _v2 = A4($author$project$Components$Company$VirtualBankAccounts$Invoice$init, companyId, config.aa4, practice, config.lk);
			var model_ = _v2.a;
			var cmd_ = _v2.b;
			return _Utils_Tuple2(
				$elm$core$Maybe$Just(model_),
				A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$VirtualBankAccountsComponentMsg, cmd_));
		} else {
			return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
		}
	}();
	var virtualBankAccountModel = _v0.a;
	var virtualBankAccountCmd = _v0.b;
	var _v4 = $author$project$Components$Invoice$initFormFields(config.lk.dd);
	var fields = _v4.a;
	return _Utils_Tuple2(
		{
			cY: $author$project$Utils$Form$init(fields),
			mn: config.mn,
			iw: $elm$core$Maybe$Nothing,
			afQ: config.afQ,
			iM: $elm$core$Maybe$Nothing,
			m$: $elm$core$Maybe$Nothing,
			dd: config.lk.dd,
			i9: $elm$core$Maybe$Nothing,
			jt: $author$project$Components$Invoice$DownloadFile$init(config.lk.adY),
			no: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$toTopRight(
					$author$project$Ui$Dropdown$defaultConfig(
						{ahP: 'invoice-actions-dropdown-menu', al6: $author$project$Components$Invoice$DropdownMenuMsg}))),
			Ub: $author$project$Api$Data$Loading,
			Uk: $author$project$Api$Data$Loading,
			Aj: $elm$core$Maybe$Nothing,
			eB: $elm$core$Maybe$Nothing,
			gB: $elm$core$Maybe$Nothing,
			Uv: config.Uv,
			Ij: $author$project$Shared$isHintAdmin(config.lk),
			Is: config.Is,
			eJ: $elm$core$Maybe$Nothing,
			tN: config.tN,
			kC: A4(
				$author$project$Components$Invoice$PaymentsHistory$init,
				config.lk.J7,
				A2($author$project$Components$Invoice$paymentsBasePath, config.aa4, config.Uv),
				config.aa4,
				true),
			ZV: practice,
			t9: config.lk.t9,
			e7: $elm$core$Maybe$Nothing,
			k9: $author$project$Api$Data$NotAsked,
			aa4: config.aa4,
			p4: false,
			p5: false,
			p6: false,
			J7: config.lk.J7,
			adY: config.lk.adY,
			vo: virtualBankAccountModel,
			vp: $elm$core$Maybe$Nothing
		},
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A3($author$project$Components$Invoice$retrieveInvoice, config.Gv, config.aa4, config.Uv),
					virtualBankAccountCmd,
					A4(
					$author$project$Components$Invoice$retrieveIntegrationRecords,
					$author$project$Shared$isHintAdmin(config.lk),
					config.Gv,
					config.aa4,
					config.Uv)
				])));
};
var $author$project$Components$Invoice$Summary$Affiliate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Invoice$Summary$Company = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Invoice$GotSummary = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Invoice$InvoiceDate = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Invoice$InvoiceDueDate = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Api$Common$Invoice$Summary$allLines = function (_v0) {
	var record = _v0;
	return record.Lq;
};
var $author$project$Api$Common$Invoice$Summary$AllLines$count = function (_v0) {
	var record = _v0;
	return A2($elm$core$Maybe$withDefault, 0, record.FW.OK);
};
var $author$project$Api$Provider$Invoice$One$createdAt = function (_v0) {
	var record = _v0.b;
	return record.O1;
};
var $author$project$Api$Invoice$One$createdAt = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $elm$core$Maybe$Just(
			$author$project$Api$Provider$Invoice$One$createdAt(invoice_));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Invoice$Deleted = F2(
	function (a, b) {
		return {$: 19, a: a, b: b};
	});
var $author$project$Api$Provider$Company$Invoice$delete = F4(
	function (apiClient, companyId, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Provider$Company$Invoice$invoicePath, companyId, id)));
	});
var $author$project$Api$Company$Invoice$delete = F5(
	function (apiClient, session, companyId, id, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : A4($author$project$Api$Provider$Company$Invoice$delete, apiClient, companyId, id, toMsg);
	});
var $author$project$Api$Provider$AffiliateBill$delete = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$AffiliateBill$affiliateBillPath(id)));
	});
var $author$project$Components$Invoice$delete = F4(
	function (apiClient, session, invoiceType, invoice) {
		if (!invoiceType.$) {
			var id = invoiceType.b;
			return A3(
				$author$project$Api$Provider$AffiliateBill$delete,
				apiClient,
				id,
				$author$project$Components$Invoice$Deleted(invoice));
		} else {
			var companyId = invoiceType.a;
			var id = invoiceType.b;
			return A5(
				$author$project$Api$Company$Invoice$delete,
				apiClient,
				session,
				companyId,
				id,
				$author$project$Components$Invoice$Deleted(invoice));
		}
	});
var $author$project$Api$Employer$Invoice$Shared$dueDate = function (_v0) {
	var record = _v0;
	return record.QX;
};
var $author$project$Api$Employer$Invoice$One$dueDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Invoice$Shared$dueDate(shared);
};
var $author$project$Api$Provider$Invoice$Shared$dueDate = function (_v0) {
	var record = _v0.b;
	return record.QX;
};
var $author$project$Api$Provider$Invoice$One$dueDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Invoice$Shared$dueDate(shared);
};
var $author$project$Api$Invoice$One$dueDate = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$One$dueDate(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$One$dueDate(invoice_);
	}
};
var $author$project$Api$Provider$Invoice$One$date = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Invoice$Shared$invoiceDate(shared);
};
var $author$project$Api$Employer$Invoice$Shared$invoiceDate = function (_v0) {
	var record = _v0;
	return record.Uq;
};
var $author$project$Api$Employer$Invoice$One$invoiceDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Invoice$Shared$invoiceDate(shared);
};
var $author$project$Api$Invoice$One$invoiceDate = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$One$date(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$One$invoiceDate(invoice_);
	}
};
var $author$project$Components$Invoice$formFieldsFromInvoice = function (invoice) {
	var _v0 = $author$project$Components$DateInput$init;
	var invoiceDateInput = _v0.a;
	var invoiceDateInputCmd = _v0.b;
	return _Utils_Tuple2(
		{
			Uq: $author$project$Api$Invoice$One$invoiceDate(invoice),
			n3: invoiceDateInput,
			j_: $author$project$Api$Invoice$One$dueDate(invoice),
			n4: invoiceDateInput
		},
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Cmd$map,
				$author$project$Components$Invoice$InvoiceDateInputMsg(invoiceDateInput),
				invoiceDateInputCmd),
				A2(
				$elm$core$Platform$Cmd$map,
				$author$project$Components$Invoice$InvoiceDueDateInputMsg(invoiceDateInput),
				invoiceDateInputCmd)
			]));
};
var $author$project$Components$AuditTrailLog$PopoverMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$AuditTrailLog$init = F7(
	function (session, url, timeFormatter, resource, resourceId, resourceCreatedAt, filter) {
		return {
			ro: $author$project$Api$Data$Loading,
			HM: filter,
			ajJ: $author$project$Api$Pagination$init,
			aT: A3($author$project$Ui$Popover$init, 'audit-history', false, $author$project$Components$AuditTrailLog$PopoverMsg),
			Jy: resource,
			Eg: resourceCreatedAt,
			Jz: resourceId,
			aa4: session,
			cU: _List_Nil,
			J7: timeFormatter,
			FV: 0,
			adY: url
		};
	});
var $author$project$Api$Provider$Report$AffiliateBillLine = 5;
var $author$project$Components$Invoice$InvoiceLinesTable$EmployeeDivisionDropdownMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$GotEmployeeDivisions = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Report$InvoiceLine = 4;
var $author$project$Api$Employer$Company$Shared$allowCustomMembershipPlan = function (_v0) {
	var record = _v0;
	return record.Lv;
};
var $author$project$Api$Employer$Company$One$allowCustomMembershipPlan = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Company$Shared$allowCustomMembershipPlan(shared);
};
var $author$project$Api$Provider$Company$Shared$allowCustomMembershipPlan = function (_v0) {
	var record = _v0;
	return record.Lv;
};
var $author$project$Api$Provider$Company$One$allowCustomMembershipPlan = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$allowCustomMembershipPlan(shared);
};
var $author$project$Api$Company$allowCustomMembershipPlan = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$allowCustomMembershipPlan(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$allowCustomMembershipPlan(company_);
	}
};
var $author$project$Components$Invoice$InvoiceLinesTable$allowCustomMembershipPlan = function (company) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (company_) {
				if (!company_.$) {
					return false;
				} else {
					var company__ = company_.a;
					return $author$project$Api$Company$allowCustomMembershipPlan(company__);
				}
			},
			company));
};
var $author$project$Components$Invoice$InvoiceLinesTable$companyId = function (company) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function (company_) {
				if (!company_.$) {
					var company__ = company_.a;
					return $author$project$Api$Provider$Company$Min$id(company__);
				} else {
					var company__ = company_.a;
					return $author$project$Api$Company$id(company__);
				}
			},
			company));
};
var $author$project$Components$Invoice$InvoiceLinesTable$GotInvoiceLines = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$EmployeeDivision$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Employer$EmployeeDivision$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$EmployeeDivision$Shared$id(shared);
};
var $author$project$Api$Provider$EmployeeDivision$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$EmployeeDivision$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$EmployeeDivision$Shared$id(shared);
};
var $author$project$Api$EmployeeDivision$All$id = function (employeeDivision) {
	if (!employeeDivision.$) {
		var employeeDivision_ = employeeDivision.a;
		return $author$project$Api$Provider$EmployeeDivision$All$id(employeeDivision_);
	} else {
		var employeeDivision_ = employeeDivision.a;
		return $author$project$Api$Employer$EmployeeDivision$All$id(employeeDivision_);
	}
};
var $author$project$Api$Provider$InvoiceLine$All$InvoiceLine = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$InvoiceLine$Shared$InvoiceLine = $elm$core$Basics$identity;
var $author$project$Api$Provider$InvoiceLine$Shared$Record = F3(
	function (id, date, amountInCents) {
		return {LE: amountInCents, PB: date, ahP: id};
	});
var $author$project$Api$Provider$InvoiceLine$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'amount_in_cents',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'date',
		$author$project$Utils$Date$decode,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$InvoiceLine$Shared$Record))));
var $author$project$Api$Provider$InvoiceLine$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$InvoiceLine$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$InvoiceLine$All$Record = function (endDate) {
	return function (patientName) {
		return function (dependentCount) {
			return function (chargeDescription) {
				return function (categoryName) {
					return function (shouldHideAmount) {
						return function (shouldShowMoreInfo) {
							return function (employeeDivision) {
								return function (plan) {
									return function (charges) {
										return function (createdBy) {
											return {Ns: categoryName, Nw: chargeDescription, NA: charges, O2: createdBy, Ql: dependentCount, HA: employeeDivision, sb: endDate, Y1: patientName, Jb: plan, abi: shouldHideAmount, abj: shouldShowMoreInfo};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Charge$ForInvoiceLineAll$Charge = $elm$core$Basics$identity;
var $author$project$Api$Provider$Charge$ForInvoiceLineAll$Record = F2(
	function (isLocked, meta) {
		return {UU: isLocked, W4: meta};
	});
var $author$project$Api$Provider$Charge$Meta$Meta = $elm$core$Basics$identity;
var $author$project$Api$Provider$Charge$Meta$Record = function (patient) {
	return function (name) {
		return function (quantity) {
			return function (quantityUom) {
				return function (priceInCents) {
					return function (category) {
						return function (description) {
							return function (practitioner) {
								return function (date) {
									return function (endDate) {
										return function (location) {
											return function (actions) {
												return {vy: actions, GW: category, PB: date, Qr: description, sb: endDate, ais: location, Bq: name, YY: patient, aka: practitioner, Dw: priceInCents, Dz: quantity, DA: quantityUom};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Charge$Meta$ActionsRecord = F3(
	function (edit, destroy, revisable) {
		return {Qu: destroy, Q0: edit, $4: revisable};
	});
var $author$project$Api$Provider$Charge$Meta$actionsRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'revisable',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'destroy',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'edit',
			$elm$json$Json$Decode$bool,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Charge$Meta$ActionsRecord))));
var $author$project$Api$Provider$Charge$Meta$EditableRecord = function (editable) {
	return {Q4: editable};
};
var $author$project$Api$Provider$Charge$Meta$editableRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'editable',
	$elm$json$Json$Decode$bool,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Charge$Meta$EditableRecord));
var $author$project$Api$Provider$Charge$Meta$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'actions',
	$author$project$Api$Provider$Charge$Meta$actionsRecordDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'location',
		$author$project$Api$Provider$Charge$Meta$editableRecordDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'end_date',
			$author$project$Api$Provider$Charge$Meta$editableRecordDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'date',
				$author$project$Api$Provider$Charge$Meta$editableRecordDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'practitioner',
					$author$project$Api$Provider$Charge$Meta$editableRecordDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'description',
						$author$project$Api$Provider$Charge$Meta$editableRecordDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'category',
							$author$project$Api$Provider$Charge$Meta$editableRecordDecoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'price_in_cents',
								$author$project$Api$Provider$Charge$Meta$editableRecordDecoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'quantity_uom',
									$author$project$Api$Provider$Charge$Meta$editableRecordDecoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'quantity',
										$author$project$Api$Provider$Charge$Meta$editableRecordDecoder,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'name',
											$author$project$Api$Provider$Charge$Meta$editableRecordDecoder,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'patient',
												$author$project$Api$Provider$Charge$Meta$editableRecordDecoder,
												$elm$json$Json$Decode$succeed($author$project$Api$Provider$Charge$Meta$Record)))))))))))));
var $author$project$Api$Provider$Charge$Meta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Charge$Meta$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Charge$ForInvoiceLineAll$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'meta',
	$author$project$Api$Provider$Charge$Meta$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'is_locked',
		$elm$json$Json$Decode$bool,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Charge$ForInvoiceLineAll$Record)));
var $author$project$Api$Provider$Charge$ForInvoiceLineAll$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Charge$ForInvoiceLineAll$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$EmployeeDivision$Shared$EmployeeDivision = $elm$core$Basics$identity;
var $author$project$Api$Provider$EmployeeDivision$Shared$Record = F2(
	function (id, name) {
		return {ahP: id, Bq: name};
	});
var $author$project$Api$Provider$EmployeeDivision$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$EmployeeDivision$Shared$Record)));
var $author$project$Api$Provider$EmployeeDivision$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$EmployeeDivision$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Session$Shared$Session = $elm$core$Basics$identity;
var $author$project$Api$Provider$Session$Shared$Record = F2(
	function (user, organization) {
		return {Yr: organization, ad0: user};
	});
var $author$project$Api$Provider$Session$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'organization',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Organization$Min$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'user',
		$author$project$Api$Provider$User$Min$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Session$Shared$Record)));
var $author$project$Api$Provider$Session$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Session$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$InvoiceLine$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'created_by',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Session$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'charges',
		$elm$json$Json$Decode$list($author$project$Api$Provider$Charge$ForInvoiceLineAll$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'plan',
			$elm$json$Json$Decode$nullable($author$project$Api$Provider$Plan$Shared$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'employee_division',
				$elm$json$Json$Decode$nullable($author$project$Api$Provider$EmployeeDivision$Shared$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'should_show_more_info',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'should_hide_amount',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'category_name',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'charge_description',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'dependent_count',
									$elm$json$Json$Decode$int,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'patient_name',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'end_date',
											$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
											$elm$json$Json$Decode$succeed($author$project$Api$Provider$InvoiceLine$All$Record))))))))))));
var $author$project$Api$Provider$InvoiceLine$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$InvoiceLine$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$InvoiceLine$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$InvoiceLine$All$InvoiceLine)));
var $author$project$Api$Employer$Invoice$InvoiceLine$invoiceLinesPath = function (invoiceId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['invoice_lines']),
		$author$project$Api$Employer$Invoice$invoicePath(invoiceId));
};
var $author$project$Api$Common$InvoiceLine$ListOptionals$defaults = {GW: $elm$core$Maybe$Nothing, HA: $elm$core$Maybe$Nothing, ajJ: $author$project$Api$Pagination$init, Jb: $elm$core$Maybe$Nothing, akl: $elm$core$Maybe$Nothing, alA: $author$project$Api$Sort$init};
var $author$project$Api$Common$InvoiceLine$ListOptionals$toParams = function (optionals) {
	var options = optionals($author$project$Api$Common$InvoiceLine$ListOptionals$defaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.akl;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.GW;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'category', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.Jb;
				if (!_v2.$) {
					var string = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'plan', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v3 = options.HA;
				if (!_v3.$) {
					var string = _v3.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'employee_division', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Pagination$toApiParams(options.ajJ),
				$author$project$Api$Sort$toParams(options.alA)
			]));
};
var $author$project$Api$Employer$Invoice$InvoiceLine$list = F4(
	function (apiClient, invoiceId, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$InvoiceLine$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Common$InvoiceLine$ListOptionals$toParams(optionals),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Employer$Invoice$InvoiceLine$invoiceLinesPath(invoiceId))));
	});
var $author$project$Api$Provider$Company$Invoice$InvoiceLine$invoiceLinesPath = F2(
	function (companyId, invoiceId) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				['invoice_lines']),
			A2($author$project$Api$Provider$Company$Invoice$invoicePath, companyId, invoiceId));
	});
var $author$project$Api$Provider$Company$Invoice$InvoiceLine$list = F5(
	function (apiClient, companyId, invoiceId, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$InvoiceLine$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Common$InvoiceLine$ListOptionals$toParams(optionals),
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Provider$Company$Invoice$InvoiceLine$invoiceLinesPath, companyId, invoiceId))));
	});
var $author$project$Api$Company$Invoice$InvoiceLine$list = F6(
	function (apiClient, session, companyId, invoiceId, optionals, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4($author$project$Api$Employer$Invoice$InvoiceLine$list, apiClient, invoiceId, optionals, toMsg) : A5($author$project$Api$Provider$Company$Invoice$InvoiceLine$list, apiClient, companyId, invoiceId, optionals, toMsg);
	});
var $author$project$Api$Provider$AffiliateBill$InvoiceLine$invoiceLinesPath = function (affiliateBillId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['invoice_lines']),
		$author$project$Api$Provider$AffiliateBill$affiliateBillPath(affiliateBillId));
};
var $author$project$Api$Provider$AffiliateBill$InvoiceLine$list = F4(
	function (apiClient, affiliateBillId, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$InvoiceLine$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Common$InvoiceLine$ListOptionals$toParams(optionals),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$AffiliateBill$InvoiceLine$invoiceLinesPath(affiliateBillId))));
	});
var $author$project$Components$Invoice$InvoiceLinesTable$fetchInvoiceLines = F2(
	function (apiClient, model) {
		var list = function () {
			var _v0 = model.Uv;
			if (_v0.$ === 1) {
				var companyId_ = _v0.a;
				var id = _v0.b;
				return A4($author$project$Api$Company$Invoice$InvoiceLine$list, apiClient, model.aa4, companyId_, id);
			} else {
				var id = _v0.b;
				return A2($author$project$Api$Provider$AffiliateBill$InvoiceLine$list, apiClient, id);
			}
		}();
		return A2(
			list,
			function (d) {
				return _Utils_update(
					d,
					{
						GW: model.iF,
						HA: A2($elm$core$Maybe$map, $author$project$Api$EmployeeDivision$All$id, model.HA),
						ajJ: model.ajJ,
						Jb: model.aj4,
						akl: model.akl,
						alA: model.alA
					});
			},
			$author$project$Components$Invoice$InvoiceLinesTable$GotInvoiceLines);
	});
var $author$project$Api$EmployeeDivision$All$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$EmployeeDivision$All$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$EmployeeDivision$All$EmployeeDivision = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Employer$EmployeeDivision$Shared$EmployeeDivision = $elm$core$Basics$identity;
var $author$project$Api$Employer$EmployeeDivision$Shared$Record = F2(
	function (id, name) {
		return {ahP: id, Bq: name};
	});
var $author$project$Api$Employer$EmployeeDivision$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$EmployeeDivision$Shared$Record)));
var $author$project$Api$Employer$EmployeeDivision$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$EmployeeDivision$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$EmployeeDivision$All$Record = F3(
	function (assignedAccounts, eligibleAccounts, enrolledAccounts) {
		return {L$: assignedAccounts, Rh: eligibleAccounts, RB: enrolledAccounts};
	});
var $author$project$Api$Employer$EmployeeDivision$All$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'enrolled_accounts_count',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'eligible_accounts_count',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'assigned_accounts_count',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
			$elm$core$Maybe$Nothing,
			$elm$json$Json$Decode$succeed($author$project$Api$Employer$EmployeeDivision$All$Record))));
var $author$project$Api$Employer$EmployeeDivision$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$EmployeeDivision$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Employer$EmployeeDivision$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$EmployeeDivision$All$EmployeeDivision)));
var $author$project$Api$Employer$EmployeeDivision$employeeDivisionsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['employee_divisions']),
	$author$project$Api$Data$employerPath);
var $author$project$Api$Employer$EmployeeDivision$expandToString = function (expand) {
	return 'count';
};
var $author$project$Api$Employer$EmployeeDivision$listDefaults = {HE: _List_Nil};
var $author$project$Api$Employer$EmployeeDivision$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Employer$EmployeeDivision$listDefaults);
	return _List_fromArray(
		[
			A2(
			$author$project$Api$Param$list,
			'expand',
			A2($elm$core$List$map, $author$project$Api$Employer$EmployeeDivision$expandToString, options.HE))
		]);
};
var $author$project$Api$Employer$EmployeeDivision$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Employer$EmployeeDivision$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Employer$EmployeeDivision$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Employer$EmployeeDivision$employeeDivisionsPath)));
	});
var $author$project$Api$Provider$EmployeeDivision$All$EmployeeDivision = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$EmployeeDivision$All$Record = F3(
	function (assignedAccounts, eligibleAccounts, enrolledAccounts) {
		return {L$: assignedAccounts, Rh: eligibleAccounts, RB: enrolledAccounts};
	});
var $author$project$Api$Provider$EmployeeDivision$All$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'enrolled_accounts_count',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'eligible_accounts_count',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'assigned_accounts_count',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
			$elm$core$Maybe$Nothing,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$EmployeeDivision$All$Record))));
var $author$project$Api$Provider$EmployeeDivision$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$EmployeeDivision$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$EmployeeDivision$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$EmployeeDivision$All$EmployeeDivision)));
var $author$project$Api$Provider$Company$EmployeeDivision$employeeDivisionsPath = function (companyId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['employee_divisions']),
		$author$project$Api$Provider$Company$companyPath(companyId));
};
var $author$project$Api$Provider$Company$EmployeeDivision$expandToString = function (expand) {
	return 'count';
};
var $author$project$Api$Provider$Company$EmployeeDivision$listDefaults = {HE: _List_Nil};
var $author$project$Api$Provider$Company$EmployeeDivision$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Company$EmployeeDivision$listDefaults);
	return _List_fromArray(
		[
			A2(
			$author$project$Api$Param$list,
			'expand',
			A2($elm$core$List$map, $author$project$Api$Provider$Company$EmployeeDivision$expandToString, options.HE))
		]);
};
var $author$project$Api$Provider$Company$EmployeeDivision$list = F4(
	function (apiClient, companyId, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$EmployeeDivision$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Company$EmployeeDivision$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Company$EmployeeDivision$employeeDivisionsPath(companyId))));
	});
var $author$project$Api$Employer$EmployeeDivision$Count = 0;
var $author$project$Api$EmployeeDivision$expandToEmployer = function (expand) {
	return 0;
};
var $author$project$Api$EmployeeDivision$listDefaults = {HE: _List_Nil};
var $author$project$Api$EmployeeDivision$optionalsToEmployer = function (optionals) {
	var options = optionals($author$project$Api$EmployeeDivision$listDefaults);
	return function (d) {
		return _Utils_update(
			d,
			{
				HE: A2($elm$core$List$map, $author$project$Api$EmployeeDivision$expandToEmployer, options.HE)
			});
	};
};
var $author$project$Api$Provider$Company$EmployeeDivision$Count = 0;
var $author$project$Api$EmployeeDivision$expandToProvider = function (expand) {
	return 0;
};
var $author$project$Api$EmployeeDivision$optionalsToProvider = function (optionals) {
	var options = optionals($author$project$Api$EmployeeDivision$listDefaults);
	return function (d) {
		return _Utils_update(
			d,
			{
				HE: A2($elm$core$List$map, $author$project$Api$EmployeeDivision$expandToProvider, options.HE)
			});
	};
};
var $author$project$Api$EmployeeDivision$list = F5(
	function (apiClient, session, companyId, optionals, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$EmployeeDivision$list,
			apiClient,
			$author$project$Api$EmployeeDivision$optionalsToEmployer(optionals),
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$EmployeeDivision$All$Employer)))) : A4(
			$author$project$Api$Provider$Company$EmployeeDivision$list,
			apiClient,
			companyId,
			$author$project$Api$EmployeeDivision$optionalsToProvider(optionals),
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$EmployeeDivision$All$Provider))));
	});
var $author$project$Api$Employer$Invoice$One$recurring = function (_v0) {
	var record = _v0.b;
	return record.$g;
};
var $author$project$Api$Provider$Invoice$One$recurring = function (_v0) {
	var record = _v0.b;
	return record.$g;
};
var $author$project$Api$Invoice$One$recurring = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$One$recurring(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$One$recurring(invoice_);
	}
};
var $author$project$Api$Employer$Company$Shared$usesEmployeeDivisions = function (_v0) {
	var record = _v0;
	return record.ad6;
};
var $author$project$Api$Employer$Company$One$usesEmployeeDivisions = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Company$Shared$usesEmployeeDivisions(shared);
};
var $author$project$Api$Provider$Company$One$usesEmployeeDivisions = function (_v0) {
	var record = _v0.b;
	return record.ad6;
};
var $author$project$Api$Company$usesEmployeeDivisions = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$usesEmployeeDivisions(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$usesEmployeeDivisions(company_);
	}
};
var $author$project$Components$Invoice$InvoiceLinesTable$usesEmployeeDivisions = function (company) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (company_) {
				if (!company_.$) {
					return false;
				} else {
					var company__ = company_.a;
					return $author$project$Api$Company$usesEmployeeDivisions(company__);
				}
			},
			company));
};
var $author$project$Components$Invoice$InvoiceLinesTable$init = F7(
	function (currentDate, apiClient, session, practice, company, invoiceType, invoice) {
		var resource = function () {
			if (invoiceType.$ === 1) {
				return 4;
			} else {
				return 5;
			}
		}();
		var q = $elm$core$Maybe$Nothing;
		var _v0 = $author$project$Components$Invoice$InvoiceLinesTable$allowCustomMembershipPlan(company) ? A2(
			$elm$core$Tuple$mapFirst,
			$elm$core$Maybe$Just,
			A4(
				$author$project$Components$ResourceFilter$Plan$init,
				apiClient,
				session,
				function (d) {
					return _Utils_update(
						d,
						{
							Gz: $elm$core$Maybe$Just(
								$author$project$Components$Invoice$InvoiceLinesTable$companyId(company))
						});
				},
				function (d) {
					return _Utils_update(
						d,
						{Gp: 'All Plans'});
				})) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
		var planResourceFilter = _v0.a;
		var planResourceFilterCmd = _v0.b;
		var _v1 = A3(
			$author$project$Components$ResourceFilter$Category$init,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'All Categories', XY: 'Unassigned', ai5: true});
			});
		var categoryResourceFilter = _v1.a;
		var categoryResourceFilterCmd = _v1.b;
		var model = {
			il: $elm$core$Maybe$Nothing,
			iF: $elm$core$Maybe$Nothing,
			c8: categoryResourceFilter,
			afQ: company,
			dd: currentDate,
			gb: $elm$core$Maybe$Nothing,
			ef: $elm$core$Set$empty,
			HA: $elm$core$Maybe$Nothing,
			nv: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'employee-division-dropdown-filter', al6: $author$project$Components$Invoice$InvoiceLinesTable$EmployeeDivisionDropdownMsg})),
			zr: $author$project$Api$Data$Loading,
			nD: $author$project$Components$ExportCsv$initForPractice(resource),
			Uk: invoice,
			aO: $author$project$Api$Data$Loading,
			Uv: invoiceType,
			ajJ: $author$project$Api$Pagination$init,
			eS: $elm$core$Dict$empty,
			aj4: $elm$core$Maybe$Nothing,
			hi: planResourceFilter,
			ZV: practice,
			akl: q,
			DJ: $author$project$Api$Invoice$One$recurring(invoice),
			up: $author$project$Ui$SearchInput$init(q),
			aa4: session,
			alA: A3($author$project$Api$Sort$withDefault, 'date', 0, $author$project$Api$Sort$init)
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Components$Invoice$InvoiceLinesTable$fetchInvoiceLines, apiClient, model),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$CategoryResourceFilterMsg, categoryResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$PlanResourceFilterMsg, planResourceFilterCmd),
						$author$project$Components$Invoice$InvoiceLinesTable$usesEmployeeDivisions(company) ? A5(
						$author$project$Api$EmployeeDivision$list,
						apiClient,
						session,
						$author$project$Components$Invoice$InvoiceLinesTable$companyId(company),
						function (d) {
							return d;
						},
						$author$project$Components$Invoice$InvoiceLinesTable$GotEmployeeDivisions) : $elm$core$Platform$Cmd$none
					])));
	});
var $author$project$Components$Invoice$Summary$GotDelta = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Invoice$Summary$Model = $elm$core$Basics$identity;
var $author$project$Components$Invoice$Summary$EmployeeDivision = 1;
var $author$project$Components$Invoice$Summary$Plan = 0;
var $author$project$Components$Invoice$Summary$Sponsor = 2;
var $author$project$Components$Invoice$Summary$companyAllowCustomMembershipPlan = function (company) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (company_) {
				if (!company_.$) {
					return false;
				} else {
					var company__ = company_.a;
					return $author$project$Api$Company$allowCustomMembershipPlan(company__);
				}
			},
			company));
};
var $author$project$Components$Invoice$Summary$companyUsesEmployeeDivisions = function (company) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (company_) {
				if (!company_.$) {
					return false;
				} else {
					var company__ = company_.a;
					return $author$project$Api$Company$usesEmployeeDivisions(company__);
				}
			},
			company));
};
var $author$project$Api$Common$Invoice$Summary$sponsorFeeDealLines = function (_v0) {
	var record = _v0;
	return record.ab_;
};
var $author$project$Components$Invoice$Summary$groupBy = F3(
	function (company, summary, showSponsor) {
		return showSponsor ? $elm$core$Maybe$Just(2) : ($author$project$Components$Invoice$Summary$companyAllowCustomMembershipPlan(company) ? $elm$core$Maybe$Just(0) : (($author$project$Components$Invoice$Summary$companyUsesEmployeeDivisions(company) && $elm$core$List$isEmpty(
			$author$project$Api$Common$Invoice$Summary$sponsorFeeDealLines(summary))) ? $elm$core$Maybe$Just(1) : $elm$core$Maybe$Nothing));
	});
var $author$project$Components$Invoice$Summary$OtherChargesSummary$init = function (recurringInvoice) {
	return {DJ: recurringInvoice, hG: false};
};
var $author$project$Api$Common$Invoice$Delta$Delta = $elm$core$Basics$identity;
var $author$project$Api$Common$Invoice$Delta$Record = F2(
	function (added, removed) {
		return {KW: added, $v: removed};
	});
var $author$project$Api$Provider$InvoicePatient$Shared$InvoicePatient = $elm$core$Basics$identity;
var $author$project$Api$Provider$InvoicePatient$Shared$Record = F4(
	function (name, startDate, endDate, owner) {
		return {sb: endDate, Bq: name, YD: owner, ab7: startDate};
	});
var $author$project$Api$Provider$InvoicePatient$Shared$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'owner',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Min$decoder),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'end_date',
		$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'start_date',
			$elm_community$json_extra$Json$Decode$Extra$datetime,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$InvoicePatient$Shared$Record)))));
var $author$project$Api$Provider$InvoicePatient$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$InvoicePatient$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$Invoice$Delta$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'removed',
	$elm$json$Json$Decode$list($author$project$Api$Provider$InvoicePatient$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'added',
		$elm$json$Json$Decode$list($author$project$Api$Provider$InvoicePatient$Shared$decoder),
		$elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Delta$Record)));
var $author$project$Api$Common$Invoice$Delta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Invoice$Delta$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Invoice$Delta$deltaPath = function (invoiceId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['delta']),
		$author$project$Api$Employer$Invoice$invoicePath(invoiceId));
};
var $author$project$Api$Employer$Invoice$Delta$retrieve = F3(
	function (apiClient, invoiceId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Common$Invoice$Delta$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Employer$Invoice$Delta$deltaPath(invoiceId)));
	});
var $author$project$Api$Provider$Company$Invoice$Delta$deltaPath = F2(
	function (companyId, invoiceId) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				['delta']),
			A2($author$project$Api$Provider$Company$Invoice$invoicePath, companyId, invoiceId));
	});
var $author$project$Api$Provider$Company$Invoice$Delta$retrieve = F4(
	function (apiClient, companyId, invoiceId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Common$Invoice$Delta$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Provider$Company$Invoice$Delta$deltaPath, companyId, invoiceId)));
	});
var $author$project$Api$Company$Invoice$Delta$retrieve = F5(
	function (apiClient, session, companyId, invoiceId, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$Invoice$Delta$retrieve, apiClient, invoiceId, toMsg) : A4($author$project$Api$Provider$Company$Invoice$Delta$retrieve, apiClient, companyId, invoiceId, toMsg);
	});
var $author$project$Api$Provider$AffiliateBill$Delta$deltaPath = function (affiliateBillId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['delta']),
		$author$project$Api$Provider$AffiliateBill$affiliateBillPath(affiliateBillId));
};
var $author$project$Api$Provider$AffiliateBill$Delta$retrieve = F3(
	function (apiClient, affiliateBillId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Common$Invoice$Delta$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$AffiliateBill$Delta$deltaPath(affiliateBillId)));
	});
var $author$project$Api$Employer$Company$Shared$companyType = function (_v0) {
	var record = _v0;
	return record.Ok;
};
var $author$project$Api$Employer$Company$One$companyType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Company$Shared$companyType(shared);
};
var $author$project$Api$Provider$Company$Shared$companyType = function (_v0) {
	var record = _v0;
	return record.Ok;
};
var $author$project$Api$Provider$Company$One$companyType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$companyType(shared);
};
var $author$project$Api$Company$companyType = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$companyType(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$companyType(company_);
	}
};
var $author$project$Api$Provider$Company$Min$companyType = function (_v0) {
	var record = _v0;
	return record.Ok;
};
var $author$project$Components$Invoice$Summary$companyType = function (company) {
	return A2(
		$elm$core$Maybe$map,
		function (company_) {
			if (!company_.$) {
				var company__ = company_.a;
				return $author$project$Api$Provider$Company$Min$companyType(company__);
			} else {
				var company__ = company_.a;
				return $author$project$Api$Company$companyType(company__);
			}
		},
		company);
};
var $author$project$Components$Invoice$Summary$companyIsNetwork = function (company) {
	return _Utils_eq(
		$author$project$Components$Invoice$Summary$companyType(company),
		$elm$core$Maybe$Just(0));
};
var $author$project$Components$Invoice$Summary$showSponsorBreakdown = F3(
	function (invoiceType, session, company) {
		var organizationIsPractice = $author$project$Api$Platform$Session$One$organizationIsAdminPractice(session);
		var isAffiliateBill = function () {
			if (!invoiceType.$) {
				return true;
			} else {
				return false;
			}
		}();
		return organizationIsPractice && ($author$project$Components$Invoice$Summary$companyIsNetwork(company) || isAffiliateBill);
	});
var $author$project$Components$Invoice$Summary$init = F8(
	function (apiClient, session, timeFormatter, practice, company, invoiceType, invoice, summary) {
		var recurringInvoice = $author$project$Api$Invoice$One$recurring(invoice);
		var organizationIsPractice = $author$project$Api$Platform$Session$One$organizationIsAdminPractice(session);
		var groupBy_ = A3(
			$author$project$Components$Invoice$Summary$groupBy,
			company,
			summary,
			A3($author$project$Components$Invoice$Summary$showSponsorBreakdown, invoiceType, session, company));
		return _Utils_Tuple2(
			{
				afQ: company,
				zb: $author$project$Api$Data$Loading,
				gx: groupBy_,
				Uk: invoice,
				Uv: invoiceType,
				tv: $author$project$Components$Invoice$Summary$OtherChargesSummary$init(recurringInvoice),
				oV: $elm$core$Maybe$Nothing,
				ZV: practice,
				aa4: session,
				hF: false,
				hH: organizationIsPractice && (!_Utils_eq(groupBy_, $elm$core$Maybe$Nothing)),
				acF: summary,
				J7: timeFormatter
			},
			function () {
				if (!invoiceType.$) {
					var id = invoiceType.a;
					return A3($author$project$Api$Provider$AffiliateBill$Delta$retrieve, apiClient, id, $author$project$Components$Invoice$Summary$GotDelta);
				} else {
					var companyId = invoiceType.a;
					var id = invoiceType.b;
					return A5($author$project$Api$Company$Invoice$Delta$retrieve, apiClient, session, companyId, id, $author$project$Components$Invoice$Summary$GotDelta);
				}
			}());
	});
var $author$project$Api$Provider$Notification$EmployerInvoiceCreated = 1;
var $author$project$Components$CompanyEmailModal$Loading = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Notification$Company = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$CompanyEmailModal$GotPreview = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$Notification$One$Notification = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Notification$Shared$Notification = $elm$core$Basics$identity;
var $author$project$Api$Provider$Notification$Shared$Record = F9(
	function (subject, body, attemptedAt, failedAt, recipientEmail, shortDescription, errorMessage, clickedAt, openedAt) {
		return {L6: attemptedAt, fO: body, NI: clickedAt, RM: errorMessage, R6: failedAt, Yo: openedAt, $d: recipientEmail, abc: shortDescription, J_: subject};
	});
var $author$project$Api$Provider$Notification$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'opened_at',
	$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'clicked_at',
		$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'error_message',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'short_description',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'recipient_email',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'failed_at',
						$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'attempted_at',
							$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'body',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'subject',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									$elm$json$Json$Decode$succeed($author$project$Api$Provider$Notification$Shared$Record))))))))));
var $author$project$Api$Provider$Notification$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Notification$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Notification$One$Record = F3(
	function (subjectHtml, bodyHtml, shortDescriptionHtml) {
		return {MM: bodyHtml, abd: shortDescriptionHtml, acw: subjectHtml};
	});
var $author$project$Api$Provider$Notification$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'short_description_html',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'body_html',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'subject_html',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Notification$One$Record))));
var $author$project$Api$Provider$Notification$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Notification$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Notification$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Notification$One$Notification)));
var $author$project$Api$Provider$Notification$previewNotificationPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['preview']),
	$author$project$Api$Provider$Notification$notificationsPath);
var $author$project$Api$Provider$Notification$typeToString = function (type_) {
	if (!type_) {
		return 'customer_invoice';
	} else {
		return 'employer_invoice_created';
	}
};
var $author$project$Api$Provider$Notification$preview = F6(
	function (apiClient, type_, recipient, contextId, fields, toMsg) {
		var body_ = $elm$json$Json$Encode$object(
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							_Utils_Tuple2(
							'context_id',
							$elm$json$Json$Encode$string(contextId)),
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string(
								$author$project$Api$Provider$Notification$typeToString(type_)))
						]),
						function () {
						if (!recipient.$) {
							var patientId = recipient.a;
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'patient',
									$elm$json$Json$Encode$string(patientId))
								]);
						} else {
							var companyId = recipient.a;
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'company',
									$elm$json$Json$Encode$string(companyId))
								]);
						}
					}(),
						function () {
						var _v1 = fields.J_;
						if (!_v1.$) {
							var string = _v1.a;
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'subject',
									$elm$json$Json$Encode$string(string))
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v2 = fields.fO;
						if (!_v2.$) {
							var string = _v2.a;
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'body',
									$elm$json$Json$Encode$string(string))
								]);
						} else {
							return _List_Nil;
						}
					}()
					])));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Notification$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body_,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Notification$previewNotificationPath)));
	});
var $author$project$Components$CompanyEmailModal$previewNotification = F3(
	function (apiClient, shared, formFields) {
		var fields = function () {
			var _v1 = A2($elm$core$Maybe$map, $rtfeldman$elm_validate$Validate$fromValid, formFields);
			if (!_v1.$) {
				var fields_ = _v1.a;
				return {fO: fields_.fO, J_: fields_.J_};
			} else {
				return {fO: $elm$core$Maybe$Nothing, J_: $elm$core$Maybe$Nothing};
			}
		}();
		var _v0 = shared;
		var type_ = _v0.amg;
		var contextId = _v0.yP;
		var recipient = _v0.DI;
		return A6(
			$author$project$Api$Provider$Notification$preview,
			apiClient,
			type_,
			$author$project$Api$Provider$Notification$Company(
				$author$project$Api$Provider$Company$One$id(recipient)),
			contextId,
			fields,
			$author$project$Components$CompanyEmailModal$GotPreview);
	});
var $author$project$Components$CompanyEmailModal$init = F6(
	function (apiClient, type_, contextId, recipient, header, beforeSend) {
		var shared = {GD: beforeSend, yP: contextId, sx: header, DI: recipient, amg: type_};
		return _Utils_Tuple2(
			$author$project$Components$CompanyEmailModal$Loading(shared),
			A3($author$project$Components$CompanyEmailModal$previewNotification, apiClient, shared, $elm$core$Maybe$Nothing));
	});
var $author$project$Api$Provider$Company$Invoice$makeViewable = F4(
	function (apiClient, companyId, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Invoice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['make_viewable']),
					A2($author$project$Api$Provider$Company$Invoice$invoicePath, companyId, id))));
	});
var $author$project$Api$Company$Invoice$makeViewable = F5(
	function (apiClient, session, companyId, id, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : A4(
			$author$project$Api$Provider$Company$Invoice$makeViewable,
			apiClient,
			companyId,
			id,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Invoice$One$Provider)));
	});
var $author$project$Components$Invoice$makeViewable = F3(
	function (apiClient, session, invoiceType) {
		if (!invoiceType.$) {
			return function (_v1) {
				return $elm$core$Platform$Cmd$none;
			};
		} else {
			var companyId = invoiceType.a;
			var id = invoiceType.b;
			return A4($author$project$Api$Company$Invoice$makeViewable, apiClient, session, companyId, id);
		}
	});
var $author$project$Components$Invoice$initCompanyEmailModal = F4(
	function (apiClient, model, invoice, makeViewable_) {
		var _v0 = model.afQ;
		if (((!_v0.$) && (_v0.a.$ === 1)) && (!_v0.a.a.$)) {
			var company = _v0.a.a.a;
			var _v1 = makeViewable_ ? _Utils_Tuple2(
				$elm$core$Maybe$Just(
					$elm$core$String$concat(
						_List_fromArray(
							[
								'Sending this invoice to ',
								$author$project$Api$Provider$Company$One$name(company),
								' will make it available on their employer portal, and will also send them the email below. ',
								'Invoices can be shared while still in draft mode.'
							]))),
				$elm$core$Maybe$Just(
					A3($author$project$Components$Invoice$makeViewable, apiClient, model.aa4, model.Uv))) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
			var header = _v1.a;
			var cmd = _v1.b;
			var _v2 = A6(
				$author$project$Components$CompanyEmailModal$init,
				apiClient,
				1,
				$author$project$Api$Invoice$One$id(invoice),
				company,
				header,
				cmd);
			var companyEmailModal = _v2.a;
			var companyEmailModalCmd = _v2.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						iM: $elm$core$Maybe$Just(companyEmailModal)
					}),
				A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$CompanyEmailModalMsg, companyEmailModalCmd));
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Components$Invoice$CreatePaymentModal$AffiliateBill = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Invoice$CreatePaymentModal$Invoice = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Api$Company$companyPath = F2(
	function (session, companyId) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $author$project$Api$Data$employerPath : $author$project$Api$Provider$Company$companyPath(companyId);
	});
var $author$project$Components$Invoice$sourceBasePath = F2(
	function (session, invoiceType) {
		if (!invoiceType.$) {
			var affiliateId = invoiceType.a;
			return $elm$core$Maybe$Just(
				$author$project$Api$Provider$Affiliate$affiliatePath(affiliateId));
		} else {
			var companyId = invoiceType.a;
			return $elm$core$Maybe$Just(
				A2($author$project$Api$Company$companyPath, session, companyId));
		}
	});
var $author$project$Components$Invoice$initCreatePaymentModal = F4(
	function (apiClient, model, invoice, external) {
		var createPaymentModalInvoice = function () {
			var _v1 = model.Uv;
			if (!_v1.$) {
				var affiliateId = _v1.a;
				return A2($author$project$Components$Invoice$CreatePaymentModal$AffiliateBill, affiliateId, invoice);
			} else {
				var companyId = _v1.a;
				return A2($author$project$Components$Invoice$CreatePaymentModal$Invoice, companyId, invoice);
			}
		}();
		var _v0 = $author$project$Components$Invoice$CreatePaymentModal$init(model.dd)(model.J7)(
			A2($author$project$Components$Invoice$paymentsBasePath, model.aa4, model.Uv))(
			A2($author$project$Components$Invoice$sourceBasePath, model.aa4, model.Uv))(apiClient)(model.aa4)(model.ZV)(model.Ij)(model.t9)(
			function (d) {
				return _Utils_update(
					d,
					{R5: external, alv: model.Ij});
			})(createPaymentModalInvoice);
		var createPaymentModal = _v0.a;
		var createPaymentModalCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					m$: $elm$core$Maybe$Just(createPaymentModal)
				}),
			A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$CreatePaymentModalMsg, createPaymentModalCmd));
	});
var $author$project$Components$Invoice$InvoiceLinesTable$EmployerOrProviderCompany = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$ProviderMin = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Invoice$invoiceLinesTableCompany = function (company) {
	return A2(
		$elm$core$Maybe$map,
		function (company_) {
			if (!company_.$) {
				var company__ = company_.a;
				return $author$project$Components$Invoice$InvoiceLinesTable$ProviderMin(company__);
			} else {
				var company__ = company_.a;
				return $author$project$Components$Invoice$InvoiceLinesTable$EmployerOrProviderCompany(company__);
			}
		},
		company);
};
var $author$project$Components$Invoice$InvoiceLinesTable$Affiliate = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Invoice$InvoiceLinesTable$Company = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Invoice$invoiceLinesTableInvoiceType = function (invoiceType) {
	if (!invoiceType.$) {
		var affiliateId = invoiceType.a;
		var id = invoiceType.b;
		return A2($author$project$Components$Invoice$InvoiceLinesTable$Affiliate, affiliateId, id);
	} else {
		var companyId = invoiceType.a;
		var id = invoiceType.b;
		return A2($author$project$Components$Invoice$InvoiceLinesTable$Company, companyId, id);
	}
};
var $author$project$Components$Invoice$Summary$EmployerOrProviderCompany = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Invoice$Summary$ProviderMin = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Invoice$invoiceSummaryCompany = function (company) {
	return A2(
		$elm$core$Maybe$map,
		function (company_) {
			if (!company_.$) {
				var company__ = company_.a;
				return $author$project$Components$Invoice$Summary$ProviderMin(company__);
			} else {
				var company__ = company_.a;
				return $author$project$Components$Invoice$Summary$EmployerOrProviderCompany(company__);
			}
		},
		company);
};
var $author$project$Api$Provider$Invoice$One$isUpdating = function (_v0) {
	var record = _v0.b;
	return record.Vl;
};
var $author$project$Api$Invoice$One$isUpdating = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$One$isUpdating(invoice_);
	} else {
		return false;
	}
};
var $author$project$Components$Invoice$Issued = function (a) {
	return {$: 21, a: a};
};
var $author$project$Api$Employer$Invoice$issue = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Employer$Invoice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['issue']),
					$author$project$Api$Employer$Invoice$invoicePath(id))));
	});
var $author$project$Api$Provider$Company$Invoice$issue = F4(
	function (apiClient, companyId, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Invoice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['issue']),
					A2($author$project$Api$Provider$Company$Invoice$invoicePath, companyId, id))));
	});
var $author$project$Api$Company$Invoice$issue = F5(
	function (apiClient, session, companyId, id, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$Invoice$issue,
			apiClient,
			id,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Invoice$One$Employer))) : A4(
			$author$project$Api$Provider$Company$Invoice$issue,
			apiClient,
			companyId,
			id,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Invoice$One$Provider)));
	});
var $author$project$Api$Provider$AffiliateBill$issue = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Invoice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['issue']),
					$author$project$Api$Provider$AffiliateBill$affiliateBillPath(id))));
	});
var $author$project$Components$Invoice$issue = F3(
	function (apiClient, session, invoiceType) {
		if (!invoiceType.$) {
			var id = invoiceType.b;
			return A3(
				$author$project$Api$Provider$AffiliateBill$issue,
				apiClient,
				id,
				A2(
					$elm$core$Basics$composeL,
					$author$project$Components$Invoice$Issued,
					$author$project$Api$Data$map($author$project$Api$Invoice$One$Provider)));
		} else {
			var companyId = invoiceType.a;
			var id = invoiceType.b;
			return A5($author$project$Api$Company$Invoice$issue, apiClient, session, companyId, id, $author$project$Components$Invoice$Issued);
		}
	});
var $author$project$Components$Invoice$MarkedAsBadDebt = F2(
	function (a, b) {
		return {$: 14, a: a, b: b};
	});
var $author$project$Api$Provider$Company$Invoice$markAsBadDebt = F4(
	function (apiClient, companyId, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Invoice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['mark_as_bad_debt']),
					A2($author$project$Api$Provider$Company$Invoice$invoicePath, companyId, id))));
	});
var $author$project$Api$Company$Invoice$markAsBadDebt = F5(
	function (apiClient, session, companyId, id, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : A4(
			$author$project$Api$Provider$Company$Invoice$markAsBadDebt,
			apiClient,
			companyId,
			id,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Invoice$One$Provider)));
	});
var $author$project$Components$Invoice$markAsBadDebt = F4(
	function (apiClient, session, invoiceType, invoice) {
		if (!invoiceType.$) {
			return $elm$core$Platform$Cmd$none;
		} else {
			var companyId = invoiceType.a;
			var id = invoiceType.b;
			return A5(
				$author$project$Api$Company$Invoice$markAsBadDebt,
				apiClient,
				session,
				companyId,
				id,
				$author$project$Components$Invoice$MarkedAsBadDebt(invoice));
		}
	});
var $author$project$Components$Invoice$PollInvoiceStatus = {$: 33};
var $author$project$Components$Invoice$pollInvoiceForStatus = A2(
	$elm$core$Task$perform,
	function (_v0) {
		return $author$project$Components$Invoice$PollInvoiceStatus;
	},
	$elm$core$Process$sleep(2000));
var $author$project$Api$Common$Invoice$Summary$Summary = $elm$core$Basics$identity;
var $author$project$Api$Common$Invoice$Summary$Record = F9(
	function (sponsorFeeDealLines, activeLines, allLines, byPlan, byEmployeeDivision, bySponsor, membershipAdjustmentLines, nonMembershipAdjustmentLines, byCategory) {
		return {KP: activeLines, Lq: allLines, M_: byCategory, M$: byEmployeeDivision, M0: byPlan, M1: bySponsor, WO: membershipAdjustmentLines, XX: nonMembershipAdjustmentLines, ab_: sponsorFeeDealLines};
	});
var $author$project$Api$Common$Invoice$Summary$ActiveLines$ActiveLines = $elm$core$Basics$identity;
var $author$project$Api$Common$Invoice$Summary$ActiveLines$Record = function (totals) {
	return {FW: totals};
};
var $author$project$Api$Common$Invoice$Summary$ActiveLines$TotalsRecord = F3(
	function (count, numberOfDependents, amountInCents) {
		return {LE: amountInCents, OK: count, X2: numberOfDependents};
	});
var $author$project$Api$Common$Invoice$Summary$ActiveLines$totalsRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'amount_in_cents',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'number_of_dependents',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'count',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$ActiveLines$TotalsRecord))));
var $author$project$Api$Common$Invoice$Summary$ActiveLines$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'totals',
	$author$project$Api$Common$Invoice$Summary$ActiveLines$totalsRecordDecoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$ActiveLines$Record));
var $author$project$Api$Common$Invoice$Summary$ActiveLines$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Invoice$Summary$ActiveLines$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$Invoice$Summary$AllLines$AllLines = $elm$core$Basics$identity;
var $author$project$Api$Common$Invoice$Summary$AllLines$Record = function (totals) {
	return {FW: totals};
};
var $author$project$Api$Common$Invoice$Summary$AllLines$TotalsRecord = F2(
	function (amountInCents, count) {
		return {LE: amountInCents, OK: count};
	});
var $author$project$Api$Common$Invoice$Summary$AllLines$totalsRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'count',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'amount_in_cents',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		$elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$AllLines$TotalsRecord)));
var $author$project$Api$Common$Invoice$Summary$AllLines$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'totals',
	$author$project$Api$Common$Invoice$Summary$AllLines$totalsRecordDecoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$AllLines$Record));
var $author$project$Api$Common$Invoice$Summary$AllLines$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Invoice$Summary$AllLines$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$Invoice$Summary$ByCategory$ByCategory = $elm$core$Basics$identity;
var $author$project$Api$Common$Invoice$Summary$ByCategory$Record = function (nonMembershipAdjustmentLines) {
	return {XX: nonMembershipAdjustmentLines};
};
var $author$project$Api$Common$Invoice$Summary$ByCategory$NonMembershipAdjustmentLinesRecord = function (rows) {
	return {aac: rows};
};
var $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Row$Row = $elm$core$Basics$identity;
var $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Row$Record = F3(
	function (count, amountInCents, categoryName) {
		return {LE: amountInCents, Ns: categoryName, OK: count};
	});
var $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Row$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'category_name',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'amount_in_cents',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'count',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Row$Record))));
var $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Row$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Row$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$Invoice$Summary$ByCategory$nonMembershipAdjustmentLinesRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'rows',
	$elm$json$Json$Decode$list($author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Row$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$ByCategory$NonMembershipAdjustmentLinesRecord));
var $author$project$Api$Common$Invoice$Summary$ByCategory$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'non_membership_adjustment_lines',
	$author$project$Api$Common$Invoice$Summary$ByCategory$nonMembershipAdjustmentLinesRecordDecoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$ByCategory$Record));
var $author$project$Api$Common$Invoice$Summary$ByCategory$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Invoice$Summary$ByCategory$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$Invoice$Summary$Grouped$Grouped = $elm$core$Basics$identity;
var $author$project$Api$Common$Invoice$Summary$Grouped$Record = F2(
	function (activeLines, membershipAdjustmentLines) {
		return {KP: activeLines, WO: membershipAdjustmentLines};
	});
var $author$project$Api$Common$Invoice$Summary$Grouped$ActiveLinesRecord = function (rows) {
	return {aac: rows};
};
var $author$project$Api$Common$Invoice$Summary$ActiveLines$Row$Row = $elm$core$Basics$identity;
var $author$project$Api$Common$Invoice$Summary$ActiveLines$Row$Record = F6(
	function (count, amountInCents, numberOfDependents, planName, divisionName, companyName) {
		return {LE: amountInCents, Og: companyName, OK: count, QQ: divisionName, X2: numberOfDependents, ZE: planName};
	});
var $author$project$Api$Common$Invoice$Summary$ActiveLines$Row$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'company_name',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'division_name',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'plan_name',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'number_of_dependents',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'amount_in_cents',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'count',
						$elm$json$Json$Decode$int,
						$elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$ActiveLines$Row$Record)))))));
var $author$project$Api$Common$Invoice$Summary$ActiveLines$Row$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Invoice$Summary$ActiveLines$Row$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$Invoice$Summary$Grouped$activeLinesRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'rows',
	$elm$json$Json$Decode$list($author$project$Api$Common$Invoice$Summary$ActiveLines$Row$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$Grouped$ActiveLinesRecord));
var $author$project$Api$Common$Invoice$Summary$Grouped$MembershipAdjustmentLinesRecord = function (rows) {
	return {aac: rows};
};
var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$Row = $elm$core$Basics$identity;
var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$Record = F7(
	function (count, amountInCents, planName, divisionName, companyName, numberOfOtherCharges, numberOfMembershipCharges) {
		return {LE: amountInCents, Og: companyName, OK: count, QQ: divisionName, X4: numberOfMembershipCharges, X5: numberOfOtherCharges, ZE: planName};
	});
var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'number_of_membership_charges',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'number_of_other_charges',
		$elm$json$Json$Decode$int,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'company_name',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'division_name',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'plan_name',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'amount_in_cents',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'count',
							$elm$json$Json$Decode$int,
							$elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$Record))))))));
var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$Invoice$Summary$Grouped$membershipAdjustmentLinesRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'rows',
	$elm$json$Json$Decode$list($author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$Grouped$MembershipAdjustmentLinesRecord));
var $author$project$Api$Common$Invoice$Summary$Grouped$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'membership_adjustment_lines',
	$author$project$Api$Common$Invoice$Summary$Grouped$membershipAdjustmentLinesRecordDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'active_lines',
		$author$project$Api$Common$Invoice$Summary$Grouped$activeLinesRecordDecoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$Grouped$Record)));
var $author$project$Api$Common$Invoice$Summary$Grouped$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Invoice$Summary$Grouped$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$MembershipAdjustmentLines = $elm$core$Basics$identity;
var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Record = function (totals) {
	return {FW: totals};
};
var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$TotalsRecord = F4(
	function (count, amountInCents, numberOfOtherCharges, numberOfMembershipCharges) {
		return {LE: amountInCents, OK: count, X4: numberOfMembershipCharges, X5: numberOfOtherCharges};
	});
var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalsRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'number_of_membership_charges',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'number_of_other_charges',
		$elm$json$Json$Decode$int,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'amount_in_cents',
			$elm$json$Json$Decode$int,
			0,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'count',
				$elm$json$Json$Decode$int,
				$elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$TotalsRecord)))));
var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'totals',
	$author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalsRecordDecoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Record));
var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$NonMembershipAdjustmentLines = $elm$core$Basics$identity;
var $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Record = function (totals) {
	return {FW: totals};
};
var $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$TotalsRecord = F2(
	function (count, amountInCents) {
		return {LE: amountInCents, OK: count};
	});
var $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$totalsRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'amount_in_cents',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'count',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$TotalsRecord)));
var $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'totals',
	$author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$totalsRecordDecoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Record));
var $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$Invoice$Summary$SponsorFeeDealLine$SponsorFeeDealLine = 0;
var $author$project$Api$Common$Invoice$Summary$SponsorFeeDealLine$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Common$Invoice$Summary$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'by_category',
	$elm$json$Json$Decode$nullable($author$project$Api$Common$Invoice$Summary$ByCategory$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'non_membership_adjustment_lines',
		$author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'membership_adjustment_lines',
			$author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'by_sponsor',
				$elm$json$Json$Decode$nullable($author$project$Api$Common$Invoice$Summary$Grouped$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'by_employee_division',
					$elm$json$Json$Decode$nullable($author$project$Api$Common$Invoice$Summary$Grouped$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'by_plan',
						$elm$json$Json$Decode$nullable($author$project$Api$Common$Invoice$Summary$Grouped$decoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'all_lines',
							$author$project$Api$Common$Invoice$Summary$AllLines$decoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'active_lines',
								$author$project$Api$Common$Invoice$Summary$ActiveLines$decoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'sponsor_fee_deal_lines',
									$elm$json$Json$Decode$list($author$project$Api$Common$Invoice$Summary$SponsorFeeDealLine$decoder),
									$elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$Record))))))))));
var $author$project$Api$Common$Invoice$Summary$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Invoice$Summary$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Invoice$Summary$retrieve = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Common$Invoice$Summary$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['summary']),
					$author$project$Api$Employer$Invoice$invoicePath(id))));
	});
var $author$project$Api$Provider$Invoice$Summary$retrieve = F4(
	function (apiClient, companyId, invoiceId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Common$Invoice$Summary$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['summary']),
					A2($author$project$Api$Provider$Company$Invoice$invoicePath, companyId, invoiceId))));
	});
var $author$project$Api$Company$Invoice$Summary$retrieve = F5(
	function (apiClient, session, companyId, id, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$Invoice$Summary$retrieve, apiClient, id, toMsg) : A4($author$project$Api$Provider$Invoice$Summary$retrieve, apiClient, companyId, id, toMsg);
	});
var $author$project$Api$Provider$AffiliateBill$Summary$retrieve = F3(
	function (apiClient, affiliateBillId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Common$Invoice$Summary$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['summary']),
					$author$project$Api$Provider$AffiliateBill$affiliateBillPath(affiliateBillId))));
	});
var $author$project$Components$Invoice$GotCompanyInvoiceStatus = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Invoice$retrieveInvoiceStatus = F3(
	function (apiClient, session, invoiceType) {
		if (!invoiceType.$) {
			var id = invoiceType.b;
			return A3(
				$author$project$Api$Provider$AffiliateBill$retrieve,
				apiClient,
				id,
				A2(
					$elm$core$Basics$composeL,
					$author$project$Components$Invoice$GotCompanyInvoiceStatus,
					$author$project$Api$Data$map($author$project$Api$Invoice$One$Provider)));
		} else {
			var companyId = invoiceType.a;
			var id = invoiceType.b;
			return A5($author$project$Api$Company$Invoice$retrieve, apiClient, session, companyId, id, $author$project$Components$Invoice$GotCompanyInvoiceStatus);
		}
	});
var $author$project$Components$Invoice$ReturnedToDraft = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Api$Provider$Company$Invoice$returnToDraft = F4(
	function (apiClient, companyId, id, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$Invoice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['return_to_draft']),
					A2($author$project$Api$Provider$Company$Invoice$invoicePath, companyId, id))));
	});
var $author$project$Api$Company$Invoice$returnToDraft = F5(
	function (apiClient, session, companyId, id, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : A4(
			$author$project$Api$Provider$Company$Invoice$returnToDraft,
			apiClient,
			companyId,
			id,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Invoice$One$Provider)));
	});
var $author$project$Api$Provider$AffiliateBill$returnToDraft = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Invoice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['return_to_draft']),
					$author$project$Api$Provider$AffiliateBill$affiliateBillPath(id))));
	});
var $author$project$Components$Invoice$returnToDraft = F4(
	function (apiClient, session, invoiceType, invoice) {
		if (!invoiceType.$) {
			var id = invoiceType.b;
			return A3(
				$author$project$Api$Provider$AffiliateBill$returnToDraft,
				apiClient,
				id,
				A2(
					$elm$core$Basics$composeL,
					$author$project$Components$Invoice$ReturnedToDraft(invoice),
					$author$project$Api$Data$map($author$project$Api$Invoice$One$Provider)));
		} else {
			var companyId = invoiceType.a;
			var id = invoiceType.b;
			return A5(
				$author$project$Api$Company$Invoice$returnToDraft,
				apiClient,
				session,
				companyId,
				id,
				$author$project$Components$Invoice$ReturnedToDraft(invoice));
		}
	});
var $author$project$Components$Invoice$ReversedBadDebt = function (a) {
	return {$: 16, a: a};
};
var $author$project$Api$Provider$Company$Invoice$reverseBadDebt = F4(
	function (apiClient, companyId, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Invoice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['reverse_bad_debt']),
					A2($author$project$Api$Provider$Company$Invoice$invoicePath, companyId, id))));
	});
var $author$project$Api$Company$Invoice$reverseBadDebt = F5(
	function (apiClient, session, companyId, id, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : A4(
			$author$project$Api$Provider$Company$Invoice$reverseBadDebt,
			apiClient,
			companyId,
			id,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Invoice$One$Provider)));
	});
var $author$project$Components$Invoice$reverseBadDebt = F3(
	function (apiClient, session, invoiceType) {
		if (!invoiceType.$) {
			return $elm$core$Platform$Cmd$none;
		} else {
			var companyId = invoiceType.a;
			var id = invoiceType.b;
			return A5($author$project$Api$Company$Invoice$reverseBadDebt, apiClient, session, companyId, id, $author$project$Components$Invoice$ReversedBadDebt);
		}
	});
var $author$project$Components$AuditTrailLog$GotAudits = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Audit$Audit = $elm$core$Basics$identity;
var $author$project$Api$Audit$AuditRecord = F7(
	function (id, name, createdAt, whodunnit, crumbs, role, aggregate) {
		return {xf: aggregate, O1: createdAt, Pa: crumbs, ahP: id, Bq: name, ak3: role, aez: whodunnit};
	});
var $author$project$Api$Audit$Crumb$Crumb = F4(
	function (createdAt, item, diff, verb) {
		return {O1: createdAt, QB: diff, Io: item, aef: verb};
	});
var $author$project$Api$Audit$Crumb$Plain = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Audit$Crumb$Record = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Audit$Crumb$Linkable = F5(
	function (id, label, routeParts, type_, extraUrl) {
		return {aha: extraUrl, ahP: id, aih: label, ak5: routeParts, amg: type_};
	});
var $elm$json$Json$Decode$map5 = _Json_map5;
var $author$project$Api$Audit$Crumb$linkableDecoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Api$Audit$Crumb$Linkable,
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['id']),
		$elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['label']),
		$elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['route_parts']),
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['type']),
		$elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['extra_url']),
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)));
var $author$project$Api$Audit$Crumb$decodeChange = A2(
	$elm$json$Json$Decode$andThen,
	function (changesList) {
		if ((changesList.b && changesList.b.b) && (!changesList.b.b.b)) {
			var from = changesList.a;
			var _v1 = changesList.b;
			var to = _v1.a;
			return $elm$json$Json$Decode$succeed(
				_Utils_Tuple2(from, to));
		} else {
			return $elm$json$Json$Decode$fail('Expected changes to be of length 2');
		}
	},
	$elm$json$Json$Decode$list(
		$elm$json$Json$Decode$nullable(
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2($elm$json$Json$Decode$map, $author$project$Api$Audit$Crumb$Plain, $elm$json$Json$Decode$string),
						A2(
						$elm$json$Json$Decode$map,
						$author$project$Api$Audit$Crumb$Plain,
						A2($elm$json$Json$Decode$map, $elm$core$String$fromInt, $elm$json$Json$Decode$int)),
						A2(
						$elm$json$Json$Decode$map,
						$author$project$Api$Audit$Crumb$Plain,
						A2($elm$json$Json$Decode$map, $author$project$Formatters$Bool$toString, $elm$json$Json$Decode$bool)),
						A2($elm$json$Json$Decode$map, $author$project$Api$Audit$Crumb$Record, $author$project$Api$Audit$Crumb$linkableDecoder)
					])))));
var $author$project$Api$Audit$Crumb$Create = 0;
var $author$project$Api$Audit$Crumb$Delete = 2;
var $author$project$Api$Audit$Crumb$Update = 1;
var $author$project$Api$Audit$Crumb$decodeEvent = A2(
	$elm$json$Json$Decode$andThen,
	function (stringEvent) {
		switch (stringEvent) {
			case 'create':
				return $elm$json$Json$Decode$succeed(0);
			case 'update':
				return $elm$json$Json$Decode$succeed(1);
			case 'destroy':
				return $elm$json$Json$Decode$succeed(2);
			default:
				var unsupported = stringEvent;
				return $elm$json$Json$Decode$fail('unsupported event type ' + unsupported);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Audit$Crumb$decode = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'event',
	$author$project$Api$Audit$Crumb$decodeEvent,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'object_changes',
		$elm$json$Json$Decode$keyValuePairs($author$project$Api$Audit$Crumb$decodeChange),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'item',
			$author$project$Api$Audit$Crumb$linkableDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'created_at',
				$elm_community$json_extra$Json$Decode$Extra$datetime,
				$elm$json$Json$Decode$succeed($author$project$Api$Audit$Crumb$Crumb)))));
var $author$project$Api$Audit$Whodunnit = F2(
	function (id, name) {
		return {ahP: id, Bq: name};
	});
var $author$project$Api$Audit$decodeWhodunnit = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Audit$Whodunnit)));
var $author$project$Api$Audit$auditRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'aggregate',
	$elm$json$Json$Decode$maybe($author$project$Api$Audit$Crumb$linkableDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'request_session_role',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'crumbs',
			$elm$json$Json$Decode$list($author$project$Api$Audit$Crumb$decode),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'whodunnit',
				$author$project$Api$Audit$decodeWhodunnit,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'created_at',
					$elm_community$json_extra$Json$Decode$Extra$datetime,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'name',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Api$Audit$AuditRecord))))))));
var $author$project$Api$Audit$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Audit$auditRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Audit$listDefaults = {
	HM: $elm$core$Maybe$Nothing,
	ajJ: $author$project$Api$Pagination$init,
	Jy: $elm$core$Maybe$Nothing,
	Jz: $elm$core$Maybe$Nothing,
	JQ: $elm$core$Maybe$Just('request')
};
var $author$project$Api$Audit$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Audit$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				$author$project$Api$Pagination$toApiParams(options.ajJ),
				function () {
				var _v0 = options.JQ;
				if (!_v0.$) {
					var source_ = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'source', source_)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.Jy;
				if (!_v1.$) {
					var resource_ = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'resource', resource_)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.Jz;
				if (!_v2.$) {
					var resourceId_ = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'resource_id', resourceId_)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v3 = options.HM;
				if (!_v3.$) {
					var filter_ = _v3.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'filter', filter_)
						]);
				} else {
					return _List_Nil;
				}
			}()
			]));
};
var $author$project$Api$Audit$list = F3(
	function (apiClient, query, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Audit$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Audit$listOptionsToParams(query),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['audits']),
						$author$project$Api$Data$providerPath))));
	});
var $author$project$Components$AuditTrailLog$fetchAudits = F2(
	function (apiClient, optionals) {
		return A3($author$project$Api$Audit$list, apiClient, optionals, $author$project$Components$AuditTrailLog$GotAudits);
	});
var $author$project$Components$AuditTrailLog$optionalsFromModel = function (_v0) {
	var pagination = _v0.ajJ;
	var resource = _v0.Jy;
	var resourceId = _v0.Jz;
	var filter = _v0.HM;
	return function (d) {
		return _Utils_update(
			d,
			{HM: filter, ajJ: pagination, Jy: resource, Jz: resourceId});
	};
};
var $author$project$Components$AuditTrailLog$setPagination = function (model) {
	var _v0 = model.ro;
	if (_v0.$ === 3) {
		var records = _v0.a;
		var headers = _v0.b;
		return _Utils_update(
			model,
			{
				ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ),
				cU: _Utils_ap(model.cU, records)
			});
	} else {
		return model;
	}
};
var $author$project$Components$AuditTrailLog$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var showingAuditDetails = $author$project$Ui$Popover$isOpen(model.aT) ? model.cU : _List_Nil;
				var popover = A3(
					$author$project$Ui$Popover$init,
					'audit-history',
					!$author$project$Ui$Popover$isOpen(model.aT),
					$author$project$Components$AuditTrailLog$PopoverMsg);
				var pagination = $author$project$Ui$Popover$isOpen(model.aT) ? $author$project$Api$Pagination$init : model.ajJ;
				var auditsCmd = $author$project$Ui$Popover$isOpen(model.aT) ? $elm$core$Platform$Cmd$none : A2(
					$author$project$Components$AuditTrailLog$fetchAudits,
					apiClient,
					$author$project$Components$AuditTrailLog$optionalsFromModel(model));
				return {
					GZ: auditsCmd,
					aiO: _Utils_update(
						model,
						{ajJ: pagination, aT: popover, cU: showingAuditDetails}),
					aR: _List_Nil
				};
			case 1:
				var paginationMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, paginationMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{ajJ: pagination});
				return {
					GZ: A2(
						$author$project$Components$AuditTrailLog$fetchAudits,
						apiClient,
						$author$project$Components$AuditTrailLog$optionalsFromModel(newModel)),
					aiO: newModel,
					aR: _List_Nil
				};
			case 2:
				var audits = msg.a;
				var totalAuditsCount = function () {
					if (audits.$ === 3) {
						var headers = audits.b;
						return A2(
							$elm$core$Maybe$withDefault,
							0,
							A2(
								$elm$core$Maybe$andThen,
								$elm$core$String$toInt,
								A2($elm$core$Dict$get, 'x-total-count', headers)));
					} else {
						return 0;
					}
				}();
				return {
					GZ: $elm$core$Platform$Cmd$none,
					aiO: $author$project$Components$AuditTrailLog$setPagination(
						_Utils_update(
							model,
							{ro: audits, FV: totalAuditsCount})),
					aR: $author$project$OutMsg$handleErrorResponse(audits)
				};
			default:
				var subMsg = msg.a;
				var popoverModel = A2($author$project$Ui$Popover$update, subMsg, model.aT);
				var pagination = $author$project$Ui$Popover$isOpen(model.aT) ? $author$project$Api$Pagination$init : model.ajJ;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					aiO: _Utils_update(
						model,
						{ajJ: pagination, aT: popoverModel}),
					aR: _List_Nil
				};
		}
	});
var $author$project$Components$Company$VirtualBankAccounts$Invoice$update = F3(
	function (_v0, msg, _v1) {
		var model = _v1;
		if (!msg.$) {
			var response = msg.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{F7: response}),
				$elm$core$Platform$Cmd$none,
				$author$project$OutMsg$handleErrorResponse(response));
		} else {
			var field = msg.a;
			var copiedText = msg.b;
			return _Utils_Tuple3(
				model,
				$author$project$Ports$Clipboard$copy(copiedText),
				_List_fromArray(
					[
						A2($author$project$OutMsg$ShowToast, 3, field + ' copied to clipboard')
					]));
		}
	});
var $author$project$Components$CompanyEmailModal$BeforeSent = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$CompanyEmailModal$Closed = 0;
var $author$project$Components$CompanyEmailModal$Delivered = 1;
var $author$project$Components$CompanyEmailModal$Editing = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Components$CompanyEmailModal$None = 2;
var $author$project$Components$CompanyEmailModal$Open = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Components$CompanyEmailModal$GotDelivery = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$Notification$Shared$body = function (_v0) {
	var record = _v0;
	return record.fO;
};
var $author$project$Api$Provider$Notification$One$body = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Notification$Shared$body(shared);
};
var $author$project$Api$Provider$Notification$create = F6(
	function (apiClient, type_, recipient, contextId, fields, toMsg) {
		var body_ = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'notification',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'context_id',
								$elm$json$Json$Encode$string(contextId)),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'type',
									$elm$json$Json$Encode$string(
										$author$project$Api$Provider$Notification$typeToString(type_))),
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										'subject',
										A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.J_)),
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(
											'body',
											A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.fO)),
										function () {
											if (!recipient.$) {
												var patientId = recipient.a;
												return _List_fromArray(
													[
														_Utils_Tuple2(
														'patient',
														$elm$json$Json$Encode$string(patientId))
													]);
											} else {
												var companyId = recipient.a;
												return _List_fromArray(
													[
														_Utils_Tuple2(
														'company',
														$elm$json$Json$Encode$string(companyId))
													]);
											}
										}()))))))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Notification$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body_,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Notification$notificationsPath)));
	});
var $author$project$Api$Provider$Notification$Shared$subject = function (_v0) {
	var record = _v0;
	return record.J_;
};
var $author$project$Api$Provider$Notification$One$subject = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Notification$Shared$subject(shared);
};
var $author$project$Components$CompanyEmailModal$createNotification = F3(
	function (apiClient, _v0, preview) {
		var type_ = _v0.amg;
		var contextId = _v0.yP;
		var recipient = _v0.DI;
		return A6(
			$author$project$Api$Provider$Notification$create,
			apiClient,
			type_,
			$author$project$Api$Provider$Notification$Company(
				$author$project$Api$Provider$Company$One$id(recipient)),
			contextId,
			{
				fO: $author$project$Api$Provider$Notification$One$body(preview),
				J_: $author$project$Api$Provider$Notification$One$subject(preview)
			},
			$author$project$Components$CompanyEmailModal$GotDelivery);
	});
var $author$project$Components$CompanyEmailModal$initNotificationFormFields = function (notification) {
	return {
		fO: $author$project$Api$Provider$Notification$One$body(notification),
		J_: $author$project$Api$Provider$Notification$One$subject(notification)
	};
};
var $author$project$Components$CompanyEmailModal$notificationFormFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var string = field.a;
			return _Utils_update(
				fields,
				{
					J_: $author$project$Utils$String$toMaybe(string)
				});
		} else {
			var string = field.a;
			return _Utils_update(
				fields,
				{
					fO: $author$project$Utils$String$toMaybe(string)
				});
		}
	});
var $author$project$Components$CompanyEmailModal$BodyValidation = 1;
var $author$project$Components$CompanyEmailModal$SubjectValidation = 0;
var $author$project$Components$CompanyEmailModal$notificationFormFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.J_;
			},
			_Utils_Tuple2(0, 'Please enter a valid subject')),
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.fO;
			},
			_Utils_Tuple2(1, 'Please enter a valid body'))
		]));
var $author$project$Components$CompanyEmailModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
			case 1:
				if (model.$ === 2) {
					var shared = model.a;
					var notificationForm = model.b;
					var preview = model.c;
					var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$CompanyEmailModal$notificationFormFieldsValidator, notificationForm);
					if (!_v2.$) {
						var _v3 = _v2.a;
						var newForm = _v3.a;
						var validFormFields = _v3.b;
						return {
							GZ: A3(
								$author$project$Components$CompanyEmailModal$previewNotification,
								apiClient,
								shared,
								$elm$core$Maybe$Just(validFormFields)),
							agZ: 2,
							aiO: A3($author$project$Components$CompanyEmailModal$Editing, shared, newForm, $author$project$Api$Data$Loading),
							aR: _List_Nil
						};
					} else {
						var newForm = _v2.a;
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 2,
							aiO: A3($author$project$Components$CompanyEmailModal$Editing, shared, newForm, preview),
							aR: _List_Nil
						};
					}
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 2, aiO: model, aR: _List_Nil};
				}
			case 2:
				if (model.$ === 1) {
					var shared = model.a;
					var preview = model.b;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 2,
						aiO: A3(
							$author$project$Components$CompanyEmailModal$Editing,
							shared,
							$author$project$Utils$Form$init(
								$author$project$Components$CompanyEmailModal$initNotificationFormFields(preview)),
							$author$project$Api$Data$NotAsked),
						aR: _List_Nil
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 2, aiO: model, aR: _List_Nil};
				}
			case 3:
				if (model.$ === 1) {
					var shared = model.a;
					var preview = model.b;
					return {
						GZ: function () {
							var _v6 = shared.GD;
							if (!_v6.$) {
								var beforeSend = _v6.a;
								return beforeSend($author$project$Components$CompanyEmailModal$BeforeSent);
							} else {
								return A3($author$project$Components$CompanyEmailModal$createNotification, apiClient, shared, preview);
							}
						}(),
						agZ: 2,
						aiO: A3($author$project$Components$CompanyEmailModal$Open, shared, preview, $author$project$Api$Data$Loading),
						aR: _List_Nil
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 2, aiO: model, aR: _List_Nil};
				}
			case 4:
				var response = msg.a;
				if (model.$ === 1) {
					var shared = model.a;
					var preview = model.b;
					if (response.$ === 3) {
						return {
							GZ: A3($author$project$Components$CompanyEmailModal$createNotification, apiClient, shared, preview),
							agZ: 2,
							aiO: model,
							aR: _List_Nil
						};
					} else {
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 2,
							aiO: A3($author$project$Components$CompanyEmailModal$Open, shared, preview, $author$project$Api$Data$NotAsked),
							aR: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 2, aiO: model, aR: _List_Nil};
				}
			case 5:
				var response = msg.a;
				var _v9 = _Utils_Tuple2(model, response);
				switch (_v9.a.$) {
					case 0:
						if (_v9.b.$ === 3) {
							var shared = _v9.a.a;
							var _v10 = _v9.b;
							var preview = _v10.a;
							return {
								GZ: $elm$core$Platform$Cmd$none,
								agZ: 2,
								aiO: A3($author$project$Components$CompanyEmailModal$Open, shared, preview, $author$project$Api$Data$NotAsked),
								aR: _List_Nil
							};
						} else {
							var shared = _v9.a.a;
							return {
								GZ: $elm$core$Platform$Cmd$none,
								agZ: 0,
								aiO: $author$project$Components$CompanyEmailModal$Loading(shared),
								aR: $author$project$OutMsg$handleErrorResponse(response)
							};
						}
					case 2:
						if (_v9.b.$ === 3) {
							var _v11 = _v9.a;
							var shared = _v11.a;
							var _v12 = _v9.b;
							var preview = _v12.a;
							return {
								GZ: $elm$core$Platform$Cmd$none,
								agZ: 2,
								aiO: A3($author$project$Components$CompanyEmailModal$Open, shared, preview, $author$project$Api$Data$NotAsked),
								aR: _List_Nil
							};
						} else {
							var _v13 = _v9.a;
							var shared = _v13.a;
							var notificationForm = _v13.b;
							return {
								GZ: $elm$core$Platform$Cmd$none,
								agZ: 2,
								aiO: A3($author$project$Components$CompanyEmailModal$Editing, shared, notificationForm, response),
								aR: $author$project$OutMsg$handleErrorResponse(response)
							};
						}
					default:
						return {GZ: $elm$core$Platform$Cmd$none, agZ: 2, aiO: model, aR: _List_Nil};
				}
			case 6:
				var field = msg.a;
				if (model.$ === 2) {
					var shared = model.a;
					var notificationForm = model.b;
					var preview = model.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$CompanyEmailModal$notificationFormFieldsUpdate, field, notificationForm);
					var validatedForm = function () {
						var _v15 = A2($author$project$Utils$Form$validate, $author$project$Components$CompanyEmailModal$notificationFormFieldsValidator, newForm);
						if (!_v15.$) {
							var _v16 = _v15.a;
							var form = _v16.a;
							return form;
						} else {
							var form = _v15.a;
							return form;
						}
					}();
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 2,
						aiO: A3($author$project$Components$CompanyEmailModal$Editing, shared, validatedForm, preview),
						aR: _List_Nil
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 2, aiO: model, aR: _List_Nil};
				}
			default:
				var response = msg.a;
				if (model.$ === 1) {
					var shared = model.a;
					var preview = model.b;
					if (response.$ === 3) {
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 1,
							aiO: model,
							aR: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'This email is being sent')
								])
						};
					} else {
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 2,
							aiO: A3($author$project$Components$CompanyEmailModal$Open, shared, preview, response),
							aR: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 2, aiO: model, aR: _List_Nil};
				}
		}
	});
var $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$Affiliate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$Company = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Invoice$InvoiceLinesTable$ExportFileMsg = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$InvoiceLineDeleted = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Components$Invoice$InvoiceLinesTable$InvoiceLinesChanged = 0;
var $author$project$Components$Invoice$InvoiceLinesTable$None = 1;
var $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfoMsg = F2(
	function (a, b) {
		return {$: 14, a: a, b: b};
	});
var $author$project$Components$Invoice$InvoiceLinesTable$SearchInputMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$AffiliateBill$InvoiceLine$invoiceLinePath = F2(
	function (affiliateBillId, id) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id]),
			$author$project$Api$Provider$AffiliateBill$InvoiceLine$invoiceLinesPath(affiliateBillId));
	});
var $author$project$Api$Provider$AffiliateBill$InvoiceLine$delete = F4(
	function (apiClient, affiliateBillId, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Provider$AffiliateBill$InvoiceLine$invoiceLinePath, affiliateBillId, id)));
	});
var $author$project$Api$Provider$Company$Invoice$InvoiceLine$invoiceLinePath = F3(
	function (companyId, invoiceId, id) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id]),
			A2($author$project$Api$Provider$Company$Invoice$InvoiceLine$invoiceLinesPath, companyId, invoiceId));
	});
var $author$project$Api$Provider$Company$Invoice$InvoiceLine$delete = F5(
	function (apiClient, companyId, invoiceId, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A3($author$project$Api$Provider$Company$Invoice$InvoiceLine$invoiceLinePath, companyId, invoiceId, id)));
	});
var $author$project$Api$Provider$InvoiceLine$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$InvoiceLine$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$InvoiceLine$Shared$id(shared);
};
var $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$init = F4(
	function (session, invoiceType, usesEmployeeDivisions, invoiceLine) {
		return {yU: $author$project$Api$Data$NotAsked, sN: invoiceLine, gz: $author$project$Api$Data$NotAsked, Uv: invoiceType, aa4: session, p7: false, ad6: usesEmployeeDivisions};
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Affiliate = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Company = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$EmployerOrProviderCompany = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ProviderMin = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$adjustmentModalCompany = function (company) {
	return A2(
		$elm$core$Maybe$map,
		function (company_) {
			if (!company_.$) {
				var company__ = company_.a;
				return $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ProviderMin(company__);
			} else {
				var company__ = company_.a;
				return $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$EmployerOrProviderCompany(company__);
			}
		},
		company);
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotCategories = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotInvoiceLine = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$EndDateInputMsg = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$StartDateInputMsg = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$formFieldsInit = F5(
	function (apiClient, showItemTypeInTitle, session, today, category) {
		var _v0 = $author$project$Components$DateInput$init;
		var startDateInput = _v0.a;
		var startDateInputCmd = _v0.b;
		var _v1 = A3(
			$author$project$Components$ResourceFilter$Practitioner$init,
			apiClient,
			$elm$core$Basics$identity,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Unassigned', ai5: false});
			});
		var practitionerResourceFilter = _v1.a;
		var practitionerResourceFilterCmd = _v1.b;
		var _v2 = A4(
			$author$project$Components$ResourceFilter$Location$init,
			apiClient,
			$elm$core$Maybe$Nothing,
			$elm$core$Basics$identity,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Unassigned', ai5: false});
			});
		var locationResourceFilter = _v2.a;
		var locationResourceFilterCmd = _v2.b;
		var _v3 = $author$project$Components$DateInput$init;
		var endDateInput = _v3.a;
		var endDateInputCmd = _v3.b;
		var _v4 = A4(
			$author$project$Components$ResourceFilter$ChargeItem$initWithItemType,
			showItemTypeInTitle,
			apiClient,
			$elm$core$Basics$identity,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'None', Lr: false, ahw: true, ahx: '', ai5: false});
			});
		var chargeItemResourceFilter = _v4.a;
		var chargeItemResourceFilterCmd = _v4.b;
		var _v5 = A3(
			$author$project$Components$ResourceFilter$Category$init,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Unassigned', ai5: false});
			});
		var categoryResourceFilter = _v5.a;
		var categoryResourceFilterCmd = _v5.b;
		return _Utils_Tuple2(
			{
				GW: A2($elm$core$Maybe$map, $author$project$Api$Provider$Category$All$id, category),
				c8: categoryResourceFilter,
				mL: $elm$core$Maybe$Nothing,
				cq: chargeItemResourceFilter,
				Qr: '',
				QD: 0,
				QE: false,
				sb: $elm$core$Maybe$Nothing,
				sd: endDateInput,
				ahP: $elm$core$Maybe$Nothing,
				ais: $elm$core$Maybe$Nothing,
				os: locationResourceFilter,
				Bq: $elm$core$Maybe$Nothing,
				YY: $elm$core$Maybe$Nothing,
				aka: $elm$core$Maybe$Nothing,
				hk: practitionerResourceFilter,
				Dw: $elm$core$Maybe$Nothing,
				_h: $elm$core$Maybe$Nothing,
				Dz: $elm$core$Maybe$Just(1),
				DA: $elm$core$Maybe$Nothing,
				ab7: $elm$core$Maybe$Just(today),
				lx: startDateInput,
				acZ: false
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$StartDateInputMsg(startDateInput),
						startDateInputCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$EndDateInputMsg(endDateInput),
						endDateInputCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ChargeItemResourceFilterMsg, chargeItemResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CategoryResourceFilterMsg, categoryResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$PractitionerResourceFilterMsg, practitionerResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$LocationResourceFilterMsg, locationResourceFilterCmd)
					])));
	});
var $author$project$Api$Provider$Company$Account$companyAccountsPath = function (basePath) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['accounts']),
		basePath);
};
var $author$project$Api$Provider$CompanyAccount$All$CompanyAccount = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$CompanyAccount$All$Record = function (registrations) {
	return function (subscriber) {
		return function (division) {
			return function (membershipStartDate) {
				return function (defaultEnrollmentStartDate) {
					return function (invoicedThroughDate) {
						return function (membershipEndDate) {
							return function (status) {
								return function (plan) {
									return function (meta) {
										return {PZ: defaultEnrollmentStartDate, QO: division, Uw: invoicedThroughDate, WQ: membershipEndDate, WW: membershipStartDate, W4: meta, Jb: plan, akF: registrations, alH: status, acy: subscriber};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$CompanyAccount$Meta$Meta = $elm$core$Basics$identity;
var $author$project$Api$Provider$CompanyAccount$Meta$Record = F2(
	function (actions, membership) {
		return {vy: actions, kk: membership};
	});
var $author$project$Api$Provider$CompanyAccount$Meta$ActionsRecord = F3(
	function (needsApproval, canEnroll, isEligible) {
		return {M8: canEnroll, UO: isEligible, Xx: needsApproval};
	});
var $author$project$Api$Provider$CompanyAccount$Meta$actionsRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'eligible',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'enroll',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'needs_approval',
			$elm$json$Json$Decode$bool,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAccount$Meta$ActionsRecord))));
var $author$project$Api$Provider$CompanyAccount$Meta$MembershipRecord = F3(
	function (billFromDate, billingStartDate, endDate) {
		return {MD: billFromDate, MH: billingStartDate, sb: endDate};
	});
var $author$project$Api$Provider$CompanyAccount$Meta$EndDateRecord = F4(
	function (defaultValue, maxWithoutBilling, min, minWithoutProration) {
		return {Qf: defaultValue, WE: maxWithoutBilling, W9: min, Xc: minWithoutProration};
	});
var $author$project$Api$Provider$CompanyAccount$Meta$endDateRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'min_without_proration',
	$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'min',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'max_without_billing',
			$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'default_value',
				$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAccount$Meta$EndDateRecord)))));
var $author$project$Api$Provider$CompanyAccount$Meta$membershipRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'end_date',
	$author$project$Api$Provider$CompanyAccount$Meta$endDateRecordDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'billing_start_date',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'bill_from_date',
			$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAccount$Meta$MembershipRecord))));
var $author$project$Api$Provider$CompanyAccount$Meta$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'membership',
	$author$project$Api$Provider$CompanyAccount$Meta$membershipRecordDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'actions',
		$author$project$Api$Provider$CompanyAccount$Meta$actionsRecordDecoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAccount$Meta$Record)));
var $author$project$Api$Provider$CompanyAccount$Meta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CompanyAccount$Meta$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$CompanyRegistration = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$Record = F5(
	function (patient, account, status, membershipStartDate, meta) {
		return {KF: account, WW: membershipStartDate, W4: meta, YY: patient, alH: status};
	});
var $author$project$Api$Provider$Meta$CompanyRegistration$Meta = $elm$core$Basics$identity;
var $author$project$Api$Provider$Meta$CompanyRegistration$Record = function (actions) {
	return {vy: actions};
};
var $author$project$Api$Provider$Meta$CompanyRegistration$ActionsRecord = F3(
	function (enroll, needsApproval, isEligible) {
		return {Rz: enroll, UO: isEligible, Xx: needsApproval};
	});
var $author$project$Api$Provider$Meta$CompanyRegistration$actionsRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'eligible',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'needs_approval',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'enroll',
			$elm$json$Json$Decode$bool,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Meta$CompanyRegistration$ActionsRecord))));
var $author$project$Api$Provider$Meta$CompanyRegistration$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'actions',
	$author$project$Api$Provider$Meta$CompanyRegistration$actionsRecordDecoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Meta$CompanyRegistration$Record));
var $author$project$Api$Provider$Meta$CompanyRegistration$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Meta$CompanyRegistration$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'meta',
	$author$project$Api$Provider$Meta$CompanyRegistration$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'membership_start_date',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'status',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'account',
				$author$project$Api$Provider$CompanyAccount$Min$decoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'patient',
					$author$project$Api$Provider$Patient$Min$decoder,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$Record))))));
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$CompanyRegistration$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$CompanyRegistration)));
var $author$project$Api$Provider$CompanyAccount$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'meta',
	$author$project$Api$Provider$CompanyAccount$Meta$decoder,
	A3(
		$author$project$Api$Expandable$expandable,
		'plan',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Plan$Min$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'status',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'membership_end_date',
				$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'invoiced_through_date',
					$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'default_enrollment_start_date',
						$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'membership_start_date',
							$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'division',
								$elm$json$Json$Decode$nullable($author$project$Api$Provider$EmployeeDivision$Shared$decoder),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'subscriber',
									$elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Shared$decoder),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'registrations',
										$elm$json$Json$Decode$list($author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$decoder),
										$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAccount$All$Record)))))))))));
var $author$project$Api$Provider$CompanyAccount$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CompanyAccount$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$CompanyAccount$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAccount$All$CompanyAccount)));
var $author$project$Api$Provider$Company$Account$expandToString = function (expand) {
	switch (expand) {
		case 2:
			return 'plan';
		case 1:
			return 'registrations';
		default:
			return 'membership_patients';
	}
};
var $author$project$Api$Provider$Company$Account$listDefaults = {HE: _List_Nil, HM: $elm$core$Maybe$Nothing, ahP: $elm$core$Maybe$Nothing, ajJ: $author$project$Api$Pagination$init, akl: $elm$core$Maybe$Nothing, alA: $author$project$Api$Sort$init};
var $author$project$Api$Provider$Company$Account$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Company$Account$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.akl;
				if (!_v0.$) {
					var q = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', q)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.ahP;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.HM;
				if (!_v2.$) {
					var string = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'filter', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				A2($author$project$Api$Expandable$toParam, $author$project$Api$Provider$Company$Account$expandToString, options.HE),
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$Provider$Company$Account$list = F4(
	function (apiClient, basePath, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$CompanyAccount$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Company$Account$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Company$Account$companyAccountsPath(basePath))));
	});
var $author$project$Api$Provider$CompanyAccount$All$registrations = function (_v0) {
	var record = _v0.b;
	return record.akF;
};
var $author$project$Components$ResourceFilter$CompanyRegistration$list = F4(
	function (apiClient, basePath, optionals, toMsg) {
		return A4(
			$author$project$Api$Provider$Company$Account$list,
			apiClient,
			basePath,
			optionals,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$concatMap($author$project$Api$Provider$CompanyAccount$All$registrations))));
	});
var $author$project$Components$ResourceFilter$CompanyRegistration$fetchResources = F6(
	function (basePath, listOptionals, toMsg, apiClient, pagination, query) {
		return A4(
			$author$project$Components$ResourceFilter$CompanyRegistration$list,
			apiClient,
			basePath,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{ajJ: pagination, akl: query});
				}),
			toMsg);
	});
var $author$project$Components$ResourceFilter$CompanyRegistration$retrieveResource = F5(
	function (basePath, listOptionals, toMsg, apiClient, id) {
		return A4(
			$author$project$Components$ResourceFilter$CompanyRegistration$list,
			apiClient,
			basePath,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{
							ahP: $elm$core$Maybe$Just(id)
						});
				}),
			toMsg);
	});
var $author$project$Components$ResourceFilter$CompanyRegistration$selectId = 'company-reigstrations';
var $author$project$Api$Provider$Patient$Min$name = function (_v0) {
	var min = _v0;
	return min.Bq;
};
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$patient = function (_v0) {
	var record = _v0.b;
	return record.YY;
};
var $author$project$Components$ResourceFilter$CompanyRegistration$toTitle = A2($elm$core$Basics$composeR, $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$patient, $author$project$Api$Provider$Patient$Min$name);
var $author$project$Components$ResourceFilter$CompanyRegistration$toLabel = function (resource) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Components$ResourceFilter$CompanyRegistration$toTitle(resource))
		]);
};
var $author$project$Api$Provider$CompanyRegistration$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyRegistration$Shared$id(shared);
};
var $author$project$Components$ResourceFilter$CompanyRegistration$toValue = $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$id;
var $author$project$Components$ResourceFilter$CompanyRegistration$init = F4(
	function (apiClient, basePath, listOptionals, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{
				Sk: A2($author$project$Components$ResourceFilter$CompanyRegistration$fetchResources, basePath, listOptionals),
				ahP: $author$project$Components$ResourceFilter$CompanyRegistration$selectId,
				k$: 'Registration',
				uk: A2($author$project$Components$ResourceFilter$CompanyRegistration$retrieveResource, basePath, listOptionals),
				u9: $author$project$Components$ResourceFilter$CompanyRegistration$toLabel,
				lN: $author$project$Components$ResourceFilter$CompanyRegistration$toTitle,
				hX: $author$project$Components$ResourceFilter$CompanyRegistration$toValue
			},
			A2(
				$elm$core$Basics$composeL,
				optionals,
				function (d) {
					return _Utils_update(
						d,
						{JK: false});
				}));
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{Jy: $author$project$Components$ResourceFilter$All, b8: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Api$Provider$InvoiceLine$One$InvoiceLine = $elm$core$Basics$identity;
var $author$project$Api$Provider$InvoiceLine$One$Record = F3(
	function (status, charges, companyAccount) {
		return {NA: charges, Ob: companyAccount, alH: status};
	});
var $author$project$Api$Provider$Charge$One$Charge = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Charge$Shared$Charge = $elm$core$Basics$identity;
var $author$project$Api$Provider$Charge$Shared$Record = function (id) {
	return function (name) {
		return function (issuedSubtotalInCents) {
			return function (subtotalInCents) {
				return function (totalInCents) {
					return function (description) {
						return function (issuedPriceInCents) {
							return function (priceInCents) {
								return function (issuedQuantity) {
									return function (quantity) {
										return function (discountOverridden) {
											return function (discountInCents) {
												return function (date) {
													return function (endDate) {
														return function (taxable) {
															return function (type_) {
																return function (isPersisted) {
																	return {PB: date, Qr: description, QD: discountInCents, QE: discountOverridden, sb: endDate, ahP: id, U4: isPersisted, Vo: issuedPriceInCents, Vp: issuedQuantity, Vr: issuedSubtotalInCents, Bq: name, Dw: priceInCents, Dz: quantity, acD: subtotalInCents, acZ: taxable, adp: totalInCents, amg: type_};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Charge$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'is_persisted',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'type',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'taxable',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'end_date',
				$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'date',
					$author$project$Utils$Date$decode,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'discount_in_cents',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'discount_overridden',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'quantity',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'issued_quantity',
									$elm$json$Json$Decode$int,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'price_in_cents',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'issued_price_in_cents',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'description',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'total_in_cents',
													$elm$json$Json$Decode$int,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'subtotal_in_cents',
														$elm$json$Json$Decode$int,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'issued_subtotal_in_cents',
															$elm$json$Json$Decode$int,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'name',
																$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'id',
																	$elm$json$Json$Decode$string,
																	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Charge$Shared$Record))))))))))))))))));
var $author$project$Api$Provider$Charge$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Charge$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Charge$One$Record = function (practitioner) {
	return function (location) {
		return function (priceUom) {
			return function (quantityUom) {
				return function (issuedQuantityUom) {
					return function (chargeItem) {
						return function (category) {
							return function (patient) {
								return function (invoice) {
									return function (isLocked) {
										return function (rulePayer) {
											return function (meta) {
												return function (prepaidCharges) {
													return function (consumedPrepaidCharges) {
														return {GW: category, mL: chargeItem, Ot: consumedPrepaidCharges, Uk: invoice, UU: isLocked, Vq: issuedQuantityUom, ais: location, W4: meta, YY: patient, aka: practitioner, _b: prepaidCharges, _h: priceUom, DA: quantityUom, aaj: rulePayer};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Charge$RulePayer$Patient = 1;
var $author$project$Api$Charge$RulePayer$Sponsor = 0;
var $author$project$Api$Charge$RulePayer$rulePayerDecoder = function (string) {
	switch (string) {
		case 'sponsor':
			return $elm$json$Json$Decode$succeed(0);
		case 'patient':
			return $elm$json$Json$Decode$succeed(1);
		default:
			return $elm$json$Json$Decode$fail('Unsupported charge rule payer: ' + string);
	}
};
var $author$project$Api$Charge$RulePayer$decoder = A2($elm$json$Json$Decode$andThen, $author$project$Api$Charge$RulePayer$rulePayerDecoder, $elm$json$Json$Decode$string);
var $author$project$Api$Common$Payable$Invoice$MinWithOwner$Invoice = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Common$Payable$Invoice$Min$Invoice = $elm$core$Basics$identity;
var $author$project$Api$Common$Payable$Invoice$Min$Record = F7(
	function (type_, id, invoiceNumber, status, date, humanStatus, paymentScheduledOn) {
		return {PB: date, TH: humanStatus, ahP: id, Uu: invoiceNumber, Zf: paymentScheduledOn, alH: status, amg: type_};
	});
var $author$project$Api$Common$Payable$Invoice$Type$CompanyInvoice = 0;
var $author$project$Api$Common$Payable$Invoice$Type$CustomerInvoice = 1;
var $author$project$Api$Common$Payable$Invoice$Type$PracticeInvoice = 2;
var $author$project$Api$Common$Payable$Invoice$Type$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'Invoice':
				return $elm$json$Json$Decode$succeed(0);
			case 'CustomerInvoice':
				return $elm$json$Json$Decode$succeed(1);
			case 'PracticeInvoice':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Unsupported invoice type: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Common$Payable$Invoice$Min$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'payment_scheduled_on',
	$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'human_status',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'date',
			$author$project$Utils$Date$decode,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'status',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'invoice_number',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'type',
							$author$project$Api$Common$Payable$Invoice$Type$decoder,
							$elm$json$Json$Decode$succeed($author$project$Api$Common$Payable$Invoice$Min$Record))))))));
var $author$project$Api$Common$Payable$Invoice$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Payable$Invoice$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$Payable$Invoice$MinWithOwner$Record = function (owner) {
	return {YD: owner};
};
var $author$project$Api$Common$Payable$Invoice$MinWithOwner$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'owner',
	$elm$json$Json$Decode$nullable($author$project$Api$Common$Payable$Owner$Min$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Common$Payable$Invoice$MinWithOwner$Record));
var $author$project$Api$Common$Payable$Invoice$MinWithOwner$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Payable$Invoice$MinWithOwner$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Common$Payable$Invoice$Min$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Common$Payable$Invoice$MinWithOwner$Invoice)));
var $author$project$Api$Provider$ChargeItem$ForCharge$ChargeItem = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$ChargeItem$ForCharge$Record = function (uom) {
	return {adP: uom};
};
var $author$project$Api$Provider$ChargeItem$ForCharge$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'uom',
	$author$project$Api$Provider$Uom$Shared$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeItem$ForCharge$Record));
var $author$project$Api$Provider$ChargeItem$ForCharge$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ChargeItem$ForCharge$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$ChargeItem$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeItem$ForCharge$ChargeItem)));
var $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$Patient = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$Record = F2(
	function (practitioner, location) {
		return {ais: location, aka: practitioner};
	});
var $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'location',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Location$Min$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'practitioner',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Practitioner$Min$decoder),
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$Record)));
var $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Patient$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$Patient)));
var $author$project$Api$Provider$PrepaidCharge$PrepaidCharge = $elm$core$Basics$identity;
var $author$project$Api$Provider$PrepaidCharge$PrepaidChargeRecord = F6(
	function (id, originalQuantity, remainingQuantity, priceInCents, chargeItem, charge) {
		return {afx: charge, mL: chargeItem, ahP: id, Yw: originalQuantity, Dw: priceInCents, $t: remainingQuantity};
	});
var $author$project$Api$Provider$PrepaidCharge$Charge = F2(
	function (id, name) {
		return {ahP: id, Bq: name};
	});
var $author$project$Api$Provider$PrepaidCharge$chargeDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$PrepaidCharge$Charge)));
var $author$project$Api$Provider$PrepaidCharge$decoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'charge',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Api$Provider$PrepaidCharge$chargeDecoder),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'charge_item',
			$author$project$Api$Provider$ChargeItem$Min$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'price_in_cents',
				$author$project$Currency$decode,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'remaining_quantity',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'original_quantity',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Api$Provider$PrepaidCharge$PrepaidChargeRecord))))))));
var $author$project$Api$Provider$Charge$One$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'consumed_prepaid_charges',
	$elm$json$Json$Decode$list($author$project$Api$Provider$PrepaidCharge$decoder),
	_List_Nil,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'prepaid_charges',
		$elm$json$Json$Decode$list($author$project$Api$Provider$PrepaidCharge$decoder),
		_List_Nil,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'meta',
			$author$project$Api$Provider$Charge$Meta$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'rule_payer',
				$elm$json$Json$Decode$nullable($author$project$Api$Charge$RulePayer$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'is_locked',
					$elm$json$Json$Decode$bool,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'invoice',
						$elm$json$Json$Decode$nullable($author$project$Api$Common$Payable$Invoice$MinWithOwner$decoder),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'patient',
							$elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$decoder),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'category',
								$elm$json$Json$Decode$nullable($author$project$Api$Provider$Category$Shared$decoder),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'charge_item',
									$elm$json$Json$Decode$nullable($author$project$Api$Provider$ChargeItem$ForCharge$decoder),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'issued_quantity_uom',
										$author$project$Api$Provider$Uom$Shared$decoder,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'quantity_uom',
											$author$project$Api$Provider$Uom$Shared$decoder,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'price_uom',
												$author$project$Api$Provider$Uom$Shared$decoder,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'location',
													$elm$json$Json$Decode$nullable($author$project$Api$Provider$Location$Min$decoder),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'practitioner',
														$elm$json$Json$Decode$nullable($author$project$Api$Provider$Practitioner$Shared$decoder),
														$elm$json$Json$Decode$succeed($author$project$Api$Provider$Charge$One$Record)))))))))))))));
var $author$project$Api$Provider$Charge$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Charge$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Charge$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Charge$One$Charge)));
var $author$project$Api$Provider$CompanyAccount$One$CompanyAccount = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$CompanyAccount$One$Record = F6(
	function (division, subscriber, selectedPlan, memberships, membershipPlan, registrations) {
		return {QO: division, WU: membershipPlan, WZ: memberships, akF: registrations, aaH: selectedPlan, acy: subscriber};
	});
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOne$CompanyRegistration = $elm$core$Basics$identity;
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOne$Record = function (patient) {
	return {YY: patient};
};
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOne$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'patient',
	$author$project$Api$Provider$Patient$Min$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOne$Record));
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOne$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOne$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Membership$ForCompanyAccountOne$Membership = $elm$core$Basics$identity;
var $author$project$Api$Provider$Membership$ForCompanyAccountOne$Record = function (membershipPatients) {
	return {WR: membershipPatients};
};
var $author$project$Api$Provider$MembershipPatient$Min$MembershipPatient = $elm$core$Basics$identity;
var $author$project$Api$Provider$MembershipPatient$Min$Record = F2(
	function (name, periodRateInCents) {
		return {Bq: name, Zt: periodRateInCents};
	});
var $author$project$Api$Provider$MembershipPatient$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'period_rate_in_cents',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$MembershipPatient$Min$Record)));
var $author$project$Api$Provider$MembershipPatient$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$MembershipPatient$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Membership$ForCompanyAccountOne$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'membership_patients',
	$elm$json$Json$Decode$list($author$project$Api$Provider$MembershipPatient$Min$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$ForCompanyAccountOne$Record));
var $author$project$Api$Provider$Membership$ForCompanyAccountOne$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Membership$ForCompanyAccountOne$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CompanyAccount$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'registrations',
	$elm$json$Json$Decode$list($author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOne$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'membership_plan',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Plan$Min$decoder),
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'memberships',
			$elm$json$Json$Decode$list($author$project$Api$Provider$Membership$ForCompanyAccountOne$decoder),
			_List_Nil,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'selected_plan',
				$elm$json$Json$Decode$nullable($author$project$Api$Provider$Plan$Min$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'subscriber',
					$elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Shared$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'division',
						$elm$json$Json$Decode$nullable($author$project$Api$Provider$EmployeeDivision$All$decoder),
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAccount$One$Record)))))));
var $author$project$Api$Provider$CompanyAccount$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CompanyAccount$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$CompanyAccount$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAccount$One$CompanyAccount)));
var $author$project$Api$Provider$InvoiceLine$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'company_account',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$CompanyAccount$One$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'charges',
		$elm$json$Json$Decode$list($author$project$Api$Provider$Charge$One$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'status',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$InvoiceLine$One$Record))));
var $author$project$Api$Provider$InvoiceLine$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$InvoiceLine$One$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$AffiliateBill$InvoiceLine$retrieve = F4(
	function (apiClient, affiliateBillId, id, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$InvoiceLine$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Provider$AffiliateBill$InvoiceLine$invoiceLinePath, affiliateBillId, id)));
	});
var $author$project$Api$Provider$Company$Invoice$InvoiceLine$retrieve = F5(
	function (apiClient, companyId, invoiceId, id, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$InvoiceLine$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A3($author$project$Api$Provider$Company$Invoice$InvoiceLine$invoiceLinePath, companyId, invoiceId, id)));
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$init = F7(
	function (apiClient, currentDate, session, practice, company, invoiceType, invoiceLineId) {
		var companyRegistrationsBasePath = function () {
			if (invoiceType.$ === 1) {
				var companyId_ = invoiceType.a;
				return $author$project$Api$Provider$Company$companyPath(companyId_);
			} else {
				var affiliateId = invoiceType.a;
				return $author$project$Api$Provider$Affiliate$affiliatePath(affiliateId);
			}
		}();
		var _v0 = A4(
			$author$project$Components$ResourceFilter$CompanyRegistration$init,
			apiClient,
			companyRegistrationsBasePath,
			$elm$core$Basics$identity,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'None', ai5: false});
			});
		var companyRegistrationResourceFilter = _v0.a;
		var companyRegistrationResourceFilterCmd = _v0.b;
		var _v1 = function () {
			var _v2 = _Utils_Tuple2(invoiceLineId, invoiceType);
			if (!_v2.a.$) {
				if (_v2.b.$ === 1) {
					var invoiceLineId_ = _v2.a.a;
					var _v3 = _v2.b;
					var companyId_ = _v3.a;
					var invoiceId = _v3.b;
					return _Utils_Tuple2(
						$elm$core$Maybe$Nothing,
						A5($author$project$Api$Provider$Company$Invoice$InvoiceLine$retrieve, apiClient, companyId_, invoiceId, invoiceLineId_, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotInvoiceLine));
				} else {
					var invoiceLineId_ = _v2.a.a;
					var _v4 = _v2.b;
					var affiliateBillId = _v4.b;
					return _Utils_Tuple2(
						$elm$core$Maybe$Nothing,
						A4($author$project$Api$Provider$AffiliateBill$InvoiceLine$retrieve, apiClient, affiliateBillId, invoiceLineId_, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotInvoiceLine));
				}
			} else {
				if (_v2.b.$ === 1) {
					var _v5 = _v2.a;
					var _v6 = _v2.b;
					return _Utils_Tuple2(
						$elm$core$Maybe$Nothing,
						A3(
							$author$project$Api$Provider$Category$list,
							apiClient,
							function (d) {
								return _Utils_update(
									d,
									{
										Ho: $elm$core$Maybe$Just(true)
									});
							},
							$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotCategories));
				} else {
					var _v7 = _v2.a;
					var _v8 = _v2.b;
					var _v9 = A5(
						$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$formFieldsInit,
						apiClient,
						A2($author$project$Utils$FeatureGate$gateAvailable, 14, practice),
						session,
						currentDate,
						$elm$core$Maybe$Nothing);
					var formFields = _v9.a;
					var formFieldsCmd = _v9.b;
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(
							$author$project$Utils$Form$init(formFields)),
						formFieldsCmd);
				}
			}
		}();
		var form = _v1.a;
		var cmd = _v1.b;
		return _Utils_Tuple2(
			{afQ: company, Ob: $author$project$Api$Data$NotAsked, f_: companyRegistrationResourceFilter, dd: currentDate, QE: false, SD: form, sN: $author$project$Api$Data$NotAsked, sO: invoiceLineId, Uv: invoiceType, ZV: practice, akd: $author$project$Api$Data$NotAsked, eW: $jinjor$elm_debounce$Debounce$init, k9: $author$project$Api$Data$NotAsked, aa4: session},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						cmd,
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CompanyRegistrationResourceFilterMsg, companyRegistrationResourceFilterCmd)
					])));
	});
var $author$project$Components$Invoice$InvoiceLinesTable$openAdjustmentModal = F3(
	function (apiClient, model, id) {
		var invoiceType = function () {
			var _v1 = model.Uv;
			if (!_v1.$) {
				var affiliateId = _v1.a;
				var affiliateBillId = _v1.b;
				return A2($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Affiliate, affiliateId, affiliateBillId);
			} else {
				var companyId_ = _v1.a;
				var invoiceId = _v1.b;
				return A2($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Company, companyId_, invoiceId);
			}
		}();
		var _v0 = A7(
			$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$init,
			apiClient,
			model.dd,
			model.aa4,
			model.ZV,
			$author$project$Components$Invoice$InvoiceLinesTable$adjustmentModalCompany(model.afQ),
			invoiceType,
			id);
		var adjustmentModal = _v0.a;
		var adjustmentModalCmd = _v0.b;
		return {
			GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModalMsg, adjustmentModalCmd),
			agZ: 1,
			aiO: _Utils_update(
				model,
				{
					il: $elm$core$Maybe$Just(adjustmentModal)
				}),
			aR: _List_Nil
		};
	});
var $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$GotInvoiceLineDetails = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Employer$Invoice$InvoiceLine$invoiceLinePath = F2(
	function (invoiceId, id) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id]),
			$author$project$Api$Employer$Invoice$InvoiceLine$invoiceLinesPath(invoiceId));
	});
var $author$project$Api$Employer$Invoice$InvoiceLine$retrieve = F4(
	function (apiClient, invoiceId, id, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$InvoiceLine$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Employer$Invoice$InvoiceLine$invoiceLinePath, invoiceId, id)));
	});
var $author$project$Api$Company$Invoice$InvoiceLine$retrieve = F6(
	function (apiClient, session, companyId, invoiceId, id, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4($author$project$Api$Employer$Invoice$InvoiceLine$retrieve, apiClient, invoiceId, id, toMsg) : A5($author$project$Api$Provider$Company$Invoice$InvoiceLine$retrieve, apiClient, companyId, invoiceId, id, toMsg);
	});
var $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$retrieveInvoiceLine = F4(
	function (apiClient, session, invoiceType, invoiceLine) {
		if (invoiceType.$ === 1) {
			var companyId = invoiceType.a;
			var invoiceId = invoiceType.b;
			return A6(
				$author$project$Api$Company$Invoice$InvoiceLine$retrieve,
				apiClient,
				session,
				companyId,
				invoiceId,
				$author$project$Api$Provider$InvoiceLine$All$id(invoiceLine),
				$author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$GotInvoiceLineDetails);
		} else {
			var invoiceId = invoiceType.a;
			return A4(
				$author$project$Api$Provider$AffiliateBill$InvoiceLine$retrieve,
				apiClient,
				invoiceId,
				$author$project$Api$Provider$InvoiceLine$All$id(invoiceLine),
				$author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$GotInvoiceLineDetails);
		}
	});
var $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$refresh = F2(
	function (apiClient, model) {
		var _v0 = model.gz;
		if (_v0.$ === 3) {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{gz: $author$project$Api$Data$Loading}),
				A4($author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$retrieveInvoiceLine, apiClient, model.aa4, model.Uv, model.sN));
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Components$Invoice$InvoiceLinesTable$refreshPhiMoreInfo = F3(
	function (apiClient, phiMoreInfos, id) {
		if (!id.$) {
			var id_ = id.a;
			var _v1 = A2($elm$core$Dict$get, id_, phiMoreInfos);
			if (!_v1.$) {
				var phiMoreInfo = _v1.a;
				var _v2 = A2($author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$refresh, apiClient, phiMoreInfo);
				var phiMoreInfo_ = _v2.a;
				var phiMoreInfoCmd = _v2.b;
				return _Utils_Tuple2(
					A3($elm$core$Dict$insert, id_, phiMoreInfo_, phiMoreInfos),
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfoMsg(id_),
						phiMoreInfoCmd));
			} else {
				return _Utils_Tuple2(phiMoreInfos, $elm$core$Platform$Cmd$none);
			}
		} else {
			return _Utils_Tuple2(phiMoreInfos, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Category = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ChargeCreated = {$: 3};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ChargeItem = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Closed = {$: 1};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CompanyRegistration = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$EndDate = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotAffiliatePatient = function (a) {
	return {$: 20, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotChargeUpdated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotPatient = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$InvoiceLineUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Location = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None = {$: 0};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Practitioner = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Practitioner$Shared$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$StartDate = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$account = function (_v0) {
	var record = _v0.b;
	return record.KF;
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotPreview = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Provider$Charge$Calculate$Charge = $elm$core$Basics$identity;
var $author$project$Api$Provider$Charge$Calculate$Record = F8(
	function (priceInCents, discountInCents, subtotalInCents, issuedSubtotalInCents, routedInvoice, adjudicatedPayer, coveredCharges, prepaidAllocatedQuantity) {
		return {K9: adjudicatedPayer, OX: coveredCharges, QD: discountInCents, Vr: issuedSubtotalInCents, _a: prepaidAllocatedQuantity, Dw: priceInCents, aaa: routedInvoice, acD: subtotalInCents};
	});
var $author$project$Api$Provider$Charge$AdjudicatedPayer$One$AdjudicatedPayer = $elm$core$Basics$identity;
var $author$project$Api$Provider$Charge$AdjudicatedPayer$One$Record = F3(
	function (id, name, payerType) {
		return {ahP: id, Bq: name, Y6: payerType};
	});
var $author$project$Api$Provider$Charge$AdjudicatedPayer$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'type',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Charge$AdjudicatedPayer$One$Record))));
var $author$project$Api$Provider$Charge$AdjudicatedPayer$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Charge$AdjudicatedPayer$One$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Charge$RoutedInvoice$One$RoutedInvoice = $elm$core$Basics$identity;
var $author$project$Api$Provider$Charge$RoutedInvoice$One$Record = function (id) {
	return {ahP: id};
};
var $author$project$Api$Provider$Charge$RoutedInvoice$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'id',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Charge$RoutedInvoice$One$Record));
var $author$project$Api$Provider$Charge$RoutedInvoice$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Charge$RoutedInvoice$One$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CoveredCharge$All$CoveredCharge = $elm$core$Basics$identity;
var $author$project$Api$Provider$CoveredCharge$All$Record = function (coverageRule) {
	return {OU: coverageRule};
};
var $author$project$Api$Provider$CoveredCharge$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'coverage_rule',
	$author$project$Api$Provider$CoverageRule$Shared$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$CoveredCharge$All$Record));
var $author$project$Api$Provider$CoveredCharge$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CoveredCharge$All$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Charge$Calculate$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'prepaid_allocated_quantity',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'covered_charges',
		$elm$json$Json$Decode$list($author$project$Api$Provider$CoveredCharge$All$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'adjudicated_payer',
			$elm$json$Json$Decode$nullable($author$project$Api$Provider$Charge$AdjudicatedPayer$One$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'routed_invoice',
				$elm$json$Json$Decode$nullable($author$project$Api$Provider$Charge$RoutedInvoice$One$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'issued_subtotal_in_cents',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'subtotal_in_cents',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'discount_in_cents',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'price_in_cents',
								$elm$json$Json$Decode$int,
								$elm$json$Json$Decode$succeed($author$project$Api$Provider$Charge$Calculate$Record)))))))));
var $author$project$Api$Provider$Charge$Calculate$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Charge$Calculate$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Charge$calculate = F4(
	function (basePath, apiClient, fields, toMsg) {
		var quantityUom = function () {
			var _v5 = fields.DA;
			if (!_v5.$) {
				var quantityUom_ = _v5.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'quantity_uom',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'code',
									$elm$json$Json$Encode$string(quantityUom_))
								])))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var practitioner = function () {
			var _v4 = fields.aka;
			if (!_v4.$) {
				var practitioner_ = _v4.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'practitioner',
						$author$project$Utils$Encode$association(practitioner_))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var patient = function () {
			var _v3 = fields.YY;
			if (!_v3.$) {
				var patient_ = _v3.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'patient',
						$author$project$Utils$Encode$association(patient_))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var location = function () {
			var _v2 = fields.ais;
			if (!_v2.$) {
				var location_ = _v2.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'location',
						$author$project$Utils$Encode$association(location_))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var chargeItem = function () {
			var _v1 = fields.mL;
			if (!_v1.$) {
				var chargeItem_ = _v1.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'charge_item',
						$author$project$Utils$Encode$association(chargeItem_))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var category = function () {
			var _v0 = fields.GW;
			if (!_v0.$) {
				var category_ = _v0.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'category',
						$author$project$Utils$Encode$association(category_))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'charge',
					$elm$json$Json$Encode$object(
						_Utils_ap(
							patient,
							_Utils_ap(
								practitioner,
								_Utils_ap(
									chargeItem,
									_Utils_ap(
										category,
										_Utils_ap(
											location,
											_Utils_ap(
												quantityUom,
												_List_fromArray(
													[
														_Utils_Tuple2(
														'payer',
														A2(
															$author$project$Utils$Encode$nullable,
															$author$project$Utils$Encode$association,
															A2(
																$elm$core$Maybe$andThen,
																function ($) {
																	return $.ahP;
																},
																fields.I6))),
														_Utils_Tuple2(
														'name',
														A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Bq)),
														_Utils_Tuple2(
														'description',
														$elm$json$Json$Encode$string(fields.Qr)),
														_Utils_Tuple2(
														'charge_item',
														A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.mL)),
														_Utils_Tuple2(
														'quantity',
														$elm$json$Json$Encode$int(fields.Dz)),
														_Utils_Tuple2(
														'price_in_cents',
														A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Dw)),
														_Utils_Tuple2(
														'date',
														A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.PB)),
														_Utils_Tuple2(
														'end_date',
														A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.sb)),
														_Utils_Tuple2(
														'discount_overridden',
														$elm$json$Json$Encode$bool(fields.QE))
													])))))))))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Charge$Calculate$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['calculate']),
						basePath))));
	});
var $author$project$Api$Provider$Charge$chargesPath = function (basePath) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['charges']),
		basePath);
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$calculateBasePath = function (invoiceType) {
	if (invoiceType.$ === 1) {
		return $author$project$Api$Provider$Charge$chargesPath($author$project$Api$Data$providerPath);
	} else {
		var affiliationId = invoiceType.a;
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				['affiliate_charges']),
			$author$project$Api$Provider$Affiliate$affiliatePath(affiliationId));
	}
};
var $author$project$Api$Provider$Charge$Invoice = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$companyId = function (company) {
	if (!company.$) {
		var company__ = company.a;
		return $author$project$Api$Provider$Company$Min$id(company__);
	} else {
		var company__ = company.a;
		return $author$project$Api$Company$id(company__);
	}
};
var $author$project$Api$Provider$Charge$Calculate$discountInCents = function (_v0) {
	var record = _v0;
	return record.QD;
};
var $author$project$Api$Provider$Charge$Calculate$issuedSubtotalInCents = function (_v0) {
	var record = _v0;
	return record.Vr;
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$paramsWithPrice = F2(
	function (model, fields) {
		var priceInCents = function () {
			if (!(!fields.QD)) {
				var _v0 = _Utils_Tuple2(fields.mL, model.akd);
				if (!_v0.a.$) {
					var chargeItem = _v0.a.a;
					return $elm$core$Maybe$Just(chargeItem.Dw | 0);
				} else {
					if (_v0.b.$ === 3) {
						var _v1 = _v0.a;
						var _v2 = _v0.b;
						var preview = _v2.a;
						return $elm$core$Maybe$Just(
							$author$project$Api$Provider$Charge$Calculate$issuedSubtotalInCents(preview) + $author$project$Api$Provider$Charge$Calculate$discountInCents(preview));
					} else {
						var _v3 = _v0.a;
						return $elm$core$Maybe$Just(
							fields.QD + A2(
								$elm$core$Maybe$withDefault,
								0,
								A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.Dw)));
					}
				}
			} else {
				return A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.Dw);
			}
		}();
		return {
			GW: fields.GW,
			mL: A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.ahP;
				},
				fields.mL),
			PB: fields.ab7,
			Qr: fields.Qr,
			QE: fields.QE,
			sb: fields.sb,
			Uk: $author$project$Api$Provider$Charge$Invoice($elm$core$Maybe$Nothing),
			ais: fields.ais,
			Bq: fields.Bq,
			YY: A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.ahP;
				},
				fields.YY),
			I6: A2(
				$elm$core$Maybe$map,
				function (company) {
					return {
						ahP: $elm$core$Maybe$Just(
							$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$companyId(company)),
						amg: $elm$core$Maybe$Just('company')
					};
				},
				model.afQ),
			aka: fields.aka,
			Dw: priceInCents,
			Dz: A2($elm$core$Maybe$withDefault, 1, fields.Dz),
			DA: A2($elm$core$Maybe$map, $author$project$Api$Provider$Uom$Shared$code, fields.DA)
		};
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$PreviewDebouncedMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$previewDebounceConfig = {
	alK: $jinjor$elm_debounce$Debounce$later(1000),
	ame: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$PreviewDebouncedMsg
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$shouldCalculatePreview = function (field) {
	switch (field.$) {
		case 0:
			return false;
		case 1:
			return true;
		case 2:
			return true;
		case 3:
			return false;
		case 4:
			return false;
		case 5:
			return false;
		case 6:
			return true;
		case 7:
			return true;
		case 8:
			return true;
		case 9:
			return true;
		case 10:
			return true;
		case 11:
			return true;
		case 12:
			return true;
		default:
			return true;
	}
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$validPreviewFields = function (fields) {
	return $author$project$Utils$Maybe$toBool(fields.Bq) && (A2($elm$core$Maybe$withDefault, 0, fields.Dz) > 0);
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$calculatePreview = F4(
	function (apiClient, field, form, model) {
		var fields = $author$project$Utils$Form$fields(form);
		var _v0 = ($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$shouldCalculatePreview(field) && $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$validPreviewFields(fields)) ? A3(
			$jinjor$elm_debounce$Debounce$push,
			$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$previewDebounceConfig,
			A4(
				$author$project$Api$Provider$Charge$calculate,
				$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$calculateBasePath(model.Uv),
				apiClient,
				A2($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$paramsWithPrice, model, fields),
				$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotPreview),
			model.eW) : _Utils_Tuple2(model.eW, $elm$core$Platform$Cmd$none);
		var newDebouncer = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$shouldCalculatePreview(field) && $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$validPreviewFields(fields)) ? _Utils_update(
				model,
				{akd: $author$project$Api$Data$Loading, eW: newDebouncer}) : ((!$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$validPreviewFields(fields)) ? _Utils_update(
				model,
				{akd: $author$project$Api$Data$NotAsked, eW: newDebouncer}) : _Utils_update(
				model,
				{eW: newDebouncer})),
			cmd);
	});
var $author$project$Api$Provider$InvoiceLine$One$charges = function (_v0) {
	var record = _v0;
	return record.NA;
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$chargesBasePath = function (invoiceType) {
	if (invoiceType.$ === 1) {
		var companyId_ = invoiceType.a;
		var invoiceId = invoiceType.b;
		return A2($author$project$Api$Provider$Company$Invoice$invoicePath, companyId_, invoiceId);
	} else {
		var affiliateBillId = invoiceType.b;
		return $author$project$Api$Provider$AffiliateBill$affiliateBillPath(affiliateBillId);
	}
};
var $author$project$Api$Provider$InvoiceLine$One$companyAccount = function (_v0) {
	var record = _v0;
	return record.Ob;
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$PreviewDebounced = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$debouncePreview = function (cmd) {
	return A2(
		$elm$core$Task$perform,
		$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$PreviewDebounced,
		$elm$core$Task$succeed(cmd));
};
var $author$project$Api$Provider$Charge$Shared$discountOverridden = function (_v0) {
	var record = _v0;
	return record.QE;
};
var $author$project$Api$Provider$Charge$One$discountOverridden = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Charge$Shared$discountOverridden(shared);
};
var $author$project$Components$ResourceFilter$CompanyRegistration$extraItems = F2(
	function (list_, model) {
		var extraItems_ = A2(
			$elm$core$List$map,
			function (item) {
				return {aih: item.Bq, aee: item.ahP};
			},
			list_);
		return _Utils_update(
			model,
			{
				b8: A2($author$project$Components$ResourceFilter$extraItems, extraItems_, model.b8)
			});
	});
var $author$project$Api$Provider$ChargeItem$ForCharge$alertQuantity = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$alertQuantity(shared);
};
var $author$project$Api$Provider$Charge$One$category = function (_v0) {
	var record = _v0.b;
	return record.GW;
};
var $author$project$Api$Provider$Charge$One$chargeItem = function (_v0) {
	var record = _v0.b;
	return record.mL;
};
var $author$project$Api$Provider$Charge$Shared$date = function (_v0) {
	var record = _v0;
	return record.PB;
};
var $author$project$Api$Provider$Charge$One$date = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Charge$Shared$date(shared);
};
var $author$project$Api$Provider$Charge$Shared$description = function (_v0) {
	var record = _v0;
	return record.Qr;
};
var $author$project$Api$Provider$Charge$One$description = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Charge$Shared$description(shared);
};
var $author$project$Api$Provider$ChargeItem$ForCharge$description = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$description(shared);
};
var $author$project$Api$Provider$Charge$Shared$discountInCents = function (_v0) {
	var record = _v0;
	return record.QD;
};
var $author$project$Api$Provider$Charge$One$discountInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Charge$Shared$discountInCents(shared);
};
var $author$project$Api$Provider$Charge$Shared$endDate = function (_v0) {
	var record = _v0;
	return record.sb;
};
var $author$project$Api$Provider$Charge$One$endDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Charge$Shared$endDate(shared);
};
var $author$project$Components$ResourceFilter$Location$extraItems = F2(
	function (list_, model) {
		var extraItems_ = A2(
			$elm$core$List$map,
			function (item) {
				return {aih: item.Bq, aee: item.ahP};
			},
			list_);
		return _Utils_update(
			model,
			{
				b8: A2($author$project$Components$ResourceFilter$extraItems, extraItems_, model.b8)
			});
	});
var $author$project$Components$ResourceFilter$Practitioner$extraItems = F2(
	function (list_, model) {
		var extraItems_ = A2(
			$elm$core$List$map,
			function (item) {
				return {aih: item.Bq, aee: item.ahP};
			},
			list_);
		return _Utils_update(
			model,
			{
				b8: A2($author$project$Components$ResourceFilter$extraItems, extraItems_, model.b8)
			});
	});
var $author$project$Currency$fromMaybeInt = function (maybeInt) {
	return A2($elm$core$Maybe$map, $author$project$Currency$fromInt, maybeInt);
};
var $author$project$Api$Provider$Charge$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Charge$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Charge$Shared$id(shared);
};
var $author$project$Api$Provider$ChargeItem$ForCharge$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$id(shared);
};
var $author$project$Api$Provider$Location$Min$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$id(shared);
};
var $author$project$Api$Provider$ChargeItem$ForCharge$isPackage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$itemType(shared) === 1;
};
var $author$project$Api$Provider$Charge$One$location = function (_v0) {
	var record = _v0.b;
	return record.ais;
};
var $author$project$Api$Provider$ChargeItem$ForCharge$manufacturer = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$manufacturer(shared);
};
var $author$project$Api$Provider$Charge$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$Charge$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Charge$Shared$name(shared);
};
var $author$project$Api$Provider$ChargeItem$ForCharge$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$name(shared);
};
var $author$project$Api$Provider$Location$Min$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$name(shared);
};
var $author$project$Api$Provider$Charge$One$patient = function (_v0) {
	var record = _v0.b;
	return record.YY;
};
var $author$project$Api$Provider$Charge$One$practitioner = function (_v0) {
	var record = _v0.b;
	return record.aka;
};
var $author$project$Api$Provider$Charge$Shared$priceInCents = function (_v0) {
	var record = _v0;
	return record.Dw;
};
var $author$project$Api$Provider$Charge$One$priceInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Charge$Shared$priceInCents(shared);
};
var $author$project$Api$Provider$ChargeItem$ForCharge$priceInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$priceInCents(shared);
};
var $author$project$Api$Provider$Charge$One$priceUom = function (_v0) {
	var record = _v0.b;
	return record._h;
};
var $author$project$Api$Provider$Charge$Shared$quantity = function (_v0) {
	var record = _v0;
	return record.Dz;
};
var $author$project$Api$Provider$Charge$One$quantity = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Charge$Shared$quantity(shared);
};
var $author$project$Api$Provider$ChargeItem$ForCharge$quantityInStock = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$quantityInStock(shared);
};
var $author$project$Api$Provider$Charge$One$quantityUom = function (_v0) {
	var record = _v0.b;
	return record.DA;
};
var $author$project$Api$Provider$ChargeItem$ForCharge$taxable = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$taxable(shared);
};
var $author$project$Api$Provider$ChargeItem$ForCharge$trackInventory = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$trackInventory(shared);
};
var $author$project$Api$Provider$ChargeItem$ForCharge$uom = function (_v0) {
	var record = _v0.b;
	return record.adP;
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$formFieldsFromItem = F4(
	function (apiClient, showItemTypeInTitle, session, charge) {
		var practitioner = $author$project$Api$Provider$Charge$One$practitioner(charge);
		var patient = A2(
			$elm$core$Maybe$map,
			function (patient_) {
				return {
					ahP: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$id(patient_),
					Bq: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$name(patient_)
				};
			},
			$author$project$Api$Provider$Charge$One$patient(charge));
		var location = $author$project$Api$Provider$Charge$One$location(charge);
		var chargeItem = A2(
			$elm$core$Maybe$map,
			function (chargeItem_) {
				return {
					Lm: $author$project$Api$Provider$ChargeItem$ForCharge$alertQuantity(chargeItem_),
					GW: $author$project$Api$Provider$Charge$One$category(charge),
					NN: $author$project$Api$Provider$ChargeItem$ForCharge$code(chargeItem_),
					NP: $author$project$Api$Provider$ChargeItem$ForCharge$codeType(chargeItem_),
					Qr: $author$project$Api$Provider$ChargeItem$ForCharge$description(chargeItem_),
					ahP: $author$project$Api$Provider$ChargeItem$ForCharge$id(chargeItem_),
					aid: $author$project$Api$Provider$ChargeItem$ForCharge$isPackage(chargeItem_),
					sW: $author$project$Api$Provider$ChargeItem$ForCharge$isPackage(chargeItem_) ? 1 : 0,
					Wt: $author$project$Api$Provider$ChargeItem$ForCharge$manufacturer(chargeItem_),
					Bq: $author$project$Api$Provider$ChargeItem$ForCharge$name(chargeItem_),
					Dw: $author$project$Api$Provider$ChargeItem$ForCharge$priceInCents(chargeItem_),
					_P: $author$project$Api$Provider$ChargeItem$ForCharge$quantityInStock(chargeItem_),
					acZ: $author$project$Api$Provider$ChargeItem$ForCharge$taxable(chargeItem_),
					ads: $author$project$Api$Provider$ChargeItem$ForCharge$trackInventory(chargeItem_),
					adP: $author$project$Api$Provider$ChargeItem$ForCharge$uom(chargeItem_)
				};
			},
			$author$project$Api$Provider$Charge$One$chargeItem(charge));
		var category = $author$project$Api$Provider$Charge$One$category(charge);
		var _v0 = $author$project$Components$DateInput$init;
		var startDateInput = _v0.a;
		var startDateInputCmd = _v0.b;
		var _v1 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Components$ResourceFilter$Practitioner$extraItems(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (practitioner_) {
							return _List_fromArray(
								[
									{
									ahP: $author$project$Api$Provider$Practitioner$Shared$id(practitioner_),
									Bq: $author$project$Api$Provider$Practitioner$Shared$name(practitioner_)
								}
								]);
						},
						practitioner))),
			A3(
				$author$project$Components$ResourceFilter$Practitioner$init,
				apiClient,
				$elm$core$Basics$identity,
				function (d) {
					return _Utils_update(
						d,
						{
							Gp: 'Unassigned',
							ai5: false,
							akb: A2($elm$core$Maybe$map, $author$project$Api$Provider$Practitioner$Shared$id, practitioner)
						});
				}));
		var practitionerResourceFilter = _v1.a;
		var practitionerResourceFilterCmd = _v1.b;
		var _v2 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Components$ResourceFilter$Location$extraItems(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (location_) {
							return _List_fromArray(
								[
									{
									ahP: $author$project$Api$Provider$Location$Min$id(location_),
									Bq: $author$project$Api$Provider$Location$Min$name(location_)
								}
								]);
						},
						location))),
			A4(
				$author$project$Components$ResourceFilter$Location$init,
				apiClient,
				$elm$core$Maybe$Nothing,
				$elm$core$Basics$identity,
				function (d) {
					return _Utils_update(
						d,
						{
							Gp: 'Unassigned',
							ai5: false,
							akb: A2($elm$core$Maybe$map, $author$project$Api$Provider$Location$Min$id, location)
						});
				}));
		var locationResourceFilter = _v2.a;
		var locationResourceFilterCmd = _v2.b;
		var _v3 = $author$project$Components$DateInput$init;
		var endDateInput = _v3.a;
		var endDateInputCmd = _v3.b;
		var _v4 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Components$ResourceFilter$ChargeItem$setValue(
				A2(
					$elm$core$Maybe$withDefault,
					$author$project$Components$ResourceFilter$FreeText(
						A2(
							$elm$core$Maybe$withDefault,
							'',
							$author$project$Api$Provider$Charge$One$name(charge))),
					A2(
						$elm$core$Maybe$map,
						function (chargeItem_) {
							return $author$project$Components$ResourceFilter$One(
								{Lm: chargeItem_.Lm, GW: chargeItem_.GW, NN: chargeItem_.NN, NP: chargeItem_.NP, Qr: chargeItem_.Qr, ahP: chargeItem_.ahP, aid: chargeItem_.aid, sW: chargeItem_.sW, Wt: chargeItem_.Wt, Bq: chargeItem_.Bq, Dw: chargeItem_.Dw, _P: chargeItem_._P, acZ: chargeItem_.acZ, ads: chargeItem_.ads, adP: chargeItem_.adP});
						},
						chargeItem))),
			A4(
				$author$project$Components$ResourceFilter$ChargeItem$initWithItemType,
				showItemTypeInTitle,
				apiClient,
				$elm$core$Basics$identity,
				function (d) {
					return _Utils_update(
						d,
						{Gp: 'None', Lr: false, ahw: true, ahx: '', ai5: false});
				}));
		var chargeItemResourceFilter = _v4.a;
		var chargeItemResourceFilterCmd = _v4.b;
		var _v5 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Components$ResourceFilter$Category$extraItems(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (category_) {
							return _List_fromArray(
								[
									{
									ahP: $author$project$Api$Provider$Category$Shared$id(category_),
									Bq: $author$project$Api$Provider$Category$Shared$name(category_)
								}
								]);
						},
						category))),
			A3(
				$author$project$Components$ResourceFilter$Category$init,
				apiClient,
				session,
				function (d) {
					return _Utils_update(
						d,
						{
							Gp: 'Unassigned',
							ai5: false,
							akb: A2($elm$core$Maybe$map, $author$project$Api$Provider$Category$Shared$id, category)
						});
				}));
		var categoryResourceFilter = _v5.a;
		var categoryResourceFilterCmd = _v5.b;
		return _Utils_Tuple2(
			{
				GW: A2(
					$elm$core$Maybe$map,
					$author$project$Api$Provider$Category$Shared$id,
					$author$project$Api$Provider$Charge$One$category(charge)),
				c8: categoryResourceFilter,
				mL: chargeItem,
				cq: chargeItemResourceFilter,
				Qr: $author$project$Api$Provider$Charge$One$description(charge),
				QD: $author$project$Api$Provider$Charge$One$discountInCents(charge),
				QE: $author$project$Api$Provider$Charge$One$discountOverridden(charge),
				sb: $author$project$Api$Provider$Charge$One$endDate(charge),
				sd: endDateInput,
				ahP: $elm$core$Maybe$Just(
					$author$project$Api$Provider$Charge$One$id(charge)),
				ais: A2(
					$elm$core$Maybe$map,
					$author$project$Api$Provider$Location$Min$id,
					$author$project$Api$Provider$Charge$One$location(charge)),
				os: locationResourceFilter,
				Bq: $author$project$Api$Provider$Charge$One$name(charge),
				YY: patient,
				aka: A2(
					$elm$core$Maybe$map,
					$author$project$Api$Provider$Practitioner$Shared$id,
					$author$project$Api$Provider$Charge$One$practitioner(charge)),
				hk: practitionerResourceFilter,
				Dw: $author$project$Currency$fromMaybeInt(
					$author$project$Api$Provider$Charge$One$priceInCents(charge)),
				_h: $elm$core$Maybe$Just(
					$author$project$Api$Provider$Charge$One$priceUom(charge)),
				Dz: $elm$core$Maybe$Just(
					$author$project$Api$Provider$Charge$One$quantity(charge)),
				DA: $elm$core$Maybe$Just(
					$author$project$Api$Provider$Charge$One$quantityUom(charge)),
				ab7: $elm$core$Maybe$Just(
					$author$project$Api$Provider$Charge$One$date(charge)),
				lx: startDateInput,
				acZ: A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						$author$project$Api$Provider$ChargeItem$ForCharge$taxable,
						$author$project$Api$Provider$Charge$One$chargeItem(charge)))
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$StartDateInputMsg(startDateInput),
						startDateInputCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$EndDateInputMsg(endDateInput),
						endDateInputCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ChargeItemResourceFilterMsg, chargeItemResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CategoryResourceFilterMsg, categoryResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$PractitionerResourceFilterMsg, practitionerResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$LocationResourceFilterMsg, locationResourceFilterCmd)
					])));
	});
var $author$project$Utils$Uom$matchRange = F2(
	function (fromDate, toDate) {
		var toDate_ = A3($justinmimbs$date$Date$add, 3, 1, toDate);
		var diff = A2($author$project$Utils$Uom$dateDiff, fromDate, toDate_);
		return (!(!diff.agb)) ? $author$project$Api$Provider$Uom$Shared$day : ((!diff.aiQ) ? $author$project$Api$Provider$Uom$Shared$year : ((!A2($elm$core$Basics$modBy, 6, diff.aiQ)) ? $author$project$Api$Provider$Uom$Shared$halfYear : ((!A2($elm$core$Basics$modBy, 3, diff.aiQ)) ? $author$project$Api$Provider$Uom$Shared$quarter : $author$project$Api$Provider$Uom$Shared$month)));
	});
var $author$project$Utils$Uom$dateUnitMultiplier = function (periodUnit) {
	switch (periodUnit) {
		case 0:
			return 1;
		case 1:
			return 1;
		case 2:
			return 3;
		case 3:
			return 6;
		default:
			return 1;
	}
};
var $author$project$Utils$Uom$toDateUnit = function (periodUnit) {
	switch (periodUnit) {
		case 0:
			return 3;
		case 1:
			return 1;
		case 2:
			return 1;
		case 3:
			return 1;
		default:
			return 0;
	}
};
var $author$project$Utils$Uom$withInfinityDefault = F2(
	function (_default, _float) {
		return $elm$core$Basics$isInfinite(_float) ? _default : _float;
	});
var $author$project$Utils$Uom$quantityBetween = F3(
	function (uom, fromDate, toDate) {
		var _v0 = _Utils_Tuple3(
			$author$project$Api$Provider$Uom$Shared$periodUnit(uom),
			$author$project$Api$Provider$Uom$Shared$periodQuantity(uom),
			toDate);
		if (((!_v0.a.$) && (!_v0.b.$)) && (!_v0.c.$)) {
			var periodUnit = _v0.a.a;
			var periodQuantity = _v0.b.a;
			var toDate_ = _v0.c.a;
			var quantity = $elm$core$Basics$round(
				A2(
					$author$project$Utils$Uom$withInfinityDefault,
					1,
					(1 / ($author$project$Utils$Uom$dateUnitMultiplier(periodUnit) * periodQuantity)) * A3(
						$justinmimbs$date$Date$diff,
						$author$project$Utils$Uom$toDateUnit(periodUnit),
						fromDate,
						A3($justinmimbs$date$Date$add, 3, 1, toDate_))));
			return A2(
				$elm$core$Maybe$withDefault,
				1,
				$elm$core$List$maximum(
					_List_fromArray(
						[quantity, 1])));
		} else {
			return 0;
		}
	});
var $author$project$Utils$Uom$addTo = F3(
	function (date, uom, quantity) {
		var _v0 = _Utils_Tuple2(
			$author$project$Api$Provider$Uom$Shared$periodUnit(uom),
			$author$project$Api$Provider$Uom$Shared$periodQuantity(uom));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var periodUnit = _v0.a.a;
			var periodQuantity = _v0.b.a;
			return A2(
				$elm$core$Maybe$map,
				A2($justinmimbs$date$Date$add, 3, -1),
				A2(
					$elm$core$Maybe$map,
					A2(
						$justinmimbs$date$Date$add,
						$author$project$Utils$Uom$toDateUnit(periodUnit),
						(periodQuantity * $author$project$Utils$Uom$dateUnitMultiplier(periodUnit)) * quantity),
					date));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$resetEndDate = function (fields) {
	var _v0 = _Utils_Tuple2(fields.Dz, fields.DA);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var quantity = _v0.a.a;
		var quantityUom = _v0.b.a;
		return _Utils_update(
			fields,
			{
				sb: A3($author$project$Utils$Uom$addTo, fields.ab7, quantityUom, quantity)
			});
	} else {
		return fields;
	}
};
var $author$project$Components$ResourceFilter$Category$setValue = F2(
	function (resource, model) {
		return _Utils_update(
			model,
			{
				Jy: function () {
					if (!resource.$) {
						var resource_ = resource.a;
						return $author$project$Components$ResourceFilter$One(resource_);
					} else {
						return $author$project$Components$ResourceFilter$All;
					}
				}()
			});
	});
var $author$project$Components$ResourceFilter$Practitioner$setValue = F2(
	function (resource, model) {
		return _Utils_update(
			model,
			{
				Jy: function () {
					if (!resource.$) {
						var resource_ = resource.a;
						return $author$project$Components$ResourceFilter$One(resource_);
					} else {
						return $author$project$Components$ResourceFilter$All;
					}
				}()
			});
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						mL: $elm$core$Maybe$Nothing,
						Bq: $author$project$Utils$String$toMaybe(string)
					});
			case 1:
				var chargeItem = field.a;
				var category = A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.GW;
					},
					chargeItem);
				return $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$resetEndDate(
					_Utils_update(
						fields,
						{
							GW: A2($elm$core$Maybe$map, $author$project$Api$Provider$Category$Shared$id, category),
							c8: A2(
								$author$project$Components$ResourceFilter$Category$setValue,
								A2(
									$elm$core$Maybe$map,
									function (category_) {
										return {
											ahP: $author$project$Api$Provider$Category$Shared$id(category_),
											Bq: $author$project$Api$Provider$Category$Shared$name(category_)
										};
									},
									category),
								fields.c8),
							mL: chargeItem,
							Qr: A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$andThen,
									function ($) {
										return $.Qr;
									},
									chargeItem)),
							Bq: A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.Bq;
								},
								chargeItem),
							Dw: A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.Dw;
									},
									$author$project$Currency$fromFloat),
								chargeItem),
							_h: A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.adP;
								},
								chargeItem),
							Dz: $elm$core$Maybe$Just(1),
							DA: A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.adP;
								},
								chargeItem)
						}));
			case 2:
				var maybeString = field.a;
				return _Utils_update(
					fields,
					{GW: maybeString});
			case 3:
				var practitioner = field.a;
				return _Utils_update(
					fields,
					{
						aka: A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.ahP;
							},
							practitioner),
						hk: A2($author$project$Components$ResourceFilter$Practitioner$setValue, practitioner, fields.hk)
					});
			case 4:
				var location = field.a;
				return _Utils_update(
					fields,
					{
						ais: A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.ahP;
							},
							location),
						os: A2($author$project$Components$ResourceFilter$Location$setValue, location, fields.os)
					});
			case 5:
				var string = field.a;
				return _Utils_update(
					fields,
					{Qr: string});
			case 6:
				var string = field.a;
				return $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$resetEndDate(
					_Utils_update(
						fields,
						{
							Dz: $elm$core$String$toInt(string)
						}));
			case 7:
				var string = field.a;
				var _v1 = $author$project$Utils$Uom$fromCode(string);
				if (!_v1.$) {
					var quantityUom = _v1.a;
					var quantity = function () {
						var _v2 = _Utils_Tuple2(fields.ab7, fields.sb);
						if ((!_v2.a.$) && (!_v2.b.$)) {
							var startDate = _v2.a.a;
							var endDate = _v2.b.a;
							return $elm$core$Maybe$Just(
								A3(
									$author$project$Utils$Uom$quantityBetween,
									quantityUom,
									startDate,
									$elm$core$Maybe$Just(endDate)));
						} else {
							return fields.Dz;
						}
					}();
					return $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$resetEndDate(
						_Utils_update(
							fields,
							{
								Dz: quantity,
								DA: $elm$core$Maybe$Just(quantityUom)
							}));
				} else {
					return _Utils_update(
						fields,
						{DA: $elm$core$Maybe$Nothing});
				}
			case 8:
				var dateInput = field.a;
				var date = field.b;
				return $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$resetEndDate(
					_Utils_update(
						fields,
						{ab7: date, lx: dateInput}));
			case 9:
				var dateInput = field.a;
				var date = field.b;
				var _v3 = function () {
					var _v4 = _Utils_Tuple2(fields.ab7, date);
					if ((!_v4.a.$) && (!_v4.b.$)) {
						var startDate_ = _v4.a.a;
						var endDate = _v4.b.a;
						var startDate__ = (A2($justinmimbs$date$Date$compare, startDate_, endDate) === 2) ? endDate : startDate_;
						var quantityUom_ = A2($author$project$Utils$Uom$matchRange, startDate__, endDate);
						return _Utils_Tuple3(
							$elm$core$Maybe$Just(startDate__),
							$elm$core$Maybe$Just(quantityUom_),
							$elm$core$Maybe$Just(
								A3(
									$author$project$Utils$Uom$quantityBetween,
									quantityUom_,
									startDate__,
									$elm$core$Maybe$Just(endDate))));
					} else {
						return _Utils_Tuple3(fields.ab7, fields.DA, fields.Dz);
					}
				}();
				var startDate = _v3.a;
				var quantityUom = _v3.b;
				var quantity = _v3.c;
				return _Utils_update(
					fields,
					{sb: date, sd: dateInput, Dz: quantity, DA: quantityUom, ab7: startDate});
			case 10:
				var _int = field.a;
				return _Utils_update(
					fields,
					{Dw: _int});
			case 11:
				var companyRegistration = field.a;
				return _Utils_update(
					fields,
					{
						YY: A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.YY;
							},
							companyRegistration)
					});
			case 12:
				var bool = field.a;
				var priceInCents = bool ? fields.Dw : A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.Dw;
						},
						$author$project$Currency$fromFloat),
					fields.mL);
				return _Utils_update(
					fields,
					{QE: bool, Dw: priceInCents});
			default:
				var _int = field.a;
				return _Utils_update(
					fields,
					{QD: _int});
		}
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ChargeItemValidation = 0;
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$PriceInCentsValidation = 4;
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$StartDateValidation = 2;
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$validateChargeItem = function (fields) {
	var _v0 = fields.mL;
	if (!_v0.$) {
		var chargeItem = _v0.a;
		return chargeItem.acZ ? _List_fromArray(
			[
				_Utils_Tuple2(0, 'We do not support adding taxable charges to this invoice at this time. Please contact us to learn more.')
			]) : _List_Nil;
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.Bq;
			},
			_Utils_Tuple2(0, 'Please pick a charge.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.Dw;
			},
			_Utils_Tuple2(4, 'Please enter an amount.')),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$validateChargeItem),
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.ab7;
			},
			_Utils_Tuple2(2, 'Please pick a date.'))
		]));
var $author$project$Api$Provider$CompanyAccount$Min$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$CompanyAccount$Shared$id = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Provider$CompanyAccount$Min$id(min);
};
var $author$project$Api$Provider$CompanyAccount$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyAccount$Shared$id(shared);
};
var $author$project$Api$Provider$Patient$One$location = function (_v0) {
	var record = _v0.b;
	return record.ais;
};
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOne$patient = function (_v0) {
	var record = _v0;
	return record.YY;
};
var $author$project$Api$Provider$Patient$One$practitioner = function (_v0) {
	var record = _v0.b;
	return record.aka;
};
var $author$project$Api$Provider$CompanyAccount$One$registrations = function (_v0) {
	var record = _v0.b;
	return record.akF;
};
var $author$project$Api$Employer$Practitioner$Shared$affiliation = function (_v0) {
	var record = _v0;
	return record.Li;
};
var $author$project$Api$Practitioner$Shared$affiliation = function (practitioner) {
	if (!practitioner.$) {
		var practitioner_ = practitioner.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Affiliate$AffiliateMin$Provider,
			$author$project$Api$Provider$Practitioner$Shared$affiliation(practitioner_));
	} else {
		var practitioner_ = practitioner.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Affiliate$AffiliateMin$Employer,
			$author$project$Api$Employer$Practitioner$Shared$affiliation(practitioner_));
	}
};
var $author$project$Api$Employer$Practitioner$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Practitioner$Shared$id = function (practitioner) {
	if (!practitioner.$) {
		var practitioner_ = practitioner.a;
		return $author$project$Api$Provider$Practitioner$Shared$id(practitioner_);
	} else {
		var practitioner_ = practitioner.a;
		return $author$project$Api$Employer$Practitioner$Shared$id(practitioner_);
	}
};
var $author$project$Api$Employer$Practitioner$Shared$isMaster = function (_v0) {
	var record = _v0;
	return record.UV;
};
var $author$project$Api$Practitioner$Shared$isMaster = function (practitioner) {
	if (!practitioner.$) {
		var practitioner_ = practitioner.a;
		return $author$project$Api$Provider$Practitioner$Shared$isMaster(practitioner_);
	} else {
		var practitioner_ = practitioner.a;
		return $author$project$Api$Employer$Practitioner$Shared$isMaster(practitioner_);
	}
};
var $author$project$Api$Employer$Practitioner$Shared$isSynced = function (_v0) {
	var record = _v0;
	return record.Vf;
};
var $author$project$Api$Practitioner$Shared$isSynced = function (practitioner) {
	if (!practitioner.$) {
		var practitioner_ = practitioner.a;
		return $author$project$Api$Provider$Practitioner$Shared$isSynced(practitioner_);
	} else {
		var practitioner_ = practitioner.a;
		return $author$project$Api$Employer$Practitioner$Shared$isSynced(practitioner_);
	}
};
var $author$project$Api$Employer$Practitioner$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Practitioner$Shared$name = function (practitioner) {
	if (!practitioner.$) {
		var practitioner_ = practitioner.a;
		return $author$project$Api$Provider$Practitioner$Shared$name(practitioner_);
	} else {
		var practitioner_ = practitioner.a;
		return $author$project$Api$Employer$Practitioner$Shared$name(practitioner_);
	}
};
var $author$project$Api$Employer$Practitioner$Shared$openingsSize = function (_v0) {
	var record = _v0;
	return record.Yp;
};
var $author$project$Api$Practitioner$Shared$openingsSize = function (practitioner) {
	if (!practitioner.$) {
		var practitioner_ = practitioner.a;
		return $author$project$Api$Provider$Practitioner$Shared$openingsSize(practitioner_);
	} else {
		var practitioner_ = practitioner.a;
		return $author$project$Api$Employer$Practitioner$Shared$openingsSize(practitioner_);
	}
};
var $author$project$Api$Practitioner$Shared$practiceName = function (practitioner) {
	if (!practitioner.$) {
		var practitioner_ = practitioner.a;
		return $author$project$Api$Provider$Practitioner$Shared$practiceName(practitioner_);
	} else {
		return '';
	}
};
var $author$project$Api$Practitioner$Shared$practitionerType = function (practitioner) {
	if (!practitioner.$) {
		var practitioner_ = practitioner.a;
		return $author$project$Api$Provider$Practitioner$Shared$practitionerType(practitioner_);
	} else {
		return '';
	}
};
var $author$project$Components$ResourceFilter$Practitioner$resourceFromShared = $elm$core$Maybe$map(
	function (practitioner) {
		return {
			Li: $author$project$Api$Practitioner$Shared$affiliation(practitioner),
			ahP: $author$project$Api$Practitioner$Shared$id(practitioner),
			UV: $author$project$Api$Practitioner$Shared$isMaster(practitioner),
			Vf: $author$project$Api$Practitioner$Shared$isSynced(practitioner),
			Bq: $author$project$Api$Practitioner$Shared$name(practitioner),
			Yp: $author$project$Api$Practitioner$Shared$openingsSize(practitioner),
			ZY: $author$project$Api$Practitioner$Shared$practiceName(practitioner),
			Z3: $author$project$Api$Practitioner$Shared$practitionerType(practitioner)
		};
	});
var $author$project$Api$Provider$Affiliates$AffiliatePatient$patientsPath = function (affiliateId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['affiliate_patients']),
		$author$project$Api$Provider$Affiliate$affiliatePath(affiliateId));
};
var $author$project$Api$Provider$Affiliates$AffiliatePatient$patientPath = F2(
	function (affiliateId, id) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id]),
			$author$project$Api$Provider$Affiliates$AffiliatePatient$patientsPath(affiliateId));
	});
var $author$project$Api$Provider$Affiliates$AffiliatePatient$retrieve = F4(
	function (apiClient, affiliateId, patientId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Patient$Min$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Provider$Affiliates$AffiliatePatient$patientPath, affiliateId, patientId)));
	});
var $author$project$Api$Provider$Patient$retrieve = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Patient$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Patient$patientPath(id_)));
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotChargeCreated = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Api$Provider$Charge$create = F4(
	function (basePath, apiClient, fields, toMsg) {
		var quantityUom = function () {
			var _v3 = fields.DA;
			if (!_v3.$) {
				var quantityUom_ = _v3.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'quantity_uom',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'code',
									$elm$json$Json$Encode$string(quantityUom_))
								])))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var patient = function () {
			var _v2 = fields.YY;
			if (!_v2.$) {
				var patient_ = _v2.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'patient',
						$author$project$Utils$Encode$association(patient_))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var invoice = function () {
			var _v1 = fields.Uk;
			if (!_v1.$) {
				var invoice_ = _v1.a;
				return A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$typedAssociation, invoice_);
			} else {
				return $elm$json$Json$Encode$string('new');
			}
		}();
		var chargeItem = function () {
			var _v0 = fields.mL;
			if (!_v0.$) {
				var chargeItem_ = _v0.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'charge_item',
						$author$project$Utils$Encode$association(chargeItem_))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'charge',
					$elm$json$Json$Encode$object(
						_Utils_ap(
							patient,
							_Utils_ap(
								chargeItem,
								_Utils_ap(
									quantityUom,
									_List_fromArray(
										[
											_Utils_Tuple2(
											'payer',
											A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$typedAssociation, fields.I6)),
											_Utils_Tuple2('invoice', invoice),
											_Utils_Tuple2(
											'name',
											A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Bq)),
											_Utils_Tuple2(
											'description',
											$elm$json$Json$Encode$string(fields.Qr)),
											_Utils_Tuple2(
											'charge_item',
											A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.mL)),
											_Utils_Tuple2(
											'quantity',
											$elm$json$Json$Encode$int(fields.Dz)),
											_Utils_Tuple2(
											'price_in_cents',
											A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Dw)),
											_Utils_Tuple2(
											'date',
											A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.PB)),
											_Utils_Tuple2(
											'end_date',
											A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.sb)),
											_Utils_Tuple2(
											'practitioner',
											A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.aka)),
											_Utils_Tuple2(
											'location',
											A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.ais)),
											_Utils_Tuple2(
											'category',
											A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.GW))
										]))))))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Charge$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Charge$chargesPath(basePath))));
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$createCharge = F3(
	function (apiClient, model, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4(
			$author$project$Api$Provider$Charge$create,
			$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$chargesBasePath(model.Uv),
			apiClient,
			A2($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$paramsWithPrice, model, fields),
			$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotChargeCreated(formFields));
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotChargeReset = F3(
	function (a, b, c) {
		return {$: 6, a: a, b: b, c: c};
	});
var $author$project$Api$Provider$Charge$chargePath = F2(
	function (basePath, chargeId) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[chargeId]),
			$author$project$Api$Provider$Charge$chargesPath(basePath));
	});
var $author$project$Api$Provider$Charge$CoverageDiscount$coverageDiscountsPath = function (chargeId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['coverage_discounts']),
		A2($author$project$Api$Provider$Charge$chargePath, $author$project$Api$Data$providerPath, chargeId));
};
var $author$project$Api$Provider$Charge$CoverageDiscount$override = F3(
	function (apiClient, chargeId, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Charge$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['override']),
					$author$project$Api$Provider$Charge$CoverageDiscount$coverageDiscountsPath(chargeId))));
	});
var $author$project$Api$Provider$Charge$CoverageDiscount$reset = F3(
	function (apiClient, chargeId, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Charge$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['reset']),
					$author$project$Api$Provider$Charge$CoverageDiscount$coverageDiscountsPath(chargeId))));
	});
var $author$project$Api$Provider$Charge$update = F5(
	function (basePath, apiClient, id, fields, toMsg) {
		var quantityUom = function () {
			var _v3 = fields.DA;
			if (!_v3.$) {
				var quantityUom_ = _v3.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'quantity_uom',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'code',
									$elm$json$Json$Encode$string(quantityUom_))
								])))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var patient = function () {
			var _v2 = fields.YY;
			if (!_v2.$) {
				var patient_ = _v2.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'patient',
						$author$project$Utils$Encode$association(patient_))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var chargeItem = function () {
			var _v1 = fields.mL;
			if (!_v1.$) {
				var chargeItem_ = _v1.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'charge_item',
						$author$project$Utils$Encode$association(chargeItem_))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var category = function () {
			var _v0 = fields.GW;
			if (!_v0.$) {
				var category_ = _v0.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'category',
						$author$project$Utils$Encode$association(category_))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'charge',
					$elm$json$Json$Encode$object(
						_Utils_ap(
							patient,
							_Utils_ap(
								chargeItem,
								_Utils_ap(
									category,
									_Utils_ap(
										quantityUom,
										_List_fromArray(
											[
												_Utils_Tuple2(
												'name',
												A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Bq)),
												_Utils_Tuple2(
												'description',
												$elm$json$Json$Encode$string(fields.Qr)),
												_Utils_Tuple2(
												'quantity',
												$elm$json$Json$Encode$int(fields.Dz)),
												_Utils_Tuple2(
												'price_in_cents',
												A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Dw)),
												_Utils_Tuple2(
												'date',
												A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.PB)),
												_Utils_Tuple2(
												'end_date',
												A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.sb)),
												_Utils_Tuple2(
												'practitioner',
												A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.aka)),
												_Utils_Tuple2(
												'location',
												A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.ais))
											])))))))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Charge$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Provider$Charge$chargePath, basePath, id))));
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateCharge = F4(
	function (apiClient, model, id, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var apiFields = A2($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$paramsWithPrice, model, fields);
		return (fields.QE && (!model.QE)) ? A3(
			$author$project$Api$Provider$Charge$CoverageDiscount$override,
			apiClient,
			id,
			A2($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotChargeReset, id, apiFields)) : (((!fields.QE) && model.QE) ? A3(
			$author$project$Api$Provider$Charge$CoverageDiscount$reset,
			apiClient,
			id,
			A2($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotChargeReset, id, apiFields)) : A5(
			$author$project$Api$Provider$Charge$update,
			$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$chargesBasePath(model.Uv),
			apiClient,
			id,
			apiFields,
			$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotChargeUpdated));
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$save = F3(
	function (apiClient, model, formFields) {
		var _v0 = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var id = _v0.ahP;
		if (!id.$) {
			var id_ = id.a;
			return A4($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateCharge, apiClient, model, id_, formFields);
		} else {
			return A3($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$createCharge, apiClient, model, formFields);
		}
	});
var $author$project$Components$ResourceFilter$CompanyRegistration$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.b8);
		var modelAfterEvent = function () {
			var _v1 = result.agZ;
			if (!_v1.$) {
				var selected = _v1.a;
				return _Utils_update(
					model,
					{Jy: selected});
			} else {
				return model;
			}
		}();
		return {
			GZ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.GZ),
			agZ: result.agZ,
			aiO: _Utils_update(
				modelAfterEvent,
				{b8: result.aiO}),
			aR: result.aR
		};
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotCompanyAccount = function (a) {
	return {$: 18, a: a};
};
var $author$project$Api$Common$Account$RetrieveOptionals$Memberships = 0;
var $author$project$Api$Provider$Affiliate$Account$companyAccountsPath = function (companyId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['accounts']),
		$author$project$Api$Provider$Affiliate$affiliatePath(companyId));
};
var $author$project$Api$Provider$Affiliate$Account$companyAccountPath = F2(
	function (companyId, id) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id]),
			$author$project$Api$Provider$Affiliate$Account$companyAccountsPath(companyId));
	});
var $author$project$Api$Common$Account$RetrieveOptionals$expandToString = function (expand) {
	return 'memberships';
};
var $author$project$Api$Common$Account$RetrieveOptionals$retrieveDefaults = {HE: _List_Nil};
var $author$project$Api$Common$Account$RetrieveOptionals$toParams = function (optionals) {
	var options = optionals($author$project$Api$Common$Account$RetrieveOptionals$retrieveDefaults);
	return _List_fromArray(
		[
			A2(
			$author$project$Api$Param$list,
			'expand',
			A2($elm$core$List$map, $author$project$Api$Common$Account$RetrieveOptionals$expandToString, options.HE))
		]);
};
var $author$project$Api$Provider$Affiliate$Account$retrieve = F5(
	function (apiClient, companyId, id, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$CompanyAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Common$Account$RetrieveOptionals$toParams(optionals),
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Provider$Affiliate$Account$companyAccountPath, companyId, id))));
	});
var $author$project$Api$Provider$Company$Account$companyAccountPath = F2(
	function (basePath, id) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id]),
			$author$project$Api$Provider$Company$Account$companyAccountsPath(basePath));
	});
var $author$project$Api$Provider$Company$Account$retrieve = F5(
	function (apiClient, companyId, id, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$CompanyAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Common$Account$RetrieveOptionals$toParams(optionals),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Provider$Company$Account$companyAccountPath,
						$author$project$Api$Provider$Company$companyPath(companyId),
						id))));
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$findRecentMembership = F3(
	function (apiClient, field, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		var companyRegistrationId = function () {
			if (field.$ === 11) {
				var companyRegistration = field.a;
				return A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.fv;
					},
					companyRegistration);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		return _Utils_Tuple2(
			$author$project$Utils$Maybe$toBool(companyRegistrationId) ? _Utils_update(
				model,
				{Ob: $author$project$Api$Data$Loading}) : model,
			function () {
				if (!companyRegistrationId.$) {
					var companyRegistrationId_ = companyRegistrationId.a;
					return $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								cmd,
								function () {
								var _v2 = model.Uv;
								if (!_v2.$) {
									var affiliateId = _v2.a;
									return A5(
										$author$project$Api$Provider$Affiliate$Account$retrieve,
										apiClient,
										affiliateId,
										companyRegistrationId_,
										function (d) {
											return _Utils_update(
												d,
												{
													HE: _List_fromArray(
														[0])
												});
										},
										$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotCompanyAccount);
								} else {
									var companyId_ = _v2.a;
									return A5(
										$author$project$Api$Provider$Company$Account$retrieve,
										apiClient,
										companyId_,
										companyRegistrationId_,
										function (d) {
											return _Utils_update(
												d,
												{
													HE: _List_fromArray(
														[0])
												});
										},
										$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotCompanyAccount);
								}
							}()
							]));
				} else {
					return cmd;
				}
			}());
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateForm = F4(
	function (apiClient, model, field, form) {
		var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$formFieldsUpdate, field, form);
		return A3(
			$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$findRecentMembership,
			apiClient,
			field,
			A4(
				$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$calculatePreview,
				apiClient,
				field,
				newForm,
				_Utils_update(
					model,
					{
						SD: $elm$core$Maybe$Just(newForm)
					})));
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateDateInputFormField = F7(
	function (apiClient, model, dateInput, subMsg, toMsg, field, fieldGetter) {
		var _v0 = model.SD;
		if (!_v0.$) {
			var form = _v0.a;
			var _v1 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
			var newDateInput = _v1.a;
			var subCmd = _v1.b;
			var event = _v1.c;
			var dateField = function () {
				if (event.$ === 1) {
					var date = event.a;
					return A2(field, newDateInput, date);
				} else {
					var fields = $author$project$Utils$Form$fields(form);
					return A2(
						field,
						newDateInput,
						fieldGetter(fields));
				}
			}();
			var _v2 = A4($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateForm, apiClient, model, dateField, form);
			var newModel = _v2.a;
			var formCmd = _v2.b;
			return {
				GZ: $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							formCmd,
							A2(
							$elm$core$Platform$Cmd$map,
							toMsg(newDateInput),
							subCmd)
						])),
				agZ: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
				aiO: newModel,
				aR: _List_Nil
			};
		} else {
			return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None, aiO: model, aR: _List_Nil};
		}
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$DiscountInCents = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$PriceInCents = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Provider$Charge$Calculate$priceInCents = function (_v0) {
	var record = _v0;
	return record.Dw;
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateFormFromPreview = F2(
	function (preview, form) {
		return A3(
			$author$project$Utils$Form$update,
			$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$formFieldsUpdate,
			$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$DiscountInCents(
				$author$project$Api$Provider$Charge$Calculate$discountInCents(preview)),
			A3(
				$author$project$Utils$Form$update,
				$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$formFieldsUpdate,
				$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$PriceInCents(
					$elm$core$Maybe$Just(
						$author$project$Currency$fromInt(
							$author$project$Api$Provider$Charge$Calculate$priceInCents(preview)))),
				form));
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Closed, aiO: model, aR: _List_Nil};
			case 1:
				var response = msg.a;
				if (response.$ === 3) {
					var invoiceLine = response.a;
					var charge = $elm$core$List$head(
						$author$project$Api$Provider$InvoiceLine$One$charges(invoiceLine));
					var _v3 = function () {
						if (!charge.$) {
							var charge_ = charge.a;
							var registrations = A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									$author$project$Api$Provider$CompanyAccount$One$registrations,
									$author$project$Api$Provider$InvoiceLine$One$companyAccount(invoiceLine)));
							var patient = $author$project$Api$Provider$Charge$One$patient(charge_);
							var companyRegistrationsBasePath = function () {
								var _v8 = model.Uv;
								if (_v8.$ === 1) {
									var companyId_ = _v8.a;
									return $author$project$Api$Provider$Company$companyPath(companyId_);
								} else {
									var affiliateId = _v8.a;
									return $author$project$Api$Provider$Affiliate$affiliatePath(affiliateId);
								}
							}();
							var chargePatientId = A2(
								$elm$core$Maybe$map,
								$author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$id,
								A2($elm$core$Maybe$andThen, $author$project$Api$Provider$Charge$One$patient, charge));
							var selectedRegistration = A2(
								$elm_community$list_extra$List$Extra$find,
								function (registration) {
									var registrationPatientId = $author$project$Api$Provider$Patient$Min$id(
										$author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOne$patient(registration));
									return _Utils_eq(
										$elm$core$Maybe$Just(registrationPatientId),
										chargePatientId);
								},
								registrations);
							var formCompanyRegistration = A2(
								$elm$core$Maybe$map,
								function (selectedRegistration_) {
									var accountId = A2(
										$elm$core$Maybe$map,
										$author$project$Api$Provider$CompanyAccount$One$id,
										$author$project$Api$Provider$InvoiceLine$One$companyAccount(invoiceLine));
									return {
										fv: accountId,
										YY: {
											ahP: A2($elm$core$Basics$composeR, $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOne$patient, $author$project$Api$Provider$Patient$Min$id)(selectedRegistration_),
											Bq: A2($elm$core$Basics$composeR, $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOne$patient, $author$project$Api$Provider$Patient$Min$name)(selectedRegistration_)
										}
									};
								},
								selectedRegistration);
							var _v5 = A4(
								$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$formFieldsFromItem,
								apiClient,
								A2($author$project$Utils$FeatureGate$gateAvailable, 14, model.ZV),
								model.aa4,
								charge_);
							var formFields = _v5.a;
							var formFieldsCmd = _v5.b;
							var form = $author$project$Utils$Form$init(formFields);
							var _v6 = A4(
								$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateForm,
								apiClient,
								model,
								$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CompanyRegistration(formCompanyRegistration),
								form);
							var modelWithForm = _v6.a;
							var formCmd_ = _v6.b;
							var _v7 = A2(
								$elm$core$Tuple$mapFirst,
								$author$project$Components$ResourceFilter$CompanyRegistration$extraItems(
									A2(
										$elm$core$Maybe$withDefault,
										_List_Nil,
										A2(
											$elm$core$Maybe$map,
											function (patient_) {
												return _List_fromArray(
													[
														{
														ahP: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$id(patient_),
														Bq: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$name(patient_)
													}
													]);
											},
											patient))),
								A4(
									$author$project$Components$ResourceFilter$CompanyRegistration$init,
									apiClient,
									companyRegistrationsBasePath,
									$elm$core$Basics$identity,
									function (d) {
										return _Utils_update(
											d,
											{
												Gp: 'None',
												ai5: false,
												akb: A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$id, patient)
											});
									}));
							var companyRegistrationResourceFilter = _v7.a;
							var companyRegistrationResourceFilterCmd = _v7.b;
							return _Utils_Tuple2(
								_Utils_update(
									modelWithForm,
									{f_: companyRegistrationResourceFilter}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											formFieldsCmd,
											formCmd_,
											A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CompanyRegistrationResourceFilterMsg, companyRegistrationResourceFilterCmd)
										])));
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					}();
					var newModel = _v3.a;
					var formCmd = _v3.b;
					return {
						GZ: formCmd,
						agZ: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
						aiO: _Utils_update(
							newModel,
							{
								QE: A2(
									$elm$core$Maybe$withDefault,
									false,
									A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$One$discountOverridden, charge)),
								sN: response
							}),
						aR: _List_Nil
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
						aiO: _Utils_update(
							model,
							{sN: response}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					var categories = response.a;
					var category = $elm$core$List$head(categories);
					var _v10 = A5(
						$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$formFieldsInit,
						apiClient,
						A2($author$project$Utils$FeatureGate$gateAvailable, 14, model.ZV),
						model.aa4,
						model.dd,
						category);
					var formFields = _v10.a;
					var formFieldsCmd = _v10.b;
					var _v11 = A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Components$ResourceFilter$Category$extraItems(
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function (category_) {
										return _List_fromArray(
											[
												{
												ahP: $author$project$Api$Provider$Category$All$id(category_),
												Bq: $author$project$Api$Provider$Category$All$name(category_)
											}
											]);
									},
									category))),
						A2(
							$author$project$Components$ResourceFilter$Category$preSelectedId,
							A2($elm$core$Maybe$map, $author$project$Api$Provider$Category$All$id, category),
							formFields.c8));
					var categoryResourceFilter = _v11.a;
					var categoryResourceFilterCmd = _v11.b;
					var form = $elm$core$Maybe$Just(
						$author$project$Utils$Form$init(
							_Utils_update(
								formFields,
								{c8: categoryResourceFilter})));
					return {
						GZ: $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									formFieldsCmd,
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CategoryResourceFilterMsg, categoryResourceFilterCmd)
								])),
						agZ: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
						aiO: _Utils_update(
							model,
							{SD: form}),
						aR: _List_Nil
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
						aiO: model,
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 3:
				var field = msg.a;
				var _v12 = model.SD;
				if (!_v12.$) {
					var form = _v12.a;
					var _v13 = A4($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateForm, apiClient, model, field, form);
					var newModel = _v13.a;
					var formCmd = _v13.b;
					return {GZ: formCmd, agZ: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None, aiO: newModel, aR: _List_Nil};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None, aiO: model, aR: _List_Nil};
				}
			case 8:
				var debounceMsg = msg.a;
				var _v14 = A4(
					$jinjor$elm_debounce$Debounce$update,
					$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$previewDebounceConfig,
					$jinjor$elm_debounce$Debounce$takeLast($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$debouncePreview),
					debounceMsg,
					model.eW);
				var newDebouncer = _v14.a;
				var cmd = _v14.b;
				return {
					GZ: cmd,
					agZ: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
					aiO: _Utils_update(
						model,
						{eW: newDebouncer}),
					aR: _List_Nil
				};
			case 9:
				var cmd = msg.a;
				return {GZ: cmd, agZ: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None, aiO: model, aR: _List_Nil};
			case 10:
				var response = msg.a;
				if (response.$ === 3) {
					var preview = response.a;
					var form = A2(
						$elm$core$Maybe$map,
						$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateFormFromPreview(preview),
						model.SD);
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
						aiO: _Utils_update(
							model,
							{SD: form, akd: response}),
						aR: _List_Nil
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
						aiO: _Utils_update(
							model,
							{akd: response}),
						aR: _List_Nil
					};
				}
			case 4:
				var _v16 = model.SD;
				if (!_v16.$) {
					var form = _v16.a;
					var _v17 = A2($author$project$Utils$Form$validate, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$formFieldsValidator, form);
					if (!_v17.$) {
						var _v18 = _v17.a;
						var newForm = _v18.a;
						var validFormFields = _v18.b;
						return {
							GZ: A3($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$save, apiClient, model, validFormFields),
							agZ: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
							aiO: _Utils_update(
								model,
								{
									SD: $elm$core$Maybe$Just(newForm),
									k9: $author$project$Api$Data$Loading
								}),
							aR: _List_Nil
						};
					} else {
						var newForm = _v17.a;
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
							aiO: _Utils_update(
								model,
								{
									SD: $elm$core$Maybe$Just(newForm)
								}),
							aR: _List_Nil
						};
					}
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None, aiO: model, aR: _List_Nil};
				}
			case 5:
				var fields = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var charge = response.a;
					var id = $author$project$Api$Provider$Charge$One$id(charge);
					var eventName = 'Adjustment Added';
					return {
						GZ: A4($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateCharge, apiClient, model, id, fields),
						agZ: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ChargeCreated,
						aiO: _Utils_update(
							model,
							{k9: $author$project$Api$Data$NotAsked}),
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, eventName)
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
						aiO: _Utils_update(
							model,
							{k9: $author$project$Api$Data$NotAsked}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 6:
				var id = msg.a;
				var params = msg.b;
				var response = msg.c;
				if (response.$ === 3) {
					return {
						GZ: A5(
							$author$project$Api$Provider$Charge$update,
							$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$chargesBasePath(model.Uv),
							apiClient,
							id,
							params,
							$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotChargeUpdated),
						agZ: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ChargeCreated,
						aiO: _Utils_update(
							model,
							{k9: $author$project$Api$Data$Loading}),
						aR: _List_Nil
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
						aiO: _Utils_update(
							model,
							{k9: $author$project$Api$Data$NotAsked}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 7:
				var response = msg.a;
				if (response.$ === 3) {
					var eventName = 'Adjustment Updated';
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$InvoiceLineUpdated(
							A2($elm$core$Maybe$withDefault, '', model.sO)),
						aiO: _Utils_update(
							model,
							{k9: $author$project$Api$Data$NotAsked}),
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, eventName)
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
						aiO: _Utils_update(
							model,
							{k9: $author$project$Api$Data$NotAsked}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 11:
				var subMsg = msg.a;
				var _v22 = model.SD;
				if (!_v22.$) {
					var form = _v22.a;
					var fields = $author$project$Utils$Form$fields(form);
					var chargeItemResourceResult = A3($author$project$Components$ResourceFilter$ChargeItem$update, apiClient, subMsg, fields.cq);
					var newForm = A2(
						$author$project$Utils$Form$set,
						_Utils_update(
							fields,
							{cq: chargeItemResourceResult.aiO}),
						form);
					var _v23 = function () {
						var _v24 = chargeItemResourceResult.agZ;
						_v24$3:
						while (true) {
							if (!_v24.$) {
								switch (_v24.a.$) {
									case 0:
										var chargeItem = _v24.a.a;
										return A4(
											$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateForm,
											apiClient,
											model,
											$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ChargeItem(
												$elm$core$Maybe$Just(
													{Lm: chargeItem.Lm, GW: chargeItem.GW, NN: chargeItem.NN, NP: chargeItem.NP, Qr: chargeItem.Qr, ahP: chargeItem.ahP, aid: chargeItem.aid, sW: chargeItem.sW, Wt: chargeItem.Wt, Bq: chargeItem.Bq, Dw: chargeItem.Dw, _P: chargeItem._P, acZ: chargeItem.acZ, ads: chargeItem.ads, adP: chargeItem.adP})),
											newForm);
									case 5:
										var string = _v24.a.a;
										return A4(
											$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateForm,
											apiClient,
											model,
											$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Name(string),
											newForm);
									case 2:
										var _v25 = _v24.a;
										return A4(
											$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateForm,
											apiClient,
											model,
											$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ChargeItem($elm$core$Maybe$Nothing),
											newForm);
									default:
										break _v24$3;
								}
							} else {
								break _v24$3;
							}
						}
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									SD: $elm$core$Maybe$Just(newForm)
								}),
							$elm$core$Platform$Cmd$none);
					}();
					var newModel = _v23.a;
					var formCmd = _v23.b;
					return {
						GZ: $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ChargeItemResourceFilterMsg, chargeItemResourceResult.GZ),
									formCmd
								])),
						agZ: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
						aiO: newModel,
						aR: chargeItemResourceResult.aR
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None, aiO: model, aR: _List_Nil};
				}
			case 12:
				var subMsg = msg.a;
				var _v26 = model.SD;
				if (!_v26.$) {
					var form = _v26.a;
					var fields = $author$project$Utils$Form$fields(form);
					var categoryResourceResult = A3($author$project$Components$ResourceFilter$Category$update, apiClient, subMsg, fields.c8);
					var newForm = A2(
						$author$project$Utils$Form$set,
						_Utils_update(
							fields,
							{c8: categoryResourceResult.aiO}),
						form);
					var _v27 = function () {
						var _v28 = categoryResourceResult.agZ;
						if (!_v28.$) {
							return A4(
								$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateForm,
								apiClient,
								model,
								$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Category(
									$author$project$Components$ResourceFilter$Category$value(categoryResourceResult.aiO)),
								newForm);
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										SD: $elm$core$Maybe$Just(newForm)
									}),
								$elm$core$Platform$Cmd$none);
						}
					}();
					var newModel = _v27.a;
					var formCmd = _v27.b;
					return {
						GZ: $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CategoryResourceFilterMsg, categoryResourceResult.GZ),
									formCmd
								])),
						agZ: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
						aiO: newModel,
						aR: categoryResourceResult.aR
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None, aiO: model, aR: _List_Nil};
				}
			case 13:
				var subMsg = msg.a;
				var _v29 = model.SD;
				if (!_v29.$) {
					var form = _v29.a;
					var fields = $author$project$Utils$Form$fields(form);
					var practitionerResourceResult = A3($author$project$Components$ResourceFilter$Practitioner$update, apiClient, subMsg, fields.hk);
					var newForm = A2(
						$author$project$Utils$Form$set,
						_Utils_update(
							fields,
							{hk: practitionerResourceResult.aiO}),
						form);
					var _v30 = function () {
						var _v31 = practitionerResourceResult.agZ;
						_v31$2:
						while (true) {
							if (!_v31.$) {
								switch (_v31.a.$) {
									case 0:
										var practitioner = _v31.a.a;
										return A4(
											$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateForm,
											apiClient,
											model,
											$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Practitioner(
												$elm$core$Maybe$Just(practitioner)),
											newForm);
									case 2:
										var _v32 = _v31.a;
										return A4(
											$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateForm,
											apiClient,
											model,
											$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Practitioner($elm$core$Maybe$Nothing),
											newForm);
									default:
										break _v31$2;
								}
							} else {
								break _v31$2;
							}
						}
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									SD: $elm$core$Maybe$Just(newForm)
								}),
							$elm$core$Platform$Cmd$none);
					}();
					var newModel = _v30.a;
					var formCmd = _v30.b;
					return {
						GZ: $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$PractitionerResourceFilterMsg, practitionerResourceResult.GZ),
									formCmd
								])),
						agZ: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
						aiO: newModel,
						aR: practitionerResourceResult.aR
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None, aiO: model, aR: _List_Nil};
				}
			case 14:
				var subMsg = msg.a;
				var _v33 = model.SD;
				if (!_v33.$) {
					var form = _v33.a;
					var fields = $author$project$Utils$Form$fields(form);
					var locationResourceResult = A3($author$project$Components$ResourceFilter$Location$update, apiClient, subMsg, fields.os);
					var newForm = A2(
						$author$project$Utils$Form$set,
						_Utils_update(
							fields,
							{os: locationResourceResult.aiO}),
						form);
					var _v34 = function () {
						var _v35 = locationResourceResult.agZ;
						_v35$2:
						while (true) {
							if (!_v35.$) {
								switch (_v35.a.$) {
									case 0:
										var location = _v35.a.a;
										return A4(
											$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateForm,
											apiClient,
											model,
											$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Location(
												$elm$core$Maybe$Just(location)),
											newForm);
									case 2:
										var _v36 = _v35.a;
										return A4(
											$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateForm,
											apiClient,
											model,
											$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Location($elm$core$Maybe$Nothing),
											newForm);
									default:
										break _v35$2;
								}
							} else {
								break _v35$2;
							}
						}
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									SD: $elm$core$Maybe$Just(newForm)
								}),
							$elm$core$Platform$Cmd$none);
					}();
					var newModel = _v34.a;
					var formCmd = _v34.b;
					return {
						GZ: $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$LocationResourceFilterMsg, locationResourceResult.GZ),
									formCmd
								])),
						agZ: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
						aiO: newModel,
						aR: locationResourceResult.aR
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None, aiO: model, aR: _List_Nil};
				}
			case 15:
				var subMsg = msg.a;
				var companyRegistrationResourceResult = A3($author$project$Components$ResourceFilter$CompanyRegistration$update, apiClient, subMsg, model.f_);
				var _v37 = model.SD;
				if (!_v37.$) {
					var form = _v37.a;
					var _v38 = function () {
						var _v39 = companyRegistrationResourceResult.agZ;
						_v39$2:
						while (true) {
							if (!_v39.$) {
								switch (_v39.a.$) {
									case 0:
										var companyRegistration = _v39.a.a;
										var patientId_ = A2($elm$core$Basics$composeR, $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$patient, $author$project$Api$Provider$Patient$Min$id)(companyRegistration);
										var formCompanyRegistration = {
											fv: $elm$core$Maybe$Just(
												A2($elm$core$Basics$composeR, $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$account, $author$project$Api$Provider$CompanyAccount$Min$id)(companyRegistration)),
											YY: {
												ahP: patientId_,
												Bq: A2($elm$core$Basics$composeR, $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$patient, $author$project$Api$Provider$Patient$Min$name)(companyRegistration)
											}
										};
										return A2(
											$author$project$Utils$Tuple3$fromTuple2,
											$elm$core$Maybe$Just(patientId_),
											A4(
												$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateForm,
												apiClient,
												model,
												$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CompanyRegistration(
													$elm$core$Maybe$Just(formCompanyRegistration)),
												form));
									case 2:
										var _v40 = _v39.a;
										return A2(
											$author$project$Utils$Tuple3$fromTuple2,
											$elm$core$Maybe$Nothing,
											A4(
												$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateForm,
												apiClient,
												model,
												$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CompanyRegistration($elm$core$Maybe$Nothing),
												form));
									default:
										break _v39$2;
								}
							} else {
								break _v39$2;
							}
						}
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
					}();
					var newModel = _v38.a;
					var formCmd = _v38.b;
					var patientId = _v38.c;
					return {
						GZ: $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CompanyRegistrationResourceFilterMsg, companyRegistrationResourceResult.GZ),
									formCmd,
									function () {
									if (!patientId.$) {
										var patientId_ = patientId.a;
										var _v42 = model.Uv;
										if (_v42.$ === 1) {
											return A3($author$project$Api$Provider$Patient$retrieve, apiClient, patientId_, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotPatient);
										} else {
											var affiliateId = _v42.a;
											return A4($author$project$Api$Provider$Affiliates$AffiliatePatient$retrieve, apiClient, affiliateId, patientId_, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotAffiliatePatient);
										}
									} else {
										return $elm$core$Platform$Cmd$none;
									}
								}()
								])),
						agZ: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
						aiO: _Utils_update(
							newModel,
							{f_: companyRegistrationResourceResult.aiO}),
						aR: companyRegistrationResourceResult.aR
					};
				} else {
					return {
						GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CompanyRegistrationResourceFilterMsg, companyRegistrationResourceResult.GZ),
						agZ: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
						aiO: _Utils_update(
							model,
							{f_: companyRegistrationResourceResult.aiO}),
						aR: _List_Nil
					};
				}
			case 16:
				var dateInput = msg.a;
				var subMsg = msg.b;
				return A7(
					$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateDateInputFormField,
					apiClient,
					model,
					dateInput,
					subMsg,
					$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$StartDateInputMsg,
					$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$StartDate,
					function ($) {
						return $.ab7;
					});
			case 17:
				var dateInput = msg.a;
				var subMsg = msg.b;
				return A7(
					$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateDateInputFormField,
					apiClient,
					model,
					dateInput,
					subMsg,
					$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$EndDateInputMsg,
					$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$EndDate,
					function ($) {
						return $.sb;
					});
			case 18:
				var response = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
					aiO: _Utils_update(
						model,
						{Ob: response}),
					aR: $author$project$OutMsg$handleErrorResponse(response)
				};
			case 19:
				var response = msg.a;
				var _v43 = _Utils_Tuple2(response, model.SD);
				if ((_v43.a.$ === 3) && (!_v43.b.$)) {
					var _v44 = _v43.a;
					var patient = _v44.a;
					var form = _v43.b.a;
					var _v45 = function () {
						var _v46 = _Utils_Tuple2(
							$author$project$Api$Provider$Patient$One$location(patient),
							$author$project$Api$Provider$Patient$One$practitioner(patient));
						if (!_v46.a.$) {
							if (!_v46.b.$) {
								var location = _v46.a.a;
								var practitioner = _v46.b.a;
								var field_ = $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Location(
									$author$project$Components$ResourceFilter$Location$resourceFromShared(
										$elm$core$Maybe$Just(
											$author$project$Api$Location$Shared$Provider(location))));
								return _Utils_Tuple2(
									A3(
										$author$project$Utils$Form$update,
										$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$formFieldsUpdate,
										$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Practitioner(
											$author$project$Components$ResourceFilter$Practitioner$resourceFromShared(
												$elm$core$Maybe$Just(
													$author$project$Api$Practitioner$Shared$Provider(practitioner)))),
										A3($author$project$Utils$Form$update, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$formFieldsUpdate, field_, form)),
									$elm$core$Maybe$Just(field_));
							} else {
								var location = _v46.a.a;
								var _v47 = _v46.b;
								var field_ = $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Location(
									$author$project$Components$ResourceFilter$Location$resourceFromShared(
										$elm$core$Maybe$Just(
											$author$project$Api$Location$Shared$Provider(location))));
								return _Utils_Tuple2(
									A3($author$project$Utils$Form$update, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$formFieldsUpdate, field_, form),
									$elm$core$Maybe$Just(field_));
							}
						} else {
							if (!_v46.b.$) {
								var _v48 = _v46.a;
								var practitioner = _v46.b.a;
								var field_ = $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Practitioner(
									$author$project$Components$ResourceFilter$Practitioner$resourceFromShared(
										$elm$core$Maybe$Just(
											$author$project$Api$Practitioner$Shared$Provider(practitioner))));
								return _Utils_Tuple2(
									A3($author$project$Utils$Form$update, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$formFieldsUpdate, field_, form),
									$elm$core$Maybe$Just(field_));
							} else {
								var _v49 = _v46.a;
								var _v50 = _v46.b;
								return _Utils_Tuple2(form, $elm$core$Maybe$Nothing);
							}
						}
					}();
					var newForm = _v45.a;
					var field = _v45.b;
					var _v51 = function () {
						if (!field.$) {
							var field_ = field.a;
							return A4($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$calculatePreview, apiClient, field_, newForm, model);
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					}();
					var newModel = _v51.a;
					var calculatePreviewCmd = _v51.b;
					return {
						GZ: calculatePreviewCmd,
						agZ: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
						aiO: _Utils_update(
							newModel,
							{
								SD: $elm$core$Maybe$Just(newForm)
							}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
						aiO: model,
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			default:
				var response = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
					aiO: model,
					aR: $author$project$OutMsg$handleErrorResponse(response)
				};
		}
	});
var $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$GotCoverageDiscounts = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$Charge$CoverageDiscount$list = F3(
	function (apiClient, chargeId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$CoveredCharge$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Charge$CoverageDiscount$coverageDiscountsPath(chargeId)));
	});
var $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{p7: !model.p7}),
					function () {
						var _v1 = model.gz;
						if (_v1.$ === 3) {
							return $elm$core$Platform$Cmd$none;
						} else {
							return A4($author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$retrieveInvoiceLine, apiClient, model.aa4, model.Uv, model.sN);
						}
					}(),
					_List_Nil);
			case 1:
				var response = msg.a;
				if (response.$ === 3) {
					var invoiceLine = response.a;
					var charge = $elm$core$List$head(
						$author$project$Api$Provider$InvoiceLine$One$charges(invoiceLine));
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{gz: response}),
						function () {
							var _v3 = _Utils_Tuple3(
								$author$project$Api$Platform$Session$One$organizationIsCompany(model.aa4),
								charge,
								model.Uv);
							if (((!_v3.a) && (!_v3.b.$)) && (_v3.c.$ === 1)) {
								var charge_ = _v3.b.a;
								var _v4 = _v3.c;
								return A3(
									$author$project$Api$Provider$Charge$CoverageDiscount$list,
									apiClient,
									$author$project$Api$Provider$Charge$One$id(charge_),
									$author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$GotCoverageDiscounts);
							} else {
								return $elm$core$Platform$Cmd$none;
							}
						}(),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{gz: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{yU: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
		}
	});
var $author$project$Components$Invoice$InvoiceLinesTable$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var invoiceLines = response.a;
					var headers = response.b;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 1,
						aiO: _Utils_update(
							model,
							{
								aO: response,
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ),
								eS: $elm$core$Dict$fromList(
									A2(
										$elm$core$List$map,
										function (invoiceLine) {
											var invoiceType = function () {
												var _v2 = model.Uv;
												if (!_v2.$) {
													var affiliateBillId = _v2.b;
													return $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$Affiliate(affiliateBillId);
												} else {
													var companyId_ = _v2.a;
													var invoiceId = _v2.b;
													return A2($author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$Company, companyId_, invoiceId);
												}
											}();
											var phiMoreInfo = A4(
												$author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$init,
												model.aa4,
												invoiceType,
												$author$project$Components$Invoice$InvoiceLinesTable$usesEmployeeDivisions(model.afQ),
												invoiceLine);
											return _Utils_Tuple2(
												$author$project$Api$Provider$InvoiceLine$All$id(invoiceLine),
												phiMoreInfo);
										},
										invoiceLines))
							}),
						aR: _List_Nil
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 1,
						aiO: _Utils_update(
							model,
							{aO: response}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 1:
				var response = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 1,
					aiO: _Utils_update(
						model,
						{zr: response}),
					aR: $author$project$OutMsg$handleErrorResponse(response)
				};
			case 2:
				var subMsg = msg.a;
				var _v3 = A2($author$project$Ui$SearchInput$update, subMsg, model.up);
				var searchInput = _v3.a;
				var searchInputCmd = _v3.b;
				var searchInputEvent = _v3.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.akl;
					}
				}();
				var _v4 = function () {
					if (_Utils_eq(q, model.akl)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								aO: $author$project$Api$Data$Loading,
								ajJ: $author$project$Api$Pagination$reset(model.ajJ),
								akl: q
							});
						return _Utils_Tuple2(
							qModel,
							A2($author$project$Components$Invoice$InvoiceLinesTable$fetchInvoiceLines, apiClient, qModel));
					}
				}();
				var newModel = _v4.a;
				var cmd = _v4.b;
				return {
					GZ: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$SearchInputMsg, searchInputCmd),
								cmd
							])),
					agZ: 1,
					aiO: _Utils_update(
						newModel,
						{up: searchInput}),
					aR: _List_Nil
				};
			case 3:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{aO: $author$project$Api$Data$Loading, ajJ: pagination});
				return {
					GZ: A2($author$project$Components$Invoice$InvoiceLinesTable$fetchInvoiceLines, apiClient, newModel),
					agZ: 1,
					aiO: newModel,
					aR: _List_Nil
				};
			case 4:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						aO: $author$project$Api$Data$Loading,
						alA: A2($author$project$Api$Sort$update, columnId, model.alA)
					});
				return {
					GZ: A2($author$project$Components$Invoice$InvoiceLinesTable$fetchInvoiceLines, apiClient, newModel),
					agZ: 1,
					aiO: newModel,
					aR: _List_Nil
				};
			case 5:
				var subMsg = msg.a;
				var categoryResourceResult = A3($author$project$Components$ResourceFilter$Category$update, apiClient, subMsg, model.c8);
				var categoryId = function () {
					var _v7 = categoryResourceResult.agZ;
					if (!_v7.$) {
						return $author$project$Components$ResourceFilter$Category$value(categoryResourceResult.aiO);
					} else {
						return model.iF;
					}
				}();
				var newModel = _Utils_update(
					model,
					{iF: categoryId, c8: categoryResourceResult.aiO});
				var _v6 = _Utils_eq(model.iF, newModel.iF) ? _Utils_Tuple2(model.aO, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					$author$project$Api$Data$Loading,
					A2($author$project$Components$Invoice$InvoiceLinesTable$fetchInvoiceLines, apiClient, newModel));
				var invoiceLines = _v6.a;
				var cmd = _v6.b;
				return {
					GZ: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$CategoryResourceFilterMsg, categoryResourceResult.GZ),
								cmd
							])),
					agZ: 1,
					aiO: _Utils_update(
						newModel,
						{aO: invoiceLines}),
					aR: categoryResourceResult.aR
				};
			case 6:
				var subMsg = msg.a;
				var _v8 = model.hi;
				if (!_v8.$) {
					var planResourceFilter = _v8.a;
					var planResourceResult = A3($author$project$Components$ResourceFilter$Plan$update, apiClient, subMsg, planResourceFilter);
					var planId = function () {
						var _v10 = planResourceResult.agZ;
						if (!_v10.$) {
							return $author$project$Components$ResourceFilter$Plan$value(planResourceResult.aiO);
						} else {
							return model.aj4;
						}
					}();
					var newModel = _Utils_update(
						model,
						{
							aj4: planId,
							hi: $elm$core$Maybe$Just(planResourceResult.aiO)
						});
					var _v9 = _Utils_eq(model.aj4, newModel.aj4) ? _Utils_Tuple2(model.aO, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
						$author$project$Api$Data$Loading,
						A2($author$project$Components$Invoice$InvoiceLinesTable$fetchInvoiceLines, apiClient, newModel));
					var invoiceLines = _v9.a;
					var cmd = _v9.b;
					return {
						GZ: $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$PlanResourceFilterMsg, planResourceResult.GZ),
									cmd
								])),
						agZ: 1,
						aiO: _Utils_update(
							newModel,
							{aO: invoiceLines}),
						aR: planResourceResult.aR
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 1, aiO: model, aR: _List_Nil};
				}
			case 7:
				var subMsg = msg.a;
				var _v11 = A2($author$project$Ui$Dropdown$update, subMsg, model.nv);
				var employeeDivisionDropdown = _v11.a;
				var cmd = _v11.b;
				return {
					GZ: cmd,
					agZ: 1,
					aiO: _Utils_update(
						model,
						{nv: employeeDivisionDropdown}),
					aR: _List_Nil
				};
			case 8:
				var selectedDivision = msg.a;
				var newModel = _Utils_update(
					model,
					{
						HA: selectedDivision,
						aO: $author$project$Api$Data$Loading,
						ajJ: $author$project$Api$Pagination$reset(model.ajJ)
					});
				return {
					GZ: A2($author$project$Components$Invoice$InvoiceLinesTable$fetchInvoiceLines, apiClient, newModel),
					agZ: 1,
					aiO: newModel,
					aR: _List_Nil
				};
			case 9:
				return A3($author$project$Components$Invoice$InvoiceLinesTable$openAdjustmentModal, apiClient, model, $elm$core$Maybe$Nothing);
			case 10:
				var invoiceLine = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 1,
					aiO: _Utils_update(
						model,
						{
							gb: $elm$core$Maybe$Just(
								_Utils_Tuple2(invoiceLine, $author$project$Api$Data$NotAsked))
						}),
					aR: _List_Nil
				};
			case 11:
				var invoiceLine = msg.a;
				var confirmed = msg.b;
				if (confirmed) {
					var id = $author$project$Api$Provider$InvoiceLine$All$id(invoiceLine);
					return {
						GZ: function () {
							var _v12 = model.Uv;
							if (_v12.$ === 1) {
								var companyId_ = _v12.a;
								var invoiceId_ = _v12.b;
								return A5(
									$author$project$Api$Provider$Company$Invoice$InvoiceLine$delete,
									apiClient,
									companyId_,
									invoiceId_,
									id,
									$author$project$Components$Invoice$InvoiceLinesTable$InvoiceLineDeleted(id));
							} else {
								var invoiceId_ = _v12.b;
								return A4(
									$author$project$Api$Provider$AffiliateBill$InvoiceLine$delete,
									apiClient,
									invoiceId_,
									id,
									$author$project$Components$Invoice$InvoiceLinesTable$InvoiceLineDeleted(id));
							}
						}(),
						agZ: 1,
						aiO: _Utils_update(
							model,
							{
								gb: $elm$core$Maybe$Just(
									_Utils_Tuple2(invoiceLine, $author$project$Api$Data$Loading)),
								ef: A2($elm$core$Set$insert, id, model.ef)
							}),
						aR: _List_Nil
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 1,
						aiO: _Utils_update(
							model,
							{gb: $elm$core$Maybe$Nothing}),
						aR: _List_Nil
					};
				}
			case 12:
				var id = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return {
							GZ: A2($author$project$Components$Invoice$InvoiceLinesTable$fetchInvoiceLines, apiClient, model),
							agZ: 0,
							aiO: _Utils_update(
								model,
								{
									gb: $elm$core$Maybe$Nothing,
									ef: A2($elm$core$Set$remove, id, model.ef),
									aO: $author$project$Api$Data$Loading
								}),
							aR: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Invoice line removed')
								])
						};
					case 2:
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 1,
							aiO: _Utils_update(
								model,
								{
									ef: A2($elm$core$Set$remove, id, model.ef)
								}),
							aR: $author$project$OutMsg$handleErrorResponse(response)
						};
					default:
						return {GZ: $elm$core$Platform$Cmd$none, agZ: 1, aiO: model, aR: _List_Nil};
				}
			case 13:
				var invoiceLine = msg.a;
				var id = $author$project$Api$Provider$InvoiceLine$All$id(invoiceLine);
				return A3(
					$author$project$Components$Invoice$InvoiceLinesTable$openAdjustmentModal,
					apiClient,
					model,
					$elm$core$Maybe$Just(id));
			case 14:
				var id = msg.a;
				var subMsg = msg.b;
				var _v14 = A2($elm$core$Dict$get, id, model.eS);
				if (!_v14.$) {
					var phiMoreInfo = _v14.a;
					var _v15 = A3($author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$update, apiClient, subMsg, phiMoreInfo);
					var phiMoreInfo_ = _v15.a;
					var phiMoreInfoCmd = _v15.b;
					var phiMoreInfoOutMsgs = _v15.c;
					return {
						GZ: A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfoMsg(id),
							phiMoreInfoCmd),
						agZ: 1,
						aiO: _Utils_update(
							model,
							{
								eS: A3($elm$core$Dict$insert, id, phiMoreInfo_, model.eS)
							}),
						aR: phiMoreInfoOutMsgs
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 1, aiO: model, aR: _List_Nil};
				}
			case 15:
				var subMsg = msg.a;
				var _v16 = model.il;
				if (!_v16.$) {
					var adjustmentModal = _v16.a;
					var adjustmentModalResult = A3($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$update, apiClient, subMsg, adjustmentModal);
					var _v17 = function () {
						var _v18 = adjustmentModalResult.agZ;
						switch (_v18.$) {
							case 0:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(adjustmentModalResult.aiO),
									1,
									$elm$core$Maybe$Nothing);
							case 1:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, 1, $elm$core$Maybe$Nothing);
							case 2:
								var id = _v18.a;
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									0,
									$elm$core$Maybe$Just(id));
							default:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, 0, $elm$core$Maybe$Nothing);
						}
					}();
					var adjustmentModal_ = _v17.a;
					var event = _v17.b;
					var toUpdateId = _v17.c;
					var _v19 = A3($author$project$Components$Invoice$InvoiceLinesTable$refreshPhiMoreInfo, apiClient, model.eS, toUpdateId);
					var phiMoreInfos = _v19.a;
					var phiMoreInfoCmd = _v19.b;
					return {
						GZ: $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModalMsg, adjustmentModalResult.GZ),
									phiMoreInfoCmd
								])),
						agZ: event,
						aiO: _Utils_update(
							model,
							{il: adjustmentModal_, eS: phiMoreInfos}),
						aR: adjustmentModalResult.aR
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 1, aiO: model, aR: _List_Nil};
				}
			case 17:
				var subMsg = msg.a;
				var _v20 = $author$project$Components$FileLink$update(subMsg);
				var getFileCmdMsg = _v20.a;
				var outMsgs = _v20.b;
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$ExportFileMsg, getFileCmdMsg),
					agZ: 1,
					aiO: model,
					aR: outMsgs
				};
			default:
				var subMsg = msg.a;
				var _v21 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.nD);
				var exportCsv = _v21.a;
				var subCmd = _v21.b;
				var subOutMsg = _v21.c;
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$ExportCsvMsg, subCmd),
					agZ: 1,
					aiO: _Utils_update(
						model,
						{nD: exportCsv}),
					aR: subOutMsg
				};
		}
	});
var $author$project$Components$Invoice$Summary$OtherChargesSummary$update = F2(
	function (msg, model) {
		return _Utils_update(
			model,
			{hG: !model.hG});
	});
var $author$project$Components$Invoice$Summary$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var groupBy_ = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							gx: $elm$core$Maybe$Just(groupBy_)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{hH: !model.hH}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{hF: !model.hF}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{zb: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 4:
				var delta = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							oV: $elm$core$Maybe$Just(delta)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oV: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var subMsg = msg.a;
				var otherChargesSummary = A2($author$project$Components$Invoice$Summary$OtherChargesSummary$update, subMsg, model.tv);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{tv: otherChargesSummary}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
		}
	});
var $author$project$Components$Invoice$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var dateInput = field.a;
			var date = field.b;
			return _Utils_update(
				fields,
				{Uq: date, n3: dateInput});
		} else {
			var dateInput = field.a;
			var date = field.b;
			return _Utils_update(
				fields,
				{j_: date, n4: dateInput});
		}
	});
var $author$project$Api$Provider$Company$Invoice$updateDates = F5(
	function (apiClient, companyId, id, _v0, toMsg) {
		var invoiceDate = _v0.Uq;
		var dueDate = _v0.QX;
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'invoice',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'date',
								$author$project$Utils$Date$encode(invoiceDate)),
								_Utils_Tuple2(
								'due_date',
								$author$project$Utils$Date$encode(dueDate))
							])))
				]));
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$Invoice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Provider$Company$Invoice$invoicePath, companyId, id))));
	});
var $author$project$Api$Company$Invoice$updateDates = F6(
	function (apiClient, session, companyId, id, dates, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : A5(
			$author$project$Api$Provider$Company$Invoice$updateDates,
			apiClient,
			companyId,
			id,
			dates,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Invoice$One$Provider)));
	});
var $author$project$Components$Invoice$updateDateInputFormField = F7(
	function (apiClient, model, dateInput, subMsg, toMsg, field, fieldGetter) {
		var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
		var newDateInput = _v0.a;
		var subCmd = _v0.b;
		var event = _v0.c;
		var cmdInput = A2(
			$elm$core$Platform$Cmd$map,
			toMsg(newDateInput),
			subCmd);
		if (event.$ === 1) {
			var maybeDate = event.a;
			if (!maybeDate.$) {
				var date = maybeDate.a;
				var form = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Invoice$formFieldsUpdate,
					A2(field, newDateInput, date),
					model.cY);
				var updateInvoiceCmd = function () {
					var _v3 = model.Uv;
					if (!_v3.$) {
						return $elm$core$Platform$Cmd$none;
					} else {
						var companyId = _v3.a;
						var id = _v3.b;
						var newFields = $author$project$Utils$Form$fields(form);
						var dateFields = {QX: newFields.j_, Uq: newFields.Uq};
						return A6($author$project$Api$Company$Invoice$updateDates, apiClient, model.aa4, companyId, id, dateFields, $author$project$Components$Invoice$GotCompanyInvoice);
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cY: form, p4: false, p6: false}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[cmdInput, updateInvoiceCmd])),
					_List_Nil);
			} else {
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
			}
		} else {
			var fields = $author$project$Utils$Form$fields(model.cY);
			var form = A3(
				$author$project$Utils$Form$update,
				$author$project$Components$Invoice$formFieldsUpdate,
				A2(
					field,
					newDateInput,
					fieldGetter(fields)),
				model.cY);
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{cY: form}),
				cmdInput,
				_List_Nil);
		}
	});
var $author$project$Components$Invoice$Voided = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Api$Provider$Company$Invoice$void = F4(
	function (apiClient, companyId, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Invoice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['void']),
					A2($author$project$Api$Provider$Company$Invoice$invoicePath, companyId, id))));
	});
var $author$project$Api$Company$Invoice$void = F5(
	function (apiClient, session, companyId, id, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : A4(
			$author$project$Api$Provider$Company$Invoice$void,
			apiClient,
			companyId,
			id,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Invoice$One$Provider)));
	});
var $author$project$Api$Provider$AffiliateBill$void = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Invoice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['void']),
					$author$project$Api$Provider$AffiliateBill$affiliateBillPath(id))));
	});
var $author$project$Components$Invoice$void = F4(
	function (apiClient, session, invoiceType, invoice) {
		if (!invoiceType.$) {
			var id = invoiceType.b;
			return A3(
				$author$project$Api$Provider$AffiliateBill$void,
				apiClient,
				id,
				A2(
					$elm$core$Basics$composeL,
					$author$project$Components$Invoice$Voided(invoice),
					$author$project$Api$Data$map($author$project$Api$Invoice$One$Provider)));
		} else {
			var companyId = invoiceType.a;
			var id = invoiceType.b;
			return A5(
				$author$project$Api$Company$Invoice$void,
				apiClient,
				session,
				companyId,
				id,
				$author$project$Components$Invoice$Voided(invoice));
		}
	});
var $author$project$Components$Invoice$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var invoice = response.a;
					var auditTrailLog = A7(
						$author$project$Components$AuditTrailLog$init,
						model.aa4,
						model.adY,
						model.J7,
						$elm$core$Maybe$Just('invoice'),
						$elm$core$Maybe$Just(
							$author$project$Api$Invoice$One$id(invoice)),
						$author$project$Api$Invoice$One$createdAt(invoice),
						$elm$core$Maybe$Nothing);
					var _v3 = A7(
						$author$project$Components$Invoice$InvoiceLinesTable$init,
						model.dd,
						apiClient,
						model.aa4,
						model.ZV,
						$author$project$Components$Invoice$invoiceLinesTableCompany(model.afQ),
						$author$project$Components$Invoice$invoiceLinesTableInvoiceType(model.Uv),
						invoice);
					var invoiceLinesTable = _v3.a;
					var invoiceLinesTableCmd = _v3.b;
					var _v4 = $author$project$Components$Invoice$formFieldsFromInvoice(invoice);
					var fields = _v4.a;
					var fieldsCmd = _v4.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cY: $author$project$Utils$Form$init(fields),
								iw: $elm$core$Maybe$Just(auditTrailLog),
								Uk: response,
								eB: $elm$core$Maybe$Just(invoiceLinesTable)
							}),
						$elm$core$Platform$Cmd$batch(
							A2(
								$elm$core$List$cons,
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTableMsg, invoiceLinesTableCmd),
								A2(
									$elm$core$List$cons,
									function () {
										var _v5 = model.Uv;
										if (_v5.$ === 1) {
											var companyId = _v5.a;
											var invoiceId = _v5.b;
											return A5($author$project$Api$Company$Invoice$Summary$retrieve, apiClient, model.aa4, companyId, invoiceId, $author$project$Components$Invoice$GotSummary);
										} else {
											var invoiceId = _v5.b;
											return A3($author$project$Api$Provider$AffiliateBill$Summary$retrieve, apiClient, invoiceId, $author$project$Components$Invoice$GotSummary);
										}
									}(),
									A2(
										$elm$core$List$cons,
										$author$project$Api$Invoice$One$isUpdating(invoice) ? $author$project$Components$Invoice$pollInvoiceForStatus : $elm$core$Platform$Cmd$none,
										fieldsCmd)))),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Uk: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var response = msg.a;
				if (response.$ === 3) {
					var invoice = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Uk: response}),
						$author$project$Api$Invoice$One$isUpdating(invoice) ? $author$project$Components$Invoice$pollInvoiceForStatus : A3($author$project$Components$Invoice$retrieveInvoice, apiClient, model.aa4, model.Uv),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Uk: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 2:
				var response = msg.a;
				var _v7 = _Utils_Tuple2(response, model.Uk);
				if ((_v7.a.$ === 3) && (_v7.b.$ === 3)) {
					var _v8 = _v7.a;
					var summary = _v8.a;
					var _v9 = _v7.b;
					var invoice = _v9.a;
					var totalCount = $author$project$Api$Common$Invoice$Summary$AllLines$count(
						$author$project$Api$Common$Invoice$Summary$allLines(summary));
					var invoiceSummaryInvoiceType = function () {
						var _v11 = model.Uv;
						if (!_v11.$) {
							var id = _v11.b;
							return $author$project$Components$Invoice$Summary$Affiliate(id);
						} else {
							var companyId = _v11.a;
							var id = _v11.b;
							return A2($author$project$Components$Invoice$Summary$Company, companyId, id);
						}
					}();
					var _v10 = A8(
						$author$project$Components$Invoice$Summary$init,
						apiClient,
						model.aa4,
						model.J7,
						model.ZV,
						$author$project$Components$Invoice$invoiceSummaryCompany(model.afQ),
						invoiceSummaryInvoiceType,
						invoice,
						summary);
					var invoiceSummary = _v10.a;
					var invoiceSummaryCmd = _v10.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Aj: $elm$core$Maybe$Just(totalCount),
								gB: $elm$core$Maybe$Just(invoiceSummary)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceSummaryMsg, invoiceSummaryCmd),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 3:
				var subMsg = msg.a;
				var _v12 = A2($author$project$Ui$Dropdown$update, subMsg, model.no);
				var dropdownMenu = _v12.a;
				var cmd = _v12.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{no: dropdownMenu}),
					cmd,
					_List_Nil);
			case 4:
				var invoice = msg.a;
				return A2(
					$author$project$Utils$Tuple3$fromTuple2,
					_List_Nil,
					A4($author$project$Components$Invoice$initCompanyEmailModal, apiClient, model, invoice, false));
			case 5:
				var invoice = msg.a;
				return A2(
					$author$project$Utils$Tuple3$fromTuple2,
					_List_Nil,
					A4(
						$author$project$Components$Invoice$initCompanyEmailModal,
						apiClient,
						_Utils_update(
							model,
							{k9: $author$project$Api$Data$NotAsked}),
						invoice,
						true));
			case 6:
				var invoice = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							vp: $elm$core$Maybe$Just(invoice)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 7:
				var invoice = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							k9: $author$project$Api$Data$Loading,
							vp: $elm$core$Maybe$Just(invoice)
						}),
					A4($author$project$Components$Invoice$void, apiClient, model.aa4, model.Uv, invoice),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{vp: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 8:
				var invoice = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Uk: response, k9: $author$project$Api$Data$NotAsked, vp: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Invoice voided')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								k9: $author$project$Api$Data$NotAsked,
								vp: $elm$core$Maybe$Just(invoice)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 9:
				var invoice = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							e7: $elm$core$Maybe$Just(invoice)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 10:
				var invoice = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							e7: $elm$core$Maybe$Just(invoice),
							k9: $author$project$Api$Data$Loading
						}),
					A4($author$project$Components$Invoice$returnToDraft, apiClient, model.aa4, model.Uv, invoice),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{e7: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 11:
				var invoice = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Uk: response, e7: $elm$core$Maybe$Nothing, k9: $author$project$Api$Data$NotAsked}),
						$author$project$Components$Invoice$pollInvoiceForStatus,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Invoice returned to draft')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								e7: $elm$core$Maybe$Just(invoice),
								k9: $author$project$Api$Data$NotAsked
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 12:
				var invoice = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							eJ: $elm$core$Maybe$Just(invoice)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 13:
				var invoice = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							eJ: $elm$core$Maybe$Just(invoice),
							k9: $author$project$Api$Data$Loading
						}),
					A4($author$project$Components$Invoice$markAsBadDebt, apiClient, model.aa4, model.Uv, invoice),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{eJ: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 14:
				var invoice = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Uk: response, eJ: $elm$core$Maybe$Nothing, k9: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Invoice marked as bad debt')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								eJ: $elm$core$Maybe$Just(invoice),
								k9: $author$project$Api$Data$NotAsked
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 15:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{k9: $author$project$Api$Data$Loading}),
					A3($author$project$Components$Invoice$reverseBadDebt, apiClient, model.aa4, model.Uv),
					_List_Nil);
			case 16:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Uk: response, k9: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Invoice returned to issued')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 17:
				var invoice = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							i9: $elm$core$Maybe$Just(invoice)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 18:
				var invoice = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							i9: $elm$core$Maybe$Just(invoice),
							k9: $author$project$Api$Data$Loading
						}),
					A4($author$project$Components$Invoice$delete, apiClient, model.aa4, model.Uv, invoice),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{i9: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 19:
				var invoice = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{i9: $elm$core$Maybe$Nothing, k9: $author$project$Api$Data$NotAsked}),
						A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, model.Is),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Invoice destroyed successfully')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								i9: $elm$core$Maybe$Just(invoice),
								k9: $author$project$Api$Data$NotAsked
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 20:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{k9: $author$project$Api$Data$Loading}),
					A3($author$project$Components$Invoice$issue, apiClient, model.aa4, model.Uv),
					_List_Nil);
			case 21:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Uk: response, k9: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Invoice issued')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 22:
				var invoice = msg.a;
				return A2(
					$author$project$Utils$Tuple3$fromTuple2,
					_List_Nil,
					A4($author$project$Components$Invoice$initCreatePaymentModal, apiClient, model, invoice, false));
			case 23:
				var invoice = msg.a;
				return A2(
					$author$project$Utils$Tuple3$fromTuple2,
					_List_Nil,
					A4($author$project$Components$Invoice$initCreatePaymentModal, apiClient, model, invoice, true));
			case 24:
				var subMsg = msg.a;
				var paymentsHistoryResult = A3($author$project$Components$Invoice$PaymentsHistory$update, apiClient, subMsg, model.kC);
				var _v19 = function () {
					var refreshInvoice = _Utils_Tuple2(
						$author$project$Api$Data$Loading,
						A3($author$project$Components$Invoice$retrieveInvoice, apiClient, model.aa4, model.Uv));
					var _v20 = paymentsHistoryResult.agZ;
					switch (_v20) {
						case 0:
							return _Utils_Tuple2(model.Uk, $elm$core$Platform$Cmd$none);
						case 1:
							return refreshInvoice;
						case 2:
							return refreshInvoice;
						case 3:
							return refreshInvoice;
						case 4:
							return refreshInvoice;
						default:
							return refreshInvoice;
					}
				}();
				var invoice = _v19.a;
				var cmd = _v19.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Uk: invoice, kC: paymentsHistoryResult.aiO}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$PaymentsHistoryMsg, paymentsHistoryResult.GZ),
								cmd
							])),
					paymentsHistoryResult.aR);
			case 25:
				var subMsg = msg.a;
				var _v21 = model.iM;
				if (!_v21.$) {
					var companyEmailModal = _v21.a;
					var companyEmailModalResult = A3($author$project$Components$CompanyEmailModal$update, apiClient, subMsg, companyEmailModal);
					var _v22 = function () {
						var _v23 = companyEmailModalResult.agZ;
						switch (_v23) {
							case 2:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(companyEmailModalResult.aiO),
									model.Uk,
									$elm$core$Platform$Cmd$none);
							case 1:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Api$Data$Loading,
									A3($author$project$Components$Invoice$retrieveInvoice, apiClient, model.aa4, model.Uv));
							default:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.Uk, $elm$core$Platform$Cmd$none);
						}
					}();
					var companyEmailModal_ = _v22.a;
					var invoice = _v22.b;
					var cmd = _v22.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{iM: companyEmailModal_, Uk: invoice}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$CompanyEmailModalMsg, companyEmailModalResult.GZ),
									cmd
								])),
						companyEmailModalResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 26:
				var subMsg = msg.a;
				var _v24 = model.m$;
				if (!_v24.$) {
					var createPaymentModal = _v24.a;
					var createPaymentModalResult = A3($author$project$Components$Invoice$CreatePaymentModal$update, apiClient, subMsg, createPaymentModal);
					var _v25 = function () {
						var _v26 = createPaymentModalResult.agZ;
						switch (_v26) {
							case 1:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(createPaymentModalResult.aiO),
									model.Uk,
									$elm$core$Platform$Cmd$none);
							case 2:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Api$Data$Loading,
									A3($author$project$Components$Invoice$retrieveInvoice, apiClient, model.aa4, model.Uv));
							default:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.Uk, $elm$core$Platform$Cmd$none);
						}
					}();
					var createPaymentModal_ = _v25.a;
					var invoice = _v25.b;
					var cmd = _v25.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{m$: createPaymentModal_, Uk: invoice}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$CreatePaymentModalMsg, createPaymentModalResult.GZ),
									cmd
								])),
						createPaymentModalResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 27:
				var subMsg = msg.a;
				var _v27 = model.gB;
				if (!_v27.$) {
					var invoiceSummary = _v27.a;
					var _v28 = A2($author$project$Components$Invoice$Summary$update, subMsg, invoiceSummary);
					var invoiceSummary_ = _v28.a;
					var invoiceSummaryCmd = _v28.b;
					var invoiceSummaryOutMsgs = _v28.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								gB: $elm$core$Maybe$Just(invoiceSummary_)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceSummaryMsg, invoiceSummaryCmd),
						invoiceSummaryOutMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 28:
				var subMsg = msg.a;
				var _v29 = model.eB;
				if (!_v29.$) {
					var invoiceLinesTable = _v29.a;
					var invoiceLinesTableResult = A3($author$project$Components$Invoice$InvoiceLinesTable$update, apiClient, subMsg, invoiceLinesTable);
					var _v30 = function () {
						var _v31 = invoiceLinesTableResult.agZ;
						if (_v31 === 1) {
							return _Utils_Tuple2(model.Uk, $elm$core$Platform$Cmd$none);
						} else {
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								A3($author$project$Components$Invoice$retrieveInvoice, apiClient, model.aa4, model.Uv));
						}
					}();
					var invoice = _v30.a;
					var cmd = _v30.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Uk: invoice,
								eB: $elm$core$Maybe$Just(invoiceLinesTableResult.aiO)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									cmd,
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTableMsg, invoiceLinesTableResult.GZ)
								])),
						invoiceLinesTableResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 29:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{p4: !model.p4}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 31:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{p6: !model.p6}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 30:
				var dateInput = msg.a;
				var subMsg = msg.b;
				return A7(
					$author$project$Components$Invoice$updateDateInputFormField,
					apiClient,
					model,
					dateInput,
					subMsg,
					$author$project$Components$Invoice$InvoiceDateInputMsg,
					$author$project$Components$Invoice$InvoiceDate,
					function ($) {
						return $.Uq;
					});
			case 32:
				var dateInput = msg.a;
				var subMsg = msg.b;
				return A7(
					$author$project$Components$Invoice$updateDateInputFormField,
					apiClient,
					model,
					dateInput,
					subMsg,
					$author$project$Components$Invoice$InvoiceDueDateInputMsg,
					$author$project$Components$Invoice$InvoiceDueDate,
					function ($) {
						return $.j_;
					});
			case 33:
				return _Utils_Tuple3(
					model,
					A3($author$project$Components$Invoice$retrieveInvoiceStatus, apiClient, model.aa4, model.Uv),
					_List_Nil);
			case 34:
				var subMsg = msg.a;
				var downloadInvoiceResult = A3($author$project$Components$Invoice$DownloadFile$update, apiClient, subMsg, model.jt);
				var showModal = function () {
					var _v32 = downloadInvoiceResult.agZ;
					switch (_v32) {
						case 2:
							return true;
						case 3:
							return false;
						default:
							return model.p5;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{jt: downloadInvoiceResult.aiO, p5: showModal}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$DownloadInvoiceMsg, downloadInvoiceResult.GZ),
					downloadInvoiceResult.aR);
			case 35:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{p5: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 36:
				var subMsg = msg.a;
				var _v33 = model.iw;
				if (!_v33.$) {
					var auditTrailLog = _v33.a;
					var auditTrailLogResult = A3($author$project$Components$AuditTrailLog$update, apiClient, subMsg, auditTrailLog);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								iw: $elm$core$Maybe$Just(auditTrailLogResult.aiO)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$AuditTrailLogMsg, auditTrailLogResult.GZ),
						auditTrailLogResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 37:
				var subMsg = msg.a;
				var _v34 = function () {
					var _v35 = model.vo;
					if (!_v35.$) {
						var virtualBankAccountsComponent_ = _v35.a;
						var _v36 = A3($author$project$Components$Company$VirtualBankAccounts$Invoice$update, apiClient, subMsg, virtualBankAccountsComponent_);
						var virtualModel_ = _v36.a;
						var virtualCmd_ = _v36.b;
						var virtualOutMsgs_ = _v36.c;
						return _Utils_Tuple3(
							$elm$core$Maybe$Just(virtualModel_),
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$VirtualBankAccountsComponentMsg, virtualCmd_),
							virtualOutMsgs_);
					} else {
						return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				}();
				var model_ = _v34.a;
				var cmd_ = _v34.b;
				var outMsgs_ = _v34.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{vo: model_}),
					cmd_,
					outMsgs_);
			default:
				var integrationRecords = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Ub: integrationRecords}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(integrationRecords));
		}
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var session = msg.a;
			var practice = msg.b;
			var shared = msg.c;
			var affiliateBillId = msg.d;
			var response = msg.e;
			if (response.$ === 3) {
				var affiliate = response.a;
				var _v2 = $author$project$Components$Invoice$init(
					{
						Gv: model.Gv,
						mn: true,
						afQ: A2(
							$elm$core$Maybe$map,
							$author$project$Components$Invoice$ProviderMin,
							$author$project$Api$Provider$Affiliate$One$company(affiliate)),
						Uv: A2(
							$author$project$Components$Invoice$Affiliate,
							$author$project$Api$Provider$Affiliate$One$id(affiliate),
							affiliateBillId),
						Is: $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Top(
							{
								rd: $author$project$Api$Provider$Affiliate$One$id(affiliate)
							}),
						tN: $elm$core$Maybe$Nothing,
						ZV: $author$project$Api$Practice$Provider(practice),
						aa4: session,
						lk: shared
					});
				var invoiceComponent = _v2.a;
				var invoiceComponentCmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							gA: $elm$core$Maybe$Just(invoiceComponent)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$InvoiceComponentMsg, invoiceComponentCmd),
					_List_Nil);
			} else {
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{gA: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			}
		} else {
			var subMsg = msg.a;
			var _v3 = model.gA;
			if (!_v3.$) {
				var invoiceComponent = _v3.a;
				var _v4 = A3($author$project$Components$Invoice$update, model.Gv, subMsg, invoiceComponent);
				var invoiceComponent_ = _v4.a;
				var cmd = _v4.b;
				var outMsgs = _v4.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							gA: $elm$core$Maybe$Just(invoiceComponent_)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$InvoiceComponentMsg, cmd),
					outMsgs);
			} else {
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
			}
		}
	});
var $author$project$Components$Invoice$Delete = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Invoice$Email = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Invoice$MakeViewableAndEmail = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Invoice$MarkAsBadDebt = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Invoice$Pay = function (a) {
	return {$: 22, a: a};
};
var $author$project$Components$Invoice$RecordPayment = function (a) {
	return {$: 23, a: a};
};
var $author$project$Components$Invoice$ReturnToDraft = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Invoice$ReverseBadDebt = {$: 15};
var $author$project$Components$Invoice$Void = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Employer$Invoice$Shared$amountInCents = function (_v0) {
	var record = _v0;
	return record.LE;
};
var $author$project$Api$Employer$Invoice$One$amountInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Invoice$Shared$amountInCents(shared);
};
var $author$project$Api$Provider$Invoice$One$amountInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Invoice$Shared$amountInCents(shared);
};
var $author$project$Api$Invoice$One$amountInCents = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$One$amountInCents(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$One$amountInCents(invoice_);
	}
};
var $author$project$Api$Employer$Invoice$One$autoPayDate = function (_v0) {
	var record = _v0.b;
	return record.Mi;
};
var $author$project$Api$Provider$Invoice$One$autoPayDate = function (_v0) {
	var record = _v0.b;
	return record.Mi;
};
var $author$project$Api$Invoice$One$autoPayDate = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$One$autoPayDate(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$One$autoPayDate(invoice_);
	}
};
var $author$project$Api$Employer$Invoice$Meta$canCancelAction = function (_v0) {
	var meta = _v0;
	return meta.vy.M4;
};
var $author$project$Api$Provider$Invoice$Meta$canCancelAction = function (_v0) {
	var meta = _v0;
	return meta.vy.M4;
};
var $author$project$Api$Invoice$Meta$canCancelAction = function (meta) {
	if (!meta.$) {
		var meta_ = meta.a;
		return $author$project$Api$Provider$Invoice$Meta$canCancelAction(meta_);
	} else {
		var meta_ = meta.a;
		return $author$project$Api$Employer$Invoice$Meta$canCancelAction(meta_);
	}
};
var $author$project$Api$Provider$Invoice$Meta$canDelete = function (_v0) {
	var meta = _v0;
	return meta.vy.M5;
};
var $author$project$Api$Invoice$Meta$canDelete = function (meta) {
	if (!meta.$) {
		var meta_ = meta.a;
		return $author$project$Api$Provider$Invoice$Meta$canDelete(meta_);
	} else {
		return false;
	}
};
var $author$project$Api$Provider$Invoice$Meta$canDraftAndDestroyCurrentDraftAction = function (_v0) {
	var meta = _v0;
	return meta.vy.M7;
};
var $author$project$Api$Invoice$Meta$canDraftAndDestroyCurrentDraftAction = function (meta) {
	if (!meta.$) {
		var meta_ = meta.a;
		return $author$project$Api$Provider$Invoice$Meta$canDraftAndDestroyCurrentDraftAction(meta_);
	} else {
		return false;
	}
};
var $author$project$Api$Provider$Invoice$Meta$canMakeViewableAction = function (_v0) {
	var meta = _v0;
	return meta.vy.Nd;
};
var $author$project$Api$Invoice$Meta$canMakeViewableAction = function (meta) {
	if (!meta.$) {
		var meta_ = meta.a;
		return $author$project$Api$Provider$Invoice$Meta$canMakeViewableAction(meta_);
	} else {
		return false;
	}
};
var $author$project$Api$Provider$Invoice$Meta$canMarkAsBadDebtAction = function (_v0) {
	var meta = _v0;
	return meta.vy.Ne;
};
var $author$project$Api$Invoice$Meta$canMarkAsBadDebtAction = function (meta) {
	if (!meta.$) {
		var meta_ = meta.a;
		return $author$project$Api$Provider$Invoice$Meta$canMarkAsBadDebtAction(meta_);
	} else {
		return false;
	}
};
var $author$project$Api$Provider$Invoice$Meta$canNotifyAction = function (_v0) {
	var meta = _v0;
	return meta.vy.Nf;
};
var $author$project$Api$Invoice$Meta$canNotifyAction = function (meta) {
	if (!meta.$) {
		var meta_ = meta.a;
		return $author$project$Api$Provider$Invoice$Meta$canNotifyAction(meta_);
	} else {
		return false;
	}
};
var $author$project$Api$Provider$Invoice$Meta$canReverseBadDebtAction = function (_v0) {
	var meta = _v0;
	return meta.vy.Nh;
};
var $author$project$Api$Invoice$Meta$canReverseBadDebtAction = function (meta) {
	if (!meta.$) {
		var meta_ = meta.a;
		return $author$project$Api$Provider$Invoice$Meta$canReverseBadDebtAction(meta_);
	} else {
		return false;
	}
};
var $author$project$Components$Invoice$companyAddress = function (company) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Maybe$Nothing,
		A2(
			$elm$core$Maybe$andThen,
			function (company_) {
				if (!company_.$) {
					return $elm$core$Maybe$Nothing;
				} else {
					var company__ = company_.a;
					return $elm$core$Maybe$Just(
						$author$project$Api$Company$address(company__));
				}
			},
			company));
};
var $author$project$Api$Employer$Company$One$defaultSource = function (_v0) {
	var record = _v0.b;
	return record.Qc;
};
var $author$project$Api$Provider$Company$One$defaultSource = function (_v0) {
	var record = _v0.b;
	return record.Qc;
};
var $author$project$Api$Company$defaultSource = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$defaultSource(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$defaultSource(company_);
	}
};
var $author$project$Components$Invoice$companyDefaultSource = function (company) {
	return A2(
		$elm$core$Maybe$andThen,
		function (company_) {
			if (!company_.$) {
				return $elm$core$Maybe$Nothing;
			} else {
				var company__ = company_.a;
				return $author$project$Api$Company$defaultSource(company__);
			}
		},
		company);
};
var $author$project$Api$Provider$Company$Min$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Components$Invoice$companyName = function (company) {
	return A2(
		$elm$core$Maybe$map,
		function (company_) {
			if (!company_.$) {
				var company__ = company_.a;
				return $author$project$Api$Provider$Company$Min$name(company__);
			} else {
				var company__ = company_.a;
				return $author$project$Api$Company$name(company__);
			}
		},
		company);
};
var $author$project$Api$Employer$Company$One$phones = function (_v0) {
	var record = _v0.b;
	return record.Zy;
};
var $author$project$Api$Provider$Company$One$phones = function (_v0) {
	var record = _v0.b;
	return record.Zy;
};
var $author$project$Api$Company$phones = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$phones(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$phones(company_);
	}
};
var $author$project$Components$Invoice$companyPhones = function (company) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (company_) {
				if (!company_.$) {
					return _List_Nil;
				} else {
					var company__ = company_.a;
					return $author$project$Api$Company$phones(company__);
				}
			},
			company));
};
var $author$project$Api$Employer$Invoice$Meta$createPaymentAction = function (_v0) {
	var meta = _v0;
	return meta.vy.O_;
};
var $author$project$Api$Provider$Invoice$Meta$createPaymentAction = function (_v0) {
	var meta = _v0;
	return meta.vy.O_;
};
var $author$project$Api$Invoice$Meta$createPaymentAction = function (meta) {
	if (!meta.$) {
		var meta_ = meta.a;
		return $author$project$Api$Provider$Invoice$Meta$createPaymentAction(meta_);
	} else {
		var meta_ = meta.a;
		return $author$project$Api$Employer$Invoice$Meta$createPaymentAction(meta_);
	}
};
var $author$project$Api$Employer$Invoice$Shared$humanStatus = function (_v0) {
	var record = _v0;
	return record.TH;
};
var $author$project$Api$Employer$Invoice$One$humanStatus = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Invoice$Shared$humanStatus(shared);
};
var $author$project$Api$Provider$Invoice$One$humanStatus = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Invoice$Shared$humanStatus(shared);
};
var $author$project$Api$Invoice$One$humanStatus = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$One$humanStatus(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$One$humanStatus(invoice_);
	}
};
var $author$project$Api$Employer$Invoice$Shared$invoiceNumber = function (_v0) {
	var record = _v0;
	return record.Uu;
};
var $author$project$Api$Employer$Invoice$One$invoiceNumber = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Invoice$Shared$invoiceNumber(shared);
};
var $author$project$Api$Provider$Invoice$One$number = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Invoice$Shared$invoiceNumber(shared);
};
var $author$project$Api$Invoice$One$invoiceNumber = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$One$number(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$One$invoiceNumber(invoice_);
	}
};
var $author$project$Components$Invoice$isAPractice = function (session) {
	return !$author$project$Api$Platform$Session$One$organizationIsCompany(session);
};
var $author$project$Components$Invoice$isNetwork = function (company) {
	if (!company.$) {
		if (!company.a.$) {
			var company_ = company.a.a;
			return !$author$project$Api$Provider$Company$Min$companyType(company_);
		} else {
			var company_ = company.a.a;
			return !$author$project$Api$Company$companyType(company_);
		}
	} else {
		return false;
	}
};
var $author$project$Api$Employer$Invoice$One$isPayable = function (_v0) {
	var record = _v0.b;
	return record.U2;
};
var $author$project$Api$Provider$Invoice$One$isPayable = function (_v0) {
	var record = _v0.b;
	return record.U2;
};
var $author$project$Api$Invoice$One$isPayable = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$One$isPayable(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$One$isPayable(invoice_);
	}
};
var $author$project$Api$Employer$Invoice$Meta$issueAction = function (_v0) {
	var meta = _v0;
	return meta.vy.Vm;
};
var $author$project$Api$Provider$Invoice$Meta$issueAction = function (_v0) {
	var meta = _v0;
	return meta.vy.Vm;
};
var $author$project$Api$Invoice$Meta$issueAction = function (meta) {
	if (!meta.$) {
		var meta_ = meta.a;
		return $author$project$Api$Provider$Invoice$Meta$issueAction(meta_);
	} else {
		var meta_ = meta.a;
		return $author$project$Api$Employer$Invoice$Meta$issueAction(meta_);
	}
};
var $author$project$Api$Employer$Invoice$Meta$markAsPaidAction = function (_v0) {
	var meta = _v0;
	return meta.vy.Wv;
};
var $author$project$Api$Provider$Invoice$Meta$markAsPaidAction = function (_v0) {
	var meta = _v0;
	return meta.vy.Wv;
};
var $author$project$Api$Invoice$Meta$markAsPaidAction = function (meta) {
	if (!meta.$) {
		var meta_ = meta.a;
		return $author$project$Api$Provider$Invoice$Meta$markAsPaidAction(meta_);
	} else {
		var meta_ = meta.a;
		return $author$project$Api$Employer$Invoice$Meta$markAsPaidAction(meta_);
	}
};
var $author$project$Components$Invoice$maxInvoiceLinesForDetailsDownload = 750;
var $author$project$Api$Invoice$Meta$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Invoice$Meta$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$Invoice$One$meta = function (_v0) {
	var record = _v0.b;
	return record.W4;
};
var $author$project$Api$Provider$Invoice$One$meta = function (_v0) {
	var record = _v0.b;
	return record.W4;
};
var $author$project$Api$Invoice$One$meta = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Invoice$Meta$Provider(
			$author$project$Api$Provider$Invoice$One$meta(invoice_));
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Invoice$Meta$Employer(
			$author$project$Api$Employer$Invoice$One$meta(invoice_));
	}
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Save = {$: 4};
var $author$project$Ui$Modal$Collapsible = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Ui$Modal$collapsible = F2(
	function (sectionTitle, contents) {
		return A2($author$project$Ui$Modal$Collapsible, sectionTitle, contents);
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$DiscountOverridden = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$EndDateValidation = 3;
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$FormUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Quantity = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$QuantityUom = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$QuantityValidation = 1;
var $author$project$Api$Charge$PayerType$Sponsor = 1;
var $author$project$Api$Provider$Charge$Calculate$coveredCharges = function (_v0) {
	var record = _v0;
	return record.OX;
};
var $author$project$Api$Provider$Charge$Calculate$prepaidAllocatedQuantity = function (_v0) {
	var record = _v0;
	return record._a;
};
var $author$project$Api$Provider$InvoiceLine$One$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Api$Provider$Charge$Calculate$subtotalInCents = function (_v0) {
	var record = _v0;
	return record.acD;
};
var $author$project$Ui$Element$textLeft = $author$project$Ui$Element$Alignment($author$project$Ui$Alignment$textLeft);
var $author$project$Api$Employer$Practice$One$trackPatientsByLocation = function (_v0) {
	var record = _v0;
	return record.adt;
};
var $author$project$Api$Practice$trackPatientsByLocation = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice_);
	} else {
		var practice_ = practice.a;
		return $author$project$Api$Employer$Practice$One$trackPatientsByLocation(practice_);
	}
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$uomOptions = A2(
	$elm$core$List$map,
	function (uom_) {
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(
				$author$project$Api$Provider$Uom$Shared$code(uom_)),
			$author$project$Api$Provider$Uom$Shared$name(uom_));
	},
	$author$project$Api$Provider$Uom$list(
		function (d) {
			return _Utils_update(
				d,
				{
					Kg: $elm$core$Maybe$Just('time')
				});
		}));
var $author$project$Components$InventoryWarning$LowStock = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$InventoryWarning$NotTracking = {$: 3};
var $author$project$Components$InventoryWarning$OutOfStock = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$InventoryWarning$Tracking = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$InventoryWarning$calculateStatus = F2(
	function (chargeItem, quantity) {
		var _v0 = _Utils_Tuple2(chargeItem, quantity);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var chargeItem_ = _v0.a.a;
			var quantity_ = _v0.b.a;
			var _v1 = function () {
				var _v2 = chargeItem_.Lm;
				if (!_v2.$) {
					var alertQuantity_ = _v2.a;
					return _Utils_Tuple2(true, alertQuantity_);
				} else {
					return _Utils_Tuple2(false, 0);
				}
			}();
			var hasAlertQuantity = _v1.a;
			var alertQuantity = _v1.b;
			if (!chargeItem_.ads) {
				return $author$project$Components$InventoryWarning$NotTracking;
			} else {
				var existing = A2($elm$core$Maybe$withDefault, 0, chargeItem_._P);
				var remaining = existing - quantity_;
				return (remaining < 0) ? $author$project$Components$InventoryWarning$OutOfStock(existing) : ((!remaining) ? $author$project$Components$InventoryWarning$LowStock(remaining) : ((hasAlertQuantity && (_Utils_cmp(remaining, alertQuantity) < 1)) ? $author$project$Components$InventoryWarning$LowStock(remaining) : $author$project$Components$InventoryWarning$Tracking(remaining)));
			}
		} else {
			return $author$project$Components$InventoryWarning$NotTracking;
		}
	});
var $author$project$Components$InventoryWarning$viewLowStock = function (remaining) {
	return A2(
		$author$project$Ui$Typography$p,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Badge$view,
				_List_fromArray(
					[$author$project$Ui$Badge$warning]),
				_List_fromArray(
					[
						$elm$html$Html$text('Low Inventory')
					])),
				$author$project$Utils$Html$noBreakSpace,
				(!remaining) ? $author$project$Utils$Html$empty : A2(
				$author$project$Ui$Typography$text,
				_List_fromArray(
					[$author$project$Ui$Typography$muted]),
				'Only '),
				A2(
				$author$project$Ui$Typography$text,
				_List_fromArray(
					[$author$project$Ui$Typography$muted]),
				A2($author$project$Formatters$String$pluralize, 'item', remaining)),
				A2(
				$author$project$Ui$Typography$text,
				_List_fromArray(
					[$author$project$Ui$Typography$muted]),
				' will be left in stock'),
				A2($elm$html$Html$br, _List_Nil, _List_Nil),
				A3(
				$author$project$Ui$Link$route,
				$author$project$Spa$Generated$Route$Admin__ChargeItems__Top,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Manage stock levels')
					]))
			]));
};
var $author$project$Components$InventoryWarning$viewOutOfStock = function (existing) {
	return A2(
		$author$project$Ui$Typography$p,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Badge$view,
				_List_fromArray(
					[$author$project$Ui$Badge$danger]),
				_List_fromArray(
					[
						$elm$html$Html$text('Out of Stock')
					])),
				$author$project$Utils$Html$noBreakSpace,
				A2(
				$author$project$Ui$Typography$text,
				_List_fromArray(
					[$author$project$Ui$Typography$muted]),
				'Not enough stock ('),
				A2(
				$author$project$Ui$Typography$text,
				_List_fromArray(
					[$author$project$Ui$Typography$muted]),
				A2($author$project$Formatters$String$pluralize, 'item', existing)),
				A2(
				$author$project$Ui$Typography$text,
				_List_fromArray(
					[$author$project$Ui$Typography$muted]),
				' in stock)'),
				A2($elm$html$Html$br, _List_Nil, _List_Nil),
				A3(
				$author$project$Ui$Link$route,
				$author$project$Spa$Generated$Route$Admin__ChargeItems__Top,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Manage stock levels')
					]))
			]));
};
var $author$project$Components$InventoryWarning$viewTracking = function (remaining) {
	return A2(
		$author$project$Ui$Typography$p,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Utils$Html$noBreakSpace,
				A2(
				$author$project$Ui$Typography$text,
				_List_fromArray(
					[$author$project$Ui$Typography$muted]),
				A2($author$project$Formatters$String$pluralize, 'item', remaining)),
				A2(
				$author$project$Ui$Typography$text,
				_List_fromArray(
					[$author$project$Ui$Typography$muted]),
				' will be left in stock')
			]));
};
var $author$project$Components$InventoryWarning$view = F2(
	function (chargeItem, quantity) {
		var status = A2($author$project$Components$InventoryWarning$calculateStatus, chargeItem, quantity);
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					function () {
					switch (status.$) {
						case 2:
							var existing = status.a;
							return $author$project$Components$InventoryWarning$viewOutOfStock(existing);
						case 1:
							var remaining = status.a;
							return $author$project$Components$InventoryWarning$viewLowStock(remaining);
						case 0:
							var remaining = status.a;
							return $author$project$Components$InventoryWarning$viewTracking(remaining);
						default:
							return $author$project$Utils$Html$empty;
					}
				}()
				]));
	});
var $author$project$Components$CoverageRuleDescription$Shared = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$CoveredCharge$All$coverageRule = function (_v0) {
	var shared = _v0;
	return shared.OU;
};
var $author$project$Components$Invoice$ChargeDiscount$viewCoveredCharge = function (coveredCharge) {
	var coverageRule = $author$project$Api$Provider$CoveredCharge$All$coverageRule(coveredCharge);
	return A2(
		$author$project$Components$CoverageRuleDescription$view,
		$author$project$Components$CoverageRuleDescription$Shared(coverageRule),
		false);
};
var $author$project$Components$Invoice$ChargeDiscount$view = function (charge) {
	var discountInCents = $author$project$Api$Provider$Charge$Calculate$discountInCents(charge);
	if (!(!discountInCents)) {
		var issuedSubtotalInCents = $author$project$Api$Provider$Charge$Calculate$issuedSubtotalInCents(charge);
		var coveredCharges = $author$project$Api$Provider$Charge$Calculate$coveredCharges(charge);
		return A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					(!$elm$core$List$isEmpty(coveredCharges)) ? A3(
					$author$project$Ui$Popover$view,
					_List_fromArray(
						[$author$project$Ui$Popover$lg]),
					_List_fromArray(
						[
							$author$project$Ui$Icon$help(_List_Nil)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Popover$body,
							_List_Nil,
							A2($elm$core$List$map, $author$project$Components$Invoice$ChargeDiscount$viewCoveredCharge, coveredCharges))
						])) : $author$project$Utils$Html$empty,
					A2(
					$author$project$Ui$Typography$text,
					_List_fromArray(
						[$author$project$Ui$Typography$strike, $author$project$Ui$Typography$muted]),
					$author$project$Utils$Currency$fromInt(issuedSubtotalInCents + discountInCents)),
					$author$project$Utils$Html$noBreakSpace
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewCategoryFormGroup = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var categoryResourceFilter = _v0.c8;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Category'),
				$author$project$Ui$Form$Group$required(true),
				$author$project$Ui$Form$Group$labelSpan(3),
				$author$project$Ui$Form$Group$inputSpan(9)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CategoryResourceFilterMsg,
				A2(
					$author$project$Components$ResourceFilter$Category$view,
					_List_fromArray(
						[
							$author$project$Components$ResourceFilter$style(0)
						]),
					categoryResourceFilter))
			]));
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewChargeFormGroup = F2(
	function (model, form) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Charge Name'),
					$author$project$Ui$Form$Group$required(true),
					$author$project$Ui$Form$Group$labelSpan(3),
					$author$project$Ui$Form$Group$inputSpan(9)
				]),
			function () {
				var _v0 = model.Uv;
				if (!_v0.$) {
					var _v1 = $author$project$Utils$Form$fields(form);
					var name = _v1.Bq;
					return _List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(
									A2($elm$core$Maybe$withDefault, '', name)),
									$author$project$Ui$Form$Input$placeholder('e.g. Office Visit'),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$FormUpdated, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Name)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 0, form))
								]))
						]);
				} else {
					var _v2 = $author$project$Utils$Form$fields(form);
					var chargeItemResourceFilter = _v2.cq;
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ChargeItemResourceFilterMsg,
							A2(
								$author$project$Components$ResourceFilter$ChargeItem$view,
								_List_fromArray(
									[
										$author$project$Components$ResourceFilter$style(0),
										$author$project$Components$ResourceFilter$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
										$author$project$Components$ResourceFilter$errors(
										A2($author$project$Utils$Form$validationErrors, 0, form))
									]),
								chargeItemResourceFilter))
						]);
				}
			}());
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Description = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewDescriptionFormGroup = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var description = _v0.Qr;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Description'),
				$author$project$Ui$Form$Group$labelSpan(3),
				$author$project$Ui$Form$Group$inputSpan(9)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Textarea$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Textarea$value(description),
						$author$project$Ui$Form$Textarea$placeholder('e.g. Examination'),
						$author$project$Ui$Form$Textarea$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$FormUpdated, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Description))
					]))
			]));
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewLocationFormGroup = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var locationResourceFilter = _v0.os;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Location'),
				$author$project$Ui$Form$Group$labelSpan(3),
				$author$project$Ui$Form$Group$inputSpan(9)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$LocationResourceFilterMsg,
				A2(
					$author$project$Components$ResourceFilter$Location$view,
					_List_fromArray(
						[
							$author$project$Components$ResourceFilter$style(0)
						]),
					locationResourceFilter))
			]));
};
var $author$project$Api$Provider$Membership$ForCompanyAccountOne$membershipPatients = function (_v0) {
	var record = _v0;
	return record.WR;
};
var $author$project$Api$Provider$CompanyAccount$One$memberships = function (_v0) {
	var record = _v0.b;
	return record.WZ;
};
var $author$project$Components$ResourceFilter$CompanyRegistration$view = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$view,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.Jy),
					options),
				model.b8));
	});
var $author$project$Api$Provider$MembershipPatient$Min$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$MembershipPatient$Min$periodRateInCents = function (_v0) {
	var record = _v0;
	return record.Zt;
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewMembershipPatient = function (membershipPatient) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$phi]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Api$Provider$MembershipPatient$Min$name(membershipPatient)),
				$elm$html$Html$text(' - '),
				$elm$html$Html$text(
				$author$project$Utils$Currency$fromInt(
					A2(
						$elm$core$Maybe$withDefault,
						0,
						$author$project$Api$Provider$MembershipPatient$Min$periodRateInCents(membershipPatient))))
			]));
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewPatientFormGroup = F2(
	function (model, form) {
		var _v0 = $author$project$Utils$Form$fields(form);
		var patient = _v0.YY;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Patient'),
					$author$project$Ui$Form$Group$labelSpan(3),
					$author$project$Ui$Form$Group$inputSpan(9)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CompanyRegistrationResourceFilterMsg,
					A2(
						$author$project$Components$ResourceFilter$CompanyRegistration$view,
						_List_fromArray(
							[
								$author$project$Components$ResourceFilter$style(0)
							]),
						model.f_)),
					function () {
					if (!patient.$) {
						var patient_ = patient.a;
						return A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$titleSm,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Most Recent Membership Prices')
										])),
									function () {
									var _v2 = model.Ob;
									if (_v2.$ === 3) {
										var companyAccount = _v2.a;
										var membershipPatients = A2(
											$elm$core$Maybe$withDefault,
											_List_Nil,
											A2(
												$elm$core$Maybe$map,
												$author$project$Api$Provider$Membership$ForCompanyAccountOne$membershipPatients,
												$elm_community$list_extra$List$Extra$last(
													$author$project$Api$Provider$CompanyAccount$One$memberships(companyAccount))));
										return $elm$core$List$isEmpty(membershipPatients) ? $elm$html$Html$text('No recent memberships found for ' + patient_.Bq) : A2(
											$author$project$Ui$Element$view,
											_List_Nil,
											A2($elm$core$List$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewMembershipPatient, membershipPatients));
									} else {
										return $author$project$Ui$Spinner$view(
											_List_fromArray(
												[$author$project$Ui$Spinner$small]));
									}
								}()
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]));
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewProviderFormGroup = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var practitionerResourceFilter = _v0.hk;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Provider'),
				$author$project$Ui$Form$Group$labelSpan(3),
				$author$project$Ui$Form$Group$inputSpan(9)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$PractitionerResourceFilterMsg,
				A2(
					$author$project$Components$ResourceFilter$Practitioner$view,
					_List_fromArray(
						[
							$author$project$Components$ResourceFilter$style(0)
						]),
					practitionerResourceFilter))
			]));
};
var $author$project$Components$ChargeRoutingWarning$Calculate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Charge$PayerType$Patient = 0;
var $author$project$Api$Provider$Charge$Calculate$adjudicatedPayer = function (_v0) {
	var record = _v0;
	return record.K9;
};
var $author$project$Api$Provider$Charge$AdjudicatedPayer$One$payerType = function (_v0) {
	var record = _v0;
	return record.Y6;
};
var $author$project$Api$Charge$PayerType$adjudicatedType = function (preview) {
	return A2(
		$elm$core$Maybe$map,
		$author$project$Api$Provider$Charge$AdjudicatedPayer$One$payerType,
		$author$project$Api$Provider$Charge$Calculate$adjudicatedPayer(preview));
};
var $author$project$Api$Charge$PayerType$toPayerType = function (maybeString) {
	if ((!maybeString.$) && (maybeString.a === 'company')) {
		return 1;
	} else {
		return 0;
	}
};
var $author$project$Api$Charge$PayerType$adjudicatedToSelectedPayer = F2(
	function (preview, selectedPayer) {
		return _Utils_eq(
			$author$project$Api$Charge$PayerType$toPayerType(
				$author$project$Api$Charge$PayerType$adjudicatedType(preview)),
			selectedPayer);
	});
var $author$project$Api$Provider$Charge$One$rulePayer = function (_v0) {
	var record = _v0.b;
	return record.aaj;
};
var $author$project$Api$Charge$PayerType$toString = function (payerType) {
	if (!payerType) {
		return 'Patient';
	} else {
		return 'Sponsor';
	}
};
var $author$project$Api$Charge$RulePayer$toString = function (gender) {
	if (!gender) {
		return 'sponsor';
	} else {
		return 'patient';
	}
};
var $author$project$Components$ChargeRoutingWarning$view = F2(
	function (selectedPayer, charge) {
		var coveredCharges = function () {
			if (!charge.$) {
				var charge_ = charge.a;
				return $author$project$Api$Provider$Charge$Calculate$coveredCharges(charge_);
			} else {
				return _List_Nil;
			}
		}();
		var showWarning = function () {
			var _v1 = _Utils_Tuple2(coveredCharges, charge);
			if (!_v1.b.$) {
				var coveredCharges_ = _v1.a;
				var charge_ = _v1.b.a;
				return (!A2($author$project$Api$Charge$PayerType$adjudicatedToSelectedPayer, charge_, selectedPayer)) && ($elm$core$List$length(coveredCharges_) > 0);
			} else {
				if (!_v1.a.b) {
					var charge_ = _v1.b.a;
					var _v2 = $author$project$Api$Provider$Charge$One$rulePayer(charge_);
					if (!_v2.$) {
						var rulePayer = _v2.a;
						return !_Utils_eq(
							$author$project$Api$Charge$RulePayer$toString(rulePayer),
							$elm$core$String$toLower(
								$author$project$Api$Charge$PayerType$toString(selectedPayer)));
					} else {
						return false;
					}
				} else {
					return false;
				}
			}
		}();
		if (showWarning) {
			var inverse = function () {
				if (!selectedPayer) {
					return 1;
				} else {
					return 0;
				}
			}();
			return $elm$core$Maybe$Just(
				A2(
					$author$project$Ui$Alert$warning,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('This charge is being added to the '),
							$elm$html$Html$text(
							$elm$core$String$toLower(
								$author$project$Api$Charge$PayerType$toString(selectedPayer))),
							$elm$html$Html$text('\'s invoice, but the membership rule specifies it should be paid for by the '),
							$elm$html$Html$text(
							$elm$core$String$toLower(
								$author$project$Api$Charge$PayerType$toString(inverse))),
							$elm$html$Html$text('.')
						])));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$ChargeRoutingWarning$viewWithChargeCalculate = F2(
	function (selectedPayer, charge) {
		return A2(
			$author$project$Components$ChargeRoutingWarning$view,
			selectedPayer,
			$author$project$Components$ChargeRoutingWarning$Calculate(charge));
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewFormGroups = F2(
	function (model, form) {
		var fields = $author$project$Utils$Form$fields(form);
		var isTimeBased = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$eq('time'),
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.adP;
						},
						$author$project$Api$Provider$Uom$Shared$unitClass),
					fields.mL)));
		var editingNotInDraft = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$neq('draft'),
				A2(
					$elm$core$Maybe$map,
					$author$project$Api$Provider$InvoiceLine$One$status,
					$author$project$Api$Data$toMaybe(model.sN))));
		var discountNotRemoved = function () {
			var _v11 = $author$project$Api$Data$toMaybe(model.akd);
			if (!_v11.$) {
				var preview = _v11.a;
				return (!fields.QE) && (!(!$author$project$Api$Provider$Charge$Calculate$discountInCents(preview)));
			} else {
				return false;
			}
		}();
		return _List_fromArray(
			[
				A2($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewChargeFormGroup, model, form),
				function () {
				var _v0 = model.Uv;
				if (_v0.$ === 1) {
					return $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewCategoryFormGroup(form);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v1 = model.Uv;
				if (_v1.$ === 1) {
					return $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewDescriptionFormGroup(form);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewPatientFormGroup, model, form),
				function () {
				var _v2 = model.Uv;
				if (_v2.$ === 1) {
					return $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewProviderFormGroup(form);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v3 = _Utils_Tuple2(
					model.Uv,
					$author$project$Api$Practice$trackPatientsByLocation(model.ZV));
				if ((_v3.a.$ === 1) && _v3.b) {
					var _v4 = _v3.a;
					return $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewLocationFormGroup(form);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v5 = model.Uv;
				if (_v5.$ === 1) {
					return A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label(
								isTimeBased ? 'Dates' : 'Date'),
								$author$project$Ui$Form$Group$labelSpan(3),
								$author$project$Ui$Form$Group$inputSpan(9),
								$author$project$Ui$Form$Group$required(true)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(6)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$StartDateInputMsg(fields.lx),
												A2(
													$author$project$Components$DateInput$view,
													_List_fromArray(
														[
															$author$project$Components$DateInput$value(fields.ab7),
															$author$project$Components$DateInput$invalid(
															A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
															$author$project$Components$DateInput$errors(
															A2($author$project$Utils$Form$validationErrors, 2, form)),
															$author$project$Components$DateInput$disabled(editingNotInDraft)
														]),
													fields.lx))
											])),
										isTimeBased ? A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(6)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$EndDateInputMsg(fields.sd),
												A2(
													$author$project$Components$DateInput$view,
													_List_fromArray(
														[
															$author$project$Components$DateInput$value(fields.sb),
															$author$project$Components$DateInput$invalid(
															A2($author$project$Utils$Form$hasValidationErrors, 3, form)),
															$author$project$Components$DateInput$errors(
															A2($author$project$Utils$Form$validationErrors, 3, form)),
															$author$project$Components$DateInput$disabled(editingNotInDraft)
														]),
													fields.sd))
											])) : $author$project$Ui$Grid$none
									]))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v6 = model.Uv;
				if (_v6.$ === 1) {
					return A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('QTY'),
								$author$project$Ui$Form$Group$labelSpan(3),
								$author$project$Ui$Form$Group$inputSpan(9),
								$author$project$Ui$Form$Group$required(true)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(6)
											]),
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$view(
												_List_fromArray(
													[
														$author$project$Ui$Form$Input$number,
														$author$project$Ui$Form$Input$value(
														A2(
															$elm$core$Maybe$withDefault,
															'',
															A2($elm$core$Maybe$map, $elm$core$String$fromInt, fields.Dz))),
														$author$project$Ui$Form$Input$onInput(
														A2($elm$core$Basics$composeL, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$FormUpdated, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Quantity)),
														$author$project$Ui$Form$Input$disabled(editingNotInDraft),
														$author$project$Ui$Form$Input$invalid(
														A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
														$author$project$Ui$Form$Input$errors(
														A2($author$project$Utils$Form$validationErrors, 1, form)),
														$author$project$Ui$Form$Input$test('company-charge-quantity')
													]))
											])),
										isTimeBased ? A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(6)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Select$view,
												_List_fromArray(
													[
														$author$project$Ui$Form$Select$value(
														A2($elm$core$Maybe$map, $author$project$Api$Provider$Uom$Shared$code, fields.DA)),
														$author$project$Ui$Form$Select$onChange(
														A2($elm$core$Basics$composeL, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$FormUpdated, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$QuantityUom)),
														$author$project$Ui$Form$Select$disabled(editingNotInDraft)
													]),
												$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$uomOptions)
											])) : $author$project$Ui$Grid$none
									])),
								A2(
								$author$project$Ui$Grid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(12)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Components$InventoryWarning$view,
												A2(
													$elm$core$Maybe$map,
													function (chargeItem) {
														return {Lm: chargeItem.Lm, _P: chargeItem._P, ads: chargeItem.ads};
													},
													fields.mL),
												fields.Dz)
											]))
									]))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Price'),
						$author$project$Ui$Form$Group$labelSpan(3),
						$author$project$Ui$Form$Group$inputSpan(9)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$span(6)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$CurrencyInput$view(
										A2(
											$elm$core$List$cons,
											$author$project$Ui$Form$CurrencyInput$value(fields.Dw),
											A2(
												$elm$core$List$cons,
												$author$project$Ui$Form$CurrencyInput$placeholder('e.g. 50.00'),
												A2(
													$elm$core$List$cons,
													$author$project$Ui$Form$CurrencyInput$onInput(
														A2($elm$core$Basics$composeL, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$FormUpdated, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$PriceInCents)),
													A2(
														$elm$core$List$cons,
														$author$project$Ui$Form$CurrencyInput$invalid(
															A2($author$project$Utils$Form$hasValidationErrors, 4, form)),
														A2(
															$elm$core$List$cons,
															$author$project$Ui$Form$CurrencyInput$disabled(editingNotInDraft || discountNotRemoved),
															function () {
																var _v7 = _Utils_Tuple2(
																	isTimeBased,
																	A2(
																		$elm$core$Maybe$map,
																		$elm$core$String$toLower,
																		A2($elm$core$Maybe$map, $author$project$Api$Provider$Uom$Shared$name, fields._h)));
																if (_v7.a && (!_v7.b.$)) {
																	var name = _v7.b.a;
																	return _List_fromArray(
																		[
																			$author$project$Ui$Form$CurrencyInput$postfix('per ' + name)
																		]);
																} else {
																	return _List_Nil;
																}
															}())))))),
										$author$project$Utils$FormErrors$view(
										A2($author$project$Utils$Form$validationErrors, 4, form)),
										function () {
										if ((!editingNotInDraft) && discountNotRemoved) {
											var hasPrepaidDiscount = function () {
												var _v9 = $author$project$Api$Data$toMaybe(model.akd);
												if (!_v9.$) {
													var preview_ = _v9.a;
													return $author$project$Api$Provider$Charge$Calculate$prepaidAllocatedQuantity(preview_) > 0;
												} else {
													return false;
												}
											}();
											var hasMembershipDiscount = function () {
												var _v8 = $author$project$Api$Data$toMaybe(model.akd);
												if (!_v8.$) {
													var preview_ = _v8.a;
													return !$elm$core$List$isEmpty(
														$author$project$Api$Provider$Charge$Calculate$coveredCharges(preview_));
												} else {
													return false;
												}
											}();
											var removeRuleLabel = (hasPrepaidDiscount && (!hasMembershipDiscount)) ? 'Remove package rule' : 'Remove membership rule';
											return A2(
												$author$project$Ui$Form$Static$view,
												_List_Nil,
												_List_fromArray(
													[
														A3(
														$author$project$Ui$Button$view,
														{mm: removeRuleLabel},
														_List_fromArray(
															[
																$author$project$Ui$Button$onClick(
																$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$FormUpdated(
																	$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$DiscountOverridden(true)))
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(removeRuleLabel)
															]))
													]));
										} else {
											return $author$project$Utils$Html$empty;
										}
									}()
									])),
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$span(6)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$textLeft]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Static$view,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Amounts can be negative')
													]))
											]))
									]))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Total'),
						$author$project$Ui$Form$Group$labelSpan(3),
						$author$project$Ui$Form$Group$inputSpan(9)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								function () {
								var _v10 = model.akd;
								switch (_v10.$) {
									case 3:
										var preview = _v10.a;
										if ((!$author$project$Api$Provider$Charge$Calculate$discountInCents(preview)) && (!fields.QE)) {
											return $elm$html$Html$text(
												$author$project$Utils$Currency$fromInt(
													$author$project$Api$Provider$Charge$Calculate$subtotalInCents(preview)));
										} else {
											var discountRemoved = fields.QE && (!$author$project$Api$Provider$Charge$Calculate$discountInCents(preview));
											return A2(
												$author$project$Ui$Element$view,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Element$view,
														_List_Nil,
														_List_fromArray(
															[
																$author$project$Ui$Typography$headingSm(
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		$author$project$Utils$Currency$fromInt(
																			$author$project$Api$Provider$Charge$Calculate$subtotalInCents(preview)))
																	]))
															])),
														function () {
														if (!(!$author$project$Api$Provider$Charge$Calculate$discountInCents(preview))) {
															var totalWithoutLabel = ($author$project$Api$Provider$Charge$Calculate$prepaidAllocatedQuantity(preview) > 0) ? 'Total without package: ' : 'Total without membership: ';
															return A2(
																$author$project$Ui$Form$Static$view,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text(totalWithoutLabel),
																		$author$project$Components$Invoice$ChargeDiscount$view(preview)
																	]));
														} else {
															return $author$project$Utils$Html$empty;
														}
													}(),
														($author$project$Api$Provider$Charge$Calculate$prepaidAllocatedQuantity(preview) > 0) ? A2(
														$author$project$Ui$Form$Static$view,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('This item is covered by the patient\'s package. No additional charge will be applied.')
															])) : $author$project$Utils$Html$empty,
														discountRemoved ? A2(
														$author$project$Ui$Form$Static$view,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Membership rule was removed')
															])) : $author$project$Utils$Html$empty,
														$author$project$Utils$Html$noBreakSpace,
														((!editingNotInDraft) && (discountRemoved && $author$project$Utils$Maybe$toBool(fields.mL))) ? A3(
														$author$project$Ui$Button$view,
														{mm: 'Revert to original'},
														_List_fromArray(
															[
																$author$project$Ui$Button$link,
																$author$project$Ui$Button$onClick(
																$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$FormUpdated(
																	$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$DiscountOverridden(false)))
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Revert to original')
															])) : $author$project$Utils$Html$empty,
														A2(
														$elm$core$Maybe$withDefault,
														$elm$html$Html$text(''),
														A2($author$project$Components$ChargeRoutingWarning$viewWithChargeCalculate, 1, preview))
													]));
										}
									case 1:
										return $author$project$Ui$Spinner$view(
											_List_fromArray(
												[$author$project$Ui$Spinner$small]));
									default:
										return $elm$html$Html$text('N/A');
								}
							}()
							]))
					]))
			]);
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$view = function (_v0) {
	var model = _v0;
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Typography$headingSm(
						_List_fromArray(
							[
								function () {
								var _v1 = model.sO;
								if (!_v1.$) {
									return $elm$html$Html$text('Update');
								} else {
									return $elm$html$Html$text('Add');
								}
							}(),
								$elm$html$Html$text(' Charge')
							]))
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						function () {
						var _v2 = model.SD;
						if (!_v2.$) {
							var form = _v2.a;
							return A2(
								$author$project$Ui$Form$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$onSubmit($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Save)
									]),
								A2($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewFormGroups, model, form));
						} else {
							return A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$textCenter]),
								_List_fromArray(
									[
										$author$project$Ui$Spinner$view(_List_Nil)
									]));
						}
					}()
					])),
				A2(
				$author$project$Ui$Modal$collapsible,
				'How do I add incidental charges?',
				_List_fromArray(
					[
						$elm$html$Html$text('Search for the charge item from your preconfigured list or manually enter the details of the charge. '),
						$elm$html$Html$text('To add more than one, change the quantity field to auto-calculate the amount for a group of charges like flu shots or COVID tests.')
					])),
				A2(
				$author$project$Ui$Modal$collapsible,
				'How do I add credit?',
				_List_fromArray(
					[
						$elm$html$Html$text('Search for the negative charge item from your preconfigured list or manually enter the details of the credit with a '),
						$elm$html$Html$text('negative (-) minus sign in front of the price (e.g. $-20).')
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$span(6)
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Cancel and close'},
										_List_fromArray(
											[
												$author$project$Ui$Button$fullWidth(true),
												$author$project$Ui$Button$onClick($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Close)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cancel')
											]))
									])),
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$span(6)
									]),
								_List_fromArray(
									[
										function () {
										var verb = function () {
											var _v3 = model.sO;
											if (!_v3.$) {
												return 'Update';
											} else {
												return 'Add';
											}
										}();
										return A3(
											$author$project$Ui$Button$view,
											{mm: verb},
											_List_fromArray(
												[
													$author$project$Ui$Button$fullWidth(true),
													$author$project$Ui$Button$onClick($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Save),
													$author$project$Ui$Button$primary,
													$author$project$Ui$Button$loading(
													_Utils_eq(model.k9, $author$project$Api$Data$Loading))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(verb + ' Charge')
												]));
									}()
									]))
							]))
					]))
			]));
};
var $author$project$Components$Invoice$InvoiceLinesTable$modal = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				function () {
				var _v0 = model.gb;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var invoiceLine = _v1.a;
					var deleteRequest = _v1.b;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Components$Invoice$InvoiceLinesTable$HiConfirmClosed(invoiceLine),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('delete'),
								$author$project$Components$HiConfirm$noun('invoice line'),
								$author$project$Components$HiConfirm$loading(
								_Utils_eq(deleteRequest, $author$project$Api$Data$Loading))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v2 = model.il;
				if (!_v2.$) {
					var adjustmentModal = _v2.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModalMsg,
						$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$view(adjustmentModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]));
};
var $author$project$Api$Common$Invoice$Delta$added = function (_v0) {
	var record = _v0;
	return record.KW;
};
var $author$project$Api$Provider$InvoicePatient$Shared$endDate = function (_v0) {
	var record = _v0;
	return record.sb;
};
var $author$project$Api$Common$Invoice$Delta$removed = function (_v0) {
	var record = _v0;
	return record.$v;
};
var $author$project$Api$Provider$InvoicePatient$Shared$startDate = function (_v0) {
	var record = _v0;
	return record.ab7;
};
var $author$project$Api$Provider$InvoicePatient$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$InvoicePatient$Shared$owner = function (_v0) {
	var record = _v0;
	return record.YD;
};
var $author$project$Components$Invoice$Summary$PatientDeltaModal$viewInvoicePatient = F3(
	function (timeFormatter, timeGetter, invoicePatient) {
		return A2(
			$author$project$Ui$ListGroup$item,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(4)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										A2(
											$elm$core$Maybe$map,
											timeFormatter(5),
											timeGetter(invoicePatient))))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(4)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$InvoicePatient$Shared$name(invoicePatient))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(4)
								]),
							_List_fromArray(
								[
									function () {
									var _v0 = $author$project$Api$Provider$InvoicePatient$Shared$owner(invoicePatient);
									if (!_v0.$) {
										var owner = _v0.a;
										return A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[$author$project$Ui$Typography$gray]),
											'Dependent of ' + $author$project$Api$Provider$Patient$Min$name(owner));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								]))
						]))
				]));
	});
var $author$project$Components$Invoice$Summary$PatientDeltaModal$view = F3(
	function (timeFormatter, close, delta) {
		var patientsRemoved = $author$project$Api$Common$Invoice$Delta$removed(delta);
		var patientsAdded = $author$project$Api$Common$Invoice$Delta$added(delta);
		return A3(
			$author$project$Ui$Modal$view,
			close,
			_List_fromArray(
				[$author$project$Ui$Modal$lg]),
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('Patient List Changes')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(6)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$title,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$elm$core$String$fromInt(
														$elm$core$List$length(patientsAdded))),
													$elm$html$Html$text(' Patients'),
													A2(
													$author$project$Ui$Typography$text,
													_List_fromArray(
														[
															$author$project$Ui$Typography$fontWeight(1)
														]),
													' - added')
												])),
											($elm$core$List$length(patientsAdded) > 0) ? A2(
											$author$project$Ui$ListGroup$view,
											_List_Nil,
											A2(
												$elm$core$List$map,
												A2(
													$author$project$Components$Invoice$Summary$PatientDeltaModal$viewInvoicePatient,
													timeFormatter,
													A2($elm$core$Basics$composeR, $author$project$Api$Provider$InvoicePatient$Shared$startDate, $elm$core$Maybe$Just)),
												patientsAdded)) : $author$project$Utils$Html$empty
										])),
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(6)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$title,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$elm$core$String$fromInt(
														$elm$core$List$length(patientsRemoved))),
													$elm$html$Html$text(' Patients'),
													A2(
													$author$project$Ui$Typography$text,
													_List_fromArray(
														[
															$author$project$Ui$Typography$fontWeight(1)
														]),
													' - removed')
												])),
											($elm$core$List$length(patientsRemoved) > 0) ? A2(
											$author$project$Ui$ListGroup$view,
											_List_Nil,
											A2(
												$elm$core$List$map,
												A2($author$project$Components$Invoice$Summary$PatientDeltaModal$viewInvoicePatient, timeFormatter, $author$project$Api$Provider$InvoicePatient$Shared$endDate),
												patientsRemoved)) : $author$project$Utils$Html$empty
										]))
								]))
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Cancel and close modal'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick(close),
									$author$project$Ui$Button$primary
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Close')
								]))
						]))
				]));
	});
var $author$project$Components$Invoice$Summary$modal = function (_v0) {
	var model = _v0;
	var _v1 = model.oV;
	if (!_v1.$) {
		var patientDelta = _v1.a;
		return A3($author$project$Components$Invoice$Summary$PatientDeltaModal$view, model.J7, $author$project$Components$Invoice$Summary$CloseDeltaModal, patientDelta);
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Api$Employer$Invoice$Shared$paidAt = function (_v0) {
	var record = _v0;
	return record.YH;
};
var $author$project$Api$Employer$Invoice$One$paidAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Invoice$Shared$paidAt(shared);
};
var $author$project$Api$Provider$Invoice$Shared$paidAt = function (_v0) {
	var record = _v0.b;
	return record.YH;
};
var $author$project$Api$Provider$Invoice$One$paidAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Invoice$Shared$paidAt(shared);
};
var $author$project$Api$Invoice$One$paidAt = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$One$paidAt(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$One$paidAt(invoice_);
	}
};
var $author$project$Api$Employer$Invoice$Shared$paidInCents = function (_v0) {
	var record = _v0;
	return record.YI;
};
var $author$project$Api$Employer$Invoice$One$paidInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Invoice$Shared$paidInCents(shared);
};
var $author$project$Api$Provider$Invoice$Shared$paidInCents = function (_v0) {
	var record = _v0.b;
	return record.YI;
};
var $author$project$Api$Provider$Invoice$One$paidInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Invoice$Shared$paidInCents(shared);
};
var $author$project$Api$Invoice$One$paidInCents = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$One$paidInCents(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$One$paidInCents(invoice_);
	}
};
var $author$project$Api$Payment$Provider_SharedWithRefunds = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$Invoice$One$payments = function (_v0) {
	var record = _v0.b;
	return record.Zi;
};
var $author$project$Api$Provider$Invoice$One$payments = function (_v0) {
	var record = _v0.b;
	return record.Zi;
};
var $author$project$Api$Invoice$One$payments = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return A2(
			$elm$core$List$map,
			$author$project$Api$Payment$Provider_SharedWithRefunds,
			$author$project$Api$Provider$Invoice$One$payments(invoice_));
	} else {
		var invoice_ = invoice.a;
		return A2(
			$elm$core$List$map,
			$author$project$Api$Payment$Employer_One,
			$author$project$Api$Employer$Invoice$One$payments(invoice_));
	}
};
var $author$project$Api$Employer$Practice$One$phones = function (_v0) {
	var record = _v0;
	return record.Zy;
};
var $author$project$Api$Practice$phones = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$phones(practice_);
	} else {
		var practice_ = practice.a;
		return $author$project$Api$Employer$Practice$One$phones(practice_);
	}
};
var $author$project$Api$Employer$Invoice$One$securePdfInlineToken = function (_v0) {
	var record = _v0.b;
	return record.aaE;
};
var $author$project$Api$Provider$Invoice$One$securePdfInlineToken = function (_v0) {
	var record = _v0.b;
	return record.aaE;
};
var $author$project$Api$Invoice$One$securePdfInlineToken = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$One$securePdfInlineToken(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$One$securePdfInlineToken(invoice_);
	}
};
var $author$project$Api$Employer$Invoice$One$securePdfWithChargeDetailsToken = function (_v0) {
	var record = _v0.b;
	return record.aaF;
};
var $author$project$Api$Provider$Invoice$One$securePdfWithChargeDetailsToken = function (_v0) {
	var record = _v0.b;
	return record.aaF;
};
var $author$project$Api$Invoice$One$securePdfInlineWithChargeDetailsToken = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$One$securePdfWithChargeDetailsToken(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$One$securePdfWithChargeDetailsToken(invoice_);
	}
};
var $author$project$Ui$Icon$Stop = 61;
var $author$project$Ui$Icon$stop = $author$project$Ui$Icon$viewIcon(61);
var $author$project$Components$AuditTrailLog$Toggle = {$: 0};
var $author$project$Ui$Button$Badge = 11;
var $author$project$Ui$Button$badge = $author$project$Ui$Button$Styled(11);
var $author$project$Ui$Icon$History = 57;
var $author$project$Ui$Icon$history = $author$project$Ui$Icon$viewIcon(57);
var $author$project$Api$Audit$record_ = function (_v0) {
	var record = _v0;
	return record;
};
var $author$project$Api$Audit$createdAt = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Audit$record_,
	function ($) {
		return $.O1;
	});
var $author$project$Api$Audit$extraUrl = function (audit) {
	var record = audit;
	var _v1 = record.xf;
	if (!_v1.$) {
		var aggregate = _v1.a;
		return aggregate.aha;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$String$endsWith = _String_endsWith;
var $author$project$Components$AuditTrailLog$formatWhodunnit = function (email) {
	return A2(
		$elm$core$String$endsWith,
		'@hint.com',
		$elm$core$String$toLower(email)) ? 'System Admin' : email;
};
var $author$project$Components$AuditTrailLog$isLast = F2(
	function (audits, audit) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$eq(audit),
				$elm$core$List$head(
					$elm$core$List$reverse(audits))));
	});
var $author$project$Api$Audit$name = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Audit$record_,
	function ($) {
		return $.Bq;
	});
var $author$project$Api$Audit$isOnlineSignup = function (trail) {
	return A2(
		$elm$core$String$contains,
		'OnlineEnrollment',
		$author$project$Api$Audit$name(trail));
};
var $author$project$Api$Audit$aggregateType = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Audit$record_,
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.xf;
		},
		$elm$core$Maybe$map(
			function ($) {
				return $.amg;
			})));
var $author$project$Api$Audit$crumbs = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Audit$record_,
	function ($) {
		return $.Pa;
	});
var $author$project$Api$Audit$Crumb$label = function (crumb) {
	return crumb.Io.aih;
};
var $author$project$Api$Audit$Crumb$recordType = function (crumb) {
	return crumb.Io.amg;
};
var $author$project$Api$Audit$Crumb$diff = function ($) {
	return $.QB;
};
var $author$project$Components$Auditing$Crumb$Helpers$isChangePresent = function (_v0) {
	var from = _v0.a;
	var to = _v0.b;
	var _v1 = _Utils_Tuple2(from, to);
	if (!_v1.a.$) {
		return true;
	} else {
		if (!_v1.b.$) {
			return true;
		} else {
			return false;
		}
	}
};
var $author$project$Components$Auditing$Crumb$Helpers$getFieldName = function (_v0) {
	var field = _v0.a;
	var diff = _v0.b;
	return $author$project$Components$Auditing$Crumb$Helpers$isChangePresent(diff) ? $author$project$Formatters$String$humanize(field) : '';
};
var $elm$html$Html$s = _VirtualDom_node('s');
var $author$project$Components$Auditing$Crumb$Helpers$viewCrumbDiffValue = function (diffValue) {
	if (!diffValue.$) {
		var text = diffValue.a;
		return $elm$html$Html$text(text);
	} else {
		var linkable = diffValue.a;
		return $elm$html$Html$text(linkable.aih);
	}
};
var $author$project$Components$Auditing$Crumb$Helpers$processDiff = function (_v0) {
	var from = _v0.a;
	var to = _v0.b;
	var _v1 = _Utils_Tuple2(from, to);
	if (!_v1.a.$) {
		if (_v1.b.$ === 1) {
			var fromValue = _v1.a.a;
			var _v2 = _v1.b;
			return A2(
				$author$project$Ui$Element$prose,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(' removed '),
						A2(
						$elm$html$Html$s,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Components$Auditing$Crumb$Helpers$viewCrumbDiffValue(fromValue)
							]))
					]));
		} else {
			var fromValue = _v1.a.a;
			var toValue = _v1.b.a;
			return A2(
				$author$project$Ui$Element$prose,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(' changed from '),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$s,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Components$Auditing$Crumb$Helpers$viewCrumbDiffValue(fromValue)
									])),
								$elm$html$Html$text(' to '),
								$author$project$Components$Auditing$Crumb$Helpers$viewCrumbDiffValue(toValue)
							]))
					]));
		}
	} else {
		if (!_v1.b.$) {
			var _v3 = _v1.a;
			var toValue = _v1.b.a;
			return A2(
				$author$project$Ui$Element$prose,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(' added '),
						$author$project$Components$Auditing$Crumb$Helpers$viewCrumbDiffValue(toValue)
					]));
		} else {
			var _v4 = _v1.a;
			var _v5 = _v1.b;
			return $elm$html$Html$text('');
		}
	}
};
var $author$project$Components$Auditing$Crumb$Helpers$viewChangeWithPrefix = F2(
	function (prefix, _v0) {
		var field = _v0.a;
		var diff = _v0.b;
		var prefixText = $elm$core$String$isEmpty(prefix) ? $elm$html$Html$text('') : $elm$html$Html$text(prefix + '\'s ');
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					prefixText,
					$elm$core$String$isEmpty(prefix) ? $elm$html$Html$text(
					$author$project$Components$Auditing$Crumb$Helpers$getFieldName(
						_Utils_Tuple2(field, diff))) : $elm$html$Html$text(
					$elm$core$String$toLower(
						$author$project$Components$Auditing$Crumb$Helpers$getFieldName(
							_Utils_Tuple2(field, diff)))),
					$author$project$Components$Auditing$Crumb$Helpers$processDiff(diff)
				]));
	});
var $author$project$Components$Auditing$Crumb$Helpers$viewChange = $author$project$Components$Auditing$Crumb$Helpers$viewChangeWithPrefix('');
var $author$project$Components$Auditing$Crumb$Helpers$viewChanges = function (crumb) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		A2(
			$elm$core$List$map,
			$author$project$Components$Auditing$Crumb$Helpers$viewChange,
			$author$project$Api$Audit$Crumb$diff(crumb)));
};
var $author$project$Components$Auditing$Crumb$Address$view = function (crumb) {
	var _v0 = crumb.aef;
	switch (_v0) {
		case 0:
			return A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Address added')
					]));
		case 1:
			return $author$project$Components$Auditing$Crumb$Helpers$viewChanges(crumb);
		default:
			return A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Address deleted')
					]));
	}
};
var $author$project$Components$Auditing$Crumb$Charge$view = function (crumb) {
	var _v0 = crumb.aef;
	switch (_v0) {
		case 0:
			return A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Charge added')
					]));
		case 1:
			return $author$project$Components$Auditing$Crumb$Helpers$viewChanges(crumb);
		default:
			return A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Charge deleted')
					]));
	}
};
var $author$project$Components$Auditing$Crumb$MembershipPatient$viewCreate = function (name) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(name + ' was enrolled')
			]));
};
var $author$project$Components$Auditing$Crumb$MembershipPatient$viewTerminated = function (name) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(name + ' was terminated')
			]));
};
var $author$project$Components$Auditing$Crumb$Helpers$getDiffValue = F2(
	function (searchKey, crumb) {
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$second,
				A2(
					$elm_community$list_extra$List$Extra$find,
					function (_v0) {
						var key = _v0.a;
						return _Utils_eq(key, searchKey);
					},
					$author$project$Api$Audit$Crumb$diff(crumb))));
	});
var $author$project$Components$Auditing$Crumb$Helpers$getDiffValues = F2(
	function (searchKey, crumb) {
		var _v0 = A2(
			$elm_community$list_extra$List$Extra$find,
			function (_v1) {
				var key = _v1.a;
				return _Utils_eq(key, searchKey);
			},
			$author$project$Api$Audit$Crumb$diff(crumb));
		if (!_v0.$) {
			var _v2 = _v0.a;
			var _v3 = _v2.b;
			var from = _v3.a;
			var to = _v3.b;
			var _v4 = _Utils_Tuple2(from, to);
			_v4$3:
			while (true) {
				if (!_v4.a.$) {
					if (!_v4.a.a.$) {
						if (!_v4.b.$) {
							if (!_v4.b.a.$) {
								var fromValue = _v4.a.a.a;
								var toValue = _v4.b.a.a;
								return _Utils_Tuple2(fromValue, toValue);
							} else {
								break _v4$3;
							}
						} else {
							var fromValue = _v4.a.a.a;
							var _v5 = _v4.b;
							return _Utils_Tuple2(fromValue, '');
						}
					} else {
						break _v4$3;
					}
				} else {
					if ((!_v4.b.$) && (!_v4.b.a.$)) {
						var _v6 = _v4.a;
						var toValue = _v4.b.a.a;
						return _Utils_Tuple2('', toValue);
					} else {
						break _v4$3;
					}
				}
			}
			return _Utils_Tuple2('', '');
		} else {
			return _Utils_Tuple2('', '');
		}
	});
var $author$project$Components$Auditing$Crumb$MembershipPatient$viewRestarted = function (name) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(name + ' was re-enrolled')
			]));
};
var $author$project$Components$Auditing$Crumb$MembershipPatient$viewUpdate = function (crumb) {
	var name = $author$project$Api$Audit$Crumb$label(crumb);
	var _v0 = A2($author$project$Components$Auditing$Crumb$Helpers$getDiffValues, 'status', crumb);
	var oldStatus = _v0.a;
	var newStatus = _v0.b;
	var _v1 = A2($author$project$Components$Auditing$Crumb$Helpers$getDiffValues, 'start_date', crumb);
	var oldStartDate = _v1.a;
	var newStartDate = _v1.b;
	var isEnrolled = (oldStartDate === '') && (newStartDate !== '');
	var _v2 = A2($author$project$Components$Auditing$Crumb$Helpers$getDiffValues, 'end_date', crumb);
	var oldEndDate = _v2.a;
	var newEndDate = _v2.b;
	if (isEnrolled) {
		return $author$project$Components$Auditing$Crumb$MembershipPatient$viewCreate(name);
	} else {
		if (oldStatus === 'ended') {
			return $author$project$Components$Auditing$Crumb$MembershipPatient$viewRestarted(name);
		} else {
			var isTerminated = (oldEndDate === '') && (newEndDate !== '');
			if ((newStatus === 'ended') || isTerminated) {
				return $author$project$Components$Auditing$Crumb$MembershipPatient$viewTerminated(name);
			} else {
				var startDateDiff = A2($author$project$Components$Auditing$Crumb$Helpers$getDiffValue, 'start_date', crumb);
				var startDateValue = A2(
					$author$project$Components$Auditing$Crumb$Helpers$viewChangeWithPrefix,
					name,
					_Utils_Tuple2('start_date', startDateDiff));
				return A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[startDateValue]));
			}
		}
	}
};
var $author$project$Components$Auditing$Crumb$MembershipPatient$view = function (crumb) {
	var name = $author$project$Api$Audit$Crumb$label(crumb);
	var _v0 = crumb.aef;
	switch (_v0) {
		case 0:
			return $author$project$Components$Auditing$Crumb$MembershipPatient$viewCreate(name);
		case 1:
			return $author$project$Components$Auditing$Crumb$MembershipPatient$viewUpdate(crumb);
		default:
			return $author$project$Components$Auditing$Crumb$MembershipPatient$viewTerminated(name);
	}
};
var $author$project$Components$Auditing$Crumb$CompanyAccount$viewMadeEligible = function (name) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(name + ' was made eligible')
			]));
};
var $author$project$Components$Auditing$Crumb$CompanyAccount$viewMadeIneligible = function (name) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(name + ' was removed from the company account')
			]));
};
var $author$project$Components$Auditing$Crumb$CompanyAccount$viewUpdate = function (crumb) {
	var name = $author$project$Api$Audit$Crumb$label(crumb);
	var _v0 = A2($author$project$Components$Auditing$Crumb$Helpers$getDiffValues, 'termination_requested_at', crumb);
	var oldTerminationDate = _v0.a;
	var newTerminationDate = _v0.b;
	return ((oldTerminationDate !== '') && (newTerminationDate === '')) ? $author$project$Components$Auditing$Crumb$CompanyAccount$viewMadeEligible(name) : (((oldTerminationDate === '') && (newTerminationDate !== '')) ? $author$project$Components$Auditing$Crumb$CompanyAccount$viewMadeIneligible(name) : A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('')
			])));
};
var $author$project$Components$Auditing$Crumb$CompanyAccount$view = function (crumb) {
	var _v0 = crumb.aef;
	switch (_v0) {
		case 0:
			return A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Membership created')
					]));
		case 1:
			var _v1 = $author$project$Api$Audit$Crumb$recordType(crumb);
			if (_v1 === 'membership_patient') {
				return $author$project$Components$Auditing$Crumb$MembershipPatient$view(crumb);
			} else {
				return $author$project$Components$Auditing$Crumb$CompanyAccount$viewUpdate(crumb);
			}
		default:
			return A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Membership deleted')
					]));
	}
};
var $author$project$Components$Auditing$Crumb$CompanyRegistration$viewMadeEligible = function (name) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(name + ' was made eligible')
			]));
};
var $author$project$Components$Auditing$Crumb$CompanyRegistration$viewMadeIneligible = function (name) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(name + ' was removed from the company account')
			]));
};
var $author$project$Components$Auditing$Crumb$CompanyRegistration$viewUpdate = function (crumb) {
	var name = $author$project$Api$Audit$Crumb$label(crumb);
	var _v0 = A2($author$project$Components$Auditing$Crumb$Helpers$getDiffValues, 'termination_requested_at', crumb);
	var oldTerminationDate = _v0.a;
	var newTerminationDate = _v0.b;
	return ((oldTerminationDate !== '') && (newTerminationDate === '')) ? $author$project$Components$Auditing$Crumb$CompanyRegistration$viewMadeEligible(name) : (((oldTerminationDate === '') && (newTerminationDate !== '')) ? $author$project$Components$Auditing$Crumb$CompanyRegistration$viewMadeIneligible(name) : A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('')
			])));
};
var $author$project$Components$Auditing$Crumb$CompanyRegistration$view = function (crumb) {
	var _v0 = crumb.aef;
	switch (_v0) {
		case 0:
			return A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Audit$Crumb$label(crumb) + ' was enrolled')
					]));
		case 1:
			return $author$project$Components$Auditing$Crumb$CompanyRegistration$viewUpdate(crumb);
		default:
			return A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Audit$Crumb$label(crumb) + ' was unenrolled')
					]));
	}
};
var $author$project$Components$Auditing$Crumb$CustomerInvoice$view = function (crumb) {
	var invoiceNumber = $author$project$Api$Audit$Crumb$label(crumb);
	var _v0 = crumb.aef;
	switch (_v0) {
		case 0:
			return A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Invoice ' + (invoiceNumber + ' was issued'))
					]));
		case 1:
			return $author$project$Components$Auditing$Crumb$Helpers$viewChanges(crumb);
		default:
			return A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Invoice ' + (invoiceNumber + ' was deleted'))
					]));
	}
};
var $author$project$Components$Auditing$Crumb$Membership$viewCreate = A2(
	$author$project$Ui$Element$view,
	_List_Nil,
	_List_fromArray(
		[
			$elm$html$Html$text('Membership created')
		]));
var $author$project$Components$Auditing$Crumb$Membership$viewDelete = A2(
	$author$project$Ui$Element$view,
	_List_Nil,
	_List_fromArray(
		[
			$elm$html$Html$text('Membership terminated')
		]));
var $author$project$Components$Auditing$Crumb$Membership$viewUpdate = function (crumb) {
	var _v0 = A2($author$project$Components$Auditing$Crumb$Helpers$getDiffValues, 'end_date', crumb);
	var oldEndDate = _v0.a;
	var newEndDate = _v0.b;
	return ((oldEndDate !== '') && (newEndDate === '')) ? $author$project$Components$Auditing$Crumb$Membership$viewCreate : (((oldEndDate === '') && (newEndDate !== '')) ? $author$project$Components$Auditing$Crumb$Membership$viewDelete : $author$project$Components$Auditing$Crumb$Helpers$viewChanges(crumb));
};
var $author$project$Components$Auditing$Crumb$Membership$view = function (crumb) {
	var _v0 = crumb.aef;
	switch (_v0) {
		case 0:
			return $author$project$Components$Auditing$Crumb$Membership$viewCreate;
		case 1:
			return $author$project$Components$Auditing$Crumb$Membership$viewUpdate(crumb);
		default:
			return $author$project$Components$Auditing$Crumb$Membership$viewDelete;
	}
};
var $author$project$Components$Auditing$Crumb$Phone$view = function (crumb) {
	var phoneType = $author$project$Api$Audit$Crumb$label(crumb);
	var _v0 = A2($author$project$Components$Auditing$Crumb$Helpers$getDiffValues, 'number', crumb);
	var oldPhoneNumber = _v0.a;
	var newPhoneNumber = _v0.b;
	var _v1 = _Utils_Tuple2(crumb.aef, oldPhoneNumber);
	switch (_v1.a) {
		case 0:
			var _v2 = _v1.a;
			return A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(phoneType + (' ' + (newPhoneNumber + ' added')))
					]));
		case 1:
			if (_v1.b === '') {
				var _v3 = _v1.a;
				return A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(phoneType + (' ' + (newPhoneNumber + ' added')))
						]));
			} else {
				var _v4 = _v1.a;
				return A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(phoneType),
							$elm$html$Html$text(' changed from '),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$s,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(oldPhoneNumber)
										])),
									$elm$html$Html$text(' to '),
									$elm$html$Html$text(newPhoneNumber)
								]))
						]));
			}
		default:
			var _v5 = _v1.a;
			return A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(phoneType + (' ' + (oldPhoneNumber + ' removed')))
					]));
	}
};
var $author$project$Components$Auditing$Crumb$view = function (crumb) {
	var _v0 = $author$project$Api$Audit$Crumb$recordType(crumb);
	switch (_v0) {
		case 'company_registration':
			return $author$project$Components$Auditing$Crumb$CompanyRegistration$view(crumb);
		case 'company_account':
			return $author$project$Components$Auditing$Crumb$CompanyAccount$view(crumb);
		case 'charge':
			return $author$project$Components$Auditing$Crumb$Charge$view(crumb);
		case 'membership':
			return $author$project$Components$Auditing$Crumb$Membership$view(crumb);
		case 'membership_patient':
			return $author$project$Components$Auditing$Crumb$MembershipPatient$view(crumb);
		case 'customer_invoice':
			return $author$project$Components$Auditing$Crumb$CustomerInvoice$view(crumb);
		case 'address':
			return $author$project$Components$Auditing$Crumb$Address$view(crumb);
		case 'phone':
			return $author$project$Components$Auditing$Crumb$Phone$view(crumb);
		default:
			return $author$project$Components$Auditing$Crumb$Helpers$viewChanges(crumb);
	}
};
var $author$project$Components$Auditing$Trail$BankAccount$viewAll = function (trail) {
	return A2(
		$elm$core$List$map,
		$author$project$Components$Auditing$Crumb$view,
		$author$project$Api$Audit$crumbs(trail));
};
var $author$project$Components$Auditing$Trail$BankAccount$view = function (trail) {
	var label = A2(
		$elm$core$Maybe$withDefault,
		'Bank Account',
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Audit$Crumb$label,
			$elm$core$List$head(
				$author$project$Api$Audit$crumbs(trail))));
	var _v0 = $author$project$Api$Audit$name(trail);
	switch (_v0) {
		case 'BankAccount Created':
			return A2($author$project$Ui$Typography$text, _List_Nil, label + ' created');
		case 'BankAccount Deleted':
			return A2($author$project$Ui$Typography$text, _List_Nil, label + ' deleted');
		default:
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				$author$project$Components$Auditing$Trail$BankAccount$viewAll(trail));
	}
};
var $author$project$Components$Auditing$Trail$Card$viewAll = function (trail) {
	return A2(
		$elm$core$List$map,
		$author$project$Components$Auditing$Crumb$view,
		$author$project$Api$Audit$crumbs(trail));
};
var $author$project$Components$Auditing$Trail$Card$view = function (trail) {
	var label = A2(
		$elm$core$Maybe$withDefault,
		'Card',
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Audit$Crumb$label,
			$elm$core$List$head(
				$author$project$Api$Audit$crumbs(trail))));
	var _v0 = $author$project$Api$Audit$name(trail);
	switch (_v0) {
		case 'Card Created':
			return A2($author$project$Ui$Typography$text, _List_Nil, label + ' created');
		case 'Card Deleted':
			return A2($author$project$Ui$Typography$text, _List_Nil, label + ' deleted');
		default:
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				$author$project$Components$Auditing$Trail$Card$viewAll(trail));
	}
};
var $author$project$Components$Auditing$Trail$CompanyAccount$getCrumbList = function (trail) {
	return A2(
		$elm$core$List$map,
		$author$project$Components$Auditing$Crumb$view,
		$author$project$Api$Audit$crumbs(trail));
};
var $author$project$Components$Auditing$Trail$CompanyAccount$viewAll = function (trail) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		$author$project$Components$Auditing$Trail$CompanyAccount$getCrumbList(trail));
};
var $author$project$Components$Auditing$Trail$CompanyAccount$viewCreated = A2($author$project$Ui$Typography$text, _List_Nil, 'Membership created');
var $author$project$Components$Auditing$Trail$CompanyAccount$viewDeleted = A2($author$project$Ui$Typography$text, _List_Nil, 'Membership terminated');
var $author$project$Components$Auditing$Trail$CompanyAccount$viewEnrollmentApproved = A2($author$project$Ui$Typography$text, _List_Nil, 'Enrollment Approved');
var $author$project$Components$Auditing$Trail$CompanyAccount$view = function (trail) {
	var _v0 = $author$project$Api$Audit$name(trail);
	switch (_v0) {
		case 'CompanyAccount Created':
			return $author$project$Components$Auditing$Trail$CompanyAccount$viewCreated;
		case 'CompanyAccount Unenrolled':
			return $author$project$Components$Auditing$Trail$CompanyAccount$viewDeleted;
		case 'CompanyAccount Approved':
			return $author$project$Components$Auditing$Trail$CompanyAccount$viewEnrollmentApproved;
		default:
			return $author$project$Components$Auditing$Trail$CompanyAccount$viewAll(trail);
	}
};
var $author$project$Components$Auditing$Trail$CustomerInvoice$getCrumbList = function (trail) {
	return A2(
		$elm$core$List$map,
		$author$project$Components$Auditing$Crumb$view,
		$author$project$Api$Audit$crumbs(trail));
};
var $author$project$Components$Auditing$Trail$CustomerInvoice$viewAll = function (trail) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		$author$project$Components$Auditing$Trail$CustomerInvoice$getCrumbList(trail));
};
var $author$project$Api$Audit$label = function (audit) {
	var record = audit;
	var _v1 = record.xf;
	if (!_v1.$) {
		var aggregate = _v1.a;
		return aggregate.aih;
	} else {
		return '';
	}
};
var $author$project$Components$Auditing$Trail$CustomerInvoice$viewCreated = function (trail) {
	return A2(
		$author$project$Ui$Typography$text,
		_List_Nil,
		'Invoice ' + ($author$project$Api$Audit$label(trail) + ' created'));
};
var $author$project$Api$Audit$Crumb$diffTypeToString = function (diffType) {
	if (!diffType.$) {
		var string = diffType.a;
		return $elm$core$Maybe$Just(string);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Auditing$Trail$CustomerInvoice$getCreditAmount = function (trail) {
	return A2(
		$elm$core$Maybe$map,
		$elm$core$Tuple$second,
		A2(
			$elm$core$Maybe$andThen,
			function (crumb) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (_v0) {
							var key = _v0.a;
							return key === 'credit';
						},
						$author$project$Api$Audit$Crumb$diff(crumb)));
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (crumb) {
						return $author$project$Api$Audit$Crumb$recordType(crumb) === 'credit';
					},
					$author$project$Api$Audit$crumbs(trail)))));
};
var $author$project$Components$Auditing$Trail$CustomerInvoice$getCreditAmountHelper = F2(
	function (extractDiffType, trail) {
		var creditAmount = function () {
			var _v0 = $author$project$Components$Auditing$Trail$CustomerInvoice$getCreditAmount(trail);
			if (!_v0.$) {
				var diff = _v0.a;
				return A2(
					$elm$core$Maybe$andThen,
					$author$project$Api$Audit$Crumb$diffTypeToString,
					extractDiffType(diff));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		return A2($elm$core$Maybe$withDefault, '', creditAmount);
	});
var $author$project$Components$Auditing$Trail$CustomerInvoice$getCreditAmountApplied = $author$project$Components$Auditing$Trail$CustomerInvoice$getCreditAmountHelper(
	function (_v0) {
		var maybeDiffType = _v0.b;
		return maybeDiffType;
	});
var $author$project$Components$Auditing$Trail$CustomerInvoice$getCrumbListWithoutCredit = function (trail) {
	return A2(
		$elm$core$List$map,
		$author$project$Components$Auditing$Crumb$view,
		A2(
			$elm$core$List$filter,
			function (crumb) {
				return $author$project$Api$Audit$Crumb$recordType(crumb) !== 'credit';
			},
			$author$project$Api$Audit$crumbs(trail)));
};
var $author$project$Components$Auditing$Trail$CustomerInvoice$viewCreditApplied = function (trail) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$text,
				_List_Nil,
				$author$project$Components$Auditing$Trail$CustomerInvoice$getCreditAmountApplied(trail) + ' credit applied'),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				$author$project$Components$Auditing$Trail$CustomerInvoice$getCrumbListWithoutCredit(trail))
			]));
};
var $author$project$Components$Auditing$Trail$CustomerInvoice$getCreditAmountRemoved = $author$project$Components$Auditing$Trail$CustomerInvoice$getCreditAmountHelper(
	function (_v0) {
		var maybeDiffType = _v0.a;
		return maybeDiffType;
	});
var $author$project$Components$Auditing$Trail$CustomerInvoice$viewCreditRemoved = function (trail) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$text,
				_List_Nil,
				$author$project$Components$Auditing$Trail$CustomerInvoice$getCreditAmountRemoved(trail) + ' credit removed'),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				$author$project$Components$Auditing$Trail$CustomerInvoice$getCrumbListWithoutCredit(trail))
			]));
};
var $author$project$Components$Auditing$Trail$CustomerInvoice$viewIssued = function (trail) {
	return A2(
		$author$project$Ui$Typography$text,
		_List_Nil,
		'Invoice ' + ($author$project$Api$Audit$label(trail) + ' was issued'));
};
var $author$project$Components$Auditing$Trail$CustomerInvoice$viewReturnedToDraft = function (trail) {
	return A2(
		$author$project$Ui$Typography$text,
		_List_Nil,
		'Invoice ' + ($author$project$Api$Audit$label(trail) + ' was returned to draft'));
};
var $author$project$Api$Audit$Crumb$event = function (crumb) {
	var _v0 = crumb.aef;
	switch (_v0) {
		case 0:
			return 'create';
		case 1:
			return 'update';
		default:
			return 'delete';
	}
};
var $author$project$Components$Auditing$Trail$CustomerInvoice$viewUpload = function (trail) {
	var isCustomerInvoiceCreate = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (crumb) {
				return $author$project$Api$Audit$Crumb$event(crumb) === 'create';
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (crumb) {
						return $author$project$Api$Audit$Crumb$recordType(crumb) === 'customer_invoice';
					},
					$author$project$Api$Audit$crumbs(trail)))));
	return isCustomerInvoiceCreate ? $author$project$Components$Auditing$Trail$CustomerInvoice$viewCreated(trail) : A2(
		$elm$html$Html$div,
		_List_Nil,
		$author$project$Components$Auditing$Trail$CustomerInvoice$getCrumbList(trail));
};
var $author$project$Components$Auditing$Trail$CustomerInvoice$viewVoided = function (trail) {
	return A2(
		$author$project$Ui$Typography$text,
		_List_Nil,
		'Invoice ' + ($author$project$Api$Audit$label(trail) + ' was voided'));
};
var $author$project$Components$Auditing$Trail$CustomerInvoice$view = function (trail) {
	var _v0 = $author$project$Api$Audit$name(trail);
	switch (_v0) {
		case 'CustomerInvoice Returned to draft':
			return $author$project$Components$Auditing$Trail$CustomerInvoice$viewReturnedToDraft(trail);
		case 'CustomerInvoice Issued':
			return $author$project$Components$Auditing$Trail$CustomerInvoice$viewIssued(trail);
		case 'CustomerInvoice Created':
			return $author$project$Components$Auditing$Trail$CustomerInvoice$viewCreated(trail);
		case 'CustomerInvoice Voided':
			return $author$project$Components$Auditing$Trail$CustomerInvoice$viewVoided(trail);
		case 'CSV Uploaded':
			return $author$project$Components$Auditing$Trail$CustomerInvoice$viewUpload(trail);
		case 'CustomerInvoice Credits applied':
			return $author$project$Components$Auditing$Trail$CustomerInvoice$viewCreditApplied(trail);
		case 'CustomerInvoice Credits removed':
			return $author$project$Components$Auditing$Trail$CustomerInvoice$viewCreditRemoved(trail);
		default:
			return $author$project$Components$Auditing$Trail$CustomerInvoice$viewAll(trail);
	}
};
var $author$project$Components$Auditing$Trail$Invoice$viewAutoIssued = A2($author$project$Ui$Typography$text, _List_Nil, 'Invoice Auto-Issued');
var $author$project$Components$Auditing$Trail$Invoice$viewCreated = A2($author$project$Ui$Typography$text, _List_Nil, 'Invoice Created');
var $author$project$Components$Auditing$Trail$Invoice$viewEmpty = $elm$html$Html$text('');
var $author$project$Components$Auditing$Trail$Invoice$viewIssued = A2($author$project$Ui$Typography$text, _List_Nil, 'Invoice Issued');
var $author$project$Components$Auditing$Trail$Invoice$viewMarkedAsBadDebt = A2($author$project$Ui$Typography$text, _List_Nil, 'Invoice marked as bad debt');
var $author$project$Components$Auditing$Trail$Invoice$viewNotificationSent = A2($author$project$Ui$Typography$text, _List_Nil, 'Invoice Notification Sent');
var $author$project$Components$Auditing$Trail$Invoice$viewReturnedToDraft = A2($author$project$Ui$Typography$text, _List_Nil, 'Invoice Returned to Draft');
var $author$project$Components$Auditing$Trail$Invoice$viewVoided = A2($author$project$Ui$Typography$text, _List_Nil, 'Invoice Voided');
var $author$project$Components$Auditing$Trail$Invoice$view = function (trail) {
	var _v0 = $author$project$Api$Audit$name(trail);
	switch (_v0) {
		case 'Invoice Returned to draft':
			return $author$project$Components$Auditing$Trail$Invoice$viewReturnedToDraft;
		case 'Invoice Issued':
			return $author$project$Components$Auditing$Trail$Invoice$viewIssued;
		case 'Invoice Created':
			return $author$project$Components$Auditing$Trail$Invoice$viewCreated;
		case 'Invoice Voided':
			return $author$project$Components$Auditing$Trail$Invoice$viewVoided;
		case 'Notification Created':
			return $author$project$Components$Auditing$Trail$Invoice$viewNotificationSent;
		case 'Invoice Marked as bad debt':
			return $author$project$Components$Auditing$Trail$Invoice$viewMarkedAsBadDebt;
		case 'Invoice Notify upcoming':
			return $author$project$Components$Auditing$Trail$Invoice$viewNotificationSent;
		case 'Invoice Notify upcoming one worker':
			return $author$project$Components$Auditing$Trail$Invoice$viewNotificationSent;
		case 'Invoice Issue and or autopay':
			return $author$project$Components$Auditing$Trail$Invoice$viewAutoIssued;
		case 'Invoice Issue and or autopay one worker':
			return $author$project$Components$Auditing$Trail$Invoice$viewAutoIssued;
		default:
			return $author$project$Components$Auditing$Trail$Invoice$viewEmpty;
	}
};
var $author$project$Components$Auditing$Trail$Membership$getCrumbList = function (trail) {
	return A2(
		$elm$core$List$map,
		$author$project$Components$Auditing$Crumb$view,
		$author$project$Api$Audit$crumbs(trail));
};
var $author$project$Components$Auditing$Trail$Membership$viewAll = function (trail) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		$author$project$Components$Auditing$Trail$Membership$getCrumbList(trail));
};
var $author$project$Components$Auditing$Trail$Membership$viewCancelled = A2($author$project$Ui$Typography$text, _List_Nil, 'Membership terminated');
var $author$project$Components$Auditing$Trail$Membership$viewCreated = A2($author$project$Ui$Typography$text, _List_Nil, 'Membership created');
var $author$project$Components$Auditing$Trail$Membership$viewCreatedViaOnlineSignup = A2($author$project$Ui$Typography$text, _List_Nil, 'Created by patient');
var $author$project$Components$Auditing$Trail$Membership$viewEasUpload = function (trail) {
	return A2(
		$elm$core$List$map,
		$author$project$Components$Auditing$Crumb$CompanyAccount$view,
		$author$project$Api$Audit$crumbs(trail));
};
var $author$project$Components$Auditing$Trail$Membership$viewRestarted = function (trail) {
	var crumbList = A2(
		$elm$core$List$append,
		_List_fromArray(
			[
				$elm$html$Html$text('Membership restarted')
			]),
		$author$project$Components$Auditing$Trail$Membership$getCrumbList(trail));
	return A2($elm$html$Html$div, _List_Nil, crumbList);
};
var $author$project$Components$Auditing$Crumb$MembershipUpload$view = function (crumb) {
	var _v0 = crumb.aef;
	switch (_v0) {
		case 0:
			return A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Membership created')
					]));
		case 1:
			var _v1 = $author$project$Api$Audit$Crumb$recordType(crumb);
			switch (_v1) {
				case 'membership':
					return $author$project$Components$Auditing$Crumb$Helpers$viewChanges(crumb);
				case 'membership_patient':
					return $author$project$Components$Auditing$Crumb$MembershipPatient$view(crumb);
				default:
					return $author$project$Components$Auditing$Crumb$Helpers$viewChanges(crumb);
			}
		default:
			return A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Membership deleted')
					]));
	}
};
var $author$project$Components$Auditing$Trail$Membership$viewUpload = function (trail) {
	return A2(
		$elm$core$List$map,
		function (crumb) {
			var _v0 = $author$project$Api$Audit$Crumb$recordType(crumb);
			switch (_v0) {
				case 'membership':
					return $author$project$Components$Auditing$Crumb$MembershipUpload$view(crumb);
				case 'membership_patient':
					return $author$project$Components$Auditing$Crumb$MembershipPatient$view(crumb);
				default:
					return $elm$html$Html$text('');
			}
		},
		$author$project$Api$Audit$crumbs(trail));
};
var $author$project$Components$Auditing$Trail$Membership$view = function (trail) {
	var _v0 = $author$project$Api$Audit$name(trail);
	switch (_v0) {
		case 'Membership Created':
			return $author$project$Components$Auditing$Trail$Membership$viewCreated;
		case 'Membership Cancelled':
			return $author$project$Components$Auditing$Trail$Membership$viewCancelled;
		case 'CSV Uploaded':
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				$author$project$Components$Auditing$Trail$Membership$viewUpload(trail));
		case 'EAS CSV Uploaded':
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				$author$project$Components$Auditing$Trail$Membership$viewEasUpload(trail));
		case 'Membership Updated':
			return $author$project$Components$Auditing$Trail$Membership$viewAll(trail);
		case 'Membership Restarted':
			return $author$project$Components$Auditing$Trail$Membership$viewRestarted(trail);
		case 'OnlineEnrollments Confirm Created':
			return $author$project$Components$Auditing$Trail$Membership$viewCreatedViaOnlineSignup;
		default:
			return $author$project$Components$Auditing$Trail$Membership$viewAll(trail);
	}
};
var $author$project$Components$Auditing$Trail$Patient$viewAll = function (trail) {
	return A2(
		$elm$core$List$map,
		$author$project$Components$Auditing$Crumb$view,
		$author$project$Api$Audit$crumbs(trail));
};
var $author$project$Components$Auditing$Trail$Patient$viewCreated = A2($author$project$Ui$Typography$text, _List_Nil, 'Patient created');
var $author$project$Components$Auditing$Trail$Patient$viewCreatedViaOnlineSignup = A2($author$project$Ui$Typography$text, _List_Nil, 'Created by patient');
var $author$project$Components$Auditing$Crumb$Patient$view = function (crumb) {
	var _v0 = crumb.aef;
	switch (_v0) {
		case 0:
			return A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Patient created')
					]));
		case 1:
			return $author$project$Components$Auditing$Crumb$Helpers$viewChanges(crumb);
		default:
			return A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Patient deleted')
					]));
	}
};
var $author$project$Components$Auditing$Crumb$PatientAffiliation$view = function (crumb) {
	var _v0 = crumb.aef;
	switch (_v0) {
		case 0:
			return A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Patient affiliation created')
					]));
		case 1:
			return $author$project$Components$Auditing$Crumb$Helpers$viewChanges(crumb);
		default:
			return A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Patient affiliation deleted')
					]));
	}
};
var $author$project$Components$Auditing$Trail$Patient$viewUpload = function (trail) {
	var isPatientCreate = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (crumb) {
				return $author$project$Api$Audit$Crumb$event(crumb) === 'create';
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (crumb) {
						return $author$project$Api$Audit$Crumb$recordType(crumb) === 'patient';
					},
					$author$project$Api$Audit$crumbs(trail)))));
	return isPatientCreate ? $author$project$Components$Auditing$Trail$Patient$viewCreated : A2(
		$elm$html$Html$div,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (crumb) {
				var _v0 = $author$project$Api$Audit$Crumb$recordType(crumb);
				switch (_v0) {
					case 'patient':
						return $author$project$Components$Auditing$Crumb$Patient$view(crumb);
					case 'address':
						return $author$project$Components$Auditing$Crumb$Address$view(crumb);
					case 'phone':
						return $author$project$Components$Auditing$Crumb$Phone$view(crumb);
					case 'patient_affiliation':
						return $author$project$Components$Auditing$Crumb$PatientAffiliation$view(crumb);
					default:
						return $author$project$Components$Auditing$Crumb$view(crumb);
				}
			},
			$author$project$Api$Audit$crumbs(trail)));
};
var $author$project$Components$Auditing$Trail$Patient$view = function (trail) {
	var _v0 = $author$project$Api$Audit$name(trail);
	switch (_v0) {
		case 'Patient Created':
			return $author$project$Components$Auditing$Trail$Patient$viewCreated;
		case 'CSV Uploaded':
			return $author$project$Components$Auditing$Trail$Patient$viewUpload(trail);
		case 'EAS CSV Uploaded':
			return $author$project$Components$Auditing$Trail$Patient$viewUpload(trail);
		case 'CompanyRegistration Created':
			return $author$project$Components$Auditing$Trail$Patient$viewCreated;
		case 'OnlineEnrollment Confirmed':
			return $author$project$Components$Auditing$Trail$Patient$viewCreatedViaOnlineSignup;
		case 'OnlineEnrollments Member Created':
			return $author$project$Components$Auditing$Trail$Patient$viewCreatedViaOnlineSignup;
		case 'CompanyRegistration Updated':
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				$author$project$Components$Auditing$Trail$Patient$viewAll(trail));
		default:
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				$author$project$Components$Auditing$Trail$Patient$viewAll(trail));
	}
};
var $author$project$Components$Auditing$Trail$viewAll = function (trail) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		A2(
			$elm$core$List$map,
			$author$project$Components$Auditing$Crumb$view,
			$author$project$Api$Audit$crumbs(trail)));
};
var $author$project$Components$Auditing$Trail$view = function (trail) {
	var _v0 = _Utils_Tuple2(
		$author$project$Api$Audit$aggregateType(trail),
		$author$project$Api$Audit$name(trail));
	_v0$5:
	while (true) {
		_v0$6:
		while (true) {
			_v0$7:
			while (true) {
				if (!_v0.a.$) {
					switch (_v0.a.a) {
						case 'membership':
							return $author$project$Components$Auditing$Trail$Membership$view(trail);
						case 'patient':
							return $author$project$Components$Auditing$Trail$Patient$view(trail);
						case 'company_account':
							return $author$project$Components$Auditing$Trail$CompanyAccount$view(trail);
						case 'customer_invoice':
							return $author$project$Components$Auditing$Trail$CustomerInvoice$view(trail);
						case 'invoice':
							return $author$project$Components$Auditing$Trail$Invoice$view(trail);
						default:
							switch (_v0.b) {
								case 'Card Deleted':
									break _v0$5;
								case 'BankAccount Deleted':
									break _v0$6;
								default:
									break _v0$7;
							}
					}
				} else {
					switch (_v0.b) {
						case 'Card Deleted':
							break _v0$5;
						case 'BankAccount Deleted':
							break _v0$6;
						default:
							break _v0$7;
					}
				}
			}
			return $author$project$Components$Auditing$Trail$viewAll(trail);
		}
		return $author$project$Components$Auditing$Trail$BankAccount$view(trail);
	}
	return $author$project$Components$Auditing$Trail$Card$view(trail);
};
var $author$project$Api$Audit$whodunnit = function (audit) {
	return $author$project$Api$Audit$record_(audit).aez.Bq;
};
var $author$project$Components$AuditTrailLog$viewAudit = F3(
	function (timeFormatter, audits, audit) {
		var createdAt = A2(
			timeFormatter,
			0,
			$author$project$Api$Audit$createdAt(audit));
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Components$Auditing$Trail$view(audit),
					function () {
					if ($author$project$Api$Audit$isOnlineSignup(audit)) {
						return A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[$author$project$Ui$Typography$small, $author$project$Ui$Typography$helpBlock]),
											createdAt + ' via online signup')
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[$author$project$Ui$Typography$small, $author$project$Ui$Typography$helpBlock]),
											A2(
												$elm$core$Maybe$withDefault,
												'',
												$author$project$Api$Audit$extraUrl(audit)))
										]))
								]));
					} else {
						var whodunnit = $author$project$Components$AuditTrailLog$formatWhodunnit(
							$author$project$Api$Audit$whodunnit(audit));
						return A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$small, $author$project$Ui$Typography$helpBlock]),
									createdAt + (' by ' + whodunnit))
								]));
					}
				}(),
					A2($author$project$Components$AuditTrailLog$isLast, audits, audit) ? $author$project$Utils$Html$empty : $author$project$Ui$HorizontalRule$view(
					_List_fromArray(
						[$author$project$Ui$HorizontalRule$thin]))
				]));
	});
var $author$project$Components$AuditTrailLog$changeHistoryView = function (model) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_Nil,
		A2(
			$elm$core$List$map,
			A2($author$project$Components$AuditTrailLog$viewAudit, model.J7, model.cU),
			model.cU));
};
var $author$project$Components$AuditTrailLog$loadingView = A2(
	$author$project$Ui$Element$view,
	_List_fromArray(
		[$author$project$Ui$Element$textCenter]),
	_List_fromArray(
		[
			$author$project$Ui$Spinner$view(_List_Nil)
		]));
var $author$project$Ui$Popover$Medium = 2;
var $author$project$Ui$Popover$md = $author$project$Ui$Popover$Size(2);
var $author$project$Components$AuditTrailLog$PaginationMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$AuditTrailLog$isCreatedBeforeOct2023 = function (resourceCreatedAt) {
	if (!resourceCreatedAt.$) {
		var createdAt = resourceCreatedAt.a;
		var oct1_2023 = $elm$time$Time$millisToPosix(1696118400000);
		return _Utils_cmp(
			$elm$time$Time$posixToMillis(createdAt),
			$elm$time$Time$posixToMillis(oct1_2023)) < 0;
	} else {
		return false;
	}
};
var $author$project$Components$AuditTrailLog$showContactSupport = A2(
	$author$project$Ui$Element$view,
	_List_fromArray(
		[$author$project$Ui$Element$textMuted]),
	_List_fromArray(
		[
			$elm$html$Html$text('For information on changes prior to 10/1/2023 email '),
			A3(
			$author$project$Ui$Link$mailto,
			'support@hint.com',
			_List_fromArray(
				[$author$project$Ui$Link$targetBlank]),
			_List_fromArray(
				[
					$elm$html$Html$text('support@hint.com')
				])),
			$elm$html$Html$text('.')
		]));
var $author$project$Components$AuditTrailLog$showNoHistory = function (resource) {
	var record = _Utils_eq(
		resource,
		$elm$core$Maybe$Just('request')) ? 'the payment methods' : A2(
		$elm$core$String$append,
		'this ',
		A3(
			$elm$core$String$replace,
			'_',
			' ',
			A2($elm$core$Maybe$withDefault, 'record', resource)));
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$textMuted]),
		_List_fromArray(
			[
				$elm$html$Html$text('No changes have been recorded for ' + (record + '.'))
			]));
};
var $author$project$Components$AuditTrailLog$showMoreItem = function (model) {
	if ($elm$core$List$isEmpty(model.cU)) {
		return $author$project$Components$AuditTrailLog$isCreatedBeforeOct2023(model.Eg) ? $author$project$Components$AuditTrailLog$showContactSupport : $author$project$Components$AuditTrailLog$showNoHistory(model.Jy);
	} else {
		var totalRemaining = model.FV - $elm$core$List$length(model.cU);
		return (!(!totalRemaining)) ? A2(
			$elm$html$Html$map,
			$author$project$Components$AuditTrailLog$PaginationMsg,
			A2($author$project$Api$Pagination$viewAsShowMore, _List_Nil, model.ajJ)) : ($author$project$Components$AuditTrailLog$isCreatedBeforeOct2023(model.Eg) ? A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$HorizontalRule$view(
					_List_fromArray(
						[$author$project$Ui$HorizontalRule$thin])),
					$author$project$Components$AuditTrailLog$showContactSupport
				])) : $author$project$Utils$Html$empty);
	}
};
var $author$project$Components$AuditTrailLog$viewWith = F3(
	function (popoverOptions, displayedContent, model) {
		return A4(
			$author$project$Ui$Popover$viewAsClickable,
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Popover$md,
				A2(
					$elm$core$List$cons,
					$author$project$Ui$Popover$visible(
						$author$project$Ui$Popover$isOpen(model.aT)),
					popoverOptions)),
			displayedContent,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Popover$body,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = model.ro;
							if (_v0.$ === 3) {
								return $elm$core$List$isEmpty(model.cU) ? $author$project$Utils$Html$empty : $author$project$Components$AuditTrailLog$changeHistoryView(model);
							} else {
								return $author$project$Components$AuditTrailLog$loadingView;
							}
						}(),
							$author$project$Components$AuditTrailLog$showMoreItem(model)
						]))
				]),
			model.aT);
	});
var $author$project$Components$AuditTrailLog$view = function (model) {
	return A3(
		$author$project$Components$AuditTrailLog$viewWith,
		_List_Nil,
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{mm: 'See change history'},
				_List_fromArray(
					[
						$author$project$Ui$Button$onClick($author$project$Components$AuditTrailLog$Toggle),
						$author$project$Ui$Button$badge,
						$author$project$Ui$Button$icon($author$project$Ui$Icon$history)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('See Change History')
					]))
			]),
		model);
};
var $author$project$Components$Company$VirtualBankAccounts$Invoice$loadFromData = function (model) {
	var _v0 = model.F7;
	if (_v0.$ === 3) {
		var virtualBankAccounts_ = _v0.a;
		return virtualBankAccounts_;
	} else {
		return _List_Nil;
	}
};
var $author$project$Api$Employer$VirtualBankAccount$Shared$abaAccountNumber = function (_v0) {
	var record = _v0;
	return record.Ku;
};
var $author$project$Api$Provider$VirtualBankAccount$Shared$abaAccountNumber = function (_v0) {
	var record = _v0;
	return record.Ku;
};
var $author$project$Api$VirtualBankAccount$abaAccountNumber = function (vba) {
	if (!vba.$) {
		var vba_ = vba.a;
		return $author$project$Api$Provider$VirtualBankAccount$Shared$abaAccountNumber(vba_);
	} else {
		var vba_ = vba.a;
		return $author$project$Api$Employer$VirtualBankAccount$Shared$abaAccountNumber(vba_);
	}
};
var $author$project$Api$Employer$VirtualBankAccount$Shared$abaBankName = function (_v0) {
	var record = _v0;
	return record.Kv;
};
var $author$project$Api$Provider$VirtualBankAccount$Shared$abaBankName = function (_v0) {
	var record = _v0;
	return record.Kv;
};
var $author$project$Api$VirtualBankAccount$abaBankName = function (vba) {
	if (!vba.$) {
		var vba_ = vba.a;
		return $author$project$Api$Provider$VirtualBankAccount$Shared$abaBankName(vba_);
	} else {
		var vba_ = vba.a;
		return $author$project$Api$Employer$VirtualBankAccount$Shared$abaBankName(vba_);
	}
};
var $author$project$Api$Employer$VirtualBankAccount$Shared$abaRoutingtNumber = function (_v0) {
	var record = _v0;
	return record.Kw;
};
var $author$project$Api$Provider$VirtualBankAccount$Shared$abaRoutingtNumber = function (_v0) {
	var record = _v0;
	return record.Kw;
};
var $author$project$Api$VirtualBankAccount$abaRoutingtNumber = function (vba) {
	if (!vba.$) {
		var vba_ = vba.a;
		return $author$project$Api$Provider$VirtualBankAccount$Shared$abaRoutingtNumber(vba_);
	} else {
		var vba_ = vba.a;
		return $author$project$Api$Employer$VirtualBankAccount$Shared$abaRoutingtNumber(vba_);
	}
};
var $author$project$Api$Employer$VirtualBankAccount$Shared$swiftCode = function (_v0) {
	var record = _v0;
	return record.acG;
};
var $author$project$Api$Provider$VirtualBankAccount$Shared$swiftCode = function (_v0) {
	var record = _v0;
	return record.acG;
};
var $author$project$Api$VirtualBankAccount$swiftCode = function (vba) {
	if (!vba.$) {
		var vba_ = vba.a;
		return $author$project$Api$Provider$VirtualBankAccount$Shared$swiftCode(vba_);
	} else {
		var vba_ = vba.a;
		return $author$project$Api$Employer$VirtualBankAccount$Shared$swiftCode(vba_);
	}
};
var $author$project$Components$Company$VirtualBankAccounts$Invoice$CopyToClipboard = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Company$VirtualBankAccounts$Invoice$viewBankAccountRow = function (_v0) {
	var label = _v0.a;
	var value = _v0.b;
	return A2(
		$author$project$Ui$Grid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$span(4)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$text,
						_List_fromArray(
							[$author$project$Ui$Typography$muted]),
						label)
					])),
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$span(8)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$prose,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$text,
								_List_fromArray(
									[
										$author$project$Ui$Typography$phi(true)
									]),
								value),
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Copy ' + label},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$icon($author$project$Ui$Icon$copy),
										$author$project$Ui$Button$onClick(
										A2($author$project$Components$Company$VirtualBankAccounts$Invoice$CopyToClipboard, label, value))
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $author$project$Components$Company$VirtualBankAccounts$Invoice$viewVirtualBankAccountBox = function (vba) {
	return A3(
		$author$project$Ui$Alert$view,
		1,
		_List_fromArray(
			[
				$author$project$Ui$Alert$alignment($author$project$Ui$Alignment$textLeft)
			]),
		A2(
			$elm$core$List$map,
			$author$project$Components$Company$VirtualBankAccounts$Invoice$viewBankAccountRow,
			_List_fromArray(
				[
					_Utils_Tuple2(
					'Bank Name',
					$author$project$Api$VirtualBankAccount$abaBankName(vba)),
					_Utils_Tuple2(
					'Routing Number',
					$author$project$Api$VirtualBankAccount$abaRoutingtNumber(vba)),
					_Utils_Tuple2(
					'Account Number',
					$author$project$Api$VirtualBankAccount$abaAccountNumber(vba)),
					_Utils_Tuple2(
					'SWIFT code',
					$author$project$Api$VirtualBankAccount$swiftCode(vba))
				])));
};
var $author$project$Components$Company$VirtualBankAccounts$Invoice$viewVirtualBankAccount = F2(
	function (payerName, virtualBankAccount) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Transfer Instructions'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('To complete payments to ' + (payerName + ', transfer funds from your banking institution to the bank account provided below. Bank Transfers can take up to five business days.')),
							A2($elm$html$Html$br, _List_Nil, _List_Nil)
						])),
					$author$project$Components$Company$VirtualBankAccounts$Invoice$viewVirtualBankAccountBox(virtualBankAccount)
				]));
	});
var $author$project$Components$Company$VirtualBankAccounts$Invoice$view = F2(
	function (_v0, payerName) {
		var model = _v0;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2(
				$elm$core$List$map,
				$author$project$Components$Company$VirtualBankAccounts$Invoice$viewVirtualBankAccount(payerName),
				$author$project$Components$Company$VirtualBankAccounts$Invoice$loadFromData(model)));
	});
var $author$project$Components$CompanyEmailModal$Body = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$CompanyEmailModal$NotificationFormFieldUpdated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$CompanyEmailModal$Subject = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Notification$One$bodyHtml = function (_v0) {
	var record = _v0.b;
	return record.MM;
};
var $author$project$Api$Provider$Notification$One$subjectHtml = function (_v0) {
	var record = _v0.b;
	return record.acw;
};
var $author$project$Components$CompanyEmailModal$viewPreview = F3(
	function (header, subject, body) {
		return _List_fromArray(
			[
				function () {
				if (!header.$) {
					var header_ = header.a;
					return A2(
						$author$project$Ui$Alert$info,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(header_)
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$phi]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('email-preview')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Subject')
									])),
								subject,
								$author$project$Ui$HorizontalRule$view(_List_Nil),
								body
							]))
					]))
			]);
	});
var $author$project$Components$CompanyEmailModal$viewModalBody = function (model) {
	switch (model.$) {
		case 0:
			var shared = model.a;
			return A3(
				$author$project$Components$CompanyEmailModal$viewPreview,
				shared.sx,
				$author$project$Ui$Spinner$view(_List_Nil),
				$author$project$Ui$Spinner$view(_List_Nil));
		case 1:
			var shared = model.a;
			var preview = model.b;
			var delivery = model.c;
			return _Utils_ap(
				A3(
					$author$project$Components$CompanyEmailModal$viewPreview,
					shared.sx,
					A2(
						$elm$html$Html$map,
						$elm$core$Basics$never,
						A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('subject')
								]),
							$author$project$Utils$Dom$textToHtml(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									$author$project$Api$Provider$Notification$One$subjectHtml(preview))))),
					A2(
						$elm$html$Html$map,
						$elm$core$Basics$never,
						A2(
							$elm$html$Html$div,
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$class('body'),
								$author$project$Api$Phi$displayAttr),
							$author$project$Utils$Dom$textToHtml(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									$author$project$Api$Provider$Notification$One$bodyHtml(preview)))))),
				_List_fromArray(
					[
						function () {
						if (delivery.$ === 2) {
							var error = delivery.a;
							return A2(
								$author$project$Ui$Alert$danger,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Error sending email')
											])),
										A2($elm$html$Html$br, _List_Nil, _List_Nil),
										$elm$html$Html$text(
										$author$project$Api$Data$errorToString(error))
									]));
						} else {
							return $author$project$Utils$Html$empty;
						}
					}()
					]));
		default:
			var shared = model.a;
			var notificationForm = model.b;
			var _v2 = $author$project$Utils$Form$fields(notificationForm);
			var subject = _v2.J_;
			var body = _v2.fO;
			return A3(
				$author$project$Components$CompanyEmailModal$viewPreview,
				shared.sx,
				A2(
					$author$project$Ui$Form$Group$view,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(
									A2($elm$core$Maybe$withDefault, '', subject)),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$CompanyEmailModal$NotificationFormFieldUpdated, $author$project$Components$CompanyEmailModal$Subject)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, notificationForm)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 0, notificationForm))
								]))
						])),
				A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Form$Textarea$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Textarea$rows(15),
											$author$project$Ui$Form$Textarea$value(
											A2($elm$core$Maybe$withDefault, '', body)),
											$author$project$Ui$Form$Textarea$onInput(
											A2($elm$core$Basics$composeL, $author$project$Components$CompanyEmailModal$NotificationFormFieldUpdated, $author$project$Components$CompanyEmailModal$Body)),
											$author$project$Ui$Form$Textarea$invalid(
											A2($author$project$Utils$Form$hasValidationErrors, 1, notificationForm)),
											$author$project$Ui$Form$Textarea$errors(
											A2($author$project$Utils$Form$validationErrors, 1, notificationForm))
										]))
								]))
						])));
	}
};
var $author$project$Components$CompanyEmailModal$Edit = {$: 2};
var $author$project$Components$CompanyEmailModal$Preview = {$: 1};
var $author$project$Components$CompanyEmailModal$Send = {$: 3};
var $author$project$Components$CompanyEmailModal$viewCancelButton = A3(
	$author$project$Ui$Button$view,
	{mm: 'Cancel and close modal'},
	_List_fromArray(
		[
			$author$project$Ui$Button$onClick($author$project$Components$CompanyEmailModal$Close)
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('Cancel')
		]));
var $author$project$Components$CompanyEmailModal$viewModalFooter = function (model) {
	switch (model.$) {
		case 0:
			return _List_fromArray(
				[$author$project$Components$CompanyEmailModal$viewCancelButton]);
		case 1:
			var delivery = model.c;
			var deliveryLoading = function () {
				if (delivery.$ === 1) {
					return true;
				} else {
					return false;
				}
			}();
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Customize email'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Components$CompanyEmailModal$Edit)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Customize Email')
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									$author$project$Components$CompanyEmailModal$viewCancelButton,
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Send email'},
									_List_fromArray(
										[
											$author$project$Ui$Button$primary,
											$author$project$Ui$Button$submit,
											$author$project$Ui$Button$onClick($author$project$Components$CompanyEmailModal$Send),
											$author$project$Ui$Button$loading(deliveryLoading)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Icon$send(_List_Nil),
											$elm$html$Html$text(' Send Email')
										]))
								]))
						]))
				]);
		default:
			var preview = model.c;
			var loading = function () {
				if (preview.$ === 1) {
					return true;
				} else {
					return false;
				}
			}();
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Preview email'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Components$CompanyEmailModal$Preview),
									$author$project$Ui$Button$loading(loading)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Preview Email')
								])),
							$author$project$Components$CompanyEmailModal$viewCancelButton
						]))
				]);
	}
};
var $author$project$Components$CompanyEmailModal$view = function (model) {
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$CompanyEmailModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Send via Email')
					])),
				$author$project$Ui$Modal$body(
				$author$project$Components$CompanyEmailModal$viewModalBody(model)),
				$author$project$Ui$Modal$footer(
				$author$project$Components$CompanyEmailModal$viewModalFooter(model))
			]));
};
var $author$project$Api$Employer$Invoice$Meta$hideChargeDetailsAction = function (_v0) {
	var meta = _v0;
	return meta.vy.Tr;
};
var $author$project$Api$Invoice$Meta$hideChargeDetailsAction = function (meta) {
	if (!meta.$) {
		return false;
	} else {
		var meta_ = meta.a;
		return $author$project$Api$Employer$Invoice$Meta$hideChargeDetailsAction(meta_);
	}
};
var $author$project$Components$ExportCsv$ReportParams = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$ExportCsv$reportParams = $author$project$Components$ExportCsv$ReportParams;
var $author$project$Components$Invoice$InvoiceLinesTable$reportParams = function (model) {
	var _v0 = model.Uv;
	if (!_v0.$) {
		var affiliateBillId = _v0.b;
		return _List_fromArray(
			[
				A2($author$project$Api$Param$string, 'affiliate_bill', affiliateBillId)
			]);
	} else {
		var companyId_ = _v0.a;
		var invoiceId = _v0.b;
		return _List_fromArray(
			[
				A2($author$project$Api$Param$string, 'invoice', invoiceId),
				A2($author$project$Api$Param$string, 'company', companyId_)
			]);
	}
};
var $author$project$Components$Invoice$InvoiceLinesTable$AddInvoiceLine = {$: 9};
var $author$project$Components$Invoice$InvoiceLinesTable$PaginationMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$SortTable = function (a) {
	return {$: 4, a: a};
};
var $author$project$Formatters$String$affiliateMember = F2(
	function (memberString, companyType) {
		if (_Utils_eq(
			companyType,
			$elm$core$Maybe$Just(0))) {
			switch (memberString) {
				case 'employee':
					return 'primary member';
				case 'Employee':
					return 'Primary';
				case 'Employees':
					return 'Members';
				case 'Employees & Dependents':
					return 'Members';
				default:
					return memberString;
			}
		} else {
			return memberString;
		}
	});
var $author$project$Api$Employer$Invoice$Meta$canAdjustAction = function (_v0) {
	var meta = _v0;
	return meta.vy.M3;
};
var $author$project$Api$Provider$Invoice$Meta$canAdjustAction = function (_v0) {
	var meta = _v0;
	return meta.vy.M3;
};
var $author$project$Api$Invoice$Meta$canAdjustAction = function (meta) {
	if (!meta.$) {
		var meta_ = meta.a;
		return $author$project$Api$Provider$Invoice$Meta$canAdjustAction(meta_);
	} else {
		var meta_ = meta.a;
		return $author$project$Api$Employer$Invoice$Meta$canAdjustAction(meta_);
	}
};
var $author$project$Api$Column$withOption = F2(
	function (newOption, _v0) {
		var col = _v0;
		var options = col.Cd;
		return _Utils_update(
			col,
			{
				Cd: A2($elm$core$List$cons, newOption, options)
			});
	});
var $author$project$Components$Invoice$InvoiceLinesTable$columns = function (company) {
	return $elm$core$List$concat(
		_List_fromArray(
			[
				_List_fromArray(
				[
					A3($author$project$Api$Column$init, 'date', true, 'Date'),
					A3($author$project$Api$Column$init, 'patient', false, 'Patient'),
					A3($author$project$Api$Column$init, 'description', false, 'Charge')
				]),
				$author$project$Components$Invoice$InvoiceLinesTable$allowCustomMembershipPlan(company) ? _List_fromArray(
				[
					A3($author$project$Api$Column$init, 'plan', true, 'Plan')
				]) : _List_Nil,
				_List_fromArray(
				[
					A3($author$project$Api$Column$init, 'category', false, 'Category'),
					A2(
					$author$project$Api$Column$withOption,
					$author$project$Ui$Table$textRight,
					A3($author$project$Api$Column$init, 'amount_in_cents', true, 'Amount'))
				])
			]));
};
var $author$project$Components$Invoice$InvoiceLinesTable$companyType = function (company) {
	return A2(
		$elm$core$Maybe$map,
		function (company_) {
			if (!company_.$) {
				var company__ = company_.a;
				return $author$project$Api$Provider$Company$Min$companyType(company__);
			} else {
				var company__ = company_.a;
				return $author$project$Api$Company$companyType(company__);
			}
		},
		company);
};
var $author$project$Ui$SearchInput$Loading = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$SearchInput$loading = $author$project$Ui$SearchInput$Loading;
var $author$project$Ui$Icon$Lock = 22;
var $author$project$Ui$Icon$lock = $author$project$Ui$Icon$viewIcon(22);
var $author$project$Ui$SearchInput$Phi = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$SearchInput$phi = $author$project$Ui$SearchInput$Phi;
var $author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$EmployerOrProviderCompany = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$ProviderMin = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$phiAlertCompany = function (company) {
	return A2(
		$elm$core$Maybe$map,
		function (company_) {
			if (!company_.$) {
				var company__ = company_.a;
				return $author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$ProviderMin(company__);
			} else {
				var company__ = company_.a;
				return $author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$EmployerOrProviderCompany(company__);
			}
		},
		company);
};
var $author$project$Api$Employer$Invoice$Meta$reportingPeriodIsLocked = function (_v0) {
	var meta = _v0;
	return meta.$y;
};
var $author$project$Api$Provider$Invoice$Meta$reportingPeriodIsLocked = function (_v0) {
	var meta = _v0;
	return meta.$y;
};
var $author$project$Api$Invoice$Meta$reportingPeriodIsLocked = function (meta) {
	if (!meta.$) {
		var meta_ = meta.a;
		return $author$project$Api$Provider$Invoice$Meta$reportingPeriodIsLocked(meta_);
	} else {
		var meta_ = meta.a;
		return $author$project$Api$Employer$Invoice$Meta$reportingPeriodIsLocked(meta_);
	}
};
var $author$project$Ui$Table$Test = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Table$test = $author$project$Ui$Table$Test;
var $author$project$Api$Employer$Company$One$chargePhiDetailsEnabled = function (_v0) {
	var record = _v0.b;
	return record.Nx;
};
var $author$project$Api$Provider$Company$One$chargePhiDetailsEnabled = function (_v0) {
	var record = _v0.b;
	return record.Nx;
};
var $author$project$Api$Company$chargePhiDetailsEnabled = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$chargePhiDetailsEnabled(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$chargePhiDetailsEnabled(company_);
	}
};
var $author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$chargePhiDetailsEnabled = function (company) {
	if (!company.$) {
		if (!company.a.$) {
			return false;
		} else {
			var company_ = company.a.a;
			return $author$project$Api$Company$chargePhiDetailsEnabled(company_);
		}
	} else {
		return false;
	}
};
var $author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$companyId = function (company) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function (company_) {
				if (!company_.$) {
					var company__ = company_.a;
					return $author$project$Api$Provider$Company$Min$id(company__);
				} else {
					var company__ = company_.a;
					return $author$project$Api$Company$id(company__);
				}
			},
			company));
};
var $author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$companyName = function (company) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function (company_) {
				if (!company_.$) {
					var company__ = company_.a;
					return $author$project$Api$Provider$Company$Min$name(company__);
				} else {
					var company__ = company_.a;
					return $author$project$Api$Company$name(company__);
				}
			},
			company));
};
var $author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$companyType = function (company) {
	return A2(
		$elm$core$Maybe$map,
		function (company_) {
			if (!company_.$) {
				var company__ = company_.a;
				return $author$project$Api$Provider$Company$Min$companyType(company__);
			} else {
				var company__ = company_.a;
				return $author$project$Api$Company$companyType(company__);
			}
		},
		company);
};
var $author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$viewForCompany = function (company) {
	return _Utils_eq(
		$author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$companyType(company),
		$elm$core$Maybe$Just(0)) ? $author$project$Utils$Html$empty : A2(
		$author$project$Ui$Alert$info,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Non-membership charges are not visible to '),
				A2(
				$author$project$Ui$Typography$strong,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$companyName(company))
					])),
				$elm$html$Html$text(' in the line items section. '),
				$elm$html$Html$text('Aggregate details by category are visible to '),
				A2(
				$author$project$Ui$Typography$strong,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$companyName(company))
					])),
				$elm$html$Html$text(' in the summary section. '),
				$elm$html$Html$text('This is configurable in the '),
				A3(
				$author$project$Ui$Link$route,
				$author$project$Spa$Generated$Route$Companies__CompanyId_String__InvoiceSettings(
					{
						fZ: $author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$companyId(company)
					}),
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('invoice settings')
					])),
				$elm$html$Html$text(' tab above.')
			]));
};
var $author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$viewForPractice = function (practice) {
	return A2(
		$author$project$Ui$Alert$info,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(12)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('In order to protect patient privacy all non-membership charge details are not visible. '),
								$elm$html$Html$text('Aggregate costs can be viewed in the summary section above by category of charge. '),
								$elm$html$Html$text('Please contact '),
								A2(
								$author$project$Ui$Typography$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Api$Practice$name(practice))
									])),
								$elm$html$Html$text(' for more info.')
							]))
					]))
			]));
};
var $author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$view = F3(
	function (session, practice, company) {
		return $author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$chargePhiDetailsEnabled(company) ? $author$project$Utils$Html$empty : ($author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$viewForPractice(practice) : $author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$viewForCompany(company));
	});
var $author$project$Components$Invoice$InvoiceLinesTable$viewCategoryResourceFilter = function (categoryResourceFilter) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Invoice$InvoiceLinesTable$CategoryResourceFilterMsg,
		A2($author$project$Components$ResourceFilter$Category$view, _List_Nil, categoryResourceFilter));
};
var $author$project$Components$Invoice$InvoiceLinesTable$EmployeeDivisionSelected = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Employer$EmployeeDivision$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Employer$EmployeeDivision$All$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$EmployeeDivision$Shared$name(shared);
};
var $author$project$Api$Provider$EmployeeDivision$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$EmployeeDivision$All$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$EmployeeDivision$Shared$name(shared);
};
var $author$project$Api$EmployeeDivision$All$name = function (employeeDivision) {
	if (!employeeDivision.$) {
		var employeeDivision_ = employeeDivision.a;
		return $author$project$Api$Provider$EmployeeDivision$All$name(employeeDivision_);
	} else {
		var employeeDivision_ = employeeDivision.a;
		return $author$project$Api$Employer$EmployeeDivision$All$name(employeeDivision_);
	}
};
var $author$project$Components$Invoice$InvoiceLinesTable$viewEmployeeDivisionDropdown = function (model) {
	var items = function () {
		var _v1 = model.zr;
		if (_v1.$ === 3) {
			var employeeDivisions = _v1.a;
			return A2(
				$elm$core$List$cons,
				A2(
					$author$project$Ui$Dropdown$item,
					_List_fromArray(
						[
							$author$project$Ui$Dropdown$onSelect(
							$author$project$Components$Invoice$InvoiceLinesTable$EmployeeDivisionSelected($elm$core$Maybe$Nothing))
						]),
					$elm$html$Html$text('All Divisions')),
				A2(
					$elm$core$List$cons,
					$author$project$Ui$Dropdown$separator,
					A2(
						$elm$core$List$map,
						function (division) {
							return A2(
								$author$project$Ui$Dropdown$item,
								_List_fromArray(
									[
										$author$project$Ui$Dropdown$onSelect(
										$author$project$Components$Invoice$InvoiceLinesTable$EmployeeDivisionSelected(
											$elm$core$Maybe$Just(division)))
									]),
								$elm$html$Html$text(
									$author$project$Api$EmployeeDivision$All$name(division)));
						},
						employeeDivisions)));
		} else {
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$Dropdown$item,
					_List_Nil,
					$elm$html$Html$text('Loading...'))
				]);
		}
	}();
	var currentLabel = function () {
		var _v0 = model.HA;
		if (!_v0.$) {
			var division = _v0.a;
			return $author$project$Api$EmployeeDivision$All$name(division);
		} else {
			return 'Division';
		}
	}();
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(currentLabel)
			]),
		items,
		model.nv);
};
var $author$project$Components$Invoice$InvoiceLinesTable$EditInvoiceLine = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$RemoveInvoiceLine = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Provider$InvoiceLine$Shared$amountInCents = function (_v0) {
	var record = _v0;
	return record.LE;
};
var $author$project$Api$Provider$InvoiceLine$All$amountInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$InvoiceLine$Shared$amountInCents(shared);
};
var $author$project$Api$Provider$InvoiceLine$All$categoryName = function (_v0) {
	var record = _v0.b;
	return record.Ns;
};
var $author$project$Api$Provider$InvoiceLine$All$chargeDescription = function (_v0) {
	var record = _v0.b;
	return record.Nw;
};
var $author$project$Api$Provider$InvoiceLine$All$charges = function (_v0) {
	var record = _v0.b;
	return record.NA;
};
var $author$project$Api$Provider$InvoiceLine$Shared$date = function (_v0) {
	var record = _v0;
	return record.PB;
};
var $author$project$Api$Provider$InvoiceLine$All$date = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$InvoiceLine$Shared$date(shared);
};
var $author$project$Api$Provider$InvoiceLine$All$dependentCount = function (_v0) {
	var record = _v0.b;
	return record.Ql;
};
var $author$project$Api$Provider$Charge$Meta$destroyAction = function (_v0) {
	var meta = _v0;
	return meta.vy.Qu;
};
var $author$project$Api$Provider$Charge$Meta$editAction = function (_v0) {
	var meta = _v0;
	return meta.vy.Q0;
};
var $author$project$Api$Provider$InvoiceLine$All$endDate = function (_v0) {
	var record = _v0.b;
	return record.sb;
};
var $author$project$Api$Invoice$Status$isDraft = function (status) {
	return _Utils_eq(status, $author$project$Api$Invoice$Status$Draft);
};
var $author$project$Api$Provider$Charge$ForInvoiceLineAll$isLocked = function (_v0) {
	var record = _v0;
	return record.UU;
};
var $author$project$Api$Provider$Charge$ForInvoiceLineAll$meta = function (_v0) {
	var record = _v0;
	return record.W4;
};
var $author$project$Ui$Table$NoBorder = {$: 1};
var $author$project$Ui$Table$noBorder = $author$project$Ui$Table$NoBorder;
var $author$project$Api$Provider$InvoiceLine$All$patientName = function (_v0) {
	var record = _v0.b;
	return record.Y1;
};
var $author$project$Api$Provider$InvoiceLine$All$plan = function (_v0) {
	var record = _v0.b;
	return record.Jb;
};
var $author$project$Api$Provider$InvoiceLine$All$shouldHideAmount = function (_v0) {
	var record = _v0.b;
	return record.abi;
};
var $author$project$Formatters$ChargeItemCode$ChargeItemForCharge = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$ToggleShowMore = {$: 0};
var $author$project$Api$Provider$InvoiceLine$All$createdBy = function (_v0) {
	var record = _v0.b;
	return record.O2;
};
var $author$project$Api$Provider$InvoiceLine$All$employeeDivision = function (_v0) {
	var record = _v0.b;
	return record.HA;
};
var $author$project$Api$Provider$Charge$One$issuedQuantityUom = function (_v0) {
	var record = _v0.b;
	return record.Vq;
};
var $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$humanizePriceAndQuantity = function (charge) {
	if (!charge.$) {
		var charge_ = charge.a;
		var priceUom = $author$project$Api$Provider$Charge$One$priceUom(charge_);
		var priceAndQuantity = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$author$project$Utils$Currency$fromInt,
				$author$project$Api$Provider$Charge$One$priceInCents(charge_)));
		if ($author$project$Api$Provider$Uom$Shared$type_(priceUom) === 'Time') {
			var priceUomName = $elm$core$String$toLower(
				$author$project$Api$Provider$Uom$Shared$name(priceUom));
			var issuedQuantityUomName = $elm$core$String$toLower(
				$author$project$Api$Provider$Uom$Shared$name(
					$author$project$Api$Provider$Charge$One$issuedQuantityUom(charge_)));
			var issuedUomNameAndQty = A2(
				$author$project$Formatters$String$pluralize,
				issuedQuantityUomName,
				$author$project$Api$Provider$Charge$One$quantity(charge_));
			return priceAndQuantity + ('/' + (priceUomName + (' x ' + issuedUomNameAndQty)));
		} else {
			return priceAndQuantity + (' x ' + $elm$core$String$fromInt(
				$author$project$Api$Provider$Charge$One$quantity(charge_)));
		}
	} else {
		return '';
	}
};
var $author$project$Api$Provider$Organization$Min$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$Session$Shared$organization = function (_v0) {
	var record = _v0;
	return record.Yr;
};
var $author$project$Ui$Icon$rotate180 = $author$project$Ui$Icon$Rotate(180);
var $author$project$Api$Provider$InvoiceLine$All$shouldShowMoreInfo = function (_v0) {
	var record = _v0.b;
	return record.abj;
};
var $author$project$Api$Provider$Session$Shared$user = function (_v0) {
	var record = _v0;
	return record.ad0;
};
var $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$viewCoverageDiscount = function (coverageDiscount) {
	var coverageRule = $author$project$Api$Provider$CoveredCharge$All$coverageRule(coverageDiscount);
	return A2(
		$author$project$Components$CoverageRuleDescription$view,
		$author$project$Components$CoverageRuleDescription$Shared(coverageRule),
		true);
};
var $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$viewField = F2(
	function (label, value) {
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$strong,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(label + ': ')
						])),
					$elm$html$Html$text(value)
				]));
	});
var $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$view = function (model) {
	return $author$project$Api$Provider$InvoiceLine$All$shouldShowMoreInfo(model.sN) ? A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				function () {
				var _v0 = model.p7 ? _Utils_Tuple2(
					'Less info ',
					$author$project$Ui$Icon$chevron(
						_List_fromArray(
							[$author$project$Ui$Icon$rotate180]))) : _Utils_Tuple2(
					'More info ',
					$author$project$Ui$Icon$chevronDown(_List_Nil));
				var verb = _v0.a;
				var icon = _v0.b;
				return A3(
					$author$project$Ui$Button$view,
					{mm: verb},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$sm,
							$author$project$Ui$Button$onClick($author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$ToggleShowMore)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(verb),
							icon
						]));
			}(),
				function () {
				if (model.p7) {
					var _v1 = function () {
						var _v2 = _Utils_Tuple3(
							$author$project$Api$Platform$Session$One$organizationIsCompany(model.aa4),
							model.gz,
							model.yU);
						if (_v2.b.$ === 3) {
							if ((!_v2.a) && (_v2.c.$ === 3)) {
								var _v3 = _v2.b;
								var invoiceLineDetails_ = _v3.a;
								var _v4 = _v2.c;
								var coverageDiscounts_ = _v4.a;
								return _Utils_Tuple2(
									$elm$core$Maybe$Just(invoiceLineDetails_),
									coverageDiscounts_);
							} else {
								var _v5 = _v2.b;
								var invoiceLineDetails_ = _v5.a;
								return _Utils_Tuple2(
									$elm$core$Maybe$Just(invoiceLineDetails_),
									_List_Nil);
							}
						} else {
							return _Utils_Tuple2($elm$core$Maybe$Nothing, _List_Nil);
						}
					}();
					var invoiceLineDetails = _v1.a;
					var coverageDiscounts = _v1.b;
					return A2(
						$author$project$Ui$Element$view,
						_List_Nil,
						function () {
							if (!invoiceLineDetails.$) {
								var invoiceLineDetails_ = invoiceLineDetails.a;
								var charge = $elm$core$List$head(
									$author$project$Api$Provider$InvoiceLine$One$charges(invoiceLineDetails_));
								var _v7 = function () {
									var _v8 = A2(
										$elm$core$Maybe$withDefault,
										$elm$core$Maybe$Nothing,
										A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$One$chargeItem, charge));
									if (!_v8.$) {
										var chargeItem = _v8.a;
										var manufacturer_ = $author$project$Api$Provider$ChargeItem$ForCharge$manufacturer(chargeItem);
										var code_ = $author$project$Formatters$ChargeItemCode$toString(
											$author$project$Formatters$ChargeItemCode$ChargeItemForCharge(chargeItem));
										return _Utils_Tuple2(code_, manufacturer_);
									} else {
										return _Utils_Tuple2('', '');
									}
								}();
								var code = _v7.a;
								var manufacturer = _v7.b;
								return _List_fromArray(
									[
										A2(
										$author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$viewField,
										'Description',
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$One$description, charge))),
										A2($author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$viewField, 'Code', code),
										A2($author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$viewField, 'Facility/Manufacturer', manufacturer),
										A2(
										$author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$viewField,
										'Provider',
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Maybe$map,
												$author$project$Api$Provider$Practitioner$Shared$name,
												A2($elm$core$Maybe$andThen, $author$project$Api$Provider$Charge$One$practitioner, charge)))),
										A2(
										$author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$viewField,
										'Location',
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Maybe$map,
												$author$project$Api$Provider$Location$Min$name,
												A2($elm$core$Maybe$andThen, $author$project$Api$Provider$Charge$One$location, charge)))),
										model.ad6 ? A2(
										$author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$viewField,
										'Division',
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Maybe$map,
												$author$project$Api$Provider$EmployeeDivision$Shared$name,
												$author$project$Api$Provider$InvoiceLine$All$employeeDivision(model.sN)))) : $author$project$Utils$Html$empty,
										A2(
										$author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$viewField,
										'Price & Quantity',
										$author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$humanizePriceAndQuantity(charge)),
										($elm$core$List$length(coverageDiscounts) > 0) ? A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
										A2(
											$elm$core$List$cons,
											A2(
												$author$project$Ui$Typography$strong,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Coverage: ')
													])),
											A2($elm$core$List$map, $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$viewCoverageDiscount, coverageDiscounts))) : $author$project$Utils$Html$empty,
										A2(
										$author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$viewField,
										'Added by',
										function () {
											var _v9 = $author$project$Api$Provider$InvoiceLine$All$createdBy(model.sN);
											if (!_v9.$) {
												var createdBy = _v9.a;
												return $author$project$Api$Provider$User$Min$name(
													$author$project$Api$Provider$Session$Shared$user(createdBy)) + (' from ' + A2(
													$elm$core$Maybe$withDefault,
													'N/A',
													A2(
														$elm$core$Maybe$map,
														$author$project$Api$Provider$Organization$Min$name,
														$author$project$Api$Provider$Session$Shared$organization(createdBy))));
											} else {
												return 'a recurring charge on the Plan';
											}
										}())
									]);
							} else {
								return _List_fromArray(
									[
										$author$project$Ui$Spinner$view(
										_List_fromArray(
											[$author$project$Ui$Spinner$extraSmall]))
									]);
							}
						}());
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Components$Invoice$InvoiceLinesTable$viewInvoiceLine = F2(
	function (model, invoiceLine) {
		var maybeCharge = $elm$core$List$head(
			$author$project$Api$Provider$InvoiceLine$All$charges(invoiceLine));
		var id = $author$project$Api$Provider$InvoiceLine$All$id(invoiceLine);
		var loading = A2($elm$core$Set$member, id, model.ef);
		var canEditCharge = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$Charge$Meta$editAction,
				A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$ForInvoiceLineAll$meta, maybeCharge)));
		var canDestroyCharge = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$Charge$Meta$destroyAction,
				A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$ForInvoiceLineAll$meta, maybeCharge)));
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Table$row,
				_List_Nil,
				$elm$core$List$concat(
					_List_fromArray(
						[
							_List_fromArray(
							[
								A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2(
											$author$project$Formatters$Date$toString,
											$author$project$Formatters$Date$Full,
											$author$project$Api$Provider$InvoiceLine$All$date(invoiceLine))),
										function () {
										var _v0 = $author$project$Api$Provider$InvoiceLine$All$endDate(invoiceLine);
										if (!_v0.$) {
											var endDate = _v0.a;
											return A2(
												$author$project$Ui$Typography$text,
												_List_Nil,
												' - ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, endDate));
										} else {
											return $author$project$Utils$Html$empty;
										}
									}()
									])),
								A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$text,
										_List_fromArray(
											[
												$author$project$Ui$Typography$phi(true)
											]),
										$author$project$Api$Provider$InvoiceLine$All$patientName(invoiceLine)),
										($author$project$Api$Provider$InvoiceLine$All$dependentCount(invoiceLine) > 0) ? A2(
										$author$project$Ui$Typography$text,
										_List_fromArray(
											[
												$author$project$Ui$Typography$small,
												$author$project$Ui$Typography$gray,
												$author$project$Ui$Typography$phi(true)
											]),
										' + ' + A2(
											$author$project$Formatters$String$pluralize,
											'dependent',
											$author$project$Api$Provider$InvoiceLine$All$dependentCount(invoiceLine))) : $author$project$Utils$Html$empty
									])),
								A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Api$Provider$InvoiceLine$All$chargeDescription(invoiceLine))
									]))
							]),
							$author$project$Components$Invoice$InvoiceLinesTable$allowCustomMembershipPlan(model.afQ) ? _List_fromArray(
							[
								A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Maybe$map,
												$author$project$Api$Provider$Plan$Shared$name,
												$author$project$Api$Provider$InvoiceLine$All$plan(invoiceLine))))
									]))
							]) : _List_Nil,
							_List_fromArray(
							[
								A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2(
											$elm$core$Maybe$withDefault,
											'Unassigned',
											$author$project$Api$Provider$InvoiceLine$All$categoryName(invoiceLine)))
									])),
								A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$fontBold, $author$project$Ui$Element$textRight]),
										_List_fromArray(
											[
												$author$project$Api$Provider$InvoiceLine$All$shouldHideAmount(invoiceLine) ? $author$project$Utils$Html$empty : $elm$html$Html$text(
												$author$project$Utils$Currency$fromInt(
													$author$project$Api$Provider$InvoiceLine$All$amountInCents(invoiceLine)))
											]))
									])),
								A2(
								$author$project$Ui$Table$cell,
								_List_fromArray(
									[$author$project$Ui$Table$textRight]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$gap2, $author$project$Ui$Element$justifyRight]),
										_List_fromArray(
											[
												((!$author$project$Utils$Maybe$toBool(
												$author$project$Api$Provider$InvoiceLine$All$plan(invoiceLine))) && A2(
												$elm$core$Maybe$withDefault,
												false,
												A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$ForInvoiceLineAll$isLocked, maybeCharge))) ? A3(
												$author$project$Ui$Popover$view,
												_List_Nil,
												_List_fromArray(
													[
														A3(
														$author$project$Ui$Button$view,
														{mm: 'This charge\'s reporting period is locked. And admin must unlock it to edit this charge.'},
														_List_fromArray(
															[
																$author$project$Ui$Button$disabled(true),
																$author$project$Ui$Button$sm,
																$author$project$Ui$Button$icon($author$project$Ui$Icon$lock)
															]),
														_List_Nil)
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Popover$heading,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Locked')
															])),
														A2(
														$author$project$Ui$Popover$body,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('An admin must unlock this charge\'s reporting period before editing this charge.')
															]))
													])) : $author$project$Utils$Html$empty,
												((!$author$project$Api$Platform$Session$One$organizationIsCompany(model.aa4)) && ((!$author$project$Utils$Maybe$toBool(
												$author$project$Api$Provider$InvoiceLine$All$plan(invoiceLine))) && ((!A2(
												$elm$core$Maybe$withDefault,
												false,
												A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$ForInvoiceLineAll$isLocked, maybeCharge))) && canEditCharge))) ? A3(
												$author$project$Ui$Button$view,
												{mm: 'Edit invoice line'},
												_List_fromArray(
													[
														$author$project$Ui$Button$link,
														$author$project$Ui$Button$sm,
														$author$project$Ui$Button$loading(loading),
														$author$project$Ui$Button$onClick(
														$author$project$Components$Invoice$InvoiceLinesTable$EditInvoiceLine(invoiceLine)),
														$author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Edit')
													])) : $author$project$Utils$Html$empty,
												((!$author$project$Api$Platform$Session$One$organizationIsCompany(model.aa4)) && ((!$author$project$Utils$Maybe$toBool(
												$author$project$Api$Provider$InvoiceLine$All$plan(invoiceLine))) && ($author$project$Api$Invoice$Status$isDraft(
												$author$project$Api$Invoice$One$humanStatus(model.Uk)) && canDestroyCharge))) ? A3(
												$author$project$Ui$Button$view,
												{mm: 'Delete invoice line'},
												_List_fromArray(
													[
														$author$project$Ui$Button$link,
														$author$project$Ui$Button$sm,
														$author$project$Ui$Button$loading(loading),
														$author$project$Ui$Button$onClick(
														$author$project$Components$Invoice$InvoiceLinesTable$RemoveInvoiceLine(invoiceLine)),
														$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Delete')
													])) : $author$project$Utils$Html$empty
											]))
									]))
							])
						]))),
				A2(
				$author$project$Ui$Table$row,
				_List_fromArray(
					[$author$project$Ui$Table$noBorder]),
				_List_fromArray(
					[
						A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
						A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
						A2(
						$author$project$Ui$Table$cell,
						_List_fromArray(
							[
								$author$project$Ui$Table$colspan(5)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfoMsg(id),
								A2(
									$elm$core$Maybe$withDefault,
									$author$project$Utils$Html$empty,
									A2(
										$elm$core$Maybe$map,
										$author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$view,
										A2($elm$core$Dict$get, id, model.eS))))
							]))
					]))
			]);
	});
var $author$project$Components$Invoice$InvoiceLinesTable$viewPlanResourceFilter = function (planResourceFilter) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Invoice$InvoiceLinesTable$PlanResourceFilterMsg,
		A2($author$project$Components$ResourceFilter$Plan$view, _List_Nil, planResourceFilter));
};
var $author$project$Components$Invoice$InvoiceLinesTable$viewInvoiceLines = function (model) {
	var invoiceMeta = $author$project$Api$Invoice$One$meta(model.Uk);
	var _v0 = function () {
		var _v1 = model.aO;
		if (_v1.$ === 3) {
			var invoiceLines_ = _v1.a;
			return _Utils_Tuple2(false, invoiceLines_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var invoiceLines = _v0.b;
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						function () {
						if (model.DJ) {
							var companyType_ = $author$project$Components$Invoice$InvoiceLinesTable$companyType(model.afQ);
							return $author$project$Ui$Typography$headingSm(
								_List_fromArray(
									[
										$elm$html$Html$text('Enrolled '),
										$elm$html$Html$text(
										A2($author$project$Formatters$String$affiliateMember, 'Employees & Dependents', companyType_))
									]));
						} else {
							return $author$project$Ui$Typography$headingSm(
								_List_fromArray(
									[
										$elm$html$Html$text('Line Items')
									]));
						}
					}(),
						A2(
						$author$project$Ui$Grid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$span(3)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Components$Invoice$InvoiceLinesTable$SearchInputMsg,
										A2(
											$author$project$Ui$SearchInput$view,
											_List_fromArray(
												[
													$author$project$Ui$SearchInput$phi(true),
													$author$project$Ui$SearchInput$placeholder('Search by employee name or amount'),
													$author$project$Ui$SearchInput$loading(loading)
												]),
											model.up))
									])),
								function () {
								var _v2 = model.Uv;
								if (!_v2.$) {
									return $author$project$Ui$Grid$none;
								} else {
									return A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(2)
											]),
										_List_fromArray(
											[
												$author$project$Components$Invoice$InvoiceLinesTable$viewCategoryResourceFilter(model.c8)
											]));
								}
							}(),
								function () {
								var _v3 = model.hi;
								if (!_v3.$) {
									var planResourceFilter = _v3.a;
									return A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(2)
											]),
										_List_fromArray(
											[
												$author$project$Components$Invoice$InvoiceLinesTable$viewPlanResourceFilter(planResourceFilter)
											]));
								} else {
									return $author$project$Ui$Grid$none;
								}
							}(),
								$author$project$Components$Invoice$InvoiceLinesTable$usesEmployeeDivisions(model.afQ) ? A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$span(2)
									]),
								_List_fromArray(
									[
										$author$project$Components$Invoice$InvoiceLinesTable$viewEmployeeDivisionDropdown(model)
									])) : $author$project$Ui$Grid$none,
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$span(3)
									]),
								_List_fromArray(
									[
										function () {
										if ((!$author$project$Api$Platform$Session$One$organizationIsCompany(model.aa4)) && ($author$project$Api$Invoice$Meta$canAdjustAction(invoiceMeta) && (!$author$project$Api$Invoice$Meta$reportingPeriodIsLocked(invoiceMeta)))) {
											var verb = model.DJ ? 'Add Charge or Adjustment' : 'Add Charge';
											return A3(
												$author$project$Ui$Button$view,
												{mm: verb},
												_List_fromArray(
													[
														$author$project$Ui$Button$onClick($author$project$Components$Invoice$InvoiceLinesTable$AddInvoiceLine),
														$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(verb)
													]));
										} else {
											return $author$project$Utils$Html$empty;
										}
									}(),
										$author$project$Api$Invoice$Meta$reportingPeriodIsLocked(invoiceMeta) ? A3(
										$author$project$Ui$Popover$view,
										_List_Nil,
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Button$view,
												{mm: 'Add charge or adjustment'},
												_List_fromArray(
													[
														$author$project$Ui$Button$disabled(true),
														$author$project$Ui$Button$fullWidth(true),
														$author$project$Ui$Button$icon($author$project$Ui$Icon$lock)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Add Charge or Adjustment')
													]))
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Popover$heading,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Locked')
													])),
												A2(
												$author$project$Ui$Popover$body,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('An admin must unlock this invoice\'s reporting period before adding charges or adjustments.')
													]))
											])) : $author$project$Utils$Html$empty
									]))
							]))
					])),
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$view,
						model.aa4,
						model.ZV,
						$author$project$Components$Invoice$InvoiceLinesTable$phiAlertCompany(model.afQ))
					])),
				A4(
				$author$project$Ui$Panel$table,
				_List_fromArray(
					[
						$author$project$Ui$Table$loading(loading),
						$author$project$Ui$Table$zeroState(
						_List_fromArray(
							[
								$elm$html$Html$text('No matching results.')
							])),
						$author$project$Ui$Table$test('invoice-lines')
					]),
				_Utils_ap(
					A2(
						$elm$core$List$map,
						$author$project$Api$Column$view(
							A2($author$project$Api$Column$Sortable, model.alA, $author$project$Components$Invoice$InvoiceLinesTable$SortTable)),
						$author$project$Components$Invoice$InvoiceLinesTable$columns(model.afQ)),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$header,
							_List_Nil,
							_List_fromArray(
								[$author$project$Utils$Html$empty]))
						])),
				A2(
					$elm$core$List$concatMap,
					$author$project$Components$Invoice$InvoiceLinesTable$viewInvoiceLine(model),
					invoiceLines),
				_List_Nil),
				A2(
				$author$project$Ui$Panel$footer,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Components$Invoice$InvoiceLinesTable$PaginationMsg,
						A2(
							$author$project$Api$Pagination$view,
							_List_fromArray(
								[
									$author$project$Ui$Pagination$List$loading(loading)
								]),
							model.ajJ))
					]))
			]));
};
var $author$project$Components$Invoice$InvoiceLinesTable$view = F2(
	function (apiClient, model) {
		var invoiceMeta = $author$project$Api$Invoice$One$meta(model.Uk);
		return _List_fromArray(
			[
				$author$project$Api$Platform$Session$One$organizationIsCompany(model.aa4) ? $elm$html$Html$text('') : A2(
				$elm$html$Html$map,
				$author$project$Components$Invoice$InvoiceLinesTable$ExportCsvMsg,
				A3(
					$author$project$Components$ExportCsv$modal,
					apiClient,
					_List_fromArray(
						[
							$author$project$Components$ExportCsv$report(
							$author$project$Api$Data$totalCount(model.aO)),
							$author$project$Components$ExportCsv$reportParams(
							$author$project$Components$Invoice$InvoiceLinesTable$reportParams(model))
						]),
					model.nD)),
				$author$project$Api$Invoice$Meta$hideChargeDetailsAction(invoiceMeta) ? $author$project$Utils$Html$empty : $author$project$Components$Invoice$InvoiceLinesTable$viewInvoiceLines(model)
			]);
	});
var $author$project$Components$Invoice$Summary$OtherChargesSummaryMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Common$Invoice$Summary$Grouped$activeLinesRows = function (_v0) {
	var record = _v0;
	return record.KP.aac;
};
var $author$project$Api$Common$Invoice$Summary$byEmployeeDivision = function (_v0) {
	var record = _v0;
	return record.M$;
};
var $author$project$Api$Common$Invoice$Summary$byPlan = function (_v0) {
	var record = _v0;
	return record.M0;
};
var $author$project$Api$Common$Invoice$Summary$bySponsor = function (_v0) {
	var record = _v0;
	return record.M1;
};
var $author$project$Components$Invoice$Summary$activeLinesFor = F2(
	function (summary, groupBy_) {
		switch (groupBy_) {
			case 0:
				return A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						$author$project$Api$Common$Invoice$Summary$Grouped$activeLinesRows,
						$author$project$Api$Common$Invoice$Summary$byPlan(summary)));
			case 1:
				return A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						$author$project$Api$Common$Invoice$Summary$Grouped$activeLinesRows,
						$author$project$Api$Common$Invoice$Summary$byEmployeeDivision(summary)));
			default:
				return A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						$author$project$Api$Common$Invoice$Summary$Grouped$activeLinesRows,
						$author$project$Api$Common$Invoice$Summary$bySponsor(summary)));
		}
	});
var $author$project$Api$Employer$Invoice$One$discountSavingsInCents = function (_v0) {
	var record = _v0.b;
	return record.QH;
};
var $author$project$Api$Provider$Invoice$One$discountSavingsInCents = function (_v0) {
	var record = _v0.b;
	return record.QH;
};
var $author$project$Api$Invoice$One$discountSavingsInCents = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$One$discountSavingsInCents(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$One$discountSavingsInCents(invoice_);
	}
};
var $author$project$Api$Common$Invoice$Summary$membershipAdjustmentLines = function (_v0) {
	var record = _v0;
	return record.WO;
};
var $author$project$Api$Common$Invoice$Summary$Grouped$membershipAdjustmentLinesRows = function (_v0) {
	var record = _v0;
	return record.WO.aac;
};
var $author$project$Components$Invoice$Summary$membershipAdjustmentLinesFor = F2(
	function (summary, groupBy_) {
		switch (groupBy_) {
			case 0:
				return A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						$author$project$Api$Common$Invoice$Summary$Grouped$membershipAdjustmentLinesRows,
						$author$project$Api$Common$Invoice$Summary$byPlan(summary)));
			case 1:
				return A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						$author$project$Api$Common$Invoice$Summary$Grouped$membershipAdjustmentLinesRows,
						$author$project$Api$Common$Invoice$Summary$byEmployeeDivision(summary)));
			default:
				return A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						$author$project$Api$Common$Invoice$Summary$Grouped$membershipAdjustmentLinesRows,
						$author$project$Api$Common$Invoice$Summary$bySponsor(summary)));
		}
	});
var $author$project$Api$Common$Invoice$Summary$AllLines$totalAmountInCents = function (_v0) {
	var record = _v0;
	return A2($elm$core$Maybe$withDefault, 0, record.FW.LE);
};
var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalCount = function (_v0) {
	var record = _v0;
	return record.FW.OK;
};
var $author$project$Api$Common$Invoice$Summary$byCategory = function (_v0) {
	var record = _v0;
	return record.M_;
};
var $author$project$Api$Common$Invoice$Summary$ByCategory$nonMembershipAdjustmentLinesRows = function (_v0) {
	var record = _v0;
	return record.XX.aac;
};
var $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Row$amountInCents = function (_v0) {
	var record = _v0;
	return record.LE;
};
var $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Row$categoryName = function (_v0) {
	var record = _v0;
	return record.Ns;
};
var $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Row$count = function (_v0) {
	var record = _v0;
	return record.OK;
};
var $author$project$Ui$Typography$Subtotal = {$: 17};
var $author$project$Ui$Typography$subtotal = $author$project$Ui$Typography$Subtotal;
var $author$project$Components$Invoice$Summary$OtherChargesSummary$viewNonMembershipAdjustmentLine = F2(
	function (model, nonMembershipAdjustmentLineRow) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(3)
								]),
							_List_fromArray(
								[
									model.DJ ? A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$info, $author$project$Ui$Typography$subtotal]),
									A2(
										$elm$core$Maybe$withDefault,
										'Unassigned',
										$author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Row$categoryName(nonMembershipAdjustmentLineRow))) : $elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'Unassigned',
										$author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Row$categoryName(nonMembershipAdjustmentLineRow)))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(4)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$String$pluralize,
										'charge',
										$author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Row$count(nonMembershipAdjustmentLineRow)))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(5)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textRight]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$text,
											_List_Nil,
											$author$project$Utils$Currency$fromInt(
												$author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Row$amountInCents(nonMembershipAdjustmentLineRow)))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Invoice$Summary$OtherChargesSummary$viewNonRecurringSummary = F2(
	function (summary, model) {
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					function () {
					var nonMembershipAdjustmentLines = A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							$author$project$Api$Common$Invoice$Summary$ByCategory$nonMembershipAdjustmentLinesRows,
							$author$project$Api$Common$Invoice$Summary$byCategory(summary)));
					return A2(
						$author$project$Ui$Element$view,
						_List_Nil,
						A2(
							$elm$core$List$map,
							$author$project$Components$Invoice$Summary$OtherChargesSummary$viewNonMembershipAdjustmentLine(model),
							nonMembershipAdjustmentLines));
				}()
				]));
	});
var $author$project$Components$Invoice$Summary$OtherChargesSummary$ToggleShowGroupCharges = 0;
var $author$project$Api$Common$Invoice$Summary$nonMembershipAdjustmentLines = function (_v0) {
	var record = _v0;
	return record.XX;
};
var $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$totalAmountInCents = function (_v0) {
	var record = _v0;
	return A2($elm$core$Maybe$withDefault, 0, record.FW.LE);
};
var $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$totalCount = function (_v0) {
	var record = _v0;
	return record.FW.OK;
};
var $author$project$Components$Invoice$Summary$OtherChargesSummary$viewRecurringSummary = F2(
	function (summary, model) {
		var _v0 = model.hG ? _Utils_Tuple2($author$project$Ui$Icon$minus, 'Hide group charges') : _Utils_Tuple2($author$project$Ui$Icon$add, 'Show group charges');
		var icon = _v0.a;
		var ariaLabel = _v0.b;
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					($author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$totalCount(
					$author$project$Api$Common$Invoice$Summary$nonMembershipAdjustmentLines(summary)) > 0) ? A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(3)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_Nil,
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Button$view,
													{mm: ariaLabel},
													_List_fromArray(
														[
															$author$project$Ui$Button$link,
															$author$project$Ui$Button$onClick(0),
															$author$project$Ui$Button$icon(icon)
														]),
													_List_Nil),
													$author$project$Utils$Html$noBreakSpace,
													A2(
													$author$project$Ui$Typography$strong,
													_List_fromArray(
														[$author$project$Ui$Typography$info]),
													_List_fromArray(
														[
															$elm$html$Html$text('Other Charges')
														]))
												]))
										])),
									model.hG ? $author$project$Ui$Grid$none : A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(4)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$text,
											_List_Nil,
											A2(
												$author$project$Formatters$String$pluralize,
												'charge',
												$author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$totalCount(
													$author$project$Api$Common$Invoice$Summary$nonMembershipAdjustmentLines(summary))))
										])),
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(5)
										]),
									model.hG ? _List_fromArray(
										[$author$project$Utils$Html$empty]) : _List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$textRight]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$text,
													_List_fromArray(
														[$author$project$Ui$Typography$bold]),
													$author$project$Utils$Currency$fromInt(
														$author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$totalAmountInCents(
															$author$project$Api$Common$Invoice$Summary$nonMembershipAdjustmentLines(summary))))
												]))
										]))
								]))
						])) : $author$project$Utils$Html$empty,
					function () {
					if (model.hG) {
						var nonMembershipAdjustmentLines = A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								$author$project$Api$Common$Invoice$Summary$ByCategory$nonMembershipAdjustmentLinesRows,
								$author$project$Api$Common$Invoice$Summary$byCategory(summary)));
						return A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							A2(
								$elm$core$List$map,
								$author$project$Components$Invoice$Summary$OtherChargesSummary$viewNonMembershipAdjustmentLine(model),
								nonMembershipAdjustmentLines));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]));
	});
var $author$project$Components$Invoice$Summary$OtherChargesSummary$view = F2(
	function (summary, model) {
		return model.DJ ? A2($author$project$Components$Invoice$Summary$OtherChargesSummary$viewRecurringSummary, summary, model) : A2($author$project$Components$Invoice$Summary$OtherChargesSummary$viewNonRecurringSummary, summary, model);
	});
var $author$project$Api$Common$Invoice$Summary$ActiveLines$Row$amountInCents = function (_v0) {
	var record = _v0;
	return record.LE;
};
var $author$project$Api$Common$Invoice$Summary$ActiveLines$Row$companyName = function (_v0) {
	var record = _v0;
	return record.Og;
};
var $author$project$Api$Common$Invoice$Summary$ActiveLines$Row$count = function (_v0) {
	var record = _v0;
	return record.OK;
};
var $author$project$Api$Common$Invoice$Summary$ActiveLines$Row$divisionName = function (_v0) {
	var record = _v0;
	return record.QQ;
};
var $author$project$Components$Invoice$Summary$groupName = F5(
	function (groupBy_, activeLineRow, divisionName, planName, companyName) {
		switch (groupBy_) {
			case 1:
				return A2(
					$elm$core$Maybe$withDefault,
					'No Division',
					divisionName(activeLineRow));
			case 0:
				return A2(
					$elm$core$Maybe$withDefault,
					'No Plan',
					planName(activeLineRow));
			default:
				return A2(
					$elm$core$Maybe$withDefault,
					'No Sponsor',
					companyName(activeLineRow));
		}
	});
var $author$project$Api$Common$Invoice$Summary$ActiveLines$Row$numberOfDependents = function (_v0) {
	var record = _v0;
	return record.X2;
};
var $author$project$Api$Common$Invoice$Summary$ActiveLines$Row$planName = function (_v0) {
	var record = _v0;
	return record.ZE;
};
var $author$project$Components$Invoice$Summary$viewActiveLine = F3(
	function (companyType_, groupBy_, activeLineRow) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(3)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$info, $author$project$Ui$Typography$subtotal]),
									A5($author$project$Components$Invoice$Summary$groupName, groupBy_, activeLineRow, $author$project$Api$Common$Invoice$Summary$ActiveLines$Row$divisionName, $author$project$Api$Common$Invoice$Summary$ActiveLines$Row$planName, $author$project$Api$Common$Invoice$Summary$ActiveLines$Row$companyName))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(4)
								]),
							_List_fromArray(
								[
									($author$project$Api$Common$Invoice$Summary$ActiveLines$Row$count(activeLineRow) > 0) ? A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$author$project$Formatters$String$pluralize,
												A2($author$project$Formatters$String$affiliateMember, 'employee', companyType_),
												$author$project$Api$Common$Invoice$Summary$ActiveLines$Row$count(activeLineRow))),
											($author$project$Api$Common$Invoice$Summary$ActiveLines$Row$numberOfDependents(activeLineRow) > 0) ? $elm$html$Html$text(
											' and ' + A2(
												$author$project$Formatters$String$pluralize,
												'dependent',
												$author$project$Api$Common$Invoice$Summary$ActiveLines$Row$numberOfDependents(activeLineRow))) : $author$project$Utils$Html$empty
										])) : $author$project$Utils$Html$empty
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(5)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textRight]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$text,
											_List_Nil,
											$author$project$Utils$Currency$fromInt(
												$author$project$Api$Common$Invoice$Summary$ActiveLines$Row$amountInCents(activeLineRow)))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Invoice$Summary$GroupByUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Invoice$Summary$viewGroupByButton = F3(
	function (currentGroupBy, groupBy_, label) {
		return A3(
			$author$project$Ui$Button$view,
			{mm: label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(currentGroupBy, groupBy_)),
					$author$project$Ui$Button$onClick(
					$author$project$Components$Invoice$Summary$GroupByUpdated(groupBy_))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Components$Invoice$Summary$viewGroupByButtonGroup = function (model) {
	var summary = model.acF;
	var _v0 = model.gx;
	if (!_v0.$) {
		var groupBy_ = _v0.a;
		return ($author$project$Components$Invoice$Summary$companyAllowCustomMembershipPlan(model.afQ) && ($author$project$Components$Invoice$Summary$companyUsesEmployeeDivisions(model.afQ) && $elm$core$List$isEmpty(
			$author$project$Api$Common$Invoice$Summary$sponsorFeeDealLines(summary)))) ? $author$project$Ui$Button$group(
			_List_fromArray(
				[
					A3($author$project$Components$Invoice$Summary$viewGroupByButton, groupBy_, 0, 'By Plan'),
					A3($author$project$Components$Invoice$Summary$viewGroupByButton, groupBy_, 1, 'By Division')
				])) : (($author$project$Components$Invoice$Summary$companyAllowCustomMembershipPlan(model.afQ) && A3($author$project$Components$Invoice$Summary$showSponsorBreakdown, model.Uv, model.aa4, model.afQ)) ? $author$project$Ui$Button$group(
			_List_fromArray(
				[
					A3($author$project$Components$Invoice$Summary$viewGroupByButton, groupBy_, 0, 'By Plan'),
					A3($author$project$Components$Invoice$Summary$viewGroupByButton, groupBy_, 2, 'By Sponsor')
				])) : $author$project$Utils$Html$empty);
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$amountInCents = function (_v0) {
	var record = _v0;
	return record.LE;
};
var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$companyName = function (_v0) {
	var record = _v0;
	return record.Og;
};
var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$count = function (_v0) {
	var record = _v0;
	return record.OK;
};
var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$divisionName = function (_v0) {
	var record = _v0;
	return record.QQ;
};
var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$numberOfMembershipCharges = function (_v0) {
	var record = _v0;
	return record.X4;
};
var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$numberOfOtherCharges = function (_v0) {
	var record = _v0;
	return record.X5;
};
var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$planName = function (_v0) {
	var record = _v0;
	return record.ZE;
};
var $author$project$Components$Invoice$Summary$viewMembershipAdjustmentLine = F2(
	function (groupBy_, membershipAdjustmentLineRow) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(3)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$info, $author$project$Ui$Typography$subtotal]),
									A5($author$project$Components$Invoice$Summary$groupName, groupBy_, membershipAdjustmentLineRow, $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$divisionName, $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$planName, $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$companyName))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(4)
								]),
							_List_fromArray(
								[
									($author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$numberOfOtherCharges(membershipAdjustmentLineRow) > 0) ? $elm$html$Html$text(
									$elm$core$String$fromInt(
										$author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$numberOfOtherCharges(membershipAdjustmentLineRow)) + ' manual') : $author$project$Utils$Html$empty,
									$author$project$Utils$Html$noBreakSpace,
									(($author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$numberOfOtherCharges(membershipAdjustmentLineRow) > 0) && ($author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$numberOfMembershipCharges(membershipAdjustmentLineRow) > 0)) ? $elm$html$Html$text(
									$elm$core$String$fromInt(
										$author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$numberOfMembershipCharges(membershipAdjustmentLineRow)) + 'and ') : $author$project$Utils$Html$empty,
									($author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$numberOfMembershipCharges(membershipAdjustmentLineRow) > 0) ? $elm$html$Html$text(
									$elm$core$String$fromInt(
										$author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$numberOfMembershipCharges(membershipAdjustmentLineRow)) + ' automated') : $author$project$Utils$Html$empty,
									$author$project$Utils$Html$noBreakSpace,
									($author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$count(membershipAdjustmentLineRow) === 1) ? $elm$html$Html$text('adjustment') : $elm$html$Html$text('adjustments')
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(5)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textRight]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$text,
											_List_Nil,
											$author$project$Utils$Currency$fromInt(
												$author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$amountInCents(membershipAdjustmentLineRow)))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Invoice$Summary$ToggleShowGroupAdjustments = {$: 2};
var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalAmountInCents = function (_v0) {
	var record = _v0;
	return record.FW.LE;
};
var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalNumberOfMembershipCharges = function (_v0) {
	var record = _v0;
	return record.FW.X4;
};
var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalNumberOfOtherCharges = function (_v0) {
	var record = _v0;
	return record.FW.X5;
};
var $author$project$Components$Invoice$Summary$viewMembershipAdjustmentSummary = F2(
	function (model, summary) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(3)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											function () {
											var _v0 = model.gx;
											if (!_v0.$) {
												return A3(
													$author$project$Ui$Button$view,
													{mm: 'Show group adjustments'},
													_List_fromArray(
														[
															$author$project$Ui$Button$link,
															$author$project$Ui$Button$onClick($author$project$Components$Invoice$Summary$ToggleShowGroupAdjustments),
															$author$project$Ui$Button$icon(
															model.hF ? $author$project$Ui$Icon$minus : $author$project$Ui$Icon$add)
														]),
													_List_Nil);
											} else {
												return $author$project$Utils$Html$empty;
											}
										}(),
											A2(
											$author$project$Ui$Typography$strong,
											_List_fromArray(
												[$author$project$Ui$Typography$info]),
											_List_fromArray(
												[
													$elm$html$Html$text(' Membership Adjustments')
												]))
										]))
								])),
							model.hF ? $author$project$Ui$Grid$none : A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(4)
								]),
							_List_fromArray(
								[
									($author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalCount(
									$author$project$Api$Common$Invoice$Summary$membershipAdjustmentLines(summary)) > 0) ? A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											($author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalNumberOfOtherCharges(
											$author$project$Api$Common$Invoice$Summary$membershipAdjustmentLines(summary)) > 0) ? $elm$html$Html$text(
											$elm$core$String$fromInt(
												$author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalNumberOfOtherCharges(
													$author$project$Api$Common$Invoice$Summary$membershipAdjustmentLines(summary))) + ' manual') : $author$project$Utils$Html$empty,
											$author$project$Utils$Html$noBreakSpace,
											(($author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalNumberOfOtherCharges(
											$author$project$Api$Common$Invoice$Summary$membershipAdjustmentLines(summary)) > 0) && ($author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalNumberOfMembershipCharges(
											$author$project$Api$Common$Invoice$Summary$membershipAdjustmentLines(summary)) > 0)) ? $elm$html$Html$text('and ') : $author$project$Utils$Html$empty,
											($author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalNumberOfMembershipCharges(
											$author$project$Api$Common$Invoice$Summary$membershipAdjustmentLines(summary)) > 0) ? $elm$html$Html$text(
											$elm$core$String$fromInt(
												$author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalNumberOfMembershipCharges(
													$author$project$Api$Common$Invoice$Summary$membershipAdjustmentLines(summary))) + ' automated') : $author$project$Utils$Html$empty,
											$author$project$Utils$Html$noBreakSpace,
											($author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalCount(
											$author$project$Api$Common$Invoice$Summary$membershipAdjustmentLines(summary)) === 1) ? $elm$html$Html$text('adjustment') : $elm$html$Html$text('adjustments')
										])) : $author$project$Utils$Html$empty
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(5)
								]),
							_List_fromArray(
								[
									model.hF ? $author$project$Utils$Html$empty : A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textRight]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[$author$project$Ui$Typography$bold]),
											$author$project$Utils$Currency$fromInt(
												$author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalAmountInCents(
													$author$project$Api$Common$Invoice$Summary$membershipAdjustmentLines(summary))))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Invoice$Summary$ShowDeltaModal = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Invoice$Summary$ToggleShowGroups = {$: 1};
var $author$project$Api$Common$Invoice$Summary$activeLines = function (_v0) {
	var record = _v0;
	return record.KP;
};
var $author$project$Api$Common$Invoice$Summary$ActiveLines$totalAmountInCents = function (_v0) {
	var record = _v0;
	return A2($elm$core$Maybe$withDefault, 0, record.FW.LE);
};
var $author$project$Api$Common$Invoice$Summary$ActiveLines$totalCount = function (_v0) {
	var record = _v0;
	return record.FW.OK;
};
var $author$project$Api$Common$Invoice$Summary$ActiveLines$totalNumberOfDependents = function (_v0) {
	var record = _v0;
	return A2($elm$core$Maybe$withDefault, 0, record.FW.X2);
};
var $author$project$Ui$Icon$TrendingDown = 71;
var $author$project$Ui$Icon$trendingDown = $author$project$Ui$Icon$viewIcon(71);
var $author$project$Ui$Icon$TrendingUp = 70;
var $author$project$Ui$Icon$trendingUp = $author$project$Ui$Icon$viewIcon(70);
var $author$project$Components$Invoice$Summary$viewRecurringSummary = function (model) {
	var summary = model.acF;
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$span(3)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									function () {
									var _v0 = model.gx;
									if (!_v0.$) {
										return A3(
											$author$project$Ui$Button$view,
											{mm: 'Toggle group visibility'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick($author$project$Components$Invoice$Summary$ToggleShowGroups),
													$author$project$Ui$Button$icon(
													model.hH ? $author$project$Ui$Icon$minus : $author$project$Ui$Icon$add)
												]),
											_List_Nil);
									} else {
										return $author$project$Utils$Html$empty;
									}
								}(),
									A2(
									$author$project$Ui$Typography$strong,
									_List_fromArray(
										[$author$project$Ui$Typography$info]),
									_List_fromArray(
										[
											$elm$html$Html$text(' Current Period')
										]))
								]))
						])),
					model.hH ? $author$project$Ui$Grid$none : A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$span(3)
						]),
					function () {
						if ($author$project$Api$Common$Invoice$Summary$ActiveLines$totalCount(
							$author$project$Api$Common$Invoice$Summary$activeLines(summary)) > 0) {
							var companyType_ = $author$project$Components$Invoice$Summary$companyType(model.afQ);
							return _List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$String$pluralize,
										A2($author$project$Formatters$String$affiliateMember, 'employee', companyType_),
										$author$project$Api$Common$Invoice$Summary$ActiveLines$totalCount(
											$author$project$Api$Common$Invoice$Summary$activeLines(summary)))),
									($author$project$Api$Common$Invoice$Summary$ActiveLines$totalNumberOfDependents(
									$author$project$Api$Common$Invoice$Summary$activeLines(summary)) > 0) ? $elm$html$Html$text(
									' and ' + A2(
										$author$project$Formatters$String$pluralize,
										'dependent',
										$author$project$Api$Common$Invoice$Summary$ActiveLines$totalNumberOfDependents(
											$author$project$Api$Common$Invoice$Summary$activeLines(summary)))) : $author$project$Utils$Html$empty
								]);
						} else {
							return _List_Nil;
						}
					}()),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$span(4)
						]),
					_List_fromArray(
						[
							function () {
							var _v1 = model.zb;
							if (_v1.$ === 3) {
								var delta = _v1.a;
								return ($elm$core$List$isEmpty(
									$author$project$Api$Common$Invoice$Delta$added(delta)) && $elm$core$List$isEmpty(
									$author$project$Api$Common$Invoice$Delta$removed(delta))) ? $author$project$Utils$Html$empty : A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap]),
									_List_fromArray(
										[
											$elm$core$List$isEmpty(
											$author$project$Api$Common$Invoice$Delta$added(delta)) ? $author$project$Utils$Html$empty : A2(
											$author$project$Ui$Element$view,
											_List_Nil,
											_List_fromArray(
												[
													$author$project$Ui$Icon$trendingUp(_List_Nil),
													A2(
													$author$project$Ui$Typography$text,
													_List_fromArray(
														[$author$project$Ui$Typography$success]),
													$elm$core$String$fromInt(
														$elm$core$List$length(
															$author$project$Api$Common$Invoice$Delta$added(delta)))),
													A2(
													$author$project$Ui$Typography$text,
													_List_fromArray(
														[$author$project$Ui$Typography$success]),
													' added')
												])),
											$elm$core$List$isEmpty(
											$author$project$Api$Common$Invoice$Delta$removed(delta)) ? $author$project$Utils$Html$empty : A2(
											$author$project$Ui$Element$view,
											_List_Nil,
											_List_fromArray(
												[
													$author$project$Ui$Icon$trendingDown(_List_Nil),
													A2(
													$author$project$Ui$Typography$text,
													_List_fromArray(
														[$author$project$Ui$Typography$danger]),
													$elm$core$String$fromInt(
														$elm$core$List$length(
															$author$project$Api$Common$Invoice$Delta$removed(delta)))),
													A2(
													$author$project$Ui$Typography$text,
													_List_fromArray(
														[$author$project$Ui$Typography$danger]),
													' removed')
												])),
											A3(
											$author$project$Ui$Button$view,
											{mm: 'See changes'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick(
													$author$project$Components$Invoice$Summary$ShowDeltaModal(delta))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('See changes')
												]))
										]));
							} else {
								return $author$project$Ui$Spinner$view(
									_List_fromArray(
										[$author$project$Ui$Spinner$small]));
							}
						}()
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$span(2)
						]),
					_List_fromArray(
						[
							model.hH ? $author$project$Utils$Html$empty : A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textRight]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$bold]),
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Common$Invoice$Summary$ActiveLines$totalAmountInCents(
											$author$project$Api$Common$Invoice$Summary$activeLines(summary))))
								]))
						]))
				]))
		]);
};
var $author$project$Components$Invoice$Summary$viewSummary = function (model) {
	var summary = model.acF;
	var recurring = $author$project$Api$Invoice$One$recurring(model.Uk);
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
						_List_fromArray(
							[
								$author$project$Ui$Typography$headingSm(
								_List_fromArray(
									[
										$elm$html$Html$text('Summary')
									])),
								$author$project$Components$Invoice$Summary$viewGroupByButtonGroup(model)
							]))
					])),
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						recurring ? $author$project$Components$Invoice$Summary$viewRecurringSummary(model) : _List_Nil),
						function () {
						var _v0 = _Utils_Tuple2(model.gx, model.hH);
						if ((!_v0.a.$) && _v0.b) {
							var groupBy_ = _v0.a.a;
							var companyType_ = $author$project$Components$Invoice$Summary$companyType(model.afQ);
							return A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								A2(
									$elm$core$List$map,
									A2($author$project$Components$Invoice$Summary$viewActiveLine, companyType_, groupBy_),
									A2($author$project$Components$Invoice$Summary$activeLinesFor, summary, groupBy_)));
						} else {
							return $author$project$Utils$Html$empty;
						}
					}(),
						($author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalCount(
						$author$project$Api$Common$Invoice$Summary$membershipAdjustmentLines(summary)) > 0) ? A2($author$project$Components$Invoice$Summary$viewMembershipAdjustmentSummary, model, summary) : $author$project$Utils$Html$empty,
						function () {
						var _v1 = _Utils_Tuple2(model.gx, model.hF);
						if ((!_v1.a.$) && _v1.b) {
							var groupBy_ = _v1.a.a;
							return A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								A2(
									$elm$core$List$map,
									$author$project$Components$Invoice$Summary$viewMembershipAdjustmentLine(groupBy_),
									A2($author$project$Components$Invoice$Summary$membershipAdjustmentLinesFor, summary, groupBy_)));
						} else {
							return $author$project$Utils$Html$empty;
						}
					}(),
						A2(
						$elm$html$Html$map,
						$author$project$Components$Invoice$Summary$OtherChargesSummaryMsg,
						A2($author$project$Components$Invoice$Summary$OtherChargesSummary$view, summary, model.tv)),
						$author$project$Ui$HorizontalRule$view(
						_List_fromArray(
							[$author$project$Ui$HorizontalRule$thin])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(3)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$strong,
												_List_fromArray(
													[$author$project$Ui$Typography$info]),
												_List_fromArray(
													[
														$elm$html$Html$text('Total')
													]))
											])),
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(7),
												$author$project$Ui$Grid$justifyRight
											]),
										($author$project$Api$Invoice$One$discountSavingsInCents(model.Uk) > 0) ? _List_fromArray(
											[
												A2(
												$author$project$Ui$Badge$view,
												_List_fromArray(
													[$author$project$Ui$Badge$success]),
												_List_fromArray(
													[
														$elm$html$Html$text('Membership Savings: '),
														$elm$html$Html$text(
														$author$project$Utils$Currency$fromInt(
															$author$project$Api$Invoice$One$discountSavingsInCents(model.Uk)))
													]))
											]) : _List_Nil),
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(2)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$textRight]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$text,
														_List_fromArray(
															[$author$project$Ui$Typography$bold]),
														$author$project$Utils$Currency$fromInt(
															$author$project$Api$Common$Invoice$Summary$AllLines$totalAmountInCents(
																$author$project$Api$Common$Invoice$Summary$allLines(summary))))
													]))
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Components$Invoice$Summary$view = function (_v0) {
	var model = _v0;
	var recurring = $author$project$Api$Invoice$One$recurring(model.Uk);
	return recurring ? $author$project$Components$Invoice$Summary$viewSummary(model) : (($author$project$Api$Common$Invoice$Summary$AllLines$count(
		$author$project$Api$Common$Invoice$Summary$allLines(model.acF)) > 0) ? $author$project$Components$Invoice$Summary$viewSummary(model) : $author$project$Utils$Html$empty);
};
var $author$project$Components$Invoice$DownloadFile$Label = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Invoice$DownloadFile$label = function (str) {
	return $author$project$Components$Invoice$DownloadFile$Label(str);
};
var $author$project$Components$Invoice$DownloadFile$Tooltip = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Invoice$DownloadFile$tooltip = function (bool) {
	return $author$project$Components$Invoice$DownloadFile$Tooltip(bool);
};
var $author$project$Components$Invoice$viewDownloadUnavailableWarningModal = function (_v0) {
	var showDownloadUnavailableWarningModal = _v0.p5;
	var invoice = _v0.Uk;
	var downloadInvoice = _v0.jt;
	var _v1 = _Utils_Tuple2(invoice, showDownloadUnavailableWarningModal);
	if ((_v1.a.$ === 3) && _v1.b) {
		var _v2 = _v1.a;
		var invoice_ = _v2.a;
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$Invoice$DownloadUnavailableModalClosed,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('Can not export to PDF')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('The PDF file for this invoice would be more than 50 pages long and cannot be generated. Please download the summary only as a pdf and then export the charge details to excel.')
								]))
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Cancel download'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Components$Invoice$DownloadUnavailableModalClosed)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							$author$project$Utils$Html$noBreakSpace,
							A2(
							$elm$html$Html$map,
							$author$project$Components$Invoice$DownloadInvoiceMsg,
							A4(
								$author$project$Components$Invoice$DownloadFile$view,
								downloadInvoice,
								$author$project$Api$Invoice$One$securePdfInlineToken(invoice_),
								_List_fromArray(
									[
										$author$project$Components$Invoice$DownloadFile$label('Download Summary'),
										$author$project$Components$Invoice$DownloadFile$tooltip(false)
									]),
								_List_fromArray(
									[$author$project$Ui$Button$primary])))
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Invoice$DownloadFile$UnavailableOptionClicked = {$: 5};
var $author$project$Components$Invoice$DownloadFile$viewDownloadOption = function (_v0) {
	var token = _v0.a;
	var option = _v0.b;
	var action = option.ae4 ? $author$project$Components$Invoice$DownloadFile$DownloadFileClicked(token) : $author$project$Components$Invoice$DownloadFile$UnavailableOptionClicked;
	return A2(
		$author$project$Ui$Dropdown$item,
		_List_fromArray(
			[
				$author$project$Ui$Dropdown$onSelect(action)
			]),
		$elm$html$Html$text(option.aih));
};
var $author$project$Components$Invoice$DownloadFile$viewDropdown = F2(
	function (model, options) {
		return A3(
			$author$project$Ui$Tooltip$view,
			_List_fromArray(
				[
					$author$project$Ui$Tooltip$placement(0)
				]),
			'Download or print PDF',
			_List_fromArray(
				[
					A4(
					$author$project$Ui$Dropdown$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Export to PDF '),
							$author$project$Ui$Icon$export(_List_Nil)
						]),
					A2($elm$core$List$map, $author$project$Components$Invoice$DownloadFile$viewDownloadOption, options),
					model.gi),
					model.U5 ? $author$project$Components$Invoice$DownloadFile$viewModal : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$Invoice$InvoiceLinesTable$exportCsvPath = F2(
	function (apiClient, model) {
		var path = A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				['invoice_lines']),
			function () {
				var _v0 = model.Uv;
				if (!_v0.$) {
					var id = _v0.b;
					return $author$project$Api$Provider$AffiliateBill$affiliateBillPath(id);
				} else {
					var companyId_ = _v0.a;
					var id = _v0.b;
					return A3($author$project$Api$Company$Invoice$invoicePath, model.aa4, companyId_, id);
				}
			}());
		return A4($author$project$Api$Data$downloadUrl, apiClient, path, 0, _List_Nil);
	});
var $author$project$Components$Invoice$InvoiceLinesTable$viewExportButton = F3(
	function (client, label, model) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(model.aa4) ? A3(
			$author$project$Ui$Tooltip$view,
			_List_Nil,
			'Export to Excel',
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Components$Invoice$InvoiceLinesTable$ExportFileMsg,
					A3(
						$author$project$Components$FileLink$view,
						{
							NJ: client,
							SG: 0,
							adY: A2($author$project$Components$Invoice$InvoiceLinesTable$exportCsvPath, client, model)
						},
						_List_fromArray(
							[
								$author$project$Ui$Link$buttonDefault,
								$author$project$Ui$Link$icon($author$project$Ui$Icon$export)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Export to Excel')
							])))
				])) : A2(
			$elm$html$Html$map,
			$author$project$Components$Invoice$InvoiceLinesTable$ExportCsvMsg,
			A2(
				$author$project$Components$ExportCsv$customButton,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(label)
					])));
	});
var $author$project$Api$Provider$IntegrationRecord$Shared$errorMessage = function (_v0) {
	var record = _v0;
	return record.RM;
};
var $author$project$Api$Provider$IntegrationRecord$One$errorMessage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$IntegrationRecord$Shared$errorMessage(shared);
};
var $author$project$Api$Provider$IntegrationRecord$All$errorMessage = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$IntegrationRecord$One$errorMessage(one);
};
var $author$project$Api$Provider$IntegrationRecord$All$integration = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$IntegrationRecord$One$integration(one);
};
var $author$project$Api$Provider$IntegrationRecord$Shared$integrationLastSyncedAt = function (_v0) {
	var record = _v0;
	return record.T9;
};
var $author$project$Api$Provider$IntegrationRecord$One$integrationLastSyncedAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$IntegrationRecord$Shared$integrationLastSyncedAt(shared);
};
var $author$project$Api$Provider$IntegrationRecord$All$integrationLastSyncedAt = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$IntegrationRecord$One$integrationLastSyncedAt(one);
};
var $author$project$Api$Provider$IntegrationRecord$All$integrationSyncStatus = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$IntegrationRecord$One$integrationSyncStatus(one);
};
var $author$project$Api$Provider$IntegrationRecord$Shared$unsyncedReason = function (_v0) {
	var record = _v0;
	return record.adO;
};
var $author$project$Api$Provider$IntegrationRecord$One$unsyncedReason = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$IntegrationRecord$Shared$unsyncedReason(shared);
};
var $author$project$Api$Provider$IntegrationRecord$All$unsyncedReason = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$IntegrationRecord$One$unsyncedReason(one);
};
var $author$project$Components$Invoice$viewIntegrationRecord = F2(
	function (timeFormatter, record) {
		var unsyncedReason = function () {
			var _v2 = $author$project$Api$Provider$IntegrationRecord$All$unsyncedReason(record);
			if (!_v2.$) {
				var reason = _v2.a;
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ml-1')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(reason)
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}();
		var lastSyncedAt = function () {
			var _v1 = $author$project$Api$Provider$IntegrationRecord$All$integrationLastSyncedAt(record);
			if (!_v1.$) {
				var time = _v1.a;
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ml-1')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							'on ' + A2(timeFormatter, 0, time))
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}();
		var integrationName = $author$project$Api$Provider$Integration$SharedWithInlinePartner$displayName(
			$author$project$Api$Provider$IntegrationRecord$All$integration(record));
		var errorMessage = function () {
			var _v0 = $author$project$Api$Provider$IntegrationRecord$All$errorMessage(record);
			if (!_v0.$) {
				var message = _v0.a;
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ml-1')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(message)
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}();
		var additionalInfo = A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-control--static'),
					$elm$html$Html$Attributes$class('text-muted')
				]),
			_List_fromArray(
				[unsyncedReason, errorMessage, lastSyncedAt]));
		return A2(
			$author$project$Ui$HinterOnly$formGroup,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label(integrationName),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$itemsStart]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Badge$fromString,
									_List_Nil,
									$author$project$Api$IntegrationRecord$Status$toString(
										$author$project$Api$Provider$IntegrationRecord$All$integrationSyncStatus(record)))
								])),
							additionalInfo
						]))
				]));
	});
var $author$project$Components$Invoice$viewIntegrationRecords = F2(
	function (formatter, response) {
		if (response.$ === 3) {
			var integrationRecords = response.a;
			return A2(
				$elm$core$List$map,
				$author$project$Components$Invoice$viewIntegrationRecord(formatter),
				integrationRecords);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Invoice$EditDateButtonClicked = {$: 29};
var $author$project$Components$Invoice$editDateButton = F4(
	function (buttonText, recurring, status, message) {
		return ((!recurring) && $author$project$Api$Invoice$Status$isDraft(status)) ? A3(
			$author$project$Ui$Button$view,
			{mm: buttonText},
			_List_fromArray(
				[
					$author$project$Ui$Button$onClick(message),
					$author$project$Ui$Button$sm,
					$author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(buttonText)
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Api$Provider$Invoice$One$periodInMonths = function (_v0) {
	var record = _v0.b;
	return record.Zs;
};
var $author$project$Api$Invoice$One$periodInMonths = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$One$periodInMonths(invoice_);
	} else {
		return 0;
	}
};
var $author$project$Components$Invoice$formatInvoiceDate = F2(
	function (invoice, recurring) {
		return _List_fromArray(
			[
				recurring ? $elm$html$Html$text(
				A2(
					$author$project$Formatters$Date$toString,
					$author$project$Formatters$Date$MonthAndYear,
					$author$project$Api$Invoice$One$invoiceDate(invoice))) : $elm$html$Html$text(
				A2(
					$author$project$Formatters$Date$toString,
					$author$project$Formatters$Date$Full,
					$author$project$Api$Invoice$One$invoiceDate(invoice))),
				(($author$project$Api$Invoice$One$periodInMonths(invoice) > 1) && recurring) ? A2(
				$author$project$Ui$Element$prose,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(' - '),
						$elm$html$Html$text(
						A2(
							$author$project$Formatters$Date$toString,
							$author$project$Formatters$Date$MonthAndYear,
							A3(
								$justinmimbs$date$Date$add,
								1,
								$author$project$Api$Invoice$One$periodInMonths(invoice) - 1,
								$author$project$Api$Invoice$One$invoiceDate(invoice))))
					])) : $author$project$Utils$Html$empty
			]);
	});
var $author$project$Components$Invoice$viewInvoiceDate = F3(
	function (invoice, showDateInput, fields) {
		var status = $author$project$Api$Invoice$One$humanStatus(invoice);
		var recurring = $author$project$Api$Invoice$One$recurring(invoice);
		return A2(
			$author$project$Ui$Form$Group$view,
			recurring ? _List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Invoice Period'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8)
				]) : _List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Invoice Date'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_fromArray(
						[$author$project$Ui$Grid$rowItemsCenter]),
					_List_fromArray(
						[
							function () {
							if (showDateInput) {
								return A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(6)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$map,
											$author$project$Components$Invoice$InvoiceDateInputMsg(fields.n3),
											A2(
												$author$project$Components$DateInput$view,
												_List_fromArray(
													[
														$author$project$Components$DateInput$value(
														$elm$core$Maybe$Just(fields.Uq))
													]),
												fields.n3))
										]));
							} else {
								var dateWidth = recurring ? 6 : 3;
								return A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(dateWidth)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$strong,
													_List_Nil,
													A2($author$project$Components$Invoice$formatInvoiceDate, invoice, recurring))
												]))
										]));
							}
						}(),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(4)
								]),
							_List_fromArray(
								[
									A4($author$project$Components$Invoice$editDateButton, 'Edit Invoice Date', recurring, status, $author$project$Components$Invoice$EditDateButtonClicked)
								]))
						]))
				]));
	});
var $author$project$Components$Invoice$EditDueDateButtonClicked = {$: 31};
var $author$project$Components$Invoice$viewInvoiceDueDate = F3(
	function (invoice, showDueDateInput, fields) {
		var status = $author$project$Api$Invoice$One$humanStatus(invoice);
		var recurring = $author$project$Api$Invoice$One$recurring(invoice);
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Due On'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_fromArray(
						[$author$project$Ui$Grid$rowItemsCenter]),
					_List_fromArray(
						[
							showDueDateInput ? A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(6)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Components$Invoice$InvoiceDueDateInputMsg(fields.n4),
									A2(
										$author$project$Components$DateInput$view,
										_List_fromArray(
											[
												$author$project$Components$DateInput$value(
												$elm$core$Maybe$Just(fields.j_))
											]),
										fields.n4))
								])) : A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(3)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2(
														$author$project$Formatters$Date$toString,
														$author$project$Formatters$Date$Full,
														$author$project$Api$Invoice$One$dueDate(invoice)))
												]))
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(4)
								]),
							_List_fromArray(
								[
									A4($author$project$Components$Invoice$editDateButton, 'Edit Due Date', recurring, status, $author$project$Components$Invoice$EditDueDateButtonClicked)
								]))
						]))
				]));
	});
var $author$project$Components$Invoice$Issue = {$: 20};
var $author$project$Api$Provider$Invoice$One$viewingAsAffiliate = function (_v0) {
	var record = _v0.b;
	return record.aei;
};
var $author$project$Api$Invoice$One$viewingAsAffiliate = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$One$viewingAsAffiliate(invoice_);
	} else {
		return false;
	}
};
var $author$project$Components$Invoice$viewIssueButton = F2(
	function (model, invoice) {
		var meta = $author$project$Api$Invoice$One$meta(invoice);
		return ($author$project$Api$Invoice$Meta$issueAction(meta) && (!$author$project$Api$Invoice$One$viewingAsAffiliate(invoice))) ? A3(
			$author$project$Ui$Button$view,
			{mm: 'Issue invoice'},
			_List_fromArray(
				[
					$author$project$Ui$Button$primary,
					$author$project$Ui$Button$loading(
					_Utils_eq(model.k9, $author$project$Api$Data$Loading)),
					$author$project$Ui$Button$onClick($author$project$Components$Invoice$Issue),
					$author$project$Ui$Button$icon($author$project$Ui$Icon$check)
				]),
			_List_fromArray(
				[
					$author$project$Components$Invoice$isNetwork(model.afQ) ? $elm$html$Html$text('Approve ') : $elm$html$Html$text('Issue '),
					$elm$html$Html$text('Invoice')
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Api$Employer$Invoice$One$willAutoPay = function (_v0) {
	var record = _v0.b;
	return record.aeB;
};
var $author$project$Api$Provider$Invoice$One$willAutoPay = function (_v0) {
	var record = _v0.b;
	return record.aeB;
};
var $author$project$Api$Invoice$One$willAutoPay = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$One$willAutoPay(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$One$willAutoPay(invoice_);
	}
};
var $author$project$Components$Invoice$view = F2(
	function (apiClient, _v0) {
		var model = _v0;
		return _List_fromArray(
			[
				function () {
				var _v1 = model.vp;
				if (!_v1.$) {
					var invoice = _v1.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Components$Invoice$VoidHiConfirmClosed(invoice),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('void'),
								$author$project$Components$HiConfirm$noun(
								'Invoice #' + $elm$core$String$fromInt(
									$author$project$Api$Invoice$One$invoiceNumber(invoice))),
								$author$project$Components$HiConfirm$loading(
								_Utils_eq(model.k9, $author$project$Api$Data$Loading))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v2 = model.e7;
				if (!_v2.$) {
					var invoice = _v2.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Components$Invoice$ReturnToDraftHiConfirmClosed(invoice),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('Return to draft'),
								$author$project$Components$HiConfirm$noun(
								'Invoice #' + $elm$core$String$fromInt(
									$author$project$Api$Invoice$One$invoiceNumber(invoice))),
								$author$project$Components$HiConfirm$detail('which will also delete the current draft invoice if any'),
								$author$project$Components$HiConfirm$loading(
								_Utils_eq(model.k9, $author$project$Api$Data$Loading))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v3 = model.eJ;
				if (!_v3.$) {
					var invoice = _v3.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Components$Invoice$MarkAsBadDebtHiConfirmClosed(invoice),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('Mark'),
								$author$project$Components$HiConfirm$noun(
								'Invoice #' + $elm$core$String$fromInt(
									$author$project$Api$Invoice$One$invoiceNumber(invoice))),
								$author$project$Components$HiConfirm$detail('which will remove it from your outstanding invoices report'),
								$author$project$Components$HiConfirm$loading(
								_Utils_eq(model.k9, $author$project$Api$Data$Loading))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v4 = model.i9;
				if (!_v4.$) {
					var invoice = _v4.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Components$Invoice$DeleteHiConfirmClosed(invoice),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('delete'),
								$author$project$Components$HiConfirm$noun(
								'Invoice #' + $elm$core$String$fromInt(
									$author$project$Api$Invoice$One$invoiceNumber(invoice))),
								$author$project$Components$HiConfirm$loading(
								_Utils_eq(model.k9, $author$project$Api$Data$Loading))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v5 = model.iM;
				if (!_v5.$) {
					var companyEmailModal = _v5.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$Invoice$CompanyEmailModalMsg,
						$author$project$Components$CompanyEmailModal$view(companyEmailModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v6 = model.m$;
				if (!_v6.$) {
					var createPaymentModal = _v6.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$Invoice$CreatePaymentModalMsg,
						$author$project$Components$Invoice$CreatePaymentModal$view(createPaymentModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v7 = model.gB;
				if (!_v7.$) {
					var invoiceSummary = _v7.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$Invoice$InvoiceSummaryMsg,
						$author$project$Components$Invoice$Summary$modal(invoiceSummary));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v8 = model.eB;
				if (!_v8.$) {
					var invoiceLinesTable = _v8.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$Invoice$InvoiceLinesTableMsg,
						$author$project$Components$Invoice$InvoiceLinesTable$modal(invoiceLinesTable));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				$author$project$Components$Invoice$viewDownloadUnavailableWarningModal(model),
				A2(
				$elm$html$Html$map,
				$author$project$Components$Invoice$PaymentsHistoryMsg,
				$author$project$Components$Invoice$PaymentsHistory$modal(model.kC)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						function () {
							var _v9 = model.Uk;
							if (_v9.$ === 3) {
								var invoice = _v9.a;
								var meta = $author$project$Api$Invoice$One$meta(invoice);
								return _List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$elm$core$Basics$never,
										A2(
											$author$project$Ui$Breadcrumb$view,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Breadcrumb$item,
													_List_Nil,
													_List_fromArray(
														[
															A3(
															$author$project$Ui$Link$route,
															model.Is,
															_List_Nil,
															_List_fromArray(
																[
																	model.mn ? $elm$html$Html$text('Bills') : $elm$html$Html$text('Invoices')
																]))
														])),
													A2(
													$author$project$Ui$Breadcrumb$item,
													_List_fromArray(
														[
															$author$project$Ui$Breadcrumb$active(true)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															'#' + $elm$core$String$fromInt(
																$author$project$Api$Invoice$One$invoiceNumber(invoice)))
														]))
												]))),
										$author$project$Ui$HorizontalRule$view(_List_Nil),
										$author$project$Api$Invoice$One$isUpdating(invoice) ? A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$mb2]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Alert$warning,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('We are updating the invoice with recent membership changes. The page will reload when the update completes.')
													]))
											])) : $author$project$Utils$Html$empty,
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsStart]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Element$view,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Element$view,
														_List_fromArray(
															[$author$project$Ui$Element$itemsCenter]),
														_List_fromArray(
															[
																$author$project$Ui$Typography$heading(
																_List_fromArray(
																	[
																		$elm$html$Html$text('Invoice #'),
																		$elm$html$Html$text(
																		$elm$core$String$fromInt(
																			$author$project$Api$Invoice$One$invoiceNumber(invoice)))
																	])),
																A2(
																$author$project$Ui$Element$view,
																_List_fromArray(
																	[$author$project$Ui$Element$ml2]),
																_List_fromArray(
																	[
																		A2(
																		$elm$core$Maybe$withDefault,
																		$author$project$Utils$Html$empty,
																		A2(
																			$elm$core$Maybe$map,
																			A2(
																				$elm$core$Basics$composeR,
																				$author$project$Components$AuditTrailLog$view,
																				$elm$html$Html$map($author$project$Components$Invoice$AuditTrailLogMsg)),
																			model.iw))
																	]))
															])),
														$author$project$Ui$Typography$headingSm(
														_List_fromArray(
															[
																$elm$html$Html$text(
																$author$project$Utils$Currency$fromInt(
																	$author$project$Api$Invoice$One$amountInCents(invoice))),
																$author$project$Utils$Html$noBreakSpace,
																$author$project$Api$Invoice$Status$toBadge(
																$author$project$Api$Invoice$One$humanStatus(invoice))
															]))
													])),
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$gap2, $author$project$Ui$Element$justifyRight]),
												_List_fromArray(
													[
														A2($author$project$Components$Invoice$viewIssueButton, model, invoice),
														($author$project$Api$Invoice$Meta$canMakeViewableAction(meta) && (!$author$project$Api$Invoice$One$viewingAsAffiliate(invoice))) ? A3(
														$author$project$Ui$Tooltip$view,
														_List_Nil,
														'Email Invoice',
														_List_fromArray(
															[
																A3(
																$author$project$Ui$Button$view,
																{mm: 'Send invoice to employer'},
																_List_fromArray(
																	[
																		$author$project$Ui$Button$onClick(
																		$author$project$Components$Invoice$MakeViewableAndEmail(invoice)),
																		$author$project$Ui$Button$icon($author$project$Ui$Icon$send)
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Send to employer')
																	]))
															])) : $author$project$Utils$Html$empty,
														$author$project$Api$Invoice$Meta$canNotifyAction(meta) ? A3(
														$author$project$Ui$Tooltip$view,
														_List_Nil,
														'Email Invoice',
														_List_fromArray(
															[
																A3(
																$author$project$Ui$Button$view,
																{mm: 'Email invoice'},
																_List_fromArray(
																	[
																		$author$project$Ui$Button$onClick(
																		$author$project$Components$Invoice$Email(invoice)),
																		$author$project$Ui$Button$icon($author$project$Ui$Icon$send)
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Email')
																	]))
															])) : $author$project$Utils$Html$empty,
														function () {
														var chargesOptionAvailable = function (count) {
															return _Utils_cmp(count, $author$project$Components$Invoice$maxInvoiceLinesForDetailsDownload) < 0;
														}(
															A2($elm$core$Maybe$withDefault, 0, model.Aj));
														return A2(
															$elm$html$Html$map,
															$author$project$Components$Invoice$DownloadInvoiceMsg,
															A2(
																$author$project$Components$Invoice$DownloadFile$viewDropdown,
																model.jt,
																_List_fromArray(
																	[
																		_Utils_Tuple2(
																		$author$project$Api$Invoice$One$securePdfInlineToken(invoice),
																		{
																			ae4: true,
																			PD: {HY: '', Iw: ''},
																			aih: 'Summary Only'
																		}),
																		_Utils_Tuple2(
																		$author$project$Api$Invoice$One$securePdfInlineWithChargeDetailsToken(invoice),
																		{
																			ae4: chargesOptionAvailable,
																			PD: {HY: '', Iw: ''},
																			aih: 'Summary and Charges'
																		})
																	])));
													}(),
														A2(
														$elm$core$Maybe$withDefault,
														$elm$html$Html$text(''),
														A2(
															$elm$core$Maybe$map,
															$elm$html$Html$map($author$project$Components$Invoice$InvoiceLinesTableMsg),
															A2(
																$elm$core$Maybe$map,
																A2($author$project$Components$Invoice$InvoiceLinesTable$viewExportButton, apiClient, 'Export to Excel'),
																model.eB)))
													]))
											])),
										A2(
										$author$project$Ui$Grid$row,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Grid$column,
												_List_fromArray(
													[
														$author$project$Ui$Grid$span(6)
													]),
												_List_fromArray(
													[
														$author$project$Api$Platform$Session$One$organizationIsCompany(model.aa4) ? A2(
														$author$project$Ui$Form$Group$view,
														_List_fromArray(
															[
																$author$project$Ui$Form$Group$label('Pay To'),
																$author$project$Ui$Form$Group$labelSpan(4),
																$author$project$Ui$Form$Group$inputSpan(8)
															]),
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Form$Static$view,
																_List_Nil,
																_List_fromArray(
																	[
																		A2(
																		$author$project$Ui$Typography$strong,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$elm$html$Html$text(
																				$author$project$Api$Practice$name(model.ZV))
																			])),
																		function () {
																		var _v10 = A2(
																			$elm$core$Maybe$andThen,
																			$author$project$Api$Common$Phone$Shared$number,
																			$elm$core$List$head(
																				$author$project$Api$Practice$phones(model.ZV)));
																		if (!_v10.$) {
																			var phoneNumber = _v10.a;
																			return A2(
																				$author$project$Ui$Element$view,
																				_List_fromArray(
																					[$author$project$Ui$Element$phi]),
																				_List_fromArray(
																					[
																						$elm$html$Html$text(
																						$author$project$Formatters$Phone$format(phoneNumber))
																					]));
																		} else {
																			return $author$project$Utils$Html$empty;
																		}
																	}(),
																		function () {
																		var _v11 = $author$project$Api$Practice$address(model.ZV);
																		if (!_v11.$) {
																			var address = _v11.a;
																			return $author$project$Components$AddressDisplay$view(address);
																		} else {
																			return $author$project$Utils$Html$empty;
																		}
																	}()
																	]))
															])) : A2(
														$author$project$Ui$Form$Group$view,
														_List_fromArray(
															[
																$author$project$Ui$Form$Group$label('Payer'),
																$author$project$Ui$Form$Group$labelSpan(4),
																$author$project$Ui$Form$Group$inputSpan(8)
															]),
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Form$Static$view,
																_List_Nil,
																_List_fromArray(
																	[
																		A2(
																		$author$project$Ui$Typography$strong,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$elm$html$Html$text(
																				A2(
																					$elm$core$Maybe$withDefault,
																					'',
																					$author$project$Components$Invoice$companyName(model.afQ))),
																				A2($elm$html$Html$br, _List_Nil, _List_Nil)
																			])),
																		A2(
																		$author$project$Ui$Typography$strong,
																		_List_Nil,
																		_List_fromArray(
																			[
																				function () {
																				var _v12 = A2(
																					$elm$core$Maybe$andThen,
																					$author$project$Api$Common$Phone$Shared$number,
																					$elm$core$List$head(
																						$author$project$Components$Invoice$companyPhones(model.afQ)));
																				if (!_v12.$) {
																					var phoneNumber = _v12.a;
																					return A2(
																						$author$project$Ui$Element$view,
																						_List_fromArray(
																							[$author$project$Ui$Element$phi]),
																						_List_fromArray(
																							[
																								$elm$html$Html$text(
																								$author$project$Formatters$Phone$format(phoneNumber))
																							]));
																				} else {
																					return $author$project$Utils$Html$empty;
																				}
																			}(),
																				function () {
																				var _v13 = $author$project$Components$Invoice$companyAddress(model.afQ);
																				if (!_v13.$) {
																					var address = _v13.a;
																					return $author$project$Components$AddressDisplay$view(address);
																				} else {
																					return $author$project$Utils$Html$empty;
																				}
																			}()
																			]))
																	]))
															])),
														function () {
														var hasActiveInvoice = !A2(
															$elm$core$List$member,
															$author$project$Api$Invoice$Status$toString(
																$author$project$Api$Invoice$One$humanStatus(invoice)),
															_List_fromArray(
																['draft', 'paid', 'cancelled']));
														return hasActiveInvoice ? A2(
															$elm$core$Maybe$withDefault,
															$author$project$Utils$Html$empty,
															A2(
																$elm$core$Maybe$map,
																function (virtualBankAccountsComponent_) {
																	var payerName = $author$project$Api$Platform$Session$One$organizationIsCompany(model.aa4) ? $author$project$Api$Practice$name(model.ZV) : A2(
																		$elm$core$Maybe$withDefault,
																		'',
																		$author$project$Components$Invoice$companyName(model.afQ));
																	return A2(
																		$elm$html$Html$map,
																		$author$project$Components$Invoice$VirtualBankAccountsComponentMsg,
																		A2($author$project$Components$Company$VirtualBankAccounts$Invoice$view, virtualBankAccountsComponent_, payerName));
																},
																model.vo)) : $author$project$Utils$Html$empty;
													}(),
														A2($elm$html$Html$br, _List_Nil, _List_Nil)
													])),
												A2(
												$author$project$Ui$Grid$column,
												_List_fromArray(
													[
														$author$project$Ui$Grid$span(6)
													]),
												A2(
													$elm$core$List$cons,
													A3(
														$author$project$Components$Invoice$viewInvoiceDate,
														invoice,
														model.p4,
														$author$project$Utils$Form$fields(model.cY)),
													A2(
														$elm$core$List$cons,
														A3(
															$author$project$Components$Invoice$viewInvoiceDueDate,
															invoice,
															model.p6,
															$author$project$Utils$Form$fields(model.cY)),
														A2(
															$elm$core$List$cons,
															$author$project$Api$Invoice$One$recurring(invoice) ? A2(
																$author$project$Ui$Form$Group$view,
																_List_fromArray(
																	[
																		$author$project$Ui$Form$Group$label('Autopay'),
																		$author$project$Ui$Form$Group$labelSpan(4),
																		$author$project$Ui$Form$Group$inputSpan(8)
																	]),
																_List_fromArray(
																	[
																		A2(
																		$author$project$Ui$Form$Static$view,
																		_List_Nil,
																		_List_fromArray(
																			[
																				A2(
																				$author$project$Ui$Typography$strong,
																				_List_Nil,
																				_List_fromArray(
																					[
																						$author$project$Api$Invoice$One$willAutoPay(invoice) ? $elm$html$Html$text(
																						$author$project$Formatters$Bool$toString(
																							$author$project$Api$Invoice$One$willAutoPay(invoice)) + (', on ' + A2(
																							$elm$core$Maybe$withDefault,
																							'N/A',
																							A2(
																								$elm$core$Maybe$map,
																								$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
																								$author$project$Api$Invoice$One$autoPayDate(invoice))))) : $elm$html$Html$text(
																						$author$project$Formatters$Bool$toString(
																							$author$project$Api$Invoice$One$willAutoPay(invoice))),
																						$author$project$Api$Invoice$One$willAutoPay(invoice) ? $author$project$Utils$Html$empty : A3(
																						$author$project$Ui$Tooltip$view,
																						_List_fromArray(
																							[$author$project$Ui$Tooltip$wide]),
																						'We will only try to autopay invoices if the company has a default payment source, autopay is enabled (see \"Invoice Settings\"), and no payment attempts have been made',
																						_List_fromArray(
																							[
																								$author$project$Utils$Html$noBreakSpace,
																								$author$project$Ui$Icon$help(_List_Nil)
																							]))
																					]))
																			]))
																	])) : $author$project$Utils$Html$empty,
															A2(
																$elm$core$List$cons,
																$author$project$Api$Invoice$One$willAutoPay(invoice) ? A2(
																	$author$project$Ui$Form$Group$view,
																	_List_fromArray(
																		[
																			$author$project$Ui$Form$Group$label('Payment Source'),
																			$author$project$Ui$Form$Group$labelSpan(4),
																			$author$project$Ui$Form$Group$inputSpan(8)
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$author$project$Ui$Form$Static$view,
																			_List_Nil,
																			_List_fromArray(
																				[
																					function () {
																					var _v14 = $author$project$Api$Invoice$One$source(invoice);
																					if (!_v14.$) {
																						var source = _v14.a;
																						return A2(
																							$author$project$Components$PaymentSourceDisplayer$view,
																							model.J7,
																							_List_fromArray(
																								[
																									$author$project$Components$PaymentSourceDisplayer$source(
																									$elm$core$Maybe$Just(
																										$author$project$Api$Source$Source(source))),
																									$author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus(true),
																									$author$project$Components$PaymentSourceDisplayer$limitedView(true)
																								]));
																					} else {
																						return A2(
																							$author$project$Ui$Badge$view,
																							_List_Nil,
																							_List_fromArray(
																								[
																									$elm$html$Html$text('none')
																								]));
																					}
																				}()
																				]))
																		])) : $author$project$Utils$Html$empty,
																A2(
																	$elm$core$List$cons,
																	A2(
																		$author$project$Ui$Form$Group$view,
																		_List_fromArray(
																			[
																				$author$project$Ui$Form$Group$label('Total Paid'),
																				$author$project$Ui$Form$Group$labelSpan(4),
																				$author$project$Ui$Form$Group$inputSpan(8)
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$author$project$Ui$Form$Static$view,
																				_List_Nil,
																				_List_fromArray(
																					[
																						A2(
																						$author$project$Ui$Typography$strong,
																						_List_Nil,
																						_List_fromArray(
																							[
																								$elm$html$Html$text(
																								$author$project$Utils$Currency$fromInt(
																									$author$project$Api$Invoice$One$paidInCents(invoice)))
																							])),
																						function () {
																						var _v15 = $author$project$Api$Invoice$One$paidAt(invoice);
																						if (!_v15.$) {
																							var paidAt = _v15.a;
																							return A2(
																								$author$project$Ui$Element$prose,
																								_List_Nil,
																								_List_fromArray(
																									[
																										$author$project$Utils$Html$noBreakSpace,
																										$author$project$Api$Invoice$Status$toBadge(
																										$author$project$Api$Invoice$One$humanStatus(invoice)),
																										A2(
																										$author$project$Ui$Typography$text,
																										_List_fromArray(
																											[$author$project$Ui$Typography$small]),
																										' on ' + A2(model.J7, 2, paidAt))
																									]));
																						} else {
																							return $author$project$Utils$Html$empty;
																						}
																					}()
																					])),
																				A2(
																				$elm$html$Html$map,
																				$author$project$Components$Invoice$PaymentsHistoryMsg,
																				A2(
																					$author$project$Components$Invoice$PaymentsHistory$view,
																					{
																						aeS: model.Ij,
																						aeV: $author$project$Components$Invoice$isAPractice(model.aa4) && (!model.mn),
																						Ij: model.Ij,
																						Zi: $author$project$Api$Invoice$One$payments(invoice),
																						alx: $author$project$Components$Invoice$isAPractice(model.aa4)
																					},
																					model.kC))
																			])),
																	A2(
																		$elm$core$List$cons,
																		A2(
																			$author$project$Ui$Form$Group$view,
																			_List_fromArray(
																				[
																					$author$project$Ui$Form$Group$label('Total Due'),
																					$author$project$Ui$Form$Group$labelSpan(4),
																					$author$project$Ui$Form$Group$inputSpan(8)
																				]),
																			_List_fromArray(
																				[
																					A2(
																					$author$project$Ui$Form$Static$view,
																					_List_Nil,
																					_List_fromArray(
																						[
																							A2(
																							$author$project$Ui$Typography$strong,
																							_List_Nil,
																							_List_fromArray(
																								[
																									$elm$html$Html$text(
																									$author$project$Utils$Currency$fromInt(
																										$author$project$Api$Invoice$One$dueInCents(invoice)))
																								]))
																						]))
																				])),
																		A2($author$project$Components$Invoice$viewIntegrationRecords, model.J7, model.Ub))))))))
											])),
										function () {
										var _v16 = model.gB;
										if (!_v16.$) {
											var invoiceSummary = _v16.a;
											return A2(
												$elm$html$Html$map,
												$author$project$Components$Invoice$InvoiceSummaryMsg,
												$author$project$Components$Invoice$Summary$view(invoiceSummary));
										} else {
											return $author$project$Utils$Html$empty;
										}
									}(),
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$mt2]),
										function () {
											var _v17 = model.eB;
											if (!_v17.$) {
												var invoiceLinesTable = _v17.a;
												return A2(
													$elm$core$List$map,
													$elm$html$Html$map($author$project$Components$Invoice$InvoiceLinesTableMsg),
													A2($author$project$Components$Invoice$InvoiceLinesTable$view, apiClient, invoiceLinesTable));
											} else {
												return _List_Nil;
											}
										}())
									]);
							} else {
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$textCenter]),
										_List_fromArray(
											[
												$author$project$Ui$Spinner$view(_List_Nil)
											]))
									]);
							}
						}()),
						A2(
						$author$project$Ui$Panel$footer,
						_List_fromArray(
							[$author$project$Ui$Element$gap2, $author$project$Ui$Element$justifyCenter]),
						function () {
							var _v18 = model.Uk;
							if (_v18.$ === 3) {
								var invoice = _v18.a;
								var meta = $author$project$Api$Invoice$One$meta(invoice);
								return _List_fromArray(
									[
										function () {
										if (($author$project$Api$Invoice$Meta$canCancelAction(meta) || ($author$project$Api$Invoice$Meta$canDraftAndDestroyCurrentDraftAction(meta) || ($author$project$Api$Invoice$Meta$canMarkAsBadDebtAction(meta) || $author$project$Api$Invoice$Meta$canReverseBadDebtAction(meta)))) && (!$author$project$Api$Invoice$One$viewingAsAffiliate(invoice))) {
											var actions = A2(
												$elm$core$List$filterMap,
												$elm$core$Basics$identity,
												_List_fromArray(
													[
														$author$project$Api$Invoice$Meta$canCancelAction(meta) ? $elm$core$Maybe$Just(
														A2(
															$author$project$Ui$Dropdown$item,
															_List_fromArray(
																[
																	$author$project$Ui$Dropdown$onSelect(
																	$author$project$Components$Invoice$Void(invoice))
																]),
															A2(
																$author$project$Ui$Element$view,
																_List_Nil,
																_List_fromArray(
																	[
																		$author$project$Ui$Icon$eraser(_List_Nil),
																		$author$project$Utils$Html$noBreakSpace,
																		$elm$html$Html$text('Void')
																	])))) : $elm$core$Maybe$Nothing,
														$author$project$Api$Invoice$Meta$canDraftAndDestroyCurrentDraftAction(meta) ? $elm$core$Maybe$Just(
														A2(
															$author$project$Ui$Dropdown$item,
															_List_fromArray(
																[
																	$author$project$Ui$Dropdown$onSelect(
																	$author$project$Components$Invoice$ReturnToDraft(invoice))
																]),
															A2(
																$author$project$Ui$Element$view,
																_List_Nil,
																_List_fromArray(
																	[
																		$author$project$Ui$Icon$arrowLeft(_List_Nil),
																		$author$project$Utils$Html$noBreakSpace,
																		$elm$html$Html$text('Return To Draft')
																	])))) : $elm$core$Maybe$Nothing,
														$author$project$Api$Invoice$Meta$canMarkAsBadDebtAction(meta) ? $elm$core$Maybe$Just(
														A2(
															$author$project$Ui$Dropdown$item,
															_List_fromArray(
																[
																	$author$project$Ui$Dropdown$onSelect(
																	$author$project$Components$Invoice$MarkAsBadDebt(invoice))
																]),
															A2(
																$author$project$Ui$Element$view,
																_List_Nil,
																_List_fromArray(
																	[
																		$author$project$Ui$Icon$stop(_List_Nil),
																		$author$project$Utils$Html$noBreakSpace,
																		$elm$html$Html$text('Bad Debt')
																	])))) : $elm$core$Maybe$Nothing,
														$author$project$Api$Invoice$Meta$canReverseBadDebtAction(meta) ? $elm$core$Maybe$Just(
														A2(
															$author$project$Ui$Dropdown$item,
															_List_fromArray(
																[
																	$author$project$Ui$Dropdown$onSelect($author$project$Components$Invoice$ReverseBadDebt)
																]),
															A2(
																$author$project$Ui$Element$view,
																_List_Nil,
																_List_fromArray(
																	[
																		$author$project$Ui$Icon$arrowLeft(_List_Nil),
																		$author$project$Utils$Html$noBreakSpace,
																		$elm$html$Html$text('Return To Issued')
																	])))) : $elm$core$Maybe$Nothing
													]));
											return A4(
												$author$project$Ui$Dropdown$view,
												_List_fromArray(
													[
														$author$project$Ui$Dropdown$disabled(
														_Utils_eq(model.k9, $author$project$Api$Data$Loading)),
														$author$project$Ui$Dropdown$buttonWarning
													]),
												_List_fromArray(
													[
														$author$project$Ui$Icon$edit(_List_Nil),
														$author$project$Utils$Html$noBreakSpace,
														$elm$html$Html$text('Revise Invoice')
													]),
												actions,
												model.no);
										} else {
											return $author$project$Utils$Html$empty;
										}
									}(),
										function () {
										if ($author$project$Api$Invoice$One$isPayable(invoice) && ((!$author$project$Utils$Maybe$toBool(
											$author$project$Components$Invoice$companyDefaultSource(model.afQ))) && ((!$author$project$Components$Invoice$isNetwork(model.afQ)) && (!$author$project$Api$Invoice$One$viewingAsAffiliate(invoice))))) {
											var _v19 = model.tN;
											if (!_v19.$) {
												var paymentSourcesRoute = _v19.a;
												return A3(
													$author$project$Ui$Link$route,
													paymentSourcesRoute,
													_List_fromArray(
														[$author$project$Ui$Link$buttonDefault]),
													_List_fromArray(
														[
															$elm$html$Html$text('Add Payment Source')
														]));
											} else {
												return $author$project$Utils$Html$empty;
											}
										} else {
											return $author$project$Utils$Html$empty;
										}
									}(),
										$author$project$Api$Invoice$Meta$markAsPaidAction(meta) ? A3(
										$author$project$Ui$Button$view,
										{mm: 'Record payment'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$loading(
												_Utils_eq(model.k9, $author$project$Api$Data$Loading)),
												$author$project$Ui$Button$onClick(
												$author$project$Components$Invoice$RecordPayment(invoice)),
												$author$project$Ui$Button$icon($author$project$Ui$Icon$check)
											]),
										_List_fromArray(
											[
												$author$project$Components$Invoice$isNetwork(model.afQ) ? $elm$html$Html$text('Mark As Paid') : $elm$html$Html$text('Record Payment')
											])) : $author$project$Utils$Html$empty,
										($author$project$Api$Invoice$Meta$createPaymentAction(meta) && (!$author$project$Api$Invoice$One$viewingAsAffiliate(invoice))) ? A3(
										$author$project$Ui$Button$view,
										{mm: 'Process payment'},
										_List_fromArray(
											[
												$author$project$Ui$Button$success,
												$author$project$Ui$Button$loading(
												_Utils_eq(model.k9, $author$project$Api$Data$Loading)),
												$author$project$Ui$Button$onClick(
												$author$project$Components$Invoice$Pay(invoice)),
												$author$project$Ui$Button$icon($author$project$Ui$Icon$dollarSign)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Process Payment')
											])) : $author$project$Utils$Html$empty,
										($author$project$Api$Invoice$Meta$issueAction(meta) && (!$author$project$Api$Invoice$One$viewingAsAffiliate(invoice))) ? A2($author$project$Components$Invoice$viewIssueButton, model, invoice) : $author$project$Utils$Html$empty,
										($author$project$Api$Invoice$Meta$canDelete(meta) && (!$author$project$Api$Invoice$One$viewingAsAffiliate(invoice))) ? A3(
										$author$project$Ui$Button$view,
										{mm: 'Delete invoice'},
										_List_fromArray(
											[
												$author$project$Ui$Button$danger,
												$author$project$Ui$Button$loading(
												_Utils_eq(model.k9, $author$project$Api$Data$Loading)),
												$author$project$Ui$Button$onClick(
												$author$project$Components$Invoice$Delete(invoice))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Delete')
											])) : $author$project$Utils$Html$empty
									]);
							} else {
								return _List_fromArray(
									[
										$author$project$Ui$Spinner$view(_List_Nil)
									]);
							}
						}())
					]))
			]);
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$view = function (model) {
	return {
		fO: function () {
			var _v0 = model.gA;
			if (!_v0.$) {
				var invoiceComponent = _v0.a;
				return A2(
					$elm$core$List$map,
					$elm$html$Html$map($author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$InvoiceComponentMsg),
					A2($author$project$Components$Invoice$view, model.Gv, invoiceComponent));
			} else {
				return $author$project$Components$LoadingPage$view;
			}
		}(),
		ac9: 'Affiliates | Bills'
	};
};
var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$init, aiq: $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$load, k8: $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$save, alO: $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$subscriptions, adT: $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$update, amo: $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$view});
var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$GotAffiliate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$init = F4(
	function (_v0, practice, shared, _v1) {
		var query = _v1.DE;
		var params = _v1.YL;
		return _Utils_Tuple2(
			{
				rd: params.rd,
				Gv: shared.Gv,
				iz: $elm$core$Maybe$Nothing,
				dd: shared.dd,
				Zd: $author$project$Api$Provider$Practice$One$paymentProcessor(practice),
				DE: query,
				J7: shared.J7
			},
			A3($author$project$Api$Provider$Affiliate$retrieve, shared.Gv, params.rd, $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$GotAffiliate));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$BillsListMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$subscriptions = function (model) {
	var _v0 = model.iz;
	if (!_v0.$) {
		var billsList = _v0.a;
		return A2(
			$elm$core$Platform$Sub$map,
			$author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$BillsListMsg,
			$author$project$Components$Affiliates$BillsList$subscriptions(billsList));
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var response = msg.a;
			if (response.$ === 3) {
				var affiliate = response.a;
				var _v2 = $author$project$Components$Affiliates$BillsList$init(
					{
						Gn: $elm$core$Maybe$Just(affiliate),
						Gv: model.Gv,
						dd: model.dd,
						Is: $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Top(
							{rd: model.rd}),
						Zd: model.Zd,
						DE: model.DE,
						J7: model.J7
					});
				var billsList = _v2.a;
				var billsListCmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							iz: $elm$core$Maybe$Just(billsList)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$BillsListMsg, billsListCmd),
					_List_Nil);
			} else {
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			}
		} else {
			var subMsg = msg.a;
			var _v3 = model.iz;
			if (!_v3.$) {
				var billsList = _v3.a;
				var _v4 = A3($author$project$Components$Affiliates$BillsList$update, model.Gv, subMsg, billsList);
				var billsList_ = _v4.a;
				var billsListCmd = _v4.b;
				var billsListOutMsgs = _v4.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							iz: $elm$core$Maybe$Just(billsList_)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$BillsListMsg, billsListCmd),
					billsListOutMsgs);
			} else {
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
			}
		}
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				function () {
				var _v0 = model.iz;
				if (!_v0.$) {
					var billsList = _v0.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$BillsListMsg,
						$author$project$Components$Affiliates$BillsList$view(billsList));
				} else {
					return A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$textCenter]),
						_List_fromArray(
							[
								$author$project$Ui$Spinner$view(_List_Nil)
							]));
				}
			}()
			]),
		ac9: 'Affiliates | Bills'
	};
};
var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$init, aiq: $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$load, k8: $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$save, alO: $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$subscriptions, adT: $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$update, amo: $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$view});
var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$GotLocations = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Affiliates$Location$All$Location = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Affiliates$Location$Min$Location = $elm$core$Basics$identity;
var $author$project$Api$Provider$Affiliates$Location$Min$Record = F2(
	function (id, name) {
		return {ahP: id, Bq: name};
	});
var $author$project$Api$Provider$Affiliates$Location$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Affiliates$Location$Min$Record)));
var $author$project$Api$Provider$Affiliates$Location$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Affiliates$Location$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Affiliates$Location$All$Record = F2(
	function (activeLives, affiliateLocation) {
		return {KQ: activeLives, Lc: affiliateLocation};
	});
var $author$project$Api$Provider$Affiliates$Location$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'affiliate_location',
	$author$project$Api$Provider$Location$Min$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'active_lives',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Affiliates$Location$All$Record)));
var $author$project$Api$Provider$Affiliates$Location$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Affiliates$Location$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Affiliates$Location$Min$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Affiliates$Location$All$Location)));
var $author$project$Api$Provider$Affiliates$Location$locationsPath = function (affiliateId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['locations']),
		$author$project$Api$Provider$Affiliate$affiliatePath(affiliateId));
};
var $author$project$Api$Provider$Affiliates$Location$list = F3(
	function (apiClient, affiliateId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Affiliates$Location$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Affiliates$Location$locationsPath(affiliateId)));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$fetchLocations = function (model) {
	return A3($author$project$Api$Provider$Affiliates$Location$list, model.Gv, model.rd, $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$GotLocations);
};
var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$GotPractitioners = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Affiliates$Practitioner$All$Practitioner = $elm$core$Basics$identity;
var $author$project$Api$Provider$Affiliates$Practitioner$All$Record = F4(
	function (id, name, activeLives, affiliatePractitioner) {
		return {KQ: activeLives, Lf: affiliatePractitioner, ahP: id, Bq: name};
	});
var $author$project$Api$Provider$Affiliates$Practitioner$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'affiliate_practitioner',
	$author$project$Api$Provider$Practitioner$Min$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'active_lives',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$Affiliates$Practitioner$All$Record)))));
var $author$project$Api$Provider$Affiliates$Practitioner$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Affiliates$Practitioner$All$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Affiliates$Practitioner$practitionersPath = function (affiliateId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['practitioners']),
		$author$project$Api$Provider$Affiliate$affiliatePath(affiliateId));
};
var $author$project$Api$Provider$Affiliates$Practitioner$list = F3(
	function (apiClient, affiliateId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Affiliates$Practitioner$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Affiliates$Practitioner$practitionersPath(affiliateId)));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$fetchPractitioners = function (model) {
	return A3($author$project$Api$Provider$Affiliates$Practitioner$list, model.Gv, model.rd, $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$GotPractitioners);
};
var $author$project$Components$Affiliates$LinkRecordsModal$Closed = {$: 0};
var $author$project$Components$Affiliates$LinkRecordsModal$init = $author$project$Components$Affiliates$LinkRecordsModal$Closed;
var $author$project$Components$Affiliates$UnlinkRecordsModal$Closed = {$: 0};
var $author$project$Components$Affiliates$UnlinkRecordsModal$init = $author$project$Components$Affiliates$UnlinkRecordsModal$Closed;
var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$init = F4(
	function (session, practice, shared, _v0) {
		var params = _v0.YL;
		var model = {
			rd: params.rd,
			Gv: shared.Gv,
			ahK: shared.ahK,
			ok: $author$project$Components$Affiliates$LinkRecordsModal$init,
			Wg: $author$project$Api$Data$Loading,
			ZV: practice,
			Z4: $author$project$Api$Data$Loading,
			aa4: session,
			lG: $elm$core$Maybe$Nothing,
			qL: $author$project$Components$Affiliates$UnlinkRecordsModal$init,
			Km: A2($author$project$Utils$User$isViewingAsHinter, session, shared.ahK)
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$fetchPractitioners(model),
						$author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$fetchLocations(model)
					])));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$LinkRecordsModalMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$SyncPatientsModalMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$UnlinkRecordsModalMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Affiliates$LinkRecordsModal$CloseModal = {$: 5};
var $author$project$Components$Affiliates$LinkRecordsModal$subscriptions = function (model) {
	if (model.$ === 1) {
		return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Affiliates$LinkRecordsModal$CloseModal);
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Components$Affiliates$SyncPatientsModal$CloseModal = {$: 0};
var $author$project$Components$Affiliates$SyncPatientsModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Affiliates$SyncPatientsModal$CloseModal);
};
var $author$project$Components$Affiliates$UnlinkRecordsModal$CloseModal = {$: 1};
var $author$project$Components$Affiliates$UnlinkRecordsModal$subscriptions = function (model) {
	if (model.$ === 1) {
		return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Affiliates$UnlinkRecordsModal$CloseModal);
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$LinkRecordsModalMsg,
				$author$project$Components$Affiliates$LinkRecordsModal$subscriptions(model.ok)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$SyncPatientsModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Affiliates$SyncPatientsModal$subscriptions, model.lG))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$UnlinkRecordsModalMsg,
				$author$project$Components$Affiliates$UnlinkRecordsModal$subscriptions(model.qL))
			]));
};
var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$LinkedAllProviders = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Affiliates$SyncPatientsModal$Skip = 1;
var $author$project$Components$Affiliates$SyncPatientsModal$init = function (affiliateId) {
	return {Gg: 1, l6: $author$project$Api$Data$NotAsked, rd: affiliateId};
};
var $author$project$Api$Provider$Affiliate$linkAllProviders = F3(
	function (apiClient, affiliateId, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['link_all_practitioners']),
					$author$project$Api$Provider$Affiliate$affiliatePath(affiliateId))));
	});
var $author$project$Components$Affiliates$LinkRecordsModal$GotAffiliateLocations = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Affiliates$LinkRecordsModal$GotAffiliatePractitioners = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Affiliates$LinkRecordsModal$GotNetworkLocations = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Affiliates$LinkRecordsModal$GotNetworkPractitioners = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Affiliates$LinkRecordsModal$Linked = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Affiliates$LinkRecordsModal$LocationLinked = 2;
var $author$project$Components$Affiliates$LinkRecordsModal$None = 0;
var $author$project$Components$Affiliates$LinkRecordsModal$Open = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Affiliates$LinkRecordsModal$PractitionerLinked = 1;
var $author$project$Api$Provider$Affiliates$AffiliateLocation$Min$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Affiliates$AffiliateLocation$All$id = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Provider$Affiliates$AffiliateLocation$Min$id(min);
};
var $author$project$Api$Provider$Practitioner$Min$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Practitioner$Affiliate$id = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Provider$Practitioner$Min$id(min);
};
var $author$project$Components$Affiliates$LinkRecordsModal$formFieldsUpdate = F3(
	function (model, field, fields) {
		switch (field.$) {
			case 0:
				var id = field.a;
				var affiliatePractitioners = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$author$project$Api$Data$toMaybe(model.rf));
				return _Utils_update(
					fields,
					{
						Lf: A2(
							$elm_community$list_extra$List$Extra$find,
							function (practitioner) {
								return _Utils_eq(
									$author$project$Api$Provider$Practitioner$Affiliate$id(practitioner),
									id);
							},
							affiliatePractitioners)
					});
			case 1:
				var id = field.a;
				var affiliateLocations = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$author$project$Api$Data$toMaybe(model.re));
				return _Utils_update(
					fields,
					{
						Lc: A2(
							$elm_community$list_extra$List$Extra$find,
							function (location) {
								return _Utils_eq(
									$author$project$Api$Provider$Affiliates$AffiliateLocation$All$id(location),
									id);
							},
							affiliateLocations)
					});
			case 2:
				var id = field.a;
				var networkPractitioners = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$author$project$Api$Data$toMaybe(model.tg));
				return _Utils_update(
					fields,
					{
						tf: A2(
							$elm_community$list_extra$List$Extra$find,
							function (practitioner) {
								return _Utils_eq(
									$author$project$Api$Provider$Practitioner$All$id(practitioner),
									id);
							},
							networkPractitioners)
					});
			case 3:
				var id = field.a;
				var networkLocations = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$author$project$Api$Data$toMaybe(model.te));
				return _Utils_update(
					fields,
					{
						td: A2(
							$elm_community$list_extra$List$Extra$find,
							function (location) {
								return _Utils_eq(
									$author$project$Api$Provider$Location$All$id(location),
									id);
							},
							networkLocations)
					});
			default:
				var value = field.a;
				return _Utils_update(
					fields,
					{u0: value});
		}
	});
var $author$project$Components$Affiliates$LinkRecordsModal$AffiliateLocationValidation = 1;
var $author$project$Components$Affiliates$LinkRecordsModal$validateAffiliateLocation = F2(
	function (resource, fields) {
		var _v0 = _Utils_Tuple2(resource, fields.Lc);
		if ((_v0.a === 1) && (_v0.b.$ === 1)) {
			var _v1 = _v0.a;
			var _v2 = _v0.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(1, 'Please pick a location.')
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Affiliates$LinkRecordsModal$AffiliatePractitionerValidation = 0;
var $author$project$Components$Affiliates$LinkRecordsModal$validateAffiliatePractitioner = F2(
	function (resource, fields) {
		var _v0 = _Utils_Tuple2(resource, fields.Lf);
		if ((!_v0.a) && (_v0.b.$ === 1)) {
			var _v1 = _v0.a;
			var _v2 = _v0.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(0, 'Please pick a practitioner.')
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Affiliates$LinkRecordsModal$formFieldsValidator = function (resource) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$Affiliates$LinkRecordsModal$validateAffiliatePractitioner(resource)),
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$Affiliates$LinkRecordsModal$validateAffiliateLocation(resource))
			]));
};
var $author$project$Components$Affiliates$LinkRecordsModal$initFormFields = function (userIsHinter) {
	return {Lc: $elm$core$Maybe$Nothing, Lf: $elm$core$Maybe$Nothing, td: $elm$core$Maybe$Nothing, tf: $elm$core$Maybe$Nothing, u0: userIsHinter};
};
var $author$project$Api$Provider$Affiliates$Location$link = F5(
	function (apiClient, affiliateId, affiliateLocationId, networkLocationId, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'network_location_id',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, networkLocationId)),
					_Utils_Tuple2(
					'affiliate_location_id',
					$elm$json$Json$Encode$string(affiliateLocationId))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Affiliates$Location$locationsPath(affiliateId))));
	});
var $author$project$Api$Provider$Affiliates$Practitioner$link = F6(
	function (apiClient, affiliateId, affiliatePractitionerId, networkPractitionerId, syncToRentalNetworks, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'network_practitioner_id',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, networkPractitionerId)),
					_Utils_Tuple2(
					'affiliate_practitioner_id',
					$elm$json$Json$Encode$string(affiliatePractitionerId)),
					_Utils_Tuple2(
					'sync_to_rental_networks',
					$elm$json$Json$Encode$bool(syncToRentalNetworks))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Affiliates$Practitioner$practitionersPath(affiliateId))));
	});
var $author$project$Api$Provider$Affiliates$AffiliateLocation$affiliateLocationsPath = function (affiliateId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['affiliate_locations']),
		$author$project$Api$Provider$Affiliate$affiliatePath(affiliateId));
};
var $author$project$Api$Provider$Affiliates$AffiliateLocation$All$AffiliateLocation = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Affiliates$AffiliateLocation$Min$AffiliateLocation = $elm$core$Basics$identity;
var $author$project$Api$Provider$Affiliates$AffiliateLocation$Min$Record = F2(
	function (id, name) {
		return {ahP: id, Bq: name};
	});
var $author$project$Api$Provider$Affiliates$AffiliateLocation$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Affiliates$AffiliateLocation$Min$Record)));
var $author$project$Api$Provider$Affiliates$AffiliateLocation$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Affiliates$AffiliateLocation$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Affiliates$AffiliateLocation$All$Record = function (synced) {
	return {acN: synced};
};
var $author$project$Api$Provider$Affiliates$AffiliateLocation$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'synced',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Location$Min$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Affiliates$AffiliateLocation$All$Record));
var $author$project$Api$Provider$Affiliates$AffiliateLocation$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Affiliates$AffiliateLocation$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Affiliates$AffiliateLocation$Min$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Affiliates$AffiliateLocation$All$AffiliateLocation)));
var $author$project$Api$Provider$Affiliates$AffiliateLocation$list = F3(
	function (apiClient, affiliateId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Affiliates$AffiliateLocation$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Affiliates$AffiliateLocation$affiliateLocationsPath(affiliateId)));
	});
var $author$project$Api$Provider$Affiliates$AffiliatePractitioner$affiliatePractitionersPath = function (affiliateId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['affiliate_practitioners']),
		$author$project$Api$Provider$Affiliate$affiliatePath(affiliateId));
};
var $author$project$Api$Provider$Practitioner$Affiliate$Practitioner = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Practitioner$Affiliate$Record = function (synced) {
	return {acN: synced};
};
var $author$project$Api$Provider$Practitioner$Affiliate$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'synced',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Practitioner$Min$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Practitioner$Affiliate$Record));
var $author$project$Api$Provider$Practitioner$Affiliate$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Practitioner$Affiliate$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Practitioner$Min$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Practitioner$Affiliate$Practitioner)));
var $author$project$Api$Provider$Affiliates$AffiliatePractitioner$list = F3(
	function (apiClient, affiliateId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Practitioner$Affiliate$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Affiliates$AffiliatePractitioner$affiliatePractitionersPath(affiliateId)));
	});
var $author$project$Components$Affiliates$LinkRecordsModal$update = F4(
	function (apiClient, msg, model, userIsHinter) {
		switch (msg.$) {
			case 0:
				var affiliateId = msg.a;
				var resource = msg.b;
				var form = $author$project$Utils$Form$init(
					$author$project$Components$Affiliates$LinkRecordsModal$initFormFields(userIsHinter));
				return {
					GZ: function () {
						if (!resource) {
							return $elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A3($author$project$Api$Provider$Affiliates$AffiliatePractitioner$list, apiClient, affiliateId, $author$project$Components$Affiliates$LinkRecordsModal$GotAffiliatePractitioners),
										A3($author$project$Api$Provider$Practitioner$list, apiClient, $elm$core$Basics$identity, $author$project$Components$Affiliates$LinkRecordsModal$GotNetworkPractitioners)
									]));
						} else {
							return $elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A3($author$project$Api$Provider$Affiliates$AffiliateLocation$list, apiClient, affiliateId, $author$project$Components$Affiliates$LinkRecordsModal$GotAffiliateLocations),
										A3($author$project$Api$Provider$Location$list, apiClient, $elm$core$Basics$identity, $author$project$Components$Affiliates$LinkRecordsModal$GotNetworkLocations)
									]));
						}
					}(),
					agZ: 0,
					aiO: $author$project$Components$Affiliates$LinkRecordsModal$Open(
						{rd: affiliateId, re: $author$project$Api$Data$Loading, rf: $author$project$Api$Data$Loading, SD: form, te: $author$project$Api$Data$Loading, tg: $author$project$Api$Data$Loading, Jy: resource, k9: $author$project$Api$Data$NotAsked, Km: userIsHinter}),
					aR: _List_Nil
				};
			case 1:
				var response = msg.a;
				if (model.$ === 1) {
					var openModel = model.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: $author$project$Components$Affiliates$LinkRecordsModal$Open(
							_Utils_update(
								openModel,
								{rf: response})),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: $author$project$Components$Affiliates$LinkRecordsModal$Closed, aR: _List_Nil};
				}
			case 2:
				var response = msg.a;
				if (model.$ === 1) {
					var openModel = model.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: $author$project$Components$Affiliates$LinkRecordsModal$Open(
							_Utils_update(
								openModel,
								{re: response})),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: $author$project$Components$Affiliates$LinkRecordsModal$Closed, aR: _List_Nil};
				}
			case 3:
				var response = msg.a;
				if (model.$ === 1) {
					var openModel = model.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: $author$project$Components$Affiliates$LinkRecordsModal$Open(
							_Utils_update(
								openModel,
								{tg: response})),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: $author$project$Components$Affiliates$LinkRecordsModal$Closed, aR: _List_Nil};
				}
			case 4:
				var response = msg.a;
				if (model.$ === 1) {
					var openModel = model.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: $author$project$Components$Affiliates$LinkRecordsModal$Open(
							_Utils_update(
								openModel,
								{te: response})),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: $author$project$Components$Affiliates$LinkRecordsModal$Closed, aR: _List_Nil};
				}
			case 5:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: $author$project$Components$Affiliates$LinkRecordsModal$Closed, aR: _List_Nil};
			case 6:
				var field = msg.a;
				if (model.$ === 1) {
					var openModel = model.a;
					var newForm = A3(
						$author$project$Utils$Form$update,
						$author$project$Components$Affiliates$LinkRecordsModal$formFieldsUpdate(openModel),
						field,
						openModel.SD);
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: $author$project$Components$Affiliates$LinkRecordsModal$Open(
							_Utils_update(
								openModel,
								{SD: newForm})),
						aR: _List_Nil
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: $author$project$Components$Affiliates$LinkRecordsModal$Closed, aR: _List_Nil};
				}
			case 7:
				if (model.$ === 1) {
					var openModel = model.a;
					var _v8 = A2(
						$author$project$Utils$Form$validate,
						$author$project$Components$Affiliates$LinkRecordsModal$formFieldsValidator(openModel.Jy),
						openModel.SD);
					if (!_v8.$) {
						var _v9 = _v8.a;
						var newForm = _v9.a;
						var validFormFields = _v9.b;
						var cmd = function () {
							var _v10 = openModel.Jy;
							if (!_v10) {
								var _v11 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
								var affiliatePractitioner = _v11.Lf;
								var networkPractitioner = _v11.tf;
								var syncToRentalNetworks = _v11.u0;
								return A6(
									$author$project$Api$Provider$Affiliates$Practitioner$link,
									apiClient,
									openModel.rd,
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2($elm$core$Maybe$map, $author$project$Api$Provider$Practitioner$Affiliate$id, affiliatePractitioner)),
									A2($elm$core$Maybe$map, $author$project$Api$Provider$Practitioner$All$id, networkPractitioner),
									syncToRentalNetworks,
									$author$project$Components$Affiliates$LinkRecordsModal$Linked);
							} else {
								var _v12 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
								var affiliateLocation = _v12.Lc;
								var networkLocation = _v12.td;
								return A5(
									$author$project$Api$Provider$Affiliates$Location$link,
									apiClient,
									openModel.rd,
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2($elm$core$Maybe$map, $author$project$Api$Provider$Affiliates$AffiliateLocation$All$id, affiliateLocation)),
									A2($elm$core$Maybe$map, $author$project$Api$Provider$Location$All$id, networkLocation),
									$author$project$Components$Affiliates$LinkRecordsModal$Linked);
							}
						}();
						return {
							GZ: cmd,
							agZ: 0,
							aiO: $author$project$Components$Affiliates$LinkRecordsModal$Open(
								_Utils_update(
									openModel,
									{SD: newForm, k9: $author$project$Api$Data$Loading})),
							aR: _List_Nil
						};
					} else {
						var newForm = _v8.a;
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 0,
							aiO: $author$project$Components$Affiliates$LinkRecordsModal$Open(
								_Utils_update(
									openModel,
									{SD: newForm})),
							aR: _List_Nil
						};
					}
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: $author$project$Components$Affiliates$LinkRecordsModal$Closed, aR: _List_Nil};
				}
			default:
				var response = msg.a;
				if (model.$ === 1) {
					var openModel = model.a;
					switch (response.$) {
						case 3:
							var _v15 = function () {
								var _v16 = openModel.Jy;
								if (!_v16) {
									return _Utils_Tuple2('Practitioner linked!', 1);
								} else {
									return _Utils_Tuple2('Location linked!', 2);
								}
							}();
							var message = _v15.a;
							var event = _v15.b;
							return {
								GZ: $elm$core$Platform$Cmd$none,
								agZ: event,
								aiO: $author$project$Components$Affiliates$LinkRecordsModal$Closed,
								aR: _List_fromArray(
									[
										A2($author$project$OutMsg$ShowToast, 3, message),
										$author$project$OutMsg$RefreshPractice
									])
							};
						case 2:
							return {
								GZ: $elm$core$Platform$Cmd$none,
								agZ: 0,
								aiO: $author$project$Components$Affiliates$LinkRecordsModal$Open(
									_Utils_update(
										openModel,
										{k9: response})),
								aR: $author$project$OutMsg$handleErrorResponse(response)
							};
						default:
							return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
					}
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: $author$project$Components$Affiliates$LinkRecordsModal$Closed, aR: _List_Nil};
				}
		}
	});
var $author$project$Components$Affiliates$SyncPatientsModal$Activated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Affiliates$SyncPatientsModal$ActivationSkiped = 3;
var $author$project$Components$Affiliates$SyncPatientsModal$AffiliateActivated = 2;
var $author$project$Components$Affiliates$SyncPatientsModal$Closed = 1;
var $author$project$Components$Affiliates$SyncPatientsModal$None = 0;
var $author$project$Api$Provider$Affiliate$activate = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$Affiliate$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['activate']),
					$author$project$Api$Provider$Affiliate$affiliatePath(id_))));
	});
var $author$project$Components$Affiliates$SyncPatientsModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: 1, aiO: model, aR: _List_Nil};
			case 1:
				var action = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{Gg: action}),
					aR: _List_Nil
				};
			case 2:
				var _v1 = function () {
					var _v2 = model.Gg;
					if (!_v2) {
						return _Utils_Tuple3(
							$author$project$Api$Data$Loading,
							A3($author$project$Api$Provider$Affiliate$activate, apiClient, model.rd, $author$project$Components$Affiliates$SyncPatientsModal$Activated),
							0);
					} else {
						return _Utils_Tuple3(model.l6, $elm$core$Platform$Cmd$none, 3);
					}
				}();
				var activateRequest = _v1.a;
				var cmd = _v1.b;
				var event = _v1.c;
				return {
					GZ: cmd,
					agZ: event,
					aiO: _Utils_update(
						model,
						{l6: activateRequest}),
					aR: _List_Nil
				};
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 2,
						aiO: model,
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Sync synccessful')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{l6: response}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
		}
	});
var $author$project$Components$Affiliates$UnlinkRecordsModal$LocationUnlinked = 2;
var $author$project$Components$Affiliates$UnlinkRecordsModal$None = 0;
var $author$project$Components$Affiliates$UnlinkRecordsModal$Open = F4(
	function (a, b, c, d) {
		return {$: 1, a: a, b: b, c: c, d: d};
	});
var $author$project$Components$Affiliates$UnlinkRecordsModal$PractitionerUnlinked = 1;
var $author$project$Components$Affiliates$UnlinkRecordsModal$ReassignLocation = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Affiliates$UnlinkRecordsModal$ReassignPractitioner = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Affiliates$UnlinkRecordsModal$TerminateLocation = {$: 3};
var $author$project$Components$Affiliates$UnlinkRecordsModal$TerminatePractitioner = {$: 1};
var $author$project$Components$Affiliates$UnlinkRecordsModal$Unlinked = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Affiliates$Location$Min$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Affiliates$Location$All$id = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Provider$Affiliates$Location$Min$id(min);
};
var $author$project$Api$Provider$Affiliates$Practitioner$All$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Components$Affiliates$UnlinkRecordsModal$isValid = function (action) {
	switch (action.$) {
		case 0:
			var newPractitioner = action.b;
			return $author$project$Utils$Maybe$toBool(newPractitioner);
		case 2:
			var newLocation = action.b;
			return $author$project$Utils$Maybe$toBool(newLocation);
		case 1:
			return true;
		default:
			return true;
	}
};
var $author$project$Api$Provider$Affiliates$Location$locationPath = F2(
	function (affiliateId, id) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id]),
			$author$project$Api$Provider$Affiliates$Location$locationsPath(affiliateId));
	});
var $author$project$Api$Provider$Affiliates$Location$unlink = F5(
	function (apiClient, affiliateId, id, reassignToId, toMsg) {
		var body = $elm$json$Json$Encode$object(
			function () {
				if (!reassignToId.$) {
					var reassignToId_ = reassignToId.a;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'reassign_to_id',
							$elm$json$Json$Encode$string(reassignToId_))
						]);
				} else {
					return _List_Nil;
				}
			}());
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['unlink']),
						A2($author$project$Api$Provider$Affiliates$Location$locationPath, affiliateId, id)))));
	});
var $author$project$Api$Provider$Affiliates$Practitioner$practitionerPath = F2(
	function (affiliateId, id) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id]),
			$author$project$Api$Provider$Affiliates$Practitioner$practitionersPath(affiliateId));
	});
var $author$project$Api$Provider$Affiliates$Practitioner$unlink = F5(
	function (apiClient, affiliateId, id, reassignToId, toMsg) {
		var body = $elm$json$Json$Encode$object(
			function () {
				if (!reassignToId.$) {
					var reassignToId_ = reassignToId.a;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'reassign_to_id',
							$elm$json$Json$Encode$string(reassignToId_))
						]);
				} else {
					return _List_Nil;
				}
			}());
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['unlink']),
						A2($author$project$Api$Provider$Affiliates$Practitioner$practitionerPath, affiliateId, id)))));
	});
var $author$project$Components$Affiliates$UnlinkRecordsModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var affiliateId = msg.a;
				var resource = msg.b;
				var action = function () {
					if (!resource.$) {
						var remainingPractitioners = resource.b;
						return $elm$core$List$isEmpty(remainingPractitioners) ? $author$project$Components$Affiliates$UnlinkRecordsModal$TerminatePractitioner : A2($author$project$Components$Affiliates$UnlinkRecordsModal$ReassignPractitioner, remainingPractitioners, $elm$core$Maybe$Nothing);
					} else {
						var remainingLocations = resource.b;
						return $elm$core$List$isEmpty(remainingLocations) ? $author$project$Components$Affiliates$UnlinkRecordsModal$TerminateLocation : A2($author$project$Components$Affiliates$UnlinkRecordsModal$ReassignLocation, remainingLocations, $elm$core$Maybe$Nothing);
					}
				}();
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: A4($author$project$Components$Affiliates$UnlinkRecordsModal$Open, affiliateId, resource, action, $author$project$Api$Data$NotAsked),
					aR: _List_Nil
				};
			case 1:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: $author$project$Components$Affiliates$UnlinkRecordsModal$Closed, aR: _List_Nil};
			case 3:
				var action = msg.a;
				if (model.$ === 1) {
					var practitioner = model.a;
					var remainingPractitioners = model.b;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: A4($author$project$Components$Affiliates$UnlinkRecordsModal$Open, practitioner, remainingPractitioners, action, $author$project$Api$Data$NotAsked),
						aR: _List_Nil
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: $author$project$Components$Affiliates$UnlinkRecordsModal$Closed, aR: _List_Nil};
				}
			case 5:
				var id = msg.a;
				if (model.$ === 1) {
					var affiliateId = model.a;
					var resource = model.b;
					var action = model.c;
					var response = model.d;
					switch (action.$) {
						case 0:
							var remainingPractitioners = action.a;
							var newPractitioner = A2(
								$elm_community$list_extra$List$Extra$find,
								function (practitioner_) {
									return _Utils_eq(
										id,
										$author$project$Api$Provider$Affiliates$Practitioner$All$id(practitioner_));
								},
								remainingPractitioners);
							return {
								GZ: $elm$core$Platform$Cmd$none,
								agZ: 0,
								aiO: A4(
									$author$project$Components$Affiliates$UnlinkRecordsModal$Open,
									affiliateId,
									resource,
									A2($author$project$Components$Affiliates$UnlinkRecordsModal$ReassignPractitioner, remainingPractitioners, newPractitioner),
									response),
								aR: _List_Nil
							};
						case 2:
							var remainingLocations = action.a;
							var newLocation = A2(
								$elm_community$list_extra$List$Extra$find,
								function (location) {
									return _Utils_eq(
										id,
										$author$project$Api$Provider$Affiliates$Location$All$id(location));
								},
								remainingLocations);
							return {
								GZ: $elm$core$Platform$Cmd$none,
								agZ: 0,
								aiO: A4(
									$author$project$Components$Affiliates$UnlinkRecordsModal$Open,
									affiliateId,
									resource,
									A2($author$project$Components$Affiliates$UnlinkRecordsModal$ReassignLocation, remainingLocations, newLocation),
									response),
								aR: _List_Nil
							};
						case 1:
							return {
								GZ: $elm$core$Platform$Cmd$none,
								agZ: 0,
								aiO: A4($author$project$Components$Affiliates$UnlinkRecordsModal$Open, affiliateId, resource, $author$project$Components$Affiliates$UnlinkRecordsModal$TerminatePractitioner, response),
								aR: _List_Nil
							};
						default:
							return {
								GZ: $elm$core$Platform$Cmd$none,
								agZ: 0,
								aiO: A4($author$project$Components$Affiliates$UnlinkRecordsModal$Open, affiliateId, resource, $author$project$Components$Affiliates$UnlinkRecordsModal$TerminateLocation, response),
								aR: _List_Nil
							};
					}
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: $author$project$Components$Affiliates$UnlinkRecordsModal$Closed, aR: _List_Nil};
				}
			case 2:
				if (model.$ === 1) {
					var affiliateId = model.a;
					var resource = model.b;
					var action = model.c;
					if ($author$project$Components$Affiliates$UnlinkRecordsModal$isValid(action)) {
						var id = function () {
							if (!resource.$) {
								var practitioner = resource.a;
								return $author$project$Api$Provider$Affiliates$Practitioner$All$id(practitioner);
							} else {
								var location = resource.a;
								return $author$project$Api$Provider$Affiliates$Location$All$id(location);
							}
						}();
						var cmd = function () {
							switch (action.$) {
								case 0:
									var newPractitioner_ = action.b;
									return A5(
										$author$project$Api$Provider$Affiliates$Practitioner$unlink,
										apiClient,
										affiliateId,
										id,
										A2($elm$core$Maybe$map, $author$project$Api$Provider$Affiliates$Practitioner$All$id, newPractitioner_),
										$author$project$Components$Affiliates$UnlinkRecordsModal$Unlinked);
								case 2:
									var newLocation_ = action.b;
									return A5(
										$author$project$Api$Provider$Affiliates$Location$unlink,
										apiClient,
										affiliateId,
										id,
										A2($elm$core$Maybe$map, $author$project$Api$Provider$Affiliates$Location$All$id, newLocation_),
										$author$project$Components$Affiliates$UnlinkRecordsModal$Unlinked);
								case 1:
									return A5($author$project$Api$Provider$Affiliates$Practitioner$unlink, apiClient, affiliateId, id, $elm$core$Maybe$Nothing, $author$project$Components$Affiliates$UnlinkRecordsModal$Unlinked);
								default:
									return A5($author$project$Api$Provider$Affiliates$Location$unlink, apiClient, affiliateId, id, $elm$core$Maybe$Nothing, $author$project$Components$Affiliates$UnlinkRecordsModal$Unlinked);
							}
						}();
						return {
							GZ: cmd,
							agZ: 0,
							aiO: A4($author$project$Components$Affiliates$UnlinkRecordsModal$Open, affiliateId, resource, action, $author$project$Api$Data$Loading),
							aR: _List_Nil
						};
					} else {
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 0,
							aiO: A4($author$project$Components$Affiliates$UnlinkRecordsModal$Open, affiliateId, resource, action, $author$project$Api$Data$NotAsked),
							aR: _List_Nil
						};
					}
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: $author$project$Components$Affiliates$UnlinkRecordsModal$Closed, aR: _List_Nil};
				}
			default:
				var response = msg.a;
				if (model.$ === 1) {
					var affiliateId = model.a;
					var resource = model.b;
					var action = model.c;
					switch (response.$) {
						case 3:
							var _v10 = function () {
								if (!resource.$) {
									return _Utils_Tuple2('Practitioner unlinked!', 1);
								} else {
									return _Utils_Tuple2('Location unlinked!', 2);
								}
							}();
							var message = _v10.a;
							var event = _v10.b;
							return {
								GZ: $elm$core$Platform$Cmd$none,
								agZ: event,
								aiO: $author$project$Components$Affiliates$UnlinkRecordsModal$Closed,
								aR: _List_fromArray(
									[
										A2($author$project$OutMsg$ShowToast, 3, message),
										$author$project$OutMsg$RefreshPractice
									])
							};
						case 2:
							return {
								GZ: $elm$core$Platform$Cmd$none,
								agZ: 0,
								aiO: A4($author$project$Components$Affiliates$UnlinkRecordsModal$Open, affiliateId, resource, action, response),
								aR: $author$project$OutMsg$handleErrorResponse(response)
							};
						default:
							return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
					}
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: $author$project$Components$Affiliates$UnlinkRecordsModal$Closed, aR: _List_Nil};
				}
		}
	});
var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Z4: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Wg: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 2:
				var subMsg = msg.a;
				var unlinkRecordsModalResutl = A3($author$project$Components$Affiliates$UnlinkRecordsModal$update, model.Gv, subMsg, model.qL);
				var _v1 = function () {
					var _v2 = unlinkRecordsModalResutl.agZ;
					switch (_v2) {
						case 0:
							return _Utils_Tuple3(model.Z4, model.Wg, $elm$core$Platform$Cmd$none);
						case 1:
							return _Utils_Tuple3(
								$author$project$Api$Data$Loading,
								model.Wg,
								$author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$fetchPractitioners(model));
						default:
							return _Utils_Tuple3(
								model.Z4,
								$author$project$Api$Data$Loading,
								$author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$fetchLocations(model));
					}
				}();
				var practitioners = _v1.a;
				var locations = _v1.b;
				var cmd = _v1.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Wg: locations, Z4: practitioners, qL: unlinkRecordsModalResutl.aiO}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$UnlinkRecordsModalMsg, unlinkRecordsModalResutl.GZ),
								cmd
							])),
					unlinkRecordsModalResutl.aR);
			case 3:
				var subMsg = msg.a;
				var linkRecordsModalResutl = A4($author$project$Components$Affiliates$LinkRecordsModal$update, model.Gv, subMsg, model.ok, model.Km);
				var _v3 = function () {
					var _v4 = linkRecordsModalResutl.agZ;
					switch (_v4) {
						case 0:
							return _Utils_Tuple3(model.Z4, model.Wg, $elm$core$Platform$Cmd$none);
						case 1:
							return _Utils_Tuple3(
								$author$project$Api$Data$Loading,
								model.Wg,
								$author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$fetchPractitioners(model));
						default:
							return _Utils_Tuple3(
								model.Z4,
								$author$project$Api$Data$Loading,
								$author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$fetchLocations(model));
					}
				}();
				var practitioners = _v3.a;
				var locations = _v3.b;
				var cmd = _v3.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ok: linkRecordsModalResutl.aiO, Wg: locations, Z4: practitioners}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$LinkRecordsModalMsg, linkRecordsModalResutl.GZ),
								cmd
							])),
					linkRecordsModalResutl.aR);
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							lG: $elm$core$Maybe$Just(
								$author$project$Components$Affiliates$SyncPatientsModal$init(model.rd))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var subMsg = msg.a;
				var _v5 = model.lG;
				if (!_v5.$) {
					var syncPatientsModal = _v5.a;
					var syncPatientsModalResutl = A3($author$project$Components$Affiliates$SyncPatientsModal$update, model.Gv, subMsg, syncPatientsModal);
					var _v6 = function () {
						var _v7 = syncPatientsModalResutl.agZ;
						switch (_v7) {
							case 0:
								return _Utils_Tuple2(
									$elm$core$Maybe$Just(syncPatientsModalResutl.aiO),
									$elm$core$Platform$Cmd$none);
							case 1:
								return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
							case 3:
								return _Utils_Tuple2(
									$elm$core$Maybe$Nothing,
									A2(
										$author$project$Utils$Route$navigate,
										$elm$core$Dict$empty,
										$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Top(
											{rd: model.rd})));
							default:
								return _Utils_Tuple2(
									$elm$core$Maybe$Nothing,
									A2(
										$author$project$Utils$Route$navigate,
										$elm$core$Dict$empty,
										$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Top(
											{rd: model.rd})));
						}
					}();
					var syncPatientsModal_ = _v6.a;
					var cmd = _v6.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{lG: syncPatientsModal_}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$SyncPatientsModalMsg, syncPatientsModalResutl.GZ),
									cmd
								])),
						syncPatientsModalResutl.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var cmd = A3($author$project$Api$Provider$Affiliate$linkAllProviders, model.Gv, model.rd, $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$LinkedAllProviders);
				return _Utils_Tuple3(model, cmd, _List_Nil);
			default:
				var response = msg.a;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'A job has been queued to link all providers, and an email will be sent to you when it\'s complete.'),
									$author$project$OutMsg$RefreshPractice
								]));
					case 2:
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$SyncPatients = {$: 4};
var $author$project$Components$Affiliates$LinkRecordsModal$FormUpdated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Affiliates$LinkRecordsModal$Link = {$: 7};
var $author$project$Components$Affiliates$LinkRecordsModal$SyncToRentalNetworks = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Affiliates$LinkRecordsModal$resourceName = function (resource) {
	if (!resource) {
		return 'provider';
	} else {
		return 'location';
	}
};
var $author$project$Components$Affiliates$LinkRecordsModal$AffiliateLocation = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Affiliates$LinkRecordsModal$AffiliatePractitioner = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Affiliates$AffiliateLocation$Min$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$Affiliates$AffiliateLocation$All$name = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Provider$Affiliates$AffiliateLocation$Min$name(min);
};
var $author$project$Api$Provider$Practitioner$Affiliate$name = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Provider$Practitioner$Min$name(min);
};
var $author$project$Api$Provider$Affiliates$AffiliateLocation$All$synced = function (_v0) {
	var record = _v0.b;
	return record.acN;
};
var $author$project$Api$Provider$Practitioner$Affiliate$synced = function (_v0) {
	var record = _v0.b;
	return record.acN;
};
var $author$project$Components$Affiliates$LinkRecordsModal$affiliateRecordOptions = F3(
	function (resource, practitioners, locations) {
		var affiliateRecords = function () {
			if (!resource) {
				return A2(
					$elm$core$List$map,
					function (practitioner) {
						return {
							ahP: $author$project$Api$Provider$Practitioner$Affiliate$id(practitioner),
							Vf: A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practitioner$Affiliate$synced, $author$project$Utils$Maybe$toBool)(practitioner),
							Bq: $author$project$Api$Provider$Practitioner$Affiliate$name(practitioner)
						};
					},
					practitioners);
			} else {
				return A2(
					$elm$core$List$map,
					function (location) {
						return {
							ahP: $author$project$Api$Provider$Affiliates$AffiliateLocation$All$id(location),
							Vf: A2($elm$core$Basics$composeR, $author$project$Api$Provider$Affiliates$AffiliateLocation$All$synced, $author$project$Utils$Maybe$toBool)(location),
							Bq: $author$project$Api$Provider$Affiliates$AffiliateLocation$All$name(location)
						};
					},
					locations);
			}
		}();
		var notSynced = A2(
			$elm_community$list_extra$List$Extra$filterNot,
			function ($) {
				return $.Vf;
			},
			affiliateRecords);
		var sortedNotSynced = function () {
			if (resource === 1) {
				return A2(
					$elm$core$List$sortBy,
					function (record) {
						return $elm$core$String$toLower(record.Bq);
					},
					notSynced);
			} else {
				return notSynced;
			}
		}();
		return A2(
			$elm$core$List$cons,
			A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(''),
				'Choose a ' + ($author$project$Components$Affiliates$LinkRecordsModal$resourceName(resource) + '...')),
			A2(
				$elm$core$List$map,
				function (affiliateRecord) {
					return A3(
						$author$project$Ui$Form$Select$option,
						_List_Nil,
						$elm$core$Maybe$Just(affiliateRecord.ahP),
						affiliateRecord.Bq);
				},
				sortedNotSynced));
	});
var $author$project$Components$Affiliates$LinkRecordsModal$viewAffiliateRecordSelect = function (model) {
	var fields = $author$project$Utils$Form$fields(model.SD);
	var _v0 = function () {
		var _v1 = _Utils_Tuple3(model.Jy, model.rf, model.re);
		if (!_v1.a) {
			if (_v1.b.$ === 3) {
				var _v2 = _v1.a;
				var _v3 = _v1.b;
				var list = _v3.a;
				return _Utils_Tuple3(false, list, _List_Nil);
			} else {
				var _v4 = _v1.a;
				return _Utils_Tuple3(true, _List_Nil, _List_Nil);
			}
		} else {
			if (_v1.c.$ === 3) {
				var _v5 = _v1.a;
				var _v6 = _v1.c;
				var list = _v6.a;
				return _Utils_Tuple3(false, _List_Nil, list);
			} else {
				var _v7 = _v1.a;
				return _Utils_Tuple3(true, _List_Nil, _List_Nil);
			}
		}
	}();
	var loading = _v0.a;
	var practitioners_ = _v0.b;
	var locations_ = _v0.c;
	var selectOptions = A3($author$project$Components$Affiliates$LinkRecordsModal$affiliateRecordOptions, model.Jy, practitioners_, locations_);
	var _v8 = function () {
		var _v9 = model.Jy;
		if (!_v9) {
			return _Utils_Tuple2(
				A2($elm$core$Maybe$map, $author$project$Api$Provider$Practitioner$Affiliate$id, fields.Lf),
				$author$project$Components$Affiliates$LinkRecordsModal$AffiliatePractitioner);
		} else {
			return _Utils_Tuple2(
				A2($elm$core$Maybe$map, $author$project$Api$Provider$Affiliates$AffiliateLocation$All$id, fields.Lc),
				$author$project$Components$Affiliates$LinkRecordsModal$AffiliateLocation);
		}
	}();
	var id = _v8.a;
	var field = _v8.b;
	var _v10 = function () {
		var _v11 = model.Jy;
		if (!_v11) {
			return _Utils_Tuple2(
				A2($author$project$Utils$Form$hasValidationErrors, 0, model.SD),
				A2($author$project$Utils$Form$validationErrors, 0, model.SD));
		} else {
			return _Utils_Tuple2(
				A2($author$project$Utils$Form$hasValidationErrors, 1, model.SD),
				A2($author$project$Utils$Form$validationErrors, 1, model.SD));
		}
	}();
	var invalid = _v10.a;
	var errors = _v10.b;
	return ((!loading) && ($elm$core$List$length(selectOptions) === 1)) ? A2(
		$author$project$Ui$Alert$warning,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('No more affiliate '),
				$elm$html$Html$text(
				$author$project$Components$Affiliates$LinkRecordsModal$resourceName(model.Jy)),
				$elm$html$Html$text('s')
			])) : A2(
		$author$project$Ui$Form$Select$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Select$value(id),
				$author$project$Ui$Form$Select$onChange(
				A2($elm$core$Basics$composeL, $author$project$Components$Affiliates$LinkRecordsModal$FormUpdated, field)),
				$author$project$Ui$Form$Select$invalid(invalid),
				$author$project$Ui$Form$Select$errors(errors),
				$author$project$Ui$Form$Select$loading(loading)
			]),
		selectOptions);
};
var $author$project$Components$Affiliates$LinkRecordsModal$NetworkLocation = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Affiliates$LinkRecordsModal$NetworkLocationValidation = 3;
var $author$project$Components$Affiliates$LinkRecordsModal$NetworkPractitioner = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Affiliates$LinkRecordsModal$NetworkPractitionerValidation = 2;
var $author$project$Components$Affiliates$LinkRecordsModal$networkRecordOptions = F3(
	function (resource, practitioners, locations) {
		var networkRecords = function () {
			if (!resource) {
				return A2(
					$elm$core$List$map,
					function (practitioner) {
						return {
							ahP: $author$project$Api$Provider$Practitioner$All$id(practitioner),
							Vf: $author$project$Api$Provider$Practitioner$All$isSynced(practitioner),
							Bq: $author$project$Api$Provider$Practitioner$All$name(practitioner)
						};
					},
					practitioners);
			} else {
				return A2(
					$elm$core$List$map,
					function (location) {
						return {
							ahP: $author$project$Api$Provider$Location$All$id(location),
							Vf: $author$project$Api$Provider$Location$All$isSynced(location),
							Bq: $author$project$Api$Provider$Location$All$name(location)
						};
					},
					locations);
			}
		}();
		var notSynced = A2(
			$elm_community$list_extra$List$Extra$filterNot,
			function ($) {
				return $.Vf;
			},
			networkRecords);
		return A2(
			$elm$core$List$cons,
			A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(''),
				'Create new network ' + $author$project$Components$Affiliates$LinkRecordsModal$resourceName(resource)),
			A2(
				$elm$core$List$map,
				function (networkRecord) {
					return A3(
						$author$project$Ui$Form$Select$option,
						_List_Nil,
						$elm$core$Maybe$Just(networkRecord.ahP),
						networkRecord.Bq);
				},
				notSynced));
	});
var $author$project$Components$Affiliates$LinkRecordsModal$viewNetworkRecordSelect = function (model) {
	var fields = $author$project$Utils$Form$fields(model.SD);
	var _v0 = function () {
		var _v1 = _Utils_Tuple3(model.Jy, model.tg, model.te);
		if (!_v1.a) {
			if (_v1.b.$ === 3) {
				var _v2 = _v1.a;
				var _v3 = _v1.b;
				var list = _v3.a;
				return _Utils_Tuple3(false, list, _List_Nil);
			} else {
				var _v4 = _v1.a;
				return _Utils_Tuple3(true, _List_Nil, _List_Nil);
			}
		} else {
			if (_v1.c.$ === 3) {
				var _v5 = _v1.a;
				var _v6 = _v1.c;
				var list = _v6.a;
				return _Utils_Tuple3(false, _List_Nil, list);
			} else {
				var _v7 = _v1.a;
				return _Utils_Tuple3(true, _List_Nil, _List_Nil);
			}
		}
	}();
	var loading = _v0.a;
	var practitioners_ = _v0.b;
	var locations_ = _v0.c;
	var selectOptions = A3($author$project$Components$Affiliates$LinkRecordsModal$networkRecordOptions, model.Jy, practitioners_, locations_);
	var _v8 = function () {
		var _v9 = model.Jy;
		if (!_v9) {
			return _Utils_Tuple2(
				A2($elm$core$Maybe$map, $author$project$Api$Provider$Practitioner$All$id, fields.tf),
				$author$project$Components$Affiliates$LinkRecordsModal$NetworkPractitioner);
		} else {
			return _Utils_Tuple2(
				A2($elm$core$Maybe$map, $author$project$Api$Provider$Location$All$id, fields.td),
				$author$project$Components$Affiliates$LinkRecordsModal$NetworkLocation);
		}
	}();
	var id = _v8.a;
	var field = _v8.b;
	var _v10 = function () {
		var _v11 = model.Jy;
		if (!_v11) {
			return _Utils_Tuple2(
				A2($author$project$Utils$Form$hasValidationErrors, 2, model.SD),
				A2($author$project$Utils$Form$validationErrors, 2, model.SD));
		} else {
			return _Utils_Tuple2(
				A2($author$project$Utils$Form$hasValidationErrors, 3, model.SD),
				A2($author$project$Utils$Form$validationErrors, 3, model.SD));
		}
	}();
	var invalid = _v10.a;
	var errors = _v10.b;
	return A2(
		$author$project$Ui$Form$Select$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Select$value(id),
				$author$project$Ui$Form$Select$onChange(
				A2($elm$core$Basics$composeL, $author$project$Components$Affiliates$LinkRecordsModal$FormUpdated, field)),
				$author$project$Ui$Form$Select$invalid(invalid),
				$author$project$Ui$Form$Select$errors(errors),
				$author$project$Ui$Form$Select$loading(loading)
			]),
		selectOptions);
};
var $author$project$Components$Affiliates$LinkRecordsModal$viewModal = function (model) {
	var fields = $author$project$Utils$Form$fields(model.SD);
	var showNetworkRecordSelect = function () {
		var _v3 = model.Jy;
		if (!_v3) {
			return $author$project$Utils$Maybe$toBool(fields.Lf);
		} else {
			return $author$project$Utils$Maybe$toBool(fields.Lc);
		}
	}();
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Affiliates$LinkRecordsModal$CloseModal,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title(
						'Link affiliate\'s ' + $author$project$Components$Affiliates$LinkRecordsModal$resourceName(model.Jy))
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label(
								function () {
									var _v0 = model.Jy;
									if (!_v0) {
										return 'Affiliate Provider\'s Name';
									} else {
										return 'Affiliate Location\'s Name';
									}
								}()),
								$author$project$Ui$Form$Group$labelSpan(4),
								$author$project$Ui$Form$Group$inputSpan(8)
							]),
						_List_fromArray(
							[
								$author$project$Components$Affiliates$LinkRecordsModal$viewAffiliateRecordSelect(model)
							])),
						showNetworkRecordSelect ? A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label(
								function () {
									var _v1 = model.Jy;
									if (!_v1) {
										return 'Network Provider\'s Name';
									} else {
										return 'Network Location\'s Name';
									}
								}()),
								$author$project$Ui$Form$Group$labelSpan(4),
								$author$project$Ui$Form$Group$inputSpan(8)
							]),
						_List_fromArray(
							[
								$author$project$Components$Affiliates$LinkRecordsModal$viewNetworkRecordSelect(model)
							])) : $author$project$Utils$Html$empty,
						function () {
						if (model.Km) {
							var _v2 = model.Jy;
							if (!_v2) {
								return A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$labelSpan(4),
											$author$project$Ui$Form$Group$inputSpan(8),
											$author$project$Ui$Form$Group$label('')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Checkbox$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Checkbox$value(fields.u0),
													$author$project$Ui$Form$Checkbox$onCheck(
													A2($elm$core$Basics$composeL, $author$project$Components$Affiliates$LinkRecordsModal$FormUpdated, $author$project$Components$Affiliates$LinkRecordsModal$SyncToRentalNetworks))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Sync to all rental networks')
												]))
										]));
							} else {
								return $author$project$Utils$Html$empty;
							}
						} else {
							return $author$project$Utils$Html$empty;
						}
					}()
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Affiliates$LinkRecordsModal$CloseModal)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Save'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$loading(
								_Utils_eq(model.k9, $author$project$Api$Data$Loading)),
								$author$project$Ui$Button$onClick($author$project$Components$Affiliates$LinkRecordsModal$Link),
								$author$project$Ui$Button$icon($author$project$Ui$Icon$check)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Save')
							]))
					]))
			]));
};
var $author$project$Components$Affiliates$LinkRecordsModal$modal = function (model) {
	if (model.$ === 1) {
		var openModel = model.a;
		return $author$project$Components$Affiliates$LinkRecordsModal$viewModal(openModel);
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Affiliates$UnlinkRecordsModal$Unlink = {$: 2};
var $author$project$Components$Affiliates$UnlinkRecordsModal$UpdateAction = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Affiliates$Location$Min$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$Affiliates$Location$All$name = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Provider$Affiliates$Location$Min$name(min);
};
var $author$project$Api$Provider$Affiliates$Practitioner$All$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Components$Affiliates$UnlinkRecordsModal$UpdateNewPractitioner = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Affiliates$UnlinkRecordsModal$locationOptions = function (locations) {
	return A2(
		$elm$core$List$cons,
		A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(''),
			'Choose a location...'),
		A2(
			$elm$core$List$map,
			function (location) {
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$Affiliates$Location$All$id(location)),
					$author$project$Api$Provider$Affiliates$Location$All$name(location));
			},
			locations));
};
var $author$project$Components$Affiliates$UnlinkRecordsModal$practitionerOptions = function (practitioners) {
	return A2(
		$elm$core$List$cons,
		A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(''),
			'Choose a practitioner...'),
		A2(
			$elm$core$List$map,
			function (practitioner) {
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$Affiliates$Practitioner$All$id(practitioner)),
					$author$project$Api$Provider$Affiliates$Practitioner$All$name(practitioner));
			},
			practitioners));
};
var $author$project$Components$Affiliates$UnlinkRecordsModal$reassignOptions = function (resource) {
	if (!resource.$) {
		var remainingPractitioners = resource.b;
		return $author$project$Components$Affiliates$UnlinkRecordsModal$practitionerOptions(remainingPractitioners);
	} else {
		var remainingLocations = resource.b;
		return $author$project$Components$Affiliates$UnlinkRecordsModal$locationOptions(remainingLocations);
	}
};
var $author$project$Components$Affiliates$UnlinkRecordsModal$viewReassingSelect = F3(
	function (resource, id, invalid) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pt-05')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Select$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Select$value(id),
							$author$project$Ui$Form$Select$onChange($author$project$Components$Affiliates$UnlinkRecordsModal$UpdateNewPractitioner),
							$author$project$Ui$Form$Select$invalid(invalid),
							$author$project$Ui$Form$Select$errors(
							function () {
								if (invalid) {
									var resourceName = function () {
										if (!resource.$) {
											return 'provider';
										} else {
											return 'location';
										}
									}();
									return _List_fromArray(
										['Please pick a ' + (resourceName + ' for reassignment')]);
								} else {
									return _List_Nil;
								}
							}())
						]),
					$author$project$Components$Affiliates$UnlinkRecordsModal$reassignOptions(resource))
				]));
	});
var $author$project$Components$Affiliates$UnlinkRecordsModal$viewModal = F3(
	function (resource, action, request) {
		var _v0 = function () {
			switch (action.$) {
				case 0:
					return _Utils_Tuple2(true, false);
				case 2:
					return _Utils_Tuple2(true, false);
				case 1:
					return _Utils_Tuple2(false, true);
				default:
					return _Utils_Tuple2(false, true);
			}
		}();
		var reassignActive = _v0.a;
		var terminateActive = _v0.b;
		var _v2 = function () {
			if (!resource.$) {
				var practitioner = resource.a;
				var remainingPractitioners = resource.b;
				return _Utils_Tuple2(
					$author$project$Api$Provider$Affiliates$Practitioner$All$name(practitioner),
					$elm$core$List$isEmpty(remainingPractitioners));
			} else {
				var location = resource.a;
				var remainingLocations = resource.b;
				return _Utils_Tuple2(
					$author$project$Api$Provider$Affiliates$Location$All$name(location),
					$elm$core$List$isEmpty(remainingLocations));
			}
		}();
		var name = _v2.a;
		var remainingResourcesEmpty = _v2.b;
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$Affiliates$UnlinkRecordsModal$CloseModal,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('What would you like to do with ' + (name + '\'s patients?'))
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label(
									function () {
										if (!resource.$) {
											return 'Provider';
										} else {
											return 'Location';
										}
									}()),
									$author$project$Ui$Form$Group$labelSpan(4),
									$author$project$Ui$Form$Group$inputSpan(8)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(name)
												]))
										]))
								])),
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Action'),
									$author$project$Ui$Form$Group$labelSpan(4),
									$author$project$Ui$Form$Group$inputSpan(8)
								]),
							_List_fromArray(
								[
									function () {
									var terminateAction = function () {
										if (!resource.$) {
											return $author$project$Components$Affiliates$UnlinkRecordsModal$UpdateAction($author$project$Components$Affiliates$UnlinkRecordsModal$TerminatePractitioner);
										} else {
											return $author$project$Components$Affiliates$UnlinkRecordsModal$UpdateAction($author$project$Components$Affiliates$UnlinkRecordsModal$TerminateLocation);
										}
									}();
									var reassignAction = function () {
										if (!resource.$) {
											var remainingPractitioners = resource.b;
											return $author$project$Components$Affiliates$UnlinkRecordsModal$UpdateAction(
												A2($author$project$Components$Affiliates$UnlinkRecordsModal$ReassignPractitioner, remainingPractitioners, $elm$core$Maybe$Nothing));
										} else {
											var remainingLocations = resource.b;
											return $author$project$Components$Affiliates$UnlinkRecordsModal$UpdateAction(
												A2($author$project$Components$Affiliates$UnlinkRecordsModal$ReassignLocation, remainingLocations, $elm$core$Maybe$Nothing));
										}
									}();
									var _v5 = function () {
										if (!resource.$) {
											return _Utils_Tuple2('Terminate', 'Provider');
										} else {
											return _Utils_Tuple2('Remove', 'Location');
										}
									}();
									var terminationVerb = _v5.a;
									var resourceName = _v5.b;
									return $author$project$Ui$Button$group(
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Button$view,
												{mm: 'Reassign ' + resourceName},
												_List_fromArray(
													[
														$author$project$Ui$Button$active(reassignActive),
														$author$project$Ui$Button$disabled(remainingResourcesEmpty),
														$author$project$Ui$Button$onClick(reassignAction)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Reassign')
													])),
												A3(
												$author$project$Ui$Button$view,
												{mm: terminationVerb + (' ' + resourceName)},
												_List_fromArray(
													[
														$author$project$Ui$Button$active(terminateActive),
														$author$project$Ui$Button$onClick(terminateAction)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(terminationVerb)
													]))
											]));
								}(),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pt-05')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
											_List_fromArray(
												[
													function () {
													switch (action.$) {
														case 0:
															return $elm$html$Html$text('All patients will be switched to a different provider.');
														case 1:
															return $elm$html$Html$text('All affiliate memberships will be terminated. Your memberships are not affected.');
														case 2:
															return $elm$html$Html$text('All patients will be switched to a new location.');
														default:
															return $elm$html$Html$text('This location will be removed from all patients. The primary care clinic will not be removed.');
													}
												}()
												]))
										])),
									function () {
									switch (action.$) {
										case 0:
											var newPractitioner = action.b;
											var newPractitionerInvalid = !$author$project$Utils$Maybe$toBool(newPractitioner);
											return A3(
												$author$project$Components$Affiliates$UnlinkRecordsModal$viewReassingSelect,
												resource,
												A2($elm$core$Maybe$map, $author$project$Api$Provider$Affiliates$Practitioner$All$id, newPractitioner),
												newPractitionerInvalid);
										case 2:
											var newLocation = action.b;
											var newLocationInvalid = !$author$project$Utils$Maybe$toBool(newLocation);
											return A3(
												$author$project$Components$Affiliates$UnlinkRecordsModal$viewReassingSelect,
												resource,
												A2($elm$core$Maybe$map, $author$project$Api$Provider$Affiliates$Location$All$id, newLocation),
												newLocationInvalid);
										case 1:
											return $author$project$Utils$Html$empty;
										default:
											return $author$project$Utils$Html$empty;
									}
								}()
								]))
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Cancel and close modal'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Components$Affiliates$UnlinkRecordsModal$CloseModal)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Unlink'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$loading(
									_Utils_eq(request, $author$project$Api$Data$Loading)),
									$author$project$Ui$Button$onClick($author$project$Components$Affiliates$UnlinkRecordsModal$Unlink),
									$author$project$Ui$Button$icon($author$project$Ui$Icon$check)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(' Unlink')
								]))
						]))
				]));
	});
var $author$project$Components$Affiliates$UnlinkRecordsModal$modal = function (model) {
	if (model.$ === 1) {
		var resource = model.b;
		var action = model.c;
		var request = model.d;
		return A3($author$project$Components$Affiliates$UnlinkRecordsModal$viewModal, resource, action, request);
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Api$Provider$Network$Shared$syncByAffiliation = function (_v0) {
	var record = _v0;
	return record.acI;
};
var $author$project$Components$Affiliates$SyncPatientsModal$Activate = 0;
var $author$project$Components$Affiliates$SyncPatientsModal$Save = {$: 2};
var $author$project$Components$Affiliates$SyncPatientsModal$UpdateAction = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Affiliates$SyncPatientsModal$view = function (model) {
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Affiliates$SyncPatientsModal$CloseModal,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Patients Syncing')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Patients Syncing'),
								$author$project$Ui$Form$Group$labelSpan(3),
								$author$project$Ui$Form$Group$inputSpan(9)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Static$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Radio$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Radio$value(model.Gg === 1),
												$author$project$Ui$Form$Radio$onCheck(
												$elm$core$Basics$always(
													$author$project$Components$Affiliates$SyncPatientsModal$UpdateAction(1)))
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$p,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Pend the Affiliation (recommended)')
													])),
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
												_List_fromArray(
													[
														$elm$html$Html$text('Syncing will be turned on at a later date')
													]))
											]))
									])),
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								A2(
								$author$project$Ui$Form$Static$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Radio$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Radio$value(!model.Gg),
												$author$project$Ui$Form$Radio$onCheck(
												$elm$core$Basics$always(
													$author$project$Components$Affiliates$SyncPatientsModal$UpdateAction(0)))
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$p,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Activate the Affiliation')
													])),
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
												_List_fromArray(
													[
														$elm$html$Html$text('Patients will begin syncing immediately')
													]))
											]))
									]))
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanSm(6)
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Cancel and close modal'},
										_List_fromArray(
											[
												$author$project$Ui$Button$fullWidth(true),
												$author$project$Ui$Button$onClick($author$project$Components$Affiliates$SyncPatientsModal$CloseModal)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cancel')
											]))
									])),
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanSm(6)
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Confirm patient sync'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$loading(
												_Utils_eq(model.l6, $author$project$Api$Data$Loading)),
												$author$project$Ui$Button$onClick($author$project$Components$Affiliates$SyncPatientsModal$Save),
												$author$project$Ui$Button$fullWidth(true)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Confirm')
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Components$Affiliates$LinkRecordsModal$Location = 1;
var $author$project$Components$Affiliates$LinkRecordsModal$OpenModal = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Affiliates$LinkRecordsModal$button_ = F3(
	function (affiliateId, resource, options) {
		var label = 'Add ' + function () {
			if (!resource) {
				return 'provider';
			} else {
				return 'location';
			}
		}();
		return A3(
			$author$project$Ui$Button$view,
			{mm: label},
			_Utils_ap(
				options,
				_List_fromArray(
					[
						$author$project$Ui$Button$styled(0),
						$author$project$Ui$Button$onClick(
						A2($author$project$Components$Affiliates$LinkRecordsModal$OpenModal, affiliateId, resource))
					])),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Components$Affiliates$LinkRecordsModal$buttonSm = F2(
	function (affiliateId, resource) {
		return A3(
			$author$project$Components$Affiliates$LinkRecordsModal$button_,
			affiliateId,
			resource,
			_List_fromArray(
				[
					$author$project$Ui$Button$sm,
					$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
				]));
	});
var $author$project$Components$Affiliates$UnlinkRecordsModal$Location = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Api$Provider$Affiliates$Location$All$affiliateLocation = function (_v0) {
	var record = _v0.b;
	return record.Lc;
};
var $author$project$Ui$Icon$ArrowRight = 64;
var $author$project$Ui$Icon$arrowRight = $author$project$Ui$Icon$viewIcon(64);
var $author$project$Components$Affiliates$UnlinkRecordsModal$OpenModal = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Affiliates$UnlinkRecordsModal$button = F2(
	function (affiliateId, resource) {
		var resourceName = function () {
			if (!resource.$) {
				return 'provider';
			} else {
				return 'location';
			}
		}();
		return A3(
			$author$project$Ui$Button$view,
			{mm: 'Unlink ' + resourceName},
			_List_fromArray(
				[
					$author$project$Ui$Button$sm,
					$author$project$Ui$Button$link,
					$author$project$Ui$Button$onClick(
					A2($author$project$Components$Affiliates$UnlinkRecordsModal$OpenModal, affiliateId, resource)),
					$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Unlink')
				]));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$viewLocation = F3(
	function (model, locations, location) {
		var remainingLocations = A2(
			$elm$core$List$filter,
			function (remainingLocation) {
				return !_Utils_eq(
					$author$project$Api$Provider$Affiliates$Location$All$id(location),
					$author$project$Api$Provider$Affiliates$Location$All$id(remainingLocation));
			},
			locations);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Network: '),
							A2(
							$author$project$Ui$Typography$b,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$Affiliates$Location$All$name(location))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textMuted]),
							_List_fromArray(
								[
									$author$project$Ui$Icon$arrowRight(_List_Nil)
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Affiliate: '),
							A2(
							$author$project$Ui$Typography$b,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$Location$Min$name(
										$author$project$Api$Provider$Affiliates$Location$All$affiliateLocation(location)))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$UnlinkRecordsModalMsg,
							A2(
								$author$project$Components$Affiliates$UnlinkRecordsModal$button,
								model.rd,
								A2($author$project$Components$Affiliates$UnlinkRecordsModal$Location, location, remainingLocations)))
						]))
				]));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$viewLocationsTable = function (model) {
	var _v0 = function () {
		var _v1 = model.Wg;
		if (_v1.$ === 3) {
			var locations_ = _v1.a;
			return _Utils_Tuple2(false, locations_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var locations = _v0.b;
	return _List_fromArray(
		[
			A2($elm$html$Html$br, _List_Nil, _List_Nil),
			A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(5)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('Locations')
								])),
							A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Create links between affiliate\'s locations and your network.')
								]))
						]))
				])),
			A4(
			$author$project$Ui$Table$view,
			_List_fromArray(
				[
					$author$project$Ui$Table$loading(loading),
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('No linked locations.')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$header,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(5)
						]),
					_List_Nil),
					A2(
					$author$project$Ui$Table$header,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(1)
						]),
					_List_Nil),
					A2(
					$author$project$Ui$Table$header,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(4)
						]),
					_List_Nil),
					A2(
					$author$project$Ui$Table$header,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(2)
						]),
					_List_Nil)
				]),
			A2(
				$elm$core$List$map,
				A2($author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$viewLocation, model, locations),
				locations),
			_List_Nil),
			A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(3)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$LinkRecordsModalMsg,
							A2($author$project$Components$Affiliates$LinkRecordsModal$buttonSm, model.rd, 1))
						]))
				])),
			A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(6)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
							_List_fromArray(
								[
									$elm$html$Html$text('You can add locations to your network from the affiliate\'s account.')
								]))
						]))
				]))
		]);
};
var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$LinkAllProviders = {$: 6};
var $author$project$Components$Affiliates$LinkRecordsModal$Practitioner = 0;
var $author$project$Components$Affiliates$UnlinkRecordsModal$Practitioner = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Affiliates$Practitioner$All$affiliatePractitioner = function (_v0) {
	var record = _v0;
	return record.Lf;
};
var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$viewPractitioner = F3(
	function (model, practitioners, practitioner) {
		var remainingPractitioners = A2(
			$elm$core$List$filter,
			function (remainingPractitioner) {
				return !_Utils_eq(
					$author$project$Api$Provider$Affiliates$Practitioner$All$id(practitioner),
					$author$project$Api$Provider$Affiliates$Practitioner$All$id(remainingPractitioner));
			},
			practitioners);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Network: '),
							A2(
							$author$project$Ui$Typography$b,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$Affiliates$Practitioner$All$name(practitioner))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textMuted]),
							_List_fromArray(
								[
									$author$project$Ui$Icon$arrowRight(_List_Nil)
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Affiliate: '),
							A2(
							$author$project$Ui$Typography$b,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$Practitioner$Min$name(
										$author$project$Api$Provider$Affiliates$Practitioner$All$affiliatePractitioner(practitioner)))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$UnlinkRecordsModalMsg,
							A2(
								$author$project$Components$Affiliates$UnlinkRecordsModal$button,
								model.rd,
								A2($author$project$Components$Affiliates$UnlinkRecordsModal$Practitioner, practitioner, remainingPractitioners)))
						]))
				]));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$viewPractitionersTable = function (model) {
	var isHinter = A2($author$project$Utils$User$isViewingAsHinter, model.aa4, model.ahK);
	var _v0 = function () {
		var _v1 = model.Z4;
		if (_v1.$ === 3) {
			var practitioners_ = _v1.a;
			return _Utils_Tuple2(false, practitioners_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var practitioners = _v0.b;
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(5)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('Link Providers')
								])),
							A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Create links between affiliate\'s providers and your network.')
								]))
						]))
				])),
			A4(
			$author$project$Ui$Table$view,
			_List_fromArray(
				[
					$author$project$Ui$Table$loading(loading),
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('No linked providers.')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$header,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(5)
						]),
					_List_Nil),
					A2(
					$author$project$Ui$Table$header,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(1)
						]),
					_List_Nil),
					A2(
					$author$project$Ui$Table$header,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(4)
						]),
					_List_Nil),
					A2(
					$author$project$Ui$Table$header,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(2)
						]),
					_List_Nil)
				]),
			A2(
				$elm$core$List$map,
				A2($author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$viewPractitioner, model, practitioners),
				practitioners),
			_List_Nil),
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mb2, $author$project$Ui$Element$mt2]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$LinkRecordsModalMsg,
					A2($author$project$Components$Affiliates$LinkRecordsModal$buttonSm, model.rd, 0)),
					isHinter ? A3(
					$author$project$Ui$HinterOnly$button,
					{mm: 'Add all providers'},
					_List_fromArray(
						[
							$author$project$Ui$Button$styled(0),
							$author$project$Ui$Button$sm,
							$author$project$Ui$Button$onClick($author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$LinkAllProviders)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Add all providers')
						])) : $elm$html$Html$text('')
				])),
			A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(6)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
							_List_fromArray(
								[
									$elm$html$Html$text('You can add providers to your network from the affiliate\'s account.')
								]))
						]))
				]))
		]);
};
var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$view = function (model) {
	var network = $author$project$Api$Provider$Practice$One$network(model.ZV);
	var syncByAffiliation = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2($elm$core$Maybe$map, $author$project$Api$Provider$Network$Shared$syncByAffiliation, network));
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$UnlinkRecordsModalMsg,
				$author$project$Components$Affiliates$UnlinkRecordsModal$modal(model.qL)),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$LinkRecordsModalMsg,
				$author$project$Components$Affiliates$LinkRecordsModal$modal(model.ok)),
				function () {
				var _v0 = model.lG;
				if (!_v0.$) {
					var syncPatientsModal = _v0.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$SyncPatientsModalMsg,
						$author$project$Components$Affiliates$SyncPatientsModal$view(syncPatientsModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						A2(
							$elm$core$List$cons,
							A2(
								$elm$html$Html$map,
								$elm$core$Basics$never,
								A2(
									$author$project$Ui$Breadcrumb$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Breadcrumb$item,
											_List_Nil,
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Affiliates__Top,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Manage affiliates')
														]))
												])),
											A2(
											$author$project$Ui$Breadcrumb$item,
											_List_Nil,
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Affiliates__New,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Add new affiliate')
														]))
												])),
											A2(
											$author$project$Ui$Breadcrumb$item,
											_List_Nil,
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Affiliates__New,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Create Affiliation')
														]))
												])),
											A2(
											$author$project$Ui$Breadcrumb$item,
											_List_fromArray(
												[
													$author$project$Ui$Breadcrumb$active(true)
												]),
											_List_fromArray(
												[
													syncByAffiliation ? $elm$html$Html$text('Link Providers & Locations') : $elm$html$Html$text('Link Providers')
												]))
										]))),
							_Utils_ap(
								$author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$viewPractitionersTable(model),
								syncByAffiliation ? $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$viewLocationsTable(model) : _List_Nil))),
						A2(
						$author$project$Ui$Panel$footer,
						_List_fromArray(
							[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$gap2]),
						_List_fromArray(
							[
								function () {
								var label = syncByAffiliation ? 'Link providers & locations' : 'Finish';
								return A3(
									$author$project$Ui$Button$view,
									{mm: label},
									_List_fromArray(
										[
											$author$project$Ui$Button$primary,
											$author$project$Ui$Button$onClick($author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$SyncPatients)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(label)
										]));
							}()
							]))
					]))
			]),
		ac9: 'Affiliates'
	};
};
var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$init, aiq: $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$load, k8: $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$save, alO: $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$subscriptions, adT: $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$update, amo: $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$view});
var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$GotLocations = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$fetchLocations = function (model) {
	return A3($author$project$Api$Provider$Affiliates$Location$list, model.Gv, model.rd, $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$GotLocations);
};
var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$GotPractitioners = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$fetchPractitioners = function (model) {
	return A3($author$project$Api$Provider$Affiliates$Practitioner$list, model.Gv, model.rd, $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$GotPractitioners);
};
var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$init = F4(
	function (session, practice, _v0, _v1) {
		var apiClient = _v0.Gv;
		var hinterViewOff = _v0.ahK;
		var params = _v1.YL;
		var model = {
			rd: params.rd,
			Gv: apiClient,
			ok: $author$project$Components$Affiliates$LinkRecordsModal$init,
			Wg: $author$project$Api$Data$Loading,
			ZV: practice,
			Z4: $author$project$Api$Data$Loading,
			qL: $author$project$Components$Affiliates$UnlinkRecordsModal$init,
			Km: A2($author$project$Utils$User$isViewingAsHinter, session, hinterViewOff)
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$fetchPractitioners(model),
						$author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$fetchLocations(model)
					])));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$LinkRecordsModalMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$UnlinkRecordsModalMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$LinkRecordsModalMsg,
				$author$project$Components$Affiliates$LinkRecordsModal$subscriptions(model.ok)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$UnlinkRecordsModalMsg,
				$author$project$Components$Affiliates$UnlinkRecordsModal$subscriptions(model.qL))
			]));
};
var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Z4: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Wg: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 2:
				var subMsg = msg.a;
				var unlinkRecordsModalResutl = A3($author$project$Components$Affiliates$UnlinkRecordsModal$update, model.Gv, subMsg, model.qL);
				var _v1 = function () {
					var _v2 = unlinkRecordsModalResutl.agZ;
					switch (_v2) {
						case 0:
							return _Utils_Tuple3(model.Z4, model.Wg, $elm$core$Platform$Cmd$none);
						case 1:
							return _Utils_Tuple3(
								$author$project$Api$Data$Loading,
								model.Wg,
								$author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$fetchPractitioners(model));
						default:
							return _Utils_Tuple3(
								model.Z4,
								$author$project$Api$Data$Loading,
								$author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$fetchLocations(model));
					}
				}();
				var practitioners = _v1.a;
				var locations = _v1.b;
				var cmd = _v1.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Wg: locations, Z4: practitioners, qL: unlinkRecordsModalResutl.aiO}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$UnlinkRecordsModalMsg, unlinkRecordsModalResutl.GZ),
								cmd
							])),
					unlinkRecordsModalResutl.aR);
			default:
				var subMsg = msg.a;
				var linkRecordsModalResutl = A4($author$project$Components$Affiliates$LinkRecordsModal$update, model.Gv, subMsg, model.ok, model.Km);
				var _v3 = function () {
					var _v4 = linkRecordsModalResutl.agZ;
					switch (_v4) {
						case 0:
							return _Utils_Tuple3(model.Z4, model.Wg, $elm$core$Platform$Cmd$none);
						case 1:
							return _Utils_Tuple3(
								$author$project$Api$Data$Loading,
								model.Wg,
								$author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$fetchPractitioners(model));
						default:
							return _Utils_Tuple3(
								model.Z4,
								$author$project$Api$Data$Loading,
								$author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$fetchLocations(model));
					}
				}();
				var practitioners = _v3.a;
				var locations = _v3.b;
				var cmd = _v3.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ok: linkRecordsModalResutl.aiO, Wg: locations, Z4: practitioners}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$LinkRecordsModalMsg, linkRecordsModalResutl.GZ),
								cmd
							])),
					linkRecordsModalResutl.aR);
		}
	});
var $author$project$Components$Affiliates$LinkRecordsModal$button = F2(
	function (affiliateId, resource) {
		return A3(
			$author$project$Components$Affiliates$LinkRecordsModal$button_,
			affiliateId,
			resource,
			_List_fromArray(
				[
					$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
				]));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$locationsColumns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'network_name', false, 'Network Location Name'),
		A3($author$project$Api$Column$init, 'affiliate_name', false, 'Affiliate Location Name'),
		A3($author$project$Api$Column$init, 'active_lives', false, 'Active Synced Patients'),
		A3($author$project$Api$Column$init, 'actions', false, '')
	]);
var $author$project$Api$Provider$Affiliates$Location$All$activeLives = function (_v0) {
	var record = _v0.b;
	return record.KQ;
};
var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$viewLocation = F3(
	function (model, locations, location) {
		var remainingLocations = A2(
			$elm$core$List$filter,
			function (remainingLocation) {
				return !_Utils_eq(
					$author$project$Api$Provider$Affiliates$Location$All$id(location),
					$author$project$Api$Provider$Affiliates$Location$All$id(remainingLocation));
			},
			locations);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$Affiliates$Location$All$name(location))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$Location$Min$name(
								$author$project$Api$Provider$Affiliates$Location$All$affiliateLocation(location)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(
								$author$project$Api$Provider$Affiliates$Location$All$activeLives(location)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$textRight]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$UnlinkRecordsModalMsg,
							A2(
								$author$project$Components$Affiliates$UnlinkRecordsModal$button,
								model.rd,
								A2($author$project$Components$Affiliates$UnlinkRecordsModal$Location, location, remainingLocations)))
						]))
				]));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$viewLocationsTable = function (model) {
	var _v0 = function () {
		var _v1 = model.Wg;
		if (_v1.$ === 3) {
			var locations_ = _v1.a;
			return _Utils_Tuple2(false, locations_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var locations = _v0.b;
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Grid$row,
			_List_fromArray(
				[$author$project$Ui$Grid$mt4]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(10)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('Locations')
								]))
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(2),
							$author$project$Ui$Grid$justifyRight
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$LinkRecordsModalMsg,
							A2($author$project$Components$Affiliates$LinkRecordsModal$button, model.rd, 1))
						]))
				])),
			A2(
			$author$project$Ui$Typography$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Manage links between affiliate locations and your network.')
				])),
			A4(
			$author$project$Ui$Table$view,
			_List_fromArray(
				[
					$author$project$Ui$Table$loading(loading),
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('No linked locations.')
						]))
				]),
			A2(
				$elm$core$List$map,
				$author$project$Api$Column$view($author$project$Api$Column$NonSortable),
				$author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$locationsColumns),
			A2(
				$elm$core$List$map,
				A2($author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$viewLocation, model, locations),
				locations),
			_List_Nil)
		]);
};
var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$practitionersColumns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'network_name', false, 'Network Provider Name'),
		A3($author$project$Api$Column$init, 'affiliate_name', false, 'Affiliate Provider Name'),
		A3($author$project$Api$Column$init, 'active_lives', false, 'Active Synced Patients'),
		A3($author$project$Api$Column$init, 'active_lives', false, 'Active Synced Patients'),
		A3($author$project$Api$Column$init, 'actions', false, '')
	]);
var $author$project$Api$Provider$Affiliates$Practitioner$All$activeLives = function (_v0) {
	var record = _v0;
	return record.KQ;
};
var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$viewPractitioner = F3(
	function (model, practitioners, practitioner) {
		var remainingPractitioners = A2(
			$elm$core$List$filter,
			function (remainingPractitioner) {
				return !_Utils_eq(
					$author$project$Api$Provider$Affiliates$Practitioner$All$id(practitioner),
					$author$project$Api$Provider$Affiliates$Practitioner$All$id(remainingPractitioner));
			},
			practitioners);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$Affiliates$Practitioner$All$name(practitioner))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$Practitioner$Min$name(
								$author$project$Api$Provider$Affiliates$Practitioner$All$affiliatePractitioner(practitioner)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(
								$author$project$Api$Provider$Affiliates$Practitioner$All$activeLives(practitioner)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$textRight]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$UnlinkRecordsModalMsg,
							A2(
								$author$project$Components$Affiliates$UnlinkRecordsModal$button,
								model.rd,
								A2($author$project$Components$Affiliates$UnlinkRecordsModal$Practitioner, practitioner, remainingPractitioners)))
						]))
				]));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$viewPractitionersTable = function (model) {
	var network = $author$project$Api$Provider$Practice$One$network(model.ZV);
	var _v0 = function () {
		var _v1 = model.Z4;
		if (_v1.$ === 3) {
			var practitioners_ = _v1.a;
			return _Utils_Tuple2(false, practitioners_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var practitioners = _v0.b;
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(10)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									A2(
									$elm$core$Maybe$withDefault,
									false,
									A2($elm$core$Maybe$map, $author$project$Api$Provider$Network$Shared$syncByAffiliation, network)) ? $elm$html$Html$text('Providers') : $elm$html$Html$text('Linked Providers')
								]))
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(2),
							$author$project$Ui$Grid$justifyRight
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$LinkRecordsModalMsg,
							A2($author$project$Components$Affiliates$LinkRecordsModal$button, model.rd, 0))
						]))
				])),
			A2(
			$author$project$Ui$Typography$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Manage links between affiliate providers and your network.')
				])),
			A4(
			$author$project$Ui$Table$view,
			_List_fromArray(
				[
					$author$project$Ui$Table$loading(loading),
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('No linked providers.')
						]))
				]),
			A2(
				$elm$core$List$map,
				$author$project$Api$Column$view($author$project$Api$Column$NonSortable),
				$author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$practitionersColumns),
			A2(
				$elm$core$List$map,
				A2($author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$viewPractitioner, model, practitioners),
				practitioners),
			_List_Nil)
		]);
};
var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$view = function (model) {
	var network = $author$project$Api$Provider$Practice$One$network(model.ZV);
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$UnlinkRecordsModalMsg,
				$author$project$Components$Affiliates$UnlinkRecordsModal$modal(model.qL)),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$LinkRecordsModalMsg,
				$author$project$Components$Affiliates$LinkRecordsModal$modal(model.ok)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_Utils_ap(
							$author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$viewPractitionersTable(model),
							A2(
								$elm$core$Maybe$withDefault,
								false,
								A2($elm$core$Maybe$map, $author$project$Api$Provider$Network$Shared$syncByAffiliation, network)) ? $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$viewLocationsTable(model) : _List_Nil))
					]))
			]),
		ac9: 'Affiliates | Linked Providers'
	};
};
var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$init, aiq: $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$load, k8: $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$save, alO: $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$subscriptions, adT: $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$update, amo: $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$view});
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$CompanyResourceFilterMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$PlanResourceFilterMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$PractitionerResourceFilterMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$StatusDropdownMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$statusTypeToString = function (statusType) {
	switch (statusType) {
		case 0:
			return 'active';
		case 1:
			return 'pending';
		default:
			return 'ended';
	}
};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$buildUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('q'),
			model.akl),
			$elm$core$List$isEmpty(model.h) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			A2(
				$elm$url$Url$Builder$string,
				'filter',
				A2(
					$elm$core$String$join,
					',',
					A2($elm$core$List$map, $author$project$Api$Provider$Patient$filterToString, model.h)))),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('company'),
			model.fZ),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('plan'),
			model.aj4),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('practitioner'),
			model.Z2),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('status'),
			A2($elm$core$Maybe$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$statusTypeToString, model.alH))
		]);
	return A2(
		$elm$url$Url$Builder$relative,
		_List_fromArray(
			[
				$author$project$Spa$Generated$Route$toString(
				$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Patients(
					{rd: model.rd}))
			]),
		A2(
			$elm$core$List$append,
			$author$project$Api$Pagination$toPageQuery(model.ajJ),
			A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)));
};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$GotAffiliateCoveragePeriods = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$fetchParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				afQ: model.fZ,
				HM: model.h,
				ajJ: model.ajJ,
				Jb: model.aj4,
				aka: model.Z2,
				akl: model.akl,
				alH: A2($elm$core$Maybe$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$statusTypeToString, model.alH)
			});
	};
};
var $author$project$Api$Provider$Affiliates$AffiliateCoveragePeriod$affiliateCoveragePeriodsPath = function (affiliateId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['affiliate_coverage_periods']),
		$author$project$Api$Provider$Affiliate$affiliatePath(affiliateId));
};
var $author$project$Api$Provider$AffiliateCoveragePeriod$All$AffiliateCoveragePeriod = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$AffiliateCoveragePeriod$Shared$AffiliateCoveragePeriod = $elm$core$Basics$identity;
var $author$project$Api$Provider$AffiliateCoveragePeriod$Shared$Record = F3(
	function (status, enrollmentDate, terminationDate) {
		return {RE: enrollmentDate, alH: status, ac1: terminationDate};
	});
var $author$project$Api$Provider$AffiliateCoveragePeriod$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'termination_date',
	$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'enrollment_date',
		$author$project$Utils$Date$decode,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'status',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$AffiliateCoveragePeriod$Shared$Record))));
var $author$project$Api$Provider$AffiliateCoveragePeriod$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$AffiliateCoveragePeriod$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$AffiliateCoveragePeriod$All$Record = F8(
	function (affiliatePeriodInMonths, affiliateRateInCents, networkPeriodInMonths, networkRateInCents, patient, company, practitioner, rateRule) {
		return {Ld: affiliatePeriodInMonths, Lg: affiliateRateInCents, afQ: company, XD: networkPeriodInMonths, XF: networkRateInCents, YY: patient, aka: practitioner, _3: rateRule};
	});
var $author$project$Api$Provider$RateRule$Min$RateRule = $elm$core$Basics$identity;
var $author$project$Api$Provider$RateRule$Min$Record = F2(
	function (type_, name) {
		return {Bq: name, amg: type_};
	});
var $author$project$Api$Provider$RateRule$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'type',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$RateRule$Min$Record)));
var $author$project$Api$Provider$RateRule$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$RateRule$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$AffiliateCoveragePeriod$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'rate_rule',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Min$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'practitioner',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Practitioner$Min$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'company',
			$elm$json$Json$Decode$nullable($author$project$Api$Provider$Company$Min$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'patient',
				$author$project$Api$Provider$Patient$Min$decoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'network_rate_in_cents',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'network_period_in_months',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'affiliate_rate_in_cents',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'affiliate_period_in_months',
								$elm$json$Json$Decode$int,
								$elm$json$Json$Decode$succeed($author$project$Api$Provider$AffiliateCoveragePeriod$All$Record)))))))));
var $author$project$Api$Provider$AffiliateCoveragePeriod$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$AffiliateCoveragePeriod$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$AffiliateCoveragePeriod$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$AffiliateCoveragePeriod$All$AffiliateCoveragePeriod)));
var $author$project$Api$Provider$Affiliates$AffiliateCoveragePeriod$listDefaults = {afQ: $elm$core$Maybe$Nothing, HM: _List_Nil, ajJ: $author$project$Api$Pagination$init, Jb: $elm$core$Maybe$Nothing, aka: $elm$core$Maybe$Nothing, akl: $elm$core$Maybe$Nothing, alH: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$Affiliates$AffiliateCoveragePeriod$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Affiliates$AffiliateCoveragePeriod$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.akl;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.HM;
				if (!_v1.b) {
					return _List_Nil;
				} else {
					var filters = _v1;
					return _List_fromArray(
						[
							A2(
							$author$project$Api$Param$string,
							'filter',
							A2(
								$elm$core$String$join,
								',',
								A2($elm$core$List$map, $author$project$Api$Provider$Patient$filterToString, filters)))
						]);
				}
			}(),
				function () {
				var _v2 = options.afQ;
				if (!_v2.$) {
					var string = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'company', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v3 = options.Jb;
				if (!_v3.$) {
					var string = _v3.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'plan', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v4 = options.aka;
				if (!_v4.$) {
					var string = _v4.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'practitioner', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v5 = options.alH;
				if (!_v5.$) {
					var string = _v5.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'status', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$Provider$Affiliates$AffiliateCoveragePeriod$list = F4(
	function (apiClient, affiliateId, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$AffiliateCoveragePeriod$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Affiliates$AffiliateCoveragePeriod$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Affiliates$AffiliateCoveragePeriod$affiliateCoveragePeriodsPath(affiliateId))));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$fetchAffiliateCoveragePeriods = function (model) {
	return A4(
		$author$project$Api$Provider$Affiliates$AffiliateCoveragePeriod$list,
		model.Gv,
		model.rd,
		$author$project$Pages$Affiliates$AffiliateId_String$Patients$fetchParams(model),
		$author$project$Pages$Affiliates$AffiliateId_String$Patients$GotAffiliateCoveragePeriods);
};
var $author$project$Api$Provider$Patient$AccountOwnerWithoutPaymentInfo = {$: 4};
var $author$project$Api$Provider$Patient$Active = 0;
var $author$project$Api$Provider$Patient$ActiveMembership = {$: 2};
var $author$project$Api$Provider$Patient$Archived = 4;
var $author$project$Api$Provider$Patient$AutopayEnabled = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Patient$CurrentlyEngaged = 0;
var $author$project$Api$Provider$Patient$Engaged = function (a) {
	return {$: 13, a: a};
};
var $author$project$Api$Provider$Patient$Inactive = 1;
var $author$project$Api$Provider$Patient$NeverEngaged = 2;
var $author$project$Api$Provider$Patient$NewActivationsSinceDate = {$: 10};
var $author$project$Api$Provider$Patient$NewTerminationsSinceDate = {$: 11};
var $author$project$Api$Provider$Patient$PastDueCustomerInvoices = {$: 3};
var $author$project$Api$Provider$Patient$Pending = 2;
var $author$project$Api$Provider$Patient$PreviouslyEngaged = 1;
var $author$project$Api$Provider$Patient$Status = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Patient$Unconfirmed = 3;
var $author$project$Api$Provider$Patient$WithBouncedEmail = {$: 14};
var $author$project$Api$Provider$Patient$WithFailedIntegrations = {$: 8};
var $author$project$Api$Provider$Patient$WithFlaggedNotes = {$: 7};
var $author$project$Api$Provider$Patient$WithUnsubscribedEmails = {$: 15};
var $author$project$Api$Provider$Patient$WithUnsyncedIntegrations = {$: 9};
var $author$project$Api$Provider$Patient$WithUpcomingBirthday = {$: 12};
var $author$project$Api$Provider$Patient$filterFromString = function (filter) {
	switch (filter) {
		case 'current_membership':
			return $elm$core$Maybe$Just(
				$author$project$Api$Provider$Patient$Status(0));
		case 'future_membership':
			return $elm$core$Maybe$Just(
				$author$project$Api$Provider$Patient$Status(2));
		case 'with_unconfirmed_membership':
			return $elm$core$Maybe$Just(
				$author$project$Api$Provider$Patient$Status(3));
		case 'inactive':
			return $elm$core$Maybe$Just(
				$author$project$Api$Provider$Patient$Status(1));
		case 'archived':
			return $elm$core$Maybe$Just(
				$author$project$Api$Provider$Patient$Status(4));
		case 'with_autopay':
			return $elm$core$Maybe$Just(
				$author$project$Api$Provider$Patient$AutopayEnabled(true));
		case 'without_autopay':
			return $elm$core$Maybe$Just(
				$author$project$Api$Provider$Patient$AutopayEnabled(false));
		case 'active_membership':
			return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$ActiveMembership);
		case 'past_due_customer_invoices':
			return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$PastDueCustomerInvoices);
		case 'account_owner_without_payment_info':
			return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$AccountOwnerWithoutPaymentInfo);
		case 'without_hipaa_authorization':
			return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$WithoutHipaaAuthorization);
		case 'without_email':
			return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$WithoutEmail);
		case 'with_flagged_notes':
			return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$WithFlaggedNotes);
		case 'with_failed_sync':
			return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$WithFailedIntegrations);
		case 'with_failed_integrations':
			return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$WithFailedIntegrations);
		case 'with_unsynced_integrations':
			return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$WithUnsyncedIntegrations);
		case 'new_activations_since_date':
			return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$NewActivationsSinceDate);
		case 'new_terminations_since_date':
			return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$NewTerminationsSinceDate);
		case 'with_upcoming_birthday':
			return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$WithUpcomingBirthday);
		case 'currently_engaged':
			return $elm$core$Maybe$Just(
				$author$project$Api$Provider$Patient$Engaged(0));
		case 'previously_engaged':
			return $elm$core$Maybe$Just(
				$author$project$Api$Provider$Patient$Engaged(1));
		case 'never_engaged':
			return $elm$core$Maybe$Just(
				$author$project$Api$Provider$Patient$Engaged(2));
		case 'with_bounced_emails':
			return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$WithBouncedEmail);
		case 'with_unsubscribed_emails':
			return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$WithUnsubscribedEmails);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$PatientFilter$DropdownMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$PatientFilter$init = $author$project$Ui$Dropdown$init(
	$author$project$Ui$Dropdown$defaultConfig(
		{ahP: 'patient-filter', al6: $author$project$Components$PatientFilter$DropdownMsg}));
var $author$project$Api$Practice$sponsorize = F2(
	function (practice, string) {
		if (!practice.$) {
			var practice_ = practice.a;
			return A2($author$project$Formatters$String$sponsorize, practice_, string);
		} else {
			return string;
		}
	});
var $author$project$Utils$Report$CompanyResourceFilter$init = F4(
	function (apiClient, optionals, practice, companyId) {
		return A2(
			$author$project$Components$ResourceFilter$Company$init,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				optionals,
				function (d) {
					return _Utils_update(
						d,
						{
							Gp: 'All ' + A2($author$project$Api$Practice$sponsorize, practice, 'Companies'),
							akb: companyId
						});
				}));
	});
var $author$project$Utils$Report$PlanResourceFilter$init = F4(
	function (apiClient, optionals, session, planId) {
		return A4(
			$author$project$Components$ResourceFilter$Plan$init,
			apiClient,
			session,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Basics$composeL,
				optionals,
				function (d) {
					return _Utils_update(
						d,
						{Gp: 'All Plans', akb: planId});
				}));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$Active = 0;
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$Ended = 2;
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$Pending = 1;
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$stringToStatusType = function (str) {
	switch (str) {
		case 'active':
			return $elm$core$Maybe$Just(0);
		case 'pending':
			return $elm$core$Maybe$Just(1);
		case 'ended':
			return $elm$core$Maybe$Just(2);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$init = F4(
	function (session, practice, shared, _v0) {
		var params = _v0.YL;
		var query = _v0.DE;
		var q = A2($elm$core$Dict$get, 'q', query);
		var planId = A2($elm$core$Dict$get, 'plan', query);
		var companyId = A2($elm$core$Dict$get, 'company', query);
		var _v1 = A3(
			$author$project$Components$ResourceFilter$Practitioner$init,
			shared.Gv,
			function (d) {
				return _Utils_update(
					d,
					{
						Gn: $elm$core$Maybe$Just(params.rd)
					});
			},
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'All Providers', ai5: true});
			});
		var practitionerResourceFilter = _v1.a;
		var practitionerResourceFilterCmd = _v1.b;
		var _v2 = A4(
			$author$project$Utils$Report$PlanResourceFilter$init,
			shared.Gv,
			function (d) {
				return _Utils_update(
					d,
					{ai5: true});
			},
			session,
			planId);
		var planResourceFilter = _v2.a;
		var planResourceFilterCmd = _v2.b;
		var _v3 = A4(
			$author$project$Utils$Report$CompanyResourceFilter$init,
			shared.Gv,
			function (d) {
				return _Utils_update(
					d,
					{ai5: true});
			},
			$author$project$Api$Practice$Provider(practice),
			companyId);
		var companyResourceFilter = _v3.a;
		var companyResourceFilterCmd = _v3.b;
		var model = {
			c$: $author$project$Api$Data$Loading,
			rd: params.rd,
			Gv: shared.Gv,
			GQ: A3($author$project$Permission$canGoTo, session, shared.ahK, 50),
			fZ: companyId,
			mZ: companyResourceFilter,
			h: A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					$elm$core$List$filterMap($author$project$Api$Provider$Patient$filterFromString),
					A2(
						$elm$core$Maybe$map,
						$elm$core$String$split(','),
						A2($elm$core$Dict$get, 'filter', query)))),
			Ij: $author$project$Shared$isHintAdmin(shared),
			ajJ: $author$project$Api$Pagination$initFromQuery(query),
			kz: $author$project$Components$PatientFilter$init,
			aj4: planId,
			hi: planResourceFilter,
			ZV: practice,
			Z2: A2($elm$core$Dict$get, 'practitioner', query),
			hk: practitionerResourceFilter,
			akl: q,
			e5: false,
			up: $author$project$Ui$SearchInput$init(q),
			alH: A2(
				$elm$core$Maybe$andThen,
				$author$project$Pages$Affiliates$AffiliateId_String$Patients$stringToStatusType,
				A2($elm$core$Dict$get, 'status', query)),
			qn: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'status-dropdown-filter', al6: $author$project$Pages$Affiliates$AffiliateId_String$Patients$StatusDropdownMsg}))
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Pages$Affiliates$AffiliateId_String$Patients$fetchAffiliateCoveragePeriods(model),
						A2($elm$core$Basics$composeR, $author$project$Pages$Affiliates$AffiliateId_String$Patients$buildUrl, $author$project$Ports$Navigation$replaceUrl)(model),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$CompanyResourceFilterMsg, companyResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$PlanResourceFilterMsg, planResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$PractitionerResourceFilterMsg, practitionerResourceFilterCmd)
					])));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$CloseResyncWarningModal = {$: 12};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$PatientFilterMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$PatientFilter$subscriptions = function (model) {
	return $author$project$Ui$Dropdown$subscriptions(model);
};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Affiliates$AffiliateId_String$Patients$PatientFilterMsg,
				$author$project$Components$PatientFilter$subscriptions(model.kz)),
				model.e5 ? $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Pages$Affiliates$AffiliateId_String$Patients$CloseResyncWarningModal) : $elm$core$Platform$Sub$none,
				$author$project$Ui$Dropdown$subscriptions(model.qn),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Affiliates$AffiliateId_String$Patients$PlanResourceFilterMsg,
				$author$project$Components$ResourceFilter$Plan$subscriptions(model.hi)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Affiliates$AffiliateId_String$Patients$CompanyResourceFilterMsg,
				$author$project$Components$ResourceFilter$Company$subscriptions(model.mZ)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Affiliates$AffiliateId_String$Patients$PractitionerResourceFilterMsg,
				$author$project$Components$ResourceFilter$Practitioner$subscriptions(model.hk))
			]));
};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$ExportFileMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$ResyncTriggered = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$SearchInputMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Affiliate$syncPlansAndFailedSyncs = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['sync_plans_and_failed_syncs']),
					$author$project$Api$Provider$Affiliate$affiliatePath(id_))));
	});
var $author$project$Components$PatientFilter$FilterSelected = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$PatientFilter$None = {$: 0};
var $author$project$Components$PatientFilter$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var subMsg = msg.a;
			var _v1 = A2($author$project$Ui$Dropdown$update, subMsg, model);
			var dropdown = _v1.a;
			var cmd = _v1.b;
			return _Utils_Tuple3(dropdown, cmd, $author$project$Components$PatientFilter$None);
		} else {
			var patientFilter = msg.a;
			return _Utils_Tuple3(
				model,
				$elm$core$Platform$Cmd$none,
				$author$project$Components$PatientFilter$FilterSelected(patientFilter));
		}
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$updateIfStale = F3(
	function (getter, currentModel, newModel) {
		var updatedModel = _Utils_eq(
			getter(currentModel),
			getter(newModel)) ? newModel : _Utils_update(
			newModel,
			{
				c$: $author$project$Api$Data$Loading,
				ajJ: $author$project$Api$Pagination$reset(newModel.ajJ)
			});
		return _Utils_eq(
			getter(currentModel),
			getter(newModel)) ? _Utils_Tuple2(updatedModel, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
			updatedModel,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Pages$Affiliates$AffiliateId_String$Patients$fetchAffiliateCoveragePeriods(updatedModel),
						A2($elm$core$Basics$composeR, $author$project$Pages$Affiliates$AffiliateId_String$Patients$buildUrl, $author$project$Ports$Navigation$pushUrl)(updatedModel)
					])));
	});
var $author$project$Components$ResourceFilter$Company$value = function (model) {
	return A2($author$project$Components$ResourceFilter$choiceToValue, model.b8, model.Jy);
};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								c$: response,
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{c$: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Ui$SearchInput$update, subMsg, model.up);
				var searchInput = _v2.a;
				var searchInputCmd = _v2.b;
				var searchInputEvent = _v2.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.akl;
					}
				}();
				var _v3 = function () {
					if (_Utils_eq(q, model.akl)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								c$: $author$project$Api$Data$Loading,
								ajJ: $author$project$Api$Pagination$reset(model.ajJ),
								akl: q
							});
						return _Utils_Tuple2(
							qModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Affiliates$AffiliateId_String$Patients$fetchAffiliateCoveragePeriods(qModel),
										A2($elm$core$Basics$composeR, $author$project$Pages$Affiliates$AffiliateId_String$Patients$buildUrl, $author$project$Ports$Navigation$pushUrl)(qModel)
									])));
					}
				}();
				var newModel = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{up: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
			case 2:
				var subMsg = msg.a;
				var _v5 = A2($author$project$Components$PatientFilter$update, subMsg, model.kz);
				var patientFilter = _v5.a;
				var cmd = _v5.b;
				var event = _v5.c;
				if (event.$ === 1) {
					var selectedFilters = event.a;
					var newModel = _Utils_update(
						model,
						{
							c$: $author$project$Api$Data$Loading,
							h: selectedFilters,
							ajJ: $author$project$Api$Pagination$reset(model.ajJ),
							kz: patientFilter
						});
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Pages$Affiliates$AffiliateId_String$Patients$fetchAffiliateCoveragePeriods(newModel),
									A2($elm$core$Basics$composeR, $author$project$Pages$Affiliates$AffiliateId_String$Patients$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$PatientFilterMsg, cmd)
								])),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{kz: patientFilter}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$PatientFilterMsg, cmd),
						_List_Nil);
				}
			case 3:
				var subMsg = msg.a;
				var companyResourceResult = A3($author$project$Components$ResourceFilter$Company$update, model.Gv, subMsg, model.mZ);
				var companyId = function () {
					var _v8 = companyResourceResult.agZ;
					if (!_v8.$) {
						return $author$project$Components$ResourceFilter$Company$value(companyResourceResult.aiO);
					} else {
						return model.fZ;
					}
				}();
				var _v7 = A3(
					$author$project$Pages$Affiliates$AffiliateId_String$Patients$updateIfStale,
					function ($) {
						return $.fZ;
					},
					model,
					_Utils_update(
						model,
						{fZ: companyId, mZ: companyResourceResult.aiO}));
				var newModel = _v7.a;
				var cmd = _v7.b;
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$CompanyResourceFilterMsg, companyResourceResult.GZ),
								cmd
							])),
					companyResourceResult.aR);
			case 4:
				var subMsg = msg.a;
				var planResourceResult = A3($author$project$Components$ResourceFilter$Plan$update, model.Gv, subMsg, model.hi);
				var planId = function () {
					var _v10 = planResourceResult.agZ;
					if (!_v10.$) {
						return $author$project$Components$ResourceFilter$Plan$value(planResourceResult.aiO);
					} else {
						return model.aj4;
					}
				}();
				var _v9 = A3(
					$author$project$Pages$Affiliates$AffiliateId_String$Patients$updateIfStale,
					function ($) {
						return $.aj4;
					},
					model,
					_Utils_update(
						model,
						{aj4: planId, hi: planResourceResult.aiO}));
				var newModel = _v9.a;
				var cmd = _v9.b;
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$PlanResourceFilterMsg, planResourceResult.GZ),
								cmd
							])),
					planResourceResult.aR);
			case 5:
				var subMsg = msg.a;
				var practitionerResourceResult = A3($author$project$Components$ResourceFilter$Practitioner$update, model.Gv, subMsg, model.hk);
				var practitionerId = function () {
					var _v12 = practitionerResourceResult.agZ;
					if (!_v12.$) {
						return $author$project$Components$ResourceFilter$Practitioner$value(practitionerResourceResult.aiO);
					} else {
						return model.Z2;
					}
				}();
				var _v11 = A3(
					$author$project$Pages$Affiliates$AffiliateId_String$Patients$updateIfStale,
					function ($) {
						return $.Z2;
					},
					model,
					_Utils_update(
						model,
						{Z2: practitionerId, hk: practitionerResourceResult.aiO}));
				var newModel = _v11.a;
				var cmd = _v11.b;
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$PractitionerResourceFilterMsg, practitionerResourceResult.GZ),
								cmd
							])),
					practitionerResourceResult.aR);
			case 6:
				var subMsg = msg.a;
				var _v13 = A2($author$project$Ui$Dropdown$update, subMsg, model.qn);
				var statusDropdown = _v13.a;
				var cmd = _v13.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qn: statusDropdown}),
					cmd,
					_List_Nil);
			case 7:
				var selectedStatus = msg.a;
				var newModel = _Utils_update(
					model,
					{
						c$: $author$project$Api$Data$Loading,
						ajJ: $author$project$Api$Pagination$reset(model.ajJ),
						alH: selectedStatus
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Affiliates$AffiliateId_String$Patients$fetchAffiliateCoveragePeriods(newModel),
								A2($elm$core$Basics$composeR, $author$project$Pages$Affiliates$AffiliateId_String$Patients$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 8:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{c$: $author$project$Api$Data$Loading, ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Affiliates$AffiliateId_String$Patients$fetchAffiliateCoveragePeriods(newModel),
								A2($elm$core$Basics$composeR, $author$project$Pages$Affiliates$AffiliateId_String$Patients$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 9:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{e5: true}),
					A3($author$project$Api$Provider$Affiliate$syncPlansAndFailedSyncs, model.Gv, model.rd, $author$project$Pages$Affiliates$AffiliateId_String$Patients$ResyncTriggered),
					_List_Nil);
			case 10:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{e5: false}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Re-sync triggered successfully')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{e5: false}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 11:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{e5: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 12:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{e5: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v15 = $author$project$Components$FileLink$update(subMsg);
				var getFileCmdMsg = _v15.a;
				var outMsgs = _v15.b;
				return _Utils_Tuple3(
					model,
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$ExportFileMsg, getFileCmdMsg),
					outMsgs);
		}
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$PaginationMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$ShowResyncWarningModal = {$: 11};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$TriggerResync = {$: 9};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$columns = function (practice) {
	return _List_fromArray(
		[
			A3($author$project$Api$Column$init, 'name', false, 'Name'),
			A3($author$project$Api$Column$init, 'plan_type', false, 'Plan Type'),
			A3(
			$author$project$Api$Column$init,
			'company',
			false,
			A2($author$project$Formatters$String$sponsorize, practice, 'Employer')),
			A3($author$project$Api$Column$init, 'practitioner', false, 'Provider'),
			A3($author$project$Api$Column$init, 'affiliate_rate', false, 'Affiliate Rate'),
			A3($author$project$Api$Column$init, 'total_in_cents', false, 'Total Rate'),
			A3($author$project$Api$Column$init, 'status', false, 'Status')
		]);
};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$exportCsvPath = function (model) {
	var csvParams = A2(
		$elm$core$List$concatMap,
		$author$project$Api$Param$toQuery,
		$author$project$Api$Provider$Affiliates$AffiliateCoveragePeriod$listOptionsToParams(
			$author$project$Pages$Affiliates$AffiliateId_String$Patients$fetchParams(model)));
	return A4(
		$author$project$Api$Data$downloadUrl,
		model.Gv,
		$author$project$Api$Provider$Affiliates$AffiliateCoveragePeriod$affiliateCoveragePeriodsPath(model.rd),
		0,
		csvParams);
};
var $author$project$Components$PatientFilter$FilterSelected_ = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$PatientFilter$isAutopayFilter = function (filter) {
	if (filter.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$PatientFilter$isEngagedFilter = function (filter) {
	if (filter.$ === 13) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$PatientFilter$isStatusFilter = function (filter) {
	if (!filter.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$PatientFilter$checkedItem = F2(
	function (filter, currentFilters) {
		return A2($elm$core$List$member, filter, currentFilters) ? A2(
			$elm$core$List$filter,
			function (current) {
				return !_Utils_eq(current, filter);
			},
			currentFilters) : A2(
			$elm$core$List$cons,
			filter,
			function () {
				switch (filter.$) {
					case 0:
						return A2(
							$elm$core$List$filter,
							A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Components$PatientFilter$isStatusFilter),
							currentFilters);
					case 1:
						return A2(
							$elm$core$List$filter,
							A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Components$PatientFilter$isAutopayFilter),
							currentFilters);
					case 13:
						return A2(
							$elm$core$List$filter,
							A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Components$PatientFilter$isEngagedFilter),
							currentFilters);
					default:
						return currentFilters;
				}
			}());
	});
var $author$project$Components$PatientFilter$clearCategoryFilters = F2(
	function (predicate, currentFilters) {
		return A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, predicate),
			currentFilters);
	});
var $author$project$Components$PatientFilter$filterToLabel = function (filter) {
	switch (filter.$) {
		case 0:
			switch (filter.a) {
				case 0:
					var _v1 = filter.a;
					return 'Active Patients';
				case 2:
					var _v2 = filter.a;
					return 'Pending';
				case 3:
					var _v3 = filter.a;
					return 'Unconfirmed';
				case 1:
					var _v4 = filter.a;
					return 'Inactive';
				default:
					var _v5 = filter.a;
					return 'Archived Patients';
			}
		case 1:
			if (filter.a) {
				return 'Autopay Enabled';
			} else {
				return 'Autopay Disabled';
			}
		case 2:
			return 'Active and Paid';
		case 3:
			return 'Has Past Due Invoices';
		case 4:
			return 'No Payment Info';
		case 5:
			return 'No ePHI waiver';
		case 6:
			return 'No Email Address';
		case 7:
			return 'Has Flagged Notes';
		case 15:
			return 'Unsubscribed From Emails';
		case 14:
			return 'Has Bounced Emails';
		case 9:
			return 'Unsynced Integration';
		case 8:
			return 'Failed Sync';
		case 10:
			return 'New Activations';
		case 11:
			return 'New Terminations';
		case 12:
			return 'Upcoming Birthdays';
		default:
			switch (filter.a) {
				case 0:
					var _v6 = filter.a;
					return 'Currently Engaged';
				case 1:
					var _v7 = filter.a;
					return 'Previously Engaged';
				default:
					var _v8 = filter.a;
					return 'Never Engaged';
			}
	}
};
var $author$project$Ui$Dropdown$Radio = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Ui$Dropdown$radio = $author$project$Ui$Dropdown$Radio;
var $author$project$Components$PatientFilter$dropdownItems = F2(
	function (practice, currentFilters) {
		var radioItem = function (filter) {
			return A2(
				$author$project$Ui$Dropdown$radio,
				_List_fromArray(
					[
						$author$project$Ui$Dropdown$onCheck(
						$elm$core$Basics$always(
							$author$project$Components$PatientFilter$FilterSelected_(
								A2($author$project$Components$PatientFilter$checkedItem, filter, currentFilters)))),
						$author$project$Ui$Dropdown$checked(
						A2($elm$core$List$member, filter, currentFilters))
					]),
				$elm$html$Html$text(
					$author$project$Components$PatientFilter$filterToLabel(filter)));
		};
		var practiceIsAffiliateOrNetwork = $author$project$Api$Provider$Practice$One$isNetwork(practice) || $author$project$Api$Provider$Practice$One$isAffiliate(practice);
		var gateIsAvailable = A2(
			$author$project$Utils$FeatureGate$gateAvailable,
			11,
			$author$project$Api$Practice$Provider(practice));
		var engagementFilters = function () {
			if (gateIsAvailable || practiceIsAffiliateOrNetwork) {
				var anyEngagedItem = A2(
					$author$project$Ui$Dropdown$radio,
					_List_fromArray(
						[
							$author$project$Ui$Dropdown$onCheck(
							$elm$core$Basics$always(
								$author$project$Components$PatientFilter$FilterSelected_(
									A2($author$project$Components$PatientFilter$clearCategoryFilters, $author$project$Components$PatientFilter$isEngagedFilter, currentFilters)))),
							$author$project$Ui$Dropdown$checked(
							!A2($elm$core$List$any, $author$project$Components$PatientFilter$isEngagedFilter, currentFilters))
						]),
					$elm$html$Html$text('Any Engagement'));
				return _List_fromArray(
					[
						$author$project$Ui$Dropdown$separator,
						anyEngagedItem,
						radioItem(
						$author$project$Api$Provider$Patient$Engaged(0)),
						radioItem(
						$author$project$Api$Provider$Patient$Engaged(1)),
						radioItem(
						$author$project$Api$Provider$Patient$Engaged(2))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var checkboxItem = function (filter) {
			return A2(
				$author$project$Ui$Dropdown$checkbox,
				_List_fromArray(
					[
						$author$project$Ui$Dropdown$onCheck(
						$elm$core$Basics$always(
							$author$project$Components$PatientFilter$FilterSelected_(
								A2($author$project$Components$PatientFilter$checkedItem, filter, currentFilters)))),
						$author$project$Ui$Dropdown$checked(
						A2($elm$core$List$member, filter, currentFilters))
					]),
				$elm$html$Html$text(
					$author$project$Components$PatientFilter$filterToLabel(filter)));
		};
		var anyStatusItem = A2(
			$author$project$Ui$Dropdown$radio,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onCheck(
					$elm$core$Basics$always(
						$author$project$Components$PatientFilter$FilterSelected_(
							A2($author$project$Components$PatientFilter$clearCategoryFilters, $author$project$Components$PatientFilter$isStatusFilter, currentFilters)))),
					$author$project$Ui$Dropdown$checked(
					!A2($elm$core$List$any, $author$project$Components$PatientFilter$isStatusFilter, currentFilters))
				]),
			$elm$html$Html$text('Any Status'));
		var anyAutopayItem = A2(
			$author$project$Ui$Dropdown$radio,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onCheck(
					$elm$core$Basics$always(
						$author$project$Components$PatientFilter$FilterSelected_(
							A2($author$project$Components$PatientFilter$clearCategoryFilters, $author$project$Components$PatientFilter$isAutopayFilter, currentFilters)))),
					$author$project$Ui$Dropdown$checked(
					!A2($elm$core$List$any, $author$project$Components$PatientFilter$isAutopayFilter, currentFilters))
				]),
			$elm$html$Html$text('Any Autopay'));
		var baseFilters = _List_fromArray(
			[
				anyStatusItem,
				radioItem(
				$author$project$Api$Provider$Patient$Status(0)),
				radioItem(
				$author$project$Api$Provider$Patient$Status(2)),
				radioItem(
				$author$project$Api$Provider$Patient$Status(3)),
				radioItem(
				$author$project$Api$Provider$Patient$Status(1)),
				radioItem(
				$author$project$Api$Provider$Patient$Status(4)),
				$author$project$Ui$Dropdown$separator,
				anyAutopayItem,
				radioItem(
				$author$project$Api$Provider$Patient$AutopayEnabled(true)),
				radioItem(
				$author$project$Api$Provider$Patient$AutopayEnabled(false)),
				$author$project$Ui$Dropdown$separator,
				checkboxItem($author$project$Api$Provider$Patient$ActiveMembership),
				checkboxItem($author$project$Api$Provider$Patient$PastDueCustomerInvoices),
				checkboxItem($author$project$Api$Provider$Patient$AccountOwnerWithoutPaymentInfo),
				$author$project$Ui$Dropdown$separator,
				checkboxItem($author$project$Api$Provider$Patient$WithoutHipaaAuthorization),
				checkboxItem($author$project$Api$Provider$Patient$WithoutEmail),
				checkboxItem($author$project$Api$Provider$Patient$WithFlaggedNotes),
				checkboxItem($author$project$Api$Provider$Patient$WithUnsubscribedEmails),
				checkboxItem($author$project$Api$Provider$Patient$WithBouncedEmail),
				$author$project$Ui$Dropdown$separator,
				checkboxItem($author$project$Api$Provider$Patient$WithUnsyncedIntegrations),
				checkboxItem($author$project$Api$Provider$Patient$WithFailedIntegrations),
				$author$project$Ui$Dropdown$separator,
				checkboxItem($author$project$Api$Provider$Patient$NewActivationsSinceDate),
				checkboxItem($author$project$Api$Provider$Patient$NewTerminationsSinceDate),
				checkboxItem($author$project$Api$Provider$Patient$WithUpcomingBirthday)
			]);
		return A2(
			$elm$core$List$cons,
			A2(
				$author$project$Ui$Dropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$Dropdown$onSelect(
						$author$project$Components$PatientFilter$FilterSelected_(_List_Nil)),
						$author$project$Ui$Dropdown$selected(
						_Utils_eq(currentFilters, _List_Nil))
					]),
				$elm$html$Html$text('All Patients')),
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Dropdown$separator,
				_Utils_ap(baseFilters, engagementFilters)));
	});
var $author$project$Components$PatientFilter$view = F3(
	function (practice, value, model) {
		var placeholder = function () {
			if (!value.b) {
				return 'All Patients';
			} else {
				if (!value.b.b) {
					var single = value.a;
					return $author$project$Components$PatientFilter$filterToLabel(single);
				} else {
					var many = value;
					return $elm$core$String$fromInt(
						$elm$core$List$length(many)) + ' Selected';
				}
			}
		}();
		return A4(
			$author$project$Ui$Dropdown$viewSelect,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(placeholder)
				]),
			A2($author$project$Components$PatientFilter$dropdownItems, practice, value),
			model);
	});
var $author$project$Api$Provider$AffiliateCoveragePeriod$All$affiliatePeriodInMonths = function (_v0) {
	var record = _v0.b;
	return record.Ld;
};
var $author$project$Api$Provider$AffiliateCoveragePeriod$All$affiliateRateInCents = function (_v0) {
	var record = _v0.b;
	return record.Lg;
};
var $author$project$Formatters$Int$asPeriod = function (periodInMonths) {
	switch (periodInMonths) {
		case 1:
			return 'Monthly';
		case 3:
			return 'Quarterly';
		case 6:
			return 'Semi-annually';
		case 12:
			return 'Annually';
		default:
			return '/ ' + $elm$core$String$fromInt(periodInMonths);
	}
};
var $author$project$Api$Provider$AffiliateCoveragePeriod$All$company = function (_v0) {
	var record = _v0.b;
	return record.afQ;
};
var $author$project$Api$Provider$AffiliateCoveragePeriod$Shared$enrollmentDate = function (_v0) {
	var record = _v0;
	return record.RE;
};
var $author$project$Api$Provider$AffiliateCoveragePeriod$All$enrollmentDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$AffiliateCoveragePeriod$Shared$enrollmentDate(shared);
};
var $author$project$Api$Provider$AffiliateCoveragePeriod$Shared$terminationDate = function (_v0) {
	var record = _v0;
	return record.ac1;
};
var $author$project$Api$Provider$AffiliateCoveragePeriod$All$terminationDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$AffiliateCoveragePeriod$Shared$terminationDate(shared);
};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$dateForDisplay = function (affiliateCoveragePeriod) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Api$Provider$AffiliateCoveragePeriod$All$enrollmentDate(affiliateCoveragePeriod),
		$author$project$Api$Provider$AffiliateCoveragePeriod$All$terminationDate(affiliateCoveragePeriod));
};
var $author$project$Api$Provider$RateRule$Min$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$AffiliateCoveragePeriod$All$networkPeriodInMonths = function (_v0) {
	var record = _v0.b;
	return record.XD;
};
var $author$project$Api$Provider$AffiliateCoveragePeriod$All$networkRateInCents = function (_v0) {
	var record = _v0.b;
	return record.XF;
};
var $author$project$Api$Provider$AffiliateCoveragePeriod$All$patient = function (_v0) {
	var record = _v0.b;
	return record.YY;
};
var $author$project$Api$Provider$AffiliateCoveragePeriod$All$practitioner = function (_v0) {
	var record = _v0.b;
	return record.aka;
};
var $author$project$Api$Provider$AffiliateCoveragePeriod$All$rateRule = function (_v0) {
	var record = _v0.b;
	return record._3;
};
var $author$project$Api$Provider$AffiliateCoveragePeriod$Shared$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Api$Provider$AffiliateCoveragePeriod$All$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$AffiliateCoveragePeriod$Shared$status(shared);
};
var $author$project$Api$Provider$RateRule$Min$type_ = function (_v0) {
	var record = _v0;
	return record.amg;
};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$verbFor = function (affiliateCoveragePeriod) {
	return $author$project$Utils$Maybe$toBool(
		$author$project$Api$Provider$AffiliateCoveragePeriod$All$terminationDate(affiliateCoveragePeriod)) ? (($author$project$Api$Provider$AffiliateCoveragePeriod$All$status(affiliateCoveragePeriod) === 'ended') ? 'ended' : 'ending') : (($author$project$Api$Provider$AffiliateCoveragePeriod$All$status(affiliateCoveragePeriod) === 'pending') ? 'starting' : 'since');
};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$viewAffiliateCoveragePeriod = F2(
	function (canGoToPatients, affiliateCoveragePeriod) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[
									$author$project$Ui$Typography$phi(true)
								]),
							function () {
								var _v0 = _Utils_Tuple2(
									$elm$core$Maybe$Just(
										$author$project$Api$Provider$AffiliateCoveragePeriod$All$patient(affiliateCoveragePeriod)),
									canGoToPatients);
								if (!_v0.a.$) {
									if (_v0.b) {
										var patient = _v0.a.a;
										return _List_fromArray(
											[
												A3(
												$author$project$Ui$Link$route,
												$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
													{
														YZ: $author$project$Api$Provider$Patient$Min$id(patient)
													}),
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Api$Provider$Patient$Min$name(patient))
													]))
											]);
									} else {
										var patient = _v0.a.a;
										return _List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Api$Provider$Patient$Min$name(patient))
											]);
									}
								} else {
									return _List_Nil;
								}
							}())
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									A2($elm$core$Basics$composeR, $author$project$Api$Provider$RateRule$Min$type_, $author$project$Formatters$String$humanize),
									$author$project$Api$Provider$AffiliateCoveragePeriod$All$rateRule(affiliateCoveragePeriod)))),
							A2($elm$html$Html$br, _List_Nil, _List_Nil),
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'N/A',
								A2(
									$elm$core$Maybe$map,
									$author$project$Api$Provider$RateRule$Min$name,
									$author$project$Api$Provider$AffiliateCoveragePeriod$All$rateRule(affiliateCoveragePeriod))))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									$author$project$Api$Provider$Company$Min$name,
									$author$project$Api$Provider$AffiliateCoveragePeriod$All$company(affiliateCoveragePeriod))))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									$author$project$Api$Provider$Practitioner$Min$name,
									$author$project$Api$Provider$AffiliateCoveragePeriod$All$practitioner(affiliateCoveragePeriod))))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					function () {
						var _v1 = $author$project$Api$Provider$AffiliateCoveragePeriod$All$affiliateRateInCents(affiliateCoveragePeriod);
						if (!_v1.$) {
							var affiliateRateInCents = _v1.a;
							return _List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(affiliateRateInCents)),
									$author$project$Utils$Html$noBreakSpace,
									$elm$html$Html$text(
									$author$project$Formatters$Int$asPeriod(
										$author$project$Api$Provider$AffiliateCoveragePeriod$All$affiliatePeriodInMonths(affiliateCoveragePeriod)))
								]);
						} else {
							return _List_Nil;
						}
					}()),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					function () {
						var _v2 = $author$project$Api$Provider$AffiliateCoveragePeriod$All$networkRateInCents(affiliateCoveragePeriod);
						if (!_v2.$) {
							var networkRateInCents = _v2.a;
							return _List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(networkRateInCents)),
									$author$project$Utils$Html$noBreakSpace,
									$elm$html$Html$text(
									$author$project$Formatters$Int$asPeriod(
										$author$project$Api$Provider$AffiliateCoveragePeriod$All$networkPeriodInMonths(affiliateCoveragePeriod)))
								]);
						} else {
							return _List_Nil;
						}
					}()),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[
							$author$project$Ui$Table$colspan(2)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Badge$fromString,
							_List_Nil,
							$author$project$Api$Provider$AffiliateCoveragePeriod$All$status(affiliateCoveragePeriod)),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textMuted]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Pages$Affiliates$AffiliateId_String$Patients$verbFor(affiliateCoveragePeriod)),
									$author$project$Utils$Html$noBreakSpace,
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$Date$toString,
										$author$project$Formatters$Date$Full,
										$author$project$Pages$Affiliates$AffiliateId_String$Patients$dateForDisplay(affiliateCoveragePeriod)))
								]))
						]))
				]));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$StatusSelected = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$statusTypeToLabel = function (statusType) {
	switch (statusType) {
		case 0:
			return 'Active';
		case 1:
			return 'Pending';
		default:
			return 'Ended';
	}
};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$viewStatusDropdown = function (model) {
	var currentLabel = function () {
		var _v0 = model.alH;
		if (!_v0.$) {
			var statusType = _v0.a;
			return $author$project$Pages$Affiliates$AffiliateId_String$Patients$statusTypeToLabel(statusType);
		} else {
			return 'Status';
		}
	}();
	var allStatuses = _List_fromArray(
		[0, 1, 2]);
	var items = A2(
		$elm$core$List$cons,
		A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Pages$Affiliates$AffiliateId_String$Patients$StatusSelected($elm$core$Maybe$Nothing))
				]),
			$elm$html$Html$text('All Statuses')),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$Dropdown$separator,
			A2(
				$elm$core$List$map,
				function (statusType) {
					return A2(
						$author$project$Ui$Dropdown$item,
						_List_fromArray(
							[
								$author$project$Ui$Dropdown$onSelect(
								$author$project$Pages$Affiliates$AffiliateId_String$Patients$StatusSelected(
									$elm$core$Maybe$Just(statusType)))
							]),
						$elm$html$Html$text(
							$author$project$Pages$Affiliates$AffiliateId_String$Patients$statusTypeToLabel(statusType)));
				},
				allStatuses)));
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(currentLabel)
			]),
		items,
		model.qn);
};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$view = function (model) {
	var _v0 = function () {
		var _v1 = model.c$;
		if (_v1.$ === 3) {
			var affiliateCoveragePeriods_ = _v1.a;
			return _Utils_Tuple2(false, affiliateCoveragePeriods_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var affiliateCoveragePeriods = _v0.b;
	return {
		fO: _List_fromArray(
			[
				model.e5 ? A3(
				$author$project$Ui$Modal$view,
				$author$project$Pages$Affiliates$AffiliateId_String$Patients$CloseResyncWarningModal,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Modal$header(
						_List_fromArray(
							[
								$author$project$Ui$Modal$title('Resync mapped plans and failed syncs')
							])),
						$author$project$Ui$Modal$body(
						_List_fromArray(
							[
								$elm$html$Html$text('Please don\'t execute the resync more than once an hour. If failures persist after the previous resync, contact the affiliates team instead of running this.')
							])),
						$author$project$Ui$Modal$footer(
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Close modal'},
								_List_fromArray(
									[
										$author$project$Ui$Button$onClick($author$project$Pages$Affiliates$AffiliateId_String$Patients$CloseResyncWarningModal)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Close')
									])),
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Resync mapped plans and failed syncs'},
								_List_fromArray(
									[
										$author$project$Ui$Button$primary,
										$author$project$Ui$Button$onClick($author$project$Pages$Affiliates$AffiliateId_String$Patients$TriggerResync)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Re-sync')
									]))
							]))
					])) : $author$project$Utils$Html$empty,
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$mb2]),
								_List_fromArray(
									[
										$author$project$Ui$Typography$headingSm(
										_List_fromArray(
											[
												$elm$html$Html$text('Patients')
											])),
										model.Ij ? A3(
										$author$project$Ui$HinterOnly$button,
										{mm: 'Re-sync'},
										_List_fromArray(
											[
												$author$project$Ui$Button$styled(0),
												$author$project$Ui$Button$onClick($author$project$Pages$Affiliates$AffiliateId_String$Patients$ShowResyncWarningModal),
												$author$project$Ui$Button$sm
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Re-sync')
											])) : $author$project$Utils$Html$empty
									])),
								A2(
								$author$project$Ui$Grid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$spanSm(12)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Pages$Affiliates$AffiliateId_String$Patients$SearchInputMsg,
												A2($author$project$Ui$SearchInput$view, _List_Nil, model.up))
											]))
									])),
								A2(
								$author$project$Ui$Grid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(6),
												$author$project$Ui$Grid$spanSm(2)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Pages$Affiliates$AffiliateId_String$Patients$PatientFilterMsg,
												A3($author$project$Components$PatientFilter$view, model.ZV, model.h, model.kz))
											])),
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(6),
												$author$project$Ui$Grid$spanSm(2)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Pages$Affiliates$AffiliateId_String$Patients$CompanyResourceFilterMsg,
												A2($author$project$Components$ResourceFilter$Company$view, _List_Nil, model.mZ))
											])),
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(6),
												$author$project$Ui$Grid$spanSm(2)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Pages$Affiliates$AffiliateId_String$Patients$PlanResourceFilterMsg,
												A2($author$project$Components$ResourceFilter$Plan$view, _List_Nil, model.hi))
											])),
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(6),
												$author$project$Ui$Grid$spanSm(2)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Pages$Affiliates$AffiliateId_String$Patients$PractitionerResourceFilterMsg,
												A2($author$project$Components$ResourceFilter$Practitioner$view, _List_Nil, model.hk))
											])),
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(6),
												$author$project$Ui$Grid$spanSm(2)
											]),
										_List_fromArray(
											[
												$author$project$Pages$Affiliates$AffiliateId_String$Patients$viewStatusDropdown(model)
											]))
									]))
							])),
						A4(
						$author$project$Ui$Panel$table,
						_List_fromArray(
							[
								$author$project$Ui$Table$loading(loading),
								$author$project$Ui$Table$zeroState(
								_List_fromArray(
									[
										$elm$html$Html$text('No matching results.')
									]))
							]),
						_Utils_ap(
							A2(
								$elm$core$List$map,
								$author$project$Api$Column$view($author$project$Api$Column$NonSortable),
								$author$project$Pages$Affiliates$AffiliateId_String$Patients$columns(model.ZV)),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Table$header,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$justifyRight]),
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Tooltip$view,
													_List_Nil,
													'Export to CSV',
													_List_fromArray(
														[
															A2(
															$elm$html$Html$map,
															$author$project$Pages$Affiliates$AffiliateId_String$Patients$ExportFileMsg,
															A3(
																$author$project$Components$FileLink$view,
																{
																	NJ: model.Gv,
																	SG: 0,
																	adY: $author$project$Pages$Affiliates$AffiliateId_String$Patients$exportCsvPath(model)
																},
																_List_fromArray(
																	[
																		$author$project$Ui$Link$ariaLabel('Export Csv'),
																		$author$project$Ui$Link$icon($author$project$Ui$Icon$export)
																	]),
																_List_Nil))
														]))
												]))
										]))
								])),
						A2(
							$elm$core$List$map,
							$author$project$Pages$Affiliates$AffiliateId_String$Patients$viewAffiliateCoveragePeriod(model.GQ),
							affiliateCoveragePeriods),
						_List_Nil),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Affiliates$AffiliateId_String$Patients$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(loading)
										]),
									model.ajJ))
							]))
					]))
			]),
		ac9: 'Affiliates | Patients'
	};
};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Affiliates$AffiliateId_String$Patients$init, aiq: $author$project$Pages$Affiliates$AffiliateId_String$Patients$load, k8: $author$project$Pages$Affiliates$AffiliateId_String$Patients$save, alO: $author$project$Pages$Affiliates$AffiliateId_String$Patients$subscriptions, adT: $author$project$Pages$Affiliates$AffiliateId_String$Patients$update, amo: $author$project$Pages$Affiliates$AffiliateId_String$Patients$view});
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$GotAffiliate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$GotPlans = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Affiliates$Plan$All$Plan = $elm$core$Basics$identity;
var $author$project$Api$Provider$Affiliates$Plan$One$Plan = $elm$core$Basics$identity;
var $author$project$Api$Provider$Affiliates$Plan$One$Record = F6(
	function (id, name, billingDate, _default, plan, networkPlans) {
		return {MG: billingDate, PW: _default, ahP: id, Bq: name, XE: networkPlans, Jb: plan};
	});
var $author$project$Api$Provider$Affiliates$Plan$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'network_plans',
	$elm$json$Json$Decode$list($author$project$Api$Provider$Plan$One$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'plan',
		$author$project$Api$Provider$Plan$One$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'default',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'billing_date',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'name',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$Affiliates$Plan$One$Record)))))));
var $author$project$Api$Provider$Affiliates$Plan$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Affiliates$Plan$One$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Affiliates$Plan$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Affiliates$Plan$One$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Affiliates$Plan$plansPath = function (affiliateId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['plans']),
		$author$project$Api$Provider$Affiliate$affiliatePath(affiliateId));
};
var $author$project$Api$Provider$Affiliates$Plan$list = F3(
	function (apiClient, affiliateId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Affiliates$Plan$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Affiliates$Plan$plansPath(affiliateId)));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$fetchPlans = function (model) {
	return A3($author$project$Api$Provider$Affiliates$Plan$list, model.Gv, model.rd, $author$project$Pages$Affiliates$AffiliateId_String$Settings$GotPlans);
};
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$init = F4(
	function (session, _v0, shared, _v1) {
		var params = _v1.YL;
		var model = {
			Gn: $author$project$Api$Data$Loading,
			rd: params.rd,
			Gv: shared.Gv,
			dY: false,
			iY: $elm$core$Maybe$Nothing,
			jx: $elm$core$Maybe$Nothing,
			Ij: $author$project$Shared$isHintAdmin(shared),
			ZG: $author$project$Api$Data$Loading,
			aV: $elm$core$Set$empty,
			aa4: session
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Pages$Affiliates$AffiliateId_String$Settings$fetchPlans(model),
						A3($author$project$Api$Provider$Affiliate$retrieve, shared.Gv, params.rd, $author$project$Pages$Affiliates$AffiliateId_String$Settings$GotAffiliate)
					])));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					Ij: $author$project$Shared$isHintAdmin(shared)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$CloseArchiveWarningModal = {$: 13};
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$CreateNetworkPlanModalMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$EditNetworkPlanModalMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$CloseModal = {$: 0};
var $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$PercentagePlanMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Affiliates$PercentagePlan$PlanResourceFilterMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Affiliates$PercentagePlan$subscriptions = function (_v0) {
	var model = _v0;
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Components$Affiliates$PercentagePlan$PlanResourceFilterMsg,
		$author$project$Components$ResourceFilter$Plan$subscriptions(model.hi));
};
var $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$CloseModal),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$PercentagePlanMsg,
				$author$project$Components$Affiliates$PercentagePlan$subscriptions(model.hd))
			]));
};
var $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$CloseModal = {$: 0};
var $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$PlanResourceFilterMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Affiliates$Settings$EditNetworkPlanModal$CloseModal),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Affiliates$Settings$EditNetworkPlanModal$PlanResourceFilterMsg,
				$author$project$Components$ResourceFilter$Plan$subscriptions(model.hi))
			]));
};
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Affiliates$AffiliateId_String$Settings$CreateNetworkPlanModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$subscriptions, model.iY))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Affiliates$AffiliateId_String$Settings$EditNetworkPlanModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$subscriptions, model.jx))),
				model.dY ? $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Pages$Affiliates$AffiliateId_String$Settings$CloseArchiveWarningModal) : $elm$core$Platform$Sub$none
			]));
};
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$AffiliationArchived = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$Defaulted = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$Deleted = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$OutMsg$GoToRouteAction = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Affiliate$One$affiliatePractice = function (_v0) {
	var record = _v0.b;
	return record.Le;
};
var $author$project$Api$Provider$Affiliate$archive = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$Affiliate$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['archive']),
					$author$project$Api$Provider$Affiliate$affiliatePath(id_))));
	});
var $author$project$Api$Provider$Affiliates$Plan$planPath = F2(
	function (affiliateId, id) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id]),
			$author$project$Api$Provider$Affiliates$Plan$plansPath(affiliateId));
	});
var $author$project$Api$Provider$Affiliates$Plan$delete = F4(
	function (apiClient, affiliateId, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Provider$Affiliates$Plan$planPath, affiliateId, id)));
	});
var $author$project$Components$Affiliates$PercentagePlan$Model = $elm$core$Basics$identity;
var $author$project$Components$Affiliates$PercentagePlan$Fixed = 0;
var $author$project$Components$Affiliates$PercentagePlan$initFormFields = {ahn: $elm$core$Maybe$Nothing, Bq: $elm$core$Maybe$Nothing, ajZ: $elm$core$Maybe$Nothing, aj4: $elm$core$Maybe$Nothing, akg: 0};
var $author$project$Components$Affiliates$PercentagePlan$initPlanResourceFilter = F2(
	function (apiClient, session) {
		return A4(
			$author$project$Components$ResourceFilter$Plan$init,
			apiClient,
			session,
			$elm$core$Basics$identity,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Select a Plan'});
			});
	});
var $author$project$Components$Affiliates$PercentagePlan$init = F3(
	function (apiClient, session, affiliatePractice) {
		var _v0 = A2($author$project$Components$Affiliates$PercentagePlan$initPlanResourceFilter, apiClient, session);
		var planResourceFilter = _v0.a;
		var planResourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{
				Le: affiliatePractice,
				SD: $author$project$Utils$Form$init($author$project$Components$Affiliates$PercentagePlan$initFormFields),
				hi: planResourceFilter
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$Affiliates$PercentagePlan$PlanResourceFilterMsg, planResourceFilterCmd));
	});
var $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$init = F3(
	function (apiClient, session, affiliateId) {
		var _v0 = A3($author$project$Components$Affiliates$PercentagePlan$init, apiClient, session, $elm$core$Maybe$Nothing);
		var percentagePlan = _v0.a;
		var percentagePlanCmd = _v0.b;
		return _Utils_Tuple2(
			{rd: affiliateId, hd: percentagePlan, k9: $author$project$Api$Data$NotAsked},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$PercentagePlanMsg, percentagePlanCmd));
	});
var $author$project$Api$Provider$Affiliates$Plan$One$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Affiliates$Plan$All$id = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Affiliates$Plan$One$id(one);
};
var $author$project$Api$Provider$Affiliates$Plan$One$networkPlans = function (_v0) {
	var record = _v0;
	return record.XE;
};
var $author$project$Api$Provider$Affiliates$Plan$All$networkPlans = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Affiliates$Plan$One$networkPlans(one);
};
var $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$init = F4(
	function (apiClient, session, affiliateId, plan) {
		var _v0 = A4(
			$author$project$Components$ResourceFilter$Plan$init,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{
						Gy: $elm$core$Maybe$Just(affiliateId)
					});
			},
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Select a Plan'});
			});
		var planResourceFilter = _v0.a;
		var planResourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{
				l9: false,
				rd: affiliateId,
				ahP: $author$project$Api$Provider$Affiliates$Plan$All$id(plan),
				eH: $author$project$Api$Data$NotAsked,
				XE: $author$project$Api$Provider$Affiliates$Plan$All$networkPlans(plan),
				hi: planResourceFilter,
				fp: $elm$core$Set$empty
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$PlanResourceFilterMsg, planResourceFilterCmd));
	});
var $author$project$Api$Provider$Affiliates$Plan$makeDefault = F4(
	function (apiClient, affiliateId, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['default']),
					A2($author$project$Api$Provider$Affiliates$Plan$planPath, affiliateId, id))));
	});
var $author$project$Api$Provider$Affiliates$Plan$One$plan = function (_v0) {
	var record = _v0;
	return record.Jb;
};
var $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$AffiliatePlanCreated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$Closed = {$: 1};
var $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$Created = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$None = {$: 0};
var $author$project$Api$Provider$Affiliates$Plan$create = F4(
	function (apiClient, affiliateId, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'pricing_type',
					$elm$json$Json$Encode$string(fields.akg)),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(fields.Bq)),
					_Utils_Tuple2(
					'percentage',
					$elm$json$Json$Encode$float(fields.ajZ)),
					_Utils_Tuple2(
					'fixed_amount_in_cents',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.ahn)),
					_Utils_Tuple2(
					'default_plan',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$bool, fields.P8))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Affiliates$Plan$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Affiliates$Plan$plansPath(affiliateId))));
	});
var $author$project$Api$Provider$Affiliates$Plan$One$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Components$Affiliates$PercentagePlan$Plan = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Affiliates$PercentagePlan$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 1:
				var plan = field.a;
				return _Utils_update(
					fields,
					{
						Bq: $elm$core$Maybe$Nothing,
						aj4: A2($elm$core$Maybe$map, $author$project$Api$Plan$id, plan)
					});
			case 0:
				var pricingType = field.a;
				return _Utils_update(
					fields,
					{akg: pricingType});
			case 2:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Bq: $author$project$Utils$String$toMaybe(string),
						aj4: $elm$core$Maybe$Nothing
					});
			case 4:
				var _float = field.a;
				return _Utils_update(
					fields,
					{ajZ: _float});
			default:
				var _int = field.a;
				return _Utils_update(
					fields,
					{ahn: _int});
		}
	});
var $author$project$Components$Affiliates$PercentagePlan$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		if (!msg.$) {
			var field = msg.a;
			var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Affiliates$PercentagePlan$formFieldsUpdate, field, model.SD);
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{SD: newForm}),
				$elm$core$Platform$Cmd$none,
				_List_Nil);
		} else {
			var subMsg = msg.a;
			var planResourceFilterResult = A3($author$project$Components$ResourceFilter$Plan$update, apiClient, subMsg, model.hi);
			var modelAfterEvent = function () {
				var _v2 = planResourceFilterResult.agZ;
				if (!_v2.$) {
					if (!_v2.a.$) {
						var plan = _v2.a.a;
						return _Utils_update(
							model,
							{
								SD: A3(
									$author$project$Utils$Form$update,
									$author$project$Components$Affiliates$PercentagePlan$formFieldsUpdate,
									$author$project$Components$Affiliates$PercentagePlan$Plan(
										$elm$core$Maybe$Just(plan)),
									model.SD)
							});
					} else {
						return _Utils_update(
							model,
							{
								SD: A3(
									$author$project$Utils$Form$update,
									$author$project$Components$Affiliates$PercentagePlan$formFieldsUpdate,
									$author$project$Components$Affiliates$PercentagePlan$Plan($elm$core$Maybe$Nothing),
									model.SD)
							});
					}
				} else {
					return model;
				}
			}();
			return _Utils_Tuple3(
				_Utils_update(
					modelAfterEvent,
					{hi: planResourceFilterResult.aiO}),
				A2($elm$core$Platform$Cmd$map, $author$project$Components$Affiliates$PercentagePlan$PlanResourceFilterMsg, planResourceFilterResult.GZ),
				planResourceFilterResult.aR);
		}
	});
var $author$project$Components$Affiliates$PercentagePlan$Exising = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Affiliates$PercentagePlan$New = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Affiliates$PercentagePlan$NameValidation = 1;
var $author$project$Components$Affiliates$PercentagePlan$validateName = function (fields) {
	var _v0 = _Utils_Tuple2(fields.akg, fields.Bq);
	if ((_v0.a === 1) && (_v0.b.$ === 1)) {
		var _v1 = _v0.a;
		var _v2 = _v0.b;
		return _List_fromArray(
			[
				_Utils_Tuple2(1, 'Please enter a name.')
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Affiliates$PercentagePlan$PercentageValidation = 2;
var $author$project$Components$Affiliates$PercentagePlan$validatePercentage = function (fields) {
	var _v0 = _Utils_Tuple2(
		fields.akg,
		A2(
			$author$project$Utils$Validate$isInvalidPercentage,
			{aeU: false, AU: $elm$core$Maybe$Nothing, W9: $elm$core$Maybe$Nothing},
			fields.ajZ));
	if ((_v0.a === 1) && _v0.b) {
		var _v1 = _v0.a;
		return _List_fromArray(
			[
				_Utils_Tuple2(2, 'Please enter a percentage.')
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Affiliates$PercentagePlan$PlanValidation = 0;
var $author$project$Components$Affiliates$PercentagePlan$validatePlan = F2(
	function (affiliatePractice, fields) {
		var _v0 = _Utils_Tuple3(affiliatePractice, fields.akg, fields.aj4);
		if (((!_v0.a.$) && (!_v0.b)) && (_v0.c.$ === 1)) {
			var _v1 = _v0.b;
			var _v2 = _v0.c;
			return _List_fromArray(
				[
					_Utils_Tuple2(0, 'Please pick a plan.')
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Affiliates$PercentagePlan$formFieldsValidator = function (affiliatePractice) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$Affiliates$PercentagePlan$validatePlan(affiliatePractice)),
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Affiliates$PercentagePlan$validateName),
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Affiliates$PercentagePlan$validatePercentage)
			]));
};
var $author$project$Components$Affiliates$PercentagePlan$pricingTypeToString = function (pricingType) {
	if (!pricingType) {
		return 'fixed';
	} else {
		return 'percentage';
	}
};
var $author$project$Components$Affiliates$PercentagePlan$validate = function (_v0) {
	var model = _v0;
	var _v1 = A2(
		$author$project$Utils$Form$validate,
		$author$project$Components$Affiliates$PercentagePlan$formFieldsValidator(model.Le),
		model.SD);
	if (!_v1.$) {
		var _v2 = _v1.a;
		var validatedForm = _v2.a;
		var validFormFields = _v2.b;
		var _v3 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
		var pricingType = _v3.akg;
		var planId = _v3.aj4;
		var name = _v3.Bq;
		var percentage = _v3.ajZ;
		var fixedAmountInCents = _v3.ahn;
		var percentagePlan = function () {
			if (!planId.$) {
				var planId_ = planId.a;
				return $author$project$Components$Affiliates$PercentagePlan$Exising(planId_);
			} else {
				return $author$project$Components$Affiliates$PercentagePlan$New(
					{
						ahn: A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fixedAmountInCents),
						Bq: A2($elm$core$Maybe$withDefault, '', name),
						ajZ: A2(
							$elm$core$Maybe$withDefault,
							0,
							A2($elm$core$Maybe$andThen, $author$project$Percentage$toFloat, percentage)),
						akg: $author$project$Components$Affiliates$PercentagePlan$pricingTypeToString(pricingType)
					});
			}
		}();
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{SD: validatedForm}),
			$elm$core$Maybe$Just(percentagePlan));
	} else {
		var validatedForm = _v1.a;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{SD: validatedForm}),
			$elm$core$Maybe$Nothing);
	}
};
var $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$Closed, aiO: model, aR: _List_Nil};
			case 2:
				var subMsg = msg.a;
				var _v1 = A3($author$project$Components$Affiliates$PercentagePlan$update, apiClient, subMsg, model.hd);
				var percentagePlan = _v1.a;
				var percentagePlanCmd = _v1.b;
				var percentagePlanOutMsgs = _v1.c;
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$PercentagePlanMsg, percentagePlanCmd),
					agZ: $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$None,
					aiO: _Utils_update(
						model,
						{hd: percentagePlan}),
					aR: percentagePlanOutMsgs
				};
			case 1:
				var _v2 = $author$project$Components$Affiliates$PercentagePlan$validate(model.hd);
				var newPercentagePlan = _v2.a;
				var percentagePlanData = _v2.b;
				var _v3 = function () {
					if (!percentagePlanData.$) {
						var percentagePlanData_ = percentagePlanData.a;
						if (percentagePlanData_.$ === 1) {
							return _Utils_Tuple2(model.k9, $elm$core$Platform$Cmd$none);
						} else {
							var percentagePlanFields = percentagePlanData_.a;
							var fields = {
								P8: $elm$core$Maybe$Just(true),
								ahn: A2($elm$core$Maybe$map, $elm$core$Basics$negate, percentagePlanFields.ahn),
								Bq: percentagePlanFields.Bq,
								ajZ: percentagePlanFields.ajZ,
								akg: percentagePlanFields.akg
							};
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								A4($author$project$Api$Provider$Affiliates$Plan$create, apiClient, model.rd, fields, $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$Created));
						}
					} else {
						return _Utils_Tuple2(model.k9, $elm$core$Platform$Cmd$none);
					}
				}();
				var saveRequest = _v3.a;
				var cmd = _v3.b;
				return {
					GZ: cmd,
					agZ: $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$None,
					aiO: _Utils_update(
						model,
						{hd: newPercentagePlan, k9: saveRequest}),
					aR: _List_Nil
				};
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var affiliatePlan = response.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$AffiliatePlanCreated(affiliatePlan),
						aiO: _Utils_update(
							model,
							{k9: $author$project$Api$Data$NotAsked}),
						aR: _List_fromArray(
							[
								A2(
								$author$project$OutMsg$ShowToast,
								3,
								$author$project$Api$Provider$Affiliates$Plan$One$name(affiliatePlan) + ' plan added!')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$None,
						aiO: model,
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
		}
	});
var $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$AffiliatePlanUpdated = 2;
var $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$Closed = 1;
var $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$Linked = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$None = 0;
var $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$Unlinked = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Api$Provider$Affiliates$Plan$link = F5(
	function (apiClient, affiliateId, id, networkPlanId, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'network_plan_id',
					$elm$json$Json$Encode$string(networkPlanId))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Affiliates$Plan$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['link']),
						A2($author$project$Api$Provider$Affiliates$Plan$planPath, affiliateId, id)))));
	});
var $author$project$Api$Provider$Affiliates$Plan$unlink = F5(
	function (apiClient, affiliateId, id, networkPlanId, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'network_plan_id',
					$elm$json$Json$Encode$string(networkPlanId))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Affiliates$Plan$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['unlink']),
						A2($author$project$Api$Provider$Affiliates$Plan$planPath, affiliateId, id)))));
	});
var $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: 1, aiO: model, aR: _List_Nil};
			case 1:
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{l9: true}),
					aR: _List_Nil
				};
			case 2:
				var subMsg = msg.a;
				var planResourceResult = A3($author$project$Components$ResourceFilter$Plan$update, apiClient, subMsg, model.hi);
				var _v1 = function () {
					var _v2 = planResourceResult.agZ;
					if ((!_v2.$) && (!_v2.a.$)) {
						var plan = _v2.a.a;
						return _Utils_Tuple2(
							$author$project$Api$Data$Loading,
							A5(
								$author$project$Api$Provider$Affiliates$Plan$link,
								apiClient,
								model.rd,
								model.ahP,
								$author$project$Api$Plan$id(plan),
								$author$project$Components$Affiliates$Settings$EditNetworkPlanModal$Linked));
					} else {
						return _Utils_Tuple2(model.eH, $elm$core$Platform$Cmd$none);
					}
				}();
				var linkRequest = _v1.a;
				var cmd = _v1.b;
				return {
					GZ: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								cmd,
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$PlanResourceFilterMsg, planResourceResult.GZ)
							])),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{eH: linkRequest, hi: planResourceResult.aiO}),
					aR: planResourceResult.aR
				};
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					var plan = response.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 2,
						aiO: _Utils_update(
							model,
							{
								l9: false,
								eH: response,
								XE: $author$project$Api$Provider$Affiliates$Plan$One$networkPlans(plan)
							}),
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Network plan linked!')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{eH: response}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 4:
				var plan = msg.a;
				var id = $author$project$Api$Provider$Plan$One$id(plan);
				return {
					GZ: A5(
						$author$project$Api$Provider$Affiliates$Plan$unlink,
						apiClient,
						model.rd,
						model.ahP,
						id,
						$author$project$Components$Affiliates$Settings$EditNetworkPlanModal$Unlinked(id)),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							fp: A2($elm$core$Set$insert, id, model.fp)
						}),
					aR: _List_Nil
				};
			default:
				var id = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var plan = response.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 2,
						aiO: _Utils_update(
							model,
							{
								eH: response,
								XE: $author$project$Api$Provider$Affiliates$Plan$One$networkPlans(plan),
								fp: A2($elm$core$Set$remove, id, model.fp)
							}),
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Network plan unlinked!')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{
								eH: response,
								fp: A2($elm$core$Set$remove, id, model.fp)
							}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
		}
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Gn: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ZG: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 2:
				var _v1 = A3($author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$init, model.Gv, model.aa4, model.rd);
				var createNetworkPlanModal = _v1.a;
				var createNetworkPlanModalCmd = _v1.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							iY: $elm$core$Maybe$Just(createNetworkPlanModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Settings$CreateNetworkPlanModalMsg, createNetworkPlanModalCmd),
					_List_Nil);
			case 3:
				var plan = msg.a;
				var _v2 = A4($author$project$Components$Affiliates$Settings$EditNetworkPlanModal$init, model.Gv, model.aa4, model.rd, plan);
				var editNetworkPlanModal = _v2.a;
				var editNetworkPlanModalCmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							jx: $elm$core$Maybe$Just(editNetworkPlanModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Settings$EditNetworkPlanModalMsg, editNetworkPlanModalCmd),
					_List_Nil);
			case 4:
				var id = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aV: A2($elm$core$Set$insert, id, model.aV)
						}),
					A4(
						$author$project$Api$Provider$Affiliates$Plan$delete,
						model.Gv,
						model.rd,
						id,
						$author$project$Pages$Affiliates$AffiliateId_String$Settings$Deleted(id)),
					_List_Nil);
			case 5:
				var id = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ZG: $author$project$Api$Data$Loading,
								aV: A2($elm$core$Set$remove, id, model.aV)
							}),
						$author$project$Pages$Affiliates$AffiliateId_String$Settings$fetchPlans(model),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Affiliate plan deleted')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aV: A2($elm$core$Set$remove, id, model.aV)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 6:
				var id = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aV: A2($elm$core$Set$insert, id, model.aV)
						}),
					A4(
						$author$project$Api$Provider$Affiliates$Plan$makeDefault,
						model.Gv,
						model.rd,
						id,
						$author$project$Pages$Affiliates$AffiliateId_String$Settings$Defaulted(id)),
					_List_Nil);
			case 7:
				var id = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ZG: $author$project$Api$Data$Loading,
								aV: A2($elm$core$Set$remove, id, model.aV)
							}),
						$author$project$Pages$Affiliates$AffiliateId_String$Settings$fetchPlans(model),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Affiliate plan is default')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aV: A2($elm$core$Set$remove, id, model.aV)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 8:
				var subMsg = msg.a;
				var _v5 = model.iY;
				if (!_v5.$) {
					var createNetworkPlanModal = _v5.a;
					var createNetworkPlanModalResult = A3($author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$update, model.Gv, subMsg, createNetworkPlanModal);
					var _v6 = function () {
						var _v7 = createNetworkPlanModalResult.agZ;
						switch (_v7.$) {
							case 0:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(createNetworkPlanModalResult.aiO),
									model.ZG,
									$elm$core$Maybe$Nothing);
							case 1:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.ZG, $elm$core$Maybe$Nothing);
							default:
								var plan = _v7.a;
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Api$Data$Loading,
									$elm$core$Maybe$Just(plan));
						}
					}();
					var createNetworkPlanModal_ = _v6.a;
					var plans = _v6.b;
					var affiliatePlan = _v6.c;
					var _v8 = function () {
						if (!affiliatePlan.$) {
							var affiliatePlan_ = affiliatePlan.a;
							if ($author$project$Api$Provider$Plan$One$planType(
								$author$project$Api$Provider$Affiliates$Plan$One$plan(affiliatePlan_)) !== 4) {
								var planId = $author$project$Api$Provider$Plan$One$id(
									$author$project$Api$Provider$Affiliates$Plan$One$plan(affiliatePlan_));
								var affiliatePracticeId = A2(
									$elm$core$Maybe$withDefault,
									'',
									A2(
										$elm$core$Maybe$map,
										A2($elm$core$Basics$composeR, $author$project$Api$Provider$Affiliate$One$affiliatePractice, $author$project$Api$Provider$Practice$One$organizationId),
										$author$project$Api$Data$toMaybe(model.Gn)));
								return _Utils_Tuple2(
									$elm$core$Platform$Cmd$none,
									_List_fromArray(
										[
											A3(
											$author$project$OutMsg$SwitchToOrganization,
											affiliatePracticeId,
											$elm$core$Maybe$Nothing,
											$author$project$OutMsg$GoToRouteAction(
												$author$project$Spa$Generated$Route$Admin__CompanyPlans__Id_String(
													{ahP: planId})))
										]));
							} else {
								return _Utils_Tuple2(
									$author$project$Pages$Affiliates$AffiliateId_String$Settings$fetchPlans(model),
									_List_Nil);
							}
						} else {
							return _Utils_Tuple2($elm$core$Platform$Cmd$none, _List_Nil);
						}
					}();
					var cmd = _v8.a;
					var outMsgs = _v8.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{iY: createNetworkPlanModal_, ZG: plans}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									cmd,
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Settings$CreateNetworkPlanModalMsg, createNetworkPlanModalResult.GZ)
								])),
						_Utils_ap(outMsgs, createNetworkPlanModalResult.aR));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var subMsg = msg.a;
				var _v10 = model.jx;
				if (!_v10.$) {
					var editNetworkPlanModal = _v10.a;
					var editNetworkPlanModalResult = A3($author$project$Components$Affiliates$Settings$EditNetworkPlanModal$update, model.Gv, subMsg, editNetworkPlanModal);
					var _v11 = function () {
						var _v12 = editNetworkPlanModalResult.agZ;
						switch (_v12) {
							case 0:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(editNetworkPlanModalResult.aiO),
									model.ZG,
									$elm$core$Platform$Cmd$none);
							case 1:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.ZG, $elm$core$Platform$Cmd$none);
							default:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(editNetworkPlanModalResult.aiO),
									$author$project$Api$Data$Loading,
									$author$project$Pages$Affiliates$AffiliateId_String$Settings$fetchPlans(model));
						}
					}();
					var editNetworkPlanModal_ = _v11.a;
					var plans = _v11.b;
					var cmd = _v11.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jx: editNetworkPlanModal_, ZG: plans}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									cmd,
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Settings$EditNetworkPlanModalMsg, editNetworkPlanModalResult.GZ)
								])),
						editNetworkPlanModalResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 11:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dY: true}),
					A3($author$project$Api$Provider$Affiliate$archive, model.Gv, model.rd, $author$project$Pages$Affiliates$AffiliateId_String$Settings$AffiliationArchived),
					_List_Nil);
			case 10:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Gn: response, dY: false}),
						A2(
							$author$project$Utils$Route$navigate,
							$elm$core$Dict$empty,
							$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Top(
								{rd: model.rd})),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Affiliation successfully archived')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dY: false}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 12:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dY: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dY: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
		}
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$AddPlan = {$: 2};
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$ArchiveAffiliationButtonClicked = {$: 11};
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$ShowArchiveWarningModal = {$: 12};
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$columns = function (isHintAdmin) {
	return A2(
		$elm$core$List$cons,
		A3($author$project$Api$Column$init, '', false, 'Name'),
		A2(
			$elm$core$List$cons,
			A3($author$project$Api$Column$init, '', false, 'Billing Cycle'),
			A2(
				$elm$core$List$cons,
				A3($author$project$Api$Column$init, '', false, 'Billing Date'),
				A2(
					$elm$core$List$cons,
					A3($author$project$Api$Column$init, '', false, 'Affiliate Rate'),
					A2(
						$elm$core$List$cons,
						A3($author$project$Api$Column$init, '', false, 'Network Fee Plans'),
						isHintAdmin ? _List_fromArray(
							[
								A3($author$project$Api$Column$init, '', false, '')
							]) : _List_Nil)))));
};
var $author$project$Api$Provider$Affiliate$Shared$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Api$Provider$Affiliate$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Affiliate$Shared$status(shared);
};
var $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$Save = {$: 1};
var $author$project$Components$Affiliates$PercentagePlan$FixedAmountInCents = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Affiliates$PercentagePlan$FixedAmountInCentsValidation = 3;
var $author$project$Components$Affiliates$PercentagePlan$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Affiliates$PercentagePlan$Name = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Affiliates$PercentagePlan$Percentage = 1;
var $author$project$Components$Affiliates$PercentagePlan$PercentageField = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Platform$Practice$Min$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Platform$Practice$One$name = function (_v0) {
	var min = _v0;
	return $author$project$Api$Platform$Practice$Min$name(min);
};
var $author$project$Components$Affiliates$PercentagePlan$PricingType = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Affiliates$PercentagePlan$viewPricingTypeButton = F3(
	function (currentPricingType, pricingType, label) {
		return A3(
			$author$project$Ui$Button$view,
			{mm: 'Select ' + label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(currentPricingType, pricingType)),
					$author$project$Ui$Button$onClick(
					$author$project$Components$Affiliates$PercentagePlan$FormUpdated(
						$author$project$Components$Affiliates$PercentagePlan$PricingType(pricingType)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Components$Affiliates$PercentagePlan$view = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.SD);
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				function () {
				var _v1 = model.Le;
				if (!_v1.$) {
					var affiliatePractice = _v1.a;
					return A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Account Name'),
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Static$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Api$Platform$Practice$One$name(affiliatePractice))
											]))
									]))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8),
						$author$project$Ui$Form$Group$label('Payment Type')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Button$group(
						_List_fromArray(
							[
								A3($author$project$Components$Affiliates$PercentagePlan$viewPricingTypeButton, fields.akg, 0, '$'),
								A3($author$project$Components$Affiliates$PercentagePlan$viewPricingTypeButton, fields.akg, 1, '%')
							]))
					])),
				function () {
				var _v2 = _Utils_Tuple2(model.Le, fields.akg);
				if ((!_v2.a.$) && (!_v2.b)) {
					var _v3 = _v2.b;
					return A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8),
								$author$project$Ui$Form$Group$label('Affiliate Fee Plan'),
								$author$project$Ui$Form$Group$required(true)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$Affiliates$PercentagePlan$PlanResourceFilterMsg,
								A2(
									$author$project$Components$ResourceFilter$Plan$view,
									_List_fromArray(
										[
											$author$project$Components$ResourceFilter$invalid(
											A2($author$project$Utils$Form$hasValidationErrors, 0, model.SD)),
											$author$project$Components$ResourceFilter$errors(
											A2($author$project$Utils$Form$validationErrors, 0, model.SD))
										]),
									model.hi))
							]));
				} else {
					return A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(6),
								$author$project$Ui$Form$Group$label('Affiliate Fee Plan Name'),
								$author$project$Ui$Form$Group$required(true)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$value(
										A2($elm$core$Maybe$withDefault, '', fields.Bq)),
										$author$project$Ui$Form$Input$onInput(
										A2($elm$core$Basics$composeL, $author$project$Components$Affiliates$PercentagePlan$FormUpdated, $author$project$Components$Affiliates$PercentagePlan$Name)),
										$author$project$Ui$Form$Input$placeholder('Affiliate Membership'),
										$author$project$Ui$Form$Input$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 1, model.SD)),
										$author$project$Ui$Form$Input$errors(
										A2($author$project$Utils$Form$validationErrors, 1, model.SD))
									]))
							]));
				}
			}(),
				function () {
				var _v4 = fields.akg;
				if (_v4 === 1) {
					return A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8),
								$author$project$Ui$Form$Group$label('Amount paid to affiliate'),
								$author$project$Ui$Form$Group$required(true)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$PercentageInput$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$PercentageInput$value(fields.ajZ),
										$author$project$Ui$Form$PercentageInput$onInput(
										A2($elm$core$Basics$composeL, $author$project$Components$Affiliates$PercentagePlan$FormUpdated, $author$project$Components$Affiliates$PercentagePlan$PercentageField)),
										$author$project$Ui$Form$PercentageInput$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 2, model.SD)),
										$author$project$Ui$Form$PercentageInput$placeholder('10')
									])),
								$author$project$Utils$FormErrors$view(
								A2($author$project$Utils$Form$validationErrors, 2, model.SD))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v5 = fields.akg;
				if (_v5 === 1) {
					return A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8),
								$author$project$Ui$Form$Group$label('Amount subtracted per member'),
								$author$project$Ui$Form$Group$required(true)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$CurrencyInput$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$CurrencyInput$value(fields.ahn),
										$author$project$Ui$Form$CurrencyInput$onInput(
										A2($elm$core$Basics$composeL, $author$project$Components$Affiliates$PercentagePlan$FormUpdated, $author$project$Components$Affiliates$PercentagePlan$FixedAmountInCents)),
										$author$project$Ui$Form$CurrencyInput$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 3, model.SD)),
										$author$project$Ui$Form$CurrencyInput$errors(
										A2($author$project$Utils$Form$validationErrors, 3, model.SD)),
										$author$project$Ui$Form$CurrencyInput$placeholder('10.00')
									]))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]));
};
var $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$view = function (model) {
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$CloseModal,
		_List_fromArray(
			[$author$project$Ui$Modal$lg]),
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('New Affiliate Fee Plan')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$noValidate(true),
								$author$project$Ui$Form$autocomplete(true),
								$author$project$Ui$Form$onSubmit($author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$Save)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$PercentagePlanMsg,
								$author$project$Components$Affiliates$PercentagePlan$view(model.hd))
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanSm(6)
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Cancel and close modal'},
										_List_fromArray(
											[
												$author$project$Ui$Button$fullWidth(true),
												$author$project$Ui$Button$onClick($author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$CloseModal)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cancel')
											]))
									])),
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanSm(6)
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Confirm plan'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$loading(
												_Utils_eq(model.k9, $author$project$Api$Data$Loading)),
												$author$project$Ui$Button$onClick($author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$Save),
												$author$project$Ui$Button$fullWidth(true)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Confirm')
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$AddNew = {$: 1};
var $author$project$Components$ResourceFilter$Loading = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$ResourceFilter$loading = $author$project$Components$ResourceFilter$Loading;
var $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$Unlink = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$viewNetworkPlan = F2(
	function (unlinkingPlans, networkPlan) {
		var loading = A2(
			$elm$core$Set$member,
			$author$project$Api$Provider$Plan$One$id(networkPlan),
			unlinkingPlans);
		return A2(
			$author$project$Ui$Form$Static$view,
			_List_fromArray(
				[$author$project$Ui$Form$Static$flex, $author$project$Ui$Form$Static$spaceBetween, $author$project$Ui$Form$Static$itemsCenter]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Api$Provider$Plan$One$name(networkPlan)),
					$author$project$Utils$Html$noBreakSpace,
					A3(
					$author$project$Ui$Button$view,
					{mm: 'Delete plan'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$sm,
							$author$project$Ui$Button$onClick(
							$author$project$Components$Affiliates$Settings$EditNetworkPlanModal$Unlink(networkPlan)),
							$author$project$Ui$Button$loading(loading),
							$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Delete')
						])),
					$author$project$Ui$HorizontalRule$view(_List_Nil)
				]));
	});
var $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$view = function (model) {
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Affiliates$Settings$EditNetworkPlanModal$CloseModal,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Edit network fee plans')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$noValidate(true),
								$author$project$Ui$Form$autocomplete(true)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Network fee plans'),
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(7)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_Nil,
										A2(
											$elm$core$List$map,
											$author$project$Components$Affiliates$Settings$EditNetworkPlanModal$viewNetworkPlan(model.fp),
											model.XE)),
										model.l9 ? A2(
										$author$project$Ui$Form$Static$view,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Components$Affiliates$Settings$EditNetworkPlanModal$PlanResourceFilterMsg,
												A2(
													$author$project$Components$ResourceFilter$Plan$view,
													_List_fromArray(
														[
															$author$project$Components$ResourceFilter$loading(
															_Utils_eq(model.eH, $author$project$Api$Data$Loading))
														]),
													model.hi))
											])) : $author$project$Utils$Html$empty,
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Add network plan'},
										_List_fromArray(
											[
												$author$project$Ui$Button$onClick($author$project$Components$Affiliates$Settings$EditNetworkPlanModal$AddNew),
												$author$project$Ui$Button$disabled(model.l9),
												$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Add network plan')
											]))
									]))
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Affiliates$Settings$EditNetworkPlanModal$CloseModal)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Close')
							]))
					]))
			]));
};
var $author$project$Api$Plan$ProviderOne = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Affiliates$Plan$One$billingDate = function (_v0) {
	var record = _v0;
	return record.MG;
};
var $author$project$Api$Provider$Affiliates$Plan$All$billingDate = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Affiliates$Plan$One$billingDate(one);
};
var $author$project$Api$Provider$Affiliates$Plan$All$name = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Affiliates$Plan$One$name(one);
};
var $author$project$Api$Provider$Affiliates$Plan$All$plan = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Affiliates$Plan$One$plan(one);
};
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$viewNetworkPlan = function (networkPlan) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Api$Provider$Plan$One$name(networkPlan))
			]));
};
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$Delete = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$EditPlan = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$MakeDefault = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$Affiliates$Plan$One$default = function (_v0) {
	var record = _v0;
	return record.PW;
};
var $author$project$Api$Provider$Affiliates$Plan$All$default = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Affiliates$Plan$One$default(one);
};
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$viewPlanButtons = F3(
	function (isHintAdmin, savingPlans, plan) {
		if (isHintAdmin) {
			var id = $author$project$Api$Provider$Affiliates$Plan$All$id(plan);
			var loading = A2($elm$core$Set$member, id, savingPlans);
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$mb2]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$HinterOnly$button,
									{mm: 'Edit network fee plans'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$loading(loading),
											$author$project$Ui$Button$disabled(
											$author$project$Api$Provider$Affiliates$Plan$All$default(plan)),
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Affiliates$AffiliateId_String$Settings$EditPlan(plan)),
											$author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit network fee plans')
										]))
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$mb2]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$HinterOnly$button,
									{mm: 'Delete network fee plans'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$loading(loading),
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Affiliates$AffiliateId_String$Settings$Delete(id)),
											$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Delete affiliate fee plan')
										]))
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$itemsCenter]),
							_List_fromArray(
								[
									$author$project$Api$Provider$Affiliates$Plan$All$default(plan) ? A2(
									$author$project$Ui$Badge$view,
									_List_fromArray(
										[$author$project$Ui$Badge$primary]),
									_List_fromArray(
										[
											$elm$html$Html$text('Default')
										])) : $author$project$Utils$Html$empty,
									$author$project$Utils$Html$noBreakSpace,
									function () {
									if ($author$project$Api$Provider$Affiliates$Plan$All$default(plan)) {
										return $author$project$Utils$Html$empty;
									} else {
										var networkPlans = $author$project$Api$Provider$Affiliates$Plan$All$networkPlans(plan);
										return $elm$core$List$isEmpty(networkPlans) ? A3(
											$author$project$Ui$HinterOnly$button,
											{mm: 'Make default'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$loading(loading),
													$author$project$Ui$Button$onClick(
													$author$project$Pages$Affiliates$AffiliateId_String$Settings$MakeDefault(id))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Make Default')
												])) : $author$project$Utils$Html$empty;
									}
								}()
								]))
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$viewPlan = F3(
	function (isHintAdmin, savingPlans, plan) {
		var networkPlans = $author$project$Api$Provider$Affiliates$Plan$All$networkPlans(plan);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$Affiliates$Plan$All$name(plan))
						])),
				A2(
					$elm$core$List$cons,
					A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$Affiliates$Plan$All$billingDate(plan)),
									$elm$html$Html$text(' day')
								])),
						A2(
							$elm$core$List$cons,
							A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										A3(
										$author$project$Components$Plan$Summary$Pricing$view,
										$author$project$Api$Plan$ProviderOne(
											$author$project$Api$Provider$Affiliates$Plan$All$plan(plan)),
										$elm$core$Maybe$Nothing,
										$elm$core$Maybe$Nothing)
									])),
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$Ui$Table$cell,
									_List_Nil,
									$elm$core$List$isEmpty(networkPlans) ? _List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$textMuted]),
											_List_fromArray(
												[
													$elm$html$Html$text('None')
												]))
										]) : A2($elm$core$List$map, $author$project$Pages$Affiliates$AffiliateId_String$Settings$viewNetworkPlan, networkPlans)),
								A3($author$project$Pages$Affiliates$AffiliateId_String$Settings$viewPlanButtons, isHintAdmin, savingPlans, plan)))))));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$viewBody = F2(
	function (model, affiliate) {
		var _v0 = function () {
			var _v1 = model.ZG;
			if (_v1.$ === 3) {
				var plans_ = _v1.a;
				return _Utils_Tuple2(false, plans_);
			} else {
				return _Utils_Tuple2(true, _List_Nil);
			}
		}();
		var loading = _v0.a;
		var plans = _v0.b;
		return _List_fromArray(
			[
				function () {
				var _v2 = model.iY;
				if (!_v2.$) {
					var createNetworkPlanModal = _v2.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$Affiliates$AffiliateId_String$Settings$CreateNetworkPlanModalMsg,
						$author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$view(createNetworkPlanModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v3 = model.jx;
				if (!_v3.$) {
					var editNetworkPlanModal = _v3.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$Affiliates$AffiliateId_String$Settings$EditNetworkPlanModalMsg,
						$author$project$Components$Affiliates$Settings$EditNetworkPlanModal$view(editNetworkPlanModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$row,
								_List_fromArray(
									[$author$project$Ui$Grid$rowItemsCenter]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$spanSm(8)
											]),
										_List_fromArray(
											[
												$author$project$Ui$Panel$title(
												_List_fromArray(
													[
														$elm$html$Html$text('Affiliate Fee Plans')
													]))
											])),
										function () {
										if (model.Ij) {
											var isEnded = $author$project$Api$Provider$Affiliate$One$status(affiliate) === 'ended';
											return A2(
												$author$project$Ui$Grid$column,
												_List_fromArray(
													[
														$author$project$Ui$Grid$spanSm(4),
														$author$project$Ui$Grid$justifyRight
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Element$view,
														_List_fromArray(
															[$author$project$Ui$Element$gap2]),
														_List_fromArray(
															[
																A3(
																$author$project$Ui$Button$view,
																{mm: 'Archive affiliation'},
																_List_fromArray(
																	[
																		$author$project$Ui$Button$danger,
																		$author$project$Ui$Button$disabled(isEnded),
																		$author$project$Ui$Button$onClick($author$project$Pages$Affiliates$AffiliateId_String$Settings$ShowArchiveWarningModal),
																		$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Archive Affiliation')
																	])),
																A3(
																$author$project$Ui$Button$view,
																{mm: 'Add plan'},
																_List_fromArray(
																	[
																		$author$project$Ui$Button$onClick($author$project$Pages$Affiliates$AffiliateId_String$Settings$AddPlan),
																		$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Add Plan')
																	]))
															]))
													]));
										} else {
											return $author$project$Ui$Grid$none;
										}
									}()
									]))
							])),
						A4(
						$author$project$Ui$Panel$table,
						_List_fromArray(
							[
								$author$project$Ui$Table$loading(loading),
								$author$project$Ui$Table$zeroState(
								_List_fromArray(
									[
										$elm$html$Html$text('This affiliate does not have any plans.')
									]))
							]),
						A2(
							$elm$core$List$map,
							$author$project$Api$Column$view($author$project$Api$Column$NonSortable),
							$author$project$Pages$Affiliates$AffiliateId_String$Settings$columns(model.Ij)),
						A2(
							$elm$core$List$map,
							A2($author$project$Pages$Affiliates$AffiliateId_String$Settings$viewPlan, model.Ij, model.aV),
							plans),
						_List_Nil)
					])),
				model.dY ? A3(
				$author$project$Ui$Modal$view,
				$author$project$Pages$Affiliates$AffiliateId_String$Settings$CloseArchiveWarningModal,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Modal$header(
						_List_fromArray(
							[
								$author$project$Ui$Modal$title('Archive affiliation')
							])),
						$author$project$Ui$Modal$body(
						_List_fromArray(
							[
								$elm$html$Html$text('Are you sure you want to archive the affiliation?')
							])),
						$author$project$Ui$Modal$footer(
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Close warning modal'},
								_List_fromArray(
									[
										$author$project$Ui$Button$onClick($author$project$Pages$Affiliates$AffiliateId_String$Settings$CloseArchiveWarningModal)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Close')
									])),
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Archive affiliation'},
								_List_fromArray(
									[
										$author$project$Ui$Button$primary,
										$author$project$Ui$Button$onClick($author$project$Pages$Affiliates$AffiliateId_String$Settings$ArchiveAffiliationButtonClicked)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Archive')
									]))
							]))
					])) : $author$project$Utils$Html$empty
			]);
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$view = function (model) {
	return {
		fO: function () {
			var _v0 = model.Gn;
			if (_v0.$ === 3) {
				var affiliate = _v0.a;
				return A2($author$project$Pages$Affiliates$AffiliateId_String$Settings$viewBody, model, affiliate);
			} else {
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$textCenter]),
						_List_fromArray(
							[
								$author$project$Ui$Spinner$view(_List_Nil)
							]))
					]);
			}
		}(),
		ac9: 'Affiliates | Fee Plans'
	};
};
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Affiliates$AffiliateId_String$Settings$init, aiq: $author$project$Pages$Affiliates$AffiliateId_String$Settings$load, k8: $author$project$Pages$Affiliates$AffiliateId_String$Settings$save, alO: $author$project$Pages$Affiliates$AffiliateId_String$Settings$subscriptions, adT: $author$project$Pages$Affiliates$AffiliateId_String$Settings$update, amo: $author$project$Pages$Affiliates$AffiliateId_String$Settings$view});
var $author$project$Pages$Affiliates$AffiliateId_String$Users$GotTeamMembers = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$PracticeUser$Affiliate$PracticeUser = $elm$core$Basics$identity;
var $author$project$Api$Provider$PracticeUser$Affiliate$Record = F7(
	function (id, email, role, notificationsEnabled, invitationPending, invitationUrl, user) {
		return {Rj: email, ahP: id, Ui: invitationPending, Uj: invitationUrl, X$: notificationsEnabled, ak3: role, ad0: user};
	});
var $author$project$Api$Provider$PracticeUser$Affiliate$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'user',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$User$One$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'invitation_url',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'invitation_pending',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'notifications_enabled',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'role',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'email',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticeUser$Affiliate$Record))))))));
var $author$project$Api$Provider$PracticeUser$Affiliate$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PracticeUser$Affiliate$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Affiliates$TeamMember$teamMembersPath = function (affiliateId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['team_members']),
		$author$project$Api$Provider$Affiliate$affiliatePath(affiliateId));
};
var $author$project$Api$Provider$Affiliates$TeamMember$list = F3(
	function (apiClient, affiliateId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$PracticeUser$Affiliate$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Affiliates$TeamMember$teamMembersPath(affiliateId)));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Users$init = F4(
	function (_v0, _v1, _v2, _v3) {
		var apiClient = _v2.Gv;
		var params = _v3.YL;
		return _Utils_Tuple2(
			{rd: params.rd, Gv: apiClient, fm: $author$project$Api$Data$Loading},
			A3($author$project$Api$Provider$Affiliates$TeamMember$list, apiClient, params.rd, $author$project$Pages$Affiliates$AffiliateId_String$Users$GotTeamMembers));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Users$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Users$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Users$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Affiliates$AffiliateId_String$Users$GotInvitation = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Api$Provider$PracticeUser$Affiliate$email = function (_v0) {
	var record = _v0;
	return record.Rj;
};
var $author$project$Api$Provider$PracticeUser$Affiliate$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Affiliate$invite = F4(
	function (apiClient, affiliateId, teamMemberId, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'team_member_id',
					$elm$json$Json$Encode$string(teamMemberId))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['invite']),
						$author$project$Api$Provider$Affiliate$affiliatePath(affiliateId)))));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Users$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{fm: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var url = msg.a;
				return _Utils_Tuple3(
					model,
					$author$project$Ports$Clipboard$copy(url),
					_List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 3, 'Copied invite link to clipboard')
						]));
			case 2:
				var teamMember = msg.a;
				return _Utils_Tuple3(
					model,
					A4(
						$author$project$Api$Provider$Affiliate$invite,
						model.Gv,
						model.rd,
						$author$project$Api$Provider$PracticeUser$Affiliate$id(teamMember),
						$author$project$Pages$Affiliates$AffiliateId_String$Users$GotInvitation(
							$author$project$Api$Provider$PracticeUser$Affiliate$email(teamMember))),
					_List_Nil);
			default:
				var email = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{fm: $author$project$Api$Data$Loading}),
						A3($author$project$Api$Provider$Affiliates$TeamMember$list, model.Gv, model.rd, $author$project$Pages$Affiliates$AffiliateId_String$Users$GotTeamMembers),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'A new invitation is being sent to ' + email)
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Users$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'name', false, 'Name'),
		A3($author$project$Api$Column$init, 'email', false, 'Email'),
		A3($author$project$Api$Column$init, 'role', false, 'role'),
		A3($author$project$Api$Column$init, 'notifications', false, 'Notifications')
	]);
var $author$project$Pages$Affiliates$AffiliateId_String$Users$ReInviteTeamMember = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$PracticeUser$Affiliate$invitationPending = function (_v0) {
	var record = _v0;
	return record.Ui;
};
var $author$project$Api$Provider$PracticeUser$Affiliate$notificationsEnabled = function (_v0) {
	var record = _v0;
	return record.X$;
};
var $author$project$Api$Provider$PracticeUser$Affiliate$role = function (_v0) {
	var record = _v0;
	return record.ak3;
};
var $author$project$Api$Provider$PracticeUser$Affiliate$user = function (_v0) {
	var record = _v0;
	return record.ad0;
};
var $author$project$Pages$Affiliates$AffiliateId_String$Users$CopyInviteLink = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$PracticeUser$Affiliate$invitationUrl = function (_v0) {
	var record = _v0;
	return record.Uj;
};
var $author$project$Pages$Affiliates$AffiliateId_String$Users$viewCopyInviteLink = function (teamMember) {
	var _v0 = $author$project$Api$Provider$PracticeUser$Affiliate$invitationUrl(teamMember);
	if (!_v0.$) {
		var url = _v0.a;
		return A3(
			$author$project$Ui$Button$view,
			{mm: 'Copy invite link'},
			_List_fromArray(
				[
					$author$project$Ui$Button$link,
					$author$project$Ui$Button$onClick(
					$author$project$Pages$Affiliates$AffiliateId_String$Users$CopyInviteLink(url)),
					$author$project$Ui$Button$sm,
					$author$project$Ui$Button$icon($author$project$Ui$Icon$copy)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Copy Invite Link')
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Pages$Affiliates$AffiliateId_String$Users$viewTeamMember = function (teamMember) {
	var notificationsStatus = $author$project$Api$Provider$PracticeUser$Affiliate$notificationsEnabled(teamMember) ? 'enabled' : 'disabled';
	return A2(
		$author$project$Ui$Table$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_fromArray(
					[
						$author$project$Ui$Table$minWidth('11em')
					]),
				function () {
					var _v0 = $author$project$Api$Provider$PracticeUser$Affiliate$user(teamMember);
					if (!_v0.$) {
						var user = _v0.a;
						return _List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Api$Provider$User$One$name(user))
									]))
							]);
					} else {
						return $author$project$Api$Provider$PracticeUser$Affiliate$invitationPending(teamMember) ? _List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$em,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Invitation Pending ')
									])),
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Resend invitation email'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$onClick(
												$author$project$Pages$Affiliates$AffiliateId_String$Users$ReInviteTeamMember(teamMember)),
												$author$project$Ui$Button$icon($author$project$Ui$Icon$repeat)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Resend')
											])),
										$author$project$Pages$Affiliates$AffiliateId_String$Users$viewCopyInviteLink(teamMember)
									]))
							]) : _List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$em,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Not Invited ')
									])),
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Send invitation email'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$onClick(
												$author$project$Pages$Affiliates$AffiliateId_String$Users$ReInviteTeamMember(teamMember)),
												$author$project$Ui$Button$icon($author$project$Ui$Icon$send)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Invite')
											]))
									]))
							]);
					}
				}()),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Provider$PracticeUser$Affiliate$email(teamMember))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Formatters$String$titleize(
							$author$project$Formatters$String$humanize(
								$author$project$Api$Provider$PracticeUser$Affiliate$role(teamMember))))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$Ui$Badge$fromString, _List_Nil, notificationsStatus)
					]))
			]));
};
var $author$project$Pages$Affiliates$AffiliateId_String$Users$view = function (model) {
	var _v0 = function () {
		var _v1 = model.fm;
		if (_v1.$ === 3) {
			var teamMembers_ = _v1.a;
			return _Utils_Tuple2(false, teamMembers_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var teamMembers = _v0.b;
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Users')
									]))
							])),
						A4(
						$author$project$Ui$Panel$table,
						_List_fromArray(
							[
								$author$project$Ui$Table$loading(loading),
								$author$project$Ui$Table$zeroState(
								_List_fromArray(
									[
										$elm$html$Html$text('This affiliate does not have any users.')
									]))
							]),
						A2(
							$elm$core$List$map,
							$author$project$Api$Column$view($author$project$Api$Column$NonSortable),
							$author$project$Pages$Affiliates$AffiliateId_String$Users$columns),
						A2($elm$core$List$map, $author$project$Pages$Affiliates$AffiliateId_String$Users$viewTeamMember, teamMembers),
						_List_Nil)
					]))
			]),
		ac9: 'Affiliates | Users'
	};
};
var $author$project$Pages$Affiliates$AffiliateId_String$Users$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Affiliates$AffiliateId_String$Users$init, aiq: $author$project$Pages$Affiliates$AffiliateId_String$Users$load, k8: $author$project$Pages$Affiliates$AffiliateId_String$Users$save, alO: $author$project$Pages$Affiliates$AffiliateId_String$Users$subscriptions, adT: $author$project$Pages$Affiliates$AffiliateId_String$Users$update, amo: $author$project$Pages$Affiliates$AffiliateId_String$Users$view});
var $author$project$Pages$Affiliates$Create$GotAffiliatePractice = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Platform$Practice$One$Practice = $elm$core$Basics$identity;
var $author$project$Api$Platform$Practice$Min$Practice = $elm$core$Basics$identity;
var $author$project$Api$Platform$Practice$Min$Record = F5(
	function (id, name, isDeactivated, flaggedNotesCount, requiresMfa) {
		return {Sz: flaggedNotesCount, ahP: id, UL: isDeactivated, Bq: name, $H: requiresMfa};
	});
var $author$project$Api$Platform$Practice$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'requires_mfa',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'flagged_notes_count',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'is_deactivated',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Platform$Practice$Min$Record))))));
var $author$project$Api$Platform$Practice$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$Practice$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Platform$Practice$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$Practice$Min$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Platform$User$Practice$practicesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['practices']),
	$author$project$Api$Platform$User$userPath);
var $author$project$Api$Platform$User$Practice$practicePath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		$author$project$Api$Platform$User$Practice$practicesPath);
};
var $author$project$Api$Platform$User$Practice$retrieve = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Platform$Practice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Platform$User$Practice$practicePath(id)));
	});
var $author$project$Pages$Affiliates$Create$init = F4(
	function (session, practice, _v0, _v1) {
		var apiClient = _v0.Gv;
		var query = _v1.DE;
		var cmd = function () {
			var _v2 = A2($elm$core$Dict$get, 'affiliatePracticeId', query);
			if (!_v2.$) {
				var affiliatePracticeId = _v2.a;
				return A3($author$project$Api$Platform$User$Practice$retrieve, apiClient, affiliatePracticeId, $author$project$Pages$Affiliates$Create$GotAffiliatePractice);
			} else {
				return A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Affiliates__New);
			}
		}();
		return _Utils_Tuple2(
			{
				Le: $author$project$Api$Data$Loading,
				aeM: A2(
					$elm$core$Maybe$withDefault,
					'',
					A2($elm$core$Dict$get, 'affiliatePracticeId', query)),
				Gv: apiClient,
				hd: $elm$core$Maybe$Nothing,
				ZV: practice,
				k9: $author$project$Api$Data$NotAsked,
				aa4: session
			},
			cmd);
	});
var $author$project$Pages$Affiliates$Create$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Affiliates$Create$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Affiliates$Create$PercentagePlanMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Affiliates$Create$subscriptions = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Platform$Sub$none,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Components$Affiliates$PercentagePlan$subscriptions,
				$elm$core$Platform$Sub$map($author$project$Pages$Affiliates$Create$PercentagePlanMsg)),
			model.hd));
};
var $author$project$Pages$Affiliates$Create$AffiliateCreated = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Affiliates$Create$AffiliatePlanCreated = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Api$Provider$Affiliate$create = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'affiliation',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'affiliate_practice_id',
								$elm$json$Json$Encode$string(fields.aeM)),
								_Utils_Tuple2(
								'plan_id',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.aj4))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Affiliate$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Affiliate$affiliatesPath)));
	});
var $author$project$Pages$Affiliates$Create$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				switch (response.$) {
					case 3:
						var affiliatePractice = response.a;
						var _v2 = A3(
							$author$project$Components$Affiliates$PercentagePlan$init,
							model.Gv,
							model.aa4,
							$elm$core$Maybe$Just(affiliatePractice));
						var percentagePlan = _v2.a;
						var percentagePlanCmd = _v2.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									Le: response,
									hd: $elm$core$Maybe$Just(percentagePlan)
								}),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$Create$PercentagePlanMsg, percentagePlanCmd),
							_List_Nil);
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{Le: response}),
							A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Affiliates__New),
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{Le: response}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
				}
			case 1:
				var subMsg = msg.a;
				var _v3 = model.hd;
				if (!_v3.$) {
					var percentagePlan = _v3.a;
					var _v4 = A3($author$project$Components$Affiliates$PercentagePlan$update, model.Gv, subMsg, percentagePlan);
					var percentagePlan_ = _v4.a;
					var percentagePlanCmd = _v4.b;
					var percentagePlanOutMsgs = _v4.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								hd: $elm$core$Maybe$Just(percentagePlan_)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$Create$PercentagePlanMsg, percentagePlanCmd),
						percentagePlanOutMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				var _v5 = model.hd;
				if (!_v5.$) {
					var percentagePlan = _v5.a;
					var _v6 = $author$project$Components$Affiliates$PercentagePlan$validate(percentagePlan);
					var newPercentagePlan = _v6.a;
					var percentagePlanData = _v6.b;
					var _v7 = function () {
						if (!percentagePlanData.$) {
							var percentagePlanData_ = percentagePlanData.a;
							var planId = function () {
								if (percentagePlanData_.$ === 1) {
									var planId_ = percentagePlanData_.a;
									return $elm$core$Maybe$Just(planId_);
								} else {
									return $elm$core$Maybe$Nothing;
								}
							}();
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								A3(
									$author$project$Api$Provider$Affiliate$create,
									model.Gv,
									{aeM: model.aeM, aj4: planId},
									$author$project$Pages$Affiliates$Create$AffiliateCreated(percentagePlanData_)));
						} else {
							return _Utils_Tuple2(model.k9, $elm$core$Platform$Cmd$none);
						}
					}();
					var saveRequest = _v7.a;
					var cmd = _v7.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								hd: $elm$core$Maybe$Just(newPercentagePlan),
								k9: saveRequest
							}),
						cmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var percentagePlan = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var affiliate = response.a;
					var _v11 = function () {
						if (percentagePlan.$ === 1) {
							return _Utils_Tuple2(
								response,
								A2(
									$author$project$Utils$Route$navigate,
									$elm$core$Dict$empty,
									$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__LinkProviders(
										{
											rd: $author$project$Api$Provider$Affiliate$One$id(affiliate)
										})));
						} else {
							var percentagePlanFields = percentagePlan.a;
							var fields = {
								P8: $elm$core$Maybe$Just(true),
								ahn: A2($elm$core$Maybe$map, $elm$core$Basics$negate, percentagePlanFields.ahn),
								Bq: percentagePlanFields.Bq,
								ajZ: percentagePlanFields.ajZ,
								akg: percentagePlanFields.akg
							};
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								A4(
									$author$project$Api$Provider$Affiliates$Plan$create,
									model.Gv,
									$author$project$Api$Provider$Affiliate$One$id(affiliate),
									fields,
									$author$project$Pages$Affiliates$Create$AffiliatePlanCreated(affiliate)));
						}
					}();
					var saveRequest = _v11.a;
					var cmd = _v11.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: saveRequest}),
						cmd,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Affiliate added!')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var affiliate = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var affiliatePlan = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: $author$project$Api$Data$NotAsked}),
						A2(
							$author$project$Utils$Route$navigate,
							$elm$core$Dict$empty,
							$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__LinkProviders(
								{
									rd: $author$project$Api$Provider$Affiliate$One$id(affiliate)
								})),
						_List_fromArray(
							[
								A2(
								$author$project$OutMsg$ShowToast,
								3,
								$author$project$Api$Provider$Affiliates$Plan$One$name(affiliatePlan) + ' plan added!')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Affiliates$Create$Create = {$: 2};
var $author$project$Pages$Affiliates$Create$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$elm$core$Basics$never,
								A2(
									$author$project$Ui$Breadcrumb$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Breadcrumb$item,
											_List_Nil,
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Affiliates__Top,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Manage affiliates')
														]))
												])),
											A2(
											$author$project$Ui$Breadcrumb$item,
											_List_Nil,
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Affiliates__New,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Add new affiliate')
														]))
												])),
											A2(
											$author$project$Ui$Breadcrumb$item,
											_List_fromArray(
												[
													$author$project$Ui$Breadcrumb$active(true)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Create Affiliation')
												]))
										]))),
								A2(
								$author$project$Ui$Grid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Ui$Typography$headingSm(
												_List_fromArray(
													[
														$elm$html$Html$text('Create affiliation')
													]))
											]))
									])),
								function () {
								var _v0 = model.hd;
								if (!_v0.$) {
									var percentagePlan = _v0.a;
									return A2(
										$author$project$Ui$Form$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$noValidate(true),
												$author$project$Ui$Form$autocomplete(true),
												$author$project$Ui$Form$onSubmit($author$project$Pages$Affiliates$Create$Create)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Pages$Affiliates$Create$PercentagePlanMsg,
												$author$project$Components$Affiliates$PercentagePlan$view(percentagePlan))
											]));
								} else {
									return A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$textCenter]),
										_List_fromArray(
											[
												$author$project$Ui$Spinner$view(_List_Nil)
											]));
								}
							}()
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_fromArray(
							[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$gap2]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Affiliates__New,
								_List_fromArray(
									[$author$project$Ui$Link$buttonDefault]),
								_List_fromArray(
									[
										$elm$html$Html$text('Cancel')
									])),
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Create affiliation'},
								_List_fromArray(
									[
										$author$project$Ui$Button$primary,
										$author$project$Ui$Button$onClick($author$project$Pages$Affiliates$Create$Create),
										$author$project$Ui$Button$loading(
										_Utils_eq(model.k9, $author$project$Api$Data$Loading))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Create Affiliation')
									]))
							]))
					]))
			]),
		ac9: 'Affiliates'
	};
};
var $author$project$Pages$Affiliates$Create$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Affiliates$Create$init, aiq: $author$project$Pages$Affiliates$Create$load, k8: $author$project$Pages$Affiliates$Create$save, alO: $author$project$Pages$Affiliates$Create$subscriptions, adT: $author$project$Pages$Affiliates$Create$update, amo: $author$project$Pages$Affiliates$Create$view});
var $author$project$Api$Platform$User$Practice$Affiliates = 0;
var $author$project$Pages$Affiliates$New$GotPractices = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Platform$Practice$All$Practice = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Platform$Practice$All$Record = F4(
	function (address, organizationId, owner, productType) {
		return {K2: address, ajD: organizationId, YD: owner, Jo: productType};
	});
var $author$project$Api$Platform$User$Min$User = $elm$core$Basics$identity;
var $author$project$Api$Platform$User$Min$Record = F3(
	function (id, name, email) {
		return {Rj: email, ahP: id, Bq: name};
	});
var $author$project$Api$Platform$User$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'email',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Platform$User$Min$Record))));
var $author$project$Api$Platform$User$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$User$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Platform$Practice$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'product_type',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'owner',
		$elm$json$Json$Decode$nullable($author$project$Api$Platform$User$Min$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'organization_id',
			$elm$json$Json$Decode$string,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'address',
				$elm$json$Json$Decode$nullable($author$project$Api$Common$Address$Shared$decoder),
				$elm$core$Maybe$Nothing,
				$elm$json$Json$Decode$succeed($author$project$Api$Platform$Practice$All$Record)))));
var $author$project$Api$Platform$Practice$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$Practice$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Platform$Practice$Min$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Platform$Practice$All$Practice)));
var $author$project$Api$Platform$User$Practice$expandToString = function (expand) {
	return 'affiliates';
};
var $author$project$Api$Platform$User$Practice$listDefaults = {
	Go: $elm$core$Maybe$Nothing,
	HE: _List_Nil,
	HM: $elm$core$Maybe$Nothing,
	ajJ: $author$project$Api$Pagination$init,
	akl: $elm$core$Maybe$Nothing,
	alA: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init),
	Kc: $elm$core$Maybe$Nothing
};
var $author$project$Api$Platform$User$Practice$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Platform$User$Practice$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.akl;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.HM;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'filter', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.Kc;
				if (!_v2.$) {
					var bool = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$bool, 'unaffiliated', bool)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v3 = options.Go;
				if (!_v3.$) {
					var bool = _v3.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$bool, 'affiliated', bool)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				_List_fromArray(
				[
					A2(
					$author$project$Api$Param$list,
					'expand',
					A2($elm$core$List$map, $author$project$Api$Platform$User$Practice$expandToString, options.HE))
				]),
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$Platform$User$Practice$list = F4(
	function (apiClient, optionals, maybeTracker, toMsg) {
		var request = function (req) {
			if (!maybeTracker.$) {
				var tracker = maybeTracker.a;
				return A2($author$project$Api$Data$requestWithTracker, tracker, req);
			} else {
				return req;
			}
		}(
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Platform$User$Practice$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Platform$User$Practice$practicesPath)));
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Platform$Practice$All$decoder),
			toMsg,
			request);
	});
var $author$project$Pages$Affiliates$New$fetchData = function (model) {
	return A4(
		$author$project$Api$Platform$User$Practice$list,
		model.Gv,
		function (d) {
			return _Utils_update(
				d,
				{
					HE: _List_fromArray(
						[0]),
					ajJ: model.ajJ,
					akl: model.akl,
					alA: model.alA,
					Kc: $elm$core$Maybe$Just(true)
				});
		},
		$elm$core$Maybe$Nothing,
		$author$project$Pages$Affiliates$New$GotPractices);
};
var $author$project$Pages$Affiliates$New$init = F4(
	function (_v0, _v1, _v2, _v3) {
		var apiClient = _v2.Gv;
		var query = _v3.DE;
		var q = A2($elm$core$Dict$get, 'q', query);
		var model = {
			Gv: apiClient,
			ajJ: $author$project$Api$Pagination$initFromQuery(query),
			kM: $author$project$Api$Data$Loading,
			akl: q,
			up: $author$project$Ui$SearchInput$init(q),
			alA: A3(
				$author$project$Api$Sort$withDefault,
				'name',
				0,
				$author$project$Api$Sort$initFromQuery(query))
		};
		return _Utils_Tuple2(
			model,
			$author$project$Pages$Affiliates$New$fetchData(model));
	});
var $author$project$Pages$Affiliates$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Affiliates$New$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Affiliates$New$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Affiliates$New$SearchInputMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Affiliates$New$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('q'),
			model.akl)
		]);
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Affiliates__New)
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.ajJ),
				A2(
					$elm$core$List$append,
					$author$project$Api$Sort$toQuery(model.alA),
					A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
};
var $author$project$Pages$Affiliates$New$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ),
								kM: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{kM: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Ui$SearchInput$update, subMsg, model.up);
				var searchInput = _v2.a;
				var searchInputCmd = _v2.b;
				var searchInputEvent = _v2.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.akl;
					}
				}();
				var _v3 = function () {
					if (_Utils_eq(q, model.akl)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								ajJ: $author$project$Api$Pagination$reset(model.ajJ),
								kM: $author$project$Api$Data$Loading,
								akl: q
							});
						return _Utils_Tuple2(
							qModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Affiliates$New$fetchData(qModel),
										$author$project$Pages$Affiliates$New$updateUrl(qModel)
									])));
					}
				}();
				var newModel = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{up: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$New$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
			case 2:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{ajJ: pagination, kM: $author$project$Api$Data$Loading});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Affiliates$New$fetchData(newModel),
								$author$project$Pages$Affiliates$New$updateUrl(newModel)
							])),
					_List_Nil);
			default:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						alA: A2($author$project$Api$Sort$update, columnId, model.alA)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Affiliates$New$fetchData(newModel),
								$author$project$Pages$Affiliates$New$updateUrl(newModel)
							])),
					_List_Nil);
		}
	});
var $author$project$Pages$Affiliates$New$PaginationMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Affiliates$New$SortTable = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Affiliates$New$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'name', true, 'Affiliate Name'),
		A3($author$project$Api$Column$init, 'address', false, 'Address')
	]);
var $author$project$Api$Platform$Practice$All$address = function (_v0) {
	var record = _v0.b;
	return record.K2;
};
var $author$project$Api$Platform$Practice$Min$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Platform$Practice$All$id = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Platform$Practice$Min$id(min);
};
var $author$project$Api$Platform$Practice$All$name = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Platform$Practice$Min$name(min);
};
var $author$project$Pages$Affiliates$New$viewPractice = function (practice) {
	return A2(
		$author$project$Ui$Table$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Platform$Practice$All$name(practice))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						function () {
						var _v0 = $author$project$Api$Platform$Practice$All$address(practice);
						if (!_v0.$) {
							var address = _v0.a;
							return $author$project$Components$AddressDisplay$view(address);
						} else {
							return $elm$html$Html$text('N/A');
						}
					}()
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$flex, $author$project$Ui$Element$justifyRight]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Affiliates__Create,
								_List_fromArray(
									[
										$author$project$Ui$Link$buttonDefault,
										$author$project$Ui$Link$sm,
										$author$project$Ui$Link$routeParams(
										_List_fromArray(
											[
												A2(
												$elm$url$Url$Builder$string,
												'affiliatePracticeId',
												$author$project$Api$Platform$Practice$All$id(practice))
											]))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Set up an affiliation')
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Affiliates$New$view = function (model) {
	var _v0 = function () {
		var _v1 = model.kM;
		if (_v1.$ === 3) {
			var practices_ = _v1.a;
			return _Utils_Tuple2(false, practices_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var practices = _v0.b;
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$elm$core$Basics$never,
								A2(
									$author$project$Ui$Breadcrumb$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Breadcrumb$item,
											_List_Nil,
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Affiliates__Top,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Manage affiliates')
														]))
												])),
											A2(
											$author$project$Ui$Breadcrumb$item,
											_List_fromArray(
												[
													$author$project$Ui$Breadcrumb$active(true)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Add new affiliate')
												]))
										]))),
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$mb2]),
								_List_fromArray(
									[
										$author$project$Ui$Typography$headingSm(
										_List_fromArray(
											[
												$elm$html$Html$text('Find new affiliate on this platform')
											])),
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Hinter__NewPractice,
										_List_fromArray(
											[
												$author$project$Ui$Link$buttonDefault,
												$author$project$Ui$Link$routeParams(
												_List_fromArray(
													[
														A2(
														$elm$url$Url$Builder$string,
														'affiliateWizard',
														$author$project$Utils$Bool$toString(true))
													])),
												$author$project$Ui$Link$icon($author$project$Ui$Icon$add)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Create new account')
											]))
									])),
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$mb2]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Pages$Affiliates$New$SearchInputMsg,
										A2($author$project$Ui$SearchInput$view, _List_Nil, model.up))
									])),
								A4(
								$author$project$Ui$Table$view,
								_List_fromArray(
									[
										$author$project$Ui$Table$loading(loading),
										$author$project$Ui$Table$zeroState(
										_List_fromArray(
											[
												$elm$html$Html$text('No matching results.')
											]))
									]),
								_Utils_ap(
									A2(
										$elm$core$List$map,
										$author$project$Api$Column$view(
											A2($author$project$Api$Column$Sortable, model.alA, $author$project$Pages$Affiliates$New$SortTable)),
										$author$project$Pages$Affiliates$New$columns),
									_List_fromArray(
										[
											A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
										])),
								A2($elm$core$List$map, $author$project$Pages$Affiliates$New$viewPractice, practices),
								_List_Nil)
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Affiliates$New$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(loading)
										]),
									model.ajJ))
							]))
					]))
			]),
		ac9: 'Affiliates'
	};
};
var $author$project$Pages$Affiliates$New$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Affiliates$New$init, aiq: $author$project$Pages$Affiliates$New$load, k8: $author$project$Pages$Affiliates$New$save, alO: $author$project$Pages$Affiliates$New$subscriptions, adT: $author$project$Pages$Affiliates$New$update, amo: $author$project$Pages$Affiliates$New$view});
var $author$project$Pages$Affiliates$Top$StatusDropdownMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Affiliates$Top$GotAffiliates = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Affiliate$All$Affiliate = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Affiliate$All$Record = F4(
	function (activeLives, amountOwed, createdFrom, address) {
		return {KQ: activeLives, K2: address, LG: amountOwed, af0: createdFrom};
	});
var $author$project$Api$Provider$Affiliate$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'address',
	$elm$json$Json$Decode$nullable($author$project$Api$Common$Address$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'created_from',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'amount_owed',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'active_lives',
				$elm$json$Json$Decode$int,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$Affiliate$All$Record)))));
var $author$project$Api$Provider$Affiliate$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Affiliate$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Affiliate$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Affiliate$All$Affiliate)));
var $author$project$Api$Provider$Affiliate$listDefaults = {
	ahP: $elm$core$Maybe$Nothing,
	ais: $elm$core$Maybe$Nothing,
	ajJ: $author$project$Api$Pagination$init,
	aka: $elm$core$Maybe$Nothing,
	akl: $elm$core$Maybe$Nothing,
	alA: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init),
	alH: $elm$core$Maybe$Nothing
};
var $author$project$Api$Provider$Affiliate$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Affiliate$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.akl;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.ahP;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.alH;
				if (!_v2.$) {
					var string = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'status', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ),
				function () {
				var _v3 = options.aka;
				if (!_v3.$) {
					var string = _v3.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'practitioner', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v4 = options.ais;
				if (!_v4.$) {
					var string = _v4.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'location', string)
						]);
				} else {
					return _List_Nil;
				}
			}()
			]));
};
var $author$project$Api$Provider$Affiliate$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Affiliate$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Affiliate$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Affiliate$affiliatesPath)));
	});
var $author$project$Pages$Affiliates$Top$statusToValue = function (status) {
	switch (status) {
		case 0:
			return 'active';
		case 1:
			return 'pending';
		default:
			return 'ended';
	}
};
var $author$project$Pages$Affiliates$Top$fetchData = function (model) {
	return A3(
		$author$project$Api$Provider$Affiliate$list,
		model.Gv,
		function (d) {
			return _Utils_update(
				d,
				{
					ajJ: model.ajJ,
					akl: model.akl,
					alA: model.alA,
					alH: A2($elm$core$Maybe$map, $author$project$Pages$Affiliates$Top$statusToValue, model.alH)
				});
		},
		$author$project$Pages$Affiliates$Top$GotAffiliates);
};
var $author$project$Pages$Affiliates$Top$Active = 0;
var $author$project$Pages$Affiliates$Top$Ended = 2;
var $author$project$Pages$Affiliates$Top$Pending = 1;
var $author$project$Pages$Affiliates$Top$statusFromQuery = function (queryString) {
	return A2(
		$elm_community$list_extra$List$Extra$find,
		function (status) {
			return _Utils_eq(
				$author$project$Pages$Affiliates$Top$statusToValue(status),
				queryString);
		},
		_List_fromArray(
			[0, 1, 2]));
};
var $author$project$Pages$Affiliates$Top$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.DE;
		var q = A2($elm$core$Dict$get, 'q', query);
		var model = {
			fB: $author$project$Api$Data$Loading,
			Gv: shared.Gv,
			Ij: $author$project$Shared$isHintAdmin(shared),
			ajJ: $author$project$Api$Pagination$initFromQuery(query),
			ZV: practice,
			akl: q,
			up: $author$project$Ui$SearchInput$init(q),
			aa4: session,
			alA: A3(
				$author$project$Api$Sort$withDefault,
				'name',
				0,
				$author$project$Api$Sort$initFromQuery(query)),
			alH: A2(
				$elm$core$Maybe$andThen,
				$author$project$Pages$Affiliates$Top$statusFromQuery,
				A2($elm$core$Dict$get, 'status', query)),
			qn: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'status-dropdown-filter', al6: $author$project$Pages$Affiliates$Top$StatusDropdownMsg}))
		};
		return _Utils_Tuple2(
			model,
			$author$project$Pages$Affiliates$Top$fetchData(model));
	});
var $author$project$Pages$Affiliates$Top$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					Ij: $author$project$Shared$isHintAdmin(shared)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Affiliates$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Affiliates$Top$subscriptions = function (model) {
	return $author$project$Ui$Dropdown$subscriptions(model.qn);
};
var $author$project$Pages$Affiliates$Top$SearchInputMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Affiliates$Top$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('q'),
			model.akl),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Pages$Affiliates$Top$statusToValue,
				$elm$url$Url$Builder$string('status')),
			model.alH)
		]);
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Affiliates__Top)
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.ajJ),
				A2(
					$elm$core$List$append,
					$author$project$Api$Sort$toQuery(model.alA),
					A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
};
var $author$project$Pages$Affiliates$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								fB: response,
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{fB: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Ui$SearchInput$update, subMsg, model.up);
				var searchInput = _v2.a;
				var searchInputCmd = _v2.b;
				var searchInputEvent = _v2.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.akl;
					}
				}();
				var _v3 = function () {
					if (_Utils_eq(q, model.akl)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								fB: $author$project$Api$Data$Loading,
								ajJ: $author$project$Api$Pagination$reset(model.ajJ),
								akl: q
							});
						return _Utils_Tuple2(
							qModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Affiliates$Top$fetchData(qModel),
										$author$project$Pages$Affiliates$Top$updateUrl(qModel)
									])));
					}
				}();
				var newModel = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{up: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$Top$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
			case 2:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{fB: $author$project$Api$Data$Loading, ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Affiliates$Top$fetchData(newModel),
								$author$project$Pages$Affiliates$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 4:
				var subMsg = msg.a;
				var _v5 = A2($author$project$Ui$Dropdown$update, subMsg, model.qn);
				var dropdown = _v5.a;
				var dropdownCmd = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qn: dropdown}),
					dropdownCmd,
					_List_Nil);
			case 3:
				var status = msg.a;
				var newModel = _Utils_update(
					model,
					{fB: $author$project$Api$Data$Loading, alH: status});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Affiliates$Top$fetchData(newModel),
								$author$project$Pages$Affiliates$Top$updateUrl(newModel)
							])),
					_List_Nil);
			default:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						alA: A2($author$project$Api$Sort$update, columnId, model.alA)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Affiliates$Top$fetchData(newModel),
								$author$project$Pages$Affiliates$Top$updateUrl(newModel)
							])),
					_List_Nil);
		}
	});
var $author$project$Pages$Affiliates$Top$PaginationMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Affiliates$Top$SortTable = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Affiliates$Top$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'name', true, 'Affiliate Name'),
		A3($author$project$Api$Column$init, 'address', false, 'Address'),
		A3($author$project$Api$Column$init, 'active_lives', false, 'Active Lives'),
		A3($author$project$Api$Column$init, 'amount_owed', false, 'Amount Owed'),
		A3($author$project$Api$Column$init, 'status', true, 'Status')
	]);
var $author$project$Api$Provider$Affiliate$All$activeLives = function (_v0) {
	var record = _v0.b;
	return record.KQ;
};
var $author$project$Api$Provider$Affiliate$All$address = function (_v0) {
	var record = _v0.b;
	return record.K2;
};
var $author$project$Api$Provider$Affiliate$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Affiliate$Shared$id(shared);
};
var $author$project$Api$Provider$Affiliate$All$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Affiliate$Shared$status(shared);
};
var $author$project$Pages$Affiliates$Top$affiliateRoute = function (affiliate) {
	return ($author$project$Api$Provider$Affiliate$All$status(affiliate) === 'pending') ? $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__LinkProviders(
		{
			rd: $author$project$Api$Provider$Affiliate$All$id(affiliate)
		}) : $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Top(
		{
			rd: $author$project$Api$Provider$Affiliate$All$id(affiliate)
		});
};
var $author$project$Api$Provider$Affiliate$All$amountOwed = function (_v0) {
	var record = _v0.b;
	return record.LG;
};
var $author$project$Api$Provider$Affiliate$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$Affiliate$All$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Affiliate$Shared$name(shared);
};
var $author$project$Pages$Affiliates$Top$viewAffiliate = function (affiliate) {
	return A2(
		$author$project$Ui$Table$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$route,
						$author$project$Pages$Affiliates$Top$affiliateRoute(affiliate),
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$elm$core$Maybe$withDefault,
									'N/A',
									$author$project$Api$Provider$Affiliate$All$name(affiliate)))
							]))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						function () {
						var _v0 = $author$project$Api$Provider$Affiliate$All$address(affiliate);
						if (!_v0.$) {
							var address = _v0.a;
							return $author$project$Components$AddressDisplay$view(address);
						} else {
							return $elm$html$Html$text('N/A');
						}
					}()
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$fromInt(
							$author$project$Api$Provider$Affiliate$All$activeLives(affiliate)))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Utils$Currency$fromInt(
							$author$project$Api$Provider$Affiliate$All$amountOwed(affiliate)))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Badge$fromString,
						_List_Nil,
						$author$project$Api$Provider$Affiliate$All$status(affiliate))
					]))
			]));
};
var $author$project$Pages$Affiliates$Top$StatusSelected = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Affiliates$Top$statusToLabel = function (status) {
	if (!status.$) {
		switch (status.a) {
			case 0:
				var _v1 = status.a;
				return 'Active';
			case 1:
				var _v2 = status.a;
				return 'Pending';
			default:
				var _v3 = status.a;
				return 'Ended';
		}
	} else {
		return 'All Status';
	}
};
var $author$project$Pages$Affiliates$Top$statusDropdownOptions = function (currentStatus) {
	var statusToItem = function (status) {
		return A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Pages$Affiliates$Top$StatusSelected(status)),
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(status, currentStatus))
				]),
			$elm$html$Html$text(
				$author$project$Pages$Affiliates$Top$statusToLabel(status)));
	};
	return A2(
		$elm$core$List$cons,
		statusToItem($elm$core$Maybe$Nothing),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$Dropdown$separator,
			A2(
				$elm$core$List$map,
				A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, statusToItem),
				_List_fromArray(
					[0, 1, 2]))));
};
var $author$project$Pages$Affiliates$Top$viewStatusDropdown = function (model) {
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Pages$Affiliates$Top$statusToLabel(model.alH))
			]),
		$author$project$Pages$Affiliates$Top$statusDropdownOptions(model.alH),
		model.qn);
};
var $author$project$Pages$Affiliates$Top$view = function (model) {
	var _v0 = function () {
		var _v1 = model.fB;
		if (_v1.$ === 3) {
			var affiliates_ = _v1.a;
			return _Utils_Tuple2(false, affiliates_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var affiliates = _v0.b;
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$spanSm(7)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Group$view,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$map,
														$author$project$Pages$Affiliates$Top$SearchInputMsg,
														A2($author$project$Ui$SearchInput$view, _List_Nil, model.up))
													]))
											])),
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$spanSm(2)
											]),
										_List_fromArray(
											[
												$author$project$Pages$Affiliates$Top$viewStatusDropdown(model)
											])),
										model.Ij ? A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$spanSm(3)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$flex, $author$project$Ui$Element$justifyRight]),
												_List_fromArray(
													[
														A3(
														$author$project$Ui$HinterOnly$linkRoute,
														$author$project$Spa$Generated$Route$Affiliates__New,
														_List_fromArray(
															[
																$author$project$Ui$Link$buttonDefault,
																$author$project$Ui$Link$icon($author$project$Ui$Icon$add)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Add new affiliate')
															]))
													]))
											])) : $author$project$Ui$Grid$none
									]))
							])),
						A4(
						$author$project$Ui$Panel$table,
						_List_fromArray(
							[
								$author$project$Ui$Table$loading(loading),
								$author$project$Ui$Table$zeroState(
								_List_fromArray(
									[
										$elm$html$Html$text('No matching results.')
									]))
							]),
						A2(
							$elm$core$List$map,
							$author$project$Api$Column$view(
								A2($author$project$Api$Column$Sortable, model.alA, $author$project$Pages$Affiliates$Top$SortTable)),
							$author$project$Pages$Affiliates$Top$columns),
						A2($elm$core$List$map, $author$project$Pages$Affiliates$Top$viewAffiliate, affiliates),
						_List_Nil),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Affiliates$Top$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(loading)
										]),
									model.ajJ))
							]))
					]))
			]),
		ac9: 'Affiliates | Manage'
	};
};
var $author$project$Pages$Affiliates$Top$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Affiliates$Top$init, aiq: $author$project$Pages$Affiliates$Top$load, k8: $author$project$Pages$Affiliates$Top$save, alO: $author$project$Pages$Affiliates$Top$subscriptions, adT: $author$project$Pages$Affiliates$Top$update, amo: $author$project$Pages$Affiliates$Top$view});
var $author$project$Pages$Apps$Slug_String$GotPartnerApp = $elm$core$Basics$identity;
var $author$project$Api$Common$PartnerApp$One$PartnerApp = $elm$core$Basics$identity;
var $author$project$Api$Common$PartnerApp$Shared$PartnerApp = $elm$core$Basics$identity;
var $author$project$Api$Common$PartnerApp$Shared$Record = F9(
	function (id, name, anchors, partner, partnerRoles, defaultAdminRole, defaultNonAdminRole, prepopulateRoleMappings, localhostMode) {
		return {Gr: anchors, PX: defaultAdminRole, P3: defaultNonAdminRole, ahP: id, V9: localhostMode, Bq: name, YN: partner, I3: partnerRoles, _e: prepopulateRoleMappings};
	});
var $author$project$Api$Common$Partner$Min$Partner = $elm$core$Basics$identity;
var $author$project$Api$Common$Partner$Min$Record = F3(
	function (id, name, slug) {
		return {ahP: id, Bq: name, abG: slug};
	});
var $author$project$Api$Common$Partner$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'slug',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Common$Partner$Min$Record))));
var $author$project$Api$Common$Partner$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Partner$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$PartnerApp$Anchor$Anchor = $elm$core$Basics$identity;
var $author$project$Api$Common$PartnerApp$Anchor$Record = F5(
	function (id, type_, corePageIconUrl, corePageIconLabel, settingsLabel) {
		return {OI: corePageIconLabel, OJ: corePageIconUrl, ahP: id, aa5: settingsLabel, amg: type_};
	});
var $author$project$Api$Common$PartnerApp$Anchor$ClinicalChart = 2;
var $author$project$Api$Common$PartnerApp$Anchor$ClinicalInteraction = 1;
var $author$project$Api$Common$PartnerApp$Anchor$CorePage = 0;
var $author$project$Api$Common$PartnerApp$Anchor$Settings = 3;
var $author$project$Api$Common$PartnerApp$Anchor$anchorTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (typeString) {
		switch (typeString) {
			case 'core_page':
				return $elm$json$Json$Decode$succeed(0);
			case 'clinical_interaction':
				return $elm$json$Json$Decode$succeed(1);
			case 'clinical_chart':
				return $elm$json$Json$Decode$succeed(2);
			case 'settings':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('Unknown anchor type: ' + typeString);
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$Api$Common$PartnerApp$Anchor$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'settings_label',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'core_page_icon_label',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'core_page_icon_url',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
					$author$project$Api$Common$PartnerApp$Anchor$anchorTypeDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Api$Common$PartnerApp$Anchor$Record)))))),
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$PartnerApp$PartnerRole$PartnerRole = $elm$core$Basics$identity;
var $author$project$Api$Common$PartnerApp$PartnerRole$Record = F2(
	function (name, description) {
		return {Qr: description, Bq: name};
	});
var $author$project$Api$Common$PartnerApp$PartnerRole$decoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'description',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Common$PartnerApp$PartnerRole$Record))));
var $author$project$Api$Common$PartnerApp$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'localhost_mode',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'prepopulate_role_mappings',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'default_non_admin_role',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'default_admin_role',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'partner_roles',
					$elm$json$Json$Decode$list($author$project$Api$Common$PartnerApp$PartnerRole$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'partner',
						$author$project$Api$Common$Partner$Min$decoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'anchors',
							$elm$json$Json$Decode$list($author$project$Api$Common$PartnerApp$Anchor$decoder),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'name',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'id',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Api$Common$PartnerApp$Shared$Record))))))))));
var $author$project$Api$Common$PartnerApp$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$PartnerApp$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$PartnerApp$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$PartnerApp$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PartnerApp$partnerAppsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['partner_apps']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$PartnerApp$retrieve = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Common$PartnerApp$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						[id]),
					$author$project$Api$Provider$PartnerApp$partnerAppsPath)));
	});
var $author$project$Pages$Apps$Slug_String$init = F4(
	function (session, practice, shared, _v0) {
		var params = _v0.YL;
		return _Utils_Tuple2(
			{Gv: shared.Gv, YP: $author$project$Api$Data$Loading, ZV: practice, aa4: session},
			A3($author$project$Api$Provider$PartnerApp$retrieve, shared.Gv, params.abG, $elm$core$Basics$identity));
	});
var $author$project$Pages$Apps$Slug_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Apps$Slug_String$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Apps$Slug_String$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Api$Common$PartnerApp$Anchor$isCorePage = function (_v0) {
	var record = _v0;
	var _v1 = record.amg;
	if (!_v1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Api$Common$PartnerApp$Shared$corePageAnchor = function (_v0) {
	var record = _v0;
	return A2($elm_community$list_extra$List$Extra$find, $author$project$Api$Common$PartnerApp$Anchor$isCorePage, record.Gr);
};
var $author$project$Api$Common$PartnerApp$Shared$embedsCorePage = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Common$PartnerApp$Shared$corePageAnchor,
	$elm$core$Basics$neq($elm$core$Maybe$Nothing));
var $author$project$Api$Common$PartnerApp$One$shared = function (_v0) {
	var shared_ = _v0;
	return shared_;
};
var $author$project$Api$Common$PartnerApp$One$embedsCorePage = A2($elm$core$Basics$composeR, $author$project$Api$Common$PartnerApp$One$shared, $author$project$Api$Common$PartnerApp$Shared$embedsCorePage);
var $author$project$Api$Common$PartnerApp$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Common$PartnerApp$One$id = A2($elm$core$Basics$composeR, $author$project$Api$Common$PartnerApp$One$shared, $author$project$Api$Common$PartnerApp$Shared$id);
var $author$project$Api$Common$PartnerApp$Shared$localhostMode = function (_v0) {
	var record = _v0;
	return record.V9;
};
var $author$project$Api$Common$PartnerApp$One$localhostMode = A2($elm$core$Basics$composeR, $author$project$Api$Common$PartnerApp$One$shared, $author$project$Api$Common$PartnerApp$Shared$localhostMode);
var $author$project$Ports$PartnerApps$partnerAppsMount = _Platform_outgoingPort(
	'partnerAppsMount',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'appId',
					$elm$json$Json$Encode$string($.ae$)),
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string($.ahP)),
					_Utils_Tuple2(
					'localhostMode',
					$elm$json$Json$Encode$bool($.V9)),
					_Utils_Tuple2(
					'type_',
					$elm$json$Json$Encode$string($.amg))
				]));
	});
var $author$project$Ports$PartnerApps$mount = F2(
	function (id, options) {
		return $author$project$Ports$PartnerApps$partnerAppsMount(
			{ae$: options.ae$, ahP: id, V9: options.V9, amg: options.amg});
	});
var $author$project$Pages$Apps$Slug_String$update = F2(
	function (msg, model) {
		var response = msg;
		if (response.$ === 3) {
			var app = response.a;
			var cmd = $author$project$Api$Common$PartnerApp$One$embedsCorePage(app) ? A2(
				$author$project$Ports$PartnerApps$mount,
				'partner-app',
				{
					ae$: $author$project$Api$Common$PartnerApp$One$id(app),
					V9: $author$project$Api$Common$PartnerApp$One$localhostMode(app),
					amg: 'core_page'
				}) : $elm$core$Platform$Cmd$none;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{YP: response}),
				cmd,
				$author$project$OutMsg$handleErrorResponse(response));
		} else {
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{YP: response}),
				$elm$core$Platform$Cmd$none,
				$author$project$OutMsg$handleErrorResponse(response));
		}
	});
var $author$project$Api$Common$PartnerApp$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Common$PartnerApp$One$name = A2($elm$core$Basics$composeR, $author$project$Api$Common$PartnerApp$One$shared, $author$project$Api$Common$PartnerApp$Shared$name);
var $author$project$Pages$Apps$Slug_String$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('partner-app-wrapper'),
						$elm$html$Html$Attributes$id('partner-app')
					]),
				_List_Nil)
			]),
		ac9: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Common$PartnerApp$One$name,
				$author$project$Api$Data$toMaybe(model.YP)))
	};
};
var $author$project$Pages$Apps$Slug_String$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Apps$Slug_String$init, aiq: $author$project$Pages$Apps$Slug_String$load, k8: $author$project$Pages$Apps$Slug_String$save, alO: $author$project$Pages$Apps$Slug_String$subscriptions, adT: $author$project$Pages$Apps$Slug_String$update, amo: $author$project$Pages$Apps$Slug_String$view});
var $author$project$Spa$Page$ignoreEffect = function (model) {
	return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
};
var $author$project$Spa$Page$static = function (view) {
	return {
		ah_: F2(
			function (_v0, url) {
				return _Utils_Tuple3(url, $elm$core$Platform$Cmd$none, _List_Nil);
			}),
		aiq: $elm$core$Basics$always($author$project$Spa$Page$ignoreEffect),
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v1) {
			return $elm$core$Platform$Sub$none;
		},
		adT: F2(
			function (_v2, model) {
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
			}),
		amo: view
	};
};
var $author$project$Pages$Blank$view = function (_v0) {
	return {fO: _List_Nil, ac9: ''};
};
var $author$project$Pages$Blank$page = $author$project$Spa$Page$static($author$project$Pages$Blank$view);
var $author$project$Pages$Bookkeeping$GotLayerAccount = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Bookkeeping$Loading = {$: 0};
var $author$project$Pages$Bookkeeping$NavMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Bookkeeping$Overview = 0;
var $author$project$Ui$Nav$Model = $elm$core$Basics$identity;
var $author$project$Ports$NavTabs$navTabActiveChanged = _Platform_outgoingPort('navTabActiveChanged', $elm$json$Json$Encode$string);
var $author$project$Ui$Nav$init = F2(
	function (navId, toMsg) {
		return _Utils_Tuple2(
			{ahP: navId, al6: toMsg, Kd: 0, Ke: 0},
			$author$project$Ports$NavTabs$navTabActiveChanged(navId));
	});
var $author$project$Ports$Layer$layerPortLoad = _Platform_outgoingPort(
	'layerPortLoad',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$Layer$load = $author$project$Ports$Layer$layerPortLoad(0);
var $author$project$Api$Provider$LayerAccount$One$LayerAccount = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$LayerAccount$Shared$LayerAccount = $elm$core$Basics$identity;
var $author$project$Api$Provider$LayerAccount$Shared$Record = function (status) {
	return {alH: status};
};
var $author$project$Api$Provider$LayerAccount$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'status',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$LayerAccount$Shared$Record));
var $author$project$Api$Provider$LayerAccount$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$LayerAccount$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$LayerAccount$One$Record = F7(
	function (legalName, tin, state, entityType, phone, smsEnabled, bookkeepingEnabled) {
		return {MN: bookkeepingEnabled, RI: entityType, VU: legalName, Zw: phone, abI: smsEnabled, uP: state, ac8: tin};
	});
var $author$project$Api$Provider$LayerAccount$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'bookkeeping_enabled',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'sms_enabled',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'phone',
			$elm$json$Json$Decode$nullable($author$project$Api$Common$Phone$Shared$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'entity_type',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'state',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'tin',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'legal_name',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							$elm$json$Json$Decode$succeed($author$project$Api$Provider$LayerAccount$One$Record))))))));
var $author$project$Api$Provider$LayerAccount$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$LayerAccount$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$LayerAccount$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$LayerAccount$One$LayerAccount)));
var $author$project$Api$Provider$Practice$LayerAccount$layerAccountPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['layer_account']),
	$author$project$Api$Provider$Practice$practicePath);
var $author$project$Api$Provider$Practice$LayerAccount$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$LayerAccount$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$LayerAccount$layerAccountPath));
	});
var $author$project$Pages$Bookkeeping$sectionId = function (section) {
	switch (section) {
		case 0:
			return 'overview';
		case 1:
			return 'bank-transactions-and-accounts';
		case 2:
			return 'reports';
		default:
			return 'general-ledger';
	}
};
var $author$project$Pages$Bookkeeping$BankTransactionsAndAccounts = 1;
var $author$project$Pages$Bookkeeping$GeneralLedger = 3;
var $author$project$Pages$Bookkeeping$Reports = 2;
var $author$project$Pages$Bookkeeping$sections = function (bookkeepingEnabled) {
	return A2(
		$elm$core$List$cons,
		0,
		A2(
			$elm$core$List$cons,
			1,
			A2(
				$elm$core$List$cons,
				2,
				bookkeepingEnabled ? _List_Nil : _List_fromArray(
					[3]))));
};
var $author$project$Pages$Bookkeeping$updateUrl = function (section) {
	return $author$project$Ports$Navigation$replaceUrl(
		A2(
			$elm$core$String$append,
			A2(
				$elm$url$Url$Builder$relative,
				_List_fromArray(
					[
						$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Bookkeeping)
					]),
				_List_Nil),
			'#' + $author$project$Pages$Bookkeeping$sectionId(section)));
};
var $author$project$Pages$Bookkeeping$init = F4(
	function (_v0, practice, shared, _v1) {
		var rawUrl = _v1.akq;
		var section = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$andThen,
				function (fragment) {
					return A2(
						$elm_community$list_extra$List$Extra$find,
						function (section_) {
							return _Utils_eq(
								$author$project$Pages$Bookkeeping$sectionId(section_),
								fragment);
						},
						$author$project$Pages$Bookkeeping$sections(false));
				},
				rawUrl.ahu));
		var _v2 = A2($author$project$Ui$Nav$init, 'bookkeeping-nav', $author$project$Pages$Bookkeeping$NavMsg);
		var nav = _v2.a;
		var navCmd = _v2.b;
		var model = {q7: $author$project$Api$Data$Loading, Gv: shared.Gv, AA: $author$project$Api$Data$Loading, kp: nav, ZV: practice, ur: section, alH: $author$project$Pages$Bookkeeping$Loading};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						navCmd,
						$author$project$Pages$Bookkeeping$updateUrl(section),
						A2($author$project$Api$Provider$Practice$LayerAccount$retrieve, shared.Gv, $author$project$Pages$Bookkeeping$GotLayerAccount),
						$author$project$Ports$Layer$load
					])));
	});
var $author$project$Pages$Bookkeeping$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Bookkeeping$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Ui$Nav$GotUnderlinePosition = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ports$NavTabs$onNavTabActivePositionChange = _Platform_incomingPort(
	'onNavTabActivePositionChange',
	A2(
		$elm$json$Json$Decode$andThen,
		function (width) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (navId) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (left) {
							return $elm$json$Json$Decode$succeed(
								{aik: left, aiU: navId, ams: width});
						},
						A2($elm$json$Json$Decode$field, 'left', $elm$json$Json$Decode$float));
				},
				A2($elm$json$Json$Decode$field, 'navId', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'width', $elm$json$Json$Decode$float)));
var $author$project$Ui$Nav$subscriptions = function (_v0) {
	var toMsg = _v0.al6;
	return A2(
		$elm$core$Platform$Sub$map,
		toMsg,
		$author$project$Ports$NavTabs$onNavTabActivePositionChange($author$project$Ui$Nav$GotUnderlinePosition));
};
var $author$project$Pages$Bookkeeping$subscriptions = function (model) {
	return $author$project$Ui$Nav$subscriptions(model.kp);
};
var $author$project$Pages$Bookkeeping$CreateAccount = {$: 2};
var $author$project$Pages$Bookkeeping$GotAccessToken = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Bookkeeping$HasLayerAccountAccount = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Practice$LayerAccount$AccessToken$accessTokenPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['access_token']),
	$author$project$Api$Provider$Practice$LayerAccount$layerAccountPath);
var $author$project$Api$Provider$Practice$LayerAccount$AccessToken$AccessToken = $elm$core$Basics$identity;
var $author$project$Api$Provider$Practice$LayerAccount$AccessToken$Record = F3(
	function (token, businessId, env) {
		return {MX: businessId, RJ: env, adi: token};
	});
var $author$project$Api$Provider$Practice$LayerAccount$AccessToken$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'env',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'business_id',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'token',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Practice$LayerAccount$AccessToken$Record))));
var $author$project$Api$Provider$Practice$LayerAccount$AccessToken$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Practice$LayerAccount$AccessToken$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Practice$LayerAccount$AccessToken$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Practice$LayerAccount$AccessToken$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$LayerAccount$AccessToken$accessTokenPath));
	});
var $author$project$Api$Provider$LayerAccount$Shared$record = function (_v0) {
	var record_ = _v0;
	return record_;
};
var $author$project$Api$Provider$LayerAccount$Shared$status = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$LayerAccount$Shared$record,
	function ($) {
		return $.alH;
	});
var $author$project$Api$Provider$LayerAccount$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$LayerAccount$Shared$status(shared);
};
var $author$project$Ui$Nav$update = F2(
	function (msg, _v0) {
		var model = _v0;
		if (msg.$ === 1) {
			var navId = msg.a.aiU;
			var width = msg.a.ams;
			var left = msg.a.aik;
			return _Utils_eq(navId, model.ahP) ? _Utils_Tuple2(
				_Utils_update(
					model,
					{Kd: left, Ke: width}),
				$elm$core$Platform$Cmd$none) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(
				model,
				$author$project$Ports$NavTabs$navTabActiveChanged(model.ahP));
		}
	});
var $author$project$Pages$Bookkeeping$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 2:
				var navMsg = msg.a;
				return A2(
					$author$project$Utils$Tuple3$fromTuple2,
					_List_Nil,
					A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Platform$Cmd$map($author$project$Pages$Bookkeeping$NavMsg),
						A2(
							$elm$core$Tuple$mapFirst,
							function (newNav) {
								return _Utils_update(
									model,
									{kp: newNav});
							},
							A2($author$project$Ui$Nav$update, navMsg, model.kp))));
			case 0:
				var response = msg.a;
				_v1$2:
				while (true) {
					switch (response.$) {
						case 3:
							var layerAccount = response.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										AA: response,
										alH: $author$project$Pages$Bookkeeping$HasLayerAccountAccount(layerAccount)
									}),
								($author$project$Api$Provider$LayerAccount$One$status(layerAccount) === 'active') ? A2($author$project$Api$Provider$Practice$LayerAccount$AccessToken$retrieve, model.Gv, $author$project$Pages$Bookkeeping$GotAccessToken) : $elm$core$Platform$Cmd$none,
								_List_fromArray(
									[$author$project$OutMsg$RefreshPractice]));
						case 2:
							if (response.a.$ === 5) {
								var _v2 = response.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{alH: $author$project$Pages$Bookkeeping$CreateAccount}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							} else {
								break _v1$2;
							}
						default:
							break _v1$2;
					}
				}
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{q7: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			default:
				var section = msg.a;
				var _v3 = _Utils_Tuple2(
					$author$project$Api$Data$Loading,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Api$Provider$Practice$LayerAccount$AccessToken$retrieve, model.Gv, $author$project$Pages$Bookkeeping$GotAccessToken),
								$author$project$Pages$Bookkeeping$updateUrl(section)
							])));
				var accessToken = _v3.a;
				var sectionCmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{q7: accessToken, ur: section}),
					sectionCmd,
					_List_Nil);
		}
	});
var $author$project$Api$Feature$Accounting = 15;
var $author$project$Api$Feature$AccountingWithoutBookkeeping = 16;
var $author$project$Pages$Bookkeeping$viewCreateAccountBody = _List_fromArray(
	[
		A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Panel$title(
						_List_fromArray(
							[
								$elm$html$Html$text('Bookkeeping')
							]))
					])),
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$textCenter, $author$project$Ui$Element$mt2, $author$project$Ui$Element$mb4]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$elm$core$Basics$never,
								$author$project$Ui$Typography$headingSm(
									_List_fromArray(
										[
											$elm$html$Html$text('Go to '),
											A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$Marketplace__Slug_String(
												{abG: 'bookkeeping'}),
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('marketplace')
												])),
											$elm$html$Html$text(' to install.')
										])))
							]))
					]))
			]))
	]);
var $author$project$Pages$Bookkeeping$viewLoadingBody = _List_fromArray(
	[
		A2(
		$author$project$Ui$Typography$p,
		_List_fromArray(
			[
				$author$project$Ui$Typography$helpBlock,
				$author$project$Ui$Typography$muted,
				$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
			]),
		_List_Nil)
	]);
var $author$project$Api$Provider$LayerAccount$One$bookkeepingEnabled = function (_v0) {
	var record = _v0.b;
	return record.MN;
};
var $author$project$Pages$Bookkeeping$SectionChanged = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Nav$Active = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Nav$activeItem = $author$project$Ui$Nav$Active;
var $author$project$Ui$Nav$Item = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Ui$Nav$item = $author$project$Ui$Nav$Item;
var $author$project$Ui$Nav$OnClick = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Nav$onItemClick = $author$project$Ui$Nav$OnClick;
var $author$project$Pages$Bookkeeping$sectionName = function (section) {
	switch (section) {
		case 0:
			return 'Overview';
		case 1:
			return 'Bank Transactions and Accounts';
		case 2:
			return 'Reports';
		default:
			return 'General Ledger';
	}
};
var $author$project$Pages$Bookkeeping$sectionToNavItem = F2(
	function (currentSection, section) {
		return A2(
			$author$project$Ui$Nav$item,
			_List_fromArray(
				[
					$author$project$Ui$Nav$activeItem(
					_Utils_eq(section, currentSection)),
					$author$project$Ui$Nav$onItemClick(
					$author$project$Pages$Bookkeeping$SectionChanged(section))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Pages$Bookkeeping$sectionName(section))
				]));
	});
var $author$project$WebComponents$Layer$view = F4(
	function (component, environment, businessId, accessToken) {
		return A3(
			$elm$html$Html$node,
			'layer-' + component,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'business-id', businessId),
					A2($elm$html$Html$Attributes$attribute, 'environment', environment),
					A2($elm$html$Html$Attributes$attribute, 'business-access-token', accessToken)
				]),
			_List_Nil);
	});
var $author$project$WebComponents$Layer$accountingOverview = $author$project$WebComponents$Layer$view('accounting-overview');
var $author$project$WebComponents$Layer$bankTransactionsWithLinkedAccounts = $author$project$WebComponents$Layer$view('bank-transactions-with-linked-accounts');
var $author$project$WebComponents$Layer$bookkeepingOverview = $author$project$WebComponents$Layer$view('bookkeeping-overview');
var $author$project$Api$Provider$Practice$LayerAccount$AccessToken$businessId = function (_v0) {
	var record = _v0;
	return record.MX;
};
var $author$project$Api$Provider$Practice$LayerAccount$AccessToken$env = function (_v0) {
	var record = _v0;
	return record.RJ;
};
var $author$project$WebComponents$Layer$generalLedger = $author$project$WebComponents$Layer$view('general-ledger');
var $author$project$WebComponents$Layer$reports = $author$project$WebComponents$Layer$view('reports');
var $author$project$Api$Provider$Practice$LayerAccount$AccessToken$token = function (_v0) {
	var record = _v0;
	return record.adi;
};
var $author$project$Pages$Bookkeeping$sectionToComponent = F3(
	function (layerAccount, accessToken, section) {
		return function (component) {
			return A3(
				component,
				$author$project$Api$Provider$Practice$LayerAccount$AccessToken$env(accessToken),
				$author$project$Api$Provider$Practice$LayerAccount$AccessToken$businessId(accessToken),
				$author$project$Api$Provider$Practice$LayerAccount$AccessToken$token(accessToken));
		}(
			function () {
				switch (section) {
					case 0:
						return $author$project$Api$Provider$LayerAccount$One$bookkeepingEnabled(layerAccount) ? $author$project$WebComponents$Layer$bookkeepingOverview : $author$project$WebComponents$Layer$accountingOverview;
					case 1:
						return $author$project$WebComponents$Layer$bankTransactionsWithLinkedAccounts;
					case 2:
						return $author$project$WebComponents$Layer$reports;
					default:
						return $author$project$WebComponents$Layer$generalLedger;
				}
			}());
	});
var $author$project$Pages$Bookkeeping$toPane = F3(
	function (layerAccount, accessToken, section) {
		return A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = _Utils_Tuple2(
								$author$project$Api$Data$toMaybe(layerAccount),
								$author$project$Api$Data$toMaybe(accessToken));
							if ((!_v0.a.$) && (!_v0.b.$)) {
								var layerAccount_ = _v0.a.a;
								var accessToken_ = _v0.b.a;
								return A3($author$project$Pages$Bookkeeping$sectionToComponent, layerAccount_, accessToken_, section);
							} else {
								return A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textCenter]),
									_List_fromArray(
										[
											$author$project$Ui$Spinner$view(_List_Nil)
										]));
							}
						}()
						]))
				]));
	});
var $author$project$Ui$Nav$navOptionsToOptionsRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				return _Utils_update(
					record,
					{EH: true});
			}),
		{EH: false},
		options);
};
var $author$project$Ui$Nav$defaultOptions = {KN: false, ahP: $elm$core$Maybe$Nothing, s0: _List_Nil, IS: $elm$core$Maybe$Nothing, e: $elm$core$Maybe$Nothing};
var $author$project$Ui$Nav$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 1:
						var linkOptions_ = option.a;
						return _Utils_update(
							record,
							{
								s0: _Utils_ap(record.s0, linkOptions_)
							});
					case 0:
						var bool = option.a;
						return _Utils_update(
							record,
							{KN: bool});
					case 2:
						var route_ = option.a;
						return _Utils_update(
							record,
							{
								e: $elm$core$Maybe$Just(route_)
							});
					case 3:
						var string = option.a;
						return _Utils_update(
							record,
							{
								ahP: $elm$core$Maybe$Just(string)
							});
					default:
						var handler = option.a;
						return _Utils_update(
							record,
							{
								IS: $elm$core$Maybe$Just(handler)
							});
				}
			}),
		$author$project$Ui$Nav$defaultOptions,
		options);
};
var $author$project$Ui$Nav$ItemClicked = {$: 0};
var $elm$html$Html$Events$onMouseUp = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseup',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Ui$Nav$viewNonEmptyItem = F3(
	function (toMsg, options, contents) {
		var optionsRecord = $author$project$Ui$Nav$optionsToRecord(options);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('nav-tabs__item'),
					A2($elm$html$Html$Attributes$attribute, 'role', 'presentation'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('nav-tabs__item--active', optionsRecord.KN)
						])),
					function () {
					var _v0 = _Utils_Tuple2(optionsRecord.IS, optionsRecord.KN);
					if ((!_v0.a.$) && (!_v0.b)) {
						var handler = _v0.a.a;
						return $elm$html$Html$Events$onClick(handler);
					} else {
						return $author$project$Utils$Html$Attributes$none;
					}
				}(),
					optionsRecord.KN ? $author$project$Utils$Html$Attributes$none : A2(
					$elm$html$Html$Attributes$map,
					toMsg,
					$elm$html$Html$Events$onMouseUp($author$project$Ui$Nav$ItemClicked)),
					A2(
					$elm$core$Maybe$withDefault,
					$elm$html$Html$Attributes$class(''),
					A2($elm$core$Maybe$map, $elm$html$Html$Attributes$id, optionsRecord.ahP))
				]),
			_List_fromArray(
				[contents]));
	});
var $author$project$Ui$Nav$viewItem = F2(
	function (toMsg, item_) {
		switch (item_.$) {
			case 0:
				var options = item_.a;
				var html = item_.b;
				var optionsRecord = $author$project$Ui$Nav$optionsToRecord(options);
				return A3(
					$author$project$Ui$Nav$viewNonEmptyItem,
					toMsg,
					options,
					function () {
						var _v1 = optionsRecord.e;
						if (!_v1.$) {
							var route_ = _v1.a;
							return A2(
								$elm$html$Html$map,
								$elm$core$Basics$never,
								A3($author$project$Ui$Link$route, route_, optionsRecord.s0, html));
						} else {
							return A2(
								$elm$html$Html$map,
								$elm$core$Basics$never,
								A3(
									$author$project$Ui$Button$view,
									{mm: 'Nav Item'},
									_List_fromArray(
										[$author$project$Ui$Button$link]),
									html));
						}
					}());
			case 1:
				var options = item_.a;
				var html = item_.b;
				return A3($author$project$Ui$Nav$viewNonEmptyItem, toMsg, options, html);
			default:
				return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Ui$Nav$view = F3(
	function (options, items, _v0) {
		var underlineWidth = _v0.Ke;
		var underlineLeft = _v0.Kd;
		var id = _v0.ahP;
		var toMsg = _v0.al6;
		var transform = 'translateX(' + ($elm$core$String$fromFloat(underlineLeft) + ('px) ' + ('scaleX(' + ($elm$core$String$fromFloat(underlineWidth) + ')'))));
		var optionsRecord = $author$project$Ui$Nav$navOptionsToOptionsRecord(options);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('nav-tabs'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('nav-tabs--slim', optionsRecord.EH)
						])),
					$elm$html$Html$Attributes$id(id)
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'transform', transform),
							$elm$html$Html$Attributes$class('nav-tabs__underline')
						]),
					_List_Nil),
				A2(
					$elm$core$List$map,
					$author$project$Ui$Nav$viewItem(toMsg),
					items)));
	});
var $author$project$Pages$Bookkeeping$viewSections = F2(
	function (layerAccount, model) {
		var sectionNavItems = A2(
			$elm$core$List$map,
			$author$project$Pages$Bookkeeping$sectionToNavItem(model.ur),
			$author$project$Pages$Bookkeeping$sections(
				$author$project$Api$Provider$LayerAccount$One$bookkeepingEnabled(layerAccount)));
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('layout-header')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mb2]),
						_List_fromArray(
							[
								$author$project$Ui$Typography$heading(
								_List_fromArray(
									[
										$elm$html$Html$text('Bookkeeping')
									]))
							])),
						A3($author$project$Ui$Nav$view, _List_Nil, sectionNavItems, model.kp)
					])),
				A3($author$project$Pages$Bookkeeping$toPane, model.AA, model.q7, model.ur)
			]);
	});
var $author$project$Pages$Bookkeeping$view = function (model) {
	var bookkeepingEnabled = A2($author$project$Api$Provider$Practice$One$featureEnabled, 15, model.ZV) || A2($author$project$Api$Provider$Practice$One$featureEnabled, 16, model.ZV);
	return {
		fO: function () {
			var _v0 = _Utils_Tuple2(bookkeepingEnabled, model.alH);
			if (_v0.a) {
				switch (_v0.b.$) {
					case 0:
						var _v1 = _v0.b;
						return $author$project$Pages$Bookkeeping$viewLoadingBody;
					case 1:
						var layerAccount = _v0.b.a;
						return A2($author$project$Pages$Bookkeeping$viewSections, layerAccount, model);
					default:
						var _v2 = _v0.b;
						return $author$project$Pages$Bookkeeping$viewCreateAccountBody;
				}
			} else {
				return _List_Nil;
			}
		}(),
		ac9: 'Bookkeeping'
	};
};
var $author$project$Pages$Bookkeeping$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Bookkeeping$init, aiq: $author$project$Pages$Bookkeeping$load, k8: $author$project$Pages$Bookkeeping$save, alO: $author$project$Pages$Bookkeeping$subscriptions, adT: $author$project$Pages$Bookkeeping$update, amo: $author$project$Pages$Bookkeeping$view});
var $author$project$Pages$Calendar$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Calendar$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Calendar$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Calendar$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Calendar'};
};
var $author$project$Pages$Calendar$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$Calendar$init,
		aiq: $author$project$Pages$Calendar$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$Calendar$update,
		amo: $author$project$Pages$Calendar$view
	});
var $author$project$Pages$CcdaImports$CcdaId_String$Top$GotStats = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$CcdaImports$CcdaId_String$Top$GotReports = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$CcdaImport$All$CcdaImport = $elm$core$Basics$identity;
var $author$project$Api$Provider$CcdaImport$Shared$CcdaImport = $elm$core$Basics$identity;
var $author$project$Api$Provider$CcdaImport$Shared$Record = F4(
	function (id, extractionStatus, syncStatus, patient) {
		return {HI: extractionStatus, ahP: id, YY: patient, acL: syncStatus};
	});
var $author$project$Api$Provider$CcdaImport$ExtractionStatus$Extracted = {$: 0};
var $author$project$Api$Provider$CcdaImport$ExtractionStatus$Failed = {$: 2};
var $author$project$Api$Provider$CcdaImport$ExtractionStatus$Partial = {$: 1};
var $author$project$Api$Provider$CcdaImport$ExtractionStatus$Unknown = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$CcdaImport$ExtractionStatus$fromString = function (s) {
	switch (s) {
		case 'extracted':
			return $author$project$Api$Provider$CcdaImport$ExtractionStatus$Extracted;
		case 'partial':
			return $author$project$Api$Provider$CcdaImport$ExtractionStatus$Partial;
		case 'failed':
			return $author$project$Api$Provider$CcdaImport$ExtractionStatus$Failed;
		default:
			var other = s;
			return $author$project$Api$Provider$CcdaImport$ExtractionStatus$Unknown(other);
	}
};
var $author$project$Api$Provider$CcdaImport$ExtractionStatus$decoder = A2($elm$json$Json$Decode$map, $author$project$Api$Provider$CcdaImport$ExtractionStatus$fromString, $elm$json$Json$Decode$string);
var $author$project$Api$Provider$CcdaImport$SyncStatus$AwaitingApproval = {$: 1};
var $author$project$Api$Provider$CcdaImport$SyncStatus$Declined = {$: 5};
var $author$project$Api$Provider$CcdaImport$SyncStatus$PartiallySynced = {$: 4};
var $author$project$Api$Provider$CcdaImport$SyncStatus$Pending = {$: 0};
var $author$project$Api$Provider$CcdaImport$SyncStatus$Synced = {$: 3};
var $author$project$Api$Provider$CcdaImport$SyncStatus$Syncing = {$: 2};
var $author$project$Api$Provider$CcdaImport$SyncStatus$Unknown = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$CcdaImport$SyncStatus$fromString = function (s) {
	switch (s) {
		case 'pending':
			return $author$project$Api$Provider$CcdaImport$SyncStatus$Pending;
		case 'awaiting_approval':
			return $author$project$Api$Provider$CcdaImport$SyncStatus$AwaitingApproval;
		case 'syncing':
			return $author$project$Api$Provider$CcdaImport$SyncStatus$Syncing;
		case 'synced':
			return $author$project$Api$Provider$CcdaImport$SyncStatus$Synced;
		case 'partially_synced':
			return $author$project$Api$Provider$CcdaImport$SyncStatus$PartiallySynced;
		case 'declined':
			return $author$project$Api$Provider$CcdaImport$SyncStatus$Declined;
		default:
			var other = s;
			return $author$project$Api$Provider$CcdaImport$SyncStatus$Unknown(other);
	}
};
var $author$project$Api$Provider$CcdaImport$SyncStatus$decoder = A2($elm$json$Json$Decode$map, $author$project$Api$Provider$CcdaImport$SyncStatus$fromString, $elm$json$Json$Decode$string);
var $author$project$Api$Provider$CcdaImport$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'patient',
	$author$project$Api$Provider$Patient$Min$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'sync_status',
		$author$project$Api$Provider$CcdaImport$SyncStatus$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'extraction_status',
			$author$project$Api$Provider$CcdaImport$ExtractionStatus$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$CcdaImport$Shared$Record)))));
var $author$project$Api$Provider$CcdaImport$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CcdaImport$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CcdaImport$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CcdaImport$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CcdaImport$importReportsPath = F2(
	function (ccdaId, base) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				['emr', 'file_imports', 'ccda', ccdaId, 'imports']),
			base);
	});
var $author$project$Api$Provider$CcdaImport$ExtractionStatus$toString = function (status) {
	switch (status.$) {
		case 0:
			return 'extracted';
		case 1:
			return 'partial';
		case 2:
			return 'failed';
		default:
			var other = status.a;
			return other;
	}
};
var $author$project$Api$Provider$CcdaImport$extractionStatusParam = function (maybeStatus) {
	if (!maybeStatus.$) {
		var s = maybeStatus.a;
		return _List_fromArray(
			[
				A2(
				$author$project$Api$Param$string,
				'extraction_status',
				$author$project$Api$Provider$CcdaImport$ExtractionStatus$toString(s))
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Api$Provider$CcdaImport$listDefaults = {HI: $elm$core$Maybe$Nothing, ajJ: $author$project$Api$Pagination$init, akl: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$CcdaImport$qParam = function (maybeQ) {
	if (!maybeQ.$) {
		var q = maybeQ.a;
		return _List_fromArray(
			[
				A2($author$project$Api$Param$string, 'q', q)
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Api$Provider$CcdaImport$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$CcdaImport$listDefaults);
	return _Utils_ap(
		$author$project$Api$Pagination$toApiParams(options.ajJ),
		_Utils_ap(
			$author$project$Api$Provider$CcdaImport$extractionStatusParam(options.HI),
			$author$project$Api$Provider$CcdaImport$qParam(options.akl)));
};
var $author$project$Api$Provider$CcdaImport$list = F4(
	function (apiClient, ccdaId, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$CcdaImport$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$CcdaImport$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Provider$CcdaImport$importReportsPath, ccdaId, $author$project$Api$Data$providerPath))));
	});
var $author$project$Pages$CcdaImports$CcdaId_String$Top$fetchReports = F5(
	function (ccdaId, pagination, filter, q, apiClient) {
		return A4(
			$author$project$Api$Provider$CcdaImport$list,
			apiClient,
			ccdaId,
			function (d) {
				return _Utils_update(
					d,
					{HI: filter, ajJ: pagination, akl: q});
			},
			$author$project$Pages$CcdaImports$CcdaId_String$Top$GotReports);
	});
var $author$project$Api$Provider$CcdaImport$Stats = F4(
	function (total, extracted, partial, failed) {
		return {ahb: extracted, ahe: failed, ajN: partial, al9: total};
	});
var $author$project$Api$Provider$CcdaImport$statsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'failed',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'partial',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'extracted',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'total',
				$elm$json$Json$Decode$int,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$CcdaImport$Stats)))));
var $author$project$Api$Provider$CcdaImport$stats = F3(
	function (apiClient, ccdaId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$CcdaImport$statsDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['stats']),
					A2($author$project$Api$Provider$CcdaImport$importReportsPath, ccdaId, $author$project$Api$Data$providerPath))));
	});
var $author$project$Pages$CcdaImports$CcdaId_String$Top$init = F4(
	function (_v0, _v1, shared, _v2) {
		var params = _v2.YL;
		var query = _v2.DE;
		var q = A2($elm$core$Dict$get, 'q', query);
		var pagination = $author$project$Api$Pagination$init;
		return _Utils_Tuple2(
			{
				Gv: shared.Gv,
				fF: $elm$core$Set$empty,
				afv: params.afv,
				bY: $elm$core$Dict$empty,
				nB: $elm$core$Set$empty,
				HM: $elm$core$Maybe$Nothing,
				ajJ: pagination,
				akl: q,
				ue: $author$project$Api$Data$Loading,
				up: $author$project$Ui$SearchInput$init(q),
				EL: $author$project$Api$Data$Loading,
				J7: shared.J7
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A5($author$project$Pages$CcdaImports$CcdaId_String$Top$fetchReports, params.afv, pagination, $elm$core$Maybe$Nothing, q, shared.Gv),
						A3($author$project$Api$Provider$CcdaImport$stats, shared.Gv, params.afv, $author$project$Pages$CcdaImports$CcdaId_String$Top$GotStats)
					])));
	});
var $author$project$Pages$CcdaImports$CcdaId_String$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$CcdaImports$CcdaId_String$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$CcdaImports$CcdaId_String$Top$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$CcdaImports$CcdaId_String$Top$GotApprove = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Pages$CcdaImports$CcdaId_String$Top$GotReport = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$CcdaImports$CcdaId_String$Top$SearchInputMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$CcdaImport$One$CcdaImport = $elm$core$Basics$identity;
var $author$project$Api$Provider$CcdaImport$Allergy$Allergy = F8(
	function (name, code, codeSystem, status, severity, startDate, endDate, reaction) {
		return {NN: code, afN: codeSystem, sb: endDate, Bq: name, akr: reaction, alr: severity, ab7: startDate, alH: status};
	});
var $author$project$Api$Provider$CcdaImport$Allergy$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'reaction',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'end_date',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'start_date',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'severity',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'status',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'code_system',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'code',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'name',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Api$Provider$CcdaImport$Allergy$Allergy)))))))));
var $author$project$Api$Provider$CcdaImport$Diagnosis$Diagnosis = F6(
	function (name, code, codeSystem, status, startDate, endDate) {
		return {NN: code, afN: codeSystem, sb: endDate, Bq: name, ab7: startDate, alH: status};
	});
var $author$project$Api$Provider$CcdaImport$Diagnosis$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'end_date',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'start_date',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'status',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'code_system',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'code',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'name',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$CcdaImport$Diagnosis$Diagnosis)))))));
var $author$project$Api$Provider$CcdaImport$Encounter$Encounter = F7(
	function (type_, code, codeSystem, date, performerName, performerNpi, locationName) {
		return {NN: code, afN: codeSystem, PB: date, ait: locationName, aj_: performerName, aj$: performerNpi, amg: type_};
	});
var $author$project$Api$Provider$CcdaImport$Encounter$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'location_name',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'performer_npi',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'performer_name',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'date',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'code_system',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'code',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'type',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							$elm$json$Json$Decode$succeed($author$project$Api$Provider$CcdaImport$Encounter$Encounter))))))));
var $author$project$Api$Provider$CcdaImport$FamilyHistory$FamilyHistory = function (relation) {
	return function (relationCode) {
		return function (relationGender) {
			return function (relationBirthYear) {
				return function (relationDeceased) {
					return function (conditionName) {
						return function (conditionCode) {
							return function (conditionCodeSystem) {
								return function (ageAtOnset) {
									return function (observedAt) {
										return {aeN: ageAtOnset, afS: conditionCode, afT: conditionCodeSystem, afU: conditionName, ai9: observedAt, akG: relation, akH: relationBirthYear, akI: relationCode, akJ: relationDeceased, akK: relationGender};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$CcdaImport$FamilyHistory$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'observed_at',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'age_at_onset',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'condition_code_system',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'condition_code',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'condition_name',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'relation_deceased',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'relation_birth_year',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'relation_gender',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'relation_code',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'relation',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Api$Provider$CcdaImport$FamilyHistory$FamilyHistory)))))))))));
var $author$project$Api$Provider$CcdaImport$Immunization$Immunization = F7(
	function (name, code, codeSystem, status, administeredAt, lotNumber, doseQuantity) {
		return {aeK: administeredAt, NN: code, afN: codeSystem, agD: doseQuantity, aiw: lotNumber, Bq: name, alH: status};
	});
var $author$project$Api$Provider$CcdaImport$Immunization$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'dose_quantity',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'lot_number',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'administered_at',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'status',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'code_system',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'code',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'name',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Api$Provider$CcdaImport$Immunization$Immunization))))))));
var $author$project$Api$Provider$CcdaImport$Lab$Lab = function (name) {
	return function (code) {
		return function (codeSystem) {
			return function (value) {
				return function (unit) {
					return function (referenceRangeLow) {
						return function (referenceRangeHigh) {
							return function (referenceRangeUnit) {
								return function (status) {
									return function (observedAt) {
										return function (panelName) {
											return function (panelCode) {
												return {NN: code, afN: codeSystem, Bq: name, ai9: observedAt, ajK: panelCode, ajL: panelName, akw: referenceRangeHigh, akx: referenceRangeLow, aky: referenceRangeUnit, alH: status, adL: unit, aee: value};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$CcdaImport$Lab$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'panel_code',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'panel_name',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'observed_at',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'status',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'reference_range_unit',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'reference_range_high',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'reference_range_low',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'unit',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'value',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'code_system',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'code',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'name',
												$elm$json$Json$Decode$string,
												$elm$json$Json$Decode$succeed($author$project$Api$Provider$CcdaImport$Lab$Lab)))))))))))));
var $author$project$Api$Provider$CcdaImport$Medication$Medication = F7(
	function (name, code, codeSystem, status, startDate, endDate, instructions) {
		return {NN: code, afN: codeSystem, sb: endDate, ah0: instructions, Bq: name, ab7: startDate, alH: status};
	});
var $author$project$Api$Provider$CcdaImport$Medication$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'instructions',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'end_date',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'start_date',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'status',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'code_system',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'code',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'name',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Api$Provider$CcdaImport$Medication$Medication))))))));
var $author$project$Api$Provider$CcdaImport$Outcome$Failed = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$CcdaImport$Outcome$Ignored = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$CcdaImport$Outcome$Parsed = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$CcdaImport$Outcome$PartiallyParsed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$CcdaImport$Outcome$UnknownOutcome = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$CcdaImport$Outcome$decoder = F2(
	function (valueDecoder, reasonFromString) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (kind) {
				switch (kind) {
					case 'Parsed':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$Api$Provider$CcdaImport$Outcome$Parsed,
							A2($elm$json$Json$Decode$field, 'value', valueDecoder));
					case 'PartiallyParsed':
						return A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'missing',
							$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
							_List_Nil,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'value',
								valueDecoder,
								$elm$json$Json$Decode$succeed(
									F2(
										function (v, m) {
											return $author$project$Api$Provider$CcdaImport$Outcome$PartiallyParsed(
												{aiM: m, aee: v});
										}))));
					case 'Ignored':
						return A2(
							$elm$json$Json$Decode$map,
							A2($elm$core$Basics$composeR, reasonFromString, $author$project$Api$Provider$CcdaImport$Outcome$Ignored),
							A2($elm$json$Json$Decode$field, 'reason', $elm$json$Json$Decode$string));
					case 'Failed':
						return A2(
							$elm$json$Json$Decode$map,
							A2($elm$core$Basics$composeR, reasonFromString, $author$project$Api$Provider$CcdaImport$Outcome$Failed),
							A2($elm$json$Json$Decode$field, 'reason', $elm$json$Json$Decode$string));
					default:
						var other = kind;
						return $elm$json$Json$Decode$succeed(
							$author$project$Api$Provider$CcdaImport$Outcome$UnknownOutcome(other));
				}
			},
			A2($elm$json$Json$Decode$field, 'kind', $elm$json$Json$Decode$string));
	});
var $author$project$Api$Provider$CcdaImport$Procedure$Procedure = F6(
	function (name, code, codeSystem, status, startDate, endDate) {
		return {NN: code, afN: codeSystem, sb: endDate, Bq: name, ab7: startDate, alH: status};
	});
var $author$project$Api$Provider$CcdaImport$Procedure$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'end_date',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'start_date',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'status',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'code_system',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'code',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'name',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$CcdaImport$Procedure$Procedure)))))));
var $author$project$Api$Provider$CcdaImport$SocialHistory$SocialHistory = F6(
	function (type_, typeCode, value, code, codeSystem, observedAt) {
		return {NN: code, afN: codeSystem, ai9: observedAt, amf: typeCode, amg: type_, aee: value};
	});
var $author$project$Api$Provider$CcdaImport$SocialHistory$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'observed_at',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'code_system',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'code',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'value',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'type_code',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'type',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$CcdaImport$SocialHistory$SocialHistory)))))));
var $author$project$Api$Provider$CcdaImport$Vital$Vital = F6(
	function (type_, typeCode, name, value, unit, measuredAt) {
		return {aiD: measuredAt, Bq: name, amf: typeCode, amg: type_, adL: unit, aee: value};
	});
var $author$project$Api$Provider$CcdaImport$Vital$decimalAsString = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			$elm$json$Json$Decode$string,
			A2($elm$json$Json$Decode$map, $elm$core$String$fromFloat, $elm$json$Json$Decode$float),
			A2($elm$json$Json$Decode$map, $elm$core$String$fromInt, $elm$json$Json$Decode$int)
		]));
var $author$project$Api$Provider$CcdaImport$Vital$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'measured_at',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'unit',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'value',
			$author$project$Api$Provider$CcdaImport$Vital$decimalAsString,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'type_code',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'type',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$CcdaImport$Vital$Vital)))))));
var $author$project$Api$Provider$CcdaImport$Allergy$MalformedActStructure = {$: 3};
var $author$project$Api$Provider$CcdaImport$Allergy$MalformedXml = {$: 5};
var $author$project$Api$Provider$CcdaImport$Allergy$MissingSubstance = {$: 2};
var $author$project$Api$Provider$CcdaImport$Allergy$NoKnownAllergies = {$: 0};
var $author$project$Api$Provider$CcdaImport$Allergy$NonAllergyActInSection = {$: 1};
var $author$project$Api$Provider$CcdaImport$Allergy$UnknownReason = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$CcdaImport$Allergy$UnrecognizedCodeSystemNoTextFallback = {$: 4};
var $author$project$Api$Provider$CcdaImport$Allergy$reasonFromString = function (s) {
	switch (s) {
		case 'no_known_allergies':
			return $author$project$Api$Provider$CcdaImport$Allergy$NoKnownAllergies;
		case 'non_allergy_act_in_section':
			return $author$project$Api$Provider$CcdaImport$Allergy$NonAllergyActInSection;
		case 'missing_substance':
			return $author$project$Api$Provider$CcdaImport$Allergy$MissingSubstance;
		case 'malformed_act_structure':
			return $author$project$Api$Provider$CcdaImport$Allergy$MalformedActStructure;
		case 'unrecognized_code_system_no_text_fallback':
			return $author$project$Api$Provider$CcdaImport$Allergy$UnrecognizedCodeSystemNoTextFallback;
		case 'malformed_xml':
			return $author$project$Api$Provider$CcdaImport$Allergy$MalformedXml;
		default:
			var other = s;
			return $author$project$Api$Provider$CcdaImport$Allergy$UnknownReason(other);
	}
};
var $author$project$Api$Provider$CcdaImport$Diagnosis$MalformedActStructure = {$: 3};
var $author$project$Api$Provider$CcdaImport$Diagnosis$MalformedXml = {$: 5};
var $author$project$Api$Provider$CcdaImport$Diagnosis$MissingProblemCode = {$: 2};
var $author$project$Api$Provider$CcdaImport$Diagnosis$NoKnownProblems = {$: 0};
var $author$project$Api$Provider$CcdaImport$Diagnosis$NonDiagnosisActInSection = {$: 1};
var $author$project$Api$Provider$CcdaImport$Diagnosis$UnknownReason = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$CcdaImport$Diagnosis$UnrecognizedCodeSystemNoTextFallback = {$: 4};
var $author$project$Api$Provider$CcdaImport$Diagnosis$reasonFromString = function (s) {
	switch (s) {
		case 'no_known_problems':
			return $author$project$Api$Provider$CcdaImport$Diagnosis$NoKnownProblems;
		case 'non_diagnosis_act_in_section':
			return $author$project$Api$Provider$CcdaImport$Diagnosis$NonDiagnosisActInSection;
		case 'missing_problem_code':
			return $author$project$Api$Provider$CcdaImport$Diagnosis$MissingProblemCode;
		case 'malformed_act_structure':
			return $author$project$Api$Provider$CcdaImport$Diagnosis$MalformedActStructure;
		case 'unrecognized_code_system_no_text_fallback':
			return $author$project$Api$Provider$CcdaImport$Diagnosis$UnrecognizedCodeSystemNoTextFallback;
		case 'malformed_xml':
			return $author$project$Api$Provider$CcdaImport$Diagnosis$MalformedXml;
		default:
			var other = s;
			return $author$project$Api$Provider$CcdaImport$Diagnosis$UnknownReason(other);
	}
};
var $author$project$Api$Provider$CcdaImport$Encounter$EmptyEncounter = {$: 1};
var $author$project$Api$Provider$CcdaImport$Encounter$NonEncounterEntryInSection = {$: 0};
var $author$project$Api$Provider$CcdaImport$Encounter$UnknownReason = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$CcdaImport$Encounter$reasonFromString = function (s) {
	switch (s) {
		case 'non_encounter_entry_in_section':
			return $author$project$Api$Provider$CcdaImport$Encounter$NonEncounterEntryInSection;
		case 'empty_encounter':
			return $author$project$Api$Provider$CcdaImport$Encounter$EmptyEncounter;
		default:
			var other = s;
			return $author$project$Api$Provider$CcdaImport$Encounter$UnknownReason(other);
	}
};
var $author$project$Api$Provider$CcdaImport$FamilyHistory$MalformedOrganizerStructure = {$: 2};
var $author$project$Api$Provider$CcdaImport$FamilyHistory$MalformedXml = {$: 4};
var $author$project$Api$Provider$CcdaImport$FamilyHistory$MissingConditionCode = {$: 0};
var $author$project$Api$Provider$CcdaImport$FamilyHistory$NonFamilyHistoryOrganizer = {$: 3};
var $author$project$Api$Provider$CcdaImport$FamilyHistory$UnknownReason = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$CcdaImport$FamilyHistory$UnrecognizedCodeSystemNoTextFallback = {$: 1};
var $author$project$Api$Provider$CcdaImport$FamilyHistory$reasonFromString = function (s) {
	switch (s) {
		case 'missing_condition_code':
			return $author$project$Api$Provider$CcdaImport$FamilyHistory$MissingConditionCode;
		case 'unrecognized_code_system_no_text_fallback':
			return $author$project$Api$Provider$CcdaImport$FamilyHistory$UnrecognizedCodeSystemNoTextFallback;
		case 'malformed_organizer_structure':
			return $author$project$Api$Provider$CcdaImport$FamilyHistory$MalformedOrganizerStructure;
		case 'non_family_history_organizer':
			return $author$project$Api$Provider$CcdaImport$FamilyHistory$NonFamilyHistoryOrganizer;
		case 'malformed_xml':
			return $author$project$Api$Provider$CcdaImport$FamilyHistory$MalformedXml;
		default:
			var other = s;
			return $author$project$Api$Provider$CcdaImport$FamilyHistory$UnknownReason(other);
	}
};
var $author$project$Api$Provider$CcdaImport$Immunization$MalformedSubstanceAdministration = {$: 2};
var $author$project$Api$Provider$CcdaImport$Immunization$MalformedXml = {$: 4};
var $author$project$Api$Provider$CcdaImport$Immunization$MissingVaccineCode = {$: 1};
var $author$project$Api$Provider$CcdaImport$Immunization$NonImmunizationEntryInSection = {$: 0};
var $author$project$Api$Provider$CcdaImport$Immunization$UnknownReason = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$CcdaImport$Immunization$UnrecognizedCodeSystemNoTextFallback = {$: 3};
var $author$project$Api$Provider$CcdaImport$Immunization$reasonFromString = function (s) {
	switch (s) {
		case 'non_immunization_entry_in_section':
			return $author$project$Api$Provider$CcdaImport$Immunization$NonImmunizationEntryInSection;
		case 'missing_vaccine_code':
			return $author$project$Api$Provider$CcdaImport$Immunization$MissingVaccineCode;
		case 'malformed_substance_administration':
			return $author$project$Api$Provider$CcdaImport$Immunization$MalformedSubstanceAdministration;
		case 'unrecognized_code_system_no_text_fallback':
			return $author$project$Api$Provider$CcdaImport$Immunization$UnrecognizedCodeSystemNoTextFallback;
		case 'malformed_xml':
			return $author$project$Api$Provider$CcdaImport$Immunization$MalformedXml;
		default:
			var other = s;
			return $author$project$Api$Provider$CcdaImport$Immunization$UnknownReason(other);
	}
};
var $author$project$Api$Provider$CcdaImport$Lab$MalformedXml = {$: 2};
var $author$project$Api$Provider$CcdaImport$Lab$MissingCode = {$: 1};
var $author$project$Api$Provider$CcdaImport$Lab$NonResultOrganizerInSection = {$: 0};
var $author$project$Api$Provider$CcdaImport$Lab$UnknownReason = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$CcdaImport$Lab$reasonFromString = function (s) {
	switch (s) {
		case 'non_result_organizer_in_section':
			return $author$project$Api$Provider$CcdaImport$Lab$NonResultOrganizerInSection;
		case 'missing_code':
			return $author$project$Api$Provider$CcdaImport$Lab$MissingCode;
		case 'malformed_xml':
			return $author$project$Api$Provider$CcdaImport$Lab$MalformedXml;
		default:
			var other = s;
			return $author$project$Api$Provider$CcdaImport$Lab$UnknownReason(other);
	}
};
var $author$project$Api$Provider$CcdaImport$Medication$MalformedSubstanceAdministration = {$: 2};
var $author$project$Api$Provider$CcdaImport$Medication$MalformedXml = {$: 4};
var $author$project$Api$Provider$CcdaImport$Medication$MissingSubstance = {$: 1};
var $author$project$Api$Provider$CcdaImport$Medication$NonMedicationEntryInSection = {$: 0};
var $author$project$Api$Provider$CcdaImport$Medication$UnknownReason = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$CcdaImport$Medication$UnrecognizedCodeSystemNoTextFallback = {$: 3};
var $author$project$Api$Provider$CcdaImport$Medication$reasonFromString = function (s) {
	switch (s) {
		case 'non_medication_entry_in_section':
			return $author$project$Api$Provider$CcdaImport$Medication$NonMedicationEntryInSection;
		case 'missing_substance':
			return $author$project$Api$Provider$CcdaImport$Medication$MissingSubstance;
		case 'malformed_substance_administration':
			return $author$project$Api$Provider$CcdaImport$Medication$MalformedSubstanceAdministration;
		case 'unrecognized_code_system_no_text_fallback':
			return $author$project$Api$Provider$CcdaImport$Medication$UnrecognizedCodeSystemNoTextFallback;
		case 'malformed_xml':
			return $author$project$Api$Provider$CcdaImport$Medication$MalformedXml;
		default:
			var other = s;
			return $author$project$Api$Provider$CcdaImport$Medication$UnknownReason(other);
	}
};
var $author$project$Api$Provider$CcdaImport$Procedure$MalformedProcedureStructure = {$: 2};
var $author$project$Api$Provider$CcdaImport$Procedure$MalformedXml = {$: 4};
var $author$project$Api$Provider$CcdaImport$Procedure$MissingProcedureCode = {$: 1};
var $author$project$Api$Provider$CcdaImport$Procedure$NonProcedureEntryInSection = {$: 0};
var $author$project$Api$Provider$CcdaImport$Procedure$UnknownReason = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$CcdaImport$Procedure$UnrecognizedCodeSystemNoTextFallback = {$: 3};
var $author$project$Api$Provider$CcdaImport$Procedure$reasonFromString = function (s) {
	switch (s) {
		case 'non_procedure_entry_in_section':
			return $author$project$Api$Provider$CcdaImport$Procedure$NonProcedureEntryInSection;
		case 'missing_procedure_code':
			return $author$project$Api$Provider$CcdaImport$Procedure$MissingProcedureCode;
		case 'malformed_procedure_structure':
			return $author$project$Api$Provider$CcdaImport$Procedure$MalformedProcedureStructure;
		case 'unrecognized_code_system_no_text_fallback':
			return $author$project$Api$Provider$CcdaImport$Procedure$UnrecognizedCodeSystemNoTextFallback;
		case 'malformed_xml':
			return $author$project$Api$Provider$CcdaImport$Procedure$MalformedXml;
		default:
			var other = s;
			return $author$project$Api$Provider$CcdaImport$Procedure$UnknownReason(other);
	}
};
var $author$project$Api$Provider$CcdaImport$SocialHistory$MalformedObservationStructure = {$: 1};
var $author$project$Api$Provider$CcdaImport$SocialHistory$MalformedXml = {$: 3};
var $author$project$Api$Provider$CcdaImport$SocialHistory$MissingValue = {$: 0};
var $author$project$Api$Provider$CcdaImport$SocialHistory$UnknownReason = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$CcdaImport$SocialHistory$UnrecognizedCodeSystemNoTextFallback = {$: 2};
var $author$project$Api$Provider$CcdaImport$SocialHistory$reasonFromString = function (s) {
	switch (s) {
		case 'missing_value':
			return $author$project$Api$Provider$CcdaImport$SocialHistory$MissingValue;
		case 'malformed_observation_structure':
			return $author$project$Api$Provider$CcdaImport$SocialHistory$MalformedObservationStructure;
		case 'unrecognized_code_system_no_text_fallback':
			return $author$project$Api$Provider$CcdaImport$SocialHistory$UnrecognizedCodeSystemNoTextFallback;
		case 'malformed_xml':
			return $author$project$Api$Provider$CcdaImport$SocialHistory$MalformedXml;
		default:
			var other = s;
			return $author$project$Api$Provider$CcdaImport$SocialHistory$UnknownReason(other);
	}
};
var $author$project$Api$Provider$CcdaImport$Vital$MalformedXml = {$: 4};
var $author$project$Api$Provider$CcdaImport$Vital$MissingValue = {$: 2};
var $author$project$Api$Provider$CcdaImport$Vital$MissingVitalCode = {$: 1};
var $author$project$Api$Provider$CcdaImport$Vital$NonVitalObservationInSection = {$: 0};
var $author$project$Api$Provider$CcdaImport$Vital$UnknownReason = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$CcdaImport$Vital$UnparseableValue = {$: 3};
var $author$project$Api$Provider$CcdaImport$Vital$reasonFromString = function (s) {
	switch (s) {
		case 'non_vital_observation_in_section':
			return $author$project$Api$Provider$CcdaImport$Vital$NonVitalObservationInSection;
		case 'missing_vital_code':
			return $author$project$Api$Provider$CcdaImport$Vital$MissingVitalCode;
		case 'missing_value':
			return $author$project$Api$Provider$CcdaImport$Vital$MissingValue;
		case 'unparseable_value':
			return $author$project$Api$Provider$CcdaImport$Vital$UnparseableValue;
		case 'malformed_xml':
			return $author$project$Api$Provider$CcdaImport$Vital$MalformedXml;
		default:
			var other = s;
			return $author$project$Api$Provider$CcdaImport$Vital$UnknownReason(other);
	}
};
var $author$project$Api$Provider$CcdaImport$One$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'outcomes',
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$field,
				'labs',
				$elm$json$Json$Decode$list(
					A2($author$project$Api$Provider$CcdaImport$Outcome$decoder, $author$project$Api$Provider$CcdaImport$Lab$decoder, $author$project$Api$Provider$CcdaImport$Lab$reasonFromString))),
				$elm$json$Json$Decode$succeed(_List_Nil)
			])),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'outcomes',
		A2(
			$elm$json$Json$Decode$field,
			'vitals',
			$elm$json$Json$Decode$list(
				A2($author$project$Api$Provider$CcdaImport$Outcome$decoder, $author$project$Api$Provider$CcdaImport$Vital$decoder, $author$project$Api$Provider$CcdaImport$Vital$reasonFromString))),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'outcomes',
			A2(
				$elm$json$Json$Decode$field,
				'encounters',
				$elm$json$Json$Decode$list(
					A2($author$project$Api$Provider$CcdaImport$Outcome$decoder, $author$project$Api$Provider$CcdaImport$Encounter$decoder, $author$project$Api$Provider$CcdaImport$Encounter$reasonFromString))),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'outcomes',
				A2(
					$elm$json$Json$Decode$field,
					'family_histories',
					$elm$json$Json$Decode$list(
						A2($author$project$Api$Provider$CcdaImport$Outcome$decoder, $author$project$Api$Provider$CcdaImport$FamilyHistory$decoder, $author$project$Api$Provider$CcdaImport$FamilyHistory$reasonFromString))),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'outcomes',
					A2(
						$elm$json$Json$Decode$field,
						'social_histories',
						$elm$json$Json$Decode$list(
							A2($author$project$Api$Provider$CcdaImport$Outcome$decoder, $author$project$Api$Provider$CcdaImport$SocialHistory$decoder, $author$project$Api$Provider$CcdaImport$SocialHistory$reasonFromString))),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'outcomes',
						A2(
							$elm$json$Json$Decode$field,
							'immunizations',
							$elm$json$Json$Decode$list(
								A2($author$project$Api$Provider$CcdaImport$Outcome$decoder, $author$project$Api$Provider$CcdaImport$Immunization$decoder, $author$project$Api$Provider$CcdaImport$Immunization$reasonFromString))),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'outcomes',
							A2(
								$elm$json$Json$Decode$field,
								'procedures',
								$elm$json$Json$Decode$list(
									A2($author$project$Api$Provider$CcdaImport$Outcome$decoder, $author$project$Api$Provider$CcdaImport$Procedure$decoder, $author$project$Api$Provider$CcdaImport$Procedure$reasonFromString))),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'outcomes',
								A2(
									$elm$json$Json$Decode$field,
									'diagnoses',
									$elm$json$Json$Decode$list(
										A2($author$project$Api$Provider$CcdaImport$Outcome$decoder, $author$project$Api$Provider$CcdaImport$Diagnosis$decoder, $author$project$Api$Provider$CcdaImport$Diagnosis$reasonFromString))),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'outcomes',
									A2(
										$elm$json$Json$Decode$field,
										'medications',
										$elm$json$Json$Decode$list(
											A2($author$project$Api$Provider$CcdaImport$Outcome$decoder, $author$project$Api$Provider$CcdaImport$Medication$decoder, $author$project$Api$Provider$CcdaImport$Medication$reasonFromString))),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'outcomes',
										A2(
											$elm$json$Json$Decode$field,
											'allergies',
											$elm$json$Json$Decode$list(
												A2($author$project$Api$Provider$CcdaImport$Outcome$decoder, $author$project$Api$Provider$CcdaImport$Allergy$decoder, $author$project$Api$Provider$CcdaImport$Allergy$reasonFromString))),
										A2(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
											$author$project$Api$Provider$CcdaImport$Shared$decoder,
											$elm$json$Json$Decode$succeed(
												function (s) {
													return function (a) {
														return function (m) {
															return function (d) {
																return function (p) {
																	return function (i) {
																		return function (sh) {
																			return function (fh) {
																				return function (e) {
																					return function (v) {
																						return function (l) {
																							return {Lt: a, QA: d, Rp: e, R7: fh, TR: i, VA: l, WK: m, _o: p, lk: s, abJ: sh, aek: v};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												}))))))))))));
var $author$project$Api$Provider$CcdaImport$approve = F4(
	function (apiClient, ccdaId, reportId, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CcdaImport$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						[reportId, 'approve']),
					A2($author$project$Api$Provider$CcdaImport$importReportsPath, ccdaId, $author$project$Api$Data$providerPath))));
	});
var $author$project$Pages$CcdaImports$CcdaId_String$Top$buildUrl = function (model) {
	return A2(
		$elm$url$Url$Builder$relative,
		_List_fromArray(
			[
				$author$project$Spa$Generated$Route$toString(
				$author$project$Spa$Generated$Route$CcdaImports__CcdaId_String__Top(
					{afv: model.afv}))
			]),
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$map,
					$elm$url$Url$Builder$string('q'),
					model.akl)
				])));
};
var $author$project$Api$Provider$CcdaImport$retrieve = F4(
	function (apiClient, ccdaId, reportId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$CcdaImport$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						[reportId]),
					A2($author$project$Api$Provider$CcdaImport$importReportsPath, ccdaId, $author$project$Api$Data$providerPath))));
	});
var $author$project$Pages$CcdaImports$CcdaId_String$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ),
								ue: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ue: response}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 1:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{EL: response}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bY: $elm$core$Dict$empty, nB: $elm$core$Set$empty, ajJ: pagination, ue: $author$project$Api$Data$Loading}),
					A5($author$project$Pages$CcdaImports$CcdaId_String$Top$fetchReports, model.afv, pagination, model.HM, model.akl, model.Gv),
					_List_Nil);
			case 5:
				var newFilter = msg.a;
				var pagination = $author$project$Api$Pagination$init;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bY: $elm$core$Dict$empty, nB: $elm$core$Set$empty, HM: newFilter, ajJ: pagination, ue: $author$project$Api$Data$Loading}),
					A5($author$project$Pages$CcdaImports$CcdaId_String$Top$fetchReports, model.afv, pagination, newFilter, model.akl, model.Gv),
					_List_Nil);
			case 6:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Ui$SearchInput$update, subMsg, model.up);
				var searchInput = _v2.a;
				var searchInputCmd = _v2.b;
				var event = _v2.c;
				if (event.$ === 1) {
					var q = event.a;
					var pagination = $author$project$Api$Pagination$init;
					var newModel = _Utils_update(
						model,
						{bY: $elm$core$Dict$empty, nB: $elm$core$Set$empty, ajJ: pagination, akl: q, ue: $author$project$Api$Data$Loading, up: searchInput});
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$CcdaImports$CcdaId_String$Top$SearchInputMsg, searchInputCmd),
									A5($author$project$Pages$CcdaImports$CcdaId_String$Top$fetchReports, model.afv, pagination, model.HM, q, model.Gv),
									$author$project$Ports$Navigation$replaceUrl(
									$author$project$Pages$CcdaImports$CcdaId_String$Top$buildUrl(newModel))
								])),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{up: searchInput}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$CcdaImports$CcdaId_String$Top$SearchInputMsg, searchInputCmd),
						_List_Nil);
				}
			case 3:
				var reportId = msg.a;
				if (A2($elm$core$Set$member, reportId, model.nB)) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								nB: A2($elm$core$Set$remove, reportId, model.nB)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					var needsFetch = function () {
						var _v4 = A2($elm$core$Dict$get, reportId, model.bY);
						_v4$2:
						while (true) {
							if (!_v4.$) {
								switch (_v4.a.$) {
									case 3:
										var _v5 = _v4.a;
										return false;
									case 1:
										var _v6 = _v4.a;
										return false;
									default:
										break _v4$2;
								}
							} else {
								break _v4$2;
							}
						}
						return true;
					}();
					var nextDetails = needsFetch ? A3($elm$core$Dict$insert, reportId, $author$project$Api$Data$Loading, model.bY) : model.bY;
					var fetchCmd = needsFetch ? A4(
						$author$project$Api$Provider$CcdaImport$retrieve,
						model.Gv,
						model.afv,
						reportId,
						$author$project$Pages$CcdaImports$CcdaId_String$Top$GotReport(reportId)) : $elm$core$Platform$Cmd$none;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bY: nextDetails,
								nB: A2($elm$core$Set$insert, reportId, model.nB)
							}),
						fetchCmd,
						_List_Nil);
				}
			case 4:
				var reportId = msg.a;
				var response = msg.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bY: A3($elm$core$Dict$insert, reportId, response, model.bY)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 7:
				var reportId = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							fF: A2($elm$core$Set$insert, reportId, model.fF)
						}),
					A4(
						$author$project$Api$Provider$CcdaImport$approve,
						model.Gv,
						model.afv,
						reportId,
						$author$project$Pages$CcdaImports$CcdaId_String$Top$GotApprove(reportId)),
					_List_Nil);
			default:
				var reportId = msg.a;
				var response = msg.b;
				var approving = A2($elm$core$Set$remove, reportId, model.fF);
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{fF: approving}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A5($author$project$Pages$CcdaImports$CcdaId_String$Top$fetchReports, model.afv, model.ajJ, model.HM, model.akl, model.Gv),
									A4(
									$author$project$Api$Provider$CcdaImport$retrieve,
									model.Gv,
									model.afv,
									reportId,
									$author$project$Pages$CcdaImports$CcdaId_String$Top$GotReport(reportId))
								])),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{fF: approving}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$CcdaImports$CcdaId_String$Top$PaginationMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$CcdaImports$CcdaId_String$Top$SetFilter = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$CcdaImports$CcdaId_String$Top$statButton = F4(
	function (model, tileFilter, label, count) {
		return A3(
			$author$project$Ui$Button$view,
			{mm: label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(model.HM, tileFilter)),
					$author$project$Ui$Button$onClick(
					$author$project$Pages$CcdaImports$CcdaId_String$Top$SetFilter(tileFilter))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					label + (': ' + $elm$core$String$fromInt(count)))
				]));
	});
var $author$project$Pages$CcdaImports$CcdaId_String$Top$viewStatButtons = function (model) {
	var _v0 = model.EL;
	if (_v0.$ === 3) {
		var s = _v0.a;
		return $author$project$Ui$Button$group(
			_List_fromArray(
				[
					A4($author$project$Pages$CcdaImports$CcdaId_String$Top$statButton, model, $elm$core$Maybe$Nothing, 'All', s.al9),
					A4(
					$author$project$Pages$CcdaImports$CcdaId_String$Top$statButton,
					model,
					$elm$core$Maybe$Just($author$project$Api$Provider$CcdaImport$ExtractionStatus$Extracted),
					'Extracted',
					s.ahb),
					A4(
					$author$project$Pages$CcdaImports$CcdaId_String$Top$statButton,
					model,
					$elm$core$Maybe$Just($author$project$Api$Provider$CcdaImport$ExtractionStatus$Partial),
					'Partial',
					s.ajN),
					A4(
					$author$project$Pages$CcdaImports$CcdaId_String$Top$statButton,
					model,
					$elm$core$Maybe$Just($author$project$Api$Provider$CcdaImport$ExtractionStatus$Failed),
					'Failed',
					s.ahe)
				]));
	} else {
		return $author$project$Ui$Skeleton$text(
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$span(2)
				]));
	}
};
var $author$project$Pages$CcdaImports$CcdaId_String$Top$viewControls = function (model) {
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap2]),
						_List_fromArray(
							[
								$author$project$Pages$CcdaImports$CcdaId_String$Top$viewStatButtons(model),
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$fullWidth]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Pages$CcdaImports$CcdaId_String$Top$SearchInputMsg,
										A2(
											$author$project$Ui$SearchInput$view,
											_List_fromArray(
												[
													$author$project$Ui$SearchInput$placeholder('Search by patient')
												]),
											model.up))
									]))
							]))
					]))
			]));
};
var $author$project$Pages$CcdaImports$CcdaId_String$Top$ToggleExpand = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Panel$Collapsed = function (a) {
	return {$: 6, a: a};
};
var $author$project$Ui$Panel$collapsed = $author$project$Ui$Panel$Collapsed;
var $author$project$Api$Provider$CcdaImport$Shared$extractionStatus = function (_v0) {
	var r = _v0;
	return r.HI;
};
var $author$project$Api$Provider$CcdaImport$All$extractionStatus = function (_v0) {
	var s = _v0;
	return $author$project$Api$Provider$CcdaImport$Shared$extractionStatus(s);
};
var $author$project$Api$Provider$CcdaImport$Shared$id = function (_v0) {
	var r = _v0;
	return r.ahP;
};
var $author$project$Api$Provider$CcdaImport$All$id = function (_v0) {
	var s = _v0;
	return $author$project$Api$Provider$CcdaImport$Shared$id(s);
};
var $author$project$Api$Provider$CcdaImport$Shared$patient = function (_v0) {
	var r = _v0;
	return r.YY;
};
var $author$project$Api$Provider$CcdaImport$All$patient = function (_v0) {
	var s = _v0;
	return $author$project$Api$Provider$CcdaImport$Shared$patient(s);
};
var $author$project$Api$Provider$CcdaImport$Shared$syncStatus = function (_v0) {
	var r = _v0;
	return r.acL;
};
var $author$project$Api$Provider$CcdaImport$All$syncStatus = function (_v0) {
	var s = _v0;
	return $author$project$Api$Provider$CcdaImport$Shared$syncStatus(s);
};
var $author$project$Pages$CcdaImports$CcdaId_String$Top$ApproveClicked = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$CcdaImport$SyncStatus$isAwaitingApproval = function (status) {
	if (status.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Pages$CcdaImports$CcdaId_String$Top$viewApproveButton = F3(
	function (model, reportId, status) {
		if ($author$project$Api$Provider$CcdaImport$SyncStatus$isAwaitingApproval(status)) {
			var isApproving = A2($elm$core$Set$member, reportId, model.fF);
			return A3(
				$author$project$Ui$Button$view,
				{mm: 'Approve and sync'},
				_List_fromArray(
					[
						$author$project$Ui$Button$onClick(
						$author$project$Pages$CcdaImports$CcdaId_String$Top$ApproveClicked(reportId)),
						$author$project$Ui$Button$disabled(isApproving),
						$author$project$Ui$Button$primary,
						$author$project$Ui$Button$sm
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						isApproving ? 'Approving…' : 'Approve and sync')
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Api$Provider$CcdaImport$One$allergies = function (_v0) {
	var r = _v0;
	return r.Lt;
};
var $author$project$Api$Provider$CcdaImport$One$diagnoses = function (_v0) {
	var r = _v0;
	return r.QA;
};
var $author$project$Api$Provider$CcdaImport$One$encounters = function (_v0) {
	var r = _v0;
	return r.Rp;
};
var $author$project$Api$Provider$CcdaImport$One$familyHistories = function (_v0) {
	var r = _v0;
	return r.R7;
};
var $author$project$Api$Provider$CcdaImport$Allergy$humanizeReason = function (reason) {
	switch (reason.$) {
		case 0:
			return 'No known allergies';
		case 1:
			return 'Non-allergy entry in section';
		case 2:
			return 'Missing substance code';
		case 3:
			return 'Malformed entry structure';
		case 4:
			return 'Unrecognized code system, no fallback text';
		case 5:
			return 'Malformed XML';
		default:
			var other = reason.a;
			return other;
	}
};
var $author$project$Api$Provider$CcdaImport$Diagnosis$humanizeReason = function (reason) {
	switch (reason.$) {
		case 0:
			return 'No known problems';
		case 1:
			return 'Non-diagnosis entry in section';
		case 2:
			return 'Missing problem code';
		case 3:
			return 'Malformed entry structure';
		case 4:
			return 'Unrecognized code system, no fallback text';
		case 5:
			return 'Malformed XML';
		default:
			var other = reason.a;
			return other;
	}
};
var $author$project$Api$Provider$CcdaImport$Encounter$humanizeReason = function (reason) {
	switch (reason.$) {
		case 0:
			return 'Non-encounter entry in section';
		case 1:
			return 'Empty encounter';
		default:
			var other = reason.a;
			return other;
	}
};
var $author$project$Api$Provider$CcdaImport$FamilyHistory$humanizeReason = function (reason) {
	switch (reason.$) {
		case 0:
			return 'Missing condition code';
		case 1:
			return 'Unrecognized code system, no fallback text';
		case 2:
			return 'Malformed organizer structure';
		case 3:
			return 'Non family-history organizer';
		case 4:
			return 'Malformed XML';
		default:
			var other = reason.a;
			return other;
	}
};
var $author$project$Api$Provider$CcdaImport$Immunization$humanizeReason = function (reason) {
	switch (reason.$) {
		case 0:
			return 'Non-immunization entry in section';
		case 1:
			return 'Missing vaccine code';
		case 2:
			return 'Malformed entry structure';
		case 3:
			return 'Unrecognized code system, no fallback text';
		case 4:
			return 'Malformed XML';
		default:
			var other = reason.a;
			return other;
	}
};
var $author$project$Api$Provider$CcdaImport$Lab$humanizeReason = function (reason) {
	switch (reason.$) {
		case 0:
			return 'Non-result organizer in section';
		case 1:
			return 'Missing test code';
		case 2:
			return 'Malformed XML';
		default:
			var other = reason.a;
			return other;
	}
};
var $author$project$Api$Provider$CcdaImport$Medication$humanizeReason = function (reason) {
	switch (reason.$) {
		case 0:
			return 'Non-medication entry in section';
		case 1:
			return 'Missing substance code';
		case 2:
			return 'Malformed entry structure';
		case 3:
			return 'Unrecognized code system, no fallback text';
		case 4:
			return 'Malformed XML';
		default:
			var other = reason.a;
			return other;
	}
};
var $author$project$Api$Provider$CcdaImport$Procedure$humanizeReason = function (reason) {
	switch (reason.$) {
		case 0:
			return 'Non-procedure entry in section';
		case 1:
			return 'Missing procedure code';
		case 2:
			return 'Malformed entry structure';
		case 3:
			return 'Unrecognized code system, no fallback text';
		case 4:
			return 'Malformed XML';
		default:
			var other = reason.a;
			return other;
	}
};
var $author$project$Api$Provider$CcdaImport$SocialHistory$humanizeReason = function (reason) {
	switch (reason.$) {
		case 0:
			return 'Missing value';
		case 1:
			return 'Malformed entry structure';
		case 2:
			return 'Unrecognized code system, no fallback text';
		case 3:
			return 'Malformed XML';
		default:
			var other = reason.a;
			return other;
	}
};
var $author$project$Api$Provider$CcdaImport$Vital$humanizeReason = function (reason) {
	switch (reason.$) {
		case 0:
			return 'Non-vital observation in section';
		case 1:
			return 'Missing vital code';
		case 2:
			return 'Missing value';
		case 3:
			return 'Unparseable value';
		case 4:
			return 'Malformed XML';
		default:
			var other = reason.a;
			return other;
	}
};
var $author$project$Api$Provider$CcdaImport$One$immunizations = function (_v0) {
	var r = _v0;
	return r.TR;
};
var $author$project$Api$Provider$CcdaImport$Allergy$isSentinelEmpty = function (reason) {
	return _Utils_eq(reason, $author$project$Api$Provider$CcdaImport$Allergy$NoKnownAllergies);
};
var $author$project$Api$Provider$CcdaImport$Diagnosis$isSentinelEmpty = function (reason) {
	return _Utils_eq(reason, $author$project$Api$Provider$CcdaImport$Diagnosis$NoKnownProblems);
};
var $author$project$Api$Provider$CcdaImport$Encounter$isSentinelEmpty = function (_v0) {
	return false;
};
var $author$project$Api$Provider$CcdaImport$FamilyHistory$isSentinelEmpty = function (_v0) {
	return false;
};
var $author$project$Api$Provider$CcdaImport$Immunization$isSentinelEmpty = function (_v0) {
	return false;
};
var $author$project$Api$Provider$CcdaImport$Lab$isSentinelEmpty = function (_v0) {
	return false;
};
var $author$project$Api$Provider$CcdaImport$Medication$isSentinelEmpty = function (_v0) {
	return false;
};
var $author$project$Api$Provider$CcdaImport$Procedure$isSentinelEmpty = function (_v0) {
	return false;
};
var $author$project$Api$Provider$CcdaImport$SocialHistory$isSentinelEmpty = function (_v0) {
	return false;
};
var $author$project$Api$Provider$CcdaImport$Vital$isSentinelEmpty = function (_v0) {
	return false;
};
var $author$project$Api$Provider$CcdaImport$One$labs = function (_v0) {
	var r = _v0;
	return r.VA;
};
var $author$project$Api$Provider$CcdaImport$One$medications = function (_v0) {
	var r = _v0;
	return r.WK;
};
var $author$project$Api$Provider$CcdaImport$One$procedures = function (_v0) {
	var r = _v0;
	return r._o;
};
var $author$project$Api$Provider$CcdaImport$One$socialHistories = function (_v0) {
	var r = _v0;
	return r.abJ;
};
var $author$project$Pages$CcdaImports$CcdaId_String$Top$viewValue = function (fields) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('value-row')
			]),
		A2(
			$elm$core$List$filterMap,
			function (_v0) {
				var label = _v0.a;
				var maybeValue = _v0.b;
				return A2(
					$elm$core$Maybe$map,
					function (v) {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('value-field')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$muted]),
									label + ': '),
									$elm$html$Html$text(v)
								]));
					},
					maybeValue);
			},
			fields));
};
var $author$project$Pages$CcdaImports$CcdaId_String$Top$viewAllergy = function (a) {
	return $author$project$Pages$CcdaImports$CcdaId_String$Top$viewValue(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$core$Maybe$Just(a.Bq)),
				_Utils_Tuple2('code', a.NN),
				_Utils_Tuple2('system', a.afN),
				_Utils_Tuple2(
				'status',
				$elm$core$Maybe$Just(a.alH)),
				_Utils_Tuple2('severity', a.alr),
				_Utils_Tuple2('from', a.ab7),
				_Utils_Tuple2('to', a.sb),
				_Utils_Tuple2('reaction', a.akr)
			]));
};
var $author$project$Pages$CcdaImports$CcdaId_String$Top$viewDiagnosis = function (d) {
	return $author$project$Pages$CcdaImports$CcdaId_String$Top$viewValue(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$core$Maybe$Just(d.Bq)),
				_Utils_Tuple2('code', d.NN),
				_Utils_Tuple2('system', d.afN),
				_Utils_Tuple2(
				'status',
				$elm$core$Maybe$Just(d.alH)),
				_Utils_Tuple2('from', d.ab7),
				_Utils_Tuple2('to', d.sb)
			]));
};
var $author$project$Pages$CcdaImports$CcdaId_String$Top$viewEncounter = function (e) {
	return $author$project$Pages$CcdaImports$CcdaId_String$Top$viewValue(
		_List_fromArray(
			[
				_Utils_Tuple2('type', e.amg),
				_Utils_Tuple2('code', e.NN),
				_Utils_Tuple2('system', e.afN),
				_Utils_Tuple2('date', e.PB),
				_Utils_Tuple2('performer', e.aj_),
				_Utils_Tuple2('npi', e.aj$),
				_Utils_Tuple2('location', e.ait)
			]));
};
var $author$project$Pages$CcdaImports$CcdaId_String$Top$boolLabel = function (b) {
	return b ? 'yes' : 'no';
};
var $author$project$Pages$CcdaImports$CcdaId_String$Top$viewFamilyHistory = function (fh) {
	return $author$project$Pages$CcdaImports$CcdaId_String$Top$viewValue(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'relation',
				$elm$core$Maybe$Just(fh.akG + (' [' + (fh.akI + ']')))),
				_Utils_Tuple2('gender', fh.akK),
				_Utils_Tuple2(
				'birth year',
				A2($elm$core$Maybe$map, $elm$core$String$fromInt, fh.akH)),
				_Utils_Tuple2(
				'deceased',
				A2($elm$core$Maybe$map, $author$project$Pages$CcdaImports$CcdaId_String$Top$boolLabel, fh.akJ)),
				_Utils_Tuple2('condition', fh.afU),
				_Utils_Tuple2('code', fh.afS),
				_Utils_Tuple2('system', fh.afT),
				_Utils_Tuple2(
				'age at onset',
				A2($elm$core$Maybe$map, $elm$core$String$fromInt, fh.aeN)),
				_Utils_Tuple2('observed', fh.ai9)
			]));
};
var $author$project$Pages$CcdaImports$CcdaId_String$Top$viewImmunization = function (i) {
	return $author$project$Pages$CcdaImports$CcdaId_String$Top$viewValue(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$core$Maybe$Just(i.Bq)),
				_Utils_Tuple2('code', i.NN),
				_Utils_Tuple2('system', i.afN),
				_Utils_Tuple2(
				'status',
				$elm$core$Maybe$Just(i.alH)),
				_Utils_Tuple2('administered', i.aeK),
				_Utils_Tuple2('lot', i.aiw),
				_Utils_Tuple2('dose', i.agD)
			]));
};
var $author$project$Pages$CcdaImports$CcdaId_String$Top$labRange = function (l) {
	var _v0 = _Utils_Tuple2(l.akx, l.akw);
	if ((_v0.a.$ === 1) && (_v0.b.$ === 1)) {
		var _v1 = _v0.a;
		var _v2 = _v0.b;
		return $elm$core$Maybe$Nothing;
	} else {
		var low = _v0.a;
		var high = _v0.b;
		return $elm$core$Maybe$Just(
			A2($elm$core$Maybe$withDefault, '', low) + ('–' + (A2($elm$core$Maybe$withDefault, '', high) + A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function (u) {
						return ' ' + u;
					},
					l.aky)))));
	}
};
var $author$project$Pages$CcdaImports$CcdaId_String$Top$labResult = function (l) {
	return A2(
		$elm$core$Maybe$map,
		function (v) {
			return _Utils_ap(
				v,
				A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						function (u) {
							return ' ' + u;
						},
						l.adL)));
		},
		l.aee);
};
var $author$project$Pages$CcdaImports$CcdaId_String$Top$viewLab = function (l) {
	return $author$project$Pages$CcdaImports$CcdaId_String$Top$viewValue(
		_List_fromArray(
			[
				_Utils_Tuple2('panel', l.ajL),
				_Utils_Tuple2(
				'test',
				$elm$core$Maybe$Just(l.Bq)),
				_Utils_Tuple2('code', l.NN),
				_Utils_Tuple2('system', l.afN),
				_Utils_Tuple2(
				'result',
				$author$project$Pages$CcdaImports$CcdaId_String$Top$labResult(l)),
				_Utils_Tuple2(
				'range',
				$author$project$Pages$CcdaImports$CcdaId_String$Top$labRange(l)),
				_Utils_Tuple2(
				'status',
				$elm$core$Maybe$Just(l.alH)),
				_Utils_Tuple2('observed', l.ai9)
			]));
};
var $author$project$Pages$CcdaImports$CcdaId_String$Top$viewMedication = function (m) {
	return $author$project$Pages$CcdaImports$CcdaId_String$Top$viewValue(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$core$Maybe$Just(m.Bq)),
				_Utils_Tuple2('code', m.NN),
				_Utils_Tuple2('system', m.afN),
				_Utils_Tuple2(
				'status',
				$elm$core$Maybe$Just(m.alH)),
				_Utils_Tuple2('from', m.ab7),
				_Utils_Tuple2('to', m.sb),
				_Utils_Tuple2('instructions', m.ah0)
			]));
};
var $author$project$Pages$CcdaImports$CcdaId_String$Top$viewProcedure = function (p) {
	return $author$project$Pages$CcdaImports$CcdaId_String$Top$viewValue(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$core$Maybe$Just(p.Bq)),
				_Utils_Tuple2('code', p.NN),
				_Utils_Tuple2('system', p.afN),
				_Utils_Tuple2(
				'status',
				$elm$core$Maybe$Just(p.alH)),
				_Utils_Tuple2('from', p.ab7),
				_Utils_Tuple2('to', p.sb)
			]));
};
var $author$project$Pages$CcdaImports$CcdaId_String$Top$isSentinelOnly = F2(
	function (isSentinel, outcome) {
		if (outcome.$ === 2) {
			var r = outcome.a;
			return isSentinel(r);
		} else {
			return false;
		}
	});
var $author$project$Api$Provider$CcdaImport$ExtractionStatus$label = function (status) {
	switch (status.$) {
		case 0:
			return 'Extracted';
		case 1:
			return 'Partial';
		case 2:
			return 'Failed';
		default:
			var other = status.a;
			return other;
	}
};
var $author$project$Ui$Badge$Neutral = 5;
var $author$project$Ui$Badge$neutral = $author$project$Ui$Badge$Color(5);
var $author$project$Pages$CcdaImports$CcdaId_String$Top$viewExtractionBadge = function (status) {
	var opt = function () {
		switch (status.$) {
			case 0:
				return $author$project$Ui$Badge$success;
			case 1:
				return $author$project$Ui$Badge$warning;
			case 2:
				return $author$project$Ui$Badge$danger;
			default:
				return $author$project$Ui$Badge$neutral;
		}
	}();
	return A2(
		$author$project$Ui$Badge$view,
		_List_fromArray(
			[opt]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Api$Provider$CcdaImport$ExtractionStatus$label(status))
			]));
};
var $author$project$Pages$CcdaImports$CcdaId_String$Top$maybeStatusBadge = function (status) {
	if (!status.$) {
		return $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Just(
			$author$project$Pages$CcdaImports$CcdaId_String$Top$viewExtractionBadge(status));
	}
};
var $author$project$Pages$CcdaImports$CcdaId_String$Top$isFailedOutcome = function (outcome) {
	if (outcome.$ === 3) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Pages$CcdaImports$CcdaId_String$Top$isPartialOutcome = function (outcome) {
	switch (outcome.$) {
		case 1:
			return true;
		case 2:
			return true;
		default:
			return false;
	}
};
var $author$project$Pages$CcdaImports$CcdaId_String$Top$sectionStatus = function (outcomes) {
	return A2($elm$core$List$any, $author$project$Pages$CcdaImports$CcdaId_String$Top$isFailedOutcome, outcomes) ? $author$project$Api$Provider$CcdaImport$ExtractionStatus$Failed : (A2($elm$core$List$any, $author$project$Pages$CcdaImports$CcdaId_String$Top$isPartialOutcome, outcomes) ? $author$project$Api$Provider$CcdaImport$ExtractionStatus$Partial : $author$project$Api$Provider$CcdaImport$ExtractionStatus$Extracted);
};
var $author$project$Pages$CcdaImports$CcdaId_String$Top$viewOutcome = F3(
	function (humanize, valueView, outcome) {
		switch (outcome.$) {
			case 0:
				var value = outcome.a;
				return valueView(value);
			case 1:
				var value = outcome.a.aee;
				var missing = outcome.a.aiM;
				return A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap2]),
					_List_fromArray(
						[
							valueView(value),
							A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[$author$project$Ui$Typography$muted]),
							'missing: ' + A2($elm$core$String$join, ', ', missing))
						]));
			case 2:
				var reason = outcome.a;
				return A2(
					$author$project$Ui$Typography$text,
					_List_fromArray(
						[$author$project$Ui$Typography$muted]),
					'Ignored: ' + humanize(reason));
			case 3:
				var reason = outcome.a;
				return A2(
					$author$project$Ui$Typography$text,
					_List_fromArray(
						[$author$project$Ui$Typography$muted]),
					'Failed: ' + humanize(reason));
			default:
				var other = outcome.a;
				return A2(
					$author$project$Ui$Typography$text,
					_List_fromArray(
						[$author$project$Ui$Typography$muted]),
					'Unknown: ' + other);
		}
	});
var $author$project$Pages$CcdaImports$CcdaId_String$Top$viewSection = F5(
	function (title, outcomes, isSentinel, humanize, valueView) {
		var nonSentinel = A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Basics$not,
				$author$project$Pages$CcdaImports$CcdaId_String$Top$isSentinelOnly(isSentinel)),
			outcomes);
		return $elm$core$List$isEmpty(nonSentinel) ? A2(
			$author$project$Ui$Typography$text,
			_List_fromArray(
				[$author$project$Ui$Typography$muted]),
			title + ': no entries') : A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap2]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$itemsCenter]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$titleSm,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								])),
							A2(
							$elm$core$Maybe$withDefault,
							$elm$html$Html$text(''),
							$author$project$Pages$CcdaImports$CcdaId_String$Top$maybeStatusBadge(
								$author$project$Pages$CcdaImports$CcdaId_String$Top$sectionStatus(nonSentinel)))
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap2]),
					A2(
						$elm$core$List$map,
						A2($author$project$Pages$CcdaImports$CcdaId_String$Top$viewOutcome, humanize, valueView),
						nonSentinel))
				]));
	});
var $author$project$Pages$CcdaImports$CcdaId_String$Top$viewSocialHistory = function (s) {
	return $author$project$Pages$CcdaImports$CcdaId_String$Top$viewValue(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$core$Maybe$Just(s.amg)),
				_Utils_Tuple2('value', s.aee),
				_Utils_Tuple2('code', s.NN),
				_Utils_Tuple2('system', s.afN),
				_Utils_Tuple2('observed', s.ai9)
			]));
};
var $author$project$Pages$CcdaImports$CcdaId_String$Top$formatVitalValue = function (v) {
	var _v0 = v.adL;
	if (!_v0.$) {
		var unit = _v0.a;
		return v.aee + (' ' + unit);
	} else {
		return v.aee;
	}
};
var $author$project$Pages$CcdaImports$CcdaId_String$Top$viewVital = function (v) {
	return $author$project$Pages$CcdaImports$CcdaId_String$Top$viewValue(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$core$Maybe$Just(v.amg)),
				_Utils_Tuple2('name', v.Bq),
				_Utils_Tuple2(
				'value',
				$elm$core$Maybe$Just(
					$author$project$Pages$CcdaImports$CcdaId_String$Top$formatVitalValue(v))),
				_Utils_Tuple2('loinc', v.amf),
				_Utils_Tuple2('measured', v.aiD)
			]));
};
var $author$project$Api$Provider$CcdaImport$One$vitals = function (_v0) {
	var r = _v0;
	return r.aek;
};
var $author$project$Pages$CcdaImports$CcdaId_String$Top$viewExpandedContent = F2(
	function (model, reportId) {
		var _v0 = A2($elm$core$Dict$get, reportId, model.bY);
		_v0$2:
		while (true) {
			if (!_v0.$) {
				switch (_v0.a.$) {
					case 3:
						var _v1 = _v0.a;
						var report = _v1.a;
						return A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap4]),
							_List_fromArray(
								[
									A5(
									$author$project$Pages$CcdaImports$CcdaId_String$Top$viewSection,
									'Allergies',
									$author$project$Api$Provider$CcdaImport$One$allergies(report),
									$author$project$Api$Provider$CcdaImport$Allergy$isSentinelEmpty,
									$author$project$Api$Provider$CcdaImport$Allergy$humanizeReason,
									$author$project$Pages$CcdaImports$CcdaId_String$Top$viewAllergy),
									A5(
									$author$project$Pages$CcdaImports$CcdaId_String$Top$viewSection,
									'Medications',
									$author$project$Api$Provider$CcdaImport$One$medications(report),
									$author$project$Api$Provider$CcdaImport$Medication$isSentinelEmpty,
									$author$project$Api$Provider$CcdaImport$Medication$humanizeReason,
									$author$project$Pages$CcdaImports$CcdaId_String$Top$viewMedication),
									A5(
									$author$project$Pages$CcdaImports$CcdaId_String$Top$viewSection,
									'Diagnoses',
									$author$project$Api$Provider$CcdaImport$One$diagnoses(report),
									$author$project$Api$Provider$CcdaImport$Diagnosis$isSentinelEmpty,
									$author$project$Api$Provider$CcdaImport$Diagnosis$humanizeReason,
									$author$project$Pages$CcdaImports$CcdaId_String$Top$viewDiagnosis),
									A5(
									$author$project$Pages$CcdaImports$CcdaId_String$Top$viewSection,
									'Procedures',
									$author$project$Api$Provider$CcdaImport$One$procedures(report),
									$author$project$Api$Provider$CcdaImport$Procedure$isSentinelEmpty,
									$author$project$Api$Provider$CcdaImport$Procedure$humanizeReason,
									$author$project$Pages$CcdaImports$CcdaId_String$Top$viewProcedure),
									A5(
									$author$project$Pages$CcdaImports$CcdaId_String$Top$viewSection,
									'Immunizations',
									$author$project$Api$Provider$CcdaImport$One$immunizations(report),
									$author$project$Api$Provider$CcdaImport$Immunization$isSentinelEmpty,
									$author$project$Api$Provider$CcdaImport$Immunization$humanizeReason,
									$author$project$Pages$CcdaImports$CcdaId_String$Top$viewImmunization),
									A5(
									$author$project$Pages$CcdaImports$CcdaId_String$Top$viewSection,
									'Social history',
									$author$project$Api$Provider$CcdaImport$One$socialHistories(report),
									$author$project$Api$Provider$CcdaImport$SocialHistory$isSentinelEmpty,
									$author$project$Api$Provider$CcdaImport$SocialHistory$humanizeReason,
									$author$project$Pages$CcdaImports$CcdaId_String$Top$viewSocialHistory),
									A5(
									$author$project$Pages$CcdaImports$CcdaId_String$Top$viewSection,
									'Family history',
									$author$project$Api$Provider$CcdaImport$One$familyHistories(report),
									$author$project$Api$Provider$CcdaImport$FamilyHistory$isSentinelEmpty,
									$author$project$Api$Provider$CcdaImport$FamilyHistory$humanizeReason,
									$author$project$Pages$CcdaImports$CcdaId_String$Top$viewFamilyHistory),
									A5(
									$author$project$Pages$CcdaImports$CcdaId_String$Top$viewSection,
									'Encounters',
									$author$project$Api$Provider$CcdaImport$One$encounters(report),
									$author$project$Api$Provider$CcdaImport$Encounter$isSentinelEmpty,
									$author$project$Api$Provider$CcdaImport$Encounter$humanizeReason,
									$author$project$Pages$CcdaImports$CcdaId_String$Top$viewEncounter),
									A5(
									$author$project$Pages$CcdaImports$CcdaId_String$Top$viewSection,
									'Vitals',
									$author$project$Api$Provider$CcdaImport$One$vitals(report),
									$author$project$Api$Provider$CcdaImport$Vital$isSentinelEmpty,
									$author$project$Api$Provider$CcdaImport$Vital$humanizeReason,
									$author$project$Pages$CcdaImports$CcdaId_String$Top$viewVital),
									A5(
									$author$project$Pages$CcdaImports$CcdaId_String$Top$viewSection,
									'Labs',
									$author$project$Api$Provider$CcdaImport$One$labs(report),
									$author$project$Api$Provider$CcdaImport$Lab$isSentinelEmpty,
									$author$project$Api$Provider$CcdaImport$Lab$humanizeReason,
									$author$project$Pages$CcdaImports$CcdaId_String$Top$viewLab)
								]));
					case 2:
						return A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[$author$project$Ui$Typography$muted]),
							'Couldn\'t load details.');
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return $author$project$Ui$Skeleton$text(
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$span(4)
				]));
	});
var $author$project$Pages$CcdaImports$CcdaId_String$Top$viewPatientHeader = function (patient_) {
	return $author$project$Ui$Typography$headingSm(
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Api$Provider$Patient$Min$name(patient_)),
				$elm$html$Html$text(' '),
				A2(
				$author$project$Ui$Typography$text,
				_List_fromArray(
					[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
				'(' + ($author$project$Api$Provider$Patient$Min$id(patient_) + ')'))
			]));
};
var $author$project$Api$Provider$CcdaImport$SyncStatus$label = function (status) {
	switch (status.$) {
		case 0:
			return 'Pending';
		case 1:
			return 'Awaiting approval';
		case 2:
			return 'Syncing';
		case 3:
			return 'Synced';
		case 4:
			return 'Partially synced';
		case 5:
			return 'Declined';
		default:
			var other = status.a;
			return other;
	}
};
var $author$project$Pages$CcdaImports$CcdaId_String$Top$viewSyncBadge = function (status) {
	var opt = function () {
		switch (status.$) {
			case 3:
				return $author$project$Ui$Badge$success;
			case 4:
				return $author$project$Ui$Badge$warning;
			case 2:
				return $author$project$Ui$Badge$info;
			case 1:
				return $author$project$Ui$Badge$neutral;
			case 5:
				return $author$project$Ui$Badge$danger;
			case 0:
				return $author$project$Ui$Badge$neutral;
			default:
				return $author$project$Ui$Badge$neutral;
		}
	}();
	return A2(
		$author$project$Ui$Badge$view,
		_List_fromArray(
			[opt]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Api$Provider$CcdaImport$SyncStatus$label(status))
			]));
};
var $author$project$Pages$CcdaImports$CcdaId_String$Top$viewReportPanel = F2(
	function (model, report) {
		var reportId = $author$project$Api$Provider$CcdaImport$All$id(report);
		var isExpanded = A2($elm$core$Set$member, reportId, model.nB);
		return A2(
			$author$project$Ui$Panel$view,
			_List_fromArray(
				[
					$author$project$Ui$Panel$collapsed(!isExpanded)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$fullWidth]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('panel-toggle text-left bg-transparent border-0'),
											$elm$html$Html$Events$onClick(
											$author$project$Pages$CcdaImports$CcdaId_String$Top$ToggleExpand(reportId))
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
											_List_fromArray(
												[
													$author$project$Pages$CcdaImports$CcdaId_String$Top$viewPatientHeader(
													$author$project$Api$Provider$CcdaImport$All$patient(report)),
													$author$project$Pages$CcdaImports$CcdaId_String$Top$viewExtractionBadge(
													$author$project$Api$Provider$CcdaImport$All$extractionStatus(report)),
													$author$project$Pages$CcdaImports$CcdaId_String$Top$viewSyncBadge(
													$author$project$Api$Provider$CcdaImport$All$syncStatus(report))
												]))
										])),
									A3(
									$author$project$Pages$CcdaImports$CcdaId_String$Top$viewApproveButton,
									model,
									reportId,
									$author$project$Api$Provider$CcdaImport$All$syncStatus(report))
								]))
						])),
					isExpanded ? A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Pages$CcdaImports$CcdaId_String$Top$viewExpandedContent, model, reportId)
						])) : $author$project$Ui$Panel$none
				]));
	});
var $author$project$Pages$CcdaImports$CcdaId_String$Top$viewBody = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap4]),
		_List_fromArray(
			[
				$author$project$Ui$Typography$heading(
				_List_fromArray(
					[
						$elm$html$Html$text('CCDA Import Reports')
					])),
				$author$project$Pages$CcdaImports$CcdaId_String$Top$viewControls(model),
				function () {
				var _v0 = model.ue;
				switch (_v0.$) {
					case 1:
						return $author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$span(6)
								]));
					case 3:
						var reports = _v0.a;
						return A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flexCol]),
							A2(
								$elm$core$List$map,
								$author$project$Pages$CcdaImports$CcdaId_String$Top$viewReportPanel(model),
								reports));
					default:
						return A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[$author$project$Ui$Typography$muted]),
							'Couldn\'t load reports.');
				}
			}(),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$CcdaImports$CcdaId_String$Top$PaginationMsg,
				A2($author$project$Api$Pagination$view, _List_Nil, model.ajJ))
			]));
};
var $author$project$Pages$CcdaImports$CcdaId_String$Top$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				$author$project$Pages$CcdaImports$CcdaId_String$Top$viewBody(model)
			]),
		ac9: 'CCDA Import Reports'
	};
};
var $author$project$Pages$CcdaImports$CcdaId_String$Top$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$CcdaImports$CcdaId_String$Top$init, aiq: $author$project$Pages$CcdaImports$CcdaId_String$Top$load, k8: $author$project$Pages$CcdaImports$CcdaId_String$Top$save, alO: $author$project$Pages$CcdaImports$CcdaId_String$Top$subscriptions, adT: $author$project$Pages$CcdaImports$CcdaId_String$Top$update, amo: $author$project$Pages$CcdaImports$CcdaId_String$Top$view});
var $author$project$Pages$Charges$New$ChargeFormMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Charge$Form$CategoryResourceFilterMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Charge$Form$ChargeItemResourceFilterMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Charge$Form$EndDateInputMsg = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Components$Charge$Form$LocationResourceFilterMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Charge$Form$Model = $elm$core$Basics$identity;
var $author$project$Components$Charge$Form$PatientResourceFilterMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Charge$Form$PractitionerResourceFilterMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Charge$Form$RoutingFieldsMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Charge$Form$StartDateInputMsg = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$Components$Charge$Form$RoutingFields$GotCurrentDate = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Charge$Form$RoutingFields$initFields = {Us: $elm$core$Maybe$Nothing, ajW: $elm$core$Maybe$Nothing, Y6: 0};
var $author$project$Components$Charge$Form$RoutingFields$init = F2(
	function (apiClient, practice) {
		var _v0 = A2($author$project$Components$ResourceFilter$Patient$init, apiClient, $elm$core$Basics$identity);
		var patientPayerFilter = _v0.a;
		return _Utils_Tuple2(
			{
				dd: $elm$core$Maybe$Nothing,
				ct: $author$project$Api$Data$NotAsked,
				ahi: $author$project$Components$Charge$Form$RoutingFields$initFields,
				ajJ: A2($author$project$Api$Pagination$withItemsPerPage, 20, $author$project$Api$Pagination$init),
				YY: $author$project$Api$Data$NotAsked,
				YZ: '',
				eP: patientPayerFilter,
				tI: false,
				ZV: practice,
				akd: $author$project$Api$Data$NotAsked,
				hl: $author$project$Api$Data$NotAsked,
				fi: $author$project$Api$Data$NotAsked
			},
			A2($elm$core$Task$perform, $author$project$Components$Charge$Form$RoutingFields$GotCurrentDate, $justinmimbs$date$Date$today));
	});
var $author$project$Components$Charge$Form$initCategoryResourceFilter = F3(
	function (apiClient, session, excludeLabs) {
		var excludedCategoryTitles = excludeLabs ? $elm$core$Maybe$Just(
			_List_fromArray(
				['Labs'])) : $elm$core$Maybe$Nothing;
		return A3(
			$author$project$Components$ResourceFilter$Category$init,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Unassigned', ag0: excludedCategoryTitles});
			});
	});
var $author$project$Components$Charge$Form$initChargeItemResourceFilter = F2(
	function (apiClient, showItemTypeInTitle) {
		return A4(
			$author$project$Components$ResourceFilter$ChargeItem$initWithItemType,
			showItemTypeInTitle,
			apiClient,
			$elm$core$Basics$identity,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Select a Charge Item', Lr: false, ahw: true, ahx: '', ahG: true, ahH: true, ai5: false});
			});
	});
var $author$project$Components$Charge$Form$initFormFields = F4(
	function (today, startDateInput, endDateInput, categoryResourceFilter) {
		return {
			GW: $elm$core$Maybe$Nothing,
			c8: categoryResourceFilter,
			mL: $elm$core$Maybe$Nothing,
			PB: today,
			Qr: '',
			QD: 0,
			QE: false,
			sb: $elm$core$Maybe$Nothing,
			sd: endDateInput,
			Uk: $elm$core$Maybe$Nothing,
			ais: $elm$core$Maybe$Nothing,
			Bq: $elm$core$Maybe$Nothing,
			YY: $elm$core$Maybe$Nothing,
			I6: $elm$core$Maybe$Nothing,
			Y6: 0,
			aka: $elm$core$Maybe$Nothing,
			Dw: $elm$core$Maybe$Nothing,
			_h: $elm$core$Maybe$Nothing,
			Dz: $elm$core$Maybe$Just(1),
			DA: $elm$core$Maybe$Nothing,
			ab7: today,
			lx: startDateInput
		};
	});
var $author$project$Components$Charge$Form$initLocationResourceFilter = function (apiClient) {
	return A4(
		$author$project$Components$ResourceFilter$Location$init,
		apiClient,
		$elm$core$Maybe$Nothing,
		$elm$core$Basics$identity,
		function (d) {
			return _Utils_update(
				d,
				{Gp: 'Unassigned', ai5: false});
		});
};
var $author$project$Api$Provider$Patient$One$record_ = function (_v0) {
	var record = _v0.b;
	return record;
};
var $author$project$Api$Provider$Patient$One$age = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$One$record_,
	function ($) {
		return $.Lj;
	});
var $author$project$Components$ResourceFilter$Patient$extraItems = F2(
	function (list_, model) {
		var extraItems_ = A2(
			$elm$core$List$map,
			function (item) {
				return {
					aih: _Utils_ap(
						item.Bq,
						_Utils_ap(
							function () {
								var _v0 = item.Lj;
								if (!_v0.$) {
									var age = _v0.a;
									return ' - ' + $elm$core$String$fromInt(age);
								} else {
									return '';
								}
							}(),
							(!$elm$core$String$isEmpty(item.WX)) ? (' - ' + $author$project$Formatters$String$humanize(item.WX)) : '')),
					aee: item.ahP
				};
			},
			list_);
		return _Utils_update(
			model,
			{
				b8: A2($author$project$Components$ResourceFilter$extraItems, extraItems_, model.b8)
			});
	});
var $author$project$Api$Provider$Patient$One$membershipStatus = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$membershipStatus(shared);
};
var $author$project$Components$Charge$Form$initPatientResourceFilter = F2(
	function (apiClient, preselectedPatient) {
		return A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Components$ResourceFilter$Patient$extraItems(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (patient_) {
							return _List_fromArray(
								[
									{
									Lj: $author$project$Api$Provider$Patient$One$age(patient_),
									ahP: $author$project$Api$Provider$Patient$One$id(patient_),
									WX: $author$project$Api$Provider$Patient$One$membershipStatus(patient_),
									Bq: $author$project$Api$Provider$Patient$One$name(patient_)
								}
								]);
						},
						preselectedPatient))),
			A3(
				$author$project$Components$ResourceFilter$Patient$initWithId,
				'charge-form-patient',
				apiClient,
				function (d) {
					return _Utils_update(
						d,
						{
							Gp: 'Select a Patient',
							Lr: false,
							akb: A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$One$id, preselectedPatient)
						});
				}));
	});
var $author$project$Components$Charge$Form$initPractitionerResourceFilter = function (apiClient) {
	return A3(
		$author$project$Components$ResourceFilter$Practitioner$init,
		apiClient,
		$elm$core$Basics$identity,
		function (d) {
			return _Utils_update(
				d,
				{Gp: 'Unassigned'});
		});
};
var $author$project$Components$Charge$Form$PreloadedPatient = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Charge$Form$preloadPatient = F2(
	function (apiClient, preselectedPatientId) {
		return A3($author$project$Api$Provider$Patient$retrieve, apiClient, preselectedPatientId, $author$project$Components$Charge$Form$PreloadedPatient);
	});
var $author$project$Components$Charge$Form$init = F5(
	function (apiClient, session, practice, preselectedPatientId, _v0) {
		var currentDate = _v0.dd;
		var packageFeatureEnabled = A2(
			$author$project$Utils$FeatureGate$gateAvailable,
			14,
			$author$project$Api$Practice$Provider(practice));
		var excludeLabs = A2($author$project$Api$Provider$Practice$One$featureEnabled, 6, practice);
		var _v1 = $author$project$Components$DateInput$init;
		var startDateInput = _v1.a;
		var startDateInputCmd = _v1.b;
		var _v2 = A2($author$project$Components$Charge$Form$RoutingFields$init, apiClient, practice);
		var routingFields = _v2.a;
		var routingFieldsCmd = _v2.b;
		var _v3 = function () {
			if (!preselectedPatientId.$) {
				var patId = preselectedPatientId.a;
				return _Utils_Tuple2(
					A2($author$project$Components$Charge$Form$preloadPatient, apiClient, patId),
					$author$project$Api$Data$Loading);
			} else {
				return _Utils_Tuple2($elm$core$Platform$Cmd$none, $author$project$Api$Data$NotAsked);
			}
		}();
		var preloadPatientCmd = _v3.a;
		var preloadedPatientData = _v3.b;
		var _v5 = $author$project$Components$Charge$Form$initPractitionerResourceFilter(apiClient);
		var practitionerResourceFilter = _v5.a;
		var practitionerResourceFilterCmd = _v5.b;
		var _v6 = A2($author$project$Components$Charge$Form$initPatientResourceFilter, apiClient, $elm$core$Maybe$Nothing);
		var patientResourceFilter = _v6.a;
		var patientResourceFilterCmd = _v6.b;
		var _v7 = $author$project$Components$Charge$Form$initLocationResourceFilter(apiClient);
		var locationResourceFilter = _v7.a;
		var locationResourceFilterCmd = _v7.b;
		var _v8 = $author$project$Components$DateInput$init;
		var endDateInput = _v8.a;
		var endDateInputCmd = _v8.b;
		var _v9 = A2($author$project$Components$Charge$Form$initChargeItemResourceFilter, apiClient, packageFeatureEnabled);
		var chargeItemResourceFilter = _v9.a;
		var chargeItemResourceFilterCmd = _v9.b;
		var _v10 = A3($author$project$Components$Charge$Form$initCategoryResourceFilter, apiClient, session, excludeLabs);
		var categoryResourceFilter = _v10.a;
		var categoryResourceFilterCmd = _v10.b;
		return _Utils_Tuple2(
			{
				afx: $author$project$Api$Data$NotAsked,
				f: $author$project$Utils$Form$init(
					A4(
						$author$project$Components$Charge$Form$initFormFields,
						$elm$core$Maybe$Just(currentDate),
						startDateInput,
						endDateInput,
						categoryResourceFilter)),
				cq: chargeItemResourceFilter,
				dd: currentDate,
				os: locationResourceFilter,
				YY: $elm$core$Maybe$Nothing,
				tG: false,
				oY: patientResourceFilter,
				ZV: practice,
				hk: practitionerResourceFilter,
				Dv: preloadedPatientData,
				akd: $author$project$Api$Data$NotAsked,
				eW: $jinjor$elm_debounce$Debounce$init,
				_6: false,
				pK: routingFields,
				aa4: session,
				hD: false,
				lx: startDateInput,
				h8: true
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$PatientResourceFilterMsg, patientResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$ChargeItemResourceFilterMsg, chargeItemResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$RoutingFieldsMsg, routingFieldsCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$CategoryResourceFilterMsg, categoryResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$PractitionerResourceFilterMsg, practitionerResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$LocationResourceFilterMsg, locationResourceFilterCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Components$Charge$Form$StartDateInputMsg(startDateInput),
						startDateInputCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Components$Charge$Form$EndDateInputMsg(endDateInput),
						endDateInputCmd),
						preloadPatientCmd
					])));
	});
var $author$project$Components$CustomerEmailModal$Closed = {$: 0};
var $author$project$Components$CustomerEmailModal$init = $author$project$Components$CustomerEmailModal$Closed;
var $author$project$Components$CustomerSchedulePaymentModal$Closed = {$: 0};
var $author$project$Components$CustomerSchedulePaymentModal$init = $author$project$Components$CustomerSchedulePaymentModal$Closed;
var $author$project$Components$Charge$Form$withPatientLocked = function (_v0) {
	var model = _v0;
	return _Utils_update(
		model,
		{tG: true});
};
var $author$project$Pages$Charges$New$initEmbeddedChargeForm = function (model) {
	return $author$project$Components$Charge$Form$withPatientLocked(model);
};
var $author$project$Pages$Charges$New$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.DE;
		var preselectedPatientId = A2($elm$core$Dict$get, 'patient', query);
		var _v1 = A5($author$project$Components$Charge$Form$init, shared.Gv, session, practice, preselectedPatientId, shared);
		var chargeForm = _v1.a;
		var chargeFormCmd = _v1.b;
		return _Utils_Tuple2(
			{
				Gv: shared.Gv,
				f: (shared.ahq.agL ? $author$project$Pages$Charges$New$initEmbeddedChargeForm : $elm$core$Basics$identity)(chargeForm),
				m$: $elm$core$Maybe$Nothing,
				d3: _List_Nil,
				m5: $author$project$Components$CustomerEmailModal$init,
				sP: _List_Nil,
				Ij: $author$project$Shared$isHintAdmin(shared),
				ZV: practice,
				t9: shared.t9,
				ui: true,
				hw: $author$project$Components$CustomerSchedulePaymentModal$init,
				aa4: session,
				lk: shared
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Pages$Charges$New$ChargeFormMsg, chargeFormCmd));
	});
var $author$project$Pages$Charges$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Charges$New$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Charges$New$CreatePaymentModalMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Charges$New$CustomerEmailModalMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Charges$New$SchedulePaymentModalMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Charge$Form$RoutingFields$PatientPayerFilterMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Charge$Form$RoutingFields$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Components$Charge$Form$RoutingFields$PatientPayerFilterMsg,
		$author$project$Components$ResourceFilter$Patient$subscriptions(model.eP));
};
var $author$project$Components$Charge$Form$subscriptions = function (_v0) {
	var model = _v0;
	var _v1 = $author$project$Utils$Form$fields(model.f);
	var categoryResourceFilter = _v1.c8;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Charge$Form$PatientResourceFilterMsg,
				$author$project$Components$ResourceFilter$Patient$subscriptions(model.oY)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Charge$Form$ChargeItemResourceFilterMsg,
				$author$project$Components$ResourceFilter$ChargeItem$subscriptions(model.cq)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Charge$Form$CategoryResourceFilterMsg,
				$author$project$Components$ResourceFilter$Category$subscriptions(categoryResourceFilter)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Charge$Form$PractitionerResourceFilterMsg,
				$author$project$Components$ResourceFilter$Practitioner$subscriptions(model.hk)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Charge$Form$LocationResourceFilterMsg,
				$author$project$Components$ResourceFilter$Location$subscriptions(model.os)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Charge$Form$RoutingFieldsMsg,
				$author$project$Components$Charge$Form$RoutingFields$subscriptions(model.pK))
			]));
};
var $author$project$Components$CustomerEmailModal$Close = {$: 1};
var $author$project$Components$CustomerEmailModal$subscriptions = function (model) {
	if (!model.$) {
		return $elm$core$Platform$Sub$none;
	} else {
		return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$CustomerEmailModal$Close);
	}
};
var $author$project$Components$CustomerSchedulePaymentModal$CloseModal = {$: 0};
var $author$project$Components$CustomerSchedulePaymentModal$subscriptions = function (model) {
	if (model.$ === 1) {
		return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$CustomerSchedulePaymentModal$CloseModal);
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Pages$Charges$New$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Charges$New$CustomerEmailModalMsg,
				$author$project$Components$CustomerEmailModal$subscriptions(model.m5)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Charges$New$SchedulePaymentModalMsg,
				$author$project$Components$CustomerSchedulePaymentModal$subscriptions(model.hw)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Charges$New$CreatePaymentModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2(
						$elm$core$Maybe$map,
						$author$project$Components$Invoice$CreatePaymentModal$subscriptions,
						A2($elm$core$Maybe$map, $elm$core$Tuple$first, model.m$)))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Charges$New$ChargeFormMsg,
				$author$project$Components$Charge$Form$subscriptions(model.f)),
				$elm$core$Platform$Sub$batch(
				A2(
					$elm$core$List$map,
					function (invoice) {
						return $author$project$Ui$Dropdown$subscriptions(invoice.no);
					},
					model.sP))
			]));
};
var $author$project$Api$Provider$CustomerInvoice$Charges = 0;
var $author$project$Api$Provider$Notification$CustomerInvoice = 0;
var $author$project$Pages$Charges$New$Dropdown = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Charges$New$GotCustomerInvoice = F3(
	function (a, b, c) {
		return {$: 7, a: a, b: b, c: c};
	});
var $author$project$Pages$Charges$New$GotPatient = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Pages$Charges$New$Issue = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Pages$Charges$New$OpenEmail = 2;
var $author$project$Pages$Charges$New$OpenPaymentProcessing = 0;
var $author$project$Pages$Charges$New$OpenPaymentRecording = 1;
var $author$project$Pages$Charges$New$OpenSchedulePayment = 3;
var $author$project$Components$CustomerEmailModal$PatientOne = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Charges$New$SaveRequest = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Charges$New$Status = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Charge$Form$charge = function (_v0) {
	var model = _v0;
	return model.afx;
};
var $author$project$Pages$Charges$New$findInvoice = F2(
	function (invoices, invoiceId) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (invoice) {
					return _Utils_eq(invoice.ahP, invoiceId);
				},
				invoices));
	});
var $author$project$Pages$Charges$New$findDropdownMenu = F2(
	function (invoices, invoiceId) {
		return A2(
			$elm$core$Maybe$map,
			function (invoice) {
				return invoice.no;
			},
			A2($author$project$Pages$Charges$New$findInvoice, invoices, invoiceId));
	});
var $author$project$Components$Charge$Form$hide = function (_v0) {
	var model = _v0;
	return _Utils_update(
		model,
		{h8: false});
};
var $author$project$Api$Provider$CustomerInvoice$Shared$humanStatus = function (_v0) {
	var record = _v0;
	return record.TH;
};
var $author$project$Api$Provider$CustomerInvoice$One$humanStatus = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CustomerInvoice$Shared$humanStatus(shared);
};
var $author$project$Api$Common$Payable$Invoice$Min$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Common$Payable$Invoice$MinWithOwner$id = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Common$Payable$Invoice$Min$id(min);
};
var $author$project$Api$Provider$Charge$One$invoice = function (_v0) {
	var record = _v0.b;
	return record.Uk;
};
var $author$project$Pages$Charges$New$isDraft = function (invoice) {
	return invoice.alH === 'draft';
};
var $author$project$Api$Provider$CustomerInvoice$customerInvoicesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['customer_invoices']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$CustomerInvoice$customerInvoicePath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		$author$project$Api$Provider$CustomerInvoice$customerInvoicesPath);
};
var $author$project$Api$Provider$CustomerInvoice$One$CustomerInvoice = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$CustomerInvoice$Shared$CustomerInvoice = $elm$core$Basics$identity;
var $author$project$Api$Provider$CustomerInvoice$Shared$Record = function (id) {
	return function (date) {
		return function (invoiceNumber) {
			return function (humanStatus) {
				return function (estimatedDueInCents) {
					return function (dueInCents) {
						return function (securePdfInlineToken) {
							return function (subtotalInCents) {
								return function (issuedTotalInCents) {
									return function (totalInCents) {
										return function (paidInCents) {
											return function (creditInCents) {
												return function (taxInCents) {
													return function (isPaymentScheduled) {
														return function (hasGoodPaymentSource) {
															return function (paymentScheduledOn) {
																return function (passthroughFeesInCents) {
																	return {O7: creditInCents, PB: date, QY: dueInCents, RP: estimatedDueInCents, Ta: hasGoodPaymentSource, TH: humanStatus, ahP: id, Uu: invoiceNumber, U3: isPaymentScheduled, Vs: issuedTotalInCents, YI: paidInCents, YW: passthroughFeesInCents, Zf: paymentScheduledOn, aaE: securePdfInlineToken, acD: subtotalInCents, acV: taxInCents, adp: totalInCents};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$CustomerInvoice$Shared$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'passthrough_fees_in_cents',
	$elm$json$Json$Decode$int,
	0,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'payment_scheduled_on',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'has_good_payment_source',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'is_payment_scheduled',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'tax_in_cents',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'credit_in_cents',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'paid_in_cents',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'total_in_cents',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'issued_total_in_cents',
									$elm$json$Json$Decode$int,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'subtotal_in_cents',
										$elm$json$Json$Decode$int,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'secure_pdf_inline_token',
											$elm$json$Json$Decode$nullable($author$project$Api$File$Token$decoder),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'due_in_cents',
												$elm$json$Json$Decode$int,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'estimated_due_in_cents',
													$elm$json$Json$Decode$int,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'human_status',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'invoice_number',
															$elm$json$Json$Decode$int,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'date',
																$author$project$Utils$Date$decode,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'id',
																	$elm$json$Json$Decode$string,
																	$elm$json$Json$Decode$succeed($author$project$Api$Provider$CustomerInvoice$Shared$Record))))))))))))))))));
var $author$project$Api$Provider$CustomerInvoice$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CustomerInvoice$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CustomerInvoice$One$Record = function (lastSentAt) {
	return function (chargeGroup) {
		return function (meta) {
			return function (source) {
				return function (membershipPaymentSource) {
					return function (owner) {
						return function (location) {
							return function (taxProfile) {
								return function (charges) {
									return function (creditToAutoApplyInCents) {
										return function (transferredToCreditInCents) {
											return function (payments) {
												return function (adjustments) {
													return function (revisionNumber) {
														return function (voidReason) {
															return function (voidedAt) {
																return function (voidedByName) {
																	return function (probablePatients) {
																		return function (createdAt) {
																			return {Lb: adjustments, afy: chargeGroup, NA: charges, O1: createdAt, O8: creditToAutoApplyInCents, VL: lastSentAt, ais: location, WT: membershipPaymentSource, W4: meta, YD: owner, Zi: payments, _m: probablePatients, $5: revisionNumber, JQ: source, acX: taxProfile, adA: transferredToCreditInCents, amq: voidReason, ael: voidedAt, aem: voidedByName};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$CustomerInvoice$Meta$Meta = $elm$core$Basics$identity;
var $author$project$Api$Provider$CustomerInvoice$Meta$Record = F2(
	function (actions, taxProfile) {
		return {vy: actions, acX: taxProfile};
	});
var $author$project$Api$Provider$CustomerInvoice$Meta$ActionsRecord = function (paymentProcess) {
	return function (recordPayment) {
		return function (schedulePayment) {
			return function (schedulePartialPayments) {
				return function (markAsSent) {
					return function (markAsUnsent) {
						return function (returnToDraft) {
							return function (markAsBadDebt) {
								return function (reverseBadDebt) {
									return function (stopRetrying) {
										return function (applyCredits) {
											return function (removeCredits) {
												return function (destroy) {
													return function (issue) {
														return function (isRevisable) {
															return function (createAdjustment) {
																return function (transferToCredit) {
																	return function (reverseCreditTransfer) {
																		return function (update) {
																			return function (cancel) {
																				return {LX: applyCredits, Nl: cancel, OZ: createAdjustment, Qu: destroy, aif: isRevisable, Vm: issue, Wu: markAsBadDebt, Ww: markAsSent, Wx: markAsUnsent, Zc: paymentProcess, $e: recordPayment, $u: removeCredits, $Z: returnToDraft, $1: reverseBadDebt, $2: reverseCreditTransfer, aau: schedulePartialPayments, aav: schedulePayment, aci: stopRetrying, ady: transferToCredit, adT: update};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$CustomerInvoice$Meta$actionsRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'cancel',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'update',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'reverse_credit_transfer',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'transfer_to_credit',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'create_adjustment',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'is_revisable',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'issue',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'destroy',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'remove_credits',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'apply_credits',
										$elm$json$Json$Decode$bool,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'stop_retrying',
											$elm$json$Json$Decode$bool,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'reverse_bad_debt',
												$elm$json$Json$Decode$bool,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'mark_as_bad_debt',
													$elm$json$Json$Decode$bool,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'return_to_draft',
														$elm$json$Json$Decode$bool,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'mark_as_unsent',
															$elm$json$Json$Decode$bool,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'mark_as_sent',
																$elm$json$Json$Decode$bool,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'schedule_partial_payments',
																	$elm$json$Json$Decode$bool,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'schedule_payment',
																		$elm$json$Json$Decode$bool,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'payments_paid',
																			$elm$json$Json$Decode$bool,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'payments_process',
																				$elm$json$Json$Decode$bool,
																				$elm$json$Json$Decode$succeed($author$project$Api$Provider$CustomerInvoice$Meta$ActionsRecord)))))))))))))))))))));
var $author$project$Api$Provider$CustomerInvoice$Meta$TaxProfileRecord = F2(
	function (viewable, editable) {
		return {Q4: editable, aeh: viewable};
	});
var $author$project$Api$Provider$CustomerInvoice$Meta$taxProfileRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'editable',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'viewable',
		$elm$json$Json$Decode$bool,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$CustomerInvoice$Meta$TaxProfileRecord)));
var $author$project$Api$Provider$CustomerInvoice$Meta$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'tax_profile',
	$author$project$Api$Provider$CustomerInvoice$Meta$taxProfileRecordDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'actions',
		$author$project$Api$Provider$CustomerInvoice$Meta$actionsRecordDecoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$CustomerInvoice$Meta$Record)));
var $author$project$Api$Provider$CustomerInvoice$Meta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CustomerInvoice$Meta$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$InvoiceAdjustment = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$InvoiceAdjustment$Shared$InvoiceAdjustment = $elm$core$Basics$identity;
var $author$project$Api$Provider$InvoiceAdjustment$Shared$Record = function (totalAdjustmentInCents) {
	return {ama: totalAdjustmentInCents};
};
var $author$project$Api$Provider$InvoiceAdjustment$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'total_adjustment_in_cents',
	$elm$json$Json$Decode$int,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$InvoiceAdjustment$Shared$Record));
var $author$project$Api$Provider$InvoiceAdjustment$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$InvoiceAdjustment$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$Record = F4(
	function (createdAt, position, reason, user) {
		return {O1: createdAt, ZP: position, _7: reason, ad0: user};
	});
var $author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'user',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$User$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'reason',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'position',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'created_at',
				$elm_community$json_extra$Json$Decode$Extra$datetime,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$Record)))));
var $author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$InvoiceAdjustment$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$InvoiceAdjustment)));
var $author$project$Api$Provider$CustomerInvoice$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'created_at',
	$elm_community$json_extra$Json$Decode$Extra$datetime,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'probable_patients',
		$elm$json$Json$Decode$list($author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'voided_by_name',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'voided_at',
				$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'void_reason',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'revision_number',
						$elm$json$Json$Decode$int,
						A3(
							$author$project$Api$Expandable$expandable,
							'invoice_adjustments',
							$elm$json$Json$Decode$list($author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$decoder),
							A3(
								$author$project$Api$Expandable$expandable,
								'payments',
								$elm$json$Json$Decode$list($author$project$Api$Provider$Payment$One$decoder),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'transferred_to_credit_in_cents',
									$elm$json$Json$Decode$int,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'credit_to_auto_apply_in_cents',
										$elm$json$Json$Decode$int,
										A3(
											$author$project$Api$Expandable$expandable,
											'charges',
											$elm$json$Json$Decode$list($author$project$Api$Provider$Charge$One$decoder),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'tax_profile',
												$elm$json$Json$Decode$nullable($author$project$Api$Provider$TaxProfile$Shared$decoder),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'location',
													$elm$json$Json$Decode$nullable($author$project$Api$Provider$Location$Min$decoder),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'owner',
														$elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Shared$decoder),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'membership_payment_source',
															$elm$json$Json$Decode$nullable($author$project$Api$Common$Source$Shared$decoder),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'source',
																$elm$json$Json$Decode$nullable($author$project$Api$Common$Source$Shared$decoder),
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'meta',
																	$author$project$Api$Provider$CustomerInvoice$Meta$decoder,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'charge_group',
																		$elm$json$Json$Decode$nullable(
																			$elm$json$Json$Decode$dict($elm$json$Json$Decode$string)),
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'last_sent_at',
																			$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
																			$elm$json$Json$Decode$succeed($author$project$Api$Provider$CustomerInvoice$One$Record))))))))))))))))))));
var $author$project$Api$Provider$CustomerInvoice$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CustomerInvoice$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$CustomerInvoice$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$CustomerInvoice$One$CustomerInvoice)));
var $author$project$Api$Provider$CustomerInvoice$expandToString = function (expand) {
	switch (expand) {
		case 0:
			return 'charges';
		case 1:
			return 'payments';
		case 2:
			return 'invoice_adjustments';
		case 3:
			return 'owner.phones';
		default:
			return 'membership_payment_source';
	}
};
var $author$project$Api$Provider$CustomerInvoice$issue = F4(
	function (apiClient, id, expand, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CustomerInvoice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2(
						$author$project$Api$Param$list,
						'expand',
						A2($elm$core$List$map, $author$project$Api$Provider$CustomerInvoice$expandToString, expand))
					]),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['issue']),
						$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id)))));
	});
var $author$project$Components$Charge$Form$NewFormWithPatient = {$: 3};
var $author$project$Components$Charge$Form$newFormWithPatient = A2(
	$elm$core$Task$perform,
	$elm$core$Basics$always($author$project$Components$Charge$Form$NewFormWithPatient),
	$elm$core$Task$succeed($elm$core$Maybe$Nothing));
var $author$project$Components$CustomerEmailModal$Loading = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$CustomerEmailModal$NoRecipientEmail = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Api$Provider$Reports$Patient$oneId = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Components$CustomerEmailModal$recipientId = function (recipient) {
	switch (recipient.$) {
		case 0:
			var patient = recipient.a;
			return $author$project$Api$Provider$Reports$Patient$oneId(patient);
		case 1:
			var patient = recipient.a;
			return $author$project$Api$Provider$Patient$One$id(patient);
		default:
			var patient = recipient.a;
			return $author$project$Api$Provider$Patient$Shared$id(patient);
	}
};
var $author$project$Components$CustomerEmailModal$initPatientFormFields = function (patient) {
	return {
		Rj: '',
		YZ: $author$project$Components$CustomerEmailModal$recipientId(patient)
	};
};
var $author$project$Components$CustomerEmailModal$GotPreview = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$Notification$Patient = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$CustomerEmailModal$previewNotification = F3(
	function (apiClient, shared, formFields) {
		var fields = function () {
			var _v1 = A2($elm$core$Maybe$map, $rtfeldman$elm_validate$Validate$fromValid, formFields);
			if (!_v1.$) {
				var fields_ = _v1.a;
				return {fO: fields_.fO, J_: fields_.J_};
			} else {
				return {fO: $elm$core$Maybe$Nothing, J_: $elm$core$Maybe$Nothing};
			}
		}();
		var _v0 = shared;
		var type_ = _v0.amg;
		var contextId = _v0.yP;
		var recipient = _v0.DI;
		return A6(
			$author$project$Api$Provider$Notification$preview,
			apiClient,
			type_,
			$author$project$Api$Provider$Notification$Patient(
				$author$project$Components$CustomerEmailModal$recipientId(recipient)),
			contextId,
			fields,
			$author$project$Components$CustomerEmailModal$GotPreview);
	});
var $author$project$Api$Provider$Patient$One$email = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$email(shared);
};
var $author$project$Api$Provider$Reports$Patient$oneEmail = function (_v0) {
	var record = _v0;
	return record.Rj;
};
var $author$project$Components$CustomerEmailModal$recipientEmail = function (recipient) {
	switch (recipient.$) {
		case 0:
			var patient = recipient.a;
			return $author$project$Api$Provider$Reports$Patient$oneEmail(patient);
		case 1:
			var patient = recipient.a;
			return $author$project$Api$Provider$Patient$One$email(patient);
		default:
			var patient = recipient.a;
			return $author$project$Api$Provider$Patient$Shared$email(patient);
	}
};
var $author$project$Components$CustomerEmailModal$open = F6(
	function (apiClient, session, type_, contextId, recipient, _v0) {
		var shared = {yP: contextId, DI: recipient, aa4: session, amg: type_};
		var _v1 = $author$project$Components$CustomerEmailModal$recipientEmail(recipient);
		if (_v1.$ === 1) {
			return _Utils_Tuple2(
				A2(
					$author$project$Components$CustomerEmailModal$NoRecipientEmail,
					shared,
					$author$project$Utils$Form$init(
						$author$project$Components$CustomerEmailModal$initPatientFormFields(recipient))),
				$elm$core$Platform$Cmd$none);
		} else {
			if (_v1.a === '') {
				return _Utils_Tuple2(
					A2(
						$author$project$Components$CustomerEmailModal$NoRecipientEmail,
						shared,
						$author$project$Utils$Form$init(
							$author$project$Components$CustomerEmailModal$initPatientFormFields(recipient))),
					$elm$core$Platform$Cmd$none);
			} else {
				var email = _v1.a;
				return _Utils_Tuple2(
					A2($author$project$Components$CustomerEmailModal$Loading, shared, email),
					A3($author$project$Components$CustomerEmailModal$previewNotification, apiClient, shared, $elm$core$Maybe$Nothing));
			}
		}
	});
var $author$project$Components$CustomerSchedulePaymentModal$Open = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$CustomerSchedulePaymentModal$DateInputMsg = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$CustomerSchedulePaymentModal$initFormFields = function () {
	var _v0 = $author$project$Components$DateInput$init;
	var dateInput = _v0.a;
	var dateInputCmd = _v0.b;
	return _Utils_Tuple2(
		{PB: $elm$core$Maybe$Nothing, rZ: dateInput},
		A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Components$CustomerSchedulePaymentModal$DateInputMsg(dateInput),
			dateInputCmd));
}();
var $author$project$Components$CustomerSchedulePaymentModal$open = F2(
	function (invoiceId, currentDate) {
		var _v0 = $author$project$Components$CustomerSchedulePaymentModal$initFormFields;
		var fields = _v0.a;
		var fieldsCmd = _v0.b;
		var model = {
			dd: currentDate,
			SD: $author$project$Utils$Form$init(fields),
			Us: invoiceId,
			uf: $author$project$Api$Data$NotAsked
		};
		return _Utils_Tuple2(
			$author$project$Components$CustomerSchedulePaymentModal$Open(model),
			fieldsCmd);
	});
var $author$project$Components$Charge$Form$readOnly = function (_v0) {
	var model = _v0;
	return _Utils_update(
		model,
		{_6: true});
};
var $author$project$Pages$Charges$New$DropdownMenuMsg = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Api$Common$Payable$Invoice$Min$invoiceNumber = function (_v0) {
	var record = _v0;
	return record.Uu;
};
var $author$project$Api$Common$Payable$Invoice$MinWithOwner$invoiceNumber = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Common$Payable$Invoice$Min$invoiceNumber(min);
};
var $author$project$Api$Common$Payable$Invoice$MinWithOwner$owner = function (_v0) {
	var record = _v0.b;
	return record.YD;
};
var $author$project$Api$Common$Payable$Invoice$Min$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Api$Common$Payable$Invoice$MinWithOwner$status = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Common$Payable$Invoice$Min$status(min);
};
var $author$project$Ui$Dropdown$TopLeft = 3;
var $author$project$Ui$Dropdown$toTopLeft = function (config) {
	return _Utils_update(
		config,
		{bv: 3});
};
var $author$project$Api$Common$Payable$Invoice$Min$type_ = function (_v0) {
	var record = _v0;
	return record.amg;
};
var $author$project$Api$Common$Payable$Invoice$MinWithOwner$type_ = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Common$Payable$Invoice$Min$type_(min);
};
var $author$project$Pages$Charges$New$buildInvoiceRecord = function (invoice) {
	return {
		no: $author$project$Ui$Dropdown$init(
			$author$project$Ui$Dropdown$toTopLeft(
				$author$project$Ui$Dropdown$defaultConfig(
					{
						ahP: 'invoice-actions-dropdown-menu-' + $author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice),
						al6: $author$project$Pages$Charges$New$DropdownMenuMsg(
							$author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice))
					}))),
		ahP: $author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice),
		Uu: $author$project$Api$Common$Payable$Invoice$MinWithOwner$invoiceNumber(invoice),
		YD: $author$project$Api$Common$Payable$Invoice$MinWithOwner$owner(invoice),
		k9: $author$project$Api$Data$NotAsked,
		alH: $author$project$Api$Common$Payable$Invoice$MinWithOwner$status(invoice),
		amg: $author$project$Api$Common$Payable$Invoice$MinWithOwner$type_(invoice)
	};
};
var $author$project$Pages$Charges$New$refreshInvoiceList = F2(
	function (invoices, maybeInvoice) {
		if (!maybeInvoice.$) {
			var invoice = maybeInvoice.a;
			var member = F2(
				function (record, i) {
					return _Utils_eq(i.ahP, record.ahP);
				});
			var invoiceRecord = $author$project$Pages$Charges$New$buildInvoiceRecord(invoice);
			return A2(
				$elm$core$List$any,
				member(invoiceRecord),
				invoices) ? A2(
				$elm$core$List$map,
				function (i) {
					return A2(member, invoiceRecord, i) ? invoiceRecord : i;
				},
				invoices) : A2($elm$core$List$cons, invoiceRecord, invoices);
		} else {
			return invoices;
		}
	});
var $author$project$Components$Charge$Form$ResetForm = {$: 2};
var $author$project$Components$Charge$Form$reset = A2(
	$elm$core$Task$perform,
	$elm$core$Basics$always($author$project$Components$Charge$Form$ResetForm),
	$elm$core$Task$succeed($elm$core$Maybe$Nothing));
var $author$project$Api$Provider$CustomerInvoice$retrieve = F4(
	function (apiClient, id, expand, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$CustomerInvoice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2(
						$author$project$Api$Param$list,
						'expand',
						A2($elm$core$List$map, $author$project$Api$Provider$CustomerInvoice$expandToString, expand))
					]),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id))));
	});
var $author$project$Pages$Charges$New$retrieveInvoice = F2(
	function (apiClient, invoiceId) {
		return A4(
			$author$project$Api$Provider$CustomerInvoice$retrieve,
			apiClient,
			invoiceId,
			_List_Nil,
			A2($author$project$Pages$Charges$New$GotCustomerInvoice, invoiceId, $elm$core$Maybe$Nothing));
	});
var $author$project$Components$Charge$Form$Save = {$: 1};
var $author$project$Components$Charge$Form$save = A2(
	$elm$core$Task$perform,
	$elm$core$Basics$always($author$project$Components$Charge$Form$Save),
	$elm$core$Task$succeed($elm$core$Maybe$Nothing));
var $author$project$Components$Invoice$CreatePaymentModal$CustomerInvoice = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Charges$New$initCreatePaymentModal = F4(
	function (model, external, invoiceId, invoice) {
		var invoiceOwnerId = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$Maybe$map($author$project$Api$Common$Payable$Owner$Min$id),
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.YD;
					},
					A2($author$project$Pages$Charges$New$findInvoice, model.sP, invoiceId))));
		var _v0 = $author$project$Components$Invoice$CreatePaymentModal$init(model.lk.dd)(model.lk.J7)(
			$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(
				$author$project$Api$Provider$CustomerInvoice$One$id(invoice)))(
			$elm$core$Maybe$Just(
				$author$project$Api$Provider$Patient$patientPath(invoiceOwnerId)))(model.lk.Gv)(model.aa4)(
			$author$project$Api$Practice$Provider(model.ZV))(model.Ij)(model.t9)(
			function (d) {
				return _Utils_update(
					d,
					{R5: external, alv: model.Ij});
			})(
			A2($author$project$Components$Invoice$CreatePaymentModal$CustomerInvoice, invoiceOwnerId, invoice));
		var createPaymentModal = _v0.a;
		var createPaymentModalCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					m$: $elm$core$Maybe$Just(
						_Utils_Tuple2(
							createPaymentModal,
							$author$project$Api$Provider$CustomerInvoice$One$id(invoice)))
				}),
			A2($elm$core$Platform$Cmd$map, $author$project$Pages$Charges$New$CreatePaymentModalMsg, createPaymentModalCmd));
	});
var $author$project$Pages$Charges$New$showPaymentModal = F4(
	function (model, invoice, external, invoiceId) {
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil),
			A2(
				$elm$core$Maybe$map,
				$author$project$Utils$Tuple3$fromTuple2(_List_Nil),
				A2(
					$elm$core$Maybe$map,
					A3($author$project$Pages$Charges$New$initCreatePaymentModal, model, external, invoiceId),
					$author$project$Api$Data$toMaybe(invoice.k9))));
	});
var $author$project$Components$Charge$Form$toggle = function (_v0) {
	var model = _v0;
	return _Utils_update(
		model,
		{h8: !model.h8});
};
var $author$project$Pages$Charges$New$Email = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Pages$Charges$New$Pay = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Pages$Charges$New$SchedulePayment = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Charges$New$triggerAfterIssueAction = F2(
	function (afterIssueMsg, invoice) {
		switch (afterIssueMsg) {
			case 0:
				return A2(
					$elm$core$Task$perform,
					function (_v1) {
						return A2($author$project$Pages$Charges$New$Pay, invoice, false);
					},
					$elm$time$Time$now);
			case 1:
				return A2(
					$elm$core$Task$perform,
					function (_v2) {
						return A2($author$project$Pages$Charges$New$Pay, invoice, true);
					},
					$elm$time$Time$now);
			case 2:
				var _v3 = invoice.YD;
				if (!_v3.$) {
					var owner = _v3.a;
					return A2(
						$elm$core$Task$perform,
						function (_v4) {
							return A2(
								$author$project$Pages$Charges$New$Email,
								$author$project$Api$Common$Payable$Owner$Min$id(owner),
								invoice);
						},
						$elm$time$Time$now);
				} else {
					return $elm$core$Platform$Cmd$none;
				}
			default:
				return A2(
					$elm$core$Task$perform,
					function (_v5) {
						return $author$project$Pages$Charges$New$SchedulePayment(invoice);
					},
					$elm$time$Time$now);
		}
	});
var $author$project$Components$Charge$Form$Category = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Charge$Form$ChargeCreated = 1;
var $author$project$Components$Charge$Form$ChargeItem = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Charge$Form$EndDate = F2(
	function (a, b) {
		return {$: 14, a: a, b: b};
	});
var $author$project$Components$Charge$Form$GotPatient = function (a) {
	return {$: 20, a: a};
};
var $author$project$Components$Charge$Form$RoutingFields$GotPreview = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Charge$Form$RoutingFields$GotPreviewWithPayer = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Charge$Form$Location = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Charge$Form$Name = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Charge$Form$None = 0;
var $author$project$Components$Charge$Form$Patient = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Charge$Form$RoutingFields$PatientUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Charge$Form$Practitioner = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Charge$Form$RoutingFields = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Charge$Form$StartDate = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Components$Charge$Form$GotPreviewWithPayer = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Charge$Form$ChargeItemValidation = 1;
var $author$project$Components$Charge$Form$PatientValidation = 0;
var $author$project$Components$Charge$Form$PriceInCentsValidation = 3;
var $author$project$Components$Charge$Form$QuantityValidation = 2;
var $author$project$Components$Charge$Form$StartDateValidation = 4;
var $author$project$Components$Charge$Form$validateChargeItem = function (fields) {
	var _v0 = fields.mL;
	if (!_v0.$) {
		var chargeItem = _v0.a;
		var sponsorPayer = fields.Y6 === 1;
		return (chargeItem.acZ && sponsorPayer) ? _List_fromArray(
			[
				_Utils_Tuple2(1, '')
			]) : _List_Nil;
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Charge$Form$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.YY;
			},
			_Utils_Tuple2(0, 'Please select a patient.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.Bq;
			},
			_Utils_Tuple2(1, 'Please select a charge item.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.Dz;
			},
			_Utils_Tuple2(2, 'Please enter a quantity.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.Dw;
			},
			_Utils_Tuple2(3, 'Please enter an amount.')),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Charge$Form$validateChargeItem),
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.ab7;
			},
			_Utils_Tuple2(4, 'Please pick a date.'))
		]));
var $author$project$Components$Charge$Form$paramsWithPrice = F2(
	function (fields, previewData) {
		var priceInCents = function () {
			if (!(!fields.QD)) {
				var _v0 = _Utils_Tuple2(fields.mL, previewData);
				if (!_v0.a.$) {
					var chargeItem = _v0.a.a;
					return $elm$core$Maybe$Just(chargeItem.Dw | 0);
				} else {
					if (_v0.b.$ === 3) {
						var _v1 = _v0.a;
						var _v2 = _v0.b;
						var preview = _v2.a;
						return $elm$core$Maybe$Just(
							$author$project$Api$Provider$Charge$Calculate$issuedSubtotalInCents(preview) + $author$project$Api$Provider$Charge$Calculate$discountInCents(preview));
					} else {
						var _v3 = _v0.a;
						return $elm$core$Maybe$Just(
							fields.QD + A2(
								$elm$core$Maybe$withDefault,
								0,
								A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.Dw)));
					}
				}
			} else {
				return A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.Dw);
			}
		}();
		return {
			GW: fields.GW,
			mL: A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.ahP;
				},
				fields.mL),
			PB: fields.ab7,
			Qr: fields.Qr,
			QE: fields.QE,
			sb: fields.sb,
			Uk: $author$project$Api$Provider$Charge$Invoice($elm$core$Maybe$Nothing),
			ais: fields.ais,
			Bq: fields.Bq,
			YY: A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.ahP;
				},
				fields.YY),
			I6: $elm$core$Maybe$Nothing,
			aka: fields.aka,
			Dw: priceInCents,
			Dz: A2($elm$core$Maybe$withDefault, 1, fields.Dz),
			DA: A2($elm$core$Maybe$map, $author$project$Api$Provider$Uom$Shared$code, fields.DA)
		};
	});
var $author$project$Api$Charge$PayerType$payerTypeParam = function (payerType) {
	if (!payerType) {
		return $elm$core$Maybe$Just('patient');
	} else {
		return $elm$core$Maybe$Just('company');
	}
};
var $author$project$Components$Charge$Form$calculatePreviewWithPayer = F2(
	function (apiClient, model) {
		var _v0 = A2($author$project$Utils$Form$validate, $author$project$Components$Charge$Form$formFieldsValidator, model.f);
		if (!_v0.$) {
			var fields = $author$project$Utils$Form$fields(model.f);
			var params = A2($author$project$Components$Charge$Form$paramsWithPrice, fields, model.akd);
			var paramsWithPayer = _Utils_update(
				params,
				{
					I6: $elm$core$Maybe$Just(
						{
							ahP: fields.I6,
							amg: $author$project$Api$Charge$PayerType$payerTypeParam(fields.Y6)
						})
				});
			return _List_fromArray(
				[
					A4(
					$author$project$Api$Provider$Charge$calculate,
					$author$project$Api$Provider$Charge$chargesPath($author$project$Api$Data$providerPath),
					apiClient,
					paramsWithPayer,
					$author$project$Components$Charge$Form$GotPreviewWithPayer),
					A2(
					$elm$core$Task$perform,
					$author$project$Components$Charge$Form$RoutingFieldsMsg,
					$elm$core$Task$succeed(
						$author$project$Components$Charge$Form$RoutingFields$GotPreviewWithPayer($author$project$Api$Data$Loading)))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Charge$Form$GotChargeCreated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$Charge$NewInvoice = {$: 1};
var $author$project$Api$Provider$Charge$RoutedInvoice$One$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Charge$Calculate$routedInvoice = function (_v0) {
	var record = _v0;
	return record.aaa;
};
var $author$project$Components$Charge$Form$RoutingFields$routedInvoiceId = function (preview) {
	return $elm$core$Maybe$Just(
		A2(
			$elm$core$Maybe$withDefault,
			'new',
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$Charge$RoutedInvoice$One$id,
				$author$project$Api$Provider$Charge$Calculate$routedInvoice(preview))));
};
var $author$project$Components$Charge$Form$invoiceNotChanged = F2(
	function (previewData, fields) {
		return A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				function (preview_) {
					return _Utils_eq(
						$author$project$Components$Charge$Form$RoutingFields$routedInvoiceId(preview_),
						fields.Uk);
				},
				$author$project$Api$Data$toMaybe(previewData)));
	});
var $author$project$Components$Charge$Form$invoiceTypeParam = function (payertype) {
	if (!payertype) {
		return $elm$core$Maybe$Just('customer_invoice');
	} else {
		return $elm$core$Maybe$Just('company_invoice');
	}
};
var $author$project$Api$Provider$Charge$AdjudicatedPayer$One$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Components$Charge$Form$RoutingFields$adjudicatedPayerId = function (preview) {
	return A2(
		$elm$core$Maybe$map,
		$author$project$Api$Provider$Charge$AdjudicatedPayer$One$id,
		$author$project$Api$Provider$Charge$Calculate$adjudicatedPayer(preview));
};
var $author$project$Components$Charge$Form$payerNotChanged = F2(
	function (previewData, fields) {
		return A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				function (preview_) {
					return _Utils_eq(
						$author$project$Components$Charge$Form$RoutingFields$adjudicatedPayerId(preview_),
						fields.I6);
				},
				$author$project$Api$Data$toMaybe(previewData)));
	});
var $author$project$Components$Charge$Form$createParams = F2(
	function (fields, previewData) {
		var newSponsorInvoice = (fields.Y6 === 1) && _Utils_eq(
			fields.Uk,
			$elm$core$Maybe$Just('new'));
		var invoice = function () {
			if (A2($author$project$Components$Charge$Form$invoiceNotChanged, previewData, fields)) {
				return $author$project$Api$Provider$Charge$Invoice($elm$core$Maybe$Nothing);
			} else {
				var newPatientInvoice = (!fields.Y6) && _Utils_eq(
					fields.Uk,
					$elm$core$Maybe$Just('new'));
				return (newSponsorInvoice || newPatientInvoice) ? $author$project$Api$Provider$Charge$NewInvoice : $author$project$Api$Provider$Charge$Invoice(
					A2(
						$elm$core$Maybe$map,
						$elm$core$Basics$always(
							{
								ahP: fields.Uk,
								amg: $author$project$Components$Charge$Form$invoiceTypeParam(fields.Y6)
							}),
						fields.Uk));
			}
		}();
		var payer = (A2($author$project$Components$Charge$Form$payerNotChanged, previewData, fields) || ((!_Utils_eq(
			invoice,
			$author$project$Api$Provider$Charge$Invoice($elm$core$Maybe$Nothing))) && (!newSponsorInvoice))) ? $elm$core$Maybe$Nothing : A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$always(
				{
					ahP: fields.I6,
					amg: $author$project$Api$Charge$PayerType$payerTypeParam(fields.Y6)
				}),
			fields.I6);
		var baseParams = A2($author$project$Components$Charge$Form$paramsWithPrice, fields, previewData);
		return _Utils_update(
			baseParams,
			{Uk: invoice, I6: payer});
	});
var $author$project$Components$Charge$Form$createCharge = F3(
	function (apiClient, model, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4(
			$author$project$Api$Provider$Charge$create,
			$author$project$Api$Data$providerPath,
			apiClient,
			A2($author$project$Components$Charge$Form$createParams, fields, model.akd),
			$author$project$Components$Charge$Form$GotChargeCreated);
	});
var $author$project$Components$Charge$Form$PreviewDebounced = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Charge$Form$debouncePreview = function (cmd) {
	return A2(
		$elm$core$Task$perform,
		$author$project$Components$Charge$Form$PreviewDebounced,
		$elm$core$Task$succeed(cmd));
};
var $author$project$Components$Charge$Form$resetEndDate = function (fields) {
	var _v0 = _Utils_Tuple2(fields.Dz, fields.DA);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var quantity = _v0.a.a;
		var quantityUom = _v0.b.a;
		return _Utils_update(
			fields,
			{
				sb: A3($author$project$Utils$Uom$addTo, fields.ab7, quantityUom, quantity)
			});
	} else {
		return fields;
	}
};
var $author$project$Components$Charge$Form$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var patient = field.a;
				return _Utils_update(
					fields,
					{YY: patient});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						GW: $elm$core$Maybe$Nothing,
						c8: A2($author$project$Components$ResourceFilter$Category$setValue, $elm$core$Maybe$Nothing, fields.c8),
						mL: $elm$core$Maybe$Nothing,
						QD: 0,
						Bq: $elm$core$Maybe$Just(string),
						Dw: $elm$core$Maybe$Nothing
					});
			case 2:
				var string = field.a;
				return _Utils_update(
					fields,
					{Qr: string});
			case 3:
				var item = field.a;
				var category = item.GW;
				return $author$project$Components$Charge$Form$resetEndDate(
					_Utils_update(
						fields,
						{
							GW: A2($elm$core$Maybe$map, $author$project$Api$Provider$Category$Shared$id, category),
							c8: A2(
								$author$project$Components$ResourceFilter$Category$setValue,
								A2(
									$elm$core$Maybe$map,
									function (category_) {
										return {
											ahP: $author$project$Api$Provider$Category$Shared$id(category_),
											Bq: $author$project$Api$Provider$Category$Shared$name(category_)
										};
									},
									category),
								fields.c8),
							mL: $elm$core$Maybe$Just(item),
							Qr: A2($elm$core$Maybe$withDefault, '', item.Qr),
							Bq: $elm$core$Maybe$Just(item.Bq),
							Dw: $elm$core$Maybe$Just(
								$author$project$Currency$fromFloat(item.Dw)),
							_h: $elm$core$Maybe$Just(item.adP),
							DA: $elm$core$Maybe$Just(item.adP)
						}));
			case 4:
				var string = field.a;
				return $author$project$Components$Charge$Form$resetEndDate(
					_Utils_update(
						fields,
						{
							Dz: $elm$core$String$toInt(string)
						}));
			case 5:
				var string = field.a;
				var _v1 = $author$project$Utils$Uom$fromCode(string);
				if (!_v1.$) {
					var quantityUom = _v1.a;
					var quantity = function () {
						var _v2 = _Utils_Tuple2(fields.ab7, fields.sb);
						if ((!_v2.a.$) && (!_v2.b.$)) {
							var startDate = _v2.a.a;
							var endDate = _v2.b.a;
							return $elm$core$Maybe$Just(
								A3(
									$author$project$Utils$Uom$quantityBetween,
									quantityUom,
									startDate,
									$elm$core$Maybe$Just(endDate)));
						} else {
							return fields.Dz;
						}
					}();
					return $author$project$Components$Charge$Form$resetEndDate(
						_Utils_update(
							fields,
							{
								Dz: quantity,
								DA: $elm$core$Maybe$Just(quantityUom)
							}));
				} else {
					return _Utils_update(
						fields,
						{DA: $elm$core$Maybe$Nothing});
				}
			case 6:
				var currency = field.a;
				return _Utils_update(
					fields,
					{Dw: currency});
			case 7:
				var _int = field.a;
				return _Utils_update(
					fields,
					{QD: _int});
			case 9:
				var routingFields = field.a;
				return _Utils_update(
					fields,
					{Uk: routingFields.Us, I6: routingFields.ajW, Y6: routingFields.Y6});
			case 8:
				var bool = field.a;
				var priceInCents = bool ? fields.Dw : A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.Dw;
						},
						$author$project$Currency$fromFloat),
					fields.mL);
				return _Utils_update(
					fields,
					{QE: bool, Dw: priceInCents});
			case 10:
				var category = field.a;
				return _Utils_update(
					fields,
					{GW: category});
			case 11:
				var practitioner = field.a;
				return _Utils_update(
					fields,
					{
						aka: A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.ahP;
							},
							practitioner)
					});
			case 12:
				var location = field.a;
				return _Utils_update(
					fields,
					{
						ais: A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.ahP;
							},
							location)
					});
			case 13:
				var dateInput = field.a;
				var date = field.b;
				return $author$project$Components$Charge$Form$resetEndDate(
					_Utils_update(
						fields,
						{ab7: date, lx: dateInput}));
			default:
				var dateInput = field.a;
				var date = field.b;
				var _v3 = function () {
					var _v4 = _Utils_Tuple2(fields.ab7, date);
					if ((!_v4.a.$) && (!_v4.b.$)) {
						var startDate_ = _v4.a.a;
						var endDate = _v4.b.a;
						var startDate__ = (A2($justinmimbs$date$Date$compare, startDate_, endDate) === 2) ? endDate : startDate_;
						var quantityUom_ = A2($author$project$Utils$Uom$matchRange, startDate__, endDate);
						return _Utils_Tuple3(
							$elm$core$Maybe$Just(startDate__),
							$elm$core$Maybe$Just(quantityUom_),
							$elm$core$Maybe$Just(
								A3(
									$author$project$Utils$Uom$quantityBetween,
									quantityUom_,
									startDate__,
									$elm$core$Maybe$Just(endDate))));
					} else {
						return _Utils_Tuple3(fields.ab7, fields.DA, fields.Dz);
					}
				}();
				var startDate = _v3.a;
				var quantityUom = _v3.b;
				var quantity = _v3.c;
				return _Utils_update(
					fields,
					{sb: date, sd: dateInput, Dz: quantity, DA: quantityUom, ab7: startDate});
		}
	});
var $author$project$Components$Charge$Form$GotChargeOverridden = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Charge$Form$overrideChargeDiscount = F3(
	function (apiClient, id, form) {
		var fields = $author$project$Utils$Form$fields(form);
		return fields.QE ? _Utils_Tuple2(
			A3($author$project$Api$Provider$Charge$CoverageDiscount$override, apiClient, id, $author$project$Components$Charge$Form$GotChargeOverridden),
			0) : _Utils_Tuple2($elm$core$Platform$Cmd$none, 1);
	});
var $author$project$Components$Charge$Form$PreviewDebouncedMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Charge$Form$previewDebounceConfig = {
	alK: $jinjor$elm_debounce$Debounce$later(1000),
	ame: $author$project$Components$Charge$Form$PreviewDebouncedMsg
};
var $author$project$Components$ResourceFilter$Patient$setValue = F2(
	function (resource, model) {
		return _Utils_update(
			model,
			{
				Jy: function () {
					if (!resource.$) {
						var resource_ = resource.a;
						return $author$project$Components$ResourceFilter$One(resource_);
					} else {
						return $author$project$Components$ResourceFilter$All;
					}
				}()
			});
	});
var $author$project$Components$Charge$Form$RoutingFields$GotPatient = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Charge$Form$RoutingFields$None = 0;
var $author$project$Components$Charge$Form$RoutingFields$clearRoutingFields = function (fields) {
	return _Utils_update(
		fields,
		{Us: $elm$core$Maybe$Nothing, ajW: $elm$core$Maybe$Nothing});
};
var $author$project$Api$Charge$PayerType$adjudicatedToSponsor = function (preview) {
	return $author$project$Api$Charge$PayerType$toPayerType(
		$author$project$Api$Charge$PayerType$adjudicatedType(preview)) === 1;
};
var $author$project$Api$Provider$CustomerInvoice$All$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Components$Charge$Form$RoutingFields$firstInvoiceOrNewId = function (invoices) {
	return $elm$core$Maybe$Just(
		A2(
			$elm$core$Maybe$withDefault,
			'new',
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$CustomerInvoice$All$id,
				A2(
					$elm$core$Maybe$andThen,
					$elm$core$List$head,
					$author$project$Api$Data$toMaybe(invoices)))));
};
var $author$project$Components$Charge$Form$RoutingFields$defaultInvoiceId = F4(
	function (fields, dataCustomerInvoices, dataPreview, dataPreviewWithPayer) {
		if (dataPreview.$ === 3) {
			var preview = dataPreview.a;
			var _v1 = _Utils_Tuple2(
				fields.Y6,
				$author$project$Api$Charge$PayerType$adjudicatedToSponsor(preview));
			if (!_v1.a) {
				if (!_v1.b) {
					var _v2 = _v1.a;
					return _Utils_eq(
						fields.ajW,
						$author$project$Components$Charge$Form$RoutingFields$adjudicatedPayerId(preview)) ? $author$project$Components$Charge$Form$RoutingFields$routedInvoiceId(preview) : $author$project$Components$Charge$Form$RoutingFields$firstInvoiceOrNewId(dataCustomerInvoices);
				} else {
					var _v3 = _v1.a;
					return $author$project$Components$Charge$Form$RoutingFields$firstInvoiceOrNewId(dataCustomerInvoices);
				}
			} else {
				if (!_v1.b) {
					var _v4 = _v1.a;
					return A2(
						$elm$core$Maybe$andThen,
						$author$project$Components$Charge$Form$RoutingFields$routedInvoiceId,
						$author$project$Api$Data$toMaybe(dataPreviewWithPayer));
				} else {
					var _v5 = _v1.a;
					return $author$project$Components$Charge$Form$RoutingFields$routedInvoiceId(preview);
				}
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Api$Provider$Patient$One$company = function (_v0) {
	var record = _v0.b;
	return record.afQ;
};
var $author$project$Components$Charge$Form$RoutingFields$patientCurrentCompany = function (patient) {
	return $author$project$Api$Provider$Patient$One$company(patient);
};
var $author$project$Api$Provider$Patient$One$payer = function (_v0) {
	var record = _v0.b;
	return record.I6;
};
var $author$project$Components$Charge$Form$RoutingFields$patientPayerId = function (patient) {
	var _v0 = $author$project$Api$Provider$Patient$One$payer(patient);
	if (!_v0.$) {
		var payer = _v0.a;
		return $elm$core$Maybe$Just(
			$author$project$Api$Provider$Patient$Min$id(payer));
	} else {
		return $elm$core$Maybe$Just(
			$author$project$Api$Provider$Patient$One$id(patient));
	}
};
var $author$project$Components$Charge$Form$RoutingFields$defaultPayerId = F3(
	function (payerType, dataPatient, dataPreview) {
		var _v0 = _Utils_Tuple2(dataPatient, dataPreview);
		if ((_v0.a.$ === 3) && (_v0.b.$ === 3)) {
			var _v1 = _v0.a;
			var patient = _v1.a;
			var _v2 = _v0.b;
			var preview = _v2.a;
			var _v3 = _Utils_Tuple2(
				payerType,
				$author$project$Api$Charge$PayerType$adjudicatedToSponsor(preview));
			if (!_v3.a) {
				if (!_v3.b) {
					var _v4 = _v3.a;
					return $author$project$Components$Charge$Form$RoutingFields$adjudicatedPayerId(preview);
				} else {
					var _v5 = _v3.a;
					return $author$project$Components$Charge$Form$RoutingFields$patientPayerId(patient);
				}
			} else {
				if (!_v3.b) {
					var _v6 = _v3.a;
					return A2(
						$elm$core$Maybe$map,
						$author$project$Api$Provider$Company$Min$id,
						$author$project$Components$Charge$Form$RoutingFields$patientCurrentCompany(patient));
				} else {
					var _v7 = _v3.a;
					return $author$project$Components$Charge$Form$RoutingFields$adjudicatedPayerId(preview);
				}
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Charge$Form$RoutingFields$GotCustomerInvoices = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Charge$Form$RoutingFields$GotSponsorInvoices = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Invoice$All$Invoice = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Invoice$All$Record = F6(
	function (invoiceDate, humanStatus, amountInCents, paidInCents, dueInCents, description) {
		return {LE: amountInCents, Qr: description, QY: dueInCents, TH: humanStatus, Uq: invoiceDate, YI: paidInCents};
	});
var $author$project$Api$Provider$Invoice$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'description',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'due_in_cents',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'paid_in_cents',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'amount_in_cents',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'human_status',
					$author$project$Api$Invoice$Status$decode,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'invoice_date',
						$author$project$Utils$Date$decode,
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$Invoice$All$Record)))))));
var $author$project$Api$Provider$Invoice$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Invoice$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Invoice$Min$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Invoice$All$Invoice)));
var $author$project$Api$Provider$Invoice$listDefaults = {ajJ: $author$project$Api$Pagination$init, alA: $author$project$Api$Sort$init, alH: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$Invoice$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Invoice$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ),
				function () {
				var _v0 = options.alH;
				if (!_v0.$) {
					var list_ = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$list, 'status', list_)
						]);
				} else {
					return _List_Nil;
				}
			}()
			]));
};
var $author$project$Api$Provider$Company$Invoice$list = F4(
	function (apiClient, companyId, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Invoice$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Invoice$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Company$Invoice$invoicesPath(companyId))));
	});
var $author$project$Api$Provider$CustomerInvoice$All$CustomerInvoice = $elm$core$Basics$identity;
var $author$project$Api$Provider$CustomerInvoice$All$Record = function (id) {
	return function (date) {
		return function (dueInCents) {
			return function (invoiceNumber) {
				return function (humanStatus) {
					return function (isPaymentScheduled) {
						return function (paymentScheduledOn) {
							return function (status) {
								return function (issuedTotalInCents) {
									return function (totalInCents) {
										return function (lastSentAt) {
											return function (paidAt) {
												return function (nextScheduledPaymentDate) {
													return {PB: date, QY: dueInCents, TH: humanStatus, ahP: id, Uu: invoiceNumber, U3: isPaymentScheduled, Vs: issuedTotalInCents, VL: lastSentAt, XU: nextScheduledPaymentDate, YH: paidAt, Zf: paymentScheduledOn, alH: status, adp: totalInCents};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$CustomerInvoice$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'next_scheduled_payment_date',
	$elm$json$Json$Decode$maybe($author$project$Utils$Date$decode),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'paid_at',
		$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'last_sent_at',
			$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'total_in_cents',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'issued_total_in_cents',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'status',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'payment_scheduled_on',
							$elm$json$Json$Decode$maybe($author$project$Utils$Date$decode),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'is_payment_scheduled',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'human_status',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'invoice_number',
										$elm$json$Json$Decode$int,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'due_in_cents',
											$elm$json$Json$Decode$int,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'date',
												$author$project$Utils$Date$decode,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'id',
													$elm$json$Json$Decode$string,
													$elm$json$Json$Decode$succeed($author$project$Api$Provider$CustomerInvoice$All$Record))))))))))))));
var $author$project$Api$Provider$CustomerInvoice$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CustomerInvoice$All$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CustomerInvoice$listDefaults = {HB: $elm$core$Maybe$Nothing, HE: _List_Nil, YD: $elm$core$Maybe$Nothing, ajJ: $author$project$Api$Pagination$init, alA: $author$project$Api$Sort$init, JV: $elm$core$Maybe$Nothing, alH: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$CustomerInvoice$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$CustomerInvoice$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ),
				function () {
				var _v0 = options.alH;
				if (!_v0.$) {
					var list_ = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$list, 'status', list_)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.YD;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'owner', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.JV;
				if (!_v2.$) {
					var start_ = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$date, 'start', start_)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v3 = options.HB;
				if (!_v3.$) {
					var end_ = _v3.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$date, 'end', end_)
						]);
				} else {
					return _List_Nil;
				}
			}()
			]));
};
var $author$project$Api$Provider$CustomerInvoice$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$CustomerInvoice$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$CustomerInvoice$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$CustomerInvoice$customerInvoicesPath)));
	});
var $author$project$Components$Charge$Form$RoutingFields$listInvoices = F2(
	function (apiClient, model) {
		var _v0 = _Utils_Tuple2(model.ahi.Y6, model.ahi.ajW);
		_v0$2:
		while (true) {
			if (!_v0.a) {
				if (!_v0.b.$) {
					var _v1 = _v0.a;
					var options = function (d) {
						return _Utils_update(
							d,
							{
								YD: model.ahi.ajW,
								ajJ: model.ajJ,
								alH: $elm$core$Maybe$Just(
									_List_fromArray(
										['draft']))
							});
					};
					return A3($author$project$Api$Provider$CustomerInvoice$list, apiClient, options, $author$project$Components$Charge$Form$RoutingFields$GotCustomerInvoices);
				} else {
					break _v0$2;
				}
			} else {
				if (!_v0.b.$) {
					var _v2 = _v0.a;
					var id = _v0.b.a;
					var options = function (d) {
						return _Utils_update(
							d,
							{
								ajJ: model.ajJ,
								alH: $elm$core$Maybe$Just(
									_List_fromArray(
										['draft']))
							});
					};
					return A4($author$project$Api$Provider$Company$Invoice$list, apiClient, id, options, $author$project$Components$Charge$Form$RoutingFields$GotSponsorInvoices);
				} else {
					break _v0$2;
				}
			}
		}
		return $elm$core$Platform$Cmd$none;
	});
var $author$project$Components$Charge$Form$RoutingFields$PreviewWithPayerRequested = 1;
var $author$project$Components$Charge$Form$RoutingFields$requestPreviewWithPayer = F2(
	function (payerType, dataPreview) {
		var _v0 = _Utils_Tuple2(payerType, dataPreview);
		if ((_v0.a === 1) && (_v0.b.$ === 3)) {
			var _v1 = _v0.a;
			var _v2 = _v0.b;
			var preview = _v2.a;
			return $author$project$Api$Charge$PayerType$adjudicatedToSponsor(preview) ? 0 : 1;
		} else {
			return 0;
		}
	});
var $author$project$Components$Charge$Form$RoutingFields$setInvoicesAsLoading = function (model) {
	var _v0 = function () {
		var _v1 = _Utils_Tuple2(model.ahi.Y6, model.ahi.ajW);
		_v1$2:
		while (true) {
			if (!_v1.a) {
				if (!_v1.b.$) {
					var _v2 = _v1.a;
					return _Utils_Tuple2($author$project$Api$Data$Loading, model.fi);
				} else {
					break _v1$2;
				}
			} else {
				if (!_v1.b.$) {
					var _v3 = _v1.a;
					return _Utils_Tuple2(model.ct, $author$project$Api$Data$Loading);
				} else {
					break _v1$2;
				}
			}
		}
		return _Utils_Tuple2(model.ct, model.fi);
	}();
	var customerInvoices = _v0.a;
	var sponsorInvoices = _v0.b;
	return _Utils_update(
		model,
		{ct: customerInvoices, fi: sponsorInvoices});
};
var $author$project$Components$Charge$Form$RoutingFields$initPatientPayerFilter = F2(
	function (apiClient, id) {
		return A2(
			$author$project$Components$ResourceFilter$Patient$init,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Select a Patient', Lr: false, akb: id, akl: id});
			});
	});
var $author$project$Components$Charge$Form$RoutingFields$updatePayerId = F2(
	function (payerId, fields) {
		return _Utils_update(
			fields,
			{ajW: payerId});
	});
var $author$project$Components$Charge$Form$RoutingFields$updatePayerType = F2(
	function (payerType, fields) {
		return _Utils_eq(fields.Y6, payerType) ? fields : _Utils_update(
			fields,
			{Us: $elm$core$Maybe$Nothing, ajW: $elm$core$Maybe$Nothing, Y6: payerType});
	});
var $author$project$Components$Charge$Form$RoutingFields$updateFromPreview = F4(
	function (apiClient, model, dataPreview, preview) {
		var newFields = A2(
			$author$project$Components$Charge$Form$RoutingFields$updatePayerId,
			$author$project$Components$Charge$Form$RoutingFields$adjudicatedPayerId(preview),
			A2(
				$author$project$Components$Charge$Form$RoutingFields$updatePayerType,
				$author$project$Api$Charge$PayerType$toPayerType(
					$author$project$Api$Charge$PayerType$adjudicatedType(preview)),
				model.ahi));
		var _v0 = function () {
			var _v1 = model.YY;
			if (_v1.$ === 3) {
				var patient = _v1.a;
				return A2(
					$author$project$Components$Charge$Form$RoutingFields$initPatientPayerFilter,
					apiClient,
					$author$project$Components$Charge$Form$RoutingFields$patientPayerId(patient));
			} else {
				return _Utils_Tuple2(model.eP, $elm$core$Platform$Cmd$none);
			}
		}();
		var newPatientPayerFilter = _v0.a;
		var newPatientPayerFilterCmd = _v0.b;
		var newModel = $author$project$Components$Charge$Form$RoutingFields$setInvoicesAsLoading(
			_Utils_update(
				model,
				{ahi: newFields, eP: newPatientPayerFilter, akd: dataPreview}));
		return {
			GZ: $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$RoutingFields$PatientPayerFilterMsg, newPatientPayerFilterCmd),
						A2($author$project$Components$Charge$Form$RoutingFields$listInvoices, apiClient, newModel)
					])),
			agZ: 0,
			aiO: newModel,
			aR: _List_Nil
		};
	});
var $author$project$Components$Charge$Form$RoutingFields$updateInvoiceId = F2(
	function (invoiceId, fields) {
		return _Utils_update(
			fields,
			{Us: invoiceId});
	});
var $author$project$Components$Charge$Form$RoutingFields$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var patientId = msg.a;
				return {
					GZ: A3($author$project$Api$Provider$Patient$retrieve, apiClient, patientId, $author$project$Components$Charge$Form$RoutingFields$GotPatient),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							ct: $author$project$Api$Data$NotAsked,
							ahi: $author$project$Components$Charge$Form$RoutingFields$clearRoutingFields(model.ahi),
							YY: $author$project$Api$Data$Loading,
							YZ: patientId,
							tI: false,
							hl: $author$project$Api$Data$NotAsked,
							fi: $author$project$Api$Data$NotAsked
						}),
					aR: _List_Nil
				};
			case 1:
				var response = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{YY: response}),
					aR: _List_Nil
				};
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					var preview = response.a;
					return A4($author$project$Components$Charge$Form$RoutingFields$updateFromPreview, apiClient, model, response, preview);
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{akd: response}),
						aR: _List_Nil
					};
				}
			case 3:
				var response = msg.a;
				var newFields = function () {
					if (response.$ === 3) {
						return A2(
							$author$project$Components$Charge$Form$RoutingFields$updateInvoiceId,
							A4($author$project$Components$Charge$Form$RoutingFields$defaultInvoiceId, model.ahi, model.ct, model.akd, response),
							model.ahi);
					} else {
						return model.ahi;
					}
				}();
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{ahi: newFields, hl: response}),
					aR: _List_Nil
				};
			case 4:
				var response = msg.a;
				var newFields = A2(
					$author$project$Components$Charge$Form$RoutingFields$updateInvoiceId,
					A4($author$project$Components$Charge$Form$RoutingFields$defaultInvoiceId, model.ahi, model.ct, model.akd, model.hl),
					model.ahi);
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{ahi: newFields, fi: response}),
					aR: _List_Nil
				};
			case 5:
				var response = msg.a;
				var newFields = A2(
					$author$project$Components$Charge$Form$RoutingFields$updateInvoiceId,
					A4($author$project$Components$Charge$Form$RoutingFields$defaultInvoiceId, model.ahi, response, model.akd, model.hl),
					model.ahi);
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{ct: response, ahi: newFields}),
					aR: _List_Nil
				};
			case 6:
				var payerType = msg.a;
				var newFields = A2(
					$author$project$Components$Charge$Form$RoutingFields$updatePayerId,
					A3($author$project$Components$Charge$Form$RoutingFields$defaultPayerId, payerType, model.YY, model.akd),
					A2($author$project$Components$Charge$Form$RoutingFields$updatePayerType, payerType, model.ahi));
				var newModel = $author$project$Components$Charge$Form$RoutingFields$setInvoicesAsLoading(
					_Utils_update(
						model,
						{ahi: newFields, tI: true}));
				return {
					GZ: A2($author$project$Components$Charge$Form$RoutingFields$listInvoices, apiClient, newModel),
					agZ: A2($author$project$Components$Charge$Form$RoutingFields$requestPreviewWithPayer, payerType, model.akd),
					aiO: newModel,
					aR: _List_Nil
				};
			case 7:
				var subMsg = msg.a;
				var patientPayerFilterResult = A3($author$project$Components$ResourceFilter$Patient$update, apiClient, subMsg, model.eP);
				var _v3 = _Utils_Tuple2(patientPayerFilterResult.agZ, model.ahi.Y6);
				if (((!_v3.a.$) && (!_v3.a.a.$)) && (!_v3.b)) {
					var patient = _v3.a.a.a;
					var _v4 = _v3.b;
					var newModel = $author$project$Components$Charge$Form$RoutingFields$setInvoicesAsLoading(
						_Utils_update(
							model,
							{
								ahi: A2(
									$author$project$Components$Charge$Form$RoutingFields$updatePayerId,
									$elm$core$Maybe$Just(
										$author$project$Api$Provider$Patient$All$id(patient)),
									model.ahi),
								eP: patientPayerFilterResult.aiO
							}));
					return {
						GZ: $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$RoutingFields$PatientPayerFilterMsg, patientPayerFilterResult.GZ),
									A2($author$project$Components$Charge$Form$RoutingFields$listInvoices, apiClient, newModel)
								])),
						agZ: 0,
						aiO: newModel,
						aR: patientPayerFilterResult.aR
					};
				} else {
					return {
						GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$RoutingFields$PatientPayerFilterMsg, patientPayerFilterResult.GZ),
						agZ: 0,
						aiO: _Utils_update(
							model,
							{eP: patientPayerFilterResult.aiO}),
						aR: patientPayerFilterResult.aR
					};
				}
			case 8:
				var payerId = msg.a;
				var newModel = $author$project$Components$Charge$Form$RoutingFields$setInvoicesAsLoading(
					_Utils_update(
						model,
						{
							ahi: A2(
								$author$project$Components$Charge$Form$RoutingFields$updatePayerId,
								$elm$core$Maybe$Just(payerId),
								model.ahi)
						}));
				return {
					GZ: A2($author$project$Components$Charge$Form$RoutingFields$listInvoices, apiClient, newModel),
					agZ: A2($author$project$Components$Charge$Form$RoutingFields$requestPreviewWithPayer, 1, model.akd),
					aiO: newModel,
					aR: _List_Nil
				};
			case 9:
				var invoiceId = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							ahi: A2(
								$author$project$Components$Charge$Form$RoutingFields$updateInvoiceId,
								$elm$core$Maybe$Just(invoiceId),
								model.ahi)
						}),
					aR: _List_Nil
				};
			case 10:
				var invoiceId = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							ahi: A2(
								$author$project$Components$Charge$Form$RoutingFields$updateInvoiceId,
								$elm$core$Maybe$Just(invoiceId),
								model.ahi)
						}),
					aR: _List_Nil
				};
			default:
				var currentDate = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							dd: $elm$core$Maybe$Just(currentDate)
						}),
					aR: _List_Nil
				};
		}
	});
var $author$project$Components$Charge$Form$GotPreview = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Charge$Form$shouldCalculatePreview = function (field) {
	switch (field.$) {
		case 0:
			return true;
		case 1:
			return false;
		case 3:
			return true;
		case 4:
			return true;
		case 5:
			return true;
		case 6:
			return true;
		case 7:
			return true;
		case 2:
			return false;
		case 13:
			return true;
		case 14:
			return true;
		case 10:
			return true;
		case 8:
			return true;
		case 9:
			return false;
		case 11:
			return false;
		default:
			return false;
	}
};
var $author$project$Components$Charge$Form$validPreviewFields = function (fields) {
	return $author$project$Utils$Maybe$toBool(fields.Bq) && (A2($elm$core$Maybe$withDefault, 0, fields.Dz) > 0);
};
var $author$project$Components$Charge$Form$calculatePreview = F4(
	function (apiClient, field, form, model) {
		var fields = $author$project$Utils$Form$fields(form);
		var _v0 = ($author$project$Components$Charge$Form$shouldCalculatePreview(field) && $author$project$Components$Charge$Form$validPreviewFields(fields)) ? A2(
			$author$project$Utils$Tuple3$fromTuple2,
			A2(
				$elm$core$Task$perform,
				$author$project$Components$Charge$Form$RoutingFieldsMsg,
				$elm$core$Task$succeed(
					$author$project$Components$Charge$Form$RoutingFields$GotPreview($author$project$Api$Data$Loading))),
			A3(
				$jinjor$elm_debounce$Debounce$push,
				$author$project$Components$Charge$Form$previewDebounceConfig,
				A4(
					$author$project$Api$Provider$Charge$calculate,
					$author$project$Api$Provider$Charge$chargesPath($author$project$Api$Data$providerPath),
					apiClient,
					A2($author$project$Components$Charge$Form$paramsWithPrice, fields, model.akd),
					$author$project$Components$Charge$Form$GotPreview),
				model.eW)) : _Utils_Tuple3(model.eW, $elm$core$Platform$Cmd$none, $elm$core$Platform$Cmd$none);
		var newDebouncer = _v0.a;
		var cmd = _v0.b;
		var routingFieldsCmd = _v0.c;
		return _Utils_Tuple2(
			($author$project$Components$Charge$Form$shouldCalculatePreview(field) && $author$project$Components$Charge$Form$validPreviewFields(fields)) ? _Utils_update(
				model,
				{akd: $author$project$Api$Data$Loading, eW: newDebouncer}) : ((!$author$project$Components$Charge$Form$validPreviewFields(fields)) ? _Utils_update(
				model,
				{akd: $author$project$Api$Data$NotAsked, eW: newDebouncer}) : _Utils_update(
				model,
				{eW: newDebouncer})),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[cmd, routingFieldsCmd])));
	});
var $author$project$Components$Charge$Form$updateForm = F4(
	function (apiClient, model, field, form) {
		var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Charge$Form$formFieldsUpdate, field, form);
		return A4(
			$author$project$Components$Charge$Form$calculatePreview,
			apiClient,
			field,
			newForm,
			_Utils_update(
				model,
				{f: newForm}));
	});
var $author$project$Components$Charge$Form$updateDateInputFormField = F7(
	function (apiClient, model, dateInput, subMsg, toMsg, field, fieldGetter) {
		var fields = $author$project$Utils$Form$fields(model.f);
		var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
		var newDateInput = _v0.a;
		var subCmd = _v0.b;
		var event = _v0.c;
		var _v1 = function () {
			if (event.$ === 1) {
				var date = event.a;
				return _Utils_Tuple2(
					A2(field, newDateInput, date),
					!_Utils_eq(
						date,
						fieldGetter(fields)));
			} else {
				return _Utils_Tuple2(
					A2(
						field,
						newDateInput,
						fieldGetter(fields)),
					false);
			}
		}();
		var dateField = _v1.a;
		var shouldPreview = _v1.b;
		var _v3 = shouldPreview ? A4($author$project$Components$Charge$Form$updateForm, apiClient, model, dateField, model.f) : _Utils_Tuple2(
			_Utils_update(
				model,
				{
					f: A3($author$project$Utils$Form$update, $author$project$Components$Charge$Form$formFieldsUpdate, dateField, model.f)
				}),
			$elm$core$Platform$Cmd$none);
		var newModel = _v3.a;
		var formCmd = _v3.b;
		return {
			GZ: $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						formCmd,
						A2(
						$elm$core$Platform$Cmd$map,
						toMsg(newDateInput),
						subCmd)
					])),
			agZ: 0,
			aiO: newModel,
			aR: _List_Nil
		};
	});
var $author$project$Components$Charge$Form$updateFilters = F3(
	function (apiClient, patient, model) {
		var _v0 = function () {
			var _v1 = _Utils_Tuple2(
				$author$project$Api$Provider$Patient$One$location(patient),
				$author$project$Api$Provider$Patient$One$practitioner(patient));
			if (!_v1.a.$) {
				if (!_v1.b.$) {
					var location = _v1.a.a;
					var practitioner = _v1.b.a;
					var practitionerResourceFilter_ = function (value) {
						return A2($author$project$Components$ResourceFilter$Practitioner$setValue, value, model.hk);
					}(
						$author$project$Components$ResourceFilter$Practitioner$resourceFromShared(
							$elm$core$Maybe$Just(
								$author$project$Api$Practitioner$Shared$Provider(practitioner))));
					var locationResourceFilter_ = function (value) {
						return A2($author$project$Components$ResourceFilter$Location$setValue, value, model.os);
					}(
						$author$project$Components$ResourceFilter$Location$resourceFromShared(
							$elm$core$Maybe$Just(
								$author$project$Api$Location$Shared$Provider(location))));
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(locationResourceFilter_),
						$elm$core$Maybe$Just(practitionerResourceFilter_));
				} else {
					var location = _v1.a.a;
					var _v2 = _v1.b;
					var locationResourceFilter_ = function (value) {
						return A2($author$project$Components$ResourceFilter$Location$setValue, value, model.os);
					}(
						$author$project$Components$ResourceFilter$Location$resourceFromShared(
							$elm$core$Maybe$Just(
								$author$project$Api$Location$Shared$Provider(location))));
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(locationResourceFilter_),
						$elm$core$Maybe$Nothing);
				}
			} else {
				if (!_v1.b.$) {
					var _v3 = _v1.a;
					var practitioner = _v1.b.a;
					var practitionerResourceFilter_ = function (value) {
						return A2($author$project$Components$ResourceFilter$Practitioner$setValue, value, model.hk);
					}(
						$author$project$Components$ResourceFilter$Practitioner$resourceFromShared(
							$elm$core$Maybe$Just(
								$author$project$Api$Practitioner$Shared$Provider(practitioner))));
					return _Utils_Tuple2(
						$elm$core$Maybe$Nothing,
						$elm$core$Maybe$Just(practitionerResourceFilter_));
				} else {
					var _v4 = _v1.a;
					var _v5 = _v1.b;
					return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
				}
			}
		}();
		var locationResourceFilter = _v0.a;
		var practitionerResourceFilter = _v0.b;
		var _v6 = function () {
			if (!practitionerResourceFilter.$) {
				var filter = practitionerResourceFilter.a;
				return _Utils_Tuple2(filter, $elm$core$Platform$Cmd$none);
			} else {
				return $author$project$Components$Charge$Form$initPractitionerResourceFilter(apiClient);
			}
		}();
		var newPractitionerResourceFilter = _v6.a;
		var newPractitionerResourceFilterCmd = _v6.b;
		var _v8 = function () {
			if (!locationResourceFilter.$) {
				var filter = locationResourceFilter.a;
				return _Utils_Tuple2(filter, $elm$core$Platform$Cmd$none);
			} else {
				return $author$project$Components$Charge$Form$initLocationResourceFilter(apiClient);
			}
		}();
		var newLocationResourceFilter = _v8.a;
		var newLocationResourceFilterCmd = _v8.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{os: newLocationResourceFilter, hk: newPractitionerResourceFilter}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$LocationResourceFilterMsg, newLocationResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$PractitionerResourceFilterMsg, newPractitionerResourceFilterCmd)
					])));
	});
var $author$project$Components$Charge$Form$DiscountInCents = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Charge$Form$PriceInCents = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Charge$Form$updateFormFromPreview = F2(
	function (preview, form) {
		return A3(
			$author$project$Utils$Form$update,
			$author$project$Components$Charge$Form$formFieldsUpdate,
			$author$project$Components$Charge$Form$DiscountInCents(
				$author$project$Api$Provider$Charge$Calculate$discountInCents(preview)),
			A3(
				$author$project$Utils$Form$update,
				$author$project$Components$Charge$Form$formFieldsUpdate,
				$author$project$Components$Charge$Form$PriceInCents(
					$elm$core$Maybe$Just(
						$author$project$Currency$fromInt(
							$author$project$Api$Provider$Charge$Calculate$priceInCents(preview)))),
				form));
	});
var $author$project$Components$Charge$Form$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var _v2 = A4($author$project$Components$Charge$Form$updateForm, apiClient, model, field, model.f);
				var newModel = _v2.a;
				var formCmd = _v2.b;
				return {GZ: formCmd, agZ: 0, aiO: newModel, aR: _List_Nil};
			case 1:
				var _v3 = A2($author$project$Utils$Form$validate, $author$project$Components$Charge$Form$formFieldsValidator, model.f);
				if (!_v3.$) {
					var _v4 = _v3.a;
					var form = _v4.a;
					var validFormFields = _v4.b;
					return {
						GZ: A3($author$project$Components$Charge$Form$createCharge, apiClient, model, validFormFields),
						agZ: 0,
						aiO: _Utils_update(
							model,
							{afx: $author$project$Api$Data$Loading, f: form}),
						aR: _List_Nil
					};
				} else {
					var newForm = _v3.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{f: newForm}),
						aR: _List_Nil
					};
				}
			case 2:
				var newPatientFilter = A2($author$project$Components$ResourceFilter$Patient$setValue, $elm$core$Maybe$Nothing, model.oY);
				var newChargeItemFilter = A2($author$project$Components$ResourceFilter$ChargeItem$setValue, $author$project$Components$ResourceFilter$All, model.cq);
				var excludeLabs = A2($author$project$Api$Provider$Practice$One$featureEnabled, 6, model.ZV);
				var _v5 = $author$project$Components$DateInput$init;
				var startDateInput = _v5.a;
				var startDateInputCmd = _v5.b;
				var _v6 = $author$project$Components$Charge$Form$initPractitionerResourceFilter(apiClient);
				var practitionerResourceFilter = _v6.a;
				var practitionerResourceFilterCmd = _v6.b;
				var _v7 = $author$project$Components$Charge$Form$initLocationResourceFilter(apiClient);
				var locationResourceFilter = _v7.a;
				var locationResourceFilterCmd = _v7.b;
				var _v8 = $author$project$Components$DateInput$init;
				var endDateInput = _v8.a;
				var endDateInputCmd = _v8.b;
				var _v9 = A3($author$project$Components$Charge$Form$initCategoryResourceFilter, apiClient, model.aa4, excludeLabs);
				var categoryResourceFilter = _v9.a;
				var categoryResourceFilterCmd = _v9.b;
				var newModel = _Utils_update(
					model,
					{
						f: $author$project$Utils$Form$init(
							A4(
								$author$project$Components$Charge$Form$initFormFields,
								$elm$core$Maybe$Just(model.dd),
								startDateInput,
								endDateInput,
								categoryResourceFilter)),
						cq: newChargeItemFilter,
						os: locationResourceFilter,
						oY: newPatientFilter,
						hk: practitionerResourceFilter,
						akd: $author$project$Api$Data$NotAsked
					});
				return {
					GZ: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Task$perform,
								$author$project$Components$Charge$Form$RoutingFieldsMsg,
								$elm$core$Task$succeed(
									$author$project$Components$Charge$Form$RoutingFields$GotPreview($author$project$Api$Data$NotAsked))),
								A2(
								$elm$core$Platform$Cmd$map,
								$author$project$Components$Charge$Form$StartDateInputMsg(startDateInput),
								startDateInputCmd),
								A2(
								$elm$core$Platform$Cmd$map,
								$author$project$Components$Charge$Form$EndDateInputMsg(endDateInput),
								endDateInputCmd),
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$CategoryResourceFilterMsg, categoryResourceFilterCmd),
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$LocationResourceFilterMsg, locationResourceFilterCmd),
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$PractitionerResourceFilterMsg, practitionerResourceFilterCmd)
							])),
					agZ: 0,
					aiO: newModel,
					aR: _List_Nil
				};
			case 3:
				var newChargeItemFilter = A2($author$project$Components$ResourceFilter$ChargeItem$setValue, $author$project$Components$ResourceFilter$All, model.cq);
				var excludeLabs = A2($author$project$Api$Provider$Practice$One$featureEnabled, 6, model.ZV);
				var _v10 = $author$project$Components$DateInput$init;
				var startDateInput = _v10.a;
				var startDateInputCmd = _v10.b;
				var _v11 = function () {
					var _v12 = model.YY;
					if (!_v12.$) {
						var patient = _v12.a;
						return A3($author$project$Components$Charge$Form$updateFilters, apiClient, patient, model);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				}();
				var filtersMsg = _v11.b;
				var _v13 = $author$project$Components$DateInput$init;
				var endDateInput = _v13.a;
				var endDateInputCmd = _v13.b;
				var _v14 = A3($author$project$Components$Charge$Form$initCategoryResourceFilter, apiClient, model.aa4, excludeLabs);
				var categoryResourceFilter = _v14.a;
				var categoryResourceFilterCmd = _v14.b;
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Charge$Form$formFieldsUpdate,
					$author$project$Components$Charge$Form$Patient(
						$author$project$Utils$Form$fields(model.f).YY),
					$author$project$Utils$Form$init(
						A4(
							$author$project$Components$Charge$Form$initFormFields,
							$elm$core$Maybe$Just(model.dd),
							startDateInput,
							endDateInput,
							categoryResourceFilter)));
				return {
					GZ: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Task$perform,
								$author$project$Components$Charge$Form$RoutingFieldsMsg,
								$elm$core$Task$succeed(
									$author$project$Components$Charge$Form$RoutingFields$GotPreview($author$project$Api$Data$NotAsked))),
								A2(
								$elm$core$Platform$Cmd$map,
								$author$project$Components$Charge$Form$StartDateInputMsg(startDateInput),
								startDateInputCmd),
								A2(
								$elm$core$Platform$Cmd$map,
								$author$project$Components$Charge$Form$EndDateInputMsg(endDateInput),
								endDateInputCmd),
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$CategoryResourceFilterMsg, categoryResourceFilterCmd),
								filtersMsg
							])),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{f: newForm, cq: newChargeItemFilter, akd: $author$project$Api$Data$NotAsked, _6: false, hD: false, h8: true}),
					aR: _List_Nil
				};
			case 4:
				var response = msg.a;
				var newForm = function () {
					if (response.$ === 3) {
						var preview = response.a;
						return A2($author$project$Components$Charge$Form$updateFormFromPreview, preview, model.f);
					} else {
						return model.f;
					}
				}();
				return {
					GZ: A2(
						$elm$core$Task$perform,
						$author$project$Components$Charge$Form$RoutingFieldsMsg,
						$elm$core$Task$succeed(
							$author$project$Components$Charge$Form$RoutingFields$GotPreview(response))),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{f: newForm, akd: response}),
					aR: _List_Nil
				};
			case 15:
				var response = msg.a;
				return {
					GZ: A2(
						$elm$core$Task$perform,
						$author$project$Components$Charge$Form$RoutingFieldsMsg,
						$elm$core$Task$succeed(
							$author$project$Components$Charge$Form$RoutingFields$GotPreviewWithPayer(response))),
					agZ: 0,
					aiO: model,
					aR: _List_Nil
				};
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					var charge_ = response.a;
					var _v17 = A3(
						$author$project$Components$Charge$Form$overrideChargeDiscount,
						apiClient,
						$author$project$Api$Provider$Charge$One$id(charge_),
						model.f);
					var cmd = _v17.a;
					var event = _v17.b;
					return {
						GZ: cmd,
						agZ: event,
						aiO: _Utils_update(
							model,
							{afx: response, hD: false}),
						aR: _List_Nil
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{afx: response}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 13:
				var response = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 1,
					aiO: _Utils_update(
						model,
						{afx: response}),
					aR: $author$project$OutMsg$handleErrorResponse(response)
				};
			case 6:
				var subMsg = msg.a;
				var patientResourceResult = A3($author$project$Components$ResourceFilter$Patient$update, apiClient, subMsg, model.oY);
				var patientUpdatedCmd = function () {
					var _v21 = patientResourceResult.agZ;
					if ((!_v21.$) && (!_v21.a.$)) {
						var patient = _v21.a.a;
						return A2(
							$elm$core$Task$perform,
							$author$project$Components$Charge$Form$RoutingFieldsMsg,
							$elm$core$Task$succeed(
								$author$project$Components$Charge$Form$RoutingFields$PatientUpdated(
									$author$project$Api$Provider$Patient$All$id(patient))));
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				var patientRequestCmd = function () {
					var _v20 = patientResourceResult.agZ;
					if ((!_v20.$) && (!_v20.a.$)) {
						var patient = _v20.a.a;
						var patientId = $author$project$Api$Provider$Patient$All$id(patient);
						return A3($author$project$Api$Provider$Patient$retrieve, apiClient, patientId, $author$project$Components$Charge$Form$GotPatient);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				var _v18 = function () {
					var _v19 = patientResourceResult.agZ;
					if ((!_v19.$) && (!_v19.a.$)) {
						var patient = _v19.a.a;
						var formPatient = {
							ahP: $author$project$Api$Provider$Patient$All$id(patient),
							Bq: $author$project$Api$Provider$Patient$All$name(patient)
						};
						return A4(
							$author$project$Components$Charge$Form$updateForm,
							apiClient,
							model,
							$author$project$Components$Charge$Form$Patient(
								$elm$core$Maybe$Just(formPatient)),
							model.f);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				}();
				var newModel = _v18.a;
				var formCmd = _v18.b;
				return {
					GZ: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								formCmd,
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$PatientResourceFilterMsg, patientResourceResult.GZ),
								patientUpdatedCmd,
								patientRequestCmd
							])),
					agZ: 0,
					aiO: _Utils_update(
						newModel,
						{oY: patientResourceResult.aiO}),
					aR: patientResourceResult.aR
				};
			case 7:
				var subMsg = msg.a;
				var chargeItemResourceResult = A3($author$project$Components$ResourceFilter$ChargeItem$update, apiClient, subMsg, model.cq);
				var _v22 = function () {
					var _v23 = chargeItemResourceResult.agZ;
					_v23$2:
					while (true) {
						if (!_v23.$) {
							switch (_v23.a.$) {
								case 0:
									var chargeItem = _v23.a.a;
									return A4(
										$author$project$Components$Charge$Form$updateForm,
										apiClient,
										model,
										$author$project$Components$Charge$Form$ChargeItem(chargeItem),
										model.f);
								case 5:
									var string = _v23.a.a;
									var _v24 = A4(
										$author$project$Components$Charge$Form$updateForm,
										apiClient,
										model,
										$author$project$Components$Charge$Form$Name(string),
										model.f);
									var newModel_ = _v24.a;
									var formCmd_ = _v24.b;
									return _Utils_Tuple2(
										_Utils_update(
											newModel_,
											{akd: $author$project$Api$Data$NotAsked}),
										$elm$core$Platform$Cmd$batch(
											_List_fromArray(
												[
													A2(
													$elm$core$Task$perform,
													$author$project$Components$Charge$Form$RoutingFieldsMsg,
													$elm$core$Task$succeed(
														$author$project$Components$Charge$Form$RoutingFields$GotPreview($author$project$Api$Data$NotAsked))),
													formCmd_
												])));
								default:
									break _v23$2;
							}
						} else {
							break _v23$2;
						}
					}
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}();
				var newModel = _v22.a;
				var formCmd = _v22.b;
				return {
					GZ: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								formCmd,
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$ChargeItemResourceFilterMsg, chargeItemResourceResult.GZ)
							])),
					agZ: 0,
					aiO: _Utils_update(
						newModel,
						{cq: chargeItemResourceResult.aiO}),
					aR: chargeItemResourceResult.aR
				};
			case 8:
				var subMsg = msg.a;
				var fields = $author$project$Utils$Form$fields(model.f);
				var categoryResourceResult = A3($author$project$Components$ResourceFilter$Category$update, apiClient, subMsg, fields.c8);
				var newForm = A2(
					$author$project$Utils$Form$set,
					_Utils_update(
						fields,
						{c8: categoryResourceResult.aiO}),
					model.f);
				var _v25 = function () {
					var _v26 = categoryResourceResult.agZ;
					if (!_v26.$) {
						return A4(
							$author$project$Components$Charge$Form$updateForm,
							apiClient,
							model,
							$author$project$Components$Charge$Form$Category(
								$author$project$Components$ResourceFilter$Category$value(categoryResourceResult.aiO)),
							newForm);
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{f: newForm}),
							$elm$core$Platform$Cmd$none);
					}
				}();
				var newModel = _v25.a;
				var formCmd = _v25.b;
				return {
					GZ: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$CategoryResourceFilterMsg, categoryResourceResult.GZ),
								formCmd
							])),
					agZ: 0,
					aiO: newModel,
					aR: categoryResourceResult.aR
				};
			case 9:
				var subMsg = msg.a;
				var practitionerResourceResult = A3($author$project$Components$ResourceFilter$Practitioner$update, apiClient, subMsg, model.hk);
				var _v27 = function () {
					var _v28 = practitionerResourceResult.agZ;
					_v28$2:
					while (true) {
						if (!_v28.$) {
							switch (_v28.a.$) {
								case 0:
									var practitioner = _v28.a.a;
									return A4(
										$author$project$Components$Charge$Form$updateForm,
										apiClient,
										model,
										$author$project$Components$Charge$Form$Practitioner(
											$elm$core$Maybe$Just(practitioner)),
										model.f);
								case 2:
									var _v29 = _v28.a;
									return A4(
										$author$project$Components$Charge$Form$updateForm,
										apiClient,
										model,
										$author$project$Components$Charge$Form$Practitioner($elm$core$Maybe$Nothing),
										model.f);
								default:
									break _v28$2;
							}
						} else {
							break _v28$2;
						}
					}
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}();
				var newModel = _v27.a;
				var formCmd = _v27.b;
				return {
					GZ: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								formCmd,
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$PractitionerResourceFilterMsg, practitionerResourceResult.GZ)
							])),
					agZ: 0,
					aiO: _Utils_update(
						newModel,
						{hk: practitionerResourceResult.aiO}),
					aR: practitionerResourceResult.aR
				};
			case 10:
				var subMsg = msg.a;
				var locationResourceResult = A3($author$project$Components$ResourceFilter$Location$update, apiClient, subMsg, model.os);
				var _v30 = function () {
					var _v31 = locationResourceResult.agZ;
					_v31$2:
					while (true) {
						if (!_v31.$) {
							switch (_v31.a.$) {
								case 0:
									var location = _v31.a.a;
									return A4(
										$author$project$Components$Charge$Form$updateForm,
										apiClient,
										model,
										$author$project$Components$Charge$Form$Location(
											$elm$core$Maybe$Just(location)),
										model.f);
								case 2:
									var _v32 = _v31.a;
									return A4(
										$author$project$Components$Charge$Form$updateForm,
										apiClient,
										model,
										$author$project$Components$Charge$Form$Location($elm$core$Maybe$Nothing),
										model.f);
								default:
									break _v31$2;
							}
						} else {
							break _v31$2;
						}
					}
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}();
				var newModel = _v30.a;
				var formCmd = _v30.b;
				return {
					GZ: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								formCmd,
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$LocationResourceFilterMsg, locationResourceResult.GZ)
							])),
					agZ: 0,
					aiO: _Utils_update(
						newModel,
						{os: locationResourceResult.aiO}),
					aR: locationResourceResult.aR
				};
			case 11:
				var debounceMsg = msg.a;
				var _v33 = A4(
					$jinjor$elm_debounce$Debounce$update,
					$author$project$Components$Charge$Form$previewDebounceConfig,
					$jinjor$elm_debounce$Debounce$takeLast($author$project$Components$Charge$Form$debouncePreview),
					debounceMsg,
					model.eW);
				var newDebouncer = _v33.a;
				var cmd = _v33.b;
				return {
					GZ: cmd,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{eW: newDebouncer}),
					aR: _List_Nil
				};
			case 12:
				var cmd = msg.a;
				return {GZ: cmd, agZ: 0, aiO: model, aR: _List_Nil};
			case 14:
				var subMsg = msg.a;
				var routingFieldsResult = A3($author$project$Components$Charge$Form$RoutingFields$update, apiClient, subMsg, model.pK);
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Charge$Form$formFieldsUpdate,
					$author$project$Components$Charge$Form$RoutingFields(routingFieldsResult.aiO.ahi),
					model.f);
				var newModel = _Utils_update(
					model,
					{f: newForm, pK: routingFieldsResult.aiO});
				var previewWithPayerCmds = function () {
					var _v34 = routingFieldsResult.agZ;
					if (_v34 === 1) {
						return A2($author$project$Components$Charge$Form$calculatePreviewWithPayer, apiClient, newModel);
					} else {
						return _List_Nil;
					}
				}();
				return {
					GZ: $elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$cons,
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$RoutingFieldsMsg, routingFieldsResult.GZ),
							previewWithPayerCmds)),
					agZ: 0,
					aiO: newModel,
					aR: routingFieldsResult.aR
				};
			case 16:
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{hD: !model.hD}),
					aR: _List_Nil
				};
			case 17:
				var dateInput = msg.a;
				var subMsg = msg.b;
				return A7(
					$author$project$Components$Charge$Form$updateDateInputFormField,
					apiClient,
					model,
					dateInput,
					subMsg,
					$author$project$Components$Charge$Form$StartDateInputMsg,
					$author$project$Components$Charge$Form$StartDate,
					function ($) {
						return $.ab7;
					});
			case 18:
				var dateInput = msg.a;
				var subMsg = msg.b;
				return A7(
					$author$project$Components$Charge$Form$updateDateInputFormField,
					apiClient,
					model,
					dateInput,
					subMsg,
					$author$project$Components$Charge$Form$EndDateInputMsg,
					$author$project$Components$Charge$Form$EndDate,
					function ($) {
						return $.sb;
					});
			case 20:
				var response = msg.a;
				if (response.$ === 3) {
					var patient = response.a;
					var fields = $author$project$Utils$Form$fields(model.f);
					var newForm = A2(
						$author$project$Utils$Form$set,
						_Utils_update(
							fields,
							{
								ais: A2(
									$elm$core$Maybe$map,
									$author$project$Api$Provider$Location$Shared$id,
									$author$project$Api$Provider$Patient$One$location(patient)),
								aka: A2(
									$elm$core$Maybe$map,
									$author$project$Api$Provider$Practitioner$Shared$id,
									$author$project$Api$Provider$Patient$One$practitioner(patient))
							}),
						model.f);
					var _v36 = A3($author$project$Components$Charge$Form$updateFilters, apiClient, patient, model);
					var newModel = _v36.a;
					var filtersMsg = _v36.b;
					return {
						GZ: filtersMsg,
						agZ: 0,
						aiO: _Utils_update(
							newModel,
							{
								f: newForm,
								YY: $elm$core$Maybe$Just(patient)
							}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: model,
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			default:
				var response = msg.a;
				var modelWithResponse = _Utils_update(
					model,
					{Dv: response});
				if (response.$ === 3) {
					var patient = response.a;
					var formPatient = {
						ahP: $author$project$Api$Provider$Patient$One$id(patient),
						Bq: $author$project$Api$Provider$Patient$One$name(patient)
					};
					var _v38 = A2(
						$author$project$Components$Charge$Form$initPatientResourceFilter,
						apiClient,
						$elm$core$Maybe$Just(patient));
					var patientResourceFilter = _v38.a;
					var patientResourceFilterCmd = _v38.b;
					var _v39 = A4(
						$author$project$Components$Charge$Form$updateForm,
						apiClient,
						modelWithResponse,
						$author$project$Components$Charge$Form$Patient(
							$elm$core$Maybe$Just(formPatient)),
						modelWithResponse.f);
					var modelWithForm = _v39.a;
					var formCmd = _v39.b;
					var _v40 = A3($author$project$Components$Charge$Form$updateFilters, apiClient, patient, modelWithForm);
					var modelWithFilters = _v40.a;
					var filtersCmd = _v40.b;
					return {
						GZ: $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$PatientResourceFilterMsg, patientResourceFilterCmd),
									formCmd,
									filtersCmd,
									A2(
									$elm$core$Task$perform,
									$author$project$Components$Charge$Form$RoutingFieldsMsg,
									$elm$core$Task$succeed(
										$author$project$Components$Charge$Form$RoutingFields$PatientUpdated(
											$author$project$Api$Provider$Patient$One$id(patient))))
								])),
						agZ: 0,
						aiO: _Utils_update(
							modelWithFilters,
							{
								YY: $elm$core$Maybe$Just(patient),
								oY: patientResourceFilter
							}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: modelWithResponse,
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
		}
	});
var $author$project$Components$CustomerEmailModal$Editing = F4(
	function (a, b, c, d) {
		return {$: 4, a: a, b: b, c: c, d: d};
	});
var $author$project$Components$CustomerEmailModal$Open = F4(
	function (a, b, c, d) {
		return {$: 3, a: a, b: b, c: c, d: d};
	});
var $author$project$Components$CustomerEmailModal$GotDelivery = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$CustomerEmailModal$createNotification = F3(
	function (apiClient, _v0, preview) {
		var type_ = _v0.amg;
		var contextId = _v0.yP;
		var recipient = _v0.DI;
		return A6(
			$author$project$Api$Provider$Notification$create,
			apiClient,
			type_,
			$author$project$Api$Provider$Notification$Patient(
				$author$project$Components$CustomerEmailModal$recipientId(recipient)),
			contextId,
			{
				fO: $author$project$Api$Provider$Notification$One$body(preview),
				J_: $author$project$Api$Provider$Notification$One$subject(preview)
			},
			$author$project$Components$CustomerEmailModal$GotDelivery);
	});
var $author$project$Components$CustomerEmailModal$initNotificationFormFields = function (notification) {
	return {
		fO: $author$project$Api$Provider$Notification$One$body(notification),
		J_: $author$project$Api$Provider$Notification$One$subject(notification)
	};
};
var $author$project$Components$CustomerEmailModal$notificationFormFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var string = field.a;
			return _Utils_update(
				fields,
				{
					J_: $author$project$Utils$String$toMaybe(string)
				});
		} else {
			var string = field.a;
			return _Utils_update(
				fields,
				{
					fO: $author$project$Utils$String$toMaybe(string)
				});
		}
	});
var $author$project$Components$CustomerEmailModal$BodyValidation = 1;
var $author$project$Components$CustomerEmailModal$SubjectValidation = 0;
var $author$project$Components$CustomerEmailModal$notificationFormFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.J_;
			},
			_Utils_Tuple2(0, 'Please enter a valid subject')),
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.fO;
			},
			_Utils_Tuple2(1, 'Please enter a valid body'))
		]));
var $author$project$Components$CustomerEmailModal$patientFormFieldsUpdate = F2(
	function (field, fields) {
		var string = field;
		return _Utils_update(
			fields,
			{Rj: string});
	});
var $author$project$Components$CustomerEmailModal$EmailValidation = 0;
var $author$project$Components$CustomerEmailModal$patientFormFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A3(
			$author$project$Utils$Validate$ifInvalidEmail,
			{aeT: false},
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.Rj;
				},
				$elm$core$Maybe$Just),
			_Utils_Tuple2(0, 'Please enter a valid email'))
		]));
var $author$project$Components$CustomerEmailModal$GotPatient = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Provider$Patient$updateEmail = F4(
	function (apiClient, id_, email_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'patient',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'email',
								$elm$json$Json$Encode$string(email_))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Patient$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Patient$patientPath(id_))));
	});
var $author$project$Components$CustomerEmailModal$updatePatientEmail = F2(
	function (apiClient, formFields) {
		var _v0 = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var patientId = _v0.YZ;
		var email = _v0.Rj;
		return A4($author$project$Api$Provider$Patient$updateEmail, apiClient, patientId, email, $author$project$Components$CustomerEmailModal$GotPatient);
	});
var $author$project$Components$CustomerEmailModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var session = msg.a;
				var type_ = msg.b;
				var contextId = msg.c;
				var recipient = msg.d;
				return A2(
					$author$project$Utils$Tuple3$fromTuple2,
					_List_Nil,
					A6($author$project$Components$CustomerEmailModal$open, apiClient, session, type_, contextId, recipient, model));
			case 1:
				return _Utils_Tuple3($author$project$Components$CustomerEmailModal$Closed, $elm$core$Platform$Cmd$none, _List_Nil);
			case 2:
				if (model.$ === 4) {
					var shared = model.a;
					var email = model.b;
					var notificationForm = model.c;
					var preview = model.d;
					var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$CustomerEmailModal$notificationFormFieldsValidator, notificationForm);
					if (!_v2.$) {
						var _v3 = _v2.a;
						var newForm = _v3.a;
						var validFormFields = _v3.b;
						return _Utils_Tuple3(
							A4($author$project$Components$CustomerEmailModal$Editing, shared, email, newForm, $author$project$Api$Data$Loading),
							A3(
								$author$project$Components$CustomerEmailModal$previewNotification,
								apiClient,
								shared,
								$elm$core$Maybe$Just(validFormFields)),
							_List_Nil);
					} else {
						var newForm = _v2.a;
						return _Utils_Tuple3(
							A4($author$project$Components$CustomerEmailModal$Editing, shared, email, newForm, preview),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				if (model.$ === 3) {
					var shared = model.a;
					var email = model.b;
					var preview = model.c;
					return _Utils_Tuple3(
						A4(
							$author$project$Components$CustomerEmailModal$Editing,
							shared,
							email,
							$author$project$Utils$Form$init(
								$author$project$Components$CustomerEmailModal$initNotificationFormFields(preview)),
							$author$project$Api$Data$NotAsked),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				if (model.$ === 3) {
					var shared = model.a;
					var email = model.b;
					var preview = model.c;
					return _Utils_Tuple3(
						A4($author$project$Components$CustomerEmailModal$Open, shared, email, preview, $author$project$Api$Data$Loading),
						A3($author$project$Components$CustomerEmailModal$createNotification, apiClient, shared, preview),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				if (model.$ === 1) {
					var shared = model.a;
					var patientForm = model.b;
					var _v7 = function () {
						var _v8 = A2($author$project$Utils$Form$validate, $author$project$Components$CustomerEmailModal$patientFormFieldsValidator, patientForm);
						if (!_v8.$) {
							var _v9 = _v8.a;
							var form = _v9.a;
							var validFormFields = _v9.b;
							return _Utils_Tuple2(
								form,
								A2($author$project$Components$CustomerEmailModal$updatePatientEmail, apiClient, validFormFields));
						} else {
							var form = _v8.a;
							return _Utils_Tuple2(form, $elm$core$Platform$Cmd$none);
						}
					}();
					var validatedForm = _v7.a;
					var cmd = _v7.b;
					return _Utils_Tuple3(
						A2($author$project$Components$CustomerEmailModal$NoRecipientEmail, shared, validatedForm),
						cmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var response = msg.a;
				var _v10 = _Utils_Tuple2(model, response);
				switch (_v10.a.$) {
					case 2:
						if (_v10.b.$ === 3) {
							var _v11 = _v10.a;
							var shared = _v11.a;
							var email = _v11.b;
							var _v12 = _v10.b;
							var preview = _v12.a;
							return _Utils_Tuple3(
								A4($author$project$Components$CustomerEmailModal$Open, shared, email, preview, $author$project$Api$Data$NotAsked),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
						} else {
							var _v13 = _v10.a;
							var shared = _v13.a;
							var email = _v13.b;
							return _Utils_Tuple3(
								A2($author$project$Components$CustomerEmailModal$Loading, shared, email),
								$elm$core$Platform$Cmd$none,
								$author$project$OutMsg$handleErrorResponse(response));
						}
					case 4:
						if (_v10.b.$ === 3) {
							var _v14 = _v10.a;
							var shared = _v14.a;
							var email = _v14.b;
							var _v15 = _v10.b;
							var preview = _v15.a;
							return _Utils_Tuple3(
								A4($author$project$Components$CustomerEmailModal$Open, shared, email, preview, $author$project$Api$Data$NotAsked),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
						} else {
							var _v16 = _v10.a;
							var shared = _v16.a;
							var email = _v16.b;
							var notificationForm = _v16.c;
							return _Utils_Tuple3(
								A4($author$project$Components$CustomerEmailModal$Editing, shared, email, notificationForm, response),
								$elm$core$Platform$Cmd$none,
								$author$project$OutMsg$handleErrorResponse(response));
						}
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var field = msg.a;
				if (model.$ === 4) {
					var shared = model.a;
					var email = model.b;
					var notificationForm = model.c;
					var preview = model.d;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$CustomerEmailModal$notificationFormFieldsUpdate, field, notificationForm);
					var validatedForm = function () {
						var _v18 = A2($author$project$Utils$Form$validate, $author$project$Components$CustomerEmailModal$notificationFormFieldsValidator, newForm);
						if (!_v18.$) {
							var _v19 = _v18.a;
							var form = _v19.a;
							return form;
						} else {
							var form = _v18.a;
							return form;
						}
					}();
					return _Utils_Tuple3(
						A4($author$project$Components$CustomerEmailModal$Editing, shared, email, validatedForm, preview),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 8:
				var field = msg.a;
				if (model.$ === 1) {
					var shared = model.a;
					var patientForm = model.b;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$CustomerEmailModal$patientFormFieldsUpdate, field, patientForm);
					var validatedForm = function () {
						var _v21 = A2($author$project$Utils$Form$validate, $author$project$Components$CustomerEmailModal$patientFormFieldsValidator, newForm);
						if (!_v21.$) {
							var _v22 = _v21.a;
							var form = _v22.a;
							return form;
						} else {
							var form = _v21.a;
							return form;
						}
					}();
					return _Utils_Tuple3(
						A2($author$project$Components$CustomerEmailModal$NoRecipientEmail, shared, validatedForm),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var response = msg.a;
				if (model.$ === 1) {
					var shared = model.a;
					var patientForm = model.b;
					if (response.$ === 3) {
						var patient = response.a;
						return _Utils_Tuple3(
							A2(
								$author$project$Components$CustomerEmailModal$Loading,
								shared,
								A2(
									$elm$core$Maybe$withDefault,
									'',
									$author$project$Api$Provider$Patient$One$email(patient))),
							A3($author$project$Components$CustomerEmailModal$previewNotification, apiClient, shared, $elm$core$Maybe$Nothing),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Patient email updated')
								]));
					} else {
						return _Utils_Tuple3(
							A2($author$project$Components$CustomerEmailModal$NoRecipientEmail, shared, patientForm),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var response = msg.a;
				if (model.$ === 3) {
					var shared = model.a;
					var email = model.b;
					var preview = model.c;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							$author$project$Components$CustomerEmailModal$Closed,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'This email is being sent')
								]));
					} else {
						return _Utils_Tuple3(
							A4($author$project$Components$CustomerEmailModal$Open, shared, email, preview, response),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Api$Provider$CustomerInvoice$Adjustments = 2;
var $author$project$Components$CustomerSchedulePaymentModal$Date = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$CustomerSchedulePaymentModal$None = {$: 0};
var $author$project$Api$Provider$CustomerInvoice$OwnerPhones = 3;
var $author$project$Components$CustomerSchedulePaymentModal$PaymentScheduled = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Api$Provider$CustomerInvoice$Payments = 1;
var $author$project$Components$CustomerSchedulePaymentModal$Scheduled = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$CustomerSchedulePaymentModal$formFieldsUpdate = F2(
	function (field, fields) {
		var dateInput = field.a;
		var date = field.b;
		return _Utils_update(
			fields,
			{PB: date, rZ: dateInput});
	});
var $author$project$Components$CustomerSchedulePaymentModal$DateValidation = 0;
var $author$project$Components$CustomerSchedulePaymentModal$validateStartDate = F2(
	function (currentDate, fields) {
		var _v0 = fields.PB;
		if (!_v0.$) {
			var date = _v0.a;
			return (A2($justinmimbs$date$Date$compare, currentDate, date) !== 2) ? _List_Nil : _List_fromArray(
				[
					_Utils_Tuple2(0, 'Please enter a future date')
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$CustomerSchedulePaymentModal$formFieldsValidator = function (currentDate) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$CustomerSchedulePaymentModal$validateStartDate(currentDate))
			]));
};
var $author$project$Api$Provider$CustomerInvoice$schedulePayment = F5(
	function (apiClient, id, date, expand, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, date))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CustomerInvoice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				A2(
					$author$project$Api$Data$requestWithQuery,
					_List_fromArray(
						[
							A2(
							$author$project$Api$Param$list,
							'expand',
							A2($elm$core$List$map, $author$project$Api$Provider$CustomerInvoice$expandToString, expand))
						]),
					$author$project$Api$Data$requestTo(
						A2(
							$author$project$Api$Data$pathAppend,
							_List_fromArray(
								['schedule_payment']),
							$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id))))));
	});
var $author$project$Components$CustomerSchedulePaymentModal$update = F3(
	function (apiClient, msg, model) {
		if (model.$ === 1) {
			var model_ = model.a;
			switch (msg.$) {
				case 0:
					return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$CustomerSchedulePaymentModal$None, aiO: $author$project$Components$CustomerSchedulePaymentModal$Closed, aR: _List_Nil};
				case 1:
					var _v2 = A2(
						$author$project$Utils$Form$validate,
						$author$project$Components$CustomerSchedulePaymentModal$formFieldsValidator(model_.dd),
						model_.SD);
					if (!_v2.$) {
						var _v3 = _v2.a;
						var newForm = _v3.a;
						var validFormFields = _v3.b;
						var _v4 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
						var date = _v4.PB;
						return {
							GZ: A5(
								$author$project$Api$Provider$CustomerInvoice$schedulePayment,
								apiClient,
								model_.Us,
								date,
								_List_fromArray(
									[0, 1, 2, 3]),
								$author$project$Components$CustomerSchedulePaymentModal$Scheduled),
							agZ: $author$project$Components$CustomerSchedulePaymentModal$None,
							aiO: $author$project$Components$CustomerSchedulePaymentModal$Open(
								_Utils_update(
									model_,
									{SD: newForm, uf: $author$project$Api$Data$Loading})),
							aR: _List_Nil
						};
					} else {
						var newForm = _v2.a;
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: $author$project$Components$CustomerSchedulePaymentModal$None,
							aiO: $author$project$Components$CustomerSchedulePaymentModal$Open(
								_Utils_update(
									model_,
									{SD: newForm})),
							aR: _List_Nil
						};
					}
				case 2:
					var response = msg.a;
					if (response.$ === 3) {
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: A2($author$project$Components$CustomerSchedulePaymentModal$PaymentScheduled, model_.Us, response),
							aiO: $author$project$Components$CustomerSchedulePaymentModal$Closed,
							aR: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Payment scheduled!')
								])
						};
					} else {
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: $author$project$Components$CustomerSchedulePaymentModal$None,
							aiO: model,
							aR: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
				default:
					var dateInput = msg.a;
					var subMsg = msg.b;
					var _v6 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
					var newDateInput = _v6.a;
					var subCmd = _v6.b;
					var event = _v6.c;
					var newForm = function () {
						if (event.$ === 1) {
							var date = event.a;
							return A3(
								$author$project$Utils$Form$update,
								$author$project$Components$CustomerSchedulePaymentModal$formFieldsUpdate,
								A2($author$project$Components$CustomerSchedulePaymentModal$Date, newDateInput, date),
								model_.SD);
						} else {
							var fields = $author$project$Utils$Form$fields(model_.SD);
							return A3(
								$author$project$Utils$Form$update,
								$author$project$Components$CustomerSchedulePaymentModal$formFieldsUpdate,
								A2($author$project$Components$CustomerSchedulePaymentModal$Date, newDateInput, fields.PB),
								model_.SD);
						}
					}();
					return {
						GZ: A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Components$CustomerSchedulePaymentModal$DateInputMsg(newDateInput),
							subCmd),
						agZ: $author$project$Components$CustomerSchedulePaymentModal$None,
						aiO: $author$project$Components$CustomerSchedulePaymentModal$Open(
							_Utils_update(
								model_,
								{SD: newForm})),
						aR: _List_Nil
					};
			}
		} else {
			return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$CustomerSchedulePaymentModal$None, aiO: $author$project$Components$CustomerSchedulePaymentModal$Closed, aR: _List_Nil};
		}
	});
var $author$project$Pages$Charges$New$updateField = F2(
	function (invoice, field) {
		switch (field.$) {
			case 0:
				var status = field.a;
				return _Utils_update(
					invoice,
					{alH: status});
			case 1:
				var dropdownMenu = field.a;
				return _Utils_update(
					invoice,
					{no: dropdownMenu});
			default:
				var response = field.a;
				return _Utils_update(
					invoice,
					{k9: response});
		}
	});
var $author$project$Pages$Charges$New$updateInvoice = F3(
	function (invoiceId, field, invoices) {
		return A2(
			$elm$core$List$map,
			function (invoice) {
				return _Utils_eq(invoice.ahP, invoiceId) ? A2($author$project$Pages$Charges$New$updateField, invoice, field) : invoice;
			},
			invoices);
	});
var $author$project$Pages$Charges$New$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ui: true}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Charges$New$ChargeFormMsg, $author$project$Components$Charge$Form$save),
					_List_Nil);
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ui: false}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Charges$New$ChargeFormMsg, $author$project$Components$Charge$Form$save),
					_List_Nil);
			case 2:
				var subMsg = msg.a;
				var chargeFormResult = A3($author$project$Components$Charge$Form$update, model.Gv, subMsg, model.f);
				var maybeInvoice = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Maybe$Nothing,
					A2(
						$elm$core$Maybe$map,
						$author$project$Api$Provider$Charge$One$invoice,
						$author$project$Api$Data$toMaybe(
							$author$project$Components$Charge$Form$charge(chargeFormResult.aiO))));
				var invoiceRetrieveCmd = function () {
					if (!maybeInvoice.$) {
						var invoice = maybeInvoice.a;
						var _v7 = $author$project$Api$Common$Payable$Invoice$MinWithOwner$type_(invoice);
						switch (_v7) {
							case 1:
								return A4(
									$author$project$Api$Provider$CustomerInvoice$retrieve,
									model.Gv,
									$author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice),
									_List_Nil,
									A2(
										$author$project$Pages$Charges$New$GotCustomerInvoice,
										$author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice),
										$elm$core$Maybe$Nothing));
							case 0:
								return $elm$core$Platform$Cmd$none;
							default:
								return $elm$core$Platform$Cmd$none;
						}
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				var _v1 = function () {
					var _v2 = chargeFormResult.agZ;
					if (_v2 === 1) {
						var _v3 = model.ui ? _Utils_Tuple2($author$project$Components$Charge$Form$reset, 'created') : _Utils_Tuple2($author$project$Components$Charge$Form$newFormWithPatient, 'added');
						var chargeFormCmd = _v3.a;
						var toastVerb = _v3.b;
						return _Utils_Tuple2(
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Charges$New$ChargeFormMsg, chargeFormCmd),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$elm$core$String$concat(
										_List_fromArray(
											['Charge ', toastVerb, '!'])))
								]));
					} else {
						return _Utils_Tuple2($elm$core$Platform$Cmd$none, _List_Nil);
					}
				}();
				var resetCmd = _v1.a;
				var toastMsgs = _v1.b;
				var _v4 = function () {
					var _v5 = chargeFormResult.agZ;
					if (_v5 === 1) {
						var createdChargeForm = $author$project$Components$Charge$Form$readOnly(
							$author$project$Components$Charge$Form$hide(chargeFormResult.aiO));
						return _Utils_Tuple2(
							_Utils_ap(
								model.d3,
								_List_fromArray(
									[createdChargeForm])),
							A2($author$project$Pages$Charges$New$refreshInvoiceList, model.sP, maybeInvoice));
					} else {
						return _Utils_Tuple2(model.d3, model.sP);
					}
				}();
				var createdCharges = _v4.a;
				var invoices = _v4.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{f: chargeFormResult.aiO, d3: createdCharges, sP: invoices}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Charges$New$ChargeFormMsg, chargeFormResult.GZ),
								resetCmd,
								invoiceRetrieveCmd
							])),
					_Utils_ap(chargeFormResult.aR, toastMsgs));
			case 3:
				return _Utils_Tuple3(
					model,
					A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Patients__Top),
					_List_Nil);
			case 4:
				var invoiceId = msg.a;
				var subMsg = msg.b;
				var _v8 = A2($author$project$Pages$Charges$New$findDropdownMenu, model.sP, invoiceId);
				if (!_v8.$) {
					var invoiceDropdownMenu = _v8.a;
					var _v9 = A2($author$project$Ui$Dropdown$update, subMsg, invoiceDropdownMenu);
					var dropdownMenu = _v9.a;
					var cmd = _v9.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								sP: A3(
									$author$project$Pages$Charges$New$updateInvoice,
									invoiceId,
									$author$project$Pages$Charges$New$Dropdown(dropdownMenu),
									model.sP)
							}),
						cmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var index = msg.a;
				var _v10 = A2($elm_community$list_extra$List$Extra$getAt, index, model.d3);
				if (!_v10.$) {
					var createdCharge = _v10.a;
					var updatedCreatedCharge = $author$project$Components$Charge$Form$toggle(createdCharge);
					var createdCharges = A3(
						$elm_community$list_extra$List$Extra$setAt,
						index,
						updatedCreatedCharge,
						A2(
							$elm$core$List$map,
							function (createdCharge_) {
								return $author$project$Components$Charge$Form$hide(createdCharge_);
							},
							model.d3));
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{d3: createdCharges}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				var invoiceId = msg.a;
				var afterIssueMsg = msg.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							sP: A3(
								$author$project$Pages$Charges$New$updateInvoice,
								invoiceId,
								$author$project$Pages$Charges$New$SaveRequest($author$project$Api$Data$Loading),
								model.sP)
						}),
					A4(
						$author$project$Api$Provider$CustomerInvoice$issue,
						model.Gv,
						invoiceId,
						_List_fromArray(
							[0]),
						A2(
							$author$project$Pages$Charges$New$GotCustomerInvoice,
							invoiceId,
							$elm$core$Maybe$Just(afterIssueMsg))),
					_List_Nil);
			case 7:
				var invoiceId = msg.a;
				var maybeAfterIssueMsg = msg.b;
				var response = msg.c;
				if (response.$ === 3) {
					var invoice = response.a;
					var invoicesUpdated = A3(
						$author$project$Pages$Charges$New$updateInvoice,
						invoiceId,
						$author$project$Pages$Charges$New$SaveRequest(response),
						A3(
							$author$project$Pages$Charges$New$updateInvoice,
							invoiceId,
							$author$project$Pages$Charges$New$Status(
								$author$project$Api$Provider$CustomerInvoice$One$humanStatus(invoice)),
							model.sP));
					var cmd = function () {
						var _v12 = _Utils_Tuple2(
							maybeAfterIssueMsg,
							A2($author$project$Pages$Charges$New$findInvoice, invoicesUpdated, invoiceId));
						if ((!_v12.a.$) && (!_v12.b.$)) {
							var afterIssueMsg = _v12.a.a;
							var invoice_ = _v12.b.a;
							return A2($author$project$Pages$Charges$New$triggerAfterIssueAction, afterIssueMsg, invoice_);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{sP: invoicesUpdated}),
						cmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								sP: A3(
									$author$project$Pages$Charges$New$updateInvoice,
									invoiceId,
									$author$project$Pages$Charges$New$SaveRequest(response),
									model.sP)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 8:
				var invoice = msg.a;
				var external = msg.b;
				return $author$project$Pages$Charges$New$isDraft(invoice) ? _Utils_Tuple3(
					model,
					A2(
						$elm$core$Task$perform,
						function (_v13) {
							var paymentMsgType = external ? 1 : 0;
							return A2($author$project$Pages$Charges$New$Issue, invoice.ahP, paymentMsgType);
						},
						$elm$time$Time$now),
					_List_Nil) : A4($author$project$Pages$Charges$New$showPaymentModal, model, invoice, external, invoice.ahP);
			case 9:
				var subMsg = msg.a;
				var _v14 = model.m$;
				if (!_v14.$) {
					var _v15 = _v14.a;
					var createPaymentModal = _v15.a;
					var invoiceId = _v15.b;
					var createPaymentModalResult = A3($author$project$Components$Invoice$CreatePaymentModal$update, model.Gv, subMsg, createPaymentModal);
					var _v16 = function () {
						var _v17 = createPaymentModalResult.agZ;
						switch (_v17) {
							case 1:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(
										_Utils_Tuple2(createPaymentModalResult.aiO, invoiceId)),
									model.sP,
									$elm$core$Platform$Cmd$none);
							case 2:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									A3(
										$author$project$Pages$Charges$New$updateInvoice,
										invoiceId,
										$author$project$Pages$Charges$New$SaveRequest($author$project$Api$Data$Loading),
										model.sP),
									A2($author$project$Pages$Charges$New$retrieveInvoice, model.Gv, invoiceId));
							default:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.sP, $elm$core$Platform$Cmd$none);
						}
					}();
					var createPaymentModal_ = _v16.a;
					var invoices = _v16.b;
					var cmd = _v16.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{m$: createPaymentModal_, sP: invoices}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Charges$New$CreatePaymentModalMsg, createPaymentModalResult.GZ),
									cmd
								])),
						createPaymentModalResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 11:
				var patientId = msg.a;
				var invoice = msg.b;
				var cmd = $author$project$Pages$Charges$New$isDraft(invoice) ? A2(
					$elm$core$Task$perform,
					function (_v18) {
						return A2($author$project$Pages$Charges$New$Issue, invoice.ahP, 2);
					},
					$elm$time$Time$now) : A3(
					$author$project$Api$Provider$Patient$retrieve,
					model.Gv,
					patientId,
					$author$project$Pages$Charges$New$GotPatient(invoice.ahP));
				return _Utils_Tuple3(model, cmd, _List_Nil);
			case 12:
				var invoiceId = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var patient = response.a;
					var _v20 = A6(
						$author$project$Components$CustomerEmailModal$open,
						model.Gv,
						model.aa4,
						0,
						invoiceId,
						$author$project$Components$CustomerEmailModal$PatientOne(patient),
						model.m5);
					var customerEmailModal = _v20.a;
					var customerEmailModalCmd = _v20.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{m5: customerEmailModal}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Charges$New$CustomerEmailModalMsg, customerEmailModalCmd),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 10:
				var subMsg = msg.a;
				var _v21 = A3($author$project$Components$CustomerEmailModal$update, model.Gv, subMsg, model.m5);
				var customerEmailModal = _v21.a;
				var subCmd = _v21.b;
				var subOutMsg = _v21.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{m5: customerEmailModal}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Charges$New$CustomerEmailModalMsg, subCmd),
					subOutMsg);
			case 13:
				var invoice = msg.a;
				var _v22 = $author$project$Pages$Charges$New$isDraft(invoice) ? _Utils_Tuple2(
					model.hw,
					A2(
						$elm$core$Task$perform,
						function (_v23) {
							return A2($author$project$Pages$Charges$New$Issue, invoice.ahP, 3);
						},
						$elm$time$Time$now)) : A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Pages$Charges$New$SchedulePaymentModalMsg),
					A2($author$project$Components$CustomerSchedulePaymentModal$open, invoice.ahP, model.lk.dd));
				var schedulePaymentModal = _v22.a;
				var schedulePaymentModalCmd = _v22.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{hw: schedulePaymentModal}),
					schedulePaymentModalCmd,
					_List_Nil);
			default:
				var subMsg = msg.a;
				var schedulePaymentResult = A3($author$project$Components$CustomerSchedulePaymentModal$update, model.Gv, subMsg, model.hw);
				var invoices = function () {
					var _v24 = schedulePaymentResult.agZ;
					if (!_v24.$) {
						return model.sP;
					} else {
						var invoiceId = _v24.a;
						var invoice = _v24.b;
						return A3(
							$author$project$Pages$Charges$New$updateInvoice,
							invoiceId,
							$author$project$Pages$Charges$New$SaveRequest(invoice),
							model.sP);
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{sP: invoices, hw: schedulePaymentResult.aiO}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Charges$New$SchedulePaymentModalMsg, schedulePaymentResult.GZ),
					schedulePaymentResult.aR);
		}
	});
var $author$project$Components$CustomerEmailModal$Body = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$CustomerEmailModal$Email = $elm$core$Basics$identity;
var $author$project$Components$CustomerEmailModal$NotificationFormFieldUpdated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$CustomerEmailModal$PatientFormFieldUpdated = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$CustomerEmailModal$Subject = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$CustomerEmailModal$UpdatePatientEmail = {$: 5};
var $author$project$Api$Provider$Reports$Patient$oneName = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Components$CustomerEmailModal$recipientName = function (recipient) {
	switch (recipient.$) {
		case 0:
			var patient = recipient.a;
			return $author$project$Api$Provider$Reports$Patient$oneName(patient);
		case 1:
			var patient = recipient.a;
			return $author$project$Api$Provider$Patient$One$name(patient);
		default:
			var patient = recipient.a;
			return $author$project$Api$Provider$Patient$Shared$name(patient);
	}
};
var $author$project$Components$CustomerEmailModal$viewPreview = F4(
	function (recipient, email, subject, body) {
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$phi]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('email-preview')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										'To ' + $author$project$Components$CustomerEmailModal$recipientName(recipient))
									])),
								$elm$html$Html$text('<' + (email + '>')),
								$author$project$Ui$HorizontalRule$view(_List_Nil),
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Subject')
									])),
								subject,
								$author$project$Ui$HorizontalRule$view(_List_Nil),
								body
							]))
					]))
			]);
	});
var $author$project$Components$CustomerEmailModal$viewModalBody = function (model) {
	switch (model.$) {
		case 0:
			return _List_Nil;
		case 1:
			var shared = model.a;
			var patientForm = model.b;
			var _v1 = $author$project$Utils$Form$fields(patientForm);
			var email = _v1.Rj;
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$Alert$warning,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Please add an email address for '),
							A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[
									$author$project$Ui$Typography$phi(true)
								]),
							$author$project$Components$CustomerEmailModal$recipientName(shared.DI)),
							$elm$html$Html$text('.')
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$phi]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('email-preview')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$noValidate(true),
											$author$project$Ui$Form$autocomplete(false),
											$author$project$Ui$Form$onSubmit($author$project$Components$CustomerEmailModal$UpdatePatientEmail)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Group$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Group$label(
													'To ' + $author$project$Components$CustomerEmailModal$recipientName(shared.DI))
												]),
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$view(
													_List_fromArray(
														[
															$author$project$Ui$Form$Input$placeholder('somebody@example.com'),
															$author$project$Ui$Form$Input$value(email),
															$author$project$Ui$Form$Input$onInput(
															A2($elm$core$Basics$composeL, $author$project$Components$CustomerEmailModal$PatientFormFieldUpdated, $elm$core$Basics$identity)),
															$author$project$Ui$Form$Input$invalid(
															A2($author$project$Utils$Form$hasValidationErrors, 0, patientForm))
														]))
												])),
											A3(
											$author$project$Ui$Button$view,
											{mm: 'Save custom email'},
											_List_fromArray(
												[$author$project$Ui$Button$submit]),
											_List_fromArray(
												[
													$elm$html$Html$text('Save')
												]))
										]))
								]))
						]))
				]);
		case 2:
			var shared = model.a;
			var email = model.b;
			return A4(
				$author$project$Components$CustomerEmailModal$viewPreview,
				shared.DI,
				email,
				$author$project$Ui$Spinner$view(_List_Nil),
				$author$project$Ui$Spinner$view(_List_Nil));
		case 3:
			var shared = model.a;
			var email = model.b;
			var preview = model.c;
			var delivery = model.d;
			return _Utils_ap(
				A4(
					$author$project$Components$CustomerEmailModal$viewPreview,
					shared.DI,
					email,
					A2(
						$elm$html$Html$map,
						$elm$core$Basics$never,
						A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('subject')
								]),
							$author$project$Utils$Dom$textToHtml(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									$author$project$Api$Provider$Notification$One$subjectHtml(preview))))),
					A2(
						$elm$html$Html$map,
						$elm$core$Basics$never,
						A2(
							$elm$html$Html$div,
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$class('body'),
								$author$project$Api$Phi$displayAttr),
							$author$project$Utils$Dom$textToHtml(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									$author$project$Api$Provider$Notification$One$bodyHtml(preview)))))),
				_List_fromArray(
					[
						function () {
						if (delivery.$ === 2) {
							var error = delivery.a;
							return A2(
								$author$project$Ui$Alert$danger,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Error sending email')
											])),
										A2($elm$html$Html$br, _List_Nil, _List_Nil),
										$elm$html$Html$text(
										$author$project$Api$Data$errorToString(error))
									]));
						} else {
							return $author$project$Utils$Html$empty;
						}
					}()
					]));
		default:
			var shared = model.a;
			var email = model.b;
			var notificationForm = model.c;
			var _v3 = $author$project$Utils$Form$fields(notificationForm);
			var subject = _v3.J_;
			var body = _v3.fO;
			return A4(
				$author$project$Components$CustomerEmailModal$viewPreview,
				shared.DI,
				email,
				A2(
					$author$project$Ui$Form$Group$view,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(
									A2($elm$core$Maybe$withDefault, '', subject)),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$CustomerEmailModal$NotificationFormFieldUpdated, $author$project$Components$CustomerEmailModal$Subject)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, notificationForm)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 0, notificationForm))
								]))
						])),
				A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Form$Textarea$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Textarea$rows(15),
											$author$project$Ui$Form$Textarea$value(
											A2($elm$core$Maybe$withDefault, '', body)),
											$author$project$Ui$Form$Textarea$onInput(
											A2($elm$core$Basics$composeL, $author$project$Components$CustomerEmailModal$NotificationFormFieldUpdated, $author$project$Components$CustomerEmailModal$Body)),
											$author$project$Ui$Form$Textarea$invalid(
											A2($author$project$Utils$Form$hasValidationErrors, 1, notificationForm)),
											$author$project$Ui$Form$Textarea$errors(
											A2($author$project$Utils$Form$validationErrors, 1, notificationForm))
										]))
								]))
						])));
	}
};
var $author$project$Components$CustomerEmailModal$Edit = {$: 3};
var $author$project$Components$CustomerEmailModal$Preview = {$: 2};
var $author$project$Components$CustomerEmailModal$Send = {$: 4};
var $author$project$Components$CustomerEmailModal$viewCancelButton = A3(
	$author$project$Ui$Button$view,
	{mm: 'Cancel and close modal'},
	_List_fromArray(
		[
			$author$project$Ui$Button$onClick($author$project$Components$CustomerEmailModal$Close)
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('Cancel')
		]));
var $author$project$Components$CustomerEmailModal$viewModalFooter = function (model) {
	return $elm$core$List$singleton(
		A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$gap2]),
			function () {
				switch (model.$) {
					case 0:
						return _List_Nil;
					case 1:
						return _List_fromArray(
							[$author$project$Components$CustomerEmailModal$viewCancelButton]);
					case 2:
						return _List_fromArray(
							[$author$project$Components$CustomerEmailModal$viewCancelButton]);
					case 3:
						var delivery = model.d;
						var deliveryLoading = function () {
							if (delivery.$ === 1) {
								return true;
							} else {
								return false;
							}
						}();
						return _List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Customize email'},
								_List_fromArray(
									[
										$author$project$Ui$Button$onClick($author$project$Components$CustomerEmailModal$Edit)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Customize Email')
									])),
								$author$project$Components$CustomerEmailModal$viewCancelButton,
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Send email'},
								_List_fromArray(
									[
										$author$project$Ui$Button$primary,
										$author$project$Ui$Button$submit,
										$author$project$Ui$Button$onClick($author$project$Components$CustomerEmailModal$Send),
										$author$project$Ui$Button$loading(deliveryLoading)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Icon$send(_List_Nil),
										$elm$html$Html$text('Send Email')
									]))
							]);
					default:
						var preview = model.d;
						var loading = function () {
							if (preview.$ === 1) {
								return true;
							} else {
								return false;
							}
						}();
						return _List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Preview email'},
								_List_fromArray(
									[
										$author$project$Ui$Button$onClick($author$project$Components$CustomerEmailModal$Preview),
										$author$project$Ui$Button$loading(loading)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Preview Email')
									])),
								$author$project$Components$CustomerEmailModal$viewCancelButton
							]);
				}
			}()));
};
var $author$project$Components$CustomerEmailModal$viewModal = function (model) {
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$CustomerEmailModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Send via Email')
					])),
				$author$project$Ui$Modal$body(
				$author$project$Components$CustomerEmailModal$viewModalBody(model)),
				$author$project$Ui$Modal$footer(
				$author$project$Components$CustomerEmailModal$viewModalFooter(model))
			]));
};
var $author$project$Components$CustomerEmailModal$modal = function (model) {
	if (!model.$) {
		return $author$project$Utils$Html$empty;
	} else {
		return $author$project$Components$CustomerEmailModal$viewModal(model);
	}
};
var $author$project$Components$CustomerSchedulePaymentModal$Schedule = {$: 1};
var $author$project$Components$CustomerSchedulePaymentModal$viewDate = F2(
	function (fields, form) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(6),
					$author$project$Ui$Form$Group$label('On Date')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Components$CustomerSchedulePaymentModal$DateInputMsg(fields.rZ),
					A2(
						$author$project$Components$DateInput$view,
						_List_fromArray(
							[
								$author$project$Components$DateInput$value(fields.PB),
								$author$project$Components$DateInput$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
								$author$project$Components$DateInput$errors(
								A2($author$project$Utils$Form$validationErrors, 0, form))
							]),
						fields.rZ))
				]));
	});
var $author$project$Components$CustomerSchedulePaymentModal$viewModal = function (model) {
	var fields = $author$project$Utils$Form$fields(model.SD);
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$CustomerSchedulePaymentModal$CloseModal,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Schedule Payment')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Components$CustomerSchedulePaymentModal$viewDate, fields, model.SD)
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$CustomerSchedulePaymentModal$CloseModal)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Schedule payment'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$loading(
								_Utils_eq(model.uf, $author$project$Api$Data$Loading)),
								$author$project$Ui$Button$onClick($author$project$Components$CustomerSchedulePaymentModal$Schedule)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Schedule Payment')
							]))
					]))
			]));
};
var $author$project$Components$CustomerSchedulePaymentModal$view = function (model) {
	if (model.$ === 1) {
		var model_ = model.a;
		return $author$project$Components$CustomerSchedulePaymentModal$viewModal(model_);
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Charges$New$Save = {$: 0};
var $author$project$Components$Charge$Form$formReady = function (_v0) {
	var model = _v0;
	var _v1 = model.Dv;
	switch (_v1.$) {
		case 0:
			return !model.tG;
		case 3:
			return true;
		default:
			return false;
	}
};
var $author$project$Ui$Element$Background = function (a) {
	return {$: 8, a: a};
};
var $author$project$Ui$Element$Primary50 = 0;
var $author$project$Ui$Element$bgPrimary50 = $author$project$Ui$Element$Background(0);
var $author$project$Api$Provider$Charge$One$meta = function (_v0) {
	var record = _v0.b;
	return record.W4;
};
var $author$project$Components$Charge$Form$RoutingFields$PatientInvoiceSelected = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Charge$Form$RoutingFields$SponsorInvoiceSelected = function (a) {
	return {$: 9, a: a};
};
var $author$project$Ui$Form$Accessible$Grid = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$Accessible$labelSpanSm = A2($elm$core$Basics$composeR, $author$project$Ui$Grid$spanSm, $author$project$Ui$Form$Accessible$Grid);
var $author$project$Api$Provider$CustomerInvoice$All$date = function (_v0) {
	var record = _v0;
	return record.PB;
};
var $author$project$Api$Provider$CustomerInvoice$All$humanStatus = function (_v0) {
	var record = _v0;
	return record.TH;
};
var $author$project$Components$Charge$Form$RoutingFields$invoiceLabel = F3(
	function (status, number, date) {
		return $elm_community$string_extra$String$Extra$humanize(status) + (' Invoice #' + ($elm$core$String$fromInt(number) + (' - Date ' + A2($justinmimbs$date$Date$format, 'MM/dd/yyyy', date))));
	});
var $author$project$Api$Provider$CustomerInvoice$All$invoiceNumber = function (_v0) {
	var record = _v0;
	return record.Uu;
};
var $author$project$Components$Charge$Form$RoutingFields$patientInvoiceSelectItems = F2(
	function (currentDate, dataCustomerInvoices) {
		if (dataCustomerInvoices.$ === 3) {
			var customerInvoices = dataCustomerInvoices.a;
			var newInvoice = A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just('new'),
				'Create a new draft invoice');
			var lastInvoice = $elm$core$List$head(
				$elm$core$List$reverse(customerInvoices));
			var lastInvoiceDate = function () {
				if (!lastInvoice.$) {
					var lastInvoice_ = lastInvoice.a;
					return $author$project$Api$Provider$CustomerInvoice$All$date(lastInvoice_);
				} else {
					return currentDate;
				}
			}();
			var label = function (invoice) {
				return A3(
					$author$project$Components$Charge$Form$RoutingFields$invoiceLabel,
					$author$project$Api$Provider$CustomerInvoice$All$humanStatus(invoice),
					$author$project$Api$Provider$CustomerInvoice$All$invoiceNumber(invoice),
					$author$project$Api$Provider$CustomerInvoice$All$date(invoice));
			};
			return (A3($justinmimbs$date$Date$diff, 3, lastInvoiceDate, currentDate) > 30) ? _List_fromArray(
				[newInvoice]) : _Utils_ap(
				A2(
					$elm$core$List$map,
					function (invoice) {
						return A3(
							$author$project$Ui$Form$Select$option,
							_List_Nil,
							$elm$core$Maybe$Just(
								$author$project$Api$Provider$CustomerInvoice$All$id(invoice)),
							label(invoice));
					},
					customerInvoices),
				_List_fromArray(
					[newInvoice]));
		} else {
			return _List_Nil;
		}
	});
var $author$project$Ui$Form$Accessible$Required = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$Accessible$required = $author$project$Ui$Form$Accessible$Required;
var $author$project$Ui$Form$Accessible$Select = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Ui$Form$Accessible$select = $author$project$Ui$Form$Accessible$Select;
var $author$project$Ui$Form$Accessible$AccessibleInput = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Ui$Grid$extractSpanValue = function (option) {
	extractSpanValue:
	while (true) {
		_v0$2:
		while (true) {
			switch (option.$) {
				case 0:
					var screenSize = option.a;
					var spanValue = option.b;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(screenSize, spanValue));
				case 2:
					if (option.a.a) {
						var _v1 = option.a;
						var innerOption = _v1.b;
						var $temp$option = innerOption;
						option = $temp$option;
						continue extractSpanValue;
					} else {
						break _v0$2;
					}
				default:
					break _v0$2;
			}
		}
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Ui$ScreenSize$Lg = 3;
var $author$project$Ui$Grid$spanLg = $author$project$Ui$Grid$Span(3);
var $author$project$Ui$ScreenSize$Xl = 4;
var $author$project$Ui$Grid$spanXl = $author$project$Ui$Grid$Span(4);
var $author$project$Ui$Grid$complementSpan = function (labelOptions) {
	var spanValues = A2($elm$core$List$filterMap, $author$project$Ui$Grid$extractSpanValue, labelOptions);
	var createComplementarySpan = function (_v1) {
		var screenSize = _v1.a;
		var spanValue = _v1.b;
		switch (screenSize) {
			case 0:
				return $author$project$Ui$Grid$span(12 - spanValue);
			case 1:
				return $author$project$Ui$Grid$spanSm(12 - spanValue);
			case 2:
				return $author$project$Ui$Grid$spanMd(12 - spanValue);
			case 3:
				return $author$project$Ui$Grid$spanLg(12 - spanValue);
			default:
				return $author$project$Ui$Grid$spanXl(12 - spanValue);
		}
	};
	return A2($elm$core$List$map, createComplementarySpan, spanValues);
};
var $author$project$Ui$Form$Accessible$defaultLabelOptions = {bD: _List_Nil, akR: false};
var $author$project$Ui$Form$Accessible$labelOptionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (opt, rec) {
				if (!opt.$) {
					var gridOption = opt.a;
					return _Utils_update(
						rec,
						{
							bD: A2($elm$core$List$cons, gridOption, rec.bD)
						});
				} else {
					var bool = opt.a;
					return _Utils_update(
						rec,
						{akR: bool});
				}
			}),
		$author$project$Ui$Form$Accessible$defaultLabelOptions,
		options);
};
var $author$project$Ui$Form$Accessible$defaultInputOptions = {agX: _List_Nil, bD: _List_Nil};
var $author$project$Ui$Form$Accessible$inputOptionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (opt, rec) {
				if (!opt.$) {
					var gridOption = opt.a;
					return _Utils_update(
						rec,
						{
							bD: A2($elm$core$List$cons, gridOption, rec.bD)
						});
				} else {
					var errors_ = opt.a;
					return _Utils_update(
						rec,
						{agX: errors_});
				}
			}),
		$author$project$Ui$Form$Accessible$defaultInputOptions,
		options);
};
var $author$project$Components$DateInput$HideErrors = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$DateInput$hideErrors = $author$project$Components$DateInput$HideErrors;
var $author$project$Ui$Form$CurrencyInput$HideErrors = function (a) {
	return {$: 10, a: a};
};
var $author$project$Ui$Form$CurrencyInput$hideErrors = $author$project$Ui$Form$CurrencyInput$HideErrors;
var $author$project$Ui$Form$Select$HideErrors = function (a) {
	return {$: 8, a: a};
};
var $author$project$Ui$Form$Select$hideErrors = $author$project$Ui$Form$Select$HideErrors;
var $author$project$Ui$Form$Textarea$HideErrors = function (a) {
	return {$: 12, a: a};
};
var $author$project$Ui$Form$Textarea$hideErrors = $author$project$Ui$Form$Textarea$HideErrors;
var $author$project$Components$ResourceFilter$AriaLabel = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$ResourceFilter$ariaLabel = $author$project$Components$ResourceFilter$AriaLabel;
var $author$project$Ui$Form$Accessible$resourceFilterOptions = F2(
	function (label_, errors_) {
		return _List_fromArray(
			[
				$author$project$Components$ResourceFilter$errors(errors_),
				$author$project$Components$ResourceFilter$invalid(
				!$elm$core$List$isEmpty(errors_)),
				$author$project$Components$ResourceFilter$ariaLabel(label_)
			]);
	});
var $author$project$Components$ResourceFilter$CreditCategory$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Components$ResourceFilter$CreditCategory$view = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$view,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.Jy),
					options),
				model.b8));
	});
var $author$project$Ui$Form$Accessible$viewInput = function (accessibleInput) {
	if (accessibleInput.$ === 1) {
		return $elm$html$Html$text('');
	} else {
		var labelText = accessibleInput.a;
		var inputOptions = accessibleInput.b;
		var input_ = accessibleInput.c;
		var optionsRecord = $author$project$Ui$Form$Accessible$inputOptionsToRecord(inputOptions);
		return A2(
			$elm$html$Html$label,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sr-only')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(labelText)
						])),
					function () {
					switch (input_.$) {
						case 0:
							var options = input_.a;
							return $author$project$Ui$Form$Input$view(
								A2(
									$elm$core$List$cons,
									$author$project$Ui$Form$Input$errors(optionsRecord.agX),
									A2(
										$elm$core$List$cons,
										$author$project$Ui$Form$Input$invalid(
											!$elm$core$List$isEmpty(optionsRecord.agX)),
										A2(
											$elm$core$List$cons,
											$author$project$Ui$Form$Input$hideErrors(true),
											options))));
						case 1:
							var options = input_.a;
							return $author$project$Ui$Form$Textarea$view(
								A2(
									$elm$core$List$cons,
									$author$project$Ui$Form$Textarea$errors(optionsRecord.agX),
									A2(
										$elm$core$List$cons,
										$author$project$Ui$Form$Textarea$invalid(
											!$elm$core$List$isEmpty(optionsRecord.agX)),
										A2(
											$elm$core$List$cons,
											$author$project$Ui$Form$Textarea$hideErrors(true),
											options))));
						case 2:
							var options = input_.a;
							return $author$project$Ui$Form$CurrencyInput$view(
								A2(
									$elm$core$List$cons,
									$author$project$Ui$Form$CurrencyInput$errors(optionsRecord.agX),
									A2(
										$elm$core$List$cons,
										$author$project$Ui$Form$CurrencyInput$invalid(
											!$elm$core$List$isEmpty(optionsRecord.agX)),
										A2(
											$elm$core$List$cons,
											$author$project$Ui$Form$CurrencyInput$hideErrors(true),
											options))));
						case 4:
							var options = input_.a;
							var items = input_.b;
							return A2(
								$author$project$Ui$Form$Select$view,
								A2(
									$elm$core$List$cons,
									$author$project$Ui$Form$Select$errors(optionsRecord.agX),
									A2(
										$elm$core$List$cons,
										$author$project$Ui$Form$Select$invalid(
											!$elm$core$List$isEmpty(optionsRecord.agX)),
										A2(
											$elm$core$List$cons,
											$author$project$Ui$Form$Select$hideErrors(true),
											options))),
								items);
						case 5:
							var options = input_.a;
							var trigger = input_.b;
							var items = input_.c;
							var model = input_.d;
							return A4(
								$author$project$Ui$Dropdown$viewSelect,
								A2(
									$elm$core$List$cons,
									$author$project$Ui$Dropdown$errors(optionsRecord.agX),
									A2(
										$elm$core$List$cons,
										$author$project$Ui$Dropdown$invalid(
											!$elm$core$List$isEmpty(optionsRecord.agX)),
										options)),
								trigger,
								items,
								model);
						case 6:
							var options = input_.a;
							var content = input_.b;
							return A2($author$project$Ui$Form$Checkbox$view, options, content);
						case 7:
							var mapper = input_.a;
							var options = input_.b;
							var model = input_.c;
							return A2(
								$elm$html$Html$map,
								mapper,
								A2(
									$author$project$Components$ResourceFilter$Patient$view,
									_Utils_ap(
										A2($author$project$Ui$Form$Accessible$resourceFilterOptions, labelText, optionsRecord.agX),
										options),
									model));
						case 8:
							var mapper = input_.a;
							var options = input_.b;
							var model = input_.c;
							return A2(
								$elm$html$Html$map,
								mapper,
								A2(
									$author$project$Components$ResourceFilter$ChargeItem$view,
									_Utils_ap(
										A2($author$project$Ui$Form$Accessible$resourceFilterOptions, labelText, optionsRecord.agX),
										options),
									model));
						case 9:
							var mapper = input_.a;
							var options = input_.b;
							var model = input_.c;
							return A2(
								$elm$html$Html$map,
								mapper,
								A2(
									$author$project$Components$ResourceFilter$Category$view,
									_Utils_ap(
										A2($author$project$Ui$Form$Accessible$resourceFilterOptions, labelText, optionsRecord.agX),
										options),
									model));
						case 10:
							var mapper = input_.a;
							var options = input_.b;
							var model = input_.c;
							return A2(
								$elm$html$Html$map,
								mapper,
								A2(
									$author$project$Components$ResourceFilter$Practitioner$view,
									_Utils_ap(
										A2($author$project$Ui$Form$Accessible$resourceFilterOptions, labelText, optionsRecord.agX),
										options),
									model));
						case 12:
							var mapper = input_.a;
							var options = input_.b;
							var model = input_.c;
							return A2(
								$elm$html$Html$map,
								mapper,
								A2(
									$author$project$Components$ResourceFilter$CreditCategory$view,
									_Utils_ap(
										A2($author$project$Ui$Form$Accessible$resourceFilterOptions, labelText, optionsRecord.agX),
										options),
									model));
						case 11:
							var mapper = input_.a;
							var options = input_.b;
							var model = input_.c;
							return A2(
								$elm$html$Html$map,
								mapper,
								A2(
									$author$project$Components$ResourceFilter$Location$view,
									_Utils_ap(
										A2($author$project$Ui$Form$Accessible$resourceFilterOptions, labelText, optionsRecord.agX),
										options),
									model));
						case 3:
							var mapper = input_.a;
							var options = input_.b;
							var model = input_.c;
							return A2(
								$elm$html$Html$map,
								mapper,
								A2(
									$author$project$Components$DateInput$view,
									A2(
										$elm$core$List$cons,
										$author$project$Components$DateInput$errors(optionsRecord.agX),
										A2(
											$elm$core$List$cons,
											$author$project$Components$DateInput$invalid(
												!$elm$core$List$isEmpty(optionsRecord.agX)),
											A2(
												$elm$core$List$cons,
												$author$project$Components$DateInput$hideErrors(true),
												options))),
									model));
						default:
							var content = input_.a;
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('new-form-group__static')
									]),
								content);
					}
				}(),
					function () {
					var _v2 = optionsRecord.agX;
					if (!_v2.b) {
						return $elm$html$Html$text('');
					} else {
						var errors_ = _v2;
						return A2(
							$elm$html$Html$div,
							_List_Nil,
							A2(
								$elm$core$List$map,
								function (err) {
									return A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												A2($elm$html$Html$Attributes$attribute, 'role', 'alert'),
												$elm$html$Html$Attributes$class('text-danger')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(err)
											]));
								},
								errors_));
					}
				}()
				]));
	}
};
var $author$project$Ui$Form$Accessible$viewGroupInput = function (accessibleInput) {
	if (accessibleInput.$ === 1) {
		return $author$project$Ui$Grid$none;
	} else {
		var inputOptions = accessibleInput.b;
		var record = $author$project$Ui$Form$Accessible$inputOptionsToRecord(inputOptions);
		return A2(
			$author$project$Ui$Grid$column,
			record.bD,
			_List_fromArray(
				[
					$author$project$Ui$Form$Accessible$viewInput(accessibleInput)
				]));
	}
};
var $author$project$Ui$Form$Accessible$single = F4(
	function (legend, options, inputOptions, input_) {
		var optionsRecord = $author$project$Ui$Form$Accessible$labelOptionsToRecord(options);
		var complementarySpans = $author$project$Ui$Grid$complementSpan(optionsRecord.bD);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('new-form-group')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							optionsRecord.bD,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('new-form-group__label'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('new-form-group__label--required', optionsRecord.akR)
												]))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(legend)
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							complementarySpans,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('new-form-group__content')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Grid$row,
											_List_Nil,
											_List_fromArray(
												[
													$author$project$Ui$Form$Accessible$viewGroupInput(
													A3($author$project$Ui$Form$Accessible$AccessibleInput, legend, inputOptions, input_))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Api$Provider$Invoice$All$humanStatus = function (_v0) {
	var record = _v0.b;
	return record.TH;
};
var $author$project$Api$Provider$Invoice$All$id = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Provider$Invoice$Min$id(min);
};
var $author$project$Api$Provider$Invoice$All$invoiceDate = function (_v0) {
	var record = _v0.b;
	return record.Uq;
};
var $author$project$Api$Provider$Invoice$All$invoiceNumber = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Provider$Invoice$Min$invoiceNumber(min);
};
var $author$project$Components$Charge$Form$RoutingFields$sponsorInvoiceSelectItems = function (dataInvoices) {
	if (dataInvoices.$ === 3) {
		var invoices = dataInvoices.a;
		var newInvoice = A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just('new'),
			'Create a new draft invoice');
		var label = function (invoice) {
			return A3(
				$author$project$Components$Charge$Form$RoutingFields$invoiceLabel,
				$author$project$Api$Invoice$Status$toString(
					$author$project$Api$Provider$Invoice$All$humanStatus(invoice)),
				$author$project$Api$Provider$Invoice$All$invoiceNumber(invoice),
				$author$project$Api$Provider$Invoice$All$invoiceDate(invoice));
		};
		var baseItems = A2(
			$elm$core$List$map,
			function (invoice) {
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$Invoice$All$id(invoice)),
					label(invoice));
			},
			invoices);
		return _Utils_ap(
			baseItems,
			_List_fromArray(
				[newInvoice]));
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Charge$Form$RoutingFields$viewInvoice = F2(
	function (model, readOnly) {
		var _v0 = _Utils_Tuple2(model.ahi.Y6, model.dd);
		_v0$2:
		while (true) {
			if (!_v0.a) {
				if (!_v0.b.$) {
					var _v1 = _v0.a;
					var currentDate = _v0.b.a;
					return A4(
						$author$project$Ui$Form$Accessible$single,
						'Invoice',
						_List_fromArray(
							[
								$author$project$Ui$Form$Accessible$labelSpanSm(4),
								$author$project$Ui$Form$Accessible$required(true)
							]),
						_List_Nil,
						A2(
							$author$project$Ui$Form$Accessible$select,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(model.ahi.Us),
									$author$project$Ui$Form$Select$onChange($author$project$Components$Charge$Form$RoutingFields$PatientInvoiceSelected),
									$author$project$Ui$Form$Select$disabled(
									readOnly || _Utils_eq(model.ct, $author$project$Api$Data$Loading))
								]),
							A2($author$project$Components$Charge$Form$RoutingFields$patientInvoiceSelectItems, currentDate, model.ct)));
				} else {
					break _v0$2;
				}
			} else {
				if (!_v0.b.$) {
					var _v2 = _v0.a;
					return A4(
						$author$project$Ui$Form$Accessible$single,
						'Invoice',
						_List_fromArray(
							[
								$author$project$Ui$Form$Accessible$labelSpanSm(4),
								$author$project$Ui$Form$Accessible$required(true)
							]),
						_List_Nil,
						A2(
							$author$project$Ui$Form$Accessible$select,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(model.ahi.Us),
									$author$project$Ui$Form$Select$onChange($author$project$Components$Charge$Form$RoutingFields$SponsorInvoiceSelected),
									$author$project$Ui$Form$Select$disabled(
									readOnly || (_Utils_eq(model.fi, $author$project$Api$Data$Loading) || _Utils_eq(model.hl, $author$project$Api$Data$Loading)))
								]),
							$author$project$Components$Charge$Form$RoutingFields$sponsorInvoiceSelectItems(model.fi)));
				} else {
					break _v0$2;
				}
			}
		}
		return $author$project$Utils$Html$empty;
	});
var $author$project$Components$Charge$Form$RoutingFields$SponsorPayerSelected = function (a) {
	return {$: 8, a: a};
};
var $author$project$Ui$Form$Accessible$group = F3(
	function (legend, options, inputs) {
		var optionsRecord = $author$project$Ui$Form$Accessible$labelOptionsToRecord(options);
		var complementarySpans = $author$project$Ui$Grid$complementSpan(optionsRecord.bD);
		return A2(
			$elm$html$Html$fieldset,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('new-form-group')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$legend,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('new-form-group__legend')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(legend)
						])),
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							optionsRecord.bD,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('new-form-group__label'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('new-form-group__label--required', optionsRecord.akR)
												]))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(legend)
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							complementarySpans,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('new-form-group__content')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Grid$row,
											_List_Nil,
											A2($elm$core$List$map, $author$project$Ui$Form$Accessible$viewGroupInput, inputs))
										]))
								]))
						]))
				]));
	});
var $author$project$Ui$Form$Accessible$input = F3(
	function (labelText, options, input_) {
		return A3($author$project$Ui$Form$Accessible$AccessibleInput, labelText, options, input_);
	});
var $author$project$Ui$Form$Accessible$InputGrid = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$Accessible$inputSpanLg = A2($elm$core$Basics$composeR, $author$project$Ui$Grid$spanLg, $author$project$Ui$Form$Accessible$InputGrid);
var $author$project$Ui$Form$Accessible$inputSpanMd = A2($elm$core$Basics$composeR, $author$project$Ui$Grid$spanMd, $author$project$Ui$Form$Accessible$InputGrid);
var $author$project$Ui$Form$Accessible$inputSpanSm = A2($elm$core$Basics$composeR, $author$project$Ui$Grid$spanSm, $author$project$Ui$Form$Accessible$InputGrid);
var $author$project$Ui$Form$Accessible$None = {$: 1};
var $author$project$Ui$Form$Accessible$none = $author$project$Ui$Form$Accessible$None;
var $author$project$Ui$Form$Accessible$PatientFilter = F3(
	function (a, b, c) {
		return {$: 7, a: a, b: b, c: c};
	});
var $author$project$Ui$Form$Accessible$patientFilter = $author$project$Ui$Form$Accessible$PatientFilter;
var $author$project$Api$Provider$CompanyAccount$ForPatient$company = function (_v0) {
	var record = _v0.b;
	return record.afQ;
};
var $author$project$Api$Provider$Patient$One$companyAccounts = function (_v0) {
	var record = _v0.b;
	return record.Od;
};
var $author$project$Components$Charge$Form$RoutingFields$sponsorPayerSelectItems = function (patientData) {
	if (patientData.$ === 3) {
		var patient = patientData.a;
		var accounts = $author$project$Api$Provider$Patient$One$companyAccounts(patient);
		var companies = A2($elm$core$List$map, $author$project$Api$Provider$CompanyAccount$ForPatient$company, accounts);
		return A2(
			$elm$core$List$map,
			function (company) {
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$Company$Min$id(company)),
					$author$project$Api$Provider$Company$Min$name(company));
			},
			companies);
	} else {
		return _List_Nil;
	}
};
var $author$project$Ui$Form$Accessible$Static = function (a) {
	return {$: 13, a: a};
};
var $author$project$Ui$Form$Accessible$static = function (content) {
	return $author$project$Ui$Form$Accessible$Static(content);
};
var $author$project$Components$Charge$Form$RoutingFields$PayerSelected = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Charge$Form$RoutingFields$buttonStyle = F2(
	function (payer, selectedPayerType) {
		return _Utils_eq(payer, selectedPayerType) ? 1 : 0;
	});
var $author$project$Components$Charge$Form$RoutingFields$viewPayerButton = F3(
	function (payerType, selectedPayerType, disabled) {
		return A3(
			$author$project$Ui$Button$view,
			{
				mm: 'Select ' + $author$project$Api$Charge$PayerType$toString(payerType)
			},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(selectedPayerType, payerType)),
					$author$project$Ui$Button$styled(
					A2($author$project$Components$Charge$Form$RoutingFields$buttonStyle, payerType, selectedPayerType)),
					$author$project$Ui$Button$onClick(
					$author$project$Components$Charge$Form$RoutingFields$PayerSelected(payerType)),
					$author$project$Ui$Button$disabled(disabled)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Api$Charge$PayerType$toString(payerType))
				]));
	});
var $author$project$Components$Charge$Form$RoutingFields$viewPayer = F4(
	function (model, readOnly, preview, patient) {
		var warningContent = model.tI ? A2(
			$elm$core$Maybe$withDefault,
			$author$project$Ui$Form$Accessible$none,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$singleton,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Ui$Form$Accessible$static,
						A2(
							$author$project$Ui$Form$Accessible$input,
							'',
							_List_fromArray(
								[
									$author$project$Ui$Form$Accessible$inputSpanSm(12)
								])))),
				A2($author$project$Components$ChargeRoutingWarning$viewWithChargeCalculate, model.ahi.Y6, preview))) : $author$project$Ui$Form$Accessible$none;
		var sponsorDisabled = _Utils_eq(
			$author$project$Components$Charge$Form$RoutingFields$patientCurrentCompany(patient),
			$elm$core$Maybe$Nothing);
		var payerFilterInput = function () {
			var _v0 = model.ahi.Y6;
			if (!_v0) {
				return A3(
					$author$project$Ui$Form$Accessible$patientFilter,
					$author$project$Components$Charge$Form$RoutingFields$PatientPayerFilterMsg,
					_List_fromArray(
						[
							$author$project$Components$ResourceFilter$disabled(readOnly)
						]),
					model.eP);
			} else {
				return A2(
					$author$project$Ui$Form$Accessible$select,
					_List_fromArray(
						[
							$author$project$Ui$Form$Select$value(model.ahi.ajW),
							$author$project$Ui$Form$Select$onChange($author$project$Components$Charge$Form$RoutingFields$SponsorPayerSelected),
							$author$project$Ui$Form$Select$disabled(
							$author$project$Api$Charge$PayerType$adjudicatedToSponsor(preview) || _Utils_eq(model.YY, $author$project$Api$Data$Loading))
						]),
					$author$project$Components$Charge$Form$RoutingFields$sponsorPayerSelectItems(model.YY));
			}
		}();
		var buttonsDisabled = _Utils_eq(model.hl, $author$project$Api$Data$Loading) || readOnly;
		var payerButtonsContent = _List_fromArray(
			[
				$author$project$Ui$Button$group(
				_List_fromArray(
					[
						A3($author$project$Components$Charge$Form$RoutingFields$viewPayerButton, 0, model.ahi.Y6, buttonsDisabled),
						sponsorDisabled ? A3(
						$author$project$Ui$Tooltip$view,
						_List_Nil,
						'The selected patient does not have any sponsors available.',
						_List_fromArray(
							[
								A3($author$project$Components$Charge$Form$RoutingFields$viewPayerButton, 1, model.ahi.Y6, true)
							])) : A3($author$project$Components$Charge$Form$RoutingFields$viewPayerButton, 1, model.ahi.Y6, buttonsDisabled)
					]))
			]);
		return A3(
			$author$project$Ui$Form$Accessible$group,
			'Payer',
			_List_fromArray(
				[
					$author$project$Ui$Form$Accessible$labelSpanSm(4),
					$author$project$Ui$Form$Accessible$required(true)
				]),
			_List_fromArray(
				[
					warningContent,
					A3(
					$author$project$Ui$Form$Accessible$input,
					'Type',
					_List_fromArray(
						[
							$author$project$Ui$Form$Accessible$inputSpanMd(4),
							$author$project$Ui$Form$Accessible$inputSpanLg(3)
						]),
					$author$project$Ui$Form$Accessible$static(payerButtonsContent)),
					A3(
					$author$project$Ui$Form$Accessible$input,
					'Selection',
					_List_fromArray(
						[
							$author$project$Ui$Form$Accessible$inputSpanMd(8),
							$author$project$Ui$Form$Accessible$inputSpanLg(9)
						]),
					payerFilterInput)
				]));
	});
var $author$project$Components$Charge$Form$RoutingFields$view = F2(
	function (model, readOnly) {
		var _v0 = _Utils_Tuple2(model.akd, model.YY);
		if ((_v0.a.$ === 3) && (_v0.b.$ === 3)) {
			var _v1 = _v0.a;
			var preview = _v1.a;
			var _v2 = _v0.b;
			var patient = _v2.a;
			return _List_fromArray(
				[
					A4($author$project$Components$Charge$Form$RoutingFields$viewPayer, model, readOnly, preview, patient),
					A2($author$project$Components$Charge$Form$RoutingFields$viewInvoice, model, readOnly)
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Charge$Form$ToggleAdditionalDetails = {$: 16};
var $author$project$Components$Charge$Form$viewAdditionalDetails = function (showAdditionalDetails) {
	return A4(
		$author$project$Ui$Form$Accessible$single,
		'',
		_List_fromArray(
			[
				$author$project$Ui$Form$Accessible$labelSpanSm(4)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Accessible$inputSpanSm(6)
			]),
		$author$project$Ui$Form$Accessible$static(
			_List_fromArray(
				[
					function () {
					var label = showAdditionalDetails ? 'Hide additional charge details ' : 'See additional charge details ';
					return A3(
						$author$project$Ui$Button$view,
						{mm: label},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$onClick($author$project$Components$Charge$Form$ToggleAdditionalDetails)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(label),
								$author$project$Ui$Icon$chevronDown(_List_Nil)
							]));
				}()
				])));
};
var $author$project$Ui$Form$Accessible$CategoryFilter = F3(
	function (a, b, c) {
		return {$: 9, a: a, b: b, c: c};
	});
var $author$project$Ui$Form$Accessible$categoryFilter = $author$project$Ui$Form$Accessible$CategoryFilter;
var $author$project$Components$Charge$Form$viewCategory = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var categoryResourceFilter = _v0.c8;
	return A4(
		$author$project$Ui$Form$Accessible$single,
		'Category',
		_List_fromArray(
			[
				$author$project$Ui$Form$Accessible$labelSpanSm(4)
			]),
		_List_Nil,
		A3(
			$author$project$Ui$Form$Accessible$categoryFilter,
			$author$project$Components$Charge$Form$CategoryResourceFilterMsg,
			_List_fromArray(
				[
					$author$project$Components$ResourceFilter$style(0)
				]),
			categoryResourceFilter));
};
var $author$project$Ui$Form$Accessible$ChargeItemFilter = F3(
	function (a, b, c) {
		return {$: 8, a: a, b: b, c: c};
	});
var $author$project$Ui$Form$Accessible$chargeItemFilter = $author$project$Ui$Form$Accessible$ChargeItemFilter;
var $author$project$Ui$Form$Accessible$Errors = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$Accessible$errors = $author$project$Ui$Form$Accessible$Errors;
var $author$project$Components$Charge$Form$viewChargeItemInput = F3(
	function (chargeItemResourceFilter, readOnly_, form) {
		return A4(
			$author$project$Ui$Form$Accessible$single,
			'Charge Item',
			_List_fromArray(
				[
					$author$project$Ui$Form$Accessible$labelSpanSm(4),
					$author$project$Ui$Form$Accessible$required(true)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Accessible$errors(
					A2($author$project$Utils$Form$validationErrors, 1, form))
				]),
			A3(
				$author$project$Ui$Form$Accessible$chargeItemFilter,
				$author$project$Components$Charge$Form$ChargeItemResourceFilterMsg,
				_List_fromArray(
					[
						$author$project$Components$ResourceFilter$disabled(readOnly_)
					]),
				chargeItemResourceFilter));
	});
var $author$project$Components$Charge$Form$Description = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Charge$Form$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$Textarea$Test = function (a) {
	return {$: 10, a: a};
};
var $author$project$Ui$Form$Textarea$test = function (dataTest) {
	return $author$project$Ui$Form$Textarea$Test(dataTest);
};
var $author$project$Ui$Form$Accessible$Textarea = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$Accessible$textarea = $author$project$Ui$Form$Accessible$Textarea;
var $author$project$Components$Charge$Form$viewDescription = function (fields) {
	return A4(
		$author$project$Ui$Form$Accessible$single,
		'Description',
		_List_fromArray(
			[
				$author$project$Ui$Form$Accessible$labelSpanSm(4)
			]),
		_List_Nil,
		$author$project$Ui$Form$Accessible$textarea(
			_List_fromArray(
				[
					$author$project$Ui$Form$Textarea$value(fields.Qr),
					$author$project$Ui$Form$Textarea$placeholder('e.g. Examination'),
					$author$project$Ui$Form$Textarea$onInput(
					A2($elm$core$Basics$composeL, $author$project$Components$Charge$Form$FormUpdated, $author$project$Components$Charge$Form$Description)),
					$author$project$Ui$Form$Textarea$test('charge-description')
				])));
};
var $author$project$Ui$Form$Accessible$LocationFilter = F3(
	function (a, b, c) {
		return {$: 11, a: a, b: b, c: c};
	});
var $author$project$Ui$Form$Accessible$locationFilter = $author$project$Ui$Form$Accessible$LocationFilter;
var $author$project$Components$Charge$Form$viewLocation = function (locationResourceFilter) {
	return A4(
		$author$project$Ui$Form$Accessible$single,
		'Location',
		_List_fromArray(
			[
				$author$project$Ui$Form$Accessible$labelSpanSm(4)
			]),
		_List_Nil,
		A3(
			$author$project$Ui$Form$Accessible$locationFilter,
			$author$project$Components$Charge$Form$LocationResourceFilterMsg,
			_List_fromArray(
				[
					$author$project$Components$ResourceFilter$style(0)
				]),
			locationResourceFilter));
};
var $author$project$Components$Charge$Form$viewPatientInput = F3(
	function (patientResourceFilter, readOnly_, form) {
		return A4(
			$author$project$Ui$Form$Accessible$single,
			'Patient',
			_List_fromArray(
				[
					$author$project$Ui$Form$Accessible$labelSpanSm(4),
					$author$project$Ui$Form$Accessible$required(true)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Accessible$errors(
					A2($author$project$Utils$Form$validationErrors, 0, form))
				]),
			A3(
				$author$project$Ui$Form$Accessible$patientFilter,
				$author$project$Components$Charge$Form$PatientResourceFilterMsg,
				_List_fromArray(
					[
						$author$project$Components$ResourceFilter$disabled(readOnly_)
					]),
				patientResourceFilter));
	});
var $author$project$Components$Charge$Form$DiscountOverridden = function (a) {
	return {$: 8, a: a};
};
var $author$project$Ui$Form$Accessible$CurrencyInput = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Form$Accessible$currencyInput = $author$project$Ui$Form$Accessible$CurrencyInput;
var $author$project$Api$Provider$Charge$Meta$priceInCentsEditable = function (_v0) {
	var meta = _v0;
	return meta.Dw.Q4;
};
var $author$project$Ui$Form$CurrencyInput$Test = function (a) {
	return {$: 8, a: a};
};
var $author$project$Ui$Form$CurrencyInput$test = function (dataTest) {
	return $author$project$Ui$Form$CurrencyInput$Test(dataTest);
};
var $author$project$Components$Charge$Form$viewPriceInput = F6(
	function (fields, readyOnly, form, meta, preview, isTimeBased) {
		var hasDiscount = function () {
			var _v3 = $author$project$Api$Data$toMaybe(preview);
			if (!_v3.$) {
				var preview_ = _v3.a;
				return !(!$author$project$Api$Provider$Charge$Calculate$discountInCents(preview_));
			} else {
				return false;
			}
		}();
		var discountNotRemoved = (!fields.QE) && hasDiscount;
		var staticContent = function () {
			if (discountNotRemoved && (!readyOnly)) {
				var hasPrepaidDiscount = function () {
					var _v2 = $author$project$Api$Data$toMaybe(preview);
					if (!_v2.$) {
						var preview_ = _v2.a;
						return $author$project$Api$Provider$Charge$Calculate$prepaidAllocatedQuantity(preview_) > 0;
					} else {
						return false;
					}
				}();
				var hasMembershipDiscount = function () {
					var _v1 = $author$project$Api$Data$toMaybe(preview);
					if (!_v1.$) {
						var preview_ = _v1.a;
						return !$elm$core$List$isEmpty(
							$author$project$Api$Provider$Charge$Calculate$coveredCharges(preview_));
					} else {
						return false;
					}
				}();
				var removeRuleLabel = (hasPrepaidDiscount && (!hasMembershipDiscount)) ? 'Remove package rule' : 'Remove membership rule';
				return A3(
					$author$project$Ui$Form$Accessible$input,
					'',
					_List_Nil,
					$author$project$Ui$Form$Accessible$static(
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{mm: removeRuleLabel},
								_List_fromArray(
									[
										$author$project$Ui$Button$onClick(
										$author$project$Components$Charge$Form$FormUpdated(
											$author$project$Components$Charge$Form$DiscountOverridden(true)))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(removeRuleLabel)
									]))
							])));
			} else {
				return $author$project$Ui$Form$Accessible$none;
			}
		}();
		var canEdit = A2(
			$elm$core$Maybe$withDefault,
			A2(
				$elm$core$Maybe$withDefault,
				true,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$Basics$not,
						function ($) {
							return $.aid;
						}),
					fields.mL)),
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$Meta$priceInCentsEditable, meta));
		var currencyOptions = A2(
			$elm$core$List$cons,
			$author$project$Ui$Form$CurrencyInput$value(fields.Dw),
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Form$CurrencyInput$placeholder('e.g. 50.00'),
				A2(
					$elm$core$List$cons,
					$author$project$Ui$Form$CurrencyInput$disabled(hasDiscount || (readyOnly || (!canEdit))),
					A2(
						$elm$core$List$cons,
						$author$project$Ui$Form$CurrencyInput$onInput(
							A2($elm$core$Basics$composeL, $author$project$Components$Charge$Form$FormUpdated, $author$project$Components$Charge$Form$PriceInCents)),
						A2(
							$elm$core$List$cons,
							$author$project$Ui$Form$CurrencyInput$test('charge-price'),
							function () {
								var _v0 = _Utils_Tuple2(
									isTimeBased,
									A2(
										$elm$core$Maybe$map,
										$elm$core$String$toLower,
										A2($elm$core$Maybe$map, $author$project$Api$Provider$Uom$Shared$name, fields._h)));
								if (_v0.a && (!_v0.b.$)) {
									var name = _v0.b.a;
									return _List_fromArray(
										[
											$author$project$Ui$Form$CurrencyInput$postfix('per ' + name)
										]);
								} else {
									return _List_Nil;
								}
							}())))));
		var priceInput = A3(
			$author$project$Ui$Form$Accessible$input,
			'Price',
			_List_fromArray(
				[
					$author$project$Ui$Form$Accessible$inputSpanSm(4),
					$author$project$Ui$Form$Accessible$errors(
					A2($author$project$Utils$Form$validationErrors, 3, form))
				]),
			$author$project$Ui$Form$Accessible$currencyInput(currencyOptions));
		return A3(
			$author$project$Ui$Form$Accessible$group,
			'Price',
			_List_fromArray(
				[
					$author$project$Ui$Form$Accessible$labelSpanSm(4),
					$author$project$Ui$Form$Accessible$required(true)
				]),
			_List_fromArray(
				[priceInput, staticContent]));
	});
var $author$project$Ui$Form$Accessible$PractitionerFilter = F3(
	function (a, b, c) {
		return {$: 10, a: a, b: b, c: c};
	});
var $author$project$Ui$Form$Accessible$practitionerFilter = $author$project$Ui$Form$Accessible$PractitionerFilter;
var $author$project$Components$Charge$Form$viewProvider = function (practitionerResourceFilter) {
	return A4(
		$author$project$Ui$Form$Accessible$single,
		'Provider',
		_List_fromArray(
			[
				$author$project$Ui$Form$Accessible$labelSpanSm(4)
			]),
		_List_Nil,
		A3(
			$author$project$Ui$Form$Accessible$practitionerFilter,
			$author$project$Components$Charge$Form$PractitionerResourceFilterMsg,
			_List_fromArray(
				[
					$author$project$Components$ResourceFilter$style(0)
				]),
			practitionerResourceFilter));
};
var $author$project$Components$Charge$Form$Quantity = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Charge$Form$QuantityUom = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Form$Accessible$inputSpan = A2($elm$core$Basics$composeR, $author$project$Ui$Grid$span, $author$project$Ui$Form$Accessible$InputGrid);
var $author$project$Ui$Form$Accessible$labelSpan = A2($elm$core$Basics$composeR, $author$project$Ui$Grid$span, $author$project$Ui$Form$Accessible$Grid);
var $author$project$Ui$Form$Accessible$TextInput = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$Accessible$textInput = $author$project$Ui$Form$Accessible$TextInput;
var $author$project$Components$Charge$Form$viewQuantityInput = F4(
	function (fields, readOnly_, form, isTimeBased) {
		return A3(
			$author$project$Ui$Form$Accessible$group,
			'Quantity',
			_List_fromArray(
				[
					$author$project$Ui$Form$Accessible$labelSpan(4),
					$author$project$Ui$Form$Accessible$required(true)
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Form$Accessible$input,
					'Quantity',
					_List_fromArray(
						[
							$author$project$Ui$Form$Accessible$inputSpan(4),
							$author$project$Ui$Form$Accessible$errors(
							A2($author$project$Utils$Form$validationErrors, 2, form))
						]),
					$author$project$Ui$Form$Accessible$textInput(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$number,
								$author$project$Ui$Form$Input$value(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									A2($elm$core$Maybe$map, $elm$core$String$fromInt, fields.Dz))),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Components$Charge$Form$FormUpdated, $author$project$Components$Charge$Form$Quantity)),
								$author$project$Ui$Form$Input$disabled(readOnly_),
								$author$project$Ui$Form$Input$test('charge-quantity')
							]))),
					function () {
					if (isTimeBased) {
						var uomOptions = A2(
							$elm$core$List$map,
							function (uom_) {
								return A3(
									$author$project$Ui$Form$Select$option,
									_List_Nil,
									$elm$core$Maybe$Just(
										$author$project$Api$Provider$Uom$Shared$code(uom_)),
									$author$project$Api$Provider$Uom$Shared$name(uom_));
							},
							$author$project$Api$Provider$Uom$list(
								function (d) {
									return _Utils_update(
										d,
										{
											Kg: $elm$core$Maybe$Just('time')
										});
								}));
						return A3(
							$author$project$Ui$Form$Accessible$input,
							'Time unit of measure',
							_List_fromArray(
								[
									$author$project$Ui$Form$Accessible$inputSpan(4)
								]),
							A2(
								$author$project$Ui$Form$Accessible$select,
								_List_fromArray(
									[
										$author$project$Ui$Form$Select$value(
										A2($elm$core$Maybe$map, $author$project$Api$Provider$Uom$Shared$code, fields.DA)),
										$author$project$Ui$Form$Select$onChange(
										A2($elm$core$Basics$composeL, $author$project$Components$Charge$Form$FormUpdated, $author$project$Components$Charge$Form$QuantityUom)),
										$author$project$Ui$Form$Select$disabled(readOnly_)
									]),
								uomOptions));
					} else {
						return $author$project$Ui$Form$Accessible$none;
					}
				}()
				]));
	});
var $author$project$Ui$Form$Accessible$DateInput = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $author$project$Ui$Form$Accessible$dateInput = $author$project$Ui$Form$Accessible$DateInput;
var $author$project$Components$DateInput$Test = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$DateInput$test = function (dataTest) {
	return $author$project$Components$DateInput$Test(dataTest);
};
var $author$project$Components$Charge$Form$viewServiceDate = F4(
	function (fields, readOnly_, form, isTimeBased) {
		return A3(
			$author$project$Ui$Form$Accessible$group,
			isTimeBased ? 'Dates' : 'Date',
			_List_fromArray(
				[
					$author$project$Ui$Form$Accessible$labelSpanSm(4),
					$author$project$Ui$Form$Accessible$required(true)
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Form$Accessible$input,
					'Start Date',
					_List_fromArray(
						[
							$author$project$Ui$Form$Accessible$inputSpan(6),
							$author$project$Ui$Form$Accessible$errors(
							A2($author$project$Utils$Form$validationErrors, 4, form))
						]),
					A3(
						$author$project$Ui$Form$Accessible$dateInput,
						$author$project$Components$Charge$Form$StartDateInputMsg(fields.lx),
						_List_fromArray(
							[
								$author$project$Components$DateInput$value(fields.ab7),
								$author$project$Components$DateInput$disabled(readOnly_),
								$author$project$Components$DateInput$test('charge-date')
							]),
						fields.lx)),
					isTimeBased ? A3(
					$author$project$Ui$Form$Accessible$input,
					'End Date',
					_List_fromArray(
						[
							$author$project$Ui$Form$Accessible$inputSpan(6)
						]),
					A3(
						$author$project$Ui$Form$Accessible$dateInput,
						$author$project$Components$Charge$Form$EndDateInputMsg(fields.sd),
						_List_fromArray(
							[
								$author$project$Components$DateInput$value(fields.sb),
								$author$project$Components$DateInput$disabled(readOnly_)
							]),
						fields.sd)) : $author$project$Ui$Form$Accessible$none
				]));
	});
var $author$project$Components$ChargeItemTaxableWarning$view = F2(
	function (selectedPayer, taxable) {
		var sponsorPayer = selectedPayer === 1;
		var showWarning = sponsorPayer && taxable;
		return showWarning ? A2(
			$author$project$Ui$Alert$danger,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Taxed charge items cannot be billed on a sponsor\'s invoice. Please contact support at support@hint.com to learn more.')
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Components$Charge$Form$viewTaxableWarning = function (fields) {
	var _v0 = fields.mL;
	if (!_v0.$) {
		var chargeItem = _v0.a;
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanSm(8),
								$author$project$Ui$Grid$offsetSm(4)
							]),
						_List_fromArray(
							[
								A2($author$project$Components$ChargeItemTaxableWarning$view, fields.Y6, chargeItem.acZ)
							]))
					]))
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Charge$Form$discountDetails = F3(
	function (fields, readyOnly, preview) {
		var discountRemoved = fields.QE && (!$author$project$Api$Provider$Charge$Calculate$discountInCents(preview));
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					function () {
					if (!(!$author$project$Api$Provider$Charge$Calculate$discountInCents(preview))) {
						var totalWithoutLabel = ($author$project$Api$Provider$Charge$Calculate$prepaidAllocatedQuantity(preview) > 0) ? 'Total without package: ' : 'Total without membership: ';
						return A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(totalWithoutLabel),
									$author$project$Components$Invoice$ChargeDiscount$view(preview)
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					discountRemoved ? A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Membership rule was removed')
						])) : $author$project$Utils$Html$empty,
					(discountRemoved && ($author$project$Utils$Maybe$toBool(fields.mL) && (!readyOnly))) ? A3(
					$author$project$Ui$Button$view,
					{mm: 'Revert to original discount'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$onClick(
							$author$project$Components$Charge$Form$FormUpdated(
								$author$project$Components$Charge$Form$DiscountOverridden(false)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Revert to original')
						])) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$Charge$Form$viewTotal = F3(
	function (fields, readyOnly, model) {
		var labelOptions = _List_fromArray(
			[
				$author$project$Ui$Form$Accessible$labelSpanSm(4)
			]);
		var inputOptions = _List_fromArray(
			[
				$author$project$Ui$Form$Accessible$inputSpanSm(8)
			]);
		return A4(
			$author$project$Ui$Form$Accessible$single,
			'Total',
			labelOptions,
			inputOptions,
			$author$project$Ui$Form$Accessible$static(
				function () {
					var _v0 = model.akd;
					switch (_v0.$) {
						case 3:
							var preview = _v0.a;
							var total = $author$project$Utils$Currency$fromInt(
								$author$project$Api$Provider$Charge$Calculate$subtotalInCents(preview));
							return ((!$author$project$Api$Provider$Charge$Calculate$discountInCents(preview)) && (!fields.QE)) ? _List_fromArray(
								[
									$elm$html$Html$text(total)
								]) : _List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$title,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(total)
												])),
											A3($author$project$Components$Charge$Form$discountDetails, fields, readyOnly, preview)
										]))
								]);
						case 1:
							return _List_fromArray(
								[
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$spanFromText('$100.00')
										]))
								]);
						default:
							return _List_fromArray(
								[
									$elm$html$Html$text('N/A')
								]);
					}
				}()));
	});
var $author$project$Components$Charge$Form$view = function (_v0) {
	var model = _v0;
	if (model.h8) {
		var routingFields = A2(
			$elm$core$List$map,
			$elm$html$Html$map($author$project$Components$Charge$Form$RoutingFieldsMsg),
			A2($author$project$Components$Charge$Form$RoutingFields$view, model.pK, model._6));
		var meta = A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$Charge$One$meta,
			$author$project$Api$Data$toMaybe(model.afx));
		var fields = $author$project$Utils$Form$fields(model.f);
		var isTimeBased = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Uom$Shared$isTimeBased, fields.DA));
		var taxWarning = $author$project$Components$Charge$Form$viewTaxableWarning(fields);
		var baseFields = _List_fromArray(
			[
				A3($author$project$Components$Charge$Form$viewPatientInput, model.oY, model._6 || model.tG, model.f),
				A3($author$project$Components$Charge$Form$viewChargeItemInput, model.cq, model._6, model.f),
				A4($author$project$Components$Charge$Form$viewQuantityInput, fields, model._6, model.f, isTimeBased),
				A6($author$project$Components$Charge$Form$viewPriceInput, fields, model._6, model.f, meta, model.akd, isTimeBased),
				A3($author$project$Components$Charge$Form$viewTotal, fields, model._6, model),
				(!model._6) ? $author$project$Components$Charge$Form$viewAdditionalDetails(model.hD) : $author$project$Utils$Html$empty
			]);
		var additionalFields = model.hD ? _List_fromArray(
			[
				$author$project$Components$Charge$Form$viewCategory(model.f),
				$author$project$Components$Charge$Form$viewDescription(fields),
				A4($author$project$Components$Charge$Form$viewServiceDate, fields, model._6, model.f, isTimeBased),
				$author$project$Components$Charge$Form$viewProvider(model.hk),
				$author$project$Components$Charge$Form$viewLocation(model.os)
			]) : (model._6 ? _List_fromArray(
			[
				A4($author$project$Components$Charge$Form$viewServiceDate, fields, model._6, model.f, isTimeBased)
			]) : _List_Nil);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_Utils_ap(
				baseFields,
				_Utils_ap(
					additionalFields,
					_Utils_ap(routingFields, taxWarning))));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Charges$New$isPaid = function (invoice) {
	return invoice.alH === 'paid';
};
var $author$project$Api$Provider$CustomerInvoice$Shared$hasGoodPaymentSource = function (_v0) {
	var record = _v0;
	return record.Ta;
};
var $author$project$Api$Provider$CustomerInvoice$One$hasGoodPaymentSource = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CustomerInvoice$Shared$hasGoodPaymentSource(shared);
};
var $author$project$Pages$Charges$New$issueLabel = F2(
	function (invoice, actionText) {
		return $author$project$Pages$Charges$New$isDraft(invoice) ? (' Issue & ' + actionText) : (' ' + actionText);
	});
var $author$project$Pages$Charges$New$viewPayAction = function (invoice) {
	var canCreatePayment = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$CustomerInvoice$One$hasGoodPaymentSource,
			$author$project$Api$Data$toMaybe(invoice.k9)));
	return canCreatePayment ? _List_fromArray(
		[
			A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onSelect(
					A2($author$project$Pages$Charges$New$Pay, invoice, false))
				]),
			A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Icon$bolt(_List_Nil),
						$elm$html$Html$text(
						A2($author$project$Pages$Charges$New$issueLabel, invoice, 'Pay'))
					])))
		]) : _List_Nil;
};
var $author$project$Pages$Charges$New$viewRecordPaymentAction = function (invoice) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onSelect(
					A2($author$project$Pages$Charges$New$Pay, invoice, true))
				]),
			A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Icon$check(_List_Nil),
						$elm$html$Html$text(
						A2($author$project$Pages$Charges$New$issueLabel, invoice, 'Record Payment'))
					])))
		]);
};
var $author$project$Api$Provider$CustomerInvoice$Shared$isPaymentScheduled = function (_v0) {
	var record = _v0;
	return record.U3;
};
var $author$project$Api$Provider$CustomerInvoice$One$isPaymentScheduled = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CustomerInvoice$Shared$isPaymentScheduled(shared);
};
var $author$project$Pages$Charges$New$viewSchedulePaymentAction = function (invoice) {
	var hasScheduledPayment = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$CustomerInvoice$One$isPaymentScheduled,
			$author$project$Api$Data$toMaybe(invoice.k9)));
	return (!hasScheduledPayment) ? _List_fromArray(
		[
			A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Pages$Charges$New$SchedulePayment(invoice))
				]),
			A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Icon$calendar(_List_Nil),
						$elm$html$Html$text(
						A2($author$project$Pages$Charges$New$issueLabel, invoice, 'Schedule Payment'))
					])))
		]) : _List_Nil;
};
var $author$project$Pages$Charges$New$viewSendEmailAction = function (invoice) {
	var _v0 = invoice.YD;
	if (!_v0.$) {
		var owner = _v0.a;
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Dropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$Dropdown$onSelect(
						A2(
							$author$project$Pages$Charges$New$Email,
							$author$project$Api$Common$Payable$Owner$Min$id(owner),
							invoice))
					]),
				A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Icon$send(_List_Nil),
							$elm$html$Html$text(
							A2($author$project$Pages$Charges$New$issueLabel, invoice, 'Send email'))
						])))
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Pages$Charges$New$viewInvoiceActions = function (invoice) {
	var _v0 = invoice.amg;
	switch (_v0) {
		case 0:
			return $author$project$Utils$Html$empty;
		case 1:
			var actions = _Utils_ap(
				$author$project$Pages$Charges$New$viewPayAction(invoice),
				_Utils_ap(
					$author$project$Pages$Charges$New$viewRecordPaymentAction(invoice),
					_Utils_ap(
						$author$project$Pages$Charges$New$viewSchedulePaymentAction(invoice),
						$author$project$Pages$Charges$New$viewSendEmailAction(invoice))));
			return ($author$project$Pages$Charges$New$isPaid(invoice) || _Utils_eq(actions, _List_Nil)) ? $author$project$Utils$Html$empty : A4(
				$author$project$Ui$Dropdown$view,
				_List_fromArray(
					[
						$author$project$Ui$Dropdown$disabled(
						_Utils_eq(invoice.k9, $author$project$Api$Data$Loading))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Invoice Actions')
					]),
				actions,
				invoice.no);
		default:
			return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Charges$New$ToggleChargeDetails = function (a) {
	return {$: 6, a: a};
};
var $elm_community$maybe_extra$Maybe$Extra$join = function (mx) {
	if (!mx.$) {
		var x = mx.a;
		return x;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$Charge$Shared$totalInCents = function (_v0) {
	var record = _v0;
	return record.adp;
};
var $author$project$Api$Provider$Charge$One$totalInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Charge$Shared$totalInCents(shared);
};
var $author$project$Components$Charge$Form$visible = function (_v0) {
	var model = _v0;
	return model.h8;
};
var $author$project$Pages$Charges$New$viewCharge = F2(
	function (index, createdCharge) {
		var charge = $author$project$Api$Data$toMaybe(
			$author$project$Components$Charge$Form$charge(createdCharge));
		var chargeName = A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm_community$maybe_extra$Maybe$Extra$join(
				A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$One$name, charge)));
		var patientName = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$name,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Maybe$Nothing,
					A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$One$patient, charge))));
		var totalInCents = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$author$project$Utils$Currency$fromInt,
				A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$One$totalInCents, charge)));
		return A2(
			$author$project$Ui$ListGroup$item,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_fromArray(
								[$author$project$Ui$Typography$primary]),
							_List_fromArray(
								[
									$elm$html$Html$text(totalInCents + (' — ' + (chargeName + (' for ' + patientName))))
								])),
							function () {
							var _v0 = $author$project$Components$Charge$Form$visible(createdCharge) ? _Utils_Tuple2(
								'Hide charge details ',
								$author$project$Ui$Icon$chevron(
									_List_fromArray(
										[$author$project$Ui$Icon$rotate180]))) : _Utils_Tuple2(
								'See charge details ',
								$author$project$Ui$Icon$chevronDown(_List_Nil));
							var buttonLabel = _v0.a;
							var icon = _v0.b;
							return A3(
								$author$project$Ui$Button$view,
								{mm: buttonLabel},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$sm,
										$author$project$Ui$Button$onClick(
										$author$project$Pages$Charges$New$ToggleChargeDetails(index))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(buttonLabel),
										icon
									]));
						}()
						])),
					A2(
					$elm$html$Html$map,
					$author$project$Pages$Charges$New$ChargeFormMsg,
					$author$project$Components$Charge$Form$view(createdCharge))
				]));
	});
var $author$project$Pages$Charges$New$viewInvoiceCharges = F2(
	function (invoice, createdChargesWithIndex) {
		var createdChargesForInvoiceWithIndex = A2(
			$elm$core$List$filter,
			function (_v1) {
				var createdCharge = _v1.b;
				return _Utils_eq(
					A2(
						$elm$core$Maybe$map,
						$author$project$Api$Common$Payable$Invoice$MinWithOwner$id,
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Maybe$Nothing,
							A2(
								$elm$core$Maybe$map,
								$author$project$Api$Provider$Charge$One$invoice,
								$author$project$Api$Data$toMaybe(
									$author$project$Components$Charge$Form$charge(createdCharge))))),
					$elm$core$Maybe$Just(invoice.ahP));
			},
			createdChargesWithIndex);
		return A2(
			$elm$core$List$map,
			function (_v0) {
				var index = _v0.a;
				var createdCharge = _v0.b;
				return A2($author$project$Pages$Charges$New$viewCharge, index, createdCharge);
			},
			createdChargesForInvoiceWithIndex);
	});
var $author$project$Pages$Charges$New$viewInvoiceLink = F4(
	function (invoiceId, invoiceType, invoiceNumber, ownerId) {
		var invoiceRoute = function () {
			switch (invoiceType) {
				case 0:
					return $elm$core$Maybe$Just(
						$author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String(
							{fZ: ownerId, ahP: invoiceId}));
				case 1:
					return $elm$core$Maybe$Just(
						$author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top(
							{Us: invoiceId, YZ: ownerId}));
				default:
					return $elm$core$Maybe$Nothing;
			}
		}();
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Utils$Html$empty,
			A2(
				$elm$core$Maybe$map,
				function (partialLink) {
					return A2(
						partialLink,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(invoiceNumber)
							]));
				},
				A2($elm$core$Maybe$map, $author$project$Ui$Link$route, invoiceRoute)));
	});
var $author$project$Pages$Charges$New$viewOwnerLink = F3(
	function (invoiceType, ownerId, ownerName) {
		var ownerRoute = function () {
			switch (invoiceType) {
				case 0:
					return $elm$core$Maybe$Just(
						$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top(
							{fZ: ownerId}));
				case 1:
					return $elm$core$Maybe$Just(
						$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
							{YZ: ownerId}));
				default:
					return $elm$core$Maybe$Nothing;
			}
		}();
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Utils$Html$empty,
			A2(
				$elm$core$Maybe$map,
				function (partialLink) {
					return A2(
						partialLink,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(ownerName)
							]));
				},
				A2($elm$core$Maybe$map, $author$project$Ui$Link$route, ownerRoute)));
	});
var $author$project$Pages$Charges$New$viewInvoiceDetails = function (invoice) {
	var ownerName = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Maybe$map, $author$project$Api$Common$Payable$Owner$Min$name, invoice.YD));
	var ownerId = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Maybe$map, $author$project$Api$Common$Payable$Owner$Min$id, invoice.YD));
	var invoiceType = invoice.amg;
	var invoiceNumber = A2(
		$elm$core$String$append,
		'#',
		$elm$core$String$fromInt(invoice.Uu));
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Invoice '),
				A4($author$project$Pages$Charges$New$viewInvoiceLink, invoice.ahP, invoiceType, invoiceNumber, ownerId),
				$elm$html$Html$text(' paid for by'),
				A3($author$project$Pages$Charges$New$viewOwnerLink, invoiceType, ownerId, ownerName),
				A2($author$project$Ui$Badge$fromString, _List_Nil, invoice.alH)
			]));
};
var $author$project$Pages$Charges$New$viewInvoice = F2(
	function (createdCharges, invoice) {
		var createdChargesWithIndex = A2(
			$elm$core$List$indexedMap,
			F2(
				function (index, createdCharge) {
					return _Utils_Tuple2(index, createdCharge);
				}),
			createdCharges);
		return A2(
			$author$project$Ui$ListGroup$view,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Ui$ListGroup$item,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
							_List_fromArray(
								[
									$author$project$Pages$Charges$New$viewInvoiceDetails(invoice),
									$author$project$Pages$Charges$New$viewInvoiceActions(invoice)
								]))
						])),
				A2($author$project$Pages$Charges$New$viewInvoiceCharges, invoice, createdChargesWithIndex)));
	});
var $author$project$Pages$Charges$New$viewCreatedChargesGroupedByInvoice = function (model) {
	return $elm$core$List$isEmpty(model.sP) ? $author$project$Utils$Html$empty : A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$textLeft, $author$project$Ui$Element$mt2]),
		A2(
			$elm$core$List$map,
			$author$project$Pages$Charges$New$viewInvoice(model.d3),
			model.sP));
};
var $author$project$Pages$Charges$New$viewPanelBody = function (model) {
	return A2(
		$elm$core$List$append,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Pages$Charges$New$ChargeFormMsg,
						$author$project$Components$Charge$Form$view(model.f))
					]))
			]),
		(model.lk.ahq.agL && (!$elm$core$List$isEmpty(model.sP))) ? _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$body,
				_List_fromArray(
					[$author$project$Ui$Element$bgPrimary50]),
				_List_fromArray(
					[
						$author$project$Pages$Charges$New$viewCreatedChargesGroupedByInvoice(model)
					]))
			]) : _List_Nil);
};
var $author$project$Pages$Charges$New$SaveAndAddAnother = {$: 1};
var $author$project$Components$Charge$Form$loading = function (_v0) {
	var model = _v0;
	return _Utils_eq(model.akd, $author$project$Api$Data$Loading);
};
var $author$project$Components$Charge$Form$saving = function (_v0) {
	var model = _v0;
	return _Utils_eq(model.afx, $author$project$Api$Data$Loading);
};
var $author$project$Pages$Charges$New$viewPanelFooter = function (model) {
	var formSaving = $author$project$Components$Charge$Form$saving(model.f);
	var formLoading = $author$project$Components$Charge$Form$loading(model.f);
	var _v0 = model.lk.ahq.agL ? _Utils_Tuple2('Add Another', 'Create') : _Utils_Tuple2('Save & Add Another', 'Save');
	var saveAndAddButtonLabel = _v0.a;
	var saveButtonLabel = _v0.b;
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Panel$footer,
			_List_fromArray(
				[$author$project$Ui$Element$flexCol]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Patients__Top,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{mm: saveAndAddButtonLabel},
							_List_fromArray(
								[
									$author$project$Ui$Button$styled(0),
									$author$project$Ui$Button$disabled(formLoading),
									$author$project$Ui$Button$loading(formSaving),
									$author$project$Ui$Button$onClick($author$project$Pages$Charges$New$SaveAndAddAnother)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(saveAndAddButtonLabel)
								])),
							A3(
							$author$project$Ui$Button$view,
							{mm: saveButtonLabel},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$submit,
									$author$project$Ui$Button$disabled(formLoading),
									$author$project$Ui$Button$loading(formSaving)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(saveButtonLabel)
								]))
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							model.lk.ahq.agL ? $author$project$Utils$Html$empty : $author$project$Pages$Charges$New$viewCreatedChargesGroupedByInvoice(model)
						]))
				]))
		]);
};
var $author$project$Pages$Charges$New$Close = {$: 3};
var $author$project$Pages$Charges$New$viewPanelHeading = _List_fromArray(
	[
		A2(
		$author$project$Ui$Panel$heading,
		_List_fromArray(
			[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
		_List_fromArray(
			[
				$author$project$Ui$Panel$title(
				_List_fromArray(
					[
						$elm$html$Html$text('Create New Charges')
					])),
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Close and go back'},
				_List_fromArray(
					[
						$author$project$Ui$Button$close,
						$author$project$Ui$Button$onClick($author$project$Pages$Charges$New$Close)
					]),
				_List_Nil)
			]))
	]);
var $author$project$Pages$Charges$New$viewBody = function (model) {
	return $author$project$Components$Charge$Form$formReady(model.f) ? A2(
		$author$project$Ui$Form$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$noValidate(true),
				$author$project$Ui$Form$autocomplete(false),
				$author$project$Ui$Form$onSubmit($author$project$Pages$Charges$New$Save)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				$elm$core$List$concat(
					_List_fromArray(
						[
							$author$project$Pages$Charges$New$viewPanelHeading,
							$author$project$Pages$Charges$New$viewPanelBody(model),
							$author$project$Pages$Charges$New$viewPanelFooter(model)
						])))
			])) : A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$mt4]),
		$author$project$Components$LoadingPage$view);
};
var $author$project$Pages$Charges$New$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Charges$New$CustomerEmailModalMsg,
				$author$project$Components$CustomerEmailModal$modal(model.m5)),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Charges$New$SchedulePaymentModalMsg,
				$author$project$Components$CustomerSchedulePaymentModal$view(model.hw)),
				function () {
				var _v0 = model.m$;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var createPaymentModal = _v1.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$Charges$New$CreatePaymentModalMsg,
						$author$project$Components$Invoice$CreatePaymentModal$view(createPaymentModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				$author$project$Pages$Charges$New$viewBody(model)
			]),
		ac9: 'Charges'
	};
};
var $author$project$Pages$Charges$New$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Charges$New$init, aiq: $author$project$Pages$Charges$New$load, k8: $author$project$Pages$Charges$New$save, alO: $author$project$Pages$Charges$New$subscriptions, adT: $author$project$Pages$Charges$New$update, amo: $author$project$Pages$Charges$New$view});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$BrokerId_String$Top$BrokerFormMsg = $elm$core$Basics$identity;
var $author$project$Components$Broker$Form$GotItem = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Broker$Form$Model = $elm$core$Basics$identity;
var $author$project$Components$Broker$Form$formFieldsInit = {Bq: '', Cg: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$Broker$brokerPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$Broker$brokersPath);
};
var $author$project$Api$Provider$Broker$One$Broker = $elm$core$Basics$identity;
var $author$project$Api$Provider$Broker$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Broker$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Broker$retrieve = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Broker$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Broker$brokerPath(id_)));
	});
var $author$project$Components$Broker$Form$init = F4(
	function (apiClient, session, brokerAccountId, id) {
		var _v0 = function () {
			if (!id.$) {
				var id_ = id.a;
				return _Utils_Tuple2(
					$elm$core$Maybe$Nothing,
					A3($author$project$Api$Provider$Broker$retrieve, apiClient, id_, $author$project$Components$Broker$Form$GotItem));
			} else {
				return _Utils_Tuple2(
					$elm$core$Maybe$Just($author$project$Components$Broker$Form$formFieldsInit),
					$elm$core$Platform$Cmd$none);
			}
		}();
		var formFields = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			{
				cm: brokerAccountId,
				SD: A2($elm$core$Maybe$map, $author$project$Utils$Form$init, formFields),
				ahP: id,
				k9: $author$project$Api$Data$NotAsked,
				aa4: session
			},
			cmd);
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$BrokerId_String$Top$init = F4(
	function (session, _v0, _v1, _v2) {
		var apiClient = _v1.Gv;
		var params = _v2.YL;
		var _v3 = A4(
			$author$project$Components$Broker$Form$init,
			apiClient,
			session,
			params.cm,
			$elm$core$Maybe$Just(params.GN));
		var form = _v3.a;
		var cmd = _v3.b;
		return _Utils_Tuple2(
			{Gv: apiClient, SD: form},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$BrokerId_String$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$BrokerId_String$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$BrokerId_String$Top$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Api$Provider$Broker$One$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Broker$Shared$name(shared);
};
var $author$project$Components$Broker$Form$formFieldsFromItem = function (broker) {
	return {
		Bq: $author$project$Api$Provider$Broker$One$name(broker),
		Cg: $elm$core$Maybe$Just(
			$author$project$Api$Provider$Broker$One$name(broker))
	};
};
var $author$project$Components$Broker$Form$formFieldsUpdate = F2(
	function (field, fields) {
		var string = field;
		return _Utils_update(
			fields,
			{Bq: string});
	});
var $author$project$Components$Broker$Form$NameValidation = 0;
var $author$project$Components$Broker$Form$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.Bq;
			},
			_Utils_Tuple2(0, 'Please enter a name.'))
		]));
var $author$project$Components$Broker$Form$Created = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Broker$create = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'broker',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(fields.Bq)),
								_Utils_Tuple2(
								'broker_account',
								$author$project$Utils$Encode$association(fields.xG))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Broker$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Broker$brokersPath)));
	});
var $author$project$Components$Broker$Form$createItem = F3(
	function (apiClient, brokerAccountId, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var apiFields = {xG: brokerAccountId, Bq: fields.Bq};
		return A3($author$project$Api$Provider$Broker$create, apiClient, apiFields, $author$project$Components$Broker$Form$Created);
	});
var $author$project$Components$Broker$Form$Updated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Broker$update = F4(
	function (apiClient, id_, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'broker',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(fields.Bq))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Broker$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Broker$brokerPath(id_))));
	});
var $author$project$Components$Broker$Form$updateItem = F3(
	function (apiClient, id, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var apiFields = {Bq: fields.Bq};
		return A4($author$project$Api$Provider$Broker$update, apiClient, id, apiFields, $author$project$Components$Broker$Form$Updated);
	});
var $author$project$Components$Broker$Form$saveItem = F4(
	function (maybeId, apiClient, brokerAccountId, formFields) {
		if (!maybeId.$) {
			var id_ = maybeId.a;
			return A3($author$project$Components$Broker$Form$updateItem, apiClient, id_, formFields);
		} else {
			return A3($author$project$Components$Broker$Form$createItem, apiClient, brokerAccountId, formFields);
		}
	});
var $author$project$Components$Broker$Form$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var broker = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								SD: $elm$core$Maybe$Just(
									$author$project$Utils$Form$init(
										$author$project$Components$Broker$Form$formFieldsFromItem(broker)))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$reportDecodeError(response));
				}
			case 1:
				var field = msg.a;
				var _v3 = model.SD;
				if (!_v3.$) {
					var form = _v3.a;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Broker$Form$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								SD: $elm$core$Maybe$Just(newForm)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				var _v4 = model.SD;
				if (!_v4.$) {
					var form = _v4.a;
					var _v5 = A2($author$project$Utils$Form$validate, $author$project$Components$Broker$Form$formFieldsValidator, form);
					if (!_v5.$) {
						var _v6 = _v5.a;
						var newForm = _v6.a;
						var validFormFields = _v6.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									SD: $elm$core$Maybe$Just(newForm),
									k9: $author$project$Api$Data$Loading
								}),
							A4($author$project$Components$Broker$Form$saveItem, model.ahP, apiClient, model.cm, validFormFields),
							_List_Nil);
					} else {
						var newForm = _v5.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									SD: $elm$core$Maybe$Just(newForm),
									k9: $author$project$Api$Data$NotAsked
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var response = msg.a;
				var _v7 = model.SD;
				if (!_v7.$) {
					if (response.$ === 3) {
						var broker = response.a;
						return _Utils_Tuple3(
							model,
							A2(
								$author$project$Utils$Route$navigate,
								$elm$core$Dict$empty,
								$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top(
									{cm: model.cm})),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									'Successfully created ' + $author$project$Api$Provider$Broker$One$name(broker))
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{k9: response}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var response = msg.a;
				var _v9 = model.SD;
				if (!_v9.$) {
					if (response.$ === 3) {
						var broker = response.a;
						return _Utils_Tuple3(
							model,
							A2(
								$author$project$Utils$Route$navigate,
								$elm$core$Dict$empty,
								$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top(
									{cm: model.cm})),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Provider$Broker$One$name(broker) + ' was successfully updated.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{k9: response}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$BrokerId_String$Top$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Broker$Form$update, model.Gv, subMsg, model.SD);
		var newModelForm = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{SD: newModelForm}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Components$Broker$Form$Save = {$: 2};
var $author$project$Components$Broker$Form$FormUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Broker$Form$Name = $elm$core$Basics$identity;
var $author$project$Components$Broker$Form$viewForm = function (form) {
	var fields = $author$project$Utils$Form$fields(form);
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(4),
					$author$project$Ui$Form$Group$required(true),
					$author$project$Ui$Form$Group$label('Name')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$value(fields.Bq),
							$author$project$Ui$Form$Input$placeholder('e.g. John Doe'),
							$author$project$Ui$Form$Input$autofocus(true),
							$author$project$Ui$Form$Input$onInput(
							A2($elm$core$Basics$composeL, $author$project$Components$Broker$Form$FormUpdated, $elm$core$Basics$identity)),
							$author$project$Ui$Form$Input$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
							$author$project$Ui$Form$Input$errors(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						]))
				]))
		]);
};
var $author$project$Components$Broker$Form$view = function (_v0) {
	var model = _v0;
	return A2(
		$author$project$Ui$Form$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$noValidate(true),
				$author$project$Ui$Form$autocomplete(false),
				$author$project$Ui$Form$onSubmit($author$project$Components$Broker$Form$Save)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$elm$core$Basics$never,
								A2(
									$author$project$Ui$Breadcrumb$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Breadcrumb$item,
											_List_Nil,
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top(
														{cm: model.cm}),
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('All Brokers')
														]))
												])),
											A2(
											$author$project$Ui$Breadcrumb$item,
											_List_fromArray(
												[
													$author$project$Ui$Breadcrumb$active(true)
												]),
											_List_fromArray(
												[
													function () {
													var _v1 = model.SD;
													if (!_v1.$) {
														var form = _v1.a;
														var _v2 = $author$project$Utils$Form$fields(form);
														var originalName = _v2.Cg;
														return $elm$html$Html$text(
															A2($elm$core$Maybe$withDefault, 'Add New Broker', originalName));
													} else {
														return $author$project$Ui$Spinner$view(
															_List_fromArray(
																[$author$project$Ui$Spinner$extraSmall]));
													}
												}()
												]))
										]))),
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										function () {
										var _v3 = model.ahP;
										if (!_v3.$) {
											return $elm$html$Html$text('Edit broker');
										} else {
											return $elm$html$Html$text('Add new broker');
										}
									}()
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						function () {
							var _v4 = model.SD;
							if (!_v4.$) {
								var form = _v4.a;
								return $author$project$Components$Broker$Form$viewForm(form);
							} else {
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$textCenter]),
										_List_fromArray(
											[
												$author$project$Ui$Spinner$view(_List_Nil)
											]))
									]);
							}
						}()),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$itemsCenter]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top(
											{cm: model.cm}),
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Back')
											])),
										function () {
										var verb = function () {
											var _v5 = model.ahP;
											if (!_v5.$) {
												return 'Update';
											} else {
												return 'Create';
											}
										}();
										return A3(
											$author$project$Ui$Button$view,
											{mm: verb + ' broker'},
											_List_fromArray(
												[
													$author$project$Ui$Button$primary,
													$author$project$Ui$Button$submit,
													$author$project$Ui$Button$loading(
													_Utils_eq(model.k9, $author$project$Api$Data$Loading))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(verb)
												]));
									}()
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$BrokerId_String$Top$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Broker$Form$view(model.SD))
			]),
		ac9: 'Commissions | Brokers'
	};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$BrokerId_String$Top$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$BrokerId_String$Top$init, aiq: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$BrokerId_String$Top$load, k8: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$BrokerId_String$Top$save, alO: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$BrokerId_String$Top$subscriptions, adT: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$BrokerId_String$Top$update, amo: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$BrokerId_String$Top$view});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$GotBrokers = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$fetchBrokers = function (model) {
	return A3(
		$author$project$Api$Provider$Broker$list,
		model.Gv,
		function (d) {
			return _Utils_update(
				d,
				{
					xG: $elm$core$Maybe$Just(model.cm),
					TU: $elm$core$Maybe$Just(true),
					ajJ: model.ajJ,
					alA: model.alA
				});
		},
		$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$GotBrokers);
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$init = F4(
	function (session, _v0, _v1, _v2) {
		var apiClient = _v1.Gv;
		var query = _v2.DE;
		var params = _v2.YL;
		var model = {
			Gv: apiClient,
			cm: params.cm,
			MS: $author$project$Api$Data$Loading,
			ajJ: $author$project$Api$Pagination$initFromQuery(query),
			k0: $elm$core$Maybe$Nothing,
			aa4: session,
			alA: $author$project$Api$Sort$initFromQuery(query)
		};
		return _Utils_Tuple2(
			model,
			$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$fetchBrokers(model));
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$RestartModalMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Broker$RestartModal$Close = {$: 1};
var $author$project$Components$Broker$RestartModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Broker$RestartModal$Close);
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$RestartModalMsg,
		A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Platform$Sub$none,
			A2($elm$core$Maybe$map, $author$project$Components$Broker$RestartModal$subscriptions, model.k0)));
};
var $author$project$Components$Broker$RestartModal$init = F2(
	function (session, broker) {
		return {xF: broker, aa4: session, qP: $author$project$Api$Data$NotAsked};
	});
var $author$project$Components$Broker$RestartModal$BrokerRestarted = 2;
var $author$project$Components$Broker$RestartModal$Closed = 1;
var $author$project$Components$Broker$RestartModal$None = 0;
var $author$project$Components$Broker$RestartModal$Restarted = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$Broker$restart = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Broker$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['restart']),
					$author$project$Api$Provider$Broker$brokerPath(id_))));
	});
var $author$project$Components$Broker$RestartModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 1:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: 1, aiO: model, aR: _List_Nil};
			case 0:
				return {
					GZ: A3(
						$author$project$Api$Provider$Broker$restart,
						apiClient,
						$author$project$Api$Provider$Broker$All$id(model.xF),
						$author$project$Components$Broker$RestartModal$Restarted),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{qP: $author$project$Api$Data$Loading}),
					aR: _List_Nil
				};
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 2,
						aiO: model,
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Broker successfully restarted')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{qP: $author$project$Api$Data$NotAsked}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
		}
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$updateUrl = function (model) {
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString(
					$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top(
						{cm: model.cm}))
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.ajJ),
				$author$project$Api$Sort$toQuery(model.alA))));
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								MS: response,
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{MS: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$fetchBrokers(newModel),
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$updateUrl(newModel)
							])),
					_List_Nil);
			case 2:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						alA: A2($author$project$Api$Sort$update, columnId, model.alA)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$fetchBrokers(newModel),
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$updateUrl(newModel)
							])),
					_List_Nil);
			case 3:
				var broker = msg.a;
				var restartModal = A2($author$project$Components$Broker$RestartModal$init, model.aa4, broker);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							k0: $elm$core$Maybe$Just(restartModal)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v2 = model.k0;
				if (!_v2.$) {
					var restartModal = _v2.a;
					var restartModalResult = A3($author$project$Components$Broker$RestartModal$update, model.Gv, subMsg, restartModal);
					var _v3 = function () {
						var _v4 = restartModalResult.agZ;
						switch (_v4) {
							case 0:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(restartModalResult.aiO),
									model.MS,
									$elm$core$Platform$Cmd$none);
							case 1:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.MS, $elm$core$Platform$Cmd$none);
							default:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Api$Data$Loading,
									$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$fetchBrokers(model));
						}
					}();
					var restartModal_ = _v3.a;
					var brokers = _v3.b;
					var cmd = _v3.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{MS: brokers, k0: restartModal_}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$RestartModalMsg, restartModalResult.GZ),
									cmd
								])),
						restartModalResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$PaginationMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Broker$RestartModal$Restart = {$: 0};
var $author$project$Components$Broker$RestartModal$view = function (model) {
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Broker$RestartModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Restart Broker')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$helpBlock]),
						_List_fromArray(
							[
								$elm$html$Html$text('Restarting this broker will not re-activate any old deals they may have been associated with '),
								$elm$html$Html$text('but will allow them to be used in new deals.')
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Broker$RestartModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Restart broker'},
						_List_fromArray(
							[
								$author$project$Ui$Button$danger,
								$author$project$Ui$Button$loading(
								_Utils_eq(model.qP, $author$project$Api$Data$Loading)),
								$author$project$Ui$Button$onClick($author$project$Components$Broker$RestartModal$Restart)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Restart')
							]))
					]))
			]));
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$SortTable = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'name', false, 'Name')
	]);
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$Restart = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Broker$Shared$endedOn = function (_v0) {
	var record = _v0;
	return record.Rw;
};
var $author$project$Api$Provider$Broker$All$endedOn = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Broker$Shared$endedOn(shared);
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$viewBroker = function (broker) {
	return A2(
		$author$project$Ui$Table$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(9)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$bold]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Api$Provider$Broker$All$name(broker)),
								function () {
								var _v0 = $author$project$Api$Provider$Broker$All$endedOn(broker);
								if (!_v0.$) {
									var endedOn = _v0.a;
									return $elm$html$Html$text(
										' on ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, endedOn));
								} else {
									return $author$project$Utils$Html$empty;
								}
							}()
							]))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(3)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$justifyRight]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Restart broker'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$sm,
										$author$project$Ui$Button$onClick(
										$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$Restart(broker)),
										$author$project$Ui$Button$icon($author$project$Ui$Icon$repeat)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Restart')
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$viewPanelBody = function (model) {
	var _v0 = function () {
		var _v1 = model.MS;
		if (_v1.$ === 3) {
			var brokers_ = _v1.a;
			return _Utils_Tuple2(false, brokers_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var brokers = _v0.b;
	return _List_fromArray(
		[
			A4(
			$author$project$Ui$Table$view,
			_List_fromArray(
				[
					$author$project$Ui$Table$verticalCentered,
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('No ended brokers.')
						])),
					$author$project$Ui$Table$loading(loading)
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						A2(
						$elm$core$List$map,
						$author$project$Api$Column$view(
							A2($author$project$Api$Column$Sortable, model.alA, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$SortTable)),
						$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$columns),
						_List_fromArray(
						[
							A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
						])
					])),
			A2($elm$core$List$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$viewBroker, brokers),
			_List_Nil)
		]);
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				function () {
				var _v0 = model.k0;
				if (!_v0.$) {
					var restartModal = _v0.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$RestartModalMsg,
						$author$project$Components$Broker$RestartModal$view(restartModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$elm$core$Basics$never,
								A2(
									$author$project$Ui$Breadcrumb$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Breadcrumb$item,
											_List_Nil,
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top(
														{cm: model.cm}),
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Active Brokers')
														]))
												])),
											A2(
											$author$project$Ui$Breadcrumb$item,
											_List_fromArray(
												[
													$author$project$Ui$Breadcrumb$active(true)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Ended Brokers')
												]))
										]))),
								$author$project$Ui$HorizontalRule$view(_List_Nil),
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Ended Brokers')
									])),
								A2($elm$html$Html$br, _List_Nil, _List_Nil)
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$viewPanelBody(model)),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								function () {
								var _v1 = model.MS;
								if (_v1.$ === 3) {
									return A2(
										$elm$html$Html$map,
										$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$PaginationMsg,
										A2($author$project$Api$Pagination$view, _List_Nil, model.ajJ));
								} else {
									return $author$project$Utils$Html$empty;
								}
							}()
							]))
					]))
			]),
		ac9: 'Commissions | Brokers'
	};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$init, aiq: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$load, k8: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$save, alO: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$subscriptions, adT: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$update, amo: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$view});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$New$BrokerFormMsg = $elm$core$Basics$identity;
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$New$init = F4(
	function (session, _v0, _v1, _v2) {
		var apiClient = _v1.Gv;
		var params = _v2.YL;
		var _v3 = A4($author$project$Components$Broker$Form$init, apiClient, session, params.cm, $elm$core$Maybe$Nothing);
		var form = _v3.a;
		var cmd = _v3.b;
		return _Utils_Tuple2(
			{Gv: apiClient, SD: form},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$New$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$New$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$New$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Broker$Form$update, model.Gv, subMsg, model.SD);
		var newModelForm = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{SD: newModelForm}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$New$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Broker$Form$view(model.SD))
			]),
		ac9: 'Commissions | Brokers'
	};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$New$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$New$init, aiq: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$New$load, k8: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$New$save, alO: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$New$subscriptions, adT: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$New$update, amo: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$New$view});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$GotBrokers = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$fetchBrokers = function (model) {
	return A3(
		$author$project$Api$Provider$Broker$list,
		model.Gv,
		function (d) {
			return _Utils_update(
				d,
				{
					xG: $elm$core$Maybe$Just(model.cm),
					ajJ: model.ajJ,
					alA: model.alA
				});
		},
		$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$GotBrokers);
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$init = F4(
	function (session, _v0, shared, _v1) {
		var query = _v1.DE;
		var params = _v1.YL;
		var model = {
			Gv: shared.Gv,
			cm: params.cm,
			MS: $author$project$Api$Data$Loading,
			dd: shared.dd,
			gm: $elm$core$Maybe$Nothing,
			ajJ: $author$project$Api$Pagination$initFromQuery(query),
			aa4: session,
			alA: $author$project$Api$Sort$initFromQuery(query)
		};
		return _Utils_Tuple2(
			model,
			$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$fetchBrokers(model));
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$EndModalMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Broker$EndModal$Close = {$: 1};
var $author$project$Components$Broker$EndModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Broker$EndModal$Close);
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$subscriptions = function (_v0) {
	var endModal = _v0.gm;
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$EndModalMsg,
		A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Platform$Sub$none,
			A2($elm$core$Maybe$map, $author$project$Components$Broker$EndModal$subscriptions, endModal)));
};
var $author$project$Components$Broker$EndModal$Broker = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Broker$EndModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Broker$EndModal$EndDateDateInputMsg = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$Broker$EndModal$initFormFields = function () {
	var _v0 = $author$project$Components$DateInput$init;
	var endDateDateInput = _v0.a;
	var endDateDateInputCmd = _v0.b;
	return _Utils_Tuple2(
		{sb: $elm$core$Maybe$Nothing, sc: endDateDateInput},
		A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Components$Broker$EndModal$EndDateDateInputMsg(endDateDateInput),
			endDateDateInputCmd));
}();
var $author$project$Components$Broker$EndModal$init = F3(
	function (session, currentDate, resource) {
		var _v0 = $author$project$Components$Broker$EndModal$initFormFields;
		var fields = _v0.a;
		var fieldsCmd = _v0.b;
		return _Utils_Tuple2(
			{
				dd: currentDate,
				SD: $author$project$Utils$Form$init(fields),
				Jy: resource,
				aa4: session,
				qP: $author$project$Api$Data$NotAsked
			},
			fieldsCmd);
	});
var $author$project$Components$Broker$EndModal$BrokerAccountEnded = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Broker$EndModal$BrokerEnded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Broker$EndModal$Closed = {$: 1};
var $author$project$Components$Broker$EndModal$EndDate = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Broker$EndModal$EndedBroker = {$: 2};
var $author$project$Components$Broker$EndModal$EndedBrokerAccount = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Broker$EndModal$None = {$: 0};
var $author$project$Api$Provider$Broker$end = F4(
	function (apiClient, id_, endDate, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'broker',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'ended_on',
								$author$project$Utils$Date$encode(endDate))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Broker$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['end']),
						$author$project$Api$Provider$Broker$brokerPath(id_)))));
	});
var $author$project$Api$Provider$BrokerAccount$brokerAccountsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['broker_accounts']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$BrokerAccount$brokerAccountPath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		$author$project$Api$Provider$BrokerAccount$brokerAccountsPath);
};
var $author$project$Api$Provider$BrokerAccount$One$BrokerAccount = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$BrokerAccount$One$Record = function (ein) {
	return function (singleBrokerName) {
		return function (addressLine1) {
			return function (addressLine2) {
				return function (addressCity) {
					return function (addressState) {
						return function (addressZip) {
							return function (addressCountry) {
								return function (futureRatePeriodScheduleStartDate) {
									return function (futureRatePeriodSchedule) {
										return function (meta) {
											return {K3: addressCity, K4: addressCountry, K5: addressLine1, K6: addressLine2, K7: addressState, K8: addressZip, Q9: ein, SO: futureRatePeriodSchedule, SP: futureRatePeriodScheduleStartDate, W4: meta, abB: singleBrokerName};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$BrokerAccount$Meta$Meta = $elm$core$Basics$identity;
var $author$project$Api$Provider$BrokerAccount$Meta$Record = F3(
	function (destroyable, currentScheduleEnded, futureScheduleEnded) {
		return {Pi: currentScheduleEnded, Qw: destroyable, SQ: futureScheduleEnded};
	});
var $author$project$Api$Provider$BrokerAccount$Meta$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'future_schedule_ended',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'current_schedule_ended',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'destroyable',
			$elm$json$Json$Decode$bool,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$BrokerAccount$Meta$Record))));
var $author$project$Api$Provider$BrokerAccount$Meta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$BrokerAccount$Meta$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$BrokerAccount$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'meta',
	$author$project$Api$Provider$BrokerAccount$Meta$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'future_rate_period_schedule',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$RatePeriodSchedule$Shared$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'future_rate_period_schedule_start_date',
			$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'address_country',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'address_zip',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'address_state',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'address_city',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'address_line2',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'address_line1',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'single_broker_name',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'ein',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
											$elm$json$Json$Decode$succeed($author$project$Api$Provider$BrokerAccount$One$Record))))))))))));
var $author$project$Api$Provider$BrokerAccount$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$BrokerAccount$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$BrokerAccount$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$BrokerAccount$One$BrokerAccount)));
var $author$project$Api$Provider$BrokerAccount$end = F4(
	function (apiClient, id, endDate, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'broker_account',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'end_date',
								$author$project$Utils$Date$encode(endDate))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$BrokerAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['end']),
						$author$project$Api$Provider$BrokerAccount$brokerAccountPath(id)))));
	});
var $author$project$Components$Broker$EndModal$EndDateValidation = 0;
var $author$project$Components$Broker$EndModal$validateEndDate = F2(
	function (currentDate, fields) {
		var _v0 = fields.sb;
		if (!_v0.$) {
			var endDate = _v0.a;
			var yesterdayDate = A3($justinmimbs$date$Date$add, 3, -1, currentDate);
			return (A2($justinmimbs$date$Date$compare, yesterdayDate, endDate) !== 2) ? _List_Nil : _List_fromArray(
				[
					_Utils_Tuple2(0, 'Please enter a date greater or equal than yesterday')
				]);
		} else {
			return _List_fromArray(
				[
					_Utils_Tuple2(0, 'Please enter a date.')
				]);
		}
	});
var $author$project$Components$Broker$EndModal$formFieldsValidator = function (currentDate) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$Broker$EndModal$validateEndDate(currentDate))
			]));
};
var $author$project$Api$Provider$BrokerAccount$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$BrokerAccount$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BrokerAccount$Shared$id(shared);
};
var $author$project$Components$Broker$EndModal$formFieldsUpdate = F2(
	function (field, fields) {
		var dateInput = field.a;
		var date = field.b;
		return _Utils_update(
			fields,
			{sb: date, sc: dateInput});
	});
var $author$project$Components$Broker$EndModal$updateDateInputFormField = F6(
	function (model, dateInput, subMsg, toMsg, field, fieldGetter) {
		var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
		var newDateInput = _v0.a;
		var subCmd = _v0.b;
		var event = _v0.c;
		var newForm = function () {
			if (event.$ === 1) {
				var date = event.a;
				return A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Broker$EndModal$formFieldsUpdate,
					A2(field, newDateInput, date),
					model.SD);
			} else {
				var fields = $author$project$Utils$Form$fields(model.SD);
				return A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Broker$EndModal$formFieldsUpdate,
					A2(
						field,
						newDateInput,
						fieldGetter(fields)),
					model.SD);
			}
		}();
		return {
			GZ: A2(
				$elm$core$Platform$Cmd$map,
				toMsg(newDateInput),
				subCmd),
			agZ: $author$project$Components$Broker$EndModal$None,
			aiO: _Utils_update(
				model,
				{SD: newForm}),
			aR: _List_Nil
		};
	});
var $author$project$Components$Broker$EndModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 1:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$Broker$EndModal$Closed, aiO: model, aR: _List_Nil};
			case 0:
				var _v2 = A2(
					$author$project$Utils$Form$validate,
					$author$project$Components$Broker$EndModal$formFieldsValidator(model.dd),
					model.SD);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var newForm = _v3.a;
					var validFormFields = _v3.b;
					var endDate = A2(
						$elm$core$Maybe$withDefault,
						model.dd,
						$rtfeldman$elm_validate$Validate$fromValid(validFormFields).sb);
					return {
						GZ: function () {
							var _v4 = model.Jy;
							if (!_v4.$) {
								var broker = _v4.a;
								return A4(
									$author$project$Api$Provider$Broker$end,
									apiClient,
									$author$project$Api$Provider$Broker$All$id(broker),
									endDate,
									$author$project$Components$Broker$EndModal$BrokerEnded);
							} else {
								var brokerAccount = _v4.a;
								return A4(
									$author$project$Api$Provider$BrokerAccount$end,
									apiClient,
									$author$project$Api$Provider$BrokerAccount$One$id(brokerAccount),
									endDate,
									$author$project$Components$Broker$EndModal$BrokerAccountEnded);
							}
						}(),
						agZ: $author$project$Components$Broker$EndModal$None,
						aiO: _Utils_update(
							model,
							{SD: newForm, qP: $author$project$Api$Data$Loading}),
						aR: _List_Nil
					};
				} else {
					var newForm = _v2.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Broker$EndModal$None,
						aiO: _Utils_update(
							model,
							{SD: newForm}),
						aR: _List_Nil
					};
				}
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Broker$EndModal$EndedBroker,
						aiO: model,
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Broker successfully ended')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Broker$EndModal$None,
						aiO: _Utils_update(
							model,
							{qP: $author$project$Api$Data$NotAsked}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: function () {
							var _v7 = model.Jy;
							if (_v7.$ === 1) {
								var brokerAccount = _v7.a;
								return $author$project$Components$Broker$EndModal$EndedBrokerAccount(brokerAccount);
							} else {
								return $author$project$Components$Broker$EndModal$None;
							}
						}(),
						aiO: model,
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Brokers and deals successfully ended')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Broker$EndModal$None,
						aiO: _Utils_update(
							model,
							{qP: $author$project$Api$Data$NotAsked}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			default:
				var dateInput = msg.a;
				var subMsg = msg.b;
				return A6(
					$author$project$Components$Broker$EndModal$updateDateInputFormField,
					model,
					dateInput,
					subMsg,
					$author$project$Components$Broker$EndModal$EndDateDateInputMsg,
					$author$project$Components$Broker$EndModal$EndDate,
					function ($) {
						return $.sb;
					});
		}
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$updateUrl = function (model) {
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString(
					$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top(
						{cm: model.cm}))
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.ajJ),
				$author$project$Api$Sort$toQuery(model.alA))));
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								MS: response,
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{MS: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$fetchBrokers(newModel),
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 2:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						alA: A2($author$project$Api$Sort$update, columnId, model.alA)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$fetchBrokers(newModel),
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 3:
				var broker = msg.a;
				var _v2 = A3(
					$author$project$Components$Broker$EndModal$init,
					model.aa4,
					model.dd,
					$author$project$Components$Broker$EndModal$Broker(broker));
				var endModal = _v2.a;
				var endModalCmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							gm: $elm$core$Maybe$Just(endModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$EndModalMsg, endModalCmd),
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v3 = model.gm;
				if (!_v3.$) {
					var endModal = _v3.a;
					var endModalResult = A3($author$project$Components$Broker$EndModal$update, model.Gv, subMsg, endModal);
					var _v4 = function () {
						var _v5 = endModalResult.agZ;
						switch (_v5.$) {
							case 0:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(endModalResult.aiO),
									model.MS,
									$elm$core$Platform$Cmd$none);
							case 1:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.MS, $elm$core$Platform$Cmd$none);
							case 2:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Api$Data$Loading,
									$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$fetchBrokers(model));
							default:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.MS, $elm$core$Platform$Cmd$none);
						}
					}();
					var endModal_ = _v4.a;
					var brokers = _v4.b;
					var cmd = _v4.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{MS: brokers, gm: endModal_}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$EndModalMsg, endModalResult.GZ),
									cmd
								])),
						endModalResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$PaginationMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Broker$EndModal$End = {$: 0};
var $author$project$Components$Broker$EndModal$view = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.SD);
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Broker$EndModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title(
						function () {
							var _v1 = model.Jy;
							if (!_v1.$) {
								var broker = _v1.a;
								return 'End Broker ' + $author$project$Api$Provider$Broker$All$name(broker);
							} else {
								return 'End All Deals';
							}
						}())
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$onSubmit($author$project$Components$Broker$EndModal$End)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Date'),
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(4),
										$author$project$Ui$Form$Group$required(true)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Components$Broker$EndModal$EndDateDateInputMsg(fields.sc),
										A2(
											$author$project$Components$DateInput$view,
											_List_fromArray(
												[
													$author$project$Components$DateInput$value(fields.sb),
													$author$project$Components$DateInput$invalid(
													A2($author$project$Utils$Form$hasValidationErrors, 0, model.SD)),
													$author$project$Components$DateInput$errors(
													A2($author$project$Utils$Form$validationErrors, 0, model.SD))
												]),
											fields.sc)),
										A2(
										$author$project$Ui$Typography$text,
										_List_fromArray(
											[$author$project$Ui$Typography$helpBlock]),
										function () {
											var _v2 = model.Jy;
											if (!_v2.$) {
												return 'Ending this broker will end all deals on the same date and delete any deals taking effect in the future.';
											} else {
												return 'This will end all brokers and their deals on the same date, and delete any deals taking effect in the future.';
											}
										}())
									]))
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Broker$EndModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'End broker and their deals'},
						_List_fromArray(
							[
								$author$project$Ui$Button$danger,
								$author$project$Ui$Button$loading(
								_Utils_eq(model.qP, $author$project$Api$Data$Loading)),
								$author$project$Ui$Button$onClick($author$project$Components$Broker$EndModal$End)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('End')
							]))
					]))
			]));
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$SortTable = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'name', false, 'Name')
	]);
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$End = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$viewBroker = F2(
	function (brokerAccountId, broker) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(9)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$p,
							_List_fromArray(
								[$author$project$Ui$Typography$bold]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$Broker$All$name(broker)),
									function () {
									var _v0 = $author$project$Api$Provider$Broker$All$endedOn(broker);
									if (!_v0.$) {
										var endedOn = _v0.a;
										return A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													A2($author$project$Ui$Badge$fromString, _List_Nil, 'deal_ending'),
													$elm$html$Html$text(' on '),
													$elm$html$Html$text(
													A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, endedOn))
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(3)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__BrokerId_String__Top(
										{
											cm: brokerAccountId,
											GN: $author$project$Api$Provider$Broker$All$id(broker)
										}),
									_List_fromArray(
										[
											$author$project$Ui$Link$sm,
											$author$project$Ui$Link$icon($author$project$Ui$Icon$edit)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit')
										])),
									function () {
									var _v1 = $author$project$Api$Provider$Broker$All$endedOn(broker);
									if (_v1.$ === 1) {
										return A3(
											$author$project$Ui$Button$view,
											{mm: 'End broker'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$sm,
													$author$project$Ui$Button$onClick(
													$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$End(broker)),
													$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('End')
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								]))
						]))
				]));
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$viewPanelBody = function (model) {
	var _v0 = function () {
		var _v1 = model.MS;
		if (_v1.$ === 3) {
			var brokers_ = _v1.a;
			return _Utils_Tuple2(false, brokers_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var brokers = _v0.b;
	return _List_fromArray(
		[
			A4(
			$author$project$Ui$Table$view,
			_List_fromArray(
				[
					$author$project$Ui$Table$verticalCentered,
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('It looks like you haven’t added any brokers yet. '),
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__New(
								{cm: model.cm}),
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Create one')
								])),
							$elm$html$Html$text('?')
						])),
					$author$project$Ui$Table$loading(loading)
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						A2(
						$elm$core$List$map,
						$author$project$Api$Column$view(
							A2($author$project$Api$Column$Sortable, model.alA, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$SortTable)),
						$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$columns),
						_List_fromArray(
						[
							A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
						])
					])),
			A2(
				$elm$core$List$map,
				$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$viewBroker(model.cm),
				brokers),
			_List_Nil)
		]);
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				function () {
				var _v0 = model.gm;
				if (!_v0.$) {
					var endModal = _v0.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$EndModalMsg,
						$author$project$Components$Broker$EndModal$view(endModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$spanMd(9)
											]),
										_List_fromArray(
											[
												$author$project$Ui$Panel$title(
												_List_fromArray(
													[
														$elm$html$Html$text('Brokers')
													])),
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$textMuted]),
												_List_fromArray(
													[
														$elm$html$Html$text('A broker represents an individual who brings in deals. We track commissions at the broker level and then group those commissions onto statements at the account level.')
													]))
											])),
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$spanMd(3),
												$author$project$Ui$Grid$justifyRight
											]),
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Link$route,
												$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Ended(
													{cm: model.cm}),
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('See Ended Brokers')
													])),
												A3(
												$author$project$Ui$Link$route,
												$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__New(
													{cm: model.cm}),
												_List_fromArray(
													[
														$author$project$Ui$Link$buttonDefault,
														$author$project$Ui$Link$icon($author$project$Ui$Icon$add)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Add Broker')
													]))
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$viewPanelBody(model)),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								function () {
								var _v1 = model.MS;
								if (_v1.$ === 3) {
									return A2(
										$elm$html$Html$map,
										$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$PaginationMsg,
										A2($author$project$Api$Pagination$view, _List_Nil, model.ajJ));
								} else {
									return $author$project$Utils$Html$empty;
								}
							}()
							]))
					]))
			]),
		ac9: 'Commissions | Brokers'
	};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$init, aiq: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$load, k8: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$save, alO: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$subscriptions, adT: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$update, amo: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$view});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$BrokerResourceFilterMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$GotBrokerAccount = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$TypeDropdownMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$dealTypeToString = function (dealType) {
	if (!dealType) {
		return 'Company';
	} else {
		return 'Membership';
	}
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$buildUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('q'),
			model.akl),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('type'),
			A2($elm$core$Maybe$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$dealTypeToString, model.amg)),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('broker'),
			model.GN)
		]);
	return A2(
		$elm$url$Url$Builder$relative,
		_List_fromArray(
			[
				$author$project$Spa$Generated$Route$toString(
				$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Deals(
					{cm: model.cm}))
			]),
		A2(
			$elm$core$List$append,
			$author$project$Api$Pagination$toPageQuery(model.ajJ),
			A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)));
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$GotBrokerDeals = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$BrokerDeal$brokerDealsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['broker_deals']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$BrokerDeal$All$BrokerDeal = $elm$core$Basics$identity;
var $author$project$Api$Provider$BrokerDeal$One$BrokerDeal = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$BrokerDeal$Shared$BrokerDeal = $elm$core$Basics$identity;
var $author$project$Api$Provider$BrokerDeal$Shared$Record = F2(
	function (id, endDate) {
		return {sb: endDate, ahP: id};
	});
var $author$project$Api$Provider$BrokerDeal$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'end_date',
	$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$BrokerDeal$Shared$Record)));
var $author$project$Api$Provider$BrokerDeal$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$BrokerDeal$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$BrokerDeal$One$Record = F6(
	function (dealName, dealType, broker, rates, company, meta) {
		return {xF: broker, afQ: company, PS: dealName, PT: dealType, W4: meta, _4: rates};
	});
var $author$project$Api$Provider$BrokerDeal$Meta$Meta = $elm$core$Basics$identity;
var $author$project$Api$Provider$BrokerDeal$Meta$MetaRecord = F8(
	function (hasEndedRates, hasEndedDeal, dateEditable, restartable, isMembershipType, destroyable, editable, endable) {
		return {PC: dateEditable, Qw: destroyable, Q4: editable, Rv: endable, S7: hasEndedDeal, S8: hasEndedRates, UX: isMembershipType, $R: restartable};
	});
var $author$project$Api$Provider$BrokerDeal$Meta$metaRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'endable',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'editable',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'destroyable',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'is_membership_type',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'restartable',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'date_editable',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'has_ended_deal',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'has_ended_rates',
								$elm$json$Json$Decode$bool,
								$elm$json$Json$Decode$succeed($author$project$Api$Provider$BrokerDeal$Meta$MetaRecord)))))))));
var $author$project$Api$Provider$BrokerDeal$Meta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$BrokerDeal$Meta$metaRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$BrokerDealRate = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$BrokerDealRate$Shared$BrokerDealRate = $elm$core$Basics$identity;
var $author$project$Api$Provider$BrokerDealRate$Shared$Record = F5(
	function (id, startDate, endDate, description, pricingStructure) {
		return {Qr: description, sb: endDate, ahP: id, _l: pricingStructure, ab7: startDate};
	});
var $author$project$Api$Provider$BrokerDealRate$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'pricing_structure',
	$author$project$Api$Provider$PricingStructure$Shared$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'description',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'end_date',
			$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'start_date',
				$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$BrokerDealRate$Shared$Record))))));
var $author$project$Api$Provider$BrokerDealRate$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$BrokerDealRate$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$Record = F2(
	function (isEnded, isFuture) {
		return {UP: isEnded, UR: isFuture};
	});
var $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'is_future',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'is_ended',
		$elm$json$Json$Decode$bool,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$Record)));
var $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$BrokerDealRate$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$BrokerDealRate)));
var $author$project$Api$Provider$BrokerDeal$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'meta',
	$author$project$Api$Provider$BrokerDeal$Meta$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'company',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Company$Shared$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'rates',
			$elm$json$Json$Decode$list($author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'broker',
				$author$project$Api$Provider$Broker$Shared$decoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'deal_type',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'deal_name',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$BrokerDeal$One$Record)))))));
var $author$project$Api$Provider$BrokerDeal$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$BrokerDeal$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$BrokerDeal$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$BrokerDeal$One$BrokerDeal)));
var $author$project$Api$Provider$BrokerDeal$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$BrokerDeal$One$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$BrokerDeal$listDefaults = {xF: $elm$core$Maybe$Nothing, xG: $elm$core$Maybe$Nothing, afQ: $elm$core$Maybe$Nothing, TU: $elm$core$Maybe$Nothing, kk: $elm$core$Maybe$Nothing, ajJ: $author$project$Api$Pagination$init, akl: $elm$core$Maybe$Nothing, alA: $author$project$Api$Sort$init, amg: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$BrokerDeal$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$BrokerDeal$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.afQ;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'company', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.xG;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'broker_account', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.xF;
				if (!_v2.$) {
					var string = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'broker', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v3 = options.kk;
				if (!_v3.$) {
					var string = _v3.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'membership', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v4 = options.amg;
				if (!_v4.$) {
					var string = _v4.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'type', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v5 = options.TU;
				if (!_v5.$) {
					var bool = _v5.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$bool, 'inactive', bool)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v6 = options.akl;
				if (!_v6.$) {
					var string = _v6.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$Provider$BrokerDeal$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$BrokerDeal$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$BrokerDeal$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$BrokerDeal$brokerDealsPath)));
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$fetchBrokerDeals = function (model) {
	return A3(
		$author$project$Api$Provider$BrokerDeal$list,
		model.Gv,
		function (d) {
			return _Utils_update(
				d,
				{
					xF: model.GN,
					xG: $elm$core$Maybe$Just(model.cm),
					ajJ: model.ajJ,
					akl: model.akl,
					amg: A2($elm$core$Maybe$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$dealTypeToString, model.amg)
				});
		},
		$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$GotBrokerDeals);
};
var $author$project$Components$BrokerDeal$Table$init = F3(
	function (session, currentDate, options) {
		return {MR: _List_Nil, dd: currentDate, ny: options.ny, ss: options.ss, st: options.st, aa4: session, hE: $elm$core$Set$empty};
	});
var $author$project$Api$Provider$BrokerAccount$retrieve = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$BrokerAccount$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$BrokerAccount$brokerAccountPath(id)));
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$Company = 0;
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$Membership = 1;
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$stringToDealType = function (str) {
	switch (str) {
		case 'Company':
			return $elm$core$Maybe$Just(0);
		case 'Membership':
			return $elm$core$Maybe$Just(1);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$init = F4(
	function (session, practice, shared, _v0) {
		var params = _v0.YL;
		var query = _v0.DE;
		var q = A2($elm$core$Dict$get, 'q', query);
		var brokerId = A2($elm$core$Dict$get, 'broker', query);
		var _v1 = A3(
			$author$project$Components$ResourceFilter$Broker$init,
			shared.Gv,
			function (d) {
				return _Utils_update(
					d,
					{
						xG: $elm$core$Maybe$Just(params.cm)
					});
			},
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'All Brokers', akb: brokerId});
			});
		var brokerResourceFilter = _v1.a;
		var brokerResourceFilterCmd = _v1.b;
		var model = {
			Gv: shared.Gv,
			xG: $author$project$Api$Data$Loading,
			cm: params.cm,
			MR: $author$project$Api$Data$Loading,
			d_: A3(
				$author$project$Components$BrokerDeal$Table$init,
				session,
				shared.dd,
				{ny: false, ss: true, st: false}),
			GN: brokerId,
			mx: brokerResourceFilter,
			iX: $elm$core$Maybe$Nothing,
			dd: shared.dd,
			ajJ: $author$project$Api$Pagination$initFromQuery(query),
			ZV: practice,
			akl: q,
			up: $author$project$Ui$SearchInput$init(q),
			aa4: session,
			J8: shared.J8,
			qI: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'type-dropdown-filter', al6: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$TypeDropdownMsg})),
			amg: A2(
				$elm$core$Maybe$andThen,
				$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$stringToDealType,
				A2($elm$core$Dict$get, 'type', query))
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$BrokerResourceFilterMsg, brokerResourceFilterCmd),
						$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$fetchBrokerDeals(model),
						A3($author$project$Api$Provider$BrokerAccount$retrieve, shared.Gv, params.cm, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$GotBrokerAccount),
						A2($elm$core$Basics$composeR, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$buildUrl, $author$project$Ports$Navigation$replaceUrl)(model)
					])));
	});
var $author$project$Components$BrokerDeal$Table$load = F2(
	function (currentDate, model) {
		return _Utils_update(
			model,
			{dd: currentDate});
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					d_: A2($author$project$Components$BrokerDeal$Table$load, shared.dd, model.d_)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$BrokerDealsTableMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$CreateModalMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$BrokerDeal$CreateModal$BrokerResourceFilterMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$BrokerDeal$CreateModal$Close = {$: 1};
var $author$project$Components$BrokerDeal$CreateModal$CompanyResourceFilterMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$BrokerDeal$CreateModal$PatientResourceFilterMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$BrokerDeal$CreateModal$PricingStructureSelectMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$PricingStructureSelect$subscriptions = function (model) {
	return $author$project$Ui$Dropdown$subscriptions(model.nm);
};
var $author$project$Components$BrokerDeal$CreateModal$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$BrokerDeal$CreateModal$Close),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$BrokerDeal$CreateModal$CompanyResourceFilterMsg,
				$author$project$Components$ResourceFilter$Company$subscriptions(model.mZ)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$BrokerDeal$CreateModal$BrokerResourceFilterMsg,
				$author$project$Components$ResourceFilter$Broker$subscriptions(model.mx)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$BrokerDeal$CreateModal$PatientResourceFilterMsg,
				$author$project$Components$ResourceFilter$Patient$subscriptions(model.oY)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$BrokerDeal$CreateModal$PricingStructureSelectMsg,
				$author$project$Components$PricingStructureSelect$subscriptions(model.pk))
			]));
};
var $author$project$Components$BrokerDeal$Table$TimelineMsg = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$BrokerDeal$Timeline$BrokerDealRateModalMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$BrokerDeal$Timeline$CancelHiConfirmClosed = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Components$BrokerDeal$Timeline$DeleteHiConfirmClosed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$BrokerDeal$Timeline$EndModalMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$BrokerDeal$Timeline$RestartModalMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$BrokerDeal$EndModal$Close = {$: 1};
var $author$project$Components$BrokerDeal$EndModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$BrokerDeal$EndModal$Close);
};
var $author$project$Components$BrokerDeal$RestartModal$Close = {$: 1};
var $author$project$Components$BrokerDeal$RestartModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$BrokerDeal$RestartModal$Close);
};
var $author$project$Components$BrokerDealRate$CreateUpdateModal$Close = {$: 1};
var $author$project$Components$BrokerDealRate$CreateUpdateModal$PricingStructureSelectMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$BrokerDealRate$CreateUpdateModal$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$BrokerDealRate$CreateUpdateModal$Close),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$BrokerDealRate$CreateUpdateModal$PricingStructureSelectMsg,
				$author$project$Components$PricingStructureSelect$subscriptions(model.pk))
			]));
};
var $author$project$Components$BrokerDeal$Timeline$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				function () {
				var _v0 = model.fQ;
				if (!_v0.$) {
					var brokerDealRateModal = _v0.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Components$BrokerDeal$Timeline$BrokerDealRateModalMsg,
						$author$project$Components$BrokerDealRate$CreateUpdateModal$subscriptions(brokerDealRateModal));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$BrokerDeal$Timeline$EndModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$BrokerDeal$EndModal$subscriptions, model.gm))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$BrokerDeal$Timeline$RestartModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$BrokerDeal$RestartModal$subscriptions, model.k0))),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$BrokerDeal$Timeline$DeleteHiConfirmClosed)),
					model.f7)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$BrokerDeal$Timeline$CancelHiConfirmClosed),
					A2($elm$core$Maybe$map, $elm$core$Tuple$first, model.fR)))
			]));
};
var $author$project$Components$BrokerDeal$Table$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		A2(
			$elm$core$List$indexedMap,
			F2(
				function (index, _v0) {
					var timeline = _v0.b;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Components$BrokerDeal$Table$TimelineMsg(index),
						$author$project$Components$BrokerDeal$Timeline$subscriptions(timeline));
				}),
			model.MR));
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$CreateModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$BrokerDeal$CreateModal$subscriptions, model.iX))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$BrokerDealsTableMsg,
				$author$project$Components$BrokerDeal$Table$subscriptions(model.d_)),
				$author$project$Ui$Dropdown$subscriptions(model.qI),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$BrokerResourceFilterMsg,
				$author$project$Components$ResourceFilter$Broker$subscriptions(model.mx))
			]));
};
var $author$project$Components$BrokerDeal$CreateModal$Company = 0;
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$SearchInputMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$BrokerDeal$One$broker = function (_v0) {
	var record = _v0.b;
	return record.xF;
};
var $author$project$Api$Provider$BrokerDeal$All$broker = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BrokerDeal$One$broker(one);
};
var $author$project$Api$Provider$BrokerDeal$One$company = function (_v0) {
	var record = _v0.b;
	return record.afQ;
};
var $author$project$Api$Provider$BrokerDeal$All$company = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BrokerDeal$One$company(one);
};
var $author$project$Api$Provider$BrokerDeal$One$dealName = function (_v0) {
	var record = _v0.b;
	return record.PS;
};
var $author$project$Api$Provider$BrokerDeal$All$dealName = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BrokerDeal$One$dealName(one);
};
var $author$project$Api$Provider$BrokerDeal$One$dealType = function (_v0) {
	var record = _v0.b;
	return record.PT;
};
var $author$project$Api$Provider$BrokerDeal$All$dealType = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BrokerDeal$One$dealType(one);
};
var $author$project$Api$Provider$BrokerDeal$Shared$endDate = function (_v0) {
	var record = _v0;
	return record.sb;
};
var $author$project$Api$Provider$BrokerDeal$One$endDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BrokerDeal$Shared$endDate(shared);
};
var $author$project$Api$Provider$BrokerDeal$All$endDate = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BrokerDeal$One$endDate(one);
};
var $author$project$Api$Provider$BrokerDeal$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$BrokerDeal$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BrokerDeal$Shared$id(shared);
};
var $author$project$Api$Provider$BrokerDeal$All$id = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BrokerDeal$One$id(one);
};
var $author$project$Api$Provider$BrokerDeal$One$meta = function (_v0) {
	var record = _v0.b;
	return record.W4;
};
var $author$project$Api$Provider$BrokerDeal$All$meta = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BrokerDeal$One$meta(one);
};
var $author$project$Api$Provider$BrokerDeal$One$rates = function (_v0) {
	var record = _v0.b;
	return record._4;
};
var $author$project$Api$Provider$BrokerDeal$All$rates = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BrokerDeal$One$rates(one);
};
var $author$project$Components$BrokerDeal$BrokerDealRecord$fromProviderAll = function (brokerDeal) {
	return {
		xF: $author$project$Api$Provider$BrokerDeal$All$broker(brokerDeal),
		afQ: $author$project$Api$Provider$BrokerDeal$All$company(brokerDeal),
		PS: $author$project$Api$Provider$BrokerDeal$All$dealName(brokerDeal),
		PT: $author$project$Api$Provider$BrokerDeal$All$dealType(brokerDeal),
		sb: $author$project$Api$Provider$BrokerDeal$All$endDate(brokerDeal),
		ahP: $author$project$Api$Provider$BrokerDeal$All$id(brokerDeal),
		W4: $author$project$Api$Provider$BrokerDeal$All$meta(brokerDeal),
		_4: $author$project$Api$Provider$BrokerDeal$All$rates(brokerDeal)
	};
};
var $author$project$Components$BrokerDeal$CreateModal$Model = $elm$core$Basics$identity;
var $author$project$Components$BrokerDeal$CreateModal$One = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$PricingStructureSelect$DropdownMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$PricingStructureSelect$GotPricingStructures = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$PricingStructure$All$PricingStructure = $elm$core$Basics$identity;
var $author$project$Api$Provider$PricingStructure$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PricingStructure$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PricingStructure$pricingStructuresPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['pricing_structures']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$PricingStructure$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$PricingStructure$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$PricingStructure$pricingStructuresPath));
	});
var $author$project$Components$PricingStructureSelect$init = function (apiClient) {
	return _Utils_Tuple2(
		{
			ih: false,
			nm: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'pricing-structure-dropdown-filter', al6: $author$project$Components$PricingStructureSelect$DropdownMsg})),
			t3: $author$project$Api$Data$Loading
		},
		A2($author$project$Api$Provider$PricingStructure$list, apiClient, $author$project$Components$PricingStructureSelect$GotPricingStructures));
};
var $author$project$Api$Provider$Membership$Shared$id = function (_v0) {
	var record = _v0;
	return A2($elm$core$Maybe$withDefault, '', record.ahP);
};
var $author$project$Api$Provider$Membership$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Membership$Shared$id(shared);
};
var $author$project$Api$Provider$Membership$One$owner = function (_v0) {
	var record = _v0.b;
	return record.YD;
};
var $author$project$Components$BrokerDeal$CreateModal$patientFromShared = function (patient) {
	return {
		ahP: $author$project$Api$Provider$Patient$Shared$id(patient),
		WX: $author$project$Api$Provider$Patient$Shared$membershipStatus(patient)
	};
};
var $author$project$Components$BrokerDeal$CreateModal$initFormFields = F4(
	function (dealType, company, membership, broker) {
		var patient = A2(
			$elm$core$Maybe$map,
			$author$project$Components$BrokerDeal$CreateModal$patientFromShared,
			A2($elm$core$Maybe$andThen, $author$project$Api$Provider$Membership$One$owner, membership));
		return _Utils_Tuple2(
			{
				afb: $elm$core$Maybe$Nothing,
				xF: broker,
				afQ: company,
				PT: dealType,
				zv: $author$project$Utils$Maybe$toBool(
					A2($elm$core$Maybe$andThen, $author$project$Api$Provider$Membership$One$owner, membership)),
				kk: membership,
				AW: A2($elm$core$Maybe$map, $author$project$Api$Provider$Membership$One$id, membership),
				YY: patient,
				_l: $elm$core$Maybe$Nothing
			},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Components$BrokerDeal$CreateModal$init = F5(
	function (apiClient, session, currentDate, timeZone, options) {
		var company = A2(
			$elm$core$Maybe$map,
			function (a) {
				return $author$project$Components$BrokerDeal$CreateModal$One(a);
			},
			options.afQ);
		var _v0 = $author$project$Components$PricingStructureSelect$init(apiClient);
		var pricingStructureSelect = _v0.a;
		var pricingStructureSelectCmd = _v0.b;
		var _v1 = A2(
			$author$project$Components$ResourceFilter$Patient$init,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Select a Patient'});
			});
		var patientResourceFilter = _v1.a;
		var patientResourceFilterCmd = _v1.b;
		var _v2 = A4($author$project$Components$BrokerDeal$CreateModal$initFormFields, options.PT, company, options.kk, options.xF);
		var fields = _v2.a;
		var fieldsCmd = _v2.b;
		var _v3 = A2(
			$author$project$Components$ResourceFilter$Company$init,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Select an Employer'});
			});
		var companyResourceFilter = _v3.a;
		var companyResourceFilterCmd = _v3.b;
		var _v4 = A3(
			$author$project$Components$ResourceFilter$Broker$init,
			apiClient,
			function (d) {
				return $author$project$Utils$Maybe$toBool(options.xG) ? _Utils_update(
					d,
					{
						xG: options.xG,
						IK: $elm$core$Maybe$Just(true)
					}) : ($author$project$Utils$Maybe$toBool(options.kk) ? _Utils_update(
					d,
					{
						JA: $elm$core$Maybe$Just(true)
					}) : d);
			},
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Select a broker'});
			});
		var brokerResourceFilter = _v4.a;
		var brokerResourceFilterCmd = _v4.b;
		return _Utils_Tuple2(
			{
				mx: brokerResourceFilter,
				N7: options.N7,
				afQ: company,
				mZ: companyResourceFilter,
				dd: currentDate,
				SD: $author$project$Utils$Form$init(fields),
				oY: patientResourceFilter,
				pk: pricingStructureSelect,
				ak0: options.ak0,
				aa4: session,
				J8: timeZone,
				qP: $author$project$Api$Data$NotAsked
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						fieldsCmd,
						A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$CreateModal$PricingStructureSelectMsg, pricingStructureSelectCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$CreateModal$CompanyResourceFilterMsg, companyResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$CreateModal$BrokerResourceFilterMsg, brokerResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$CreateModal$PatientResourceFilterMsg, patientResourceFilterCmd)
					])));
	});
var $author$project$Api$Provider$BrokerAccount$Shared$retailEnabled = function (_v0) {
	var record = _v0;
	return record.ak0;
};
var $author$project$Api$Provider$BrokerAccount$One$retailEnabled = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BrokerAccount$Shared$retailEnabled(shared);
};
var $author$project$Components$BrokerDeal$CreateModal$All = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$BrokerDeal$CreateModal$Broker = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$BrokerDeal$CreateModal$BrokerDealCreated = 2;
var $author$project$Components$BrokerDeal$CreateModal$Closed = 1;
var $author$project$Components$BrokerDeal$CreateModal$CompanyField = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$BrokerDeal$CreateModal$GotMembership = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Components$BrokerDeal$CreateModal$MembershipField = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Components$BrokerDeal$CreateModal$MembershipUpdated = 3;
var $author$project$Components$BrokerDeal$CreateModal$None = 0;
var $author$project$Components$BrokerDeal$CreateModal$Patient = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$BrokerDeal$CreateModal$PricingStructure = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$BrokerDeal$CreateModal$Created = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$PricingType$encode = function (pricingType) {
	switch (pricingType.$) {
		case 0:
			return $elm$json$Json$Encode$string('percentage');
		case 1:
			return $elm$json$Json$Encode$string('fixed_amount_in_cents');
		case 2:
			return $elm$json$Json$Encode$string('percentage_and_fixed_amount');
		default:
			return $elm$json$Json$Encode$string('tiered');
	}
};
var $author$project$Api$SplitType$toString = function (splitType) {
	switch (splitType) {
		case 0:
			return 'all_members';
		case 1:
			return 'primary_only';
		default:
			return 'flat';
	}
};
var $author$project$Api$SplitType$encode = A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$Api$SplitType$toString);
var $author$project$Api$Provider$BrokerDeal$create = F3(
	function (apiClient, fields, toMsg) {
		var pricingStructure_ = function () {
			var _v0 = fields._l;
			if (_v0.$ === 1) {
				return _List_Nil;
			} else {
				var pricingStructure__ = _v0.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'pricing_structure',
						$elm$json$Json$Encode$object(
							$elm$core$List$concat(
								_List_fromArray(
									[
										function () {
										var _v1 = pricingStructure__.ahP;
										if (!_v1.$) {
											var string = _v1.a;
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'id',
													$elm$json$Json$Encode$string(string))
												]);
										} else {
											return _List_Nil;
										}
									}(),
										function () {
										var _v2 = pricingStructure__.Qr;
										if (!_v2.$) {
											var string = _v2.a;
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'description',
													$elm$json$Json$Encode$string(string))
												]);
										} else {
											return _List_Nil;
										}
									}(),
										function () {
										var _v3 = pricingStructure__.ahn;
										if (!_v3.$) {
											var _int = _v3.a;
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'fixed_amount_in_cents',
													$author$project$Currency$encode(_int))
												]);
										} else {
											return _List_Nil;
										}
									}(),
										function () {
										var _v4 = pricingStructure__.ajZ;
										if (!_v4.$) {
											var percentage = _v4.a;
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'percentage',
													$author$project$Percentage$encode(percentage))
												]);
										} else {
											return _List_Nil;
										}
									}(),
										function () {
										var _v5 = pricingStructure__.alD;
										if (!_v5.$) {
											var splitType = _v5.a;
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'split_type',
													$author$project$Api$SplitType$encode(splitType))
												]);
										} else {
											return _List_Nil;
										}
									}(),
										function () {
										var _v6 = pricingStructure__.akg;
										if (!_v6.$) {
											var pricingType_ = _v6.a;
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'pricing_type',
													$author$project$Api$PricingType$encode(pricingType_))
												]);
										} else {
											return _List_Nil;
										}
									}()
									]))))
					]);
			}
		}();
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'broker_deal',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'bill_from',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.afb)),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'company',
									A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.afQ)),
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										'membership',
										A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.kk)),
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(
											'broker',
											A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.xF)),
										pricingStructure_))))))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$BrokerDeal$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$BrokerDeal$brokerDealsPath)));
	});
var $author$project$Components$BrokerDeal$CreateModal$createBrokerDeal = F2(
	function (apiClient, validFormFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
		var companyId = function (company_) {
			if (!company_.$) {
				var company = company_.a;
				return $author$project$Api$Provider$Company$One$id(company);
			} else {
				var company = company_.a;
				return $author$project$Api$Provider$Company$All$id(company);
			}
		};
		return A3(
			$author$project$Api$Provider$BrokerDeal$create,
			apiClient,
			{
				afb: fields.afb,
				xF: A2($elm$core$Maybe$map, $author$project$Api$Provider$Broker$All$id, fields.xF),
				afQ: A2($elm$core$Maybe$map, companyId, fields.afQ),
				kk: A2($elm$core$Maybe$map, $author$project$Api$Provider$Membership$One$id, fields.kk),
				_l: fields._l
			},
			$author$project$Components$BrokerDeal$CreateModal$Created);
	});
var $author$project$Components$BrokerDeal$CreateModal$Updated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Membership$One$Membership = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Membership$Shared$Membership = $elm$core$Basics$identity;
var $author$project$Api$Provider$Membership$Shared$Record = function (id) {
	return function (isSponsored) {
		return function (startDate) {
			return function (endDate) {
				return function (isConfirmed) {
					return function (isUpdatable) {
						return function (isRestartable) {
							return function (billDate) {
								return function (nextBillDate) {
									return function (billFromDate) {
										return function (fixedPeriodRateInCents) {
											return function (fixedRegistrationFeeInCents) {
												return function (minimumEnrollmentPeriodInMonths) {
													return function (minimumEnrollmentStartDate) {
														return function (minimumEnrollmentEndDate) {
															return function (contractType) {
																return function (contractExpires) {
																	return function (contractEndDate) {
																		return function (billsAtEndOfPeriod) {
																			return function (billingStartDate) {
																				return function (endDateFarInThePast) {
																					return {xB: billDate, MD: billFromDate, MH: billingStartDate, MI: billsAtEndOfPeriod, yQ: contractEndDate, OB: contractExpires, G3: contractType, sb: endDate, Ru: endDateFarInThePast, Sx: fixedPeriodRateInCents, Sy: fixedRegistrationFeeInCents, ahP: id, UH: isConfirmed, Vb: isRestartable, Vc: isSponsored, Vk: isUpdatable, Xe: minimumEnrollmentEndDate, Xf: minimumEnrollmentPeriodInMonths, Xg: minimumEnrollmentStartDate, XP: nextBillDate, ab7: startDate};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Membership$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'end_date_far_in_the_past',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'billing_start_date',
		$author$project$Utils$Date$decode,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'bills_at_end_of_period',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'contract_end_date',
				$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contract_expires',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'contract_type',
						$elm$json$Json$Decode$nullable($author$project$Api$ContractType$decode),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'minimum_enrollment_end_date',
							$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'minimum_enrollment_start_date',
								$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'minimum_enrollment_period_in_months',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'fixed_registration_fee_in_cents',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'fixed_period_rate_in_cents',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'bill_from_date',
												$author$project$Utils$Date$decode,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'next_bill_date',
													$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'bill_date',
														$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'is_restartable',
															$elm$json$Json$Decode$bool,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'is_updatable',
																$elm$json$Json$Decode$bool,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'is_confirmed',
																	$elm$json$Json$Decode$bool,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'end_date',
																		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'start_date',
																			$author$project$Utils$Date$decode,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'is_sponsored',
																				$elm$json$Json$Decode$bool,
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'id',
																					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																					$elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$Shared$Record))))))))))))))))))))));
var $author$project$Api$Provider$Membership$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Membership$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Membership$One$Record = function (status) {
	return function (plan) {
		return function (membershipPatients) {
			return function (billedThroughDate) {
				return function (periodInMonths) {
					return function (periodRateInCents) {
						return function (isDestroyable) {
							return function (isCancellable) {
								return function (isConfirmable) {
									return function (shouldBeBilledUpToDate) {
										return function (autoRenew) {
											return function (revenueInCents) {
												return function (contractPeriodInMonths) {
													return function (finalBillingEndDate) {
														return function (neverBeenBilled) {
															return function (isSynced) {
																return function (owner) {
																	return function (upcomingAndOutstandingBills) {
																		return function (prepayOptions) {
																			return function (company) {
																				return function (companyAccount) {
																					return function (coupon) {
																						return function (brokerDeals) {
																							return function (cancellationReason) {
																								return function (cancellationReasonOther) {
																									return function (scheduledChange) {
																										return function (firstContract) {
																											return function (lastContract) {
																												return function (recurringCharges) {
																													return function (meta) {
																														return function (createdAt) {
																															return function (source) {
																																return function (taxProfileId) {
																																	return {Mk: autoRenew, ME: billedThroughDate, MR: brokerDeals, afo: cancellationReason, afp: cancellationReasonOther, afQ: company, Ob: companyAccount, OC: contractPeriodInMonths, OP: coupon, O1: createdAt, Sq: finalBillingEndDate, Su: firstContract, UF: isCancellable, UG: isConfirmable, UN: isDestroyable, Vf: isSynced, VD: lastContract, WR: membershipPatients, W4: meta, XH: neverBeenBilled, YD: owner, Zs: periodInMonths, Zt: periodRateInCents, Jb: plan, _d: prepayOptions, $h: recurringCharges, $_: revenueInCents, aaw: scheduledChange, abf: shouldBeBilledUpToDate, JQ: source, alH: status, acY: taxProfileId, adQ: upcomingAndOutstandingBills};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Membership$Meta$Meta = $elm$core$Basics$identity;
var $author$project$Api$Provider$Membership$Meta$Record = function (actions) {
	return function (owner) {
		return function (plan) {
			return function (startDate) {
				return function (billDate) {
					return function (nextBillDate) {
						return function (autoRenew) {
							return function (periodInMonths) {
								return function (minimumEnrollmentPeriodInMonths) {
									return function (membershipPatients) {
										return function (endDate) {
											return function (coupon) {
												return function (fixedRegistrationFeeInCents) {
													return function (fixedPeriodRateInCents) {
														return function (contractExpires) {
															return function (contractEndDate) {
																return function (contractPeriodInMonths) {
																	return function (contractType) {
																		return function (membershipScheduledChange) {
																			return function (membershipPatientsMaxCount) {
																				return function (recurringCharges) {
																					return function (paymentSource) {
																						return {vy: actions, Mk: autoRenew, xB: billDate, yQ: contractEndDate, OB: contractExpires, OC: contractPeriodInMonths, G3: contractType, OP: coupon, sb: endDate, Sx: fixedPeriodRateInCents, Sy: fixedRegistrationFeeInCents, WR: membershipPatients, WS: membershipPatientsMaxCount, WV: membershipScheduledChange, Xf: minimumEnrollmentPeriodInMonths, XP: nextBillDate, YD: owner, Zg: paymentSource, Zs: periodInMonths, Jb: plan, $h: recurringCharges, ab7: startDate};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Membership$Meta$ActionsRecord = function (invoiceNow) {
	return {Ut: invoiceNow};
};
var $author$project$Api$Provider$Membership$Meta$actionsRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'invoice_now',
	$elm$json$Json$Decode$bool,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$Meta$ActionsRecord));
var $author$project$Api$Provider$Membership$Meta$BillDateRecord = F3(
	function (editable, min, values) {
		return {Q4: editable, W9: min, q_: values};
	});
var $author$project$Api$Provider$Membership$Meta$billDateRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'values',
	$elm$json$Json$Decode$nullable(
		$elm$json$Json$Decode$list($author$project$Utils$Date$decode)),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'min',
		$author$project$Utils$Date$decode,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'editable',
			$elm$json$Json$Decode$bool,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$Meta$BillDateRecord))));
var $author$project$Api$Provider$Membership$Meta$ContractEndDateRecord = F3(
	function (editable, _default, values) {
		return {PW: _default, Q4: editable, q_: values};
	});
var $author$project$Api$Provider$Membership$Meta$contractEndDateRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'values',
	$elm$json$Json$Decode$list($author$project$Utils$Date$decode),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'default',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'editable',
			$elm$json$Json$Decode$bool,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$Meta$ContractEndDateRecord))));
var $author$project$Api$Provider$Membership$Meta$ContractTypeRecord = F2(
	function (editable, values) {
		return {Q4: editable, q_: values};
	});
var $author$project$Api$Provider$Membership$Meta$contractTypeRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'values',
	$elm$json$Json$Decode$list($author$project$Api$ContractType$decode),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'editable',
		$elm$json$Json$Decode$bool,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$Meta$ContractTypeRecord)));
var $author$project$Api$Provider$Membership$Meta$EditableRecord = function (editable) {
	return {Q4: editable};
};
var $author$project$Api$Provider$Membership$Meta$editableRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'editable',
	$elm$json$Json$Decode$bool,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$Meta$EditableRecord));
var $author$project$Api$Provider$Membership$Meta$EndDateRecord = F5(
	function (sponsoredMinWithoutProration, sponsoredMaxWithoutBilling, sponsoredMin, defaultValue, retailValues) {
		return {Qf: defaultValue, $Y: retailValues, ab2: sponsoredMaxWithoutBilling, ab3: sponsoredMin, ab4: sponsoredMinWithoutProration};
	});
var $author$project$Api$Provider$Membership$Meta$endDateRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'retail_values',
	$elm$json$Json$Decode$list($author$project$Utils$Date$decode),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'default_value',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'sponsored_min',
			$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'sponsored_max_without_billing',
				$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'sponsored_min_without_proration',
					$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$Meta$EndDateRecord))))));
var $author$project$Api$Provider$Membership$Meta$MembershipPatientsRecord = F5(
	function (patient, enrollmentRequestedOn, startDate, specialRate, fixedPeriodRateInCents) {
		return {RF: enrollmentRequestedOn, Sx: fixedPeriodRateInCents, YY: patient, abS: specialRate, ab7: startDate};
	});
var $author$project$Api$Provider$Membership$Meta$membershipPatientsRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'fixed_period_rate_in_cents',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'special_rate',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'start_date',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'enrollment_requested_on',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'patient',
					$elm$json$Json$Decode$bool,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$Meta$MembershipPatientsRecord))))));
var $author$project$Api$Provider$Membership$Meta$NextBillDateRecord = F3(
	function (editable, min, max) {
		return {Q4: editable, AU: max, W9: min};
	});
var $author$project$Api$Provider$Membership$Meta$nextBillDateRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'max',
	$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'min',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'editable',
			$elm$json$Json$Decode$bool,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$Meta$NextBillDateRecord))));
var $author$project$Api$Provider$Membership$Meta$StartDateRecord = F3(
	function (editable, min, max) {
		return {Q4: editable, AU: max, W9: min};
	});
var $author$project$Api$Provider$Membership$Meta$startDateRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'max',
	$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'min',
		$author$project$Utils$Date$decode,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'editable',
			$elm$json$Json$Decode$bool,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$Meta$StartDateRecord))));
var $author$project$Api$Provider$Membership$Meta$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'payment_source',
	$author$project$Api$Provider$Membership$Meta$editableRecordDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'recurring_charges',
		$author$project$Api$Provider$Membership$Meta$editableRecordDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['membership_patients', 'max_count']),
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'membership_scheduled_change',
				$author$project$Api$Provider$Membership$Meta$editableRecordDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contract_type',
					$author$project$Api$Provider$Membership$Meta$contractTypeRecordDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'contract_period_in_months',
						$author$project$Api$Provider$Membership$Meta$editableRecordDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'contract_end_date',
							$author$project$Api$Provider$Membership$Meta$contractEndDateRecordDecoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'contract_expires',
								$author$project$Api$Provider$Membership$Meta$editableRecordDecoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'fixed_period_rate_in_cents',
									$author$project$Api$Provider$Membership$Meta$editableRecordDecoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'fixed_registration_fee_in_cents',
										$author$project$Api$Provider$Membership$Meta$editableRecordDecoder,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'coupon',
											$author$project$Api$Provider$Membership$Meta$editableRecordDecoder,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'end_date',
												$author$project$Api$Provider$Membership$Meta$endDateRecordDecoder,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'membership_patients',
													$author$project$Api$Provider$Membership$Meta$membershipPatientsRecordDecoder,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'minimum_enrollment_period_in_months',
														$author$project$Api$Provider$Membership$Meta$editableRecordDecoder,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'period_in_months',
															$author$project$Api$Provider$Membership$Meta$editableRecordDecoder,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'auto_renew',
																$author$project$Api$Provider$Membership$Meta$editableRecordDecoder,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'next_bill_date',
																	$author$project$Api$Provider$Membership$Meta$nextBillDateRecordDecoder,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'bill_date',
																		$author$project$Api$Provider$Membership$Meta$billDateRecordDecoder,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'start_date',
																			$author$project$Api$Provider$Membership$Meta$startDateRecordDecoder,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'plan',
																				$author$project$Api$Provider$Membership$Meta$editableRecordDecoder,
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'owner',
																					$author$project$Api$Provider$Membership$Meta$editableRecordDecoder,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'actions',
																						$author$project$Api$Provider$Membership$Meta$actionsRecordDecoder,
																						$elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$Meta$Record)))))))))))))))))))))));
var $author$project$Api$Provider$Membership$Meta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Membership$Meta$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Membership$Source$Record = function (id) {
	return function (type_) {
		return function (name) {
			return function (lastFour) {
				return function (status) {
					return function (funding) {
						return function (expMonth) {
							return function (expYear) {
								return function (zip) {
									return function (paymentProcessor) {
										return {ag3: expMonth, ag4: expYear, SN: funding, ahP: id, VG: lastFour, Bq: name, Zd: paymentProcessor, alH: status, amg: type_, vv: zip};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Membership$Source$Source = $elm$core$Basics$identity;
var $author$project$Api$Provider$Membership$Source$decoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'payment_processor',
		$elm$json$Json$Decode$string,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'zip',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'exp_year',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'exp_month',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'funding',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'status',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'last_four',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'name',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'type',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'id',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$Source$Record))))))))))));
var $author$project$Api$Provider$MembershipBill$ForMembershipOne$MembershipBill = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$MembershipBill$Shared$MembershipBill = $elm$core$Basics$identity;
var $author$project$Api$Provider$MembershipBill$Shared$Record = F8(
	function (startDate, date, amountInCents, registrationFeeInCents, couponDiscountInCents, membershipAmountInCents, periodInMonths, couponDiscountMonths) {
		return {LE: amountInCents, OQ: couponDiscountInCents, OR: couponDiscountMonths, PB: date, WP: membershipAmountInCents, Zs: periodInMonths, $p: registrationFeeInCents, ab7: startDate};
	});
var $author$project$Api$Provider$MembershipBill$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'coupon_discount_months',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'period_in_months',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'membership_amount_in_cents',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'coupon_discount_in_cents',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'registration_fee_in_cents',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'amount_in_cents',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'date',
							$author$project$Utils$Date$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'start_date',
								$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
								$elm$json$Json$Decode$succeed($author$project$Api$Provider$MembershipBill$Shared$Record)))))))));
var $author$project$Api$Provider$MembershipBill$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$MembershipBill$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$MembershipBill$ForMembershipOne$Record = F2(
	function (invoice, charges) {
		return {NA: charges, Uk: invoice};
	});
var $author$project$Api$Provider$MembershipBillCharge$ForMembershipOne$MembershipBillCharge = $elm$core$Basics$identity;
var $author$project$Api$Provider$MembershipBillCharge$ForMembershipOne$Record = F3(
	function (amountInCents, name, quantity) {
		return {LE: amountInCents, Bq: name, Dz: quantity};
	});
var $author$project$Api$Provider$MembershipBillCharge$ForMembershipOne$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'quantity',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'amount_in_cents',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$MembershipBillCharge$ForMembershipOne$Record))));
var $author$project$Api$Provider$MembershipBillCharge$ForMembershipOne$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$MembershipBillCharge$ForMembershipOne$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$MembershipBill$ForMembershipOne$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'charges',
	$elm$json$Json$Decode$list($author$project$Api$Provider$MembershipBillCharge$ForMembershipOne$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'invoice',
		$elm$json$Json$Decode$nullable($author$project$Api$Common$Payable$Invoice$Min$decoder),
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$MembershipBill$ForMembershipOne$Record)));
var $author$project$Api$Provider$MembershipBill$ForMembershipOne$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$MembershipBill$ForMembershipOne$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$MembershipBill$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$MembershipBill$ForMembershipOne$MembershipBill)));
var $author$project$Api$Provider$MembershipBill$ForMembershipPrepayOptions$MembershipBill = $elm$core$Basics$identity;
var $author$project$Api$Provider$MembershipBill$ForMembershipPrepayOptions$Record = function (periodInMonths) {
	return {Zs: periodInMonths};
};
var $author$project$Api$Provider$MembershipBill$ForMembershipPrepayOptions$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'period_in_months',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$MembershipBill$ForMembershipPrepayOptions$Record));
var $author$project$Api$Provider$MembershipBill$ForMembershipPrepayOptions$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$MembershipBill$ForMembershipPrepayOptions$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$MembershipContract$Shared$MembershipContract = $elm$core$Basics$identity;
var $author$project$Api$Provider$MembershipContract$Shared$Record = F4(
	function (startDate, endDate, memo, isUpcoming) {
		return {sb: endDate, Vj: isUpcoming, aiG: memo, ab7: startDate};
	});
var $author$project$Api$Provider$MembershipContract$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'is_upcoming',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'memo',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'end_date',
			$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'start_date',
				$author$project$Utils$Date$decode,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$MembershipContract$Shared$Record)))));
var $author$project$Api$Provider$MembershipContract$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$MembershipContract$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$MembershipPatient = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$MembershipPatient$Shared$MembershipPatient = $elm$core$Basics$identity;
var $author$project$Api$Provider$MembershipPatient$Shared$Record = F8(
	function (id, startDate, endDate, effectiveEndDate, enrollmentRequestedOn, firstBillStartDate, status, membership) {
		return {Q8: effectiveEndDate, sb: endDate, RF: enrollmentRequestedOn, St: firstBillStartDate, ahP: id, kk: membership, ab7: startDate, alH: status};
	});
var $author$project$Api$Provider$MembershipPatient$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'membership',
	$author$project$Api$Provider$Membership$Min$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'status',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'first_bill_start_date',
			$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'enrollment_requested_on',
				$author$project$Utils$Date$decode,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'effective_end_date',
					$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'end_date',
						$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'start_date',
							$author$project$Utils$Date$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Api$Provider$MembershipPatient$Shared$Record)))))))));
var $author$project$Api$Provider$MembershipPatient$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$MembershipPatient$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$Record = function (revenueInCents) {
	return function (fixedPeriodRateInCents) {
		return function (memberType) {
			return function (patient) {
				return function (companyRegistration) {
					return function (cancellationReason) {
						return function (cancellationReasonOther) {
							return function (specialRate) {
								return function (rateRule) {
									return function (discountRule) {
										return {afo: cancellationReason, afp: cancellationReasonOther, Oi: companyRegistration, QF: discountRule, Sx: fixedPeriodRateInCents, WN: memberType, YY: patient, _3: rateRule, $_: revenueInCents, abS: specialRate};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$MemberRelationship$Child = 2;
var $author$project$Api$MemberRelationship$Employee = 0;
var $author$project$Api$MemberRelationship$Other = 3;
var $author$project$Api$MemberRelationship$Spouse = 1;
var $author$project$Api$MemberRelationship$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'employee':
				return $elm$json$Json$Decode$succeed(0);
			case 'spouse':
				return $elm$json$Json$Decode$succeed(1);
			case 'child':
				return $elm$json$Json$Decode$succeed(2);
			case 'other':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('Unsupported member relationship: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$CompanyRegistration$Meta$CompanyRegistration = $elm$core$Basics$identity;
var $author$project$Api$Provider$CompanyRegistration$Meta$Record = function (meta) {
	return {W4: meta};
};
var $author$project$Api$Provider$CompanyRegistration$Meta$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'meta',
	$author$project$Api$Provider$Meta$CompanyRegistration$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyRegistration$Meta$Record));
var $author$project$Api$Provider$CompanyRegistration$Meta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CompanyRegistration$Meta$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$DiscountRule$Min$DiscountRule = $elm$core$Basics$identity;
var $author$project$Api$Provider$DiscountRule$Min$Record = function (name) {
	return {Bq: name};
};
var $author$project$Api$Provider$DiscountRule$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$DiscountRule$Min$Record));
var $author$project$Api$Provider$DiscountRule$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$DiscountRule$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$SpecialRate$Min$SpecialRate = $elm$core$Basics$identity;
var $author$project$Api$Provider$SpecialRate$Min$Record = F2(
	function (id, name) {
		return {ahP: id, Bq: name};
	});
var $author$project$Api$Provider$SpecialRate$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$SpecialRate$Min$Record)));
var $author$project$Api$Provider$SpecialRate$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$SpecialRate$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'discount_rule',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$DiscountRule$Min$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'rate_rule',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Min$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'special_rate',
			$elm$json$Json$Decode$nullable($author$project$Api$Provider$SpecialRate$Min$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'cancellation_reason_other',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'cancellation_reason',
					$elm$json$Json$Decode$nullable($author$project$Api$Provider$CancellationReason$Shared$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'company_registration',
						$elm$json$Json$Decode$nullable($author$project$Api$Provider$CompanyRegistration$Meta$decoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'patient',
							$author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$decoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'member_type',
								$author$project$Api$MemberRelationship$decoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'fixed_period_rate_in_cents',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'revenue_in_cents',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
										$elm$json$Json$Decode$succeed($author$project$Api$Provider$MembershipPatient$ForMembershipOne$Record)))))))))));
var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$MembershipPatient$ForMembershipOne$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$MembershipPatient$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$MembershipPatient$ForMembershipOne$MembershipPatient)));
var $author$project$Api$Provider$MembershipScheduledChange$Shared$MembershipScheduledChange = $elm$core$Basics$identity;
var $author$project$Api$Provider$MembershipScheduledChange$Shared$Record = F6(
	function (type_, id, effectiveDate, changeAfterMonths, changeOnDate, toPlan) {
		return {Nt: changeAfterMonths, Nu: changeOnDate, Q7: effectiveDate, ahP: id, adc: toPlan, amg: type_};
	});
var $author$project$Api$Provider$MembershipScheduledChange$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'to_plan',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Plan$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'change_on_date',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'change_after_months',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'effective_date',
				$author$project$Utils$Date$decode,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'type',
						$author$project$Api$Provider$MembershipScheduledChange$Type$decoder,
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$MembershipScheduledChange$Shared$Record)))))));
var $author$project$Api$Provider$MembershipScheduledChange$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$MembershipScheduledChange$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Plan$SharedWithContractInfo$Plan = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Plan$SharedWithContractInfo$Record = F3(
	function (contractExpires, contractPeriodInMonths, contractType) {
		return {OB: contractExpires, OC: contractPeriodInMonths, G3: contractType};
	});
var $author$project$Api$Provider$Plan$SharedWithContractInfo$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'contract_type',
	$elm$json$Json$Decode$nullable($author$project$Api$ContractType$decode),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'contract_period_in_months',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'contract_expires',
			$elm$json$Json$Decode$bool,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Plan$SharedWithContractInfo$Record))));
var $author$project$Api$Provider$Plan$SharedWithContractInfo$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Plan$SharedWithContractInfo$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Plan$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Plan$SharedWithContractInfo$Plan)));
var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$RecurringCharge = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$RecurringCharge$Shared$RecurringCharge = $elm$core$Basics$identity;
var $author$project$Api$Provider$RecurringCharge$Shared$Record = function (id) {
	return function (name) {
		return function (periodsMax) {
			return function (periodInMonths) {
				return function (periodsRemaining) {
					return function (quantity) {
						return function (fixedDescription) {
							return function (fixedPriceInCents) {
								return function (startDate) {
									return function (nextBillDate) {
										return {aho: fixedDescription, ahp: fixedPriceInCents, ahP: id, Bq: name, XP: nextBillDate, Zs: periodInMonths, Zu: periodsMax, aj1: periodsRemaining, Dz: quantity, ab7: startDate};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$RecurringCharge$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'next_bill_date',
	$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'start_date',
		$author$project$Utils$Date$decode,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'fixed_price_in_cents',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'fixed_description',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'quantity',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'periods_remaining',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'period_in_months',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'periods_max',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'name',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
										$elm$json$Json$Decode$succeed($author$project$Api$Provider$RecurringCharge$Shared$Record)))))))))));
var $author$project$Api$Provider$RecurringCharge$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$RecurringCharge$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$Record = F4(
	function (patient, chargeItem, practitioner, uom) {
		return {mL: chargeItem, YY: patient, aka: practitioner, adP: uom};
	});
var $author$project$Api$Provider$ChargeItem$ForRecurringCharge$ChargeItem = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$ChargeItem$ForRecurringCharge$Record = F3(
	function (description, priceInCents, taxable) {
		return {Qr: description, Dw: priceInCents, acZ: taxable};
	});
var $author$project$Api$Provider$ChargeItem$ForRecurringCharge$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'taxable',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'price_in_cents',
		$elm$json$Json$Decode$float,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'description',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeItem$ForRecurringCharge$Record))));
var $author$project$Api$Provider$ChargeItem$ForRecurringCharge$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ChargeItem$ForRecurringCharge$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$ChargeItem$Min$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeItem$ForRecurringCharge$ChargeItem)));
var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'uom',
	$author$project$Api$Provider$Uom$Shared$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'practitioner',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Practitioner$Min$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'charge_item',
			$author$project$Api$Provider$ChargeItem$ForRecurringCharge$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'patient',
				$author$project$Api$Provider$Patient$Min$decoder,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$RecurringCharge$ForMembershipOne$Record)))));
var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$RecurringCharge$ForMembershipOne$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$RecurringCharge$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$RecurringCharge$ForMembershipOne$RecurringCharge)));
var $author$project$Api$Provider$Membership$One$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'tax_profile',
	$elm$json$Json$Decode$nullable(
		A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string)),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'source',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Membership$Source$decoder),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'created_at',
			$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'meta',
				$author$project$Api$Provider$Membership$Meta$decoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'recurring_charges',
					$elm$json$Json$Decode$list($author$project$Api$Provider$RecurringCharge$ForMembershipOne$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'last_contract',
						$elm$json$Json$Decode$nullable($author$project$Api$Provider$MembershipContract$Shared$decoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'first_contract',
							$elm$json$Json$Decode$nullable($author$project$Api$Provider$MembershipContract$Shared$decoder),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'scheduled_change',
								$elm$json$Json$Decode$nullable($author$project$Api$Provider$MembershipScheduledChange$Shared$decoder),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'cancellation_reason_other',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'cancellation_reason',
										$elm$json$Json$Decode$nullable($author$project$Api$Provider$CancellationReason$Shared$decoder),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'broker_deals',
											$elm$json$Json$Decode$list($author$project$Api$Provider$BrokerDeal$One$decoder),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'coupon',
												$elm$json$Json$Decode$nullable($author$project$Api$Common$Coupon$Shared$decode),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'company_account',
													$elm$json$Json$Decode$nullable($author$project$Api$Provider$CompanyAccount$Shared$decoder),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'company',
														$elm$json$Json$Decode$nullable($author$project$Api$Provider$Company$Shared$decoder),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'prepay_options',
															$elm$json$Json$Decode$list($author$project$Api$Provider$MembershipBill$ForMembershipPrepayOptions$decoder),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'upcoming_and_outstanding_bills',
																$elm$json$Json$Decode$list($author$project$Api$Provider$MembershipBill$ForMembershipOne$decoder),
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'owner',
																	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Shared$decoder),
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'is_synced',
																		$elm$json$Json$Decode$bool,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'never_been_billed',
																			$elm$json$Json$Decode$bool,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'final_billing_end_date',
																				$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'contract_period_in_months',
																					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'revenue_in_cents',
																						$elm$json$Json$Decode$int,
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'auto_renew',
																							$elm$json$Json$Decode$bool,
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'should_be_billed_up_to_date',
																								$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'is_confirmable',
																									$elm$json$Json$Decode$bool,
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'is_cancellable',
																										$elm$json$Json$Decode$bool,
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'is_destroyable',
																											$elm$json$Json$Decode$bool,
																											A3(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																												'period_rate_in_cents',
																												$elm$json$Json$Decode$int,
																												A3(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																													'period_in_months',
																													$elm$json$Json$Decode$int,
																													A3(
																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																														'billed_through_date',
																														$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
																														A3(
																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																															'membership_patients',
																															$elm$json$Json$Decode$list($author$project$Api$Provider$MembershipPatient$ForMembershipOne$decoder),
																															A3(
																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																'plan',
																																$author$project$Api$Provider$Plan$SharedWithContractInfo$decoder,
																																A3(
																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																	'status',
																																	$elm$json$Json$Decode$string,
																																	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$One$Record))))))))))))))))))))))))))))))))));
var $author$project$Api$Provider$Membership$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Membership$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Membership$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$One$Membership)));
var $author$project$Api$Provider$Membership$membershipsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['memberships']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Membership$membershipPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$Membership$membershipsPath);
};
var $author$project$Api$Provider$Membership$addBrokerDeal = F4(
	function (apiClient, id, brokerDeals, toMsg) {
		var encodeBrokerDeal = function (brokerDeal) {
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'id',
						A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, brokerDeal.ahP)),
						_Utils_Tuple2(
						'bill_from',
						A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, brokerDeal.afb)),
						_Utils_Tuple2(
						'broker',
						A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, brokerDeal.xF))
					]));
		};
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'membership',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'broker_deals',
								A2($elm$json$Json$Encode$list, encodeBrokerDeal, brokerDeals))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Membership$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Membership$membershipPath(id))));
	});
var $author$project$Api$Provider$Membership$One$brokerDeals = function (_v0) {
	var record = _v0.b;
	return record.MR;
};
var $author$project$Components$BrokerDeal$CreateModal$updateMembership = F3(
	function (apiClient, membership, validFormFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
		var brokerDeals = _Utils_ap(
			A2(
				$elm$core$List$map,
				function (brokerDeal) {
					return {
						afb: $elm$core$Maybe$Nothing,
						xF: $elm$core$Maybe$Just(
							$author$project$Api$Provider$Broker$Shared$id(
								$author$project$Api$Provider$BrokerDeal$One$broker(brokerDeal))),
						ahP: $elm$core$Maybe$Just(
							$author$project$Api$Provider$BrokerDeal$One$id(brokerDeal))
					};
				},
				$author$project$Api$Provider$Membership$One$brokerDeals(membership)),
			_List_fromArray(
				[
					{
					afb: fields.afb,
					xF: A2($elm$core$Maybe$map, $author$project$Api$Provider$Broker$All$id, fields.xF),
					ahP: $elm$core$Maybe$Nothing
				}
				]));
		return A4(
			$author$project$Api$Provider$Membership$addBrokerDeal,
			apiClient,
			$author$project$Api$Provider$Membership$One$id(membership),
			brokerDeals,
			$author$project$Components$BrokerDeal$CreateModal$Updated);
	});
var $author$project$Components$BrokerDeal$CreateModal$create = F2(
	function (apiClient, validFormFields) {
		var _v0 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
		var dealType = _v0.PT;
		var membership = _v0.kk;
		var _v1 = _Utils_Tuple2(dealType, membership);
		if (!_v1.a) {
			var _v2 = _v1.a;
			return A2($author$project$Components$BrokerDeal$CreateModal$createBrokerDeal, apiClient, validFormFields);
		} else {
			if (!_v1.b.$) {
				var _v3 = _v1.a;
				var membership_ = _v1.b.a;
				return A3($author$project$Components$BrokerDeal$CreateModal$updateMembership, apiClient, membership_, validFormFields);
			} else {
				var _v4 = _v1.a;
				var _v5 = _v1.b;
				return $elm$core$Platform$Cmd$none;
			}
		}
	});
var $author$project$Components$BrokerDeal$CreateModal$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var pricingStructure = field.a;
				return _Utils_update(
					fields,
					{_l: pricingStructure});
			case 1:
				var dealType = field.a;
				return _Utils_update(
					fields,
					{PT: dealType});
			case 2:
				var company = field.a;
				return _Utils_update(
					fields,
					{afQ: company});
			case 3:
				var broker = field.a;
				return _Utils_update(
					fields,
					{xF: broker});
			case 4:
				var patient = field.a;
				return _Utils_update(
					fields,
					{YY: patient});
			case 5:
				var membershipId = field.a;
				var membership = field.b;
				return _Utils_update(
					fields,
					{kk: membership, AW: membershipId});
			default:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						afb: $author$project$Utils$String$toMaybe(string)
					});
		}
	});
var $author$project$Components$BrokerDeal$CreateModal$BrokerValidation = 2;
var $author$project$Components$BrokerDeal$CreateModal$CompanyValidation = 1;
var $author$project$Components$BrokerDeal$CreateModal$validateCompany = function (fields) {
	var _v0 = _Utils_Tuple2(fields.PT, fields.afQ);
	if (!_v0.a) {
		if (_v0.b.$ === 1) {
			var _v1 = _v0.a;
			var _v2 = _v0.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(1, 'Please select an employer.')
				]);
		} else {
			var _v3 = _v0.a;
			return _List_Nil;
		}
	} else {
		var _v4 = _v0.a;
		return _List_Nil;
	}
};
var $author$project$Components$BrokerDeal$CreateModal$MembershipValidation = 3;
var $author$project$Api$Provider$Membership$Shared$isSponsored = function (_v0) {
	var record = _v0;
	return record.Vc;
};
var $author$project$Api$Provider$Membership$One$isSponsored = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Membership$Shared$isSponsored(shared);
};
var $author$project$Components$BrokerDeal$CreateModal$validateMembership = function (fields) {
	var _v0 = _Utils_Tuple2(fields.PT, fields.kk);
	if (_v0.a === 1) {
		if (!_v0.b.$) {
			var _v1 = _v0.a;
			var membership = _v0.b.a;
			return $author$project$Api$Provider$Membership$One$isSponsored(membership) ? _List_fromArray(
				[
					_Utils_Tuple2(3, 'This is an employer sponsored membership that is not eligible for retail commission tracking. You can assign a broker to an employer by changing the category above to \"Employer\".')
				]) : _List_Nil;
		} else {
			var _v2 = _v0.a;
			return _List_Nil;
		}
	} else {
		var _v3 = _v0.a;
		return _List_Nil;
	}
};
var $author$project$Components$BrokerDeal$CreateModal$PatientValidation = 4;
var $author$project$Components$BrokerDeal$CreateModal$validatePatient = function (fields) {
	var _v0 = _Utils_Tuple2(fields.PT, fields.YY);
	if (_v0.a === 1) {
		if (_v0.b.$ === 1) {
			var _v1 = _v0.a;
			var _v2 = _v0.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(4, 'Please select a patient.')
				]);
		} else {
			var _v3 = _v0.a;
			var patient = _v0.b.a;
			return (patient.WX === 'inactive') ? _List_fromArray(
				[
					_Utils_Tuple2(4, 'Inactive membership (You can\'t assign broker to this patient).')
				]) : _List_Nil;
		}
	} else {
		var _v4 = _v0.a;
		return _List_Nil;
	}
};
var $author$project$Components$BrokerDeal$CreateModal$PricingStructureValidation = 0;
var $author$project$Components$BrokerDeal$CreateModal$validatePricingStructure = function (fields) {
	var _v0 = _Utils_Tuple2(fields.PT, fields._l);
	if (!_v0.a) {
		if (_v0.b.$ === 1) {
			var _v1 = _v0.a;
			var _v2 = _v0.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(0, 'Please select a broker commission rate.')
				]);
		} else {
			var _v3 = _v0.a;
			return _List_Nil;
		}
	} else {
		var _v4 = _v0.a;
		return _List_Nil;
	}
};
var $author$project$Components$BrokerDeal$CreateModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$BrokerDeal$CreateModal$validatePatient),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$BrokerDeal$CreateModal$validateMembership),
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.xF;
			},
			_Utils_Tuple2(2, 'Please select a broker.')),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$BrokerDeal$CreateModal$validateCompany),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$BrokerDeal$CreateModal$validatePricingStructure)
		]));
var $author$project$Api$Provider$Membership$Min$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$MembershipPatient$ForPatientAll$membership = function (_v0) {
	var record = _v0;
	return record.kk;
};
var $author$project$Api$Provider$Patient$All$membershipPatients = function (_v0) {
	var record = _v0.b;
	return record.WR;
};
var $author$project$Components$BrokerDeal$CreateModal$patientFromAll = function (patient) {
	return {
		ahP: $author$project$Api$Provider$Patient$All$id(patient),
		WX: $author$project$Api$Provider$Patient$All$membershipStatus(patient)
	};
};
var $author$project$Api$Provider$Membership$expandToString = function (expand) {
	return 'coverage_plan';
};
var $author$project$Api$Provider$Membership$retrieve = F4(
	function (apiClient, id_, expand, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Membership$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2(
						$author$project$Api$Param$list,
						'expand',
						A2($elm$core$List$map, $author$project$Api$Provider$Membership$expandToString, expand))
					]),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Membership$membershipPath(id_))));
	});
var $author$project$Api$Provider$MembershipPatient$ForPatientAll$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Components$PricingStructureSelect$None = {$: 0};
var $author$project$Components$PricingStructureSelect$Selected = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$PricingStructure$Shared$description = function (_v0) {
	var record = _v0;
	return record.Qr;
};
var $author$project$Api$Provider$PricingStructure$All$description = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PricingStructure$Shared$description(shared);
};
var $author$project$Api$Provider$PricingStructure$All$fixedAmountInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PricingStructure$Shared$fixedAmountInCents(shared);
};
var $author$project$Api$Provider$PricingStructure$All$percentage = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PricingStructure$Shared$percentage(shared);
};
var $author$project$Api$Provider$PricingStructure$All$pricingType = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PricingStructure$Shared$pricingType(shared);
};
var $author$project$Api$Provider$PricingStructure$Shared$splitType = function (_v0) {
	var record = _v0;
	return record.alD;
};
var $author$project$Api$Provider$PricingStructure$All$splitType = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PricingStructure$Shared$splitType(shared);
};
var $author$project$Components$PricingStructureSelect$existingPricingStructure = F2(
	function (pricingStructure, id) {
		return {
			Qr: A2($elm$core$Maybe$map, $author$project$Api$Provider$PricingStructure$All$description, pricingStructure),
			ahn: A2(
				$elm$core$Maybe$map,
				$author$project$Currency$fromInt,
				A2($elm$core$Maybe$map, $author$project$Api$Provider$PricingStructure$All$fixedAmountInCents, pricingStructure)),
			ahP: id,
			ajZ: A2(
				$elm$core$Maybe$map,
				$author$project$Percentage$fromFloat,
				A2($elm$core$Maybe$map, $author$project$Api$Provider$PricingStructure$All$percentage, pricingStructure)),
			akg: A2($elm$core$Maybe$map, $author$project$Api$Provider$PricingStructure$All$pricingType, pricingStructure),
			alD: A2($elm$core$Maybe$map, $author$project$Api$Provider$PricingStructure$All$splitType, pricingStructure)
		};
	});
var $author$project$Api$Provider$PricingStructure$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$PricingStructure$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PricingStructure$Shared$id(shared);
};
var $author$project$Components$PricingStructureSelect$newPricingStructure = {
	Qr: $elm$core$Maybe$Nothing,
	ahn: $elm$core$Maybe$Nothing,
	ahP: $elm$core$Maybe$Nothing,
	ajZ: $elm$core$Maybe$Nothing,
	akg: $elm$core$Maybe$Just($author$project$Api$PricingType$Percentage),
	alD: $elm$core$Maybe$Just(0)
};
var $author$project$Components$PricingStructureSelect$updateNewPricingStructureField = F2(
	function (pricingStructure, field) {
		switch (field.$) {
			case 0:
				var pricingType = field.a;
				return _Utils_update(
					pricingStructure,
					{
						akg: $elm$core$Maybe$Just(pricingType)
					});
			case 1:
				var splitType = field.a;
				return _Utils_update(
					pricingStructure,
					{
						alD: $elm$core$Maybe$Just(splitType)
					});
			case 2:
				var _int = field.a;
				return _Utils_update(
					pricingStructure,
					{ahn: _int});
			default:
				var _float = field.a;
				return _Utils_update(
					pricingStructure,
					{ajZ: _float});
		}
	});
var $author$project$Components$PricingStructureSelect$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Ui$Dropdown$update, subMsg, model.nm);
				var dropdownFilter = _v1.a;
				var cmd = _v1.b;
				return {
					GZ: cmd,
					agZ: $author$project$Components$PricingStructureSelect$None,
					aiO: _Utils_update(
						model,
						{nm: dropdownFilter}),
					aR: _List_Nil
				};
			case 1:
				var pricingStructureId = msg.a;
				var _v2 = function () {
					if (_Utils_eq(
						pricingStructureId,
						$elm$core$Maybe$Just(''))) {
						return _Utils_Tuple2(
							true,
							$author$project$Components$PricingStructureSelect$Selected(
								$elm$core$Maybe$Just($author$project$Components$PricingStructureSelect$newPricingStructure)));
					} else {
						var pricingStructure = A2(
							$elm_community$list_extra$List$Extra$find,
							function (item) {
								return _Utils_eq(
									$elm$core$Maybe$Just(
										$author$project$Api$Provider$PricingStructure$All$id(item)),
									pricingStructureId);
							},
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								$author$project$Api$Data$toMaybe(model.t3)));
						return _Utils_Tuple2(
							false,
							$author$project$Components$PricingStructureSelect$Selected(
								$elm$core$Maybe$Just(
									A2($author$project$Components$PricingStructureSelect$existingPricingStructure, pricingStructure, pricingStructureId))));
					}
				}();
				var addingNew = _v2.a;
				var event = _v2.b;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: event,
					aiO: _Utils_update(
						model,
						{ih: addingNew}),
					aR: _List_Nil
				};
			case 2:
				var response = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: $author$project$Components$PricingStructureSelect$None,
					aiO: _Utils_update(
						model,
						{t3: response}),
					aR: $author$project$OutMsg$handleErrorResponse(response)
				};
			default:
				var pricingStructure = msg.a;
				var field = msg.b;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: $author$project$Components$PricingStructureSelect$Selected(
						$elm$core$Maybe$Just(
							A2($author$project$Components$PricingStructureSelect$updateNewPricingStructureField, pricingStructure, field))),
					aiO: model,
					aR: _List_Nil
				};
		}
	});
var $author$project$Components$BrokerDeal$CreateModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 1:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: 1, aiO: model, aR: _List_Nil};
			case 0:
				var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$BrokerDeal$CreateModal$formFieldsValidator, model.SD);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var newForm = _v3.a;
					var validFormFields = _v3.b;
					return {
						GZ: A2($author$project$Components$BrokerDeal$CreateModal$create, apiClient, validFormFields),
						agZ: 0,
						aiO: _Utils_update(
							model,
							{SD: newForm, qP: $author$project$Api$Data$Loading}),
						aR: _List_Nil
					};
				} else {
					var newForm = _v2.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{SD: newForm}),
						aR: _List_Nil
					};
				}
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 2,
						aiO: model,
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Broker commission successfully created')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{qP: $author$project$Api$Data$NotAsked}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 3,
						aiO: model,
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Broker commission successfully created')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{qP: $author$project$Api$Data$NotAsked}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 4:
				var subMsg = msg.a;
				var pricingStructureSelectResult = A2($author$project$Components$PricingStructureSelect$update, subMsg, model.pk);
				var form = function () {
					var _v6 = pricingStructureSelectResult.agZ;
					if (!_v6.$) {
						return model.SD;
					} else {
						var pricingStructure = _v6.a;
						return A3(
							$author$project$Utils$Form$update,
							$author$project$Components$BrokerDeal$CreateModal$formFieldsUpdate,
							$author$project$Components$BrokerDeal$CreateModal$PricingStructure(pricingStructure),
							model.SD);
					}
				}();
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$CreateModal$PricingStructureSelectMsg, pricingStructureSelectResult.GZ),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{SD: form, pk: pricingStructureSelectResult.aiO}),
					aR: pricingStructureSelectResult.aR
				};
			case 5:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$BrokerDeal$CreateModal$formFieldsUpdate, field, model.SD);
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{SD: newForm}),
					aR: _List_Nil
				};
			case 6:
				var subMsg = msg.a;
				var companyResourceResult = A3($author$project$Components$ResourceFilter$Company$update, apiClient, subMsg, model.mZ);
				var newForm = function () {
					var _v7 = companyResourceResult.agZ;
					_v7$2:
					while (true) {
						if (!_v7.$) {
							switch (_v7.a.$) {
								case 0:
									var company = _v7.a.a;
									return A3(
										$author$project$Utils$Form$update,
										$author$project$Components$BrokerDeal$CreateModal$formFieldsUpdate,
										$author$project$Components$BrokerDeal$CreateModal$CompanyField(
											$elm$core$Maybe$Just(
												$author$project$Components$BrokerDeal$CreateModal$All(company))),
										model.SD);
								case 2:
									var _v8 = _v7.a;
									return A3(
										$author$project$Utils$Form$update,
										$author$project$Components$BrokerDeal$CreateModal$formFieldsUpdate,
										$author$project$Components$BrokerDeal$CreateModal$CompanyField($elm$core$Maybe$Nothing),
										model.SD);
								default:
									break _v7$2;
							}
						} else {
							break _v7$2;
						}
					}
					return model.SD;
				}();
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$CreateModal$CompanyResourceFilterMsg, companyResourceResult.GZ),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{mZ: companyResourceResult.aiO, SD: newForm}),
					aR: companyResourceResult.aR
				};
			case 7:
				var subMsg = msg.a;
				var brokerResourceResult = A3($author$project$Components$ResourceFilter$Broker$update, apiClient, subMsg, model.mx);
				var newForm = function () {
					var _v9 = brokerResourceResult.agZ;
					_v9$2:
					while (true) {
						if (!_v9.$) {
							switch (_v9.a.$) {
								case 0:
									var broker = _v9.a.a;
									return A3(
										$author$project$Utils$Form$update,
										$author$project$Components$BrokerDeal$CreateModal$formFieldsUpdate,
										$author$project$Components$BrokerDeal$CreateModal$Broker(
											$elm$core$Maybe$Just(broker)),
										model.SD);
								case 2:
									var _v10 = _v9.a;
									return A3(
										$author$project$Utils$Form$update,
										$author$project$Components$BrokerDeal$CreateModal$formFieldsUpdate,
										$author$project$Components$BrokerDeal$CreateModal$Broker($elm$core$Maybe$Nothing),
										model.SD);
								default:
									break _v9$2;
							}
						} else {
							break _v9$2;
						}
					}
					return model.SD;
				}();
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$CreateModal$BrokerResourceFilterMsg, brokerResourceResult.GZ),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{mx: brokerResourceResult.aiO, SD: newForm}),
					aR: brokerResourceResult.aR
				};
			case 8:
				var subMsg = msg.a;
				var patientResourceResult = A3($author$project$Components$ResourceFilter$Patient$update, apiClient, subMsg, model.oY);
				var _v11 = function () {
					var _v12 = patientResourceResult.agZ;
					_v12$2:
					while (true) {
						if (!_v12.$) {
							switch (_v12.a.$) {
								case 0:
									var patient = _v12.a.a;
									var newForm_ = A3(
										$author$project$Utils$Form$update,
										$author$project$Components$BrokerDeal$CreateModal$formFieldsUpdate,
										$author$project$Components$BrokerDeal$CreateModal$Patient(
											$elm$core$Maybe$Just(
												$author$project$Components$BrokerDeal$CreateModal$patientFromAll(patient))),
										model.SD);
									var membershipPatients = $author$project$Api$Provider$Patient$All$membershipPatients(patient);
									var membershipId = A2(
										$elm$core$Maybe$map,
										$author$project$Api$Provider$Membership$Min$id,
										A2(
											$elm$core$Maybe$map,
											$author$project$Api$Provider$MembershipPatient$ForPatientAll$membership,
											A2(
												$elm_community$list_extra$List$Extra$find,
												function (membershipPatient_) {
													return _Utils_eq(
														$author$project$Api$Provider$MembershipPatient$ForPatientAll$status(membershipPatient_),
														$author$project$Api$Provider$Patient$All$membershipStatus(patient));
												},
												membershipPatients)));
									return _Utils_Tuple2(
										A3(
											$author$project$Utils$Form$update,
											$author$project$Components$BrokerDeal$CreateModal$formFieldsUpdate,
											A2($author$project$Components$BrokerDeal$CreateModal$MembershipField, membershipId, $elm$core$Maybe$Nothing),
											newForm_),
										function () {
											if (!membershipId.$) {
												var id = membershipId.a;
												return A4(
													$author$project$Api$Provider$Membership$retrieve,
													apiClient,
													id,
													_List_Nil,
													$author$project$Components$BrokerDeal$CreateModal$GotMembership(id));
											} else {
												return $elm$core$Platform$Cmd$none;
											}
										}());
								case 2:
									var _v14 = _v12.a;
									return _Utils_Tuple2(
										A3(
											$author$project$Utils$Form$update,
											$author$project$Components$BrokerDeal$CreateModal$formFieldsUpdate,
											A2($author$project$Components$BrokerDeal$CreateModal$MembershipField, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
											A3(
												$author$project$Utils$Form$update,
												$author$project$Components$BrokerDeal$CreateModal$formFieldsUpdate,
												$author$project$Components$BrokerDeal$CreateModal$Patient($elm$core$Maybe$Nothing),
												model.SD)),
										$elm$core$Platform$Cmd$none);
								default:
									break _v12$2;
							}
						} else {
							break _v12$2;
						}
					}
					return _Utils_Tuple2(model.SD, $elm$core$Platform$Cmd$none);
				}();
				var newForm = _v11.a;
				var cmd = _v11.b;
				return {
					GZ: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$CreateModal$PatientResourceFilterMsg, patientResourceResult.GZ),
								cmd
							])),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{SD: newForm, oY: patientResourceResult.aiO}),
					aR: patientResourceResult.aR
				};
			default:
				var membershipId = msg.a;
				var response = msg.b;
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$BrokerDeal$CreateModal$formFieldsUpdate,
					A2(
						$author$project$Components$BrokerDeal$CreateModal$MembershipField,
						$elm$core$Maybe$Just(membershipId),
						$author$project$Api$Data$toMaybe(response)),
					model.SD);
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{SD: newForm}),
					aR: $author$project$OutMsg$handleErrorResponse(response)
				};
		}
	});
var $author$project$Components$BrokerDeal$Table$BrokerDealDeleted = 1;
var $author$project$Components$BrokerDeal$Table$BrokerDealEnded = 3;
var $author$project$Components$BrokerDeal$Table$BrokerDealRateCanceled = 4;
var $author$project$Components$BrokerDeal$Table$BrokerDealRateCreated = 5;
var $author$project$Components$BrokerDeal$Table$BrokerDealRateUpdated = 6;
var $author$project$Components$BrokerDeal$Table$BrokerDealRestarted = 2;
var $author$project$Components$BrokerDeal$Table$None = 0;
var $author$project$Components$BrokerDeal$Timeline$BrokerDealDeleted = 1;
var $author$project$Components$BrokerDeal$Timeline$BrokerDealEnded = 3;
var $author$project$Components$BrokerDeal$Timeline$BrokerDealRateCanceled = 4;
var $author$project$Components$BrokerDeal$Timeline$BrokerDealRateCreated = 5;
var $author$project$Components$BrokerDeal$Timeline$BrokerDealRateUpdated = 6;
var $author$project$Components$BrokerDeal$Timeline$BrokerDealRestarted = 2;
var $author$project$Components$BrokerDeal$Timeline$Canceled = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Components$BrokerDeal$Timeline$Deleted = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$BrokerDeal$Timeline$None = 0;
var $author$project$Api$Provider$BrokerDealRate$brokerDealRatesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['broker_deal_rates']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$BrokerDealRate$brokerDealRatePath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$BrokerDealRate$brokerDealRatesPath);
};
var $author$project$Api$Provider$BrokerDealRate$One$BrokerDealRate = 0;
var $author$project$Api$Provider$BrokerDealRate$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Provider$BrokerDealRate$cancel = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$BrokerDealRate$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['cancel']),
					$author$project$Api$Provider$BrokerDealRate$brokerDealRatePath(id_))));
	});
var $author$project$Api$Provider$BrokerDeal$brokerDealPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$BrokerDeal$brokerDealsPath);
};
var $author$project$Api$Provider$BrokerDeal$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$BrokerDeal$brokerDealPath(id_)));
	});
var $author$project$Api$Provider$BrokerDealRate$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BrokerDealRate$Shared$id(shared);
};
var $author$project$Components$BrokerDeal$EndModal$Model = $elm$core$Basics$identity;
var $author$project$Components$BrokerDeal$EndModal$EndDateDateInputMsg = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Api$Provider$BrokerDealRate$Shared$endDate = function (_v0) {
	var record = _v0;
	return record.sb;
};
var $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$endDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BrokerDealRate$Shared$endDate(shared);
};
var $author$project$Components$BrokerDeal$EndModal$initFormFields = function (brokerDeal) {
	var endDate = A2(
		$elm$core$Maybe$andThen,
		$author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$endDate,
		$elm$core$List$head(brokerDeal._4));
	var _v0 = $author$project$Components$DateInput$init;
	var endDateDateInput = _v0.a;
	var endDateDateInputCmd = _v0.b;
	return _Utils_Tuple2(
		{sb: endDate, sc: endDateDateInput},
		A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Components$BrokerDeal$EndModal$EndDateDateInputMsg(endDateDateInput),
			endDateDateInputCmd));
};
var $author$project$Components$BrokerDeal$EndModal$init = F4(
	function (session, currentDate, options, brokerDeal) {
		var _v0 = $author$project$Components$BrokerDeal$EndModal$initFormFields(brokerDeal);
		var fields = _v0.a;
		var fieldsCmd = _v0.b;
		return _Utils_Tuple2(
			{
				MQ: brokerDeal,
				xX: options.xX,
				dd: currentDate,
				SD: $author$project$Utils$Form$init(fields),
				aa4: session,
				qP: $author$project$Api$Data$NotAsked
			},
			fieldsCmd);
	});
var $author$project$Components$BrokerDeal$RestartModal$init = F2(
	function (session, brokerDeal) {
		return {MQ: brokerDeal, uj: $author$project$Api$Data$NotAsked, aa4: session};
	});
var $author$project$Components$BrokerDealRate$CreateUpdateModal$Model = $elm$core$Basics$identity;
var $author$project$Components$BrokerDealRate$CreateUpdateModal$StartDateDateInputMsg = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Api$Provider$BrokerDealRate$Shared$pricingStructure = function (_v0) {
	var record = _v0;
	return record._l;
};
var $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$pricingStructure = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BrokerDealRate$Shared$pricingStructure(shared);
};
var $author$project$Api$Provider$BrokerDealRate$Shared$startDate = function (_v0) {
	var record = _v0;
	return record.ab7;
};
var $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$startDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BrokerDealRate$Shared$startDate(shared);
};
var $author$project$Components$BrokerDealRate$CreateUpdateModal$initFormFields = F2(
	function (brokerDeal, brokerDealRate) {
		var startDate = A2(
			$elm$core$Maybe$andThen,
			$author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$startDate,
			$elm$core$List$head(brokerDeal._4));
		var pricingStructure = $elm$core$Maybe$Just(
			A2(
				$author$project$Components$PricingStructureSelect$existingPricingStructure,
				$elm$core$Maybe$Nothing,
				A2(
					$elm$core$Maybe$map,
					$author$project$Api$Provider$PricingStructure$Shared$id,
					A2($elm$core$Maybe$map, $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$pricingStructure, brokerDealRate))));
		var _v0 = $author$project$Components$DateInput$init;
		var startDateDateInput = _v0.a;
		var startDateDateInputCmd = _v0.b;
		return _Utils_Tuple2(
			{_l: pricingStructure, ab7: startDate, uO: startDateDateInput},
			A2(
				$elm$core$Platform$Cmd$map,
				$author$project$Components$BrokerDealRate$CreateUpdateModal$StartDateDateInputMsg(startDateDateInput),
				startDateDateInputCmd));
	});
var $author$project$Components$BrokerDealRate$CreateUpdateModal$init = F5(
	function (apiClient, session, currentDate, brokerDeal, brokerDealRate) {
		var _v0 = $author$project$Components$PricingStructureSelect$init(apiClient);
		var pricingStructureSelect = _v0.a;
		var pricingStructureSelectCmd = _v0.b;
		var _v1 = A2($author$project$Components$BrokerDealRate$CreateUpdateModal$initFormFields, brokerDeal, brokerDealRate);
		var fields = _v1.a;
		var fieldsCmd = _v1.b;
		return _Utils_Tuple2(
			{
				MQ: brokerDeal,
				GM: brokerDealRate,
				dd: currentDate,
				SD: $author$project$Utils$Form$init(fields),
				pk: pricingStructureSelect,
				aa4: session,
				qP: $author$project$Api$Data$NotAsked
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						fieldsCmd,
						A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDealRate$CreateUpdateModal$PricingStructureSelectMsg, pricingStructureSelectCmd)
					])));
	});
var $author$project$Components$BrokerDeal$EndModal$BrokerDealEnded = 2;
var $author$project$Components$BrokerDeal$EndModal$Closed = 1;
var $author$project$Components$BrokerDeal$EndModal$EndDate = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$BrokerDeal$EndModal$Ended = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$BrokerDeal$EndModal$None = 0;
var $author$project$Api$Provider$BrokerDeal$end = F4(
	function (apiClient, id_, endDate_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'broker_deal',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'end_date',
								$author$project$Utils$Date$encode(endDate_))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$BrokerDeal$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['end']),
						$author$project$Api$Provider$BrokerDeal$brokerDealPath(id_)))));
	});
var $author$project$Components$BrokerDeal$EndModal$EndDateValidation = 0;
var $author$project$Components$BrokerDeal$EndModal$validateEndDate = F2(
	function (currentDate, fields) {
		var _v0 = fields.sb;
		if (!_v0.$) {
			var endDate = _v0.a;
			var yesterdayDate = A3($justinmimbs$date$Date$add, 3, -1, currentDate);
			return (A2($justinmimbs$date$Date$compare, yesterdayDate, endDate) !== 2) ? _List_Nil : _List_fromArray(
				[
					_Utils_Tuple2(0, 'Please enter a date greater or equal than yesterday')
				]);
		} else {
			return _List_fromArray(
				[
					_Utils_Tuple2(0, 'Please enter a date.')
				]);
		}
	});
var $author$project$Components$BrokerDeal$EndModal$formFieldsValidator = function (currentDate) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$BrokerDeal$EndModal$validateEndDate(currentDate))
			]));
};
var $author$project$Components$BrokerDeal$EndModal$formFieldsUpdate = F2(
	function (field, fields) {
		var dateInput = field.a;
		var date = field.b;
		return _Utils_update(
			fields,
			{sb: date, sc: dateInput});
	});
var $author$project$Components$BrokerDeal$EndModal$updateDateInputFormField = F6(
	function (model, dateInput, subMsg, toMsg, field, fieldGetter) {
		var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
		var newDateInput = _v0.a;
		var subCmd = _v0.b;
		var event = _v0.c;
		var newForm = function () {
			if (event.$ === 1) {
				var date = event.a;
				return A3(
					$author$project$Utils$Form$update,
					$author$project$Components$BrokerDeal$EndModal$formFieldsUpdate,
					A2(field, newDateInput, date),
					model.SD);
			} else {
				var fields = $author$project$Utils$Form$fields(model.SD);
				return A3(
					$author$project$Utils$Form$update,
					$author$project$Components$BrokerDeal$EndModal$formFieldsUpdate,
					A2(
						field,
						newDateInput,
						fieldGetter(fields)),
					model.SD);
			}
		}();
		return {
			GZ: A2(
				$elm$core$Platform$Cmd$map,
				toMsg(newDateInput),
				subCmd),
			agZ: 0,
			aiO: _Utils_update(
				model,
				{SD: newForm}),
			aR: _List_Nil
		};
	});
var $author$project$Components$BrokerDeal$EndModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 1:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: 1, aiO: model, aR: _List_Nil};
			case 0:
				var _v2 = A2(
					$author$project$Utils$Form$validate,
					$author$project$Components$BrokerDeal$EndModal$formFieldsValidator(model.dd),
					model.SD);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var newForm = _v3.a;
					var validFormFields = _v3.b;
					var _v4 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
					var endDate = _v4.sb;
					return {
						GZ: A4(
							$author$project$Api$Provider$BrokerDeal$end,
							apiClient,
							model.MQ.ahP,
							A2($elm$core$Maybe$withDefault, model.dd, endDate),
							$author$project$Components$BrokerDeal$EndModal$Ended),
						agZ: 0,
						aiO: _Utils_update(
							model,
							{SD: newForm, qP: $author$project$Api$Data$Loading}),
						aR: _List_Nil
					};
				} else {
					var newForm = _v2.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{SD: newForm}),
						aR: _List_Nil
					};
				}
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 2,
						aiO: model,
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Broker deal successfully ended')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{qP: $author$project$Api$Data$NotAsked}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			default:
				var dateInput = msg.a;
				var subMsg = msg.b;
				return A6(
					$author$project$Components$BrokerDeal$EndModal$updateDateInputFormField,
					model,
					dateInput,
					subMsg,
					$author$project$Components$BrokerDeal$EndModal$EndDateDateInputMsg,
					$author$project$Components$BrokerDeal$EndModal$EndDate,
					function ($) {
						return $.sb;
					});
		}
	});
var $author$project$Components$BrokerDeal$RestartModal$BrokerDealRestarted = 2;
var $author$project$Components$BrokerDeal$RestartModal$Closed = 1;
var $author$project$Components$BrokerDeal$RestartModal$None = 0;
var $author$project$Components$BrokerDeal$RestartModal$Restarted = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$BrokerDeal$restart = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$BrokerDeal$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['restart']),
					$author$project$Api$Provider$BrokerDeal$brokerDealPath(id_))));
	});
var $author$project$Components$BrokerDeal$RestartModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 1:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: 1, aiO: model, aR: _List_Nil};
			case 0:
				return {
					GZ: A3($author$project$Api$Provider$BrokerDeal$restart, apiClient, model.MQ.ahP, $author$project$Components$BrokerDeal$RestartModal$Restarted),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{uj: $author$project$Api$Data$Loading}),
					aR: _List_Nil
				};
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 2,
						aiO: model,
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Broker deal successfully restarted')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{uj: $author$project$Api$Data$NotAsked}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
		}
	});
var $author$project$Components$BrokerDealRate$CreateUpdateModal$BrokerDealRateCreated = 3;
var $author$project$Components$BrokerDealRate$CreateUpdateModal$BrokerDealRateUpdated = 2;
var $author$project$Components$BrokerDealRate$CreateUpdateModal$Closed = 1;
var $author$project$Components$BrokerDealRate$CreateUpdateModal$None = 0;
var $author$project$Components$BrokerDealRate$CreateUpdateModal$PricingStructure = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$BrokerDealRate$CreateUpdateModal$StartDate = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$BrokerDealRate$CreateUpdateModal$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var dateInput = field.a;
			var date = field.b;
			return _Utils_update(
				fields,
				{ab7: date, uO: dateInput});
		} else {
			var pricingStructure = field.a;
			return _Utils_update(
				fields,
				{_l: pricingStructure});
		}
	});
var $author$project$Components$BrokerDealRate$CreateUpdateModal$PricingStructureValidation = 1;
var $author$project$Components$BrokerDealRate$CreateUpdateModal$validatePricingStructure = function (fields) {
	var _v0 = fields._l;
	if (!_v0.$) {
		var pricingStructure = _v0.a;
		var _v1 = pricingStructure.ahP;
		if (!_v1.$) {
			return _List_Nil;
		} else {
			var _v2 = _Utils_Tuple3(pricingStructure.akg, pricingStructure.ajZ, pricingStructure.ahn);
			_v2$2:
			while (true) {
				if (!_v2.a.$) {
					switch (_v2.a.a.$) {
						case 0:
							if (_v2.b.$ === 1) {
								var _v3 = _v2.a.a;
								var _v4 = _v2.b;
								return _List_fromArray(
									[
										_Utils_Tuple2(1, 'Please enter a number')
									]);
							} else {
								break _v2$2;
							}
						case 1:
							if (_v2.c.$ === 1) {
								var _v5 = _v2.a.a;
								var _v6 = _v2.c;
								return _List_fromArray(
									[
										_Utils_Tuple2(1, 'Please enter an amount')
									]);
							} else {
								break _v2$2;
							}
						default:
							break _v2$2;
					}
				} else {
					break _v2$2;
				}
			}
			return _List_Nil;
		}
	} else {
		return _List_fromArray(
			[
				_Utils_Tuple2(1, 'Please pick or create a rate.')
			]);
	}
};
var $author$project$Components$BrokerDealRate$CreateUpdateModal$StartDateValidation = 0;
var $author$project$Components$BrokerDealRate$CreateUpdateModal$validateStartDate = F2(
	function (currentDate, fields) {
		var _v0 = fields.ab7;
		if (!_v0.$) {
			var startDate = _v0.a;
			var yesterdayDate = A3($justinmimbs$date$Date$add, 3, -1, currentDate);
			return (A2($justinmimbs$date$Date$compare, yesterdayDate, startDate) !== 2) ? _List_Nil : _List_fromArray(
				[
					_Utils_Tuple2(0, 'Please enter a date greater or equal than yesterday')
				]);
		} else {
			return _List_fromArray(
				[
					_Utils_Tuple2(0, 'Please enter a date.')
				]);
		}
	});
var $author$project$Components$BrokerDealRate$CreateUpdateModal$formFieldsValidator = function (currentDate) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$BrokerDealRate$CreateUpdateModal$validateStartDate(currentDate)),
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$BrokerDealRate$CreateUpdateModal$validatePricingStructure)
			]));
};
var $author$project$Components$BrokerDealRate$CreateUpdateModal$Created = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$BrokerDealRate$CreateUpdateModal$Updated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$BrokerDealRate$CreateUpdateModal$apiFields = F2(
	function (brokerDeal, formFields) {
		return {MQ: brokerDeal.ahP, _l: formFields._l, ab7: formFields.ab7};
	});
var $author$project$Api$Provider$BrokerDealRate$create = F3(
	function (apiClient, fields, toMsg) {
		var pricingStructure_ = function () {
			var _v0 = fields._l;
			if (_v0.$ === 1) {
				return _List_Nil;
			} else {
				var pricingStructure__ = _v0.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'pricing_structure',
						$elm$json$Json$Encode$object(
							$elm$core$List$concat(
								_List_fromArray(
									[
										function () {
										var _v1 = pricingStructure__.ahP;
										if (!_v1.$) {
											var string = _v1.a;
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'id',
													$elm$json$Json$Encode$string(string))
												]);
										} else {
											return _List_Nil;
										}
									}(),
										function () {
										var _v2 = pricingStructure__.Qr;
										if (!_v2.$) {
											var string = _v2.a;
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'description',
													$elm$json$Json$Encode$string(string))
												]);
										} else {
											return _List_Nil;
										}
									}(),
										function () {
										var _v3 = pricingStructure__.ahn;
										if (!_v3.$) {
											var _int = _v3.a;
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'fixed_amount_in_cents',
													$author$project$Currency$encode(_int))
												]);
										} else {
											return _List_Nil;
										}
									}(),
										function () {
										var _v4 = pricingStructure__.ajZ;
										if (!_v4.$) {
											var _float = _v4.a;
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'percentage',
													$author$project$Percentage$encode(_float))
												]);
										} else {
											return _List_Nil;
										}
									}(),
										function () {
										var _v5 = pricingStructure__.alD;
										if (!_v5.$) {
											var splitType = _v5.a;
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'split_type',
													$author$project$Api$SplitType$encode(splitType))
												]);
										} else {
											return _List_Nil;
										}
									}(),
										function () {
										var _v6 = pricingStructure__.akg;
										if (!_v6.$) {
											var pricingType_ = _v6.a;
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'pricing_type',
													$author$project$Api$PricingType$encode(pricingType_))
												]);
										} else {
											return _List_Nil;
										}
									}()
									]))))
					]);
			}
		}();
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'rate',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'broker_deal',
								$author$project$Utils$Encode$association(fields.MQ)),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'start_date',
									A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.ab7)),
								pricingStructure_))))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$BrokerDealRate$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$BrokerDealRate$brokerDealRatesPath)));
	});
var $author$project$Api$Provider$BrokerDealRate$update = F4(
	function (apiClient, id_, fields, toMsg) {
		var pricingStructure_ = function () {
			var _v0 = fields._l;
			if (_v0.$ === 1) {
				return _List_Nil;
			} else {
				var pricingStructure__ = _v0.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'pricing_structure',
						$elm$json$Json$Encode$object(
							$elm$core$List$concat(
								_List_fromArray(
									[
										function () {
										var _v1 = pricingStructure__.ahP;
										if (!_v1.$) {
											var string = _v1.a;
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'id',
													$elm$json$Json$Encode$string(string))
												]);
										} else {
											return _List_Nil;
										}
									}(),
										function () {
										var _v2 = pricingStructure__.Qr;
										if (!_v2.$) {
											var string = _v2.a;
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'description',
													$elm$json$Json$Encode$string(string))
												]);
										} else {
											return _List_Nil;
										}
									}(),
										function () {
										var _v3 = pricingStructure__.ahn;
										if (!_v3.$) {
											var _int = _v3.a;
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'fixed_amount_in_cents',
													$author$project$Currency$encode(_int))
												]);
										} else {
											return _List_Nil;
										}
									}(),
										function () {
										var _v4 = pricingStructure__.ajZ;
										if (!_v4.$) {
											var _float = _v4.a;
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'percentage',
													$author$project$Percentage$encode(_float))
												]);
										} else {
											return _List_Nil;
										}
									}(),
										function () {
										var _v5 = pricingStructure__.alD;
										if (!_v5.$) {
											var splitType = _v5.a;
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'split_type',
													$author$project$Api$SplitType$encode(splitType))
												]);
										} else {
											return _List_Nil;
										}
									}(),
										function () {
										var _v6 = pricingStructure__.akg;
										if (!_v6.$) {
											var pricingType_ = _v6.a;
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'pricing_type',
													$author$project$Api$PricingType$encode(pricingType_))
												]);
										} else {
											return _List_Nil;
										}
									}()
									]))))
					]);
			}
		}();
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'rate',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'broker_deal',
								$author$project$Utils$Encode$association(fields.MQ)),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'start_date',
									A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.ab7)),
								pricingStructure_))))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$BrokerDealRate$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$BrokerDealRate$brokerDealRatePath(id_))));
	});
var $author$project$Components$BrokerDealRate$CreateUpdateModal$save = F4(
	function (apiClient, brokerDeal, brokerDealRate, validFormFields) {
		var apiFields_ = A2(
			$author$project$Components$BrokerDealRate$CreateUpdateModal$apiFields,
			brokerDeal,
			$rtfeldman$elm_validate$Validate$fromValid(validFormFields));
		if (!brokerDealRate.$) {
			var brokerDealRate_ = brokerDealRate.a;
			return A4(
				$author$project$Api$Provider$BrokerDealRate$update,
				apiClient,
				$author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$id(brokerDealRate_),
				apiFields_,
				$author$project$Components$BrokerDealRate$CreateUpdateModal$Updated);
		} else {
			return A3($author$project$Api$Provider$BrokerDealRate$create, apiClient, apiFields_, $author$project$Components$BrokerDealRate$CreateUpdateModal$Created);
		}
	});
var $author$project$Components$BrokerDealRate$CreateUpdateModal$updateDateInputFormField = F6(
	function (model, dateInput, subMsg, toMsg, field, fieldGetter) {
		var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
		var newDateInput = _v0.a;
		var subCmd = _v0.b;
		var event = _v0.c;
		var newForm = function () {
			if (event.$ === 1) {
				var date = event.a;
				return A3(
					$author$project$Utils$Form$update,
					$author$project$Components$BrokerDealRate$CreateUpdateModal$formFieldsUpdate,
					A2(field, newDateInput, date),
					model.SD);
			} else {
				var fields = $author$project$Utils$Form$fields(model.SD);
				return A3(
					$author$project$Utils$Form$update,
					$author$project$Components$BrokerDealRate$CreateUpdateModal$formFieldsUpdate,
					A2(
						field,
						newDateInput,
						fieldGetter(fields)),
					model.SD);
			}
		}();
		return {
			GZ: A2(
				$elm$core$Platform$Cmd$map,
				toMsg(newDateInput),
				subCmd),
			agZ: 0,
			aiO: _Utils_update(
				model,
				{SD: newForm}),
			aR: _List_Nil
		};
	});
var $author$project$Components$BrokerDealRate$CreateUpdateModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 1:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: 1, aiO: model, aR: _List_Nil};
			case 0:
				var _v2 = A2(
					$author$project$Utils$Form$validate,
					$author$project$Components$BrokerDealRate$CreateUpdateModal$formFieldsValidator(model.dd),
					model.SD);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var newForm = _v3.a;
					var validFormFields = _v3.b;
					return {
						GZ: A4($author$project$Components$BrokerDealRate$CreateUpdateModal$save, apiClient, model.MQ, model.GM, validFormFields),
						agZ: 0,
						aiO: _Utils_update(
							model,
							{SD: newForm, qP: $author$project$Api$Data$Loading}),
						aR: _List_Nil
					};
				} else {
					var newForm = _v2.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{SD: newForm}),
						aR: _List_Nil
					};
				}
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 3,
						aiO: model,
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Broker deal rate successfully added')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{qP: $author$project$Api$Data$NotAsked}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 2,
						aiO: model,
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Broker deal rate successfully updated')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{qP: $author$project$Api$Data$NotAsked}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 4:
				var dateInput = msg.a;
				var subMsg = msg.b;
				return A6(
					$author$project$Components$BrokerDealRate$CreateUpdateModal$updateDateInputFormField,
					model,
					dateInput,
					subMsg,
					$author$project$Components$BrokerDealRate$CreateUpdateModal$StartDateDateInputMsg,
					$author$project$Components$BrokerDealRate$CreateUpdateModal$StartDate,
					function ($) {
						return $.ab7;
					});
			default:
				var subMsg = msg.a;
				var pricingStructureSelectResult = A2($author$project$Components$PricingStructureSelect$update, subMsg, model.pk);
				var form = function () {
					var _v6 = pricingStructureSelectResult.agZ;
					if (!_v6.$) {
						return model.SD;
					} else {
						var pricingStructure = _v6.a;
						return A3(
							$author$project$Utils$Form$update,
							$author$project$Components$BrokerDealRate$CreateUpdateModal$formFieldsUpdate,
							$author$project$Components$BrokerDealRate$CreateUpdateModal$PricingStructure(pricingStructure),
							model.SD);
					}
				}();
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDealRate$CreateUpdateModal$PricingStructureSelectMsg, pricingStructureSelectResult.GZ),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{SD: form, pk: pricingStructureSelectResult.aiO}),
					aR: pricingStructureSelectResult.aR
				};
		}
	});
var $author$project$Components$BrokerDeal$Timeline$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							f7: $elm$core$Maybe$Just($author$project$Api$Data$NotAsked)
						}),
					aR: _List_Nil
				};
			case 1:
				var confirmed = msg.a;
				return confirmed ? {
					GZ: A3($author$project$Api$Provider$BrokerDeal$delete, apiClient, model.MQ.ahP, $author$project$Components$BrokerDeal$Timeline$Deleted),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							f7: $elm$core$Maybe$Just($author$project$Api$Data$Loading)
						}),
					aR: _List_Nil
				} : {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{f7: $elm$core$Maybe$Nothing}),
					aR: _List_Nil
				};
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 1,
						aiO: _Utils_update(
							model,
							{f7: $elm$core$Maybe$Nothing}),
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Broker deal successfully deleted')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{
								f7: $elm$core$Maybe$Just(response)
							}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 3:
				var _v2 = A5($author$project$Components$BrokerDealRate$CreateUpdateModal$init, apiClient, model.aa4, model.dd, model.MQ, $elm$core$Maybe$Nothing);
				var brokerDealRateModal = _v2.a;
				var brokerDealRateModalCmd = _v2.b;
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$Timeline$BrokerDealRateModalMsg, brokerDealRateModalCmd),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							fQ: $elm$core$Maybe$Just(brokerDealRateModal)
						}),
					aR: _List_Nil
				};
			case 4:
				var brokerDealRate = msg.a;
				var _v3 = A5(
					$author$project$Components$BrokerDealRate$CreateUpdateModal$init,
					apiClient,
					model.aa4,
					model.dd,
					model.MQ,
					$elm$core$Maybe$Just(brokerDealRate));
				var brokerDealRateModal = _v3.a;
				var brokerDealRateModalCmd = _v3.b;
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$Timeline$BrokerDealRateModalMsg, brokerDealRateModalCmd),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							fQ: $elm$core$Maybe$Just(brokerDealRateModal)
						}),
					aR: _List_Nil
				};
			case 5:
				var subMsg = msg.a;
				var _v4 = model.fQ;
				if (!_v4.$) {
					var brokerDealRateModal = _v4.a;
					var brokerDealRateModalResult = A3($author$project$Components$BrokerDealRate$CreateUpdateModal$update, apiClient, subMsg, brokerDealRateModal);
					var _v5 = function () {
						var _v6 = brokerDealRateModalResult.agZ;
						switch (_v6) {
							case 0:
								return _Utils_Tuple2(
									$elm$core$Maybe$Just(brokerDealRateModalResult.aiO),
									0);
							case 1:
								return _Utils_Tuple2($elm$core$Maybe$Nothing, 0);
							case 3:
								return _Utils_Tuple2($elm$core$Maybe$Nothing, 5);
							default:
								return _Utils_Tuple2($elm$core$Maybe$Nothing, 6);
						}
					}();
					var brokerDealRateModal_ = _v5.a;
					var event = _v5.b;
					return {
						GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$Timeline$BrokerDealRateModalMsg, brokerDealRateModalResult.GZ),
						agZ: event,
						aiO: _Utils_update(
							model,
							{fQ: brokerDealRateModal_}),
						aR: brokerDealRateModalResult.aR
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
			case 6:
				var brokerDealRate = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							fR: $elm$core$Maybe$Just(
								_Utils_Tuple2(brokerDealRate, $author$project$Api$Data$NotAsked))
						}),
					aR: _List_Nil
				};
			case 7:
				var brokerDealRate = msg.a;
				var confirmed = msg.b;
				return confirmed ? {
					GZ: A3(
						$author$project$Api$Provider$BrokerDealRate$cancel,
						apiClient,
						$author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$id(brokerDealRate),
						$author$project$Components$BrokerDeal$Timeline$Canceled(brokerDealRate)),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							fR: $elm$core$Maybe$Just(
								_Utils_Tuple2(brokerDealRate, $author$project$Api$Data$Loading))
						}),
					aR: _List_Nil
				} : {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{fR: $elm$core$Maybe$Nothing}),
					aR: _List_Nil
				};
			case 8:
				var brokerDealRate = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 4,
						aiO: model,
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Rate successfully canceled')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{
								fR: $elm$core$Maybe$Just(
									_Utils_Tuple2(brokerDealRate, response))
							}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 9:
				var _v8 = A4(
					$author$project$Components$BrokerDeal$EndModal$init,
					model.aa4,
					model.dd,
					{xX: true},
					model.MQ);
				var endModal = _v8.a;
				var endModalCmd = _v8.b;
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$Timeline$EndModalMsg, endModalCmd),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							gm: $elm$core$Maybe$Just(endModal)
						}),
					aR: _List_Nil
				};
			case 10:
				var _v9 = A4(
					$author$project$Components$BrokerDeal$EndModal$init,
					model.aa4,
					model.dd,
					{xX: false},
					model.MQ);
				var endModal = _v9.a;
				var endModalCmd = _v9.b;
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$Timeline$EndModalMsg, endModalCmd),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							gm: $elm$core$Maybe$Just(endModal)
						}),
					aR: _List_Nil
				};
			case 11:
				var subMsg = msg.a;
				var _v10 = model.gm;
				if (!_v10.$) {
					var endModal = _v10.a;
					var endModalResult = A3($author$project$Components$BrokerDeal$EndModal$update, apiClient, subMsg, endModal);
					var _v11 = function () {
						var _v12 = endModalResult.agZ;
						switch (_v12) {
							case 0:
								return _Utils_Tuple2(
									$elm$core$Maybe$Just(endModalResult.aiO),
									0);
							case 1:
								return _Utils_Tuple2($elm$core$Maybe$Nothing, 0);
							default:
								return _Utils_Tuple2($elm$core$Maybe$Nothing, 3);
						}
					}();
					var endModal_ = _v11.a;
					var event = _v11.b;
					return {
						GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$Timeline$EndModalMsg, endModalResult.GZ),
						agZ: event,
						aiO: _Utils_update(
							model,
							{gm: endModal_}),
						aR: endModalResult.aR
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
			case 12:
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							k0: $elm$core$Maybe$Just(
								A2($author$project$Components$BrokerDeal$RestartModal$init, model.aa4, model.MQ))
						}),
					aR: _List_Nil
				};
			default:
				var subMsg = msg.a;
				var _v13 = model.k0;
				if (!_v13.$) {
					var restartModal = _v13.a;
					var restartModalResult = A3($author$project$Components$BrokerDeal$RestartModal$update, apiClient, subMsg, restartModal);
					var _v14 = function () {
						var _v15 = restartModalResult.agZ;
						switch (_v15) {
							case 0:
								return _Utils_Tuple2(
									$elm$core$Maybe$Just(restartModalResult.aiO),
									0);
							case 1:
								return _Utils_Tuple2($elm$core$Maybe$Nothing, 0);
							default:
								return _Utils_Tuple2($elm$core$Maybe$Nothing, 2);
						}
					}();
					var restartModal_ = _v14.a;
					var event = _v14.b;
					return {
						GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$Timeline$RestartModalMsg, restartModalResult.GZ),
						agZ: event,
						aiO: _Utils_update(
							model,
							{k0: restartModal_}),
						aR: restartModalResult.aR
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
		}
	});
var $author$project$Components$BrokerDeal$Timeline$init = F4(
	function (session, currentDate, options, brokerDeal) {
		return {MQ: brokerDeal, fQ: $elm$core$Maybe$Nothing, fR: $elm$core$Maybe$Nothing, dd: currentDate, f7: $elm$core$Maybe$Nothing, gm: $elm$core$Maybe$Nothing, k0: $elm$core$Maybe$Nothing, aa4: session, alu: options.alu};
	});
var $author$project$Components$BrokerDeal$Table$withBrokerDeals = F2(
	function (brokerDeals, model) {
		return _Utils_update(
			model,
			{
				MR: A2(
					$elm$core$List$indexedMap,
					F2(
						function (index, brokerDeal) {
							var showEndedOnTimeline = A2($elm$core$Set$member, index, model.hE);
							return _Utils_Tuple2(
								brokerDeal,
								A4(
									$author$project$Components$BrokerDeal$Timeline$init,
									model.aa4,
									model.dd,
									{alu: model.ny || showEndedOnTimeline},
									brokerDeal));
						}),
					brokerDeals)
			});
	});
var $author$project$Components$BrokerDeal$Table$update = F3(
	function (apiClient, msg, model) {
		if (!msg.$) {
			var index = msg.a;
			return {
				GZ: $elm$core$Platform$Cmd$none,
				agZ: 0,
				aiO: function (deals) {
					var showEndedOnTimeline = A2($elm$core$Set$member, index, model.hE) ? A2($elm$core$Set$remove, index, model.hE) : A2($elm$core$Set$insert, index, model.hE);
					return A2(
						$author$project$Components$BrokerDeal$Table$withBrokerDeals,
						deals,
						_Utils_update(
							model,
							{hE: showEndedOnTimeline}));
				}(
					A2($elm$core$List$map, $elm$core$Tuple$first, model.MR)),
				aR: _List_Nil
			};
		} else {
			var index = msg.a;
			var subMsg = msg.b;
			var _v1 = A2($elm_community$list_extra$List$Extra$getAt, index, model.MR);
			if (!_v1.$) {
				var _v2 = _v1.a;
				var brokerDeal = _v2.a;
				var timeline = _v2.b;
				var timelineResult = A3($author$project$Components$BrokerDeal$Timeline$update, apiClient, subMsg, timeline);
				var event = function () {
					var _v3 = timelineResult.agZ;
					switch (_v3) {
						case 0:
							return 0;
						case 1:
							return 1;
						case 2:
							return 2;
						case 3:
							return 3;
						case 4:
							return 4;
						case 5:
							return 5;
						default:
							return 6;
					}
				}();
				return {
					GZ: A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Components$BrokerDeal$Table$TimelineMsg(index),
						timelineResult.GZ),
					agZ: event,
					aiO: _Utils_update(
						model,
						{
							MR: A3(
								$elm_community$list_extra$List$Extra$setAt,
								index,
								_Utils_Tuple2(brokerDeal, timelineResult.aiO),
								model.MR)
						}),
					aR: timelineResult.aR
				};
			} else {
				return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
			}
		}
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{xG: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var response = msg.a;
				if (response.$ === 3) {
					var brokerDeals = response.a;
					var headers = response.b;
					var brokerDealsTable = A2(
						$author$project$Components$BrokerDeal$Table$withBrokerDeals,
						A2($elm$core$List$map, $author$project$Components$BrokerDeal$BrokerDealRecord$fromProviderAll, brokerDeals),
						model.d_);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								MR: response,
								d_: brokerDealsTable,
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{MR: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 2:
				var subMsg = msg.a;
				var brokerDealsTableResult = A3($author$project$Components$BrokerDeal$Table$update, model.Gv, subMsg, model.d_);
				var _v2 = function () {
					var _v3 = brokerDealsTableResult.agZ;
					switch (_v3) {
						case 0:
							return _Utils_Tuple2(model.MR, $elm$core$Platform$Cmd$none);
						case 1:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$fetchBrokerDeals(model));
						case 2:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$fetchBrokerDeals(model));
						case 3:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$fetchBrokerDeals(model));
						case 4:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$fetchBrokerDeals(model));
						case 5:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$fetchBrokerDeals(model));
						default:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$fetchBrokerDeals(model));
					}
				}();
				var brokerDeals = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{MR: brokerDeals, d_: brokerDealsTableResult.aiO}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$BrokerDealsTableMsg, brokerDealsTableResult.GZ),
								cmd
							])),
					brokerDealsTableResult.aR);
			case 3:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$fetchBrokerDeals(newModel),
								A2($elm$core$Basics$composeR, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 5:
				var subMsg = msg.a;
				var _v4 = A2($author$project$Ui$Dropdown$update, subMsg, model.qI);
				var typeDropdown = _v4.a;
				var cmd = _v4.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qI: typeDropdown}),
					cmd,
					_List_Nil);
			case 6:
				var selectedType = msg.a;
				var newModel = _Utils_update(
					model,
					{
						MR: $author$project$Api$Data$Loading,
						ajJ: $author$project$Api$Pagination$reset(model.ajJ),
						amg: selectedType
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$fetchBrokerDeals(newModel),
								A2($elm$core$Basics$composeR, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 7:
				var subMsg = msg.a;
				var brokerResourceResult = A3($author$project$Components$ResourceFilter$Broker$update, model.Gv, subMsg, model.mx);
				var brokerId = function () {
					var _v6 = brokerResourceResult.agZ;
					if (!_v6.$) {
						return $author$project$Components$ResourceFilter$Broker$value(brokerResourceResult.aiO);
					} else {
						return model.GN;
					}
				}();
				var newModel = _Utils_update(
					model,
					{GN: brokerId, mx: brokerResourceResult.aiO});
				var _v5 = _Utils_eq(model.GN, newModel.GN) ? _Utils_Tuple2(model.MR, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					$author$project$Api$Data$Loading,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$fetchBrokerDeals(newModel),
								A2($elm$core$Basics$composeR, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])));
				var brokerDeals = _v5.a;
				var cmd = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{MR: brokerDeals}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$BrokerResourceFilterMsg, brokerResourceResult.GZ),
								cmd
							])),
					brokerResourceResult.aR);
			case 4:
				var subMsg = msg.a;
				var _v7 = A2($author$project$Ui$SearchInput$update, subMsg, model.up);
				var searchInput = _v7.a;
				var searchInputCmd = _v7.b;
				var searchInputEvent = _v7.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.akl;
					}
				}();
				var _v8 = function () {
					if (_Utils_eq(q, model.akl)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								MR: $author$project$Api$Data$Loading,
								ajJ: $author$project$Api$Pagination$reset(model.ajJ),
								akl: q
							});
						return _Utils_Tuple2(
							qModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$fetchBrokerDeals(qModel),
										A2($elm$core$Basics$composeR, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$buildUrl, $author$project$Ports$Navigation$pushUrl)(qModel)
									])));
					}
				}();
				var newModel = _v8.a;
				var cmd = _v8.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{up: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
			case 8:
				var brokerAccount = msg.a;
				var _v10 = A5(
					$author$project$Components$BrokerDeal$CreateModal$init,
					model.Gv,
					model.aa4,
					model.dd,
					model.J8,
					{
						xF: $elm$core$Maybe$Nothing,
						xG: $elm$core$Maybe$Just(
							$author$project$Api$Provider$BrokerAccount$One$id(brokerAccount)),
						N7: $author$project$Api$Provider$Practice$One$commissionsTrackingFrom(model.ZV),
						afQ: $elm$core$Maybe$Nothing,
						PT: 0,
						kk: $elm$core$Maybe$Nothing,
						ak0: $author$project$Api$Provider$BrokerAccount$One$retailEnabled(brokerAccount)
					});
				var createModal = _v10.a;
				var createModalCmd = _v10.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							iX: $elm$core$Maybe$Just(createModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$CreateModalMsg, createModalCmd),
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v11 = model.iX;
				if (!_v11.$) {
					var createModal = _v11.a;
					var createModalResult = A3($author$project$Components$BrokerDeal$CreateModal$update, model.Gv, subMsg, createModal);
					var _v12 = function () {
						var _v13 = createModalResult.agZ;
						switch (_v13) {
							case 0:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(createModalResult.aiO),
									model.MR,
									$elm$core$Platform$Cmd$none);
							case 1:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.MR, $elm$core$Platform$Cmd$none);
							case 2:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Api$Data$Loading,
									$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$fetchBrokerDeals(model));
							default:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Api$Data$Loading,
									$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$fetchBrokerDeals(model));
						}
					}();
					var createModal_ = _v12.a;
					var brokerDeals = _v12.b;
					var cmd = _v12.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{MR: brokerDeals, iX: createModal_}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$CreateModalMsg, createModalResult.GZ),
									cmd
								])),
						createModalResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$Create = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$PaginationMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$BrokerDeal$Table$loading = $author$project$Ui$Table$loading;
var $author$project$Components$BrokerDeal$EndModal$End = {$: 0};
var $author$project$Components$BrokerDeal$EndModal$view = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.SD);
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$BrokerDeal$EndModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title(
						model.xX ? 'Edit Employer Deal' : 'End Employer Deal')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$onSubmit($author$project$Components$BrokerDeal$EndModal$End)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Employer name'),
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(8)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Static$view,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2(
													$elm$core$Maybe$withDefault,
													'',
													A2($elm$core$Maybe$map, $author$project$Api$Provider$Company$Shared$name, model.MQ.afQ)))
											]))
									])),
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Broker name'),
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(8)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Static$view,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Api$Provider$Broker$Shared$name(model.MQ.xF))
											]))
									])),
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Date'),
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(8),
										$author$project$Ui$Form$Group$required(true)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Components$BrokerDeal$EndModal$EndDateDateInputMsg(fields.sc),
										A2(
											$author$project$Components$DateInput$view,
											_List_fromArray(
												[
													$author$project$Components$DateInput$value(fields.sb),
													$author$project$Components$DateInput$invalid(
													A2($author$project$Utils$Form$hasValidationErrors, 0, model.SD)),
													$author$project$Components$DateInput$errors(
													A2($author$project$Utils$Form$validationErrors, 0, model.SD))
												]),
											fields.sc)),
										A2(
										$author$project$Ui$Element$view,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$text,
												_List_fromArray(
													[$author$project$Ui$Typography$helpBlock]),
												'Ending this employer deal will stop commissions from being calculated on the date specified. If any future calculations exist they will be removed or reversed.')
											]))
									]))
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$BrokerDeal$EndModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'End broker deal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$loading(
								_Utils_eq(model.qP, $author$project$Api$Data$Loading)),
								$author$project$Ui$Button$onClick($author$project$Components$BrokerDeal$EndModal$End)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('End')
							]))
					]))
			]));
};
var $author$project$Components$BrokerDeal$RestartModal$Restart = {$: 0};
var $author$project$Api$Provider$BrokerDealRate$Shared$description = function (_v0) {
	var record = _v0;
	return record.Qr;
};
var $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$description = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BrokerDealRate$Shared$description(shared);
};
var $author$project$Components$BrokerDeal$RestartModal$view = function (model) {
	var rateDescription = A2(
		$elm$core$Maybe$map,
		$author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$description,
		$elm$core$List$head(model.MQ._4));
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$BrokerDeal$RestartModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Restart employer deal')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$onSubmit($author$project$Components$BrokerDeal$RestartModal$Restart)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Employer name'),
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(8)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Static$view,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2(
													$elm$core$Maybe$withDefault,
													'',
													A2($elm$core$Maybe$map, $author$project$Api$Provider$Company$Shared$name, model.MQ.afQ)))
											]))
									])),
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Rate'),
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(8)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Static$view,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2($elm$core$Maybe$withDefault, '', rateDescription))
											])),
										A2(
										$author$project$Ui$Element$view,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$text,
												_List_fromArray(
													[$author$project$Ui$Typography$helpBlock]),
												'Restarting this broker on this deal will create all missing commission calculations for the entire life of the deal.')
											]))
									]))
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$BrokerDeal$RestartModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Restart broker deal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$loading(
								_Utils_eq(model.uj, $author$project$Api$Data$Loading)),
								$author$project$Ui$Button$onClick($author$project$Components$BrokerDeal$RestartModal$Restart)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Restart')
							]))
					]))
			]));
};
var $author$project$Components$BrokerDealRate$CreateUpdateModal$Save = {$: 0};
var $author$project$Components$PricingStructureSelect$Errors = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$PricingStructureSelect$errors = $author$project$Components$PricingStructureSelect$Errors;
var $author$project$Components$PricingStructureSelect$Invalid = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$PricingStructureSelect$invalid = $author$project$Components$PricingStructureSelect$Invalid;
var $author$project$Components$PricingStructureSelect$Value = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$PricingStructureSelect$value = $author$project$Components$PricingStructureSelect$Value;
var $author$project$Components$PricingStructureSelect$defaultOptions = {agX: _List_Nil, nZ: 8, sM: false, of: 4, aee: $elm$core$Maybe$Nothing};
var $author$project$Components$PricingStructureSelect$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var span = option.a;
						return _Utils_update(
							record,
							{of: span});
					case 1:
						var span = option.a;
						return _Utils_update(
							record,
							{nZ: span});
					case 2:
						var string = option.a;
						return _Utils_update(
							record,
							{aee: string});
					case 3:
						var bool = option.a;
						return _Utils_update(
							record,
							{sM: bool});
					default:
						var list = option.a;
						return _Utils_update(
							record,
							{agX: list});
				}
			}),
		$author$project$Components$PricingStructureSelect$defaultOptions,
		options);
};
var $author$project$Components$PricingStructureSelect$NewPricingStructureUpdated = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$PricingStructureSelect$SplitType = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$PricingStructureSelect$viewSplitTypeButton = F3(
	function (pricingStructure, splitType, label) {
		var currentSplitType = A2($elm$core$Maybe$withDefault, 0, pricingStructure.alD);
		return A3(
			$author$project$Ui$Button$view,
			{mm: label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(currentSplitType, splitType)),
					$author$project$Ui$Button$onClick(
					A2(
						$author$project$Components$PricingStructureSelect$NewPricingStructureUpdated,
						pricingStructure,
						$author$project$Components$PricingStructureSelect$SplitType(splitType)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Components$PricingStructureSelect$viewCommissionType = F3(
	function (optionsRecord, model, value_) {
		return model.ih ? A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Commission Type'),
					$author$project$Ui$Form$Group$labelSpan(optionsRecord.of),
					$author$project$Ui$Form$Group$inputSpan(optionsRecord.nZ)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Button$group(
					_List_fromArray(
						[
							A3($author$project$Components$PricingStructureSelect$viewSplitTypeButton, value_, 0, 'All members'),
							A3($author$project$Components$PricingStructureSelect$viewSplitTypeButton, value_, 1, 'Primary member')
						]))
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Components$PricingStructureSelect$PricingStructureSelected = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$PricingStructureSelect$viewRateDropdown = F4(
	function (optionsRecord, model, loadingPricingStructures, pricingStructures) {
		var currentSelection = model.ih ? $elm$core$Maybe$Just('') : A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.ahP;
			},
			optionsRecord.aee);
		var items = function () {
			if (loadingPricingStructures) {
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Dropdown$item,
						_List_Nil,
						$elm$html$Html$text('Loading...'))
					]);
			} else {
				var addNewItem = A2(
					$author$project$Ui$Dropdown$item,
					_List_fromArray(
						[
							$author$project$Ui$Dropdown$onSelect(
							$author$project$Components$PricingStructureSelect$PricingStructureSelected(
								$elm$core$Maybe$Just(''))),
							$author$project$Ui$Dropdown$selected(
							_Utils_eq(
								currentSelection,
								$elm$core$Maybe$Just('')))
						]),
					$elm$html$Html$text('Add new commission rate'));
				if ($elm$core$List$isEmpty(pricingStructures)) {
					return _List_fromArray(
						[addNewItem]);
				} else {
					var pricingStructureItems = A2(
						$elm$core$List$map,
						function (ps) {
							return A2(
								$author$project$Ui$Dropdown$item,
								_List_fromArray(
									[
										$author$project$Ui$Dropdown$onSelect(
										$author$project$Components$PricingStructureSelect$PricingStructureSelected(
											$elm$core$Maybe$Just(
												$author$project$Api$Provider$PricingStructure$All$id(ps)))),
										$author$project$Ui$Dropdown$selected(
										_Utils_eq(
											currentSelection,
											$elm$core$Maybe$Just(
												$author$project$Api$Provider$PricingStructure$All$id(ps))))
									]),
								$elm$html$Html$text(
									$author$project$Api$Provider$PricingStructure$All$description(ps)));
						},
						pricingStructures);
					return A2(
						$elm$core$List$cons,
						addNewItem,
						A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, pricingStructureItems));
				}
			}
		}();
		var currentLabel = function () {
			if (!currentSelection.$) {
				if (currentSelection.a === '') {
					return 'Add new commission rate';
				} else {
					var id = currentSelection.a;
					return A2(
						$elm$core$Maybe$withDefault,
						'Choose broker commission rate',
						A2(
							$elm$core$Maybe$map,
							$author$project$Api$Provider$PricingStructure$All$description,
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (ps) {
									return _Utils_eq(
										$author$project$Api$Provider$PricingStructure$All$id(ps),
										id);
								},
								pricingStructures)));
				}
			} else {
				return 'Choose broker commission rate';
			}
		}();
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Rate'),
					$author$project$Ui$Form$Group$labelSpan(optionsRecord.of),
					$author$project$Ui$Form$Group$inputSpan(optionsRecord.nZ),
					$author$project$Ui$Form$Group$required(true)
				]),
			_List_fromArray(
				[
					A4(
					$author$project$Ui$Dropdown$viewSelect,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(currentLabel)
						]),
					items,
					model.nm),
					(!model.ih) ? $author$project$Utils$FormErrors$view(optionsRecord.agX) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$PricingStructureSelect$FixedAmountInCents = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$PricingStructureSelect$Percentage = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$PricingStructureSelect$PricingType = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$PricingStructureSelect$viewPricingTypeButton = F3(
	function (pricingStructure, pricingType, label) {
		var currentPricingType = A2($elm$core$Maybe$withDefault, $author$project$Api$PricingType$Percentage, pricingStructure.akg);
		return A3(
			$author$project$Ui$Button$view,
			{mm: label},
			_List_fromArray(
				[
					$author$project$Ui$Button$styled(
					_Utils_eq(currentPricingType, pricingType) ? 1 : 0),
					$author$project$Ui$Button$onClick(
					A2(
						$author$project$Components$PricingStructureSelect$NewPricingStructureUpdated,
						pricingStructure,
						$author$project$Components$PricingStructureSelect$PricingType(pricingType)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Components$PricingStructureSelect$viewRetailRate = F3(
	function (optionsRecord, model, value_) {
		return model.ih ? A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Retail Rate'),
					$author$project$Ui$Form$Group$labelSpan(optionsRecord.of),
					$author$project$Ui$Form$Group$inputSpan(optionsRecord.nZ),
					$author$project$Ui$Form$Group$required(true)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$mr2]),
							_List_fromArray(
								[
									$author$project$Ui$Button$group(
									_List_fromArray(
										[
											A3($author$project$Components$PricingStructureSelect$viewPricingTypeButton, value_, $author$project$Api$PricingType$FixedAmountInCents, '$'),
											A3($author$project$Components$PricingStructureSelect$viewPricingTypeButton, value_, $author$project$Api$PricingType$Percentage, '%')
										]))
								])),
							_Utils_eq(
							value_.akg,
							$elm$core$Maybe$Just($author$project$Api$PricingType$FixedAmountInCents)) ? $author$project$Ui$Form$CurrencyInput$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$CurrencyInput$value(value_.ahn),
									$author$project$Ui$Form$CurrencyInput$onInput(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Components$PricingStructureSelect$NewPricingStructureUpdated(value_),
										$author$project$Components$PricingStructureSelect$FixedAmountInCents)),
									$author$project$Ui$Form$CurrencyInput$invalid(optionsRecord.sM),
									$author$project$Ui$Form$CurrencyInput$placeholder('10.00')
								])) : $author$project$Ui$Form$PercentageInput$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$PercentageInput$value(value_.ajZ),
									$author$project$Ui$Form$PercentageInput$onInput(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Components$PricingStructureSelect$NewPricingStructureUpdated(value_),
										$author$project$Components$PricingStructureSelect$Percentage)),
									$author$project$Ui$Form$PercentageInput$invalid(optionsRecord.sM),
									$author$project$Ui$Form$PercentageInput$placeholder('10')
								]))
						])),
					$author$project$Utils$FormErrors$view(optionsRecord.agX)
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Components$PricingStructureSelect$view = F2(
	function (options, model) {
		var optionsRecord = $author$project$Components$PricingStructureSelect$optionsToRecord(options);
		var value_ = A2($elm$core$Maybe$withDefault, $author$project$Components$PricingStructureSelect$newPricingStructure, optionsRecord.aee);
		var _v0 = function () {
			var _v1 = model.t3;
			if (_v1.$ === 3) {
				var pricingStructures_ = _v1.a;
				return _Utils_Tuple2(false, pricingStructures_);
			} else {
				return _Utils_Tuple2(true, _List_Nil);
			}
		}();
		var loadingPricingStructures = _v0.a;
		var pricingStructures = _v0.b;
		return _List_fromArray(
			[
				A4($author$project$Components$PricingStructureSelect$viewRateDropdown, optionsRecord, model, loadingPricingStructures, pricingStructures),
				A3($author$project$Components$PricingStructureSelect$viewCommissionType, optionsRecord, model, value_),
				A3($author$project$Components$PricingStructureSelect$viewRetailRate, optionsRecord, model, value_)
			]);
	});
var $author$project$Components$BrokerDealRate$CreateUpdateModal$view = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.SD);
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$BrokerDealRate$CreateUpdateModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Change employer deal')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$onSubmit($author$project$Components$BrokerDealRate$CreateUpdateModal$Save)
							]),
						$elm$core$List$concat(
							_List_fromArray(
								[
									_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$label('Employer name'),
												$author$project$Ui$Form$Group$labelSpan(4),
												$author$project$Ui$Form$Group$inputSpan(8)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Static$view,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2(
															$elm$core$Maybe$withDefault,
															'',
															A2($elm$core$Maybe$map, $author$project$Api$Provider$Company$Shared$name, model.MQ.afQ)))
													]))
											]))
									]),
									A2(
									$elm$core$List$map,
									$elm$html$Html$map($author$project$Components$BrokerDealRate$CreateUpdateModal$PricingStructureSelectMsg),
									A2(
										$author$project$Components$PricingStructureSelect$view,
										_List_fromArray(
											[
												$author$project$Components$PricingStructureSelect$value(fields._l),
												$author$project$Components$PricingStructureSelect$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, 1, model.SD)),
												$author$project$Components$PricingStructureSelect$errors(
												A2($author$project$Utils$Form$validationErrors, 1, model.SD))
											]),
										model.pk)),
									_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$label('Date'),
												$author$project$Ui$Form$Group$labelSpan(4),
												$author$project$Ui$Form$Group$inputSpan(8),
												$author$project$Ui$Form$Group$required(true)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Components$BrokerDealRate$CreateUpdateModal$StartDateDateInputMsg(fields.uO),
												A2(
													$author$project$Components$DateInput$view,
													_List_fromArray(
														[
															$author$project$Components$DateInput$value(fields.ab7),
															$author$project$Components$DateInput$invalid(
															A2($author$project$Utils$Form$hasValidationErrors, 0, model.SD)),
															$author$project$Components$DateInput$errors(
															A2($author$project$Utils$Form$validationErrors, 0, model.SD))
														]),
													fields.uO)),
												A2(
												$author$project$Ui$Element$view,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$text,
														_List_fromArray(
															[$author$project$Ui$Typography$helpBlock]),
														'Change the broker\'s rate will update all commission calculations starting on the date specified.')
													]))
											]))
									])
								])))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$BrokerDealRate$CreateUpdateModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Change broker deal rate'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$loading(
								_Utils_eq(model.qP, $author$project$Api$Data$Loading)),
								$author$project$Ui$Button$onClick($author$project$Components$BrokerDealRate$CreateUpdateModal$Save)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Change Rate')
							]))
					]))
			]));
};
var $author$project$Components$BrokerDeal$Timeline$modal = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				function () {
				var _v0 = model.f7;
				if (!_v0.$) {
					var deleteRequest = _v0.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Components$BrokerDeal$Timeline$DeleteHiConfirmClosed,
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('delete'),
								$author$project$Components$HiConfirm$noun('broker deal'),
								$author$project$Components$HiConfirm$detail(
								model.MQ.PS + (' - ' + ($author$project$Api$Provider$Broker$Shared$name(model.MQ.xF) + ' and remove it from all existing invoices'))),
								$author$project$Components$HiConfirm$loading(
								_Utils_eq(deleteRequest, $author$project$Api$Data$Loading))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v1 = model.fR;
				if (!_v1.$) {
					var _v2 = _v1.a;
					var brokerDealRate = _v2.a;
					var cancelRequest = _v2.b;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Components$BrokerDeal$Timeline$CancelHiConfirmClosed(brokerDealRate),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('cancel'),
								$author$project$Components$HiConfirm$noun('broker deal rate'),
								$author$project$Components$HiConfirm$customMessage(
								_List_fromArray(
									[
										$elm$html$Html$text('Are you sure you want to cancel this rate?')
									])),
								$author$project$Components$HiConfirm$loading(
								_Utils_eq(cancelRequest, $author$project$Api$Data$Loading))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v3 = model.k0;
				if (!_v3.$) {
					var restartModal = _v3.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$BrokerDeal$Timeline$RestartModalMsg,
						$author$project$Components$BrokerDeal$RestartModal$view(restartModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v4 = model.gm;
				if (!_v4.$) {
					var endModal = _v4.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$BrokerDeal$Timeline$EndModalMsg,
						$author$project$Components$BrokerDeal$EndModal$view(endModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v5 = model.fQ;
				if (!_v5.$) {
					var brokerDealRateModal = _v5.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$BrokerDeal$Timeline$BrokerDealRateModalMsg,
						$author$project$Components$BrokerDealRate$CreateUpdateModal$view(brokerDealRateModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]));
};
var $author$project$Components$BrokerDeal$Table$modal = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		A2(
			$elm$core$List$indexedMap,
			F2(
				function (index, _v0) {
					var timeline = _v0.b;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$BrokerDeal$Table$TimelineMsg(index),
						$author$project$Components$BrokerDeal$Timeline$modal(timeline));
				}),
			model.MR));
};
var $author$project$Components$BrokerDeal$CreateModal$BillFrom = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$BrokerDeal$CreateModal$Create = {$: 0};
var $author$project$Components$BrokerDeal$CreateModal$FormUpdated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$BrokerDeal$CreateModal$Membership = 1;
var $elm_community$list_extra$List$Extra$maximumBy = F2(
	function (f, ls) {
		var maxBy = F2(
			function (x, _v1) {
				var y = _v1.a;
				var fy = _v1.b;
				var fx = f(x);
				return (_Utils_cmp(fx, fy) > 0) ? _Utils_Tuple2(x, fx) : _Utils_Tuple2(y, fy);
			});
		if (ls.b) {
			if (!ls.b.b) {
				var l_ = ls.a;
				return $elm$core$Maybe$Just(l_);
			} else {
				var l_ = ls.a;
				var ls_ = ls.b;
				return $elm$core$Maybe$Just(
					A3(
						$elm$core$List$foldl,
						maxBy,
						_Utils_Tuple2(
							l_,
							f(l_)),
						ls_).a);
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$BrokerDeal$CreateModal$billFromDates = F3(
	function (currentDate, commissionsTrackingFrom, dealStartDate) {
		var startMonth = A2($justinmimbs$date$Date$floor, 2, currentDate);
		var dealDate = A2(
			$elm$core$Maybe$map,
			$justinmimbs$date$Date$floor(2),
			dealStartDate);
		var commissionDate = A2(
			$elm$core$Maybe$map,
			$justinmimbs$date$Date$floor(2),
			commissionsTrackingFrom);
		var allTimeDate = A2(
			$justinmimbs$date$Date$floor,
			2,
			A3($justinmimbs$date$Date$add, 1, -9, currentDate));
		var maxDate = A2(
			$elm_community$list_extra$List$Extra$maximumBy,
			$justinmimbs$date$Date$toRataDie,
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						$elm$core$Maybe$Just(allTimeDate),
						commissionDate,
						dealDate
					])));
		var dateDuration = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				A2($justinmimbs$date$Date$diff, 1, currentDate),
				maxDate));
		return A2(
			$elm$core$List$map,
			function (index) {
				return A3($justinmimbs$date$Date$add, 1, index, startMonth);
			},
			$elm$core$List$reverse(
				A2($elm$core$List$range, dateDuration + 1, 0)));
	});
var $author$project$Components$BrokerDeal$CreateModal$billFromOptions = F3(
	function (currentDate, commissionsTrackingFrom, dealStartDate) {
		return A2(
			$elm$core$List$cons,
			A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(''),
				'Start of the deal'),
			A2(
				$elm$core$List$map,
				function (billFrom) {
					return A3(
						$author$project$Ui$Form$Select$option,
						_List_Nil,
						$elm$core$Maybe$Just(
							$author$project$Utils$Date$toIsoString(billFrom)),
						A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$MonthAndYear, billFrom));
				},
				A3($author$project$Components$BrokerDeal$CreateModal$billFromDates, currentDate, commissionsTrackingFrom, dealStartDate)));
	});
var $author$project$Api$Provider$Company$Shared$createdAt = function (_v0) {
	var record = _v0;
	return record.O1;
};
var $author$project$Api$Provider$Company$All$createdAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$createdAt(shared);
};
var $author$project$Api$Provider$Company$One$createdAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$createdAt(shared);
};
var $author$project$Components$BrokerDeal$CreateModal$companyCreatedAt = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$createdAt(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$All$createdAt(company_);
	}
};
var $author$project$Components$PricingStructureSelect$InputGrid = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$PricingStructureSelect$inputSpan = $author$project$Components$PricingStructureSelect$InputGrid;
var $author$project$Components$PricingStructureSelect$LabelGrid = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$PricingStructureSelect$labelSpan = $author$project$Components$PricingStructureSelect$LabelGrid;
var $author$project$Api$Provider$Membership$Shared$startDate = function (_v0) {
	var record = _v0;
	return record.ab7;
};
var $author$project$Api$Provider$Membership$One$startDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Membership$Shared$startDate(shared);
};
var $author$project$Components$BrokerDeal$CreateModal$viewBrokerResourceFilter = F2(
	function (brokerResourceFilter, form) {
		return A2(
			$elm$html$Html$map,
			$author$project$Components$BrokerDeal$CreateModal$BrokerResourceFilterMsg,
			A2(
				$author$project$Components$ResourceFilter$Broker$view,
				_List_fromArray(
					[
						$author$project$Components$ResourceFilter$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
						$author$project$Components$ResourceFilter$errors(
						A2($author$project$Utils$Form$validationErrors, 2, form))
					]),
				brokerResourceFilter));
	});
var $author$project$Api$Provider$RatePeriodScheduleInterval$Shared$intervalInMonths = function (_v0) {
	var record = _v0;
	return record.ah2;
};
var $author$project$Api$Provider$RatePeriodSchedule$Shared$intervals = function (_v0) {
	var record = _v0;
	return record.ah3;
};
var $author$project$Api$Provider$BrokerAccount$Shared$ratePeriodSchedule = function (_v0) {
	var record = _v0;
	return record._2;
};
var $author$project$Api$Provider$RatePeriodScheduleInterval$Shared$pricingStructure = function (_v0) {
	var record = _v0;
	return record._l;
};
var $author$project$Components$BrokerDeal$CreateModal$viewInterval = F3(
	function (intervals, index, interval) {
		var previous = A2($elm_community$list_extra$List$Extra$getAt, index - 1, intervals);
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('timeline__item')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mb1]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[$author$project$Ui$Typography$muted]),
							function () {
								if (previous.$ === 1) {
									return 'Start of the deal';
								} else {
									var previous_ = previous.a;
									return 'After ' + (A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											$elm$core$String$fromInt,
											$author$project$Api$Provider$RatePeriodScheduleInterval$Shared$intervalInMonths(previous_))) + ' months');
								}
							}())
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$PricingStructure$Shared$description(
								$author$project$Api$Provider$RatePeriodScheduleInterval$Shared$pricingStructure(interval)))
						]))
				]));
	});
var $author$project$Components$BrokerDeal$CreateModal$viewBrokerTimeline = function (broker) {
	var intervals = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$RatePeriodSchedule$Shared$intervals,
			$author$project$Api$Provider$BrokerAccount$Shared$ratePeriodSchedule(
				$author$project$Api$Provider$Broker$All$brokerAccount(broker))));
	return A2(
		$elm$html$Html$ul,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('timeline')
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$indexedMap,
					$author$project$Components$BrokerDeal$CreateModal$viewInterval(intervals),
					intervals),
					_List_fromArray(
					[
						A2(
						$elm$html$Html$li,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('timeline__item')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$mb1]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$text,
										_List_fromArray(
											[$author$project$Ui$Typography$muted]),
										function () {
											var _v0 = A2(
												$elm$core$Maybe$andThen,
												$author$project$Api$Provider$RatePeriodScheduleInterval$Shared$intervalInMonths,
												$elm_community$list_extra$List$Extra$last(intervals));
											if (_v0.$ === 1) {
												return 'Recurring Deal';
											} else {
												var intervalInMonths = _v0.a;
												return $elm$core$String$fromInt(intervalInMonths) + ' months';
											}
										}())
									]))
							]))
					])
				])));
};
var $author$project$Components$BrokerDeal$CreateModal$viewCompanyResourceFilter = F2(
	function (companyResourceFilter, form) {
		return A2(
			$elm$html$Html$map,
			$author$project$Components$BrokerDeal$CreateModal$CompanyResourceFilterMsg,
			A2(
				$author$project$Components$ResourceFilter$Company$view,
				_List_fromArray(
					[
						$author$project$Components$ResourceFilter$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
						$author$project$Components$ResourceFilter$errors(
						A2($author$project$Utils$Form$validationErrors, 1, form))
					]),
				companyResourceFilter));
	});
var $author$project$Components$BrokerDeal$CreateModal$DealType = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$BrokerDeal$CreateModal$viewDealTypeButton = F3(
	function (currentDealType, dealType, label) {
		return A3(
			$author$project$Ui$Button$view,
			{mm: 'Select deal type ' + label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(currentDealType, dealType)),
					$author$project$Ui$Button$onClick(
					$author$project$Components$BrokerDeal$CreateModal$FormUpdated(
						$author$project$Components$BrokerDeal$CreateModal$DealType(dealType)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Api$Provider$Membership$One$membershipPatients = function (_v0) {
	var record = _v0.b;
	return record.WR;
};
var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$patient = function (_v0) {
	var record = _v0.b;
	return record.YY;
};
var $author$project$Api$Provider$Membership$One$plan = function (_v0) {
	var record = _v0.b;
	return record.Jb;
};
var $author$project$Components$BrokerDeal$CreateModal$viewMembership = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var membership = _v0.kk;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label(''),
				$author$project$Ui$Form$Group$labelSpan(3),
				$author$project$Ui$Form$Group$inputSpan(9)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$text,
						_List_fromArray(
							[$author$project$Ui$Typography$muted]),
						'Membership '),
						A2(
						$author$project$Ui$Typography$span,
						_List_fromArray(
							[$author$project$Ui$Typography$gray]),
						_List_fromArray(
							[
								function () {
								if (!membership.$) {
									var membership_ = membership.a;
									return $elm$html$Html$text(
										$author$project$Api$Provider$Plan$SharedWithContractInfo$name(
											$author$project$Api$Provider$Membership$One$plan(membership_)));
								} else {
									return $author$project$Ui$Spinner$view(
										_List_fromArray(
											[$author$project$Ui$Spinner$extraSmall]));
								}
							}()
							]))
					])),
				A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$text,
						_List_fromArray(
							[$author$project$Ui$Typography$muted]),
						'Members '),
						A2(
						$author$project$Ui$Typography$span,
						_List_fromArray(
							[$author$project$Ui$Typography$gray]),
						_List_fromArray(
							[
								function () {
								if (!membership.$) {
									var membership_ = membership.a;
									return $elm$html$Html$text(
										$author$project$Formatters$String$toSentence(
											A2(
												$elm$core$List$map,
												A2($elm$core$Basics$composeR, $author$project$Api$Provider$MembershipPatient$ForMembershipOne$patient, $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$name),
												$author$project$Api$Provider$Membership$One$membershipPatients(membership_))));
								} else {
									return $author$project$Ui$Spinner$view(
										_List_fromArray(
											[$author$project$Ui$Spinner$extraSmall]));
								}
							}()
							]))
					])),
				$author$project$Utils$FormErrors$view(
				A2($author$project$Utils$Form$validationErrors, 3, form))
			]));
};
var $author$project$Components$BrokerDeal$CreateModal$viewPatientResourceFilter = F2(
	function (patientResourceFilter, form) {
		return A2(
			$elm$html$Html$map,
			$author$project$Components$BrokerDeal$CreateModal$PatientResourceFilterMsg,
			A2(
				$author$project$Components$ResourceFilter$Patient$view,
				_List_fromArray(
					[
						$author$project$Components$ResourceFilter$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 4, form)),
						$author$project$Components$ResourceFilter$errors(
						A2($author$project$Utils$Form$validationErrors, 4, form))
					]),
				patientResourceFilter));
	});
var $author$project$Components$BrokerDeal$CreateModal$view = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.SD);
	var dealStartDate = function () {
		var _v6 = _Utils_Tuple3(fields.PT, fields.afQ, fields.kk);
		_v6$2:
		while (true) {
			if (!_v6.a) {
				if (!_v6.b.$) {
					var _v7 = _v6.a;
					var company = _v6.b.a;
					return $elm$core$Maybe$Just(
						A2(
							$justinmimbs$date$Date$fromPosix,
							model.J8,
							$author$project$Components$BrokerDeal$CreateModal$companyCreatedAt(company)));
				} else {
					break _v6$2;
				}
			} else {
				if (!_v6.c.$) {
					var _v8 = _v6.a;
					var membership = _v6.c.a;
					return $elm$core$Maybe$Just(
						$author$project$Api$Provider$Membership$One$startDate(membership));
				} else {
					break _v6$2;
				}
			}
		}
		return $elm$core$Maybe$Nothing;
	}();
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$BrokerDeal$CreateModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Create deal')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$onSubmit($author$project$Components$BrokerDeal$CreateModal$Create)
							]),
						$elm$core$List$concat(
							_List_fromArray(
								[
									_List_fromArray(
									[
										function () {
										var _v1 = _Utils_Tuple2(model.ak0, model.afQ);
										if (_v1.a && (_v1.b.$ === 1)) {
											var _v2 = _v1.b;
											return A2(
												$author$project$Ui$Form$Group$view,
												_List_fromArray(
													[
														$author$project$Ui$Form$Group$label('Deal Category'),
														$author$project$Ui$Form$Group$labelSpan(3),
														$author$project$Ui$Form$Group$inputSpan(9)
													]),
												_List_fromArray(
													[
														$author$project$Ui$Button$group(
														_List_fromArray(
															[
																A3($author$project$Components$BrokerDeal$CreateModal$viewDealTypeButton, fields.PT, 0, 'Employer'),
																A3($author$project$Components$BrokerDeal$CreateModal$viewDealTypeButton, fields.PT, 1, 'Retail')
															]))
													]));
										} else {
											return $author$project$Utils$Html$empty;
										}
									}()
									]),
									function () {
									var _v3 = fields.PT;
									if (!_v3) {
										return $elm$core$List$concat(
											_List_fromArray(
												[
													_List_fromArray(
													[
														function () {
														var _v4 = model.afQ;
														if (!_v4.$) {
															return $author$project$Utils$Html$empty;
														} else {
															return A2(
																$author$project$Ui$Form$Group$view,
																_List_fromArray(
																	[
																		$author$project$Ui$Form$Group$label('Employer name'),
																		$author$project$Ui$Form$Group$labelSpan(3),
																		$author$project$Ui$Form$Group$inputSpan(9),
																		$author$project$Ui$Form$Group$required(true)
																	]),
																_List_fromArray(
																	[
																		A2($author$project$Components$BrokerDeal$CreateModal$viewCompanyResourceFilter, model.mZ, model.SD)
																	]));
														}
													}(),
														A2(
														$author$project$Ui$Form$Group$view,
														_List_fromArray(
															[
																$author$project$Ui$Form$Group$label('Broker'),
																$author$project$Ui$Form$Group$labelSpan(3),
																$author$project$Ui$Form$Group$inputSpan(9),
																$author$project$Ui$Form$Group$required(true)
															]),
														_List_fromArray(
															[
																A2($author$project$Components$BrokerDeal$CreateModal$viewBrokerResourceFilter, model.mx, model.SD)
															]))
													]),
													A2(
													$elm$core$List$map,
													$elm$html$Html$map($author$project$Components$BrokerDeal$CreateModal$PricingStructureSelectMsg),
													A2(
														$author$project$Components$PricingStructureSelect$view,
														_List_fromArray(
															[
																$author$project$Components$PricingStructureSelect$value(fields._l),
																$author$project$Components$PricingStructureSelect$invalid(
																A2($author$project$Utils$Form$hasValidationErrors, 0, model.SD)),
																$author$project$Components$PricingStructureSelect$errors(
																A2($author$project$Utils$Form$validationErrors, 0, model.SD)),
																$author$project$Components$PricingStructureSelect$labelSpan(3),
																$author$project$Components$PricingStructureSelect$inputSpan(9)
															]),
														model.pk))
												]));
									} else {
										return _List_fromArray(
											[
												(!fields.zv) ? A2(
												$author$project$Ui$Form$Group$view,
												_List_fromArray(
													[
														$author$project$Ui$Form$Group$label('Patient Name'),
														$author$project$Ui$Form$Group$labelSpan(3),
														$author$project$Ui$Form$Group$inputSpan(9),
														$author$project$Ui$Form$Group$required(true)
													]),
												_List_fromArray(
													[
														A2($author$project$Components$BrokerDeal$CreateModal$viewPatientResourceFilter, model.oY, model.SD)
													])) : $author$project$Utils$Html$empty,
												((!fields.zv) && $author$project$Utils$Maybe$toBool(fields.AW)) ? $author$project$Components$BrokerDeal$CreateModal$viewMembership(model.SD) : $author$project$Utils$Html$empty,
												A2(
												$author$project$Ui$Form$Group$view,
												_List_fromArray(
													[
														$author$project$Ui$Form$Group$label('Broker'),
														$author$project$Ui$Form$Group$labelSpan(3),
														$author$project$Ui$Form$Group$inputSpan(9),
														$author$project$Ui$Form$Group$required(true)
													]),
												_List_fromArray(
													[
														A2($author$project$Components$BrokerDeal$CreateModal$viewBrokerResourceFilter, model.mx, model.SD)
													])),
												function () {
												var _v5 = fields.xF;
												if (!_v5.$) {
													var broker = _v5.a;
													return A2(
														$author$project$Ui$Form$Group$view,
														_List_fromArray(
															[
																$author$project$Ui$Form$Group$label('Rate'),
																$author$project$Ui$Form$Group$labelSpan(3),
																$author$project$Ui$Form$Group$inputSpan(9)
															]),
														_List_fromArray(
															[
																$author$project$Components$BrokerDeal$CreateModal$viewBrokerTimeline(broker)
															]));
												} else {
													return $author$project$Utils$Html$empty;
												}
											}()
											]);
									}
								}(),
									_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$label('Track From'),
												$author$project$Ui$Form$Group$labelSpan(3),
												$author$project$Ui$Form$Group$inputSpan(9)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Select$view,
												_List_fromArray(
													[
														$author$project$Ui$Form$Select$value(fields.afb),
														$author$project$Ui$Form$Select$onChange(
														A2($elm$core$Basics$composeL, $author$project$Components$BrokerDeal$CreateModal$FormUpdated, $author$project$Components$BrokerDeal$CreateModal$BillFrom))
													]),
												A3($author$project$Components$BrokerDeal$CreateModal$billFromOptions, model.dd, model.N7, dealStartDate))
											]))
									])
								])))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$BrokerDeal$CreateModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Add broker deal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$loading(
								_Utils_eq(model.qP, $author$project$Api$Data$Loading)),
								$author$project$Ui$Button$onClick($author$project$Components$BrokerDeal$CreateModal$Create)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Add')
							]))
					]))
			]));
};
var $author$project$Components$BrokerDeal$Table$tableHeaders = F2(
	function (fromBrokerAccount, fromCompany) {
		return $elm$core$List$concat(
			_List_fromArray(
				[
					fromBrokerAccount ? _List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[
								$author$project$Ui$Table$cellSpan(2)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Name')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[
								$author$project$Ui$Table$cellSpan(2)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Category')
							]))
					]) : _List_Nil,
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[
								fromBrokerAccount ? $author$project$Ui$Table$cellSpan(2) : $author$project$Ui$Table$cellSpan(3)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Broker')
							]))
					]),
					fromCompany ? _List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[
								$author$project$Ui$Table$cellSpan(3)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Account')
							]))
					]) : _List_Nil,
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[
								$author$project$Ui$Table$cellSpan(6)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Rate')
							]))
					])
				]));
	});
var $author$project$Components$BrokerDeal$Table$ToogleEnded = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$BrokerDeal$Meta$hasEndedRates = function (_v0) {
	var meta = _v0;
	return meta.S8;
};
var $author$project$Components$BrokerDeal$Timeline$AddBrokerDealRate = {$: 3};
var $author$project$Components$BrokerDeal$Timeline$AddEndDate = {$: 10};
var $author$project$Components$BrokerDeal$Timeline$CancelBrokerDealRate = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$BrokerDeal$Timeline$Delete = {$: 0};
var $author$project$Components$BrokerDeal$Timeline$EditBrokerDealRate = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$BrokerDeal$Timeline$Restart = {$: 12};
var $author$project$Components$BrokerDeal$Timeline$UpdateEndDate = {$: 9};
var $author$project$Api$Provider$BrokerDeal$Meta$dateEditable = function (_v0) {
	var meta = _v0;
	return meta.PC;
};
var $author$project$Api$Provider$BrokerDeal$Meta$destroyable = function (_v0) {
	var meta = _v0;
	return meta.Qw;
};
var $author$project$Api$Provider$BrokerDeal$Meta$editable = function (_v0) {
	var meta = _v0;
	return meta.Q4;
};
var $author$project$Api$Provider$BrokerDeal$Meta$endable = function (_v0) {
	var meta = _v0;
	return meta.Rv;
};
var $author$project$Api$Provider$BrokerDeal$Meta$hasEndedDeal = function (_v0) {
	var meta = _v0;
	return meta.S7;
};
var $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$isFuture = function (_v0) {
	var record = _v0.b;
	return record.UR;
};
var $author$project$Api$Provider$BrokerDeal$Meta$isMembershipType = function (_v0) {
	var meta = _v0;
	return meta.UX;
};
var $author$project$Api$Provider$BrokerDeal$Meta$restartable = function (_v0) {
	var meta = _v0;
	return meta.$R;
};
var $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$isEnded = function (_v0) {
	var record = _v0.b;
	return record.UP;
};
var $author$project$Components$BrokerDeal$Timeline$viewRate = F2(
	function (controls, brokerDealRate) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('timeline__item')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mb1]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[$author$project$Ui$Typography$muted]),
							function () {
								var _v0 = $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$startDate(brokerDealRate);
								if (!_v0.$) {
									var startDate = _v0.a;
									return A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, startDate);
								} else {
									return 'Start of the deal';
								}
							}())
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$description(brokerDealRate)),
							controls(brokerDealRate)
						]))
				]));
	});
var $author$project$Components$BrokerDeal$Timeline$view = F5(
	function (showEnded, brokerDeal, controls1, controls2, brokerDealRateControls) {
		var rates = $elm$core$List$reverse(
			A2(
				$elm$core$List$filter,
				function (rate) {
					return (!$author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$isEnded(rate)) || showEnded;
				},
				brokerDeal._4));
		var meta = brokerDeal.W4;
		var endDate = A2(
			$elm$core$Maybe$andThen,
			$author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$endDate,
			$elm$core$List$head(brokerDeal._4));
		var hasEndDate = $author$project$Utils$Maybe$toBool(endDate);
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('timeline')
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						A2(
						$elm$core$List$map,
						$author$project$Components$BrokerDeal$Timeline$viewRate(brokerDealRateControls),
						rates),
						(hasEndDate || $author$project$Api$Provider$BrokerDeal$Meta$hasEndedDeal(meta)) ? _List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('timeline__item timeline__item--error')
								]),
							_List_fromArray(
								[
									function () {
									if (!endDate.$) {
										var endDate_ = endDate.a;
										return A2(
											$author$project$Ui$Element$view,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('End of deal: '),
													$elm$html$Html$text(
													A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, endDate_))
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}(),
									controls1
								]))
						]) : _List_Nil,
						(!hasEndDate) ? _List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('timeline__item')
								]),
							_List_fromArray(
								[
									controls2,
									$author$project$Api$Provider$BrokerDeal$Meta$isMembershipType(meta) ? A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-muted mb-075')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Recurring Deal')
										])) : $author$project$Utils$Html$empty
								]))
						]) : _List_Nil
					])));
	});
var $author$project$Components$BrokerDeal$Timeline$viewWithControls = function (model) {
	var meta = model.MQ.W4;
	return A5(
		$author$project$Components$BrokerDeal$Timeline$view,
		model.alu,
		model.MQ,
		A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$gap2]),
			_List_fromArray(
				[
					$author$project$Api$Provider$BrokerDeal$Meta$dateEditable(meta) ? A3(
					$author$project$Ui$Button$view,
					{mm: 'Change broker deal end date'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$sm,
							$author$project$Ui$Button$onClick($author$project$Components$BrokerDeal$Timeline$UpdateEndDate),
							$author$project$Ui$Button$icon($author$project$Ui$Icon$calendar)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Change end date')
						])) : $author$project$Utils$Html$empty,
					$author$project$Api$Provider$BrokerDeal$Meta$restartable(meta) ? A3(
					$author$project$Ui$Button$view,
					{mm: 'Restar broker deal'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$sm,
							$author$project$Ui$Button$onClick($author$project$Components$BrokerDeal$Timeline$Restart),
							$author$project$Ui$Button$icon($author$project$Ui$Icon$repeat)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Restart')
						])) : $author$project$Utils$Html$empty,
					$author$project$Api$Provider$BrokerDeal$Meta$hasEndedDeal(meta) ? ($author$project$Api$Provider$BrokerDeal$Meta$isMembershipType(meta) ? A2(
					$author$project$Ui$Typography$text,
					_List_fromArray(
						[$author$project$Ui$Typography$small, $author$project$Ui$Typography$gray]),
					'Membership has ended') : A2(
					$author$project$Ui$Typography$text,
					_List_fromArray(
						[$author$project$Ui$Typography$small, $author$project$Ui$Typography$gray]),
					'Employer is inactive')) : $author$project$Utils$Html$empty,
					$author$project$Api$Provider$BrokerDeal$Meta$destroyable(meta) ? A3(
					$author$project$Ui$Button$view,
					{mm: 'Delete broker deal'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$sm,
							$author$project$Ui$Button$onClick($author$project$Components$BrokerDeal$Timeline$Delete),
							$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Delete')
						])) : $author$project$Utils$Html$empty
				])),
		A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
			_List_fromArray(
				[
					$author$project$Api$Provider$BrokerDeal$Meta$editable(meta) ? A3(
					$author$project$Ui$Button$view,
					{mm: 'Add deal rate'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$sm,
							$author$project$Ui$Button$onClick($author$project$Components$BrokerDeal$Timeline$AddBrokerDealRate),
							$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Add Rate Change')
						])) : $author$project$Utils$Html$empty,
					$author$project$Api$Provider$BrokerDeal$Meta$endable(meta) ? A3(
					$author$project$Ui$Button$view,
					{mm: 'Add end date'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$sm,
							$author$project$Ui$Button$onClick($author$project$Components$BrokerDeal$Timeline$AddEndDate),
							$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Add End Date')
						])) : $author$project$Utils$Html$empty
				])),
		function (brokerDealRate) {
			return $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$isFuture(brokerDealRate) ? A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$gap2, $author$project$Ui$Element$justifyRight]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Edit rate'},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$sm,
								$author$project$Ui$Button$onClick(
								$author$project$Components$BrokerDeal$Timeline$EditBrokerDealRate(brokerDealRate)),
								$author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Edit Rate Change')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Cancel deal rate change'},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$sm,
								$author$project$Ui$Button$onClick(
								$author$project$Components$BrokerDeal$Timeline$CancelBrokerDealRate(brokerDealRate)),
								$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel Rate Change')
							]))
					])) : $author$project$Utils$Html$empty;
		});
};
var $author$project$Components$BrokerDeal$Table$viewBrokerDeal = F6(
	function (ended, fromBrokerAccount, fromCompany, model, index, _v0) {
		var brokerDeal = _v0.a;
		var timeline = _v0.b;
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						fromBrokerAccount ? _List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$bold]),
									_List_fromArray(
										[
											$elm$html$Html$text(brokerDeal.PS)
										]))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(brokerDeal.PT)
								]))
						]) : _List_Nil,
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$Broker$Shared$name(brokerDeal.xF))
								]))
						]),
						fromCompany ? _List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$BrokerAccount$Shared$name(
										$author$project$Api$Provider$Broker$Shared$brokerAccount(brokerDeal.xF)))
								]))
						]) : _List_Nil,
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									function () {
									if ((!ended) && $author$project$Api$Provider$BrokerDeal$Meta$hasEndedRates(brokerDeal.W4)) {
										var showEndedOnTimeline = A2($elm$core$Set$member, index, model.hE);
										var label = showEndedOnTimeline ? 'Hide expired rates' : 'See expired rates';
										return A3(
											$author$project$Ui$Button$view,
											{mm: label},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$sm,
													$author$project$Ui$Button$onClick(
													$author$project$Components$BrokerDeal$Table$ToogleEnded(index))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(label)
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}(),
									A2(
									$elm$html$Html$map,
									$author$project$Components$BrokerDeal$Table$TimelineMsg(index),
									$author$project$Components$BrokerDeal$Timeline$viewWithControls(timeline))
								]))
						])
					])));
	});
var $author$project$Components$BrokerDeal$Table$view = F2(
	function (options, model) {
		return A4(
			$author$project$Ui$Table$view,
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							model.ny ? $elm$html$Html$text('No ended deals.') : $elm$html$Html$text('No deals found.')
						])),
				options),
			A2($author$project$Components$BrokerDeal$Table$tableHeaders, model.ss, model.st),
			A2(
				$elm$core$List$indexedMap,
				A4($author$project$Components$BrokerDeal$Table$viewBrokerDeal, model.ny, model.ss, model.st, model),
				model.MR),
			_List_Nil);
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$viewBrokerResourceFilter = function (brokerResourceFilter) {
	return A2(
		$elm$html$Html$map,
		$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$BrokerResourceFilterMsg,
		A2($author$project$Components$ResourceFilter$Broker$view, _List_Nil, brokerResourceFilter));
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$DealTypeSelected = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$dealTypeToLabel = function (dealType) {
	if (!dealType) {
		return 'Employer';
	} else {
		return 'Retail';
	}
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$viewTypeDropdown = function (model) {
	var currentLabel = function () {
		var _v0 = model.amg;
		if (!_v0.$) {
			var dealType = _v0.a;
			return $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$dealTypeToLabel(dealType);
		} else {
			return 'Categories';
		}
	}();
	var allTypes = _List_fromArray(
		[0, 1]);
	var items = A2(
		$elm$core$List$cons,
		A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$DealTypeSelected($elm$core$Maybe$Nothing))
				]),
			$elm$html$Html$text('All Categories')),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$Dropdown$separator,
			A2(
				$elm$core$List$map,
				function (dealType) {
					return A2(
						$author$project$Ui$Dropdown$item,
						_List_fromArray(
							[
								$author$project$Ui$Dropdown$onSelect(
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$DealTypeSelected(
									$elm$core$Maybe$Just(dealType)))
							]),
						$elm$html$Html$text(
							$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$dealTypeToLabel(dealType)));
				},
				allTypes)));
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(currentLabel)
			]),
		items,
		model.qI);
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$BrokerDealsTableMsg,
				$author$project$Components$BrokerDeal$Table$modal(model.d_)),
				function () {
				var _v0 = model.iX;
				if (!_v0.$) {
					var createModal = _v0.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$CreateModalMsg,
						$author$project$Components$BrokerDeal$CreateModal$view(createModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween]),
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Active Deals')
											])),
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__EndedDeals(
											{cm: model.cm}),
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('See Ended Deals')
											]))
									])),
								A2(
								$author$project$Ui$Grid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$spanMd(10)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$p,
												_List_fromArray(
													[$author$project$Ui$Typography$gray]),
												_List_fromArray(
													[
														$elm$html$Html$text('A deal represents the relationship between a broker and their commission. If you need to remove a deal, make sure that it is ended first.')
													]))
											]))
									])),
								A2(
								$author$project$Ui$Grid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(6)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$SearchInputMsg,
												A2(
													$author$project$Ui$SearchInput$view,
													_List_fromArray(
														[
															$author$project$Ui$SearchInput$placeholder('Search deal')
														]),
													model.up))
											])),
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(2)
											]),
										_List_fromArray(
											[
												$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$viewBrokerResourceFilter(model.mx)
											])),
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(2)
											]),
										_List_fromArray(
											[
												$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$viewTypeDropdown(model)
											])),
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(2)
											]),
										_List_fromArray(
											[
												function () {
												var _v1 = model.xG;
												if (_v1.$ === 3) {
													var brokerAccount = _v1.a;
													return A3(
														$author$project$Ui$Button$view,
														{mm: 'Create deal'},
														_List_fromArray(
															[
																$author$project$Ui$Button$icon($author$project$Ui$Icon$add),
																$author$project$Ui$Button$onClick(
																$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$Create(brokerAccount))
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Create Deal')
															]));
												} else {
													return $author$project$Ui$Skeleton$input(_List_Nil);
												}
											}()
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$BrokerDealsTableMsg,
								A2(
									$author$project$Components$BrokerDeal$Table$view,
									_List_fromArray(
										[
											$author$project$Components$BrokerDeal$Table$loading(
											!$author$project$Api$Data$isSuccess(model.MR))
										]),
									model.d_))
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(
											!$author$project$Api$Data$isSuccess(model.MR))
										]),
									model.ajJ))
							]))
					]))
			]),
		ac9: 'Commissions | Broker Deals'
	};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$init, aiq: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$load, k8: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$save, alO: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$subscriptions, adT: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$update, amo: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$view});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$BrokerResourceFilterMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$buildUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('q'),
			model.akl),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('broker'),
			model.GN)
		]);
	return A2(
		$elm$url$Url$Builder$relative,
		_List_fromArray(
			[
				$author$project$Spa$Generated$Route$toString(
				$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__EndedDeals(
					{cm: model.cm}))
			]),
		A2(
			$elm$core$List$append,
			$author$project$Api$Pagination$toPageQuery(model.ajJ),
			A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)));
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$GotBrokerDeals = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$fetchBrokerDeals = function (model) {
	return A3(
		$author$project$Api$Provider$BrokerDeal$list,
		model.Gv,
		function (d) {
			return _Utils_update(
				d,
				{
					xF: model.GN,
					xG: $elm$core$Maybe$Just(model.cm),
					TU: $elm$core$Maybe$Just(true),
					ajJ: model.ajJ,
					akl: model.akl
				});
		},
		$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$GotBrokerDeals);
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$init = F4(
	function (session, practice, shared, _v0) {
		var params = _v0.YL;
		var query = _v0.DE;
		var q = A2($elm$core$Dict$get, 'q', query);
		var brokerId = A2($elm$core$Dict$get, 'broker', query);
		var _v1 = A3(
			$author$project$Components$ResourceFilter$Broker$init,
			shared.Gv,
			$elm$core$Basics$identity,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'All Brokers', akb: brokerId});
			});
		var brokerResourceFilter = _v1.a;
		var brokerResourceFilterCmd = _v1.b;
		var model = {
			Gv: shared.Gv,
			cm: params.cm,
			MR: $author$project$Api$Data$Loading,
			d_: A3(
				$author$project$Components$BrokerDeal$Table$init,
				session,
				shared.dd,
				{ny: true, ss: true, st: false}),
			GN: brokerId,
			mx: brokerResourceFilter,
			ajJ: $author$project$Api$Pagination$initFromQuery(query),
			ZV: practice,
			akl: q,
			up: $author$project$Ui$SearchInput$init(q)
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$BrokerResourceFilterMsg, brokerResourceFilterCmd),
						$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$fetchBrokerDeals(model),
						A2($elm$core$Basics$composeR, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$buildUrl, $author$project$Ports$Navigation$replaceUrl)(model)
					])));
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					d_: A2($author$project$Components$BrokerDeal$Table$load, shared.dd, model.d_)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$BrokerDealsTableMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$subscriptions = function (_v0) {
	var brokerDealsTable = _v0.d_;
	var brokerResourceFilter = _v0.mx;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$BrokerDealsTableMsg,
				$author$project$Components$BrokerDeal$Table$subscriptions(brokerDealsTable)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$BrokerResourceFilterMsg,
				$author$project$Components$ResourceFilter$Broker$subscriptions(brokerResourceFilter))
			]));
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$SearchInputMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var brokerDeals = response.a;
					var headers = response.b;
					var brokerDealsTable = A2(
						$author$project$Components$BrokerDeal$Table$withBrokerDeals,
						A2($elm$core$List$map, $author$project$Components$BrokerDeal$BrokerDealRecord$fromProviderAll, brokerDeals),
						model.d_);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								MR: response,
								d_: brokerDealsTable,
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{MR: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var brokerDealsTableResult = A3($author$project$Components$BrokerDeal$Table$update, model.Gv, subMsg, model.d_);
				var _v2 = function () {
					var _v3 = brokerDealsTableResult.agZ;
					switch (_v3) {
						case 0:
							return _Utils_Tuple2(model.MR, $elm$core$Platform$Cmd$none);
						case 1:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$fetchBrokerDeals(model));
						case 2:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$fetchBrokerDeals(model));
						case 3:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$fetchBrokerDeals(model));
						case 4:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$fetchBrokerDeals(model));
						case 5:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$fetchBrokerDeals(model));
						default:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$fetchBrokerDeals(model));
					}
				}();
				var brokerDeals = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{MR: brokerDeals, d_: brokerDealsTableResult.aiO}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$BrokerDealsTableMsg, brokerDealsTableResult.GZ),
								cmd
							])),
					brokerDealsTableResult.aR);
			case 2:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$fetchBrokerDeals(newModel),
								A2($elm$core$Basics$composeR, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 3:
				var subMsg = msg.a;
				var _v4 = A2($author$project$Ui$SearchInput$update, subMsg, model.up);
				var searchInput = _v4.a;
				var searchInputCmd = _v4.b;
				var searchInputEvent = _v4.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.akl;
					}
				}();
				var _v5 = function () {
					if (_Utils_eq(q, model.akl)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								MR: $author$project$Api$Data$Loading,
								ajJ: $author$project$Api$Pagination$reset(model.ajJ),
								akl: q
							});
						return _Utils_Tuple2(
							qModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$fetchBrokerDeals(qModel),
										A2($elm$core$Basics$composeR, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$buildUrl, $author$project$Ports$Navigation$pushUrl)(qModel)
									])));
					}
				}();
				var newModel = _v5.a;
				var cmd = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{up: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
			default:
				var subMsg = msg.a;
				var brokerResourceResult = A3($author$project$Components$ResourceFilter$Broker$update, model.Gv, subMsg, model.mx);
				var brokerId = function () {
					var _v8 = brokerResourceResult.agZ;
					if (!_v8.$) {
						return $author$project$Components$ResourceFilter$Broker$value(brokerResourceResult.aiO);
					} else {
						return model.GN;
					}
				}();
				var newModel = _Utils_update(
					model,
					{GN: brokerId, mx: brokerResourceResult.aiO});
				var _v7 = _Utils_eq(model.GN, newModel.GN) ? _Utils_Tuple2(model.MR, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					$author$project$Api$Data$Loading,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$fetchBrokerDeals(newModel),
								A2($elm$core$Basics$composeR, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])));
				var brokerDeals = _v7.a;
				var cmd = _v7.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{MR: brokerDeals}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$BrokerResourceFilterMsg, brokerResourceResult.GZ),
								cmd
							])),
					brokerResourceResult.aR);
		}
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$PaginationMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$ResourceFilter$Button = 1;
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$viewBrokerResourceFilter = function (brokerResourceFilter) {
	return A2(
		$elm$html$Html$map,
		$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$BrokerResourceFilterMsg,
		A2(
			$author$project$Components$ResourceFilter$Broker$view,
			_List_fromArray(
				[
					$author$project$Components$ResourceFilter$style(1)
				]),
			brokerResourceFilter));
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$BrokerDealsTableMsg,
				$author$project$Components$BrokerDeal$Table$modal(model.d_)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$elm$core$Basics$never,
								A2(
									$author$project$Ui$Breadcrumb$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Breadcrumb$item,
											_List_Nil,
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Deals(
														{cm: model.cm}),
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Active Deals')
														]))
												])),
											A2(
											$author$project$Ui$Breadcrumb$item,
											_List_fromArray(
												[
													$author$project$Ui$Breadcrumb$active(true)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Ended Deals')
												]))
										]))),
								$author$project$Ui$HorizontalRule$view(_List_Nil),
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Ended Deals')
									])),
								A2(
								$author$project$Ui$Grid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(6)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$SearchInputMsg,
												A2(
													$author$project$Ui$SearchInput$view,
													_List_fromArray(
														[
															$author$project$Ui$SearchInput$placeholder('Search deal')
														]),
													model.up))
											])),
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(3)
											]),
										_List_fromArray(
											[
												$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$viewBrokerResourceFilter(model.mx)
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$BrokerDealsTableMsg,
								A2(
									$author$project$Components$BrokerDeal$Table$view,
									_List_fromArray(
										[
											$author$project$Components$BrokerDeal$Table$loading(
											!$author$project$Api$Data$isSuccess(model.MR))
										]),
									model.d_))
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(
											!$author$project$Utils$Maybe$toBool(
												$author$project$Api$Data$toMaybe(model.MR)))
										]),
									model.ajJ))
							]))
					]))
			]),
		ac9: 'Commissions | Broker Deals'
	};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$init, aiq: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$load, k8: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$save, alO: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$subscriptions, adT: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$update, amo: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$view});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$GotStatement = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Statement$One$Statement = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Statement$Shared$Statement = $elm$core$Basics$identity;
var $author$project$Api$Provider$Statement$Shared$Record = F7(
	function (id, number, amountInCents, date, status, dueInCents, brokerAccount) {
		return {LE: amountInCents, xG: brokerAccount, PB: date, QY: dueInCents, ahP: id, IO: number, alH: status};
	});
var $author$project$Api$Provider$Statement$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'broker_account',
	$author$project$Api$Provider$BrokerAccount$Shared$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'due_in_cents',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'status',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'date',
				$author$project$Utils$Date$decode,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'amount_in_cents',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'number',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Api$Provider$Statement$Shared$Record))))))));
var $author$project$Api$Provider$Statement$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Statement$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Statement$One$Record = F4(
	function (brokersCount, dealsCount, securePdfInlineToken, payments) {
		return {MT: brokersCount, PU: dealsCount, Zi: payments, aaE: securePdfInlineToken};
	});
var $author$project$Api$Provider$Statement$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'payments',
	$elm$json$Json$Decode$list($author$project$Api$Provider$Payment$One$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'secure_pdf_inline_token',
		$author$project$Api$File$Token$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'deals_count',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'brokers_count',
				$elm$json$Json$Decode$int,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$Statement$One$Record)))));
var $author$project$Api$Provider$Statement$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Statement$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Statement$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Statement$One$Statement)));
var $author$project$Api$Provider$Statement$statementsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['statements']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Statement$statementPath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		$author$project$Api$Provider$Statement$statementsPath);
};
var $author$project$Api$Provider$Statement$retrieve = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Statement$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Statement$statementPath(id)));
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$init = F4(
	function (session, practice, shared, _v0) {
		var params = _v0.YL;
		return _Utils_Tuple2(
			{
				il: $elm$core$Maybe$Nothing,
				Gv: shared.Gv,
				cm: params.cm,
				m$: $elm$core$Maybe$Nothing,
				dd: shared.dd,
				jt: $author$project$Components$Invoice$DownloadFile$init(shared.adY),
				Ij: $author$project$Shared$isHintAdmin(shared),
				oc: $author$project$Api$Data$NotAsked,
				kD: A4(
					$author$project$Components$PaymentsList$init,
					shared.J7,
					$author$project$Api$Provider$Statement$statementPath(params.alG),
					session,
					true),
				ZV: practice,
				t9: shared.t9,
				aa4: session,
				JW: $author$project$Api$Data$Loading,
				alG: params.alG,
				u_: $author$project$Api$Data$Loading,
				lE: $elm$core$Dict$empty,
				J7: shared.J7
			},
			A3($author$project$Api$Provider$Statement$retrieve, shared.Gv, params.alG, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$GotStatement));
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$AdjustmentModalMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$CreatePaymentModalMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$PaymentsListMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Commissions$Statement$AdjustmentModal$BrokerResourceFilterMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Commissions$Statement$AdjustmentModal$Close = {$: 0};
var $author$project$Components$Commissions$Statement$AdjustmentModal$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Commissions$Statement$AdjustmentModal$Close),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Commissions$Statement$AdjustmentModal$BrokerResourceFilterMsg,
				$author$project$Components$ResourceFilter$Broker$subscriptions(
					$author$project$Utils$Form$fields(model.SD).mx))
			]));
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$PaymentsListMsg,
				$author$project$Components$PaymentsList$subscriptions(model.kD)),
				function () {
				var _v0 = model.m$;
				if (!_v0.$) {
					var createPaymentModal = _v0.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$CreatePaymentModalMsg,
						$author$project$Components$Invoice$CreatePaymentModal$subscriptions(createPaymentModal));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				function () {
				var _v1 = model.il;
				if (!_v1.$) {
					var adjustmentModal = _v1.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$AdjustmentModalMsg,
						$author$project$Components$Commissions$Statement$AdjustmentModal$subscriptions(adjustmentModal));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}()
			]));
};
var $author$project$Api$Provider$Statement$SummaryLine$Broker = 0;
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$DownloadInvoiceMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$GotSummaryLines = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$Issued = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$SummaryLineDetailsMsg = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Api$Provider$Statement$Shared$amountInCents = function (_v0) {
	var record = _v0;
	return record.LE;
};
var $author$project$Api$Provider$Statement$One$amountInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Statement$Shared$amountInCents(shared);
};
var $author$project$Components$Commissions$Statement$AdjustmentModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Commissions$Statement$AdjustmentModal$Bonus = 0;
var $author$project$Components$Commissions$Statement$AdjustmentModal$defaultCategory = 0;
var $author$project$Components$Commissions$Statement$AdjustmentModal$formFieldsInit = F2(
	function (apiClient, brokerAccountId) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$Broker$init,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						xG: $elm$core$Maybe$Just(brokerAccountId),
						IK: $elm$core$Maybe$Just(true)
					});
			},
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'None', ai5: false});
			});
		var brokerResourceFilter = _v0.a;
		var brokerResourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{LE: $elm$core$Maybe$Nothing, xF: $elm$core$Maybe$Nothing, mx: brokerResourceFilter, GW: $author$project$Components$Commissions$Statement$AdjustmentModal$defaultCategory, aiG: $elm$core$Maybe$Nothing},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$Statement$AdjustmentModal$BrokerResourceFilterMsg, brokerResourceFilterCmd));
	});
var $author$project$Components$Commissions$Statement$AdjustmentModal$init = F3(
	function (apiClient, brokerAccountId, statement) {
		var _v0 = A2($author$project$Components$Commissions$Statement$AdjustmentModal$formFieldsInit, apiClient, brokerAccountId);
		var formFields = _v0.a;
		var formFieldsCmd = _v0.b;
		return _Utils_Tuple2(
			{
				QE: false,
				SD: $author$project$Utils$Form$init(formFields),
				k9: $author$project$Api$Data$NotAsked,
				JW: statement
			},
			formFieldsCmd);
	});
var $author$project$Components$Commissions$Statement$SummaryLine$Details$init = F2(
	function (statement, summaryLine) {
		return {p0: false, JW: statement, J0: summaryLine, u_: $author$project$Api$Data$NotAsked};
	});
var $author$project$Components$Invoice$CreatePaymentModal$ElectronicFundsTransfer = 3;
var $author$project$Components$Invoice$CreatePaymentModal$Statement = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$initCreatePaymentModal = F2(
	function (statement, model) {
		var _v0 = $author$project$Components$Invoice$CreatePaymentModal$init(model.dd)(model.J7)(
			$author$project$Api$Provider$Statement$statementPath(model.alG))($elm$core$Maybe$Nothing)(model.Gv)(model.aa4)(
			$author$project$Api$Practice$Provider(model.ZV))(model.Ij)(model.t9)(
			function (d) {
				return _Utils_update(
					d,
					{
						R5: true,
						HG: _List_fromArray(
							[0, 3, 4]),
						alv: model.Ij
					});
			})(
			A2($author$project$Components$Invoice$CreatePaymentModal$Statement, model.cm, statement));
		var createPaymentModal = _v0.a;
		var createPaymentModalCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					m$: $elm$core$Maybe$Just(createPaymentModal)
				}),
			A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$CreatePaymentModalMsg, createPaymentModalCmd));
	});
var $author$project$Api$Provider$Statement$issue = F4(
	function (apiClient, id, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'statement',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'amount_in_cents',
								$elm$json$Json$Encode$int(fields.LE))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Statement$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['issue']),
						$author$project$Api$Provider$Statement$statementPath(id)))));
	});
var $author$project$Api$Provider$Statement$SummaryLine$All$SummaryLine = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Statement$SummaryLine$Shared$SummaryLine = $elm$core$Basics$identity;
var $author$project$Api$Provider$Statement$SummaryLine$Shared$Record = F6(
	function (membershipsCount, linesCount, patientsCount, payableAmountInCents, liabilityAmountInCents, totalRateAmountInCents) {
		return {VW: liabilityAmountInCents, V2: linesCount, W_: membershipsCount, Y2: patientsCount, Y3: payableAmountInCents, adr: totalRateAmountInCents};
	});
var $author$project$Api$Provider$Statement$SummaryLine$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'total_rate_amount_in_cents',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'liability_amount_in_cents',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'payable_amount_in_cents',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'patients_count',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'lines_count',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'memberships_count',
						$elm$json$Json$Decode$int,
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$Statement$SummaryLine$Shared$Record)))))));
var $author$project$Api$Provider$Statement$SummaryLine$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Statement$SummaryLine$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Statement$SummaryLine$All$Record = F6(
	function (payable, category, inStatementPeriod, categoryName, invoice, broker) {
		return {xF: broker, GW: category, Ns: categoryName, TT: inStatementPeriod, Uk: invoice, ajV: payable};
	});
var $author$project$Api$Provider$Broker$Min$Broker = $elm$core$Basics$identity;
var $author$project$Api$Provider$Broker$Min$Record = F2(
	function (id, name) {
		return {ahP: id, Bq: name};
	});
var $author$project$Api$Provider$Broker$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Broker$Min$Record)));
var $author$project$Api$Provider$Broker$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Broker$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Invoice$MinWithCompany$Invoice = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Invoice$MinWithCompany$Record = function (company) {
	return {afQ: company};
};
var $author$project$Api$Provider$Invoice$MinWithCompany$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'company',
	$author$project$Api$Provider$Company$Min$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Invoice$MinWithCompany$Record));
var $author$project$Api$Provider$Invoice$MinWithCompany$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Invoice$MinWithCompany$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Invoice$Min$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Invoice$MinWithCompany$Invoice)));
var $author$project$Api$Provider$Statement$SummaryLine$All$recordDecoder = A3(
	$author$project$Api$Expandable$expandable,
	'broker',
	$author$project$Api$Provider$Broker$Min$decoder,
	A3(
		$author$project$Api$Expandable$expandable,
		'invoice',
		$author$project$Api$Provider$Invoice$MinWithCompany$decoder,
		A3(
			$author$project$Api$Expandable$expandable,
			'category_name',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$Api$Expandable$expandable,
				'in_statement_period',
				$elm$json$Json$Decode$bool,
				A3(
					$author$project$Api$Expandable$expandable,
					'category',
					$elm$json$Json$Decode$string,
					A3(
						$author$project$Api$Expandable$expandable,
						'payable',
						$elm$json$Json$Decode$bool,
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$Statement$SummaryLine$All$Record)))))));
var $author$project$Api$Provider$Statement$SummaryLine$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Statement$SummaryLine$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Statement$SummaryLine$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Statement$SummaryLine$All$SummaryLine)));
var $author$project$Api$Provider$Statement$SummaryLine$expandToString = function (expand) {
	switch (expand) {
		case 0:
			return 'broker';
		case 1:
			return 'category_name';
		case 3:
			return 'period';
		case 4:
			return 'payable';
		default:
			return 'category_type';
	}
};
var $author$project$Api$Provider$Statement$SummaryLine$listDefaults = {GN: $elm$core$Maybe$Nothing, HE: _List_Nil};
var $author$project$Api$Provider$Statement$SummaryLine$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Statement$SummaryLine$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.GN;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'broker_id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				A2($author$project$Api$Expandable$toParam, $author$project$Api$Provider$Statement$SummaryLine$expandToString, options.HE)
			]));
};
var $author$project$Api$Provider$Statement$SummaryLine$summaryLinesPath = function (statementId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['summary_lines']),
		$author$project$Api$Provider$Statement$statementPath(statementId));
};
var $author$project$Api$Provider$Statement$SummaryLine$list = F4(
	function (apiClient, statementId, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Statement$SummaryLine$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Statement$SummaryLine$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Statement$SummaryLine$summaryLinesPath(statementId))));
	});
var $author$project$Components$Commissions$Statement$AdjustmentModal$AdjustmentCreated = 2;
var $author$project$Components$Commissions$Statement$AdjustmentModal$Broker = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Commissions$Statement$AdjustmentModal$Closed = 1;
var $author$project$Components$Commissions$Statement$AdjustmentModal$None = 0;
var $author$project$Components$Commissions$Statement$AdjustmentModal$AmountInCentsValidation = 1;
var $author$project$Components$Commissions$Statement$AdjustmentModal$BrokerValidation = 0;
var $author$project$Components$Commissions$Statement$AdjustmentModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.xF;
			},
			_Utils_Tuple2(0, 'Please pick a broker.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.LE;
			},
			_Utils_Tuple2(1, 'Please enter an amount.'))
		]));
var $author$project$Components$Commissions$Statement$AdjustmentModal$Created = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Statement$Adjustment$adjustmentsPath = function (statementId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['adjustments']),
		$author$project$Api$Provider$Statement$statementPath(statementId));
};
var $author$project$Api$Provider$StatementAdjustment$One$StatementAdjustment = 0;
var $author$project$Api$Provider$StatementAdjustment$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Provider$Statement$Adjustment$create = F4(
	function (apiClient, statementId, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'statement_adjustment',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'category',
								$elm$json$Json$Encode$string(fields.GW)),
								_Utils_Tuple2(
								'broker',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.xF)),
								_Utils_Tuple2(
								'amount_in_cents',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.LE)),
								_Utils_Tuple2(
								'memo',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.aiG))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$StatementAdjustment$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Statement$Adjustment$adjustmentsPath(statementId))));
	});
var $author$project$Components$Commissions$Statement$AdjustmentModal$createParams = function (fields) {
	var category = function () {
		var _v0 = fields.GW;
		switch (_v0) {
			case 0:
				return 'bonus';
			case 1:
				return 'correction';
			default:
				return 'other';
		}
	}();
	return {
		LE: A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.LE),
		xF: fields.xF,
		GW: category,
		aiG: fields.aiG
	};
};
var $author$project$Components$Commissions$Statement$AdjustmentModal$save = F3(
	function (apiClient, model, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4(
			$author$project$Api$Provider$Statement$Adjustment$create,
			apiClient,
			$author$project$Api$Provider$Statement$One$id(model.JW),
			$author$project$Components$Commissions$Statement$AdjustmentModal$createParams(fields),
			$author$project$Components$Commissions$Statement$AdjustmentModal$Created);
	});
var $author$project$Components$Commissions$Statement$AdjustmentModal$Correction = 1;
var $author$project$Components$Commissions$Statement$AdjustmentModal$Other = 2;
var $author$project$Components$Commissions$Statement$AdjustmentModal$categoryFromString = function (string) {
	switch (string) {
		case 'Bonus':
			return 0;
		case 'Correction':
			return 1;
		case 'Other':
			return 2;
		default:
			return $author$project$Components$Commissions$Statement$AdjustmentModal$defaultCategory;
	}
};
var $author$project$Components$Commissions$Statement$AdjustmentModal$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						aiG: $author$project$Utils$String$toMaybe(string)
					});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						GW: $author$project$Components$Commissions$Statement$AdjustmentModal$categoryFromString(string)
					});
			case 2:
				var broker = field.a;
				return _Utils_update(
					fields,
					{
						xF: A2($elm$core$Maybe$map, $author$project$Api$Provider$Broker$All$id, broker)
					});
			default:
				var _int = field.a;
				return _Utils_update(
					fields,
					{LE: _int});
		}
	});
var $author$project$Components$Commissions$Statement$AdjustmentModal$updateForm = F3(
	function (model, field, form) {
		var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Commissions$Statement$AdjustmentModal$formFieldsUpdate, field, form);
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{SD: newForm}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Components$Commissions$Statement$AdjustmentModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: 1, aiO: model, aR: _List_Nil};
			case 1:
				var field = msg.a;
				var _v2 = A3($author$project$Components$Commissions$Statement$AdjustmentModal$updateForm, model, field, model.SD);
				var newModel = _v2.a;
				var formCmd = _v2.b;
				return {GZ: formCmd, agZ: 0, aiO: newModel, aR: _List_Nil};
			case 2:
				var _v3 = A2($author$project$Utils$Form$validate, $author$project$Components$Commissions$Statement$AdjustmentModal$formFieldsValidator, model.SD);
				if (!_v3.$) {
					var _v4 = _v3.a;
					var newForm = _v4.a;
					var validFormFields = _v4.b;
					return {
						GZ: A3($author$project$Components$Commissions$Statement$AdjustmentModal$save, apiClient, model, validFormFields),
						agZ: 0,
						aiO: _Utils_update(
							model,
							{SD: newForm, k9: $author$project$Api$Data$Loading}),
						aR: _List_Nil
					};
				} else {
					var newForm = _v3.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{SD: newForm}),
						aR: _List_Nil
					};
				}
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 2,
						aiO: _Utils_update(
							model,
							{k9: $author$project$Api$Data$NotAsked}),
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Statement Ajusted')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{k9: $author$project$Api$Data$NotAsked}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			default:
				var subMsg = msg.a;
				var fields = $author$project$Utils$Form$fields(model.SD);
				var brokerResourceResult = A3($author$project$Components$ResourceFilter$Broker$update, apiClient, subMsg, fields.mx);
				var newForm = A2(
					$author$project$Utils$Form$set,
					_Utils_update(
						fields,
						{mx: brokerResourceResult.aiO}),
					model.SD);
				var _v6 = function () {
					var _v7 = brokerResourceResult.agZ;
					_v7$2:
					while (true) {
						if (!_v7.$) {
							switch (_v7.a.$) {
								case 0:
									var broker = _v7.a.a;
									return A3(
										$author$project$Components$Commissions$Statement$AdjustmentModal$updateForm,
										model,
										$author$project$Components$Commissions$Statement$AdjustmentModal$Broker(
											$elm$core$Maybe$Just(broker)),
										newForm);
								case 2:
									var _v8 = _v7.a;
									return A3(
										$author$project$Components$Commissions$Statement$AdjustmentModal$updateForm,
										model,
										$author$project$Components$Commissions$Statement$AdjustmentModal$Broker($elm$core$Maybe$Nothing),
										newForm);
								default:
									break _v7$2;
							}
						} else {
							break _v7$2;
						}
					}
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{SD: newForm}),
						$elm$core$Platform$Cmd$none);
				}();
				var newModel = _v6.a;
				var formCmd = _v6.b;
				return {
					GZ: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$Statement$AdjustmentModal$BrokerResourceFilterMsg, brokerResourceResult.GZ),
								formCmd
							])),
					agZ: 0,
					aiO: newModel,
					aR: brokerResourceResult.aR
				};
		}
	});
var $author$project$Api$Provider$Statement$SummaryLine$CategoryName = 1;
var $author$project$Api$Provider$Statement$SummaryLine$CategoryType = 2;
var $author$project$Components$Commissions$Statement$SummaryLine$Details$GotSummaryLines = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Statement$SummaryLine$Payable = 4;
var $author$project$Api$Provider$Statement$SummaryLine$Period = 3;
var $author$project$Api$Provider$Statement$SummaryLine$All$broker = function (_v0) {
	var record = _v0.b;
	return record.xF;
};
var $author$project$Api$Provider$Statement$One$brokersCount = function (_v0) {
	var record = _v0.b;
	return record.MT;
};
var $author$project$Api$Provider$Statement$One$dealsCount = function (_v0) {
	var record = _v0.b;
	return record.PU;
};
var $author$project$Components$Commissions$Statement$SummaryLine$Details$expandedView = function (statement) {
	return _Utils_cmp(
		$author$project$Api$Provider$Statement$One$brokersCount(statement) * 10,
		$author$project$Api$Provider$Statement$One$dealsCount(statement)) > -1;
};
var $author$project$Api$Provider$Broker$Min$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Components$Commissions$Statement$SummaryLine$Details$retrieveSummaryLines = F3(
	function (apiClient, statement, summaryLine) {
		var expand = $author$project$Components$Commissions$Statement$SummaryLine$Details$expandedView(statement) ? _List_fromArray(
			[1, 3, 4]) : _List_fromArray(
			[4, 3, 2]);
		var brokerId = $author$project$Api$Expandable$toMaybe(
			A2(
				$author$project$Api$Expandable$map,
				$author$project$Api$Provider$Broker$Min$id,
				$author$project$Api$Provider$Statement$SummaryLine$All$broker(summaryLine)));
		return A4(
			$author$project$Api$Provider$Statement$SummaryLine$list,
			apiClient,
			$author$project$Api$Provider$Statement$One$id(statement),
			function (d) {
				return _Utils_update(
					d,
					{GN: brokerId, HE: expand});
			},
			$author$project$Components$Commissions$Statement$SummaryLine$Details$GotSummaryLines);
	});
var $author$project$Components$Commissions$Statement$SummaryLine$Details$update = F3(
	function (apiClient, msg, model) {
		if (!msg.$) {
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{p0: !model.p0}),
				function () {
					var _v1 = model.u_;
					if (_v1.$ === 3) {
						return $elm$core$Platform$Cmd$none;
					} else {
						return A3($author$project$Components$Commissions$Statement$SummaryLine$Details$retrieveSummaryLines, apiClient, model.JW, model.J0);
					}
				}(),
				_List_Nil);
		} else {
			var response = msg.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{u_: response}),
				$elm$core$Platform$Cmd$none,
				$author$project$OutMsg$handleErrorResponse(response));
		}
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var statement = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{JW: response}),
						A4(
							$author$project$Api$Provider$Statement$SummaryLine$list,
							model.Gv,
							model.alG,
							function (d) {
								return _Utils_update(
									d,
									{
										HE: _List_fromArray(
											[0])
									});
							},
							$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$GotSummaryLines(statement)),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{JW: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var statement = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var summaryLines = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								u_: response,
								lE: $elm$core$Dict$fromList(
									A2(
										$elm$core$List$indexedMap,
										F2(
											function (index, summaryLine) {
												var summaryLineDetails = A2($author$project$Components$Commissions$Statement$SummaryLine$Details$init, statement, summaryLine);
												return _Utils_Tuple2(index, summaryLineDetails);
											}),
										summaryLines))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{u_: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 2:
				var statement = msg.a;
				var _v3 = A3($author$project$Components$Commissions$Statement$AdjustmentModal$init, model.Gv, model.cm, statement);
				var adjustmentModal = _v3.a;
				var adjustmentModalCmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							il: $elm$core$Maybe$Just(adjustmentModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$AdjustmentModalMsg, adjustmentModalCmd),
					_List_Nil);
			case 3:
				var statement = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oc: $author$project$Api$Data$Loading}),
					A4(
						$author$project$Api$Provider$Statement$issue,
						model.Gv,
						model.alG,
						{
							LE: $author$project$Api$Provider$Statement$One$amountInCents(statement)
						},
						$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$Issued),
					_List_Nil);
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{oc: $author$project$Api$Data$NotAsked, JW: response}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Statement issued')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{oc: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 5:
				var statement = msg.a;
				return A2(
					$author$project$Utils$Tuple3$fromTuple2,
					_List_Nil,
					A2($author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$initCreatePaymentModal, statement, model));
			case 6:
				var subMsg = msg.a;
				var downloadInvoiceResult = A3($author$project$Components$Invoice$DownloadFile$update, model.Gv, subMsg, model.jt);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{jt: downloadInvoiceResult.aiO}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$DownloadInvoiceMsg, downloadInvoiceResult.GZ),
					downloadInvoiceResult.aR);
			case 7:
				var subMsg = msg.a;
				var paymentsListResult = A3($author$project$Components$PaymentsList$update, model.Gv, subMsg, model.kD);
				var _v5 = function () {
					var _v6 = paymentsListResult.agZ;
					switch (_v6) {
						case 0:
							return _Utils_Tuple2(model.JW, $elm$core$Platform$Cmd$none);
						case 1:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								A3($author$project$Api$Provider$Statement$retrieve, model.Gv, model.alG, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$GotStatement));
						case 2:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								A3($author$project$Api$Provider$Statement$retrieve, model.Gv, model.alG, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$GotStatement));
						case 3:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								A3($author$project$Api$Provider$Statement$retrieve, model.Gv, model.alG, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$GotStatement));
						case 4:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								A3($author$project$Api$Provider$Statement$retrieve, model.Gv, model.alG, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$GotStatement));
						default:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								A3($author$project$Api$Provider$Statement$retrieve, model.Gv, model.alG, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$GotStatement));
					}
				}();
				var statement = _v5.a;
				var cmd = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{kD: paymentsListResult.aiO, JW: statement}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$PaymentsListMsg, paymentsListResult.GZ),
								cmd
							])),
					paymentsListResult.aR);
			case 8:
				var subMsg = msg.a;
				var _v7 = model.m$;
				if (!_v7.$) {
					var createPaymentModal = _v7.a;
					var createPaymentModalResult = A3($author$project$Components$Invoice$CreatePaymentModal$update, model.Gv, subMsg, createPaymentModal);
					var _v8 = function () {
						var _v9 = createPaymentModalResult.agZ;
						switch (_v9) {
							case 1:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(createPaymentModalResult.aiO),
									model.JW,
									$elm$core$Platform$Cmd$none);
							case 2:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Api$Data$Loading,
									A3($author$project$Api$Provider$Statement$retrieve, model.Gv, model.alG, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$GotStatement));
							default:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.JW, $elm$core$Platform$Cmd$none);
						}
					}();
					var createPaymentModal_ = _v8.a;
					var statement = _v8.b;
					var cmd = _v8.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{m$: createPaymentModal_, JW: statement}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$CreatePaymentModalMsg, createPaymentModalResult.GZ),
									cmd
								])),
						createPaymentModalResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var id = msg.a;
				var subMsg = msg.b;
				var _v10 = A2($elm$core$Dict$get, id, model.lE);
				if (!_v10.$) {
					var summaryLineDetails = _v10.a;
					var _v11 = A3($author$project$Components$Commissions$Statement$SummaryLine$Details$update, model.Gv, subMsg, summaryLineDetails);
					var summaryLineDetails_ = _v11.a;
					var summaryLineDetailsCmd = _v11.b;
					var summaryLineDetailsOutMsgs = _v11.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								lE: A3($elm$core$Dict$insert, id, summaryLineDetails_, model.lE)
							}),
						A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$SummaryLineDetailsMsg(id),
							summaryLineDetailsCmd),
						summaryLineDetailsOutMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var subMsg = msg.a;
				var _v12 = model.il;
				if (!_v12.$) {
					var adjustmentModal = _v12.a;
					var adjustmentModalResult = A3($author$project$Components$Commissions$Statement$AdjustmentModal$update, model.Gv, subMsg, adjustmentModal);
					var _v13 = function () {
						var _v14 = adjustmentModalResult.agZ;
						switch (_v14) {
							case 0:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(adjustmentModalResult.aiO),
									model.JW,
									$elm$core$Platform$Cmd$none);
							case 2:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Api$Data$Loading,
									A3($author$project$Api$Provider$Statement$retrieve, model.Gv, model.alG, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$GotStatement));
							default:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.JW, $elm$core$Platform$Cmd$none);
						}
					}();
					var adjustmentModal_ = _v13.a;
					var statement = _v13.b;
					var cmd = _v13.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{il: adjustmentModal_, JW: statement}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$AdjustmentModalMsg, adjustmentModalResult.GZ),
									cmd
								])),
						adjustmentModalResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Components$Commissions$Statement$AdjustmentModal$Save = {$: 2};
var $author$project$Components$Commissions$Statement$AdjustmentModal$AmountInCents = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Commissions$Statement$AdjustmentModal$FormUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Commissions$Statement$AdjustmentModal$viewAmountInCentsFormGroup = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var amountInCents = _v0.LE;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Amount'),
				$author$project$Ui$Form$Group$required(true),
				$author$project$Ui$Form$Group$labelSpan(3),
				$author$project$Ui$Form$Group$inputSpan(9)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$row,
				_List_fromArray(
					[$author$project$Ui$Grid$rowItemsCenter]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(6)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$CurrencyInput$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$CurrencyInput$value(amountInCents),
										$author$project$Ui$Form$CurrencyInput$placeholder('e.g. 50.00'),
										$author$project$Ui$Form$CurrencyInput$onInput(
										A2($elm$core$Basics$composeL, $author$project$Components$Commissions$Statement$AdjustmentModal$FormUpdated, $author$project$Components$Commissions$Statement$AdjustmentModal$AmountInCents)),
										$author$project$Ui$Form$CurrencyInput$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 1, form))
									])),
								$author$project$Utils$FormErrors$view(
								A2($author$project$Utils$Form$validationErrors, 1, form))
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(6)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$textLeft]),
								_List_fromArray(
									[
										$elm$html$Html$text('Amounts can be negative')
									]))
							]))
					]))
			]));
};
var $author$project$Components$Commissions$Statement$AdjustmentModal$viewBrokerFormGroup = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var brokerResourceFilter = _v0.mx;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Broker'),
				$author$project$Ui$Form$Group$required(true),
				$author$project$Ui$Form$Group$labelSpan(3),
				$author$project$Ui$Form$Group$inputSpan(9)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Commissions$Statement$AdjustmentModal$BrokerResourceFilterMsg,
				A2(
					$author$project$Components$ResourceFilter$Broker$view,
					_List_fromArray(
						[
							$author$project$Components$ResourceFilter$style(0),
							$author$project$Components$ResourceFilter$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
							$author$project$Components$ResourceFilter$errors(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						]),
					brokerResourceFilter))
			]));
};
var $author$project$Components$Commissions$Statement$AdjustmentModal$Category = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Commissions$Statement$AdjustmentModal$allCategories = _List_fromArray(
	[0, 1, 2]);
var $author$project$Components$Commissions$Statement$AdjustmentModal$categoryToString = function (category) {
	switch (category) {
		case 0:
			return 'Bonus';
		case 1:
			return 'Correction';
		default:
			return 'Other';
	}
};
var $author$project$Components$Commissions$Statement$AdjustmentModal$categoryOptions = A2(
	$elm$core$List$map,
	function (category) {
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(
				$author$project$Components$Commissions$Statement$AdjustmentModal$categoryToString(category)),
			$author$project$Components$Commissions$Statement$AdjustmentModal$categoryToString(category));
	},
	$author$project$Components$Commissions$Statement$AdjustmentModal$allCategories);
var $author$project$Components$Commissions$Statement$AdjustmentModal$viewCategoryFormGroup = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var category = _v0.GW;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Category'),
				$author$project$Ui$Form$Group$required(true),
				$author$project$Ui$Form$Group$labelSpan(3),
				$author$project$Ui$Form$Group$inputSpan(9)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Select$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Select$value(
						$elm$core$Maybe$Just(
							$author$project$Components$Commissions$Statement$AdjustmentModal$categoryToString(category))),
						$author$project$Ui$Form$Select$onChange(
						A2($elm$core$Basics$composeL, $author$project$Components$Commissions$Statement$AdjustmentModal$FormUpdated, $author$project$Components$Commissions$Statement$AdjustmentModal$Category))
					]),
				$author$project$Components$Commissions$Statement$AdjustmentModal$categoryOptions)
			]));
};
var $author$project$Components$Commissions$Statement$AdjustmentModal$Memo = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Commissions$Statement$AdjustmentModal$viewMemoFormGroup = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var memo = _v0.aiG;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Memo'),
				$author$project$Ui$Form$Group$labelSpan(3),
				$author$project$Ui$Form$Group$inputSpan(9)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$value(
						A2($elm$core$Maybe$withDefault, '', memo)),
						$author$project$Ui$Form$Input$placeholder('Additional notes about this payment'),
						$author$project$Ui$Form$Input$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Commissions$Statement$AdjustmentModal$FormUpdated, $author$project$Components$Commissions$Statement$AdjustmentModal$Memo))
					]))
			]));
};
var $author$project$Components$Commissions$Statement$AdjustmentModal$viewFormGroups = function (form) {
	return _List_fromArray(
		[
			$author$project$Components$Commissions$Statement$AdjustmentModal$viewCategoryFormGroup(form),
			$author$project$Components$Commissions$Statement$AdjustmentModal$viewBrokerFormGroup(form),
			$author$project$Components$Commissions$Statement$AdjustmentModal$viewAmountInCentsFormGroup(form),
			$author$project$Components$Commissions$Statement$AdjustmentModal$viewMemoFormGroup(form)
		]);
};
var $author$project$Components$Commissions$Statement$AdjustmentModal$view = function (_v0) {
	var model = _v0;
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Commissions$Statement$AdjustmentModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Typography$headingSm(
						_List_fromArray(
							[
								$elm$html$Html$text('Add Adjustment')
							]))
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$onSubmit($author$project$Components$Commissions$Statement$AdjustmentModal$Save)
							]),
						$author$project$Components$Commissions$Statement$AdjustmentModal$viewFormGroups(model.SD))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$span(6)
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Cancel and close modal'},
										_List_fromArray(
											[
												$author$project$Ui$Button$fullWidth(true),
												$author$project$Ui$Button$onClick($author$project$Components$Commissions$Statement$AdjustmentModal$Close)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cancel')
											]))
									])),
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$span(6)
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Confirm adjustment'},
										_List_fromArray(
											[
												$author$project$Ui$Button$fullWidth(true),
												$author$project$Ui$Button$onClick($author$project$Components$Commissions$Statement$AdjustmentModal$Save),
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$loading(
												_Utils_eq(model.k9, $author$project$Api$Data$Loading))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Confirm Adjustment')
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$Adjust = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$Statement$Shared$date = function (_v0) {
	var record = _v0;
	return record.PB;
};
var $author$project$Api$Provider$Statement$One$date = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Statement$Shared$date(shared);
};
var $author$project$Api$Provider$Statement$Shared$number = function (_v0) {
	var record = _v0;
	return record.IO;
};
var $author$project$Api$Provider$Statement$One$number = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Statement$Shared$number(shared);
};
var $author$project$Api$Provider$Statement$One$securePdfInlineToken = function (_v0) {
	var record = _v0.b;
	return record.aaE;
};
var $author$project$Api$Provider$Statement$Shared$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Api$Provider$Statement$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Statement$Shared$status(shared);
};
var $author$project$Api$Provider$Statement$One$payments = function (_v0) {
	var record = _v0.b;
	return record.Zi;
};
var $author$project$Components$PaymentsList$ShowCreatedBy = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$PaymentsList$showCreatedBy = $author$project$Components$PaymentsList$ShowCreatedBy;
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$viewPaymentsList = F3(
	function (isHintAdmin, statement, paymentsList) {
		var payments = A2(
			$elm$core$List$map,
			$author$project$Api$Payment$Provider_One,
			$author$project$Api$Provider$Statement$One$payments(statement));
		return $elm$core$List$isEmpty(payments) ? $author$project$Utils$Html$empty : A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Panel$title(
							_List_fromArray(
								[
									$elm$html$Html$text('Payment History')
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$PaymentsListMsg,
							A3(
								$author$project$Components$PaymentsList$view,
								_List_fromArray(
									[
										$author$project$Components$PaymentsList$isHintAdmin(isHintAdmin),
										$author$project$Components$PaymentsList$allowRefunds(true),
										$author$project$Components$PaymentsList$showCreatedBy(true),
										$author$project$Components$PaymentsList$showRefundMemo(true)
									]),
								payments,
								paymentsList))
						]))
				]));
	});
var $author$project$Components$Commissions$Statement$SummaryLine$Details$ToggleShow = {$: 0};
var $author$project$Components$Commissions$Statement$SummaryLine$Details$button = function (model) {
	var icon = model.p0 ? $author$project$Ui$Icon$minus : $author$project$Ui$Icon$add;
	return A3(
		$author$project$Ui$Button$view,
		{mm: 'Toggle visibility'},
		_List_fromArray(
			[
				$author$project$Ui$Button$link,
				$author$project$Ui$Button$onClick($author$project$Components$Commissions$Statement$SummaryLine$Details$ToggleShow),
				$author$project$Ui$Button$icon(icon)
			]),
		_List_Nil);
};
var $author$project$Api$Provider$Statement$SummaryLine$Shared$membershipsCount = function (_v0) {
	var record = _v0;
	return record.W_;
};
var $author$project$Api$Provider$Statement$SummaryLine$All$membershipsCount = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Statement$SummaryLine$Shared$membershipsCount(shared);
};
var $author$project$Api$Provider$Broker$Min$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$Statement$SummaryLine$Shared$patientsCount = function (_v0) {
	var record = _v0;
	return record.Y2;
};
var $author$project$Api$Provider$Statement$SummaryLine$All$patientsCount = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Statement$SummaryLine$Shared$patientsCount(shared);
};
var $author$project$Api$Provider$Statement$SummaryLine$Shared$payableAmountInCents = function (_v0) {
	var record = _v0;
	return record.Y3;
};
var $author$project$Api$Provider$Statement$SummaryLine$All$payableAmountInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Statement$SummaryLine$Shared$payableAmountInCents(shared);
};
var $author$project$Api$Provider$Statement$SummaryLine$All$inStatementPeriod = function (_v0) {
	var record = _v0.b;
	return record.TT;
};
var $author$project$Components$Commissions$Statement$SummaryLine$Details$inStatementPeriod = function (summaryLine) {
	return $author$project$Api$Expandable$toMaybe(
		$author$project$Api$Provider$Statement$SummaryLine$All$inStatementPeriod(summaryLine));
};
var $author$project$Ui$Well$NoBorder = {$: 1};
var $author$project$Ui$Well$noBorder = $author$project$Ui$Well$NoBorder;
var $author$project$Api$Provider$Statement$SummaryLine$All$payable = function (_v0) {
	var record = _v0.b;
	return record.ajV;
};
var $author$project$Components$Commissions$Statement$SummaryLine$Details$payable = function (summaryLine) {
	return $author$project$Api$Expandable$toMaybe(
		$author$project$Api$Provider$Statement$SummaryLine$All$payable(summaryLine));
};
var $author$project$Ui$Typography$Capitalized = 5;
var $author$project$Ui$Typography$capitalized = $author$project$Ui$Typography$Decoration(5);
var $author$project$Api$Provider$Statement$SummaryLine$All$categoryName = function (_v0) {
	var record = _v0.b;
	return record.Ns;
};
var $author$project$Api$Provider$Invoice$MinWithCompany$company = function (_v0) {
	var record = _v0.b;
	return record.afQ;
};
var $author$project$Api$Provider$Invoice$MinWithCompany$id = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Provider$Invoice$Min$id(min);
};
var $author$project$Api$Provider$Statement$SummaryLine$All$invoice = function (_v0) {
	var record = _v0.b;
	return record.Uk;
};
var $author$project$Api$Provider$Invoice$MinWithCompany$invoiceNumber = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Provider$Invoice$Min$invoiceNumber(min);
};
var $author$project$Api$Provider$Statement$SummaryLine$Shared$liabilityAmountInCents = function (_v0) {
	var record = _v0;
	return record.VW;
};
var $author$project$Api$Provider$Statement$SummaryLine$All$liabilityAmountInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Statement$SummaryLine$Shared$liabilityAmountInCents(shared);
};
var $author$project$Api$Provider$Statement$SummaryLine$Shared$linesCount = function (_v0) {
	var record = _v0;
	return record.V2;
};
var $author$project$Api$Provider$Statement$SummaryLine$All$linesCount = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Statement$SummaryLine$Shared$linesCount(shared);
};
var $author$project$Api$Provider$Statement$SummaryLine$Shared$totalRateAmountInCents = function (_v0) {
	var record = _v0;
	return record.adr;
};
var $author$project$Api$Provider$Statement$SummaryLine$All$totalRateAmountInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Statement$SummaryLine$Shared$totalRateAmountInCents(shared);
};
var $author$project$Components$Commissions$Statement$SummaryLine$Details$viewExpandedSummaryLineTableRow = F2(
	function (isOutstanding, summaryLine) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = $author$project$Api$Provider$Statement$SummaryLine$All$categoryName(summaryLine);
							_v0$4:
							while (true) {
								if (!_v0.$) {
									switch (_v0.a) {
										case 'Retail':
											return $elm$html$Html$text('--');
										case 'bonus':
											return $author$project$Utils$Html$empty;
										case 'correction':
											return $author$project$Utils$Html$empty;
										case 'other':
											return $author$project$Utils$Html$empty;
										default:
											break _v0$4;
									}
								} else {
									break _v0$4;
								}
							}
							var _v1 = $author$project$Api$Provider$Statement$SummaryLine$All$invoice(summaryLine);
							if (!_v1.$) {
								var invoice = _v1.a;
								var invoiceNumber = $author$project$Api$Provider$Invoice$MinWithCompany$invoiceNumber(invoice);
								var invoiceId = $author$project$Api$Provider$Invoice$MinWithCompany$id(invoice);
								var companyId = $author$project$Api$Provider$Company$Min$id(
									$author$project$Api$Provider$Invoice$MinWithCompany$company(invoice));
								var invoiceRoute = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String(
									{fZ: companyId, ahP: invoiceId});
								return A3(
									$author$project$Ui$Link$route,
									invoiceRoute,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											'#' + $elm$core$String$fromInt(invoiceNumber))
										]));
							} else {
								return $elm$html$Html$text('N/A');
							}
						}()
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[$author$project$Ui$Typography$capitalized]),
							A2(
								$author$project$Api$Expandable$withDefault,
								'N/A',
								$author$project$Api$Provider$Statement$SummaryLine$All$categoryName(summaryLine)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v2 = $author$project$Api$Provider$Statement$SummaryLine$All$categoryName(summaryLine);
							_v2$3:
							while (true) {
								if (!_v2.$) {
									switch (_v2.a) {
										case 'bonus':
											return $elm$html$Html$text(
												A2(
													$author$project$Formatters$String$pluralize,
													'line',
													$author$project$Api$Provider$Statement$SummaryLine$All$linesCount(summaryLine)));
										case 'correction':
											return $elm$html$Html$text(
												A2(
													$author$project$Formatters$String$pluralize,
													'line',
													$author$project$Api$Provider$Statement$SummaryLine$All$linesCount(summaryLine)));
										case 'other':
											return $elm$html$Html$text(
												A2(
													$author$project$Formatters$String$pluralize,
													'line',
													$author$project$Api$Provider$Statement$SummaryLine$All$linesCount(summaryLine)));
										default:
											break _v2$3;
									}
								} else {
									break _v2$3;
								}
							}
							return A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(
											$author$project$Api$Provider$Statement$SummaryLine$All$membershipsCount(summaryLine))),
										$elm$html$Html$text(' primary '),
										$elm$html$Html$text(
										A2(
											$author$project$Formatters$String$pluralize,
											'patient',
											$author$project$Api$Provider$Statement$SummaryLine$All$patientsCount(summaryLine)))
									]));
						}()
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v3 = $author$project$Api$Provider$Statement$SummaryLine$All$categoryName(summaryLine);
							_v3$3:
							while (true) {
								if (!_v3.$) {
									switch (_v3.a) {
										case 'bonus':
											return $author$project$Utils$Html$empty;
										case 'correction':
											return $author$project$Utils$Html$empty;
										case 'other':
											return $author$project$Utils$Html$empty;
										default:
											break _v3$3;
									}
								} else {
									break _v3$3;
								}
							}
							return $elm$html$Html$text(
								$author$project$Utils$Currency$fromInt(
									A2(
										$elm$core$Maybe$withDefault,
										0,
										$author$project$Api$Provider$Statement$SummaryLine$All$totalRateAmountInCents(summaryLine))));
						}()
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var amountInCents = isOutstanding ? $author$project$Api$Provider$Statement$SummaryLine$All$liabilityAmountInCents(summaryLine) : $author$project$Api$Provider$Statement$SummaryLine$All$payableAmountInCents(summaryLine);
							return $elm$html$Html$text(
								$author$project$Utils$Currency$fromInt(amountInCents));
						}()
						]))
				]));
	});
var $author$project$Components$Commissions$Statement$SummaryLine$Details$viewExpandedSummaryLineTable = F2(
	function (isOutstanding, summaryLines) {
		return A4(
			$author$project$Ui$Table$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$header,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(1)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Invoice')
						])),
					A2(
					$author$project$Ui$Table$header,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(3)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Employer / Category')
						])),
					A2(
					$author$project$Ui$Table$header,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(2)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Deal')
						])),
					A2(
					$author$project$Ui$Table$header,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(2)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Total rate')
						])),
					A2(
					$author$project$Ui$Table$header,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(2)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Commission')
						]))
				]),
			A2(
				$elm$core$List$map,
				$author$project$Components$Commissions$Statement$SummaryLine$Details$viewExpandedSummaryLineTableRow(isOutstanding),
				summaryLines),
			_List_Nil);
	});
var $author$project$Api$Provider$Statement$SummaryLine$All$category = function (_v0) {
	var record = _v0.b;
	return record.GW;
};
var $author$project$Components$Commissions$Statement$SummaryLine$Details$viewSummarizedSummaryLineTableRow = F2(
	function (isOutstanding, summaryLine) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = $author$project$Api$Provider$Statement$SummaryLine$All$category(summaryLine);
							_v0$2:
							while (true) {
								if (!_v0.$) {
									switch (_v0.a) {
										case 'Membership':
											return $elm$html$Html$text('Retail');
										case 'Company':
											return $elm$html$Html$text('Employer');
										default:
											break _v0$2;
									}
								} else {
									break _v0$2;
								}
							}
							return $elm$html$Html$text(
								A2(
									$author$project$Api$Expandable$withDefault,
									'N/A',
									$author$project$Api$Provider$Statement$SummaryLine$All$category(summaryLine)));
						}()
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v1 = $author$project$Api$Provider$Statement$SummaryLine$All$category(summaryLine);
							_v1$5:
							while (true) {
								if (!_v1.$) {
									switch (_v1.a) {
										case 'bonus':
											return $elm$html$Html$text(
												A2(
													$author$project$Formatters$String$pluralize,
													'line',
													$author$project$Api$Provider$Statement$SummaryLine$All$linesCount(summaryLine)));
										case 'correction':
											return $elm$html$Html$text(
												A2(
													$author$project$Formatters$String$pluralize,
													'line',
													$author$project$Api$Provider$Statement$SummaryLine$All$linesCount(summaryLine)));
										case 'other':
											return $elm$html$Html$text(
												A2(
													$author$project$Formatters$String$pluralize,
													'line',
													$author$project$Api$Provider$Statement$SummaryLine$All$linesCount(summaryLine)));
										case 'Membership':
											return A2(
												$author$project$Ui$Element$view,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														$elm$core$String$fromInt(
															$author$project$Api$Provider$Statement$SummaryLine$All$membershipsCount(summaryLine))),
														$elm$html$Html$text(' primary '),
														$elm$html$Html$text(
														A2(
															$author$project$Formatters$String$pluralize,
															'patient',
															$author$project$Api$Provider$Statement$SummaryLine$All$patientsCount(summaryLine)))
													]));
										case 'Company':
											return A2(
												$author$project$Ui$Element$view,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														$elm$core$String$fromInt(
															$author$project$Api$Provider$Statement$SummaryLine$All$membershipsCount(summaryLine))),
														$elm$html$Html$text(' primary '),
														$elm$html$Html$text(
														A2(
															$author$project$Formatters$String$pluralize,
															'patient',
															$author$project$Api$Provider$Statement$SummaryLine$All$patientsCount(summaryLine)))
													]));
										default:
											break _v1$5;
									}
								} else {
									break _v1$5;
								}
							}
							return $author$project$Utils$Html$empty;
						}()
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$Currency$fromInt(
								A2(
									$elm$core$Maybe$withDefault,
									0,
									$author$project$Api$Provider$Statement$SummaryLine$All$totalRateAmountInCents(summaryLine))))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var amountInCents = isOutstanding ? $author$project$Api$Provider$Statement$SummaryLine$All$liabilityAmountInCents(summaryLine) : $author$project$Api$Provider$Statement$SummaryLine$All$payableAmountInCents(summaryLine);
							return $elm$html$Html$text(
								$author$project$Utils$Currency$fromInt(amountInCents));
						}()
						]))
				]));
	});
var $author$project$Components$Commissions$Statement$SummaryLine$Details$viewSummarizedSummaryLineTable = F2(
	function (isOutstanding, summaryLines) {
		return A4(
			$author$project$Ui$Table$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$header,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(2)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Category')
						])),
					A2(
					$author$project$Ui$Table$header,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(3)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Deal')
						])),
					A2(
					$author$project$Ui$Table$header,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(2)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Total rate')
						])),
					A2(
					$author$project$Ui$Table$header,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(2)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Commission')
						]))
				]),
			A2(
				$elm$core$List$map,
				$author$project$Components$Commissions$Statement$SummaryLine$Details$viewSummarizedSummaryLineTableRow(isOutstanding),
				summaryLines),
			_List_Nil);
	});
var $author$project$Components$Commissions$Statement$SummaryLine$Details$viewSummaryLineTable = F3(
	function (expanded, isOutstanding, summaryLines) {
		return expanded ? A2($author$project$Components$Commissions$Statement$SummaryLine$Details$viewExpandedSummaryLineTable, isOutstanding, summaryLines) : A2($author$project$Components$Commissions$Statement$SummaryLine$Details$viewSummarizedSummaryLineTable, isOutstanding, summaryLines);
	});
var $author$project$Components$Commissions$Statement$SummaryLine$Details$viewSummaryLineTables = F2(
	function (statement, summaryLines) {
		var previousSummaryLines = A2(
			$elm$core$List$filter,
			function (summaryLine) {
				return _Utils_eq(
					$author$project$Components$Commissions$Statement$SummaryLine$Details$inStatementPeriod(summaryLine),
					$elm$core$Maybe$Just(false)) && _Utils_eq(
					$author$project$Components$Commissions$Statement$SummaryLine$Details$payable(summaryLine),
					$elm$core$Maybe$Just(true));
			},
			summaryLines);
		var outstandingSummaryLines = A2(
			$elm$core$List$filter,
			function (summaryLine) {
				return _Utils_eq(
					$author$project$Components$Commissions$Statement$SummaryLine$Details$payable(summaryLine),
					$elm$core$Maybe$Just(false));
			},
			summaryLines);
		var currentSummaryLines = A2(
			$elm$core$List$filter,
			function (summaryLine) {
				return _Utils_eq(
					$author$project$Components$Commissions$Statement$SummaryLine$Details$inStatementPeriod(summaryLine),
					$elm$core$Maybe$Just(true)) && _Utils_eq(
					$author$project$Components$Commissions$Statement$SummaryLine$Details$payable(summaryLine),
					$elm$core$Maybe$Just(true));
			},
			summaryLines);
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$elm$core$List$isEmpty(currentSummaryLines) ? $author$project$Utils$Html$empty : A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(12)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Current')
										])),
									A3(
									$author$project$Components$Commissions$Statement$SummaryLine$Details$viewSummaryLineTable,
									$author$project$Components$Commissions$Statement$SummaryLine$Details$expandedView(statement),
									false,
									currentSummaryLines)
								]))
						])),
					$elm$core$List$isEmpty(previousSummaryLines) ? $author$project$Utils$Html$empty : A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(12)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Previous')
										])),
									A3(
									$author$project$Components$Commissions$Statement$SummaryLine$Details$viewSummaryLineTable,
									$author$project$Components$Commissions$Statement$SummaryLine$Details$expandedView(statement),
									false,
									previousSummaryLines)
								]))
						])),
					$elm$core$List$isEmpty(outstandingSummaryLines) ? $author$project$Utils$Html$empty : A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(12)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Well$view,
									_List_fromArray(
										[$author$project$Ui$Well$small, $author$project$Ui$Well$noBorder]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$mt2]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$strong,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Outstanding')
														])),
													$author$project$Utils$Html$noBreakSpace,
													A2(
													$author$project$Ui$Typography$text,
													_List_fromArray(
														[$author$project$Ui$Typography$gray]),
													'(not reflected in totals)')
												])),
											A3(
											$author$project$Components$Commissions$Statement$SummaryLine$Details$viewSummaryLineTable,
											$author$project$Components$Commissions$Statement$SummaryLine$Details$expandedView(statement),
											true,
											outstandingSummaryLines)
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Commissions$Statement$SummaryLine$Details$view = function (model) {
	return model.p0 ? A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$mt2]),
		_List_fromArray(
			[
				function () {
				var _v0 = model.u_;
				if (_v0.$ === 3) {
					var summaryLines = _v0.a;
					return A2($author$project$Components$Commissions$Statement$SummaryLine$Details$viewSummaryLineTables, model.JW, summaryLines);
				} else {
					return $author$project$Ui$Spinner$view(
						_List_fromArray(
							[$author$project$Ui$Spinner$extraSmall]));
				}
			}()
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$viewSummaryLine = F3(
	function (summaryLinesDetails, index, summaryLine) {
		return A2(
			$author$project$Ui$ListGroup$item,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(4)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$map,
											$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$SummaryLineDetailsMsg(index),
											A2(
												$elm$core$Maybe$withDefault,
												$author$project$Utils$Html$empty,
												A2(
													$elm$core$Maybe$map,
													$author$project$Components$Commissions$Statement$SummaryLine$Details$button,
													A2($elm$core$Dict$get, index, summaryLinesDetails)))),
											$author$project$Utils$Html$noBreakSpace,
											$elm$html$Html$text(
											A2(
												$author$project$Api$Expandable$withDefault,
												'N/A',
												A2(
													$author$project$Api$Expandable$map,
													$author$project$Api$Provider$Broker$Min$name,
													$author$project$Api$Provider$Statement$SummaryLine$All$broker(summaryLine))))
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(5)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(
										$author$project$Api$Provider$Statement$SummaryLine$All$membershipsCount(summaryLine))),
									$elm$html$Html$text(' Primary, '),
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$String$pluralize,
										'Patient',
										$author$project$Api$Provider$Statement$SummaryLine$All$patientsCount(summaryLine)))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(3),
									$author$project$Ui$Grid$justifyRight
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$Statement$SummaryLine$All$payableAmountInCents(summaryLine)))
								]))
						])),
					A2(
					$elm$html$Html$map,
					$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$SummaryLineDetailsMsg(index),
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$Utils$Html$empty,
						A2(
							$elm$core$Maybe$map,
							$author$project$Components$Commissions$Statement$SummaryLine$Details$view,
							A2($elm$core$Dict$get, index, summaryLinesDetails))))
				]));
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$viewPanelBody = F2(
	function (statement, model) {
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanSm(6)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$elm$core$Basics$never,
								A2(
									$author$project$Ui$Breadcrumb$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Breadcrumb$item,
											_List_Nil,
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__Top(
														{cm: model.cm}),
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('All Statements')
														]))
												])),
											A2(
											$author$project$Ui$Breadcrumb$item,
											_List_fromArray(
												[
													$author$project$Ui$Breadcrumb$active(true)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													'#' + $elm$core$String$fromInt(
														$author$project$Api$Provider$Statement$One$number(statement)))
												]))
										])))
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanSm(6),
								$author$project$Ui$Grid$justifyRight
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$DownloadInvoiceMsg,
								A4(
									$author$project$Components$Invoice$DownloadFile$view,
									model.jt,
									$author$project$Api$Provider$Statement$One$securePdfInlineToken(statement),
									_List_Nil,
									_List_Nil))
							]))
					])),
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				$author$project$Ui$Typography$headingSm(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Statement  #'),
										$elm$html$Html$text(
										$elm$core$String$fromInt(
											$author$project$Api$Provider$Statement$One$number(statement)))
									])),
								A2(
								$author$project$Ui$Badge$fromString,
								_List_Nil,
								$author$project$Api$Provider$Statement$One$status(statement))
							]))
					])),
				$author$project$Ui$Typography$heading(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanSm(4)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$label('')
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$label,
												_List_fromArray(
													[$author$project$Ui$Typography$controlLabel]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2(
															$author$project$Formatters$Date$toString,
															$author$project$Formatters$Date$MonthAndYear,
															$author$project$Api$Provider$Statement$One$date(statement)))
													]))
											]))
									])),
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanSm(4),
										$author$project$Ui$Grid$offsetSm(4),
										$author$project$Ui$Grid$justifyRight
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$label('')
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$label,
												_List_fromArray(
													[$author$project$Ui$Typography$controlLabel]),
												_List_fromArray(
													[
														$elm$html$Html$text('TOTAL AMOUNT')
													])),
												$author$project$Utils$Html$noBreakSpace,
												$author$project$Utils$Html$noBreakSpace,
												A2(
												$author$project$Ui$Typography$strong,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Utils$Currency$fromInt(
															$author$project$Api$Provider$Statement$One$amountInCents(statement)))
													])),
												($author$project$Api$Provider$Statement$One$status(statement) !== 'paid') ? A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$textSm]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$label,
														_List_fromArray(
															[$author$project$Ui$Typography$controlLabel]),
														_List_fromArray(
															[
																$elm$html$Html$text('AMOUNT DUE')
															])),
														$author$project$Utils$Html$noBreakSpace,
														$author$project$Utils$Html$noBreakSpace,
														A2(
														$author$project$Ui$Typography$strong,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(
																$author$project$Utils$Currency$fromInt(
																	$author$project$Api$Provider$Statement$One$dueInCents(statement)))
															]))
													])) : $author$project$Utils$Html$empty
											]))
									]))
							]))
					])),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$spanSm(4)
											]),
										_List_fromArray(
											[
												$author$project$Ui$Panel$title(
												_List_fromArray(
													[
														$elm$html$Html$text('Summary')
													]))
											])),
										($author$project$Api$Provider$Statement$One$status(statement) === 'draft') ? A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$spanSm(4),
												$author$project$Ui$Grid$offsetSm(4),
												$author$project$Ui$Grid$justifyRight
											]),
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Button$view,
												{mm: 'Adjust statement'},
												_List_fromArray(
													[
														$author$project$Ui$Button$onClick(
														$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$Adjust(statement)),
														$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Adjustment')
													]))
											])) : $author$project$Ui$Grid$none
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								function () {
								var _v0 = model.u_;
								if (_v0.$ === 3) {
									var summaryLines = _v0.a;
									return A2(
										$author$project$Ui$ListGroup$view,
										_List_Nil,
										A2(
											$elm$core$List$indexedMap,
											$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$viewSummaryLine(model.lE),
											summaryLines));
								} else {
									return A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$textCenter]),
										_List_fromArray(
											[
												$author$project$Ui$Spinner$view(_List_Nil)
											]));
								}
							}()
							]))
					])),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Typography$headingSm(
								_List_fromArray(
									[
										$elm$html$Html$text('Patient Level Calculations')
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Commissions calculations for each patient can be viewed in the '),
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Commissions__StatementLines__Top,
										_List_fromArray(
											[
												$author$project$Ui$Link$routeParams(
												_List_fromArray(
													[
														A2(
														$elm$url$Url$Builder$string,
														'statement',
														$author$project$Api$Provider$Statement$One$id(statement)),
														A2($elm$url$Url$Builder$string, 'payable', 'true')
													]))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('statement lines report')
											])),
										$elm$html$Html$text('.')
									]))
							]))
					])),
				A3($author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$viewPaymentsList, model.Ij, statement, model.kD)
			]);
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$Issue = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$RecordPayment = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$viewPanelFooter = F2(
	function (issueRequest, statement) {
		return A2(
			$author$project$Ui$Panel$footer,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$textCenter]),
					_List_fromArray(
						[
							($author$project$Api$Provider$Statement$One$status(statement) === 'draft') ? A3(
							$author$project$Ui$Button$view,
							{mm: 'Issue statement'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$onClick(
									$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$Issue(statement)),
									$author$project$Ui$Button$loading(
									_Utils_eq(issueRequest, $author$project$Api$Data$Loading))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Issue Statement')
								])) : $author$project$Utils$Html$empty,
							($author$project$Api$Provider$Statement$One$status(statement) === 'issued') ? A3(
							$author$project$Ui$Button$view,
							{mm: 'Record payment'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$loading(
									_Utils_eq(issueRequest, $author$project$Api$Data$Loading)),
									$author$project$Ui$Button$onClick(
									$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$RecordPayment(statement)),
									$author$project$Ui$Button$icon($author$project$Ui$Icon$check)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Record Payment')
								])) : $author$project$Utils$Html$empty
						]))
				]));
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				function () {
				var _v0 = model.m$;
				if (!_v0.$) {
					var createPaymentModal = _v0.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$CreatePaymentModalMsg,
						$author$project$Components$Invoice$CreatePaymentModal$view(createPaymentModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v1 = model.il;
				if (!_v1.$) {
					var adjustmentModal = _v1.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$AdjustmentModalMsg,
						$author$project$Components$Commissions$Statement$AdjustmentModal$view(adjustmentModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$PaymentsListMsg,
				$author$project$Components$PaymentsList$modal(model.kD)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						function () {
							var _v2 = model.JW;
							if (_v2.$ === 3) {
								var statement = _v2.a;
								return A2($author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$viewPanelBody, statement, model);
							} else {
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$textCenter]),
										_List_fromArray(
											[
												$author$project$Ui$Spinner$view(_List_Nil)
											]))
									]);
							}
						}()),
						function () {
						var _v3 = model.JW;
						if (_v3.$ === 3) {
							var statement = _v3.a;
							return A2($author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$viewPanelFooter, model.oc, statement);
						} else {
							return $author$project$Ui$Panel$none;
						}
					}()
					]))
			]),
		ac9: 'Commissions | Statements'
	};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$init, aiq: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$load, k8: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$save, alO: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$subscriptions, adT: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$update, amo: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$view});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$Top$StatementsTableMsg = $elm$core$Basics$identity;
var $author$project$Components$Commissions$Statement$List$BrokerAccountResourceFilterMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Commissions$Statement$List$BrokerResourceFilterMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Commissions$Statement$List$DateRangeInputMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Commissions$Statement$List$StatusDropdownMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Commissions$Statement$List$dateRangeInputSettings = F2(
	function (start, end) {
		var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
		return _Utils_update(
			defaultSettings,
			{ahy: start, al5: end});
	});
var $author$project$Components$Commissions$Statement$List$GotStatements = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Statement$All$Statement = $elm$core$Basics$identity;
var $author$project$Api$Provider$Statement$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Statement$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Statement$listDefaults = {xF: $elm$core$Maybe$Nothing, xG: $elm$core$Maybe$Nothing, HB: $elm$core$Maybe$Nothing, ahP: $elm$core$Maybe$Nothing, ajJ: $author$project$Api$Pagination$init, akl: $elm$core$Maybe$Nothing, alA: $author$project$Api$Sort$init, JV: $elm$core$Maybe$Nothing, alH: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$Statement$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Statement$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.xG;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'broker_account', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.akl;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.ahP;
				if (!_v2.$) {
					var string = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v3 = options.JV;
				if (!_v3.$) {
					var start_ = _v3.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$date, 'start', start_)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v4 = options.HB;
				if (!_v4.$) {
					var end_ = _v4.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$date, 'end', end_)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v5 = options.alH;
				if (!_v5.$) {
					var string = _v5.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'status', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v6 = options.xF;
				if (!_v6.$) {
					var string = _v6.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'broker', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$Provider$Statement$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Statement$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Statement$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Statement$statementsPath)));
	});
var $author$project$Components$Commissions$Statement$List$fetchStatements = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Api$Provider$Statement$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						xF: model.GN,
						xG: model.cm,
						HB: A2(
							$elm$core$Maybe$map,
							A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
							model.HB),
						ajJ: model.ajJ,
						alA: model.alA,
						JV: A2(
							$elm$core$Maybe$map,
							A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
							model.JV),
						alH: model.alH
					});
			},
			$author$project$Components$Commissions$Statement$List$GotStatements);
	});
var $author$project$Components$ResourceFilter$BrokerAccount$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Api$Provider$BrokerAccount$All$BrokerAccount = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$BrokerAccount$All$Record = function (brokers) {
	return {MS: brokers};
};
var $author$project$Api$Provider$BrokerAccount$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'brokers',
	$elm$json$Json$Decode$list($author$project$Api$Provider$Broker$Shared$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$BrokerAccount$All$Record));
var $author$project$Api$Provider$BrokerAccount$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$BrokerAccount$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$BrokerAccount$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$BrokerAccount$All$BrokerAccount)));
var $author$project$Api$Provider$BrokerAccount$listDefaults = {ahP: $elm$core$Maybe$Nothing, ajJ: $author$project$Api$Pagination$init, akl: $elm$core$Maybe$Nothing, alA: $author$project$Api$Sort$init};
var $author$project$Api$Provider$BrokerAccount$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$BrokerAccount$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.akl;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.ahP;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$Provider$BrokerAccount$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$BrokerAccount$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$BrokerAccount$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$BrokerAccount$brokerAccountsPath)));
	});
var $author$project$Components$ResourceFilter$BrokerAccount$list = $author$project$Api$Provider$BrokerAccount$list;
var $author$project$Components$ResourceFilter$BrokerAccount$fetchResources = F5(
	function (listOptionals, toMsg, apiClient, pagination, query) {
		return A3(
			$author$project$Components$ResourceFilter$BrokerAccount$list,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{ajJ: pagination, akl: query});
				}),
			toMsg);
	});
var $author$project$Components$ResourceFilter$BrokerAccount$retrieveResource = F4(
	function (listOptionals, toMsg, apiClient, id) {
		return A3(
			$author$project$Components$ResourceFilter$BrokerAccount$list,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{
							ahP: $elm$core$Maybe$Just(id)
						});
				}),
			toMsg);
	});
var $author$project$Components$ResourceFilter$BrokerAccount$selectId = 'broker_accounts';
var $author$project$Api$Provider$BrokerAccount$All$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BrokerAccount$Shared$name(shared);
};
var $author$project$Components$ResourceFilter$BrokerAccount$toTitle = function (resource) {
	return $author$project$Api$Provider$BrokerAccount$All$name(resource);
};
var $author$project$Components$ResourceFilter$BrokerAccount$toLabel = function (resource) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Components$ResourceFilter$BrokerAccount$toTitle(resource))
		]);
};
var $author$project$Api$Provider$BrokerAccount$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BrokerAccount$Shared$id(shared);
};
var $author$project$Components$ResourceFilter$BrokerAccount$toValue = $author$project$Api$Provider$BrokerAccount$All$id;
var $author$project$Components$ResourceFilter$BrokerAccount$init = F3(
	function (apiClient, listOptionals, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{
				Sk: $author$project$Components$ResourceFilter$BrokerAccount$fetchResources(listOptionals),
				ahP: $author$project$Components$ResourceFilter$BrokerAccount$selectId,
				k$: 'Broker Account',
				uk: $author$project$Components$ResourceFilter$BrokerAccount$retrieveResource(listOptionals),
				u9: $author$project$Components$ResourceFilter$BrokerAccount$toLabel,
				lN: $author$project$Components$ResourceFilter$BrokerAccount$toTitle,
				hX: $author$project$Components$ResourceFilter$BrokerAccount$toValue
			},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{Jy: $author$project$Components$ResourceFilter$All, b8: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$Commissions$Statement$List$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('start'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.dd, 0)),
			model.JV),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('end'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.dd, 0)),
			model.HB),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('status'),
			model.alH),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('broker'),
			model.GN),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('broker_account'),
			model.cm)
		]);
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString(model.Is)
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.ajJ),
				A2(
					$elm$core$List$append,
					$author$project$Api$Sort$toQuery(model.alA),
					A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
};
var $author$project$Components$Commissions$Statement$List$init = function (config) {
	var brokerId = A2($elm$core$Dict$get, 'broker', config.DE);
	var brokerAccountId = function () {
		var _v5 = _Utils_Tuple2(
			config.cm,
			A2($elm$core$Dict$get, 'broker_account', config.DE));
		if (!_v5.a.$) {
			var fromConfig = _v5.a.a;
			return $elm$core$Maybe$Just(fromConfig);
		} else {
			if (!_v5.b.$) {
				var _v6 = _v5.a;
				var fromQuery = _v5.b.a;
				return $elm$core$Maybe$Just(fromQuery);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}
	}();
	var _v0 = $author$project$Utils$DateWithDefault$fromQuery(config.DE);
	var start = _v0.a;
	var end = _v0.b;
	var _v1 = A2(
		$author$project$Components$DateRangeInput$init,
		'date-range-input',
		A2(
			$author$project$Components$Commissions$Statement$List$dateRangeInputSettings,
			A2(
				$elm$core$Maybe$map,
				A2($author$project$Utils$DateWithDefault$toDate, config.dd, 0),
				start),
			A2(
				$elm$core$Maybe$map,
				A2($author$project$Utils$DateWithDefault$toDate, config.dd, 0),
				end)));
	var dateRangeInput = _v1.a;
	var dateRangeInputCmd = _v1.b;
	var _v2 = A3(
		$author$project$Components$ResourceFilter$Broker$init,
		config.Gv,
		function () {
			var _v3 = config.cm;
			if (!_v3.$) {
				var accountId = _v3.a;
				return function (d) {
					return _Utils_update(
						d,
						{
							xG: $elm$core$Maybe$Just(accountId)
						});
				};
			} else {
				return $elm$core$Basics$identity;
			}
		}(),
		function (d) {
			return _Utils_update(
				d,
				{Gp: 'All Brokers', akb: brokerId});
		});
	var brokerResourceFilter = _v2.a;
	var brokerResourceFilterCmd = _v2.b;
	var _v4 = A3(
		$author$project$Components$ResourceFilter$BrokerAccount$init,
		config.Gv,
		$elm$core$Basics$identity,
		function (d) {
			return _Utils_update(
				d,
				{Gp: 'All Broker Accounts', akb: brokerAccountId});
		});
	var brokerAccountResourceFilter = _v4.a;
	var brokerAccountResourceFilterCmd = _v4.b;
	var model = {
		cm: brokerAccountId,
		mw: brokerAccountResourceFilter,
		GN: brokerId,
		mx: brokerResourceFilter,
		rx: config.rx,
		ry: config.ry,
		rz: config.rz,
		dd: config.dd,
		i4: dateRangeInput,
		HB: end,
		Is: config.Is,
		ajJ: $author$project$Api$Pagination$initFromQuery(config.DE),
		fg: config.fg,
		alA: $author$project$Api$Sort$initFromQuery(config.DE),
		JV: start,
		cc: $author$project$Api$Data$Loading,
		alH: A2($elm$core$Dict$get, 'status', config.DE),
		qn: $author$project$Ui$Dropdown$init(
			$author$project$Ui$Dropdown$defaultConfig(
				{ahP: 'status-dropdown-filter', al6: $author$project$Components$Commissions$Statement$List$StatusDropdownMsg}))
	};
	return _Utils_Tuple2(
		model,
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$Statement$List$DateRangeInputMsg, dateRangeInputCmd),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$Statement$List$BrokerResourceFilterMsg, brokerResourceFilterCmd),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$Statement$List$BrokerAccountResourceFilterMsg, brokerAccountResourceFilterCmd),
					A2($author$project$Components$Commissions$Statement$List$fetchStatements, config.Gv, model),
					$author$project$Components$Commissions$Statement$List$updateUrl(model)
				])));
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$Top$init = F4(
	function (_v0, _v1, shared, _v2) {
		var query = _v2.DE;
		var params = _v2.YL;
		var _v3 = $author$project$Components$Commissions$Statement$List$init(
			{
				Gv: shared.Gv,
				cm: $elm$core$Maybe$Just(params.cm),
				rx: false,
				ry: true,
				rz: false,
				dd: shared.dd,
				Is: $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__Top(
					{cm: params.cm}),
				DE: query,
				fg: false
			});
		var statementsTable = _v3.a;
		var statementsTableCmd = _v3.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, s1: statementsTable},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, statementsTableCmd));
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$ResourceFilter$BrokerAccount$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.b8));
};
var $author$project$Components$Commissions$Statement$List$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Commissions$Statement$List$DateRangeInputMsg,
				$author$project$Components$DateRangeInput$subscriptions(model.i4)),
				$author$project$Ui$Dropdown$subscriptions(model.qn),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Commissions$Statement$List$BrokerResourceFilterMsg,
				$author$project$Components$ResourceFilter$Broker$subscriptions(model.mx)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Commissions$Statement$List$BrokerAccountResourceFilterMsg,
				$author$project$Components$ResourceFilter$BrokerAccount$subscriptions(model.mw))
			]));
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$Top$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Commissions$Statement$List$subscriptions(model.s1));
};
var $author$project$Components$ResourceFilter$BrokerAccount$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.b8);
		var modelAfterEvent = function () {
			var _v1 = result.agZ;
			if (!_v1.$) {
				var selected = _v1.a;
				return _Utils_update(
					model,
					{Jy: selected});
			} else {
				return model;
			}
		}();
		return {
			GZ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.GZ),
			agZ: result.agZ,
			aiO: _Utils_update(
				modelAfterEvent,
				{b8: result.aiO}),
			aR: result.aR
		};
	});
var $author$project$Components$ResourceFilter$BrokerAccount$value = function (model) {
	return A2($author$project$Components$ResourceFilter$choiceToValue, model.b8, model.Jy);
};
var $author$project$Components$Commissions$Statement$List$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ),
								cc: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cc: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Commissions$Statement$List$fetchStatements, apiClient, newModel),
								$author$project$Components$Commissions$Statement$List$updateUrl(newModel)
							])),
					_List_Nil);
			case 2:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						alA: A2($author$project$Api$Sort$update, columnId, model.alA)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Commissions$Statement$List$fetchStatements, apiClient, newModel),
								$author$project$Components$Commissions$Statement$List$updateUrl(newModel)
							])),
					_List_Nil);
			case 3:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Components$DateRangeInput$update, subMsg, model.i4);
				var dateRangeInput = _v2.a;
				var subCmd = _v2.b;
				var event = _v2.c;
				var newModel = function () {
					if (event.$ === 1) {
						var fromDate = event.a;
						var toDate = event.b;
						return _Utils_update(
							model,
							{
								i4: dateRangeInput,
								HB: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
								ajJ: $author$project$Api$Pagination$reset(model.ajJ),
								JV: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate),
								cc: $author$project$Api$Data$Loading
							});
					} else {
						return _Utils_update(
							model,
							{i4: dateRangeInput});
					}
				}();
				var cmds = (_Utils_eq(newModel.JV, model.JV) && _Utils_eq(newModel.HB, model.HB)) ? _List_Nil : _List_fromArray(
					[
						A2($author$project$Components$Commissions$Statement$List$fetchStatements, apiClient, newModel),
						$author$project$Components$Commissions$Statement$List$updateUrl(newModel)
					]);
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$cons,
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$Statement$List$DateRangeInputMsg, subCmd),
							cmds)),
					_List_Nil);
			case 4:
				var subMsg = msg.a;
				var _v4 = A2($author$project$Ui$Dropdown$update, subMsg, model.qn);
				var statusDropdown = _v4.a;
				var cmd = _v4.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qn: statusDropdown}),
					cmd,
					_List_Nil);
			case 5:
				var status = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ajJ: $author$project$Api$Pagination$reset(model.ajJ),
						cc: $author$project$Api$Data$Loading,
						alH: status
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Commissions$Statement$List$fetchStatements, apiClient, newModel),
								$author$project$Components$Commissions$Statement$List$updateUrl(newModel)
							])),
					_List_Nil);
			case 6:
				var subMsg = msg.a;
				var brokerResourceResult = A3($author$project$Components$ResourceFilter$Broker$update, apiClient, subMsg, model.mx);
				var brokerId = function () {
					var _v6 = brokerResourceResult.agZ;
					if (!_v6.$) {
						return $author$project$Components$ResourceFilter$Broker$value(brokerResourceResult.aiO);
					} else {
						return model.GN;
					}
				}();
				var newModel = _Utils_update(
					model,
					{GN: brokerId, mx: brokerResourceResult.aiO});
				var _v5 = _Utils_eq(model.GN, newModel.GN) ? _Utils_Tuple2(model.cc, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					$author$project$Api$Data$Loading,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Commissions$Statement$List$fetchStatements, apiClient, newModel),
								$author$project$Components$Commissions$Statement$List$updateUrl(newModel)
							])));
				var statements = _v5.a;
				var cmd = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{cc: statements}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$Statement$List$BrokerResourceFilterMsg, brokerResourceResult.GZ),
								cmd
							])),
					brokerResourceResult.aR);
			default:
				var subMsg = msg.a;
				var brokerAccountResourceResult = A3($author$project$Components$ResourceFilter$BrokerAccount$update, apiClient, subMsg, model.mw);
				var brokerAccountId = function () {
					var _v8 = brokerAccountResourceResult.agZ;
					if (!_v8.$) {
						return $author$project$Components$ResourceFilter$BrokerAccount$value(brokerAccountResourceResult.aiO);
					} else {
						return model.cm;
					}
				}();
				var newModel = _Utils_update(
					model,
					{cm: brokerAccountId, mw: brokerAccountResourceResult.aiO});
				var _v7 = _Utils_eq(model.cm, newModel.cm) ? _Utils_Tuple2(model.cc, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					$author$project$Api$Data$Loading,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Commissions$Statement$List$fetchStatements, apiClient, newModel),
								$author$project$Components$Commissions$Statement$List$updateUrl(newModel)
							])));
				var statements = _v7.a;
				var cmd = _v7.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{cc: statements}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$Statement$List$BrokerAccountResourceFilterMsg, brokerAccountResourceResult.GZ),
								cmd
							])),
					brokerAccountResourceResult.aR);
		}
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$Top$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Commissions$Statement$List$update, model.Gv, subMsg, model.s1);
		var statementsTable = _v1.a;
		var statementsTableCmd = _v1.b;
		var statementsTableOutMsgs = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{s1: statementsTable}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, statementsTableCmd),
			statementsTableOutMsgs);
	});
var $author$project$Components$Commissions$Statement$List$PaginationMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$ResourceFilter$BrokerAccount$view = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$view,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.Jy),
					options),
				model.b8));
	});
var $author$project$Components$Commissions$Statement$List$viewBrokerAccountResourceFilter = function (brokerAccountResourceFilter) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Commissions$Statement$List$BrokerAccountResourceFilterMsg,
		A2($author$project$Components$ResourceFilter$BrokerAccount$view, _List_Nil, brokerAccountResourceFilter));
};
var $author$project$Components$Commissions$Statement$List$viewBrokerResourceFilter = function (brokerResourceFilter) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Commissions$Statement$List$BrokerResourceFilterMsg,
		A2($author$project$Components$ResourceFilter$Broker$view, _List_Nil, brokerResourceFilter));
};
var $author$project$Components$Commissions$Statement$List$SortTable = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Commissions$Statement$List$columns = function (showAccount) {
	return $elm$core$List$concat(
		_List_fromArray(
			[
				_List_fromArray(
				[
					A3($author$project$Api$Column$init, 'number', true, 'Number')
				]),
				showAccount ? _List_fromArray(
				[
					A3($author$project$Api$Column$init, 'broker_account', false, 'Broker Account')
				]) : _List_Nil,
				_List_fromArray(
				[
					A3($author$project$Api$Column$init, 'date', true, 'Period'),
					A3($author$project$Api$Column$init, 'amount_in_cents', true, 'Bill Amount'),
					A3($author$project$Api$Column$init, 'status', true, 'Status')
				])
			]));
};
var $author$project$Api$Provider$Statement$All$amountInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Statement$Shared$amountInCents(shared);
};
var $author$project$Api$Provider$Statement$Shared$brokerAccount = function (_v0) {
	var record = _v0;
	return record.xG;
};
var $author$project$Api$Provider$Statement$All$brokerAccount = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Statement$Shared$brokerAccount(shared);
};
var $author$project$Api$Provider$Statement$All$date = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Statement$Shared$date(shared);
};
var $author$project$Api$Provider$Statement$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Statement$Shared$id(shared);
};
var $author$project$Api$Provider$Statement$All$number = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Statement$Shared$number(shared);
};
var $author$project$Api$Provider$Statement$All$status = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Statement$Shared$status(shared);
};
var $author$project$Components$Commissions$Statement$List$viewStatement = F2(
	function (model, statement) {
		var brokerAccount = $author$project$Api$Provider$Statement$All$brokerAccount(statement);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_fromArray(
								[
									model.fg ? $author$project$Ui$Table$cellSpan(1) : $author$project$Ui$Table$cellSpan(2)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__StatementId_String(
										{
											cm: $author$project$Api$Provider$BrokerAccount$Shared$id(brokerAccount),
											alG: $author$project$Api$Provider$Statement$All$id(statement)
										}),
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('#'),
											$elm$html$Html$text(
											$elm$core$String$fromInt(
												$author$project$Api$Provider$Statement$All$number(statement)))
										]))
								]))
						]),
						model.fg ? _List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_fromArray(
								[
									$author$project$Ui$Table$cellSpan(3)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$BrokerAccount$Shared$name(brokerAccount))
								]))
						]) : _List_Nil,
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_fromArray(
								[
									model.fg ? $author$project$Ui$Table$cellSpan(2) : $author$project$Ui$Table$cellSpan(3)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$Date$toString,
										$author$project$Formatters$Date$MonthAndYear,
										$author$project$Api$Provider$Statement$All$date(statement)))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_fromArray(
								[
									model.fg ? $author$project$Ui$Table$cellSpan(2) : $author$project$Ui$Table$cellSpan(3)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$Statement$All$amountInCents(statement)))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_fromArray(
								[
									$author$project$Ui$Table$cellSpan(2)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Badge$fromString,
									_List_Nil,
									$author$project$Api$Provider$Statement$All$status(statement))
								]))
						])
					])));
	});
var $author$project$Components$Commissions$Statement$List$viewPanelBody = function (model) {
	var _v0 = function () {
		var _v1 = model.cc;
		if (_v1.$ === 3) {
			var statements_ = _v1.a;
			return _Utils_Tuple2(false, statements_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var statements = _v0.b;
	return _List_fromArray(
		[
			A4(
			$author$project$Ui$Table$view,
			_List_fromArray(
				[
					$author$project$Ui$Table$verticalCentered,
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('No statements found.')
						])),
					$author$project$Ui$Table$loading(loading)
				]),
			A2(
				$elm$core$List$map,
				$author$project$Api$Column$view(
					A2($author$project$Api$Column$Sortable, model.alA, $author$project$Components$Commissions$Statement$List$SortTable)),
				$author$project$Components$Commissions$Statement$List$columns(model.fg)),
			A2(
				$elm$core$List$map,
				$author$project$Components$Commissions$Statement$List$viewStatement(model),
				statements),
			_List_Nil)
		]);
};
var $author$project$Components$Commissions$Statement$List$StatusOptionSelected = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Commissions$Statement$List$viewStatusDropdown = function (model) {
	var currentText = function () {
		var _v0 = model.alH;
		_v0$3:
		while (true) {
			if (!_v0.$) {
				switch (_v0.a) {
					case 'draft':
						return 'Draft';
					case 'issued':
						return 'Issued';
					case 'paid':
						return 'Paid';
					default:
						break _v0$3;
				}
			} else {
				break _v0$3;
			}
		}
		return 'Status';
	}();
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(currentText)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Dropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$Dropdown$onSelect(
						$author$project$Components$Commissions$Statement$List$StatusOptionSelected($elm$core$Maybe$Nothing)),
						$author$project$Ui$Dropdown$selected(
						_Utils_eq(model.alH, $elm$core$Maybe$Nothing))
					]),
				$elm$html$Html$text('All')),
				$author$project$Ui$Dropdown$separator,
				A2(
				$author$project$Ui$Dropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$Dropdown$onSelect(
						$author$project$Components$Commissions$Statement$List$StatusOptionSelected(
							$elm$core$Maybe$Just('draft'))),
						$author$project$Ui$Dropdown$selected(
						_Utils_eq(
							model.alH,
							$elm$core$Maybe$Just('draft')))
					]),
				$elm$html$Html$text('Draft')),
				A2(
				$author$project$Ui$Dropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$Dropdown$onSelect(
						$author$project$Components$Commissions$Statement$List$StatusOptionSelected(
							$elm$core$Maybe$Just('issued'))),
						$author$project$Ui$Dropdown$selected(
						_Utils_eq(
							model.alH,
							$elm$core$Maybe$Just('issued')))
					]),
				$elm$html$Html$text('Issued')),
				A2(
				$author$project$Ui$Dropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$Dropdown$onSelect(
						$author$project$Components$Commissions$Statement$List$StatusOptionSelected(
							$elm$core$Maybe$Just('paid'))),
						$author$project$Ui$Dropdown$selected(
						_Utils_eq(
							model.alH,
							$elm$core$Maybe$Just('paid')))
					]),
				$elm$html$Html$text('Paid'))
			]),
		model.qn);
};
var $author$project$Components$Commissions$Statement$List$view = function (model) {
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mb2]),
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('View Statements')
									]))
							])),
						model.rz ? A2(
						$author$project$Ui$Grid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanSm(12)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Components$Commissions$Statement$List$DateRangeInputMsg,
										$author$project$Components$DateRangeInput$view(model.i4))
									]))
							])) : $author$project$Utils$Html$empty,
						A2(
						$author$project$Ui$Grid$row,
						_List_Nil,
						_List_fromArray(
							[
								model.ry ? A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanSm(6),
										$author$project$Ui$Grid$spanMd(3)
									]),
								_List_fromArray(
									[
										$author$project$Components$Commissions$Statement$List$viewBrokerResourceFilter(model.mx)
									])) : $author$project$Ui$Grid$none,
								model.rx ? A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanSm(6),
										$author$project$Ui$Grid$spanMd(3)
									]),
								_List_fromArray(
									[
										$author$project$Components$Commissions$Statement$List$viewBrokerAccountResourceFilter(model.mw)
									])) : $author$project$Ui$Grid$none,
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanSm(2)
									]),
								_List_fromArray(
									[
										$author$project$Components$Commissions$Statement$List$viewStatusDropdown(model)
									]))
							]))
					])),
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				$author$project$Components$Commissions$Statement$List$viewPanelBody(model)),
				A2(
				$author$project$Ui$Panel$footer,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Components$Commissions$Statement$List$PaginationMsg,
						A2(
							$author$project$Api$Pagination$view,
							_List_fromArray(
								[
									$author$project$Ui$Pagination$List$loading(
									!$author$project$Utils$Maybe$toBool(
										$author$project$Api$Data$toMaybe(model.cc)))
								]),
							model.ajJ))
					]))
			]));
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$Top$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Commissions$Statement$List$view(model.s1))
			]),
		ac9: 'Commissions | Statements'
	};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$Top$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$Top$init, aiq: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$Top$load, k8: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$Top$save, alO: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$Top$subscriptions, adT: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$Top$update, amo: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$Top$view});
var $author$project$Components$Commissions$BrokerAccount$Form$GotItem = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$Form$Model = $elm$core$Basics$identity;
var $author$project$Components$Commissions$BrokerAccount$Form$AddressInputMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$Form$formFieldsInit = function () {
	var _v0 = $author$project$Components$AddressInput$init('broker_account');
	var addressInput = _v0.a;
	var addressInputCmd = _v0.b;
	return _Utils_Tuple2(
		{K2: addressInput, Q9: $elm$core$Maybe$Nothing, Xw: true, Bq: '', abB: $elm$core$Maybe$Nothing},
		A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$Form$AddressInputMsg, addressInputCmd));
}();
var $author$project$Api$Provider$BrokerAccount$One$ratePeriodSchedule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BrokerAccount$Shared$ratePeriodSchedule(shared);
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$pricingStructureFromApi = function (pricingStructure) {
	return {
		Qr: $elm$core$Maybe$Just(
			$author$project$Api$Provider$PricingStructure$Shared$description(pricingStructure)),
		ahn: $elm$core$Maybe$Just(
			$author$project$Currency$fromInt(
				$author$project$Api$Provider$PricingStructure$Shared$fixedAmountInCents(pricingStructure))),
		ahP: $elm$core$Maybe$Just(
			$author$project$Api$Provider$PricingStructure$Shared$id(pricingStructure)),
		ajZ: $elm$core$Maybe$Just(
			$author$project$Percentage$fromFloat(
				$author$project$Api$Provider$PricingStructure$Shared$percentage(pricingStructure))),
		akg: $elm$core$Maybe$Just(
			$author$project$Api$Provider$PricingStructure$Shared$pricingType(pricingStructure)),
		alD: $elm$core$Maybe$Just(
			$author$project$Api$Provider$PricingStructure$Shared$splitType(pricingStructure))
	};
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$ratePeriodScheduleIntervalToInterval = function (ratePeriodScheduleInterval) {
	return {
		ah2: $author$project$Api$Provider$RatePeriodScheduleInterval$Shared$intervalInMonths(ratePeriodScheduleInterval),
		_l: $author$project$Components$Commissions$BrokerAccount$RetailSchedule$pricingStructureFromApi(
			$author$project$Api$Provider$RatePeriodScheduleInterval$Shared$pricingStructure(ratePeriodScheduleInterval))
	};
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$currentIntervalsFromApi = function (brokerAccount) {
	return A2(
		$elm$core$Maybe$map,
		$elm$core$List$map($author$project$Components$Commissions$BrokerAccount$RetailSchedule$ratePeriodScheduleIntervalToInterval),
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$RatePeriodSchedule$Shared$intervals,
			A2($elm$core$Maybe$andThen, $author$project$Api$Provider$BrokerAccount$One$ratePeriodSchedule, brokerAccount)));
};
var $author$project$Api$Provider$BrokerAccount$Meta$currentScheduleEnded = function (_v0) {
	var record = _v0;
	return record.Pi;
};
var $author$project$Api$Provider$BrokerAccount$One$futureRatePeriodSchedule = function (_v0) {
	var record = _v0.b;
	return record.SO;
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$futureIntervalsFromApi = function (brokerAccount) {
	return A2(
		$elm$core$Maybe$map,
		$elm$core$List$map($author$project$Components$Commissions$BrokerAccount$RetailSchedule$ratePeriodScheduleIntervalToInterval),
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$RatePeriodSchedule$Shared$intervals,
			A2($elm$core$Maybe$andThen, $author$project$Api$Provider$BrokerAccount$One$futureRatePeriodSchedule, brokerAccount)));
};
var $author$project$Api$Provider$BrokerAccount$One$futureRatePeriodScheduleStartDate = function (_v0) {
	var record = _v0.b;
	return record.SP;
};
var $author$project$Api$Provider$BrokerAccount$Meta$futureScheduleEnded = function (_v0) {
	var record = _v0;
	return record.SQ;
};
var $author$project$Api$Provider$BrokerAccount$One$meta = function (_v0) {
	var record = _v0.b;
	return record.W4;
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$init = F3(
	function (timeZone, currentDate, brokerAccount) {
		var futureStartDate_ = A2(
			$elm$core$Maybe$map,
			$justinmimbs$date$Date$fromPosix(timeZone),
			A2($elm$core$Maybe$andThen, $author$project$Api$Provider$BrokerAccount$One$futureRatePeriodScheduleStartDate, brokerAccount));
		var futureScheduleEnded = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$BrokerAccount$Meta$futureScheduleEnded,
				A2($elm$core$Maybe$map, $author$project$Api$Provider$BrokerAccount$One$meta, brokerAccount)));
		var currentScheduleEnded = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$BrokerAccount$Meta$currentScheduleEnded,
				A2($elm$core$Maybe$map, $author$project$Api$Provider$BrokerAccount$One$meta, brokerAccount)));
		return {
			fy: $elm$core$Maybe$Nothing,
			fz: $elm$core$Maybe$Nothing,
			ig: $elm$core$Maybe$Nothing,
			xG: brokerAccount,
			c3: $elm$core$Maybe$Nothing,
			dd: currentDate,
			aI: $author$project$Components$Commissions$BrokerAccount$RetailSchedule$currentIntervalsFromApi(brokerAccount),
			Pi: currentScheduleEnded,
			jE: $elm$core$Maybe$Nothing,
			ah: $author$project$Components$Commissions$BrokerAccount$RetailSchedule$futureIntervalsFromApi(brokerAccount),
			SQ: futureScheduleEnded,
			gv: futureStartDate_,
			ak0: A2(
				$elm$core$Maybe$withDefault,
				false,
				A2($elm$core$Maybe$map, $author$project$Api$Provider$BrokerAccount$One$retailEnabled, brokerAccount))
		};
	});
var $author$project$Components$Commissions$BrokerAccount$Form$init = F5(
	function (apiClient, timeZone, currentDate, session, id) {
		var _v0 = function () {
			if (!id.$) {
				var id_ = id.a;
				return _Utils_Tuple2(
					$elm$core$Maybe$Nothing,
					A3($author$project$Api$Provider$BrokerAccount$retrieve, apiClient, id_, $author$project$Components$Commissions$BrokerAccount$Form$GotItem));
			} else {
				var _v2 = $author$project$Components$Commissions$BrokerAccount$Form$formFieldsInit;
				var formFields = _v2.a;
				var formFieldsCmd = _v2.b;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_Tuple2(
							$author$project$Utils$Form$init(formFields),
							A3($author$project$Components$Commissions$BrokerAccount$RetailSchedule$init, timeZone, currentDate, $elm$core$Maybe$Nothing))),
					formFieldsCmd);
			}
		}();
		var form = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			{fG: $elm$core$Maybe$Nothing, dd: currentDate, f7: $elm$core$Maybe$Nothing, gm: $elm$core$Maybe$Nothing, SD: form, ahP: id, Io: $elm$core$Maybe$Nothing, k9: $author$project$Api$Data$NotAsked, aa4: session, J8: timeZone, qQ: $author$project$Api$Data$NotAsked},
			cmd);
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Top$init = F4(
	function (session, _v0, _v1, _v2) {
		var apiClient = _v1.Gv;
		var timeZone = _v1.J8;
		var currentDate = _v1.dd;
		var params = _v2.YL;
		var _v3 = A5(
			$author$project$Components$Commissions$BrokerAccount$Form$init,
			apiClient,
			timeZone,
			currentDate,
			session,
			$elm$core$Maybe$Just(params.cm));
		var form = _v3.a;
		var cmd = _v3.b;
		return _Utils_Tuple2(
			{Gv: apiClient, SD: form},
			cmd);
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Commissions$BrokerAccount$Form$ArchiveHiConfirmClosed = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Components$Commissions$BrokerAccount$Form$DeleteHiConfirmClosed = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Components$Commissions$BrokerAccount$Form$EndModalMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$Form$RetailScheduleMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModalMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModalMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModalMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$CancelHiConfirmClosed = F3(
	function (a, b, c) {
		return {$: 11, a: a, b: b, c: c};
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModalMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$Close = {$: 1};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$PricingStructureSelectMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$Close),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$PricingStructureSelectMsg,
				$author$project$Components$PricingStructureSelect$subscriptions(model.pk))
			]));
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$Close = {$: 1};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$PricingStructureSelectMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$Close),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$PricingStructureSelectMsg,
				$author$project$Components$PricingStructureSelect$subscriptions(model.pk))
			]));
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$Close = {$: 1};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$Close);
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$Close = {$: 1};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$Close);
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2(
						$elm$core$Maybe$map,
						function (_v0) {
							var retailModal = _v0.c;
							return $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$subscriptions(retailModal);
						},
						model.fy))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2(
						$elm$core$Maybe$map,
						function (_v1) {
							var endDealModal = _v1.b;
							return $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$subscriptions(endDealModal);
						},
						model.jE))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2(
						$elm$core$Maybe$map,
						function (_v2) {
							var changeModal = _v2.c;
							return $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$subscriptions(changeModal);
						},
						model.fz))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$subscriptions, model.ig))),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					function (_v3) {
						var isCurrent = _v3.a;
						var index = _v3.b;
						return $author$project$Components$HiConfirm$subscribeToEscapeKeyPress(
							A2($author$project$Components$Commissions$BrokerAccount$RetailSchedule$CancelHiConfirmClosed, isCurrent, index));
					},
					model.c3))
			]));
};
var $author$project$Components$Commissions$BrokerAccount$Form$subscriptions = function (_v0) {
	var archiveRequest = _v0.fG;
	var deleteRequest = _v0.f7;
	var endModal = _v0.gm;
	var form = _v0.SD;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				function () {
				if (!endModal.$) {
					var justEndModal = endModal.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Components$Commissions$BrokerAccount$Form$EndModalMsg,
						$author$project$Components$Broker$EndModal$subscriptions(justEndModal));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				function () {
				if (!form.$) {
					var _v3 = form.a;
					var itemForm = _v3.a;
					var retailSchedule = _v3.b;
					var _v4 = $author$project$Utils$Form$fields(itemForm);
					var address = _v4.K2;
					return $elm$core$Platform$Sub$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Platform$Sub$map,
								$author$project$Components$Commissions$BrokerAccount$Form$RetailScheduleMsg,
								$author$project$Components$Commissions$BrokerAccount$RetailSchedule$subscriptions(retailSchedule)),
								A2(
								$elm$core$Platform$Sub$map,
								$author$project$Components$Commissions$BrokerAccount$Form$AddressInputMsg,
								$author$project$Components$AddressInput$subscriptions(address))
							]));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Commissions$BrokerAccount$Form$ArchiveHiConfirmClosed),
					A2($elm$core$Maybe$map, $elm$core$Tuple$first, archiveRequest))),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Commissions$BrokerAccount$Form$DeleteHiConfirmClosed),
					A2($elm$core$Maybe$map, $elm$core$Tuple$first, deleteRequest)))
			]));
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Top$subscriptions = function (model) {
	return $author$project$Components$Commissions$BrokerAccount$Form$subscriptions(model.SD);
};
var $author$project$Components$Commissions$BrokerAccount$Form$Address = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$Form$Archived = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Components$Broker$EndModal$BrokerAccount = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$Form$Deleted = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Api$Provider$BrokerAccount$archive = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$BrokerAccount$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['archive']),
					$author$project$Api$Provider$BrokerAccount$brokerAccountPath(id))));
	});
var $author$project$Components$Commissions$BrokerAccount$Form$RatePeriodScheduleCreated = F3(
	function (a, b, c) {
		return {$: 6, a: a, b: b, c: c};
	});
var $author$project$Api$Provider$RatePeriodSchedule$One$RatePeriodSchedule = 0;
var $author$project$Api$Provider$RatePeriodSchedule$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Provider$BrokerAccount$RatePeriodSchedule$encodePricingStructure = function (pricingStructure) {
	return $elm$json$Json$Encode$object(
		$elm$core$List$concat(
			_List_fromArray(
				[
					function () {
					var _v0 = pricingStructure.ahP;
					if (!_v0.$) {
						var string = _v0.a;
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'id',
								$elm$json$Json$Encode$string(string))
							]);
					} else {
						return _List_Nil;
					}
				}(),
					function () {
					var _v1 = pricingStructure.Qr;
					if (!_v1.$) {
						var string = _v1.a;
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'description',
								$elm$json$Json$Encode$string(string))
							]);
					} else {
						return _List_Nil;
					}
				}(),
					function () {
					var _v2 = pricingStructure.ahn;
					if (!_v2.$) {
						var _int = _v2.a;
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'fixed_amount_in_cents',
								$author$project$Currency$encode(_int))
							]);
					} else {
						return _List_Nil;
					}
				}(),
					function () {
					var _v3 = pricingStructure.ajZ;
					if (!_v3.$) {
						var percentage = _v3.a;
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'percentage',
								$author$project$Percentage$encode(percentage))
							]);
					} else {
						return _List_Nil;
					}
				}(),
					function () {
					var _v4 = pricingStructure.alD;
					if (!_v4.$) {
						var splitType = _v4.a;
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'split_type',
								$author$project$Api$SplitType$encode(splitType))
							]);
					} else {
						return _List_Nil;
					}
				}(),
					function () {
					var _v5 = pricingStructure.akg;
					if (!_v5.$) {
						var pricingType_ = _v5.a;
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'pricing_type',
								$author$project$Api$PricingType$encode(pricingType_))
							]);
					} else {
						return _List_Nil;
					}
				}()
				])));
};
var $author$project$Api$Provider$BrokerAccount$RatePeriodSchedule$ratePeriodSchedulesPath = function (brokerAccountId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['rate_period_schedules']),
		$author$project$Api$Provider$BrokerAccount$brokerAccountPath(brokerAccountId));
};
var $author$project$Api$Provider$BrokerAccount$RatePeriodSchedule$create = F5(
	function (apiClient, brokerAccountId, brokerAccountFields, fields, toMsg) {
		var encodeInterval = function (interval) {
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'interval_in_months',
						A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, interval.ah2)),
						_Utils_Tuple2(
						'pricing_structure',
						$author$project$Api$Provider$BrokerAccount$RatePeriodSchedule$encodePricingStructure(interval._l))
					]));
		};
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'broker_account',
					$elm$json$Json$Encode$object(
						$elm$core$List$concat(
							_List_fromArray(
								[
									function () {
									var _v0 = brokerAccountFields.ak0;
									if (!_v0.$) {
										var retailEnabled = _v0.a;
										return _List_fromArray(
											[
												_Utils_Tuple2(
												'retail_enabled',
												$elm$json$Json$Encode$bool(retailEnabled))
											]);
									} else {
										return _List_Nil;
									}
								}(),
									function () {
									var _v1 = brokerAccountFields.SP;
									if (!_v1.$) {
										var futureRatePeriodScheduleStartDate = _v1.a;
										return _List_fromArray(
											[
												_Utils_Tuple2(
												'future_rate_period_schedule_start_date',
												$author$project$Utils$Date$encode(futureRatePeriodScheduleStartDate))
											]);
									} else {
										return _List_Nil;
									}
								}()
								])))),
					_Utils_Tuple2(
					'rate_period_schedule',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'intervals',
								A2($elm$json$Json$Encode$list, encodeInterval, fields.ah3))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$RatePeriodSchedule$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$BrokerAccount$RatePeriodSchedule$ratePeriodSchedulesPath(brokerAccountId))));
	});
var $author$project$Components$Commissions$BrokerAccount$Form$createRetailSchedule = F5(
	function (apiClient, isUpdate, brokerAccount, brokerAccountFields, intervals) {
		return A5(
			$author$project$Api$Provider$BrokerAccount$RatePeriodSchedule$create,
			apiClient,
			$author$project$Api$Provider$BrokerAccount$One$id(brokerAccount),
			brokerAccountFields,
			{ah3: intervals},
			A2($author$project$Components$Commissions$BrokerAccount$Form$RatePeriodScheduleCreated, isUpdate, brokerAccount));
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$currentIntervals = function ($) {
	return $.aI;
};
var $author$project$Api$Provider$BrokerAccount$delete = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$BrokerAccount$brokerAccountPath(id)));
	});
var $author$project$Api$Provider$BrokerAccount$One$addressCity = function (_v0) {
	var record = _v0.b;
	return record.K3;
};
var $author$project$Api$Provider$BrokerAccount$One$addressCountry = function (_v0) {
	var record = _v0.b;
	return record.K4;
};
var $author$project$Api$Provider$BrokerAccount$One$addressLine1 = function (_v0) {
	var record = _v0.b;
	return record.K5;
};
var $author$project$Api$Provider$BrokerAccount$One$addressLine2 = function (_v0) {
	var record = _v0.b;
	return record.K6;
};
var $author$project$Api$Provider$BrokerAccount$One$addressState = function (_v0) {
	var record = _v0.b;
	return record.K7;
};
var $author$project$Api$Provider$BrokerAccount$One$addressZip = function (_v0) {
	var record = _v0.b;
	return record.K8;
};
var $author$project$Api$Provider$BrokerAccount$One$ein = function (_v0) {
	var record = _v0.b;
	return record.Q9;
};
var $author$project$Api$Provider$BrokerAccount$Shared$multipleBrokers = function (_v0) {
	var record = _v0;
	return record.Xw;
};
var $author$project$Api$Provider$BrokerAccount$One$multipleBrokers = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BrokerAccount$Shared$multipleBrokers(shared);
};
var $author$project$Api$Provider$BrokerAccount$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BrokerAccount$Shared$name(shared);
};
var $author$project$Api$Provider$BrokerAccount$One$singleBrokerName = function (_v0) {
	var record = _v0.b;
	return record.abB;
};
var $author$project$Components$Commissions$BrokerAccount$Form$formFieldsFromItem = function (brokerAccount) {
	var _v0 = A2(
		$author$project$Components$AddressInput$initFromFields,
		'broker_account',
		{
			cZ: $author$project$Api$Provider$BrokerAccount$One$addressLine1(brokerAccount),
			fA: $author$project$Api$Provider$BrokerAccount$One$addressLine2(brokerAccount),
			rE: $author$project$Api$Provider$BrokerAccount$One$addressCity(brokerAccount),
			rK: $author$project$Api$Provider$BrokerAccount$One$addressCountry(brokerAccount),
			uP: $author$project$Api$Provider$BrokerAccount$One$addressState(brokerAccount),
			vv: $author$project$Api$Provider$BrokerAccount$One$addressZip(brokerAccount)
		});
	var addressInput = _v0.a;
	var addressInputCmd = _v0.b;
	return _Utils_Tuple2(
		{
			K2: addressInput,
			Q9: $author$project$Api$Provider$BrokerAccount$One$ein(brokerAccount),
			Xw: $author$project$Api$Provider$BrokerAccount$One$multipleBrokers(brokerAccount),
			Bq: $author$project$Api$Provider$BrokerAccount$One$name(brokerAccount),
			abB: $author$project$Api$Provider$BrokerAccount$One$singleBrokerName(brokerAccount)
		},
		A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$Form$AddressInputMsg, addressInputCmd));
};
var $author$project$Components$Commissions$BrokerAccount$Form$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{Bq: string});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Q9: $author$project$Utils$String$toMaybe(string)
					});
			case 2:
				var address = field.a;
				return _Utils_update(
					fields,
					{K2: address});
			case 3:
				var bool = field.a;
				return _Utils_update(
					fields,
					{Xw: bool});
			default:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						abB: $author$project$Utils$String$toMaybe(string)
					});
		}
	});
var $author$project$Components$Commissions$BrokerAccount$Form$EinValidation = 1;
var $author$project$Components$Commissions$BrokerAccount$Form$NameValidation = 0;
var $author$project$Ui$Form$Ein$ifInvalid = F2(
	function (subjectToMaybe, error) {
		return A2(
			$rtfeldman$elm_validate$Validate$ifTrue,
			function (subject) {
				var _v0 = subjectToMaybe(subject);
				if (!_v0.$) {
					var ein = _v0.a;
					return !A2($author$project$Utils$Regex$matches, $author$project$Ui$Form$Ein$einFormat, ein);
				} else {
					return false;
				}
			},
			error);
	});
var $author$project$Components$Commissions$BrokerAccount$Form$AddressValidation = 2;
var $author$project$Components$Commissions$BrokerAccount$Form$validateAddress = function (fields) {
	return $author$project$Components$AddressInput$isValid(fields.K2) ? _List_Nil : _List_fromArray(
		[
			_Utils_Tuple2(2, 'Please enter an address')
		]);
};
var $author$project$Components$Commissions$BrokerAccount$Form$SingleBrokerNameValidation = 3;
var $author$project$Components$Commissions$BrokerAccount$Form$validateSingleBrokerName = function (fields) {
	return fields.Xw ? _List_Nil : ($author$project$Utils$Maybe$toBool(fields.abB) ? _List_Nil : _List_fromArray(
		[
			_Utils_Tuple2(3, 'Please enter a broker name.')
		]));
};
var $author$project$Components$Commissions$BrokerAccount$Form$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.Bq;
			},
			_Utils_Tuple2(0, 'Please enter a name.')),
			A2(
			$author$project$Ui$Form$Ein$ifInvalid,
			function ($) {
				return $.Q9;
			},
			_Utils_Tuple2(1, 'Please enter a valid EIN or leave empty')),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Commissions$BrokerAccount$Form$validateAddress),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Commissions$BrokerAccount$Form$validateSingleBrokerName)
		]));
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$futureIntervals = function ($) {
	return $.ah;
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$futureStartDate = function ($) {
	return $.gv;
};
var $author$project$Components$Commissions$BrokerAccount$Form$redirectAfterCreate = function (brokerAccount) {
	var id = $author$project$Api$Provider$BrokerAccount$One$id(brokerAccount);
	return $author$project$Api$Provider$BrokerAccount$One$multipleBrokers(brokerAccount) ? _Utils_Tuple2(
		A2(
			$author$project$Utils$Route$navigate,
			$elm$core$Dict$empty,
			$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top(
				{cm: id})),
		_List_Nil) : _Utils_Tuple2(
		A2(
			$author$project$Utils$Route$navigate,
			$elm$core$Dict$empty,
			$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Deals(
				{cm: id})),
		_List_fromArray(
			[$author$project$OutMsg$RefreshPractice]));
};
var $author$project$Components$Commissions$BrokerAccount$Form$Created = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$Form$apiFields = function (fields) {
	return {
		K2: $author$project$Components$AddressInput$getAddress(fields.K2),
		Q9: fields.Q9,
		Xw: fields.Xw,
		Bq: fields.Bq,
		abB: fields.abB
	};
};
var $author$project$Api$Common$Address$Shared$encodePartsWithPrefix = F2(
	function (prefix, address) {
		return _List_fromArray(
			[
				_Utils_Tuple2(
				prefix + 'city',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address.rE)),
				_Utils_Tuple2(
				prefix + 'country',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address.rK)),
				_Utils_Tuple2(
				prefix + 'line1',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address.s$)),
				_Utils_Tuple2(
				prefix + 'line2',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address.AD)),
				_Utils_Tuple2(
				prefix + 'state',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address.uP)),
				_Utils_Tuple2(
				prefix + 'zip',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address.vv))
			]);
	});
var $author$project$Api$Common$Address$Shared$encodeParts = $author$project$Api$Common$Address$Shared$encodePartsWithPrefix('address_');
var $author$project$Api$Provider$BrokerAccount$create = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'broker_account',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(fields.Bq)),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'ein',
									A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Q9)),
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										'multiple_brokers',
										$elm$json$Json$Encode$bool(fields.Xw)),
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(
											'single_broker_name',
											A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.abB)),
										$author$project$Api$Common$Address$Shared$encodeParts(fields.K2)))))))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$BrokerAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$BrokerAccount$brokerAccountsPath)));
	});
var $author$project$Components$Commissions$BrokerAccount$Form$createItem = F2(
	function (apiClient, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A3(
			$author$project$Api$Provider$BrokerAccount$create,
			apiClient,
			$author$project$Components$Commissions$BrokerAccount$Form$apiFields(fields),
			$author$project$Components$Commissions$BrokerAccount$Form$Created);
	});
var $author$project$Components$Commissions$BrokerAccount$Form$Updated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$BrokerAccount$update = F4(
	function (apiClient, id, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'broker_account',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(fields.Bq)),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'ein',
									A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Q9)),
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										'multiple_brokers',
										$elm$json$Json$Encode$bool(fields.Xw)),
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(
											'single_broker_name',
											A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.abB)),
										$author$project$Api$Common$Address$Shared$encodeParts(fields.K2)))))))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$BrokerAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$BrokerAccount$brokerAccountPath(id))));
	});
var $author$project$Components$Commissions$BrokerAccount$Form$updateItem = F3(
	function (apiClient, id, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4(
			$author$project$Api$Provider$BrokerAccount$update,
			apiClient,
			id,
			$author$project$Components$Commissions$BrokerAccount$Form$apiFields(fields),
			$author$project$Components$Commissions$BrokerAccount$Form$Updated);
	});
var $author$project$Components$Commissions$BrokerAccount$Form$saveItem = F3(
	function (apiClient, maybeId, formFields) {
		if (!maybeId.$) {
			var id_ = maybeId.a;
			return A3($author$project$Components$Commissions$BrokerAccount$Form$updateItem, apiClient, id_, formFields);
		} else {
			return A2($author$project$Components$Commissions$BrokerAccount$Form$createItem, apiClient, formFields);
		}
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$None = 0;
var $author$project$Formatters$Percentage$toString = function (currency) {
	var _v0 = $author$project$Percentage$toFloat(currency);
	if (!_v0.$) {
		var _float = _v0.a;
		return $author$project$Formatters$Float$toPercentage(_float);
	} else {
		return 'N/A';
	}
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$buildDescriptionIfNew = function (pricingStructure) {
	var _v0 = pricingStructure.ahP;
	if (!_v0.$) {
		return {Qr: pricingStructure.Qr, ahn: pricingStructure.ahn, ahP: pricingStructure.ahP, ajZ: pricingStructure.ajZ, akg: pricingStructure.akg, alD: pricingStructure.alD};
	} else {
		var splitType = _Utils_eq(
			pricingStructure.alD,
			$elm$core$Maybe$Just(0)) ? $elm$core$Maybe$Just('for all members') : (_Utils_eq(
			pricingStructure.alD,
			$elm$core$Maybe$Just(1)) ? $elm$core$Maybe$Just('for primary member') : $elm$core$Maybe$Nothing);
		var amount = function () {
			var _v2 = _Utils_Tuple3(pricingStructure.akg, pricingStructure.ahn, pricingStructure.ajZ);
			_v2$2:
			while (true) {
				if (!_v2.a.$) {
					switch (_v2.a.a.$) {
						case 1:
							if (!_v2.b.$) {
								var _v3 = _v2.a.a;
								var fixedAmountInCents = _v2.b.a;
								return $elm$core$Maybe$Just(
									$author$project$Currency$format(fixedAmountInCents));
							} else {
								break _v2$2;
							}
						case 0:
							if (!_v2.c.$) {
								var _v4 = _v2.a.a;
								var percentage = _v2.c.a;
								return $elm$core$Maybe$Just(
									$author$project$Formatters$Percentage$toString(percentage));
							} else {
								break _v2$2;
							}
						default:
							break _v2$2;
					}
				} else {
					break _v2$2;
				}
			}
			return $elm$core$Maybe$Nothing;
		}();
		var description = function () {
			var _v1 = _Utils_Tuple2(amount, splitType);
			if ((!_v1.a.$) && (!_v1.b.$)) {
				var amount_ = _v1.a.a;
				var splitType_ = _v1.b.a;
				return $elm$core$Maybe$Just(amount_ + (' ' + splitType_));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		return _Utils_update(
			pricingStructure,
			{Qr: description});
	}
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$addNewInterval = F3(
	function (pricingStructure, intervalInMonths, intervals) {
		var interval = {
			ah2: $elm$core$Maybe$Nothing,
			_l: $author$project$Components$Commissions$BrokerAccount$RetailSchedule$buildDescriptionIfNew(pricingStructure)
		};
		return function (newIntervals) {
			return A2(
				$elm$core$List$append,
				newIntervals,
				_List_fromArray(
					[interval]));
		}(
			A3(
				$elm_community$list_extra$List$Extra$updateAt,
				$elm$core$List$length(intervals) - 1,
				function (lastInterval) {
					return (!$elm$core$List$isEmpty(intervals)) ? _Utils_update(
						lastInterval,
						{ah2: intervalInMonths}) : lastInterval;
				},
				intervals));
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$editFirstSchedule = F2(
	function (pricingStructure, intervals) {
		return A3(
			$elm_community$list_extra$List$Extra$updateAt,
			0,
			function (interval) {
				return _Utils_update(
					interval,
					{
						_l: $author$project$Components$Commissions$BrokerAccount$RetailSchedule$buildDescriptionIfNew(pricingStructure)
					});
			},
			intervals);
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$editInterval = F4(
	function (pricingStructure, intervalInMonths, index, intervals) {
		return A3(
			$elm_community$list_extra$List$Extra$updateAt,
			index,
			function (interval) {
				return _Utils_update(
					interval,
					{
						_l: $author$project$Components$Commissions$BrokerAccount$RetailSchedule$buildDescriptionIfNew(pricingStructure)
					});
			},
			A3(
				$elm_community$list_extra$List$Extra$updateAt,
				index - 1,
				function (interval) {
					return _Utils_update(
						interval,
						{ah2: intervalInMonths});
				},
				intervals));
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$initFormFields = {_l: $elm$core$Maybe$Nothing};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$init = function (apiClient) {
	var _v0 = $author$project$Components$PricingStructureSelect$init(apiClient);
	var pricingStructureSelect = _v0.a;
	var pricingStructureSelectCmd = _v0.b;
	return _Utils_Tuple2(
		{
			SD: $author$project$Utils$Form$init($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$initFormFields),
			pk: pricingStructureSelect
		},
		A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$PricingStructureSelectMsg, pricingStructureSelectCmd));
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$initFormFields = {ah2: $elm$core$Maybe$Nothing, _l: $elm$core$Maybe$Nothing};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$init = function (apiClient) {
	var _v0 = $author$project$Components$PricingStructureSelect$init(apiClient);
	var pricingStructureSelect = _v0.a;
	var pricingStructureSelectCmd = _v0.b;
	return _Utils_Tuple2(
		{
			SD: $author$project$Utils$Form$init($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$initFormFields),
			pk: pricingStructureSelect
		},
		A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$PricingStructureSelectMsg, pricingStructureSelectCmd));
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$StartDateDateInputMsg = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$initFormFields = function () {
	var _v0 = $author$project$Components$DateInput$init;
	var startDateDateInput = _v0.a;
	var startDateDateInputCmd = _v0.b;
	return _Utils_Tuple2(
		{ab7: $elm$core$Maybe$Nothing, uO: startDateDateInput},
		A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$StartDateDateInputMsg(startDateDateInput),
			startDateDateInputCmd));
}();
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$init = function (currentDate) {
	var _v0 = $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$initFormFields;
	var fields = _v0.a;
	var fieldsCmd = _v0.b;
	return _Utils_Tuple2(
		{
			dd: currentDate,
			SD: $author$project$Utils$Form$init(fields)
		},
		fieldsCmd);
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$initFormFields = {ah2: $elm$core$Maybe$Nothing};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$init = $author$project$Utils$Form$init($author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$initFormFields);
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$removeInterval = F2(
	function (index, intervals) {
		var currentInterval = A2($elm_community$list_extra$List$Extra$getAt, index, intervals);
		return A2(
			$elm_community$list_extra$List$Extra$removeAt,
			index,
			A3(
				$elm_community$list_extra$List$Extra$updateAt,
				index - 1,
				function (interval) {
					return _Utils_update(
						interval,
						{
							ah2: A2(
								$elm$core$Maybe$andThen,
								function ($) {
									return $.ah2;
								},
								currentInterval)
						});
				},
				intervals));
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$Closed = {$: 1};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$None = {$: 0};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$PricingStructure = $elm$core$Basics$identity;
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$RetailRateAdded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$formFieldsUpdate = F2(
	function (field, fields) {
		var pricingStructure = field;
		return _Utils_update(
			fields,
			{_l: pricingStructure});
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$PricingStructureValidation = 0;
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$validatePricingStructure = function (fields) {
	var _v0 = fields._l;
	if (!_v0.$) {
		var pricingStructure = _v0.a;
		var _v1 = pricingStructure.ahP;
		if (!_v1.$) {
			return _List_Nil;
		} else {
			var _v2 = _Utils_Tuple3(pricingStructure.akg, pricingStructure.ajZ, pricingStructure.ahn);
			_v2$3:
			while (true) {
				if (_v2.a.$ === 1) {
					var _v3 = _v2.a;
					return _List_fromArray(
						[
							_Utils_Tuple2(0, 'Please pick or create a rate.')
						]);
				} else {
					switch (_v2.a.a.$) {
						case 0:
							if (_v2.b.$ === 1) {
								var _v4 = _v2.a.a;
								var _v5 = _v2.b;
								return _List_fromArray(
									[
										_Utils_Tuple2(0, 'Please enter a number')
									]);
							} else {
								break _v2$3;
							}
						case 1:
							if (_v2.c.$ === 1) {
								var _v6 = _v2.a.a;
								var _v7 = _v2.c;
								return _List_fromArray(
									[
										_Utils_Tuple2(0, 'Please enter an amount')
									]);
							} else {
								break _v2$3;
							}
						default:
							break _v2$3;
					}
				}
			}
			return _List_Nil;
		}
	} else {
		return _List_fromArray(
			[
				_Utils_Tuple2(0, 'Please pick or create a rate.')
			]);
	}
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$validatePricingStructure)
		]));
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 1:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$Closed, aiO: model, aR: _List_Nil};
			case 0:
				var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$formFieldsValidator, model.SD);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var newForm = _v3.a;
					var validFormFields = _v3.b;
					var event = A2(
						$elm$core$Maybe$withDefault,
						$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$Closed,
						A2(
							$elm$core$Maybe$map,
							$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$RetailRateAdded,
							$rtfeldman$elm_validate$Validate$fromValid(validFormFields)._l));
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: event,
						aiO: _Utils_update(
							model,
							{SD: newForm}),
						aR: _List_Nil
					};
				} else {
					var newForm = _v2.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$None,
						aiO: _Utils_update(
							model,
							{SD: newForm}),
						aR: _List_Nil
					};
				}
			default:
				var subMsg = msg.a;
				var pricingStructureSelectResult = A2($author$project$Components$PricingStructureSelect$update, subMsg, model.pk);
				var form = function () {
					var _v4 = pricingStructureSelectResult.agZ;
					if (!_v4.$) {
						return model.SD;
					} else {
						var pricingStructure = _v4.a;
						return A3($author$project$Utils$Form$update, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$formFieldsUpdate, pricingStructure, model.SD);
					}
				}();
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$PricingStructureSelectMsg, pricingStructureSelectResult.GZ),
					agZ: $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$None,
					aiO: _Utils_update(
						model,
						{SD: form, pk: pricingStructureSelectResult.aiO}),
					aR: pricingStructureSelectResult.aR
				};
		}
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$Closed = {$: 1};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$None = {$: 0};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$PricingStructure = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$RetailRateAdded = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var string = field.a;
			return _Utils_update(
				fields,
				{
					ah2: $elm$core$String$toInt(string)
				});
		} else {
			var pricingStructure = field.a;
			return _Utils_update(
				fields,
				{_l: pricingStructure});
		}
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$IntervalInMonthsValidation = 1;
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$validateIntervalInMonths = function (fields) {
	var validationError = _Utils_Tuple2(1, 'Please enter a number greater than 0');
	var _v0 = fields.ah2;
	if (!_v0.$) {
		var intervalInMonths = _v0.a;
		return (intervalInMonths > 0) ? _List_Nil : _List_fromArray(
			[validationError]);
	} else {
		return _List_fromArray(
			[validationError]);
	}
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$PricingStructureValidation = 0;
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$validatePricingStructure = function (fields) {
	var _v0 = fields._l;
	if (!_v0.$) {
		var pricingStructure = _v0.a;
		var _v1 = pricingStructure.ahP;
		if (!_v1.$) {
			return _List_Nil;
		} else {
			var _v2 = _Utils_Tuple3(pricingStructure.akg, pricingStructure.ajZ, pricingStructure.ahn);
			_v2$3:
			while (true) {
				if (_v2.a.$ === 1) {
					var _v3 = _v2.a;
					return _List_fromArray(
						[
							_Utils_Tuple2(0, 'Please pick or create a rate.')
						]);
				} else {
					switch (_v2.a.a.$) {
						case 0:
							if (_v2.b.$ === 1) {
								var _v4 = _v2.a.a;
								var _v5 = _v2.b;
								return _List_fromArray(
									[
										_Utils_Tuple2(0, 'Please enter a number')
									]);
							} else {
								break _v2$3;
							}
						case 1:
							if (_v2.c.$ === 1) {
								var _v6 = _v2.a.a;
								var _v7 = _v2.c;
								return _List_fromArray(
									[
										_Utils_Tuple2(0, 'Please enter an amount')
									]);
							} else {
								break _v2$3;
							}
						default:
							break _v2$3;
					}
				}
			}
			return _List_Nil;
		}
	} else {
		return _List_fromArray(
			[
				_Utils_Tuple2(0, 'Please pick or create a rate.')
			]);
	}
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$validateIntervalInMonths),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$validatePricingStructure)
		]));
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 1:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$Closed, aiO: model, aR: _List_Nil};
			case 0:
				var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$formFieldsValidator, model.SD);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var newForm = _v3.a;
					var validFormFields = _v3.b;
					var _v4 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
					var pricingStructure = _v4._l;
					var intervalInMonths = _v4.ah2;
					var event = A2(
						$elm$core$Maybe$withDefault,
						$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$Closed,
						A2(
							$elm$core$Maybe$map,
							$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$RetailRateAdded(intervalInMonths),
							pricingStructure));
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: event,
						aiO: _Utils_update(
							model,
							{SD: newForm}),
						aR: _List_Nil
					};
				} else {
					var newForm = _v2.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$None,
						aiO: _Utils_update(
							model,
							{SD: newForm}),
						aR: _List_Nil
					};
				}
			case 2:
				var field = msg.a;
				var form = A3($author$project$Utils$Form$update, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$formFieldsUpdate, field, model.SD);
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$None,
					aiO: _Utils_update(
						model,
						{SD: form}),
					aR: _List_Nil
				};
			default:
				var subMsg = msg.a;
				var pricingStructureSelectResult = A2($author$project$Components$PricingStructureSelect$update, subMsg, model.pk);
				var form = function () {
					var _v5 = pricingStructureSelectResult.agZ;
					if (!_v5.$) {
						return model.SD;
					} else {
						var pricingStructure = _v5.a;
						return A3(
							$author$project$Utils$Form$update,
							$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$formFieldsUpdate,
							$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$PricingStructure(pricingStructure),
							model.SD);
					}
				}();
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$PricingStructureSelectMsg, pricingStructureSelectResult.GZ),
					agZ: $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$None,
					aiO: _Utils_update(
						model,
						{SD: form, pk: pricingStructureSelectResult.aiO}),
					aR: pricingStructureSelectResult.aR
				};
		}
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$Closed = {$: 1};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$DatePicked = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$None = {$: 0};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$StartDate = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$StartDateValidation = 0;
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$validateStartDate = F2(
	function (currentDate, fields) {
		var _v0 = fields.ab7;
		if (!_v0.$) {
			var startDate = _v0.a;
			return (A2($justinmimbs$date$Date$compare, currentDate, startDate) !== 2) ? _List_Nil : _List_fromArray(
				[
					_Utils_Tuple2(0, 'Please enter a date greater or equal than today')
				]);
		} else {
			return _List_fromArray(
				[
					_Utils_Tuple2(0, 'Please enter a date.')
				]);
		}
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$formFieldsValidator = function (currentDate) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$validateStartDate(currentDate))
			]));
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$formFieldsUpdate = F2(
	function (field, fields) {
		var dateInput = field.a;
		var date = field.b;
		return _Utils_update(
			fields,
			{ab7: date, uO: dateInput});
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$updateDateInputFormField = F6(
	function (model, dateInput, subMsg, toMsg, field, fieldGetter) {
		var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
		var newDateInput = _v0.a;
		var subCmd = _v0.b;
		var event = _v0.c;
		var newForm = function () {
			if (event.$ === 1) {
				var date = event.a;
				return A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$formFieldsUpdate,
					A2(field, newDateInput, date),
					model.SD);
			} else {
				var fields = $author$project$Utils$Form$fields(model.SD);
				return A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$formFieldsUpdate,
					A2(
						field,
						newDateInput,
						fieldGetter(fields)),
					model.SD);
			}
		}();
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{SD: newForm}),
			A2(
				$elm$core$Platform$Cmd$map,
				toMsg(newDateInput),
				subCmd),
			$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$None);
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 1:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$Closed);
			case 0:
				var _v2 = A2(
					$author$project$Utils$Form$validate,
					$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$formFieldsValidator(model.dd),
					model.SD);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var newForm = _v3.a;
					var validFormFields = _v3.b;
					var startDate = A2(
						$elm$core$Maybe$withDefault,
						model.dd,
						$rtfeldman$elm_validate$Validate$fromValid(validFormFields).ab7);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{SD: newForm}),
						$elm$core$Platform$Cmd$none,
						$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$DatePicked(startDate));
				} else {
					var newForm = _v2.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{SD: newForm}),
						$elm$core$Platform$Cmd$none,
						$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$None);
				}
			default:
				var dateInput = msg.a;
				var subMsg = msg.b;
				return A6(
					$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$updateDateInputFormField,
					model,
					dateInput,
					subMsg,
					$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$StartDateDateInputMsg,
					$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$StartDate,
					function ($) {
						return $.ab7;
					});
		}
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$Closed = {$: 1};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$None = {$: 0};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$RetailRateAdded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$formFieldsUpdate = F2(
	function (field, fields) {
		var string = field;
		return _Utils_update(
			fields,
			{
				ah2: $elm$core$String$toInt(string)
			});
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$IntervalInMonthsValidation = 0;
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$validateIntervalInMonths = function (fields) {
	var validationError = _Utils_Tuple2(0, 'Please enter a number greater than 0');
	var _v0 = fields.ah2;
	if (!_v0.$) {
		var intervalInMonths = _v0.a;
		return (intervalInMonths > 0) ? _List_Nil : _List_fromArray(
			[validationError]);
	} else {
		return _List_fromArray(
			[validationError]);
	}
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$validateIntervalInMonths)
		]));
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$update = F2(
	function (msg, _v0) {
		var form = _v0;
		switch (msg.$) {
			case 1:
				return _Utils_Tuple3(form, $elm$core$Platform$Cmd$none, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$Closed);
			case 0:
				var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$formFieldsValidator, form);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var newForm = _v3.a;
					var validFormFields = _v3.b;
					var _v4 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
					var intervalInMonths = _v4.ah2;
					var event = A2(
						$elm$core$Maybe$withDefault,
						$author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$Closed,
						A2($elm$core$Maybe$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$RetailRateAdded, intervalInMonths));
					return _Utils_Tuple3(newForm, $elm$core$Platform$Cmd$none, event);
				} else {
					var newForm = _v2.a;
					return _Utils_Tuple3(newForm, $elm$core$Platform$Cmd$none, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$None);
				}
			default:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$formFieldsUpdate, field, form);
				return _Utils_Tuple3(newForm, $elm$core$Platform$Cmd$none, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$None);
		}
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var _v1 = $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$init(apiClient);
				var addRetailModal = _v1.a;
				var addRetailModalCmd = _v1.b;
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModalMsg, addRetailModalCmd),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							fy: $elm$core$Maybe$Just(
								_Utils_Tuple3(true, true, addRetailModal))
						}),
					aR: _List_Nil
				};
			case 1:
				var subMsg = msg.a;
				var _v2 = model.fy;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var resetIntervals = _v3.a;
					var isCurrent = _v3.b;
					var addRetailModal = _v3.c;
					var intervals = isCurrent ? model.aI : model.ah;
					var addRetailModalResult = A2($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$update, subMsg, addRetailModal);
					var _v4 = function () {
						var _v5 = _Utils_Tuple2(addRetailModalResult.agZ, resetIntervals);
						switch (_v5.a.$) {
							case 0:
								var _v6 = _v5.a;
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(
										_Utils_Tuple3(resetIntervals, isCurrent, addRetailModalResult.aiO)),
									model.ak0,
									intervals);
							case 1:
								if (_v5.b) {
									var _v7 = _v5.a;
									return _Utils_Tuple3($elm$core$Maybe$Nothing, false, intervals);
								} else {
									var _v8 = _v5.a;
									return _Utils_Tuple3($elm$core$Maybe$Nothing, model.ak0, intervals);
								}
							default:
								if (_v5.b) {
									var pricingStructure = _v5.a.a;
									return _Utils_Tuple3(
										$elm$core$Maybe$Nothing,
										true,
										$elm$core$Maybe$Just(
											A3($author$project$Components$Commissions$BrokerAccount$RetailSchedule$addNewInterval, pricingStructure, $elm$core$Maybe$Nothing, _List_Nil)));
								} else {
									var pricingStructure = _v5.a.a;
									return _Utils_Tuple3(
										$elm$core$Maybe$Nothing,
										model.ak0,
										$elm$core$Maybe$Just(
											A2(
												$author$project$Components$Commissions$BrokerAccount$RetailSchedule$editFirstSchedule,
												pricingStructure,
												A2($elm$core$Maybe$withDefault, _List_Nil, intervals))));
								}
						}
					}();
					var addRetailModal_ = _v4.a;
					var retailEnabled_ = _v4.b;
					var newIntervals = _v4.c;
					var newModel = isCurrent ? _Utils_update(
						model,
						{aI: newIntervals}) : _Utils_update(
						model,
						{ah: newIntervals});
					return {
						GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModalMsg, addRetailModalResult.GZ),
						agZ: 0,
						aiO: _Utils_update(
							newModel,
							{fy: addRetailModal_, ak0: retailEnabled_}),
						aR: addRetailModalResult.aR
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
			case 2:
				var isCurrent = msg.a;
				var index = msg.b;
				if (!index) {
					var _v9 = $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$init(apiClient);
					var addRetailModal = _v9.a;
					var addRetailModalCmd = _v9.b;
					return {
						GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModalMsg, addRetailModalCmd),
						agZ: 0,
						aiO: _Utils_update(
							model,
							{
								fy: $elm$core$Maybe$Just(
									_Utils_Tuple3(false, isCurrent, addRetailModal))
							}),
						aR: _List_Nil
					};
				} else {
					var _v10 = $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$init(apiClient);
					var addRetailRateChangeModal = _v10.a;
					var addRetailRateChangeModalCmd = _v10.b;
					return {
						GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModalMsg, addRetailRateChangeModalCmd),
						agZ: 0,
						aiO: _Utils_update(
							model,
							{
								fz: $elm$core$Maybe$Just(
									_Utils_Tuple3(
										isCurrent,
										$elm$core$Maybe$Just(index),
										addRetailRateChangeModal))
							}),
						aR: _List_Nil
					};
				}
			case 3:
				var isCurrent = msg.a;
				var intervals = isCurrent ? model.aI : model.ah;
				var newIntervals = A2(
					$elm$core$Maybe$map,
					function (intervals_) {
						return A3(
							$elm_community$list_extra$List$Extra$updateAt,
							$elm$core$List$length(intervals_) - 1,
							function (lastInterval) {
								return _Utils_update(
									lastInterval,
									{ah2: $elm$core$Maybe$Nothing});
							},
							intervals_);
					},
					intervals);
				var newModel = isCurrent ? _Utils_update(
					model,
					{aI: newIntervals, Pi: false}) : _Utils_update(
					model,
					{ah: newIntervals, SQ: false});
				return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: newModel, aR: _List_Nil};
			case 4:
				var isCurrent = msg.a;
				var _v11 = $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$init(apiClient);
				var addRetailRateChangeModal = _v11.a;
				var addRetailRateChangeModalCmd = _v11.b;
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModalMsg, addRetailRateChangeModalCmd),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							fz: $elm$core$Maybe$Just(
								_Utils_Tuple3(isCurrent, $elm$core$Maybe$Nothing, addRetailRateChangeModal))
						}),
					aR: _List_Nil
				};
			case 5:
				var subMsg = msg.a;
				var _v12 = model.fz;
				if (!_v12.$) {
					var _v13 = _v12.a;
					var isCurrent = _v13.a;
					var index = _v13.b;
					var addRetailRateChangeModal = _v13.c;
					var intervals = isCurrent ? model.aI : model.ah;
					var addRetailRateChangeModalResult = A2($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$update, subMsg, addRetailRateChangeModal);
					var _v14 = function () {
						var _v15 = _Utils_Tuple2(addRetailRateChangeModalResult.agZ, index);
						switch (_v15.a.$) {
							case 0:
								var _v16 = _v15.a;
								return _Utils_Tuple2(
									$elm$core$Maybe$Just(
										_Utils_Tuple3(isCurrent, index, addRetailRateChangeModalResult.aiO)),
									intervals);
							case 1:
								var _v17 = _v15.a;
								return _Utils_Tuple2($elm$core$Maybe$Nothing, intervals);
							default:
								if (_v15.b.$ === 1) {
									var _v18 = _v15.a;
									var intervalInMonths = _v18.a;
									var pricingStructure = _v18.b;
									var _v19 = _v15.b;
									return _Utils_Tuple2(
										$elm$core$Maybe$Nothing,
										$elm$core$Maybe$Just(
											A3(
												$author$project$Components$Commissions$BrokerAccount$RetailSchedule$addNewInterval,
												pricingStructure,
												intervalInMonths,
												A2($elm$core$Maybe$withDefault, _List_Nil, intervals))));
								} else {
									var _v20 = _v15.a;
									var intervalInMonths = _v20.a;
									var pricingStructure = _v20.b;
									var index_ = _v15.b.a;
									return _Utils_Tuple2(
										$elm$core$Maybe$Nothing,
										$elm$core$Maybe$Just(
											A4(
												$author$project$Components$Commissions$BrokerAccount$RetailSchedule$editInterval,
												pricingStructure,
												intervalInMonths,
												index_,
												A2($elm$core$Maybe$withDefault, _List_Nil, intervals))));
								}
						}
					}();
					var addRetailRateChangeModal_ = _v14.a;
					var newIntervals = _v14.b;
					var newModel = isCurrent ? _Utils_update(
						model,
						{aI: newIntervals}) : _Utils_update(
						model,
						{ah: newIntervals});
					return {
						GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModalMsg, addRetailRateChangeModalResult.GZ),
						agZ: 0,
						aiO: _Utils_update(
							newModel,
							{fz: addRetailRateChangeModal_}),
						aR: addRetailRateChangeModalResult.aR
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
			case 6:
				var isCurrent = msg.a;
				var endDealModal = $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$init;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							jE: $elm$core$Maybe$Just(
								_Utils_Tuple2(isCurrent, endDealModal))
						}),
					aR: _List_Nil
				};
			case 7:
				var subMsg = msg.a;
				var _v21 = model.jE;
				if (!_v21.$) {
					var _v22 = _v21.a;
					var isCurrent = _v22.a;
					var endDealModal = _v22.b;
					var _v23 = isCurrent ? _Utils_Tuple2(model.Pi, model.aI) : _Utils_Tuple2(model.Pi, model.ah);
					var scheduleEnded = _v23.a;
					var intervals = _v23.b;
					var _v24 = A2($author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$update, subMsg, endDealModal);
					var endDealModal_ = _v24.a;
					var endDealModalCmd = _v24.b;
					var endDealModalEvent = _v24.c;
					var _v25 = function () {
						switch (endDealModalEvent.$) {
							case 0:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(
										_Utils_Tuple2(isCurrent, endDealModal_)),
									scheduleEnded,
									intervals);
							case 1:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, scheduleEnded, intervals);
							default:
								var intervalInMonths = endDealModalEvent.a;
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									true,
									A2(
										$elm$core$Maybe$map,
										function (intervals_) {
											return A3(
												$elm_community$list_extra$List$Extra$updateAt,
												$elm$core$List$length(intervals_) - 1,
												function (lastInterval) {
													return _Utils_update(
														lastInterval,
														{
															ah2: $elm$core$Maybe$Just(intervalInMonths)
														});
												},
												intervals_);
										},
										intervals));
						}
					}();
					var newEndDealModal = _v25.a;
					var scheduleEnded_ = _v25.b;
					var newIntervals = _v25.c;
					var newModel = isCurrent ? _Utils_update(
						model,
						{aI: newIntervals, Pi: scheduleEnded_}) : _Utils_update(
						model,
						{ah: newIntervals, SQ: scheduleEnded_});
					return {
						GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModalMsg, endDealModalCmd),
						agZ: 0,
						aiO: _Utils_update(
							newModel,
							{jE: newEndDealModal}),
						aR: _List_Nil
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
			case 8:
				var _v27 = $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$init(model.dd);
				var addScheduleModal = _v27.a;
				var addScheduleModalCmd = _v27.b;
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModalMsg, addScheduleModalCmd),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							ig: $elm$core$Maybe$Just(addScheduleModal)
						}),
					aR: _List_Nil
				};
			case 9:
				var subMsg = msg.a;
				var _v28 = model.ig;
				if (!_v28.$) {
					var addScheduleModal = _v28.a;
					var _v29 = A2($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$update, subMsg, addScheduleModal);
					var addScheduleModal_ = _v29.a;
					var addScheduleModalCmd = _v29.b;
					var addScheduleModalEvent = _v29.c;
					var _v30 = function () {
						switch (addScheduleModalEvent.$) {
							case 0:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(addScheduleModal_),
									model.gv,
									model.ah);
							case 1:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.gv, model.ah);
							default:
								var date = addScheduleModalEvent.a;
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$elm$core$Maybe$Just(date),
									model.aI);
						}
					}();
					var addScheduleModal__ = _v30.a;
					var futureStartDate_ = _v30.b;
					var futureIntervals_ = _v30.c;
					return {
						GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModalMsg, addScheduleModalCmd),
						agZ: 0,
						aiO: _Utils_update(
							model,
							{ig: addScheduleModal__, ah: futureIntervals_, gv: futureStartDate_}),
						aR: _List_Nil
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
			case 10:
				var isCurrent = msg.a;
				var index = msg.b;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							c3: $elm$core$Maybe$Just(
								_Utils_Tuple2(isCurrent, index))
						}),
					aR: _List_Nil
				};
			default:
				var isCurrent = msg.a;
				var index = msg.b;
				var confirmed = msg.c;
				if (confirmed) {
					var _v32 = _Utils_Tuple3(isCurrent, model.aI, model.ah);
					_v32$2:
					while (true) {
						if (_v32.a) {
							if (!_v32.b.$) {
								var currentIntervals_ = _v32.b.a;
								return {
									GZ: $elm$core$Platform$Cmd$none,
									agZ: 0,
									aiO: _Utils_update(
										model,
										{
											c3: $elm$core$Maybe$Nothing,
											aI: $elm$core$Maybe$Just(
												A2($author$project$Components$Commissions$BrokerAccount$RetailSchedule$removeInterval, index, currentIntervals_))
										}),
									aR: _List_Nil
								};
							} else {
								break _v32$2;
							}
						} else {
							if (!_v32.c.$) {
								var futureIntervals_ = _v32.c.a;
								return {
									GZ: $elm$core$Platform$Cmd$none,
									agZ: 0,
									aiO: _Utils_update(
										model,
										{
											c3: $elm$core$Maybe$Nothing,
											ah: $elm$core$Maybe$Just(
												A2($author$project$Components$Commissions$BrokerAccount$RetailSchedule$removeInterval, index, futureIntervals_))
										}),
									aR: _List_Nil
								};
							} else {
								break _v32$2;
							}
						}
					}
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{c3: $elm$core$Maybe$Nothing}),
						aR: _List_Nil
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{c3: $elm$core$Maybe$Nothing}),
						aR: _List_Nil
					};
				}
		}
	});
var $author$project$Components$Commissions$BrokerAccount$Form$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var brokerAccount = response.a;
					var retailSchedule = A3(
						$author$project$Components$Commissions$BrokerAccount$RetailSchedule$init,
						model.J8,
						model.dd,
						$elm$core$Maybe$Just(brokerAccount));
					var _v3 = $author$project$Components$Commissions$BrokerAccount$Form$formFieldsFromItem(brokerAccount);
					var formFields = _v3.a;
					var cmd = _v3.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								SD: $elm$core$Maybe$Just(
									_Utils_Tuple2(
										$author$project$Utils$Form$init(formFields),
										retailSchedule)),
								Io: $elm$core$Maybe$Just(brokerAccount)
							}),
						cmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$reportDecodeError(response));
				}
			case 1:
				var field = msg.a;
				var _v4 = model.SD;
				if (!_v4.$) {
					var _v5 = _v4.a;
					var form = _v5.a;
					var retailSchedule = _v5.b;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Commissions$BrokerAccount$Form$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								SD: $elm$core$Maybe$Just(
									_Utils_Tuple2(newForm, retailSchedule))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				var subMsg = msg.a;
				var _v6 = model.SD;
				if (!_v6.$) {
					var _v7 = _v6.a;
					var form = _v7.a;
					var retailSchedule = _v7.b;
					var _v8 = $author$project$Utils$Form$fields(form);
					var address = _v8.K2;
					var _v9 = A2($author$project$Components$AddressInput$update, subMsg, address);
					var addressInputModel = _v9.a;
					var addressInputCmd = _v9.b;
					var outMsgs = _v9.c;
					var newForm = A3(
						$author$project$Utils$Form$update,
						$author$project$Components$Commissions$BrokerAccount$Form$formFieldsUpdate,
						$author$project$Components$Commissions$BrokerAccount$Form$Address(addressInputModel),
						form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								SD: $elm$core$Maybe$Just(
									_Utils_Tuple2(newForm, retailSchedule))
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$Form$AddressInputMsg, addressInputCmd),
						outMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var _v10 = model.SD;
				if (!_v10.$) {
					var _v11 = _v10.a;
					var form = _v11.a;
					var retailSchedule = _v11.b;
					var _v12 = A2($author$project$Utils$Form$validate, $author$project$Components$Commissions$BrokerAccount$Form$formFieldsValidator, form);
					if (!_v12.$) {
						var _v13 = _v12.a;
						var newForm = _v13.a;
						var validFormFields = _v13.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									SD: $elm$core$Maybe$Just(
										_Utils_Tuple2(newForm, retailSchedule)),
									k9: $author$project$Api$Data$Loading
								}),
							A3($author$project$Components$Commissions$BrokerAccount$Form$saveItem, apiClient, model.ahP, validFormFields),
							_List_Nil);
					} else {
						var newForm = _v12.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									SD: $elm$core$Maybe$Just(
										_Utils_Tuple2(newForm, retailSchedule)),
									k9: $author$project$Api$Data$NotAsked
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				var response = msg.a;
				var _v14 = model.SD;
				if (!_v14.$) {
					var _v15 = _v14.a;
					var retailSchedule = _v15.b;
					if (response.$ === 3) {
						var brokerAccount = response.a;
						var _v17 = function () {
							var _v18 = $author$project$Components$Commissions$BrokerAccount$RetailSchedule$currentIntervals(retailSchedule);
							if (!_v18.$) {
								var currentIntervals = _v18.a;
								return _Utils_Tuple2(
									A5(
										$author$project$Components$Commissions$BrokerAccount$Form$createRetailSchedule,
										apiClient,
										false,
										brokerAccount,
										{
											SP: $elm$core$Maybe$Nothing,
											ak0: $elm$core$Maybe$Just(true)
										},
										currentIntervals),
									_List_Nil);
							} else {
								return $author$project$Components$Commissions$BrokerAccount$Form$redirectAfterCreate(brokerAccount);
							}
						}();
						var cmd = _v17.a;
						var outMsgs = _v17.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{k9: response}),
							cmd,
							A2(
								$elm$core$List$cons,
								A2($author$project$OutMsg$ShowToast, 3, 'Broker Account successfully created'),
								outMsgs));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{k9: response}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				var response = msg.a;
				var _v19 = model.SD;
				if (!_v19.$) {
					if (response.$ === 3) {
						var brokerAccount = response.a;
						var retailSchedule = A3(
							$author$project$Components$Commissions$BrokerAccount$RetailSchedule$init,
							model.J8,
							model.dd,
							$elm$core$Maybe$Just(brokerAccount));
						var _v21 = $author$project$Components$Commissions$BrokerAccount$Form$formFieldsFromItem(brokerAccount);
						var formFields = _v21.a;
						var cmd = _v21.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									SD: $elm$core$Maybe$Just(
										_Utils_Tuple2(
											$author$project$Utils$Form$init(formFields),
											retailSchedule)),
									k9: response
								}),
							cmd,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Broker Account updated')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{k9: response}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var isUpdate = msg.a;
				var brokerAccount = msg.b;
				var response = msg.c;
				var _v22 = model.SD;
				if (!_v22.$) {
					if (response.$ === 3) {
						var _v24 = isUpdate ? _Utils_Tuple3($elm$core$Platform$Cmd$none, _List_Nil, 'Retail commission schedule updated') : A2(
							$author$project$Utils$Tuple3$fromTuple2,
							'Rate schedule successfully created',
							$author$project$Components$Commissions$BrokerAccount$Form$redirectAfterCreate(brokerAccount));
						var cmd = _v24.a;
						var outMsgs = _v24.b;
						var messsage = _v24.c;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{SD: $elm$core$Maybe$Nothing, qQ: $author$project$Api$Data$NotAsked}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										cmd,
										A3(
										$author$project$Api$Provider$BrokerAccount$retrieve,
										apiClient,
										$author$project$Api$Provider$BrokerAccount$One$id(brokerAccount),
										$author$project$Components$Commissions$BrokerAccount$Form$GotItem)
									])),
							A2(
								$elm$core$List$cons,
								A2($author$project$OutMsg$ShowToast, 3, messsage),
								outMsgs));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{qQ: $author$project$Api$Data$NotAsked}),
							A2(
								$author$project$Utils$Route$navigate,
								$elm$core$Dict$empty,
								$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Top(
									{
										cm: $author$project$Api$Provider$BrokerAccount$One$id(brokerAccount)
									})),
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var brokerAccount = msg.a;
				var _v25 = model.SD;
				if (!_v25.$) {
					var _v26 = _v25.a;
					var retailSchedule = _v26.b;
					var _v27 = $author$project$Api$Provider$BrokerAccount$One$retailEnabled(brokerAccount) ? _Utils_Tuple2(
						{
							SP: $author$project$Components$Commissions$BrokerAccount$RetailSchedule$futureStartDate(retailSchedule),
							ak0: $elm$core$Maybe$Nothing
						},
						$author$project$Components$Commissions$BrokerAccount$RetailSchedule$futureIntervals(retailSchedule)) : _Utils_Tuple2(
						{
							SP: $elm$core$Maybe$Nothing,
							ak0: $elm$core$Maybe$Just(true)
						},
						$author$project$Components$Commissions$BrokerAccount$RetailSchedule$currentIntervals(retailSchedule));
					var brokerAccountFields = _v27.a;
					var intervals = _v27.b;
					if (!intervals.$) {
						var intervals_ = intervals.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{qQ: $author$project$Api$Data$Loading}),
							A5($author$project$Components$Commissions$BrokerAccount$Form$createRetailSchedule, apiClient, true, brokerAccount, brokerAccountFields, intervals_),
							_List_Nil);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 8:
				var brokerAccount = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							fG: $elm$core$Maybe$Just(
								_Utils_Tuple2(brokerAccount, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 9:
				var brokerAccount = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							fG: $elm$core$Maybe$Just(
								_Utils_Tuple2(brokerAccount, $author$project$Api$Data$Loading))
						}),
					A3(
						$author$project$Api$Provider$BrokerAccount$archive,
						apiClient,
						$author$project$Api$Provider$BrokerAccount$One$id(brokerAccount),
						$author$project$Components$Commissions$BrokerAccount$Form$Archived(brokerAccount)),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{fG: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 10:
				var brokerAccount = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__Top),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Broker Account archived')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								fG: $elm$core$Maybe$Just(
									_Utils_Tuple2(brokerAccount, response))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 11:
				var brokerAccount = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							f7: $elm$core$Maybe$Just(
								_Utils_Tuple2(brokerAccount, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 12:
				var brokerAccount = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							f7: $elm$core$Maybe$Just(
								_Utils_Tuple2(brokerAccount, $author$project$Api$Data$Loading))
						}),
					A3(
						$author$project$Api$Provider$BrokerAccount$delete,
						apiClient,
						$author$project$Api$Provider$BrokerAccount$One$id(brokerAccount),
						$author$project$Components$Commissions$BrokerAccount$Form$Deleted(brokerAccount)),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{f7: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 13:
				var brokerAccount = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__Top),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Broker Account deleted')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								f7: $elm$core$Maybe$Just(
									_Utils_Tuple2(brokerAccount, response))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 14:
				var brokerAccount = msg.a;
				var _v31 = A3(
					$author$project$Components$Broker$EndModal$init,
					model.aa4,
					model.dd,
					$author$project$Components$Broker$EndModal$BrokerAccount(brokerAccount));
				var endModal = _v31.a;
				var endModalCmd = _v31.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							gm: $elm$core$Maybe$Just(endModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$Form$EndModalMsg, endModalCmd),
					_List_Nil);
			case 15:
				var subMsg = msg.a;
				var _v32 = model.gm;
				if (!_v32.$) {
					var endModal = _v32.a;
					var endModalResult = A3($author$project$Components$Broker$EndModal$update, apiClient, subMsg, endModal);
					var _v33 = function () {
						var _v34 = endModalResult.agZ;
						switch (_v34.$) {
							case 0:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(endModalResult.aiO),
									model.SD,
									$elm$core$Platform$Cmd$none);
							case 1:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.SD, $elm$core$Platform$Cmd$none);
							case 2:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.SD, $elm$core$Platform$Cmd$none);
							default:
								var brokerAccount = _v34.a;
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$elm$core$Maybe$Nothing,
									A3(
										$author$project$Api$Provider$BrokerAccount$retrieve,
										apiClient,
										$author$project$Api$Provider$BrokerAccount$One$id(brokerAccount),
										$author$project$Components$Commissions$BrokerAccount$Form$GotItem));
						}
					}();
					var endModal_ = _v33.a;
					var form = _v33.b;
					var cmd = _v33.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{gm: endModal_, SD: form}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$Form$EndModalMsg, endModalResult.GZ),
									cmd
								])),
						endModalResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var subMsg = msg.a;
				var _v35 = model.SD;
				if (!_v35.$) {
					var _v36 = _v35.a;
					var form = _v36.a;
					var retailSchedule = _v36.b;
					var retailScheduleResult = A3($author$project$Components$Commissions$BrokerAccount$RetailSchedule$update, apiClient, subMsg, retailSchedule);
					var newForm = function () {
						var _v37 = retailScheduleResult.agZ;
						return form;
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								SD: $elm$core$Maybe$Just(
									_Utils_Tuple2(newForm, retailScheduleResult.aiO))
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$Form$RetailScheduleMsg, retailScheduleResult.GZ),
						retailScheduleResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Top$update = F2(
	function (msg, model) {
		var _v0 = A3($author$project$Components$Commissions$BrokerAccount$Form$update, model.Gv, msg, model.SD);
		var form = _v0.a;
		var cmd = _v0.b;
		var outMsgs = _v0.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{SD: form}),
			cmd,
			outMsgs);
	});
var $author$project$Components$Commissions$BrokerAccount$Form$Save = {$: 3};
var $author$project$Components$Commissions$BrokerAccount$Form$button = function (model) {
	var label = function () {
		var _v0 = model.ahP;
		if (!_v0.$) {
			return 'Update';
		} else {
			return 'Add new account';
		}
	}();
	return A3(
		$author$project$Ui$Button$view,
		{mm: label},
		_List_fromArray(
			[
				$author$project$Ui$Button$primary,
				$author$project$Ui$Button$loading(
				_Utils_eq(model.k9, $author$project$Api$Data$Loading)),
				$author$project$Ui$Button$onClick($author$project$Components$Commissions$BrokerAccount$Form$Save)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(label)
			]));
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$AddRetailRate = {$: 0};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$view = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.SD);
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Add retail commission')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$onSubmit($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$AddRetailRate)
							]),
						A2(
							$elm$core$List$map,
							$elm$html$Html$map($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$PricingStructureSelectMsg),
							A2(
								$author$project$Components$PricingStructureSelect$view,
								_List_fromArray(
									[
										$author$project$Components$PricingStructureSelect$value(fields._l),
										$author$project$Components$PricingStructureSelect$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 0, model.SD)),
										$author$project$Components$PricingStructureSelect$errors(
										A2($author$project$Utils$Form$validationErrors, 0, model.SD))
									]),
								model.pk)))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Cancle and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Add retail rate'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$onClick($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$AddRetailRate)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Add')
							]))
					]))
			]));
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$AddRetailRate = {$: 0};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$FormUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$IntervalInMonths = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$view = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.SD);
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Add retail commission')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$onSubmit($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$AddRetailRate)
							]),
						A2(
							$elm$core$List$cons,
							A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Number of months'),
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(4),
										$author$project$Ui$Form$Group$required(true)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$value(
												A2(
													$elm$core$Maybe$withDefault,
													'',
													A2($elm$core$Maybe$map, $elm$core$String$fromInt, fields.ah2))),
												$author$project$Ui$Form$Input$onInput(
												A2($elm$core$Basics$composeL, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$FormUpdated, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$IntervalInMonths)),
												$author$project$Ui$Form$Input$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, 1, model.SD)),
												$author$project$Ui$Form$Input$errors(
												A2($author$project$Utils$Form$validationErrors, 1, model.SD))
											])),
										A2(
										$author$project$Ui$Typography$p,
										_List_fromArray(
											[$author$project$Ui$Typography$helpBlock]),
										_List_fromArray(
											[
												$elm$html$Html$text('Identify in how many months the rate should be changed')
											]))
									])),
							A2(
								$elm$core$List$map,
								$elm$html$Html$map($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$PricingStructureSelectMsg),
								A2(
									$author$project$Components$PricingStructureSelect$view,
									_List_fromArray(
										[
											$author$project$Components$PricingStructureSelect$value(fields._l),
											$author$project$Components$PricingStructureSelect$invalid(
											A2($author$project$Utils$Form$hasValidationErrors, 0, model.SD)),
											$author$project$Components$PricingStructureSelect$errors(
											A2($author$project$Utils$Form$validationErrors, 0, model.SD))
										]),
									model.pk))))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Add retail rate'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$onClick($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$AddRetailRate)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Add')
							]))
					]))
			]));
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$ChangeRate = {$: 0};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$view = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.SD);
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Confirm retail rate change')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$onSubmit($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$ChangeRate)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpBlock]),
								_List_fromArray(
									[
										$elm$html$Html$text('You are about to change the retail commission structure. This will not update the existing deals on this rate.')
									])),
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Effective date'),
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(4),
										$author$project$Ui$Form$Group$required(true)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$StartDateDateInputMsg(fields.uO),
										A2(
											$author$project$Components$DateInput$view,
											_List_fromArray(
												[
													$author$project$Components$DateInput$value(fields.ab7),
													$author$project$Components$DateInput$invalid(
													A2($author$project$Utils$Form$hasValidationErrors, 0, model.SD)),
													$author$project$Components$DateInput$errors(
													A2($author$project$Utils$Form$validationErrors, 0, model.SD))
												]),
											fields.uO))
									]))
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Revert to previous rate'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Revert to previous rate')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Change rate'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$onClick($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$ChangeRate)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Change rate')
							]))
					]))
			]));
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$AddRetailRate = {$: 0};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$FormUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$IntervalInMonths = $elm$core$Basics$identity;
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$view = function (_v0) {
	var form = _v0;
	var fields = $author$project$Utils$Form$fields(form);
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Add retail commission')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$onSubmit($author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$AddRetailRate)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Number of months'),
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(4),
										$author$project$Ui$Form$Group$required(true)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$value(
												A2(
													$elm$core$Maybe$withDefault,
													'',
													A2($elm$core$Maybe$map, $elm$core$String$fromInt, fields.ah2))),
												$author$project$Ui$Form$Input$onInput(
												A2($elm$core$Basics$composeL, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$FormUpdated, $elm$core$Basics$identity)),
												$author$project$Ui$Form$Input$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
												$author$project$Ui$Form$Input$errors(
												A2($author$project$Utils$Form$validationErrors, 0, form))
											])),
										A2(
										$author$project$Ui$Typography$p,
										_List_fromArray(
											[$author$project$Ui$Typography$helpBlock]),
										_List_fromArray(
											[
												$elm$html$Html$text('Identify in how many months the rate should be changed')
											]))
									]))
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Add retail rate'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$onClick($author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$AddRetailRate)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Add')
							]))
					]))
			]));
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$modal = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				function () {
				var _v0 = model.c3;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var isCurrent = _v1.a;
					var index = _v1.b;
					return A2(
						$author$project$Components$HiConfirm$modal,
						A2($author$project$Components$Commissions$BrokerAccount$RetailSchedule$CancelHiConfirmClosed, isCurrent, index),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('cancel'),
								$author$project$Components$HiConfirm$noun('interval rate'),
								$author$project$Components$HiConfirm$customMessage(
								_List_fromArray(
									[
										$elm$html$Html$text('Are you sure you want to cancel this rate?')
									]))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v2 = model.ig;
				if (!_v2.$) {
					var addScheduleModal = _v2.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModalMsg,
						$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$view(addScheduleModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v3 = model.fy;
				if (!_v3.$) {
					var _v4 = _v3.a;
					var addRetailModal = _v4.c;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModalMsg,
						$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$view(addRetailModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v5 = model.fz;
				if (!_v5.$) {
					var _v6 = _v5.a;
					var addRetailRateChangeModal = _v6.c;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModalMsg,
						$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$view(addRetailRateChangeModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v7 = model.jE;
				if (!_v7.$) {
					var _v8 = _v7.a;
					var endDealModal = _v8.b;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModalMsg,
						$author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$view(endDealModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]));
};
var $author$project$Components$Commissions$BrokerAccount$Form$modal = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				function () {
				var _v0 = model.fG;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var brokerAccount = _v1.a;
					var archiveRequest = _v1.b;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Components$Commissions$BrokerAccount$Form$ArchiveHiConfirmClosed(brokerAccount),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$customMessage(
								_List_fromArray(
									[
										$elm$html$Html$text('This will end all brokers effective today and will archive the broker account.')
									])),
								$author$project$Components$HiConfirm$loading(
								_Utils_eq(archiveRequest, $author$project$Api$Data$Loading))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v2 = model.f7;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var brokerAccount = _v3.a;
					var deleteRequest = _v3.b;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Components$Commissions$BrokerAccount$Form$DeleteHiConfirmClosed(brokerAccount),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$customMessage(
								_List_fromArray(
									[
										$elm$html$Html$text('Once deleted this broker account can not be recovered.  All data, historical and current will be deleted.  To hide this broker account from view without deleting data it can be archived.')
									])),
								$author$project$Components$HiConfirm$loading(
								_Utils_eq(deleteRequest, $author$project$Api$Data$Loading))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v4 = model.gm;
				if (!_v4.$) {
					var endModal = _v4.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$Commissions$BrokerAccount$Form$EndModalMsg,
						$author$project$Components$Broker$EndModal$view(endModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v5 = model.SD;
				if (!_v5.$) {
					var _v6 = _v5.a;
					var retailSchedule = _v6.b;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$Commissions$BrokerAccount$Form$RetailScheduleMsg,
						$author$project$Components$Commissions$BrokerAccount$RetailSchedule$modal(retailSchedule));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]));
};
var $author$project$Components$Commissions$BrokerAccount$Form$Archive = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$Form$Ein = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$Form$EndAllDeals = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$Form$FormUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$Form$MultipleBrokers = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$Form$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$Form$SingleBrokerName = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$Form$UpdateRetailCommissionSchedule = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$retailEnabled = function ($) {
	return $.ak0;
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$ShowAddRetailModal = {$: 0};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$Cancel = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EditInterval = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$viewInterval = F5(
	function (showControls, intervals, isCurrent, index, interval) {
		var previousInterval = A2($elm_community$list_extra$List$Extra$getAt, index - 1, intervals);
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('timeline__item')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mb1]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[$author$project$Ui$Typography$muted]),
							function () {
								if (previousInterval.$ === 1) {
									return 'Start of the deal';
								} else {
									var previousInterval_ = previousInterval.a;
									return 'After ' + (A2(
										$elm$core$Maybe$withDefault,
										'',
										A2($elm$core$Maybe$map, $elm$core$String$fromInt, previousInterval_.ah2)) + ' months');
								}
							}())
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($elm$core$Maybe$withDefault, 'N/A', interval._l.Qr)),
							function () {
							if (showControls) {
								var label = (!index) ? 'Edit Rate' : 'Edit Rate Change';
								return A3(
									$author$project$Ui$Button$view,
									{mm: label},
									_List_fromArray(
										[
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick(
											A2($author$project$Components$Commissions$BrokerAccount$RetailSchedule$EditInterval, isCurrent, index)),
											$author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(label)
										]));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}(),
							(showControls && (!(!index))) ? A3(
							$author$project$Ui$Button$view,
							{mm: 'Cancel rate change'},
							_List_fromArray(
								[
									$author$project$Ui$Button$sm,
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$onClick(
									A2($author$project$Components$Commissions$BrokerAccount$RetailSchedule$Cancel, isCurrent, index)),
									$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel Rate Change')
								])) : $author$project$Utils$Html$empty
						]))
				]));
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChange = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDeal = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$RemoveEndDeal = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$viewRatePeriodScheduleActions = F5(
	function (showRemoveEndDeal, showControls, scheduleEnded, isCurrent, intervals) {
		return _List_fromArray(
			[
				function () {
				if (scheduleEnded) {
					var lastInterval = $elm_community$list_extra$List$Extra$last(intervals);
					return A2(
						$elm$html$Html$li,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('timeline__item')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$mb1]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$text,
										_List_fromArray(
											[$author$project$Ui$Typography$muted]),
										'End after '),
										A2(
										$author$project$Ui$Typography$text,
										_List_fromArray(
											[$author$project$Ui$Typography$muted]),
										A2(
											$elm$core$Maybe$withDefault,
											'N/A',
											A2(
												$elm$core$Maybe$map,
												$elm$core$String$fromInt,
												A2(
													$elm$core$Maybe$andThen,
													function ($) {
														return $.ah2;
													},
													lastInterval)))),
										A2(
										$author$project$Ui$Typography$text,
										_List_fromArray(
											[$author$project$Ui$Typography$muted]),
										' months')
									]))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				(scheduleEnded && showRemoveEndDeal) ? A2(
				$elm$html$Html$li,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('timeline__item')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Remove end date'},
						_List_fromArray(
							[
								$author$project$Ui$Button$sm,
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$onClick(
								$author$project$Components$Commissions$BrokerAccount$RetailSchedule$RemoveEndDeal(isCurrent)),
								$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Remove End Date')
							]))
					])) : $author$project$Utils$Html$empty,
				((!scheduleEnded) && showControls) ? A2(
				$elm$html$Html$li,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('timeline__item')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$gap2]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Add rate change'},
								_List_fromArray(
									[
										$author$project$Ui$Button$sm,
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$onClick(
										$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChange(isCurrent)),
										$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Add Rate Change')
									])),
								A3(
								$author$project$Ui$Button$view,
								{mm: 'End the deal'},
								_List_fromArray(
									[
										$author$project$Ui$Button$sm,
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$onClick(
										$author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDeal(isCurrent)),
										$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('End The Deal')
									]))
							]))
					])) : $author$project$Utils$Html$empty
			]);
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$viewCurrentRatePeriodSchedule = F2(
	function (hasSavedSchedule, model) {
		var currentIntervals_ = A2($elm$core$Maybe$withDefault, _List_Nil, model.aI);
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Current retail schedule')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('timeline')
						]),
					$elm$core$List$concat(
						_List_fromArray(
							[
								A2(
								$elm$core$List$indexedMap,
								A3($author$project$Components$Commissions$BrokerAccount$RetailSchedule$viewInterval, !hasSavedSchedule, currentIntervals_, true),
								currentIntervals_),
								_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('timeline__item')
										]),
									_List_fromArray(
										[
											(hasSavedSchedule && (!model.Pi)) ? A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$mb1]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$text,
													_List_fromArray(
														[$author$project$Ui$Typography$muted]),
													'Recurring Deal')
												])) : $author$project$Utils$Html$empty
										]))
								]),
								A5($author$project$Components$Commissions$BrokerAccount$RetailSchedule$viewRatePeriodScheduleActions, !hasSavedSchedule, !hasSavedSchedule, model.Pi, true, currentIntervals_)
							])))
				]));
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddNewSchedule = {$: 8};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$viewFutureRatePeriodSchedule = F2(
	function (futureScheduleEnded, model) {
		var futureIntervals_ = A2($elm$core$Maybe$withDefault, _List_Nil, model.ah);
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Future retail schedule')
				]),
			_List_fromArray(
				[
					function () {
					var _v0 = model.gv;
					if (!_v0.$) {
						var futureStartDate_ = _v0.a;
						return A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Updated rate starting from '),
									$elm$html$Html$text(
									A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, futureStartDate_))
								]));
					} else {
						return A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$ml1]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{mm: 'Add new schedule'},
											_List_fromArray(
												[
													$author$project$Ui$Button$sm,
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddNewSchedule),
													$author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Add new schedule')
												]))
										]))
								]));
					}
				}(),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('timeline')
						]),
					$elm$core$List$concat(
						_List_fromArray(
							[
								A2(
								$elm$core$List$indexedMap,
								A3($author$project$Components$Commissions$BrokerAccount$RetailSchedule$viewInterval, true, futureIntervals_, false),
								futureIntervals_),
								A5(
								$author$project$Components$Commissions$BrokerAccount$RetailSchedule$viewRatePeriodScheduleActions,
								true,
								$author$project$Utils$Maybe$toBool(model.gv),
								futureScheduleEnded,
								false,
								futureIntervals_)
							])))
				]));
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$view = function (model) {
	var hasSavedSchedule = $author$project$Utils$Maybe$toBool(
		A2($elm$core$Maybe$andThen, $author$project$Api$Provider$BrokerAccount$One$ratePeriodSchedule, model.xG));
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Typography$headingSm(
				_List_fromArray(
					[
						$elm$html$Html$text('Retail commission schedule')
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpan(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Retail Commissions')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Enable commission on retail memberships')
							])),
						$author$project$Ui$ToggleSwitch$view(
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$on(model.ak0),
								$author$project$Ui$ToggleSwitch$onChange(
								$elm$core$Basics$always($author$project$Components$Commissions$BrokerAccount$RetailSchedule$ShowAddRetailModal)),
								$author$project$Ui$ToggleSwitch$disabled(model.ak0)
							]))
					])),
				model.ak0 ? A2($author$project$Components$Commissions$BrokerAccount$RetailSchedule$viewCurrentRatePeriodSchedule, hasSavedSchedule, model) : $author$project$Utils$Html$empty,
				(model.ak0 && hasSavedSchedule) ? A2($author$project$Components$Commissions$BrokerAccount$RetailSchedule$viewFutureRatePeriodSchedule, model.SQ, model) : $author$project$Utils$Html$empty
			]));
};
var $author$project$Components$Commissions$BrokerAccount$Form$Delete = function (a) {
	return {$: 11, a: a};
};
var $author$project$Api$Provider$BrokerAccount$Meta$destroyable = function (_v0) {
	var record = _v0;
	return record.Qw;
};
var $author$project$Components$Commissions$BrokerAccount$Form$viewDeleteButton = F2(
	function (brokerAccount, saveRequest) {
		return $author$project$Api$Provider$BrokerAccount$Meta$destroyable(
			$author$project$Api$Provider$BrokerAccount$One$meta(brokerAccount)) ? A3(
			$author$project$Ui$Button$view,
			{mm: 'Delete broker account'},
			_List_fromArray(
				[
					$author$project$Ui$Button$danger,
					$author$project$Ui$Button$loading(
					_Utils_eq(saveRequest, $author$project$Api$Data$Loading)),
					$author$project$Ui$Button$onClick(
					$author$project$Components$Commissions$BrokerAccount$Form$Delete(brokerAccount))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Delete')
				])) : A3(
			$author$project$Ui$Tooltip$view,
			_List_Nil,
			'Statements have been issued or paid so this broker account can no longer be deleted.  Archive this account to hide it from view.',
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{mm: 'Delete broker account'},
					_List_fromArray(
						[
							$author$project$Ui$Button$danger,
							$author$project$Ui$Button$disabled(true)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Delete')
						]))
				]));
	});
var $author$project$Components$Commissions$BrokerAccount$Form$viewForm = F3(
	function (model, retailSchedule, form) {
		var fields = $author$project$Utils$Form$fields(form);
		return $elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8),
								$author$project$Ui$Form$Group$required(true),
								$author$project$Ui$Form$Group$label('Business Name')
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$value(fields.Bq),
										$author$project$Ui$Form$Input$placeholder('e.g. Heffernan Insurance Brokers'),
										$author$project$Ui$Form$Input$autofocus(true),
										$author$project$Ui$Form$Input$onInput(
										A2($elm$core$Basics$composeL, $author$project$Components$Commissions$BrokerAccount$Form$FormUpdated, $author$project$Components$Commissions$BrokerAccount$Form$Name)),
										$author$project$Ui$Form$Input$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
										$author$project$Ui$Form$Input$errors(
										A2($author$project$Utils$Form$validationErrors, 0, form))
									]))
							])),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8),
								$author$project$Ui$Form$Group$label('EIN')
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$Ein$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Ein$value(fields.Q9),
										$author$project$Ui$Form$Ein$onInput(
										A2($elm$core$Basics$composeL, $author$project$Components$Commissions$BrokerAccount$Form$FormUpdated, $author$project$Components$Commissions$BrokerAccount$Form$Ein)),
										$author$project$Ui$Form$Ein$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
										$author$project$Ui$Form$Ein$errors(
										A2($author$project$Utils$Form$validationErrors, 1, form))
									]))
							])),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8),
								$author$project$Ui$Form$Group$label('Legal Address')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$Commissions$BrokerAccount$Form$AddressInputMsg,
								A2($author$project$Components$AddressInput$view, _List_Nil, fields.K2))
							])),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpan(4),
								$author$project$Ui$Form$Group$inputSpan(8),
								$author$project$Ui$Form$Group$label('Multiple Brokers')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Static$view,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Will this account cover more than one broker?')
									])),
								$author$project$Ui$ToggleSwitch$view(
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$on(fields.Xw),
										$author$project$Ui$ToggleSwitch$onChange(
										A2($elm$core$Basics$composeL, $author$project$Components$Commissions$BrokerAccount$Form$FormUpdated, $author$project$Components$Commissions$BrokerAccount$Form$MultipleBrokers))
									]))
							]))
					]),
					fields.Xw ? _List_Nil : _List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8),
								$author$project$Ui$Form$Group$required(true),
								$author$project$Ui$Form$Group$label('Broker Name')
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$value(
										A2($elm$core$Maybe$withDefault, '', fields.abB)),
										$author$project$Ui$Form$Input$placeholder('e.g. John Doe'),
										$author$project$Ui$Form$Input$onInput(
										A2($elm$core$Basics$composeL, $author$project$Components$Commissions$BrokerAccount$Form$FormUpdated, $author$project$Components$Commissions$BrokerAccount$Form$SingleBrokerName)),
										$author$project$Ui$Form$Input$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 3, form)),
										$author$project$Ui$Form$Input$errors(
										A2($author$project$Utils$Form$validationErrors, 3, form))
									]))
							]))
					]),
					function () {
					var _v0 = model.ahP;
					if (!_v0.$) {
						return _List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$spanSm(2),
												$author$project$Ui$Grid$offsetSm(6)
											]),
										_List_fromArray(
											[
												$author$project$Components$Commissions$BrokerAccount$Form$button(model)
											]))
									]))
							]);
					} else {
						return _List_Nil;
					}
				}(),
					_List_fromArray(
					[
						$author$project$Ui$HorizontalRule$view(_List_Nil),
						A2(
						$elm$html$Html$map,
						$author$project$Components$Commissions$BrokerAccount$Form$RetailScheduleMsg,
						$author$project$Components$Commissions$BrokerAccount$RetailSchedule$view(retailSchedule)),
						function () {
						var _v1 = model.Io;
						if (!_v1.$) {
							var item = _v1.a;
							return $author$project$Components$Commissions$BrokerAccount$RetailSchedule$retailEnabled(retailSchedule) ? A2(
								$author$project$Ui$Grid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$spanSm(2),
												$author$project$Ui$Grid$offsetSm(6)
											]),
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Button$view,
												{mm: 'Update retail schedule'},
												_List_fromArray(
													[
														$author$project$Ui$Button$primary,
														$author$project$Ui$Button$loading(
														_Utils_eq(model.qQ, $author$project$Api$Data$Loading)),
														$author$project$Ui$Button$onClick(
														$author$project$Components$Commissions$BrokerAccount$Form$UpdateRetailCommissionSchedule(item)),
														$author$project$Ui$Button$disabled(
														$author$project$Api$Provider$BrokerAccount$One$retailEnabled(item) && (!$author$project$Utils$Maybe$toBool(
															$author$project$Components$Commissions$BrokerAccount$RetailSchedule$futureIntervals(retailSchedule))))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Update')
													]))
											]))
									])) : $author$project$Utils$Html$empty;
						} else {
							return $author$project$Utils$Html$empty;
						}
					}()
					]),
					function () {
					var _v2 = model.Io;
					if (!_v2.$) {
						var item = _v2.a;
						return _List_fromArray(
							[
								$author$project$Ui$HorizontalRule$view(_List_Nil),
								$author$project$Ui$Typography$headingSm(
								_List_fromArray(
									[
										$elm$html$Html$text('Archive Broker Account')
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$gray]),
								_List_fromArray(
									[
										$elm$html$Html$text('Archive this broker account to hide it from the list. If no statements are paid you may also delete this broker account; deleting an account will also delete all historical commission calculations and date, this cannot be undone.')
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$gray]),
								_List_fromArray(
									[
										$elm$html$Html$text('Ending all deals will stop all future commission calculations, but will not archive the account. The end date can be today or in the future.')
									])),
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$gap2]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Archive broker account'},
										_List_fromArray(
											[
												$author$project$Ui$Button$danger,
												$author$project$Ui$Button$loading(
												_Utils_eq(model.k9, $author$project$Api$Data$Loading)),
												$author$project$Ui$Button$onClick(
												$author$project$Components$Commissions$BrokerAccount$Form$Archive(item))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Archive')
											])),
										A2($author$project$Components$Commissions$BrokerAccount$Form$viewDeleteButton, item, model.k9),
										A3(
										$author$project$Ui$Button$view,
										{mm: 'End all deals for account'},
										_List_fromArray(
											[
												$author$project$Ui$Button$loading(
												_Utils_eq(model.k9, $author$project$Api$Data$Loading)),
												$author$project$Ui$Button$onClick(
												$author$project$Components$Commissions$BrokerAccount$Form$EndAllDeals(item))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('End All Deals')
											]))
									]))
							]);
					} else {
						return _List_Nil;
					}
				}()
				]));
	});
var $author$project$Components$Commissions$BrokerAccount$Form$view = function (_v0) {
	var model = _v0;
	return _List_fromArray(
		[
			$author$project$Components$Commissions$BrokerAccount$Form$modal(model),
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Panel$title(
							_List_fromArray(
								[
									function () {
									var _v1 = model.ahP;
									if (!_v1.$) {
										return $elm$html$Html$text('Broker Account Information');
									} else {
										return $elm$html$Html$text('Add New Broker Account');
									}
								}()
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$noValidate(true),
									$author$project$Ui$Form$autocomplete(false)
								]),
							function () {
								var _v2 = model.SD;
								if (!_v2.$) {
									var _v3 = _v2.a;
									var form = _v3.a;
									var retailSchedule = _v3.b;
									return A3($author$project$Components$Commissions$BrokerAccount$Form$viewForm, model, retailSchedule, form);
								} else {
									return _List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$textCenter]),
											_List_fromArray(
												[
													$author$project$Ui$Spinner$view(_List_Nil)
												]))
										]);
								}
							}())
						])),
					function () {
					var _v4 = model.ahP;
					if (!_v4.$) {
						return $author$project$Ui$Panel$none;
					} else {
						return A2(
							$author$project$Ui$Panel$footer,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$itemsCenter]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__Top,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Cancel')
												])),
											$author$project$Components$Commissions$BrokerAccount$Form$button(model)
										]))
								]));
					}
				}()
				]))
		]);
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Top$view = function (model) {
	return {
		fO: $author$project$Components$Commissions$BrokerAccount$Form$view(model.SD),
		ac9: 'Commissions | Broker Accounts'
	};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Top$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Top$init, aiq: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Top$load, k8: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Top$save, alO: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Top$subscriptions, adT: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Top$update, amo: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Top$view});
var $author$project$Pages$Commissions$BrokerAccounts$New$init = F4(
	function (session, _v0, _v1, _v2) {
		var apiClient = _v1.Gv;
		var timeZone = _v1.J8;
		var currentDate = _v1.dd;
		var _v3 = A5($author$project$Components$Commissions$BrokerAccount$Form$init, apiClient, timeZone, currentDate, session, $elm$core$Maybe$Nothing);
		var form = _v3.a;
		var cmd = _v3.b;
		return _Utils_Tuple2(
			{Gv: apiClient, SD: form},
			cmd);
	});
var $author$project$Pages$Commissions$BrokerAccounts$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Commissions$BrokerAccounts$New$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Commissions$BrokerAccounts$New$subscriptions = function (model) {
	return $author$project$Components$Commissions$BrokerAccount$Form$subscriptions(model.SD);
};
var $author$project$Pages$Commissions$BrokerAccounts$New$update = F2(
	function (msg, model) {
		var _v0 = A3($author$project$Components$Commissions$BrokerAccount$Form$update, model.Gv, msg, model.SD);
		var form = _v0.a;
		var cmd = _v0.b;
		var outMsgs = _v0.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{SD: form}),
			cmd,
			outMsgs);
	});
var $author$project$Pages$Commissions$BrokerAccounts$New$view = function (model) {
	return {
		fO: $author$project$Components$Commissions$BrokerAccount$Form$view(model.SD),
		ac9: 'Commissions | Broker Accounts'
	};
};
var $author$project$Pages$Commissions$BrokerAccounts$New$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Commissions$BrokerAccounts$New$init, aiq: $author$project$Pages$Commissions$BrokerAccounts$New$load, k8: $author$project$Pages$Commissions$BrokerAccounts$New$save, alO: $author$project$Pages$Commissions$BrokerAccounts$New$subscriptions, adT: $author$project$Pages$Commissions$BrokerAccounts$New$update, amo: $author$project$Pages$Commissions$BrokerAccounts$New$view});
var $author$project$Pages$Commissions$BrokerAccounts$Top$GotBrokerAccounts = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$Top$fetchBrokerAccounts = function (model) {
	return A3(
		$author$project$Api$Provider$BrokerAccount$list,
		model.Gv,
		function (d) {
			return _Utils_update(
				d,
				{ajJ: model.ajJ, akl: model.akl, alA: model.alA});
		},
		$author$project$Pages$Commissions$BrokerAccounts$Top$GotBrokerAccounts);
};
var $author$project$Pages$Commissions$BrokerAccounts$Top$init = F4(
	function (_v0, _v1, _v2, _v3) {
		var apiClient = _v2.Gv;
		var query = _v3.DE;
		var q = A2($elm$core$Dict$get, 'q', query);
		var model = {
			Gv: apiClient,
			iB: $author$project$Api$Data$Loading,
			ajJ: $author$project$Api$Pagination$initFromQuery(query),
			akl: q,
			up: $author$project$Ui$SearchInput$init(q),
			alA: $author$project$Api$Sort$initFromQuery(query)
		};
		return _Utils_Tuple2(
			model,
			$author$project$Pages$Commissions$BrokerAccounts$Top$fetchBrokerAccounts(model));
	});
var $author$project$Pages$Commissions$BrokerAccounts$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Commissions$BrokerAccounts$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Commissions$BrokerAccounts$Top$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Commissions$BrokerAccounts$Top$SearchInputMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$Top$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('q'),
			model.akl)
		]);
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Commissions__BrokerAccounts__Top)
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.ajJ),
				A2(
					$elm$core$List$append,
					$author$project$Api$Sort$toQuery(model.alA),
					A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
};
var $author$project$Pages$Commissions$BrokerAccounts$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								iB: response,
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{iB: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Commissions$BrokerAccounts$Top$fetchBrokerAccounts(newModel),
								$author$project$Pages$Commissions$BrokerAccounts$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 2:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						alA: A2($author$project$Api$Sort$update, columnId, model.alA)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Commissions$BrokerAccounts$Top$fetchBrokerAccounts(newModel),
								$author$project$Pages$Commissions$BrokerAccounts$Top$updateUrl(newModel)
							])),
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Ui$SearchInput$update, subMsg, model.up);
				var searchInput = _v2.a;
				var searchInputCmd = _v2.b;
				var searchInputEvent = _v2.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.akl;
					}
				}();
				var _v3 = function () {
					if (_Utils_eq(q, model.akl)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								iB: $author$project$Api$Data$Loading,
								ajJ: $author$project$Api$Pagination$reset(model.ajJ),
								akl: q
							});
						return _Utils_Tuple2(
							qModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Commissions$BrokerAccounts$Top$fetchBrokerAccounts(qModel),
										$author$project$Pages$Commissions$BrokerAccounts$Top$updateUrl(qModel)
									])));
					}
				}();
				var newModel = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{up: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$Top$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
		}
	});
var $author$project$Pages$Commissions$BrokerAccounts$Top$PaginationMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$Top$SortTable = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$Top$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'name', false, 'Name'),
		A3($author$project$Api$Column$init, 'brokers', false, 'Brokers'),
		A3($author$project$Api$Column$init, 'retail_enabled', true, 'Retail Enabled')
	]);
var $author$project$Api$Provider$BrokerAccount$All$brokers = function (_v0) {
	var record = _v0.b;
	return record.MS;
};
var $author$project$Api$Provider$BrokerAccount$All$retailEnabled = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BrokerAccount$Shared$retailEnabled(shared);
};
var $author$project$Pages$Commissions$BrokerAccounts$Top$viewBrokerAccount = function (brokerAccount) {
	return A2(
		$author$project$Ui$Table$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4)
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Deals(
							{
								cm: $author$project$Api$Provider$BrokerAccount$All$id(brokerAccount)
							}),
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Api$Provider$BrokerAccount$All$name(brokerAccount))
							]))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Formatters$String$toSentence(
							A2(
								$elm$core$List$map,
								$author$project$Api$Provider$Broker$Shared$name,
								$author$project$Api$Provider$BrokerAccount$All$brokers(brokerAccount))))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Formatters$Bool$toString(
							$author$project$Api$Provider$BrokerAccount$All$retailEnabled(brokerAccount)))
					]))
			]));
};
var $author$project$Pages$Commissions$BrokerAccounts$Top$viewPanelBody = function (model) {
	var _v0 = function () {
		var _v1 = model.iB;
		if (_v1.$ === 3) {
			var brokerAccounts_ = _v1.a;
			return _Utils_Tuple2(false, brokerAccounts_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var brokerAccounts = _v0.b;
	return _List_fromArray(
		[
			A4(
			$author$project$Ui$Table$view,
			_List_fromArray(
				[
					$author$project$Ui$Table$verticalCentered,
					$author$project$Ui$Table$zeroState(
					function () {
						var _v2 = model.akl;
						if (!_v2.$) {
							return _List_fromArray(
								[
									$elm$html$Html$text('No matching results. Please check your search query or '),
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__New,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('create a new broker account')
										])),
									$elm$html$Html$text('.')
								]);
						} else {
							return _List_fromArray(
								[
									$elm$html$Html$text('It looks like you haven’t added any broker accounts yet. '),
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__New,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Create one')
										])),
									$elm$html$Html$text('?')
								]);
						}
					}()),
					$author$project$Ui$Table$loading(loading)
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						A2(
						$elm$core$List$map,
						$author$project$Api$Column$view(
							A2($author$project$Api$Column$Sortable, model.alA, $author$project$Pages$Commissions$BrokerAccounts$Top$SortTable)),
						$author$project$Pages$Commissions$BrokerAccounts$Top$columns),
						_List_fromArray(
						[
							A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
						])
					])),
			A2($elm$core$List$map, $author$project$Pages$Commissions$BrokerAccounts$Top$viewBrokerAccount, brokerAccounts),
			_List_Nil)
		]);
};
var $author$project$Pages$Commissions$BrokerAccounts$Top$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween]),
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Manage Broker Accounts')
											])),
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__New,
										_List_fromArray(
											[
												$author$project$Ui$Link$buttonDefault,
												$author$project$Ui$Link$icon($author$project$Ui$Icon$add)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Add Account')
											]))
									])),
								A2(
								$author$project$Ui$Grid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$spanMd(10)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$p,
												_List_fromArray(
													[$author$project$Ui$Typography$gray]),
												_List_fromArray(
													[
														$elm$html$Html$text('A broker account represents the business entity to which you will pay a commission.  You can add more than one broker to each account, but those brokers will not each receive a statement.')
													]))
											]))
									])),
								A2(
								$author$project$Ui$Grid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Pages$Commissions$BrokerAccounts$Top$SearchInputMsg,
												A2(
													$author$project$Ui$SearchInput$view,
													_List_fromArray(
														[
															$author$project$Ui$SearchInput$placeholder('Search for account and broker names')
														]),
													model.up))
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						$author$project$Pages$Commissions$BrokerAccounts$Top$viewPanelBody(model)),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								function () {
								var _v0 = model.iB;
								if (_v0.$ === 3) {
									return A2(
										$elm$html$Html$map,
										$author$project$Pages$Commissions$BrokerAccounts$Top$PaginationMsg,
										A2($author$project$Api$Pagination$view, _List_Nil, model.ajJ));
								} else {
									return $author$project$Utils$Html$empty;
								}
							}()
							]))
					]))
			]),
		ac9: 'Commissions | Broker Accounts'
	};
};
var $author$project$Pages$Commissions$BrokerAccounts$Top$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Commissions$BrokerAccounts$Top$init, aiq: $author$project$Pages$Commissions$BrokerAccounts$Top$load, k8: $author$project$Pages$Commissions$BrokerAccounts$Top$save, alO: $author$project$Pages$Commissions$BrokerAccounts$Top$subscriptions, adT: $author$project$Pages$Commissions$BrokerAccounts$Top$update, amo: $author$project$Pages$Commissions$BrokerAccounts$Top$view});
var $author$project$Pages$Commissions$StatementLines$Summary$ReportMsg = $elm$core$Basics$identity;
var $author$project$Components$Commissions$StatementLines$Summary = 1;
var $author$project$Components$Commissions$StatementLines$BrokerAccountResourceFilterMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Commissions$StatementLines$BrokerResourceFilterMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Commissions$StatementLines$ByDropdownMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Commissions$StatementLines$CompanyResourceFilterMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Commissions$StatementLines$DateRangeInputMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Commissions$StatementLines$PayableDropdownMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$Report$StatementLine = 2;
var $author$project$Components$Commissions$StatementLines$StatementResourceFilterMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Utils$QueryParameter$fromTuple = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return A2($elm$url$Url$Builder$string, key, value);
};
var $author$project$Utils$QueryParameter$fromList = function (list) {
	return A2($elm$core$List$map, $author$project$Utils$QueryParameter$fromTuple, list);
};
var $author$project$Utils$QueryParameter$fromDict = function (dict) {
	return $author$project$Utils$QueryParameter$fromList(
		$elm$core$Dict$toList(dict));
};
var $author$project$Components$Commissions$StatementLines$urlParams = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Tuple$pair('start'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.dd, 0)),
			model.JV),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Tuple$pair('end'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.dd, 0)),
			model.HB),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('q'),
			model.akl),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('broker_account'),
			model.cm),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('statement'),
			model.alG),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('broker'),
			model.GN),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('company'),
			model.fZ),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Tuple$pair('payable'),
				$author$project$Utils$Bool$toString),
			model.ajV),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('by'),
			model.co)
		]);
	return $elm$core$Dict$fromList(
		A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams));
};
var $author$project$Components$Commissions$StatementLines$buildUrl = function (model) {
	return A2(
		$elm$url$Url$Builder$relative,
		_List_fromArray(
			[
				function () {
				var _v0 = model.co;
				if (!_v0.$) {
					return $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Commissions__StatementLines__Summary);
				} else {
					return $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Commissions__StatementLines__Top);
				}
			}()
			]),
		A2(
			$elm$core$List$append,
			$author$project$Api$Pagination$toPageQuery(model.ajJ),
			A2(
				$elm$core$List$append,
				$author$project$Api$Sort$toQuery(model.alA),
				$author$project$Utils$QueryParameter$fromDict(
					$author$project$Components$Commissions$StatementLines$urlParams(model)))));
};
var $author$project$Components$Commissions$StatementLines$dateRangeInputSettings = F2(
	function (start, end) {
		var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
		return _Utils_update(
			defaultSettings,
			{ahy: start, al5: end});
	});
var $author$project$Components$Commissions$StatementLines$GotStatementLines = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Commissions$StatementLines$fetchStatementLinesParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				xF: model.GN,
				xG: model.cm,
				afQ: model.fZ,
				HB: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.HB),
				ajJ: model.ajJ,
				ajV: model.ajV,
				akl: model.akl,
				alA: model.alA,
				JV: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.JV),
				JW: model.alG
			});
	};
};
var $author$project$Api$Provider$StatementLine$All$StatementLine = $elm$core$Basics$identity;
var $author$project$Api$Provider$StatementLine$All$Record = function (type_) {
	return function (dealType) {
		return function (date) {
			return function (statementNumber) {
				return function (payable) {
					return function (amountInCents) {
						return function (description) {
							return function (patient) {
								return function (owner) {
									return function (broker) {
										return function (statementAdjustment) {
											return function (charge) {
												return function (company) {
													return {LE: amountInCents, xF: broker, afx: charge, afQ: company, PB: date, PT: dealType, Qr: description, YD: owner, YY: patient, ajV: payable, acb: statementAdjustment, acd: statementNumber, amg: type_};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$BrokerDeal$DealType$Company = 0;
var $author$project$Api$Provider$BrokerDeal$DealType$Membership = 1;
var $author$project$Api$Provider$BrokerDeal$DealType$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'Company':
				return $elm$json$Json$Decode$succeed(0);
			case 'Membership':
				return $elm$json$Json$Decode$succeed(1);
			default:
				var somethingElse = string;
				return $elm$json$Json$Decode$fail('Unknown BrokerDeal.DealType: ' + somethingElse);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$Charge$SharedWithInvoice$Charge = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Charge$SharedWithInvoice$Record = function (invoice) {
	return {Uk: invoice};
};
var $author$project$Api$Provider$Charge$SharedWithInvoice$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'invoice',
	$elm$json$Json$Decode$nullable($author$project$Api$Common$Payable$Invoice$MinWithOwner$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Charge$SharedWithInvoice$Record));
var $author$project$Api$Provider$Charge$SharedWithInvoice$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Charge$SharedWithInvoice$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Charge$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Charge$SharedWithInvoice$Charge)));
var $author$project$Api$Provider$StatementAdjustment$Min$StatementAdjustment = $elm$core$Basics$identity;
var $author$project$Api$Provider$StatementAdjustment$Min$Record = F2(
	function (category, memo) {
		return {GW: category, aiG: memo};
	});
var $author$project$Api$Provider$StatementAdjustment$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'memo',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'category',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$StatementAdjustment$Min$Record)));
var $author$project$Api$Provider$StatementAdjustment$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$StatementAdjustment$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$StatementLine$All$CommissionBillLine = 0;
var $author$project$Api$Provider$StatementLine$All$StatementAdjustmentLine = 1;
var $author$project$Api$Provider$StatementLine$All$typeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'CommissionBillLine':
				return $elm$json$Json$Decode$succeed(0);
			case 'StatementAdjustmentLine':
				return $elm$json$Json$Decode$succeed(1);
			default:
				var somethingElse = string;
				return $elm$json$Json$Decode$fail('Unknown StatementLine.type: ' + somethingElse);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$StatementLine$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'company',
	$elm$json$Json$Decode$maybe($author$project$Api$Provider$Company$Min$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'charge',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Charge$SharedWithInvoice$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'statement_adjustment',
			$elm$json$Json$Decode$nullable($author$project$Api$Provider$StatementAdjustment$Min$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'broker',
				$author$project$Api$Provider$Broker$Shared$decoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'owner',
					$elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Min$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'patient',
						$elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Min$decoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'description',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'amount_in_cents',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'payable',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'statement_number',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'date',
											$author$project$Utils$Date$decode,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'deal_type',
												$elm$json$Json$Decode$nullable($author$project$Api$Provider$BrokerDeal$DealType$decoder),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'type',
													$author$project$Api$Provider$StatementLine$All$typeDecoder,
													$elm$json$Json$Decode$succeed($author$project$Api$Provider$StatementLine$All$Record))))))))))))));
var $author$project$Api$Provider$StatementLine$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$StatementLine$All$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$StatementLine$listDefaults = {xF: $elm$core$Maybe$Nothing, xG: $elm$core$Maybe$Nothing, afQ: $elm$core$Maybe$Nothing, HB: $elm$core$Maybe$Nothing, ajJ: $author$project$Api$Pagination$init, ajV: $elm$core$Maybe$Nothing, akl: $elm$core$Maybe$Nothing, alA: $author$project$Api$Sort$init, JV: $elm$core$Maybe$Nothing, JW: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$StatementLine$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$StatementLine$listDefaults);
	return A2(
		$elm$core$List$append,
		$author$project$Api$Pagination$toApiParams(options.ajJ),
		A2(
			$elm$core$List$append,
			$author$project$Api$Sort$toParams(options.alA),
			$elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						var _v0 = options.JV;
						if (!_v0.$) {
							var start_ = _v0.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'start', start_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v1 = options.HB;
						if (!_v1.$) {
							var end_ = _v1.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'end', end_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v2 = options.akl;
						if (!_v2.$) {
							var string = _v2.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'q', string)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v3 = options.xG;
						if (!_v3.$) {
							var string = _v3.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'broker_account', string)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v4 = options.JW;
						if (!_v4.$) {
							var string = _v4.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'statement', string)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v5 = options.xF;
						if (!_v5.$) {
							var string = _v5.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'broker', string)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v6 = options.afQ;
						if (!_v6.$) {
							var string = _v6.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'company', string)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v7 = options.ajV;
						if (!_v7.$) {
							var bool = _v7.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$bool, 'payable', bool)
								]);
						} else {
							return _List_Nil;
						}
					}()
					]))));
};
var $author$project$Api$Provider$StatementLine$listPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['statement_lines']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$StatementLine$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$StatementLine$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$StatementLine$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$StatementLine$listPath)));
	});
var $author$project$Components$Commissions$StatementLines$fetchStatementLines = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Api$Provider$StatementLine$list,
			apiClient,
			$author$project$Components$Commissions$StatementLines$fetchStatementLinesParams(model),
			$author$project$Components$Commissions$StatementLines$GotStatementLines);
	});
var $author$project$Components$Commissions$StatementLines$GotSummary = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Commissions$StatementLines$fetchSummaryParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				xF: model.GN,
				xG: model.cm,
				afQ: model.fZ,
				HB: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.HB),
				ajV: model.ajV,
				akl: model.akl,
				JV: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.JV),
				JW: model.alG
			});
	};
};
var $author$project$Api$Provider$Reports$Summary$Summary = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$Summary$SummaryRecord = F3(
	function (type_, values, rows) {
		return {aac: rows, amg: type_, q_: values};
	});
var $author$project$Api$Provider$Reports$Summary$Row = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$Summary$RowRecord = F4(
	function (type_, name, params, values) {
		return {Bq: name, YL: params, amg: type_, q_: values};
	});
var $author$project$Api$Provider$Reports$Summary$SummaryValuesRecord = F5(
	function (amountInCents, hintFeeInCents, stripeFeeInCents, totalFeeInCents, count) {
		return {LE: amountInCents, OK: count, Ty: hintFeeInCents, aco: stripeFeeInCents, adn: totalFeeInCents};
	});
var $author$project$Api$Provider$Reports$Summary$summaryValuesDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'count',
	$elm$json$Json$Decode$int,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'total_fee_in_cents',
		$elm$json$Json$Decode$int,
		0,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'stripe_fee_in_cents',
			$elm$json$Json$Decode$int,
			0,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'hint_fee_in_cents',
				$elm$json$Json$Decode$int,
				0,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'amount_in_cents',
					$elm$json$Json$Decode$int,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$Summary$SummaryValuesRecord))))));
var $author$project$Api$Provider$Reports$Summary$summaryRowRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'values',
	$author$project$Api$Provider$Reports$Summary$summaryValuesDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'params',
		$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'type',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$Summary$RowRecord)))));
var $author$project$Api$Provider$Reports$Summary$summaryRowDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Reports$Summary$summaryRowRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$Summary$summaryRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'rows',
	$elm$json$Json$Decode$list($author$project$Api$Provider$Reports$Summary$summaryRowDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'values',
		$author$project$Api$Provider$Reports$Summary$summaryValuesDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'type',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$Summary$SummaryRecord))));
var $author$project$Api$Provider$Reports$Summary$summaryDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Reports$Summary$summaryRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$Summary$summaryPath = function (listPath) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['summary']),
		listPath);
};
var $author$project$Api$Provider$Reports$Summary$retrieve = F5(
	function (apiClient, listPath, by, params, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Reports$Summary$summaryDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				params,
				A2(
					$author$project$Api$Data$requestWithQuery,
					_List_fromArray(
						[
							A2($author$project$Api$Param$string, 'by', by)
						]),
					$author$project$Api$Data$requestTo(
						$author$project$Api$Provider$Reports$Summary$summaryPath(listPath)))));
	});
var $author$project$Api$Provider$StatementLine$summary = F4(
	function (apiClient, by, optionals, toMsg) {
		return A5(
			$author$project$Api$Provider$Reports$Summary$retrieve,
			apiClient,
			$author$project$Api$Provider$StatementLine$listPath,
			by,
			$author$project$Api$Provider$StatementLine$listOptionsToParams(optionals),
			toMsg);
	});
var $author$project$Components$Commissions$StatementLines$fetchSummary = F2(
	function (apiClient, model) {
		return A4(
			$author$project$Api$Provider$StatementLine$summary,
			apiClient,
			A2($elm$core$Maybe$withDefault, '', model.co),
			$author$project$Components$Commissions$StatementLines$fetchSummaryParams(model),
			$author$project$Components$Commissions$StatementLines$GotSummary);
	});
var $author$project$Components$Commissions$StatementLines$fetchData = F2(
	function (apiClient, model) {
		var _v0 = model.amg;
		if (!_v0) {
			return A2($author$project$Components$Commissions$StatementLines$fetchStatementLines, apiClient, model);
		} else {
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Components$Commissions$StatementLines$fetchSummary, apiClient, model),
						A2($author$project$Components$Commissions$StatementLines$fetchStatementLines, apiClient, model)
					]));
		}
	});
var $author$project$Components$Commissions$StatementLines$initBrokerFilter = F3(
	function (apiClient, brokerAccountId, brokerId) {
		return A3(
			$author$project$Components$ResourceFilter$Broker$init,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{xG: brokerAccountId});
			},
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'All Brokers', akb: brokerId});
			});
	});
var $author$project$Components$ResourceFilter$Statement$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Components$ResourceFilter$Statement$list = $author$project$Api$Provider$Statement$list;
var $author$project$Components$ResourceFilter$Statement$fetchResources = F5(
	function (listOptionals, toMsg, apiClient, pagination, query) {
		return A3(
			$author$project$Components$ResourceFilter$Statement$list,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{ajJ: pagination, akl: query});
				}),
			toMsg);
	});
var $author$project$Components$ResourceFilter$Statement$retrieveResource = F4(
	function (listOptionals, toMsg, apiClient, id) {
		return A3(
			$author$project$Components$ResourceFilter$Statement$list,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{
							ahP: $elm$core$Maybe$Just(id)
						});
				}),
			toMsg);
	});
var $author$project$Components$ResourceFilter$Statement$selectId = 'statements';
var $author$project$Components$ResourceFilter$Statement$toTitle = function (resource) {
	return '#' + $elm$core$String$fromInt(
		$author$project$Api$Provider$Statement$All$number(resource));
};
var $author$project$Components$ResourceFilter$Statement$toLabel = function (resource) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Components$ResourceFilter$Statement$toTitle(resource))
		]);
};
var $author$project$Components$ResourceFilter$Statement$toValue = $author$project$Api$Provider$Statement$All$id;
var $author$project$Components$ResourceFilter$Statement$init = F3(
	function (apiClient, listOptionals, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{
				Sk: $author$project$Components$ResourceFilter$Statement$fetchResources(listOptionals),
				ahP: $author$project$Components$ResourceFilter$Statement$selectId,
				k$: 'Statements',
				uk: $author$project$Components$ResourceFilter$Statement$retrieveResource(listOptionals),
				u9: $author$project$Components$ResourceFilter$Statement$toLabel,
				lN: $author$project$Components$ResourceFilter$Statement$toTitle,
				hX: $author$project$Components$ResourceFilter$Statement$toValue
			},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{Jy: $author$project$Components$ResourceFilter$All, b8: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$Commissions$StatementLines$initStatementFilter = F3(
	function (apiClient, brokerAccountId, statementId) {
		return A3(
			$author$project$Components$ResourceFilter$Statement$init,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{xG: brokerAccountId});
			},
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'All Statements', akb: statementId});
			});
	});
var $author$project$Components$Commissions$StatementLines$PollStatus = {$: 15};
var $author$project$Components$Commissions$StatementLines$pollStatus = A2(
	$elm$core$Task$perform,
	function (_v0) {
		return $author$project$Components$Commissions$StatementLines$PollStatus;
	},
	$elm$core$Process$sleep(2000));
var $author$project$Components$Commissions$StatementLines$init = F5(
	function (type_, session, practice, _v0, query) {
		var currentDate = _v0.dd;
		var apiClient = _v0.Gv;
		var hinterViewOff = _v0.ahK;
		var statementId = A2($elm$core$Dict$get, 'statement', query);
		var q = A2($elm$core$Dict$get, 'q', query);
		var companyId = A2($elm$core$Dict$get, 'company', query);
		var brokerId = A2($elm$core$Dict$get, 'broker', query);
		var brokerAccountId = A2($elm$core$Dict$get, 'broker_account', query);
		var _v1 = function () {
			if (!type_) {
				return _Utils_Tuple2($author$project$Api$Data$Loading, $author$project$Api$Data$NotAsked);
			} else {
				return _Utils_Tuple2($author$project$Api$Data$NotAsked, $author$project$Api$Data$Loading);
			}
		}();
		var statementLines = _v1.a;
		var summary = _v1.b;
		var _v3 = A3($author$project$Components$Commissions$StatementLines$initStatementFilter, apiClient, brokerAccountId, statementId);
		var statementResourceFilter = _v3.a;
		var statementResourceFilterCmd = _v3.b;
		var _v4 = $author$project$Utils$DateWithDefault$fromQuery(query);
		var start = _v4.a;
		var end = _v4.b;
		var _v5 = A2(
			$author$project$Components$DateRangeInput$init,
			'date-range-input',
			A2(
				$author$project$Components$Commissions$StatementLines$dateRangeInputSettings,
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					start),
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					end)));
		var dateRangeInput = _v5.a;
		var dateRangeInputCmd = _v5.b;
		var _v6 = A4(
			$author$project$Utils$Report$CompanyResourceFilter$init,
			apiClient,
			$elm$core$Basics$identity,
			$author$project$Api$Practice$Provider(practice),
			companyId);
		var companyResourceFilter = _v6.a;
		var companyResourceFilterCmd = _v6.b;
		var _v7 = A3($author$project$Components$Commissions$StatementLines$initBrokerFilter, apiClient, brokerAccountId, brokerId);
		var brokerResourceFilter = _v7.a;
		var brokerResourceFilterCmd = _v7.b;
		var _v8 = A3(
			$author$project$Components$ResourceFilter$BrokerAccount$init,
			apiClient,
			$elm$core$Basics$identity,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'All Broker Accounts', akb: brokerAccountId});
			});
		var brokerAccountResourceFilter = _v8.a;
		var brokerAccountResourceFilterCmd = _v8.b;
		var model = {
			cm: brokerAccountId,
			mw: brokerAccountResourceFilter,
			GN: brokerId,
			mx: brokerResourceFilter,
			co: A2($elm$core$Dict$get, 'by', query),
			mB: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'by-dropdown-filter', al6: $author$project$Components$Commissions$StatementLines$ByDropdownMsg})),
			GQ: A3($author$project$Permission$canGoTo, session, hinterViewOff, 50),
			fZ: companyId,
			mZ: companyResourceFilter,
			dd: currentDate,
			i4: dateRangeInput,
			HB: end,
			nD: $author$project$Components$ExportCsv$initForPractice(2),
			sT: false,
			ajJ: $author$project$Api$Pagination$initFromQuery(query),
			ajV: A2(
				$elm$core$Maybe$andThen,
				$author$project$Utils$Bool$fromString,
				A2($elm$core$Dict$get, 'payable', query)),
			o_: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'payable-dropdown-filter', al6: $author$project$Components$Commissions$StatementLines$PayableDropdownMsg})),
			akl: q,
			up: $author$project$Ui$SearchInput$init(q),
			alA: A3(
				$author$project$Api$Sort$withDefault,
				'date',
				0,
				A2($author$project$Api$Sort$fromQuery, query, $author$project$Api$Sort$init)),
			JV: start,
			alG: statementId,
			s: statementLines,
			hM: statementResourceFilter,
			acF: summary,
			amg: type_
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$StatementLines$DateRangeInputMsg, dateRangeInputCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$StatementLines$BrokerAccountResourceFilterMsg, brokerAccountResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$StatementLines$StatementResourceFilterMsg, statementResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$StatementLines$BrokerResourceFilterMsg, brokerResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$StatementLines$CompanyResourceFilterMsg, companyResourceFilterCmd),
						A2($author$project$Components$Commissions$StatementLines$fetchData, apiClient, model),
						A2($elm$core$Basics$composeR, $author$project$Components$Commissions$StatementLines$buildUrl, $author$project$Ports$Navigation$replaceUrl)(model),
						$author$project$Components$Commissions$StatementLines$pollStatus
					])));
	});
var $author$project$Pages$Commissions$StatementLines$Summary$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.DE;
		var _v1 = A5($author$project$Components$Commissions$StatementLines$init, 1, session, practice, shared, query);
		var report = _v1.a;
		var reportCmd = _v1.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, kV: report},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportCmd));
	});
var $author$project$Pages$Commissions$StatementLines$Summary$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Commissions$StatementLines$Summary$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Commissions$StatementLines$ExportCsvMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$ResourceFilter$Statement$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.b8));
};
var $author$project$Components$Commissions$StatementLines$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Commissions$StatementLines$DateRangeInputMsg,
				$author$project$Components$DateRangeInput$subscriptions(model.i4)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Commissions$StatementLines$ExportCsvMsg,
				$author$project$Components$ExportCsv$subscriptions(model.nD)),
				$author$project$Ui$Dropdown$subscriptions(model.o_),
				$author$project$Ui$Dropdown$subscriptions(model.mB),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Commissions$StatementLines$StatementResourceFilterMsg,
				$author$project$Components$ResourceFilter$Statement$subscriptions(model.hM)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Commissions$StatementLines$BrokerResourceFilterMsg,
				$author$project$Components$ResourceFilter$Broker$subscriptions(model.mx)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Commissions$StatementLines$BrokerAccountResourceFilterMsg,
				$author$project$Components$ResourceFilter$BrokerAccount$subscriptions(model.mw)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Commissions$StatementLines$CompanyResourceFilterMsg,
				$author$project$Components$ResourceFilter$Company$subscriptions(model.mZ))
			]));
};
var $author$project$Pages$Commissions$StatementLines$Summary$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Commissions$StatementLines$subscriptions(model.kV));
};
var $author$project$Api$Provider$StatementLine$Done = 1;
var $author$project$Components$Commissions$StatementLines$GotStatus = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Commissions$StatementLines$SearchInputMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$StatementLine$Running = 0;
var $author$project$Api$Provider$StatementLine$StatusRecord = function (status) {
	return {alH: status};
};
var $author$project$Api$Provider$StatementLine$statusDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (record) {
		var _v0 = record.alH;
		switch (_v0) {
			case 'running':
				return $elm$json$Json$Decode$succeed(0);
			case 'done':
				return $elm$json$Json$Decode$succeed(1);
			default:
				var somethingElse = _v0;
				return $elm$json$Json$Decode$fail('Unsupported StatementLine -> Status: ' + somethingElse);
		}
	},
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'status',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$StatementLine$StatusRecord)));
var $author$project$Api$Provider$StatementLine$statusPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['status']),
	$author$project$Api$Provider$StatementLine$listPath);
var $author$project$Api$Provider$StatementLine$status = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$StatementLine$statusDecoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$StatementLine$statusPath));
	});
var $author$project$Components$ResourceFilter$Statement$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.b8);
		var modelAfterEvent = function () {
			var _v1 = result.agZ;
			if (!_v1.$) {
				var selected = _v1.a;
				return _Utils_update(
					model,
					{Jy: selected});
			} else {
				return model;
			}
		}();
		return {
			GZ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.GZ),
			agZ: result.agZ,
			aiO: _Utils_update(
				modelAfterEvent,
				{b8: result.aiO}),
			aR: result.aR
		};
	});
var $author$project$Components$ResourceFilter$Statement$value = function (model) {
	return A2($author$project$Components$ResourceFilter$choiceToValue, model.b8, model.Jy);
};
var $author$project$Components$Commissions$StatementLines$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 1:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Ui$SearchInput$update, subMsg, model.up);
				var searchInput = _v1.a;
				var searchInputCmd = _v1.b;
				var searchInputEvent = _v1.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.akl;
					}
				}();
				var _v2 = function () {
					if (_Utils_eq(q, model.akl)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								ajJ: $author$project$Api$Pagination$reset(model.ajJ),
								akl: q,
								s: $author$project$Api$Data$Loading
							});
						return _Utils_Tuple2(
							qModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($author$project$Components$Commissions$StatementLines$fetchData, apiClient, qModel),
										A2($elm$core$Basics$composeR, $author$project$Components$Commissions$StatementLines$buildUrl, $author$project$Ports$Navigation$pushUrl)(qModel)
									])));
					}
				}();
				var newModel = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{up: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$StatementLines$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
			case 2:
				var subMsg = msg.a;
				var brokerAccountResourceResult = A3($author$project$Components$ResourceFilter$BrokerAccount$update, apiClient, subMsg, model.mw);
				var brokerAccountId = function () {
					var _v9 = brokerAccountResourceResult.agZ;
					if (!_v9.$) {
						return $author$project$Components$ResourceFilter$BrokerAccount$value(brokerAccountResourceResult.aiO);
					} else {
						return model.cm;
					}
				}();
				var _v4 = function () {
					var _v5 = brokerAccountResourceResult.agZ;
					if (!_v5.$) {
						return A2(
							$author$project$Utils$Tuple3$fromTuple2,
							$elm$core$Maybe$Nothing,
							A3($author$project$Components$Commissions$StatementLines$initStatementFilter, apiClient, brokerAccountId, $elm$core$Maybe$Nothing));
					} else {
						return _Utils_Tuple3(model.hM, $elm$core$Platform$Cmd$none, model.alG);
					}
				}();
				var statementResourceFilter = _v4.a;
				var statementResourceFilterCmd = _v4.b;
				var statementId = _v4.c;
				var _v6 = function () {
					var _v7 = brokerAccountResourceResult.agZ;
					if (!_v7.$) {
						return A2(
							$author$project$Utils$Tuple3$fromTuple2,
							$elm$core$Maybe$Nothing,
							A3($author$project$Components$Commissions$StatementLines$initBrokerFilter, apiClient, brokerAccountId, $elm$core$Maybe$Nothing));
					} else {
						return _Utils_Tuple3(model.mx, $elm$core$Platform$Cmd$none, model.GN);
					}
				}();
				var brokerResourceFilter = _v6.a;
				var brokerResourceFilterCmd = _v6.b;
				var brokerId = _v6.c;
				var newModel = _Utils_update(
					model,
					{cm: brokerAccountId, mw: brokerAccountResourceResult.aiO, GN: brokerId, mx: brokerResourceFilter, alG: statementId, hM: statementResourceFilter});
				var _v8 = (_Utils_eq(model.cm, newModel.cm) && (_Utils_eq(model.alG, newModel.alG) && _Utils_eq(model.GN, newModel.GN))) ? _Utils_Tuple2(model.s, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					$author$project$Api$Data$Loading,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Commissions$StatementLines$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Commissions$StatementLines$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])));
				var statementLines = _v8.a;
				var cmd = _v8.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{s: statementLines}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$StatementLines$BrokerAccountResourceFilterMsg, brokerAccountResourceResult.GZ),
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$StatementLines$StatementResourceFilterMsg, statementResourceFilterCmd),
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$StatementLines$BrokerResourceFilterMsg, brokerResourceFilterCmd),
								cmd
							])),
					brokerAccountResourceResult.aR);
			case 3:
				var subMsg = msg.a;
				var statementResourceResult = A3($author$project$Components$ResourceFilter$Statement$update, apiClient, subMsg, model.hM);
				var statementId = function () {
					var _v11 = statementResourceResult.agZ;
					if (!_v11.$) {
						return $author$project$Components$ResourceFilter$Statement$value(statementResourceResult.aiO);
					} else {
						return model.alG;
					}
				}();
				var newModel = _Utils_update(
					model,
					{alG: statementId, hM: statementResourceResult.aiO});
				var _v10 = _Utils_eq(model.alG, newModel.alG) ? _Utils_Tuple2(model.s, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					$author$project$Api$Data$Loading,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Commissions$StatementLines$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Commissions$StatementLines$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])));
				var statementLines = _v10.a;
				var cmd = _v10.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{s: statementLines}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$StatementLines$StatementResourceFilterMsg, statementResourceResult.GZ),
								cmd
							])),
					statementResourceResult.aR);
			case 4:
				var subMsg = msg.a;
				var brokerResourceResult = A3($author$project$Components$ResourceFilter$Broker$update, apiClient, subMsg, model.mx);
				var brokerId = function () {
					var _v13 = brokerResourceResult.agZ;
					if (!_v13.$) {
						return $author$project$Components$ResourceFilter$Broker$value(brokerResourceResult.aiO);
					} else {
						return model.GN;
					}
				}();
				var newModel = _Utils_update(
					model,
					{GN: brokerId, mx: brokerResourceResult.aiO});
				var _v12 = _Utils_eq(model.GN, newModel.GN) ? _Utils_Tuple2(model.s, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					$author$project$Api$Data$Loading,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Commissions$StatementLines$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Commissions$StatementLines$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])));
				var statementLines = _v12.a;
				var cmd = _v12.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{s: statementLines}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$StatementLines$BrokerResourceFilterMsg, brokerResourceResult.GZ),
								cmd
							])),
					brokerResourceResult.aR);
			case 5:
				var subMsg = msg.a;
				var companyResourceResult = A3($author$project$Components$ResourceFilter$Company$update, apiClient, subMsg, model.mZ);
				var companyId = function () {
					var _v15 = companyResourceResult.agZ;
					if (!_v15.$) {
						return $author$project$Components$ResourceFilter$Company$value(companyResourceResult.aiO);
					} else {
						return model.fZ;
					}
				}();
				var newModel = _Utils_update(
					model,
					{fZ: companyId, mZ: companyResourceResult.aiO});
				var _v14 = _Utils_eq(model.fZ, newModel.fZ) ? _Utils_Tuple2(model.s, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					$author$project$Api$Data$Loading,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Commissions$StatementLines$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Commissions$StatementLines$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])));
				var statementLines = _v14.a;
				var cmd = _v14.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{s: statementLines}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$StatementLines$CompanyResourceFilterMsg, companyResourceResult.GZ),
								cmd
							])),
					companyResourceResult.aR);
			case 6:
				var subMsg = msg.a;
				var _v16 = A2($author$project$Ui$Dropdown$update, subMsg, model.o_);
				var payableDropdown = _v16.a;
				var cmd = _v16.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{o_: payableDropdown}),
					cmd,
					_List_Nil);
			case 7:
				var subMsg = msg.a;
				var _v17 = A2($author$project$Ui$Dropdown$update, subMsg, model.mB);
				var byDropdown = _v17.a;
				var cmd = _v17.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{mB: byDropdown}),
					cmd,
					_List_Nil);
			case 8:
				var payable = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ajJ: $author$project$Api$Pagination$reset(model.ajJ),
						ajV: payable,
						s: $author$project$Api$Data$Loading
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Commissions$StatementLines$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Commissions$StatementLines$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 9:
				var by = msg.a;
				var newModel = _Utils_update(
					model,
					{
						co: by,
						ajJ: $author$project$Api$Pagination$reset(model.ajJ),
						s: $author$project$Api$Data$Loading
					});
				var cmds = function () {
					var _v18 = _Utils_Tuple2(model.amg, newModel.co);
					if (!_v18.a) {
						if (!_v18.b.$) {
							var _v19 = _v18.a;
							return _List_fromArray(
								[
									A2($elm$core$Basics$composeR, $author$project$Components$Commissions$StatementLines$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
								]);
						} else {
							var _v20 = _v18.a;
							var _v21 = _v18.b;
							return _List_fromArray(
								[$elm$core$Platform$Cmd$none]);
						}
					} else {
						if (_v18.b.$ === 1) {
							var _v22 = _v18.a;
							var _v23 = _v18.b;
							return _List_fromArray(
								[
									A2($elm$core$Basics$composeR, $author$project$Components$Commissions$StatementLines$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
								]);
						} else {
							var _v24 = _v18.a;
							return _List_fromArray(
								[
									A2($author$project$Components$Commissions$StatementLines$fetchData, apiClient, newModel),
									A2($elm$core$Basics$composeR, $author$project$Components$Commissions$StatementLines$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
								]);
						}
					}
				}();
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(cmds),
					_List_Nil);
			case 0:
				var subMsg = msg.a;
				var _v25 = A2($author$project$Components$DateRangeInput$update, subMsg, model.i4);
				var dateRangeInput = _v25.a;
				var subCmd = _v25.b;
				var event = _v25.c;
				var newModel = function () {
					if (event.$ === 1) {
						var fromDate = event.a;
						var toDate = event.b;
						return _Utils_update(
							model,
							{
								i4: dateRangeInput,
								HB: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
								ajJ: $author$project$Api$Pagination$reset(model.ajJ),
								JV: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate),
								s: $author$project$Api$Data$Loading
							});
					} else {
						return _Utils_update(
							model,
							{i4: dateRangeInput});
					}
				}();
				var cmds = (_Utils_eq(newModel.JV, model.JV) && _Utils_eq(newModel.HB, model.HB)) ? _List_Nil : _List_fromArray(
					[
						A2($author$project$Components$Commissions$StatementLines$fetchData, apiClient, newModel),
						A2($elm$core$Basics$composeR, $author$project$Components$Commissions$StatementLines$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
					]);
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$cons,
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$StatementLines$DateRangeInputMsg, subCmd),
							cmds)),
					_List_Nil);
			case 10:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ),
								s: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{s: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 11:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{acF: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 12:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{ajJ: pagination, s: $author$project$Api$Data$Loading});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Commissions$StatementLines$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Commissions$StatementLines$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 13:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						alA: A2($author$project$Api$Sort$update, columnId, model.alA),
						s: $author$project$Api$Data$Loading
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Commissions$StatementLines$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Commissions$StatementLines$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 14:
				var subMsg = msg.a;
				var _v28 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.nD);
				var exportCsv = _v28.a;
				var subCmd = _v28.b;
				var subOutMsg = _v28.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nD: exportCsv}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$StatementLines$ExportCsvMsg, subCmd),
					subOutMsg);
			case 15:
				return _Utils_Tuple3(
					model,
					A2($author$project$Api$Provider$StatementLine$status, apiClient, $author$project$Components$Commissions$StatementLines$GotStatus),
					_List_Nil);
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var status = response.a;
					var isRunnningBackgroundJobs = status !== 1;
					var _v30 = (model.sT && (!isRunnningBackgroundJobs)) ? _Utils_Tuple2(
						$author$project$Api$Data$Loading,
						A2($author$project$Components$Commissions$StatementLines$fetchData, apiClient, model)) : _Utils_Tuple2(model.s, $elm$core$Platform$Cmd$none);
					var statementLines = _v30.a;
					var cmd = _v30.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{sT: isRunnningBackgroundJobs, s: statementLines}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[$author$project$Components$Commissions$StatementLines$pollStatus, cmd])),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$author$project$Components$Commissions$StatementLines$pollStatus,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Commissions$StatementLines$Summary$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Commissions$StatementLines$update, model.Gv, subMsg, model.kV);
		var report = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{kV: report}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Components$Commissions$StatementLines$PaginationMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Commissions$StatementLines$amountFromHeader = F2(
	function (headers, name) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$String$toInt,
				A2($elm$core$Dict$get, name, headers)));
	});
var $author$project$Components$Commissions$StatementLines$viewBrokerAccountResourceFilter = function (brokerAccountResourceFilter) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Commissions$StatementLines$BrokerAccountResourceFilterMsg,
		A2($author$project$Components$ResourceFilter$BrokerAccount$view, _List_Nil, brokerAccountResourceFilter));
};
var $author$project$Components$Commissions$StatementLines$viewBrokerResourceFilter = function (brokerResourceFilter) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Commissions$StatementLines$BrokerResourceFilterMsg,
		A2($author$project$Components$ResourceFilter$Broker$view, _List_Nil, brokerResourceFilter));
};
var $author$project$Components$Commissions$StatementLines$ByOptionSelected = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Commissions$StatementLines$viewByDropdown = function (model) {
	var currentText = function () {
		var _v0 = model.co;
		_v0$2:
		while (true) {
			if (!_v0.$) {
				switch (_v0.a) {
					case 'broker_account':
						return 'Broker Account';
					case 'broker':
						return 'Broker';
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return 'Summarize by';
	}();
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(currentText)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Dropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$Dropdown$onSelect(
						$author$project$Components$Commissions$StatementLines$ByOptionSelected($elm$core$Maybe$Nothing)),
						$author$project$Ui$Dropdown$selected(
						_Utils_eq(model.co, $elm$core$Maybe$Nothing))
					]),
				$elm$html$Html$text('No Summary')),
				$author$project$Ui$Dropdown$separator,
				A2(
				$author$project$Ui$Dropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$Dropdown$onSelect(
						$author$project$Components$Commissions$StatementLines$ByOptionSelected(
							$elm$core$Maybe$Just('broker_account'))),
						$author$project$Ui$Dropdown$selected(
						_Utils_eq(
							model.co,
							$elm$core$Maybe$Just('broker_account')))
					]),
				$elm$html$Html$text('Broker Account')),
				A2(
				$author$project$Ui$Dropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$Dropdown$onSelect(
						$author$project$Components$Commissions$StatementLines$ByOptionSelected(
							$elm$core$Maybe$Just('broker'))),
						$author$project$Ui$Dropdown$selected(
						_Utils_eq(
							model.co,
							$elm$core$Maybe$Just('broker')))
					]),
				$elm$html$Html$text('Broker'))
			]),
		model.mB);
};
var $author$project$Components$Commissions$StatementLines$viewCompanyResourceFilter = function (companyResourceFilter) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Commissions$StatementLines$CompanyResourceFilterMsg,
		A2($author$project$Components$ResourceFilter$Company$view, _List_Nil, companyResourceFilter));
};
var $author$project$Components$Commissions$StatementLines$PayableOptionSelected = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Commissions$StatementLines$viewPayableDropdown = function (model) {
	var currentText = function () {
		var _v0 = model.ajV;
		if (!_v0.$) {
			if (_v0.a) {
				return 'Payable';
			} else {
				return 'Pending';
			}
		} else {
			return 'Status';
		}
	}();
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(currentText)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Dropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$Dropdown$onSelect(
						$author$project$Components$Commissions$StatementLines$PayableOptionSelected($elm$core$Maybe$Nothing)),
						$author$project$Ui$Dropdown$selected(
						_Utils_eq(model.ajV, $elm$core$Maybe$Nothing))
					]),
				$elm$html$Html$text('All')),
				$author$project$Ui$Dropdown$separator,
				A2(
				$author$project$Ui$Dropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$Dropdown$onSelect(
						$author$project$Components$Commissions$StatementLines$PayableOptionSelected(
							$elm$core$Maybe$Just(true))),
						$author$project$Ui$Dropdown$selected(
						_Utils_eq(
							model.ajV,
							$elm$core$Maybe$Just(true)))
					]),
				$elm$html$Html$text('Payable')),
				A2(
				$author$project$Ui$Dropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$Dropdown$onSelect(
						$author$project$Components$Commissions$StatementLines$PayableOptionSelected(
							$elm$core$Maybe$Just(false))),
						$author$project$Ui$Dropdown$selected(
						_Utils_eq(
							model.ajV,
							$elm$core$Maybe$Just(false)))
					]),
				$elm$html$Html$text('Pending'))
			]),
		model.o_);
};
var $author$project$Components$ResourceFilter$Statement$view = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$view,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.Jy),
					options),
				model.b8));
	});
var $author$project$Components$Commissions$StatementLines$viewStatementResourceFilter = function (statementResourceFilter) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Commissions$StatementLines$StatementResourceFilterMsg,
		A2($author$project$Components$ResourceFilter$Statement$view, _List_Nil, statementResourceFilter));
};
var $author$project$Api$Provider$Reports$Summary$summaryRows = function (_v0) {
	var record = _v0;
	return record.aac;
};
var $author$project$Api$Provider$Reports$Summary$summaryType = function (_v0) {
	var record = _v0;
	return record.amg;
};
var $author$project$Api$Provider$Reports$Summary$summaryRowAmountInCents = function (_v0) {
	var record = _v0;
	return record.q_.LE;
};
var $author$project$Api$Provider$Reports$Summary$summaryRowCount = function (_v0) {
	var record = _v0;
	return record.q_.OK;
};
var $author$project$Api$Provider$Reports$Summary$summaryRowName = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $elm$core$Dict$filter = F2(
	function (isGood, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, d) {
					return A2(isGood, k, v) ? A3($elm$core$Dict$insert, k, v, d) : d;
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $author$project$Api$Provider$Reports$Summary$summaryRowParams = function (_v0) {
	var record = _v0;
	return record.YL;
};
var $author$project$Api$Provider$Reports$Summary$summaryRowType = function (_v0) {
	var record = _v0;
	return record.amg;
};
var $author$project$Utils$Report$summaryRowTableParams = F2(
	function (urlParams, summaryRow) {
		return $author$project$Utils$QueryParameter$fromDict(
			A2(
				$elm$core$Dict$filter,
				F2(
					function (key, _v0) {
						return ($author$project$Api$Provider$Reports$Summary$summaryRowType(summaryRow) !== 'deposit') || ((key !== 'start') && (key !== 'end'));
					}),
				A2(
					$elm$core$Dict$remove,
					'by',
					A2(
						$elm$core$Dict$union,
						urlParams,
						$author$project$Api$Provider$Reports$Summary$summaryRowParams(summaryRow)))));
	});
var $author$project$Components$Commissions$StatementLines$viewSummaryRow = F2(
	function (model, summaryRow) {
		var routeParams = _List_fromArray(
			[
				$author$project$Ui$Link$routeParams(
				A2(
					$author$project$Utils$Report$summaryRowTableParams,
					$author$project$Components$Commissions$StatementLines$urlParams(model),
					summaryRow))
			]);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_fromArray(
								[
									$author$project$Ui$Typography$info,
									$author$project$Ui$Typography$phi(true)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Commissions__StatementLines__Top,
									routeParams,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'Unassigned',
												$author$project$Api$Provider$Reports$Summary$summaryRowName(summaryRow)))
										]))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Commissions__StatementLines__Top,
							routeParams,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$String$pluralize,
										'charge',
										$author$project$Api$Provider$Reports$Summary$summaryRowCount(summaryRow)))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$textRight]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Commissions__StatementLines__Top,
									routeParams,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Utils$Currency$fromInt(
												$author$project$Api$Provider$Reports$Summary$summaryRowAmountInCents(summaryRow)))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Commissions$StatementLines$viewSummaryTable = function (model) {
	var summaryType = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Api$Provider$Reports$Summary$summaryType, $author$project$Formatters$String$humanize),
			$author$project$Api$Data$toMaybe(model.acF)));
	var summaryRows = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$Reports$Summary$summaryRows,
			$author$project$Api$Data$toMaybe(model.acF)));
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$loading(
				!$author$project$Api$Data$isSuccess(model.acF)),
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mb4]),
						_List_fromArray(
							[
								$elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
							]))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(summaryType)
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Commission Lines')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4),
						$author$project$Ui$Table$textRight
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Amount')
					]))
			]),
		A2(
			$elm$core$List$map,
			$author$project$Components$Commissions$StatementLines$viewSummaryRow(model),
			summaryRows),
		_List_Nil);
};
var $author$project$Components$Commissions$StatementLines$SortTable = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Commissions$StatementLines$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'date', true, 'Date'),
		A3($author$project$Api$Column$init, 'statement', true, 'Statement'),
		A3($author$project$Api$Column$init, 'broker', false, 'Broker'),
		A3($author$project$Api$Column$init, 'reference', false, 'Reference'),
		A3($author$project$Api$Column$init, 'invoice', false, 'Invoice'),
		A3($author$project$Api$Column$init, 'payable', true, 'Status'),
		A3($author$project$Api$Column$init, 'commission', false, 'Commission')
	]);
var $author$project$Api$Provider$StatementLine$All$amountInCents = function (_v0) {
	var record = _v0;
	return record.LE;
};
var $author$project$Api$Provider$StatementLine$All$broker = function (_v0) {
	var record = _v0;
	return record.xF;
};
var $author$project$Api$Provider$StatementAdjustment$Min$category = function (_v0) {
	var record = _v0;
	return record.GW;
};
var $author$project$Api$Provider$StatementLine$All$charge = function (_v0) {
	var record = _v0;
	return record.afx;
};
var $author$project$Api$Provider$StatementLine$All$company = function (_v0) {
	var record = _v0;
	return record.afQ;
};
var $author$project$Api$Common$Payable$Invoice$Min$date = function (_v0) {
	var record = _v0;
	return record.PB;
};
var $author$project$Api$Common$Payable$Invoice$MinWithOwner$date = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Common$Payable$Invoice$Min$date(min);
};
var $author$project$Api$Provider$StatementLine$All$date = function (_v0) {
	var record = _v0;
	return record.PB;
};
var $author$project$Api$Provider$StatementLine$All$dealType = function (_v0) {
	var record = _v0;
	return record.PT;
};
var $author$project$Api$Provider$StatementLine$All$description = function (_v0) {
	var record = _v0;
	return record.Qr;
};
var $author$project$Api$Provider$Charge$SharedWithInvoice$invoice = function (_v0) {
	var record = _v0.b;
	return record.Uk;
};
var $author$project$Api$Provider$StatementAdjustment$Min$memo = function (_v0) {
	var record = _v0;
	return record.aiG;
};
var $author$project$Api$Provider$StatementLine$All$owner = function (_v0) {
	var record = _v0;
	return record.YD;
};
var $author$project$Api$Provider$StatementLine$All$patient = function (_v0) {
	var record = _v0;
	return record.YY;
};
var $author$project$Api$Provider$StatementLine$All$payable = function (_v0) {
	var record = _v0;
	return record.ajV;
};
var $author$project$Api$Provider$StatementLine$All$statementAdjustment = function (_v0) {
	var record = _v0;
	return record.acb;
};
var $author$project$Api$Provider$StatementLine$All$statementNumber = function (_v0) {
	var record = _v0;
	return record.acd;
};
var $author$project$Api$Provider$Charge$SharedWithInvoice$totalInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Charge$Shared$totalInCents(shared);
};
var $author$project$Api$Provider$StatementLine$All$type_ = function (_v0) {
	var record = _v0;
	return record.amg;
};
var $author$project$Components$Commissions$StatementLines$viewRow = F2(
	function (canGoToPatients, statementLine) {
		var patientName = function (patient_) {
			return A2(
				$author$project$Ui$Typography$text,
				_List_fromArray(
					[
						$author$project$Ui$Typography$phi(true)
					]),
				$author$project$Api$Provider$Patient$Min$name(patient_));
		};
		var patient = $author$project$Api$Provider$StatementLine$All$patient(statementLine);
		var broker = $author$project$Api$Provider$StatementLine$All$broker(statementLine);
		var brokerAccount = $author$project$Api$Provider$Broker$Shared$brokerAccount(broker);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$author$project$Formatters$Date$toString,
								$author$project$Formatters$Date$Full,
								$author$project$Api$Provider$StatementLine$All$date(statementLine)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = $author$project$Api$Provider$StatementLine$All$statementNumber(statementLine);
							if (!_v0.$) {
								var statementNumber = _v0.a;
								return A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textRight]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											'#' + $elm$core$String$fromInt(statementNumber))
										]));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__BrokerId_String__Top(
								{
									cm: $author$project$Api$Provider$BrokerAccount$Shared$id(brokerAccount),
									GN: $author$project$Api$Provider$Broker$Shared$id(broker)
								}),
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$Broker$Shared$name(broker))
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textMuted]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$BrokerAccount$Shared$name(brokerAccount))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					function () {
						var _v1 = $author$project$Api$Provider$StatementLine$All$type_(statementLine);
						if (!_v1) {
							var owner = $author$project$Api$Provider$StatementLine$All$owner(statementLine);
							return _List_fromArray(
								[
									function () {
									var _v2 = _Utils_Tuple2(patient, canGoToPatients);
									if (!_v2.a.$) {
										if (_v2.b) {
											var patient_ = _v2.a.a;
											return A3(
												$author$project$Ui$Link$route,
												$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
													{
														YZ: $author$project$Api$Provider$Patient$Min$id(patient_)
													}),
												_List_Nil,
												_List_fromArray(
													[
														patientName(patient_)
													]));
										} else {
											var patient_ = _v2.a.a;
											return patientName(patient_);
										}
									} else {
										var _v3 = _v2.a;
										return $elm$html$Html$text('N/A');
									}
								}(),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textMuted]),
									_List_fromArray(
										[
											_Utils_eq(
											A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Min$id, owner),
											A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Min$id, patient)) ? $elm$html$Html$text('Owns the membership') : $elm$html$Html$text(
											'Membership owner: ' + A2(
												$elm$core$Maybe$withDefault,
												'N/A',
												A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Min$name, owner)))
										]))
								]);
						} else {
							return _List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										A2(
											$elm$core$Maybe$map,
											A2($elm$core$Basics$composeR, $author$project$Api$Provider$StatementAdjustment$Min$category, $author$project$Formatters$String$titleize),
											$author$project$Api$Provider$StatementLine$All$statementAdjustment(statementLine)))),
									$elm$html$Html$text(' Adjustment'),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textMuted]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$author$project$Formatters$String$ellipsis,
												30,
												A2(
													$elm$core$Maybe$withDefault,
													'',
													A2(
														$elm$core$Maybe$andThen,
														$author$project$Api$Provider$StatementAdjustment$Min$memo,
														$author$project$Api$Provider$StatementLine$All$statementAdjustment(statementLine)))))
										]))
								]);
						}
					}()),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					function () {
						var _v4 = $author$project$Api$Provider$StatementLine$All$type_(statementLine);
						if (!_v4) {
							var invoiceRoute = function (invoice_) {
								return A2(
									$elm$core$Maybe$andThen,
									function (dealType) {
										if (!dealType) {
											return A2(
												$elm$core$Maybe$map,
												function (invoiceOwner) {
													return $author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String(
														{
															fZ: $author$project$Api$Common$Payable$Owner$Min$id(invoiceOwner),
															ahP: $author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice_)
														});
												},
												$author$project$Api$Common$Payable$Invoice$MinWithOwner$owner(invoice_));
										} else {
											var _v11 = _Utils_Tuple2(patient, canGoToPatients);
											if ((!_v11.a.$) && _v11.b) {
												var patient_ = _v11.a.a;
												return $elm$core$Maybe$Just(
													$author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top(
														{
															Us: $author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice_),
															YZ: $author$project$Api$Provider$Patient$Min$id(patient_)
														}));
											} else {
												return $elm$core$Maybe$Nothing;
											}
										}
									},
									$author$project$Api$Provider$StatementLine$All$dealType(statementLine));
							};
							var invoice = A2(
								$elm$core$Maybe$andThen,
								$author$project$Api$Provider$Charge$SharedWithInvoice$invoice,
								$author$project$Api$Provider$StatementLine$All$charge(statementLine));
							return _List_fromArray(
								[
									function () {
									if (!invoice.$) {
										var invoice_ = invoice.a;
										var _v6 = invoiceRoute(invoice_);
										if (!_v6.$) {
											var invoiceRoute_ = _v6.a;
											return A3(
												$author$project$Ui$Link$route,
												invoiceRoute_,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														'#' + $elm$core$String$fromInt(
															$author$project$Api$Common$Payable$Invoice$MinWithOwner$invoiceNumber(invoice_)))
													]));
										} else {
											return $elm$html$Html$text(
												'#' + $elm$core$String$fromInt(
													$author$project$Api$Common$Payable$Invoice$MinWithOwner$invoiceNumber(invoice_)));
										}
									} else {
										return $elm$html$Html$text('N/A');
									}
								}(),
									$elm$html$Html$text(' on '),
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										A2(
											$elm$core$Maybe$map,
											A2(
												$elm$core$Basics$composeR,
												$author$project$Api$Common$Payable$Invoice$MinWithOwner$date,
												$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full)),
											invoice))),
									$elm$html$Html$text(' for '),
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										A2(
											$elm$core$Maybe$map,
											A2($elm$core$Basics$composeR, $author$project$Api$Provider$Charge$SharedWithInvoice$totalInCents, $author$project$Utils$Currency$fromInt),
											$author$project$Api$Provider$StatementLine$All$charge(statementLine)))),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textMuted]),
									_List_fromArray(
										[
											function () {
											var _v7 = $author$project$Api$Provider$StatementLine$All$dealType(statementLine);
											if (_v7.$ === 1) {
												return $elm$html$Html$text('N/A');
											} else {
												if (!_v7.a) {
													var _v8 = _v7.a;
													return $elm$html$Html$text(
														'For Employer: ' + A2(
															$elm$core$Maybe$withDefault,
															'N/A',
															A2(
																$elm$core$Maybe$map,
																$author$project$Api$Provider$Company$Min$name,
																$author$project$Api$Provider$StatementLine$All$company(statementLine))));
												} else {
													var _v9 = _v7.a;
													return $elm$html$Html$text('Retail Deal');
												}
											}
										}()
										]))
								]);
						} else {
							return _List_Nil;
						}
					}()),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Badge$fromString,
							_List_Nil,
							$author$project$Api$Provider$StatementLine$All$payable(statementLine) ? 'payable' : 'pending')
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[
							$author$project$Ui$Table$colspan(2)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$Currency$fromInt(
								$author$project$Api$Provider$StatementLine$All$amountInCents(statementLine))),
							$author$project$Utils$Html$noBreakSpace,
							(!$author$project$Api$Provider$StatementLine$All$type_(statementLine)) ? A3(
							$author$project$Ui$Tooltip$view,
							_List_fromArray(
								[
									$author$project$Ui$Tooltip$placement(2)
								]),
							A2(
								$elm$core$Maybe$withDefault,
								'',
								$author$project$Api$Provider$StatementLine$All$description(statementLine)),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$small]),
									_List_fromArray(
										[
											$author$project$Ui$Icon$help(_List_Nil)
										]))
								])) : $author$project$Utils$Html$empty
						]))
				]));
	});
var $author$project$Components$Commissions$StatementLines$viewTable = function (model) {
	var _v0 = function () {
		var _v1 = model.s;
		if (_v1.$ === 3) {
			var statementLines_ = _v1.a;
			return _Utils_Tuple2(false, statementLines_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var statementLines = _v0.b;
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$map,
					$author$project$Api$Column$view(
						A2($author$project$Api$Column$Sortable, model.alA, $author$project$Components$Commissions$StatementLines$SortTable)),
					$author$project$Components$Commissions$StatementLines$columns),
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$justifyRight]),
								_List_fromArray(
									[
										A2($elm$html$Html$map, $author$project$Components$Commissions$StatementLines$ExportCsvMsg, $author$project$Components$ExportCsv$button)
									]))
							]))
					])
				])),
		A2(
			$elm$core$List$map,
			$author$project$Components$Commissions$StatementLines$viewRow(model.GQ),
			statementLines),
		_List_Nil);
};
var $author$project$Components$Commissions$StatementLines$view = F2(
	function (apiClient, model) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Commissions$StatementLines$ExportCsvMsg,
				A3(
					$author$project$Components$ExportCsv$modal,
					apiClient,
					_List_fromArray(
						[
							$author$project$Components$ExportCsv$path($author$project$Api$Provider$StatementLine$listPath),
							$author$project$Components$ExportCsv$params(
							A2($elm$core$Basics$composeL, $author$project$Api$Provider$StatementLine$listOptionsToParams, $author$project$Components$Commissions$StatementLines$fetchStatementLinesParams)(model))
						]),
					model.nD)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								function () {
									var _v0 = model.s;
									if (_v0.$ === 3) {
										var headers = _v0.b;
										return _List_fromArray(
											[
												$elm$html$Html$text(
												'Total: ' + $author$project$Utils$Currency$fromInt(
													A2($author$project$Components$Commissions$StatementLines$amountFromHeader, headers, 'x-total-amount')))
											]);
									} else {
										return _List_fromArray(
											[
												$author$project$Ui$Skeleton$text(
												_List_fromArray(
													[
														$author$project$Ui$Skeleton$spanFromText('Total: $1000.00')
													]))
											]);
									}
								}()),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpBlock]),
								_List_fromArray(
									[
										$elm$html$Html$text('Total amount of statement lines generated for brokers')
									])),
								A2(
								$author$project$Ui$Grid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$spanSm(12)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Components$Commissions$StatementLines$DateRangeInputMsg,
												$author$project$Components$DateRangeInput$view(model.i4))
											]))
									])),
								A2(
								$author$project$Ui$Grid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(12)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Components$Commissions$StatementLines$SearchInputMsg,
												A2(
													$author$project$Ui$SearchInput$view,
													_List_fromArray(
														[
															$author$project$Ui$SearchInput$placeholder('Search for patient or membership owner name')
														]),
													model.up))
											]))
									])),
								A2(
								$author$project$Ui$Grid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(6),
												$author$project$Ui$Grid$spanMd(4)
											]),
										_List_fromArray(
											[
												$author$project$Components$Commissions$StatementLines$viewBrokerAccountResourceFilter(model.mw)
											])),
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(6),
												$author$project$Ui$Grid$spanMd(4)
											]),
										_List_fromArray(
											[
												$author$project$Components$Commissions$StatementLines$viewStatementResourceFilter(model.hM)
											])),
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(6),
												$author$project$Ui$Grid$spanMd(4)
											]),
										_List_fromArray(
											[
												$author$project$Components$Commissions$StatementLines$viewBrokerResourceFilter(model.mx)
											])),
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(6),
												$author$project$Ui$Grid$spanMd(4)
											]),
										_List_fromArray(
											[
												$author$project$Components$Commissions$StatementLines$viewCompanyResourceFilter(model.mZ)
											])),
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(6),
												$author$project$Ui$Grid$spanMd(4)
											]),
										_List_fromArray(
											[
												$author$project$Components$Commissions$StatementLines$viewPayableDropdown(model)
											])),
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(6),
												$author$project$Ui$Grid$spanMd(4)
											]),
										_List_fromArray(
											[
												$author$project$Components$Commissions$StatementLines$viewByDropdown(model)
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								model.sT ? A2(
								$author$project$Ui$Alert$warning,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('We are updating this report with recent invoice changes. The page will reload when the update completes.')
									])) : $author$project$Utils$Html$empty
							])),
						function () {
						var _v1 = model.amg;
						if (!_v1) {
							return $author$project$Components$Commissions$StatementLines$viewTable(model);
						} else {
							return $author$project$Components$Commissions$StatementLines$viewSummaryTable(model);
						}
					}(),
						function () {
						var _v2 = model.amg;
						if (!_v2) {
							return A2(
								$author$project$Ui$Panel$footer,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Components$Commissions$StatementLines$PaginationMsg,
										A2(
											$author$project$Api$Pagination$view,
											_List_fromArray(
												[
													$author$project$Ui$Pagination$List$loading(
													!$author$project$Utils$Maybe$toBool(
														$author$project$Api$Data$toMaybe(model.s)))
												]),
											model.ajJ))
									]));
						} else {
							return $author$project$Ui$Panel$none;
						}
					}()
					]))
			]);
	});
var $author$project$Pages$Commissions$StatementLines$Summary$view = function (model) {
	return {
		fO: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			A2($author$project$Components$Commissions$StatementLines$view, model.Gv, model.kV)),
		ac9: 'Commissions | Statements'
	};
};
var $author$project$Pages$Commissions$StatementLines$Summary$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Commissions$StatementLines$Summary$init, aiq: $author$project$Pages$Commissions$StatementLines$Summary$load, k8: $author$project$Pages$Commissions$StatementLines$Summary$save, alO: $author$project$Pages$Commissions$StatementLines$Summary$subscriptions, adT: $author$project$Pages$Commissions$StatementLines$Summary$update, amo: $author$project$Pages$Commissions$StatementLines$Summary$view});
var $author$project$Pages$Commissions$StatementLines$Top$ReportMsg = $elm$core$Basics$identity;
var $author$project$Components$Commissions$StatementLines$Table = 0;
var $author$project$Pages$Commissions$StatementLines$Top$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.DE;
		var _v1 = A5($author$project$Components$Commissions$StatementLines$init, 0, session, practice, shared, query);
		var report = _v1.a;
		var reportTaxCmd = _v1.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, kV: report},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportTaxCmd));
	});
var $author$project$Pages$Commissions$StatementLines$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Commissions$StatementLines$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Commissions$StatementLines$Top$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Commissions$StatementLines$subscriptions(model.kV));
};
var $author$project$Pages$Commissions$StatementLines$Top$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Commissions$StatementLines$update, model.Gv, subMsg, model.kV);
		var report = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{kV: report}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Pages$Commissions$StatementLines$Top$view = function (model) {
	return {
		fO: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			A2($author$project$Components$Commissions$StatementLines$view, model.Gv, model.kV)),
		ac9: 'Commissions | Statements'
	};
};
var $author$project$Pages$Commissions$StatementLines$Top$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Commissions$StatementLines$Top$init, aiq: $author$project$Pages$Commissions$StatementLines$Top$load, k8: $author$project$Pages$Commissions$StatementLines$Top$save, alO: $author$project$Pages$Commissions$StatementLines$Top$subscriptions, adT: $author$project$Pages$Commissions$StatementLines$Top$update, amo: $author$project$Pages$Commissions$StatementLines$Top$view});
var $author$project$Pages$Commissions$Statements$StatementsTableMsg = $elm$core$Basics$identity;
var $author$project$Pages$Commissions$Statements$init = F4(
	function (_v0, _v1, shared, _v2) {
		var query = _v2.DE;
		var _v3 = $author$project$Components$Commissions$Statement$List$init(
			{Gv: shared.Gv, cm: $elm$core$Maybe$Nothing, rx: true, ry: false, rz: true, dd: shared.dd, Is: $author$project$Spa$Generated$Route$Commissions__Statements, DE: query, fg: true});
		var statementsTable = _v3.a;
		var statementsTableCmd = _v3.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, s1: statementsTable},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, statementsTableCmd));
	});
var $author$project$Pages$Commissions$Statements$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Commissions$Statements$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Commissions$Statements$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Commissions$Statement$List$subscriptions(model.s1));
};
var $author$project$Pages$Commissions$Statements$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Commissions$Statement$List$update, model.Gv, subMsg, model.s1);
		var statementsTable = _v1.a;
		var statementsTableCmd = _v1.b;
		var statementsTableOutMsgs = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{s1: statementsTable}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, statementsTableCmd),
			statementsTableOutMsgs);
	});
var $author$project$Pages$Commissions$Statements$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Commissions$Statement$List$view(model.s1))
			]),
		ac9: 'Commissions | Statements'
	};
};
var $author$project$Pages$Commissions$Statements$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Commissions$Statements$init, aiq: $author$project$Pages$Commissions$Statements$load, k8: $author$project$Pages$Commissions$Statements$save, alO: $author$project$Pages$Commissions$Statements$subscriptions, adT: $author$project$Pages$Commissions$Statements$update, amo: $author$project$Pages$Commissions$Statements$view});
var $author$project$OutMsg$RetrieveCompany = function (a) {
	return {$: 9, a: a};
};
var $author$project$Spa$Page$applicationCompanyOrEmployer = function (page) {
	return {
		ah_: F2(
			function (shared, url) {
				var _v0 = _Utils_Tuple3(shared.aa4, shared.ZV, shared.afQ);
				_v0$3:
				while (true) {
					_v0$4:
					while (true) {
						_v0$5:
						while (true) {
							switch (_v0.a.$) {
								case 3:
									switch (_v0.b.$) {
										case 3:
											switch (_v0.c.$) {
												case 3:
													var _v1 = _v0.a;
													var session = _v1.a;
													var _v2 = _v0.b;
													var practice = _v2.a;
													var _v3 = _v0.c;
													var company = _v3.a;
													return (!A3($author$project$Spa$Page$authorizeUrl, session, shared.ahK, shared.adY)) ? _Utils_Tuple3(
														$author$project$Spa$Page$SessionLoading(url),
														A2(
															$author$project$Utils$Route$navigate,
															$elm$core$Dict$empty,
															A2($author$project$Permission$homeStateFor, session, shared.ahK)),
														_List_Nil) : ((!_Utils_eq(
														url.YL.fZ,
														$author$project$Api$Company$id(company))) ? _Utils_Tuple3(
														$author$project$Spa$Page$SessionLoading(url),
														$elm$core$Platform$Cmd$none,
														_List_fromArray(
															[
																$author$project$OutMsg$RetrieveCompany(url.YL.fZ)
															])) : A2(
														$author$project$Utils$Tuple3$mapFirst,
														$author$project$Spa$Page$SessionLoaded,
														A2(
															$author$project$Utils$Tuple3$fromTuple2,
															_List_Nil,
															A5(page.ah_, session, practice, company, shared, url))));
												case 2:
													break _v0$4;
												default:
													break _v0$5;
											}
										case 2:
											break _v0$3;
										default:
											if (_v0.c.$ === 2) {
												break _v0$4;
											} else {
												break _v0$5;
											}
									}
								case 2:
									return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
								case 0:
									var _v4 = _v0.a;
									return _Utils_Tuple3(
										$author$project$Spa$Page$SessionLoading(url),
										$author$project$Ports$Session$authorize(
											{aku: true}),
										_List_Nil);
								default:
									if (_v0.b.$ === 2) {
										break _v0$3;
									} else {
										if (_v0.c.$ === 2) {
											break _v0$4;
										} else {
											break _v0$5;
										}
									}
							}
						}
						var _v5 = url;
						var params = _v5.YL;
						return _Utils_Tuple3(
							$author$project$Spa$Page$SessionLoading(url),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									$author$project$OutMsg$RetrieveCompany(params.fZ)
								]));
					}
					return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
				}
				return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
			}),
		aiq: F2(
			function (shared, model) {
				var _v6 = _Utils_Tuple3(shared.aa4, shared.ZV, shared.afQ);
				_v6$1:
				while (true) {
					_v6$3:
					while (true) {
						_v6$4:
						while (true) {
							switch (_v6.a.$) {
								case 3:
									switch (_v6.b.$) {
										case 3:
											switch (_v6.c.$) {
												case 3:
													var _v7 = _v6.a;
													var session = _v7.a;
													var _v8 = _v6.b;
													var practice = _v8.a;
													var _v9 = _v6.c;
													var company = _v9.a;
													switch (model.$) {
														case 0:
															var url = model.a;
															if (!A3($author$project$Spa$Page$authorizeUrl, session, shared.ahK, shared.adY)) {
																return _Utils_Tuple3(
																	$author$project$Spa$Page$SessionLoading(url),
																	A2(
																		$author$project$Utils$Route$navigate,
																		$elm$core$Dict$empty,
																		A2($author$project$Permission$homeStateFor, session, shared.ahK)),
																	_List_Nil);
															} else {
																var _v11 = A5(page.ah_, session, practice, company, shared, url);
																var pageModel = _v11.a;
																var cmd = _v11.b;
																return _Utils_Tuple3(
																	$author$project$Spa$Page$SessionLoaded(pageModel),
																	cmd,
																	_List_Nil);
															}
														case 1:
															var modelWithSession = model.a;
															return A2(
																$author$project$Utils$Tuple3$fromTuple2,
																_List_Nil,
																A2(
																	$elm$core$Tuple$mapFirst,
																	$author$project$Spa$Page$SessionLoaded,
																	A2(
																		page.aiq,
																		shared,
																		_Utils_update(
																			modelWithSession,
																			{Gv: shared.Gv}))));
														default:
															return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
													}
												case 0:
													break _v6$1;
												default:
													break _v6$4;
											}
										case 2:
											if (!_v6.c.$) {
												break _v6$1;
											} else {
												break _v6$3;
											}
										default:
											if (!_v6.c.$) {
												break _v6$1;
											} else {
												break _v6$4;
											}
									}
								case 2:
									return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
								default:
									if (_v6.b.$ === 2) {
										break _v6$3;
									} else {
										break _v6$4;
									}
							}
						}
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
					return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
				}
				var _v12 = _v6.a;
				var _v13 = _v6.c;
				if (!model.$) {
					var url = model.a;
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								$author$project$OutMsg$RetrieveCompany(url.YL.fZ)
							]));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			}),
		k8: F2(
			function (model, shared) {
				if (model.$ === 1) {
					var modelWithSession = model.a;
					return A2(page.k8, modelWithSession, shared);
				} else {
					return shared;
				}
			}),
		alO: function (model) {
			if (model.$ === 1) {
				var modelWithSession = model.a;
				return page.alO(modelWithSession);
			} else {
				return $elm$core$Platform$Sub$none;
			}
		},
		adT: F2(
			function (msg, model) {
				if (model.$ === 1) {
					var modelWithSession = model.a;
					return A2(
						$author$project$Utils$Tuple3$mapFirst,
						$author$project$Spa$Page$SessionLoaded,
						A2(page.adT, msg, modelWithSession));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			}),
		amo: function (model) {
			if (model.$ === 1) {
				var modelWithSession = model.a;
				return page.amo(modelWithSession);
			} else {
				return {fO: $author$project$Components$BlankPage$view, ac9: 'Loading...'};
			}
		}
	};
};
var $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$GotCompanyPlans = $elm$core$Basics$identity;
var $author$project$Api$CompanyPlan$Pricing = 0;
var $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$init = F5(
	function (session, practice, company, _v0, _v1) {
		var apiClient = _v0.Gv;
		var params = _v1.YL;
		return _Utils_Tuple2(
			{Gv: apiClient, afQ: company, aH: $author$project$Api$Data$Loading, ZV: practice},
			A5(
				$author$project$Api$CompanyPlan$list,
				apiClient,
				session,
				params.fZ,
				function (d) {
					return _Utils_update(
						d,
						{
							HE: _List_fromArray(
								[0])
						});
				},
				$elm$core$Basics$identity));
	});
var $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$update = F2(
	function (msg, model) {
		var response = msg;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{aH: response}),
			$elm$core$Platform$Cmd$none,
			$author$project$OutMsg$handleErrorResponse(response));
	});
var $author$project$Api$Employer$Plan$Shared$defaultPeriodInMonths = function (_v0) {
	var record = _v0;
	return record.P7;
};
var $author$project$Api$Employer$Plan$All$defaultPeriodInMonths = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$defaultPeriodInMonths(shared);
};
var $author$project$Api$Employer$Plan$One$defaultPeriodInMonths = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$defaultPeriodInMonths(shared);
};
var $author$project$Api$Provider$Plan$Shared$defaultPeriodInMonths = function (_v0) {
	var record = _v0;
	return record.P7;
};
var $author$project$Api$Provider$Plan$All$defaultPeriodInMonths = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$defaultPeriodInMonths(shared);
};
var $author$project$Api$Provider$Plan$One$defaultPeriodInMonths = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$defaultPeriodInMonths(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$defaultPeriodInMonths = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$defaultPeriodInMonths(shared);
};
var $author$project$Api$Plan$defaultPeriodInMonths = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$Shared$defaultPeriodInMonths(plan_);
		case 1:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$SharedWithContractInfo$defaultPeriodInMonths(plan_);
		case 4:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$Shared$defaultPeriodInMonths(plan_);
		case 2:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$All$defaultPeriodInMonths(plan_);
		case 6:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$All$defaultPeriodInMonths(plan_);
		case 3:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$One$defaultPeriodInMonths(plan_);
		default:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$One$defaultPeriodInMonths(plan_);
	}
};
var $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$viewCompanyPlan = function (companyPlan) {
	var plan = $author$project$Api$CompanyPlan$plan(companyPlan);
	return A2(
		$author$project$Ui$Table$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Api$Plan$name(plan))
							]))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						function () {
						var _v0 = $elm$core$List$head(
							$author$project$Api$Plan$allowedBillingPeriodCodes(plan));
						if (!_v0.$) {
							var allowedBillingPeriodCode = _v0.a;
							return $elm$html$Html$text(
								$author$project$Formatters$String$titleize(allowedBillingPeriodCode) + 'ly');
						} else {
							return $elm$html$Html$text('N/A');
						}
					}()
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Formatters$Int$ordinal(
							$author$project$Api$Plan$defaultPeriodInMonths(plan))),
						$elm$html$Html$text(' day')
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A3($author$project$Components$Plan$Summary$Pricing$view, plan, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing)
					]))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$view = function (model) {
	var _v0 = function () {
		var _v1 = model.aH;
		if (_v1.$ === 3) {
			var list = _v1.a;
			return _Utils_Tuple2(false, list);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var companyPlans = _v0.b;
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Affiliate Fee Plans')
									]))
							])),
						A4(
						$author$project$Ui$Panel$table,
						_List_fromArray(
							[
								$author$project$Ui$Table$loading(loading)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Table$header,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Name')
									])),
								A2(
								$author$project$Ui$Table$header,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Billing cycle')
									])),
								A2(
								$author$project$Ui$Table$header,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Billing date')
									])),
								A2(
								$author$project$Ui$Table$header,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Rate')
									]))
							]),
						A2($elm$core$List$map, $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$viewCompanyPlan, companyPlans),
						_List_Nil)
					]))
			]),
		ac9: A2($author$project$Api$Practice$sponsorize, model.ZV, 'Companies') + ' | Affiliate Fee Plans'
	};
};
var $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$page = $author$project$Spa$Page$applicationCompanyOrEmployer(
	{ah_: $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$init, aiq: $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$load, k8: $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$save, alO: $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$subscriptions, adT: $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$update, amo: $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$view});
var $author$project$Pages$Companies$CompanyId_String$Eas$GotFeedEnroller = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$GotUploadSetting = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$GotData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$UploadHeader$All$UploadHeader = $elm$core$Basics$identity;
var $author$project$Api$Provider$UploadHeader$Shared$UploadHeader = $elm$core$Basics$identity;
var $author$project$Api$Provider$UploadHeader$Shared$Record = F5(
	function (id, columnName, destination, required, ignored) {
		return {N2: columnName, Qt: destination, ahP: id, ahS: ignored, akR: required};
	});
var $author$project$Api$Provider$UploadHeader$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'ignored',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'required',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'destination',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'column_name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$UploadHeader$Shared$Record))))));
var $author$project$Api$Provider$UploadHeader$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$UploadHeader$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$UploadHeader$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$UploadHeader$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Company$UploadHeader$uploadHeadersPath = function (companyId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['upload_headers']),
		$author$project$Api$Provider$Company$companyPath(companyId));
};
var $author$project$Api$Provider$Company$UploadHeader$list = F3(
	function (apiClient, companyId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$UploadHeader$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Company$UploadHeader$uploadHeadersPath(companyId)));
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$fetchUploadHeaders = function (model) {
	return A3(
		$author$project$Api$Provider$Company$UploadHeader$list,
		model.Gv,
		$author$project$Api$Company$id(model.afQ),
		$author$project$Pages$Companies$CompanyId_String$Eas$GotData);
};
var $author$project$Api$FeedEnroller$EmployerAll = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$FeedEnroller$ProviderAll = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$FeedEnroller$All$FeedEnroller = $elm$core$Basics$identity;
var $author$project$Api$Employer$FeedEnroller$Shared$FeedEnroller = $elm$core$Basics$identity;
var $author$project$Api$Employer$FeedEnroller$Shared$Record = F9(
	function (id, publicSshKey, fileMatch, enabled, contactName, contactEmail, server, path, username) {
		return {Ow: contactEmail, Ox: contactName, Ro: enabled, Sm: fileMatch, ahP: id, YX: path, _H: publicSshKey, aaZ: server, ad1: username};
	});
var $author$project$Api$Employer$FeedEnroller$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'username',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'path',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'server',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'contact_email',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contact_name',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'enabled',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'file_match',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'public_ssh_key',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'id',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Api$Employer$FeedEnroller$Shared$Record))))))))));
var $author$project$Api$Employer$FeedEnroller$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$FeedEnroller$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$FeedEnroller$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$FeedEnroller$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$FeedEnroller$feedEnrollersPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['feed_enrollers']),
	$author$project$Api$Data$employerPath);
var $author$project$Api$Employer$FeedEnroller$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Employer$FeedEnroller$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Employer$FeedEnroller$feedEnrollersPath));
	});
var $author$project$Api$Provider$FeedEnroller$All$FeedEnroller = $elm$core$Basics$identity;
var $author$project$Api$Provider$FeedEnroller$Shared$FeedEnroller = $elm$core$Basics$identity;
var $author$project$Api$Provider$FeedEnroller$Shared$Record = F9(
	function (id, publicSshKey, fileMatch, enabled, contactName, contactEmail, server, path, username) {
		return {Ow: contactEmail, Ox: contactName, Ro: enabled, Sm: fileMatch, ahP: id, YX: path, _H: publicSshKey, aaZ: server, ad1: username};
	});
var $author$project$Api$Provider$FeedEnroller$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'username',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'path',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'server',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'contact_email',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contact_name',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'enabled',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'file_match',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'public_ssh_key',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'id',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Api$Provider$FeedEnroller$Shared$Record))))))))));
var $author$project$Api$Provider$FeedEnroller$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$FeedEnroller$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$FeedEnroller$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$FeedEnroller$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$FeedEnroller$feedEnrollersPath = function (basePath) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['feed_enrollers']),
		basePath);
};
var $author$project$Api$Provider$FeedEnroller$list = F3(
	function (apiClient, companyId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$FeedEnroller$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$FeedEnroller$feedEnrollersPath(
					$author$project$Api$Provider$Company$companyPath(companyId))));
	});
var $author$project$Api$FeedEnroller$list = F4(
	function (apiClient, session, companyId, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A2(
			$author$project$Api$Employer$FeedEnroller$list,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$FeedEnroller$EmployerAll)))) : A3(
			$author$project$Api$Provider$FeedEnroller$list,
			apiClient,
			companyId,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$FeedEnroller$ProviderAll))));
	});
var $author$project$Api$FeedEnroller$retrieve = F4(
	function (apiClient, session, companyId, toMsg) {
		return A4(
			$author$project$Api$FeedEnroller$list,
			apiClient,
			session,
			companyId,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($elm$core$List$head)));
	});
var $author$project$Api$Provider$UploadSetting$One$UploadSetting = $elm$core$Basics$identity;
var $author$project$Api$Provider$UploadSetting$One$Record = function (adoptCompanies) {
	return function (autoProcessTimer) {
		return function (createChildCompanies) {
			return function (createDivisions) {
				return function (endDateBuffer) {
					return function (fileGrowthThreshold) {
						return function (fileGrowthThresholdPct) {
							return function (inheritPlans) {
								return function (mapUnknownPlanValuesToCompanyDefaultPlan) {
									return function (nameMatch) {
										return function (restrictTerminationByOmissionToEmployees) {
											return function (restrictTerminationByOmissionToFeedPatients) {
												return function (terminateMembersByOmission) {
													return function (terminateMembersPct) {
														return function (terminateEligibilityByOmission) {
															return function (useUploadCreationDateAsEnrollmentDate) {
																return {aeL: adoptCompanies, ae3: autoProcessTimer, af_: createChildCompanies, af$: createDivisions, agT: endDateBuffer, ahk: fileGrowthThreshold, ahl: fileGrowthThresholdPct, ahZ: inheritPlans, aiy: mapUnknownPlanValuesToCompanyDefaultPlan, aiS: nameMatch, akZ: restrictTerminationByOmissionToEmployees, ak_: restrictTerminationByOmissionToFeedPatients, alZ: terminateEligibilityByOmission, al_: terminateMembersByOmission, al$: terminateMembersPct, amk: useUploadCreationDateAsEnrollmentDate};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$UploadSetting$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'use_upload_creation_date_as_enrollment_date',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'terminate_eligibility_by_omission',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'terminate_members_pct',
			$elm$json$Json$Decode$float,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'terminate_members_by_omission',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'restrict_termination_by_omission_to_feed_patients',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'restrict_termination_by_omission_to_employees',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'name_match',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'map_unknown_plan_values_to_company_default_plan',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'inherit_plans',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'file_growth_threshold_pct',
										$elm$json$Json$Decode$float,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'file_growth_threshold',
											$elm$json$Json$Decode$bool,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'end_date_buffer',
												$elm$json$Json$Decode$int,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'create_divisions',
													$elm$json$Json$Decode$bool,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'create_child_companies',
														$elm$json$Json$Decode$bool,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'auto_process_timer',
															$elm$json$Json$Decode$int,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'adopt_companies',
																$elm$json$Json$Decode$bool,
																$elm$json$Json$Decode$succeed($author$project$Api$Provider$UploadSetting$One$Record)))))))))))))))));
var $author$project$Api$Provider$UploadSetting$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$UploadSetting$One$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Company$UploadSetting$uploadSettingPath = function (companyId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['upload_setting']),
		$author$project$Api$Provider$Company$companyPath(companyId));
};
var $author$project$Api$Provider$Company$UploadSetting$retrieve = F3(
	function (apiClient, companyId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$UploadSetting$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Company$UploadSetting$uploadSettingPath(companyId)));
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$init = F5(
	function (session, practice, company, shared, _v0) {
		var params = _v0.YL;
		var model = {
			Gv: shared.Gv,
			afQ: company,
			age: shared.ahq.age,
			ee: $elm$core$Maybe$Nothing,
			jL: $author$project$Api$Data$Loading,
			ev: $elm$core$Maybe$Nothing,
			ew: $author$project$Api$Data$NotAsked,
			Ij: $author$project$Shared$isHintAdmin(shared),
			ZV: practice,
			aa4: session,
			ao: $elm$core$Maybe$Nothing,
			lX: $author$project$Api$Data$Loading,
			lZ: $author$project$Api$Data$Loading,
			ce: $elm$core$Maybe$Nothing
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Pages$Companies$CompanyId_String$Eas$fetchUploadHeaders(model),
						A4($author$project$Api$FeedEnroller$retrieve, shared.Gv, session, params.fZ, $author$project$Pages$Companies$CompanyId_String$Eas$GotFeedEnroller),
						A3($author$project$Api$Provider$Company$UploadSetting$retrieve, shared.Gv, params.fZ, $author$project$Pages$Companies$CompanyId_String$Eas$GotUploadSetting)
					])));
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					Ij: $author$project$Shared$isHintAdmin(shared)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$CancelUploadHeaderEdit = {$: 16};
var $author$project$Pages$Companies$CompanyId_String$Eas$DeleteFeedEnrollerHiConfirmClosed = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Companies$CompanyId_String$Eas$CancelUploadHeaderEdit)),
					model.ao)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Companies$CompanyId_String$Eas$DeleteFeedEnrollerHiConfirmClosed),
					A2($elm$core$Maybe$map, $elm$core$Tuple$first, model.ee)))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Eas$FeedEnrollerCreated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$FeedEnrollerDeleted = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Api$FeedEnroller$ProviderOne = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$FeedEnroller$One$FeedEnroller = $elm$core$Basics$identity;
var $author$project$Api$Provider$FeedEnroller$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$FeedEnroller$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$FeedEnroller$create = F4(
	function (apiClient, companyId, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'skip_sftp_server',
					$elm$json$Json$Encode$bool(params.alz)),
					_Utils_Tuple2(
					'feed_enroller',
					$elm$json$Json$Encode$object(_List_Nil))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$FeedEnroller$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$FeedEnroller$feedEnrollersPath(
						$author$project$Api$Provider$Company$companyPath(companyId)))));
	});
var $author$project$Api$FeedEnroller$create = F5(
	function (apiClient, session, companyId, params, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : A4(
			$author$project$Api$Provider$FeedEnroller$create,
			apiClient,
			companyId,
			params,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$FeedEnroller$ProviderOne)));
	});
var $author$project$Api$Provider$FeedEnroller$feedEnrollerPath = F2(
	function (basePath, id) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id]),
			$author$project$Api$Provider$FeedEnroller$feedEnrollersPath(basePath));
	});
var $author$project$Api$Provider$FeedEnroller$delete = F4(
	function (apiClient, companyId, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Provider$FeedEnroller$feedEnrollerPath,
					$author$project$Api$Provider$Company$companyPath(companyId),
					id)));
	});
var $author$project$Api$FeedEnroller$delete = F5(
	function (apiClient, session, companyId, id_, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : A4($author$project$Api$Provider$FeedEnroller$delete, apiClient, companyId, id_, toMsg);
	});
var $author$project$Api$Employer$FeedEnroller$Shared$contactEmail = function (_v0) {
	var record = _v0;
	return record.Ow;
};
var $author$project$Api$Employer$FeedEnroller$All$contactEmail = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$FeedEnroller$Shared$contactEmail(shared);
};
var $author$project$Api$Provider$FeedEnroller$Shared$contactEmail = function (_v0) {
	var record = _v0;
	return record.Ow;
};
var $author$project$Api$Provider$FeedEnroller$All$contactEmail = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$FeedEnroller$Shared$contactEmail(shared);
};
var $author$project$Api$Provider$FeedEnroller$One$contactEmail = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$FeedEnroller$Shared$contactEmail(shared);
};
var $author$project$Api$FeedEnroller$contactEmail = function (feedEnroller) {
	switch (feedEnroller.$) {
		case 0:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Provider$FeedEnroller$All$contactEmail(feedEnroller_);
		case 1:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Employer$FeedEnroller$All$contactEmail(feedEnroller_);
		default:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Provider$FeedEnroller$One$contactEmail(feedEnroller_);
	}
};
var $author$project$Api$Employer$FeedEnroller$Shared$contactName = function (_v0) {
	var record = _v0;
	return record.Ox;
};
var $author$project$Api$Employer$FeedEnroller$All$contactName = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$FeedEnroller$Shared$contactName(shared);
};
var $author$project$Api$Provider$FeedEnroller$Shared$contactName = function (_v0) {
	var record = _v0;
	return record.Ox;
};
var $author$project$Api$Provider$FeedEnroller$All$contactName = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$FeedEnroller$Shared$contactName(shared);
};
var $author$project$Api$Provider$FeedEnroller$One$contactName = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$FeedEnroller$Shared$contactName(shared);
};
var $author$project$Api$FeedEnroller$contactName = function (feedEnroller) {
	switch (feedEnroller.$) {
		case 0:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Provider$FeedEnroller$All$contactName(feedEnroller_);
		case 1:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Employer$FeedEnroller$All$contactName(feedEnroller_);
		default:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Provider$FeedEnroller$One$contactName(feedEnroller_);
	}
};
var $author$project$Api$Employer$FeedEnroller$Shared$enabled = function (_v0) {
	var record = _v0;
	return record.Ro;
};
var $author$project$Api$Employer$FeedEnroller$All$enabled = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$FeedEnroller$Shared$enabled(shared);
};
var $author$project$Api$Provider$FeedEnroller$Shared$enabled = function (_v0) {
	var record = _v0;
	return record.Ro;
};
var $author$project$Api$Provider$FeedEnroller$All$enabled = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$FeedEnroller$Shared$enabled(shared);
};
var $author$project$Api$Provider$FeedEnroller$One$enabled = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$FeedEnroller$Shared$enabled(shared);
};
var $author$project$Api$FeedEnroller$enabled = function (feedEnroller) {
	switch (feedEnroller.$) {
		case 0:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Provider$FeedEnroller$All$enabled(feedEnroller_);
		case 1:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Employer$FeedEnroller$All$enabled(feedEnroller_);
		default:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Provider$FeedEnroller$One$enabled(feedEnroller_);
	}
};
var $author$project$Api$Employer$FeedEnroller$Shared$fileMatch = function (_v0) {
	var record = _v0;
	return record.Sm;
};
var $author$project$Api$Employer$FeedEnroller$All$fileMatch = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$FeedEnroller$Shared$fileMatch(shared);
};
var $author$project$Api$Provider$FeedEnroller$Shared$fileMatch = function (_v0) {
	var record = _v0;
	return record.Sm;
};
var $author$project$Api$Provider$FeedEnroller$All$fileMatch = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$FeedEnroller$Shared$fileMatch(shared);
};
var $author$project$Api$Provider$FeedEnroller$One$fileMatch = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$FeedEnroller$Shared$fileMatch(shared);
};
var $author$project$Api$FeedEnroller$fileMatch = function (feedEnroller) {
	switch (feedEnroller.$) {
		case 0:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Provider$FeedEnroller$All$fileMatch(feedEnroller_);
		case 1:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Employer$FeedEnroller$All$fileMatch(feedEnroller_);
		default:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Provider$FeedEnroller$One$fileMatch(feedEnroller_);
	}
};
var $author$project$Api$Employer$FeedEnroller$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Employer$FeedEnroller$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$FeedEnroller$Shared$id(shared);
};
var $author$project$Api$Provider$FeedEnroller$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$FeedEnroller$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$FeedEnroller$Shared$id(shared);
};
var $author$project$Api$Provider$FeedEnroller$One$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$FeedEnroller$Shared$id(shared);
};
var $author$project$Api$FeedEnroller$id = function (feedEnroller) {
	switch (feedEnroller.$) {
		case 0:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Provider$FeedEnroller$All$id(feedEnroller_);
		case 1:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Employer$FeedEnroller$All$id(feedEnroller_);
		default:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Provider$FeedEnroller$One$id(feedEnroller_);
	}
};
var $author$project$Api$Employer$FeedEnroller$Shared$path = function (_v0) {
	var record = _v0;
	return record.YX;
};
var $author$project$Api$Employer$FeedEnroller$All$path = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$FeedEnroller$Shared$path(shared);
};
var $author$project$Api$Provider$FeedEnroller$Shared$path = function (_v0) {
	var record = _v0;
	return record.YX;
};
var $author$project$Api$Provider$FeedEnroller$All$path = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$FeedEnroller$Shared$path(shared);
};
var $author$project$Api$Provider$FeedEnroller$One$path = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$FeedEnroller$Shared$path(shared);
};
var $author$project$Api$FeedEnroller$path = function (feedEnroller) {
	switch (feedEnroller.$) {
		case 0:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Provider$FeedEnroller$All$path(feedEnroller_);
		case 1:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Employer$FeedEnroller$All$path(feedEnroller_);
		default:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Provider$FeedEnroller$One$path(feedEnroller_);
	}
};
var $author$project$Api$Employer$FeedEnroller$Shared$publicSshKey = function (_v0) {
	var record = _v0;
	return record._H;
};
var $author$project$Api$Employer$FeedEnroller$All$publicSshKey = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$FeedEnroller$Shared$publicSshKey(shared);
};
var $author$project$Api$Provider$FeedEnroller$Shared$publicSshKey = function (_v0) {
	var record = _v0;
	return record._H;
};
var $author$project$Api$Provider$FeedEnroller$All$publicSshKey = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$FeedEnroller$Shared$publicSshKey(shared);
};
var $author$project$Api$Provider$FeedEnroller$One$publicSshKey = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$FeedEnroller$Shared$publicSshKey(shared);
};
var $author$project$Api$FeedEnroller$publicSshKey = function (feedEnroller) {
	switch (feedEnroller.$) {
		case 0:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Provider$FeedEnroller$All$publicSshKey(feedEnroller_);
		case 1:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Employer$FeedEnroller$All$publicSshKey(feedEnroller_);
		default:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Provider$FeedEnroller$One$publicSshKey(feedEnroller_);
	}
};
var $author$project$Api$Employer$FeedEnroller$Shared$server = function (_v0) {
	var record = _v0;
	return record.aaZ;
};
var $author$project$Api$Employer$FeedEnroller$All$server = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$FeedEnroller$Shared$server(shared);
};
var $author$project$Api$Provider$FeedEnroller$Shared$server = function (_v0) {
	var record = _v0;
	return record.aaZ;
};
var $author$project$Api$Provider$FeedEnroller$All$server = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$FeedEnroller$Shared$server(shared);
};
var $author$project$Api$Provider$FeedEnroller$One$server = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$FeedEnroller$Shared$server(shared);
};
var $author$project$Api$FeedEnroller$server = function (feedEnroller) {
	switch (feedEnroller.$) {
		case 0:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Provider$FeedEnroller$All$server(feedEnroller_);
		case 1:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Employer$FeedEnroller$All$server(feedEnroller_);
		default:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Provider$FeedEnroller$One$server(feedEnroller_);
	}
};
var $author$project$Api$Employer$FeedEnroller$Shared$username = function (_v0) {
	var record = _v0;
	return record.ad1;
};
var $author$project$Api$Employer$FeedEnroller$All$username = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$FeedEnroller$Shared$username(shared);
};
var $author$project$Api$Provider$FeedEnroller$Shared$username = function (_v0) {
	var record = _v0;
	return record.ad1;
};
var $author$project$Api$Provider$FeedEnroller$All$username = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$FeedEnroller$Shared$username(shared);
};
var $author$project$Api$Provider$FeedEnroller$One$username = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$FeedEnroller$Shared$username(shared);
};
var $author$project$Api$FeedEnroller$username = function (feedEnroller) {
	switch (feedEnroller.$) {
		case 0:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Provider$FeedEnroller$All$username(feedEnroller_);
		case 1:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Employer$FeedEnroller$All$username(feedEnroller_);
		default:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Provider$FeedEnroller$One$username(feedEnroller_);
	}
};
var $author$project$Pages$Companies$CompanyId_String$Eas$feedEnrollerFormFieldsFromFeedEnroller = function (feedEnroller) {
	return {
		Ow: $author$project$Api$FeedEnroller$contactEmail(feedEnroller),
		Ox: $author$project$Api$FeedEnroller$contactName(feedEnroller),
		Ro: $author$project$Api$FeedEnroller$enabled(feedEnroller),
		Sm: $author$project$Api$FeedEnroller$fileMatch(feedEnroller),
		ahP: $author$project$Api$FeedEnroller$id(feedEnroller),
		YX: $author$project$Api$FeedEnroller$path(feedEnroller),
		_H: $author$project$Api$FeedEnroller$publicSshKey(feedEnroller),
		aaZ: $author$project$Api$FeedEnroller$server(feedEnroller),
		ad1: $author$project$Api$FeedEnroller$username(feedEnroller)
	};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$feedEnrollerFormFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						_H: $author$project$Utils$String$toMaybe(string)
					});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{Sm: string});
			case 2:
				var bool = field.a;
				return _Utils_update(
					fields,
					{Ro: bool});
			case 3:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Ox: $author$project$Utils$String$toMaybe(string)
					});
			default:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Ow: $author$project$Utils$String$toMaybe(string)
					});
		}
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$FileMatchValidation = 0;
var $author$project$Pages$Companies$CompanyId_String$Eas$feedEnrollerFormFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.Sm;
			},
			_Utils_Tuple2(0, 'Please enter a file match.'))
		]));
var $author$project$Api$Provider$UploadHeader$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$UploadHeader$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$UploadHeader$Shared$id(shared);
};
var $author$project$Pages$Companies$CompanyId_String$Eas$UploadHeaderCreated = function (a) {
	return {$: 19, a: a};
};
var $author$project$Api$Provider$UploadHeader$One$UploadHeader = 0;
var $author$project$Api$Provider$UploadHeader$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Provider$Company$UploadHeader$create = F4(
	function (apiClient, companyId, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'upload_header',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'column_name',
								$elm$json$Json$Encode$string(fields.N2))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$UploadHeader$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Company$UploadHeader$uploadHeadersPath(companyId))));
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$createUploadHeader = F3(
	function (apiClient, company, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var apiFields = {N2: fields.N2};
		return A4(
			$author$project$Api$Provider$Company$UploadHeader$create,
			apiClient,
			$author$project$Api$Company$id(company),
			apiFields,
			$author$project$Pages$Companies$CompanyId_String$Eas$UploadHeaderCreated);
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$UploadHeaderUpdated = function (a) {
	return {$: 20, a: a};
};
var $author$project$Api$Provider$Company$UploadHeader$uploadHeaderPath = F2(
	function (companyId, id_) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id_]),
			$author$project$Api$Provider$Company$UploadHeader$uploadHeadersPath(companyId));
	});
var $author$project$Api$Provider$Company$UploadHeader$update = F5(
	function (apiClient, companyId, id, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'upload_header',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'column_name',
								$elm$json$Json$Encode$string(fields.N2)),
								_Utils_Tuple2(
								'required',
								$elm$json$Json$Encode$bool(fields.akR)),
								_Utils_Tuple2(
								'ignored',
								$elm$json$Json$Encode$bool(fields.ahS))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$UploadHeader$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Provider$Company$UploadHeader$uploadHeaderPath, companyId, id))));
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$updateUploadHeader = F4(
	function (apiClient, company, id, formFields) {
		return A5(
			$author$project$Api$Provider$Company$UploadHeader$update,
			apiClient,
			$author$project$Api$Company$id(company),
			id,
			$rtfeldman$elm_validate$Validate$fromValid(formFields),
			$author$project$Pages$Companies$CompanyId_String$Eas$UploadHeaderUpdated);
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$saveUploadHeader = F4(
	function (apiClient, maybeId, company, formFields) {
		if (!maybeId.$) {
			var id_ = maybeId.a;
			return A4($author$project$Pages$Companies$CompanyId_String$Eas$updateUploadHeader, apiClient, company, id_, formFields);
		} else {
			return A3($author$project$Pages$Companies$CompanyId_String$Eas$createUploadHeader, apiClient, company, formFields);
		}
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$FeedEnrollerUpdated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$FeedEnroller$update = F5(
	function (apiClient, companyId, id, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'feed_enroller',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'enabled',
								$elm$json$Json$Encode$bool(params.Ro)),
								_Utils_Tuple2(
								'file_match',
								$elm$json$Json$Encode$string(params.Sm)),
								_Utils_Tuple2(
								'public_ssh_key',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params._H)),
								_Utils_Tuple2(
								'contact_name',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.Ox)),
								_Utils_Tuple2(
								'contact_email',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.Ow))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$FeedEnroller$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Provider$FeedEnroller$feedEnrollerPath,
						$author$project$Api$Provider$Company$companyPath(companyId),
						id))));
	});
var $author$project$Api$FeedEnroller$update = F6(
	function (apiClient, session, companyId, id_, params, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : A5(
			$author$project$Api$Provider$FeedEnroller$update,
			apiClient,
			companyId,
			id_,
			params,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$FeedEnroller$ProviderOne)));
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$updateFeedEnroller = F5(
	function (apiClient, session, company, id, formFields) {
		var validFields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A6(
			$author$project$Api$FeedEnroller$update,
			apiClient,
			session,
			$author$project$Api$Company$id(company),
			id,
			{Ow: validFields.Ow, Ox: validFields.Ox, Ro: validFields.Ro, Sm: validFields.Sm, _H: validFields._H},
			$author$project$Pages$Companies$CompanyId_String$Eas$FeedEnrollerUpdated);
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$UploadSettingUpdated = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$defaultAutoProcessTimer = 0;
var $author$project$Pages$Companies$CompanyId_String$Eas$defaultEndDateBuffer = 0;
var $author$project$Pages$Companies$CompanyId_String$Eas$defaultFileGrowthThresholdPct = $author$project$Percentage$fromFloat(0.5);
var $author$project$Pages$Companies$CompanyId_String$Eas$defaultTerminateMembersPct = $author$project$Percentage$fromFloat(0.05);
var $author$project$Api$Provider$Company$UploadSetting$update = F4(
	function (apiClient, companyId, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'upload_setting',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'adopt_companies',
								$elm$json$Json$Encode$bool(fields.aeL)),
								_Utils_Tuple2(
								'auto_process_timer',
								$elm$json$Json$Encode$int(fields.ae3)),
								_Utils_Tuple2(
								'create_child_companies',
								$elm$json$Json$Encode$bool(fields.af_)),
								_Utils_Tuple2(
								'create_divisions',
								$elm$json$Json$Encode$bool(fields.af$)),
								_Utils_Tuple2(
								'end_date_buffer',
								$elm$json$Json$Encode$int(fields.agT)),
								_Utils_Tuple2(
								'file_growth_threshold',
								$elm$json$Json$Encode$bool(fields.ahk)),
								_Utils_Tuple2(
								'file_growth_threshold_pct',
								$author$project$Percentage$encode(fields.ahl)),
								_Utils_Tuple2(
								'inherit_plans',
								$elm$json$Json$Encode$bool(fields.ahZ)),
								_Utils_Tuple2(
								'map_unknown_plan_values_to_company_default_plan',
								$elm$json$Json$Encode$bool(fields.aiy)),
								_Utils_Tuple2(
								'name_match',
								$elm$json$Json$Encode$bool(fields.aiS)),
								_Utils_Tuple2(
								'restrict_termination_by_omission_to_employees',
								$elm$json$Json$Encode$bool(fields.akZ)),
								_Utils_Tuple2(
								'restrict_termination_by_omission_to_feed_patients',
								$elm$json$Json$Encode$bool(fields.ak_)),
								_Utils_Tuple2(
								'terminate_members_by_omission',
								$elm$json$Json$Encode$bool(fields.al_)),
								_Utils_Tuple2(
								'terminate_eligibility_by_omission',
								$elm$json$Json$Encode$bool(fields.alZ)),
								_Utils_Tuple2(
								'terminate_members_pct',
								$author$project$Percentage$encode(fields.al$)),
								_Utils_Tuple2(
								'use_upload_creation_date_as_enrollment_date',
								$elm$json$Json$Encode$bool(fields.amk))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$UploadSetting$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Company$UploadSetting$uploadSettingPath(companyId))));
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$updateUploadSetting = F3(
	function (apiClient, company, formFields) {
		var validFields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4(
			$author$project$Api$Provider$Company$UploadSetting$update,
			apiClient,
			$author$project$Api$Company$id(company),
			{
				aeL: validFields.aeL,
				ae3: A2($elm$core$Maybe$withDefault, $author$project$Pages$Companies$CompanyId_String$Eas$defaultAutoProcessTimer, validFields.ae3),
				af_: validFields.af_,
				af$: validFields.af$,
				agT: A2($elm$core$Maybe$withDefault, $author$project$Pages$Companies$CompanyId_String$Eas$defaultEndDateBuffer, validFields.agT),
				ahk: validFields.ahk,
				ahl: A2($elm$core$Maybe$withDefault, $author$project$Pages$Companies$CompanyId_String$Eas$defaultFileGrowthThresholdPct, validFields.ahl),
				ahZ: validFields.ahZ,
				aiy: validFields.aiy,
				aiS: validFields.aiS,
				akZ: validFields.akZ,
				ak_: validFields.ak_,
				alZ: validFields.alZ,
				al_: validFields.al_,
				al$: A2($elm$core$Maybe$withDefault, $author$project$Pages$Companies$CompanyId_String$Eas$defaultTerminateMembersPct, validFields.al$),
				amk: validFields.amk
			},
			$author$project$Pages$Companies$CompanyId_String$Eas$UploadSettingUpdated);
	});
var $author$project$Api$Provider$UploadHeader$Shared$columnName = function (_v0) {
	var record = _v0;
	return record.N2;
};
var $author$project$Api$Provider$UploadHeader$All$columnName = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$UploadHeader$Shared$columnName(shared);
};
var $author$project$Api$Provider$UploadHeader$Shared$destination = function (_v0) {
	var record = _v0;
	return record.Qt;
};
var $author$project$Api$Provider$UploadHeader$All$destination = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$UploadHeader$Shared$destination(shared);
};
var $author$project$Api$Provider$UploadHeader$Shared$ignored = function (_v0) {
	var record = _v0;
	return record.ahS;
};
var $author$project$Api$Provider$UploadHeader$All$ignored = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$UploadHeader$Shared$ignored(shared);
};
var $author$project$Api$Provider$UploadHeader$Shared$required = function (_v0) {
	var record = _v0;
	return record.akR;
};
var $author$project$Api$Provider$UploadHeader$All$required = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$UploadHeader$Shared$required(shared);
};
var $author$project$Pages$Companies$CompanyId_String$Eas$uploadHeaderFormFieldsFromUploadHeader = function (uploadHeader) {
	return {
		N2: $author$project$Api$Provider$UploadHeader$All$columnName(uploadHeader),
		Qt: $author$project$Api$Provider$UploadHeader$All$destination(uploadHeader),
		ahS: $author$project$Api$Provider$UploadHeader$All$ignored(uploadHeader),
		akR: $author$project$Api$Provider$UploadHeader$All$required(uploadHeader)
	};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$uploadHeaderFormFieldsInit = {N2: '', Qt: '', ahS: true, akR: false};
var $author$project$Pages$Companies$CompanyId_String$Eas$uploadHeaderFormFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{N2: string});
			case 1:
				var bool = field.a;
				return _Utils_update(
					fields,
					{akR: bool});
			default:
				var bool = field.a;
				return _Utils_update(
					fields,
					{ahS: bool});
		}
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$ColumnNameValidation = 0;
var $author$project$Pages$Companies$CompanyId_String$Eas$uploadHeaderFormFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.N2;
			},
			_Utils_Tuple2(0, 'Please enter a column name.'))
		]));
var $author$project$Api$Provider$UploadSetting$One$adoptCompanies = function (_v0) {
	var record = _v0;
	return record.aeL;
};
var $author$project$Api$Provider$UploadSetting$One$autoProcessTimer = function (_v0) {
	var record = _v0;
	return record.ae3;
};
var $author$project$Api$Provider$UploadSetting$One$createChildCompanies = function (_v0) {
	var record = _v0;
	return record.af_;
};
var $author$project$Api$Provider$UploadSetting$One$createDivisions = function (_v0) {
	var record = _v0;
	return record.af$;
};
var $author$project$Api$Provider$UploadSetting$One$endDateBuffer = function (_v0) {
	var record = _v0;
	return record.agT;
};
var $author$project$Api$Provider$UploadSetting$One$fileGrowthThreshold = function (_v0) {
	var record = _v0;
	return record.ahk;
};
var $author$project$Api$Provider$UploadSetting$One$fileGrowthThresholdPct = function (_v0) {
	var record = _v0;
	return record.ahl;
};
var $author$project$Api$Provider$UploadSetting$One$inheritPlans = function (_v0) {
	var record = _v0;
	return record.ahZ;
};
var $author$project$Api$Provider$UploadSetting$One$mapUnknownPlanValuesToCompanyDefaultPlan = function (_v0) {
	var record = _v0;
	return record.aiy;
};
var $author$project$Api$Provider$UploadSetting$One$nameMatch = function (_v0) {
	var record = _v0;
	return record.aiS;
};
var $author$project$Api$Provider$UploadSetting$One$restrictTerminationByOmissionToEmployees = function (_v0) {
	var record = _v0;
	return A2($elm$core$Maybe$withDefault, false, record.akZ);
};
var $author$project$Api$Provider$UploadSetting$One$restrictTerminationByOmissionToFeedPatients = function (_v0) {
	var record = _v0;
	return record.ak_;
};
var $author$project$Api$Provider$UploadSetting$One$terminateEligibilityByOmission = function (_v0) {
	var record = _v0;
	return record.alZ;
};
var $author$project$Api$Provider$UploadSetting$One$terminateMembersByOmission = function (_v0) {
	var record = _v0;
	return A2($elm$core$Maybe$withDefault, false, record.al_);
};
var $author$project$Api$Provider$UploadSetting$One$terminateMembersPct = function (_v0) {
	var record = _v0;
	return record.al$;
};
var $author$project$Api$Provider$UploadSetting$One$useUploadCreationDateAsEnrollmentDate = function (_v0) {
	var record = _v0;
	return record.amk;
};
var $author$project$Pages$Companies$CompanyId_String$Eas$uploadSettingFormFieldsFromUploadSetting = function (uploadSetting) {
	return {
		aeL: $author$project$Api$Provider$UploadSetting$One$adoptCompanies(uploadSetting),
		ae3: $elm$core$Maybe$Just(
			$author$project$Api$Provider$UploadSetting$One$autoProcessTimer(uploadSetting)),
		af_: $author$project$Api$Provider$UploadSetting$One$createChildCompanies(uploadSetting),
		af$: $author$project$Api$Provider$UploadSetting$One$createDivisions(uploadSetting),
		agT: $elm$core$Maybe$Just(
			$author$project$Api$Provider$UploadSetting$One$endDateBuffer(uploadSetting)),
		ahk: $author$project$Api$Provider$UploadSetting$One$fileGrowthThreshold(uploadSetting),
		ahl: $elm$core$Maybe$Just(
			$author$project$Percentage$fromFloat(
				$author$project$Api$Provider$UploadSetting$One$fileGrowthThresholdPct(uploadSetting))),
		ahZ: $author$project$Api$Provider$UploadSetting$One$inheritPlans(uploadSetting),
		aiy: $author$project$Api$Provider$UploadSetting$One$mapUnknownPlanValuesToCompanyDefaultPlan(uploadSetting),
		aiS: $author$project$Api$Provider$UploadSetting$One$nameMatch(uploadSetting),
		akZ: $author$project$Api$Provider$UploadSetting$One$restrictTerminationByOmissionToEmployees(uploadSetting),
		ak_: $author$project$Api$Provider$UploadSetting$One$restrictTerminationByOmissionToFeedPatients(uploadSetting),
		alZ: $author$project$Api$Provider$UploadSetting$One$terminateEligibilityByOmission(uploadSetting),
		al_: $author$project$Api$Provider$UploadSetting$One$terminateMembersByOmission(uploadSetting),
		al$: $elm$core$Maybe$Just(
			$author$project$Percentage$fromFloat(
				$author$project$Api$Provider$UploadSetting$One$terminateMembersPct(uploadSetting))),
		amk: $author$project$Api$Provider$UploadSetting$One$useUploadCreationDateAsEnrollmentDate(uploadSetting)
	};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$uploadSettingFormFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var bool = field.a;
				return _Utils_update(
					fields,
					{aeL: bool});
			case 2:
				var bool = field.a;
				return _Utils_update(
					fields,
					{af_: bool});
			case 3:
				var bool = field.a;
				return _Utils_update(
					fields,
					{af$: bool});
			case 4:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						agT: $elm$core$String$toInt(string)
					});
			case 7:
				var bool = field.a;
				return _Utils_update(
					fields,
					{ahZ: bool});
			case 9:
				var bool = field.a;
				return _Utils_update(
					fields,
					{aiS: bool});
			case 12:
				var bool = field.a;
				return _Utils_update(
					fields,
					{al_: bool});
			case 13:
				var bool = field.a;
				return _Utils_update(
					fields,
					{alZ: bool});
			case 11:
				var bool = field.a;
				return _Utils_update(
					fields,
					{ak_: bool});
			case 10:
				var bool = field.a;
				return _Utils_update(
					fields,
					{akZ: bool});
			case 5:
				var bool = field.a;
				return _Utils_update(
					fields,
					{ahk: bool});
			case 8:
				var bool = field.a;
				return _Utils_update(
					fields,
					{aiy: bool});
			case 14:
				var _float = field.a;
				return _Utils_update(
					fields,
					{al$: _float});
			case 6:
				var _float = field.a;
				return _Utils_update(
					fields,
					{ahl: _float});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						ae3: $elm$core$String$toInt(string)
					});
			default:
				var bool = field.a;
				return _Utils_update(
					fields,
					{amk: bool});
		}
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$EndDateBufferValidation = 1;
var $author$project$Pages$Companies$CompanyId_String$Eas$FileGrowthThresholdPctValidation = 2;
var $author$project$Pages$Companies$CompanyId_String$Eas$TerminateMembersPctValidation = 3;
var $author$project$Pages$Companies$CompanyId_String$Eas$validatePercentage = F3(
	function (getter, validationGroup, fields) {
		var _v0 = getter(fields);
		if (!_v0.$) {
			var percentage = _v0.a;
			return A2(
				$author$project$Percentage$isValid,
				{AU: $elm$core$Maybe$Nothing, W9: $elm$core$Maybe$Nothing},
				percentage) ? _List_Nil : _List_fromArray(
				[
					_Utils_Tuple2(validationGroup, 'Please enter a valid percentage.')
				]);
		} else {
			return _List_fromArray(
				[
					_Utils_Tuple2(validationGroup, 'Please enter a valid percentage.')
				]);
		}
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$validatePositive = F3(
	function (getter, validationGroup, fields) {
		var _v0 = getter(fields);
		if (!_v0.$) {
			var integer = _v0.a;
			return (integer >= 0) ? _List_Nil : _List_fromArray(
				[
					_Utils_Tuple2(validationGroup, 'Please enter a valid number.')
				]);
		} else {
			return _List_fromArray(
				[
					_Utils_Tuple2(validationGroup, 'Please enter a valid number.')
				]);
		}
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$uploadSettingFormFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors(
			A2(
				$author$project$Pages$Companies$CompanyId_String$Eas$validatePercentage,
				function ($) {
					return $.al$;
				},
				3)),
			$rtfeldman$elm_validate$Validate$fromErrors(
			A2(
				$author$project$Pages$Companies$CompanyId_String$Eas$validatePercentage,
				function ($) {
					return $.ahl;
				},
				2)),
			$rtfeldman$elm_validate$Validate$fromErrors(
			A2(
				$author$project$Pages$Companies$CompanyId_String$Eas$validatePositive,
				function ($) {
					return $.agT;
				},
				1))
		]));
var $author$project$Pages$Companies$CompanyId_String$Eas$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var feedEnroller = response.a;
					var form = A2(
						$elm$core$Maybe$map,
						function (feedEnroller_) {
							return _Utils_Tuple2(
								$author$project$Api$FeedEnroller$id(feedEnroller_),
								$author$project$Utils$Form$init(
									$author$project$Pages$Companies$CompanyId_String$Eas$feedEnrollerFormFieldsFromFeedEnroller(feedEnroller_)));
						},
						feedEnroller);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jL: response, ev: form}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jL: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var response = msg.a;
				_v2$2:
				while (true) {
					switch (response.$) {
						case 3:
							var uploadSetting = response.a;
							var form = $author$project$Utils$Form$init(
								$author$project$Pages$Companies$CompanyId_String$Eas$uploadSettingFormFieldsFromUploadSetting(uploadSetting));
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										lZ: response,
										ce: $elm$core$Maybe$Just(
											_Utils_Tuple2(form, $author$project$Api$Data$NotAsked))
									}),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
						case 2:
							if (response.a.$ === 5) {
								var _v3 = response.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{lZ: response}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							} else {
								break _v2$2;
							}
						default:
							break _v2$2;
					}
				}
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{lZ: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 2:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{lX: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$reportDecodeError(response));
			case 3:
				var field = msg.a;
				var _v4 = model.ev;
				if (!_v4.$) {
					var _v5 = _v4.a;
					var id = _v5.a;
					var form = _v5.b;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Companies$CompanyId_String$Eas$feedEnrollerFormFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ev: $elm$core$Maybe$Just(
									_Utils_Tuple2(id, newForm))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ew: $author$project$Api$Data$Loading}),
					A5(
						$author$project$Api$FeedEnroller$create,
						model.Gv,
						model.aa4,
						$author$project$Api$Company$id(model.afQ),
						{alz: model.age},
						$author$project$Pages$Companies$CompanyId_String$Eas$FeedEnrollerCreated),
					_List_Nil);
			case 5:
				var _v6 = model.ev;
				if (!_v6.$) {
					var _v7 = _v6.a;
					var id = _v7.a;
					var form = _v7.b;
					var _v8 = A2($author$project$Utils$Form$validate, $author$project$Pages$Companies$CompanyId_String$Eas$feedEnrollerFormFieldsValidator, form);
					if (!_v8.$) {
						var _v9 = _v8.a;
						var newForm = _v9.a;
						var validFormFields = _v9.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ev: $elm$core$Maybe$Just(
										_Utils_Tuple2(id, newForm)),
									ew: $author$project$Api$Data$Loading
								}),
							A5($author$project$Pages$Companies$CompanyId_String$Eas$updateFeedEnroller, model.Gv, model.aa4, model.afQ, id, validFormFields),
							_List_Nil);
					} else {
						var newForm = _v8.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ev: $elm$core$Maybe$Just(
										_Utils_Tuple2(id, newForm))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var response = msg.a;
				if (response.$ === 3) {
					var companyId = $author$project$Api$Company$id(model.afQ);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jL: $author$project$Api$Data$Loading, ew: response, lX: $author$project$Api$Data$Loading, lZ: $author$project$Api$Data$Loading}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Pages$Companies$CompanyId_String$Eas$fetchUploadHeaders(model),
									A4($author$project$Api$FeedEnroller$retrieve, model.Gv, model.aa4, companyId, $author$project$Pages$Companies$CompanyId_String$Eas$GotFeedEnroller),
									A3($author$project$Api$Provider$Company$UploadSetting$retrieve, model.Gv, companyId, $author$project$Pages$Companies$CompanyId_String$Eas$GotUploadSetting)
								])),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'SFTP Server created.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ew: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 7:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ew: response}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'SFTP Server updated.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ew: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 8:
				var id = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ee: $elm$core$Maybe$Just(
								_Utils_Tuple2(id, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 9:
				var id = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ee: $elm$core$Maybe$Just(
								_Utils_Tuple2(id, $author$project$Api$Data$Loading))
						}),
					A5(
						$author$project$Api$FeedEnroller$delete,
						model.Gv,
						model.aa4,
						$author$project$Api$Company$id(model.afQ),
						id,
						$author$project$Pages$Companies$CompanyId_String$Eas$FeedEnrollerDeleted(id)),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{ee: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 10:
				var id = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ee: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'SFTP server is being removed.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ee: $elm$core$Maybe$Just(
									_Utils_Tuple2(id, response))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 11:
				var field = msg.a;
				var _v13 = model.ce;
				if (!_v13.$) {
					var _v14 = _v13.a;
					var form = _v14.a;
					var saveRequest = _v14.b;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Companies$CompanyId_String$Eas$uploadSettingFormFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ce: $elm$core$Maybe$Just(
									_Utils_Tuple2(newForm, saveRequest))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 12:
				var _v15 = model.ce;
				if (!_v15.$) {
					var _v16 = _v15.a;
					var form = _v16.a;
					var _v17 = A2($author$project$Utils$Form$validate, $author$project$Pages$Companies$CompanyId_String$Eas$uploadSettingFormFieldsValidator, form);
					if (!_v17.$) {
						var _v18 = _v17.a;
						var newForm = _v18.a;
						var validFormFields = _v18.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ce: $elm$core$Maybe$Just(
										_Utils_Tuple2(newForm, $author$project$Api$Data$Loading))
								}),
							A3($author$project$Pages$Companies$CompanyId_String$Eas$updateUploadSetting, model.Gv, model.afQ, validFormFields),
							_List_Nil);
					} else {
						var newForm = _v17.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ce: $elm$core$Maybe$Just(
										_Utils_Tuple2(newForm, $author$project$Api$Data$NotAsked))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 13:
				var response = msg.a;
				var _v19 = model.ce;
				if (!_v19.$) {
					var _v20 = _v19.a;
					var form = _v20.a;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ce: $elm$core$Maybe$Just(
										_Utils_Tuple2(form, response))
								}),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Upload settings updated.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ce: $elm$core$Maybe$Just(
										_Utils_Tuple2(form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 14:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ao: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init($author$project$Pages$Companies$CompanyId_String$Eas$uploadHeaderFormFieldsInit),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 15:
				var uploadHeader = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ao: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(
										$author$project$Api$Provider$UploadHeader$All$id(uploadHeader)),
									$author$project$Utils$Form$init(
										$author$project$Pages$Companies$CompanyId_String$Eas$uploadHeaderFormFieldsFromUploadHeader(uploadHeader)),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 16:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ao: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 17:
				var field = msg.a;
				var _v22 = model.ao;
				if (!_v22.$) {
					var _v23 = _v22.a;
					var id = _v23.a;
					var form = _v23.b;
					var uploadHeader = _v23.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Companies$CompanyId_String$Eas$uploadHeaderFormFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ao: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, uploadHeader))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 18:
				var form = msg.a;
				var id = msg.b;
				var _v24 = A2($author$project$Utils$Form$validate, $author$project$Pages$Companies$CompanyId_String$Eas$uploadHeaderFormFieldsValidator, form);
				if (!_v24.$) {
					var _v25 = _v24.a;
					var newForm = _v25.a;
					var validFormFields = _v25.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ao: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, $author$project$Api$Data$Loading))
							}),
						A4($author$project$Pages$Companies$CompanyId_String$Eas$saveUploadHeader, model.Gv, id, model.afQ, validFormFields),
						_List_Nil);
				} else {
					var newForm = _v24.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ao: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 19:
				var response = msg.a;
				var _v26 = model.ao;
				if (!_v26.$) {
					var _v27 = _v26.a;
					var id = _v27.a;
					var form = _v27.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{ao: $elm$core$Maybe$Nothing, lX: $author$project$Api$Data$Loading}),
							$author$project$Pages$Companies$CompanyId_String$Eas$fetchUploadHeaders(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Upload header created.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ao: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var response = msg.a;
				var _v29 = model.ao;
				if (!_v29.$) {
					var _v30 = _v29.a;
					var id = _v30.a;
					var form = _v30.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{ao: $elm$core$Maybe$Nothing, lX: $author$project$Api$Data$Loading}),
							$author$project$Pages$Companies$CompanyId_String$Eas$fetchUploadHeaders(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Upload settings updated.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ao: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Layouts$Company$Uploads$companyIsChild = function (company) {
	return $author$project$Api$Company$companyType(company) === 1;
};
var $author$project$Api$Employer$Company$Min$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Company$Min$id = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$Min$id(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$Min$id(company_);
	}
};
var $author$project$Api$Employer$Company$Min$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Company$Min$name = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$Min$name(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$Min$name(company_);
	}
};
var $author$project$Api$Company$Min$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Company$Min$fromEmployer = $author$project$Api$Company$Min$Employer;
var $author$project$Api$Company$Min$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Company$Min$fromProvider = $author$project$Api$Company$Min$Provider;
var $author$project$Api$Employer$Company$One$parent = function (_v0) {
	var record = _v0.b;
	return record.YM;
};
var $author$project$Api$Provider$Company$One$parent = function (_v0) {
	var record = _v0.b;
	return record.YM;
};
var $author$project$Api$Company$parent = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Company$Min$fromProvider,
			$author$project$Api$Provider$Company$One$parent(company_));
	} else {
		var company_ = company.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Company$Min$fromEmployer,
			$author$project$Api$Employer$Company$One$parent(company_));
	}
};
var $author$project$Layouts$Company$Uploads$companyIsParent = function (company) {
	return $author$project$Api$Company$companyType(company) === 2;
};
var $author$project$Layouts$Company$Uploads$companyIsStandalone = function (company) {
	return $author$project$Api$Company$companyType(company) === 3;
};
var $author$project$Layouts$Company$Uploads$betaPageMessage = F2(
	function (feedEnroller, company) {
		return ($author$project$Utils$Maybe$toBool(feedEnroller) || $author$project$Layouts$Company$Uploads$companyIsParent(company)) ? 'This company is on an AutoSync. Any questions/concerns? Reach out to autosync@hint.com today!' : ($author$project$Layouts$Company$Uploads$companyIsStandalone(company) ? 'Interested in automating and unlocking more advanced features and support for your employee uploads? Reach out to support@hint.com today!' : '');
	});
var $author$project$Layouts$Company$Uploads$viewBetaPagePopover = F2(
	function (feedEnroller, company) {
		var betaPageMessage_ = function () {
			if (feedEnroller.$ === 3) {
				var feedEnroller_ = feedEnroller.a;
				return A2($author$project$Layouts$Company$Uploads$betaPageMessage, feedEnroller_, company);
			} else {
				return '';
			}
		}();
		return A3(
			$author$project$Ui$Tooltip$view,
			_List_fromArray(
				[$author$project$Ui$Tooltip$wide]),
			betaPageMessage_,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$span,
					_List_fromArray(
						[$author$project$Ui$Typography$warning]),
					_List_fromArray(
						[
							$author$project$Ui$Icon$alert(_List_Nil)
						]))
				]));
	});
var $author$project$Layouts$Company$Uploads$view = F6(
	function (session, practice, company, feedEnroller, contents, footer) {
		return A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					$elm$core$List$concat(
						_List_fromArray(
							[
								_List_fromArray(
								[
									$author$project$Ui$Typography$headingSm(
									_List_fromArray(
										[
											$elm$html$Html$text('Employee Uploads'),
											$author$project$Utils$Html$noBreakSpace,
											(!$author$project$Layouts$Company$Uploads$companyIsChild(company)) ? A2($author$project$Layouts$Company$Uploads$viewBetaPagePopover, feedEnroller, company) : $author$project$Utils$Html$empty
										])),
									function () {
									var _v0 = $author$project$Api$Company$parent(company);
									if (!_v0.$) {
										var parent = _v0.a;
										return A2(
											$author$project$Ui$Alert$warning,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('This '),
													$elm$html$Html$text(
													A2($author$project$Api$Practice$sponsorize, practice, 'employer')),
													$elm$html$Html$text('\'s eligibility and enrollment information is administered by '),
													$author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$html$Html$text(
													$author$project$Api$Company$Min$name(parent)) : A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__Top(
														{
															fZ: $author$project$Api$Company$Min$id(parent)
														}),
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Api$Company$Min$name(parent))
														])),
													$elm$html$Html$text(' please go to their account to view '),
													$elm$html$Html$text(
													A2($author$project$Api$Practice$sponsorize, practice, 'employee')),
													$elm$html$Html$text(' upload files.')
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								]),
								contents
							]))),
					$elm$core$List$isEmpty(footer) ? $author$project$Ui$Panel$none : A2($author$project$Ui$Panel$footer, _List_Nil, footer)
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$ContactEmail = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$ContactName = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$CreateFeedEnroller = {$: 4};
var $author$project$Pages$Companies$CompanyId_String$Eas$DeleteFeedEnroller = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$Enabled = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$FeedEnrollerFormUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$FileMatch = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$PublicSshKey = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$SaveFeedEnroller = {$: 5};
var $author$project$Pages$Companies$CompanyId_String$Eas$viewFeedEnroller = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Typography$headingSm(
				_List_fromArray(
					[
						$elm$html$Html$text('SFTP Server')
					])),
				function () {
				var _v0 = model.jL;
				if (_v0.$ === 3) {
					var _v1 = model.ev;
					if (!_v1.$) {
						var _v2 = _v1.a;
						var form = _v2.b;
						var fields = $author$project$Utils$Form$fields(form);
						return A2(
							$author$project$Ui$Form$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$onSubmit($author$project$Pages$Companies$CompanyId_String$Eas$SaveFeedEnroller),
									$author$project$Ui$Form$noValidate(true),
									$author$project$Ui$Form$autocomplete(false)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$labelSpanSm(2),
											$author$project$Ui$Form$Group$inputSpan(10),
											$author$project$Ui$Form$Group$label('SSH Key')
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$Textarea$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$Textarea$value(
													A2($elm$core$Maybe$withDefault, '', fields._H)),
													$author$project$Ui$Form$Textarea$onInput(
													A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Eas$FeedEnrollerFormUpdated, $author$project$Pages$Companies$CompanyId_String$Eas$PublicSshKey)),
													$author$project$Ui$Form$Textarea$placeholder('Begins with \'ssh-rsa\', \'ssh-dss\', \'ssh-ed25519\', \'ecdsa-sha2-nistp256\', \'ecdsa-sha2-nistp384\', or \'ecdsa-sha2-nistp521\''),
													$author$project$Ui$Form$Textarea$disabled(model.age)
												]))
										])),
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$labelSpanSm(2),
											$author$project$Ui$Form$Group$inputSpan(10),
											$author$project$Ui$Form$Group$label('File Regex Match'),
											$author$project$Ui$Form$Group$required(true)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$value(fields.Sm),
													$author$project$Ui$Form$Input$onInput(
													A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Eas$FeedEnrollerFormUpdated, $author$project$Pages$Companies$CompanyId_String$Eas$FileMatch)),
													$author$project$Ui$Form$Input$placeholder('Regular Expression to match files'),
													$author$project$Ui$Form$Input$disabled(model.age),
													$author$project$Ui$Form$Input$invalid(
													A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
													$author$project$Ui$Form$Input$errors(
													A2($author$project$Utils$Form$validationErrors, 0, form))
												]))
										])),
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$labelSpanSm(2),
											$author$project$Ui$Form$Group$inputSpan(10),
											$author$project$Ui$Form$Group$label('SFTP Server Address:Port')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(fields.aaZ),
													$elm$html$Html$text(':22')
												]))
										])),
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$labelSpanSm(2),
											$author$project$Ui$Form$Group$inputSpan(10),
											$author$project$Ui$Form$Group$label('Path')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(fields.YX)
												]))
										])),
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$labelSpanSm(2),
											$author$project$Ui$Form$Group$inputSpan(10),
											$author$project$Ui$Form$Group$label('Username')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(fields.ad1)
												]))
										])),
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$labelSpanSm(2),
											$author$project$Ui$Form$Group$inputSpan(10),
											$author$project$Ui$Form$Group$label('Autoprocess')
										]),
									_List_fromArray(
										[
											$author$project$Ui$ToggleSwitch$view(
											_List_fromArray(
												[
													$author$project$Ui$ToggleSwitch$on(fields.Ro),
													$author$project$Ui$ToggleSwitch$onChange(
													A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Eas$FeedEnrollerFormUpdated, $author$project$Pages$Companies$CompanyId_String$Eas$Enabled))
												]))
										])),
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$labelSpanSm(2),
											$author$project$Ui$Form$Group$inputSpan(3),
											$author$project$Ui$Form$Group$label('Contact name')
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$value(
													A2($elm$core$Maybe$withDefault, '', fields.Ox)),
													$author$project$Ui$Form$Input$onInput(
													A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Eas$FeedEnrollerFormUpdated, $author$project$Pages$Companies$CompanyId_String$Eas$ContactName))
												]))
										])),
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$labelSpanSm(2),
											$author$project$Ui$Form$Group$inputSpan(3),
											$author$project$Ui$Form$Group$label('Contact email')
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$value(
													A2($elm$core$Maybe$withDefault, '', fields.Ow)),
													$author$project$Ui$Form$Input$onInput(
													A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Eas$FeedEnrollerFormUpdated, $author$project$Pages$Companies$CompanyId_String$Eas$ContactEmail))
												]))
										])),
									model.Ij ? A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textCenter, $author$project$Ui$Element$mt4]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$HinterOnly$button,
											{mm: 'Update SFTP server'},
											_List_fromArray(
												[$author$project$Ui$Button$primary, $author$project$Ui$Button$submit]),
											_List_fromArray(
												[
													$elm$html$Html$text('Update')
												])),
											A3(
											$author$project$Ui$HinterOnly$button,
											{mm: 'Remove SFTP server'},
											_List_fromArray(
												[
													$author$project$Ui$Button$danger,
													$author$project$Ui$Button$onClick(
													$author$project$Pages$Companies$CompanyId_String$Eas$DeleteFeedEnroller(fields.ahP))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Remove SFTP Server')
												]))
										])) : $author$project$Utils$Html$empty
								]));
					} else {
						return model.Ij ? A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$justifyCenter]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$HinterOnly$button,
									{mm: 'Create SFTP Server'},
									_List_fromArray(
										[
											$author$project$Ui$Button$primary,
											$author$project$Ui$Button$onClick($author$project$Pages$Companies$CompanyId_String$Eas$CreateFeedEnroller),
											$author$project$Ui$Button$loading(
											_Utils_eq(model.ew, $author$project$Api$Data$Loading))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Create SFTP Server')
										]))
								])) : $author$project$Utils$Html$empty;
					}
				} else {
					return A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$justifyCenter]),
						_List_fromArray(
							[
								$author$project$Ui$Spinner$view(_List_Nil)
							]));
				}
			}()
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Eas$ColumnName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$Ignored = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$Required = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$SaveUploadHeader = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$UploadHeaderFormUpdated = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$viewModal = F3(
	function (id, form, uploadHeader) {
		var modalConfig = {
			Tq: $elm$core$Maybe$Nothing,
			aih: 'Upload Header',
			V8: _Utils_eq(uploadHeader, $author$project$Api$Data$Loading),
			WG: id,
			WH: $elm$core$Maybe$Nothing,
			Yd: $author$project$Pages$Companies$CompanyId_String$Eas$CancelUploadHeaderEdit,
			Yf: $author$project$Pages$Companies$CompanyId_String$Eas$SaveUploadHeader(form)
		};
		var fields = $author$project$Utils$Form$fields(form);
		var hasDestination = !$elm$core$String$isEmpty(fields.Qt);
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Column Name'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(fields.N2),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Eas$UploadHeaderFormUpdated, $author$project$Pages$Companies$CompanyId_String$Eas$ColumnName)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 0, form))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Destination')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									hasDestination ? $elm$html$Html$text(
									$author$project$Formatters$String$titleize(fields.Qt)) : $elm$html$Html$text('N/A')
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Required')
						]),
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$view(
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$on(fields.akR),
									$author$project$Ui$ToggleSwitch$onChange(
									A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Eas$UploadHeaderFormUpdated, $author$project$Pages$Companies$CompanyId_String$Eas$Required)),
									$author$project$Ui$ToggleSwitch$disabled(
									(!$author$project$Utils$Maybe$toBool(id)) || (!hasDestination))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Ignored')
						]),
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$view(
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$on(fields.ahS),
									$author$project$Ui$ToggleSwitch$onChange(
									A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Eas$UploadHeaderFormUpdated, $author$project$Pages$Companies$CompanyId_String$Eas$Ignored)),
									$author$project$Ui$ToggleSwitch$disabled(
									(!$author$project$Utils$Maybe$toBool(id)) || (!hasDestination))
								]))
						]))
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$NewUploadHeader = {$: 14};
var $author$project$Pages$Companies$CompanyId_String$Eas$EditUploadHeader = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$viewuUploadHeader = function (uploadHeader) {
	return A2(
		$author$project$Ui$Table$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Provider$UploadHeader$All$columnName(uploadHeader))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Formatters$String$titleize(
							$author$project$Api$Provider$UploadHeader$All$destination(uploadHeader)))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Formatters$Bool$toString(
							$author$project$Api$Provider$UploadHeader$All$required(uploadHeader)))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Formatters$Bool$toString(
							$author$project$Api$Provider$UploadHeader$All$ignored(uploadHeader)))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_fromArray(
					[$author$project$Ui$Table$textRight]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Edit upload header'},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$sm,
								$author$project$Ui$Button$onClick(
								$author$project$Pages$Companies$CompanyId_String$Eas$EditUploadHeader(uploadHeader)),
								$author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Edit')
							]))
					]))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Eas$viewUploadHeaders = function (model) {
	var _v0 = function () {
		var _v1 = model.lX;
		if (_v1.$ === 3) {
			var uploadHeaders_ = _v1.a;
			return _Utils_Tuple2(
				false,
				A2($elm$core$List$sortBy, $author$project$Api$Provider$UploadHeader$All$destination, uploadHeaders_));
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var uploadHeaders = _v0.b;
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mt2]),
				_List_fromArray(
					[
						$author$project$Ui$Typography$headingSm(
						_List_fromArray(
							[
								$elm$html$Html$text('Upload Headers')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'New upload header'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$onClick($author$project$Pages$Companies$CompanyId_String$Eas$NewUploadHeader),
								$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('New Upload Header')
							]))
					])),
				A2($elm$html$Html$br, _List_Nil, _List_Nil),
				A4(
				$author$project$Ui$Table$view,
				_List_fromArray(
					[
						$author$project$Ui$Table$verticalCentered,
						$author$project$Ui$Table$zeroState(
						_List_fromArray(
							[
								$elm$html$Html$text('None')
							])),
						$author$project$Ui$Table$loading(loading)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[
								$author$project$Ui$Table$cellSpan(2)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Column name')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[
								$author$project$Ui$Table$cellSpan(2)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Destination')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[
								$author$project$Ui$Table$cellSpan(2)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Required')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[
								$author$project$Ui$Table$cellSpan(2)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Ignored')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[
								$author$project$Ui$Table$cellSpan(2)
							]),
						_List_Nil)
					]),
				A2($elm$core$List$map, $author$project$Pages$Companies$CompanyId_String$Eas$viewuUploadHeader, uploadHeaders),
				_List_Nil)
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Eas$AdoptCompanies = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$AutoProcessTimer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$AutoProcessTimerValidation = 0;
var $author$project$Pages$Companies$CompanyId_String$Eas$CreateChildCompanies = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$CreateDivisions = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$EndDateBuffer = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$FileGrowthThreshold = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$FileGrowthThresholdPct = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$InheritPlans = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$MapUnknownPlanValuesToCompanyDefaultPlan = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$NameMatch = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$RestrictTerminationByOmissionToEmployees = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$RestrictTerminationByOmissionToFeedPatients = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$SaveUploadSetting = {$: 12};
var $author$project$Pages$Companies$CompanyId_String$Eas$TerminateEligibilityByOmission = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$TerminateMembersByOmission = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$TerminateMembersPct = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$UseUploadCreationDateAsEnrollmentDate = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$UploadSettingFormUpdated = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingBoolField = F4(
	function (title, description, value, field) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(7),
					$author$project$Ui$Form$Group$inputSpan(4),
					$author$project$Ui$Form$Group$label(title),
					$author$project$Ui$Form$Group$labelClass(''),
					$author$project$Ui$Form$Group$labelHelp(
					$elm$html$Html$text(description))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$justifyRight]),
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$view(
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$on(value),
									$author$project$Ui$ToggleSwitch$onChange(
									A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Eas$UploadSettingFormUpdated, field))
								]))
						]))
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingIntField = F8(
	function (title, description, placeholder, value, field, validationGroup, form, fieldLabel) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(7),
					$author$project$Ui$Form$Group$inputSpan(4),
					$author$project$Ui$Form$Group$label(title),
					$author$project$Ui$Form$Group$labelClass(''),
					$author$project$Ui$Form$Group$labelHelp(
					$elm$html$Html$text(description))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$justifyRight]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$group(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(
											A2(
												$elm$core$Maybe$withDefault,
												'',
												A2($elm$core$Maybe$map, $elm$core$String$fromInt, value))),
											$author$project$Ui$Form$Input$onInput(
											A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Eas$UploadSettingFormUpdated, field)),
											$author$project$Ui$Form$Input$number,
											$author$project$Ui$Form$Input$invalid(
											A2($author$project$Utils$Form$hasValidationErrors, validationGroup, form)),
											$author$project$Ui$Form$Input$errors(
											A2($author$project$Utils$Form$validationErrors, validationGroup, form)),
											$author$project$Ui$Form$Input$placeholder(placeholder)
										])),
									$author$project$Ui$Form$Input$addon(
									_List_fromArray(
										[
											$elm$html$Html$text(fieldLabel)
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingPercentageField = F7(
	function (title, description, placeholder, value, field, validationGroup, form) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(7),
					$author$project$Ui$Form$Group$inputSpan(4),
					$author$project$Ui$Form$Group$label(title),
					$author$project$Ui$Form$Group$labelClass(''),
					$author$project$Ui$Form$Group$labelHelp(
					$elm$html$Html$text(description))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$justifyRight]),
					_List_fromArray(
						[
							$author$project$Ui$Form$PercentageInput$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$PercentageInput$value(value),
									$author$project$Ui$Form$PercentageInput$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Eas$UploadSettingFormUpdated, field)),
									$author$project$Ui$Form$PercentageInput$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, validationGroup, form)),
									$author$project$Ui$Form$PercentageInput$errors(
									A2($author$project$Utils$Form$validationErrors, validationGroup, form)),
									$author$project$Ui$Form$PercentageInput$placeholder(placeholder)
								]))
						]))
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSetting = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mt2]),
				_List_fromArray(
					[
						$author$project$Ui$Typography$headingSm(
						_List_fromArray(
							[
								$elm$html$Html$text('Upload Settings')
							]))
					])),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mt4]),
				function () {
					var _v0 = model.ce;
					if (!_v0.$) {
						var _v1 = _v0.a;
						var form = _v1.a;
						var saveRequest = _v1.b;
						var fields = $author$project$Utils$Form$fields(form);
						return _List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(11),
												$author$project$Ui$Grid$offset(1)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$view,
												_List_fromArray(
													[
														$author$project$Ui$Form$onSubmit($author$project$Pages$Companies$CompanyId_String$Eas$SaveUploadSetting),
														$author$project$Ui$Form$noValidate(true),
														$author$project$Ui$Form$autocomplete(false)
													]),
												_List_fromArray(
													[
														A4($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingBoolField, 'Adopt Companies', 'When enabled, any companies that appear in the file that we were able to match by Name to an existing company, will automatically be adopted as a Child Company.', fields.aeL, $author$project$Pages$Companies$CompanyId_String$Eas$AdoptCompanies),
														A4($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingBoolField, 'Create Child Companies', 'When enabled, any new companies that appear in the file that we are unable to match to an existing Company, will be created as a Child Company (and support the same plan as the parent).', fields.af_, $author$project$Pages$Companies$CompanyId_String$Eas$CreateChildCompanies),
														A4($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingBoolField, 'Create Divisions', 'When enabled, any new divisions that appear in the file that we are unable to match to an existing Division will be created as a Division for that Company.', fields.af$, $author$project$Pages$Companies$CompanyId_String$Eas$CreateDivisions),
														A4($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingBoolField, 'Inherit Plans', 'When enabled, any plan names that appear in the file that are not supported by the Child Company but do match a plan supported by the Parent Company, will be adopted by the Child Company. If disabled, then those plans would map to the Company\'s default plan.', fields.ahZ, $author$project$Pages$Companies$CompanyId_String$Eas$InheritPlans),
														A4($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingBoolField, 'Name Match', 'When enabled, system will try to match patients on First Name, Last Name, and DOB when we cannot match based on external_id, nor SSN.', fields.aiS, $author$project$Pages$Companies$CompanyId_String$Eas$NameMatch),
														A4($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingBoolField, 'Terminate Members By Omission', 'When enabled, we will terminate the memberships from the \'Missing Patients\' List as long as it does not exceed the TERMINATE MEMBERS PCT.', fields.al_, $author$project$Pages$Companies$CompanyId_String$Eas$TerminateMembersByOmission),
														A4($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingBoolField, 'Terminate Eligibility By Omission', 'When enabled, we will terminate patients\' eligibility from the \'Missing Patients\' List', fields.alZ, $author$project$Pages$Companies$CompanyId_String$Eas$TerminateEligibilityByOmission),
														A7($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingPercentageField, 'Terminate Members Pct', 'Default 5%. This percent is meant as a validation to ensure the Missing Patients list is not greater than expected. Specifically, when the percent of missing patients (out of total active members) is higher than this threshold, the system will Fail to Terminate and notify users to review the file for accuracy.', '0.01', fields.al$, $author$project$Pages$Companies$CompanyId_String$Eas$TerminateMembersPct, 3, form),
														A8($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingIntField, 'End Date Buffer', 'Default 0. A number of days to add to the end of a membership when that member is terminated', '0', fields.agT, $author$project$Pages$Companies$CompanyId_String$Eas$EndDateBuffer, 1, form, 'days'),
														A4($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingBoolField, 'Restrict Termination By Omission To Feed Patients', 'When enabled, patients will only be terminated by omission if they previously appeared on an employee file (i.e. they have ea File System Import Identifier). When disabled, patients will be terminated by omission, regardless of whether or not they have ever appeared on an employee file.', fields.ak_, $author$project$Pages$Companies$CompanyId_String$Eas$RestrictTerminationByOmissionToFeedPatients),
														A4($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingBoolField, 'Restrict Termination By Omission To Employees', 'When enabled, the system will only check to see if employees are absent from the file. When disabled, the system will check if employees or dependents are absent from the file.', fields.akZ, $author$project$Pages$Companies$CompanyId_String$Eas$RestrictTerminationByOmissionToEmployees),
														A8($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingIntField, 'Auto Process Timer', 'This determines how long the system will hold off on processing a file if there are unmapped data values found. The idea here is that when it is >0, you have time to review the unmapped values and resolve them.', '4000', fields.ae3, $author$project$Pages$Companies$CompanyId_String$Eas$AutoProcessTimer, 0, form, 'min'),
														A4($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingBoolField, 'Review File Size Increases', 'When enabled, a new upload will be paused if it is larger than the previous processed upload by REVIEW FILE SIZE PCT.', fields.ahk, $author$project$Pages$Companies$CompanyId_String$Eas$FileGrowthThreshold),
														A7($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingPercentageField, 'Review File Size Pct', 'Default 50%. When a new upload exceeds the previous completed upload by this threshold, the upload will be paused so the user can verify this increase was intended.', '0.5', fields.ahl, $author$project$Pages$Companies$CompanyId_String$Eas$FileGrowthThresholdPct, 2, form),
														A4($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingBoolField, 'Map Unknown Plan Values To Company Default Plan', 'If enabled, unknown plan values in the file will be mapped to the Company\'s default plan.', fields.aiy, $author$project$Pages$Companies$CompanyId_String$Eas$MapUnknownPlanValuesToCompanyDefaultPlan),
														A4($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingBoolField, 'Enroll By Presence', 'When enabled we will enroll patients that do not have start dates indicated in the file. Their start date will be determined using the company enrollment cutoff date. If a start date is included on any rows, we will use that date', fields.amk, $author$project$Pages$Companies$CompanyId_String$Eas$UseUploadCreationDateAsEnrollmentDate)
													]))
											]))
									])),
								model.Ij ? A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$textCenter]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$HinterOnly$button,
										{mm: 'Update upload settings'},
										_List_fromArray(
											[
												$author$project$Ui$Button$styled(1),
												$author$project$Ui$Button$onClick($author$project$Pages$Companies$CompanyId_String$Eas$SaveUploadSetting),
												$author$project$Ui$Button$loading(
												_Utils_eq(saveRequest, $author$project$Api$Data$Loading))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Update')
											]))
									])) : $author$project$Utils$Html$empty
							]);
					} else {
						return _List_Nil;
					}
				}())
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Eas$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				function () {
				var _v0 = model.ee;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var id = _v1.a;
					var deleteRequest = _v1.b;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Companies$CompanyId_String$Eas$DeleteFeedEnrollerHiConfirmClosed(id),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('delete'),
								$author$project$Components$HiConfirm$noun('sftp server'),
								$author$project$Components$HiConfirm$loading(
								_Utils_eq(deleteRequest, $author$project$Api$Data$Loading))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v2 = model.ao;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var id = _v3.a;
					var form = _v3.b;
					var uploadHeader = _v3.c;
					return A3($author$project$Pages$Companies$CompanyId_String$Eas$viewModal, id, form, uploadHeader);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A6(
				$author$project$Layouts$Company$Uploads$view,
				model.aa4,
				model.ZV,
				model.afQ,
				model.jL,
				_List_fromArray(
					[
						$author$project$Ui$HorizontalRule$view(_List_Nil),
						$author$project$Pages$Companies$CompanyId_String$Eas$viewFeedEnroller(model),
						function () {
						var _v4 = model.lZ;
						switch (_v4.$) {
							case 3:
								return A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSetting(model),
											A2($elm$html$Html$br, _List_Nil, _List_Nil),
											$author$project$Pages$Companies$CompanyId_String$Eas$viewUploadHeaders(model)
										]));
							case 2:
								return $author$project$Utils$Html$empty;
							default:
								return A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mt2]),
									_List_fromArray(
										[
											$author$project$Ui$Spinner$view(_List_Nil)
										]));
						}
					}()
					]),
				_List_Nil)
			]),
		ac9: A2($author$project$Api$Practice$sponsorize, model.ZV, 'Companies') + ' | Upload Settings'
	};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$page = $author$project$Spa$Page$applicationCompanyOrEmployer(
	{ah_: $author$project$Pages$Companies$CompanyId_String$Eas$init, aiq: $author$project$Pages$Companies$CompanyId_String$Eas$load, k8: $author$project$Pages$Companies$CompanyId_String$Eas$save, alO: $author$project$Pages$Companies$CompanyId_String$Eas$subscriptions, adT: $author$project$Pages$Companies$CompanyId_String$Eas$update, amo: $author$project$Pages$Companies$CompanyId_String$Eas$view});
var $author$project$Pages$Companies$CompanyId_String$Employees$Create$FormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Feature$ManuallyDisableElationSync = 3;
var $author$project$Components$Employee$Form$Division = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Employee$Form$EligibilityDate = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Employee$Form$EmployeeForm = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Employee$Form$FieldUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Employee$Form$PatientFormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Employee$Form$Plan = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Employee$Form$Type = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Employee$Form$defaultEmployeeSettings = {$F: false, Ef: true, ad6: false};
var $author$project$Components$Patient$Form$defaultSettings = F3(
	function (currentDate, isNew, isEmployeeForm) {
		return {afg: false, afn: false, dd: currentDate, Tb: false, Th: false, sQ: isEmployeeForm, j1: isNew, aiC: false, W4: $elm$core$Maybe$Nothing, tc: false, Ee: false, akV: false, $G: false, akW: false, $M: false, $N: false, ab6: false, acI: false, al8: false, adt: false, adv: false, F1: false};
	});
var $author$project$Components$Employee$Form$defaultSettings = F3(
	function (currentDate, isNew, employeeSettings) {
		return {
			zp: employeeSettings,
			YY: A3($author$project$Components$Patient$Form$defaultSettings, currentDate, isNew, true)
		};
	});
var $author$project$Components$EmployeeDependentTypeInput$empty = F2(
	function (session, company) {
		return _Utils_Tuple2(
			{afQ: company, gd: $elm$core$Maybe$Nothing, dg: $elm$core$Maybe$Nothing, aa4: session, amg: 'employee'},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Components$EmployeeDivisionInput$GotEmployeeDivisions = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$EmployeeDivisionInput$empty = F3(
	function (session, companyId, apiClient) {
		return _Utils_Tuple2(
			{Gv: apiClient, QO: $elm$core$Maybe$Nothing, zr: $author$project$Api$Data$Loading, akR: false, aa4: session},
			A5(
				$author$project$Api$EmployeeDivision$list,
				apiClient,
				session,
				companyId,
				function (d) {
					return d;
				},
				$author$project$Components$EmployeeDivisionInput$GotEmployeeDivisions));
	});
var $author$project$Components$Patient$Form$Address = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Patient$Form$Affiliate = function (a) {
	return {$: 24, a: a};
};
var $author$project$Components$Patient$Form$FieldUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Patient$Form$HealthInsurance = function (a) {
	return {$: 22, a: a};
};
var $author$project$Components$Patient$Form$JoinedPractice = function (a) {
	return {$: 20, a: a};
};
var $author$project$Components$Patient$Form$KnownPractice = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Patient$Form$LeadSource = function (a) {
	return {$: 21, a: a};
};
var $author$project$Components$Patient$Form$Location = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Patient$Form$PatientForm = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Practitioner$PracticeExtras = 1;
var $author$project$Components$Patient$Form$Practitioner = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$Patient$Form$affiliateOptionals = F2(
	function (practitioner, location) {
		return function (d) {
			return _Utils_update(
				d,
				{ais: location, aka: practitioner});
		};
	});
var $author$project$Api$Employer$Company$One$defaultAffiliation = function (_v0) {
	var record = _v0.b;
	return record.PY;
};
var $author$project$Api$Provider$Company$One$defaultAffiliation = function (_v0) {
	var record = _v0.b;
	return record.PY;
};
var $author$project$Api$Company$defaultAffiliation = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Affiliate$AffiliateMin$Provider,
			$author$project$Api$Provider$Company$One$defaultAffiliation(company_));
	} else {
		var company_ = company.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Affiliate$AffiliateMin$Employer,
			$author$project$Api$Employer$Company$One$defaultAffiliation(company_));
	}
};
var $author$project$Api$Location$Shared$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Employer$Company$One$defaultLocation = function (_v0) {
	var record = _v0.b;
	return record.P$;
};
var $author$project$Api$Provider$Company$One$defaultLocation = function (_v0) {
	var record = _v0.b;
	return record.P$;
};
var $author$project$Api$Company$defaultLocation = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Location$Shared$Provider,
			$author$project$Api$Provider$Company$One$defaultLocation(company_));
	} else {
		var company_ = company.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Location$Shared$Employer,
			$author$project$Api$Employer$Company$One$defaultLocation(company_));
	}
};
var $author$project$Api$Practitioner$Shared$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Employer$Company$One$defaultPractitioner = function (_v0) {
	var record = _v0.b;
	return record.Qa;
};
var $author$project$Api$Provider$Company$One$defaultPractitioner = function (_v0) {
	var record = _v0.b;
	return record.Qa;
};
var $author$project$Api$Company$defaultPractitioner = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Practitioner$Shared$Provider,
			$author$project$Api$Provider$Company$One$defaultPractitioner(company_));
	} else {
		var company_ = company.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Practitioner$Shared$Employer,
			$author$project$Api$Employer$Company$One$defaultPractitioner(company_));
	}
};
var $author$project$Components$AffiliateInput$FilterMsg = $elm$core$Basics$identity;
var $author$project$Components$ResourceFilter$Affiliate$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Api$Affiliate$All$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Affiliate$All$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$Affiliate$affiliatesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['affiliates']),
	$author$project$Api$Data$employerPath);
var $author$project$Api$Employer$Affiliate$All$Affiliate = $elm$core$Basics$identity;
var $author$project$Api$Employer$Affiliate$Shared$Affiliate = $elm$core$Basics$identity;
var $author$project$Api$Employer$Affiliate$Shared$Record = F2(
	function (id, name) {
		return {ahP: id, Bq: name};
	});
var $author$project$Api$Employer$Affiliate$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$Affiliate$Shared$Record)));
var $author$project$Api$Employer$Affiliate$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Affiliate$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Affiliate$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Affiliate$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Affiliate$listDefaults = {
	ahP: $elm$core$Maybe$Nothing,
	ais: $elm$core$Maybe$Nothing,
	ajJ: $author$project$Api$Pagination$init,
	aka: $elm$core$Maybe$Nothing,
	akl: $elm$core$Maybe$Nothing,
	alA: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init),
	alH: $elm$core$Maybe$Nothing
};
var $author$project$Api$Employer$Affiliate$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Employer$Affiliate$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.akl;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.ahP;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.alH;
				if (!_v2.$) {
					var string = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'status', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$Employer$Affiliate$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Employer$Affiliate$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Employer$Affiliate$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Employer$Affiliate$affiliatesPath)));
	});
var $author$project$Api$Affiliate$list = F4(
	function (apiClient, session, optionals, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$Affiliate$list,
			apiClient,
			optionals,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$Affiliate$All$Employer)))) : A3(
			$author$project$Api$Provider$Affiliate$list,
			apiClient,
			optionals,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$Affiliate$All$Provider))));
	});
var $author$project$Components$ResourceFilter$Affiliate$list = $author$project$Api$Affiliate$list;
var $author$project$Api$Employer$Affiliate$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Employer$Affiliate$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Affiliate$Shared$id(shared);
};
var $author$project$Api$Affiliate$All$id = function (affiliate) {
	if (!affiliate.$) {
		var affiliate_ = affiliate.a;
		return $author$project$Api$Provider$Affiliate$All$id(affiliate_);
	} else {
		var affiliate_ = affiliate.a;
		return $author$project$Api$Employer$Affiliate$All$id(affiliate_);
	}
};
var $author$project$Api$Employer$Affiliate$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Employer$Affiliate$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Affiliate$Shared$name(shared);
};
var $author$project$Api$Affiliate$All$name = function (affiliate) {
	if (!affiliate.$) {
		var affiliate_ = affiliate.a;
		return $author$project$Api$Provider$Affiliate$All$name(affiliate_);
	} else {
		var affiliate_ = affiliate.a;
		return $author$project$Api$Employer$Affiliate$All$name(affiliate_);
	}
};
var $author$project$Components$ResourceFilter$Affiliate$resourceFromAll = function (affiliate) {
	return {
		ahP: $author$project$Api$Affiliate$All$id(affiliate),
		Bq: $author$project$Api$Affiliate$All$name(affiliate)
	};
};
var $author$project$Components$ResourceFilter$Affiliate$fetchResources = F6(
	function (session, listOptionals, toMsg, apiClient, pagination, query) {
		return A4(
			$author$project$Components$ResourceFilter$Affiliate$list,
			apiClient,
			session,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{ajJ: pagination, akl: query});
				}),
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Components$ResourceFilter$Affiliate$resourceFromAll))));
	});
var $author$project$Components$ResourceFilter$Affiliate$retrieveResource = F5(
	function (session, listOptionals, toMsg, apiClient, id) {
		return A4(
			$author$project$Components$ResourceFilter$Affiliate$list,
			apiClient,
			session,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{
							ahP: $elm$core$Maybe$Just(id)
						});
				}),
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Components$ResourceFilter$Affiliate$resourceFromAll))));
	});
var $author$project$Components$ResourceFilter$Affiliate$selectId = 'affiliates';
var $author$project$Components$ResourceFilter$Affiliate$toTitle = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.Bq;
	},
	$elm$core$Maybe$withDefault('N/A'));
var $author$project$Components$ResourceFilter$Affiliate$toLabel = function (resource) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Components$ResourceFilter$Affiliate$toTitle(resource))
		]);
};
var $author$project$Components$ResourceFilter$Affiliate$toValue = function ($) {
	return $.ahP;
};
var $author$project$Components$ResourceFilter$Affiliate$init = F4(
	function (apiClient, session, listOptionals, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{
				Sk: A2($author$project$Components$ResourceFilter$Affiliate$fetchResources, session, listOptionals),
				ahP: $author$project$Components$ResourceFilter$Affiliate$selectId,
				k$: 'Affiliate',
				uk: A2($author$project$Components$ResourceFilter$Affiliate$retrieveResource, session, listOptionals),
				u9: $author$project$Components$ResourceFilter$Affiliate$toLabel,
				lN: $author$project$Components$ResourceFilter$Affiliate$toTitle,
				hX: $author$project$Components$ResourceFilter$Affiliate$toValue
			},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{Jy: $author$project$Components$ResourceFilter$All, b8: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$AffiliateInput$empty = F3(
	function (apiClient, session, listOptionals) {
		var _v0 = A4(
			$author$project$Components$ResourceFilter$Affiliate$init,
			apiClient,
			session,
			listOptionals,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Unassigned', ai5: false});
			});
		var filter = _v0.a;
		var filterCmd = _v0.b;
		return _Utils_Tuple2(
			{HM: filter, aee: $elm$core$Maybe$Nothing},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, filterCmd));
	});
var $author$project$Components$HealthInsuranceInput$FilterMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$HealthInsuranceInput$Model = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Components$ResourceFilter$InsuranceCarrierAlias$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Api$InsuranceCarrierAlias$All$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$InsuranceCarrierAlias$All$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$InsuranceCarrierAlias$All$InsuranceCarrierAlias = $elm$core$Basics$identity;
var $author$project$Api$Employer$InsuranceCarrierAlias$One$InsuranceCarrierAlias = $elm$core$Basics$identity;
var $author$project$Api$Employer$InsuranceCarrierAlias$One$Record = F2(
	function (name, carrier) {
		return {Np: carrier, Bq: name};
	});
var $author$project$Api$Employer$HealthInsuranceCarrier$Shared$HealthInsuranceCarrier = $elm$core$Basics$identity;
var $author$project$Api$Employer$HealthInsuranceCarrier$Shared$Record = F4(
	function (id, collectGroupId, collectHighDeductible, collectMemberId) {
		return {NU: collectGroupId, NV: collectHighDeductible, NY: collectMemberId, ahP: id};
	});
var $author$project$Api$Employer$HealthInsuranceCarrier$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'collect_member_id',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'collect_high_deductible',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'collect_group_id',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Employer$HealthInsuranceCarrier$Shared$Record)))));
var $author$project$Api$Employer$HealthInsuranceCarrier$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$HealthInsuranceCarrier$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$InsuranceCarrierAlias$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'carrier',
	$author$project$Api$Employer$HealthInsuranceCarrier$Shared$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$InsuranceCarrierAlias$One$Record)));
var $author$project$Api$Employer$InsuranceCarrierAlias$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$InsuranceCarrierAlias$One$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$InsuranceCarrierAlias$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$InsuranceCarrierAlias$One$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$InsuranceCarrierAlias$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Employer$InsuranceCarrierAlias$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				optionals,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['health_insurance_carrier_aliases']),
						$author$project$Api$Data$employerPath))));
	});
var $author$project$Api$Provider$InsuranceCarrierAlias$All$InsuranceCarrierAlias = $elm$core$Basics$identity;
var $author$project$Api$Provider$InsuranceCarrierAlias$One$InsuranceCarrierAlias = $elm$core$Basics$identity;
var $author$project$Api$Provider$InsuranceCarrierAlias$One$Record = F2(
	function (name, carrier) {
		return {Np: carrier, Bq: name};
	});
var $author$project$Api$Provider$InsuranceCarrierAlias$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'carrier',
	$author$project$Api$Provider$HealthInsuranceCarrier$Shared$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$InsuranceCarrierAlias$One$Record)));
var $author$project$Api$Provider$InsuranceCarrierAlias$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$InsuranceCarrierAlias$One$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$InsuranceCarrierAlias$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$InsuranceCarrierAlias$One$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$InsuranceCarrierAlias$list = F3(
	function (apiClient, params, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$InsuranceCarrierAlias$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				params,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['health_insurance_carrier_aliases']),
						$author$project$Api$Data$providerPath))));
	});
var $author$project$Api$InsuranceCarrierAlias$defaults = {ahP: $elm$core$Maybe$Nothing, Bq: $elm$core$Maybe$Nothing, ajJ: $author$project$Api$Pagination$init};
var $author$project$Api$InsuranceCarrierAlias$optionalsToParams = function (optionals) {
	var options = optionals($author$project$Api$InsuranceCarrierAlias$defaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.ahP;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.Bq;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'name', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$InsuranceCarrierAlias$list = F4(
	function (apiClient, session, optionals, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$InsuranceCarrierAlias$list,
			apiClient,
			$author$project$Api$InsuranceCarrierAlias$optionalsToParams(optionals),
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$InsuranceCarrierAlias$All$Employer)))) : A3(
			$author$project$Api$Provider$InsuranceCarrierAlias$list,
			apiClient,
			$author$project$Api$InsuranceCarrierAlias$optionalsToParams(optionals),
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$InsuranceCarrierAlias$All$Provider))));
	});
var $author$project$Components$ResourceFilter$InsuranceCarrierAlias$list = $author$project$Api$InsuranceCarrierAlias$list;
var $author$project$Api$HealthInsuranceCarrier$Shared$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$HealthInsuranceCarrier$Shared$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$InsuranceCarrierAlias$One$record = function (_v0) {
	var record_ = _v0;
	return record_;
};
var $author$project$Api$Employer$InsuranceCarrierAlias$One$carrier = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Employer$InsuranceCarrierAlias$One$record,
	function ($) {
		return $.Np;
	});
var $author$project$Api$Employer$InsuranceCarrierAlias$All$one = function (_v0) {
	var one_ = _v0;
	return one_;
};
var $author$project$Api$Employer$InsuranceCarrierAlias$All$carrier = A2($elm$core$Basics$composeR, $author$project$Api$Employer$InsuranceCarrierAlias$All$one, $author$project$Api$Employer$InsuranceCarrierAlias$One$carrier);
var $author$project$Api$Provider$InsuranceCarrierAlias$One$record = function (_v0) {
	var record_ = _v0;
	return record_;
};
var $author$project$Api$Provider$InsuranceCarrierAlias$One$carrier = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$InsuranceCarrierAlias$One$record,
	function ($) {
		return $.Np;
	});
var $author$project$Api$Provider$InsuranceCarrierAlias$All$one = function (_v0) {
	var one_ = _v0;
	return one_;
};
var $author$project$Api$Provider$InsuranceCarrierAlias$All$carrier = A2($elm$core$Basics$composeR, $author$project$Api$Provider$InsuranceCarrierAlias$All$one, $author$project$Api$Provider$InsuranceCarrierAlias$One$carrier);
var $author$project$Api$InsuranceCarrierAlias$All$carrier = function (carrierAlias) {
	if (!carrierAlias.$) {
		var carrierAlias_ = carrierAlias.a;
		return $author$project$Api$HealthInsuranceCarrier$Shared$Provider(
			$author$project$Api$Provider$InsuranceCarrierAlias$All$carrier(carrierAlias_));
	} else {
		var carrierAlias_ = carrierAlias.a;
		return $author$project$Api$HealthInsuranceCarrier$Shared$Employer(
			$author$project$Api$Employer$InsuranceCarrierAlias$All$carrier(carrierAlias_));
	}
};
var $author$project$Api$Employer$HealthInsuranceCarrier$Shared$collectGroupId = function (_v0) {
	var shared = _v0;
	return shared.NU;
};
var $author$project$Api$Provider$HealthInsuranceCarrier$Shared$collectGroupId = function (_v0) {
	var shared = _v0;
	return shared.NU;
};
var $author$project$Api$HealthInsuranceCarrier$Shared$collectGroupId = function (carrier) {
	if (!carrier.$) {
		var carrier_ = carrier.a;
		return $author$project$Api$Provider$HealthInsuranceCarrier$Shared$collectGroupId(carrier_);
	} else {
		var carrier_ = carrier.a;
		return $author$project$Api$Employer$HealthInsuranceCarrier$Shared$collectGroupId(carrier_);
	}
};
var $author$project$Api$Employer$HealthInsuranceCarrier$Shared$collectHighDeductible = function (_v0) {
	var shared = _v0;
	return shared.NV;
};
var $author$project$Api$Provider$HealthInsuranceCarrier$Shared$collectHighDeductible = function (_v0) {
	var shared = _v0;
	return shared.NV;
};
var $author$project$Api$HealthInsuranceCarrier$Shared$collectHighDeductible = function (carrier) {
	if (!carrier.$) {
		var carrier_ = carrier.a;
		return $author$project$Api$Provider$HealthInsuranceCarrier$Shared$collectHighDeductible(carrier_);
	} else {
		var carrier_ = carrier.a;
		return $author$project$Api$Employer$HealthInsuranceCarrier$Shared$collectHighDeductible(carrier_);
	}
};
var $author$project$Api$Employer$HealthInsuranceCarrier$Shared$collectMemberId = function (_v0) {
	var shared = _v0;
	return shared.NY;
};
var $author$project$Api$Provider$HealthInsuranceCarrier$Shared$collectMemberId = function (_v0) {
	var shared = _v0;
	return shared.NY;
};
var $author$project$Api$HealthInsuranceCarrier$Shared$collectMemberId = function (carrier) {
	if (!carrier.$) {
		var carrier_ = carrier.a;
		return $author$project$Api$Provider$HealthInsuranceCarrier$Shared$collectMemberId(carrier_);
	} else {
		var carrier_ = carrier.a;
		return $author$project$Api$Employer$HealthInsuranceCarrier$Shared$collectMemberId(carrier_);
	}
};
var $author$project$Api$Employer$HealthInsuranceCarrier$Shared$id = function (_v0) {
	var shared = _v0;
	return shared.ahP;
};
var $author$project$Api$Provider$HealthInsuranceCarrier$Shared$id = function (_v0) {
	var shared = _v0;
	return shared.ahP;
};
var $author$project$Api$HealthInsuranceCarrier$Shared$id = function (carrier) {
	if (!carrier.$) {
		var carrier_ = carrier.a;
		return $author$project$Api$Provider$HealthInsuranceCarrier$Shared$id(carrier_);
	} else {
		var carrier_ = carrier.a;
		return $author$project$Api$Employer$HealthInsuranceCarrier$Shared$id(carrier_);
	}
};
var $author$project$Api$Employer$InsuranceCarrierAlias$One$name = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Employer$InsuranceCarrierAlias$One$record,
	function ($) {
		return $.Bq;
	});
var $author$project$Api$Employer$InsuranceCarrierAlias$All$name = A2($elm$core$Basics$composeR, $author$project$Api$Employer$InsuranceCarrierAlias$All$one, $author$project$Api$Employer$InsuranceCarrierAlias$One$name);
var $author$project$Api$Provider$InsuranceCarrierAlias$One$name = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$InsuranceCarrierAlias$One$record,
	function ($) {
		return $.Bq;
	});
var $author$project$Api$Provider$InsuranceCarrierAlias$All$name = A2($elm$core$Basics$composeR, $author$project$Api$Provider$InsuranceCarrierAlias$All$one, $author$project$Api$Provider$InsuranceCarrierAlias$One$name);
var $author$project$Api$InsuranceCarrierAlias$All$name = function (carrierAlias) {
	if (!carrierAlias.$) {
		var carrierAlias_ = carrierAlias.a;
		return $author$project$Api$Provider$InsuranceCarrierAlias$All$name(carrierAlias_);
	} else {
		var carrierAlias_ = carrierAlias.a;
		return $author$project$Api$Employer$InsuranceCarrierAlias$All$name(carrierAlias_);
	}
};
var $author$project$Components$ResourceFilter$InsuranceCarrierAlias$resourceFromAll = function (insuranceCarrierAlias) {
	var carrient = $author$project$Api$InsuranceCarrierAlias$All$carrier(insuranceCarrierAlias);
	return {
		GT: $author$project$Api$HealthInsuranceCarrier$Shared$collectGroupId(carrient),
		Nq: $author$project$Api$HealthInsuranceCarrier$Shared$collectHighDeductible(carrient),
		GU: $author$project$Api$HealthInsuranceCarrier$Shared$collectMemberId(carrient),
		GV: $author$project$Api$HealthInsuranceCarrier$Shared$id(carrient),
		Bq: $author$project$Api$InsuranceCarrierAlias$All$name(insuranceCarrierAlias)
	};
};
var $author$project$Components$ResourceFilter$InsuranceCarrierAlias$fetchResources = F5(
	function (session, toMsg, apiClient, pagination, query) {
		return A4(
			$author$project$Components$ResourceFilter$InsuranceCarrierAlias$list,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{Bq: query, ajJ: pagination});
			},
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Components$ResourceFilter$InsuranceCarrierAlias$resourceFromAll))));
	});
var $author$project$Components$ResourceFilter$InsuranceCarrierAlias$retrieveResource = F4(
	function (session, toMsg, apiClient, id) {
		return A4(
			$author$project$Components$ResourceFilter$InsuranceCarrierAlias$list,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{
						ahP: $elm$core$Maybe$Just(id)
					});
			},
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Components$ResourceFilter$InsuranceCarrierAlias$resourceFromAll))));
	});
var $author$project$Components$ResourceFilter$InsuranceCarrierAlias$selectId = 'insurance-carrier-alias';
var $author$project$Components$ResourceFilter$InsuranceCarrierAlias$toTitle = function ($) {
	return $.Bq;
};
var $author$project$Components$ResourceFilter$InsuranceCarrierAlias$toLabel = function (resource) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Components$ResourceFilter$InsuranceCarrierAlias$toTitle(resource))
		]);
};
var $author$project$Components$ResourceFilter$InsuranceCarrierAlias$toValue = function ($) {
	return $.Bq;
};
var $author$project$Components$ResourceFilter$InsuranceCarrierAlias$init = F3(
	function (apiClient, session, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{
				Sk: $author$project$Components$ResourceFilter$InsuranceCarrierAlias$fetchResources(session),
				ahP: $author$project$Components$ResourceFilter$InsuranceCarrierAlias$selectId,
				k$: 'Insurance Carrier',
				uk: $author$project$Components$ResourceFilter$InsuranceCarrierAlias$retrieveResource(session),
				u9: $author$project$Components$ResourceFilter$InsuranceCarrierAlias$toLabel,
				lN: $author$project$Components$ResourceFilter$InsuranceCarrierAlias$toTitle,
				hX: $author$project$Components$ResourceFilter$InsuranceCarrierAlias$toValue
			},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{Jy: $author$project$Components$ResourceFilter$All, b8: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$HealthInsuranceInput$empty = F2(
	function (apiClient, session) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$InsuranceCarrierAlias$init,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Select a health insurance carrier', XY: 'Other (Enter insurance carrier name manually)', ai5: true});
			});
		var insuranceCarrierAliasFilter = _v0.a;
		var insuranceCarrierAliasCmd = _v0.b;
		return _Utils_Tuple2(
			A3(
				$author$project$Components$HealthInsuranceInput$Model,
				insuranceCarrierAliasFilter,
				{ep: false},
				$elm$core$Maybe$Nothing),
			A2($elm$core$Platform$Cmd$map, $author$project$Components$HealthInsuranceInput$FilterMsg, insuranceCarrierAliasCmd));
	});
var $author$project$Components$KnownPracticeInput$FilterMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$KnownPracticeInput$Model = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$ResourceFilter$KnownPractice$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Api$KnownPractice$All$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$KnownPractice$All$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$KnownPractice$All$KnownPractice = $elm$core$Basics$identity;
var $author$project$Api$Employer$KnownPractice$Shared$KnownPractice = $elm$core$Basics$identity;
var $author$project$Api$Employer$KnownPractice$Shared$Record = F2(
	function (id, name) {
		return {ahP: id, Bq: name};
	});
var $author$project$Api$Employer$KnownPractice$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$KnownPractice$Shared$Record)));
var $author$project$Api$Employer$KnownPractice$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$KnownPractice$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$KnownPractice$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$KnownPractice$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$KnownPractice$defaults = {ahP: $elm$core$Maybe$Nothing, Bq: $elm$core$Maybe$Nothing, ajJ: $author$project$Api$Pagination$init};
var $author$project$Api$Employer$KnownPractice$optionalsToParams = function (optionals) {
	var options = optionals($author$project$Api$Employer$KnownPractice$defaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.ahP;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.Bq;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'name', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$Employer$KnownPractice$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Employer$KnownPractice$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Employer$KnownPractice$optionalsToParams(optionals),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['known_practices']),
						$author$project$Api$Data$employerPath))));
	});
var $author$project$Api$Provider$KnownPractice$All$KnownPractice = $elm$core$Basics$identity;
var $author$project$Api$Provider$KnownPractice$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$KnownPractice$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$KnownPractice$defaults = {ahP: $elm$core$Maybe$Nothing, Bq: $elm$core$Maybe$Nothing, ajJ: $author$project$Api$Pagination$init};
var $author$project$Api$Provider$KnownPractice$optionalsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$KnownPractice$defaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.ahP;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.Bq;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'name', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$Provider$KnownPractice$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$KnownPractice$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$KnownPractice$optionalsToParams(optionals),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['known_practices']),
						$author$project$Api$Data$providerPath))));
	});
var $author$project$Api$KnownPractice$list = F4(
	function (apiClient, session, optionals, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$KnownPractice$list,
			apiClient,
			optionals,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$KnownPractice$All$Employer)))) : A3(
			$author$project$Api$Provider$KnownPractice$list,
			apiClient,
			optionals,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$KnownPractice$All$Provider))));
	});
var $author$project$Components$ResourceFilter$KnownPractice$list = $author$project$Api$KnownPractice$list;
var $author$project$Api$Employer$KnownPractice$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Employer$KnownPractice$All$shared = function (_v0) {
	var shared_ = _v0;
	return shared_;
};
var $author$project$Api$Employer$KnownPractice$All$id = A2($elm$core$Basics$composeR, $author$project$Api$Employer$KnownPractice$All$shared, $author$project$Api$Employer$KnownPractice$Shared$id);
var $author$project$Api$Provider$KnownPractice$Shared$record = function (_v0) {
	var record_ = _v0;
	return record_;
};
var $author$project$Api$Provider$KnownPractice$Shared$id = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$KnownPractice$Shared$record,
	function ($) {
		return $.ahP;
	});
var $author$project$Api$Provider$KnownPractice$All$shared = function (_v0) {
	var shared_ = _v0;
	return shared_;
};
var $author$project$Api$Provider$KnownPractice$All$id = A2($elm$core$Basics$composeR, $author$project$Api$Provider$KnownPractice$All$shared, $author$project$Api$Provider$KnownPractice$Shared$id);
var $author$project$Api$KnownPractice$All$id = function (knownPractice) {
	if (!knownPractice.$) {
		var knownPractice_ = knownPractice.a;
		return $author$project$Api$Provider$KnownPractice$All$id(knownPractice_);
	} else {
		var knownPractice_ = knownPractice.a;
		return $author$project$Api$Employer$KnownPractice$All$id(knownPractice_);
	}
};
var $author$project$Api$Employer$KnownPractice$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Employer$KnownPractice$All$name = A2($elm$core$Basics$composeR, $author$project$Api$Employer$KnownPractice$All$shared, $author$project$Api$Employer$KnownPractice$Shared$name);
var $author$project$Api$Provider$KnownPractice$Shared$name = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$KnownPractice$Shared$record,
	function ($) {
		return $.Bq;
	});
var $author$project$Api$Provider$KnownPractice$All$name = A2($elm$core$Basics$composeR, $author$project$Api$Provider$KnownPractice$All$shared, $author$project$Api$Provider$KnownPractice$Shared$name);
var $author$project$Api$KnownPractice$All$name = function (knownPractice) {
	if (!knownPractice.$) {
		var knownPractice_ = knownPractice.a;
		return $author$project$Api$Provider$KnownPractice$All$name(knownPractice_);
	} else {
		var knownPractice_ = knownPractice.a;
		return $author$project$Api$Employer$KnownPractice$All$name(knownPractice_);
	}
};
var $author$project$Components$ResourceFilter$KnownPractice$resourceFromAll = function (knownPractice) {
	return {
		ahP: $author$project$Api$KnownPractice$All$id(knownPractice),
		Bq: $author$project$Api$KnownPractice$All$name(knownPractice)
	};
};
var $author$project$Components$ResourceFilter$KnownPractice$fetchResources = F5(
	function (session, toMsg, apiClient, pagination, query) {
		return A4(
			$author$project$Components$ResourceFilter$KnownPractice$list,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{Bq: query, ajJ: pagination});
			},
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Components$ResourceFilter$KnownPractice$resourceFromAll))));
	});
var $author$project$Components$ResourceFilter$KnownPractice$retrieveResource = F4(
	function (session, toMsg, apiClient, id) {
		return A4(
			$author$project$Components$ResourceFilter$KnownPractice$list,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{
						ahP: $elm$core$Maybe$Just(id)
					});
			},
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Components$ResourceFilter$KnownPractice$resourceFromAll))));
	});
var $author$project$Components$ResourceFilter$KnownPractice$selectId = 'known-practices';
var $author$project$Components$ResourceFilter$KnownPractice$toTitle = function ($) {
	return $.Bq;
};
var $author$project$Components$ResourceFilter$KnownPractice$toLabel = function (resource) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Components$ResourceFilter$KnownPractice$toTitle(resource))
		]);
};
var $author$project$Components$ResourceFilter$KnownPractice$toValue = function ($) {
	return $.ahP;
};
var $author$project$Components$ResourceFilter$KnownPractice$init = F3(
	function (apiClient, session, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{
				Sk: $author$project$Components$ResourceFilter$KnownPractice$fetchResources(session),
				ahP: $author$project$Components$ResourceFilter$KnownPractice$selectId,
				k$: 'Known Practice',
				uk: $author$project$Components$ResourceFilter$KnownPractice$retrieveResource(session),
				u9: $author$project$Components$ResourceFilter$KnownPractice$toLabel,
				lN: $author$project$Components$ResourceFilter$KnownPractice$toTitle,
				hX: $author$project$Components$ResourceFilter$KnownPractice$toValue
			},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{Jy: $author$project$Components$ResourceFilter$All, b8: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$KnownPracticeInput$empty = F2(
	function (apiClient, session) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$KnownPractice$init,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Select a DPC practice', XY: 'Other (Enter your DPC manually)', ai5: true});
			});
		var knownPracticeFilter = _v0.a;
		var knownPracticeCmd = _v0.b;
		return _Utils_Tuple2(
			A2($author$project$Components$KnownPracticeInput$Model, knownPracticeFilter, $elm$core$Maybe$Nothing),
			A2($elm$core$Platform$Cmd$map, $author$project$Components$KnownPracticeInput$FilterMsg, knownPracticeCmd));
	});
var $author$project$Components$LeadSourceInput$LeadSourceResourceFilterMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$ResourceFilter$TopRight = 0;
var $author$project$Components$ResourceFilter$toTopRight = $elm$core$Maybe$Just(0);
var $author$project$Components$LeadSourceInput$initLeadSourceResourceFilter = F2(
	function (apiClient, preSelectedId) {
		return A3(
			$author$project$Components$ResourceFilter$LeadSource$init,
			apiClient,
			$elm$core$Basics$identity,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Unassigned', ajB: $author$project$Components$ResourceFilter$toTopRight, akb: preSelectedId});
			});
	});
var $author$project$Components$LeadSourceInput$empty = function (apiClient) {
	var _v0 = A2($author$project$Components$LeadSourceInput$initLeadSourceResourceFilter, apiClient, $elm$core$Maybe$Nothing);
	var leadSourceResourceFilter = _v0.a;
	var leadSourceResourceFilterCmd = _v0.b;
	return _Utils_Tuple2(
		{ep: false, oi: leadSourceResourceFilter, dx: $elm$core$Maybe$Nothing, aB: $elm$core$Maybe$Nothing},
		A2($elm$core$Platform$Cmd$map, $author$project$Components$LeadSourceInput$LeadSourceResourceFilterMsg, leadSourceResourceFilterCmd));
};
var $author$project$Components$NameInput$Model = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Components$NameInput$empty = A3(
	$author$project$Components$NameInput$Model,
	_List_Nil,
	{ep: false, u6: ''},
	{Sv: '', VH: '', W7: '', acE: $elm$core$Maybe$Nothing, ac9: ''});
var $author$project$Components$PractitionerInput$FilterMsg = $elm$core$Basics$identity;
var $author$project$Components$PractitionerInput$empty = F2(
	function (apiClient, listOptionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$Practitioner$init,
			apiClient,
			listOptionals,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Unassigned', ai5: false});
			});
		var filter = _v0.a;
		var filterCmd = _v0.b;
		return _Utils_Tuple2(
			{ep: false, HM: filter, akR: false, aee: $elm$core$Maybe$Nothing},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, filterCmd));
	});
var $author$project$Components$EmergencyContactInput$RelationshipDropdownMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Common$EmergencyContact$Shared$record = function (_v0) {
	var r = _v0;
	return r;
};
var $author$project$Api$Common$EmergencyContact$Shared$email = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Common$EmergencyContact$Shared$record,
	function ($) {
		return $.Rj;
	});
var $author$project$Components$EmergencyContactInput$initPhone = function (maybePhone) {
	return A3(
		$author$project$Components$PhoneInput$init,
		'emergency-contact-phone',
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				{IO: '', akD: 0, amg: $author$project$Api$Common$Phone$Shared$Mobile},
				A2($elm$core$Maybe$map, $author$project$Utils$Phone$fromApi, maybePhone))
			]),
		function (opts) {
			return _Utils_update(
				opts,
				{aeW: false, AU: 1});
		});
};
var $author$project$Components$EmergencyContactInput$empty = {
	Rj: '',
	Sv: '',
	VH: '',
	Zw: $author$project$Components$EmergencyContactInput$initPhone($elm$core$Maybe$Nothing),
	$q: $elm$core$Maybe$Nothing
};
var $author$project$Api$Common$EmergencyContact$Shared$firstName = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Common$EmergencyContact$Shared$record,
	function ($) {
		return $.Sv;
	});
var $author$project$Api$Common$EmergencyContact$Shared$lastName = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Common$EmergencyContact$Shared$record,
	function ($) {
		return $.VH;
	});
var $author$project$Api$Common$EmergencyContact$Shared$phone = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Common$EmergencyContact$Shared$record,
	function ($) {
		return $.Zw;
	});
var $author$project$Api$Common$EmergencyContact$Shared$relationship = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Common$EmergencyContact$Shared$record,
	function ($) {
		return $.$q;
	});
var $author$project$Components$EmergencyContactInput$Child = {$: 2};
var $author$project$Components$EmergencyContactInput$Grandparent = {$: 4};
var $author$project$Components$EmergencyContactInput$Guardian = {$: 5};
var $author$project$Components$EmergencyContactInput$Other = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$EmergencyContactInput$Parent = {$: 1};
var $author$project$Components$EmergencyContactInput$Sibling = {$: 3};
var $author$project$Components$EmergencyContactInput$Spouse = {$: 0};
var $author$project$Components$EmergencyContactInput$relationshipFromString = function (rel) {
	switch (rel) {
		case 'spouse':
			return $author$project$Components$EmergencyContactInput$Spouse;
		case 'parent':
			return $author$project$Components$EmergencyContactInput$Parent;
		case 'child':
			return $author$project$Components$EmergencyContactInput$Child;
		case 'sibling':
			return $author$project$Components$EmergencyContactInput$Sibling;
		case 'grandparent':
			return $author$project$Components$EmergencyContactInput$Grandparent;
		case 'guardian':
			return $author$project$Components$EmergencyContactInput$Guardian;
		default:
			return $author$project$Components$EmergencyContactInput$Other(rel);
	}
};
var $author$project$Components$EmergencyContactInput$init = function (patientEmergencyContact) {
	var relationshipDropdown = $author$project$Ui$Dropdown$init(
		$author$project$Ui$Dropdown$defaultConfig(
			{ahP: 'emergency-contact-relationship-dropdown', al6: $author$project$Components$EmergencyContactInput$RelationshipDropdownMsg}));
	var form = A2(
		$elm$core$Maybe$withDefault,
		$author$project$Utils$Form$init($author$project$Components$EmergencyContactInput$empty),
		A2(
			$elm$core$Maybe$map,
			$author$project$Utils$Form$init,
			A2(
				$elm$core$Maybe$map,
				function (ec) {
					return {
						Rj: A2(
							$elm$core$Maybe$withDefault,
							'',
							$author$project$Api$Common$EmergencyContact$Shared$email(ec)),
						Sv: A2(
							$elm$core$Maybe$withDefault,
							'',
							$author$project$Api$Common$EmergencyContact$Shared$firstName(ec)),
						VH: A2(
							$elm$core$Maybe$withDefault,
							'',
							$author$project$Api$Common$EmergencyContact$Shared$lastName(ec)),
						Zw: $author$project$Components$EmergencyContactInput$initPhone(
							$author$project$Api$Common$EmergencyContact$Shared$phone(ec)),
						$q: A2(
							$elm$core$Maybe$map,
							$author$project$Components$EmergencyContactInput$relationshipFromString,
							$author$project$Api$Common$EmergencyContact$Shared$relationship(ec))
					};
				},
				patientEmergencyContact)));
	return {SD: form, pB: relationshipDropdown};
};
var $author$project$Components$LocationInput$setValue = F2(
	function (location, model) {
		var resource = $author$project$Components$ResourceFilter$Location$resourceFromShared(location);
		return A2($author$project$Components$LocationInput$setValueWithResource, resource, model);
	});
var $author$project$Components$LocationInput$init = F3(
	function (apiClient, listOptionals, location) {
		return A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Components$LocationInput$setValue(location),
			A2($author$project$Components$LocationInput$empty, apiClient, listOptionals));
	});
var $author$project$Components$PractitionerInput$setValueWithResource = F2(
	function (resource, model) {
		return _Utils_update(
			model,
			{
				HM: A2($author$project$Components$ResourceFilter$Practitioner$setValue, resource, model.HM),
				aee: resource
			});
	});
var $author$project$Components$PractitionerInput$setValue = F2(
	function (practitioner, model) {
		var resource = $author$project$Components$ResourceFilter$Practitioner$resourceFromShared(practitioner);
		return A2($author$project$Components$PractitionerInput$setValueWithResource, resource, model);
	});
var $author$project$Components$PractitionerInput$init = F3(
	function (apiClient, listOptionals, practitioner) {
		return A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Components$PractitionerInput$setValue(practitioner),
			A2($author$project$Components$PractitionerInput$empty, apiClient, listOptionals));
	});
var $author$project$Api$SignupPage$Min$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$SignupPage$Min$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$Company$One$defaultSignupPage = function (_v0) {
	var record = _v0.b;
	return record.Qb;
};
var $author$project$Api$Provider$Company$One$defaultSignupPage = function (_v0) {
	var record = _v0.b;
	return record.Qb;
};
var $author$project$Api$Company$defaultSignupPage = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$SignupPage$Min$Provider,
			$author$project$Api$Provider$Company$One$defaultSignupPage(company_));
	} else {
		var company_ = company.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$SignupPage$Min$Employer,
			$author$project$Api$Employer$Company$One$defaultSignupPage(company_));
	}
};
var $author$project$Api$Employer$SignupPage$Min$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$SignupPage$Min$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$SignupPage$Min$id = function (signupPage) {
	if (!signupPage.$) {
		var sponsorFeeDeal_ = signupPage.a;
		return $author$project$Api$Provider$SignupPage$Min$id(sponsorFeeDeal_);
	} else {
		var sponsorFeeDeal_ = signupPage.a;
		return $author$project$Api$Employer$SignupPage$Min$id(sponsorFeeDeal_);
	}
};
var $author$project$Components$Patient$Form$practitionerSignupOptionals = F2(
	function (isEmployeeForm, company) {
		var page = isEmployeeForm ? A2(
			$elm$core$Maybe$map,
			function (pg) {
				return $author$project$Api$SignupPage$Min$id(pg);
			},
			A2($elm$core$Maybe$andThen, $author$project$Api$Company$defaultSignupPage, company)) : $elm$core$Maybe$Nothing;
		var _v0 = function () {
			if (!company.$) {
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(true),
					$elm$core$Maybe$Nothing);
			} else {
				return _Utils_Tuple2(
					$elm$core$Maybe$Nothing,
					$elm$core$Maybe$Just(true));
			}
		}();
		var acceptsEnrollmentsFromEmployer = _v0.a;
		var acceptsEnrollmentsFromRetail = _v0.b;
		return function (d) {
			return _Utils_update(
				d,
				{q5: acceptsEnrollmentsFromEmployer, q6: acceptsEnrollmentsFromRetail, JM: page});
		};
	});
var $author$project$Components$Patient$Form$practitionerSignupOptionalsWithExtras = F5(
	function (isEmployeeForm, company, location, affiliate, expand) {
		var page = isEmployeeForm ? A2(
			$elm$core$Maybe$map,
			function (pg) {
				return $author$project$Api$SignupPage$Min$id(pg);
			},
			A2($elm$core$Maybe$andThen, $author$project$Api$Company$defaultSignupPage, company)) : $elm$core$Maybe$Nothing;
		var _v0 = function () {
			if (!company.$) {
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(true),
					$elm$core$Maybe$Nothing);
			} else {
				return _Utils_Tuple2(
					$elm$core$Maybe$Nothing,
					$elm$core$Maybe$Just(true));
			}
		}();
		var acceptsEnrollmentsFromEmployer = _v0.a;
		var acceptsEnrollmentsFromRetail = _v0.b;
		return function (d) {
			return _Utils_update(
				d,
				{q5: acceptsEnrollmentsFromEmployer, q6: acceptsEnrollmentsFromRetail, Gn: affiliate, HE: expand, ais: location, JM: page});
		};
	});
var $author$project$Components$LocationInput$require = F2(
	function (required, input) {
		return _Utils_update(
			input,
			{akR: required});
	});
var $author$project$Components$PractitionerInput$require = F2(
	function (required, input) {
		return _Utils_update(
			input,
			{akR: required});
	});
var $author$project$Api$Employer$Affiliate$AffiliateMin$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Affiliate$AffiliateMin$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Affiliate$AffiliateMin$id = function (affiliate) {
	if (!affiliate.$) {
		var affiliate_ = affiliate.a;
		return $author$project$Api$Provider$Affiliate$AffiliateMin$id(affiliate_);
	} else {
		var affiliate_ = affiliate.a;
		return $author$project$Api$Employer$Affiliate$AffiliateMin$id(affiliate_);
	}
};
var $author$project$Api$Employer$Affiliate$AffiliateMin$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$Affiliate$AffiliateMin$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Affiliate$AffiliateMin$name = function (affiliate) {
	if (!affiliate.$) {
		var affiliate_ = affiliate.a;
		return $author$project$Api$Provider$Affiliate$AffiliateMin$name(affiliate_);
	} else {
		var affiliate_ = affiliate.a;
		return $author$project$Api$Employer$Affiliate$AffiliateMin$name(affiliate_);
	}
};
var $author$project$Components$ResourceFilter$Affiliate$resourceFromAffiliateMin = function (affiliate) {
	return {
		ahP: $author$project$Api$Affiliate$AffiliateMin$id(affiliate),
		Bq: $author$project$Api$Affiliate$AffiliateMin$name(affiliate)
	};
};
var $author$project$Components$ResourceFilter$Affiliate$setValue = F2(
	function (resource, model) {
		return _Utils_update(
			model,
			{
				Jy: function () {
					if (!resource.$) {
						var resource_ = resource.a;
						return $author$project$Components$ResourceFilter$One(resource_);
					} else {
						return $author$project$Components$ResourceFilter$All;
					}
				}()
			});
	});
var $author$project$Components$AffiliateInput$setValueWithResource = F2(
	function (resource, model) {
		return _Utils_update(
			model,
			{
				HM: A2($author$project$Components$ResourceFilter$Affiliate$setValue, resource, model.HM),
				aee: resource
			});
	});
var $author$project$Components$AffiliateInput$setValue = F2(
	function (maybeAffiliate, model) {
		var resource = A2($elm$core$Maybe$map, $author$project$Components$ResourceFilter$Affiliate$resourceFromAffiliateMin, maybeAffiliate);
		return A2($author$project$Components$AffiliateInput$setValueWithResource, resource, model);
	});
var $author$project$Components$Patient$Form$signupOptionals = F2(
	function (isEmployeeForm, company) {
		return isEmployeeForm ? A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Maybe$map,
				function (page) {
					return function (d) {
						return _Utils_update(
							d,
							{
								JM: $elm$core$Maybe$Just(
									$author$project$Api$SignupPage$Min$id(page))
							});
					};
				},
				A2($elm$core$Maybe$andThen, $author$project$Api$Company$defaultSignupPage, company))) : $elm$core$Basics$identity;
	});
var $author$project$Components$Patient$Form$empty = F6(
	function (apiClient, session, currentDate, company, isEmployeeForm, settingsMapper) {
		var settings = settingsMapper(
			A3($author$project$Components$Patient$Form$defaultSettings, currentDate, true, isEmployeeForm));
		var practitionerOptionals = isEmployeeForm ? A2($author$project$Components$Patient$Form$practitionerSignupOptionals, isEmployeeForm, company) : A5(
			$author$project$Components$Patient$Form$practitionerSignupOptionalsWithExtras,
			isEmployeeForm,
			company,
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Nothing,
			_List_fromArray(
				[1]));
		var phonesInput = A3(
			$author$project$Components$PhoneInput$init,
			'patient-phones',
			_List_Nil,
			function (d) {
				return _Utils_update(
					d,
					{Gh: true});
			});
		var optionals = A2($author$project$Components$Patient$Form$signupOptionals, isEmployeeForm, company);
		var _v0 = function () {
			var _v1 = A2($elm$core$Maybe$andThen, $author$project$Api$Company$defaultPractitioner, company);
			if (!_v1.$) {
				var companyPractitioner = _v1.a;
				return A3(
					$author$project$Components$PractitionerInput$init,
					apiClient,
					practitionerOptionals,
					$elm$core$Maybe$Just(companyPractitioner));
			} else {
				return A2($author$project$Components$PractitionerInput$empty, apiClient, practitionerOptionals);
			}
		}();
		var practitioner = _v0.a;
		var practitionerCmd = _v0.b;
		var _v2 = function () {
			var _v3 = A2($elm$core$Maybe$andThen, $author$project$Api$Company$defaultLocation, company);
			if (!_v3.$) {
				var companyLocation = _v3.a;
				return A3(
					$author$project$Components$LocationInput$init,
					apiClient,
					optionals,
					$elm$core$Maybe$Just(companyLocation));
			} else {
				return A2($author$project$Components$LocationInput$empty, apiClient, optionals);
			}
		}();
		var location = _v2.a;
		var locationCmd = _v2.b;
		var _v4 = $author$project$Components$LeadSourceInput$empty(apiClient);
		var leadSource = _v4.a;
		var leadSourceCmd = _v4.b;
		var _v5 = A2($author$project$Components$KnownPracticeInput$empty, apiClient, session);
		var knownPractice = _v5.a;
		var knownPracticeCmd = _v5.b;
		var _v6 = A2($author$project$Components$HealthInsuranceInput$empty, apiClient, session);
		var healthInsurance = _v6.a;
		var healthInsuranceCmd = _v6.b;
		var _v7 = $author$project$Components$DateInput$init;
		var dateInput = _v7.a;
		var dateInputCmd = _v7.b;
		var _v8 = function () {
			var _v9 = A2($elm$core$Maybe$andThen, $author$project$Api$Company$defaultAffiliation, company);
			if (!_v9.$) {
				var companyAffiliation = _v9.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Components$AffiliateInput$setValue(
						$elm$core$Maybe$Just(companyAffiliation)),
					A3(
						$author$project$Components$AffiliateInput$empty,
						apiClient,
						session,
						A2($author$project$Components$Patient$Form$affiliateOptionals, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing)));
			} else {
				return A3(
					$author$project$Components$AffiliateInput$empty,
					apiClient,
					session,
					A2($author$project$Components$Patient$Form$affiliateOptionals, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing));
			}
		}();
		var affiliate = _v8.a;
		var affiliateCmd = _v8.b;
		var _v10 = $author$project$Components$AddressInput$init('patient-address');
		var address = _v10.a;
		var addressCmd = _v10.b;
		return _Utils_Tuple2(
			A2(
				$author$project$Components$Patient$Form$PatientForm,
				settings,
				$author$project$Utils$Form$init(
					{
						K2: address,
						Gn: affiliate,
						MF: $elm$core$Maybe$Nothing,
						bU: $elm$core$Maybe$Nothing,
						rT: $elm$core$Maybe$Nothing,
						PF: '',
						Rj: $elm$core$Maybe$Nothing,
						Rl: $author$project$Components$EmergencyContactInput$init($elm$core$Maybe$Nothing),
						SR: $elm$core$Maybe$Nothing,
						SS: $elm$core$Maybe$Nothing,
						ST: $elm$core$Maybe$Nothing,
						Tm: healthInsurance,
						j5: _Utils_Tuple2($elm$core$Maybe$Nothing, dateInput),
						Vy: knownPractice,
						VR: leadSource,
						VU: $author$project$Components$NameInput$empty,
						ais: A2($author$project$Components$LocationInput$require, settings.$G, location),
						Zy: A2($author$project$Components$PhoneInput$require, settings.akW, phonesInput),
						aka: A2($author$project$Components$PractitionerInput$require, settings.$M, practitioner),
						Z9: $author$project$Language$english,
						t5: 0,
						_A: $elm$core$Maybe$Nothing,
						_B: $elm$core$Maybe$Nothing,
						aa8: $elm$core$Maybe$Nothing,
						ab5: '',
						acM: true,
						qz: $elm$core$Maybe$Nothing,
						ad3: false
					})),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Address),
						addressCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$KnownPractice),
						knownPracticeCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Practitioner),
						practitionerCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Location),
						locationCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Affiliate),
						affiliateCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$LeadSource),
						leadSourceCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$HealthInsurance),
						healthInsuranceCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$JoinedPractice),
						dateInputCmd)
					])));
	});
var $author$project$Components$SponsorPlanInput$FilterMsg = $elm$core$Basics$identity;
var $author$project$Api$Employer$Company$One$defaultPlan = function (_v0) {
	var record = _v0.b;
	return record.P8;
};
var $author$project$Api$Provider$Company$One$defaultPlan = function (_v0) {
	var record = _v0.b;
	return record.P8;
};
var $author$project$Api$Company$defaultPlan = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Plan$ProviderShared,
			$author$project$Api$Provider$Company$One$defaultPlan(company_));
	} else {
		var company_ = company.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Plan$EmployerShared,
			$author$project$Api$Employer$Company$One$defaultPlan(company_));
	}
};
var $author$project$Components$SponsorPlanInput$filterInit = F4(
	function (session, company, apiClient, planId) {
		return A4(
			$author$project$Components$ResourceFilter$CompanyPlan$init,
			apiClient,
			session,
			$author$project$Api$Company$id(company),
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Select a Plan', Lr: false, ai5: false, akb: planId});
			});
	});
var $author$project$Components$SponsorPlanInput$init = F3(
	function (session, company, apiClient) {
		var defaultPlanId = A2(
			$elm$core$Maybe$map,
			$author$project$Api$Plan$id,
			$author$project$Api$Company$defaultPlan(company));
		var _v0 = A4($author$project$Components$SponsorPlanInput$filterInit, session, company, apiClient, defaultPlanId);
		var filter = _v0.a;
		var filterCmd = _v0.b;
		return _Utils_Tuple2(
			{ep: false, HM: filter, akR: false, aee: $elm$core$Maybe$Nothing},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, filterCmd));
	});
var $author$project$Components$Employee$Form$nextFirstOfMonth = function (currentDate) {
	return $author$project$Utils$Date$toIsoString(
		A2($justinmimbs$date$Date$ceiling, 2, currentDate));
};
var $author$project$Components$EmployeeDivisionInput$require = F2(
	function (required, input) {
		return _Utils_update(
			input,
			{akR: required});
	});
var $author$project$Components$SponsorPlanInput$require = F2(
	function (required, input) {
		return _Utils_update(
			input,
			{akR: required});
	});
var $author$project$Components$Employee$Form$empty = F6(
	function (session, company, apiClient, currentDate, employeeMapper, patientMapper) {
		var isNew = true;
		var employeeSettings = employeeMapper($author$project$Components$Employee$Form$defaultEmployeeSettings);
		var _v0 = A2($author$project$Components$EmployeeDependentTypeInput$empty, session, company);
		var typeInput = _v0.a;
		var typeInputCmd = _v0.b;
		var _v1 = $author$project$Components$DateInput$init;
		var startDateInput = _v1.a;
		var startDateInputCmd = _v1.b;
		var _v2 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Components$SponsorPlanInput$require(true),
			A3($author$project$Components$SponsorPlanInput$init, session, company, apiClient));
		var sponsorPlan = _v2.a;
		var sponsorPlanCmd = _v2.b;
		var _v3 = A6(
			$author$project$Components$Patient$Form$empty,
			apiClient,
			session,
			currentDate,
			$elm$core$Maybe$Just(company),
			true,
			patientMapper);
		var patientForm = _v3.a;
		var patientFormCmd = _v3.b;
		var _v4 = A3(
			$author$project$Components$EmployeeDivisionInput$empty,
			session,
			$author$project$Api$Company$id(company),
			apiClient);
		var divisionInput = _v4.a;
		var divisionInputCmd = _v4.b;
		var form = $author$project$Utils$Form$init(
			{
				QO: A2($author$project$Components$EmployeeDivisionInput$require, employeeSettings.$F, divisionInput),
				dj: _Utils_Tuple2(
					$elm$core$Maybe$Just(currentDate),
					startDateInput),
				Rz: $elm$core$Maybe$Just(true),
				ag7: $elm$core$Maybe$Nothing,
				ahP: $elm$core$Maybe$Nothing,
				j1: isNew,
				WW: $author$project$Components$Employee$Form$nextFirstOfMonth(currentDate),
				YY: patientForm,
				Jb: A2($author$project$Components$SponsorPlanInput$require, employeeSettings.Ef, sponsorPlan),
				amg: typeInput
			});
		return _Utils_Tuple2(
			A2(
				$author$project$Components$Employee$Form$EmployeeForm,
				A3($author$project$Components$Employee$Form$defaultSettings, currentDate, isNew, employeeSettings),
				form),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Employee$Form$PatientFormMsg, patientFormCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$Type),
						typeInputCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$Plan),
						sponsorPlanCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$EligibilityDate),
						startDateInputCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$Division),
						divisionInputCmd)
					])));
	});
var $author$project$Api$Employer$Practice$One$hasLocations = function (_v0) {
	var record = _v0;
	return record.W4.Tb;
};
var $author$project$Api$Practice$hasLocations = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$hasLocations(practice_);
	} else {
		var practice_ = practice.a;
		return $author$project$Api$Employer$Practice$One$hasLocations(practice_);
	}
};
var $author$project$Api$Employer$Practice$One$hasPractitioners = function (_v0) {
	var record = _v0;
	return record.W4.Th;
};
var $author$project$Api$Practice$hasPractitioners = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$hasPractitioners(practice_);
	} else {
		var practice_ = practice.a;
		return $author$project$Api$Employer$Practice$One$hasPractitioners(practice_);
	}
};
var $author$project$Api$Provider$Practice$One$labelBillingAsShipping = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Vz;
	});
var $author$project$Api$Practice$labelBillingAsShipping = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$labelBillingAsShipping(practice_);
	} else {
		return false;
	}
};
var $author$project$Api$Employer$Company$Shared$requiresEmployeeDivisions = function (_v0) {
	var record = _v0;
	return record.$F;
};
var $author$project$Api$Employer$Company$One$requiresEmployeeDivisions = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Company$Shared$requiresEmployeeDivisions(shared);
};
var $author$project$Api$Provider$Company$Shared$requiresEmployeeDivisions = function (_v0) {
	var record = _v0;
	return record.$F;
};
var $author$project$Api$Provider$Company$One$requiresEmployeeDivisions = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$requiresEmployeeDivisions(shared);
};
var $author$project$Api$Company$requiresEmployeeDivisions = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$requiresEmployeeDivisions(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$requiresEmployeeDivisions(company_);
	}
};
var $author$project$Api$Employer$Practice$One$requiresLocation = function (_v0) {
	var record = _v0;
	return record.$G;
};
var $author$project$Api$Practice$requiresLocation = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$requiresLocation(practice_);
	} else {
		var practice_ = practice.a;
		return $author$project$Api$Employer$Practice$One$requiresLocation(practice_);
	}
};
var $author$project$Api$Employer$Practice$One$requiresPatientEmail = function (_v0) {
	var record = _v0;
	return record.$I;
};
var $author$project$Api$Practice$requiresPatientEmail = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$requiresPatientEmail(practice_);
	} else {
		var practice_ = practice.a;
		return $author$project$Api$Employer$Practice$One$requiresPatientEmail(practice_);
	}
};
var $author$project$Api$Employer$Practice$One$requiresPatientMobile = function (_v0) {
	var record = _v0;
	return record.$J;
};
var $author$project$Api$Practice$requiresPatientMobile = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$requiresPatientMobile(practice_);
	} else {
		var practice_ = practice.a;
		return $author$project$Api$Employer$Practice$One$requiresPatientMobile(practice_);
	}
};
var $author$project$Api$Employer$Practice$One$requiresPractitioner = function (_v0) {
	var record = _v0;
	return record.$M;
};
var $author$project$Api$Practice$requiresPractitioner = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$requiresPractitioner(practice_);
	} else {
		var practice_ = practice.a;
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			$author$project$Api$Employer$Practice$One$requiresPractitioner(practice_));
	}
};
var $author$project$Api$Employer$Practice$One$requiresSSN = function (_v0) {
	var record = _v0;
	return record.$N;
};
var $author$project$Api$Practice$requiresSSN = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$requiresSSN(practice_);
	} else {
		var practice_ = practice.a;
		return $author$project$Api$Employer$Practice$One$requiresSSN(practice_);
	}
};
var $author$project$Api$Employer$Practice$One$ssnEnabled = function (_v0) {
	var record = _v0;
	return record.ab6;
};
var $author$project$Api$Practice$ssnEnabled = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$ssnEnabled(practice_);
	} else {
		var practice_ = practice.a;
		return $author$project$Api$Employer$Practice$One$ssnEnabled(practice_);
	}
};
var $author$project$Api$Employer$Network$Shared$syncByAffiliation = function (_v0) {
	var record = _v0;
	return record.acI;
};
var $author$project$Api$Network$Shared$syncByAffiliation = function (network) {
	if (!network.$) {
		var network_ = network.a;
		return $author$project$Api$Provider$Network$Shared$syncByAffiliation(network_);
	} else {
		var network_ = network.a;
		return $author$project$Api$Employer$Network$Shared$syncByAffiliation(network_);
	}
};
var $author$project$Api$Employer$Practice$One$transInclusivity = function (_v0) {
	var record = _v0;
	return record.adv;
};
var $author$project$Api$Provider$Practice$One$transInclusivity = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.adv;
	});
var $author$project$Api$Practice$transInclusivity = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$transInclusivity(practice_);
	} else {
		var practice_ = practice.a;
		return $author$project$Api$Employer$Practice$One$transInclusivity(practice_);
	}
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Create$init = F5(
	function (session, practice, company, shared, _v0) {
		var params = _v0.YL;
		var _v1 = A6(
			$author$project$Components$Employee$Form$empty,
			session,
			company,
			shared.Gv,
			shared.dd,
			function (employeeSettings) {
				return _Utils_update(
					employeeSettings,
					{
						$F: $author$project$Api$Company$requiresEmployeeDivisions(company),
						ad6: $author$project$Api$Company$usesEmployeeDivisions(company)
					});
			},
			function (patientSettings) {
				return _Utils_update(
					patientSettings,
					{
						afg: $author$project$Api$Practice$labelBillingAsShipping(practice),
						afn: A2($author$project$Api$Practice$featureEnabled, 3, practice),
						Tb: $author$project$Api$Practice$hasLocations(practice),
						Th: $author$project$Api$Practice$hasPractitioners(practice),
						Ee: true,
						akV: $author$project$Api$Practice$requiresPatientEmail(practice),
						$G: $author$project$Api$Practice$requiresLocation(practice),
						akW: $author$project$Api$Practice$requiresPatientMobile(practice),
						$M: $author$project$Api$Practice$requiresPractitioner(practice),
						$N: $author$project$Api$Practice$requiresSSN(practice),
						ab6: $author$project$Api$Practice$ssnEnabled(practice),
						acI: A2(
							$elm$core$Maybe$withDefault,
							false,
							A2(
								$elm$core$Maybe$map,
								$author$project$Api$Network$Shared$syncByAffiliation,
								$author$project$Api$Practice$network(practice))),
						al8: A2($author$project$Api$Practice$featureEnabled, 2, practice),
						adt: $author$project$Api$Practice$trackPatientsByLocation(practice),
						adv: $author$project$Api$Practice$transInclusivity(practice),
						F1: A3($author$project$Permission$canGoTo, session, shared.ahK, 0)
					});
			});
		var form = _v1.a;
		var formCmd = _v1.b;
		var model = {KF: $author$project$Api$Data$NotAsked, Gv: shared.Gv, afQ: company, aK: form, ahP: params.fZ, ajE: shared.ajE, ZV: practice, aa4: session, lA: false};
		return _Utils_Tuple2(
			model,
			A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Employees$Create$FormMsg, formCmd));
	});
var $author$project$Pages$Companies$CompanyId_String$Employees$Create$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Companies$CompanyId_String$Employees$Create$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Employee$Form$Patient = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$EmployeeDependentTypeInput$CompanyAccountFilterMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$ResourceFilter$CompanyAccount$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Components$ResourceFilter$CompanyAccount$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.b8));
};
var $author$project$Components$EmployeeDependentTypeInput$subscriptions = function (_v0) {
	var dependentOfFilter = _v0.dg;
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Platform$Sub$none,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Components$ResourceFilter$CompanyAccount$subscriptions,
				$elm$core$Platform$Sub$map($author$project$Components$EmployeeDependentTypeInput$CompanyAccountFilterMsg)),
			dependentOfFilter));
};
var $author$project$Components$Patient$Form$BillingAddress = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Patient$Form$EmergencyContact = function (a) {
	return {$: 27, a: a};
};
var $author$project$Components$Patient$Form$Phones = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$ResourceFilter$Affiliate$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.b8));
};
var $author$project$Components$AffiliateInput$subscriptions = function (_v0) {
	var filter = _v0.HM;
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$Affiliate$subscriptions(filter));
};
var $author$project$Components$EmergencyContactInput$FieldChanged = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$EmergencyContactInput$Phone = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$EmergencyContactInput$subscriptions = function (_v0) {
	var form = _v0.SD;
	var relationshipDropdown = _v0.pB;
	var emergencyContact = $author$project$Utils$Form$fields(form);
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$Dropdown$subscriptions(relationshipDropdown),
				A2(
				$elm$core$Platform$Sub$map,
				A2($elm$core$Basics$composeL, $author$project$Components$EmergencyContactInput$FieldChanged, $author$project$Components$EmergencyContactInput$Phone),
				$author$project$Components$PhoneInput$subscriptions(emergencyContact.Zw))
			]));
};
var $author$project$Components$ResourceFilter$InsuranceCarrierAlias$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.b8));
};
var $author$project$Components$HealthInsuranceInput$subscriptions = function (_v0) {
	var filter = _v0.a;
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Components$HealthInsuranceInput$FilterMsg,
		$author$project$Components$ResourceFilter$InsuranceCarrierAlias$subscriptions(filter));
};
var $author$project$Components$ResourceFilter$KnownPractice$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.b8));
};
var $author$project$Components$KnownPracticeInput$subscriptions = function (_v0) {
	var filter = _v0.a;
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Components$KnownPracticeInput$FilterMsg,
		$author$project$Components$ResourceFilter$KnownPractice$subscriptions(filter));
};
var $author$project$Components$LeadSourceInput$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Components$LeadSourceInput$LeadSourceResourceFilterMsg,
		$author$project$Components$ResourceFilter$LeadSource$subscriptions(model.oi));
};
var $author$project$Components$PractitionerInput$subscriptions = function (_v0) {
	var filter = _v0.HM;
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$Practitioner$subscriptions(filter));
};
var $author$project$Components$Patient$Form$subscriptions = function (_v0) {
	var form = _v0.b;
	var _v1 = $author$project$Utils$Form$fields(form);
	var emergencyContact = _v1.Rl;
	var address = _v1.K2;
	var billingAddress = _v1.MF;
	var phones = _v1.Zy;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Address),
				$author$project$Components$AddressInput$subscriptions(address)),
				A2(
				$elm$core$Platform$Sub$map,
				A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$BillingAddress),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$AddressInput$subscriptions, billingAddress))),
				A2(
				$elm$core$Platform$Sub$map,
				A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$EmergencyContact),
				$author$project$Components$EmergencyContactInput$subscriptions(emergencyContact)),
				A2(
				$elm$core$Platform$Sub$map,
				A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Phones),
				$author$project$Components$PhoneInput$subscriptions(phones)),
				A2(
				$elm$core$Platform$Sub$map,
				A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$LeadSource),
				$author$project$Components$LeadSourceInput$subscriptions(
					$author$project$Utils$Form$fields(form).VR)),
				A2(
				$elm$core$Platform$Sub$map,
				A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Location),
				$author$project$Components$LocationInput$subscriptions(
					$author$project$Utils$Form$fields(form).ais)),
				A2(
				$elm$core$Platform$Sub$map,
				A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Affiliate),
				$author$project$Components$AffiliateInput$subscriptions(
					$author$project$Utils$Form$fields(form).Gn)),
				A2(
				$elm$core$Platform$Sub$map,
				A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Practitioner),
				$author$project$Components$PractitionerInput$subscriptions(
					$author$project$Utils$Form$fields(form).aka)),
				A2(
				$elm$core$Platform$Sub$map,
				A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$KnownPractice),
				$author$project$Components$KnownPracticeInput$subscriptions(
					$author$project$Utils$Form$fields(form).Vy)),
				A2(
				$elm$core$Platform$Sub$map,
				A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$HealthInsurance),
				$author$project$Components$HealthInsuranceInput$subscriptions(
					$author$project$Utils$Form$fields(form).Tm))
			]));
};
var $author$project$Components$SponsorPlanInput$subscriptions = function (_v0) {
	var filter = _v0.HM;
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$CompanyPlan$subscriptions(filter));
};
var $author$project$Components$Employee$Form$subscriptions = function (_v0) {
	var form = _v0.b;
	var fields = $author$project$Utils$Form$fields(form);
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$Patient),
				$author$project$Components$Patient$Form$subscriptions(fields.YY)),
				A2(
				$elm$core$Platform$Sub$map,
				A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$Plan),
				$author$project$Components$SponsorPlanInput$subscriptions(fields.Jb)),
				A2(
				$elm$core$Platform$Sub$map,
				A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$Type),
				$author$project$Components$EmployeeDependentTypeInput$subscriptions(fields.amg))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Create$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$Companies$CompanyId_String$Employees$Create$FormMsg,
		$author$project$Components$Employee$Form$subscriptions(model.aK));
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Create$CompanyAccountCreated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Create$CompanyRegistrationCreated = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Companies$CompanyId_String$Employees$Create$RegistrationEnrolled = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$CompanyAccount$One$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$CompanyAccount$One$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$CompanyAccount$companyAccountsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['accounts']),
	$author$project$Api$Data$employerPath);
var $author$project$Api$Employer$CompanyAccount$One$CompanyAccount = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Employer$CompanyAccount$Shared$CompanyAccount = $elm$core$Basics$identity;
var $author$project$Api$Employer$CompanyAccount$Shared$Record = F5(
	function (id, isEligible, terminationRequestedAt, eligibilityStartDate, eligibilityEndDate) {
		return {Rf: eligibilityEndDate, Rg: eligibilityStartDate, ahP: id, UO: isEligible, al0: terminationRequestedAt};
	});
var $author$project$Api$Employer$CompanyAccount$Shared$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'eligibility_end_date',
	$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'eligibility_start_date',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'termination_requested_at',
			$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'is_eligible',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyAccount$Shared$Record))))));
var $author$project$Api$Employer$CompanyAccount$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$CompanyAccount$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$CompanyAccount$One$Record = F5(
	function (division, subscriber, selectedPlan, membershipPlan, registrations) {
		return {QO: division, WU: membershipPlan, akF: registrations, aaH: selectedPlan, acy: subscriber};
	});
var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountOne$CompanyRegistration = $elm$core$Basics$identity;
var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountOne$Record = function (patient) {
	return {YY: patient};
};
var $author$project$Api$Employer$Patient$Min$Patient = $elm$core$Basics$identity;
var $author$project$Api$Employer$Patient$Min$Record = F5(
	function (id, name, email, dob, age) {
		return {Lj: age, agC: dob, Rj: email, ahP: id, Bq: name};
	});
var $author$project$Api$Employer$Patient$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'age',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'dob',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'email',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Employer$Patient$Min$Record))))));
var $author$project$Api$Employer$Patient$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Patient$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountOne$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'patient',
	$author$project$Api$Employer$Patient$Min$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyRegistration$ForCompanyAccountOne$Record));
var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountOne$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$CompanyRegistration$ForCompanyAccountOne$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Patient$Shared$Patient = $elm$core$Basics$identity;
var $author$project$Api$Employer$Patient$Shared$Record = function (id) {
	return function (name) {
		return function (firstName) {
			return function (middleName) {
				return function (lastName) {
					return function (email) {
						return function (dob) {
							return function (sex) {
								return function (gender) {
									return function (genderIdentity) {
										return function (genderOther) {
											return function (pronoun) {
												return function (leadSourceOther) {
													return function (syncToEmr) {
														return function (joinedPracticeDate) {
															return function (usesTobacco) {
																return {agC: dob, Rj: email, Sv: firstName, SR: gender, SS: genderIdentity, ST: genderOther, ahP: id, Vw: joinedPracticeDate, VH: lastName, VT: leadSourceOther, W7: middleName, Bq: name, _B: pronoun, aa8: sex, acM: syncToEmr, ad9: usesTobacco};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Employer$Patient$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'uses_tobacco',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'joined_practice_date',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'sync_to_emr',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'lead_source_other',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'pronoun',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'gender_other',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'gender_identity',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'gender',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'sex',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'dob',
										$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'email',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'last_name',
												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'middle_name',
													$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'first_name',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'name',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'id',
																$elm$json$Json$Decode$string,
																$elm$json$Json$Decode$succeed($author$project$Api$Employer$Patient$Shared$Record)))))))))))))))));
var $author$project$Api$Employer$Patient$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Patient$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Plan$Min$Plan = $elm$core$Basics$identity;
var $author$project$Api$Employer$Plan$Min$Record = F5(
	function (id, name, maximumAge, minimumAge, tobaccoSurchargeType) {
		return {ahP: id, WF: maximumAge, Xd: minimumAge, Bq: name, adh: tobaccoSurchargeType};
	});
var $author$project$Api$Employer$Plan$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'tobacco_surcharge_type',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'minimum_age',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'maximum_age',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Employer$Plan$Min$Record))))));
var $author$project$Api$Employer$Plan$Min$decoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $author$project$Api$Employer$Plan$Min$recordDecoder);
var $author$project$Api$Employer$CompanyAccount$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'registrations',
	$elm$json$Json$Decode$list($author$project$Api$Employer$CompanyRegistration$ForCompanyAccountOne$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'membership_plan',
		$elm$json$Json$Decode$nullable($author$project$Api$Employer$Plan$Min$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'selected_plan',
			$elm$json$Json$Decode$nullable($author$project$Api$Employer$Plan$Min$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'subscriber',
				$elm$json$Json$Decode$nullable($author$project$Api$Employer$Patient$Shared$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'division',
					$elm$json$Json$Decode$nullable($author$project$Api$Employer$EmployeeDivision$All$decoder),
					$elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyAccount$One$Record))))));
var $author$project$Api$Employer$CompanyAccount$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$CompanyAccount$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Employer$CompanyAccount$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyAccount$One$CompanyAccount)));
var $author$project$Api$Employer$CompanyAccount$create = F3(
	function (apiClient, jsonBody, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Employer$CompanyAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				jsonBody,
				$author$project$Api$Data$requestTo($author$project$Api$Employer$CompanyAccount$companyAccountsPath)));
	});
var $author$project$Api$Provider$Company$Account$create = F4(
	function (apiClient, basePath, jsonBody, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CompanyAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				jsonBody,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Company$Account$companyAccountsPath(basePath))));
	});
var $author$project$Api$CompanyAccount$create = F5(
	function (apiClient, session, companyId, jsonBody, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$CompanyAccount$create,
			apiClient,
			jsonBody,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Employer))) : A4(
			$author$project$Api$Provider$Company$Account$create,
			apiClient,
			$author$project$Api$Provider$Company$companyPath(companyId),
			jsonBody,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Provider)));
	});
var $author$project$Api$CompanyRegistration$One$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$CompanyRegistration$One$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$CompanyAccount$companyAccountPath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		$author$project$Api$Employer$CompanyAccount$companyAccountsPath);
};
var $author$project$Api$Employer$CompanyRegistration$companyRegistrationsPath = function (accountId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['registrations']),
		$author$project$Api$Employer$CompanyAccount$companyAccountPath(accountId));
};
var $author$project$Api$Employer$CompanyRegistration$One$CompanyRegistration = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Employer$CompanyRegistration$Shared$CompanyRegistration = $elm$core$Basics$identity;
var $author$project$Api$Employer$CompanyRegistration$Shared$Record = F8(
	function (id, type_, isSubscriber, externalId, terminationRequestedAt, eligibilityStartDate, eligibilityEndDate, membershipEndDate) {
		return {Rf: eligibilityEndDate, Rg: eligibilityStartDate, ag7: externalId, ahP: id, Vd: isSubscriber, WQ: membershipEndDate, al0: terminationRequestedAt, amg: type_};
	});
var $author$project$Api$Employer$CompanyRegistration$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'membership_end_date',
	$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'eligibility_end_date',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'eligibility_start_date',
			$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'termination_requested_at',
				$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'external_id',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'is_subscriber',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'type',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyRegistration$Shared$Record)))))))));
var $author$project$Api$Employer$CompanyRegistration$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$CompanyRegistration$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$CompanyRegistration$One$Record = function (patient) {
	return {YY: patient};
};
var $author$project$Api$Employer$CompanyRegistration$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'patient',
	$author$project$Api$Employer$Patient$Min$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyRegistration$One$Record));
var $author$project$Api$Employer$CompanyRegistration$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$CompanyRegistration$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Employer$CompanyRegistration$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyRegistration$One$CompanyRegistration)));
var $author$project$Api$Employer$CompanyRegistration$create = F4(
	function (apiClient, accountId, jsonBody, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Employer$CompanyRegistration$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				jsonBody,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Employer$CompanyRegistration$companyRegistrationsPath(accountId))));
	});
var $author$project$Api$Provider$Company$Registration$companyRegistrationsPath = F2(
	function (companyId, companyAccountId) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				['registrations']),
			A2(
				$author$project$Api$Provider$Company$Account$companyAccountPath,
				$author$project$Api$Provider$Company$companyPath(companyId),
				companyAccountId));
	});
var $author$project$Api$Provider$CompanyRegistration$One$CompanyRegistration = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$CompanyRegistration$One$Record = function (patient) {
	return {YY: patient};
};
var $author$project$Api$Provider$CompanyRegistration$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'patient',
	$author$project$Api$Provider$Patient$Min$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyRegistration$One$Record));
var $author$project$Api$Provider$CompanyRegistration$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CompanyRegistration$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$CompanyRegistration$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyRegistration$One$CompanyRegistration)));
var $author$project$Api$Provider$Company$Registration$create = F5(
	function (apiClient, companyId, companyAccountId, jsonBody, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CompanyRegistration$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				jsonBody,
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Provider$Company$Registration$companyRegistrationsPath, companyId, companyAccountId))));
	});
var $author$project$Api$CompanyRegistration$create = F6(
	function (apiClient, session, companyId, accountId, jsonBody, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4(
			$author$project$Api$Employer$CompanyRegistration$create,
			apiClient,
			accountId,
			jsonBody,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyRegistration$One$Employer))) : A5(
			$author$project$Api$Provider$Company$Registration$create,
			apiClient,
			companyId,
			accountId,
			jsonBody,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyRegistration$One$Provider)));
	});
var $author$project$Components$Patient$Form$PatientLinked = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$AffiliateInput$affiliateId = function (_v0) {
	var value = _v0.aee;
	return A2(
		$elm$core$Maybe$map,
		function ($) {
			return $.ahP;
		},
		value);
};
var $author$project$Api$Employer$Affiliate$affiliatePath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		$author$project$Api$Employer$Affiliate$affiliatesPath);
};
var $author$project$Api$Employer$Affiliates$Patient$create = F4(
	function (apiClient, affiliateId, patientId, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'patient_id',
							$elm$json$Json$Encode$string(patientId))
						])),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['patients']),
						$author$project$Api$Employer$Affiliate$affiliatePath(affiliateId)))));
	});
var $author$project$Api$Provider$Affiliates$Patient$create = F4(
	function (apiClient, affiliateId, patientId, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'patient_id',
							$elm$json$Json$Encode$string(patientId))
						])),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['patients']),
						$author$project$Api$Provider$Affiliate$affiliatePath(affiliateId)))));
	});
var $author$project$Api$Affiliates$Patient$create = F5(
	function (apiClient, session, affiliateId, patientId, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4($author$project$Api$Employer$Affiliates$Patient$create, apiClient, affiliateId, patientId, toMsg) : A4($author$project$Api$Provider$Affiliates$Patient$create, apiClient, affiliateId, patientId, toMsg);
	});
var $author$project$Api$Employer$Affiliates$Patient$delete = F4(
	function (apiClient, affiliateId, patientId, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['patients', patientId]),
					$author$project$Api$Employer$Affiliate$affiliatePath(affiliateId))));
	});
var $author$project$Api$Provider$Affiliates$Patient$delete = F4(
	function (apiClient, affiliateId, patientId, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['patients', patientId]),
					$author$project$Api$Provider$Affiliate$affiliatePath(affiliateId))));
	});
var $author$project$Api$Affiliates$Patient$delete = F5(
	function (apiClient, session, affiliateId, patientId, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4($author$project$Api$Employer$Affiliates$Patient$delete, apiClient, affiliateId, patientId, toMsg) : A4($author$project$Api$Provider$Affiliates$Patient$delete, apiClient, affiliateId, patientId, toMsg);
	});
var $author$project$Components$Patient$Form$createAffiliation = F5(
	function (authToken, session, patientId, affiliationId, _v0) {
		var settings = _v0.a;
		var form = _v0.b;
		return settings.acI ? A2(
			$elm$core$Maybe$withDefault,
			function () {
				if (affiliationId.$ === 1) {
					return {xZ: false, GZ: $elm$core$Platform$Cmd$none};
				} else {
					var affiliationId_ = affiliationId.a;
					return {
						xZ: true,
						GZ: A5($author$project$Api$Affiliates$Patient$delete, authToken, session, affiliationId_, patientId, $author$project$Components$Patient$Form$PatientLinked)
					};
				}
			}(),
			A2(
				$elm$core$Maybe$map,
				function (affiliateId) {
					return {
						xZ: true,
						GZ: A5($author$project$Api$Affiliates$Patient$create, authToken, session, affiliateId, patientId, $author$project$Components$Patient$Form$PatientLinked)
					};
				},
				$author$project$Components$AffiliateInput$affiliateId(
					$author$project$Utils$Form$fields(form).Gn))) : {xZ: false, GZ: $elm$core$Platform$Cmd$none};
	});
var $author$project$Api$Employer$Patient$Min$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Patient$Min$id = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$Min$id(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$Min$id(patient_);
	}
};
var $author$project$Api$Patient$Min$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Patient$Min$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$CompanyRegistration$One$patient = function (_v0) {
	var record = _v0.b;
	return record.YY;
};
var $author$project$Api$Provider$CompanyRegistration$One$patient = function (_v0) {
	var record = _v0.b;
	return record.YY;
};
var $author$project$Api$CompanyRegistration$One$patient = function (companyRegistration) {
	if (!companyRegistration.$) {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Patient$Min$Provider(
			$author$project$Api$Provider$CompanyRegistration$One$patient(companyRegistration_));
	} else {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Patient$Min$Employer(
			$author$project$Api$Employer$CompanyRegistration$One$patient(companyRegistration_));
	}
};
var $author$project$Components$Employee$Form$createEmployeeAffiliation = F4(
	function (authToken, session, registration, _v0) {
		var settings = _v0.a;
		var form = _v0.b;
		if (settings.YY.acI) {
			var patientId = $author$project$Api$Patient$Min$id(
				$author$project$Api$CompanyRegistration$One$patient(registration));
			var fields = $author$project$Utils$Form$fields(form);
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$Components$Employee$Form$PatientFormMsg,
				A5($author$project$Components$Patient$Form$createAffiliation, authToken, session, patientId, $elm$core$Maybe$Nothing, fields.YY).GZ);
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Components$EmployeeDependentTypeInput$account = function (_v0) {
	var dependentOf = _v0.gd;
	return dependentOf;
};
var $author$project$Components$Employee$Form$dependentOf = function (_v0) {
	var form = _v0.b;
	return $author$project$Components$EmployeeDependentTypeInput$account(
		$author$project$Utils$Form$fields(form).amg);
};
var $author$project$Components$EmployeeDivisionInput$encodeDivision = function (_v0) {
	var division = _v0.QO;
	if (!division.$) {
		var divisionId = division.a;
		return _List_fromArray(
			[
				_Utils_Tuple2(
				'division',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'id',
							$elm$json$Json$Encode$string(divisionId))
						])))
			]);
	} else {
		return _List_fromArray(
			[
				_Utils_Tuple2('division', $elm$json$Json$Encode$null)
			]);
	}
};
var $author$project$Components$Employee$Form$encodeAccount = F2(
	function (validFields, _v0) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(validFields);
		return function (encodedFields) {
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'account',
						$elm$json$Json$Encode$object(encodedFields))
					]));
		}(
			A2(
				$elm$core$List$append,
				$author$project$Components$EmployeeDivisionInput$encodeDivision(fields.QO),
				function () {
					var _v1 = fields.dj.a;
					if (!_v1.$) {
						var date = _v1.a;
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'eligibility_start_date',
								$elm$json$Json$Encode$string(
									$author$project$Utils$Date$toIsoString(date)))
							]);
					} else {
						return _List_Nil;
					}
				}()));
	});
var $author$project$Components$SponsorPlanInput$encode = function (_v0) {
	var value = _v0.aee;
	if (value.$ === 1) {
		return $elm$json$Json$Encode$null;
	} else {
		var companyPlan = value.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(
						$author$project$Api$Plan$id(
							$author$project$Api$CompanyPlan$plan(companyPlan))))
				]));
	}
};
var $author$project$Components$EmployeeDependentTypeInput$selectedType = function (_v0) {
	var type_ = _v0.amg;
	return type_;
};
var $author$project$Components$Employee$Form$encodeEnroll = F2(
	function (validFields, _v0) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(validFields);
		var encodedPlan = (fields.j1 && ($author$project$Components$EmployeeDependentTypeInput$selectedType(fields.amg) === 'employee')) ? _List_fromArray(
			[
				_Utils_Tuple2(
				'plan',
				$author$project$Components$SponsorPlanInput$encode(fields.Jb))
			]) : _List_Nil;
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'membership_start_date',
					$elm$json$Json$Encode$string(fields.WW)),
				encodedPlan));
	});
var $author$project$Components$Patient$Form$datePattern = $agustinrhcp$elm_mask$Mask$fromString('##/##/####');
var $author$project$Components$AddressInput$encodeWithPrefix = F2(
	function (prefix, _v0) {
		var model = _v0;
		var fields = $author$project$Utils$Form$fields(model.SD);
		return _List_fromArray(
			[
				_Utils_Tuple2(
				prefix + 'city',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.rE)),
				_Utils_Tuple2(
				prefix + 'country',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.rK)),
				_Utils_Tuple2(
				prefix + 'line1',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.cZ)),
				_Utils_Tuple2(
				prefix + 'line2',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.fA)),
				_Utils_Tuple2(
				prefix + 'state',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.uP)),
				_Utils_Tuple2(
				prefix + 'zip',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.vv))
			]);
	});
var $author$project$Components$AddressInput$encode = $author$project$Components$AddressInput$encodeWithPrefix('address_');
var $author$project$Components$EmergencyContactInput$relationshipToValue = function (rel) {
	switch (rel.$) {
		case 0:
			return 'spouse';
		case 1:
			return 'parent';
		case 2:
			return 'child';
		case 3:
			return 'sibling';
		case 4:
			return 'grandparent';
		case 5:
			return 'guardian';
		default:
			return 'other';
	}
};
var $author$project$Components$EmergencyContactInput$encode = function (_v0) {
	var form = _v0.SD;
	var encodeEmptyAsNull = function (value) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$json$Json$Encode$null,
			A2(
				$elm$core$Maybe$map,
				$elm$json$Json$Encode$string,
				$elm$core$String$isEmpty(value) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(value)));
	};
	var emergencyContact = $author$project$Utils$Form$fields(form);
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'first_name',
				encodeEmptyAsNull(emergencyContact.Sv)),
				_Utils_Tuple2(
				'last_name',
				encodeEmptyAsNull(emergencyContact.VH)),
				_Utils_Tuple2(
				'relationship',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2(
						$elm$core$Maybe$map,
						A2($elm$core$Basics$composeR, $author$project$Components$EmergencyContactInput$relationshipToValue, $elm$json$Json$Encode$string),
						emergencyContact.$q))),
				_Utils_Tuple2(
				'relationship_other',
				function (rel) {
					if ((!rel.$) && (rel.a.$ === 6)) {
						var other = rel.a.a;
						return $elm$json$Json$Encode$string(other);
					} else {
						return $elm$json$Json$Encode$null;
					}
				}(emergencyContact.$q)),
				_Utils_Tuple2(
				'phone',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2(
						$elm$core$Maybe$map,
						function (phone) {
							return $elm$core$String$isEmpty(phone.IO) ? $elm$json$Json$Encode$null : $author$project$Api$Common$Phone$Shared$encode(phone);
						},
						A2(
							$elm$core$Maybe$map,
							$author$project$Utils$Phone$toRecord,
							A2(
								$elm$core$Maybe$andThen,
								$elm$core$List$head,
								$author$project$Components$PhoneInput$getPhones(emergencyContact.Zw)))))),
				_Utils_Tuple2(
				'email',
				encodeEmptyAsNull(emergencyContact.Rj))
			]));
};
var $author$project$Components$HealthInsuranceInput$encode = function (_v0) {
	var maybeCarrierAndInsurance = _v0.c;
	if (maybeCarrierAndInsurance.$ === 1) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2('group_id', $elm$json$Json$Encode$null),
					_Utils_Tuple2('member_id', $elm$json$Json$Encode$null),
					_Utils_Tuple2('high_deductible', $elm$json$Json$Encode$null),
					_Utils_Tuple2('carrier', $elm$json$Json$Encode$null),
					_Utils_Tuple2('payer_name', $elm$json$Json$Encode$null)
				]));
	} else {
		var _v2 = maybeCarrierAndInsurance.a;
		var insuranceCarrier = _v2.a;
		var record = _v2.b;
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'group_id',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, record.S$))),
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						'member_id',
						A2(
							$elm$core$Maybe$withDefault,
							$elm$json$Json$Encode$null,
							A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, record.WL))),
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'high_deductible',
							A2(
								$elm$core$Maybe$withDefault,
								$elm$json$Json$Encode$null,
								A2($elm$core$Maybe$map, $elm$json$Json$Encode$bool, record.Tt))),
						function () {
							if (!insuranceCarrier.$) {
								var carrierAlias = insuranceCarrier.a;
								return _List_fromArray(
									[
										_Utils_Tuple2(
										'carrier',
										$elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'id',
													$elm$json$Json$Encode$string(carrierAlias.GV))
												]))),
										_Utils_Tuple2(
										'payer_name',
										$elm$json$Json$Encode$string(carrierAlias.Bq))
									]);
							} else {
								var name = insuranceCarrier.a.Bq;
								return _List_fromArray(
									[
										_Utils_Tuple2('carrier', $elm$json$Json$Encode$null),
										_Utils_Tuple2(
										'payer_name',
										$elm$json$Json$Encode$string(name))
									]);
							}
						}()))));
	}
};
var $author$project$Components$KnownPracticeInput$encode = function (_v0) {
	var knowPractice = _v0.b;
	if (!knowPractice.$) {
		if (!knowPractice.a.$) {
			var knownPractice_ = knowPractice.a.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'id',
						$elm$json$Json$Encode$string(knownPractice_.ahP))
					]));
		} else {
			var name = knowPractice.a.a.Bq;
			var website = knowPractice.a.a.F9;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'other',
						$elm$json$Json$Encode$string(name)),
						_Utils_Tuple2(
						'website',
						$elm$core$String$isEmpty(website) ? $elm$json$Json$Encode$null : $elm$json$Json$Encode$string(website))
					]));
		}
	} else {
		return $elm$json$Json$Encode$null;
	}
};
var $author$project$Components$LeadSourceInput$encode = function (_v0) {
	var selected = _v0.aB;
	var other = _v0.dx;
	var strSelected = A2($elm$core$Maybe$withDefault, '', selected);
	return ($elm$core$String$length(strSelected) > 0) ? _List_fromArray(
		[
			_Utils_Tuple2(
			'lead_source',
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'id',
						$elm$json$Json$Encode$string(strSelected))
					]))),
			_Utils_Tuple2(
			'lead_source_other',
			A2(
				$elm$core$Maybe$withDefault,
				$elm$json$Json$Encode$null,
				A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, other)))
		]) : _List_fromArray(
		[
			_Utils_Tuple2('lead_source', $elm$json$Json$Encode$null),
			_Utils_Tuple2('lead_source_other', $elm$json$Json$Encode$null)
		]);
};
var $author$project$Components$LocationInput$encode = function (_v0) {
	var value = _v0.aee;
	if (value.$ === 1) {
		return $elm$json$Json$Encode$null;
	} else {
		var location = value.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(location.ahP))
				]));
	}
};
var $author$project$Components$NameInput$encodeString = function (string) {
	if (string === '') {
		return $elm$json$Json$Encode$null;
	} else {
		return $elm$json$Json$Encode$string(string);
	}
};
var $author$project$Components$NameInput$encodeWithPrefix = F2(
	function (prefix, _v0) {
		var fields = _v0.c;
		var _v1 = fields;
		var title = _v1.ac9;
		var firstName = _v1.Sv;
		var middleName = _v1.W7;
		var lastName = _v1.VH;
		var suffix = _v1.acE;
		return A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				prefix + 'title',
				$author$project$Components$NameInput$encodeString(title)),
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					prefix + 'first_name',
					$author$project$Components$NameInput$encodeString(firstName)),
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						prefix + 'middle_name',
						$author$project$Components$NameInput$encodeString(middleName)),
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							prefix + 'last_name',
							$author$project$Components$NameInput$encodeString(lastName)),
						function () {
							if (!suffix.$) {
								var s = suffix.a;
								return _List_fromArray(
									[
										_Utils_Tuple2(
										prefix + 'suffix',
										$author$project$Components$NameInput$encodeString(s))
									]);
							} else {
								return _List_Nil;
							}
						}()))));
	});
var $author$project$Components$NameInput$encode = $author$project$Components$NameInput$encodeWithPrefix('');
var $author$project$Components$PractitionerInput$encode = function (_v0) {
	var value = _v0.aee;
	if (value.$ === 1) {
		return $elm$json$Json$Encode$null;
	} else {
		var practitioner = value.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(practitioner.ahP))
				]));
	}
};
var $author$project$Components$Patient$Form$encodeBillingAddress = function (maybeBillingAddress) {
	if (!maybeBillingAddress.$) {
		var billingAddress = maybeBillingAddress.a;
		return A2($author$project$Components$AddressInput$encodeWithPrefix, 'billing_address_', billingAddress);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Patient$Form$encodeGender = F2(
	function (maybeGender, genderOther) {
		if (!maybeGender.$) {
			if (maybeGender.a === 3) {
				var _v1 = maybeGender.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'gender',
						$elm$json$Json$Encode$string('other')),
						_Utils_Tuple2(
						'gender_other',
						A2(
							$elm$core$Maybe$withDefault,
							$elm$json$Json$Encode$null,
							A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, genderOther)))
					]);
			} else {
				var rest = maybeGender.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'gender',
						$elm$json$Json$Encode$string(
							$author$project$Api$Gender$toString(rest))),
						_Utils_Tuple2('gender_other', $elm$json$Json$Encode$null)
					]);
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Api$GenderIdentity$toString = function (genderIdentity) {
	switch (genderIdentity.$) {
		case 0:
			return 'man';
		case 1:
			return 'woman';
		case 2:
			return 'non-binary';
		case 3:
			return 'trans man';
		case 4:
			return 'trans woman';
		default:
			return 'not listed';
	}
};
var $author$project$Components$Patient$Form$encodeGenderIdentity = function (maybeGenderIdentity) {
	if (maybeGenderIdentity.$ === 1) {
		return _List_fromArray(
			[
				_Utils_Tuple2('gender_identity', $elm$json$Json$Encode$null)
			]);
	} else {
		if (maybeGenderIdentity.a.$ === 5) {
			var other = maybeGenderIdentity.a.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'gender_identity',
					$elm$json$Json$Encode$string('not listed')),
					_Utils_Tuple2(
					'gender_other',
					$elm$json$Json$Encode$string(other))
				]);
		} else {
			var genderIdentity = maybeGenderIdentity.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'gender_identity',
					$elm$json$Json$Encode$string(
						$author$project$Api$GenderIdentity$toString(genderIdentity))),
					_Utils_Tuple2('gender_other', $elm$json$Json$Encode$null)
				]);
		}
	}
};
var $author$project$Components$Patient$Form$encodePhones = function (phones) {
	return A2(
		$elm$json$Json$Encode$list,
		A2($elm$core$Basics$composeR, $author$project$Utils$Phone$toRecord, $author$project$Api$Common$Phone$Shared$encode),
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			$author$project$Components$PhoneInput$getPhones(phones)));
};
var $author$project$Api$Pronoun$toString = function (pronoun) {
	switch (pronoun.$) {
		case 0:
			return 'He/Him/His';
		case 1:
			return 'She/Her/Hers';
		case 2:
			return 'They/Them/Theirs';
		default:
			return 'Not Listed';
	}
};
var $author$project$Components$Patient$Form$encodePronoun = function (maybePronoun) {
	if (maybePronoun.$ === 1) {
		return _Utils_Tuple2('pronoun', $elm$json$Json$Encode$null);
	} else {
		if (maybePronoun.a.$ === 3) {
			var other = maybePronoun.a.a;
			return _Utils_Tuple2(
				'pronoun',
				$elm$json$Json$Encode$string(other));
		} else {
			var pronoun = maybePronoun.a;
			return _Utils_Tuple2(
				'pronoun',
				$elm$json$Json$Encode$string(
					$author$project$Api$Pronoun$toString(pronoun)));
		}
	}
};
var $author$project$Components$Patient$Form$encodeSex = function (maybeSex) {
	if (!maybeSex.$) {
		var sex = maybeSex.a;
		return _List_fromArray(
			[
				_Utils_Tuple2(
				'sex',
				$elm$json$Json$Encode$string(
					$author$project$Api$Gender$toString(sex)))
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Patient$Form$encodePatient = F2(
	function (validFields, _v0) {
		var settings = _v0.a;
		var fields = $rtfeldman$elm_validate$Validate$fromValid(validFields);
		var encodeMaskedDate = function (stringDate) {
			return A2(
				$elm$core$Maybe$withDefault,
				$elm$json$Json$Encode$null,
				$elm$core$Result$toMaybe(
					A2(
						$elm$core$Result$map,
						$author$project$Utils$Date$encode,
						$author$project$Utils$Date$fromUsString(
							A2($agustinrhcp$elm_mask$Mask$mask, $author$project$Components$Patient$Form$datePattern, stringDate)))));
		};
		var appendIfSetting = F3(
			function (getter, appending, original) {
				return getter(settings) ? A2($elm$core$List$append, appending, original) : original;
			});
		var add = F2(
			function (item, list) {
				return _Utils_ap(
					list,
					_List_fromArray(
						[item]));
			});
		var addIfSetting = F3(
			function (getter, item, list) {
				return getter(settings) ? A2(add, item, list) : list;
			});
		var _v1 = fields;
		var billingAddress = _v1.MF;
		var usesBillingAddress = _v1.ad3;
		var healthInsurance = _v1.Tm;
		var syncToEmr = _v1.acM;
		var profilePictureUrl = _v1._A;
		var profilePicture = function () {
			if (!profilePictureUrl.$) {
				var base64 = profilePictureUrl.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'profile_picture',
						$elm$json$Json$Encode$string(base64))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var _v2 = fields;
		var genderIdentity = _v2.SS;
		var sex = _v2.aa8;
		var address = _v2.K2;
		var ssn = _v2.ab5;
		var knownPractice = _v2.Vy;
		var tobaccoUse = _v2.qz;
		var practitioner = _v2.aka;
		var location = _v2.ais;
		var _v3 = fields;
		var legalName = _v3.VU;
		var chosenName = _v3.bU;
		var email = _v3.Rj;
		var pronoun = _v3._B;
		var phones = _v3.Zy;
		var dateOfBirth = _v3.PF;
		var joinedPractice = _v3.j5;
		var leadSource = _v3.VR;
		var _v4 = fields;
		var preferredLanguage = _v4.Z9;
		var emergencyContact = _v4.Rl;
		return function (encodedFields) {
			return _Utils_Tuple2(
				'patient',
				$elm$json$Json$Encode$object(encodedFields));
		}(
			A2(
				add,
				_Utils_Tuple2(
					'emergency_contact',
					$author$project$Components$EmergencyContactInput$encode(emergencyContact)),
				A3(
					addIfSetting,
					function ($) {
						return $.tc;
					},
					_Utils_Tuple2(
						'preferred_language',
						$elm$json$Json$Encode$string(
							$author$project$Language$toValue(preferredLanguage))),
					A2(
						$elm$core$List$append,
						profilePicture,
						A2(
							$elm$core$List$append,
							$author$project$Components$Patient$Form$encodeBillingAddress(billingAddress),
							A2(
								add,
								_Utils_Tuple2(
									'uses_billing_address',
									$elm$json$Json$Encode$bool(usesBillingAddress)),
								A2(
									$elm$core$List$append,
									$author$project$Components$AddressInput$encode(address),
									A3(
										addIfSetting,
										function ($) {
											return $.afn;
										},
										_Utils_Tuple2(
											'sync_to_emr',
											$elm$json$Json$Encode$bool(syncToEmr)),
										A2(
											add,
											_Utils_Tuple2(
												'phones',
												$author$project$Components$Patient$Form$encodePhones(phones)),
											A3(
												appendIfSetting,
												function ($) {
													return $.adv;
												},
												$author$project$Components$Patient$Form$encodeGenderIdentity(genderIdentity),
												A3(
													addIfSetting,
													function ($) {
														return $.adv;
													},
													$author$project$Components$Patient$Form$encodePronoun(pronoun),
													A3(
														appendIfSetting,
														function ($) {
															return $.adv;
														},
														$author$project$Components$Patient$Form$encodeSex(sex),
														A3(
															appendIfSetting,
															A2(
																$elm$core$Basics$composeR,
																function ($) {
																	return $.adv;
																},
																$elm$core$Basics$not),
															A2($author$project$Components$Patient$Form$encodeGender, fields.SR, fields.ST),
															A2(
																add,
																_Utils_Tuple2(
																	'health_insurance',
																	$author$project$Components$HealthInsuranceInput$encode(healthInsurance)),
																A3(
																	addIfSetting,
																	function ($) {
																		return $.aiC;
																	},
																	_Utils_Tuple2(
																		'known_practice',
																		$author$project$Components$KnownPracticeInput$encode(knownPractice)),
																	A2(
																		$elm$core$List$append,
																		$author$project$Components$LeadSourceInput$encode(leadSource),
																		A2(
																			add,
																			_Utils_Tuple2(
																				'joined_practice_date',
																				A2(
																					$elm$core$Maybe$withDefault,
																					$elm$json$Json$Encode$null,
																					A2($elm$core$Maybe$map, $author$project$Utils$Date$encode, joinedPractice.a))),
																			A3(
																				addIfSetting,
																				function (_v6) {
																					var hasLocations = _v6.Tb;
																					var trackPatientsByLocation = _v6.adt;
																					return hasLocations && trackPatientsByLocation;
																				},
																				_Utils_Tuple2(
																					'location',
																					$author$project$Components$LocationInput$encode(location)),
																				A3(
																					addIfSetting,
																					function ($) {
																						return $.Th;
																					},
																					_Utils_Tuple2(
																						'practitioner',
																						$author$project$Components$PractitionerInput$encode(practitioner)),
																					A3(
																						addIfSetting,
																						function ($) {
																							return $.al8;
																						},
																						_Utils_Tuple2(
																							'uses_tobacco',
																							A2(
																								$elm$core$Maybe$withDefault,
																								$elm$json$Json$Encode$null,
																								A2($elm$core$Maybe$map, $elm$json$Json$Encode$bool, tobaccoUse))),
																						A3(
																							addIfSetting,
																							function (_v5) {
																								var ssnEnabled = _v5.ab6;
																								var userIsAdmin = _v5.F1;
																								var isNew = _v5.j1;
																								return ssnEnabled && (userIsAdmin || isNew);
																							},
																							_Utils_Tuple2(
																								'ssn',
																								$elm$json$Json$Encode$object(
																									_List_fromArray(
																										[
																											_Utils_Tuple2(
																											'number',
																											$elm$json$Json$Encode$string(ssn))
																										]))),
																							A2(
																								add,
																								_Utils_Tuple2(
																									'dob',
																									encodeMaskedDate(dateOfBirth)),
																								A2(
																									add,
																									_Utils_Tuple2(
																										'email',
																										A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, email)),
																									A2(
																										$elm$core$List$append,
																										A2(
																											$author$project$Components$NameInput$encodeWithPrefix,
																											'chosen_',
																											A2($elm$core$Maybe$withDefault, $author$project$Components$NameInput$empty, chosenName)),
																										$author$project$Components$NameInput$encode(legalName)))))))))))))))))))))))));
	});
var $author$project$Components$EmployeeDependentTypeInput$encodeType = function (_v0) {
	var type_ = _v0.amg;
	return _Utils_Tuple2(
		'type',
		$elm$json$Json$Encode$string(type_));
};
var $author$project$Components$EmergencyContactInput$ContactIdentificationValidation = 0;
var $author$project$Components$EmergencyContactInput$EmailValidation = 2;
var $author$project$Components$EmergencyContactInput$PhoneValidation = 1;
var $author$project$Components$EmergencyContactInput$RelationshipOtherValidation = 3;
var $author$project$Components$EmergencyContactInput$formFieldsValidator = function () {
	var validatePhone = function (_v7) {
		var phone = _v7.Zw;
		return $author$project$Components$PhoneInput$hasErrors(phone) ? _List_fromArray(
			[
				_Utils_Tuple2(1, '')
			]) : _List_Nil;
	};
	var validateContact = function (_v6) {
		var firstName = _v6.Sv;
		var lastName = _v6.VH;
		var relationship = _v6.$q;
		var email = _v6.Rj;
		var phone = _v6.Zw;
		var relationshipIsNone = function () {
			if (relationship.$ === 1) {
				return true;
			} else {
				return false;
			}
		}();
		var nameIsEmpty = A2(
			$elm$core$List$all,
			$elm$core$String$isEmpty,
			_List_fromArray(
				[firstName, lastName]));
		var contactIsEmpty = function () {
			var number = A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Utils$Phone$toRecord,
					function ($) {
						return $.IO;
					}),
				A2(
					$elm$core$Maybe$andThen,
					$elm$core$List$head,
					$author$project$Components$PhoneInput$getPhones(phone)));
			var _v4 = _Utils_Tuple2(number, email);
			if (((!_v4.a.$) && (_v4.a.a === '')) && (_v4.b === '')) {
				return true;
			} else {
				return false;
			}
		}();
		var _v3 = _Utils_Tuple2(nameIsEmpty && relationshipIsNone, contactIsEmpty);
		if (_v3.a) {
			if (_v3.b) {
				return _List_Nil;
			} else {
				return _List_fromArray(
					[
						_Utils_Tuple2(0, 'Please enter at least one of first name, last name or relationship.')
					]);
			}
		} else {
			if (!_v3.b) {
				return _List_Nil;
			} else {
				return _List_Nil;
			}
		}
	};
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				$rtfeldman$elm_validate$Validate$fromErrors(validateContact),
				$rtfeldman$elm_validate$Validate$fromErrors(validatePhone),
				A2(
				$rtfeldman$elm_validate$Validate$ifFalse,
				function (_v0) {
					var email = _v0.Rj;
					return $rtfeldman$elm_validate$Validate$isBlank(email) || $rtfeldman$elm_validate$Validate$isValidEmail(email);
				},
				_Utils_Tuple2(2, 'Please enter a valid email.')),
				A2(
				$rtfeldman$elm_validate$Validate$ifFalse,
				function (_v1) {
					var relationship = _v1.$q;
					if (((!relationship.$) && (relationship.a.$ === 6)) && (relationship.a.a === '')) {
						return false;
					} else {
						return true;
					}
				},
				_Utils_Tuple2(3, 'Please enter relationship.'))
			]));
}();
var $author$project$Components$EmergencyContactInput$validateForm = function (form) {
	var emergencyContact = $author$project$Utils$Form$fields(form);
	var form_ = A2(
		$author$project$Utils$Form$set,
		_Utils_update(
			emergencyContact,
			{
				Zw: $author$project$Components$PhoneInput$validate(emergencyContact.Zw)
			}),
		form);
	var _v0 = A2($author$project$Utils$Form$validate, $author$project$Components$EmergencyContactInput$formFieldsValidator, form_);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var f = _v1.a;
		return _Utils_Tuple2(f, true);
	} else {
		var f = _v0.a;
		return _Utils_Tuple2(f, false);
	}
};
var $author$project$Components$EmergencyContactInput$validate = function (model) {
	return function (f) {
		return _Utils_update(
			model,
			{SD: f});
	}(
		$author$project$Components$EmergencyContactInput$validateForm(model.SD).a);
};
var $author$project$Components$NameInput$FirstNameValidation = 0;
var $author$project$Components$NameInput$validateFirstName = function (_v0) {
	var firstName = _v0.c.Sv;
	return $author$project$Utils$String$isBlank(firstName) ? _List_fromArray(
		[
			_Utils_Tuple2(0, 'Please enter first name')
		]) : _List_Nil;
};
var $author$project$Components$NameInput$LastNameValidation = 1;
var $author$project$Components$NameInput$validateLastName = function (_v0) {
	var lastName = _v0.c.VH;
	return $author$project$Utils$String$isBlank(lastName) ? _List_fromArray(
		[
			_Utils_Tuple2(1, 'Please enter last name')
		]) : _List_Nil;
};
var $author$project$Components$NameInput$validator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$NameInput$validateFirstName),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$NameInput$validateLastName)
		]));
var $author$project$Components$NameInput$validate = function (_v0) {
	var options = _v0.b;
	var fields = _v0.c;
	return $author$project$Utils$Result$merge(
		A2(
			$elm$core$Result$mapError,
			function (errors) {
				return A3($author$project$Components$NameInput$Model, errors, options, fields);
			},
			A2(
				$elm$core$Result$map,
				$rtfeldman$elm_validate$Validate$fromValid,
				A2(
					$rtfeldman$elm_validate$Validate$validate,
					$author$project$Components$NameInput$validator,
					A3($author$project$Components$NameInput$Model, _List_Nil, options, fields)))));
};
var $author$project$Components$Patient$Form$KnownPracticeValidation = 7;
var $author$project$Components$Patient$Form$LocationValidation = 9;
var $author$project$Components$Patient$Form$PractitionerValidation = 8;
var $author$project$Components$Patient$Form$SSNValidation = 6;
var $author$project$Components$Patient$Form$EmailValidation = 2;
var $author$project$Components$Patient$Form$emailValidator = function (requiresEmail) {
	return A3(
		$author$project$Utils$Validate$ifInvalidEmail,
		{aeT: !requiresEmail},
		function ($) {
			return $.Rj;
		},
		_Utils_Tuple2(2, 'Please enter a valid email.'));
};
var $author$project$Components$Patient$Form$ProfilePictureValidation = 11;
var $author$project$Components$Patient$Form$computeMaxPictureBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
var $author$project$Components$Patient$Form$profilePictureValidator = A3(
	$author$project$Utils$Validate$ifIntGreaterThan,
	function ($) {
		return $.t5;
	},
	$author$project$Components$Patient$Form$computeMaxPictureBytesSize,
	_Utils_Tuple2(11, 'That image is too large! Our maximum image size is 5 mb, please choose a smaller image.'));
var $author$project$Components$KnownPracticeInput$validate = F2(
	function (getter, formatter) {
		return A2(
			$rtfeldman$elm_validate$Validate$ifTrue,
			function (model) {
				var _v0 = getter(model);
				if ((!_v0.b.$) && (_v0.b.a.$ === 1)) {
					var name = _v0.b.a.a.Bq;
					return $rtfeldman$elm_validate$Validate$isBlank(name);
				} else {
					return false;
				}
			},
			formatter('DPC name cannot be blank'));
	});
var $author$project$Components$LocationInput$validate = F3(
	function (isRequired, getter, formatter) {
		return A2(
			$rtfeldman$elm_validate$Validate$ifFalse,
			function (model) {
				var _v0 = getter(model);
				var value = _v0.aee;
				var _v1 = _Utils_Tuple2(isRequired, value);
				if (_v1.a && (_v1.b.$ === 1)) {
					var _v2 = _v1.b;
					return false;
				} else {
					return true;
				}
			},
			formatter('Please select a location.'));
	});
var $author$project$Components$PractitionerInput$validate = F3(
	function (isRequired, getter, formatter) {
		return A2(
			$rtfeldman$elm_validate$Validate$ifFalse,
			function (model) {
				var _v0 = getter(model);
				var value = _v0.aee;
				var _v1 = _Utils_Tuple2(isRequired, value);
				if (_v1.a && (_v1.b.$ === 1)) {
					var _v2 = _v1.b;
					return false;
				} else {
					return true;
				}
			},
			formatter('Please select a practitioner'));
	});
var $author$project$Utils$Validate$alwaysValid = $rtfeldman$elm_validate$Validate$all(_List_Nil);
var $author$project$Components$SocialSecurityNumberInput$isComplete = function (ssn) {
	return $elm$core$String$length(ssn) === 9;
};
var $author$project$Components$SocialSecurityNumberInput$validate = F3(
	function (isRequired, getter, formatter) {
		var isRequired_ = isRequired ? A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function (model) {
				return getter(model);
			},
			formatter('Please enter SSN.')) : $author$project$Utils$Validate$alwaysValid;
		var containsNineDigits = A2(
			$rtfeldman$elm_validate$Validate$ifFalse,
			function (model) {
				var ssn = getter(model);
				return $elm$core$String$isEmpty(ssn) || $author$project$Components$SocialSecurityNumberInput$isComplete(ssn);
			},
			formatter('SSN must contain 9 digits.'));
		return $rtfeldman$elm_validate$Validate$all(
			_List_fromArray(
				[isRequired_, containsNineDigits]));
	});
var $author$project$Components$Patient$Form$AddressValidation = 4;
var $author$project$Components$Patient$Form$validateAddress = function (_v0) {
	var address = _v0.K2;
	return $author$project$Components$AddressInput$isValid(address) ? _List_Nil : _List_fromArray(
		[
			_Utils_Tuple2(4, '')
		]);
};
var $author$project$Components$Patient$Form$BillingAddressValidation = 5;
var $author$project$Components$Patient$Form$validateBillingAddress = function (_v0) {
	var billingAddress = _v0.MF;
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (address) {
				return $author$project$Components$AddressInput$isValid(address) ? _List_Nil : _List_fromArray(
					[
						_Utils_Tuple2(5, '')
					]);
			},
			billingAddress));
};
var $author$project$Components$Patient$Form$ChosenNameValidation = 1;
var $author$project$Components$NameInput$hasErrors = function (_v0) {
	var errors = _v0.a;
	return !$elm$core$List$isEmpty(errors);
};
var $author$project$Components$Patient$Form$validateChosenName = function (_v0) {
	var chosenName = _v0.bU;
	var nameHasErrors = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2($elm$core$Maybe$map, $author$project$Components$NameInput$hasErrors, chosenName));
	return nameHasErrors ? _List_fromArray(
		[
			_Utils_Tuple2(1, '')
		]) : _List_Nil;
};
var $author$project$Components$Patient$Form$DateOfBirthValidation = 10;
var $author$project$Components$Patient$Form$validateDateOfBirth = F2(
	function (requiresDOB, _v0) {
		var dateOfBirth = _v0.PF;
		if (!$elm$core$String$length(dateOfBirth)) {
			return requiresDOB ? _List_fromArray(
				[
					_Utils_Tuple2(10, 'Please enter a date of birth.')
				]) : _List_Nil;
		} else {
			var _v1 = $author$project$Utils$Date$fromUsString(
				A2($agustinrhcp$elm_mask$Mask$mask, $author$project$Components$Patient$Form$datePattern, dateOfBirth));
			if (_v1.$ === 1) {
				return _List_fromArray(
					[
						_Utils_Tuple2(10, '')
					]);
			} else {
				return _List_Nil;
			}
		}
	});
var $author$project$Components$Patient$Form$EmergencyContactValidation = 12;
var $author$project$Components$EmergencyContactInput$isValid = function (_v0) {
	var form = _v0.SD;
	return $author$project$Components$EmergencyContactInput$validateForm(form).b;
};
var $author$project$Components$Patient$Form$validateEmergencyContact = function (_v0) {
	var emergencyContact = _v0.Rl;
	return $author$project$Components$EmergencyContactInput$isValid(emergencyContact) ? _List_Nil : _List_fromArray(
		[
			_Utils_Tuple2(12, '')
		]);
};
var $author$project$Components$Patient$Form$LegalNameValidation = 0;
var $author$project$Components$Patient$Form$validateLegalName = function (_v0) {
	var legalName = _v0.VU;
	return $author$project$Components$NameInput$hasErrors(legalName) ? _List_fromArray(
		[
			_Utils_Tuple2(0, '')
		]) : _List_Nil;
};
var $author$project$Components$Patient$Form$PhonesValidation = 3;
var $author$project$Components$Patient$Form$validatePhones = function (_v0) {
	var phones = _v0.Zy;
	return $author$project$Components$PhoneInput$hasErrors(phones) ? _List_fromArray(
		[
			_Utils_Tuple2(3, '')
		]) : _List_Nil;
};
var $author$project$Components$Patient$Form$validator = function (_v0) {
	var requiresEmail = _v0.akV;
	var requiresDOB = _v0.Ee;
	var ssnEnabled = _v0.ab6;
	var requiresSSN = _v0.$N;
	var userIsAdmin = _v0.F1;
	var isNew = _v0.j1;
	var requiresPractitioner = _v0.$M;
	var requiresLocation = _v0.$G;
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				$author$project$Components$Patient$Form$emailValidator(requiresEmail),
				A3(
				$author$project$Components$SocialSecurityNumberInput$validate,
				ssnEnabled && (requiresSSN && (userIsAdmin || isNew)),
				function ($) {
					return $.ab5;
				},
				function (error) {
					return _Utils_Tuple2(6, error);
				}),
				A2(
				$author$project$Components$KnownPracticeInput$validate,
				function ($) {
					return $.Vy;
				},
				function (error) {
					return _Utils_Tuple2(7, error);
				}),
				A3(
				$author$project$Components$PractitionerInput$validate,
				requiresPractitioner,
				function ($) {
					return $.aka;
				},
				function (error) {
					return _Utils_Tuple2(8, error);
				}),
				A3(
				$author$project$Components$LocationInput$validate,
				requiresLocation,
				function ($) {
					return $.ais;
				},
				function (error) {
					return _Utils_Tuple2(9, error);
				}),
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Patient$Form$validateLegalName),
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Patient$Form$validateChosenName),
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Patient$Form$validatePhones),
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Patient$Form$validateAddress),
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Patient$Form$validateBillingAddress),
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Patient$Form$validateEmergencyContact),
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$Patient$Form$validateDateOfBirth(requiresDOB)),
				$author$project$Components$Patient$Form$profilePictureValidator
			]));
};
var $author$project$Components$Patient$Form$validate = function (_v0) {
	var settings = _v0.a;
	var form = _v0.b;
	var fields = $author$project$Utils$Form$fields(form);
	return A2(
		$elm$core$Result$mapError,
		$author$project$Components$Patient$Form$PatientForm(settings),
		A2(
			$elm$core$Result$map,
			$elm$core$Tuple$mapFirst(
				$author$project$Components$Patient$Form$PatientForm(settings)),
			A2(
				$author$project$Utils$Form$validate,
				$author$project$Components$Patient$Form$validator(settings),
				A2(
					$author$project$Utils$Form$set,
					_Utils_update(
						fields,
						{
							K2: $author$project$Components$AddressInput$validate(fields.K2),
							MF: A2($elm$core$Maybe$map, $author$project$Components$AddressInput$validate, fields.MF),
							bU: A2($elm$core$Maybe$map, $author$project$Components$NameInput$validate, fields.bU),
							Rl: $author$project$Components$EmergencyContactInput$validate(fields.Rl),
							VU: $author$project$Components$NameInput$validate(fields.VU),
							Zy: $author$project$Components$PhoneInput$validate(fields.Zy)
						}),
					form))));
};
var $author$project$Components$Employee$Form$encodeRegistration = F2(
	function (validFields, _v0) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(validFields);
		var add = F2(
			function (item, list) {
				return _Utils_ap(
					list,
					_List_fromArray(
						[item]));
			});
		return function (encodedFields) {
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'registration',
						$elm$json$Json$Encode$object(encodedFields))
					]));
		}(
			A2(
				$elm$core$List$append,
				function () {
					var _v4 = fields.ag7;
					if (!_v4.$) {
						var externalId = _v4.a;
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'external_id',
								$elm$json$Json$Encode$string(externalId))
							]);
					} else {
						return _List_Nil;
					}
				}(),
				A2(
					$elm$core$List$append,
					function () {
						var _v3 = fields.dj.a;
						if (!_v3.$) {
							var date = _v3.a;
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'eligibility_start_date',
									$elm$json$Json$Encode$string(
										$author$project$Utils$Date$toIsoString(date)))
								]);
						} else {
							return _List_Nil;
						}
					}(),
					A2(
						add,
						$author$project$Components$EmployeeDependentTypeInput$encodeType(fields.amg),
						function () {
							var _v1 = $author$project$Components$Patient$Form$validate(fields.YY);
							if (!_v1.$) {
								var _v2 = _v1.a;
								var patientFields = _v2.b;
								return _List_fromArray(
									[
										A2($author$project$Components$Patient$Form$encodePatient, patientFields, fields.YY)
									]);
							} else {
								return _List_Nil;
							}
						}()))));
	});
var $author$project$Api$Employer$CompanyRegistration$companyRegistrationPath = F2(
	function (accountId, registrationId) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[registrationId]),
			$author$project$Api$Employer$CompanyRegistration$companyRegistrationsPath(accountId));
	});
var $author$project$Api$Employer$CompanyRegistration$enroll = F5(
	function (apiClient, accountId, registrationId, jsonBody, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Employer$CompanyRegistration$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				jsonBody,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['enroll']),
						A2($author$project$Api$Employer$CompanyRegistration$companyRegistrationPath, accountId, registrationId)))));
	});
var $author$project$Api$Provider$Company$Registration$companyRegistrationPath = F3(
	function (companyId, companyAccountId, registrationId) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[registrationId]),
			A2($author$project$Api$Provider$Company$Registration$companyRegistrationsPath, companyId, companyAccountId));
	});
var $author$project$Api$Provider$Company$Registration$enroll = F6(
	function (apiClient, companyId, companyAccountId, registrationId, jsonBody, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CompanyRegistration$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				jsonBody,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['enroll']),
						A3($author$project$Api$Provider$Company$Registration$companyRegistrationPath, companyId, companyAccountId, registrationId)))));
	});
var $author$project$Api$CompanyRegistration$enroll = F5(
	function (apiClient, session, _v0, jsonBody, toMsg) {
		var companyId = _v0.fZ;
		var accountId = _v0.fv;
		var registrationId = _v0.pA;
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A5(
			$author$project$Api$Employer$CompanyRegistration$enroll,
			apiClient,
			accountId,
			registrationId,
			jsonBody,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyRegistration$One$Employer))) : A6(
			$author$project$Api$Provider$Company$Registration$enroll,
			apiClient,
			companyId,
			accountId,
			registrationId,
			jsonBody,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyRegistration$One$Provider)));
	});
var $author$project$Api$Employer$CompanyAccount$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Employer$CompanyAccount$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$CompanyAccount$Shared$id(shared);
};
var $author$project$Api$Provider$CompanyAccount$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyAccount$Shared$id(shared);
};
var $author$project$Api$CompanyAccount$All$id = function (companyAccount) {
	if (!companyAccount.$) {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$Provider$CompanyAccount$All$id(companyAccount_);
	} else {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$Employer$CompanyAccount$All$id(companyAccount_);
	}
};
var $author$project$Api$Employer$CompanyAccount$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$CompanyAccount$Shared$id(shared);
};
var $author$project$Api$CompanyAccount$One$id = function (companyAccount) {
	if (!companyAccount.$) {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$Provider$CompanyAccount$One$id(companyAccount_);
	} else {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$Employer$CompanyAccount$One$id(companyAccount_);
	}
};
var $author$project$Api$Employer$CompanyRegistration$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Employer$CompanyRegistration$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$CompanyRegistration$Shared$id(shared);
};
var $author$project$Api$Provider$CompanyRegistration$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyRegistration$Shared$id(shared);
};
var $author$project$Api$CompanyRegistration$One$id = function (companyRegistration) {
	if (!companyRegistration.$) {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Provider$CompanyRegistration$One$id(companyRegistration_);
	} else {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Employer$CompanyRegistration$One$id(companyRegistration_);
	}
};
var $author$project$Components$Employee$Form$shouldEnroll = function (_v0) {
	var form = _v0.b;
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		$author$project$Utils$Form$fields(form).Rz);
};
var $author$project$Api$Employer$CompanyAccount$All$defaultEnrollmentStartDate = function (_v0) {
	var record = _v0.b;
	return record.PZ;
};
var $author$project$Api$Provider$CompanyAccount$All$defaultEnrollmentStartDate = function (_v0) {
	var record = _v0.b;
	return record.PZ;
};
var $author$project$Api$CompanyAccount$All$defaultEnrollmentStartDate = function (companyAccount) {
	if (!companyAccount.$) {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$Provider$CompanyAccount$All$defaultEnrollmentStartDate(companyAccount_);
	} else {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$Employer$CompanyAccount$All$defaultEnrollmentStartDate(companyAccount_);
	}
};
var $author$project$Api$Employer$CompanyAccount$All$invoicedThroughDate = function (_v0) {
	var record = _v0.b;
	return record.Uw;
};
var $author$project$Api$Provider$CompanyAccount$All$invoicedThroughDate = function (_v0) {
	var record = _v0.b;
	return record.Uw;
};
var $author$project$Api$CompanyAccount$All$invoicedThroughDate = function (companyAccount) {
	if (!companyAccount.$) {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$Provider$CompanyAccount$All$invoicedThroughDate(companyAccount_);
	} else {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$Employer$CompanyAccount$All$invoicedThroughDate(companyAccount_);
	}
};
var $author$project$Api$Employer$CompanyAccount$All$membershipStartDate = function (_v0) {
	var record = _v0.b;
	return record.WW;
};
var $author$project$Api$Provider$CompanyAccount$All$membershipStartDate = function (_v0) {
	var record = _v0.b;
	return record.WW;
};
var $author$project$Api$CompanyAccount$All$membershipStartDate = function (companyAccount) {
	if (!companyAccount.$) {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$Provider$CompanyAccount$All$membershipStartDate(companyAccount_);
	} else {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$Employer$CompanyAccount$All$membershipStartDate(companyAccount_);
	}
};
var $elm_community$maybe_extra$Maybe$Extra$orList = function (maybes) {
	orList:
	while (true) {
		if (!maybes.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (maybes.a.$ === 1) {
				var _v1 = maybes.a;
				var rest = maybes.b;
				var $temp$maybes = rest;
				maybes = $temp$maybes;
				continue orList;
			} else {
				var answer = maybes.a.a;
				return $elm$core$Maybe$Just(answer);
			}
		}
	}
};
var $author$project$Components$Employee$Form$dependentStartDate = function (account) {
	return $elm_community$maybe_extra$Maybe$Extra$orList(
		_List_fromArray(
			[
				$author$project$Api$CompanyAccount$All$defaultEnrollmentStartDate(account),
				$author$project$Api$CompanyAccount$All$invoicedThroughDate(account),
				$author$project$Api$CompanyAccount$All$membershipStartDate(account)
			]));
};
var $author$project$Api$Employer$CompanyAccount$All$status = function (_v0) {
	var record = _v0.b;
	return record.alH;
};
var $author$project$Api$Provider$CompanyAccount$All$status = function (_v0) {
	var record = _v0.b;
	return record.alH;
};
var $author$project$Api$CompanyAccount$All$status = function (companyAccount) {
	if (!companyAccount.$) {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$Provider$CompanyAccount$All$status(companyAccount_);
	} else {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$Employer$CompanyAccount$All$status(companyAccount_);
	}
};
var $author$project$Components$EmployeeDependentTypeInput$AccountSelected = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$EmployeeDependentTypeInput$None = {$: 2};
var $author$project$Components$EmployeeDependentTypeInput$TypeSelected = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$CompanyAccount$All$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$CompanyAccount$All$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$CompanyAccount$All$CompanyAccount = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Employer$CompanyAccount$All$Record = function (registrations) {
	return function (subscriber) {
		return function (division) {
			return function (membershipStartDate) {
				return function (defaultEnrollmentStartDate) {
					return function (invoicedThroughDate) {
						return function (membershipEndDate) {
							return function (status) {
								return function (plan) {
									return function (meta) {
										return {PZ: defaultEnrollmentStartDate, QO: division, Uw: invoicedThroughDate, WQ: membershipEndDate, WW: membershipStartDate, W4: meta, Jb: plan, akF: registrations, alH: status, acy: subscriber};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Employer$CompanyAccount$Meta$Meta = $elm$core$Basics$identity;
var $author$project$Api$Employer$CompanyAccount$Meta$Record = F2(
	function (actions, membership) {
		return {vy: actions, kk: membership};
	});
var $author$project$Api$Employer$CompanyAccount$Meta$ActionsRecord = F3(
	function (needsApproval, canEnroll, isEligible) {
		return {M8: canEnroll, UO: isEligible, Xx: needsApproval};
	});
var $author$project$Api$Employer$CompanyAccount$Meta$actionsRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'eligible',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'enroll',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'needs_approval',
			$elm$json$Json$Decode$bool,
			$elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyAccount$Meta$ActionsRecord))));
var $author$project$Api$Employer$CompanyAccount$Meta$MembershipRecord = F3(
	function (billFromDate, billingStartDate, endDate) {
		return {MD: billFromDate, MH: billingStartDate, sb: endDate};
	});
var $author$project$Api$Employer$CompanyAccount$Meta$EndDateRecord = F4(
	function (defaultValue, maxWithoutBilling, min, minWithoutProration) {
		return {Qf: defaultValue, WE: maxWithoutBilling, W9: min, Xc: minWithoutProration};
	});
var $author$project$Api$Employer$CompanyAccount$Meta$endDateRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'min_without_proration',
	$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'min',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'max_without_billing',
			$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'default_value',
				$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
				$elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyAccount$Meta$EndDateRecord)))));
var $author$project$Api$Employer$CompanyAccount$Meta$membershipRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'end_date',
	$author$project$Api$Employer$CompanyAccount$Meta$endDateRecordDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'billing_start_date',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'bill_from_date',
			$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
			$elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyAccount$Meta$MembershipRecord))));
var $author$project$Api$Employer$CompanyAccount$Meta$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'membership',
	$author$project$Api$Employer$CompanyAccount$Meta$membershipRecordDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'actions',
		$author$project$Api$Employer$CompanyAccount$Meta$actionsRecordDecoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyAccount$Meta$Record)));
var $author$project$Api$Employer$CompanyAccount$Meta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$CompanyAccount$Meta$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$CompanyRegistration = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$Record = F4(
	function (patient, status, membershipStartDate, meta) {
		return {WW: membershipStartDate, W4: meta, YY: patient, alH: status};
	});
var $author$project$Api$Employer$CompanyRegistration$Meta$Meta = $elm$core$Basics$identity;
var $author$project$Api$Employer$CompanyRegistration$Meta$Record = function (actions) {
	return {vy: actions};
};
var $author$project$Api$Employer$CompanyRegistration$Meta$ActionsRecord = F2(
	function (canEnroll, isEligible) {
		return {M8: canEnroll, UO: isEligible};
	});
var $author$project$Api$Employer$CompanyRegistration$Meta$actionsRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'eligible',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'enroll',
		$elm$json$Json$Decode$bool,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyRegistration$Meta$ActionsRecord)));
var $author$project$Api$Employer$CompanyRegistration$Meta$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'actions',
	$author$project$Api$Employer$CompanyRegistration$Meta$actionsRecordDecoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyRegistration$Meta$Record));
var $author$project$Api$Employer$CompanyRegistration$Meta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$CompanyRegistration$Meta$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'meta',
	$author$project$Api$Employer$CompanyRegistration$Meta$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'membership_start_date',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'status',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'patient',
				$author$project$Api$Employer$Patient$Min$decoder,
				$elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$Record)))));
var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Employer$CompanyRegistration$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$CompanyRegistration)));
var $author$project$Api$Employer$CompanyAccount$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'meta',
	$author$project$Api$Employer$CompanyAccount$Meta$decoder,
	A3(
		$author$project$Api$Expandable$expandable,
		'plan',
		$elm$json$Json$Decode$nullable($author$project$Api$Employer$Plan$Min$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'status',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'membership_end_date',
				$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'invoiced_through_date',
					$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'default_enrollment_start_date',
						$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'membership_start_date',
							$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'division',
								$elm$json$Json$Decode$nullable($author$project$Api$Employer$EmployeeDivision$Shared$decoder),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'subscriber',
									$elm$json$Json$Decode$nullable($author$project$Api$Employer$Patient$Shared$decoder),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'registrations',
										$elm$json$Json$Decode$list($author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$decoder),
										$elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyAccount$All$Record)))))))))));
var $author$project$Api$Employer$CompanyAccount$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$CompanyAccount$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Employer$CompanyAccount$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyAccount$All$CompanyAccount)));
var $author$project$Api$Employer$CompanyAccount$expandToString = function (expand) {
	if (expand === 1) {
		return 'plan';
	} else {
		return 'registrations';
	}
};
var $author$project$Api$Employer$CompanyAccount$listDefaults = {HE: _List_Nil, HM: $elm$core$Maybe$Nothing, ahP: $elm$core$Maybe$Nothing, ajJ: $author$project$Api$Pagination$init, akl: $elm$core$Maybe$Nothing, alA: $author$project$Api$Sort$init};
var $author$project$Api$Employer$CompanyAccount$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Employer$CompanyAccount$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.akl;
				if (!_v0.$) {
					var q = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', q)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.ahP;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.HM;
				if (!_v2.$) {
					var string = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'filter', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				A2($author$project$Api$Expandable$toParam, $author$project$Api$Employer$CompanyAccount$expandToString, options.HE),
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$Employer$CompanyAccount$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Employer$CompanyAccount$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Employer$CompanyAccount$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Employer$CompanyAccount$companyAccountsPath)));
	});
var $author$project$Api$Employer$CompanyAccount$Plan = 1;
var $author$project$Api$Employer$CompanyAccount$Registrations = 0;
var $author$project$Api$CompanyAccount$expandToEmployer = function (expand) {
	switch (expand) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Just(0);
		default:
			return $elm$core$Maybe$Just(1);
	}
};
var $author$project$Api$CompanyAccount$listDefaults = {HE: _List_Nil, HM: $elm$core$Maybe$Nothing, ahP: $elm$core$Maybe$Nothing, ajJ: $author$project$Api$Pagination$init, akl: $elm$core$Maybe$Nothing, alA: $author$project$Api$Sort$init};
var $author$project$Api$CompanyAccount$optionalsToEmployer = function (optionals) {
	var options = optionals($author$project$Api$CompanyAccount$listDefaults);
	return function (d) {
		return _Utils_update(
			d,
			{
				HE: A2($elm$core$List$filterMap, $author$project$Api$CompanyAccount$expandToEmployer, options.HE),
				HM: options.HM,
				ahP: options.ahP,
				ajJ: options.ajJ,
				akl: options.akl,
				alA: options.alA
			});
	};
};
var $author$project$Api$Provider$Company$Account$MembershipPatients = 0;
var $author$project$Api$Provider$Company$Account$Plan = 2;
var $author$project$Api$Provider$Company$Account$Registrations = 1;
var $author$project$Api$CompanyAccount$expandToProvider = function (expand) {
	switch (expand) {
		case 0:
			return 0;
		case 1:
			return 1;
		default:
			return 2;
	}
};
var $author$project$Api$CompanyAccount$optionalsToProvider = function (optionals) {
	var options = optionals($author$project$Api$CompanyAccount$listDefaults);
	return function (d) {
		return _Utils_update(
			d,
			{
				HE: A2($elm$core$List$map, $author$project$Api$CompanyAccount$expandToProvider, options.HE),
				HM: options.HM,
				ahP: options.ahP,
				ajJ: options.ajJ,
				akl: options.akl,
				alA: options.alA
			});
	};
};
var $author$project$Api$CompanyAccount$list = F5(
	function (apiClient, session, companyId, optionals, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$CompanyAccount$list,
			apiClient,
			$author$project$Api$CompanyAccount$optionalsToEmployer(optionals),
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$CompanyAccount$All$Employer)))) : A4(
			$author$project$Api$Provider$Company$Account$list,
			apiClient,
			$author$project$Api$Provider$Company$companyPath(companyId),
			$author$project$Api$CompanyAccount$optionalsToProvider(optionals),
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$CompanyAccount$All$Provider))));
	});
var $author$project$Components$ResourceFilter$CompanyAccount$list = $author$project$Api$CompanyAccount$list;
var $author$project$Components$ResourceFilter$CompanyAccount$fetchResources = F7(
	function (session, companyId, listOptionals, toMsg, apiClient, pagination, query) {
		return A5(
			$author$project$Components$ResourceFilter$CompanyAccount$list,
			apiClient,
			session,
			companyId,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{ajJ: pagination, akl: query});
				}),
			toMsg);
	});
var $author$project$Components$ResourceFilter$CompanyAccount$retrieveResource = F6(
	function (session, companyId, listOptionals, toMsg, apiClient, id) {
		return A5(
			$author$project$Components$ResourceFilter$CompanyAccount$list,
			apiClient,
			session,
			companyId,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{
							ahP: $elm$core$Maybe$Just(id)
						});
				}),
			toMsg);
	});
var $author$project$Components$ResourceFilter$CompanyAccount$selectId = 'accounts';
var $author$project$Api$Employer$Patient$Shared$name = function (_v0) {
	var shared = _v0;
	return shared.Bq;
};
var $author$project$Api$Employer$CompanyAccount$All$subscriber = function (_v0) {
	var record = _v0.b;
	return record.acy;
};
var $author$project$Api$Provider$CompanyAccount$All$subscriber = function (_v0) {
	var record = _v0.b;
	return record.acy;
};
var $author$project$Api$CompanyAccount$All$subscriberName = function (companyAccount) {
	if (!companyAccount.$) {
		var companyAccount_ = companyAccount.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$Patient$Shared$name,
			$author$project$Api$Provider$CompanyAccount$All$subscriber(companyAccount_));
	} else {
		var companyAccount_ = companyAccount.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Employer$Patient$Shared$name,
			$author$project$Api$Employer$CompanyAccount$All$subscriber(companyAccount_));
	}
};
var $author$project$Components$ResourceFilter$CompanyAccount$toTitle = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$CompanyAccount$All$subscriberName,
	$elm$core$Maybe$withDefault(''));
var $author$project$Components$ResourceFilter$CompanyAccount$toLabel = function (resource) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Components$ResourceFilter$CompanyAccount$toTitle(resource))
		]);
};
var $author$project$Components$ResourceFilter$CompanyAccount$toValue = $author$project$Api$CompanyAccount$All$id;
var $author$project$Components$ResourceFilter$CompanyAccount$init = F5(
	function (apiClient, session, companyId, listOptionals, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{
				Sk: A3($author$project$Components$ResourceFilter$CompanyAccount$fetchResources, session, companyId, listOptionals),
				ahP: $author$project$Components$ResourceFilter$CompanyAccount$selectId,
				k$: 'Company Account',
				uk: A3($author$project$Components$ResourceFilter$CompanyAccount$retrieveResource, session, companyId, listOptionals),
				u9: $author$project$Components$ResourceFilter$CompanyAccount$toLabel,
				lN: $author$project$Components$ResourceFilter$CompanyAccount$toTitle,
				hX: $author$project$Components$ResourceFilter$CompanyAccount$toValue
			},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{Jy: $author$project$Components$ResourceFilter$All, b8: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$ResourceFilter$CompanyAccount$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.b8);
		var modelAfterEvent = function () {
			var _v1 = result.agZ;
			if (!_v1.$) {
				var selected = _v1.a;
				return _Utils_update(
					model,
					{Jy: selected});
			} else {
				return model;
			}
		}();
		return {
			GZ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.GZ),
			agZ: result.agZ,
			aiO: _Utils_update(
				modelAfterEvent,
				{b8: result.aiO}),
			aR: result.aR
		};
	});
var $author$project$Components$EmployeeDependentTypeInput$update = F3(
	function (apiClient, msg, model) {
		if (!msg.$) {
			var type_ = msg.a;
			if (type_ === 'employee') {
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{gd: $elm$core$Maybe$Nothing, dg: $elm$core$Maybe$Nothing, amg: type_}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$EmployeeDependentTypeInput$TypeSelected(type_));
			} else {
				var _v1 = A5(
					$author$project$Components$ResourceFilter$CompanyAccount$init,
					apiClient,
					model.aa4,
					$author$project$Api$Company$id(model.afQ),
					$elm$core$Basics$identity,
					function (d) {
						return _Utils_update(
							d,
							{Gp: 'Select an Employee', Lr: false, ai5: false});
					});
				var dependentOfFilter = _v1.a;
				var dependentOfFilterCmd = _v1.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							dg: $elm$core$Maybe$Just(dependentOfFilter),
							amg: type_
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$EmployeeDependentTypeInput$CompanyAccountFilterMsg, dependentOfFilterCmd),
					$author$project$Components$EmployeeDependentTypeInput$TypeSelected(type_));
			}
		} else {
			var filterMsg = msg.a;
			var _v2 = model.dg;
			if (!_v2.$) {
				var dependentOfFilter_ = _v2.a;
				var newDependentOfResult = A3($author$project$Components$ResourceFilter$CompanyAccount$update, apiClient, filterMsg, dependentOfFilter_);
				var _v3 = function () {
					var _v4 = newDependentOfResult.agZ;
					if ((!_v4.$) && (!_v4.a.$)) {
						var dependentOf = _v4.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									gd: $elm$core$Maybe$Just(dependentOf),
									dg: $elm$core$Maybe$Just(newDependentOfResult.aiO)
								}),
							$author$project$Components$EmployeeDependentTypeInput$AccountSelected(dependentOf));
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									dg: $elm$core$Maybe$Just(newDependentOfResult.aiO)
								}),
							$author$project$Components$EmployeeDependentTypeInput$None);
					}
				}();
				var newModel = _v3.a;
				var event = _v3.b;
				return _Utils_Tuple3(
					newModel,
					A2($elm$core$Platform$Cmd$map, $author$project$Components$EmployeeDependentTypeInput$CompanyAccountFilterMsg, newDependentOfResult.GZ),
					event);
			} else {
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Components$EmployeeDependentTypeInput$None);
			}
		}
	});
var $author$project$Components$EmployeeDivisionInput$DivisionSelected = 0;
var $author$project$Components$EmployeeDivisionInput$None = 1;
var $author$project$Components$EmployeeDivisionInput$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var division = msg.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						QO: ($elm$core$String$length(division) > 0) ? $elm$core$Maybe$Just(division) : $elm$core$Maybe$Nothing
					}),
				$elm$core$Platform$Cmd$none,
				0);
		} else {
			var response = msg.a;
			var requiresDivisions = function () {
				if (response.$ === 3) {
					var divisions = response.a;
					return !$elm$core$List$isEmpty(divisions);
				} else {
					return model.akR;
				}
			}();
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{zr: response, akR: requiresDivisions}),
				$elm$core$Platform$Cmd$none,
				1);
		}
	});
var $author$project$Components$Patient$Form$DateOfBirth = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Patient$Form$ProfilePicture = F2(
	function (a, b) {
		return {$: 25, a: a, b: b};
	});
var $author$project$Components$Patient$Form$SSN = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Patient$Form$clearFieldErrors = F2(
	function (field, form) {
		switch (field.$) {
			case 18:
				return A2($author$project$Utils$Form$clearGroupErrors, 8, form);
			case 19:
				return A2($author$project$Utils$Form$clearGroupErrors, 9, form);
			default:
				return form;
		}
	});
var $author$project$Api$Provider$SocialSecurityNumber$One$formattedNumber = function (_v0) {
	var record = _v0;
	return record.SH;
};
var $author$project$Components$Patient$Form$sixToEightDigitDate = F2(
	function (currentDate, inputValue) {
		var nextTwoDigitsYear = A2(
			$elm$core$String$right,
			2,
			$elm$core$String$fromInt(
				$justinmimbs$date$Date$year(currentDate) + 1));
		var _v0 = _Utils_Tuple2(
			A2($elm$core$String$left, 4, inputValue),
			A2($elm$core$String$right, 2, inputValue));
		var dayAndMonth = _v0.a;
		var twoDigitYear = _v0.b;
		var newYear = (_Utils_cmp(nextTwoDigitsYear, twoDigitYear) < 0) ? $elm$core$String$concat(
			_List_fromArray(
				['19', twoDigitYear])) : $elm$core$String$concat(
			_List_fromArray(
				['20', twoDigitYear]));
		return $elm$core$String$concat(
			_List_fromArray(
				[dayAndMonth, newYear]));
	});
var $author$project$Components$SocialSecurityNumberInput$ssnPattern = $agustinrhcp$elm_mask$Mask$fromString('###-##-####');
var $author$project$Api$GenderIdentity$NotListed = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Pronoun$Other = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$AffiliateInput$initWithResource = F4(
	function (apiClient, session, listOptionals, resource) {
		return A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Components$AffiliateInput$setValueWithResource(resource),
			A3($author$project$Components$AffiliateInput$empty, apiClient, session, listOptionals));
	});
var $author$project$Components$Patient$Form$buildAffiliateInput = F5(
	function (apiClient, session, currentResource, _v0, _v1) {
		var locationEnabledSetting = _v0.a;
		var practitionersEnabledSetting = _v0.b;
		var practitionerResource = _v1.a;
		var locationResource = _v1.b;
		var practitionerId = practitionersEnabledSetting ? A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.ahP;
			},
			practitionerResource) : $elm$core$Maybe$Nothing;
		var locationId = locationEnabledSetting ? A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.ahP;
			},
			locationResource) : $elm$core$Maybe$Nothing;
		var filteredAffiliateOptionals = A2($author$project$Components$Patient$Form$affiliateOptionals, practitionerId, locationId);
		return A4($author$project$Components$AffiliateInput$initWithResource, apiClient, session, filteredAffiliateOptionals, currentResource);
	});
var $author$project$Components$Patient$Form$locationOptionals = F4(
	function (isEmployeeForm, company, practitioner, affiliate) {
		var signupPageValue = isEmployeeForm ? A2(
			$elm$core$Maybe$map,
			$author$project$Api$SignupPage$Min$id,
			A2($elm$core$Maybe$andThen, $author$project$Api$Company$defaultSignupPage, company)) : $elm$core$Maybe$Nothing;
		return function (d) {
			return _Utils_update(
				d,
				{Gn: affiliate, aka: practitioner, JM: signupPageValue});
		};
	});
var $author$project$Components$Patient$Form$buildLocationInput = F6(
	function (apiClient, isEmployeeForm, company, currentResource, _v0, _v1) {
		var affiliateEnabledSetting = _v0.a;
		var practitionersEnabledSetting = _v0.b;
		var practitionerResource = _v1.a;
		var affiliateResource = _v1.b;
		var practitionerId = practitionersEnabledSetting ? A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.ahP;
			},
			practitionerResource) : $elm$core$Maybe$Nothing;
		var affiliateId = affiliateEnabledSetting ? A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.ahP;
			},
			affiliateResource) : $elm$core$Maybe$Nothing;
		var filteredLocationOptionals = A4($author$project$Components$Patient$Form$locationOptionals, isEmployeeForm, company, practitionerId, affiliateId);
		return A3($author$project$Components$LocationInput$initWithResource, apiClient, filteredLocationOptionals, currentResource);
	});
var $author$project$Components$PractitionerInput$initWithResource = F3(
	function (apiClient, listOptionals, resource) {
		return A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Components$PractitionerInput$setValueWithResource(resource),
			A2($author$project$Components$PractitionerInput$empty, apiClient, listOptionals));
	});
var $author$project$Components$Patient$Form$buildPractitionerInput = F6(
	function (apiClient, isEmployeeForm, company, currentResource, _v0, _v1) {
		var affiliateEnabledSetting = _v0.a;
		var locationEnabledSetting = _v0.b;
		var locationResource = _v1.a;
		var affiliateResource = _v1.b;
		var locationId = locationEnabledSetting ? A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.ahP;
			},
			locationResource) : $elm$core$Maybe$Nothing;
		var affiliateId = affiliateEnabledSetting ? A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.ahP;
			},
			affiliateResource) : $elm$core$Maybe$Nothing;
		var filteredPractitionerOptionals = A5(
			$author$project$Components$Patient$Form$practitionerSignupOptionalsWithExtras,
			isEmployeeForm,
			company,
			locationId,
			affiliateId,
			_List_fromArray(
				[1]));
		return A3($author$project$Components$PractitionerInput$initWithResource, apiClient, filteredPractitionerOptionals, currentResource);
	});
var $author$project$Components$Patient$Form$selectSelectedAffiliation = F5(
	function (apiClient, session, affiliationResource, practitionerResource, locationResource) {
		var filteredAffiliateOptionals = A2(
			$author$project$Components$Patient$Form$affiliateOptionals,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.ahP;
				},
				practitionerResource),
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.ahP;
				},
				locationResource));
		return A4($author$project$Components$AffiliateInput$initWithResource, apiClient, session, filteredAffiliateOptionals, affiliationResource);
	});
var $author$project$Components$Patient$Form$handleAffiliateSelect = F8(
	function (apiClient, session, company, form, event, _v0, isEmployeeForm, _v1) {
		var affiliateEnabledSetting = _v0.a;
		var locationEnabledSetting = _v0.b;
		var practitionersEnabledSetting = _v0.c;
		var affiliate = _v1.a;
		var affiliateCmd = _v1.b;
		var filterPractitionerDropdown = F2(
			function (locationResource, affiliateResource) {
				return A6(
					$author$project$Components$Patient$Form$buildPractitionerInput,
					apiClient,
					isEmployeeForm,
					company,
					$elm$core$Maybe$Nothing,
					_Utils_Tuple2(affiliateEnabledSetting, locationEnabledSetting),
					_Utils_Tuple2(locationResource, affiliateResource));
			});
		var filterLocationDropdown = F2(
			function (practitionerResource, affiliateResource) {
				return A6(
					$author$project$Components$Patient$Form$buildLocationInput,
					apiClient,
					isEmployeeForm,
					company,
					$elm$core$Maybe$Nothing,
					_Utils_Tuple2(affiliateEnabledSetting, practitionersEnabledSetting),
					_Utils_Tuple2(practitionerResource, affiliateResource));
			});
		_v2$2:
		while (true) {
			if (!event.$) {
				switch (event.a.$) {
					case 2:
						var _v3 = event.a;
						var _v4 = A5(
							$author$project$Components$Patient$Form$buildAffiliateInput,
							apiClient,
							session,
							$elm$core$Maybe$Nothing,
							_Utils_Tuple2(locationEnabledSetting, practitionersEnabledSetting),
							_Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing));
						var initAffiliate = _v4.a;
						var initAffiliateCmd = _v4.b;
						return _Utils_Tuple3(
							A2(filterPractitionerDropdown, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
							A2(filterLocationDropdown, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
							_Utils_Tuple2(initAffiliate, initAffiliateCmd));
					case 0:
						return _Utils_eq(affiliate.aee, form.Gn.aee) ? _Utils_Tuple3(
							_Utils_Tuple2(form.aka, $elm$core$Platform$Cmd$none),
							_Utils_Tuple2(form.ais, $elm$core$Platform$Cmd$none),
							_Utils_Tuple2(affiliate, affiliateCmd)) : _Utils_Tuple3(
							A2(filterPractitionerDropdown, form.ais.aee, affiliate.aee),
							A2(filterLocationDropdown, form.aka.aee, affiliate.aee),
							A5($author$project$Components$Patient$Form$selectSelectedAffiliation, apiClient, session, affiliate.aee, form.aka.aee, form.ais.aee));
					default:
						break _v2$2;
				}
			} else {
				break _v2$2;
			}
		}
		return _Utils_Tuple3(
			_Utils_Tuple2(form.aka, $elm$core$Platform$Cmd$none),
			_Utils_Tuple2(form.ais, $elm$core$Platform$Cmd$none),
			_Utils_Tuple2(affiliate, affiliateCmd));
	});
var $author$project$Components$Patient$Form$selectAffiliationFromOtherResource = F4(
	function (apiClient, session, practitionerResource, locationResource) {
		var filteredAffiliateOptionals = A2(
			$author$project$Components$Patient$Form$affiliateOptionals,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.ahP;
				},
				practitionerResource),
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.ahP;
				},
				locationResource));
		var affiliationResource = function () {
			var _v0 = _Utils_Tuple2(practitionerResource, locationResource);
			if (!_v0.a.$) {
				if (!_v0.b.$) {
					return A2(
						$elm$core$Maybe$andThen,
						$elm$core$Maybe$map($author$project$Components$ResourceFilter$Affiliate$resourceFromAffiliateMin),
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.Li;
							},
							practitionerResource));
				} else {
					var _v1 = _v0.b;
					return A2(
						$elm$core$Maybe$andThen,
						$elm$core$Maybe$map($author$project$Components$ResourceFilter$Affiliate$resourceFromAffiliateMin),
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.Li;
							},
							practitionerResource));
				}
			} else {
				if (!_v0.b.$) {
					var _v2 = _v0.a;
					return A2(
						$elm$core$Maybe$andThen,
						$elm$core$Maybe$map($author$project$Components$ResourceFilter$Affiliate$resourceFromAffiliateMin),
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.Li;
							},
							locationResource));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}();
		return A4($author$project$Components$AffiliateInput$initWithResource, apiClient, session, filteredAffiliateOptionals, affiliationResource);
	});
var $author$project$Components$Patient$Form$handleLocationSelect = F8(
	function (apiClient, session, company, form, event, _v0, isEmployeeForm, _v1) {
		var affiliateEnabledSetting = _v0.a;
		var locationEnabledSetting = _v0.b;
		var hasPractitioners = _v0.c;
		var location = _v1.a;
		var locationCmd = _v1.b;
		var filterPractitionerDropdown = A6(
			$author$project$Components$Patient$Form$buildPractitionerInput,
			apiClient,
			isEmployeeForm,
			company,
			form.aka.aee,
			_Utils_Tuple2(affiliateEnabledSetting, locationEnabledSetting),
			_Utils_Tuple2(location.aee, form.Gn.aee));
		_v2$2:
		while (true) {
			if (!event.$) {
				switch (event.a.$) {
					case 2:
						var _v3 = event.a;
						var filterAffiliateDropdown = A5(
							$author$project$Components$Patient$Form$buildAffiliateInput,
							apiClient,
							session,
							form.Gn.aee,
							_Utils_Tuple2(locationEnabledSetting, hasPractitioners),
							_Utils_Tuple2(form.aka.aee, location.aee));
						var _v4 = A6(
							$author$project$Components$Patient$Form$buildLocationInput,
							apiClient,
							isEmployeeForm,
							company,
							$elm$core$Maybe$Nothing,
							_Utils_Tuple2(affiliateEnabledSetting, hasPractitioners),
							_Utils_Tuple2(form.aka.aee, form.Gn.aee));
						var initLocation = _v4.a;
						var initLocationCmd = _v4.b;
						return _Utils_Tuple3(
							filterPractitionerDropdown,
							_Utils_Tuple2(initLocation, initLocationCmd),
							filterAffiliateDropdown);
					case 0:
						return _Utils_eq(location.aee, form.ais.aee) ? _Utils_Tuple3(
							_Utils_Tuple2(form.aka, $elm$core$Platform$Cmd$none),
							_Utils_Tuple2(location, locationCmd),
							_Utils_Tuple2(form.Gn, $elm$core$Platform$Cmd$none)) : _Utils_Tuple3(
							filterPractitionerDropdown,
							_Utils_Tuple2(location, locationCmd),
							A4($author$project$Components$Patient$Form$selectAffiliationFromOtherResource, apiClient, session, form.aka.aee, location.aee));
					default:
						break _v2$2;
				}
			} else {
				break _v2$2;
			}
		}
		return _Utils_Tuple3(
			_Utils_Tuple2(form.aka, $elm$core$Platform$Cmd$none),
			_Utils_Tuple2(location, locationCmd),
			_Utils_Tuple2(form.Gn, $elm$core$Platform$Cmd$none));
	});
var $author$project$Components$Patient$Form$handlePractitionerSelect = F8(
	function (apiClient, session, company, form, event, _v0, isEmployeeForm, _v1) {
		var syncByAffiliation = _v0.a;
		var locationEnabledSetting = _v0.b;
		var hasPractitioners = _v0.c;
		var practitioner = _v1.a;
		var practitionerCmd = _v1.b;
		var filterLocationDropDown = A6(
			$author$project$Components$Patient$Form$buildLocationInput,
			apiClient,
			isEmployeeForm,
			company,
			form.ais.aee,
			_Utils_Tuple2(syncByAffiliation, hasPractitioners),
			_Utils_Tuple2(practitioner.aee, form.Gn.aee));
		_v2$2:
		while (true) {
			if (!event.$) {
				switch (event.a.$) {
					case 2:
						var _v3 = event.a;
						var filterAffiliateDropdown = A5(
							$author$project$Components$Patient$Form$buildAffiliateInput,
							apiClient,
							session,
							form.Gn.aee,
							_Utils_Tuple2(locationEnabledSetting, hasPractitioners),
							_Utils_Tuple2(practitioner.aee, form.ais.aee));
						var _v4 = A6(
							$author$project$Components$Patient$Form$buildPractitionerInput,
							apiClient,
							isEmployeeForm,
							company,
							$elm$core$Maybe$Nothing,
							_Utils_Tuple2(syncByAffiliation, locationEnabledSetting),
							_Utils_Tuple2(form.ais.aee, form.Gn.aee));
						var initPractitioner = _v4.a;
						var initPractitionerCmd = _v4.b;
						return _Utils_Tuple3(
							_Utils_Tuple2(initPractitioner, initPractitionerCmd),
							filterLocationDropDown,
							filterAffiliateDropdown);
					case 0:
						return _Utils_eq(practitioner.aee, form.aka.aee) ? _Utils_Tuple3(
							_Utils_Tuple2(practitioner, practitionerCmd),
							_Utils_Tuple2(form.ais, $elm$core$Platform$Cmd$none),
							_Utils_Tuple2(form.Gn, $elm$core$Platform$Cmd$none)) : _Utils_Tuple3(
							_Utils_Tuple2(practitioner, practitionerCmd),
							filterLocationDropDown,
							A4($author$project$Components$Patient$Form$selectAffiliationFromOtherResource, apiClient, session, practitioner.aee, form.ais.aee));
					default:
						break _v2$2;
				}
			} else {
				break _v2$2;
			}
		}
		return _Utils_Tuple3(
			_Utils_Tuple2(practitioner, practitionerCmd),
			_Utils_Tuple2(form.ais, $elm$core$Platform$Cmd$none),
			_Utils_Tuple2(form.Gn, $elm$core$Platform$Cmd$none));
	});
var $author$project$Components$ResourceFilter$Affiliate$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.b8);
		var modelAfterEvent = function () {
			var _v1 = result.agZ;
			if (!_v1.$) {
				var selected = _v1.a;
				return _Utils_update(
					model,
					{Jy: selected});
			} else {
				return model;
			}
		}();
		return {
			GZ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.GZ),
			agZ: result.agZ,
			aiO: _Utils_update(
				modelAfterEvent,
				{b8: result.aiO}),
			aR: result.aR
		};
	});
var $author$project$Components$AffiliateInput$update = F3(
	function (apiClient, msg, input) {
		var filterMsg = msg;
		var _v1 = A3($author$project$Components$ResourceFilter$Affiliate$update, apiClient, filterMsg, input.HM);
		var model = _v1.aiO;
		var cmd = _v1.GZ;
		var event = _v1.agZ;
		return _Utils_Tuple3(
			function () {
				_v2$2:
				while (true) {
					if (!event.$) {
						switch (event.a.$) {
							case 0:
								var affiliate = event.a.a;
								return _Utils_update(
									input,
									{
										HM: model,
										aee: $elm$core$Maybe$Just(affiliate)
									});
							case 2:
								var _v3 = event.a;
								return _Utils_update(
									input,
									{HM: model, aee: $elm$core$Maybe$Nothing});
							default:
								break _v2$2;
						}
					} else {
						break _v2$2;
					}
				}
				return _Utils_update(
					input,
					{HM: model});
			}(),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd),
			event);
	});
var $author$project$Components$EmergencyContactInput$fieldChanged = F2(
	function (field, emergencyContact) {
		switch (field.$) {
			case 0:
				var firstName = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						emergencyContact,
						{Sv: firstName}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var lastName = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						emergencyContact,
						{VH: lastName}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var relationship = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						emergencyContact,
						{$q: relationship}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var email = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						emergencyContact,
						{Rj: email}),
					$elm$core$Platform$Cmd$none);
			default:
				var phoneMsg = field.a;
				var _v1 = A2($author$project$Components$PhoneInput$update, phoneMsg, emergencyContact.Zw);
				var phone = _v1.a;
				var phoneCmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						emergencyContact,
						{Zw: phone}),
					A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$EmergencyContactInput$FieldChanged, $author$project$Components$EmergencyContactInput$Phone),
						phoneCmd));
		}
	});
var $author$project$Utils$Form$updateWithCmd = F3(
	function (updater, field_, _v0) {
		var originalFields = _v0.a;
		var validated_ = _v0.b;
		var fields_ = _v0.c;
		var errors_ = _v0.d;
		var _v1 = A2(updater, field_, fields_);
		var updated = _v1.a;
		var cmd = _v1.b;
		return _Utils_Tuple2(
			A4($author$project$Utils$Form$Form, originalFields, validated_, updated, errors_),
			cmd);
	});
var $author$project$Components$EmergencyContactInput$update = F2(
	function (msg, model) {
		if (msg.$ === 1) {
			var subMsg = msg.a;
			var _v1 = A2($author$project$Ui$Dropdown$update, subMsg, model.pB);
			var dropdown = _v1.a;
			var dropdownCmd = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{pB: dropdown}),
				dropdownCmd);
		} else {
			var field = msg.a;
			var _v2 = A3($author$project$Utils$Form$updateWithCmd, $author$project$Components$EmergencyContactInput$fieldChanged, field, model.SD);
			var newForm = _v2.a;
			var formCmd = _v2.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{SD: newForm}),
				formCmd);
		}
	});
var $author$project$Components$HealthInsuranceInput$InsuranceCarrierAlias = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$HealthInsuranceInput$Other = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$HealthInsuranceInput$ifElse = F3(
	function (ifVal, elseVal, bool) {
		return bool ? ifVal : elseVal;
	});
var $author$project$Components$ResourceFilter$InsuranceCarrierAlias$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.b8);
		var modelAfterEvent = function () {
			var _v1 = result.agZ;
			if (!_v1.$) {
				var selected = _v1.a;
				return _Utils_update(
					model,
					{Jy: selected});
			} else {
				return model;
			}
		}();
		return {
			GZ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.GZ),
			agZ: result.agZ,
			aiO: _Utils_update(
				modelAfterEvent,
				{b8: result.aiO}),
			aR: result.aR
		};
	});
var $author$project$Components$HealthInsuranceInput$updateRecord = F2(
	function (updateFn, model) {
		var filter = model.a;
		var options = model.b;
		var maybeCarrierAndInsurance = model.c;
		if (!maybeCarrierAndInsurance.$) {
			var _v1 = maybeCarrierAndInsurance.a;
			var carrier = _v1.a;
			var record = _v1.b;
			return A3(
				$author$project$Components$HealthInsuranceInput$Model,
				filter,
				options,
				$elm$core$Maybe$Just(
					_Utils_Tuple2(
						carrier,
						updateFn(record))));
		} else {
			return model;
		}
	});
var $author$project$Components$HealthInsuranceInput$update = F3(
	function (apiClient, msg, model) {
		var filter = model.a;
		var options = model.b;
		var healthInsurance = model.c;
		switch (msg.$) {
			case 0:
				var filterMsg = msg.a;
				var result = A3($author$project$Components$ResourceFilter$InsuranceCarrierAlias$update, apiClient, filterMsg, filter);
				var event = result.agZ;
				var cmd = result.GZ;
				var newFilter = result.aiO;
				return _Utils_Tuple2(
					function () {
						if (!event.$) {
							switch (event.a.$) {
								case 0:
									var carrierAlias = event.a.a;
									var sameAlias = function () {
										if ((!healthInsurance.$) && (!healthInsurance.a.a.$)) {
											var _v3 = healthInsurance.a;
											var alias_ = _v3.a.a;
											return _Utils_eq(alias_.Bq, carrierAlias.Bq);
										} else {
											return false;
										}
									}();
									return sameAlias ? A3($author$project$Components$HealthInsuranceInput$Model, newFilter, options, healthInsurance) : A3(
										$author$project$Components$HealthInsuranceInput$Model,
										newFilter,
										options,
										$elm$core$Maybe$Just(
											_Utils_Tuple2(
												$author$project$Components$HealthInsuranceInput$InsuranceCarrierAlias(carrierAlias),
												{
													S$: A3(
														$author$project$Components$HealthInsuranceInput$ifElse,
														$elm$core$Maybe$Just(''),
														$elm$core$Maybe$Nothing,
														carrierAlias.GT),
													Tt: $elm$core$Maybe$Nothing,
													WL: A3(
														$author$project$Components$HealthInsuranceInput$ifElse,
														$elm$core$Maybe$Just(''),
														$elm$core$Maybe$Nothing,
														carrierAlias.GU),
													Y5: $elm$core$Maybe$Nothing
												})));
								case 3:
									var _v4 = event.a;
									if ((!healthInsurance.$) && (healthInsurance.a.a.$ === 1)) {
										var _v6 = healthInsurance.a;
										return A3($author$project$Components$HealthInsuranceInput$Model, newFilter, options, healthInsurance);
									} else {
										return A3(
											$author$project$Components$HealthInsuranceInput$Model,
											newFilter,
											options,
											$elm$core$Maybe$Just(
												_Utils_Tuple2(
													$author$project$Components$HealthInsuranceInput$Other(
														{Bq: ''}),
													{
														S$: $elm$core$Maybe$Just(''),
														Tt: $elm$core$Maybe$Nothing,
														WL: $elm$core$Maybe$Just(''),
														Y5: $elm$core$Maybe$Just('')
													})));
									}
								case 2:
									var _v7 = event.a;
									return A3($author$project$Components$HealthInsuranceInput$Model, newFilter, options, $elm$core$Maybe$Nothing);
								default:
									return A3($author$project$Components$HealthInsuranceInput$Model, newFilter, options, $elm$core$Maybe$Nothing);
							}
						} else {
							return A3($author$project$Components$HealthInsuranceInput$Model, newFilter, options, healthInsurance);
						}
					}(),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$HealthInsuranceInput$FilterMsg, cmd));
			case 1:
				var name = msg.a;
				if ((!healthInsurance.$) && (healthInsurance.a.a.$ === 1)) {
					var _v9 = healthInsurance.a;
					var other = _v9.a.a;
					var record = _v9.b;
					return _Utils_Tuple2(
						A3(
							$author$project$Components$HealthInsuranceInput$Model,
							filter,
							options,
							$elm$core$Maybe$Just(
								_Utils_Tuple2(
									$author$project$Components$HealthInsuranceInput$Other(
										_Utils_update(
											other,
											{Bq: name})),
									record))),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 3:
				var memberId = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$HealthInsuranceInput$updateRecord,
						function (record) {
							return _Utils_update(
								record,
								{
									WL: $elm$core$Maybe$Just(memberId)
								});
						},
						model),
					$elm$core$Platform$Cmd$none);
			case 4:
				var groupId = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$HealthInsuranceInput$updateRecord,
						function (record) {
							return _Utils_update(
								record,
								{
									S$: $elm$core$Maybe$Just(groupId)
								});
						},
						model),
					$elm$core$Platform$Cmd$none);
			default:
				var highDeductible = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$HealthInsuranceInput$updateRecord,
						function (record) {
							return _Utils_update(
								record,
								{
									Tt: $elm$core$Maybe$Just(highDeductible)
								});
						},
						model),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Components$KnownPracticeInput$KnownPractice = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$KnownPracticeInput$Other = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$ResourceFilter$KnownPractice$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.b8);
		var modelAfterEvent = function () {
			var _v1 = result.agZ;
			if (!_v1.$) {
				var selected = _v1.a;
				return _Utils_update(
					model,
					{Jy: selected});
			} else {
				return model;
			}
		}();
		return {
			GZ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.GZ),
			agZ: result.agZ,
			aiO: _Utils_update(
				modelAfterEvent,
				{b8: result.aiO}),
			aR: result.aR
		};
	});
var $author$project$Components$KnownPracticeInput$update = F3(
	function (apiClient, msg, _v0) {
		var filter = _v0.a;
		var knownPractice = _v0.b;
		switch (msg.$) {
			case 0:
				var filterMsg = msg.a;
				var _v2 = A3($author$project$Components$ResourceFilter$KnownPractice$update, apiClient, filterMsg, filter);
				var model = _v2.aiO;
				var event = _v2.agZ;
				var cmd = _v2.GZ;
				return _Utils_Tuple2(
					function () {
						if (!event.$) {
							switch (event.a.$) {
								case 0:
									var knownPractice_ = event.a.a;
									return A2(
										$author$project$Components$KnownPracticeInput$Model,
										model,
										$elm$core$Maybe$Just(
											$author$project$Components$KnownPracticeInput$KnownPractice(knownPractice_)));
								case 3:
									var _v4 = event.a;
									return A2(
										$author$project$Components$KnownPracticeInput$Model,
										model,
										$elm$core$Maybe$Just(
											$author$project$Components$KnownPracticeInput$Other(
												{Bq: '', F9: ''})));
								default:
									return A2($author$project$Components$KnownPracticeInput$Model, model, $elm$core$Maybe$Nothing);
							}
						} else {
							return A2($author$project$Components$KnownPracticeInput$Model, model, knownPractice);
						}
					}(),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$KnownPracticeInput$FilterMsg, cmd));
			case 1:
				var name = msg.a;
				if ((!knownPractice.$) && (knownPractice.a.$ === 1)) {
					var other = knownPractice.a.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$KnownPracticeInput$Model,
							filter,
							$elm$core$Maybe$Just(
								$author$project$Components$KnownPracticeInput$Other(
									_Utils_update(
										other,
										{Bq: name})))),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						A2($author$project$Components$KnownPracticeInput$Model, filter, knownPractice),
						$elm$core$Platform$Cmd$none);
				}
			default:
				var website = msg.a;
				if ((!knownPractice.$) && (knownPractice.a.$ === 1)) {
					var other = knownPractice.a.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$KnownPracticeInput$Model,
							filter,
							$elm$core$Maybe$Just(
								$author$project$Components$KnownPracticeInput$Other(
									_Utils_update(
										other,
										{F9: website})))),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						A2($author$project$Components$KnownPracticeInput$Model, filter, knownPractice),
						$elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Components$LeadSourceInput$isOther = function (leadSource) {
	return $author$project$Api$Provider$LeadSource$All$name(leadSource) === 'Other';
};
var $author$project$Components$LeadSourceInput$update = F3(
	function (apiClient, msg, model) {
		if (!msg.$) {
			var subMsg = msg.a;
			var leadSourceResourceResult = A3($author$project$Components$ResourceFilter$LeadSource$update, apiClient, subMsg, model.oi);
			var _v1 = function () {
				var _v2 = leadSourceResourceResult.agZ;
				_v2$2:
				while (true) {
					if (!_v2.$) {
						switch (_v2.a.$) {
							case 0:
								var leadSource = _v2.a.a;
								return _Utils_Tuple2(
									$elm$core$Maybe$Just(
										$author$project$Api$Provider$LeadSource$All$id(leadSource)),
									function () {
										var _v3 = _Utils_Tuple2(
											$author$project$Components$LeadSourceInput$isOther(leadSource),
											model.dx);
										if (_v3.a) {
											if (!_v3.b.$) {
												return model.dx;
											} else {
												var _v4 = _v3.b;
												return $elm$core$Maybe$Just('');
											}
										} else {
											return $elm$core$Maybe$Nothing;
										}
									}());
							case 2:
								var _v5 = _v2.a;
								return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
							default:
								break _v2$2;
						}
					} else {
						break _v2$2;
					}
				}
				return _Utils_Tuple2(model.aB, model.dx);
			}();
			var selected = _v1.a;
			var other = _v1.b;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{oi: leadSourceResourceResult.aiO, dx: other, aB: selected}),
				A2($elm$core$Platform$Cmd$map, $author$project$Components$LeadSourceInput$LeadSourceResourceFilterMsg, leadSourceResourceResult.GZ),
				leadSourceResourceResult.aR);
		} else {
			var other = msg.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						dx: $elm$core$Maybe$Just(other)
					}),
				$elm$core$Platform$Cmd$none,
				_List_Nil);
		}
	});
var $author$project$Components$NameInput$updateField = F2(
	function (field, _v0) {
		var errors = _v0.a;
		var options = _v0.b;
		var fields = _v0.c;
		return A3(
			$author$project$Components$NameInput$Model,
			errors,
			options,
			function () {
				switch (field.$) {
					case 0:
						var title = field.a;
						return _Utils_update(
							fields,
							{ac9: title});
					case 1:
						var firstName = field.a;
						return _Utils_update(
							fields,
							{Sv: firstName});
					case 2:
						var middleName = field.a;
						return _Utils_update(
							fields,
							{W7: middleName});
					case 3:
						var lastName = field.a;
						return _Utils_update(
							fields,
							{VH: lastName});
					default:
						var suffix = field.a;
						return _Utils_update(
							fields,
							{acE: suffix});
				}
			}());
	});
var $author$project$Components$NameInput$update = F2(
	function (msg, model) {
		var field = msg;
		return A2($author$project$Components$NameInput$updateField, field, model);
	});
var $author$project$Components$PractitionerInput$update = F3(
	function (apiClient, msg, input) {
		var filterMsg = msg;
		var _v1 = A3($author$project$Components$ResourceFilter$Practitioner$update, apiClient, filterMsg, input.HM);
		var model = _v1.aiO;
		var cmd = _v1.GZ;
		var event = _v1.agZ;
		return _Utils_Tuple3(
			function () {
				_v2$2:
				while (true) {
					if (!event.$) {
						switch (event.a.$) {
							case 0:
								var practitioner = event.a.a;
								return _Utils_update(
									input,
									{
										HM: model,
										aee: $elm$core$Maybe$Just(practitioner)
									});
							case 2:
								var _v3 = event.a;
								return _Utils_update(
									input,
									{HM: model, aee: $elm$core$Maybe$Nothing});
							default:
								break _v2$2;
						}
					} else {
						break _v2$2;
					}
				}
				return _Utils_update(
					input,
					{HM: model});
			}(),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd),
			event);
	});
var $author$project$Components$Patient$Form$updateField = F6(
	function (apiClient, session, company, settings, field, form) {
		switch (field.$) {
			case 0:
				var nameInputMsg = field.a;
				var newName = A2($author$project$Components$NameInput$update, nameInputMsg, form.VU);
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{VU: newName}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var nameInputMsg = field.a;
				var _v1 = form.bU;
				if (!_v1.$) {
					var chosenName = _v1.a;
					var newName = A2($author$project$Components$NameInput$update, nameInputMsg, chosenName);
					return _Utils_Tuple3(
						_Utils_update(
							form,
							{
								bU: $elm$core$Maybe$Just(newName)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(form, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				var gender = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{
							aa8: $elm$core$Maybe$Just(gender)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var gender = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{
							SR: $elm$core$Maybe$Just(gender)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var genderOther = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{
							ST: $elm$core$Maybe$Just(genderOther)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var dob = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{PF: dob}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 6:
				var email = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{Rj: email}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 7:
				var genderIdentity = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{SS: genderIdentity}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 8:
				var other = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{
							SS: $elm$core$Maybe$Just(
								$author$project$Api$GenderIdentity$NotListed(other))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 9:
				var pronoun = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{_B: pronoun}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 10:
				var other = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{
							_B: $elm$core$Maybe$Just(
								$author$project$Api$Pronoun$Other(other))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 11:
				var phoneMsg = field.a;
				var _v2 = A2($author$project$Components$PhoneInput$update, phoneMsg, form.Zy);
				var updatedPhones = _v2.a;
				var phoneCmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{Zy: updatedPhones}),
					A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Phones),
						phoneCmd),
					_List_Nil);
			case 12:
				var addressMsg = field.a;
				var _v3 = A2($author$project$Components$AddressInput$update, addressMsg, form.K2);
				var address = _v3.a;
				var addressCmd = _v3.b;
				var outMsgs = _v3.c;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{K2: address}),
					A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Address),
						addressCmd),
					outMsgs);
			case 13:
				var usesBillingAddress = field.a;
				if (usesBillingAddress) {
					var _v4 = A2(
						$elm$core$Maybe$withDefault,
						$author$project$Components$AddressInput$init('patient-billing-address'),
						A2(
							$elm$core$Maybe$map,
							function (address_) {
								return _Utils_Tuple2(address_, $elm$core$Platform$Cmd$none);
							},
							form.MF));
					var address = _v4.a;
					var addressCmd = _v4.b;
					return _Utils_Tuple3(
						_Utils_update(
							form,
							{
								MF: $elm$core$Maybe$Just(address),
								ad3: usesBillingAddress
							}),
						A2(
							$elm$core$Platform$Cmd$map,
							A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$BillingAddress),
							addressCmd),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							form,
							{ad3: usesBillingAddress}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 14:
				var addressMsg = field.a;
				var _v5 = form.MF;
				if (_v5.$ === 1) {
					return _Utils_Tuple3(form, $elm$core$Platform$Cmd$none, _List_Nil);
				} else {
					var billingAddress = _v5.a;
					var _v6 = A2($author$project$Components$AddressInput$update, addressMsg, billingAddress);
					var address = _v6.a;
					var addressCmd = _v6.b;
					var outMsgs = _v6.c;
					return _Utils_Tuple3(
						_Utils_update(
							form,
							{
								MF: $elm$core$Maybe$Just(address)
							}),
						A2(
							$elm$core$Platform$Cmd$map,
							A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$BillingAddress),
							addressCmd),
						outMsgs);
				}
			case 15:
				var string = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{ab5: string}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 16:
				var msg = field.a;
				var _v7 = A3($author$project$Components$KnownPracticeInput$update, apiClient, msg, form.Vy);
				var knownPractice = _v7.a;
				var knownPracticeCmd = _v7.b;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{Vy: knownPractice}),
					A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$KnownPractice),
						knownPracticeCmd),
					_List_Nil);
			case 17:
				var tobaccoUse = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{qz: tobaccoUse}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 18:
				var msg = field.a;
				var _v8 = A3($author$project$Components$PractitionerInput$update, apiClient, msg, form.aka);
				var selectedPractitioner = _v8.a;
				var selectedPractitionerCmd = _v8.b;
				var event = _v8.c;
				var _v9 = function () {
					var locationEnabledSetting = settings.Tb && settings.adt;
					return A8(
						$author$project$Components$Patient$Form$handlePractitionerSelect,
						apiClient,
						session,
						company,
						form,
						event,
						_Utils_Tuple3(settings.acI, locationEnabledSetting, settings.Th),
						settings.sQ,
						_Utils_Tuple2(selectedPractitioner, selectedPractitionerCmd));
				}();
				var _v10 = _v9.a;
				var practitioner = _v10.a;
				var practitionerCmd = _v10.b;
				var _v11 = _v9.b;
				var location = _v11.a;
				var locationCmd = _v11.b;
				var _v12 = _v9.c;
				var affiliate = _v12.a;
				var affiliateCmd = _v12.b;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{Gn: affiliate, ais: location, aka: practitioner}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Platform$Cmd$map,
								A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Practitioner),
								practitionerCmd),
								A2(
								$elm$core$Platform$Cmd$map,
								A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Location),
								locationCmd),
								A2(
								$elm$core$Platform$Cmd$map,
								A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Affiliate),
								affiliateCmd)
							])),
					_List_Nil);
			case 19:
				var msg = field.a;
				var _v13 = A3($author$project$Components$LocationInput$update, apiClient, msg, form.ais);
				var selectedLocation = _v13.a;
				var selectedLocationCmd = _v13.b;
				var event = _v13.c;
				var _v14 = function () {
					var locationEnabledSetting = settings.Tb && settings.adt;
					return A8(
						$author$project$Components$Patient$Form$handleLocationSelect,
						apiClient,
						session,
						company,
						form,
						event,
						_Utils_Tuple3(settings.acI, locationEnabledSetting, settings.Th),
						settings.sQ,
						_Utils_Tuple2(selectedLocation, selectedLocationCmd));
				}();
				var _v15 = _v14.a;
				var practitioner = _v15.a;
				var practitionerCmd = _v15.b;
				var _v16 = _v14.b;
				var location = _v16.a;
				var locationCmd = _v16.b;
				var _v17 = _v14.c;
				var affiliate = _v17.a;
				var affiliateCmd = _v17.b;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{Gn: affiliate, ais: location, aka: practitioner}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Platform$Cmd$map,
								A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Practitioner),
								practitionerCmd),
								A2(
								$elm$core$Platform$Cmd$map,
								A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Location),
								locationCmd),
								A2(
								$elm$core$Platform$Cmd$map,
								A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Affiliate),
								affiliateCmd)
							])),
					_List_Nil);
			case 24:
				var msg = field.a;
				var _v18 = A3($author$project$Components$AffiliateInput$update, apiClient, msg, form.Gn);
				var selectedAffiliate = _v18.a;
				var selectedAffiliateCmd = _v18.b;
				var event = _v18.c;
				var _v19 = function () {
					var locationEnabledSetting = settings.Tb && settings.adt;
					return A8(
						$author$project$Components$Patient$Form$handleAffiliateSelect,
						apiClient,
						session,
						company,
						form,
						event,
						_Utils_Tuple3(settings.acI, locationEnabledSetting, settings.Th),
						settings.sQ,
						_Utils_Tuple2(selectedAffiliate, selectedAffiliateCmd));
				}();
				var _v20 = _v19.a;
				var practitioner = _v20.a;
				var practitionerCmd = _v20.b;
				var _v21 = _v19.b;
				var location = _v21.a;
				var locationCmd = _v21.b;
				var _v22 = _v19.c;
				var affiliate = _v22.a;
				var affiliateCmd = _v22.b;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{Gn: affiliate, ais: location, aka: practitioner}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Platform$Cmd$map,
								A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Affiliate),
								affiliateCmd),
								A2(
								$elm$core$Platform$Cmd$map,
								A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Practitioner),
								practitionerCmd),
								A2(
								$elm$core$Platform$Cmd$map,
								A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Location),
								locationCmd)
							])),
					_List_Nil);
			case 20:
				var dateInputMsg = field.a;
				var _v23 = form.j5;
				var prevValue = _v23.a;
				var prevInput = _v23.b;
				var _v24 = A2($author$project$Components$DateInput$update, dateInputMsg, prevInput);
				var dateInput = _v24.a;
				var dateInputCmd = _v24.b;
				var event = _v24.c;
				var newValue = function () {
					if (event.$ === 1) {
						var date = event.a;
						return date;
					} else {
						return prevValue;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{
							j5: _Utils_Tuple2(newValue, dateInput)
						}),
					A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$JoinedPractice),
						dateInputCmd),
					_List_Nil);
			case 21:
				var msg = field.a;
				var _v26 = A3($author$project$Components$LeadSourceInput$update, apiClient, msg, form.VR);
				var leadSource = _v26.a;
				var leadSourceCmd = _v26.b;
				var leadSourceOutMsgs = _v26.c;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{VR: leadSource}),
					A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$LeadSource),
						leadSourceCmd),
					leadSourceOutMsgs);
			case 22:
				var msg = field.a;
				var _v27 = A3($author$project$Components$HealthInsuranceInput$update, apiClient, msg, form.Tm);
				var healthInsurance = _v27.a;
				var healthInsuranceCmd = _v27.b;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{Tm: healthInsurance}),
					A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$HealthInsurance),
						healthInsuranceCmd),
					_List_Nil);
			case 23:
				var sync = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{acM: sync}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 25:
				var _int = field.a;
				var string = field.b;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{
							rT: $elm$core$Maybe$Just(string),
							t5: _int,
							_A: $elm$core$Maybe$Just(string)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 26:
				var lang = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{Z9: lang}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var emergencyContactMsg = field.a;
				var _v28 = A2($author$project$Components$EmergencyContactInput$update, emergencyContactMsg, form.Rl);
				var emergencyContact = _v28.a;
				var emergencyContactCmd = _v28.b;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{Rl: emergencyContact}),
					A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeR, $author$project$Components$Patient$Form$EmergencyContact, $author$project$Components$Patient$Form$FieldUpdated),
						emergencyContactCmd),
					_List_Nil);
		}
	});
var $author$project$Utils$Form$updateWithCmdAndOutMsgs = F3(
	function (updater, field_, _v0) {
		var originalFields = _v0.a;
		var validated_ = _v0.b;
		var fields_ = _v0.c;
		var errors_ = _v0.d;
		var _v1 = A2(updater, field_, fields_);
		var updated = _v1.a;
		var cmd = _v1.b;
		var outMsgs = _v1.c;
		return _Utils_Tuple3(
			A4($author$project$Utils$Form$Form, originalFields, validated_, updated, errors_),
			cmd,
			outMsgs);
	});
var $author$project$Components$Patient$Form$update = F5(
	function (apiClient, session, company, msg, model) {
		var settings = model.a;
		var form = model.b;
		switch (msg.$) {
			case 1:
				var enable = msg.a;
				var fields = $author$project$Utils$Form$fields(form);
				var newFields = _Utils_update(
					fields,
					{
						bU: enable ? $elm$core$Maybe$Just($author$project$Components$NameInput$empty) : $elm$core$Maybe$Nothing
					});
				return _Utils_Tuple3(
					A2(
						$author$project$Components$Patient$Form$PatientForm,
						settings,
						A2($author$project$Utils$Form$set, newFields, form)),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					var ssn = response.a;
					var ssnString = A2(
						$agustinrhcp$elm_mask$Mask$unMask,
						$author$project$Components$SocialSecurityNumberInput$ssnPattern,
						A2(
							$elm$core$Maybe$withDefault,
							'',
							$author$project$Api$Provider$SocialSecurityNumber$One$formattedNumber(ssn)));
					return A2(
						$author$project$Utils$Tuple3$mapFirst,
						$author$project$Components$Patient$Form$PatientForm(settings),
						A2(
							$author$project$Utils$Tuple3$mapFirst,
							$author$project$Components$Patient$Form$clearFieldErrors(
								$author$project$Components$Patient$Form$SSN(ssnString)),
							A3(
								$author$project$Utils$Form$updateWithCmdAndOutMsgs,
								A4($author$project$Components$Patient$Form$updateField, apiClient, session, company, settings),
								$author$project$Components$Patient$Form$SSN(ssnString),
								form)));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 0:
				var field = msg.a;
				return A2(
					$author$project$Utils$Tuple3$mapFirst,
					$author$project$Components$Patient$Form$PatientForm(settings),
					A2(
						$author$project$Utils$Tuple3$mapFirst,
						$author$project$Components$Patient$Form$clearFieldErrors(field),
						A3(
							$author$project$Utils$Form$updateWithCmdAndOutMsgs,
							A4($author$project$Components$Patient$Form$updateField, apiClient, session, company, settings),
							field,
							form)));
			case 3:
				var response = msg.a;
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 4:
				var inputValue = $author$project$Utils$Form$fields(form).PF;
				var newValue = ($elm$core$String$length(inputValue) === 6) ? A2($author$project$Components$Patient$Form$sixToEightDigitDate, settings.dd, inputValue) : inputValue;
				return A2(
					$author$project$Utils$Tuple3$mapFirst,
					$author$project$Components$Patient$Form$PatientForm(settings),
					A3(
						$author$project$Utils$Form$updateWithCmdAndOutMsgs,
						A4($author$project$Components$Patient$Form$updateField, apiClient, session, company, settings),
						$author$project$Components$Patient$Form$DateOfBirth(newValue),
						form));
			default:
				var pictures = msg.a;
				var cmd = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						function (_v2) {
							var task = _v2.a;
							var size = _v2.b;
							return A2(
								$elm$core$Task$perform,
								A2(
									$elm$core$Basics$composeL,
									$author$project$Components$Patient$Form$FieldUpdated,
									$author$project$Components$Patient$Form$ProfilePicture(size)),
								task);
						},
						A2(
							$elm$core$Maybe$map,
							function (picture) {
								return _Utils_Tuple2(
									$elm$file$File$toUrl(picture),
									$elm$file$File$size(picture));
							},
							$elm$core$List$head(pictures))));
				return _Utils_Tuple3(model, cmd, _List_Nil);
		}
	});
var $author$project$Components$SponsorPlanInput$update = F3(
	function (apiClient, msg, input) {
		var filterMsg = msg;
		var _v1 = A3($author$project$Components$ResourceFilter$CompanyPlan$update, apiClient, filterMsg, input.HM);
		var model = _v1.aiO;
		var cmd = _v1.GZ;
		var event = _v1.agZ;
		return _Utils_Tuple3(
			function () {
				_v2$2:
				while (true) {
					if (!event.$) {
						switch (event.a.$) {
							case 0:
								var companyPlan = event.a.a;
								return _Utils_update(
									input,
									{
										HM: model,
										aee: $elm$core$Maybe$Just(companyPlan)
									});
							case 2:
								var _v3 = event.a;
								return _Utils_update(
									input,
									{HM: model, aee: $elm$core$Maybe$Nothing});
							default:
								break _v2$2;
						}
					} else {
						break _v2$2;
					}
				}
				return _Utils_update(
					input,
					{HM: model});
			}(),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd),
			event);
	});
var $author$project$Components$Employee$Form$updateField = F6(
	function (apiClient, session, company, settings, field, form) {
		switch (field.$) {
			case 0:
				var typeMsg = field.a;
				var _v1 = A3($author$project$Components$EmployeeDependentTypeInput$update, apiClient, typeMsg, form.amg);
				var newTypeInput = _v1.a;
				var newTypeInputCmd = _v1.b;
				var newTypeEvent = _v1.c;
				var _v2 = function () {
					switch (newTypeEvent.$) {
						case 1:
							var account = newTypeEvent.a;
							return _Utils_Tuple2(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									A2(
										$elm$core$Maybe$map,
										$author$project$Utils$Date$toIsoString,
										$author$project$Components$Employee$Form$dependentStartDate(account))),
								($author$project$Api$CompanyAccount$All$status(account) === 'enrolled') ? $elm$core$Maybe$Just(true) : $elm$core$Maybe$Nothing);
						case 0:
							var type_ = newTypeEvent.a;
							return (type_ === 'employee') ? _Utils_Tuple2(
								$author$project$Components$Employee$Form$nextFirstOfMonth(settings.YY.dd),
								$elm$core$Maybe$Just(true)) : _Utils_Tuple2('', $elm$core$Maybe$Nothing);
						default:
							return _Utils_Tuple2(form.WW, form.Rz);
					}
				}();
				var membershipStartDate = _v2.a;
				var enroll = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{Rz: enroll, WW: membershipStartDate, amg: newTypeInput}),
					A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$Type),
						newTypeInputCmd),
					_List_Nil);
			case 1:
				var patientFormMsg = field.a;
				var _v4 = A5($author$project$Components$Patient$Form$update, apiClient, session, company, patientFormMsg, form.YY);
				var newPatientForm = _v4.a;
				var newPatientFormCmd = _v4.b;
				var newPatientFormOutMsgs = _v4.c;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{YY: newPatientForm}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Employee$Form$PatientFormMsg, newPatientFormCmd),
					newPatientFormOutMsgs);
			case 2:
				var sponsorPlanMsg = field.a;
				var _v5 = A3($author$project$Components$SponsorPlanInput$update, apiClient, sponsorPlanMsg, form.Jb);
				var newPlanInput = _v5.a;
				var newPlanInputCmd = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{Jb: newPlanInput}),
					A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$Plan),
						newPlanInputCmd),
					_List_Nil);
			case 3:
				var startDate = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{WW: startDate}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var dateInputMsg = field.a;
				var _v6 = form.dj;
				var prevValue = _v6.a;
				var prevInput = _v6.b;
				var _v7 = A2($author$project$Components$DateInput$update, dateInputMsg, prevInput);
				var dateInput = _v7.a;
				var dateInputCmd = _v7.b;
				var event = _v7.c;
				var newValue = function () {
					if (event.$ === 1) {
						var date = event.a;
						return date;
					} else {
						return prevValue;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{
							dj: _Utils_Tuple2(newValue, dateInput)
						}),
					A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$EligibilityDate),
						dateInputCmd),
					_List_Nil);
			case 5:
				var maybeBool = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{Rz: maybeBool}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 6:
				var externalId = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{
							ag7: $elm$core$Maybe$Just(externalId)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var divisionMsg = field.a;
				var _v9 = A2($author$project$Components$EmployeeDivisionInput$update, divisionMsg, form.QO);
				var divisionInput = _v9.a;
				var divisionInputCmd = _v9.b;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{QO: divisionInput}),
					A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$Division),
						divisionInputCmd),
					_List_Nil);
		}
	});
var $author$project$Components$Employee$Form$update = F5(
	function (apiClient, session, company, msg, _v0) {
		var settings = _v0.a;
		var form = _v0.b;
		if (!msg.$) {
			var subMsg = msg.a;
			return A2(
				$author$project$Utils$Tuple3$mapFirst,
				$author$project$Components$Employee$Form$EmployeeForm(settings),
				A3(
					$author$project$Utils$Form$updateWithCmdAndOutMsgs,
					A4($author$project$Components$Employee$Form$updateField, apiClient, session, company, settings),
					$author$project$Components$Employee$Form$Patient(subMsg),
					form));
		} else {
			var field = msg.a;
			return A2(
				$author$project$Utils$Tuple3$mapFirst,
				$author$project$Components$Employee$Form$EmployeeForm(settings),
				A3(
					$author$project$Utils$Form$updateWithCmdAndOutMsgs,
					A4($author$project$Components$Employee$Form$updateField, apiClient, session, company, settings),
					field,
					form));
		}
	});
var $author$project$Components$Employee$Form$EmployeeDivisionValidation = 4;
var $author$project$Components$Employee$Form$PlanFieldValidation = 2;
var $author$project$Components$Employee$Form$TypeFieldValidation = 0;
var $author$project$Components$EmployeeDependentTypeInput$validate = F2(
	function (getter, formatter) {
		return A2(
			$rtfeldman$elm_validate$Validate$ifFalse,
			function (model) {
				var _v0 = getter(model);
				var type_ = _v0.amg;
				var dependentOf = _v0.gd;
				var _v1 = _Utils_Tuple2(type_, dependentOf);
				_v1$2:
				while (true) {
					if (_v1.b.$ === 1) {
						switch (_v1.a) {
							case 'spouse':
								var _v2 = _v1.b;
								return false;
							case 'child':
								var _v3 = _v1.b;
								return false;
							default:
								break _v1$2;
						}
					} else {
						break _v1$2;
					}
				}
				return true;
			},
			formatter('Please select an employee'));
	});
var $author$project$Components$EmployeeDivisionInput$validate = F2(
	function (getter, formatter) {
		return A2(
			$rtfeldman$elm_validate$Validate$ifFalse,
			function (model) {
				var _v0 = getter(model);
				var required = _v0.akR;
				var division = _v0.QO;
				var _v1 = _Utils_Tuple2(required, division);
				if (_v1.a && (_v1.b.$ === 1)) {
					var _v2 = _v1.b;
					return false;
				} else {
					return true;
				}
			},
			formatter('Please select an employee division.'));
	});
var $author$project$Components$SponsorPlanInput$validate = F2(
	function (getter, formatter) {
		return A2(
			$rtfeldman$elm_validate$Validate$ifFalse,
			function (model) {
				var _v0 = getter(model);
				var required = _v0.akR;
				var value = _v0.aee;
				var _v1 = _Utils_Tuple2(required, value);
				if (_v1.a && (_v1.b.$ === 1)) {
					var _v2 = _v1.b;
					return false;
				} else {
					return true;
				}
			},
			formatter('Please select a plan.'));
	});
var $author$project$Components$Employee$Form$EligibilityDateValidation = 3;
var $elm_community$maybe_extra$Maybe$Extra$isJust = function (m) {
	if (m.$ === 1) {
		return false;
	} else {
		return true;
	}
};
var $author$project$Components$Employee$Form$validateEligibilityDate = F2(
	function (isNew, _v0) {
		var eligibilityDate = _v0.dj;
		var hasDate = $elm_community$maybe_extra$Maybe$Extra$isJust(eligibilityDate.a);
		return hasDate ? _List_Nil : (isNew ? _List_fromArray(
			[
				_Utils_Tuple2(3, 'Please select an eligibility date.')
			]) : _List_Nil);
	});
var $author$project$Components$Employee$Form$PatientFieldValidation = 1;
var $author$project$Components$Patient$Form$hasErrors = function (_v0) {
	var form = _v0.b;
	return $author$project$Utils$Form$hasAnyValidationError(form);
};
var $author$project$Components$Employee$Form$validatePatientFields = function (_v0) {
	var patient = _v0.YY;
	var hasErrors = $author$project$Components$Patient$Form$hasErrors(patient);
	return hasErrors ? _List_fromArray(
		[
			_Utils_Tuple2(1, '')
		]) : _List_Nil;
};
var $author$project$Components$Employee$Form$validator = F3(
	function (requiresDivisions, isNew, type_) {
		var typeValidator = isNew ? _List_fromArray(
			[
				A2(
				$author$project$Components$EmployeeDependentTypeInput$validate,
				function ($) {
					return $.amg;
				},
				function (error) {
					return _Utils_Tuple2(0, error);
				})
			]) : _List_Nil;
		var planValidator = (isNew && (type_ === 'employee')) ? _List_fromArray(
			[
				A2(
				$author$project$Components$SponsorPlanInput$validate,
				function ($) {
					return $.Jb;
				},
				function (error) {
					return _Utils_Tuple2(2, error);
				})
			]) : _List_Nil;
		var eligibilityDateValidator = isNew ? _List_fromArray(
			[
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$Employee$Form$validateEligibilityDate(isNew))
			]) : _List_Nil;
		var divisionValidator = requiresDivisions ? _List_fromArray(
			[
				A2(
				$author$project$Components$EmployeeDivisionInput$validate,
				function ($) {
					return $.QO;
				},
				function (error) {
					return _Utils_Tuple2(4, error);
				})
			]) : _List_Nil;
		var validators = A2(
			$elm$core$List$cons,
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Employee$Form$validatePatientFields),
			_Utils_ap(
				typeValidator,
				_Utils_ap(
					planValidator,
					_Utils_ap(divisionValidator, eligibilityDateValidator))));
		return $rtfeldman$elm_validate$Validate$all(validators);
	});
var $author$project$Components$Employee$Form$validate = function (_v0) {
	var settings = _v0.a;
	var form = _v0.b;
	var fields = $author$project$Utils$Form$fields(form);
	var patientForm = function () {
		var _v1 = $author$project$Components$Patient$Form$validate(fields.YY);
		if (!_v1.$) {
			var _v2 = _v1.a;
			var newForm = _v2.a;
			return newForm;
		} else {
			var newForm = _v1.a;
			return newForm;
		}
	}();
	return A2(
		$elm$core$Result$mapError,
		$author$project$Components$Employee$Form$EmployeeForm(settings),
		A2(
			$elm$core$Result$map,
			$elm$core$Tuple$mapFirst(
				$author$project$Components$Employee$Form$EmployeeForm(settings)),
			A2(
				$author$project$Utils$Form$validate,
				A3(
					$author$project$Components$Employee$Form$validator,
					settings.zp.$F,
					fields.j1,
					$author$project$Components$EmployeeDependentTypeInput$selectedType(fields.amg)),
				A2(
					$author$project$Utils$Form$set,
					_Utils_update(
						fields,
						{YY: patientForm}),
					form))));
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Create$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A5(
					$author$project$Components$Employee$Form$update,
					model.Gv,
					model.aa4,
					$elm$core$Maybe$Just(model.afQ),
					subMsg,
					model.aK);
				var form = _v1.a;
				var formCmd = _v1.b;
				var formOutMsgs = _v1.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aK: form}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Employees$Create$FormMsg, formCmd),
					formOutMsgs);
			case 1:
				var _v2 = $author$project$Components$Employee$Form$validate(model.aK);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var validForm = _v3.a;
					var validFields = _v3.b;
					var cmd = function () {
						var _v4 = $author$project$Components$Employee$Form$dependentOf(model.aK);
						if (!_v4.$) {
							var account = _v4.a;
							return A6(
								$author$project$Api$CompanyRegistration$create,
								model.Gv,
								model.aa4,
								model.ahP,
								$author$project$Api$CompanyAccount$All$id(account),
								A2($author$project$Components$Employee$Form$encodeRegistration, validFields, validForm),
								$author$project$Pages$Companies$CompanyId_String$Employees$Create$CompanyRegistrationCreated(
									$author$project$Api$CompanyAccount$All$id(account)));
						} else {
							return A5(
								$author$project$Api$CompanyAccount$create,
								model.Gv,
								model.aa4,
								model.ahP,
								A2($author$project$Components$Employee$Form$encodeAccount, validFields, validForm),
								$author$project$Pages$Companies$CompanyId_String$Employees$Create$CompanyAccountCreated);
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{lA: true}),
						cmd,
						_List_Nil);
				} else {
					var erroredForm = _v2.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{aK: erroredForm}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 2:
				var response = msg.a;
				var _v5 = _Utils_Tuple2(
					$author$project$Components$Employee$Form$validate(model.aK),
					response);
				_v5$2:
				while (true) {
					switch (_v5.b.$) {
						case 3:
							if (!_v5.a.$) {
								var _v6 = _v5.a.a;
								var validForm = _v6.a;
								var validFields = _v6.b;
								var _v7 = _v5.b;
								var account = _v7.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{KF: response}),
									A6(
										$author$project$Api$CompanyRegistration$create,
										model.Gv,
										model.aa4,
										model.ahP,
										$author$project$Api$CompanyAccount$One$id(account),
										A2($author$project$Components$Employee$Form$encodeRegistration, validFields, validForm),
										$author$project$Pages$Companies$CompanyId_String$Employees$Create$CompanyRegistrationCreated(
											$author$project$Api$CompanyAccount$One$id(account))),
									_List_Nil);
							} else {
								break _v5$2;
							}
						case 2:
							var error = _v5.b.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{KF: response, lA: false}),
								$elm$core$Platform$Cmd$none,
								A2(
									$elm$core$List$cons,
									A2(
										$author$project$OutMsg$ShowToast,
										1,
										$author$project$Ui$Toast$serverError(error)),
									$author$project$OutMsg$reportDecodeError(response)));
						default:
							break _v5$2;
					}
				}
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{KF: response, lA: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var accountId = msg.a;
				var response = msg.b;
				var _v8 = _Utils_Tuple2(
					$author$project$Components$Employee$Form$validate(model.aK),
					response);
				_v8$2:
				while (true) {
					switch (_v8.b.$) {
						case 3:
							if (!_v8.a.$) {
								var _v9 = _v8.a.a;
								var validForm = _v9.a;
								var validFields = _v9.b;
								var _v10 = _v8.b;
								var registration = _v10.a;
								var _v11 = $author$project$Components$Employee$Form$shouldEnroll(model.aK) ? _Utils_Tuple2(
									A5(
										$author$project$Api$CompanyRegistration$enroll,
										model.Gv,
										model.aa4,
										{
											fv: accountId,
											fZ: model.ahP,
											pA: $author$project$Api$CompanyRegistration$One$id(registration)
										},
										A2($author$project$Components$Employee$Form$encodeEnroll, validFields, validForm),
										$author$project$Pages$Companies$CompanyId_String$Employees$Create$RegistrationEnrolled),
									_List_Nil) : _Utils_Tuple2(
									A2(
										$author$project$Utils$Route$navigate,
										$elm$core$Dict$empty,
										$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top(
											{fZ: model.ahP})),
									_List_fromArray(
										[
											A2($author$project$OutMsg$ShowToast, 3, 'Patient created!')
										]));
								var cmd = _v11.a;
								var outMsg = _v11.b;
								return _Utils_Tuple3(model, cmd, outMsg);
							} else {
								break _v8$2;
							}
						case 2:
							var error = _v8.b.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{lA: false}),
								$elm$core$Platform$Cmd$none,
								A2(
									$elm$core$List$cons,
									A2(
										$author$project$OutMsg$ShowToast,
										1,
										$author$project$Ui$Toast$serverError(error)),
									$author$project$OutMsg$reportDecodeError(response)));
						default:
							break _v8$2;
					}
				}
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{lA: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var response = msg.a;
				switch (response.$) {
					case 3:
						var registration = response.a;
						var createAffiliationCmd = A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Pages$Companies$CompanyId_String$Employees$Create$FormMsg,
							A4($author$project$Components$Employee$Form$createEmployeeAffiliation, model.Gv, model.aa4, registration, model.aK));
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{lA: false}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2(
										$author$project$Utils$Route$navigate,
										$elm$core$Dict$empty,
										$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top(
											{fZ: model.ahP})),
										createAffiliationCmd
									])),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Patient created!')
								]));
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{lA: false}),
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error)),
								$author$project$OutMsg$reportDecodeError(response)));
					default:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{lA: false}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
				}
		}
	});
var $author$project$Pages$Companies$CompanyId_String$Employees$Create$FormSubmitted = {$: 1};
var $author$project$Pages$Companies$CompanyId_String$Employees$Create$buttonText = function (form) {
	var _v0 = _Utils_Tuple2(
		$author$project$Components$Employee$Form$dependentOf(form),
		$author$project$Components$Employee$Form$shouldEnroll(form));
	if (_v0.a.$ === 1) {
		if (_v0.b) {
			var _v1 = _v0.a;
			return 'Create and Enroll Employee';
		} else {
			var _v2 = _v0.a;
			return 'Create Employee';
		}
	} else {
		if (_v0.b) {
			return 'Create and Enroll Dependent';
		} else {
			return 'Create Dependent';
		}
	}
};
var $elm_community$list_extra$List$Extra$splitAt = F2(
	function (n, xs) {
		return _Utils_Tuple2(
			A2($elm$core$List$take, n, xs),
			A2($elm$core$List$drop, n, xs));
	});
var $author$project$Api$Patient$Meta$chosenFirstName = function (_v0) {
	var fields = _v0.a;
	return fields.ND;
};
var $author$project$Api$Patient$Meta$dob = function (_v0) {
	var fields = _v0.a;
	return fields.agC;
};
var $author$project$Api$Patient$Meta$firstName = function (_v0) {
	var fields = _v0.a;
	return fields.Sv;
};
var $author$project$Api$Patient$Meta$gender = function (_v0) {
	var fields = _v0.a;
	return fields.SR;
};
var $author$project$Api$Patient$Meta$genderIdentity = function (_v0) {
	var fields = _v0.a;
	return fields.SS;
};
var $author$project$Api$Patient$Meta$healthInsuranceCarrier = function (_v0) {
	var fields = _v0.a;
	return fields.Tn;
};
var $author$project$Api$Patient$Meta$joinedPracticeDate = function (_v0) {
	var fields = _v0.a;
	return fields.Vw;
};
var $author$project$Api$Patient$Meta$leadSourceId = function (_v0) {
	var fields = _v0.a;
	return fields.VS;
};
var $author$project$Api$Patient$Meta$locationId = function (_v0) {
	var fields = _v0.a;
	return fields.We;
};
var $author$project$Api$Patient$Meta$practitionerId = function (_v0) {
	var fields = _v0.a;
	return fields.Z2;
};
var $author$project$Api$Patient$Meta$pronouns = function (_v0) {
	var fields = _v0.a;
	return fields._C;
};
var $author$project$Api$Patient$Meta$sex = function (_v0) {
	var fields = _v0.a;
	return fields.aa8;
};
var $author$project$Api$Patient$Meta$usesTobacco = function (_v0) {
	var fields = _v0.a;
	return fields.ad9;
};
var $author$project$Ui$Form$Group$Test = function (a) {
	return {$: 8, a: a};
};
var $author$project$Ui$Form$Group$test = function (dataTest) {
	return $author$project$Ui$Form$Group$Test(dataTest);
};
var $author$project$Components$Patient$Form$viewAddressField = function (address) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Address'),
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpanMd(8),
				$author$project$Ui$Form$Group$test('address')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Address),
				A2($author$project$Components$AddressInput$view, _List_Nil, address))
			]));
};
var $author$project$Components$ResourceFilter$Affiliate$view = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$view,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.Jy),
					options),
				model.b8));
	});
var $author$project$Components$AffiliateInput$view = function (_v0) {
	var filter = _v0.HM;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				A2(
					$author$project$Components$ResourceFilter$Affiliate$view,
					_List_fromArray(
						[
							$author$project$Components$ResourceFilter$style(0)
						]),
					filter))
			]));
};
var $author$project$Components$Patient$Form$viewAffiliateField = function (affiliate) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Primary Care Clinic'),
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpanMd(8),
				$author$project$Ui$Form$Group$test('affiliate')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Affiliate),
				$author$project$Components$AffiliateInput$view(affiliate))
			]));
};
var $author$project$Components$Patient$Form$viewBillingAddressField = F3(
	function (_v0, usesBillingAddress, billingAddress) {
		var billingAsShipping = _v0.afg;
		var _v1 = _Utils_Tuple2(usesBillingAddress, billingAddress);
		if (_v1.a && (!_v1.b.$)) {
			var address = _v1.b.a;
			return A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label(
						(billingAsShipping ? 'Shipping' : 'Billing') + ' Address'),
						$author$project$Ui$Form$Group$labelSpan(4),
						$author$project$Ui$Form$Group$inputSpanMd(8),
						$author$project$Ui$Form$Group$test('billing-address')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$BillingAddress),
						A2($author$project$Components$AddressInput$view, _List_Nil, address))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$Patient$Form$ChosenName = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$NameInput$disable = F2(
	function (disable_, _v0) {
		var errors = _v0.a;
		var options = _v0.b;
		var fields = _v0.c;
		return A3(
			$author$project$Components$NameInput$Model,
			errors,
			_Utils_update(
				options,
				{ep: disable_}),
			fields);
	});
var $author$project$Components$NameInput$test = F2(
	function (string, _v0) {
		var errors = _v0.a;
		var options = _v0.b;
		var fields = _v0.c;
		return A3(
			$author$project$Components$NameInput$Model,
			errors,
			_Utils_update(
				options,
				{u6: string}),
			fields);
	});
var $author$project$Components$NameInput$FieldUpdated = $elm$core$Basics$identity;
var $author$project$Components$NameInput$FirstName = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$NameInput$LastName = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$NameInput$MiddleName = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$NameInput$Suffix = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$NameInput$Title = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$NameInput$errorsForGroup = F2(
	function (validation, errors) {
		return A2(
			$elm$core$List$filterMap,
			function (_v0) {
				var errValidation = _v0.a;
				var errMessage = _v0.b;
				return _Utils_eq(validation, errValidation) ? $elm$core$Maybe$Just(errMessage) : $elm$core$Maybe$Nothing;
			},
			errors);
	});
var $author$project$Components$NameInput$groupHasErrors = F2(
	function (validationGroup, errors) {
		return !$elm$core$List$isEmpty(
			A2($author$project$Components$NameInput$errorsForGroup, validationGroup, errors));
	});
var $author$project$Components$NameInput$titleOptions = _List_fromArray(
	['Ms.', 'Mrs.', 'Miss', 'Mr.', 'Dr.', 'Mx.']);
var $author$project$Components$NameInput$view = function (_v0) {
	var errors = _v0.a;
	var disabled = _v0.b.ep;
	var testStr = _v0.b.u6;
	var fields = _v0.c;
	var _v1 = fields;
	var title = _v1.ac9;
	var firstName = _v1.Sv;
	var middleName = _v1.W7;
	var lastName = _v1.VH;
	var suffix = _v1.acE;
	return A2(
		$author$project$Ui$Grid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$spanSm(2)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Select$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Select$value(
								$elm$core$Maybe$Just(title)),
								$author$project$Ui$Form$Select$onChange(
								A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$NameInput$Title)),
								$author$project$Ui$Form$Select$disabled(disabled)
							]),
						A2(
							$elm$core$List$cons,
							A3(
								$author$project$Ui$Form$Select$option,
								_List_Nil,
								$elm$core$Maybe$Just(''),
								''),
							A2(
								$elm$core$List$map,
								function (option) {
									return A3(
										$author$project$Ui$Form$Select$option,
										_List_Nil,
										$elm$core$Maybe$Just(option),
										option);
								},
								$author$project$Components$NameInput$titleOptions)))
					])),
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$spanMd(3),
						$author$project$Ui$Grid$spanSm(6)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(firstName),
								$author$project$Ui$Form$Input$placeholder('First'),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$NameInput$FirstName)),
								$author$project$Ui$Form$Input$errors(
								A2($author$project$Components$NameInput$errorsForGroup, 0, errors)),
								$author$project$Ui$Form$Input$invalid(
								A2($author$project$Components$NameInput$groupHasErrors, 0, errors)),
								$author$project$Ui$Form$Input$disabled(disabled),
								$author$project$Ui$Form$Input$phi(true),
								$author$project$Ui$Form$Input$test(testStr + '-first-name')
							]))
					])),
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$spanMd(2),
						$author$project$Ui$Grid$spanSm(4)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(middleName),
								$author$project$Ui$Form$Input$placeholder('M'),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$NameInput$MiddleName)),
								$author$project$Ui$Form$Input$disabled(disabled),
								$author$project$Ui$Form$Input$phi(true),
								$author$project$Ui$Form$Input$test(testStr + '-middle-name')
							]))
					])),
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$spanMd(3),
						$author$project$Ui$Grid$spanSm(7)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(lastName),
								$author$project$Ui$Form$Input$placeholder('Last'),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$NameInput$LastName)),
								$author$project$Ui$Form$Input$errors(
								A2($author$project$Components$NameInput$errorsForGroup, 1, errors)),
								$author$project$Ui$Form$Input$invalid(
								A2($author$project$Components$NameInput$groupHasErrors, 1, errors)),
								$author$project$Ui$Form$Input$disabled(disabled),
								$author$project$Ui$Form$Input$phi(true),
								$author$project$Ui$Form$Input$ariaLabel('Last Name'),
								$author$project$Ui$Form$Input$test(testStr + '-last-name')
							]))
					])),
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$spanMd(2),
						$author$project$Ui$Grid$spanSm(5)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(
								A2($elm$core$Maybe$withDefault, '', suffix)),
								$author$project$Ui$Form$Input$placeholder('Suffix'),
								$author$project$Ui$Form$Input$onInput(
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$NameInput$Suffix),
									$elm$core$Maybe$Just)),
								$author$project$Ui$Form$Input$disabled(disabled),
								$author$project$Ui$Form$Input$phi(true),
								$author$project$Ui$Form$Input$ariaLabel('Suffix'),
								$author$project$Ui$Form$Input$test(testStr + '-suffix')
							]))
					]))
			]));
};
var $author$project$Components$Patient$Form$withinTooltipIf = F2(
	function (maybeExplanation, content) {
		if (!maybeExplanation.$) {
			var explanation = maybeExplanation.a;
			return A3(
				$author$project$Ui$Tooltip$view,
				_List_Nil,
				explanation,
				_List_fromArray(
					[content]));
		} else {
			return content;
		}
	});
var $author$project$Components$Patient$Form$viewChosenNameField = F2(
	function (metaField, maybeChosenName) {
		if (!maybeChosenName.$) {
			var chosenName = maybeChosenName.a;
			return A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Chosen Name'),
						$author$project$Ui$Form$Group$labelSpan(4),
						$author$project$Ui$Form$Group$inputSpanMd(8),
						$author$project$Ui$Form$Group$required(true),
						$author$project$Ui$Form$Group$test('chosen-name')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Components$Patient$Form$withinTooltipIf,
						$author$project$Utils$MetaFields$explanation(metaField),
						A2(
							$elm$html$Html$map,
							A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$ChosenName),
							$author$project$Components$NameInput$view(
								A2(
									$author$project$Components$NameInput$test,
									'chosen-name',
									A2(
										$author$project$Components$NameInput$disable,
										$author$project$Utils$MetaFields$isUneditable(metaField),
										chosenName)))))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$Patient$Form$DateOfBirthBlur = {$: 4};
var $author$project$Components$Patient$Form$viewDateOfBirthField = F4(
	function (metaField, _v0, errors, dateOfBirth) {
		var requiresDOB = _v0.Ee;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Date of Birth'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpanMd(8),
					$author$project$Ui$Form$Group$required(requiresDOB),
					$author$project$Ui$Form$Group$test('date-of-birth')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Patient$Form$withinTooltipIf,
					$author$project$Utils$MetaFields$explanation(metaField),
					$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$phi(true),
								$author$project$Ui$Form$Input$placeholder('mm/dd/yyyy'),
								A2($author$project$Ui$Form$Input$maskedValue, $author$project$Components$Patient$Form$datePattern, dateOfBirth),
								A3(
								$author$project$Ui$Form$Input$onMaskedInput,
								$author$project$Components$Patient$Form$datePattern,
								dateOfBirth,
								A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$DateOfBirth)),
								$author$project$Ui$Form$Input$disabled(
								$author$project$Utils$MetaFields$isUneditable(metaField)),
								$author$project$Ui$Form$Input$invalid(
								!$elm$core$List$isEmpty(errors)),
								$author$project$Ui$Form$Input$onBlur($author$project$Components$Patient$Form$DateOfBirthBlur)
							])))
				]));
	});
var $author$project$Components$Patient$Form$Email = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Patient$Form$viewEmailField = F3(
	function (_v0, errors, email) {
		var requiresEmail = _v0.akV;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Email'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpanMd(8),
					$author$project$Ui$Form$Group$required(requiresEmail),
					$author$project$Ui$Form$Group$test('email')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$phi(true),
							$author$project$Ui$Form$Input$placeholder('joe@example.com'),
							$author$project$Ui$Form$Input$value(
							A2($elm$core$Maybe$withDefault, '', email)),
							$author$project$Ui$Form$Input$onInput(
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Email),
								$author$project$Utils$String$toMaybe)),
							$author$project$Ui$Form$Input$errors(errors),
							$author$project$Ui$Form$Input$invalid(
							!$elm$core$List$isEmpty(errors))
						]))
				]));
	});
var $author$project$Components$EmergencyContactInput$Email = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$EmergencyContactInput$FirstName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$EmergencyContactInput$LastName = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$EmergencyContactInput$Relationship = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$EmergencyContactInput$relationshipToLabel = function (rel) {
	if (rel.$ === 1) {
		return 'None';
	} else {
		switch (rel.a.$) {
			case 0:
				var _v1 = rel.a;
				return 'Spouse';
			case 1:
				var _v2 = rel.a;
				return 'Parent';
			case 2:
				var _v3 = rel.a;
				return 'Child';
			case 3:
				var _v4 = rel.a;
				return 'Sibling';
			case 4:
				var _v5 = rel.a;
				return 'Grandparent';
			case 5:
				var _v6 = rel.a;
				return 'Guardian';
			default:
				return 'Other';
		}
	}
};
var $author$project$Components$EmergencyContactInput$relationshipOptions = function (selected) {
	var relationshipToItem = function (rel) {
		return A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(selected, rel)),
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Components$EmergencyContactInput$FieldChanged(
						$author$project$Components$EmergencyContactInput$Relationship(rel)))
				]),
			$elm$html$Html$text(
				$author$project$Components$EmergencyContactInput$relationshipToLabel(rel)));
	};
	return A2(
		$elm$core$List$map,
		relationshipToItem,
		function (someOptions) {
			return A2($elm$core$List$cons, $elm$core$Maybe$Nothing, someOptions);
		}(
			A2(
				$elm$core$List$map,
				$elm$core$Maybe$Just,
				_List_fromArray(
					[
						$author$project$Components$EmergencyContactInput$Spouse,
						$author$project$Components$EmergencyContactInput$Parent,
						$author$project$Components$EmergencyContactInput$Child,
						$author$project$Components$EmergencyContactInput$Sibling,
						$author$project$Components$EmergencyContactInput$Grandparent,
						$author$project$Components$EmergencyContactInput$Guardian,
						$author$project$Components$EmergencyContactInput$Other('')
					]))));
};
var $author$project$Components$EmergencyContactInput$view = function (_v0) {
	var form = _v0.SD;
	var relationshipDropdown = _v0.pB;
	var emergencyContact = $author$project$Utils$Form$fields(form);
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(4)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$placeholder('First Name'),
										$author$project$Ui$Form$Input$phi(true),
										$author$project$Ui$Form$Input$onInput(
										A2($elm$core$Basics$composeL, $author$project$Components$EmergencyContactInput$FieldChanged, $author$project$Components$EmergencyContactInput$FirstName)),
										$author$project$Ui$Form$Input$value(emergencyContact.Sv),
										$author$project$Ui$Form$Input$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 0, form))
									]))
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(4)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$placeholder('Last Name'),
										$author$project$Ui$Form$Input$phi(true),
										$author$project$Ui$Form$Input$onInput(
										A2($elm$core$Basics$composeL, $author$project$Components$EmergencyContactInput$FieldChanged, $author$project$Components$EmergencyContactInput$LastName)),
										$author$project$Ui$Form$Input$value(emergencyContact.VH),
										$author$project$Ui$Form$Input$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 0, form))
									]))
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(4)
							]),
						_List_fromArray(
							[
								A4(
								$author$project$Ui$Dropdown$viewSelect,
								_List_fromArray(
									[
										$author$project$Ui$Dropdown$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 0, form))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										function () {
											var _v1 = emergencyContact.$q;
											if (!_v1.$) {
												var rel = _v1.a;
												return $author$project$Components$EmergencyContactInput$relationshipToLabel(
													$elm$core$Maybe$Just(rel));
											} else {
												return 'Select a relationship';
											}
										}())
									]),
								$author$project$Components$EmergencyContactInput$relationshipOptions(emergencyContact.$q),
								relationshipDropdown)
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(12)
							]),
						_List_fromArray(
							[
								$author$project$Utils$FormErrors$view(
								A2($author$project$Utils$Form$validationErrors, 0, form))
							]))
					])),
				function () {
				var _v2 = emergencyContact.$q;
				if ((!_v2.$) && (_v2.a.$ === 6)) {
					var other = _v2.a.a;
					return A2(
						$author$project$Ui$Grid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanMd(12)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$placeholder('Relationship'),
												$author$project$Ui$Form$Input$onInput(
												A2(
													$elm$core$Basics$composeL,
													A2(
														$elm$core$Basics$composeL,
														A2($elm$core$Basics$composeL, $author$project$Components$EmergencyContactInput$FieldChanged, $author$project$Components$EmergencyContactInput$Relationship),
														$elm$core$Maybe$Just),
													$author$project$Components$EmergencyContactInput$Other)),
												$author$project$Ui$Form$Input$value(other),
												$author$project$Ui$Form$Input$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, 3, form))
											]))
									]))
							]));
				} else {
					return $elm$html$Html$text('');
				}
			}(),
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(6)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								A2($elm$core$Basics$composeL, $author$project$Components$EmergencyContactInput$FieldChanged, $author$project$Components$EmergencyContactInput$Phone),
								$author$project$Components$PhoneInput$view(emergencyContact.Zw))
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(6)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$phi(true),
										$author$project$Ui$Form$Input$placeholder('Email'),
										$author$project$Ui$Form$Input$value(emergencyContact.Rj),
										$author$project$Ui$Form$Input$onInput(
										A2($elm$core$Basics$composeL, $author$project$Components$EmergencyContactInput$FieldChanged, $author$project$Components$EmergencyContactInput$Email)),
										$author$project$Ui$Form$Input$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 2, form))
									])),
								$author$project$Utils$FormErrors$view(
								A2($author$project$Utils$Form$validationErrors, 2, form))
							]))
					]))
			]));
};
var $author$project$Components$Patient$Form$viewEmergencyContact = function (emergencyContact) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Emergency Contact'),
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpanMd(8),
				$author$project$Ui$Form$Group$test('emergency-contacts')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$EmergencyContact),
				$author$project$Components$EmergencyContactInput$view(emergencyContact))
			]));
};
var $author$project$Components$Patient$Form$Gender = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Patient$Form$GenderOther = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Patient$Form$viewGenderField = F3(
	function (metaField, gender, genderOther) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Sex'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpanMd(8),
					$author$project$Ui$Form$Group$test('gender')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Patient$Form$withinTooltipIf,
					$author$project$Utils$MetaFields$explanation(metaField),
					$author$project$Ui$Form$Gender$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Gender$gender(gender),
								$author$project$Ui$Form$Gender$genderOther(genderOther),
								$author$project$Ui$Form$Gender$onGenderChange(
								A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Gender)),
								$author$project$Ui$Form$Gender$onGenderOtherChange(
								A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$GenderOther)),
								$author$project$Ui$Form$Gender$disabled(
								$author$project$Utils$MetaFields$isUneditable(metaField))
							])))
				]));
	});
var $author$project$Components$Patient$Form$GenderIdentity = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Patient$Form$GenderIdentityOther = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$GenderIdentity$Man = {$: 0};
var $author$project$Api$GenderIdentity$NonBinary = {$: 2};
var $author$project$Api$GenderIdentity$TransMan = {$: 3};
var $author$project$Api$GenderIdentity$TransWoman = {$: 4};
var $author$project$Api$GenderIdentity$Woman = {$: 1};
var $author$project$Api$GenderIdentity$all = _List_fromArray(
	[
		$author$project$Api$GenderIdentity$Man,
		$author$project$Api$GenderIdentity$Woman,
		$author$project$Api$GenderIdentity$NonBinary,
		$author$project$Api$GenderIdentity$TransMan,
		$author$project$Api$GenderIdentity$TransWoman,
		$author$project$Api$GenderIdentity$NotListed('')
	]);
var $author$project$Api$GenderIdentity$fromString = F2(
	function (notListedString, genderIdentity) {
		var _v0 = $elm$core$String$toLower(genderIdentity);
		switch (_v0) {
			case 'man':
				return $elm$core$Maybe$Just($author$project$Api$GenderIdentity$Man);
			case 'woman':
				return $elm$core$Maybe$Just($author$project$Api$GenderIdentity$Woman);
			case 'non-binary':
				return $elm$core$Maybe$Just($author$project$Api$GenderIdentity$NonBinary);
			case 'trans man':
				return $elm$core$Maybe$Just($author$project$Api$GenderIdentity$TransMan);
			case 'trans woman':
				return $elm$core$Maybe$Just($author$project$Api$GenderIdentity$TransWoman);
			case 'not listed':
				return $elm$core$Maybe$Just(
					$author$project$Api$GenderIdentity$NotListed(notListedString));
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Patient$Form$viewGenderIdentityField = F3(
	function (metaField, maybeGenderOther, genderIdentity) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Gender Identity'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpanMd(8),
					$author$project$Ui$Form$Group$test('gender-identity')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Components$Patient$Form$withinTooltipIf,
					$author$project$Utils$MetaFields$explanation(metaField),
					A2(
						$author$project$Ui$Form$Select$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Select$value(
								A2($elm$core$Maybe$map, $author$project$Api$GenderIdentity$toString, genderIdentity)),
								$author$project$Ui$Form$Select$onChange(
								A2(
									$elm$core$Basics$composeR,
									$author$project$Api$GenderIdentity$fromString(
										A2($elm$core$Maybe$withDefault, '', maybeGenderOther)),
									A2($elm$core$Basics$composeR, $author$project$Components$Patient$Form$GenderIdentity, $author$project$Components$Patient$Form$FieldUpdated))),
								$author$project$Ui$Form$Select$disabled(
								$author$project$Utils$MetaFields$isUneditable(metaField))
							]),
						A2(
							$elm$core$List$cons,
							A3(
								$author$project$Ui$Form$Select$option,
								_List_Nil,
								$elm$core$Maybe$Just(''),
								''),
							A2(
								$elm$core$List$map,
								function (option) {
									return A3(
										$author$project$Ui$Form$Select$option,
										_List_Nil,
										$elm$core$Maybe$Just(option),
										$elm_community$string_extra$String$Extra$toTitleCase(option));
								},
								A2($elm$core$List$map, $author$project$Api$GenderIdentity$toString, $author$project$Api$GenderIdentity$all))))),
				function () {
					if ((!genderIdentity.$) && (genderIdentity.a.$ === 5)) {
						var other = genderIdentity.a.a;
						return _List_fromArray(
							[
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								A2(
								$author$project$Components$Patient$Form$withinTooltipIf,
								$author$project$Utils$MetaFields$explanation(metaField),
								$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(other),
											$author$project$Ui$Form$Input$placeholder('Description'),
											$author$project$Ui$Form$Input$onInput(
											A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$GenderIdentityOther)),
											$author$project$Ui$Form$Input$disabled(
											$author$project$Utils$MetaFields$isUneditable(metaField))
										])))
							]);
					} else {
						return _List_fromArray(
							[$author$project$Utils$Html$empty]);
					}
				}()));
	});
var $author$project$Components$HealthInsuranceInput$disable = F2(
	function (disabled, _v0) {
		var filter = _v0.a;
		var options = _v0.b;
		var healthInsurance = _v0.c;
		return A3(
			$author$project$Components$HealthInsuranceInput$Model,
			filter,
			_Utils_update(
				options,
				{ep: disabled}),
			healthInsurance);
	});
var $author$project$Components$HealthInsuranceInput$OtherNameUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$ResourceFilter$InsuranceCarrierAlias$view = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$view,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.Jy),
					options),
				model.b8));
	});
var $author$project$Components$HealthInsuranceInput$GroupIdUpdated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$HealthInsuranceInput$viewGroupIdField = F2(
	function (options, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpan(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Group Id')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(value),
								$author$project$Ui$Form$Input$onInput($author$project$Components$HealthInsuranceInput$GroupIdUpdated),
								$author$project$Ui$Form$Input$placeholder('3207524'),
								$author$project$Ui$Form$Input$disabled(options.ep),
								$author$project$Ui$Form$Input$phi(true)
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$HealthInsuranceInput$DeductibleUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$HealthInsuranceInput$viewHighDeductibleField = F2(
	function (options, maybeValue) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('High deductible')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Is this a high-deductible plan?')
						])),
					function () {
					if (!maybeValue.$) {
						var deductible = maybeValue.a;
						return $author$project$Ui$Button$group(
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Yes, this is a high-deductible plan'},
									_List_fromArray(
										[
											$author$project$Ui$Button$active(deductible),
											$author$project$Ui$Button$onClick(
											$author$project$Components$HealthInsuranceInput$DeductibleUpdated(true)),
											$author$project$Ui$Button$disabled(options.ep)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Yes')
										])),
									A3(
									$author$project$Ui$Button$view,
									{mm: 'No, this is not a high-deductible plan'},
									_List_fromArray(
										[
											$author$project$Ui$Button$active(!deductible),
											$author$project$Ui$Button$onClick(
											$author$project$Components$HealthInsuranceInput$DeductibleUpdated(false)),
											$author$project$Ui$Button$disabled(options.ep)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('No')
										]))
								]));
					} else {
						return $author$project$Ui$Button$group(
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Yes, this is a high-deductible plan'},
									_List_fromArray(
										[
											$author$project$Ui$Button$onClick(
											$author$project$Components$HealthInsuranceInput$DeductibleUpdated(true)),
											$author$project$Ui$Button$disabled(options.ep)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Yes')
										])),
									A3(
									$author$project$Ui$Button$view,
									{mm: 'No, this is not a high-deductible plan'},
									_List_fromArray(
										[
											$author$project$Ui$Button$onClick(
											$author$project$Components$HealthInsuranceInput$DeductibleUpdated(false)),
											$author$project$Ui$Button$disabled(options.ep)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('No')
										]))
								]));
					}
				}()
				]));
	});
var $author$project$Components$HealthInsuranceInput$MemberIdUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$HealthInsuranceInput$viewMemberIdField = F2(
	function (options, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpan(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Member Id')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(value),
								$author$project$Ui$Form$Input$onInput($author$project$Components$HealthInsuranceInput$MemberIdUpdated),
								$author$project$Ui$Form$Input$placeholder('A22222222'),
								$author$project$Ui$Form$Input$disabled(options.ep),
								$author$project$Ui$Form$Input$phi(true)
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$HealthInsuranceInput$view = function (_v0) {
	var filter = _v0.a;
	var options = _v0.b;
	var maybeCarrierAndInsurance = _v0.c;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$HealthInsuranceInput$FilterMsg,
				A2(
					$author$project$Components$ResourceFilter$InsuranceCarrierAlias$view,
					_List_fromArray(
						[
							$author$project$Components$ResourceFilter$disabled(options.ep)
						]),
					filter)),
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						A2($elm$html$Html$br, _List_Nil, _List_Nil)),
					maybeCarrierAndInsurance)),
				function () {
				if ((!maybeCarrierAndInsurance.$) && (maybeCarrierAndInsurance.a.a.$ === 1)) {
					var _v2 = maybeCarrierAndInsurance.a;
					var name = _v2.a.a.Bq;
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Carrier\'s Name'),
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(8)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$value(name),
												$author$project$Ui$Form$Input$onInput($author$project$Components$HealthInsuranceInput$OtherNameUpdated),
												$author$project$Ui$Form$Input$disabled(options.ep)
											]))
									]))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				if (!maybeCarrierAndInsurance.$) {
					var _v4 = maybeCarrierAndInsurance.a;
					var groupId = _v4.b.S$;
					var memberId = _v4.b.WL;
					var highDeductible = _v4.b.Tt;
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Components$HealthInsuranceInput$viewGroupIdField, options, groupId),
								A2($author$project$Components$HealthInsuranceInput$viewMemberIdField, options, memberId),
								A2($author$project$Components$HealthInsuranceInput$viewHighDeductibleField, options, highDeductible)
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]));
};
var $author$project$Components$Patient$Form$viewHealthInsuranceField = F2(
	function (metaField, healthInsurance) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Health Insurance'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpanMd(8),
					$author$project$Ui$Form$Group$test('health-insurance')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Patient$Form$withinTooltipIf,
					$author$project$Utils$MetaFields$explanation(metaField),
					A2(
						$elm$html$Html$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$HealthInsurance),
						$author$project$Components$HealthInsuranceInput$view(
							A2(
								$author$project$Components$HealthInsuranceInput$disable,
								$author$project$Utils$MetaFields$isUneditable(metaField),
								healthInsurance))))
				]));
	});
var $author$project$Components$Patient$Form$viewJoinedPracticeField = F2(
	function (metaField, _v0) {
		var joinedPractice = _v0.a;
		var dateInput = _v0.b;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Joined Practice'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpanMd(8),
					$author$project$Ui$Form$Group$test('joined-practice')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Patient$Form$withinTooltipIf,
					$author$project$Utils$MetaFields$explanation(metaField),
					A2(
						$elm$html$Html$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$JoinedPractice),
						A2(
							$author$project$Components$DateInput$view,
							_List_fromArray(
								[
									$author$project$Components$DateInput$value(joinedPractice),
									$author$project$Components$DateInput$disabled(
									$author$project$Utils$MetaFields$isUneditable(metaField))
								]),
							dateInput)))
				]));
	});
var $author$project$Components$KnownPracticeInput$Errors = $elm$core$Basics$identity;
var $author$project$Components$KnownPracticeInput$errors = $elm$core$Basics$identity;
var $author$project$Components$KnownPracticeInput$OtherNameUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$KnownPracticeInput$OtherWebsiteUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$KnownPracticeInput$optionToRecord = F2(
	function (option, acc) {
		var errors_ = option;
		return _Utils_update(
			acc,
			{agX: errors_});
	});
var $author$project$Components$ResourceFilter$KnownPractice$view = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$view,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.Jy),
					options),
				model.b8));
	});
var $author$project$Components$KnownPracticeInput$view = F2(
	function (options, _v0) {
		var filter = _v0.a;
		var knownPractice = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Components$KnownPracticeInput$FilterMsg,
					A2($author$project$Components$ResourceFilter$KnownPractice$view, _List_Nil, filter)),
					function () {
					if ((!knownPractice.$) && (knownPractice.a.$ === 1)) {
						var name = knownPractice.a.a.Bq;
						var website = knownPractice.a.a.F9;
						var optionsRecord = A3(
							$elm$core$List$foldl,
							$author$project$Components$KnownPracticeInput$optionToRecord,
							{agX: _List_Nil},
							options);
						return A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$label('Your DPC Name'),
											$author$project$Ui$Form$Group$labelSpan(4),
											$author$project$Ui$Form$Group$inputSpan(8),
											$author$project$Ui$Form$Group$required(true)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$value(name),
													$author$project$Ui$Form$Input$onInput($author$project$Components$KnownPracticeInput$OtherNameUpdated),
													$author$project$Ui$Form$Input$errors(optionsRecord.agX),
													$author$project$Ui$Form$Input$invalid(
													!$elm$core$List$isEmpty(optionsRecord.agX))
												]))
										])),
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$label('DPC Website'),
											$author$project$Ui$Form$Group$labelSpan(4),
											$author$project$Ui$Form$Group$inputSpan(8)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$value(website),
													$author$project$Ui$Form$Input$onInput($author$project$Components$KnownPracticeInput$OtherWebsiteUpdated)
												]))
										]))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]));
	});
var $author$project$Components$Patient$Form$viewKnownPracticeField = F2(
	function (errors, knownPractice) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('DPC Practice'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpanMd(8),
					$author$project$Ui$Form$Group$test('known-practice')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$KnownPractice),
					A2(
						$author$project$Components$KnownPracticeInput$view,
						_List_fromArray(
							[
								$author$project$Components$KnownPracticeInput$errors(errors)
							]),
						knownPractice))
				]));
	});
var $author$project$Components$LeadSourceInput$disable = F2(
	function (disabled, model) {
		return _Utils_update(
			model,
			{ep: disabled});
	});
var $author$project$Components$LeadSourceInput$OtherChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$LeadSourceInput$view = function (_v0) {
	var other = _v0.dx;
	var disabled = _v0.ep;
	var leadSourceResourceFilter = _v0.oi;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$LeadSourceInput$LeadSourceResourceFilterMsg,
				A2(
					$author$project$Components$ResourceFilter$LeadSource$view,
					_List_fromArray(
						[
							$author$project$Components$ResourceFilter$disabled(disabled)
						]),
					leadSourceResourceFilter)),
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						A2($elm$html$Html$br, _List_Nil, _List_Nil)),
					other)),
				function () {
				if (!other.$) {
					var otherText = other.a;
					return $author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(otherText),
								$author$project$Ui$Form$Input$onInput($author$project$Components$LeadSourceInput$OtherChanged)
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]));
};
var $author$project$Components$Patient$Form$viewLeadSourceField = F2(
	function (metaField, leadSource) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Lead Source'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpanMd(8),
					$author$project$Ui$Form$Group$test('lead-source')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Patient$Form$withinTooltipIf,
					$author$project$Utils$MetaFields$explanation(metaField),
					A2(
						$elm$html$Html$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$LeadSource),
						$author$project$Components$LeadSourceInput$view(
							A2(
								$author$project$Components$LeadSourceInput$disable,
								$author$project$Utils$MetaFields$isUneditable(metaField),
								leadSource))))
				]));
	});
var $author$project$Components$Patient$Form$DifferentChosenNameClicked = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Patient$Form$LegalName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Patient$Form$viewLegalNameField = F3(
	function (metaField, chosenNameIsDifferent, legalName) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Legal Name'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpanMd(8),
					$author$project$Ui$Form$Group$required(true),
					$author$project$Ui$Form$Group$test('legal-name')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Patient$Form$withinTooltipIf,
					$author$project$Utils$MetaFields$explanation(metaField),
					A2(
						$elm$html$Html$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$LegalName),
						$author$project$Components$NameInput$view(
							A2(
								$author$project$Components$NameInput$test,
								'legal-name',
								A2(
									$author$project$Components$NameInput$disable,
									$author$project$Utils$MetaFields$isUneditable(metaField),
									legalName))))),
					A2(
					$author$project$Ui$Form$Checkbox$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Checkbox$value(chosenNameIsDifferent),
							$author$project$Ui$Form$Checkbox$onCheck($author$project$Components$Patient$Form$DifferentChosenNameClicked)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Chosen name is different')
						]))
				]));
	});
var $author$project$Components$Patient$Form$viewLocationField = F4(
	function (metaField, required, errors, location) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Location'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpanMd(8),
					$author$project$Ui$Form$Group$required(required),
					$author$project$Ui$Form$Group$test('location')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Patient$Form$withinTooltipIf,
					$author$project$Utils$MetaFields$explanation(metaField),
					A2(
						$elm$html$Html$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Location),
						A2(
							$author$project$Components$LocationInput$view,
							_List_fromArray(
								[
									$author$project$Components$LocationInput$errors(errors)
								]),
							A2(
								$author$project$Components$LocationInput$disable,
								$author$project$Utils$MetaFields$isUneditable(metaField),
								location))))
				]));
	});
var $author$project$Components$Patient$Form$viewPhonesField = F2(
	function (_v0, phones) {
		var requiresPhone = _v0.akW;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Phones'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpanMd(8),
					$author$project$Ui$Form$Group$required(requiresPhone),
					$author$project$Ui$Form$Group$test('phones')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Phones),
					$author$project$Components$PhoneInput$view(phones))
				]));
	});
var $author$project$Components$PractitionerInput$disable = F2(
	function (disabled, input) {
		return _Utils_update(
			input,
			{ep: disabled});
	});
var $author$project$Components$PractitionerInput$Errors = $elm$core$Basics$identity;
var $author$project$Components$PractitionerInput$errors = $elm$core$Basics$identity;
var $author$project$Components$PractitionerInput$optionToRecord = F2(
	function (option, acc) {
		var errors_ = option;
		return _Utils_update(
			acc,
			{agX: errors_});
	});
var $author$project$Components$PractitionerInput$view = F2(
	function (options, _v0) {
		var filter = _v0.HM;
		var disabled = _v0.ep;
		var optionsRecord = A3(
			$elm$core$List$foldl,
			$author$project$Components$PractitionerInput$optionToRecord,
			{agX: _List_Nil},
			options);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$elm$core$Basics$identity,
					A2(
						$author$project$Components$ResourceFilter$Practitioner$view,
						_List_fromArray(
							[
								$author$project$Components$ResourceFilter$style(0),
								$author$project$Components$ResourceFilter$invalid(
								!$elm$core$List$isEmpty(optionsRecord.agX)),
								$author$project$Components$ResourceFilter$disabled(disabled)
							]),
						filter)),
					$author$project$Utils$FormErrors$view(optionsRecord.agX)
				]));
	});
var $author$project$Components$Patient$Form$viewPractitionerField = F4(
	function (metaField, required, errors, practitioner) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Provider'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpanMd(8),
					$author$project$Ui$Form$Group$required(required),
					$author$project$Ui$Form$Group$test('provider')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Patient$Form$withinTooltipIf,
					$author$project$Utils$MetaFields$explanation(metaField),
					A2(
						$elm$html$Html$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Practitioner),
						A2(
							$author$project$Components$PractitionerInput$view,
							_List_fromArray(
								[
									$author$project$Components$PractitionerInput$errors(errors)
								]),
							A2(
								$author$project$Components$PractitionerInput$disable,
								$author$project$Utils$MetaFields$isUneditable(metaField),
								practitioner))))
				]));
	});
var $author$project$Components$Patient$Form$PreferredLanguage = function (a) {
	return {$: 26, a: a};
};
var $author$project$Components$Patient$Form$viewPreferredLanguageField = function (preferredLanguage) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Preferred Language'),
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpanMd(8),
				$author$project$Ui$Form$Group$test('preferred-language')
			]),
		_List_fromArray(
			[
				$author$project$Components$LanguageInput$view(
				_List_fromArray(
					[
						$author$project$Components$LanguageInput$value(preferredLanguage),
						$author$project$Components$LanguageInput$onChange(
						A2($elm$core$Basics$composeR, $author$project$Components$Patient$Form$PreferredLanguage, $author$project$Components$Patient$Form$FieldUpdated))
					])),
				A2(
				$author$project$Ui$Typography$text,
				_List_fromArray(
					[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
				'This language will be used on the patient portal and all patient notifications')
			]));
};
var $author$project$Components$Patient$Form$ProfilePictureUploaded = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Patient$Form$viewProfilePictureField = F2(
	function (errors, currentProfilePictureUrl) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Profile Picture'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpanMd(8),
					$author$project$Ui$Form$Group$test('profilePicture')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$File$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$File$accept(0),
							$author$project$Ui$Form$File$onInput($author$project$Components$Patient$Form$ProfilePictureUploaded),
							$author$project$Ui$Form$File$empty(false)
						])),
					function () {
					if (!currentProfilePictureUrl.$) {
						if (currentProfilePictureUrl.a === '') {
							return $author$project$Utils$Html$empty;
						} else {
							var url = currentProfilePictureUrl.a;
							return A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$mt4]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Image$fromSrc,
										{LD: 'Profile picture'},
										url,
										_List_fromArray(
											[
												$author$project$Ui$Image$height(50)
											])),
										$author$project$Utils$FormErrors$view(errors)
									]));
						}
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$helpBlock]),
					_List_fromArray(
						[
							$elm$html$Html$text('Profile picture will be shown on patient profile.'),
							A2($elm$html$Html$br, _List_Nil, _List_Nil),
							$elm$html$Html$text('Recommended size: 200x200 px or larger.'),
							A2($elm$html$Html$br, _List_Nil, _List_Nil),
							$elm$html$Html$text('Supported image files: JPG, PNG.')
						]))
				]));
	});
var $author$project$Components$Patient$Form$Pronoun = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Patient$Form$PronounOther = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Pronoun$HeHimHis = {$: 0};
var $author$project$Api$Pronoun$SheHerHers = {$: 1};
var $author$project$Api$Pronoun$TheyThemTheirs = {$: 2};
var $author$project$Api$Pronoun$all = _List_fromArray(
	[
		$author$project$Api$Pronoun$HeHimHis,
		$author$project$Api$Pronoun$SheHerHers,
		$author$project$Api$Pronoun$TheyThemTheirs,
		$author$project$Api$Pronoun$Other('')
	]);
var $author$project$Api$Pronoun$fromString = function (string) {
	switch (string) {
		case 'He/Him/His':
			return $elm$core$Maybe$Just($author$project$Api$Pronoun$HeHimHis);
		case 'She/Her/Hers':
			return $elm$core$Maybe$Just($author$project$Api$Pronoun$SheHerHers);
		case 'They/Them/Theirs':
			return $elm$core$Maybe$Just($author$project$Api$Pronoun$TheyThemTheirs);
		case 'Not Listed':
			return $elm$core$Maybe$Just(
				$author$project$Api$Pronoun$Other(''));
		default:
			return $elm$core$Maybe$Just(
				$author$project$Api$Pronoun$Other(string));
	}
};
var $author$project$Components$Patient$Form$viewPronounField = F2(
	function (metaField, pronoun) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Pronoun'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(6),
					$author$project$Ui$Form$Group$test('pronoun')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Patient$Form$withinTooltipIf,
					$author$project$Utils$MetaFields$explanation(metaField),
					A2(
						$elm$html$Html$div,
						_List_Nil,
						A2(
							$elm$core$List$cons,
							A2(
								$author$project$Ui$Form$Select$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Select$value(
										A2($elm$core$Maybe$map, $author$project$Api$Pronoun$toString, pronoun)),
										$author$project$Ui$Form$Select$onChange(
										A2(
											$elm$core$Basics$composeL,
											A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Pronoun),
											$author$project$Api$Pronoun$fromString)),
										$author$project$Ui$Form$Select$disabled(
										$author$project$Utils$MetaFields$isUneditable(metaField))
									]),
								A2(
									$elm$core$List$cons,
									A3(
										$author$project$Ui$Form$Select$option,
										_List_Nil,
										$elm$core$Maybe$Just(''),
										''),
									A2(
										$elm$core$List$map,
										function (option) {
											return A3(
												$author$project$Ui$Form$Select$option,
												_List_Nil,
												$elm$core$Maybe$Just(option),
												option);
										},
										A2($elm$core$List$map, $author$project$Api$Pronoun$toString, $author$project$Api$Pronoun$all)))),
							function () {
								if ((!pronoun.$) && (pronoun.a.$ === 3)) {
									var other = pronoun.a.a;
									return _List_fromArray(
										[
											A2($elm$html$Html$br, _List_Nil, _List_Nil),
											$author$project$Ui$Form$Input$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$value(other),
													$author$project$Ui$Form$Input$onInput(
													A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$PronounOther)),
													$author$project$Ui$Form$Input$placeholder('Pronoun'),
													$author$project$Ui$Form$Input$disabled(
													$author$project$Utils$MetaFields$isUneditable(metaField))
												]))
										]);
								} else {
									return _List_fromArray(
										[$author$project$Utils$Html$empty]);
								}
							}())))
				]));
	});
var $author$project$Components$Patient$Form$Sex = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Gender$allWithoutOther = _List_fromArray(
	[0, 1, 2]);
var $author$project$Components$Patient$Form$viewSexField = F2(
	function (metaField, sex) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Sex'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpanMd(8),
					$author$project$Ui$Form$Group$test('sex')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Patient$Form$withinTooltipIf,
					$author$project$Utils$MetaFields$explanation(metaField),
					A2(
						$elm$html$Html$span,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (genderOption) {
								return A2(
									$author$project$Ui$Form$Radio$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Radio$value(
											A2(
												$elm$core$Maybe$withDefault,
												false,
												A2(
													$elm$core$Maybe$map,
													$elm$core$Basics$eq(genderOption),
													sex))),
											$author$project$Ui$Form$Radio$onCheck(
											A2(
												$elm$core$Basics$composeL,
												A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Sex),
												$elm$core$Basics$always(genderOption))),
											$author$project$Ui$Form$Radio$disabled(
											$author$project$Utils$MetaFields$isUneditable(metaField))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm_community$string_extra$String$Extra$toTitleCase(
												$author$project$Api$Gender$toString(genderOption)))
										]));
							},
							$author$project$Api$Gender$allWithoutOther)))
				]));
	});
var $author$project$Components$SocialSecurityNumberInput$Errors = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$SocialSecurityNumberInput$errors = $author$project$Components$SocialSecurityNumberInput$Errors;
var $author$project$Components$SocialSecurityNumberInput$Invalid = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$SocialSecurityNumberInput$invalid = $author$project$Components$SocialSecurityNumberInput$Invalid;
var $author$project$Components$SocialSecurityNumberInput$OnInput = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$SocialSecurityNumberInput$onInput = $author$project$Components$SocialSecurityNumberInput$OnInput;
var $author$project$Components$SocialSecurityNumberInput$Value = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$SocialSecurityNumberInput$value = $author$project$Components$SocialSecurityNumberInput$Value;
var $author$project$Components$SocialSecurityNumberInput$defaultOptionRecord = {agX: _List_Nil, sM: false, ajm: $elm$core$Maybe$Nothing, aee: ''};
var $author$project$Components$SocialSecurityNumberInput$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 1:
						var handler = option.a;
						return _Utils_update(
							record,
							{
								ajm: $elm$core$Maybe$Just(handler)
							});
					case 0:
						var val = option.a;
						return _Utils_update(
							record,
							{aee: val});
					case 2:
						var errors_ = option.a;
						return _Utils_update(
							record,
							{agX: errors_});
					default:
						var invalid_ = option.a;
						return _Utils_update(
							record,
							{sM: invalid_});
				}
			}),
		$author$project$Components$SocialSecurityNumberInput$defaultOptionRecord,
		options);
};
var $author$project$Components$SocialSecurityNumberInput$view = function (options) {
	var optionsRecord = $author$project$Components$SocialSecurityNumberInput$optionsToRecord(options);
	var onInputAttr = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (handler) {
				return _List_fromArray(
					[
						A3($author$project$Ui$Form$Input$onMaskedInput, $author$project$Components$SocialSecurityNumberInput$ssnPattern, optionsRecord.aee, handler)
					]);
			},
			optionsRecord.ajm));
	return $author$project$Ui$Form$Input$view(
		A2(
			$elm$core$List$cons,
			A2($author$project$Ui$Form$Input$maskedValue, $author$project$Components$SocialSecurityNumberInput$ssnPattern, optionsRecord.aee),
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Form$Input$placeholder('123-45-6789'),
				A2(
					$elm$core$List$cons,
					$author$project$Ui$Form$Input$errors(optionsRecord.agX),
					A2(
						$elm$core$List$cons,
						$author$project$Ui$Form$Input$invalid(optionsRecord.sM),
						A2(
							$elm$core$List$cons,
							$author$project$Ui$Form$Input$phi(true),
							onInputAttr))))));
};
var $author$project$Components$Patient$Form$viewSsnField = F3(
	function (errors, requiresSSN, ssn) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('SSN'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(4),
					$author$project$Ui$Form$Group$required(requiresSSN),
					$author$project$Ui$Form$Group$test('ssn')
				]),
			_List_fromArray(
				[
					$author$project$Components$SocialSecurityNumberInput$view(
					_List_fromArray(
						[
							$author$project$Components$SocialSecurityNumberInput$value(ssn),
							$author$project$Components$SocialSecurityNumberInput$onInput(
							A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$SSN)),
							$author$project$Components$SocialSecurityNumberInput$errors(errors),
							$author$project$Components$SocialSecurityNumberInput$invalid(
							!$elm$core$List$isEmpty(errors))
						]))
				]));
	});
var $author$project$Components$Patient$Form$SyncToEmr = function (a) {
	return {$: 23, a: a};
};
var $author$project$Components$Patient$Form$viewSyncToEmrField = function (syncToEmr) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Sync to emr'),
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpanMd(8),
				$author$project$Ui$Form$Group$test('sync-to-emr')
			]),
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$view(
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$on(syncToEmr),
						$author$project$Ui$ToggleSwitch$onChange(
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$SyncToEmr))
					]))
			]));
};
var $author$project$Components$Patient$Form$TobaccoUse = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Patient$Form$tobaccoUseFromMaybeString = function (string) {
	switch (string) {
		case 'true':
			return $elm$core$Maybe$Just(true);
		case 'false':
			return $elm$core$Maybe$Just(false);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Patient$Form$tobaccoUseToMaybeString = function (maybeBool) {
	return A2(
		$elm$core$Maybe$map,
		function (bool) {
			return bool ? 'true' : 'false';
		},
		maybeBool);
};
var $author$project$Components$Patient$Form$viewTobaccoUseField = F2(
	function (metaField, tobaccoUse) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Tobacco Use'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpanMd(8),
					$author$project$Ui$Form$Group$test('tobacco-use')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Patient$Form$withinTooltipIf,
					$author$project$Utils$MetaFields$explanation(metaField),
					A2(
						$author$project$Ui$Form$Select$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Select$value(
								$author$project$Components$Patient$Form$tobaccoUseToMaybeString(tobaccoUse)),
								$author$project$Ui$Form$Select$onChange(
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$TobaccoUse),
									$author$project$Components$Patient$Form$tobaccoUseFromMaybeString)),
								$author$project$Ui$Form$Select$disabled(
								$author$project$Utils$MetaFields$isUneditable(metaField))
							]),
						_List_fromArray(
							[
								A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, ''),
								A3(
								$author$project$Ui$Form$Select$option,
								_List_Nil,
								$author$project$Components$Patient$Form$tobaccoUseToMaybeString(
									$elm$core$Maybe$Just(true)),
								'Uses tobacco'),
								A3(
								$author$project$Ui$Form$Select$option,
								_List_Nil,
								$author$project$Components$Patient$Form$tobaccoUseToMaybeString(
									$elm$core$Maybe$Just(false)),
								'Does not use tobacco')
							])))
				]));
	});
var $author$project$Components$Patient$Form$UsesBillingAddress = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Patient$Form$viewUsesBillingAddressField = F2(
	function (_v0, usesBillingAddress) {
		var billingAsShipping = _v0.afg;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label(''),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpanMd(8),
					$author$project$Ui$Form$Group$test('uses-billing-address')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Checkbox$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Checkbox$value(usesBillingAddress),
							$author$project$Ui$Form$Checkbox$onCheck(
							A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$UsesBillingAddress))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Use a different address for billing')
								])),
							A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
							'This ' + ((billingAsShipping ? 'shipping' : 'billing') + ' address will be shown on all invoices and used for payment processing.'))
						]))
				]));
	});
var $author$project$Components$Patient$Form$view = function (_v0) {
	var settings = _v0.a;
	var form = _v0.b;
	var ifSetting = F2(
		function (getter, field) {
			return getter(settings) ? field : $author$project$Utils$Html$empty;
		});
	var fields = $author$project$Utils$Form$fields(form);
	var errorsFor = function (group) {
		return A2($author$project$Utils$Form$validationErrors, group, form);
	};
	var editableField = function (accessor) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Utils$MetaFields$alwaysEditable,
			A2($elm$core$Maybe$map, accessor, settings.W4));
	};
	return _List_fromArray(
		[
			A3(
			$author$project$Components$Patient$Form$viewLegalNameField,
			editableField($author$project$Api$Patient$Meta$firstName),
			$author$project$Utils$Maybe$toBool(fields.bU),
			fields.VU),
			A2(
			$author$project$Components$Patient$Form$viewChosenNameField,
			editableField($author$project$Api$Patient$Meta$chosenFirstName),
			fields.bU),
			A4(
			$author$project$Components$Patient$Form$viewDateOfBirthField,
			editableField($author$project$Api$Patient$Meta$dob),
			settings,
			errorsFor(10),
			fields.PF),
			A2(
			ifSetting,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.adv;
				},
				$elm$core$Basics$not),
			A3(
				$author$project$Components$Patient$Form$viewGenderField,
				editableField($author$project$Api$Patient$Meta$gender),
				fields.SR,
				fields.ST)),
			A2(
			ifSetting,
			function ($) {
				return $.adv;
			},
			A2(
				$author$project$Components$Patient$Form$viewSexField,
				editableField($author$project$Api$Patient$Meta$sex),
				fields.aa8)),
			A2(
			ifSetting,
			function ($) {
				return $.adv;
			},
			A3(
				$author$project$Components$Patient$Form$viewGenderIdentityField,
				editableField($author$project$Api$Patient$Meta$genderIdentity),
				fields.ST,
				fields.SS)),
			A2(
			ifSetting,
			function ($) {
				return $.adv;
			},
			A2(
				$author$project$Components$Patient$Form$viewPronounField,
				editableField($author$project$Api$Patient$Meta$pronouns),
				fields._B)),
			A3(
			$author$project$Components$Patient$Form$viewEmailField,
			settings,
			errorsFor(2),
			fields.Rj),
			A2(
			ifSetting,
			function ($) {
				return $.tc;
			},
			$author$project$Components$Patient$Form$viewPreferredLanguageField(fields.Z9)),
			A2(
			$author$project$Components$Patient$Form$viewProfilePictureField,
			errorsFor(11),
			fields.rT),
			A2($author$project$Components$Patient$Form$viewPhonesField, settings, fields.Zy),
			$author$project$Components$Patient$Form$viewAddressField(fields.K2),
			A2($author$project$Components$Patient$Form$viewUsesBillingAddressField, settings, fields.ad3),
			A3($author$project$Components$Patient$Form$viewBillingAddressField, settings, fields.ad3, fields.MF),
			$author$project$Components$Patient$Form$viewEmergencyContact(fields.Rl),
			A2(
			ifSetting,
			function (_v1) {
				var ssnEnabled = _v1.ab6;
				var userIsAdmin = _v1.F1;
				var isNew = _v1.j1;
				return ssnEnabled && (userIsAdmin || isNew);
			},
			A3(
				$author$project$Components$Patient$Form$viewSsnField,
				errorsFor(6),
				settings.$N,
				fields.ab5)),
			A2(
			ifSetting,
			function ($) {
				return $.aiC;
			},
			A2(
				$author$project$Components$Patient$Form$viewKnownPracticeField,
				errorsFor(7),
				fields.Vy)),
			A2(
			ifSetting,
			function ($) {
				return $.al8;
			},
			A2(
				$author$project$Components$Patient$Form$viewTobaccoUseField,
				editableField($author$project$Api$Patient$Meta$usesTobacco),
				fields.qz)),
			A2(
			ifSetting,
			function ($) {
				return $.Th;
			},
			A4(
				$author$project$Components$Patient$Form$viewPractitionerField,
				editableField($author$project$Api$Patient$Meta$practitionerId),
				settings.$M,
				errorsFor(8),
				fields.aka)),
			A2(
			ifSetting,
			function (_v2) {
				var hasLocations = _v2.Tb;
				var trackPatientsByLocation = _v2.adt;
				return hasLocations && trackPatientsByLocation;
			},
			A4(
				$author$project$Components$Patient$Form$viewLocationField,
				editableField($author$project$Api$Patient$Meta$locationId),
				settings.$G,
				errorsFor(9),
				fields.ais)),
			A2(
			ifSetting,
			function ($) {
				return $.acI;
			},
			$author$project$Components$Patient$Form$viewAffiliateField(fields.Gn)),
			A2(
			$author$project$Components$Patient$Form$viewJoinedPracticeField,
			editableField($author$project$Api$Patient$Meta$joinedPracticeDate),
			fields.j5),
			A2(
			$author$project$Components$Patient$Form$viewHealthInsuranceField,
			editableField($author$project$Api$Patient$Meta$healthInsuranceCarrier),
			fields.Tm),
			A2(
			$author$project$Components$Patient$Form$viewLeadSourceField,
			editableField($author$project$Api$Patient$Meta$leadSourceId),
			fields.VR),
			A2(
			ifSetting,
			function ($) {
				return $.afn;
			},
			$author$project$Components$Patient$Form$viewSyncToEmrField(fields.acM))
		]);
};
var $author$project$Components$Employee$Form$viewEligibilityDate = F2(
	function (errors, _v0) {
		var eligibilityDate = _v0.a;
		var dateInput = _v0.b;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Eligibility Date'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$test('eligibility-date')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$EligibilityDate),
					A2(
						$author$project$Components$DateInput$view,
						_List_fromArray(
							[
								$author$project$Components$DateInput$value(eligibilityDate),
								$author$project$Components$DateInput$errors(errors)
							]),
						dateInput))
				]));
	});
var $author$project$Components$EmployeeDivisionInput$Errors = $elm$core$Basics$identity;
var $author$project$Components$EmployeeDivisionInput$errors = $elm$core$Basics$identity;
var $author$project$Components$EmployeeDivisionInput$DivisionChanged = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$EmployeeDivisionInput$divisionOptions = function (divisions) {
	return A2(
		$elm$core$List$cons,
		A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, 'Unassigned'),
		A2(
			$elm$core$List$map,
			function (division) {
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(
						$author$project$Api$EmployeeDivision$All$id(division)),
					$author$project$Api$EmployeeDivision$All$name(division));
			},
			divisions));
};
var $author$project$Components$EmployeeDivisionInput$optionToRecord = F2(
	function (option, acc) {
		var errors_ = option;
		return _Utils_update(
			acc,
			{agX: errors_});
	});
var $author$project$Components$EmployeeDivisionInput$view = F2(
	function (options, _v0) {
		var employeeDivisions = _v0.zr;
		var division = _v0.QO;
		if (employeeDivisions.$ === 3) {
			var divisions = employeeDivisions.a;
			var optionsRecord = A3(
				$elm$core$List$foldl,
				$author$project$Components$EmployeeDivisionInput$optionToRecord,
				{agX: _List_Nil},
				options);
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Select$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Select$value(division),
								$author$project$Ui$Form$Select$onChange($author$project$Components$EmployeeDivisionInput$DivisionChanged),
								$author$project$Ui$Form$Select$invalid(
								!$elm$core$List$isEmpty(optionsRecord.agX))
							]),
						$author$project$Components$EmployeeDivisionInput$divisionOptions(divisions)),
						$author$project$Utils$FormErrors$view(optionsRecord.agX)
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$EmployeeDivisionInput$visible = function (_v0) {
	var employeeDivisions = _v0.zr;
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$List$isEmpty),
			$author$project$Api$Data$toMaybe(employeeDivisions)));
};
var $author$project$Components$Employee$Form$viewEmployeeDivision = F3(
	function (errors, settings, division) {
		return (settings.ad6 && $author$project$Components$EmployeeDivisionInput$visible(division)) ? A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Division'),
					$author$project$Ui$Form$Group$labelSpanMd(4),
					$author$project$Ui$Form$Group$inputSpanMd(8),
					$author$project$Ui$Form$Group$required(settings.$F)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$Division),
					A2(
						$author$project$Components$EmployeeDivisionInput$view,
						_List_fromArray(
							[
								$author$project$Components$EmployeeDivisionInput$errors(errors)
							]),
						division))
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Components$Employee$Form$viewEmployeeId = F2(
	function (type_, id) {
		if (!id.$) {
			var id_ = id.a;
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label(
							($author$project$Components$EmployeeDependentTypeInput$selectedType(type_) === 'employee') ? 'Employee ID' : 'Dependent ID'),
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$required(false),
							$author$project$Ui$Form$Group$test('registration-id')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(id_)
								]))
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Employee$Form$ExternalId = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Employee$Form$viewExternalId = function (externalId) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('External ID'),
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$test('externalId')
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$value(
						A2($elm$core$Maybe$withDefault, '', externalId)),
						$author$project$Ui$Form$Input$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$ExternalId))
					]))
			]));
};
var $author$project$Components$Employee$Form$Enroll = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Employee$Form$MembershipStartDate = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Employee$Form$viewMembershipStartDate = F3(
	function (currentDate, startDate, maybeEnroll) {
		if (!maybeEnroll.$) {
			var enroll = maybeEnroll.a;
			return A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Membership Start Date'),
						$author$project$Ui$Form$Group$labelSpan(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$test('membership-start-date')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanSm(6)
									]),
								_List_fromArray(
									[
										function () {
										if (enroll) {
											var dateOption = function (date) {
												return A3(
													$author$project$Ui$Form$Select$option,
													_List_Nil,
													$elm$core$Maybe$Just(
														$justinmimbs$date$Date$toIsoString(date)),
													A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, date));
											};
											var options = A2(
												$elm$core$List$map,
												dateOption,
												A4(
													$justinmimbs$date$Date$range,
													2,
													1,
													A3($justinmimbs$date$Date$add, 1, -6, currentDate),
													A3($justinmimbs$date$Date$add, 1, 6, currentDate)));
											return A2(
												$author$project$Ui$Form$Select$view,
												_List_fromArray(
													[
														$author$project$Ui$Form$Select$value(
														$elm$core$Maybe$Just(startDate)),
														$author$project$Ui$Form$Select$onChange(
														A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$MembershipStartDate))
													]),
												options);
										} else {
											return A2(
												$author$project$Ui$Form$Static$view,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Will not be enrolled')
													]));
										}
									}()
									])),
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanSm(6)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Static$view,
										_List_Nil,
										_List_fromArray(
											[
												enroll ? A3(
												$author$project$Ui$Button$view,
												{mm: 'Do not enroll yet'},
												_List_fromArray(
													[
														$author$project$Ui$Button$link,
														$author$project$Ui$Button$onClick(
														$author$project$Components$Employee$Form$FieldUpdated(
															$author$project$Components$Employee$Form$Enroll(
																$elm$core$Maybe$Just(false))))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Do Not Enroll Yet')
													])) : A3(
												$author$project$Ui$Button$view,
												{mm: 'Set membership start date'},
												_List_fromArray(
													[
														$author$project$Ui$Button$link,
														$author$project$Ui$Button$onClick(
														$author$project$Components$Employee$Form$FieldUpdated(
															$author$project$Components$Employee$Form$Enroll(
																$elm$core$Maybe$Just(true))))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Set membership start date')
													]))
											]))
									]))
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$SponsorPlanInput$Errors = $elm$core$Basics$identity;
var $author$project$Components$SponsorPlanInput$errors = $elm$core$Basics$identity;
var $author$project$Components$SponsorPlanInput$optionToRecord = F2(
	function (option, acc) {
		var errors_ = option;
		return _Utils_update(
			acc,
			{agX: errors_});
	});
var $author$project$Components$SponsorPlanInput$view = F2(
	function (options, _v0) {
		var filter = _v0.HM;
		var disabled = _v0.ep;
		var optionsRecord = A3(
			$elm$core$List$foldl,
			$author$project$Components$SponsorPlanInput$optionToRecord,
			{agX: _List_Nil},
			options);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$elm$core$Basics$identity,
					A2(
						$author$project$Components$ResourceFilter$CompanyPlan$view,
						_List_fromArray(
							[
								$author$project$Components$ResourceFilter$style(0),
								$author$project$Components$ResourceFilter$invalid(
								!$elm$core$List$isEmpty(optionsRecord.agX)),
								$author$project$Components$ResourceFilter$disabled(disabled)
							]),
						filter)),
					$author$project$Utils$FormErrors$view(optionsRecord.agX)
				]));
	});
var $author$project$Components$Employee$Form$viewPlanField = F5(
	function (required, errors, type_, sponsorPlan, id) {
		var _v0 = _Utils_Tuple2(
			id,
			$author$project$Components$EmployeeDependentTypeInput$selectedType(type_));
		if ((_v0.a.$ === 1) && (_v0.b === 'employee')) {
			var _v1 = _v0.a;
			return A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Membership Plan'),
						$author$project$Ui$Form$Group$labelSpan(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$required(required),
						$author$project$Ui$Form$Group$test('membership-plan')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$Plan),
						A2(
							$author$project$Components$SponsorPlanInput$view,
							_List_fromArray(
								[
									$author$project$Components$SponsorPlanInput$errors(errors)
								]),
							sponsorPlan))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$EmployeeDependentTypeInput$Errors = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$EmployeeDependentTypeInput$errors = $author$project$Components$EmployeeDependentTypeInput$Errors;
var $author$project$Components$EmployeeDependentTypeInput$Readonly = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$EmployeeDependentTypeInput$readonly = $author$project$Components$EmployeeDependentTypeInput$Readonly;
var $author$project$Components$EmployeeDependentTypeInput$TypeChanged = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$EmployeeDependentTypeInput$defaultOptions = {agX: _List_Nil, ua: false};
var $author$project$Components$EmployeeDependentTypeInput$optionToRecord = F2(
	function (option, acc) {
		if (!option.$) {
			var errors_ = option.a;
			return _Utils_update(
				acc,
				{agX: errors_});
		} else {
			var bool = option.a;
			return _Utils_update(
				acc,
				{ua: bool});
		}
	});
var $author$project$Components$EmployeeDependentTypeInput$typeLabel = function (type_) {
	switch (type_) {
		case 'employee':
			return 'Employee';
		case 'spouse':
			return 'Adult';
		case 'child':
			return 'Child';
		default:
			var somethingElse = type_;
			return somethingElse;
	}
};
var $author$project$Components$EmployeeDependentTypeInput$typeOptions = A2(
	$elm$core$List$map,
	function (type_) {
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(type_),
			$author$project$Components$EmployeeDependentTypeInput$typeLabel(type_));
	},
	_List_fromArray(
		['employee', 'spouse', 'child']));
var $author$project$Components$ResourceFilter$CompanyAccount$view = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$view,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.Jy),
					options),
				model.b8));
	});
var $author$project$Components$EmployeeDependentTypeInput$view = F2(
	function (options, _v0) {
		var type_ = _v0.amg;
		var dependentOfFilter = _v0.dg;
		var dependentOf = _v0.gd;
		var optionsRecord = A3($elm$core$List$foldl, $author$project$Components$EmployeeDependentTypeInput$optionToRecord, $author$project$Components$EmployeeDependentTypeInput$defaultOptions, options);
		return _Utils_Tuple2(
			optionsRecord.ua ? A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Components$EmployeeDependentTypeInput$typeLabel(type_))
					])) : A2(
				$author$project$Ui$Form$Select$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Select$value(
						$elm$core$Maybe$Just(type_)),
						$author$project$Ui$Form$Select$onChange($author$project$Components$EmployeeDependentTypeInput$TypeChanged)
					]),
				$author$project$Components$EmployeeDependentTypeInput$typeOptions),
			(type_ === 'employee') ? $elm$core$Maybe$Nothing : A2(
				$elm$core$Maybe$map,
				function (filter) {
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						optionsRecord.ua ? _List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Static$view,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2($elm$core$Maybe$andThen, $author$project$Api$CompanyAccount$All$subscriberName, dependentOf)))
									]))
							]) : _List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$EmployeeDependentTypeInput$CompanyAccountFilterMsg,
								A2($author$project$Components$ResourceFilter$CompanyAccount$view, _List_Nil, filter)),
								$author$project$Utils$FormErrors$view(optionsRecord.agX)
							]));
				},
				dependentOfFilter));
	});
var $author$project$Components$Employee$Form$viewTypeField = F3(
	function (isNew, errors, typeInput) {
		var _v0 = A2(
			$author$project$Components$EmployeeDependentTypeInput$view,
			_List_fromArray(
				[
					$author$project$Components$EmployeeDependentTypeInput$readonly(!isNew),
					$author$project$Components$EmployeeDependentTypeInput$errors(errors)
				]),
			typeInput);
		var type_ = _v0.a;
		var maybeDependentOf = _v0.b;
		return A2(
			$elm$core$List$cons,
			A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Type'),
						$author$project$Ui$Form$Group$labelSpan(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$required(!isNew),
						$author$project$Ui$Form$Group$test('registration-type')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$Type),
						type_)
					])),
			function () {
				if (!maybeDependentOf.$) {
					var dependentOf_ = maybeDependentOf.a;
					return _List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Dependent Of'),
									$author$project$Ui$Form$Group$labelSpan(4),
									$author$project$Ui$Form$Group$inputSpan(8),
									$author$project$Ui$Form$Group$required(!isNew)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$Type),
									dependentOf_)
								]))
						]);
				} else {
					return _List_Nil;
				}
			}());
	});
var $author$project$Components$Employee$Form$view = function (_v0) {
	var settings = _v0.a;
	var form = _v0.b;
	var fields = $author$project$Utils$Form$fields(form);
	var patientFields = A2(
		$elm$core$List$map,
		$elm$html$Html$map($author$project$Components$Employee$Form$PatientFormMsg),
		$author$project$Components$Patient$Form$view(fields.YY));
	var externalIdField = _List_fromArray(
		[
			$author$project$Components$Employee$Form$viewExternalId(fields.ag7)
		]);
	var errorsFor = function (group) {
		return A2($author$project$Utils$Form$validationErrors, group, form);
	};
	var otherEmployeeFields = fields.j1 ? _List_fromArray(
		[
			A5(
			$author$project$Components$Employee$Form$viewPlanField,
			true,
			errorsFor(2),
			fields.amg,
			fields.Jb,
			fields.ahP),
			A3($author$project$Components$Employee$Form$viewMembershipStartDate, settings.YY.dd, fields.WW, fields.Rz),
			A2(
			$author$project$Components$Employee$Form$viewEligibilityDate,
			errorsFor(3),
			fields.dj)
		]) : _List_fromArray(
		[
			A3($author$project$Components$Employee$Form$viewMembershipStartDate, settings.YY.dd, fields.WW, fields.Rz),
			A2(
			$author$project$Components$Employee$Form$viewEligibilityDate,
			errorsFor(3),
			fields.dj)
		]);
	var divisionField = _List_fromArray(
		[
			A3(
			$author$project$Components$Employee$Form$viewEmployeeDivision,
			errorsFor(4),
			settings.zp,
			fields.QO)
		]);
	var _v1 = A2($elm_community$list_extra$List$Extra$splitAt, 2, patientFields);
	var nameFields = _v1.a;
	var otherPatientFields = _v1.b;
	return _Utils_ap(
		A2($author$project$Components$Employee$Form$viewEmployeeId, fields.amg, fields.ahP),
		_Utils_ap(
			externalIdField,
			_Utils_ap(
				nameFields,
				_Utils_ap(
					A3(
						$author$project$Components$Employee$Form$viewTypeField,
						fields.j1,
						errorsFor(0),
						fields.amg),
					_Utils_ap(
						divisionField,
						_Utils_ap(otherPatientFields, otherEmployeeFields))))));
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Create$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$noValidate(true),
						$author$project$Ui$Form$autocomplete(false),
						$author$project$Ui$Form$onSubmit($author$project$Pages$Companies$CompanyId_String$Employees$Create$FormSubmitted)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_Nil,
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Link$route,
												$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top(
													{fZ: model.ahP}),
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('All Employees & Dependents')
													])),
												A2(
												$author$project$Ui$Typography$text,
												_List_fromArray(
													[$author$project$Ui$Typography$gray]),
												'  /  New Employee or Dependent')
											])),
										$author$project$Ui$HorizontalRule$view(
										_List_fromArray(
											[$author$project$Ui$HorizontalRule$thin])),
										$author$project$Ui$Typography$headingSm(
										_List_fromArray(
											[
												$elm$html$Html$text('New Employee or Dependent')
											])),
										A2(
										$author$project$Ui$Element$view,
										_List_Nil,
										A2(
											$elm$core$List$map,
											$elm$html$Html$map($author$project$Pages$Companies$CompanyId_String$Employees$Create$FormMsg),
											$author$project$Components$Employee$Form$view(model.aK)))
									])),
								A2(
								$author$project$Ui$Panel$footer,
								_List_fromArray(
									[$author$project$Ui$Element$justifyCenter]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top(
											{fZ: model.ahP}),
										_List_fromArray(
											[$author$project$Ui$Link$buttonSecondary]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cancel')
											])),
										A3(
										$author$project$Ui$Button$view,
										{
											mm: $author$project$Pages$Companies$CompanyId_String$Employees$Create$buttonText(model.aK)
										},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$submit,
												$author$project$Ui$Button$loading(model.lA)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Pages$Companies$CompanyId_String$Employees$Create$buttonText(model.aK))
											]))
									]))
							]))
					]))
			]),
		ac9: A2($author$project$Api$Practice$sponsorize, model.ZV, 'Companies') + (' | ' + model.ahP)
	};
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Create$page = $author$project$Spa$Page$applicationCompanyOrEmployer(
	{ah_: $author$project$Pages$Companies$CompanyId_String$Employees$Create$init, aiq: $author$project$Pages$Companies$CompanyId_String$Employees$Create$load, k8: $author$project$Pages$Companies$CompanyId_String$Employees$Create$save, alO: $author$project$Pages$Companies$CompanyId_String$Employees$Create$subscriptions, adT: $author$project$Pages$Companies$CompanyId_String$Employees$Create$update, amo: $author$project$Pages$Companies$CompanyId_String$Employees$Create$view});
var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$GotCompanyAccount = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$GotCompanyRegistration = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Employer$CompanyAccount$retrieve = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Employer$CompanyAccount$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Employer$CompanyAccount$companyAccountPath(id)));
	});
var $author$project$Api$CompanyAccount$retrieve = F5(
	function (apiClient, session, companyId, id, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$CompanyAccount$retrieve,
			apiClient,
			id,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Employer))) : A5(
			$author$project$Api$Provider$Company$Account$retrieve,
			apiClient,
			companyId,
			id,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Provider)));
	});
var $author$project$Api$Employer$CompanyRegistration$retrieve = F4(
	function (apiClient, accountId, id, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Employer$CompanyRegistration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Employer$CompanyRegistration$companyRegistrationPath, accountId, id)));
	});
var $author$project$Api$Provider$Company$Registration$retrieve = F5(
	function (apiClient, companyId, companyAccountId, id, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$CompanyRegistration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A3($author$project$Api$Provider$Company$Registration$companyRegistrationPath, companyId, companyAccountId, id)));
	});
var $author$project$Api$CompanyRegistration$retrieve = F6(
	function (apiClient, session, companyId, companyAccoutId, id, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4(
			$author$project$Api$Employer$CompanyRegistration$retrieve,
			apiClient,
			companyAccoutId,
			id,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyRegistration$One$Employer))) : A5(
			$author$project$Api$Provider$Company$Registration$retrieve,
			apiClient,
			companyId,
			companyAccoutId,
			id,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyRegistration$One$Provider)));
	});
var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$init = F5(
	function (session, practice, company, shared, _v0) {
		var params = _v0.YL;
		var model = {Gv: shared.Gv, afQ: company, Ob: $author$project$Api$Data$Loading, Oc: params.agM, fZ: params.fZ, Oi: $author$project$Api$Data$Loading, G_: params.agp, dd: shared.dd, aK: $elm$core$Maybe$Nothing, ahK: shared.ahK, W4: $author$project$Api$Data$Loading, ajE: shared.ajE, YY: $author$project$Api$Data$Loading, ZV: practice, k9: $author$project$Api$Data$NotAsked, aa4: session, lA: false};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A5($author$project$Api$CompanyAccount$retrieve, shared.Gv, session, params.fZ, params.agM, $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$GotCompanyAccount),
						A6($author$project$Api$CompanyRegistration$retrieve, shared.Gv, session, params.fZ, params.agM, params.agp, $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$GotCompanyRegistration)
					])));
	});
var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$FormMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$subscriptions = function (model) {
	var _v0 = model.aK;
	if (!_v0.$) {
		var employeeForm = _v0.a;
		return A2(
			$elm$core$Platform$Sub$map,
			$author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$FormMsg,
			$author$project$Components$Employee$Form$subscriptions(employeeForm));
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$CompanyAccountUpdated = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$CompanyRegistrationUpdated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$GotMeta = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$GotPatient = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Employer$CompanyAccount$One$division = function (_v0) {
	var record = _v0.b;
	return record.QO;
};
var $author$project$Api$Provider$CompanyAccount$One$division = function (_v0) {
	var record = _v0.b;
	return record.QO;
};
var $author$project$Api$CompanyAccount$One$division = function (companyAccount) {
	if (!companyAccount.$) {
		var companyAccount_ = companyAccount.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$EmployeeDivision$All$Provider,
			$author$project$Api$Provider$CompanyAccount$One$division(companyAccount_));
	} else {
		var companyAccount_ = companyAccount.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$EmployeeDivision$All$Employer,
			$author$project$Api$Employer$CompanyAccount$One$division(companyAccount_));
	}
};
var $author$project$Api$Employer$CompanyAccount$Shared$eligibilityStartDate = function (_v0) {
	var record = _v0;
	return record.Rg;
};
var $author$project$Api$Employer$CompanyAccount$One$eligibilityStartDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$CompanyAccount$Shared$eligibilityStartDate(shared);
};
var $author$project$Api$Provider$CompanyAccount$Shared$eligibilityStartDate = function (_v0) {
	var record = _v0.b;
	return record.Rg;
};
var $author$project$Api$Provider$CompanyAccount$One$eligibilityStartDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyAccount$Shared$eligibilityStartDate(shared);
};
var $author$project$Api$CompanyAccount$One$eligibilityStartDate = function (companyAccount) {
	if (!companyAccount.$) {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$Provider$CompanyAccount$One$eligibilityStartDate(companyAccount_);
	} else {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$Employer$CompanyAccount$One$eligibilityStartDate(companyAccount_);
	}
};
var $author$project$Api$Employer$CompanyRegistration$Shared$externalId = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Employer$CompanyRegistration$One$externalId = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$CompanyRegistration$Shared$externalId(shared);
};
var $author$project$Api$Provider$CompanyRegistration$Shared$externalId = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Provider$CompanyRegistration$One$externalId = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyRegistration$Shared$externalId(shared);
};
var $author$project$Api$CompanyRegistration$One$externalId = function (companyRegistration) {
	if (!companyRegistration.$) {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Provider$CompanyRegistration$One$externalId(companyRegistration_);
	} else {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Employer$CompanyRegistration$One$externalId(companyRegistration_);
	}
};
var $author$project$Components$EmployeeDependentTypeInput$fill = F3(
	function (session, company, type_) {
		return _Utils_Tuple2(
			{afQ: company, gd: $elm$core$Maybe$Nothing, dg: $elm$core$Maybe$Nothing, aa4: session, amg: type_},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Components$EmployeeDivisionInput$fill = F4(
	function (session, companyId, apiClient, division) {
		return _Utils_Tuple2(
			{Gv: apiClient, QO: division, zr: $author$project$Api$Data$Loading, akR: false, aa4: session},
			A5(
				$author$project$Api$EmployeeDivision$list,
				apiClient,
				session,
				companyId,
				function (d) {
					return d;
				},
				$author$project$Components$EmployeeDivisionInput$GotEmployeeDivisions));
	});
var $author$project$Api$Employer$Patient$One$address = function (_v0) {
	var record = _v0.b;
	return record.K2;
};
var $author$project$Api$Patient$One$address = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$address(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$address(patient_);
	}
};
var $author$project$Api$Employer$Patient$One$assignedAffiliation = function (_v0) {
	var record = _v0.b;
	return record.L0;
};
var $author$project$Api$Provider$Patient$One$assignedAffiliation = function (_v0) {
	var record = _v0.b;
	return record.L0;
};
var $author$project$Api$Patient$One$assignedAffiliation = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Affiliate$AffiliateMin$Provider,
			$author$project$Api$Provider$Patient$One$assignedAffiliation(patient_));
	} else {
		var patient_ = patient.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Affiliate$AffiliateMin$Employer,
			$author$project$Api$Employer$Patient$One$assignedAffiliation(patient_));
	}
};
var $author$project$Api$Employer$Patient$One$billingAddress = function (_v0) {
	var record = _v0.b;
	return record.MF;
};
var $author$project$Api$Patient$One$billingAddress = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$billingAddress(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$billingAddress(patient_);
	}
};
var $author$project$Api$Employer$Patient$One$chosenFirstName = function (_v0) {
	var record = _v0.b;
	return record.ND;
};
var $author$project$Api$Provider$Patient$Shared$chosenFirstName = function (_v0) {
	var shared = _v0;
	return shared.ND;
};
var $author$project$Api$Provider$Patient$One$chosenFirstName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$chosenFirstName(shared);
};
var $author$project$Api$Patient$One$chosenFirstName = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$chosenFirstName(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$chosenFirstName(patient_);
	}
};
var $author$project$Api$Employer$Patient$One$chosenLastName = function (_v0) {
	var record = _v0.b;
	return record.NE;
};
var $author$project$Api$Provider$Patient$Shared$chosenLastName = function (_v0) {
	var shared = _v0;
	return shared.NE;
};
var $author$project$Api$Provider$Patient$One$chosenLastName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$chosenLastName(shared);
};
var $author$project$Api$Patient$One$chosenLastName = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$chosenLastName(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$chosenLastName(patient_);
	}
};
var $author$project$Api$Employer$Patient$One$chosenMiddleName = function (_v0) {
	var record = _v0.b;
	return record.NF;
};
var $author$project$Api$Provider$Patient$Shared$chosenMiddleName = function (_v0) {
	var shared = _v0;
	return shared.NF;
};
var $author$project$Api$Provider$Patient$One$chosenMiddleName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$chosenMiddleName(shared);
};
var $author$project$Api$Patient$One$chosenMiddleName = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$chosenMiddleName(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$chosenMiddleName(patient_);
	}
};
var $author$project$Api$Employer$Patient$One$chosenTitle = function (_v0) {
	var record = _v0.b;
	return record.NH;
};
var $author$project$Api$Provider$Patient$Shared$chosenTitle = function (_v0) {
	var shared = _v0;
	return shared.NH;
};
var $author$project$Api$Provider$Patient$One$chosenTitle = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$chosenTitle(shared);
};
var $author$project$Api$Patient$One$chosenTitle = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$chosenTitle(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$chosenTitle(patient_);
	}
};
var $author$project$Components$Patient$Form$chosenNamePresent = function (patient) {
	return $author$project$Utils$Maybe$toBool(
		$author$project$Api$Patient$One$chosenTitle(patient)) || ($author$project$Utils$Maybe$toBool(
		$author$project$Api$Patient$One$chosenFirstName(patient)) || ($author$project$Utils$Maybe$toBool(
		$author$project$Api$Patient$One$chosenMiddleName(patient)) || $author$project$Utils$Maybe$toBool(
		$author$project$Api$Patient$One$chosenLastName(patient))));
};
var $author$project$Api$Employer$Patient$One$chosenSuffix = function (_v0) {
	var record = _v0.b;
	return record.NG;
};
var $author$project$Api$Provider$Patient$Shared$chosenSuffix = function (_v0) {
	var shared = _v0;
	return shared.NG;
};
var $author$project$Api$Provider$Patient$One$chosenSuffix = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$chosenSuffix(shared);
};
var $author$project$Api$Patient$One$chosenSuffix = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$chosenSuffix(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$chosenSuffix(patient_);
	}
};
var $author$project$Api$Employer$Patient$Shared$dob = function (_v0) {
	var record = _v0;
	return record.agC;
};
var $author$project$Api$Employer$Patient$One$dob = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Patient$Shared$dob(shared);
};
var $author$project$Api$Provider$Patient$Shared$dob = function (_v0) {
	var shared = _v0;
	return shared.agC;
};
var $author$project$Api$Provider$Patient$One$dob = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$dob(shared);
};
var $author$project$Api$Patient$One$dob = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$dob(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$dob(patient_);
	}
};
var $author$project$Api$Employer$Patient$Shared$email = function (_v0) {
	var record = _v0;
	return record.Rj;
};
var $author$project$Api$Employer$Patient$One$email = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Patient$Shared$email(shared);
};
var $author$project$Api$Patient$One$email = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$email(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$email(patient_);
	}
};
var $author$project$Api$Employer$Patient$One$emergencyContact = function (_v0) {
	var record = _v0.b;
	return record.Rl;
};
var $author$project$Api$Provider$Patient$One$emergencyContact = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$One$record_,
	function ($) {
		return $.Rl;
	});
var $author$project$Api$Patient$One$emergencyContact = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$emergencyContact(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$emergencyContact(patient_);
	}
};
var $author$project$Components$Patient$Form$GotPlainSSN = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Employer$Patient$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Employer$Patient$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Patient$Shared$id(shared);
};
var $author$project$Api$Patient$One$id = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$id(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$id(patient_);
	}
};
var $author$project$Api$Provider$SocialSecurityNumber$One$SocialSecurityNumber = $elm$core$Basics$identity;
var $author$project$Api$Provider$SocialSecurityNumber$One$Record = function (formattedNumber) {
	return {SH: formattedNumber};
};
var $author$project$Api$Provider$SocialSecurityNumber$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'formatted_number',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$SocialSecurityNumber$One$Record));
var $author$project$Api$Provider$SocialSecurityNumber$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$SocialSecurityNumber$One$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$SocialSecurityNumber$ssnPath = function (patientId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['social_security_number']),
		A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[patientId]),
			A2(
				$author$project$Api$Data$pathAppend,
				_List_fromArray(
					['patients']),
				$author$project$Api$Data$providerPath)));
};
var $author$project$Api$Provider$SocialSecurityNumber$retrieve = F3(
	function (apiClient, patientId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$SocialSecurityNumber$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$SocialSecurityNumber$ssnPath(patientId)));
	});
var $author$project$Components$Patient$Form$fetchPlainSSN = F3(
	function (apiClient, session, patient) {
		var _v0 = $author$project$Api$Platform$Session$One$role(session);
		if (_v0 === 'practice_admin') {
			return A3(
				$author$project$Api$Provider$SocialSecurityNumber$retrieve,
				apiClient,
				$author$project$Api$Patient$One$id(patient),
				$author$project$Components$Patient$Form$GotPlainSSN);
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Api$Employer$Patient$Shared$firstName = function (_v0) {
	var shared = _v0;
	return shared.Sv;
};
var $author$project$Api$Employer$Patient$One$firstName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Patient$Shared$firstName(shared);
};
var $author$project$Api$Provider$Patient$Shared$firstName = function (_v0) {
	var shared = _v0;
	return shared.Sv;
};
var $author$project$Api$Provider$Patient$One$firstName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$firstName(shared);
};
var $author$project$Api$Patient$One$firstName = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$firstName(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$firstName(patient_);
	}
};
var $author$project$Api$Gender$fromString = function (gender) {
	switch (gender) {
		case 'male':
			return $elm$core$Maybe$Just(0);
		case 'female':
			return $elm$core$Maybe$Just(1);
		case 'intersex':
			return $elm$core$Maybe$Just(2);
		case 'other':
			return $elm$core$Maybe$Just(3);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Employer$Patient$Shared$gender = function (_v0) {
	var shared = _v0;
	return shared.SR;
};
var $author$project$Api$Employer$Patient$One$gender = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Patient$Shared$gender(shared);
};
var $author$project$Api$Provider$Patient$Shared$gender = function (_v0) {
	var shared = _v0;
	return shared.SR;
};
var $author$project$Api$Provider$Patient$One$gender = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$gender(shared);
};
var $author$project$Api$Patient$One$gender = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$gender(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$gender(patient_);
	}
};
var $author$project$Api$Employer$Patient$Shared$genderIdentity = function (_v0) {
	var shared = _v0;
	return shared.SS;
};
var $author$project$Api$Employer$Patient$One$genderIdentity = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Patient$Shared$genderIdentity(shared);
};
var $author$project$Api$Provider$Patient$Shared$genderIdentity = function (_v0) {
	var shared = _v0;
	return shared.SS;
};
var $author$project$Api$Provider$Patient$One$genderIdentity = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$genderIdentity(shared);
};
var $author$project$Api$Patient$One$genderIdentity = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$genderIdentity(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$genderIdentity(patient_);
	}
};
var $author$project$Api$Employer$Patient$Shared$genderOther = function (_v0) {
	var shared = _v0;
	return shared.ST;
};
var $author$project$Api$Employer$Patient$One$genderOther = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Patient$Shared$genderOther(shared);
};
var $author$project$Api$Provider$Patient$Shared$genderOther = function (_v0) {
	var shared = _v0;
	return shared.ST;
};
var $author$project$Api$Provider$Patient$One$genderOther = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$genderOther(shared);
};
var $author$project$Api$Patient$One$genderOther = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$genderOther(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$genderOther(patient_);
	}
};
var $author$project$Api$HealthInsurance$Shared$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$HealthInsurance$Shared$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$Patient$One$healthInsurance = function (_v0) {
	var record = _v0.b;
	return record.Tm;
};
var $author$project$Api$Provider$Patient$One$healthInsurance = function (_v0) {
	var record = _v0.b;
	return record.Tm;
};
var $author$project$Api$Patient$One$healthInsurance = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$HealthInsurance$Shared$Provider,
			$author$project$Api$Provider$Patient$One$healthInsurance(patient_));
	} else {
		var patient_ = patient.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$HealthInsurance$Shared$Employer,
			$author$project$Api$Employer$Patient$One$healthInsurance(patient_));
	}
};
var $author$project$Api$Employer$LeadSource$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$LeadSource$Shared$id = function (leadSource) {
	if (!leadSource.$) {
		var leadSource_ = leadSource.a;
		return $author$project$Api$Provider$LeadSource$Shared$id(leadSource_);
	} else {
		var leadSource_ = leadSource.a;
		return $author$project$Api$Employer$LeadSource$Shared$id(leadSource_);
	}
};
var $author$project$Api$Employer$HealthInsurance$Shared$carrier = function (_v0) {
	var record = _v0;
	return record.Np;
};
var $author$project$Api$Provider$HealthInsurance$Shared$carrier = function (_v0) {
	var shared = _v0;
	return shared.Np;
};
var $author$project$Api$HealthInsurance$Shared$carrier = function (insurance) {
	if (!insurance.$) {
		var insurance_ = insurance.a;
		return A2(
			$elm$core$Maybe$map,
			function (carrier_) {
				return $author$project$Api$HealthInsuranceCarrier$Shared$Provider(carrier_);
			},
			$author$project$Api$Provider$HealthInsurance$Shared$carrier(insurance_));
	} else {
		var insurance_ = insurance.a;
		return A2(
			$elm$core$Maybe$map,
			function (carrier_) {
				return $author$project$Api$HealthInsuranceCarrier$Shared$Employer(carrier_);
			},
			$author$project$Api$Employer$HealthInsurance$Shared$carrier(insurance_));
	}
};
var $author$project$Api$Employer$HealthInsurance$Shared$groupId = function (_v0) {
	var record = _v0;
	return record.S$;
};
var $author$project$Api$Provider$HealthInsurance$Shared$groupId = function (_v0) {
	var shared = _v0;
	return shared.S$;
};
var $author$project$Api$HealthInsurance$Shared$groupId = function (insurance) {
	if (!insurance.$) {
		var insurance_ = insurance.a;
		return $author$project$Api$Provider$HealthInsurance$Shared$groupId(insurance_);
	} else {
		var insurance_ = insurance.a;
		return $author$project$Api$Employer$HealthInsurance$Shared$groupId(insurance_);
	}
};
var $author$project$Api$Employer$HealthInsurance$Shared$highDeductible = function (_v0) {
	var record = _v0;
	return record.Tt;
};
var $author$project$Api$Provider$HealthInsurance$Shared$highDeductible = function (_v0) {
	var shared = _v0;
	return shared.Tt;
};
var $author$project$Api$HealthInsurance$Shared$highDeductible = function (insurance) {
	if (!insurance.$) {
		var insurance_ = insurance.a;
		return $author$project$Api$Provider$HealthInsurance$Shared$highDeductible(insurance_);
	} else {
		var insurance_ = insurance.a;
		return $author$project$Api$Employer$HealthInsurance$Shared$highDeductible(insurance_);
	}
};
var $author$project$Api$Employer$HealthInsurance$Shared$memberId = function (_v0) {
	var record = _v0;
	return record.WL;
};
var $author$project$Api$Provider$HealthInsurance$Shared$memberId = function (_v0) {
	var shared = _v0;
	return shared.WL;
};
var $author$project$Api$HealthInsurance$Shared$memberId = function (insurance) {
	if (!insurance.$) {
		var insurance_ = insurance.a;
		return $author$project$Api$Provider$HealthInsurance$Shared$memberId(insurance_);
	} else {
		var insurance_ = insurance.a;
		return $author$project$Api$Employer$HealthInsurance$Shared$memberId(insurance_);
	}
};
var $author$project$Api$Employer$HealthInsurance$Shared$payerName = function (_v0) {
	var record = _v0;
	return record.Y5;
};
var $author$project$Api$Provider$HealthInsurance$Shared$payerName = function (_v0) {
	var shared = _v0;
	return shared.Y5;
};
var $author$project$Api$HealthInsurance$Shared$payerName = function (insurance) {
	if (!insurance.$) {
		var insurance_ = insurance.a;
		return $author$project$Api$Provider$HealthInsurance$Shared$payerName(insurance_);
	} else {
		var insurance_ = insurance.a;
		return $author$project$Api$Employer$HealthInsurance$Shared$payerName(insurance_);
	}
};
var $author$project$Components$ResourceFilter$InsuranceCarrierAlias$preSelectedId = F2(
	function (id, model) {
		var _v0 = A2($author$project$Components$ResourceFilter$preSelectedId, id, model.b8);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{b8: resourceFilter}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$ResourceFilter$InsuranceCarrierAlias$setValue = F2(
	function (resource, model) {
		return _Utils_update(
			model,
			{
				Jy: function () {
					if (!resource.$) {
						var resource_ = resource.a;
						return $author$project$Components$ResourceFilter$One(resource_);
					} else {
						return $author$project$Components$ResourceFilter$All;
					}
				}()
			});
	});
var $author$project$Components$HealthInsuranceInput$init = F3(
	function (apiClient, session, healthInsurance) {
		var insuranceCarrier = function () {
			var _v3 = $author$project$Api$HealthInsurance$Shared$carrier(healthInsurance);
			if (!_v3.$) {
				var carrier = _v3.a;
				return $author$project$Components$HealthInsuranceInput$InsuranceCarrierAlias(
					{
						GT: $author$project$Api$HealthInsuranceCarrier$Shared$collectGroupId(carrier),
						Nq: $author$project$Api$HealthInsuranceCarrier$Shared$collectHighDeductible(carrier),
						GU: $author$project$Api$HealthInsuranceCarrier$Shared$collectMemberId(carrier),
						GV: $author$project$Api$HealthInsuranceCarrier$Shared$id(carrier),
						Bq: A2(
							$elm$core$Maybe$withDefault,
							'',
							$author$project$Api$HealthInsurance$Shared$payerName(healthInsurance))
					});
			} else {
				return $author$project$Components$HealthInsuranceInput$Other(
					{
						Bq: A2(
							$elm$core$Maybe$withDefault,
							'',
							$author$project$Api$HealthInsurance$Shared$payerName(healthInsurance))
					});
			}
		}();
		var healthInsuranceRecord = {
			S$: $author$project$Api$HealthInsurance$Shared$groupId(healthInsurance),
			Tt: $author$project$Api$HealthInsurance$Shared$highDeductible(healthInsurance),
			WL: $author$project$Api$HealthInsurance$Shared$memberId(healthInsurance),
			Y5: $author$project$Api$HealthInsurance$Shared$payerName(healthInsurance)
		};
		var _v0 = function (_v1) {
			var filter = _v1.a;
			var filterCmd = _v1.b;
			var _v2 = $author$project$Api$HealthInsurance$Shared$carrier(healthInsurance);
			if (!_v2.$) {
				var carrier = _v2.a;
				var insuranceAlias = {
					GT: $author$project$Api$HealthInsuranceCarrier$Shared$collectGroupId(carrier),
					Nq: $author$project$Api$HealthInsuranceCarrier$Shared$collectHighDeductible(carrier),
					GU: $author$project$Api$HealthInsuranceCarrier$Shared$collectMemberId(carrier),
					GV: $author$project$Api$HealthInsuranceCarrier$Shared$id(carrier),
					Bq: A2(
						$elm$core$Maybe$withDefault,
						'',
						$author$project$Api$HealthInsurance$Shared$payerName(healthInsurance))
				};
				return _Utils_Tuple2(
					A2(
						$author$project$Components$ResourceFilter$InsuranceCarrierAlias$setValue,
						$elm$core$Maybe$Just(insuranceAlias),
						filter),
					filterCmd);
			} else {
				return A2(
					$elm$core$Tuple$mapSecond,
					function (preSelectedIdCmd) {
						return $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[filterCmd, preSelectedIdCmd]));
					},
					A2(
						$author$project$Components$ResourceFilter$InsuranceCarrierAlias$preSelectedId,
						$elm$core$Maybe$Just(''),
						filter));
			}
		}(
			A3(
				$author$project$Components$ResourceFilter$InsuranceCarrierAlias$init,
				apiClient,
				session,
				function (d) {
					return _Utils_update(
						d,
						{Gp: 'None', XY: 'Other (Enter insurance carrier name manually)', ai5: true});
				}));
		var insuranceCarrierAliasFilter = _v0.a;
		var insuranceCarrierAliasCmd = _v0.b;
		return _Utils_Tuple2(
			A3(
				$author$project$Components$HealthInsuranceInput$Model,
				insuranceCarrierAliasFilter,
				{ep: false},
				$elm$core$Maybe$Just(
					_Utils_Tuple2(insuranceCarrier, healthInsuranceRecord))),
			A2($elm$core$Platform$Cmd$map, $author$project$Components$HealthInsuranceInput$FilterMsg, insuranceCarrierAliasCmd));
	});
var $author$project$Api$KnownPractice$Shared$id = function (knownPractice) {
	if (!knownPractice.$) {
		var knownPractice_ = knownPractice.a;
		return $author$project$Api$Provider$KnownPractice$Shared$id(knownPractice_);
	} else {
		var knownPractice_ = knownPractice.a;
		return $author$project$Api$Employer$KnownPractice$Shared$id(knownPractice_);
	}
};
var $author$project$Api$KnownPractice$Shared$name = function (knownPractice) {
	if (!knownPractice.$) {
		var knownPractice_ = knownPractice.a;
		return $author$project$Api$Provider$KnownPractice$Shared$name(knownPractice_);
	} else {
		var knownPractice_ = knownPractice.a;
		return $author$project$Api$Employer$KnownPractice$Shared$name(knownPractice_);
	}
};
var $author$project$Components$ResourceFilter$KnownPractice$setValue = F2(
	function (resource, model) {
		return _Utils_update(
			model,
			{
				Jy: function () {
					if (!resource.$) {
						var resource_ = resource.a;
						return $author$project$Components$ResourceFilter$One(resource_);
					} else {
						return $author$project$Components$ResourceFilter$All;
					}
				}()
			});
	});
var $author$project$Components$KnownPracticeInput$init = F3(
	function (apiClient, session, knownPractice) {
		var knownPractice_ = {
			ahP: $author$project$Api$KnownPractice$Shared$id(knownPractice),
			Bq: $author$project$Api$KnownPractice$Shared$name(knownPractice)
		};
		var _v0 = A2(
			$elm$core$Tuple$mapFirst,
			function (filter) {
				return A2(
					$author$project$Components$ResourceFilter$KnownPractice$setValue,
					$elm$core$Maybe$Just(knownPractice_),
					filter);
			},
			A3(
				$author$project$Components$ResourceFilter$KnownPractice$init,
				apiClient,
				session,
				function (d) {
					return _Utils_update(
						d,
						{Gp: 'Select a DPC practice', XY: 'Other (Enter your DPC manually)', ai5: true});
				}));
		var knownPracticeFilter = _v0.a;
		var knownPracticeCmd = _v0.b;
		return _Utils_Tuple2(
			A2(
				$author$project$Components$KnownPracticeInput$Model,
				knownPracticeFilter,
				$elm$core$Maybe$Just(
					$author$project$Components$KnownPracticeInput$KnownPractice(knownPractice_))),
			A2($elm$core$Platform$Cmd$map, $author$project$Components$KnownPracticeInput$FilterMsg, knownPracticeCmd));
	});
var $author$project$Components$LeadSourceInput$init = F3(
	function (apiClient, selected, other) {
		var _v0 = A2($author$project$Components$LeadSourceInput$initLeadSourceResourceFilter, apiClient, selected);
		var leadSourceResourceFilter = _v0.a;
		var leadSourceResourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{ep: false, oi: leadSourceResourceFilter, dx: other, aB: selected},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$LeadSourceInput$LeadSourceResourceFilterMsg, leadSourceResourceFilterCmd));
	});
var $author$project$Components$NameInput$init = function (fields) {
	return A3(
		$author$project$Components$NameInput$Model,
		_List_Nil,
		{ep: false, u6: ''},
		fields);
};
var $author$project$Api$Employer$Patient$Shared$joinedPracticeDate = function (_v0) {
	var shared = _v0;
	return shared.Vw;
};
var $author$project$Api$Employer$Patient$One$joinedPracticeDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Patient$Shared$joinedPracticeDate(shared);
};
var $author$project$Api$Provider$Patient$Shared$joinedPracticeDate = function (_v0) {
	var shared = _v0;
	return shared.Vw;
};
var $author$project$Api$Provider$Patient$One$joinedPracticeDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$joinedPracticeDate(shared);
};
var $author$project$Api$Patient$One$joinedPracticeDate = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$joinedPracticeDate(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$joinedPracticeDate(patient_);
	}
};
var $author$project$Api$KnownPractice$Shared$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$KnownPractice$Shared$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$Patient$One$knownPractice = function (_v0) {
	var record = _v0.b;
	return record.Vy;
};
var $author$project$Api$Provider$Patient$One$knownPractice = function (_v0) {
	var record = _v0.b;
	return record.Vy;
};
var $author$project$Api$Patient$One$knownPractice = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$KnownPractice$Shared$Provider,
			$author$project$Api$Provider$Patient$One$knownPractice(patient_));
	} else {
		var patient_ = patient.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$KnownPractice$Shared$Employer,
			$author$project$Api$Employer$Patient$One$knownPractice(patient_));
	}
};
var $author$project$Api$Employer$Patient$Shared$lastName = function (_v0) {
	var shared = _v0;
	return shared.VH;
};
var $author$project$Api$Employer$Patient$One$lastName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Patient$Shared$lastName(shared);
};
var $author$project$Api$Provider$Patient$Shared$lastName = function (_v0) {
	var shared = _v0;
	return shared.VH;
};
var $author$project$Api$Provider$Patient$One$lastName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$lastName(shared);
};
var $author$project$Api$Patient$One$lastName = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$lastName(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$lastName(patient_);
	}
};
var $author$project$Api$LeadSource$Shared$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$LeadSource$Shared$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$Patient$One$leadSource = function (_v0) {
	var record = _v0.b;
	return record.VR;
};
var $author$project$Api$Provider$Patient$One$leadSource = function (_v0) {
	var record = _v0.b;
	return record.VR;
};
var $author$project$Api$Patient$One$leadSource = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$LeadSource$Shared$Provider,
			$author$project$Api$Provider$Patient$One$leadSource(patient_));
	} else {
		var patient_ = patient.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$LeadSource$Shared$Employer,
			$author$project$Api$Employer$Patient$One$leadSource(patient_));
	}
};
var $author$project$Api$Employer$Patient$Shared$leadSourceOther = function (_v0) {
	var shared = _v0;
	return shared.VT;
};
var $author$project$Api$Employer$Patient$One$leadSourceOther = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Patient$Shared$leadSourceOther(shared);
};
var $author$project$Api$Provider$Patient$Shared$leadSourceOther = function (_v0) {
	var shared = _v0;
	return shared.VT;
};
var $author$project$Api$Provider$Patient$One$leadSourceOther = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$leadSourceOther(shared);
};
var $author$project$Api$Patient$One$leadSourceOther = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$leadSourceOther(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$leadSourceOther(patient_);
	}
};
var $author$project$Api$Employer$Patient$One$location = function (_v0) {
	var record = _v0.b;
	return record.ais;
};
var $author$project$Api$Patient$One$location = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Location$Shared$Provider,
			$author$project$Api$Provider$Patient$One$location(patient_));
	} else {
		var patient_ = patient.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Location$Shared$Employer,
			$author$project$Api$Employer$Patient$One$location(patient_));
	}
};
var $author$project$Api$Employer$Patient$Shared$middleName = function (_v0) {
	var shared = _v0;
	return shared.W7;
};
var $author$project$Api$Employer$Patient$One$middleName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Patient$Shared$middleName(shared);
};
var $author$project$Api$Provider$Patient$Shared$middleName = function (_v0) {
	var shared = _v0;
	return shared.W7;
};
var $author$project$Api$Provider$Patient$One$middleName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$middleName(shared);
};
var $author$project$Api$Patient$One$middleName = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$middleName(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$middleName(patient_);
	}
};
var $author$project$Api$Employer$Patient$One$phones = function (_v0) {
	var record = _v0.b;
	return record.Zy;
};
var $author$project$Api$Provider$Patient$One$phones = function (_v0) {
	var record = _v0.b;
	return record.Zy;
};
var $author$project$Api$Patient$One$phones = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$phones(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$phones(patient_);
	}
};
var $author$project$Api$Employer$Patient$One$practitioner = function (_v0) {
	var record = _v0.b;
	return record.aka;
};
var $author$project$Api$Patient$One$practitioner = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Practitioner$Shared$Provider,
			$author$project$Api$Provider$Patient$One$practitioner(patient_));
	} else {
		var patient_ = patient.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Practitioner$Shared$Employer,
			$author$project$Api$Employer$Patient$One$practitioner(patient_));
	}
};
var $author$project$Api$Employer$Patient$One$preferredLanguage = function (_v0) {
	var record = _v0.b;
	return record.Z9;
};
var $author$project$Api$Provider$Patient$One$preferredLanguage = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$One$record_,
	function ($) {
		return $.Z9;
	});
var $author$project$Api$Patient$One$preferredLanguage = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$preferredLanguage(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$preferredLanguage(patient_);
	}
};
var $author$project$Api$Employer$Patient$One$profilePictureUrl = function (_v0) {
	var record = _v0.b;
	return record._A;
};
var $author$project$Api$Provider$Patient$One$profilePictureUrl = function (_v0) {
	var record = _v0.b;
	return record._A;
};
var $author$project$Api$Patient$One$profilePictureUrl = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$profilePictureUrl(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$profilePictureUrl(patient_);
	}
};
var $author$project$Api$Employer$Patient$Shared$pronoun = function (_v0) {
	var shared = _v0;
	return shared._B;
};
var $author$project$Api$Employer$Patient$One$pronoun = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Patient$Shared$pronoun(shared);
};
var $author$project$Api$Provider$Patient$Shared$pronoun = function (_v0) {
	var shared = _v0;
	return shared._B;
};
var $author$project$Api$Provider$Patient$One$pronoun = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$pronoun(shared);
};
var $author$project$Api$Patient$One$pronoun = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$pronoun(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$pronoun(patient_);
	}
};
var $author$project$Api$Employer$Patient$Shared$sex = function (_v0) {
	var shared = _v0;
	return shared.aa8;
};
var $author$project$Api$Employer$Patient$One$sex = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Patient$Shared$sex(shared);
};
var $author$project$Api$Provider$Patient$Shared$sex = function (_v0) {
	var shared = _v0;
	return shared.aa8;
};
var $author$project$Api$Provider$Patient$One$sex = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$sex(shared);
};
var $author$project$Api$Patient$One$sex = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$sex(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$sex(patient_);
	}
};
var $author$project$Api$Employer$Patient$One$suffix = function (_v0) {
	var record = _v0.b;
	return record.acE;
};
var $author$project$Api$Provider$Patient$One$suffix = function (_v0) {
	var record = _v0.b;
	return record.acE;
};
var $author$project$Api$Patient$One$suffix = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$suffix(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$suffix(patient_);
	}
};
var $author$project$Api$Employer$Patient$Shared$syncToEmr = function (_v0) {
	var shared = _v0;
	return shared.acM;
};
var $author$project$Api$Employer$Patient$One$syncToEmr = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Patient$Shared$syncToEmr(shared);
};
var $author$project$Api$Provider$Patient$Shared$syncToEmr = function (_v0) {
	var shared = _v0;
	return shared.acM;
};
var $author$project$Api$Provider$Patient$One$syncToEmr = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$syncToEmr(shared);
};
var $author$project$Api$Patient$One$syncToEmr = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$syncToEmr(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$syncToEmr(patient_);
	}
};
var $author$project$Api$Employer$Patient$One$title = function (_v0) {
	var record = _v0.b;
	return record.ac9;
};
var $author$project$Api$Provider$Patient$One$title = function (_v0) {
	var record = _v0.b;
	return record.ac9;
};
var $author$project$Api$Patient$One$title = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$title(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$title(patient_);
	}
};
var $author$project$Api$Employer$Patient$One$usesBillingAddress = function (_v0) {
	var record = _v0.b;
	return record.ad3;
};
var $author$project$Api$Provider$Patient$One$usesBillingAddress = function (_v0) {
	var record = _v0.b;
	return record.ad3;
};
var $author$project$Api$Patient$One$usesBillingAddress = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$usesBillingAddress(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$usesBillingAddress(patient_);
	}
};
var $author$project$Api$Employer$Patient$Shared$usesTobacco = function (_v0) {
	var shared = _v0;
	return shared.ad9;
};
var $author$project$Api$Employer$Patient$One$usesTobacco = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Patient$Shared$usesTobacco(shared);
};
var $author$project$Api$Provider$Patient$Shared$usesTobacco = function (_v0) {
	var shared = _v0;
	return shared.ad9;
};
var $author$project$Api$Provider$Patient$One$usesTobacco = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$usesTobacco(shared);
};
var $author$project$Api$Patient$One$usesTobacco = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$usesTobacco(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$usesTobacco(patient_);
	}
};
var $author$project$Components$Patient$Form$fill = F8(
	function (apiClient, session, currentDate, company, isEmployeeForm, patient, meta, settingsMapper) {
		var settings = function () {
			var defaultSettings_ = A3($author$project$Components$Patient$Form$defaultSettings, currentDate, false, isEmployeeForm);
			return settingsMapper(
				_Utils_update(
					defaultSettings_,
					{
						W4: $elm$core$Maybe$Just(meta)
					}));
		}();
		var practitionerOptionals = function () {
			var locationId = (settings.Tb && settings.adt) ? A2(
				$elm$core$Maybe$map,
				$author$project$Api$Location$Shared$id,
				$author$project$Api$Patient$One$location(patient)) : $elm$core$Maybe$Nothing;
			var affiliateId = settings.acI ? A2(
				$elm$core$Maybe$map,
				$author$project$Api$Affiliate$AffiliateMin$id,
				$author$project$Api$Patient$One$assignedAffiliation(patient)) : $elm$core$Maybe$Nothing;
			return A5(
				$author$project$Components$Patient$Form$practitionerSignupOptionalsWithExtras,
				isEmployeeForm,
				company,
				locationId,
				affiliateId,
				_List_fromArray(
					[1]));
		}();
		var phones = A2(
			$elm$core$List$map,
			$author$project$Utils$Phone$fromApi,
			$author$project$Api$Patient$One$phones(patient));
		var phonesInput = A3(
			$author$project$Components$PhoneInput$init,
			'patient-phones',
			phones,
			function (d) {
				return _Utils_update(
					d,
					{Gh: true});
			});
		var optionals = function () {
			var practitionerId = settings.Th ? A2(
				$elm$core$Maybe$map,
				$author$project$Api$Practitioner$Shared$id,
				$author$project$Api$Patient$One$practitioner(patient)) : $elm$core$Maybe$Nothing;
			var affiliateId = settings.acI ? A2(
				$elm$core$Maybe$map,
				$author$project$Api$Affiliate$AffiliateMin$id,
				$author$project$Api$Patient$One$assignedAffiliation(patient)) : $elm$core$Maybe$Nothing;
			return A4($author$project$Components$Patient$Form$locationOptionals, isEmployeeForm, company, practitionerId, affiliateId);
		}();
		var legalNameFields = {
			Sv: $author$project$Api$Patient$One$firstName(patient),
			VH: A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Api$Patient$One$lastName(patient)),
			W7: A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Api$Patient$One$middleName(patient)),
			acE: $author$project$Api$Patient$One$suffix(patient),
			ac9: A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Api$Patient$One$title(patient))
		};
		var currentProfilePictureUrl = $author$project$Api$Patient$One$profilePictureUrl(patient);
		var chosenNameFields = $author$project$Components$Patient$Form$chosenNamePresent(patient) ? $elm$core$Maybe$Just(
			$author$project$Components$NameInput$init(
				{
					Sv: A2(
						$elm$core$Maybe$withDefault,
						'',
						$author$project$Api$Patient$One$chosenFirstName(patient)),
					VH: A2(
						$elm$core$Maybe$withDefault,
						'',
						$author$project$Api$Patient$One$chosenLastName(patient)),
					W7: A2(
						$elm$core$Maybe$withDefault,
						'',
						$author$project$Api$Patient$One$chosenMiddleName(patient)),
					acE: $author$project$Api$Patient$One$chosenSuffix(patient),
					ac9: A2(
						$elm$core$Maybe$withDefault,
						'',
						$author$project$Api$Patient$One$chosenTitle(patient))
				})) : $elm$core$Maybe$Nothing;
		var _v0 = A3(
			$author$project$Components$PractitionerInput$init,
			apiClient,
			practitionerOptionals,
			$author$project$Api$Patient$One$practitioner(patient));
		var practitioner = _v0.a;
		var practitionerCmd = _v0.b;
		var _v1 = A3(
			$author$project$Components$LocationInput$init,
			apiClient,
			optionals,
			$author$project$Api$Patient$One$location(patient));
		var location = _v1.a;
		var locationCmd = _v1.b;
		var _v2 = function () {
			var maybeLeadSourceId = A2(
				$elm$core$Maybe$map,
				$author$project$Api$LeadSource$Shared$id,
				$author$project$Api$Patient$One$leadSource(patient));
			return A3(
				$author$project$Components$LeadSourceInput$init,
				apiClient,
				maybeLeadSourceId,
				$author$project$Api$Patient$One$leadSourceOther(patient));
		}();
		var leadSource = _v2.a;
		var leadSourceCmd = _v2.b;
		var _v3 = function () {
			var _v4 = $author$project$Api$Patient$One$knownPractice(patient);
			if (!_v4.$) {
				var knownPractice_ = _v4.a;
				return A3($author$project$Components$KnownPracticeInput$init, apiClient, session, knownPractice_);
			} else {
				return A2($author$project$Components$KnownPracticeInput$empty, apiClient, session);
			}
		}();
		var knownPractice = _v3.a;
		var knownPracticeCmd = _v3.b;
		var _v5 = function () {
			var _v6 = $author$project$Api$Patient$One$healthInsurance(patient);
			if (!_v6.$) {
				var insurance_ = _v6.a;
				return A3($author$project$Components$HealthInsuranceInput$init, apiClient, session, insurance_);
			} else {
				return A2($author$project$Components$HealthInsuranceInput$empty, apiClient, session);
			}
		}();
		var healthInsurance = _v5.a;
		var healthInsuranceCmd = _v5.b;
		var _v7 = $author$project$Components$DateInput$init;
		var dateInput = _v7.a;
		var dateInputCmd = _v7.b;
		var _v8 = A2(
			$author$project$Components$AddressInput$initFromApi,
			'patient-billing-address',
			$author$project$Api$Patient$One$billingAddress(patient));
		var billingAddress = _v8.a;
		var billingAddressCmd = _v8.b;
		var _v9 = function () {
			var resource = A2(
				$elm$core$Maybe$map,
				$author$project$Components$ResourceFilter$Affiliate$resourceFromAffiliateMin,
				$author$project$Api$Patient$One$assignedAffiliation(patient));
			var practitionerId = settings.Th ? A2(
				$elm$core$Maybe$map,
				$author$project$Api$Practitioner$Shared$id,
				$author$project$Api$Patient$One$practitioner(patient)) : $elm$core$Maybe$Nothing;
			var locationId = (settings.Tb && settings.adt) ? A2(
				$elm$core$Maybe$map,
				$author$project$Api$Location$Shared$id,
				$author$project$Api$Patient$One$location(patient)) : $elm$core$Maybe$Nothing;
			var filteredAffiliateOptionals = A2($author$project$Components$Patient$Form$affiliateOptionals, practitionerId, locationId);
			return A4($author$project$Components$AffiliateInput$initWithResource, apiClient, session, filteredAffiliateOptionals, resource);
		}();
		var affiliate = _v9.a;
		var affiliateCmd = _v9.b;
		var _v10 = A2(
			$author$project$Components$AddressInput$initFromApi,
			'patient-address',
			$author$project$Api$Patient$One$address(patient));
		var address = _v10.a;
		var addressCmd = _v10.b;
		return _Utils_Tuple2(
			A2(
				$author$project$Components$Patient$Form$PatientForm,
				settings,
				$author$project$Utils$Form$init(
					{
						K2: address,
						Gn: affiliate,
						MF: $elm$core$Maybe$Just(billingAddress),
						bU: chosenNameFields,
						rT: currentProfilePictureUrl,
						PF: A2(
							$agustinrhcp$elm_mask$Mask$unMask,
							$author$project$Components$Patient$Form$datePattern,
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
									$author$project$Api$Patient$One$dob(patient)))),
						Rj: $author$project$Api$Patient$One$email(patient),
						Rl: $author$project$Components$EmergencyContactInput$init(
							$author$project$Api$Patient$One$emergencyContact(patient)),
						SR: A2(
							$elm$core$Maybe$andThen,
							$author$project$Api$Gender$fromString,
							$author$project$Api$Patient$One$gender(patient)),
						SS: A2(
							$elm$core$Maybe$andThen,
							$author$project$Api$GenderIdentity$fromString(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									$author$project$Api$Patient$One$genderOther(patient))),
							$author$project$Api$Patient$One$genderIdentity(patient)),
						ST: $author$project$Api$Patient$One$genderOther(patient),
						Tm: healthInsurance,
						j5: _Utils_Tuple2(
							$author$project$Api$Patient$One$joinedPracticeDate(patient),
							dateInput),
						Vy: knownPractice,
						VR: leadSource,
						VU: $author$project$Components$NameInput$init(legalNameFields),
						ais: A2($author$project$Components$LocationInput$require, settings.$G, location),
						Zy: A2($author$project$Components$PhoneInput$require, settings.akW, phonesInput),
						aka: A2($author$project$Components$PractitionerInput$require, settings.$M, practitioner),
						Z9: $author$project$Api$Patient$One$preferredLanguage(patient),
						t5: 0,
						_A: $elm$core$Maybe$Nothing,
						_B: A2(
							$elm$core$Maybe$andThen,
							$author$project$Api$Pronoun$fromString,
							$author$project$Api$Patient$One$pronoun(patient)),
						aa8: A2(
							$elm$core$Maybe$andThen,
							$author$project$Api$Gender$fromString,
							$author$project$Api$Patient$One$sex(patient)),
						ab5: '',
						acM: $author$project$Api$Patient$One$syncToEmr(patient),
						qz: $author$project$Api$Patient$One$usesTobacco(patient),
						ad3: $author$project$Api$Patient$One$usesBillingAddress(patient)
					})),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Address),
						addressCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$BillingAddress),
						billingAddressCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$KnownPractice),
						knownPracticeCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Practitioner),
						practitionerCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Location),
						locationCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$LeadSource),
						leadSourceCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$HealthInsurance),
						healthInsuranceCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$JoinedPractice),
						dateInputCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Affiliate),
						affiliateCmd),
						A3($author$project$Components$Patient$Form$fetchPlainSSN, apiClient, session, patient)
					])));
	});
var $author$project$Api$Employer$Plan$Min$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Plan$Min$id = function (plan) {
	if (!plan.$) {
		var plan_ = plan.a;
		return $author$project$Api$Provider$Plan$Min$id(plan_);
	} else {
		var plan_ = plan.a;
		return $author$project$Api$Employer$Plan$Min$id(plan_);
	}
};
var $author$project$Api$Plan$Min$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Plan$Min$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$CompanyAccount$One$membershipPlan = function (_v0) {
	var record = _v0.b;
	return record.WU;
};
var $author$project$Api$Provider$CompanyAccount$One$membershipPlan = function (_v0) {
	var record = _v0.b;
	return record.WU;
};
var $author$project$Api$CompanyAccount$One$membershipPlan = function (companyAccount) {
	if (!companyAccount.$) {
		var companyAccount_ = companyAccount.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Plan$Min$Provider,
			$author$project$Api$Provider$CompanyAccount$One$membershipPlan(companyAccount_));
	} else {
		var companyAccount_ = companyAccount.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Plan$Min$Employer,
			$author$project$Api$Employer$CompanyAccount$One$membershipPlan(companyAccount_));
	}
};
var $author$project$Components$SponsorPlanInput$fill = F4(
	function (session, company, apiClient, companyAccount) {
		var planId = A2(
			$elm$core$Maybe$map,
			$author$project$Api$Plan$Min$id,
			$author$project$Api$CompanyAccount$One$membershipPlan(companyAccount));
		var _v0 = A4($author$project$Components$SponsorPlanInput$filterInit, session, company, apiClient, planId);
		var filter = _v0.a;
		var filterCmd = _v0.b;
		return _Utils_Tuple2(
			{ep: false, HM: filter, akR: false, aee: $elm$core$Maybe$Nothing},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, filterCmd));
	});
var $author$project$Api$Employer$CompanyRegistration$Shared$type_ = function (_v0) {
	var record = _v0;
	return record.amg;
};
var $author$project$Api$Employer$CompanyRegistration$One$type_ = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$CompanyRegistration$Shared$type_(shared);
};
var $author$project$Api$Provider$CompanyRegistration$Shared$type_ = function (_v0) {
	var record = _v0;
	return record.amg;
};
var $author$project$Api$Provider$CompanyRegistration$One$type_ = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyRegistration$Shared$type_(shared);
};
var $author$project$Api$CompanyRegistration$One$type_ = function (companyRegistration) {
	if (!companyRegistration.$) {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Provider$CompanyRegistration$One$type_(companyRegistration_);
	} else {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Employer$CompanyRegistration$One$type_(companyRegistration_);
	}
};
var $author$project$Components$Employee$Form$fill = function (session) {
	return function (company) {
		return function (apiClient) {
			return function (currentDate) {
				return function (companyAccount) {
					return function (companyRegistration) {
						return function (patient) {
							return function (meta) {
								return function (employeeMapper) {
									return function (patientMapper) {
										var isNew = false;
										var employeeSettings = employeeMapper($author$project$Components$Employee$Form$defaultEmployeeSettings);
										var division = $author$project$Api$CompanyAccount$One$division(companyAccount);
										var divisionId = A2($elm$core$Maybe$map, $author$project$Api$EmployeeDivision$All$id, division);
										var _v0 = A3(
											$author$project$Components$EmployeeDependentTypeInput$fill,
											session,
											company,
											$author$project$Api$CompanyRegistration$One$type_(companyRegistration));
										var typeInput = _v0.a;
										var typeInputCmd = _v0.b;
										var _v1 = $author$project$Components$DateInput$init;
										var startDateInput = _v1.a;
										var startDateInputCmd = _v1.b;
										var _v2 = A2(
											$elm$core$Tuple$mapFirst,
											$author$project$Components$SponsorPlanInput$require(true),
											A4($author$project$Components$SponsorPlanInput$fill, session, company, apiClient, companyAccount));
										var sponsorPlan = _v2.a;
										var sponsorPlanCmd = _v2.b;
										var _v3 = A8(
											$author$project$Components$Patient$Form$fill,
											apiClient,
											session,
											currentDate,
											$elm$core$Maybe$Just(company),
											true,
											patient,
											meta,
											patientMapper);
										var patientForm = _v3.a;
										var patientFormCmd = _v3.b;
										var _v4 = A4(
											$author$project$Components$EmployeeDivisionInput$fill,
											session,
											$author$project$Api$Company$id(company),
											apiClient,
											divisionId);
										var divisionInput = _v4.a;
										var divisionInputCmd = _v4.b;
										var form = $author$project$Utils$Form$init(
											{
												QO: A2($author$project$Components$EmployeeDivisionInput$require, employeeSettings.$F, divisionInput),
												dj: _Utils_Tuple2(
													$author$project$Api$CompanyAccount$One$eligibilityStartDate(companyAccount),
													startDateInput),
												Rz: $elm$core$Maybe$Nothing,
												ag7: $author$project$Api$CompanyRegistration$One$externalId(companyRegistration),
												ahP: $elm$core$Maybe$Just(
													$author$project$Api$CompanyRegistration$One$id(companyRegistration)),
												j1: isNew,
												WW: $author$project$Components$Employee$Form$nextFirstOfMonth(currentDate),
												YY: patientForm,
												Jb: A2($author$project$Components$SponsorPlanInput$require, employeeSettings.Ef, sponsorPlan),
												amg: typeInput
											});
										return _Utils_Tuple2(
											A2(
												$author$project$Components$Employee$Form$EmployeeForm,
												A3($author$project$Components$Employee$Form$defaultSettings, currentDate, isNew, employeeSettings),
												form),
											$elm$core$Platform$Cmd$batch(
												_List_fromArray(
													[
														A2($elm$core$Platform$Cmd$map, $author$project$Components$Employee$Form$PatientFormMsg, patientFormCmd),
														A2(
														$elm$core$Platform$Cmd$map,
														A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$Type),
														typeInputCmd),
														A2(
														$elm$core$Platform$Cmd$map,
														A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$Plan),
														sponsorPlanCmd),
														A2(
														$elm$core$Platform$Cmd$map,
														A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$EligibilityDate),
														startDateInputCmd),
														A2(
														$elm$core$Platform$Cmd$map,
														A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$Division),
														divisionInputCmd)
													])));
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$initForm = function (model) {
	var _v0 = model.W4;
	if (_v0.$ === 3) {
		var meta = _v0.a;
		var _v1 = _Utils_Tuple3(model.Ob, model.Oi, model.YY);
		if (((_v1.a.$ === 3) && (_v1.b.$ === 3)) && (_v1.c.$ === 3)) {
			var _v2 = _v1.a;
			var companyAccount = _v2.a;
			var _v3 = _v1.b;
			var companyRegistration = _v3.a;
			var _v4 = _v1.c;
			var patient = _v4.a;
			var _v5 = $author$project$Components$Employee$Form$fill(model.aa4)(model.afQ)(model.Gv)(model.dd)(companyAccount)(companyRegistration)(patient)(meta)(
				function (es) {
					return _Utils_update(
						es,
						{
							$F: $author$project$Api$Company$requiresEmployeeDivisions(model.afQ),
							ad6: $author$project$Api$Company$usesEmployeeDivisions(model.afQ)
						});
				})(
				function (ps) {
					return _Utils_update(
						ps,
						{
							afg: $author$project$Api$Practice$labelBillingAsShipping(model.ZV),
							afn: A2($author$project$Api$Practice$featureEnabled, 3, model.ZV),
							Tb: $author$project$Api$Practice$hasPractitioners(model.ZV),
							Th: $author$project$Api$Practice$hasPractitioners(model.ZV),
							Ee: true,
							akV: $author$project$Api$Practice$requiresPatientEmail(model.ZV),
							$G: $author$project$Api$Practice$requiresLocation(model.ZV),
							akW: $author$project$Api$Practice$requiresPatientMobile(model.ZV),
							$M: $author$project$Api$Practice$requiresPractitioner(model.ZV),
							$N: $author$project$Api$Practice$requiresSSN(model.ZV),
							ab6: $author$project$Api$Practice$ssnEnabled(model.ZV),
							acI: A2(
								$elm$core$Maybe$withDefault,
								false,
								A2(
									$elm$core$Maybe$map,
									$author$project$Api$Network$Shared$syncByAffiliation,
									$author$project$Api$Practice$network(model.ZV))),
							al8: A2($author$project$Api$Practice$featureEnabled, 2, model.ZV),
							adt: $author$project$Api$Practice$trackPatientsByLocation(model.ZV),
							adv: $author$project$Api$Practice$transInclusivity(model.ZV),
							F1: A3($author$project$Permission$canGoTo, model.aa4, model.ahK, 0)
						});
				});
			var form = _v5.a;
			var formCmd = _v5.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						aK: $elm$core$Maybe$Just(form)
					}),
				A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$FormMsg, formCmd));
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	} else {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	}
};
var $author$project$Api$Employer$Patient$Min$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Patient$Min$name = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$Min$name(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$Min$name(patient_);
	}
};
var $author$project$Api$Patient$One$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Patient$One$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$Patient$One$Patient = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Employer$Patient$One$Record = function (chosenTitle) {
	return function (chosenFirstName) {
		return function (chosenMiddleName) {
			return function (chosenLastName) {
				return function (chosenSuffix) {
					return function (title) {
						return function (suffix) {
							return function (usesBillingAddress) {
								return function (address) {
									return function (billingAddress) {
										return function (phones) {
											return function (location) {
												return function (practitioner) {
													return function (preferredLanguage) {
														return function (leadSource) {
															return function (healthInsurance) {
																return function (knownPractice) {
																	return function (assignedAffiliation) {
																		return function (profilePictureUrl) {
																			return function (emergencyContact) {
																				return {K2: address, L0: assignedAffiliation, MF: billingAddress, ND: chosenFirstName, NE: chosenLastName, NF: chosenMiddleName, NG: chosenSuffix, NH: chosenTitle, Rl: emergencyContact, Tm: healthInsurance, Vy: knownPractice, VR: leadSource, ais: location, Zy: phones, aka: practitioner, Z9: preferredLanguage, _A: profilePictureUrl, acE: suffix, ac9: title, ad3: usesBillingAddress};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Employer$Affiliate$AffiliateMin$Affiliate = $elm$core$Basics$identity;
var $author$project$Api$Employer$Affiliate$AffiliateMin$Record = F2(
	function (id, name) {
		return {ahP: id, Bq: name};
	});
var $author$project$Api$Employer$Affiliate$AffiliateMin$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$Affiliate$AffiliateMin$Record)));
var $author$project$Api$Employer$Affiliate$AffiliateMin$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Affiliate$AffiliateMin$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$HealthInsurance$Shared$HealthInsurance = $elm$core$Basics$identity;
var $author$project$Api$Employer$HealthInsurance$Shared$Record = F5(
	function (memberId, groupId, payerName, highDeductible, carrier) {
		return {Np: carrier, S$: groupId, Tt: highDeductible, WL: memberId, Y5: payerName};
	});
var $author$project$Api$Employer$HealthInsurance$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'carrier',
	$elm$json$Json$Decode$nullable($author$project$Api$Employer$HealthInsuranceCarrier$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'high_deductible',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'payer_name',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'group_id',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'member_id',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					$elm$json$Json$Decode$succeed($author$project$Api$Employer$HealthInsurance$Shared$Record))))));
var $author$project$Api$Employer$HealthInsurance$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$HealthInsurance$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$LeadSource$Shared$LeadSource = $elm$core$Basics$identity;
var $author$project$Api$Employer$LeadSource$Shared$Record = function (id) {
	return {ahP: id};
};
var $author$project$Api$Employer$LeadSource$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'id',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Employer$LeadSource$Shared$Record));
var $author$project$Api$Employer$LeadSource$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$LeadSource$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Location$Shared$Location = $elm$core$Basics$identity;
var $author$project$Api$Employer$Location$Shared$Record = F3(
	function (id, name, affiliation) {
		return {Li: affiliation, ahP: id, Bq: name};
	});
var $author$project$Api$Employer$Location$Shared$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'affiliation',
	$elm$json$Json$Decode$nullable($author$project$Api$Employer$Affiliate$AffiliateMin$decoder),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Employer$Location$Shared$Record))));
var $author$project$Api$Employer$Location$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Location$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Practitioner$Shared$Practitioner = $elm$core$Basics$identity;
var $author$project$Api$Employer$Practitioner$Shared$Record = F6(
	function (id, name, isMaster, isSynced, openingsSize, affiliation) {
		return {Li: affiliation, ahP: id, UV: isMaster, Vf: isSynced, Bq: name, Yp: openingsSize};
	});
var $author$project$Api$Employer$Practitioner$Shared$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'affiliation',
	$elm$json$Json$Decode$nullable($author$project$Api$Employer$Affiliate$AffiliateMin$decoder),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'openings_size',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'is_synced',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'is_master',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'name',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Api$Employer$Practitioner$Shared$Record)))))));
var $author$project$Api$Employer$Practitioner$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Practitioner$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Patient$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'emergency_contact',
	$elm$json$Json$Decode$nullable($author$project$Api$Common$EmergencyContact$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'profile_picture_url',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'assigned_affiliation',
			$elm$json$Json$Decode$nullable($author$project$Api$Employer$Affiliate$AffiliateMin$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'known_practice',
				$elm$json$Json$Decode$nullable($author$project$Api$Employer$KnownPractice$Shared$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'health_insurance',
					$elm$json$Json$Decode$nullable($author$project$Api$Employer$HealthInsurance$Shared$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'lead_source',
						$elm$json$Json$Decode$nullable($author$project$Api$Employer$LeadSource$Shared$decoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'preferred_language',
							$author$project$Language$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'practitioner',
								$elm$json$Json$Decode$nullable($author$project$Api$Employer$Practitioner$Shared$decoder),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'location',
									$elm$json$Json$Decode$nullable($author$project$Api$Employer$Location$Shared$decoder),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'phones',
										$elm$json$Json$Decode$list($author$project$Api$Common$Phone$Shared$decoder),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'billing_address',
											$elm$json$Json$Decode$nullable($author$project$Api$Common$Address$Shared$decoder),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'address',
												$elm$json$Json$Decode$nullable($author$project$Api$Common$Address$Shared$decoder),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'uses_billing_address',
													$elm$json$Json$Decode$bool,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'suffix',
														$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'title',
															$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'chosen_suffix',
																$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'chosen_last_name',
																	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'chosen_middle_name',
																		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'chosen_first_name',
																			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'chosen_title',
																				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																				$elm$json$Json$Decode$succeed($author$project$Api$Employer$Patient$One$Record)))))))))))))))))))));
var $author$project$Api$Employer$Patient$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Patient$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Employer$Patient$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$Patient$One$Patient)));
var $author$project$Api$Employer$Patient$patientsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['patients']),
	$author$project$Api$Data$employerPath);
var $author$project$Api$Employer$Patient$patientPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Employer$Patient$patientsPath);
};
var $author$project$Api$Employer$Patient$retrieve = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Employer$Patient$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Employer$Patient$patientPath(id_)));
	});
var $author$project$Api$Patient$retrieve = F4(
	function (apiClient, session, id, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$Patient$retrieve,
			apiClient,
			id,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Patient$One$Employer))) : A3(
			$author$project$Api$Provider$Patient$retrieve,
			apiClient,
			id,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Patient$One$Provider)));
	});
var $author$project$Api$Patient$Meta$Meta = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Patient$Meta$MetaActions = function (archive) {
	return {LZ: archive};
};
var $author$project$Utils$MetaFields$decodeActionable = $elm$json$Json$Decode$bool;
var $author$project$Api$Patient$Meta$decodeMetaActions = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
	_List_fromArray(
		['actions', 'archive']),
	$author$project$Utils$MetaFields$decodeActionable,
	$elm$json$Json$Decode$succeed($author$project$Api$Patient$Meta$MetaActions));
var $author$project$Api$Patient$Meta$MetaFields = function (firstName) {
	return function (chosenFirstName) {
		return function (dob) {
			return function (gender) {
				return function (sex) {
					return function (genderIdentity) {
						return function (pronouns) {
							return function (usesTobacco) {
								return function (practitionerId) {
									return function (locationId) {
										return function (joinedPracticeDate) {
											return function (healthInsuranceCarrier) {
												return function (leadSourceId) {
													return {ND: chosenFirstName, agC: dob, Sv: firstName, SR: gender, SS: genderIdentity, Tn: healthInsuranceCarrier, Vw: joinedPracticeDate, VS: leadSourceId, We: locationId, Z2: practitionerId, _C: pronouns, aa8: sex, ad9: usesTobacco};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Patient$Meta$decodeMetaFields = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'lead_source_id',
	$author$project$Utils$MetaFields$decodeEditable,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'health_insurance_carrier',
		$author$project$Utils$MetaFields$decodeEditable,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'joined_practice_date',
			$author$project$Utils$MetaFields$decodeEditable,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'location_id',
				$author$project$Utils$MetaFields$decodeEditable,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'practitioner_id',
					$author$project$Utils$MetaFields$decodeEditable,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'uses_tobacco',
						$author$project$Utils$MetaFields$decodeEditable,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'pronouns',
							$author$project$Utils$MetaFields$decodeEditable,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'gender_identity',
								$author$project$Utils$MetaFields$decodeEditable,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'sex',
									$author$project$Utils$MetaFields$decodeEditable,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'gender',
										$author$project$Utils$MetaFields$decodeEditable,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'dob',
											$author$project$Utils$MetaFields$decodeEditable,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'chosen_first_name',
												$author$project$Utils$MetaFields$decodeEditable,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'first_name',
													$author$project$Utils$MetaFields$decodeEditable,
													$elm$json$Json$Decode$succeed($author$project$Api$Patient$Meta$MetaFields))))))))))))));
var $author$project$Api$Patient$Meta$decode = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Patient$Meta$decodeMetaActions,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Patient$Meta$decodeMetaFields,
		$elm$json$Json$Decode$succeed($author$project$Api$Patient$Meta$Meta)));
var $author$project$Api$Employer$Patient$Meta$metaPath = function (patientId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['meta']),
		$author$project$Api$Employer$Patient$patientPath(patientId));
};
var $author$project$Api$Provider$Patient$Meta$metaPath = function (patientId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['meta']),
		$author$project$Api$Provider$Patient$patientPath(patientId));
};
var $author$project$Api$Patient$Meta$retrieve = F4(
	function (apiClient, session, id, toMsg) {
		var metaPath = $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $author$project$Api$Employer$Patient$Meta$metaPath : $author$project$Api$Provider$Patient$Meta$metaPath;
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Patient$Meta$decode,
			toMsg,
			$author$project$Api$Data$requestTo(
				metaPath(id)));
	});
var $author$project$Api$Employer$CompanyAccount$update = F4(
	function (apiClient, id, jsonBody, toMsg) {
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Employer$CompanyAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				jsonBody,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Employer$CompanyAccount$companyAccountPath(id))));
	});
var $author$project$Api$Provider$Company$Account$update = F5(
	function (apiClient, basePath, id, jsonBody, toMsg) {
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$CompanyAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				jsonBody,
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Provider$Company$Account$companyAccountPath, basePath, id))));
	});
var $author$project$Api$CompanyAccount$update = F6(
	function (apiClient, session, companyId, id, jsonBody, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4(
			$author$project$Api$Employer$CompanyAccount$update,
			apiClient,
			id,
			jsonBody,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Employer))) : A5(
			$author$project$Api$Provider$Company$Account$update,
			apiClient,
			$author$project$Api$Provider$Company$companyPath(companyId),
			id,
			jsonBody,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Provider)));
	});
var $author$project$Api$Employer$CompanyRegistration$update = F5(
	function (apiClient, accountId, id, jsonBody, toMsg) {
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Employer$CompanyRegistration$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				jsonBody,
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Employer$CompanyRegistration$companyRegistrationPath, accountId, id))));
	});
var $author$project$Api$Provider$Company$Registration$update = F6(
	function (apiClient, companyId, companyAccountId, id, jsonBody, toMsg) {
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$CompanyRegistration$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				jsonBody,
				$author$project$Api$Data$requestTo(
					A3($author$project$Api$Provider$Company$Registration$companyRegistrationPath, companyId, companyAccountId, id))));
	});
var $author$project$Api$CompanyRegistration$update = F7(
	function (apiClient, session, companyId, accountId, id, jsonBody, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A5(
			$author$project$Api$Employer$CompanyRegistration$update,
			apiClient,
			accountId,
			id,
			jsonBody,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyRegistration$One$Employer))) : A6(
			$author$project$Api$Provider$Company$Registration$update,
			apiClient,
			companyId,
			accountId,
			id,
			jsonBody,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyRegistration$One$Provider)));
	});
var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return A2(
					$author$project$Utils$Tuple3$fromTuple2,
					$author$project$OutMsg$handleErrorResponse(response),
					$author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$initForm(
						_Utils_update(
							model,
							{Ob: response})));
			case 1:
				var response = msg.a;
				if (response.$ === 3) {
					var companyRegistration = response.a;
					var patientId = $author$project$Api$Patient$Min$id(
						$author$project$Api$CompanyRegistration$One$patient(companyRegistration));
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Oi: response}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A4($author$project$Api$Patient$retrieve, model.Gv, model.aa4, patientId, $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$GotPatient),
									A4($author$project$Api$Patient$Meta$retrieve, model.Gv, model.aa4, patientId, $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$GotMeta)
								])),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Oi: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 2:
				var response = msg.a;
				return A2(
					$author$project$Utils$Tuple3$fromTuple2,
					$author$project$OutMsg$handleErrorResponse(response),
					$author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$initForm(
						_Utils_update(
							model,
							{YY: response})));
			case 3:
				var response = msg.a;
				return A2(
					$author$project$Utils$Tuple3$fromTuple2,
					$author$project$OutMsg$handleErrorResponse(response),
					$author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$initForm(
						_Utils_update(
							model,
							{W4: response})));
			case 4:
				var subMsg = msg.a;
				var _v2 = model.aK;
				if (!_v2.$) {
					var employeeForm = _v2.a;
					var _v3 = A5(
						$author$project$Components$Employee$Form$update,
						model.Gv,
						model.aa4,
						$elm$core$Maybe$Just(model.afQ),
						subMsg,
						employeeForm);
					var form = _v3.a;
					var formCmd = _v3.b;
					var formOutMsgs = _v3.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aK: $elm$core$Maybe$Just(form)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$FormMsg, formCmd),
						formOutMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				var _v4 = model.aK;
				if (!_v4.$) {
					var employeeForm = _v4.a;
					var _v5 = $author$project$Components$Employee$Form$validate(employeeForm);
					if (!_v5.$) {
						var _v6 = _v5.a;
						var validForm = _v6.a;
						var validFields = _v6.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{lA: true}),
							A7(
								$author$project$Api$CompanyRegistration$update,
								model.Gv,
								model.aa4,
								model.fZ,
								model.Oc,
								model.G_,
								A2($author$project$Components$Employee$Form$encodeRegistration, validFields, validForm),
								$author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$CompanyRegistrationUpdated),
							_List_Nil);
					} else {
						var erroredForm = _v5.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aK: $elm$core$Maybe$Just(erroredForm)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var response = msg.a;
				var _v7 = model.aK;
				if (!_v7.$) {
					var employeeForm = _v7.a;
					var _v8 = _Utils_Tuple2(
						$author$project$Components$Employee$Form$validate(employeeForm),
						response);
					if ((!_v8.a.$) && (_v8.b.$ === 3)) {
						var _v9 = _v8.a.a;
						var validForm = _v9.a;
						var validFields = _v9.b;
						var _v10 = _v8.b;
						var registration = _v10.a;
						var createAffiliationCmd = A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$FormMsg,
							A4($author$project$Components$Employee$Form$createEmployeeAffiliation, model.Gv, model.aa4, registration, employeeForm));
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A6(
										$author$project$Api$CompanyAccount$update,
										model.Gv,
										model.aa4,
										model.fZ,
										model.Oc,
										A2($author$project$Components$Employee$Form$encodeAccount, validFields, validForm),
										$author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$CompanyAccountUpdated(registration)),
										createAffiliationCmd
									])),
							_List_Nil);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{lA: false}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var registration = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var patientName = $author$project$Api$Patient$Min$name(
						$author$project$Api$CompanyRegistration$One$patient(registration));
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Ob: $author$project$Api$Data$Loading, Oi: $author$project$Api$Data$Loading, YY: $author$project$Api$Data$Loading, lA: false}),
						A2(
							$author$project$Utils$Route$navigate,
							$elm$core$Dict$empty,
							$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top(
								{fZ: model.fZ})),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Successfully updated ' + patientName)
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{lA: false}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$FormSubmitted = {$: 5};
var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$noValidate(true),
						$author$project$Ui$Form$autocomplete(false),
						$author$project$Ui$Form$onSubmit($author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$FormSubmitted)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_Nil,
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Link$route,
												$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top(
													{fZ: model.fZ}),
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('All Employees & Dependents')
													])),
												A2(
												$author$project$Ui$Typography$text,
												_List_fromArray(
													[$author$project$Ui$Typography$gray]),
												'  /  Edit Employee')
											])),
										$author$project$Ui$HorizontalRule$view(
										_List_fromArray(
											[$author$project$Ui$HorizontalRule$thin])),
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Edit Employee')
											])),
										function () {
										var _v0 = model.aK;
										if (!_v0.$) {
											var employeeForm = _v0.a;
											return A2(
												$author$project$Ui$Element$view,
												_List_Nil,
												A2(
													$elm$core$List$map,
													$elm$html$Html$map($author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$FormMsg),
													$author$project$Components$Employee$Form$view(employeeForm)));
										} else {
											return A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$itemsCenter]),
												_List_fromArray(
													[
														$author$project$Ui$Spinner$view(_List_Nil)
													]));
										}
									}()
									])),
								A2(
								$author$project$Ui$Panel$footer,
								_List_fromArray(
									[$author$project$Ui$Element$justifyCenter]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top(
											{fZ: model.fZ}),
										_List_fromArray(
											[$author$project$Ui$Link$buttonSecondary]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cancel')
											])),
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Update employee'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$submit,
												$author$project$Ui$Button$loading(model.lA)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Update')
											]))
									]))
							]))
					]))
			]),
		ac9: A2($author$project$Api$Practice$sponsorize, model.ZV, 'Companies') + (' | ' + model.fZ)
	};
};
var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$page = $author$project$Spa$Page$applicationCompanyOrEmployer(
	{ah_: $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$init, aiq: $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$load, k8: $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$save, alO: $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$subscriptions, adT: $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$update, amo: $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$view});
var $author$project$Api$Provider$Report$CompanyRegistrations = 24;
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$FilterDropdownMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$GotCancellationReasons = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$CancellationReason$Employer = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$CancellationReason$Provider = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Employer$CancellationReason$cancellationReasonsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['cancellation_reasons']),
	$author$project$Api$Data$employerPath);
var $author$project$Api$Employer$CancellationReason$All$CancellationReason = $elm$core$Basics$identity;
var $author$project$Api$Employer$CancellationReason$Shared$CancellationReason = $elm$core$Basics$identity;
var $author$project$Api$Employer$CancellationReason$Shared$SharedRecord = F2(
	function (id, description) {
		return {Qr: description, ahP: id};
	});
var $author$project$Api$Employer$CancellationReason$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'description',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$CancellationReason$Shared$SharedRecord)));
var $author$project$Api$Employer$CancellationReason$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$CancellationReason$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$CancellationReason$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$CancellationReason$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$CancellationReason$listDefaults = {ajJ: $author$project$Api$Pagination$init};
var $author$project$Api$Employer$CancellationReason$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Employer$CancellationReason$listDefaults);
	return $author$project$Api$Pagination$toApiParams(options.ajJ);
};
var $author$project$Api$Employer$CancellationReason$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Employer$CancellationReason$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Employer$CancellationReason$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Employer$CancellationReason$cancellationReasonsPath)));
	});
var $author$project$Api$CancellationReason$listDefaults = {ajJ: $author$project$Api$Pagination$init};
var $author$project$Api$CancellationReason$optionalsToEmployer = function (optionals) {
	var options = optionals($author$project$Api$CancellationReason$listDefaults);
	return function (d) {
		return _Utils_update(
			d,
			{ajJ: options.ajJ});
	};
};
var $author$project$Api$CancellationReason$optionalsToProvider = function (optionals) {
	var options = optionals($author$project$Api$CancellationReason$listDefaults);
	return function (d) {
		return _Utils_update(
			d,
			{ajJ: options.ajJ});
	};
};
var $author$project$Api$CancellationReason$list = F4(
	function (apiClient, session, optionals, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$CancellationReason$list,
			apiClient,
			$author$project$Api$CancellationReason$optionalsToEmployer(optionals),
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$CancellationReason$Employer)))) : A3(
			$author$project$Api$Provider$CancellationReason$list,
			apiClient,
			$author$project$Api$CancellationReason$optionalsToProvider(optionals),
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$CancellationReason$Provider))));
	});
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$fetchCancellationReasons = function (model) {
	return A4(
		$author$project$Api$CancellationReason$list,
		model.Gv,
		model.aa4,
		function (d) {
			return _Utils_update(
				d,
				{
					ajJ: A2($author$project$Api$Pagination$withItemsPerPage, 100, model.ajJ)
				});
		},
		$author$project$Pages$Companies$CompanyId_String$Employees$Top$GotCancellationReasons);
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$GotCompanyAccounts = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$CompanyAccount$MembershipPatients = 0;
var $author$project$Api$CompanyAccount$Plan = 2;
var $author$project$Api$CompanyAccount$Registrations = 1;
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$filterToValue = function (filter) {
	switch (filter) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Just('needs_approval');
		case 2:
			return $elm$core$Maybe$Just('denied');
		case 3:
			return $elm$core$Maybe$Just('active_members');
		case 4:
			return $elm$core$Maybe$Just('not_active_members');
		case 5:
			return $elm$core$Maybe$Just('eligible');
		default:
			return $elm$core$Maybe$Just('not_eligible');
	}
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$fetchParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				HE: _List_fromArray(
					[2, 1, 0]),
				HM: $author$project$Pages$Companies$CompanyId_String$Employees$Top$filterToValue(model.HM),
				ajJ: model.ajJ,
				akl: model.akl,
				alA: model.alA
			});
	};
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$fetchCompanyAccounts = function (model) {
	return A5(
		$author$project$Api$CompanyAccount$list,
		model.Gv,
		model.aa4,
		model.ahP,
		$author$project$Pages$Companies$CompanyId_String$Employees$Top$fetchParams(model),
		$author$project$Pages$Companies$CompanyId_String$Employees$Top$GotCompanyAccounts);
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$All = 0;
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$DeniedApproval = 2;
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$Eligible = 5;
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$Enrolled = 3;
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$NeedsApproval = 1;
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$NotEligible = 6;
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$Unenrolled = 4;
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$filterFromQuery = function (queryString) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		A2(
			$elm_community$list_extra$List$Extra$find,
			function (filter) {
				return _Utils_eq(
					$author$project$Pages$Companies$CompanyId_String$Employees$Top$filterToValue(filter),
					queryString);
			},
			_List_fromArray(
				[1, 2, 3, 4, 5, 6])));
};
var $author$project$Components$ExportCsv$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$ExportCsv$initForEmployer = function (resource) {
	return $author$project$Components$ExportCsv$emptyModel(
		$author$project$Components$ExportCsv$Employer(resource));
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$init = F5(
	function (session, practice, company, shared, _v0) {
		var params = _v0.YL;
		var query = _v0.DE;
		var q = A2($elm$core$Dict$get, 'q', query);
		var model = {
			Gv: shared.Gv,
			afq: $author$project$Api$Data$Loading,
			afQ: company,
			Od: $author$project$Api$Data$Loading,
			dd: shared.dd,
			Ql: $elm$core$Maybe$Nothing,
			zq: $elm$core$Maybe$Nothing,
			nD: shared.ajE ? $author$project$Components$ExportCsv$initForEmployer(24) : $author$project$Components$ExportCsv$initForPractice(24),
			HM: $author$project$Pages$Companies$CompanyId_String$Employees$Top$filterFromQuery(
				A2($elm$core$Dict$get, 'filter', query)),
			nK: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'employee-filter-dropdown', al6: $author$project$Pages$Companies$CompanyId_String$Employees$Top$FilterDropdownMsg})),
			ahr: $elm$core$Maybe$Nothing,
			ahP: params.fZ,
			ajE: shared.ajE,
			ajJ: $author$project$Api$Pagination$initFromQuery(query),
			ZV: practice,
			akl: q,
			up: $author$project$Ui$SearchInput$init(q),
			aa4: session,
			alA: $author$project$Api$Sort$initFromQuery(query),
			fl: _List_Nil,
			J7: shared.J7
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Pages$Companies$CompanyId_String$Employees$Top$fetchCompanyAccounts(model),
						$author$project$Pages$Companies$CompanyId_String$Employees$Top$fetchCancellationReasons(model)
					])));
	});
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{ajE: shared.ajE}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$ExportCsvMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$EmployeeRowMsg = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Company$EmployeeRow$DeleteHiConfirmClosed = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Components$Company$EmployeeRow$DependentPlanAgeWarningHiConfirmClosed = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Components$Company$EmployeeRow$EnrollmentModalMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Employee$EnrollmentModal$Close = {$: 1};
var $author$project$Components$Employee$EnrollmentModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Employee$EnrollmentModal$Close);
};
var $author$project$Components$Company$EmployeeRow$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$Dropdown$subscriptions(model.gi),
				function () {
				var _v0 = model.go;
				if (!_v0.$) {
					var enrollmentModal = _v0.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Components$Company$EmployeeRow$EnrollmentModalMsg,
						$author$project$Components$Employee$EnrollmentModal$subscriptions(enrollmentModal));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Company$EmployeeRow$DeleteHiConfirmClosed),
					model.i9)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Company$EmployeeRow$DependentPlanAgeWarningHiConfirmClosed),
					model.jj))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$tableRowSubscriptions = function (tableRows) {
	return A2(
		$elm$core$List$map,
		function (_v0) {
			var id = _v0.a;
			var row = _v0.b;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Companies$CompanyId_String$Employees$Top$EmployeeRowMsg(id),
				$author$project$Components$Company$EmployeeRow$subscriptions(row));
		},
		tableRows);
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$elm$core$Platform$Sub$batch(
				$author$project$Pages$Companies$CompanyId_String$Employees$Top$tableRowSubscriptions(model.fl)),
				$author$project$Ui$Dropdown$subscriptions(model.nK),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Companies$CompanyId_String$Employees$Top$ExportCsvMsg,
				$author$project$Components$ExportCsv$subscriptions(model.nD))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$SearchInputMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$findTableRow = F2(
	function (tableRows, companyRegistrationId) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (_v0) {
					var id = _v0.a;
					return _Utils_eq(id, companyRegistrationId);
				},
				tableRows));
	});
var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$CompanyRegistration$Shared$id(shared);
};
var $author$project$Api$CompanyRegistration$ForCompanyAccountAll$id = function (companyRegistration) {
	if (!companyRegistration.$) {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$id(companyRegistration_);
	} else {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$id(companyRegistration_);
	}
};
var $author$project$Components$Company$EmployeeRow$DropdownMenuMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Dropdown$DownLeft = 2;
var $author$project$Ui$Dropdown$toDownLeft = function (config) {
	return _Utils_update(
		config,
		{bv: 2});
};
var $author$project$Components$Company$EmployeeRow$init = F8(
	function (practice, session, company, currentDate, timeFormatter, cancellationReasons, companyAccount, registration) {
		return {
			afq: cancellationReasons,
			afQ: company,
			Ob: companyAccount,
			Oi: registration,
			dd: currentDate,
			i9: $elm$core$Maybe$Nothing,
			jj: $elm$core$Maybe$Nothing,
			gi: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$toDownLeft(
					$author$project$Ui$Dropdown$defaultConfig(
						{
							ahP: 'employee-actions-dropdown-' + $author$project$Api$CompanyRegistration$ForCompanyAccountAll$id(registration),
							al6: $author$project$Components$Company$EmployeeRow$DropdownMenuMsg
						}))),
			go: $elm$core$Maybe$Nothing,
			ZV: practice,
			k9: $author$project$Api$Data$NotAsked,
			aa4: session,
			J7: timeFormatter,
			h1: $elm$core$Maybe$Nothing,
			adK: $elm$core$Maybe$Nothing
		};
	});
var $author$project$Api$CompanyRegistration$ForCompanyAccountAll$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$CompanyRegistration$ForCompanyAccountAll$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$CompanyAccount$All$registrations = function (_v0) {
	var record = _v0.b;
	return record.akF;
};
var $author$project$Api$CompanyAccount$All$registrations = function (companyAccount) {
	if (!companyAccount.$) {
		var companyAccount_ = companyAccount.a;
		return A2(
			$elm$core$List$map,
			$author$project$Api$CompanyRegistration$ForCompanyAccountAll$Provider,
			$author$project$Api$Provider$CompanyAccount$All$registrations(companyAccount_));
	} else {
		var companyAccount_ = companyAccount.a;
		return A2(
			$elm$core$List$map,
			$author$project$Api$CompanyRegistration$ForCompanyAccountAll$Employer,
			$author$project$Api$Employer$CompanyAccount$All$registrations(companyAccount_));
	}
};
var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$type_ = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$CompanyRegistration$Shared$type_(shared);
};
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$type_ = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyRegistration$Shared$type_(shared);
};
var $author$project$Api$CompanyRegistration$ForCompanyAccountAll$type_ = function (companyRegistration) {
	if (!companyRegistration.$) {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$type_(companyRegistration_);
	} else {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$type_(companyRegistration_);
	}
};
var $author$project$Components$Company$EmployeeRow$AccountOrRegistrationUpdated = 1;
var $author$project$Components$Employee$EnrollmentModal$Approve = 1;
var $author$project$Components$Company$EmployeeRow$CompanyAccountOrRegistrationRemoved = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Company$EmployeeRow$DependentEnrolled = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Company$EmployeeRow$EmployeeDenied = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Employee$EnrollmentModal$Enroll = 0;
var $author$project$Components$Company$EmployeeRow$GotCompanyAccount = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Company$EmployeeRow$GotCompanyRegistration = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$Company$EmployeeRow$None = 0;
var $author$project$Components$Company$EmployeeRow$UnenrollModalMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Api$CompanyAccount$companyAccountPath = F3(
	function (session, companyId, accountId) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[accountId]),
			A2(
				$author$project$Api$Data$pathAppend,
				_List_fromArray(
					['accounts']),
				A2($author$project$Api$Company$companyPath, session, companyId)));
	});
var $author$project$Api$Employer$CompanyAccount$delete = F3(
	function (apiClient, basePath, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(basePath));
	});
var $author$project$Api$Provider$Company$Account$delete = F4(
	function (apiClient, companyId, accountId, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Provider$Company$Account$companyAccountPath,
					$author$project$Api$Provider$Company$companyPath(companyId),
					accountId)));
	});
var $author$project$Api$CompanyAccount$delete = F4(
	function (apiClient, session, _v0, toMsg) {
		var companyId = _v0.fZ;
		var accountId = _v0.fv;
		if ($author$project$Api$Platform$Session$One$organizationIsCompany(session)) {
			var basePath = A3($author$project$Api$CompanyAccount$companyAccountPath, session, companyId, accountId);
			return A3($author$project$Api$Employer$CompanyAccount$delete, apiClient, basePath, toMsg);
		} else {
			return A4($author$project$Api$Provider$Company$Account$delete, apiClient, companyId, accountId, toMsg);
		}
	});
var $author$project$Api$Employer$CompanyRegistration$delete = F4(
	function (apiClient, accountId, registrationId, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Employer$CompanyRegistration$companyRegistrationPath, accountId, registrationId)));
	});
var $author$project$Api$Provider$Company$Registration$delete = F5(
	function (apiClient, companyId, companyAccountId, registrationId, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A3($author$project$Api$Provider$Company$Registration$companyRegistrationPath, companyId, companyAccountId, registrationId)));
	});
var $author$project$Api$CompanyRegistration$delete = F4(
	function (apiClient, session, _v0, toMsg) {
		var companyId = _v0.fZ;
		var accountId = _v0.fv;
		var registrationId = _v0.pA;
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4($author$project$Api$Employer$CompanyRegistration$delete, apiClient, accountId, registrationId, toMsg) : A5($author$project$Api$Provider$Company$Registration$delete, apiClient, companyId, accountId, registrationId, toMsg);
	});
var $author$project$Api$Employer$CompanyAccount$deny = F3(
	function (apiClient, basePath, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Employer$CompanyAccount$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['deny']),
					basePath)));
	});
var $author$project$Api$Provider$Company$Account$deny = F3(
	function (apiClient, basePath, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CompanyAccount$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['deny']),
					basePath)));
	});
var $author$project$Api$CompanyAccount$deny = F4(
	function (apiClient, session, _v0, toMsg) {
		var companyId = _v0.fZ;
		var accountId = _v0.fv;
		var basePath = A3($author$project$Api$CompanyAccount$companyAccountPath, session, companyId, accountId);
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$CompanyAccount$deny,
			apiClient,
			basePath,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Employer))) : A3(
			$author$project$Api$Provider$Company$Account$deny,
			apiClient,
			basePath,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Provider)));
	});
var $author$project$Components$Company$UnenrollModal$EndDateInputMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Employer$CompanyAccount$Meta$defaultValue = function (_v0) {
	var meta = _v0;
	return meta.kk.sb.Qf;
};
var $author$project$Api$Provider$CompanyAccount$Meta$defaultValue = function (_v0) {
	var meta = _v0;
	return meta.kk.sb.Qf;
};
var $author$project$Api$CompanyAccount$Meta$defaultValue = function (meta) {
	if (!meta.$) {
		var meta_ = meta.a;
		return $author$project$Api$Provider$CompanyAccount$Meta$defaultValue(meta_);
	} else {
		var meta_ = meta.a;
		return $author$project$Api$Employer$CompanyAccount$Meta$defaultValue(meta_);
	}
};
var $author$project$Components$Company$UnenrollModal$initFormFields = function (companyAccount) {
	return {
		afo: $elm$core$Maybe$Nothing,
		afp: $elm$core$Maybe$Nothing,
		akO: $author$project$Api$CompanyAccount$Meta$defaultValue(companyAccount)
	};
};
var $author$project$Api$CompanyAccount$Meta$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$CompanyAccount$Meta$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$CompanyAccount$All$meta = function (_v0) {
	var record = _v0.b;
	return record.W4;
};
var $author$project$Api$Provider$CompanyAccount$All$meta = function (_v0) {
	var record = _v0.b;
	return record.W4;
};
var $author$project$Api$CompanyAccount$All$meta = function (companyAccount) {
	if (!companyAccount.$) {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$CompanyAccount$Meta$Provider(
			$author$project$Api$Provider$CompanyAccount$All$meta(companyAccount_));
	} else {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$CompanyAccount$Meta$Employer(
			$author$project$Api$Employer$CompanyAccount$All$meta(companyAccount_));
	}
};
var $author$project$Components$Company$UnenrollModal$init = F6(
	function (session, _v0, companyAccount, registration, currentDate, minDate) {
		var companyId = _v0.fZ;
		var accountId = _v0.fv;
		var registrationId = _v0.pA;
		var accountMeta = $author$project$Api$CompanyAccount$All$meta(companyAccount);
		var fields = $author$project$Components$Company$UnenrollModal$initFormFields(accountMeta);
		var _v1 = $author$project$Components$DateInput$init;
		var endDateInput = _v1.a;
		var endDateInputCmd = _v1.b;
		return _Utils_Tuple2(
			{
				fv: accountId,
				Ob: companyAccount,
				fZ: companyId,
				Oi: registration,
				dd: currentDate,
				sd: endDateInput,
				SD: $author$project$Utils$Form$init(fields),
				Bh: minDate,
				pA: registrationId,
				aa4: session
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$UnenrollModal$EndDateInputMsg, endDateInputCmd));
	});
var $author$project$Components$Employee$EnrollmentModal$GotCompanyAccount = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Employee$EnrollmentModal$GotCompanyPlans = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Employee$EnrollmentModal$Model = $elm$core$Basics$identity;
var $author$project$Utils$Date$alignTo = F2(
	function (date, cutoffDay) {
		var alignedDate = A2($justinmimbs$date$Date$floor, 2, date);
		return (_Utils_cmp(
			$justinmimbs$date$Date$day(date),
			cutoffDay) > 0) ? A3($justinmimbs$date$Date$add, 1, 1, alignedDate) : alignedDate;
	});
var $author$project$Api$Employer$Company$Shared$enrollmentCutOffDayOfMonth = function (_v0) {
	var record = _v0;
	return record.RD;
};
var $author$project$Api$Employer$Company$One$enrollmentCutOffDayOfMonth = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Company$Shared$enrollmentCutOffDayOfMonth(shared);
};
var $author$project$Api$Provider$Company$One$enrollmentCutOffDayOfMonth = function (_v0) {
	var record = _v0.b;
	return record.RD;
};
var $author$project$Api$Company$enrollmentCutOffDayOfMonth = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$enrollmentCutOffDayOfMonth(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$enrollmentCutOffDayOfMonth(company_);
	}
};
var $author$project$Api$Employer$Company$One$nextInvoiceDate = function (_v0) {
	var record = _v0.b;
	return record.XS;
};
var $author$project$Api$Provider$Company$Shared$nextInvoiceDate = function (_v0) {
	var record = _v0;
	return record.XS;
};
var $author$project$Api$Provider$Company$One$nextInvoiceDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$nextInvoiceDate(shared);
};
var $author$project$Api$Company$nextInvoiceDate = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$nextInvoiceDate(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$nextInvoiceDate(company_);
	}
};
var $author$project$Components$Employee$EnrollmentModal$init = F6(
	function (apiClient, currentDate, session, action, company, companyAccountId) {
		var enrollmentCutOffDayOfMonth = $author$project$Api$Company$enrollmentCutOffDayOfMonth(company);
		var alignToCutoff = function (date) {
			return A2($author$project$Utils$Date$alignTo, date, enrollmentCutOffDayOfMonth);
		};
		var defaultStart = alignToCutoff(currentDate);
		return _Utils_Tuple2(
			{
				Gg: action,
				Lp: alignToCutoff,
				afQ: company,
				Ob: $author$project$Api$Data$Loading,
				Oc: companyAccountId,
				aH: $author$project$Api$Data$Loading,
				dd: currentDate,
				za: defaultStart,
				SD: $elm$core$Maybe$Nothing,
				XS: $author$project$Api$Company$nextInvoiceDate(company),
				k9: $author$project$Api$Data$NotAsked,
				aa4: session,
				lB: ''
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A5(
						$author$project$Api$CompanyPlan$list,
						apiClient,
						session,
						$author$project$Api$Company$id(company),
						$elm$core$Basics$identity,
						$author$project$Components$Employee$EnrollmentModal$GotCompanyPlans),
						A5(
						$author$project$Api$CompanyAccount$retrieve,
						apiClient,
						session,
						$author$project$Api$Company$id(company),
						companyAccountId,
						$author$project$Components$Employee$EnrollmentModal$GotCompanyAccount)
					])));
	});
var $author$project$Api$Employer$CompanyAccount$makeEligible = F3(
	function (apiClient, basePath, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Employer$CompanyAccount$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['make_eligible']),
					basePath)));
	});
var $author$project$Api$Provider$Company$Account$makeEligible = F3(
	function (apiClient, basePath, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CompanyAccount$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['make_eligible']),
					basePath)));
	});
var $author$project$Api$CompanyAccount$makeEligible = F4(
	function (apiClient, session, _v0, toMsg) {
		var companyId = _v0.fZ;
		var accountId = _v0.fv;
		var basePath = A3($author$project$Api$CompanyAccount$companyAccountPath, session, companyId, accountId);
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$CompanyAccount$makeEligible,
			apiClient,
			basePath,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Employer))) : A3(
			$author$project$Api$Provider$Company$Account$makeEligible,
			apiClient,
			basePath,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Provider)));
	});
var $author$project$Api$Employer$CompanyRegistration$makeEligible = F4(
	function (apiClient, accountId, registrationId, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Employer$CompanyRegistration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['make_eligible']),
					A2($author$project$Api$Employer$CompanyRegistration$companyRegistrationPath, accountId, registrationId))));
	});
var $author$project$Api$Provider$Company$Registration$makeEligible = F5(
	function (apiClient, companyId, companyAccountId, registrationId, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CompanyRegistration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['make_eligible']),
					A3($author$project$Api$Provider$Company$Registration$companyRegistrationPath, companyId, companyAccountId, registrationId))));
	});
var $author$project$Api$CompanyRegistration$makeEligible = F4(
	function (apiClient, session, _v0, toMsg) {
		var companyId = _v0.fZ;
		var accountId = _v0.fv;
		var registrationId = _v0.pA;
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4(
			$author$project$Api$Employer$CompanyRegistration$makeEligible,
			apiClient,
			accountId,
			registrationId,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyRegistration$One$Employer))) : A5(
			$author$project$Api$Provider$Company$Registration$makeEligible,
			apiClient,
			companyId,
			accountId,
			registrationId,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyRegistration$One$Provider)));
	});
var $author$project$Api$Employer$CompanyAccount$makeIneligible = F3(
	function (apiClient, basePath, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Employer$CompanyAccount$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['make_ineligible']),
					basePath)));
	});
var $author$project$Api$Provider$Company$Account$makeIneligible = F3(
	function (apiClient, basePath, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CompanyAccount$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['make_ineligible']),
					basePath)));
	});
var $author$project$Api$CompanyAccount$makeIneligible = F4(
	function (apiClient, session, _v0, toMsg) {
		var companyId = _v0.fZ;
		var accountId = _v0.fv;
		var basePath = A3($author$project$Api$CompanyAccount$companyAccountPath, session, companyId, accountId);
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$CompanyAccount$makeIneligible,
			apiClient,
			basePath,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Employer))) : A3(
			$author$project$Api$Provider$Company$Account$makeIneligible,
			apiClient,
			basePath,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Provider)));
	});
var $author$project$Api$Employer$CompanyRegistration$makeIneligible = F4(
	function (apiClient, accountId, registrationId, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Employer$CompanyRegistration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['make_ineligible']),
					A2($author$project$Api$Employer$CompanyRegistration$companyRegistrationPath, accountId, registrationId))));
	});
var $author$project$Api$Provider$Company$Registration$makeIneligible = F5(
	function (apiClient, companyId, companyAccountId, registrationId, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CompanyRegistration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['make_ineligible']),
					A3($author$project$Api$Provider$Company$Registration$companyRegistrationPath, companyId, companyAccountId, registrationId))));
	});
var $author$project$Api$CompanyRegistration$makeIneligible = F4(
	function (apiClient, session, _v0, toMsg) {
		var companyId = _v0.fZ;
		var accountId = _v0.fv;
		var registrationId = _v0.pA;
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4(
			$author$project$Api$Employer$CompanyRegistration$makeIneligible,
			apiClient,
			accountId,
			registrationId,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyRegistration$One$Employer))) : A5(
			$author$project$Api$Provider$Company$Registration$makeIneligible,
			apiClient,
			companyId,
			accountId,
			registrationId,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyRegistration$One$Provider)));
	});
var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$membershipStartDate = function (_v0) {
	var record = _v0.b;
	return record.WW;
};
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$membershipStartDate = function (_v0) {
	var record = _v0.b;
	return record.WW;
};
var $author$project$Api$CompanyRegistration$ForCompanyAccountAll$membershipStartDate = function (companyRegistration) {
	if (!companyRegistration.$) {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$membershipStartDate(companyRegistration_);
	} else {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$membershipStartDate(companyRegistration_);
	}
};
var $author$project$Api$Employer$CompanyAccount$Meta$min = function (_v0) {
	var meta = _v0;
	return meta.kk.sb.W9;
};
var $author$project$Api$Provider$CompanyAccount$Meta$min = function (_v0) {
	var meta = _v0;
	return meta.kk.sb.W9;
};
var $author$project$Api$CompanyAccount$Meta$min = function (meta) {
	if (!meta.$) {
		var meta_ = meta.a;
		return $author$project$Api$Provider$CompanyAccount$Meta$min(meta_);
	} else {
		var meta_ = meta.a;
		return $author$project$Api$Employer$CompanyAccount$Meta$min(meta_);
	}
};
var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$patient = function (_v0) {
	var record = _v0.b;
	return record.YY;
};
var $author$project$Api$CompanyRegistration$ForCompanyAccountAll$patient = function (companyRegistration) {
	if (!companyRegistration.$) {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Patient$Min$Provider(
			$author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$patient(companyRegistration_));
	} else {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Patient$Min$Employer(
			$author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$patient(companyRegistration_));
	}
};
var $author$project$Api$Employer$Patient$Min$age = function (_v0) {
	var record = _v0;
	return record.Lj;
};
var $author$project$Api$Provider$Patient$Min$age = function (_v0) {
	var min = _v0;
	return min.Lj;
};
var $author$project$Api$Patient$Min$age = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$Min$age(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$Min$age(patient_);
	}
};
var $author$project$Api$Employer$Plan$Min$maximumAge = function (_v0) {
	var record = _v0;
	return record.WF;
};
var $author$project$Api$Provider$Plan$Min$maximumAge = function (_v0) {
	var record = _v0;
	return record.WF;
};
var $author$project$Api$Plan$Min$maximumAge = function (plan) {
	if (!plan.$) {
		var plan_ = plan.a;
		return $author$project$Api$Provider$Plan$Min$maximumAge(plan_);
	} else {
		var plan_ = plan.a;
		return $author$project$Api$Employer$Plan$Min$maximumAge(plan_);
	}
};
var $author$project$Components$Company$EmployeeRow$patientIsAboveAge = F2(
	function (plan, patient) {
		var _v0 = _Utils_Tuple2(
			$author$project$Api$Plan$Min$maximumAge(plan),
			$author$project$Api$Patient$Min$age(patient));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var maximumAge = _v0.a.a;
			var age = _v0.b.a;
			return _Utils_cmp(age, maximumAge) > 0;
		} else {
			return false;
		}
	});
var $author$project$Api$Employer$Plan$Min$minimumAge = function (_v0) {
	var record = _v0;
	return record.Xd;
};
var $author$project$Api$Provider$Plan$Min$minimumAge = function (_v0) {
	var record = _v0;
	return record.Xd;
};
var $author$project$Api$Plan$Min$minimumAge = function (plan) {
	if (!plan.$) {
		var plan_ = plan.a;
		return $author$project$Api$Provider$Plan$Min$minimumAge(plan_);
	} else {
		var plan_ = plan.a;
		return $author$project$Api$Employer$Plan$Min$minimumAge(plan_);
	}
};
var $author$project$Components$Company$EmployeeRow$patientIsBelowAge = F2(
	function (plan, patient) {
		var _v0 = _Utils_Tuple2(
			$author$project$Api$Plan$Min$minimumAge(plan),
			$author$project$Api$Patient$Min$age(patient));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var minimumAge = _v0.a.a;
			var age = _v0.b.a;
			return _Utils_cmp(age, minimumAge) < 0;
		} else {
			return false;
		}
	});
var $author$project$Components$Company$EmployeeRow$patientOutsideAgeRange = F2(
	function (plan, companyRegistration) {
		if ((!plan.$) && (!plan.a.$)) {
			var plan_ = plan.a.a;
			var patient = $author$project$Api$CompanyRegistration$ForCompanyAccountAll$patient(companyRegistration);
			return A2($author$project$Components$Company$EmployeeRow$patientIsBelowAge, plan_, patient) || A2($author$project$Components$Company$EmployeeRow$patientIsAboveAge, plan_, patient);
		} else {
			return false;
		}
	});
var $author$project$Api$Employer$CompanyAccount$All$plan = function (_v0) {
	var record = _v0.b;
	return record.Jb;
};
var $author$project$Api$Provider$CompanyAccount$All$plan = function (_v0) {
	var record = _v0.b;
	return record.Jb;
};
var $author$project$Api$CompanyAccount$All$plan = function (companyAccount) {
	if (!companyAccount.$) {
		var companyAccount_ = companyAccount.a;
		return A2(
			A2($elm$core$Basics$composeR, $elm$core$Maybe$map, $author$project$Api$Expandable$map),
			$author$project$Api$Plan$Min$Provider,
			$author$project$Api$Provider$CompanyAccount$All$plan(companyAccount_));
	} else {
		var companyAccount_ = companyAccount.a;
		return A2(
			A2($elm$core$Basics$composeR, $elm$core$Maybe$map, $author$project$Api$Expandable$map),
			$author$project$Api$Plan$Min$Employer,
			$author$project$Api$Employer$CompanyAccount$All$plan(companyAccount_));
	}
};
var $author$project$Components$Company$UnenrollModal$CancellationReasonOtherValidation = 1;
var $author$project$Components$Company$UnenrollModal$CancellationReasonValidation = 0;
var $author$project$Components$Company$UnenrollModal$Closed = 1;
var $author$project$Components$Company$UnenrollModal$EndDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Company$UnenrollModal$GotCompanyAccount = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Company$UnenrollModal$GotCompanyRegistration = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Company$UnenrollModal$None = 0;
var $author$project$Components$Company$UnenrollModal$Unenrolled = 2;
var $author$project$Components$Company$UnenrollModal$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var date = field.a;
			return _Utils_update(
				fields,
				{akO: date});
		} else {
			var _v1 = field.a;
			var cancellationReason = _v1.a;
			var cancellationReasonOther = _v1.b;
			return _Utils_update(
				fields,
				{afo: cancellationReason, afp: cancellationReasonOther});
		}
	});
var $author$project$Components$CancellationReason$Input$validate = F3(
	function (cancellationReasonValidationGroup, cancellationReasonOtherValidationGroup, fields) {
		var _v0 = _Utils_Tuple2(
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Qr;
				},
				fields.afo),
			fields.afp);
		if (_v0.a.$ === 1) {
			var _v1 = _v0.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(cancellationReasonValidationGroup, 'Please select a reason.')
				]);
		} else {
			if ((_v0.a.a === 'Other') && (_v0.b.$ === 1)) {
				var _v2 = _v0.b;
				return _List_fromArray(
					[
						_Utils_Tuple2(cancellationReasonOtherValidationGroup, 'Please enter a reason')
					]);
			} else {
				return _List_Nil;
			}
		}
	});
var $author$project$Components$Company$UnenrollModal$EndDateValidation = 2;
var $author$project$Components$Company$UnenrollModal$validateEndDate = F2(
	function (model, fields) {
		var _v0 = fields.akO;
		if (!_v0.$) {
			var endDate = _v0.a;
			var yesterdayDate = A3($justinmimbs$date$Date$add, 3, -1, model.dd);
			var minDate = A2($elm$core$Maybe$withDefault, yesterdayDate, model.Bh);
			return (A2($justinmimbs$date$Date$compare, minDate, endDate) !== 2) ? _List_Nil : _List_fromArray(
				[
					_Utils_Tuple2(2, 'End date is invalid')
				]);
		} else {
			return _List_fromArray(
				[
					_Utils_Tuple2(2, 'Please enter a date.')
				]);
		}
	});
var $author$project$Components$Company$UnenrollModal$formFieldsValidator = function (model) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$Company$UnenrollModal$validateEndDate(model)),
				$rtfeldman$elm_validate$Validate$fromErrors(
				A2($author$project$Components$CancellationReason$Input$validate, 0, 1))
			]));
};
var $author$project$Api$Employer$CompanyAccount$unenroll = F4(
	function (apiClient, basePath, jsonBody, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Employer$CompanyAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				jsonBody,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['unenroll']),
						basePath))));
	});
var $author$project$Api$Provider$Company$Account$unenroll = F4(
	function (apiClient, basePath, jsonBody, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CompanyAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				jsonBody,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['unenroll']),
						basePath))));
	});
var $author$project$Api$CompanyAccount$unenroll = F5(
	function (apiClient, session, _v0, fields, toMsg) {
		var companyId = _v0.fZ;
		var accountId = _v0.fv;
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'requested_end_date',
					A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.akO)),
					_Utils_Tuple2(
					'cancellation_reason',
					A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.afo)),
					_Utils_Tuple2(
					'cancellation_reason_other',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.afp))
				]));
		var basePath = A3($author$project$Api$CompanyAccount$companyAccountPath, session, companyId, accountId);
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4(
			$author$project$Api$Employer$CompanyAccount$unenroll,
			apiClient,
			basePath,
			body,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Employer))) : A4(
			$author$project$Api$Provider$Company$Account$unenroll,
			apiClient,
			basePath,
			body,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Provider)));
	});
var $author$project$Api$Employer$CompanyRegistration$unenroll = F5(
	function (apiClient, accountId, registrationId, jsonBody, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Employer$CompanyRegistration$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				jsonBody,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['unenroll']),
						A2($author$project$Api$Employer$CompanyRegistration$companyRegistrationPath, accountId, registrationId)))));
	});
var $author$project$Api$Provider$Company$Registration$unenroll = F6(
	function (apiClient, companyId, companyAccountId, registrationId, jsonBody, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CompanyRegistration$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				jsonBody,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['unenroll']),
						A3($author$project$Api$Provider$Company$Registration$companyRegistrationPath, companyId, companyAccountId, registrationId)))));
	});
var $author$project$Api$CompanyRegistration$unenroll = F5(
	function (apiClient, session, _v0, fields, toMsg) {
		var companyId = _v0.fZ;
		var accountId = _v0.fv;
		var registrationId = _v0.pA;
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'requested_end_date',
					A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.akO)),
					_Utils_Tuple2(
					'cancellation_reason',
					A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.afo)),
					_Utils_Tuple2(
					'cancellation_reason_other',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.afp))
				]));
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A5(
			$author$project$Api$Employer$CompanyRegistration$unenroll,
			apiClient,
			accountId,
			registrationId,
			body,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyRegistration$One$Employer))) : A6(
			$author$project$Api$Provider$Company$Registration$unenroll,
			apiClient,
			companyId,
			accountId,
			registrationId,
			body,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyRegistration$One$Provider)));
	});
var $author$project$Components$Company$UnenrollModal$updateDateInputFormField = F6(
	function (model, dateInputGetter, dateInputSetter, subMsg, toMsg, field) {
		var dateInput = dateInputGetter(model);
		var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
		var newDateInput = _v0.a;
		var subCmd = _v0.b;
		var event = _v0.c;
		var newForm = function () {
			if (event.$ === 1) {
				var date = event.a;
				return $author$project$Utils$Form$fromValidateResult(
					A2(
						$author$project$Utils$Form$validate,
						$rtfeldman$elm_validate$Validate$fromErrors(
							$author$project$Components$Company$UnenrollModal$validateEndDate(model)),
						A3(
							$author$project$Utils$Form$update,
							$author$project$Components$Company$UnenrollModal$formFieldsUpdate,
							field(date),
							model.SD)));
			} else {
				return model.SD;
			}
		}();
		return {
			GZ: A2($elm$core$Platform$Cmd$map, toMsg, subCmd),
			agZ: 0,
			aiO: A2(
				dateInputSetter,
				newDateInput,
				_Utils_update(
					model,
					{SD: newForm})),
			aR: _List_Nil
		};
	});
var $author$project$Components$Company$UnenrollModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: 1, aiO: model, aR: _List_Nil};
			case 1:
				var _v1 = A2(
					$author$project$Utils$Form$validate,
					$author$project$Components$Company$UnenrollModal$formFieldsValidator(model),
					model.SD);
				if (!_v1.$) {
					var _v2 = _v1.a;
					var newForm = _v2.a;
					var validFormFields = _v2.b;
					var validFields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
					var apiFields = {
						afo: A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.ahP;
							},
							validFields.afo),
						afp: validFields.afp,
						akO: validFields.akO
					};
					var unenrollCmd = function () {
						var _v3 = model.pA;
						if (!_v3.$) {
							var registrationId = _v3.a;
							return A5(
								$author$project$Api$CompanyRegistration$unenroll,
								apiClient,
								model.aa4,
								{fv: model.fv, fZ: model.fZ, pA: registrationId},
								apiFields,
								$author$project$Components$Company$UnenrollModal$GotCompanyRegistration);
						} else {
							return A5(
								$author$project$Api$CompanyAccount$unenroll,
								apiClient,
								model.aa4,
								{fv: model.fv, fZ: model.fZ},
								apiFields,
								$author$project$Components$Company$UnenrollModal$GotCompanyAccount);
						}
					}();
					return {
						GZ: unenrollCmd,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{SD: newForm}),
						aR: _List_Nil
					};
				} else {
					var newForm = _v1.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{SD: newForm}),
						aR: _List_Nil
					};
				}
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					var patientName = $author$project$Api$Patient$Min$name(
						$author$project$Api$CompanyRegistration$ForCompanyAccountAll$patient(model.Oi));
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 2,
						aiO: model,
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, patientName + ' is now unenrolled.')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: model,
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					var patientName = $author$project$Api$Patient$Min$name(
						$author$project$Api$CompanyRegistration$ForCompanyAccountAll$patient(model.Oi));
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 2,
						aiO: model,
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, patientName + ' is now unenrolled.')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: model,
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 4:
				var subMsg = msg.a;
				return A6(
					$author$project$Components$Company$UnenrollModal$updateDateInputFormField,
					model,
					function ($) {
						return $.sd;
					},
					F2(
						function (newDateInput, model_) {
							return _Utils_update(
								model_,
								{sd: newDateInput});
						}),
					subMsg,
					$author$project$Components$Company$UnenrollModal$EndDateInputMsg,
					$author$project$Components$Company$UnenrollModal$EndDate);
			default:
				var field = msg.a;
				var newForm = $author$project$Utils$Form$fromValidateResult(
					A2(
						$author$project$Utils$Form$validate,
						$rtfeldman$elm_validate$Validate$fromErrors(
							A2($author$project$Components$CancellationReason$Input$validate, 0, 1)),
						A3($author$project$Utils$Form$update, $author$project$Components$Company$UnenrollModal$formFieldsUpdate, field, model.SD)));
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{SD: newForm}),
					aR: _List_Nil
				};
		}
	});
var $author$project$Components$Employee$EnrollmentModal$Approved = 3;
var $author$project$Components$Employee$EnrollmentModal$Closed = 1;
var $author$project$Components$Employee$EnrollmentModal$CompanyAccountApproved = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Employee$EnrollmentModal$CompanyAccountEnrolled = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Employee$EnrollmentModal$Enrolled = 2;
var $author$project$Components$Employee$EnrollmentModal$None = 0;
var $author$project$Api$Employer$CompanyAccount$approve = F4(
	function (apiClient, basePath, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'membership_start_date',
					$author$project$Utils$Date$encode(fields.WW))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Employer$CompanyAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['approve']),
						basePath))));
	});
var $author$project$Api$Provider$Company$Account$approve = F4(
	function (apiClient, basePath, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'membership_start_date',
					$author$project$Utils$Date$encode(fields.WW)),
					_Utils_Tuple2(
					'plan',
					A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.Jb))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CompanyAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['approve']),
						basePath))));
	});
var $author$project$Api$CompanyAccount$approve = F5(
	function (apiClient, session, _v0, fields, toMsg) {
		var companyId = _v0.fZ;
		var accountId = _v0.fv;
		var basePath = A3($author$project$Api$CompanyAccount$companyAccountPath, session, companyId, accountId);
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4(
			$author$project$Api$Employer$CompanyAccount$approve,
			apiClient,
			basePath,
			{WW: fields.WW},
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Employer))) : A4(
			$author$project$Api$Provider$Company$Account$approve,
			apiClient,
			basePath,
			fields,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Provider)));
	});
var $author$project$Api$Employer$CompanyAccount$enroll = F4(
	function (apiClient, basePath, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'membership_start_date',
					$author$project$Utils$Date$encode(fields.WW)),
					_Utils_Tuple2(
					'plan',
					A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.Jb))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Employer$CompanyAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['enroll']),
						basePath))));
	});
var $author$project$Api$Provider$Company$Account$enroll = F4(
	function (apiClient, basePath, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'membership_start_date',
					$author$project$Utils$Date$encode(fields.WW)),
					_Utils_Tuple2(
					'plan',
					A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.Jb))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CompanyAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['enroll']),
						basePath))));
	});
var $author$project$Api$CompanyAccount$enroll = F5(
	function (apiClient, session, _v0, fields, toMsg) {
		var companyId = _v0.fZ;
		var accountId = _v0.fv;
		var basePath = A3($author$project$Api$CompanyAccount$companyAccountPath, session, companyId, accountId);
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4(
			$author$project$Api$Employer$CompanyAccount$enroll,
			apiClient,
			basePath,
			fields,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Employer))) : A4(
			$author$project$Api$Provider$Company$Account$enroll,
			apiClient,
			basePath,
			fields,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Provider)));
	});
var $author$project$Api$Employer$Plan$Shared$maximumAge = function (_v0) {
	var record = _v0;
	return record.WF;
};
var $author$project$Api$Employer$Plan$All$maximumAge = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$maximumAge(shared);
};
var $author$project$Api$Employer$Plan$One$maximumAge = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$maximumAge(shared);
};
var $author$project$Api$Provider$Plan$All$maximumAge = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$maximumAge(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$maximumAge = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$maximumAge(shared);
};
var $author$project$Api$Plan$maximumAge = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$Shared$maximumAge(plan_);
		case 1:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$SharedWithContractInfo$maximumAge(plan_);
		case 4:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$Shared$maximumAge(plan_);
		case 2:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$All$maximumAge(plan_);
		case 6:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$All$maximumAge(plan_);
		case 3:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$One$maximumAge(plan_);
		default:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$One$maximumAge(plan_);
	}
};
var $author$project$Api$Employer$Plan$Shared$minimumAge = function (_v0) {
	var record = _v0;
	return record.Xd;
};
var $author$project$Api$Employer$Plan$All$minimumAge = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$minimumAge(shared);
};
var $author$project$Api$Employer$Plan$One$minimumAge = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$minimumAge(shared);
};
var $author$project$Api$Provider$Plan$All$minimumAge = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$minimumAge(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$minimumAge = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$minimumAge(shared);
};
var $author$project$Api$Plan$minimumAge = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$Shared$minimumAge(plan_);
		case 1:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$SharedWithContractInfo$minimumAge(plan_);
		case 4:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$Shared$minimumAge(plan_);
		case 2:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$All$minimumAge(plan_);
		case 6:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$All$minimumAge(plan_);
		case 3:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$One$minimumAge(plan_);
		default:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$One$minimumAge(plan_);
	}
};
var $author$project$Api$Employer$Plan$Shared$tobaccoSurchargeType = function (_v0) {
	var record = _v0;
	return record.adh;
};
var $author$project$Api$Employer$Plan$All$tobaccoSurchargeType = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$tobaccoSurchargeType(shared);
};
var $author$project$Api$Employer$Plan$One$tobaccoSurchargeType = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$tobaccoSurchargeType(shared);
};
var $author$project$Api$Provider$Plan$All$tobaccoSurchargeType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$tobaccoSurchargeType(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$tobaccoSurchargeType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$tobaccoSurchargeType(shared);
};
var $author$project$Api$Plan$tobaccoSurchargeType = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$Shared$tobaccoSurchargeType(plan_);
		case 1:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$SharedWithContractInfo$tobaccoSurchargeType(plan_);
		case 4:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$Shared$tobaccoSurchargeType(plan_);
		case 2:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$All$tobaccoSurchargeType(plan_);
		case 6:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$All$tobaccoSurchargeType(plan_);
		case 3:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$One$tobaccoSurchargeType(plan_);
		default:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$One$tobaccoSurchargeType(plan_);
	}
};
var $author$project$Components$Employee$EnrollmentModal$planFieldFromApi = function (plan) {
	return {
		ahP: $author$project$Api$Plan$id(plan),
		WF: $author$project$Api$Plan$maximumAge(plan),
		Xd: $author$project$Api$Plan$minimumAge(plan),
		Bq: $author$project$Api$Plan$name(plan),
		adh: $author$project$Api$Plan$tobaccoSurchargeType(plan)
	};
};
var $author$project$Components$Employee$EnrollmentModal$formFieldsUpdate = F3(
	function (_v0, field, fields) {
		var model = _v0;
		if (!field.$) {
			var planId = field.a;
			var plans = A2($elm$core$List$map, $author$project$Api$CompanyPlan$plan, fields.aH);
			var plan = A2(
				$elm_community$list_extra$List$Extra$find,
				function (plan_) {
					return _Utils_eq(
						$author$project$Api$Plan$id(plan_),
						planId);
				},
				plans);
			return _Utils_update(
				fields,
				{
					Jb: A2($elm$core$Maybe$map, $author$project$Components$Employee$EnrollmentModal$planFieldFromApi, plan)
				});
		} else {
			var date = field.a;
			return _Utils_update(
				fields,
				{
					WW: A2($elm$core$Maybe$withDefault, model.za, date)
				});
		}
	});
var $author$project$Components$Employee$EnrollmentModal$PlanValidation = 0;
var $author$project$Components$Employee$EnrollmentModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.Jb;
			},
			_Utils_Tuple2(0, 'Please pick a plan'))
		]));
var $author$project$Api$Employer$CompanyPlan$Shared$isDefault = function (_v0) {
	var record = _v0;
	return record.UM;
};
var $author$project$Api$Employer$CompanyPlan$All$isDefault = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$CompanyPlan$Shared$isDefault(shared);
};
var $author$project$Api$Provider$CompanyPlan$Shared$isDefault = function (_v0) {
	var record = _v0;
	return record.UM;
};
var $author$project$Api$Provider$CompanyPlan$One$isDefault = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyPlan$Shared$isDefault(shared);
};
var $author$project$Api$Provider$CompanyPlan$All$isDefault = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$CompanyPlan$One$isDefault(one);
};
var $author$project$Api$CompanyPlan$isDefault = function (companyPlan) {
	switch (companyPlan.$) {
		case 0:
			var companyPlan_ = companyPlan.a;
			return $author$project$Api$Provider$CompanyPlan$One$isDefault(companyPlan_);
		case 1:
			var companyPlan_ = companyPlan.a;
			return $author$project$Api$Provider$CompanyPlan$All$isDefault(companyPlan_);
		default:
			var companyPlan_ = companyPlan.a;
			return $author$project$Api$Employer$CompanyPlan$All$isDefault(companyPlan_);
	}
};
var $author$project$Api$Employer$Plan$Min$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Plan$Min$name = function (plan) {
	if (!plan.$) {
		var plan_ = plan.a;
		return $author$project$Api$Provider$Plan$Min$name(plan_);
	} else {
		var plan_ = plan.a;
		return $author$project$Api$Employer$Plan$Min$name(plan_);
	}
};
var $author$project$Api$Employer$Plan$Min$tobaccoSurchargeType = function (_v0) {
	var record = _v0;
	return record.adh;
};
var $author$project$Api$Provider$Plan$Min$tobaccoSurchargeType = function (_v0) {
	var record = _v0;
	return record.adh;
};
var $author$project$Api$Plan$Min$tobaccoSurchargeType = function (plan) {
	if (!plan.$) {
		var plan_ = plan.a;
		return $author$project$Api$Provider$Plan$Min$tobaccoSurchargeType(plan_);
	} else {
		var plan_ = plan.a;
		return $author$project$Api$Employer$Plan$Min$tobaccoSurchargeType(plan_);
	}
};
var $author$project$Components$Employee$EnrollmentModal$planFieldFromApiMin = function (plan) {
	return {
		ahP: $author$project$Api$Plan$Min$id(plan),
		WF: $author$project$Api$Plan$Min$maximumAge(plan),
		Xd: $author$project$Api$Plan$Min$minimumAge(plan),
		Bq: $author$project$Api$Plan$Min$name(plan),
		adh: $author$project$Api$Plan$Min$tobaccoSurchargeType(plan)
	};
};
var $author$project$Api$Employer$CompanyAccount$One$selectedPlan = function (_v0) {
	var record = _v0.b;
	return record.aaH;
};
var $author$project$Api$Provider$CompanyAccount$One$selectedPlan = function (_v0) {
	var record = _v0.b;
	return record.aaH;
};
var $author$project$Api$CompanyAccount$One$selectedPlan = function (companyAccount) {
	if (!companyAccount.$) {
		var companyAccount_ = companyAccount.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Plan$Min$Provider,
			$author$project$Api$Provider$CompanyAccount$One$selectedPlan(companyAccount_));
	} else {
		var companyAccount_ = companyAccount.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Plan$Min$Employer,
			$author$project$Api$Employer$CompanyAccount$One$selectedPlan(companyAccount_));
	}
};
var $author$project$Components$Employee$EnrollmentModal$initFormFields = F3(
	function (defaultStart, companyAccount, companyPlans) {
		var plans = A2($elm$core$List$map, $author$project$Api$CompanyPlan$plan, companyPlans);
		var plan = function () {
			if ($elm$core$List$length(plans) === 1) {
				return A2(
					$elm$core$Maybe$map,
					$author$project$Components$Employee$EnrollmentModal$planFieldFromApi,
					$elm$core$List$head(plans));
			} else {
				var defaultCompanyPlan = A2(
					$elm_community$list_extra$List$Extra$find,
					function (companyPlan) {
						return $author$project$Api$CompanyPlan$isDefault(companyPlan);
					},
					companyPlans);
				var _v0 = _Utils_Tuple2(
					$author$project$Api$CompanyAccount$One$selectedPlan(companyAccount),
					A2($elm$core$Maybe$map, $author$project$Api$CompanyPlan$plan, defaultCompanyPlan));
				if (!_v0.a.$) {
					var selectedPlan = _v0.a.a;
					return $elm$core$Maybe$Just(
						$author$project$Components$Employee$EnrollmentModal$planFieldFromApiMin(selectedPlan));
				} else {
					if (!_v0.b.$) {
						var _v1 = _v0.a;
						var defaultPlan = _v0.b.a;
						return $elm$core$Maybe$Just(
							$author$project$Components$Employee$EnrollmentModal$planFieldFromApi(defaultPlan));
					} else {
						var _v2 = _v0.a;
						var _v3 = _v0.b;
						return A2(
							$elm$core$Maybe$map,
							$author$project$Components$Employee$EnrollmentModal$planFieldFromApi,
							$elm$core$List$head(plans));
					}
				}
			}
		}();
		return {Ob: companyAccount, aH: companyPlans, WW: defaultStart, Jb: plan};
	});
var $author$project$Components$Employee$EnrollmentModal$initForm = F3(
	function (companyAccount, companyPlans, defaultStart) {
		var fields = function () {
			var _v0 = _Utils_Tuple2(companyAccount, companyPlans);
			if ((_v0.a.$ === 3) && (_v0.b.$ === 3)) {
				var _v1 = _v0.a;
				var companyAccount_ = _v1.a;
				var _v2 = _v0.b;
				var companyPlans_ = _v2.a;
				return $elm$core$Maybe$Just(
					A3($author$project$Components$Employee$EnrollmentModal$initFormFields, defaultStart, companyAccount_, companyPlans_));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		return A2($elm$core$Maybe$map, $author$project$Utils$Form$init, fields);
	});
var $author$project$Api$Employer$CompanyAccount$One$subscriber = function (_v0) {
	var record = _v0.b;
	return record.acy;
};
var $author$project$Api$Provider$CompanyAccount$One$subscriber = function (_v0) {
	var record = _v0.b;
	return record.acy;
};
var $author$project$Api$CompanyAccount$One$subscriberName = function (companyAccount) {
	if (!companyAccount.$) {
		var companyAccount_ = companyAccount.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$Patient$Shared$name,
			$author$project$Api$Provider$CompanyAccount$One$subscriber(companyAccount_));
	} else {
		var companyAccount_ = companyAccount.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Employer$Patient$Shared$name,
			$author$project$Api$Employer$CompanyAccount$One$subscriber(companyAccount_));
	}
};
var $author$project$Components$Employee$EnrollmentModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 1:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: 1, aiO: model, aR: _List_Nil};
			case 0:
				var _v2 = model.SD;
				if (!_v2.$) {
					var form = _v2.a;
					var _v3 = A2($author$project$Utils$Form$validate, $author$project$Components$Employee$EnrollmentModal$formFieldsValidator, form);
					if (!_v3.$) {
						var _v4 = _v3.a;
						var newForm = _v4.a;
						var validFormFields = _v4.b;
						var validFields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
						var employeeParams = {
							fv: model.Oc,
							fZ: $author$project$Api$Company$id(model.afQ)
						};
						var apiFields = {
							WW: validFields.WW,
							Jb: A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.ahP;
								},
								validFields.Jb)
						};
						return {
							GZ: function () {
								var _v5 = model.Gg;
								if (!_v5) {
									return A5($author$project$Api$CompanyAccount$enroll, apiClient, model.aa4, employeeParams, apiFields, $author$project$Components$Employee$EnrollmentModal$CompanyAccountEnrolled);
								} else {
									return A5($author$project$Api$CompanyAccount$approve, apiClient, model.aa4, employeeParams, apiFields, $author$project$Components$Employee$EnrollmentModal$CompanyAccountApproved);
								}
							}(),
							agZ: 0,
							aiO: _Utils_update(
								model,
								{
									SD: $elm$core$Maybe$Just(newForm),
									k9: $author$project$Api$Data$Loading
								}),
							aR: _List_Nil
						};
					} else {
						var newForm = _v3.a;
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 0,
							aiO: _Utils_update(
								model,
								{
									SD: $elm$core$Maybe$Just(newForm)
								}),
							aR: _List_Nil
						};
					}
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					var companyAccount = response.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{
								Ob: response,
								SD: A3($author$project$Components$Employee$EnrollmentModal$initForm, response, model.aH, model.za),
								lB: A2(
									$elm$core$Maybe$withDefault,
									'N/A',
									$author$project$Api$CompanyAccount$One$subscriberName(companyAccount))
							}),
						aR: _List_Nil
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: model,
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{
								aH: response,
								SD: A3($author$project$Components$Employee$EnrollmentModal$initForm, model.Ob, response, model.za)
							}),
						aR: _List_Nil
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: model,
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 2,
						aiO: model,
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, model.lB + ' was enrolled')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{k9: $author$project$Api$Data$NotAsked}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 3,
						aiO: model,
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, model.lB + ' was enrolled')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{k9: $author$project$Api$Data$NotAsked}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			default:
				var field = msg.a;
				var _v10 = model.SD;
				if (!_v10.$) {
					var form = _v10.a;
					var newForm = A3(
						$author$project$Utils$Form$update,
						$author$project$Components$Employee$EnrollmentModal$formFieldsUpdate(model),
						field,
						form);
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{
								SD: $elm$core$Maybe$Just(newForm)
							}),
						aR: _List_Nil
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
		}
	});
var $author$project$Components$Company$EmployeeRow$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Ui$Dropdown$update, subMsg, model.gi);
				var dropdown = _v1.a;
				var cmd = _v1.b;
				return {
					GZ: cmd,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{gi: dropdown}),
					aR: _List_Nil
				};
			case 1:
				var employeeOrDependent_ = msg.a;
				var madeEligibleCmd = function () {
					if (!employeeOrDependent_.$) {
						var employee = employeeOrDependent_.a;
						return A4(
							$author$project$Api$CompanyAccount$makeEligible,
							apiClient,
							model.aa4,
							{
								fv: $author$project$Api$CompanyAccount$All$id(employee),
								fZ: $author$project$Api$Company$id(model.afQ)
							},
							$author$project$Components$Company$EmployeeRow$GotCompanyAccount('eligible'));
					} else {
						var dependent = employeeOrDependent_.a;
						return A4(
							$author$project$Api$CompanyRegistration$makeEligible,
							apiClient,
							model.aa4,
							{
								fv: $author$project$Api$CompanyAccount$All$id(model.Ob),
								fZ: $author$project$Api$Company$id(model.afQ),
								pA: $author$project$Api$CompanyRegistration$ForCompanyAccountAll$id(dependent)
							},
							$author$project$Components$Company$EmployeeRow$GotCompanyRegistration('eligible'));
					}
				}();
				return {GZ: madeEligibleCmd, agZ: 0, aiO: model, aR: _List_Nil};
			case 2:
				var employeeOrDependent_ = msg.a;
				var madeIneligibleCmd = function () {
					if (!employeeOrDependent_.$) {
						var employee = employeeOrDependent_.a;
						return A4(
							$author$project$Api$CompanyAccount$makeIneligible,
							apiClient,
							model.aa4,
							{
								fv: $author$project$Api$CompanyAccount$All$id(employee),
								fZ: $author$project$Api$Company$id(model.afQ)
							},
							$author$project$Components$Company$EmployeeRow$GotCompanyAccount('ineligible'));
					} else {
						var dependent = employeeOrDependent_.a;
						return A4(
							$author$project$Api$CompanyRegistration$makeIneligible,
							apiClient,
							model.aa4,
							{
								fv: $author$project$Api$CompanyAccount$All$id(model.Ob),
								fZ: $author$project$Api$Company$id(model.afQ),
								pA: $author$project$Api$CompanyRegistration$ForCompanyAccountAll$id(dependent)
							},
							$author$project$Components$Company$EmployeeRow$GotCompanyRegistration('ineligible'));
					}
				}();
				return {GZ: madeIneligibleCmd, agZ: 0, aiO: model, aR: _List_Nil};
			case 3:
				var actionString = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var patientName = $author$project$Api$Patient$Min$name(
						$author$project$Api$CompanyRegistration$ForCompanyAccountAll$patient(model.Oi));
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 1,
						aiO: model,
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, patientName + (' was made ' + actionString))
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: model,
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 4:
				var actionString = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var patientName = $author$project$Api$Patient$Min$name(
						$author$project$Api$CompanyRegistration$ForCompanyAccountAll$patient(model.Oi));
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 1,
						aiO: model,
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, patientName + (' was made ' + actionString))
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: model,
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					var patientName = $author$project$Api$Patient$Min$name(
						$author$project$Api$CompanyRegistration$ForCompanyAccountAll$patient(model.Oi));
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 1,
						aiO: model,
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, patientName + ' was deleted.')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: model,
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 6:
				var employeeOrDependent_ = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{i9: employeeOrDependent_}),
					aR: _List_Nil
				};
			case 7:
				var employeeOrDependent_ = msg.a;
				var confirmed = msg.b;
				if (confirmed) {
					var deleteCmd = function () {
						if (!employeeOrDependent_.$) {
							var employee = employeeOrDependent_.a;
							return A4(
								$author$project$Api$CompanyAccount$delete,
								apiClient,
								model.aa4,
								{
									fv: $author$project$Api$CompanyAccount$All$id(employee),
									fZ: $author$project$Api$Company$id(model.afQ)
								},
								$author$project$Components$Company$EmployeeRow$CompanyAccountOrRegistrationRemoved);
						} else {
							var dependent = employeeOrDependent_.a;
							return A4(
								$author$project$Api$CompanyRegistration$delete,
								apiClient,
								model.aa4,
								{
									fv: $author$project$Api$CompanyAccount$All$id(model.Ob),
									fZ: $author$project$Api$Company$id(model.afQ),
									pA: $author$project$Api$CompanyRegistration$ForCompanyAccountAll$id(dependent)
								},
								$author$project$Components$Company$EmployeeRow$CompanyAccountOrRegistrationRemoved);
						}
					}();
					return {
						GZ: deleteCmd,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{
								i9: $elm$core$Maybe$Just(employeeOrDependent_)
							}),
						aR: _List_Nil
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{i9: $elm$core$Maybe$Nothing}),
						aR: _List_Nil
					};
				}
			case 15:
				var employeeOrDependent_ = msg.a;
				var _v8 = function () {
					if (!employeeOrDependent_.$) {
						var employee = employeeOrDependent_.a;
						var accountMeta = $author$project$Api$CompanyAccount$All$meta(model.Ob);
						return _Utils_Tuple3(
							$author$project$Api$CompanyAccount$All$id(employee),
							$elm$core$Maybe$Nothing,
							$author$project$Api$CompanyAccount$Meta$min(accountMeta));
					} else {
						var dependent = employeeOrDependent_.a;
						return _Utils_Tuple3(
							$author$project$Api$CompanyAccount$All$id(model.Ob),
							$elm$core$Maybe$Just(
								$author$project$Api$CompanyRegistration$ForCompanyAccountAll$id(dependent)),
							$author$project$Api$CompanyRegistration$ForCompanyAccountAll$membershipStartDate(dependent));
					}
				}();
				var accountId = _v8.a;
				var registrationId = _v8.b;
				var minDate = _v8.c;
				var _v10 = A6(
					$author$project$Components$Company$UnenrollModal$init,
					model.aa4,
					{
						fv: accountId,
						fZ: $author$project$Api$Company$id(model.afQ),
						pA: registrationId
					},
					model.Ob,
					model.Oi,
					model.dd,
					minDate);
				var unenrollModal = _v10.a;
				var unenrollModalCmd = _v10.b;
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$EmployeeRow$UnenrollModalMsg, unenrollModalCmd),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							h1: $elm$core$Maybe$Just(unenrollModal)
						}),
					aR: _List_Nil
				};
			case 8:
				var employeeOrDependent_ = msg.a;
				if (!employeeOrDependent_.$) {
					var companyAccount = employeeOrDependent_.a;
					var _v12 = A6(
						$author$project$Components$Employee$EnrollmentModal$init,
						apiClient,
						model.dd,
						model.aa4,
						0,
						model.afQ,
						$author$project$Api$CompanyAccount$All$id(companyAccount));
					var enrollmentModal = _v12.a;
					var enrollmentModalCmd = _v12.b;
					return {
						GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$EmployeeRow$EnrollmentModalMsg, enrollmentModalCmd),
						agZ: 0,
						aiO: _Utils_update(
							model,
							{
								go: $elm$core$Maybe$Just(enrollmentModal)
							}),
						aR: _List_Nil
					};
				} else {
					var dependent = employeeOrDependent_.a;
					var showPlanAgeWarning = A2(
						$author$project$Components$Company$EmployeeRow$patientOutsideAgeRange,
						$author$project$Api$CompanyAccount$All$plan(model.Ob),
						dependent);
					return {
						GZ: showPlanAgeWarning ? $elm$core$Platform$Cmd$none : A5(
							$author$project$Api$CompanyRegistration$enroll,
							apiClient,
							model.aa4,
							{
								fv: $author$project$Api$CompanyAccount$All$id(model.Ob),
								fZ: $author$project$Api$Company$id(model.afQ),
								pA: $author$project$Api$CompanyRegistration$ForCompanyAccountAll$id(dependent)
							},
							$elm$json$Json$Encode$object(_List_Nil),
							$author$project$Components$Company$EmployeeRow$DependentEnrolled),
						agZ: 0,
						aiO: showPlanAgeWarning ? _Utils_update(
							model,
							{
								jj: $elm$core$Maybe$Just(dependent)
							}) : _Utils_update(
							model,
							{k9: $author$project$Api$Data$Loading}),
						aR: _List_Nil
					};
				}
			case 10:
				var dependent = msg.a;
				var confirmed = msg.b;
				return confirmed ? {
					GZ: A5(
						$author$project$Api$CompanyRegistration$enroll,
						apiClient,
						model.aa4,
						{
							fv: $author$project$Api$CompanyAccount$All$id(model.Ob),
							fZ: $author$project$Api$Company$id(model.afQ),
							pA: $author$project$Api$CompanyRegistration$ForCompanyAccountAll$id(dependent)
						},
						$elm$json$Json$Encode$object(_List_Nil),
						$author$project$Components$Company$EmployeeRow$DependentEnrolled),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{jj: $elm$core$Maybe$Nothing, k9: $author$project$Api$Data$Loading}),
					aR: _List_Nil
				} : {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{jj: $elm$core$Maybe$Nothing}),
					aR: _List_Nil
				};
			case 9:
				var response = msg.a;
				if (response.$ === 3) {
					var patientName = $author$project$Api$Patient$Min$name(
						$author$project$Api$CompanyRegistration$ForCompanyAccountAll$patient(model.Oi));
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 1,
						aiO: _Utils_update(
							model,
							{k9: $author$project$Api$Data$NotAsked}),
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, patientName + ' was successfully enrolled.')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{k9: $author$project$Api$Data$NotAsked}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 16:
				var subMsg = msg.a;
				var _v14 = model.h1;
				if (!_v14.$) {
					var unenrollModal = _v14.a;
					var unenrollModalResult = A3($author$project$Components$Company$UnenrollModal$update, apiClient, subMsg, unenrollModal);
					var event = function () {
						var _v17 = unenrollModalResult.agZ;
						if (_v17 === 2) {
							return 1;
						} else {
							return 0;
						}
					}();
					var _v15 = function () {
						var _v16 = unenrollModalResult.agZ;
						switch (_v16) {
							case 0:
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											h1: $elm$core$Maybe$Just(unenrollModalResult.aiO)
										}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							case 1:
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{h1: $elm$core$Maybe$Nothing}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							default:
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{h1: $elm$core$Maybe$Nothing}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
						}
					}();
					var newModel = _v15.a;
					var cmd = _v15.b;
					var outMsgs = _v15.c;
					return {
						GZ: $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$EmployeeRow$UnenrollModalMsg, unenrollModalResult.GZ),
									cmd
								])),
						agZ: event,
						aiO: newModel,
						aR: _Utils_ap(unenrollModalResult.aR, outMsgs)
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
			case 11:
				var _v18 = A6(
					$author$project$Components$Employee$EnrollmentModal$init,
					apiClient,
					model.dd,
					model.aa4,
					1,
					model.afQ,
					$author$project$Api$CompanyAccount$All$id(model.Ob));
				var enrollmentModal = _v18.a;
				var enrollmentModalCmd = _v18.b;
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$EmployeeRow$EnrollmentModalMsg, enrollmentModalCmd),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							go: $elm$core$Maybe$Just(enrollmentModal)
						}),
					aR: _List_Nil
				};
			case 12:
				var subMsg = msg.a;
				var _v19 = model.go;
				if (!_v19.$) {
					var enrollmentModal = _v19.a;
					var enrollmentModalResult = A3($author$project$Components$Employee$EnrollmentModal$update, apiClient, subMsg, enrollmentModal);
					var _v20 = function () {
						var _v21 = enrollmentModalResult.agZ;
						switch (_v21) {
							case 0:
								return _Utils_Tuple2(
									$elm$core$Maybe$Just(enrollmentModalResult.aiO),
									0);
							case 1:
								return _Utils_Tuple2($elm$core$Maybe$Nothing, 0);
							case 2:
								return _Utils_Tuple2($elm$core$Maybe$Nothing, 1);
							default:
								return _Utils_Tuple2($elm$core$Maybe$Nothing, 1);
						}
					}();
					var newEnrollmentModal = _v20.a;
					var event = _v20.b;
					return {
						GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$EmployeeRow$EnrollmentModalMsg, enrollmentModalResult.GZ),
						agZ: event,
						aiO: _Utils_update(
							model,
							{go: newEnrollmentModal}),
						aR: enrollmentModalResult.aR
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
			case 13:
				return {
					GZ: A4(
						$author$project$Api$CompanyAccount$deny,
						apiClient,
						model.aa4,
						{
							fv: $author$project$Api$CompanyAccount$All$id(model.Ob),
							fZ: $author$project$Api$Company$id(model.afQ)
						},
						$author$project$Components$Company$EmployeeRow$EmployeeDenied),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{k9: $author$project$Api$Data$Loading}),
					aR: _List_Nil
				};
			case 14:
				var response = msg.a;
				if (response.$ === 3) {
					var patientName = A2(
						$elm$core$Maybe$withDefault,
						'',
						$author$project$Api$CompanyAccount$All$subscriberName(model.Ob));
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 1,
						aiO: _Utils_update(
							model,
							{k9: $author$project$Api$Data$NotAsked}),
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, patientName + ' is denied and they will no longer be eligible.')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{k9: $author$project$Api$Data$NotAsked}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			default:
				var registrationId = msg.a;
				return {
					GZ: A2(
						$author$project$Utils$Route$navigate,
						$elm$core$Dict$empty,
						$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__EmployeeId_String__Dependent__DependentId_String__Top(
							{
								fZ: $author$project$Api$Company$id(model.afQ),
								agp: registrationId,
								agM: $author$project$Api$CompanyAccount$All$id(model.Ob)
							})),
					agZ: 0,
					aiO: model,
					aR: _List_Nil
				};
		}
	});
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$updateTableRows = F2(
	function (tableRows, _v0) {
		var registrationId = _v0.a;
		var rowToUpdate = _v0.b;
		return A2(
			$elm$core$List$map,
			function (_v1) {
				var id = _v1.a;
				var row = _v1.b;
				return _Utils_eq(id, registrationId) ? _Utils_Tuple2(registrationId, rowToUpdate) : _Utils_Tuple2(id, row);
			},
			tableRows);
	});
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('q'),
			model.akl),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('filter'),
			$author$project$Pages$Companies$CompanyId_String$Employees$Top$filterToValue(model.HM))
		]);
	return $author$project$Ports$Navigation$replaceUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString(
					$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top(
						{fZ: model.ahP}))
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.ajJ),
				A2(
					$elm$core$List$append,
					$author$project$Api$Sort$toQuery(model.alA),
					A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var companyAccounts = response.a;
					var headers = response.b;
					var intFromHeader = F2(
						function (key, headers_) {
							return A2(
								$elm$core$Maybe$withDefault,
								0,
								A2(
									$elm$core$Maybe$andThen,
									$elm$core$String$toInt,
									A2($elm$core$Dict$get, key, headers_)));
						});
					var totalAmount = A2(intFromHeader, 'x-total-amount', headers);
					var totalDueAmount = A2(intFromHeader, 'x-total-due-amount', headers);
					var employeePrioritized = function (registration) {
						return ($author$project$Api$CompanyRegistration$ForCompanyAccountAll$type_(registration) === 'employee') ? 0 : 1;
					};
					var orderedRegistrations = function (account) {
						return A2(
							$elm$core$List$sortBy,
							employeePrioritized,
							$author$project$Api$CompanyAccount$All$registrations(account));
					};
					var tableRows = A3(
						$elm$core$List$foldr,
						$elm$core$Basics$append,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (account) {
								return A2(
									$elm$core$List$map,
									function (reg) {
										return _Utils_Tuple2(
											$author$project$Api$CompanyRegistration$ForCompanyAccountAll$id(reg),
											A8($author$project$Components$Company$EmployeeRow$init, model.ZV, model.aa4, model.afQ, model.dd, model.J7, model.afq, account, reg));
									},
									orderedRegistrations(account));
							},
							companyAccounts));
					var employeeCount = A2(intFromHeader, 'x-employee-count', headers);
					var dependentCount = A2(intFromHeader, 'x-dependent-count', headers);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Od: response,
								Ql: $elm$core$Maybe$Just(dependentCount),
								zq: $elm$core$Maybe$Just(employeeCount),
								ahr: $elm$core$Maybe$Just(
									_Utils_Tuple2(totalAmount, totalDueAmount)),
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ),
								fl: tableRows
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Od: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{Od: $author$project$Api$Data$Loading, ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Companies$CompanyId_String$Employees$Top$fetchCompanyAccounts(newModel),
								$author$project$Pages$Companies$CompanyId_String$Employees$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 2:
				var registrationId = msg.a;
				var subMsg = msg.b;
				var _v2 = A2($author$project$Pages$Companies$CompanyId_String$Employees$Top$findTableRow, model.fl, registrationId);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var id = _v3.a;
					var employeeRow = _v3.b;
					var employeeRowResult = A3($author$project$Components$Company$EmployeeRow$update, model.Gv, subMsg, employeeRow);
					var refreshCmd = function () {
						var _v5 = employeeRowResult.agZ;
						if (!_v5) {
							return $elm$core$Platform$Cmd$none;
						} else {
							return $author$project$Pages$Companies$CompanyId_String$Employees$Top$fetchCompanyAccounts(model);
						}
					}();
					var _v4 = _Utils_Tuple3(employeeRowResult.aiO, employeeRowResult.GZ, employeeRowResult.aR);
					var newEmployeeRow = _v4.a;
					var employeeRowCmd = _v4.b;
					var employeeRowOutMsgs = _v4.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								fl: A2(
									$author$project$Pages$Companies$CompanyId_String$Employees$Top$updateTableRows,
									model.fl,
									_Utils_Tuple2(id, newEmployeeRow))
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									refreshCmd,
									A2(
									$elm$core$Platform$Cmd$map,
									$author$project$Pages$Companies$CompanyId_String$Employees$Top$EmployeeRowMsg(registrationId),
									employeeRowCmd)
								])),
						employeeRowOutMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var subMsg = msg.a;
				var _v6 = A2($author$project$Ui$SearchInput$update, subMsg, model.up);
				var searchInput = _v6.a;
				var searchInputCmd = _v6.b;
				var searchInputEvent = _v6.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.akl;
					}
				}();
				var _v7 = function () {
					if (_Utils_eq(q, model.akl)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								Od: $author$project$Api$Data$Loading,
								ajJ: $author$project$Api$Pagination$reset(model.ajJ),
								akl: q
							});
						return _Utils_Tuple2(
							qModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Companies$CompanyId_String$Employees$Top$fetchCompanyAccounts(qModel),
										$author$project$Pages$Companies$CompanyId_String$Employees$Top$updateUrl(qModel)
									])));
					}
				}();
				var newModel = _v7.a;
				var cmd = _v7.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{up: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Employees$Top$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
			case 4:
				var subMsg = msg.a;
				var _v9 = A2($author$project$Ui$Dropdown$update, subMsg, model.nK);
				var dropdown = _v9.a;
				var dropdownCmd = _v9.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nK: dropdown}),
					dropdownCmd,
					_List_Nil);
			case 5:
				var option = msg.a;
				var newModel = _Utils_update(
					model,
					{Od: $author$project$Api$Data$Loading, HM: option});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Companies$CompanyId_String$Employees$Top$fetchCompanyAccounts(newModel),
								$author$project$Pages$Companies$CompanyId_String$Employees$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 6:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{afq: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			default:
				var subMsg = msg.a;
				var _v10 = A3($author$project$Components$ExportCsv$update, model.Gv, subMsg, model.nD);
				var exportCsv = _v10.a;
				var subCmd = _v10.b;
				var subOutMsg = _v10.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nD: exportCsv}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Employees$Top$ExportCsvMsg, subCmd),
					subOutMsg);
		}
	});
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$EmployerOrProviderCompany = $elm$core$Basics$identity;
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$PaginationMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$companyType = function (company) {
	return A2(
		$elm$core$Maybe$map,
		function (company_) {
			var company__ = company_;
			return $author$project$Api$Company$companyType(company__);
		},
		company);
};
var $author$project$Api$CompanyRegistration$exportPath = F2(
	function (session, companyId) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				['export']),
			A2(
				$author$project$Api$Data$pathAppend,
				_List_fromArray(
					['accounts']),
				A2($author$project$Api$Company$companyPath, session, companyId)));
	});
var $author$project$Components$ExportCsv$link = A3(
	$author$project$Ui$Button$view,
	{mm: 'Export to csv'},
	_List_fromArray(
		[
			$author$project$Ui$Button$link,
			$author$project$Ui$Button$onClick($author$project$Components$ExportCsv$OpenModal),
			$author$project$Ui$Button$icon($author$project$Ui$Icon$export)
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('Export to CSV')
		]));
var $author$project$Api$CompanyAccount$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$CompanyAccount$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.HM;
				if (!_v0.$) {
					var filter = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'filter', filter)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.akl;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.ahP;
				if (!_v2.$) {
					var string = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Components$Company$EmployeeRow$deleteModal = function (model) {
	var _v0 = model.i9;
	if (!_v0.$) {
		var employee = _v0.a;
		var patientName = $author$project$Api$Patient$Min$name(
			$author$project$Api$CompanyRegistration$ForCompanyAccountAll$patient(model.Oi));
		return A2(
			$author$project$Components$HiConfirm$modal,
			$author$project$Components$Company$EmployeeRow$DeleteHiConfirmClosed(employee),
			_List_fromArray(
				[
					$author$project$Components$HiConfirm$verb('remove'),
					$author$project$Components$HiConfirm$noun(patientName),
					$author$project$Components$HiConfirm$customMessage(
					_List_fromArray(
						[
							$elm$html$Html$text('Removing this relationship will delete the patient history with this company. Are you sure you want to remove?')
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Company$EmployeeRow$viewEnrollDependentModal = function (model) {
	var _v0 = model.jj;
	if (!_v0.$) {
		var dependent = _v0.a;
		var customMessage = function () {
			var _v1 = $author$project$Api$CompanyAccount$All$plan(model.Ob);
			if ((!_v1.$) && (!_v1.a.$)) {
				var plan = _v1.a.a;
				var patient = $author$project$Api$CompanyRegistration$ForCompanyAccountAll$patient(dependent);
				var _v2 = A2($author$project$Components$Company$EmployeeRow$patientIsBelowAge, plan, patient) ? _Utils_Tuple2(
					A2(
						$elm$core$Maybe$withDefault,
						0,
						$author$project$Api$Plan$Min$minimumAge(plan)),
					'minimum') : (A2($author$project$Components$Company$EmployeeRow$patientIsAboveAge, plan, patient) ? _Utils_Tuple2(
					A2(
						$elm$core$Maybe$withDefault,
						0,
						$author$project$Api$Plan$Min$maximumAge(plan)),
					'maximum') : _Utils_Tuple2(0, ''));
				var ageLimit = _v2.a;
				var ageLimitType = _v2.b;
				return _List_fromArray(
					[
						$elm$html$Html$text(
						'The ' + (ageLimitType + (' age defined for this plan is ' + ($elm$core$String$fromInt(ageLimit) + ('. ' + ($author$project$Api$Patient$Min$name(patient) + (' is ' + (A2(
							$elm$core$Maybe$withDefault,
							'N/A',
							A2(
								$elm$core$Maybe$map,
								$elm$core$String$fromInt,
								$author$project$Api$Patient$Min$age(patient))) + ' years old. Do you want to proceed anyway?'))))))))
					]);
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$author$project$Components$HiConfirm$modal,
			$author$project$Components$Company$EmployeeRow$DependentPlanAgeWarningHiConfirmClosed(dependent),
			_List_fromArray(
				[
					$author$project$Components$HiConfirm$verb('enroll'),
					$author$project$Components$HiConfirm$noun(
					($author$project$Api$CompanyRegistration$ForCompanyAccountAll$type_(dependent) === 'spouse') ? 'adult' : $author$project$Api$CompanyRegistration$ForCompanyAccountAll$type_(dependent)),
					$author$project$Components$HiConfirm$customMessage(customMessage)
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Employee$EnrollmentModal$Save = {$: 0};
var $author$project$Ui$Modal$htmlTitle = function (contents) {
	return A2(
		$elm$html$Html$h4,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal__title')
			]),
		A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$never),
			contents));
};
var $author$project$Components$Employee$EnrollmentModal$FormUpdated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Employee$EnrollmentModal$MembershipStartDate = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Employee$EnrollmentModal$MembershipStartDateValidation = 1;
var $author$project$Components$Employee$EnrollmentModal$Plan = function (a) {
	return {$: 0, a: a};
};
var $author$project$Utils$Date$isBeforeOrEqual = F2(
	function (date, otherDate) {
		return A2($author$project$Utils$Date$isBefore, date, otherDate) || _Utils_eq(date, otherDate);
	});
var $author$project$Ui$Form$Select$dateOptions = function (dates) {
	return A2(
		$elm$core$List$map,
		function (date) {
			var dateString = $justinmimbs$date$Date$toIsoString(date);
			return A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(dateString),
				A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, date));
		},
		dates);
};
var $author$project$Utils$Date$nextTwelveMonths = function (referenceDate) {
	return A2(
		$elm$core$List$map,
		function (offset) {
			return A3($justinmimbs$date$Date$add, 1, offset, referenceDate);
		},
		A2($elm$core$List$range, 0, 11));
};
var $author$project$Components$Employee$EnrollmentModal$membershipStartDateOptions = F2(
	function (currentDate, alignToCutoff) {
		var startDate = A3(
			$justinmimbs$date$Date$add,
			1,
			-6,
			alignToCutoff(currentDate));
		return $author$project$Ui$Form$Select$dateOptions(
			$author$project$Utils$Date$nextTwelveMonths(startDate));
	});
var $author$project$Api$Employer$CompanyPlan$Shared$availableForEnrollment = function (_v0) {
	var record = _v0;
	return record.Mn;
};
var $author$project$Api$Employer$CompanyPlan$All$availableForEnrollment = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$CompanyPlan$Shared$availableForEnrollment(shared);
};
var $author$project$Api$Provider$CompanyPlan$Shared$availableForEnrollment = function (_v0) {
	var record = _v0;
	return record.Mn;
};
var $author$project$Api$Provider$CompanyPlan$One$availableForEnrollment = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyPlan$Shared$availableForEnrollment(shared);
};
var $author$project$Api$Provider$CompanyPlan$All$availableForEnrollment = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$CompanyPlan$One$availableForEnrollment(one);
};
var $author$project$Api$CompanyPlan$availableForEnrollment = function (companyPlan) {
	switch (companyPlan.$) {
		case 0:
			var companyPlan_ = companyPlan.a;
			return $author$project$Api$Provider$CompanyPlan$One$availableForEnrollment(companyPlan_);
		case 1:
			var companyPlan_ = companyPlan.a;
			return $author$project$Api$Provider$CompanyPlan$All$availableForEnrollment(companyPlan_);
		default:
			var companyPlan_ = companyPlan.a;
			return $author$project$Api$Employer$CompanyPlan$All$availableForEnrollment(companyPlan_);
	}
};
var $author$project$Components$Employee$EnrollmentModal$planOptions = function (companyPlans) {
	return A2(
		$elm$core$List$map,
		function (companyPlan) {
			var plan = $author$project$Api$CompanyPlan$plan(companyPlan);
			var label = (!$author$project$Api$CompanyPlan$availableForEnrollment(companyPlan)) ? ($author$project$Api$Plan$name(plan) + ' (Hidden for new enrollments)') : $author$project$Api$Plan$name(plan);
			return A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(
					$author$project$Api$Plan$id(plan)),
				label);
		},
		companyPlans);
};
var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountOne$patient = function (_v0) {
	var record = _v0;
	return record.YY;
};
var $author$project$Api$CompanyRegistration$ForCompanyAccountOne$patient = function (companyRegistration) {
	if (!companyRegistration.$) {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Patient$Min$Provider(
			$author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOne$patient(companyRegistration_));
	} else {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Patient$Min$Employer(
			$author$project$Api$Employer$CompanyRegistration$ForCompanyAccountOne$patient(companyRegistration_));
	}
};
var $author$project$Components$Employee$EnrollmentModal$patientsOutsideAgeRange = F2(
	function (plan, companyRegistrations) {
		var patients = A2($elm$core$List$map, $author$project$Api$CompanyRegistration$ForCompanyAccountOne$patient, companyRegistrations);
		var belowAgePatients = A2(
			$elm$core$List$filter,
			function (patient) {
				var _v1 = _Utils_Tuple2(
					plan.Xd,
					$author$project$Api$Patient$Min$age(patient));
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var minimumAge = _v1.a.a;
					var age = _v1.b.a;
					return _Utils_cmp(age, minimumAge) < 0;
				} else {
					return false;
				}
			},
			patients);
		var aboveAgePatients = A2(
			$elm$core$List$filter,
			function (patient) {
				var _v0 = _Utils_Tuple2(
					plan.WF,
					$author$project$Api$Patient$Min$age(patient));
				if ((!_v0.a.$) && (!_v0.b.$)) {
					var maximumAge = _v0.a.a;
					var age = _v0.b.a;
					return _Utils_cmp(age, maximumAge) > 0;
				} else {
					return false;
				}
			},
			patients);
		return _Utils_Tuple2(belowAgePatients, aboveAgePatients);
	});
var $author$project$Api$CompanyRegistration$ForCompanyAccountOne$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$CompanyRegistration$ForCompanyAccountOne$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$CompanyAccount$One$registrations = function (_v0) {
	var record = _v0.b;
	return record.akF;
};
var $author$project$Api$CompanyAccount$One$registrations = function (companyAccount) {
	if (!companyAccount.$) {
		var companyAccount_ = companyAccount.a;
		return A2(
			$elm$core$List$map,
			$author$project$Api$CompanyRegistration$ForCompanyAccountOne$Provider,
			$author$project$Api$Provider$CompanyAccount$One$registrations(companyAccount_));
	} else {
		var companyAccount_ = companyAccount.a;
		return A2(
			$elm$core$List$map,
			$author$project$Api$CompanyRegistration$ForCompanyAccountOne$Employer,
			$author$project$Api$Employer$CompanyAccount$One$registrations(companyAccount_));
	}
};
var $author$project$Components$Employee$EnrollmentModal$viewPatient = function (patient) {
	return A2(
		$elm$html$Html$li,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$text,
				_List_fromArray(
					[
						$author$project$Ui$Typography$phi(true)
					]),
				$author$project$Api$Patient$Min$name(patient)),
				$elm$html$Html$text(' is '),
				A2(
				$author$project$Ui$Typography$text,
				_List_fromArray(
					[
						$author$project$Ui$Typography$phi(true)
					]),
				A2(
					$elm$core$Maybe$withDefault,
					'N/A',
					A2(
						$elm$core$Maybe$map,
						$elm$core$String$fromInt,
						$author$project$Api$Patient$Min$age(patient)))),
				$elm$html$Html$text(' years old.')
			]));
};
var $author$project$Components$Employee$EnrollmentModal$viewPatientsOutsideRange = F3(
	function (range, limit, patients) {
		return A2(
			$author$project$Ui$Alert$warning,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('The '),
					$elm$html$Html$text(range),
					$elm$html$Html$text(' age defined for this plan is '),
					$elm$html$Html$text(
					A2(
						$elm$core$Maybe$withDefault,
						'N/A',
						A2($elm$core$Maybe$map, $elm$core$String$fromInt, limit))),
					$elm$html$Html$text('.'),
					A2(
					$elm$html$Html$ul,
					_List_Nil,
					A2($elm$core$List$map, $author$project$Components$Employee$EnrollmentModal$viewPatient, patients))
				]));
	});
var $author$project$Components$Employee$EnrollmentModal$viewPatientsOutsideRangeWarning = F2(
	function (plan, companyAccount) {
		var _v0 = A2(
			$author$project$Components$Employee$EnrollmentModal$patientsOutsideAgeRange,
			plan,
			$author$project$Api$CompanyAccount$One$registrations(companyAccount));
		var belowAgePatients = _v0.a;
		var aboveAgePatients = _v0.b;
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					($elm$core$List$length(belowAgePatients) >= 1) ? A3($author$project$Components$Employee$EnrollmentModal$viewPatientsOutsideRange, 'minimum', plan.Xd, belowAgePatients) : $author$project$Utils$Html$empty,
					($elm$core$List$length(aboveAgePatients) >= 1) ? A3($author$project$Components$Employee$EnrollmentModal$viewPatientsOutsideRange, 'maximum', plan.WF, aboveAgePatients) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$Employee$EnrollmentModal$viewForm = F2(
	function (form, _v0) {
		var model = _v0;
		var fields = $author$project$Utils$Form$fields(form);
		var membershipStartsAfterEligibility = function () {
			var _v2 = $author$project$Api$CompanyAccount$One$eligibilityStartDate(fields.Ob);
			if (!_v2.$) {
				var eligibilityStartDate = _v2.a;
				return A2($author$project$Utils$Date$isBeforeOrEqual, eligibilityStartDate, fields.WW);
			} else {
				return true;
			}
		}();
		var chargesOnNextInvoice = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				function (nextInvoiceDate) {
					var monthsUntilBill = A3($justinmimbs$date$Date$diff, 1, fields.WW, nextInvoiceDate) + 1;
					return A2($elm$core$Basics$max, monthsUntilBill, 0);
				},
				model.XS));
		return A2(
			$author$project$Ui$Form$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$onSubmit($author$project$Components$Employee$EnrollmentModal$Save)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('Plan'),
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							($elm$core$List$length(fields.aH) > 1) ? A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.ahP;
										},
										fields.Jb)),
									$author$project$Ui$Form$Select$onChange(
									A2($elm$core$Basics$composeL, $author$project$Components$Employee$EnrollmentModal$FormUpdated, $author$project$Components$Employee$EnrollmentModal$Plan)),
									$author$project$Ui$Form$Select$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
									$author$project$Ui$Form$Select$errors(
									A2($author$project$Utils$Form$validationErrors, 0, form))
								]),
							$author$project$Components$Employee$EnrollmentModal$planOptions(fields.aH)) : A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										A2(
											$elm$core$Maybe$map,
											function ($) {
												return $.Bq;
											},
											fields.Jb)))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('Start Membership'),
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(
									$elm$core$Maybe$Just(
										$justinmimbs$date$Date$toIsoString(fields.WW))),
									$author$project$Ui$Form$Select$onChange(
									A2(
										$elm$core$Basics$composeL,
										A2(
											$elm$core$Basics$composeL,
											A2($elm$core$Basics$composeL, $author$project$Components$Employee$EnrollmentModal$FormUpdated, $author$project$Components$Employee$EnrollmentModal$MembershipStartDate),
											$elm$core$Result$toMaybe),
										$justinmimbs$date$Date$fromIsoString)),
									$author$project$Ui$Form$Select$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
									$author$project$Ui$Form$Select$errors(
									A2($author$project$Utils$Form$validationErrors, 1, form))
								]),
							A2($author$project$Components$Employee$EnrollmentModal$membershipStartDateOptions, model.dd, model.Lp))
						])),
					(chargesOnNextInvoice <= 1) ? A2(
					$author$project$Ui$Alert$info,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('We will charge for this employee starting on the draft '),
							$elm$html$Html$text(
							A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, fields.WW)),
							$elm$html$Html$text(' invoice.')
						])) : $author$project$Utils$Html$empty,
					(!_Utils_eq(
					A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.adh;
						},
						fields.Jb),
					$elm$core$Maybe$Nothing)) ? A2(
					$author$project$Ui$Alert$warning,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('This plan includes a tobacco surcharge. Please review each member’s tobacco use to ensure pricing is accurate.')
						])) : $author$project$Utils$Html$empty,
					((chargesOnNextInvoice > 1) || (!membershipStartsAfterEligibility)) ? A2(
					$author$project$Ui$Alert$warning,
					_List_Nil,
					_List_fromArray(
						[
							(chargesOnNextInvoice > 1) ? A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('We will back bill this enrollee starting from '),
									$elm$html$Html$text(
									A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, fields.WW)),
									$elm$html$Html$text('. '),
									$elm$html$Html$text('All charges will be added to the draft '),
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										A2(
											$elm$core$Maybe$map,
											$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
											model.XS))),
									$elm$html$Html$text(' invoice.')
								])) : $author$project$Utils$Html$empty,
							(!membershipStartsAfterEligibility) ? A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('You are enrolling this person before their eligibility start date.')
								])) : $author$project$Utils$Html$empty
						])) : $author$project$Utils$Html$empty,
					function () {
					var _v1 = fields.Jb;
					if (!_v1.$) {
						var plan = _v1.a;
						return A2($author$project$Components$Employee$EnrollmentModal$viewPatientsOutsideRangeWarning, plan, fields.Ob);
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]));
	});
var $author$project$Components$Employee$EnrollmentModal$view = function (_v0) {
	var model = _v0;
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Employee$EnrollmentModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$htmlTitle(
						_List_fromArray(
							[
								function () {
								var _v1 = model.Gg;
								if (_v1 === 1) {
									return $elm$html$Html$text('Approve');
								} else {
									return $elm$html$Html$text('Enroll');
								}
							}(),
								$author$project$Utils$Html$noBreakSpace,
								A2(
								$author$project$Ui$Typography$text,
								_List_fromArray(
									[
										$author$project$Ui$Typography$phi(true)
									]),
								model.lB)
							]))
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						function () {
						var _v2 = model.SD;
						if (!_v2.$) {
							var form = _v2.a;
							return A2($author$project$Components$Employee$EnrollmentModal$viewForm, form, model);
						} else {
							return A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$textCenter]),
								_List_fromArray(
									[
										$author$project$Ui$Spinner$view(_List_Nil)
									]));
						}
					}()
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Employee$EnrollmentModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						function () {
						var verb = function () {
							var _v3 = model.Gg;
							if (!_v3) {
								return 'Enroll';
							} else {
								return 'Approve and Enroll';
							}
						}();
						return A3(
							$author$project$Ui$Button$view,
							{mm: verb + (' ' + model.lB)},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$loading(
									_Utils_eq(model.k9, $author$project$Api$Data$Loading)),
									$author$project$Ui$Button$onClick($author$project$Components$Employee$EnrollmentModal$Save),
									$author$project$Ui$Button$disabled(
									_Utils_eq(model.SD, $elm$core$Maybe$Nothing))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(verb),
									$author$project$Utils$Html$noBreakSpace,
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[
											$author$project$Ui$Typography$phi(true)
										]),
									model.lB)
								]));
					}()
					]))
			]));
};
var $author$project$Components$Company$EmployeeRow$viewEnrollModal = function (model) {
	var _v0 = model.go;
	if (!_v0.$) {
		var enrollmentModal = _v0.a;
		return A2(
			$elm$html$Html$map,
			$author$project$Components$Company$EmployeeRow$EnrollmentModalMsg,
			$author$project$Components$Employee$EnrollmentModal$view(enrollmentModal));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Company$UnenrollModal$CancellationReason = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Company$UnenrollModal$Close = {$: 0};
var $author$project$Components$Company$UnenrollModal$FormUpdated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Company$UnenrollModal$Unenroll = {$: 1};
var $author$project$Api$Employer$CancellationReason$Shared$description = function (_v0) {
	var shared = _v0;
	return shared.Qr;
};
var $author$project$Api$Employer$CancellationReason$All$description = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$CancellationReason$Shared$description(shared);
};
var $author$project$Api$CancellationReason$description = function (cancellationReason) {
	if (cancellationReason.$ === 1) {
		var cancellationReason_ = cancellationReason.a;
		return $author$project$Api$Provider$CancellationReason$All$description(cancellationReason_);
	} else {
		var cancellationReason_ = cancellationReason.a;
		return $author$project$Api$Employer$CancellationReason$All$description(cancellationReason_);
	}
};
var $author$project$Api$Employer$CancellationReason$Shared$id = function (_v0) {
	var shared = _v0;
	return shared.ahP;
};
var $author$project$Api$Employer$CancellationReason$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$CancellationReason$Shared$id(shared);
};
var $author$project$Api$CancellationReason$id = function (cancellationReason) {
	if (cancellationReason.$ === 1) {
		var cancellationReason_ = cancellationReason.a;
		return $author$project$Api$Provider$CancellationReason$All$id(cancellationReason_);
	} else {
		var cancellationReason_ = cancellationReason.a;
		return $author$project$Api$Employer$CancellationReason$All$id(cancellationReason_);
	}
};
var $author$project$Components$CancellationReason$Input$cancellationReasonOptions = function (cancellationReasons) {
	return A2(
		$elm$core$List$cons,
		A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(''),
			'Choose a reason'),
		A2(
			$elm$core$List$map,
			function (cancellationReason) {
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(
						$author$project$Api$CancellationReason$id(cancellationReason)),
					$author$project$Api$CancellationReason$description(cancellationReason));
			},
			A2(
				$elm$core$List$filter,
				function (cancellationReason) {
					return $author$project$Api$CancellationReason$description(cancellationReason) !== 'Termination by Patient';
				},
				cancellationReasons)));
};
var $author$project$Components$CancellationReason$CancellationReasonRecord$fromAll = function (cancellationReason) {
	return {
		Qr: $author$project$Api$CancellationReason$description(cancellationReason),
		ahP: $author$project$Api$CancellationReason$id(cancellationReason)
	};
};
var $author$project$Components$CancellationReason$Input$findCancellationReason = F2(
	function (cancellationReasons, id) {
		return A2(
			$elm$core$Maybe$map,
			$author$project$Components$CancellationReason$CancellationReasonRecord$fromAll,
			A2(
				$elm_community$list_extra$List$Extra$find,
				function (cancellationReason) {
					return _Utils_eq(
						$author$project$Api$CancellationReason$id(cancellationReason),
						id);
				},
				cancellationReasons));
	});
var $author$project$Components$CancellationReason$Input$view = function (options) {
	var labelWidth = A2($elm$core$Maybe$withDefault, 4, options.aii);
	var _v0 = function () {
		var _v1 = options.afq;
		if (_v1.$ === 3) {
			var cancellationReasons_ = _v1.a;
			return _Utils_Tuple2(cancellationReasons_, false);
		} else {
			return _Utils_Tuple2(_List_Nil, true);
		}
	}();
	var cancellationReasons = _v0.a;
	var cancellationReasonsLoading = _v0.b;
	var _v2 = options.aee;
	var cancellationReason = _v2.a;
	var cancellationReasonOther = _v2.b;
	var isOther = _Utils_eq(
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.Qr;
			},
			cancellationReason),
		$elm$core$Maybe$Just('Other'));
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpan(labelWidth),
						$author$project$Ui$Form$Group$inputSpan(12 - labelWidth),
						$author$project$Ui$Form$Group$label('Cancellation Reason'),
						$author$project$Ui$Form$Group$required(true)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Select$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Select$value(
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.ahP;
									},
									cancellationReason)),
								$author$project$Ui$Form$Select$onChange(
								function (id) {
									return options.ajd(
										_Utils_Tuple2(
											A2($author$project$Components$CancellationReason$Input$findCancellationReason, cancellationReasons, id),
											$elm$core$Maybe$Nothing));
								}),
								$author$project$Ui$Form$Select$invalid(
								!$elm$core$List$isEmpty(options.agX)),
								$author$project$Ui$Form$Select$errors(options.agX),
								$author$project$Ui$Form$Select$loading(cancellationReasonsLoading)
							]),
						$author$project$Components$CancellationReason$Input$cancellationReasonOptions(cancellationReasons))
					])),
				isOther ? A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpan(labelWidth),
						$author$project$Ui$Form$Group$inputSpan(12 - labelWidth),
						$author$project$Ui$Form$Group$label('Cancellation Reason Description'),
						$author$project$Ui$Form$Group$required(true)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$placeholder('Cancellation Reason Description Required'),
								$author$project$Ui$Form$Input$value(
								A2($elm$core$Maybe$withDefault, '', cancellationReasonOther)),
								$author$project$Ui$Form$Input$onInput(
								function (string) {
									return options.ajd(
										_Utils_Tuple2(
											cancellationReason,
											$author$project$Utils$String$toMaybe(string)));
								}),
								$author$project$Ui$Form$Input$invalid(
								!$elm$core$List$isEmpty(options.RO)),
								$author$project$Ui$Form$Input$errors(options.RO)
							]))
					])) : $author$project$Utils$Html$empty
			]));
};
var $author$project$Api$Employer$CompanyAccount$Meta$billFromDate = function (_v0) {
	var meta = _v0;
	return meta.kk.MD;
};
var $author$project$Api$Provider$CompanyAccount$Meta$billFromDate = function (_v0) {
	var meta = _v0;
	return meta.kk.MD;
};
var $author$project$Api$CompanyAccount$Meta$billFromDate = function (meta) {
	if (!meta.$) {
		var meta_ = meta.a;
		return $author$project$Api$Provider$CompanyAccount$Meta$billFromDate(meta_);
	} else {
		var meta_ = meta.a;
		return $author$project$Api$Employer$CompanyAccount$Meta$billFromDate(meta_);
	}
};
var $justinmimbs$date$Date$isBetween = F3(
	function (_v0, _v1, _v2) {
		var a = _v0;
		var b = _v1;
		var x = _v2;
		return A3($justinmimbs$date$Date$isBetweenInt, a, b, x);
	});
var $author$project$Api$Employer$CompanyAccount$Meta$minWithoutProration = function (_v0) {
	var meta = _v0;
	return meta.kk.sb.Xc;
};
var $author$project$Api$Provider$CompanyAccount$Meta$minWithoutProration = function (_v0) {
	var meta = _v0;
	return meta.kk.sb.Xc;
};
var $author$project$Api$CompanyAccount$Meta$minWithoutProration = function (meta) {
	if (!meta.$) {
		var meta_ = meta.a;
		return $author$project$Api$Provider$CompanyAccount$Meta$minWithoutProration(meta_);
	} else {
		var meta_ = meta.a;
		return $author$project$Api$Employer$CompanyAccount$Meta$minWithoutProration(meta_);
	}
};
var $author$project$Components$Company$UnenrollModal$mayHaveCancellableInvoice = F2(
	function (companyAccountMeta, endDate) {
		var minWithoutProration = $author$project$Api$CompanyAccount$Meta$minWithoutProration(companyAccountMeta);
		var billFromDate = $author$project$Api$CompanyAccount$Meta$billFromDate(companyAccountMeta);
		var _v0 = _Utils_Tuple3(endDate, minWithoutProration, billFromDate);
		if (((!_v0.a.$) && (!_v0.b.$)) && (!_v0.c.$)) {
			var endDate_ = _v0.a.a;
			var minWithoutProration_ = _v0.b.a;
			var billFromDate_ = _v0.c.a;
			return A3($justinmimbs$date$Date$isBetween, minWithoutProration_, billFromDate_, endDate_) && (!_Utils_eq(endDate_, billFromDate_));
		} else {
			return false;
		}
	});
var $author$project$Components$Company$UnenrollModal$viewCancellableInvoiceMessage = F2(
	function (companyAccountMeta, endDate) {
		return A2($author$project$Components$Company$UnenrollModal$mayHaveCancellableInvoice, companyAccountMeta, endDate) ? A2(
			$author$project$Ui$Form$Static$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Alert$warning,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Patient will not appear on invoices after this date.')
						]))
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Api$Employer$CompanyAccount$Meta$billingStartDate = function (_v0) {
	var meta = _v0;
	return meta.kk.MH;
};
var $author$project$Api$Provider$CompanyAccount$Meta$billingStartDate = function (_v0) {
	var meta = _v0;
	return meta.kk.MH;
};
var $author$project$Api$CompanyAccount$Meta$billingStartDate = function (meta) {
	if (!meta.$) {
		var meta_ = meta.a;
		return $author$project$Api$Provider$CompanyAccount$Meta$billingStartDate(meta_);
	} else {
		var meta_ = meta.a;
		return $author$project$Api$Employer$CompanyAccount$Meta$billingStartDate(meta_);
	}
};
var $author$project$Api$Employer$CompanyAccount$Meta$maxWithoutBilling = function (_v0) {
	var meta = _v0;
	return meta.kk.sb.WE;
};
var $author$project$Api$Provider$CompanyAccount$Meta$maxWithoutBilling = function (_v0) {
	var meta = _v0;
	return meta.kk.sb.WE;
};
var $author$project$Api$CompanyAccount$Meta$maxWithoutBilling = function (meta) {
	if (!meta.$) {
		var meta_ = meta.a;
		return $author$project$Api$Provider$CompanyAccount$Meta$maxWithoutBilling(meta_);
	} else {
		var meta_ = meta.a;
		return $author$project$Api$Employer$CompanyAccount$Meta$maxWithoutBilling(meta_);
	}
};
var $author$project$Components$Company$UnenrollModal$mayNeedProration = F2(
	function (companyAccountMeta, endDate) {
		var minWithoutProration = $author$project$Api$CompanyAccount$Meta$minWithoutProration(companyAccountMeta);
		var maxWithoutBilling = $author$project$Api$CompanyAccount$Meta$maxWithoutBilling(companyAccountMeta);
		var _v0 = _Utils_Tuple3(minWithoutProration, maxWithoutBilling, endDate);
		if (((!_v0.a.$) && (!_v0.b.$)) && (!_v0.c.$)) {
			var minWithoutProration_ = _v0.a.a;
			var maxWithoutBilling_ = _v0.b.a;
			var endDate_ = _v0.c.a;
			return A3($justinmimbs$date$Date$isBetween, maxWithoutBilling_, minWithoutProration_, endDate_) && (!_Utils_eq(endDate_, minWithoutProration_));
		} else {
			return false;
		}
	});
var $author$project$Components$Company$UnenrollModal$prorationWarning = F3(
	function (supportUrl, minWithoutProration, billedFromDate) {
		var format = function (maybeDate) {
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
					maybeDate));
		};
		return A2(
			$author$project$Ui$Form$Static$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Alert$warning,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							'We have billed this membership through ' + (format(minWithoutProration) + ('. If you’d like to credit the period of ' + (format(billedFromDate) + (' through ' + (format(minWithoutProration) + ', you can learn how to do that ')))))),
							A3(
							$author$project$Ui$Link$externalHref,
							supportUrl,
							_List_fromArray(
								[$author$project$Ui$Link$targetBlank]),
							_List_fromArray(
								[
									$elm$html$Html$text('here')
								])),
							$elm$html$Html$text('.')
						]))
				]));
	});
var $author$project$Components$Company$UnenrollModal$viewProrationWarning = F2(
	function (companyAccountMeta, endDate) {
		if (A2($author$project$Components$Company$UnenrollModal$mayNeedProration, companyAccountMeta, endDate)) {
			var minWithoutProration = $author$project$Api$CompanyAccount$Meta$minWithoutProration(companyAccountMeta);
			var billingStartDate = $author$project$Api$CompanyAccount$Meta$billingStartDate(companyAccountMeta);
			var billedFromDate = A2(
				$elm_community$list_extra$List$Extra$maximumBy,
				$justinmimbs$date$Date$toRataDie,
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[endDate, billingStartDate])));
			return A3($author$project$Components$Company$UnenrollModal$prorationWarning, 'https://support.hint.com/en/articles/4622730-adding-an-employer-credit-or-one-off-charge', minWithoutProration, billedFromDate);
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$Company$UnenrollModal$view = F2(
	function (cancellationReasons, model) {
		var minDate = A2($elm$core$Maybe$withDefault, model.dd, model.Bh);
		var isDisabled = function (date) {
			return !(!A2($justinmimbs$date$Date$compare, minDate, date));
		};
		var fields = $author$project$Utils$Form$fields(model.SD);
		var accountMeta = $author$project$Api$CompanyAccount$All$meta(model.Ob);
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$Company$UnenrollModal$Close,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('Unenroll Employee')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$onSubmit($author$project$Components$Company$UnenrollModal$Unenroll)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$label('End Date'),
											$author$project$Ui$Form$Group$labelSpan(4),
											$author$project$Ui$Form$Group$inputSpan(4),
											$author$project$Ui$Form$Group$required(true)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$map,
											$author$project$Components$Company$UnenrollModal$EndDateInputMsg,
											A2(
												$author$project$Components$DateInput$view,
												_List_fromArray(
													[
														$author$project$Components$DateInput$value(fields.akO),
														$author$project$Components$DateInput$invalid(
														A2($author$project$Utils$Form$hasValidationErrors, 2, model.SD)),
														$author$project$Components$DateInput$errors(
														A2($author$project$Utils$Form$validationErrors, 2, model.SD)),
														$author$project$Components$DateInput$disabledPickerDates(isDisabled)
													]),
												model.sd)),
											A2($author$project$Components$Company$UnenrollModal$viewCancellableInvoiceMessage, accountMeta, fields.akO),
											A2($author$project$Components$Company$UnenrollModal$viewProrationWarning, accountMeta, fields.akO)
										])),
									$author$project$Components$CancellationReason$Input$view(
									{
										afq: cancellationReasons,
										agX: A2($author$project$Utils$Form$validationErrors, 0, model.SD),
										RO: A2($author$project$Utils$Form$validationErrors, 1, model.SD),
										aii: $elm$core$Maybe$Nothing,
										ajd: A2($elm$core$Basics$composeL, $author$project$Components$Company$UnenrollModal$FormUpdated, $author$project$Components$Company$UnenrollModal$CancellationReason),
										aee: _Utils_Tuple2(fields.afo, fields.afp)
									})
								]))
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Cancel and close modal'},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$onClick($author$project$Components$Company$UnenrollModal$Close)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{mm: 'End employee enrollment'},
							_List_fromArray(
								[
									$author$project$Ui$Button$danger,
									$author$project$Ui$Button$onClick($author$project$Components$Company$UnenrollModal$Unenroll),
									$author$project$Ui$Button$disabled(
									$author$project$Utils$Form$hasAnyValidationError(model.SD))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('End')
								]))
						]))
				]));
	});
var $author$project$Components$Company$EmployeeRow$viewUnenrollModal = function (model) {
	var _v0 = model.h1;
	if (!_v0.$) {
		var unenrollModal = _v0.a;
		return A2(
			$elm$html$Html$map,
			$author$project$Components$Company$EmployeeRow$UnenrollModalMsg,
			A2($author$project$Components$Company$UnenrollModal$view, model.afq, unenrollModal));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Company$EmployeeRow$modal = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Components$Company$EmployeeRow$deleteModal(model),
				$author$project$Components$Company$EmployeeRow$viewUnenrollModal(model),
				$author$project$Components$Company$EmployeeRow$viewEnrollModal(model),
				$author$project$Components$Company$EmployeeRow$viewEnrollDependentModal(model)
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$viewEmployeesStats = F3(
	function (companyType_, employeeCount, dependentCount) {
		var totalCount = A2($elm$core$Maybe$withDefault, 0, employeeCount) + A2($elm$core$Maybe$withDefault, 0, dependentCount);
		return A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanMd(2)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$title,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2($author$project$Formatters$String$affiliateMember, 'Employees', companyType_) + ': ')
										])),
									A2(
									$author$project$Ui$Typography$title,
									_List_fromArray(
										[$author$project$Ui$Typography$bold]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'',
												A2($elm$core$Maybe$map, $elm$core$String$fromInt, employeeCount)))
										]))
								]))
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanMd(2)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$title,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Dependents: ')
										])),
									A2(
									$author$project$Ui$Typography$title,
									_List_fromArray(
										[$author$project$Ui$Typography$bold]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'',
												A2($elm$core$Maybe$map, $elm$core$String$fromInt, dependentCount)))
										]))
								]))
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanMd(2)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$title,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Total: ')
										])),
									A2(
									$author$project$Ui$Typography$title,
									_List_fromArray(
										[$author$project$Ui$Typography$bold]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$core$String$fromInt(totalCount))
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$viewNewEmployeeDependentButton = function (company) {
	return (!(!$author$project$Api$Company$companyType(company))) ? A3(
		$author$project$Ui$Link$route,
		$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Create(
			{
				fZ: $author$project$Api$Company$id(company)
			}),
		_List_fromArray(
			[
				$author$project$Ui$Link$buttonDefault,
				$author$project$Ui$Link$icon($author$project$Ui$Icon$add)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('New Employee or Dependent')
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$FilterSelected = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$filterToLabel = function (filter) {
	switch (filter) {
		case 0:
			return 'All Status';
		case 1:
			return 'Needs Approval';
		case 2:
			return 'Denied Approval';
		case 3:
			return 'Enrolled';
		case 4:
			return 'Unenrolled';
		case 5:
			return 'Eligible';
		default:
			return 'Not Eligible';
	}
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$filterItems = function (currentFilter) {
	var filterToItem = function (filter) {
		return A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(currentFilter, filter)),
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Pages$Companies$CompanyId_String$Employees$Top$FilterSelected(filter))
				]),
			$elm$html$Html$text(
				$author$project$Pages$Companies$CompanyId_String$Employees$Top$filterToLabel(filter)));
	};
	return A2(
		$elm$core$List$cons,
		filterToItem(0),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$Dropdown$separator,
			A2(
				$elm$core$List$map,
				filterToItem,
				_List_fromArray(
					[1, 2, 3, 4, 5, 6]))));
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$viewSearchAndFilters = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$mb2, $author$project$Ui$Element$mt2]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(8),
								$author$project$Ui$Grid$spanMd(6)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Companies$CompanyId_String$Employees$Top$SearchInputMsg,
								A2($author$project$Ui$SearchInput$view, _List_Nil, model.up))
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(4),
								$author$project$Ui$Grid$spanMd(2)
							]),
						_List_fromArray(
							[
								A4(
								$author$project$Ui$Dropdown$viewSelect,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Pages$Companies$CompanyId_String$Employees$Top$filterToLabel(model.HM))
									]),
								$author$project$Pages$Companies$CompanyId_String$Employees$Top$filterItems(model.HM),
								model.nK)
							]))
					]))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$usesEmployeeDivisions = function (company) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (company_) {
				var company__ = company_;
				return $author$project$Api$Company$usesEmployeeDivisions(company__);
			},
			company));
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$columns = function (model) {
	return $elm$core$List$concat(
		_List_fromArray(
			[
				_List_fromArray(
				[
					A3($author$project$Api$Column$init, 'name', true, 'Name'),
					A3($author$project$Api$Column$init, 'type', true, 'Type'),
					A3($author$project$Api$Column$init, 'email', false, 'Email'),
					A3($author$project$Api$Column$init, 'date_of_birth', true, 'Date of Birth'),
					A3($author$project$Api$Column$init, 'plan', true, 'Plan'),
					A3($author$project$Api$Column$init, 'status', true, 'Status')
				]),
				$author$project$Pages$Companies$CompanyId_String$Employees$Top$usesEmployeeDivisions(
				$elm$core$Maybe$Just(model.afQ)) ? _List_fromArray(
				[
					A3($author$project$Api$Column$init, 'divisions', true, 'Divisions')
				]) : _List_Nil,
				_List_fromArray(
				[
					A3($author$project$Api$Column$init, 'actions', false, 'Actions')
				])
			]));
};
var $author$project$Ui$Table$Attribute = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Table$CellActive = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Table$Display = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Table$Hidden = function (a) {
	return {$: 6, a: a};
};
var $author$project$Ui$Table$LimitWidth = {$: 7};
var $author$project$Ui$Table$Nested = {$: 9};
var $author$project$Ui$Table$NoWrap = {$: 10};
var $author$project$Ui$Table$Rowspan = function (a) {
	return {$: 12, a: a};
};
var $author$project$Ui$Table$VerticalAlignedBottom = {$: 15};
var $author$project$Ui$Table$VerticalCenteredCell = {$: 16};
var $author$project$Ui$Table$mapCellOption = F2(
	function (f, cellOption) {
		switch (cellOption.$) {
			case 0:
				var attributes = cellOption.a;
				return $author$project$Ui$Table$Attribute(attributes);
			case 1:
				var value = cellOption.a;
				return $author$project$Ui$Table$CellActive(value);
			case 2:
				var alignment = cellOption.a;
				return $author$project$Ui$Table$CellAlignment(alignment);
			case 3:
				var _int = cellOption.a;
				return $author$project$Ui$Table$Colspan(_int);
			case 4:
				var display = cellOption.a;
				return $author$project$Ui$Table$Display(display);
			case 5:
				var screenSize = cellOption.a;
				var _int = cellOption.b;
				return A2($author$project$Ui$Table$Grid, screenSize, _int);
			case 6:
				var screenSize = cellOption.a;
				return $author$project$Ui$Table$Hidden(screenSize);
			case 7:
				return $author$project$Ui$Table$LimitWidth;
			case 8:
				var string = cellOption.a;
				return $author$project$Ui$Table$MinWidth(string);
			case 9:
				return $author$project$Ui$Table$Nested;
			case 10:
				return $author$project$Ui$Table$NoWrap;
			case 12:
				var _int = cellOption.a;
				return $author$project$Ui$Table$Rowspan(_int);
			case 11:
				var msg = cellOption.a;
				return $author$project$Ui$Table$OnClick(
					f(msg));
			case 13:
				var bool = cellOption.a;
				return $author$project$Ui$Table$Sortable(bool);
			case 14:
				var direction = cellOption.a;
				return $author$project$Ui$Table$SortDirection(direction);
			case 15:
				return $author$project$Ui$Table$VerticalAlignedBottom;
			default:
				return $author$project$Ui$Table$VerticalCenteredCell;
		}
	});
var $author$project$Ui$Table$mapCell = F2(
	function (f, _v0) {
		var _v1 = _v0;
		var options = _v1.a;
		var contents = _v1.b;
		return _Utils_Tuple2(
			A2(
				$elm$core$List$map,
				$author$project$Ui$Table$mapCellOption(f),
				options),
			A2(
				$elm$core$List$map,
				$elm$html$Html$map(f),
				contents));
	});
var $author$project$Ui$Table$mapRowOption = F2(
	function (_v0, rowOption) {
		if (!rowOption.$) {
			var style = rowOption.a;
			return $author$project$Ui$Table$Styled(style);
		} else {
			return $author$project$Ui$Table$NoBorder;
		}
	});
var $author$project$Ui$Table$mapRow = F2(
	function (f, row_) {
		if (row_.$ === 1) {
			var _v1 = row_.a;
			var options = _v1.a;
			var cells = _v1.b;
			return $author$project$Ui$Table$Row(
				_Utils_Tuple2(
					A2(
						$elm$core$List$map,
						$author$project$Ui$Table$mapRowOption(f),
						options),
					A2(
						$elm$core$List$map,
						$author$project$Ui$Table$mapCell(f),
						cells)));
		} else {
			return $author$project$Ui$Table$None;
		}
	});
var $author$project$Components$Company$EmployeeRow$EmployerOrProviderCompany = $elm$core$Basics$identity;
var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$status = function (_v0) {
	var record = _v0.b;
	return record.alH;
};
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$status = function (_v0) {
	var record = _v0.b;
	return record.alH;
};
var $author$project$Api$CompanyRegistration$ForCompanyAccountAll$status = function (companyRegistration) {
	if (!companyRegistration.$) {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$status(companyRegistration_);
	} else {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$status(companyRegistration_);
	}
};
var $author$project$Components$Company$EmployeeRow$employeeOrDependentStatus = function (employee) {
	if (!employee.$) {
		var employee_ = employee.a;
		return $author$project$Api$CompanyAccount$All$status(employee_);
	} else {
		var employee_ = employee.a;
		return $author$project$Api$CompanyRegistration$ForCompanyAccountAll$status(employee_);
	}
};
var $author$project$Components$Company$EmployeeRow$endingStatus = F3(
	function (endDate, currentDate, endDateString) {
		if (!endDate.$) {
			var date = endDate.a;
			return ((A2($justinmimbs$date$Date$compare, currentDate, date) === 2) || (A2($justinmimbs$date$Date$compare, currentDate, date) === 1)) ? ('Ended on ' + endDateString) : ('Member through ' + endDateString);
		} else {
			return 'Eligible';
		}
	});
var $author$project$Api$Employer$CompanyAccount$All$membershipEndDate = function (_v0) {
	var record = _v0.b;
	return record.WQ;
};
var $author$project$Api$Provider$CompanyAccount$All$membershipEndDate = function (_v0) {
	var record = _v0.b;
	return record.WQ;
};
var $author$project$Api$CompanyAccount$All$membershipEndDate = function (companyAccount) {
	if (!companyAccount.$) {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$Provider$CompanyAccount$All$membershipEndDate(companyAccount_);
	} else {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$Employer$CompanyAccount$All$membershipEndDate(companyAccount_);
	}
};
var $author$project$Api$Employer$CompanyRegistration$Shared$membershipEndDate = function (_v0) {
	var record = _v0;
	return record.WQ;
};
var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$membershipEndDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$CompanyRegistration$Shared$membershipEndDate(shared);
};
var $author$project$Api$Provider$CompanyRegistration$Shared$membershipEndDate = function (_v0) {
	var record = _v0;
	return record.WQ;
};
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$membershipEndDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyRegistration$Shared$membershipEndDate(shared);
};
var $author$project$Api$CompanyRegistration$ForCompanyAccountAll$membershipEndDate = function (companyRegistration) {
	if (!companyRegistration.$) {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$membershipEndDate(companyRegistration_);
	} else {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$membershipEndDate(companyRegistration_);
	}
};
var $author$project$Components$Company$EmployeeRow$accountStatus = F2(
	function (currentDate, employee) {
		var status = $author$project$Components$Company$EmployeeRow$employeeOrDependentStatus(employee);
		var membershipEndDate = function () {
			if (!employee.$) {
				var employee_ = employee.a;
				return $author$project$Api$CompanyAccount$All$membershipEndDate(employee_);
			} else {
				var employee_ = employee.a;
				return $author$project$Api$CompanyRegistration$ForCompanyAccountAll$membershipEndDate(employee_);
			}
		}();
		var membershipEndDateString = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
				membershipEndDate));
		switch (status) {
			case 'ending':
				return A3($author$project$Components$Company$EmployeeRow$endingStatus, membershipEndDate, currentDate, membershipEndDateString);
			case 'needs_approval':
				return 'Needs Approval';
			case 'eligible':
				return A3($author$project$Components$Company$EmployeeRow$endingStatus, membershipEndDate, currentDate, membershipEndDateString);
			case 'enrolled':
				var membershipStartDateString = function () {
					if (!employee.$) {
						var employee_ = employee.a;
						return A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$map,
								$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
								$author$project$Api$CompanyAccount$All$membershipStartDate(employee_)));
					} else {
						var employee_ = employee.a;
						return A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$map,
								$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
								$author$project$Api$CompanyRegistration$ForCompanyAccountAll$membershipStartDate(employee_)));
					}
				}();
				return 'Enrolled' + (' as of ' + membershipStartDateString);
			default:
				return $author$project$Formatters$String$humanize(status);
		}
	});
var $author$project$Api$EmployeeDivision$Shared$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$EmployeeDivision$Shared$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$CompanyAccount$All$division = function (_v0) {
	var record = _v0.b;
	return record.QO;
};
var $author$project$Api$Provider$CompanyAccount$All$division = function (_v0) {
	var record = _v0.b;
	return record.QO;
};
var $author$project$Api$CompanyAccount$All$division = function (companyAccount) {
	if (!companyAccount.$) {
		var companyAccount_ = companyAccount.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$EmployeeDivision$Shared$Provider,
			$author$project$Api$Provider$CompanyAccount$All$division(companyAccount_));
	} else {
		var companyAccount_ = companyAccount.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$EmployeeDivision$Shared$Employer,
			$author$project$Api$Employer$CompanyAccount$All$division(companyAccount_));
	}
};
var $author$project$Api$Employer$Patient$Min$dob = function (_v0) {
	var record = _v0;
	return record.agC;
};
var $author$project$Api$Provider$Patient$Min$dob = function (_v0) {
	var min = _v0;
	return min.agC;
};
var $author$project$Api$Patient$Min$dob = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$Min$dob(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$Min$dob(patient_);
	}
};
var $author$project$Api$Employer$CompanyAccount$Shared$eligibilityEndDate = function (_v0) {
	var record = _v0;
	return record.Rf;
};
var $author$project$Api$Employer$CompanyAccount$All$eligibilityEndDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$CompanyAccount$Shared$eligibilityEndDate(shared);
};
var $author$project$Api$Provider$CompanyAccount$Shared$eligibilityEndDate = function (_v0) {
	var record = _v0.b;
	return record.Rf;
};
var $author$project$Api$Provider$CompanyAccount$All$eligibilityEndDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyAccount$Shared$eligibilityEndDate(shared);
};
var $author$project$Api$CompanyAccount$All$eligibilityEndDate = function (companyAccount) {
	if (!companyAccount.$) {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$Provider$CompanyAccount$All$eligibilityEndDate(companyAccount_);
	} else {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$Employer$CompanyAccount$All$eligibilityEndDate(companyAccount_);
	}
};
var $author$project$Api$Employer$CompanyRegistration$Shared$eligibilityEndDate = function (_v0) {
	var record = _v0;
	return record.Rf;
};
var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$eligibilityEndDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$CompanyRegistration$Shared$eligibilityEndDate(shared);
};
var $author$project$Api$Provider$CompanyRegistration$Shared$eligibilityEndDate = function (_v0) {
	var record = _v0;
	return record.Rf;
};
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$eligibilityEndDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyRegistration$Shared$eligibilityEndDate(shared);
};
var $author$project$Api$CompanyRegistration$ForCompanyAccountAll$eligibilityEndDate = function (companyRegistration) {
	if (!companyRegistration.$) {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$eligibilityEndDate(companyRegistration_);
	} else {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$eligibilityEndDate(companyRegistration_);
	}
};
var $author$project$Api$Employer$CompanyAccount$All$eligibilityStartDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$CompanyAccount$Shared$eligibilityStartDate(shared);
};
var $author$project$Api$Provider$CompanyAccount$All$eligibilityStartDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyAccount$Shared$eligibilityStartDate(shared);
};
var $author$project$Api$CompanyAccount$All$eligibilityStartDate = function (companyAccount) {
	if (!companyAccount.$) {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$Provider$CompanyAccount$All$eligibilityStartDate(companyAccount_);
	} else {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$Employer$CompanyAccount$All$eligibilityStartDate(companyAccount_);
	}
};
var $author$project$Api$Employer$CompanyRegistration$Shared$eligibilityStartDate = function (_v0) {
	var record = _v0;
	return record.Rg;
};
var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$eligibilityStartDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$CompanyRegistration$Shared$eligibilityStartDate(shared);
};
var $author$project$Api$Provider$CompanyRegistration$Shared$eligibilityStartDate = function (_v0) {
	var record = _v0;
	return record.Rg;
};
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$eligibilityStartDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyRegistration$Shared$eligibilityStartDate(shared);
};
var $author$project$Api$CompanyRegistration$ForCompanyAccountAll$eligibilityStartDate = function (companyRegistration) {
	if (!companyRegistration.$) {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$eligibilityStartDate(companyRegistration_);
	} else {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$eligibilityStartDate(companyRegistration_);
	}
};
var $author$project$Components$Company$EmployeeRow$eligibleFromAndOrTo = function (employee) {
	var eligibilityStartDate = function () {
		if (!employee.$) {
			var employee_ = employee.a;
			return $author$project$Api$CompanyAccount$All$eligibilityStartDate(employee_);
		} else {
			var employee_ = employee.a;
			return $author$project$Api$CompanyRegistration$ForCompanyAccountAll$eligibilityStartDate(employee_);
		}
	}();
	var eligibilityEndDate = function () {
		if (!employee.$) {
			var employee_ = employee.a;
			return $author$project$Api$CompanyAccount$All$eligibilityEndDate(employee_);
		} else {
			var employee_ = employee.a;
			return $author$project$Api$CompanyRegistration$ForCompanyAccountAll$eligibilityEndDate(employee_);
		}
	}();
	var _v0 = _Utils_Tuple2(eligibilityStartDate, eligibilityEndDate);
	if (!_v0.a.$) {
		if (_v0.b.$ === 1) {
			var eligibilityDate = _v0.a.a;
			var _v1 = _v0.b;
			return 'Eligible from ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, eligibilityDate);
		} else {
			var eligibilityDate = _v0.a.a;
			var eligibilityEndDate_ = _v0.b.a;
			return 'Eligible from ' + (A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, eligibilityDate) + (' to ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, eligibilityEndDate_)));
		}
	} else {
		return '';
	}
};
var $author$project$Components$Company$EmployeeRow$eligibilityStatus = F2(
	function (model, employee) {
		var eligibilityEndDate = function () {
			if (!employee.$) {
				var employee_ = employee.a;
				return $author$project$Api$CompanyAccount$All$eligibilityEndDate(employee_);
			} else {
				var employee_ = employee.a;
				return $author$project$Api$CompanyRegistration$ForCompanyAccountAll$eligibilityEndDate(employee_);
			}
		}();
		if (!eligibilityEndDate.$) {
			var eligibilityEndDate_ = eligibilityEndDate.a;
			return A2($author$project$Utils$Date$isBefore, eligibilityEndDate_, model.dd) ? ('Ineligible since ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, eligibilityEndDate_)) : $author$project$Components$Company$EmployeeRow$eligibleFromAndOrTo(employee);
		} else {
			return $author$project$Components$Company$EmployeeRow$eligibleFromAndOrTo(employee);
		}
	});
var $author$project$Api$Employer$Patient$Min$email = function (_v0) {
	var record = _v0;
	return record.Rj;
};
var $author$project$Api$Provider$Patient$Min$email = function (_v0) {
	var min = _v0;
	return min.Rj;
};
var $author$project$Api$Patient$Min$email = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$Min$email(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$Min$email(patient_);
	}
};
var $author$project$Components$Company$EmployeeRow$Dependent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Company$EmployeeRow$Employee = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Company$EmployeeRow$employeeOrDependent = function (model) {
	var _v0 = $author$project$Api$CompanyRegistration$ForCompanyAccountAll$type_(model.Oi);
	if (_v0 === 'employee') {
		return $author$project$Components$Company$EmployeeRow$Employee(model.Ob);
	} else {
		return $author$project$Components$Company$EmployeeRow$Dependent(model.Oi);
	}
};
var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$externalId = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$CompanyRegistration$Shared$externalId(shared);
};
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$externalId = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyRegistration$Shared$externalId(shared);
};
var $author$project$Api$CompanyRegistration$ForCompanyAccountAll$externalId = function (companyRegistration) {
	if (!companyRegistration.$) {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$externalId(companyRegistration_);
	} else {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$externalId(companyRegistration_);
	}
};
var $author$project$Components$Company$EmployeeRow$isNetwork = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return !$author$project$Api$Company$companyType(company_);
	} else {
		return false;
	}
};
var $author$project$Api$Employer$CompanyRegistration$Shared$isSubscriber = function (_v0) {
	var record = _v0;
	return record.Vd;
};
var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$isSubscriber = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$CompanyRegistration$Shared$isSubscriber(shared);
};
var $author$project$Api$Provider$CompanyRegistration$Shared$isSubscriber = function (_v0) {
	var record = _v0;
	return record.Vd;
};
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$isSubscriber = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyRegistration$Shared$isSubscriber(shared);
};
var $author$project$Api$CompanyRegistration$ForCompanyAccountAll$isSubscriber = function (companyRegistration) {
	if (!companyRegistration.$) {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$isSubscriber(companyRegistration_);
	} else {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$isSubscriber(companyRegistration_);
	}
};
var $author$project$Api$EmployeeDivision$Shared$name = function (employeeDivision) {
	if (!employeeDivision.$) {
		var employeeDivision_ = employeeDivision.a;
		return $author$project$Api$Provider$EmployeeDivision$Shared$name(employeeDivision_);
	} else {
		var employeeDivision_ = employeeDivision.a;
		return $author$project$Api$Employer$EmployeeDivision$Shared$name(employeeDivision_);
	}
};
var $author$project$Ui$Table$nested = $author$project$Ui$Table$Nested;
var $author$project$Components$Company$EmployeeRow$usesEmployeeDivisions = function (company) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (company_) {
				var company__ = company_;
				return $author$project$Api$Company$usesEmployeeDivisions(company__);
			},
			company));
};
var $author$project$Components$Company$EmployeeRow$Approve = 0;
var $author$project$Components$Company$EmployeeRow$ApproveEmployee = {$: 11};
var $author$project$Components$Company$EmployeeRow$DeleteEmployeeOrDependent = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Company$EmployeeRow$Deny = 1;
var $author$project$Components$Company$EmployeeRow$DenyEmployee = {$: 13};
var $author$project$Components$Company$EmployeeRow$DependentMeta = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Company$EmployeeRow$EditEmployeeOrDependent = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Company$EmployeeRow$EmployeeMeta = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Company$EmployeeRow$Enroll = 2;
var $author$project$Components$Company$EmployeeRow$EnrollEmployeeOrDependent = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Company$EmployeeRow$MadeEmployeeOrDependentEligible = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Company$EmployeeRow$MadeEmployeeOrDependentIneligible = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Company$EmployeeRow$MakeEligible = 5;
var $author$project$Components$Company$EmployeeRow$MakeIneligible = 4;
var $author$project$Components$Company$EmployeeRow$Remove = 6;
var $author$project$Components$Company$EmployeeRow$Unenroll = 3;
var $author$project$Components$Company$EmployeeRow$UnenrollEmployeeOrDependent = function (a) {
	return {$: 15, a: a};
};
var $author$project$Ui$Dropdown$ButtonSize = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Dropdown$Sm = 0;
var $author$project$Ui$Dropdown$buttonSm = $author$project$Ui$Dropdown$ButtonSize(0);
var $author$project$Api$Employer$CompanyAccount$Meta$canEnrollAction = function (_v0) {
	var meta = _v0;
	return meta.vy.M8;
};
var $author$project$Api$Provider$CompanyAccount$Meta$canEnrollAction = function (_v0) {
	var record = _v0;
	return record.vy.M8;
};
var $author$project$Api$CompanyAccount$Meta$canEnrollAction = function (meta) {
	if (!meta.$) {
		var meta_ = meta.a;
		return $author$project$Api$Provider$CompanyAccount$Meta$canEnrollAction(meta_);
	} else {
		var meta_ = meta.a;
		return $author$project$Api$Employer$CompanyAccount$Meta$canEnrollAction(meta_);
	}
};
var $author$project$Api$Employer$CompanyRegistration$Meta$canEnrollAction = function (_v0) {
	var meta = _v0;
	return meta.vy.M8;
};
var $author$project$Api$Provider$Meta$CompanyRegistration$enrollAction = function (_v0) {
	var record = _v0;
	return record.vy.Rz;
};
var $author$project$Api$CompanyRegistration$Meta$canEnrollAction = function (meta) {
	if (!meta.$) {
		var meta_ = meta.a;
		return $author$project$Api$Provider$Meta$CompanyRegistration$enrollAction(meta_);
	} else {
		var meta_ = meta.a;
		return $author$project$Api$Employer$CompanyRegistration$Meta$canEnrollAction(meta_);
	}
};
var $author$project$Api$Employer$CompanyAccount$Shared$isEligible = function (_v0) {
	var record = _v0;
	return record.UO;
};
var $author$project$Api$Employer$CompanyAccount$All$isEligible = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$CompanyAccount$Shared$isEligible(shared);
};
var $author$project$Api$Provider$CompanyAccount$Shared$isEligible = function (_v0) {
	var record = _v0.b;
	return record.UO;
};
var $author$project$Api$Provider$CompanyAccount$All$isEligible = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyAccount$Shared$isEligible(shared);
};
var $author$project$Api$CompanyAccount$All$isEligible = function (companyAccount) {
	if (!companyAccount.$) {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$Provider$CompanyAccount$All$isEligible(companyAccount_);
	} else {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$Employer$CompanyAccount$All$isEligible(companyAccount_);
	}
};
var $author$project$Api$Employer$CompanyAccount$Meta$isEligibleAction = function (_v0) {
	var meta = _v0;
	return meta.vy.UO;
};
var $author$project$Api$Provider$CompanyAccount$Meta$isEligibleAction = function (_v0) {
	var meta = _v0;
	return meta.vy.UO;
};
var $author$project$Api$CompanyAccount$Meta$isEligibleAction = function (meta) {
	if (!meta.$) {
		var meta_ = meta.a;
		return $author$project$Api$Provider$CompanyAccount$Meta$isEligibleAction(meta_);
	} else {
		var meta_ = meta.a;
		return $author$project$Api$Employer$CompanyAccount$Meta$isEligibleAction(meta_);
	}
};
var $author$project$Api$Employer$CompanyRegistration$Meta$isEligibleAction = function (_v0) {
	var meta = _v0;
	return meta.vy.UO;
};
var $author$project$Api$Provider$Meta$CompanyRegistration$isEligibleAction = function (_v0) {
	var meta = _v0;
	return meta.vy.UO;
};
var $author$project$Api$CompanyRegistration$Meta$isEligibleAction = function (meta) {
	if (!meta.$) {
		var meta_ = meta.a;
		return $author$project$Api$Provider$Meta$CompanyRegistration$isEligibleAction(meta_);
	} else {
		var meta_ = meta.a;
		return $author$project$Api$Employer$CompanyRegistration$Meta$isEligibleAction(meta_);
	}
};
var $author$project$Api$Employer$CompanyAccount$Meta$needsApprovalAction = function (_v0) {
	var meta = _v0;
	return meta.vy.Xx;
};
var $author$project$Api$Provider$CompanyAccount$Meta$needsApprovalAction = function (_v0) {
	var meta = _v0;
	return meta.vy.Xx;
};
var $author$project$Api$CompanyAccount$Meta$needsApprovalAction = function (meta) {
	if (!meta.$) {
		var meta_ = meta.a;
		return $author$project$Api$Provider$CompanyAccount$Meta$needsApprovalAction(meta_);
	} else {
		var meta_ = meta.a;
		return $author$project$Api$Employer$CompanyAccount$Meta$needsApprovalAction(meta_);
	}
};
var $author$project$Components$Company$EmployeeRow$canTakeAction = F4(
	function (actions, employee, meta, model) {
		var status = $author$project$Components$Company$EmployeeRow$employeeOrDependentStatus(employee);
		switch (actions) {
			case 0:
				if (!meta.$) {
					var meta_ = meta.a;
					return $author$project$Api$CompanyAccount$Meta$needsApprovalAction(meta_) || ((status === 'needs_approval') || (status === 'denied'));
				} else {
					return false;
				}
			case 1:
				if (!employee.$) {
					return status === 'needs_approval';
				} else {
					return false;
				}
			case 2:
				var enrollMeta = function () {
					if (!meta.$) {
						var meta_ = meta.a;
						return $author$project$Api$CompanyAccount$Meta$canEnrollAction(meta_);
					} else {
						var meta_ = meta.a;
						return $author$project$Api$CompanyRegistration$Meta$canEnrollAction(meta_);
					}
				}();
				return enrollMeta || (enrollMeta && ((status === 'eligible') && (!$author$project$Components$Company$EmployeeRow$isNetwork(
					$elm$core$Maybe$Just(model.afQ)))));
			case 3:
				return (status === 'enrolled') && (!$author$project$Components$Company$EmployeeRow$isNetwork(
					$elm$core$Maybe$Just(model.afQ)));
			case 4:
				return status === 'eligible';
			case 5:
				if (!meta.$) {
					var meta_ = meta.a;
					return $author$project$Api$CompanyAccount$Meta$isEligibleAction(meta_);
				} else {
					var meta_ = meta.a;
					return $author$project$Api$CompanyRegistration$Meta$isEligibleAction(meta_);
				}
			default:
				if (!employee.$) {
					var employee_ = employee.a;
					return !$author$project$Api$CompanyAccount$All$isEligible(employee_);
				} else {
					return status === 'ineligible';
				}
		}
	});
var $author$project$Api$CompanyRegistration$Meta$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$CompanyRegistration$Meta$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$meta = function (_v0) {
	var record = _v0.b;
	return record.W4;
};
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$meta = function (_v0) {
	var record = _v0.b;
	return record.W4;
};
var $author$project$Api$CompanyRegistration$ForCompanyAccountAll$meta = function (companyRegistration) {
	if (!companyRegistration.$) {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$CompanyRegistration$Meta$Provider(
			$author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$meta(companyRegistration_));
	} else {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$CompanyRegistration$Meta$Employer(
			$author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$meta(companyRegistration_));
	}
};
var $author$project$Components$Company$EmployeeRow$viewActionsDropdown = function (model) {
	var canManageAccount = !$author$project$Components$Company$EmployeeRow$isNetwork(
		$elm$core$Maybe$Just(model.afQ));
	return _List_fromArray(
		[
			function () {
			if (canManageAccount) {
				var registrationId = $author$project$Api$CompanyRegistration$ForCompanyAccountAll$id(model.Oi);
				var employeeOrDependentMeta = function () {
					var _v0 = $author$project$Api$CompanyRegistration$ForCompanyAccountAll$type_(model.Oi);
					if (_v0 === 'employee') {
						return $author$project$Components$Company$EmployeeRow$EmployeeMeta(
							$author$project$Api$CompanyAccount$All$meta(model.Ob));
					} else {
						return $author$project$Components$Company$EmployeeRow$DependentMeta(
							$author$project$Api$CompanyRegistration$ForCompanyAccountAll$meta(model.Oi));
					}
				}();
				var items = A2(
					$elm$core$List$cons,
					A2(
						$author$project$Ui$Dropdown$item,
						_List_fromArray(
							[
								$author$project$Ui$Dropdown$onSelect(
								$author$project$Components$Company$EmployeeRow$EditEmployeeOrDependent(registrationId))
							]),
						$elm$html$Html$text('Edit')),
					_Utils_ap(
						A4(
							$author$project$Components$Company$EmployeeRow$canTakeAction,
							0,
							$author$project$Components$Company$EmployeeRow$employeeOrDependent(model),
							employeeOrDependentMeta,
							model) ? _List_fromArray(
							[
								A2(
								$author$project$Ui$Dropdown$item,
								_List_fromArray(
									[
										$author$project$Ui$Dropdown$onSelect($author$project$Components$Company$EmployeeRow$ApproveEmployee)
									]),
								$elm$html$Html$text('Approve'))
							]) : _List_Nil,
						_Utils_ap(
							A4(
								$author$project$Components$Company$EmployeeRow$canTakeAction,
								1,
								$author$project$Components$Company$EmployeeRow$employeeOrDependent(model),
								employeeOrDependentMeta,
								model) ? _List_fromArray(
								[
									A2(
									$author$project$Ui$Dropdown$item,
									_List_fromArray(
										[
											$author$project$Ui$Dropdown$onSelect($author$project$Components$Company$EmployeeRow$DenyEmployee)
										]),
									$elm$html$Html$text('Deny'))
								]) : _List_Nil,
							_Utils_ap(
								A4(
									$author$project$Components$Company$EmployeeRow$canTakeAction,
									2,
									$author$project$Components$Company$EmployeeRow$employeeOrDependent(model),
									employeeOrDependentMeta,
									model) ? _List_fromArray(
									[
										A2(
										$author$project$Ui$Dropdown$item,
										_List_fromArray(
											[
												$author$project$Ui$Dropdown$onSelect(
												$author$project$Components$Company$EmployeeRow$EnrollEmployeeOrDependent(
													$author$project$Components$Company$EmployeeRow$employeeOrDependent(model)))
											]),
										$elm$html$Html$text('Enroll'))
									]) : _List_Nil,
								_Utils_ap(
									A4(
										$author$project$Components$Company$EmployeeRow$canTakeAction,
										3,
										$author$project$Components$Company$EmployeeRow$employeeOrDependent(model),
										employeeOrDependentMeta,
										model) ? _List_fromArray(
										[
											A2(
											$author$project$Ui$Dropdown$item,
											_List_fromArray(
												[
													$author$project$Ui$Dropdown$onSelect(
													$author$project$Components$Company$EmployeeRow$UnenrollEmployeeOrDependent(
														$author$project$Components$Company$EmployeeRow$employeeOrDependent(model)))
												]),
											$elm$html$Html$text('Unenroll'))
										]) : _List_Nil,
									_Utils_ap(
										A4(
											$author$project$Components$Company$EmployeeRow$canTakeAction,
											5,
											$author$project$Components$Company$EmployeeRow$employeeOrDependent(model),
											employeeOrDependentMeta,
											model) ? _List_fromArray(
											[
												A2(
												$author$project$Ui$Dropdown$item,
												_List_fromArray(
													[
														$author$project$Ui$Dropdown$onSelect(
														$author$project$Components$Company$EmployeeRow$MadeEmployeeOrDependentEligible(
															$author$project$Components$Company$EmployeeRow$employeeOrDependent(model)))
													]),
												$elm$html$Html$text('Make Eligible'))
											]) : _List_Nil,
										_Utils_ap(
											A4(
												$author$project$Components$Company$EmployeeRow$canTakeAction,
												4,
												$author$project$Components$Company$EmployeeRow$employeeOrDependent(model),
												employeeOrDependentMeta,
												model) ? _List_fromArray(
												[
													A2(
													$author$project$Ui$Dropdown$item,
													_List_fromArray(
														[
															$author$project$Ui$Dropdown$onSelect(
															$author$project$Components$Company$EmployeeRow$MadeEmployeeOrDependentIneligible(
																$author$project$Components$Company$EmployeeRow$employeeOrDependent(model)))
														]),
													$elm$html$Html$text('Make Ineligible'))
												]) : _List_Nil,
											A4(
												$author$project$Components$Company$EmployeeRow$canTakeAction,
												6,
												$author$project$Components$Company$EmployeeRow$employeeOrDependent(model),
												employeeOrDependentMeta,
												model) ? _List_fromArray(
												[
													A2(
													$author$project$Ui$Dropdown$item,
													_List_fromArray(
														[
															$author$project$Ui$Dropdown$onSelect(
															$author$project$Components$Company$EmployeeRow$DeleteEmployeeOrDependent(
																$elm$core$Maybe$Just(
																	$author$project$Components$Company$EmployeeRow$employeeOrDependent(model))))
														]),
													$elm$html$Html$text('Remove'))
												]) : _List_Nil)))))));
				return A4(
					$author$project$Ui$Dropdown$view,
					_List_fromArray(
						[$author$project$Ui$Dropdown$buttonSm]),
					_List_fromArray(
						[
							$elm$html$Html$text('Manage')
						]),
					items,
					model.gi);
			} else {
				return A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
					_List_fromArray(
						[
							$elm$html$Html$text('You can\'t take any actions on this account')
						]));
			}
		}()
		]);
};
var $author$project$Components$Company$EmployeeRow$viewRow = function (model) {
	var patient = $author$project$Api$CompanyRegistration$ForCompanyAccountAll$patient(model.Oi);
	var membershipPlanName = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Plan$Min$name,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$Basics$identity,
				$author$project$Api$Expandable$toMaybe(
					$author$project$Api$CompanyAccount$All$plan(model.Ob)))));
	var memberType = function () {
		if ($author$project$Components$Company$EmployeeRow$isNetwork(
			$elm$core$Maybe$Just(model.afQ)) && ($author$project$Api$CompanyRegistration$ForCompanyAccountAll$type_(model.Oi) !== 'employee')) {
			return 'Dependent';
		} else {
			var _v0 = $author$project$Api$CompanyRegistration$ForCompanyAccountAll$type_(model.Oi);
			if (_v0 === 'spouse') {
				return 'Adult';
			} else {
				return $author$project$Api$CompanyRegistration$ForCompanyAccountAll$type_(model.Oi);
			}
		}
	}();
	var isSubscriber = $author$project$Api$CompanyRegistration$ForCompanyAccountAll$isSubscriber(model.Oi);
	var isEmployee = $author$project$Api$CompanyRegistration$ForCompanyAccountAll$type_(model.Oi) === 'employee';
	var nestedCellClass = (isSubscriber && isEmployee) ? _List_Nil : _List_fromArray(
		[$author$project$Ui$Table$nested]);
	var tableClass = (isSubscriber && isEmployee) ? $author$project$Ui$Table$row(_List_Nil) : $author$project$Ui$Table$row(
		_List_fromArray(
			[$author$project$Ui$Table$noBorder]));
	var externalId = A2(
		$elm$core$Maybe$withDefault,
		'',
		$author$project$Api$CompanyRegistration$ForCompanyAccountAll$externalId(model.Oi));
	var patientName = A2(
		$elm$html$Html$span,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$text,
				_List_Nil,
				$author$project$Api$Patient$Min$name(patient)),
				A2(
				$author$project$Ui$Typography$text,
				_List_fromArray(
					[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
				' ' + externalId)
			]));
	var patientNameCellContent = $author$project$Api$Platform$Session$One$organizationIsCompany(model.aa4) ? patientName : A3(
		$author$project$Ui$Link$route,
		$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
			{
				YZ: $author$project$Api$Patient$Min$id(patient)
			}),
		_List_Nil,
		_List_fromArray(
			[patientName]));
	var email = A2(
		$elm$core$Maybe$withDefault,
		'',
		$author$project$Api$Patient$Min$email(patient));
	var dob = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
			$author$project$Api$Patient$Min$dob(patient)));
	return tableClass(
		A2(
			$elm$core$List$cons,
			A2(
				$author$project$Ui$Table$cell,
				nestedCellClass,
				_List_fromArray(
					[patientNameCellContent])),
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Formatters$String$titleize(memberType))
						])),
				A2(
					$elm$core$List$cons,
					A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(email)
							])),
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(dob)
								])),
						A2(
							$elm$core$List$cons,
							A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(membershipPlanName)
									])),
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$Ui$Table$cell,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2(
																$author$project$Components$Company$EmployeeRow$accountStatus,
																model.dd,
																$author$project$Components$Company$EmployeeRow$employeeOrDependent(model)))
														])),
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2(
																$author$project$Components$Company$EmployeeRow$eligibilityStatus,
																model,
																$author$project$Components$Company$EmployeeRow$employeeOrDependent(model)))
														]))
												]))
										])),
								_Utils_ap(
									function () {
										if ($author$project$Components$Company$EmployeeRow$usesEmployeeDivisions(
											$elm$core$Maybe$Just(model.afQ))) {
											var division = A2(
												$elm$core$Maybe$withDefault,
												'',
												A2(
													$elm$core$Maybe$map,
													$author$project$Api$EmployeeDivision$Shared$name,
													$author$project$Api$CompanyAccount$All$division(model.Ob)));
											return _List_fromArray(
												[
													A2(
													$author$project$Ui$Table$cell,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(division)
														]))
												]);
										} else {
											return _List_Nil;
										}
									}(),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Table$cell,
											_List_Nil,
											$author$project$Components$Company$EmployeeRow$viewActionsDropdown(model))
										])))))))));
};
var $author$project$Components$Company$EmployeeRow$view = function (model) {
	return $author$project$Components$Company$EmployeeRow$viewRow(model);
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$viewTable = function (model) {
	var tableRows = A2(
		$elm$core$List$map,
		function (_v2) {
			var registrationId = _v2.a;
			var row = _v2.b;
			return A2(
				$author$project$Ui$Table$mapRow,
				$author$project$Pages$Companies$CompanyId_String$Employees$Top$EmployeeRowMsg(registrationId),
				$author$project$Components$Company$EmployeeRow$view(row));
		},
		model.fl);
	var _v0 = function () {
		var _v1 = model.Od;
		if (_v1.$ === 3) {
			var companyAccounts_ = _v1.a;
			return _Utils_Tuple2(false, companyAccounts_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any employees')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		A2(
			$elm$core$List$map,
			$author$project$Api$Column$view($author$project$Api$Column$NonSortable),
			$author$project$Pages$Companies$CompanyId_String$Employees$Top$columns(model)),
		tableRows,
		_List_Nil);
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$view = function (model) {
	return {
		fO: function () {
			var tableRowModals = A2(
				$elm$core$List$map,
				function (_v1) {
					var registrationId = _v1.a;
					var row = _v1.b;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$Companies$CompanyId_String$Employees$Top$EmployeeRowMsg(registrationId),
						$author$project$Components$Company$EmployeeRow$modal(row));
				},
				model.fl);
			var loading = function () {
				var _v0 = model.Od;
				if (_v0.$ === 3) {
					return false;
				} else {
					return true;
				}
			}();
			var companyType_ = $author$project$Pages$Companies$CompanyId_String$Employees$Top$companyType(
				$elm$core$Maybe$Just(model.afQ));
			return _Utils_ap(
				tableRowModals,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$spaceBetween]),
										_List_fromArray(
											[
												$author$project$Ui$Panel$title(
												_List_fromArray(
													[
														$elm$html$Html$text(
														'All ' + A2($author$project$Formatters$String$affiliateMember, 'Employees & Dependents', companyType_))
													])),
												$author$project$Pages$Companies$CompanyId_String$Employees$Top$viewNewEmployeeDependentButton(model.afQ)
											])),
										$author$project$Pages$Companies$CompanyId_String$Employees$Top$viewSearchAndFilters(model),
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
										_List_fromArray(
											[
												A3($author$project$Pages$Companies$CompanyId_String$Employees$Top$viewEmployeesStats, companyType_, model.zq, model.Ql),
												A2(
												$author$project$Ui$Element$view,
												_List_Nil,
												_List_fromArray(
													[
														A2($elm$html$Html$map, $author$project$Pages$Companies$CompanyId_String$Employees$Top$ExportCsvMsg, $author$project$Components$ExportCsv$link),
														A2(
														$elm$html$Html$map,
														$author$project$Pages$Companies$CompanyId_String$Employees$Top$ExportCsvMsg,
														A3(
															$author$project$Components$ExportCsv$modal,
															model.Gv,
															_List_fromArray(
																[
																	$author$project$Components$ExportCsv$path(
																	A2($author$project$Api$CompanyRegistration$exportPath, model.aa4, model.ahP)),
																	$author$project$Components$ExportCsv$params(
																	A2($elm$core$Basics$composeL, $author$project$Api$CompanyAccount$listOptionsToParams, $author$project$Pages$Companies$CompanyId_String$Employees$Top$fetchParams)(model))
																]),
															model.nD))
													]))
											]))
									])),
								$author$project$Pages$Companies$CompanyId_String$Employees$Top$viewTable(model),
								A2(
								$author$project$Ui$Panel$footer,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Pages$Companies$CompanyId_String$Employees$Top$PaginationMsg,
										A2(
											$author$project$Api$Pagination$view,
											_List_fromArray(
												[
													$author$project$Ui$Pagination$List$loading(loading)
												]),
											model.ajJ))
									]))
							]))
					]));
		}(),
		ac9: A2($author$project$Api$Practice$sponsorize, model.ZV, 'Companies') + (' | ' + model.ahP)
	};
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$page = $author$project$Spa$Page$applicationCompanyOrEmployer(
	{ah_: $author$project$Pages$Companies$CompanyId_String$Employees$Top$init, aiq: $author$project$Pages$Companies$CompanyId_String$Employees$Top$load, k8: $author$project$Pages$Companies$CompanyId_String$Employees$Top$save, alO: $author$project$Pages$Companies$CompanyId_String$Employees$Top$subscriptions, adT: $author$project$Pages$Companies$CompanyId_String$Employees$Top$update, amo: $author$project$Pages$Companies$CompanyId_String$Employees$Top$view});
var $author$project$Spa$Page$applicationCompany = function (page) {
	return {
		ah_: F2(
			function (shared, url) {
				var _v0 = _Utils_Tuple3(shared.aa4, shared.ZV, shared.afQ);
				_v0$4:
				while (true) {
					_v0$5:
					while (true) {
						_v0$6:
						while (true) {
							switch (_v0.a.$) {
								case 3:
									switch (_v0.b.$) {
										case 3:
											if (!_v0.b.a.$) {
												switch (_v0.c.$) {
													case 3:
														if (!_v0.c.a.$) {
															var _v1 = _v0.a;
															var session = _v1.a;
															var _v2 = _v0.b;
															var practice = _v2.a.a;
															var _v3 = _v0.c;
															var company = _v3.a.a;
															return (!A3($author$project$Spa$Page$authorizeUrl, session, shared.ahK, shared.adY)) ? _Utils_Tuple3(
																$author$project$Spa$Page$SessionLoading(url),
																A2(
																	$author$project$Utils$Route$navigate,
																	$elm$core$Dict$empty,
																	A2($author$project$Permission$homeStateFor, session, shared.ahK)),
																_List_Nil) : ((!_Utils_eq(
																url.YL.fZ,
																$author$project$Api$Provider$Company$One$id(company))) ? _Utils_Tuple3(
																$author$project$Spa$Page$SessionLoading(url),
																$elm$core$Platform$Cmd$none,
																_List_fromArray(
																	[
																		$author$project$OutMsg$RetrieveCompany(url.YL.fZ)
																	])) : A2(
																$author$project$Utils$Tuple3$mapFirst,
																$author$project$Spa$Page$SessionLoaded,
																A2(
																	$author$project$Utils$Tuple3$fromTuple2,
																	_List_Nil,
																	A5(page.ah_, session, practice, company, shared, url))));
														} else {
															break _v0$6;
														}
													case 2:
														break _v0$5;
													default:
														break _v0$6;
												}
											} else {
												var _v4 = _v0.a;
												var session = _v4.a;
												var _v5 = _v0.b;
												return _Utils_Tuple3(
													$author$project$Spa$Page$SessionLoading(url),
													A2(
														$author$project$Utils$Route$navigate,
														$elm$core$Dict$empty,
														A2($author$project$Permission$homeStateFor, session, shared.ahK)),
													_List_Nil);
											}
										case 2:
											break _v0$4;
										default:
											if (_v0.c.$ === 2) {
												break _v0$5;
											} else {
												break _v0$6;
											}
									}
								case 2:
									return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
								case 0:
									var _v6 = _v0.a;
									return _Utils_Tuple3(
										$author$project$Spa$Page$SessionLoading(url),
										$author$project$Ports$Session$authorize(
											{aku: true}),
										_List_Nil);
								default:
									if (_v0.b.$ === 2) {
										break _v0$4;
									} else {
										if (_v0.c.$ === 2) {
											break _v0$5;
										} else {
											break _v0$6;
										}
									}
							}
						}
						var _v7 = url;
						var params = _v7.YL;
						return _Utils_Tuple3(
							$author$project$Spa$Page$SessionLoading(url),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									$author$project$OutMsg$RetrieveCompany(params.fZ)
								]));
					}
					return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
				}
				return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
			}),
		aiq: F2(
			function (shared, model) {
				var _v8 = _Utils_Tuple3(shared.aa4, shared.ZV, shared.afQ);
				_v8$2:
				while (true) {
					_v8$4:
					while (true) {
						_v8$5:
						while (true) {
							switch (_v8.a.$) {
								case 3:
									switch (_v8.b.$) {
										case 3:
											if (!_v8.b.a.$) {
												switch (_v8.c.$) {
													case 3:
														if (!_v8.c.a.$) {
															var _v9 = _v8.a;
															var session = _v9.a;
															var _v10 = _v8.b;
															var practice = _v10.a.a;
															var _v11 = _v8.c;
															var company = _v11.a.a;
															switch (model.$) {
																case 0:
																	var url = model.a;
																	if (!A3($author$project$Spa$Page$authorizeUrl, session, shared.ahK, shared.adY)) {
																		return _Utils_Tuple3(
																			$author$project$Spa$Page$SessionLoading(url),
																			A2(
																				$author$project$Utils$Route$navigate,
																				$elm$core$Dict$empty,
																				A2($author$project$Permission$homeStateFor, session, shared.ahK)),
																			_List_Nil);
																	} else {
																		var _v13 = A5(page.ah_, session, practice, company, shared, url);
																		var pageModel = _v13.a;
																		var cmd = _v13.b;
																		return _Utils_Tuple3(
																			$author$project$Spa$Page$SessionLoaded(pageModel),
																			cmd,
																			_List_Nil);
																	}
																case 1:
																	var modelWithSession = model.a;
																	return A2(
																		$author$project$Utils$Tuple3$fromTuple2,
																		_List_Nil,
																		A2(
																			$elm$core$Tuple$mapFirst,
																			$author$project$Spa$Page$SessionLoaded,
																			A2(
																				page.aiq,
																				shared,
																				_Utils_update(
																					modelWithSession,
																					{Gv: shared.Gv}))));
																default:
																	return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
															}
														} else {
															break _v8$5;
														}
													case 0:
														break _v8$2;
													default:
														break _v8$5;
												}
											} else {
												var _v14 = _v8.a;
												var session = _v14.a;
												var _v15 = _v8.b;
												return _Utils_Tuple3(
													model,
													A2(
														$author$project$Utils$Route$navigate,
														$elm$core$Dict$empty,
														A2($author$project$Permission$homeStateFor, session, shared.ahK)),
													_List_Nil);
											}
										case 2:
											if (!_v8.c.$) {
												break _v8$2;
											} else {
												break _v8$4;
											}
										default:
											if (!_v8.c.$) {
												break _v8$2;
											} else {
												break _v8$5;
											}
									}
								case 2:
									return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
								default:
									if (_v8.b.$ === 2) {
										break _v8$4;
									} else {
										break _v8$5;
									}
							}
						}
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
					return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
				}
				var _v16 = _v8.a;
				var _v17 = _v8.c;
				if (!model.$) {
					var url = model.a;
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								$author$project$OutMsg$RetrieveCompany(url.YL.fZ)
							]));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			}),
		k8: F2(
			function (model, shared) {
				if (model.$ === 1) {
					var modelWithSession = model.a;
					return A2(page.k8, modelWithSession, shared);
				} else {
					return shared;
				}
			}),
		alO: function (model) {
			if (model.$ === 1) {
				var modelWithSession = model.a;
				return page.alO(modelWithSession);
			} else {
				return $elm$core$Platform$Sub$none;
			}
		},
		adT: F2(
			function (msg, model) {
				if (model.$ === 1) {
					var modelWithSession = model.a;
					return A2(
						$author$project$Utils$Tuple3$mapFirst,
						$author$project$Spa$Page$SessionLoaded,
						A2(page.adT, msg, modelWithSession));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			}),
		amo: function (model) {
			if (model.$ === 1) {
				var modelWithSession = model.a;
				return page.amo(modelWithSession);
			} else {
				return {fO: $author$project$Components$BlankPage$view, ac9: 'Loading...'};
			}
		}
	};
};
var $author$project$Pages$Companies$CompanyId_String$EndedCommissions$GotBrokerDeals = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$EndedCommissions$fetchBrokerDeals = function (model) {
	return A3(
		$author$project$Api$Provider$BrokerDeal$list,
		model.Gv,
		function (d) {
			return _Utils_update(
				d,
				{
					afQ: $elm$core$Maybe$Just(model.fZ),
					TU: $elm$core$Maybe$Just(true)
				});
		},
		$author$project$Pages$Companies$CompanyId_String$EndedCommissions$GotBrokerDeals);
};
var $author$project$Pages$Companies$CompanyId_String$EndedCommissions$init = F5(
	function (session, practice, _v0, shared, _v1) {
		var params = _v1.YL;
		var model = {
			Gv: shared.Gv,
			MR: $author$project$Api$Data$Loading,
			d_: A3(
				$author$project$Components$BrokerDeal$Table$init,
				session,
				shared.dd,
				{ny: true, ss: false, st: true}),
			fZ: params.fZ,
			ZV: practice
		};
		return _Utils_Tuple2(
			model,
			$author$project$Pages$Companies$CompanyId_String$EndedCommissions$fetchBrokerDeals(model));
	});
var $author$project$Pages$Companies$CompanyId_String$EndedCommissions$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					d_: A2($author$project$Components$BrokerDeal$Table$load, shared.dd, model.d_)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Companies$CompanyId_String$EndedCommissions$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Companies$CompanyId_String$EndedCommissions$BrokerDealsTableMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$EndedCommissions$subscriptions = function (_v0) {
	var brokerDealsTable = _v0.d_;
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$Companies$CompanyId_String$EndedCommissions$BrokerDealsTableMsg,
		$author$project$Components$BrokerDeal$Table$subscriptions(brokerDealsTable));
};
var $author$project$Pages$Companies$CompanyId_String$EndedCommissions$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var response = msg.a;
			if (response.$ === 3) {
				var brokerDeals = response.a;
				var brokerDealsTable = A2(
					$author$project$Components$BrokerDeal$Table$withBrokerDeals,
					A2($elm$core$List$map, $author$project$Components$BrokerDeal$BrokerDealRecord$fromProviderAll, brokerDeals),
					model.d_);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{MR: response, d_: brokerDealsTable}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			} else {
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{MR: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			}
		} else {
			var subMsg = msg.a;
			var brokerDealsTableResult = A3($author$project$Components$BrokerDeal$Table$update, model.Gv, subMsg, model.d_);
			var _v2 = function () {
				var _v3 = brokerDealsTableResult.agZ;
				switch (_v3) {
					case 0:
						return _Utils_Tuple2(model.MR, $elm$core$Platform$Cmd$none);
					case 1:
						return _Utils_Tuple2(
							$author$project$Api$Data$Loading,
							$author$project$Pages$Companies$CompanyId_String$EndedCommissions$fetchBrokerDeals(model));
					case 2:
						return _Utils_Tuple2(
							$author$project$Api$Data$Loading,
							$author$project$Pages$Companies$CompanyId_String$EndedCommissions$fetchBrokerDeals(model));
					case 3:
						return _Utils_Tuple2(
							$author$project$Api$Data$Loading,
							$author$project$Pages$Companies$CompanyId_String$EndedCommissions$fetchBrokerDeals(model));
					case 4:
						return _Utils_Tuple2(
							$author$project$Api$Data$Loading,
							$author$project$Pages$Companies$CompanyId_String$EndedCommissions$fetchBrokerDeals(model));
					case 5:
						return _Utils_Tuple2(
							$author$project$Api$Data$Loading,
							$author$project$Pages$Companies$CompanyId_String$EndedCommissions$fetchBrokerDeals(model));
					default:
						return _Utils_Tuple2(
							$author$project$Api$Data$Loading,
							$author$project$Pages$Companies$CompanyId_String$EndedCommissions$fetchBrokerDeals(model));
				}
			}();
			var brokerDeals = _v2.a;
			var cmd = _v2.b;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{MR: brokerDeals, d_: brokerDealsTableResult.aiO}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$EndedCommissions$BrokerDealsTableMsg, brokerDealsTableResult.GZ),
							cmd
						])),
				brokerDealsTableResult.aR);
		}
	});
var $author$project$Pages$Companies$CompanyId_String$EndedCommissions$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Companies$CompanyId_String$EndedCommissions$BrokerDealsTableMsg,
				$author$project$Components$BrokerDeal$Table$modal(model.d_)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$elm$core$Basics$never,
								A2(
									$author$project$Ui$Breadcrumb$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Breadcrumb$item,
											_List_Nil,
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Companies__CompanyId_String__Top(
														{fZ: model.fZ}),
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Account & Pricing')
														]))
												])),
											A2(
											$author$project$Ui$Breadcrumb$item,
											_List_fromArray(
												[
													$author$project$Ui$Breadcrumb$active(true)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Ended Deals')
												]))
										]))),
								$author$project$Ui$HorizontalRule$view(_List_Nil),
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Ended Deals')
									])),
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Companies$CompanyId_String$EndedCommissions$BrokerDealsTableMsg,
								A2(
									$author$project$Components$BrokerDeal$Table$view,
									_List_fromArray(
										[
											$author$project$Components$BrokerDeal$Table$loading(
											!$author$project$Api$Data$isSuccess(model.MR))
										]),
									model.d_))
							]))
					]))
			]),
		ac9: A2($author$project$Formatters$String$sponsorize, model.ZV, 'Companies') + ' | Commissions'
	};
};
var $author$project$Pages$Companies$CompanyId_String$EndedCommissions$page = $author$project$Spa$Page$applicationCompany(
	{ah_: $author$project$Pages$Companies$CompanyId_String$EndedCommissions$init, aiq: $author$project$Pages$Companies$CompanyId_String$EndedCommissions$load, k8: $author$project$Pages$Companies$CompanyId_String$EndedCommissions$save, alO: $author$project$Pages$Companies$CompanyId_String$EndedCommissions$subscriptions, adT: $author$project$Pages$Companies$CompanyId_String$EndedCommissions$update, amo: $author$project$Pages$Companies$CompanyId_String$EndedCommissions$view});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$GotCompanyInvoiceSetting = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$GotPaymentSourceSetting = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$GotPracticeCompanyInvoiceSetting = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$GotPracticePaymentSourceSetting = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$GotVirtualBankAccount = function (a) {
	return {$: 12, a: a};
};
var $author$project$Api$Provider$Company$One$companyInvoiceSettingId = function (_v0) {
	var record = _v0.b;
	return record.Of;
};
var $author$project$Api$Provider$Company$One$companyPaymentSourceSettingId = function (_v0) {
	var record = _v0.b;
	return record.Oh;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$ForCompany = $elm$core$Basics$identity;
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$Record = function (invoiceUpcomingAutoSend) {
	return function (invoiceAutoSend) {
		return function (invoiceAutoSendDay) {
			return function (invoiceAutoSendMonth) {
				return function (invoiceAutoIssue) {
					return function (invoiceAutoIssueDay) {
						return function (invoiceAutoIssueMonth) {
							return function (invoiceDueDay) {
								return function (invoiceDueMonth) {
									return function (invoiceAutoPay) {
										return function (invoiceAutoPayDay) {
											return function (invoiceAutoPayMonth) {
												return function (invoiceGracePeriodDays) {
													return function (chargePhiDetailsEnabled) {
														return function (chargePhiDetailsUpdatedAt) {
															return function (chargePhiDetailsUpdatedBy) {
																return function (chargeRouteToRecurringInvoice) {
																	return function (billingEnabled) {
																		return function (billingStartDate) {
																			return function (hideSponsorInvoices) {
																				return {GF: billingEnabled, MH: billingStartDate, Nx: chargePhiDetailsEnabled, Ny: chargePhiDetailsUpdatedAt, Nz: chargePhiDetailsUpdatedBy, GX: chargeRouteToRecurringInvoice, Ts: hideSponsorInvoices, Ul: invoiceAutoIssue, Um: invoiceAutoIssueDay, Ic: invoiceAutoIssueMonth, Un: invoiceAutoPay, Id: invoiceAutoPayDay, Ie: invoiceAutoPayMonth, Uo: invoiceAutoSend, Up: invoiceAutoSendDay, If: invoiceAutoSendMonth, Ur: invoiceDueDay, Ig: invoiceDueMonth, Ih: invoiceGracePeriodDays, Ii: invoiceUpcomingAutoSend};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'hide_sponsor_invoices',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'billing_start_date',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'billing_enabled',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'charge_route_to_recurring_invoice',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'charge_phi_details_updated_by',
					$elm$json$Json$Decode$nullable($author$project$Api$Provider$User$Min$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'charge_phi_details_updated_at',
						$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'charge_phi_details_enabled',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'invoice_grace_period_days',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'invoice_auto_pay_month',
									$elm$json$Json$Decode$nullable($author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$decoder),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'invoice_auto_pay_day',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'invoice_auto_pay',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'invoice_due_month',
												$elm$json$Json$Decode$nullable($author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$decoder),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'invoice_due_day',
													$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'invoice_auto_issue_month',
														$elm$json$Json$Decode$nullable($author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$decoder),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'invoice_auto_issue_day',
															$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'invoice_auto_issue',
																$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'invoice_auto_send_month',
																	$elm$json$Json$Decode$nullable($author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$decoder),
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'invoice_auto_send_day',
																		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'invoice_auto_send',
																			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'invoice_upcoming_auto_send',
																				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
																				$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$Record)))))))))))))))))))));
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$retrieve = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$CompanyInvoiceSetting$Shared$companyInvoiceSettingPath(id_)));
	});
var $author$project$Api$Provider$PaymentSourceSetting$ForCompany$ForCompany = $elm$core$Basics$identity;
var $author$project$Api$Provider$PaymentSourceSetting$ForCompany$Record = F3(
	function (acceptsAch, acceptsCards, acceptsAmex) {
		return {KA: acceptsAch, KB: acceptsAmex, KC: acceptsCards};
	});
var $author$project$Api$Provider$PaymentSourceSetting$ForCompany$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'accepts_amex',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'accepts_cards',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'accepts_ach',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$PaymentSourceSetting$ForCompany$Record))));
var $author$project$Api$Provider$PaymentSourceSetting$ForCompany$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PaymentSourceSetting$ForCompany$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PaymentSourceSetting$ForCompany$retrieve = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$PaymentSourceSetting$ForCompany$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$PaymentSourceSetting$Shared$paymentSourceSettingPath(id_)));
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$init = F5(
	function (_v0, practice, company, shared, _v1) {
		var practiceId = $author$project$Api$Provider$CompanyInvoiceSetting$Shared$id(
			$author$project$Api$Provider$Practice$One$companyInvoiceSetting(practice));
		var paymentSettingId = $author$project$Api$Provider$PaymentSourceSetting$Shared$id(
			$author$project$Api$Provider$Practice$One$paymentSourceSetting(practice));
		return _Utils_Tuple2(
			{
				Gv: shared.Gv,
				afQ: company,
				dd: shared.dd,
				SD: $elm$core$Maybe$Nothing,
				ahP: $author$project$Api$Provider$Company$One$companyInvoiceSettingId(company),
				Ij: $author$project$Shared$isHintAdmin(shared),
				be: $elm$core$Maybe$Nothing,
				tL: $author$project$Api$Provider$Company$One$companyPaymentSourceSettingId(company),
				Zh: $author$project$Api$Data$Loading,
				ZV: practice,
				pf: $author$project$Api$Data$Loading,
				tY: $author$project$Api$Data$Loading,
				cT: $author$project$Api$Data$Loading,
				dQ: $elm$core$Maybe$Nothing,
				ft: $elm$core$Maybe$Nothing,
				F7: $elm$core$Maybe$Nothing
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3($author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$retrieve, shared.Gv, practiceId, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$GotPracticeCompanyInvoiceSetting),
						A3($author$project$Api$Provider$PaymentSourceSetting$ForPractice$retrieve, shared.Gv, paymentSettingId, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$GotPracticePaymentSourceSetting),
						A3(
						$author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$retrieve,
						shared.Gv,
						$author$project$Api$Provider$Company$One$companyInvoiceSettingId(company),
						$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$GotCompanyInvoiceSetting),
						A3(
						$author$project$Api$Provider$PaymentSourceSetting$ForCompany$retrieve,
						shared.Gv,
						$author$project$Api$Provider$Company$One$companyPaymentSourceSettingId(company),
						$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$GotPaymentSourceSetting),
						A2($author$project$Api$Provider$Practice$One$featureEnabled, 11, practice) ? A3(
						$author$project$Api$Provider$VirtualBankAccount$list,
						shared.Gv,
						$author$project$Api$Provider$Company$One$id(company),
						$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$GotVirtualBankAccount) : $elm$core$Platform$Cmd$none
					])));
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{dd: shared.dd}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountAuthorizeModalMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountEnableModalMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$Close = 3;
var $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress(3);
};
var $author$project$Components$Company$VirtualBankAccounts$EnableModal$Close = 1;
var $author$project$Components$Company$VirtualBankAccounts$EnableModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress(1);
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					function (virtualBankAccountEnableModal) {
						return A2(
							$elm$core$Platform$Sub$map,
							$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountEnableModalMsg,
							$author$project$Components$Company$VirtualBankAccounts$EnableModal$subscriptions(virtualBankAccountEnableModal));
					},
					model.ft)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					function (virtualBankAccountAuthorizeModal) {
						return A2(
							$elm$core$Platform$Sub$map,
							$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountAuthorizeModalMsg,
							$author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$subscriptions(virtualBankAccountAuthorizeModal));
					},
					model.dQ))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountAuthorizedAndConfirmed = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountCreated = function (a) {
	return {$: 11, a: a};
};
var $author$project$Api$Provider$VirtualBankAccount$authorizeAndCreate = F3(
	function (apiClient, companyId, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['authorize_and_create']),
					$author$project$Api$Provider$VirtualBankAccount$virtualBankAccountsPath(companyId))));
	});
var $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$closeModal = function (_v0) {
	var model = _v0;
	return _Utils_update(
		model,
		{Ao: false});
};
var $author$project$Components$Company$VirtualBankAccounts$EnableModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Company$VirtualBankAccounts$EnableModal$closeModal = function (_v0) {
	var model = _v0;
	return _Utils_update(
		model,
		{Ao: false});
};
var $author$project$Api$Provider$VirtualBankAccount$create = F3(
	function (apiClient, companyId, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$VirtualBankAccount$virtualBankAccountsPath(companyId)));
	});
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$billingEnabled = function (_v0) {
	var forCompany = _v0;
	return forCompany.GF;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$billingStartDate = function (_v0) {
	var forCompany = _v0;
	return forCompany.MH;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$chargePhiDetailsEnabled = function (_v0) {
	var forCompany = _v0;
	return forCompany.Nx;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$chargeRouteToRecurringInvoice = function (_v0) {
	var forCompany = _v0;
	return forCompany.GX;
};
var $author$project$Utils$Overridable$Defaulted = function (a) {
	return {$: 1, a: a};
};
var $author$project$Utils$Overridable$Overriden = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Utils$Overridable$fromMaybe = F2(
	function (maybe, default_) {
		if (!maybe.$) {
			var override_ = maybe.a;
			return A2($author$project$Utils$Overridable$Overriden, override_, default_);
		} else {
			return $author$project$Utils$Overridable$Defaulted(default_);
		}
	});
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$hideSponsorInvoices = function (_v0) {
	var forCompany = _v0;
	return forCompany.Ts;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoIssue = function (_v0) {
	var forCompany = _v0;
	return forCompany.Ul;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoIssueDay = function (_v0) {
	var forCompany = _v0;
	return forCompany.Um;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoIssueMonth = function (_v0) {
	var forCompany = _v0;
	return forCompany.Ic;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoPay = function (_v0) {
	var forCompany = _v0;
	return forCompany.Un;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoPayDay = function (_v0) {
	var forCompany = _v0;
	return forCompany.Id;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoPayMonth = function (_v0) {
	var forCompany = _v0;
	return forCompany.Ie;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoSend = function (_v0) {
	var forCompany = _v0;
	return forCompany.Uo;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoSendDay = function (_v0) {
	var forCompany = _v0;
	return forCompany.Up;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoSendMonth = function (_v0) {
	var forCompany = _v0;
	return forCompany.If;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceDueDay = function (_v0) {
	var forCompany = _v0;
	return forCompany.Ur;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceDueMonth = function (_v0) {
	var forCompany = _v0;
	return forCompany.Ig;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceGracePeriodDays = function (_v0) {
	var forCompany = _v0;
	return forCompany.Ih;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceUpcomingAutoSend = function (_v0) {
	var forCompany = _v0;
	return forCompany.Ii;
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$createForm = F3(
	function (companySettings, practiceSettings, currentDate) {
		var billingStartDate = function () {
			var _v1 = $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$billingStartDate(companySettings);
			if (!_v1.$) {
				var date = _v1.a;
				return ((A2($justinmimbs$date$Date$compare, currentDate, date) === 2) || (A2($justinmimbs$date$Date$compare, currentDate, date) === 1)) ? $elm$core$Maybe$Just(
					A3($justinmimbs$date$Date$add, 3, 1, currentDate)) : $elm$core$Maybe$Just(date);
			} else {
				return $elm$core$Maybe$Just(
					A3($justinmimbs$date$Date$add, 3, 1, currentDate));
			}
		}();
		var billingEnabledDateToggle = function () {
			var _v0 = $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$billingStartDate(companySettings);
			if (!_v0.$) {
				var date = _v0.a;
				return $elm$core$Maybe$Just(
					!((A2($justinmimbs$date$Date$compare, currentDate, date) === 2) || (A2($justinmimbs$date$Date$compare, currentDate, date) === 1)));
			} else {
				return $elm$core$Maybe$Just(false);
			}
		}();
		return _Utils_Tuple2(
			{
				GF: A2(
					$author$project$Utils$Overridable$fromMaybe,
					$author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$billingEnabled(companySettings),
					$author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$billingEnabled(practiceSettings)),
				fN: A2(
					$author$project$Utils$Overridable$fromMaybe,
					billingEnabledDateToggle,
					$author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$billingEnabled(practiceSettings)),
				MH: billingStartDate,
				Nx: A2(
					$author$project$Utils$Overridable$fromMaybe,
					$author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$chargePhiDetailsEnabled(companySettings),
					$author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$chargePhiDetailsEnabled(practiceSettings)),
				GX: A2(
					$author$project$Utils$Overridable$fromMaybe,
					$author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$chargeRouteToRecurringInvoice(companySettings),
					$author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$chargeRouteToRecurringInvoice(practiceSettings)),
				Ts: A2(
					$author$project$Utils$Overridable$fromMaybe,
					$author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$hideSponsorInvoices(companySettings),
					$author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$hideSponsorInvoices(practiceSettings)),
				Ul: A2(
					$author$project$Utils$Overridable$fromMaybe,
					$author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoIssue(companySettings),
					$author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoIssue(practiceSettings)),
				Um: A2(
					$author$project$Utils$Overridable$fromMaybe,
					$author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoIssueDay(companySettings),
					$author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoIssueDay(practiceSettings)),
				Ic: A2(
					$author$project$Utils$Overridable$fromMaybe,
					$author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoIssueMonth(companySettings),
					$author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoIssueMonth(practiceSettings)),
				Un: A2(
					$author$project$Utils$Overridable$fromMaybe,
					$author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoPay(companySettings),
					$author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoPay(practiceSettings)),
				Id: A2(
					$author$project$Utils$Overridable$fromMaybe,
					$author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoPayDay(companySettings),
					$author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoPayDay(practiceSettings)),
				Ie: A2(
					$author$project$Utils$Overridable$fromMaybe,
					$author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoPayMonth(companySettings),
					$author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoPayMonth(practiceSettings)),
				Uo: A2(
					$author$project$Utils$Overridable$fromMaybe,
					$author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoSend(companySettings),
					$author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoSend(practiceSettings)),
				Up: A2(
					$author$project$Utils$Overridable$fromMaybe,
					$author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoSendDay(companySettings),
					$author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoSendDay(practiceSettings)),
				If: A2(
					$author$project$Utils$Overridable$fromMaybe,
					$author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoSendMonth(companySettings),
					$author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoSendMonth(practiceSettings)),
				Ur: A2(
					$author$project$Utils$Overridable$fromMaybe,
					$author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceDueDay(companySettings),
					$author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceDueDay(practiceSettings)),
				Ig: A2(
					$author$project$Utils$Overridable$fromMaybe,
					$author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceDueMonth(companySettings),
					$author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceDueMonth(practiceSettings)),
				Ih: A2(
					$author$project$Utils$Overridable$fromMaybe,
					$author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceGracePeriodDays(companySettings),
					$author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceGracePeriodDays(practiceSettings)),
				Ii: A2(
					$author$project$Utils$Overridable$fromMaybe,
					$author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceUpcomingAutoSend(companySettings),
					$author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceUpcomingAutoSend(practiceSettings))
			},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AutoPayIssueDateValidation = 4;
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$isOnOrAfter = F2(
	function (_v0, _v1) {
		var firstDay = _v0.a;
		var firstMonth = _v0.b;
		var secondDay = _v1.a;
		var secondMonth = _v1.b;
		var secondMonthInt = $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toInt(secondMonth);
		var firstMonthInt = $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toInt(firstMonth);
		return _Utils_eq(firstMonthInt, secondMonthInt) ? (_Utils_cmp(firstDay, secondDay) < 1) : (_Utils_cmp(firstMonthInt, secondMonthInt) < 0);
	});
var $author$project$Utils$Overridable$value = function (overridable) {
	if (!overridable.$) {
		var override_ = overridable.a;
		return override_;
	} else {
		var default_ = overridable.a;
		return default_;
	}
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoPayDateIsOnOrAfterAutoIssueDate = function (form) {
	return ($author$project$Utils$Overridable$value(form.Un) && $author$project$Utils$Overridable$value(form.Ul)) ? A2(
		$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$isOnOrAfter,
		_Utils_Tuple2(
			$author$project$Utils$Overridable$value(form.Um),
			$author$project$Utils$Overridable$value(form.Ic)),
		_Utils_Tuple2(
			$author$project$Utils$Overridable$value(form.Id),
			$author$project$Utils$Overridable$value(form.Ie))) : true;
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoIssueDateIsBeforeOrOnAutoPayDateValidator = A2(
	$rtfeldman$elm_validate$Validate$ifFalse,
	$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoPayDateIsOnOrAfterAutoIssueDate,
	_Utils_Tuple2(4, 'The autopay date must be on or after the scheduled issue date'));
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$IssueDateValidation = 5;
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoPayDateIsOnOrAfterAutoIssueDateValidator = A2(
	$rtfeldman$elm_validate$Validate$ifFalse,
	$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoPayDateIsOnOrAfterAutoIssueDate,
	_Utils_Tuple2(5, 'The scheduled issue date must be before or on the autopay date'));
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AutoPayDateValidation = 3;
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoPayDateIsOnOrAfterAutoSendDate = function (form) {
	return ($author$project$Utils$Overridable$value(form.Uo) && $author$project$Utils$Overridable$value(form.Un)) ? A2(
		$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$isOnOrAfter,
		_Utils_Tuple2(
			$author$project$Utils$Overridable$value(form.Up),
			$author$project$Utils$Overridable$value(form.If)),
		_Utils_Tuple2(
			$author$project$Utils$Overridable$value(form.Id),
			$author$project$Utils$Overridable$value(form.Ie))) : true;
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoPayDateIsOnOrAfterAutoSendDateValidator = A2(
	$rtfeldman$elm_validate$Validate$ifFalse,
	$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoPayDateIsOnOrAfterAutoSendDate,
	_Utils_Tuple2(3, 'The autopay date must be on or after the Invoice Created notification date'));
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$dueDateIsOnOrAfterAutoPayDate = function (form) {
	return $author$project$Utils$Overridable$value(form.Un) ? A2(
		$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$isOnOrAfter,
		_Utils_Tuple2(
			$author$project$Utils$Overridable$value(form.Id),
			$author$project$Utils$Overridable$value(form.Ie)),
		_Utils_Tuple2(
			$author$project$Utils$Overridable$value(form.Ur),
			$author$project$Utils$Overridable$value(form.Ig))) : true;
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoPayIsOnOrBeforeDueDateValidator = A2(
	$rtfeldman$elm_validate$Validate$ifFalse,
	$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$dueDateIsOnOrAfterAutoPayDate,
	_Utils_Tuple2(3, 'The autopay date must be before the invoice is due'));
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AutoSendDateValidation = 1;
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoSendDateIsBeforeOrOnPayDateValidator = A2(
	$rtfeldman$elm_validate$Validate$ifFalse,
	$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoPayDateIsOnOrAfterAutoSendDate,
	_Utils_Tuple2(1, 'The Invoice Created notification date must be before or on the autopay date'));
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$dueDateIsOnOrAfterAutoSendDate = function (form) {
	return ($author$project$Utils$Overridable$value(form.Un) || (!$author$project$Utils$Overridable$value(form.Uo))) ? true : A2(
		$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$isOnOrAfter,
		_Utils_Tuple2(
			$author$project$Utils$Overridable$value(form.Up),
			$author$project$Utils$Overridable$value(form.If)),
		_Utils_Tuple2(
			$author$project$Utils$Overridable$value(form.Ur),
			$author$project$Utils$Overridable$value(form.Ig)));
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoSendDateIsOnOrBeforeDueDateValidator = A2(
	$rtfeldman$elm_validate$Validate$ifFalse,
	$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$dueDateIsOnOrAfterAutoSendDate,
	_Utils_Tuple2(1, 'The Invoice Created notification date must be before the invoice is due'));
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$DueDateValidation = 6;
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$dueDateIsOnOrAfterAutoPayDateValidator = A2(
	$rtfeldman$elm_validate$Validate$ifFalse,
	$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$dueDateIsOnOrAfterAutoPayDate,
	_Utils_Tuple2(6, 'The invoice must be due on or after the autopay date'));
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$dueDateIsOnOrAfterAutoSendDateValidator = A2(
	$rtfeldman$elm_validate$Validate$ifFalse,
	$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$dueDateIsOnOrAfterAutoSendDate,
	_Utils_Tuple2(6, 'The invoice must be due on or after the Invoice Created notification date'));
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$EnableBillingDateValidation = 2;
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$enableBillingIsInFutureValidator = function (currentDate) {
	return A2(
		$rtfeldman$elm_validate$Validate$ifFalse,
		function (_v0) {
			var billingStartDate = _v0.MH;
			var billingEnabledDateToggle = _v0.fN;
			if (!$author$project$Utils$Overridable$value(billingEnabledDateToggle)) {
				return true;
			} else {
				var billingDate = function () {
					if (!billingStartDate.$) {
						var date = billingStartDate.a;
						return date;
					} else {
						return currentDate;
					}
				}();
				return !((A2($justinmimbs$date$Date$compare, currentDate, billingDate) === 2) || (A2($justinmimbs$date$Date$compare, currentDate, billingDate) === 1));
			}
		},
		_Utils_Tuple2(2, 'The date must be in the future'));
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceUpcomingValidation = 0;
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$invoiceCreatedIsEnabledIfInvoiceUpcomingIsEnabledValidator = A2(
	$rtfeldman$elm_validate$Validate$ifFalse,
	function (_v0) {
		var invoiceUpcomingAutoSend = _v0.Ii;
		var invoiceAutoSend = _v0.Uo;
		return $author$project$Utils$Overridable$value(invoiceUpcomingAutoSend) ? $author$project$Utils$Overridable$value(invoiceAutoSend) : true;
	},
	_Utils_Tuple2(0, 'This notification can only be enabled if the Invoice Created notification is also enabled'));
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$invoiceUpcomingIsEnabledIfInvoiceCreatedIsEnabledValidator = A2(
	$rtfeldman$elm_validate$Validate$ifFalse,
	function (_v0) {
		var invoiceUpcomingAutoSend = _v0.Ii;
		var invoiceAutoSend = _v0.Uo;
		return $author$project$Utils$Overridable$value(invoiceUpcomingAutoSend) ? $author$project$Utils$Overridable$value(invoiceAutoSend) : true;
	},
	_Utils_Tuple2(1, 'This notification cannot be disabled if the Invoice Upcoming notification is enabled'));
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$formFieldsValidator = function (currentDate) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$invoiceCreatedIsEnabledIfInvoiceUpcomingIsEnabledValidator,
				$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$invoiceUpcomingIsEnabledIfInvoiceCreatedIsEnabledValidator,
				$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoIssueDateIsBeforeOrOnAutoPayDateValidator,
				$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoPayDateIsOnOrAfterAutoSendDateValidator,
				$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoPayDateIsOnOrAfterAutoIssueDateValidator,
				$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoSendDateIsBeforeOrOnPayDateValidator,
				$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$dueDateIsOnOrAfterAutoPayDateValidator,
				$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoPayIsOnOrBeforeDueDateValidator,
				$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$dueDateIsOnOrAfterAutoSendDateValidator,
				$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoSendDateIsOnOrBeforeDueDateValidator,
				$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$enableBillingIsInFutureValidator(currentDate)
			]));
};
var $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$init = function (companyName) {
	return {Og: companyName, sR: false, Ao: true, k9: $author$project$Api$Data$NotAsked};
};
var $author$project$Components$Company$VirtualBankAccounts$EnableModal$init = function (companyName) {
	return {Og: companyName, Ao: true, k9: $author$project$Api$Data$NotAsked};
};
var $author$project$Api$Provider$PaymentSourceSetting$ForCompany$acceptsAch = function (_v0) {
	var forCompany = _v0;
	return forCompany.KA;
};
var $author$project$Api$Provider$PaymentSourceSetting$ForCompany$acceptsAmex = function (_v0) {
	var forCompany = _v0;
	return forCompany.KB;
};
var $author$project$Api$Provider$PaymentSourceSetting$ForCompany$acceptsCards = function (_v0) {
	var forCompany = _v0;
	return forCompany.KC;
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$initPaymentFormFields = F2(
	function (practicePaymentSourceSetting, paymentSourceSetting) {
		return {
			KA: A2(
				$author$project$Utils$Overridable$fromMaybe,
				$author$project$Api$Provider$PaymentSourceSetting$ForCompany$acceptsAch(paymentSourceSetting),
				$author$project$Api$Provider$PaymentSourceSetting$ForPractice$acceptsAch(practicePaymentSourceSetting)),
			KB: A2(
				$author$project$Utils$Overridable$fromMaybe,
				$author$project$Api$Provider$PaymentSourceSetting$ForCompany$acceptsAmex(paymentSourceSetting),
				$author$project$Api$Provider$PaymentSourceSetting$ForPractice$acceptsAmex(practicePaymentSourceSetting)),
			KC: A2(
				$author$project$Utils$Overridable$fromMaybe,
				$author$project$Api$Provider$PaymentSourceSetting$ForCompany$acceptsCards(paymentSourceSetting),
				$author$project$Api$Provider$PaymentSourceSetting$ForPractice$acceptsCards(practicePaymentSourceSetting))
		};
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$paymentFormFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var overridableBool = field.a;
				return _Utils_update(
					fields,
					{KA: overridableBool});
			case 1:
				var overridableBool = field.a;
				return _Utils_update(
					fields,
					{KB: overridableBool, KC: overridableBool});
			default:
				var overridableBool = field.a;
				return _Utils_update(
					fields,
					{KB: overridableBool});
		}
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AcceptsAmexValidation = 0;
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$sponsorAcceptsAllCards = function (form) {
	return !((!$author$project$Utils$Overridable$value(form.KC)) && $author$project$Utils$Overridable$value(form.KB));
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$acceptsAmexValidator = A2(
	$rtfeldman$elm_validate$Validate$ifFalse,
	$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$sponsorAcceptsAllCards,
	_Utils_Tuple2(0, 'If the sponsor does not accept cards they cannot accept Amex'));
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$paymentFormFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$acceptsAmexValidator]));
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$CompanyInvoiceSettingsUpdated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$billingStartDate = function (_v0) {
	var forPractice = _v0;
	return forPractice.MH;
};
var $author$project$Utils$Overridable$toMaybe = function (overridable) {
	if (!overridable.$) {
		var override_ = overridable.a;
		return $elm$core$Maybe$Just(override_);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable = F2(
	function (encoder, maybeA) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$json$Json$Encode$null,
			A2($elm$core$Maybe$map, encoder, maybeA));
	});
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$update = F4(
	function (apiClient, id, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'company_invoice_setting',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'invoice_upcoming_auto_send',
								A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$bool, fields.Ii)),
								_Utils_Tuple2(
								'invoice_auto_send',
								A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$bool, fields.Uo)),
								_Utils_Tuple2(
								'invoice_auto_send_day',
								A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$int, fields.Up)),
								_Utils_Tuple2(
								'invoice_auto_send_month',
								A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$encoder, fields.If)),
								_Utils_Tuple2(
								'invoice_auto_issue',
								A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$bool, fields.Ul)),
								_Utils_Tuple2(
								'invoice_auto_issue_day',
								A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$int, fields.Um)),
								_Utils_Tuple2(
								'invoice_auto_issue_month',
								A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$encoder, fields.Ic)),
								_Utils_Tuple2(
								'invoice_due_day',
								A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$int, fields.Ur)),
								_Utils_Tuple2(
								'invoice_due_month',
								A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$encoder, fields.Ig)),
								_Utils_Tuple2(
								'invoice_auto_pay',
								A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$bool, fields.Un)),
								_Utils_Tuple2(
								'invoice_auto_pay_day',
								A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$int, fields.Id)),
								_Utils_Tuple2(
								'invoice_auto_pay_month',
								A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$encoder, fields.Ie)),
								_Utils_Tuple2(
								'invoice_grace_period_days',
								A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$int, fields.Ih)),
								_Utils_Tuple2(
								'charge_phi_details_enabled',
								A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$bool, fields.Nx)),
								_Utils_Tuple2(
								'charge_route_to_recurring_invoice',
								A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$bool, fields.GX)),
								_Utils_Tuple2(
								'billing_enabled',
								A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$bool, fields.GF)),
								_Utils_Tuple2(
								'billing_start_date',
								A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $author$project$Utils$Date$encode, fields.MH)),
								_Utils_Tuple2(
								'hide_sponsor_invoices',
								A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$bool, fields.Ts))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$CompanyInvoiceSetting$Shared$companyInvoiceSettingPath(id))));
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$submitCompanyInvoiceSettings = F5(
	function (apiClient, id, formFields, practiceSettings, currentDate) {
		var validated = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var billingStartDate = function () {
			var _v0 = $author$project$Utils$Overridable$toMaybe(validated.GF);
			if (!_v0.$) {
				var billingEnabled = _v0.a;
				return (!billingEnabled) ? $elm$core$Maybe$Nothing : ((!$author$project$Utils$Overridable$value(validated.fN)) ? $elm$core$Maybe$Just(currentDate) : validated.MH);
			} else {
				if (practiceSettings.$ === 3) {
					var settings = practiceSettings.a;
					return $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$billingStartDate(settings);
				} else {
					return validated.MH;
				}
			}
		}();
		var flattenedForm = {
			GF: $author$project$Utils$Overridable$toMaybe(validated.GF),
			MH: billingStartDate,
			Nx: $author$project$Utils$Overridable$toMaybe(validated.Nx),
			GX: $author$project$Utils$Overridable$toMaybe(validated.GX),
			Ts: $author$project$Utils$Overridable$toMaybe(validated.Ts),
			Ul: $author$project$Utils$Overridable$toMaybe(validated.Ul),
			Um: $author$project$Utils$Overridable$toMaybe(validated.Um),
			Ic: $author$project$Utils$Overridable$toMaybe(validated.Ic),
			Un: $author$project$Utils$Overridable$toMaybe(validated.Un),
			Id: $author$project$Utils$Overridable$toMaybe(validated.Id),
			Ie: $author$project$Utils$Overridable$toMaybe(validated.Ie),
			Uo: $author$project$Utils$Overridable$toMaybe(validated.Uo),
			Up: $author$project$Utils$Overridable$toMaybe(validated.Up),
			If: $author$project$Utils$Overridable$toMaybe(validated.If),
			Ur: $author$project$Utils$Overridable$toMaybe(validated.Ur),
			Ig: $author$project$Utils$Overridable$toMaybe(validated.Ig),
			Ih: $author$project$Utils$Overridable$toMaybe(validated.Ih),
			Ii: $author$project$Utils$Overridable$toMaybe(validated.Ii)
		};
		return A4($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$update, apiClient, id, flattenedForm, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$CompanyInvoiceSettingsUpdated);
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$PaymentSourceSettingUpdated = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$PaymentSourceSetting$ForCompany$encodeNullable = F2(
	function (encoder, maybeA) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$json$Json$Encode$null,
			A2($elm$core$Maybe$map, encoder, maybeA));
	});
var $author$project$Api$Provider$PaymentSourceSetting$ForCompany$update = F4(
	function (apiClient, id, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'payment_source_setting',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'accepts_ach',
								A2($author$project$Api$Provider$PaymentSourceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$bool, fields.KA)),
								_Utils_Tuple2(
								'accepts_cards',
								A2($author$project$Api$Provider$PaymentSourceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$bool, fields.KC)),
								_Utils_Tuple2(
								'accepts_amex',
								A2($author$project$Api$Provider$PaymentSourceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$bool, fields.KB))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$PaymentSourceSetting$ForCompany$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$PaymentSourceSetting$Shared$paymentSourceSettingPath(id))));
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$updatePaymentSourceSetting = F3(
	function (apiClient, id, formFields) {
		var validated = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var flattenedForm = {
			KA: $author$project$Utils$Overridable$toMaybe(validated.KA),
			KB: $author$project$Utils$Overridable$toMaybe(validated.KB),
			KC: $author$project$Utils$Overridable$toMaybe(validated.KC)
		};
		return A4($author$project$Api$Provider$PaymentSourceSetting$ForCompany$update, apiClient, id, flattenedForm, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$PaymentSourceSettingUpdated);
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$submitCompanyInvoiceAndPaymentSetting = function (model) {
	var _v0 = _Utils_Tuple2(model.SD, model.be);
	if (!_v0.a.$) {
		if (_v0.b.$ === 1) {
			var form = _v0.a.a;
			var _v1 = _v0.b;
			var _v2 = A2(
				$author$project$Utils$Form$validate,
				$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$formFieldsValidator(model.dd),
				form);
			if (!_v2.$) {
				var _v3 = _v2.a;
				var newForm = _v3.a;
				var validFormFields = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							SD: $elm$core$Maybe$Just(newForm),
							cT: $author$project$Api$Data$Loading
						}),
					A5($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$submitCompanyInvoiceSettings, model.Gv, model.ahP, validFormFields, model.tY, model.dd),
					_List_Nil);
			} else {
				var newForm = _v2.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							SD: $elm$core$Maybe$Just(newForm)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			}
		} else {
			var form = _v0.a.a;
			var paymentForm = _v0.b.a;
			var _v4 = _Utils_Tuple2(
				A2(
					$author$project$Utils$Form$validate,
					$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$formFieldsValidator(model.dd),
					form),
				A2($author$project$Utils$Form$validate, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$paymentFormFieldsValidator, paymentForm));
			if (!_v4.a.$) {
				if (!_v4.b.$) {
					var _v5 = _v4.a.a;
					var newForm = _v5.a;
					var validFormFields = _v5.b;
					var _v6 = _v4.b.a;
					var newPaymentForm = _v6.a;
					var validPaymentFormFields = _v6.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								SD: $elm$core$Maybe$Just(newForm),
								be: $elm$core$Maybe$Just(newPaymentForm),
								Zh: $author$project$Api$Data$Loading,
								cT: $author$project$Api$Data$Loading
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A5($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$submitCompanyInvoiceSettings, model.Gv, model.ahP, validFormFields, model.tY, model.dd),
									A3($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$updatePaymentSourceSetting, model.Gv, model.tL, validPaymentFormFields)
								])),
						_List_Nil);
				} else {
					var _v7 = _v4.a.a;
					var newForm = _v7.a;
					var validFormFields = _v7.b;
					var newPaymentForm = _v4.b.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								SD: $elm$core$Maybe$Just(newForm),
								be: $elm$core$Maybe$Just(newPaymentForm),
								cT: $author$project$Api$Data$Loading
							}),
						A5($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$submitCompanyInvoiceSettings, model.Gv, model.ahP, validFormFields, model.tY, model.dd),
						_List_Nil);
				}
			} else {
				if (!_v4.b.$) {
					var newForm = _v4.a.a;
					var _v8 = _v4.b.a;
					var newPaymentForm = _v8.a;
					var validPaymentFormFields = _v8.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								SD: $elm$core$Maybe$Just(newForm),
								be: $elm$core$Maybe$Just(newPaymentForm),
								Zh: $author$project$Api$Data$Loading
							}),
						A3($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$updatePaymentSourceSetting, model.Gv, model.tL, validPaymentFormFields),
						_List_Nil);
				} else {
					var newForm = _v4.a.a;
					var newPaymentForm = _v4.b.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								SD: $elm$core$Maybe$Just(newForm),
								be: $elm$core$Maybe$Just(newPaymentForm)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			}
		}
	} else {
		if (!_v0.b.$) {
			var _v9 = _v0.a;
			var paymentForm = _v0.b.a;
			var _v10 = A2($author$project$Utils$Form$validate, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$paymentFormFieldsValidator, paymentForm);
			if (!_v10.$) {
				var _v11 = _v10.a;
				var newForm = _v11.a;
				var validFormFields = _v11.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							be: $elm$core$Maybe$Just(newForm),
							Zh: $author$project$Api$Data$Loading
						}),
					A3($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$updatePaymentSourceSetting, model.Gv, model.tL, validFormFields),
					_List_Nil);
			} else {
				var newForm = _v10.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							be: $elm$core$Maybe$Just(newForm)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			}
		} else {
			var _v12 = _v0.a;
			return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	}
};
var $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$Closed = 2;
var $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$Confirm = 1;
var $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$None = 0;
var $author$project$Ports$NewTab$open = _Platform_outgoingPort('open', $elm$json$Json$Encode$string);
var $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$StripeTimerDone = 1;
var $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$stripeButtonClicked = A2(
	$elm$core$Task$perform,
	function (_v0) {
		return 1;
	},
	$elm$core$Process$sleep(3000));
var $author$project$Utils$HintUrls$stripePaymentMethodsUrl = 'https://dashboard.stripe.com/settings/payment_methods';
var $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg) {
			case 0:
				var cmd = model.sR ? $author$project$Ports$NewTab$open($author$project$Utils$HintUrls$stripePaymentMethodsUrl) : $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							$author$project$Ports$NewTab$open($author$project$Utils$HintUrls$stripePaymentMethodsUrl),
							$author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$stripeButtonClicked
						]));
				return {GZ: cmd, agZ: 0, aiO: model, aR: _List_Nil};
			case 1:
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{sR: true}),
					aR: _List_Nil
				};
			case 2:
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 1,
					aiO: $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$closeModal(model),
					aR: _List_Nil
				};
			default:
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 2,
					aiO: $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$closeModal(model),
					aR: _List_Nil
				};
		}
	});
var $author$project$Components$Company$VirtualBankAccounts$EnableModal$Closed = 1;
var $author$project$Components$Company$VirtualBankAccounts$EnableModal$Confirmed = 0;
var $author$project$Components$Company$VirtualBankAccounts$EnableModal$update = F2(
	function (msg, _v0) {
		var model = _v0;
		if (!msg) {
			return {
				GZ: $elm$core$Platform$Cmd$none,
				agZ: 0,
				aiO: $author$project$Components$Company$VirtualBankAccounts$EnableModal$closeModal(model),
				aR: _List_Nil
			};
		} else {
			return {
				GZ: $elm$core$Platform$Cmd$none,
				agZ: 1,
				aiO: $author$project$Components$Company$VirtualBankAccounts$EnableModal$closeModal(model),
				aR: _List_Nil
			};
		}
	});
var $author$project$Utils$Overridable$default = function (overridable) {
	if (!overridable.$) {
		var default_ = overridable.b;
		return default_;
	} else {
		var default_ = overridable.a;
		return default_;
	}
};
var $author$project$Utils$Overridable$makeDefault = function (overridable) {
	if (!overridable.$) {
		var default_ = overridable.b;
		return $author$project$Utils$Overridable$Defaulted(default_);
	} else {
		return overridable;
	}
};
var $author$project$Utils$Overridable$overriden = F2(
	function (override_, default_) {
		return A2($author$project$Utils$Overridable$Overriden, override_, default_);
	});
var $author$project$Utils$Overridable$switch = function (overridable) {
	if (!overridable.$) {
		var default_ = overridable.b;
		return $author$project$Utils$Overridable$Defaulted(default_);
	} else {
		var default_ = overridable.a;
		return A2($author$project$Utils$Overridable$Overriden, default_, default_);
	}
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$updateFormField = F2(
	function (formField, form) {
		switch (formField.$) {
			case 0:
				var overridableBool = formField.a;
				return _Utils_update(
					form,
					{Ii: overridableBool});
			case 15:
				var settingGroup = formField.a;
				var isDefault = formField.b;
				switch (settingGroup) {
					case 0:
						return isDefault ? _Utils_update(
							form,
							{
								Uo: $author$project$Utils$Overridable$makeDefault(form.Uo),
								Up: $author$project$Utils$Overridable$makeDefault(form.Up),
								If: $author$project$Utils$Overridable$makeDefault(form.If)
							}) : _Utils_update(
							form,
							{
								Uo: A2(
									$author$project$Utils$Overridable$overriden,
									$author$project$Utils$Overridable$default(form.Uo),
									$author$project$Utils$Overridable$default(form.Uo)),
								Up: A2(
									$author$project$Utils$Overridable$overriden,
									$author$project$Utils$Overridable$default(form.Up),
									$author$project$Utils$Overridable$default(form.Up)),
								If: A2(
									$author$project$Utils$Overridable$overriden,
									$author$project$Utils$Overridable$default(form.If),
									$author$project$Utils$Overridable$default(form.If))
							});
					case 1:
						return isDefault ? _Utils_update(
							form,
							{
								Ul: $author$project$Utils$Overridable$makeDefault(form.Ul),
								Um: $author$project$Utils$Overridable$makeDefault(form.Um),
								Ic: $author$project$Utils$Overridable$makeDefault(form.Ic)
							}) : _Utils_update(
							form,
							{
								Ul: A2(
									$author$project$Utils$Overridable$overriden,
									$author$project$Utils$Overridable$default(form.Ul),
									$author$project$Utils$Overridable$default(form.Ul)),
								Um: A2(
									$author$project$Utils$Overridable$overriden,
									$author$project$Utils$Overridable$default(form.Um),
									$author$project$Utils$Overridable$default(form.Um)),
								Ic: A2(
									$author$project$Utils$Overridable$overriden,
									$author$project$Utils$Overridable$default(form.Ic),
									$author$project$Utils$Overridable$default(form.Ic))
							});
					case 5:
						return isDefault ? _Utils_update(
							form,
							{
								GF: $author$project$Utils$Overridable$makeDefault(form.GF)
							}) : _Utils_update(
							form,
							{
								GF: A2(
									$author$project$Utils$Overridable$overriden,
									$author$project$Utils$Overridable$default(form.GF),
									$author$project$Utils$Overridable$default(form.GF))
							});
					case 2:
						return isDefault ? _Utils_update(
							form,
							{
								Un: $author$project$Utils$Overridable$makeDefault(form.Un),
								Id: $author$project$Utils$Overridable$makeDefault(form.Id),
								Ie: $author$project$Utils$Overridable$makeDefault(form.Ie)
							}) : _Utils_update(
							form,
							{
								Un: A2(
									$author$project$Utils$Overridable$overriden,
									$author$project$Utils$Overridable$default(form.Un),
									$author$project$Utils$Overridable$default(form.Un)),
								Id: A2(
									$author$project$Utils$Overridable$overriden,
									$author$project$Utils$Overridable$default(form.Id),
									$author$project$Utils$Overridable$default(form.Id)),
								Ie: A2(
									$author$project$Utils$Overridable$overriden,
									$author$project$Utils$Overridable$default(form.Ie),
									$author$project$Utils$Overridable$default(form.Ie))
							});
					case 3:
						return isDefault ? _Utils_update(
							form,
							{
								Ur: $author$project$Utils$Overridable$makeDefault(form.Ur),
								Ig: $author$project$Utils$Overridable$makeDefault(form.Ig)
							}) : _Utils_update(
							form,
							{
								Ur: A2(
									$author$project$Utils$Overridable$overriden,
									$author$project$Utils$Overridable$default(form.Ur),
									$author$project$Utils$Overridable$default(form.Ur)),
								Ig: A2(
									$author$project$Utils$Overridable$overriden,
									$author$project$Utils$Overridable$default(form.Ig),
									$author$project$Utils$Overridable$default(form.Ig))
							});
					default:
						return _Utils_update(
							form,
							{
								Ih: $author$project$Utils$Overridable$switch(form.Ih)
							});
				}
			case 1:
				var overridableBool = formField.a;
				return $author$project$Utils$Overridable$value(overridableBool) ? _Utils_update(
					form,
					{
						Uo: overridableBool,
						Up: A2(
							$author$project$Utils$Overridable$overriden,
							$author$project$Utils$Overridable$value(form.Up),
							$author$project$Utils$Overridable$default(form.Up)),
						If: A2(
							$author$project$Utils$Overridable$overriden,
							$author$project$Utils$Overridable$value(form.If),
							$author$project$Utils$Overridable$default(form.If))
					}) : _Utils_update(
					form,
					{
						Uo: overridableBool,
						Up: $author$project$Utils$Overridable$makeDefault(form.Up),
						If: $author$project$Utils$Overridable$makeDefault(form.If)
					});
			case 2:
				var string = formField.a;
				var autosendDay = $elm$core$String$toInt(string);
				if (!autosendDay.$) {
					var day = autosendDay.a;
					return _Utils_update(
						form,
						{
							Up: A2(
								$author$project$Utils$Overridable$overriden,
								day,
								$author$project$Utils$Overridable$default(form.Up))
						});
				} else {
					return form;
				}
			case 3:
				var string = formField.a;
				var maybeAutoSendMonth = $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$fromString(string);
				if (!maybeAutoSendMonth.$) {
					var autosendMonth = maybeAutoSendMonth.a;
					return _Utils_update(
						form,
						{
							If: A2(
								$author$project$Utils$Overridable$overriden,
								autosendMonth,
								$author$project$Utils$Overridable$default(form.If))
						});
				} else {
					return form;
				}
			case 4:
				var overridableBool = formField.a;
				return $author$project$Utils$Overridable$value(overridableBool) ? _Utils_update(
					form,
					{
						Ul: overridableBool,
						Um: A2(
							$author$project$Utils$Overridable$overriden,
							$author$project$Utils$Overridable$value(form.Um),
							$author$project$Utils$Overridable$default(form.Um)),
						Ic: A2(
							$author$project$Utils$Overridable$overriden,
							$author$project$Utils$Overridable$value(form.Ic),
							$author$project$Utils$Overridable$default(form.Ic))
					}) : _Utils_update(
					form,
					{
						Ul: overridableBool,
						Um: $author$project$Utils$Overridable$makeDefault(form.Um),
						Ic: $author$project$Utils$Overridable$makeDefault(form.Ic)
					});
			case 5:
				var string = formField.a;
				var autoIssueDay = $elm$core$String$toInt(string);
				if (!autoIssueDay.$) {
					var day = autoIssueDay.a;
					return _Utils_update(
						form,
						{
							Um: A2(
								$author$project$Utils$Overridable$overriden,
								day,
								$author$project$Utils$Overridable$default(form.Um))
						});
				} else {
					return form;
				}
			case 6:
				var string = formField.a;
				var maybeAutoIssueMonth = $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$fromString(string);
				if (!maybeAutoIssueMonth.$) {
					var autoIssueMonth = maybeAutoIssueMonth.a;
					return _Utils_update(
						form,
						{
							Ic: A2(
								$author$project$Utils$Overridable$overriden,
								autoIssueMonth,
								$author$project$Utils$Overridable$default(form.Ic))
						});
				} else {
					return form;
				}
			case 7:
				var overridableBool = formField.a;
				return $author$project$Utils$Overridable$value(overridableBool) ? _Utils_update(
					form,
					{
						Un: overridableBool,
						Id: A2(
							$author$project$Utils$Overridable$overriden,
							$author$project$Utils$Overridable$value(form.Id),
							$author$project$Utils$Overridable$default(form.Id)),
						Ie: A2(
							$author$project$Utils$Overridable$overriden,
							$author$project$Utils$Overridable$value(form.Ie),
							$author$project$Utils$Overridable$default(form.Ie))
					}) : _Utils_update(
					form,
					{
						Un: overridableBool,
						Id: $author$project$Utils$Overridable$makeDefault(form.Id),
						Ie: $author$project$Utils$Overridable$makeDefault(form.Ie)
					});
			case 8:
				var string = formField.a;
				var autoPayDay = $elm$core$String$toInt(string);
				if (!autoPayDay.$) {
					var day = autoPayDay.a;
					return _Utils_update(
						form,
						{
							Id: A2(
								$author$project$Utils$Overridable$overriden,
								day,
								$author$project$Utils$Overridable$default(form.Id))
						});
				} else {
					return form;
				}
			case 9:
				var string = formField.a;
				var maybeAutoPayMonth = $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$fromString(string);
				if (!maybeAutoPayMonth.$) {
					var autoPayMonth = maybeAutoPayMonth.a;
					return _Utils_update(
						form,
						{
							Ie: A2(
								$author$project$Utils$Overridable$overriden,
								autoPayMonth,
								$author$project$Utils$Overridable$default(form.Ie))
						});
				} else {
					return form;
				}
			case 10:
				var string = formField.a;
				var dueDay = $elm$core$String$toInt(string);
				if (!dueDay.$) {
					var day = dueDay.a;
					return _Utils_update(
						form,
						{
							Ur: A2(
								$author$project$Utils$Overridable$overriden,
								day,
								$author$project$Utils$Overridable$default(form.Ur))
						});
				} else {
					return form;
				}
			case 11:
				var string = formField.a;
				var maybeDueMonth = $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$fromString(string);
				if (!maybeDueMonth.$) {
					var month = maybeDueMonth.a;
					return _Utils_update(
						form,
						{
							Ig: A2(
								$author$project$Utils$Overridable$overriden,
								month,
								$author$project$Utils$Overridable$default(form.Ig))
						});
				} else {
					return form;
				}
			case 16:
				var overridableBool = formField.a;
				return _Utils_update(
					form,
					{fN: overridableBool});
			case 17:
				var overridableBool = formField.a;
				return _Utils_update(
					form,
					{GF: overridableBool});
			case 18:
				var overridableBool = formField.a;
				return _Utils_update(
					form,
					{Ts: overridableBool});
			case 19:
				var selectedDateOption = formField.a;
				return _Utils_update(
					form,
					{
						MH: $elm$core$Result$toMaybe(
							$justinmimbs$date$Date$fromIsoString(selectedDateOption))
					});
			case 12:
				var string = formField.a;
				var days = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(string));
				return _Utils_update(
					form,
					{
						Ih: A2(
							$author$project$Utils$Overridable$overriden,
							days,
							$author$project$Utils$Overridable$default(form.Ih))
					});
			case 13:
				var overridableBool = formField.a;
				return _Utils_update(
					form,
					{Nx: overridableBool});
			default:
				var overridableBool = formField.a;
				return _Utils_update(
					form,
					{GX: overridableBool});
		}
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				var _v1 = _Utils_Tuple2(response, model.tY);
				if ((_v1.a.$ === 3) && (_v1.b.$ === 3)) {
					var _v2 = _v1.a;
					var companySettings = _v2.a;
					var _v3 = _v1.b;
					var practiceSettings = _v3.a;
					var _v4 = A3($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$createForm, companySettings, practiceSettings, model.dd);
					var fields = _v4.a;
					var cmd = _v4.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								SD: $elm$core$Maybe$Just(
									$author$project$Utils$Form$fromValidateResult(
										A2(
											$author$project$Utils$Form$validate,
											$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$formFieldsValidator(model.dd),
											$author$project$Utils$Form$init(fields)))),
								cT: response
							}),
						cmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cT: response}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 3:
				var response = msg.a;
				var _v5 = _Utils_Tuple2(response, model.pf);
				if ((_v5.a.$ === 3) && (_v5.b.$ === 3)) {
					var _v6 = _v5.a;
					var paymentSourceSetting = _v6.a;
					var _v7 = _v5.b;
					var practicePaymentSourceSetting = _v7.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								be: $elm$core$Maybe$Just(
									$author$project$Utils$Form$fromValidateResult(
										A2(
											$author$project$Utils$Form$validate,
											$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$paymentFormFieldsValidator,
											$author$project$Utils$Form$init(
												A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$initPaymentFormFields, practicePaymentSourceSetting, paymentSourceSetting))))),
								Zh: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Zh: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 2:
				var response = msg.a;
				var _v8 = _Utils_Tuple2(response, model.Zh);
				if ((_v8.a.$ === 3) && (_v8.b.$ === 3)) {
					var _v9 = _v8.a;
					var practicePaymentSourceSetting = _v9.a;
					var _v10 = _v8.b;
					var paymentSourceSetting = _v10.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								be: $elm$core$Maybe$Just(
									$author$project$Utils$Form$init(
										A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$initPaymentFormFields, practicePaymentSourceSetting, paymentSourceSetting))),
								pf: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{pf: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var response = msg.a;
				var _v11 = _Utils_Tuple2(response, model.cT);
				if ((_v11.a.$ === 3) && (_v11.b.$ === 3)) {
					var _v12 = _v11.a;
					var practiceSettings = _v12.a;
					var _v13 = _v11.b;
					var companySettings = _v13.a;
					var _v14 = A3($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$createForm, companySettings, practiceSettings, model.dd);
					var fields = _v14.a;
					var cmd = _v14.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								SD: $elm$core$Maybe$Just(
									$author$project$Utils$Form$init(fields)),
								tY: response
							}),
						cmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{tY: response}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 4:
				var formField = msg.a;
				var _v15 = model.SD;
				if (!_v15.$) {
					var form = _v15.a;
					return function (newForm) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									SD: $elm$core$Maybe$Just(newForm)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}(
						$author$project$Utils$Form$fromValidateResult(
							A2(
								$author$project$Utils$Form$validate,
								$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$formFieldsValidator(model.dd),
								A3($author$project$Utils$Form$update, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$updateFormField, formField, form))));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				var field = msg.a;
				var _v16 = model.be;
				if (!_v16.$) {
					var form = _v16.a;
					return function (newForm) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									be: $elm$core$Maybe$Just(newForm)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}(
						A3($author$project$Utils$Form$update, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$paymentFormFieldsUpdate, field, form));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				return $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$submitCompanyInvoiceAndPaymentSetting(model);
			case 7:
				var response = msg.a;
				var _v17 = _Utils_Tuple2(response, model.tY);
				if ((_v17.a.$ === 3) && (_v17.b.$ === 3)) {
					var _v18 = _v17.a;
					var companyInvoiceSettings = _v18.a;
					var _v19 = _v17.b;
					var practiceSettings = _v19.a;
					var _v20 = A3($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$createForm, companyInvoiceSettings, practiceSettings, model.dd);
					var fields = _v20.a;
					var cmd = _v20.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								SD: $elm$core$Maybe$Just(
									$author$project$Utils$Form$init(fields)),
								cT: response
							}),
						cmd,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Invoice settings updated')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cT: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 8:
				var response = msg.a;
				var _v21 = _Utils_Tuple2(response, model.pf);
				if ((_v21.a.$ === 3) && (_v21.b.$ === 3)) {
					var _v22 = _v21.a;
					var paymentSourceSetting = _v22.a;
					var _v23 = _v21.b;
					var practicePaymentSourceSetting = _v23.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								be: $elm$core$Maybe$Just(
									$author$project$Utils$Form$init(
										A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$initPaymentFormFields, practicePaymentSourceSetting, paymentSourceSetting))),
								Zh: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Payment options settings updated')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Zh: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 9:
				var acceptsSourceBankTransfers = msg.a;
				return acceptsSourceBankTransfers ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ft: $elm$core$Maybe$Just(
								$author$project$Components$Company$VirtualBankAccounts$EnableModal$init(
									$author$project$Api$Provider$Company$One$name(model.afQ)))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{
							dQ: $elm$core$Maybe$Just(
								$author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$init(
									$author$project$Api$Provider$Company$One$name(model.afQ)))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 10:
				var subMsg = msg.a;
				var _v24 = model.ft;
				if (!_v24.$) {
					var virtualBankAccountEnableModal = _v24.a;
					var modalResult = A2($author$project$Components$Company$VirtualBankAccounts$EnableModal$update, subMsg, virtualBankAccountEnableModal);
					var _v25 = modalResult.agZ;
					if (_v25 === 1) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ft: $elm$core$Maybe$Just(
										$author$project$Components$Company$VirtualBankAccounts$EnableModal$closeModal(virtualBankAccountEnableModal))
								}),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountEnableModalMsg, modalResult.GZ),
							modalResult.aR);
					} else {
						var createCmd = A3(
							$author$project$Api$Provider$VirtualBankAccount$create,
							model.Gv,
							$author$project$Api$Provider$Company$One$id(model.afQ),
							$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountCreated);
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ft: $elm$core$Maybe$Just(modalResult.aiO)
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										createCmd,
										A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountEnableModalMsg, modalResult.GZ)
									])),
							modalResult.aR);
					}
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ft: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 11:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						A3(
							$author$project$Api$Provider$VirtualBankAccount$list,
							model.Gv,
							$author$project$Api$Provider$Company$One$id(model.afQ),
							$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$GotVirtualBankAccount),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Bank Transfer account enabled')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 12:
				var response = msg.a;
				if (response.$ === 3) {
					var virtualBankAccounts = response.a;
					return $elm$core$List$isEmpty(virtualBankAccounts) ? _Utils_Tuple3(
						_Utils_update(
							model,
							{F7: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil) : _Utils_Tuple3(
						_Utils_update(
							model,
							{
								F7: $elm$core$Maybe$Just(virtualBankAccounts)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{F7: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 13:
				var subMsg = msg.a;
				var _v28 = model.dQ;
				if (!_v28.$) {
					var virtualBankAccountAuthorizeModal = _v28.a;
					var modalResult = A2($author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$update, subMsg, virtualBankAccountAuthorizeModal);
					var _v29 = modalResult.agZ;
					switch (_v29) {
						case 0:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										dQ: $elm$core$Maybe$Just(modalResult.aiO)
									}),
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountAuthorizeModalMsg, modalResult.GZ),
								modalResult.aR);
						case 2:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										dQ: $elm$core$Maybe$Just(
											$author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$closeModal(virtualBankAccountAuthorizeModal))
									}),
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountAuthorizeModalMsg, modalResult.GZ),
								modalResult.aR);
						default:
							var createCmd = A3(
								$author$project$Api$Provider$VirtualBankAccount$authorizeAndCreate,
								model.Gv,
								$author$project$Api$Provider$Company$One$id(model.afQ),
								$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountAuthorizedAndConfirmed);
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										dQ: $elm$core$Maybe$Just(
											$author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$closeModal(virtualBankAccountAuthorizeModal))
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountAuthorizeModalMsg, modalResult.GZ),
											createCmd
										])),
								modalResult.aR);
					}
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dQ: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						A3(
							$author$project$Api$Provider$VirtualBankAccount$list,
							model.Gv,
							$author$project$Api$Provider$Company$One$id(model.afQ),
							$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$GotVirtualBankAccount),
						_List_fromArray(
							[
								A2(
								$author$project$OutMsg$ShowToast,
								3,
								'Authorization confirmed and transfer details created for ' + $author$project$Api$Provider$Company$One$name(model.afQ))
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$CompanyInvoiceSettingsSubmitted = {$: 6};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$chargePhiDetailsUpdatedAt = function (_v0) {
	var forCompany = _v0;
	return forCompany.Ny;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$chargePhiDetailsUpdatedBy = function (_v0) {
	var forCompany = _v0;
	return forCompany.Nz;
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$justFormAndSuccessfulSetting = F2(
	function (func, maybeForm) {
		if (!maybeForm.$) {
			var form = maybeForm.a;
			return func(form);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$ConfirmAndEnable = 2;
var $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$GoToStripeClicked = 0;
var $author$project$Utils$HintUrls$stripeBankTransfersUrl = 'https://docs.stripe.com/payments/bank-transfers';
var $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$modal = function (_v0) {
	var model = _v0;
	return model.Ao ? A3(
		$author$project$Ui$Modal$view,
		3,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Stripe Authorization Needed')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$onSubmit(2)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[
										$author$project$Ui$Typography$fontWeight(1)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('To activate bank transfers for employers, you will first need to turn on bank transfer payments in Stripe. Click “Go to Stripe” to complete the setup.'),
										A2($elm$html$Html$br, _List_Nil, _List_Nil),
										A2($elm$html$Html$br, _List_Nil, _List_Nil),
										A3(
										$author$project$Ui$Link$externalHref,
										$author$project$Utils$HintUrls$stripeBankTransfersUrl,
										_List_fromArray(
											[$author$project$Ui$Link$targetBlank]),
										_List_fromArray(
											[
												$elm$html$Html$text('Learn More')
											]))
									]))
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$justifyCenter]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Cancel and close modal'},
								_List_fromArray(
									[
										$author$project$Ui$Button$onClick(3)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Cancel')
									])),
								model.sR ? A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$ml2]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Go to stripe'},
										_List_fromArray(
											[
												$author$project$Ui$Button$onClick(0)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Go to Stripe')
											])),
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Confirm and enable bank transfers'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$onClick(2),
												$author$project$Ui$Button$submit
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Confirm and Enable')
											]))
									])) : A3(
								$author$project$Ui$Button$view,
								{mm: 'Go to stripe'},
								_List_fromArray(
									[
										$author$project$Ui$Button$primary,
										$author$project$Ui$Button$onClick(0)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Go to Stripe')
									]))
							]))
					]))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Components$Company$VirtualBankAccounts$EnableModal$Confirm = 0;
var $author$project$Components$Company$VirtualBankAccounts$EnableModal$modal = function (_v0) {
	var model = _v0;
	return model.Ao ? A3(
		$author$project$Ui$Modal$view,
		1,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Enable Bank Transfers for ' + model.Og)
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$onSubmit(0)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[
										$author$project$Ui$Typography$helpBlock,
										$author$project$Ui$Typography$fontWeight(1)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Clicking Confirm will allow the employer to transfer funds directly to that account to pay invoices. This setting will apply to all future invoices for this employer.')
									]))
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$textCenter]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Cancel and close modal'},
								_List_fromArray(
									[
										$author$project$Ui$Button$onClick(1)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Cancel')
									])),
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Confirm'},
								_List_fromArray(
									[
										$author$project$Ui$Button$primary,
										$author$project$Ui$Button$onClick(0),
										$author$project$Ui$Button$submit
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Confirm')
									]))
							]))
					]))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$ChargePhiDetailsEnabled = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged = function (a) {
	return {$: 4, a: a};
};
var $author$project$Utils$Overridable$isOverriden = function (overridable) {
	if (!overridable.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Utils$Overridable$override = F2(
	function (override_, overridable) {
		return A2(
			$author$project$Utils$Overridable$Overriden,
			override_,
			$author$project$Utils$Overridable$default(overridable));
	});
var $author$project$Formatters$Bool$toOnOff = function (bool) {
	return bool ? 'On' : 'Off';
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewChargePhiDetailsEnabled = function (form) {
	var fields = $author$project$Utils$Form$fields(form);
	var overrideText = $author$project$Utils$Overridable$isOverriden(fields.Nx) ? 'Remove override' : 'Override';
	var value = $author$project$Utils$Overridable$value(fields.Nx);
	return _Utils_ap(
		$author$project$Utils$Overridable$isOverriden(fields.Nx) ? _List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$view(
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$on(value),
						$author$project$Ui$ToggleSwitch$onChange(
						function (bool) {
							return $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged(
								$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$ChargePhiDetailsEnabled(
									A2($author$project$Utils$Overridable$override, bool, fields.Nx)));
						})
					]))
			]) : _List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$justifyRight]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Formatters$Bool$toOnOff(value))
							]))
					]))
			]),
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{mm: overrideText},
				_List_fromArray(
					[
						$author$project$Ui$Button$link,
						$author$project$Ui$Button$onClick(
						$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged(
							$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$ChargePhiDetailsEnabled(
								$author$project$Utils$Overridable$switch(fields.Nx))))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(overrideText)
					]))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$ChargeRouteToRecurringInvoice = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewChargeRouteToRecurringInvoice = function (form) {
	var fields = $author$project$Utils$Form$fields(form);
	var overrideText = $author$project$Utils$Overridable$isOverriden(fields.GX) ? 'Remove override' : 'Override';
	var value = $author$project$Utils$Overridable$value(fields.GX);
	return _Utils_ap(
		$author$project$Utils$Overridable$isOverriden(fields.GX) ? _List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$justifyRight]),
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$view(
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$on(value),
								$author$project$Ui$ToggleSwitch$onChange(
								function (bool) {
									return $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged(
										$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$ChargeRouteToRecurringInvoice(
											A2($author$project$Utils$Overridable$override, bool, fields.GX)));
								})
							]))
					]))
			]) : _List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$justifyRight]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Formatters$Bool$toOnOff(value))
							]))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$justifyRight]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: overrideText},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$onClick(
								$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged(
									$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$ChargeRouteToRecurringInvoice(
										$author$project$Utils$Overridable$switch(fields.GX))))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(overrideText)
							]))
					]))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$BillingEnabled = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$OverrideToggle = F2(
	function (a, b) {
		return {$: 15, a: a, b: b};
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$StartDateToggleBilling = 5;
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewEnableBillingToggle = F2(
	function (isHintAdmin, form) {
		var fields = $author$project$Utils$Form$fields(form);
		return _Utils_ap(
			$author$project$Utils$Overridable$isOverriden(fields.GF) ? _List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$justifyRight]),
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$view(
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$on(
									$author$project$Utils$Overridable$value(fields.GF)),
									$author$project$Ui$ToggleSwitch$disabled(!isHintAdmin),
									$author$project$Ui$ToggleSwitch$onChange(
									function (bool) {
										return $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged(
											$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$BillingEnabled(
												A2($author$project$Utils$Overridable$override, bool, fields.GF)));
									})
								]))
						]))
				]) : _List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$justifyRight]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Formatters$Bool$toOnOff(
										$author$project$Utils$Overridable$value(fields.GF)))
								]))
						]))
				]),
			_List_fromArray(
				[
					function () {
					if (isHintAdmin) {
						var overrideText = $author$project$Utils$Overridable$isOverriden(fields.GF) ? 'Remove override' : 'Override';
						return A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$justifyRight]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$HinterOnly$button,
									{mm: overrideText},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged(
												A2(
													$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$OverrideToggle,
													5,
													$author$project$Utils$Overridable$isOverriden(fields.GF))))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(overrideText)
										]))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewEnableBilling = F2(
	function (isHintAdmin, form) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Billing (Hinter only)')
						])),
					A2(
					$author$project$Ui$Grid$row,
					_List_fromArray(
						[$author$project$Ui$Grid$mb4]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanMd(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('We will bill sponsors when this setting is enabled. When this setting is disabled, we will not bill sponsors, but are still tracking employee eligibility.')
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanMd(6)
								]),
							A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewEnableBillingToggle, isHintAdmin, form))
						])),
					$author$project$Ui$HorizontalRule$view(_List_Nil)
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$BillingEnabledDateToggle = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$BillingStartDateSelected = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewEnabledBillingSelectedDropdownDate = F2(
	function (billingStartDate, currentDate) {
		if (!billingStartDate.$) {
			var date = billingStartDate.a;
			return date;
		} else {
			return currentDate;
		}
	});
var $author$project$Utils$Date$changeDay = F2(
	function (day, date) {
		var year = $justinmimbs$date$Date$year(date);
		var month = $justinmimbs$date$Date$month(date);
		return A3($justinmimbs$date$Date$fromCalendarDate, year, month, day);
	});
var $author$project$Utils$Date$toBeginningOfMonth = function (date) {
	return A2($author$project$Utils$Date$changeDay, 1, date);
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewEnabledBillingStartDateOptions = function (startDate) {
	return $author$project$Ui$Form$Select$dateOptions(
		$author$project$Utils$Date$nextTwelveMonths(
			$author$project$Utils$Date$toBeginningOfMonth(startDate)));
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewEnableBillingDate = F2(
	function (form, currentDate) {
		var fields = $author$project$Utils$Form$fields(form);
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$justifyRight]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mr-2')
							]),
						_List_fromArray(
							[
								$author$project$Utils$Overridable$value(fields.fN) ? A2(
								$author$project$Ui$Form$Select$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Select$value(
										$elm$core$Maybe$Just(
											$author$project$Utils$Date$toIsoString(
												A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewEnabledBillingSelectedDropdownDate, fields.MH, currentDate)))),
										$author$project$Ui$Form$Select$onChange(
										A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$BillingStartDateSelected))
									]),
								$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewEnabledBillingStartDateOptions(currentDate)) : $author$project$Utils$Html$empty
							])),
						$author$project$Ui$ToggleSwitch$view(
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$on(
								$author$project$Utils$Overridable$value(fields.fN)),
								$author$project$Ui$ToggleSwitch$onChange(
								function (bool) {
									return $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged(
										$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$BillingEnabledDateToggle(
											A2($author$project$Utils$Overridable$override, bool, fields.fN)));
								})
							]))
					]))
			]);
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewEnableBillingStartDate = F2(
	function (form, currentDate) {
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					($author$project$Utils$Overridable$value(fields.GF) && $author$project$Utils$Overridable$isOverriden(fields.GF)) ? A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('Start billing in the future')
								])),
							A2(
							$author$project$Ui$Grid$row,
							_List_fromArray(
								[$author$project$Ui$Grid$mb4]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanMd(6)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Select a date when sponsor billing will start. Changing this date will cause all draft and outstanding invoices to be CANCELLED.')
												]))
										])),
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanMd(6)
										]),
									A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewEnableBillingDate, form, currentDate))
								])),
							$author$project$Ui$HorizontalRule$view(_List_Nil)
						])) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$HideSponsorInvoices = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewHideSponsorInvoicesToggle = F2(
	function (isHintAdmin, form) {
		var fields = $author$project$Utils$Form$fields(form);
		return _Utils_ap(
			$author$project$Utils$Overridable$isOverriden(fields.Ts) ? _List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$justifyRight]),
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$view(
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$on(
									$author$project$Utils$Overridable$value(fields.Ts)),
									$author$project$Ui$ToggleSwitch$disabled(!isHintAdmin),
									$author$project$Ui$ToggleSwitch$onChange(
									function (bool) {
										return $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged(
											$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$HideSponsorInvoices(
												A2($author$project$Utils$Overridable$override, bool, fields.Ts)));
									})
								]))
						]))
				]) : _List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$justifyRight]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Formatters$Bool$toOnOff(
										$author$project$Utils$Overridable$value(fields.Ts)))
								]))
						]))
				]),
			_List_fromArray(
				[
					function () {
					if (isHintAdmin) {
						var overrideText = $author$project$Utils$Overridable$isOverriden(fields.Ts) ? 'Remove override' : 'Override';
						return A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$justifyRight]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$HinterOnly$button,
									{mm: overrideText},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged(
												$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$HideSponsorInvoices(
													$author$project$Utils$Overridable$switch(fields.Ts))))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(overrideText)
										]))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewHideSponsorInvoices = F2(
	function (isHintAdmin, form) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Hide Sponsor Invoice Tab (Hinter only)')
						])),
					A2(
					$author$project$Ui$Grid$row,
					_List_fromArray(
						[$author$project$Ui$Grid$mb4]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanMd(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('When billing is disabled for sponsors, the Invoices tab will be hidden in the employer portal.')
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanMd(6)
								]),
							A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewHideSponsorInvoicesToggle, isHintAdmin, form))
						])),
					$author$project$Ui$HorizontalRule$view(_List_Nil)
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AutoIssue = 1;
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoIssue = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoIssueDay = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoIssueMonth = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$daysOfMonth = A2($elm$core$List$range, 1, 31);
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$invoiceDayOptions = A2(
	$elm$core$List$map,
	function (day) {
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(
				$elm$core$String$fromInt(day)),
			$author$project$Formatters$Int$ordinal(day));
	},
	$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$daysOfMonth);
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$monthOptions = A2(
	$elm$core$List$map,
	function (option) {
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(
				$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(option)),
			$author$project$Formatters$String$humanize(
				$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(option)));
	},
	$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$enumerate);
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewErrorRow = function (message) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'padding-top', '10px')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(12)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[
										$author$project$Ui$Typography$danger,
										$author$project$Ui$Typography$small,
										$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(message)
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewInvoiceAutoIssue = function (form) {
	var fields = $author$project$Utils$Form$fields(form);
	var invoiceAutoIssue = $author$project$Utils$Overridable$value(fields.Ul);
	var invoiceAutoIssueDay = $author$project$Utils$Overridable$value(fields.Um);
	var invoiceAutoIssueMonth = $author$project$Utils$Overridable$value(fields.Ic);
	var overrideText = $author$project$Utils$Overridable$isOverriden(fields.Ul) ? 'Remove override' : 'Override';
	return _Utils_ap(
		function () {
			if ($author$project$Utils$Overridable$isOverriden(fields.Ul)) {
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$offset(1),
										$author$project$Ui$Grid$spanMd(5)
									]),
								_List_fromArray(
									[
										invoiceAutoIssue ? A2(
										$author$project$Ui$Form$Select$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Select$value(
												$elm$core$Maybe$Just(
													$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(invoiceAutoIssueMonth))),
												$author$project$Ui$Form$Select$onChange(
												A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoIssueMonth)),
												$author$project$Ui$Form$Select$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, 5, form))
											]),
										$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$monthOptions) : $author$project$Utils$Html$empty
									])),
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanMd(3)
									]),
								_List_fromArray(
									[
										invoiceAutoIssue ? A2(
										$author$project$Ui$Form$Select$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Select$value(
												$elm$core$Maybe$Just(
													$elm$core$String$fromInt(invoiceAutoIssueDay))),
												$author$project$Ui$Form$Select$onChange(
												A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoIssueDay)),
												$author$project$Ui$Form$Select$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, 5, form))
											]),
										$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$invoiceDayOptions) : $author$project$Utils$Html$empty
									])),
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanMd(3)
									]),
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$view(
										_List_fromArray(
											[
												$author$project$Ui$ToggleSwitch$on(invoiceAutoIssue),
												$author$project$Ui$ToggleSwitch$onChange(
												function (bool) {
													return $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged(
														$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoIssue(
															A2($author$project$Utils$Overridable$override, bool, fields.Ul)));
												})
											]))
									]))
							])),
						A2($author$project$Utils$Form$hasValidationErrors, 5, form) ? A2(
						$elm$html$Html$div,
						_List_Nil,
						A2(
							$elm$core$List$map,
							$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewErrorRow,
							A2($author$project$Utils$Form$validationErrors, 5, form))) : $author$project$Utils$Html$empty
					]);
			} else {
				var settingsText = invoiceAutoIssue ? ($author$project$Formatters$String$humanize(
					$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(invoiceAutoIssueMonth)) + (', on the ' + $author$project$Formatters$Int$ordinal(invoiceAutoIssueDay))) : $author$project$Formatters$Bool$toOnOff(invoiceAutoIssue);
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$justifyRight]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(settingsText)
									]))
							]))
					]);
			}
		}(),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$justifyRight]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: overrideText},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$onClick(
								$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged(
									A2(
										$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$OverrideToggle,
										1,
										$author$project$Utils$Overridable$isOverriden(fields.Ul))))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(overrideText)
							]))
					]))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AutoPay = 2;
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoPay = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoPayDay = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoPayMonth = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewInvoiceAutoPay = function (form) {
	var fields = $author$project$Utils$Form$fields(form);
	var invoiceAutoPay = $author$project$Utils$Overridable$value(fields.Un);
	var invoiceAutoPayDay = $author$project$Utils$Overridable$value(fields.Id);
	var invoiceAutoPayMonth = $author$project$Utils$Overridable$value(fields.Ie);
	var overrideText = $author$project$Utils$Overridable$isOverriden(fields.Un) ? 'Remove override' : 'Override';
	return _Utils_ap(
		function () {
			if ($author$project$Utils$Overridable$isOverriden(fields.Un)) {
				var hasValidationErrors = A2($author$project$Utils$Form$hasValidationErrors, 3, form) || A2($author$project$Utils$Form$hasValidationErrors, 4, form);
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$offsetMd(1),
										$author$project$Ui$Grid$spanMd(5)
									]),
								_List_fromArray(
									[
										invoiceAutoPay ? A2(
										$author$project$Ui$Form$Select$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Select$value(
												$elm$core$Maybe$Just(
													$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(invoiceAutoPayMonth))),
												$author$project$Ui$Form$Select$onChange(
												A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoPayMonth)),
												$author$project$Ui$Form$Select$invalid(hasValidationErrors)
											]),
										$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$monthOptions) : $author$project$Utils$Html$empty
									])),
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanMd(3)
									]),
								_List_fromArray(
									[
										invoiceAutoPay ? A2(
										$author$project$Ui$Form$Select$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Select$value(
												$elm$core$Maybe$Just(
													$elm$core$String$fromInt(invoiceAutoPayDay))),
												$author$project$Ui$Form$Select$onChange(
												A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoPayDay)),
												$author$project$Ui$Form$Select$invalid(hasValidationErrors)
											]),
										$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$invoiceDayOptions) : $author$project$Utils$Html$empty
									])),
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanMd(3)
									]),
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$view(
										_List_fromArray(
											[
												$author$project$Ui$ToggleSwitch$on(invoiceAutoPay),
												$author$project$Ui$ToggleSwitch$onChange(
												function (bool) {
													return $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged(
														$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoPay(
															A2($author$project$Utils$Overridable$override, bool, fields.Un)));
												})
											]))
									]))
							])),
						hasValidationErrors ? A2(
						$elm$html$Html$div,
						_List_Nil,
						_Utils_ap(
							A2(
								$elm$core$List$map,
								$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewErrorRow,
								A2($author$project$Utils$Form$validationErrors, 3, form)),
							A2(
								$elm$core$List$map,
								$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewErrorRow,
								A2($author$project$Utils$Form$validationErrors, 4, form)))) : $author$project$Utils$Html$empty
					]);
			} else {
				var settingsText = invoiceAutoPay ? ($author$project$Formatters$String$humanize(
					$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(invoiceAutoPayMonth)) + (', on the ' + $author$project$Formatters$Int$ordinal(invoiceAutoPayDay))) : $author$project$Formatters$Bool$toOnOff(invoiceAutoPay);
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$justifyRight]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(settingsText)
									]))
							]))
					]);
			}
		}(),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$justifyRight]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: overrideText},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$onClick(
								$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged(
									A2(
										$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$OverrideToggle,
										2,
										$author$project$Utils$Overridable$isOverriden(fields.Un))))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(overrideText)
							]))
					]))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AutoSend = 0;
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoSend = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoSendDay = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoSendMonth = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewInvoiceAutoSend = function (form) {
	var fields = $author$project$Utils$Form$fields(form);
	var invoiceAutoSend = $author$project$Utils$Overridable$value(fields.Uo);
	var invoiceAutoSendDay = $author$project$Utils$Overridable$value(fields.Up);
	var invoiceAutoSendMonth = $author$project$Utils$Overridable$value(fields.If);
	var overrideText = $author$project$Utils$Overridable$isOverriden(fields.Uo) ? 'Remove override' : 'Override';
	return _Utils_ap(
		function () {
			if ($author$project$Utils$Overridable$isOverriden(fields.Uo)) {
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$offset(1),
										$author$project$Ui$Grid$spanMd(5)
									]),
								_List_fromArray(
									[
										invoiceAutoSend ? A2(
										$author$project$Ui$Form$Select$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Select$value(
												$elm$core$Maybe$Just(
													$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(invoiceAutoSendMonth))),
												$author$project$Ui$Form$Select$onChange(
												A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoSendMonth)),
												$author$project$Ui$Form$Select$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, 1, form))
											]),
										$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$monthOptions) : $author$project$Utils$Html$empty
									])),
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanMd(3)
									]),
								_List_fromArray(
									[
										invoiceAutoSend ? A2(
										$author$project$Ui$Form$Select$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Select$value(
												$elm$core$Maybe$Just(
													$elm$core$String$fromInt(invoiceAutoSendDay))),
												$author$project$Ui$Form$Select$onChange(
												A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoSendDay)),
												$author$project$Ui$Form$Select$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, 1, form))
											]),
										$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$invoiceDayOptions) : $author$project$Utils$Html$empty
									])),
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanMd(3)
									]),
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$view(
										_List_fromArray(
											[
												$author$project$Ui$ToggleSwitch$on(invoiceAutoSend),
												$author$project$Ui$ToggleSwitch$onChange(
												function (bool) {
													return $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged(
														$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoSend(
															A2($author$project$Utils$Overridable$override, bool, fields.Uo)));
												})
											]))
									]))
							])),
						A2($author$project$Utils$Form$hasValidationErrors, 1, form) ? A2(
						$elm$html$Html$div,
						_List_Nil,
						A2(
							$elm$core$List$map,
							$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewErrorRow,
							A2($author$project$Utils$Form$validationErrors, 1, form))) : $author$project$Utils$Html$empty
					]);
			} else {
				var settingsText = invoiceAutoSend ? ($author$project$Formatters$String$humanize(
					$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(invoiceAutoSendMonth)) + (', on the ' + $author$project$Formatters$Int$ordinal(invoiceAutoSendDay))) : $author$project$Formatters$Bool$toOnOff(invoiceAutoSend);
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$justifyRight]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(settingsText)
									]))
							]))
					]);
			}
		}(),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$justifyRight]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: overrideText},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$onClick(
								$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged(
									A2(
										$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$OverrideToggle,
										0,
										$author$project$Utils$Overridable$isOverriden(fields.Uo))))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(overrideText)
							]))
					]))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$DueDate = 3;
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceDueDay = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceDueMonth = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewInvoiceDueDay = function (form) {
	var fields = $author$project$Utils$Form$fields(form);
	var invoiceDueDay = $author$project$Utils$Overridable$value(fields.Ur);
	var invoiceDueMonth = $author$project$Utils$Overridable$value(fields.Ig);
	var overrideText = $author$project$Utils$Overridable$isOverriden(fields.Ur) ? 'Remove override' : 'Override';
	return _Utils_ap(
		function () {
			if ($author$project$Utils$Overridable$isOverriden(fields.Ur)) {
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$offsetMd(4),
										$author$project$Ui$Grid$spanMd(5)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Select$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Select$value(
												$elm$core$Maybe$Just(
													$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(invoiceDueMonth))),
												$author$project$Ui$Form$Select$onChange(
												A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceDueMonth)),
												$author$project$Ui$Form$Select$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, 6, form))
											]),
										$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$monthOptions)
									])),
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanMd(3)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Select$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Select$value(
												$elm$core$Maybe$Just(
													$elm$core$String$fromInt(invoiceDueDay))),
												$author$project$Ui$Form$Select$onChange(
												A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceDueDay)),
												$author$project$Ui$Form$Select$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, 6, form))
											]),
										$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$invoiceDayOptions)
									]))
							])),
						A2($author$project$Utils$Form$hasValidationErrors, 6, form) ? A2(
						$elm$html$Html$div,
						_List_Nil,
						A2(
							$elm$core$List$map,
							$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewErrorRow,
							A2($author$project$Utils$Form$validationErrors, 6, form))) : $author$project$Utils$Html$empty
					]);
			} else {
				var settingsText = $author$project$Formatters$String$humanize(
					$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(invoiceDueMonth)) + (', on the ' + $author$project$Formatters$Int$ordinal(invoiceDueDay));
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$justifyRight]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(settingsText)
									]))
							]))
					]);
			}
		}(),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$justifyRight]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: overrideText},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$onClick(
								$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged(
									A2(
										$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$OverrideToggle,
										3,
										$author$project$Utils$Overridable$isOverriden(fields.Ur))))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(overrideText)
							]))
					]))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$GracePeriod = 4;
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceGracePeriodDays = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewInvoiceGracePeriodDays = function (form) {
	var fields = $author$project$Utils$Form$fields(form);
	var invoiceGracePeriodDays = $author$project$Utils$Overridable$value(fields.Ih);
	var overrideText = $author$project$Utils$Overridable$isOverriden(fields.Ih) ? 'Remove override' : 'Override';
	return _Utils_ap(
		$author$project$Utils$Overridable$isOverriden(fields.Ih) ? _List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$offset(6),
								$author$project$Ui$Grid$spanMd(6)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$group(
								A2(
									$author$project$Ui$Form$Input$withPreAddon,
									'# of days',
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(
											$elm$core$String$fromInt(invoiceGracePeriodDays)),
											$author$project$Ui$Form$Input$onInput(
											A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceGracePeriodDays))
										])))
							]))
					]))
			]) : _List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$justifyRight]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$Formatters$String$pluralize, 'day', invoiceGracePeriodDays))
							]))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$justifyRight]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: overrideText},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$onClick(
								$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged(
									A2(
										$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$OverrideToggle,
										4,
										$author$project$Utils$Overridable$isOverriden(fields.Ih))))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(overrideText)
							]))
					]))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceUpcomingAutoSend = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewInvoiceUpcomingAutoSend = function (form) {
	var fields = $author$project$Utils$Form$fields(form);
	var invoiceUpcomingAutoSend = $author$project$Utils$Overridable$value(fields.Ii);
	var overrideText = $author$project$Utils$Overridable$isOverriden(fields.Ii) ? 'Remove override' : 'Override';
	return _Utils_ap(
		$author$project$Utils$Overridable$isOverriden(fields.Ii) ? _List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$flexCol]),
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$view(
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$on(invoiceUpcomingAutoSend),
								$author$project$Ui$ToggleSwitch$onChange(
								function (bool) {
									return $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged(
										$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceUpcomingAutoSend(
											A2($author$project$Utils$Overridable$override, bool, fields.Ii)));
								})
							]))
					])),
				A2($author$project$Utils$Form$hasValidationErrors, 0, form) ? A2(
				$elm$html$Html$div,
				_List_Nil,
				A2(
					$elm$core$List$map,
					$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewErrorRow,
					A2($author$project$Utils$Form$validationErrors, 0, form))) : $author$project$Utils$Html$empty
			]) : _List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Formatters$Bool$toOnOff(invoiceUpcomingAutoSend))
							]))
					]))
			]),
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{mm: overrideText},
				_List_fromArray(
					[
						$author$project$Ui$Button$link,
						$author$project$Ui$Button$onClick(
						$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged(
							$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceUpcomingAutoSend(
								$author$project$Utils$Overridable$switch(fields.Ii))))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(overrideText)
					]))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AcceptsAch = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AcceptsAmex = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AcceptsCards = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$PaymentFormFieldUpdated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewAcceptsSource = F3(
	function (acceptsSource, acceptsSourceField, label) {
		var acceptsSourceBool = $author$project$Utils$Overridable$value(acceptsSource);
		var acceptsFieldType = function () {
			switch (acceptsSourceField.$) {
				case 0:
					return $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AcceptsAch;
				case 1:
					return $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AcceptsCards;
				default:
					return $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AcceptsAmex;
			}
		}();
		var overrideBtn = A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$justifyRight]),
			_List_fromArray(
				[
					function () {
					var buttonLabel = $author$project$Utils$Overridable$isOverriden(acceptsSource) ? 'Remove override' : 'Override';
					return A3(
						$author$project$Ui$Button$view,
						{mm: label},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$onClick(
								$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$PaymentFormFieldUpdated(
									acceptsFieldType(
										$author$project$Utils$Overridable$switch(acceptsSource))))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(buttonLabel)
							]));
				}()
				]));
		return $author$project$Utils$Overridable$isOverriden(acceptsSource) ? A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanMd(6)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$titleSm,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(label)
								]))
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanMd(6),
							$author$project$Ui$Grid$justifyRight
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$view(
									_List_fromArray(
										[
											$author$project$Ui$ToggleSwitch$on(acceptsSourceBool),
											$author$project$Ui$ToggleSwitch$onChange(
											function (bool) {
												return $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$PaymentFormFieldUpdated(
													acceptsFieldType(
														A2($author$project$Utils$Overridable$override, bool, acceptsSource)));
											})
										]))
								])),
							overrideBtn
						]))
				])) : A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanMd(6)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$titleSm,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(label)
								]))
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanMd(6),
							$author$project$Ui$Grid$justifyRight
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Formatters$Bool$toOnOff(acceptsSourceBool))
								])),
							overrideBtn
						]))
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountEnableModalClicked = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Provider$Practice$Shared$hasBankTransfersCapability = function (_v0) {
	var record = _v0;
	return record.S4;
};
var $author$project$Api$Provider$Practice$One$hasBankTransfersCapability = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$hasBankTransfersCapability(shared);
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewVirtualBankAccountsActions = F2(
	function (model, label) {
		return A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanMd(6)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h5,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('m-0')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(label)
								]))
						])),
					function () {
					var _v0 = model.F7;
					if (!_v0.$) {
						var companyId = $author$project$Api$Provider$Company$One$id(model.afQ);
						var route = $author$project$Spa$Generated$Route$Companies__CompanyId_String__PaymentSources(
							{fZ: companyId});
						return A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanMd(6),
									$author$project$Ui$Grid$justifyRight
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Formatters$Bool$toOnOff(true))
										])),
									A3(
									$author$project$Ui$Link$route,
									route,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('View Transfer Details')
										]))
								]));
					} else {
						return A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanMd(6),
									$author$project$Ui$Grid$justifyRight
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$justifyRight]),
									_List_fromArray(
										[
											function () {
											var acceptsSourceBankTransfers = $author$project$Api$Provider$Practice$One$hasBankTransfersCapability(model.ZV);
											var verb = acceptsSourceBankTransfers ? 'Enable' : 'Authorize';
											return A3(
												$author$project$Ui$Button$view,
												{mm: verb + ' transfer details'},
												_List_fromArray(
													[
														$author$project$Ui$Button$onClick(
														$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountEnableModalClicked(acceptsSourceBankTransfers))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(verb)
													]));
										}()
										]))
								]));
					}
				}()
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewPaymentOptions = F3(
	function (model, fields, sponsorized) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Payment Options')
						])),
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanMd(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Choose payment options available to  ' + (sponsorized + 's.'))
										]))
								]))
						])),
					A2($author$project$Api$Provider$Practice$One$featureEnabled, 11, model.ZV) ? A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewVirtualBankAccountsActions, model, 'Accept Bank Transfers') : $author$project$Utils$Html$empty,
					A3(
					$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewAcceptsSource,
					fields.KA,
					$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AcceptsAch(fields.KA),
					'Accept Bank Accounts'),
					A3(
					$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewAcceptsSource,
					fields.KC,
					$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AcceptsCards(fields.KC),
					'Accept Credit Cards'),
					A3(
					$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewAcceptsSource,
					fields.KB,
					$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AcceptsAmex(fields.KB),
					'Accept American Express')
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewPaymentSettingsForm = F2(
	function (model, form) {
		var sponsorized = A2($author$project$Formatters$String$sponsorize, model.ZV, 'employer');
		var fields = $author$project$Utils$Form$fields(form);
		return _List_fromArray(
			[
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				A3($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewPaymentOptions, model, fields, sponsorized)
			]);
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$createTimelineEventAttributes = F2(
	function (fields, today) {
		var createTimelineDate = $author$project$Components$InvoiceSetting$Timeline$createTimelineDate(today);
		var dueDate = A2(
			createTimelineDate,
			$author$project$Utils$Overridable$value(fields.Ig),
			$author$project$Utils$Overridable$value(fields.Ur));
		var unpaidDate = A3(
			$justinmimbs$date$Date$add,
			3,
			$author$project$Utils$Overridable$value(fields.Ih),
			A2(
				createTimelineDate,
				$author$project$Utils$Overridable$value(fields.Ig),
				$author$project$Utils$Overridable$value(fields.Ur)));
		var upcomingDate = A3(
			$justinmimbs$date$Date$add,
			2,
			-1,
			A2(
				createTimelineDate,
				$author$project$Utils$Overridable$value(fields.If),
				$author$project$Utils$Overridable$value(fields.Up)));
		var autopayDate = A2(
			createTimelineDate,
			$author$project$Utils$Overridable$value(fields.Ie),
			$author$project$Utils$Overridable$value(fields.Id));
		var autoSendDate = A2(
			createTimelineDate,
			$author$project$Utils$Overridable$value(fields.If),
			$author$project$Utils$Overridable$value(fields.Up));
		var autoIssueDate = A2(
			createTimelineDate,
			$author$project$Utils$Overridable$value(fields.Ic),
			$author$project$Utils$Overridable$value(fields.Um));
		return _List_fromArray(
			[
				_Utils_Tuple3(
				$author$project$Utils$Overridable$value(fields.Ii) && $author$project$Utils$Overridable$value(fields.Uo),
				upcomingDate,
				'Send \"Upcoming\" email'),
				_Utils_Tuple3(
				$author$project$Utils$Overridable$value(fields.Uo),
				autoSendDate,
				'Send \"Created\" email'),
				_Utils_Tuple3(
				$author$project$Utils$Overridable$value(fields.Ul),
				autoIssueDate,
				'Issue Invoice'),
				_Utils_Tuple3(
				$author$project$Utils$Overridable$value(fields.Un),
				autopayDate,
				'Autopay Invoice'),
				_Utils_Tuple3(true, dueDate, 'Due Date'),
				_Utils_Tuple3(true, unpaidDate, 'Employees show as unpaid')
			]);
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewTimeline = F2(
	function (currentDate, form) {
		if (!form.$) {
			var settingsForm = form.a;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanMd(12)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Timeline$view,
										_List_fromArray(
											[$author$project$Ui$Timeline$lg]),
										$author$project$Components$InvoiceSetting$Timeline$createTimelineEvents(
											A2(
												$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$createTimelineEventAttributes,
												$author$project$Utils$Form$fields(settingsForm),
												currentDate)))
									]))
							])),
						A2(
						$author$project$Ui$Grid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanMd(12)
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Admin__InvoiceSettings,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Update global sponsor invoice settings')
											]))
									]))
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$view = function (model) {
	var sponsorizedPl = A2($author$project$Formatters$String$sponsorize, model.ZV, 'employers');
	var sponsorized = A2($author$project$Formatters$String$sponsorize, model.ZV, 'employer');
	var hideSponsorInvoicesSection = function () {
		var _v7 = model.SD;
		if (!_v7.$) {
			var form = _v7.a;
			return (model.Ij && (!$author$project$Utils$Overridable$value(
				$author$project$Utils$Form$fields(form).GF))) ? A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewHideSponsorInvoices, model.Ij, form)
					])) : $author$project$Utils$Html$empty;
		} else {
			return $author$project$Utils$Html$empty;
		}
	}();
	var enableBillingSection = function () {
		var _v6 = model.SD;
		if (!_v6.$) {
			var form = _v6.a;
			return A2($author$project$Api$Provider$Practice$One$featureEnabled, 7, model.ZV) ? (((!model.Ij) && $author$project$Utils$Overridable$value(
				$author$project$Utils$Form$fields(form).GF)) ? A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewEnableBillingStartDate,
						form,
						A3($justinmimbs$date$Date$add, 1, 1, model.dd))
					])) : A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewEnableBilling, model.Ij, form),
						A2(
						$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewEnableBillingStartDate,
						form,
						A3($justinmimbs$date$Date$add, 1, 1, model.dd))
					]))) : $author$project$Utils$Html$empty;
		} else {
			return $author$project$Utils$Html$empty;
		}
	}();
	return {
		fO: _List_fromArray(
			[
				function () {
				var _v0 = model.ft;
				if (!_v0.$) {
					var virtualBankAccountEnableModal = _v0.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountEnableModalMsg,
						$author$project$Components$Company$VirtualBankAccounts$EnableModal$modal(virtualBankAccountEnableModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v1 = model.dQ;
				if (!_v1.$) {
					var virtualBankAccountAuthorizeModal = _v1.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountAuthorizeModalMsg,
						$author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$modal(virtualBankAccountAuthorizeModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Form$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Example of Upcoming Month')
											]))
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewTimeline, model.dd, model.SD),
										$author$project$Ui$HorizontalRule$view(_List_Nil),
										enableBillingSection,
										hideSponsorInvoicesSection,
										$author$project$Ui$Typography$headingSm(
										_List_fromArray(
											[
												$elm$html$Html$text('Notification: Invoice Upcoming')
											])),
										A2(
										$author$project$Ui$Grid$row,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Grid$column,
												_List_fromArray(
													[
														$author$project$Ui$Grid$spanMd(6)
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$p,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Sent to '),
																$elm$html$Html$text(sponsorizedPl),
																$elm$html$Html$text(' to let them know when to expect an invoice. '),
																$elm$html$Html$text('This notification is sent 1 week prior to the “Invoice Created” notification')
															])),
														A3(
														$author$project$Ui$Link$route,
														$author$project$Spa$Generated$Route$Admin__Notifications__Company,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('View and customize the notification')
															]))
													])),
												A2(
												$author$project$Ui$Grid$column,
												_List_fromArray(
													[
														$author$project$Ui$Grid$spanMd(6),
														$author$project$Ui$Grid$justifyRight
													]),
												A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$justFormAndSuccessfulSetting, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewInvoiceUpcomingAutoSend, model.SD))
											])),
										$author$project$Ui$HorizontalRule$view(_List_Nil),
										$author$project$Ui$Typography$headingSm(
										_List_fromArray(
											[
												$elm$html$Html$text('Notification: Invoice Created')
											])),
										A2(
										$author$project$Ui$Grid$row,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Grid$column,
												_List_fromArray(
													[
														$author$project$Ui$Grid$spanMd(6)
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$p,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Sent to '),
																$elm$html$Html$text(sponsorizedPl),
																$elm$html$Html$text(' on the specified day. Invoices can be sent regardless'),
																$elm$html$Html$text(' of whether they are still in draft or have been issued.')
															])),
														A3(
														$author$project$Ui$Link$route,
														$author$project$Spa$Generated$Route$Admin__Notifications__Company,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('View and customize the notification')
															]))
													])),
												A2(
												$author$project$Ui$Grid$column,
												_List_fromArray(
													[
														$author$project$Ui$Grid$spanMd(6)
													]),
												A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$justFormAndSuccessfulSetting, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewInvoiceAutoSend, model.SD))
											])),
										$author$project$Ui$HorizontalRule$view(_List_Nil),
										$author$project$Ui$Typography$headingSm(
										_List_fromArray(
											[
												$elm$html$Html$text('Scheduled Issue Date')
											])),
										A2(
										$author$project$Ui$Grid$row,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Grid$column,
												_List_fromArray(
													[
														$author$project$Ui$Grid$spanMd(6)
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$p,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(
																'Invoices will be automatically issued on the specified date, locking charges in place and preventing ' + ($author$project$Formatters$String$pluralOf(sponsorized) + (' from making any changes. Once issued, ' + (sponsorized + ' can pay invoices manually, or invoices will be automatically processed based on the Scheduled Autopay Date settings.'))))
															]))
													])),
												A2(
												$author$project$Ui$Grid$column,
												_List_fromArray(
													[
														$author$project$Ui$Grid$spanMd(6)
													]),
												A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$justFormAndSuccessfulSetting, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewInvoiceAutoIssue, model.SD))
											])),
										$author$project$Ui$HorizontalRule$view(_List_Nil),
										$author$project$Ui$Typography$headingSm(
										_List_fromArray(
											[
												$elm$html$Html$text('Scheduled Autopay Date')
											])),
										A2(
										$author$project$Ui$Grid$row,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Grid$column,
												_List_fromArray(
													[
														$author$project$Ui$Grid$spanMd(6)
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$p,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Payment for the full amount of all issued invoices will be automatically attempted on the specified date. ' + ('Payments will not be processed for non-issued invoices. This date is visible to the  ' + (sponsorized + '.')))
															]))
													])),
												A2(
												$author$project$Ui$Grid$column,
												_List_fromArray(
													[
														$author$project$Ui$Grid$spanMd(6)
													]),
												A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$justFormAndSuccessfulSetting, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewInvoiceAutoPay, model.SD))
											])),
										$author$project$Ui$HorizontalRule$view(_List_Nil),
										$author$project$Ui$Typography$headingSm(
										_List_fromArray(
											[
												$elm$html$Html$text('Due Date')
											])),
										A2(
										$author$project$Ui$Grid$row,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Grid$column,
												_List_fromArray(
													[
														$author$project$Ui$Grid$spanMd(6)
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$p,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('The day when the invoice is considered ”due”. This date is visible to the ' + (sponsorized + ' and printed on the invoice.'))
															]))
													])),
												A2(
												$author$project$Ui$Grid$column,
												_List_fromArray(
													[
														$author$project$Ui$Grid$spanMd(6)
													]),
												A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$justFormAndSuccessfulSetting, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewInvoiceDueDay, model.SD))
											])),
										$author$project$Ui$HorizontalRule$view(_List_Nil),
										$author$project$Ui$Typography$headingSm(
										_List_fromArray(
											[
												$elm$html$Html$text('Grace Period')
											])),
										A2(
										$author$project$Ui$Grid$row,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Grid$column,
												_List_fromArray(
													[
														$author$project$Ui$Grid$spanMd(6)
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$p,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('If the invoice is not yet paid after the grace period passes, each employee\'s membership status will be set to “unpaid” and the invoice will be considered “overdue”. The grace period starts after the due date.')
															]))
													])),
												A2(
												$author$project$Ui$Grid$column,
												_List_fromArray(
													[
														$author$project$Ui$Grid$spanMd(6)
													]),
												A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$justFormAndSuccessfulSetting, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewInvoiceGracePeriodDays, model.SD))
											])),
										$author$project$Ui$HorizontalRule$view(_List_Nil),
										$author$project$Ui$Typography$headingSm(
										_List_fromArray(
											[
												$elm$html$Html$text('Include Full Charge Details')
											])),
										A2(
										$author$project$Ui$Grid$row,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Grid$column,
												_List_fromArray(
													[
														$author$project$Ui$Grid$spanMd(6)
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$p,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Allow the ' + (sponsorized + ' to see full charge details and patient names when viewing or downloading the invoice. Since these details may contain protected health information, this setting is off by default.'))
															]))
													])),
												A2(
												$author$project$Ui$Grid$column,
												_List_fromArray(
													[
														$author$project$Ui$Grid$spanMd(6),
														$author$project$Ui$Grid$justifyRight
													]),
												_List_fromArray(
													[
														function () {
														var _v2 = $author$project$Api$Data$toMaybe(model.cT);
														if (!_v2.$) {
															var companyInvoiceSetting = _v2.a;
															var _v3 = $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$chargePhiDetailsUpdatedAt(companyInvoiceSetting);
															if (!_v3.$) {
																var chargePhiDetailsUpdatedAt = _v3.a;
																return A2(
																	$author$project$Ui$Grid$row,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			$author$project$Ui$Grid$column,
																			_List_fromArray(
																				[
																					$author$project$Ui$Grid$spanMd(12)
																				]),
																			_List_fromArray(
																				[
																					A2(
																					$author$project$Ui$Typography$p,
																					_List_fromArray(
																						[
																							$author$project$Ui$Typography$muted,
																							$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
																						]),
																					_List_fromArray(
																						[
																							$elm$html$Html$text('Updated by '),
																							$elm$html$Html$text(
																							A2(
																								$elm$core$Maybe$withDefault,
																								'N/A',
																								A2(
																									$elm$core$Maybe$map,
																									$author$project$Api$Provider$User$Min$name,
																									$author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$chargePhiDetailsUpdatedBy(companyInvoiceSetting)))),
																							$elm$html$Html$text(' on '),
																							$elm$html$Html$text(
																							A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, chargePhiDetailsUpdatedAt))
																						]))
																				]))
																		]));
															} else {
																return $author$project$Utils$Html$empty;
															}
														} else {
															return $author$project$Utils$Html$empty;
														}
													}(),
														A2(
														$author$project$Ui$Element$view,
														_List_fromArray(
															[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$flexCol]),
														A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$justFormAndSuccessfulSetting, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewChargePhiDetailsEnabled, model.SD))
													]))
											])),
										A3(
										$author$project$Utils$FeatureGate$gate,
										3,
										$author$project$Api$Practice$Provider(model.ZV),
										A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													$author$project$Ui$HorizontalRule$view(_List_Nil),
													$author$project$Ui$Typography$headingSm(
													_List_fromArray(
														[
															$elm$html$Html$text('Add Service Charges to Membership Invoices')
														])),
													A2(
													$author$project$Ui$Grid$row,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Grid$column,
															_List_fromArray(
																[
																	$author$project$Ui$Grid$spanMd(6)
																]),
															_List_fromArray(
																[
																	A2(
																	$author$project$Ui$Typography$p,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text('When point-of-care service charges are paid for by the employer, '),
																			$elm$html$Html$text('automatically add these charges to the employer\'s next draft membership invoice. If this setting is disabled, '),
																			$elm$html$Html$text('service charges will be added to a separate service invoice.')
																		]))
																])),
															A2(
															$author$project$Ui$Grid$column,
															_List_fromArray(
																[
																	$author$project$Ui$Grid$spanMd(6)
																]),
															A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$justFormAndSuccessfulSetting, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewChargeRouteToRecurringInvoice, model.SD))
														])),
													A2(
													$elm$html$Html$div,
													_List_Nil,
													function () {
														var _v4 = model.be;
														if (!_v4.$) {
															var form = _v4.a;
															return A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewPaymentSettingsForm, model, form);
														} else {
															return _List_fromArray(
																[$author$project$Utils$Html$empty]);
														}
													}())
												])))
									])),
								A2(
								$author$project$Ui$Panel$footer,
								_List_fromArray(
									[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$justifyCenter]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Admin__Practice,
										_List_fromArray(
											[$author$project$Ui$Link$buttonSecondary]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cancel')
											])),
										function () {
										if ($author$project$Utils$Maybe$toBool(model.SD)) {
											var nonSubmittable = function () {
												var _v5 = model.SD;
												if (!_v5.$) {
													var form = _v5.a;
													return $author$project$Utils$Form$hasAnyValidationError(form);
												} else {
													return true;
												}
											}();
											return A3(
												$author$project$Ui$Button$view,
												{mm: 'Update company invoice settings'},
												_List_fromArray(
													[
														$author$project$Ui$Button$primary,
														$author$project$Ui$Button$loading(
														_Utils_eq(model.cT, $author$project$Api$Data$Loading)),
														$author$project$Ui$Button$onClick($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$CompanyInvoiceSettingsSubmitted),
														$author$project$Ui$Button$disabled(nonSubmittable)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Update')
													]));
										} else {
											return $author$project$Utils$Html$empty;
										}
									}()
									]))
							]))
					]))
			]),
		ac9: A2($author$project$Formatters$String$sponsorize, model.ZV, 'Companies') + ' | Invoice Settings'
	};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$page = $author$project$Spa$Page$applicationCompany(
	{ah_: $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$init, aiq: $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$load, k8: $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$save, alO: $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$subscriptions, adT: $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$update, amo: $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$view});
var $author$project$Components$Invoice$Company = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Invoice$EmployerOrProviderCompany = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Invoices$Id_String$InvoiceComponentMsg = $elm$core$Basics$identity;
var $author$project$Pages$Companies$CompanyId_String$Invoices$Id_String$init = F5(
	function (session, practice, company, shared, _v0) {
		var params = _v0.YL;
		var _v1 = $author$project$Components$Invoice$init(
			{
				Gv: shared.Gv,
				mn: false,
				afQ: $elm$core$Maybe$Just(
					$author$project$Components$Invoice$EmployerOrProviderCompany(company)),
				Uv: A2($author$project$Components$Invoice$Company, params.fZ, params.ahP),
				Is: $author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Top(
					{fZ: params.fZ}),
				tN: $elm$core$Maybe$Just(
					$author$project$Spa$Generated$Route$Companies__CompanyId_String__PaymentSources(
						{fZ: params.fZ})),
				ZV: practice,
				aa4: session,
				lk: shared
			});
		var invoiceComponent = _v1.a;
		var invoiceComponentCmd = _v1.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, Uk: invoiceComponent, ZV: practice},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, invoiceComponentCmd));
	});
var $author$project$Pages$Companies$CompanyId_String$Invoices$Id_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Companies$CompanyId_String$Invoices$Id_String$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Companies$CompanyId_String$Invoices$Id_String$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Invoice$subscriptions(model.Uk));
};
var $author$project$Pages$Companies$CompanyId_String$Invoices$Id_String$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Invoice$update, model.Gv, subMsg, model.Uk);
		var invoiceComponent = _v1.a;
		var cmd = _v1.b;
		var outMsgs = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{Uk: invoiceComponent}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd),
			outMsgs);
	});
var $author$project$Pages$Companies$CompanyId_String$Invoices$Id_String$view = function (model) {
	return {
		fO: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			A2($author$project$Components$Invoice$view, model.Gv, model.Uk)),
		ac9: A2($author$project$Api$Practice$sponsorize, model.ZV, 'Companies') + ' | Invoices'
	};
};
var $author$project$Pages$Companies$CompanyId_String$Invoices$Id_String$page = $author$project$Spa$Page$applicationCompanyOrEmployer(
	{ah_: $author$project$Pages$Companies$CompanyId_String$Invoices$Id_String$init, aiq: $author$project$Pages$Companies$CompanyId_String$Invoices$Id_String$load, k8: $author$project$Pages$Companies$CompanyId_String$Invoices$Id_String$save, alO: $author$project$Pages$Companies$CompanyId_String$Invoices$Id_String$subscriptions, adT: $author$project$Pages$Companies$CompanyId_String$Invoices$Id_String$update, amo: $author$project$Pages$Companies$CompanyId_String$Invoices$Id_String$view});
var $author$project$Api$Provider$Report$Invoice = 3;
var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$GotInvoices = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$fetchParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{ajJ: model.ajJ, alA: model.alA});
	};
};
var $author$project$Api$Invoice$All$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Invoice$All$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$Invoice$All$Invoice = $elm$core$Basics$identity;
var $author$project$Api$Employer$Invoice$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Invoice$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Invoice$listDefaults = {ajJ: $author$project$Api$Pagination$init, alA: $author$project$Api$Sort$init, alH: $elm$core$Maybe$Nothing};
var $author$project$Api$Employer$Invoice$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Employer$Invoice$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$Employer$Invoice$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Employer$Invoice$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Employer$Invoice$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Employer$Invoice$invoicesPath)));
	});
var $author$project$Api$Invoice$list = F5(
	function (apiClient, session, companyId, optionals, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$Invoice$list,
			apiClient,
			optionals,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$Invoice$All$Employer)))) : A4(
			$author$project$Api$Provider$Company$Invoice$list,
			apiClient,
			companyId,
			optionals,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$Invoice$All$Provider))));
	});
var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$fetchInvoices = function (model) {
	return A5(
		$author$project$Api$Invoice$list,
		model.Gv,
		model.aa4,
		model.ahP,
		$author$project$Pages$Companies$CompanyId_String$Invoices$Top$fetchParams(model),
		$author$project$Pages$Companies$CompanyId_String$Invoices$Top$GotInvoices);
};
var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$init = F5(
	function (session, practice, company, shared, _v0) {
		var params = _v0.YL;
		var query = _v0.DE;
		var model = {
			Gv: shared.Gv,
			afQ: company,
			nD: shared.ajE ? $author$project$Components$ExportCsv$initForEmployer(3) : $author$project$Components$ExportCsv$initForPractice(3),
			ahr: $elm$core$Maybe$Nothing,
			ahP: params.fZ,
			sP: $author$project$Api$Data$Loading,
			oK: $author$project$Api$Data$NotAsked,
			ajE: shared.ajE,
			ajJ: $author$project$Api$Pagination$initFromQuery(query),
			ZV: practice,
			aa4: session,
			alA: A3(
				$author$project$Api$Sort$withDefault,
				'invoice_date',
				1,
				$author$project$Api$Sort$initFromQuery(query))
		};
		return _Utils_Tuple2(
			model,
			$author$project$Pages$Companies$CompanyId_String$Invoices$Top$fetchInvoices(model));
	});
var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{ajE: shared.ajE}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$ExportCsvMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$Companies$CompanyId_String$Invoices$Top$ExportCsvMsg,
		$author$project$Components$ExportCsv$subscriptions(model.nD));
};
var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$InvoiceCreated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Company$Invoice$create = F3(
	function (apiClient, companyId, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Invoice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Company$Invoice$invoicesPath(companyId)));
	});
var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$updateUrl = function (model) {
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString(
					$author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Top(
						{fZ: model.ahP}))
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.ajJ),
				$author$project$Api$Sort$toQuery(model.alA))));
};
var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					var intFromHeader = F2(
						function (key, headers_) {
							return A2(
								$elm$core$Maybe$withDefault,
								0,
								A2(
									$elm$core$Maybe$andThen,
									$elm$core$String$toInt,
									A2($elm$core$Dict$get, key, headers_)));
						});
					var totalAmount = A2(intFromHeader, 'x-total-amount', headers);
					var totalDueAmount = A2(intFromHeader, 'x-total-due-amount', headers);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ahr: $elm$core$Maybe$Just(
									_Utils_Tuple2(totalAmount, totalDueAmount)),
								sP: response,
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{sP: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						alA: A2($author$project$Api$Sort$update, columnId, model.alA)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Companies$CompanyId_String$Invoices$Top$fetchInvoices(newModel),
								$author$project$Pages$Companies$CompanyId_String$Invoices$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 2:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{sP: $author$project$Api$Data$Loading, ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Companies$CompanyId_String$Invoices$Top$fetchInvoices(newModel),
								$author$project$Pages$Companies$CompanyId_String$Invoices$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oK: $author$project$Api$Data$Loading}),
					A3($author$project$Api$Provider$Company$Invoice$create, model.Gv, model.ahP, $author$project$Pages$Companies$CompanyId_String$Invoices$Top$InvoiceCreated),
					_List_Nil);
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					var invoice = response.a;
					var newModel = _Utils_update(
						model,
						{sP: $author$project$Api$Data$Loading, oK: response});
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Pages$Companies$CompanyId_String$Invoices$Top$fetchInvoices(newModel),
									A2(
									$author$project$Utils$Route$navigate,
									$elm$core$Dict$empty,
									$author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String(
										{
											fZ: model.ahP,
											ahP: $author$project$Api$Provider$Invoice$One$id(invoice)
										}))
								])),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'New invoice created!')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{oK: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var subMsg = msg.a;
				var _v3 = A3($author$project$Components$ExportCsv$update, model.Gv, subMsg, model.nD);
				var exportCsv = _v3.a;
				var subCmd = _v3.b;
				var subOutMsg = _v3.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nD: exportCsv}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Invoices$Top$ExportCsvMsg, subCmd),
					subOutMsg);
		}
	});
var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$PaginationMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Invoice$invoicesPath = F2(
	function (session, id_) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $author$project$Api$Employer$Invoice$invoicesPath : $author$project$Api$Provider$Company$Invoice$invoicesPath(id_);
	});
var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$CreateInvoice = {$: 3};
var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$newInvoiceButton = F2(
	function (practiceOrganization, newInvoice) {
		if (!practiceOrganization.$) {
			return A2($author$project$Utils$FeatureGate$gateAvailable, 3, practiceOrganization) ? A3(
				$author$project$Ui$Button$view,
				{mm: 'Create new invoice'},
				_List_fromArray(
					[
						$author$project$Ui$Button$styled(0),
						$author$project$Ui$Button$loading(
						_Utils_eq(newInvoice, $author$project$Api$Data$Loading)),
						$author$project$Ui$Button$onClick($author$project$Pages$Companies$CompanyId_String$Invoices$Top$CreateInvoice),
						$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('New Invoice')
					])) : $author$project$Utils$Html$empty;
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$SortTable = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'invoice_date', true, 'Date'),
		A3($author$project$Api$Column$init, 'invoice_number', true, 'Invoice Number'),
		A3($author$project$Api$Column$init, 'status', true, 'Invoice Status'),
		A3($author$project$Api$Column$init, 'amount_in_cents', true, 'Total'),
		A3($author$project$Api$Column$init, 'description', false, 'Description')
	]);
var $author$project$Api$Employer$Invoice$All$amountInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Invoice$Shared$amountInCents(shared);
};
var $author$project$Api$Provider$Invoice$All$amountInCents = function (_v0) {
	var record = _v0.b;
	return record.LE;
};
var $author$project$Api$Invoice$All$amountInCents = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$All$amountInCents(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$All$amountInCents(invoice_);
	}
};
var $author$project$Api$Employer$Invoice$Shared$description = function (_v0) {
	var record = _v0;
	return record.Qr;
};
var $author$project$Api$Employer$Invoice$All$description = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Invoice$Shared$description(shared);
};
var $author$project$Api$Provider$Invoice$All$description = function (_v0) {
	var record = _v0.b;
	return record.Qr;
};
var $author$project$Api$Invoice$All$description = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$All$description(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$All$description(invoice_);
	}
};
var $author$project$Api$Employer$Invoice$All$dueInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Invoice$Shared$dueInCents(shared);
};
var $author$project$Api$Provider$Invoice$All$dueInCents = function (_v0) {
	var record = _v0.b;
	return record.QY;
};
var $author$project$Api$Invoice$All$dueInCents = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$All$dueInCents(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$All$dueInCents(invoice_);
	}
};
var $author$project$Api$Employer$Invoice$All$humanStatus = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Invoice$Shared$humanStatus(shared);
};
var $author$project$Api$Invoice$All$humanStatus = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$All$humanStatus(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$All$humanStatus(invoice_);
	}
};
var $author$project$Api$Employer$Invoice$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Invoice$Shared$id(shared);
};
var $author$project$Api$Invoice$All$id = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$All$id(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$All$id(invoice_);
	}
};
var $author$project$Api$Employer$Invoice$All$invoiceDate = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Invoice$Shared$invoiceDate(shared);
};
var $author$project$Api$Invoice$All$invoiceDate = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$All$invoiceDate(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$All$invoiceDate(invoice_);
	}
};
var $author$project$Api$Employer$Invoice$All$invoiceNumber = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Invoice$Shared$invoiceNumber(shared);
};
var $author$project$Api$Invoice$All$invoiceNumber = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$All$invoiceNumber(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$All$invoiceNumber(invoice_);
	}
};
var $author$project$Api$Employer$Invoice$All$paidInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Invoice$Shared$paidInCents(shared);
};
var $author$project$Api$Provider$Invoice$All$paidInCents = function (_v0) {
	var record = _v0.b;
	return record.YI;
};
var $author$project$Api$Invoice$All$paidInCents = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$All$paidInCents(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$All$paidInCents(invoice_);
	}
};
var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$viewRow = F2(
	function (companyId, invoice) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String(
								{
									fZ: companyId,
									ahP: $author$project$Api$Invoice$All$id(invoice)
								}),
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$Date$toString,
										$author$project$Formatters$Date$Full,
										$author$project$Api$Invoice$All$invoiceDate(invoice)))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String(
								{
									fZ: companyId,
									ahP: $author$project$Api$Invoice$All$id(invoice)
								}),
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(
										$author$project$Api$Invoice$All$invoiceNumber(invoice)))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Api$Invoice$Status$toBadge(
							$author$project$Api$Invoice$All$humanStatus(invoice))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$Currency$fromInt(
								$author$project$Api$Invoice$All$amountInCents(invoice))),
							$author$project$Utils$Html$noBreakSpace,
							(($author$project$Api$Invoice$All$dueInCents(invoice) > 0) && ($author$project$Api$Invoice$All$paidInCents(invoice) > 0)) ? $elm$html$Html$text(
							'(' + ($author$project$Utils$Currency$fromInt(
								$author$project$Api$Invoice$All$dueInCents(invoice)) + ' due)')) : $author$project$Utils$Html$empty
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[$author$project$Ui$Typography$ellipsis]),
							$author$project$Api$Invoice$All$description(invoice))
						])),
					A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil)
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$viewTable = function (model) {
	var _v0 = function () {
		var _v1 = model.sP;
		if (_v1.$ === 3) {
			var invoices_ = _v1.a;
			return _Utils_Tuple2(false, invoices_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var invoices = _v0.b;
	return A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any charges for '),
						$elm$html$Html$text(
						$author$project$Api$Company$name(model.afQ)),
						$elm$html$Html$text(' yet. An invoice will be created on the 1st of the month for any '),
						$elm$html$Html$text(
						A2($author$project$Api$Practice$sponsorize, model.ZV, 'employees')),
						$elm$html$Html$text(' who have signed up.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$map,
					$author$project$Api$Column$view(
						A2($author$project$Api$Column$Sortable, model.alA, $author$project$Pages$Companies$CompanyId_String$Invoices$Top$SortTable)),
					$author$project$Pages$Companies$CompanyId_String$Invoices$Top$columns),
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								A2($elm$html$Html$map, $author$project$Pages$Companies$CompanyId_String$Invoices$Top$ExportCsvMsg, $author$project$Components$ExportCsv$button)
							]))
					])
				])),
		A2(
			$elm$core$List$map,
			$author$project$Pages$Companies$CompanyId_String$Invoices$Top$viewRow(model.ahP),
			invoices),
		_List_Nil);
};
var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$view = function (model) {
	return {
		fO: function () {
			var loading = function () {
				var _v0 = model.sP;
				if (_v0.$ === 3) {
					return false;
				} else {
					return true;
				}
			}();
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Panel$heading,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
									_List_fromArray(
										[
											$author$project$Ui$Panel$title(
											_List_fromArray(
												[
													$elm$html$Html$text('Invoices')
												])),
											A2($author$project$Pages$Companies$CompanyId_String$Invoices$Top$newInvoiceButton, model.ZV, model.oK)
										]))
								])),
							A2(
							$author$project$Ui$Panel$body,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Pages$Companies$CompanyId_String$Invoices$Top$viewTable(model)
								])),
							A2(
							$author$project$Ui$Panel$footer,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Pages$Companies$CompanyId_String$Invoices$Top$PaginationMsg,
									A2(
										$author$project$Api$Pagination$view,
										_List_fromArray(
											[
												$author$project$Ui$Pagination$List$loading(loading)
											]),
										model.ajJ))
								]))
						])),
					A2(
					$elm$html$Html$map,
					$author$project$Pages$Companies$CompanyId_String$Invoices$Top$ExportCsvMsg,
					A3(
						$author$project$Components$ExportCsv$modal,
						model.Gv,
						_List_fromArray(
							[
								$author$project$Components$ExportCsv$path(
								A2($author$project$Api$Invoice$invoicesPath, model.aa4, model.ahP)),
								$author$project$Components$ExportCsv$params(
								$author$project$Api$Provider$Invoice$listOptionsToParams(
									$author$project$Pages$Companies$CompanyId_String$Invoices$Top$fetchParams(model)))
							]),
						model.nD))
				]);
		}(),
		ac9: A2($author$project$Api$Practice$sponsorize, model.ZV, 'Companies') + ' | Invoices'
	};
};
var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$page = $author$project$Spa$Page$applicationCompanyOrEmployer(
	{ah_: $author$project$Pages$Companies$CompanyId_String$Invoices$Top$init, aiq: $author$project$Pages$Companies$CompanyId_String$Invoices$Top$load, k8: $author$project$Pages$Companies$CompanyId_String$Invoices$Top$save, alO: $author$project$Pages$Companies$CompanyId_String$Invoices$Top$subscriptions, adT: $author$project$Pages$Companies$CompanyId_String$Invoices$Top$update, amo: $author$project$Pages$Companies$CompanyId_String$Invoices$Top$view});
var $author$project$Api$Provider$Note$Company = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Notes$NotesMsg = $elm$core$Basics$identity;
var $author$project$Pages$Companies$CompanyId_String$Notes$init = F5(
	function (session, practice, _v0, shared, _v1) {
		var query = _v1.DE;
		var params = _v1.YL;
		var _v2 = A6(
			$author$project$Components$Notes$init,
			shared.Gv,
			shared.J7,
			$author$project$Spa$Generated$Route$Companies__CompanyId_String__Notes(
				{fZ: params.fZ}),
			query,
			$author$project$Api$Provider$Note$Company(params.fZ),
			$author$project$Api$Platform$Session$One$userIsPracticeAdmin(session));
		var notes = _v2.a;
		var notesCmd = _v2.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, s1: notes, ZV: practice},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, notesCmd));
	});
var $author$project$Pages$Companies$CompanyId_String$Notes$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Companies$CompanyId_String$Notes$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Companies$CompanyId_String$Notes$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Notes$subscriptions(model.s1));
};
var $author$project$Pages$Companies$CompanyId_String$Notes$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Notes$update, model.Gv, subMsg, model.s1);
		var notes = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{s1: notes}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Pages$Companies$CompanyId_String$Notes$view = function (model) {
	return {
		fO: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			$author$project$Components$Notes$view(model.s1)),
		ac9: A2($author$project$Formatters$String$sponsorize, model.ZV, 'Companies') + ' | Notes'
	};
};
var $author$project$Pages$Companies$CompanyId_String$Notes$page = $author$project$Spa$Page$applicationCompany(
	{ah_: $author$project$Pages$Companies$CompanyId_String$Notes$init, aiq: $author$project$Pages$Companies$CompanyId_String$Notes$load, k8: $author$project$Pages$Companies$CompanyId_String$Notes$save, alO: $author$project$Pages$Companies$CompanyId_String$Notes$subscriptions, adT: $author$project$Pages$Companies$CompanyId_String$Notes$update, amo: $author$project$Pages$Companies$CompanyId_String$Notes$view});
var $author$project$Pages$Companies$CompanyId_String$Notifications$AdminTableMsg = $elm$core$Basics$identity;
var $author$project$Api$Provider$Notification$CompanyContext = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Notifications$init = F5(
	function (session, practice, _v0, shared, _v1) {
		var params = _v1.YL;
		var multilanguageEnabled = A2(
			$author$project$Api$Practice$featureEnabled,
			10,
			$author$project$Api$Practice$Provider(practice));
		var _v2 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Components$Admin$NotificationSetting$AdminTable$withMultiLanguageFeature(multilanguageEnabled),
			A4(
				$author$project$Components$Admin$NotificationSetting$AdminTable$init,
				shared.Gv,
				session,
				$author$project$Api$Provider$Notification$CompanyContext(params.fZ),
				0));
		var adminTable = _v2.a;
		var adminTableCmd = _v2.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, s1: adminTable, ZV: practice},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, adminTableCmd));
	});
var $author$project$Pages$Companies$CompanyId_String$Notifications$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Companies$CompanyId_String$Notifications$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Companies$CompanyId_String$Notifications$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Admin$NotificationSetting$AdminTable$subscriptions(model.s1));
};
var $author$project$Pages$Companies$CompanyId_String$Notifications$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Admin$NotificationSetting$AdminTable$update, model.Gv, subMsg, model.s1);
		var adminTable = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{s1: adminTable}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Pages$Companies$CompanyId_String$Notifications$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Employee Notifications')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						A2(
							$elm$core$List$cons,
							A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('These are emails that will be sent to any patients who are being sponsored by their employers. '),
										$elm$html$Html$text('They will also receive any patient emails that don\'t relate to payment of their memberships.')
									])),
							A2(
								$elm$core$List$map,
								$elm$html$Html$map($elm$core$Basics$identity),
								$author$project$Components$Admin$NotificationSetting$AdminTable$view(model.s1))))
					]))
			]),
		ac9: A2($author$project$Formatters$String$sponsorize, model.ZV, 'Companies') + ' | Notifications'
	};
};
var $author$project$Pages$Companies$CompanyId_String$Notifications$page = $author$project$Spa$Page$applicationCompany(
	{ah_: $author$project$Pages$Companies$CompanyId_String$Notifications$init, aiq: $author$project$Pages$Companies$CompanyId_String$Notifications$load, k8: $author$project$Pages$Companies$CompanyId_String$Notifications$save, alO: $author$project$Pages$Companies$CompanyId_String$Notifications$subscriptions, adT: $author$project$Pages$Companies$CompanyId_String$Notifications$update, amo: $author$project$Pages$Companies$CompanyId_String$Notifications$view});
var $author$project$Components$PaymentSources$Company = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$PaymentSources$PaymentSourcesMsg = $elm$core$Basics$identity;
var $author$project$Components$PaymentSources$DropdownMenuMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$PaymentSources$Model = $elm$core$Basics$identity;
var $author$project$Components$PaymentSources$VirtualBankAccountsComponentMsg = function (a) {
	return {$: 20, a: a};
};
var $author$project$Api$Provider$Patient$One$createdAt = function (_v0) {
	var record = _v0.b;
	return record.O1;
};
var $author$project$Components$MovePaymentMethodsModal$Closed = {$: 0};
var $author$project$Components$MovePaymentMethodsModal$init = $author$project$Components$MovePaymentMethodsModal$Closed;
var $author$project$Components$VirtualBankAccounts$Model = $elm$core$Basics$identity;
var $author$project$Components$VirtualBankAccounts$GotVirtualBankAccounts = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$VirtualBankAccounts$loadData = F2(
	function (apiClient, companyId) {
		return _Utils_Tuple2(
			$author$project$Api$Data$Loading,
			A3($author$project$Api$Provider$VirtualBankAccount$list, apiClient, companyId, $author$project$Components$VirtualBankAccounts$GotVirtualBankAccounts));
	});
var $author$project$Components$VirtualBankAccounts$init = F3(
	function (companyId, practice, _v0) {
		var timeFormatter = _v0.J7;
		var apiClient = _v0.Gv;
		var _v1 = A2($author$project$Components$VirtualBankAccounts$loadData, apiClient, companyId);
		var virtualBankAccounts = _v1.a;
		var cmd = _v1.b;
		return _Utils_Tuple2(
			{Mx: false, ZV: practice, J7: timeFormatter, F7: virtualBankAccounts},
			cmd);
	});
var $author$project$Components$PaymentSources$GotBankAccounts = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$PaymentSources$GotCards = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$PaymentSources$GotPaymentSourcesMigratable = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Provider$Patient$PaymentMethod$canMigrateDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['can_migrate']),
	$elm$json$Json$Decode$bool);
var $author$project$Api$Provider$Patient$PaymentMethod$paymentMethodsPath = function (patientId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['payment_methods']),
		$author$project$Api$Provider$Patient$patientPath(patientId));
};
var $author$project$Api$Provider$Patient$PaymentMethod$canMigratePath = function (patientId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['can_migrate']),
		$author$project$Api$Provider$Patient$PaymentMethod$paymentMethodsPath(patientId));
};
var $author$project$Api$Provider$Patient$PaymentMethod$canMigrate = F3(
	function (apiClient, patientId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Patient$PaymentMethod$canMigrateDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Patient$PaymentMethod$canMigratePath(patientId)));
	});
var $author$project$Components$PaymentSources$loadData = F4(
	function (basePath, apiClient, session, resource) {
		return _Utils_Tuple3(
			$author$project$Api$Data$Loading,
			$author$project$Api$Data$Loading,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A4($author$project$Api$Card$list, basePath, apiClient, session, $author$project$Components$PaymentSources$GotCards),
						A4($author$project$Api$BankAccount$list, basePath, apiClient, session, $author$project$Components$PaymentSources$GotBankAccounts),
						function () {
						if (resource.$ === 1) {
							var patient = resource.a;
							return A3(
								$author$project$Api$Provider$Patient$PaymentMethod$canMigrate,
								apiClient,
								$author$project$Api$Provider$Patient$One$id(patient),
								$author$project$Components$PaymentSources$GotPaymentSourcesMigratable);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}()
					])));
	});
var $author$project$Components$PaymentSources$init = F4(
	function (resource, session, practice, shared) {
		var patientId = function () {
			if (resource.$ === 1) {
				var patient = resource.a;
				return $author$project$Api$Provider$Patient$One$id(patient);
			} else {
				return '';
			}
		}();
		var patientCreatedAt = function () {
			if (resource.$ === 1) {
				var patient = resource.a;
				return $elm$core$Maybe$Just(
					$author$project$Api$Provider$Patient$One$createdAt(patient));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var basePath = function () {
			if (!resource.$) {
				var company = resource.a;
				if (!company.$) {
					var company_ = company.a;
					return $author$project$Api$Provider$Company$companyPath(
						$author$project$Api$Provider$Company$One$id(company_));
				} else {
					return $author$project$Api$Data$employerPath;
				}
			} else {
				var patient = resource.a;
				return A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						[
							$author$project$Api$Provider$Patient$One$id(patient)
						]),
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['patients']),
						$author$project$Api$Data$providerPath));
			}
		}();
		var _v0 = function () {
			var _v1 = _Utils_Tuple2(
				resource,
				A2($author$project$Api$Practice$featureEnabled, 11, practice));
			if ((!_v1.a.$) && _v1.b) {
				var company = _v1.a.a;
				var _v2 = A3(
					$author$project$Components$VirtualBankAccounts$init,
					$author$project$Api$Company$id(company),
					practice,
					{Gv: shared.Gv, J7: shared.J7});
				var model_ = _v2.a;
				var cmd_ = _v2.b;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(model_),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentSources$VirtualBankAccountsComponentMsg, cmd_));
			} else {
				return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
			}
		}();
		var virtualBankAccountModel = _v0.a;
		var virtualBankAccountCmd = _v0.b;
		var _v3 = A4($author$project$Components$PaymentSources$loadData, basePath, shared.Gv, session, resource);
		var cards = _v3.a;
		var bankAccounts = _v3.b;
		var cmd = _v3.c;
		return _Utils_Tuple2(
			{
				iw: A7(
					$author$project$Components$AuditTrailLog$init,
					session,
					shared.adY,
					shared.J7,
					$elm$core$Maybe$Just('patient'),
					$elm$core$Maybe$Just(patientId),
					patientCreatedAt,
					$elm$core$Maybe$Just('payment_methods')),
				rs: bankAccounts,
				xx: basePath,
				rC: cards,
				i_: $author$project$Components$CreatePaymentMethodModal$init,
				dd: shared.dd,
				gc: $elm$core$Maybe$Nothing,
				sF: shared.sF,
				Ij: $author$project$Shared$isHintAdmin(shared),
				ta: $author$project$Ui$Dropdown$init(
					$author$project$Ui$Dropdown$defaultConfig(
						{ahP: 'payment-methods-other-actions-dropdown-menu', al6: $author$project$Components$PaymentSources$DropdownMenuMsg})),
				gY: $author$project$Components$MovePaymentMethodsModal$init,
				kA: $author$project$Api$Data$Loading,
				ZV: practice,
				t9: shared.t9,
				Jy: resource,
				aa4: session,
				JQ: $elm$core$Maybe$Nothing,
				J7: shared.J7,
				J: $elm$core$Set$empty,
				vo: virtualBankAccountModel
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[cmd, virtualBankAccountCmd])));
	});
var $author$project$Pages$Companies$CompanyId_String$PaymentSources$init = F5(
	function (session, practice, company, shared, _v0) {
		var _v1 = A4(
			$author$project$Components$PaymentSources$init,
			$author$project$Components$PaymentSources$Company(company),
			session,
			practice,
			shared);
		var paymentSources = _v1.a;
		var paymentSourcesCmd = _v1.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, s1: paymentSources, ZV: practice},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, paymentSourcesCmd));
	});
var $author$project$Components$PaymentSources$setPractice = F2(
	function (practice, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{ZV: practice});
	});
var $author$project$Pages$Companies$CompanyId_String$PaymentSources$load = F2(
	function (shared, model) {
		var _v0 = shared.ZV;
		if (_v0.$ === 3) {
			var practice = _v0.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						s1: A2($author$project$Components$PaymentSources$setPractice, practice, model.s1),
						ZV: practice
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Companies$CompanyId_String$PaymentSources$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$PaymentSources$AuditTrailLogMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$PaymentSources$CreatePaymentMethodModalMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$PaymentSources$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Components$PaymentSources$MovePaymentMethodsModalMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$MovePaymentMethodsModal$Close = {$: 0};
var $author$project$Components$MovePaymentMethodsModal$LimitedPatientSelectorMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$LimitedPatientSelector$PatientResourceFilterMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$LimitedPatientSelector$subscriptions = function (model) {
	var _v0 = model.oY;
	if (!_v0.$) {
		var patientResourceFilter = _v0.a;
		return A2(
			$elm$core$Platform$Sub$map,
			$author$project$Components$LimitedPatientSelector$PatientResourceFilterMsg,
			$author$project$Components$ResourceFilter$Patient$subscriptions(patientResourceFilter));
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Components$MovePaymentMethodsModal$subscriptions = function (model) {
	if (!model.$) {
		return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$MovePaymentMethodsModal$Close);
	} else {
		var open = model.a;
		var fields = $author$project$Utils$Form$fields(open.SD);
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$MovePaymentMethodsModal$Close),
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$Components$MovePaymentMethodsModal$LimitedPatientSelectorMsg,
					$author$project$Components$LimitedPatientSelector$subscriptions(fields.oj))
				]));
	}
};
var $author$project$Components$PaymentSources$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$PaymentSources$CreatePaymentMethodModalMsg,
				$author$project$Components$CreatePaymentMethodModal$subscriptions(model.i_)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$PaymentSources$HiConfirmClosed),
					model.gc)),
				$author$project$Components$AuditTrailLog$isOpen(model.iw) ? A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$PaymentSources$AuditTrailLogMsg,
				$author$project$Components$AuditTrailLog$subscriptions(model.iw)) : $elm$core$Platform$Sub$none,
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$PaymentSources$MovePaymentMethodsModalMsg,
				$author$project$Components$MovePaymentMethodsModal$subscriptions(model.gY))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$PaymentSources$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$PaymentSources$subscriptions(model.s1));
};
var $author$project$Components$PaymentSources$Deleted = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$PaymentSources$MadeDefault = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Components$PaymentSources$Patient = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$PaymentSources$PatientUpdated = function (a) {
	return {$: 15, a: a};
};
var $author$project$OutMsg$RetrievePatient = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$PaymentSources$formFieldsFromSource = function (source) {
	var cardFields = function () {
		if (!source.$) {
			return $elm$core$Maybe$Just(
				{
					ag3: $author$project$Api$Source$expMonth(source),
					ag4: $author$project$Api$Source$expYear(source),
					vv: A2(
						$elm$core$Maybe$withDefault,
						'',
						$author$project$Api$Source$zip(source))
				});
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	return {
		GS: cardFields,
		aih: $author$project$Api$Source$label(source)
	};
};
var $author$project$Components$PaymentSources$cardFormFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 1:
				var month = field.a;
				return _Utils_update(
					fields,
					{
						ag3: $elm$core$String$toInt(month)
					});
			case 2:
				var year = field.a;
				return _Utils_update(
					fields,
					{
						ag4: $elm$core$String$toInt(year)
					});
			case 3:
				var string = field.a;
				return _Utils_update(
					fields,
					{vv: string});
			default:
				return fields;
		}
	});
var $author$project$Components$PaymentSources$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var string = field.a;
			return _Utils_update(
				fields,
				{
					aih: $author$project$Utils$String$toMaybe(string)
				});
		} else {
			var _v1 = fields.GS;
			if (_v1.$ === 1) {
				return fields;
			} else {
				var cardFields = _v1.a;
				return _Utils_update(
					fields,
					{
						GS: $elm$core$Maybe$Just(
							A2($author$project$Components$PaymentSources$cardFormFieldsUpdate, field, cardFields))
					});
			}
		}
	});
var $author$project$Components$PaymentSources$ExpirationDateValidation = 1;
var $author$project$Components$PaymentSources$expDateValidator = F2(
	function (currentDate, fields) {
		var _v0 = fields.GS;
		if (_v0.$ === 1) {
			return _List_Nil;
		} else {
			var cardFields = _v0.a;
			var invalid = _Utils_Tuple2(1, 'Please enter a future expiration date.');
			var _v1 = _Utils_Tuple2(cardFields.ag4, cardFields.ag3);
			if ((!_v1.a.$) && (!_v1.b.$)) {
				var expYear = _v1.a.a;
				var expMonth = _v1.b.a;
				var currentYear = $justinmimbs$date$Date$year(currentDate);
				var currentMonth = $justinmimbs$date$Date$monthNumber(currentDate);
				return (_Utils_eq(currentYear, expYear) && (_Utils_cmp(expMonth, currentMonth) < 0)) ? _List_fromArray(
					[invalid]) : _List_Nil;
			} else {
				return _List_fromArray(
					[invalid]);
			}
		}
	});
var $author$project$Components$PaymentSources$ZipValidation = 0;
var $author$project$Components$PaymentSources$zipValidator = function (fields) {
	var _v0 = fields.GS;
	if (_v0.$ === 1) {
		return _List_Nil;
	} else {
		var cardFields = _v0.a;
		var zipLenght = $elm$core$String$length(cardFields.vv);
		return ((zipLenght === 5) || (zipLenght === 9)) ? _List_Nil : _List_fromArray(
			[
				_Utils_Tuple2(0, 'Please enter a valid zip code.')
			]);
	}
};
var $author$project$Components$PaymentSources$formFieldsValidator = function (currentDate) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$PaymentSources$zipValidator),
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$PaymentSources$expDateValidator(currentDate))
			]));
};
var $author$project$Components$MovePaymentMethodsModal$None = 1;
var $author$project$Components$MovePaymentMethodsModal$Open = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$MovePaymentMethodsModal$GotPaymentSources = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$PaymentMethod$Min$PaymentMethod = $elm$core$Basics$identity;
var $author$project$Api$Provider$PaymentMethod$Min$Record = F5(
	function (id, sourceBrand, lastFour, label, isDefault) {
		return {ahP: id, UM: isDefault, aih: label, VG: lastFour, abK: sourceBrand};
	});
var $author$project$Api$Provider$PaymentMethod$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'is_default',
	$elm$json$Json$Decode$bool,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'label',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'last_four',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'payment_method_brand',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$PaymentMethod$Min$Record))))));
var $author$project$Api$Provider$PaymentMethod$Min$decoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $author$project$Api$Provider$PaymentMethod$Min$recordDecoder);
var $author$project$Api$Provider$Patient$PaymentMethod$list = F3(
	function (apiClient, patientId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$maybe(
				$elm$json$Json$Decode$list($author$project$Api$Provider$PaymentMethod$Min$decoder)),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Patient$PaymentMethod$paymentMethodsPath(patientId)));
	});
var $author$project$Components$MovePaymentMethodsModal$getPaymentSources = F2(
	function (apiClient, patientId) {
		return A3($author$project$Api$Provider$Patient$PaymentMethod$list, apiClient, patientId, $author$project$Components$MovePaymentMethodsModal$GotPaymentSources);
	});
var $author$project$Components$ResourceFilter$Patient$preSelectedId = F2(
	function (id, model) {
		var _v0 = A2($author$project$Components$ResourceFilter$preSelectedId, id, model.b8);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{b8: resourceFilter}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$LimitedPatientSelector$initPatientResourceFilter = F3(
	function (apiClient, optionals, patient) {
		return function (_v0) {
			var patientResourceFilter = _v0.a;
			var patientResourceFilterCmd = _v0.b;
			return A2(
				$elm$core$Maybe$withDefault,
				_Utils_Tuple2(patientResourceFilter, patientResourceFilterCmd),
				A2(
					$elm$core$Maybe$map,
					function (patient_) {
						var _v1 = A2(
							$author$project$Components$ResourceFilter$Patient$preSelectedId,
							$elm$core$Maybe$Just(patient_.ahP),
							patientResourceFilter);
						var withPreSelectedModel = _v1.a;
						var withPreSelectedCmd = _v1.b;
						return _Utils_Tuple2(
							A2(
								$author$project$Components$ResourceFilter$Patient$extraItems,
								_List_fromArray(
									[
										{Lj: patient_.Lj, ahP: patient_.ahP, WX: patient_.WX, Bq: patient_.Bq}
									]),
								withPreSelectedModel),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[withPreSelectedCmd, patientResourceFilterCmd])));
					},
					patient));
		}(
			A2($author$project$Components$ResourceFilter$Patient$init, apiClient, optionals));
	});
var $author$project$Components$LimitedPatientSelector$init = F4(
	function (apiClient, patientResourceFilterOptionals, patients, patient) {
		var _v0 = A2(
			$elm$core$List$any,
			function (patient_) {
				return _Utils_eq(
					$elm$core$Maybe$Just(patient_.ahP),
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.ahP;
						},
						patient));
			},
			patients) ? _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none) : A2(
			$elm$core$Tuple$mapFirst,
			$elm$core$Maybe$Just,
			A3($author$project$Components$LimitedPatientSelector$initPatientResourceFilter, apiClient, patientResourceFilterOptionals, patient));
		var patientResourceFilter = _v0.a;
		var patientResourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{
				YY: patient,
				oY: patientResourceFilter,
				I5: patientResourceFilterOptionals,
				CM: patients,
				aee: A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.ahP;
					},
					patient)
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$LimitedPatientSelector$PatientResourceFilterMsg, patientResourceFilterCmd));
	});
var $author$project$Components$MovePaymentMethodsModal$mapPatientAttributes = function (patient) {
	return A2(
		$elm$core$Maybe$map,
		function (patient_) {
			return {
				Lj: $author$project$Api$Provider$Patient$One$age(patient_),
				ahP: $author$project$Api$Provider$Patient$One$id(patient_),
				ais: $elm$core$Maybe$Nothing,
				WX: $author$project$Api$Provider$Patient$One$membershipStatus(patient_),
				Bq: $author$project$Api$Provider$Patient$One$name(patient_),
				aka: $elm$core$Maybe$Nothing,
				ad9: $author$project$Api$Provider$Patient$One$usesTobacco(patient_)
			};
		},
		patient);
};
var $author$project$Components$MovePaymentMethodsModal$initLimitedPatientSelector = F3(
	function (apiClient, patients, patient) {
		return A4(
			$author$project$Components$LimitedPatientSelector$init,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Select a Patient', Lr: true});
			},
			patients,
			$author$project$Components$MovePaymentMethodsModal$mapPatientAttributes(patient));
	});
var $author$project$Api$Provider$Patient$One$payees = function (_v0) {
	var record = _v0.b;
	return record.Y4;
};
var $author$project$Components$MovePaymentMethodsModal$initFormFields = F2(
	function (apiClient, patient) {
		var patients = A2(
			$elm$core$List$map,
			function (patient_) {
				return {
					Lj: $author$project$Api$Provider$Patient$Shared$age(patient_),
					ahP: $author$project$Api$Provider$Patient$Shared$id(patient_),
					ais: $elm$core$Maybe$Nothing,
					WX: $author$project$Api$Provider$Patient$Shared$membershipStatus(patient_),
					Bq: $author$project$Api$Provider$Patient$Shared$name(patient_),
					aka: $elm$core$Maybe$Nothing,
					ad9: $author$project$Api$Provider$Patient$Shared$usesTobacco(patient_)
				};
			},
			$author$project$Api$Provider$Patient$One$payees(patient));
		var _v0 = A3(
			$author$project$Components$MovePaymentMethodsModal$initLimitedPatientSelector,
			apiClient,
			patients,
			$elm$core$Maybe$Just(patient));
		var limitedPatientSelector = _v0.a;
		var limitedPatientSelectorCmd = _v0.b;
		return _Utils_Tuple2(
			{
				mM: true,
				oj: limitedPatientSelector,
				YY: $author$project$Components$MovePaymentMethodsModal$mapPatientAttributes(
					$elm$core$Maybe$Just(patient))
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$MovePaymentMethodsModal$LimitedPatientSelectorMsg, limitedPatientSelectorCmd));
	});
var $author$project$Components$MovePaymentMethodsModal$openAndInit = F4(
	function (apiClient, basePath, session, patient) {
		var _v0 = A2($author$project$Components$MovePaymentMethodsModal$initFormFields, apiClient, patient);
		var formFields = _v0.a;
		var formFieldsCmd = _v0.b;
		var open = {
			xx: basePath,
			SD: $author$project$Utils$Form$init(formFields),
			Al: true,
			tb: $author$project$Api$Data$NotAsked,
			YY: patient,
			eR: $elm$core$Maybe$Nothing,
			kB: $elm$core$Maybe$Nothing,
			Eq: $elm$core$Maybe$Just(
				$author$project$Api$Provider$Patient$One$id(patient)),
			Er: $elm$core$Maybe$Just(
				$author$project$Api$Provider$Patient$One$name(patient)),
			aa4: session
		};
		return {
			GZ: $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						formFieldsCmd,
						A2(
						$author$project$Components$MovePaymentMethodsModal$getPaymentSources,
						apiClient,
						$author$project$Api$Provider$Patient$One$id(patient))
					])),
			agZ: 1,
			aiO: $author$project$Components$MovePaymentMethodsModal$Open(open),
			aR: _List_Nil
		};
	});
var $author$project$Components$MovePaymentMethodsModal$Patient = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$MovePaymentMethodsModal$PaymentMethodsMigrated = 0;
var $author$project$Components$MovePaymentMethodsModal$moveDefaultToOtherSource = function (paymentSources) {
	return A2(
		$elm$core$List$map,
		function (paymentSource) {
			return _Utils_update(
				paymentSource,
				{UM: false});
		},
		paymentSources);
};
var $author$project$Components$MovePaymentMethodsModal$appendPaymentsources = F2(
	function (sourcePaymentSources, destinationpaymentSources) {
		return A2(
			$elm$core$Maybe$map,
			function (sourcePaymentSources_) {
				return A2(
					$elm$core$Maybe$withDefault,
					sourcePaymentSources_,
					A2(
						$elm$core$Maybe$map,
						function (destinationpaymentSources_) {
							return A2(
								$elm$core$List$append,
								sourcePaymentSources_,
								$author$project$Components$MovePaymentMethodsModal$moveDefaultToOtherSource(destinationpaymentSources_));
						},
						destinationpaymentSources));
			},
			sourcePaymentSources);
	});
var $author$project$Components$MovePaymentMethodsModal$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var patient = field.a;
			return _Utils_update(
				fields,
				{YY: patient});
		} else {
			var bool = field.a;
			return _Utils_update(
				fields,
				{mM: bool});
		}
	});
var $author$project$Components$MovePaymentMethodsModal$PatientValidation = 0;
var $author$project$Components$MovePaymentMethodsModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.YY;
			},
			_Utils_Tuple2(0, 'Please pick a patient.'))
		]));
var $author$project$Api$Provider$PaymentMethod$Min$isDefault = function (_v0) {
	var record = _v0;
	return record.UM;
};
var $author$project$Api$Provider$PaymentMethod$Min$lastFour = function (_v0) {
	var record = _v0;
	return record.VG;
};
var $author$project$Api$Provider$PaymentMethod$Min$paymentMethodBrand = function (_v0) {
	var record = _v0;
	return record.abK;
};
var $author$project$Components$MovePaymentMethodsModal$mapPaymentSourceAttributes = function (sources) {
	return A2(
		$elm$core$Maybe$map,
		function (sources_) {
			return A2(
				$elm$core$List$map,
				function (source_) {
					return {
						UM: $author$project$Api$Provider$PaymentMethod$Min$isDefault(source_),
						VG: A2(
							$elm$core$Maybe$withDefault,
							'N/A',
							$author$project$Api$Provider$PaymentMethod$Min$lastFour(source_)),
						C7: $author$project$Api$Provider$PaymentMethod$Min$paymentMethodBrand(source_)
					};
				},
				sources_);
		},
		sources);
};
var $author$project$Components$MovePaymentMethodsModal$PaymentMethodsMoved = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Patient$PaymentMethod$movePath = function (patientId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['migrate']),
		$author$project$Api$Provider$Patient$PaymentMethod$paymentMethodsPath(patientId));
};
var $author$project$Api$Provider$Patient$PaymentMethod$migrate = F4(
	function (apiClient, patientId, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'to_patient_id',
					$elm$json$Json$Encode$string(params.al7)),
					_Utils_Tuple2(
					'remove_sources_from_patient',
					$elm$json$Json$Encode$bool(params.akM))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Patient$PaymentMethod$movePath(patientId))));
	});
var $author$project$Components$MovePaymentMethodsModal$movePaymentMethods = F3(
	function (apiClient, fromPatient, fields) {
		return A4(
			$author$project$Api$Provider$Patient$PaymentMethod$migrate,
			apiClient,
			$author$project$Api$Provider$Patient$One$id(fromPatient),
			{
				akM: fields.mM,
				al7: A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.ahP;
						},
						fields.YY))
			},
			$author$project$Components$MovePaymentMethodsModal$PaymentMethodsMoved);
	});
var $author$project$Components$LimitedPatientSelector$ItemSelected = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$LimitedPatientSelector$None = {$: 0};
var $author$project$Api$Provider$Patient$All$location = function (_v0) {
	var record = _v0.b;
	return record.ais;
};
var $author$project$Api$Provider$Patient$All$practitioner = function (_v0) {
	var record = _v0.b;
	return record.aka;
};
var $author$project$Api$Provider$Patient$All$usesTobacco = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$usesTobacco(shared);
};
var $author$project$Components$LimitedPatientSelector$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var _v1 = A3($author$project$Components$LimitedPatientSelector$initPatientResourceFilter, apiClient, model.I5, model.YY);
				var patientResourceFilter = _v1.a;
				var patientResourceFilterCmd = _v1.b;
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$LimitedPatientSelector$PatientResourceFilterMsg, patientResourceFilterCmd),
					agZ: $author$project$Components$LimitedPatientSelector$None,
					aiO: _Utils_update(
						model,
						{
							oY: $elm$core$Maybe$Just(patientResourceFilter)
						}),
					aR: _List_Nil
				};
			case 1:
				var patientId = msg.a;
				var patient = A2(
					$elm_community$list_extra$List$Extra$find,
					function (patient_) {
						return _Utils_eq(patient_.ahP, patientId);
					},
					model.CM);
				var event = A2(
					$elm$core$Maybe$withDefault,
					$author$project$Components$LimitedPatientSelector$ItemSelected($author$project$Components$ResourceFilter$None),
					A2(
						$elm$core$Maybe$map,
						A2($elm$core$Basics$composeL, $author$project$Components$LimitedPatientSelector$ItemSelected, $author$project$Components$ResourceFilter$One),
						patient));
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: event,
					aiO: _Utils_update(
						model,
						{
							YY: patient,
							aee: A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.ahP;
								},
								patient)
						}),
					aR: _List_Nil
				};
			default:
				var subMsg = msg.a;
				var _v2 = model.oY;
				if (!_v2.$) {
					var patientResourceFilter = _v2.a;
					var patientResourceResult = A3($author$project$Components$ResourceFilter$Patient$update, apiClient, subMsg, patientResourceFilter);
					var event = function () {
						var _v3 = patientResourceResult.agZ;
						if (_v3.$ === 1) {
							return $author$project$Components$LimitedPatientSelector$None;
						} else {
							switch (_v3.a.$) {
								case 0:
									var patient = _v3.a.a;
									var practitioner = A2(
										$elm$core$Maybe$map,
										function (practitioner_) {
											return {
												ahP: $author$project$Api$Provider$Practitioner$Min$id(practitioner_),
												Bq: $author$project$Api$Provider$Practitioner$Min$name(practitioner_)
											};
										},
										$author$project$Api$Provider$Patient$All$practitioner(patient));
									var location = A2(
										$elm$core$Maybe$map,
										function (location_) {
											return {
												ahP: $author$project$Api$Provider$Location$Min$id(location_),
												Bq: $author$project$Api$Provider$Location$Min$name(location_)
											};
										},
										$author$project$Api$Provider$Patient$All$location(patient));
									var resource = {
										Lj: $author$project$Api$Provider$Patient$All$age(patient),
										ahP: $author$project$Api$Provider$Patient$All$id(patient),
										ais: location,
										WX: $author$project$Api$Provider$Patient$All$membershipStatus(patient),
										Bq: $author$project$Api$Provider$Patient$All$name(patient),
										aka: practitioner,
										ad9: $author$project$Api$Provider$Patient$All$usesTobacco(patient)
									};
									return $author$project$Components$LimitedPatientSelector$ItemSelected(
										$author$project$Components$ResourceFilter$One(resource));
								case 2:
									var _v4 = _v3.a;
									return $author$project$Components$LimitedPatientSelector$ItemSelected($author$project$Components$ResourceFilter$None);
								case 3:
									var _v5 = _v3.a;
									return $author$project$Components$LimitedPatientSelector$ItemSelected($author$project$Components$ResourceFilter$None);
								default:
									return $author$project$Components$LimitedPatientSelector$None;
							}
						}
					}();
					return {
						GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$LimitedPatientSelector$PatientResourceFilterMsg, patientResourceResult.GZ),
						agZ: event,
						aiO: _Utils_update(
							model,
							{
								oY: $elm$core$Maybe$Just(patientResourceResult.aiO)
							}),
						aR: patientResourceResult.aR
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$LimitedPatientSelector$None, aiO: model, aR: _List_Nil};
				}
		}
	});
var $author$project$Components$MovePaymentMethodsModal$updateForm = F4(
	function (model, apiClient, field, form) {
		var selectedPatientName = function () {
			if ((!field.$) && (!field.a.$)) {
				var patient = field.a.a;
				return $elm$core$Maybe$Just(patient.Bq);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var selectedPatientId = function () {
			if ((!field.$) && (!field.a.$)) {
				var patient = field.a.a;
				return $elm$core$Maybe$Just(patient.ahP);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var newForm = A3($author$project$Utils$Form$update, $author$project$Components$MovePaymentMethodsModal$formFieldsUpdate, field, form);
		var cmd = function () {
			if (!selectedPatientId.$) {
				var patientId = selectedPatientId.a;
				return A2($author$project$Components$MovePaymentMethodsModal$getPaymentSources, apiClient, patientId);
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		}();
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{SD: newForm, Eq: selectedPatientId, Er: selectedPatientName}),
			cmd);
	});
var $author$project$Components$MovePaymentMethodsModal$update = F3(
	function (apiClient, msg, model) {
		if (model.$ === 1) {
			var open = model.a;
			switch (msg.$) {
				case 0:
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 1, aiO: $author$project$Components$MovePaymentMethodsModal$Closed, aR: _List_Nil};
				case 2:
					var field = msg.a;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$MovePaymentMethodsModal$formFieldsUpdate, field, open.SD);
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 1,
						aiO: $author$project$Components$MovePaymentMethodsModal$Open(
							_Utils_update(
								open,
								{SD: newForm})),
						aR: _List_Nil
					};
				case 1:
					var subMsg = msg.a;
					var fields = $author$project$Utils$Form$fields(open.SD);
					var limitedPatientSelectorResult = A3($author$project$Components$LimitedPatientSelector$update, apiClient, subMsg, fields.oj);
					var newForm = A2(
						$author$project$Utils$Form$set,
						_Utils_update(
							fields,
							{oj: limitedPatientSelectorResult.aiO}),
						open.SD);
					var _v2 = function () {
						var _v3 = limitedPatientSelectorResult.agZ;
						_v3$2:
						while (true) {
							if (_v3.$ === 1) {
								switch (_v3.a.$) {
									case 0:
										var patient = _v3.a.a;
										return A4(
											$author$project$Components$MovePaymentMethodsModal$updateForm,
											open,
											apiClient,
											$author$project$Components$MovePaymentMethodsModal$Patient(
												$elm$core$Maybe$Just(patient)),
											newForm);
									case 3:
										var _v4 = _v3.a;
										return A4(
											$author$project$Components$MovePaymentMethodsModal$updateForm,
											open,
											apiClient,
											$author$project$Components$MovePaymentMethodsModal$Patient($elm$core$Maybe$Nothing),
											newForm);
									default:
										break _v3$2;
								}
							} else {
								break _v3$2;
							}
						}
						return _Utils_Tuple2(
							_Utils_update(
								open,
								{SD: newForm}),
							$elm$core$Platform$Cmd$none);
					}();
					var newModel = _v2.a;
					var formCmd = _v2.b;
					return {
						GZ: $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$MovePaymentMethodsModal$LimitedPatientSelectorMsg, limitedPatientSelectorResult.GZ),
									formCmd
								])),
						agZ: 1,
						aiO: $author$project$Components$MovePaymentMethodsModal$Open(newModel),
						aR: limitedPatientSelectorResult.aR
					};
				case 3:
					var _v5 = A2($author$project$Utils$Form$validate, $author$project$Components$MovePaymentMethodsModal$formFieldsValidator, open.SD);
					if (!_v5.$) {
						var _v6 = _v5.a;
						var newForm = _v6.a;
						var validFormFields = _v6.b;
						var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
						return {
							GZ: A3($author$project$Components$MovePaymentMethodsModal$movePaymentMethods, apiClient, open.YY, fields),
							agZ: 1,
							aiO: $author$project$Components$MovePaymentMethodsModal$Open(
								_Utils_update(
									open,
									{SD: newForm, tb: $author$project$Api$Data$Loading})),
							aR: _List_Nil
						};
					} else {
						var newForm = _v5.a;
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 1,
							aiO: $author$project$Components$MovePaymentMethodsModal$Open(
								_Utils_update(
									open,
									{SD: newForm})),
							aR: _List_Nil
						};
					}
				case 4:
					var response = msg.a;
					switch (response.$) {
						case 3:
							return {
								GZ: $elm$core$Platform$Cmd$none,
								agZ: 0,
								aiO: $author$project$Components$MovePaymentMethodsModal$Closed,
								aR: _List_fromArray(
									[
										A2($author$project$OutMsg$ShowToast, 3, 'Payment sources migrated to new patient.')
									])
							};
						case 2:
							return {
								GZ: $elm$core$Platform$Cmd$none,
								agZ: 1,
								aiO: $author$project$Components$MovePaymentMethodsModal$Open(
									_Utils_update(
										open,
										{tb: response})),
								aR: $author$project$OutMsg$handleErrorResponse(response)
							};
						default:
							return {GZ: $elm$core$Platform$Cmd$none, agZ: 1, aiO: $author$project$Components$MovePaymentMethodsModal$Closed, aR: _List_Nil};
					}
				default:
					var response = msg.a;
					switch (response.$) {
						case 3:
							var paymentSources = response.a;
							var maybePaymentMethods = $author$project$Components$MovePaymentMethodsModal$mapPaymentSourceAttributes(paymentSources);
							var paymentMethodsList = A2($author$project$Components$MovePaymentMethodsModal$appendPaymentsources, open.eR, maybePaymentMethods);
							var currentOwnerPaymentMethods = open.Al ? maybePaymentMethods : open.eR;
							return {
								GZ: $elm$core$Platform$Cmd$none,
								agZ: 1,
								aiO: $author$project$Components$MovePaymentMethodsModal$Open(
									_Utils_update(
										open,
										{Al: false, eR: currentOwnerPaymentMethods, kB: paymentMethodsList})),
								aR: _List_Nil
							};
						case 2:
							return {
								GZ: $elm$core$Platform$Cmd$none,
								agZ: 1,
								aiO: $author$project$Components$MovePaymentMethodsModal$Open(open),
								aR: _List_Nil
							};
						default:
							return {GZ: $elm$core$Platform$Cmd$none, agZ: 1, aiO: $author$project$Components$MovePaymentMethodsModal$Closed, aR: _List_Nil};
					}
			}
		} else {
			return {GZ: $elm$core$Platform$Cmd$none, agZ: 1, aiO: model, aR: _List_Nil};
		}
	});
var $author$project$Api$Provider$VirtualBankAccount$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Components$VirtualBankAccounts$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{F7: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var field = msg.a;
				var copiedText = msg.b;
				return _Utils_Tuple3(
					model,
					$author$project$Ports$Clipboard$copy(copiedText),
					_List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 3, field + ' copied to clipboard')
						]));
			default:
				var virtualBankAccount = msg.a;
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					_List_fromArray(
						[
							A2(
							$author$project$OutMsg$ShowToast,
							1,
							'Unimplemented action ' + $author$project$Api$Provider$VirtualBankAccount$Shared$id(virtualBankAccount))
						]));
		}
	});
var $author$project$Api$Provider$Patient$updateAutopay = F4(
	function (apiClient, id_, autopay_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'patient',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'autopay',
								$elm$json$Json$Encode$bool(autopay_))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Patient$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Patient$patientPath(id_))));
	});
var $author$project$Api$Provider$Patient$updateExemptFromCreditCardFees = F4(
	function (apiClient, id_, autopay_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'patient',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'exempt_from_credit_card_fees',
								$elm$json$Json$Encode$bool(autopay_))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Patient$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Patient$patientPath(id_))));
	});
var $author$project$Components$PaymentSources$Updated = function (a) {
	return {$: 19, a: a};
};
var $author$project$Api$Employer$BankAccount$update = F5(
	function (basePath, apiClient, id_, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'bank_account',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'label',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.aih))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Employer$BankAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Employer$BankAccount$bankAccountPath, basePath, id_))));
	});
var $author$project$Api$Provider$BankAccount$update = F5(
	function (basePath, apiClient, id_, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'bank_account',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'label',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.aih))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$BankAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Provider$BankAccount$bankAccountPath, basePath, id_))));
	});
var $author$project$Api$BankAccount$update = F6(
	function (basePath, apiClient, session, bankAccount, fields, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A5(
			$author$project$Api$Employer$BankAccount$update,
			basePath,
			apiClient,
			$author$project$Api$BankAccount$id(bankAccount),
			fields,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$BankAccount$EmployerOne))) : A5(
			$author$project$Api$Provider$BankAccount$update,
			basePath,
			apiClient,
			$author$project$Api$BankAccount$id(bankAccount),
			fields,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$BankAccount$ProviderOne)));
	});
var $author$project$Api$Employer$Card$update = F5(
	function (basePath, apiClient, id_, fields, toMsg) {
		var zipCode = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$json$Json$Encode$string,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$pair('zip'),
						$elm$core$List$singleton)),
				fields.vv));
		var label = _List_fromArray(
			[
				_Utils_Tuple2(
				'label',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.aih))
			]);
		var expYear = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$String$fromInt,
					A2(
						$elm$core$Basics$composeR,
						$elm$json$Json$Encode$string,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$pair('exp_year'),
							$elm$core$List$singleton))),
				fields.ag4));
		var expMonth = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$String$fromInt,
					A2(
						$elm$core$Basics$composeR,
						$elm$json$Json$Encode$string,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$pair('exp_month'),
							$elm$core$List$singleton))),
				fields.ag3));
		var cardObject = $elm$json$Json$Encode$object(
			$elm$core$List$concat(
				_List_fromArray(
					[label, expMonth, expYear, zipCode])));
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2('card', cardObject)
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Employer$Card$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Employer$Card$cardPath, basePath, id_))));
	});
var $author$project$Api$Provider$Card$update = F5(
	function (basePath, apiClient, id_, fields, toMsg) {
		var zipCode = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$json$Json$Encode$string,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$pair('zip'),
						$elm$core$List$singleton)),
				fields.vv));
		var label = _List_fromArray(
			[
				_Utils_Tuple2(
				'label',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.aih))
			]);
		var expYear = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$String$fromInt,
					A2(
						$elm$core$Basics$composeR,
						$elm$json$Json$Encode$string,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$pair('exp_year'),
							$elm$core$List$singleton))),
				fields.ag4));
		var expMonth = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$String$fromInt,
					A2(
						$elm$core$Basics$composeR,
						$elm$json$Json$Encode$string,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$pair('exp_month'),
							$elm$core$List$singleton))),
				fields.ag3));
		var cardObject = $elm$json$Json$Encode$object(
			$elm$core$List$concat(
				_List_fromArray(
					[label, expMonth, expYear, zipCode])));
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2('card', cardObject)
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Card$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Provider$Card$cardPath, basePath, id_))));
	});
var $author$project$Api$Card$update = F6(
	function (basePath, apiClient, session, card, fields, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A5(
			$author$project$Api$Employer$Card$update,
			basePath,
			apiClient,
			$author$project$Api$Card$id(card),
			fields,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Card$EmployerOne))) : A5(
			$author$project$Api$Provider$Card$update,
			basePath,
			apiClient,
			$author$project$Api$Card$id(card),
			fields,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Card$ProviderOne)));
	});
var $author$project$Api$Source$update = F6(
	function (basePath, apiClient, session, source, fields, toMsg) {
		switch (source.$) {
			case 0:
				var card = source.a;
				var cardFields = {
					ag3: A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.ag3;
						},
						fields.GS),
					ag4: A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.ag4;
						},
						fields.GS),
					aih: fields.aih,
					vv: A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.vv;
						},
						fields.GS)
				};
				return A6(
					$author$project$Api$Card$update,
					basePath,
					apiClient,
					session,
					card,
					cardFields,
					A2(
						$elm$core$Basics$composeL,
						toMsg,
						$author$project$Api$Data$map($author$project$Api$Source$Card)));
			case 1:
				var bankAccount = source.a;
				var onlyLabel = function (f) {
					return {aih: f.aih};
				}(fields);
				return A6(
					$author$project$Api$BankAccount$update,
					basePath,
					apiClient,
					session,
					bankAccount,
					onlyLabel,
					A2(
						$elm$core$Basics$composeL,
						toMsg,
						$author$project$Api$Data$map($author$project$Api$Source$BankAccount)));
			default:
				return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Components$PaymentSources$updateSource = F5(
	function (basePath, apiClient, session, source, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A6($author$project$Api$Source$update, basePath, apiClient, session, source, fields, $author$project$Components$PaymentSources$Updated);
	});
var $author$project$Components$PaymentSources$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 9:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{rC: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 8:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{rs: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 10:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{kA: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 17:
				var patientId = msg.a;
				var toggle = msg.b;
				var cmd = A4($author$project$Api$Provider$Patient$updateExemptFromCreditCardFees, apiClient, patientId, toggle, $author$project$Components$PaymentSources$PatientUpdated);
				return _Utils_Tuple3(model, cmd, _List_Nil);
			case 16:
				var patientId = msg.a;
				var toggle = msg.b;
				var cmd = A4($author$project$Api$Provider$Patient$updateAutopay, apiClient, patientId, toggle, $author$project$Components$PaymentSources$PatientUpdated);
				return _Utils_Tuple3(model, cmd, _List_Nil);
			case 15:
				var response = msg.a;
				switch (response.$) {
					case 2:
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					case 3:
						var patient = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									Jy: $author$project$Components$PaymentSources$Patient(patient)
								}),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									$author$project$OutMsg$RetrievePatient(
									$author$project$Api$Provider$Patient$One$id(patient))
								]));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var source = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							JQ: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									source,
									$author$project$Utils$Form$init(
										$author$project$Components$PaymentSources$formFieldsFromSource(source)),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 7:
				var field = msg.a;
				var _v3 = model.JQ;
				if (!_v3.$) {
					var _v4 = _v3.a;
					var source = _v4.a;
					var form = _v4.b;
					var saveRequest = _v4.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$PaymentSources$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								JQ: $elm$core$Maybe$Just(
									_Utils_Tuple3(source, newForm, saveRequest))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{JQ: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 18:
				var _v5 = model.JQ;
				if (!_v5.$) {
					var _v6 = _v5.a;
					var source = _v6.a;
					var form = _v6.b;
					var formValidator = $author$project$Components$PaymentSources$formFieldsValidator(model.dd);
					var _v7 = A2($author$project$Utils$Form$validate, formValidator, form);
					if (!_v7.$) {
						var _v8 = _v7.a;
						var newForm = _v8.a;
						var validFormFields = _v8.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									JQ: $elm$core$Maybe$Just(
										_Utils_Tuple3(source, newForm, $author$project$Api$Data$Loading))
								}),
							A5($author$project$Components$PaymentSources$updateSource, model.xx, apiClient, model.aa4, source, validFormFields),
							_List_Nil);
					} else {
						var newForm = _v7.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									JQ: $elm$core$Maybe$Just(
										_Utils_Tuple3(source, newForm, $author$project$Api$Data$NotAsked))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 19:
				var response = msg.a;
				var _v9 = model.JQ;
				if (!_v9.$) {
					var _v10 = _v9.a;
					var source = _v10.a;
					var form = _v10.b;
					if (response.$ === 3) {
						var _v12 = A4($author$project$Components$PaymentSources$loadData, model.xx, apiClient, model.aa4, model.Jy);
						var cards = _v12.a;
						var bankAccounts = _v12.b;
						var cmd = _v12.c;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{rs: bankAccounts, rC: cards, JQ: $elm$core$Maybe$Nothing}),
							cmd,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Source successfully updated.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									JQ: $elm$core$Maybe$Just(
										_Utils_Tuple3(source, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 13:
				var source = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							gc: $elm$core$Maybe$Nothing,
							J: A2(
								$elm$core$Set$insert,
								$author$project$Api$Source$id(source),
								model.J)
						}),
					A6(
						$author$project$Api$Source$updateDefault,
						model.xx,
						apiClient,
						model.aa4,
						source,
						$elm$core$Maybe$Nothing,
						$author$project$Components$PaymentSources$MadeDefault(
							$author$project$Api$Source$id(source))),
					_List_Nil);
			case 12:
				var id = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						var _v14 = A4($author$project$Components$PaymentSources$loadData, model.xx, apiClient, model.aa4, model.Jy);
						var cards = _v14.a;
						var bankAccounts = _v14.b;
						var cmd = _v14.c;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									rs: bankAccounts,
									rC: cards,
									J: A2($elm$core$Set$remove, id, model.J)
								}),
							cmd,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Default source successfully updated.')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									J: A2($elm$core$Set$remove, id, model.J)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var source = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							gc: $elm$core$Maybe$Just(source)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 11:
				var source = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							gc: $elm$core$Maybe$Nothing,
							J: A2(
								$elm$core$Set$insert,
								$author$project$Api$Source$id(source),
								model.J)
						}),
					A5(
						$author$project$Api$Source$delete,
						model.xx,
						apiClient,
						model.aa4,
						source,
						$author$project$Components$PaymentSources$Deleted(source)),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{gc: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var source = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						var retrieveOutMsg = function () {
							var _v17 = model.Jy;
							if (_v17.$ === 1) {
								var patient = _v17.a;
								return _List_fromArray(
									[
										$author$project$OutMsg$RetrievePatient(
										$author$project$Api$Provider$Patient$One$id(patient))
									]);
							} else {
								return _List_Nil;
							}
						}();
						var _v16 = A4($author$project$Components$PaymentSources$loadData, model.xx, apiClient, model.aa4, model.Jy);
						var cards = _v16.a;
						var bankAccounts = _v16.b;
						var cmd = _v16.c;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									rs: bankAccounts,
									rC: cards,
									J: A2(
										$elm$core$Set$remove,
										$author$project$Api$Source$id(source),
										model.J)
								}),
							cmd,
							A2(
								$elm$core$List$cons,
								A2($author$project$OutMsg$ShowToast, 3, 'Source successfully deleted'),
								retrieveOutMsg));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									J: A2(
										$elm$core$Set$remove,
										$author$project$Api$Source$id(source),
										model.J)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				var subMsg = msg.a;
				var createPaymentMethodModalResult = A3($author$project$Components$CreatePaymentMethodModal$update, apiClient, subMsg, model.i_);
				var _v18 = function () {
					var _v19 = createPaymentMethodModalResult.agZ;
					if (!_v19) {
						return A4($author$project$Components$PaymentSources$loadData, model.xx, apiClient, model.aa4, model.Jy);
					} else {
						return _Utils_Tuple3(model.rC, model.rs, $elm$core$Platform$Cmd$none);
					}
				}();
				var cards = _v18.a;
				var bankAccounts = _v18.b;
				var cmd = _v18.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{rs: bankAccounts, rC: cards, i_: createPaymentMethodModalResult.aiO}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentSources$CreatePaymentMethodModalMsg, createPaymentMethodModalResult.GZ),
								cmd
							])),
					createPaymentMethodModalResult.aR);
			case 5:
				var subMsg = msg.a;
				var _v20 = A2($author$project$Ui$Dropdown$update, subMsg, model.ta);
				var dropdownMenu = _v20.a;
				var cmd = _v20.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ta: dropdownMenu}),
					cmd,
					_List_Nil);
			case 14:
				var subMsg = msg.a;
				var movePaymentMethodsModalResult = A3($author$project$Components$MovePaymentMethodsModal$update, apiClient, subMsg, model.gY);
				var _v21 = function () {
					var _v22 = movePaymentMethodsModalResult.agZ;
					if (!_v22) {
						return A4($author$project$Components$PaymentSources$loadData, model.xx, apiClient, model.aa4, model.Jy);
					} else {
						return _Utils_Tuple3(model.rC, model.rs, $elm$core$Platform$Cmd$none);
					}
				}();
				var cards = _v21.a;
				var bankAccounts = _v21.b;
				var cmd = _v21.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{rs: bankAccounts, rC: cards, gY: movePaymentMethodsModalResult.aiO}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentSources$MovePaymentMethodsModalMsg, movePaymentMethodsModalResult.GZ),
								cmd
							])),
					movePaymentMethodsModalResult.aR);
			case 0:
				var subMsg = msg.a;
				var auditTrailLogResult = A3($author$project$Components$AuditTrailLog$update, apiClient, subMsg, model.iw);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{iw: auditTrailLogResult.aiO}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentSources$AuditTrailLogMsg, auditTrailLogResult.GZ),
					auditTrailLogResult.aR);
			case 20:
				var subMsg = msg.a;
				var _v23 = function () {
					var _v24 = model.vo;
					if (!_v24.$) {
						var virtualBankAccountsComponent_ = _v24.a;
						var _v25 = A2($author$project$Components$VirtualBankAccounts$update, subMsg, virtualBankAccountsComponent_);
						var virtualModel_ = _v25.a;
						var virtualCmd_ = _v25.b;
						var virtualOutMsgs_ = _v25.c;
						return _Utils_Tuple3(
							$elm$core$Maybe$Just(virtualModel_),
							A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentSources$VirtualBankAccountsComponentMsg, virtualCmd_),
							virtualOutMsgs_);
					} else {
						return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				}();
				var model_ = _v23.a;
				var cmd_ = _v23.b;
				var outMsgs_ = _v23.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{vo: model_}),
					cmd_,
					outMsgs_);
			default:
				var patient = msg.a;
				var result = A4($author$project$Components$MovePaymentMethodsModal$openAndInit, apiClient, model.xx, model.aa4, patient);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{gY: result.aiO}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentSources$MovePaymentMethodsModalMsg, result.GZ),
					result.aR);
		}
	});
var $author$project$Pages$Companies$CompanyId_String$PaymentSources$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$PaymentSources$update, model.Gv, subMsg, model.s1);
		var paymentSources = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{s1: paymentSources}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Components$MovePaymentMethodsModal$Checkbox = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$MovePaymentMethodsModal$FormUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$MovePaymentMethodsModal$MovePaymentMethods = {$: 3};
var $author$project$Components$MovePaymentMethodsModal$countPaymentSources = F2(
	function (model, patientId) {
		var paymentSources = _Utils_eq(
			patientId,
			$author$project$Api$Provider$Patient$One$id(model.YY)) ? model.eR : model.kB;
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$List$length, paymentSources));
	});
var $author$project$Components$MovePaymentMethodsModal$defaultPaymentSource = function (paymentSources) {
	return A2(
		$elm$core$List$filter,
		function (paymentSource_) {
			return paymentSource_.UM;
		},
		paymentSources);
};
var $author$project$Components$MovePaymentMethodsModal$displayDefaultSource = F3(
	function (model, patientId, typOptions) {
		var defaultSource = function () {
			if (_Utils_eq(
				patientId,
				$author$project$Api$Provider$Patient$One$id(model.YY))) {
				var _v0 = model.eR;
				if (!_v0.$) {
					var paymentSource_ = _v0.a;
					return $author$project$Components$MovePaymentMethodsModal$defaultPaymentSource(paymentSource_);
				} else {
					return _List_Nil;
				}
			} else {
				var _v1 = model.kB;
				if (!_v1.$) {
					var paymentSource_ = _v1.a;
					return $author$project$Components$MovePaymentMethodsModal$defaultPaymentSource(paymentSource_);
				} else {
					return _List_Nil;
				}
			}
		}();
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('list-align-left')
				]),
			A2(
				$elm$core$List$map,
				function (source_) {
					return A2(
						$elm$html$Html$li,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$text,
								A2($elm$core$List$cons, $author$project$Ui$Typography$bold, typOptions),
								source_.C7 + ' '),
								A2($author$project$Ui$Typography$text, typOptions, source_.VG)
							]));
				},
				defaultSource));
	});
var $author$project$Components$MovePaymentMethodsModal$displayNoBulletSources = F3(
	function (model, patientId, typOptions) {
		var paymentSources = _Utils_eq(
			patientId,
			$author$project$Api$Provider$Patient$One$id(model.YY)) ? model.eR : model.kB;
		var paymentSource = A2(
			$elm$core$Maybe$andThen,
			function (sources) {
				return $elm$core$List$head(sources);
			},
			paymentSources);
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					function () {
					if (!paymentSource.$) {
						var paymentSource_ = paymentSource.a;
						return A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$text,
									A2($elm$core$List$cons, $author$project$Ui$Typography$bold, typOptions),
									paymentSource_.C7 + ' '),
									A2($author$project$Ui$Typography$text, typOptions, paymentSource_.VG)
								]));
					} else {
						return $elm$html$Html$text('');
					}
				}()
				]));
	});
var $author$project$Components$MovePaymentMethodsModal$otherPaymentSources = function (paymentSources) {
	return A2(
		$elm$core$List$filter,
		function (paymentSource_) {
			return !paymentSource_.UM;
		},
		paymentSources);
};
var $author$project$Components$MovePaymentMethodsModal$displayOtherSources = F3(
	function (model, patientId, typOptions) {
		var otherSources = function () {
			if (_Utils_eq(
				patientId,
				$author$project$Api$Provider$Patient$One$id(model.YY))) {
				var _v0 = model.eR;
				if (!_v0.$) {
					var paymentSource_ = _v0.a;
					return $author$project$Components$MovePaymentMethodsModal$otherPaymentSources(paymentSource_);
				} else {
					return _List_Nil;
				}
			} else {
				var _v1 = model.kB;
				if (!_v1.$) {
					var paymentSource_ = _v1.a;
					return $author$project$Components$MovePaymentMethodsModal$otherPaymentSources(paymentSource_);
				} else {
					return _List_Nil;
				}
			}
		}();
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('list-align-left')
				]),
			A2(
				$elm$core$List$map,
				function (source_) {
					return A2(
						$elm$html$Html$li,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$text,
								A2($elm$core$List$cons, $author$project$Ui$Typography$bold, typOptions),
								source_.C7 + ' '),
								A2($author$project$Ui$Typography$text, typOptions, source_.VG)
							]));
				},
				otherSources));
	});
var $author$project$Components$MovePaymentMethodsModal$showTextIf = F2(
	function (isTrue, htmlMsg) {
		return isTrue ? htmlMsg : $elm$html$Html$text('');
	});
var $author$project$Components$MovePaymentMethodsModal$displayPaymentSources = F3(
	function (model, patientId, typOptions) {
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Components$MovePaymentMethodsModal$showTextIf,
					A2($author$project$Components$MovePaymentMethodsModal$countPaymentSources, model, patientId) > 1,
					A2($author$project$Ui$Typography$text, typOptions, 'Default Source:')),
					A2(
					$author$project$Components$MovePaymentMethodsModal$showTextIf,
					A2($author$project$Components$MovePaymentMethodsModal$countPaymentSources, model, patientId) > 1,
					A3($author$project$Components$MovePaymentMethodsModal$displayDefaultSource, model, patientId, typOptions)),
					A2(
					$author$project$Components$MovePaymentMethodsModal$showTextIf,
					A2($author$project$Components$MovePaymentMethodsModal$countPaymentSources, model, patientId) === 1,
					A3($author$project$Components$MovePaymentMethodsModal$displayNoBulletSources, model, patientId, typOptions)),
					A2(
					$author$project$Components$MovePaymentMethodsModal$showTextIf,
					A2($author$project$Components$MovePaymentMethodsModal$countPaymentSources, model, patientId) > 1,
					A2($author$project$Ui$Typography$text, typOptions, 'Payment Sources:')),
					A2(
					$author$project$Components$MovePaymentMethodsModal$showTextIf,
					A2($author$project$Components$MovePaymentMethodsModal$countPaymentSources, model, patientId) > 1,
					A3($author$project$Components$MovePaymentMethodsModal$displayOtherSources, model, patientId, typOptions))
				]));
	});
var $author$project$Components$LimitedPatientSelector$Errors = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$LimitedPatientSelector$errors = $author$project$Components$LimitedPatientSelector$Errors;
var $author$project$Components$LimitedPatientSelector$Invalid = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$LimitedPatientSelector$invalid = $author$project$Components$LimitedPatientSelector$Invalid;
var $author$project$Components$LimitedPatientSelector$FindAnotherPatient = {$: 0};
var $author$project$Components$LimitedPatientSelector$PatientSelected = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$LimitedPatientSelector$defaultOptions = {agX: _List_Nil, sM: false};
var $author$project$Components$LimitedPatientSelector$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				if (!option.$) {
					var bool = option.a;
					return _Utils_update(
						record,
						{sM: bool});
				} else {
					var list = option.a;
					return _Utils_update(
						record,
						{agX: list});
				}
			}),
		$author$project$Components$LimitedPatientSelector$defaultOptions,
		options);
};
var $author$project$Components$LimitedPatientSelector$patientOptions = function (patients) {
	return A2(
		$elm$core$List$cons,
		A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(''),
			'Choose a patient'),
		A2(
			$elm$core$List$map,
			function (patient) {
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(patient.ahP),
					patient.Bq);
			},
			patients));
};
var $author$project$Components$LimitedPatientSelector$view = F2(
	function (options, model) {
		var optionsRecord = $author$project$Components$LimitedPatientSelector$optionsToRecord(options);
		var _v0 = model.oY;
		if (!_v0.$) {
			var patientResourceFilter = _v0.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Components$LimitedPatientSelector$PatientResourceFilterMsg,
				A2(
					$author$project$Components$ResourceFilter$Patient$view,
					_List_fromArray(
						[
							$author$project$Components$ResourceFilter$invalid(optionsRecord.sM),
							$author$project$Components$ResourceFilter$errors(optionsRecord.agX)
						]),
					patientResourceFilter));
		} else {
			return A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Select$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Select$value(model.aee),
								$author$project$Ui$Form$Select$onChange($author$project$Components$LimitedPatientSelector$PatientSelected),
								$author$project$Ui$Form$Select$invalid(optionsRecord.sM),
								$author$project$Ui$Form$Select$errors(optionsRecord.agX)
							]),
						$author$project$Components$LimitedPatientSelector$patientOptions(model.CM)),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$textSm]),
						_List_fromArray(
							[
								$elm$html$Html$text(' or '),
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Find another patient'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$sm,
										$author$project$Ui$Button$onClick($author$project$Components$LimitedPatientSelector$FindAnotherPatient)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Find another patient')
									]))
							]))
					]));
		}
	});
var $author$project$Components$MovePaymentMethodsModal$viewMovePaymentMethodsModal = function (open) {
	var selectedPatientId = A2($elm$core$Maybe$withDefault, '', open.Eq);
	var fields = $author$project$Utils$Form$fields(open.SD);
	return A2(
		$author$project$Ui$Form$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$noValidate(true),
				$author$project$Ui$Form$autocomplete(true),
				$author$project$Ui$Form$onSubmit($author$project$Components$MovePaymentMethodsModal$MovePaymentMethods)
			]),
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Modal$view,
				$author$project$Components$MovePaymentMethodsModal$Close,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Modal$header(
						_List_fromArray(
							[
								$author$project$Ui$Modal$title('Move Payment Methods to Another Patient')
							])),
						$author$project$Ui$Modal$body(
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$labelSpanSm(3),
												$author$project$Ui$Form$Group$inputSpanSm(9),
												$author$project$Ui$Form$Group$label('New Owner'),
												$author$project$Ui$Form$Group$required(true)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Components$MovePaymentMethodsModal$LimitedPatientSelectorMsg,
												A2(
													$author$project$Components$LimitedPatientSelector$view,
													_List_fromArray(
														[
															$author$project$Components$LimitedPatientSelector$invalid(
															A2($author$project$Utils$Form$hasValidationErrors, 0, open.SD)),
															$author$project$Components$LimitedPatientSelector$errors(
															A2($author$project$Utils$Form$validationErrors, 0, open.SD))
														]),
													fields.oj)),
												A2(
												$author$project$Ui$Form$Checkbox$view,
												_List_fromArray(
													[
														$author$project$Ui$Form$Checkbox$value(fields.mM),
														$author$project$Ui$Form$Checkbox$onCheck(
														A2($elm$core$Basics$composeL, $author$project$Components$MovePaymentMethodsModal$FormUpdated, $author$project$Components$MovePaymentMethodsModal$Checkbox))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Remove payment methods from current patient')
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('ml-50')
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Grid$row,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Grid$column,
														_List_fromArray(
															[
																$author$project$Ui$Grid$spanSm(6)
															]),
														_List_fromArray(
															[
																(A2(
																$author$project$Components$MovePaymentMethodsModal$countPaymentSources,
																open,
																$author$project$Api$Provider$Patient$One$id(open.YY)) > 0) ? A2(
																$author$project$Ui$Element$view,
																_List_Nil,
																_List_fromArray(
																	[
																		A2(
																		$author$project$Ui$Typography$text,
																		_List_fromArray(
																			[$author$project$Ui$Typography$gray]),
																		'From '),
																		A2(
																		$author$project$Ui$Typography$text,
																		_List_fromArray(
																			[$author$project$Ui$Typography$gray, $author$project$Ui$Typography$bold]),
																		$author$project$Api$Provider$Patient$One$name(open.YY))
																	])) : $elm$html$Html$text(''),
																fields.mM ? A3(
																$author$project$Components$MovePaymentMethodsModal$displayPaymentSources,
																open,
																$author$project$Api$Provider$Patient$One$id(open.YY),
																_List_fromArray(
																	[$author$project$Ui$Typography$danger, $author$project$Ui$Typography$strike])) : A3(
																$author$project$Components$MovePaymentMethodsModal$displayPaymentSources,
																open,
																$author$project$Api$Provider$Patient$One$id(open.YY),
																_List_fromArray(
																	[$author$project$Ui$Typography$danger]))
															])),
														A2(
														$author$project$Ui$Grid$column,
														_List_fromArray(
															[
																$author$project$Ui$Grid$spanSm(6)
															]),
														_List_fromArray(
															[
																((!$elm$core$String$isEmpty(selectedPatientId)) && ((A2(
																$author$project$Components$MovePaymentMethodsModal$countPaymentSources,
																open,
																$author$project$Api$Provider$Patient$One$id(open.YY)) > 0) && (A2($author$project$Components$MovePaymentMethodsModal$countPaymentSources, open, selectedPatientId) > 0))) ? A2(
																$author$project$Ui$Element$view,
																_List_Nil,
																_List_fromArray(
																	[
																		A2(
																		$author$project$Ui$Typography$text,
																		_List_fromArray(
																			[$author$project$Ui$Typography$gray]),
																		'To '),
																		function () {
																		var selectedPatientName = A2($elm$core$Maybe$withDefault, '', open.Er);
																		return A2(
																			$author$project$Ui$Typography$text,
																			_List_fromArray(
																				[$author$project$Ui$Typography$gray, $author$project$Ui$Typography$bold]),
																			selectedPatientName);
																	}()
																	])) : $author$project$Utils$Html$empty,
																$elm$core$String$isEmpty(selectedPatientId) ? $author$project$Utils$Html$empty : A3(
																$author$project$Components$MovePaymentMethodsModal$displayPaymentSources,
																open,
																selectedPatientId,
																_List_fromArray(
																	[$author$project$Ui$Typography$success]))
															]))
													]))
											]))
									]))
							])),
						$author$project$Ui$Modal$footer(
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Cancel and close modal'},
								_List_fromArray(
									[
										$author$project$Ui$Button$onClick($author$project$Components$MovePaymentMethodsModal$Close)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Cancel')
									])),
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Confirm'},
								_List_fromArray(
									[
										$author$project$Ui$Button$primary,
										$author$project$Ui$Button$submit,
										$author$project$Ui$Button$loading(
										_Utils_eq(open.tb, $author$project$Api$Data$Loading))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Confirm')
									]))
							]))
					]))
			]));
};
var $author$project$Components$MovePaymentMethodsModal$modal = function (model) {
	if (model.$ === 1) {
		var open = model.a;
		return $author$project$Components$MovePaymentMethodsModal$viewMovePaymentMethodsModal(open);
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$PaymentSourceDisplayer$skeleton = A2(
	$author$project$Ui$Element$view,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$spanFromText('VISA *4242')
						]))
				])),
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$textSm]),
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$spanFromText('Added mm/dd/YYYY, expires mm/dd/YYYY')
						]))
				])),
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$textSm]),
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$spanFromText('Maually added by someone')
						]))
				]))
		]));
var $author$project$Components$VirtualBankAccounts$loadFromData = function (model) {
	var _v0 = model.F7;
	if (_v0.$ === 3) {
		var virtualBankAccounts_ = _v0.a;
		return virtualBankAccounts_;
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$VirtualBankAccounts$TransactionHistory = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$VirtualBankAccount$Shared$balanceInCents = function (_v0) {
	var record = _v0;
	return record.afa;
};
var $author$project$Api$Provider$VirtualBankAccount$Shared$createdAt = function (_v0) {
	var record = _v0;
	return record.O1;
};
var $author$project$Components$VirtualBankAccounts$CopyToClipboard = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Api$Provider$VirtualBankAccount$Shared$swiftAccountNumber = function (_v0) {
	var record = _v0;
	return record.alQ;
};
var $author$project$Api$Provider$VirtualBankAccount$Shared$swiftBankName = function (_v0) {
	var record = _v0;
	return record.alR;
};
var $author$project$Components$VirtualBankAccounts$viewVirtualBankAccountBox = function (virtualBankAccount) {
	return A3(
		$author$project$Ui$Alert$view,
		1,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(2)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$text,
								_List_fromArray(
									[$author$project$Ui$Typography$muted]),
								'Bank Name')
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(10)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$prose,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$text,
										_List_fromArray(
											[
												$author$project$Ui$Typography$phi(true)
											]),
										$author$project$Api$Provider$VirtualBankAccount$Shared$abaBankName(virtualBankAccount)),
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Copy Bank Name'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$icon($author$project$Ui$Icon$copy),
												$author$project$Ui$Button$onClick(
												A2(
													$author$project$Components$VirtualBankAccounts$CopyToClipboard,
													'Bank Name',
													$author$project$Api$Provider$VirtualBankAccount$Shared$swiftBankName(virtualBankAccount)))
											]),
										_List_Nil)
									]))
							]))
					])),
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(2)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$text,
								_List_fromArray(
									[$author$project$Ui$Typography$muted]),
								'Routing Number')
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(10)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$prose,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$text,
										_List_fromArray(
											[
												$author$project$Ui$Typography$phi(true)
											]),
										$author$project$Api$Provider$VirtualBankAccount$Shared$abaRoutingtNumber(virtualBankAccount)),
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Copy Routing Number'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$icon($author$project$Ui$Icon$copy),
												$author$project$Ui$Button$onClick(
												A2(
													$author$project$Components$VirtualBankAccounts$CopyToClipboard,
													'Routing Number',
													$author$project$Api$Provider$VirtualBankAccount$Shared$abaRoutingtNumber(virtualBankAccount)))
											]),
										_List_Nil)
									]))
							]))
					])),
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(2)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$text,
								_List_fromArray(
									[$author$project$Ui$Typography$muted]),
								'Account Number')
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(10)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$prose,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$text,
										_List_fromArray(
											[
												$author$project$Ui$Typography$phi(true)
											]),
										$author$project$Api$Provider$VirtualBankAccount$Shared$abaAccountNumber(virtualBankAccount)),
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Copy Account Number'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$icon($author$project$Ui$Icon$copy),
												$author$project$Ui$Button$onClick(
												A2(
													$author$project$Components$VirtualBankAccounts$CopyToClipboard,
													'Account Number',
													$author$project$Api$Provider$VirtualBankAccount$Shared$swiftAccountNumber(virtualBankAccount)))
											]),
										_List_Nil)
									]))
							]))
					])),
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(2)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$text,
								_List_fromArray(
									[$author$project$Ui$Typography$muted]),
								'SWIFT code')
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(10)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$prose,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$text,
										_List_fromArray(
											[
												$author$project$Ui$Typography$phi(true)
											]),
										$author$project$Api$Provider$VirtualBankAccount$Shared$swiftCode(virtualBankAccount)),
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Copy SWIFT Code'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$icon($author$project$Ui$Icon$copy),
												$author$project$Ui$Button$onClick(
												A2(
													$author$project$Components$VirtualBankAccounts$CopyToClipboard,
													'Swift Code',
													$author$project$Api$Provider$VirtualBankAccount$Shared$swiftCode(virtualBankAccount)))
											]),
										_List_Nil)
									]))
							]))
					]))
			]));
};
var $author$project$Components$VirtualBankAccounts$viewVirtualBankAccount = F2(
	function (timeFormatter, virtualBankAccount) {
		return A2(
			$author$project$Ui$ListGroup$item,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(6)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$strong,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('inline')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$text,
											_List_Nil,
											$author$project$Formatters$String$titleize(
												$author$project$Api$Provider$VirtualBankAccount$Shared$abaBankName(virtualBankAccount)))
										])),
									A2(
									$author$project$Ui$Typography$text,
									_List_Nil,
									' (Account Balance: ' + ($author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$VirtualBankAccount$Shared$balanceInCents(virtualBankAccount)) + ')'))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textRight]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{mm: 'View transaction history'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick(
													$author$project$Components$VirtualBankAccounts$TransactionHistory(virtualBankAccount))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Transaction History')
												]))
										]))
								]))
						])),
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(12)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$p,
											_List_fromArray(
												[$author$project$Ui$Typography$muted]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													'Added ' + A2(
														timeFormatter,
														5,
														$author$project$Api$Provider$VirtualBankAccount$Shared$createdAt(virtualBankAccount)))
												]))
										]))
								]))
						])),
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(12)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$p,
											_List_fromArray(
												[$author$project$Ui$Typography$muted]),
											_List_fromArray(
												[
													$elm$html$Html$text('TRANSFER INSTRUCTIONS')
												]))
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$p,
											_List_fromArray(
												[$author$project$Ui$Typography$black]),
											_List_fromArray(
												[
													$elm$html$Html$text('To pay via Bank Transfer, transer funds using the following bank information. Bank Transfers can take up to five business days.')
												]))
										]))
								]))
						])),
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(12)
								]),
							_List_fromArray(
								[
									$author$project$Components$VirtualBankAccounts$viewVirtualBankAccountBox(virtualBankAccount)
								]))
						]))
				]));
	});
var $author$project$Components$VirtualBankAccounts$view = function (_v0) {
	var model = _v0;
	return A2(
		$author$project$Ui$ListGroup$view,
		_List_Nil,
		A2(
			$elm$core$List$map,
			$author$project$Components$VirtualBankAccounts$viewVirtualBankAccount(model.J7),
			$author$project$Components$VirtualBankAccounts$loadFromData(model)));
};
var $author$project$Components$PaymentSources$viewAuditTrailLog = function (model) {
	var _v0 = model.Jy;
	if (_v0.$ === 1) {
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$ml2]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Components$PaymentSources$AuditTrailLogMsg,
						$author$project$Components$AuditTrailLog$view(model.iw))
					]))
			]);
	} else {
		return _List_fromArray(
			[$author$project$Utils$Html$empty]);
	}
};
var $author$project$Api$Employer$Company$One$invoiceAutoPay = function (_v0) {
	var record = _v0.b;
	return record.Un;
};
var $author$project$Api$Provider$Company$One$invoiceAutoPay = function (_v0) {
	var record = _v0.b;
	return record.Un;
};
var $author$project$Api$Company$invoiceAutoPay = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$invoiceAutoPay(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$invoiceAutoPay(company_);
	}
};
var $author$project$Components$PaymentSources$viewCompanyAutopay = F3(
	function (model, company, organizationIsCompany) {
		var _v0 = $author$project$Api$Company$invoiceAutoPay(company) ? _Utils_Tuple2('On', ' Disable Autopay to stop automated payment collection on upcoming invoices.') : _Utils_Tuple2('Off', '');
		var disableAutoPayToggleText = _v0.a;
		var disableAutoPayText = _v0.b;
		return A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(10)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Autopay')
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
							_List_fromArray(
								[
									$author$project$Api$Platform$Session$One$organizationIsCompany(model.aa4) ? $elm$html$Html$text(
									$elm$core$String$concat(
										_List_fromArray(
											['Automatically process payment for issued invoices on their due date.', disableAutoPayText]))) : $elm$html$Html$text('If set, we will automatically try to process a payment for the invoice on its due date.')
								]))
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(2),
							$author$project$Ui$Grid$justifyRight
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(disableAutoPayToggleText)
										]))
								])),
							organizationIsCompany ? $author$project$Utils$Html$empty : A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Companies__CompanyId_String__InvoiceSettings(
								{
									fZ: $author$project$Api$Company$id(company)
								}),
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Manage invoice settings')
								]))
						]))
				]));
	});
var $author$project$Components$PaymentSources$TogglePatientAutopay = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Api$Provider$Patient$Shared$autopay = function (_v0) {
	var shared = _v0;
	return shared.Mm;
};
var $author$project$Api$Provider$Patient$One$autopay = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$autopay(shared);
};
var $author$project$Components$PaymentSources$viewPatientAutopay = F2(
	function (practice, patient) {
		var _v0 = function () {
			if ($author$project$Api$Provider$Patient$One$autopay(patient)) {
				var multipleMembershipsText = $author$project$Api$Practice$allowMultipleRetailMemberships(practice) ? ' To set a different payment method for a specific membership, update it from the Memberships tab under Pricing.' : '';
				return _Utils_Tuple2('Automated payments collection will be attempted.', 'Disable Autopay to stop automated payment collection on upcoming invoices.' + multipleMembershipsText);
			} else {
				return _Utils_Tuple2('No automated payments collection will be attempted.', 'Enable Autopay to start automated payment collection on upcoming invoices.');
			}
		}();
		var autoPayText = _v0.a;
		var toggleAutoPayText = _v0.b;
		return A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(10)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Autopay')
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$concat(
										_List_fromArray(
											[autoPayText, ' ', toggleAutoPayText])))
								]))
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(2),
							$author$project$Ui$Grid$justifyRight
						]),
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$view(
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$on(
									$author$project$Api$Provider$Patient$One$autopay(patient)),
									$author$project$Ui$ToggleSwitch$onChange(
									$author$project$Components$PaymentSources$TogglePatientAutopay(
										$author$project$Api$Provider$Patient$One$id(patient)))
								]))
						]))
				]));
	});
var $author$project$Components$PaymentSources$viewAutopay = function (model) {
	var _v0 = model.Jy;
	if (!_v0.$) {
		var company = _v0.a;
		return _List_fromArray(
			[
				A3(
				$author$project$Components$PaymentSources$viewCompanyAutopay,
				model,
				company,
				$author$project$Api$Platform$Session$One$organizationIsCompany(model.aa4))
			]);
	} else {
		var patient = _v0.a;
		return _List_fromArray(
			[
				A2($author$project$Components$PaymentSources$viewPatientAutopay, model.ZV, patient)
			]);
	}
};
var $author$project$Components$PaymentSources$TogglePatientExemptFromCreditCardFees = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$Api$Provider$Patient$One$exemptFromCreditCardFees = function (_v0) {
	var record = _v0.b;
	return record.RS;
};
var $author$project$Components$PaymentSources$viewExemptFromCreditCardFees = function (model) {
	var showToggle = function () {
		var _v1 = model.ZV;
		if (!_v1.$) {
			var practice = _v1.a;
			return $author$project$Api$Provider$Practice$One$chargePatientsCreditCardFees(practice);
		} else {
			return false;
		}
	}();
	var _v0 = _Utils_Tuple2(model.Jy, showToggle);
	if ((_v0.a.$ === 1) && _v0.b) {
		var patient = _v0.a.a;
		var exemptText = 'When enabled, this patient will not be charged credit card fees, even if they pay with a credit card.';
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanSm(10)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Exclude this patient from credit card surcharge')
									])),
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$concat(
											_List_fromArray(
												[exemptText, ' '])))
									]))
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanSm(2),
								$author$project$Ui$Grid$justifyRight
							]),
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$view(
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$on(
										$author$project$Api$Provider$Patient$One$exemptFromCreditCardFees(patient)),
										$author$project$Ui$ToggleSwitch$onChange(
										$author$project$Components$PaymentSources$TogglePatientExemptFromCreditCardFees(
											$author$project$Api$Provider$Patient$One$id(patient)))
									]))
							]))
					]))
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$PaymentSources$OpenMovePaymentMethodsModal = function (a) {
	return {$: 21, a: a};
};
var $author$project$Components$PaymentSources$viewMoreActionsDowndown = F2(
	function (model, sources) {
		var _v0 = model.Jy;
		if (!_v0.$) {
			return _List_Nil;
		} else {
			var patient = _v0.a;
			var canMigrate = function () {
				var _v1 = model.kA;
				if (_v1.$ === 3) {
					var paymentSourcesMigratable = _v1.a;
					return paymentSourcesMigratable;
				} else {
					return false;
				}
			}();
			return ((!$elm$core$List$isEmpty(sources)) && canMigrate) ? $elm$core$List$singleton(
				A4(
					$author$project$Ui$Dropdown$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Other Actions')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Dropdown$item,
							_List_fromArray(
								[
									$author$project$Ui$Dropdown$onSelect(
									$author$project$Components$PaymentSources$OpenMovePaymentMethodsModal(patient))
								]),
							A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Icon$copy(_List_Nil),
										$author$project$Utils$Html$noBreakSpace,
										$elm$html$Html$text('Move All Payment Methods to Another Patient')
									])))
						]),
					model.ta)) : _List_Nil;
		}
	});
var $author$project$Api$Employer$BankAccount$One$default = function (_v0) {
	var record = _v0.b;
	return record.PW;
};
var $author$project$Api$Employer$BankAccount$All$default = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$BankAccount$One$default(one);
};
var $author$project$Api$Provider$BankAccount$One$default = function (_v0) {
	var record = _v0.b;
	return record.PW;
};
var $author$project$Api$Provider$BankAccount$All$default = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BankAccount$One$default(one);
};
var $author$project$Api$BankAccount$default = function (bankAccount) {
	switch (bankAccount.$) {
		case 0:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$One$default(bankAccount_);
		case 1:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$All$default(bankAccount_);
		case 2:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$One$default(bankAccount_);
		default:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$All$default(bankAccount_);
	}
};
var $author$project$Api$Employer$Card$One$default = function (_v0) {
	var record = _v0.b;
	return record.PW;
};
var $author$project$Api$Employer$Card$All$default = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$Card$One$default(one);
};
var $author$project$Api$Provider$Card$One$default = function (_v0) {
	var record = _v0.b;
	return record.PW;
};
var $author$project$Api$Provider$Card$All$default = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Card$One$default(one);
};
var $author$project$Api$Card$default = function (card) {
	switch (card.$) {
		case 0:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$One$default(card_);
		case 1:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$All$default(card_);
		case 2:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$One$default(card_);
		default:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$All$default(card_);
	}
};
var $author$project$Api$Source$default = function (source) {
	switch (source.$) {
		case 0:
			var card = source.a;
			return $author$project$Api$Card$default(card);
		case 1:
			var bankAccount = source.a;
			return $author$project$Api$BankAccount$default(bankAccount);
		default:
			return false;
	}
};
var $author$project$Components$PaymentSources$viewNoDefaultSourceWarning = F2(
	function (resource, sources) {
		if (resource.$ === 1) {
			var patient = resource.a;
			var hasNoDefaultSource = (!$elm$core$List$isEmpty(sources)) && $elm$core$List$isEmpty(
				A2(
					$elm$core$List$filter,
					function (source) {
						return $author$project$Api$Source$default(source);
					},
					sources));
			return ($author$project$Api$Provider$Patient$One$autopay(patient) && hasNoDefaultSource) ? A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(12)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$mb4]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Alert$warning,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('There is no default payment source on file. '),
												$elm$html$Html$text('Please select a default payment method or turn off auto pay.')
											]))
									]))
							]))
					])) : $author$project$Utils$Html$empty;
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$PaymentSources$Delete = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$PaymentSources$Edit = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$PaymentSources$MakeDefault = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$PaymentSourceDisplayer$PatientId = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$PaymentSourceDisplayer$patientId = $author$project$Components$PaymentSourceDisplayer$PatientId;
var $author$project$Components$PaymentSourceDisplayer$ShowAssignedMemberships = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$PaymentSourceDisplayer$showAssignedMemberships = $author$project$Components$PaymentSourceDisplayer$ShowAssignedMemberships;
var $author$project$Components$PaymentSources$viewSource = F6(
	function (timeFormatter, isHintAdmin, updatingSources, practice, maybePatientId, source) {
		var loading = A2(
			$elm$core$Set$member,
			$author$project$Api$Source$id(source),
			updatingSources);
		return A2(
			$author$project$Ui$ListGroup$item,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Components$PaymentSourceDisplayer$view,
									timeFormatter,
									_List_fromArray(
										[
											$author$project$Components$PaymentSourceDisplayer$source(
											$elm$core$Maybe$Just(source)),
											$author$project$Components$PaymentSourceDisplayer$showProcessor(isHintAdmin),
											$author$project$Components$PaymentSourceDisplayer$showAssignedMemberships(
											$author$project$Api$Practice$allowMultipleRetailMemberships(practice)),
											$author$project$Components$PaymentSourceDisplayer$patientId(maybePatientId)
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
									_List_fromArray(
										[
											$author$project$Api$Source$default(source) ? A2($author$project$Ui$Badge$fromString, _List_Nil, 'default') : A3(
											$author$project$Ui$Button$view,
											{mm: 'Make this payment source the default for the payer'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick(
													$author$project$Components$PaymentSources$MakeDefault(source))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Make Default')
												])),
											A3(
											$author$project$Ui$Button$view,
											{mm: 'Edit payment source'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick(
													$author$project$Components$PaymentSources$Edit(source)),
													$author$project$Ui$Button$disabled(loading)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Edit')
												])),
											A3(
											$author$project$Ui$Button$view,
											{mm: 'Delete payment source'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$loading(loading),
													$author$project$Ui$Button$onClick(
													$author$project$Components$PaymentSources$Delete(source))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Delete')
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$PaymentSources$viewPaymentSourcesList = F2(
	function (model, sources) {
		if ($elm$core$List$isEmpty(sources)) {
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$ListGroup$item,
					_List_Nil,
					$author$project$Api$Platform$Session$One$organizationIsCompany(model.aa4) ? _List_fromArray(
						[
							$elm$html$Html$text('You have not added any credit cards or bank accounts.')
						]) : _List_fromArray(
						[
							(!$author$project$Api$Practice$hasPaymentProcessorAccount(model.ZV)) ? A2(
							$author$project$Utils$PaymentProcessor$toSetupAlert,
							model.ZV,
							$elm$core$Maybe$Just('In order to add payment options')) : A2(
							$author$project$Ui$Alert$warning,
							_List_Nil,
							_List_fromArray(
								[
									function () {
									var _v0 = model.Jy;
									if (!_v0.$) {
										return $elm$html$Html$text('This employer has no payment sources set up.');
									} else {
										return $elm$html$Html$text('This patient has no payment sources set up.');
									}
								}()
								]))
						]))
				]);
		} else {
			var maybePatientId = function () {
				var _v1 = model.Jy;
				if (_v1.$ === 1) {
					var patient = _v1.a;
					return $elm$core$Maybe$Just(
						$author$project$Api$Provider$Patient$One$id(patient));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}();
			return A2(
				$elm$core$List$map,
				A5($author$project$Components$PaymentSources$viewSource, model.J7, model.Ij, model.J, model.ZV, maybePatientId),
				sources);
		}
	});
var $author$project$Api$Employer$Company$One$invoiceAutoIssue = function (_v0) {
	var record = _v0.b;
	return record.Ul;
};
var $author$project$Api$Provider$Company$One$invoiceAutoIssue = function (_v0) {
	var record = _v0.b;
	return record.Ul;
};
var $author$project$Api$Company$invoiceAutoIssue = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$invoiceAutoIssue(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$invoiceAutoIssue(company_);
	}
};
var $author$project$Api$Employer$Company$One$invoiceAutoIssueDay = function (_v0) {
	var record = _v0.b;
	return record.Um;
};
var $author$project$Api$Provider$Company$One$invoiceAutoIssueDay = function (_v0) {
	var record = _v0.b;
	return record.Um;
};
var $author$project$Api$Company$invoiceAutoIssueDay = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$invoiceAutoIssueDay(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$invoiceAutoIssueDay(company_);
	}
};
var $author$project$Api$Employer$Company$One$invoiceAutoSend = function (_v0) {
	var record = _v0.b;
	return record.Uo;
};
var $author$project$Api$Provider$Company$One$invoiceAutoSend = function (_v0) {
	var record = _v0.b;
	return record.Uo;
};
var $author$project$Api$Company$invoiceAutoSend = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$invoiceAutoSend(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$invoiceAutoSend(company_);
	}
};
var $author$project$Api$Employer$Company$One$invoiceAutoSendDay = function (_v0) {
	var record = _v0.b;
	return record.Up;
};
var $author$project$Api$Provider$Company$One$invoiceAutoSendDay = function (_v0) {
	var record = _v0.b;
	return record.Up;
};
var $author$project$Api$Company$invoiceAutoSendDay = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$invoiceAutoSendDay(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$invoiceAutoSendDay(company_);
	}
};
var $author$project$Api$Employer$Company$One$invoiceDueDay = function (_v0) {
	var record = _v0.b;
	return record.Ur;
};
var $author$project$Api$Provider$Company$One$invoiceDueDay = function (_v0) {
	var record = _v0.b;
	return record.Ur;
};
var $author$project$Api$Company$invoiceDueDay = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$invoiceDueDay(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$invoiceDueDay(company_);
	}
};
var $author$project$Components$PaymentSources$viewPaymentTerms = function (model) {
	return (!$author$project$Api$Platform$Session$One$organizationIsCompany(model.aa4)) ? $author$project$Utils$Html$empty : A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanSm(12)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Payment Terms')
									]))
							]))
					])),
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanSm(12)
							]),
						_List_fromArray(
							[
								function () {
								var _v0 = model.Jy;
								if (!_v0.$) {
									var company = _v0.a;
									return A2(
										$author$project$Ui$Typography$p,
										_List_Nil,
										_List_fromArray(
											[
												function () {
												var _v1 = _Utils_Tuple2(
													$author$project$Api$Company$invoiceAutoSend(company),
													$author$project$Api$Company$invoiceAutoSendDay(company));
												if (_v1.a && (!_v1.b.$)) {
													var invoiceAutoSendDay = _v1.b.a;
													return A2(
														$author$project$Ui$Element$view,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('You will receive the invoice on the '),
																A2(
																$author$project$Ui$Typography$strong,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		$author$project$Formatters$Int$ordinal(invoiceAutoSendDay))
																	])),
																$elm$html$Html$text(' and can make changes until '),
																function () {
																var _v2 = _Utils_Tuple2(
																	$author$project$Api$Company$invoiceAutoIssue(company),
																	$author$project$Api$Company$invoiceAutoIssueDay(company));
																if (_v2.a && (!_v2.b.$)) {
																	var invoiceAutoIssueDay = _v2.b.a;
																	return (_Utils_cmp(invoiceAutoIssueDay, invoiceAutoSendDay) > 0) ? A2(
																		$author$project$Ui$Element$prose,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$elm$html$Html$text('the '),
																				A2(
																				$author$project$Ui$Typography$strong,
																				_List_Nil,
																				_List_fromArray(
																					[
																						$elm$html$Html$text(
																						$author$project$Formatters$Int$ordinal(invoiceAutoIssueDay))
																					])),
																				$elm$html$Html$text('.')
																			])) : $elm$html$Html$text('it gets issued by the Practice.');
																} else {
																	return $elm$html$Html$text('it gets issued by the Practice.');
																}
															}()
															]));
												} else {
													return A2(
														$author$project$Ui$Element$view,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('You will receive the invoice once it gets issued.')
															]));
												}
											}(),
												A2(
												$author$project$Ui$Element$prose,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Payment will be due on the '),
														A2(
														$author$project$Ui$Typography$strong,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(
																$author$project$Formatters$Int$ordinal(
																	$author$project$Api$Company$invoiceDueDay(company)))
															])),
														$elm$html$Html$text(' if autopay is '),
														A2(
														$author$project$Ui$Typography$strong,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('on')
															])),
														$elm$html$Html$text(' then it will process.')
													]))
											]));
								} else {
									return $author$project$Utils$Html$empty;
								}
							}()
							]))
					]))
			]));
};
var $author$project$Components$PaymentSources$CancelEdit = {$: 1};
var $author$project$Components$PaymentSources$FormUpdated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$PaymentSources$Label = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$PaymentSources$Update = {$: 18};
var $author$project$Components$PaymentSources$ExpMonth = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$PaymentSources$ExpYear = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$PaymentSources$Zip = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$PaymentSources$monthOptions = A2(
	$elm$core$List$map,
	function (month) {
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(
				$elm$core$String$fromInt(month)),
			$elm$core$String$fromInt(month));
	},
	A2($elm$core$List$range, 1, 12));
var $author$project$Components$PaymentSources$yearOptions = function (currentDate) {
	var fromYear = $justinmimbs$date$Date$year(currentDate);
	var toYear = fromYear + 10;
	return A2(
		$elm$core$List$map,
		function (year) {
			return A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(
					$elm$core$String$fromInt(year)),
				$elm$core$String$fromInt(year));
		},
		A2($elm$core$List$range, fromYear, toYear));
};
var $author$project$Components$PaymentSources$viewCardFields = F3(
	function (currentDate, form, cardFields) {
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpan(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Expiration Date'),
						$author$project$Ui$Form$Group$required(true)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanSm(6)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Select$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Select$value(
												A2($elm$core$Maybe$map, $elm$core$String$fromInt, cardFields.ag3)),
												$author$project$Ui$Form$Select$onChange(
												A2($elm$core$Basics$composeL, $author$project$Components$PaymentSources$FormUpdated, $author$project$Components$PaymentSources$ExpMonth)),
												$author$project$Ui$Form$Select$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, 1, form))
											]),
										$author$project$Components$PaymentSources$monthOptions)
									])),
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanSm(6)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Select$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Select$value(
												A2($elm$core$Maybe$map, $elm$core$String$fromInt, cardFields.ag4)),
												$author$project$Ui$Form$Select$onChange(
												A2($elm$core$Basics$composeL, $author$project$Components$PaymentSources$FormUpdated, $author$project$Components$PaymentSources$ExpYear)),
												$author$project$Ui$Form$Select$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, 1, form))
											]),
										$author$project$Components$PaymentSources$yearOptions(currentDate))
									]))
							])),
						$author$project$Utils$FormErrors$view(
						A2($author$project$Utils$Form$validationErrors, 1, form))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpan(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Zip Code'),
						$author$project$Ui$Form$Group$required(true)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(cardFields.vv),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Components$PaymentSources$FormUpdated, $author$project$Components$PaymentSources$Zip)),
								$author$project$Ui$Form$Input$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 0, form))
							])),
						$author$project$Utils$FormErrors$view(
						A2($author$project$Utils$Form$validationErrors, 0, form))
					]))
			]);
	});
var $author$project$Components$PaymentSources$viewSourceModal = F3(
	function (currentDate, form, updateRequest) {
		var modalConfig = {
			Tq: $elm$core$Maybe$Nothing,
			aih: 'Payment Source',
			V8: _Utils_eq(updateRequest, $author$project$Api$Data$Loading),
			WG: $elm$core$Maybe$Just(''),
			WH: $elm$core$Maybe$Nothing,
			Yd: $author$project$Components$PaymentSources$CancelEdit,
			Yf: $elm$core$Basics$always($author$project$Components$PaymentSources$Update)
		};
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Description')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$placeholder('HSA card for incidental charges'),
									$author$project$Ui$Form$Input$value(
									A2($elm$core$Maybe$withDefault, '', fields.aih)),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$PaymentSources$FormUpdated, $author$project$Components$PaymentSources$Label))
								]))
						])),
				function () {
					var _v0 = fields.GS;
					if (_v0.$ === 1) {
						return _List_Nil;
					} else {
						var cardFields = _v0.a;
						return A3($author$project$Components$PaymentSources$viewCardFields, currentDate, form, cardFields);
					}
				}()));
	});
var $author$project$Components$CreatePaymentMethodModal$Company = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$Patient = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$PaymentSources$viewSourcesActions = function (model) {
	var paymentMethodOwner = function () {
		var _v0 = model.Jy;
		if (!_v0.$) {
			var company = _v0.a;
			return $author$project$Components$CreatePaymentMethodModal$Company(company);
		} else {
			var patient = _v0.a;
			return $author$project$Components$CreatePaymentMethodModal$Patient(patient);
		}
	}();
	var openOptions = {xx: model.xx, sF: model.sF, jY: $elm$core$Maybe$Nothing, Ij: model.Ij, YD: paymentMethodOwner, ZV: model.ZV, t9: model.t9, aa4: model.aa4, J7: model.J7, vl: true};
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$map,
			$author$project$Components$PaymentSources$CreatePaymentMethodModalMsg,
			$author$project$Components$CreatePaymentMethodModal$button(openOptions))
		]);
};
var $author$project$Api$Employer$Company$One$stripeLink = function (_v0) {
	var record = _v0.b;
	return record.acq;
};
var $author$project$Api$Provider$Company$Shared$stripeLink = function (_v0) {
	var record = _v0;
	return record.acq;
};
var $author$project$Api$Provider$Company$One$stripeLink = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$stripeLink(shared);
};
var $author$project$Api$Company$stripeLink = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$stripeLink(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$stripeLink(company_);
	}
};
var $author$project$Api$Provider$Patient$One$stripeLink = function (_v0) {
	var record = _v0.b;
	return record.acq;
};
var $author$project$Components$PaymentSources$viewStripeLink = function (model) {
	var maybeStripeLink = function () {
		var _v2 = model.Jy;
		if (!_v2.$) {
			var company = _v2.a;
			return $author$project$Api$Company$stripeLink(company);
		} else {
			var patient = _v2.a;
			return $author$project$Api$Provider$Patient$One$stripeLink(patient);
		}
	}();
	if (!maybeStripeLink.$) {
		var stripeLink_ = maybeStripeLink.a;
		var viewOnStripeLink = A3(
			$author$project$Ui$HinterOnly$linkHref,
			stripeLink_,
			_List_fromArray(
				[$author$project$Ui$Link$targetBlank]),
			_List_fromArray(
				[
					$elm$html$Html$text(' View on Stripe')
				]));
		var _v1 = model.Jy;
		if (!_v1.$) {
			return model.Ij ? _List_fromArray(
				[viewOnStripeLink]) : _List_Nil;
		} else {
			return model.Ij ? _List_fromArray(
				[viewOnStripeLink]) : _List_Nil;
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$PaymentSources$view = function (_v0) {
	var model = _v0;
	var _v1 = function () {
		var _v2 = _Utils_Tuple2(model.rC, model.rs);
		_v2$2:
		while (true) {
			switch (_v2.a.$) {
				case 3:
					if (_v2.b.$ === 3) {
						var _v3 = _v2.a;
						var cards = _v3.a;
						var _v4 = _v2.b;
						var bankAccounts = _v4.a;
						return _Utils_Tuple2(
							false,
							$elm$core$List$reverse(
								A2(
									$elm$core$List$sortBy,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Api$Source$createdAt,
										A2(
											$elm$core$Basics$composeR,
											$elm$core$Maybe$map($elm$time$Time$posixToMillis),
											$elm$core$Maybe$withDefault(0))),
									_Utils_ap(
										A2($elm$core$List$map, $author$project$Api$Source$Card, cards),
										A2($elm$core$List$map, $author$project$Api$Source$BankAccount, bankAccounts)))));
					} else {
						break _v2$2;
					}
				case 2:
					if (_v2.b.$ === 2) {
						return _Utils_Tuple2(false, _List_Nil);
					} else {
						break _v2$2;
					}
				default:
					break _v2$2;
			}
		}
		return _Utils_Tuple2(true, _List_Nil);
	}();
	var loading = _v1.a;
	var sources = _v1.b;
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$map,
			$author$project$Components$PaymentSources$CreatePaymentMethodModalMsg,
			$author$project$Components$CreatePaymentMethodModal$modal(model.i_)),
			A2(
			$elm$html$Html$map,
			$author$project$Components$PaymentSources$MovePaymentMethodsModalMsg,
			$author$project$Components$MovePaymentMethodsModal$modal(model.gY)),
			function () {
			var _v5 = model.JQ;
			if (!_v5.$) {
				var _v6 = _v5.a;
				var form = _v6.b;
				var updateRequest = _v6.c;
				return A3($author$project$Components$PaymentSources$viewSourceModal, model.dd, form, updateRequest);
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			function () {
			var _v7 = model.gc;
			if (!_v7.$) {
				var source = _v7.a;
				return A2(
					$author$project$Components$HiConfirm$modal,
					$author$project$Components$PaymentSources$HiConfirmClosed(source),
					_List_fromArray(
						[
							$author$project$Components$HiConfirm$verb('delete'),
							$author$project$Components$HiConfirm$noun(
							$author$project$Api$Source$noun(source)),
							$author$project$Components$HiConfirm$detail(
							$author$project$Api$Source$detail(source))
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$row,
							_List_fromArray(
								[$author$project$Ui$Grid$rowItemsCenter]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(5)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$wrap, $author$project$Ui$Element$mb2, $author$project$Ui$Element$itemsStart]),
											_List_fromArray(
												[
													$author$project$Ui$Panel$title(
													_List_fromArray(
														[
															$elm$html$Html$text('Payment Methods')
														])),
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$wrap, $author$project$Ui$Element$mt1]),
													$author$project$Components$PaymentSources$viewAuditTrailLog(model))
												]))
										])),
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(7)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mb2, $author$project$Ui$Element$justifyRight]),
											_Utils_ap(
												$author$project$Components$PaymentSources$viewStripeLink(model),
												_Utils_ap(
													A2($author$project$Components$PaymentSources$viewMoreActionsDowndown, model, sources),
													$author$project$Components$PaymentSources$viewSourcesActions(model))))
										]))
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$mb4]),
							$author$project$Components$PaymentSources$viewExemptFromCreditCardFees(model)),
							A2(
							$author$project$Ui$Grid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(12)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$mb4]),
											$author$project$Components$PaymentSources$viewAutopay(model))
										]))
								])),
							A2($author$project$Components$PaymentSources$viewNoDefaultSourceWarning, model.Jy, sources),
							A2(
							$author$project$Ui$Grid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(12)
										]),
									_List_fromArray(
										[
											$author$project$Components$PaymentSources$viewPaymentTerms(model)
										]))
								])),
							loading ? A2(
							$author$project$Ui$ListGroup$view,
							_List_Nil,
							A2(
								$elm$core$List$repeat,
								2,
								A2(
									$author$project$Ui$ListGroup$item,
									_List_Nil,
									_List_fromArray(
										[$author$project$Components$PaymentSourceDisplayer$skeleton])))) : A2(
							$author$project$Ui$ListGroup$view,
							_List_Nil,
							A2($author$project$Components$PaymentSources$viewPaymentSourcesList, model, sources)),
							A2(
							$elm$core$Maybe$withDefault,
							$author$project$Utils$Html$empty,
							A2(
								$elm$core$Maybe$map,
								function (virtualBankAccountsComponent_) {
									return A2(
										$elm$html$Html$map,
										$author$project$Components$PaymentSources$VirtualBankAccountsComponentMsg,
										$author$project$Components$VirtualBankAccounts$view(virtualBankAccountsComponent_));
								},
								model.vo))
						]))
				]))
		]);
};
var $author$project$Pages$Companies$CompanyId_String$PaymentSources$view = function (model) {
	return {
		fO: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			$author$project$Components$PaymentSources$view(model.s1)),
		ac9: A2($author$project$Api$Practice$sponsorize, model.ZV, 'Companies') + ' | Payment Options'
	};
};
var $author$project$Pages$Companies$CompanyId_String$PaymentSources$page = $author$project$Spa$Page$applicationCompanyOrEmployer(
	{ah_: $author$project$Pages$Companies$CompanyId_String$PaymentSources$init, aiq: $author$project$Pages$Companies$CompanyId_String$PaymentSources$load, k8: $author$project$Pages$Companies$CompanyId_String$PaymentSources$save, alO: $author$project$Pages$Companies$CompanyId_String$PaymentSources$subscriptions, adT: $author$project$Pages$Companies$CompanyId_String$PaymentSources$update, amo: $author$project$Pages$Companies$CompanyId_String$PaymentSources$view});
var $author$project$Pages$Companies$CompanyId_String$Signup$GotSignupPages = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Signup$fetchSignupPages = F2(
	function (apiClient, company) {
		return A3(
			$author$project$Api$Provider$SignupPage$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						fZ: $elm$core$Maybe$Just(
							$author$project$Api$Company$id(company)),
						ajJ: $elm$core$Maybe$Nothing
					});
			},
			$author$project$Pages$Companies$CompanyId_String$Signup$GotSignupPages);
	});
var $author$project$Pages$Companies$CompanyId_String$Signup$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Company$One$collectPaymentSourceOnSignup = function (_v0) {
	var record = _v0.b;
	return record.NZ;
};
var $author$project$Api$Company$collectPaymentSourceOnSignup = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $elm$core$Maybe$Just(
			$author$project$Api$Provider$Company$One$collectPaymentSourceOnSignup(company_));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$Company$One$collectPractitionerOnSignup = function (_v0) {
	var record = _v0.b;
	return record.N_;
};
var $author$project$Api$Company$collectPractitionerOnSignup = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$collectPractitionerOnSignup(company_);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Employer$Company$One$collectSSNOnSignup = function (_v0) {
	var record = _v0.b;
	return record.N$;
};
var $author$project$Api$Provider$Company$One$collectSSNOnSignup = function (_v0) {
	var record = _v0.b;
	return record.N$;
};
var $author$project$Api$Company$collectSSNOnSignup = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$collectSSNOnSignup(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$collectSSNOnSignup(company_);
	}
};
var $author$project$Api$Provider$Company$Shared$customPostSignupPage = function (_v0) {
	var record = _v0;
	return record.Ps;
};
var $author$project$Api$Provider$Company$One$customPostSignupPage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$customPostSignupPage(shared);
};
var $author$project$Api$Company$customPostSignupPage = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $elm$core$Maybe$Just(
			$author$project$Api$Provider$Company$One$customPostSignupPage(company_));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$Companies$CompanyId_String$Signup$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Signup$initProviderFields = function (params) {
	return $author$project$Pages$Companies$CompanyId_String$Signup$Provider(
		{
			NZ: params.NZ,
			N_: params.N_,
			N$: params.N$,
			Ps: A2($elm$core$Maybe$withDefault, false, params.Ps),
			ZR: A2($elm$core$Maybe$withDefault, '', params.ZR),
			ZS: A2($elm$core$Maybe$withDefault, '', params.ZS),
			ZT: A2($elm$core$Maybe$withDefault, '', params.ZT),
			$l: A2($elm$core$Maybe$withDefault, false, params.$l),
			abp: A2($elm$core$Maybe$withDefault, false, params.abp)
		});
};
var $author$project$Api$Provider$Company$Shared$postSignupButtonLabel = function (_v0) {
	var record = _v0;
	return record.ZR;
};
var $author$project$Api$Provider$Company$One$postSignupButtonLabel = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$postSignupButtonLabel(shared);
};
var $author$project$Api$Company$postSignupButtonLabel = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$postSignupButtonLabel(company_);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$Company$Shared$postSignupMessage = function (_v0) {
	var record = _v0;
	return record.ZS;
};
var $author$project$Api$Provider$Company$One$postSignupMessage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$postSignupMessage(shared);
};
var $author$project$Api$Company$postSignupMessage = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$postSignupMessage(company_);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$Company$Shared$postSignupRedirectUrl = function (_v0) {
	var record = _v0;
	return record.ZT;
};
var $author$project$Api$Provider$Company$One$postSignupRedirectUrl = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$postSignupRedirectUrl(shared);
};
var $author$project$Api$Company$postSignupRedirectUrl = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$postSignupRedirectUrl(company_);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$Company$Shared$redirectsPostSignup = function (_v0) {
	var record = _v0;
	return record.$l;
};
var $author$project$Api$Provider$Company$One$redirectsPostSignup = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$redirectsPostSignup(shared);
};
var $author$project$Api$Company$redirectsPostSignup = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $elm$core$Maybe$Just(
			$author$project$Api$Provider$Company$One$redirectsPostSignup(company_));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$Company$Shared$showPostSignupFooterButton = function (_v0) {
	var record = _v0;
	return record.abp;
};
var $author$project$Api$Provider$Company$One$showPostSignupFooterButton = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$showPostSignupFooterButton(shared);
};
var $author$project$Api$Company$showPostSignupFooterButton = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $elm$core$Maybe$Just(
			$author$project$Api$Provider$Company$One$showPostSignupFooterButton(company_));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$Companies$CompanyId_String$Signup$formFieldsInitFromCompany = F2(
	function (organizationIsCompany, company) {
		return organizationIsCompany ? $author$project$Pages$Companies$CompanyId_String$Signup$Employer(
			{
				N$: $author$project$Api$Company$collectSSNOnSignup(company)
			}) : $author$project$Pages$Companies$CompanyId_String$Signup$initProviderFields(
			{
				NZ: $author$project$Api$Company$collectPaymentSourceOnSignup(company),
				N_: $author$project$Api$Company$collectPractitionerOnSignup(company),
				N$: $author$project$Api$Company$collectSSNOnSignup(company),
				Ps: $author$project$Api$Company$customPostSignupPage(company),
				ZR: $author$project$Api$Company$postSignupButtonLabel(company),
				ZS: $author$project$Api$Company$postSignupMessage(company),
				ZT: $author$project$Api$Company$postSignupRedirectUrl(company),
				$l: $author$project$Api$Company$redirectsPostSignup(company),
				abp: $author$project$Api$Company$showPostSignupFooterButton(company)
			});
	});
var $author$project$Pages$Companies$CompanyId_String$Signup$init = F5(
	function (session, practice, company, shared, _v0) {
		var model = {
			Gv: shared.Gv,
			afQ: company,
			age: shared.ahq.age,
			Qb: $elm$core$Maybe$Nothing,
			n6: false,
			Ij: $author$project$Shared$isHintAdmin(shared),
			dv: $author$project$Utils$Form$init(
				A2($author$project$Pages$Companies$CompanyId_String$Signup$formFieldsInitFromCompany, shared.ajE, company)),
			ZV: practice,
			pQ: $jinjor$elm_debounce$Debounce$init,
			aa4: session,
			p3: false,
			uJ: _List_Nil
		};
		var fetchSignupPagesCmd = ($author$project$Api$Platform$Session$One$role(session) === 'practice_admin') ? A2($author$project$Pages$Companies$CompanyId_String$Signup$fetchSignupPages, shared.Gv, company) : $elm$core$Platform$Cmd$none;
		return _Utils_Tuple2(model, fetchSignupPagesCmd);
	});
var $author$project$Pages$Companies$CompanyId_String$Signup$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					Ij: $author$project$Shared$isHintAdmin(shared)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Companies$CompanyId_String$Signup$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Companies$CompanyId_String$Signup$ConfirmModalClosed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Signup$subscriptions = function (model) {
	return model.p3 ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Companies$CompanyId_String$Signup$ConfirmModalClosed) : $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Companies$CompanyId_String$Signup$CustomPostSignupPage = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Signup$SignupPageUpdated = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Signup$SaveSettings = {$: 5};
var $author$project$Pages$Companies$CompanyId_String$Signup$debounceSave = function (field) {
	return A2(
		$elm$core$Task$perform,
		function (_v0) {
			return $author$project$Pages$Companies$CompanyId_String$Signup$SaveSettings;
		},
		$elm$core$Task$succeed(field));
};
var $author$project$Pages$Companies$CompanyId_String$Signup$employerFormFieldsUpdate = F2(
	function (field, fields) {
		if (fields.$ === 1) {
			var fields_ = fields.a;
			if (field.$ === 6) {
				var collectSSN = field.a;
				return $author$project$Pages$Companies$CompanyId_String$Signup$Employer(
					_Utils_update(
						fields_,
						{N$: collectSSN}));
			} else {
				return $author$project$Pages$Companies$CompanyId_String$Signup$Employer(fields_);
			}
		} else {
			var fields_ = fields.a;
			return $author$project$Pages$Companies$CompanyId_String$Signup$Provider(fields_);
		}
	});
var $author$project$Api$Provider$Company$SignupSetting$collectPaymentSourceOnSignup = function (_v0) {
	var record = _v0;
	return record.NZ;
};
var $author$project$Api$Company$SignupSetting$collectPaymentSourceOnSignup = function (signupSetting) {
	if (!signupSetting.$) {
		var signupSetting_ = signupSetting.a;
		return $elm$core$Maybe$Just(
			$author$project$Api$Provider$Company$SignupSetting$collectPaymentSourceOnSignup(signupSetting_));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$Company$SignupSetting$collectPractitionerOnSignup = function (_v0) {
	var record = _v0;
	return record.N_;
};
var $author$project$Api$Company$SignupSetting$collectPractitionerOnSignup = function (signupSetting) {
	if (!signupSetting.$) {
		var signupSetting_ = signupSetting.a;
		return $author$project$Api$Provider$Company$SignupSetting$collectPractitionerOnSignup(signupSetting_);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Employer$Company$SignupSetting$collectSSNOnSignup = function (_v0) {
	var record = _v0;
	return record.N$;
};
var $author$project$Api$Provider$Company$SignupSetting$collectSSNOnSignup = function (_v0) {
	var record = _v0;
	return record.N$;
};
var $author$project$Api$Company$SignupSetting$collectSSNOnSignup = function (signupSetting) {
	if (!signupSetting.$) {
		var signupSetting_ = signupSetting.a;
		return $author$project$Api$Provider$Company$SignupSetting$collectSSNOnSignup(signupSetting_);
	} else {
		var signupSetting_ = signupSetting.a;
		return $author$project$Api$Employer$Company$SignupSetting$collectSSNOnSignup(signupSetting_);
	}
};
var $author$project$Api$Provider$Company$SignupSetting$customPostSignupPage = function (_v0) {
	var record = _v0;
	return record.Ps;
};
var $author$project$Api$Company$SignupSetting$customPostSignupPage = function (signupSetting) {
	if (!signupSetting.$) {
		var signupSetting_ = signupSetting.a;
		return $elm$core$Maybe$Just(
			$author$project$Api$Provider$Company$SignupSetting$customPostSignupPage(signupSetting_));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$Company$SignupSetting$postSignupButtonLabel = function (_v0) {
	var record = _v0;
	return record.ZR;
};
var $author$project$Api$Company$SignupSetting$postSignupButtonLabel = function (signupSetting) {
	if (!signupSetting.$) {
		var signupSetting_ = signupSetting.a;
		return $author$project$Api$Provider$Company$SignupSetting$postSignupButtonLabel(signupSetting_);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$Company$SignupSetting$postSignupMessage = function (_v0) {
	var record = _v0;
	return record.ZS;
};
var $author$project$Api$Company$SignupSetting$postSignupMessage = function (signupSetting) {
	if (!signupSetting.$) {
		var signupSetting_ = signupSetting.a;
		return $author$project$Api$Provider$Company$SignupSetting$postSignupMessage(signupSetting_);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$Company$SignupSetting$postSignupRedirectUrl = function (_v0) {
	var record = _v0;
	return record.ZT;
};
var $author$project$Api$Company$SignupSetting$postSignupRedirectUrl = function (signupSetting) {
	if (!signupSetting.$) {
		var signupSetting_ = signupSetting.a;
		return $author$project$Api$Provider$Company$SignupSetting$postSignupRedirectUrl(signupSetting_);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$Company$SignupSetting$redirectsPostSignup = function (_v0) {
	var record = _v0;
	return record.$l;
};
var $author$project$Api$Company$SignupSetting$redirectsPostSignup = function (signupSetting) {
	if (!signupSetting.$) {
		var signupSetting_ = signupSetting.a;
		return $elm$core$Maybe$Just(
			$author$project$Api$Provider$Company$SignupSetting$redirectsPostSignup(signupSetting_));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$Company$SignupSetting$showPostSignupFooterButton = function (_v0) {
	var record = _v0;
	return record.abp;
};
var $author$project$Api$Company$SignupSetting$showPostSignupFooterButton = function (signupSetting) {
	if (!signupSetting.$) {
		var signupSetting_ = signupSetting.a;
		return $elm$core$Maybe$Just(
			$author$project$Api$Provider$Company$SignupSetting$showPostSignupFooterButton(signupSetting_));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$Companies$CompanyId_String$Signup$formFieldsInitFromSignupSetting = F2(
	function (organizationIsCompany, signupSetting) {
		return organizationIsCompany ? $author$project$Pages$Companies$CompanyId_String$Signup$Employer(
			{
				N$: $author$project$Api$Company$SignupSetting$collectSSNOnSignup(signupSetting)
			}) : $author$project$Pages$Companies$CompanyId_String$Signup$initProviderFields(
			{
				NZ: $author$project$Api$Company$SignupSetting$collectPaymentSourceOnSignup(signupSetting),
				N_: $author$project$Api$Company$SignupSetting$collectPractitionerOnSignup(signupSetting),
				N$: $author$project$Api$Company$SignupSetting$collectSSNOnSignup(signupSetting),
				Ps: $author$project$Api$Company$SignupSetting$customPostSignupPage(signupSetting),
				ZR: $author$project$Api$Company$SignupSetting$postSignupButtonLabel(signupSetting),
				ZS: $author$project$Api$Company$SignupSetting$postSignupMessage(signupSetting),
				ZT: $author$project$Api$Company$SignupSetting$postSignupRedirectUrl(signupSetting),
				$l: $author$project$Api$Company$SignupSetting$redirectsPostSignup(signupSetting),
				abp: $author$project$Api$Company$SignupSetting$showPostSignupFooterButton(signupSetting)
			});
	});
var $author$project$Pages$Companies$CompanyId_String$Signup$providerFormFieldsUpdate = F2(
	function (field, fields) {
		if (!fields.$) {
			var fields_ = fields.a;
			switch (field.$) {
				case 0:
					var bool = field.a;
					return $author$project$Pages$Companies$CompanyId_String$Signup$Provider(
						_Utils_update(
							fields_,
							{Ps: bool}));
				case 1:
					var bool = field.a;
					return $author$project$Pages$Companies$CompanyId_String$Signup$Provider(
						_Utils_update(
							fields_,
							{$l: bool}));
				case 2:
					var bool = field.a;
					return $author$project$Pages$Companies$CompanyId_String$Signup$Provider(
						_Utils_update(
							fields_,
							{abp: bool}));
				case 3:
					var string = field.a;
					return $author$project$Pages$Companies$CompanyId_String$Signup$Provider(
						_Utils_update(
							fields_,
							{ZS: string}));
				case 4:
					var string = field.a;
					return $author$project$Pages$Companies$CompanyId_String$Signup$Provider(
						_Utils_update(
							fields_,
							{ZR: string}));
				case 5:
					var string = field.a;
					return $author$project$Pages$Companies$CompanyId_String$Signup$Provider(
						_Utils_update(
							fields_,
							{ZT: string}));
				case 6:
					var collectSSN = field.a;
					return $author$project$Pages$Companies$CompanyId_String$Signup$Provider(
						_Utils_update(
							fields_,
							{N$: collectSSN}));
				default:
					var collectPractitioner = field.a;
					return $author$project$Pages$Companies$CompanyId_String$Signup$Provider(
						_Utils_update(
							fields_,
							{N_: collectPractitioner}));
			}
		} else {
			var fields_ = fields.a;
			return $author$project$Pages$Companies$CompanyId_String$Signup$Employer(fields_);
		}
	});
var $author$project$Pages$Companies$CompanyId_String$Signup$debounceSaveForField = function (field) {
	switch (field.$) {
		case 0:
			return false;
		case 1:
			return false;
		case 2:
			return false;
		case 3:
			return true;
		case 4:
			return true;
		case 5:
			return true;
		case 6:
			return false;
		default:
			return false;
	}
};
var $author$project$Pages$Companies$CompanyId_String$Signup$SaveDebounceMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Signup$saveDebounceConfig = {
	alK: $jinjor$elm_debounce$Debounce$later(1000),
	ame: $author$project$Pages$Companies$CompanyId_String$Signup$SaveDebounceMsg
};
var $author$project$Pages$Companies$CompanyId_String$Signup$SignupSettingUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Utils$String$encode = function (str) {
	return $author$project$Utils$String$isBlank(str) ? $elm$json$Json$Encode$null : $elm$json$Json$Encode$string(
		$elm$core$String$trim(str));
};
var $author$project$Pages$Companies$CompanyId_String$Signup$encodeForm = function (form) {
	var fields = $author$project$Utils$Form$fields(form);
	if (!fields.$) {
		var fields_ = fields.a;
		return _List_fromArray(
			[
				_Utils_Tuple2(
				'custom_post_signup_page',
				$elm$json$Json$Encode$bool(fields_.Ps)),
				_Utils_Tuple2(
				'redirects_post_signup',
				$elm$json$Json$Encode$bool(fields_.$l)),
				_Utils_Tuple2(
				'show_post_signup_footer_button',
				$elm$json$Json$Encode$bool(fields_.abp)),
				_Utils_Tuple2(
				'post_signup_message',
				$author$project$Utils$String$encode(fields_.ZS)),
				_Utils_Tuple2(
				'post_signup_button_label',
				$author$project$Utils$String$encode(fields_.ZR)),
				_Utils_Tuple2(
				'post_signup_redirect_url',
				$author$project$Utils$String$encode(fields_.ZT)),
				_Utils_Tuple2(
				'collect_practitioner_on_signup',
				$author$project$Api$CollectOnSignup$encoderMaybe(fields_.N_)),
				_Utils_Tuple2(
				'collect_ssn_on_signup',
				$author$project$Api$CollectOnSignup$encoderMaybe(fields_.N$)),
				_Utils_Tuple2(
				'collect_payment_source_on_signup',
				$author$project$Api$CollectOnSignup$encoderMaybe(fields_.NZ))
			]);
	} else {
		var fields_ = fields.a;
		return _List_fromArray(
			[
				_Utils_Tuple2(
				'collect_ssn_on_signup',
				$author$project$Api$CollectOnSignup$encoderMaybe(fields_.N$))
			]);
	}
};
var $author$project$Api$Company$SignupSetting$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Company$SignupSetting$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$Company$SignupSetting$SignupSetting = $elm$core$Basics$identity;
var $author$project$Api$Employer$Company$SignupSetting$Record = function (collectSSNOnSignup) {
	return {N$: collectSSNOnSignup};
};
var $author$project$Api$Employer$Company$SignupSetting$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'collect_ssn_on_signup',
	$elm$json$Json$Decode$maybe($author$project$Api$CollectOnSignup$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Employer$Company$SignupSetting$Record));
var $author$project$Api$Employer$Company$SignupSetting$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Company$SignupSetting$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Company$SignupSetting$path = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['signup_settings']),
	$author$project$Api$Data$employerPath);
var $author$project$Api$Employer$Company$SignupSetting$update = F3(
	function (apiClient, params, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Employer$Company$SignupSetting$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				params,
				$author$project$Api$Data$requestTo($author$project$Api$Employer$Company$SignupSetting$path)));
	});
var $author$project$Api$Provider$Company$SignupSetting$SignupSetting = $elm$core$Basics$identity;
var $author$project$Api$Provider$Company$SignupSetting$Record = F9(
	function (collectSSNOnSignup, collectPractitionerOnSignup, postSignupButtonLabel, postSignupMessage, postSignupRedirectUrl, redirectsPostSignup, showPostSignupFooterButton, customPostSignupPage, collectPaymentSourceOnSignup) {
		return {NZ: collectPaymentSourceOnSignup, N_: collectPractitionerOnSignup, N$: collectSSNOnSignup, Ps: customPostSignupPage, ZR: postSignupButtonLabel, ZS: postSignupMessage, ZT: postSignupRedirectUrl, $l: redirectsPostSignup, abp: showPostSignupFooterButton};
	});
var $author$project$Api$Provider$Company$SignupSetting$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'collect_payment_source_on_signup',
	$author$project$Api$CollectOnSignup$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'custom_post_signup_page',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'show_post_signup_footer_button',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'redirects_post_signup',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'post_signup_redirect_url',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'post_signup_message',
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'post_signup_button_label',
							$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'collect_practitioner_on_signup',
								$elm$json$Json$Decode$maybe($author$project$Api$CollectOnSignup$decoder),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'collect_ssn_on_signup',
									$elm$json$Json$Decode$maybe($author$project$Api$CollectOnSignup$decoder),
									$elm$json$Json$Decode$succeed($author$project$Api$Provider$Company$SignupSetting$Record))))))))));
var $author$project$Api$Provider$Company$SignupSetting$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Company$SignupSetting$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Company$SignupSetting$path = function (companyId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['signup_settings']),
		$author$project$Api$Provider$Company$companyPath(companyId));
};
var $author$project$Api$Provider$Company$SignupSetting$update = F4(
	function (apiClient, companyId, params, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$Company$SignupSetting$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				params,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Company$SignupSetting$path(companyId))));
	});
var $author$project$Api$Company$SignupSetting$update = F5(
	function (apiClient, session, id, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'signup_settings',
					$elm$json$Json$Encode$object(params))
				]));
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$Company$SignupSetting$update,
			apiClient,
			body,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Company$SignupSetting$Employer))) : A4(
			$author$project$Api$Provider$Company$SignupSetting$update,
			apiClient,
			id,
			body,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Company$SignupSetting$Provider)));
	});
var $author$project$Pages$Companies$CompanyId_String$Signup$saveIfDirty = function (model) {
	return model.n6 ? A5(
		$author$project$Api$Company$SignupSetting$update,
		model.Gv,
		model.aa4,
		$author$project$Api$Company$id(model.afQ),
		$author$project$Pages$Companies$CompanyId_String$Signup$encodeForm(model.dv),
		$author$project$Pages$Companies$CompanyId_String$Signup$SignupSettingUpdated) : $elm$core$Platform$Cmd$none;
};
var $author$project$Pages$Companies$CompanyId_String$Signup$saveChanges = F3(
	function (field, model, updater) {
		var newModel = _Utils_update(
			model,
			{
				n6: true,
				dv: A3($author$project$Utils$Form$update, updater, field, model.dv)
			});
		if ($author$project$Pages$Companies$CompanyId_String$Signup$debounceSaveForField(field)) {
			var _v0 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Pages$Companies$CompanyId_String$Signup$saveDebounceConfig, field, newModel.pQ);
			var debounceModel = _v0.a;
			var debounceCmd = _v0.b;
			return _Utils_Tuple2(
				_Utils_update(
					newModel,
					{pQ: debounceModel}),
				debounceCmd);
		} else {
			return _Utils_Tuple2(
				newModel,
				$author$project$Pages$Companies$CompanyId_String$Signup$saveIfDirty(newModel));
		}
	});
var $author$project$Pages$Companies$CompanyId_String$Signup$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 8:
				var dataSignupPages = msg.a;
				if (dataSignupPages.$ === 3) {
					var signupPages = dataSignupPages.a;
					var defaultSignupPage = $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (page_) {
								return $author$project$Api$Provider$SignupPage$All$default(page_);
							},
							signupPages));
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Qb: defaultSignupPage, uJ: signupPages}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{uJ: _List_Nil}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(dataSignupPages));
				}
			case 0:
				var field = msg.a;
				if ((!field.$) && (!field.a)) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{p3: true}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					var _v3 = A3($author$project$Pages$Companies$CompanyId_String$Signup$saveChanges, field, model, $author$project$Pages$Companies$CompanyId_String$Signup$providerFormFieldsUpdate);
					var newModel = _v3.a;
					var debounceCmd = _v3.b;
					return _Utils_Tuple3(newModel, debounceCmd, _List_Nil);
				}
			case 1:
				var field = msg.a;
				var _v4 = A3($author$project$Pages$Companies$CompanyId_String$Signup$saveChanges, field, model, $author$project$Pages$Companies$CompanyId_String$Signup$employerFormFieldsUpdate);
				var newModel = _v4.a;
				var debounceCmd = _v4.b;
				return _Utils_Tuple3(newModel, debounceCmd, _List_Nil);
			case 2:
				var value = msg.a;
				var newField = $author$project$Pages$Companies$CompanyId_String$Signup$CustomPostSignupPage(!value);
				var _v5 = value ? A3($author$project$Pages$Companies$CompanyId_String$Signup$saveChanges, newField, model, $author$project$Pages$Companies$CompanyId_String$Signup$providerFormFieldsUpdate) : _Utils_Tuple2(
					_Utils_update(
						model,
						{
							n6: false,
							dv: A3($author$project$Utils$Form$update, $author$project$Pages$Companies$CompanyId_String$Signup$providerFormFieldsUpdate, newField, model.dv)
						}),
					$elm$core$Platform$Cmd$none);
				var newModel = _v5.a;
				var debounceCmd = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{p3: false}),
					debounceCmd,
					_List_Nil);
			case 3:
				var signupSettingData = msg.a;
				if (signupSettingData.$ === 3) {
					var signupSetting = signupSettingData.a;
					var fields = $author$project$Utils$Form$fields(model.dv);
					var isEmployer = function () {
						if (fields.$ === 1) {
							return true;
						} else {
							return false;
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								n6: false,
								dv: $author$project$Utils$Form$init(
									A2($author$project$Pages$Companies$CompanyId_String$Signup$formFieldsInitFromSignupSetting, isEmployer, signupSetting))
							}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Company successfully updated')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(signupSettingData));
				}
			case 4:
				var debounceMsg = msg.a;
				var _v8 = A4(
					$jinjor$elm_debounce$Debounce$update,
					$author$project$Pages$Companies$CompanyId_String$Signup$saveDebounceConfig,
					$jinjor$elm_debounce$Debounce$takeLast($author$project$Pages$Companies$CompanyId_String$Signup$debounceSave),
					debounceMsg,
					model.pQ);
				var newDebouncer = _v8.a;
				var debounceCmd = _v8.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{pQ: newDebouncer}),
					debounceCmd,
					_List_Nil);
			case 5:
				return _Utils_Tuple3(
					model,
					$author$project$Pages$Companies$CompanyId_String$Signup$saveIfDirty(model),
					_List_Nil);
			case 6:
				var url = msg.a;
				return _Utils_Tuple3(
					model,
					$author$project$Ports$Clipboard$copy(url),
					_List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 3, 'Copied to clipboard!')
						]));
			case 7:
				var id = msg.a;
				var selectedPage = A2(
					$elm_community$list_extra$List$Extra$find,
					function (signupPage_) {
						return _Utils_eq(
							id,
							$author$project$Api$Provider$SignupPage$All$id(signupPage_));
					},
					model.uJ);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Qb: selectedPage}),
					A3($author$project$Api$Provider$SignupPage$makeDefault, model.Gv, id, $author$project$Pages$Companies$CompanyId_String$Signup$SignupPageUpdated),
					_List_Nil);
			default:
				var signupPageData = msg.a;
				if (signupPageData.$ === 3) {
					return _Utils_Tuple3(
						model,
						A2($author$project$Pages$Companies$CompanyId_String$Signup$fetchSignupPages, model.Gv, model.afQ),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Company\'s default signup page was updated')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(signupPageData));
				}
		}
	});
var $author$project$Pages$Companies$CompanyId_String$Signup$EmployerFormUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Signup$CollectSSNOnSignup = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Employer$Practice$One$collectSSNOnSignup = function (_v0) {
	var record = _v0;
	return record.N$;
};
var $author$project$Api$Practice$collectSSNOnSignup = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$collectSSNOnSignup(practice_);
	} else {
		var practice_ = practice.a;
		return $author$project$Api$Employer$Practice$One$collectSSNOnSignup(practice_);
	}
};
var $author$project$Pages$Companies$CompanyId_String$Signup$viewCollectOnSignupButton = F5(
	function (currentCollectOnSignup, selectedCollectOnSignup, toMsg, toFieldMsg, label) {
		return A3(
			$author$project$Ui$Button$view,
			{mm: label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(currentCollectOnSignup, selectedCollectOnSignup)),
					$author$project$Ui$Button$onClick(
					toMsg(
						toFieldMsg(selectedCollectOnSignup)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$Signup$viewCollectOnSignup = F7(
	function (collectOnSignup, label, labelHelp, viewPracticeDefault, childrenContent, toMsg, toFieldMsg) {
		var extraCollectOption = viewPracticeDefault ? _List_fromArray(
			[
				A5($author$project$Pages$Companies$CompanyId_String$Signup$viewCollectOnSignupButton, collectOnSignup, $elm$core$Maybe$Nothing, toMsg, toFieldMsg, 'Practice Default')
			]) : _List_Nil;
		return A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(11),
							$author$project$Ui$Grid$offsetSm(1)
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label(label),
									$author$project$Ui$Form$Group$labelHelp(labelHelp),
									$author$project$Ui$Form$Group$labelSpan(4),
									$author$project$Ui$Form$Group$inputSpan(8),
									$author$project$Ui$Form$Group$labelClass('')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$justifyRight]),
									_List_fromArray(
										[
											$author$project$Ui$Button$group(
											A2(
												$elm$core$List$cons,
												A5(
													$author$project$Pages$Companies$CompanyId_String$Signup$viewCollectOnSignupButton,
													collectOnSignup,
													$elm$core$Maybe$Just(0),
													toMsg,
													toFieldMsg,
													'No'),
												A2(
													$elm$core$List$cons,
													A5(
														$author$project$Pages$Companies$CompanyId_String$Signup$viewCollectOnSignupButton,
														collectOnSignup,
														$elm$core$Maybe$Just(1),
														toMsg,
														toFieldMsg,
														'Optional'),
													A2(
														$elm$core$List$cons,
														A5(
															$author$project$Pages$Companies$CompanyId_String$Signup$viewCollectOnSignupButton,
															collectOnSignup,
															$elm$core$Maybe$Just(2),
															toMsg,
															toFieldMsg,
															'Require'),
														extraCollectOption))))
										]))
								])),
						childrenContent))
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$Signup$viewCollectSSN = F3(
	function (collectSSNOnSignup, practice, toMsg) {
		var labelHelpText = function () {
			if (!collectSSNOnSignup.$) {
				switch (collectSSNOnSignup.a) {
					case 0:
						var _v1 = collectSSNOnSignup.a;
						return 'SSN will not be collected.';
					case 1:
						var _v2 = collectSSNOnSignup.a;
						return 'SSN are optional and can be left blank.';
					case 2:
						var _v3 = collectSSNOnSignup.a;
						return 'A SSN is required for each member. This will prevent people without SSNs from signing up.';
					case 3:
						var _v4 = collectSSNOnSignup.a;
						return '';
					default:
						var _v5 = collectSSNOnSignup.a;
						return '';
				}
			} else {
				return 'Will use the practice setting. Currently set to \'' + ($author$project$Api$CollectOnSignup$label(
					$author$project$Api$Practice$collectSSNOnSignup(practice)) + '\'');
			}
		}();
		return A7(
			$author$project$Pages$Companies$CompanyId_String$Signup$viewCollectOnSignup,
			collectSSNOnSignup,
			'Collect SSN',
			$elm$html$Html$text(labelHelpText),
			true,
			_List_Nil,
			toMsg,
			$author$project$Pages$Companies$CompanyId_String$Signup$CollectSSNOnSignup);
	});
var $author$project$Pages$Companies$CompanyId_String$Signup$Copy = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Employer$Company$One$employeeSignupUrl = function (_v0) {
	var record = _v0.b;
	return record.Rn;
};
var $author$project$Api$Provider$Company$One$employeeSignupUrl = function (_v0) {
	var record = _v0.b;
	return record.Rn;
};
var $author$project$Api$Company$employeeSignupUrl = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$employeeSignupUrl(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$employeeSignupUrl(company_);
	}
};
var $author$project$Pages$Companies$CompanyId_String$Signup$viewEmployeeSignupUrl = function (company) {
	var url = A2(
		$elm$core$Maybe$withDefault,
		'',
		$author$project$Api$Company$employeeSignupUrl(company));
	return A2(
		$author$project$Ui$Grid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$spanSm(11),
						$author$project$Ui$Grid$offsetSm(1)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Global Employee Sign-Up Link'),
								$author$project$Ui$Form$Group$labelHelp(
								$elm$html$Html$text('Leads to the default sign-up page.')),
								$author$project$Ui$Form$Group$labelClass(''),
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpan(8)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$group(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$value(url),
												$author$project$Ui$Form$Input$disabled(true)
											])),
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Copy link to clipboard'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$onClick(
												$author$project$Pages$Companies$CompanyId_String$Signup$Copy(url))
											]),
										_List_fromArray(
											[
												$author$project$Ui$Icon$copy(_List_Nil),
												$elm$html$Html$text(' Copy Link')
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Ui$Tooltip$Right = 3;
var $author$project$Pages$Companies$CompanyId_String$Signup$viewTitle = A2(
	$author$project$Ui$Grid$row,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Grid$column,
			_List_fromArray(
				[
					$author$project$Ui$Grid$spanMd(6)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('Employee Sign-Up Settings')
								])),
							A3(
							$author$project$Ui$Tooltip$view,
							_List_fromArray(
								[
									$author$project$Ui$Tooltip$placement(3)
								]),
							'Click to Learn More',
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$externalHref,
									'https://support.hint.com/employers/employer-account-setup',
									_List_fromArray(
										[$author$project$Ui$Link$targetBlank]),
									_List_fromArray(
										[
											$author$project$Ui$Icon$help(_List_Nil)
										]))
								]))
						]))
				]))
		]));
var $author$project$Pages$Companies$CompanyId_String$Signup$viewEmployerForm = F3(
	function (employerFormFields, company, practice) {
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[$author$project$Pages$Companies$CompanyId_String$Signup$viewTitle])),
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pages$Companies$CompanyId_String$Signup$viewEmployeeSignupUrl(company),
						A3($author$project$Pages$Companies$CompanyId_String$Signup$viewCollectSSN, employerFormFields.N$, practice, $author$project$Pages$Companies$CompanyId_String$Signup$EmployerFormUpdated)
					]))
			]);
	});
var $author$project$Pages$Companies$CompanyId_String$Signup$ProviderFormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Signup$CollectPractitionerOnSignup = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Practice$collectPractitionerOnSignup = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $elm$core$Maybe$Just(
			$author$project$Api$Provider$Practice$One$collectPractitionerOnSignup(practice_));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$Companies$CompanyId_String$Signup$viewCollectPractitioner = F2(
	function (collectPractitionerOnSignup, practice) {
		var labelHelpText = function () {
			if (!collectPractitionerOnSignup.$) {
				switch (collectPractitionerOnSignup.a) {
					case 0:
						var _v1 = collectPractitionerOnSignup.a;
						return 'Providers will not be collected.';
					case 1:
						var _v2 = collectPractitionerOnSignup.a;
						return 'Providers are optional and can be left blank.';
					case 2:
						var _v3 = collectPractitionerOnSignup.a;
						return 'A provider is required for each member.';
					case 3:
						var _v4 = collectPractitionerOnSignup.a;
						return '';
					default:
						var _v5 = collectPractitionerOnSignup.a;
						return '';
				}
			} else {
				var _v6 = $author$project$Api$Practice$collectPractitionerOnSignup(practice);
				if (!_v6.$) {
					var collectPractitioner = _v6.a;
					return 'Will use the practice setting. Currently set to \'' + ($author$project$Api$CollectOnSignup$label(collectPractitioner) + '\'');
				} else {
					return 'Will use the practice setting.';
				}
			}
		}();
		return A7(
			$author$project$Pages$Companies$CompanyId_String$Signup$viewCollectOnSignup,
			collectPractitionerOnSignup,
			'Collect Provider',
			$elm$html$Html$text(labelHelpText),
			true,
			_List_Nil,
			$author$project$Pages$Companies$CompanyId_String$Signup$ProviderFormUpdated,
			$author$project$Pages$Companies$CompanyId_String$Signup$CollectPractitionerOnSignup);
	});
var $author$project$Pages$Companies$CompanyId_String$Signup$viewConfirmModal = function (showConfirmModal) {
	return showConfirmModal ? A2(
		$author$project$Components$HiConfirm$modal,
		$author$project$Pages$Companies$CompanyId_String$Signup$ConfirmModalClosed,
		_List_fromArray(
			[
				$author$project$Components$HiConfirm$verb('clear'),
				$author$project$Components$HiConfirm$noun('company settings'),
				$author$project$Components$HiConfirm$customMessage(
				_List_fromArray(
					[
						$elm$html$Html$text('Confirmation page settings specific to this company will be reverted to the practice defaults. This action cannot be undone.')
					]))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Pages$Companies$CompanyId_String$Signup$RedirectsPostSignup = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Signup$viewSettingToggle = F3(
	function (label, labelHelp, toggleSwitch) {
		return A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(11),
							$author$project$Ui$Grid$offsetSm(1)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label(label),
									$author$project$Ui$Form$Group$labelHelp(labelHelp),
									$author$project$Ui$Form$Group$labelClass(''),
									$author$project$Ui$Form$Group$labelSpan(8),
									$author$project$Ui$Form$Group$inputSpan(4)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$justifyRight]),
									_List_fromArray(
										[toggleSwitch]))
								]))
						]))
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$Signup$viewAutoRedirectToggle = function (redirectsPostSignup) {
	var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$on(redirectsPostSignup),
				$author$project$Ui$ToggleSwitch$onChange(
				A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Signup$ProviderFormUpdated, $author$project$Pages$Companies$CompanyId_String$Signup$RedirectsPostSignup))
			]));
	return A3(
		$author$project$Pages$Companies$CompanyId_String$Signup$viewSettingToggle,
		'Auto Redirect to External Site',
		$elm$html$Html$text(''),
		toggleSwitch);
};
var $author$project$Pages$Companies$CompanyId_String$Signup$PostSignupButtonLabel = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Signup$viewCustomButtonText = F4(
	function (postSignupButtonLabel, redirectsPostSignup, showPostSignupFooterButton, practice) {
		if ((!redirectsPostSignup) && showPostSignupFooterButton) {
			var labelHelp = A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								'If left blank, button will read Go to ' + ($author$project$Api$Practice$name(practice) + ' Website (under '))
							])),
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Admin__Signup,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Online Signup')
							])),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(').')
							]))
					]));
			return A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanSm(11),
								$author$project$Ui$Grid$offsetSm(1)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Custom Button Text'),
										$author$project$Ui$Form$Group$labelHelp(labelHelp),
										$author$project$Ui$Form$Group$labelClass(''),
										$author$project$Ui$Form$Group$labelSpanSm(5),
										$author$project$Ui$Form$Group$inputSpanSm(7)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$value(postSignupButtonLabel),
												$author$project$Ui$Form$Input$onInput(
												A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Signup$ProviderFormUpdated, $author$project$Pages$Companies$CompanyId_String$Signup$PostSignupButtonLabel)),
												$author$project$Ui$Form$Input$onBlur($author$project$Pages$Companies$CompanyId_String$Signup$SaveSettings)
											]))
									]))
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Pages$Companies$CompanyId_String$Signup$PostSignupRedirectUrl = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Practice$url = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$url(practice_);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$Companies$CompanyId_String$Signup$viewCustomButtonUrl = F4(
	function (postSignupRedirectUrl, redirectsPostSignup, showPostSignupFooterButton, practice) {
		if ((!redirectsPostSignup) && (!showPostSignupFooterButton)) {
			return $author$project$Utils$Html$empty;
		} else {
			var title = redirectsPostSignup ? 'Redirect URL' : 'Custom Button URL';
			var labelHelp = redirectsPostSignup ? $elm$html$Html$text('') : A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('If left blank, clicking the button will redirect to your practice website (under ')
							])),
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Admin__Practice,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Account')
							])),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(').')
							]))
					]));
			return A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanSm(11),
								$author$project$Ui$Grid$offsetSm(1)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label(title),
										$author$project$Ui$Form$Group$labelHelp(labelHelp),
										$author$project$Ui$Form$Group$labelClass(''),
										$author$project$Ui$Form$Group$labelSpanSm(5),
										$author$project$Ui$Form$Group$inputSpanSm(7)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$value(postSignupRedirectUrl),
												$author$project$Ui$Form$Input$placeholder(
												A2(
													$elm$core$Maybe$withDefault,
													'',
													$author$project$Api$Practice$url(practice))),
												$author$project$Ui$Form$Input$onInput(
												A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Signup$ProviderFormUpdated, $author$project$Pages$Companies$CompanyId_String$Signup$PostSignupRedirectUrl)),
												$author$project$Ui$Form$Input$onBlur($author$project$Pages$Companies$CompanyId_String$Signup$SaveSettings)
											]))
									]))
							]))
					]));
		}
	});
var $author$project$Pages$Companies$CompanyId_String$Signup$PostSignupMessage = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Signup$viewCustomMessage = F2(
	function (customMessage, redirectsPostSignup) {
		return redirectsPostSignup ? $author$project$Utils$Html$empty : A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(11),
							$author$project$Ui$Grid$offsetSm(1)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Custom Message'),
									$author$project$Ui$Form$Group$labelClass(''),
									$author$project$Ui$Form$Group$labelSpanSm(5),
									$author$project$Ui$Form$Group$inputSpanSm(7)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Textarea$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Textarea$placeholder('Add your custom message here.'),
											$author$project$Ui$Form$Textarea$value(customMessage),
											$author$project$Ui$Form$Textarea$onInput(
											A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Signup$ProviderFormUpdated, $author$project$Pages$Companies$CompanyId_String$Signup$PostSignupMessage)),
											$author$project$Ui$Form$Textarea$onBlur($author$project$Pages$Companies$CompanyId_String$Signup$SaveSettings)
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$Signup$ShowPostSignupFooterButton = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Signup$viewPostSignupButtonToggle = F2(
	function (showPostSignupFooterButton, redirectsPostSignup) {
		if (redirectsPostSignup) {
			return $author$project$Utils$Html$empty;
		} else {
			var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$on(showPostSignupFooterButton),
						$author$project$Ui$ToggleSwitch$onChange(
						A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Signup$ProviderFormUpdated, $author$project$Pages$Companies$CompanyId_String$Signup$ShowPostSignupFooterButton))
					]));
			var labelHelpText = showPostSignupFooterButton ? 'A button is displayed that can be configured below with a custom text and URL.' : 'No button will be shown, and employee should be instructed to close their current signup tab.';
			var labelHelp = A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(labelHelpText)
					]));
			return A3(
				$author$project$Pages$Companies$CompanyId_String$Signup$viewSettingToggle,
				'Show Redirect Button on Confirmation',
				A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp),
				toggleSwitch);
		}
	});
var $author$project$Pages$Companies$CompanyId_String$Signup$viewCustomPostSignupFields = F2(
	function (providerFormFields, practice) {
		return providerFormFields.Ps ? _List_fromArray(
			[
				$author$project$Pages$Companies$CompanyId_String$Signup$viewAutoRedirectToggle(providerFormFields.$l),
				A2($author$project$Pages$Companies$CompanyId_String$Signup$viewCustomMessage, providerFormFields.ZS, providerFormFields.$l),
				A2($author$project$Pages$Companies$CompanyId_String$Signup$viewPostSignupButtonToggle, providerFormFields.abp, providerFormFields.$l),
				A4($author$project$Pages$Companies$CompanyId_String$Signup$viewCustomButtonText, providerFormFields.ZR, providerFormFields.$l, providerFormFields.abp, practice),
				A4($author$project$Pages$Companies$CompanyId_String$Signup$viewCustomButtonUrl, providerFormFields.ZT, providerFormFields.$l, providerFormFields.abp, practice)
			]) : _List_Nil;
	});
var $author$project$Pages$Companies$CompanyId_String$Signup$viewCustomPostSignupToggle = function (customPostSignupPage) {
	var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$on(customPostSignupPage),
				$author$project$Ui$ToggleSwitch$onChange(
				A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Signup$ProviderFormUpdated, $author$project$Pages$Companies$CompanyId_String$Signup$CustomPostSignupPage))
			]));
	var labelHelp = customPostSignupPage ? A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Employee will be redirected or see a confirmation page specific to this company')
			])) : A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Employee will be redirected or see the default confirmation page based on the '),
				A3(
				$author$project$Ui$Link$route,
				$author$project$Spa$Generated$Route$Admin__Signup,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('global practice settings')
					]))
			]));
	return A3(
		$author$project$Pages$Companies$CompanyId_String$Signup$viewSettingToggle,
		'Custom Confirmation Page after Signup',
		A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp),
		toggleSwitch);
};
var $author$project$Pages$Companies$CompanyId_String$Signup$viewProviderForm = F3(
	function (showConfirmModal, providerFormFields, practice) {
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[$author$project$Pages$Companies$CompanyId_String$Signup$viewTitle])),
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				A2(
					$elm$core$List$cons,
					$author$project$Pages$Companies$CompanyId_String$Signup$viewConfirmModal(showConfirmModal),
					A2(
						$elm$core$List$cons,
						A2($author$project$Pages$Companies$CompanyId_String$Signup$viewCollectPractitioner, providerFormFields.N_, practice),
						A2(
							$elm$core$List$cons,
							A3($author$project$Pages$Companies$CompanyId_String$Signup$viewCollectSSN, providerFormFields.N$, practice, $author$project$Pages$Companies$CompanyId_String$Signup$ProviderFormUpdated),
							A2(
								$elm$core$List$cons,
								$author$project$Pages$Companies$CompanyId_String$Signup$viewCustomPostSignupToggle(providerFormFields.Ps),
								A2($author$project$Pages$Companies$CompanyId_String$Signup$viewCustomPostSignupFields, providerFormFields, practice))))))
			]);
	});
var $author$project$Pages$Companies$CompanyId_String$Signup$SignupPageSelectMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Signup$viewDefaultSignupPage = function (model) {
	var _v0 = model.Qb;
	if (!_v0.$) {
		var signupPage = _v0.a;
		var signupPageItems = A2(
			$elm$core$List$map,
			function (signupPage_) {
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$SignupPage$All$id(signupPage_)),
					$author$project$Api$Provider$SignupPage$All$displayName(signupPage_));
			},
			model.uJ);
		return A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(11),
							$author$project$Ui$Grid$offsetSm(1)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Default Sign-Up Page'),
									$author$project$Ui$Form$Group$labelHelp(
									$elm$html$Html$text('This is the page that will open when the global link is clicked by an employee.')),
									$author$project$Ui$Form$Group$labelSpan(4),
									$author$project$Ui$Form$Group$inputSpan(8),
									$author$project$Ui$Form$Group$labelClass('')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Select$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Select$value(
											$elm$core$Maybe$Just(
												$author$project$Api$Provider$SignupPage$All$id(signupPage))),
											$author$project$Ui$Form$Select$onChange($author$project$Pages$Companies$CompanyId_String$Signup$SignupPageSelectMsg)
										]),
									signupPageItems)
								]))
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Companies$CompanyId_String$Signup$viewNewSignupPageButton = function (company) {
	return A3(
		$author$project$Ui$Link$route,
		$author$project$Spa$Generated$Route$Companies__CompanyId_String__SignupPages__New(
			{
				fZ: $author$project$Api$Company$id(company)
			}),
		_List_fromArray(
			[
				$author$project$Ui$Link$buttonDefault,
				$author$project$Ui$Link$icon($author$project$Ui$Icon$add)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('New Page')
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Signup$viewSignupPage = F2(
	function (model, item) {
		var status = ($author$project$Api$Practice$hasPaymentProcessorAccount(model.ZV) && $author$project$Api$Provider$SignupPage$All$active(item)) ? 'live' : 'inactive';
		var signupPageId = $author$project$Api$Provider$SignupPage$All$id(item);
		var companyId = $author$project$Api$Company$id(model.afQ);
		return A2(
			$author$project$Ui$ListGroup$item,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_fromArray(
						[$author$project$Ui$Grid$rowItemsCenter]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$label,
											_List_Nil,
											_List_fromArray(
												[
													($author$project$Api$Provider$SignupPage$All$type_(item) === 'checkout') ? $author$project$Ui$Icon$cart(_List_Nil) : $author$project$Ui$Icon$onlineSignup(_List_Nil)
												])),
											$elm$html$Html$text(
											$author$project$Api$Provider$SignupPage$All$displayName(item)),
											A2(
											$author$project$Ui$Typography$span,
											_List_Nil,
											_List_fromArray(
												[
													A2($author$project$Ui$Badge$fromString, _List_Nil, status)
												]))
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$justifyRight, $author$project$Ui$Element$gap2]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{mm: 'Copy link to clipboard'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$sm,
													$author$project$Ui$Button$onClick(
													$author$project$Pages$Companies$CompanyId_String$Signup$Copy(
														$author$project$Api$Provider$SignupPage$All$url(item)))
												]),
											_List_fromArray(
												[
													$author$project$Ui$Icon$copy(_List_Nil),
													$author$project$Utils$Html$noBreakSpace,
													$elm$html$Html$text('Copy Link')
												])),
											A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$Companies__CompanyId_String__SignupPages__Id_String(
												{fZ: companyId, ahP: signupPageId}),
											_List_fromArray(
												[
													$author$project$Ui$Link$sm,
													$author$project$Ui$Link$icon($author$project$Ui$Icon$edit)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Edit')
												])),
											$author$project$Api$Provider$SignupPage$All$isDestroyable(item) ? A3(
											$author$project$Ui$Button$view,
											{mm: 'Delete signup page'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$sm,
													$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Delete')
												])) : $author$project$Utils$Html$empty,
											$author$project$Api$Provider$SignupPage$All$default(item) ? A2($author$project$Ui$Badge$fromString, _List_Nil, 'default') : $author$project$Utils$Html$empty
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$Signup$viewSignupPages = function (model) {
	return A2(
		$author$project$Ui$Grid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$spanSm(11),
						$author$project$Ui$Grid$offsetSm(1)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Sign-Up Pages'),
								$author$project$Ui$Form$Group$labelHelp(
								$elm$html$Html$text('Custom sign-up pages for plans and checkout items.')),
								$author$project$Ui$Form$Group$labelSpan(4),
								$author$project$Ui$Form$Group$inputSpan(8),
								$author$project$Ui$Form$Group$labelClass('')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap2]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$ListGroup$view,
										_List_Nil,
										A2(
											$elm$core$List$map,
											$author$project$Pages$Companies$CompanyId_String$Signup$viewSignupPage(model),
											model.uJ)),
										$author$project$Pages$Companies$CompanyId_String$Signup$viewNewSignupPageButton(model.afQ)
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Signup$viewSignupPagesTitle = $author$project$Ui$Typography$headingSm(
	_List_fromArray(
		[
			$elm$html$Html$text('Employee Sign-Up Pages')
		]));
var $author$project$Pages$Companies$CompanyId_String$Signup$viewSignupPagesSection = function (model) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Panel$heading,
			_List_Nil,
			_List_fromArray(
				[$author$project$Pages$Companies$CompanyId_String$Signup$viewSignupPagesTitle])),
			A2(
			$author$project$Ui$Panel$body,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Pages$Companies$CompanyId_String$Signup$viewEmployeeSignupUrl(model.afQ),
					$author$project$Pages$Companies$CompanyId_String$Signup$viewDefaultSignupPage(model),
					$author$project$Pages$Companies$CompanyId_String$Signup$viewSignupPages(model)
				]))
		]);
};
var $author$project$Pages$Companies$CompanyId_String$Signup$viewSections = function (model) {
	var fields = $author$project$Utils$Form$fields(model.dv);
	if (!fields.$) {
		var providerFormFields = fields.a;
		return _Utils_ap(
			$author$project$Pages$Companies$CompanyId_String$Signup$viewSignupPagesSection(model),
			A3($author$project$Pages$Companies$CompanyId_String$Signup$viewProviderForm, model.p3, providerFormFields, model.ZV));
	} else {
		var employerFormFields = fields.a;
		return A3($author$project$Pages$Companies$CompanyId_String$Signup$viewEmployerForm, employerFormFields, model.afQ, model.ZV);
	}
};
var $author$project$Pages$Companies$CompanyId_String$Signup$viewBody = function (model) {
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		$author$project$Pages$Companies$CompanyId_String$Signup$viewSections(model));
};
var $author$project$Pages$Companies$CompanyId_String$Signup$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				$author$project$Pages$Companies$CompanyId_String$Signup$viewBody(model)
			]),
		ac9: A2($author$project$Api$Practice$sponsorize, model.ZV, 'Companies') + ' | Online Signup'
	};
};
var $author$project$Pages$Companies$CompanyId_String$Signup$page = $author$project$Spa$Page$applicationCompanyOrEmployer(
	{ah_: $author$project$Pages$Companies$CompanyId_String$Signup$init, aiq: $author$project$Pages$Companies$CompanyId_String$Signup$load, k8: $author$project$Pages$Companies$CompanyId_String$Signup$save, alO: $author$project$Pages$Companies$CompanyId_String$Signup$subscriptions, adT: $author$project$Pages$Companies$CompanyId_String$Signup$update, amo: $author$project$Pages$Companies$CompanyId_String$Signup$view});
var $author$project$Pages$Companies$CompanyId_String$SignupPages$Id_String$FormMsg = $elm$core$Basics$identity;
var $author$project$Pages$Companies$CompanyId_String$SignupPages$Id_String$init = F5(
	function (session, practice, _v0, shared, _v1) {
		var params = _v1.YL;
		var id = params.ahP;
		var companyId = params.fZ;
		var _v2 = A6(
			$author$project$Components$Admin$SignupPages$Form$init,
			shared.Gv,
			session,
			practice,
			$elm$core$Maybe$Just(id),
			$elm$core$Maybe$Just(companyId),
			$elm$core$Maybe$Nothing);
		var form = _v2.a;
		var formCmd = _v2.b;
		return _Utils_Tuple2(
			{
				Gv: shared.Gv,
				fZ: companyId,
				age: shared.ahq.age,
				SD: form,
				Ij: $author$project$Shared$isHintAdmin(shared),
				ZV: practice,
				aa4: session
			},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, formCmd));
	});
var $author$project$Pages$Companies$CompanyId_String$SignupPages$Id_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Companies$CompanyId_String$SignupPages$Id_String$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Companies$CompanyId_String$SignupPages$Id_String$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Admin$SignupPages$Form$subscriptions(model.SD));
};
var $author$project$Pages$Companies$CompanyId_String$SignupPages$Id_String$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Admin$SignupPages$Form$update, model.Gv, subMsg, model.SD);
		var form = _v1.a;
		var formCmd = _v1.b;
		var outMsgs = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{SD: form}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, formCmd),
			outMsgs);
	});
var $author$project$Pages$Companies$CompanyId_String$SignupPages$Id_String$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Admin$SignupPages$Form$view(model.SD))
			]),
		ac9: A2($author$project$Formatters$String$sponsorize, model.ZV, 'Companies') + ' | Online Signup'
	};
};
var $author$project$Pages$Companies$CompanyId_String$SignupPages$Id_String$page = $author$project$Spa$Page$applicationCompany(
	{ah_: $author$project$Pages$Companies$CompanyId_String$SignupPages$Id_String$init, aiq: $author$project$Pages$Companies$CompanyId_String$SignupPages$Id_String$load, k8: $author$project$Pages$Companies$CompanyId_String$SignupPages$Id_String$save, alO: $author$project$Pages$Companies$CompanyId_String$SignupPages$Id_String$subscriptions, adT: $author$project$Pages$Companies$CompanyId_String$SignupPages$Id_String$update, amo: $author$project$Pages$Companies$CompanyId_String$SignupPages$Id_String$view});
var $author$project$Pages$Companies$CompanyId_String$SignupPages$New$FormMsg = $elm$core$Basics$identity;
var $author$project$Pages$Companies$CompanyId_String$SignupPages$New$init = F5(
	function (session, practice, _v0, shared, _v1) {
		var params = _v1.YL;
		var companyId = params.fZ;
		var _v2 = A6(
			$author$project$Components$Admin$SignupPages$Form$init,
			shared.Gv,
			session,
			practice,
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Just(companyId),
			$elm$core$Maybe$Nothing);
		var form = _v2.a;
		var formCmd = _v2.b;
		return _Utils_Tuple2(
			{
				Gv: shared.Gv,
				fZ: companyId,
				age: shared.ahq.age,
				SD: form,
				Ij: $author$project$Shared$isHintAdmin(shared),
				ZV: practice,
				aa4: session
			},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, formCmd));
	});
var $author$project$Pages$Companies$CompanyId_String$SignupPages$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Companies$CompanyId_String$SignupPages$New$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Companies$CompanyId_String$SignupPages$New$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Admin$SignupPages$Form$subscriptions(model.SD));
};
var $author$project$Pages$Companies$CompanyId_String$SignupPages$New$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Admin$SignupPages$Form$update, model.Gv, subMsg, model.SD);
		var form = _v1.a;
		var formCmd = _v1.b;
		var outMsgs = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{SD: form}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, formCmd),
			outMsgs);
	});
var $author$project$Pages$Companies$CompanyId_String$SignupPages$New$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Admin$SignupPages$Form$view(model.SD))
			]),
		ac9: A2($author$project$Formatters$String$sponsorize, model.ZV, 'Companies') + ' | Online Signup'
	};
};
var $author$project$Pages$Companies$CompanyId_String$SignupPages$New$page = $author$project$Spa$Page$applicationCompany(
	{ah_: $author$project$Pages$Companies$CompanyId_String$SignupPages$New$init, aiq: $author$project$Pages$Companies$CompanyId_String$SignupPages$New$load, k8: $author$project$Pages$Companies$CompanyId_String$SignupPages$New$save, alO: $author$project$Pages$Companies$CompanyId_String$SignupPages$New$subscriptions, adT: $author$project$Pages$Companies$CompanyId_String$SignupPages$New$update, amo: $author$project$Pages$Companies$CompanyId_String$SignupPages$New$view});
var $author$project$Pages$Companies$CompanyId_String$Top$CommissionDealsMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Top$CompanyAdminsMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Top$CompanyPlansMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Top$ContactFormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Top$DeactivateSponsorMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Top$EmployeeDivisionsMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Top$EnrollmentMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Top$GotCompany = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Company$Admins$Model = $elm$core$Basics$identity;
var $author$project$Components$Company$Admins$formFieldsInit = {Rj: ''};
var $author$project$Components$Company$Admins$GotCompanyAdmins = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$CompanyAdmin$companyAdminsPath = function (companyId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['admins']),
		A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[companyId]),
			A2(
				$author$project$Api$Data$pathAppend,
				_List_fromArray(
					['companies']),
				$author$project$Api$Data$providerPath)));
};
var $author$project$Api$Provider$CompanyAdmin$All$CompanyAdmin = $elm$core$Basics$identity;
var $author$project$Api$Provider$CompanyAdmin$One$CompanyAdmin = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$CompanyAdmin$Shared$CompanyAdmin = $elm$core$Basics$identity;
var $author$project$Api$Provider$CompanyAdmin$Shared$Record = F5(
	function (id, email, invitationPending, isDestroyable, user) {
		return {Rj: email, ahP: id, Ui: invitationPending, UN: isDestroyable, ad0: user};
	});
var $author$project$Api$Provider$CompanyAdmin$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'user',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$User$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'is_destroyable',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'invitation_pending',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'email',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAdmin$Shared$Record))))));
var $author$project$Api$Provider$CompanyAdmin$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CompanyAdmin$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CompanyAdmin$One$Record = function (invitationUrl) {
	return {Uj: invitationUrl};
};
var $author$project$Api$Provider$CompanyAdmin$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'invitation_url',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAdmin$One$Record));
var $author$project$Api$Provider$CompanyAdmin$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CompanyAdmin$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$CompanyAdmin$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAdmin$One$CompanyAdmin)));
var $author$project$Api$Provider$CompanyAdmin$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CompanyAdmin$One$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CompanyAdmin$list = F3(
	function (apiClient, companyId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$CompanyAdmin$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$CompanyAdmin$companyAdminsPath(companyId)));
	});
var $author$project$Components$Company$Admins$listCompanyAdmins = F2(
	function (apiClient, company) {
		return A3(
			$author$project$Api$Provider$CompanyAdmin$list,
			apiClient,
			$author$project$Api$Provider$Company$One$id(company),
			$author$project$Components$Company$Admins$GotCompanyAdmins);
	});
var $author$project$Components$Company$Admins$init = F3(
	function (apiClient, company, practice) {
		return _Utils_Tuple2(
			{
				dW: false,
				bR: $author$project$Utils$Form$init($author$project$Components$Company$Admins$formFieldsInit),
				rc: $author$project$Api$Data$Loading,
				afQ: company,
				ZV: practice,
				_r: false
			},
			A2($author$project$Components$Company$Admins$listCompanyAdmins, apiClient, company));
	});
var $author$project$Components$Company$CommissionDeals$GotBrokerDeals = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Company$CommissionDeals$fetchBrokerDeals = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Api$Provider$BrokerDeal$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						afQ: $elm$core$Maybe$Just(
							$author$project$Api$Provider$Company$One$id(model.afQ)),
						ajJ: model.ajJ
					});
			},
			$author$project$Components$Company$CommissionDeals$GotBrokerDeals);
	});
var $author$project$Components$Company$CommissionDeals$init = F6(
	function (session, company, practice, apiClient, currentDate, timeZone) {
		var model = {
			MR: $author$project$Api$Data$Loading,
			d_: A3(
				$author$project$Components$BrokerDeal$Table$init,
				session,
				currentDate,
				{ny: false, ss: false, st: true}),
			afQ: company,
			iX: $elm$core$Maybe$Nothing,
			dd: currentDate,
			ajJ: $author$project$Api$Pagination$init,
			ZV: practice,
			aa4: session,
			J8: timeZone
		};
		return _Utils_Tuple2(
			model,
			A2($author$project$Components$Company$CommissionDeals$fetchBrokerDeals, apiClient, model));
	});
var $author$project$Components$Company$ContactForm$Model = $elm$core$Basics$identity;
var $author$project$Components$Company$ContactForm$AddressInputMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Company$ContactForm$initPhoneInput = function (phones) {
	return A3(
		$author$project$Components$PhoneInput$init,
		'company-phone-input',
		A2($elm$core$List$map, $author$project$Utils$Phone$fromApi, phones),
		function (d) {
			return _Utils_update(
				d,
				{agl: $author$project$Api$Common$Phone$Shared$Office});
		});
};
var $author$project$Components$Company$ContactForm$initFormFields = function (company) {
	var _v0 = A2(
		$author$project$Components$AddressInput$initFromApi,
		'company',
		$author$project$Api$Company$address(company));
	var addressInput = _v0.a;
	var addressInputCmd = _v0.b;
	var fields = {
		K2: addressInput,
		Bq: $author$project$Api$Company$name(company),
		Zw: $author$project$Components$Company$ContactForm$initPhoneInput(
			$author$project$Api$Company$phones(company))
	};
	return _Utils_Tuple2(
		fields,
		A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$ContactForm$AddressInputMsg, addressInputCmd));
};
var $author$project$Components$Company$ContactForm$init = F3(
	function (company, practice, session) {
		var _v0 = $author$project$Components$Company$ContactForm$initFormFields(company);
		var formFields = _v0.a;
		var formFieldsCmd = _v0.b;
		return _Utils_Tuple2(
			{
				afQ: company,
				SD: $author$project$Utils$Form$init(formFields),
				ZV: practice,
				k9: $author$project$Api$Data$NotAsked,
				aa4: session
			},
			formFieldsCmd);
	});
var $author$project$Api$Provider$Company$Shared$inactive = function (_v0) {
	var record = _v0;
	return record.TU;
};
var $author$project$Api$Provider$Company$One$isInactive = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$inactive(shared);
};
var $author$project$Api$Provider$Company$One$status = function (_v0) {
	var record = _v0.b;
	return record.alH;
};
var $author$project$Components$Company$DeactivateSponsor$init = F2(
	function (company, practice) {
		var status = $author$project$Api$Provider$Company$One$status(company);
		var inactive = $author$project$Api$Provider$Company$One$isInactive(company);
		var archived = status === 'archived';
		return _Utils_Tuple2(
			{L_: archived, afQ: company, jQ: false, TU: inactive, ZV: practice, _r: false, k9: $author$project$Api$Data$NotAsked},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Components$Company$EmployeeDivisions$Model = $elm$core$Basics$identity;
var $author$project$Components$Company$EmployeeDivisions$initFormFields = function () {
	var fields = {Bq: ''};
	return _Utils_Tuple2(fields, $elm$core$Platform$Cmd$none);
}();
var $author$project$Api$EmployeeDivision$Count = 0;
var $author$project$Components$Company$EmployeeDivisions$GotEmployeeDivisions = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Company$EmployeeDivisions$listEmployeeDivisions = F3(
	function (apiClient, session, company) {
		return A5(
			$author$project$Api$EmployeeDivision$list,
			apiClient,
			session,
			$author$project$Api$Company$id(company),
			function (d) {
				return _Utils_update(
					d,
					{
						HE: _List_fromArray(
							[0])
					});
			},
			$author$project$Components$Company$EmployeeDivisions$GotEmployeeDivisions);
	});
var $author$project$Components$Company$EmployeeDivisions$init = F4(
	function (apiClient, company, practice, session) {
		var usesDivisions = $author$project$Api$Company$usesEmployeeDivisions(company);
		var requireDivisions = $author$project$Api$Company$requiresEmployeeDivisions(company);
		var _v0 = $author$project$Components$Company$EmployeeDivisions$initFormFields;
		var formFields = _v0.a;
		var formFieldsCmd = _v0.b;
		return _Utils_Tuple2(
			{
				afQ: company,
				zr: $author$project$Api$Data$Loading,
				SD: $author$project$Utils$Form$init(formFields),
				ZV: practice,
				$D: requireDivisions,
				k9: $author$project$Api$Data$NotAsked,
				aa4: session,
				ad5: usesDivisions
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						formFieldsCmd,
						usesDivisions ? A3($author$project$Components$Company$EmployeeDivisions$listEmployeeDivisions, apiClient, session, company) : $elm$core$Platform$Cmd$none
					])));
	});
var $author$project$Components$Company$Enrollment$GotNotificationSetting = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Company$Enrollment$Model = $elm$core$Basics$identity;
var $author$project$Api$Employer$Company$One$backBillPeriods = function (_v0) {
	var record = _v0.b;
	return record.Mt;
};
var $author$project$Api$Provider$Company$Shared$backBillPeriods = function (_v0) {
	var record = _v0;
	return record.Mt;
};
var $author$project$Api$Provider$Company$One$backBillPeriods = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$backBillPeriods(shared);
};
var $author$project$Api$Company$backBillPeriods = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$backBillPeriods(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$backBillPeriods(company_);
	}
};
var $author$project$Api$Provider$Company$One$employeeInviteNotification = function (_v0) {
	var record = _v0.b;
	return record.Rm;
};
var $author$project$Api$Company$employeeInviteNotification = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$employeeInviteNotification(company_);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Employer$Company$One$limitBackBill = function (_v0) {
	var record = _v0.b;
	return record.V1;
};
var $author$project$Api$Provider$Company$Shared$limitBackBill = function (_v0) {
	var record = _v0;
	return record.V1;
};
var $author$project$Api$Provider$Company$One$limitBackBill = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$limitBackBill(shared);
};
var $author$project$Api$Company$limitBackBill = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$limitBackBill(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$limitBackBill(company_);
	}
};
var $author$project$Api$Employer$Company$One$numberDependentsAllowed = function (_v0) {
	var record = _v0.b;
	return record.X1;
};
var $author$project$Api$Provider$Company$One$numberDependentsAllowed = function (_v0) {
	var record = _v0.b;
	return record.X1;
};
var $author$project$Api$Company$numberDependentsAllowed = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$numberDependentsAllowed(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$numberDependentsAllowed(company_);
	}
};
var $author$project$Api$Employer$Company$One$terminationCutOffDayOfMonth = function (_v0) {
	var record = _v0.b;
	return record.ac0;
};
var $author$project$Api$Provider$Company$One$terminationCutOffDayOfMonth = function (_v0) {
	var record = _v0.b;
	return record.ac0;
};
var $author$project$Api$Company$terminationCutOffDayOfMonth = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$terminationCutOffDayOfMonth(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$terminationCutOffDayOfMonth(company_);
	}
};
var $author$project$Api$Employer$Company$One$useTerminationCutOffDate = function (_v0) {
	var record = _v0.b;
	return record.ad_;
};
var $author$project$Api$Provider$Company$One$useTerminationCutOffDate = function (_v0) {
	var record = _v0.b;
	return record.ad_;
};
var $author$project$Api$Company$useTerminationCutOffDate = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$useTerminationCutOffDate(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$useTerminationCutOffDate(company_);
	}
};
var $author$project$Components$Company$Enrollment$formFieldsInit = function (company) {
	return {
		Mt: $elm$core$String$fromInt(
			$author$project$Api$Company$backBillPeriods(company)),
		Rm: A2(
			$elm$core$Maybe$withDefault,
			'practice_default',
			$author$project$Api$Company$employeeInviteNotification(company)),
		RD: $author$project$Api$Company$enrollmentCutOffDayOfMonth(company),
		V1: $author$project$Api$Company$limitBackBill(company),
		X1: $author$project$Api$Company$numberDependentsAllowed(company),
		ac0: $author$project$Api$Company$terminationCutOffDayOfMonth(company),
		qX: $author$project$Api$Company$useTerminationCutOffDate(company)
	};
};
var $author$project$Components$Company$Enrollment$init = F5(
	function (apiClient, company, practice, session, hinterViewOff) {
		var _v0 = $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? _Utils_Tuple2($elm$core$Platform$Cmd$none, $author$project$Api$Data$NotAsked) : _Utils_Tuple2(
			A4($author$project$Api$Provider$NotificationSetting$retrieve, apiClient, 'employee_invite', $elm$core$Maybe$Nothing, $author$project$Components$Company$Enrollment$GotNotificationSetting),
			$author$project$Api$Data$Loading);
		var cmd = _v0.a;
		var notificationSetting = _v0.b;
		return _Utils_Tuple2(
			{
				rc: $author$project$Api$Data$Loading,
				GR: A3($author$project$Permission$canGoTo, session, hinterViewOff, 0),
				afQ: company,
				i5: $jinjor$elm_debounce$Debounce$init,
				cF: $author$project$Utils$Form$init(
					$author$project$Components$Company$Enrollment$formFieldsInit(company)),
				X_: notificationSetting,
				ZV: practice,
				_r: false,
				aa4: session
			},
			cmd);
	});
var $author$project$Components$Company$Plans$GotDefaultPlan = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Company$Plans$PlanResourceFilterMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Company$Plans$GotCompanyPlans = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Company$Plans$listCompanyPlans = F3(
	function (apiClient, session, company) {
		return A5(
			$author$project$Api$CompanyPlan$list,
			apiClient,
			session,
			$author$project$Api$Company$id(company),
			function (d) {
				return d;
			},
			$author$project$Components$Company$Plans$GotCompanyPlans);
	});
var $author$project$Api$Plan$EmployerOne = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Employer$Plan$One$Plan = $elm$core$Basics$identity;
var $author$project$Api$Employer$Plan$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Plan$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Plan$planPath = function (planId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[planId]),
		$author$project$Api$Employer$Plan$plansPath);
};
var $author$project$Api$Employer$Plan$retrieve = F3(
	function (apiClient, planId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Employer$Plan$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Employer$Plan$planPath(planId)));
	});
var $author$project$Api$Plan$retrieve = F5(
	function (apiClient, session, planId, expand, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$Plan$retrieve,
			apiClient,
			planId,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Plan$EmployerOne))) : A4(
			$author$project$Api$Provider$Plan$retrieve,
			apiClient,
			planId,
			expand,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Plan$ProviderOne)));
	});
var $author$project$Components$Company$Plans$retrievePlan = F4(
	function (apiClient, session, planId, toMsg) {
		return A5(
			$author$project$Api$Plan$retrieve,
			apiClient,
			session,
			planId,
			_List_fromArray(
				[1]),
			toMsg);
	});
var $author$project$Components$Company$Plans$init = F4(
	function (apiClient, company, practice, session) {
		var retrieveDefaultPlan = function () {
			var _v1 = $author$project$Api$Company$defaultPlan(company);
			if (!_v1.$) {
				var defaultPlan = _v1.a;
				return A4(
					$author$project$Components$Company$Plans$retrievePlan,
					apiClient,
					session,
					$author$project$Api$Plan$id(defaultPlan),
					$author$project$Components$Company$Plans$GotDefaultPlan);
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		}();
		var _v0 = A4(
			$author$project$Components$ResourceFilter$Plan$init,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{
						De: _List_fromArray(
							[0, 1, 3])
					});
			},
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Select a Plan'});
			});
		var planResourceFilter = _v0.a;
		var planResourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{
				dV: false,
				afQ: company,
				aH: _List_Nil,
				OT: $elm$core$Maybe$Nothing,
				P8: $elm$core$Maybe$Nothing,
				r3: false,
				gZ: $author$project$Api$Company$allowCustomMembershipPlan(company),
				b3: $elm$core$Maybe$Nothing,
				eL: $elm$core$Maybe$Nothing,
				hi: planResourceFilter,
				ZV: practice,
				le: $elm$core$Maybe$Nothing,
				aa4: session,
				p1: false,
				h9: false
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3($author$project$Components$Company$Plans$listCompanyPlans, apiClient, session, company),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$Plans$PlanResourceFilterMsg, planResourceFilterCmd),
						retrieveDefaultPlan
					])));
	});
var $author$project$Api$Company$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Company$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$Company$companyPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['company']),
	$author$project$Api$Data$employerPath);
var $author$project$Api$Employer$Company$One$Company = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Employer$Company$Shared$Company = $elm$core$Basics$identity;
var $author$project$Api$Employer$Company$Shared$Record = function (id) {
	return function (name) {
		return function (companyType) {
			return function (periodInMonths) {
				return function (allowCustomMembershipPlan) {
					return function (usesEmployeeDivisions) {
						return function (requiresEmployeeDivisions) {
							return function (enrollmentCutOffDayOfMonth) {
								return function (inactive) {
									return function (status) {
										return {Lv: allowCustomMembershipPlan, Ok: companyType, RD: enrollmentCutOffDayOfMonth, ahP: id, TU: inactive, Bq: name, Zs: periodInMonths, $F: requiresEmployeeDivisions, alH: status, ad6: usesEmployeeDivisions};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Employer$Company$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'status',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'inactive',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'enrollment_cutoff_day_of_month',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'requires_employee_divisions',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'uses_employee_divisions',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'allow_custom_membership_plan',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'period_in_months',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'company_type',
								$author$project$Api$Company$CompanyType$decoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'name',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Api$Employer$Company$Shared$Record)))))))))));
var $author$project$Api$Employer$Company$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Company$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Company$One$Record = function (invoiceAutoIssue) {
	return function (invoiceAutoIssueDay) {
		return function (invoiceAutoSend) {
			return function (invoiceAutoSendDay) {
				return function (invoiceDueDay) {
					return function (invoiceAutoPay) {
						return function (nextInvoiceDate) {
							return function (parent) {
								return function (acceptsAch) {
									return function (acceptsAmex) {
										return function (acceptsCards) {
											return function (chargePhiDetailsEnabled) {
												return function (address) {
													return function (phones) {
														return function (defaultSource) {
															return function (activeMembershipsCount) {
																return function (defaultPlan) {
																	return function (collectSSNOnSignup) {
																		return function (employeeSignupUrl) {
																			return function (limitBackBill) {
																				return function (backBillPeriods) {
																					return function (numberDependentsAllowed) {
																						return function (useTerminationCutOffDate) {
																							return function (terminationCutOffDayOfMonth) {
																								return function (stripeLink) {
																									return function (defaultLocation) {
																										return function (defaultPractitioner) {
																											return function (defaultAffiliation) {
																												return function (defaultSignupPage) {
																													return function (billAffiliateRate) {
																														return function (hideSponsorInvoices) {
																															return {KA: acceptsAch, KB: acceptsAmex, KC: acceptsCards, KS: activeMembershipsCount, K2: address, Mt: backBillPeriods, MC: billAffiliateRate, Nx: chargePhiDetailsEnabled, N$: collectSSNOnSignup, PY: defaultAffiliation, P$: defaultLocation, P8: defaultPlan, Qa: defaultPractitioner, Qb: defaultSignupPage, Qc: defaultSource, Rn: employeeSignupUrl, Ts: hideSponsorInvoices, Ul: invoiceAutoIssue, Um: invoiceAutoIssueDay, Un: invoiceAutoPay, Uo: invoiceAutoSend, Up: invoiceAutoSendDay, Ur: invoiceDueDay, V1: limitBackBill, XS: nextInvoiceDate, X1: numberDependentsAllowed, YM: parent, Zy: phones, acq: stripeLink, ac0: terminationCutOffDayOfMonth, ad_: useTerminationCutOffDate};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Employer$Company$Min$Company = $elm$core$Basics$identity;
var $author$project$Api$Employer$Company$Min$Record = F2(
	function (id, name) {
		return {ahP: id, Bq: name};
	});
var $author$project$Api$Employer$Company$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$Company$Min$Record)));
var $author$project$Api$Employer$Company$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Company$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$SignupPage$Min$SignupPage = $elm$core$Basics$identity;
var $author$project$Api$Employer$SignupPage$Min$Record = function (id) {
	return {ahP: id};
};
var $author$project$Api$Employer$SignupPage$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'id',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Employer$SignupPage$Min$Record));
var $author$project$Api$Employer$SignupPage$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$SignupPage$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Company$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'hide_sponsor_invoices',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'bill_affiliate_rate',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'default_signup_page',
			$elm$json$Json$Decode$nullable($author$project$Api$Employer$SignupPage$Min$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'default_affiliation',
				$elm$json$Json$Decode$nullable($author$project$Api$Employer$Affiliate$AffiliateMin$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'default_practitioner',
					$elm$json$Json$Decode$nullable($author$project$Api$Employer$Practitioner$Shared$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'default_location',
						$elm$json$Json$Decode$nullable($author$project$Api$Employer$Location$Shared$decoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'stripe_link',
							$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'termination_cutoff_day_of_month',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'use_termination_cutoff_date',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'number_dependents_allowed',
										$elm$json$Json$Decode$int,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'back_bill_periods',
											$elm$json$Json$Decode$int,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'limit_back_bill',
												$elm$json$Json$Decode$bool,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'employee_signup_url',
													$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'collect_ssn_on_signup',
														$elm$json$Json$Decode$maybe($author$project$Api$CollectOnSignup$decoder),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'default_plan',
															$elm$json$Json$Decode$nullable($author$project$Api$Employer$Plan$Shared$decoder),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'memberships_count',
																$elm$json$Json$Decode$int,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'default_source',
																	$elm$json$Json$Decode$nullable($author$project$Api$Common$Source$Shared$decoder),
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'phones',
																		$elm$json$Json$Decode$list($author$project$Api$Common$Phone$Shared$decoder),
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'address',
																			$elm$json$Json$Decode$nullable($author$project$Api$Common$Address$Shared$decoder),
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'charge_phi_details_enabled',
																				$elm$json$Json$Decode$bool,
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'accepts_cards',
																					$elm$json$Json$Decode$bool,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'accepts_amex',
																						$elm$json$Json$Decode$bool,
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'accepts_ach',
																							$elm$json$Json$Decode$bool,
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'parent',
																								$elm$json$Json$Decode$nullable($author$project$Api$Employer$Company$Min$decoder),
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'next_invoice_date',
																									$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'invoice_auto_pay',
																										$elm$json$Json$Decode$bool,
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'invoice_due_day',
																											$elm$json$Json$Decode$int,
																											A3(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																												'invoice_auto_send_day',
																												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																												A3(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																													'invoice_auto_send',
																													$elm$json$Json$Decode$bool,
																													A3(
																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																														'invoice_auto_issue_day',
																														$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																														A3(
																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																															'invoice_auto_issue',
																															$elm$json$Json$Decode$bool,
																															$elm$json$Json$Decode$succeed($author$project$Api$Employer$Company$One$Record))))))))))))))))))))))))))))))));
var $author$project$Api$Employer$Company$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Company$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Employer$Company$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$Company$One$Company)));
var $author$project$Api$Employer$Company$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Employer$Company$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Employer$Company$companyPath));
	});
var $author$project$Api$Provider$Company$One$Company = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Company$One$Record = function (companyInvoiceSettingId) {
	return function (companyPaymentSourceSettingId) {
		return function (invoiceAutoIssue) {
			return function (invoiceAutoIssueDay) {
				return function (invoiceAutoSend) {
					return function (invoiceAutoSendDay) {
						return function (invoiceDueDay) {
							return function (invoiceAutoPay) {
								return function (parent) {
									return function (acceptsAch) {
										return function (acceptsAmex) {
											return function (acceptsCards) {
												return function (usesEmployeeDivisions) {
													return function (chargePhiDetailsEnabled) {
														return function (address) {
															return function (phones) {
																return function (defaultSource) {
																	return function (activeMembershipsCount) {
																		return function (defaultPlan) {
																			return function (defaultPractitioner) {
																				return function (defaultLocation) {
																					return function (defaultAffiliation) {
																						return function (collectSSNOnSignup) {
																							return function (collectPractitionerOnSignup) {
																								return function (collectPaymentSourceOnSignup) {
																									return function (employeeSignupUrl) {
																										return function (status) {
																											return function (numberDependentsAllowed) {
																												return function (enrollmentCutOffDayOfMonth) {
																													return function (useTerminationCutOffDate) {
																														return function (terminationCutOffDayOfMonth) {
																															return function (employeeInviteNotification) {
																																return function (flaggedNotesCount) {
																																	return function (invitationPending) {
																																		return function (defaultSignupPage) {
																																			return function (billAffiliateRate) {
																																				return {KA: acceptsAch, KB: acceptsAmex, KC: acceptsCards, KS: activeMembershipsCount, K2: address, MC: billAffiliateRate, Nx: chargePhiDetailsEnabled, NZ: collectPaymentSourceOnSignup, N_: collectPractitionerOnSignup, N$: collectSSNOnSignup, Of: companyInvoiceSettingId, Oh: companyPaymentSourceSettingId, PY: defaultAffiliation, P$: defaultLocation, P8: defaultPlan, Qa: defaultPractitioner, Qb: defaultSignupPage, Qc: defaultSource, Rm: employeeInviteNotification, Rn: employeeSignupUrl, RD: enrollmentCutOffDayOfMonth, Sz: flaggedNotesCount, Ui: invitationPending, Ul: invoiceAutoIssue, Um: invoiceAutoIssueDay, Un: invoiceAutoPay, Uo: invoiceAutoSend, Up: invoiceAutoSendDay, Ur: invoiceDueDay, X1: numberDependentsAllowed, YM: parent, Zy: phones, alH: status, ac0: terminationCutOffDayOfMonth, ad_: useTerminationCutOffDate, ad6: usesEmployeeDivisions};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$SignupPage$Min$SignupPage = $elm$core$Basics$identity;
var $author$project$Api$Provider$SignupPage$Min$Record = F2(
	function (id, slug) {
		return {ahP: id, abG: slug};
	});
var $author$project$Api$Provider$SignupPage$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'slug',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$SignupPage$Min$Record)));
var $author$project$Api$Provider$SignupPage$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$SignupPage$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Company$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'bill_affiliate_rate',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'default_signup_page',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$SignupPage$Min$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'invitation_pending',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'flagged_notes_count',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'employee_invite_notification',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'termination_cutoff_day_of_month',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'use_termination_cutoff_date',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'enrollment_cutoff_day_of_month',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'number_dependents_allowed',
									$elm$json$Json$Decode$int,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'status',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'employee_signup_url',
											$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'collect_payment_source_on_signup',
												$author$project$Api$CollectOnSignup$decoder,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'collect_practitioner_on_signup',
													$elm$json$Json$Decode$maybe($author$project$Api$CollectOnSignup$decoder),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'collect_ssn_on_signup',
														$elm$json$Json$Decode$maybe($author$project$Api$CollectOnSignup$decoder),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'default_affiliation',
															$elm$json$Json$Decode$nullable($author$project$Api$Provider$Affiliate$AffiliateMin$decoder),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'default_location',
																$elm$json$Json$Decode$nullable($author$project$Api$Provider$Location$Shared$decoder),
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'default_practitioner',
																	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Practitioner$Shared$decoder),
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'default_plan',
																		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Plan$Shared$decoder),
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'memberships_count',
																			$elm$json$Json$Decode$int,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'default_source',
																				$elm$json$Json$Decode$nullable($author$project$Api$Common$Source$Shared$decoder),
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'phones',
																					$elm$json$Json$Decode$list($author$project$Api$Common$Phone$Shared$decoder),
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'address',
																						$elm$json$Json$Decode$nullable($author$project$Api$Common$Address$Shared$decoder),
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'charge_phi_details_enabled',
																							$elm$json$Json$Decode$bool,
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'uses_employee_divisions',
																								$elm$json$Json$Decode$bool,
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'accepts_cards',
																									$elm$json$Json$Decode$bool,
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'accepts_amex',
																										$elm$json$Json$Decode$bool,
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'accepts_ach',
																											$elm$json$Json$Decode$bool,
																											A3(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																												'parent',
																												$elm$json$Json$Decode$nullable($author$project$Api$Provider$Company$Min$decoder),
																												A3(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																													'invoice_auto_pay',
																													$elm$json$Json$Decode$bool,
																													A3(
																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																														'invoice_due_day',
																														$elm$json$Json$Decode$int,
																														A3(
																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																															'invoice_auto_send_day',
																															$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																															A3(
																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																'invoice_auto_send',
																																$elm$json$Json$Decode$bool,
																																A3(
																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																	'invoice_auto_issue_day',
																																	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																																	A3(
																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																		'invoice_auto_issue',
																																		$elm$json$Json$Decode$bool,
																																		A3(
																																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
																																			_List_fromArray(
																																				['payment_source_setting', 'id']),
																																			$elm$json$Json$Decode$string,
																																			A3(
																																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
																																				_List_fromArray(
																																					['company_invoice_setting', 'id']),
																																				$elm$json$Json$Decode$string,
																																				$elm$json$Json$Decode$succeed($author$project$Api$Provider$Company$One$Record)))))))))))))))))))))))))))))))))))));
var $author$project$Api$Provider$Company$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Company$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Company$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Company$One$Company)));
var $author$project$Api$Provider$Company$retrieve = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Company$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Company$companyPath(id_)));
	});
var $author$project$Api$Company$retrieve = F4(
	function (apiClient, session, id_, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A2(
			$author$project$Api$Employer$Company$retrieve,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Company$Employer))) : A3(
			$author$project$Api$Provider$Company$retrieve,
			apiClient,
			id_,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Company$Provider)));
	});
var $author$project$Pages$Companies$CompanyId_String$Top$init = F5(
	function (session, practice, company, shared, _v0) {
		var params = _v0.YL;
		var _v1 = A5($author$project$Components$Company$Enrollment$init, shared.Gv, company, practice, session, shared.ahK);
		var enrollment = _v1.a;
		var enrollmentCmd = _v1.b;
		var _v2 = A4($author$project$Components$Company$EmployeeDivisions$init, shared.Gv, company, practice, session);
		var employeeDivisions = _v2.a;
		var employeeDivisionsCmd = _v2.b;
		var _v3 = function () {
			var _v4 = _Utils_Tuple2(company, practice);
			if ((!_v4.a.$) && (!_v4.b.$)) {
				var company_ = _v4.a.a;
				var practice_ = _v4.b.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					$elm$core$Maybe$Just,
					A2($author$project$Components$Company$DeactivateSponsor$init, company_, practice_));
			} else {
				return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
			}
		}();
		var deactivateSponsor = _v3.a;
		var deactivateSponsorCmd = _v3.b;
		var _v5 = A3($author$project$Components$Company$ContactForm$init, company, practice, session);
		var contactForm = _v5.a;
		var contactFormCmd = _v5.b;
		var _v6 = A4($author$project$Components$Company$Plans$init, shared.Gv, company, practice, session);
		var companyPlans = _v6.a;
		var companyPlansCmd = _v6.b;
		var _v7 = function () {
			var _v8 = _Utils_Tuple2(company, practice);
			if ((!_v8.a.$) && (!_v8.b.$)) {
				var company_ = _v8.a.a;
				var practice_ = _v8.b.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					$elm$core$Maybe$Just,
					A3($author$project$Components$Company$Admins$init, shared.Gv, company_, practice_));
			} else {
				return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
			}
		}();
		var companyAdmins = _v7.a;
		var companyAdminsCmd = _v7.b;
		var _v9 = function () {
			var _v10 = _Utils_Tuple2(company, practice);
			if ((!_v10.a.$) && (!_v10.b.$)) {
				var company_ = _v10.a.a;
				var practice_ = _v10.b.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					$elm$core$Maybe$Just,
					A6($author$project$Components$Company$CommissionDeals$init, session, company_, practice_, shared.Gv, shared.dd, shared.J8));
			} else {
				return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
			}
		}();
		var commissionDeals = _v9.a;
		var commissionDealsCmd = _v9.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, mX: commissionDeals, mY: companyAdmins, aH: companyPlans, iT: contactForm, dd: shared.dd, nc: deactivateSponsor, PY: $elm$core$Maybe$Nothing, P$: $elm$core$Maybe$Nothing, i6: $elm$core$Maybe$Nothing, zr: employeeDivisions, nA: enrollment, ahP: params.fZ, ZV: practice, aa4: session, J8: shared.J8},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A4($author$project$Api$Company$retrieve, shared.Gv, session, params.fZ, $author$project$Pages$Companies$CompanyId_String$Top$GotCompany),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$ContactFormMsg, contactFormCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$CommissionDealsMsg, commissionDealsCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$CompanyPlansMsg, companyPlansCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$CompanyAdminsMsg, companyAdminsCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$EmployeeDivisionsMsg, employeeDivisionsCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$DeactivateSponsorMsg, deactivateSponsorCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$EnrollmentMsg, enrollmentCmd)
					])));
	});
var $author$project$Pages$Companies$CompanyId_String$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Companies$CompanyId_String$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Companies$CompanyId_String$Top$DefaultAffiliationMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Top$DefaultLocationMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Top$DefaultProviderMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Company$Admins$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Components$Company$CommissionDeals$BrokerDealsTableMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Company$CommissionDeals$CreateModalMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Company$CommissionDeals$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Company$CommissionDeals$CreateModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$BrokerDeal$CreateModal$subscriptions, model.iX))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Company$CommissionDeals$BrokerDealsTableMsg,
				$author$project$Components$BrokerDeal$Table$subscriptions(model.d_))
			]));
};
var $author$project$Components$Company$ContactForm$GotPhoneInputMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Company$ContactForm$subscriptions = function (_v0) {
	var model = _v0;
	var _v1 = $author$project$Utils$Form$fields(model.SD);
	var phone = _v1.Zw;
	var address = _v1.K2;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Company$ContactForm$AddressInputMsg,
				$author$project$Components$AddressInput$subscriptions(address)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Company$ContactForm$GotPhoneInputMsg,
				$author$project$Components$PhoneInput$subscriptions(phone))
			]));
};
var $author$project$Components$Company$DeactivateSponsor$HiConfirmClosed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Company$DeactivateSponsor$subscriptions = function (model) {
	return model.jQ ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$Company$DeactivateSponsor$HiConfirmClosed) : $elm$core$Platform$Sub$none;
};
var $author$project$Components$Company$DefaultAffiliation$AffiliateResourceFilterMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Company$DefaultAffiliation$subscriptions = function (_v0) {
	var model = _v0;
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Components$Company$DefaultAffiliation$AffiliateResourceFilterMsg,
		$author$project$Components$ResourceFilter$Affiliate$subscriptions(model.mh));
};
var $author$project$Components$Company$DefaultLocation$LocationResourceFilterMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Company$DefaultLocation$subscriptions = function (_v0) {
	var model = _v0;
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Components$Company$DefaultLocation$LocationResourceFilterMsg,
		$author$project$Components$ResourceFilter$Location$subscriptions(model.os));
};
var $author$project$Components$Company$DefaultProvider$PractitionerResourceFilterMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Company$DefaultProvider$subscriptions = function (_v0) {
	var model = _v0;
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Components$Company$DefaultProvider$PractitionerResourceFilterMsg,
		$author$project$Components$ResourceFilter$Practitioner$subscriptions(model.hk));
};
var $author$project$Components$Company$Enrollment$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Components$Company$Plans$ClosePricingDetailsModal = {$: 19};
var $author$project$Components$Company$Plans$CoveragePlanMsg = function (a) {
	return {$: 22, a: a};
};
var $author$project$Components$Company$Plans$HiConfirmBillingPeriodClosed = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Company$Plans$HiConfirmPlanAddClosed = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$Company$Plans$HiConfirmPlanChangedClosed = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Company$Plans$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Company$Plans$ClosePricingDetailsModal)),
					model.le)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Company$Plans$CoveragePlanMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Admin$CoveragePlans$Rules$subscriptions, model.OT))),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$Company$Plans$HiConfirmBillingPeriodClosed)),
					model.b3)),
				function () {
				var _v0 = _Utils_Tuple2(model.P8, model.h9);
				if ((!_v0.a.$) && _v0.b) {
					return $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$Company$Plans$HiConfirmPlanChangedClosed);
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$Company$Plans$HiConfirmPlanAddClosed)),
					model.eL)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Company$Plans$PlanResourceFilterMsg,
				$author$project$Components$ResourceFilter$Plan$subscriptions(model.hi))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Top$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Companies$CompanyId_String$Top$ContactFormMsg,
				$author$project$Components$Company$ContactForm$subscriptions(model.iT)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Companies$CompanyId_String$Top$CompanyPlansMsg,
				$author$project$Components$Company$Plans$subscriptions(model.aH)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Companies$CompanyId_String$Top$EnrollmentMsg,
				$author$project$Components$Company$Enrollment$subscriptions(model.nA)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Companies$CompanyId_String$Top$CompanyAdminsMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Company$Admins$subscriptions, model.mY))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Companies$CompanyId_String$Top$DefaultProviderMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Company$DefaultProvider$subscriptions, model.i6))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Companies$CompanyId_String$Top$DefaultLocationMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Company$DefaultLocation$subscriptions, model.P$))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Companies$CompanyId_String$Top$DefaultAffiliationMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Company$DefaultAffiliation$subscriptions, model.PY))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Companies$CompanyId_String$Top$CommissionDealsMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Company$CommissionDeals$subscriptions, model.mX))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Companies$CompanyId_String$Top$DeactivateSponsorMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Company$DeactivateSponsor$subscriptions, model.nc)))
			]));
};
var $author$project$Components$Company$DefaultAffiliation$Model = $elm$core$Basics$identity;
var $author$project$Components$Company$DefaultAffiliation$GotAffiliations = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Company$DefaultAffiliation$fetchAffiliations = function (apiClient) {
	return A3(
		$author$project$Api$Provider$Affiliate$list,
		apiClient,
		function (d) {
			return _Utils_update(
				d,
				{
					ajJ: $author$project$Api$Pagination$init,
					akl: $elm$core$Maybe$Nothing,
					alA: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init),
					alH: $elm$core$Maybe$Nothing
				});
		},
		$author$project$Components$Company$DefaultAffiliation$GotAffiliations);
};
var $author$project$Components$Company$DefaultAffiliation$initAffiliateResourceFilter = F3(
	function (apiClient, session, company) {
		var _v0 = A4(
			$author$project$Components$ResourceFilter$Affiliate$init,
			apiClient,
			session,
			$elm$core$Basics$identity,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Select a Clinic', Lr: false, ai5: false});
			});
		var newResourceFilterModel = _v0.a;
		var cmd = _v0.b;
		var filterModelWithDefaults = function () {
			var _v1 = $author$project$Api$Provider$Company$One$defaultAffiliation(company);
			if (!_v1.$) {
				var affiliation = _v1.a;
				return A2(
					$author$project$Components$ResourceFilter$Affiliate$setValue,
					$elm$core$Maybe$Just(
						{
							ahP: $author$project$Api$Provider$Affiliate$AffiliateMin$id(affiliation),
							Bq: $author$project$Api$Provider$Affiliate$AffiliateMin$name(affiliation)
						}),
					newResourceFilterModel);
			} else {
				return newResourceFilterModel;
			}
		}();
		return _Utils_Tuple2(filterModelWithDefaults, cmd);
	});
var $author$project$Components$Company$DefaultAffiliation$initFormFields = function (company) {
	var defaultAffiliation = A2(
		$elm$core$Maybe$map,
		function (affiliation) {
			return $author$project$Api$Provider$Affiliate$AffiliateMin$id(affiliation);
		},
		$author$project$Api$Provider$Company$One$defaultAffiliation(company));
	return {Li: defaultAffiliation};
};
var $author$project$Components$Company$DefaultAffiliation$init = F4(
	function (session, company, practice, apiClient) {
		var affiliationForm = $author$project$Components$Company$DefaultAffiliation$initFormFields(company);
		var _v0 = A3($author$project$Components$Company$DefaultAffiliation$initAffiliateResourceFilter, apiClient, session, company);
		var affiliateResourceFilter = _v0.a;
		var affiliateResourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{
				mh: affiliateResourceFilter,
				fC: $author$project$Utils$Form$init(affiliationForm),
				rg: _List_Nil,
				afQ: company,
				ZV: practice,
				k9: $author$project$Api$Data$NotAsked
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$DefaultAffiliation$AffiliateResourceFilterMsg, affiliateResourceFilterCmd),
						$author$project$Components$Company$DefaultAffiliation$fetchAffiliations(apiClient)
					])));
	});
var $author$project$Components$Company$DefaultLocation$Model = $elm$core$Basics$identity;
var $author$project$Components$Company$DefaultLocation$initFormFields = function (company) {
	var defaultLocation = A2(
		$elm$core$Maybe$map,
		function (location) {
			return $author$project$Api$Provider$Location$Shared$id(location);
		},
		$author$project$Api$Provider$Company$One$defaultLocation(company));
	return {ais: defaultLocation};
};
var $author$project$Components$Company$DefaultLocation$initLocationResourceFilter = F2(
	function (apiClient, company) {
		var _v0 = A4(
			$author$project$Components$ResourceFilter$Location$init,
			apiClient,
			$elm$core$Maybe$Nothing,
			$elm$core$Basics$identity,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Select a Location', ai5: false});
			});
		var newResourceFilterModel = _v0.a;
		var cmd = _v0.b;
		var filterModelWithDefaults = function () {
			var _v1 = $author$project$Api$Provider$Company$One$defaultLocation(company);
			if (!_v1.$) {
				var location = _v1.a;
				return function (value) {
					return A2($author$project$Components$ResourceFilter$Location$setValue, value, newResourceFilterModel);
				}(
					$author$project$Components$ResourceFilter$Location$resourceFromShared(
						$elm$core$Maybe$Just(
							$author$project$Api$Location$Shared$Provider(location))));
			} else {
				return newResourceFilterModel;
			}
		}();
		return _Utils_Tuple2(filterModelWithDefaults, cmd);
	});
var $author$project$Components$Company$DefaultLocation$init = F3(
	function (company, practice, apiClient) {
		var locationForm = $author$project$Components$Company$DefaultLocation$initFormFields(company);
		var _v0 = A2($author$project$Components$Company$DefaultLocation$initLocationResourceFilter, apiClient, company);
		var locationResourceFilter = _v0.a;
		var locationResourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{
				afQ: company,
				gK: $author$project$Utils$Form$init(locationForm),
				os: locationResourceFilter,
				ZV: practice,
				k9: $author$project$Api$Data$NotAsked
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$DefaultLocation$LocationResourceFilterMsg, locationResourceFilterCmd));
	});
var $author$project$Components$Company$DefaultProvider$Model = $elm$core$Basics$identity;
var $author$project$Components$Company$DefaultProvider$initFormFields = function (company) {
	var defaultPractitioner = A2(
		$elm$core$Maybe$map,
		function (practitioner) {
			return $author$project$Api$Provider$Practitioner$Shared$id(practitioner);
		},
		$author$project$Api$Provider$Company$One$defaultPractitioner(company));
	return {aka: defaultPractitioner};
};
var $author$project$Components$Company$DefaultProvider$initPractitionerResourceFilter = F2(
	function (apiClient, company) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$Practitioner$init,
			apiClient,
			$elm$core$Basics$identity,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Select a Provider', ai5: false});
			});
		var newResourceFilterModel = _v0.a;
		var cmd = _v0.b;
		var filterModelWithDefaults = function () {
			var _v1 = $author$project$Api$Provider$Company$One$defaultPractitioner(company);
			if (!_v1.$) {
				var practitioner = _v1.a;
				return function (value) {
					return A2($author$project$Components$ResourceFilter$Practitioner$setValue, value, newResourceFilterModel);
				}(
					$author$project$Components$ResourceFilter$Practitioner$resourceFromShared(
						$elm$core$Maybe$Just(
							$author$project$Api$Practitioner$Shared$Provider(practitioner))));
			} else {
				return newResourceFilterModel;
			}
		}();
		return _Utils_Tuple2(filterModelWithDefaults, cmd);
	});
var $author$project$Components$Company$DefaultProvider$init = F3(
	function (company, practice, apiClient) {
		var providerForm = $author$project$Components$Company$DefaultProvider$initFormFields(company);
		var _v0 = A2($author$project$Components$Company$DefaultProvider$initPractitionerResourceFilter, apiClient, company);
		var practitionerResourceFilter = _v0.a;
		var practitionerResourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{
				afQ: company,
				ZV: practice,
				hk: practitionerResourceFilter,
				hn: $author$project$Utils$Form$init(providerForm),
				k9: $author$project$Api$Data$NotAsked
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$DefaultProvider$PractitionerResourceFilterMsg, practitionerResourceFilterCmd));
	});
var $author$project$Components$Company$Admins$CompanyAdminDeleted = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Company$Admins$GotInvitation = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $author$project$Components$Company$Admins$InviteLinkMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Provider$CompanyAdmin$companyAdminPath = F2(
	function (companyId, id_) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id_]),
			$author$project$Api$Provider$CompanyAdmin$companyAdminsPath(companyId));
	});
var $author$project$Api$Provider$CompanyAdmin$delete = F4(
	function (apiClient, companyId, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Provider$CompanyAdmin$companyAdminPath, companyId, id_)));
	});
var $author$project$Api$Provider$CompanyAdmin$Shared$email = function (_v0) {
	var record = _v0;
	return record.Rj;
};
var $author$project$Api$Provider$CompanyAdmin$One$email = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyAdmin$Shared$email(shared);
};
var $author$project$Api$Provider$CompanyAdmin$All$email = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CompanyAdmin$One$email(shared);
};
var $author$project$Components$Company$Admins$formFieldsUpdate = F2(
	function (field, fields) {
		var string = field;
		return _Utils_update(
			fields,
			{Rj: string});
	});
var $author$project$Components$Company$Admins$EmailValidation = 0;
var $author$project$Components$Company$Admins$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A3(
			$author$project$Utils$Validate$ifInvalidEmail,
			{aeT: false},
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.Rj;
				},
				$elm$core$Maybe$Just),
			_Utils_Tuple2(0, 'Please enter a valid email.'))
		]));
var $author$project$Api$Provider$CompanyAdmin$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$CompanyAdmin$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyAdmin$Shared$id(shared);
};
var $author$project$Api$Provider$CompanyAdmin$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CompanyAdmin$One$id(shared);
};
var $author$project$Api$Provider$CompanyAdmin$invite = F4(
	function (apiClient, companyId, email_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'admin',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'email',
								$elm$json$Json$Encode$string(email_))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$CompanyAdmin$companyAdminsPath(companyId))));
	});
var $author$project$Api$Provider$CompanyAdmin$reinvite = F4(
	function (apiClient, companyId, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['reinvite']),
					A2($author$project$Api$Provider$CompanyAdmin$companyAdminPath, companyId, id_))));
	});
var $author$project$Components$Company$Admins$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var admins = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								dW: $elm$core$List$isEmpty(admins),
								rc: response,
								_r: false
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{_r: false}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var admin = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{_r: true}),
					A4(
						$author$project$Api$Provider$CompanyAdmin$delete,
						apiClient,
						$author$project$Api$Provider$Company$One$id(model.afQ),
						$author$project$Api$Provider$CompanyAdmin$All$id(admin),
						$author$project$Components$Company$Admins$CompanyAdminDeleted(admin)),
					_List_Nil);
			case 2:
				var admin = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							model,
							A2($author$project$Components$Company$Admins$listCompanyAdmins, apiClient, model.afQ),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Provider$CompanyAdmin$All$email(admin) + ' was successfully removed from this company')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{_r: false}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{_r: false}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
				}
			case 3:
				var _v4 = A2($author$project$Utils$Form$validate, $author$project$Components$Company$Admins$formFieldsValidator, model.bR);
				if (!_v4.$) {
					var _v5 = _v4.a;
					var validatedForm = _v5.a;
					var validFormFields = _v5.b;
					var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dW: false, bR: validatedForm}),
						A4(
							$author$project$Api$Provider$CompanyAdmin$invite,
							apiClient,
							$author$project$Api$Provider$Company$One$id(model.afQ),
							fields.Rj,
							A2($author$project$Components$Company$Admins$GotInvitation, fields.Rj, false)),
						_List_Nil);
				} else {
					var erroredForm = _v4.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bR: erroredForm}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 4:
				var admin = msg.a;
				var adminId = $author$project$Api$Provider$CompanyAdmin$All$id(admin);
				return _Utils_Tuple3(
					model,
					A4(
						$author$project$Api$Provider$CompanyAdmin$reinvite,
						apiClient,
						$author$project$Api$Provider$Company$One$id(model.afQ),
						adminId,
						A2(
							$author$project$Components$Company$Admins$GotInvitation,
							$author$project$Api$Provider$CompanyAdmin$All$email(admin),
							true)),
					_List_Nil);
			case 5:
				var email = msg.a;
				var isReinvite = msg.b;
				var response = msg.c;
				if (response.$ === 3) {
					var sentText = isReinvite ? 'resent' : 'sent';
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bR: $author$project$Utils$Form$init($author$project$Components$Company$Admins$formFieldsInit),
								rc: $author$project$Api$Data$Loading
							}),
						A2($author$project$Components$Company$Admins$listCompanyAdmins, apiClient, model.afQ),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Invitation was successfully ' + (sentText + (' to ' + email)))
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dW: true}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 6:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dW: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 7:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							dW: false,
							bR: $author$project$Utils$Form$init($author$project$Components$Company$Admins$formFieldsInit)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 8:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Company$Admins$formFieldsUpdate, field, model.bR);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bR: newForm}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v7 = $author$project$Components$InviteLink$update(subMsg);
				var inviteLinkCmd = _v7.a;
				var inviteLinkOutMsg = _v7.b;
				return _Utils_Tuple3(
					model,
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$Admins$InviteLinkMsg, inviteLinkCmd),
					inviteLinkOutMsg);
		}
	});
var $author$project$Components$Company$CommissionDeals$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = model.iX;
				if (!_v1.$) {
					var createModal = _v1.a;
					var createModalResult = A3($author$project$Components$BrokerDeal$CreateModal$update, apiClient, subMsg, createModal);
					var _v2 = function () {
						var _v3 = createModalResult.agZ;
						switch (_v3) {
							case 0:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(createModalResult.aiO),
									model.MR,
									$elm$core$Platform$Cmd$none);
							case 1:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.MR, $elm$core$Platform$Cmd$none);
							case 2:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Api$Data$Loading,
									A2($author$project$Components$Company$CommissionDeals$fetchBrokerDeals, apiClient, model));
							default:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Api$Data$Loading,
									A2($author$project$Components$Company$CommissionDeals$fetchBrokerDeals, apiClient, model));
						}
					}();
					var createModal_ = _v2.a;
					var brokerDeals = _v2.b;
					var cmd = _v2.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{MR: brokerDeals, iX: createModal_}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$CommissionDeals$CreateModalMsg, createModalResult.GZ),
									cmd
								])),
						createModalResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var _v4 = A5(
					$author$project$Components$BrokerDeal$CreateModal$init,
					apiClient,
					model.aa4,
					model.dd,
					model.J8,
					{
						xF: $elm$core$Maybe$Nothing,
						xG: $elm$core$Maybe$Nothing,
						N7: $author$project$Api$Provider$Practice$One$commissionsTrackingFrom(model.ZV),
						afQ: $elm$core$Maybe$Just(model.afQ),
						PT: 0,
						kk: $elm$core$Maybe$Nothing,
						ak0: false
					});
				var createModal = _v4.a;
				var createModalCmd = _v4.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							iX: $elm$core$Maybe$Just(createModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$CommissionDeals$CreateModalMsg, createModalCmd),
					_List_Nil);
			case 1:
				var response = msg.a;
				if (response.$ === 3) {
					var brokerDeals = response.a;
					var headers = response.b;
					var brokerDealsTable = A2(
						$author$project$Components$BrokerDeal$Table$withBrokerDeals,
						A2($elm$core$List$map, $author$project$Components$BrokerDeal$BrokerDealRecord$fromProviderAll, brokerDeals),
						model.d_);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								MR: response,
								d_: brokerDealsTable,
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{MR: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var subMsg = msg.a;
				var brokerDealsTableResult = A3($author$project$Components$BrokerDeal$Table$update, apiClient, subMsg, model.d_);
				var _v6 = function () {
					var _v7 = brokerDealsTableResult.agZ;
					switch (_v7) {
						case 0:
							return _Utils_Tuple2(model.MR, $elm$core$Platform$Cmd$none);
						case 1:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								A2($author$project$Components$Company$CommissionDeals$fetchBrokerDeals, apiClient, model));
						case 2:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								A2($author$project$Components$Company$CommissionDeals$fetchBrokerDeals, apiClient, model));
						case 3:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								A2($author$project$Components$Company$CommissionDeals$fetchBrokerDeals, apiClient, model));
						case 4:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								A2($author$project$Components$Company$CommissionDeals$fetchBrokerDeals, apiClient, model));
						case 5:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								A2($author$project$Components$Company$CommissionDeals$fetchBrokerDeals, apiClient, model));
						default:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								A2($author$project$Components$Company$CommissionDeals$fetchBrokerDeals, apiClient, model));
					}
				}();
				var brokerDeals = _v6.a;
				var cmd = _v6.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{MR: brokerDeals, d_: brokerDealsTableResult.aiO}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$CommissionDeals$BrokerDealsTableMsg, brokerDealsTableResult.GZ),
								cmd
							])),
					brokerDealsTableResult.aR);
		}
	});
var $author$project$Components$Company$ContactForm$Address = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Company$ContactForm$Phone = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Company$ContactForm$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{Bq: string});
			case 1:
				var address = field.a;
				return _Utils_update(
					fields,
					{K2: address});
			default:
				var phone = field.a;
				return _Utils_update(
					fields,
					{Zw: phone});
		}
	});
var $author$project$Components$Company$ContactForm$NameValidation = 0;
var $author$project$Components$Company$ContactForm$AddressValidation = 1;
var $author$project$Components$Company$ContactForm$validateAddress = function (fields) {
	return $author$project$Components$AddressInput$isValid(fields.K2) ? _List_Nil : _List_fromArray(
		[
			_Utils_Tuple2(1, 'Please enter an address')
		]);
};
var $author$project$Components$Company$ContactForm$PhoneValidation = 2;
var $author$project$Components$Company$ContactForm$validatePhone = function (fields) {
	var _v0 = $author$project$Components$PhoneInput$getPhones(fields.Zw);
	if (!_v0.$) {
		return _List_Nil;
	} else {
		return _List_fromArray(
			[
				_Utils_Tuple2(2, 'Please enter a valid phone')
			]);
	}
};
var $author$project$Components$Company$ContactForm$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.Bq;
			},
			_Utils_Tuple2(0, 'Please enter a name.')),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Company$ContactForm$validateAddress),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Company$ContactForm$validatePhone)
		]));
var $author$project$Components$Company$ContactForm$CompanyUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Company$ContactForm$apiFormFields = function (fields) {
	var phones = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		$author$project$Components$PhoneInput$getPhones(fields.Zw));
	var address = $author$project$Components$AddressInput$getAddress(fields.K2);
	return {
		K2: address,
		Bq: fields.Bq,
		Zy: A2($elm$core$List$map, $author$project$Utils$Phone$toRecord, phones)
	};
};
var $author$project$Api$Company$Shared$encodeUpdate = function (fields) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'company',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'name',
							$elm$json$Json$Encode$string(fields.Bq)),
							_Utils_Tuple2(
							'address',
							$author$project$Api$Common$Address$Shared$encode(fields.K2)),
							_Utils_Tuple2(
							'phones',
							A2($elm$json$Json$Encode$list, $author$project$Api$Common$Phone$Shared$encode, fields.Zy))
						])))
			]));
};
var $author$project$Api$Employer$Company$update = F3(
	function (apiClient, fields, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Employer$Company$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Company$Shared$encodeUpdate(fields),
				$author$project$Api$Data$requestTo($author$project$Api$Employer$Company$companyPath)));
	});
var $author$project$Api$Provider$Company$update = F4(
	function (apiClient, id_, fields, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$Company$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Company$Shared$encodeUpdate(fields),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Company$companyPath(id_))));
	});
var $author$project$Api$Company$update = F5(
	function (apiClient, session, id_, fields, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$Company$update,
			apiClient,
			fields,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Company$Employer))) : A4(
			$author$project$Api$Provider$Company$update,
			apiClient,
			id_,
			fields,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Company$Provider)));
	});
var $author$project$Components$Company$ContactForm$updateContactInformation = F4(
	function (apiClient, session, id_, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A5(
			$author$project$Api$Company$update,
			apiClient,
			session,
			id_,
			$author$project$Components$Company$ContactForm$apiFormFields(fields),
			$author$project$Components$Company$ContactForm$CompanyUpdated);
	});
var $author$project$Components$Company$ContactForm$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Company$ContactForm$formFieldsUpdate, field, model.SD);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: newForm}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var fields = $author$project$Utils$Form$fields(model.SD);
				var address = $author$project$Components$AddressInput$validate(fields.K2);
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Company$ContactForm$formFieldsUpdate,
					$author$project$Components$Company$ContactForm$Address(address),
					model.SD);
				var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$Company$ContactForm$formFieldsValidator, newForm);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var validatedForm = _v3.a;
					var validFormFields = _v3.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{SD: validatedForm, k9: $author$project$Api$Data$Loading}),
						A4(
							$author$project$Components$Company$ContactForm$updateContactInformation,
							apiClient,
							model.aa4,
							$author$project$Api$Company$id(model.afQ),
							validFormFields),
						_List_Nil);
				} else {
					var validatedForm = _v2.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{SD: validatedForm, k9: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 2:
				var subMsg = msg.a;
				var _v4 = $author$project$Utils$Form$fields(model.SD);
				var address = _v4.K2;
				var _v5 = A2($author$project$Components$AddressInput$update, subMsg, address);
				var addressInputModel = _v5.a;
				var addressInputCmd = _v5.b;
				var outMsgs = _v5.c;
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Company$ContactForm$formFieldsUpdate,
					$author$project$Components$Company$ContactForm$Address(addressInputModel),
					model.SD);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: newForm}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$ContactForm$AddressInputMsg, addressInputCmd),
					outMsgs);
			case 4:
				var subMsg = msg.a;
				var _v6 = $author$project$Utils$Form$fields(model.SD);
				var phone = _v6.Zw;
				var _v7 = A2($author$project$Components$PhoneInput$update, subMsg, phone);
				var phoneInput = _v7.a;
				var phoneCmd = _v7.b;
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Company$ContactForm$formFieldsUpdate,
					$author$project$Components$Company$ContactForm$Phone(phoneInput),
					model.SD);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: newForm}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$ContactForm$GotPhoneInputMsg, phoneCmd),
					_List_Nil);
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var company = response.a;
					var _v9 = $author$project$Components$Company$ContactForm$initFormFields(company);
					var formFields = _v9.a;
					var formFieldsCmd = _v9.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								SD: $author$project$Utils$Form$init(formFields),
								k9: response
							}),
						formFieldsCmd,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Company successfully updated')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Components$Company$DeactivateSponsor$SponsorArchived = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$Company$archive = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Company$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['archive']),
					$author$project$Api$Provider$Company$companyPath(id_))));
	});
var $author$project$Components$Company$DeactivateSponsor$archiveSponsor = F2(
	function (apiClient, id) {
		return A3($author$project$Api$Provider$Company$archive, apiClient, id, $author$project$Components$Company$DeactivateSponsor$SponsorArchived);
	});
var $author$project$Components$Company$DeactivateSponsor$SponsorDeactivated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$Company$deactivate = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Company$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['deactivate']),
					$author$project$Api$Provider$Company$companyPath(id_))));
	});
var $author$project$Components$Company$DeactivateSponsor$deactivateSponsor = F2(
	function (apiClient, id) {
		return A3($author$project$Api$Provider$Company$deactivate, apiClient, id, $author$project$Components$Company$DeactivateSponsor$SponsorDeactivated);
	});
var $author$project$Components$Company$DeactivateSponsor$SponsorReactivated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$Company$reactivate = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Company$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['reactivate']),
					$author$project$Api$Provider$Company$companyPath(id_))));
	});
var $author$project$Components$Company$DeactivateSponsor$reactivateSponsor = F2(
	function (apiClient, id) {
		return A3($author$project$Api$Provider$Company$reactivate, apiClient, id, $author$project$Components$Company$DeactivateSponsor$SponsorReactivated);
	});
var $author$project$Components$Company$DeactivateSponsor$SponsorUnArchived = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$Company$unArchive = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Company$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['unarchive']),
					$author$project$Api$Provider$Company$companyPath(id_))));
	});
var $author$project$Components$Company$DeactivateSponsor$unArchiveSponsor = F2(
	function (apiClient, id) {
		return A3($author$project$Api$Provider$Company$unArchive, apiClient, id, $author$project$Components$Company$DeactivateSponsor$SponsorUnArchived);
	});
var $author$project$Components$Company$DeactivateSponsor$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{jQ: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var confirmed = msg.a;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{jQ: false, _r: true}),
					A2(
						$author$project$Components$Company$DeactivateSponsor$deactivateSponsor,
						apiClient,
						$author$project$Api$Provider$Company$One$id(model.afQ)),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{jQ: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{_r: true}),
					A2(
						$author$project$Components$Company$DeactivateSponsor$reactivateSponsor,
						apiClient,
						$author$project$Api$Provider$Company$One$id(model.afQ)),
					_List_Nil);
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{_r: true}),
					A2(
						$author$project$Components$Company$DeactivateSponsor$archiveSponsor,
						apiClient,
						$author$project$Api$Provider$Company$One$id(model.afQ)),
					_List_Nil);
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{_r: true}),
					A2(
						$author$project$Components$Company$DeactivateSponsor$unArchiveSponsor,
						apiClient,
						$author$project$Api$Provider$Company$One$id(model.afQ)),
					_List_Nil);
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{TU: true, _r: false, k9: response}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Employer account has been deactivated. The employees will be unenrolled soon')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 6:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{TU: false, _r: false, k9: response}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Employer account has been reactivated')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 7:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{L_: true, _r: false, k9: response}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Employer account has been archived. They will not show up in your employer list.')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{L_: false, _r: false, k9: response}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Employer account has been unarchived.')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Components$Company$DefaultAffiliation$Affiliation = $elm$core$Basics$identity;
var $author$project$Components$Company$DefaultAffiliation$formFieldsUpdate = F2(
	function (field, fields) {
		var affiliation = field;
		return _Utils_update(
			fields,
			{
				Li: A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.ahP;
					},
					affiliation)
			});
	});
var $author$project$Components$Company$DefaultAffiliation$AffiliationValidation = 0;
var $author$project$Components$Company$DefaultAffiliation$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.Li;
			},
			_Utils_Tuple2(0, ''))
		]));
var $author$project$Components$Company$DefaultAffiliation$CompanyUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Company$Shared$encodeUpdateAffiliation = function (fields) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'company',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'default_affiliation',
							A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.Li))
						])))
			]));
};
var $author$project$Api$Provider$Company$updateAffiliation = F4(
	function (apiClient, id_, fields, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$Company$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Company$Shared$encodeUpdateAffiliation(fields),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Company$companyPath(id_))));
	});
var $author$project$Components$Company$DefaultAffiliation$updateDefaultAffiliation = F3(
	function (apiClient, id_, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4($author$project$Api$Provider$Company$updateAffiliation, apiClient, id_, fields, $author$project$Components$Company$DefaultAffiliation$CompanyUpdated);
	});
var $author$project$Components$Company$DefaultAffiliation$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var affiliateResourceResult = A3($author$project$Components$ResourceFilter$Affiliate$update, apiClient, subMsg, model.mh);
				var _v2 = function () {
					var _v3 = affiliateResourceResult.agZ;
					_v3$2:
					while (true) {
						if (!_v3.$) {
							switch (_v3.a.$) {
								case 0:
									var affiliate = _v3.a.a;
									var newForm = A3(
										$author$project$Utils$Form$update,
										$author$project$Components$Company$DefaultAffiliation$formFieldsUpdate,
										$elm$core$Maybe$Just(affiliate),
										model.fC);
									var _v4 = A2($author$project$Utils$Form$validate, $author$project$Components$Company$DefaultAffiliation$formFieldsValidator, newForm);
									if (!_v4.$) {
										var _v5 = _v4.a;
										var validatedForm = _v5.a;
										var validFormFields = _v5.b;
										return _Utils_Tuple2(
											_Utils_update(
												model,
												{fC: validatedForm, k9: $author$project$Api$Data$Loading}),
											A3(
												$author$project$Components$Company$DefaultAffiliation$updateDefaultAffiliation,
												apiClient,
												$author$project$Api$Provider$Company$One$id(model.afQ),
												validFormFields));
									} else {
										var validatedForm = _v4.a;
										return _Utils_Tuple2(
											_Utils_update(
												model,
												{fC: validatedForm, k9: $author$project$Api$Data$NotAsked}),
											$elm$core$Platform$Cmd$none);
									}
								case 2:
									var _v6 = _v3.a;
									var form = A3($author$project$Utils$Form$update, $author$project$Components$Company$DefaultAffiliation$formFieldsUpdate, $elm$core$Maybe$Nothing, model.fC);
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{fC: form}),
										$elm$core$Platform$Cmd$none);
								default:
									break _v3$2;
							}
						} else {
							break _v3$2;
						}
					}
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}();
				var newModel = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{mh: affiliateResourceResult.aiO}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$DefaultAffiliation$AffiliateResourceFilterMsg, affiliateResourceResult.GZ),
								cmd
							])),
					affiliateResourceResult.aR);
			case 1:
				var response = msg.a;
				if (response.$ === 3) {
					var company = response.a;
					var formFields = $author$project$Components$Company$DefaultAffiliation$initFormFields(company);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								fC: $author$project$Utils$Form$init(formFields),
								afQ: company,
								k9: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								$author$project$OutMsg$RetrieveCompany(
								$author$project$Api$Provider$Company$One$id(model.afQ)),
								A2($author$project$OutMsg$ShowToast, 3, 'Company successfully updated')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var affiliations = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{rg: affiliations}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{rg: _List_Nil}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Components$Company$DefaultLocation$Location = $elm$core$Basics$identity;
var $author$project$Components$Company$DefaultLocation$formFieldsUpdate = F2(
	function (field, fields) {
		var location = field;
		return _Utils_update(
			fields,
			{
				ais: A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.ahP;
					},
					location)
			});
	});
var $author$project$Components$Company$DefaultLocation$LocationValidation = 0;
var $author$project$Components$Company$DefaultLocation$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.ais;
			},
			_Utils_Tuple2(0, ''))
		]));
var $author$project$Components$Company$DefaultLocation$CompanyUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Company$Shared$encodeUpdateLocation = function (fields) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'company',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'default_location',
							A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.ais))
						])))
			]));
};
var $author$project$Api$Provider$Company$updateLocation = F4(
	function (apiClient, id_, fields, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$Company$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Company$Shared$encodeUpdateLocation(fields),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Company$companyPath(id_))));
	});
var $author$project$Components$Company$DefaultLocation$updateDefaultLocation = F3(
	function (apiClient, id_, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4($author$project$Api$Provider$Company$updateLocation, apiClient, id_, fields, $author$project$Components$Company$DefaultLocation$CompanyUpdated);
	});
var $author$project$Components$Company$DefaultLocation$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		if (!msg.$) {
			var subMsg = msg.a;
			var locationResourceResult = A3($author$project$Components$ResourceFilter$Location$update, apiClient, subMsg, model.os);
			var _v2 = function () {
				var _v3 = locationResourceResult.agZ;
				_v3$2:
				while (true) {
					if (!_v3.$) {
						switch (_v3.a.$) {
							case 0:
								var location = _v3.a.a;
								var newForm = A3(
									$author$project$Utils$Form$update,
									$author$project$Components$Company$DefaultLocation$formFieldsUpdate,
									$elm$core$Maybe$Just(location),
									model.gK);
								var _v4 = A2($author$project$Utils$Form$validate, $author$project$Components$Company$DefaultLocation$formFieldsValidator, newForm);
								if (!_v4.$) {
									var _v5 = _v4.a;
									var validatedForm = _v5.a;
									var validFormFields = _v5.b;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{gK: validatedForm, k9: $author$project$Api$Data$Loading}),
										A3(
											$author$project$Components$Company$DefaultLocation$updateDefaultLocation,
											apiClient,
											$author$project$Api$Provider$Company$One$id(model.afQ),
											validFormFields));
								} else {
									var validatedForm = _v4.a;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{gK: validatedForm, k9: $author$project$Api$Data$NotAsked}),
										$elm$core$Platform$Cmd$none);
								}
							case 2:
								var _v6 = _v3.a;
								var form = A3($author$project$Utils$Form$update, $author$project$Components$Company$DefaultLocation$formFieldsUpdate, $elm$core$Maybe$Nothing, model.gK);
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{gK: form}),
									$elm$core$Platform$Cmd$none);
							default:
								break _v3$2;
						}
					} else {
						break _v3$2;
					}
				}
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}();
			var newModel = _v2.a;
			var cmd = _v2.b;
			return _Utils_Tuple3(
				_Utils_update(
					newModel,
					{os: locationResourceResult.aiO}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$DefaultLocation$LocationResourceFilterMsg, locationResourceResult.GZ),
							cmd
						])),
				locationResourceResult.aR);
		} else {
			var response = msg.a;
			if (response.$ === 3) {
				var company = response.a;
				var formFields = $author$project$Components$Company$DefaultLocation$initFormFields(company);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							afQ: company,
							gK: $author$project$Utils$Form$init(formFields),
							k9: response
						}),
					$elm$core$Platform$Cmd$none,
					_List_fromArray(
						[
							$author$project$OutMsg$RetrieveCompany(
							$author$project$Api$Provider$Company$One$id(model.afQ)),
							A2($author$project$OutMsg$ShowToast, 3, 'Company successfully updated')
						]));
			} else {
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			}
		}
	});
var $author$project$Components$Company$DefaultProvider$Practitioner = $elm$core$Basics$identity;
var $author$project$Components$Company$DefaultProvider$formFieldsUpdate = F2(
	function (field, fields) {
		var practitioner = field;
		return _Utils_update(
			fields,
			{
				aka: A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.ahP;
					},
					practitioner)
			});
	});
var $author$project$Components$Company$DefaultProvider$PractitionerValidation = 0;
var $author$project$Components$Company$DefaultProvider$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.aka;
			},
			_Utils_Tuple2(0, ''))
		]));
var $author$project$Components$Company$DefaultProvider$CompanyUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Company$Shared$encodeUpdatePractitioner = function (fields) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'company',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'default_practitioner',
							A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.aka))
						])))
			]));
};
var $author$project$Api$Provider$Company$updateProvider = F4(
	function (apiClient, id_, fields, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$Company$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Company$Shared$encodeUpdatePractitioner(fields),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Company$companyPath(id_))));
	});
var $author$project$Components$Company$DefaultProvider$updateDefaultProvider = F3(
	function (apiClient, id_, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4($author$project$Api$Provider$Company$updateProvider, apiClient, id_, fields, $author$project$Components$Company$DefaultProvider$CompanyUpdated);
	});
var $author$project$Components$Company$DefaultProvider$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		if (!msg.$) {
			var subMsg = msg.a;
			var practitionerResourceResult = A3($author$project$Components$ResourceFilter$Practitioner$update, apiClient, subMsg, model.hk);
			var _v2 = function () {
				var _v3 = practitionerResourceResult.agZ;
				_v3$2:
				while (true) {
					if (!_v3.$) {
						switch (_v3.a.$) {
							case 0:
								var practitioner = _v3.a.a;
								var newForm = A3(
									$author$project$Utils$Form$update,
									$author$project$Components$Company$DefaultProvider$formFieldsUpdate,
									$elm$core$Maybe$Just(practitioner),
									model.hn);
								var _v4 = A2($author$project$Utils$Form$validate, $author$project$Components$Company$DefaultProvider$formFieldsValidator, newForm);
								if (!_v4.$) {
									var _v5 = _v4.a;
									var validatedForm = _v5.a;
									var validFormFields = _v5.b;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{hn: validatedForm, k9: $author$project$Api$Data$Loading}),
										A3(
											$author$project$Components$Company$DefaultProvider$updateDefaultProvider,
											apiClient,
											$author$project$Api$Provider$Company$One$id(model.afQ),
											validFormFields));
								} else {
									var validatedForm = _v4.a;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{hn: validatedForm, k9: $author$project$Api$Data$NotAsked}),
										$elm$core$Platform$Cmd$none);
								}
							case 2:
								var _v6 = _v3.a;
								var form = A3($author$project$Utils$Form$update, $author$project$Components$Company$DefaultProvider$formFieldsUpdate, $elm$core$Maybe$Nothing, model.hn);
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{hn: form}),
									$elm$core$Platform$Cmd$none);
							default:
								break _v3$2;
						}
					} else {
						break _v3$2;
					}
				}
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}();
			var newModel = _v2.a;
			var cmd = _v2.b;
			return _Utils_Tuple3(
				_Utils_update(
					newModel,
					{hk: practitionerResourceResult.aiO}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$DefaultProvider$PractitionerResourceFilterMsg, practitionerResourceResult.GZ),
							cmd
						])),
				practitionerResourceResult.aR);
		} else {
			var response = msg.a;
			if (response.$ === 3) {
				var company = response.a;
				var formFields = $author$project$Components$Company$DefaultProvider$initFormFields(company);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							afQ: company,
							hn: $author$project$Utils$Form$init(formFields),
							k9: response
						}),
					$elm$core$Platform$Cmd$none,
					_List_fromArray(
						[
							$author$project$OutMsg$RetrieveCompany(
							$author$project$Api$Provider$Company$One$id(model.afQ)),
							A2($author$project$OutMsg$ShowToast, 3, 'Company successfully updated')
						]));
			} else {
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			}
		}
	});
var $author$project$Components$Company$EmployeeDivisions$EmployeeDivisionDeleted = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Components$Company$EmployeeDivisions$EmployeeDivisionAdded = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$EmployeeDivision$Shared$encodeAddDivision = function (fields) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'employee_division',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'name',
							$elm$json$Json$Encode$string(fields.Bq))
						])))
			]));
};
var $author$project$Api$Employer$EmployeeDivision$create = F3(
	function (apiClient, fields, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Employer$EmployeeDivision$All$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$EmployeeDivision$Shared$encodeAddDivision(fields),
				$author$project$Api$Data$requestTo($author$project$Api$Employer$EmployeeDivision$employeeDivisionsPath)));
	});
var $author$project$Api$Provider$Company$EmployeeDivision$create = F4(
	function (apiClient, companyId, fields, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$EmployeeDivision$All$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$EmployeeDivision$Shared$encodeAddDivision(fields),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Company$EmployeeDivision$employeeDivisionsPath(companyId))));
	});
var $author$project$Api$EmployeeDivision$create = F5(
	function (apiClient, session, companyId, fields, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$EmployeeDivision$create,
			apiClient,
			fields,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$EmployeeDivision$All$Employer))) : A4(
			$author$project$Api$Provider$Company$EmployeeDivision$create,
			apiClient,
			companyId,
			fields,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$EmployeeDivision$All$Provider)));
	});
var $author$project$Components$Company$EmployeeDivisions$addEmployeeDivision = F4(
	function (apiClient, session, company, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A5(
			$author$project$Api$EmployeeDivision$create,
			apiClient,
			session,
			$author$project$Api$Company$id(company),
			fields,
			$author$project$Components$Company$EmployeeDivisions$EmployeeDivisionAdded);
	});
var $author$project$Api$Employer$EmployeeDivision$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						[id_]),
					$author$project$Api$Employer$EmployeeDivision$employeeDivisionsPath)));
	});
var $author$project$Api$Provider$Company$EmployeeDivision$delete = F4(
	function (apiClient, companyId, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						[id_]),
					$author$project$Api$Provider$Company$EmployeeDivision$employeeDivisionsPath(companyId))));
	});
var $author$project$Api$EmployeeDivision$delete = F5(
	function (apiClient, session, companyId, id, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$EmployeeDivision$delete, apiClient, id, toMsg) : A4($author$project$Api$Provider$Company$EmployeeDivision$delete, apiClient, companyId, id, toMsg);
	});
var $author$project$Components$Company$EmployeeDivisions$formFieldsUpdate = F2(
	function (field, fields) {
		var string = field;
		return _Utils_update(
			fields,
			{Bq: string});
	});
var $author$project$Components$Company$EmployeeDivisions$NameValidation = 0;
var $author$project$Components$Company$EmployeeDivisions$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.Bq;
			},
			_Utils_Tuple2(0, 'Please enter a division name.'))
		]));
var $author$project$Components$Company$EmployeeDivisions$CompanyUpdated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Company$Shared$encodeUpdateRequireDivisions = function (fields) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'company',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'requires_employee_divisions',
							$elm$json$Json$Encode$bool(fields.$D))
						])))
			]));
};
var $author$project$Api$Employer$Company$updateRequireDivisions = F3(
	function (apiClient, fields, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Employer$Company$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Company$Shared$encodeUpdateRequireDivisions(fields),
				$author$project$Api$Data$requestTo($author$project$Api$Employer$Company$companyPath)));
	});
var $author$project$Api$Provider$Company$updateRequireDivisions = F4(
	function (apiClient, id_, fields, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$Company$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Company$Shared$encodeUpdateRequireDivisions(fields),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Company$companyPath(id_))));
	});
var $author$project$Api$Company$updateRequireDivisions = F5(
	function (apiClient, session, id_, fields, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$Company$updateRequireDivisions,
			apiClient,
			fields,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Company$Employer))) : A4(
			$author$project$Api$Provider$Company$updateRequireDivisions,
			apiClient,
			id_,
			fields,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Company$Provider)));
	});
var $author$project$Components$Company$EmployeeDivisions$updateCompanyRequireDivisions = F4(
	function (apiClient, session, id_, requireDivisions) {
		var fields = {$D: requireDivisions};
		return A5($author$project$Api$Company$updateRequireDivisions, apiClient, session, id_, fields, $author$project$Components$Company$EmployeeDivisions$CompanyUpdated);
	});
var $author$project$Api$Company$Shared$encodeUpdateUsesDivisions = function (fields) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'company',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'uses_employee_divisions',
							$elm$json$Json$Encode$bool(fields.ad5))
						])))
			]));
};
var $author$project$Api$Employer$Company$updateUsesDivisions = F3(
	function (apiClient, fields, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Employer$Company$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Company$Shared$encodeUpdateUsesDivisions(fields),
				$author$project$Api$Data$requestTo($author$project$Api$Employer$Company$companyPath)));
	});
var $author$project$Api$Provider$Company$updateUsesDivisions = F4(
	function (apiClient, id_, fields, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$Company$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Company$Shared$encodeUpdateUsesDivisions(fields),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Company$companyPath(id_))));
	});
var $author$project$Api$Company$updateUsesDivisions = F5(
	function (apiClient, session, id_, fields, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$Company$updateUsesDivisions,
			apiClient,
			fields,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Company$Employer))) : A4(
			$author$project$Api$Provider$Company$updateUsesDivisions,
			apiClient,
			id_,
			fields,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Company$Provider)));
	});
var $author$project$Components$Company$EmployeeDivisions$updateCompanyUsesDivisions = F4(
	function (apiClient, session, id_, usesDivisions) {
		var fields = {ad5: usesDivisions};
		return A5($author$project$Api$Company$updateUsesDivisions, apiClient, session, id_, fields, $author$project$Components$Company$EmployeeDivisions$CompanyUpdated);
	});
var $author$project$Components$Company$EmployeeDivisions$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Company$EmployeeDivisions$formFieldsUpdate, field, model.SD);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: newForm}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var bool = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{$D: bool}),
					A4(
						$author$project$Components$Company$EmployeeDivisions$updateCompanyRequireDivisions,
						apiClient,
						model.aa4,
						$author$project$Api$Company$id(model.afQ),
						bool),
					_List_Nil);
			case 2:
				var bool = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{$D: model.$D && bool, ad5: bool}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A4(
								$author$project$Components$Company$EmployeeDivisions$updateCompanyUsesDivisions,
								apiClient,
								model.aa4,
								$author$project$Api$Company$id(model.afQ),
								bool),
								A3($author$project$Components$Company$EmployeeDivisions$listEmployeeDivisions, apiClient, model.aa4, model.afQ)
							])),
					_List_Nil);
			case 3:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{zr: response}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var _v2 = function () {
					var _v3 = A2($author$project$Utils$Form$validate, $author$project$Components$Company$EmployeeDivisions$formFieldsValidator, model.SD);
					if (!_v3.$) {
						var _v4 = _v3.a;
						var validatedForm = _v4.a;
						var validFormFields = _v4.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{SD: validatedForm, k9: $author$project$Api$Data$Loading}),
							A4($author$project$Components$Company$EmployeeDivisions$addEmployeeDivision, apiClient, model.aa4, model.afQ, validFormFields));
					} else {
						var validatedForm = _v3.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{SD: validatedForm, k9: $author$project$Api$Data$NotAsked}),
							$elm$core$Platform$Cmd$none);
					}
				}();
				var newModel = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple3(newModel, cmd, _List_Nil);
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: response}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								$author$project$OutMsg$RetrieveCompany(
								$author$project$Api$Company$id(model.afQ)),
								A2($author$project$OutMsg$ShowToast, 3, 'Company successfully updated')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 6:
				var division = msg.a;
				return _Utils_Tuple3(
					model,
					A5(
						$author$project$Api$EmployeeDivision$delete,
						apiClient,
						model.aa4,
						$author$project$Api$Company$id(model.afQ),
						$author$project$Api$EmployeeDivision$All$id(division),
						$author$project$Components$Company$EmployeeDivisions$EmployeeDivisionDeleted(division)),
					_List_Nil);
			case 7:
				var division = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							model,
							A3($author$project$Components$Company$EmployeeDivisions$listEmployeeDivisions, apiClient, model.aa4, model.afQ),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$EmployeeDivision$All$name(division) + ' was successfully removed from this company')
								]));
					case 2:
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var response = msg.a;
				var _v7 = $author$project$Components$Company$EmployeeDivisions$initFormFields;
				var formFields = _v7.a;
				var formFieldsCmd = _v7.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									SD: $author$project$Utils$Form$init(formFields)
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A3($author$project$Components$Company$EmployeeDivisions$listEmployeeDivisions, apiClient, model.aa4, model.afQ),
										formFieldsCmd
									])),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, ' A new division was successfully added to this company')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									SD: $author$project$Utils$Form$init(formFields)
								}),
							formFieldsCmd,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Components$Company$Enrollment$AttemptedSave = {$: 1};
var $author$project$Components$Company$Enrollment$BackBillPeriods = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Company$Enrollment$debounceBackBillingPeriod = function (_v0) {
	return A2(
		$elm$core$Task$perform,
		$elm$core$Basics$identity,
		$elm$core$Task$succeed($author$project$Components$Company$Enrollment$AttemptedSave));
};
var $author$project$Components$Company$Enrollment$DebounceMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Company$Enrollment$debounceConfig = {
	alK: $jinjor$elm_debounce$Debounce$later(1000),
	ame: $author$project$Components$Company$Enrollment$DebounceMsg
};
var $author$project$Api$Employer$Company$EnrollmentSetting$backBillPeriods = function (_v0) {
	var record = _v0;
	return record.Mt;
};
var $author$project$Api$Provider$Company$EnrollmentSetting$backBillPeriods = function (_v0) {
	var record = _v0;
	return record.Mt;
};
var $author$project$Api$Company$EnrollmentSetting$backBillPeriods = function (signupSetting) {
	if (!signupSetting.$) {
		var enrollmentSetting_ = signupSetting.a;
		return $author$project$Api$Provider$Company$EnrollmentSetting$backBillPeriods(enrollmentSetting_);
	} else {
		var enrollmentSetting_ = signupSetting.a;
		return $author$project$Api$Employer$Company$EnrollmentSetting$backBillPeriods(enrollmentSetting_);
	}
};
var $author$project$Api$Provider$Company$EnrollmentSetting$employeeInviteNotification = function (_v0) {
	var record = _v0;
	return record.Rm;
};
var $author$project$Api$Company$EnrollmentSetting$employeeInviteNotification = function (signupSetting) {
	if (!signupSetting.$) {
		var enrollmentSetting_ = signupSetting.a;
		return $author$project$Api$Provider$Company$EnrollmentSetting$employeeInviteNotification(enrollmentSetting_);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Employer$Company$EnrollmentSetting$enrollmentCutOffDayOfMonth = function (_v0) {
	var record = _v0;
	return record.RD;
};
var $author$project$Api$Provider$Company$EnrollmentSetting$enrollmentCutOffDayOfMonth = function (_v0) {
	var record = _v0;
	return record.RD;
};
var $author$project$Api$Company$EnrollmentSetting$enrollmentCutOffDayOfMonth = function (signupSetting) {
	if (!signupSetting.$) {
		var enrollmentSetting_ = signupSetting.a;
		return $author$project$Api$Provider$Company$EnrollmentSetting$enrollmentCutOffDayOfMonth(enrollmentSetting_);
	} else {
		var enrollmentSetting_ = signupSetting.a;
		return $author$project$Api$Employer$Company$EnrollmentSetting$enrollmentCutOffDayOfMonth(enrollmentSetting_);
	}
};
var $author$project$Api$Employer$Company$EnrollmentSetting$limitBackBill = function (_v0) {
	var record = _v0;
	return record.V1;
};
var $author$project$Api$Provider$Company$EnrollmentSetting$limitBackBill = function (_v0) {
	var record = _v0;
	return record.V1;
};
var $author$project$Api$Company$EnrollmentSetting$limitBackBill = function (signupSetting) {
	if (!signupSetting.$) {
		var enrollmentSetting_ = signupSetting.a;
		return $author$project$Api$Provider$Company$EnrollmentSetting$limitBackBill(enrollmentSetting_);
	} else {
		var enrollmentSetting_ = signupSetting.a;
		return $author$project$Api$Employer$Company$EnrollmentSetting$limitBackBill(enrollmentSetting_);
	}
};
var $author$project$Api$Employer$Company$EnrollmentSetting$numberDependentsAllowed = function (_v0) {
	var record = _v0;
	return record.X1;
};
var $author$project$Api$Provider$Company$EnrollmentSetting$numberDependentsAllowed = function (_v0) {
	var record = _v0;
	return record.X1;
};
var $author$project$Api$Company$EnrollmentSetting$numberDependentsAllowed = function (signupSetting) {
	if (!signupSetting.$) {
		var enrollmentSetting_ = signupSetting.a;
		return $author$project$Api$Provider$Company$EnrollmentSetting$numberDependentsAllowed(enrollmentSetting_);
	} else {
		var enrollmentSetting_ = signupSetting.a;
		return $author$project$Api$Employer$Company$EnrollmentSetting$numberDependentsAllowed(enrollmentSetting_);
	}
};
var $author$project$Api$Employer$Company$EnrollmentSetting$terminationCutOffDayOfMonth = function (_v0) {
	var record = _v0;
	return record.ac0;
};
var $author$project$Api$Provider$Company$EnrollmentSetting$terminationCutOffDayOfMonth = function (_v0) {
	var record = _v0;
	return record.ac0;
};
var $author$project$Api$Company$EnrollmentSetting$terminationCutOffDayOfMonth = function (signupSetting) {
	if (!signupSetting.$) {
		var enrollmentSetting_ = signupSetting.a;
		return $author$project$Api$Provider$Company$EnrollmentSetting$terminationCutOffDayOfMonth(enrollmentSetting_);
	} else {
		var enrollmentSetting_ = signupSetting.a;
		return $author$project$Api$Employer$Company$EnrollmentSetting$terminationCutOffDayOfMonth(enrollmentSetting_);
	}
};
var $author$project$Api$Employer$Company$EnrollmentSetting$useTerminationCutOffDate = function (_v0) {
	var record = _v0;
	return record.ad_;
};
var $author$project$Api$Provider$Company$EnrollmentSetting$useTerminationCutOffDate = function (_v0) {
	var record = _v0;
	return record.ad_;
};
var $author$project$Api$Company$EnrollmentSetting$useTerminationCutOffDate = function (signupSetting) {
	if (!signupSetting.$) {
		var enrollmentSetting_ = signupSetting.a;
		return $author$project$Api$Provider$Company$EnrollmentSetting$useTerminationCutOffDate(enrollmentSetting_);
	} else {
		var enrollmentSetting_ = signupSetting.a;
		return $author$project$Api$Employer$Company$EnrollmentSetting$useTerminationCutOffDate(enrollmentSetting_);
	}
};
var $author$project$Components$Company$Enrollment$formFieldsInitFromEnrollmentSetting = function (enrollmentSetting) {
	return {
		Mt: $elm$core$String$fromInt(
			$author$project$Api$Company$EnrollmentSetting$backBillPeriods(enrollmentSetting)),
		Rm: A2(
			$elm$core$Maybe$withDefault,
			'practice_default',
			$author$project$Api$Company$EnrollmentSetting$employeeInviteNotification(enrollmentSetting)),
		RD: $author$project$Api$Company$EnrollmentSetting$enrollmentCutOffDayOfMonth(enrollmentSetting),
		V1: $author$project$Api$Company$EnrollmentSetting$limitBackBill(enrollmentSetting),
		X1: $author$project$Api$Company$EnrollmentSetting$numberDependentsAllowed(enrollmentSetting),
		ac0: $author$project$Api$Company$EnrollmentSetting$terminationCutOffDayOfMonth(enrollmentSetting),
		qX: $author$project$Api$Company$EnrollmentSetting$useTerminationCutOffDate(enrollmentSetting)
	};
};
var $author$project$Components$Company$Enrollment$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var bool = field.a;
				return _Utils_update(
					fields,
					{V1: bool});
			case 1:
				var value = field.a;
				return _Utils_update(
					fields,
					{Mt: value});
			case 2:
				var value = field.a;
				return _Utils_update(
					fields,
					{
						X1: A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$String$toInt(value))
					});
			case 3:
				var value = field.a;
				return _Utils_update(
					fields,
					{
						RD: A2(
							$elm$core$Maybe$withDefault,
							1,
							$elm$core$String$toInt(value))
					});
			case 4:
				var bool = field.a;
				return _Utils_update(
					fields,
					{qX: bool});
			case 5:
				var value = field.a;
				return _Utils_update(
					fields,
					{
						ac0: A2(
							$elm$core$Maybe$withDefault,
							1,
							$elm$core$String$toInt(value))
					});
			default:
				var value = field.a;
				return _Utils_update(
					fields,
					{Rm: value});
		}
	});
var $author$project$Components$Company$Enrollment$EnrollmentSettingUpdated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Company$Enrollment$encodeBackBillPeriods = function (backBillPeriods) {
	var _v0 = $elm$core$String$toInt(backBillPeriods);
	if (!_v0.$) {
		var value = _v0.a;
		return _Utils_Tuple2(
			'back_bill_periods',
			$elm$json$Json$Encode$int(value));
	} else {
		return _Utils_Tuple2('back_bill_periods', $elm$json$Json$Encode$null);
	}
};
var $author$project$Components$Company$Enrollment$encodeForm = F2(
	function (form, session) {
		var fields = $author$project$Utils$Form$fields(form);
		var encodedFields = _List_fromArray(
			[
				_Utils_Tuple2(
				'limit_back_bill',
				$elm$json$Json$Encode$bool(fields.V1)),
				$author$project$Components$Company$Enrollment$encodeBackBillPeriods(fields.Mt),
				_Utils_Tuple2(
				'number_dependents_allowed',
				$elm$json$Json$Encode$int(fields.X1)),
				_Utils_Tuple2(
				'enrollment_cutoff_day_of_month',
				$elm$json$Json$Encode$int(fields.RD)),
				_Utils_Tuple2(
				'use_termination_cutoff_date',
				$elm$json$Json$Encode$bool(fields.qX)),
				_Utils_Tuple2(
				'termination_cutoff_day_of_month',
				$elm$json$Json$Encode$int(fields.ac0))
			]);
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? encodedFields : A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				'employee_invite_notification',
				$author$project$Utils$String$encode(fields.Rm)),
			encodedFields);
	});
var $author$project$Api$Company$EnrollmentSetting$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Company$EnrollmentSetting$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$Company$EnrollmentSetting$EnrollmentSetting = $elm$core$Basics$identity;
var $author$project$Api$Employer$Company$EnrollmentSetting$Record = F6(
	function (limitBackBill, backBillPeriods, numberDependentsAllowed, enrollmentCutOffDayOfMonth, useTerminationCutOffDate, terminationCutOffDayOfMonth) {
		return {Mt: backBillPeriods, RD: enrollmentCutOffDayOfMonth, V1: limitBackBill, X1: numberDependentsAllowed, ac0: terminationCutOffDayOfMonth, ad_: useTerminationCutOffDate};
	});
var $author$project$Api$Employer$Company$EnrollmentSetting$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'termination_cutoff_day_of_month',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'use_termination_cutoff_date',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'enrollment_cutoff_day_of_month',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'number_dependents_allowed',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'back_bill_periods',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'limit_back_bill',
						$elm$json$Json$Decode$bool,
						$elm$json$Json$Decode$succeed($author$project$Api$Employer$Company$EnrollmentSetting$Record)))))));
var $author$project$Api$Employer$Company$EnrollmentSetting$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Company$EnrollmentSetting$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Company$EnrollmentSetting$path = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['enrollment_settings']),
	$author$project$Api$Data$employerPath);
var $author$project$Api$Employer$Company$EnrollmentSetting$update = F3(
	function (apiClient, params, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Employer$Company$EnrollmentSetting$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				params,
				$author$project$Api$Data$requestTo($author$project$Api$Employer$Company$EnrollmentSetting$path)));
	});
var $author$project$Api$Provider$Company$EnrollmentSetting$EnrollmentSetting = $elm$core$Basics$identity;
var $author$project$Api$Provider$Company$EnrollmentSetting$Record = F7(
	function (limitBackBill, backBillPeriods, numberDependentsAllowed, enrollmentCutOffDayOfMonth, useTerminationCutOffDate, terminationCutOffDayOfMonth, employeeInviteNotification) {
		return {Mt: backBillPeriods, Rm: employeeInviteNotification, RD: enrollmentCutOffDayOfMonth, V1: limitBackBill, X1: numberDependentsAllowed, ac0: terminationCutOffDayOfMonth, ad_: useTerminationCutOffDate};
	});
var $author$project$Api$Provider$Company$EnrollmentSetting$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'employee_invite_notification',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'termination_cutoff_day_of_month',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'use_termination_cutoff_date',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'enrollment_cutoff_day_of_month',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'number_dependents_allowed',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'back_bill_periods',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'limit_back_bill',
							$elm$json$Json$Decode$bool,
							$elm$json$Json$Decode$succeed($author$project$Api$Provider$Company$EnrollmentSetting$Record))))))));
var $author$project$Api$Provider$Company$EnrollmentSetting$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Company$EnrollmentSetting$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Company$EnrollmentSetting$path = function (companyId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['enrollment_settings']),
		$author$project$Api$Provider$Company$companyPath(companyId));
};
var $author$project$Api$Provider$Company$EnrollmentSetting$update = F4(
	function (apiClient, companyId, params, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$Company$EnrollmentSetting$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				params,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Company$EnrollmentSetting$path(companyId))));
	});
var $author$project$Api$Company$EnrollmentSetting$update = F5(
	function (apiClient, session, id, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'enrollment_settings',
					$elm$json$Json$Encode$object(params))
				]));
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$Company$EnrollmentSetting$update,
			apiClient,
			body,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Company$EnrollmentSetting$Employer))) : A4(
			$author$project$Api$Provider$Company$EnrollmentSetting$update,
			apiClient,
			id,
			body,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Company$EnrollmentSetting$Provider)));
	});
var $author$project$Components$Company$Enrollment$updateEnrollmentSetting = F4(
	function (form, apiClient, session, company) {
		return A5(
			$author$project$Api$Company$EnrollmentSetting$update,
			apiClient,
			session,
			$author$project$Api$Company$id(company),
			A2($author$project$Components$Company$Enrollment$encodeForm, form, session),
			$author$project$Components$Company$Enrollment$EnrollmentSettingUpdated);
	});
var $author$project$Components$Company$Enrollment$BackBillPeriodsValidation = 0;
var $author$project$Components$Company$Enrollment$validateBackBillPeriods = function (_v0) {
	var backBillPeriods = _v0.Mt;
	var _v1 = $elm$core$String$toInt(backBillPeriods);
	if (!_v1.$) {
		return _List_Nil;
	} else {
		return _List_fromArray(
			[
				_Utils_Tuple2(0, 'Please enter a backbilling period.')
			]);
	}
};
var $author$project$Components$Company$Enrollment$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Company$Enrollment$validateBackBillPeriods)
		]));
var $author$project$Components$Company$Enrollment$validateForm = function (enrollmentForm) {
	var _v0 = A2($author$project$Utils$Form$validate, $author$project$Components$Company$Enrollment$formFieldsValidator, enrollmentForm);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var form = _v1.a;
		return _Utils_Tuple2(form, true);
	} else {
		var form = _v0.a;
		return _Utils_Tuple2(form, false);
	}
};
var $author$project$Components$Company$Enrollment$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Company$Enrollment$formFieldsUpdate, field, model.cF);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cF: newForm}),
					A2(
						$elm$core$Task$perform,
						$elm$core$Basics$identity,
						$elm$core$Task$succeed($author$project$Components$Company$Enrollment$AttemptedSave)),
					_List_Nil);
			case 1:
				var _v2 = $author$project$Components$Company$Enrollment$validateForm(model.cF);
				var newForm = _v2.a;
				var isValid = _v2.b;
				return isValid ? _Utils_Tuple3(
					_Utils_update(
						model,
						{cF: newForm, _r: true}),
					A4($author$project$Components$Company$Enrollment$updateEnrollmentSetting, newForm, apiClient, model.aa4, model.afQ),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{cF: newForm}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var value = msg.a;
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Company$Enrollment$formFieldsUpdate,
					$author$project$Components$Company$Enrollment$BackBillPeriods(value),
					model.cF);
				var _v3 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Components$Company$Enrollment$debounceConfig, value, model.i5);
				var debounce = _v3.a;
				var debounceCmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{i5: debounce, cF: newForm}),
					debounceCmd,
					_List_Nil);
			case 3:
				var dMsg = msg.a;
				var _v4 = A4(
					$jinjor$elm_debounce$Debounce$update,
					$author$project$Components$Company$Enrollment$debounceConfig,
					$jinjor$elm_debounce$Debounce$takeLast($author$project$Components$Company$Enrollment$debounceBackBillingPeriod),
					dMsg,
					model.i5);
				var debounce = _v4.a;
				var debounceCmd = _v4.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{i5: debounce}),
					debounceCmd,
					_List_Nil);
			case 4:
				var enrollmentSettingData = msg.a;
				var newModel = _Utils_update(
					model,
					{_r: false});
				if (enrollmentSettingData.$ === 3) {
					var enrollmentSetting = enrollmentSettingData.a;
					return _Utils_Tuple3(
						_Utils_update(
							newModel,
							{
								cF: $author$project$Utils$Form$init(
									$author$project$Components$Company$Enrollment$formFieldsInitFromEnrollmentSetting(enrollmentSetting))
							}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Company successfully updated')
							]));
				} else {
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(enrollmentSettingData));
				}
			default:
				var notificationSettingData = msg.a;
				var newModel = _Utils_update(
					model,
					{X_: notificationSettingData});
				if (notificationSettingData.$ === 2) {
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(notificationSettingData));
				} else {
					return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Components$Company$Plans$CompanyPlanUpdated = function (a) {
	return {$: 20, a: a};
};
var $author$project$Components$Company$Plans$GotPricingDetailsPlan = function (a) {
	return {$: 21, a: a};
};
var $author$project$Components$Company$Plans$NewPlanSelected = function (a) {
	return {$: 12, a: a};
};
var $author$project$Api$CompanyPlan$ProviderOne = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Company$Plans$PlanAdded = function (a) {
	return {$: 14, a: a};
};
var $author$project$Api$Provider$CompanyPlan$create = F4(
	function (apiClient, companyId, planId, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'company_plan',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'plan',
								$author$project$Utils$Encode$association(planId))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CompanyPlan$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$CompanyPlan$companyPlansPath(companyId))));
	});
var $author$project$Components$Company$Plans$createCompanyPlan = F3(
	function (apiClient, company, plan) {
		return A4(
			$author$project$Api$Provider$CompanyPlan$create,
			apiClient,
			$author$project$Api$Company$id(company),
			$author$project$Api$Plan$id(plan),
			$author$project$Components$Company$Plans$PlanAdded);
	});
var $author$project$Components$Company$Plans$defaultBillingFields = {Lv: $elm$core$Maybe$Nothing, P8: $elm$core$Maybe$Nothing, Zs: $elm$core$Maybe$Nothing};
var $author$project$Components$Company$Plans$doesSupportPeriod = F2(
	function (plan, period) {
		return A2(
			$elm$core$List$member,
			period,
			$author$project$Api$Plan$periods(plan));
	});
var $author$project$Api$Employer$CompanyPlan$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Employer$CompanyPlan$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$CompanyPlan$Shared$id(shared);
};
var $author$project$Api$Provider$CompanyPlan$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$CompanyPlan$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyPlan$Shared$id(shared);
};
var $author$project$Api$Provider$CompanyPlan$All$id = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$CompanyPlan$One$id(one);
};
var $author$project$Api$CompanyPlan$id = function (companyPlan) {
	switch (companyPlan.$) {
		case 0:
			var companyPlan_ = companyPlan.a;
			return $author$project$Api$Provider$CompanyPlan$One$id(companyPlan_);
		case 1:
			var companyPlan_ = companyPlan.a;
			return $author$project$Api$Provider$CompanyPlan$All$id(companyPlan_);
		default:
			var companyPlan_ = companyPlan.a;
			return $author$project$Api$Employer$CompanyPlan$All$id(companyPlan_);
	}
};
var $author$project$Api$Plan$coveragePlan = function (plan) {
	switch (plan.$) {
		case 0:
			return $author$project$Api$Expandable$NotExpanded;
		case 1:
			return $author$project$Api$Expandable$NotExpanded;
		case 4:
			return $author$project$Api$Expandable$NotExpanded;
		case 2:
			return $author$project$Api$Expandable$NotExpanded;
		case 6:
			return $author$project$Api$Expandable$NotExpanded;
		case 3:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$One$coveragePlan(plan_);
		default:
			return $author$project$Api$Expandable$NotExpanded;
	}
};
var $author$project$Components$Company$Plans$initCoveragePlanRules = F3(
	function (apiClient, model, plan) {
		var _v0 = A2(
			$author$project$Api$Expandable$withDefault,
			$elm$core$Maybe$Nothing,
			$author$project$Api$Plan$coveragePlan(plan));
		if (!_v0.$) {
			var coveragePlan = _v0.a;
			return A3(
				$elm$core$Tuple$mapBoth,
				$elm$core$Maybe$Just,
				$elm$core$Platform$Cmd$map($author$project$Components$Company$Plans$CoveragePlanMsg),
				A6(
					$author$project$Components$Admin$CoveragePlans$Rules$init,
					apiClient,
					model.aa4,
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$CoveragePlan$One$id(coveragePlan)),
					$author$project$Api$Provider$CoveragePlan$One$coverageRules(coveragePlan),
					$elm$core$Maybe$Nothing,
					{_6: true}));
		} else {
			return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Api$Employer$Company$One$activeMembershipsCount = function (_v0) {
	var record = _v0.b;
	return record.KS;
};
var $author$project$Api$Provider$Company$One$activeMembershipsCount = function (_v0) {
	var record = _v0.b;
	return record.KS;
};
var $author$project$Api$Company$activeMembershipsCount = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$activeMembershipsCount(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$activeMembershipsCount(company_);
	}
};
var $author$project$Components$Company$Plans$hasActiveMemberships = function (company) {
	return $author$project$Api$Company$activeMembershipsCount(company) > 0;
};
var $author$project$Api$Period$retrieveByNumberOfMonths = function (number) {
	return A2(
		$elm_community$list_extra$List$Extra$find,
		function (_v0) {
			var period = _v0;
			return _Utils_eq(period.ku, number);
		},
		$author$project$Api$Period$list);
};
var $author$project$Components$Company$Plans$plansWithoutPeriod = F2(
	function (newBillingPeriod, companyPlans) {
		var maybePeriod = $author$project$Api$Period$retrieveByNumberOfMonths(newBillingPeriod);
		if (!maybePeriod.$) {
			var period = maybePeriod.a;
			return A2(
				$elm$core$List$filter,
				function (plan) {
					return !A2(
						$elm$core$List$member,
						period,
						$author$project$Api$Plan$periods(plan));
				},
				A2($elm$core$List$map, $author$project$Api$CompanyPlan$plan, companyPlans));
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Company$Plans$needsBillingChangeConfirmation = F3(
	function (company, newBillingPeriod, companyPlans) {
		return $author$project$Components$Company$Plans$hasActiveMemberships(company) || ($elm$core$List$length(
			A2($author$project$Components$Company$Plans$plansWithoutPeriod, newBillingPeriod, companyPlans)) > 0);
	});
var $author$project$Api$Employer$Company$Shared$periodInMonths = function (_v0) {
	var record = _v0;
	return record.Zs;
};
var $author$project$Api$Employer$Company$One$periodInMonths = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Company$Shared$periodInMonths(shared);
};
var $author$project$Api$Provider$Company$Shared$periodInMonths = function (_v0) {
	var record = _v0;
	return record.Zs;
};
var $author$project$Api$Provider$Company$One$periodInMonths = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$periodInMonths(shared);
};
var $author$project$Api$Company$periodInMonths = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$periodInMonths(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$periodInMonths(company_);
	}
};
var $author$project$Components$Company$Plans$PlanDeleted = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Api$Provider$CompanyPlan$companyPlanPath = F2(
	function (companyId, companyPlanId) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[companyPlanId]),
			$author$project$Api$Provider$CompanyPlan$companyPlansPath(companyId));
	});
var $author$project$Api$Provider$CompanyPlan$delete = F4(
	function (apiClient, companyId, companyPlanId, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Provider$CompanyPlan$companyPlanPath, companyId, companyPlanId)));
	});
var $author$project$Components$Company$Plans$removeCompanyPlan = F3(
	function (apiClient, company, companyPlan) {
		var companyPlanId = $author$project$Api$CompanyPlan$id(companyPlan);
		return A4(
			$author$project$Api$Provider$CompanyPlan$delete,
			apiClient,
			$author$project$Api$Company$id(company),
			companyPlanId,
			$author$project$Components$Company$Plans$PlanDeleted(companyPlanId));
	});
var $author$project$Components$Company$Plans$resetCompanyPlansOnToggleChange = function (model) {
	var _v0 = _Utils_Tuple2(model.P8, model.gZ);
	if ((!_v0.a.$) && (!_v0.b)) {
		var defaultPlan = _v0.a.a;
		return A2(
			$elm$core$List$filter,
			function (c) {
				return _Utils_eq(
					$author$project$Api$Plan$id(
						$author$project$Api$CompanyPlan$plan(c)),
					$author$project$Api$Plan$id(defaultPlan));
			},
			model.aH);
	} else {
		return model.aH;
	}
};
var $author$project$Components$Company$Plans$showResponseMessage = F2(
	function (response, successMessage) {
		if (response.$ === 3) {
			return _List_fromArray(
				[
					A2($author$project$OutMsg$ShowToast, 3, successMessage)
				]);
		} else {
			return $author$project$OutMsg$handleErrorResponse(response);
		}
	});
var $author$project$Api$Provider$CompanyPlan$update = F5(
	function (apiClient, companyId, companyPlanId, availableForEnrollment_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'company_plan',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'available_for_enrollment',
								$elm$json$Json$Encode$bool(availableForEnrollment_))
							])))
				]));
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$CompanyPlan$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Provider$CompanyPlan$companyPlanPath, companyId, companyPlanId))));
	});
var $author$project$Components$Company$Plans$CompanyUpdated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Company$updateAffiliateBilling = F4(
	function (apiClient, id_, billAffiliateRate, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'company',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'bill_affiliate_rate',
								$elm$json$Json$Encode$bool(billAffiliateRate))
							])))
				]));
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$Company$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Company$companyPath(id_))));
	});
var $author$project$Components$Company$Plans$updateCompanyAffiliateBilling = F3(
	function (apiClient, company, billAffiliateRate) {
		var companyId = $author$project$Api$Company$id(company);
		return A4(
			$author$project$Api$Provider$Company$updateAffiliateBilling,
			apiClient,
			companyId,
			billAffiliateRate,
			A2(
				$elm$core$Basics$composeL,
				$author$project$Components$Company$Plans$CompanyUpdated,
				$author$project$Api$Data$map($author$project$Api$Company$Provider)));
	});
var $author$project$Api$Provider$Company$updateBilling = F6(
	function (apiClient, id_, periodInMonths, allowCustomMembershipPlan, defaultPlanId, toMsg) {
		var defaultPlanAssociation = function (defaultPlanId_) {
			return $elm$core$Maybe$Just(
				{
					ahP: $elm$core$Maybe$Just(defaultPlanId_),
					amg: $elm$core$Maybe$Nothing
				});
		};
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'company',
					$elm$json$Json$Encode$object(
						_Utils_ap(
							A3($author$project$Utils$Encode$optional, 'period_in_months', $elm$json$Json$Encode$int, periodInMonths),
							_Utils_ap(
								A3($author$project$Utils$Encode$optional, 'allow_custom_membership_plan', $elm$json$Json$Encode$bool, allowCustomMembershipPlan),
								A3(
									$author$project$Utils$Encode$optional,
									'default_plan',
									$author$project$Utils$Encode$typedAssociation,
									A2($elm$core$Maybe$andThen, defaultPlanAssociation, defaultPlanId))))))
				]));
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$Company$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Company$companyPath(id_))));
	});
var $author$project$Components$Company$Plans$updateCompanyBilling = F3(
	function (apiClient, company, fields) {
		var defaultPlanId = A2($elm$core$Maybe$map, $author$project$Api$Plan$id, fields.P8);
		var companyId = $author$project$Api$Company$id(company);
		return A6(
			$author$project$Api$Provider$Company$updateBilling,
			apiClient,
			companyId,
			fields.Zs,
			fields.Lv,
			defaultPlanId,
			A2(
				$elm$core$Basics$composeL,
				$author$project$Components$Company$Plans$CompanyUpdated,
				$author$project$Api$Data$map($author$project$Api$Company$Provider)));
	});
var $author$project$Components$Company$Plans$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var text = msg.a;
				var newBillingPeriod = $elm$core$String$toInt(text);
				if (!newBillingPeriod.$) {
					var newBillingPeriod_ = newBillingPeriod.a;
					return A3($author$project$Components$Company$Plans$needsBillingChangeConfirmation, model.afQ, newBillingPeriod_, model.aH) ? _Utils_Tuple3(
						_Utils_update(
							model,
							{b3: newBillingPeriod, p1: false}),
						$elm$core$Platform$Cmd$none,
						_List_Nil) : _Utils_Tuple3(
						_Utils_update(
							model,
							{b3: newBillingPeriod, p1: false}),
						A3(
							$author$project$Components$Company$Plans$updateCompanyBilling,
							apiClient,
							model.afQ,
							_Utils_update(
								$author$project$Components$Company$Plans$defaultBillingFields,
								{Zs: newBillingPeriod})),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{p1: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var enabled = msg.a;
				if (enabled) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{gZ: true}),
						A3(
							$author$project$Components$Company$Plans$updateCompanyBilling,
							apiClient,
							model.afQ,
							_Utils_update(
								$author$project$Components$Company$Plans$defaultBillingFields,
								{
									Lv: $elm$core$Maybe$Just(true)
								})),
						_List_Nil);
				} else {
					if ($elm$core$List$length(model.aH) > 1) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{h9: true}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						var cmds = $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A3(
									$author$project$Components$Company$Plans$updateCompanyBilling,
									apiClient,
									model.afQ,
									_Utils_update(
										$author$project$Components$Company$Plans$defaultBillingFields,
										{
											Lv: $elm$core$Maybe$Just(false)
										})),
									A3($author$project$Components$Company$Plans$listCompanyPlans, apiClient, model.aa4, model.afQ)
								]));
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{gZ: false}),
							cmds,
							_List_Nil);
					}
				}
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					var companyPlans = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{aH: companyPlans}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					var company = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								afQ: company,
								aH: $author$project$Components$Company$Plans$resetCompanyPlansOnToggleChange(model)
							}),
						$elm$core$Platform$Cmd$none,
						A2($author$project$Components$Company$Plans$showResponseMessage, response, 'Company successfully updated'));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 5:
				var confirmed = msg.a;
				if (confirmed) {
					var _v4 = model.b3;
					if (!_v4.$) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{b3: $elm$core$Maybe$Nothing}),
							A3(
								$author$project$Components$Company$Plans$updateCompanyBilling,
								apiClient,
								model.afQ,
								_Utils_update(
									$author$project$Components$Company$Plans$defaultBillingFields,
									{Zs: model.b3})),
							_List_Nil);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{b3: $elm$core$Maybe$Nothing}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{b3: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 8:
				var confirmed = msg.a;
				if (confirmed) {
					var defaultPlanChanged = function (plan) {
						var _v5 = $author$project$Api$Company$defaultPlan(model.afQ);
						if (!_v5.$) {
							var defaultPlan = _v5.a;
							return !_Utils_eq(
								$author$project$Api$Plan$id(plan),
								$author$project$Api$Plan$id(defaultPlan));
						} else {
							return false;
						}
					};
					var newDefaultPlan = A2(
						$elm$core$Maybe$withDefault,
						false,
						A2($elm$core$Maybe$map, defaultPlanChanged, model.P8)) ? model.P8 : $elm$core$Maybe$Nothing;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{r3: false, gZ: false, h9: false}),
						A3(
							$author$project$Components$Company$Plans$updateCompanyBilling,
							apiClient,
							model.afQ,
							{
								Lv: $elm$core$Maybe$Just(false),
								P8: newDefaultPlan,
								Zs: model.b3
							}),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{h9: false}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 6:
				var enabled = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{r3: enabled}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 7:
				var subMsg = msg.a;
				var planResourceResult = A3($author$project$Components$ResourceFilter$Plan$update, apiClient, subMsg, model.hi);
				var _v6 = function () {
					var _v7 = planResourceResult.agZ;
					if (!_v7.$) {
						var _v8 = $author$project$Components$ResourceFilter$Plan$value(planResourceResult.aiO);
						if (!_v8.$) {
							var selectedPlanId = _v8.a;
							return model.dV ? _Utils_Tuple2(
								model,
								A4($author$project$Components$Company$Plans$retrievePlan, apiClient, model.aa4, selectedPlanId, $author$project$Components$Company$Plans$NewPlanSelected)) : _Utils_Tuple2(
								_Utils_update(
									model,
									{h9: true}),
								A4($author$project$Components$Company$Plans$retrievePlan, apiClient, model.aa4, selectedPlanId, $author$project$Components$Company$Plans$GotDefaultPlan));
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				}();
				var modelAfterEvent = _v6.a;
				var resourceEvent = _v6.b;
				return _Utils_Tuple3(
					_Utils_update(
						modelAfterEvent,
						{hi: planResourceResult.aiO}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$Plans$PlanResourceFilterMsg, planResourceResult.GZ),
								resourceEvent
							])),
					planResourceResult.aR);
			case 9:
				var response = msg.a;
				if (response.$ === 3) {
					var plan = response.a;
					var _v10 = A3($author$project$Components$Company$Plans$initCoveragePlanRules, apiClient, model, plan);
					var coveragePlanRules = _v10.a;
					var coveragePlanRulesCmd = _v10.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								OT: coveragePlanRules,
								P8: $elm$core$Maybe$Just(plan)
							}),
						coveragePlanRulesCmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 10:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dV: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 11:
				var maybePlan = msg.a;
				if (!maybePlan.$) {
					var plan = maybePlan.a;
					return _Utils_Tuple3(
						model,
						A3($author$project$Components$Company$Plans$removeCompanyPlan, apiClient, model.afQ, plan),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dV: false, eL: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 12:
				var response = msg.a;
				var maybePeriod = $author$project$Api$Period$retrieveByNumberOfMonths(
					$author$project$Api$Company$periodInMonths(model.afQ));
				var _v12 = _Utils_Tuple2(response, maybePeriod);
				if ((_v12.a.$ === 3) && (!_v12.b.$)) {
					var _v13 = _v12.a;
					var plan = _v13.a;
					var period = _v12.b.a;
					return A2($author$project$Components$Company$Plans$doesSupportPeriod, plan, period) ? _Utils_Tuple3(
						_Utils_update(
							model,
							{dV: false}),
						A3($author$project$Components$Company$Plans$createCompanyPlan, apiClient, model.afQ, plan),
						_List_Nil) : _Utils_Tuple3(
						_Utils_update(
							model,
							{
								eL: $elm$core$Maybe$Just(plan)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 13:
				var companyPlanId = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aH: A2(
									$elm$core$List$filter,
									function (c) {
										return !_Utils_eq(
											$author$project$Api$CompanyPlan$id(c),
											companyPlanId);
									},
									model.aH)
							}),
						$elm$core$Platform$Cmd$none,
						A2($author$project$Components$Company$Plans$showResponseMessage, response, 'The plan was successfully removed from this company'));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 14:
				var response = msg.a;
				var _v15 = A2($author$project$Api$Data$map, $author$project$Api$CompanyPlan$ProviderOne, response);
				if (_v15.$ === 3) {
					var plan = _v15.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aH: A2($elm$core$List$cons, plan, model.aH)
							}),
						$elm$core$Platform$Cmd$none,
						A2($author$project$Components$Company$Plans$showResponseMessage, response, 'The plan was successfully added to this company'));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 15:
				var plan = msg.a;
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A3(
								$author$project$Components$Company$Plans$updateCompanyBilling,
								apiClient,
								model.afQ,
								_Utils_update(
									$author$project$Components$Company$Plans$defaultBillingFields,
									{
										P8: $elm$core$Maybe$Just(plan)
									})),
								A4(
								$author$project$Components$Company$Plans$retrievePlan,
								apiClient,
								model.aa4,
								$author$project$Api$Plan$id(plan),
								$author$project$Components$Company$Plans$GotDefaultPlan)
							])),
					_List_Nil);
			case 16:
				var plan = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{OT: $elm$core$Maybe$Nothing, le: $elm$core$Maybe$Nothing}),
					A4(
						$author$project$Components$Company$Plans$retrievePlan,
						apiClient,
						model.aa4,
						$author$project$Api$Plan$id(plan),
						$author$project$Components$Company$Plans$GotPricingDetailsPlan),
					_List_Nil);
			case 17:
				var companyPlan = msg.a;
				var availableForEnrollment = msg.b;
				return _Utils_Tuple3(
					model,
					A5(
						$author$project$Api$Provider$CompanyPlan$update,
						apiClient,
						$author$project$Api$Company$id(model.afQ),
						$author$project$Api$CompanyPlan$id(companyPlan),
						availableForEnrollment,
						$author$project$Components$Company$Plans$CompanyPlanUpdated),
					_List_Nil);
			case 20:
				var response = msg.a;
				return _Utils_Tuple3(
					model,
					A3($author$project$Components$Company$Plans$listCompanyPlans, apiClient, model.aa4, model.afQ),
					A2($author$project$Components$Company$Plans$showResponseMessage, response, 'The plan was successfully update'));
			case 18:
				var confirmed = msg.a;
				var _v16 = _Utils_Tuple2(confirmed, model.eL);
				if (_v16.a && (!_v16.b.$)) {
					var newPlanRow = _v16.b.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dV: false, eL: $elm$core$Maybe$Nothing}),
						A3($author$project$Components$Company$Plans$createCompanyPlan, apiClient, model.afQ, newPlanRow),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dV: false, eL: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 19:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{le: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 21:
				var response = msg.a;
				if (response.$ === 3) {
					var plan = response.a;
					var _v18 = A3($author$project$Components$Company$Plans$initCoveragePlanRules, apiClient, model, plan);
					var coveragePlanRules = _v18.a;
					var coveragePlanRulesCmd = _v18.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								OT: coveragePlanRules,
								le: $elm$core$Maybe$Just(plan)
							}),
						coveragePlanRulesCmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 22:
				var subMsg = msg.a;
				var _v19 = model.OT;
				if (!_v19.$) {
					var coveragePlan = _v19.a;
					var _v20 = A3($author$project$Components$Admin$CoveragePlans$Rules$update, apiClient, subMsg, coveragePlan);
					var newCoveragePlan = _v20.a;
					var coveragePlanCmd = _v20.b;
					var coveragePlanOutMsgs = _v20.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								OT: $elm$core$Maybe$Just(newCoveragePlan)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$Plans$CoveragePlanMsg, coveragePlanCmd),
						coveragePlanOutMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var billAffiliateRate = msg.a;
				return _Utils_Tuple3(
					model,
					A3($author$project$Components$Company$Plans$updateCompanyAffiliateBilling, apiClient, model.afQ, billAffiliateRate),
					_List_Nil);
		}
	});
var $author$project$Pages$Companies$CompanyId_String$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A3($author$project$Components$Company$ContactForm$update, model.Gv, subMsg, model.iT);
				var newContactForm = _v1.a;
				var contactFormCmd = _v1.b;
				var contactFormOutMsgs = _v1.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{iT: newContactForm}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$ContactFormMsg, contactFormCmd),
					contactFormOutMsgs);
			case 1:
				var subMsg = msg.a;
				var _v2 = model.mX;
				if (!_v2.$) {
					var companyDeals = _v2.a;
					var _v3 = A3($author$project$Components$Company$CommissionDeals$update, model.Gv, subMsg, companyDeals);
					var newCommissionDeals = _v3.a;
					var commissionDealsCmd = _v3.b;
					var commissionDealsOutMsgs = _v3.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								mX: $elm$core$Maybe$Just(newCommissionDeals)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$CommissionDealsMsg, commissionDealsCmd),
						commissionDealsOutMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				var subMsg = msg.a;
				var _v4 = A3($author$project$Components$Company$Plans$update, model.Gv, subMsg, model.aH);
				var newCompanyPlans = _v4.a;
				var companyPlansCmd = _v4.b;
				var companyPlansOutMsgs = _v4.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aH: newCompanyPlans}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$CompanyPlansMsg, companyPlansCmd),
					companyPlansOutMsgs);
			case 3:
				var subMsg = msg.a;
				var _v5 = model.mY;
				if (!_v5.$) {
					var companyAdmins = _v5.a;
					var _v6 = A3($author$project$Components$Company$Admins$update, model.Gv, subMsg, companyAdmins);
					var newCompanyAdmins = _v6.a;
					var companyAdminsCmd = _v6.b;
					var companyAdminsOutMsgs = _v6.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								mY: $elm$core$Maybe$Just(newCompanyAdmins)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$CompanyAdminsMsg, companyAdminsCmd),
						companyAdminsOutMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				var subMsg = msg.a;
				var _v7 = model.i6;
				if (!_v7.$) {
					var defaultProvider = _v7.a;
					var _v8 = A3($author$project$Components$Company$DefaultProvider$update, model.Gv, subMsg, defaultProvider);
					var newProvider = _v8.a;
					var defaultProviderCmd = _v8.b;
					var defaultProviderOutMsgs = _v8.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								i6: $elm$core$Maybe$Just(newProvider)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$DefaultProviderMsg, defaultProviderCmd),
						defaultProviderOutMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				var subMsg = msg.a;
				var _v9 = model.P$;
				if (!_v9.$) {
					var defaultLocation = _v9.a;
					var _v10 = A3($author$project$Components$Company$DefaultLocation$update, model.Gv, subMsg, defaultLocation);
					var newLocation = _v10.a;
					var defaultLocationCmd = _v10.b;
					var defaultLocationOutMsgs = _v10.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								P$: $elm$core$Maybe$Just(newLocation)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$DefaultLocationMsg, defaultLocationCmd),
						defaultLocationOutMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var subMsg = msg.a;
				var _v11 = model.PY;
				if (!_v11.$) {
					var defaultAffiliation = _v11.a;
					var _v12 = A3($author$project$Components$Company$DefaultAffiliation$update, model.Gv, subMsg, defaultAffiliation);
					var newAffiliation = _v12.a;
					var defaultAffiliationCmd = _v12.b;
					var defaultAffiliationOutMsgs = _v12.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								PY: $elm$core$Maybe$Just(newAffiliation)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$DefaultAffiliationMsg, defaultAffiliationCmd),
						defaultAffiliationOutMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var subMsg = msg.a;
				var _v13 = A3($author$project$Components$Company$EmployeeDivisions$update, model.Gv, subMsg, model.zr);
				var newDivision = _v13.a;
				var employeeDivisionsCmd = _v13.b;
				var employeeDivisionsOutMsgs = _v13.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{zr: newDivision}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$EmployeeDivisionsMsg, employeeDivisionsCmd),
					employeeDivisionsOutMsgs);
			case 8:
				var subMsg = msg.a;
				var _v14 = model.nc;
				if (!_v14.$) {
					var deactivateSponsor = _v14.a;
					var _v15 = A3($author$project$Components$Company$DeactivateSponsor$update, model.Gv, subMsg, deactivateSponsor);
					var sponsor = _v15.a;
					var deactivateSponsorCmd = _v15.b;
					var deactivateSponsorOutMsgs = _v15.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								nc: $elm$core$Maybe$Just(sponsor)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$DeactivateSponsorMsg, deactivateSponsorCmd),
						deactivateSponsorOutMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var subMsg = msg.a;
				var _v16 = A3($author$project$Components$Company$Enrollment$update, model.Gv, subMsg, model.nA);
				var enrollmentModel = _v16.a;
				var enrollmentCmd = _v16.b;
				var enrollmentOutMsgs = _v16.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nA: enrollmentModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$EnrollmentMsg, enrollmentCmd),
					enrollmentOutMsgs);
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var company = response.a;
					var _v18 = A4($author$project$Components$Company$EmployeeDivisions$init, model.Gv, company, model.ZV, model.aa4);
					var employeeDivisions = _v18.a;
					var employeeDivisionsCmd = _v18.b;
					var _v19 = function () {
						var _v20 = _Utils_Tuple2(company, model.ZV);
						if ((!_v20.a.$) && (!_v20.b.$)) {
							var company_ = _v20.a.a;
							var practice_ = _v20.b.a;
							return A2(
								$elm$core$Tuple$mapFirst,
								$elm$core$Maybe$Just,
								A3($author$project$Components$Company$DefaultProvider$init, company_, practice_, model.Gv));
						} else {
							return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
						}
					}();
					var defaultProvider = _v19.a;
					var defaultProviderCmd = _v19.b;
					var _v21 = function () {
						var _v22 = _Utils_Tuple2(company, model.ZV);
						if ((!_v22.a.$) && (!_v22.b.$)) {
							var company_ = _v22.a.a;
							var practice_ = _v22.b.a;
							return A2(
								$elm$core$Tuple$mapFirst,
								$elm$core$Maybe$Just,
								A3($author$project$Components$Company$DefaultLocation$init, company_, practice_, model.Gv));
						} else {
							return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
						}
					}();
					var defaultLocation = _v21.a;
					var defaultLocationCmd = _v21.b;
					var _v23 = function () {
						var _v24 = _Utils_Tuple2(company, model.ZV);
						if ((!_v24.a.$) && (!_v24.b.$)) {
							var company_ = _v24.a.a;
							var practice_ = _v24.b.a;
							return A2(
								$elm$core$Tuple$mapFirst,
								$elm$core$Maybe$Just,
								A4($author$project$Components$Company$DefaultAffiliation$init, model.aa4, company_, practice_, model.Gv));
						} else {
							return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
						}
					}();
					var defaultAffiliation = _v23.a;
					var defaultAffiliationCmd = _v23.b;
					var _v25 = A3($author$project$Components$Company$ContactForm$init, company, model.ZV, model.aa4);
					var contactForm = _v25.a;
					var contactFormCmd = _v25.b;
					var _v26 = A4($author$project$Components$Company$Plans$init, model.Gv, company, model.ZV, model.aa4);
					var companyPlans = _v26.a;
					var companyPlansCmd = _v26.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{aH: companyPlans, iT: contactForm, PY: defaultAffiliation, P$: defaultLocation, i6: defaultProvider, zr: employeeDivisions}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$DefaultLocationMsg, defaultLocationCmd),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$DefaultProviderMsg, defaultProviderCmd),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$DefaultAffiliationMsg, defaultAffiliationCmd),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$EmployeeDivisionsMsg, employeeDivisionsCmd),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$ContactFormMsg, contactFormCmd),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$CompanyPlansMsg, companyPlansCmd)
								])),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Permission$disallowForRoles = F2(
	function (session, roles) {
		return A2(
			$elm$core$List$member,
			$author$project$Api$Platform$Session$One$role(session),
			roles);
	});
var $author$project$Components$Company$CommissionDeals$Create = {$: 3};
var $author$project$Components$Company$CommissionDeals$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Company$CommissionDeals$BrokerDealsTableMsg,
				$author$project$Components$BrokerDeal$Table$modal(model.d_)),
				function () {
				var _v0 = model.iX;
				if (!_v0.$) {
					var createModal = _v0.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$Company$CommissionDeals$CreateModalMsg,
						$author$project$Components$BrokerDeal$CreateModal$view(createModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsStart]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$helpBlock]),
						_List_fromArray(
							[
								A2($author$project$Ui$Typography$text, _List_Nil, 'Allocate a share of revenue from the employer to a broker. You can manage broker accounts '),
								A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__Top,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('here')
									])),
								A2($author$project$Ui$Typography$text, _List_Nil, '. '),
								A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('If you need to remove a deal, make sure that it is ended first.')
									]))
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$textRight, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Companies__CompanyId_String__EndedCommissions(
									{
										fZ: $author$project$Api$Provider$Company$One$id(model.afQ)
									}),
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('See Ended Deals')
									])),
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Add broker deal'},
								_List_fromArray(
									[
										$author$project$Ui$Button$onClick($author$project$Components$Company$CommissionDeals$Create),
										$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Add Broker Deal')
									]))
							]))
					])),
				A2(
				$elm$html$Html$map,
				$author$project$Components$Company$CommissionDeals$BrokerDealsTableMsg,
				A2(
					$author$project$Components$BrokerDeal$Table$view,
					_List_fromArray(
						[
							$author$project$Components$BrokerDeal$Table$loading(
							!$author$project$Api$Data$isSuccess(model.MR))
						]),
					model.d_))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Top$viewComissionedDeals = function (model) {
	var _v0 = model.ZV;
	if (!_v0.$) {
		var practice_ = _v0.a;
		var _v1 = _Utils_Tuple3(
			model.mX,
			$author$project$Api$Provider$Practice$One$commissionsEnabled(practice_),
			!A2(
				$author$project$Permission$disallowForRoles,
				model.aa4,
				_List_fromArray(
					['practice_staff_limited'])));
		if (((!_v1.a.$) && _v1.b) && _v1.c) {
			var commissionDeals = _v1.a.a;
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Panel$title(
							_List_fromArray(
								[
									$elm$html$Html$text('Commission Deals')
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Pages$Companies$CompanyId_String$Top$CommissionDealsMsg,
							$author$project$Components$Company$CommissionDeals$view(commissionDeals))
						]))
				]);
		} else {
			return _List_Nil;
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Company$Admins$CancelNewAdmin = {$: 7};
var $author$project$Components$Company$Admins$Email = $elm$core$Basics$identity;
var $author$project$Components$Company$Admins$FormUpdated = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Company$Admins$Invite = {$: 3};
var $author$project$Components$Company$Admins$addingUserRow = function (model) {
	if (model.dW) {
		var fields = $author$project$Utils$Form$fields(model.bR);
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Table$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$cell,
						_List_fromArray(
							[
								$author$project$Ui$Table$cellSpan(3)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$value(fields.Rj),
										$author$project$Ui$Form$Input$placeholder('gsumner@example.com'),
										$author$project$Ui$Form$Input$autofocus(true),
										$author$project$Ui$Form$Input$onInput(
										A2($elm$core$Basics$composeL, $author$project$Components$Company$Admins$FormUpdated, $elm$core$Basics$identity)),
										$author$project$Ui$Form$Input$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 0, model.bR)),
										$author$project$Ui$Form$Input$errors(
										A2($author$project$Utils$Form$validationErrors, 0, model.bR))
									]))
							])),
						A2(
						$author$project$Ui$Table$cell,
						_List_fromArray(
							[
								$author$project$Ui$Table$cellSpan(3)
							]),
						_List_Nil),
						A2(
						$author$project$Ui$Table$cell,
						_List_fromArray(
							[
								$author$project$Ui$Table$cellSpan(3)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$gap2]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Create and invite adminisitrator'},
										_List_fromArray(
											[
												$author$project$Ui$Button$sm,
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$onClick($author$project$Components$Company$Admins$Invite),
												$author$project$Ui$Button$disabled(
												$author$project$Api$Provider$Company$One$isInactive(model.afQ))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Create and Invite')
											])),
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Cancel'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$sm,
												$author$project$Ui$Button$onClick($author$project$Components$Company$Admins$CancelNewAdmin),
												$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cancel')
											]))
									]))
							]))
					]))
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Api$Provider$CompanyAdmin$Shared$user = function (_v0) {
	var record = _v0;
	return record.ad0;
};
var $author$project$Api$Provider$CompanyAdmin$One$user = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyAdmin$Shared$user(shared);
};
var $author$project$Api$Provider$CompanyAdmin$All$user = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$CompanyAdmin$One$user(one);
};
var $author$project$Components$InviteLink$CompanyAdmin = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Company$Admins$Delete = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$CompanyAdmin$Shared$isDestroyable = function (_v0) {
	var record = _v0;
	return record.UN;
};
var $author$project$Api$Provider$CompanyAdmin$One$isDestroyable = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyAdmin$Shared$isDestroyable(shared);
};
var $author$project$Api$Provider$CompanyAdmin$All$isDestroyable = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$CompanyAdmin$One$isDestroyable(one);
};
var $author$project$Components$Company$Admins$deleteLink = F2(
	function (processing, admin) {
		return A3(
			$author$project$Ui$Button$view,
			{mm: 'Remove administrator'},
			_List_fromArray(
				[
					$author$project$Ui$Button$link,
					$author$project$Ui$Button$sm,
					$author$project$Ui$Button$onClick(
					$author$project$Components$Company$Admins$Delete(admin)),
					$author$project$Ui$Button$disabled(
					(!$author$project$Api$Provider$CompanyAdmin$All$isDestroyable(admin)) || processing),
					$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Remove')
				]));
	});
var $author$project$Components$Company$Admins$ReInvite = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Company$Admins$resendInvite = function (admin) {
	return $author$project$Api$Provider$CompanyAdmin$All$invitationPending(admin) ? A3(
		$author$project$Ui$Button$view,
		{mm: 'Resend invite'},
		_List_fromArray(
			[
				$author$project$Ui$Button$link,
				$author$project$Ui$Button$sm,
				$author$project$Ui$Button$onClick(
				$author$project$Components$Company$Admins$ReInvite(admin)),
				$author$project$Ui$Button$icon($author$project$Ui$Icon$repeat)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Resend invite')
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Components$Company$Admins$userActions = F2(
	function (processing, admin) {
		return _List_fromArray(
			[
				$author$project$Components$Company$Admins$resendInvite(admin),
				A2(
				$elm$html$Html$map,
				$author$project$Components$Company$Admins$InviteLinkMsg,
				$author$project$Components$InviteLink$view(
					$author$project$Components$InviteLink$CompanyAdmin(admin))),
				A2($author$project$Components$Company$Admins$deleteLink, processing, admin)
			]);
	});
var $author$project$Components$Company$Admins$viewAdmin = F2(
	function (processing, admin) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(3)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$text,
							_List_Nil,
							$author$project$Api$Provider$CompanyAdmin$All$email(admin))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(3)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$text,
							_List_Nil,
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									$author$project$Api$Provider$User$Shared$name,
									$author$project$Api$Provider$CompanyAdmin$All$user(admin))))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(3)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$gap2, $author$project$Ui$Element$justifyRight]),
							A2($author$project$Components$Company$Admins$userActions, processing, admin))
						]))
				]));
	});
var $author$project$Components$Company$Admins$viewAdminsList = function (model) {
	var _v0 = function () {
		var _v1 = model.rc;
		if (_v1.$ === 3) {
			var admins_ = _v1.a;
			return _Utils_Tuple2(false, admins_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var admins = _v0.b;
	return A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$loading(loading)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Email')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Name')
					])),
				A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
			]),
		_Utils_ap(
			$author$project$Components$Company$Admins$addingUserRow(model),
			A2(
				$elm$core$List$map,
				$author$project$Components$Company$Admins$viewAdmin(model._r),
				admins)),
		_List_Nil);
};
var $author$project$Components$Company$Admins$AddAdminClicked = {$: 6};
var $author$project$Components$Company$Admins$viewNewAdminButton = function (cannotAddUser) {
	return A3(
		$author$project$Ui$Button$view,
		{mm: 'Add new administrator'},
		_List_fromArray(
			[
				$author$project$Ui$Button$onClick($author$project$Components$Company$Admins$AddAdminClicked),
				$author$project$Ui$Button$disabled(cannotAddUser),
				$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('New Administrator')
			]));
};
var $author$project$Components$Company$Admins$view = function (_v0) {
	var model = _v0;
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsStart, $author$project$Ui$Element$mb2]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$helpBlock]),
						_List_fromArray(
							[
								$elm$html$Html$text('These individuals will receive all emails.')
							])),
						$author$project$Components$Company$Admins$viewNewAdminButton(
						model.dW || $author$project$Api$Provider$Company$One$isInactive(model.afQ))
					])),
				$author$project$Components$Company$Admins$viewAdminsList(model)
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Top$viewCompanyAdmins = function (model) {
	var _v0 = model.ZV;
	if (!_v0.$) {
		var _v1 = model.mY;
		if (!_v1.$) {
			var companyAdmins = _v1.a;
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Panel$title(
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($author$project$Api$Practice$sponsorize, model.ZV, 'Company') + ' Administrators')
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Pages$Companies$CompanyId_String$Top$CompanyAdminsMsg,
							$author$project$Components$Company$Admins$view(companyAdmins))
						]))
				]);
		} else {
			return _List_Nil;
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Company$Plans$periodName = function (periodInMonths) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Period$billName,
			$author$project$Api$Period$retrieveByNumberOfMonths(periodInMonths)));
};
var $author$project$Components$Company$Plans$planWithoutPeriodMessage = F2(
	function (period, plan) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Icon$cross(
					_List_fromArray(
						[$author$project$Ui$Icon$danger])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(' The plan ')
						])),
					A2(
					$elm$html$Html$strong,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Plan$name(plan))
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							' does not have ' + ($author$project$Components$Company$Plans$periodName(period) + ' pricing enabled'))
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							' so rates will be calculated based on ' + ($author$project$Components$Company$Plans$periodName(
								$author$project$Api$Plan$defaultPeriodInMonths(plan)) + ' rates.'))
						]))
				]));
	});
var $author$project$Components$Company$Plans$addPlanConfirmModal = function (model) {
	var _v0 = model.eL;
	if (!_v0.$) {
		var newPlanRow = _v0.a;
		var companyPeriod = $author$project$Api$Company$periodInMonths(model.afQ);
		return A2(
			$author$project$Components$HiConfirm$modal,
			$author$project$Components$Company$Plans$HiConfirmPlanAddClosed,
			_List_fromArray(
				[
					$author$project$Components$HiConfirm$customMessage(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Alert$warning,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$Components$Company$Plans$planWithoutPeriodMessage, companyPeriod, newPlanRow)
								]))
						])),
					$author$project$Components$HiConfirm$noun('Plan'),
					$author$project$Components$HiConfirm$verb('Add')
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Company$Plans$allowBillingPeriodChangeModal = function (model) {
	var _v0 = model.b3;
	if (!_v0.$) {
		var newBillingPeriod = _v0.a;
		var plansWithoutPeriod_ = A2($author$project$Components$Company$Plans$plansWithoutPeriod, newBillingPeriod, model.aH);
		var plansMessage = ($elm$core$List$length(plansWithoutPeriod_) > 0) ? A2(
			$author$project$Ui$Alert$warning,
			_List_Nil,
			A2(
				$elm$core$List$map,
				$author$project$Components$Company$Plans$planWithoutPeriodMessage(newBillingPeriod),
				plansWithoutPeriod_)) : $author$project$Utils$Html$empty;
		var membershipsMessage = $author$project$Components$Company$Plans$hasActiveMemberships(model.afQ) ? A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							'This will change ' + (A2(
								$author$project$Formatters$String$pluralize,
								'membership',
								$author$project$Api$Company$activeMembershipsCount(model.afQ)) + (' from billing ' + ($author$project$Components$Company$Plans$periodName(
								$author$project$Api$Company$periodInMonths(model.afQ)) + (' to billing ' + ($author$project$Components$Company$Plans$periodName(newBillingPeriod) + ' on each monthly invoice.'))))))
						])),
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Regenerating the invoice draft may take a few moments.')
						])),
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					A2($elm$html$Html$br, _List_Nil, _List_Nil)
				])) : $author$project$Utils$Html$empty;
		return A2(
			$author$project$Components$HiConfirm$modal,
			$author$project$Components$Company$Plans$HiConfirmBillingPeriodClosed,
			_List_fromArray(
				[
					$author$project$Components$HiConfirm$customMessage(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textLeft]),
							_List_fromArray(
								[membershipsMessage, plansMessage]))
						])),
					$author$project$Components$HiConfirm$noun('Billing Period'),
					$author$project$Components$HiConfirm$verb('Change')
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Company$Plans$viewPricingDetails = F2(
	function (plan, model) {
		return A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$span(10),
							$author$project$Ui$Grid$offset(1)
						]),
					_List_fromArray(
						[
							function () {
							if (!plan.$) {
								var plan_ = plan.a;
								return A3(
									$author$project$Components$Plan$Summary$Pricing$view,
									plan_,
									$elm$core$Maybe$Just(model.ZV),
									$elm$core$Maybe$Just(model.afQ));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						]))
				]));
	});
var $author$project$Components$Company$Plans$allowMultiplePlanChangeModal = function (model) {
	var _v0 = _Utils_Tuple2(model.P8, model.h9);
	if ((!_v0.a.$) && _v0.b) {
		var plan = _v0.a.a;
		var newPricingMessage = A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('New Pricing')
						])),
					A2(
					$elm$html$Html$map,
					$elm$core$Basics$never,
					A2(
						$author$project$Components$Company$Plans$viewPricingDetails,
						$elm$core$Maybe$Just(plan),
						model))
				]));
		var membershipMessage = $author$project$Components$Company$Plans$hasActiveMemberships(model.afQ) ? A2(
			$author$project$Ui$Alert$warning,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					'All memberships in this company will be moved to ' + ($author$project$Api$Plan$name(plan) + ' effective on the current draft invoice.'))
				])) : $author$project$Utils$Html$empty;
		var maybePeriod = $author$project$Api$Period$retrieveByNumberOfMonths(
			$author$project$Api$Company$periodInMonths(model.afQ));
		var planMessage = function () {
			if (!maybePeriod.$) {
				var period = maybePeriod.a;
				return (!A2($author$project$Components$Company$Plans$doesSupportPeriod, plan, period)) ? A2(
					$author$project$Ui$Alert$warning,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Icon$cross(
							_List_fromArray(
								[$author$project$Ui$Icon$danger])),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('The plan ')
								])),
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Plan$name(plan))
								])),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									' does not have ' + ($author$project$Api$Period$billName(period) + (' pricing enabled so rates will be calculated based on ' + ($author$project$Components$Company$Plans$periodName(
										$author$project$Api$Plan$defaultPeriodInMonths(plan)) + ' rates.'))))
								]))
						])) : $author$project$Utils$Html$empty;
			} else {
				return $author$project$Utils$Html$empty;
			}
		}();
		return A2(
			$author$project$Components$HiConfirm$modal,
			$author$project$Components$Company$Plans$HiConfirmPlanChangedClosed,
			_List_fromArray(
				[
					$author$project$Components$HiConfirm$customMessage(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textLeft]),
							_List_fromArray(
								[planMessage, membershipMessage, newPricingMessage]))
						])),
					$author$project$Components$HiConfirm$noun('Pricing'),
					$author$project$Components$HiConfirm$verb('Update')
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Company$Plans$AffiliateBillRateChanged = function (a) {
	return {$: 23, a: a};
};
var $author$project$Components$Company$Plans$billAffiliateRateToggle = function (model) {
	var network = $author$project$Api$Practice$network(model.ZV);
	var ratesFromAffiliate = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2($elm$core$Maybe$map, $author$project$Api$Network$Shared$ratesFromAffiliate, network));
	return ratesFromAffiliate ? A2(
		$author$project$Ui$Grid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$column,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpanSm(2),
								$author$project$Ui$Form$Group$inputSpan(10),
								$author$project$Ui$Form$Group$label('Bill Affiliate Rate')
							]),
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$view(
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$on(
										$author$project$Api$Company$billAffiliateRate(model.afQ)),
										$author$project$Ui$ToggleSwitch$onChange($author$project$Components$Company$Plans$AffiliateBillRateChanged)
									]))
							]))
					]))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Components$Company$Plans$BillingPeriodChanged = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Company$Plans$ShowBillingPeriodSelect = {$: 1};
var $author$project$Components$Company$Plans$billingPeriodOptions = A2(
	$elm$core$List$map,
	function (period) {
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(
				$elm$core$String$fromInt(
					$author$project$Api$Period$numberOfMonths(period))),
			$elm_community$string_extra$String$Extra$toSentenceCase(
				$author$project$Api$Period$billName(period)));
	},
	$author$project$Api$Period$list);
var $author$project$Components$Company$Plans$billingPeriod = function (model) {
	var periodInMonths = $author$project$Api$Company$periodInMonths(model.afQ);
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(2),
				$author$project$Ui$Form$Group$inputSpan(6),
				$author$project$Ui$Form$Group$label('Billed')
			]),
		_List_fromArray(
			[
				model.p1 ? A2(
				$author$project$Ui$Form$Select$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Select$value(
						$elm$core$Maybe$Just(
							$elm$core$String$fromInt(periodInMonths))),
						$author$project$Ui$Form$Select$onChange($author$project$Components$Company$Plans$BillingPeriodChanged)
					]),
				$author$project$Components$Company$Plans$billingPeriodOptions) : A2(
				$author$project$Ui$Form$Static$view,
				_List_fromArray(
					[$author$project$Ui$Form$Static$flex, $author$project$Ui$Form$Static$spaceBetween, $author$project$Ui$Form$Static$itemsCenter]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm_community$string_extra$String$Extra$toSentenceCase(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											$author$project$Api$Period$billName,
											$author$project$Api$Period$retrieveByNumberOfMonths(periodInMonths)))))
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Edit Billing Period'},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$onClick($author$project$Components$Company$Plans$ShowBillingPeriodSelect)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Edit Billing Period')
							]))
					]))
			]));
};
var $author$project$Components$Company$Plans$AttemptMultiplePlanChange = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Company$Plans$multiplePlansToggle = function (model) {
	return A2(
		$author$project$Ui$Grid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$column,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpanSm(2),
								$author$project$Ui$Form$Group$inputSpan(10),
								$author$project$Ui$Form$Group$label('Multiple Plans')
							]),
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$view(
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$on(model.gZ),
										$author$project$Ui$ToggleSwitch$onChange($author$project$Components$Company$Plans$AttemptMultiplePlanChange)
									]))
							]))
					]))
			]));
};
var $author$project$Components$Company$Plans$viewAsPractice = function (practice) {
	if (!practice.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$Company$Plans$pricingSettings = function (model) {
	return $author$project$Components$Company$Plans$viewAsPractice(model.ZV) ? A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Components$Company$Plans$billingPeriod(model),
				$author$project$Components$Company$Plans$billAffiliateRateToggle(model),
				$author$project$Components$Company$Plans$multiplePlansToggle(model)
			])) : $elm$html$Html$text('');
};
var $author$project$Components$Company$Plans$ShowDefaultPlanSelect = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Company$Plans$editSuggestionLink = function (id_) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
		_List_fromArray(
			[
				A2($author$project$Ui$Typography$text, _List_Nil, 'You can edit the plan configuration '),
				A3(
				$author$project$Ui$Link$route,
				$author$project$Spa$Generated$Route$Admin__Plans__Id_String(
					{ahP: id_}),
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('here')
					]))
			]));
};
var $author$project$Components$Company$Plans$viewCoveragePlan = function (model) {
	var _v0 = _Utils_Tuple2(
		model.OT,
		A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Maybe$Nothing,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Expandable$withDefault($elm$core$Maybe$Nothing),
				A2($elm$core$Maybe$map, $author$project$Api$Plan$coveragePlan, model.P8))));
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var coveragePlanRulesModel = _v0.a.a;
		var coveragePlan = _v0.b.a;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$HorizontalRule$view(_List_Nil),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mb4]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('Covered Charge Categories & Items')
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(2),
							$author$project$Ui$Form$Group$inputSpan(6),
							$author$project$Ui$Form$Group$label('Coverage Plan')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Permission$disallowForRoles,
									model.aa4,
									_List_fromArray(
										['practice_manager', 'practice_staff', 'practice_staff_limited', 'practice_staff_limited_and_reports'])) ? A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Provider$CoveragePlan$One$name(coveragePlan))
										])) : A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Admin__CoveragePlans__Id_String(
										{
											ahP: $author$project$Api$Provider$CoveragePlan$One$id(coveragePlan)
										}),
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Provider$CoveragePlan$One$name(coveragePlan))
										]))
								]))
						])),
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					A2(
					$elm$html$Html$map,
					$author$project$Components$Company$Plans$CoveragePlanMsg,
					$author$project$Components$Admin$CoveragePlans$Rules$view(coveragePlanRulesModel))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Company$Plans$showDefaultPlan = function (model) {
	var _v0 = model.P8;
	if (!_v0.$) {
		var defaultPlan = _v0.a;
		return $author$project$Components$Company$Plans$viewAsPractice(model.ZV) ? A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(2),
							$author$project$Ui$Form$Group$inputSpan(6),
							$author$project$Ui$Form$Group$label('Default Plan')
						]),
					_List_fromArray(
						[
							model.r3 ? A2(
							$author$project$Ui$Grid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(10)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$map,
											$author$project$Components$Company$Plans$PlanResourceFilterMsg,
											A2($author$project$Components$ResourceFilter$Plan$view, _List_Nil, model.hi))
										])),
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(2)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$flex, $author$project$Ui$Element$justifyRight]),
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Button$view,
													{mm: 'Cancel'},
													_List_fromArray(
														[
															$author$project$Ui$Button$link,
															$author$project$Ui$Button$onClick(
															$author$project$Components$Company$Plans$ShowDefaultPlanSelect(false))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Cancel')
														]))
												]))
										]))
								])) : A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsStart]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$text,
													_List_Nil,
													$author$project$Api$Plan$name(defaultPlan)),
													$author$project$Components$Company$Plans$editSuggestionLink(
													$author$project$Api$Plan$id(defaultPlan))
												])),
											A3(
											$author$project$Ui$Button$view,
											{mm: 'Change default plan'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick(
													$author$project$Components$Company$Plans$ShowDefaultPlanSelect(true))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Change Default Plan')
												]))
										]))
								]))
						])),
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(10),
									$author$project$Ui$Grid$offset(1)
								]),
							_List_fromArray(
								[
									$author$project$Ui$HorizontalRule$view(_List_Nil)
								]))
						])),
					A2(
					$elm$html$Html$map,
					$elm$core$Basics$never,
					A2($author$project$Components$Company$Plans$viewPricingDetails, model.P8, model)),
					$author$project$Components$Company$Plans$viewCoveragePlan(model)
				])) : A2(
			$elm$html$Html$map,
			$elm$core$Basics$never,
			A2($author$project$Components$Company$Plans$viewPricingDetails, model.P8, model));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Admin$CoverageDocuments$Form$viewAsList = function (coverageDocuments) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (coverageDocument) {
				return A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Components$Admin$CoverageDocuments$Form$viewListItems(coverageDocument)
						]));
			},
			coverageDocuments));
};
var $author$project$Components$Company$Plans$showPricingModal = function (model) {
	var _v0 = model.le;
	if (!_v0.$) {
		var selectedForPricingExpanding = _v0.a;
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$Company$Plans$ClosePricingDetailsModal,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('Plan Pricing')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$elm$core$Basics$never,
							A2(
								$author$project$Components$Company$Plans$viewPricingDetails,
								$elm$core$Maybe$Just(selectedForPricingExpanding),
								model)),
							function () {
							var _v1 = model.OT;
							if (!_v1.$) {
								var modelCoveragePlanRules = _v1.a;
								return A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$labelSpanSm(3),
											$author$project$Ui$Form$Group$inputSpanSm(9),
											$author$project$Ui$Form$Group$label('Coverage Plan')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													function () {
													var coverageDocuments_ = A2(
														$elm$core$Maybe$map,
														$author$project$Api$Provider$CoveragePlan$One$coverageDocuments,
														A2(
															$author$project$Api$Expandable$withDefault,
															$elm$core$Maybe$Nothing,
															$author$project$Api$Plan$coveragePlan(selectedForPricingExpanding)));
													return $author$project$Components$Admin$CoverageDocuments$Form$viewAsList(
														A2($elm$core$Maybe$withDefault, _List_Nil, coverageDocuments_));
												}(),
													A2(
													$elm$html$Html$map,
													$author$project$Components$Company$Plans$CoveragePlanMsg,
													$author$project$Components$Admin$CoveragePlans$Rules$view(modelCoveragePlanRules))
												]))
										]));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Close modal'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Components$Company$Plans$ClosePricingDetailsModal)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Close')
								]))
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Company$Plans$AddPlanClicked = {$: 10};
var $author$project$Components$Company$Plans$RemovePlanClicked = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Company$Plans$removeLink = function (plan) {
	return A3(
		$author$project$Ui$Button$view,
		{mm: 'Remove plan'},
		_List_fromArray(
			[
				$author$project$Ui$Button$link,
				$author$project$Ui$Button$onClick(
				$author$project$Components$Company$Plans$RemovePlanClicked(plan)),
				$author$project$Ui$Button$sm,
				$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Remove')
			]));
};
var $author$project$Components$Company$Plans$addingPlan = function (model) {
	return model.dV ? _List_fromArray(
		[
			A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Components$Company$Plans$PlanResourceFilterMsg,
							A2($author$project$Components$ResourceFilter$Plan$view, _List_Nil, model.hi))
						])),
					A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Components$Company$Plans$removeLink($elm$core$Maybe$Nothing)
						]))
				]))
		]) : _List_Nil;
};
var $author$project$Components$Company$Plans$AvailableForEnrollmentToggleChanged = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$Components$Company$Plans$ShowPricingClicked = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Company$Plans$hiddenForEmployer = F2(
	function (practice, html) {
		return $author$project$Components$Company$Plans$viewAsPractice(practice) ? html : $author$project$Utils$Html$empty;
	});
var $author$project$Components$Company$Plans$MakeDefaultPlanClicked = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Company$Plans$makeDefaultLink = function (plan) {
	return A3(
		$author$project$Ui$Button$view,
		{mm: 'Make default'},
		_List_fromArray(
			[
				$author$project$Ui$Button$link,
				$author$project$Ui$Button$onClick(
				$author$project$Components$Company$Plans$MakeDefaultPlanClicked(plan)),
				$author$project$Ui$Button$sm
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Make Default')
			]));
};
var $author$project$Components$Company$Plans$viewPlan = F3(
	function (maybeDefaultPlan, practice, companyPlan) {
		var plan = $author$project$Api$CompanyPlan$plan(companyPlan);
		var availableForEnrollment = $author$project$Api$CompanyPlan$availableForEnrollment(companyPlan);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Plan$name(plan)),
									$author$project$Utils$Html$noBreakSpace,
									A3(
									$author$project$Ui$Button$view,
									{mm: 'see plan details'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick(
											$author$project$Components$Company$Plans$ShowPricingClicked(plan))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('(see plan details)')
										])),
									A2(
									$author$project$Components$Company$Plans$hiddenForEmployer,
									practice,
									$author$project$Components$Company$Plans$editSuggestionLink(
										$author$project$Api$Plan$id(plan)))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Components$Company$Plans$viewAsPractice(practice) ? $author$project$Ui$ToggleSwitch$view(
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$on(availableForEnrollment),
									$author$project$Ui$ToggleSwitch$onChange(
									$author$project$Components$Company$Plans$AvailableForEnrollmentToggleChanged(companyPlan))
								])) : (availableForEnrollment ? $elm$html$Html$text('Yes') : $elm$html$Html$text('No'))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					function () {
						var _v0 = _Utils_Tuple2(
							maybeDefaultPlan,
							$author$project$Components$Company$Plans$viewAsPractice(practice));
						if ((!_v0.a.$) && _v0.b) {
							var defaultPlan = _v0.a.a;
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$gap2]),
									(!_Utils_eq(
										$author$project$Api$Plan$id(plan),
										$author$project$Api$Plan$id(defaultPlan))) ? _List_fromArray(
										[
											$author$project$Components$Company$Plans$makeDefaultLink(plan),
											$author$project$Components$Company$Plans$removeLink(
											$elm$core$Maybe$Just(companyPlan))
										]) : _List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$helpBlock]),
											'This will be the default for new memberships')
										]))
								]);
						} else {
							return _List_Nil;
						}
					}())
				]));
	});
var $author$project$Components$Company$Plans$viewPlanList = function (model) {
	return A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$loading(
				$elm$core$List$isEmpty(model.aH))
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Name')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Available For Enrollment')
					])),
				$author$project$Components$Company$Plans$viewAsPractice(model.ZV) ? A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$flex, $author$project$Ui$Element$justifyRight]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Add plan'},
								_List_fromArray(
									[
										$author$project$Ui$Button$onClick($author$project$Components$Company$Plans$AddPlanClicked),
										$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Add Plan')
									]))
							]))
					])) : A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
			]),
		_Utils_ap(
			$author$project$Components$Company$Plans$addingPlan(model),
			A2(
				$elm$core$List$map,
				A2($author$project$Components$Company$Plans$viewPlan, model.P8, model.ZV),
				model.aH)),
		_List_Nil);
};
var $author$project$Components$Company$Plans$view = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Components$Company$Plans$allowBillingPeriodChangeModal(model),
				$author$project$Components$Company$Plans$allowMultiplePlanChangeModal(model),
				$author$project$Components$Company$Plans$showPricingModal(model),
				$author$project$Components$Company$Plans$addPlanConfirmModal(model),
				$author$project$Components$Company$Plans$pricingSettings(model),
				(!model.gZ) ? $author$project$Components$Company$Plans$showDefaultPlan(model) : A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mt4]),
				_List_fromArray(
					[
						$author$project$Components$Company$Plans$viewPlanList(model)
					]))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Top$viewCompanyPlans = function (model) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Panel$heading,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Panel$title(
					_List_fromArray(
						[
							$elm$html$Html$text('Employee Pricing')
						]))
				])),
			A2(
			$author$project$Ui$Panel$body,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Pages$Companies$CompanyId_String$Top$CompanyPlansMsg,
					$author$project$Components$Company$Plans$view(model.aH))
				]))
		]);
};
var $author$project$Components$Company$ContactForm$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Company$ContactForm$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Company$ContactForm$Save = {$: 1};
var $author$project$Components$Company$ContactForm$view = function (_v0) {
	var model = _v0;
	var sponsorString = A2($author$project$Api$Practice$sponsorize, model.ZV, 'Employer');
	var loading = _Utils_eq(model.k9, $author$project$Api$Data$Loading);
	var fields = $author$project$Utils$Form$fields(model.SD);
	return A2(
		$author$project$Ui$Form$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$onSubmit($author$project$Components$Company$ContactForm$Save)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpan(2),
						$author$project$Ui$Form$Group$inputSpan(10),
						$author$project$Ui$Form$Group$required(true),
						$author$project$Ui$Form$Group$label(sponsorString + ' Name')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(fields.Bq),
								$author$project$Ui$Form$Input$placeholder(sponsorString),
								$author$project$Ui$Form$Input$autofocus(true),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Components$Company$ContactForm$FormUpdated, $author$project$Components$Company$ContactForm$Name)),
								$author$project$Ui$Form$Input$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 0, model.SD)),
								$author$project$Ui$Form$Input$errors(
								A2($author$project$Utils$Form$validationErrors, 0, model.SD))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpan(2),
						$author$project$Ui$Form$Group$inputSpan(10),
						$author$project$Ui$Form$Group$label('Address')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Components$Company$ContactForm$AddressInputMsg,
						A2($author$project$Components$AddressInput$view, _List_Nil, fields.K2))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Phone'),
						$author$project$Ui$Form$Group$labelSpan(2),
						$author$project$Ui$Form$Group$inputSpan(10)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Components$Company$ContactForm$GotPhoneInputMsg,
						$author$project$Components$PhoneInput$view(fields.Zw))
					])),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$textCenter]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Upate contact information'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$submit,
								$author$project$Ui$Button$loading(loading)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Update')
							]))
					]))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Top$viewContactInformation = function (model) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Panel$heading,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Panel$title(
					_List_fromArray(
						[
							$elm$html$Html$text('Contact Information')
						]))
				])),
			A2(
			$author$project$Ui$Panel$body,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Pages$Companies$CompanyId_String$Top$ContactFormMsg,
					$author$project$Components$Company$ContactForm$view(model.iT))
				]))
		]);
};
var $author$project$Components$Company$DeactivateSponsor$ArchiveClicked = {$: 3};
var $author$project$Components$Company$DeactivateSponsor$UnArchiveClicked = {$: 4};
var $author$project$Components$Company$DeactivateSponsor$viewArchive = F3(
	function (sponsorString, archived, processing) {
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			archived ? _List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Unarchive ' + sponsorString)
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$helpBlock]),
					_List_fromArray(
						[
							$elm$html$Html$text('Unarchiving a sponsor shows them on your main employer list. ')
						])),
					A3(
					$author$project$Ui$Button$view,
					{mm: 'Unarchive sponsor'},
					_List_fromArray(
						[
							$author$project$Ui$Button$danger,
							$author$project$Ui$Button$submit,
							$author$project$Ui$Button$disabled(processing),
							$author$project$Ui$Button$onClick($author$project$Components$Company$DeactivateSponsor$UnArchiveClicked)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Unarchive')
						]))
				]) : _List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Archive ' + sponsorString)
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$helpBlock]),
					_List_fromArray(
						[
							$elm$html$Html$text('Archiving a sponsor simply hides them from your main employer list. ')
						])),
					A3(
					$author$project$Ui$Button$view,
					{mm: 'Archive sponsor'},
					_List_fromArray(
						[
							$author$project$Ui$Button$danger,
							$author$project$Ui$Button$submit,
							$author$project$Ui$Button$disabled(processing),
							$author$project$Ui$Button$onClick($author$project$Components$Company$DeactivateSponsor$ArchiveClicked)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Archive')
						]))
				]));
	});
var $author$project$Components$Company$DeactivateSponsor$HiConfirmOpened = {$: 0};
var $author$project$Components$Company$DeactivateSponsor$viewDeactivate = F2(
	function (sponsorString, processing) {
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mb3]),
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Deactivate ' + sponsorString)
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$helpBlock]),
					_List_fromArray(
						[
							$elm$html$Html$text('Deactivate this sponsor account. This will end all employee memberships and stop billing invoices to this employer. ')
						])),
					A3(
					$author$project$Ui$Button$view,
					{mm: 'Deactivate sponsor'},
					_List_fromArray(
						[
							$author$project$Ui$Button$danger,
							$author$project$Ui$Button$submit,
							$author$project$Ui$Button$disabled(processing),
							$author$project$Ui$Button$onClick($author$project$Components$Company$DeactivateSponsor$HiConfirmOpened)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Deactivate')
						]))
				]));
	});
var $author$project$Components$Company$DeactivateSponsor$ReactivateClicked = {$: 2};
var $author$project$Components$Company$DeactivateSponsor$viewReactivate = F3(
	function (sponsorString, archived, processing) {
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Reactivate ' + sponsorString)
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$helpBlock]),
					_List_fromArray(
						[
							$elm$html$Html$text('This has no immediate effect except to make it possible to enroll and bill for employees again. ')
						])),
					A3(
					$author$project$Ui$Button$view,
					{mm: 'Reactivate sponsor'},
					_List_fromArray(
						[
							$author$project$Ui$Button$primary,
							$author$project$Ui$Button$submit,
							$author$project$Ui$Button$disabled(archived || processing),
							$author$project$Ui$Button$onClick($author$project$Components$Company$DeactivateSponsor$ReactivateClicked)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Reactivate')
						]))
				]));
	});
var $author$project$Components$Company$DeactivateSponsor$view = function (model) {
	var sponsorString = A2($author$project$Formatters$String$sponsorize, model.ZV, 'Employer');
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				model.TU ? A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						A3($author$project$Components$Company$DeactivateSponsor$viewReactivate, sponsorString, model.L_, model._r),
						$author$project$Ui$HorizontalRule$view(_List_Nil),
						A3($author$project$Components$Company$DeactivateSponsor$viewArchive, sponsorString, model.L_, model._r)
					])) : A2($author$project$Components$Company$DeactivateSponsor$viewDeactivate, sponsorString, model._r),
				A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						function () {
						if (model.jQ) {
							var sponsorName = $author$project$Api$Provider$Company$One$name(model.afQ);
							return A2(
								$author$project$Components$HiConfirm$modal,
								$author$project$Components$Company$DeactivateSponsor$HiConfirmClosed,
								_List_fromArray(
									[
										$author$project$Components$HiConfirm$verb('deactivate'),
										$author$project$Components$HiConfirm$noun(sponsorName),
										$author$project$Components$HiConfirm$customMessage(
										_List_fromArray(
											[
												$elm$html$Html$text('You\'re about to deactivate ' + (sponsorName + ' which will cancel their memberships and disable emails and invoicing. This action cannot be undone.'))
											]))
									]));
						} else {
							return $author$project$Utils$Html$empty;
						}
					}()
					]))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Top$viewDeactivateSponsor = function (model) {
	var _v0 = _Utils_Tuple2(model.ZV, model.nc);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var deactivateSponsor = _v0.b.a;
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Pages$Companies$CompanyId_String$Top$DeactivateSponsorMsg,
						$author$project$Components$Company$DeactivateSponsor$view(deactivateSponsor))
					]))
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Company$DefaultAffiliation$view = function (_v0) {
	var model = _v0;
	return $elm$core$List$isEmpty(model.rg) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Default Primary Care Clinic')
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$helpBlock]),
					_List_fromArray(
						[
							$elm$html$Html$text('Choose a default primary care clinic to be assigned to all covered employees.')
						])),
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(7),
									$author$project$Ui$Grid$offsetSm(1)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Components$Company$DefaultAffiliation$AffiliateResourceFilterMsg,
									A2(
										$author$project$Components$ResourceFilter$Affiliate$view,
										_List_fromArray(
											[
												$author$project$Components$ResourceFilter$style(0)
											]),
										model.mh))
								]))
						]))
				])));
};
var $author$project$Pages$Companies$CompanyId_String$Top$viewDefaultAffiliation = function (model) {
	var _v0 = _Utils_Tuple2(model.ZV, model.PY);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var defaultAffiliation = _v0.b.a;
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (html) {
					return _List_fromArray(
						[
							A2(
							$author$project$Ui$Panel$body,
							_List_Nil,
							_List_fromArray(
								[
									A2($elm$html$Html$map, $author$project$Pages$Companies$CompanyId_String$Top$DefaultAffiliationMsg, html)
								]))
						]);
				},
				$author$project$Components$Company$DefaultAffiliation$view(defaultAffiliation)));
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Company$DefaultLocation$view = function (_v0) {
	var model = _v0;
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Typography$headingSm(
				_List_fromArray(
					[
						$elm$html$Html$text('Default Location')
					])),
				A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$helpBlock]),
				_List_fromArray(
					[
						$elm$html$Html$text('Choose a location to be assigned to all covered employees.')
					])),
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanSm(7),
								$author$project$Ui$Grid$offsetSm(1)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$Company$DefaultLocation$LocationResourceFilterMsg,
								A2(
									$author$project$Components$ResourceFilter$Location$view,
									_List_fromArray(
										[
											$author$project$Components$ResourceFilter$style(0)
										]),
									model.os))
							]))
					]))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Top$viewDefaultLocation = function (model) {
	var _v0 = _Utils_Tuple2(model.ZV, model.P$);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var defaultLocation = _v0.b.a;
		return $author$project$Api$Practice$hasLocations(model.ZV) ? _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Pages$Companies$CompanyId_String$Top$DefaultLocationMsg,
						$author$project$Components$Company$DefaultLocation$view(defaultLocation))
					]))
			]) : _List_Nil;
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Company$DefaultProvider$view = function (_v0) {
	var model = _v0;
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Typography$headingSm(
				_List_fromArray(
					[
						$elm$html$Html$text('Default Provider')
					])),
				A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$helpBlock]),
				_List_fromArray(
					[
						$elm$html$Html$text('Choose a provider to be assigned to all covered employees.')
					])),
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanSm(7),
								$author$project$Ui$Grid$offsetSm(1)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$Company$DefaultProvider$PractitionerResourceFilterMsg,
								A2(
									$author$project$Components$ResourceFilter$Practitioner$view,
									_List_fromArray(
										[
											$author$project$Components$ResourceFilter$style(0)
										]),
									model.hk))
							]))
					]))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Top$viewDefaultProvider = function (model) {
	var _v0 = _Utils_Tuple2(model.ZV, model.i6);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var defaultProvider = _v0.b.a;
		return $author$project$Api$Practice$hasPractitioners(model.ZV) ? _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Pages$Companies$CompanyId_String$Top$DefaultProviderMsg,
						$author$project$Components$Company$DefaultProvider$view(defaultProvider))
					]))
			]) : _List_Nil;
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Company$EmployeeDivisions$SelectedRequireDivisions = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Company$EmployeeDivisions$SelectedUsesDivisions = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Company$EmployeeDivisions$CreateDivisionClicked = {$: 5};
var $author$project$Components$Company$EmployeeDivisions$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Company$EmployeeDivisions$Name = $elm$core$Basics$identity;
var $author$project$Api$Employer$Company$Shared$isInactive = function (_v0) {
	var record = _v0;
	return record.TU;
};
var $author$project$Api$Employer$Company$One$isInactive = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Company$Shared$isInactive(shared);
};
var $author$project$Api$Company$isInactive = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$isInactive(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$isInactive(company_);
	}
};
var $author$project$Components$Company$EmployeeDivisions$addingDivision = function (model) {
	var fields = $author$project$Utils$Form$fields(model.SD);
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$span(4)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$group(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(fields.Bq),
											$author$project$Ui$Form$Input$placeholder('Human Resources'),
											$author$project$Ui$Form$Input$autofocus(true),
											$author$project$Ui$Form$Input$onInput(
											A2($elm$core$Basics$composeL, $author$project$Components$Company$EmployeeDivisions$FormUpdated, $elm$core$Basics$identity)),
											$author$project$Ui$Form$Input$invalid(
											A2($author$project$Utils$Form$hasValidationErrors, 0, model.SD)),
											$author$project$Ui$Form$Input$errors(
											A2($author$project$Utils$Form$validationErrors, 0, model.SD))
										])),
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Create division'},
									_List_fromArray(
										[
											$author$project$Ui$Button$onClick($author$project$Components$Company$EmployeeDivisions$CreateDivisionClicked),
											$author$project$Ui$Button$disabled(
											$author$project$Api$Company$isInactive(model.afQ)),
											$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Create Division')
										]))
								]))
						]))
				]))
		]);
};
var $author$project$Api$Employer$EmployeeDivision$All$assignedAccounts = function (_v0) {
	var record = _v0.b;
	return record.L$;
};
var $author$project$Api$Provider$EmployeeDivision$All$assignedAccounts = function (_v0) {
	var record = _v0.b;
	return record.L$;
};
var $author$project$Api$EmployeeDivision$All$assignedAccounts = function (employeeDivision) {
	if (!employeeDivision.$) {
		var employeeDivision_ = employeeDivision.a;
		return $author$project$Api$Provider$EmployeeDivision$All$assignedAccounts(employeeDivision_);
	} else {
		var employeeDivision_ = employeeDivision.a;
		return $author$project$Api$Employer$EmployeeDivision$All$assignedAccounts(employeeDivision_);
	}
};
var $author$project$Components$Company$EmployeeDivisions$Delete = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Company$EmployeeDivisions$deleteDivision = function (division) {
	return A3(
		$author$project$Ui$Button$view,
		{mm: 'Remove division'},
		_List_fromArray(
			[
				$author$project$Ui$Button$link,
				$author$project$Ui$Button$sm,
				$author$project$Ui$Button$onClick(
				$author$project$Components$Company$EmployeeDivisions$Delete(division)),
				$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Remove')
			]));
};
var $author$project$Api$Employer$EmployeeDivision$All$eligibleAccounts = function (_v0) {
	var record = _v0.b;
	return record.Rh;
};
var $author$project$Api$Provider$EmployeeDivision$All$eligibleAccounts = function (_v0) {
	var record = _v0.b;
	return record.Rh;
};
var $author$project$Api$EmployeeDivision$All$eligibleAccounts = function (employeeDivision) {
	if (!employeeDivision.$) {
		var employeeDivision_ = employeeDivision.a;
		return $author$project$Api$Provider$EmployeeDivision$All$eligibleAccounts(employeeDivision_);
	} else {
		var employeeDivision_ = employeeDivision.a;
		return $author$project$Api$Employer$EmployeeDivision$All$eligibleAccounts(employeeDivision_);
	}
};
var $author$project$Api$Employer$EmployeeDivision$All$enrolledAccounts = function (_v0) {
	var record = _v0.b;
	return record.RB;
};
var $author$project$Api$Provider$EmployeeDivision$All$enrolledAccounts = function (_v0) {
	var record = _v0.b;
	return record.RB;
};
var $author$project$Api$EmployeeDivision$All$enrolledAccounts = function (employeeDivision) {
	if (!employeeDivision.$) {
		var employeeDivision_ = employeeDivision.a;
		return $author$project$Api$Provider$EmployeeDivision$All$enrolledAccounts(employeeDivision_);
	} else {
		var employeeDivision_ = employeeDivision.a;
		return $author$project$Api$Employer$EmployeeDivision$All$enrolledAccounts(employeeDivision_);
	}
};
var $author$project$Components$Company$EmployeeDivisions$viewDivision = function (division) {
	return A2(
		$author$project$Ui$Table$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(3)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$text,
						_List_Nil,
						$author$project$Api$EmployeeDivision$All$name(division))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(2)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$text,
						_List_Nil,
						$elm$core$String$fromInt(
							A2(
								$elm$core$Maybe$withDefault,
								0,
								$author$project$Api$EmployeeDivision$All$assignedAccounts(division))))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(2)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$text,
						_List_Nil,
						$elm$core$String$fromInt(
							A2(
								$elm$core$Maybe$withDefault,
								0,
								$author$project$Api$EmployeeDivision$All$eligibleAccounts(division))))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(2)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$text,
						_List_Nil,
						$elm$core$String$fromInt(
							A2(
								$elm$core$Maybe$withDefault,
								0,
								$author$project$Api$EmployeeDivision$All$enrolledAccounts(division))))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(3)
					]),
				_List_fromArray(
					[
						$author$project$Components$Company$EmployeeDivisions$deleteDivision(division)
					]))
			]));
};
var $author$project$Components$Company$EmployeeDivisions$viewDivisionsList = function (model) {
	var _v0 = function () {
		var _v1 = model.zr;
		if (_v1.$ === 3) {
			var employeeDivisions_ = _v1.a;
			return _Utils_Tuple2(false, employeeDivisions_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var employeeDivisions = _v0.b;
	return A2(
		$author$project$Ui$Grid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$column,
				_List_Nil,
				_List_fromArray(
					[
						A4(
						$author$project$Ui$Table$view,
						_List_fromArray(
							[
								$author$project$Ui$Table$loading(loading)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Table$header,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Name')
									])),
								A2(
								$author$project$Ui$Table$header,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Assigned')
									])),
								A2(
								$author$project$Ui$Table$header,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Eligible')
									])),
								A2(
								$author$project$Ui$Table$header,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Enrolled')
									])),
								A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
							]),
						A2($elm$core$List$map, $author$project$Components$Company$EmployeeDivisions$viewDivision, employeeDivisions),
						_List_Nil)
					])),
				A2(
				$author$project$Ui$Grid$column,
				_List_Nil,
				$author$project$Components$Company$EmployeeDivisions$addingDivision(model))
			]));
};
var $author$project$Components$Company$EmployeeDivisions$viewEmployeeDivisions = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$mb3]),
		_List_fromArray(
			[
				$author$project$Ui$Typography$headingSm(
				_List_fromArray(
					[
						$elm$html$Html$text('Employee Divisions')
					])),
				A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$helpBlock]),
				_List_fromArray(
					[
						$elm$html$Html$text('Allows you to set a division on each employee. Invoices and reporting can then be grouped by each division. ')
					])),
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Checkbox$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Checkbox$value(model.ad5),
										$author$project$Ui$Form$Checkbox$onCheck($author$project$Components$Company$EmployeeDivisions$SelectedUsesDivisions)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Use Employee Divisions')
									]))
							]))
					])),
				model.ad5 ? A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanSm(12)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Checkbox$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Checkbox$value(model.$D),
										$author$project$Ui$Form$Checkbox$onCheck($author$project$Components$Company$EmployeeDivisions$SelectedRequireDivisions)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Require a division on each employee ')
									]))
							]))
					])) : $author$project$Utils$Html$empty,
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanSm(12)
							]),
						_List_fromArray(
							[
								model.ad5 ? $author$project$Components$Company$EmployeeDivisions$viewDivisionsList(model) : $author$project$Utils$Html$empty
							]))
					]))
			]));
};
var $author$project$Components$Company$EmployeeDivisions$view = function (_v0) {
	var model = _v0;
	return $author$project$Components$Company$EmployeeDivisions$viewEmployeeDivisions(model);
};
var $author$project$Pages$Companies$CompanyId_String$Top$viewEmployeeDivisions = function (model) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Panel$body,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Pages$Companies$CompanyId_String$Top$EmployeeDivisionsMsg,
					$author$project$Components$Company$EmployeeDivisions$view(model.zr))
				]))
		]);
};
var $author$project$Components$Company$Enrollment$title = $author$project$Ui$Typography$headingSm(
	_List_fromArray(
		[
			$elm$html$Html$text('Enrollment and Termination '),
			A2(
			$author$project$Ui$Typography$span,
			_List_fromArray(
				[$author$project$Ui$Typography$small]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Tooltip$view,
					_List_fromArray(
						[
							$author$project$Ui$Tooltip$placement(3)
						]),
					'Click to Learn More',
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$externalHref,
							'https://support.hint.com/employers/employer-account-setup',
							_List_fromArray(
								[$author$project$Ui$Link$targetBlank]),
							_List_fromArray(
								[
									$author$project$Ui$Icon$help(_List_Nil)
								]))
						]))
				]))
		]));
var $author$project$Components$Company$Enrollment$BackBillingPeriodChanged = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Feature$NonMonthlySponsorBilling = 1;
var $author$project$Ui$Form$Input$withPostAddon = F2(
	function (addonText, options) {
		var optionsRecord = $author$project$Ui$Form$Input$optionsToRecord(options);
		var onInputHandler = $author$project$Ui$Form$Input$optionsToInputHandler(optionsRecord);
		return $elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						$author$project$Ui$Form$Input$viewFeedback(optionsRecord),
						A2(
						$elm$html$Html$input,
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class('form-control'),
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$value(optionsRecord.aee),
								_Utils_ap(
									$author$project$Ui$Form$Input$inputTypeToAttributes(optionsRecord.amg),
									_Utils_ap(optionsRecord.xr, onInputHandler)))),
						_List_Nil),
						$elm$core$String$isEmpty(addonText) ? $elm$html$Html$text('') : $author$project$Ui$Form$Input$addon(
						_List_fromArray(
							[
								$elm$html$Html$text(addonText)
							]))
					]),
					A2($elm$core$List$map, $author$project$Ui$Form$Input$viewErrors, options)
				]));
	});
var $author$project$Components$Company$Enrollment$viewBackBillPeriods = F5(
	function (practice, backBillPeriods, limitBackBill, form, processing) {
		return limitBackBill ? A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(11),
							$author$project$Ui$Grid$offsetSm(1)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$spaceBetween]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$title,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Allowed Backbilling Period')
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$group(
											A2(
												$author$project$Ui$Form$Input$withPostAddon,
												A2($author$project$Api$Practice$featureEnabled, 1, practice) ? 'periods' : 'months',
												_List_fromArray(
													[
														$author$project$Ui$Form$Input$value(backBillPeriods),
														$author$project$Ui$Form$Input$onInput($author$project$Components$Company$Enrollment$BackBillingPeriodChanged),
														$author$project$Ui$Form$Input$invalid(
														A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
														$author$project$Ui$Form$Input$disabled(processing)
													])))
										]))
								]))
						]))
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Components$Company$Enrollment$notificationSettingPracticeValue = function (notificationSetting) {
	if (notificationSetting.$ === 3) {
		var notificationSetting_ = notificationSetting.a;
		return $author$project$Api$Provider$NotificationSetting$One$enabled(notificationSetting_) ? 'On' : 'Off';
	} else {
		return 'Off';
	}
};
var $author$project$Components$Company$Enrollment$EmployeeInviteNotification = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Company$Enrollment$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Company$Enrollment$viewEmployeeInviteButton = F4(
	function (currentValue, buttonValue, label, processing) {
		return A3(
			$author$project$Ui$Button$view,
			{mm: 'Select ' + label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(currentValue, buttonValue)),
					$author$project$Ui$Button$onClick(
					$author$project$Components$Company$Enrollment$FormUpdated(
						$author$project$Components$Company$Enrollment$EmployeeInviteNotification(buttonValue))),
					$author$project$Ui$Button$disabled(processing)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Components$Company$Enrollment$viewEmployeeInviteHelpText = F2(
	function (employeeInviteValue, practiceValue) {
		switch (employeeInviteValue) {
			case 'practice_default':
				return 'Will use the practice setting. Curently set to \'' + (practiceValue + '\'.');
			case 'on':
				return 'Employee invite notification will be sent.';
			default:
				return 'Employee invite notification will not be sent.';
		}
	});
var $author$project$Components$Company$Enrollment$viewEmployeeInvite = F4(
	function (employeeInviteValue, processing, canManageInvitations, notificationSetting) {
		return canManageInvitations ? A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(11),
							$author$project$Ui$Grid$offsetSm(1)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$title,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Send Employee Invite Notification')
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Button$group(
									_List_fromArray(
										[
											A4($author$project$Components$Company$Enrollment$viewEmployeeInviteButton, employeeInviteValue, 'on', 'On', processing),
											A4($author$project$Components$Company$Enrollment$viewEmployeeInviteButton, employeeInviteValue, 'off', 'Off', processing),
											A4($author$project$Components$Company$Enrollment$viewEmployeeInviteButton, employeeInviteValue, 'practice_default', 'Practice Default', processing)
										])),
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$helpBlock]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$author$project$Components$Company$Enrollment$viewEmployeeInviteHelpText,
												employeeInviteValue,
												$author$project$Components$Company$Enrollment$notificationSettingPracticeValue(notificationSetting)))
										]))
								]))
						]))
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Components$Company$Enrollment$EnrollmentCutOffDay = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Form$Select$Class = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Form$Select$class = $author$project$Ui$Form$Select$Class;
var $author$project$Components$Company$Enrollment$cutOffDayOptions = A2(
	$elm$core$List$map,
	$elm$core$String$fromInt,
	A2($elm$core$List$range, 1, 31));
var $author$project$Components$Company$Enrollment$viewEnrollmentCutOffDay = F2(
	function (enrollmentCutOffDayOfMonth, processing) {
		var infoText = '\n            If an employee self enrolls before the cutoff day,\n            they will be enrolled and billed from the 1st of the current month.\n            If they enroll after the cutoff day,\n            their membership will be billed and started on the first of next month.\n            ';
		return A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(11),
							$author$project$Ui$Grid$offsetSm(1)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$title,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Enrollment Cutoff Day')
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$mb2]),
							_List_fromArray(
								[
									$elm$html$Html$text(infoText)
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$Ui$Typography$text, _List_Nil, 'Day of Month '),
									A2(
									$author$project$Ui$Form$Select$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Select$class('select--between-text'),
											$author$project$Ui$Form$Select$inline,
											$author$project$Ui$Form$Select$value(
											$elm$core$Maybe$Just(
												$elm$core$String$fromInt(enrollmentCutOffDayOfMonth))),
											$author$project$Ui$Form$Select$onChange(
											A2($elm$core$Basics$composeL, $author$project$Components$Company$Enrollment$FormUpdated, $author$project$Components$Company$Enrollment$EnrollmentCutOffDay)),
											$author$project$Ui$Form$Select$disabled(processing)
										]),
									A2(
										$elm$core$List$map,
										function (option) {
											return A3(
												$author$project$Ui$Form$Select$option,
												_List_Nil,
												$elm$core$Maybe$Just(option),
												option);
										},
										$author$project$Components$Company$Enrollment$cutOffDayOptions))
								]))
						]))
				]));
	});
var $author$project$Components$Company$Enrollment$LimitBackbill = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Company$Enrollment$viewLimitBackbillToggle = F2(
	function (limitBackBill, processing) {
		return A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(11),
							$author$project$Ui$Grid$offsetSm(1),
							$author$project$Ui$Grid$span(12)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$spaceBetween]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$title,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Limit Backbilling')
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Ui$ToggleSwitch$view(
											_List_fromArray(
												[
													$author$project$Ui$ToggleSwitch$on(limitBackBill),
													$author$project$Ui$ToggleSwitch$onChange(
													A2($elm$core$Basics$composeL, $author$project$Components$Company$Enrollment$FormUpdated, $author$project$Components$Company$Enrollment$LimitBackbill)),
													$author$project$Ui$ToggleSwitch$disabled(processing)
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Company$Enrollment$NumberDependentsAllowed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Company$Enrollment$numberDependentsOptions = A2(
	$elm$core$List$map,
	$elm$core$String$fromInt,
	A2($elm$core$List$range, 0, 10));
var $author$project$Components$Company$Enrollment$viewNumberDependentsAllowed = F2(
	function (numberDependentsAllowed, processing) {
		return A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(11),
							$author$project$Ui$Grid$offsetSm(1)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$title,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Dependent Information')
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$Ui$Typography$text, _List_Nil, 'Employer will pay for up to '),
									A2(
									$author$project$Ui$Form$Select$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Select$class('select--between-text'),
											$author$project$Ui$Form$Select$inline,
											$author$project$Ui$Form$Select$value(
											$elm$core$Maybe$Just(
												$elm$core$String$fromInt(numberDependentsAllowed))),
											$author$project$Ui$Form$Select$onChange(
											A2($elm$core$Basics$composeL, $author$project$Components$Company$Enrollment$FormUpdated, $author$project$Components$Company$Enrollment$NumberDependentsAllowed)),
											$author$project$Ui$Form$Select$disabled(processing)
										]),
									A2(
										$elm$core$List$map,
										function (option) {
											return A3(
												$author$project$Ui$Form$Select$option,
												_List_Nil,
												$elm$core$Maybe$Just(option),
												option);
										},
										$author$project$Components$Company$Enrollment$numberDependentsOptions)),
									A2($author$project$Ui$Typography$text, _List_Nil, ' dependents for each of its employees.')
								]))
						]))
				]));
	});
var $author$project$Components$Company$Enrollment$TerminationCutOffDay = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Company$Enrollment$UseTerminationCutOffDay = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Company$Enrollment$viewTerminationCutOffDay = F3(
	function (useTerminationCutOffDay, terminationCutOffDayOfMonth, processing) {
		var infoText = useTerminationCutOffDay ? '\n              If a patient terminates before the cutoff day, the patient\'s end date\n              will be set to the 1st of the indicated month. If they terminate after\n              the cutoff day, the patient\'s end date will be the 1st of the following month.\n              Memberships with an end date prior to the current month will be ended on the\n              1st of the current month.\n              ' : '\n              Memberships can be ended on any day of the month.\n              Memberships with an end date prior to the current month will be ended \'today\'.\n              ';
		return A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(11),
							$author$project$Ui$Grid$offsetSm(1)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$mb2]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$title,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Termination Cutoff Day')
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Ui$ToggleSwitch$view(
											_List_fromArray(
												[
													$author$project$Ui$ToggleSwitch$on(useTerminationCutOffDay),
													$author$project$Ui$ToggleSwitch$onChange(
													A2($elm$core$Basics$composeL, $author$project$Components$Company$Enrollment$FormUpdated, $author$project$Components$Company$Enrollment$UseTerminationCutOffDay)),
													$author$project$Ui$ToggleSwitch$disabled(processing)
												]))
										]))
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(infoText)
								])),
							useTerminationCutOffDay ? A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$mb2]),
							_List_fromArray(
								[
									A2($author$project$Ui$Typography$text, _List_Nil, 'Day of Month '),
									A2(
									$author$project$Ui$Form$Select$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Select$class('select--between-text'),
											$author$project$Ui$Form$Select$inline,
											$author$project$Ui$Form$Select$value(
											$elm$core$Maybe$Just(
												$elm$core$String$fromInt(terminationCutOffDayOfMonth))),
											$author$project$Ui$Form$Select$onChange(
											A2($elm$core$Basics$composeL, $author$project$Components$Company$Enrollment$FormUpdated, $author$project$Components$Company$Enrollment$TerminationCutOffDay)),
											$author$project$Ui$Form$Select$disabled(processing)
										]),
									A2(
										$elm$core$List$map,
										function (option) {
											return A3(
												$author$project$Ui$Form$Select$option,
												_List_Nil,
												$elm$core$Maybe$Just(option),
												option);
										},
										$author$project$Components$Company$Enrollment$cutOffDayOptions))
								])) : $author$project$Utils$Html$empty
						]))
				]));
	});
var $author$project$Components$Company$Enrollment$viewForm = F5(
	function (practice, form, processing, canManageInvitations, notificationSetting) {
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Components$Company$Enrollment$viewLimitBackbillToggle, fields.V1, processing),
					A5($author$project$Components$Company$Enrollment$viewBackBillPeriods, practice, fields.Mt, fields.V1, form, processing),
					A2($author$project$Components$Company$Enrollment$viewNumberDependentsAllowed, fields.X1, processing),
					A2($author$project$Components$Company$Enrollment$viewEnrollmentCutOffDay, fields.RD, processing),
					A3($author$project$Components$Company$Enrollment$viewTerminationCutOffDay, fields.qX, fields.ac0, processing),
					A4($author$project$Components$Company$Enrollment$viewEmployeeInvite, fields.Rm, processing, canManageInvitations, notificationSetting)
				]));
	});
var $author$project$Components$Company$Enrollment$view = function (_v0) {
	var model = _v0;
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				A5($author$project$Components$Company$Enrollment$viewForm, model.ZV, model.cF, model._r, model.GR, model.X_)
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Top$viewEnrollment = function (model) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Panel$heading,
			_List_Nil,
			_List_fromArray(
				[$author$project$Components$Company$Enrollment$title])),
			A2(
			$author$project$Ui$Panel$body,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Pages$Companies$CompanyId_String$Top$EnrollmentMsg,
					$author$project$Components$Company$Enrollment$view(model.nA))
				]))
		]);
};
var $author$project$Pages$Companies$CompanyId_String$Top$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				$elm$core$List$concat(
					A2(
						$elm$core$List$intersperse,
						_List_fromArray(
							[$author$project$Ui$Panel$hr]),
						A2(
							$elm$core$List$filter,
							A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$List$isEmpty),
							_List_fromArray(
								[
									$author$project$Pages$Companies$CompanyId_String$Top$viewContactInformation(model),
									$author$project$Pages$Companies$CompanyId_String$Top$viewComissionedDeals(model),
									$author$project$Pages$Companies$CompanyId_String$Top$viewCompanyPlans(model),
									$author$project$Pages$Companies$CompanyId_String$Top$viewCompanyAdmins(model),
									$author$project$Pages$Companies$CompanyId_String$Top$viewEnrollment(model),
									$author$project$Pages$Companies$CompanyId_String$Top$viewDefaultProvider(model),
									$author$project$Pages$Companies$CompanyId_String$Top$viewDefaultLocation(model),
									$author$project$Pages$Companies$CompanyId_String$Top$viewDefaultAffiliation(model),
									$author$project$Pages$Companies$CompanyId_String$Top$viewEmployeeDivisions(model),
									$author$project$Pages$Companies$CompanyId_String$Top$viewDeactivateSponsor(model)
								])))))
			]),
		ac9: A2($author$project$Api$Practice$sponsorize, model.ZV, 'Companies') + ' | Account & Pricing'
	};
};
var $author$project$Pages$Companies$CompanyId_String$Top$page = $author$project$Spa$Page$applicationCompanyOrEmployer(
	{ah_: $author$project$Pages$Companies$CompanyId_String$Top$init, aiq: $author$project$Pages$Companies$CompanyId_String$Top$load, k8: $author$project$Pages$Companies$CompanyId_String$Top$save, alO: $author$project$Pages$Companies$CompanyId_String$Top$subscriptions, adT: $author$project$Pages$Companies$CompanyId_String$Top$update, amo: $author$project$Pages$Companies$CompanyId_String$Top$view});
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$GotFeedEnroller = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$GotUploads = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$basePath = function (model) {
	return $author$project$Api$Platform$Session$One$organizationIsCompany(model.aa4) ? $author$project$Api$Data$employerPath : $author$project$Api$Provider$Company$companyPath(model.ahP);
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$fetchParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{ajJ: model.ajJ, akl: model.akl});
	};
};
var $author$project$Api$Upload$All$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Upload$All$fromEmployer = $author$project$Api$Upload$All$Employer;
var $author$project$Api$Upload$All$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Upload$All$fromProvider = $author$project$Api$Upload$All$Provider;
var $author$project$Api$Employer$Upload$All$Upload = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Employer$Upload$All$Record = function (meta) {
	return {W4: meta};
};
var $author$project$Api$Employer$Upload$Meta$Meta = $elm$core$Basics$identity;
var $author$project$Api$Employer$Upload$Meta$Record = function (actions) {
	return {vy: actions};
};
var $author$project$Api$Employer$Upload$Meta$ActionsRecord = F4(
	function (preprocess, process, duplicate, cancel) {
		return {Nl: cancel, QZ: duplicate, _f: preprocess, _p: process};
	});
var $author$project$Api$Employer$Upload$Meta$actionsRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'cancel',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'duplicate',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'process',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'preprocess',
				$elm$json$Json$Decode$bool,
				$elm$json$Json$Decode$succeed($author$project$Api$Employer$Upload$Meta$ActionsRecord)))));
var $author$project$Api$Employer$Upload$Meta$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'actions',
	$author$project$Api$Employer$Upload$Meta$actionsRecordDecoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Employer$Upload$Meta$Record));
var $author$project$Api$Employer$Upload$Meta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Upload$Meta$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Upload$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'meta',
	$author$project$Api$Employer$Upload$Meta$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Employer$Upload$All$Record));
var $author$project$Api$Employer$Upload$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Upload$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Common$Upload$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$Upload$All$Upload)));
var $author$project$Api$Employer$Upload$uploadsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['uploads']),
	$author$project$Api$Data$employerPath);
var $author$project$Api$Employer$Upload$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Employer$Upload$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Common$Upload$ListOptionals$toParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Employer$Upload$uploadsPath)));
	});
var $author$project$Api$Upload$list = F5(
	function (basePath, apiClient, session, optionals, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$Upload$list,
			apiClient,
			optionals,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$Upload$All$fromEmployer)))) : A4(
			$author$project$Api$Provider$Upload$list,
			basePath,
			apiClient,
			optionals,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$Upload$All$fromProvider))));
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$fetchUploads = function (model) {
	return A5(
		$author$project$Api$Upload$list,
		$author$project$Pages$Companies$CompanyId_String$Uploads$Top$basePath(model),
		model.Gv,
		model.aa4,
		$author$project$Pages$Companies$CompanyId_String$Uploads$Top$fetchParams(model),
		$author$project$Pages$Companies$CompanyId_String$Uploads$Top$GotUploads);
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$init = F5(
	function (session, practice, company, shared, _v0) {
		var params = _v0.YL;
		var query = _v0.DE;
		var q = A2($elm$core$Dict$get, 'q', query);
		var model = {
			Gv: shared.Gv,
			c5: $elm$core$Maybe$Nothing,
			mC: false,
			afQ: company,
			di: $elm$core$Maybe$Nothing,
			jL: $author$project$Api$Data$Loading,
			ahP: params.fZ,
			Ij: $author$project$Shared$isHintAdmin(shared),
			ajE: shared.ajE,
			ajJ: $author$project$Api$Pagination$initFromQuery(query),
			ZV: practice,
			kP: $elm$core$Maybe$Nothing,
			po: $author$project$Api$Data$NotAsked,
			akl: q,
			up: $author$project$Ui$SearchInput$init(q),
			aa4: session,
			J7: shared.J7,
			lY: $elm$core$Maybe$Nothing,
			qV: $author$project$Api$Data$Loading
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Pages$Companies$CompanyId_String$Uploads$Top$fetchUploads(model),
						A4($author$project$Api$FeedEnroller$retrieve, shared.Gv, session, params.fZ, $author$project$Pages$Companies$CompanyId_String$Uploads$Top$GotFeedEnroller)
					])));
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					Ij: $author$project$Shared$isHintAdmin(shared),
					ajE: shared.ajE
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$CancelHiConfirmClosed = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$CannotUploadModalClosed = {$: 9};
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$DuplicateHiConfirmClosed = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$ProcessUploadModalMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$UploadModalMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Company$UploadModal$Close = {$: 0};
var $author$project$Components$Company$UploadModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Company$UploadModal$Close);
};
var $author$project$Components$Upload$ProcessUploadModal$Close = {$: 0};
var $author$project$Components$Upload$ProcessUploadModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Upload$ProcessUploadModal$Close);
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Companies$CompanyId_String$Uploads$Top$ProcessUploadModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Upload$ProcessUploadModal$subscriptions, model.kP))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Companies$CompanyId_String$Uploads$Top$UploadModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Company$UploadModal$subscriptions, model.lY))),
				model.mC ? $author$project$Components$Upload$CannotUploadModal$subscribeToEscapeKeyPress($author$project$Pages$Companies$CompanyId_String$Uploads$Top$CannotUploadModalClosed) : $elm$core$Platform$Sub$none,
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Companies$CompanyId_String$Uploads$Top$CancelHiConfirmClosed)),
					model.c5)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Companies$CompanyId_String$Uploads$Top$DuplicateHiConfirmClosed)),
					model.di))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$Canceled = F2(
	function (a, b) {
		return {$: 15, a: a, b: b};
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$Duplicated = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$ExportFileMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$GotProcessingStatus = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$SearchInputMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Employer$Upload$uploadPath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		$author$project$Api$Employer$Upload$uploadsPath);
};
var $author$project$Api$Employer$Upload$cancel = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['cancel']),
					$author$project$Api$Employer$Upload$uploadPath(id))));
	});
var $author$project$Api$Provider$Upload$cancel = F4(
	function (basePath, apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['cancel']),
					A2($author$project$Api$Provider$Upload$uploadPath, basePath, id))));
	});
var $author$project$Api$Upload$cancel = F5(
	function (basePath, apiClient, session, id, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$Upload$cancel, apiClient, id, toMsg) : A4($author$project$Api$Provider$Upload$cancel, basePath, apiClient, id, toMsg);
	});
var $author$project$Api$Employer$Upload$One$Upload = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Employer$Upload$One$Record = function (results) {
	return {$X: results};
};
var $author$project$Api$Employer$Upload$One$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'results',
	$author$project$Api$Common$Upload$Results$decoder,
	_List_Nil,
	$elm$json$Json$Decode$succeed($author$project$Api$Employer$Upload$One$Record));
var $author$project$Api$Employer$Upload$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Upload$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Common$Upload$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$Upload$One$Upload)));
var $author$project$Api$Employer$Upload$duplicate = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Employer$Upload$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['duplicate']),
					$author$project$Api$Employer$Upload$uploadPath(id))));
	});
var $author$project$Api$Provider$Upload$duplicate = F4(
	function (basePath, apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Upload$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['duplicate']),
					A2($author$project$Api$Provider$Upload$uploadPath, basePath, id))));
	});
var $author$project$Api$Upload$One$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Upload$One$fromEmployer = $author$project$Api$Upload$One$Employer;
var $author$project$Api$Upload$One$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Upload$One$fromProvider = $author$project$Api$Upload$One$Provider;
var $author$project$Api$Upload$duplicate = F5(
	function (basePath, apiClient, session, id, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$Upload$duplicate,
			apiClient,
			id,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Upload$One$fromEmployer))) : A4(
			$author$project$Api$Provider$Upload$duplicate,
			basePath,
			apiClient,
			id,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Upload$One$fromProvider)));
	});
var $author$project$Api$Employer$Upload$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$id(shared);
};
var $author$project$Api$Upload$All$id = function (upload) {
	if (!upload.$) {
		var upload_ = upload.a;
		return $author$project$Api$Provider$Upload$All$id(upload_);
	} else {
		var upload_ = upload.a;
		return $author$project$Api$Employer$Upload$All$id(upload_);
	}
};
var $author$project$Components$Company$UploadModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Company$UploadModal$initFormFields = {ahj: $elm$core$Maybe$Nothing};
var $author$project$Components$Company$UploadModal$init = F2(
	function (basePath, session) {
		var fields = $author$project$Components$Company$UploadModal$initFormFields;
		return {
			xx: basePath,
			SD: $author$project$Utils$Form$init(fields),
			k9: $author$project$Api$Data$NotAsked,
			aa4: session
		};
	});
var $author$project$Components$Upload$ProcessUploadModal$init = F3(
	function (basePath, session, id) {
		return {xx: basePath, ahP: id, pn: $author$project$Api$Data$NotAsked, aa4: session};
	});
var $author$project$Api$Common$Upload$ProcessingStatus$isProcessing = function (_v0) {
	var record = _v0;
	return record.U5;
};
var $author$project$Api$Common$Upload$ProcessingStatus$ProcessingStatus = $elm$core$Basics$identity;
var $author$project$Api$Common$Upload$ProcessingStatus$Record = function (isProcessing) {
	return {U5: isProcessing};
};
var $author$project$Api$Common$Upload$ProcessingStatus$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'is_processing',
	$elm$json$Json$Decode$bool,
	$elm$json$Json$Decode$succeed($author$project$Api$Common$Upload$ProcessingStatus$Record));
var $author$project$Api$Common$Upload$ProcessingStatus$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Upload$ProcessingStatus$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Upload$processingStatus = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Common$Upload$ProcessingStatus$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['is_processing']),
					$author$project$Api$Employer$Upload$uploadsPath)));
	});
var $author$project$Api$Provider$Upload$processingStatus = F3(
	function (basePath, apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Common$Upload$ProcessingStatus$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['is_processing']),
					$author$project$Api$Provider$Upload$uploadsPath(basePath))));
	});
var $author$project$Api$Upload$processingStatus = F4(
	function (basePath, apiClient, session, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A2($author$project$Api$Employer$Upload$processingStatus, apiClient, toMsg) : A3($author$project$Api$Provider$Upload$processingStatus, basePath, apiClient, toMsg);
	});
var $author$project$Components$Company$UploadModal$Closed = 0;
var $author$project$Components$Company$UploadModal$File = $elm$core$Basics$identity;
var $author$project$Components$Company$UploadModal$FileValidation = 0;
var $author$project$Components$Company$UploadModal$None = 1;
var $author$project$Components$Company$UploadModal$UploadCreated = 2;
var $author$project$Components$Company$UploadModal$Created = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Employer$FeedEnroller$createUpload = F3(
	function (apiClient, fields, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestMultipartBody,
				function () {
					var _v0 = fields.ahj;
					if (!_v0.$) {
						var file = _v0.a;
						return _List_fromArray(
							[
								A2($elm$http$Http$filePart, 'file', file)
							]);
					} else {
						return _List_Nil;
					}
				}(),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['upload']),
						$author$project$Api$Employer$FeedEnroller$feedEnrollersPath))));
	});
var $author$project$Api$Provider$FeedEnroller$createUpload = F4(
	function (basePath, apiClient, fields, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestMultipartBody,
				function () {
					var _v0 = fields.ahj;
					if (!_v0.$) {
						var file = _v0.a;
						return _List_fromArray(
							[
								A2($elm$http$Http$filePart, 'file', file)
							]);
					} else {
						return _List_Nil;
					}
				}(),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['upload']),
						$author$project$Api$Provider$FeedEnroller$feedEnrollersPath(basePath)))));
	});
var $author$project$Api$FeedEnroller$createUpload = F5(
	function (basePath, apiClient, session, fields, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$FeedEnroller$createUpload, apiClient, fields, toMsg) : A4($author$project$Api$Provider$FeedEnroller$createUpload, basePath, apiClient, fields, toMsg);
	});
var $author$project$Components$Company$UploadModal$createUpload = F4(
	function (basePath, apiClient, session, validFormFields) {
		var _v0 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
		var file = _v0.ahj;
		return A5(
			$author$project$Api$FeedEnroller$createUpload,
			basePath,
			apiClient,
			session,
			{ahj: file},
			$author$project$Components$Company$UploadModal$Created);
	});
var $author$project$Components$Company$UploadModal$formFieldsUpdate = F2(
	function (field, fields) {
		var file = field;
		return _Utils_update(
			fields,
			{ahj: file});
	});
var $author$project$Components$Company$UploadModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.ahj;
			},
			_Utils_Tuple2(0, 'Please select a file.'))
		]));
var $author$project$Components$Company$UploadModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
			case 1:
				var files = msg.a;
				var file = $elm$core$List$head(files);
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Company$UploadModal$formFieldsUpdate, file, model.SD);
				var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$Company$UploadModal$formFieldsValidator, newForm);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var validatedForm = _v3.a;
					var validFormFields = _v3.b;
					return {
						GZ: A4($author$project$Components$Company$UploadModal$createUpload, model.xx, apiClient, model.aa4, validFormFields),
						agZ: 1,
						aiO: _Utils_update(
							model,
							{SD: validatedForm, k9: $author$project$Api$Data$Loading}),
						aR: _List_Nil
					};
				} else {
					var validatedForm = _v2.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 1,
						aiO: _Utils_update(
							model,
							{SD: validatedForm}),
						aR: _List_Nil
					};
				}
			case 2:
				var _v4 = A2($author$project$Utils$Form$validate, $author$project$Components$Company$UploadModal$formFieldsValidator, model.SD);
				if (!_v4.$) {
					var _v5 = _v4.a;
					var newForm = _v5.a;
					var validFormFields = _v5.b;
					return {
						GZ: A4($author$project$Components$Company$UploadModal$createUpload, model.xx, apiClient, model.aa4, validFormFields),
						agZ: 1,
						aiO: _Utils_update(
							model,
							{SD: newForm, k9: $author$project$Api$Data$Loading}),
						aR: _List_Nil
					};
				} else {
					var newForm = _v4.a;
					var errorMsg = A2(
						$elm$core$Maybe$withDefault,
						'',
						$elm$core$List$head(
							A2($author$project$Utils$Form$validationErrors, 0, newForm)));
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 1,
						aiO: _Utils_update(
							model,
							{SD: newForm}),
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 1, errorMsg)
							])
					};
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 2,
						aiO: _Utils_update(
							model,
							{k9: $author$project$Api$Data$NotAsked}),
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'File successfully uploaded.')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 1,
						aiO: _Utils_update(
							model,
							{k9: response}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
		}
	});
var $author$project$Components$Upload$ProcessUploadModal$Closed = 1;
var $author$project$Components$Upload$ProcessUploadModal$None = 0;
var $author$project$Components$Upload$ProcessUploadModal$Processed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Upload$ProcessUploadModal$UploadProcessing = 2;
var $author$project$Api$Employer$Upload$asyncProcess = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['async_process']),
					$author$project$Api$Employer$Upload$uploadPath(id))));
	});
var $author$project$Api$Provider$Upload$asyncProcess = F4(
	function (basePath, apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['async_process']),
					A2($author$project$Api$Provider$Upload$uploadPath, basePath, id))));
	});
var $author$project$Api$Upload$asyncProcess = F5(
	function (basePath, apiClient, session, id_, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$Upload$asyncProcess, apiClient, id_, toMsg) : A4($author$project$Api$Provider$Upload$asyncProcess, basePath, apiClient, id_, toMsg);
	});
var $author$project$Components$Upload$ProcessUploadModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: 1, aiO: model, aR: _List_Nil};
			case 1:
				return {
					GZ: A5($author$project$Api$Upload$asyncProcess, model.xx, apiClient, model.aa4, model.ahP, $author$project$Components$Upload$ProcessUploadModal$Processed),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{pn: $author$project$Api$Data$Loading}),
					aR: _List_Nil
				};
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 2,
						aiO: _Utils_update(
							model,
							{pn: response}),
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'The file will be processed soon.')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{pn: response}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
		}
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('q'),
			model.akl)
		]);
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString(
					$author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__Top(
						{fZ: model.ahP}))
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.ajJ),
				A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams))));
};
var $author$project$Api$Employer$Upload$All$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$status(shared);
};
var $author$project$Api$Provider$Upload$All$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$status(shared);
};
var $author$project$Api$Upload$All$status = function (upload) {
	if (!upload.$) {
		var upload_ = upload.a;
		return $author$project$Api$Provider$Upload$All$status(upload_);
	} else {
		var upload_ = upload.a;
		return $author$project$Api$Employer$Upload$All$status(upload_);
	}
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$uploadFinishedPreprocessing = function (upload) {
	return ($author$project$Api$Upload$All$status(upload) === 5) || ($author$project$Api$Upload$All$status(upload) === 6);
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ),
								qV: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{qV: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{jL: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 2:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Ui$SearchInput$update, subMsg, model.up);
				var searchInput = _v2.a;
				var searchInputCmd = _v2.b;
				var searchInputEvent = _v2.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.akl;
					}
				}();
				var _v3 = function () {
					if (_Utils_eq(q, model.akl)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								ajJ: $author$project$Api$Pagination$reset(model.ajJ),
								akl: q,
								qV: $author$project$Api$Data$Loading
							});
						return _Utils_Tuple2(
							qModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Companies$CompanyId_String$Uploads$Top$fetchUploads(qModel),
										$author$project$Pages$Companies$CompanyId_String$Uploads$Top$updateUrl(qModel)
									])));
					}
				}();
				var newModel = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{up: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Uploads$Top$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
			case 3:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{ajJ: pagination, qV: $author$project$Api$Data$Loading});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Companies$CompanyId_String$Uploads$Top$fetchUploads(newModel),
								$author$project$Pages$Companies$CompanyId_String$Uploads$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 4:
				var uploadModal = A2(
					$author$project$Components$Company$UploadModal$init,
					$author$project$Pages$Companies$CompanyId_String$Uploads$Top$basePath(model),
					model.aa4);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							lY: $elm$core$Maybe$Just(uploadModal)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var subMsg = msg.a;
				var _v5 = model.lY;
				if (!_v5.$) {
					var uploadModal = _v5.a;
					var uploadModalResult = A3($author$project$Components$Company$UploadModal$update, model.Gv, subMsg, uploadModal);
					var _v6 = function () {
						var _v7 = uploadModalResult.agZ;
						switch (_v7) {
							case 0:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.qV, $elm$core$Platform$Cmd$none);
							case 2:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Api$Data$Loading,
									$author$project$Pages$Companies$CompanyId_String$Uploads$Top$fetchUploads(model));
							default:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(uploadModalResult.aiO),
									model.qV,
									$elm$core$Platform$Cmd$none);
						}
					}();
					var uploadModal_ = _v6.a;
					var uploads = _v6.b;
					var cmd = _v6.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{lY: uploadModal_, qV: uploads}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Uploads$Top$UploadModalMsg, uploadModalResult.GZ),
									cmd
								])),
						uploadModalResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var upload = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{po: $author$project$Api$Data$Loading}),
					A4(
						$author$project$Api$Upload$processingStatus,
						$author$project$Pages$Companies$CompanyId_String$Uploads$Top$basePath(model),
						model.Gv,
						model.aa4,
						$author$project$Pages$Companies$CompanyId_String$Uploads$Top$GotProcessingStatus(upload)),
					_List_Nil);
			case 7:
				var upload = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var processingStatus = response.a;
					var _v9 = ((!$author$project$Api$Common$Upload$ProcessingStatus$isProcessing(processingStatus)) || $author$project$Pages$Companies$CompanyId_String$Uploads$Top$uploadFinishedPreprocessing(upload)) ? _Utils_Tuple2(
						$elm$core$Maybe$Just(
							A3(
								$author$project$Components$Upload$ProcessUploadModal$init,
								$author$project$Pages$Companies$CompanyId_String$Uploads$Top$basePath(model),
								model.aa4,
								$author$project$Api$Upload$All$id(upload))),
						false) : _Utils_Tuple2($elm$core$Maybe$Nothing, true);
					var processUploadModal = _v9.a;
					var cannotUploadModal = _v9.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{mC: cannotUploadModal, kP: processUploadModal, po: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{po: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 8:
				var subMsg = msg.a;
				var _v10 = model.kP;
				if (!_v10.$) {
					var processUploadModal = _v10.a;
					var processUploadModalResult = A3($author$project$Components$Upload$ProcessUploadModal$update, model.Gv, subMsg, processUploadModal);
					var _v11 = function () {
						var _v12 = processUploadModalResult.agZ;
						switch (_v12) {
							case 0:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(processUploadModalResult.aiO),
									model.qV,
									$elm$core$Platform$Cmd$none);
							case 1:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.qV, $elm$core$Platform$Cmd$none);
							default:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Api$Data$Loading,
									$author$project$Pages$Companies$CompanyId_String$Uploads$Top$fetchUploads(model));
						}
					}();
					var processUploadModal_ = _v11.a;
					var uploads = _v11.b;
					var cmd = _v11.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{kP: processUploadModal_, qV: uploads}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Uploads$Top$ProcessUploadModalMsg, processUploadModalResult.GZ),
									cmd
								])),
						processUploadModalResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{mC: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 10:
				var upload = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							di: $elm$core$Maybe$Just(
								_Utils_Tuple2(upload, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 11:
				var confirmed = msg.a;
				var _v13 = _Utils_Tuple2(model.di, confirmed);
				if ((!_v13.a.$) && _v13.b) {
					var _v14 = _v13.a.a;
					var upload = _v14.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								di: $elm$core$Maybe$Just(
									_Utils_Tuple2(upload, $author$project$Api$Data$Loading))
							}),
						A5(
							$author$project$Api$Upload$duplicate,
							$author$project$Pages$Companies$CompanyId_String$Uploads$Top$basePath(model),
							model.Gv,
							model.aa4,
							$author$project$Api$Upload$All$id(upload),
							$author$project$Pages$Companies$CompanyId_String$Uploads$Top$Duplicated(upload)),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{di: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 12:
				var upload = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{di: $elm$core$Maybe$Nothing, qV: $author$project$Api$Data$Loading}),
						$author$project$Pages$Companies$CompanyId_String$Uploads$Top$fetchUploads(model),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Upload successfully duplicated.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								di: $elm$core$Maybe$Just(
									_Utils_Tuple2(upload, response))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 13:
				var upload = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							c5: $elm$core$Maybe$Just(
								_Utils_Tuple2(upload, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 14:
				var confirmed = msg.a;
				var _v16 = _Utils_Tuple2(model.c5, confirmed);
				if ((!_v16.a.$) && _v16.b) {
					var _v17 = _v16.a.a;
					var upload = _v17.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								c5: $elm$core$Maybe$Just(
									_Utils_Tuple2(upload, $author$project$Api$Data$Loading))
							}),
						A5(
							$author$project$Api$Upload$cancel,
							$author$project$Pages$Companies$CompanyId_String$Uploads$Top$basePath(model),
							model.Gv,
							model.aa4,
							$author$project$Api$Upload$All$id(upload),
							$author$project$Pages$Companies$CompanyId_String$Uploads$Top$Canceled(upload)),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{c5: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 15:
				var upload = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{c5: $elm$core$Maybe$Nothing, qV: $author$project$Api$Data$Loading}),
						$author$project$Pages$Companies$CompanyId_String$Uploads$Top$fetchUploads(model),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Upload successfully canceled.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								c5: $elm$core$Maybe$Just(
									_Utils_Tuple2(upload, response))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var subMsg = msg.a;
				var _v19 = $author$project$Components$FileLink$update(subMsg);
				var getFileCmdMsg = _v19.a;
				var outMsgs = _v19.b;
				return _Utils_Tuple3(
					model,
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Uploads$Top$ExportFileMsg, getFileCmdMsg),
					outMsgs);
		}
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$PaginationMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$Upload = {$: 4};
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$companyIsChild = function (company) {
	return $author$project$Api$Company$companyType(company) === 1;
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$canUploadFile = A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Pages$Companies$CompanyId_String$Uploads$Top$companyIsChild);
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$companyIsParent = function (company) {
	return $author$project$Api$Company$companyType(company) === 2;
};
var $author$project$Api$Employer$Upload$All$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$name(shared);
};
var $author$project$Api$Upload$All$name = function (upload) {
	if (!upload.$) {
		var upload_ = upload.a;
		return $author$project$Api$Provider$Upload$All$name(upload_);
	} else {
		var upload_ = upload.a;
		return $author$project$Api$Employer$Upload$All$name(upload_);
	}
};
var $author$project$Components$Company$UploadModal$FileUploaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Company$UploadModal$Save = {$: 2};
var $author$project$Components$Company$UploadModal$view = function (_v0) {
	var model = _v0;
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Company$UploadModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Upload File')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$onSubmit($author$project$Components$Company$UploadModal$Save)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('File'),
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(4)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$File$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$File$accept(1),
												$author$project$Ui$Form$File$onInput($author$project$Components$Company$UploadModal$FileUploaded)
											]))
									]))
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Company$UploadModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Upload'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Company$UploadModal$Save),
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$loading(
								_Utils_eq(model.k9, $author$project$Api$Data$Loading))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Upload')
							]))
					]))
			]));
};
var $author$project$Components$Upload$ProcessUploadModal$Process = {$: 1};
var $author$project$Components$Upload$ProcessUploadModal$view = function (model) {
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Upload$ProcessUploadModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Process Upload')
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$span(6)
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Cancel and close modal'},
										_List_fromArray(
											[
												$author$project$Ui$Button$onClick($author$project$Components$Upload$ProcessUploadModal$Close),
												$author$project$Ui$Button$fullWidth(true)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cancel')
											]))
									])),
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$span(6)
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Process upload'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$onClick($author$project$Components$Upload$ProcessUploadModal$Process),
												$author$project$Ui$Button$fullWidth(true),
												$author$project$Ui$Button$loading(
												_Utils_eq(model.pn, $author$project$Api$Data$Loading))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Process Upload')
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'name', true, 'File'),
		A3($author$project$Api$Column$init, 'uploader_type', true, 'Type'),
		A3($author$project$Api$Column$init, 'status', true, 'Status'),
		A3($author$project$Api$Column$init, 'started_at', true, 'Started'),
		A3($author$project$Api$Column$init, 'finished_at', true, 'Finished'),
		A3($author$project$Api$Column$init, 'rows_total', true, 'Total Rows'),
		A3($author$project$Api$Column$init, 'rows_processed_or_ignored', true, 'Processed'),
		A3($author$project$Api$Column$init, 'rows_failed', true, 'Failed'),
		A3($author$project$Api$Column$init, '', false, 'Actions')
	]);
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$Cancel = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$Duplicate = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$Process = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Employer$Upload$Meta$preprocessAction = function (_v0) {
	var meta = _v0;
	return meta.vy._f;
};
var $author$project$Api$Provider$Upload$Meta$preprocessAction = function (_v0) {
	var meta = _v0;
	return meta.vy._f;
};
var $author$project$Api$Upload$Meta$preprocessAction = function (upload) {
	if (!upload.$) {
		var upload_ = upload.a;
		return $author$project$Api$Provider$Upload$Meta$preprocessAction(upload_);
	} else {
		var upload_ = upload.a;
		return $author$project$Api$Employer$Upload$Meta$preprocessAction(upload_);
	}
};
var $author$project$Api$Employer$Upload$Meta$processAction = function (_v0) {
	var meta = _v0;
	return meta.vy._p;
};
var $author$project$Api$Provider$Upload$Meta$processAction = function (_v0) {
	var meta = _v0;
	return meta.vy._p;
};
var $author$project$Api$Upload$Meta$processAction = function (upload) {
	if (!upload.$) {
		var upload_ = upload.a;
		return $author$project$Api$Provider$Upload$Meta$processAction(upload_);
	} else {
		var upload_ = upload.a;
		return $author$project$Api$Employer$Upload$Meta$processAction(upload_);
	}
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$canProcessUpload = function (meta) {
	return $author$project$Api$Upload$Meta$preprocessAction(meta) || $author$project$Api$Upload$Meta$processAction(meta);
};
var $author$project$Api$Employer$Upload$Meta$cancelAction = function (_v0) {
	var meta = _v0;
	return meta.vy.Nl;
};
var $author$project$Api$Provider$Upload$Meta$cancelAction = function (_v0) {
	var meta = _v0;
	return meta.vy.Nl;
};
var $author$project$Api$Upload$Meta$cancelAction = function (upload) {
	if (!upload.$) {
		var upload_ = upload.a;
		return $author$project$Api$Provider$Upload$Meta$cancelAction(upload_);
	} else {
		var upload_ = upload.a;
		return $author$project$Api$Employer$Upload$Meta$cancelAction(upload_);
	}
};
var $author$project$Api$Employer$Upload$Meta$duplicateAction = function (_v0) {
	var meta = _v0;
	return meta.vy.QZ;
};
var $author$project$Api$Provider$Upload$Meta$duplicateAction = function (_v0) {
	var meta = _v0;
	return meta.vy.QZ;
};
var $author$project$Api$Upload$Meta$duplicateAction = function (upload) {
	if (!upload.$) {
		var upload_ = upload.a;
		return $author$project$Api$Provider$Upload$Meta$duplicateAction(upload_);
	} else {
		var upload_ = upload.a;
		return $author$project$Api$Employer$Upload$Meta$duplicateAction(upload_);
	}
};
var $author$project$Api$Upload$uploadPath = F3(
	function (basePath, session, id_) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $author$project$Api$Employer$Upload$uploadPath(id_) : A2($author$project$Api$Provider$Upload$uploadPath, basePath, id_);
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$exportCsvPath = F2(
	function (model, upload) {
		return A4(
			$author$project$Api$Data$downloadUrl,
			model.Gv,
			A3(
				$author$project$Api$Upload$uploadPath,
				$author$project$Pages$Companies$CompanyId_String$Uploads$Top$basePath(model),
				model.aa4,
				$author$project$Api$Upload$All$id(upload)),
			0,
			_List_Nil);
	});
var $author$project$Api$Common$Upload$Shared$rowsFailed = function (_v0) {
	var record = _v0;
	return record.aad;
};
var $author$project$Api$Employer$Upload$All$rowsFailed = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$rowsFailed(shared);
};
var $author$project$Api$Provider$Upload$All$rowsFailed = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$rowsFailed(shared);
};
var $author$project$Api$Upload$All$rowsFailed = function (upload) {
	if (!upload.$) {
		var upload_ = upload.a;
		return $author$project$Api$Provider$Upload$All$rowsFailed(upload_);
	} else {
		var upload_ = upload.a;
		return $author$project$Api$Employer$Upload$All$rowsFailed(upload_);
	}
};
var $author$project$Api$Common$Upload$Shared$rowsSupressed = function (_v0) {
	var record = _v0;
	return record.aag;
};
var $author$project$Api$Employer$Upload$All$rowsSupressed = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$rowsSupressed(shared);
};
var $author$project$Api$Provider$Upload$All$rowsSupressed = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$rowsSupressed(shared);
};
var $author$project$Api$Upload$All$rowsSupressed = function (upload) {
	if (!upload.$) {
		var upload_ = upload.a;
		return $author$project$Api$Provider$Upload$All$rowsSupressed(upload_);
	} else {
		var upload_ = upload.a;
		return $author$project$Api$Employer$Upload$All$rowsSupressed(upload_);
	}
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$failedRowsCountWithoutSupressed = function (upload) {
	return $elm$core$List$maximum(
		_List_fromArray(
			[
				$author$project$Api$Upload$All$rowsFailed(upload) - $author$project$Api$Upload$All$rowsSupressed(upload),
				0
			]));
};
var $author$project$Api$Common$Upload$Shared$finishedAt = function (_v0) {
	var record = _v0;
	return record.Ss;
};
var $author$project$Api$Employer$Upload$All$finishedAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$finishedAt(shared);
};
var $author$project$Api$Provider$Upload$All$finishedAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$finishedAt(shared);
};
var $author$project$Api$Upload$All$finishedAt = function (upload) {
	if (!upload.$) {
		var upload_ = upload.a;
		return $author$project$Api$Provider$Upload$All$finishedAt(upload_);
	} else {
		var upload_ = upload.a;
		return $author$project$Api$Employer$Upload$All$finishedAt(upload_);
	}
};
var $author$project$Ui$Table$limitWidth = $author$project$Ui$Table$LimitWidth;
var $author$project$Api$Upload$Meta$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Upload$Meta$fromEmployer = $author$project$Api$Upload$Meta$Employer;
var $author$project$Api$Upload$Meta$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Upload$Meta$fromProvider = $author$project$Api$Upload$Meta$Provider;
var $author$project$Api$Employer$Upload$All$meta = function (_v0) {
	var record = _v0.b;
	return record.W4;
};
var $author$project$Api$Provider$Upload$All$meta = function (_v0) {
	var record = _v0.b;
	return record.W4;
};
var $author$project$Api$Upload$All$meta = function (upload) {
	if (!upload.$) {
		var upload_ = upload.a;
		return $author$project$Api$Upload$Meta$fromProvider(
			$author$project$Api$Provider$Upload$All$meta(upload_));
	} else {
		var upload_ = upload.a;
		return $author$project$Api$Upload$Meta$fromEmployer(
			$author$project$Api$Employer$Upload$All$meta(upload_));
	}
};
var $author$project$Ui$Table$noWrap = $author$project$Ui$Table$NoWrap;
var $author$project$Api$Employer$Upload$All$rowsProcessedOrIgnored = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$rowsProcessedOrIgnored(shared);
};
var $author$project$Api$Provider$Upload$All$rowsProcessedOrIgnored = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$rowsProcessedOrIgnored(shared);
};
var $author$project$Api$Upload$All$rowsProcessedOrIgnored = function (upload) {
	if (!upload.$) {
		var upload_ = upload.a;
		return $author$project$Api$Provider$Upload$All$rowsProcessedOrIgnored(upload_);
	} else {
		var upload_ = upload.a;
		return $author$project$Api$Employer$Upload$All$rowsProcessedOrIgnored(upload_);
	}
};
var $author$project$Api$Employer$Upload$All$rowsTotal = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$rowsTotal(shared);
};
var $author$project$Api$Provider$Upload$All$rowsTotal = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$rowsTotal(shared);
};
var $author$project$Api$Upload$All$rowsTotal = function (upload) {
	if (!upload.$) {
		var upload_ = upload.a;
		return $author$project$Api$Provider$Upload$All$rowsTotal(upload_);
	} else {
		var upload_ = upload.a;
		return $author$project$Api$Employer$Upload$All$rowsTotal(upload_);
	}
};
var $author$project$Api$Common$Upload$Shared$startedAt = function (_v0) {
	var record = _v0;
	return record.aca;
};
var $author$project$Api$Employer$Upload$All$startedAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$startedAt(shared);
};
var $author$project$Api$Provider$Upload$All$startedAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$startedAt(shared);
};
var $author$project$Api$Upload$All$startedAt = function (upload) {
	if (!upload.$) {
		var upload_ = upload.a;
		return $author$project$Api$Provider$Upload$All$startedAt(upload_);
	} else {
		var upload_ = upload.a;
		return $author$project$Api$Employer$Upload$All$startedAt(upload_);
	}
};
var $author$project$Api$Upload$Status$toString = function (status) {
	switch (status) {
		case 0:
			return 'unattempted';
		case 1:
			return 'downloading';
		case 2:
			return 'enqueued_for_preprocessing';
		case 3:
			return 'ready_to_preprocess';
		case 4:
			return 'preprocessing';
		case 5:
			return 'review_data_matches';
		case 6:
			return 'review_file_size';
		case 7:
			return 'enqueued_for_processing';
		case 8:
			return 'ready_to_process';
		case 9:
			return 'processing';
		case 10:
			return 'postprocessing';
		case 11:
			return 'processed';
		case 12:
			return 'failed';
		default:
			return 'cancelled';
	}
};
var $author$project$Api$Employer$Upload$All$uploaderType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$uploaderType(shared);
};
var $author$project$Api$Provider$Upload$All$uploaderType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$uploaderType(shared);
};
var $author$project$Api$Upload$All$uploaderType = function (upload) {
	if (!upload.$) {
		var upload_ = upload.a;
		return $author$project$Api$Provider$Upload$All$uploaderType(upload_);
	} else {
		var upload_ = upload.a;
		return $author$project$Api$Employer$Upload$All$uploaderType(upload_);
	}
};
var $author$project$Ui$Link$Xs = 1;
var $author$project$Ui$Link$xs = $author$project$Ui$Link$Size(1);
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$viewRow = F2(
	function (model, upload) {
		var meta = $author$project$Api$Upload$All$meta(upload);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$limitWidth]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__UploadId_String__Top(
								{
									fZ: model.ahP,
									Kj: $author$project$Api$Upload$All$id(upload)
								}),
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										$author$project$Api$Upload$All$name(upload)))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = $author$project$Api$Upload$All$uploaderType(upload);
							switch (_v0.$) {
								case 0:
									return $elm$html$Html$text('AutoSync');
								case 1:
									return $elm$html$Html$text('Manual');
								case 2:
									return $elm$html$Html$text('Manual');
								default:
									var string = _v0.a;
									return $elm$html$Html$text(string);
							}
						}()
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Badge$fromString,
							_List_Nil,
							$author$project$Api$Upload$Status$toString(
								$author$project$Api$Upload$All$status(upload)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'N/A',
								A2(
									$elm$core$Maybe$map,
									model.J7(0),
									$author$project$Api$Upload$All$startedAt(upload))))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'N/A',
								A2(
									$elm$core$Maybe$map,
									model.J7(0),
									$author$project$Api$Upload$All$finishedAt(upload))))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(
								$author$project$Api$Upload$All$rowsTotal(upload)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(
								$author$project$Api$Upload$All$rowsProcessedOrIgnored(upload)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(
								A2(
									$elm$core$Maybe$withDefault,
									0,
									$author$project$Pages$Companies$CompanyId_String$Uploads$Top$failedRowsCountWithoutSupressed(upload))))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$noWrap]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Tooltip$view,
							_List_Nil,
							'Download file',
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Pages$Companies$CompanyId_String$Uploads$Top$ExportFileMsg,
									A3(
										$author$project$Components$FileLink$view,
										{
											NJ: model.Gv,
											SG: 0,
											adY: A2($author$project$Pages$Companies$CompanyId_String$Uploads$Top$exportCsvPath, model, upload)
										},
										_List_fromArray(
											[
												$author$project$Ui$Link$ariaLabel('Download file'),
												$author$project$Ui$Link$xs,
												$author$project$Ui$Link$buttonDefault,
												$author$project$Ui$Link$icon($author$project$Ui$Icon$export)
											]),
										_List_Nil))
								])),
							$author$project$Utils$Html$noBreakSpace,
							$author$project$Pages$Companies$CompanyId_String$Uploads$Top$canProcessUpload(meta) ? A3(
							$author$project$Ui$Button$view,
							{mm: 'Process upload'},
							_List_fromArray(
								[
									$author$project$Ui$Button$sm,
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$onClick(
									$author$project$Pages$Companies$CompanyId_String$Uploads$Top$Process(upload)),
									$author$project$Ui$Button$loading(
									_Utils_eq(model.po, $author$project$Api$Data$Loading))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Process Upload')
								])) : $author$project$Utils$Html$empty,
							$author$project$Utils$Html$noBreakSpace,
							$author$project$Api$Upload$Meta$duplicateAction(meta) ? A3(
							$author$project$Ui$Button$view,
							{mm: 'Duplicate upload'},
							_List_fromArray(
								[
									$author$project$Ui$Button$sm,
									$author$project$Ui$Button$onClick(
									$author$project$Pages$Companies$CompanyId_String$Uploads$Top$Duplicate(upload))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Duplicate Upload')
								])) : $author$project$Utils$Html$empty,
							$author$project$Utils$Html$noBreakSpace,
							$author$project$Api$Upload$Meta$cancelAction(meta) ? A3(
							$author$project$Ui$Button$view,
							{mm: 'Cancel upload'},
							_List_fromArray(
								[
									$author$project$Ui$Button$sm,
									$author$project$Ui$Button$danger,
									$author$project$Ui$Button$onClick(
									$author$project$Pages$Companies$CompanyId_String$Uploads$Top$Cancel(upload))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel Upload')
								])) : $author$project$Utils$Html$empty
						]))
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$viewTable = function (model) {
	var _v0 = function () {
		var _v1 = model.qV;
		if (_v1.$ === 3) {
			var uploads_ = _v1.a;
			return _Utils_Tuple2(false, uploads_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var uploads = _v0.b;
	return A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You have no uploads yet!')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		A2(
			$elm$core$List$map,
			$author$project$Api$Column$view($author$project$Api$Column$NonSortable),
			$author$project$Pages$Companies$CompanyId_String$Uploads$Top$columns),
		A2(
			$elm$core$List$map,
			$author$project$Pages$Companies$CompanyId_String$Uploads$Top$viewRow(model),
			uploads),
		_List_Nil);
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$view = function (model) {
	return {
		fO: function () {
			var loading = function () {
				var _v7 = model.qV;
				if (_v7.$ === 3) {
					return false;
				} else {
					return true;
				}
			}();
			return _List_fromArray(
				[
					function () {
					var _v0 = model.lY;
					if (!_v0.$) {
						var uploadModal = _v0.a;
						return A2(
							$elm$html$Html$map,
							$author$project$Pages$Companies$CompanyId_String$Uploads$Top$UploadModalMsg,
							$author$project$Components$Company$UploadModal$view(uploadModal));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					function () {
					var _v1 = model.c5;
					if (!_v1.$) {
						var _v2 = _v1.a;
						var upload = _v2.a;
						var saveRequest = _v2.b;
						return A2(
							$author$project$Components$HiConfirm$modal,
							$author$project$Pages$Companies$CompanyId_String$Uploads$Top$CancelHiConfirmClosed,
							_List_fromArray(
								[
									$author$project$Components$HiConfirm$verb('cancel'),
									$author$project$Components$HiConfirm$noun('Upload'),
									$author$project$Components$HiConfirm$detail(
									'\"' + (A2(
										$elm$core$Maybe$withDefault,
										'',
										$author$project$Api$Upload$All$name(upload)) + '\"')),
									$author$project$Components$HiConfirm$loading(
									_Utils_eq(saveRequest, $author$project$Api$Data$Loading))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					function () {
					var _v3 = model.di;
					if (!_v3.$) {
						var _v4 = _v3.a;
						var upload = _v4.a;
						var saveRequest = _v4.b;
						return A2(
							$author$project$Components$HiConfirm$modal,
							$author$project$Pages$Companies$CompanyId_String$Uploads$Top$DuplicateHiConfirmClosed,
							_List_fromArray(
								[
									$author$project$Components$HiConfirm$verb('duplicate'),
									$author$project$Components$HiConfirm$noun('Upload'),
									$author$project$Components$HiConfirm$detail(
									'\"' + (A2(
										$elm$core$Maybe$withDefault,
										'',
										$author$project$Api$Upload$All$name(upload)) + '\"')),
									$author$project$Components$HiConfirm$loading(
									_Utils_eq(saveRequest, $author$project$Api$Data$Loading))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					function () {
					var _v5 = model.kP;
					if (!_v5.$) {
						var processUploadModal = _v5.a;
						return A2(
							$elm$html$Html$map,
							$author$project$Pages$Companies$CompanyId_String$Uploads$Top$ProcessUploadModalMsg,
							$author$project$Components$Upload$ProcessUploadModal$view(processUploadModal));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					model.mC ? $author$project$Components$Upload$CannotUploadModal$view($author$project$Pages$Companies$CompanyId_String$Uploads$Top$CannotUploadModalClosed) : $author$project$Utils$Html$empty,
					A6(
					$author$project$Layouts$Company$Uploads$view,
					model.aa4,
					model.ZV,
					model.afQ,
					model.jL,
					_List_fromArray(
						[
							function () {
							if (!$author$project$Pages$Companies$CompanyId_String$Uploads$Top$companyIsChild(model.afQ)) {
								var fileUrl = 'https://docs.google.com/spreadsheets/d/1pJagUUuUftzqL8n4y_uzZLWuiQUaor7-59RLSAtPfPo/edit?gid=0';
								return A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$helpBlock]),
									_List_fromArray(
										[
											$elm$html$Html$text('Employee Uploads following the '),
											A3(
											$author$project$Ui$Link$externalHref,
											fileUrl,
											_List_fromArray(
												[$author$project$Ui$Link$targetBlank]),
											_List_fromArray(
												[
													$elm$html$Html$text('default CSV Template')
												]))
										]));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}(),
							A2(
							$author$project$Ui$Grid$row,
							_List_fromArray(
								[$author$project$Ui$Grid$mb2]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanMd(8)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Group$view,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$map,
													$author$project$Pages$Companies$CompanyId_String$Uploads$Top$SearchInputMsg,
													A2(
														$author$project$Ui$SearchInput$view,
														_List_fromArray(
															[
																$author$project$Ui$SearchInput$phi(true),
																$author$project$Ui$SearchInput$placeholder('Search by file name or upload identificator')
															]),
														model.up))
												]))
										])),
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanMd(4),
											$author$project$Ui$Grid$justifyRight
										]),
									function () {
										var _v6 = model.jL;
										if (_v6.$ === 3) {
											var feedEnroller = _v6.a;
											return _List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_Nil,
													_List_fromArray(
														[
															function () {
															if ($author$project$Pages$Companies$CompanyId_String$Uploads$Top$canUploadFile(model.afQ)) {
																var buttonLabel = ($author$project$Utils$Maybe$toBool(feedEnroller) || $author$project$Pages$Companies$CompanyId_String$Uploads$Top$companyIsParent(model.afQ)) ? 'Upload AutoSync file' : 'Upload file';
																return A3(
																	$author$project$Ui$Button$view,
																	{mm: buttonLabel},
																	_List_fromArray(
																		[
																			$author$project$Ui$Button$onClick($author$project$Pages$Companies$CompanyId_String$Uploads$Top$Upload),
																			$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(buttonLabel)
																		]));
															} else {
																return $author$project$Utils$Html$empty;
															}
														}(),
															(model.Ij && ((!$author$project$Utils$Maybe$toBool(feedEnroller)) && ((!$author$project$Pages$Companies$CompanyId_String$Uploads$Top$companyIsChild(model.afQ)) && (!$author$project$Api$Platform$Session$One$organizationIsCompany(model.aa4))))) ? A3(
															$author$project$Ui$HinterOnly$linkRoute,
															$author$project$Spa$Generated$Route$Companies__CompanyId_String__Eas(
																{fZ: model.ahP}),
															_List_fromArray(
																[$author$project$Ui$Link$buttonDefault]),
															_List_fromArray(
																[
																	$elm$html$Html$text(' Configure EAS')
																])) : $author$project$Utils$Html$empty
														]))
												]);
										} else {
											return _List_fromArray(
												[
													$author$project$Ui$Spinner$view(
													_List_fromArray(
														[$author$project$Ui$Spinner$small]))
												]);
										}
									}())
								])),
							$author$project$Pages$Companies$CompanyId_String$Uploads$Top$viewTable(model)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Pages$Companies$CompanyId_String$Uploads$Top$PaginationMsg,
							A2(
								$author$project$Api$Pagination$view,
								_List_fromArray(
									[
										$author$project$Ui$Pagination$List$loading(loading)
									]),
								model.ajJ))
						]))
				]);
		}(),
		ac9: A2($author$project$Api$Practice$sponsorize, model.ZV, 'Companies') + ' | Employee Uploads'
	};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$page = $author$project$Spa$Page$applicationCompanyOrEmployer(
	{ah_: $author$project$Pages$Companies$CompanyId_String$Uploads$Top$init, aiq: $author$project$Pages$Companies$CompanyId_String$Uploads$Top$load, k8: $author$project$Pages$Companies$CompanyId_String$Uploads$Top$save, alO: $author$project$Pages$Companies$CompanyId_String$Uploads$Top$subscriptions, adT: $author$project$Pages$Companies$CompanyId_String$Uploads$Top$update, amo: $author$project$Pages$Companies$CompanyId_String$Uploads$Top$view});
var $author$project$Components$Upload$UploadRowList$Failed = 0;
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$FailedUploadRowListMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$GotFeedEnroller = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$None = {$: 0};
var $author$project$Components$Upload$UploadRowList$Processed = 2;
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$ProcessedUploadRowListMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Upload$UploadRowList$Warning = 1;
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$WarningUploadRowListMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$GotUpload = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$basePath = function (model) {
	return $author$project$Api$Platform$Session$One$organizationIsCompany(model.aa4) ? $author$project$Api$Data$employerPath : $author$project$Api$Provider$Company$companyPath(model.fZ);
};
var $author$project$Api$Employer$Upload$retrieve = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Employer$Upload$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Employer$Upload$uploadPath(id_)));
	});
var $author$project$Api$Upload$retrieve = F5(
	function (basePath, apiClient, session, id_, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$Upload$retrieve,
			apiClient,
			id_,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Upload$One$fromEmployer))) : A4(
			$author$project$Api$Provider$Upload$retrieve,
			basePath,
			apiClient,
			id_,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Upload$One$fromProvider)));
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$fetchUpload = function (model) {
	return A5(
		$author$project$Api$Upload$retrieve,
		$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$basePath(model),
		model.Gv,
		model.aa4,
		model.ahP,
		$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$GotUpload);
};
var $author$project$Components$Upload$UploadRowList$GotUploadRows = $elm$core$Basics$identity;
var $author$project$Api$UploadRow$All$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$UploadRow$All$fromEmployer = $author$project$Api$UploadRow$All$Employer;
var $author$project$Api$UploadRow$All$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$UploadRow$All$fromProvider = $author$project$Api$UploadRow$All$Provider;
var $author$project$Api$Employer$UploadRow$All$UploadRow = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Employer$UploadRow$Shared$UploadRow = $elm$core$Basics$identity;
var $author$project$Api$Employer$UploadRow$Shared$Record = F5(
	function (id, rowNumber, reviewed, isSupressed, csvRow) {
		return {Pb: csvRow, ahP: id, Ve: isSupressed, $3: reviewed, aab: rowNumber};
	});
var $author$project$Api$Employer$UploadRow$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'csv_row',
	$elm$json$Json$Decode$dict(
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'is_supressed',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'reviewed',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'row_number',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Employer$UploadRow$Shared$Record))))));
var $author$project$Api$Employer$UploadRow$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$UploadRow$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$UploadRow$All$Record = F2(
	function (resultData, uploadRowResults) {
		return {$V: resultData, adU: uploadRowResults};
	});
var $author$project$Api$Employer$UploadRowResult$Shared$UploadRowResult = $elm$core$Basics$identity;
var $author$project$Api$Employer$UploadRowResult$Shared$Record = F2(
	function (message, resultType) {
		return {aiH: message, $W: resultType};
	});
var $author$project$Api$Employer$UploadRowResult$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'result_type',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'message',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$UploadRowResult$Shared$Record)));
var $author$project$Api$Employer$UploadRowResult$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$UploadRowResult$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$UploadRow$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'upload_row_results',
	$elm$json$Json$Decode$list($author$project$Api$Employer$UploadRowResult$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'result_data',
		$elm$json$Json$Decode$nullable($author$project$Api$Common$UploadRowResult$Data$decoder),
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$UploadRow$All$Record)));
var $author$project$Api$Employer$UploadRow$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$UploadRow$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Employer$UploadRow$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$UploadRow$All$UploadRow)));
var $author$project$Api$Employer$UploadRow$uploadRowsPath = function (uploadId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['upload_rows']),
		$author$project$Api$Employer$Upload$uploadPath(uploadId));
};
var $author$project$Api$Employer$UploadRow$list = F4(
	function (apiClient, uploadId, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Employer$UploadRow$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Common$UploadRow$ListOptionals$toParams(optionals),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Employer$UploadRow$uploadRowsPath(uploadId))));
	});
var $author$project$Api$UploadRow$list = F5(
	function (apiClient, session, uploadId, optionals, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4(
			$author$project$Api$Employer$UploadRow$list,
			apiClient,
			uploadId,
			optionals,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$UploadRow$All$fromEmployer)))) : A4(
			$author$project$Api$Provider$UploadRow$list,
			apiClient,
			uploadId,
			optionals,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$UploadRow$All$fromProvider))));
	});
var $author$project$Api$Common$UploadRow$ListOptionals$Processed = 2;
var $author$project$Api$Common$UploadRow$ListOptionals$Warning = 1;
var $author$project$Components$Upload$UploadRowList$resultTypeFilter = function (resultType) {
	switch (resultType) {
		case 0:
			return 0;
		case 1:
			return 1;
		default:
			return 2;
	}
};
var $author$project$Components$Upload$UploadRowList$fetchUploadRows = F2(
	function (apiClient, model) {
		var resultTypeListOptionals = function (listOptionals) {
			var _v0 = model.$W;
			switch (_v0) {
				case 0:
					return _Utils_update(
						listOptionals,
						{
							J1: $elm$core$Maybe$Just('not_supressed')
						});
				case 1:
					return listOptionals;
				default:
					return listOptionals;
			}
		};
		return A5(
			$author$project$Api$UploadRow$list,
			apiClient,
			model.aa4,
			model.Kj,
			A2(
				$elm$core$Basics$composeR,
				function (d) {
					return _Utils_update(
						d,
						{
							HM: $elm$core$Maybe$Just(
								$author$project$Components$Upload$UploadRowList$resultTypeFilter(model.$W))
						});
				},
				resultTypeListOptionals),
			$elm$core$Basics$identity);
	});
var $author$project$Components$Upload$UploadRowList$init = F5(
	function (apiClient, session, companyId, uploadId, resultType) {
		var model = {fZ: companyId, $W: resultType, aa4: session, Kj: uploadId, vk: $author$project$Api$Data$Loading};
		return _Utils_Tuple2(
			model,
			A2($author$project$Components$Upload$UploadRowList$fetchUploadRows, apiClient, model));
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$init = F5(
	function (session, practice, company, shared, _v0) {
		var params = _v0.YL;
		var _v1 = A5($author$project$Components$Upload$UploadRowList$init, shared.Gv, session, params.fZ, params.Kj, 1);
		var warningUploadRowList = _v1.a;
		var warningUploadRowListCmd = _v1.b;
		var _v2 = A5($author$project$Components$Upload$UploadRowList$init, shared.Gv, session, params.fZ, params.Kj, 2);
		var processedUploadRowList = _v2.a;
		var processedUploadRowListCmd = _v2.b;
		var _v3 = A5($author$project$Components$Upload$UploadRowList$init, shared.Gv, session, params.fZ, params.Kj, 0);
		var failedUploadRowList = _v3.a;
		var failedUploadRowListCmd = _v3.b;
		var model = {Gv: shared.Gv, afQ: company, fZ: params.fZ, sm: failedUploadRowList, jL: $author$project$Api$Data$Loading, ahP: params.Kj, ZV: practice, t4: processedUploadRowList, aa4: session, J7: shared.J7, FZ: $author$project$Api$Data$Loading, fq: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$None, vr: warningUploadRowList};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$fetchUpload(model),
						A4($author$project$Api$FeedEnroller$retrieve, shared.Gv, session, params.fZ, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$GotFeedEnroller),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$FailedUploadRowListMsg, failedUploadRowListCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$WarningUploadRowListMsg, warningUploadRowListCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$ProcessedUploadRowListMsg, processedUploadRowListCmd)
					])));
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$WarningDetailsModalClosed = {$: 7};
var $author$project$Components$Upload$WarningDetailsModal$subscribeToEscapeKeyPress = function (msg) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress(msg);
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$subscriptions = function (model) {
	var _v0 = model.fq;
	if (_v0.$ === 1) {
		return $author$project$Components$Upload$WarningDetailsModal$subscribeToEscapeKeyPress($author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$WarningDetailsModalClosed);
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$Warnings = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Dict$map = F2(
	function (func, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				A2(func, key, value),
				A2($elm$core$Dict$map, func, left),
				A2($elm$core$Dict$map, func, right));
		}
	});
var $BrianHicks$elm_csv$Csv$Encode$encodeItems = F2(
	function (encoder, rows) {
		if (!encoder.$) {
			var convert = encoder.a;
			var _v1 = A3(
				$elm$core$List$foldr,
				F2(
					function (row, _v2) {
						var converted_ = _v2.a;
						var names = _v2.b;
						var convertedRow = convert(row);
						return _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								$elm$core$Dict$fromList(convertedRow),
								converted_),
							A3(
								$elm$core$List$foldl,
								F2(
									function (_v3, _v4) {
										var name = _v3.a;
										var soFar = _v4.a;
										var column = _v4.b;
										return _Utils_Tuple2(
											A3(
												$elm$core$Dict$update,
												name,
												function (value) {
													if (!value.$) {
														var columns = value.a;
														return $elm$core$Maybe$Just(
															A2($elm$core$List$cons, column, columns));
													} else {
														return $elm$core$Maybe$Just(
															_List_fromArray(
																[column]));
													}
												},
												soFar),
											column + 1);
									}),
								_Utils_Tuple2(names, 0),
								convertedRow).a);
					}),
				_Utils_Tuple2(_List_Nil, $elm$core$Dict$empty),
				rows);
			var converted = _v1.a;
			var namePositions = _v1.b;
			var ordering = A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2(
					$elm$core$List$sortBy,
					$elm$core$Tuple$second,
					$elm$core$Dict$toList(
						A2(
							$elm$core$Dict$map,
							F2(
								function (_v6, positions) {
									return $elm$core$List$sum(positions) / $elm$core$List$length(positions);
								}),
							namePositions))));
			return A2(
				$elm$core$List$cons,
				ordering,
				A2(
					$elm$core$List$map,
					function (row) {
						return A2(
							$elm$core$List$map,
							function (field) {
								return A2(
									$elm$core$Maybe$withDefault,
									'',
									A2($elm$core$Dict$get, field, row));
							},
							ordering);
					},
					converted));
		} else {
			var convert = encoder.a;
			return A2($elm$core$List$map, convert, rows);
		}
	});
var $BrianHicks$elm_csv$Csv$Encode$quoteIfNecessary = F2(
	function (fieldSeparator, value) {
		return (A2($elm$core$String$contains, '\"', value) || (A2($elm$core$String$contains, fieldSeparator, value) || (A2($elm$core$String$contains, '\u000D\n', value) || A2($elm$core$String$contains, '\n', value)))) ? ('\"' + (A3($elm$core$String$replace, '\"', '\"\"', value) + '\"')) : value;
	});
var $BrianHicks$elm_csv$Csv$Encode$encode = F2(
	function (_v0, items) {
		var encoder = _v0.agS;
		var fieldSeparator = _v0.ahh;
		var fieldSeparatorString = $elm$core$String$fromChar(fieldSeparator);
		return A2(
			$elm$core$String$join,
			'\u000D\n',
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeL,
					$elm$core$String$join(fieldSeparatorString),
					$elm$core$List$map(
						$BrianHicks$elm_csv$Csv$Encode$quoteIfNecessary(fieldSeparatorString))),
				A2($BrianHicks$elm_csv$Csv$Encode$encodeItems, encoder, items)));
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$warningRowEncoder = function (record) {
	return _List_fromArray(
		[
			_Utils_Tuple2('Ident', record.ahQ),
			_Utils_Tuple2('First Name', record.Sv),
			_Utils_Tuple2('Last Name', record.VH),
			_Utils_Tuple2('DOB', record.agC),
			_Utils_Tuple2('Company Name', record.Og),
			_Utils_Tuple2('External ID', record.ag7)
		]);
};
var $BrianHicks$elm_csv$Csv$Encode$WithFieldNames = function (a) {
	return {$: 0, a: a};
};
var $BrianHicks$elm_csv$Csv$Encode$withFieldNames = $BrianHicks$elm_csv$Csv$Encode$WithFieldNames;
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$downloadWarnings = function (warnings) {
	var warningsList = function () {
		if (warnings.$ === 1) {
			var _v1 = warnings.a;
			var warnings_ = _v1.b;
			return warnings_;
		} else {
			return _List_Nil;
		}
	}();
	return A3(
		$elm$file$File$Download$string,
		'warnings.csv',
		'text/csv',
		A2(
			$BrianHicks$elm_csv$Csv$Encode$encode,
			{
				agS: $BrianHicks$elm_csv$Csv$Encode$withFieldNames($author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$warningRowEncoder),
				ahh: ','
			},
			warningsList));
};
var $author$project$Components$Upload$UploadRowList$update = F2(
	function (msg, model) {
		var response = msg;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{vk: response}),
			$elm$core$Platform$Cmd$none,
			$author$project$OutMsg$handleErrorResponse(response));
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{FZ: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{jL: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 2:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Components$Upload$UploadRowList$update, subMsg, model.sm);
				var failedUploadRowList_ = _v1.a;
				var failedUploadRowListCmd = _v1.b;
				var failedUploadRowListOutMsgs = _v1.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{sm: failedUploadRowList_}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$FailedUploadRowListMsg, failedUploadRowListCmd),
					failedUploadRowListOutMsgs);
			case 3:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Components$Upload$UploadRowList$update, subMsg, model.vr);
				var warningUploadRowList_ = _v2.a;
				var warningUploadRowListCmd = _v2.b;
				var warningUploadRowListOutMsgs = _v2.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{vr: warningUploadRowList_}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$WarningUploadRowListMsg, warningUploadRowListCmd),
					warningUploadRowListOutMsgs);
			case 4:
				var subMsg = msg.a;
				var _v3 = A2($author$project$Components$Upload$UploadRowList$update, subMsg, model.t4);
				var processedUploadRowList_ = _v3.a;
				var processedUploadRowListCmd = _v3.b;
				var processedUploadRowListOutMsgs = _v3.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{t4: processedUploadRowList_}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$ProcessedUploadRowListMsg, processedUploadRowListCmd),
					processedUploadRowListOutMsgs);
			case 5:
				var type_ = msg.a;
				var warnings = msg.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							fq: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$Warnings(
								_Utils_Tuple2(
									$author$project$Formatters$String$titleize(type_),
									warnings))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 6:
				var registration = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							fq: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$Warnings(
								_Utils_Tuple2('Too many unenrollments', registration.ahR))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 7:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{fq: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$None}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{fq: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$None}),
					$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$downloadWarnings(model.fq),
					_List_Nil);
		}
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$WarningDetailsModalDownload = {$: 8};
var $author$project$Components$Upload$WarningDetailsModal$button = function (onClick) {
	return A3(
		$author$project$Ui$Button$view,
		{mm: 'Export to csv'},
		_List_fromArray(
			[
				$author$project$Ui$Button$link,
				$author$project$Ui$Button$onClick(onClick),
				$author$project$Ui$Button$icon($author$project$Ui$Icon$export)
			]),
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Tooltip$view,
				_List_fromArray(
					[
						$author$project$Ui$Tooltip$placement(2)
					]),
				'Export to CSV',
				_List_Nil)
			]));
};
var $author$project$Components$Upload$WarningDetailsModal$viewWarning = function (warning) {
	return A2(
		$author$project$Ui$Table$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(warning.ahQ)
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(warning.Sv)
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(warning.VH)
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(warning.agC)
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(warning.Og)
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(warning.ag7)
					]))
			]));
};
var $author$project$Components$Upload$WarningDetailsModal$view = F4(
	function (title, warnings, onClose, onDownload) {
		return A3(
			$author$project$Ui$Modal$view,
			onClose,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title(title)
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A4(
							$author$project$Ui$Table$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Table$header,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('ID')
										])),
									A2(
									$author$project$Ui$Table$header,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('First Name')
										])),
									A2(
									$author$project$Ui$Table$header,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Last Name')
										])),
									A2(
									$author$project$Ui$Table$header,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('DOB')
										])),
									A2(
									$author$project$Ui$Table$header,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Company Name')
										])),
									A2(
									$author$project$Ui$Table$header,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('External ID')
										])),
									A2(
									$author$project$Ui$Table$header,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Components$Upload$WarningDetailsModal$button(onDownload)
										]))
								]),
							A2($elm$core$List$map, $author$project$Components$Upload$WarningDetailsModal$viewWarning, warnings),
							_List_Nil)
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Close modal'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick(onClose)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Close')
								]))
						]))
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$ViewTooManyUnenrollmentsWarning = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$ViewUploadWarnings = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Api$Employer$Upload$One$createdAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$createdAt(shared);
};
var $author$project$Api$Provider$Upload$One$createdAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$createdAt(shared);
};
var $author$project$Api$Upload$One$createdAt = function (upload) {
	if (!upload.$) {
		var upload_ = upload.a;
		return $author$project$Api$Provider$Upload$One$createdAt(upload_);
	} else {
		var upload_ = upload.a;
		return $author$project$Api$Employer$Upload$One$createdAt(upload_);
	}
};
var $author$project$Api$Employer$Upload$One$errorMessage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$errorMessage(shared);
};
var $author$project$Api$Upload$One$errorMessage = function (upload) {
	if (!upload.$) {
		var upload_ = upload.a;
		return $author$project$Api$Provider$Upload$One$errorMessage(upload_);
	} else {
		var upload_ = upload.a;
		return $author$project$Api$Employer$Upload$One$errorMessage(upload_);
	}
};
var $elm$core$String$lines = _String_lines;
var $author$project$Api$Employer$Upload$One$results = function (_v0) {
	var record = _v0.b;
	return record.$X;
};
var $author$project$Api$Provider$Upload$One$results = function (_v0) {
	var record = _v0.b;
	return record.$X;
};
var $author$project$Api$Upload$One$results = function (upload) {
	if (!upload.$) {
		var upload_ = upload.a;
		return $author$project$Api$Provider$Upload$One$results(upload_);
	} else {
		var upload_ = upload.a;
		return $author$project$Api$Employer$Upload$One$results(upload_);
	}
};
var $author$project$Api$Employer$Upload$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$status(shared);
};
var $author$project$Api$Upload$One$status = function (upload) {
	if (!upload.$) {
		var upload_ = upload.a;
		return $author$project$Api$Provider$Upload$One$status(upload_);
	} else {
		var upload_ = upload.a;
		return $author$project$Api$Employer$Upload$One$status(upload_);
	}
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$uploadStatusLabel = function (upload) {
	var status = $author$project$Api$Upload$One$status(upload);
	return ((status === 2) || (status === 7)) ? 'enqueued' : $author$project$Api$Upload$Status$toString(status);
};
var $author$project$Ui$ListGroup$Danger = 3;
var $author$project$Ui$ListGroup$Success = 0;
var $author$project$Ui$ListGroup$Warning = 2;
var $author$project$Ui$ListGroup$Background = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$ListGroup$background = $author$project$Ui$ListGroup$Background;
var $author$project$Components$Upload$UploadRowList$backgroundStyle = function (resultType) {
	switch (resultType) {
		case 0:
			return $author$project$Ui$ListGroup$background(3);
		case 1:
			return $author$project$Ui$ListGroup$background(2);
		default:
			return $author$project$Ui$ListGroup$background(0);
	}
};
var $author$project$Components$Upload$UploadRowList$resultTypeToString = function (resultType) {
	switch (resultType) {
		case 0:
			return 'failed';
		case 1:
			return 'warning';
		default:
			return 'processed';
	}
};
var $author$project$Components$Upload$UploadRowList$resultTypeToTitle = function (resultType) {
	switch (resultType) {
		case 0:
			return 'Failed';
		case 1:
			return 'Warning';
		default:
			return 'Processed';
	}
};
var $author$project$Components$Upload$UploadRowList$textStyle = function (resultType) {
	switch (resultType) {
		case 0:
			return $author$project$Ui$Typography$danger;
		case 1:
			return $author$project$Ui$Typography$warning;
		default:
			return $author$project$Ui$Typography$success;
	}
};
var $author$project$Components$Upload$UploadRowList$isErrorsOrWarnings = function (resultType) {
	return (!resultType) || (resultType === 1);
};
var $author$project$Api$Employer$UploadRow$Shared$rowNumber = function (_v0) {
	var record = _v0;
	return record.aab;
};
var $author$project$Api$Employer$UploadRow$All$rowNumber = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$UploadRow$Shared$rowNumber(shared);
};
var $author$project$Api$Provider$UploadRow$Shared$rowNumber = function (_v0) {
	var record = _v0;
	return record.aab;
};
var $author$project$Api$Provider$UploadRow$All$rowNumber = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$UploadRow$Shared$rowNumber(shared);
};
var $author$project$Api$UploadRow$All$rowNumber = function (uploadRow) {
	if (!uploadRow.$) {
		var uploadRow_ = uploadRow.a;
		return $author$project$Api$Provider$UploadRow$All$rowNumber(uploadRow_);
	} else {
		var uploadRow_ = uploadRow.a;
		return $author$project$Api$Employer$UploadRow$All$rowNumber(uploadRow_);
	}
};
var $author$project$Api$Employer$UploadRowResult$Shared$message = function (_v0) {
	var record = _v0;
	return record.aiH;
};
var $author$project$Api$UploadRowResult$Shared$message = function (uploadRowResult) {
	if (!uploadRowResult.$) {
		var uploadRowResult_ = uploadRowResult.a;
		return $author$project$Api$Provider$UploadRowResult$Shared$message(uploadRowResult_);
	} else {
		var uploadRowResult_ = uploadRowResult.a;
		return $author$project$Api$Employer$UploadRowResult$Shared$message(uploadRowResult_);
	}
};
var $author$project$Api$Employer$UploadRowResult$Shared$resultType = function (_v0) {
	var record = _v0;
	return record.$W;
};
var $author$project$Api$Provider$UploadRowResult$Shared$resultType = function (_v0) {
	var record = _v0;
	return record.$W;
};
var $author$project$Api$UploadRowResult$Shared$resultType = function (uploadRowResult) {
	if (!uploadRowResult.$) {
		var uploadRowResult_ = uploadRowResult.a;
		return $author$project$Api$Provider$UploadRowResult$Shared$resultType(uploadRowResult_);
	} else {
		var uploadRowResult_ = uploadRowResult.a;
		return $author$project$Api$Employer$UploadRowResult$Shared$resultType(uploadRowResult_);
	}
};
var $author$project$Api$UploadRowResult$Shared$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$UploadRowResult$Shared$fromEmployer = $author$project$Api$UploadRowResult$Shared$Employer;
var $author$project$Api$UploadRowResult$Shared$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$UploadRowResult$Shared$fromProvider = $author$project$Api$UploadRowResult$Shared$Provider;
var $author$project$Api$Employer$UploadRow$All$uploadRowResults = function (_v0) {
	var record = _v0.b;
	return record.adU;
};
var $author$project$Api$UploadRow$All$uploadRowResults = function (uploadRow) {
	if (!uploadRow.$) {
		var uploadRow_ = uploadRow.a;
		return A2(
			$elm$core$List$map,
			$author$project$Api$UploadRowResult$Shared$fromProvider,
			$author$project$Api$Provider$UploadRow$All$uploadRowResults(uploadRow_));
	} else {
		var uploadRow_ = uploadRow.a;
		return A2(
			$elm$core$List$map,
			$author$project$Api$UploadRowResult$Shared$fromEmployer,
			$author$project$Api$Employer$UploadRow$All$uploadRowResults(uploadRow_));
	}
};
var $author$project$Components$Upload$UploadRowList$viewUploadRowMessage = F2(
	function (messageTypes, uploadRow) {
		var messages = A2(
			$elm$core$List$filterMap,
			function (uploadRowResult) {
				return A2(
					$elm$core$Maybe$andThen,
					function (resultType) {
						return A2($elm$core$List$member, resultType, messageTypes) ? $author$project$Api$UploadRowResult$Shared$message(uploadRowResult) : $elm$core$Maybe$Nothing;
					},
					$author$project$Api$UploadRowResult$Shared$resultType(uploadRowResult));
			},
			$author$project$Api$UploadRow$All$uploadRowResults(uploadRow));
		var messagesString = A2(
			$elm$core$String$join,
			' - ',
			$elm_community$list_extra$List$Extra$unique(messages));
		var _v0 = $author$project$Utils$String$toMaybe(messagesString);
		if (!_v0.$) {
			var messagesString_ = _v0.a;
			return A2(
				$author$project$Ui$Typography$text,
				_List_Nil,
				A2($author$project$Formatters$String$ellipsis, 100, messagesString_));
		} else {
			return A2(
				$author$project$Ui$Typography$em,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Blank')
					]));
		}
	});
var $author$project$Components$Upload$UploadRowList$viewUploadRowResult = function (uploadRow) {
	var ignoredTypes = _List_fromArray(
		['warning']);
	var resultsWithoutWarnings = A2(
		$elm$core$List$filterMap,
		function (uploadRowResult) {
			return A2(
				$elm$core$Maybe$andThen,
				function (resultType) {
					return (!A2($elm$core$List$member, resultType, ignoredTypes)) ? $elm$core$Maybe$Just(resultType) : $elm$core$Maybe$Nothing;
				},
				$author$project$Api$UploadRowResult$Shared$resultType(uploadRowResult));
		},
		$author$project$Api$UploadRow$All$uploadRowResults(uploadRow));
	var uniqSortedResults = $elm_community$list_extra$List$Extra$unique(resultsWithoutWarnings);
	var humanizedResults = A2(
		$elm$core$List$map,
		A2($elm$core$Basics$composeR, $author$project$Formatters$String$humanize, $author$project$Formatters$String$titleize),
		uniqSortedResults);
	var resultsString = $elm$core$List$isEmpty(humanizedResults) ? 'No Account Change' : A2($elm$core$String$join, ' - ', humanizedResults);
	return A2(
		$author$project$Ui$Typography$text,
		_List_Nil,
		A2($author$project$Formatters$String$ellipsis, 100, resultsString));
};
var $author$project$Components$Upload$UploadRowList$viewUploadRow = F2(
	function (resultType, uploadRow) {
		return A2(
			$author$project$Ui$ListGroup$item,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(10)
								]),
							_List_fromArray(
								[
									function () {
									if ($author$project$Components$Upload$UploadRowList$isErrorsOrWarnings(resultType)) {
										var messageTypes = function () {
											switch (resultType) {
												case 0:
													return _List_fromArray(
														['error']);
												case 1:
													return _List_fromArray(
														['warning', 'duplicate_ignored']);
												default:
													return _List_Nil;
											}
										}();
										return A2($author$project$Components$Upload$UploadRowList$viewUploadRowMessage, messageTypes, uploadRow);
									} else {
										return $author$project$Components$Upload$UploadRowList$viewUploadRowResult(uploadRow);
									}
								}()
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(2),
									$author$project$Ui$Grid$justifyRight
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Row #'),
									$elm$html$Html$text(
									$elm$core$String$fromInt(
										$author$project$Api$UploadRow$All$rowNumber(uploadRow)))
								]))
						]))
				]));
	});
var $author$project$Components$Upload$UploadRowList$zeroState = function (resultType) {
	switch (resultType) {
		case 0:
			return 'No failed rows';
		case 1:
			return 'No rows with warnings';
		default:
			return 'No rows processed';
	}
};
var $author$project$Components$Upload$UploadRowList$view = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h5,
						_List_Nil,
						_List_fromArray(
							[
								function () {
								var _v0 = model.vk;
								if (_v0.$ === 3) {
									var headers = _v0.b;
									var totalCount = A2(
										$elm$core$Maybe$withDefault,
										0,
										A2(
											$elm$core$Maybe$andThen,
											$elm$core$String$toInt,
											A2($elm$core$Dict$get, 'x-total-count', headers)));
									return A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$text,
												_List_fromArray(
													[
														$author$project$Components$Upload$UploadRowList$textStyle(model.$W)
													]),
												$author$project$Components$Upload$UploadRowList$resultTypeToTitle(model.$W)),
												A2(
												$author$project$Ui$Typography$text,
												_List_fromArray(
													[
														$author$project$Components$Upload$UploadRowList$textStyle(model.$W)
													]),
												' - '),
												A2(
												$author$project$Ui$Typography$text,
												_List_fromArray(
													[
														$author$project$Components$Upload$UploadRowList$textStyle(model.$W)
													]),
												$elm$core$String$fromInt(totalCount)),
												A2(
												$author$project$Ui$Typography$text,
												_List_fromArray(
													[
														$author$project$Components$Upload$UploadRowList$textStyle(model.$W)
													]),
												' rows ')
											]));
								} else {
									return $author$project$Ui$Spinner$view(
										_List_fromArray(
											[$author$project$Ui$Spinner$small]));
								}
							}()
							])),
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__UploadId_String__UploadResults(
							{fZ: model.fZ, Kj: model.Kj}),
						_List_fromArray(
							[
								$author$project$Ui$Link$routeParams(
								_List_fromArray(
									[
										A2(
										$elm$url$Url$Builder$string,
										'resultType',
										$author$project$Components$Upload$UploadRowList$resultTypeToString(model.$W))
									]))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('See all rows >')
							]))
					])),
				function () {
				var _v1 = model.vk;
				if (_v1.$ === 3) {
					var uploadRows = _v1.a;
					var listGroupOptions = A2(
						$elm$core$List$cons,
						$author$project$Ui$ListGroup$zeroState(
							$author$project$Components$Upload$UploadRowList$zeroState(model.$W)),
						$elm$core$List$isEmpty(uploadRows) ? _List_Nil : _List_fromArray(
							[
								$author$project$Components$Upload$UploadRowList$backgroundStyle(model.$W)
							]));
					return A2(
						$author$project$Ui$ListGroup$view,
						listGroupOptions,
						A2(
							$elm$core$List$map,
							$author$project$Components$Upload$UploadRowList$viewUploadRow(model.$W),
							uploadRows));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$viewUpload = F2(
	function (model, upload) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Formatters$String$titleize(
								$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$uploadStatusLabel(upload)))
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('File received on '),
							A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[$author$project$Ui$Typography$bold]),
							A2(
								model.J7,
								0,
								$author$project$Api$Upload$One$createdAt(upload)))
						])),
					function () {
					var _v0 = $author$project$Api$Upload$One$errorMessage(upload);
					if (!_v0.$) {
						var errorMessage = _v0.a;
						var errorMessages = $elm$core$String$lines(errorMessage);
						return A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							A2(
								$elm$core$List$map,
								function (message) {
									return A2(
										$author$project$Ui$Element$view,
										_List_Nil,
										_List_fromArray(
											[
												A2($author$project$Ui$Badge$fromString, _List_Nil, 'error'),
												$author$project$Utils$Html$noBreakSpace,
												A2($author$project$Ui$Typography$text, _List_Nil, message)
											]));
								},
								errorMessages));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					A2(
						$elm$core$List$map,
						function (result) {
							return A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								_List_fromArray(
									[
										function () {
										switch (result.$) {
											case 0:
												var value = result.a;
												return A2(
													$elm$html$Html$span,
													_List_Nil,
													A2(
														$elm$core$List$cons,
														A2($author$project$Ui$Badge$fromString, _List_Nil, 'warning'),
														A2(
															$elm$core$List$cons,
															$author$project$Utils$Html$noBreakSpace,
															A2(
																$elm$core$List$cons,
																$elm$html$Html$text(value.aiH),
																A2(
																	$elm$core$List$indexedMap,
																	F2(
																		function (index, registration) {
																			return A2(
																				$elm$html$Html$span,
																				_List_Nil,
																				_List_fromArray(
																					[
																						$elm$html$Html$text(registration.afQ),
																						$elm$html$Html$text(' ('),
																						$elm$html$Html$text(
																						$elm$core$String$fromInt(registration.OK)),
																						$elm$html$Html$text(') '),
																						A3(
																						$author$project$Ui$Button$view,
																						{mm: 'View unenrollment warnings'},
																						_List_fromArray(
																							[
																								$author$project$Ui$Button$link,
																								$author$project$Ui$Button$onClick(
																								$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$ViewTooManyUnenrollmentsWarning(registration))
																							]),
																						_List_fromArray(
																							[
																								$elm$html$Html$text('View >')
																							])),
																						_Utils_eq(
																						index,
																						$elm$core$List$length(value.akF) - 1) ? $author$project$Utils$Html$empty : $elm$html$Html$text(', ')
																					]));
																		}),
																	value.akF)))));
											case 1:
												var key = result.a;
												var value = result.b;
												return $elm$core$List$isEmpty(value) ? $author$project$Utils$Html$empty : A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															A2($author$project$Ui$Badge$fromString, _List_Nil, 'warning'),
															$author$project$Utils$Html$noBreakSpace,
															$elm$html$Html$text(
															$author$project$Formatters$String$humanize(key)),
															$elm$html$Html$text(' ('),
															$elm$html$Html$text(
															$elm$core$String$fromInt(
																$elm$core$List$length(value))),
															$elm$html$Html$text(') '),
															A3(
															$author$project$Ui$Button$view,
															{mm: 'View upload warnings'},
															_List_fromArray(
																[
																	$author$project$Ui$Button$link,
																	$author$project$Ui$Button$onClick(
																	A2($author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$ViewUploadWarnings, key, value))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('View >')
																]))
														]));
											default:
												return $author$project$Utils$Html$empty;
										}
									}()
									]));
						},
						$author$project$Api$Upload$One$results(upload))),
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanLg(6)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$FailedUploadRowListMsg,
									$author$project$Components$Upload$UploadRowList$view(model.sm))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanLg(6)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$WarningUploadRowListMsg,
									$author$project$Components$Upload$UploadRowList$view(model.vr))
								]))
						])),
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanLg(12)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$ProcessedUploadRowListMsg,
									$author$project$Components$Upload$UploadRowList$view(model.t4))
								]))
						]))
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				function () {
				var _v0 = model.fq;
				if (_v0.$ === 1) {
					var _v1 = _v0.a;
					var title = _v1.a;
					var warnings = _v1.b;
					return A4($author$project$Components$Upload$WarningDetailsModal$view, title, warnings, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$WarningDetailsModalClosed, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$WarningDetailsModalDownload);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A6(
				$author$project$Layouts$Company$Uploads$view,
				model.aa4,
				model.ZV,
				model.afQ,
				model.jL,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$elm$core$Basics$never,
										A2(
											$author$project$Ui$Breadcrumb$view,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Breadcrumb$item,
													_List_Nil,
													_List_fromArray(
														[
															A3(
															$author$project$Ui$Link$route,
															$author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__Top(
																{fZ: model.fZ}),
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Uploads')
																]))
														])),
													A2(
													$author$project$Ui$Breadcrumb$item,
													_List_fromArray(
														[
															$author$project$Ui$Breadcrumb$active(true)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(model.ahP)
														]))
												]))),
										$author$project$Ui$HorizontalRule$view(_List_Nil),
										function () {
										var _v2 = model.FZ;
										if (_v2.$ === 3) {
											var upload = _v2.a;
											return A2($author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$viewUpload, model, upload);
										} else {
											return A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$textCenter]),
												_List_fromArray(
													[
														$author$project$Ui$Spinner$view(_List_Nil)
													]));
										}
									}()
									]))
							]))
					]),
				_List_Nil)
			]),
		ac9: A2($author$project$Api$Practice$sponsorize, model.ZV, 'Companies') + ' | Employee Uploads'
	};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$page = $author$project$Spa$Page$applicationCompanyOrEmployer(
	{ah_: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$init, aiq: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$load, k8: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$save, alO: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$subscriptions, adT: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$update, amo: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$view});
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$GotFeedEnroller = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$NotSupressed = 1;
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$Processed = 2;
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$SupressFilterDropdownMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$Supressed = 0;
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$UploadRowResultsActionDropdownMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$Report$UploadRowSponsor = 19;
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$DobUpdated = 1;
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$EndDateUpdated = 7;
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$Enrolled = 3;
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$MembershipChanged = 6;
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$NewCompany = 8;
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$NewPatient = 2;
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$NoAccountChange = 0;
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$PlanChanged = 9;
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$Restarted = 4;
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$TerminatedByEndDate = 5;
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$actionToValue = function (action) {
	switch (action) {
		case 0:
			return 'no_account_change';
		case 1:
			return 'dob_updated';
		case 2:
			return 'new_patient';
		case 3:
			return 'enrolled';
		case 4:
			return 'restarted';
		case 5:
			return 'terminated_by_end_date';
		case 7:
			return 'end_date_updated';
		case 6:
			return 'membership_changed';
		case 8:
			return 'new_company';
		default:
			return 'plan_changed';
	}
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$actionFromQuery = function (queryString) {
	return A2(
		$elm_community$list_extra$List$Extra$find,
		function (status) {
			return _Utils_eq(
				$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$actionToValue(status),
				queryString);
		},
		_List_fromArray(
			[0, 1, 2, 3, 4, 5, 7, 6, 8, 9]));
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$resultTypeToString = function (resultType) {
	switch (resultType) {
		case 0:
			return 'failed';
		case 1:
			return 'warning';
		default:
			return 'processed';
	}
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$supressToValue = function (supress) {
	if (!supress) {
		return 'supressed';
	} else {
		return 'not_supressed';
	}
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$urlParams = function (model) {
	var queryParams = _List_fromArray(
		[
			$elm$core$Maybe$Just(
			_Utils_Tuple2(
				'resultType',
				$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$resultTypeToString(model.$W))),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$actionToValue,
				$elm$core$Tuple$pair('upload_row_results_result_type')),
			model.h6),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$supressToValue,
				$elm$core$Tuple$pair('supress_filter')),
			model.J1),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('q'),
			model.akl)
		]);
	return $elm$core$Dict$fromList(
		A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams));
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$buildUrl = function (model) {
	return A2(
		$elm$url$Url$Builder$relative,
		_List_fromArray(
			[
				$author$project$Spa$Generated$Route$toString(
				$author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__UploadId_String__UploadResults(
					{fZ: model.fZ, Kj: model.Kj}))
			]),
		A2(
			$elm$core$List$append,
			$author$project$Api$Pagination$toPageQuery(model.ajJ),
			A2(
				$elm$core$List$append,
				$author$project$Api$Sort$toQuery(model.alA),
				$author$project$Utils$QueryParameter$fromDict(
					$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$urlParams(model)))));
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$GotUploadRows = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$resultTypeFilter = function (resultType) {
	switch (resultType) {
		case 0:
			return 0;
		case 1:
			return 1;
		default:
			return 2;
	}
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$fetchUploadRowsParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				HM: $elm$core$Maybe$Just(
					$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$resultTypeFilter(model.$W)),
				ajJ: model.ajJ,
				akl: model.akl,
				alA: model.alA,
				J1: A2($elm$core$Maybe$map, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$supressToValue, model.J1),
				Kk: A2($elm$core$Maybe$map, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$actionToValue, model.h6)
			});
	};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$fetchUploadRows = function (model) {
	return A5(
		$author$project$Api$UploadRow$list,
		model.Gv,
		model.aa4,
		model.Kj,
		$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$fetchUploadRowsParams(model),
		$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$GotUploadRows);
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$Failed = 0;
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$Warning = 1;
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$resultTypeFromString = function (string) {
	switch (string) {
		case 'failed':
			return $elm$core$Maybe$Just(0);
		case 'warning':
			return $elm$core$Maybe$Just(1);
		case 'processed':
			return $elm$core$Maybe$Just(2);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$init = F5(
	function (session, practice, company, _v0, _v1) {
		var apiClient = _v0.Gv;
		var hinterViewOff = _v0.ahK;
		var params = _v1.YL;
		var query = _v1.DE;
		var resultType = A2(
			$elm$core$Maybe$withDefault,
			2,
			A2(
				$elm$core$Maybe$andThen,
				$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$resultTypeFromString,
				A2($elm$core$Dict$get, 'resultType', query)));
		var q = A2($elm$core$Dict$get, 'q', query);
		var exportCsv = $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			$author$project$Components$ExportCsv$initForPractice(19));
		var _v2 = function () {
			switch (resultType) {
				case 0:
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(
							function (supressQuery) {
								if ((!supressQuery.$) && (supressQuery.a === 'supressed')) {
									return 0;
								} else {
									return 1;
								}
							}(
								A2($elm$core$Dict$get, 'supress_filter', query))),
						$elm$core$Maybe$Nothing);
				case 1:
					return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
				default:
					return _Utils_Tuple2(
						$elm$core$Maybe$Nothing,
						A2(
							$elm$core$Maybe$andThen,
							$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$actionFromQuery,
							A2($elm$core$Dict$get, 'upload_row_results_result_type', query)));
			}
		}();
		var supressFilter = _v2.a;
		var uploadRowResultsResultType = _v2.b;
		var model = {
			Gv: apiClient,
			afQ: company,
			fZ: params.fZ,
			nD: exportCsv,
			jL: $author$project$Api$Data$Loading,
			ahK: hinterViewOff,
			ajJ: $author$project$Api$Pagination$initFromQuery(query),
			ZV: practice,
			akl: q,
			kQ: $elm$core$Maybe$Nothing,
			$W: resultType,
			up: $author$project$Ui$SearchInput$init(q),
			aa4: session,
			alA: A3(
				$author$project$Api$Sort$withDefault,
				'row_number',
				0,
				$author$project$Api$Sort$initFromQuery(query)),
			J1: supressFilter,
			qp: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'supress-filter-dropdown-filter', al6: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$SupressFilterDropdownMsg})),
			bO: $elm$core$Set$empty,
			Kj: params.Kj,
			qT: $elm$core$Maybe$Nothing,
			h6: uploadRowResultsResultType,
			qU: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'upload-row-results-result-type-dropdown-filter', al6: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$UploadRowResultsActionDropdownMsg})),
			vk: $author$project$Api$Data$Loading
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A4($author$project$Api$FeedEnroller$retrieve, apiClient, session, params.fZ, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$GotFeedEnroller),
						A2($elm$core$Basics$composeR, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$buildUrl, $author$project$Ports$Navigation$replaceUrl)(model),
						$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$fetchUploadRows(model)
					])));
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$ExportCsvMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$RawRowModalMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$RowMessagesModalClosed = {$: 11};
var $author$project$Components$Upload$RowDescriptionDetailsModal$subscribeToEscapeKeyPress = function (onClose) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress(onClose);
};
var $author$project$Components$Upload$RawRowModal$Close = {$: 2};
var $author$project$Components$Upload$RawRowModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Upload$RawRowModal$Close);
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$ExportCsvMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$ExportCsv$subscriptions, model.nD))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$RawRowModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Upload$RawRowModal$subscriptions, model.kQ))),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Upload$RowDescriptionDetailsModal$subscribeToEscapeKeyPress($author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$RowMessagesModalClosed)),
					model.qT)),
				$author$project$Ui$Dropdown$subscriptions(model.qU),
				$author$project$Ui$Dropdown$subscriptions(model.qp)
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$SearchInputMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$Updated = F3(
	function (a, b, c) {
		return {$: 17, a: a, b: b, c: c};
	});
var $author$project$Api$Employer$UploadRow$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Employer$UploadRow$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$UploadRow$Shared$id(shared);
};
var $author$project$Api$Provider$UploadRow$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$UploadRow$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$UploadRow$Shared$id(shared);
};
var $author$project$Api$UploadRow$All$id = function (uploadRow) {
	if (!uploadRow.$) {
		var uploadRow_ = uploadRow.a;
		return $author$project$Api$Provider$UploadRow$All$id(uploadRow_);
	} else {
		var uploadRow_ = uploadRow.a;
		return $author$project$Api$Employer$UploadRow$All$id(uploadRow_);
	}
};
var $author$project$Components$Upload$RawRowModal$GotUploadRow = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$UploadRow$One$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$UploadRow$One$fromEmployer = $author$project$Api$UploadRow$One$Employer;
var $author$project$Api$UploadRow$One$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$UploadRow$One$fromProvider = $author$project$Api$UploadRow$One$Provider;
var $author$project$Api$Employer$UploadRow$One$UploadRow = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Employer$UploadRow$One$Record = function (rowsInMyGroup) {
	return {aae: rowsInMyGroup};
};
var $author$project$Api$Employer$UploadRow$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'rows_in_my_group',
	$elm$json$Json$Decode$list($author$project$Api$Employer$UploadRow$Shared$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Employer$UploadRow$One$Record));
var $author$project$Api$Employer$UploadRow$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$UploadRow$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Employer$UploadRow$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$UploadRow$One$UploadRow)));
var $author$project$Api$Employer$UploadRow$uploadRowPath = F2(
	function (uploadId, id) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id]),
			$author$project$Api$Employer$UploadRow$uploadRowsPath(uploadId));
	});
var $author$project$Api$Employer$UploadRow$retrieve = F4(
	function (apiClient, uploadId, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Employer$UploadRow$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Employer$UploadRow$uploadRowPath, uploadId, id_)));
	});
var $author$project$Api$Provider$UploadRow$One$UploadRow = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$UploadRow$One$Record = function (rowsInMyGroup) {
	return {aae: rowsInMyGroup};
};
var $author$project$Api$Provider$UploadRow$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'rows_in_my_group',
	$elm$json$Json$Decode$list($author$project$Api$Provider$UploadRow$Shared$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$UploadRow$One$Record));
var $author$project$Api$Provider$UploadRow$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$UploadRow$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$UploadRow$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$UploadRow$One$UploadRow)));
var $author$project$Api$Provider$UploadRow$uploadRowPath = F2(
	function (uploadId, id) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id]),
			$author$project$Api$Provider$UploadRow$uploadRowsPath(uploadId));
	});
var $author$project$Api$Provider$UploadRow$retrieve = F4(
	function (apiClient, uploadId, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$UploadRow$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Provider$UploadRow$uploadRowPath, uploadId, id_)));
	});
var $author$project$Api$UploadRow$retrieve = F5(
	function (apiClient, session, uploadId, id, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4(
			$author$project$Api$Employer$UploadRow$retrieve,
			apiClient,
			uploadId,
			id,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$UploadRow$One$fromEmployer))) : A4(
			$author$project$Api$Provider$UploadRow$retrieve,
			apiClient,
			uploadId,
			id,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$UploadRow$One$fromProvider)));
	});
var $author$project$Components$Upload$RawRowModal$init = F4(
	function (apiClient, session, uploadId, uploadRowId) {
		return _Utils_Tuple2(
			{lo: false, vj: $author$project$Api$Data$Loading},
			A5($author$project$Api$UploadRow$retrieve, apiClient, session, uploadId, uploadRowId, $author$project$Components$Upload$RawRowModal$GotUploadRow));
	});
var $author$project$Api$Employer$UploadRow$supress = F4(
	function (apiClient, uploadId, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Employer$UploadRow$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['supress']),
					A2($author$project$Api$Employer$UploadRow$uploadRowPath, uploadId, id))));
	});
var $author$project$Api$Provider$UploadRow$supress = F4(
	function (apiClient, uploadId, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$UploadRow$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['supress']),
					A2($author$project$Api$Provider$UploadRow$uploadRowPath, uploadId, id))));
	});
var $author$project$Api$UploadRow$supress = F5(
	function (apiClient, session, uploadId, id, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4(
			$author$project$Api$Employer$UploadRow$supress,
			apiClient,
			uploadId,
			id,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$UploadRow$One$fromEmployer))) : A4(
			$author$project$Api$Provider$UploadRow$supress,
			apiClient,
			uploadId,
			id,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$UploadRow$One$fromProvider)));
	});
var $author$project$Api$Employer$UploadRow$unsupress = F4(
	function (apiClient, uploadId, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Employer$UploadRow$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['unsupress']),
					A2($author$project$Api$Employer$UploadRow$uploadRowPath, uploadId, id))));
	});
var $author$project$Api$Provider$UploadRow$unsupress = F4(
	function (apiClient, uploadId, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$UploadRow$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['unsupress']),
					A2($author$project$Api$Provider$UploadRow$uploadRowPath, uploadId, id))));
	});
var $author$project$Api$UploadRow$unsupress = F5(
	function (apiClient, session, uploadId, id, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4(
			$author$project$Api$Employer$UploadRow$unsupress,
			apiClient,
			uploadId,
			id,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$UploadRow$One$fromEmployer))) : A4(
			$author$project$Api$Provider$UploadRow$unsupress,
			apiClient,
			uploadId,
			id,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$UploadRow$One$fromProvider)));
	});
var $author$project$Components$Upload$RawRowModal$Closed = 1;
var $author$project$Components$Upload$RawRowModal$None = 0;
var $author$project$Components$Upload$RawRowModal$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{vj: response}),
					$author$project$OutMsg$handleErrorResponse(response),
					0);
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{lo: !model.lo}),
					_List_Nil,
					0);
			default:
				return _Utils_Tuple3(model, _List_Nil, 1);
		}
	});
var $author$project$Api$Employer$UploadRow$updateReviewed = F5(
	function (apiClient, uploadId, id, reviewed, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'reviewed',
					$elm$json$Json$Encode$bool(reviewed))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Employer$UploadRow$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Employer$UploadRow$uploadRowPath, uploadId, id))));
	});
var $author$project$Api$Provider$UploadRow$updateReviewed = F5(
	function (apiClient, uploadId, id, reviewed, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'reviewed',
					$elm$json$Json$Encode$bool(reviewed))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$UploadRow$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Provider$UploadRow$uploadRowPath, uploadId, id))));
	});
var $author$project$Api$UploadRow$updateReviewed = F6(
	function (apiClient, session, uploadId, id, reviewed, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A5(
			$author$project$Api$Employer$UploadRow$updateReviewed,
			apiClient,
			uploadId,
			id,
			reviewed,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$UploadRow$One$fromEmployer))) : A5(
			$author$project$Api$Provider$UploadRow$updateReviewed,
			apiClient,
			uploadId,
			id,
			reviewed,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$UploadRow$One$fromProvider)));
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{jL: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ),
								vk: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{vk: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 3:
				var selectedOption = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ajJ: $author$project$Api$Pagination$reset(model.ajJ),
						h6: selectedOption,
						vk: $author$project$Api$Data$Loading
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$fetchUploadRows(newModel),
								A2($elm$core$Basics$composeR, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 2:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Ui$Dropdown$update, subMsg, model.qU);
				var dropdown = _v2.a;
				var dropdownCmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qU: dropdown}),
					dropdownCmd,
					_List_Nil);
			case 5:
				var selectedOption = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ajJ: $author$project$Api$Pagination$reset(model.ajJ),
						J1: selectedOption,
						vk: $author$project$Api$Data$Loading
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$fetchUploadRows(newModel),
								A2($elm$core$Basics$composeR, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 4:
				var subMsg = msg.a;
				var _v3 = A2($author$project$Ui$Dropdown$update, subMsg, model.qp);
				var dropdown = _v3.a;
				var dropdownCmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qp: dropdown}),
					dropdownCmd,
					_List_Nil);
			case 6:
				var subMsg = msg.a;
				var _v4 = A2($author$project$Ui$SearchInput$update, subMsg, model.up);
				var searchInput = _v4.a;
				var searchInputCmd = _v4.b;
				var searchInputEvent = _v4.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.akl;
					}
				}();
				var _v5 = function () {
					if (_Utils_eq(q, model.akl)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								ajJ: $author$project$Api$Pagination$reset(model.ajJ),
								akl: q,
								vk: $author$project$Api$Data$Loading
							});
						return _Utils_Tuple2(
							qModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$fetchUploadRows(qModel),
										A2($elm$core$Basics$composeR, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$buildUrl, $author$project$Ports$Navigation$pushUrl)(qModel)
									])));
					}
				}();
				var newModel = _v5.a;
				var cmd = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{up: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
			case 7:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						alA: A2($author$project$Api$Sort$update, columnId, model.alA),
						vk: $author$project$Api$Data$Loading
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$fetchUploadRows(newModel),
								A2($elm$core$Basics$composeR, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 8:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{ajJ: pagination, vk: $author$project$Api$Data$Loading});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$fetchUploadRows(newModel),
								A2($elm$core$Basics$composeR, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 9:
				var subMsg = msg.a;
				var _v7 = model.nD;
				if (!_v7.$) {
					var exportCsv = _v7.a;
					var _v8 = A3($author$project$Components$ExportCsv$update, model.Gv, subMsg, exportCsv);
					var exportCsv_ = _v8.a;
					var subCmd = _v8.b;
					var subOutMsg = _v8.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								nD: $elm$core$Maybe$Just(exportCsv_)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$ExportCsvMsg, subCmd),
						subOutMsg);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 10:
				var rowNumber = msg.a;
				var messages = msg.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							qT: $elm$core$Maybe$Just(
								_Utils_Tuple2(rowNumber, messages))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 11:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qT: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 12:
				var uploadRow = msg.a;
				var _v9 = A4(
					$author$project$Components$Upload$RawRowModal$init,
					model.Gv,
					model.aa4,
					model.Kj,
					$author$project$Api$UploadRow$All$id(uploadRow));
				var rawRowModal = _v9.a;
				var rawRowModalCmd = _v9.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							kQ: $elm$core$Maybe$Just(rawRowModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$RawRowModalMsg, rawRowModalCmd),
					_List_Nil);
			case 13:
				var subMsg = msg.a;
				var _v10 = model.kQ;
				if (!_v10.$) {
					var rawRowModal = _v10.a;
					var _v11 = A2($author$project$Components$Upload$RawRowModal$update, subMsg, rawRowModal);
					var rawRowModal_ = _v11.a;
					var subOutMsg = _v11.b;
					var rawRowModalEvent = _v11.c;
					var newRawRowModal = function () {
						if (!rawRowModalEvent) {
							return $elm$core$Maybe$Just(rawRowModal_);
						} else {
							return $elm$core$Maybe$Nothing;
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{kQ: newRawRowModal}),
						$elm$core$Platform$Cmd$none,
						subOutMsg);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 14:
				var uploadRow = msg.a;
				var id = $author$project$Api$UploadRow$All$id(uploadRow);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bO: A2($elm$core$Set$insert, id, model.bO)
						}),
					A5(
						$author$project$Api$UploadRow$unsupress,
						model.Gv,
						model.aa4,
						model.Kj,
						id,
						A2($author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$Updated, uploadRow, 'unmuted')),
					_List_Nil);
			case 15:
				var uploadRow = msg.a;
				var id = $author$project$Api$UploadRow$All$id(uploadRow);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bO: A2($elm$core$Set$insert, id, model.bO)
						}),
					A5(
						$author$project$Api$UploadRow$supress,
						model.Gv,
						model.aa4,
						model.Kj,
						id,
						A2($author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$Updated, uploadRow, 'muted')),
					_List_Nil);
			case 16:
				var uploadRow = msg.a;
				var bool = msg.b;
				var id = $author$project$Api$UploadRow$All$id(uploadRow);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bO: A2($elm$core$Set$insert, id, model.bO)
						}),
					A6(
						$author$project$Api$UploadRow$updateReviewed,
						model.Gv,
						model.aa4,
						model.Kj,
						id,
						bool,
						A2($author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$Updated, uploadRow, 'updated')),
					_List_Nil);
			default:
				var uploadRow = msg.a;
				var action = msg.b;
				var response = msg.c;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bO: A2(
									$elm$core$Set$remove,
									$author$project$Api$UploadRow$All$id(uploadRow),
									model.bO),
								vk: $author$project$Api$Data$Loading
							}),
						$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$fetchUploadRows(model),
						_List_fromArray(
							[
								A2(
								$author$project$OutMsg$ShowToast,
								3,
								'Row #' + ($elm$core$String$fromInt(
									$author$project$Api$UploadRow$All$rowNumber(uploadRow)) + (' was successfully ' + (action + '.'))))
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bO: A2(
									$elm$core$Set$remove,
									$author$project$Api$UploadRow$All$id(uploadRow),
									model.bO)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$PaginationMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$exportUploadRowsParams = function (model) {
	var queryParams = _List_fromArray(
		[
			$elm$core$Maybe$Just(
			A2(
				$author$project$Api$Param$string,
				'filter',
				$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$resultTypeToString(model.$W))),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$actionToValue,
				$author$project$Api$Param$string('upload_row_results_result_type')),
			model.h6),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$supressToValue,
				$author$project$Api$Param$string('supress_filter')),
			model.J1),
			A2(
			$elm$core$Maybe$map,
			$author$project$Api$Param$string('q'),
			model.akl)
		]);
	return A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams);
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$resultTypeToTitle = function (resultType) {
	switch (resultType) {
		case 0:
			return 'Failed';
		case 1:
			return 'Warning';
		default:
			return 'Processed';
	}
};
var $author$project$Api$Employer$UploadRow$One$rowNumber = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$UploadRow$Shared$rowNumber(shared);
};
var $author$project$Api$Provider$UploadRow$One$rowNumber = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$UploadRow$Shared$rowNumber(shared);
};
var $author$project$Api$UploadRow$One$rowNumber = function (uploadRow) {
	if (!uploadRow.$) {
		var uploadRow_ = uploadRow.a;
		return $author$project$Api$Provider$UploadRow$One$rowNumber(uploadRow_);
	} else {
		var uploadRow_ = uploadRow.a;
		return $author$project$Api$Employer$UploadRow$One$rowNumber(uploadRow_);
	}
};
var $author$project$Components$Upload$RawRowModal$ToggleRowsInGroup = {$: 1};
var $author$project$Api$Employer$UploadRow$Shared$csvRow = function (_v0) {
	var record = _v0;
	return record.Pb;
};
var $author$project$Api$Employer$UploadRow$One$csvRow = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$UploadRow$Shared$csvRow(shared);
};
var $author$project$Api$Provider$UploadRow$Shared$csvRow = function (_v0) {
	var record = _v0;
	return record.Pb;
};
var $author$project$Api$Provider$UploadRow$One$csvRow = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$UploadRow$Shared$csvRow(shared);
};
var $author$project$Api$UploadRow$One$csvRow = function (uploadRow) {
	if (!uploadRow.$) {
		var uploadRow_ = uploadRow.a;
		return $author$project$Api$Provider$UploadRow$One$csvRow(uploadRow_);
	} else {
		var uploadRow_ = uploadRow.a;
		return $author$project$Api$Employer$UploadRow$One$csvRow(uploadRow_);
	}
};
var $author$project$Api$UploadRow$Shared$rowNumber = function (uploadRow) {
	if (!uploadRow.$) {
		var uploadRow_ = uploadRow.a;
		return $author$project$Api$Provider$UploadRow$Shared$rowNumber(uploadRow_);
	} else {
		var uploadRow_ = uploadRow.a;
		return $author$project$Api$Employer$UploadRow$Shared$rowNumber(uploadRow_);
	}
};
var $author$project$Api$UploadRow$Shared$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$UploadRow$Shared$fromEmployer = $author$project$Api$UploadRow$Shared$Employer;
var $author$project$Api$UploadRow$Shared$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$UploadRow$Shared$fromProvider = $author$project$Api$UploadRow$Shared$Provider;
var $author$project$Api$Employer$UploadRow$One$rowsInMyGroup = function (_v0) {
	var record = _v0.b;
	return record.aae;
};
var $author$project$Api$Provider$UploadRow$One$rowsInMyGroup = function (_v0) {
	var record = _v0.b;
	return record.aae;
};
var $author$project$Api$UploadRow$One$rowsInMyGroup = function (uploadRow) {
	if (!uploadRow.$) {
		var uploadRow_ = uploadRow.a;
		return A2(
			$elm$core$List$map,
			$author$project$Api$UploadRow$Shared$fromProvider,
			$author$project$Api$Provider$UploadRow$One$rowsInMyGroup(uploadRow_));
	} else {
		var uploadRow_ = uploadRow.a;
		return A2(
			$elm$core$List$map,
			$author$project$Api$UploadRow$Shared$fromEmployer,
			$author$project$Api$Employer$UploadRow$One$rowsInMyGroup(uploadRow_));
	}
};
var $author$project$Api$UploadRow$Shared$csvRow = function (uploadRow) {
	if (!uploadRow.$) {
		var uploadRow_ = uploadRow.a;
		return $author$project$Api$Provider$UploadRow$Shared$csvRow(uploadRow_);
	} else {
		var uploadRow_ = uploadRow.a;
		return $author$project$Api$Employer$UploadRow$Shared$csvRow(uploadRow_);
	}
};
var $author$project$Components$Upload$RawRowModal$viewCsvValue = function (value) {
	return A2(
		$author$project$Ui$Table$cell,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$text,
				_List_fromArray(
					[
						$author$project$Ui$Typography$phi(true)
					]),
				A2($elm$core$Maybe$withDefault, '', value))
			]));
};
var $author$project$Components$Upload$RawRowModal$viewRowInGroupValue = F2(
	function (key, csv) {
		var value = A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Maybe$Nothing,
			A2($elm$core$Dict$get, key, csv));
		return $author$project$Components$Upload$RawRowModal$viewCsvValue(value);
	});
var $author$project$Components$Upload$RawRowModal$viewCsvField = F3(
	function (showRowsInGroup, rowsInMyGroup, _v0) {
		var key = _v0.a;
		var value = _v0.b;
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(key)
										]))
								])),
							$author$project$Components$Upload$RawRowModal$viewCsvValue(value)
						]),
						showRowsInGroup ? A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Api$UploadRow$Shared$csvRow,
							$author$project$Components$Upload$RawRowModal$viewRowInGroupValue(key)),
						rowsInMyGroup) : _List_Nil
					])));
	});
var $author$project$Components$Upload$RawRowModal$viewRowNumber = function (rowNumber) {
	return A2(
		$author$project$Ui$Table$cell,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$elm$core$String$fromInt(rowNumber))
			]));
};
var $author$project$Components$Upload$RawRowModal$viewModalBody = F2(
	function (uploadRow, model) {
		var rowsInMyGroup = $author$project$Api$UploadRow$One$rowsInMyGroup(uploadRow);
		var rowsInMyGroupLength = $elm$core$List$length(rowsInMyGroup);
		var rowNumber = $author$project$Api$UploadRow$One$rowNumber(uploadRow);
		return _List_fromArray(
			[
				(rowsInMyGroupLength > 0) ? A2(
				$author$project$Ui$Typography$p,
				_List_Nil,
				_Utils_ap(
					(rowsInMyGroupLength === 1) ? _List_fromArray(
						[
							$elm$html$Html$text('* There is one more row in this group. ')
						]) : _List_fromArray(
						[
							$elm$html$Html$text('* There are '),
							$elm$html$Html$text(
							$elm$core$String$fromInt(rowsInMyGroupLength)),
							$elm$html$Html$text(' more rows in this group. ')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Toggle rows visibility'},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$onClick($author$project$Components$Upload$RawRowModal$ToggleRowsInGroup)
								]),
							_List_fromArray(
								[
									model.lo ? $elm$html$Html$text('Hide') : $elm$html$Html$text('Show'),
									$elm$html$Html$text(' Rows')
								]))
						]))) : $author$project$Utils$Html$empty,
				A4(
				$author$project$Ui$Table$view,
				_List_Nil,
				_List_Nil,
				A2(
					$elm$core$List$cons,
					A2(
						$author$project$Ui$Table$row,
						_List_Nil,
						$elm$core$List$concat(
							_List_fromArray(
								[
									_List_fromArray(
									[
										A2(
										$author$project$Ui$Table$cell,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$strong,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Row #')
													]))
											])),
										$author$project$Components$Upload$RawRowModal$viewRowNumber(rowNumber)
									]),
									model.lo ? A2(
									$elm$core$List$map,
									A2($elm$core$Basics$composeR, $author$project$Api$UploadRow$Shared$rowNumber, $author$project$Components$Upload$RawRowModal$viewRowNumber),
									rowsInMyGroup) : _List_Nil
								]))),
					A2(
						$elm$core$List$map,
						A2($author$project$Components$Upload$RawRowModal$viewCsvField, model.lo, rowsInMyGroup),
						$elm$core$Dict$toList(
							$author$project$Api$UploadRow$One$csvRow(uploadRow)))),
				_List_Nil)
			]);
	});
var $author$project$Components$Upload$RawRowModal$view = function (model) {
	var rowNumber = A2(
		$elm$core$Maybe$withDefault,
		'N/A',
		A2(
			$elm$core$Maybe$map,
			$elm$core$String$fromInt,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$UploadRow$One$rowNumber,
				$author$project$Api$Data$toMaybe(model.vj))));
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Upload$RawRowModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Raw CSV Row #' + rowNumber)
					])),
				$author$project$Ui$Modal$body(
				function () {
					var _v0 = model.vj;
					if (_v0.$ === 3) {
						var uploadRow = _v0.a;
						return A2($author$project$Components$Upload$RawRowModal$viewModalBody, uploadRow, model);
					} else {
						return _List_fromArray(
							[
								$author$project$Ui$Spinner$view(_List_Nil)
							]);
					}
				}()),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Upload$RawRowModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Close')
							]))
					]))
			]));
};
var $author$project$Components$Upload$RowDescriptionDetailsModal$viewWarning = function (warning) {
	return A2(
		$author$project$Ui$ListGroup$item,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(warning)
			]));
};
var $author$project$Components$Upload$RowDescriptionDetailsModal$view = F3(
	function (title, warnings, onClose) {
		return A3(
			$author$project$Ui$Modal$view,
			onClose,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title(title)
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$ListGroup$view,
							_List_Nil,
							A2($elm$core$List$map, $author$project$Components$Upload$RowDescriptionDetailsModal$viewWarning, warnings))
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Close modal'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick(onClose)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Close')
								]))
						]))
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$SupressSelected = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$supressToLabel = function (supress) {
	if (supress.$ === 1) {
		return 'All Rows';
	} else {
		if (!supress.a) {
			var _v1 = supress.a;
			return 'Muted rows';
		} else {
			var _v2 = supress.a;
			return 'Umuted rows';
		}
	}
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$supressFilterDropdownOptions = function (currentSupress) {
	var supressToItem = function (supress) {
		return A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$SupressSelected(supress)),
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(currentSupress, supress))
				]),
			$elm$html$Html$text(
				$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$supressToLabel(supress)));
	};
	return _List_fromArray(
		[
			supressToItem($elm$core$Maybe$Nothing),
			$author$project$Ui$Dropdown$separator,
			supressToItem(
			$elm$core$Maybe$Just(0)),
			supressToItem(
			$elm$core$Maybe$Just(1))
		]);
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$viewSupressFilterDropdown = function (model) {
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$supressToLabel(model.J1))
			]),
		$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$supressFilterDropdownOptions(model.J1),
		model.qp);
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$SortTable = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$isFailedRow = function (resultType) {
	return !resultType;
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$columns = function (resultType) {
	var reviewedColumn = A3($author$project$Api$Column$init, 'reviewed', false, 'Reviewed');
	var messagesColumnId = $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$isFailedRow(resultType) ? 'upload_row_results_error_code' : 'upload_row_results_message';
	return $elm$core$List$concat(
		_List_fromArray(
			[
				_List_fromArray(
				[
					A3($author$project$Api$Column$init, 'row_number', true, 'Row #'),
					A3($author$project$Api$Column$init, 'patient_ident', false, 'Platform Patient'),
					A3($author$project$Api$Column$init, 'external_id', false, 'External ID'),
					A3($author$project$Api$Column$init, 'first_name', false, 'First Name'),
					A3($author$project$Api$Column$init, 'last_name', false, 'Last Name'),
					A3($author$project$Api$Column$init, 'current_dob', false, 'Dob')
				]),
				function () {
				switch (resultType) {
					case 0:
						return _List_Nil;
					case 1:
						return _List_Nil;
					default:
						return _List_fromArray(
							[
								A3($author$project$Api$Column$init, 'actions', false, 'Processing Result')
							]);
				}
			}(),
				_List_fromArray(
				[
					A3($author$project$Api$Column$init, messagesColumnId, false, 'Processing Desc.')
				]),
				function () {
				switch (resultType) {
					case 0:
						return _List_fromArray(
							[
								A3($author$project$Api$Column$init, 'supress_status', false, 'Status')
							]);
					case 1:
						return _List_Nil;
					default:
						return _List_Nil;
				}
			}(),
				function () {
				switch (resultType) {
					case 0:
						return _List_fromArray(
							[reviewedColumn]);
					case 1:
						return _List_fromArray(
							[reviewedColumn]);
					default:
						return _List_Nil;
				}
			}(),
				_List_fromArray(
				[
					A3($author$project$Api$Column$init, 'controls', false, 'Actions')
				])
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$SupressRow = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$UnsupressRow = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$UpdateRowReviewed = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$ViewRawRow = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$ViewRowMessages = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Api$Common$UploadRowResult$Data$currentDob = function (_v0) {
	var record = _v0;
	return record.Pf;
};
var $author$project$Api$Common$UploadRowResult$Data$externalId = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Common$UploadRowResult$Data$firstName = function (_v0) {
	var record = _v0;
	return record.Sv;
};
var $author$project$Api$Employer$UploadRow$Shared$isSupressed = function (_v0) {
	var record = _v0;
	return record.Ve;
};
var $author$project$Api$Employer$UploadRow$All$isSupressed = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$UploadRow$Shared$isSupressed(shared);
};
var $author$project$Api$Provider$UploadRow$Shared$isSupressed = function (_v0) {
	var record = _v0;
	return record.Ve;
};
var $author$project$Api$Provider$UploadRow$All$isSupressed = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$UploadRow$Shared$isSupressed(shared);
};
var $author$project$Api$UploadRow$All$isSupressed = function (uploadRow) {
	if (!uploadRow.$) {
		var uploadRow_ = uploadRow.a;
		return $author$project$Api$Provider$UploadRow$All$isSupressed(uploadRow_);
	} else {
		var uploadRow_ = uploadRow.a;
		return $author$project$Api$Employer$UploadRow$All$isSupressed(uploadRow_);
	}
};
var $author$project$Api$Common$UploadRowResult$Data$lastName = function (_v0) {
	var record = _v0;
	return record.VH;
};
var $author$project$Api$Common$UploadRowResult$Data$patientIdent = function (_v0) {
	var record = _v0;
	return record.Y_;
};
var $author$project$Api$Employer$UploadRow$All$resultData = function (_v0) {
	var record = _v0.b;
	return record.$V;
};
var $author$project$Api$Provider$UploadRow$All$resultData = function (_v0) {
	var record = _v0.b;
	return record.$V;
};
var $author$project$Api$UploadRow$All$resultData = function (uploadRow) {
	if (!uploadRow.$) {
		var uploadRow_ = uploadRow.a;
		return $author$project$Api$Provider$UploadRow$All$resultData(uploadRow_);
	} else {
		var uploadRow_ = uploadRow.a;
		return $author$project$Api$Employer$UploadRow$All$resultData(uploadRow_);
	}
};
var $author$project$Api$Employer$UploadRow$Shared$reviewed = function (_v0) {
	var record = _v0;
	return record.$3;
};
var $author$project$Api$Employer$UploadRow$All$reviewed = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$UploadRow$Shared$reviewed(shared);
};
var $author$project$Api$Provider$UploadRow$Shared$reviewed = function (_v0) {
	var record = _v0;
	return record.$3;
};
var $author$project$Api$Provider$UploadRow$All$reviewed = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$UploadRow$Shared$reviewed(shared);
};
var $author$project$Api$UploadRow$All$reviewed = function (uploadRow) {
	if (!uploadRow.$) {
		var uploadRow_ = uploadRow.a;
		return $author$project$Api$Provider$UploadRow$All$reviewed(uploadRow_);
	} else {
		var uploadRow_ = uploadRow.a;
		return $author$project$Api$Employer$UploadRow$All$reviewed(uploadRow_);
	}
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$uploadRowMessages = function (uploadRowResults) {
	return $elm_community$list_extra$List$Extra$unique(
		$elm$core$List$concat(
			A2(
				$elm$core$List$filterMap,
				function (uploadRowResult) {
					return A2(
						$elm$core$Maybe$map,
						$elm$core$String$split('|'),
						$author$project$Api$UploadRowResult$Shared$message(uploadRowResult));
				},
				uploadRowResults)));
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$viewRow = F2(
	function (model, uploadRow) {
		var uploadRowResults = A2(
			$elm$core$List$filterMap,
			function (uploadRowResult) {
				return A2(
					$elm$core$Maybe$andThen,
					function (resultType) {
						var _v7 = model.$W;
						switch (_v7) {
							case 1:
								return A2(
									$elm$core$List$member,
									resultType,
									_List_fromArray(
										['warning', 'duplicate_ignored'])) ? $elm$core$Maybe$Just(uploadRowResult) : $elm$core$Maybe$Nothing;
							case 0:
								return (resultType === 'error') ? $elm$core$Maybe$Just(uploadRowResult) : $elm$core$Maybe$Nothing;
							default:
								return (resultType !== 'warning') ? $elm$core$Maybe$Just(uploadRowResult) : $elm$core$Maybe$Nothing;
						}
					},
					$author$project$Api$UploadRowResult$Shared$resultType(uploadRowResult));
			},
			$author$project$Api$UploadRow$All$uploadRowResults(uploadRow));
		var uploadRowResultData = $author$project$Api$UploadRow$All$resultData(uploadRow);
		var rowNumber = $author$project$Api$UploadRow$All$rowNumber(uploadRow);
		var patientIdent = A2($elm$core$Maybe$andThen, $author$project$Api$Common$UploadRowResult$Data$patientIdent, uploadRowResultData);
		var messages = $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$uploadRowMessages(uploadRowResults);
		var loading = A2(
			$elm$core$Set$member,
			$author$project$Api$UploadRow$All$id(uploadRow),
			model.bO);
		var reviewedColumn = A2(
			$author$project$Ui$Table$cell,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Checkbox$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Checkbox$value(
							$author$project$Api$UploadRow$All$reviewed(uploadRow)),
							$author$project$Ui$Form$Checkbox$onCheck(
							$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$UpdateRowReviewed(uploadRow)),
							$author$project$Ui$Form$Checkbox$loading(loading)
						]),
					_List_Nil)
				]));
		var canGoToPatients = A3($author$project$Permission$canGoTo, model.aa4, model.ahK, 50);
		var blank = A2(
			$author$project$Ui$Typography$em,
			_List_fromArray(
				[$author$project$Ui$Typography$muted]),
			_List_fromArray(
				[
					$elm$html$Html$text('Blank')
				]));
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(rowNumber))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									function () {
									var _v0 = _Utils_Tuple2(patientIdent, canGoToPatients);
									if (!_v0.a.$) {
										if (_v0.b) {
											var patientIdent_ = _v0.a.a;
											return A3(
												$author$project$Ui$Link$route,
												$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
													{YZ: patientIdent_}),
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(patientIdent_)
													]));
										} else {
											var patientIdent_ = _v0.a.a;
											return $elm$html$Html$text(patientIdent_);
										}
									} else {
										var _v1 = _v0.a;
										return blank;
									}
								}()
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$phi]),
									_List_fromArray(
										[
											A2(
											$elm$core$Maybe$withDefault,
											blank,
											A2(
												$elm$core$Maybe$map,
												$elm$html$Html$text,
												A2($elm$core$Maybe$andThen, $author$project$Api$Common$UploadRowResult$Data$externalId, uploadRowResultData)))
										]))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$phi]),
									_List_fromArray(
										[
											A2(
											$elm$core$Maybe$withDefault,
											blank,
											A2(
												$elm$core$Maybe$map,
												$elm$html$Html$text,
												A2($elm$core$Maybe$andThen, $author$project$Api$Common$UploadRowResult$Data$firstName, uploadRowResultData)))
										]))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$phi]),
									_List_fromArray(
										[
											A2(
											$elm$core$Maybe$withDefault,
											blank,
											A2(
												$elm$core$Maybe$map,
												$elm$html$Html$text,
												A2($elm$core$Maybe$andThen, $author$project$Api$Common$UploadRowResult$Data$lastName, uploadRowResultData)))
										]))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$phi]),
									_List_fromArray(
										[
											A2(
											$elm$core$Maybe$withDefault,
											blank,
											A2(
												$elm$core$Maybe$map,
												$elm$html$Html$text,
												A2($elm$core$Maybe$andThen, $author$project$Api$Common$UploadRowResult$Data$currentDob, uploadRowResultData)))
										]))
								]))
						]),
						function () {
						var _v2 = model.$W;
						switch (_v2) {
							case 0:
								return _List_Nil;
							case 1:
								return _List_Nil;
							default:
								var results = A2(
									$elm$core$List$map,
									A2($elm$core$Basics$composeR, $author$project$Formatters$String$humanize, $author$project$Formatters$String$titleize),
									$elm_community$list_extra$List$Extra$unique(
										A2(
											$elm$core$List$filterMap,
											function (uploadRowResult) {
												return A2(
													$elm$core$Maybe$andThen,
													function (resultType) {
														var _v3 = model.$W;
														switch (_v3) {
															case 1:
																return A2(
																	$elm$core$List$member,
																	resultType,
																	_List_fromArray(
																		['warning', 'duplicate_ignored'])) ? $elm$core$Maybe$Just(resultType) : $elm$core$Maybe$Nothing;
															case 0:
																return (resultType === 'error') ? $elm$core$Maybe$Just(resultType) : $elm$core$Maybe$Nothing;
															default:
																return (resultType !== 'warning') ? $elm$core$Maybe$Just(resultType) : $elm$core$Maybe$Nothing;
														}
													},
													$author$project$Api$UploadRowResult$Shared$resultType(uploadRowResult));
											},
											uploadRowResults)));
								var resultsString = $elm$core$List$isEmpty(results) ? 'No Account Change' : A2($elm$core$String$join, ' - ', results);
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$Table$cell,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$phi]),
												_List_fromArray(
													[
														$elm$html$Html$text(resultsString)
													]))
											]))
									]);
						}
					}(),
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$phi]),
									($elm$core$List$length(messages) > 1) ? _List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$author$project$Formatters$String$ellipsis,
												100,
												A2($elm$core$String$join, ', ', messages))),
											$author$project$Utils$Html$noBreakSpace,
											A3(
											$author$project$Ui$Button$view,
											{mm: 'View all row messages'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick(
													A2($author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$ViewRowMessages, rowNumber, messages))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('View all >')
												]))
										]) : _List_fromArray(
										[
											$elm$html$Html$text(
											A2($elm$core$String$join, ', ', messages))
										]))
								]))
						]),
						function () {
						var _v4 = model.$W;
						switch (_v4) {
							case 0:
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$Table$cell,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Api$UploadRow$All$isSupressed(uploadRow) ? $elm$html$Html$text('Muted') : $elm$html$Html$text('Unmuted')
											]))
									]);
							case 1:
								return _List_Nil;
							default:
								return _List_Nil;
						}
					}(),
						function () {
						var _v5 = model.$W;
						switch (_v5) {
							case 0:
								return _List_fromArray(
									[reviewedColumn]);
							case 1:
								return _List_fromArray(
									[reviewedColumn]);
							default:
								return _List_Nil;
						}
					}(),
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_fromArray(
								[
									$author$project$Ui$Table$colspan(2)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{mm: 'View raw row details'},
									_List_fromArray(
										[
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$ViewRawRow(uploadRow))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('CSV Data')
										])),
									$author$project$Utils$Html$noBreakSpace,
									function () {
									var _v6 = _Utils_Tuple2(
										$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$isFailedRow(model.$W),
										$author$project$Api$UploadRow$All$isSupressed(uploadRow));
									if (_v6.a) {
										if (_v6.b) {
											return A3(
												$author$project$Ui$Button$view,
												{mm: 'Unmute'},
												_List_fromArray(
													[
														$author$project$Ui$Button$sm,
														$author$project$Ui$Button$onClick(
														$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$UnsupressRow(uploadRow)),
														$author$project$Ui$Button$loading(loading)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Unmute')
													]));
										} else {
											return A3(
												$author$project$Ui$Button$view,
												{mm: 'Mute'},
												_List_fromArray(
													[
														$author$project$Ui$Button$sm,
														$author$project$Ui$Button$onClick(
														$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$SupressRow(uploadRow)),
														$author$project$Ui$Button$loading(loading)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Mute')
													]));
										}
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								]))
						])
					])));
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$viewTable = function (model) {
	var _v0 = function () {
		var _v1 = model.vk;
		if (_v1.$ === 3) {
			var uploadRows_ = _v1.a;
			return _Utils_Tuple2(false, uploadRows_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var uploadRows = _v0.b;
	return A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any data for the filters selected.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$map,
					$author$project$Api$Column$view(
						A2($author$project$Api$Column$Sortable, model.alA, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$SortTable)),
					$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$columns(model.$W)),
					$author$project$Utils$Maybe$toBool(model.nD) ? _List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[$author$project$Ui$Table$textRight]),
						_List_fromArray(
							[
								A2($elm$html$Html$map, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$ExportCsvMsg, $author$project$Components$ExportCsv$button)
							]))
					]) : _List_Nil
				])),
		A2(
			$elm$core$List$map,
			$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$viewRow(model),
			uploadRows),
		_List_Nil);
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$actionToLabel = function (maybeAction) {
	if (maybeAction.$ === 1) {
		return 'All Actions';
	} else {
		var action = maybeAction.a;
		switch (action) {
			case 0:
				return 'No Account Change';
			case 1:
				return 'Dob Updated';
			case 2:
				return 'New Patient';
			case 3:
				return 'Enrolled';
			case 4:
				return 'Restarted';
			case 5:
				return 'Terminated by End Date';
			case 7:
				return 'End Date Updated';
			case 6:
				return 'Membership Changed';
			case 8:
				return 'New Company';
			default:
				return 'Plan Changed';
		}
	}
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$ResultActionSelected = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$uploadRowResultsResultTypeDropdownOptions = function (currentType) {
	var actionToItem = function (action) {
		return A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$ResultActionSelected(action)),
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(currentType, action))
				]),
			$elm$html$Html$text(
				$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$actionToLabel(action)));
	};
	return A2(
		$elm$core$List$cons,
		actionToItem($elm$core$Maybe$Nothing),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$Dropdown$separator,
			A2(
				$elm$core$List$map,
				A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, actionToItem),
				_List_fromArray(
					[0, 1, 2, 3, 4, 5, 7, 6, 8, 9]))));
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$viewUploadRowResultsResultTypeDropdown = function (model) {
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$actionToLabel(model.h6))
			]),
		$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$uploadRowResultsResultTypeDropdownOptions(model.h6),
		model.qU);
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				function () {
				var _v0 = model.qT;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var rowNumber = _v1.a;
					var messages = _v1.b;
					var title = 'Row #' + ($elm$core$String$fromInt(rowNumber) + ' Processing Description');
					return A3($author$project$Components$Upload$RowDescriptionDetailsModal$view, title, messages, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$RowMessagesModalClosed);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v2 = model.kQ;
				if (!_v2.$) {
					var rawRowModal = _v2.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$RawRowModalMsg,
						$author$project$Components$Upload$RawRowModal$view(rawRowModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v3 = model.nD;
				if (!_v3.$) {
					var exportCsv = _v3.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$ExportCsvMsg,
						A3(
							$author$project$Components$ExportCsv$modal,
							model.Gv,
							_List_fromArray(
								[
									$author$project$Components$ExportCsv$params(
									$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$exportUploadRowsParams(model)),
									$author$project$Components$ExportCsv$path(
									$author$project$Api$Provider$UploadRow$uploadRowsPath(model.Kj))
								]),
							exportCsv));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A6(
				$author$project$Layouts$Company$Uploads$view,
				model.aa4,
				model.ZV,
				model.afQ,
				model.jL,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$elm$core$Basics$never,
										A2(
											$author$project$Ui$Breadcrumb$view,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Breadcrumb$item,
													_List_Nil,
													_List_fromArray(
														[
															A3(
															$author$project$Ui$Link$route,
															$author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__Top(
																{fZ: model.fZ}),
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Uploads')
																]))
														])),
													A2(
													$author$project$Ui$Breadcrumb$item,
													_List_Nil,
													_List_fromArray(
														[
															A3(
															$author$project$Ui$Link$route,
															$author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__UploadId_String__Top(
																{fZ: model.fZ, Kj: model.Kj}),
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(model.Kj)
																]))
														])),
													A2(
													$author$project$Ui$Breadcrumb$item,
													_List_fromArray(
														[
															$author$project$Ui$Breadcrumb$active(true)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$resultTypeToTitle(model.$W))
														]))
												]))),
										$author$project$Ui$HorizontalRule$view(_List_Nil),
										A2(
										$author$project$Ui$Grid$row,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Grid$column,
												_List_fromArray(
													[
														$author$project$Ui$Grid$offset(6),
														$author$project$Ui$Grid$span(6),
														$author$project$Ui$Grid$spanSm(3),
														$author$project$Ui$Grid$offsetSm(9)
													]),
												_List_fromArray(
													[
														function () {
														var _v4 = model.$W;
														switch (_v4) {
															case 0:
																return $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$viewSupressFilterDropdown(model);
															case 1:
																return $author$project$Utils$Html$empty;
															default:
																return $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$viewUploadRowResultsResultTypeDropdown(model);
														}
													}()
													]))
											])),
										A2($elm$html$Html$br, _List_Nil, _List_Nil),
										A2(
										$author$project$Ui$Grid$row,
										_List_fromArray(
											[$author$project$Ui$Grid$mb2]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Grid$column,
												_List_fromArray(
													[
														$author$project$Ui$Grid$span(12)
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Form$Group$view,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$map,
																$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$SearchInputMsg,
																A2(
																	$author$project$Ui$SearchInput$view,
																	_List_fromArray(
																		[
																			$author$project$Ui$SearchInput$placeholder('Search by first or last name')
																		]),
																	model.up))
															]))
													]))
											])),
										$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$viewTable(model)
									]))
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$PaginationMsg,
						A2(
							$author$project$Api$Pagination$view,
							_List_fromArray(
								[
									$author$project$Ui$Pagination$List$loading(
									!$author$project$Utils$Maybe$toBool(
										$author$project$Api$Data$toMaybe(model.vk)))
								]),
							model.ajJ))
					]))
			]),
		ac9: A2($author$project$Api$Practice$sponsorize, model.ZV, 'Companies') + ' | Employee Uploads'
	};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$page = $author$project$Spa$Page$applicationCompanyOrEmployer(
	{ah_: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$init, aiq: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$load, k8: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$save, alO: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$subscriptions, adT: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$update, amo: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$view});
var $author$project$Pages$Companies$New$GotPracticeCompanyInvoiceSetting = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Companies$New$LocationResourceFilterMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Companies$New$PlanResourceFilterMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Companies$New$init = F4(
	function (session, practice, _v0, _v1) {
		var apiClient = _v0.Gv;
		var currentDate = _v0.dd;
		var practiceCompanyInvoiceSettingId = $author$project$Api$Provider$CompanyInvoiceSetting$Shared$id(
			$author$project$Api$Provider$Practice$One$companyInvoiceSetting(practice));
		var _v2 = A4(
			$author$project$Components$ResourceFilter$Plan$init,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{
						De: _List_fromArray(
							[0, 1, 3])
					});
			},
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Select a Plan'});
			});
		var planResourceFilter = _v2.a;
		var planResourceFilterCmd = _v2.b;
		var _v3 = A4(
			$author$project$Components$ResourceFilter$Location$init,
			apiClient,
			$elm$core$Maybe$Nothing,
			$elm$core$Basics$identity,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'All Locations'});
			});
		var locationResourceFilter = _v3.a;
		var locationResourceFilterCmd = _v3.b;
		return _Utils_Tuple2(
			{
				Gv: apiClient,
				GF: false,
				afQ: $author$project$Api$Data$NotAsked,
				bs: $elm$core$Maybe$Nothing,
				dd: currentDate,
				os: locationResourceFilter,
				hi: planResourceFilter,
				ZV: practice,
				Ed: $author$project$Api$Provider$Practice$One$requiresDefaultLocationForCompanies(practice)
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3($author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$retrieve, apiClient, practiceCompanyInvoiceSettingId, $author$project$Pages$Companies$New$GotPracticeCompanyInvoiceSetting),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$New$PlanResourceFilterMsg, planResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$New$LocationResourceFilterMsg, locationResourceFilterCmd)
					])));
	});
var $author$project$Pages$Companies$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Companies$New$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Companies$New$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Companies$New$LocationResourceFilterMsg,
				$author$project$Components$ResourceFilter$Location$subscriptions(model.os)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Companies$New$PlanResourceFilterMsg,
				$author$project$Components$ResourceFilter$Plan$subscriptions(model.hi))
			]));
};
var $author$project$Pages$Companies$New$DefaultLocation = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Companies$New$DefaultPlan = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Companies$New$companyFormFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{Bq: string});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{P8: string});
			case 2:
				var string = field.a;
				return _Utils_update(
					fields,
					{P$: string});
			default:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						MH: $elm$core$Maybe$Just(string)
					});
		}
	});
var $author$project$Pages$Companies$New$DefaultPlanValidation = 1;
var $author$project$Pages$Companies$New$NameValidation = 0;
var $author$project$Pages$Companies$New$DefaultLocationValidation = 2;
var $author$project$Pages$Companies$New$validateDefaultLocation = F2(
	function (requireDefaultLocationForCompanies, form) {
		var _v0 = _Utils_Tuple2(requireDefaultLocationForCompanies, form.P$);
		if (_v0.a && (_v0.b.$ === 1)) {
			var _v1 = _v0.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(2, 'Please select a location.')
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Pages$Companies$New$companyFormFieldsValidator = function (requireDefaultLocationForCompanies) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_validate$Validate$ifBlank,
				function ($) {
					return $.Bq;
				},
				_Utils_Tuple2(0, 'Please enter a company name.')),
				A2(
				$rtfeldman$elm_validate$Validate$ifBlank,
				function ($) {
					return $.P8;
				},
				_Utils_Tuple2(1, 'Please select a plan.')),
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Pages$Companies$New$validateDefaultLocation(requireDefaultLocationForCompanies))
			]));
};
var $author$project$Pages$Companies$New$GotCompany = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Company$create = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'company',
					$elm$json$Json$Encode$object(
						$elm$core$List$concat(
							_List_fromArray(
								[
									_List_fromArray(
									[
										_Utils_Tuple2(
										'name',
										$elm$json$Json$Encode$string(fields.Bq)),
										_Utils_Tuple2(
										'default_plan',
										$elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'id',
													$elm$json$Json$Encode$string(fields.P9))
												]))),
										_Utils_Tuple2(
										'billing_start_date',
										A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.MH))
									]),
									function () {
									var _v0 = fields.P0;
									if (!_v0.$) {
										var string = _v0.a;
										return _List_fromArray(
											[
												_Utils_Tuple2(
												'default_location',
												$elm$json$Json$Encode$object(
													_List_fromArray(
														[
															_Utils_Tuple2(
															'id',
															$elm$json$Json$Encode$string(string))
														])))
											]);
									} else {
										return _List_Nil;
									}
								}()
								]))))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Company$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Company$companiesPath)));
	});
var $author$project$Pages$Companies$New$createCompany = F3(
	function (practice, apiClient, companyFormFields) {
		var validFields = $rtfeldman$elm_validate$Validate$fromValid(companyFormFields);
		var defaultPlanId = validFields.P8;
		var defaultLocationId = validFields.P$;
		var billingStartDate = A2($author$project$Api$Provider$Practice$One$featureEnabled, 7, practice) ? A2(
			$elm$core$Maybe$andThen,
			A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromIsoString, $elm$core$Result$toMaybe),
			validFields.MH) : $elm$core$Maybe$Nothing;
		return A3(
			$author$project$Api$Provider$Company$create,
			apiClient,
			{MH: billingStartDate, P0: defaultLocationId, P9: defaultPlanId, Bq: validFields.Bq},
			$author$project$Pages$Companies$New$GotCompany);
	});
var $author$project$Pages$Companies$New$initCompanyFormFields = function (billingStartDate) {
	return {MH: billingStartDate, P$: $elm$core$Maybe$Nothing, P8: '', Bq: ''};
};
var $author$project$Pages$Companies$New$createCompanyForm = F2(
	function (billingEnabled, billingStartDate) {
		var billingStartDateDefaultSelectedValue = billingEnabled ? $author$project$Utils$Date$toIsoString(billingStartDate) : '';
		return $author$project$Utils$Form$init(
			$author$project$Pages$Companies$New$initCompanyFormFields(
				$author$project$Utils$String$toMaybe(billingStartDateDefaultSelectedValue)));
	});
var $author$project$Pages$Companies$New$viewBillingStartDateOptions = function (currentDate) {
	var billingStartDate = $author$project$Utils$Date$toBeginningOfMonth(currentDate);
	return _Utils_Tuple2(
		billingStartDate,
		$author$project$Ui$Form$Select$dateOptions(
			$author$project$Utils$Date$nextTwelveMonths(billingStartDate)));
};
var $author$project$Pages$Companies$New$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var _v1 = model.bs;
				if (!_v1.$) {
					var newCompanyForm = _v1.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bs: $elm$core$Maybe$Just(
									A3($author$project$Utils$Form$update, $author$project$Pages$Companies$New$companyFormFieldsUpdate, field, newCompanyForm))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 1:
				var subMsg = msg.a;
				var _v2 = model.bs;
				if (!_v2.$) {
					var newCompanyForm = _v2.a;
					var planResourceResult = A3($author$project$Components$ResourceFilter$Plan$update, model.Gv, subMsg, model.hi);
					var modelAfterEvent = function () {
						var _v3 = planResourceResult.agZ;
						if (!_v3.$) {
							return _Utils_update(
								model,
								{
									bs: $elm$core$Maybe$Just(
										A3(
											$author$project$Utils$Form$update,
											$author$project$Pages$Companies$New$companyFormFieldsUpdate,
											$author$project$Pages$Companies$New$DefaultPlan(
												A2(
													$elm$core$Maybe$withDefault,
													'',
													$author$project$Components$ResourceFilter$Plan$value(planResourceResult.aiO))),
											newCompanyForm))
								});
						} else {
							return model;
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							modelAfterEvent,
							{hi: planResourceResult.aiO}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$New$PlanResourceFilterMsg, planResourceResult.GZ),
						planResourceResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				var subMsg = msg.a;
				var _v4 = model.bs;
				if (!_v4.$) {
					var newCompanyForm = _v4.a;
					var locationResourceResult = A3($author$project$Components$ResourceFilter$Location$update, model.Gv, subMsg, model.os);
					var modelAfterEvent = function () {
						var _v5 = locationResourceResult.agZ;
						if (!_v5.$) {
							return _Utils_update(
								model,
								{
									bs: $elm$core$Maybe$Just(
										A3(
											$author$project$Utils$Form$update,
											$author$project$Pages$Companies$New$companyFormFieldsUpdate,
											$author$project$Pages$Companies$New$DefaultLocation(
												$author$project$Components$ResourceFilter$Location$value(locationResourceResult.aiO)),
											newCompanyForm))
								});
						} else {
							return model;
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							modelAfterEvent,
							{os: locationResourceResult.aiO}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$New$LocationResourceFilterMsg, locationResourceResult.GZ),
						locationResourceResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var _v6 = model.bs;
				if (!_v6.$) {
					var newCompanyForm = _v6.a;
					var _v7 = A2(
						$author$project$Utils$Form$validate,
						$author$project$Pages$Companies$New$companyFormFieldsValidator(model.Ed),
						newCompanyForm);
					if (!_v7.$) {
						var _v8 = _v7.a;
						var newForm = _v8.a;
						var validFormFields = _v8.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									afQ: $author$project$Api$Data$Loading,
									bs: $elm$core$Maybe$Just(newForm)
								}),
							A3($author$project$Pages$Companies$New$createCompany, model.ZV, model.Gv, validFormFields),
							_List_Nil);
					} else {
						var newForm = _v7.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bs: $elm$core$Maybe$Just(newForm)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					var company = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{afQ: response}),
						$author$project$Ports$Navigation$pushUrl(
							'/companies/' + $author$project$Api$Provider$Company$One$id(company)),
						_List_fromArray(
							[
								A2(
								$author$project$OutMsg$ShowToast,
								3,
								$author$project$Api$Provider$Company$One$name(company) + ' created')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{afQ: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var practiceSettings = response.a;
					var billingEnabled = A2($author$project$Api$Provider$Practice$One$featureEnabled, 7, model.ZV) ? $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$billingEnabled(practiceSettings) : false;
					var _v11 = $author$project$Pages$Companies$New$viewBillingStartDateOptions(model.dd);
					var billingStartDate = _v11.a;
					var newForm = A2($author$project$Pages$Companies$New$createCompanyForm, billingEnabled, billingStartDate);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								GF: billingEnabled,
								bs: $elm$core$Maybe$Just(newForm)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Companies$New$CreateCompany = {$: 3};
var $author$project$Pages$Companies$New$BillingStartDate = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Companies$New$CompanyFormFieldUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Companies$New$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Practice$One$notRetailPlansCount = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.XZ;
	});
var $author$project$Pages$Companies$New$viewPanelBody = function (model) {
	var _v0 = model.bs;
	if (!_v0.$) {
		var newCompanyForm = _v0.a;
		if ($author$project$Api$Provider$Practice$One$notRetailPlansCount(model.ZV) > 0) {
			var _v1 = $author$project$Utils$Form$fields(newCompanyForm);
			var name = _v1.Bq;
			var _v2 = $author$project$Pages$Companies$New$viewBillingStartDateOptions(model.dd);
			var billingStartDate = _v2.a;
			var billingStartDateOptions = _v2.b;
			return $elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label(
									'Name the ' + A2($author$project$Formatters$String$sponsorize, model.ZV, 'Employer')),
									$author$project$Ui$Form$Group$labelSpan(4),
									$author$project$Ui$Form$Group$inputSpan(8),
									$author$project$Ui$Form$Group$required(true)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$autofocus(true),
											$author$project$Ui$Form$Input$value(name),
											$author$project$Ui$Form$Input$placeholder(
											'New ' + (A2($author$project$Formatters$String$sponsorize, model.ZV, 'Employer') + ' Name')),
											$author$project$Ui$Form$Input$onInput(
											A2($elm$core$Basics$composeL, $author$project$Pages$Companies$New$CompanyFormFieldUpdated, $author$project$Pages$Companies$New$Name)),
											$author$project$Ui$Form$Input$invalid(
											A2($author$project$Utils$Form$hasValidationErrors, 0, newCompanyForm)),
											$author$project$Ui$Form$Input$errors(
											A2($author$project$Utils$Form$validationErrors, 0, newCompanyForm))
										]))
								])),
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Default Plan'),
									$author$project$Ui$Form$Group$labelSpan(4),
									$author$project$Ui$Form$Group$inputSpan(8),
									$author$project$Ui$Form$Group$required(true)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Pages$Companies$New$PlanResourceFilterMsg,
									A2(
										$author$project$Components$ResourceFilter$Plan$view,
										_List_fromArray(
											[
												$author$project$Components$ResourceFilter$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, 1, newCompanyForm)),
												$author$project$Components$ResourceFilter$errors(
												A2($author$project$Utils$Form$validationErrors, 1, newCompanyForm))
											]),
										model.hi))
								])),
							model.GF ? A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Billing Start Date'),
									$author$project$Ui$Form$Group$labelSpan(4),
									$author$project$Ui$Form$Group$inputSpan(8),
									$author$project$Ui$Form$Group$required(true)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Select$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Select$value(
											$elm$core$Maybe$Just(
												$author$project$Utils$Date$toIsoString(billingStartDate))),
											$author$project$Ui$Form$Select$onChange(
											A2($elm$core$Basics$composeL, $author$project$Pages$Companies$New$CompanyFormFieldUpdated, $author$project$Pages$Companies$New$BillingStartDate))
										]),
									billingStartDateOptions)
								])) : $author$project$Utils$Html$empty
						]),
						model.Ed ? _List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Default Location'),
									$author$project$Ui$Form$Group$labelSpan(4),
									$author$project$Ui$Form$Group$inputSpan(8),
									$author$project$Ui$Form$Group$required(true)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Pages$Companies$New$LocationResourceFilterMsg,
									A2(
										$author$project$Components$ResourceFilter$Location$view,
										_List_fromArray(
											[
												$author$project$Components$ResourceFilter$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, 2, newCompanyForm)),
												$author$project$Components$ResourceFilter$errors(
												A2($author$project$Utils$Form$validationErrors, 2, newCompanyForm))
											]),
										model.os))
								]))
						]) : _List_Nil
					]));
		} else {
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$itemsEnd, $author$project$Ui$Element$gap2]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('It looks like you haven\'t added any '),
									$elm$html$Html$text(
									A2($author$project$Formatters$String$sponsorize, model.ZV, 'employer')),
									$elm$html$Html$text(' plan yet.')
								])),
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Admin__CompanyPlans__New,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Create one?')
								]))
						]))
				]);
		}
	} else {
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSkeleton(
						'Name the ' + A2($author$project$Formatters$String$sponsorize, model.ZV, 'Employer')),
						$author$project$Ui$Form$Group$labelSpan(4),
						$author$project$Ui$Form$Group$inputSpan(8)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Skeleton$input(_List_Nil)
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSkeleton('Default Plan'),
						$author$project$Ui$Form$Group$labelSpan(4),
						$author$project$Ui$Form$Group$inputSpan(8)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Skeleton$input(_List_Nil)
					])),
				model.GF ? A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Billing Start Date'),
						$author$project$Ui$Form$Group$labelSpan(4),
						$author$project$Ui$Form$Group$inputSpan(8)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Skeleton$input(_List_Nil)
					])) : $author$project$Utils$Html$empty
			]);
	}
};
var $author$project$Pages$Companies$New$viewPanelFooter = function (_v0) {
	var practice = _v0.ZV;
	var company = _v0.afQ;
	return ($author$project$Api$Provider$Practice$One$notRetailPlansCount(practice) > 0) ? _List_fromArray(
		[
			A3(
			$author$project$Ui$Link$route,
			$author$project$Spa$Generated$Route$Companies__Top,
			_List_fromArray(
				[$author$project$Ui$Link$buttonSecondary]),
			_List_fromArray(
				[
					$elm$html$Html$text('Cancel')
				])),
			A3(
			$author$project$Ui$Button$view,
			{
				mm: 'Create New ' + A2($author$project$Formatters$String$sponsorize, practice, 'Employer')
			},
			_List_fromArray(
				[
					$author$project$Ui$Button$primary,
					$author$project$Ui$Button$submit,
					$author$project$Ui$Button$loading(
					_Utils_eq(company, $author$project$Api$Data$Loading))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					'Create New ' + A2($author$project$Formatters$String$sponsorize, practice, 'Employer'))
				]))
		]) : _List_Nil;
};
var $author$project$Pages$Companies$New$viewBody = function (model) {
	return A2(
		$author$project$Ui$Form$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$noValidate(true),
				$author$project$Ui$Form$autocomplete(false),
				$author$project$Ui$Form$onSubmit($author$project$Pages$Companies$New$CreateCompany)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text(
										'Create New ' + A2($author$project$Formatters$String$sponsorize, model.ZV, 'Employer'))
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						$author$project$Pages$Companies$New$viewPanelBody(model)),
						A2(
						$author$project$Ui$Panel$footer,
						_List_fromArray(
							[$author$project$Ui$Element$justifyCenter]),
						$author$project$Pages$Companies$New$viewPanelFooter(model))
					]))
			]));
};
var $author$project$Pages$Companies$New$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				$author$project$Pages$Companies$New$viewBody(model)
			]),
		ac9: A2($author$project$Formatters$String$sponsorize, model.ZV, 'Employers')
	};
};
var $author$project$Pages$Companies$New$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Companies$New$init, aiq: $author$project$Pages$Companies$New$load, k8: $author$project$Pages$Companies$New$save, alO: $author$project$Pages$Companies$New$subscriptions, adT: $author$project$Pages$Companies$New$update, amo: $author$project$Pages$Companies$New$view});
var $author$project$Pages$Companies$Top$FilterDropdownMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$FeatureGate$ManageEmployers = 9;
var $author$project$Pages$Companies$Top$PlanResourceFilterMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Companies$Top$SponsorTypeDropdownMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$Company$EligibleCount = 1;
var $author$project$Api$Provider$Company$EnrolledCount = 2;
var $author$project$Pages$Companies$Top$GotCompanies = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Company$NeedsApprovalCount = 3;
var $author$project$Api$Provider$Company$OwedInCents = 4;
var $author$project$Api$Provider$Company$Plans = 0;
var $author$project$Pages$Companies$Top$filterToValue = function (filter) {
	switch (filter) {
		case 0:
			return '';
		case 1:
			return 'with_flagged_notes';
		case 2:
			return 'without_default_location';
		case 3:
			return 'without_broker_deals';
		case 4:
			return 'needs_approval_review';
		default:
			return 'archived';
	}
};
var $author$project$Pages$Companies$Top$sponsorTypeToValue = function (sponsorType) {
	switch (sponsorType) {
		case 0:
			return '';
		case 1:
			return 'network';
		default:
			return 'employer';
	}
};
var $author$project$Pages$Companies$Top$fetchCompanies = function (model) {
	return A3(
		$author$project$Api$Provider$Company$list,
		model.Gv,
		function (d) {
			return _Utils_update(
				d,
				{
					HE: _List_fromArray(
						[0, 1, 2, 3, 4]),
					HM: function () {
						var _v0 = model.HM;
						if (!_v0) {
							return $elm$core$Maybe$Nothing;
						} else {
							return $elm$core$Maybe$Just(
								$author$project$Pages$Companies$Top$filterToValue(model.HM));
						}
					}(),
					ajJ: model.ajJ,
					Jb: model.aj4,
					akl: model.akl,
					alA: model.alA,
					JT: function () {
						var _v1 = model.JT;
						if (!_v1) {
							return $elm$core$Maybe$Nothing;
						} else {
							return $elm$core$Maybe$Just(
								$author$project$Pages$Companies$Top$sponsorTypeToValue(model.JT));
						}
					}()
				});
		},
		$author$project$Pages$Companies$Top$GotCompanies);
};
var $author$project$Pages$Companies$Top$GotUpgradePricing = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Companies$Top$fetchUpgradePricing = function (apiClient) {
	return A2($author$project$Api$Provider$PracticePricing$Upgrade$retrieve, apiClient, $author$project$Pages$Companies$Top$GotUpgradePricing);
};
var $author$project$Pages$Companies$Top$All = 0;
var $author$project$Pages$Companies$Top$Archived = 5;
var $author$project$Pages$Companies$Top$NeedsApprovalReview = 4;
var $author$project$Pages$Companies$Top$WithFlaggedNotes = 1;
var $author$project$Pages$Companies$Top$WithoutBrokerDeals = 3;
var $author$project$Pages$Companies$Top$WithoutDefaultLocation = 2;
var $author$project$Pages$Companies$Top$filterFromQuery = function (queryString) {
	_v0$5:
	while (true) {
		if (!queryString.$) {
			switch (queryString.a) {
				case 'with_flagged_notes':
					return 1;
				case 'without_default_location':
					return 2;
				case 'without_broker_deals':
					return 3;
				case 'needs_approval_review':
					return 4;
				case 'archived':
					return 5;
				default:
					break _v0$5;
			}
		} else {
			break _v0$5;
		}
	}
	return 0;
};
var $author$project$Pages$Companies$Top$AllSponsorTypes = 0;
var $author$project$Pages$Companies$Top$Employer = 2;
var $author$project$Pages$Companies$Top$Network = 1;
var $author$project$Pages$Companies$Top$sponsorTypeFromQuery = function (queryString) {
	_v0$2:
	while (true) {
		if (!queryString.$) {
			switch (queryString.a) {
				case 'network':
					return 1;
				case 'employer':
					return 2;
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return 0;
};
var $author$project$Pages$Companies$Top$init = F4(
	function (session, practice, _v0, _v1) {
		var apiClient = _v0.Gv;
		var query = _v1.DE;
		var selfUpgradeEnabled = !A2(
			$author$project$Utils$FeatureGate$gateAvailable,
			9,
			$author$project$Api$Practice$Provider(practice));
		var q = A2($elm$core$Dict$get, 'q', query);
		var planId = A2($elm$core$Dict$get, 'plan', query);
		var _v2 = A4(
			$author$project$Components$ResourceFilter$Plan$init,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{
						De: _List_fromArray(
							[0, 1])
					});
			},
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'All Plans', akb: planId});
			});
		var planResourceFilter = _v2.a;
		var planResourceFilterCmd = _v2.b;
		var model = {
			Gv: apiClient,
			cr: $author$project$Api$Data$Loading,
			HM: $author$project$Pages$Companies$Top$filterFromQuery(
				A2($elm$core$Dict$get, 'filter', query)),
			nK: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'filter-dropdown-filter', al6: $author$project$Pages$Companies$Top$FilterDropdownMsg})),
			ajJ: $author$project$Api$Pagination$initFromQuery(query),
			aj4: planId,
			hi: planResourceFilter,
			ZV: practice,
			akl: q,
			up: $author$project$Ui$SearchInput$init(q),
			JF: selfUpgradeEnabled,
			aa4: session,
			alA: A3(
				$author$project$Api$Sort$withDefault,
				'name',
				0,
				$author$project$Api$Sort$initFromQuery(query)),
			JT: $author$project$Pages$Companies$Top$sponsorTypeFromQuery(
				A2($elm$core$Dict$get, 'sponsor_type', query)),
			ql: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'sponsor-type-dropdown-filter', al6: $author$project$Pages$Companies$Top$SponsorTypeDropdownMsg})),
			qS: $elm$core$Maybe$Nothing,
			lV: $elm$core$Maybe$Nothing
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$Top$PlanResourceFilterMsg, planResourceFilterCmd),
						$author$project$Pages$Companies$Top$fetchCompanies(model),
						(selfUpgradeEnabled && $author$project$Api$Platform$Session$One$userIsPracticeAdmin(session)) ? $author$project$Pages$Companies$Top$fetchUpgradePricing(apiClient) : $elm$core$Platform$Cmd$none
					])));
	});
var $author$project$Pages$Companies$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Companies$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Companies$Top$UpgradePracticeModalMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Companies$Top$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$Dropdown$subscriptions(model.nK),
				$author$project$Ui$Dropdown$subscriptions(model.ql),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Companies$Top$UpgradePracticeModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$UpgradePracticeModal$subscriptions, model.lV))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Companies$Top$PlanResourceFilterMsg,
				$author$project$Components$ResourceFilter$Plan$subscriptions(model.hi))
			]));
};
var $author$project$Pages$Companies$Top$SearchInputMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Companies$Top$updateUrl = F2(
	function (model, customPath) {
		var queryParams = _List_fromArray(
			[
				A2(
				$elm$core$Maybe$map,
				$elm$url$Url$Builder$string('q'),
				model.akl),
				function () {
				var _v0 = model.HM;
				if (!_v0) {
					return $elm$core$Maybe$Nothing;
				} else {
					return $elm$core$Maybe$Just(
						A2(
							$elm$url$Url$Builder$string,
							'filter',
							$author$project$Pages$Companies$Top$filterToValue(model.HM)));
				}
			}(),
				A2(
				$elm$core$Maybe$map,
				$elm$url$Url$Builder$string('plan'),
				model.aj4),
				function () {
				var _v1 = model.JT;
				if (!_v1) {
					return $elm$core$Maybe$Nothing;
				} else {
					return $elm$core$Maybe$Just(
						A2(
							$elm$url$Url$Builder$string,
							'sponsor_type',
							$author$project$Pages$Companies$Top$sponsorTypeToValue(model.JT)));
				}
			}()
			]);
		var urlParams = A2(
			$elm$core$List$append,
			$author$project$Api$Pagination$toPageQuery(model.ajJ),
			A2(
				$elm$core$List$append,
				$author$project$Api$Sort$toQuery(model.alA),
				A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)));
		return $author$project$Ports$Navigation$replaceUrl(
			A4(
				$elm$url$Url$Builder$custom,
				$elm$url$Url$Builder$Relative,
				_List_fromArray(
					[
						$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Companies__Top)
					]),
				urlParams,
				customPath));
	});
var $author$project$Pages$Companies$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cr: response,
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cr: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Ui$SearchInput$update, subMsg, model.up);
				var searchInput = _v2.a;
				var searchInputCmd = _v2.b;
				var searchInputEvent = _v2.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.akl;
					}
				}();
				var _v3 = function () {
					if (_Utils_eq(q, model.akl)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								cr: $author$project$Api$Data$Loading,
								ajJ: $author$project$Api$Pagination$reset(model.ajJ),
								akl: q
							});
						return _Utils_Tuple2(
							qModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Companies$Top$fetchCompanies(qModel),
										A2($author$project$Pages$Companies$Top$updateUrl, qModel, $elm$core$Maybe$Nothing)
									])));
					}
				}();
				var newModel = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{up: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$Top$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
			case 2:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{cr: $author$project$Api$Data$Loading, ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Companies$Top$fetchCompanies(newModel),
								A2($author$project$Pages$Companies$Top$updateUrl, newModel, $elm$core$Maybe$Nothing)
							])),
					_List_Nil);
			case 3:
				var subMsg = msg.a;
				var _v5 = A2($author$project$Ui$Dropdown$update, subMsg, model.nK);
				var dropdown = _v5.a;
				var dropdownCmd = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nK: dropdown}),
					dropdownCmd,
					_List_Nil);
			case 4:
				var filter = msg.a;
				var newModel = _Utils_update(
					model,
					{cr: $author$project$Api$Data$Loading, HM: filter});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Companies$Top$fetchCompanies(newModel),
								A2($author$project$Pages$Companies$Top$updateUrl, newModel, $elm$core$Maybe$Nothing)
							])),
					_List_Nil);
			case 5:
				var subMsg = msg.a;
				var planResourceResult = A3($author$project$Components$ResourceFilter$Plan$update, model.Gv, subMsg, model.hi);
				var planId = function () {
					var _v7 = planResourceResult.agZ;
					if (!_v7.$) {
						return $author$project$Components$ResourceFilter$Plan$value(planResourceResult.aiO);
					} else {
						return model.aj4;
					}
				}();
				var newModel = _Utils_update(
					model,
					{aj4: planId, hi: planResourceResult.aiO});
				var _v6 = _Utils_eq(model.aj4, newModel.aj4) ? _Utils_Tuple2(model.cr, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					$author$project$Api$Data$Loading,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Companies$Top$fetchCompanies(newModel),
								A2($author$project$Pages$Companies$Top$updateUrl, newModel, $elm$core$Maybe$Nothing)
							])));
				var companies = _v6.a;
				var cmd = _v6.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{cr: companies}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$Top$PlanResourceFilterMsg, planResourceResult.GZ),
								cmd
							])),
					planResourceResult.aR);
			case 6:
				var subMsg = msg.a;
				var _v8 = A2($author$project$Ui$Dropdown$update, subMsg, model.ql);
				var dropdown = _v8.a;
				var dropdownCmd = _v8.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ql: dropdown}),
					dropdownCmd,
					_List_Nil);
			case 7:
				var option = msg.a;
				var newModel = _Utils_update(
					model,
					{cr: $author$project$Api$Data$Loading, JT: option});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Companies$Top$fetchCompanies(newModel),
								A2($author$project$Pages$Companies$Top$updateUrl, newModel, $elm$core$Maybe$Nothing)
							])),
					_List_Nil);
			case 8:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						alA: A2($author$project$Api$Sort$update, columnId, model.alA)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Companies$Top$fetchCompanies(newModel),
								A2($author$project$Pages$Companies$Top$updateUrl, newModel, $elm$core$Maybe$Nothing)
							])),
					_List_Nil);
			case 9:
				var response = msg.a;
				_v9$2:
				while (true) {
					switch (response.$) {
						case 3:
							var upgrade = response.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										qS: $elm$core$Maybe$Just(upgrade)
									}),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
						case 2:
							if (response.a.$ === 5) {
								var _v10 = response.a;
								return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
							} else {
								break _v9$2;
							}
						default:
							break _v9$2;
					}
				}
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 10:
				var _v11 = A3(
					$author$project$Components$UpgradePracticeModal$init,
					model.qS,
					model.aa4,
					$author$project$Api$Provider$Practice$One$hasClinicalAccount(model.ZV));
				var upgradePracticeModal = _v11.a;
				var upgradePracticeModalCmd = _v11.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							lV: $elm$core$Maybe$Just(upgradePracticeModal)
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$Top$UpgradePracticeModalMsg, upgradePracticeModalCmd),
								A2(
								$author$project$Pages$Companies$Top$updateUrl,
								model,
								$author$project$Components$UpgradePracticeModal$urlParam(upgradePracticeModal))
							])),
					_List_Nil);
			case 11:
				var subMsg = msg.a;
				var _v12 = model.lV;
				if (!_v12.$) {
					var upgradePracticeModal = _v12.a;
					var result = A3($author$project$Components$UpgradePracticeModal$update, model.Gv, subMsg, upgradePracticeModal);
					var _v13 = function () {
						var _v14 = result.agZ;
						switch (_v14.$) {
							case 1:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									A2($author$project$Pages$Companies$Top$updateUrl, model, $elm$core$Maybe$Nothing),
									_List_Nil);
							case 2:
								var successMsg = _v14.a;
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									A2($author$project$Utils$Route$navigateAndReload, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Companies__Top),
									_List_fromArray(
										[
											A2($author$project$OutMsg$ShowToast, 3, successMsg)
										]));
							default:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(result.aiO),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
						}
					}();
					var modal_ = _v13.a;
					var cmd_ = _v13.b;
					var outMsgs_ = _v13.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{lV: modal_}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$Top$UpgradePracticeModalMsg, result.GZ),
									cmd_
								])),
						outMsgs_);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var text = msg.a;
				var href = msg.b;
				return _Utils_Tuple3(
					model,
					A3($author$project$Utils$Analytics$HintBilling$logLinkClickedEvent, model.aa4, text, href),
					_List_Nil);
		}
	});
var $author$project$Pages$Companies$Top$PaginationMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Companies$Top$SortTable = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Companies$Top$columns = function (practice) {
	return $elm$core$List$concat(
		_List_fromArray(
			[
				_List_fromArray(
				[
					A3(
					$author$project$Api$Column$init,
					'name',
					true,
					A2($author$project$Formatters$String$sponsorize, practice, 'Employer'))
				]),
				$author$project$Api$Provider$Practice$One$usesSponsors(practice) ? _List_fromArray(
				[
					A3($author$project$Api$Column$init, 'company_type', true, 'Type')
				]) : _List_Nil,
				_List_fromArray(
				[
					A3($author$project$Api$Column$init, 'plans', false, 'Plan(s)'),
					A3($author$project$Api$Column$init, 'status', false, 'Status'),
					A3($author$project$Api$Column$init, 'enrolled', false, 'Enrolled'),
					A3($author$project$Api$Column$init, 'eligible', false, 'Eligible'),
					A3($author$project$Api$Column$init, 'needs_approval', false, 'Needs Approval'),
					A3($author$project$Api$Column$init, 'account_balance', false, 'Account Balance')
				])
			]));
};
var $author$project$Pages$Companies$Top$Filtered = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Companies$Top$filterToLabel = F2(
	function (practice, filter) {
		switch (filter) {
			case 0:
				return 'All ' + A2($author$project$Formatters$String$sponsorize, practice, 'Companies');
			case 1:
				return 'Has Flagged Notes';
			case 2:
				return 'Has No Default Location';
			case 3:
				return 'Has No Broker Deals';
			case 4:
				return 'Needs Approval Review';
			default:
				return 'Archived';
		}
	});
var $author$project$Pages$Companies$Top$filterItems = F2(
	function (currentFilter, practice) {
		var filterToItem = function (filter) {
			return A2(
				$author$project$Ui$Dropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$Dropdown$selected(
						_Utils_eq(currentFilter, filter)),
						$author$project$Ui$Dropdown$onSelect(
						$author$project$Pages$Companies$Top$Filtered(filter))
					]),
				$elm$html$Html$text(
					A2($author$project$Pages$Companies$Top$filterToLabel, practice, filter)));
		};
		return A2(
			$elm$core$List$cons,
			filterToItem(0),
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Dropdown$separator,
				A2(
					$elm$core$List$map,
					filterToItem,
					$elm$core$List$concat(
						_List_fromArray(
							[
								_List_fromArray(
								[1, 2]),
								$author$project$Api$Provider$Practice$One$commissionsEnabled(practice) ? _List_fromArray(
								[3]) : _List_Nil,
								_List_fromArray(
								[4, 5])
							])))));
	});
var $author$project$Pages$Companies$Top$SponsorTypeSelected = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Companies$Top$sponsorTypeToLabel = F2(
	function (practice, filter) {
		switch (filter) {
			case 0:
				return 'All ' + (A2($author$project$Formatters$String$sponsorize, practice, 'Companies') + ' Types');
			case 1:
				return 'Network';
			default:
				return 'Employer';
		}
	});
var $author$project$Pages$Companies$Top$sponsorTypeItems = F2(
	function (currentSponsorType, practice) {
		var sponsorTypeToItem = function (sponsorType) {
			return A2(
				$author$project$Ui$Dropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$Dropdown$selected(
						_Utils_eq(currentSponsorType, sponsorType)),
						$author$project$Ui$Dropdown$onSelect(
						$author$project$Pages$Companies$Top$SponsorTypeSelected(sponsorType))
					]),
				$elm$html$Html$text(
					A2($author$project$Pages$Companies$Top$sponsorTypeToLabel, practice, sponsorType)));
		};
		return A2(
			$elm$core$List$cons,
			sponsorTypeToItem(0),
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Dropdown$separator,
				A2(
					$elm$core$List$map,
					sponsorTypeToItem,
					_List_fromArray(
						[1, 2]))));
	});
var $author$project$Api$Provider$Company$All$companyType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$companyType(shared);
};
var $author$project$Api$Provider$Company$All$eligibleCount = function (_v0) {
	var record = _v0.b;
	return record.Ri;
};
var $author$project$Api$Provider$Company$All$enrolledCount = function (_v0) {
	var record = _v0.b;
	return record.RC;
};
var $author$project$Api$Provider$Company$All$flaggedNotesCount = function (_v0) {
	var record = _v0.b;
	return record.Sz;
};
var $author$project$Api$Provider$Company$All$needsApprovalCount = function (_v0) {
	var record = _v0.b;
	return record.Xy;
};
var $author$project$Api$Provider$Company$All$owedInCents = function (_v0) {
	var record = _v0.b;
	return record.YC;
};
var $author$project$Api$Provider$Company$All$plans = function (_v0) {
	var record = _v0.b;
	return record.ZG;
};
var $author$project$Api$Provider$Company$All$status = function (_v0) {
	var record = _v0.b;
	return record.alH;
};
var $author$project$Pages$Companies$Top$viewCompany = F2(
	function (practice, company) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top(
										{
											fZ: $author$project$Api$Provider$Company$All$id(company)
										}),
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Provider$Company$All$name(company)),
											$author$project$Utils$Html$noBreakSpace,
											($author$project$Api$Provider$Company$All$flaggedNotesCount(company) > 0) ? $author$project$Ui$Icon$flag(_List_Nil) : $author$project$Utils$Html$empty
										]))
								]))
						]),
						$author$project$Api$Provider$Practice$One$usesSponsors(practice) ? _List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									(!$author$project$Api$Provider$Company$All$companyType(company)) ? $elm$html$Html$text('Network') : $elm$html$Html$text('Employer')
								]))
						]) : _List_Nil,
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Formatters$String$toSentence(
										A2(
											$elm$core$List$map,
											$author$project$Api$Provider$Plan$Shared$name,
											A2(
												$author$project$Api$Expandable$withDefault,
												_List_Nil,
												$author$project$Api$Provider$Company$All$plans(company)))))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Formatters$String$titleize(
										$author$project$Api$Provider$Company$All$status(company)))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(
										A2(
											$author$project$Api$Expandable$withDefault,
											0,
											$author$project$Api$Provider$Company$All$enrolledCount(company))))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(
										A2(
											$author$project$Api$Expandable$withDefault,
											0,
											$author$project$Api$Provider$Company$All$eligibleCount(company))))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(
										A2(
											$author$project$Api$Expandable$withDefault,
											0,
											$author$project$Api$Provider$Company$All$needsApprovalCount(company))))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(
										A2(
											$author$project$Api$Expandable$withDefault,
											0,
											$author$project$Api$Provider$Company$All$owedInCents(company))))
								]))
						])
					])));
	});
var $author$project$Pages$Companies$Top$AnalyticsLinkClicked = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Ui$Panel$ExtraPadding = {$: 2};
var $author$project$Ui$Panel$extraPadding = $author$project$Ui$Panel$ExtraPadding;
var $author$project$Pages$Companies$Top$userCanSeeCard = F2(
	function (session, upgradeAvailable) {
		var userIsAdmin = $author$project$Api$Platform$Session$One$userIsPracticeAdmin(session);
		return (!userIsAdmin) || (userIsAdmin && $elm_community$maybe_extra$Maybe$Extra$isJust(upgradeAvailable));
	});
var $author$project$Pages$Companies$Top$UpgradePracticeClicked = {$: 10};
var $author$project$Pages$Companies$Top$viewUpgradeButton = F3(
	function (selfUpgradeEnabled, upgradeAvailable, canUserUpgrade) {
		if (selfUpgradeEnabled) {
			var buttonText = function () {
				if (!upgradeAvailable.$) {
					var upgrade = upgradeAvailable.a;
					return 'Upgrade to ' + $author$project$Api$Provider$PracticePricing$Upgrade$tierName(upgrade);
				} else {
					return 'Upgrade';
				}
			}();
			return A3(
				$author$project$Ui$Button$view,
				{mm: buttonText},
				_List_fromArray(
					[
						$author$project$Ui$Button$primary,
						$author$project$Ui$Button$onClick($author$project$Pages$Companies$Top$UpgradePracticeClicked),
						$author$project$Ui$Button$disabled(!canUserUpgrade)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(buttonText)
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Pages$Companies$Top$viewSelfUpgradeCard = F3(
	function (session, selfUpgradeEnabled, upgradeAvailable) {
		if (selfUpgradeEnabled && A2($author$project$Pages$Companies$Top$userCanSeeCard, session, upgradeAvailable)) {
			var learnMoreLink = 'https://www.hint.com/core#Employer-Direct-Contracting';
			var canUserUpgrade = $author$project$Api$Platform$Session$One$userIsPracticeAdmin(session);
			return A2(
				$author$project$Ui$Panel$view,
				_List_fromArray(
					[$author$project$Ui$Panel$extraPadding]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Typography$heading(
										_List_fromArray(
											[
												$elm$html$Html$text('Help Employers Rethink Primary Care, Your Way')
											])),
										A2(
										$author$project$Ui$Grid$row,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Grid$column,
												_List_fromArray(
													[
														$author$project$Ui$Grid$span(6)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Employers are ready for a better way to offer healthcare. Partnering with them can grow your revenue by up to 40% while keeping your practice sustainable, patient-focused, and independent. ')
													]))
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$flexMd]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$mr4]),
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Link$externalHref,
												learnMoreLink,
												_List_fromArray(
													[
														$author$project$Ui$Link$buttonSecondary,
														$author$project$Ui$Link$targetBlank,
														$author$project$Ui$Link$onClick(
														A2($author$project$Pages$Companies$Top$AnalyticsLinkClicked, 'Learn More', learnMoreLink))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Learn More')
													]))
											])),
										A2(
										$author$project$Ui$Element$view,
										_List_Nil,
										_List_fromArray(
											[
												A3($author$project$Pages$Companies$Top$viewUpgradeButton, selfUpgradeEnabled, upgradeAvailable, canUserUpgrade),
												(!canUserUpgrade) ? A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$mt2]),
												_List_fromArray(
													[
														$elm$html$Html$text('Must be an admin to upgrade')
													])) : $author$project$Utils$Html$empty
											]))
									]))
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Pages$Companies$Top$view = function (model) {
	var _v0 = function () {
		var _v1 = model.cr;
		if (_v1.$ === 3) {
			var companies_ = _v1.a;
			return _Utils_Tuple2(false, companies_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var companies = _v0.b;
	return {
		fO: _List_fromArray(
			[
				function () {
				var _v2 = model.lV;
				if (!_v2.$) {
					var modal = _v2.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$Companies$Top$UpgradePracticeModalMsg,
						$author$project$Components$UpgradePracticeModal$view(modal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mb4, $author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
				_List_fromArray(
					[
						$author$project$Ui$Typography$heading(
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$Formatters$String$sponsorize, model.ZV, 'Employers'))
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$itemsCenter]),
						_List_fromArray(
							[
								A2(
								$author$project$Utils$FeatureGate$gateAvailable,
								9,
								$author$project$Api$Practice$Provider(model.ZV)) ? A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Companies__New,
								_List_fromArray(
									[
										$author$project$Ui$Link$buttonDefault,
										$author$project$Ui$Link$icon($author$project$Ui$Icon$add),
										$author$project$Ui$Link$buttonPrimary
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Add '),
										$elm$html$Html$text(
										A2($author$project$Formatters$String$sponsorize, model.ZV, 'Employer'))
									])) : $elm$html$Html$text('')
							]))
					])),
				A3($author$project$Pages$Companies$Top$viewSelfUpgradeCard, model.aa4, model.JF, model.qS),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Pages$Companies$Top$SearchInputMsg,
												A2($author$project$Ui$SearchInput$view, _List_Nil, model.up))
											])),
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$spanSm(2),
												$author$project$Ui$Grid$span(6)
											]),
										_List_fromArray(
											[
												A4(
												$author$project$Ui$Dropdown$viewSelect,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2($author$project$Pages$Companies$Top$filterToLabel, model.ZV, model.HM))
													]),
												A2($author$project$Pages$Companies$Top$filterItems, model.HM, model.ZV),
												model.nK)
											])),
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$spanSm(2),
												$author$project$Ui$Grid$span(6)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Pages$Companies$Top$PlanResourceFilterMsg,
												A2($author$project$Components$ResourceFilter$Plan$view, _List_Nil, model.hi))
											])),
										$author$project$Api$Provider$Practice$One$usesSponsors(model.ZV) ? A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$spanSm(2),
												$author$project$Ui$Grid$span(6)
											]),
										_List_fromArray(
											[
												A4(
												$author$project$Ui$Dropdown$viewSelect,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2($author$project$Pages$Companies$Top$sponsorTypeToLabel, model.ZV, model.JT))
													]),
												A2($author$project$Pages$Companies$Top$sponsorTypeItems, model.JT, model.ZV),
												model.ql)
											])) : $author$project$Ui$Grid$none
									]))
							])),
						A4(
						$author$project$Ui$Panel$table,
						_List_fromArray(
							[
								$author$project$Ui$Table$loading(loading),
								$author$project$Ui$Table$zeroState(
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h4,
										_List_Nil,
										_List_fromArray(
											[
												function () {
												var _v3 = model.akl;
												if (!_v3.$) {
													return A2(
														$author$project$Ui$Element$view,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('No '),
																$elm$html$Html$text(
																A2($author$project$Formatters$String$sponsorize, model.ZV, 'employers')),
																$elm$html$Html$text(' found for your search criteria.')
															]));
												} else {
													return A2(
														$author$project$Ui$Element$view,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('It looks like you haven\'t added any '),
																$elm$html$Html$text(
																A2($author$project$Formatters$String$sponsorize, model.ZV, 'employers')),
																$elm$html$Html$text(' yet.')
															]));
												}
											}(),
												$author$project$Utils$Html$noBreakSpace,
												A2(
												$author$project$Utils$FeatureGate$gateAvailable,
												9,
												$author$project$Api$Practice$Provider(model.ZV)) ? A3(
												$author$project$Ui$Link$route,
												$author$project$Spa$Generated$Route$Companies__New,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Would you like to create one?')
													])) : $author$project$Utils$Html$empty
											]))
									]))
							]),
						A2(
							$elm$core$List$map,
							$author$project$Api$Column$view(
								A2($author$project$Api$Column$Sortable, model.alA, $author$project$Pages$Companies$Top$SortTable)),
							$author$project$Pages$Companies$Top$columns(model.ZV)),
						A2(
							$elm$core$List$map,
							$author$project$Pages$Companies$Top$viewCompany(model.ZV),
							companies),
						_List_Nil),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Companies$Top$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(loading)
										]),
									model.ajJ))
							]))
					]))
			]),
		ac9: A2($author$project$Formatters$String$sponsorize, model.ZV, 'Employers')
	};
};
var $author$project$Pages$Companies$Top$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Companies$Top$init, aiq: $author$project$Pages$Companies$Top$load, k8: $author$project$Pages$Companies$Top$save, alO: $author$project$Pages$Companies$Top$subscriptions, adT: $author$project$Pages$Companies$Top$update, amo: $author$project$Pages$Companies$Top$view});
var $author$project$Pages$Contacts$ContactId_String$Top$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Contacts$ContactId_String$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Contacts$ContactId_String$Top$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Contacts$ContactId_String$Top$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Contact'};
};
var $author$project$Pages$Contacts$ContactId_String$Top$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$Contacts$ContactId_String$Top$init,
		aiq: $author$project$Pages$Contacts$ContactId_String$Top$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$Contacts$ContactId_String$Top$update,
		amo: $author$project$Pages$Contacts$ContactId_String$Top$view
	});
var $author$project$Pages$Contacts$List$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Contacts$List$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Contacts$List$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Contacts$List$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Contacts'};
};
var $author$project$Pages$Contacts$List$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$Contacts$List$init,
		aiq: $author$project$Pages$Contacts$List$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$Contacts$List$update,
		amo: $author$project$Pages$Contacts$List$view
	});
var $author$project$Pages$Contacts$New$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Contacts$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Contacts$New$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Contacts$New$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'New Contact'};
};
var $author$project$Pages$Contacts$New$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$Contacts$New$init,
		aiq: $author$project$Pages$Contacts$New$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$Contacts$New$update,
		amo: $author$project$Pages$Contacts$New$view
	});
var $author$project$Spa$Page$application = function (page) {
	return page;
};
var $author$project$Pages$Error$Status_String$init = F2(
	function (_v0, _v1) {
		var params = _v1.YL;
		var query = _v1.DE;
		return _Utils_Tuple3(
			{
				aiH: A2($elm$core$Dict$get, 'message', query),
				alH: params.alH
			},
			$elm$core$Platform$Cmd$none,
			_List_Nil);
	});
var $author$project$Pages$Error$Status_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Error$Status_String$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Error$Status_String$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Error$Status_String$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Error$Status_String$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				$author$project$Ui$Typography$heading(
				_List_fromArray(
					[
						$elm$html$Html$text('Error '),
						$elm$html$Html$text(model.alH)
					])),
				function () {
				var _v0 = model.aiH;
				if (!_v0.$) {
					var message = _v0.a;
					return A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$helpBlock]),
						_List_fromArray(
							[
								$elm$html$Html$text(message)
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Typography$p,
				_List_Nil,
				function () {
					var _v1 = model.alH;
					switch (_v1) {
						case '401':
							return _List_fromArray(
								[
									$elm$html$Html$text('You need to login first to see that page.'),
									$elm$html$Html$text(' You can do that '),
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Login,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('here')
										])),
									$elm$html$Html$text('.')
								]);
						case '403':
							return _List_fromArray(
								[
									$elm$html$Html$text('You\'re not authorized to do that. Please check your permissions and try agian.')
								]);
						case '404':
							return _List_fromArray(
								[
									$elm$html$Html$text('This page doesn\'t exist anymore. Please let us know (email '),
									A3(
									$author$project$Ui$Link$mailto,
									'support@hint.com',
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('support@hint.com')
										])),
									$elm$html$Html$text(') how you got here so we can update any outdated or expired links.')
								]);
						case '418':
							return _List_fromArray(
								[
									$elm$html$Html$text('I\'m a teapot')
								]);
						case '422':
							return _List_fromArray(
								[
									$elm$html$Html$text('Your request was missing some required information or didn\'t validate properly. Please try again.')
								]);
						case '428':
							return _List_fromArray(
								[
									$elm$html$Html$text('You aren\'t able to do that until you further set up your account.')
								]);
						case '500':
							return _List_fromArray(
								[
									$elm$html$Html$text('Our servers didn\'t like that. We\'ve been notified about this error and are looking into it.')
								]);
						case '503':
							return _List_fromArray(
								[
									$elm$html$Html$text('Our servers are currently undergoing maintenance. Please try again soon.')
								]);
						default:
							return _List_fromArray(
								[
									$elm$html$Html$text('Something bad happened. Please let us know (email '),
									A3(
									$author$project$Ui$Link$mailto,
									'support@hint.com',
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('support@hint.com')
										])),
									$elm$html$Html$text(') how you did this and we\'ll take a look.')
								]);
					}
				}()),
				A2(
				$author$project$Ui$Typography$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Take me '),
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Top,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('home')
							])),
						$elm$html$Html$text('.')
					]))
			]),
		ac9: 'Error'
	};
};
var $author$project$Pages$Error$Status_String$page = $author$project$Spa$Page$application(
	{ah_: $author$project$Pages$Error$Status_String$init, aiq: $author$project$Pages$Error$Status_String$load, k8: $author$project$Pages$Error$Status_String$save, alO: $author$project$Pages$Error$Status_String$subscriptions, adT: $author$project$Pages$Error$Status_String$update, amo: $author$project$Pages$Error$Status_String$view});
var $author$project$Pages$Files$Public$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Files$Public$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Files$Public$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Files$Public$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'File Drive'};
};
var $author$project$Pages$Files$Public$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$Files$Public$init,
		aiq: $author$project$Pages$Files$Public$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$Files$Public$update,
		amo: $author$project$Pages$Files$Public$view
	});
var $author$project$Pages$Files$Top$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Files$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Files$Top$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Files$Top$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'File Drive'};
};
var $author$project$Pages$Files$Top$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$Files$Top$init,
		aiq: $author$project$Pages$Files$Top$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$Files$Top$update,
		amo: $author$project$Pages$Files$Top$view
	});
var $author$project$Pages$Forms$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Forms$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Forms$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Forms$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Forms'};
};
var $author$project$Pages$Forms$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$Forms$init,
		aiq: $author$project$Pages$Forms$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$Forms$update,
		amo: $author$project$Pages$Forms$view
	});
var $author$project$Pages$GoogleCallback$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$GoogleCallback$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$GoogleCallback$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$GoogleCallback$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Google Callback'};
};
var $author$project$Pages$GoogleCallback$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$GoogleCallback$init,
		aiq: $author$project$Pages$GoogleCallback$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$GoogleCallback$update,
		amo: $author$project$Pages$GoogleCallback$view
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$GotAdminUsersGroup = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Platform$AdminUsersGroup$adminUsersGroupsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['admin_users_groups']),
	$author$project$Api$Data$platformPath);
var $author$project$Api$Platform$AdminUsersGroup$adminUsersGroupPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Platform$AdminUsersGroup$adminUsersGroupsPath);
};
var $author$project$Api$Platform$AdminUsersGroup$One$AdminUsersGroup = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Platform$AdminUsersGroup$Shared$AdminUsersGroup = $elm$core$Basics$identity;
var $author$project$Api$Platform$AdminUsersGroup$Shared$Record = F2(
	function (id, name) {
		return {ahP: id, Bq: name};
	});
var $author$project$Api$Platform$AdminUsersGroup$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Platform$AdminUsersGroup$Shared$Record)));
var $author$project$Api$Platform$AdminUsersGroup$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$AdminUsersGroup$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Platform$AdminUsersGroup$One$Record = F2(
	function (usersCount, practicesCount) {
		return {Z0: practicesCount, ad2: usersCount};
	});
var $author$project$Api$Platform$AdminUsersGroup$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'practices_count',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'users_count',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Api$Platform$AdminUsersGroup$One$Record)));
var $author$project$Api$Platform$AdminUsersGroup$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$AdminUsersGroup$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Platform$AdminUsersGroup$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Platform$AdminUsersGroup$One$AdminUsersGroup)));
var $author$project$Api$Platform$AdminUsersGroup$retrieve = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Platform$AdminUsersGroup$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Platform$AdminUsersGroup$adminUsersGroupPath(id_)));
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroup = function (model) {
	return A3($author$project$Api$Platform$AdminUsersGroup$retrieve, model.Gv, model.ahP, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$GotAdminUsersGroup);
};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$GotAdminUsersGroupPractices = function (a) {
	return {$: 18, a: a};
};
var $author$project$Api$Platform$AdminUsersGroup$Practice$adminUsersGroupPracticesPath = function (adminUsersGroupId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['practices']),
		$author$project$Api$Platform$AdminUsersGroup$adminUsersGroupPath(adminUsersGroupId));
};
var $author$project$Api$Platform$AdminUsersGroup$Practice$listDefaults = {
	ajJ: $author$project$Api$Pagination$init,
	akl: $elm$core$Maybe$Nothing,
	alA: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init)
};
var $author$project$Api$Platform$AdminUsersGroup$Practice$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Platform$AdminUsersGroup$Practice$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.akl;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$Platform$AdminUsersGroup$Practice$list = F4(
	function (apiClient, adminUsersGroupId, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Platform$Practice$Min$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Platform$AdminUsersGroup$Practice$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Platform$AdminUsersGroup$Practice$adminUsersGroupPracticesPath(adminUsersGroupId))));
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroupPractices = function (model) {
	return A4(
		$author$project$Api$Platform$AdminUsersGroup$Practice$list,
		model.Gv,
		model.ahP,
		function (d) {
			return _Utils_update(
				d,
				{ajJ: model.b7, akl: model.ph, alA: model.pi});
		},
		$author$project$Pages$Hinter$AdminUsersGroups$Id_String$GotAdminUsersGroupPractices);
};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$GotAdminUsersGroupUsers = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Platform$AdminUsersGroup$User$adminUsersGroupUsersPath = function (adminUsersGroupId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['users']),
		$author$project$Api$Platform$AdminUsersGroup$adminUsersGroupPath(adminUsersGroupId));
};
var $author$project$Api$Platform$AdminUsersGroup$User$listDefaults = {
	ajJ: $author$project$Api$Pagination$init,
	akl: $elm$core$Maybe$Nothing,
	alA: A3($author$project$Api$Sort$withDefault, 'first_name', 0, $author$project$Api$Sort$init)
};
var $author$project$Api$Platform$AdminUsersGroup$User$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Platform$AdminUsersGroup$User$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.akl;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$Platform$AdminUsersGroup$User$list = F4(
	function (apiClient, adminUsersGroupId, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Platform$User$Min$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Platform$AdminUsersGroup$User$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Platform$AdminUsersGroup$User$adminUsersGroupUsersPath(adminUsersGroupId))));
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroupUsers = function (model) {
	return A4(
		$author$project$Api$Platform$AdminUsersGroup$User$list,
		model.Gv,
		model.ahP,
		function (d) {
			return _Utils_update(
				d,
				{ajJ: model.cf, akl: model.qY, alA: model.qZ});
		},
		$author$project$Pages$Hinter$AdminUsersGroups$Id_String$GotAdminUsersGroupUsers);
};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$init = F3(
	function (_v0, _v1, _v2) {
		var apiClient = _v1.Gv;
		var query = _v2.DE;
		var params = _v2.YL;
		var q = A2($elm$core$Dict$get, 'q', query);
		var model = {
			aq: $elm$core$Maybe$Nothing,
			a$: $elm$core$Maybe$Nothing,
			cj: $author$project$Api$Data$Loading,
			a0: $elm$core$Maybe$Nothing,
			c_: $author$project$Api$Data$Loading,
			Gm: $author$project$Api$Data$Loading,
			Gv: apiClient,
			df: $elm$core$Maybe$Nothing,
			d8: $elm$core$Set$empty,
			d9: $elm$core$Set$empty,
			ahP: params.ahP,
			b7: $author$project$Api$Pagination$init,
			ph: q,
			t_: $author$project$Ui$SearchInput$init(q),
			pi: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init),
			cf: $author$project$Api$Pagination$init,
			qY: q,
			vm: $author$project$Ui$SearchInput$init(q),
			qZ: A3($author$project$Api$Sort$withDefault, 'first_name', 0, $author$project$Api$Sort$init)
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroup(model),
						$author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroupUsers(model),
						$author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroupPractices(model)
					])));
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$CancelAddPractice = {$: 23};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$CancelAddUser = {$: 12};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$DeleteAdminUsersGroupClosed = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Hinter$AdminUsersGroups$Id_String$DeleteAdminUsersGroupClosed)),
					model.df)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Hinter$AdminUsersGroups$Id_String$CancelAddUser)),
					model.a0)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Hinter$AdminUsersGroups$Id_String$CancelAddPractice)),
					model.a$))
			]));
};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$AdminUsersGroupDeleted = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$AdminUsersGroupPracticeAdded = function (a) {
	return {$: 26, a: a};
};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$AdminUsersGroupPracticeDeleted = F2(
	function (a, b) {
		return {$: 28, a: a, b: b};
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$AdminUsersGroupUserAdded = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$AdminUsersGroupUserDeleted = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$PracticesSearchInputMsg = function (a) {
	return {$: 20, a: a};
};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$UsersSearchInputMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Platform$AdminUsersGroup$Practice$add = F4(
	function (apiClient, adminUsersGroupId, practiceId, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practice',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'id',
								$elm$json$Json$Encode$string(practiceId))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Platform$Practice$Min$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Platform$AdminUsersGroup$Practice$adminUsersGroupPracticesPath(adminUsersGroupId))));
	});
var $author$project$Api$Platform$AdminUsersGroup$User$add = F4(
	function (apiClient, adminUsersGroupId, userId, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'user',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'id',
								$elm$json$Json$Encode$string(userId))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Platform$User$Min$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Platform$AdminUsersGroup$User$adminUsersGroupUsersPath(adminUsersGroupId))));
	});
var $author$project$Api$Platform$AdminUsersGroup$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Platform$AdminUsersGroup$adminUsersGroupPath(id_)));
	});
var $author$project$Api$Platform$AdminUsersGroup$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Platform$AdminUsersGroup$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Platform$AdminUsersGroup$Shared$name(shared);
};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$formFieldsFromAdminUsersGroup = function (adminUsersGroup) {
	return $author$project$Api$Platform$AdminUsersGroup$One$name(adminUsersGroup);
};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$formFieldsUpdate = F2(
	function (field, _v0) {
		var name = field;
		return name;
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$NameValidation = 0;
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			$elm$core$Basics$identity,
			_Utils_Tuple2(0, 'Please enter a name.'))
		]));
var $author$project$Api$Platform$AdminUsersGroup$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Platform$AdminUsersGroup$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Platform$AdminUsersGroup$Shared$id(shared);
};
var $author$project$Api$Platform$User$Min$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Platform$User$Min$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$practiceFormFieldsUpdate = F2(
	function (field, _v0) {
		var practiceId = field;
		return $author$project$Utils$String$toMaybe(practiceId);
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$PracticeIdValidation = 0;
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$practiceFormFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			$elm$core$Basics$identity,
			_Utils_Tuple2(0, 'Please enter a practice ID.'))
		]));
var $author$project$Api$Platform$AdminUsersGroup$Practice$adminUsersGroupPracticePath = F2(
	function (adminUsersGroupId, practiceId) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[practiceId]),
			$author$project$Api$Platform$AdminUsersGroup$Practice$adminUsersGroupPracticesPath(adminUsersGroupId));
	});
var $author$project$Api$Platform$AdminUsersGroup$Practice$remove = F4(
	function (apiClient, adminUsersGroupId, practiceId, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Platform$AdminUsersGroup$Practice$adminUsersGroupPracticePath, adminUsersGroupId, practiceId)));
	});
var $author$project$Api$Platform$AdminUsersGroup$User$adminUsersGroupUserPath = F2(
	function (adminUsersGroupId, userId) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[userId]),
			$author$project$Api$Platform$AdminUsersGroup$User$adminUsersGroupUsersPath(adminUsersGroupId));
	});
var $author$project$Api$Platform$AdminUsersGroup$User$remove = F4(
	function (apiClient, adminUsersGroupId, userId, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Platform$AdminUsersGroup$User$adminUsersGroupUserPath, adminUsersGroupId, userId)));
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$AdminUsersGroupUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Platform$AdminUsersGroup$update = F4(
	function (apiClient, id_, name_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'admin_users_group',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(name_))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Platform$AdminUsersGroup$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Platform$AdminUsersGroup$adminUsersGroupPath(id_))));
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$updateAdminUsersGroup = F3(
	function (apiClient, id, formFields) {
		var name = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4($author$project$Api$Platform$AdminUsersGroup$update, apiClient, id, name, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$AdminUsersGroupUpdated);
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$userFormFieldsUpdate = F2(
	function (field, _v0) {
		var userId = field;
		return $author$project$Utils$String$toMaybe(userId);
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$UserIdValidation = 0;
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$userFormFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			$elm$core$Basics$identity,
			_Utils_Tuple2(0, 'Please enter a user ID.'))
		]));
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							df: $elm$core$Maybe$Just($author$project$Api$Data$NotAsked)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var confirmed = msg.a;
				var _v1 = model.aq;
				if (!_v1.$) {
					var _v2 = _v1.a;
					var adminUsersGroup = _v2.a;
					return confirmed ? _Utils_Tuple3(
						_Utils_update(
							model,
							{
								df: $elm$core$Maybe$Just($author$project$Api$Data$Loading)
							}),
						A3(
							$author$project$Api$Platform$AdminUsersGroup$delete,
							model.Gv,
							$author$project$Api$Platform$AdminUsersGroup$One$id(adminUsersGroup),
							$author$project$Pages$Hinter$AdminUsersGroups$Id_String$AdminUsersGroupDeleted(adminUsersGroup)),
						_List_Nil) : _Utils_Tuple3(
						_Utils_update(
							model,
							{df: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var adminUsersGroup = msg.a;
				var dataAdminUsersGroup = msg.b;
				switch (dataAdminUsersGroup.$) {
					case 3:
						return _Utils_Tuple3(
							model,
							A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Hinter__AdminUsersGroups__Top),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Platform$AdminUsersGroup$One$name(adminUsersGroup) + ' was successfully removed.')
								]));
					case 2:
						var error = dataAdminUsersGroup.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{df: $elm$core$Maybe$Nothing}),
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error)),
								$author$project$OutMsg$reportDecodeError(dataAdminUsersGroup)));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 1:
				var _v4 = model.aq;
				if (!_v4.$) {
					var _v5 = _v4.a;
					var adminUsersGroup = _v5.a;
					var form = _v5.b;
					var _v6 = A2($author$project$Utils$Form$validate, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$formFieldsValidator, form);
					if (!_v6.$) {
						var _v7 = _v6.a;
						var newForm = _v7.a;
						var validFormFields = _v7.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aq: $elm$core$Maybe$Just(
										_Utils_Tuple3(adminUsersGroup, newForm, $author$project$Api$Data$Loading))
								}),
							A3(
								$author$project$Pages$Hinter$AdminUsersGroups$Id_String$updateAdminUsersGroup,
								model.Gv,
								$author$project$Api$Platform$AdminUsersGroup$One$id(adminUsersGroup),
								validFormFields),
							_List_Nil);
					} else {
						var newForm = _v6.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aq: $elm$core$Maybe$Just(
										_Utils_Tuple3(adminUsersGroup, newForm, $author$project$Api$Data$NotAsked))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var adminUsersGroup = response.a;
					var form = $author$project$Utils$Form$init(
						$author$project$Pages$Hinter$AdminUsersGroups$Id_String$formFieldsFromAdminUsersGroup(adminUsersGroup));
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aq: $elm$core$Maybe$Just(
									_Utils_Tuple3(adminUsersGroup, form, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{aq: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 2:
				var field = msg.a;
				var _v9 = model.aq;
				if (!_v9.$) {
					var _v10 = _v9.a;
					var id = _v10.a;
					var form = _v10.b;
					var adminUsersGroup = _v10.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aq: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, adminUsersGroup))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var dataAdminUsersGroup = msg.a;
				var _v11 = model.aq;
				if (!_v11.$) {
					var _v12 = _v11.a;
					var adminUsersGroup = _v12.a;
					var form = _v12.b;
					if (dataAdminUsersGroup.$ === 3) {
						var newAdminUsersGroup = dataAdminUsersGroup.a;
						var newForm = $author$project$Utils$Form$init(
							$author$project$Pages$Hinter$AdminUsersGroups$Id_String$formFieldsFromAdminUsersGroup(newAdminUsersGroup));
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aq: $elm$core$Maybe$Just(
										_Utils_Tuple3(adminUsersGroup, newForm, $author$project$Api$Data$NotAsked))
								}),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Platform$AdminUsersGroup$One$name(adminUsersGroup) + ' was successfully updated.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aq: $elm$core$Maybe$Just(
										_Utils_Tuple3(adminUsersGroup, form, $author$project$Api$Data$NotAsked))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(dataAdminUsersGroup));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								c_: response,
								cf: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.cf)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{c_: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 8:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.cf);
				var newModel = _Utils_update(
					model,
					{Gm: $author$project$Api$Data$Loading, cf: pagination});
				return _Utils_Tuple3(
					newModel,
					$author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroupUsers(newModel),
					_List_Nil);
			case 9:
				var subMsg = msg.a;
				var _v15 = A2($author$project$Ui$SearchInput$update, subMsg, model.vm);
				var searchInput = _v15.a;
				var searchInputCmd = _v15.b;
				var searchInputEvent = _v15.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.qY;
					}
				}();
				var _v16 = function () {
					if (_Utils_eq(q, model.qY)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								c_: $author$project$Api$Data$Loading,
								cf: $author$project$Api$Pagination$reset(model.cf),
								qY: q
							});
						return _Utils_Tuple2(
							qModel,
							$author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroupUsers(qModel));
					}
				}();
				var newModel = _v16.a;
				var cmd = _v16.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{vm: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$UsersSearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
			case 10:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						c_: $author$project$Api$Data$Loading,
						cf: $author$project$Api$Pagination$reset(model.cf),
						qZ: A2($author$project$Api$Sort$update, columnId, model.qZ)
					});
				return _Utils_Tuple3(
					newModel,
					$author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroupUsers(newModel),
					_List_Nil);
			case 11:
				var _v18 = model.aq;
				if (!_v18.$) {
					var _v19 = _v18.a;
					var adminUsersGroup = _v19.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								a0: $elm$core$Maybe$Just(
									_Utils_Tuple3(
										$author$project$Api$Platform$AdminUsersGroup$One$id(adminUsersGroup),
										$author$project$Utils$Form$init($elm$core$Maybe$Nothing),
										$author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 12:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{a0: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 13:
				var field = msg.a;
				var _v20 = model.a0;
				if (!_v20.$) {
					var _v21 = _v20.a;
					var adminUsersGroupId = _v21.a;
					var form = _v21.b;
					var request = _v21.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$userFormFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								a0: $elm$core$Maybe$Just(
									_Utils_Tuple3(adminUsersGroupId, newForm, request))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 14:
				var _v22 = model.a0;
				if (!_v22.$) {
					var _v23 = _v22.a;
					var adminUsersGroupId = _v23.a;
					var form = _v23.b;
					var _v24 = A2($author$project$Utils$Form$validate, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$userFormFieldsValidator, form);
					if (!_v24.$) {
						var _v25 = _v24.a;
						var newForm = _v25.a;
						var validFormFields = _v25.b;
						var userId = A2(
							$elm$core$Maybe$withDefault,
							'',
							$rtfeldman$elm_validate$Validate$fromValid(validFormFields));
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									a0: $elm$core$Maybe$Just(
										_Utils_Tuple3(adminUsersGroupId, newForm, $author$project$Api$Data$Loading))
								}),
							A4($author$project$Api$Platform$AdminUsersGroup$User$add, model.Gv, adminUsersGroupId, userId, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$AdminUsersGroupUserAdded),
							_List_Nil);
					} else {
						var newForm = _v24.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									a0: $elm$core$Maybe$Just(
										_Utils_Tuple3(adminUsersGroupId, newForm, $author$project$Api$Data$NotAsked))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 15:
				var response = msg.a;
				var _v26 = model.a0;
				if (!_v26.$) {
					var _v27 = _v26.a;
					var adminUsersGroupId = _v27.a;
					var form = _v27.b;
					if (response.$ === 3) {
						var user = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{a0: $elm$core$Maybe$Nothing, c_: $author$project$Api$Data$Loading}),
							$author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroupUsers(model),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Platform$User$Min$name(user) + ' was successfully added.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									a0: $elm$core$Maybe$Just(
										_Utils_Tuple3(adminUsersGroupId, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 16:
				var adminUsersGroupId = msg.a;
				var user = msg.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							df: $elm$core$Maybe$Nothing,
							d9: A2(
								$elm$core$Set$insert,
								$author$project$Api$Platform$User$Min$id(user),
								model.d9)
						}),
					A4(
						$author$project$Api$Platform$AdminUsersGroup$User$remove,
						model.Gv,
						adminUsersGroupId,
						$author$project$Api$Platform$User$Min$id(user),
						$author$project$Pages$Hinter$AdminUsersGroups$Id_String$AdminUsersGroupUserDeleted(user)),
					_List_Nil);
			case 17:
				var user = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									c_: $author$project$Api$Data$Loading,
									d9: A2(
										$elm$core$Set$remove,
										$author$project$Api$Platform$User$Min$id(user),
										model.d9)
								}),
							$author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroupUsers(model),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Platform$User$Min$name(user) + ' was successfully removed.')
								]));
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									d9: A2(
										$elm$core$Set$remove,
										$author$project$Api$Platform$User$Min$id(user),
										model.d9)
								}),
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error)),
								$author$project$OutMsg$reportDecodeError(response)));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 18:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cj: response,
								b7: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.b7)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cj: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 19:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.b7);
				var newModel = _Utils_update(
					model,
					{cj: $author$project$Api$Data$Loading, b7: pagination});
				return _Utils_Tuple3(
					newModel,
					$author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroupPractices(newModel),
					_List_Nil);
			case 20:
				var subMsg = msg.a;
				var _v31 = A2($author$project$Ui$SearchInput$update, subMsg, model.t_);
				var searchInput = _v31.a;
				var searchInputCmd = _v31.b;
				var searchInputEvent = _v31.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.ph;
					}
				}();
				var _v32 = function () {
					if (_Utils_eq(q, model.ph)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								cj: $author$project$Api$Data$Loading,
								b7: $author$project$Api$Pagination$reset(model.b7),
								ph: q
							});
						return _Utils_Tuple2(
							qModel,
							$author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroupPractices(qModel));
					}
				}();
				var newModel = _v32.a;
				var cmd = _v32.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{t_: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$PracticesSearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
			case 21:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						cj: $author$project$Api$Data$Loading,
						b7: $author$project$Api$Pagination$reset(model.b7),
						pi: A2($author$project$Api$Sort$update, columnId, model.pi)
					});
				return _Utils_Tuple3(
					newModel,
					$author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroupPractices(newModel),
					_List_Nil);
			case 22:
				var _v34 = model.aq;
				if (!_v34.$) {
					var _v35 = _v34.a;
					var adminUsersGroup = _v35.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								a$: $elm$core$Maybe$Just(
									_Utils_Tuple3(
										$author$project$Api$Platform$AdminUsersGroup$One$id(adminUsersGroup),
										$author$project$Utils$Form$init($elm$core$Maybe$Nothing),
										$author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 23:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{a$: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 24:
				var field = msg.a;
				var _v36 = model.a$;
				if (!_v36.$) {
					var _v37 = _v36.a;
					var adminUsersGroupId = _v37.a;
					var form = _v37.b;
					var request = _v37.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$practiceFormFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								a$: $elm$core$Maybe$Just(
									_Utils_Tuple3(adminUsersGroupId, newForm, request))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 25:
				var _v38 = model.a$;
				if (!_v38.$) {
					var _v39 = _v38.a;
					var adminUsersGroupId = _v39.a;
					var form = _v39.b;
					var _v40 = A2($author$project$Utils$Form$validate, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$practiceFormFieldsValidator, form);
					if (!_v40.$) {
						var _v41 = _v40.a;
						var newForm = _v41.a;
						var validFormFields = _v41.b;
						var practiceId = A2(
							$elm$core$Maybe$withDefault,
							'',
							$rtfeldman$elm_validate$Validate$fromValid(validFormFields));
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									a$: $elm$core$Maybe$Just(
										_Utils_Tuple3(adminUsersGroupId, newForm, $author$project$Api$Data$Loading))
								}),
							A4($author$project$Api$Platform$AdminUsersGroup$Practice$add, model.Gv, adminUsersGroupId, practiceId, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$AdminUsersGroupPracticeAdded),
							_List_Nil);
					} else {
						var newForm = _v40.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									a$: $elm$core$Maybe$Just(
										_Utils_Tuple3(adminUsersGroupId, newForm, $author$project$Api$Data$NotAsked))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 26:
				var response = msg.a;
				var _v42 = model.a$;
				if (!_v42.$) {
					var _v43 = _v42.a;
					var adminUsersGroupId = _v43.a;
					var form = _v43.b;
					if (response.$ === 3) {
						var practice = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{a$: $elm$core$Maybe$Nothing, cj: $author$project$Api$Data$Loading}),
							$author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroupPractices(model),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Platform$Practice$Min$name(practice) + ' was successfully added.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									a$: $elm$core$Maybe$Just(
										_Utils_Tuple3(adminUsersGroupId, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 27:
				var adminUsersGroupId = msg.a;
				var practice = msg.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							df: $elm$core$Maybe$Nothing,
							d8: A2(
								$elm$core$Set$insert,
								$author$project$Api$Platform$Practice$Min$id(practice),
								model.d8)
						}),
					A4(
						$author$project$Api$Platform$AdminUsersGroup$Practice$remove,
						model.Gv,
						adminUsersGroupId,
						$author$project$Api$Platform$Practice$Min$id(practice),
						$author$project$Pages$Hinter$AdminUsersGroups$Id_String$AdminUsersGroupPracticeDeleted(practice)),
					_List_Nil);
			default:
				var practice = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									cj: $author$project$Api$Data$Loading,
									d8: A2(
										$elm$core$Set$remove,
										$author$project$Api$Platform$Practice$Min$id(practice),
										model.d8)
								}),
							$author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroupPractices(model),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Platform$Practice$Min$name(practice) + ' was successfully removed.')
								]));
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									d8: A2(
										$elm$core$Set$remove,
										$author$project$Api$Platform$Practice$Min$id(practice),
										model.d8)
								}),
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error)),
								$author$project$OutMsg$reportDecodeError(response)));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$PracticeFormUpdated = function (a) {
	return {$: 24, a: a};
};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$PracticeId = $elm$core$Basics$identity;
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$SaveAdminUsersGroupPractice = {$: 25};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAddPracticeModal = F2(
	function (form, request) {
		var practiceId = $author$project$Utils$Form$fields(form);
		var modalConfig = {
			Tq: $elm$core$Maybe$Nothing,
			aih: 'Add Practice',
			V8: _Utils_eq(request, $author$project$Api$Data$Loading),
			WG: $elm$core$Maybe$Nothing,
			WH: $elm$core$Maybe$Nothing,
			Yd: $author$project$Pages$Hinter$AdminUsersGroups$Id_String$CancelAddPractice,
			Yf: $elm$core$Basics$always($author$project$Pages$Hinter$AdminUsersGroups$Id_String$SaveAdminUsersGroupPractice)
		};
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(4),
							$author$project$Ui$Form$Group$label('Practice ID'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(
									A2($elm$core$Maybe$withDefault, '', practiceId)),
									$author$project$Ui$Form$Input$placeholder('pra-abcdef1234567890'),
									$author$project$Ui$Form$Input$autofocus(true),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$PracticeFormUpdated, $elm$core$Basics$identity)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form))
								])),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						]))
				]));
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$SaveAdminUsersGroupUser = {$: 14};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$UserFormUpdated = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$UserId = $elm$core$Basics$identity;
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAddUserModal = F2(
	function (form, request) {
		var userId = $author$project$Utils$Form$fields(form);
		var modalConfig = {
			Tq: $elm$core$Maybe$Nothing,
			aih: 'Add User',
			V8: _Utils_eq(request, $author$project$Api$Data$Loading),
			WG: $elm$core$Maybe$Nothing,
			WH: $elm$core$Maybe$Nothing,
			Yd: $author$project$Pages$Hinter$AdminUsersGroups$Id_String$CancelAddUser,
			Yf: $elm$core$Basics$always($author$project$Pages$Hinter$AdminUsersGroups$Id_String$SaveAdminUsersGroupUser)
		};
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(4),
							$author$project$Ui$Form$Group$label('User ID'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(
									A2($elm$core$Maybe$withDefault, '', userId)),
									$author$project$Ui$Form$Input$placeholder('user-abcdef1234567890'),
									$author$project$Ui$Form$Input$autofocus(true),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$UserFormUpdated, $elm$core$Basics$identity)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form))
								])),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						]))
				]));
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$AddPractice = {$: 22};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$PracticesPaginationMsg = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$PracticesSortTable = function (a) {
	return {$: 21, a: a};
};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$practicesTableColumns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'id', true, 'ID'),
		A3($author$project$Api$Column$init, 'name', true, 'Name')
	]);
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$DeleteAdminUsersGroupPractice = F2(
	function (a, b) {
		return {$: 27, a: a, b: b};
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAdminUsersGroupPractice = F3(
	function (adminUsersGroupId, model, practice) {
		var id = $author$project$Api$Platform$Practice$Min$id(practice);
		var loading = A2($elm$core$Set$member, id, model.d8);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Platform$Practice$Min$id(practice))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Platform$Practice$Min$name(practice))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$textRight]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Remove practice from admin users group'},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$sm,
									$author$project$Ui$Button$loading(loading),
									$author$project$Ui$Button$onClick(
									A2($author$project$Pages$Hinter$AdminUsersGroups$Id_String$DeleteAdminUsersGroupPractice, adminUsersGroupId, practice)),
									$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Remove')
								]))
						]))
				]));
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAdminUsersGroupPracticesTable = F2(
	function (adminUsersGroupId, model) {
		var _v0 = function () {
			var _v1 = model.cj;
			if (_v1.$ === 3) {
				var adminUsersGroupPractices_ = _v1.a;
				return _Utils_Tuple2(false, adminUsersGroupPractices_);
			} else {
				return _Utils_Tuple2(true, _List_Nil);
			}
		}();
		var loading = _v0.a;
		var adminUsersGroupPractices = _v0.b;
		return A4(
			$author$project$Ui$Panel$table,
			_List_fromArray(
				[
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('There are no practices in this group')
						])),
					$author$project$Ui$Table$loading(loading)
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						A2(
						$elm$core$List$map,
						$author$project$Api$Column$view(
							A2($author$project$Api$Column$Sortable, model.pi, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$PracticesSortTable)),
						$author$project$Pages$Hinter$AdminUsersGroups$Id_String$practicesTableColumns),
						_List_fromArray(
						[
							A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
						])
					])),
			A2(
				$elm$core$List$map,
				A2($author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAdminUsersGroupPractice, adminUsersGroupId, model),
				adminUsersGroupPractices),
			_List_Nil);
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAdminUsersGroupPractices = F2(
	function (adminUsersGroupId, model) {
		var loading = function () {
			var _v0 = model.cj;
			if (_v0.$ === 3) {
				return false;
			} else {
				return true;
			}
		}();
		return A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
							_List_fromArray(
								[
									$author$project$Ui$Panel$title(
									_List_fromArray(
										[
											$elm$html$Html$text('Practices')
										])),
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Add practice'},
									_List_fromArray(
										[
											$author$project$Ui$Button$default,
											$author$project$Ui$Button$onClick($author$project$Pages$Hinter$AdminUsersGroups$Id_String$AddPractice)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Add Practice')
										]))
								])),
							A2(
							$author$project$Ui$Grid$row,
							_List_fromArray(
								[$author$project$Ui$Grid$mt2]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(12)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Group$view,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$map,
													$author$project$Pages$Hinter$AdminUsersGroups$Id_String$PracticesSearchInputMsg,
													A2($author$project$Ui$SearchInput$view, _List_Nil, model.t_))
												]))
										]))
								]))
						])),
					A2($author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAdminUsersGroupPracticesTable, adminUsersGroupId, model),
					A2(
					$author$project$Ui$Panel$footer,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Pages$Hinter$AdminUsersGroups$Id_String$PracticesPaginationMsg,
							A2(
								$author$project$Api$Pagination$view,
								_List_fromArray(
									[
										$author$project$Ui$Pagination$List$loading(loading)
									]),
								model.b7))
						]))
				]));
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$AddUser = {$: 11};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$UsersPaginationMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$UsersSortTable = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$usersTableColumns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'id', true, 'ID'),
		A3($author$project$Api$Column$init, 'first_name', true, 'Name'),
		A3($author$project$Api$Column$init, 'email', true, 'Email')
	]);
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$DeleteAdminUsersGroupUser = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Api$Platform$User$Min$email = function (_v0) {
	var record = _v0;
	return record.Rj;
};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewUser = F3(
	function (adminUsersGroupId, model, user) {
		var id = $author$project$Api$Platform$User$Min$id(user);
		var loading = A2($elm$core$Set$member, id, model.d9);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Platform$User$Min$id(user))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Platform$User$Min$name(user))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Platform$User$Min$email(user))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$textRight]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Remove user from admin users group'},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$sm,
									$author$project$Ui$Button$loading(loading),
									$author$project$Ui$Button$onClick(
									A2($author$project$Pages$Hinter$AdminUsersGroups$Id_String$DeleteAdminUsersGroupUser, adminUsersGroupId, user)),
									$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Remove')
								]))
						]))
				]));
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAdminUsersGroupUsersTable = F2(
	function (adminUsersGroupId, model) {
		var _v0 = function () {
			var _v1 = model.c_;
			if (_v1.$ === 3) {
				var adminUsersGroupUsers_ = _v1.a;
				return _Utils_Tuple2(false, adminUsersGroupUsers_);
			} else {
				return _Utils_Tuple2(true, _List_Nil);
			}
		}();
		var loading = _v0.a;
		var adminUsersGroupUsers = _v0.b;
		return A4(
			$author$project$Ui$Panel$table,
			_List_fromArray(
				[
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('There are no users in this group')
						])),
					$author$project$Ui$Table$loading(loading)
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						A2(
						$elm$core$List$map,
						$author$project$Api$Column$view(
							A2($author$project$Api$Column$Sortable, model.qZ, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$UsersSortTable)),
						$author$project$Pages$Hinter$AdminUsersGroups$Id_String$usersTableColumns),
						_List_fromArray(
						[
							A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
						])
					])),
			A2(
				$elm$core$List$map,
				A2($author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewUser, adminUsersGroupId, model),
				adminUsersGroupUsers),
			_List_Nil);
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAdminUsersGroupUsers = F2(
	function (adminUsersGroupId, model) {
		var loading = function () {
			var _v0 = model.c_;
			if (_v0.$ === 3) {
				return false;
			} else {
				return true;
			}
		}();
		return A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
							_List_fromArray(
								[
									$author$project$Ui$Panel$title(
									_List_fromArray(
										[
											$elm$html$Html$text('Users')
										])),
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Add user'},
									_List_fromArray(
										[
											$author$project$Ui$Button$default,
											$author$project$Ui$Button$onClick($author$project$Pages$Hinter$AdminUsersGroups$Id_String$AddUser)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Add User')
										]))
								])),
							A2(
							$author$project$Ui$Grid$row,
							_List_fromArray(
								[$author$project$Ui$Grid$mt2]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(12)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Group$view,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$map,
													$author$project$Pages$Hinter$AdminUsersGroups$Id_String$UsersSearchInputMsg,
													A2($author$project$Ui$SearchInput$view, _List_Nil, model.vm))
												]))
										]))
								]))
						])),
					A2($author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAdminUsersGroupUsersTable, adminUsersGroupId, model),
					A2(
					$author$project$Ui$Panel$footer,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Pages$Hinter$AdminUsersGroups$Id_String$UsersPaginationMsg,
							A2(
								$author$project$Api$Pagination$view,
								_List_fromArray(
									[
										$author$project$Ui$Pagination$List$loading(loading)
									]),
								model.cf))
						]))
				]));
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$DeleteAdminUsersGroup = {$: 4};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$FormUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$Name = $elm$core$Basics$identity;
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$SaveAdminUsersGroup = {$: 1};
var $author$project$Api$Platform$AdminUsersGroup$One$practicesCount = function (_v0) {
	var record = _v0.b;
	return record.Z0;
};
var $author$project$Api$Platform$AdminUsersGroup$One$usersCount = function (_v0) {
	var record = _v0.b;
	return record.ad2;
};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewForm = F3(
	function (adminUsersGroup, form, saveRequest) {
		var preventDelete = ($author$project$Api$Platform$AdminUsersGroup$One$usersCount(adminUsersGroup) > 0) || ($author$project$Api$Platform$AdminUsersGroup$One$practicesCount(adminUsersGroup) > 0);
		var name = $author$project$Utils$Form$fields(form);
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(4),
							$author$project$Ui$Form$Group$label('Name'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(name),
									$author$project$Ui$Form$Input$placeholder('Group Name'),
									$author$project$Ui$Form$Input$autofocus(true),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$FormUpdated, $elm$core$Basics$identity)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form))
								])),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$textCenter, $author$project$Ui$Element$mt2]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Update admin users group'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$submit,
									$author$project$Ui$Button$loading(
									_Utils_eq(saveRequest, $author$project$Api$Data$Loading)),
									$author$project$Ui$Button$onClick($author$project$Pages$Hinter$AdminUsersGroups$Id_String$SaveAdminUsersGroup)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Update')
								])),
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Delete admin users group'},
							_List_fromArray(
								[
									$author$project$Ui$Button$danger,
									$author$project$Ui$Button$disabled(preventDelete),
									$author$project$Ui$Button$loading(
									_Utils_eq(saveRequest, $author$project$Api$Data$Loading)),
									$author$project$Ui$Button$onClick($author$project$Pages$Hinter$AdminUsersGroups$Id_String$DeleteAdminUsersGroup),
									$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Delete')
								]))
						]))
				]));
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAdminUsersGroup = F4(
	function (adminUsersGroup, form, saveRequest, model) {
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanMd(12)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Panel$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Panel$heading,
											_List_fromArray(
												[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
											_List_fromArray(
												[
													$author$project$Ui$Panel$title(
													_List_fromArray(
														[
															$elm$html$Html$text('Admin Users Group - '),
															$elm$html$Html$text(
															$author$project$Api$Platform$AdminUsersGroup$One$name(adminUsersGroup))
														])),
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Hinter__AdminUsersGroups__Top,
													_List_Nil,
													_List_fromArray(
														[
															$author$project$Ui$Icon$cross(_List_Nil)
														]))
												])),
											A2(
											$author$project$Ui$Panel$body,
											_List_Nil,
											_List_fromArray(
												[
													A3($author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewForm, adminUsersGroup, form, saveRequest),
													$author$project$Ui$HorizontalRule$view(_List_Nil)
												]))
										]))
								]))
						])),
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanMd(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAdminUsersGroupUsers,
									$author$project$Api$Platform$AdminUsersGroup$One$id(adminUsersGroup),
									model)
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanMd(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAdminUsersGroupPractices,
									$author$project$Api$Platform$AdminUsersGroup$One$id(adminUsersGroup),
									model)
								]))
						]))
				]));
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				function () {
				var _v0 = model.df;
				if (!_v0.$) {
					var deleteRequest = _v0.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Hinter$AdminUsersGroups$Id_String$DeleteAdminUsersGroupClosed,
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('delete'),
								$author$project$Components$HiConfirm$noun('admin users group'),
								$author$project$Components$HiConfirm$loading(
								_Utils_eq(deleteRequest, $author$project$Api$Data$Loading))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v1 = model.a0;
				if (!_v1.$) {
					var _v2 = _v1.a;
					var form = _v2.b;
					var user = _v2.c;
					return A2($author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAddUserModal, form, user);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v3 = model.a$;
				if (!_v3.$) {
					var _v4 = _v3.a;
					var form = _v4.b;
					var practice = _v4.c;
					return A2($author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAddPracticeModal, form, practice);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v5 = model.aq;
				if (!_v5.$) {
					var _v6 = _v5.a;
					var adminUsersGroup = _v6.a;
					var form = _v6.b;
					var saveRequest = _v6.c;
					return A4($author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAdminUsersGroup, adminUsersGroup, form, saveRequest, model);
				} else {
					return A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$textCenter]),
						_List_fromArray(
							[
								$author$project$Ui$Spinner$view(_List_Nil)
							]));
				}
			}()
			]),
		ac9: 'Admin | Admin Users Groups'
	};
};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$page = $author$project$Spa$Page$applicationPrivate(
	{ah_: $author$project$Pages$Hinter$AdminUsersGroups$Id_String$init, aiq: $author$project$Pages$Hinter$AdminUsersGroups$Id_String$load, k8: $author$project$Pages$Hinter$AdminUsersGroups$Id_String$save, alO: $author$project$Pages$Hinter$AdminUsersGroups$Id_String$subscriptions, adT: $author$project$Pages$Hinter$AdminUsersGroups$Id_String$update, amo: $author$project$Pages$Hinter$AdminUsersGroups$Id_String$view});
var $author$project$Pages$Hinter$AdminUsersGroups$Top$GotAdminUsersGroups = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Platform$AdminUsersGroup$All$AdminUsersGroup = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Platform$AdminUsersGroup$All$AllRecord = F2(
	function (usersCount, practicesCount) {
		return {Z0: practicesCount, ad2: usersCount};
	});
var $author$project$Api$Platform$AdminUsersGroup$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'practices_count',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'users_count',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Api$Platform$AdminUsersGroup$All$AllRecord)));
var $author$project$Api$Platform$AdminUsersGroup$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$AdminUsersGroup$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Platform$AdminUsersGroup$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Platform$AdminUsersGroup$All$AdminUsersGroup)));
var $author$project$Api$Platform$AdminUsersGroup$listDefaults = {
	ajJ: $author$project$Api$Pagination$init,
	akl: $elm$core$Maybe$Nothing,
	alA: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init)
};
var $author$project$Api$Platform$AdminUsersGroup$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Platform$AdminUsersGroup$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.akl;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$Platform$AdminUsersGroup$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Platform$AdminUsersGroup$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Platform$AdminUsersGroup$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Platform$AdminUsersGroup$adminUsersGroupsPath)));
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Top$fetchAdminUsersGroups = function (model) {
	return A3(
		$author$project$Api$Platform$AdminUsersGroup$list,
		model.Gv,
		function (d) {
			return _Utils_update(
				d,
				{ajJ: model.ajJ, akl: model.akl, alA: model.alA});
		},
		$author$project$Pages$Hinter$AdminUsersGroups$Top$GotAdminUsersGroups);
};
var $author$project$Pages$Hinter$AdminUsersGroups$Top$init = F3(
	function (_v0, _v1, _v2) {
		var apiClient = _v1.Gv;
		var query = _v2.DE;
		var q = A2($elm$core$Dict$get, 'q', query);
		var model = {
			aq: $elm$core$Maybe$Nothing,
			Gm: $author$project$Api$Data$Loading,
			Gv: apiClient,
			ajJ: $author$project$Api$Pagination$init,
			akl: q,
			up: $author$project$Ui$SearchInput$init(q),
			alA: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init)
		};
		return _Utils_Tuple2(
			model,
			$author$project$Pages$Hinter$AdminUsersGroups$Top$fetchAdminUsersGroups(model));
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Top$CancelAdminUsersGroupEdit = {$: 4};
var $author$project$Pages$Hinter$AdminUsersGroups$Top$subscriptions = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Platform$Sub$none,
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$always(
				$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Hinter$AdminUsersGroups$Top$CancelAdminUsersGroupEdit)),
			model.aq));
};
var $author$project$Pages$Hinter$AdminUsersGroups$Top$SearchInputMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Hinter$AdminUsersGroups$Top$AdminUsersGroupCreated = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Platform$AdminUsersGroup$create = F3(
	function (apiClient, name_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'admin_users_group',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(name_))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Platform$AdminUsersGroup$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Platform$AdminUsersGroup$adminUsersGroupsPath)));
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Top$createAdminUsersGroup = F2(
	function (apiClient, formFields) {
		var name = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A3($author$project$Api$Platform$AdminUsersGroup$create, apiClient, name, $author$project$Pages$Hinter$AdminUsersGroups$Top$AdminUsersGroupCreated);
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Top$formFieldsInit = '';
var $author$project$Pages$Hinter$AdminUsersGroups$Top$formFieldsUpdate = F2(
	function (field, _v0) {
		var name = field;
		return name;
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Top$NameValidation = 0;
var $author$project$Pages$Hinter$AdminUsersGroups$Top$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			$elm$core$Basics$identity,
			_Utils_Tuple2(0, 'Please enter a name.'))
		]));
var $author$project$Pages$Hinter$AdminUsersGroups$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aq: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init($author$project$Pages$Hinter$AdminUsersGroups$Top$formFieldsInit),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{Gm: $author$project$Api$Data$Loading, ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					$author$project$Pages$Hinter$AdminUsersGroups$Top$fetchAdminUsersGroups(newModel),
					_List_Nil);
			case 2:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Ui$SearchInput$update, subMsg, model.up);
				var searchInput = _v1.a;
				var searchInputCmd = _v1.b;
				var searchInputEvent = _v1.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.akl;
					}
				}();
				var _v2 = function () {
					if (_Utils_eq(q, model.akl)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								Gm: $author$project$Api$Data$Loading,
								ajJ: $author$project$Api$Pagination$reset(model.ajJ),
								akl: q
							});
						return _Utils_Tuple2(
							qModel,
							$author$project$Pages$Hinter$AdminUsersGroups$Top$fetchAdminUsersGroups(qModel));
					}
				}();
				var newModel = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{up: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Hinter$AdminUsersGroups$Top$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
			case 3:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						Gm: $author$project$Api$Data$Loading,
						ajJ: $author$project$Api$Pagination$reset(model.ajJ),
						alA: A2($author$project$Api$Sort$update, columnId, model.alA)
					});
				return _Utils_Tuple3(
					newModel,
					$author$project$Pages$Hinter$AdminUsersGroups$Top$fetchAdminUsersGroups(newModel),
					_List_Nil);
			case 6:
				var form = msg.a;
				var id = msg.b;
				var _v4 = A2($author$project$Utils$Form$validate, $author$project$Pages$Hinter$AdminUsersGroups$Top$formFieldsValidator, form);
				if (!_v4.$) {
					var _v5 = _v4.a;
					var newForm = _v5.a;
					var validFormFields = _v5.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aq: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, $author$project$Api$Data$Loading))
							}),
						A2($author$project$Pages$Hinter$AdminUsersGroups$Top$createAdminUsersGroup, model.Gv, validFormFields),
						_List_Nil);
				} else {
					var newForm = _v4.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aq: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aq: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Gm: response,
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Gm: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 7:
				var field = msg.a;
				var _v7 = model.aq;
				if (!_v7.$) {
					var _v8 = _v7.a;
					var id = _v8.a;
					var form = _v8.b;
					var adminUsersGroup = _v8.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Hinter$AdminUsersGroups$Top$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aq: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, adminUsersGroup))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var dataAdminUsersGroup = msg.a;
				var _v9 = model.aq;
				if (!_v9.$) {
					var _v10 = _v9.a;
					var id = _v10.a;
					var form = _v10.b;
					if (dataAdminUsersGroup.$ === 3) {
						var adminUsersGroup = dataAdminUsersGroup.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{aq: $elm$core$Maybe$Nothing, Gm: $author$project$Api$Data$Loading}),
							$author$project$Pages$Hinter$AdminUsersGroups$Top$fetchAdminUsersGroups(model),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									'Successfully created ' + $author$project$Api$Platform$AdminUsersGroup$One$name(adminUsersGroup))
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aq: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, dataAdminUsersGroup))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(dataAdminUsersGroup));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Top$NewAdminUsersGroup = {$: 0};
var $author$project$Pages$Hinter$AdminUsersGroups$Top$PaginationMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Hinter$AdminUsersGroups$Top$FormUpdated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Hinter$AdminUsersGroups$Top$Name = $elm$core$Basics$identity;
var $author$project$Pages$Hinter$AdminUsersGroups$Top$SaveAdminUsersGroup = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Top$viewAdminUsersGroupModal = F3(
	function (id, form, adminUsersGroup) {
		var name = $author$project$Utils$Form$fields(form);
		var modalConfig = {
			Tq: $elm$core$Maybe$Nothing,
			aih: 'Admin Users Group',
			V8: _Utils_eq(adminUsersGroup, $author$project$Api$Data$Loading),
			WG: id,
			WH: $elm$core$Maybe$Nothing,
			Yd: $author$project$Pages$Hinter$AdminUsersGroups$Top$CancelAdminUsersGroupEdit,
			Yf: $author$project$Pages$Hinter$AdminUsersGroups$Top$SaveAdminUsersGroup(form)
		};
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(4),
							$author$project$Ui$Form$Group$label('Name'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(name),
									$author$project$Ui$Form$Input$placeholder('Group Name'),
									$author$project$Ui$Form$Input$autofocus(true),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$AdminUsersGroups$Top$FormUpdated, $elm$core$Basics$identity)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form))
								])),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						]))
				]));
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Top$SortTable = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Hinter$AdminUsersGroups$Top$tableColumns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'name', true, 'Name'),
		A3($author$project$Api$Column$init, 'users_count', false, 'Users Count'),
		A3($author$project$Api$Column$init, 'practices_count', false, 'Practices Count')
	]);
var $author$project$Api$Platform$AdminUsersGroup$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Platform$AdminUsersGroup$Shared$id(shared);
};
var $author$project$Api$Platform$AdminUsersGroup$All$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Platform$AdminUsersGroup$Shared$name(shared);
};
var $author$project$Api$Platform$AdminUsersGroup$All$practicesCount = function (_v0) {
	var record = _v0.b;
	return record.Z0;
};
var $author$project$Api$Platform$AdminUsersGroup$All$usersCount = function (_v0) {
	var record = _v0.b;
	return record.ad2;
};
var $author$project$Pages$Hinter$AdminUsersGroups$Top$viewAdminUsersGroup = function (adminUsersGroup) {
	var id = $author$project$Api$Platform$AdminUsersGroup$All$id(adminUsersGroup);
	return A2(
		$author$project$Ui$Table$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Hinter__AdminUsersGroups__Id_String(
							{ahP: id}),
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Api$Platform$AdminUsersGroup$All$name(adminUsersGroup))
							]))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$fromInt(
							$author$project$Api$Platform$AdminUsersGroup$All$usersCount(adminUsersGroup)))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$fromInt(
							$author$project$Api$Platform$AdminUsersGroup$All$practicesCount(adminUsersGroup)))
					]))
			]));
};
var $author$project$Pages$Hinter$AdminUsersGroups$Top$viewPanelBody = function (model) {
	var _v0 = function () {
		var _v1 = model.Gm;
		if (_v1.$ === 3) {
			var adminUsersGroups_ = _v1.a;
			return _Utils_Tuple2(false, adminUsersGroups_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var adminUsersGroups = _v0.b;
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$verticalCentered,
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You have no Admin Users Groups.'),
						A2($elm$html$Html$br, _List_Nil, _List_Nil),
						function () {
						var label = 'Add a Admin Users Group here';
						return A3(
							$author$project$Ui$Button$view,
							{mm: label},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$onClick($author$project$Pages$Hinter$AdminUsersGroups$Top$NewAdminUsersGroup)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(label)
								]));
					}()
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		A2(
			$elm$core$List$map,
			$author$project$Api$Column$view(
				A2($author$project$Api$Column$Sortable, model.alA, $author$project$Pages$Hinter$AdminUsersGroups$Top$SortTable)),
			$author$project$Pages$Hinter$AdminUsersGroups$Top$tableColumns),
		A2($elm$core$List$map, $author$project$Pages$Hinter$AdminUsersGroups$Top$viewAdminUsersGroup, adminUsersGroups),
		_List_Nil);
};
var $author$project$Pages$Hinter$AdminUsersGroups$Top$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				function () {
				var _v0 = model.aq;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var id = _v1.a;
					var form = _v1.b;
					var adminUsersGroup = _v1.c;
					return A3($author$project$Pages$Hinter$AdminUsersGroups$Top$viewAdminUsersGroupModal, id, form, adminUsersGroup);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Admin Users Groups')
											])),
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Button$view,
												{mm: 'Add new admin users group'},
												_List_fromArray(
													[
														$author$project$Ui$Button$default,
														$author$project$Ui$Button$onClick($author$project$Pages$Hinter$AdminUsersGroups$Top$NewAdminUsersGroup),
														$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('New Admin Users Group')
													])),
												A3(
												$author$project$Ui$Link$route,
												$author$project$Spa$Generated$Route$User__Organizations__Top,
												_List_Nil,
												_List_fromArray(
													[
														$author$project$Ui$Icon$cross(_List_Nil)
													]))
											]))
									])),
								A2(
								$elm$html$Html$em,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Lets you assign multiple users to multiple practices')
									])),
								A2(
								$author$project$Ui$Grid$row,
								_List_fromArray(
									[$author$project$Ui$Grid$mt2]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(12)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Group$view,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$map,
														$author$project$Pages$Hinter$AdminUsersGroups$Top$SearchInputMsg,
														A2($author$project$Ui$SearchInput$view, _List_Nil, model.up))
													]))
											]))
									]))
							])),
						$author$project$Pages$Hinter$AdminUsersGroups$Top$viewPanelBody(model),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Hinter$AdminUsersGroups$Top$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(
											!$author$project$Api$Data$isSuccess(model.Gm))
										]),
									model.ajJ))
							]))
					]))
			]),
		ac9: 'Admin | Admin Users Groups'
	};
};
var $author$project$Pages$Hinter$AdminUsersGroups$Top$page = $author$project$Spa$Page$applicationPrivate(
	{ah_: $author$project$Pages$Hinter$AdminUsersGroups$Top$init, aiq: $author$project$Pages$Hinter$AdminUsersGroups$Top$load, k8: $author$project$Pages$Hinter$AdminUsersGroups$Top$save, alO: $author$project$Pages$Hinter$AdminUsersGroups$Top$subscriptions, adT: $author$project$Pages$Hinter$AdminUsersGroups$Top$update, amo: $author$project$Pages$Hinter$AdminUsersGroups$Top$view});
var $author$project$Pages$Hinter$ClonePractice$GotPracticeUsers = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Hinter$ClonePractice$fetchTeamMembers = function (apiClient) {
	return A3(
		$author$project$Api$Provider$TeamMember$list,
		apiClient,
		function (d) {
			return _Utils_update(
				d,
				{
					ajJ: A2($author$project$Api$Pagination$withItemsPerPage, 50, $author$project$Api$Pagination$init),
					alA: A3($author$project$Api$Sort$withDefault, 'role', 0, $author$project$Api$Sort$init)
				});
		},
		$author$project$Pages$Hinter$ClonePractice$GotPracticeUsers);
};
var $author$project$Pages$Hinter$ClonePractice$LaunchDateDateInputMsg = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Hinter$ClonePractice$initFormFields = function (practice) {
	var _v0 = $author$project$Components$DateInput$init;
	var launchDateDateInput = _v0.a;
	var launchDateDateInputCmd = _v0.b;
	return _Utils_Tuple2(
		{
			afJ: false,
			afK: false,
			afL: false,
			afM: false,
			agd: true,
			Rj: $author$project$Api$Provider$Practice$One$email(practice),
			HS: practice,
			TD: $elm$core$Maybe$Nothing,
			VQ: $elm$core$Maybe$Nothing,
			sZ: launchDateDateInput,
			Bq: '',
			aj9: _List_Nil,
			$L: false
		},
		A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Pages$Hinter$ClonePractice$LaunchDateDateInputMsg(launchDateDateInput),
			launchDateDateInputCmd));
};
var $author$project$Pages$Hinter$ClonePractice$init = F4(
	function (_v0, practice, shared, _v1) {
		var _v2 = $author$project$Pages$Hinter$ClonePractice$initFormFields(practice);
		var formFields = _v2.a;
		var formFieldsCmd = _v2.b;
		return _Utils_Tuple2(
			{
				Gv: shared.Gv,
				dd: shared.dd,
				SD: $author$project$Utils$Form$init(formFields),
				aj9: $author$project$Api$Data$Loading,
				k9: $author$project$Api$Data$NotAsked
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						formFieldsCmd,
						$author$project$Pages$Hinter$ClonePractice$fetchTeamMembers(shared.Gv)
					])));
	});
var $author$project$Pages$Hinter$ClonePractice$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{dd: shared.dd}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Hinter$ClonePractice$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Hinter$ClonePractice$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Hinter$ClonePractice$LaunchDate = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Pages$Hinter$ClonePractice$PracticeCreated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$Practice$clone = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practice',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(fields.Bq)),
								_Utils_Tuple2(
								'launch_date',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.VQ)),
								_Utils_Tuple2(
								'requires_payment_information',
								$elm$json$Json$Encode$bool(fields.$L)),
								_Utils_Tuple2(
								'practice_users',
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, fields.aj9)),
								_Utils_Tuple2(
								'hubspot_deal_id',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.TD)),
								_Utils_Tuple2(
								'clone_embedded_reports',
								$elm$json$Json$Encode$bool(fields.afK)),
								_Utils_Tuple2(
								'deal_reporting_only',
								$elm$json$Json$Encode$bool(fields.agd)),
								_Utils_Tuple2(
								'clone_lead_sources',
								$elm$json$Json$Encode$bool(fields.afM)),
								_Utils_Tuple2(
								'clone_coupons',
								$elm$json$Json$Encode$bool(fields.afJ)),
								_Utils_Tuple2(
								'clone_feature_flags',
								$elm$json$Json$Encode$bool(fields.afL)),
								_Utils_Tuple2(
								'email',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Rj))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Practice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['clone']),
						$author$project$Api$Provider$Practice$practicePath))));
	});
var $author$project$Pages$Hinter$ClonePractice$practiceFormFields = function (fields) {
	return {
		afJ: fields.afJ,
		afK: fields.afK,
		afL: fields.afL,
		afM: fields.afM,
		agd: fields.agd,
		Rj: fields.Rj,
		TD: fields.TD,
		VQ: fields.VQ,
		Bq: fields.Bq,
		aj9: A2(
			$elm$core$List$map,
			function (pu) {
				return pu.ahP;
			},
			A2(
				$elm$core$List$filter,
				function (pu) {
					return pu.iK;
				},
				fields.aj9)),
		$L: fields.$L
	};
};
var $author$project$Pages$Hinter$ClonePractice$clonePractice = F2(
	function (apiClient, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A3(
			$author$project$Api$Provider$Practice$clone,
			apiClient,
			$author$project$Pages$Hinter$ClonePractice$practiceFormFields(fields),
			$author$project$Pages$Hinter$ClonePractice$PracticeCreated);
	});
var $author$project$Pages$Hinter$ClonePractice$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{Bq: string});
			case 1:
				var dateInput = field.a;
				var date = field.b;
				return _Utils_update(
					fields,
					{VQ: date, sZ: dateInput});
			case 2:
				var bool = field.a;
				return _Utils_update(
					fields,
					{$L: bool});
			case 3:
				var practiceUserId = field.a;
				var checked = field.b;
				return _Utils_update(
					fields,
					{
						aj9: A3(
							$elm_community$list_extra$List$Extra$updateIf,
							function (practiceUserField) {
								return _Utils_eq(practiceUserField.ahP, practiceUserId);
							},
							function (practiceUserField) {
								return _Utils_update(
									practiceUserField,
									{iK: checked});
							},
							fields.aj9)
					});
			case 4:
				return _Utils_update(
					fields,
					{
						aj9: A2(
							$elm$core$List$map,
							function (practiceUserField) {
								return _Utils_update(
									practiceUserField,
									{iK: true});
							},
							fields.aj9)
					});
			case 5:
				return _Utils_update(
					fields,
					{
						aj9: A2(
							$elm$core$List$map,
							function (practiceUserField) {
								return _Utils_update(
									practiceUserField,
									{iK: false});
							},
							fields.aj9)
					});
			case 6:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						TD: $author$project$Utils$String$toMaybe(string)
					});
			case 7:
				var bool = field.a;
				return _Utils_update(
					fields,
					{afK: bool});
			case 8:
				var bool = field.a;
				return _Utils_update(
					fields,
					{agd: bool});
			case 9:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Rj: $author$project$Utils$String$toMaybe(string)
					});
			case 10:
				var bool = field.a;
				return _Utils_update(
					fields,
					{afM: bool});
			case 11:
				var bool = field.a;
				return _Utils_update(
					fields,
					{afJ: bool});
			default:
				var bool = field.a;
				return _Utils_update(
					fields,
					{afL: bool});
		}
	});
var $author$project$Pages$Hinter$ClonePractice$EmailValidation = 2;
var $author$project$Pages$Hinter$ClonePractice$NameValidation = 0;
var $author$project$Pages$Hinter$ClonePractice$LaunchDateValidation = 1;
var $author$project$Pages$Hinter$ClonePractice$validateLaunchDate = F2(
	function (currentDate, fields) {
		var invalid = _List_fromArray(
			[
				_Utils_Tuple2(1, 'Please enter a date greater or equal than today')
			]);
		var _v0 = fields.VQ;
		if (!_v0.$) {
			var launchDate = _v0.a;
			return (A2($justinmimbs$date$Date$compare, currentDate, launchDate) !== 2) ? _List_Nil : invalid;
		} else {
			return invalid;
		}
	});
var $author$project$Pages$Hinter$ClonePractice$formFieldsValidator = function (currentDate) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_validate$Validate$ifBlank,
				function ($) {
					return $.Bq;
				},
				_Utils_Tuple2(0, 'Please enter a name.')),
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Pages$Hinter$ClonePractice$validateLaunchDate(currentDate)),
				A3(
				$author$project$Utils$Validate$ifInvalidEmail,
				{aeT: true},
				function ($) {
					return $.Rj;
				},
				_Utils_Tuple2(2, 'Please enter a valid email.'))
			]));
};
var $author$project$Pages$Hinter$ClonePractice$initPracticeUserField = function (practiceUser) {
	return {
		iK: false,
		Rj: $author$project$Api$Provider$PracticeUser$All$email(practiceUser),
		ahP: $author$project$Api$Provider$PracticeUser$All$id(practiceUser),
		ak3: $author$project$Api$Provider$PracticeUser$All$role(practiceUser)
	};
};
var $author$project$Pages$Hinter$ClonePractice$formFieldsWithUsers = F2(
	function (users, formFields) {
		return _Utils_update(
			formFields,
			{
				aj9: A2($elm$core$List$map, $author$project$Pages$Hinter$ClonePractice$initPracticeUserField, users)
			});
	});
var $author$project$Pages$Hinter$ClonePractice$updateDateInputFormField = F6(
	function (model, dateInput, subMsg, toMsg, field, fieldGetter) {
		var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
		var newDateInput = _v0.a;
		var subCmd = _v0.b;
		var event = _v0.c;
		var newForm = function () {
			if (event.$ === 1) {
				var date = event.a;
				return A3(
					$author$project$Utils$Form$update,
					$author$project$Pages$Hinter$ClonePractice$formFieldsUpdate,
					A2(field, newDateInput, date),
					model.SD);
			} else {
				var fields = $author$project$Utils$Form$fields(model.SD);
				return A3(
					$author$project$Utils$Form$update,
					$author$project$Pages$Hinter$ClonePractice$formFieldsUpdate,
					A2(
						field,
						newDateInput,
						fieldGetter(fields)),
					model.SD);
			}
		}();
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{SD: newForm}),
			A2(
				$elm$core$Platform$Cmd$map,
				toMsg(newDateInput),
				subCmd),
			_List_Nil);
	});
var $author$project$Pages$Hinter$ClonePractice$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Hinter$ClonePractice$formFieldsUpdate, field, model.SD);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: newForm}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var _v1 = A2(
					$author$project$Utils$Form$validate,
					$author$project$Pages$Hinter$ClonePractice$formFieldsValidator(model.dd),
					model.SD);
				if (!_v1.$) {
					var _v2 = _v1.a;
					var validatedForm = _v2.a;
					var validFormFields = _v2.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{SD: validatedForm, k9: $author$project$Api$Data$Loading}),
						A2($author$project$Pages$Hinter$ClonePractice$clonePractice, model.Gv, validFormFields),
						_List_Nil);
				} else {
					var validatedForm = _v1.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{SD: validatedForm, k9: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					var practice = response.a;
					var _v4 = _Utils_Tuple2(
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A3(
								$author$project$OutMsg$SwitchToOrganization,
								$author$project$Api$Provider$Practice$One$organizationId(practice),
								$elm$core$Maybe$Nothing,
								$author$project$OutMsg$GoToRouteAction($author$project$Spa$Generated$Route$Admin__Billing))
							]));
					var cmd = _v4.a;
					var outMsgs = _v4.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: response}),
						cmd,
						_Utils_ap(
							outMsgs,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Practice cloned'),
									$author$project$OutMsg$PracticeUpdated(response)
								])));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 3:
				var dateInput = msg.a;
				var subMsg = msg.b;
				return A6(
					$author$project$Pages$Hinter$ClonePractice$updateDateInputFormField,
					model,
					dateInput,
					subMsg,
					$author$project$Pages$Hinter$ClonePractice$LaunchDateDateInputMsg,
					$author$project$Pages$Hinter$ClonePractice$LaunchDate,
					function ($) {
						return $.VQ;
					});
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var practiceUsers = response.a;
					var fields = $author$project$Utils$Form$fields(model.SD);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								SD: $author$project$Utils$Form$init(
									A2($author$project$Pages$Hinter$ClonePractice$formFieldsWithUsers, practiceUsers, fields)),
								aj9: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{aj9: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Hinter$ClonePractice$Save = {$: 1};
var $author$project$Pages$Hinter$ClonePractice$CloneCoupons = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Hinter$ClonePractice$CloneEmbeddedReports = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Hinter$ClonePractice$CloneFeatureFlags = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Hinter$ClonePractice$CloneLeadSources = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Hinter$ClonePractice$DealReportingOnly = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Hinter$ClonePractice$Email = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Hinter$ClonePractice$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Hinter$ClonePractice$HubspotDealId = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Hinter$ClonePractice$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Hinter$ClonePractice$RequiresPaymentInformation = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Hinter$ClonePractice$PracticeUserChecked = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Hinter$ClonePractice$viewPracticeUser = function (practiceUserField) {
	return A2(
		$author$project$Ui$Form$Checkbox$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Checkbox$value(practiceUserField.iK),
				$author$project$Ui$Form$Checkbox$onCheck(
				A2(
					$elm$core$Basics$composeL,
					$author$project$Pages$Hinter$ClonePractice$FormUpdated,
					$author$project$Pages$Hinter$ClonePractice$PracticeUserChecked(practiceUserField.ahP)))
			]),
		_List_fromArray(
			[
				$author$project$Utils$Html$noBreakSpace,
				$elm$html$Html$text(practiceUserField.Rj + (' (' + (practiceUserField.ak3 + ')')))
			]));
};
var $author$project$Pages$Hinter$ClonePractice$PracticeUserAllChecked = {$: 4};
var $author$project$Pages$Hinter$ClonePractice$PracticeUserAllUnChecked = {$: 5};
var $author$project$Pages$Hinter$ClonePractice$viewSelectAllButton = A2(
	$author$project$Ui$Element$view,
	_List_fromArray(
		[$author$project$Ui$Element$gap2]),
	_List_fromArray(
		[
			A3(
			$author$project$Ui$Button$view,
			{mm: 'Select all'},
			_List_fromArray(
				[
					$author$project$Ui$Button$link,
					$author$project$Ui$Button$onClick(
					$author$project$Pages$Hinter$ClonePractice$FormUpdated($author$project$Pages$Hinter$ClonePractice$PracticeUserAllChecked))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Select All')
				])),
			A2($author$project$Ui$Typography$text, _List_Nil, ' | '),
			A3(
			$author$project$Ui$Button$view,
			{mm: 'Unselect all'},
			_List_fromArray(
				[
					$author$project$Ui$Button$link,
					$author$project$Ui$Button$onClick(
					$author$project$Pages$Hinter$ClonePractice$FormUpdated($author$project$Pages$Hinter$ClonePractice$PracticeUserAllUnChecked))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Unselect All')
				]))
		]));
var $author$project$Pages$Hinter$ClonePractice$viewUsers = F2(
	function (practiceUsersData, practiceUserFields) {
		if (practiceUsersData.$ === 3) {
			return A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Practice Users')
					]),
				$elm$core$List$isEmpty(practiceUserFields) ? _List_fromArray(
					[
						$author$project$Ui$Form$Group$static(
						_List_fromArray(
							[
								$elm$html$Html$text('No users to clone')
							]))
					]) : _List_fromArray(
					[
						$author$project$Ui$Form$Group$static(
						A2(
							$elm$core$List$cons,
							$author$project$Pages$Hinter$ClonePractice$viewSelectAllButton,
							A2($elm$core$List$map, $author$project$Pages$Hinter$ClonePractice$viewPracticeUser, practiceUserFields)))
					]));
		} else {
			return A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSkeleton('Practice Users'),
						$author$project$Ui$Form$Group$labelSpan(4),
						$author$project$Ui$Form$Group$inputSpanMd(8)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Skeleton$input(_List_Nil)
					]));
		}
	});
var $author$project$Pages$Hinter$ClonePractice$viewForm = F2(
	function (form, practiceUsers) {
		var fields = $author$project$Utils$Form$fields(form);
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Cloning from')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Api$Provider$Practice$One$name(fields.HS))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Don\'t Require Payment Method')
					]),
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$view(
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$on(!fields.$L),
								$author$project$Ui$ToggleSwitch$onChange(
								function (isOn) {
									return $author$project$Pages$Hinter$ClonePractice$FormUpdated(
										$author$project$Pages$Hinter$ClonePractice$RequiresPaymentInformation(!isOn));
								})
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Clone Embedded Reports')
					]),
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$view(
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$on(fields.afK),
								$author$project$Ui$ToggleSwitch$onChange(
								A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$ClonePractice$FormUpdated, $author$project$Pages$Hinter$ClonePractice$CloneEmbeddedReports))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Clone Lead Sources')
					]),
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$view(
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$on(fields.afM),
								$author$project$Ui$ToggleSwitch$onChange(
								A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$ClonePractice$FormUpdated, $author$project$Pages$Hinter$ClonePractice$CloneLeadSources))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Clone Coupons')
					]),
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$view(
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$on(fields.afJ),
								$author$project$Ui$ToggleSwitch$onChange(
								A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$ClonePractice$FormUpdated, $author$project$Pages$Hinter$ClonePractice$CloneCoupons))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Clone Feature Flags')
					]),
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$view(
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$on(fields.afL),
								$author$project$Ui$ToggleSwitch$onChange(
								A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$ClonePractice$FormUpdated, $author$project$Pages$Hinter$ClonePractice$CloneFeatureFlags))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Business Name'),
						$author$project$Ui$Form$Group$required(true)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(fields.Bq),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$ClonePractice$FormUpdated, $author$project$Pages$Hinter$ClonePractice$Name)),
								$author$project$Ui$Form$Input$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
								$author$project$Ui$Form$Input$errors(
								A2($author$project$Utils$Form$validationErrors, 0, form))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Business Email')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(
								A2($elm$core$Maybe$withDefault, '', fields.Rj)),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$ClonePractice$FormUpdated, $author$project$Pages$Hinter$ClonePractice$Email)),
								$author$project$Ui$Form$Input$phi(true),
								$author$project$Ui$Form$Input$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
								$author$project$Ui$Form$Input$errors(
								A2($author$project$Utils$Form$validationErrors, 2, form))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Hubspot Deal ID')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(
								A2($elm$core$Maybe$withDefault, '', fields.TD)),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$ClonePractice$FormUpdated, $author$project$Pages$Hinter$ClonePractice$HubspotDealId))
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$helpBlock]),
						_List_fromArray(
							[
								$elm$html$Html$text('If Hubspot Deal ID is not provided then pricing will by cloned from the Practice.')
							])),
						A2(
						$author$project$Ui$Form$Checkbox$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Checkbox$value(fields.agd),
								$author$project$Ui$Form$Checkbox$onCheck(
								A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$ClonePractice$FormUpdated, $author$project$Pages$Hinter$ClonePractice$DealReportingOnly))
							]),
						_List_fromArray(
							[
								$author$project$Utils$Html$noBreakSpace,
								$elm$html$Html$text('Deal ID is used for reporting only. Clone the pricing, do not import anything from Hubspot')
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Launch Date'),
						$author$project$Ui$Form$Group$required(true)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Pages$Hinter$ClonePractice$LaunchDateDateInputMsg(fields.sZ),
						A2(
							$author$project$Components$DateInput$view,
							_List_fromArray(
								[
									$author$project$Components$DateInput$value(fields.VQ),
									$author$project$Components$DateInput$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
									$author$project$Components$DateInput$errors(
									A2($author$project$Utils$Form$validationErrors, 1, form))
								]),
							fields.sZ))
					])),
				A2($author$project$Pages$Hinter$ClonePractice$viewUsers, practiceUsers, fields.aj9)
			]);
	});
var $author$project$Pages$Hinter$ClonePractice$view = function (model) {
	var loading = _Utils_eq(model.k9, $author$project$Api$Data$Loading);
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$autocomplete(false),
						$author$project$Ui$Form$noValidate(true),
						$author$project$Ui$Form$onSubmit($author$project$Pages$Hinter$ClonePractice$Save)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Clone Practice')
											]))
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								A2($author$project$Pages$Hinter$ClonePractice$viewForm, model.SD, model.aj9)),
								A2(
								$author$project$Ui$Panel$footer,
								_List_fromArray(
									[$author$project$Ui$Element$justifyCenter]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Patients__Top,
										_List_fromArray(
											[$author$project$Ui$Link$buttonSecondary]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cancel')
											])),
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Create practice'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$submit,
												$author$project$Ui$Button$loading(loading)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Create')
											]))
									]))
							]))
					]))
			]),
		ac9: 'Clone Practice'
	};
};
var $author$project$Pages$Hinter$ClonePractice$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Hinter$ClonePractice$init, aiq: $author$project$Pages$Hinter$ClonePractice$load, k8: $author$project$Pages$Hinter$ClonePractice$save, alO: $author$project$Pages$Hinter$ClonePractice$subscriptions, adT: $author$project$Pages$Hinter$ClonePractice$update, amo: $author$project$Pages$Hinter$ClonePractice$view});
var $author$project$Pages$Hinter$Disputes$StatusDropdownMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Hinter$Disputes$GotDisputes = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Platform$Dispute$All$Dispute = $elm$core$Basics$identity;
var $author$project$Api$Platform$Dispute$All$Record = F8(
	function (id, dueDate, amountInCents, status, reasonCode, reasonDescription, invoice, practice) {
		return {LE: amountInCents, QX: dueDate, ahP: id, Uk: invoice, ZV: practice, _8: reasonCode, _9: reasonDescription, alH: status};
	});
var $author$project$Api$Platform$Dispute$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'practice',
	$author$project$Api$Platform$Practice$Min$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'invoice',
		$author$project$Api$Common$Payable$Invoice$MinWithOwner$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'reason_description',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'reason_code',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'status',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'amount_in_cents',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'due_date',
							$author$project$Utils$Date$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Api$Platform$Dispute$All$Record)))))))));
var $author$project$Api$Platform$Dispute$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$Dispute$All$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Platform$Dispute$disputesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['disputes']),
	$author$project$Api$Data$platformPath);
var $author$project$Api$Platform$Dispute$listDefaults = {ajJ: $author$project$Api$Pagination$init, alA: $author$project$Api$Sort$init, alH: $elm$core$Maybe$Nothing};
var $author$project$Api$Platform$Dispute$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Platform$Dispute$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ),
				A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Api$Param$string('status'),
						$elm$core$List$singleton),
					options.alH))
			]));
};
var $author$project$Api$Platform$Dispute$list = F3(
	function (apiClient, query, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Platform$Dispute$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Platform$Dispute$listOptionsToParams(query),
				$author$project$Api$Data$requestTo($author$project$Api$Platform$Dispute$disputesPath)));
	});
var $author$project$Pages$Hinter$Disputes$fetchDisputes = function (model) {
	return A3(
		$author$project$Api$Platform$Dispute$list,
		model.Gv,
		function (d) {
			return _Utils_update(
				d,
				{ajJ: model.ajJ, alA: model.alA, alH: model.alH});
		},
		$author$project$Pages$Hinter$Disputes$GotDisputes);
};
var $author$project$Pages$Hinter$Disputes$init = F3(
	function (_v0, _v1, _v2) {
		var apiClient = _v1.Gv;
		var query = _v2.DE;
		var model = {
			Gv: apiClient,
			gg: $elm$core$Maybe$Nothing,
			cD: $author$project$Api$Data$Loading,
			ajJ: $author$project$Api$Pagination$init,
			alA: A3(
				$author$project$Api$Sort$withDefault,
				'due_date',
				1,
				$author$project$Api$Sort$initFromQuery(query)),
			alH: A2($elm$core$Dict$get, 'status', query),
			qn: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'disputes-status-dropdown', al6: $author$project$Pages$Hinter$Disputes$StatusDropdownMsg}))
		};
		return _Utils_Tuple2(
			model,
			$author$project$Pages$Hinter$Disputes$fetchDisputes(model));
	});
var $author$project$Pages$Hinter$Disputes$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Hinter$Disputes$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Hinter$Disputes$CloseDisputeModal = {$: 5};
var $author$project$Pages$Hinter$Disputes$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$DisputeModal$subscriptions($author$project$Pages$Hinter$Disputes$CloseDisputeModal)),
					model.gg)),
				$author$project$Ui$Dropdown$subscriptions(model.qn)
			]));
};
var $author$project$Pages$Hinter$Disputes$DisputeModalMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Platform$Dispute$All$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Pages$Hinter$Disputes$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('status'),
			model.alH)
		]);
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Hinter__Disputes)
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.ajJ),
				A2(
					$elm$core$List$append,
					$author$project$Api$Sort$toQuery(model.alA),
					A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
};
var $author$project$Pages$Hinter$Disputes$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cD: response,
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cD: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Ui$Dropdown$update, subMsg, model.qn);
				var statusDropdown = _v2.a;
				var statusDropdownCmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qn: statusDropdown}),
					statusDropdownCmd,
					_List_Nil);
			case 2:
				var selectedOption = msg.a;
				var newModel = _Utils_update(
					model,
					{
						cD: $author$project$Api$Data$Loading,
						ajJ: $author$project$Api$Pagination$reset(model.ajJ),
						alH: function () {
							if (selectedOption.$ === 1) {
								return $elm$core$Maybe$Nothing;
							} else {
								var status = selectedOption.a;
								return $elm$core$Maybe$Just(status);
							}
						}()
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Hinter$Disputes$fetchDisputes(newModel),
								$author$project$Pages$Hinter$Disputes$updateUrl(newModel)
							])),
					_List_Nil);
			case 3:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Hinter$Disputes$fetchDisputes(newModel),
								$author$project$Pages$Hinter$Disputes$updateUrl(newModel)
							])),
					_List_Nil);
			case 7:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						alA: A2($author$project$Api$Sort$update, columnId, model.alA)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Hinter$Disputes$fetchDisputes(newModel),
								$author$project$Pages$Hinter$Disputes$updateUrl(newModel)
							])),
					_List_Nil);
			case 4:
				var dispute = msg.a;
				var _v4 = A3(
					$author$project$Components$DisputeModal$init,
					$author$project$Api$Data$platformPath,
					model.Gv,
					$author$project$Api$Platform$Dispute$All$id(dispute));
				var disputeModal = _v4.a;
				var disputeModalCmd = _v4.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							gg: $elm$core$Maybe$Just(disputeModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Hinter$Disputes$DisputeModalMsg, disputeModalCmd),
					_List_Nil);
			case 5:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{gg: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v5 = model.gg;
				if (!_v5.$) {
					var disputeModal = _v5.a;
					var _v6 = A2($author$project$Components$DisputeModal$update, subMsg, disputeModal);
					var newDisputeModal = _v6.a;
					var disputeModalCmd = _v6.b;
					var disputeModalOutMsgs = _v6.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								gg: $elm$core$Maybe$Just(newDisputeModal)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Hinter$Disputes$DisputeModalMsg, disputeModalCmd),
						disputeModalOutMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Hinter$Disputes$PaginationMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Hinter$Disputes$SortTable = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Hinter$Disputes$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'practice', false, 'Practice'),
		A3($author$project$Api$Column$init, 'due_date', true, 'Due Date'),
		A3($author$project$Api$Column$init, 'invoice', false, 'Invoice'),
		A3($author$project$Api$Column$init, 'amount_in_cents', true, 'Amount'),
		A3($author$project$Api$Column$init, 'reason_code', true, 'Reason Code'),
		A3($author$project$Api$Column$init, 'status', true, 'Status')
	]);
var $author$project$Pages$Hinter$Disputes$OpenDisputeModal = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Platform$Dispute$All$amountInCents = function (_v0) {
	var record = _v0;
	return record.LE;
};
var $author$project$Api$Platform$Dispute$All$dueDate = function (_v0) {
	var record = _v0;
	return record.QX;
};
var $author$project$Api$Platform$Dispute$All$invoice = function (_v0) {
	var record = _v0;
	return record.Uk;
};
var $author$project$Api$Platform$Dispute$All$practice = function (_v0) {
	var record = _v0;
	return record.ZV;
};
var $author$project$Api$Platform$Dispute$All$reasonCode = function (_v0) {
	var record = _v0;
	return record._8;
};
var $author$project$Api$Platform$Dispute$All$reasonDescription = function (_v0) {
	var record = _v0;
	return record._9;
};
var $author$project$Api$Platform$Dispute$All$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Pages$Hinter$Disputes$viewItem = function (dispute) {
	var invoice = $author$project$Api$Platform$Dispute$All$invoice(dispute);
	return A2(
		$author$project$Ui$Table$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Platform$Practice$Min$name(
							$author$project$Api$Platform$Dispute$All$practice(dispute)))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$author$project$Formatters$Date$toString,
							$author$project$Formatters$Date$Full,
							$author$project$Api$Platform$Dispute$All$dueDate(dispute)))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						'#' + $elm$core$String$fromInt(
							$author$project$Api$Common$Payable$Invoice$MinWithOwner$invoiceNumber(invoice)))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Utils$Currency$fromInt(
							$author$project$Api$Platform$Dispute$All$amountInCents(dispute)))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						function () {
						var _v0 = $author$project$Api$Platform$Dispute$All$reasonDescription(dispute);
						if (!_v0.$) {
							var reasonDescription = _v0.a;
							return A3(
								$author$project$Ui$Tooltip$view,
								_List_fromArray(
									[
										$author$project$Ui$Tooltip$placement(0)
									]),
								reasonDescription,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Badge$fromString,
										_List_Nil,
										$author$project$Api$Platform$Dispute$All$reasonCode(dispute))
									]));
						} else {
							return A2(
								$author$project$Ui$Badge$fromString,
								_List_Nil,
								$author$project$Api$Platform$Dispute$All$reasonCode(dispute));
						}
					}()
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Badge$fromString,
						_List_Nil,
						$author$project$Api$Platform$Dispute$All$status(dispute))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_fromArray(
					[
						$author$project$Ui$Table$textRight,
						$author$project$Ui$Table$colspan(2)
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'View dispute'},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$onClick(
								$author$project$Pages$Hinter$Disputes$OpenDisputeModal(dispute))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('View Dispute')
							]))
					]))
			]));
};
var $author$project$Pages$Hinter$Disputes$viewPanelBody = function (model) {
	var _v0 = function () {
		var _v1 = model.cD;
		if (_v1.$ === 3) {
			var disputes_ = _v1.a;
			return _Utils_Tuple2(false, disputes_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var disputes = _v0.b;
	return _List_fromArray(
		[
			A4(
			$author$project$Ui$Table$view,
			_List_fromArray(
				[
					$author$project$Ui$Table$verticalCentered,
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('There are no disputes.')
						])),
					$author$project$Ui$Table$loading(loading)
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						A2(
						$elm$core$List$map,
						$author$project$Api$Column$view(
							A2($author$project$Api$Column$Sortable, model.alA, $author$project$Pages$Hinter$Disputes$SortTable)),
						$author$project$Pages$Hinter$Disputes$columns),
						_List_fromArray(
						[
							A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
						])
					])),
			A2($elm$core$List$map, $author$project$Pages$Hinter$Disputes$viewItem, disputes),
			_List_Nil)
		]);
};
var $author$project$Pages$Hinter$Disputes$None = {$: 1};
var $author$project$Pages$Hinter$Disputes$Status = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Hinter$Disputes$StatusFiltered = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Hinter$Disputes$statusDropdownOptions = function (currentStatus) {
	var statusOptions = A2(
		$elm$core$List$map,
		function (status) {
			return A2(
				$author$project$Ui$Dropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$Dropdown$onSelect(
						$author$project$Pages$Hinter$Disputes$StatusFiltered(
							$author$project$Pages$Hinter$Disputes$Status(status))),
						$author$project$Ui$Dropdown$selected(
						_Utils_eq(
							$elm$core$Maybe$Just(status),
							currentStatus))
					]),
				$elm$html$Html$text(
					$author$project$Formatters$String$humanize(status)));
		},
		_List_fromArray(
			['created', 'action_required', 'processing', 'won', 'lost']));
	return A2(
		$elm$core$List$cons,
		A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Pages$Hinter$Disputes$StatusFiltered($author$project$Pages$Hinter$Disputes$None)),
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(currentStatus, $elm$core$Maybe$Nothing))
				]),
			$elm$html$Html$text('No Filter')),
		A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, statusOptions));
};
var $author$project$Pages$Hinter$Disputes$viewStatusDropdown = function (model) {
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				A2(
					$elm$core$Maybe$withDefault,
					'All Status',
					A2($elm$core$Maybe$map, $author$project$Formatters$String$humanize, model.alH)))
			]),
		$author$project$Pages$Hinter$Disputes$statusDropdownOptions(model.alH),
		model.qn);
};
var $author$project$Pages$Hinter$Disputes$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					$author$project$Components$DisputeModal$view($author$project$Pages$Hinter$Disputes$CloseDisputeModal),
					model.gg)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Disputes')
									])),
								A2(
								$author$project$Ui$Grid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(5),
												$author$project$Ui$Grid$spanSm(3),
												$author$project$Ui$Grid$spanMd(4)
											]),
										_List_fromArray(
											[
												$author$project$Pages$Hinter$Disputes$viewStatusDropdown(model)
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						$author$project$Pages$Hinter$Disputes$viewPanelBody(model)),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Hinter$Disputes$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(
											!$author$project$Api$Data$isSuccess(model.cD))
										]),
									model.ajJ))
							]))
					]))
			]),
		ac9: 'Manage Disputes'
	};
};
var $author$project$Pages$Hinter$Disputes$page = $author$project$Spa$Page$applicationPrivate(
	{ah_: $author$project$Pages$Hinter$Disputes$init, aiq: $author$project$Pages$Hinter$Disputes$load, k8: $author$project$Pages$Hinter$Disputes$save, alO: $author$project$Pages$Hinter$Disputes$subscriptions, adT: $author$project$Pages$Hinter$Disputes$update, amo: $author$project$Pages$Hinter$Disputes$view});
var $author$project$Pages$Hinter$FeatureFlags$GotFeatureFlags = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Platform$BulkFeature$bulkFeaturesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['bulk_features']),
	$author$project$Api$Data$platformPath);
var $author$project$Api$Platform$BulkFeature$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Platform$BulkFeature$bulkFeaturesPath));
	});
var $author$project$Pages$Hinter$FeatureFlags$init = F3(
	function (_v0, _v1, _v2) {
		var apiClient = _v1.Gv;
		var model = {
			fw: $elm$core$Maybe$Nothing,
			Gv: apiClient,
			sn: $author$project$Api$Data$Loading,
			up: $author$project$Ui$SearchInput$init($elm$core$Maybe$Nothing),
			uq: ''
		};
		return _Utils_Tuple2(
			model,
			A2($author$project$Api$Platform$BulkFeature$list, apiClient, $author$project$Pages$Hinter$FeatureFlags$GotFeatureFlags));
	});
var $author$project$Pages$Hinter$FeatureFlags$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Hinter$FeatureFlags$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Hinter$FeatureFlags$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Hinter$FeatureFlags$ActionCompleted = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $author$project$Pages$Hinter$FeatureFlags$DisableAll = 2;
var $author$project$Pages$Hinter$FeatureFlags$EnableAll = 1;
var $author$project$Pages$Hinter$FeatureFlags$EnableClinical = 0;
var $author$project$Pages$Hinter$FeatureFlags$SearchInputMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Hinter$FeatureFlags$actionLabel = function (actionType) {
	switch (actionType) {
		case 0:
			return 'Enable Clinical';
		case 1:
			return 'Enable All';
		default:
			return 'Disable All';
	}
};
var $author$project$Api$Platform$BulkFeature$bulkFeaturePath = function (featureName) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[featureName]),
		$author$project$Api$Platform$BulkFeature$bulkFeaturesPath);
};
var $author$project$Api$Platform$BulkFeature$disableAll = F3(
	function (apiClient, featureName, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['disable_all']),
					$author$project$Api$Platform$BulkFeature$bulkFeaturePath(featureName))));
	});
var $author$project$Api$Platform$BulkFeature$enableAll = F3(
	function (apiClient, featureName, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['enable_all']),
					$author$project$Api$Platform$BulkFeature$bulkFeaturePath(featureName))));
	});
var $author$project$Api$Platform$BulkFeature$enableClinical = F3(
	function (apiClient, featureName, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['enable_clinical']),
					$author$project$Api$Platform$BulkFeature$bulkFeaturePath(featureName))));
	});
var $author$project$Pages$Hinter$FeatureFlags$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{sn: response}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{sn: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Ui$SearchInput$update, subMsg, model.up);
				var searchInput = _v2.a;
				var searchInputCmd = _v2.b;
				var searchInputEvent = _v2.c;
				var searchQuery = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return A2($elm$core$Maybe$withDefault, '', query);
					} else {
						return model.uq;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{up: searchInput, uq: searchQuery}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Hinter$FeatureFlags$SearchInputMsg, searchInputCmd),
					_List_Nil);
			case 2:
				var featureName = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							fw: $elm$core$Maybe$Just(
								_Utils_Tuple2(featureName, 0))
						}),
					A3(
						$author$project$Api$Platform$BulkFeature$enableClinical,
						model.Gv,
						featureName,
						A2($author$project$Pages$Hinter$FeatureFlags$ActionCompleted, featureName, 0)),
					_List_Nil);
			case 3:
				var featureName = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							fw: $elm$core$Maybe$Just(
								_Utils_Tuple2(featureName, 1))
						}),
					A3(
						$author$project$Api$Platform$BulkFeature$enableAll,
						model.Gv,
						featureName,
						A2($author$project$Pages$Hinter$FeatureFlags$ActionCompleted, featureName, 1)),
					_List_Nil);
			case 4:
				var featureName = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							fw: $elm$core$Maybe$Just(
								_Utils_Tuple2(featureName, 2))
						}),
					A3(
						$author$project$Api$Platform$BulkFeature$disableAll,
						model.Gv,
						featureName,
						A2($author$project$Pages$Hinter$FeatureFlags$ActionCompleted, featureName, 2)),
					_List_Nil);
			default:
				var featureName = msg.a;
				var actionType = msg.b;
				var response = msg.c;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{fw: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2(
								$author$project$OutMsg$ShowToast,
								3,
								$author$project$Pages$Hinter$FeatureFlags$actionLabel(actionType) + (' job enqueued for ' + featureName))
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{fw: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Hinter$FeatureFlags$ClickDisableAll = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Hinter$FeatureFlags$ClickEnableAll = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Hinter$FeatureFlags$ClickEnableClinical = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Hinter$FeatureFlags$viewFeatureFlag = F2(
	function (actionInProgress, featureName) {
		var isLoading = function (actionType) {
			if (!actionInProgress.$) {
				var _v1 = actionInProgress.a;
				var name = _v1.a;
				var at = _v1.b;
				return _Utils_eq(name, featureName) && _Utils_eq(at, actionType);
			} else {
				return false;
			}
		};
		var anyLoading = !_Utils_eq(actionInProgress, $elm$core$Maybe$Nothing);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(featureName)
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Enable ' + (featureName + ' for clinical practices')},
							_List_fromArray(
								[
									$author$project$Ui$Button$success,
									$author$project$Ui$Button$sm,
									$author$project$Ui$Button$onClick(
									$author$project$Pages$Hinter$FeatureFlags$ClickEnableClinical(featureName)),
									$author$project$Ui$Button$loading(
									isLoading(0)),
									$author$project$Ui$Button$disabled(anyLoading)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Clinical')
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Enable ' + (featureName + ' for all practices')},
							_List_fromArray(
								[
									$author$project$Ui$Button$default,
									$author$project$Ui$Button$sm,
									$author$project$Ui$Button$onClick(
									$author$project$Pages$Hinter$FeatureFlags$ClickEnableAll(featureName)),
									$author$project$Ui$Button$loading(
									isLoading(1)),
									$author$project$Ui$Button$disabled(anyLoading)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('All')
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Disable ' + (featureName + ' for all practices')},
							_List_fromArray(
								[
									$author$project$Ui$Button$danger,
									$author$project$Ui$Button$sm,
									$author$project$Ui$Button$onClick(
									$author$project$Pages$Hinter$FeatureFlags$ClickDisableAll(featureName)),
									$author$project$Ui$Button$loading(
									isLoading(2)),
									$author$project$Ui$Button$disabled(anyLoading)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Disable')
								]))
						]))
				]));
	});
var $author$project$Pages$Hinter$FeatureFlags$viewPanelBody = function (model) {
	var _v0 = function () {
		var _v1 = model.sn;
		if (_v1.$ === 3) {
			var flags_ = _v1.a;
			return _Utils_Tuple2(false, flags_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var flags = _v0.b;
	var filteredFlags = $elm$core$String$isEmpty(model.uq) ? flags : A2(
		$elm$core$List$filter,
		A2(
			$elm$core$Basics$composeL,
			$elm$core$String$contains(
				$elm$core$String$toLower(model.uq)),
			$elm$core$String$toLower),
		flags);
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$verticalCentered,
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('No feature flags found.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Flag Name')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Enable Clinical')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Enable All')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Disable All')
					]))
			]),
		A2(
			$elm$core$List$map,
			$author$project$Pages$Hinter$FeatureFlags$viewFeatureFlag(model.fw),
			filteredFlags),
		_List_Nil);
};
var $author$project$Pages$Hinter$FeatureFlags$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Feature Flags')
											])),
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$User__Organizations__Top,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Ui$Icon$cross(_List_Nil)
											]))
									])),
								A2(
								$author$project$Ui$Grid$row,
								_List_fromArray(
									[$author$project$Ui$Grid$mt2]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(12)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Group$view,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$map,
														$author$project$Pages$Hinter$FeatureFlags$SearchInputMsg,
														A2(
															$author$project$Ui$SearchInput$view,
															_List_fromArray(
																[
																	$author$project$Ui$SearchInput$placeholder('Search feature flags...'),
																	$author$project$Ui$SearchInput$immediate
																]),
															model.up))
													]))
											]))
									]))
							])),
						$author$project$Pages$Hinter$FeatureFlags$viewPanelBody(model)
					]))
			]),
		ac9: 'Admin | Feature Flags'
	};
};
var $author$project$Pages$Hinter$FeatureFlags$page = $author$project$Spa$Page$applicationPrivate(
	{ah_: $author$project$Pages$Hinter$FeatureFlags$init, aiq: $author$project$Pages$Hinter$FeatureFlags$load, k8: $author$project$Pages$Hinter$FeatureFlags$save, alO: $author$project$Pages$Hinter$FeatureFlags$subscriptions, adT: $author$project$Pages$Hinter$FeatureFlags$update, amo: $author$project$Pages$Hinter$FeatureFlags$view});
var $author$project$Pages$Hinter$NewGroup$init = F3(
	function (_v0, shared, _v1) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, Bq: '', oI: $elm$core$Maybe$Nothing, k9: $author$project$Api$Data$NotAsked},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Hinter$NewGroup$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Hinter$NewGroup$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Hinter$NewGroup$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Hinter$NewGroup$Created = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$ManagementGroup$create = F3(
	function (apiClient, name_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'management_group',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(name_))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$ManagementGroup$Shared$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$ManagementGroup$resourcePath)));
	});
var $author$project$Pages$Hinter$NewGroup$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var name = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Bq: name, oI: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var trimmedName = $elm$core$String$trim(model.Bq);
				return $elm$core$String$isEmpty(trimmedName) ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							oI: $elm$core$Maybe$Just('Name is required')
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{k9: $author$project$Api$Data$Loading}),
					A3($author$project$Api$Provider$ManagementGroup$create, model.Gv, trimmedName, $author$project$Pages$Hinter$NewGroup$Created),
					_List_Nil);
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var group = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: response}),
						A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$User__Organizations__Top),
						_List_fromArray(
							[
								A2(
								$author$project$OutMsg$ShowToast,
								3,
								'Group \"' + ($author$project$Api$Provider$ManagementGroup$Shared$name(group) + '\" created'))
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Hinter$NewGroup$Save = {$: 1};
var $author$project$Pages$Hinter$NewGroup$UpdateName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Hinter$NewGroup$view = function (model) {
	var loading = _Utils_eq(model.k9, $author$project$Api$Data$Loading);
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$autocomplete(false),
						$author$project$Ui$Form$noValidate(true),
						$author$project$Ui$Form$onSubmit($author$project$Pages$Hinter$NewGroup$Save)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Create New Group')
											]))
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$label('Name'),
												$author$project$Ui$Form$Group$required(true)
											]),
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$view(
												_List_fromArray(
													[
														$author$project$Ui$Form$Input$value(model.Bq),
														$author$project$Ui$Form$Input$onInput($author$project$Pages$Hinter$NewGroup$UpdateName),
														$author$project$Ui$Form$Input$placeholder('Enter group name'),
														$author$project$Ui$Form$Input$disabled(loading),
														$author$project$Ui$Form$Input$invalid(
														!_Utils_eq(model.oI, $elm$core$Maybe$Nothing)),
														$author$project$Ui$Form$Input$errors(
														A2(
															$elm$core$Maybe$withDefault,
															_List_Nil,
															A2($elm$core$Maybe$map, $elm$core$List$singleton, model.oI)))
													]))
											]))
									])),
								A2(
								$author$project$Ui$Panel$footer,
								_List_fromArray(
									[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$gap2]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$User__Organizations__Top,
										_List_fromArray(
											[$author$project$Ui$Link$buttonSecondary]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cancel')
											])),
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Create new group'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$submit,
												$author$project$Ui$Button$loading(loading)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Create')
											]))
									]))
							]))
					]))
			]),
		ac9: 'Group Setup'
	};
};
var $author$project$Pages$Hinter$NewGroup$page = $author$project$Spa$Page$applicationPrivate(
	{ah_: $author$project$Pages$Hinter$NewGroup$init, aiq: $author$project$Pages$Hinter$NewGroup$load, k8: $author$project$Pages$Hinter$NewGroup$save, alO: $author$project$Pages$Hinter$NewGroup$subscriptions, adT: $author$project$Pages$Hinter$NewGroup$update, amo: $author$project$Pages$Hinter$NewGroup$view});
var $author$project$Pages$Hinter$NewPartner$FormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Hinter$NewPartnerForm$Model = $elm$core$Basics$identity;
var $author$project$Components$Hinter$NewPartnerForm$FormUpdated = $elm$core$Basics$identity;
var $author$project$Components$Hinter$NewPartnerForm$ManagedBy = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$AdminSettings$ManagedByInput$ManagedByTypeManagementGroup = 2;
var $author$project$Components$Partner$AdminSettings$ManagedByInput$ManagedByTypeNone = 0;
var $author$project$Components$Partner$AdminSettings$ManagedByInput$ManagedByTypePractice = 1;
var $author$project$Components$Partner$AdminSettings$ManagedByInput$Model = $elm$core$Basics$identity;
var $author$project$Components$Partner$AdminSettings$ManagedByInput$PracticeResourceFilterMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$ResourceFilter$User$Practice$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Components$ResourceFilter$User$Practice$list = $author$project$Api$Platform$User$Practice$list;
var $author$project$Components$ResourceFilter$User$Practice$fetchResources = F4(
	function (toMsg, apiClient, pagination, query) {
		return A4(
			$author$project$Components$ResourceFilter$User$Practice$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{ajJ: pagination, akl: query});
			},
			$elm$core$Maybe$Nothing,
			toMsg);
	});
var $author$project$Components$ResourceFilter$User$Practice$retrieveResource = F3(
	function (toMsg, apiClient, id) {
		return A4(
			$author$project$Components$ResourceFilter$User$Practice$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						akl: $elm$core$Maybe$Just(id)
					});
			},
			$elm$core$Maybe$Nothing,
			toMsg);
	});
var $author$project$Components$ResourceFilter$User$Practice$selectId = 'practices';
var $author$project$Components$ResourceFilter$User$Practice$toTitle = $author$project$Api$Platform$Practice$All$name;
var $author$project$Components$ResourceFilter$User$Practice$toLabel = function (resource) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Components$ResourceFilter$User$Practice$toTitle(resource))
		]);
};
var $author$project$Components$ResourceFilter$User$Practice$toValue = $author$project$Api$Platform$Practice$All$id;
var $author$project$Components$ResourceFilter$User$Practice$init = F2(
	function (apiClient, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{Sk: $author$project$Components$ResourceFilter$User$Practice$fetchResources, ahP: $author$project$Components$ResourceFilter$User$Practice$selectId, k$: 'Practices', uk: $author$project$Components$ResourceFilter$User$Practice$retrieveResource, u9: $author$project$Components$ResourceFilter$User$Practice$toLabel, lN: $author$project$Components$ResourceFilter$User$Practice$toTitle, hX: $author$project$Components$ResourceFilter$User$Practice$toValue},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{Jy: $author$project$Components$ResourceFilter$All, b8: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$Partner$AdminSettings$ManagedByInput$init = F2(
	function (apiClient, maybeInitialValue) {
		var managedByType = function () {
			if (maybeInitialValue.$ === 1) {
				return 0;
			} else {
				if (!maybeInitialValue.a.$) {
					return 1;
				} else {
					return 2;
				}
			}
		}();
		var _v0 = A2(
			$author$project$Components$ResourceFilter$User$Practice$init,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Select a Practice'});
			});
		var practiceResourceFilter = _v0.a;
		var practiceResourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{gT: managedByType, kL: practiceResourceFilter},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$Partner$AdminSettings$ManagedByInput$PracticeResourceFilterMsg, practiceResourceFilterCmd));
	});
var $author$project$Components$Hinter$NewPartnerForm$initFormFields = function (apiClient) {
	var _v0 = A2($author$project$Components$Partner$AdminSettings$ManagedByInput$init, apiClient, $elm$core$Maybe$Nothing);
	var managedByInput = _v0.a;
	var managedByInputCmd = _v0.b;
	return _Utils_Tuple2(
		{KN: false, Ma: 'manual', Pg: $elm$core$Maybe$Nothing, Rj: $elm$core$Maybe$Nothing, V6: _List_Nil, Iu: 0, Wk: $elm$core$Maybe$Nothing, ki: managedByInput, WD: $elm$core$Maybe$Nothing, Bq: '', Z1: false, aao: false, abG: $elm$core$Maybe$Nothing, alH: 'beta', ac$: $elm$core$Maybe$Nothing, ad7: true, h8: false, aes: false, aet: false},
		A2(
			$elm$core$Platform$Cmd$map,
			A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$Hinter$NewPartnerForm$ManagedBy),
			managedByInputCmd));
};
var $author$project$Components$Hinter$NewPartnerForm$init = function (apiClient) {
	var _v0 = $author$project$Components$Hinter$NewPartnerForm$initFormFields(apiClient);
	var formFields = _v0.a;
	var formFieldsCmd = _v0.b;
	return _Utils_Tuple2(
		{
			SD: $author$project$Utils$Form$init(formFields)
		},
		formFieldsCmd);
};
var $author$project$Pages$Hinter$NewPartner$init = F3(
	function (_v0, shared, _v1) {
		var _v2 = $author$project$Components$Hinter$NewPartnerForm$init(shared.Gv);
		var form = _v2.a;
		var formCmd = _v2.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, SD: form, k9: $author$project$Api$Data$NotAsked},
			A2($elm$core$Platform$Cmd$map, $author$project$Pages$Hinter$NewPartner$FormMsg, formCmd));
	});
var $author$project$Pages$Hinter$NewPartner$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Hinter$NewPartner$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$ResourceFilter$User$Practice$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.b8));
};
var $author$project$Components$Partner$AdminSettings$ManagedByInput$subscriptions = function (_v0) {
	var model = _v0;
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Components$Partner$AdminSettings$ManagedByInput$PracticeResourceFilterMsg,
		$author$project$Components$ResourceFilter$User$Practice$subscriptions(model.kL));
};
var $author$project$Components$Hinter$NewPartnerForm$subscriptions = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.SD);
	return A2(
		$elm$core$Platform$Sub$map,
		A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$Hinter$NewPartnerForm$ManagedBy),
		$author$project$Components$Partner$AdminSettings$ManagedByInput$subscriptions(fields.ki));
};
var $author$project$Pages$Hinter$NewPartner$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$Hinter$NewPartner$FormMsg,
		$author$project$Components$Hinter$NewPartnerForm$subscriptions(model.SD));
};
var $author$project$Pages$Hinter$NewPartner$Created = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Partner$BaaType$toString = function (baaType) {
	if (!baaType) {
		return 'contractor';
	} else {
		return 'independent';
	}
};
var $author$project$Api$Partner$BaaType$encode = A2($elm$core$Basics$composeR, $author$project$Api$Partner$BaaType$toString, $elm$json$Json$Encode$string);
var $author$project$Api$Partner$Partner$encodeProductOverviewField = function (field) {
	return _Utils_Tuple2(
		'product_overview',
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[field])));
};
var $author$project$Api$Partner$Partner$encodePermittedFields = function (permittedFields) {
	var encodedFields = A3(
		$elm$core$List$foldl,
		F2(
			function (field, acc) {
				switch (field.$) {
					case 0:
						var name = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(name)),
							acc);
					case 1:
						var slug = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'slug',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, slug)),
							acc);
					case 2:
						var maybeUrl = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'website_url',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, maybeUrl)),
							acc);
					case 3:
						var maybeUrl = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'redirect_url',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, maybeUrl)),
							acc);
					case 5:
						var addressParts = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'address',
								$elm$json$Json$Encode$object(addressParts)),
							acc);
					case 6:
						var authType = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'auth_type',
								$elm$json$Json$Encode$string(authType)),
							acc);
					case 7:
						var maybeEmail = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'email',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, maybeEmail)),
							acc);
					case 8:
						var email = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'technical_email',
								$elm$json$Json$Encode$string(email)),
							acc);
					case 9:
						var uses = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'uses_integration_records',
								$elm$json$Json$Encode$bool(uses)),
							acc);
					case 10:
						var active = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'active',
								$elm$json$Json$Encode$bool(active)),
							acc);
					case 11:
						var disabled = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'webhooks_disabled',
								$elm$json$Json$Encode$bool(disabled)),
							acc);
					case 12:
						var paused = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'webhooks_paused',
								$elm$json$Json$Encode$bool(paused)),
							acc);
					case 13:
						var unmute = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'unmute_self_webhooks',
								$elm$json$Json$Encode$bool(unmute)),
							acc);
					case 14:
						var maybeMax = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'max_requests_per_minute',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, maybeMax)),
							acc);
					case 15:
						var readOnly = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'practices_read_only',
								$elm$json$Json$Encode$bool(readOnly)),
							acc);
					case 16:
						var logo = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'logo',
								$elm$json$Json$Encode$string(logo)),
							acc);
					case 17:
						var events = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'listened_events',
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, events)),
							acc);
					case 18:
						var status = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'status',
								$elm$json$Json$Encode$string(status)),
							acc);
					case 19:
						var sandboxEnabled = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'sandbox_enabled',
								$elm$json$Json$Encode$bool(sandboxEnabled)),
							acc);
					case 4:
						var maybeUrl = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'post_activation_redirect_url',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, maybeUrl)),
							acc);
					case 20:
						var maybeDesc = field.a;
						return A2(
							$elm$core$List$cons,
							$author$project$Api$Partner$Partner$encodeProductOverviewField(
								_Utils_Tuple2(
									'description',
									A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, maybeDesc))),
							acc);
					case 21:
						var images = field.a;
						return A2(
							$elm$core$List$cons,
							$author$project$Api$Partner$Partner$encodeProductOverviewField(
								_Utils_Tuple2(
									'images',
									A2(
										$elm$json$Json$Encode$list,
										function (image) {
											if (!image.$) {
												var url = image.a;
												return $elm$json$Json$Encode$object(
													_List_fromArray(
														[
															_Utils_Tuple2(
															'url',
															$elm$json$Json$Encode$string(url))
														]));
											} else {
												var id = image.a.ahP;
												var alt = image.a.LD;
												return $elm$json$Json$Encode$object(
													_List_fromArray(
														[
															_Utils_Tuple2(
															'id',
															$elm$json$Json$Encode$string(id)),
															_Utils_Tuple2(
															'alt',
															$elm$json$Json$Encode$string(alt))
														]));
											}
										},
										images))),
							acc);
					case 22:
						var maybeManagedBy = field.a;
						var managedBy = A2(
							$elm$core$Maybe$map,
							function (managedBy_) {
								if (!managedBy_.$) {
									var id = managedBy_.a;
									return {
										ahP: $elm$core$Maybe$Just(id),
										amg: $elm$core$Maybe$Just('Practice')
									};
								} else {
									var id = managedBy_.a;
									return {
										ahP: $elm$core$Maybe$Just(id),
										amg: $elm$core$Maybe$Just('ManagementGroup')
									};
								}
							},
							maybeManagedBy);
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'managed_by',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$typedAssociation, managedBy)),
							acc);
					case 23:
						var partnerAgreementAccepted = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'partner_agreement_accepted',
								$elm$json$Json$Encode$bool(partnerAgreementAccepted)),
							acc);
					case 24:
						var addendumAgreementAccepted = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'addendum_agreement_accepted',
								$elm$json$Json$Encode$bool(addendumAgreementAccepted)),
							acc);
					case 25:
						var file = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'custom_partner_agreement',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, file)),
							acc);
					case 26:
						var file = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'addendum_agreement',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, file)),
							acc);
					case 27:
						var file = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'custom_api_access_agreement',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, file)),
							acc);
					case 28:
						var file = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'custom_baa_agreement',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, file)),
							acc);
					case 29:
						var baaType = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'baa_type',
								A2($author$project$Utils$Encode$nullable, $author$project$Api$Partner$BaaType$encode, baaType)),
							acc);
					case 30:
						var baaAgreementAccepted = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'baa_agreement_accepted',
								$elm$json$Json$Encode$bool(baaAgreementAccepted)),
							acc);
					case 31:
						var apiAccessAgreementAccepted = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'api_access_agreement_accepted',
								$elm$json$Json$Encode$bool(apiAccessAgreementAccepted)),
							acc);
					default:
						var accepted = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'service_fee_agreement_accepted',
								$elm$json$Json$Encode$bool(accepted)),
							acc);
				}
			}),
		_List_Nil,
		permittedFields);
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'partner',
				$elm$json$Json$Encode$object(encodedFields))
			]));
};
var $author$project$Api$Partner$Partner$create = F3(
	function (apiClient, permittedFields, toMsg) {
		var body = $author$project$Api$Partner$Partner$encodePermittedFields(permittedFields);
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$Partner$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Partner$Partner$partnerPath)));
	});
var $author$project$Pages$Hinter$NewPartner$createPartner = F2(
	function (apiClient, permittedFields) {
		return A3($author$project$Api$Partner$Partner$create, apiClient, permittedFields, $author$project$Pages$Hinter$NewPartner$Created);
	});
var $author$project$Api$Partner$Partner$Shared$organizationId = function (_v0) {
	var record = _v0;
	return record.ajD;
};
var $author$project$Api$Partner$Partner$One$organizationId = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$organizationId(shared);
};
var $author$project$Components$ResourceFilter$User$Practice$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.b8);
		var modelAfterEvent = function () {
			var _v1 = result.agZ;
			if (!_v1.$) {
				var selected = _v1.a;
				return _Utils_update(
					model,
					{Jy: selected});
			} else {
				return model;
			}
		}();
		return {
			GZ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.GZ),
			agZ: result.agZ,
			aiO: _Utils_update(
				modelAfterEvent,
				{b8: result.aiO}),
			aR: result.aR
		};
	});
var $author$project$Components$Partner$AdminSettings$ManagedByInput$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		if (!msg.$) {
			var subMsg = msg.a;
			var practiceResourceResult = A3($author$project$Components$ResourceFilter$User$Practice$update, apiClient, subMsg, model.kL);
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{kL: practiceResourceResult.aiO}),
				A2($elm$core$Platform$Cmd$map, $author$project$Components$Partner$AdminSettings$ManagedByInput$PracticeResourceFilterMsg, practiceResourceResult.GZ),
				practiceResourceResult.aR);
		} else {
			var managedByType = msg.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{gT: managedByType}),
				$elm$core$Platform$Cmd$none,
				_List_Nil);
		}
	});
var $author$project$Components$Hinter$NewPartnerForm$formFieldsUpdate = F3(
	function (apiClient, field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{Bq: string}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var string = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{
							abG: $author$project$Utils$String$toMaybe(string)
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var bool = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{aao: bool}),
					$elm$core$Platform$Cmd$none);
			default:
				var subMsg = field.a;
				var _v1 = A3($author$project$Components$Partner$AdminSettings$ManagedByInput$update, apiClient, subMsg, fields.ki);
				var managedByInput = _v1.a;
				var managedByInputCmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{ki: managedByInput}),
					A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$Hinter$NewPartnerForm$ManagedBy),
						managedByInputCmd));
		}
	});
var $author$project$Components$Hinter$NewPartnerForm$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		var field = msg;
		var _v2 = A3(
			$author$project$Utils$Form$updateWithCmd,
			$author$project$Components$Hinter$NewPartnerForm$formFieldsUpdate(apiClient),
			field,
			model.SD);
		var newForm = _v2.a;
		var cmd = _v2.b;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{SD: newForm}),
			cmd,
			_List_Nil);
	});
var $author$project$Components$Hinter$NewPartnerForm$EmailValidation = 2;
var $author$project$Components$Hinter$NewPartnerForm$LogoValidation = 1;
var $author$project$Components$Hinter$NewPartnerForm$NameValidation = 0;
var $author$project$Components$Hinter$NewPartnerForm$maxLogoBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
var $author$project$Components$Hinter$NewPartnerForm$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.Bq;
			},
			_Utils_Tuple2(0, 'Please enter a name.')),
			A3(
			$author$project$Utils$Validate$ifIntGreaterThan,
			function ($) {
				return $.Iu;
			},
			$author$project$Components$Hinter$NewPartnerForm$maxLogoBytesSize,
			_Utils_Tuple2(1, 'That image is too large! Our maximum image size is 5 mb, please choose a smaller image.')),
			A3(
			$author$project$Utils$Validate$ifInvalidEmail,
			{aeT: true},
			function ($) {
				return $.Rj;
			},
			_Utils_Tuple2(2, 'Please enter a valid email'))
		]));
var $author$project$Api$Partner$Partner$Active = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Partner$Partner$AuthType = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Partner$Partner$Email = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Partner$Partner$ListenedEvents = function (a) {
	return {$: 17, a: a};
};
var $author$project$Api$Partner$Partner$Logo = function (a) {
	return {$: 16, a: a};
};
var $author$project$Api$Partner$Partner$ManagedBy = function (a) {
	return {$: 22, a: a};
};
var $author$project$Api$Partner$Partner$ManagedByManagementGroup = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Partner$Partner$ManagedByPractice = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Partner$Partner$MaxRequestPerMinute = function (a) {
	return {$: 14, a: a};
};
var $author$project$Api$Partner$Partner$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Partner$Partner$PracticesReadOnly = function (a) {
	return {$: 15, a: a};
};
var $author$project$Api$Partner$Partner$SandboxEnabled = function (a) {
	return {$: 19, a: a};
};
var $author$project$Api$Partner$Partner$Slug = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Partner$Partner$Status = function (a) {
	return {$: 18, a: a};
};
var $author$project$Api$Partner$Partner$TechnicalEmail = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Partner$Partner$UsesIntegrationRecords = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Partner$Partner$WebhooksDisabled = function (a) {
	return {$: 11, a: a};
};
var $author$project$Api$Partner$Partner$WebhooksPaused = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Partner$AdminSettings$ManagedByInput$ManagedByPractice = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$ResourceFilter$User$Practice$value = function (model) {
	return A2($author$project$Components$ResourceFilter$choiceToValue, model.b8, model.Jy);
};
var $author$project$Components$Partner$AdminSettings$ManagedByInput$value = function (_v0) {
	var model = _v0;
	var _v1 = model.gT;
	switch (_v1) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return A2(
				$elm$core$Maybe$map,
				$author$project$Components$Partner$AdminSettings$ManagedByInput$ManagedByPractice,
				$author$project$Components$ResourceFilter$User$Practice$value(model.kL));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Hinter$NewPartnerForm$toPermittedFields = function (fields) {
	var managedByField = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$Just,
				A2($elm$core$Basics$composeR, $author$project$Api$Partner$Partner$ManagedBy, $elm$core$List$singleton)),
			A2(
				$elm$core$Maybe$map,
				function (v) {
					if (!v.$) {
						var practiceId = v.a;
						return $author$project$Api$Partner$Partner$ManagedByPractice(practiceId);
					} else {
						var managementGroupId = v.a;
						return $author$project$Api$Partner$Partner$ManagedByManagementGroup(managementGroupId);
					}
				},
				$author$project$Components$Partner$AdminSettings$ManagedByInput$value(fields.ki))));
	return A2(
		$elm$core$List$cons,
		$author$project$Api$Partner$Partner$Name(fields.Bq),
		_Utils_ap(
			function () {
				var _v0 = fields.abG;
				if (!_v0.$) {
					var slug = _v0.a;
					return _List_fromArray(
						[
							$author$project$Api$Partner$Partner$Slug(
							$elm$core$Maybe$Just(slug))
						]);
				} else {
					return _List_Nil;
				}
			}(),
			_Utils_ap(
				function () {
					var _v1 = fields.Wk;
					if (!_v1.$) {
						var logoUrl = _v1.a;
						return _List_fromArray(
							[
								$author$project$Api$Partner$Partner$Logo(logoUrl)
							]);
					} else {
						return _List_Nil;
					}
				}(),
				_Utils_ap(
					managedByField,
					_List_fromArray(
						[
							$author$project$Api$Partner$Partner$Status(fields.alH),
							$author$project$Api$Partner$Partner$AuthType(fields.Ma),
							$author$project$Api$Partner$Partner$Email(fields.Rj),
							$author$project$Api$Partner$Partner$TechnicalEmail(
							A2($elm$core$Maybe$withDefault, '', fields.ac$)),
							$author$project$Api$Partner$Partner$UsesIntegrationRecords(fields.ad7),
							$author$project$Api$Partner$Partner$Active(fields.KN),
							$author$project$Api$Partner$Partner$WebhooksDisabled(fields.aes),
							$author$project$Api$Partner$Partner$WebhooksPaused(fields.aet),
							$author$project$Api$Partner$Partner$ListenedEvents(fields.V6),
							$author$project$Api$Partner$Partner$PracticesReadOnly(fields.Z1),
							$author$project$Api$Partner$Partner$MaxRequestPerMinute(fields.WD),
							$author$project$Api$Partner$Partner$SandboxEnabled(fields.aao)
						])))));
};
var $author$project$Components$Hinter$NewPartnerForm$validate = function (_v0) {
	var model = _v0;
	var _v1 = A2($author$project$Utils$Form$validate, $author$project$Components$Hinter$NewPartnerForm$formFieldsValidator, model.SD);
	if (!_v1.$) {
		var _v2 = _v1.a;
		var validFormFields = _v2.b;
		var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
		return $elm$core$Result$Ok(
			$author$project$Components$Hinter$NewPartnerForm$toPermittedFields(fields));
	} else {
		var validatedForm = _v1.a;
		return $elm$core$Result$Err(
			_Utils_update(
				model,
				{SD: validatedForm}));
	}
};
var $author$project$Pages$Hinter$NewPartner$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A3($author$project$Components$Hinter$NewPartnerForm$update, model.Gv, subMsg, model.SD);
				var form = _v1.a;
				var cmd = _v1.b;
				var outMsgs = _v1.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: form}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Hinter$NewPartner$FormMsg, cmd),
					outMsgs);
			case 1:
				var _v2 = $author$project$Components$Hinter$NewPartnerForm$validate(model.SD);
				if (!_v2.$) {
					var permittedFields = _v2.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: $author$project$Api$Data$Loading}),
						A2($author$project$Pages$Hinter$NewPartner$createPartner, model.Gv, permittedFields),
						_List_Nil);
				} else {
					var updatedForm = _v2.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{SD: updatedForm, k9: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var partner = response.a;
					var _v4 = _Utils_Tuple2(
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A3(
								$author$project$OutMsg$SwitchToOrganization,
								$author$project$Api$Partner$Partner$One$organizationId(partner),
								$elm$core$Maybe$Nothing,
								$author$project$OutMsg$GoToRouteAction($author$project$Spa$Generated$Route$Partner__Dashboard__Top))
							]));
					var cmd = _v4.a;
					var outMsgs = _v4.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: response}),
						cmd,
						A2(
							$elm$core$List$cons,
							A2($author$project$OutMsg$ShowToast, 3, 'Partner created'),
							outMsgs));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Hinter$NewPartner$Save = {$: 1};
var $author$project$Components$Hinter$NewPartnerForm$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Hinter$NewPartnerForm$SandboxEnabled = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Hinter$NewPartnerForm$Slug = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$ResourceFilter$User$Practice$view = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$view,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.Jy),
					options),
				model.b8));
	});
var $author$project$Components$Partner$AdminSettings$ManagedByInput$ManagedByTypeSelected = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$AdminSettings$ManagedByInput$viewManagedByTypeButton = F3(
	function (currentManagedByType, managedByType, label) {
		return A3(
			$author$project$Ui$Button$view,
			{mm: label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(currentManagedByType, managedByType)),
					$author$project$Ui$Button$onClick(
					$author$project$Components$Partner$AdminSettings$ManagedByInput$ManagedByTypeSelected(managedByType))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Components$Partner$AdminSettings$ManagedByInput$view = function (_v0) {
	var model = _v0;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpan(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Managed By Type')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Button$group(
						_List_fromArray(
							[
								A3($author$project$Components$Partner$AdminSettings$ManagedByInput$viewManagedByTypeButton, model.gT, 0, 'None'),
								A3($author$project$Components$Partner$AdminSettings$ManagedByInput$viewManagedByTypeButton, model.gT, 1, 'Practice'),
								A3($author$project$Components$Partner$AdminSettings$ManagedByInput$viewManagedByTypeButton, model.gT, 2, 'Management Group')
							]))
					])),
				function () {
				var _v1 = model.gT;
				switch (_v1) {
					case 0:
						return $author$project$Utils$Html$empty;
					case 1:
						return A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$labelSpan(4),
									$author$project$Ui$Form$Group$inputSpan(8),
									$author$project$Ui$Form$Group$required(true),
									$author$project$Ui$Form$Group$label('Practice')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Components$Partner$AdminSettings$ManagedByInput$PracticeResourceFilterMsg,
									A2($author$project$Components$ResourceFilter$User$Practice$view, _List_Nil, model.kL))
								]));
					default:
						return A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$labelSpan(4),
									$author$project$Ui$Form$Group$inputSpan(8),
									$author$project$Ui$Form$Group$required(true),
									$author$project$Ui$Form$Group$label('Management Group')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Not implemented')
										]))
								]));
				}
			}()
			]));
};
var $author$project$Components$Hinter$NewPartnerForm$view = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.SD);
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mb4]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8),
								$author$project$Ui$Form$Group$label('Name'),
								$author$project$Ui$Form$Group$required(true)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$value(fields.Bq),
										$author$project$Ui$Form$Input$onInput(
										A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$Hinter$NewPartnerForm$Name)),
										$author$project$Ui$Form$Input$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 0, model.SD)),
										$author$project$Ui$Form$Input$errors(
										A2($author$project$Utils$Form$validationErrors, 0, model.SD))
									]))
							])),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8),
								$author$project$Ui$Form$Group$label('Slug')
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$value(
										A2($elm$core$Maybe$withDefault, '', fields.abG)),
										$author$project$Ui$Form$Input$onInput(
										A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$Hinter$NewPartnerForm$Slug))
									]))
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mt4, $author$project$Ui$Element$mb4]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$Hinter$NewPartnerForm$ManagedBy),
								$author$project$Components$Partner$AdminSettings$ManagedByInput$view(fields.ki))
							])),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8),
								$author$project$Ui$Form$Group$label('Sandbox Enabled')
							]),
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$view(
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$on(fields.aao),
										$author$project$Ui$ToggleSwitch$onChange(
										A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$Hinter$NewPartnerForm$SandboxEnabled))
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Hinter$NewPartner$view = function (model) {
	var loading = _Utils_eq(model.k9, $author$project$Api$Data$Loading);
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$autocomplete(false),
						$author$project$Ui$Form$noValidate(true),
						$author$project$Ui$Form$onSubmit($author$project$Pages$Hinter$NewPartner$Save)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Create New Partner')
											]))
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Pages$Hinter$NewPartner$FormMsg,
										$author$project$Components$Hinter$NewPartnerForm$view(model.SD))
									])),
								A2(
								$author$project$Ui$Panel$footer,
								_List_fromArray(
									[$author$project$Ui$Element$justifyCenter]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Patients__Top,
										_List_fromArray(
											[$author$project$Ui$Link$buttonSecondary]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cancel')
											])),
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Create new partner'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$submit,
												$author$project$Ui$Button$loading(loading)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Create')
											]))
									]))
							]))
					]))
			]),
		ac9: 'Partner Setup'
	};
};
var $author$project$Pages$Hinter$NewPartner$page = $author$project$Spa$Page$applicationPrivate(
	{ah_: $author$project$Pages$Hinter$NewPartner$init, aiq: $author$project$Pages$Hinter$NewPartner$load, k8: $author$project$Pages$Hinter$NewPartner$save, alO: $author$project$Pages$Hinter$NewPartner$subscriptions, adT: $author$project$Pages$Hinter$NewPartner$update, amo: $author$project$Pages$Hinter$NewPartner$view});
var $author$project$Pages$Hinter$NewPractice$AddressInputMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Hinter$NewPractice$LaunchDateDateInputMsg = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Pages$Hinter$NewPractice$initPhoneInput = A3(
	$author$project$Components$PhoneInput$init,
	'new-practice-phone-input',
	_List_Nil,
	function (d) {
		return _Utils_update(
			d,
			{Gh: true, aeW: false, agl: $author$project$Api$Common$Phone$Shared$Office, AU: 1, akR: false});
	});
var $author$project$Pages$Hinter$NewPractice$initFormFields = F2(
	function (origin, defaultHubspotDeal) {
		var _v0 = $author$project$Components$DateInput$init;
		var launchDateDateInput = _v0.a;
		var launchDateDateInputCmd = _v0.b;
		var _v1 = $author$project$Components$AddressInput$init('new-practice');
		var addressInput = _v1.a;
		var addressInputCmd = _v1.b;
		return _Utils_Tuple2(
			{
				KJ: 0,
				K2: A2(
					$author$project$Components$AddressInput$withHiddenCountry,
					true,
					A2($author$project$Components$AddressInput$withRequired, true, addressInput)),
				Mz: origin + '/join/',
				Pg: $elm$core$Maybe$Nothing,
				Q9: $elm$core$Maybe$Nothing,
				Rj: $elm$core$Maybe$Nothing,
				agY: $elm$core$Maybe$Nothing,
				ahI: $elm$core$Maybe$Just('rainforest'),
				TD: defaultHubspotDeal,
				ah6: $elm$core$Maybe$Nothing,
				VQ: $elm$core$Maybe$Nothing,
				sZ: launchDateDateInput,
				Iu: 0,
				Wk: $elm$core$Maybe$Nothing,
				Bq: '',
				Zd: $elm$core$Maybe$Just('rainforest'),
				Zw: $author$project$Pages$Hinter$NewPractice$initPhoneInput,
				aki: true,
				$L: false,
				Jw: false,
				ak8: $elm$core$Maybe$Nothing,
				ali: $elm$core$Maybe$Nothing,
				all: true,
				alM: $elm$core$Maybe$Nothing,
				adY: $elm$core$Maybe$Nothing
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Pages$Hinter$NewPractice$LaunchDateDateInputMsg(launchDateDateInput),
						launchDateDateInputCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Hinter$NewPractice$AddressInputMsg, addressInputCmd)
					])));
	});
var $author$project$Pages$Hinter$NewPractice$init = F3(
	function (_v0, shared, _v1) {
		var _v2 = A2($author$project$Pages$Hinter$NewPractice$initFormFields, shared.ahq.ajG, shared.ahq.agi);
		var formFields = _v2.a;
		var formFieldsCmd = _v2.b;
		return _Utils_Tuple2(
			{
				Gv: shared.Gv,
				dd: shared.dd,
				SD: $author$project$Utils$Form$init(formFields),
				k9: $author$project$Api$Data$NotAsked
			},
			formFieldsCmd);
	});
var $author$project$Pages$Hinter$NewPractice$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{dd: shared.dd}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Hinter$NewPractice$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Hinter$NewPractice$PhoneInputMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Hinter$NewPractice$subscriptions = function (model) {
	var _v0 = $author$project$Utils$Form$fields(model.SD);
	var phone = _v0.Zw;
	var address = _v0.K2;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Hinter$NewPractice$AddressInputMsg,
				$author$project$Components$AddressInput$subscriptions(address)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Hinter$NewPractice$PhoneInputMsg,
				$author$project$Components$PhoneInput$subscriptions(phone))
			]));
};
var $author$project$Pages$Hinter$NewPractice$Address = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Hinter$NewPractice$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Hinter$NewPractice$LaunchDate = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Pages$Hinter$NewPractice$Logo = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Pages$Hinter$NewPractice$Phone = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Hinter$NewPractice$Created = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$AccountType$toString = function (accountType) {
	switch (accountType) {
		case 0:
			return 'standard';
		case 1:
			return 'affiliate';
		default:
			return 'mce';
	}
};
var $author$project$Api$AccountType$encode = A2($elm$core$Basics$composeR, $author$project$Api$AccountType$toString, $elm$json$Json$Encode$string);
var $author$project$Api$Provider$Practice$create = F3(
	function (apiClient, fields, toMsg) {
		var phones_ = A2(
			$elm$json$Json$Encode$list,
			function (phone) {
				return $author$project$Api$Common$Phone$Shared$encode(phone);
			},
			fields.Zy);
		var logo_ = function () {
			var _v0 = fields.Wj;
			if (!_v0.$) {
				var base64 = _v0.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'logo',
						$elm$json$Json$Encode$string(base64))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var address_ = $author$project$Api$Common$Address$Shared$encode(fields.K2);
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practice',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'account_type',
								$author$project$Api$AccountType$encode(fields.KJ)),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'sales_owner',
									A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ak8)),
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										'primary_care',
										$elm$json$Json$Encode$bool(fields.aki)),
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(
											'segment',
											A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ali)),
										A2(
											$elm$core$List$cons,
											_Utils_Tuple2(
												'name',
												$elm$json$Json$Encode$string(fields.Bq)),
											A2(
												$elm$core$List$cons,
												_Utils_Tuple2(
													'url',
													A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.adY)),
												A2(
													$elm$core$List$cons,
													_Utils_Tuple2(
														'email',
														A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Rj)),
													A2(
														$elm$core$List$cons,
														_Utils_Tuple2(
															'ein',
															A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Q9)),
														A2(
															$elm$core$List$cons,
															_Utils_Tuple2('address', address_),
															A2(
																$elm$core$List$cons,
																_Utils_Tuple2('phones', phones_),
																A2(
																	$elm$core$List$cons,
																	_Utils_Tuple2(
																		'estimated_memberships_count',
																		A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.agY)),
																	A2(
																		$elm$core$List$cons,
																		_Utils_Tuple2(
																			'launch_date',
																			A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.VQ)),
																		A2(
																			$elm$core$List$cons,
																			_Utils_Tuple2(
																				'hubspot_deal_id',
																				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.TD)),
																			A2(
																				$elm$core$List$cons,
																				_Utils_Tuple2(
																					'payment_processor',
																					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Zd)),
																				A2(
																					$elm$core$List$cons,
																					_Utils_Tuple2(
																						'hint_customer_payment_processor',
																						A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ahI)),
																					A2(
																						$elm$core$List$cons,
																						_Utils_Tuple2(
																							'stripe_platform_id',
																							A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.alM)),
																						A2(
																							$elm$core$List$cons,
																							_Utils_Tuple2(
																								'invitation_email',
																								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ah6)),
																							A2(
																								$elm$core$List$cons,
																								_Utils_Tuple2(
																									'send_invitation',
																									$elm$json$Json$Encode$bool(fields.all)),
																								A2(
																									$elm$core$List$cons,
																									_Utils_Tuple2(
																										'ein',
																										A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Q9)),
																									A2(
																										$elm$core$List$cons,
																										_Utils_Tuple2(
																											'invitation_base_url',
																											$elm$json$Json$Encode$string(fields.ah5)),
																										A2(
																											$elm$core$List$cons,
																											_Utils_Tuple2(
																												'requires_payment_information',
																												$elm$json$Json$Encode$bool(fields.$L)),
																											logo_)))))))))))))))))))))))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Practice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$practicePath)));
	});
var $author$project$Pages$Hinter$NewPractice$practiceFormFields = function (fields) {
	var phones = A2(
		$elm$core$List$map,
		$author$project$Utils$Phone$toRecord,
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			$author$project$Components$PhoneInput$getPhones(fields.Zw)));
	var address = $author$project$Components$AddressInput$getAddress(fields.K2);
	return {KJ: fields.KJ, K2: address, Q9: fields.Q9, Rj: fields.Rj, agY: fields.agY, ahI: fields.ahI, TD: fields.TD, ah5: fields.Mz, ah6: fields.ah6, VQ: fields.VQ, Wj: fields.Wk, Bq: fields.Bq, Zd: fields.Zd, Zy: phones, aki: fields.aki, $L: fields.$L, ak8: fields.ak8, ali: fields.ali, all: fields.all, alM: fields.alM, adY: fields.adY};
};
var $author$project$Pages$Hinter$NewPractice$createPractice = F2(
	function (apiClient, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A3(
			$author$project$Api$Provider$Practice$create,
			apiClient,
			$author$project$Pages$Hinter$NewPractice$practiceFormFields(fields),
			$author$project$Pages$Hinter$NewPractice$Created);
	});
var $author$project$Pages$Hinter$NewPractice$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 1:
				var bool = field.a;
				return _Utils_update(
					fields,
					{aki: bool});
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						ak8: $author$project$Utils$String$toMaybe(string)
					});
			case 2:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						ali: $author$project$Utils$String$toMaybe(string)
					});
			case 3:
				var string = field.a;
				return _Utils_update(
					fields,
					{Bq: string});
			case 4:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						adY: $author$project$Utils$String$toMaybe(string)
					});
			case 5:
				var _int = field.a;
				var string = field.b;
				return _Utils_update(
					fields,
					{
						Pg: $elm$core$Maybe$Just(string),
						Iu: _int,
						Wk: $elm$core$Maybe$Just(string)
					});
			case 6:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Rj: $author$project$Utils$String$toMaybe(string)
					});
			case 7:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Q9: $author$project$Utils$String$toMaybe(string)
					});
			case 8:
				var phone = field.a;
				return _Utils_update(
					fields,
					{Zw: phone});
			case 9:
				var address = field.a;
				return _Utils_update(
					fields,
					{K2: address});
			case 10:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						agY: $elm$core$String$toInt(string)
					});
			case 11:
				var dateInput = field.a;
				var date = field.b;
				return _Utils_update(
					fields,
					{VQ: date, sZ: dateInput});
			case 12:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						TD: $author$project$Utils$String$toMaybe(string)
					});
			case 13:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Zd: $author$project$Utils$String$toMaybe(string)
					});
			case 14:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						ahI: $author$project$Utils$String$toMaybe(string)
					});
			case 15:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						alM: $author$project$Utils$String$toMaybe(string)
					});
			case 16:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						ah6: $author$project$Utils$String$toMaybe(string)
					});
			case 17:
				var bool = field.a;
				return _Utils_update(
					fields,
					{all: bool});
			default:
				var bool = field.a;
				return _Utils_update(
					fields,
					{$L: bool});
		}
	});
var $author$project$Pages$Hinter$NewPractice$EinValidation = 5;
var $author$project$Pages$Hinter$NewPractice$EmailValidation = 3;
var $author$project$Pages$Hinter$NewPractice$HintCustomerPaymentProcessorValidation = 11;
var $author$project$Pages$Hinter$NewPractice$InvitationEmailValidation = 8;
var $author$project$Pages$Hinter$NewPractice$LogoValidation = 2;
var $author$project$Pages$Hinter$NewPractice$NameValidation = 0;
var $author$project$Pages$Hinter$NewPractice$PaymentProcessorValidation = 10;
var $author$project$Pages$Hinter$NewPractice$maxLogoBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
var $author$project$Pages$Hinter$NewPractice$AddressValidation = 6;
var $author$project$Pages$Hinter$NewPractice$validateAddress = function (fields) {
	return (!$author$project$Components$AddressInput$isValid(fields.K2)) ? _List_fromArray(
		[
			_Utils_Tuple2(6, 'Please enter a valid address.')
		]) : _List_Nil;
};
var $author$project$Pages$Hinter$NewPractice$HubspotDealValidation = 9;
var $author$project$Pages$Hinter$NewPractice$validateHubspotDealId = function (fields) {
	return _Utils_eq(fields.TD, $elm$core$Maybe$Nothing) ? _List_fromArray(
		[
			_Utils_Tuple2(9, 'Please set a Hubspot Deal Id')
		]) : _List_Nil;
};
var $author$project$Pages$Hinter$NewPractice$LaunchDateValidation = 7;
var $author$project$Pages$Hinter$NewPractice$validateLaunchDate = F2(
	function (currentDate, fields) {
		var _v0 = fields.VQ;
		if (_v0.$ === 1) {
			return _List_Nil;
		} else {
			var launchDate = _v0.a;
			return (A2($justinmimbs$date$Date$compare, currentDate, launchDate) !== 2) ? _List_Nil : _List_fromArray(
				[
					_Utils_Tuple2(7, 'Please enter a date greater or equal than today')
				]);
		}
	});
var $author$project$Pages$Hinter$NewPractice$PhoneValidation = 4;
var $author$project$Pages$Hinter$NewPractice$validatePhone = function (fields) {
	var _v0 = $author$project$Components$PhoneInput$getPhones(fields.Zw);
	if (!_v0.$) {
		return _List_Nil;
	} else {
		return _List_fromArray(
			[
				_Utils_Tuple2(4, 'Please enter a valid phone')
			]);
	}
};
var $author$project$Pages$Hinter$NewPractice$StripePlatformIdValidation = 12;
var $author$project$Pages$Hinter$NewPractice$validateStripePlatformId = function (fields) {
	return (_Utils_eq(
		fields.ahI,
		$elm$core$Maybe$Just('stripe')) && _Utils_eq(fields.alM, $elm$core$Maybe$Nothing)) ? _List_fromArray(
		[
			_Utils_Tuple2(12, 'Please set a Stripe Customer ID or select rainforest as Pay Hint Via')
		]) : _List_Nil;
};
var $author$project$Pages$Hinter$NewPractice$UrlValidation = 1;
var $author$project$Pages$Hinter$NewPractice$validateUrl = function (fields) {
	var _v0 = fields.adY;
	if (_v0.$ === 1) {
		return _List_Nil;
	} else {
		var url = _v0.a;
		return $author$project$Utils$Validate$isInvalidUrl(url) ? _List_fromArray(
			[
				_Utils_Tuple2(1, 'URL must start with http:// or https://')
			]) : _List_Nil;
	}
};
var $author$project$Pages$Hinter$NewPractice$formFieldsValidator = function (currentDate) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_validate$Validate$ifBlank,
				function ($) {
					return $.Bq;
				},
				_Utils_Tuple2(0, 'Please enter a name.')),
				A3(
				$author$project$Utils$Validate$ifIntGreaterThan,
				function ($) {
					return $.Iu;
				},
				$author$project$Pages$Hinter$NewPractice$maxLogoBytesSize,
				_Utils_Tuple2(2, 'That image is too large! Our maximum image size is 5 mb, please choose a smaller image.')),
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Hinter$NewPractice$validateUrl),
				A3(
				$author$project$Utils$Validate$ifInvalidEmail,
				{aeT: true},
				function ($) {
					return $.Rj;
				},
				_Utils_Tuple2(3, 'Please enter a valid email')),
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Hinter$NewPractice$validatePhone),
				A2(
				$author$project$Ui$Form$Ein$ifInvalid,
				function ($) {
					return $.Q9;
				},
				_Utils_Tuple2(5, 'Please enter a valid EIN or leave empty')),
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Hinter$NewPractice$validateAddress),
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Pages$Hinter$NewPractice$validateLaunchDate(currentDate)),
				A3(
				$author$project$Utils$Validate$ifInvalidEmail,
				{aeT: true},
				function ($) {
					return $.ah6;
				},
				_Utils_Tuple2(8, 'Please enter a valid email')),
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Hinter$NewPractice$validateHubspotDealId),
				A2(
				$rtfeldman$elm_validate$Validate$ifNothing,
				function ($) {
					return $.Zd;
				},
				_Utils_Tuple2(10, 'Please select a payment processor')),
				A2(
				$rtfeldman$elm_validate$Validate$ifNothing,
				function ($) {
					return $.ahI;
				},
				_Utils_Tuple2(11, 'Please select a payment processor to pay hint via')),
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Hinter$NewPractice$validateStripePlatformId)
			]));
};
var $author$project$Pages$Hinter$NewPractice$updateDateInputFormField = F6(
	function (model, dateInput, subMsg, toMsg, field, fieldGetter) {
		var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
		var newDateInput = _v0.a;
		var subCmd = _v0.b;
		var event = _v0.c;
		var newForm = function () {
			if (event.$ === 1) {
				var date = event.a;
				return A3(
					$author$project$Utils$Form$update,
					$author$project$Pages$Hinter$NewPractice$formFieldsUpdate,
					A2(field, newDateInput, date),
					model.SD);
			} else {
				var fields = $author$project$Utils$Form$fields(model.SD);
				return A3(
					$author$project$Utils$Form$update,
					$author$project$Pages$Hinter$NewPractice$formFieldsUpdate,
					A2(
						field,
						newDateInput,
						fieldGetter(fields)),
					model.SD);
			}
		}();
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{SD: newForm}),
			A2(
				$elm$core$Platform$Cmd$map,
				toMsg(newDateInput),
				subCmd),
			_List_Nil);
	});
var $author$project$Pages$Hinter$NewPractice$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Hinter$NewPractice$formFieldsUpdate, field, model.SD);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: newForm}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var fields = $author$project$Utils$Form$fields(model.SD);
				var address = $author$project$Components$AddressInput$validate(fields.K2);
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Pages$Hinter$NewPractice$formFieldsUpdate,
					$author$project$Pages$Hinter$NewPractice$Address(address),
					model.SD);
				var _v1 = A2(
					$author$project$Utils$Form$validate,
					$author$project$Pages$Hinter$NewPractice$formFieldsValidator(model.dd),
					newForm);
				if (!_v1.$) {
					var _v2 = _v1.a;
					var validatedForm = _v2.a;
					var validFormFields = _v2.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{SD: validatedForm, k9: $author$project$Api$Data$Loading}),
						A2($author$project$Pages$Hinter$NewPractice$createPractice, model.Gv, validFormFields),
						_List_Nil);
				} else {
					var validatedForm = _v1.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{SD: validatedForm, k9: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					var practice = response.a;
					var _v4 = _Utils_Tuple2(
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A3(
								$author$project$OutMsg$SwitchToOrganization,
								$author$project$Api$Provider$Practice$One$organizationId(practice),
								$elm$core$Maybe$Nothing,
								$author$project$OutMsg$GoToRouteAction($author$project$Spa$Generated$Route$Admin__Billing))
							]));
					var cmd = _v4.a;
					var outMsgs = _v4.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: response}),
						cmd,
						_Utils_ap(
							outMsgs,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Practice created'),
									$author$project$OutMsg$PracticeUpdated(response)
								])));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: response}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 3:
				var logos = msg.a;
				var cmd = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						function (_v5) {
							var task = _v5.a;
							var size = _v5.b;
							return A2(
								$elm$core$Task$perform,
								A2(
									$elm$core$Basics$composeL,
									$author$project$Pages$Hinter$NewPractice$FormUpdated,
									$author$project$Pages$Hinter$NewPractice$Logo(size)),
								task);
						},
						A2(
							$elm$core$Maybe$map,
							function (logo) {
								return _Utils_Tuple2(
									$elm$file$File$toUrl(logo),
									$elm$file$File$size(logo));
							},
							$elm$core$List$head(logos))));
				return _Utils_Tuple3(model, cmd, _List_Nil);
			case 4:
				var subMsg = msg.a;
				var _v6 = $author$project$Utils$Form$fields(model.SD);
				var address = _v6.K2;
				var _v7 = A2($author$project$Components$AddressInput$update, subMsg, address);
				var addressInputModel = _v7.a;
				var addressInputCmd = _v7.b;
				var outMsgs = _v7.c;
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Pages$Hinter$NewPractice$formFieldsUpdate,
					$author$project$Pages$Hinter$NewPractice$Address(addressInputModel),
					model.SD);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: newForm}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Hinter$NewPractice$AddressInputMsg, addressInputCmd),
					outMsgs);
			case 5:
				var subMsg = msg.a;
				var _v8 = $author$project$Utils$Form$fields(model.SD);
				var phone = _v8.Zw;
				var _v9 = A2($author$project$Components$PhoneInput$update, subMsg, phone);
				var phoneInput = _v9.a;
				var phoneCmd = _v9.b;
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Pages$Hinter$NewPractice$formFieldsUpdate,
					$author$project$Pages$Hinter$NewPractice$Phone(phoneInput),
					model.SD);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: newForm}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Hinter$NewPractice$PhoneInputMsg, phoneCmd),
					_List_Nil);
			default:
				var dateInput = msg.a;
				var subMsg = msg.b;
				return A6(
					$author$project$Pages$Hinter$NewPractice$updateDateInputFormField,
					model,
					dateInput,
					subMsg,
					$author$project$Pages$Hinter$NewPractice$LaunchDateDateInputMsg,
					$author$project$Pages$Hinter$NewPractice$LaunchDate,
					function ($) {
						return $.VQ;
					});
		}
	});
var $author$project$Pages$Hinter$NewPractice$Save = {$: 1};
var $author$project$Pages$Hinter$NewPractice$Ein = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Hinter$NewPractice$Email = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Hinter$NewPractice$EstimatedMembershipsCount = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Hinter$NewPractice$HintCustomerPaymentProcessor = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Hinter$NewPractice$HubspotDealId = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Hinter$NewPractice$InvitationEmail = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Hinter$NewPractice$LogoUploaded = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Hinter$NewPractice$Name = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Hinter$NewPractice$PaymentProcessor = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Hinter$NewPractice$PrimaryCare = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Hinter$NewPractice$RequiresPaymentInformation = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$Hinter$NewPractice$SalesOwner = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Hinter$NewPractice$Segment = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Hinter$NewPractice$SendInvitation = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$Hinter$NewPractice$StripePlatformId = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Hinter$NewPractice$Url = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Hinter$NewPractice$paymentProcessors = _List_fromArray(
	[
		_Utils_Tuple2('stripe', 'Stripe'),
		_Utils_Tuple2('rainforest', 'Rainforest')
	]);
var $author$project$Pages$Hinter$NewPractice$paymentProcessorsOptions = A2(
	$elm$core$List$cons,
	A3(
		$author$project$Ui$Form$Select$option,
		_List_Nil,
		$elm$core$Maybe$Just(''),
		'Select an option'),
	A2(
		$elm$core$List$map,
		function (_v0) {
			var value = _v0.a;
			var label = _v0.b;
			return A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(value),
				label);
		},
		$author$project$Pages$Hinter$NewPractice$paymentProcessors));
var $author$project$Pages$Hinter$NewPractice$segments = _List_fromArray(
	['Direct care', 'Fee for service', 'Hybrid', 'Concierge']);
var $author$project$Pages$Hinter$NewPractice$segmentOptions = A2(
	$elm$core$List$cons,
	A3(
		$author$project$Ui$Form$Select$option,
		_List_Nil,
		$elm$core$Maybe$Just(''),
		'Select an option'),
	A2(
		$elm$core$List$map,
		function (segment) {
			return A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(segment),
				segment);
		},
		$author$project$Pages$Hinter$NewPractice$segments));
var $author$project$Pages$Hinter$NewPractice$viewForm = function (model) {
	var fields = $author$project$Utils$Form$fields(model.SD);
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Don\'t Require Payment Method')
				]),
			_List_fromArray(
				[
					$author$project$Ui$ToggleSwitch$view(
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$on(!fields.$L),
							$author$project$Ui$ToggleSwitch$disabled(fields.Jw),
							$author$project$Ui$ToggleSwitch$onChange(
							function (isOn) {
								return $author$project$Pages$Hinter$NewPractice$FormUpdated(
									$author$project$Pages$Hinter$NewPractice$RequiresPaymentInformation(!isOn));
							})
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Sales owner')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$value(
							A2($elm$core$Maybe$withDefault, '', fields.ak8)),
							$author$project$Ui$Form$Input$onInput(
							A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$NewPractice$FormUpdated, $author$project$Pages$Hinter$NewPractice$SalesOwner))
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Primary care')
				]),
			_List_fromArray(
				[
					$author$project$Ui$ToggleSwitch$view(
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$on(fields.aki),
							$author$project$Ui$ToggleSwitch$onChange(
							A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$NewPractice$FormUpdated, $author$project$Pages$Hinter$NewPractice$PrimaryCare))
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Segment')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Select$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Select$value(fields.ali),
							$author$project$Ui$Form$Select$onChange(
							A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$NewPractice$FormUpdated, $author$project$Pages$Hinter$NewPractice$Segment))
						]),
					$author$project$Pages$Hinter$NewPractice$segmentOptions)
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Business Name'),
					$author$project$Ui$Form$Group$required(true)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$value(fields.Bq),
							$author$project$Ui$Form$Input$onInput(
							A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$NewPractice$FormUpdated, $author$project$Pages$Hinter$NewPractice$Name)),
							$author$project$Ui$Form$Input$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 0, model.SD)),
							$author$project$Ui$Form$Input$errors(
							A2($author$project$Utils$Form$validationErrors, 0, model.SD))
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Website')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$value(
							A2($elm$core$Maybe$withDefault, '', fields.adY)),
							$author$project$Ui$Form$Input$onInput(
							A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$NewPractice$FormUpdated, $author$project$Pages$Hinter$NewPractice$Url)),
							$author$project$Ui$Form$Input$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 1, model.SD)),
							$author$project$Ui$Form$Input$errors(
							A2($author$project$Utils$Form$validationErrors, 1, model.SD))
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Practice Logo')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$File$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$File$accept(0),
							$author$project$Ui$Form$File$onInput($author$project$Pages$Hinter$NewPractice$LogoUploaded),
							$author$project$Ui$Form$File$empty(true)
						]))
				])),
			function () {
			var _v0 = fields.Pg;
			if (!_v0.$) {
				var url = _v0.a;
				return $elm$core$String$isEmpty(url) ? $author$project$Utils$Html$empty : A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpanSm(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Image$fromSrc,
							{LD: 'Logo'},
							url,
							_List_fromArray(
								[
									$author$project$Ui$Image$height(50)
								])),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 2, model.SD))
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Phone')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Pages$Hinter$NewPractice$PhoneInputMsg,
					$author$project$Components$PhoneInput$view(fields.Zw)),
					$author$project$Utils$FormErrors$view(
					A2($author$project$Utils$Form$validationErrors, 4, model.SD))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Email')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$value(
							A2($elm$core$Maybe$withDefault, '', fields.Rj)),
							$author$project$Ui$Form$Input$onInput(
							A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$NewPractice$FormUpdated, $author$project$Pages$Hinter$NewPractice$Email)),
							$author$project$Ui$Form$Input$placeholder('contact@mypractice.com'),
							$author$project$Ui$Form$Input$phi(true),
							$author$project$Ui$Form$Input$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 3, model.SD)),
							$author$project$Ui$Form$Input$errors(
							A2($author$project$Utils$Form$validationErrors, 3, model.SD))
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Business Address'),
					$author$project$Ui$Form$Group$required(true)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Pages$Hinter$NewPractice$AddressInputMsg,
					A2($author$project$Components$AddressInput$view, _List_Nil, fields.K2))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Employer Identification Number (EIN)')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Ein$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Ein$value(fields.Q9),
							$author$project$Ui$Form$Ein$onInput(
							A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$NewPractice$FormUpdated, $author$project$Pages$Hinter$NewPractice$Ein)),
							$author$project$Ui$Form$Ein$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 5, model.SD)),
							$author$project$Ui$Form$Ein$errors(
							A2($author$project$Utils$Form$validationErrors, 5, model.SD))
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label(''),
					$author$project$Ui$Form$Group$label('Launch & Billing Start')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Pages$Hinter$NewPractice$LaunchDateDateInputMsg(fields.sZ),
					A2(
						$author$project$Components$DateInput$view,
						_List_fromArray(
							[
								$author$project$Components$DateInput$value(fields.VQ),
								$author$project$Components$DateInput$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 7, model.SD)),
								$author$project$Components$DateInput$errors(
								A2($author$project$Utils$Form$validationErrors, 7, model.SD))
							]),
						fields.sZ))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Current Members')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$number,
							$author$project$Ui$Form$Input$value(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2($elm$core$Maybe$map, $elm$core$String$fromInt, fields.agY))),
							$author$project$Ui$Form$Input$onInput(
							A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$NewPractice$FormUpdated, $author$project$Pages$Hinter$NewPractice$EstimatedMembershipsCount))
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Hubspot Deal ID'),
					$author$project$Ui$Form$Group$required(true)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$value(
							A2($elm$core$Maybe$withDefault, '', fields.TD)),
							$author$project$Ui$Form$Input$onInput(
							A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$NewPractice$FormUpdated, $author$project$Pages$Hinter$NewPractice$HubspotDealId)),
							$author$project$Ui$Form$Input$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 9, model.SD)),
							$author$project$Ui$Form$Input$errors(
							A2($author$project$Utils$Form$validationErrors, 9, model.SD))
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Payment Processor'),
					$author$project$Ui$Form$Group$required(true)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Select$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Select$value(fields.Zd),
							$author$project$Ui$Form$Select$onChange(
							A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$NewPractice$FormUpdated, $author$project$Pages$Hinter$NewPractice$PaymentProcessor)),
							$author$project$Ui$Form$Select$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 10, model.SD)),
							$author$project$Ui$Form$Select$errors(
							A2($author$project$Utils$Form$validationErrors, 10, model.SD))
						]),
					$author$project$Pages$Hinter$NewPractice$paymentProcessorsOptions)
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Pay Hint Via'),
					$author$project$Ui$Form$Group$required(true)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Select$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Select$value(fields.ahI),
							$author$project$Ui$Form$Select$onChange(
							A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$NewPractice$FormUpdated, $author$project$Pages$Hinter$NewPractice$HintCustomerPaymentProcessor)),
							$author$project$Ui$Form$Select$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 11, model.SD)),
							$author$project$Ui$Form$Select$errors(
							A2($author$project$Utils$Form$validationErrors, 11, model.SD))
						]),
					$author$project$Pages$Hinter$NewPractice$paymentProcessorsOptions),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$helpBlock]),
					_List_fromArray(
						[
							$elm$html$Html$text('Use rainforest unless a stripe customer id is provided.')
						]))
				])),
			_Utils_eq(
			fields.ahI,
			$elm$core$Maybe$Just('stripe')) ? A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Stripe Customer ID')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$value(
							A2($elm$core$Maybe$withDefault, '', fields.alM)),
							$author$project$Ui$Form$Input$onInput(
							A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$NewPractice$FormUpdated, $author$project$Pages$Hinter$NewPractice$StripePlatformId)),
							$author$project$Ui$Form$Input$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 12, model.SD)),
							$author$project$Ui$Form$Input$errors(
							A2($author$project$Utils$Form$validationErrors, 12, model.SD))
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$helpBlock]),
					_List_fromArray(
						[
							$elm$html$Html$text('This is for the payment info they gave us, allowing us to charge the customer a minimum/pmpm fee.')
						]))
				])) : $author$project$Utils$Html$empty,
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Owner email')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$value(
							A2($elm$core$Maybe$withDefault, '', fields.ah6)),
							$author$project$Ui$Form$Input$placeholder('email@example.com'),
							$author$project$Ui$Form$Input$onInput(
							A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$NewPractice$FormUpdated, $author$project$Pages$Hinter$NewPractice$InvitationEmail)),
							$author$project$Ui$Form$Input$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 8, model.SD)),
							$author$project$Ui$Form$Input$errors(
							A2($author$project$Utils$Form$validationErrors, 8, model.SD))
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$helpBlock]),
					_List_fromArray(
						[
							$elm$html$Html$text('Leave this blank for clinical accounts.')
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Invitation to owners')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Do you want to send an invitation to practice owners?')
						])),
					$author$project$Ui$ToggleSwitch$view(
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$on(fields.all),
							$author$project$Ui$ToggleSwitch$onChange(
							A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$NewPractice$FormUpdated, $author$project$Pages$Hinter$NewPractice$SendInvitation))
						]))
				]))
		]);
};
var $author$project$Pages$Hinter$NewPractice$view = function (model) {
	var loading = _Utils_eq(model.k9, $author$project$Api$Data$Loading);
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$autocomplete(false),
						$author$project$Ui$Form$noValidate(true),
						$author$project$Ui$Form$onSubmit($author$project$Pages$Hinter$NewPractice$Save)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Create New Practice')
											]))
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_Utils_ap(
									$author$project$Pages$Hinter$NewPractice$viewForm(model),
									_List_fromArray(
										[
											function () {
											var _v0 = model.k9;
											if (_v0.$ === 2) {
												var error = _v0.a;
												return A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$mt4]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Alert$danger,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Api$Data$errorToString(error))
																]))
														]));
											} else {
												return $author$project$Utils$Html$empty;
											}
										}()
										]))),
								A2(
								$author$project$Ui$Panel$footer,
								_List_fromArray(
									[$author$project$Ui$Element$justifyCenter]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Patients__Top,
										_List_fromArray(
											[$author$project$Ui$Link$buttonSecondary]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cancel')
											])),
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Create new practice'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$submit,
												$author$project$Ui$Button$loading(loading)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Create')
											]))
									]))
							]))
					]))
			]),
		ac9: 'Practice Setup'
	};
};
var $author$project$Pages$Hinter$NewPractice$page = $author$project$Spa$Page$applicationPrivate(
	{ah_: $author$project$Pages$Hinter$NewPractice$init, aiq: $author$project$Pages$Hinter$NewPractice$load, k8: $author$project$Pages$Hinter$NewPractice$save, alO: $author$project$Pages$Hinter$NewPractice$subscriptions, adT: $author$project$Pages$Hinter$NewPractice$update, amo: $author$project$Pages$Hinter$NewPractice$view});
var $author$project$Pages$Home$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Home$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Home$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Home$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Home'};
};
var $author$project$Pages$Home$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$Home$init,
		aiq: $author$project$Pages$Home$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$Home$update,
		amo: $author$project$Pages$Home$view
	});
var $author$project$Pages$Inventory$InventoryId_String$Top$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Inventory$InventoryId_String$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Inventory$InventoryId_String$Top$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Inventory$InventoryId_String$Top$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Medication'};
};
var $author$project$Pages$Inventory$InventoryId_String$Top$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$Inventory$InventoryId_String$Top$init,
		aiq: $author$project$Pages$Inventory$InventoryId_String$Top$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$Inventory$InventoryId_String$Top$update,
		amo: $author$project$Pages$Inventory$InventoryId_String$Top$view
	});
var $author$project$Pages$Inventory$List$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Inventory$List$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Inventory$List$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Inventory$List$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Medications'};
};
var $author$project$Pages$Inventory$List$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$Inventory$List$init,
		aiq: $author$project$Pages$Inventory$List$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$Inventory$List$update,
		amo: $author$project$Pages$Inventory$List$view
	});
var $author$project$Pages$Inventory$New$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Inventory$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Inventory$New$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Inventory$New$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'New Medication'};
};
var $author$project$Pages$Inventory$New$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$Inventory$New$init,
		aiq: $author$project$Pages$Inventory$New$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$Inventory$New$update,
		amo: $author$project$Pages$Inventory$New$view
	});
var $author$project$Pages$Inventory$Settings$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Inventory$Settings$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Inventory$Settings$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Inventory$Settings$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Inventory Settings'};
};
var $author$project$Pages$Inventory$Settings$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$Inventory$Settings$init,
		aiq: $author$project$Pages$Inventory$Settings$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$Inventory$Settings$update,
		amo: $author$project$Pages$Inventory$Settings$view
	});
var $author$project$Pages$Join$Token_String$GotInvitation = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Join$Token_String$GotSession = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Platform$Invitation$One$Invitation = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Platform$Invitation$Shared$Invitation = $elm$core$Basics$identity;
var $author$project$Api$Platform$Invitation$Shared$Record = F2(
	function (role, email) {
		return {Rj: email, ak3: role};
	});
var $author$project$Api$Platform$Invitation$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'email',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'role',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Platform$Invitation$Shared$Record)));
var $author$project$Api$Platform$Invitation$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$Invitation$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Platform$Invitation$One$Record = F2(
	function (accepted, organization) {
		return {Kz: accepted, Yr: organization};
	});
var $author$project$Api$Platform$Invitation$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'organization',
	$author$project$Api$Platform$Organization$Shared$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'accepted',
		$elm$json$Json$Decode$bool,
		$elm$json$Json$Decode$succeed($author$project$Api$Platform$Invitation$One$Record)));
var $author$project$Api$Platform$Invitation$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$Invitation$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Platform$Invitation$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Platform$Invitation$One$Invitation)));
var $author$project$Api$Platform$Invitation$invitationsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['invitations']),
	$author$project$Api$Data$platformPath);
var $author$project$Api$Platform$Invitation$invitationPath = function (token) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[token]),
		$author$project$Api$Platform$Invitation$invitationsPath);
};
var $author$project$Api$Platform$Invitation$retrieve = F3(
	function (apiClient, token, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Platform$Invitation$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Platform$Invitation$invitationPath(token)));
	});
var $author$project$Pages$Join$Token_String$init = F2(
	function (shared, _v0) {
		var params = _v0.YL;
		var _v1 = $author$project$Api$Data$clientHasAuthToken(shared.Gv) ? _Utils_Tuple2(
			$author$project$Api$Data$Loading,
			A2($author$project$Api$Platform$Session$retrieve, shared.Gv, $author$project$Pages$Join$Token_String$GotSession)) : _Utils_Tuple2($author$project$Api$Data$NotAsked, $elm$core$Platform$Cmd$none);
		var session = _v1.a;
		var cmd = _v1.b;
		return _Utils_Tuple3(
			{Gv: shared.Gv, SD: $elm$core$Maybe$Nothing, n1: $author$project$Api$Data$Loading, ais: shared.adY, k9: $author$project$Api$Data$NotAsked, aa4: session, adi: params.adi, aey: $author$project$Api$Data$Loading},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3($author$project$Api$Platform$Invitation$retrieve, shared.Gv, params.adi, $author$project$Pages$Join$Token_String$GotInvitation),
						cmd
					])),
			_List_Nil);
	});
var $author$project$Pages$Join$Token_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Join$Token_String$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Join$Token_String$FormUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Join$Token_String$PasswordStrengthCheck = function (a) {
	return {$: 5, a: a};
};
var $author$project$Utils$PasswordStrength$PasswordStrength = $elm$core$Basics$identity;
var $author$project$Utils$PasswordStrength$init = $elm$core$Basics$identity;
var $author$project$Ports$PasswordStrength$passwordStrengthChecked = _Platform_incomingPort(
	'passwordStrengthChecked',
	A2(
		$elm$json$Json$Decode$andThen,
		function (suggestions) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (strength) {
					return $elm$json$Json$Decode$succeed(
						{alL: strength, alP: suggestions});
				},
				A2($elm$json$Json$Decode$field, 'strength', $elm$json$Json$Decode$int));
		},
		A2(
			$elm$json$Json$Decode$field,
			'suggestions',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string))));
var $author$project$Ports$PasswordStrength$checked = function (toMsg) {
	return $author$project$Ports$PasswordStrength$passwordStrengthChecked(
		A2($elm$core$Basics$composeR, $author$project$Utils$PasswordStrength$init, toMsg));
};
var $author$project$Pages$Join$Token_String$subscriptions = function (_v0) {
	return $author$project$Ports$PasswordStrength$checked(
		A2(
			$elm$core$Basics$composeL,
			A2($elm$core$Basics$composeL, $author$project$Pages$Join$Token_String$FormUpdated, $author$project$Pages$Join$Token_String$PasswordStrengthCheck),
			$elm$core$Maybe$Just));
};
var $author$project$Pages$Join$Token_String$InvitationAccepted = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Join$Token_String$UserCreated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Platform$Invitation$accept = F3(
	function (apiClient, token, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Platform$Invitation$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['accept']),
					$author$project$Api$Platform$Invitation$invitationPath(token))));
	});
var $author$project$Api$Platform$Invitation$One$accepted = function (_v0) {
	var record = _v0.b;
	return record.Kz;
};
var $author$project$Api$Data$clientWithAuthToken = F2(
	function (authToken, _v0) {
		var client = _v0;
		return _Utils_update(
			client,
			{fK: authToken});
	});
var $author$project$Api$Data$clientDisableAuth = function (_v0) {
	var client = _v0;
	return _Utils_update(
		client,
		{Ev: false});
};
var $author$project$Api$Platform$User$create = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'user',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'first_name',
								$elm$json$Json$Encode$string(fields.Sv)),
								_Utils_Tuple2(
								'last_name',
								$elm$json$Json$Encode$string(fields.VH)),
								_Utils_Tuple2(
								'email',
								$elm$json$Json$Encode$string(fields.Rj)),
								_Utils_Tuple2(
								'password',
								$elm$json$Json$Encode$string(fields.ajR)),
								_Utils_Tuple2(
								'terms_accepted',
								$elm$json$Json$Encode$bool(fields.J5))
							]))),
					_Utils_Tuple2(
					'invitation_id',
					$elm$json$Json$Encode$string(fields.ah7))
				]));
		return A4(
			$author$project$Api$Data$post,
			$author$project$Api$Data$clientDisableAuth(apiClient),
			$author$project$Api$Platform$User$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Platform$User$userPath)));
	});
var $author$project$Api$Platform$User$One$defaultOrganization = function (_v0) {
	var record = _v0.b;
	return record.P4;
};
var $author$project$Ports$PasswordStrength$checkPasswordStrength = _Platform_outgoingPort('checkPasswordStrength', $elm$json$Json$Encode$string);
var $author$project$Ports$PasswordStrength$check = $author$project$Ports$PasswordStrength$checkPasswordStrength;
var $author$project$Pages$Join$Token_String$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{Sv: string}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var string = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{VH: string}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var string = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{Rj: string}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var string = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{ajR: string, oT: $elm$core$Maybe$Nothing}),
					$author$project$Ports$PasswordStrength$check(string));
			case 4:
				var bool = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{J5: bool}),
					$elm$core$Platform$Cmd$none);
			default:
				var check = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{oT: check}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Join$Token_String$EmailValidation = 2;
var $author$project$Pages$Join$Token_String$FirstNameValidation = 0;
var $author$project$Pages$Join$Token_String$LastNameValidation = 1;
var $author$project$Pages$Join$Token_String$PasswordValidation = 3;
var $author$project$Pages$Join$Token_String$TermsAcceptedValidation = 4;
var $author$project$Utils$PasswordStrength$isUnguessable = function (_v0) {
	var record = _v0;
	return record.alL >= 3;
};
var $author$project$Pages$Join$Token_String$formFieldsValidator = function (existingUser) {
	return $rtfeldman$elm_validate$Validate$all(
		existingUser ? _List_Nil : _List_fromArray(
			[
				A2(
				$rtfeldman$elm_validate$Validate$ifBlank,
				function ($) {
					return $.Sv;
				},
				_Utils_Tuple2(0, 'Please enter a first name.')),
				A2(
				$rtfeldman$elm_validate$Validate$ifBlank,
				function ($) {
					return $.VH;
				},
				_Utils_Tuple2(1, 'Please enter a last name.')),
				A2(
				$rtfeldman$elm_validate$Validate$ifBlank,
				function ($) {
					return $.Rj;
				},
				_Utils_Tuple2(2, 'Please enter an email.')),
				A2(
				$rtfeldman$elm_validate$Validate$ifBlank,
				function ($) {
					return $.ajR;
				},
				_Utils_Tuple2(3, 'Please enter a password.')),
				A2(
				$rtfeldman$elm_validate$Validate$ifFalse,
				function ($) {
					return $.J5;
				},
				_Utils_Tuple2(4, 'You must accept our Terms of Service when creating your account.')),
				A2(
				$rtfeldman$elm_validate$Validate$ifFalse,
				function (subject) {
					return A2(
						$elm$core$Maybe$withDefault,
						false,
						A2($elm$core$Maybe$map, $author$project$Utils$PasswordStrength$isUnguessable, subject.oT));
				},
				_Utils_Tuple2(3, 'Please enter a secure password.'))
			]));
};
var $author$project$Api$Platform$Invitation$Shared$email = function (_v0) {
	var record = _v0;
	return record.Rj;
};
var $author$project$Api$Platform$Invitation$One$email = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Platform$Invitation$Shared$email(shared);
};
var $author$project$Pages$Join$Token_String$initFormFields = F2(
	function (invitation, user) {
		return {
			Rj: A2(
				$elm$core$Maybe$withDefault,
				$author$project$Api$Platform$Invitation$One$email(invitation),
				A2($elm$core$Maybe$map, $author$project$Api$Platform$User$Shared$email, user)),
			Sv: A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Maybe$map, $author$project$Api$Platform$User$Shared$firstName, user)),
			VH: A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Maybe$map, $author$project$Api$Platform$User$Shared$lastName, user)),
			ajR: '',
			oT: $elm$core$Maybe$Nothing,
			J5: false,
			ad0: user
		};
	});
var $author$project$Pages$Join$Token_String$initInvitationForm = F2(
	function (session, invitation) {
		var _v0 = _Utils_Tuple2(session, invitation);
		_v0$3:
		while (true) {
			if (_v0.b.$ === 3) {
				switch (_v0.a.$) {
					case 3:
						var _v1 = _v0.a;
						var session_ = _v1.a;
						var _v2 = _v0.b;
						var invitation_ = _v2.a;
						var form = $author$project$Utils$Form$init(
							A2(
								$author$project$Pages$Join$Token_String$initFormFields,
								invitation_,
								$elm$core$Maybe$Just(
									$author$project$Api$Platform$Session$One$user(session_))));
						return $elm$core$Maybe$Just(form);
					case 2:
						var _v3 = _v0.b;
						var invitation_ = _v3.a;
						var form = $author$project$Utils$Form$init(
							A2($author$project$Pages$Join$Token_String$initFormFields, invitation_, $elm$core$Maybe$Nothing));
						return $elm$core$Maybe$Just(form);
					case 0:
						var _v4 = _v0.a;
						var _v5 = _v0.b;
						var invitation_ = _v5.a;
						var form = $author$project$Utils$Form$init(
							A2($author$project$Pages$Join$Token_String$initFormFields, invitation_, $elm$core$Maybe$Nothing));
						return $elm$core$Maybe$Just(form);
					default:
						break _v0$3;
				}
			} else {
				break _v0$3;
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$OutMsg$GoToDefaultStateAction = {$: 0};
var $author$project$Api$Platform$Organization$Shared$requiresMfa = function (_v0) {
	var record = _v0.b;
	return record.$H;
};
var $author$project$Pages$Join$Token_String$navigateToAcceptedOrganization = function (organization) {
	return $author$project$Api$Platform$Organization$Shared$requiresMfa(organization) ? _Utils_Tuple2(
		A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$User__Mfa),
		_List_Nil) : _Utils_Tuple2(
		$elm$core$Platform$Cmd$none,
		_List_fromArray(
			[
				A3(
				$author$project$OutMsg$SwitchToOrganization,
				$author$project$Api$Platform$Organization$Shared$id(organization),
				$elm$core$Maybe$Nothing,
				$author$project$OutMsg$GoToDefaultStateAction)
			]));
};
var $author$project$Api$Platform$Invitation$One$organization = function (_v0) {
	var record = _v0.b;
	return record.Yr;
};
var $author$project$Ports$Session$sessionPersistRedirectPort = _Platform_outgoingPort('sessionPersistRedirectPort', $elm$json$Json$Encode$string);
var $author$project$Ports$Session$persistRedirect = function (url) {
	return $author$project$Ports$Session$sessionPersistRedirectPort(url);
};
var $author$project$Pages$Join$Token_String$GotWhitelabelSetting = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$WhitelabelSetting$platformWhitelabelSettingsPath = function (practiceId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['whitelabel_settings']),
		A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[practiceId]),
			A2(
				$author$project$Api$Data$pathAppend,
				_List_fromArray(
					['practices']),
				$author$project$Api$Data$platformPath)));
};
var $author$project$Api$WhitelabelSetting$platformRetrieve = F3(
	function (apiClient, practiceId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$WhitelabelSetting$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$WhitelabelSetting$platformWhitelabelSettingsPath(practiceId)));
	});
var $author$project$Pages$Join$Token_String$retrieveWhitelabelSettings = F2(
	function (apiClient, practiceId) {
		return A3($author$project$Api$WhitelabelSetting$platformRetrieve, apiClient, practiceId, $author$project$Pages$Join$Token_String$GotWhitelabelSetting);
	});
var $elm$url$Url$addPort = F2(
	function (maybePort, starter) {
		if (maybePort.$ === 1) {
			return starter;
		} else {
			var port_ = maybePort.a;
			return starter + (':' + $elm$core$String$fromInt(port_));
		}
	});
var $elm$url$Url$addPrefixed = F3(
	function (prefix, maybeSegment, starter) {
		if (maybeSegment.$ === 1) {
			return starter;
		} else {
			var segment = maybeSegment.a;
			return _Utils_ap(
				starter,
				_Utils_ap(prefix, segment));
		}
	});
var $elm$url$Url$toString = function (url) {
	var http = function () {
		var _v0 = url._D;
		if (!_v0) {
			return 'http://';
		} else {
			return 'https://';
		}
	}();
	return A3(
		$elm$url$Url$addPrefixed,
		'#',
		url.ahu,
		A3(
			$elm$url$Url$addPrefixed,
			'?',
			url.DE,
			_Utils_ap(
				A2(
					$elm$url$Url$addPort,
					url.ZN,
					_Utils_ap(http, url.ahL)),
				url.YX)));
};
var $author$project$Pages$Join$Token_String$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				var cmd = function () {
					if (response.$ === 3) {
						var invitation = response.a;
						return A2(
							$author$project$Pages$Join$Token_String$retrieveWhitelabelSettings,
							model.Gv,
							$author$project$Api$Platform$Organization$Shared$id(
								$author$project$Api$Platform$Invitation$One$organization(invitation)));
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							SD: A2($author$project$Pages$Join$Token_String$initInvitationForm, model.aa4, response),
							n1: response
						}),
					cmd,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							SD: A2($author$project$Pages$Join$Token_String$initInvitationForm, response, model.n1),
							aa4: response
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 2:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aey: response}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var field = msg.a;
				var _v2 = model.SD;
				if (!_v2.$) {
					var form = _v2.a;
					var _v3 = A3($author$project$Utils$Form$updateWithCmd, $author$project$Pages$Join$Token_String$formFieldsUpdate, field, form);
					var newForm = _v3.a;
					var cmd = _v3.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								SD: $elm$core$Maybe$Just(newForm)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Join$Token_String$FormUpdated, cmd),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				var _v4 = model.SD;
				if (!_v4.$) {
					var form = _v4.a;
					var session = $author$project$Api$Data$toMaybe(model.aa4);
					var existingUser = $author$project$Utils$Maybe$toBool(session);
					var _v5 = A2(
						$author$project$Utils$Form$validate,
						$author$project$Pages$Join$Token_String$formFieldsValidator(existingUser),
						form);
					if (!_v5.$) {
						var _v6 = _v5.a;
						var newForm = _v6.a;
						var validFormFields = _v6.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									SD: $elm$core$Maybe$Just(newForm),
									k9: $author$project$Api$Data$Loading
								}),
							function () {
								if (!session.$) {
									var accessToken = $author$project$Api$Data$clientAuthToken(model.Gv);
									var apiClient = A2($author$project$Api$Data$clientWithAuthToken, accessToken, model.Gv);
									return A3($author$project$Api$Platform$Invitation$accept, apiClient, model.adi, $author$project$Pages$Join$Token_String$InvitationAccepted);
								} else {
									var _v8 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
									var firstName = _v8.Sv;
									var lastName = _v8.VH;
									var email = _v8.Rj;
									var termsAccepted = _v8.J5;
									var password = _v8.ajR;
									return A3(
										$author$project$Api$Platform$User$create,
										model.Gv,
										{Rj: email, Sv: firstName, ah7: model.adi, VH: lastName, ajR: password, J5: termsAccepted},
										$author$project$Pages$Join$Token_String$UserCreated);
								}
							}(),
							_List_Nil);
					} else {
						var newForm = _v5.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									SD: $elm$core$Maybe$Just(newForm),
									k9: $author$project$Api$Data$NotAsked
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					var invitation = response.a;
					var organization = $author$project$Api$Platform$Invitation$One$organization(invitation);
					var _v10 = $author$project$Pages$Join$Token_String$navigateToAcceptedOrganization(organization);
					var cmd = _v10.a;
					var outMsgs = _v10.b;
					return _Utils_Tuple3(
						model,
						cmd,
						_Utils_ap(
							outMsgs,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Invitation accepted')
								])));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 6:
				var response = msg.a;
				if (response.$ === 3) {
					var user = response.a;
					var _v12 = $author$project$Api$Platform$User$One$defaultOrganization(user);
					if (!_v12.$) {
						return _Utils_Tuple3(
							model,
							$author$project$Ports$Session$logout(
								{aku: true}),
							_List_Nil);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{k9: $author$project$Api$Data$NotAsked}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 7:
				var cmd = function () {
					var _v13 = model.n1;
					if (_v13.$ === 3) {
						var invitation_ = _v13.a;
						return $author$project$Api$Platform$Invitation$One$accepted(invitation_) ? $author$project$Ports$Session$logout(
							{aku: true}) : $author$project$Ports$Session$logout(
							{aku: false});
					} else {
						return $author$project$Ports$Session$logout(
							{aku: false});
					}
				}();
				return _Utils_Tuple3(model, cmd, _List_Nil);
			default:
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Ports$Session$persistRedirect(
								$elm$url$Url$toString(model.ais)),
								$author$project$Ports$Session$authorize(
								{aku: true})
							])),
					_List_Nil);
		}
	});
var $author$project$Pages$Join$Token_String$Logout = {$: 7};
var $author$project$Pages$Join$Token_String$Email = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Join$Token_String$FirstName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Join$Token_String$LastName = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Join$Token_String$Password = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Join$Token_String$Save = {$: 4};
var $author$project$Pages$Join$Token_String$SignInClicked = {$: 8};
var $author$project$Pages$Join$Token_String$TermsAccepted = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$WhitelabelSetting$brandName = function (_v0) {
	var record = _v0;
	return record.GJ;
};
var $author$project$Ui$Button$Lg = 2;
var $author$project$Ui$Button$lg = $author$project$Ui$Button$Size(2);
var $author$project$Api$Platform$Organization$Min$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Platform$Organization$Shared$name = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Platform$Organization$Min$name(min);
};
var $author$project$Api$Platform$User$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Ui$Form$PasswordInput$Placeholder = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Form$PasswordInput$placeholder = $author$project$Ui$Form$PasswordInput$Placeholder;
var $author$project$Api$Platform$Invitation$Shared$role = function (_v0) {
	var record = _v0;
	return record.ak3;
};
var $author$project$Api$Platform$Invitation$One$role = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Platform$Invitation$Shared$role(shared);
};
var $author$project$Ui$Form$PasswordInput$StrengthCheck = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Form$PasswordInput$strengthCheck = $author$project$Ui$Form$PasswordInput$StrengthCheck;
var $author$project$Utils$HintUrls$termsUrl = 'http://www.hint.com/terms/';
var $author$project$Ui$Form$PasswordInput$WithFeedback = function (a) {
	return {$: 6, a: a};
};
var $author$project$Ui$Form$PasswordInput$withFeedback = $author$project$Ui$Form$PasswordInput$WithFeedback;
var $author$project$Pages$Join$Token_String$viewAcceptInvitationForm = F3(
	function (model, form, invitation) {
		var organization = $author$project$Api$Platform$Invitation$One$organization(invitation);
		var invitedAs = ($author$project$Api$Platform$Invitation$One$role(invitation) === 'admin') ? 'an administrator' : 'a user';
		var fields = $author$project$Utils$Form$fields(form);
		var existingUser = $author$project$Utils$Maybe$toBool(fields.ad0);
		return A3(
			$author$project$Ui$Element$custom,
			'mx-auto max-w-sm',
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Panel$body,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$noValidate(true),
											$author$project$Ui$Form$autocomplete(false),
											$author$project$Ui$Form$onSubmit($author$project$Pages$Join$Token_String$Save)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Typography$heading(
											_List_fromArray(
												[
													function () {
													if (existingUser) {
														return $elm$html$Html$text('Accept Invitation');
													} else {
														var brandName = function () {
															var _v0 = model.aey;
															if (_v0.$ === 3) {
																var whitelabelSetting = _v0.a;
																return $author$project$Api$WhitelabelSetting$brandName(whitelabelSetting) + ' ';
															} else {
																return '';
															}
														}();
														return $elm$html$Html$text(
															$elm$core$String$concat(
																_List_fromArray(
																	['Create your ', brandName, 'Account'])));
													}
												}()
												])),
											function () {
											var _v1 = fields.ad0;
											if (!_v1.$) {
												var user = _v1.a;
												return A2(
													$author$project$Ui$Element$view,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Typography$p,
															_List_fromArray(
																[$author$project$Ui$Typography$helpBlock]),
															_Utils_eq(
																$author$project$Api$Platform$User$Shared$email(user),
																$author$project$Api$Platform$Invitation$One$email(invitation)) ? _List_fromArray(
																[
																	$elm$html$Html$text('You\'re logged in as '),
																	$elm$html$Html$text(
																	$author$project$Api$Platform$User$Shared$name(user)),
																	$elm$html$Html$text('.')
																]) : _List_fromArray(
																[
																	$elm$html$Html$text('You\'re logged in as '),
																	A2(
																	$author$project$Ui$Typography$strong,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Api$Platform$User$Shared$email(user))
																		])),
																	$elm$html$Html$text(' but are accepting an invitation sent to '),
																	A2(
																	$author$project$Ui$Typography$strong,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Api$Platform$Invitation$One$email(invitation))
																		]))
																])),
															A2(
															$author$project$Ui$Typography$p,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Want to create a new account? '),
																	A3(
																	$author$project$Ui$Button$view,
																	{mm: 'Sign out'},
																	_List_fromArray(
																		[
																			$author$project$Ui$Button$link,
																			$author$project$Ui$Button$onClick($author$project$Pages$Join$Token_String$Logout)
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Sign Out')
																		])),
																	$elm$html$Html$text('.')
																]))
														]));
											} else {
												return A2(
													$author$project$Ui$Typography$p,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Already have an account? '),
															A3(
															$author$project$Ui$Button$view,
															{mm: 'Sign In'},
															_List_fromArray(
																[
																	$author$project$Ui$Button$link,
																	$author$project$Ui$Button$onClick($author$project$Pages$Join$Token_String$SignInClicked)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Sign In')
																]))
														]));
											}
										}(),
											A2(
											$author$project$Ui$Form$Group$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Group$required(true),
													$author$project$Ui$Form$Group$invalid(
													A2($author$project$Utils$Form$hasValidationErrors, 0, form) || A2($author$project$Utils$Form$hasValidationErrors, 1, form))
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Grid$row,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Grid$column,
															_List_fromArray(
																[
																	$author$project$Ui$Grid$span(6)
																]),
															_List_fromArray(
																[
																	$author$project$Ui$Form$Input$view(
																	_List_fromArray(
																		[
																			$author$project$Ui$Form$Input$placeholder('First'),
																			$author$project$Ui$Form$Input$value(fields.Sv),
																			$author$project$Ui$Form$Input$onInput(
																			A2($elm$core$Basics$composeL, $author$project$Pages$Join$Token_String$FormUpdated, $author$project$Pages$Join$Token_String$FirstName)),
																			$author$project$Ui$Form$Input$invalid(
																			A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
																			$author$project$Ui$Form$Input$disabled(existingUser)
																		]))
																])),
															A2(
															$author$project$Ui$Grid$column,
															_List_fromArray(
																[
																	$author$project$Ui$Grid$span(6)
																]),
															_List_fromArray(
																[
																	$author$project$Ui$Form$Input$view(
																	_List_fromArray(
																		[
																			$author$project$Ui$Form$Input$placeholder('Last'),
																			$author$project$Ui$Form$Input$value(fields.VH),
																			$author$project$Ui$Form$Input$onInput(
																			A2($elm$core$Basics$composeL, $author$project$Pages$Join$Token_String$FormUpdated, $author$project$Pages$Join$Token_String$LastName)),
																			$author$project$Ui$Form$Input$invalid(
																			A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
																			$author$project$Ui$Form$Input$disabled(existingUser)
																		]))
																]))
														]))
												])),
											A2(
											$author$project$Ui$Form$Group$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Group$required(true),
													$author$project$Ui$Form$Group$invalid(
													A2($author$project$Utils$Form$hasValidationErrors, 2, form))
												]),
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$view(
													_List_fromArray(
														[
															$author$project$Ui$Form$Input$placeholder('Email address'),
															$author$project$Ui$Form$Input$email,
															$author$project$Ui$Form$Input$value(fields.Rj),
															$author$project$Ui$Form$Input$onInput(
															A2($elm$core$Basics$composeL, $author$project$Pages$Join$Token_String$FormUpdated, $author$project$Pages$Join$Token_String$Email)),
															$author$project$Ui$Form$Input$invalid(
															A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
															$author$project$Ui$Form$Input$disabled(existingUser)
														]))
												])),
											(!existingUser) ? A2(
											$author$project$Ui$Form$Group$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Group$required(true),
													$author$project$Ui$Form$Group$invalid(
													A2($author$project$Utils$Form$hasValidationErrors, 3, form))
												]),
											_List_fromArray(
												[
													$author$project$Ui$Form$PasswordInput$view(
													_List_fromArray(
														[
															$author$project$Ui$Form$PasswordInput$placeholder('Password'),
															$author$project$Ui$Form$PasswordInput$value(fields.ajR),
															$author$project$Ui$Form$PasswordInput$strengthCheck(fields.oT),
															$author$project$Ui$Form$PasswordInput$onInput(
															A2($elm$core$Basics$composeL, $author$project$Pages$Join$Token_String$FormUpdated, $author$project$Pages$Join$Token_String$Password)),
															$author$project$Ui$Form$PasswordInput$invalid(
															A2($author$project$Utils$Form$hasValidationErrors, 3, form)),
															$author$project$Ui$Form$PasswordInput$withFeedback(
															$author$project$Utils$Form$validated(form))
														]))
												])) : $author$project$Utils$Html$empty,
											(!existingUser) ? A2(
											$author$project$Ui$Form$Group$view,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Form$Checkbox$view,
													_List_fromArray(
														[
															$author$project$Ui$Form$Checkbox$value(fields.J5),
															$author$project$Ui$Form$Checkbox$required(true),
															$author$project$Ui$Form$Checkbox$onCheck(
															A2($elm$core$Basics$composeL, $author$project$Pages$Join$Token_String$FormUpdated, $author$project$Pages$Join$Token_String$TermsAccepted)),
															$author$project$Ui$Form$Checkbox$errors(
															A2($author$project$Utils$Form$validationErrors, 4, form))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('I agree to this software platform\'s '),
															A3(
															$author$project$Ui$Link$externalHref,
															$author$project$Utils$HintUrls$termsUrl,
															_List_fromArray(
																[$author$project$Ui$Link$targetBlank]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Terms of Service')
																])),
															$elm$html$Html$text('.')
														]))
												])) : $author$project$Utils$Html$empty,
											A2(
											$author$project$Ui$Form$Group$view,
											_List_Nil,
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Button$view,
													{mm: 'Accept invitation'},
													_List_fromArray(
														[
															$author$project$Ui$Button$lg,
															$author$project$Ui$Button$primary,
															$author$project$Ui$Button$fullWidth(true),
															$author$project$Ui$Button$submit,
															$author$project$Ui$Button$loading(
															_Utils_eq(model.k9, $author$project$Api$Data$Loading))
														]),
													_List_fromArray(
														[
															existingUser ? $elm$html$Html$text('Accept Invitation') : $elm$html$Html$text('Sign Up')
														])),
													A2(
													$author$project$Ui$Typography$p,
													_List_fromArray(
														[
															$author$project$Ui$Typography$helpBlock,
															$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('as '),
															$elm$html$Html$text(invitedAs),
															$elm$html$Html$text(' for '),
															$elm$html$Html$text(
															$author$project$Api$Platform$Organization$Shared$name(organization))
														]))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Join$Token_String$viewInvitation = F3(
	function (model, form, invitation) {
		return $author$project$Api$Platform$Invitation$One$accepted(invitation) ? A2(
			$author$project$Ui$Typography$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('It looks like you have already accepted our invitation. Please use your new credentials to access your account '),
					A3(
					$author$project$Ui$Button$view,
					{mm: 'Sign In'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$onClick($author$project$Pages$Join$Token_String$Logout)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('here')
						])),
					$elm$html$Html$text('.')
				])) : A3($author$project$Pages$Join$Token_String$viewAcceptInvitationForm, model, form, invitation);
	});
var $author$project$Pages$Join$Token_String$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				function () {
				var _v0 = _Utils_Tuple2(model.n1, model.SD);
				_v0$2:
				while (true) {
					switch (_v0.a.$) {
						case 3:
							if (!_v0.b.$) {
								var _v1 = _v0.a;
								var invitation = _v1.a;
								var form = _v0.b.a;
								return A3($author$project$Pages$Join$Token_String$viewInvitation, model, form, invitation);
							} else {
								break _v0$2;
							}
						case 2:
							return A2(
								$author$project$Ui$Alert$danger,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('The invitation is invalid or has expired')
									]));
						default:
							break _v0$2;
					}
				}
				return A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$textCenter]),
					_List_fromArray(
						[
							$author$project$Ui$Spinner$view(_List_Nil)
						]));
			}()
			]),
		ac9: 'Login'
	};
};
var $author$project$Pages$Join$Token_String$page = $author$project$Spa$Page$application(
	{ah_: $author$project$Pages$Join$Token_String$init, aiq: $author$project$Pages$Join$Token_String$load, k8: $author$project$Pages$Join$Token_String$save, alO: $author$project$Pages$Join$Token_String$subscriptions, adT: $author$project$Pages$Join$Token_String$update, amo: $author$project$Pages$Join$Token_String$view});
var $author$project$Components$Auth$RequestCode$formFieldsInit = {Rj: ''};
var $author$project$Components$Auth$RequestCode$init = {
	cE: $author$project$Utils$Form$init($author$project$Components$Auth$RequestCode$formFieldsInit)
};
var $author$project$Components$Auth$VerifyCode$formFieldsInit = {NN: ''};
var $author$project$Components$Auth$VerifyCode$init = {
	bV: $author$project$Utils$Form$init($author$project$Components$Auth$VerifyCode$formFieldsInit),
	NO: false,
	mS: 0,
	Rj: $elm$core$Maybe$Nothing,
	RM: $elm$core$Maybe$Nothing,
	_r: false,
	um: $elm$core$Maybe$Nothing,
	uB: false
};
var $author$project$Pages$Login$redirectBasedOnSession = F2(
	function (model, shared) {
		var _v0 = shared.aa4;
		switch (_v0.$) {
			case 3:
				var session = _v0.a;
				return _Utils_Tuple3(
					model,
					A2(
						$author$project$Utils$Route$navigate,
						$elm$core$Dict$empty,
						A2($author$project$Permission$homeStateFor, session, shared.ahK)),
					_List_Nil);
			case 1:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
			default:
				var cmd = shared.ahq.ae6 ? $elm$core$Platform$Cmd$none : $author$project$Ports$Session$authorize(
					{aku: true});
				return _Utils_Tuple3(model, cmd, _List_Nil);
		}
	});
var $author$project$Pages$Login$init = F2(
	function (shared, _v0) {
		var query = _v0.DE;
		var model = {Gv: shared.Gv, ae6: shared.ahq.ae6, Rj: $elm$core$Maybe$Nothing, sF: shared.sF, _r: false, ug: $author$project$Components$Auth$RequestCode$init, um: $elm$core$Maybe$Nothing, fs: $author$project$Components$Auth$VerifyCode$init};
		if (shared.ahq.ae6) {
			return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		} else {
			if (A2($author$project$Api$Data$clientHasTokenExpired, shared.Gv, shared.af3)) {
				var returnUrlCmd = function () {
					var _v1 = A2($elm$core$Dict$get, 'returnUrl', query);
					if (!_v1.$) {
						var returnUrl = _v1.a;
						return $author$project$Ports$Session$persistRedirect(returnUrl);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								returnUrlCmd,
								$author$project$Ports$Session$authorize(
								{aku: true})
							])),
					_List_Nil);
			} else {
				return A2($author$project$Pages$Login$redirectBasedOnSession, model, shared);
			}
		}
	});
var $author$project$Pages$Login$load = F2(
	function (shared, model) {
		return A2($author$project$Pages$Login$redirectBasedOnSession, model, shared);
	});
var $author$project$Pages$Login$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Login$GotRecaptchaToken = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ports$GoogleRecaptcha$gotRecaptchaTokenPort = _Platform_incomingPort(
	'gotRecaptchaTokenPort',
	A2(
		$elm$json$Json$Decode$andThen,
		function (token) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (result) {
					return $elm$json$Json$Decode$succeed(
						{$U: result, adi: token});
				},
				A2($elm$json$Json$Decode$field, 'result', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'token', $elm$json$Json$Decode$string)));
var $author$project$Ports$GoogleRecaptcha$GoogleRecaptchaNotDefined = 0;
var $author$project$Ports$GoogleRecaptcha$GoogleRequestError = 1;
var $author$project$Ports$GoogleRecaptcha$localStorageResultFromPort = F2(
	function (msg, _v0) {
		var token = _v0.adi;
		var result = _v0.$U;
		switch (result) {
			case 'ok':
				return msg(
					$elm$core$Result$Ok(token));
			case 'recaptcha-not-defined':
				return msg(
					$elm$core$Result$Err(0));
			default:
				return msg(
					$elm$core$Result$Err(1));
		}
	});
var $author$project$Ports$GoogleRecaptcha$gotRecaptchaToken = function (msg) {
	return $author$project$Ports$GoogleRecaptcha$gotRecaptchaTokenPort(
		$author$project$Ports$GoogleRecaptcha$localStorageResultFromPort(msg));
};
var $author$project$Pages$Login$subscriptions = function (_v0) {
	return $author$project$Ports$GoogleRecaptcha$gotRecaptchaToken($author$project$Pages$Login$GotRecaptchaToken);
};
var $author$project$OutMsg$BackupAuthCodeValidated = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$Login$GotCodeCreated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ports$GoogleRecaptcha$Login = 1;
var $author$project$Pages$Login$VerifyCodeMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ports$GoogleRecaptcha$actionToString = function (action) {
	if (!action) {
		return 'onboard';
	} else {
		return 'login';
	}
};
var $author$project$Ports$GoogleRecaptcha$getRecaptchaTokenPort = _Platform_outgoingPort('getRecaptchaTokenPort', $elm$json$Json$Encode$string);
var $author$project$Ports$GoogleRecaptcha$getRecaptchaToken = function (action) {
	return $author$project$Ports$GoogleRecaptcha$getRecaptchaTokenPort(
		$author$project$Ports$GoogleRecaptcha$actionToString(action));
};
var $author$project$Api$Auth$authSaltDecoder = A2($elm$json$Json$Decode$field, 'salt', $elm$json$Json$Decode$string);
var $author$project$Api$Auth$requestCode = F4(
	function (client, email, recaptchaToken, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string(email)),
					_Utils_Tuple2(
					'google_recaptcha_token',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, recaptchaToken))
				]));
		return A4(
			$author$project$Api$Data$post,
			$author$project$Api$Data$clientDisableAuth(client),
			$author$project$Api$Auth$authSaltDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['request_code']),
						$author$project$Api$Auth$authPath))));
	});
var $author$project$Components$Auth$RequestCode$EmailSubmitted = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Auth$RequestCode$NoEvent = {$: 0};
var $author$project$Components$Auth$RequestCode$formFieldsUpdate = F2(
	function (field, form) {
		var email = field;
		return _Utils_update(
			form,
			{Rj: email});
	});
var $author$project$Components$Auth$RequestCode$EmailValidation = 0;
var $author$project$Utils$String$strip = function (string) {
	return A3($elm$core$String$replace, ' ', '', string);
};
var $author$project$Components$Auth$RequestCode$validateEmail = function (_v0) {
	var email = _v0.Rj;
	var emailText = $author$project$Utils$String$strip(email);
	return ((!$rtfeldman$elm_validate$Validate$isBlank(emailText)) && (!$rtfeldman$elm_validate$Validate$isValidEmail(emailText))) ? _List_fromArray(
		[
			_Utils_Tuple2(0, 'Please enter a valid email.')
		]) : _List_Nil;
};
var $author$project$Components$Auth$RequestCode$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Auth$RequestCode$validateEmail)
		]));
var $author$project$Components$Auth$RequestCode$validateForm = function (model) {
	var _v0 = A2($author$project$Utils$Form$validate, $author$project$Components$Auth$RequestCode$formFieldsValidator, model.cE);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var form = _v1.a;
		return _Utils_Tuple2(form, true);
	} else {
		var form = _v0.a;
		return _Utils_Tuple2(form, false);
	}
};
var $author$project$Components$Auth$RequestCode$validate = function (model) {
	return _Utils_update(
		model,
		{
			cE: $author$project$Components$Auth$RequestCode$validateForm(model).a
		});
};
var $author$project$Components$Auth$RequestCode$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 2:
				var field = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cE: A3($author$project$Utils$Form$update, $author$project$Components$Auth$RequestCode$formFieldsUpdate, field, model.cE)
						}),
					$author$project$Components$Auth$RequestCode$NoEvent);
			case 0:
				var _v1 = $author$project$Components$Auth$RequestCode$validateForm(model);
				var newForm = _v1.a;
				var isFormValid = _v1.b;
				var newModel = _Utils_update(
					model,
					{cE: newForm});
				if (isFormValid) {
					var _v2 = $author$project$Utils$Form$fields(model.cE);
					var email = _v2.Rj;
					return _Utils_Tuple2(
						newModel,
						$author$project$Components$Auth$RequestCode$EmailSubmitted(email));
				} else {
					return _Utils_Tuple2(newModel, $author$project$Components$Auth$RequestCode$NoEvent);
				}
			default:
				return _Utils_Tuple2(
					$author$project$Components$Auth$RequestCode$validate(model),
					$author$project$Components$Auth$RequestCode$NoEvent);
		}
	});
var $author$project$Components$Auth$VerifyCode$JWT = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Auth$VerifyCode$NoEvent = {$: 0};
var $author$project$Components$Auth$VerifyCode$ResendCode = {$: 1};
var $author$project$Components$Auth$VerifyCode$ResponseError = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Auth$VerifyCode$formFieldsUpdate = F2(
	function (field, form) {
		var code = field;
		return _Utils_update(
			form,
			{NN: code});
	});
var $author$project$Components$Auth$VerifyCode$CodeValidation = 0;
var $rtfeldman$elm_validate$Validate$isInt = function (str) {
	var _v0 = $elm$core$String$toInt(str);
	if (_v0.$ === 1) {
		return false;
	} else {
		return true;
	}
};
var $author$project$Components$Auth$VerifyCode$validateCode = function (_v0) {
	var code = _v0.NN;
	return ((!$rtfeldman$elm_validate$Validate$isInt(code)) || ($elm$core$String$length(code) !== 6)) ? _List_fromArray(
		[
			_Utils_Tuple2(0, 'Code format is not valid.')
		]) : _List_Nil;
};
var $author$project$Components$Auth$VerifyCode$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Auth$VerifyCode$validateCode)
		]));
var $author$project$Components$Auth$VerifyCode$validateForm = function (model) {
	var _v0 = A2($author$project$Utils$Form$validate, $author$project$Components$Auth$VerifyCode$formFieldsValidator, model.bV);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var form = _v1.a;
		return _Utils_Tuple2(form, true);
	} else {
		var form = _v0.a;
		return _Utils_Tuple2(form, false);
	}
};
var $author$project$Components$Auth$VerifyCode$validate = function (model) {
	return _Utils_update(
		model,
		{
			bV: $author$project$Components$Auth$VerifyCode$validateForm(model).a
		});
};
var $author$project$Components$Auth$VerifyCode$GotCodeValidated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Auth$verifyCode = F5(
	function (client, email, salt, code, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string(email)),
					_Utils_Tuple2(
					'code',
					$elm$json$Json$Encode$string(code)),
					_Utils_Tuple2(
					'salt',
					$elm$json$Json$Encode$string(salt))
				]));
		return A4(
			$author$project$Api$Data$post,
			$author$project$Api$Data$clientDisableAuth(client),
			$author$project$Api$Auth$authTokenDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Auth$authPath)));
	});
var $author$project$Components$Auth$VerifyCode$verifyCode = F4(
	function (apiClient, maybeEmail, maybeSalt, code) {
		var _v0 = _Utils_Tuple2(maybeEmail, maybeSalt);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var email = _v0.a.a;
			var salt = _v0.b.a;
			return A5($author$project$Api$Auth$verifyCode, apiClient, email, salt, code, $author$project$Components$Auth$VerifyCode$GotCodeValidated);
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Components$Auth$VerifyCode$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 2:
				var field = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bV: A3($author$project$Utils$Form$update, $author$project$Components$Auth$VerifyCode$formFieldsUpdate, field, model.bV)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Auth$VerifyCode$NoEvent);
			case 0:
				var _v1 = A2($author$project$Utils$Form$validate, $author$project$Components$Auth$VerifyCode$formFieldsValidator, model.bV);
				if (!_v1.$) {
					var _v2 = _v1.a;
					var newForm = _v2.a;
					var _v3 = $author$project$Utils$Form$fields(model.bV);
					var code = _v3.NN;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bV: newForm, mS: model.mS + 1, RM: $elm$core$Maybe$Nothing, _r: true, uB: false}),
						A4($author$project$Components$Auth$VerifyCode$verifyCode, apiClient, model.Rj, model.um, code),
						$author$project$Components$Auth$VerifyCode$NoEvent);
				} else {
					var newForm = _v1.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bV: newForm}),
						$elm$core$Platform$Cmd$none,
						$author$project$Components$Auth$VerifyCode$NoEvent);
				}
			case 1:
				return _Utils_Tuple3(
					$author$project$Components$Auth$VerifyCode$validate(model),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Auth$VerifyCode$NoEvent);
			case 3:
				return model._r ? _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Components$Auth$VerifyCode$NoEvent) : _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bV: $author$project$Utils$Form$init($author$project$Components$Auth$VerifyCode$formFieldsInit),
							mS: 0,
							RM: $elm$core$Maybe$Nothing,
							uB: true
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Auth$VerifyCode$ResendCode);
			default:
				var response = msg.a;
				_v4$2:
				while (true) {
					switch (response.$) {
						case 3:
							var token = response.a;
							return _Utils_Tuple3(
								model,
								$elm$core$Platform$Cmd$none,
								$author$project$Components$Auth$VerifyCode$JWT(token));
						case 2:
							if (response.a.$ === 6) {
								var _v5 = response.a;
								var errorMessage = _v5.b;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											RM: $elm$core$Maybe$Just(errorMessage),
											_r: false
										}),
									$elm$core$Platform$Cmd$none,
									$author$project$Components$Auth$VerifyCode$NoEvent);
							} else {
								break _v4$2;
							}
						default:
							break _v4$2;
					}
				}
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{_r: false}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Auth$VerifyCode$ResponseError(response));
		}
	});
var $author$project$Components$Auth$VerifyCode$withEmail = F2(
	function (email, model) {
		return _Utils_update(
			model,
			{
				Rj: $elm$core$Maybe$Just(email)
			});
	});
var $author$project$Components$Auth$VerifyCode$withSalt = F2(
	function (salt, model) {
		return _Utils_update(
			model,
			{
				um: $elm$core$Maybe$Just(salt)
			});
	});
var $author$project$Pages$Login$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var requestCodeMsg = msg.a;
				var _v1 = A2($author$project$Components$Auth$RequestCode$update, requestCodeMsg, model.ug);
				var requestCodeModel = _v1.a;
				var event = _v1.b;
				var newModel = _Utils_update(
					model,
					{ug: requestCodeModel});
				if (!event.$) {
					return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, _List_Nil);
				} else {
					var newEmail = event.a;
					return _Utils_Tuple3(
						_Utils_update(
							newModel,
							{
								Rj: $elm$core$Maybe$Just(newEmail),
								_r: true,
								fs: A2($author$project$Components$Auth$VerifyCode$withEmail, newEmail, model.fs)
							}),
						$author$project$Ports$GoogleRecaptcha$getRecaptchaToken(1),
						_List_Nil);
				}
			case 1:
				var verifyCodeMsg = msg.a;
				var _v3 = A3($author$project$Components$Auth$VerifyCode$update, model.Gv, verifyCodeMsg, model.fs);
				var verifyCodeModel = _v3.a;
				var verifyCmd = _v3.b;
				var event = _v3.c;
				var newModel = _Utils_update(
					model,
					{fs: verifyCodeModel});
				switch (event.$) {
					case 1:
						return _Utils_Tuple3(
							newModel,
							$author$project$Ports$GoogleRecaptcha$getRecaptchaToken(1),
							_List_Nil);
					case 3:
						var response = event.a;
						return _Utils_Tuple3(
							newModel,
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Login$VerifyCodeMsg, verifyCmd),
							$author$project$OutMsg$handleErrorResponse(response));
					case 2:
						var token = event.a;
						return _Utils_Tuple3(
							newModel,
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Login$VerifyCodeMsg, verifyCmd),
							_List_fromArray(
								[
									$author$project$OutMsg$BackupAuthCodeValidated(token)
								]));
					default:
						return _Utils_Tuple3(
							newModel,
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Login$VerifyCodeMsg, verifyCmd),
							_List_Nil);
				}
			case 2:
				var result = msg.a;
				var recaptchaToken = $elm$core$Result$toMaybe(result);
				var email = A2($elm$core$Maybe$withDefault, '', model.Rj);
				return _Utils_Tuple3(
					model,
					A4($author$project$Api$Auth$requestCode, model.Gv, email, recaptchaToken, $author$project$Pages$Login$GotCodeCreated),
					_List_Nil);
			default:
				var authData = msg.a;
				var newModel = _Utils_update(
					model,
					{_r: false});
				_v5$2:
				while (true) {
					switch (authData.$) {
						case 3:
							var salt = authData.a;
							return _Utils_Tuple3(
								_Utils_update(
									newModel,
									{
										um: $elm$core$Maybe$Just(salt),
										fs: A2($author$project$Components$Auth$VerifyCode$withSalt, salt, model.fs)
									}),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
						case 2:
							if (authData.a.$ === 9) {
								return _Utils_Tuple3(newModel, $elm$browser$Browser$Navigation$reload, _List_Nil);
							} else {
								break _v5$2;
							}
						default:
							break _v5$2;
					}
				}
				return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Ui$Image$HintFullLogo = 12;
var $author$project$Pages$Login$RequestCodeMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Login$canShowVerifyCode = F2(
	function (maybeEmail, maybeSalt) {
		return !($author$project$Utils$Maybe$isNothing(maybeEmail) || $author$project$Utils$Maybe$isNothing(maybeSalt));
	});
var $author$project$Components$Auth$RequestCode$EmailBlurred = {$: 1};
var $author$project$Components$Auth$RequestCode$EmailField = $elm$core$Basics$identity;
var $author$project$Components$Auth$RequestCode$FormUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Auth$RequestCode$SubmitForm = {$: 0};
var $author$project$Components$Auth$RequestCode$isSubmitDisabled = F3(
	function (email, formHasValidationErrors, processingAction) {
		return $author$project$Utils$String$isBlank(email) || (formHasValidationErrors || processingAction);
	});
var $author$project$Ui$Form$Group$LabelAbove = {$: 9};
var $author$project$Ui$Form$Group$labelAbove = $author$project$Ui$Form$Group$LabelAbove;
var $author$project$Utils$HintUrls$statusPageUrl = 'https://status.hint.com/';
var $author$project$Components$BackupAuthAlert$viewAlertText = _List_fromArray(
	[
		$elm$html$Html$text('Our main sign in system is currently down. Please save your work frequently as you will be signed out automatically when the main system comes back online.'),
		A2($elm$html$Html$br, _List_Nil, _List_Nil),
		$elm$html$Html$text('Thank you for your patience.'),
		$author$project$Utils$Html$noBreakSpace,
		A3(
		$author$project$Ui$Link$externalHref,
		$author$project$Utils$HintUrls$statusPageUrl,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('See status page for real-time updates.')
			]))
	]);
var $author$project$Components$Auth$RequestCode$viewBackupAuthAlert = A2(
	$author$project$Ui$Alert$warning,
	_List_fromArray(
		[
			$author$project$Ui$Alert$icon(67),
			$author$project$Ui$Alert$alignment($author$project$Ui$Alignment$textLeft)
		]),
	$author$project$Components$BackupAuthAlert$viewAlertText);
var $author$project$Components$Auth$RequestCode$viewForm = F2(
	function (model, processingAction) {
		var formHasValidationErrors = A2($author$project$Utils$Form$hasValidationErrors, 0, model.cE);
		var _v0 = $author$project$Utils$Form$fields(model.cE);
		var email = _v0.Rj;
		return A2(
			$elm$html$Html$form,
			_List_fromArray(
				[
					$elm$html$Html$Events$onSubmit($author$project$Components$Auth$RequestCode$SubmitForm)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Components$Auth$RequestCode$viewBackupAuthAlert,
									A2($elm$html$Html$br, _List_Nil, _List_Nil)
								]))
						])),
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$label('Your email'),
											$author$project$Ui$Form$Group$required(true),
											$author$project$Ui$Form$Group$labelAbove
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$placeholder('e.g. name@example.com'),
													$author$project$Ui$Form$Input$onInput(
													A2($elm$core$Basics$composeL, $author$project$Components$Auth$RequestCode$FormUpdated, $elm$core$Basics$identity)),
													$author$project$Ui$Form$Input$invalid(formHasValidationErrors),
													$author$project$Ui$Form$Input$value(email),
													$author$project$Ui$Form$Input$email,
													$author$project$Ui$Form$Input$onBlur($author$project$Components$Auth$RequestCode$EmailBlurred)
												])),
											$author$project$Utils$FormErrors$view(
											A2($author$project$Utils$Form$validationErrors, 0, model.cE))
										])),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Send authentication code'},
									_List_fromArray(
										[
											$author$project$Ui$Button$primary,
											$author$project$Ui$Button$fullWidth(true),
											$author$project$Ui$Button$disabled(
											A3($author$project$Components$Auth$RequestCode$isSubmitDisabled, email, formHasValidationErrors, processingAction)),
											$author$project$Ui$Button$submit,
											$author$project$Ui$Button$loading(processingAction)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Send code')
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Auth$RequestCode$viewTermsText = A2(
	$author$project$Ui$Typography$span,
	_List_fromArray(
		[
			$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
		]),
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Typography$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('I agree with the ')
				])),
			A3(
			$author$project$Ui$Link$externalHref,
			$author$project$Utils$HintUrls$termsUrl,
			_List_fromArray(
				[$author$project$Ui$Link$targetBlank]),
			_List_fromArray(
				[
					$elm$html$Html$text('Terms')
				]))
		]));
var $author$project$Components$Auth$RequestCode$view = F2(
	function (model, processingAction) {
		return A2(
			$author$project$Ui$Panel$view,
			_List_fromArray(
				[$author$project$Ui$Panel$extraPadding]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$row,
							_List_fromArray(
								[$author$project$Ui$Grid$mt4]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Ui$Typography$heading(
											_List_fromArray(
												[
													$elm$html$Html$text('Sign in with email')
												])),
											A2($elm$html$Html$br, _List_Nil, _List_Nil),
											A2($author$project$Components$Auth$RequestCode$viewForm, model, processingAction),
											A2($elm$html$Html$br, _List_Nil, _List_Nil),
											$author$project$Components$Auth$RequestCode$viewTermsText
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Auth$VerifyCode$CodeBlurred = {$: 1};
var $author$project$Components$Auth$VerifyCode$CodeField = $elm$core$Basics$identity;
var $author$project$Components$Auth$VerifyCode$FormUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Auth$VerifyCode$ResendCodeMsg = {$: 3};
var $author$project$Components$Auth$VerifyCode$SubmitForm = {$: 0};
var $author$project$Components$Auth$VerifyCode$codeExhausted = function (codeSubmitAttempts) {
	return codeSubmitAttempts >= 3;
};
var $author$project$Components$Auth$VerifyCode$isSubmitDisabled = F3(
	function (hasValidationErros, processing, codeSubmitAttempts) {
		return hasValidationErros || (processing || $author$project$Components$Auth$VerifyCode$codeExhausted(codeSubmitAttempts));
	});
var $author$project$Components$Auth$VerifyCode$viewCodeError = function (errorMessage) {
	if (!errorMessage.$) {
		var message = errorMessage.a;
		return A2(
			$author$project$Ui$Alert$danger,
			_List_fromArray(
				[
					$author$project$Ui$Alert$icon(68),
					$author$project$Ui$Alert$alignment($author$project$Ui$Alignment$textLeft)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(message)
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Auth$VerifyCode$viewCodeResendMessage = function () {
	var supportEmail = 'support@hint.com';
	var infoText = '\n            If we have an account matching your email address, you will receive\n            an email with a code. If you do not receive an email, please contact\n            us at\n            ';
	return A2(
		$author$project$Ui$Alert$info,
		_List_fromArray(
			[
				$author$project$Ui$Alert$icon(5),
				$author$project$Ui$Alert$alignment($author$project$Ui$Alignment$textLeft)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$strong,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Code has been resent')
					])),
				A2(
				$author$project$Ui$Typography$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(infoText)
					])),
				A3(
				$author$project$Ui$Link$mailto,
				supportEmail,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(supportEmail)
					]))
			]));
}();
var $author$project$Components$Auth$VerifyCode$viewEmailSentText = function (email) {
	return A2(
		$author$project$Ui$Typography$p,
		_List_fromArray(
			[
				$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('An email with a code has been sent to ' + (email + '. Please enter the code within 15 minutes.'))
			]));
};
var $author$project$Components$Auth$VerifyCode$viewForm = F6(
	function (email, processing, showCodeResend, codeForm, errorMessage, codeSubmitAttempts) {
		var hasValidationErrors = A2($author$project$Utils$Form$hasValidationErrors, 0, codeForm);
		var _v0 = $author$project$Utils$Form$fields(codeForm);
		var code = _v0.NN;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Components$Auth$VerifyCode$viewEmailSentText(email),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textCenter]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{mm: 'Resend verification code'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick($author$project$Components$Auth$VerifyCode$ResendCodeMsg),
													$author$project$Ui$Button$disabled(processing)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Resend code')
												]))
										])),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									showCodeResend ? $author$project$Components$Auth$VerifyCode$viewCodeResendMessage : $author$project$Utils$Html$empty,
									$author$project$Components$Auth$VerifyCode$viewCodeError(errorMessage)
								]))
						])),
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$label('Your code'),
											$author$project$Ui$Form$Group$required(true),
											$author$project$Ui$Form$Group$labelAbove
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$placeholder('e.g. 123456'),
													$author$project$Ui$Form$Input$onInput(
													A2($elm$core$Basics$composeL, $author$project$Components$Auth$VerifyCode$FormUpdated, $elm$core$Basics$identity)),
													$author$project$Ui$Form$Input$invalid(hasValidationErrors),
													$author$project$Ui$Form$Input$value(code),
													$author$project$Ui$Form$Input$onBlur($author$project$Components$Auth$VerifyCode$CodeBlurred)
												])),
											$author$project$Utils$FormErrors$view(
											A2($author$project$Utils$Form$validationErrors, 0, codeForm))
										])),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Sign in'},
									_List_fromArray(
										[
											$author$project$Ui$Button$primary,
											$author$project$Ui$Button$fullWidth(true),
											$author$project$Ui$Button$disabled(
											A3($author$project$Components$Auth$VerifyCode$isSubmitDisabled, hasValidationErrors, processing, codeSubmitAttempts)),
											$author$project$Ui$Button$onClick($author$project$Components$Auth$VerifyCode$SubmitForm),
											$author$project$Ui$Button$loading(processing)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Sign In')
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Auth$VerifyCode$viewTermsText = A2(
	$author$project$Ui$Typography$span,
	_List_fromArray(
		[
			$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
		]),
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Typography$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('I agree with the ')
				])),
			A3(
			$author$project$Ui$Link$externalHref,
			$author$project$Utils$HintUrls$termsUrl,
			_List_fromArray(
				[$author$project$Ui$Link$targetBlank]),
			_List_fromArray(
				[
					$elm$html$Html$text('Terms')
				]))
		]));
var $author$project$Components$Auth$VerifyCode$view = function (model) {
	var _v0 = _Utils_Tuple2(model.Rj, model.um);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var email = _v0.a.a;
		return A2(
			$author$project$Ui$Panel$view,
			_List_fromArray(
				[$author$project$Ui$Panel$extraPadding]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$row,
							_List_fromArray(
								[$author$project$Ui$Grid$mt4]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Ui$Typography$heading(
											_List_fromArray(
												[
													$elm$html$Html$text('Enter your code')
												])),
											A2($elm$html$Html$br, _List_Nil, _List_Nil),
											A6($author$project$Components$Auth$VerifyCode$viewForm, email, model._r, model.uB, model.bV, model.RM, model.mS),
											A2($elm$html$Html$br, _List_Nil, _List_Nil),
											$author$project$Components$Auth$VerifyCode$viewTermsText
										]))
								]))
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Login$viewComponents = F5(
	function (maybeEmail, maybeSalt, processingAction, requestCodeModel, verifyCodeModel) {
		return A2($author$project$Pages$Login$canShowVerifyCode, maybeEmail, maybeSalt) ? A2(
			$elm$html$Html$map,
			$author$project$Pages$Login$VerifyCodeMsg,
			$author$project$Components$Auth$VerifyCode$view(verifyCodeModel)) : A2(
			$elm$html$Html$map,
			$author$project$Pages$Login$RequestCodeMsg,
			A2($author$project$Components$Auth$RequestCode$view, requestCodeModel, processingAction));
	});
var $author$project$Ui$Link$CurrentColor = {$: 16};
var $author$project$Ui$Link$currentColor = $author$project$Ui$Link$CurrentColor;
var $author$project$Pages$Login$viewReCaptcha = A2(
	$author$project$Ui$Typography$p,
	_List_fromArray(
		[
			$author$project$Ui$Typography$muted,
			$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
		]),
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Typography$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('This site is protected by reCAPTCHA and the Google ')
				])),
			A2(
			$author$project$Ui$Typography$span,
			_List_Nil,
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Link$externalHref,
					'https://policies.google.com/privacy',
					_List_fromArray(
						[$author$project$Ui$Link$targetBlank, $author$project$Ui$Link$currentColor]),
					_List_fromArray(
						[
							$elm$html$Html$text('Privacy Policy')
						]))
				])),
			A2(
			$author$project$Ui$Typography$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(' and ')
				])),
			A2(
			$author$project$Ui$Typography$span,
			_List_fromArray(
				[
					$author$project$Ui$Typography$attrs(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('inline-block')
						]))
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Link$externalHref,
					'https://policies.google.com/terms',
					_List_fromArray(
						[$author$project$Ui$Link$targetBlank, $author$project$Ui$Link$currentColor]),
					_List_fromArray(
						[
							$elm$html$Html$text('Terms of Service')
						]))
				]))
		]));
var $author$project$Pages$Login$viewBody = function (model) {
	return model.ae6 ? A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(6),
								$author$project$Ui$Grid$offset(3)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$row,
								_List_fromArray(
									[$author$project$Ui$Grid$mb4]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[$author$project$Ui$Grid$textCenter]),
										_List_fromArray(
											[
												A4(
												$author$project$Ui$Image$view,
												model.sF,
												{LD: 'Hint Logo'},
												_List_fromArray(
													[
														$author$project$Ui$Image$height(55)
													]),
												12)
											]))
									])),
								A2(
								$author$project$Ui$Grid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_Nil,
										_List_fromArray(
											[
												A5($author$project$Pages$Login$viewComponents, model.Rj, model.um, model._r, model.ug, model.fs)
											]))
									])),
								A2(
								$author$project$Ui$Grid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_Nil,
										_List_fromArray(
											[
												A2($elm$html$Html$br, _List_Nil, _List_Nil),
												$author$project$Pages$Login$viewReCaptcha
											]))
									]))
							]))
					]))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Pages$Login$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				$author$project$Pages$Login$viewBody(model)
			]),
		ac9: 'Login'
	};
};
var $author$project$Pages$Login$page = $author$project$Spa$Page$application(
	{ah_: $author$project$Pages$Login$init, aiq: $author$project$Pages$Login$load, k8: $author$project$Pages$Login$save, alO: $author$project$Pages$Login$subscriptions, adT: $author$project$Pages$Login$update, amo: $author$project$Pages$Login$view});
var $author$project$Spa$Page$element = function (page) {
	return {
		ah_: F2(
			function (_v0, params) {
				var _v1 = page.ah_(params);
				var model = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple3(model, cmd, _List_Nil);
			}),
		aiq: $elm$core$Basics$always($author$project$Spa$Page$ignoreEffect),
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: page.alO,
		adT: F2(
			function (msg, model) {
				var _v2 = A2(page.adT, msg, model);
				var newModel = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple3(newModel, cmd, _List_Nil);
			}),
		amo: page.amo
	};
};
var $author$project$Pages$Logout$init = function (_v0) {
	return _Utils_Tuple2(
		{},
		$author$project$Ports$Session$logout(
			{aku: true}));
};
var $author$project$Pages$Logout$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Logout$update = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Logout$view = function (_v0) {
	return {fO: $author$project$Components$LoadingPage$view, ac9: 'Logout'};
};
var $author$project$Pages$Logout$page = $author$project$Spa$Page$element(
	{ah_: $author$project$Pages$Logout$init, alO: $author$project$Pages$Logout$subscriptions, adT: $author$project$Pages$Logout$update, amo: $author$project$Pages$Logout$view});
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GotAthena = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$Initial = 0;
var $author$project$Api$Provider$Integration$Athena$athenaPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['athena_configuration']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$AthenaConfiguration$One$AthenaConfiguration = $elm$core$Basics$identity;
var $author$project$Api$Provider$AthenaConfiguration$Shared$AthenaConfiguration = $elm$core$Basics$identity;
var $author$project$Api$Provider$AthenaConfiguration$Shared$Record = F8(
	function (status, allowNewPatientCreation, athenaPracticeName, athenaPracticeId, athenaProviderGroupId, scopedByProviderGroup, setupSubstate, ignoredFields) {
		return {Lx: allowNewPatientCreation, L3: athenaPracticeId, L4: athenaPracticeName, L5: athenaProviderGroupId, TO: ignoredFields, aaA: scopedByProviderGroup, aa7: setupSubstate, alH: status};
	});
var $author$project$Api$Provider$AthenaConfiguration$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'ignored_fields',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'setup_substate',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'scoped_by_provider_group',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'athena_provider_group_id',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'athena_practice_id',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'athena_practice_name',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'allow_new_patient_creation',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'status',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Api$Provider$AthenaConfiguration$Shared$Record)))))))));
var $author$project$Api$Provider$AthenaConfiguration$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$AthenaConfiguration$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$AthenaConfiguration$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$AthenaConfiguration$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Integration$Athena$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$AthenaConfiguration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Athena$athenaPath));
	});
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$init = F4(
	function (_v0, _v1, shared, _v2) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, A: $author$project$Api$Data$Loading, is: $author$project$Api$Data$NotAsked, it: $author$project$Api$Data$NotAsked, cl: _List_Nil, fI: $author$project$Api$Data$NotAsked, iu: $author$project$Api$Data$NotAsked, iv: $author$project$Api$Data$NotAsked, my: $author$project$Api$Data$NotAsked, mz: false, m0: $author$project$Api$Data$NotAsked, eq: $elm$core$Maybe$Nothing, jz: $elm$core$Set$empty, jA: $elm$core$Set$empty, SD: $elm$core$Maybe$Nothing, sF: shared.sF, ol: $elm$core$Maybe$Nothing, om: $elm$core$Maybe$Nothing, on: $elm$core$Maybe$Nothing, k9: $author$project$Api$Data$NotAsked, lm: false, acf: 0},
			A2($author$project$Api$Provider$Integration$Athena$retrieve, shared.Gv, $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GotAthena));
	});
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$CloseBulkSyncModal = {$: 41};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$DisableConfirmed = function (a) {
	return {$: 46, a: a};
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Marketplace$Athenahealth$Manage$Settings$DisableConfirmed)),
					model.eq)),
				model.lm ? $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Pages$Marketplace$Athenahealth$Manage$Settings$CloseBulkSyncModal) : $elm$core$Platform$Sub$none
			]));
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$Activated = function (a) {
	return {$: 37, a: a};
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$BulkSynced = function (a) {
	return {$: 44, a: a};
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$Completed = function (a) {
	return {$: 31, a: a};
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$Created = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$Disabled = function (a) {
	return {$: 47, a: a};
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$FieldMappingsUpdated = function (a) {
	return {$: 22, a: a};
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$FieldsStep = 3;
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GotAthenaConfigured = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GotAthenaCustomFields = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GotAthenaDepartments = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GotAthenaFieldMappings = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GotAthenaLocationMappings = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GotAthenaProviderMappings = function (a) {
	return {$: 25, a: a};
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GotAthenaProviders = function (a) {
	return {$: 24, a: a};
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GotLocationMapping = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GotOverviewFieldMappings = function (a) {
	return {$: 34, a: a};
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GotOverviewLocationMappings = function (a) {
	return {$: 33, a: a};
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GotOverviewProviderMappings = function (a) {
	return {$: 35, a: a};
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GotProviderMapping = function (a) {
	return {$: 29, a: a};
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$LinkStep = 1;
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$LocationsStep = 2;
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$OverviewStep = 5;
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$ProvidersStep = 4;
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$Updated = function (a) {
	return {$: 39, a: a};
};
var $author$project$Api$Provider$Integration$Athena$activate = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$AthenaConfiguration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['activate']),
					$author$project$Api$Provider$Integration$Athena$athenaPath)));
	});
var $author$project$Api$Provider$Integration$Athena$bulkSyncPatients = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'unlinked_only',
					$elm$json$Json$Encode$bool(fields.amj))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['bulk_sync_patients']),
						$author$project$Api$Provider$Integration$Athena$athenaPath))));
	});
var $author$project$Api$Provider$Integration$Athena$complete = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$AthenaConfiguration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['complete']),
					$author$project$Api$Provider$Integration$Athena$athenaPath)));
	});
var $author$project$Api$Provider$Integration$Athena$configure = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$AthenaConfiguration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['configure']),
					$author$project$Api$Provider$Integration$Athena$athenaPath)));
	});
var $author$project$Api$Provider$Integration$Athena$create = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$AthenaConfiguration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Athena$athenaPath));
	});
var $author$project$Api$Provider$Integration$Athena$delete = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Athena$athenaPath));
	});
var $author$project$Api$Provider$Integration$Athena$FieldMapping$Shared$externalId = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Provider$Integration$Athena$FieldMapping$All$externalId = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Integration$Athena$FieldMapping$Shared$externalId(shared);
};
var $author$project$Api$Provider$Integration$Athena$LocationMapping$Shared$externalId = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Provider$Integration$Athena$LocationMapping$All$externalId = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Integration$Athena$LocationMapping$Shared$externalId(shared);
};
var $author$project$Api$Provider$Integration$Athena$ProviderMapping$Shared$externalId = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Provider$Integration$Athena$ProviderMapping$All$externalId = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Integration$Athena$ProviderMapping$Shared$externalId(shared);
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$formFieldsInit = {L3: $elm$core$Maybe$Nothing, L5: $elm$core$Maybe$Nothing};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var string = field.a;
			return _Utils_update(
				fields,
				{
					L3: $elm$core$String$toInt(string)
				});
		} else {
			var string = field.a;
			return _Utils_update(
				fields,
				{
					L5: $elm$core$String$toInt(string)
				});
		}
	});
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$AthenaPracticeIdValidation = 0;
var $author$project$Api$Provider$AthenaConfiguration$Shared$scopedByProviderGroup = function (_v0) {
	var record = _v0;
	return record.aaA;
};
var $author$project$Api$Provider$AthenaConfiguration$One$scopedByProviderGroup = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$AthenaConfiguration$Shared$scopedByProviderGroup(shared);
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$AthenaProviderGroupIdValidation = 1;
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$validateProviderGroupId = F2(
	function (isRequired, _v0) {
		var athenaProviderGroupId = _v0.L5;
		return (isRequired && (!$author$project$Utils$Maybe$toBool(athenaProviderGroupId))) ? _List_fromArray(
			[
				_Utils_Tuple2(1, 'Please enter a provider group id')
			]) : _List_Nil;
	});
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$formFieldsValidator = function (model) {
	var providerGroupRequired = function () {
		var _v0 = model.A;
		if (_v0.$ === 3) {
			var config = _v0.a;
			return $author$project$Api$Provider$AthenaConfiguration$One$scopedByProviderGroup(config);
		} else {
			return false;
		}
	}();
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_validate$Validate$ifNothing,
				function ($) {
					return $.L3;
				},
				_Utils_Tuple2(0, 'Please enter a practice id')),
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$validateProviderGroupId(providerGroupRequired))
			]));
};
var $author$project$Api$Provider$Integration$Athena$FieldMapping$Shared$humanName = function (_v0) {
	var record = _v0;
	return record.TG;
};
var $author$project$Api$Provider$Integration$Athena$FieldMapping$All$humanName = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Integration$Athena$FieldMapping$Shared$humanName(shared);
};
var $author$project$Api$Provider$Integration$Athena$FieldMapping$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Integration$Athena$FieldMapping$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Integration$Athena$FieldMapping$Shared$id(shared);
};
var $author$project$Api$Provider$Integration$Athena$LocationMapping$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Integration$Athena$LocationMapping$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Integration$Athena$LocationMapping$Shared$id(shared);
};
var $author$project$Api$Provider$Integration$Athena$ProviderMapping$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Integration$Athena$ProviderMapping$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Integration$Athena$ProviderMapping$Shared$id(shared);
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$Linked = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$Integration$Athena$link = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'athena_integration',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'athena_practice_id',
								$elm$json$Json$Encode$int(fields.L3)),
								_Utils_Tuple2(
								'athena_provider_group_id',
								$elm$json$Json$Encode$int(fields.L5))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$AthenaConfiguration$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['link']),
						$author$project$Api$Provider$Integration$Athena$athenaPath))));
	});
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$linkAthena = F2(
	function (apiClient, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A3(
			$author$project$Api$Provider$Integration$Athena$link,
			apiClient,
			{
				L3: A2($elm$core$Maybe$withDefault, 0, fields.L3),
				L5: A2($elm$core$Maybe$withDefault, 0, fields.L5)
			},
			$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$Linked);
	});
var $author$project$Api$Provider$Integration$Athena$CustomField$customFieldsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['custom_fields']),
	$author$project$Api$Provider$Integration$Athena$athenaPath);
var $author$project$Api$Provider$Integration$Athena$CustomField$All$CustomField = $elm$core$Basics$identity;
var $author$project$Api$Provider$Integration$Athena$CustomField$Shared$CustomField = $elm$core$Basics$identity;
var $author$project$Api$Provider$Integration$Athena$CustomField$Shared$Record = F2(
	function (externalId, name) {
		return {ag7: externalId, Bq: name};
	});
var $author$project$Api$Provider$Integration$Athena$CustomField$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'external_id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Integration$Athena$CustomField$Shared$Record)));
var $author$project$Api$Provider$Integration$Athena$CustomField$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Integration$Athena$CustomField$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Integration$Athena$CustomField$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Integration$Athena$CustomField$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Integration$Athena$CustomField$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Integration$Athena$CustomField$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Athena$CustomField$customFieldsPath));
	});
var $author$project$Api$Provider$Integration$Athena$Department$All$Department = $elm$core$Basics$identity;
var $author$project$Api$Provider$Integration$Athena$Department$Shared$Department = $elm$core$Basics$identity;
var $author$project$Api$Provider$Integration$Athena$Department$Shared$Record = F3(
	function (id, name, providerGroup) {
		return {ahP: id, Bq: name, _E: providerGroup};
	});
var $author$project$Api$Provider$Integration$Athena$Department$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'provider_group',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Integration$Athena$Department$Shared$Record))));
var $author$project$Api$Provider$Integration$Athena$Department$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Integration$Athena$Department$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Integration$Athena$Department$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Integration$Athena$Department$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Integration$Athena$Department$departmentsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['departments']),
	$author$project$Api$Provider$Integration$Athena$athenaPath);
var $author$project$Api$Provider$Integration$Athena$Department$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Integration$Athena$Department$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Athena$Department$departmentsPath));
	});
var $author$project$Api$Provider$Integration$Athena$FieldMapping$All$FieldMapping = $elm$core$Basics$identity;
var $author$project$Api$Provider$Integration$Athena$FieldMapping$Shared$FieldMapping = $elm$core$Basics$identity;
var $author$project$Api$Provider$Integration$Athena$FieldMapping$Shared$Record = F3(
	function (id, humanName, externalId) {
		return {ag7: externalId, TG: humanName, ahP: id};
	});
var $author$project$Api$Provider$Integration$Athena$FieldMapping$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'external_id',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'human_name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Integration$Athena$FieldMapping$Shared$Record))));
var $author$project$Api$Provider$Integration$Athena$FieldMapping$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Integration$Athena$FieldMapping$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Integration$Athena$FieldMapping$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Integration$Athena$FieldMapping$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Integration$Athena$FieldMapping$fieldMappingsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['field_mappings']),
	$author$project$Api$Provider$Integration$Athena$athenaPath);
var $author$project$Api$Provider$Integration$Athena$FieldMapping$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Integration$Athena$FieldMapping$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Athena$FieldMapping$fieldMappingsPath));
	});
var $author$project$Api$Provider$Integration$Athena$LocationMapping$All$LocationMapping = $elm$core$Basics$identity;
var $author$project$Api$Provider$Integration$Athena$LocationMapping$Shared$LocationMapping = $elm$core$Basics$identity;
var $author$project$Api$Provider$Integration$Athena$LocationMapping$Shared$Record = F3(
	function (id, name, externalId) {
		return {ag7: externalId, ahP: id, Bq: name};
	});
var $author$project$Api$Provider$Integration$Athena$LocationMapping$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'external_id',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Integration$Athena$LocationMapping$Shared$Record))));
var $author$project$Api$Provider$Integration$Athena$LocationMapping$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Integration$Athena$LocationMapping$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Integration$Athena$LocationMapping$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Integration$Athena$LocationMapping$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Integration$Athena$LocationMapping$locationMappingsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['location_mappings']),
	$author$project$Api$Provider$Integration$Athena$athenaPath);
var $author$project$Api$Provider$Integration$Athena$LocationMapping$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Integration$Athena$LocationMapping$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Athena$LocationMapping$locationMappingsPath));
	});
var $author$project$Api$Provider$Integration$Athena$Provider$All$Provider = $elm$core$Basics$identity;
var $author$project$Api$Provider$Integration$Athena$Provider$Shared$Provider = $elm$core$Basics$identity;
var $author$project$Api$Provider$Integration$Athena$Provider$Shared$Record = F3(
	function (id, name, providerGroups) {
		return {ahP: id, Bq: name, _F: providerGroups};
	});
var $author$project$Api$Provider$Integration$Athena$Provider$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'provider_groups',
	$elm$json$Json$Decode$nullable(
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Integration$Athena$Provider$Shared$Record))));
var $author$project$Api$Provider$Integration$Athena$Provider$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Integration$Athena$Provider$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Integration$Athena$Provider$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Integration$Athena$Provider$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Integration$Athena$Provider$providersPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['providers']),
	$author$project$Api$Provider$Integration$Athena$athenaPath);
var $author$project$Api$Provider$Integration$Athena$Provider$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Integration$Athena$Provider$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Athena$Provider$providersPath));
	});
var $author$project$Api$Provider$Integration$Athena$ProviderMapping$All$ProviderMapping = $elm$core$Basics$identity;
var $author$project$Api$Provider$Integration$Athena$ProviderMapping$Shared$ProviderMapping = $elm$core$Basics$identity;
var $author$project$Api$Provider$Integration$Athena$ProviderMapping$Shared$Record = F3(
	function (id, name, externalId) {
		return {ag7: externalId, ahP: id, Bq: name};
	});
var $author$project$Api$Provider$Integration$Athena$ProviderMapping$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'external_id',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Integration$Athena$ProviderMapping$Shared$Record))));
var $author$project$Api$Provider$Integration$Athena$ProviderMapping$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Integration$Athena$ProviderMapping$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Integration$Athena$ProviderMapping$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Integration$Athena$ProviderMapping$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Integration$Athena$ProviderMapping$providerMappingsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['provider_mappings']),
	$author$project$Api$Provider$Integration$Athena$athenaPath);
var $author$project$Api$Provider$Integration$Athena$ProviderMapping$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Integration$Athena$ProviderMapping$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Athena$ProviderMapping$providerMappingsPath));
	});
var $author$project$Api$Provider$AthenaConfiguration$Shared$setupSubstate = function (_v0) {
	var record = _v0;
	return record.aa7;
};
var $author$project$Api$Provider$AthenaConfiguration$One$setupSubstate = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$AthenaConfiguration$Shared$setupSubstate(shared);
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$setupSubstateToStep = function (setupSubstate) {
	switch (setupSubstate) {
		case 'link_practice':
			return 1;
		case 'locations_mapping':
			return 2;
		case 'fields_mapping':
			return 3;
		case 'providers_mapping':
			return 4;
		case 'completed':
			return 5;
		default:
			return 5;
	}
};
var $author$project$Api$Provider$Integration$Athena$update = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'athena_integration',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'allow_new_patient_creation',
								$elm$json$Json$Encode$bool(fields.Lx))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$AthenaConfiguration$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Athena$athenaPath)));
	});
var $author$project$Api$Provider$Integration$Athena$FieldMapping$update = F3(
	function (apiClient, fieldMappings, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'field_mappings',
					A2(
						$elm$json$Json$Encode$list,
						function (fieldMapping) {
							return $elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'id',
										$elm$json$Json$Encode$string(fieldMapping.ahP)),
										_Utils_Tuple2(
										'external_id',
										A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fieldMapping.ag7))
									]));
						},
						fieldMappings))
				]));
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Integration$Athena$FieldMapping$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Athena$FieldMapping$fieldMappingsPath)));
	});
var $author$project$Api$Provider$Integration$Athena$LocationMapping$One$LocationMapping = 0;
var $author$project$Api$Provider$Integration$Athena$LocationMapping$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Provider$Integration$Athena$LocationMapping$locationMappingPath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		$author$project$Api$Provider$Integration$Athena$LocationMapping$locationMappingsPath);
};
var $author$project$Api$Provider$Integration$Athena$LocationMapping$update = F4(
	function (apiClient, id, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'location_mapping',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'external_id',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ag7))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Integration$Athena$LocationMapping$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Integration$Athena$LocationMapping$locationMappingPath(id))));
	});
var $author$project$Api$Provider$Integration$Athena$ProviderMapping$One$ProviderMapping = 0;
var $author$project$Api$Provider$Integration$Athena$ProviderMapping$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Provider$Integration$Athena$ProviderMapping$providerMappingPath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		$author$project$Api$Provider$Integration$Athena$ProviderMapping$providerMappingsPath);
};
var $author$project$Api$Provider$Integration$Athena$ProviderMapping$update = F4(
	function (apiClient, id, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'provider_mapping',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'external_id',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ag7))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Integration$Athena$ProviderMapping$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Integration$Athena$ProviderMapping$providerMappingPath(id))));
	});
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				_v1$2:
				while (true) {
					switch (response.$) {
						case 3:
							var config = response.a;
							var step = $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$setupSubstateToStep(
								$author$project$Api$Provider$AthenaConfiguration$One$setupSubstate(config));
							var cmds = function () {
								if (step === 5) {
									return $elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[
												A2($author$project$Api$Provider$Integration$Athena$LocationMapping$list, model.Gv, $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GotOverviewLocationMappings),
												A2($author$project$Api$Provider$Integration$Athena$FieldMapping$list, model.Gv, $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GotOverviewFieldMappings),
												A2($author$project$Api$Provider$Integration$Athena$ProviderMapping$list, model.Gv, $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GotOverviewProviderMappings)
											]));
								} else {
									return $elm$core$Platform$Cmd$none;
								}
							}();
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{A: response, acf: step}),
								cmds,
								_List_Nil);
						case 2:
							if (response.a.$ === 5) {
								var _v3 = response.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											A: response,
											SD: $elm$core$Maybe$Just(
												$author$project$Utils$Form$init($author$project$Pages$Marketplace$Athenahealth$Manage$Settings$formFieldsInit)),
											acf: 0
										}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							} else {
								break _v1$2;
							}
						default:
							break _v1$2;
					}
				}
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{A: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{m0: $author$project$Api$Data$Loading}),
					A2($author$project$Api$Provider$Integration$Athena$create, model.Gv, $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$Created),
					_List_Nil);
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								A: response,
								m0: $author$project$Api$Data$NotAsked,
								SD: $elm$core$Maybe$Just(
									$author$project$Utils$Form$init($author$project$Pages$Marketplace$Athenahealth$Manage$Settings$formFieldsInit)),
								acf: 1
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{m0: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							SD: $elm$core$Maybe$Just(
								$author$project$Utils$Form$init($author$project$Pages$Marketplace$Athenahealth$Manage$Settings$formFieldsInit)),
							acf: 1
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var field = msg.a;
				var _v5 = model.SD;
				if (!_v5.$) {
					var form = _v5.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								SD: $elm$core$Maybe$Just(
									A3($author$project$Utils$Form$update, $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$formFieldsUpdate, field, form))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				var _v6 = model.SD;
				if (!_v6.$) {
					var form = _v6.a;
					var _v7 = A2(
						$author$project$Utils$Form$validate,
						$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$formFieldsValidator(model),
						form);
					if (!_v7.$) {
						var _v8 = _v7.a;
						var newForm = _v8.a;
						var validFormFields = _v8.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									SD: $elm$core$Maybe$Just(newForm),
									k9: $author$project$Api$Data$Loading
								}),
							A2($author$project$Pages$Marketplace$Athenahealth$Manage$Settings$linkAthena, model.Gv, validFormFields),
							_List_Nil);
					} else {
						var newForm = _v7.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									SD: $elm$core$Maybe$Just(newForm)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{A: response, it: $author$project$Api$Data$Loading, fI: $author$project$Api$Data$Loading, SD: $elm$core$Maybe$Nothing, k9: $author$project$Api$Data$NotAsked, acf: 2}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($author$project$Api$Provider$Integration$Athena$Department$list, model.Gv, $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GotAthenaDepartments),
									A2($author$project$Api$Provider$Integration$Athena$LocationMapping$list, model.Gv, $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GotAthenaLocationMappings)
								])),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your athenahealth practice has been linked.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 7:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{it: $author$project$Api$Data$Loading, fI: $author$project$Api$Data$Loading, acf: 2}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Api$Provider$Integration$Athena$Department$list, model.Gv, $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GotAthenaDepartments),
								A2($author$project$Api$Provider$Integration$Athena$LocationMapping$list, model.Gv, $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GotAthenaLocationMappings)
							])),
					_List_Nil);
			case 8:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{it: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 9:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{fI: response, jz: $elm$core$Set$empty}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{fI: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 10:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{it: $author$project$Api$Data$Loading}),
					A2($author$project$Api$Provider$Integration$Athena$Department$list, model.Gv, $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GotAthenaDepartments),
					_List_Nil);
			case 11:
				var athenaLocationMapping = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							jz: A2(
								$elm$core$Set$insert,
								$author$project$Api$Provider$Integration$Athena$LocationMapping$All$id(athenaLocationMapping),
								model.jz)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 12:
				var athenaLocationMapping = msg.a;
				var athenaLocationId = msg.b;
				return _Utils_Tuple3(
					model,
					A4(
						$author$project$Api$Provider$Integration$Athena$LocationMapping$update,
						model.Gv,
						$author$project$Api$Provider$Integration$Athena$LocationMapping$All$id(athenaLocationMapping),
						{
							ag7: $author$project$Utils$String$toMaybe(athenaLocationId)
						},
						$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GotLocationMapping),
					_List_Nil);
			case 13:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						A2($author$project$Api$Provider$Integration$Athena$LocationMapping$list, model.Gv, $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GotAthenaLocationMappings),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your athenahealth department has been updated.')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 14:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{k9: $author$project$Api$Data$Loading}),
					A2($author$project$Api$Provider$Integration$Athena$configure, model.Gv, $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GotAthenaConfigured),
					_List_Nil);
			case 15:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{A: response, is: $author$project$Api$Data$Loading, cl: _List_Nil, k9: $author$project$Api$Data$NotAsked, acf: 3}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($author$project$Api$Provider$Integration$Athena$CustomField$list, model.Gv, $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GotAthenaCustomFields),
									A2($author$project$Api$Provider$Integration$Athena$FieldMapping$list, model.Gv, $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GotAthenaFieldMappings)
								])),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 16:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{is: $author$project$Api$Data$Loading, cl: _List_Nil, acf: 3}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Api$Provider$Integration$Athena$CustomField$list, model.Gv, $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GotAthenaCustomFields),
								A2($author$project$Api$Provider$Integration$Athena$FieldMapping$list, model.Gv, $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GotAthenaFieldMappings)
							])),
					_List_Nil);
			case 17:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{is: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 18:
				var response = msg.a;
				if (response.$ === 3) {
					var athenaFieldMappings = response.a;
					var fieldMappings = A2(
						$elm$core$List$map,
						function (athenaFieldMapping) {
							return {
								ag7: $author$project$Api$Provider$Integration$Athena$FieldMapping$All$externalId(athenaFieldMapping),
								ahP: $author$project$Api$Provider$Integration$Athena$FieldMapping$All$id(athenaFieldMapping),
								Bq: $author$project$Api$Provider$Integration$Athena$FieldMapping$All$humanName(athenaFieldMapping)
							};
						},
						athenaFieldMappings);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cl: fieldMappings}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cl: _List_Nil}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 19:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{is: $author$project$Api$Data$Loading}),
					A2($author$project$Api$Provider$Integration$Athena$CustomField$list, model.Gv, $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GotAthenaCustomFields),
					_List_Nil);
			case 20:
				var athenaFieldMapping = msg.a;
				var athenaFieldId = msg.b;
				var athenaFieldMappings = A3(
					$elm_community$list_extra$List$Extra$updateIf,
					function (fieldMapping) {
						return _Utils_eq(fieldMapping.ahP, athenaFieldMapping.ahP);
					},
					function (fieldMapping) {
						return _Utils_update(
							fieldMapping,
							{
								ag7: $author$project$Utils$String$toMaybe(athenaFieldId)
							});
					},
					model.cl);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cl: athenaFieldMappings}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 21:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{k9: $author$project$Api$Data$Loading}),
					A3(
						$author$project$Api$Provider$Integration$Athena$FieldMapping$update,
						model.Gv,
						A2(
							$elm$core$List$map,
							function (athenaFieldMapping) {
								return {ag7: athenaFieldMapping.ag7, ahP: athenaFieldMapping.ahP};
							},
							model.cl),
						$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$FieldMappingsUpdated),
					_List_Nil);
			case 22:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{iu: $author$project$Api$Data$Loading, iv: $author$project$Api$Data$Loading, k9: $author$project$Api$Data$NotAsked, acf: 4}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($author$project$Api$Provider$Integration$Athena$Provider$list, model.Gv, $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GotAthenaProviders),
									A2($author$project$Api$Provider$Integration$Athena$ProviderMapping$list, model.Gv, $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GotAthenaProviderMappings)
								])),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 23:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{iu: $author$project$Api$Data$Loading, iv: $author$project$Api$Data$Loading, acf: 4}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Api$Provider$Integration$Athena$Provider$list, model.Gv, $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GotAthenaProviders),
								A2($author$project$Api$Provider$Integration$Athena$ProviderMapping$list, model.Gv, $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GotAthenaProviderMappings)
							])),
					_List_Nil);
			case 24:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{iv: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 25:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{iu: response, jA: $elm$core$Set$empty}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{iu: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 26:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{iv: $author$project$Api$Data$Loading}),
					A2($author$project$Api$Provider$Integration$Athena$Provider$list, model.Gv, $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GotAthenaProviders),
					_List_Nil);
			case 27:
				var athenaProviderMapping = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							jA: A2(
								$elm$core$Set$insert,
								$author$project$Api$Provider$Integration$Athena$ProviderMapping$All$id(athenaProviderMapping),
								model.jA)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 28:
				var athenaProviderMapping = msg.a;
				var athenaProviderId = msg.b;
				return _Utils_Tuple3(
					model,
					A4(
						$author$project$Api$Provider$Integration$Athena$ProviderMapping$update,
						model.Gv,
						$author$project$Api$Provider$Integration$Athena$ProviderMapping$All$id(athenaProviderMapping),
						{
							ag7: $author$project$Utils$String$toMaybe(athenaProviderId)
						},
						$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GotProviderMapping),
					_List_Nil);
			case 29:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						A2($author$project$Api$Provider$Integration$Athena$ProviderMapping$list, model.Gv, $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GotAthenaProviderMappings),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your athenahealth provider has been updated.')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 30:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{k9: $author$project$Api$Data$Loading}),
					A2($author$project$Api$Provider$Integration$Athena$complete, model.Gv, $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$Completed),
					_List_Nil);
			case 31:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{A: response, ol: $elm$core$Maybe$Nothing, om: $elm$core$Maybe$Nothing, on: $elm$core$Maybe$Nothing, k9: $author$project$Api$Data$NotAsked, acf: 5}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($author$project$Api$Provider$Integration$Athena$LocationMapping$list, model.Gv, $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GotOverviewLocationMappings),
									A2($author$project$Api$Provider$Integration$Athena$FieldMapping$list, model.Gv, $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GotOverviewFieldMappings),
									A2($author$project$Api$Provider$Integration$Athena$ProviderMapping$list, model.Gv, $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GotOverviewProviderMappings)
								])),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 32:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ol: $elm$core$Maybe$Nothing, om: $elm$core$Maybe$Nothing, on: $elm$core$Maybe$Nothing, acf: 5}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Api$Provider$Integration$Athena$LocationMapping$list, model.Gv, $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GotOverviewLocationMappings),
								A2($author$project$Api$Provider$Integration$Athena$FieldMapping$list, model.Gv, $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GotOverviewFieldMappings),
								A2($author$project$Api$Provider$Integration$Athena$ProviderMapping$list, model.Gv, $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GotOverviewProviderMappings)
							])),
					_List_Nil);
			case 33:
				var response = msg.a;
				if (response.$ === 3) {
					var locationMappings = response.a;
					var linkedLocations = A2(
						$elm$core$List$filter,
						function (locationMapping) {
							return !_Utils_eq(
								$author$project$Api$Provider$Integration$Athena$LocationMapping$All$externalId(locationMapping),
								$elm$core$Maybe$Nothing);
						},
						locationMappings);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								om: $elm$core$Maybe$Just(
									$elm$core$List$length(linkedLocations))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 34:
				var response = msg.a;
				if (response.$ === 3) {
					var fieldMappings = response.a;
					var linkedFields = A2(
						$elm$core$List$filter,
						function (fieldMapping) {
							return !_Utils_eq(
								$author$project$Api$Provider$Integration$Athena$FieldMapping$All$externalId(fieldMapping),
								$elm$core$Maybe$Nothing);
						},
						fieldMappings);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ol: $elm$core$Maybe$Just(
									$elm$core$List$length(linkedFields))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 35:
				var response = msg.a;
				if (response.$ === 3) {
					var providerMappings = response.a;
					var linkedProviders = A2(
						$elm$core$List$filter,
						function (providerMapping) {
							return !_Utils_eq(
								$author$project$Api$Provider$Integration$Athena$ProviderMapping$All$externalId(providerMapping),
								$elm$core$Maybe$Nothing);
						},
						providerMappings);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								on: $elm$core$Maybe$Just(
									$elm$core$List$length(linkedProviders))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 36:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{k9: $author$project$Api$Data$Loading}),
					A2($author$project$Api$Provider$Integration$Athena$activate, model.Gv, $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$Activated),
					_List_Nil);
			case 37:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{A: response, k9: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your athenahealth integration has been activated.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 38:
				var allowNewPatientCreation = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{k9: $author$project$Api$Data$Loading}),
					A3(
						$author$project$Api$Provider$Integration$Athena$update,
						model.Gv,
						{Lx: allowNewPatientCreation},
						$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$Updated),
					_List_Nil);
			case 39:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{A: response, k9: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your athenahealth integration has been updated.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 40:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{mz: false, lm: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 41:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{lm: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 42:
				var checked = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{mz: checked}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 43:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{my: $author$project$Api$Data$Loading, lm: false}),
					A3(
						$author$project$Api$Provider$Integration$Athena$bulkSyncPatients,
						model.Gv,
						{amj: model.mz},
						$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$BulkSynced),
					_List_Nil);
			case 44:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{my: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Bulk sync to athenahealth has been initiated. Patients will be synced in the background.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{my: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 45:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							eq: $elm$core$Maybe$Just($author$project$Api$Data$NotAsked)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 46:
				var confirmed = msg.a;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							eq: $elm$core$Maybe$Just($author$project$Api$Data$Loading)
						}),
					A2($author$project$Api$Provider$Integration$Athena$delete, model.Gv, $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$Disabled),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{eq: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								A: $author$project$Api$Data$Failure($author$project$Api$Data$NotFound),
								eq: $elm$core$Maybe$Nothing,
								SD: $elm$core$Maybe$Just(
									$author$project$Utils$Form$init($author$project$Pages$Marketplace$Athenahealth$Manage$Settings$formFieldsInit)),
								acf: 0
							}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your athenahealth integration has been disabled.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{eq: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$SaveLink = {$: 5};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$ConfirmBulkSync = {$: 43};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$SetBulkSyncUnlinkedOnly = function (a) {
	return {$: 42, a: a};
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewBulkSyncModal = function (model) {
	return model.lm ? A3(
		$author$project$Ui$Modal$view,
		$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$CloseBulkSyncModal,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Sync Patients to athenahealth')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('This will sync all patients on linked locations to athenahealth. '),
								$elm$html$Html$text('This may take some time depending on the number of patients.')
							])),
						A2(
						$author$project$Ui$Form$Checkbox$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Checkbox$value(model.mz),
								$author$project$Ui$Form$Checkbox$onCheck($author$project$Pages$Marketplace$Athenahealth$Manage$Settings$SetBulkSyncUnlinkedOnly)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Unlinked patients only')
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Cancel bulk sync'},
						_List_fromArray(
							[
								$author$project$Ui$Button$secondary,
								$author$project$Ui$Button$onClick($author$project$Pages$Marketplace$Athenahealth$Manage$Settings$CloseBulkSyncModal)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Start bulk sync'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$onClick($author$project$Pages$Marketplace$Athenahealth$Manage$Settings$ConfirmBulkSync)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Start Sync')
							]))
					]))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewDisableModal = function (model) {
	var _v0 = model.eq;
	if (!_v0.$) {
		var disablingRequest = _v0.a;
		return A2(
			$author$project$Components$HiConfirm$modal,
			$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$DisableConfirmed,
			_List_fromArray(
				[
					$author$project$Components$HiConfirm$customMessage(
					_List_fromArray(
						[
							$elm$html$Html$text('Please confirm you would like to deactivate the athenahealth integration.')
						])),
					$author$project$Components$HiConfirm$loading(
					_Utils_eq(disablingRequest, $author$project$Api$Data$Loading))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$integrationExists = function (model) {
	var _v0 = model.A;
	if (_v0.$ === 3) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$RefreshAthenaCustomFields = {$: 19};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$UpdateFieldMapping = F2(
	function (a, b) {
		return {$: 20, a: a, b: b};
	});
var $author$project$Api$Provider$Integration$Athena$CustomField$Shared$externalId = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Provider$Integration$Athena$CustomField$All$externalId = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Integration$Athena$CustomField$Shared$externalId(shared);
};
var $author$project$Ui$Form$Select$ItemDisabled = $elm$core$Basics$identity;
var $author$project$Ui$Form$Select$itemDisabled = $elm$core$Basics$identity;
var $author$project$Api$Provider$Integration$Athena$CustomField$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$Integration$Athena$CustomField$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Integration$Athena$CustomField$Shared$name(shared);
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$athenaCustomFieldsOptions = function (athenaCustomFields) {
	return A2(
		$elm$core$List$cons,
		A3(
			$author$project$Ui$Form$Select$option,
			_List_fromArray(
				[
					$author$project$Ui$Form$Select$itemDisabled(true)
				]),
			$elm$core$Maybe$Nothing,
			'Choose athenahealth Custom Field'),
		A2(
			$elm$core$List$map,
			function (athenaCustomField) {
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$Integration$Athena$CustomField$All$externalId(athenaCustomField)),
					$author$project$Api$Provider$Integration$Athena$CustomField$All$name(athenaCustomField) + (' (' + ($author$project$Api$Provider$Integration$Athena$CustomField$All$externalId(athenaCustomField) + ')')));
			},
			athenaCustomFields));
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewAthenaFieldMapping = F2(
	function (athenaCustomFields, athenaFieldMapping) {
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(6)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Hint data point: '),
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$bold]),
									athenaFieldMapping.Bq)
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanMd(1)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Icon$arrowRight(_List_Nil)
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(2)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('athenahealth custom field: ')
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(3)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Select$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Select$value(athenaFieldMapping.ag7),
											$author$project$Ui$Form$Select$onChange(
											$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$UpdateFieldMapping(athenaFieldMapping))
										]),
									$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$athenaCustomFieldsOptions(athenaCustomFields))
								]))
						])),
					$author$project$Ui$HorizontalRule$view(_List_Nil)
				]));
	});
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewFieldsListSkeleton = A2(
	$author$project$Ui$Element$view,
	_List_Nil,
	A2(
		$elm$core$List$repeat,
		10,
		A2(
			$author$project$Ui$Grid$row,
			_List_fromArray(
				[$author$project$Ui$Grid$rowItemsCenter]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(6)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$spanFromText('Hint data point: ')
										]))
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$span(8),
											$author$project$Ui$Skeleton$spanMd(4)
										]))
								]))
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanMd(1)
						]),
					_List_Nil),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(2)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$spanFromText('athenahealth custom field: ')
								]))
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(3)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$input(_List_Nil)
						]))
				]))));
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewFieldsContent = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanLg(9),
								$author$project$Ui$Grid$spanMd(8),
								$author$project$Ui$Grid$spanSm(7)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Typography$headingSm(
								_List_fromArray(
									[
										$elm$html$Html$text('Match Custom Fields')
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('We will sync information about each patient\'s membership to athenahealth in custom fields.  You will need to configure these custom fields in athenahealth first, and then return to this page once complete.')
									]))
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanLg(3),
								$author$project$Ui$Grid$spanMd(4),
								$author$project$Ui$Grid$spanSm(5),
								$author$project$Ui$Grid$justifyRight
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Refresh athenahealth Custom Fields'},
								_List_fromArray(
									[
										$author$project$Ui$Button$onClick($author$project$Pages$Marketplace$Athenahealth$Manage$Settings$RefreshAthenaCustomFields),
										$author$project$Ui$Button$icon($author$project$Ui$Icon$repeat)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Refresh athenahealth Custom Fields')
									]))
							]))
					])),
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				function () {
				var _v0 = model.is;
				if (_v0.$ === 3) {
					var athenaCustomFields = _v0.a;
					return A2(
						$author$project$Ui$Element$view,
						_List_Nil,
						A2(
							$elm$core$List$map,
							$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewAthenaFieldMapping(athenaCustomFields),
							model.cl));
				} else {
					return $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewFieldsListSkeleton;
				}
			}()
			]));
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$Disable = {$: 45};
var $author$project$Api$Provider$AthenaConfiguration$Shared$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Api$Provider$AthenaConfiguration$One$status = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$AthenaConfiguration$Shared$status(shared);
};
var $author$project$Api$Provider$AthenaConfiguration$Shared$athenaPracticeId = function (_v0) {
	var record = _v0;
	return record.L3;
};
var $author$project$Api$Provider$AthenaConfiguration$One$athenaPracticeId = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$AthenaConfiguration$Shared$athenaPracticeId(shared);
};
var $author$project$Api$Provider$AthenaConfiguration$Shared$athenaPracticeName = function (_v0) {
	var record = _v0;
	return record.L4;
};
var $author$project$Api$Provider$AthenaConfiguration$One$athenaPracticeName = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$AthenaConfiguration$Shared$athenaPracticeName(shared);
};
var $author$project$Api$Provider$AthenaConfiguration$Shared$athenaProviderGroupId = function (_v0) {
	var record = _v0;
	return record.L5;
};
var $author$project$Api$Provider$AthenaConfiguration$One$athenaProviderGroupId = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$AthenaConfiguration$Shared$athenaProviderGroupId(shared);
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewName = function (maybeConfig) {
	if (!maybeConfig.$) {
		var config = maybeConfig.a;
		var _v1 = _Utils_Tuple2(
			$author$project$Api$Provider$AthenaConfiguration$One$athenaPracticeName(config),
			$author$project$Api$Provider$AthenaConfiguration$One$athenaProviderGroupId(config));
		if (!_v1.a.$) {
			var name = _v1.a.a;
			var maybeProviderGroupId = _v1.b;
			var practiceId = 'Practice ID: ' + A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Api$Provider$AthenaConfiguration$One$athenaPracticeId(config));
			var groupId = A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function (providerGroupId) {
						return ', Provider Group ID: ' + providerGroupId;
					},
					maybeProviderGroupId));
			return A2($author$project$Ui$Typography$text, _List_Nil, 'at ' + (name + (' (' + (practiceId + (groupId + ')')))));
		} else {
			return $author$project$Utils$Html$empty;
		}
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewStatus = F2(
	function (status, content) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Status'),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_fromArray(
						[$author$project$Ui$Form$Static$flex, $author$project$Ui$Form$Static$spaceBetween, $author$project$Ui$Form$Static$itemsCenter]),
					A2(
						$elm$core$List$cons,
						A2($author$project$Ui$Badge$fromString, _List_Nil, status),
						content))
				]));
	});
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewStatusWithDeactivate = function (model) {
	var athenaConfiguration_ = $author$project$Api$Data$toMaybe(model.A);
	var status = A2(
		$elm$core$Maybe$withDefault,
		'pending',
		A2($elm$core$Maybe$map, $author$project$Api$Provider$AthenaConfiguration$One$status, athenaConfiguration_));
	return A2(
		$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewStatus,
		status,
		_List_fromArray(
			[
				$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewName(athenaConfiguration_),
				function () {
				if (!athenaConfiguration_.$) {
					return A3(
						$author$project$Ui$Button$view,
						{mm: 'Deactivate integration'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Pages$Marketplace$Athenahealth$Manage$Settings$Disable),
								$author$project$Ui$Button$link
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Deactivate the integration')
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]));
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GoToFields = {$: 16};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GoToLink = {$: 3};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GoToLocations = {$: 7};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GoToOverview = {$: 32};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GoToProviders = {$: 23};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewStepBreadcrumbs = F2(
	function (hasIntegration, currentStep) {
		var steps = _List_fromArray(
			[
				_Utils_Tuple2(1, 'Connect Account'),
				_Utils_Tuple2(2, 'Match Locations to Departments'),
				_Utils_Tuple2(3, 'Match Custom Fields'),
				_Utils_Tuple2(4, 'Match Providers'),
				_Utils_Tuple2(5, 'Overview')
			]);
		var stepMsg = function (step) {
			switch (step) {
				case 1:
					return $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GoToLink;
				case 2:
					return $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GoToLocations;
				case 3:
					return $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GoToFields;
				case 4:
					return $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GoToProviders;
				case 5:
					return $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GoToOverview;
				default:
					return $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$GoToLink;
			}
		};
		var isClickable = function (step) {
			return (!_Utils_eq(step, currentStep)) && ((step === 1) || hasIntegration);
		};
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			A2(
				$elm$core$List$intersperse,
				A2(
					$author$project$Ui$Typography$text,
					_List_fromArray(
						[$author$project$Ui$Typography$muted]),
					' > '),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var step = _v0.a;
						var label = _v0.b;
						return _Utils_eq(step, currentStep) ? A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[$author$project$Ui$Typography$bold]),
							label) : (isClickable(step) ? A3(
							$author$project$Ui$Button$view,
							{mm: label},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$sm,
									$author$project$Ui$Button$onClick(
									stepMsg(step))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(label)
								])) : A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[$author$project$Ui$Typography$muted]),
							label));
					},
					steps)));
	});
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewFieldsStep = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewStatusWithDeactivate(model),
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				A2(
				$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewStepBreadcrumbs,
				$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$integrationExists(model),
				3),
				A2($elm$html$Html$br, _List_Nil, _List_Nil),
				$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewFieldsContent(model)
			]));
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$Activate = {$: 36};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$CompleteFields = {$: 21};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$CompleteProviders = {$: 30};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$ConfigureLocations = {$: 14};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$OpenBulkSyncModal = {$: 40};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewFooter = function (model) {
	var _v0 = model.acf;
	switch (_v0) {
		case 0:
			return $author$project$Ui$Panel$none;
		case 1:
			return A2(
				$author$project$Ui$Panel$footer,
				_List_fromArray(
					[$author$project$Ui$Element$justifyCenter]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Go to next step'},
						_List_fromArray(
							[
								$author$project$Ui$Button$submit,
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$loading(
								_Utils_eq(model.k9, $author$project$Api$Data$Loading))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Next Step')
							]))
					]));
		case 2:
			var _v1 = model.fI;
			if (_v1.$ === 3) {
				var athenaLocationMappings = _v1.a;
				var canContinue = A2(
					$elm$core$List$any,
					function (athenaLocationMapping) {
						return !_Utils_eq(
							$author$project$Api$Provider$Integration$Athena$LocationMapping$All$externalId(athenaLocationMapping),
							$elm$core$Maybe$Nothing);
					},
					athenaLocationMappings) && $elm$core$Set$isEmpty(model.jz);
				return A2(
					$author$project$Ui$Panel$footer,
					_List_fromArray(
						[$author$project$Ui$Element$justifyCenter]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Go to next step'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Pages$Marketplace$Athenahealth$Manage$Settings$ConfigureLocations),
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$loading(
									_Utils_eq(model.k9, $author$project$Api$Data$Loading)),
									$author$project$Ui$Button$disabled(!canContinue)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Next Step')
								]))
						]));
			} else {
				return $author$project$Ui$Panel$none;
			}
		case 3:
			var canContinue = !A2(
				$elm$core$List$any,
				function (athenaFieldMapping) {
					return _Utils_eq(athenaFieldMapping.ag7, $elm$core$Maybe$Nothing);
				},
				model.cl);
			return A2(
				$author$project$Ui$Panel$footer,
				_List_fromArray(
					[$author$project$Ui$Element$justifyCenter]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Go to next step'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Pages$Marketplace$Athenahealth$Manage$Settings$CompleteFields),
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$loading(
								_Utils_eq(model.k9, $author$project$Api$Data$Loading)),
								$author$project$Ui$Button$disabled(!canContinue)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Next Step')
							]))
					]));
		case 4:
			var canContinue = $elm$core$Set$isEmpty(model.jA);
			return A2(
				$author$project$Ui$Panel$footer,
				_List_fromArray(
					[$author$project$Ui$Element$justifyCenter]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Go to next step'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Pages$Marketplace$Athenahealth$Manage$Settings$CompleteProviders),
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$loading(
								_Utils_eq(model.k9, $author$project$Api$Data$Loading)),
								$author$project$Ui$Button$disabled(!canContinue)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Next Step')
							]))
					]));
		default:
			var _v2 = $author$project$Api$Data$toMaybe(model.A);
			if (!_v2.$) {
				var athenaConfiguration = _v2.a;
				var status = $author$project$Api$Provider$AthenaConfiguration$One$status(athenaConfiguration);
				return (status === 'pending') ? A2(
					$author$project$Ui$Panel$footer,
					_List_fromArray(
						[$author$project$Ui$Element$justifyCenter]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Activate integration'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Pages$Marketplace$Athenahealth$Manage$Settings$Activate),
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$loading(
									_Utils_eq(model.k9, $author$project$Api$Data$Loading))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Activate')
								]))
						])) : ((status === 'active') ? A2(
					$author$project$Ui$Panel$footer,
					_List_fromArray(
						[$author$project$Ui$Element$justifyCenter]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Sync all patients to athenahealth'},
							_List_fromArray(
								[
									$author$project$Ui$Button$secondary,
									$author$project$Ui$Button$onClick($author$project$Pages$Marketplace$Athenahealth$Manage$Settings$OpenBulkSyncModal),
									$author$project$Ui$Button$loading(
									_Utils_eq(model.my, $author$project$Api$Data$Loading))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Sync Patients to athenahealth')
								]))
						])) : $author$project$Ui$Panel$none);
			} else {
				return $author$project$Ui$Panel$none;
			}
	}
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$Create = {$: 1};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewInitialStep = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				A2($author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewStatus, 'inactive', _List_Nil),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label(''),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Enable athenahealth Integration'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$onClick($author$project$Pages$Marketplace$Athenahealth$Manage$Settings$Create),
								$author$project$Ui$Button$loading(
								_Utils_eq(model.m0, $author$project$Api$Data$Loading))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Enable athenahealth Integration')
							]))
					])),
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('About'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Used by physicians to manage every aspects of patient care, '),
								A3(
								$author$project$Ui$Link$externalHref,
								'https://www.athenahealth.com/',
								_List_fromArray(
									[$author$project$Ui$Link$targetBlank]),
								_List_fromArray(
									[
										$elm$html$Html$text('athenahealth')
									])),
								$elm$html$Html$text(' is an intuitive, easy to use solution that helps you quickly find, digest, '),
								$elm$html$Html$text('and act upon relevant clinical information to care for your patients.')
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Our integration will automatically create and synchronize patient demographic, '),
								$elm$html$Html$text('contact, and membership information with athenahealth.')
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('To configure this integration, you need to provide your existing athenahealth practice ID. '),
								$elm$html$Html$text('Please contact us if you need help identifying this information')
							]))
					]))
			]));
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewInitialStepSkeleton = A2(
	$author$project$Ui$Element$view,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSkeleton('Status'),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$spanFromText('inactive')
								]))
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label(''),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$input(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$spanFromText('Enable athenahealth Integration')
						]))
				])),
			$author$project$Ui$HorizontalRule$view(_List_Nil),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSkeleton('About'),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$block,
									$author$project$Ui$Skeleton$span(8)
								])),
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$block,
									$author$project$Ui$Skeleton$span(7)
								])),
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$block,
									$author$project$Ui$Skeleton$span(8)
								]))
						]))
				]))
		]));
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$AthenaPracticeId = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$AthenaProviderGroupId = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$FormUpdated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewConfigureInfo = A2(
	$author$project$Ui$Typography$p,
	_List_Nil,
	_List_fromArray(
		[
			$elm$html$Html$text('Please enter your athenahealth practice ID. This ID can be found by logging into athenahealth, and clicking on your username in the top right. '),
			$elm$html$Html$text('A dropdown will appear with a \"PRACTICE\" section. Your ID is next to your Practice name in parenthesis.')
		]));
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewLinkForm = F3(
	function (saveRequest, athenaConfig, form) {
		var scopedByProviderGroup = function () {
			if (athenaConfig.$ === 3) {
				var config = athenaConfig.a;
				return $author$project$Api$Provider$AthenaConfiguration$One$scopedByProviderGroup(config);
			} else {
				return false;
			}
		}();
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Connect athenahealth Account')
						])),
					$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewConfigureInfo,
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label(''),
							$author$project$Ui$Form$Group$inputSpanSm(8),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2($elm$core$Maybe$map, $elm$core$String$fromInt, fields.L3))),
									$author$project$Ui$Form$Input$autoComplete(false),
									$author$project$Ui$Form$Input$phi(true),
									$author$project$Ui$Form$Input$placeholder('Enter athenahealth Practice ID'),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$FormUpdated, $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$AthenaPracticeId)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 0, form))
								])),
							scopedByProviderGroup ? $author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2($elm$core$Maybe$map, $elm$core$String$fromInt, fields.L5))),
									$author$project$Ui$Form$Input$autoComplete(false),
									$author$project$Ui$Form$Input$phi(true),
									$author$project$Ui$Form$Input$customAttributes(
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mt-2')
										])),
									$author$project$Ui$Form$Input$placeholder('Enter athenahealth Provider Group ID'),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$FormUpdated, $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$AthenaProviderGroupId)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 1, form))
								])) : $author$project$Utils$Html$empty,
							function () {
							if (saveRequest.$ === 2) {
								return A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Alert$danger,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('We do not have access yet to your Athena practice. Please make sure you have sign the Authorization & Consent form on the Athena side. If you see this message for more than a few days, please contact us.')
												]))
										]));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						]))
				]));
	});
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewLinkStep = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewStatusWithDeactivate(model),
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				A2(
				$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewStepBreadcrumbs,
				$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$integrationExists(model),
				1),
				A2($elm$html$Html$br, _List_Nil, _List_Nil),
				function () {
				var _v0 = model.SD;
				if (!_v0.$) {
					var form = _v0.a;
					return A3($author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewLinkForm, model.k9, model.A, form);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]));
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$RefreshAthenaDepartments = {$: 10};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$EditAthenaLocationMapping = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$UpdateLocationMapping = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$displayDepartmentName = F2(
	function (name, providerGroup) {
		if (!providerGroup.$) {
			var providerGroupId = providerGroup.a;
			return $elm$core$String$concat(
				_List_fromArray(
					[name, ' (Provider Group: #', providerGroupId, ')']));
		} else {
			return name;
		}
	});
var $author$project$Api$Provider$Integration$Athena$Department$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Integration$Athena$Department$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Integration$Athena$Department$Shared$id(shared);
};
var $author$project$Api$Provider$Integration$Athena$Department$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$Integration$Athena$Department$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Integration$Athena$Department$Shared$name(shared);
};
var $author$project$Api$Provider$Integration$Athena$Department$Shared$providerGroup = function (_v0) {
	var record = _v0;
	return record._E;
};
var $author$project$Api$Provider$Integration$Athena$Department$All$providerGroup = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Integration$Athena$Department$Shared$providerGroup(shared);
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$athenaDepartmentsOptions = function (athenaDepartments) {
	return A2(
		$elm$core$List$cons,
		A3(
			$author$project$Ui$Form$Select$option,
			_List_fromArray(
				[
					$author$project$Ui$Form$Select$itemDisabled(true)
				]),
			$elm$core$Maybe$Nothing,
			'Choose athenahealth Department'),
		A2(
			$elm$core$List$cons,
			A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(''),
				'Unlink this Department'),
			A2(
				$elm$core$List$map,
				function (athenaDepartment) {
					return A3(
						$author$project$Ui$Form$Select$option,
						_List_Nil,
						$elm$core$Maybe$Just(
							$author$project$Api$Provider$Integration$Athena$Department$All$id(athenaDepartment)),
						A2(
							$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$displayDepartmentName,
							$author$project$Api$Provider$Integration$Athena$Department$All$name(athenaDepartment),
							$author$project$Api$Provider$Integration$Athena$Department$All$providerGroup(athenaDepartment)));
				},
				athenaDepartments)));
};
var $author$project$Api$Provider$Integration$Athena$LocationMapping$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$Integration$Athena$LocationMapping$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Integration$Athena$LocationMapping$Shared$name(shared);
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewAthenaLocationMapping = F3(
	function (editingLocationMappings, athenaDepartments, athenaLocationMapping) {
		var isEditingAthenaLocationMapping = A2(
			$elm$core$Set$member,
			$author$project$Api$Provider$Integration$Athena$LocationMapping$All$id(athenaLocationMapping),
			editingLocationMappings);
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_fromArray(
						[$author$project$Ui$Grid$rowItemsCenter]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(6)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Hint Location: '),
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$bold]),
									$author$project$Api$Provider$Integration$Athena$LocationMapping$All$name(athenaLocationMapping))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanMd(1)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Icon$arrowRight(_List_Nil)
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(2)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('athenahealth department: ')
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(3)
								]),
							_List_fromArray(
								[
									function () {
									if (isEditingAthenaLocationMapping) {
										return A2(
											$author$project$Ui$Form$Select$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Select$value(
													$author$project$Api$Provider$Integration$Athena$LocationMapping$All$externalId(athenaLocationMapping)),
													$author$project$Ui$Form$Select$onChange(
													$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$UpdateLocationMapping(athenaLocationMapping))
												]),
											$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$athenaDepartmentsOptions(athenaDepartments));
									} else {
										var athenaDepartment = A2(
											$elm_community$list_extra$List$Extra$find,
											function (athenaDepartment_) {
												return _Utils_eq(
													$elm$core$Maybe$Just(
														$author$project$Api$Provider$Integration$Athena$Department$All$id(athenaDepartment_)),
													$author$project$Api$Provider$Integration$Athena$LocationMapping$All$externalId(athenaLocationMapping));
											},
											athenaDepartments);
										var chosenDepartment = function () {
											if (!athenaDepartment.$) {
												var department_ = athenaDepartment.a;
												return A2(
													$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$displayDepartmentName,
													$author$project$Api$Provider$Integration$Athena$Department$All$name(department_),
													$author$project$Api$Provider$Integration$Athena$Department$All$providerGroup(department_));
											} else {
												return 'Not linked';
											}
										}();
										return A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$spaceBetween]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$text,
													_List_fromArray(
														[$author$project$Ui$Typography$bold]),
													chosenDepartment),
													A3(
													$author$project$Ui$Button$view,
													{mm: 'Edit location mapping'},
													_List_fromArray(
														[
															$author$project$Ui$Button$link,
															$author$project$Ui$Button$sm,
															$author$project$Ui$Button$onClick(
															$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$EditAthenaLocationMapping(athenaLocationMapping)),
															$author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Edit')
														]))
												]));
									}
								}()
								]))
						])),
					$author$project$Ui$HorizontalRule$view(_List_Nil)
				]));
	});
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewLocationsListSkeleton = A2(
	$author$project$Ui$Element$view,
	_List_Nil,
	A2(
		$elm$core$List$repeat,
		10,
		A2(
			$author$project$Ui$Grid$row,
			_List_fromArray(
				[$author$project$Ui$Grid$rowItemsCenter]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(6)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$spanFromText('Platform Location: ')
										]))
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$span(8),
											$author$project$Ui$Skeleton$spanMd(4)
										]))
								]))
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanMd(1)
						]),
					_List_Nil),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(2)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$spanFromText('athenahealth department: ')
								]))
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(3)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$input(_List_Nil)
						]))
				]))));
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewLocationsStepSkeleton = A2(
	$author$project$Ui$Element$view,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanLg(9),
							$author$project$Ui$Grid$spanMd(8),
							$author$project$Ui$Grid$spanSm(7)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$span(5)
										]))
								])),
							A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$span(11)
										]))
								]))
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanLg(3),
							$author$project$Ui$Grid$spanMd(4),
							$author$project$Ui$Grid$spanSm(5),
							$author$project$Ui$Grid$justifyRight
						]),
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$input(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$spanFromText('Refresh athenahealth Departments')
								]))
						]))
				])),
			$author$project$Ui$HorizontalRule$view(_List_Nil),
			$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewLocationsListSkeleton
		]));
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewLocationsContent = function (model) {
	var _v0 = model.fI;
	if (_v0.$ === 3) {
		var athenaLocationMappings = _v0.a;
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanLg(9),
									$author$project$Ui$Grid$spanMd(8),
									$author$project$Ui$Grid$spanSm(7)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Typography$headingSm(
									_List_fromArray(
										[
											$elm$html$Html$text('Match Hint Locations to athenahealth Departments')
										])),
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Keep your patients organized by matching your Hint Locations to athenahealth Departments. If a patient is not at a location that is linked to a department, they will not be synced to Athena.')
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanLg(3),
									$author$project$Ui$Grid$spanMd(4),
									$author$project$Ui$Grid$spanSm(5),
									$author$project$Ui$Grid$justifyRight
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Refresh athenahealth Departments'},
									_List_fromArray(
										[
											$author$project$Ui$Button$onClick($author$project$Pages$Marketplace$Athenahealth$Manage$Settings$RefreshAthenaDepartments),
											$author$project$Ui$Button$icon($author$project$Ui$Icon$repeat)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Refresh athenahealth Departments')
										]))
								]))
						])),
					$author$project$Ui$HorizontalRule$view(_List_Nil),
					function () {
					var _v1 = model.it;
					if (_v1.$ === 3) {
						var athenaDepartments = _v1.a;
						return A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							A2(
								$elm$core$List$map,
								A2($author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewAthenaLocationMapping, model.jz, athenaDepartments),
								athenaLocationMappings));
					} else {
						return $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewLocationsListSkeleton;
					}
				}()
				]));
	} else {
		return $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewLocationsStepSkeleton;
	}
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewLocationsStep = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewStatusWithDeactivate(model),
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				A2(
				$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewStepBreadcrumbs,
				$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$integrationExists(model),
				2),
				A2($elm$html$Html$br, _List_Nil, _List_Nil),
				$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewLocationsContent(model)
			]));
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$ToggleNewPatientCreation = function (a) {
	return {$: 38, a: a};
};
var $author$project$Api$Provider$AthenaConfiguration$Shared$allowNewPatientCreation = function (_v0) {
	var record = _v0;
	return record.Lx;
};
var $author$project$Api$Provider$AthenaConfiguration$One$allowNewPatientCreation = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$AthenaConfiguration$Shared$allowNewPatientCreation(shared);
};
var $author$project$Api$Provider$AthenaConfiguration$Shared$ignoredFields = function (_v0) {
	var record = _v0;
	return record.TO;
};
var $author$project$Api$Provider$AthenaConfiguration$One$ignoredFields = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$AthenaConfiguration$Shared$ignoredFields(shared);
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewOverviewStepSkeleton = A2(
	$author$project$Ui$Element$view,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSkeleton('Number of Locations Linked to Departments'),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$spanFromText('100')
								]))
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSkeleton('Number of Custom Fields Linked'),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$spanFromText('100')
								]))
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSkeleton('Number of Providers Linked'),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$spanFromText('100')
								]))
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSkeleton('Create patients from athenahealth'),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$input(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$spanMd(2),
							$author$project$Ui$Skeleton$span(3)
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$block,
									$author$project$Ui$Skeleton$span(6)
								])),
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$block,
									$author$project$Ui$Skeleton$span(7)
								])),
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$block,
									$author$project$Ui$Skeleton$span(5)
								]))
						]))
				]))
		]));
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewOverviewStep = function (model) {
	var _v0 = $author$project$Api$Data$toMaybe(model.A);
	if (!_v0.$) {
		var athenaConfiguration = _v0.a;
		var allowNewPatientCreation = $author$project$Api$Provider$AthenaConfiguration$One$allowNewPatientCreation(athenaConfiguration);
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewStatusWithDeactivate(model),
					$author$project$Ui$HorizontalRule$view(_List_Nil),
					A2(
					$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewStepBreadcrumbs,
					$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$integrationExists(model),
					5),
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('Number of Locations Linked to Departments'),
							$author$project$Ui$Form$Group$labelSpanSm(4),
							$author$project$Ui$Form$Group$inputSpanSm(8)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									function () {
									var _v1 = model.om;
									if (!_v1.$) {
										var linkedLocationsCount = _v1.a;
										return $elm$html$Html$text(
											$elm$core$String$fromInt(linkedLocationsCount));
									} else {
										return $author$project$Ui$Skeleton$text(
											_List_fromArray(
												[
													$author$project$Ui$Skeleton$spanFromText('100')
												]));
									}
								}()
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('Number of Custom Fields Linked'),
							$author$project$Ui$Form$Group$labelSpanSm(4),
							$author$project$Ui$Form$Group$inputSpanSm(8)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									function () {
									var _v2 = model.ol;
									if (!_v2.$) {
										var linkedFieldsCount = _v2.a;
										return $elm$html$Html$text(
											$elm$core$String$fromInt(linkedFieldsCount));
									} else {
										return $author$project$Ui$Skeleton$text(
											_List_fromArray(
												[
													$author$project$Ui$Skeleton$spanFromText('100')
												]));
									}
								}()
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('Number of Providers Linked'),
							$author$project$Ui$Form$Group$labelSpanSm(4),
							$author$project$Ui$Form$Group$inputSpanSm(8)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									function () {
									var _v3 = model.on;
									if (!_v3.$) {
										var linkedProvidersCount = _v3.a;
										return $elm$html$Html$text(
											$elm$core$String$fromInt(linkedProvidersCount));
									} else {
										return $author$project$Ui$Skeleton$text(
											_List_fromArray(
												[
													$author$project$Ui$Skeleton$spanFromText('100')
												]));
									}
								}()
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('Create patients from athenahealth'),
							$author$project$Ui$Form$Group$labelSpanSm(4),
							$author$project$Ui$Form$Group$inputSpanSm(8)
						]),
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$view(
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$on(allowNewPatientCreation),
									$author$project$Ui$ToggleSwitch$onChange($author$project$Pages$Marketplace$Athenahealth$Manage$Settings$ToggleNewPatientCreation),
									$author$project$Ui$ToggleSwitch$disabled(
									_Utils_eq(model.k9, $author$project$Api$Data$Loading))
								])),
							allowNewPatientCreation ? A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$helpBlock]),
									_List_fromArray(
										[
											$elm$html$Html$text('Update linked patients with changes from athenahealth. If a patient is '),
											$elm$html$Html$text('not found, create a new record in Hint. This is suggested for direct '),
											$elm$html$Html$text('care practices.')
										])),
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$helpBlock]),
									_List_fromArray(
										[
											$elm$html$Html$text('Note: Only patients in athenahealth departments linked to Hint will be '),
											$elm$html$Html$text('created in Hint.')
										]))
								])) : A2(
							$author$project$Ui$Typography$p,
							_List_fromArray(
								[$author$project$Ui$Typography$helpBlock]),
							_List_fromArray(
								[
									$elm$html$Html$text('Update linked patients with changes from athenahealth. If a patient is not found, '),
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$bold]),
									'do not create'),
									$elm$html$Html$text(' a record in Hint. This is suggested for hybrid practices '),
									$elm$html$Html$text('that have both fee-for-service as well as direct care patients.')
								]))
						])),
					$elm$core$List$isEmpty(
					$author$project$Api$Provider$AthenaConfiguration$One$ignoredFields(athenaConfiguration)) ? $author$project$Utils$Html$empty : A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('Fields excluded from the sync'),
							$author$project$Ui$Form$Group$labelSpanSm(4),
							$author$project$Ui$Form$Group$inputSpanSm(8)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$String$join,
										', ',
										$author$project$Api$Provider$AthenaConfiguration$One$ignoredFields(athenaConfiguration)))
								]))
						]))
				]));
	} else {
		return $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewOverviewStepSkeleton;
	}
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$RefreshAthenaProviders = {$: 26};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$EditAthenaProviderMapping = function (a) {
	return {$: 27, a: a};
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$UpdateProviderMapping = F2(
	function (a, b) {
		return {$: 28, a: a, b: b};
	});
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$displayProviderName = F2(
	function (name, providerGroups) {
		if (!providerGroups.$) {
			var providerGroupIds = providerGroups.a;
			return $elm$core$String$concat(
				_List_fromArray(
					[
						name,
						' (Provider Group: ',
						A2(
						$elm$core$String$join,
						', ',
						A2(
							$elm$core$List$map,
							function (id) {
								return '#' + id;
							},
							providerGroupIds)),
						')'
					]));
		} else {
			return name;
		}
	});
var $author$project$Api$Provider$Integration$Athena$Provider$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Integration$Athena$Provider$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Integration$Athena$Provider$Shared$id(shared);
};
var $author$project$Api$Provider$Integration$Athena$Provider$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$Integration$Athena$Provider$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Integration$Athena$Provider$Shared$name(shared);
};
var $author$project$Api$Provider$Integration$Athena$Provider$Shared$providerGroups = function (_v0) {
	var record = _v0;
	return record._F;
};
var $author$project$Api$Provider$Integration$Athena$Provider$All$providerGroups = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Integration$Athena$Provider$Shared$providerGroups(shared);
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$athenaProvidersOptions = function (athenaProviders) {
	return A2(
		$elm$core$List$cons,
		A3(
			$author$project$Ui$Form$Select$option,
			_List_fromArray(
				[
					$author$project$Ui$Form$Select$itemDisabled(true)
				]),
			$elm$core$Maybe$Nothing,
			'Choose athenahealth Provider'),
		A2(
			$elm$core$List$cons,
			A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(''),
				'Unlink this Provider'),
			A2(
				$elm$core$List$map,
				function (athenaProvider) {
					return A3(
						$author$project$Ui$Form$Select$option,
						_List_Nil,
						$elm$core$Maybe$Just(
							$elm$core$String$fromInt(
								$author$project$Api$Provider$Integration$Athena$Provider$All$id(athenaProvider))),
						A2(
							$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$displayProviderName,
							$author$project$Api$Provider$Integration$Athena$Provider$All$name(athenaProvider),
							$author$project$Api$Provider$Integration$Athena$Provider$All$providerGroups(athenaProvider)));
				},
				athenaProviders)));
};
var $author$project$Api$Provider$Integration$Athena$ProviderMapping$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$Integration$Athena$ProviderMapping$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Integration$Athena$ProviderMapping$Shared$name(shared);
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewAthenaProviderMapping = F3(
	function (editingProviderMappings, athenaProviders, athenaProviderMapping) {
		var isEditingAthenaProviderMapping = A2(
			$elm$core$Set$member,
			$author$project$Api$Provider$Integration$Athena$ProviderMapping$All$id(athenaProviderMapping),
			editingProviderMappings);
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(6)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Hint provider: '),
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$bold]),
									$author$project$Api$Provider$Integration$Athena$ProviderMapping$All$name(athenaProviderMapping))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanMd(1)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Icon$arrowRight(_List_Nil)
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(2)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('athenahealth provider: ')
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(3)
								]),
							_List_fromArray(
								[
									function () {
									if (isEditingAthenaProviderMapping) {
										return A2(
											$author$project$Ui$Form$Select$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Select$value(
													$author$project$Api$Provider$Integration$Athena$ProviderMapping$All$externalId(athenaProviderMapping)),
													$author$project$Ui$Form$Select$onChange(
													$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$UpdateProviderMapping(athenaProviderMapping))
												]),
											$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$athenaProvidersOptions(athenaProviders));
									} else {
										var athenaProvider = A2(
											$elm_community$list_extra$List$Extra$find,
											function (athenaProvider_) {
												return _Utils_eq(
													$elm$core$Maybe$Just(
														$elm$core$String$fromInt(
															$author$project$Api$Provider$Integration$Athena$Provider$All$id(athenaProvider_))),
													$author$project$Api$Provider$Integration$Athena$ProviderMapping$All$externalId(athenaProviderMapping));
											},
											athenaProviders);
										var chosenProvider = function () {
											if (!athenaProvider.$) {
												var provider_ = athenaProvider.a;
												return A2(
													$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$displayProviderName,
													$author$project$Api$Provider$Integration$Athena$Provider$All$name(provider_),
													$author$project$Api$Provider$Integration$Athena$Provider$All$providerGroups(provider_));
											} else {
												return 'Not linked';
											}
										}();
										return A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$spaceBetween]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$text,
													_List_fromArray(
														[$author$project$Ui$Typography$bold]),
													chosenProvider),
													A3(
													$author$project$Ui$Button$view,
													{mm: 'Edit provider mapping'},
													_List_fromArray(
														[
															$author$project$Ui$Button$link,
															$author$project$Ui$Button$sm,
															$author$project$Ui$Button$onClick(
															$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$EditAthenaProviderMapping(athenaProviderMapping)),
															$author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Edit')
														]))
												]));
									}
								}()
								]))
						])),
					$author$project$Ui$HorizontalRule$view(_List_Nil)
				]));
	});
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewProvidersListSkeleton = A2(
	$author$project$Ui$Element$view,
	_List_Nil,
	A2(
		$elm$core$List$repeat,
		10,
		A2(
			$author$project$Ui$Grid$row,
			_List_fromArray(
				[$author$project$Ui$Grid$rowItemsCenter]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(6)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$spanFromText('Platform Provider: ')
										]))
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$span(8),
											$author$project$Ui$Skeleton$spanMd(4)
										]))
								]))
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanMd(1)
						]),
					_List_Nil),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(2)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$spanFromText('athenahealth provider: ')
								]))
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(3)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$input(_List_Nil)
						]))
				]))));
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewProvidersStepSkeleton = A2(
	$author$project$Ui$Element$view,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanLg(9),
							$author$project$Ui$Grid$spanMd(8),
							$author$project$Ui$Grid$spanSm(7)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$spanFromText('Link Providers')
										]))
								])),
							A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$spanFromText('Keep the primary provider in athenahealth in sync with the the assigned provider in HintOS.')
										]))
								]))
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanLg(3),
							$author$project$Ui$Grid$spanMd(4),
							$author$project$Ui$Grid$spanSm(5),
							$author$project$Ui$Grid$justifyRight
						]),
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$input(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$spanFromText('Refresh athenahealth Providers')
								]))
						]))
				])),
			$author$project$Ui$HorizontalRule$view(_List_Nil),
			$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewProvidersListSkeleton
		]));
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewProvidersContent = function (model) {
	var _v0 = model.iu;
	if (_v0.$ === 3) {
		var athenaProviderMappings = _v0.a;
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanLg(9),
									$author$project$Ui$Grid$spanMd(8),
									$author$project$Ui$Grid$spanSm(7)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Typography$headingSm(
									_List_fromArray(
										[
											$elm$html$Html$text('Link Providers')
										])),
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Keep the primary provider in athenahealth in sync with the the assigned provider in HintOS.')
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanLg(3),
									$author$project$Ui$Grid$spanMd(4),
									$author$project$Ui$Grid$spanSm(5),
									$author$project$Ui$Grid$justifyRight
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Refresh athenahealth Providers'},
									_List_fromArray(
										[
											$author$project$Ui$Button$onClick($author$project$Pages$Marketplace$Athenahealth$Manage$Settings$RefreshAthenaProviders),
											$author$project$Ui$Button$icon($author$project$Ui$Icon$repeat)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Refresh athenahealth Providers')
										]))
								]))
						])),
					$author$project$Ui$HorizontalRule$view(_List_Nil),
					function () {
					var _v1 = model.iv;
					if (_v1.$ === 3) {
						var athenaProviders = _v1.a;
						return A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							A2(
								$elm$core$List$map,
								A2($author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewAthenaProviderMapping, model.jA, athenaProviders),
								athenaProviderMappings));
					} else {
						return $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewProvidersListSkeleton;
					}
				}()
				]));
	} else {
		return $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewProvidersStepSkeleton;
	}
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewProvidersStep = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewStatusWithDeactivate(model),
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				A2(
				$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewStepBreadcrumbs,
				$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$integrationExists(model),
				4),
				A2($elm$html$Html$br, _List_Nil, _List_Nil),
				$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewProvidersContent(model)
			]));
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewPanel = function (model) {
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Typography$heading(
						_List_fromArray(
							[
								$elm$html$Html$text('athenahealth')
							]))
					])),
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				function () {
					var _v0 = model.A;
					if (_v0.$ === 1) {
						return _List_fromArray(
							[$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewInitialStepSkeleton]);
					} else {
						return _List_fromArray(
							[
								function () {
								var _v1 = model.acf;
								switch (_v1) {
									case 0:
										return $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewInitialStep(model);
									case 1:
										return $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewLinkStep(model);
									case 2:
										return $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewLocationsStep(model);
									case 3:
										return $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewFieldsStep(model);
									case 4:
										return $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewProvidersStep(model);
									default:
										return $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewOverviewStep(model);
								}
							}()
							]);
					}
				}()),
				$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewFooter(model)
			]));
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewDisableModal(model),
				$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewBulkSyncModal(model),
				function () {
				var _v0 = model.acf;
				if (_v0 === 1) {
					return A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$noValidate(true),
								$author$project$Ui$Form$autocomplete(false),
								$author$project$Ui$Form$onSubmit($author$project$Pages$Marketplace$Athenahealth$Manage$Settings$SaveLink)
							]),
						_List_fromArray(
							[
								$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewPanel(model)
							]));
				} else {
					return A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$noValidate(true),
								$author$project$Ui$Form$autocomplete(false)
							]),
						_List_fromArray(
							[
								$author$project$Pages$Marketplace$Athenahealth$Manage$Settings$viewPanel(model)
							]));
				}
			}()
			]),
		ac9: 'Marketplace | athenahealth Settings'
	};
};
var $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$init, aiq: $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$load, k8: $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$save, alO: $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$subscriptions, adT: $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$update, amo: $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$view});
var $author$project$Pages$Marketplace$Bookkeeping$Manage$Settings$GotLayerAccount = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Marketplace$Bookkeeping$Manage$Settings$init = F4(
	function (session, practice, shared, _v0) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, np: $elm$core$Maybe$Nothing, AA: $author$project$Api$Data$Loading, ZV: practice, aa4: session},
			A2($author$project$Api$Provider$Practice$LayerAccount$retrieve, shared.Gv, $author$project$Pages$Marketplace$Bookkeeping$Manage$Settings$GotLayerAccount));
	});
var $author$project$Pages$Marketplace$Bookkeeping$Manage$Settings$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Marketplace$Bookkeeping$Manage$Settings$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Marketplace$Bookkeeping$Manage$Settings$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Marketplace$Bookkeeping$Manage$Settings$EditFormMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Layer$EditForm$Model = $elm$core$Basics$identity;
var $author$project$Api$Provider$LayerAccount$One$entityType = function (_v0) {
	var record = _v0.b;
	return record.RI;
};
var $author$project$Components$Layer$EditForm$initPhone = function (maybePhone) {
	var phoneToUse = A2(
		$elm$core$Maybe$withDefault,
		{IO: '', akD: 0, amg: $author$project$Api$Common$Phone$Shared$Mobile},
		A2($elm$core$Maybe$map, $author$project$Utils$Phone$fromApi, maybePhone));
	return A3(
		$author$project$Components$PhoneInput$init,
		'layer-account-phone',
		_List_fromArray(
			[phoneToUse]),
		function (opts) {
			return _Utils_update(
				opts,
				{aeW: false, agy: true, AU: 1});
		});
};
var $author$project$Api$Provider$LayerAccount$One$legalName = function (_v0) {
	var record = _v0.b;
	return record.VU;
};
var $author$project$Api$Provider$LayerAccount$One$phone = function (_v0) {
	var record = _v0.b;
	return record.Zw;
};
var $author$project$Api$Provider$LayerAccount$One$smsEnabled = function (_v0) {
	var record = _v0.b;
	return record.abI;
};
var $author$project$Api$Provider$LayerAccount$One$state = function (_v0) {
	var record = _v0.b;
	return record.uP;
};
var $author$project$Api$Provider$LayerAccount$One$tin = function (_v0) {
	var record = _v0.b;
	return record.ac8;
};
var $author$project$Components$Layer$EditForm$formFieldsInit = function (layerAccount) {
	return {
		RI: $author$project$Api$Provider$LayerAccount$One$entityType(layerAccount),
		VU: $author$project$Api$Provider$LayerAccount$One$legalName(layerAccount),
		Zw: $author$project$Components$Layer$EditForm$initPhone(
			$author$project$Api$Provider$LayerAccount$One$phone(layerAccount)),
		abI: $author$project$Api$Provider$LayerAccount$One$smsEnabled(layerAccount),
		uP: $author$project$Api$Provider$LayerAccount$One$state(layerAccount),
		ac8: $author$project$Api$Provider$LayerAccount$One$tin(layerAccount)
	};
};
var $author$project$Components$Layer$EditForm$init = function (layerAccount) {
	var model = {
		MN: $author$project$Api$Provider$LayerAccount$One$bookkeepingEnabled(layerAccount),
		SD: $author$project$Utils$Form$init(
			$author$project$Components$Layer$EditForm$formFieldsInit(layerAccount)),
		k9: $author$project$Api$Data$NotAsked
	};
	return model;
};
var $author$project$Components$Layer$EditForm$GotLayerAccountUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Layer$EditForm$Phone = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Layer$EditForm$PhoneInputMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Layer$EditForm$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						VU: $author$project$Utils$String$toMaybe(string)
					});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						ac8: $author$project$Utils$String$toMaybe(string)
					});
			case 2:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						uP: $author$project$Utils$String$toMaybe(string)
					});
			case 3:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						RI: $author$project$Utils$String$toMaybe(string)
					});
			case 4:
				var phone = field.a;
				return _Utils_update(
					fields,
					{Zw: phone});
			default:
				var bool = field.a;
				return _Utils_update(
					fields,
					{abI: bool});
		}
	});
var $author$project$Api$Provider$Practice$LayerAccount$update = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'layer_account',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'legal_name',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.VU)),
								_Utils_Tuple2(
								'tin',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ac8)),
								_Utils_Tuple2(
								'state',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.uP)),
								_Utils_Tuple2(
								'entity_type',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.RI)),
								_Utils_Tuple2(
								'phone_number',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Zx)),
								_Utils_Tuple2(
								'sms_enabled',
								$elm$json$Json$Encode$bool(fields.abI))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$LayerAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$LayerAccount$layerAccountPath)));
	});
var $author$project$Components$Layer$EditForm$EntityTypeValidation = 3;
var $author$project$Components$Layer$EditForm$LegalNameValidation = 0;
var $author$project$Components$Layer$EditForm$PhoneValidation = 4;
var $author$project$Components$Layer$EditForm$StateValidation = 2;
var $author$project$Components$Layer$EditForm$formFieldsValidator = function () {
	var validatePhone = function (_v0) {
		var phone = _v0.Zw;
		return $author$project$Components$PhoneInput$hasErrors(phone) ? _List_fromArray(
			[
				_Utils_Tuple2(4, '')
			]) : _List_Nil;
	};
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_validate$Validate$ifNothing,
				function ($) {
					return $.VU;
				},
				_Utils_Tuple2(0, 'Please enter a legal name.')),
				A2(
				$rtfeldman$elm_validate$Validate$ifNothing,
				function ($) {
					return $.uP;
				},
				_Utils_Tuple2(2, 'Please select a state.')),
				A2(
				$rtfeldman$elm_validate$Validate$ifNothing,
				function ($) {
					return $.RI;
				},
				_Utils_Tuple2(3, 'Please enter an entity type.')),
				$rtfeldman$elm_validate$Validate$fromErrors(validatePhone)
			]));
}();
var $author$project$Components$Layer$EditForm$validate = function (model) {
	var fields = $author$project$Utils$Form$fields(model.SD);
	var form_ = A2(
		$author$project$Utils$Form$set,
		_Utils_update(
			fields,
			{
				Zw: $author$project$Components$PhoneInput$validate(fields.Zw)
			}),
		model.SD);
	return A2(
		$elm$core$Result$mapError,
		function (validatedForm) {
			return _Utils_update(
				model,
				{SD: validatedForm});
		},
		A2(
			$elm$core$Result$map,
			function (_v0) {
				var validatedForm = _v0.a;
				var validFormFields = _v0.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{SD: validatedForm}),
					validFormFields);
			},
			A2($author$project$Utils$Form$validate, $author$project$Components$Layer$EditForm$formFieldsValidator, form_)));
};
var $author$project$Components$Layer$EditForm$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Layer$EditForm$formFieldsUpdate, field, model.SD);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: newForm}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var subMsg = msg.a;
				var _v2 = $author$project$Utils$Form$fields(model.SD);
				var phone = _v2.Zw;
				var _v3 = A2($author$project$Components$PhoneInput$update, subMsg, phone);
				var phoneInput = _v3.a;
				var phoneCmd = _v3.b;
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Layer$EditForm$formFieldsUpdate,
					$author$project$Components$Layer$EditForm$Phone(phoneInput),
					model.SD);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: newForm}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Layer$EditForm$PhoneInputMsg, phoneCmd),
					_List_Nil);
			case 2:
				var _v4 = $author$project$Components$Layer$EditForm$validate(model);
				if (!_v4.$) {
					var _v5 = _v4.a;
					var newModel = _v5.a;
					var validFormFields = _v5.b;
					var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
					var phoneNumber = A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.IO;
						},
						A2(
							$elm$core$Maybe$map,
							$author$project$Utils$Phone$toRecord,
							$elm$core$List$head(
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									$author$project$Components$PhoneInput$getPhones(fields.Zw)))));
					var apiFields = {RI: fields.RI, VU: fields.VU, Zx: phoneNumber, abI: fields.abI, uP: fields.uP, ac8: fields.ac8};
					return _Utils_Tuple3(
						_Utils_update(
							newModel,
							{k9: $author$project$Api$Data$Loading}),
						A3($author$project$Api$Provider$Practice$LayerAccount$update, apiClient, apiFields, $author$project$Components$Layer$EditForm$GotLayerAccountUpdated),
						_List_Nil);
				} else {
					var newModel = _v4.a;
					return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: response}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Account updated successfully')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Marketplace$Bookkeeping$Manage$Settings$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var response = msg.a;
			if (response.$ === 3) {
				var layerAccount = response.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							np: $elm$core$Maybe$Just(
								$author$project$Components$Layer$EditForm$init(layerAccount)),
							AA: response
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			} else {
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{AA: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			}
		} else {
			var editFormMsg = msg.a;
			var _v2 = model.np;
			if (!_v2.$) {
				var editForm = _v2.a;
				var _v3 = A3($author$project$Components$Layer$EditForm$update, model.Gv, editFormMsg, editForm);
				var newEditForm = _v3.a;
				var editFormCmd = _v3.b;
				var outMsgs = _v3.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							np: $elm$core$Maybe$Just(newEditForm)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Marketplace$Bookkeeping$Manage$Settings$EditFormMsg, editFormCmd),
					outMsgs);
			} else {
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
			}
		}
	});
var $author$project$Components$Layer$EditForm$UpdateLayerAccount = {$: 2};
var $author$project$Components$Layer$EditForm$viewCountryInput = A2(
	$author$project$Ui$Form$Group$view,
	_List_fromArray(
		[
			$author$project$Ui$Form$Group$labelSpan(4),
			$author$project$Ui$Form$Group$inputSpan(8),
			$author$project$Ui$Form$Group$label('Country')
		]),
	_List_fromArray(
		[
			$author$project$Ui$Form$Input$view(
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$value('United States'),
					$author$project$Ui$Form$Input$disabled(true)
				]))
		]));
var $author$project$Components$Layer$EditForm$EntityType = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Layer$EditForm$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Layer$EditForm$entityTypeOptions = A2(
	$elm$core$List$map,
	function (_v0) {
		var type_ = _v0.a;
		var label = _v0.b;
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(type_),
			label);
	},
	_List_fromArray(
		[
			_Utils_Tuple2('', 'Select an entity type'),
			_Utils_Tuple2('SOLE_PROP', 'Sole Proprietor'),
			_Utils_Tuple2('C_CORP', 'C Corp'),
			_Utils_Tuple2('LLC', 'LLC'),
			_Utils_Tuple2('S_CORP', 'S Corp'),
			_Utils_Tuple2('PARTNERSHIP', 'Partnership')
		]));
var $author$project$Components$Layer$EditForm$viewEntityTypeInput = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var entityType = _v0.RI;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('Entity Type'),
				$author$project$Ui$Form$Group$required(true)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Select$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Select$value(entityType),
						$author$project$Ui$Form$Select$onChange(
						A2($elm$core$Basics$composeL, $author$project$Components$Layer$EditForm$FormUpdated, $author$project$Components$Layer$EditForm$EntityType)),
						$author$project$Ui$Form$Select$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 3, form)),
						$author$project$Ui$Form$Select$errors(
						A2($author$project$Utils$Form$validationErrors, 3, form))
					]),
				$author$project$Components$Layer$EditForm$entityTypeOptions)
			]));
};
var $author$project$Components$Layer$EditForm$LegalName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Layer$EditForm$viewLegalNameInput = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var legalName = _v0.VU;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$required(true),
				$author$project$Ui$Form$Group$label('Legal Name')
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$value(
						A2($elm$core$Maybe$withDefault, '', legalName)),
						$author$project$Ui$Form$Input$placeholder('Legal Name'),
						$author$project$Ui$Form$Input$autofocus(true),
						$author$project$Ui$Form$Input$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Layer$EditForm$FormUpdated, $author$project$Components$Layer$EditForm$LegalName)),
						$author$project$Ui$Form$Input$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
						$author$project$Ui$Form$Input$errors(
						A2($author$project$Utils$Form$validationErrors, 0, form))
					]))
			]));
};
var $author$project$Components$Layer$EditForm$viewPhoneNumberInput = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var phone = _v0.Zw;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('Phone Number')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Layer$EditForm$PhoneInputMsg,
				$author$project$Components$PhoneInput$view(phone))
			]));
};
var $author$project$Components$Layer$EditForm$SmsEnabled = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Layer$EditForm$viewSmsEnabledInput = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var smsEnabled = _v0.abI;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Checkbox$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Checkbox$value(smsEnabled),
						$author$project$Ui$Form$Checkbox$onCheck(
						A2($elm$core$Basics$composeL, $author$project$Components$Layer$EditForm$FormUpdated, $author$project$Components$Layer$EditForm$SmsEnabled))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('I agree to receive SMS messages at the phone number provided above')
					]))
			]));
};
var $author$project$Components$Layer$EditForm$State = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Layer$EditForm$stateOptions = A2(
	$elm$core$List$map,
	function (_v0) {
		var code = _v0.a;
		var label = _v0.b;
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(code),
			label);
	},
	A2(
		$elm$core$List$cons,
		_Utils_Tuple2('', 'Select a state'),
		$author$project$Utils$State$list));
var $author$project$Components$Layer$EditForm$viewStateInput = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var state = _v0.uP;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('State'),
				$author$project$Ui$Form$Group$required(true)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Select$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Select$value(state),
						$author$project$Ui$Form$Select$onChange(
						A2($elm$core$Basics$composeL, $author$project$Components$Layer$EditForm$FormUpdated, $author$project$Components$Layer$EditForm$State)),
						$author$project$Ui$Form$Select$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
						$author$project$Ui$Form$Select$errors(
						A2($author$project$Utils$Form$validationErrors, 2, form))
					]),
				$author$project$Components$Layer$EditForm$stateOptions)
			]));
};
var $author$project$Components$Layer$EditForm$Tin = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Layer$EditForm$TinValidation = 1;
var $author$project$Components$Layer$EditForm$viewTinInput = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var tin = _v0.ac8;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('TIN')
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$value(
						A2($elm$core$Maybe$withDefault, '', tin)),
						$author$project$Ui$Form$Input$placeholder('123456789'),
						$author$project$Ui$Form$Input$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Layer$EditForm$FormUpdated, $author$project$Components$Layer$EditForm$Tin)),
						$author$project$Ui$Form$Input$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
						$author$project$Ui$Form$Input$errors(
						A2($author$project$Utils$Form$validationErrors, 1, form))
					]))
			]));
};
var $author$project$Components$Layer$EditForm$view = function (_v0) {
	var model = _v0;
	return A2(
		$author$project$Ui$Form$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$onSubmit($author$project$Components$Layer$EditForm$UpdateLayerAccount)
			]),
		_List_fromArray(
			[
				$author$project$Components$Layer$EditForm$viewLegalNameInput(model.SD),
				$author$project$Components$Layer$EditForm$viewTinInput(model.SD),
				$author$project$Components$Layer$EditForm$viewStateInput(model.SD),
				$author$project$Components$Layer$EditForm$viewCountryInput,
				$author$project$Components$Layer$EditForm$viewEntityTypeInput(model.SD),
				model.MN ? $author$project$Components$Layer$EditForm$viewPhoneNumberInput(model.SD) : $elm$html$Html$text(''),
				model.MN ? $author$project$Components$Layer$EditForm$viewSmsEnabledInput(model.SD) : $elm$html$Html$text(''),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$mt4]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Save account'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$submit,
								$author$project$Ui$Button$loading(
								_Utils_eq(model.k9, $author$project$Api$Data$Loading))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Save')
							]))
					]))
			]));
};
var $author$project$Pages$Marketplace$Bookkeeping$Manage$Settings$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				function () {
				var _v0 = model.np;
				if (!_v0.$) {
					var editForm = _v0.a;
					return A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Pages$Marketplace$Bookkeeping$Manage$Settings$EditFormMsg,
										$author$project$Components$Layer$EditForm$view(editForm))
									]))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]),
		ac9: 'Layer Settings'
	};
};
var $author$project$Pages$Marketplace$Bookkeeping$Manage$Settings$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Marketplace$Bookkeeping$Manage$Settings$init, aiq: $author$project$Pages$Marketplace$Bookkeeping$Manage$Settings$load, k8: $author$project$Pages$Marketplace$Bookkeeping$Manage$Settings$save, alO: $author$project$Pages$Marketplace$Bookkeeping$Manage$Settings$subscriptions, adT: $author$project$Pages$Marketplace$Bookkeeping$Manage$Settings$update, amo: $author$project$Pages$Marketplace$Bookkeeping$Manage$Settings$view});
var $author$project$Pages$Marketplace$Elation$Manage$Settings$GotElation = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Marketplace$Elation$Manage$Settings$Initial = 0;
var $author$project$Api$Provider$ElationConfiguration$One$ElationConfiguration = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$ElationConfiguration$Shared$ElationConfiguration = $elm$core$Basics$identity;
var $author$project$Api$Provider$ElationConfiguration$Shared$Record = F5(
	function (status, allowNewPatientCreation, sendEligibilityStatusTag, elationPracticeName, elationPracticeId) {
		return {Lx: allowNewPatientCreation, Rc: elationPracticeId, Rd: elationPracticeName, aaT: sendEligibilityStatusTag, alH: status};
	});
var $author$project$Api$Provider$ElationConfiguration$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'elation_practice_id',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'elation_practice_name',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'send_eligibility_status_tag',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'allow_new_patient_creation',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'status',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$ElationConfiguration$Shared$Record))))));
var $author$project$Api$Provider$ElationConfiguration$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ElationConfiguration$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$ElationConfiguration$One$Record = function (practitionersCount) {
	return {Z5: practitionersCount};
};
var $author$project$Api$Provider$ElationConfiguration$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'practitioners_count',
	$elm$json$Json$Decode$int,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$ElationConfiguration$One$Record));
var $author$project$Api$Provider$ElationConfiguration$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ElationConfiguration$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$ElationConfiguration$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$ElationConfiguration$One$ElationConfiguration)));
var $author$project$Api$Provider$Integration$Elation$elationPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['elation_configuration']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Integration$Elation$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$ElationConfiguration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Elation$elationPath));
	});
var $author$project$Pages$Marketplace$Elation$Manage$Settings$init = F4(
	function (_v0, _v1, shared, _v2) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, eq: $elm$core$Maybe$Nothing, jA: $elm$core$Set$empty, at: $author$project$Api$Data$Loading, ns: $author$project$Api$Data$NotAsked, nt: $author$project$Api$Data$NotAsked, SD: $elm$core$Maybe$Nothing, sF: shared.sF, k9: $author$project$Api$Data$NotAsked, acf: 0},
			A2($author$project$Api$Provider$Integration$Elation$retrieve, shared.Gv, $author$project$Pages$Marketplace$Elation$Manage$Settings$GotElation));
	});
var $author$project$Pages$Marketplace$Elation$Manage$Settings$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Marketplace$Elation$Manage$Settings$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Marketplace$Elation$Manage$Settings$DisableConfirmed = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$Marketplace$Elation$Manage$Settings$subscriptions = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Platform$Sub$none,
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$always(
				$author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Marketplace$Elation$Manage$Settings$DisableConfirmed)),
			model.eq));
};
var $author$project$Pages$Marketplace$Elation$Manage$Settings$Activated = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Marketplace$Elation$Manage$Settings$Disabled = function (a) {
	return {$: 20, a: a};
};
var $author$project$Pages$Marketplace$Elation$Manage$Settings$GotElationProviderMappings = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Marketplace$Elation$Manage$Settings$GotElationProviders = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Marketplace$Elation$Manage$Settings$GotProviderMapping = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Marketplace$Elation$Manage$Settings$LinkStep = 1;
var $author$project$Pages$Marketplace$Elation$Manage$Settings$OverviewStep = 3;
var $author$project$Pages$Marketplace$Elation$Manage$Settings$ProvidersStep = 2;
var $author$project$Pages$Marketplace$Elation$Manage$Settings$Updated = function (a) {
	return {$: 17, a: a};
};
var $author$project$Api$Provider$Integration$Elation$activate = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$ElationConfiguration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['activate']),
					$author$project$Api$Provider$Integration$Elation$elationPath)));
	});
var $author$project$Api$Provider$ElationConfiguration$Shared$allowNewPatientCreation = function (_v0) {
	var record = _v0;
	return record.Lx;
};
var $author$project$Api$Provider$ElationConfiguration$One$allowNewPatientCreation = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ElationConfiguration$Shared$allowNewPatientCreation(shared);
};
var $author$project$Pages$Marketplace$Elation$Manage$Settings$Created = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Integration$Elation$create = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'elation_configuration',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'username',
								$elm$json$Json$Encode$string(fields.amm)),
								_Utils_Tuple2(
								'password',
								$elm$json$Json$Encode$string(fields.ajR)),
								_Utils_Tuple2(
								'client_id',
								$elm$json$Json$Encode$string(fields.afH)),
								_Utils_Tuple2(
								'client_secret',
								$elm$json$Json$Encode$string(fields.afI))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$ElationConfiguration$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Elation$elationPath)));
	});
var $author$project$Pages$Marketplace$Elation$Manage$Settings$createElation = F2(
	function (apiClient, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A3($author$project$Api$Provider$Integration$Elation$create, apiClient, fields, $author$project$Pages$Marketplace$Elation$Manage$Settings$Created);
	});
var $author$project$Api$Provider$Integration$Elation$delete = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Elation$elationPath));
	});
var $author$project$Pages$Marketplace$Elation$Manage$Settings$formFieldsInit = {afH: '', afI: '', ajR: '', amm: ''};
var $author$project$Pages$Marketplace$Elation$Manage$Settings$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{amm: string});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{ajR: string});
			case 2:
				var string = field.a;
				return _Utils_update(
					fields,
					{afH: string});
			default:
				var string = field.a;
				return _Utils_update(
					fields,
					{afI: string});
		}
	});
var $author$project$Pages$Marketplace$Elation$Manage$Settings$ClientIdValidation = 2;
var $author$project$Pages$Marketplace$Elation$Manage$Settings$ClientSecretValidation = 3;
var $author$project$Pages$Marketplace$Elation$Manage$Settings$PasswordValidation = 1;
var $author$project$Pages$Marketplace$Elation$Manage$Settings$UserNameValidation = 0;
var $author$project$Pages$Marketplace$Elation$Manage$Settings$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.amm;
			},
			_Utils_Tuple2(0, 'Please enter a username')),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.ajR;
			},
			_Utils_Tuple2(1, 'Please enter a password')),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.afH;
			},
			_Utils_Tuple2(2, 'Please enter a client id')),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.afI;
			},
			_Utils_Tuple2(3, 'Please enter a client secret'))
		]));
var $author$project$Api$Provider$Integration$Elation$ProviderMapping$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Integration$Elation$ProviderMapping$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Integration$Elation$ProviderMapping$Shared$id(shared);
};
var $author$project$Api$Provider$Integration$Elation$Provider$All$Provider = $elm$core$Basics$identity;
var $author$project$Api$Provider$Integration$Elation$Provider$Shared$Provider = $elm$core$Basics$identity;
var $author$project$Api$Provider$Integration$Elation$Provider$Shared$Record = F2(
	function (id, name) {
		return {ahP: id, Bq: name};
	});
var $author$project$Api$Provider$Integration$Elation$Provider$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Integration$Elation$Provider$Shared$Record)));
var $author$project$Api$Provider$Integration$Elation$Provider$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Integration$Elation$Provider$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Integration$Elation$Provider$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Integration$Elation$Provider$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Integration$Elation$Provider$providersPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['providers']),
	$author$project$Api$Provider$Integration$Elation$elationPath);
var $author$project$Api$Provider$Integration$Elation$Provider$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Integration$Elation$Provider$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Elation$Provider$providersPath));
	});
var $author$project$Api$Provider$Integration$Elation$ProviderMapping$All$ProviderMapping = $elm$core$Basics$identity;
var $author$project$Api$Provider$Integration$Elation$ProviderMapping$Shared$ProviderMapping = $elm$core$Basics$identity;
var $author$project$Api$Provider$Integration$Elation$ProviderMapping$Shared$Record = F3(
	function (id, name, externalId) {
		return {ag7: externalId, ahP: id, Bq: name};
	});
var $author$project$Api$Provider$Integration$Elation$ProviderMapping$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'external_id',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Integration$Elation$ProviderMapping$Shared$Record))));
var $author$project$Api$Provider$Integration$Elation$ProviderMapping$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Integration$Elation$ProviderMapping$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Integration$Elation$ProviderMapping$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Integration$Elation$ProviderMapping$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Integration$Elation$ProviderMapping$providerMappingsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['provider_mappings']),
	$author$project$Api$Provider$Integration$Elation$elationPath);
var $author$project$Api$Provider$Integration$Elation$ProviderMapping$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Integration$Elation$ProviderMapping$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Elation$ProviderMapping$providerMappingsPath));
	});
var $author$project$Api$Provider$ElationConfiguration$Shared$sendEligibilityStatusTag = function (_v0) {
	var record = _v0;
	return record.aaT;
};
var $author$project$Api$Provider$ElationConfiguration$One$sendEligibilityStatusTag = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ElationConfiguration$Shared$sendEligibilityStatusTag(shared);
};
var $author$project$Api$Provider$Integration$Elation$update = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'elation_configuration',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'allow_new_patient_creation',
								$elm$json$Json$Encode$bool(fields.Lx)),
								_Utils_Tuple2(
								'send_eligibility_status_tag',
								$elm$json$Json$Encode$bool(fields.aaT))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$ElationConfiguration$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Elation$elationPath)));
	});
var $author$project$Api$Provider$Integration$Elation$ProviderMapping$One$ProviderMapping = 0;
var $author$project$Api$Provider$Integration$Elation$ProviderMapping$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Provider$Integration$Elation$ProviderMapping$providerMappingPath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		$author$project$Api$Provider$Integration$Elation$ProviderMapping$providerMappingsPath);
};
var $author$project$Api$Provider$Integration$Elation$ProviderMapping$update = F4(
	function (apiClient, id, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'provider_mapping',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'external_id',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ag7))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Integration$Elation$ProviderMapping$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Integration$Elation$ProviderMapping$providerMappingPath(id))));
	});
var $author$project$Pages$Marketplace$Elation$Manage$Settings$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				_v1$2:
				while (true) {
					switch (response.$) {
						case 3:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{at: response, acf: 3}),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
						case 2:
							if (response.a.$ === 5) {
								var _v2 = response.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											at: response,
											SD: $elm$core$Maybe$Just(
												$author$project$Utils$Form$init($author$project$Pages$Marketplace$Elation$Manage$Settings$formFieldsInit)),
											acf: 0
										}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							} else {
								break _v1$2;
							}
						default:
							break _v1$2;
					}
				}
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{at: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							SD: $elm$core$Maybe$Just(
								$author$project$Utils$Form$init($author$project$Pages$Marketplace$Elation$Manage$Settings$formFieldsInit)),
							acf: 1
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var field = msg.a;
				var _v3 = model.SD;
				if (!_v3.$) {
					var form = _v3.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								SD: $elm$core$Maybe$Just(
									A3($author$project$Utils$Form$update, $author$project$Pages$Marketplace$Elation$Manage$Settings$formFieldsUpdate, field, form))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var _v4 = model.SD;
				if (!_v4.$) {
					var form = _v4.a;
					var _v5 = A2($author$project$Utils$Form$validate, $author$project$Pages$Marketplace$Elation$Manage$Settings$formFieldsValidator, form);
					if (!_v5.$) {
						var _v6 = _v5.a;
						var newForm = _v6.a;
						var validFormFields = _v6.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									SD: $elm$core$Maybe$Just(newForm),
									k9: $author$project$Api$Data$Loading
								}),
							A2($author$project$Pages$Marketplace$Elation$Manage$Settings$createElation, model.Gv, validFormFields),
							_List_Nil);
					} else {
						var newForm = _v5.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									SD: $elm$core$Maybe$Just(newForm)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{at: response, SD: $elm$core$Maybe$Nothing, k9: $author$project$Api$Data$NotAsked, acf: 3}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your elation credentials have been saved.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 5:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ns: $author$project$Api$Data$Loading, nt: $author$project$Api$Data$Loading, acf: 2}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Api$Provider$Integration$Elation$Provider$list, model.Gv, $author$project$Pages$Marketplace$Elation$Manage$Settings$GotElationProviders),
								A2($author$project$Api$Provider$Integration$Elation$ProviderMapping$list, model.Gv, $author$project$Pages$Marketplace$Elation$Manage$Settings$GotElationProviderMappings)
							])),
					_List_Nil);
			case 6:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{acf: 3}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 7:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nt: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 8:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jA: $elm$core$Set$empty, ns: response}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ns: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 9:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nt: $author$project$Api$Data$Loading}),
					A2($author$project$Api$Provider$Integration$Elation$Provider$list, model.Gv, $author$project$Pages$Marketplace$Elation$Manage$Settings$GotElationProviders),
					_List_Nil);
			case 10:
				var elationProviderMapping = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							jA: A2(
								$elm$core$Set$insert,
								$author$project$Api$Provider$Integration$Elation$ProviderMapping$All$id(elationProviderMapping),
								model.jA)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 11:
				var elationProviderMapping = msg.a;
				var elationProviderId = msg.b;
				return _Utils_Tuple3(
					model,
					A4(
						$author$project$Api$Provider$Integration$Elation$ProviderMapping$update,
						model.Gv,
						$author$project$Api$Provider$Integration$Elation$ProviderMapping$All$id(elationProviderMapping),
						{
							ag7: $author$project$Utils$String$toMaybe(elationProviderId)
						},
						$author$project$Pages$Marketplace$Elation$Manage$Settings$GotProviderMapping),
					_List_Nil);
			case 12:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						A2($author$project$Api$Provider$Integration$Elation$ProviderMapping$list, model.Gv, $author$project$Pages$Marketplace$Elation$Manage$Settings$GotElationProviderMappings),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your elation provider has been updated.')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 13:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{k9: $author$project$Api$Data$Loading}),
					A2($author$project$Api$Provider$Integration$Elation$activate, model.Gv, $author$project$Pages$Marketplace$Elation$Manage$Settings$Activated),
					_List_Nil);
			case 14:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{at: response, k9: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your elation integration has been activated.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 15:
				var allowNewPatientCreation = msg.a;
				var sendEligibilityStatusTag = A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						$author$project$Api$Provider$ElationConfiguration$One$sendEligibilityStatusTag,
						$author$project$Api$Data$toMaybe(model.at)));
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{k9: $author$project$Api$Data$Loading}),
					A3(
						$author$project$Api$Provider$Integration$Elation$update,
						model.Gv,
						{Lx: allowNewPatientCreation, aaT: sendEligibilityStatusTag},
						$author$project$Pages$Marketplace$Elation$Manage$Settings$Updated),
					_List_Nil);
			case 16:
				var sendEligibilityStatusTag = msg.a;
				var allowNewPatientCreation = A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						$author$project$Api$Provider$ElationConfiguration$One$allowNewPatientCreation,
						$author$project$Api$Data$toMaybe(model.at)));
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{k9: $author$project$Api$Data$Loading}),
					A3(
						$author$project$Api$Provider$Integration$Elation$update,
						model.Gv,
						{Lx: allowNewPatientCreation, aaT: sendEligibilityStatusTag},
						$author$project$Pages$Marketplace$Elation$Manage$Settings$Updated),
					_List_Nil);
			case 17:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{at: response, k9: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your elation integration has been updated.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 18:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							eq: $elm$core$Maybe$Just($author$project$Api$Data$NotAsked)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 19:
				var confirmed = msg.a;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							eq: $elm$core$Maybe$Just($author$project$Api$Data$Loading)
						}),
					A2($author$project$Api$Provider$Integration$Elation$delete, model.Gv, $author$project$Pages$Marketplace$Elation$Manage$Settings$Disabled),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{eq: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								eq: $elm$core$Maybe$Nothing,
								at: $author$project$Api$Data$Failure($author$project$Api$Data$NotFound),
								SD: $elm$core$Maybe$Just(
									$author$project$Utils$Form$init($author$project$Pages$Marketplace$Elation$Manage$Settings$formFieldsInit)),
								acf: 0
							}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your elation integration has been disabled.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{eq: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Marketplace$Elation$Manage$Settings$SaveCredentials = {$: 3};
var $author$project$Pages$Marketplace$Elation$Manage$Settings$viewDisableModal = function (model) {
	var _v0 = model.eq;
	if (!_v0.$) {
		var disablingRequest = _v0.a;
		return A2(
			$author$project$Components$HiConfirm$modal,
			$author$project$Pages$Marketplace$Elation$Manage$Settings$DisableConfirmed,
			_List_fromArray(
				[
					$author$project$Components$HiConfirm$customMessage(
					_List_fromArray(
						[
							$elm$html$Html$text('Please confirm you would like to deactivate the Elation integration.')
						])),
					$author$project$Components$HiConfirm$loading(
					_Utils_eq(disablingRequest, $author$project$Api$Data$Loading))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Ui$Image$ElationEMRBlueLogo = 7;
var $author$project$Pages$Marketplace$Elation$Manage$Settings$Activate = {$: 13};
var $author$project$Pages$Marketplace$Elation$Manage$Settings$GoToOverview = {$: 6};
var $author$project$Api$Provider$ElationConfiguration$Shared$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Api$Provider$ElationConfiguration$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ElationConfiguration$Shared$status(shared);
};
var $author$project$Pages$Marketplace$Elation$Manage$Settings$viewFooter = function (model) {
	var _v0 = model.acf;
	switch (_v0) {
		case 0:
			return $author$project$Ui$Panel$none;
		case 1:
			return A2(
				$author$project$Ui$Panel$footer,
				_List_fromArray(
					[$author$project$Ui$Element$justifyCenter]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Go to next step'},
						_List_fromArray(
							[
								$author$project$Ui$Button$submit,
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$loading(
								_Utils_eq(model.k9, $author$project$Api$Data$Loading))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Next')
							]))
					]));
		case 2:
			return A2(
				$author$project$Ui$Panel$footer,
				_List_fromArray(
					[$author$project$Ui$Element$justifyCenter]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Go to next step'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Pages$Marketplace$Elation$Manage$Settings$GoToOverview),
								$author$project$Ui$Button$primary
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Next')
							]))
					]));
		default:
			var status = A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$ElationConfiguration$One$status,
				$author$project$Api$Data$toMaybe(model.at));
			return (!_Utils_eq(
				status,
				$elm$core$Maybe$Just('active'))) ? A2(
				$author$project$Ui$Panel$footer,
				_List_fromArray(
					[$author$project$Ui$Element$justifyCenter]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Activate integration'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Pages$Marketplace$Elation$Manage$Settings$Activate),
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$loading(
								_Utils_eq(model.k9, $author$project$Api$Data$Loading))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Activate')
							]))
					])) : $author$project$Ui$Panel$none;
	}
};
var $author$project$Pages$Marketplace$Elation$Manage$Settings$GoToLink = {$: 1};
var $author$project$Pages$Marketplace$Elation$Manage$Settings$viewConfigureInfo = A2(
	$author$project$Ui$Typography$p,
	_List_Nil,
	_List_fromArray(
		[
			$elm$html$Html$text('To configure this integration, contact the Elation Integrations team  at '),
			A3(
			$author$project$Ui$Link$mailto,
			'integrations@elationhealth.com',
			_List_fromArray(
				[$author$project$Ui$Link$targetBlank]),
			_List_fromArray(
				[
					$elm$html$Html$text('integrations@elationhealth.com')
				])),
			$elm$html$Html$text(' and request an Elation-Hint API integration.')
		]));
var $author$project$Pages$Marketplace$Elation$Manage$Settings$viewStatus = F2(
	function (status, content) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Status'),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_fromArray(
						[$author$project$Ui$Form$Static$flex, $author$project$Ui$Form$Static$spaceBetween, $author$project$Ui$Form$Static$itemsCenter]),
					A2(
						$elm$core$List$cons,
						A2($author$project$Ui$Badge$fromString, _List_Nil, status),
						content))
				]));
	});
var $author$project$Pages$Marketplace$Elation$Manage$Settings$viewInitialStep = A2(
	$author$project$Ui$Element$view,
	_List_Nil,
	_List_fromArray(
		[
			A2($author$project$Pages$Marketplace$Elation$Manage$Settings$viewStatus, 'inactive', _List_Nil),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label(''),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{mm: 'Enable Elation Integration'},
					_List_fromArray(
						[
							$author$project$Ui$Button$onClick($author$project$Pages$Marketplace$Elation$Manage$Settings$GoToLink),
							$author$project$Ui$Button$primary
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Enable Elation Integration')
						]))
				])),
			$author$project$Ui$HorizontalRule$view(_List_Nil),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('About'),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Used by physicians to manage every aspects of patient care, '),
									A3(
									$author$project$Ui$Link$externalHref,
									'https://www.elationhealth.com/',
									_List_fromArray(
										[$author$project$Ui$Link$targetBlank]),
									_List_fromArray(
										[
											$elm$html$Html$text('Elation')
										])),
									$elm$html$Html$text(' is an intuitive, easy to use solution that helps you quickly find, digest, '),
									$elm$html$Html$text('and act upon relevant clinical information to care for your patients. ')
								])),
							A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Our integration with Elation will automatically create and synchronize patient contact, '),
									$elm$html$Html$text('demographic and membership information between Hint and Elation.')
								])),
							$author$project$Pages$Marketplace$Elation$Manage$Settings$viewConfigureInfo,
							A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Hint provides this integration only as a convenience to you. '),
									$elm$html$Html$text('Elation is solely responsible for its service, content and policies, '),
									$elm$html$Html$text('including those related to privacy and security. '),
									$elm$html$Html$text('Please review Elation\'s Terms of Service and Privacy Policy '),
									$elm$html$Html$text('to ensure they meet your business and legal requirements.')
								]))
						]))
				]))
		]));
var $author$project$Pages$Marketplace$Elation$Manage$Settings$viewInitialStepSkeleton = A2(
	$author$project$Ui$Element$view,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSkeleton('Status'),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$spanFromText('inactive')
								]))
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label(''),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$input(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$spanFromText('Enable Elation Integration')
						]))
				])),
			$author$project$Ui$HorizontalRule$view(_List_Nil),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSkeleton('About'),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$block,
									$author$project$Ui$Skeleton$span(8)
								])),
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$block,
									$author$project$Ui$Skeleton$span(7)
								])),
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$block,
									$author$project$Ui$Skeleton$span(8)
								]))
						]))
				]))
		]));
var $author$project$Pages$Marketplace$Elation$Manage$Settings$integrationExists = function (model) {
	var _v0 = model.at;
	if (_v0.$ === 3) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Pages$Marketplace$Elation$Manage$Settings$ClientId = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Marketplace$Elation$Manage$Settings$ClientSecret = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Marketplace$Elation$Manage$Settings$FormUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Marketplace$Elation$Manage$Settings$Password = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Marketplace$Elation$Manage$Settings$UserName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Marketplace$Elation$Manage$Settings$viewLinkForm = function (form) {
	var fields = $author$project$Utils$Form$fields(form);
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Typography$headingSm(
				_List_fromArray(
					[
						$elm$html$Html$text('Connect Elation Account')
					])),
				$author$project$Pages$Marketplace$Elation$Manage$Settings$viewConfigureInfo,
				A2($elm$html$Html$br, _List_Nil, _List_Nil),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Username'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8),
						$author$project$Ui$Form$Group$required(true)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(fields.amm),
								$author$project$Ui$Form$Input$autoComplete(false),
								$author$project$Ui$Form$Input$phi(true),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Pages$Marketplace$Elation$Manage$Settings$FormUpdated, $author$project$Pages$Marketplace$Elation$Manage$Settings$UserName)),
								$author$project$Ui$Form$Input$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
								$author$project$Ui$Form$Input$errors(
								A2($author$project$Utils$Form$validationErrors, 0, form))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Password'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8),
						$author$project$Ui$Form$Group$required(true)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$PasswordInput$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$PasswordInput$value(fields.ajR),
								$author$project$Ui$Form$PasswordInput$onInput(
								A2($elm$core$Basics$composeL, $author$project$Pages$Marketplace$Elation$Manage$Settings$FormUpdated, $author$project$Pages$Marketplace$Elation$Manage$Settings$Password)),
								$author$project$Ui$Form$PasswordInput$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
								$author$project$Ui$Form$PasswordInput$errors(
								A2($author$project$Utils$Form$validationErrors, 1, form))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Client Id'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8),
						$author$project$Ui$Form$Group$required(true)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(fields.afH),
								$author$project$Ui$Form$Input$autoComplete(false),
								$author$project$Ui$Form$Input$phi(true),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Pages$Marketplace$Elation$Manage$Settings$FormUpdated, $author$project$Pages$Marketplace$Elation$Manage$Settings$ClientId)),
								$author$project$Ui$Form$Input$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
								$author$project$Ui$Form$Input$errors(
								A2($author$project$Utils$Form$validationErrors, 2, form))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Client Secret'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8),
						$author$project$Ui$Form$Group$required(true)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$PasswordInput$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$PasswordInput$value(fields.afI),
								$author$project$Ui$Form$PasswordInput$onInput(
								A2($elm$core$Basics$composeL, $author$project$Pages$Marketplace$Elation$Manage$Settings$FormUpdated, $author$project$Pages$Marketplace$Elation$Manage$Settings$ClientSecret)),
								$author$project$Ui$Form$PasswordInput$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 3, form)),
								$author$project$Ui$Form$PasswordInput$errors(
								A2($author$project$Utils$Form$validationErrors, 3, form))
							]))
					]))
			]));
};
var $author$project$Pages$Marketplace$Elation$Manage$Settings$Disable = {$: 18};
var $author$project$Api$Provider$ElationConfiguration$Shared$elationPracticeId = function (_v0) {
	var record = _v0;
	return record.Rc;
};
var $author$project$Api$Provider$ElationConfiguration$One$elationPracticeId = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ElationConfiguration$Shared$elationPracticeId(shared);
};
var $author$project$Api$Provider$ElationConfiguration$Shared$elationPracticeName = function (_v0) {
	var record = _v0;
	return record.Rd;
};
var $author$project$Api$Provider$ElationConfiguration$One$elationPracticeName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ElationConfiguration$Shared$elationPracticeName(shared);
};
var $author$project$Pages$Marketplace$Elation$Manage$Settings$viewStatusWithDeactivate = function (model) {
	var elationConfiguration_ = $author$project$Api$Data$toMaybe(model.at);
	var status = A2(
		$elm$core$Maybe$withDefault,
		'pending',
		A2($elm$core$Maybe$map, $author$project$Api$Provider$ElationConfiguration$One$status, elationConfiguration_));
	return A2(
		$author$project$Pages$Marketplace$Elation$Manage$Settings$viewStatus,
		status,
		_List_fromArray(
			[
				function () {
				var _v0 = A2($elm$core$Maybe$andThen, $author$project$Api$Provider$ElationConfiguration$One$elationPracticeName, elationConfiguration_);
				if (!_v0.$) {
					var elationPracticeName = _v0.a;
					return $elm$html$Html$text(
						'at ' + (elationPracticeName + (' (Practice ID: ' + (A2(
							$elm$core$Maybe$withDefault,
							'',
							A2($elm$core$Maybe$andThen, $author$project$Api$Provider$ElationConfiguration$One$elationPracticeId, elationConfiguration_)) + ')'))));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				if (!elationConfiguration_.$) {
					return A3(
						$author$project$Ui$Button$view,
						{mm: 'Deactivate integration'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Pages$Marketplace$Elation$Manage$Settings$Disable),
								$author$project$Ui$Button$link
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Deactivate the integration')
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]));
};
var $author$project$Pages$Marketplace$Elation$Manage$Settings$GoToProviders = {$: 5};
var $author$project$Pages$Marketplace$Elation$Manage$Settings$viewStepBreadcrumbs = F2(
	function (hasIntegration, currentStep) {
		var steps = _List_fromArray(
			[
				_Utils_Tuple2(1, 'Connect Account'),
				_Utils_Tuple2(2, 'Link Providers'),
				_Utils_Tuple2(3, 'Overview')
			]);
		var stepMsg = function (step) {
			switch (step) {
				case 1:
					return $author$project$Pages$Marketplace$Elation$Manage$Settings$GoToLink;
				case 2:
					return $author$project$Pages$Marketplace$Elation$Manage$Settings$GoToProviders;
				case 3:
					return $author$project$Pages$Marketplace$Elation$Manage$Settings$GoToOverview;
				default:
					return $author$project$Pages$Marketplace$Elation$Manage$Settings$GoToLink;
			}
		};
		var isClickable = function (step) {
			return (!_Utils_eq(step, currentStep)) && ((step === 1) || hasIntegration);
		};
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			A2(
				$elm$core$List$intersperse,
				A2(
					$author$project$Ui$Typography$text,
					_List_fromArray(
						[$author$project$Ui$Typography$muted]),
					' > '),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var step = _v0.a;
						var label = _v0.b;
						return _Utils_eq(step, currentStep) ? A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[$author$project$Ui$Typography$bold]),
							label) : (isClickable(step) ? A3(
							$author$project$Ui$Button$view,
							{mm: label},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$sm,
									$author$project$Ui$Button$onClick(
									stepMsg(step))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(label)
								])) : A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[$author$project$Ui$Typography$muted]),
							label));
					},
					steps)));
	});
var $author$project$Pages$Marketplace$Elation$Manage$Settings$viewLinkStep = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Pages$Marketplace$Elation$Manage$Settings$viewStatusWithDeactivate(model),
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				A2(
				$author$project$Pages$Marketplace$Elation$Manage$Settings$viewStepBreadcrumbs,
				$author$project$Pages$Marketplace$Elation$Manage$Settings$integrationExists(model),
				1),
				A2($elm$html$Html$br, _List_Nil, _List_Nil),
				function () {
				var _v0 = model.SD;
				if (!_v0.$) {
					var form = _v0.a;
					return $author$project$Pages$Marketplace$Elation$Manage$Settings$viewLinkForm(form);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]));
};
var $author$project$Pages$Marketplace$Elation$Manage$Settings$ToggleEligibilityStatusTag = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Marketplace$Elation$Manage$Settings$ToggleNewPatientCreation = function (a) {
	return {$: 15, a: a};
};
var $author$project$Api$Provider$ElationConfiguration$One$practitionersCount = function (_v0) {
	var record = _v0.b;
	return record.Z5;
};
var $author$project$Pages$Marketplace$Elation$Manage$Settings$viewOverviewStep = function (model) {
	var elationConfiguration = $author$project$Api$Data$toMaybe(model.at);
	var practitionersCount = A2(
		$elm$core$Maybe$withDefault,
		$author$project$Ui$Skeleton$text(
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$spanFromText('100')
				])),
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Api$Provider$ElationConfiguration$One$practitionersCount,
				A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $elm$html$Html$text)),
			elationConfiguration));
	var sendEligibilityStatusTag = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2($elm$core$Maybe$map, $author$project$Api$Provider$ElationConfiguration$One$sendEligibilityStatusTag, elationConfiguration));
	var allowNewPatientCreation = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2($elm$core$Maybe$map, $author$project$Api$Provider$ElationConfiguration$One$allowNewPatientCreation, elationConfiguration));
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Pages$Marketplace$Elation$Manage$Settings$viewStatusWithDeactivate(model),
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				A2(
				$author$project$Pages$Marketplace$Elation$Manage$Settings$viewStepBreadcrumbs,
				$author$project$Pages$Marketplace$Elation$Manage$Settings$integrationExists(model),
				3),
				A2($elm$html$Html$br, _List_Nil, _List_Nil),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Number of Providers Linked'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[practitionersCount]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Create patients from Elation'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$view(
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$on(allowNewPatientCreation),
								$author$project$Ui$ToggleSwitch$onChange($author$project$Pages$Marketplace$Elation$Manage$Settings$ToggleNewPatientCreation),
								$author$project$Ui$ToggleSwitch$disabled(
								_Utils_eq(model.k9, $author$project$Api$Data$Loading))
							])),
						allowNewPatientCreation ? A2(
						$author$project$Ui$Element$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpBlock]),
								_List_fromArray(
									[
										$elm$html$Html$text('Update linked patients with changes from Elation Health. If a patient is '),
										$elm$html$Html$text('not found, create a new record in Hint. This is suggested for direct '),
										$elm$html$Html$text('care practices.')
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpBlock]),
								_List_fromArray(
									[
										$elm$html$Html$text('Note: Only patients assigned to Elation physicians linked to Hint '),
										$elm$html$Html$text('will be created in Hint.')
									]))
							])) : A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$helpBlock]),
						_List_fromArray(
							[
								$elm$html$Html$text('Update linked patients with changes from Elation Health. If a patient is '),
								$elm$html$Html$text('not found, '),
								A2(
								$author$project$Ui$Typography$text,
								_List_fromArray(
									[$author$project$Ui$Typography$bold]),
								'do not create'),
								$elm$html$Html$text(' a record in Hint. This is suggested for hybrid practices '),
								$elm$html$Html$text('that have both fee-for-service as well as direct care patients.')
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Send Eligibility Status tag'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$view(
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$on(sendEligibilityStatusTag),
								$author$project$Ui$ToggleSwitch$onChange($author$project$Pages$Marketplace$Elation$Manage$Settings$ToggleEligibilityStatusTag),
								$author$project$Ui$ToggleSwitch$disabled(
								_Utils_eq(model.k9, $author$project$Api$Data$Loading))
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$helpBlock]),
						_List_fromArray(
							[
								$elm$html$Html$text('When enabled, the Eligibility Status tag will be sent to Elation Health '),
								$elm$html$Html$text('during patient synchronization.')
							]))
					]))
			]));
};
var $author$project$Pages$Marketplace$Elation$Manage$Settings$RefreshElationProviders = {$: 9};
var $author$project$Pages$Marketplace$Elation$Manage$Settings$EditElationProviderMapping = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Marketplace$Elation$Manage$Settings$UpdateProviderMapping = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Api$Provider$Integration$Elation$Provider$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Integration$Elation$Provider$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Integration$Elation$Provider$Shared$id(shared);
};
var $author$project$Api$Provider$Integration$Elation$Provider$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$Integration$Elation$Provider$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Integration$Elation$Provider$Shared$name(shared);
};
var $author$project$Pages$Marketplace$Elation$Manage$Settings$elationProvidersOptions = function (elationProviders) {
	return A2(
		$elm$core$List$cons,
		A3(
			$author$project$Ui$Form$Select$option,
			_List_fromArray(
				[
					$author$project$Ui$Form$Select$itemDisabled(true)
				]),
			$elm$core$Maybe$Nothing,
			'Choose Elation Provider'),
		A2(
			$elm$core$List$cons,
			A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(''),
				'Unlink this Provider'),
			A2(
				$elm$core$List$map,
				function (elationProvider) {
					return A3(
						$author$project$Ui$Form$Select$option,
						_List_Nil,
						$elm$core$Maybe$Just(
							$elm$core$String$fromInt(
								$author$project$Api$Provider$Integration$Elation$Provider$All$id(elationProvider))),
						$author$project$Api$Provider$Integration$Elation$Provider$All$name(elationProvider));
				},
				elationProviders)));
};
var $author$project$Api$Provider$Integration$Elation$ProviderMapping$Shared$externalId = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Provider$Integration$Elation$ProviderMapping$All$externalId = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Integration$Elation$ProviderMapping$Shared$externalId(shared);
};
var $author$project$Api$Provider$Integration$Elation$ProviderMapping$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$Integration$Elation$ProviderMapping$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Integration$Elation$ProviderMapping$Shared$name(shared);
};
var $author$project$Pages$Marketplace$Elation$Manage$Settings$viewElationProviderMapping = F3(
	function (editingProviderMappings, elationProviders, elationProviderMapping) {
		var isEditingElationProviderMapping = A2(
			$elm$core$Set$member,
			$author$project$Api$Provider$Integration$Elation$ProviderMapping$All$id(elationProviderMapping),
			editingProviderMappings);
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(6)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Hint provider: '),
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$bold]),
									$author$project$Api$Provider$Integration$Elation$ProviderMapping$All$name(elationProviderMapping))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanMd(1)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Icon$arrowRight(_List_Nil)
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(2)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Elation provider: ')
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(3)
								]),
							_List_fromArray(
								[
									function () {
									if (isEditingElationProviderMapping) {
										return A2(
											$author$project$Ui$Form$Select$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Select$value(
													$author$project$Api$Provider$Integration$Elation$ProviderMapping$All$externalId(elationProviderMapping)),
													$author$project$Ui$Form$Select$onChange(
													$author$project$Pages$Marketplace$Elation$Manage$Settings$UpdateProviderMapping(elationProviderMapping))
												]),
											$author$project$Pages$Marketplace$Elation$Manage$Settings$elationProvidersOptions(elationProviders));
									} else {
										var elationProvider = A2(
											$elm_community$list_extra$List$Extra$find,
											function (elationProvider_) {
												return _Utils_eq(
													$elm$core$Maybe$Just(
														$elm$core$String$fromInt(
															$author$project$Api$Provider$Integration$Elation$Provider$All$id(elationProvider_))),
													$author$project$Api$Provider$Integration$Elation$ProviderMapping$All$externalId(elationProviderMapping));
											},
											elationProviders);
										return A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$spaceBetween]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$text,
													_List_fromArray(
														[$author$project$Ui$Typography$bold]),
													A2(
														$elm$core$Maybe$withDefault,
														'Not linked',
														A2($elm$core$Maybe$map, $author$project$Api$Provider$Integration$Elation$Provider$All$name, elationProvider))),
													A3(
													$author$project$Ui$Button$view,
													{mm: 'Edit provider mapping'},
													_List_fromArray(
														[
															$author$project$Ui$Button$link,
															$author$project$Ui$Button$sm,
															$author$project$Ui$Button$onClick(
															$author$project$Pages$Marketplace$Elation$Manage$Settings$EditElationProviderMapping(elationProviderMapping)),
															$author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Edit')
														]))
												]));
									}
								}()
								]))
						])),
					$author$project$Ui$HorizontalRule$view(_List_Nil)
				]));
	});
var $author$project$Pages$Marketplace$Elation$Manage$Settings$viewProvidersListSkeleton = A2(
	$author$project$Ui$Element$view,
	_List_Nil,
	A2(
		$elm$core$List$repeat,
		10,
		A2(
			$author$project$Ui$Grid$row,
			_List_fromArray(
				[$author$project$Ui$Grid$rowItemsCenter]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(6)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$spanFromText('Hint Provider: ')
										]))
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$span(8),
											$author$project$Ui$Skeleton$spanMd(4)
										]))
								]))
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanMd(1)
						]),
					_List_Nil),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(2)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$spanFromText('Elation provider: ')
								]))
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(3)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$input(_List_Nil)
						]))
				]))));
var $author$project$Pages$Marketplace$Elation$Manage$Settings$viewProvidersStepSkeleton = A2(
	$author$project$Ui$Element$view,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanLg(9),
							$author$project$Ui$Grid$spanMd(8),
							$author$project$Ui$Grid$spanSm(7)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$spanFromText('Link Providers')
										]))
								])),
							A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$spanFromText('Link providers in Hint with their records in Elation Health.')
										]))
								]))
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanLg(3),
							$author$project$Ui$Grid$spanMd(4),
							$author$project$Ui$Grid$spanSm(5),
							$author$project$Ui$Grid$justifyRight
						]),
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$input(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$spanFromText('Refresh Elation Providers')
								]))
						]))
				])),
			$author$project$Ui$HorizontalRule$view(_List_Nil),
			$author$project$Pages$Marketplace$Elation$Manage$Settings$viewProvidersListSkeleton
		]));
var $author$project$Pages$Marketplace$Elation$Manage$Settings$viewProvidersContent = function (model) {
	var _v0 = _Utils_Tuple2(model.nt, model.ns);
	_v0$2:
	while (true) {
		_v0$3:
		while (true) {
			switch (_v0.a.$) {
				case 3:
					switch (_v0.b.$) {
						case 3:
							var _v1 = _v0.a;
							var elationProviders = _v1.a;
							var _v2 = _v0.b;
							var elationProviderMappings = _v2.a;
							return A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$row,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Grid$column,
												_List_fromArray(
													[
														$author$project$Ui$Grid$spanLg(9),
														$author$project$Ui$Grid$spanMd(8),
														$author$project$Ui$Grid$spanSm(7)
													]),
												_List_fromArray(
													[
														$author$project$Ui$Typography$headingSm(
														_List_fromArray(
															[
																$elm$html$Html$text('Link Providers')
															])),
														A2(
														$author$project$Ui$Typography$p,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Link providers in Hint with their records in Elation Health. '),
																$elm$html$Html$text('A patient is required to have a linked provider assigned in Hint for a new chart to be created in Elation. '),
																$elm$html$Html$text('If a patient does not have a linked provider assigned in Hint, they will not sync to elation.')
															]))
													])),
												A2(
												$author$project$Ui$Grid$column,
												_List_fromArray(
													[
														$author$project$Ui$Grid$spanLg(3),
														$author$project$Ui$Grid$spanMd(4),
														$author$project$Ui$Grid$spanSm(5),
														$author$project$Ui$Grid$justifyRight
													]),
												_List_fromArray(
													[
														A3(
														$author$project$Ui$Button$view,
														{mm: 'Refresh Elation Providers'},
														_List_fromArray(
															[
																$author$project$Ui$Button$onClick($author$project$Pages$Marketplace$Elation$Manage$Settings$RefreshElationProviders),
																$author$project$Ui$Button$icon($author$project$Ui$Icon$repeat)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Refresh Elation Providers')
															]))
													]))
											])),
										$author$project$Ui$HorizontalRule$view(_List_Nil),
										A2(
										$author$project$Ui$Element$view,
										_List_Nil,
										A2(
											$elm$core$List$map,
											A2($author$project$Pages$Marketplace$Elation$Manage$Settings$viewElationProviderMapping, model.jA, elationProviders),
											elationProviderMappings))
									]));
						case 2:
							break _v0$2;
						default:
							break _v0$3;
					}
				case 2:
					return A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$danger]),
						_List_fromArray(
							[
								$elm$html$Html$text('Failed to load Elation providers. Please try refreshing.')
							]));
				default:
					if (_v0.b.$ === 2) {
						break _v0$2;
					} else {
						break _v0$3;
					}
			}
		}
		return $author$project$Pages$Marketplace$Elation$Manage$Settings$viewProvidersStepSkeleton;
	}
	return A2(
		$author$project$Ui$Typography$p,
		_List_fromArray(
			[$author$project$Ui$Typography$danger]),
		_List_fromArray(
			[
				$elm$html$Html$text('Failed to load provider mappings. Please try refreshing.')
			]));
};
var $author$project$Pages$Marketplace$Elation$Manage$Settings$viewProvidersStep = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Pages$Marketplace$Elation$Manage$Settings$viewStatusWithDeactivate(model),
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				A2(
				$author$project$Pages$Marketplace$Elation$Manage$Settings$viewStepBreadcrumbs,
				$author$project$Pages$Marketplace$Elation$Manage$Settings$integrationExists(model),
				2),
				A2($elm$html$Html$br, _List_Nil, _List_Nil),
				$author$project$Pages$Marketplace$Elation$Manage$Settings$viewProvidersContent(model)
			]));
};
var $author$project$Pages$Marketplace$Elation$Manage$Settings$viewPanel = function (model) {
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						A4(
						$author$project$Ui$Image$view,
						model.sF,
						{LD: 'ElationEMR Logo'},
						_List_fromArray(
							[
								$author$project$Ui$Image$width(200)
							]),
						7)
					])),
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				function () {
					var _v0 = model.at;
					if (_v0.$ === 1) {
						return _List_fromArray(
							[$author$project$Pages$Marketplace$Elation$Manage$Settings$viewInitialStepSkeleton]);
					} else {
						return _List_fromArray(
							[
								function () {
								var _v1 = model.acf;
								switch (_v1) {
									case 0:
										return $author$project$Pages$Marketplace$Elation$Manage$Settings$viewInitialStep;
									case 1:
										return $author$project$Pages$Marketplace$Elation$Manage$Settings$viewLinkStep(model);
									case 2:
										return $author$project$Pages$Marketplace$Elation$Manage$Settings$viewProvidersStep(model);
									default:
										return $author$project$Pages$Marketplace$Elation$Manage$Settings$viewOverviewStep(model);
								}
							}()
							]);
					}
				}()),
				$author$project$Pages$Marketplace$Elation$Manage$Settings$viewFooter(model)
			]));
};
var $author$project$Pages$Marketplace$Elation$Manage$Settings$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				$author$project$Pages$Marketplace$Elation$Manage$Settings$viewDisableModal(model),
				function () {
				var _v0 = model.acf;
				if (_v0 === 1) {
					return A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$noValidate(true),
								$author$project$Ui$Form$autocomplete(false),
								$author$project$Ui$Form$onSubmit($author$project$Pages$Marketplace$Elation$Manage$Settings$SaveCredentials)
							]),
						_List_fromArray(
							[
								$author$project$Pages$Marketplace$Elation$Manage$Settings$viewPanel(model)
							]));
				} else {
					return A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$noValidate(true),
								$author$project$Ui$Form$autocomplete(false)
							]),
						_List_fromArray(
							[
								$author$project$Pages$Marketplace$Elation$Manage$Settings$viewPanel(model)
							]));
				}
			}()
			]),
		ac9: 'Marketplace | Elation Settings'
	};
};
var $author$project$Pages$Marketplace$Elation$Manage$Settings$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Marketplace$Elation$Manage$Settings$init, aiq: $author$project$Pages$Marketplace$Elation$Manage$Settings$load, k8: $author$project$Pages$Marketplace$Elation$Manage$Settings$save, alO: $author$project$Pages$Marketplace$Elation$Manage$Settings$subscriptions, adT: $author$project$Pages$Marketplace$Elation$Manage$Settings$update, amo: $author$project$Pages$Marketplace$Elation$Manage$Settings$view});
var $author$project$Pages$Marketplace$Manage$GotProducts = $elm$core$Basics$identity;
var $author$project$Api$Common$Marketplace$Product$All$Product = $elm$core$Basics$identity;
var $author$project$Api$Common$Marketplace$Product$Shared$Product = $elm$core$Basics$identity;
var $author$project$Api$Common$Marketplace$Product$Shared$Record = function (slug) {
	return function (name) {
		return function (distributionType) {
			return function (listingStatus) {
				return function (summary) {
					return function (iconUrl) {
						return function (builtByName) {
							return function (builtByUrl) {
								return function (featured) {
									return function (type_) {
										return function (categories) {
											return function (installsCount) {
												return function (waitlistedCount) {
													return function (status) {
														return function (subscription) {
															return {MV: builtByName, MW: builtByUrl, Nr: categories, QN: distributionType, Se: featured, TJ: iconUrl, T5: installsCount, V7: listingStatus, Bq: name, abG: slug, alH: status, acz: subscription, acF: summary, amg: type_, aeo: waitlistedCount};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Common$Marketplace$Product$Category$Category = $elm$core$Basics$identity;
var $author$project$Api$Common$Marketplace$Product$Category$Record = F2(
	function (id, name) {
		return {ahP: id, Bq: name};
	});
var $author$project$Api$Common$Marketplace$Product$Category$decoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Common$Marketplace$Product$Category$Record))));
var $author$project$Api$Common$PartnerSubscription$Min$Subscription = $elm$core$Basics$identity;
var $author$project$Api$Common$PartnerSubscription$Min$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'amount_in_cents',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed(
			F2(
				function (id_, amt) {
					return {LE: amt, ahP: id_};
				}))));
var $author$project$Api$Common$Marketplace$Product$Shared$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'subscription',
	$elm$json$Json$Decode$nullable($author$project$Api$Common$PartnerSubscription$Min$decoder),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'status',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'waitlisted_count',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'installs_count',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'categories',
					$elm$json$Json$Decode$list($author$project$Api$Common$Marketplace$Product$Category$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'type',
						$author$project$Api$Common$Marketplace$Product$ProductType$decoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'featured',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'built_by_url',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'built_by_name',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'icon_url',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'summary',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'listing_status',
												$author$project$Api$Common$Marketplace$Product$Status$decoder,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'distribution_type',
													$author$project$Api$Common$Marketplace$Product$DistributionType$decoder,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'name',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'slug',
															$elm$json$Json$Decode$string,
															$elm$json$Json$Decode$succeed($author$project$Api$Common$Marketplace$Product$Shared$Record))))))))))))))));
var $author$project$Api$Common$Marketplace$Product$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Marketplace$Product$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$Marketplace$Product$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Marketplace$Product$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Marketplace$Product$productsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['marketplace', 'products']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Marketplace$Product$listManageable = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Common$Marketplace$Product$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['managed']),
					$author$project$Api$Provider$Marketplace$Product$productsPath)));
	});
var $author$project$Pages$Marketplace$Manage$init = F4(
	function (session, practice, shared, _v0) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, AI: $author$project$Api$Data$Loading, ZV: practice, aa4: session},
			A2($author$project$Api$Provider$Marketplace$Product$listManageable, shared.Gv, $elm$core$Basics$identity));
	});
var $author$project$Pages$Marketplace$Manage$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Marketplace$Manage$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Marketplace$Manage$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Marketplace$Manage$update = F2(
	function (msg, model) {
		var response = msg;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{AI: response}),
			$elm$core$Platform$Cmd$none,
			$author$project$OutMsg$handleErrorResponse(response));
	});
var $author$project$Ui$Element$mb6 = $author$project$Ui$Element$Margin('mb-6');
var $author$project$Pages$Marketplace$Manage$productsColumns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'name', false, 'Product Name'),
		A3($author$project$Api$Column$init, 'type', false, 'Type'),
		A3($author$project$Api$Column$init, 'status', false, 'Status'),
		A3($author$project$Api$Column$init, 'subscription', false, 'Subscription')
	]);
var $author$project$Ui$Table$alignCenter = $author$project$Ui$Table$VerticalCenteredCell;
var $author$project$Api$Common$PartnerSubscription$Min$amountInCents = function (_v0) {
	var record = _v0;
	return record.LE;
};
var $author$project$Api$Common$Marketplace$Product$Shared$iconUrl = function (_v0) {
	var record = _v0;
	return record.TJ;
};
var $author$project$Api$Common$Marketplace$Product$All$iconUrl = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Common$Marketplace$Product$Shared$iconUrl(shared);
};
var $author$project$Api$Common$Marketplace$Product$Shared$slug = function (_v0) {
	var record = _v0;
	return record.abG;
};
var $author$project$Api$Common$Marketplace$Product$All$slug = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Common$Marketplace$Product$Shared$slug(shared);
};
var $author$project$Api$Common$Marketplace$Product$Shared$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Api$Common$Marketplace$Product$All$status = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Common$Marketplace$Product$Shared$status(shared);
};
var $author$project$Api$Common$Marketplace$Product$Shared$type_ = function (_v0) {
	var record = _v0;
	return record.amg;
};
var $author$project$Api$Common$Marketplace$Product$All$type_ = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Common$Marketplace$Product$Shared$type_(shared);
};
var $author$project$Pages$Marketplace$Manage$manageRoute = function (product) {
	return A2(
		$elm$core$Maybe$andThen,
		function (status) {
			switch (status) {
				case 'inactive':
					return $elm$core$Maybe$Nothing;
				case 'pending':
					var _v1 = $author$project$Api$Common$Marketplace$Product$All$slug(product);
					switch (_v1) {
						case 'quickbooks':
							return $elm$core$Maybe$Just($author$project$Spa$Generated$Route$Marketplace__Quickbooks__Manage__Settings);
						case 'elation':
							return $elm$core$Maybe$Just($author$project$Spa$Generated$Route$Marketplace__Elation__Manage__Settings);
						case 'athenahealth':
							return $elm$core$Maybe$Just($author$project$Spa$Generated$Route$Marketplace__Athenahealth__Manage__Settings);
						default:
							return $elm$core$Maybe$Just(
								$author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Onboarding(
									{
										abG: $author$project$Api$Common$Marketplace$Product$All$slug(product)
									}));
					}
				default:
					var _v2 = _Utils_Tuple2(
						$author$project$Api$Common$Marketplace$Product$All$type_(product),
						$author$project$Api$Common$Marketplace$Product$All$slug(product));
					_v2$0:
					while (true) {
						switch (_v2.b) {
							case 'bookkeeping':
								if (!_v2.a) {
									break _v2$0;
								} else {
									return $elm$core$Maybe$Just($author$project$Spa$Generated$Route$Marketplace__Bookkeeping__Manage__Settings);
								}
							case 'quickbooks':
								if (!_v2.a) {
									break _v2$0;
								} else {
									return $elm$core$Maybe$Just($author$project$Spa$Generated$Route$Marketplace__Quickbooks__Manage__Settings);
								}
							case 'elation':
								if (!_v2.a) {
									break _v2$0;
								} else {
									return $elm$core$Maybe$Just($author$project$Spa$Generated$Route$Marketplace__Elation__Manage__Settings);
								}
							case 'athenahealth':
								if (!_v2.a) {
									break _v2$0;
								} else {
									return $elm$core$Maybe$Just($author$project$Spa$Generated$Route$Marketplace__Athenahealth__Manage__Settings);
								}
							default:
								if (!_v2.a) {
									break _v2$0;
								} else {
									return $elm$core$Maybe$Nothing;
								}
						}
					}
					var _v3 = _v2.a;
					return $elm$core$Maybe$Just(
						$author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Users(
							{
								abG: $author$project$Api$Common$Marketplace$Product$All$slug(product)
							}));
			}
		},
		$author$project$Api$Common$Marketplace$Product$All$status(product));
};
var $author$project$Api$Common$Marketplace$Product$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Common$Marketplace$Product$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Common$Marketplace$Product$Shared$name(shared);
};
var $author$project$Api$Common$Marketplace$Product$Shared$subscription = function (_v0) {
	var record = _v0;
	return record.acz;
};
var $author$project$Api$Common$Marketplace$Product$All$subscription = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Common$Marketplace$Product$Shared$subscription(shared);
};
var $author$project$Api$Common$Marketplace$Product$ProductType$toLabel = function (type_) {
	switch (type_) {
		case 0:
			return 'App';
		case 1:
			return 'Integration';
		default:
			return 'Solution';
	}
};
var $author$project$Pages$Marketplace$Manage$viewProductRow = function (product) {
	var productName = $author$project$Api$Common$Marketplace$Product$All$name(product);
	return A2(
		$author$project$Ui$Table$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_fromArray(
					[$author$project$Ui$Table$alignCenter]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
						_List_fromArray(
							[
								function () {
								var _v0 = $author$project$Api$Common$Marketplace$Product$All$iconUrl(product);
								if (!_v0.$) {
									var url = _v0.a;
									return A3(
										$author$project$Ui$Image$fromSrc,
										{LD: productName + ' icon'},
										url,
										_List_fromArray(
											[
												$author$project$Ui$Image$height(32)
											]));
								} else {
									return $elm$html$Html$text('');
								}
							}(),
								A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Marketplace__Slug_String(
									{
										abG: $author$project$Api$Common$Marketplace$Product$All$slug(product)
									}),
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(productName)
									]))
							]))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_fromArray(
					[$author$project$Ui$Table$alignCenter]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Common$Marketplace$Product$ProductType$toLabel(
							$author$project$Api$Common$Marketplace$Product$All$type_(product)))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_fromArray(
					[$author$project$Ui$Table$alignCenter]),
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$withDefault,
						$elm$html$Html$text(''),
						A2(
							$elm$core$Maybe$map,
							$author$project$Ui$Badge$fromString(_List_Nil),
							$author$project$Api$Common$Marketplace$Product$All$status(product)))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_fromArray(
					[$author$project$Ui$Table$alignCenter]),
				_List_fromArray(
					[
						function () {
						var _v1 = $author$project$Api$Common$Marketplace$Product$All$subscription(product);
						if (!_v1.$) {
							var sub = _v1.a;
							return $elm$html$Html$text(
								$author$project$Utils$Currency$fromInt(
									$author$project$Api$Common$PartnerSubscription$Min$amountInCents(sub)));
						} else {
							return $elm$html$Html$text('—');
						}
					}()
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_fromArray(
					[$author$project$Ui$Table$textRight]),
				_List_fromArray(
					[
						function () {
						var _v2 = $author$project$Pages$Marketplace$Manage$manageRoute(product);
						if (!_v2.$) {
							var route = _v2.a;
							return A3(
								$author$project$Ui$Link$route,
								route,
								_List_fromArray(
									[
										$author$project$Ui$Link$buttonDefault,
										$author$project$Ui$Link$sm,
										$author$project$Ui$Link$ariaLabel('Manage ' + productName)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Manage')
									]));
						} else {
							return $elm$html$Html$text('');
						}
					}()
					]))
			]));
};
var $author$project$Pages$Marketplace$Manage$viewPartners = function (model) {
	var _v0 = function () {
		var _v1 = model.AI;
		if (_v1.$ === 3) {
			var products_ = _v1.a;
			return _Utils_Tuple2(false, products_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var products = _v0.b;
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A4(
				$author$project$Ui$Panel$table,
				_List_fromArray(
					[
						$author$project$Ui$Table$zeroState(
						_List_fromArray(
							[
								$elm$html$Html$text('There are no installed partners')
							])),
						$author$project$Ui$Table$loading(loading)
					]),
				$elm$core$List$concat(
					_List_fromArray(
						[
							A2(
							$elm$core$List$map,
							$author$project$Api$Column$view($author$project$Api$Column$NonSortable),
							$author$project$Pages$Marketplace$Manage$productsColumns),
							_List_fromArray(
							[
								A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
							])
						])),
				A2($elm$core$List$map, $author$project$Pages$Marketplace$Manage$viewProductRow, products),
				_List_Nil)
			]));
};
var $author$project$Pages$Marketplace$Manage$viewBody = function (model) {
	return _List_fromArray(
		[
			A3(
			$author$project$Ui$Element$custom,
			'layout-header h-24',
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mb6]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$heading(
							_List_fromArray(
								[
									$elm$html$Html$text('Manage Partners')
								])),
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Marketplace__Top,
							_List_fromArray(
								[$author$project$Ui$Link$buttonDefault]),
							_List_fromArray(
								[
									$elm$html$Html$text('View Marketplace')
								]))
						]))
				])),
			$author$project$Pages$Marketplace$Manage$viewPartners(model)
		]);
};
var $author$project$Pages$Marketplace$Manage$view = function (model) {
	return {
		fO: $author$project$Pages$Marketplace$Manage$viewBody(model),
		ac9: 'Marketplace | Manage'
	};
};
var $author$project$Pages$Marketplace$Manage$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Marketplace$Manage$init, aiq: $author$project$Pages$Marketplace$Manage$load, k8: $author$project$Pages$Marketplace$Manage$save, alO: $author$project$Pages$Marketplace$Manage$subscriptions, adT: $author$project$Pages$Marketplace$Manage$update, amo: $author$project$Pages$Marketplace$Manage$view});
var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$GotQuickbooksIntegration = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$Initial = {$: 0};
var $author$project$Api$Feature$QuickbooksBypassPmpmCheck = 4;
var $author$project$Api$Provider$Practice$One$feePlanType = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Si;
	});
var $author$project$Api$Provider$QuickbooksIntegration$One$QuickbooksIntegration = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$QuickbooksIntegration$Shared$QuickbooksIntegration = $elm$core$Basics$identity;
var $author$project$Api$Provider$QuickbooksIntegration$Shared$Record = function (status) {
	return {alH: status};
};
var $author$project$Api$Provider$QuickbooksIntegration$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'status',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$QuickbooksIntegration$Shared$Record));
var $author$project$Api$Provider$QuickbooksIntegration$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$QuickbooksIntegration$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$QuickbooksIntegration$One$Record = F7(
	function (oauthConnectionUrl, errorsCount, syncDepositsAvailableOnOrAfter, depositAccountExtid, discrepancyAccountExtid, feeAccountExtid, uncategorizedAccountExtid) {
		return {agq: depositAccountExtid, agA: discrepancyAccountExtid, RN: errorsCount, ahg: feeAccountExtid, X6: oauthConnectionUrl, acJ: syncDepositsAvailableOnOrAfter, ami: uncategorizedAccountExtid};
	});
var $author$project$Api$Provider$QuickbooksIntegration$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'uncategorized_account_extid',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'fee_account_extid',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'discrepancy_account_extid',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'deposit_account_extid',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'sync_deposits_available_on_or_after',
					$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'errors_count',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'oauth_connection_url',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							$elm$json$Json$Decode$succeed($author$project$Api$Provider$QuickbooksIntegration$One$Record))))))));
var $author$project$Api$Provider$QuickbooksIntegration$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$QuickbooksIntegration$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$QuickbooksIntegration$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$QuickbooksIntegration$One$QuickbooksIntegration)));
var $author$project$Api$Provider$Integration$Quickbooks$quickbooksPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['quickbooks_integration']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Integration$Quickbooks$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$QuickbooksIntegration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Quickbooks$quickbooksPath));
	});
var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.DE;
		return _Utils_Tuple2(
			{
				Gv: shared.Gv,
				ix: $elm$core$Maybe$Nothing,
				xN: ($author$project$Api$Provider$Practice$One$feePlanType(practice) === 1) || A2($author$project$Api$Provider$Practice$One$featureEnabled, 4, practice),
				f6: $elm$core$Maybe$Nothing,
				SD: $elm$core$Maybe$Nothing,
				sF: shared.sF,
				ZV: practice,
				DE: query,
				dG: $author$project$Api$Data$Loading,
				hp: $elm$core$Maybe$Nothing,
				k9: $author$project$Api$Data$NotAsked,
				aa4: session,
				acf: $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$Initial
			},
			A2($author$project$Api$Provider$Integration$Quickbooks$retrieve, shared.Gv, $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$GotQuickbooksIntegration));
	});
var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$AuthorizeOnQuickbooksHiConfirmClosed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$DeactivateHiConfirmClosed = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$QuickbooksMappingsMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Admin$Quickbooks$Mappings$CancelEdit = {$: 4};
var $author$project$Components$Admin$Quickbooks$Mappings$subscriptions = function (_v0) {
	var model = _v0;
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Platform$Sub$none,
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$always(
				$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Admin$Quickbooks$Mappings$CancelEdit)),
			model.C));
};
var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Marketplace$Quickbooks$Manage$Settings$QuickbooksMappingsMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Admin$Quickbooks$Mappings$subscriptions, model.hp))),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Marketplace$Quickbooks$Manage$Settings$AuthorizeOnQuickbooksHiConfirmClosed)),
					model.ix)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Marketplace$Quickbooks$Manage$Settings$DeactivateHiConfirmClosed)),
					model.f6))
			]));
};
var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$Activated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$Created = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$Date = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$DateInputMsg = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$Deactivated = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$Overview = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$Integration$Quickbooks$activate = F3(
	function (apiClient, syncDepositsAvailableOnOrAfter, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'sync_deposits_available_on_or_after',
					A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, syncDepositsAvailableOnOrAfter))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$QuickbooksIntegration$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['activate']),
						$author$project$Api$Provider$Integration$Quickbooks$quickbooksPath))));
	});
var $author$project$Api$Provider$Integration$Quickbooks$create = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$QuickbooksIntegration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Quickbooks$quickbooksPath));
	});
var $author$project$Api$Provider$Integration$Quickbooks$deactivate = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$QuickbooksIntegration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['deactivate']),
					$author$project$Api$Provider$Integration$Quickbooks$quickbooksPath)));
	});
var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$formFieldsUpdate = F2(
	function (field, fields) {
		var dateInput = field.a;
		var date = field.b;
		return _Utils_update(
			fields,
			{rZ: dateInput, acJ: date});
	});
var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_Nil);
var $author$project$Api$Provider$Integration$Quickbooks$Account$CategoryMatching = 0;
var $author$project$Components$Admin$Quickbooks$Mappings$GotQuickbooksAccounts = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Admin$Quickbooks$Mappings$GotQuickbooksCategoryMappings = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$Quickbooks$Mappings$Model = $elm$core$Basics$identity;
var $author$project$Components$Admin$Quickbooks$Mappings$OtherMappingsLoading = {$: 0};
var $author$project$Api$Provider$Integration$Quickbooks$Account$accountssPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['accounts']),
	$author$project$Api$Provider$Integration$Quickbooks$quickbooksPath);
var $author$project$Api$Provider$QuickbooksAccount$All$QuickbooksAccount = $elm$core$Basics$identity;
var $author$project$Api$Provider$QuickbooksAccount$Min$QuickbooksAccount = $elm$core$Basics$identity;
var $author$project$Api$Provider$QuickbooksAccount$Min$Record = F2(
	function (extid, name) {
		return {ag8: extid, Bq: name};
	});
var $author$project$Api$Provider$QuickbooksAccount$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'extid',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$QuickbooksAccount$Min$Record)));
var $author$project$Api$Provider$QuickbooksAccount$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$QuickbooksAccount$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$QuickbooksAccount$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$QuickbooksAccount$Min$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Integration$Quickbooks$Account$defaults = {amg: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$Integration$Quickbooks$Account$typeToString = function (type_) {
	switch (type_) {
		case 0:
			return 'category_matching';
		case 1:
			return 'deposit_matching';
		default:
			return 'fee_matching';
	}
};
var $author$project$Api$Provider$Integration$Quickbooks$Account$optionalsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Integration$Quickbooks$Account$defaults);
	var _v0 = options.amg;
	if (!_v0.$) {
		var type_ = _v0.a;
		return _List_fromArray(
			[
				A2(
				$author$project$Api$Param$string,
				'type',
				$author$project$Api$Provider$Integration$Quickbooks$Account$typeToString(type_))
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Api$Provider$Integration$Quickbooks$Account$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$QuickbooksAccount$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Integration$Quickbooks$Account$optionalsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Quickbooks$Account$accountssPath)));
	});
var $author$project$Api$Provider$Integration$Quickbooks$CategoryMapping$categoryMappingsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['category_mappings']),
	$author$project$Api$Provider$Integration$Quickbooks$quickbooksPath);
var $author$project$Api$Provider$QuickbooksCategoryMapping$All$QuickbooksCategoryMapping = $elm$core$Basics$identity;
var $author$project$Api$Provider$QuickbooksCategoryMapping$Shared$QuickbooksCategoryMapping = $elm$core$Basics$identity;
var $author$project$Api$Provider$QuickbooksCategoryMapping$Shared$Record = F2(
	function (category, quickbooksAccount) {
		return {GW: category, __: quickbooksAccount};
	});
var $author$project$Api$Provider$QuickbooksCategoryMapping$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'quickbooks_account',
	$author$project$Api$Provider$QuickbooksAccount$Min$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'category',
		$author$project$Api$Provider$Category$Min$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$QuickbooksCategoryMapping$Shared$Record)));
var $author$project$Api$Provider$QuickbooksCategoryMapping$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$QuickbooksCategoryMapping$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$QuickbooksCategoryMapping$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$QuickbooksCategoryMapping$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Integration$Quickbooks$CategoryMapping$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$QuickbooksCategoryMapping$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Quickbooks$CategoryMapping$categoryMappingsPath));
	});
var $author$project$Components$Admin$Quickbooks$Mappings$init = F4(
	function (apiClient, session, practice, quickbooksIntegration) {
		return _Utils_Tuple2(
			{iG: $author$project$Api$Data$Loading, mJ: _List_Nil, ni: $author$project$Api$Data$Loading, C: $elm$core$Maybe$Nothing, nH: $author$project$Api$Data$Loading, g2: $author$project$Components$Admin$Quickbooks$Mappings$OtherMappingsLoading, ZV: practice, pt: $author$project$Api$Data$Loading, dG: quickbooksIntegration, aa4: session},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3(
						$author$project$Api$Provider$Integration$Quickbooks$Account$list,
						apiClient,
						function (d) {
							return _Utils_update(
								d,
								{
									amg: $elm$core$Maybe$Just(0)
								});
						},
						$author$project$Components$Admin$Quickbooks$Mappings$GotQuickbooksAccounts(0)),
						A2($author$project$Api$Provider$Integration$Quickbooks$CategoryMapping$list, apiClient, $author$project$Components$Admin$Quickbooks$Mappings$GotQuickbooksCategoryMappings)
					])));
	});
var $author$project$Api$Provider$QuickbooksIntegration$One$syncDepositsAvailableOnOrAfter = function (_v0) {
	var record = _v0.b;
	return record.acJ;
};
var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$initFormFields = function (quickbooksIntegration) {
	var _v0 = $author$project$Components$DateInput$init;
	var dateInput = _v0.a;
	var dateInputCmd = _v0.b;
	return _Utils_Tuple2(
		{
			rZ: dateInput,
			acJ: $author$project$Api$Provider$QuickbooksIntegration$One$syncDepositsAvailableOnOrAfter(quickbooksIntegration)
		},
		A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Pages$Marketplace$Quickbooks$Manage$Settings$DateInputMsg(dateInput),
			dateInputCmd));
};
var $author$project$Api$Provider$QuickbooksIntegration$One$oauthConnectionUrl = function (_v0) {
	var record = _v0.b;
	return record.X6;
};
var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$Downloading = {$: 1};
var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$GotAuthorization = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Integration$Quickbooks$authorize = F5(
	function (apiClient, code, state, realmId, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'code',
					$elm$json$Json$Encode$string(code)),
					_Utils_Tuple2(
					'state',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, state)),
					_Utils_Tuple2(
					'realmId',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, realmId))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$QuickbooksIntegration$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['authorize']),
						$author$project$Api$Provider$Integration$Quickbooks$quickbooksPath))));
	});
var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$sendOauthSuccessDataToBackend = function (model) {
	var _v0 = A2($elm$core$Dict$get, 'code', model.DE);
	if (!_v0.$) {
		var code = _v0.a;
		var state = A2($elm$core$Dict$get, 'state', model.DE);
		var realmId = A2($elm$core$Dict$get, 'realmId', model.DE);
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{k9: $author$project$Api$Data$Loading, acf: $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$Downloading}),
			A5($author$project$Api$Provider$Integration$Quickbooks$authorize, model.Gv, code, state, realmId, $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$GotAuthorization));
	} else {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	}
};
var $author$project$Api$Provider$QuickbooksIntegration$Shared$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Api$Provider$QuickbooksIntegration$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$QuickbooksIntegration$Shared$status(shared);
};
var $author$project$Components$Admin$Quickbooks$Mappings$AccountSaved = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$Integration$Quickbooks$Account$DepositMatching = 1;
var $author$project$Components$Admin$Quickbooks$Mappings$EditingAccount = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Components$Admin$Quickbooks$Mappings$EditingMapping = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Api$Provider$Integration$Quickbooks$Account$FeeMatching = 2;
var $author$project$Components$Admin$Quickbooks$Mappings$QuickbooksCategoryMappingSaved = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$QuickbooksIntegration$One$depositAccountExtid = function (_v0) {
	var record = _v0.b;
	return record.agq;
};
var $author$project$Api$Provider$QuickbooksIntegration$One$discrepancyAccountExtid = function (_v0) {
	var record = _v0.b;
	return record.agA;
};
var $author$project$Api$Provider$QuickbooksIntegration$One$feeAccountExtid = function (_v0) {
	var record = _v0.b;
	return record.ahg;
};
var $author$project$Api$Provider$QuickbooksIntegration$One$uncategorizedAccountExtid = function (_v0) {
	var record = _v0.b;
	return record.ami;
};
var $author$project$Components$Admin$Quickbooks$Mappings$accountToParam = F2(
	function (account, quickbooksIntegration) {
		switch (account) {
			case 2:
				return $author$project$Api$Provider$QuickbooksIntegration$One$discrepancyAccountExtid(quickbooksIntegration);
			case 1:
				return $author$project$Api$Provider$QuickbooksIntegration$One$feeAccountExtid(quickbooksIntegration);
			case 0:
				return $author$project$Api$Provider$QuickbooksIntegration$One$depositAccountExtid(quickbooksIntegration);
			default:
				return $author$project$Api$Provider$QuickbooksIntegration$One$uncategorizedAccountExtid(quickbooksIntegration);
		}
	});
var $author$project$Components$Admin$Quickbooks$Mappings$accountFormFieldsInit = F2(
	function (account, quickbooksIntegration) {
		return {
			ag8: A2($author$project$Components$Admin$Quickbooks$Mappings$accountToParam, account, quickbooksIntegration),
			Bq: $elm$core$Maybe$Nothing,
			DG: _List_Nil
		};
	});
var $author$project$Components$Admin$Quickbooks$Mappings$accountFormFieldsUpdate = F2(
	function (field, fields) {
		var string = field;
		var extid = $author$project$Utils$String$toMaybe(string);
		var quickbooksAccount = A2(
			$elm_community$list_extra$List$Extra$find,
			function (quickbooksAccount_) {
				return _Utils_eq(quickbooksAccount_.ag8, extid);
			},
			fields.DG);
		return _Utils_update(
			fields,
			{
				ag8: extid,
				Bq: A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.Bq;
					},
					quickbooksAccount)
			});
	});
var $author$project$Components$Admin$Quickbooks$Mappings$blankAccountDataExtid = '__blank';
var $author$project$Components$Admin$Quickbooks$Mappings$blankAccountData = {
	ag8: $elm$core$Maybe$Just($author$project$Components$Admin$Quickbooks$Mappings$blankAccountDataExtid),
	Bq: $elm$core$Maybe$Just('Not assigned - will not sync')
};
var $author$project$Api$Provider$QuickbooksCategoryMapping$Shared$category = function (_v0) {
	var record = _v0;
	return record.GW;
};
var $author$project$Api$Provider$QuickbooksCategoryMapping$All$category = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$QuickbooksCategoryMapping$Shared$category(shared);
};
var $author$project$Api$Provider$QuickbooksAccount$Min$extid = function (_v0) {
	var record = _v0;
	return record.ag8;
};
var $author$project$Api$Provider$QuickbooksAccount$Min$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$QuickbooksCategoryMapping$Shared$quickbooksAccount = function (_v0) {
	var record = _v0;
	return record.__;
};
var $author$project$Api$Provider$QuickbooksCategoryMapping$All$quickbooksAccount = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$QuickbooksCategoryMapping$Shared$quickbooksAccount(shared);
};
var $author$project$Components$Admin$Quickbooks$Mappings$mappingFormFieldsInit = F2(
	function (quickbooksCategoryMapping, quickbooksAccounts) {
		var name = $author$project$Api$Provider$QuickbooksAccount$Min$name(
			$author$project$Api$Provider$QuickbooksCategoryMapping$All$quickbooksAccount(quickbooksCategoryMapping));
		var extid = $author$project$Api$Provider$QuickbooksAccount$Min$extid(
			$author$project$Api$Provider$QuickbooksCategoryMapping$All$quickbooksAccount(quickbooksCategoryMapping));
		return {ag8: extid, Bq: name, DG: quickbooksAccounts};
	});
var $author$project$Api$Provider$QuickbooksAccount$All$extid = function (_v0) {
	var min = _v0;
	return $author$project$Api$Provider$QuickbooksAccount$Min$extid(min);
};
var $author$project$Api$Provider$QuickbooksAccount$All$name = function (_v0) {
	var min = _v0;
	return $author$project$Api$Provider$QuickbooksAccount$Min$name(min);
};
var $author$project$Components$Admin$Quickbooks$Mappings$quickbooksAccountToAccountData = function (quickbooksAccount) {
	return {
		ag8: $author$project$Api$Provider$QuickbooksAccount$All$extid(quickbooksAccount),
		Bq: $author$project$Api$Provider$QuickbooksAccount$All$name(quickbooksAccount)
	};
};
var $author$project$Components$Admin$Quickbooks$Mappings$quickbooksAccountsToAccountData = function (quickbooksAccounts) {
	return A2($elm$core$List$map, $author$project$Components$Admin$Quickbooks$Mappings$quickbooksAccountToAccountData, quickbooksAccounts);
};
var $author$project$Components$Admin$Quickbooks$Mappings$quickbooksCategoryMappingFields = function (formFields) {
	return {ag8: formFields.ag8, Bq: formFields.Bq};
};
var $author$project$Components$Admin$Quickbooks$Mappings$quickbooksFields = F3(
	function (account, formFields, quickbooksIntegration) {
		var fields = {
			agq: $author$project$Api$Provider$QuickbooksIntegration$One$depositAccountExtid(quickbooksIntegration),
			agA: $author$project$Api$Provider$QuickbooksIntegration$One$discrepancyAccountExtid(quickbooksIntegration),
			ahg: $author$project$Api$Provider$QuickbooksIntegration$One$feeAccountExtid(quickbooksIntegration),
			ami: $author$project$Api$Provider$QuickbooksIntegration$One$uncategorizedAccountExtid(quickbooksIntegration)
		};
		switch (account) {
			case 2:
				return _Utils_update(
					fields,
					{agA: formFields.ag8});
			case 1:
				return _Utils_update(
					fields,
					{ahg: formFields.ag8});
			case 0:
				return _Utils_update(
					fields,
					{agq: formFields.ag8});
			default:
				return _Utils_update(
					fields,
					{ami: formFields.ag8});
		}
	});
var $author$project$Components$Admin$Quickbooks$Mappings$ExtidValidation = 0;
var $author$project$Components$Admin$Quickbooks$Mappings$accountFormFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.ag8;
			},
			_Utils_Tuple2(0, 'Please pick a quickbooks account.'))
		]));
var $author$project$Components$Admin$Quickbooks$Mappings$saveForm = F6(
	function (currentExtid, _v0, form, toCmd, toEditing, model) {
		var _v1 = A2($author$project$Utils$Form$validate, $author$project$Components$Admin$Quickbooks$Mappings$accountFormFieldsValidator, form);
		if (!_v1.$) {
			var _v2 = _v1.a;
			var newForm = _v2.a;
			var validFormFields = _v2.b;
			var formFields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
			var extid = _Utils_eq(
				formFields.ag8,
				$elm$core$Maybe$Just($author$project$Components$Admin$Quickbooks$Mappings$blankAccountDataExtid)) ? $elm$core$Maybe$Nothing : formFields.ag8;
			var _v3 = _Utils_eq(extid, currentExtid) ? _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none) : A2(
				toCmd,
				newForm,
				_Utils_update(
					formFields,
					{ag8: extid}));
			var editing = _v3.a;
			var cmd = _v3.b;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{C: editing}),
				cmd,
				_List_Nil);
		} else {
			var newForm = _v1.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						C: $elm$core$Maybe$Just(
							A2(toEditing, newForm, $author$project$Api$Data$NotAsked))
					}),
				$elm$core$Platform$Cmd$none,
				_List_Nil);
		}
	});
var $author$project$Components$Admin$Quickbooks$Mappings$DepositAccount = 0;
var $author$project$Components$Admin$Quickbooks$Mappings$DiscrepancyAccount = 2;
var $author$project$Components$Admin$Quickbooks$Mappings$FeeAccount = 1;
var $author$project$Components$Admin$Quickbooks$Mappings$OtherMappingsLoaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$Quickbooks$Mappings$UncategorizedAccount = 3;
var $author$project$Components$Admin$Quickbooks$Mappings$accountNameFromId = F2(
	function (model, id) {
		return A2(
			$elm$core$Maybe$andThen,
			function (id_) {
				var feeMatchingAccounts = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$author$project$Api$Data$toMaybe(model.nH));
				var depositMatchingAccounts = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$author$project$Api$Data$toMaybe(model.ni));
				var categoryMatchingAccounts = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$author$project$Api$Data$toMaybe(model.iG));
				var quickbooksAccount = A2(
					$elm_community$list_extra$List$Extra$find,
					function (quickbooksAccount_) {
						return _Utils_eq(
							$author$project$Api$Provider$QuickbooksAccount$All$extid(quickbooksAccount_),
							$elm$core$Maybe$Just(id_));
					},
					A2(
						$elm$core$List$append,
						categoryMatchingAccounts,
						A2($elm$core$List$append, feeMatchingAccounts, depositMatchingAccounts)));
				return A2($elm$core$Maybe$andThen, $author$project$Api$Provider$QuickbooksAccount$All$name, quickbooksAccount);
			},
			id);
	});
var $author$project$Components$Admin$Quickbooks$Mappings$buildAccountFromId = F2(
	function (model, id) {
		if (!id.$) {
			var id_ = id.a;
			return {
				ag8: $elm$core$Maybe$Just(id_),
				Bq: A2($author$project$Components$Admin$Quickbooks$Mappings$accountNameFromId, model, id)
			};
		} else {
			return $author$project$Components$Admin$Quickbooks$Mappings$blankAccountData;
		}
	});
var $author$project$Components$Admin$Quickbooks$Mappings$setOtherMappings = function (model) {
	var _v0 = _Utils_Tuple3(model.ni, model.nH, model.iG);
	if (((_v0.a.$ === 3) && (_v0.b.$ === 3)) && (_v0.c.$ === 3)) {
		var _v1 = _v0.a;
		var _v2 = _v0.b;
		var _v3 = _v0.c;
		var otherMappings = {
			Qm: A2(
				$author$project$Components$Admin$Quickbooks$Mappings$buildAccountFromId,
				model,
				A2($author$project$Components$Admin$Quickbooks$Mappings$accountToParam, 0, model.dG)),
			QI: A2(
				$author$project$Components$Admin$Quickbooks$Mappings$buildAccountFromId,
				model,
				A2($author$project$Components$Admin$Quickbooks$Mappings$accountToParam, 2, model.dG)),
			Sg: A2(
				$author$project$Components$Admin$Quickbooks$Mappings$buildAccountFromId,
				model,
				A2($author$project$Components$Admin$Quickbooks$Mappings$accountToParam, 1, model.dG)),
			adJ: A2(
				$author$project$Components$Admin$Quickbooks$Mappings$buildAccountFromId,
				model,
				A2($author$project$Components$Admin$Quickbooks$Mappings$accountToParam, 3, model.dG))
		};
		return _Utils_update(
			model,
			{
				g2: $author$project$Components$Admin$Quickbooks$Mappings$OtherMappingsLoaded(otherMappings)
			});
	} else {
		return _Utils_update(
			model,
			{g2: $author$project$Components$Admin$Quickbooks$Mappings$OtherMappingsLoading});
	}
};
var $author$project$Api$Provider$Integration$Quickbooks$update = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'discrepancy_account_extid',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.agA)),
					_Utils_Tuple2(
					'deposit_account_extid',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.agq)),
					_Utils_Tuple2(
					'fee_account_extid',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ahg)),
					_Utils_Tuple2(
					'uncategorized_account_extid',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ami))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$QuickbooksIntegration$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Quickbooks$quickbooksPath)));
	});
var $author$project$Api$Provider$Integration$Quickbooks$CategoryMapping$categoryMappingPath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		$author$project$Api$Provider$Integration$Quickbooks$CategoryMapping$categoryMappingsPath);
};
var $author$project$Api$Provider$QuickbooksCategoryMapping$One$QuickbooksCategoryMapping = 0;
var $author$project$Api$Provider$QuickbooksCategoryMapping$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Provider$Integration$Quickbooks$CategoryMapping$update = F4(
	function (apiClient, id, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'quickbooks_account',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'extid',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ag8)),
								_Utils_Tuple2(
								'name',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Bq))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$QuickbooksCategoryMapping$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Integration$Quickbooks$CategoryMapping$categoryMappingPath(id))));
	});
var $author$project$Components$Admin$Quickbooks$Mappings$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{pt: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var type_ = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var quickbooksAccounts = response.a;
					switch (type_) {
						case 0:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										iG: response,
										mJ: A2(
											$elm$core$List$cons,
											$author$project$Components$Admin$Quickbooks$Mappings$blankAccountData,
											$author$project$Components$Admin$Quickbooks$Mappings$quickbooksAccountsToAccountData(quickbooksAccounts))
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A3(
											$author$project$Api$Provider$Integration$Quickbooks$Account$list,
											apiClient,
											function (d) {
												return _Utils_update(
													d,
													{
														amg: $elm$core$Maybe$Just(1)
													});
											},
											$author$project$Components$Admin$Quickbooks$Mappings$GotQuickbooksAccounts(1)),
											A3(
											$author$project$Api$Provider$Integration$Quickbooks$Account$list,
											apiClient,
											function (d) {
												return _Utils_update(
													d,
													{
														amg: $elm$core$Maybe$Just(2)
													});
											},
											$author$project$Components$Admin$Quickbooks$Mappings$GotQuickbooksAccounts(2))
										])),
								_List_Nil);
						case 1:
							return _Utils_Tuple3(
								$author$project$Components$Admin$Quickbooks$Mappings$setOtherMappings(
									_Utils_update(
										model,
										{ni: response})),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
						default:
							return _Utils_Tuple3(
								$author$project$Components$Admin$Quickbooks$Mappings$setOtherMappings(
									_Utils_update(
										model,
										{nH: response})),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
					}
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 2:
				var account = msg.a;
				var form = $author$project$Utils$Form$init(
					A2($author$project$Components$Admin$Quickbooks$Mappings$accountFormFieldsInit, account, model.dG));
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							C: $elm$core$Maybe$Just(
								A3($author$project$Components$Admin$Quickbooks$Mappings$EditingAccount, account, form, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var field = msg.a;
				var _v4 = model.C;
				if (!_v4.$) {
					if (!_v4.a.$) {
						var _v5 = _v4.a;
						var account = _v5.a;
						var form = _v5.b;
						var saveRequest = _v5.c;
						var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Admin$Quickbooks$Mappings$accountFormFieldsUpdate, field, form);
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									C: $elm$core$Maybe$Just(
										A3($author$project$Components$Admin$Quickbooks$Mappings$EditingAccount, account, newForm, saveRequest))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						var _v6 = _v4.a;
						var quickbooksCategoryMapping = _v6.a;
						var form = _v6.b;
						var saveRequest = _v6.c;
						var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Admin$Quickbooks$Mappings$accountFormFieldsUpdate, field, form);
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									C: $elm$core$Maybe$Just(
										A3($author$project$Components$Admin$Quickbooks$Mappings$EditingMapping, quickbooksCategoryMapping, newForm, saveRequest))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{C: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var _v7 = model.C;
				if (!_v7.$) {
					if (!_v7.a.$) {
						var _v8 = _v7.a;
						var account = _v8.a;
						var form = _v8.b;
						var currentExtid = A2($author$project$Components$Admin$Quickbooks$Mappings$accountToParam, account, model.dG);
						var accountName = function () {
							switch (account) {
								case 2:
									return 'discrepancy';
								case 1:
									return 'fee';
								case 0:
									return 'deposit';
								default:
									return 'uncategorize';
							}
						}();
						return A6(
							$author$project$Components$Admin$Quickbooks$Mappings$saveForm,
							currentExtid,
							accountName,
							form,
							F2(
								function (newForm, formFields) {
									var fields = A3($author$project$Components$Admin$Quickbooks$Mappings$quickbooksFields, account, formFields, model.dG);
									return _Utils_Tuple2(
										$elm$core$Maybe$Just(
											A3($author$project$Components$Admin$Quickbooks$Mappings$EditingAccount, account, newForm, $author$project$Api$Data$Loading)),
										A3($author$project$Api$Provider$Integration$Quickbooks$update, apiClient, fields, $author$project$Components$Admin$Quickbooks$Mappings$AccountSaved));
								}),
							$author$project$Components$Admin$Quickbooks$Mappings$EditingAccount(account),
							model);
					} else {
						var _v10 = _v7.a;
						var quickbooksCategoryMapping = _v10.a;
						var form = _v10.b;
						var currentExtid = $author$project$Api$Provider$QuickbooksAccount$Min$extid(
							$author$project$Api$Provider$QuickbooksCategoryMapping$All$quickbooksAccount(quickbooksCategoryMapping));
						return A6(
							$author$project$Components$Admin$Quickbooks$Mappings$saveForm,
							currentExtid,
							'revenue',
							form,
							F2(
								function (newForm, formFields) {
									var id = $author$project$Api$Provider$Category$Min$id(
										$author$project$Api$Provider$QuickbooksCategoryMapping$All$category(quickbooksCategoryMapping));
									var fields = $author$project$Components$Admin$Quickbooks$Mappings$quickbooksCategoryMappingFields(formFields);
									return _Utils_Tuple2(
										$elm$core$Maybe$Just(
											A3($author$project$Components$Admin$Quickbooks$Mappings$EditingMapping, quickbooksCategoryMapping, newForm, $author$project$Api$Data$Loading)),
										A4($author$project$Api$Provider$Integration$Quickbooks$CategoryMapping$update, apiClient, id, fields, $author$project$Components$Admin$Quickbooks$Mappings$QuickbooksCategoryMappingSaved));
								}),
							$author$project$Components$Admin$Quickbooks$Mappings$EditingMapping(quickbooksCategoryMapping),
							model);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var response = msg.a;
				var _v11 = model.C;
				if ((!_v11.$) && (!_v11.a.$)) {
					var _v12 = _v11.a;
					var account = _v12.a;
					var form = _v12.b;
					if (response.$ === 3) {
						var quickbooksIntegration = response.a;
						return _Utils_Tuple3(
							$author$project$Components$Admin$Quickbooks$Mappings$setOtherMappings(
								_Utils_update(
									model,
									{C: $elm$core$Maybe$Nothing, dG: quickbooksIntegration})),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Quickbooks account successfully updated.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									C: $elm$core$Maybe$Just(
										A3($author$project$Components$Admin$Quickbooks$Mappings$EditingAccount, account, form, $author$project$Api$Data$NotAsked))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 7:
				var quickbooksCategoryMapping = msg.a;
				var form = $author$project$Utils$Form$init(
					A2($author$project$Components$Admin$Quickbooks$Mappings$mappingFormFieldsInit, quickbooksCategoryMapping, model.mJ));
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							C: $elm$core$Maybe$Just(
								A3($author$project$Components$Admin$Quickbooks$Mappings$EditingMapping, quickbooksCategoryMapping, form, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var response = msg.a;
				var _v14 = model.C;
				if ((!_v14.$) && (_v14.a.$ === 1)) {
					var _v15 = _v14.a;
					var quickbooksCategoryMapping = _v15.a;
					var form = _v15.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							$author$project$Components$Admin$Quickbooks$Mappings$setOtherMappings(
								_Utils_update(
									model,
									{C: $elm$core$Maybe$Nothing, pt: $author$project$Api$Data$Loading})),
							A2($author$project$Api$Provider$Integration$Quickbooks$CategoryMapping$list, apiClient, $author$project$Components$Admin$Quickbooks$Mappings$GotQuickbooksCategoryMappings),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Quickbooks account successfully updated.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									C: $elm$core$Maybe$Just(
										A3($author$project$Components$Admin$Quickbooks$Mappings$EditingMapping, quickbooksCategoryMapping, form, $author$project$Api$Data$NotAsked))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				_v1$2:
				while (true) {
					switch (response.$) {
						case 3:
							var quickbooksIntegration = response.a;
							var status = $author$project$Api$Provider$QuickbooksIntegration$One$status(quickbooksIntegration);
							var step = ((status === 'pending') || (status === 'active')) ? $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$Overview(quickbooksIntegration) : $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$Initial;
							var _v2 = ((status === 'pending') || (status === 'active')) ? A2(
								$elm$core$Tuple$mapFirst,
								$elm$core$Maybe$Just,
								A4($author$project$Components$Admin$Quickbooks$Mappings$init, model.Gv, model.aa4, model.ZV, quickbooksIntegration)) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
							var quickbooksMappings = _v2.a;
							var quickbooksMappingsCmd = _v2.b;
							var _v3 = (status === 'pending') ? A2(
								$elm$core$Tuple$mapFirst,
								A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $author$project$Utils$Form$init),
								$author$project$Pages$Marketplace$Quickbooks$Manage$Settings$initFormFields(quickbooksIntegration)) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
							var form = _v3.a;
							var formCmd = _v3.b;
							return A2(
								$author$project$Utils$Tuple3$fromTuple2,
								_List_Nil,
								A2(
									$elm$core$Tuple$mapSecond,
									function (cmd) {
										return $elm$core$Platform$Cmd$batch(
											_List_fromArray(
												[
													formCmd,
													cmd,
													A2($elm$core$Platform$Cmd$map, $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$QuickbooksMappingsMsg, quickbooksMappingsCmd)
												]));
									},
									$author$project$Pages$Marketplace$Quickbooks$Manage$Settings$sendOauthSuccessDataToBackend(
										_Utils_update(
											model,
											{SD: form, dG: response, hp: quickbooksMappings, acf: step}))));
						case 2:
							if (response.a.$ === 5) {
								var _v4 = response.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{dG: response, acf: $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$Initial}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							} else {
								break _v1$2;
							}
						default:
							break _v1$2;
					}
				}
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dG: response, acf: $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$Initial}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ix: $elm$core$Maybe$Just($author$project$Api$Data$NotAsked)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var confirmed = msg.a;
				if (confirmed) {
					var oauthConnectionUrl = A2(
						$elm$core$Maybe$andThen,
						$author$project$Api$Provider$QuickbooksIntegration$One$oauthConnectionUrl,
						$author$project$Api$Data$toMaybe(model.dG));
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ix: $elm$core$Maybe$Just($author$project$Api$Data$Loading),
								k9: $author$project$Api$Data$Loading
							}),
						function () {
							if (!oauthConnectionUrl.$) {
								var oauthConnectionUrl_ = oauthConnectionUrl.a;
								return $author$project$Ports$Navigation$openInNewWindow(oauthConnectionUrl_);
							} else {
								return A2($author$project$Api$Provider$Integration$Quickbooks$create, model.Gv, $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$Created);
							}
						}(),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ix: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					var quickbooksIntegration = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dG: response}),
						function () {
							var _v7 = $author$project$Api$Provider$QuickbooksIntegration$One$oauthConnectionUrl(quickbooksIntegration);
							if (!_v7.$) {
								var oauthConnectionUrl = _v7.a;
								return $author$project$Ports$Navigation$openInNewWindow(oauthConnectionUrl);
							} else {
								return $elm$core$Platform$Cmd$none;
							}
						}(),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dG: response, k9: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					var query = A2(
						$elm$core$Dict$remove,
						'realmId',
						A2(
							$elm$core$Dict$remove,
							'state',
							A2($elm$core$Dict$remove, 'code', model.DE)));
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{DE: query, dG: $author$project$Api$Data$Loading, k9: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($author$project$Utils$Route$navigate, query, $author$project$Spa$Generated$Route$Marketplace__Quickbooks__Manage__Settings),
									A2($author$project$Api$Provider$Integration$Quickbooks$retrieve, model.Gv, $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$GotQuickbooksIntegration)
								])),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dG: response, k9: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 5:
				var _v9 = model.SD;
				if (!_v9.$) {
					var form = _v9.a;
					var _v10 = A2($author$project$Utils$Form$validate, $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$formFieldsValidator, form);
					if (!_v10.$) {
						var _v11 = _v10.a;
						var newForm = _v11.a;
						var validFields = _v11.b;
						var _v12 = $rtfeldman$elm_validate$Validate$fromValid(validFields);
						var syncDepositsAvailableOnOrAfter = _v12.acJ;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									SD: $elm$core$Maybe$Just(newForm),
									k9: $author$project$Api$Data$Loading
								}),
							A3($author$project$Api$Provider$Integration$Quickbooks$activate, model.Gv, syncDepositsAvailableOnOrAfter, $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$Activated),
							_List_Nil);
					} else {
						var newForm = _v10.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									SD: $elm$core$Maybe$Just(newForm)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var response = msg.a;
				var outMsgs = function () {
					if (response.$ === 3) {
						return _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your quickbooks integration has been activated')
							]);
					} else {
						return $author$project$OutMsg$handleErrorResponse(response);
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dG: response, k9: $author$project$Api$Data$NotAsked}),
					$elm$core$Platform$Cmd$none,
					outMsgs);
			case 7:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							f6: $elm$core$Maybe$Just($author$project$Api$Data$NotAsked)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 8:
				var confirm = msg.a;
				return confirm ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							f6: $elm$core$Maybe$Just($author$project$Api$Data$Loading)
						}),
					A2($author$project$Api$Provider$Integration$Quickbooks$deactivate, model.Gv, $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$Deactivated),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{f6: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 9:
				var response = msg.a;
				var outMsgs = function () {
					if (response.$ === 3) {
						return _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your quickbooks integration has been deactivated')
							]);
					} else {
						return $author$project$OutMsg$handleErrorResponse(response);
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{f6: $elm$core$Maybe$Nothing, dG: response, acf: $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$Initial}),
					$elm$core$Platform$Cmd$none,
					outMsgs);
			case 10:
				var dateInput = msg.a;
				var subMsg = msg.b;
				var _v15 = model.SD;
				if (!_v15.$) {
					var form = _v15.a;
					var _v16 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
					var newDateInput = _v16.a;
					var subCmd = _v16.b;
					var event = _v16.c;
					var newForm = function () {
						if (event.$ === 1) {
							var date = event.a;
							return A3(
								$author$project$Utils$Form$update,
								$author$project$Pages$Marketplace$Quickbooks$Manage$Settings$formFieldsUpdate,
								A2($author$project$Pages$Marketplace$Quickbooks$Manage$Settings$Date, newDateInput, date),
								form);
						} else {
							var _v18 = $author$project$Utils$Form$fields(form);
							var syncDepositsAvailableOnOrAfter = _v18.acJ;
							return A3(
								$author$project$Utils$Form$update,
								$author$project$Pages$Marketplace$Quickbooks$Manage$Settings$formFieldsUpdate,
								A2($author$project$Pages$Marketplace$Quickbooks$Manage$Settings$Date, newDateInput, syncDepositsAvailableOnOrAfter),
								form);
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								SD: $elm$core$Maybe$Just(newForm)
							}),
						A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Pages$Marketplace$Quickbooks$Manage$Settings$DateInputMsg(newDateInput),
							subCmd),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var subMsg = msg.a;
				var _v19 = model.hp;
				if (!_v19.$) {
					var quickbooksMappings = _v19.a;
					var _v20 = A3($author$project$Components$Admin$Quickbooks$Mappings$update, model.Gv, subMsg, quickbooksMappings);
					var quickbooksMappings_ = _v20.a;
					var quickbooksMappingsCmd = _v20.b;
					var quickbooksMappingsOutMsgs = _v20.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								hp: $elm$core$Maybe$Just(quickbooksMappings_)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$QuickbooksMappingsMsg, quickbooksMappingsCmd),
						quickbooksMappingsOutMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Ui$Image$QuickBooksLogo = 8;
var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$initialStepSkeleton = _List_fromArray(
	[
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label(''),
				$author$project$Ui$Form$Group$labelSpanSm(4),
				$author$project$Ui$Form$Group$inputSpanSm(8)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$text(
				_List_fromArray(
					[
						$author$project$Ui$Skeleton$spanFromText('inactive')
					]))
			])),
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label(''),
				$author$project$Ui$Form$Group$labelSpanSm(4),
				$author$project$Ui$Form$Group$inputSpanSm(8)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$input(
				_List_fromArray(
					[
						$author$project$Ui$Skeleton$span(4)
					]))
			])),
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSkeleton('About'),
				$author$project$Ui$Form$Group$labelSpanSm(4),
				$author$project$Ui$Form$Group$inputSpanSm(8)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Skeleton$text(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$span(10)
							]))
					]))
			])),
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSkeleton('How it works'),
				$author$project$Ui$Form$Group$labelSpanSm(4),
				$author$project$Ui$Form$Group$inputSpanSm(8)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Skeleton$text(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$block,
								$author$project$Ui$Skeleton$span(6)
							])),
						$author$project$Ui$Skeleton$text(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$block,
								$author$project$Ui$Skeleton$span(7)
							])),
						$author$project$Ui$Skeleton$text(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$block,
								$author$project$Ui$Skeleton$span(10)
							]))
					]))
			]))
	]);
var $author$project$Components$Admin$Quickbooks$Mappings$AccountFormUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$Quickbooks$Mappings$Extid = $elm$core$Basics$identity;
var $author$project$Components$Admin$Quickbooks$Mappings$Save = {$: 5};
var $author$project$Components$Admin$Quickbooks$Mappings$quickBooksAccountOptions = function (quickbooksAccounts) {
	return A2(
		$elm$core$List$cons,
		A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(''),
			'Select a QuickBooks Account'),
		A2(
			$elm$core$List$map,
			function (quickbooksAccount) {
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					quickbooksAccount.ag8,
					A2($elm$core$Maybe$withDefault, 'N/A', quickbooksAccount.Bq));
			},
			quickbooksAccounts));
};
var $author$project$Components$Admin$Quickbooks$Mappings$viewForm = F3(
	function (form, quickbooksAccounts, saveRequest) {
		var modalConfig = {
			Tq: $elm$core$Maybe$Nothing,
			aih: 'Account',
			V8: _Utils_eq(saveRequest, $author$project$Api$Data$Loading),
			WG: $elm$core$Maybe$Just(''),
			WH: $elm$core$Maybe$Nothing,
			Yd: $author$project$Components$Admin$Quickbooks$Mappings$CancelEdit,
			Yf: $elm$core$Basics$always($author$project$Components$Admin$Quickbooks$Mappings$Save)
		};
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(4),
							$author$project$Ui$Form$Group$label('QuickBooks account'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(fields.ag8),
									$author$project$Ui$Form$Select$onChange(
									A2($elm$core$Basics$composeL, $author$project$Components$Admin$Quickbooks$Mappings$AccountFormUpdated, $elm$core$Basics$identity)),
									$author$project$Ui$Form$Select$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
									$author$project$Ui$Form$Select$errors(
									A2($author$project$Utils$Form$validationErrors, 0, form))
								]),
							$author$project$Components$Admin$Quickbooks$Mappings$quickBooksAccountOptions(quickbooksAccounts))
						]))
				]));
	});
var $author$project$Components$Admin$Quickbooks$Mappings$modal = function (_v0) {
	var model = _v0;
	var _v1 = model.C;
	if (!_v1.$) {
		if (!_v1.a.$) {
			var _v2 = _v1.a;
			var account = _v2.a;
			var form = _v2.b;
			var saveRequest = _v2.c;
			var quickbooksAccounts = function () {
				switch (account) {
					case 0:
						return $author$project$Components$Admin$Quickbooks$Mappings$quickbooksAccountsToAccountData(
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								$author$project$Api$Data$toMaybe(model.ni)));
					case 1:
						return $author$project$Components$Admin$Quickbooks$Mappings$quickbooksAccountsToAccountData(
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								$author$project$Api$Data$toMaybe(model.nH)));
					case 2:
						return $author$project$Components$Admin$Quickbooks$Mappings$quickbooksAccountsToAccountData(
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								$author$project$Api$Data$toMaybe(model.iG)));
					default:
						return model.mJ;
				}
			}();
			return A3($author$project$Components$Admin$Quickbooks$Mappings$viewForm, form, quickbooksAccounts, saveRequest);
		} else {
			var _v4 = _v1.a;
			var form = _v4.b;
			var saveRequest = _v4.c;
			return A3($author$project$Components$Admin$Quickbooks$Mappings$viewForm, form, model.mJ, saveRequest);
		}
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$viewStatus = function (status) {
	return A2($author$project$Ui$Badge$fromString, _List_Nil, status);
};
var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$viewStatusLeft = F2(
	function (status, content) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Ui$Typography$label,
					_List_fromArray(
						[$author$project$Ui$Typography$controlLabel]),
					_List_fromArray(
						[
							$elm$html$Html$text('Status ')
						])),
				A2(
					$elm$core$List$cons,
					$author$project$Utils$Html$noBreakSpace,
					A2(
						$elm$core$List$cons,
						$author$project$Pages$Marketplace$Quickbooks$Manage$Settings$viewStatus(status),
						A2($elm$core$List$cons, $author$project$Utils$Html$noBreakSpace, content)))));
	});
var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$viewDownloadingStep = A2(
	$author$project$Ui$Element$view,
	_List_Nil,
	_List_fromArray(
		[
			A2($author$project$Pages$Marketplace$Quickbooks$Manage$Settings$viewStatusLeft, 'downloading', _List_Nil),
			$elm$html$Html$text('We are loading your accounts from QuickBooks. After that, you\'ll be able to connect those with Hint categories.'),
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mt2]),
			_List_fromArray(
				[
					$author$project$Ui$Spinner$view(_List_Nil)
				]))
		]));
var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$AuthorizeOnQuickbooks = {$: 1};
var $author$project$Ui$Button$Background = 10;
var $author$project$Ui$Image$QuickBooksConnectButton = 9;
var $author$project$Ui$Image$Class = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Image$class = $author$project$Ui$Image$Class;
var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$viewInitialStep = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				(!model.xN) ? A2(
				$author$project$Ui$Alert$info,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanMd(8)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Your current plan does not support this integration')
											])),
										A2(
										$author$project$Ui$Element$view,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Contact our customer success team to learn more about the required pricing scheme and update your plan.')
											]))
									]))
							]))
					])) : $author$project$Utils$Html$empty,
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label(''),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Pages$Marketplace$Quickbooks$Manage$Settings$viewStatus('inactive')
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label(''),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Connect to quickbooks online'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Pages$Marketplace$Quickbooks$Manage$Settings$AuthorizeOnQuickbooks),
								$author$project$Ui$Button$disabled(!model.xN),
								$author$project$Ui$Button$loading(
								_Utils_eq(model.k9, $author$project$Api$Data$Loading)),
								$author$project$Ui$Button$styled(10)
							]),
						_List_fromArray(
							[
								A4(
								$author$project$Ui$Image$view,
								model.sF,
								{LD: 'Connect to QuickBooks Online button'},
								_List_fromArray(
									[
										$author$project$Ui$Image$class('w-72')
									]),
								9)
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('About'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Save time allocating your revenue and expenses to the correct QuickBooks accounts by connecting Hint to QuickBooks Online.')
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('How it works'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$OrderedList$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$OrderedList$item,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Log in to QuickBooks Online and give Hint permission to access your account.')
											])),
										A2(
										$author$project$Ui$OrderedList$item,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Match your Hint revenue and expense categories to the appropriate accounts in QuickBooks.')
											])),
										A2(
										$author$project$Ui$OrderedList$item,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Hint starts syncing, which means Hint will automatically split your deposits into the appropriate accounts in QuickBooks. All you need to do is reconcile your transactions as usual!')
											]))
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Need help? '),
										A3(
										$author$project$Ui$Link$externalHref,
										'https://support.hint.com/integrations/quickbooks-online-integration',
										_List_fromArray(
											[$author$project$Ui$Link$targetBlank]),
										_List_fromArray(
											[
												$elm$html$Html$text('Read the Knowledge Base article.')
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$Activate = {$: 5};
var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$viewOverviewFooter = F2(
	function (model, quickbooksIntegration) {
		return ($author$project$Api$Provider$QuickbooksIntegration$One$status(quickbooksIntegration) === 'pending') ? A2(
			$author$project$Ui$Panel$footer,
			_List_fromArray(
				[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$justifyCenter]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{mm: 'Activate integration'},
					_List_fromArray(
						[
							$author$project$Ui$Button$onClick($author$project$Pages$Marketplace$Quickbooks$Manage$Settings$Activate),
							$author$project$Ui$Button$primary,
							$author$project$Ui$Button$loading(
							_Utils_eq(model.k9, $author$project$Api$Data$Loading))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Activate')
						]))
				])) : $author$project$Ui$Panel$none;
	});
var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$Deactivate = {$: 7};
var $author$project$Api$Provider$QuickbooksIntegration$One$errorsCount = function (_v0) {
	var record = _v0.b;
	return record.RN;
};
var $author$project$Components$Admin$Quickbooks$Mappings$hasUnmappedCategories = function (quickbooksCategoryMappings) {
	return A2(
		$elm$core$List$any,
		function (quickbooksCategoryMapping) {
			return !$author$project$Utils$Maybe$toBool(
				$author$project$Api$Provider$QuickbooksAccount$Min$extid(
					$author$project$Api$Provider$QuickbooksCategoryMapping$All$quickbooksAccount(quickbooksCategoryMapping)));
		},
		quickbooksCategoryMappings);
};
var $author$project$Ui$Form$Group$LabelInsideControl = {$: 7};
var $author$project$Ui$Form$Group$labelInsideControl = $author$project$Ui$Form$Group$LabelInsideControl;
var $elm$html$Html$u = _VirtualDom_node('u');
var $author$project$Ui$Typography$u = F2(
	function (options, content) {
		return A2(
			$elm$html$Html$u,
			$author$project$Ui$Typography$optionsToAttributes(options),
			content);
	});
var $author$project$Components$Admin$Quickbooks$Mappings$EditAccount = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$Quickbooks$Mappings$viewAccount = F2(
	function (account, otherMappings) {
		var label = function () {
			switch (account) {
				case 0:
					return _List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Deposit Amounts')
								]))
						]);
				case 1:
					return _List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Transaction Fees')
								]))
						]);
				case 2:
					return _List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Discrepancy Amounts')
								]))
						]);
				default:
					return _List_fromArray(
						[
							$elm$html$Html$text('Hint category: '),
							$author$project$Ui$Icon$minus(_List_Nil)
						]);
			}
		}();
		var info = function () {
			switch (account) {
				case 0:
					return 'Map this to your \"Undeposited Funds\" account.';
				case 1:
					return 'The cost to you to process transactions through this platform and its partners.';
				case 2:
					return 'We’ll use this account to balance out discrepancies between this platform and your bank deposits, usually caused by payment disputes.';
				default:
					return 'Includes charges that haven\'t been assigned to a category in this platform. You can leave this unmatched in order to stop deposits with uncategorized charges from syncing.';
			}
		}();
		return A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanMd(4)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_Utils_ap(
								label,
								_List_fromArray(
									[
										A2($elm$html$Html$br, _List_Nil, _List_Nil),
										A2(
										$author$project$Ui$Typography$text,
										_List_fromArray(
											[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
										info)
									])))
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanMd(2)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Icon$arrowRight(_List_Nil)
								]))
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanMd(2)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textRight]),
									_List_fromArray(
										[
											$elm$html$Html$text('QuickBooks account:')
										]))
								]))
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanMd(4)
						]),
					_List_fromArray(
						[
							function () {
							if (otherMappings.$ === 1) {
								var discrepancyAccount = otherMappings.a.QI;
								var feeAccount = otherMappings.a.Sg;
								var depositAccount = otherMappings.a.Qm;
								var uncategorizedAccount = otherMappings.a.adJ;
								var otherMapping = function () {
									switch (account) {
										case 2:
											return discrepancyAccount;
										case 1:
											return feeAccount;
										case 0:
											return depositAccount;
										default:
											return uncategorizedAccount;
									}
								}();
								return A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2($elm$core$Maybe$withDefault, 'N/A', otherMapping.Bq)),
											A3(
											$author$project$Ui$Button$view,
											{mm: 'Eddit account'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$sm,
													$author$project$Ui$Button$onClick(
													$author$project$Components$Admin$Quickbooks$Mappings$EditAccount(account)),
													$author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Edit')
												]))
										]));
							} else {
								return A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$text(
											_List_fromArray(
												[
													$author$project$Ui$Skeleton$span(4)
												]))
										]));
							}
						}()
						]))
				]));
	});
var $author$project$Components$Admin$Quickbooks$Mappings$EditQuickbooksCategoryMapping = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Admin$Quickbooks$Mappings$viewIncomeAccount = F2(
	function (loading, quickbooksCategoryMapping) {
		return A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanMd(4)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Hint category: '),
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Provider$Category$Min$name(
												$author$project$Api$Provider$QuickbooksCategoryMapping$All$category(quickbooksCategoryMapping)))
										]))
								]))
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanMd(2)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Icon$arrowRight(_List_Nil)
								]))
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanMd(2)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textRight]),
									_List_fromArray(
										[
											$elm$html$Html$text('QuickBooks account:')
										]))
								]))
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanMd(4)
						]),
					_List_fromArray(
						[
							function () {
							if (loading) {
								return A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$text(
											_List_fromArray(
												[
													$author$project$Ui$Skeleton$span(4)
												]))
										]));
							} else {
								var quickbooksAccount = $author$project$Api$Provider$QuickbooksCategoryMapping$All$quickbooksAccount(quickbooksCategoryMapping);
								return A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$text,
											$author$project$Utils$Maybe$toBool(
												$author$project$Api$Provider$QuickbooksAccount$Min$extid(quickbooksAccount)) ? _List_Nil : _List_fromArray(
												[$author$project$Ui$Typography$italic]),
											A2(
												$elm$core$Maybe$withDefault,
												'Not assigned - will not sync',
												$author$project$Api$Provider$QuickbooksAccount$Min$name(
													$author$project$Api$Provider$QuickbooksCategoryMapping$All$quickbooksAccount(quickbooksCategoryMapping)))),
											A3(
											$author$project$Ui$Button$view,
											{mm: 'Edit category mapping'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$sm,
													$author$project$Ui$Button$onClick(
													$author$project$Components$Admin$Quickbooks$Mappings$EditQuickbooksCategoryMapping(quickbooksCategoryMapping)),
													$author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Edit')
												]))
										]));
							}
						}()
						]))
				]));
	});
var $author$project$Components$Admin$Quickbooks$Mappings$viewIncomeAccountSkeleton = A2(
	$author$project$Ui$Grid$row,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Grid$column,
			_List_fromArray(
				[
					$author$project$Ui$Grid$spanMd(4)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$span(4)
								]))
						]))
				])),
			A2(
			$author$project$Ui$Grid$column,
			_List_fromArray(
				[
					$author$project$Ui$Grid$spanMd(2)
				]),
			_List_Nil),
			A2(
			$author$project$Ui$Grid$column,
			_List_fromArray(
				[
					$author$project$Ui$Grid$spanMd(2)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textRight]),
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$span(8)
										]))
								]))
						]))
				])),
			A2(
			$author$project$Ui$Grid$column,
			_List_fromArray(
				[
					$author$project$Ui$Grid$spanMd(4)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$span(3)
								]))
						]))
				]))
		]));
var $author$project$Components$Admin$Quickbooks$Mappings$view = function (_v0) {
	var model = _v0;
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Other Accounts'),
						$author$project$Ui$Form$Group$labelInsideControl
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('The below accounts allow us to ensure we can correctly auto-match revenue from this platform with deposits in QuickBooks.')
							]))
					])),
				A2($author$project$Components$Admin$Quickbooks$Mappings$viewAccount, 0, model.g2),
				A2($author$project$Components$Admin$Quickbooks$Mappings$viewAccount, 1, model.g2),
				A2($author$project$Components$Admin$Quickbooks$Mappings$viewAccount, 2, model.g2),
				A2($elm$html$Html$br, _List_Nil, _List_Nil),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Income Accounts'),
						$author$project$Ui$Form$Group$labelInsideControl
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Match each revenue category from this platform (on the left) to the desired income account in QuickBooks (on the right). '),
								A2(
								$author$project$Ui$Typography$u,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('You must create your desired income accounts in QuickBooks prior to the matching process.')
									])),
								$elm$html$Html$text(' Every category on the left must be matched in order to activate the integration.')
							]))
					])),
				A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				function () {
					var _v1 = model.pt;
					if (_v1.$ === 3) {
						var quickbooksCategoryMappings = _v1.a;
						var loadingQuickbooksAccounts = !$author$project$Utils$Maybe$toBool(
							$author$project$Api$Data$toMaybe(model.iG));
						return A2(
							$elm$core$List$map,
							$author$project$Components$Admin$Quickbooks$Mappings$viewIncomeAccount(loadingQuickbooksAccounts),
							quickbooksCategoryMappings);
					} else {
						return A2($elm$core$List$repeat, 10, $author$project$Components$Admin$Quickbooks$Mappings$viewIncomeAccountSkeleton);
					}
				}()),
				A2($author$project$Components$Admin$Quickbooks$Mappings$viewAccount, 3, model.g2),
				function () {
				var _v2 = model.pt;
				if (_v2.$ === 3) {
					var quickbooksCategoryMappings = _v2.a;
					return $author$project$Components$Admin$Quickbooks$Mappings$hasUnmappedCategories(quickbooksCategoryMappings) ? A2(
						$author$project$Ui$Alert$warning,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Deposits with transactions in unmatched platform categories won\'t appear on QuickBooks.')
							])) : $author$project$Utils$Html$empty;
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]));
};
var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$viewSyncForm = function (form) {
	var fields = $author$project$Utils$Form$fields(form);
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Start syncing on'),
						$author$project$Ui$Form$Group$labelInsideControl,
						$author$project$Ui$Form$Group$inputSpanMd(8)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Hint will begin syncing transaction information for deposits made on or after this date. '),
								$elm$html$Html$text('We recommend selecting a date in the future to prevent the integration from affecting past '),
								$elm$html$Html$text('deposits that had already been reconciled in QuickBooks.')
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$inputSpanMd(4)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Pages$Marketplace$Quickbooks$Manage$Settings$DateInputMsg(fields.rZ),
						A2(
							$author$project$Components$DateInput$view,
							_List_fromArray(
								[
									$author$project$Components$DateInput$value(fields.acJ)
								]),
							fields.rZ))
					]))
			]));
};
var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$viewOverviewStep = F2(
	function (model, quickbooksIntegration) {
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Pages$Marketplace$Quickbooks$Manage$Settings$viewStatusLeft,
					$author$project$Api$Provider$QuickbooksIntegration$One$status(quickbooksIntegration),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flex, $author$project$Ui$Element$justifyRight]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Deactivate QuickBooks integration'},
									_List_fromArray(
										[
											$author$project$Ui$Button$onClick($author$project$Pages$Marketplace$Quickbooks$Manage$Settings$Deactivate),
											$author$project$Ui$Button$link
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Deactivate the integration')
										]))
								])),
							($author$project$Api$Provider$QuickbooksIntegration$One$errorsCount(quickbooksIntegration) > 0) ? A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Icon$cross(
									_List_fromArray(
										[$author$project$Ui$Icon$danger])),
									$author$project$Utils$Html$noBreakSpace,
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$danger]),
									A2(
										$author$project$Formatters$String$pluralize,
										'deposit',
										$author$project$Api$Provider$QuickbooksIntegration$One$errorsCount(quickbooksIntegration))),
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$danger]),
									' failed to sync in the last 180 days. '),
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Reports__Custom__Id_String(
										{ahP: 'rpt-xrMXbiUetHe1'}),
									_List_fromArray(
										[$author$project$Ui$Link$targetBlank]),
									_List_fromArray(
										[
											$elm$html$Html$text('View errors on the report.')
										]))
								])) : $author$project$Utils$Html$empty
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('')
						]),
					_List_fromArray(
						[
							function () {
							var _v0 = model.hp;
							if (!_v0.$) {
								var quickbooksMappings = _v0.a;
								return A2(
									$elm$html$Html$map,
									$author$project$Pages$Marketplace$Quickbooks$Manage$Settings$QuickbooksMappingsMsg,
									$author$project$Components$Admin$Quickbooks$Mappings$view(quickbooksMappings));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						])),
					function () {
					var _v1 = model.SD;
					if (!_v1.$) {
						var form = _v1.a;
						return $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$viewSyncForm(form);
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]));
	});
var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				function () {
				var _v0 = model.ix;
				if (!_v0.$) {
					var autorizeRequest = _v0.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Marketplace$Quickbooks$Manage$Settings$AuthorizeOnQuickbooksHiConfirmClosed,
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('connect'),
								$author$project$Components$HiConfirm$titleizeNoun(false),
								$author$project$Components$HiConfirm$noun('to QuickBooks Online'),
								$author$project$Components$HiConfirm$customMessage(
								_List_fromArray(
									[
										$elm$html$Html$text('Hint provides this integration only as a convenience to you. QuickBooks is solely responsible for its service, content and policies, including those related to privacy and security. Please review QuickBooks\' Terms of Service, and Privacy Policy to ensure they meet your business and legal requirements.')
									])),
								$author$project$Components$HiConfirm$loading(
								_Utils_eq(autorizeRequest, $author$project$Api$Data$Loading))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v1 = model.hp;
				if (!_v1.$) {
					var quickbooksMappings = _v1.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$Marketplace$Quickbooks$Manage$Settings$QuickbooksMappingsMsg,
						$author$project$Components$Admin$Quickbooks$Mappings$modal(quickbooksMappings));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v2 = model.f6;
				if (!_v2.$) {
					var deactivate = _v2.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Marketplace$Quickbooks$Manage$Settings$DeactivateHiConfirmClosed,
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('disconnect'),
								$author$project$Components$HiConfirm$noun('Quickbooks'),
								$author$project$Components$HiConfirm$loading(
								_Utils_eq(deactivate, $author$project$Api$Data$Loading))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A4(
								$author$project$Ui$Image$view,
								model.sF,
								{LD: 'QuickBooks Online Logo'},
								_List_fromArray(
									[
										$author$project$Ui$Image$width(200)
									]),
								8)
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						function () {
							var _v3 = model.dG;
							if (_v3.$ === 1) {
								return $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$initialStepSkeleton;
							} else {
								return _List_fromArray(
									[
										function () {
										var _v4 = model.acf;
										switch (_v4.$) {
											case 0:
												return $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$viewInitialStep(model);
											case 1:
												return $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$viewDownloadingStep;
											default:
												var quickbooksIntegration = _v4.a;
												return A2($author$project$Pages$Marketplace$Quickbooks$Manage$Settings$viewOverviewStep, model, quickbooksIntegration);
										}
									}()
									]);
							}
						}()),
						function () {
						var _v5 = model.acf;
						switch (_v5.$) {
							case 0:
								return $author$project$Ui$Panel$none;
							case 1:
								return $author$project$Ui$Panel$none;
							default:
								var quickbooksIntegration = _v5.a;
								return A2($author$project$Pages$Marketplace$Quickbooks$Manage$Settings$viewOverviewFooter, model, quickbooksIntegration);
						}
					}()
					]))
			]),
		ac9: 'Marketplace | Quickbooks Settings'
	};
};
var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$init, aiq: $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$load, k8: $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$save, alO: $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$subscriptions, adT: $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$update, amo: $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$view});
var $author$project$Pages$Marketplace$Slug_String$CallToActionMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Marketplace$Slug_String$ProductMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Platform$Session$One$organizationIsPartner = function (_v0) {
	var record = _v0;
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$eq(2),
			A2($elm$core$Maybe$map, $author$project$Api$Platform$Organization$Shared$type_, record.Yr)));
};
var $author$project$Api$Partner$PartnerProductDocument$partnerProductDocumentsPath = function (productId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['partner_products', productId, 'documents']),
		$author$project$Api$Data$partnerPath);
};
var $author$project$Api$Partner$PartnerProductDocument$partnerProductDocumentPath = F2(
	function (productId, id_) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id_]),
			$author$project$Api$Partner$PartnerProductDocument$partnerProductDocumentsPath(productId));
	});
var $author$project$Api$Partner$PartnerProductDocument$signedFileUrl = F4(
	function (apiClient, productId, id, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string),
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['signed_file_url']),
					A2($author$project$Api$Partner$PartnerProductDocument$partnerProductDocumentPath, productId, id))));
	});
var $author$project$Api$Provider$Marketplace$Product$productPath = function (slug) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[slug]),
		$author$project$Api$Provider$Marketplace$Product$productsPath);
};
var $author$project$Api$Provider$Marketplace$Product$Document$documentsPath = function (slug) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['documents']),
		$author$project$Api$Provider$Marketplace$Product$productPath(slug));
};
var $author$project$Api$Provider$Marketplace$Product$Document$documentPath = F2(
	function (slug, documentId) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[documentId]),
			$author$project$Api$Provider$Marketplace$Product$Document$documentsPath(slug));
	});
var $author$project$Api$Provider$Marketplace$Product$Document$signedUrl = F4(
	function (apiClient, slug, documentId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string),
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['signed_url']),
					A2($author$project$Api$Provider$Marketplace$Product$Document$documentPath, slug, documentId))));
	});
var $author$project$Pages$Marketplace$Slug_String$fetchDocumentSignedUrl = F6(
	function (session, slug, apiClient, productId, documentId, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsPartner(session) ? A4($author$project$Api$Partner$PartnerProductDocument$signedFileUrl, apiClient, productId, documentId, toMsg) : A4($author$project$Api$Provider$Marketplace$Product$Document$signedUrl, apiClient, slug, documentId, toMsg);
	});
var $author$project$Pages$Marketplace$Slug_String$GotProviderPractice = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Marketplace$Slug_String$fetchPractice = F2(
	function (apiClient, session) {
		return $author$project$Api$Platform$Session$One$organizationIsPartner(session) ? $elm$core$Platform$Cmd$none : A3($author$project$Api$Provider$Practice$retrieve, apiClient, $elm$core$Basics$identity, $author$project$Pages$Marketplace$Slug_String$GotProviderPractice);
	});
var $author$project$Pages$Marketplace$Slug_String$GotPartnerMarketplaceProduct = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Marketplace$Slug_String$GotProviderMarketplaceProduct = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Common$Marketplace$Product$One$Product = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Common$Marketplace$Product$Engagement$Status$CantEngage = {$: 2};
var $author$project$Api$Common$Marketplace$Product$One$Record = function (id) {
	return function (partner) {
		return function (overview) {
			return function (highlights) {
				return function (quotes) {
					return function (links) {
						return function (dataFlows) {
							return function (categories) {
								return function (composedCtaUrl) {
									return function (partnerProductDocuments) {
										return function (preconditions) {
											return function (pricing) {
												return function (engagementContext) {
													return function (betaAccess) {
														return function (installMeta) {
															return function (partnerApp) {
																return {MA: betaAccess, Nr: categories, Op: composedCtaUrl, PA: dataFlows, Rx: engagementContext, Tu: highlights, ahP: id, T4: installMeta, V5: links, YB: overview, YN: partner, YP: partnerApp, YS: partnerProductDocuments, Z7: preconditions, _i: pricing, _0: quotes};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Common$Marketplace$Product$DataFlow$DataFlow = $elm$core$Basics$identity;
var $author$project$Api$Common$Marketplace$Product$DataFlow$Record = F3(
	function (hintName, partnerName, syncDirection) {
		return {TA: hintName, YR: partnerName, acK: syncDirection};
	});
var $author$project$Api$Common$Marketplace$Product$DataFlow$decoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'sync_direction',
		$author$project$Api$Common$Marketplace$Product$SyncDirection$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'partner_name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'hint_name',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Common$Marketplace$Product$DataFlow$Record)))));
var $author$project$Api$Common$Marketplace$Product$Document$Document = $elm$core$Basics$identity;
var $author$project$Api$Common$Marketplace$Product$Document$Record = F4(
	function (id, title, documentType, url) {
		return {QU: documentType, ahP: id, ac9: title, adY: url};
	});
var $author$project$Api$Common$Marketplace$Product$Document$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'url',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'document_type',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'title',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Common$Marketplace$Product$Document$Record)))));
var $author$project$Api$Common$Marketplace$Product$Document$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Marketplace$Product$Document$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$Marketplace$Product$Highlight$Highlight = $elm$core$Basics$identity;
var $author$project$Api$Common$Marketplace$Product$Highlight$Record = F3(
	function (title, description, imageUrl) {
		return {Qr: description, TP: imageUrl, ac9: title};
	});
var $author$project$Api$Common$Marketplace$Product$Highlight$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'image_url',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'description',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'title',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Common$Marketplace$Product$Highlight$Record))));
var $author$project$Api$Common$Marketplace$Product$Highlight$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Marketplace$Product$Highlight$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$Marketplace$Product$InstallMeta$InstallMeta = $elm$core$Basics$identity;
var $author$project$Api$Common$Marketplace$Product$InstallMeta$Record = F3(
	function (enabled, reason, missingRequirements) {
		return {Ro: enabled, Xi: missingRequirements, _7: reason};
	});
var $author$project$Api$Common$Marketplace$Product$InstallMeta$MissingFeature = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Common$Marketplace$Product$InstallMeta$MissingTier = {$: 1};
var $author$project$Api$Common$Marketplace$Product$Requirement$Feature$Emr = {$: 0};
var $author$project$Api$Common$Marketplace$Product$Requirement$Feature$Other = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Common$Marketplace$Product$Requirement$Feature$fromString = function (string) {
	if (string === 'emr') {
		return $author$project$Api$Common$Marketplace$Product$Requirement$Feature$Emr;
	} else {
		return $author$project$Api$Common$Marketplace$Product$Requirement$Feature$Other(string);
	}
};
var $author$project$Api$Common$Marketplace$Product$InstallMeta$missingRequirementDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (type_) {
		if (type_ === 'feature') {
			return A2(
				$elm$json$Json$Decode$map,
				A2($elm$core$Basics$composeL, $author$project$Api$Common$Marketplace$Product$InstallMeta$MissingFeature, $author$project$Api$Common$Marketplace$Product$Requirement$Feature$fromString),
				A2($elm$json$Json$Decode$field, 'feature', $elm$json$Json$Decode$string));
		} else {
			return A2(
				$elm$json$Json$Decode$map,
				$elm$core$Basics$always($author$project$Api$Common$Marketplace$Product$InstallMeta$MissingTier),
				A2($elm$json$Json$Decode$field, 'starting_tier', $elm$json$Json$Decode$string));
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$Api$Common$Marketplace$Product$InstallMeta$decoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'missing_requirements',
		$elm$json$Json$Decode$list($author$project$Api$Common$Marketplace$Product$InstallMeta$missingRequirementDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'reason',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'enabled',
				$elm$json$Json$Decode$bool,
				$elm$json$Json$Decode$succeed($author$project$Api$Common$Marketplace$Product$InstallMeta$Record)))));
var $author$project$Api$Common$Marketplace$Product$Link$Link = $elm$core$Basics$identity;
var $author$project$Api$Common$Marketplace$Product$Link$Record = F4(
	function (title, linkType, value, composedUrl) {
		return {Oq: composedUrl, V3: linkType, ac9: title, aee: value};
	});
var $author$project$Api$Common$Marketplace$Product$Link$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'composed_url',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'value',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'link_type',
			$author$project$Api$Common$Marketplace$Product$LinkType$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'title',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Common$Marketplace$Product$Link$Record)))));
var $author$project$Api$Common$Marketplace$Product$Link$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Marketplace$Product$Link$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$Marketplace$Product$Overview$Overview = $elm$core$Basics$identity;
var $author$project$Api$Common$Marketplace$Product$Overview$Record = F2(
	function (description, images) {
		return {Qr: description, TQ: images};
	});
var $author$project$Api$Common$Marketplace$Product$ProductImage$ProductImage = $elm$core$Basics$identity;
var $author$project$Api$Common$Marketplace$Product$ProductImage$Record = F2(
	function (fileUrl, alt) {
		return {LD: alt, Sp: fileUrl};
	});
var $author$project$Api$Common$Marketplace$Product$ProductImage$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'alt',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'file_url',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$json$Json$Decode$succeed($author$project$Api$Common$Marketplace$Product$ProductImage$Record)));
var $author$project$Api$Common$Marketplace$Product$ProductImage$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Marketplace$Product$ProductImage$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$Marketplace$Product$Overview$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'images',
	$elm$json$Json$Decode$list($author$project$Api$Common$Marketplace$Product$ProductImage$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'description',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$json$Json$Decode$succeed($author$project$Api$Common$Marketplace$Product$Overview$Record)));
var $author$project$Api$Common$Marketplace$Product$Overview$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Marketplace$Product$Overview$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$Marketplace$Product$Precondition$Precondition = $elm$core$Basics$identity;
var $author$project$Api$Common$Marketplace$Product$Precondition$Record = F3(
	function (id, type_, url) {
		return {ahP: id, amg: type_, adY: url};
	});
var $author$project$Api$Common$Marketplace$Product$Precondition$Type$ExternalAccount = 1;
var $author$project$Api$Common$Marketplace$Product$Precondition$Type$ExternalInstall = 0;
var $author$project$Api$Common$Marketplace$Product$Precondition$Type$OnboardingCall = 2;
var $author$project$Api$Common$Marketplace$Product$Precondition$Type$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		switch (s) {
			case 'external_install':
				return $elm$json$Json$Decode$succeed(0);
			case 'external_account':
				return $elm$json$Json$Decode$succeed(1);
			case 'onboarding_call':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Unknown precondition type: ' + s);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Common$Marketplace$Product$Precondition$decoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'url',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'type',
			$author$project$Api$Common$Marketplace$Product$Precondition$Type$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Common$Marketplace$Product$Precondition$Record)))));
var $author$project$Api$Common$Marketplace$Product$Quote$Quote = $elm$core$Basics$identity;
var $author$project$Api$Common$Marketplace$Product$Quote$Record = F4(
	function (text, author, authorTitle, authorImageUrl) {
		return {Mb: author, Mc: authorImageUrl, Md: authorTitle, ac3: text};
	});
var $author$project$Api$Common$Marketplace$Product$Quote$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'author_image_url',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'author_title',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'author',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'text',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Common$Marketplace$Product$Quote$Record)))));
var $author$project$Api$Common$Marketplace$Product$Quote$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Marketplace$Product$Quote$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$Marketplace$Product$Engagement$Status$Engaged = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Common$Marketplace$Product$Engagement$Status$NotEngaged = {$: 1};
var $author$project$Api$Common$Marketplace$Product$Engagement$Status$Other = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Common$Marketplace$Product$Engagement$Status$BetaAccessGranted = {$: 2};
var $author$project$Api$Common$Marketplace$Product$Engagement$Status$InstallAttempted = {$: 3};
var $author$project$Api$Common$Marketplace$Product$Engagement$Status$InstallRequested = {$: 4};
var $author$project$Api$Common$Marketplace$Product$Engagement$Status$Interested = {$: 1};
var $author$project$Api$Common$Marketplace$Product$Engagement$Status$Waitlisted = {$: 0};
var $author$project$Api$Common$Marketplace$Product$Engagement$Status$fromString = function (string) {
	switch (string) {
		case 'waitlisted':
			return $elm$core$Maybe$Just($author$project$Api$Common$Marketplace$Product$Engagement$Status$Waitlisted);
		case 'interested':
			return $elm$core$Maybe$Just($author$project$Api$Common$Marketplace$Product$Engagement$Status$Interested);
		case 'beta_access_granted':
			return $elm$core$Maybe$Just($author$project$Api$Common$Marketplace$Product$Engagement$Status$BetaAccessGranted);
		case 'install_attempted':
			return $elm$core$Maybe$Just($author$project$Api$Common$Marketplace$Product$Engagement$Status$InstallAttempted);
		case 'install_requested':
			return $elm$core$Maybe$Just($author$project$Api$Common$Marketplace$Product$Engagement$Status$InstallRequested);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Common$Marketplace$Product$Engagement$Status$decoder = A2(
	$elm$json$Json$Decode$map,
	function (string) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Api$Common$Marketplace$Product$Engagement$Status$Other(string),
			$author$project$Api$Common$Marketplace$Product$Engagement$Status$fromString(string));
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Common$Marketplace$Product$Engagement$Status$engagementContextDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map($author$project$Api$Common$Marketplace$Product$Engagement$Status$Engaged),
		$elm$core$Maybe$withDefault($author$project$Api$Common$Marketplace$Product$Engagement$Status$NotEngaged)),
	$elm$json$Json$Decode$nullable($author$project$Api$Common$Marketplace$Product$Engagement$Status$decoder));
var $author$project$Api$Common$Marketplace$Product$One$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'partner_app',
	$elm$json$Json$Decode$nullable($author$project$Api$Common$PartnerApp$Shared$decoder),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'meta',
		$elm$json$Json$Decode$nullable(
			A2($elm$json$Json$Decode$field, 'install', $author$project$Api$Common$Marketplace$Product$InstallMeta$decoder)),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'beta_access',
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$withDefault(false),
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool)),
			false,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'engagement_status',
				$author$project$Api$Common$Marketplace$Product$Engagement$Status$engagementContextDecoder,
				$author$project$Api$Common$Marketplace$Product$Engagement$Status$CantEngage,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'pricing',
					$elm$json$Json$Decode$nullable(
						A2($elm$json$Json$Decode$field, 'description', $elm$json$Json$Decode$string)),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'preconditions',
						$elm$json$Json$Decode$list($author$project$Api$Common$Marketplace$Product$Precondition$decoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'partner_product_documents',
							$elm$json$Json$Decode$list($author$project$Api$Common$Marketplace$Product$Document$decoder),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'composed_cta_url',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'categories',
									$elm$json$Json$Decode$list($author$project$Api$Common$Marketplace$Product$Category$decoder),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'data_flows',
										$elm$json$Json$Decode$list($author$project$Api$Common$Marketplace$Product$DataFlow$decoder),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'links',
											$elm$json$Json$Decode$list($author$project$Api$Common$Marketplace$Product$Link$decoder),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'quotes',
												$elm$json$Json$Decode$list($author$project$Api$Common$Marketplace$Product$Quote$decoder),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'highlights',
													$elm$json$Json$Decode$list($author$project$Api$Common$Marketplace$Product$Highlight$decoder),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'overview',
														$elm$json$Json$Decode$nullable($author$project$Api$Common$Marketplace$Product$Overview$decoder),
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'partner',
															$elm$json$Json$Decode$nullable($author$project$Api$Common$Partner$Min$decoder),
															$elm$core$Maybe$Nothing,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'id',
																$elm$json$Json$Decode$string,
																$elm$json$Json$Decode$succeed($author$project$Api$Common$Marketplace$Product$One$Record)))))))))))))))));
var $author$project$Api$Common$Marketplace$Product$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Marketplace$Product$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Common$Marketplace$Product$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Common$Marketplace$Product$One$Product)));
var $author$project$Api$Partner$Marketplace$Product$productsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['marketplace', 'products']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$Marketplace$Product$productPath = function (slug) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[slug]),
		$author$project$Api$Partner$Marketplace$Product$productsPath);
};
var $author$project$Api$Partner$Marketplace$Product$retrieve = F3(
	function (apiClient, slug, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Common$Marketplace$Product$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Partner$Marketplace$Product$productPath(slug)));
	});
var $author$project$Api$Provider$Marketplace$Product$retrieve = F3(
	function (apiClient, slug, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Common$Marketplace$Product$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Marketplace$Product$productPath(slug)));
	});
var $author$project$Pages$Marketplace$Slug_String$fetchProduct = F3(
	function (apiClient, session, slug) {
		return $author$project$Api$Platform$Session$One$organizationIsPartner(session) ? A3($author$project$Api$Partner$Marketplace$Product$retrieve, apiClient, slug, $author$project$Pages$Marketplace$Slug_String$GotPartnerMarketplaceProduct) : A3($author$project$Api$Provider$Marketplace$Product$retrieve, apiClient, slug, $author$project$Pages$Marketplace$Slug_String$GotProviderMarketplaceProduct);
	});
var $author$project$Components$Marketplace$Product$Overview$CarouselMsg = $elm$core$Basics$identity;
var $author$project$Components$Marketplace$Product$Overview$Model = $elm$core$Basics$identity;
var $author$project$Components$Carousel$init = function (toMsg) {
	return {nB: false, sG: 0, al6: toMsg};
};
var $author$project$Components$Marketplace$Product$Overview$init = function (overview) {
	return {
		mH: $author$project$Components$Carousel$init($elm$core$Basics$identity),
		YB: overview
	};
};
var $author$project$Components$Marketplace$Product$Quotes$CarouselMsg = $elm$core$Basics$identity;
var $author$project$Components$Marketplace$Product$Quotes$Model = $elm$core$Basics$identity;
var $author$project$Components$Marketplace$Product$Quotes$init = function (quotes) {
	return {
		mH: $author$project$Components$Carousel$init($elm$core$Basics$identity),
		_0: quotes
	};
};
var $author$project$Components$Marketplace$Product$init = function (_v0) {
	var imageStore = _v0.sF;
	return _Utils_Tuple2(
		{
			sF: imageStore,
			YB: $author$project$Components$Marketplace$Product$Overview$init($elm$core$Maybe$Nothing),
			_s: $elm$core$Maybe$Nothing,
			_0: $author$project$Components$Marketplace$Product$Quotes$init(_List_Nil)
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Components$Marketplace$Product$CallToAction$AgreementsStep = 1;
var $author$project$Components$Marketplace$Product$CallToAction$init = function (_v0) {
	var isAdmin = _v0.Uy;
	var toMsg = _v0.al6;
	var fetchDocumentSignedUrl = _v0.zE;
	return {
		dS: $elm$core$Set$empty,
		cW: $elm$core$Set$empty,
		ib: false,
		K: $elm$core$Maybe$Nothing,
		aeJ: $elm$core$Maybe$Nothing,
		ae2: true,
		d5: $elm$core$Maybe$Nothing,
		au: $elm$core$Maybe$Just(1),
		zE: fetchDocumentSignedUrl,
		Uy: isAdmin,
		V8: false,
		ai4: $elm$core$Maybe$Nothing,
		ZV: $elm$core$Maybe$Nothing,
		_s: $elm$core$Maybe$Nothing,
		al6: toMsg
	};
};
var $author$project$Pages$Marketplace$Slug_String$init = F3(
	function (session, shared, _v0) {
		var params = _v0.YL;
		var callToAction = $author$project$Components$Marketplace$Product$CallToAction$init(
			{
				zE: A2($author$project$Pages$Marketplace$Slug_String$fetchDocumentSignedUrl, session, params.abG),
				Uy: $author$project$Api$Platform$Session$One$userIsPracticeAdmin(session),
				al6: $author$project$Pages$Marketplace$Slug_String$CallToActionMsg
			});
		var _v1 = $author$project$Components$Marketplace$Product$init(
			{sF: shared.sF});
		var product = _v1.a;
		var productCmd = _v1.b;
		return _Utils_Tuple2(
			{
				Gv: shared.Gv,
				br: callToAction,
				Ij: $author$project$Shared$isHintAdmin(shared),
				tl: false,
				tD: $elm$core$Maybe$Nothing,
				_s: product,
				pq: $elm$core$Maybe$Nothing,
				aa4: session,
				abG: params.abG
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Marketplace$Slug_String$ProductMsg, productCmd),
						A3($author$project$Pages$Marketplace$Slug_String$fetchProduct, shared.Gv, session, params.abG),
						A2($author$project$Pages$Marketplace$Slug_String$fetchPractice, shared.Gv, session)
					])));
	});
var $author$project$Pages$Marketplace$Slug_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Marketplace$Slug_String$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Marketplace$Product$OverviewMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Carousel$ToggleExpanded = {$: 1};
var $author$project$Components$Carousel$subscriptions = function (_v0) {
	var toMsg = _v0.al6;
	var expanded = _v0.nB;
	return expanded ? $elm$browser$Browser$Events$onKeyDown(
		A2(
			$elm$json$Json$Decode$andThen,
			function (key) {
				return (key === 'Escape') ? $elm$json$Json$Decode$succeed(
					toMsg($author$project$Components$Carousel$ToggleExpanded)) : $elm$json$Json$Decode$fail('ignore');
			},
			A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string))) : $elm$core$Platform$Sub$none;
};
var $author$project$Components$Marketplace$Product$Overview$subscriptions = function (_v0) {
	var model = _v0;
	return $author$project$Components$Carousel$subscriptions(model.mH);
};
var $author$project$Components$Marketplace$Product$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Components$Marketplace$Product$OverviewMsg,
		$author$project$Components$Marketplace$Product$Overview$subscriptions(model.YB));
};
var $author$project$Components$Marketplace$Product$CallToAction$ActivateCanceled = {$: 3};
var $author$project$Components$Marketplace$Product$CallToAction$DeactivateCanceled = {$: 13};
var $author$project$Components$Marketplace$Product$CallToAction$LocalhostConnectResult = function (a) {
	return {$: 10, a: a};
};
var $author$project$Ports$LocalhostConnect$localhostConnectResult = _Platform_incomingPort('localhostConnectResult', $elm$json$Json$Decode$bool);
var $author$project$Ports$LocalhostConnect$onResult = $author$project$Ports$LocalhostConnect$localhostConnectResult;
var $author$project$Components$Marketplace$Product$CallToAction$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Marketplace$Product$CallToAction$ActivateCanceled)),
					model.K)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Marketplace$Product$CallToAction$DeactivateCanceled)),
					model.d5)),
				$author$project$Ports$LocalhostConnect$onResult($author$project$Components$Marketplace$Product$CallToAction$LocalhostConnectResult)
			]));
};
var $author$project$Pages$Marketplace$Slug_String$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Marketplace$Slug_String$ProductMsg,
				$author$project$Components$Marketplace$Product$subscriptions(model._s)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Marketplace$Slug_String$CallToActionMsg,
				$author$project$Components$Marketplace$Product$CallToAction$subscriptions(model.br))
			]));
};
var $author$project$OutMsg$ReloadPartnerApps = {$: 22};
var $author$project$Api$Common$Partner$Min$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Common$Marketplace$Product$One$partnerId = function (_v0) {
	var record = _v0.b;
	return A2(
		$elm$core$Maybe$withDefault,
		record.ahP,
		A2($elm$core$Maybe$map, $author$project$Api$Common$Partner$Min$id, record.YN));
};
var $author$project$Api$Common$Marketplace$Product$ProductImage$alt = function (_v0) {
	var record = _v0;
	return record.LD;
};
var $author$project$Api$Common$Marketplace$Product$Quote$author = function (_v0) {
	var record = _v0;
	return record.Mb;
};
var $author$project$Api$Common$Marketplace$Product$Quote$authorImageUrl = function (_v0) {
	var record = _v0;
	return record.Mc;
};
var $author$project$Api$Common$Marketplace$Product$Quote$authorTitle = function (_v0) {
	var record = _v0;
	return record.Md;
};
var $author$project$Api$Common$Marketplace$Product$One$betaAccess = function (_v0) {
	var record = _v0.b;
	return record.MA;
};
var $author$project$Api$Common$Marketplace$Product$Shared$builtByName = function (_v0) {
	var record = _v0;
	return record.MV;
};
var $author$project$Api$Common$Marketplace$Product$One$builtByName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Marketplace$Product$Shared$builtByName(shared);
};
var $author$project$Api$Common$Marketplace$Product$Shared$builtByUrl = function (_v0) {
	var record = _v0;
	return record.MW;
};
var $author$project$Api$Common$Marketplace$Product$One$builtByUrl = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Marketplace$Product$Shared$builtByUrl(shared);
};
var $author$project$Api$Common$Marketplace$Product$One$categories = function (_v0) {
	var record = _v0.b;
	return record.Nr;
};
var $author$project$Api$Common$Marketplace$Product$One$composedCtaUrl = function (_v0) {
	var record = _v0.b;
	return record.Op;
};
var $author$project$Api$Common$Marketplace$Product$Link$composedUrl = function (_v0) {
	var record = _v0;
	return record.Oq;
};
var $author$project$Api$Common$Marketplace$Product$One$dataFlows = function (_v0) {
	var record = _v0.b;
	return record.PA;
};
var $author$project$Api$Common$Marketplace$Product$Highlight$description = function (_v0) {
	var record = _v0;
	return record.Qr;
};
var $author$project$Api$Common$Marketplace$Product$Overview$description = function (_v0) {
	var record = _v0;
	return record.Qr;
};
var $author$project$Api$Common$Marketplace$Product$Shared$distributionType = function (_v0) {
	var record = _v0;
	return record.QN;
};
var $author$project$Api$Common$Marketplace$Product$One$distributionType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Marketplace$Product$Shared$distributionType(shared);
};
var $author$project$Api$Common$Marketplace$Product$Document$documentType = function (_v0) {
	var record = _v0;
	return record.QU;
};
var $author$project$Api$Common$Marketplace$Product$One$engagementContext = function (_v0) {
	var record = _v0.b;
	return record.Rx;
};
var $author$project$Api$Common$Marketplace$Product$Shared$featured = function (_v0) {
	var record = _v0;
	return record.Se;
};
var $author$project$Api$Common$Marketplace$Product$One$featured = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Marketplace$Product$Shared$featured(shared);
};
var $author$project$Api$Common$Marketplace$Product$ProductImage$fileUrl = function (_v0) {
	var record = _v0;
	return record.Sp;
};
var $author$project$Api$Common$Marketplace$Product$One$highlights = function (_v0) {
	var record = _v0.b;
	return record.Tu;
};
var $author$project$Api$Common$Marketplace$Product$DataFlow$hintName = function (_v0) {
	var record = _v0;
	return record.TA;
};
var $author$project$Api$Common$Marketplace$Product$One$iconUrl = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Marketplace$Product$Shared$iconUrl(shared);
};
var $author$project$Api$Common$Marketplace$Product$Document$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Common$Marketplace$Product$One$id = function (_v0) {
	var record = _v0.b;
	return record.ahP;
};
var $author$project$Api$Common$Marketplace$Product$Highlight$imageUrl = function (_v0) {
	var record = _v0;
	return record.TP;
};
var $author$project$Api$Common$Marketplace$Product$Overview$images = function (_v0) {
	var record = _v0;
	return record.TQ;
};
var $author$project$Api$Common$Marketplace$Product$One$installMeta = function (_v0) {
	var record = _v0.b;
	return record.T4;
};
var $author$project$Api$Common$Marketplace$Product$Shared$installsCount = function (_v0) {
	var record = _v0;
	return record.T5;
};
var $author$project$Api$Common$Marketplace$Product$One$installsCount = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Marketplace$Product$Shared$installsCount(shared);
};
var $author$project$Api$Common$Marketplace$Product$Link$linkType = function (_v0) {
	var record = _v0;
	return record.V3;
};
var $author$project$Api$Common$Marketplace$Product$One$links = function (_v0) {
	var record = _v0.b;
	return record.V5;
};
var $author$project$Api$Common$Marketplace$Product$Shared$listingStatus = function (_v0) {
	var record = _v0;
	return record.V7;
};
var $author$project$Api$Common$Marketplace$Product$One$listingStatus = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Marketplace$Product$Shared$listingStatus(shared);
};
var $author$project$Api$Common$Marketplace$Product$Category$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Common$Marketplace$Product$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Marketplace$Product$Shared$name(shared);
};
var $author$project$Api$Common$Marketplace$Product$One$overview = function (_v0) {
	var record = _v0.b;
	return record.YB;
};
var $author$project$Api$Common$Marketplace$Product$DataFlow$partnerName = function (_v0) {
	var record = _v0;
	return record.YR;
};
var $author$project$Api$Common$Marketplace$Product$One$partnerProductDocuments = function (_v0) {
	var record = _v0.b;
	return record.YS;
};
var $author$project$Api$Common$Marketplace$Product$One$preconditions = function (_v0) {
	var record = _v0.b;
	return record.Z7;
};
var $author$project$Api$Common$Marketplace$Product$One$pricing = function (_v0) {
	var record = _v0.b;
	return record._i;
};
var $author$project$Api$Common$Marketplace$Product$One$quotes = function (_v0) {
	var record = _v0.b;
	return record._0;
};
var $author$project$Api$Common$Marketplace$Product$One$slug = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Marketplace$Product$Shared$slug(shared);
};
var $author$project$Api$Common$Marketplace$Product$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Marketplace$Product$Shared$status(shared);
};
var $author$project$Api$Common$Marketplace$Product$Shared$summary = function (_v0) {
	var record = _v0;
	return record.acF;
};
var $author$project$Api$Common$Marketplace$Product$One$summary = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Marketplace$Product$Shared$summary(shared);
};
var $author$project$Api$Common$Marketplace$Product$DataFlow$syncDirection = function (_v0) {
	var record = _v0;
	return record.acK;
};
var $author$project$Api$Common$Marketplace$Product$Quote$text = function (_v0) {
	var record = _v0;
	return record.ac3;
};
var $author$project$Api$Common$Marketplace$Product$Document$title = function (_v0) {
	var record = _v0;
	return record.ac9;
};
var $author$project$Api$Common$Marketplace$Product$Highlight$title = function (_v0) {
	var record = _v0;
	return record.ac9;
};
var $author$project$Api$Common$Marketplace$Product$Link$title = function (_v0) {
	var record = _v0;
	return record.ac9;
};
var $author$project$Api$Common$Marketplace$Product$One$type_ = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Marketplace$Product$Shared$type_(shared);
};
var $author$project$Api$Common$Marketplace$Product$Document$url = function (_v0) {
	var record = _v0;
	return record.adY;
};
var $author$project$Api$Common$Marketplace$Product$Link$value = function (_v0) {
	var record = _v0;
	return record.aee;
};
var $author$project$Api$Common$Marketplace$Product$Shared$waitlistedCount = function (_v0) {
	var record = _v0;
	return record.aeo;
};
var $author$project$Api$Common$Marketplace$Product$One$waitlistedCount = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Marketplace$Product$Shared$waitlistedCount(shared);
};
var $author$project$Pages$Marketplace$Slug_String$commonMarketplaceProductToProductExpanded = function (marketplaceProduct) {
	return {
		MA: $author$project$Api$Common$Marketplace$Product$One$betaAccess(marketplaceProduct),
		MV: $author$project$Api$Common$Marketplace$Product$One$builtByName(marketplaceProduct),
		MW: $author$project$Api$Common$Marketplace$Product$One$builtByUrl(marketplaceProduct),
		Nr: A2(
			$elm$core$List$map,
			function (cat) {
				return {
					Bq: $author$project$Api$Common$Marketplace$Product$Category$name(cat)
				};
			},
			$author$project$Api$Common$Marketplace$Product$One$categories(marketplaceProduct)),
		Op: $author$project$Api$Common$Marketplace$Product$One$composedCtaUrl(marketplaceProduct),
		PA: A2(
			$elm$core$List$map,
			function (df) {
				return {
					TA: $author$project$Api$Common$Marketplace$Product$DataFlow$hintName(df),
					YR: $author$project$Api$Common$Marketplace$Product$DataFlow$partnerName(df),
					acK: $author$project$Api$Common$Marketplace$Product$DataFlow$syncDirection(df)
				};
			},
			$author$project$Api$Common$Marketplace$Product$One$dataFlows(marketplaceProduct)),
		PX: $elm$core$Maybe$Nothing,
		P3: $elm$core$Maybe$Nothing,
		QN: $author$project$Api$Common$Marketplace$Product$One$distributionType(marketplaceProduct),
		Rx: $author$project$Api$Common$Marketplace$Product$One$engagementContext(marketplaceProduct),
		Se: $author$project$Api$Common$Marketplace$Product$One$featured(marketplaceProduct),
		Tu: A2(
			$elm$core$List$map,
			function (hl) {
				return {
					Qr: $author$project$Api$Common$Marketplace$Product$Highlight$description(hl),
					TP: $author$project$Api$Common$Marketplace$Product$Highlight$imageUrl(hl),
					ac9: $author$project$Api$Common$Marketplace$Product$Highlight$title(hl)
				};
			},
			$author$project$Api$Common$Marketplace$Product$One$highlights(marketplaceProduct)),
		TJ: $author$project$Api$Common$Marketplace$Product$One$iconUrl(marketplaceProduct),
		T4: $author$project$Api$Common$Marketplace$Product$One$installMeta(marketplaceProduct),
		T5: $author$project$Api$Common$Marketplace$Product$One$installsCount(marketplaceProduct),
		V5: A2(
			$elm$core$List$map,
			function (l) {
				return {
					Oq: $author$project$Api$Common$Marketplace$Product$Link$composedUrl(l),
					V3: $author$project$Api$Common$Marketplace$Product$Link$linkType(l),
					ac9: $author$project$Api$Common$Marketplace$Product$Link$title(l),
					aee: $author$project$Api$Common$Marketplace$Product$Link$value(l)
				};
			},
			$author$project$Api$Common$Marketplace$Product$One$links(marketplaceProduct)),
		V7: $author$project$Api$Common$Marketplace$Product$One$listingStatus(marketplaceProduct),
		Bq: $author$project$Api$Common$Marketplace$Product$One$name(marketplaceProduct),
		YB: A2(
			$elm$core$Maybe$map,
			function (overview) {
				return {
					Qr: $author$project$Api$Common$Marketplace$Product$Overview$description(overview),
					TQ: A2(
						$elm$core$List$map,
						function (img) {
							return {
								LD: A2(
									$elm$core$Maybe$withDefault,
									'',
									$author$project$Api$Common$Marketplace$Product$ProductImage$alt(img)),
								adY: A2(
									$elm$core$Maybe$withDefault,
									'',
									$author$project$Api$Common$Marketplace$Product$ProductImage$fileUrl(img))
							};
						},
						$author$project$Api$Common$Marketplace$Product$Overview$images(overview))
				};
			},
			$author$project$Api$Common$Marketplace$Product$One$overview(marketplaceProduct)),
		YS: A2(
			$elm$core$List$map,
			function (doc) {
				return {
					QU: $author$project$Api$Common$Marketplace$Product$Document$documentType(doc),
					ahP: $author$project$Api$Common$Marketplace$Product$Document$id(doc),
					ac9: $author$project$Api$Common$Marketplace$Product$Document$title(doc),
					adY: $author$project$Api$Common$Marketplace$Product$Document$url(doc)
				};
			},
			$author$project$Api$Common$Marketplace$Product$One$partnerProductDocuments(marketplaceProduct)),
		I3: _List_Nil,
		Z7: $author$project$Api$Common$Marketplace$Product$One$preconditions(marketplaceProduct),
		_e: false,
		_i: $author$project$Api$Common$Marketplace$Product$One$pricing(marketplaceProduct),
		Jn: $author$project$Api$Common$Marketplace$Product$One$id(marketplaceProduct),
		_0: A2(
			$elm$core$List$map,
			function (q) {
				return {
					Mb: $author$project$Api$Common$Marketplace$Product$Quote$author(q),
					Mc: $author$project$Api$Common$Marketplace$Product$Quote$authorImageUrl(q),
					Md: $author$project$Api$Common$Marketplace$Product$Quote$authorTitle(q),
					ac3: $author$project$Api$Common$Marketplace$Product$Quote$text(q)
				};
			},
			$author$project$Api$Common$Marketplace$Product$One$quotes(marketplaceProduct)),
		abG: $author$project$Api$Common$Marketplace$Product$One$slug(marketplaceProduct),
		alH: $author$project$Api$Common$Marketplace$Product$One$status(marketplaceProduct),
		acF: $author$project$Api$Common$Marketplace$Product$One$summary(marketplaceProduct),
		amg: $author$project$Api$Common$Marketplace$Product$One$type_(marketplaceProduct),
		aeo: $author$project$Api$Common$Marketplace$Product$One$waitlistedCount(marketplaceProduct)
	};
};
var $author$project$Pages$Marketplace$Slug_String$partnerMarketplaceProductToProductExpanded = $author$project$Pages$Marketplace$Slug_String$commonMarketplaceProductToProductExpanded;
var $author$project$Api$Common$PartnerApp$Shared$defaultAdminRole = function (_v0) {
	var record = _v0;
	return record.PX;
};
var $author$project$Api$Common$PartnerApp$Shared$defaultNonAdminRole = function (_v0) {
	var record = _v0;
	return record.P3;
};
var $author$project$Api$Common$Marketplace$Product$One$partnerApp = function (_v0) {
	var record = _v0.b;
	return record.YP;
};
var $author$project$Api$Common$PartnerApp$Shared$partnerRoles = function (_v0) {
	var record = _v0;
	return record.I3;
};
var $author$project$Api$Common$PartnerApp$Shared$prepopulateRoleMappings = function (_v0) {
	var record = _v0;
	return record._e;
};
var $author$project$Pages$Marketplace$Slug_String$providerMarketplaceProductToProductExpanded = function (marketplaceProduct) {
	var partnerApp = $author$project$Api$Common$Marketplace$Product$One$partnerApp(marketplaceProduct);
	return function (expanded) {
		return _Utils_update(
			expanded,
			{
				PX: A2($elm$core$Maybe$andThen, $author$project$Api$Common$PartnerApp$Shared$defaultAdminRole, partnerApp),
				P3: A2($elm$core$Maybe$andThen, $author$project$Api$Common$PartnerApp$Shared$defaultNonAdminRole, partnerApp),
				I3: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Maybe$map, $author$project$Api$Common$PartnerApp$Shared$partnerRoles, partnerApp)),
				_e: A2(
					$elm$core$Maybe$withDefault,
					false,
					A2($elm$core$Maybe$map, $author$project$Api$Common$PartnerApp$Shared$prepopulateRoleMappings, partnerApp))
			});
	}(
		$author$project$Pages$Marketplace$Slug_String$commonMarketplaceProductToProductExpanded(marketplaceProduct));
};
var $author$project$Components$Marketplace$Product$CallToAction$setPractice = F2(
	function (practice, model) {
		return _Utils_update(
			model,
			{
				ZV: $elm$core$Maybe$Just(practice)
			});
	});
var $author$project$Components$Marketplace$Product$setProduct = F2(
	function (product, model) {
		return _Utils_update(
			model,
			{
				YB: $author$project$Components$Marketplace$Product$Overview$init(product.YB),
				_s: $elm$core$Maybe$Just(product),
				_0: $author$project$Components$Marketplace$Product$Quotes$init(product._0)
			});
	});
var $author$project$Components$Marketplace$Product$CallToAction$setProduct = F2(
	function (product, model) {
		return _Utils_update(
			model,
			{
				_s: $elm$core$Maybe$Just(product)
			});
	});
var $author$project$Pages$Marketplace$Slug_String$toCallToActionProduct = function (product) {
	return {MA: product.MA, Op: product.Op, PX: product.PX, P3: product.P3, QN: product.QN, Rx: product.Rx, T4: product.T4, V7: product.V7, Bq: product.Bq, YS: product.YS, I3: product.I3, Z7: product.Z7, _e: product._e, _i: product._i, Jn: product.Jn, abG: product.abG, alH: product.alH, amg: product.amg};
};
var $author$project$Components$Marketplace$Product$QuotesMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Carousel$update = F2(
	function (msg, model) {
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map(model.al6),
			function () {
				if (!msg.$) {
					var index = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{sG: index}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{nB: !model.nB}),
						$elm$core$Platform$Cmd$none);
				}
			}());
	});
var $author$project$Components$Marketplace$Product$Overview$update = F2(
	function (msg, _v0) {
		var model = _v0;
		var carouselMsg = msg;
		return A2(
			$elm$core$Tuple$mapFirst,
			function (carousel) {
				return _Utils_update(
					model,
					{mH: carousel});
			},
			A2($author$project$Components$Carousel$update, carouselMsg, model.mH));
	});
var $author$project$Components$Marketplace$Product$Quotes$update = F2(
	function (msg, _v0) {
		var model = _v0;
		var carouselMsg = msg;
		return A2(
			$elm$core$Tuple$mapFirst,
			function (carousel) {
				return _Utils_update(
					model,
					{mH: carousel});
			},
			A2($author$project$Components$Carousel$update, carouselMsg, model.mH));
	});
var $author$project$Components$Marketplace$Product$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var overviewMsg = msg.a;
			return A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Platform$Cmd$map($author$project$Components$Marketplace$Product$OverviewMsg),
				A2(
					$elm$core$Tuple$mapFirst,
					function (overview) {
						return _Utils_update(
							model,
							{YB: overview});
					},
					A2($author$project$Components$Marketplace$Product$Overview$update, overviewMsg, model.YB)));
		} else {
			var quotesMsg = msg.a;
			return A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Platform$Cmd$map($author$project$Components$Marketplace$Product$QuotesMsg),
				A2(
					$elm$core$Tuple$mapFirst,
					function (quotes) {
						return _Utils_update(
							model,
							{_0: quotes});
					},
					A2($author$project$Components$Marketplace$Product$Quotes$update, quotesMsg, model._0)));
		}
	});
var $author$project$Components$Marketplace$Product$CallToAction$AccessSettingsStep = 3;
var $author$project$Components$Marketplace$Product$CallToAction$Activated = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Components$Marketplace$Product$CallToAction$BetaAccessRequested = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Marketplace$Product$CallToAction$Deactivated = F2(
	function (a, b) {
		return {$: 14, a: a, b: b};
	});
var $author$project$Components$Marketplace$Product$CallToAction$GotLocalhostConnectUrl = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Marketplace$Product$CallToAction$GotPdfDocumentSignedUrl = function (a) {
	return {$: 22, a: a};
};
var $author$project$Components$Marketplace$Product$CallToAction$InstallAttempted = {$: 1};
var $author$project$Components$Marketplace$Product$CallToAction$InstallRequested = function (a) {
	return {$: 20, a: a};
};
var $author$project$Components$Marketplace$Product$CallToAction$InterestExpressed = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$Marketplace$Product$CallToAction$None = 0;
var $author$project$Components$Marketplace$Product$CallToAction$PartnerActivated = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Marketplace$Product$CallToAction$PricingStep = 2;
var $author$project$Components$Marketplace$Product$CallToAction$ProductActivated = 1;
var $author$project$Components$Marketplace$Product$CallToAction$ProductDeactivated = 3;
var $author$project$Components$Marketplace$Product$CallToAction$ProductEngagementUpdated = 4;
var $author$project$Components$Marketplace$Product$CallToAction$ProductInstallRequested = 5;
var $author$project$Components$Marketplace$Product$CallToAction$ProductPartnerActivated = 2;
var $author$project$Components$Marketplace$Product$CallToAction$RequirementsStep = 0;
var $author$project$Api$Provider$Partner$ForIntegrationOne$authType = function (_v0) {
	var record = _v0.b;
	return record.Ma;
};
var $author$project$Api$Provider$Integration$One$authType = function (_v0) {
	var partner = _v0.b;
	return $author$project$Api$Provider$Partner$ForIntegrationOne$authType(partner);
};
var $author$project$Api$Provider$Integration$One$Integration = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Api$Provider$Partner$ForIntegrationOne$Partner = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Partner$ForIntegrationOne$Record = F4(
	function (active, authType, email, postActivationRedirectUrl) {
		return {KN: active, Ma: authType, Rj: email, ZQ: postActivationRedirectUrl};
	});
var $author$project$Api$Provider$Partner$ForIntegrationOne$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'post_activation_redirect_url',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'email',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'auth_type',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'active',
				$elm$json$Json$Decode$bool,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$Partner$ForIntegrationOne$Record)))));
var $author$project$Api$Provider$Partner$ForIntegrationOne$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Partner$ForIntegrationOne$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Partner$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Partner$ForIntegrationOne$Partner)));
var $author$project$Api$Provider$Integration$One$Record = F6(
	function (connectionUrl, partnerApp, product, autoGrantPartnerAppAccess, defaultPartnerAppAdminRole, defaultPartnerAppNonAdminRole) {
		return {ae2: autoGrantPartnerAppAccess, Os: connectionUrl, agj: defaultPartnerAppAdminRole, agk: defaultPartnerAppNonAdminRole, YP: partnerApp, _s: product};
	});
var $author$project$Api$Provider$Integration$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'default_partner_app_non_admin_role',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'default_partner_app_admin_role',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'auto_grant_partner_app_access',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'product',
				$author$project$Api$Common$Marketplace$Product$Shared$decoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'partner_app',
					$elm$json$Json$Decode$nullable($author$project$Api$Common$PartnerApp$Shared$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'connection_url',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$Integration$One$Record)))))));
var $author$project$Api$Provider$Integration$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Integration$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Partner$ForIntegrationOne$decoder,
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			$author$project$Api$Provider$Integration$Shared$decoder,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Integration$One$Integration))));
var $author$project$Api$Provider$Integration$integrationsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['integrations']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Integration$integrationPath = function (slugOrId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[slugOrId]),
		$author$project$Api$Provider$Integration$integrationsPath);
};
var $author$project$Api$Provider$Integration$connect = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Integration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['connect']),
					$author$project$Api$Provider$Integration$integrationPath(id))));
	});
var $author$project$Ports$LocalhostConnect$localhostConnectRequest = _Platform_outgoingPort(
	'localhostConnectRequest',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'connectUrl',
					$elm$json$Json$Encode$string($.afV))
				]));
	});
var $author$project$Ports$LocalhostConnect$connect = function (connectUrl) {
	return $author$project$Ports$LocalhostConnect$localhostConnectRequest(
		{afV: connectUrl});
};
var $author$project$Api$Provider$Integration$One$connectionUrl = function (_v0) {
	var record = _v0.c;
	return record.Os;
};
var $author$project$Api$Provider$Marketplace$Product$expressInterest = F3(
	function (apiClient, slug, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Common$Marketplace$Product$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['express_interest']),
					$author$project$Api$Provider$Marketplace$Product$productPath(slug))));
	});
var $author$project$Api$Provider$Integration$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Integration$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Integration$Shared$id(shared);
};
var $author$project$Components$Marketplace$Product$CallToAction$initRoleMappings = function (product) {
	return product._e ? {Gl: product.PX, IN: product.P3} : {Gl: $elm$core$Maybe$Nothing, IN: $elm$core$Maybe$Nothing};
};
var $author$project$Api$Provider$Marketplace$Product$OneWithIntegration$Product = $elm$core$Basics$identity;
var $author$project$Api$Provider$Marketplace$Product$OneWithIntegration$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'integration',
	$author$project$Api$Provider$Integration$One$decoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Common$Marketplace$Product$One$decoder,
		$elm$json$Json$Decode$succeed(
			F2(
				function (_v0, inte) {
					return inte;
				}))));
var $author$project$Api$Provider$Marketplace$Product$install = F4(
	function (apiClient, slug, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'partner_product_document_ids',
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, params.ajO)),
					_Utils_Tuple2(
					'auto_grant_partner_app_access',
					$elm$json$Json$Encode$bool(params.ae2)),
					_Utils_Tuple2(
					'admin_role_mapping',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.aeJ)),
					_Utils_Tuple2(
					'non_admin_role_mapping',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.ai4))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Marketplace$Product$OneWithIntegration$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['install']),
						$author$project$Api$Provider$Marketplace$Product$productPath(slug)))));
	});
var $author$project$Api$Provider$Marketplace$Product$installAttempted = F3(
	function (apiClient, slug, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Common$Marketplace$Product$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['attempt_install']),
					$author$project$Api$Provider$Marketplace$Product$productPath(slug))));
	});
var $author$project$Api$Provider$Marketplace$Product$OneWithIntegration$integration = function (_v0) {
	var i = _v0;
	return i;
};
var $author$project$Api$Provider$Integration$One$partnerApp = function (_v0) {
	var record = _v0.c;
	return record.YP;
};
var $author$project$Components$Marketplace$Product$CallToAction$isLocalhostMode = function (integration) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Common$PartnerApp$Shared$localhostMode,
			$author$project$Api$Provider$Integration$One$partnerApp(integration)));
};
var $author$project$Api$Provider$Integration$localhostConnectDecoder = A2(
	$elm$json$Json$Decode$map,
	function (url) {
		return {afV: url};
	},
	A2($elm$json$Json$Decode$field, 'connect_url', $elm$json$Json$Decode$string));
var $author$project$Api$Provider$Integration$localhostConnect = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Integration$localhostConnectDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['localhost_connect']),
					$author$project$Api$Provider$Integration$integrationPath(id))));
	});
var $author$project$Components$Marketplace$Product$CallToAction$nextStepAfter = F2(
	function (currentStep, product) {
		nextStepAfter:
		while (true) {
			switch (currentStep) {
				case 1:
					if (!$elm$core$List$isEmpty(product.Z7)) {
						return $elm$core$Maybe$Just(0);
					} else {
						var $temp$currentStep = 0,
							$temp$product = product;
						currentStep = $temp$currentStep;
						product = $temp$product;
						continue nextStepAfter;
					}
				case 0:
					if (!_Utils_eq(product._i, $elm$core$Maybe$Nothing)) {
						return $elm$core$Maybe$Just(2);
					} else {
						var $temp$currentStep = 2,
							$temp$product = product;
						currentStep = $temp$currentStep;
						product = $temp$product;
						continue nextStepAfter;
					}
				case 2:
					return $elm$core$Maybe$Just(3);
				default:
					return $elm$core$Maybe$Nothing;
			}
		}
	});
var $author$project$Api$Provider$Partner$ForIntegrationOne$postActivationRedirectUrl = function (_v0) {
	var record = _v0.b;
	return record.ZQ;
};
var $author$project$Api$Provider$Integration$One$postActivationRedirectUrl = function (_v0) {
	var partner = _v0.b;
	return $author$project$Api$Provider$Partner$ForIntegrationOne$postActivationRedirectUrl(partner);
};
var $author$project$Api$Provider$Marketplace$Product$requestBeta = F3(
	function (apiClient, slug, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Common$Marketplace$Product$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['request_beta_access']),
					$author$project$Api$Provider$Marketplace$Product$productPath(slug))));
	});
var $author$project$Api$Provider$Marketplace$Product$requestInstall = F3(
	function (apiClient, slug, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Common$Marketplace$Product$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['request_install']),
					$author$project$Api$Provider$Marketplace$Product$productPath(slug))));
	});
var $author$project$Components$Marketplace$Product$CallToAction$result = F3(
	function (model, cmd, event) {
		return {GZ: cmd, agZ: event, aiO: model, aR: _List_Nil};
	});
var $author$project$Components$Marketplace$Product$CallToAction$resultWithOutMsgs = F4(
	function (model, cmd, event, outMsgs) {
		return {GZ: cmd, agZ: event, aiO: model, aR: outMsgs};
	});
var $author$project$Api$Provider$Integration$Shared$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Api$Provider$Integration$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Integration$Shared$status(shared);
};
var $author$project$Api$Provider$Marketplace$Product$uninstall = F3(
	function (apiClient, slug, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Marketplace$Product$OneWithIntegration$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['uninstall']),
					$author$project$Api$Provider$Marketplace$Product$productPath(slug))));
	});
var $author$project$Api$Common$Marketplace$Product$Precondition$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Components$Marketplace$Product$CallToAction$withPreconditionAccepted = F2(
	function (acceptedPreconditionIds, model) {
		var allAccepted = function () {
			var _v2 = model.K;
			if (!_v2.$) {
				var _v3 = _v2.a;
				var product = _v3.a;
				return A2(
					$elm$core$List$all,
					function (p) {
						return A2(
							$elm$core$Set$member,
							$author$project$Api$Common$Marketplace$Product$Precondition$id(p),
							acceptedPreconditionIds);
					},
					product.Z7);
			} else {
				return false;
			}
		}();
		var expandedModalStep = function () {
			if (allAccepted) {
				var _v0 = model.K;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var product = _v1.a;
					return A2($author$project$Components$Marketplace$Product$CallToAction$nextStepAfter, 0, product);
				} else {
					return model.au;
				}
			} else {
				return model.au;
			}
		}();
		return _Utils_update(
			model,
			{cW: acceptedPreconditionIds, au: expandedModalStep});
	});
var $author$project$Components$Marketplace$Product$CallToAction$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var product = msg.a;
				var roleMappings = $author$project$Components$Marketplace$Product$CallToAction$initRoleMappings(product);
				var initialStep = (!$elm$core$List$isEmpty(product.YS)) ? $elm$core$Maybe$Just(1) : ((!$elm$core$List$isEmpty(product.Z7)) ? $elm$core$Maybe$Just(0) : ((!_Utils_eq(product._i, $elm$core$Maybe$Nothing)) ? $elm$core$Maybe$Just(2) : $elm$core$Maybe$Just(3)));
				return A3(
					$author$project$Components$Marketplace$Product$CallToAction$result,
					_Utils_update(
						model,
						{
							dS: $elm$core$Set$empty,
							cW: $elm$core$Set$empty,
							ib: false,
							K: $elm$core$Maybe$Just(
								_Utils_Tuple2(product, $author$project$Api$Data$NotAsked)),
							aeJ: roleMappings.Gl,
							ae2: true,
							au: initialStep,
							ai4: roleMappings.IN
						}),
					A3(
						$author$project$Api$Provider$Marketplace$Product$installAttempted,
						apiClient,
						product.abG,
						$elm$core$Basics$always($author$project$Components$Marketplace$Product$CallToAction$InstallAttempted)),
					0);
			case 1:
				return A3($author$project$Components$Marketplace$Product$CallToAction$result, model, $elm$core$Platform$Cmd$none, 0);
			case 2:
				var product = msg.a;
				var installParams = {
					aeJ: model.ae2 ? model.aeJ : $elm$core$Maybe$Nothing,
					ae2: model.ae2,
					ai4: model.ae2 ? model.ai4 : $elm$core$Maybe$Nothing,
					ajO: A2(
						$elm$core$List$map,
						function ($) {
							return $.ahP;
						},
						product.YS)
				};
				return A3(
					$author$project$Components$Marketplace$Product$CallToAction$result,
					_Utils_update(
						model,
						{
							K: $elm$core$Maybe$Just(
								_Utils_Tuple2(product, $author$project$Api$Data$Loading))
						}),
					A4(
						$author$project$Api$Provider$Marketplace$Product$install,
						apiClient,
						product.abG,
						installParams,
						$author$project$Components$Marketplace$Product$CallToAction$Activated(product)),
					0);
			case 3:
				return A3(
					$author$project$Components$Marketplace$Product$CallToAction$result,
					_Utils_update(
						model,
						{
							dS: $elm$core$Set$empty,
							cW: $elm$core$Set$empty,
							ib: false,
							K: $elm$core$Maybe$Nothing,
							aeJ: $elm$core$Maybe$Nothing,
							ae2: true,
							au: $elm$core$Maybe$Just(1),
							ai4: $elm$core$Maybe$Nothing
						}),
					$elm$core$Platform$Cmd$none,
					0);
			case 4:
				var documentId = msg.a;
				var checked = msg.b;
				var acceptedDocumentIds = checked ? A2($elm$core$Set$insert, documentId, model.dS) : A2($elm$core$Set$remove, documentId, model.dS);
				var allAccepted = function () {
					var _v3 = model.K;
					if (!_v3.$) {
						var _v4 = _v3.a;
						var product = _v4.a;
						return A2(
							$elm$core$List$all,
							function (doc) {
								return A2($elm$core$Set$member, doc.ahP, acceptedDocumentIds);
							},
							product.YS);
					} else {
						return false;
					}
				}();
				var expandedModalStep = function () {
					if (allAccepted) {
						var _v1 = model.K;
						if (!_v1.$) {
							var _v2 = _v1.a;
							var product = _v2.a;
							return A2($author$project$Components$Marketplace$Product$CallToAction$nextStepAfter, 1, product);
						} else {
							return model.au;
						}
					} else {
						return model.au;
					}
				}();
				return A3(
					$author$project$Components$Marketplace$Product$CallToAction$result,
					_Utils_update(
						model,
						{dS: acceptedDocumentIds, au: expandedModalStep}),
					$elm$core$Platform$Cmd$none,
					0);
			case 5:
				var preconditionId = msg.a;
				var checked = msg.b;
				var acceptedPreconditionIds = checked ? A2($elm$core$Set$insert, preconditionId, model.cW) : A2($elm$core$Set$remove, preconditionId, model.cW);
				return A3(
					$author$project$Components$Marketplace$Product$CallToAction$result,
					A2($author$project$Components$Marketplace$Product$CallToAction$withPreconditionAccepted, acceptedPreconditionIds, model),
					$elm$core$Platform$Cmd$none,
					0);
			case 6:
				var preconditionId = msg.a;
				var url = msg.b;
				var acceptedPreconditionIds = A2($elm$core$Set$insert, preconditionId, model.cW);
				return A3(
					$author$project$Components$Marketplace$Product$CallToAction$result,
					A2($author$project$Components$Marketplace$Product$CallToAction$withPreconditionAccepted, acceptedPreconditionIds, model),
					$author$project$Ports$Navigation$openInNewWindow(url),
					0);
			case 7:
				var product = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var installedProduct = response.a;
					var integration = $author$project$Api$Provider$Marketplace$Product$OneWithIntegration$integration(installedProduct);
					var cmd = function () {
						var _v6 = _Utils_Tuple3(
							$author$project$Api$Provider$Integration$One$authType(integration),
							$author$project$Api$Provider$Integration$One$connectionUrl(integration),
							$author$project$Api$Provider$Integration$One$postActivationRedirectUrl(integration));
						_v6$0:
						while (true) {
							_v6$3:
							while (true) {
								_v6$4:
								while (true) {
									switch (_v6.a) {
										case 'automatic_redirect':
											if (!_v6.c.$) {
												if (!_v6.b.$) {
													break _v6$0;
												} else {
													break _v6$3;
												}
											} else {
												if (!_v6.b.$) {
													break _v6$0;
												} else {
													break _v6$4;
												}
											}
										case 'automatic_headless':
											return $author$project$Components$Marketplace$Product$CallToAction$isLocalhostMode(integration) ? A3(
												$author$project$Api$Provider$Integration$localhostConnect,
												apiClient,
												$author$project$Api$Provider$Integration$One$id(integration),
												$author$project$Components$Marketplace$Product$CallToAction$GotLocalhostConnectUrl) : A3(
												$author$project$Api$Provider$Integration$connect,
												apiClient,
												$author$project$Api$Provider$Integration$One$id(integration),
												$author$project$Components$Marketplace$Product$CallToAction$PartnerActivated);
										case 'manual':
											if (A2(
												$elm$core$List$member,
												$author$project$Api$Provider$Integration$One$status(integration),
												_List_fromArray(
													['pending', 'inactive']))) {
												var _v7 = product.abG;
												switch (_v7) {
													case 'quickbooks':
														return A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Marketplace__Quickbooks__Manage__Settings);
													case 'elation':
														return A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Marketplace__Elation__Manage__Settings);
													case 'athenahealth':
														return A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Marketplace__Athenahealth__Manage__Settings);
													default:
														return A2(
															$author$project$Utils$Route$navigate,
															$elm$core$Dict$empty,
															$author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Onboarding(
																{abG: product.abG}));
												}
											} else {
												return $elm$core$Platform$Cmd$none;
											}
										default:
											if (!_v6.c.$) {
												break _v6$3;
											} else {
												break _v6$4;
											}
									}
								}
								var _v8 = _v6.c;
								return $elm$core$Platform$Cmd$none;
							}
							var postActivationRedirectUrl = _v6.c.a;
							return $author$project$Ports$Navigation$pushUrl(postActivationRedirectUrl);
						}
						var connectionUrl = _v6.b.a;
						return $author$project$Ports$Navigation$openInNewWindow(connectionUrl);
					}();
					var activatingProduct = ($author$project$Api$Provider$Integration$One$authType(integration) === 'automatic_headless') ? $elm$core$Maybe$Just(
						_Utils_Tuple2(product, response)) : $elm$core$Maybe$Nothing;
					return A3(
						$author$project$Components$Marketplace$Product$CallToAction$result,
						_Utils_update(
							model,
							{K: activatingProduct}),
						cmd,
						1);
				} else {
					return A3(
						$author$project$Components$Marketplace$Product$CallToAction$result,
						_Utils_update(
							model,
							{
								K: $elm$core$Maybe$Just(
									_Utils_Tuple2(product, response))
							}),
						$elm$core$Platform$Cmd$none,
						0);
				}
			case 8:
				var response = msg.a;
				if (response.$ === 3) {
					var integration = response.a;
					return A3(
						$author$project$Components$Marketplace$Product$CallToAction$result,
						_Utils_update(
							model,
							{K: $elm$core$Maybe$Nothing}),
						function () {
							var _v10 = _Utils_Tuple2(
								$author$project$Api$Provider$Integration$One$authType(integration),
								$author$project$Api$Provider$Integration$One$postActivationRedirectUrl(integration));
							if ((_v10.a === 'automatic_headless') && (!_v10.b.$)) {
								var postActivationRedirectUrl = _v10.b.a;
								return $author$project$Ports$Navigation$pushUrl(postActivationRedirectUrl);
							} else {
								return $elm$core$Platform$Cmd$none;
							}
						}(),
						2);
				} else {
					return A3(
						$author$project$Components$Marketplace$Product$CallToAction$result,
						_Utils_update(
							model,
							{K: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						0);
				}
			case 9:
				var response = msg.a;
				if (response.$ === 3) {
					var data = response.a;
					return A3(
						$author$project$Components$Marketplace$Product$CallToAction$result,
						model,
						$author$project$Ports$LocalhostConnect$connect(data.afV),
						0);
				} else {
					return A4(
						$author$project$Components$Marketplace$Product$CallToAction$resultWithOutMsgs,
						_Utils_update(
							model,
							{K: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						0,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 1, 'Failed to retrieve localhost connect URL.')
							]));
				}
			case 10:
				var success = msg.a;
				return success ? A3(
					$author$project$Components$Marketplace$Product$CallToAction$result,
					_Utils_update(
						model,
						{K: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					2) : A4(
					$author$project$Components$Marketplace$Product$CallToAction$resultWithOutMsgs,
					_Utils_update(
						model,
						{K: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					0,
					_List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 1, 'Localhost connect failed. Ensure your local server is running and allows CORS.')
						]));
			case 11:
				var product = msg.a;
				return A3(
					$author$project$Components$Marketplace$Product$CallToAction$result,
					_Utils_update(
						model,
						{
							d5: $elm$core$Maybe$Just(
								_Utils_Tuple2(product, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					0);
			case 12:
				var product = msg.a;
				return A3(
					$author$project$Components$Marketplace$Product$CallToAction$result,
					_Utils_update(
						model,
						{
							d5: $elm$core$Maybe$Just(
								_Utils_Tuple2(product, $author$project$Api$Data$Loading))
						}),
					A3(
						$author$project$Api$Provider$Marketplace$Product$uninstall,
						apiClient,
						product.abG,
						$author$project$Components$Marketplace$Product$CallToAction$Deactivated(product)),
					0);
			case 13:
				return A3(
					$author$project$Components$Marketplace$Product$CallToAction$result,
					_Utils_update(
						model,
						{d5: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					0);
			case 14:
				var product = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return A3(
						$author$project$Components$Marketplace$Product$CallToAction$result,
						_Utils_update(
							model,
							{d5: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						3);
				} else {
					return A3(
						$author$project$Components$Marketplace$Product$CallToAction$result,
						_Utils_update(
							model,
							{
								d5: $elm$core$Maybe$Just(
									_Utils_Tuple2(product, response))
							}),
						$elm$core$Platform$Cmd$none,
						0);
				}
			case 15:
				var product = msg.a;
				return A3(
					$author$project$Components$Marketplace$Product$CallToAction$result,
					_Utils_update(
						model,
						{V8: true}),
					A3($author$project$Api$Provider$Marketplace$Product$requestBeta, apiClient, product.abG, $author$project$Components$Marketplace$Product$CallToAction$BetaAccessRequested),
					0);
			case 16:
				var response = msg.a;
				if (response.$ === 3) {
					return A3(
						$author$project$Components$Marketplace$Product$CallToAction$result,
						_Utils_update(
							model,
							{V8: false}),
						$elm$core$Platform$Cmd$none,
						4);
				} else {
					return A3(
						$author$project$Components$Marketplace$Product$CallToAction$result,
						_Utils_update(
							model,
							{V8: false}),
						$elm$core$Platform$Cmd$none,
						0);
				}
			case 17:
				var product = msg.a;
				return A3(
					$author$project$Components$Marketplace$Product$CallToAction$result,
					_Utils_update(
						model,
						{V8: true}),
					A3($author$project$Api$Provider$Marketplace$Product$expressInterest, apiClient, product.abG, $author$project$Components$Marketplace$Product$CallToAction$InterestExpressed),
					0);
			case 18:
				var response = msg.a;
				if (response.$ === 3) {
					return A3(
						$author$project$Components$Marketplace$Product$CallToAction$result,
						_Utils_update(
							model,
							{V8: false}),
						$elm$core$Platform$Cmd$none,
						4);
				} else {
					return A3(
						$author$project$Components$Marketplace$Product$CallToAction$result,
						_Utils_update(
							model,
							{V8: false}),
						$elm$core$Platform$Cmd$none,
						0);
				}
			case 19:
				var product = msg.a;
				return A3(
					$author$project$Components$Marketplace$Product$CallToAction$result,
					_Utils_update(
						model,
						{V8: true}),
					A3($author$project$Api$Provider$Marketplace$Product$requestInstall, apiClient, product.abG, $author$project$Components$Marketplace$Product$CallToAction$InstallRequested),
					0);
			case 20:
				var response = msg.a;
				if (response.$ === 3) {
					return A3(
						$author$project$Components$Marketplace$Product$CallToAction$result,
						_Utils_update(
							model,
							{V8: false}),
						$elm$core$Platform$Cmd$none,
						5);
				} else {
					return A3(
						$author$project$Components$Marketplace$Product$CallToAction$result,
						_Utils_update(
							model,
							{V8: false}),
						$elm$core$Platform$Cmd$none,
						0);
				}
			case 21:
				var document = msg.a;
				var _v16 = model._s;
				if (!_v16.$) {
					var product = _v16.a;
					return A3(
						$author$project$Components$Marketplace$Product$CallToAction$result,
						model,
						A4(model.zE, apiClient, product.Jn, document.ahP, $author$project$Components$Marketplace$Product$CallToAction$GotPdfDocumentSignedUrl),
						0);
				} else {
					return A3($author$project$Components$Marketplace$Product$CallToAction$result, model, $elm$core$Platform$Cmd$none, 0);
				}
			case 22:
				var response = msg.a;
				if (response.$ === 3) {
					var url = response.a;
					return A3(
						$author$project$Components$Marketplace$Product$CallToAction$result,
						model,
						$author$project$Ports$Navigation$openInNewWindow(url),
						0);
				} else {
					return A3($author$project$Components$Marketplace$Product$CallToAction$result, model, $elm$core$Platform$Cmd$none, 0);
				}
			case 23:
				var checked = msg.a;
				return A3(
					$author$project$Components$Marketplace$Product$CallToAction$result,
					_Utils_update(
						model,
						{
							ib: checked,
							au: checked ? $elm$core$Maybe$Just(3) : model.au
						}),
					$elm$core$Platform$Cmd$none,
					0);
			case 24:
				var value = msg.a;
				return A3(
					$author$project$Components$Marketplace$Product$CallToAction$result,
					_Utils_update(
						model,
						{ae2: value}),
					$elm$core$Platform$Cmd$none,
					0);
			case 25:
				var value = msg.a;
				return A3(
					$author$project$Components$Marketplace$Product$CallToAction$result,
					_Utils_update(
						model,
						{
							aeJ: (value === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(value)
						}),
					$elm$core$Platform$Cmd$none,
					0);
			default:
				var value = msg.a;
				return A3(
					$author$project$Components$Marketplace$Product$CallToAction$result,
					_Utils_update(
						model,
						{
							ai4: (value === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(value)
						}),
					$elm$core$Platform$Cmd$none,
					0);
		}
	});
var $author$project$Pages$Marketplace$Slug_String$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 3:
				var prodMsg = msg.a;
				var _v1 = A2($author$project$Components$Marketplace$Product$update, prodMsg, model._s);
				var product = _v1.a;
				var productCmd = _v1.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{_s: product}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Marketplace$Slug_String$ProductMsg, productCmd),
					_List_Nil);
			case 4:
				var ctaMsg = msg.a;
				var fetchProductCmd = A3($author$project$Pages$Marketplace$Slug_String$fetchProduct, model.Gv, model.aa4, model.abG);
				var ctaResult = A3($author$project$Components$Marketplace$Product$CallToAction$update, model.Gv, ctaMsg, model.br);
				var eventOutMsgs = function () {
					var _v3 = ctaResult.agZ;
					switch (_v3) {
						case 1:
							return _List_fromArray(
								[$author$project$OutMsg$ReloadPartnerApps]);
						case 2:
							return _List_fromArray(
								[$author$project$OutMsg$ReloadPartnerApps]);
						case 3:
							return _List_fromArray(
								[$author$project$OutMsg$ReloadPartnerApps]);
						default:
							return _List_Nil;
					}
				}();
				var cmd = function () {
					var _v2 = ctaResult.agZ;
					switch (_v2) {
						case 0:
							return $elm$core$Platform$Cmd$none;
						case 1:
							return fetchProductCmd;
						case 2:
							return fetchProductCmd;
						case 3:
							return fetchProductCmd;
						case 4:
							return fetchProductCmd;
						default:
							return fetchProductCmd;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{br: ctaResult.aiO}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Marketplace$Slug_String$CallToActionMsg, ctaResult.GZ),
								cmd
							])),
					_Utils_ap(eventOutMsgs, ctaResult.aR));
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var practice = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								br: A2(
									$author$project$Components$Marketplace$Product$CallToAction$setPractice,
									{
										Bq: $author$project$Api$Provider$Practice$One$name(practice)
									},
									model.br)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var response = msg.a;
				_v5$2:
				while (true) {
					switch (response.$) {
						case 3:
							var marketplaceProduct = response.a;
							var productExpanded = $author$project$Pages$Marketplace$Slug_String$providerMarketplaceProductToProductExpanded(marketplaceProduct);
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										br: A2(
											$author$project$Components$Marketplace$Product$CallToAction$setProduct,
											$author$project$Pages$Marketplace$Slug_String$toCallToActionProduct(productExpanded),
											model.br),
										tD: $elm$core$Maybe$Just(
											$author$project$Api$Common$Marketplace$Product$One$partnerId(marketplaceProduct)),
										_s: A2($author$project$Components$Marketplace$Product$setProduct, productExpanded, model._s),
										pq: $elm$core$Maybe$Just(productExpanded)
									}),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
						case 2:
							if (response.a.$ === 5) {
								var _v6 = response.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{tl: true}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							} else {
								break _v5$2;
							}
						default:
							break _v5$2;
					}
				}
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			default:
				var response = msg.a;
				_v7$2:
				while (true) {
					switch (response.$) {
						case 3:
							var marketplaceProduct = response.a;
							var productExpanded = $author$project$Pages$Marketplace$Slug_String$partnerMarketplaceProductToProductExpanded(marketplaceProduct);
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										br: A2(
											$author$project$Components$Marketplace$Product$CallToAction$setProduct,
											$author$project$Pages$Marketplace$Slug_String$toCallToActionProduct(productExpanded),
											model.br),
										tD: $elm$core$Maybe$Just(
											$author$project$Api$Common$Marketplace$Product$One$partnerId(marketplaceProduct)),
										_s: A2($author$project$Components$Marketplace$Product$setProduct, productExpanded, model._s),
										pq: $elm$core$Maybe$Just(productExpanded)
									}),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
						case 2:
							if (response.a.$ === 5) {
								var _v8 = response.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{tl: true}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							} else {
								break _v7$2;
							}
						default:
							break _v7$2;
					}
				}
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
		}
	});
var $author$project$Components$Marketplace$Product$CallToAction$Activate = {$: 2};
var $author$project$Components$Marketplace$Product$CallToAction$ActivateProduct = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Marketplace$Product$CallToAction$DeactivateProduct = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Marketplace$Product$CallToAction$Disabled = 0;
var $author$project$Components$Marketplace$Product$CallToAction$ExpressInterest = {$: 1};
var $author$project$Components$Marketplace$Product$CallToAction$ExpressInterestClicked = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Marketplace$Product$CallToAction$RequestBeta = {$: 0};
var $author$project$Components$Marketplace$Product$CallToAction$RequestBetaAccess = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Marketplace$Product$CallToAction$RequestInstallClicked = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Marketplace$Product$CallToAction$activateVerb = function (product) {
	var _v0 = product.amg;
	switch (_v0) {
		case 0:
			return 'Install App';
		case 1:
			return 'Connect Integration';
		default:
			return '';
	}
};
var $author$project$Components$Marketplace$Product$CallToAction$NoAction = {$: 5};
var $author$project$Components$Marketplace$Product$CallToAction$ExternalCta = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Marketplace$Product$CallToAction$Deactivate = {$: 3};
var $author$project$Components$Marketplace$Product$CallToAction$ctaVariantFromEngagement = F2(
	function (product, variant) {
		if (product.MA) {
			return $author$project$Components$Marketplace$Product$CallToAction$Activate;
		} else {
			var _v0 = product.Rx;
			_v0$3:
			while (true) {
				if (!_v0.$) {
					switch (_v0.a.$) {
						case 2:
							var _v1 = _v0.a;
							return $author$project$Components$Marketplace$Product$CallToAction$Activate;
						case 3:
							var _v2 = _v0.a;
							return $author$project$Components$Marketplace$Product$CallToAction$Activate;
						case 4:
							var _v3 = _v0.a;
							return $author$project$Components$Marketplace$Product$CallToAction$Activate;
						default:
							break _v0$3;
					}
				} else {
					break _v0$3;
				}
			}
			return variant;
		}
	});
var $author$project$Components$Marketplace$Product$CallToAction$ctaVariantWhenNotActive = F2(
	function (product, variant) {
		var _v0 = product.alH;
		if (!_v0.$) {
			if (_v0.a === 'inactive') {
				return A2($author$project$Components$Marketplace$Product$CallToAction$ctaVariantFromEngagement, product, variant);
			} else {
				return $author$project$Components$Marketplace$Product$CallToAction$Deactivate;
			}
		} else {
			return A2($author$project$Components$Marketplace$Product$CallToAction$ctaVariantFromEngagement, product, variant);
		}
	});
var $author$project$Components$Marketplace$Product$CallToAction$ctaVariantForLive = function (product) {
	var _v0 = product.amg;
	if (_v0 === 2) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Components$Marketplace$Product$CallToAction$NoAction,
			A2($elm$core$Maybe$map, $author$project$Components$Marketplace$Product$CallToAction$ExternalCta, product.Op));
	} else {
		return A2($author$project$Components$Marketplace$Product$CallToAction$ctaVariantWhenNotActive, product, $author$project$Components$Marketplace$Product$CallToAction$Activate);
	}
};
var $author$project$Components$Marketplace$Product$CallToAction$ctaVariant = function (product) {
	var _v0 = product.V7;
	switch (_v0) {
		case 1:
			return $author$project$Components$Marketplace$Product$CallToAction$ctaVariantForLive(product);
		case 0:
			return $author$project$Components$Marketplace$Product$CallToAction$NoAction;
		case 5:
			return $author$project$Components$Marketplace$Product$CallToAction$ctaVariantForLive(product);
		case 4:
			return A2($author$project$Components$Marketplace$Product$CallToAction$ctaVariantWhenNotActive, product, $author$project$Components$Marketplace$Product$CallToAction$RequestBeta);
		case 3:
			return A2($author$project$Components$Marketplace$Product$CallToAction$ctaVariantWhenNotActive, product, $author$project$Components$Marketplace$Product$CallToAction$ExpressInterest);
		case 2:
			return A2($author$project$Components$Marketplace$Product$CallToAction$ctaVariantWhenNotActive, product, $author$project$Components$Marketplace$Product$CallToAction$ExpressInterest);
		default:
			return $author$project$Components$Marketplace$Product$CallToAction$NoAction;
	}
};
var $author$project$Components$Marketplace$Product$CallToAction$deactivateVerb = function (product) {
	var _v0 = product.amg;
	switch (_v0) {
		case 0:
			return 'Uninstall App';
		case 1:
			return 'Disconnect Integration';
		default:
			return '';
	}
};
var $author$project$Api$Common$Marketplace$Product$InstallMeta$enabled = function (_v0) {
	var record = _v0;
	return record.Ro;
};
var $author$project$Components$Marketplace$Product$CallToAction$isEngagementDisabled = F2(
	function (product, variant) {
		var _v0 = _Utils_Tuple2(variant, product.Rx);
		_v0$3:
		while (true) {
			if (!_v0.b.$) {
				switch (_v0.a.$) {
					case 0:
						if (!_v0.b.a.$) {
							var _v1 = _v0.a;
							var _v2 = _v0.b.a;
							return true;
						} else {
							break _v0$3;
						}
					case 1:
						if (_v0.b.a.$ === 1) {
							var _v3 = _v0.a;
							var _v4 = _v0.b.a;
							return true;
						} else {
							break _v0$3;
						}
					case 2:
						if (_v0.b.a.$ === 4) {
							var _v5 = _v0.a;
							var _v6 = _v0.b.a;
							return true;
						} else {
							break _v0$3;
						}
					default:
						break _v0$3;
				}
			} else {
				break _v0$3;
			}
		}
		return false;
	});
var $author$project$Api$Common$Marketplace$Product$InstallMeta$missingRequirements = function (_v0) {
	var record = _v0;
	return record.Xi;
};
var $author$project$Api$Common$Marketplace$Product$InstallMeta$reason = function (_v0) {
	var record = _v0;
	return record._7;
};
var $author$project$Components$Marketplace$Product$CallToAction$requestInstallHelpText = function (product) {
	var _v0 = product.amg;
	switch (_v0) {
		case 0:
			return 'Send an install request to your admins.';
		case 1:
			return 'Send a connection request to your admins.';
		default:
			return '';
	}
};
var $author$project$Components$Marketplace$Product$CallToAction$requestInstallVerb = function (product) {
	var _v0 = product.amg;
	switch (_v0) {
		case 0:
			return 'Request Install';
		case 1:
			return 'Request Connection';
		default:
			return '';
	}
};
var $author$project$Components$Marketplace$Product$CallToAction$requestedVerb = function (product) {
	var _v0 = product.amg;
	switch (_v0) {
		case 0:
			return 'Install Requested';
		case 1:
			return 'Connection Requested';
		default:
			return '';
	}
};
var $author$project$Components$Marketplace$Product$CallToAction$withMarketplaceUtmParams = function (url) {
	return A2(
		$author$project$Utils$Url$addParams,
		url,
		_List_fromArray(
			[
				A2($elm$url$Url$Builder$string, 'utm_source', 'hint'),
				A2($elm$url$Url$Builder$string, 'utm_medium', 'marketplace'),
				A2($elm$url$Url$Builder$string, 'utm_campaign', 'hint_marketplace')
			]));
};
var $author$project$Components$Marketplace$Product$CallToAction$viewMissingRequirement = function (requirement) {
	if ((!requirement.$) && (!requirement.a.$)) {
		var _v1 = requirement.a;
		return $elm$core$Maybe$Just(
			A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$externalHref,
						$author$project$Components$Marketplace$Product$CallToAction$withMarketplaceUtmParams('https://www.hint.com/clinical-upgrade'),
						_List_fromArray(
							[$author$project$Ui$Link$fullWidth, $author$project$Ui$Link$buttonPrimary, $author$project$Ui$Link$fullWidth, $author$project$Ui$Link$targetBlank]),
						_List_fromArray(
							[
								$elm$html$Html$text('Get a Demo')
							]))
					])));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Marketplace$Product$CallToAction$button = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			model.al6,
			function () {
				var _v0 = model._s;
				if (!_v0.$) {
					var product = _v0.a;
					var isDisabled = A2($elm$core$List$member, 0, options) || (product.V7 === 1);
					var commonButtonOptions = _List_fromArray(
						[
							$author$project$Ui$Button$primary,
							$author$project$Ui$Button$loading(model.V8),
							$author$project$Ui$Button$fullWidth(true)
						]);
					var _v1 = $author$project$Components$Marketplace$Product$CallToAction$ctaVariant(product);
					switch (_v1.$) {
						case 0:
							var isButtonDisabled = isDisabled || (model.V8 || A2($author$project$Components$Marketplace$Product$CallToAction$isEngagementDisabled, product, $author$project$Components$Marketplace$Product$CallToAction$RequestBeta));
							return A3(
								$author$project$Ui$Button$view,
								{mm: 'Request beta access'},
								A2(
									$elm$core$List$cons,
									$author$project$Ui$Button$onClick(
										$author$project$Components$Marketplace$Product$CallToAction$RequestBetaAccess(product)),
									A2(
										$elm$core$List$cons,
										$author$project$Ui$Button$disabled(isButtonDisabled),
										commonButtonOptions)),
								_List_fromArray(
									[
										$elm$html$Html$text(
										_Utils_eq(
											product.Rx,
											$author$project$Api$Common$Marketplace$Product$Engagement$Status$Engaged($author$project$Api$Common$Marketplace$Product$Engagement$Status$Waitlisted)) ? 'On Waitlist' : 'Request beta access')
									]));
						case 1:
							var isButtonDisabled = isDisabled || (model.V8 || A2($author$project$Components$Marketplace$Product$CallToAction$isEngagementDisabled, product, $author$project$Components$Marketplace$Product$CallToAction$ExpressInterest));
							return A3(
								$author$project$Ui$Button$view,
								{mm: 'Express interest'},
								A2(
									$elm$core$List$cons,
									$author$project$Ui$Button$onClick(
										$author$project$Components$Marketplace$Product$CallToAction$ExpressInterestClicked(product)),
									A2(
										$elm$core$List$cons,
										$author$project$Ui$Button$disabled(isButtonDisabled),
										commonButtonOptions)),
								_List_fromArray(
									[
										$elm$html$Html$text(
										_Utils_eq(
											product.Rx,
											$author$project$Api$Common$Marketplace$Product$Engagement$Status$Engaged($author$project$Api$Common$Marketplace$Product$Engagement$Status$Interested)) ? 'Interest expressed' : 'Express interest')
									]));
						case 2:
							if (model.Uy) {
								var installMeta = product.T4;
								var missingReqs = A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2($elm$core$Maybe$map, $author$project$Api$Common$Marketplace$Product$InstallMeta$missingRequirements, installMeta));
								var reasonText = A2($elm$core$Maybe$andThen, $author$project$Api$Common$Marketplace$Product$InstallMeta$reason, installMeta);
								var installEnabled = A2(
									$elm$core$Maybe$withDefault,
									true,
									A2($elm$core$Maybe$map, $author$project$Api$Common$Marketplace$Product$InstallMeta$enabled, installMeta));
								return A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$gap2, $author$project$Ui$Element$flexCol]),
									A2(
										$elm$core$List$cons,
										A2(
											$author$project$Ui$Element$view,
											_List_Nil,
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Button$view,
													{
														mm: $author$project$Components$Marketplace$Product$CallToAction$activateVerb(product)
													},
													A2(
														$elm$core$List$cons,
														$author$project$Ui$Button$onClick(
															$author$project$Components$Marketplace$Product$CallToAction$ActivateProduct(product)),
														A2(
															$elm$core$List$cons,
															$author$project$Ui$Button$disabled(isDisabled || (!installEnabled)),
															commonButtonOptions)),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Components$Marketplace$Product$CallToAction$activateVerb(product))
														])),
													function () {
													if (!reasonText.$) {
														var reason = reasonText.a;
														return A2(
															$author$project$Ui$Element$view,
															_List_fromArray(
																[$author$project$Ui$Element$textCenter, $author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
															_List_fromArray(
																[
																	$elm$html$Html$text(reason)
																]));
													} else {
														return $elm$html$Html$text('');
													}
												}()
												])),
										A2($elm$core$List$filterMap, $author$project$Components$Marketplace$Product$CallToAction$viewMissingRequirement, missingReqs)));
							} else {
								var alreadyRequested = A2($author$project$Components$Marketplace$Product$CallToAction$isEngagementDisabled, product, $author$project$Components$Marketplace$Product$CallToAction$Activate);
								var requestLabel = alreadyRequested ? $author$project$Components$Marketplace$Product$CallToAction$requestedVerb(product) : $author$project$Components$Marketplace$Product$CallToAction$requestInstallVerb(product);
								return A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$gap2, $author$project$Ui$Element$flexCol]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{mm: requestLabel},
											A2(
												$elm$core$List$cons,
												$author$project$Ui$Button$onClick(
													$author$project$Components$Marketplace$Product$CallToAction$RequestInstallClicked(product)),
												A2(
													$elm$core$List$cons,
													$author$project$Ui$Button$disabled(isDisabled || (alreadyRequested || model.V8)),
													commonButtonOptions)),
											_List_fromArray(
												[
													$elm$html$Html$text(requestLabel)
												])),
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$textCenter, $author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Components$Marketplace$Product$CallToAction$requestInstallHelpText(product))
												]))
										]));
							}
						case 3:
							return model.Uy ? A3(
								$author$project$Ui$Button$view,
								{
									mm: $author$project$Components$Marketplace$Product$CallToAction$deactivateVerb(product)
								},
								_List_fromArray(
									[
										$author$project$Ui$Button$danger,
										$author$project$Ui$Button$fullWidth(true),
										$author$project$Ui$Button$loading(model.V8),
										$author$project$Ui$Button$disabled(isDisabled),
										$author$project$Ui$Button$onClick(
										$author$project$Components$Marketplace$Product$CallToAction$DeactivateProduct(product))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Components$Marketplace$Product$CallToAction$deactivateVerb(product))
									])) : A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$gap2, $author$project$Ui$Element$flexCol]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{
											mm: $author$project$Components$Marketplace$Product$CallToAction$deactivateVerb(product)
										},
										_List_fromArray(
											[
												$author$project$Ui$Button$danger,
												$author$project$Ui$Button$fullWidth(true),
												$author$project$Ui$Button$disabled(true)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Components$Marketplace$Product$CallToAction$deactivateVerb(product))
											])),
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$textCenter, $author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
										_List_fromArray(
											[
												$elm$html$Html$text('Only admins can manage this app.')
											]))
									]));
						case 4:
							var url = _v1.a;
							return isDisabled ? A3(
								$author$project$Ui$Button$view,
								{mm: 'Contact Partner'},
								A2(
									$elm$core$List$cons,
									$author$project$Ui$Button$disabled(true),
									commonButtonOptions),
								_List_fromArray(
									[
										$elm$html$Html$text('Contact Partner')
									])) : A3(
								$author$project$Ui$Link$externalHref,
								A2(
									$author$project$Utils$Url$addParams,
									url,
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'utm_source', 'hint'),
											A2($elm$url$Url$Builder$string, 'utm_medium', 'marketplace'),
											A2($elm$url$Url$Builder$string, 'utm_campaign', 'hint_marketplace')
										])),
								_List_fromArray(
									[$author$project$Ui$Link$fullWidth, $author$project$Ui$Link$buttonPrimary, $author$project$Ui$Link$targetBlank]),
								_List_fromArray(
									[
										$elm$html$Html$text('Contact Partner')
									]));
						default:
							return $elm$html$Html$text('');
					}
				} else {
					return $elm$html$Html$text('');
				}
			}());
	});
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $author$project$Ui$Typography$headingXl = function (content) {
	return A2(
		$elm$html$Html$map,
		$elm$core$Basics$never,
		A2(
			$elm$html$Html$h1,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-heading-xl text-main')
				]),
			content));
};
var $author$project$Components$Marketplace$Product$CallToAction$ActivateConfirmed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Marketplace$Product$CallToAction$activateDescription = function (product) {
	var _v0 = product.amg;
	switch (_v0) {
		case 0:
			return 'Install this app to your Hint account to securely share data and use it directly within your workflow in Hint. You can manage or remove access at any time.';
		case 1:
			return 'Connect this integration to your Hint account to securely share data between systems. You can disconnect at any time.';
		default:
			return '';
	}
};
var $author$project$Components$Marketplace$Product$CallToAction$AdminRoleMappingChanged = function (a) {
	return {$: 25, a: a};
};
var $author$project$Components$Marketplace$Product$CallToAction$AutoGrantChanged = function (a) {
	return {$: 24, a: a};
};
var $author$project$Components$Marketplace$Product$CallToAction$NonAdminRoleMappingChanged = function (a) {
	return {$: 26, a: a};
};
var $author$project$Components$Marketplace$Product$CallToAction$hasPartnerRoles = function (product) {
	return !$elm$core$List$isEmpty(product.I3);
};
var $author$project$Ui$Icon$Circle = 48;
var $author$project$Ui$Icon$circle = $author$project$Ui$Icon$viewIcon(48);
var $author$project$Ui$Icon$Xl = 4;
var $author$project$Ui$Icon$xl = $author$project$Ui$Icon$Size(4);
var $author$project$Components$Marketplace$Product$CallToAction$modalStepIcon = function (complete) {
	return complete ? $author$project$Ui$Icon$check(
		_List_fromArray(
			[$author$project$Ui$Icon$circled, $author$project$Ui$Icon$success])) : $author$project$Ui$Icon$circle(
		_List_fromArray(
			[$author$project$Ui$Icon$info, $author$project$Ui$Icon$xl]));
};
var $author$project$Api$Common$PartnerApp$PartnerRole$description = function (_v0) {
	var record = _v0;
	return record.Qr;
};
var $author$project$Api$Common$PartnerApp$PartnerRole$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Components$Admin$PartnerApp$RoleSelect$roleLabel = F2(
	function (roleName, description) {
		var label = $author$project$Formatters$String$titleize(
			$author$project$Formatters$String$humanize(roleName));
		var descText = A2($elm$core$Maybe$withDefault, '', description);
		return $elm$core$String$isEmpty(descText) ? label : (label + (' (' + (descText + ')')));
	});
var $author$project$Components$Admin$PartnerApp$RoleSelect$view = function (config) {
	var roleItems = A2(
		$elm$core$List$map,
		function (role) {
			var roleName = $author$project$Api$Common$PartnerApp$PartnerRole$name(role);
			return A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(roleName),
				A2(
					$author$project$Components$Admin$PartnerApp$RoleSelect$roleLabel,
					roleName,
					$author$project$Api$Common$PartnerApp$PartnerRole$description(role)));
		},
		config.ak4);
	var items = A2(
		$elm$core$List$cons,
		A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, config.agN),
		roleItems);
	return A2(
		$author$project$Ui$Form$Select$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Select$value(config.aee),
				$author$project$Ui$Form$Select$onChange(config.ajd)
			]),
		items);
};
var $author$project$Components$Marketplace$Product$CallToAction$viewAccessSettings = F5(
	function (expandedStep, autoGrant, adminRole, nonAdminRole, product) {
		return A2(
			$author$project$Ui$Panel$view,
			_List_fromArray(
				[
					$author$project$Ui$Panel$collapsed(
					!_Utils_eq(
						expandedStep,
						$elm$core$Maybe$Just(3)))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_fromArray(
						[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap4]),
					_List_fromArray(
						[
							$author$project$Components$Marketplace$Product$CallToAction$modalStepIcon(true),
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Access Settings')
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap4]),
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$labelSpan(6),
											$author$project$Ui$Form$Group$inputSpan(6),
											$author$project$Ui$Form$Group$label('Automatically grant access to new team members')
										]),
									_List_fromArray(
										[
											$author$project$Ui$ToggleSwitch$view(
											_List_fromArray(
												[
													$author$project$Ui$ToggleSwitch$on(autoGrant),
													$author$project$Ui$ToggleSwitch$onChange($author$project$Components$Marketplace$Product$CallToAction$AutoGrantChanged)
												]))
										])),
								function () {
									if (autoGrant && $author$project$Components$Marketplace$Product$CallToAction$hasPartnerRoles(product)) {
										var roles = product.I3;
										return _List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Group$view,
												_List_fromArray(
													[
														$author$project$Ui$Form$Group$labelSpan(6),
														$author$project$Ui$Form$Group$inputSpan(6),
														$author$project$Ui$Form$Group$label('Default role for practice admins')
													]),
												_List_fromArray(
													[
														$author$project$Components$Admin$PartnerApp$RoleSelect$view(
														{agN: 'No access', ajd: $author$project$Components$Marketplace$Product$CallToAction$AdminRoleMappingChanged, ak4: roles, aee: adminRole})
													])),
												A2(
												$author$project$Ui$Form$Group$view,
												_List_fromArray(
													[
														$author$project$Ui$Form$Group$labelSpan(6),
														$author$project$Ui$Form$Group$inputSpan(6),
														$author$project$Ui$Form$Group$label('Default role for non-admin users')
													]),
												_List_fromArray(
													[
														$author$project$Components$Admin$PartnerApp$RoleSelect$view(
														{agN: 'No access', ajd: $author$project$Components$Marketplace$Product$CallToAction$NonAdminRoleMappingChanged, ak4: roles, aee: nonAdminRole})
													]))
											]);
									} else {
										return _List_Nil;
									}
								}()))
						]))
				]));
	});
var $author$project$Components$Marketplace$Product$CallToAction$OpenPdfDocument = function (a) {
	return {$: 21, a: a};
};
var $author$project$Components$Marketplace$Product$CallToAction$ToggleDocumentAccepted = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$Marketplace$Product$CallToAction$viewDocumentCheckbox = F2(
	function (acceptedIds, document) {
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Checkbox$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Checkbox$value(
							A2($elm$core$Set$member, document.ahP, acceptedIds)),
							$author$project$Ui$Form$Checkbox$onCheck(
							$author$project$Components$Marketplace$Product$CallToAction$ToggleDocumentAccepted(document.ahP))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('I have read and agree to')
						])),
					function () {
					var _v0 = _Utils_Tuple2(document.QU, document.adY);
					_v0$2:
					while (true) {
						switch (_v0.a) {
							case 'url':
								if (!_v0.b.$) {
									var url = _v0.b.a;
									return A3(
										$author$project$Ui$Link$externalHref,
										url,
										_List_fromArray(
											[$author$project$Ui$Link$targetBlank]),
										_List_fromArray(
											[
												$elm$html$Html$text(document.ac9)
											]));
								} else {
									break _v0$2;
								}
							case 'pdf':
								return A3(
									$author$project$Ui$Button$view,
									{mm: 'Open ' + document.ac9},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick(
											$author$project$Components$Marketplace$Product$CallToAction$OpenPdfDocument(document))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(document.ac9)
										]));
							default:
								break _v0$2;
						}
					}
					return $elm$html$Html$text(document.ac9);
				}()
				]));
	});
var $author$project$Components$Marketplace$Product$CallToAction$viewDocumentAgreements = F5(
	function (expandedStep, practice, productName, acceptedIds, documents) {
		if ($elm$core$List$isEmpty(documents)) {
			return $elm$html$Html$text('');
		} else {
			var practiceName = A2(
				$elm$core$Maybe$withDefault,
				'<practice name>',
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.Bq;
					},
					practice));
			var allAccepted = A2(
				$elm$core$List$all,
				function (doc) {
					return A2($elm$core$Set$member, doc.ahP, acceptedIds);
				},
				documents);
			return A2(
				$author$project$Ui$Panel$view,
				_List_fromArray(
					[
						$author$project$Ui$Panel$collapsed(
						!_Utils_eq(
							expandedStep,
							$elm$core$Maybe$Just(1)))
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_fromArray(
							[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap4]),
						_List_fromArray(
							[
								$author$project$Components$Marketplace$Product$CallToAction$modalStepIcon(allAccepted),
								A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Agreements')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap4]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('By checking the boxes below, you:'),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('pl-6')
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Element$view,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('i. confirm that you have read and agree to the documents listed below;')
															])),
														A2(
														$author$project$Ui$Element$view,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('ii. represent and warrant that you are an authorized representative of '),
																A2(
																$author$project$Ui$Typography$span,
																_List_fromArray(
																	[$author$project$Ui$Typography$bold]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(practiceName)
																	])),
																$elm$html$Html$text(' with full authority to legally bind the entity to this Agreement; and')
															])),
														A2(
														$author$project$Ui$Element$view,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('iii. agree that this electronic acceptance constitutes a legally binding agreement between '),
																A2(
																$author$project$Ui$Typography$span,
																_List_fromArray(
																	[$author$project$Ui$Typography$bold]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(productName)
																	])),
																$elm$html$Html$text(' and '),
																A2(
																$author$project$Ui$Typography$span,
																_List_fromArray(
																	[$author$project$Ui$Typography$bold]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(practiceName)
																	])),
																$elm$html$Html$text(', effective as of the date of acceptance.')
															]))
													]))
											])),
										A2(
										$author$project$Ui$Element$view,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('You further agree that your electronic acceptance on behalf of '),
												A2(
												$author$project$Ui$Typography$span,
												_List_fromArray(
													[$author$project$Ui$Typography$bold]),
												_List_fromArray(
													[
														$elm$html$Html$text(practiceName)
													])),
												$elm$html$Html$text(' has the same legal effect as a handwritten signature and satisfies any requirement that the Agreement be in writing.')
											])),
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap2]),
										A2(
											$elm$core$List$map,
											$author$project$Components$Marketplace$Product$CallToAction$viewDocumentCheckbox(acceptedIds),
											documents))
									]))
							]))
					]));
		}
	});
var $author$project$Components$Marketplace$Product$Precondition$Editable = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Marketplace$Product$CallToAction$ScheduleOnboardingCall = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Components$Marketplace$Product$CallToAction$TogglePreconditionAccepted = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Api$Common$Marketplace$Product$Precondition$type_ = function (_v0) {
	var record = _v0;
	return record.amg;
};
var $author$project$Api$Common$Marketplace$Product$Precondition$url = function (_v0) {
	var record = _v0;
	return record.adY;
};
var $author$project$Api$Common$Marketplace$Product$Precondition$Type$labels = function (t) {
	switch (t) {
		case 0:
			return {xe: ' before connecting.', xz: 'This app requires ', x1: 'Package Installed', AE: 'installing a package', ac9: 'Install package'};
		case 1:
			return {xe: ' before connecting.', xz: 'You\'ll need an ', x1: 'Account Created', AE: 'account with this partner', ac9: 'Create an account'};
		default:
			return {xe: ' before connecting.', xz: 'You\'ll need to ', x1: 'Onboarding Call Scheduled', AE: 'book an onboarding call', ac9: 'Schedule your onboarding call'};
	}
};
var $author$project$Components$Marketplace$Product$Precondition$linkCheckboxBody = F3(
	function (l, url, mode) {
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap2]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(l.xz),
							A3(
							$author$project$Ui$Link$externalHref,
							url,
							_List_fromArray(
								[$author$project$Ui$Link$targetBlank]),
							_List_fromArray(
								[
									$elm$html$Html$text(l.AE)
								])),
							$elm$html$Html$text(l.xe)
						])),
					function () {
					if (!mode.$) {
						var accepted = mode.a.Kz;
						var onCheck = mode.a.aje;
						return A2(
							$author$project$Ui$Form$Checkbox$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Checkbox$value(accepted),
									$author$project$Ui$Form$Checkbox$onCheck(onCheck)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(l.x1)
								]));
					} else {
						return A2(
							$author$project$Ui$Form$Checkbox$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Checkbox$disabled(true)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textMuted]),
									_List_fromArray(
										[
											$elm$html$Html$text(l.x1)
										]))
								]));
					}
				}()
				]));
	});
var $author$project$Components$Marketplace$Product$Precondition$onScheduleFrom = function (mode) {
	if (!mode.$) {
		var onSchedule = mode.a.ajt;
		return onSchedule;
	} else {
		var onSchedule = mode.a.ajt;
		return onSchedule;
	}
};
var $author$project$Components$Marketplace$Product$Precondition$onboardingCallBody = function (onSchedule) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap2]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('On your onboarding call, we will walk you through the configuration of your new account and answer any questions you may have.')
					])),
				A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Schedule onboarding call'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$onClick(onSchedule)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Schedule')
							]))
					]))
			]));
};
var $author$project$Components$Marketplace$Product$Precondition$view = function (_v0) {
	var type_ = _v0.amg;
	var url = _v0.adY;
	var mode = _v0.aiN;
	var l = $author$project$Api$Common$Marketplace$Product$Precondition$Type$labels(type_);
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap2]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$title,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(l.ac9)
					])),
				function () {
				if (type_ === 2) {
					return $author$project$Components$Marketplace$Product$Precondition$onboardingCallBody(
						$author$project$Components$Marketplace$Product$Precondition$onScheduleFrom(mode));
				} else {
					return A3($author$project$Components$Marketplace$Product$Precondition$linkCheckboxBody, l, url, mode);
				}
			}()
			]));
};
var $author$project$Components$Marketplace$Product$CallToAction$viewPrecondition = F2(
	function (acceptedIds, precondition) {
		var url = $author$project$Api$Common$Marketplace$Product$Precondition$url(precondition);
		var id = $author$project$Api$Common$Marketplace$Product$Precondition$id(precondition);
		return $author$project$Components$Marketplace$Product$Precondition$view(
			{
				aiN: $author$project$Components$Marketplace$Product$Precondition$Editable(
					{
						Kz: A2($elm$core$Set$member, id, acceptedIds),
						aje: $author$project$Components$Marketplace$Product$CallToAction$TogglePreconditionAccepted(id),
						ajt: A2($author$project$Components$Marketplace$Product$CallToAction$ScheduleOnboardingCall, id, url)
					}),
				amg: $author$project$Api$Common$Marketplace$Product$Precondition$type_(precondition),
				adY: url
			});
	});
var $author$project$Components$Marketplace$Product$CallToAction$viewPreconditions = F3(
	function (expandedStep, acceptedIds, preconditions_) {
		if ($elm$core$List$isEmpty(preconditions_)) {
			return $elm$html$Html$text('');
		} else {
			var allAccepted = A2(
				$elm$core$List$all,
				function (p) {
					return A2(
						$elm$core$Set$member,
						$author$project$Api$Common$Marketplace$Product$Precondition$id(p),
						acceptedIds);
				},
				preconditions_);
			return A2(
				$author$project$Ui$Panel$view,
				_List_fromArray(
					[
						$author$project$Ui$Panel$collapsed(
						!_Utils_eq(
							expandedStep,
							$elm$core$Maybe$Just(0)))
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_fromArray(
							[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap4]),
						_List_fromArray(
							[
								$author$project$Components$Marketplace$Product$CallToAction$modalStepIcon(allAccepted),
								A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Requirements')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap4]),
								A2(
									$elm$core$List$map,
									$author$project$Components$Marketplace$Product$CallToAction$viewPrecondition(acceptedIds),
									preconditions_))
							]))
					]));
		}
	});
var $author$project$Components$Marketplace$Product$CallToAction$TogglePricingBillingAccepted = function (a) {
	return {$: 23, a: a};
};
var $author$project$Ui$Element$PreWrap = {$: 19};
var $author$project$Ui$Element$preWrap = $author$project$Ui$Element$PreWrap;
var $author$project$Utils$Html$ulFromString = function (string) {
	return function (_v2) {
		var acc = _v2.a;
		var ils = _v2.b;
		if (!ils.b) {
			return acc;
		} else {
			var items = ils;
			return _Utils_ap(
				acc,
				_List_fromArray(
					[
						A2($elm$html$Html$ul, _List_Nil, items)
					]));
		}
	}(
		A3(
			$elm$core$List$foldl,
			F2(
				function (line, _v0) {
					var acc = _v0.a;
					var ils = _v0.b;
					if (A2($elm$core$String$startsWith, '- ', line) || A2($elm$core$String$startsWith, '* ', line)) {
						return _Utils_Tuple2(
							acc,
							_Utils_ap(
								ils,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2($elm$core$String$dropLeft, 2, line))
											]))
									])));
					} else {
						if (!ils.b) {
							return _Utils_Tuple2(
								_Utils_ap(
									acc,
									_List_fromArray(
										[
											$elm$html$Html$text(line),
											A2($elm$html$Html$br, _List_Nil, _List_Nil)
										])),
								_List_Nil);
						} else {
							return _Utils_Tuple2(
								_Utils_ap(
									acc,
									_List_fromArray(
										[
											A2($elm$html$Html$ul, _List_Nil, ils),
											$elm$html$Html$text(line),
											A2($elm$html$Html$br, _List_Nil, _List_Nil)
										])),
								_List_Nil);
						}
					}
				}),
			_Utils_Tuple2(_List_Nil, _List_Nil),
			$elm$core$String$lines(string)));
};
var $author$project$Components$Marketplace$Product$CallToAction$viewPricingBilling = F3(
	function (expandedStep, accepted, product) {
		var _v0 = product._i;
		if (!_v0.$) {
			var description = _v0.a;
			return A2(
				$author$project$Ui$Panel$view,
				_List_fromArray(
					[
						$author$project$Ui$Panel$collapsed(
						!_Utils_eq(
							expandedStep,
							$elm$core$Maybe$Just(2)))
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_fromArray(
							[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap4]),
						_List_fromArray(
							[
								$author$project$Components$Marketplace$Product$CallToAction$modalStepIcon(accepted),
								A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Pricing')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap4]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$elm$core$Basics$never,
										A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$preWrap]),
											$author$project$Utils$Html$ulFromString(description))),
										A2(
										$author$project$Ui$Element$view,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('You\'ll receive a separate monthly invoice from this partner using your existing payment method and autopay settings. You may see multiple charges on your billing date, one for each partner.')
											])),
										A2(
										$author$project$Ui$Form$Checkbox$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Checkbox$value(accepted),
												$author$project$Ui$Form$Checkbox$onCheck($author$project$Components$Marketplace$Product$CallToAction$TogglePricingBillingAccepted)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('I agree to be billed monthly based on the pricing above.')
											]))
									]))
							]))
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Components$Marketplace$Product$CallToAction$viewActivateModal = function (model) {
	var _v0 = model.K;
	if (!_v0.$) {
		var _v1 = _v0.a;
		var product = _v1.a;
		var request = _v1.b;
		var verb = $author$project$Components$Marketplace$Product$CallToAction$activateVerb(product);
		var isLoading = _Utils_eq(request, $author$project$Api$Data$Loading);
		var errorMessage = function () {
			if (request.$ === 2) {
				var error = request.a;
				return $elm$core$Maybe$Just(
					$author$project$Ui$Toast$serverError(error));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var documents = product.YS;
		var allPreconditionsAccepted = A2(
			$elm$core$List$all,
			function (p) {
				return A2(
					$elm$core$Set$member,
					$author$project$Api$Common$Marketplace$Product$Precondition$id(p),
					model.cW);
			},
			product.Z7);
		var allDocumentsAccepted = A2(
			$elm$core$List$all,
			function (doc) {
				return A2($elm$core$Set$member, doc.ahP, model.dS);
			},
			documents);
		var installDisabled = isLoading || (((!$elm$core$List$isEmpty(documents)) && (!allDocumentsAccepted)) || ((!allPreconditionsAccepted) || ((!_Utils_eq(product._i, $elm$core$Maybe$Nothing)) && (!model.ib))));
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$Marketplace$Product$CallToAction$ActivateCanceled,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title(verb)
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							function () {
							if (!errorMessage.$) {
								var message = errorMessage.a;
								return A2(
									$author$project$Ui$Alert$danger,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(message)
										]));
							} else {
								return $elm$html$Html$text('');
							}
						}(),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$mb4]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Components$Marketplace$Product$CallToAction$activateDescription(product))
								])),
							A5($author$project$Components$Marketplace$Product$CallToAction$viewDocumentAgreements, model.au, model.ZV, product.Bq, model.dS, documents),
							A3($author$project$Components$Marketplace$Product$CallToAction$viewPreconditions, model.au, model.cW, product.Z7),
							A3($author$project$Components$Marketplace$Product$CallToAction$viewPricingBilling, model.au, model.ib, product),
							A5($author$project$Components$Marketplace$Product$CallToAction$viewAccessSettings, model.au, model.ae2, model.aeJ, model.ai4, product)
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Cancel'},
							_List_fromArray(
								[
									$author$project$Ui$Button$default,
									$author$project$Ui$Button$onClick($author$project$Components$Marketplace$Product$CallToAction$ActivateCanceled)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{mm: verb},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$onClick(
									$author$project$Components$Marketplace$Product$CallToAction$ActivateConfirmed(product)),
									$author$project$Ui$Button$disabled(installDisabled),
									$author$project$Ui$Button$loading(isLoading)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(verb)
								]))
						]))
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Components$Marketplace$Product$CallToAction$DeactivateConfirmed = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Marketplace$Product$CallToAction$viewDeactivateModal = function (model) {
	var _v0 = model.d5;
	if (!_v0.$) {
		var _v1 = _v0.a;
		var product = _v1.a;
		var request = _v1.b;
		var verb = $author$project$Components$Marketplace$Product$CallToAction$deactivateVerb(product);
		var errorMessage = function () {
			if (request.$ === 2) {
				var error = request.a;
				return $elm$core$Maybe$Just(
					$author$project$Ui$Toast$serverError(error));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$Marketplace$Product$CallToAction$DeactivateCanceled,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title(verb + (' ' + (product.Bq + '?')))
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							function () {
							if (!errorMessage.$) {
								var message = errorMessage.a;
								return A2(
									$author$project$Ui$Alert$danger,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(message)
										]));
							} else {
								return $elm$html$Html$text('');
							}
						}(),
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									'Are you sure you want to ' + ($elm$core$String$toLower(verb) + ' ')),
									$elm$html$Html$text(product.Bq),
									$elm$html$Html$text('? This will remove the integration and all its settings.')
								]))
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Cancel'},
							_List_fromArray(
								[
									$author$project$Ui$Button$default,
									$author$project$Ui$Button$onClick($author$project$Components$Marketplace$Product$CallToAction$DeactivateCanceled)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{mm: verb},
							_List_fromArray(
								[
									$author$project$Ui$Button$danger,
									$author$project$Ui$Button$onClick(
									$author$project$Components$Marketplace$Product$CallToAction$DeactivateConfirmed(product)),
									$author$project$Ui$Button$disabled(
									_Utils_eq(request, $author$project$Api$Data$Loading)),
									$author$project$Ui$Button$loading(
									_Utils_eq(request, $author$project$Api$Data$Loading))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(verb)
								]))
						]))
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Components$Marketplace$Product$CallToAction$modal = function (model) {
	return A2(
		$elm$html$Html$map,
		model.al6,
		A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Components$Marketplace$Product$CallToAction$viewActivateModal(model),
					$author$project$Components$Marketplace$Product$CallToAction$viewDeactivateModal(model)
				])));
};
var $author$project$Pages$Marketplace$Slug_String$settingsUrl = function (product) {
	return A2(
		$elm$core$Maybe$andThen,
		function (status) {
			switch (status) {
				case 'inactive':
					return $elm$core$Maybe$Nothing;
				case 'pending':
					var _v1 = product.abG;
					switch (_v1) {
						case 'quickbooks':
							return $elm$core$Maybe$Just(
								$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Marketplace__Quickbooks__Manage__Settings));
						case 'elation':
							return $elm$core$Maybe$Just(
								$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Marketplace__Elation__Manage__Settings));
						case 'athenahealth':
							return $elm$core$Maybe$Just(
								$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Marketplace__Athenahealth__Manage__Settings));
						default:
							return $elm$core$Maybe$Just(
								$author$project$Spa$Generated$Route$toString(
									$author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Onboarding(
										{abG: product.abG})));
					}
				default:
					var _v2 = _Utils_Tuple2(product.amg, product.abG);
					_v2$0:
					while (true) {
						switch (_v2.b) {
							case 'bookkeeping':
								if (!_v2.a) {
									break _v2$0;
								} else {
									return $elm$core$Maybe$Just(
										$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Marketplace__Bookkeeping__Manage__Settings));
								}
							case 'quickbooks':
								if (!_v2.a) {
									break _v2$0;
								} else {
									return $elm$core$Maybe$Just(
										$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Marketplace__Quickbooks__Manage__Settings));
								}
							case 'elation':
								if (!_v2.a) {
									break _v2$0;
								} else {
									return $elm$core$Maybe$Just(
										$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Marketplace__Elation__Manage__Settings));
								}
							case 'athenahealth':
								if (!_v2.a) {
									break _v2$0;
								} else {
									return $elm$core$Maybe$Just(
										$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Marketplace__Athenahealth__Manage__Settings));
								}
							default:
								if (!_v2.a) {
									break _v2$0;
								} else {
									return $elm$core$Maybe$Nothing;
								}
						}
					}
					var _v3 = _v2.a;
					return $elm$core$Maybe$Just(
						$author$project$Spa$Generated$Route$toString(
							$author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Users(
								{abG: product.abG})));
			}
		},
		product.alH);
};
var $author$project$Pages$Marketplace$Slug_String$viewManageButton = function (model) {
	var _v0 = A2($elm$core$Maybe$andThen, $author$project$Pages$Marketplace$Slug_String$settingsUrl, model.pq);
	if (!_v0.$) {
		var url = _v0.a;
		return A3(
			$author$project$Ui$Link$externalHref,
			url,
			_List_fromArray(
				[$author$project$Ui$Link$fullWidth, $author$project$Ui$Link$buttonPrimary]),
			_List_fromArray(
				[
					$elm$html$Html$text('Manage')
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Marketplace$Slug_String$view = function (model) {
	var title = A2(
		$elm$core$Maybe$withDefault,
		model.abG,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.Bq;
			},
			model.pq));
	return {
		fO: _List_fromArray(
			[
				A3(
				$author$project$Ui$Element$custom,
				'marketplace-container',
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mb4, $author$project$Ui$Element$spaceBetween]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Marketplace__Top,
								_List_fromArray(
									[
										$author$project$Ui$Link$icon($author$project$Ui$Icon$arrowLeft)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Back to Marketplace')
									])),
								function () {
								var _v0 = _Utils_Tuple2(model.Ij, model.tD);
								if (_v0.a && (!_v0.b.$)) {
									var partnerId = _v0.b.a;
									return A3(
										$author$project$Ui$HinterOnly$linkRoute,
										$author$project$Spa$Generated$Route$Partner__Dashboard__Top,
										_List_fromArray(
											[
												$author$project$Ui$Link$buttonDefault,
												$author$project$Ui$Link$routeParams(
												_List_fromArray(
													[
														A2($elm$url$Url$Builder$string, 'switch-to-partner', partnerId)
													])),
												$author$project$Ui$Link$targetBlank
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Edit')
											]));
								} else {
									return $author$project$Utils$Html$empty;
								}
							}()
							])),
						$author$project$Components$Marketplace$Product$CallToAction$modal(model.br),
						model.tl ? A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$textCenter, $author$project$Ui$Element$mt2, $author$project$Ui$Element$mb4]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$elm$core$Basics$never,
								$author$project$Ui$Typography$headingXl(
									_List_fromArray(
										[
											$elm$html$Html$text('Product not found.')
										])))
							])) : A3(
						$elm$html$Html$node,
						'hint-marketplace-product',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'slug', model.abG),
								A2(
								$elm$html$Html$Attributes$attribute,
								'is-partner',
								$author$project$Utils$Bool$toString(
									$author$project$Api$Platform$Session$One$organizationIsPartner(model.aa4)))
							]),
						_List_fromArray(
							[
								$author$project$Pages$Marketplace$Slug_String$viewManageButton(model),
								A2($author$project$Components$Marketplace$Product$CallToAction$button, _List_Nil, model.br)
							]))
					]))
			]),
		ac9: 'Marketplace | ' + title
	};
};
var $author$project$Pages$Marketplace$Slug_String$page = $author$project$Spa$Page$applicationPrivate(
	{ah_: $author$project$Pages$Marketplace$Slug_String$init, aiq: $author$project$Pages$Marketplace$Slug_String$load, k8: $author$project$Pages$Marketplace$Slug_String$save, alO: $author$project$Pages$Marketplace$Slug_String$subscriptions, adT: $author$project$Pages$Marketplace$Slug_String$update, amo: $author$project$Pages$Marketplace$Slug_String$view});
var $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$GotIntegration = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Integration$retrieve = F3(
	function (apiClient, slug, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Integration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Integration$integrationPath(slug)));
	});
var $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$init = F4(
	function (session, practice, shared, _v0) {
		var params = _v0.YL;
		return _Utils_Tuple2(
			{dT: $author$project$Api$Data$NotAsked, Gv: shared.Gv, T8: $author$project$Api$Data$Loading, ZV: practice, aa4: session, abG: params.abG},
			A3($author$project$Api$Provider$Integration$retrieve, shared.Gv, params.abG, $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$GotIntegration));
	});
var $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$LocalhostConnectResult = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$subscriptions = function (_v0) {
	return $author$project$Ports$LocalhostConnect$onResult($author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$LocalhostConnectResult);
};
var $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$GotLocalhostConnectUrl = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$PartnerActivated = function (a) {
	return {$: 2, a: a};
};
var $author$project$OutMsg$RefreshLayout = {$: 21};
var $author$project$Api$Provider$Partner$ForIntegrationOne$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Partner$Shared$name(shared);
};
var $author$project$Api$Provider$Integration$One$partnerName = function (_v0) {
	var partner = _v0.b;
	return $author$project$Api$Provider$Partner$ForIntegrationOne$name(partner);
};
var $author$project$Api$Provider$Integration$One$productName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Integration$Shared$productName(shared);
};
var $author$project$Api$Provider$Integration$One$displayName = function (integration) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Api$Provider$Integration$One$partnerName(integration),
		$author$project$Api$Provider$Integration$One$productName(integration));
};
var $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$isLocalhostMode = function (integration) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Common$PartnerApp$Shared$localhostMode,
			$author$project$Api$Provider$Integration$One$partnerApp(integration)));
};
var $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{T8: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var integration = msg.a;
				var cmd = function () {
					var _v1 = _Utils_Tuple3(
						$author$project$Api$Provider$Integration$One$authType(integration),
						$author$project$Api$Provider$Integration$One$connectionUrl(integration),
						$author$project$Api$Provider$Integration$One$postActivationRedirectUrl(integration));
					_v1$0:
					while (true) {
						_v1$3:
						while (true) {
							_v1$4:
							while (true) {
								switch (_v1.a) {
									case 'automatic_redirect':
										if (!_v1.c.$) {
											if (!_v1.b.$) {
												break _v1$0;
											} else {
												break _v1$3;
											}
										} else {
											if (!_v1.b.$) {
												break _v1$0;
											} else {
												break _v1$4;
											}
										}
									case 'automatic_headless':
										return $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$isLocalhostMode(integration) ? A3(
											$author$project$Api$Provider$Integration$localhostConnect,
											model.Gv,
											$author$project$Api$Provider$Integration$One$id(integration),
											$author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$GotLocalhostConnectUrl) : A3(
											$author$project$Api$Provider$Integration$connect,
											model.Gv,
											$author$project$Api$Provider$Integration$One$id(integration),
											$author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$PartnerActivated);
									case 'manual':
										return $elm$core$Platform$Cmd$none;
									default:
										if (!_v1.c.$) {
											break _v1$3;
										} else {
											break _v1$4;
										}
								}
							}
							var _v2 = _v1.c;
							return $elm$core$Platform$Cmd$none;
						}
						var postActivationRedirectUrl = _v1.c.a;
						return $author$project$Ports$Navigation$pushUrl(postActivationRedirectUrl);
					}
					var connectionUrl = _v1.b.a;
					return $author$project$Ports$Navigation$openInNewWindow(connectionUrl);
				}();
				var activationRequest = ($author$project$Api$Provider$Integration$One$authType(integration) === 'automatic_headless') ? $author$project$Api$Data$Loading : $author$project$Api$Data$NotAsked;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dT: activationRequest}),
					cmd,
					($author$project$Api$Provider$Integration$One$authType(integration) === 'automatic_headless') ? _List_Nil : _List_fromArray(
						[
							A2(
							$author$project$OutMsg$ShowToast,
							3,
							$author$project$Api$Provider$Integration$One$displayName(integration) + ' activated')
						]));
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					var integration = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dT: response, T8: response}),
						function () {
							var _v4 = _Utils_Tuple2(
								$author$project$Api$Provider$Integration$One$authType(integration),
								$author$project$Api$Provider$Integration$One$postActivationRedirectUrl(integration));
							if ((_v4.a === 'automatic_headless') && (!_v4.b.$)) {
								var postActivationRedirectUrl = _v4.b.a;
								return $author$project$Ports$Navigation$pushUrl(postActivationRedirectUrl);
							} else {
								return A2(
									$author$project$Utils$Route$navigate,
									$elm$core$Dict$empty,
									$author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Users(
										{abG: model.abG}));
							}
						}(),
						_List_fromArray(
							[
								A2(
								$author$project$OutMsg$ShowToast,
								3,
								$author$project$Api$Provider$Integration$One$displayName(integration) + ' activated'),
								$author$project$OutMsg$RefreshLayout
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dT: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					var data = response.a;
					return _Utils_Tuple3(
						model,
						$author$project$Ports$LocalhostConnect$connect(data.afV),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dT: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 1, 'Failed to retrieve localhost connect URL.')
							]));
				}
			default:
				var success = msg.a;
				return success ? _Utils_Tuple3(
					_Utils_update(
						model,
						{dT: $author$project$Api$Data$NotAsked}),
					A2(
						$author$project$Utils$Route$navigate,
						$elm$core$Dict$empty,
						$author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Users(
							{abG: model.abG})),
					_List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 3, 'Partner activated'),
							$author$project$OutMsg$RefreshLayout
						])) : _Utils_Tuple3(
					_Utils_update(
						model,
						{dT: $author$project$Api$Data$NotAsked}),
					$elm$core$Platform$Cmd$none,
					_List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 1, 'Localhost connect failed. Ensure your local server is running and allows CORS.')
						]));
		}
	});
var $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$Activate = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Partner$ForIntegrationOne$active = function (_v0) {
	var record = _v0.b;
	return record.KN;
};
var $author$project$Api$Provider$Integration$One$active = function (_v0) {
	var partner = _v0.b;
	return $author$project$Api$Provider$Partner$ForIntegrationOne$active(partner);
};
var $author$project$Api$Provider$Integration$Shared$authorizationCode = function (_v0) {
	var record = _v0;
	return record.Me;
};
var $author$project$Api$Provider$Integration$One$authorizationCode = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Integration$Shared$authorizationCode(shared);
};
var $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$canAutomaticallyIntegrate = function (integration) {
	return ($author$project$Api$Provider$Integration$One$authType(integration) === 'automatic_redirect') || ($author$project$Api$Provider$Integration$One$authType(integration) === 'automatic_headless');
};
var $author$project$Api$Provider$Partner$ForIntegrationOne$email = function (_v0) {
	var record = _v0.b;
	return record.Rj;
};
var $author$project$Api$Provider$Integration$One$email = function (_v0) {
	var partner = _v0.b;
	return $author$project$Api$Provider$Partner$ForIntegrationOne$email(partner);
};
var $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				function () {
				var _v0 = model.T8;
				if (_v0.$ === 3) {
					var integration = _v0.a;
					var status = $author$project$Api$Provider$Integration$One$status(integration);
					var name = $author$project$Api$Provider$Integration$One$displayName(integration);
					return A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										((status === 'pending') && $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$canAutomaticallyIntegrate(integration)) ? A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$labelSpan(4),
												$author$project$Ui$Form$Group$inputSpan(8),
												$author$project$Ui$Form$Group$label('')
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Static$view,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$p,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Typography$em,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('If you haven\'t been contacted by '),
																		$elm$html$Html$text(name),
																		$elm$html$Html$text(' about next steps for this integration, then something probably went wrong.')
																	]))
															])),
														A3(
														$author$project$Ui$Button$view,
														{mm: 'Try again'},
														_List_fromArray(
															[
																$author$project$Ui$Button$onClick(
																$author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$Activate(integration)),
																$author$project$Ui$Button$primary,
																$author$project$Ui$Button$loading(
																_Utils_eq(model.dT, $author$project$Api$Data$Loading))
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Try again')
															]))
													]))
											])) : $author$project$Utils$Html$empty,
										function () {
										if ((status === 'pending') && ($author$project$Api$Provider$Integration$One$active(integration) && (!$author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$canAutomaticallyIntegrate(integration)))) {
											var email = $author$project$Api$Provider$Integration$One$email(integration);
											return A2(
												$author$project$Ui$Form$Group$view,
												_List_fromArray(
													[
														$author$project$Ui$Form$Group$label('Authorization Code'),
														$author$project$Ui$Form$Group$labelSpanSm(4),
														$author$project$Ui$Form$Group$inputSpanSm(8)
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Form$Static$view,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Typography$pre,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		A2(
																			$elm$core$Maybe$withDefault,
																			'N/A',
																			$author$project$Api$Provider$Integration$One$authorizationCode(integration)))
																	])),
																A2(
																$author$project$Ui$Alert$warning,
																_List_Nil,
																_List_fromArray(
																	[
																		A2(
																		$author$project$Ui$Typography$em,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$elm$html$Html$text(name),
																				$elm$html$Html$text(' does not support automatic integrations yet. Please email them at'),
																				A3(
																				$author$project$Ui$Link$mailto,
																				A2($elm$core$Maybe$withDefault, '', email),
																				_List_Nil,
																				_List_fromArray(
																					[
																						$elm$html$Html$text(
																						A2($elm$core$Maybe$withDefault, '', email))
																					])),
																				$elm$html$Html$text(' and they can provide you with next steps.')
																			]))
																	]))
															]))
													]));
										} else {
											return $author$project$Utils$Html$empty;
										}
									}()
									]))
							]));
				} else {
					return $elm$html$Html$text('');
				}
			}()
			]),
		ac9: 'Onboarding'
	};
};
var $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$init, aiq: $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$load, k8: $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$save, alO: $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$subscriptions, adT: $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$update, amo: $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$view});
var $author$project$Pages$Marketplace$Slug_String$Manage$Settings$GotIntegration = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Marketplace$Slug_String$Manage$Settings$init = F4(
	function (session, practice, shared, _v0) {
		var params = _v0.YL;
		return _Utils_Tuple2(
			{Gv: shared.Gv, T8: $author$project$Api$Data$Loading, ZV: practice, aa4: session, cT: $elm$core$Maybe$Nothing, abG: params.abG},
			A3($author$project$Api$Provider$Integration$retrieve, shared.Gv, params.abG, $author$project$Pages$Marketplace$Slug_String$Manage$Settings$GotIntegration));
	});
var $author$project$Pages$Marketplace$Slug_String$Manage$Settings$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Marketplace$Slug_String$Manage$Settings$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Marketplace$Slug_String$Manage$Settings$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Marketplace$Slug_String$Manage$Settings$SettingsMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$PartnerApp$Settings$Model = $elm$core$Basics$identity;
var $author$project$Components$Admin$PartnerApp$Settings$MountSettingsSurface = 0;
var $author$project$Api$Common$PartnerApp$Anchor$isSettings = function (_v0) {
	var record = _v0;
	var _v1 = record.amg;
	if (_v1 === 3) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Api$Common$PartnerApp$Shared$settingsAnchor = function (_v0) {
	var record = _v0;
	return A2($elm_community$list_extra$List$Extra$find, $author$project$Api$Common$PartnerApp$Anchor$isSettings, record.Gr);
};
var $author$project$Components$Admin$PartnerApp$Settings$init = function (partnerApp) {
	var settingsAnchor = $author$project$Api$Common$PartnerApp$Shared$settingsAnchor(partnerApp);
	return _Utils_Tuple2(
		{YP: partnerApp},
		function () {
			if (!settingsAnchor.$) {
				return A2(
					$elm$core$Task$perform,
					function (_v1) {
						return 0;
					},
					$elm$core$Process$sleep(1000));
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		}());
};
var $author$project$Components$Admin$PartnerApp$Settings$update = F2(
	function (msg, _v0) {
		var model = _v0;
		return _Utils_Tuple3(
			model,
			A2(
				$author$project$Ports$PartnerApps$mount,
				'partner-app-settings',
				{
					ae$: $author$project$Api$Common$PartnerApp$Shared$id(model.YP),
					V9: $author$project$Api$Common$PartnerApp$Shared$localhostMode(model.YP),
					amg: 'settings'
				}),
			_List_Nil);
	});
var $author$project$Pages$Marketplace$Slug_String$Manage$Settings$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var response = msg.a;
			if (response.$ === 3) {
				var integration = response.a;
				var _v2 = $author$project$Api$Provider$Integration$One$partnerApp(integration);
				if (!_v2.$) {
					var partnerApp = _v2.a;
					var settingsAnchor = $author$project$Api$Common$PartnerApp$Shared$settingsAnchor(partnerApp);
					if (!settingsAnchor.$) {
						var _v4 = $author$project$Components$Admin$PartnerApp$Settings$init(partnerApp);
						var settings = _v4.a;
						var settingsCmd = _v4.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									T8: response,
									cT: $elm$core$Maybe$Just(settings)
								}),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Marketplace$Slug_String$Manage$Settings$SettingsMsg, settingsCmd),
							_List_Nil);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{T8: response}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{T8: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			} else {
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{T8: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			}
		} else {
			var settingsMsg = msg.a;
			var _v5 = model.cT;
			if (!_v5.$) {
				var settings = _v5.a;
				var _v6 = A2($author$project$Components$Admin$PartnerApp$Settings$update, settingsMsg, settings);
				var newSettings = _v6.a;
				var settingsCmd = _v6.b;
				var outMsgs = _v6.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							cT: $elm$core$Maybe$Just(newSettings)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Marketplace$Slug_String$Manage$Settings$SettingsMsg, settingsCmd),
					outMsgs);
			} else {
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
			}
		}
	});
var $author$project$Components$Admin$PartnerApp$Settings$view = function (_v0) {
	var model = _v0;
	var settingsAnchor = $author$project$Api$Common$PartnerApp$Shared$settingsAnchor(model.YP);
	if (!settingsAnchor.$) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('partner-app-settings-wrapper'),
					$elm$html$Html$Attributes$id('partner-app-settings')
				]),
			_List_Nil);
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Pages$Marketplace$Slug_String$Manage$Settings$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				function () {
				var _v0 = model.cT;
				if (!_v0.$) {
					var settings = _v0.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$Marketplace$Slug_String$Manage$Settings$SettingsMsg,
						$author$project$Components$Admin$PartnerApp$Settings$view(settings));
				} else {
					return $elm$html$Html$text('');
				}
			}()
			]),
		ac9: 'Settings'
	};
};
var $author$project$Pages$Marketplace$Slug_String$Manage$Settings$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Marketplace$Slug_String$Manage$Settings$init, aiq: $author$project$Pages$Marketplace$Slug_String$Manage$Settings$load, k8: $author$project$Pages$Marketplace$Slug_String$Manage$Settings$save, alO: $author$project$Pages$Marketplace$Slug_String$Manage$Settings$subscriptions, adT: $author$project$Pages$Marketplace$Slug_String$Manage$Settings$update, amo: $author$project$Pages$Marketplace$Slug_String$Manage$Settings$view});
var $author$project$Pages$Marketplace$Slug_String$Manage$Users$GotIntegration = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Marketplace$Slug_String$Manage$Users$init = F4(
	function (session, practice, shared, _v0) {
		var params = _v0.YL;
		return _Utils_Tuple2(
			{Gv: shared.Gv, T8: $author$project$Api$Data$Loading, kx: $elm$core$Maybe$Nothing, ZV: practice, aa4: session, abG: params.abG},
			A3($author$project$Api$Provider$Integration$retrieve, shared.Gv, params.abG, $author$project$Pages$Marketplace$Slug_String$Manage$Users$GotIntegration));
	});
var $author$project$Pages$Marketplace$Slug_String$Manage$Users$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Marketplace$Slug_String$Manage$Users$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Marketplace$Slug_String$Manage$Users$PartnerAppTeamMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$PartnerApp$Team$CancelTeamMemberEdit = {$: 9};
var $author$project$Components$Admin$PartnerApp$Team$PracticeUserResourceFilterMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Admin$PartnerApp$Team$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Admin$PartnerApp$Team$PracticeUserResourceFilterMsg,
				$author$project$Components$ResourceFilter$PracticeUser$subscriptions(model.eV)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Admin$PartnerApp$Team$CancelTeamMemberEdit)),
					model.I))
			]));
};
var $author$project$Pages$Marketplace$Slug_String$Manage$Users$subscriptions = function (model) {
	var _v0 = model.kx;
	if (!_v0.$) {
		var partnerAppTeam = _v0.a;
		return A2(
			$elm$core$Platform$Sub$map,
			$author$project$Pages$Marketplace$Slug_String$Manage$Users$PartnerAppTeamMsg,
			$author$project$Components$Admin$PartnerApp$Team$subscriptions(partnerAppTeam));
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Components$Admin$PartnerApp$Team$Model = $elm$core$Basics$identity;
var $author$project$Components$Admin$PartnerApp$Team$GotTeamMembers = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$PartnerAppUser$All$PartnerAppUser = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$PartnerAppUser$Shared$PartnerAppUser = $elm$core$Basics$identity;
var $author$project$Api$Provider$PartnerAppUser$Shared$Record = F3(
	function (id, email, partnerRoles) {
		return {Rj: email, ahP: id, I3: partnerRoles};
	});
var $author$project$Api$Provider$PartnerAppUser$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'partner_roles',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'email',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$PartnerAppUser$Shared$Record))));
var $author$project$Api$Provider$PartnerAppUser$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PartnerAppUser$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PartnerAppUser$All$Record = function (practiceUser) {
	return {Z$: practiceUser};
};
var $author$project$Api$Provider$PartnerAppUser$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'practice_user',
	$author$project$Api$Provider$PracticeUser$Shared$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$PartnerAppUser$All$Record));
var $author$project$Api$Provider$PartnerAppUser$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PartnerAppUser$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$PartnerAppUser$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$PartnerAppUser$All$PartnerAppUser)));
var $author$project$Api$Provider$PartnerApp$TeamMember$listOptionalsDefaults = {ajJ: $author$project$Api$Pagination$init, akl: $elm$core$Maybe$Nothing, alA: $author$project$Api$Sort$init};
var $author$project$Api$Provider$PartnerApp$TeamMember$listOptionalsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$PartnerApp$TeamMember$listOptionalsDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.akl;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$Provider$PartnerApp$partnerAppPath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		$author$project$Api$Provider$PartnerApp$partnerAppsPath);
};
var $author$project$Api$Provider$PartnerApp$TeamMember$partnerAppTeamMembersPath = function (partnerAppId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['team_members']),
		$author$project$Api$Provider$PartnerApp$partnerAppPath(partnerAppId));
};
var $author$project$Api$Provider$PartnerApp$TeamMember$list = F4(
	function (apiClient, partnerAppId, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$PartnerAppUser$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$PartnerApp$TeamMember$listOptionalsToParams(optionals),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$PartnerApp$TeamMember$partnerAppTeamMembersPath(partnerAppId))));
	});
var $author$project$Components$Admin$PartnerApp$Team$fetchTeamMembers = F2(
	function (apiClient, model) {
		return A4(
			$author$project$Api$Provider$PartnerApp$TeamMember$list,
			apiClient,
			$author$project$Api$Common$PartnerApp$Shared$id(model.YP),
			function (d) {
				return _Utils_update(
					d,
					{ajJ: model.ajJ, akl: model.akl, alA: model.alA});
			},
			$author$project$Components$Admin$PartnerApp$Team$GotTeamMembers);
	});
var $author$project$Components$Admin$PartnerApp$Team$initPracticeUserResourceFilter = function (apiClient) {
	return A2(
		$elm$core$Tuple$mapSecond,
		$elm$core$Platform$Cmd$map($author$project$Components$Admin$PartnerApp$Team$PracticeUserResourceFilterMsg),
		A3(
			$author$project$Components$ResourceFilter$PracticeUser$init,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						HM: $elm$core$Maybe$Just(0)
					});
			},
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Select A User', ai5: false});
			}));
};
var $author$project$Api$Provider$Integration$One$autoGrantPartnerAppAccess = function (_v0) {
	var record = _v0.c;
	return record.ae2;
};
var $author$project$Api$Provider$Integration$One$defaultPartnerAppAdminRole = function (_v0) {
	var record = _v0.c;
	return record.agj;
};
var $author$project$Api$Provider$Integration$One$defaultPartnerAppNonAdminRole = function (_v0) {
	var record = _v0.c;
	return record.agk;
};
var $author$project$Components$Admin$PartnerApp$Team$settingsFormFromIntegration = function (integration) {
	return {
		ae2: $author$project$Api$Provider$Integration$One$autoGrantPartnerAppAccess(integration),
		agj: $author$project$Api$Provider$Integration$One$defaultPartnerAppAdminRole(integration),
		agk: $author$project$Api$Provider$Integration$One$defaultPartnerAppNonAdminRole(integration)
	};
};
var $author$project$Components$Admin$PartnerApp$Team$init = F4(
	function (apiClient, integration, partnerApp, currentUser) {
		var _v0 = $author$project$Components$Admin$PartnerApp$Team$initPracticeUserResourceFilter(apiClient);
		var practiceUserResourceFilter = _v0.a;
		var practiceUserResourceFilterCmd = _v0.b;
		var model = {
			Hd: currentUser,
			nf: $elm$core$Maybe$Nothing,
			eo: $elm$core$Set$empty,
			T8: integration,
			ajJ: $author$project$Api$Pagination$init,
			YP: partnerApp,
			eV: practiceUserResourceFilter,
			akl: $elm$core$Maybe$Nothing,
			up: $author$project$Ui$SearchInput$init($elm$core$Maybe$Nothing),
			bi: $author$project$Components$Admin$PartnerApp$Team$settingsFormFromIntegration(integration),
			p_: $author$project$Api$Data$NotAsked,
			alA: A3($author$project$Api$Sort$withDefault, 'user_first_name', 0, $author$project$Api$Sort$init),
			I: $elm$core$Maybe$Nothing,
			fm: $author$project$Api$Data$Loading
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Components$Admin$PartnerApp$Team$fetchTeamMembers, apiClient, model),
						practiceUserResourceFilterCmd
					])));
	});
var $author$project$Components$Admin$PartnerApp$Team$IntegrationUpdated = 1;
var $author$project$Components$Admin$PartnerApp$Team$PracticeUser = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$PartnerApp$Team$SearchInputMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$PartnerApp$Team$SettingsSaved = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Admin$PartnerApp$Team$TeamMemberDeleted = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Api$Provider$PartnerApp$TeamMember$partnerAppTeamMemberPath = F2(
	function (partnerAppId, id) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id]),
			$author$project$Api$Provider$PartnerApp$TeamMember$partnerAppTeamMembersPath(partnerAppId));
	});
var $author$project$Api$Provider$PartnerApp$TeamMember$delete = F4(
	function (apiClient, partnerAppId, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Provider$PartnerApp$TeamMember$partnerAppTeamMemberPath, partnerAppId, id)));
	});
var $author$project$Api$Provider$PartnerAppUser$Shared$partnerRoles = function (_v0) {
	var record = _v0;
	return record.I3;
};
var $author$project$Api$Provider$PartnerAppUser$All$partnerRoles = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PartnerAppUser$Shared$partnerRoles(shared);
};
var $author$project$Api$Provider$PartnerAppUser$All$practiceUser = function (_v0) {
	var record = _v0.b;
	return record.Z$;
};
var $author$project$Components$Admin$PartnerApp$Team$practiceUserRecordFromShared = function (practiceUser) {
	return {
		ahP: $author$project$Api$Provider$PracticeUser$Shared$id(practiceUser)
	};
};
var $author$project$Components$Admin$PartnerApp$Team$formFieldsFromTeamMember = function (teamMember) {
	var practiceUser = $author$project$Api$Provider$PartnerAppUser$All$practiceUser(teamMember);
	return {
		g6: $elm$core$List$head(
			$author$project$Api$Provider$PartnerAppUser$All$partnerRoles(teamMember)),
		aj9: _List_fromArray(
			[
				$author$project$Components$Admin$PartnerApp$Team$practiceUserRecordFromShared(practiceUser)
			])
	};
};
var $author$project$Components$Admin$PartnerApp$Team$formFieldsInit = {g6: $elm$core$Maybe$Nothing, aj9: _List_Nil};
var $author$project$Components$Admin$PartnerApp$Team$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var practiceUsers = field.a;
			return _Utils_update(
				fields,
				{aj9: practiceUsers});
		} else {
			var string = field.a;
			return _Utils_update(
				fields,
				{
					g6: $author$project$Utils$String$toMaybe(string)
				});
		}
	});
var $author$project$Components$Admin$PartnerApp$Team$PracticeUserValidation = 0;
var $rtfeldman$elm_validate$Validate$ifEmptyList = F2(
	function (subjectToList, error) {
		return A2(
			$rtfeldman$elm_validate$Validate$ifTrue,
			function (subject) {
				return $elm$core$List$isEmpty(
					subjectToList(subject));
			},
			error);
	});
var $author$project$Components$Admin$PartnerApp$Team$PartnerRoleValidation = 1;
var $author$project$Api$Common$PartnerApp$Shared$partnerRoleNames = function (_v0) {
	var record = _v0;
	return A2($elm$core$List$map, $author$project$Api$Common$PartnerApp$PartnerRole$name, record.I3);
};
var $author$project$Components$Admin$PartnerApp$Team$validatePartnerRole = F2(
	function (partnerApp, fields) {
		return $elm$core$List$isEmpty(
			$author$project$Api$Common$PartnerApp$Shared$partnerRoleNames(partnerApp)) ? _List_Nil : (_Utils_eq(fields.g6, $elm$core$Maybe$Nothing) ? _List_fromArray(
			[
				_Utils_Tuple2(1, 'Please pick a role.')
			]) : _List_Nil);
	});
var $author$project$Components$Admin$PartnerApp$Team$formFieldsValidator = function (partnerApp) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_validate$Validate$ifEmptyList,
				function ($) {
					return $.aj9;
				},
				_Utils_Tuple2(0, 'Please pick at least one user.')),
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$Admin$PartnerApp$Team$validatePartnerRole(partnerApp))
			]));
};
var $author$project$Components$Admin$PartnerApp$Team$None = 0;
var $author$project$Components$Admin$PartnerApp$Team$noEvent = F3(
	function (m, c, o) {
		return {GZ: c, agZ: 0, aiO: m, aR: o};
	});
var $author$project$Components$Admin$PartnerApp$Team$practiceUserRecordFromAll = function (practiceUser) {
	return {
		ahP: $author$project$Api$Provider$PracticeUser$All$id(practiceUser)
	};
};
var $author$project$Components$Admin$PartnerApp$Team$TeamMemberCreated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$PartnerAppUser$One$PartnerAppUser = 0;
var $author$project$Api$Provider$PartnerAppUser$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Provider$PartnerApp$TeamMember$bulkCreate = F4(
	function (apiClient, partnerAppId, fields, toMsg) {
		var encodeTeamMember = function (practiceUser) {
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'practice_user',
						$author$project$Utils$Encode$association(practiceUser)),
						_Utils_Tuple2(
						'partner_roles',
						A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, fields.I3))
					]));
		};
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'team_members',
					A2($elm$json$Json$Encode$list, encodeTeamMember, fields.aj9))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$PartnerAppUser$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['bulk_create']),
						$author$project$Api$Provider$PartnerApp$TeamMember$partnerAppTeamMembersPath(partnerAppId)))));
	});
var $author$project$Components$Admin$PartnerApp$Team$createTeamMember = F3(
	function (apiClient, partnerApp, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4(
			$author$project$Api$Provider$PartnerApp$TeamMember$bulkCreate,
			apiClient,
			$author$project$Api$Common$PartnerApp$Shared$id(partnerApp),
			{
				I3: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Maybe$map, $elm$core$List$singleton, fields.g6)),
				aj9: A2(
					$elm$core$List$map,
					function ($) {
						return $.ahP;
					},
					fields.aj9)
			},
			$author$project$Components$Admin$PartnerApp$Team$TeamMemberCreated);
	});
var $author$project$Components$Admin$PartnerApp$Team$TeamMemberUpdated = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Provider$PartnerApp$TeamMember$update = F5(
	function (apiClient, partnerAppId, id_, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'team_member',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'partner_roles',
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, fields.I3))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$PartnerAppUser$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Provider$PartnerApp$TeamMember$partnerAppTeamMemberPath, partnerAppId, id_))));
	});
var $author$project$Components$Admin$PartnerApp$Team$updateTeamMember = F4(
	function (apiClient, partnerApp, id, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A5(
			$author$project$Api$Provider$PartnerApp$TeamMember$update,
			apiClient,
			$author$project$Api$Common$PartnerApp$Shared$id(partnerApp),
			id,
			{
				I3: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Maybe$map, $elm$core$List$singleton, fields.g6))
			},
			$author$project$Components$Admin$PartnerApp$Team$TeamMemberUpdated);
	});
var $author$project$Components$Admin$PartnerApp$Team$saveTeamMember = F4(
	function (apiClient, partnerApp, maybeId, formFields) {
		if (!maybeId.$) {
			var id = maybeId.a;
			return A4($author$project$Components$Admin$PartnerApp$Team$updateTeamMember, apiClient, partnerApp, id, formFields);
		} else {
			return A3($author$project$Components$Admin$PartnerApp$Team$createTeamMember, apiClient, partnerApp, formFields);
		}
	});
var $author$project$Components$Admin$PartnerApp$Team$setAutoGrant = F2(
	function (value, form) {
		return _Utils_update(
			form,
			{ae2: value});
	});
var $author$project$Components$Admin$PartnerApp$Team$setDefaultPartnerAppAdminRole = F2(
	function (value, form) {
		return _Utils_update(
			form,
			{agj: value});
	});
var $author$project$Components$Admin$PartnerApp$Team$setDefaultPartnerAppNonAdminRole = F2(
	function (value, form) {
		return _Utils_update(
			form,
			{agk: value});
	});
var $author$project$Api$Provider$Integration$update = F4(
	function (apiClient, id, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'integration',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'auto_grant_partner_app_access',
								$elm$json$Json$Encode$bool(fields.ae2)),
								_Utils_Tuple2(
								'default_partner_app_admin_role',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.agj)),
								_Utils_Tuple2(
								'default_partner_app_non_admin_role',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.agk))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Integration$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Integration$integrationPath(id))));
	});
var $author$project$Components$Admin$PartnerApp$Team$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return A3(
						$author$project$Components$Admin$PartnerApp$Team$noEvent,
						_Utils_update(
							model,
							{
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ),
								fm: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return A3(
						$author$project$Components$Admin$PartnerApp$Team$noEvent,
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						alA: A2($author$project$Api$Sort$update, columnId, model.alA),
						fm: $author$project$Api$Data$Loading
					});
				return A3(
					$author$project$Components$Admin$PartnerApp$Team$noEvent,
					newModel,
					A2($author$project$Components$Admin$PartnerApp$Team$fetchTeamMembers, apiClient, newModel),
					_List_Nil);
			case 2:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{ajJ: pagination, fm: $author$project$Api$Data$Loading});
				return A3(
					$author$project$Components$Admin$PartnerApp$Team$noEvent,
					newModel,
					A2($author$project$Components$Admin$PartnerApp$Team$fetchTeamMembers, apiClient, newModel),
					_List_Nil);
			case 3:
				var subMsg = msg.a;
				var _v3 = A2($author$project$Ui$SearchInput$update, subMsg, model.up);
				var searchInput = _v3.a;
				var searchInputCmd = _v3.b;
				var searchInputEvent = _v3.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.akl;
					}
				}();
				var _v4 = function () {
					if (_Utils_eq(q, model.akl)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								ajJ: $author$project$Api$Pagination$reset(model.ajJ),
								akl: q,
								fm: $author$project$Api$Data$Loading
							});
						return _Utils_Tuple2(
							qModel,
							A2($author$project$Components$Admin$PartnerApp$Team$fetchTeamMembers, apiClient, qModel));
					}
				}();
				var newModel = _v4.a;
				var cmd = _v4.b;
				return A3(
					$author$project$Components$Admin$PartnerApp$Team$noEvent,
					_Utils_update(
						newModel,
						{up: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$PartnerApp$Team$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
			case 4:
				var _v6 = $author$project$Components$Admin$PartnerApp$Team$initPracticeUserResourceFilter(apiClient);
				var practiceUserResourceFilter = _v6.a;
				var practiceUserResourceFilterCmd = _v6.b;
				return A3(
					$author$project$Components$Admin$PartnerApp$Team$noEvent,
					_Utils_update(
						model,
						{
							eV: practiceUserResourceFilter,
							I: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init($author$project$Components$Admin$PartnerApp$Team$formFieldsInit),
									$author$project$Api$Data$NotAsked))
						}),
					practiceUserResourceFilterCmd,
					_List_Nil);
			case 5:
				var field = msg.a;
				var _v7 = model.I;
				if (!_v7.$) {
					var _v8 = _v7.a;
					var teamMember = _v8.a;
					var form = _v8.b;
					var request = _v8.c;
					return A3(
						$author$project$Components$Admin$PartnerApp$Team$noEvent,
						_Utils_update(
							model,
							{
								I: $elm$core$Maybe$Just(
									_Utils_Tuple3(
										teamMember,
										A3($author$project$Utils$Form$update, $author$project$Components$Admin$PartnerApp$Team$formFieldsUpdate, field, form),
										request))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return A3($author$project$Components$Admin$PartnerApp$Team$noEvent, model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var form = msg.a;
				var teamMember = msg.b;
				var id = msg.c;
				var _v9 = A2(
					$author$project$Utils$Form$validate,
					$author$project$Components$Admin$PartnerApp$Team$formFieldsValidator(model.YP),
					form);
				if (!_v9.$) {
					var _v10 = _v9.a;
					var newForm = _v10.a;
					var validFormFields = _v10.b;
					return A3(
						$author$project$Components$Admin$PartnerApp$Team$noEvent,
						_Utils_update(
							model,
							{
								I: $elm$core$Maybe$Just(
									_Utils_Tuple3(teamMember, newForm, $author$project$Api$Data$Loading))
							}),
						A4($author$project$Components$Admin$PartnerApp$Team$saveTeamMember, apiClient, model.YP, id, validFormFields),
						_List_Nil);
				} else {
					var newForm = _v9.a;
					return A3(
						$author$project$Components$Admin$PartnerApp$Team$noEvent,
						_Utils_update(
							model,
							{
								I: $elm$core$Maybe$Just(
									_Utils_Tuple3(teamMember, newForm, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 7:
				var response = msg.a;
				var _v11 = model.I;
				if (!_v11.$) {
					var _v12 = _v11.a;
					var teamMember = _v12.a;
					var form = _v12.b;
					if (response.$ === 3) {
						return A3(
							$author$project$Components$Admin$PartnerApp$Team$noEvent,
							_Utils_update(
								model,
								{I: $elm$core$Maybe$Nothing}),
							A2($author$project$Components$Admin$PartnerApp$Team$fetchTeamMembers, apiClient, model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Team member successfully added')
								]));
					} else {
						return A3(
							$author$project$Components$Admin$PartnerApp$Team$noEvent,
							_Utils_update(
								model,
								{
									I: $elm$core$Maybe$Just(
										_Utils_Tuple3(teamMember, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return A3($author$project$Components$Admin$PartnerApp$Team$noEvent, model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 8:
				var teamMember = msg.a;
				return A3(
					$author$project$Components$Admin$PartnerApp$Team$noEvent,
					_Utils_update(
						model,
						{
							I: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(teamMember),
									$author$project$Utils$Form$init(
										$author$project$Components$Admin$PartnerApp$Team$formFieldsFromTeamMember(teamMember)),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 9:
				return A3(
					$author$project$Components$Admin$PartnerApp$Team$noEvent,
					_Utils_update(
						model,
						{I: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 10:
				var response = msg.a;
				var _v14 = model.I;
				if (!_v14.$) {
					var _v15 = _v14.a;
					var id = _v15.a;
					var form = _v15.b;
					if (response.$ === 3) {
						return A3(
							$author$project$Components$Admin$PartnerApp$Team$noEvent,
							_Utils_update(
								model,
								{I: $elm$core$Maybe$Nothing}),
							A2($author$project$Components$Admin$PartnerApp$Team$fetchTeamMembers, apiClient, model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Team member successfully updated')
								]));
					} else {
						return A3(
							$author$project$Components$Admin$PartnerApp$Team$noEvent,
							_Utils_update(
								model,
								{
									I: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return A3($author$project$Components$Admin$PartnerApp$Team$noEvent, model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 11:
				var teamMember = msg.a;
				return A3(
					$author$project$Components$Admin$PartnerApp$Team$noEvent,
					_Utils_update(
						model,
						{
							nf: $elm$core$Maybe$Just(teamMember)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 12:
				var id = msg.a;
				var confirmed = msg.b;
				return confirmed ? A3(
					$author$project$Components$Admin$PartnerApp$Team$noEvent,
					_Utils_update(
						model,
						{
							nf: $elm$core$Maybe$Nothing,
							eo: A2($elm$core$Set$insert, id, model.eo)
						}),
					A4(
						$author$project$Api$Provider$PartnerApp$TeamMember$delete,
						apiClient,
						$author$project$Api$Common$PartnerApp$Shared$id(model.YP),
						id,
						$author$project$Components$Admin$PartnerApp$Team$TeamMemberDeleted(id)),
					_List_Nil) : A3(
					$author$project$Components$Admin$PartnerApp$Team$noEvent,
					_Utils_update(
						model,
						{nf: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 13:
				var id = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return A3(
							$author$project$Components$Admin$PartnerApp$Team$noEvent,
							_Utils_update(
								model,
								{
									eo: A2($elm$core$Set$remove, id, model.eo),
									fm: $author$project$Api$Data$Loading
								}),
							A2($author$project$Components$Admin$PartnerApp$Team$fetchTeamMembers, apiClient, model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Team member successfully removed')
								]));
					case 2:
						return A3(
							$author$project$Components$Admin$PartnerApp$Team$noEvent,
							_Utils_update(
								model,
								{
									eo: A2($elm$core$Set$remove, id, model.eo)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return A3($author$project$Components$Admin$PartnerApp$Team$noEvent, model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 14:
				var subMsg = msg.a;
				var practiceUserResourceResult = A3($author$project$Components$ResourceFilter$PracticeUser$update, apiClient, subMsg, model.eV);
				var _v18 = model.I;
				if (!_v18.$) {
					var _v19 = _v18.a;
					var id = _v19.a;
					var form = _v19.b;
					var request = _v19.c;
					var newForm = function () {
						var _v20 = practiceUserResourceResult.agZ;
						if (!_v20.$) {
							switch (_v20.a.$) {
								case 2:
									var _v21 = _v20.a;
									return A3(
										$author$project$Utils$Form$update,
										$author$project$Components$Admin$PartnerApp$Team$formFieldsUpdate,
										$author$project$Components$Admin$PartnerApp$Team$PracticeUser(_List_Nil),
										form);
								case 0:
									var practiceUser = _v20.a.a;
									return A3(
										$author$project$Utils$Form$update,
										$author$project$Components$Admin$PartnerApp$Team$formFieldsUpdate,
										$author$project$Components$Admin$PartnerApp$Team$PracticeUser(
											_List_fromArray(
												[
													$author$project$Components$Admin$PartnerApp$Team$practiceUserRecordFromAll(practiceUser)
												])),
										form);
								case 1:
									var practiceUsers = _v20.a.a;
									return A3(
										$author$project$Utils$Form$update,
										$author$project$Components$Admin$PartnerApp$Team$formFieldsUpdate,
										$author$project$Components$Admin$PartnerApp$Team$PracticeUser(
											A2($elm$core$List$map, $author$project$Components$Admin$PartnerApp$Team$practiceUserRecordFromAll, practiceUsers)),
										form);
								default:
									return form;
							}
						} else {
							return form;
						}
					}();
					return A3(
						$author$project$Components$Admin$PartnerApp$Team$noEvent,
						_Utils_update(
							model,
							{
								eV: practiceUserResourceResult.aiO,
								I: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, request))
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$PartnerApp$Team$PracticeUserResourceFilterMsg, practiceUserResourceResult.GZ),
						_List_Nil);
				} else {
					return A3(
						$author$project$Components$Admin$PartnerApp$Team$noEvent,
						_Utils_update(
							model,
							{eV: practiceUserResourceResult.aiO}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$PartnerApp$Team$PracticeUserResourceFilterMsg, practiceUserResourceResult.GZ),
						_List_Nil);
				}
			case 15:
				var value = msg.a;
				return A3(
					$author$project$Components$Admin$PartnerApp$Team$noEvent,
					_Utils_update(
						model,
						{
							bi: A2($author$project$Components$Admin$PartnerApp$Team$setAutoGrant, value, model.bi)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 16:
				var value = msg.a;
				return A3(
					$author$project$Components$Admin$PartnerApp$Team$noEvent,
					_Utils_update(
						model,
						{
							bi: A2(
								$author$project$Components$Admin$PartnerApp$Team$setDefaultPartnerAppAdminRole,
								$author$project$Utils$String$toMaybe(value),
								model.bi)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 17:
				var value = msg.a;
				return A3(
					$author$project$Components$Admin$PartnerApp$Team$noEvent,
					_Utils_update(
						model,
						{
							bi: A2(
								$author$project$Components$Admin$PartnerApp$Team$setDefaultPartnerAppNonAdminRole,
								$author$project$Utils$String$toMaybe(value),
								model.bi)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 18:
				return A3(
					$author$project$Components$Admin$PartnerApp$Team$noEvent,
					_Utils_update(
						model,
						{p_: $author$project$Api$Data$Loading}),
					A4(
						$author$project$Api$Provider$Integration$update,
						apiClient,
						$author$project$Api$Provider$Integration$One$id(model.T8),
						model.bi,
						$author$project$Components$Admin$PartnerApp$Team$SettingsSaved),
					_List_Nil);
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var integration = response.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 1,
						aiO: _Utils_update(
							model,
							{
								T8: integration,
								bi: $author$project$Components$Admin$PartnerApp$Team$settingsFormFromIntegration(integration),
								p_: $author$project$Api$Data$NotAsked
							}),
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Settings saved')
							])
					};
				} else {
					return A3(
						$author$project$Components$Admin$PartnerApp$Team$noEvent,
						_Utils_update(
							model,
							{p_: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Marketplace$Slug_String$Manage$Users$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var response = msg.a;
			if (response.$ === 3) {
				var integration = response.a;
				var _v2 = $author$project$Api$Provider$Integration$One$partnerApp(integration);
				if (!_v2.$) {
					var partnerApp = _v2.a;
					var _v3 = A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Platform$Cmd$map($author$project$Pages$Marketplace$Slug_String$Manage$Users$PartnerAppTeamMsg),
						A2(
							$elm$core$Tuple$mapFirst,
							$elm$core$Maybe$Just,
							A4(
								$author$project$Components$Admin$PartnerApp$Team$init,
								model.Gv,
								integration,
								partnerApp,
								$author$project$Api$Platform$Session$One$user(model.aa4))));
					var partnerAppTeam = _v3.a;
					var partnerAppTeamCmd = _v3.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{T8: response, kx: partnerAppTeam}),
						partnerAppTeamCmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{T8: response}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			} else {
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{T8: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			}
		} else {
			var subMsg = msg.a;
			var _v4 = model.kx;
			if (!_v4.$) {
				var partnerAppTeam = _v4.a;
				var result = A3($author$project$Components$Admin$PartnerApp$Team$update, model.Gv, subMsg, partnerAppTeam);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							kx: $elm$core$Maybe$Just(result.aiO)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Marketplace$Slug_String$Manage$Users$PartnerAppTeamMsg, result.GZ),
					result.aR);
			} else {
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
			}
		}
	});
var $author$project$Components$Admin$PartnerApp$Team$DeleteConfirmClosed = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Api$Provider$PartnerAppUser$Shared$email = function (_v0) {
	var record = _v0;
	return record.Rj;
};
var $author$project$Api$Provider$PartnerAppUser$All$email = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PartnerAppUser$Shared$email(shared);
};
var $author$project$Api$Provider$PartnerAppUser$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$PartnerAppUser$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PartnerAppUser$Shared$id(shared);
};
var $author$project$Components$Admin$PartnerApp$Team$FormUpdated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Admin$PartnerApp$Team$PartnerRole = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$PartnerApp$Team$SaveTeamMember = F3(
	function (a, b, c) {
		return {$: 6, a: a, b: b, c: c};
	});
var $author$project$Components$Admin$PartnerApp$Team$viewTeamMemberModal = F4(
	function (model, teamMember, request, form) {
		var roles = $author$project$Api$Common$PartnerApp$Shared$partnerRoles(model.YP);
		var modalConfig = {
			Tq: $elm$core$Maybe$Nothing,
			aih: 'Team Member',
			V8: _Utils_eq(request, $author$project$Api$Data$Loading),
			WG: A2($elm$core$Maybe$map, $author$project$Api$Provider$PartnerAppUser$All$id, teamMember),
			WH: $elm$core$Maybe$Nothing,
			Yd: $author$project$Components$Admin$PartnerApp$Team$CancelTeamMemberEdit,
			Yf: A2($author$project$Components$Admin$PartnerApp$Team$SaveTeamMember, form, teamMember)
		};
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('User'),
							$author$project$Ui$Form$Group$required(
							_Utils_eq(teamMember, $elm$core$Maybe$Nothing))
						]),
					_List_fromArray(
						[
							function () {
							if (!teamMember.$) {
								var teamMember_ = teamMember.a;
								return A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'N/A',
												A2(
													$elm$core$Maybe$map,
													$author$project$Api$Provider$User$One$name,
													$author$project$Api$Provider$PracticeUser$Shared$user(
														$author$project$Api$Provider$PartnerAppUser$All$practiceUser(teamMember_)))))
										]));
							} else {
								return A2(
									$elm$html$Html$div,
									_List_Nil,
									A2(
										$elm$core$List$cons,
										A2(
											$elm$html$Html$map,
											$author$project$Components$Admin$PartnerApp$Team$PracticeUserResourceFilterMsg,
											A2(
												$author$project$Components$ResourceFilter$PracticeUser$view,
												_List_fromArray(
													[
														$author$project$Components$ResourceFilter$invalid(
														A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
														$author$project$Components$ResourceFilter$errors(
														A2($author$project$Utils$Form$validationErrors, 0, form)),
														$author$project$Components$ResourceFilter$multi
													]),
												model.eV)),
										A2(
											$elm$core$List$map,
											$elm$html$Html$map($author$project$Components$Admin$PartnerApp$Team$PracticeUserResourceFilterMsg),
											$author$project$Components$ResourceFilter$PracticeUser$viewMultiSelected(model.eV))));
							}
						}(),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						])),
					function () {
					if ($elm$core$List$isEmpty(roles)) {
						return $author$project$Utils$Html$empty;
					} else {
						var fields = $author$project$Utils$Form$fields(form);
						return A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$labelSpan(4),
									$author$project$Ui$Form$Group$inputSpan(8),
									$author$project$Ui$Form$Group$required(true),
									$author$project$Ui$Form$Group$label('Role')
								]),
							_List_fromArray(
								[
									$author$project$Components$Admin$PartnerApp$RoleSelect$view(
									{
										agN: 'Pick a role',
										ajd: A2($elm$core$Basics$composeL, $author$project$Components$Admin$PartnerApp$Team$FormUpdated, $author$project$Components$Admin$PartnerApp$Team$PartnerRole),
										ak4: roles,
										aee: fields.g6
									}),
									$author$project$Utils$FormErrors$view(
									A2($author$project$Utils$Form$validationErrors, 1, form))
								]));
					}
				}()
				]));
	});
var $author$project$Components$Admin$PartnerApp$Team$modal = function (_v0) {
	var model = _v0;
	return _List_fromArray(
		[
			function () {
			var _v1 = model.I;
			if (!_v1.$) {
				var _v2 = _v1.a;
				var teamMember = _v2.a;
				var form = _v2.b;
				var request = _v2.c;
				return A4($author$project$Components$Admin$PartnerApp$Team$viewTeamMemberModal, model, teamMember, request, form);
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			function () {
			var _v3 = model.nf;
			if (!_v3.$) {
				var teamMember = _v3.a;
				return A2(
					$author$project$Components$HiConfirm$modal,
					$author$project$Components$Admin$PartnerApp$Team$DeleteConfirmClosed(
						$author$project$Api$Provider$PartnerAppUser$All$id(teamMember)),
					_List_fromArray(
						[
							$author$project$Components$HiConfirm$verb('remove'),
							$author$project$Components$HiConfirm$noun('team member'),
							$author$project$Components$HiConfirm$detail(
							$author$project$Api$Provider$PartnerAppUser$All$email(teamMember))
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}()
		]);
};
var $author$project$Components$Admin$PartnerApp$Team$AddTeamMember = {$: 4};
var $author$project$Components$Admin$PartnerApp$Team$PaginationMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$PartnerApp$Team$SortTable = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$PartnerApp$Team$columns = function (partnerApp) {
	return A2(
		$elm$core$List$cons,
		A3($author$project$Api$Column$init, 'user_first_name', true, 'Name'),
		A2(
			$elm$core$List$cons,
			A3($author$project$Api$Column$init, 'email', false, 'Email'),
			$elm$core$List$isEmpty(
				$author$project$Api$Common$PartnerApp$Shared$partnerRoleNames(partnerApp)) ? _List_Nil : _List_fromArray(
				[
					A3($author$project$Api$Column$init, 'custom_partner_role', false, 'Partner Role')
				])));
};
var $author$project$Components$Admin$PartnerApp$Team$AutoGrantChanged = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Admin$PartnerApp$Team$DefaultPartnerAppAdminRoleChanged = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Admin$PartnerApp$Team$DefaultPartnerAppNonAdminRoleChanged = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Admin$PartnerApp$Team$SaveSettings = {$: 18};
var $author$project$Components$Admin$PartnerApp$Team$viewSettings = function (model) {
	var settingsLoading = _Utils_eq(model.p_, $author$project$Api$Data$Loading);
	var roles = $author$project$Api$Common$PartnerApp$Shared$partnerRoles(model.YP);
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Access Settings')
					])),
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				A2(
					$elm$core$List$cons,
					A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpan(6),
								$author$project$Ui$Form$Group$inputSpan(6),
								$author$project$Ui$Form$Group$label('Automatically grant access to new team members')
							]),
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$view(
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$on(model.bi.ae2),
										$author$project$Ui$ToggleSwitch$onChange($author$project$Components$Admin$PartnerApp$Team$AutoGrantChanged)
									]))
							])),
					(model.bi.ae2 && (!$elm$core$List$isEmpty(roles))) ? _List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$labelSpan(6),
									$author$project$Ui$Form$Group$inputSpan(6),
									$author$project$Ui$Form$Group$label('Default role for practice admins')
								]),
							_List_fromArray(
								[
									$author$project$Components$Admin$PartnerApp$RoleSelect$view(
									{agN: 'No access', ajd: $author$project$Components$Admin$PartnerApp$Team$DefaultPartnerAppAdminRoleChanged, ak4: roles, aee: model.bi.agj})
								])),
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$labelSpan(6),
									$author$project$Ui$Form$Group$inputSpan(6),
									$author$project$Ui$Form$Group$label('Default role for non-admin users')
								]),
							_List_fromArray(
								[
									$author$project$Components$Admin$PartnerApp$RoleSelect$view(
									{agN: 'No access', ajd: $author$project$Components$Admin$PartnerApp$Team$DefaultPartnerAppNonAdminRoleChanged, ak4: roles, aee: model.bi.agk})
								]))
						]) : _List_Nil)),
				A2(
				$author$project$Ui$Panel$footer,
				_List_fromArray(
					[$author$project$Ui$Element$justifyCenter]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Save access settings'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$loading(settingsLoading),
								$author$project$Ui$Button$onClick($author$project$Components$Admin$PartnerApp$Team$SaveSettings)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Save')
							]))
					]))
			]));
};
var $author$project$Components$Admin$PartnerApp$Team$EditTeamMember = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Admin$PartnerApp$Team$OpenDeleteConfirm = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Admin$PartnerApp$Team$viewTeamMember = F4(
	function (currentUser, partnerApp, deletingTeamMembers, teamMember) {
		var isCurrentUser = _Utils_eq(
			$author$project$Api$Provider$PartnerAppUser$All$email(teamMember),
			$author$project$Api$Platform$User$Shared$email(currentUser));
		var rowOptions = isCurrentUser ? _List_fromArray(
			[
				$author$project$Ui$Table$styled(1)
			]) : _List_Nil;
		var id = $author$project$Api$Provider$PartnerAppUser$All$id(teamMember);
		var loading = A2($elm$core$Set$member, id, deletingTeamMembers);
		return A2(
			$author$project$Ui$Table$row,
			rowOptions,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										A2(
											$elm$core$Maybe$map,
											$author$project$Api$Provider$User$One$name,
											$author$project$Api$Provider$PracticeUser$Shared$user(
												$author$project$Api$Provider$PartnerAppUser$All$practiceUser(teamMember)))))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$PartnerAppUser$All$email(teamMember))
								]))
						]),
						$elm$core$List$isEmpty(
						$author$project$Api$Common$PartnerApp$Shared$partnerRoleNames(partnerApp)) ? _List_Nil : _List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										A2(
											$elm$core$Maybe$map,
											A2($elm$core$Basics$composeR, $author$project$Formatters$String$humanize, $author$project$Formatters$String$titleize),
											$elm$core$List$head(
												$author$project$Api$Provider$PartnerAppUser$All$partnerRoles(teamMember)))))
								]))
						]),
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_fromArray(
								[$author$project$Ui$Table$textRight]),
							_List_fromArray(
								[
									$elm$core$List$isEmpty(
									$author$project$Api$Common$PartnerApp$Shared$partnerRoleNames(partnerApp)) ? $author$project$Utils$Html$empty : A3(
									$author$project$Ui$Button$view,
									{mm: 'Edit team member'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$disabled(
											loading || (!$author$project$Api$Platform$User$Shared$isAdmin(currentUser))),
											$author$project$Ui$Button$onClick(
											$author$project$Components$Admin$PartnerApp$Team$EditTeamMember(teamMember)),
											$author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit')
										])),
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Delete team member'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$loading(loading),
											$author$project$Ui$Button$onClick(
											$author$project$Components$Admin$PartnerApp$Team$OpenDeleteConfirm(teamMember)),
											$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Delete')
										]))
								]))
						])
					])));
	});
var $author$project$Components$Admin$PartnerApp$Team$view = function (_v0) {
	var model = _v0;
	var _v1 = function () {
		var _v2 = model.fm;
		if (_v2.$ === 3) {
			var teamMembers_ = _v2.a;
			return _Utils_Tuple2(false, teamMembers_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v1.a;
	var teamMembers = _v1.b;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Components$Admin$PartnerApp$Team$viewSettings(model),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$gap2]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$fullWidth]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Components$Admin$PartnerApp$Team$SearchInputMsg,
												A2($author$project$Ui$SearchInput$view, _List_Nil, model.up))
											])),
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Add user'},
										_List_fromArray(
											[
												$author$project$Ui$Button$icon($author$project$Ui$Icon$add),
												$author$project$Ui$Button$onClick($author$project$Components$Admin$PartnerApp$Team$AddTeamMember)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Add User')
											]))
									]))
							])),
						A4(
						$author$project$Ui$Panel$table,
						_List_fromArray(
							[
								$author$project$Ui$Table$verticalCentered,
								$author$project$Ui$Table$zeroState(
								_List_fromArray(
									[
										$elm$html$Html$text('No users are allowed to access this integration.')
									])),
								$author$project$Ui$Table$loading(loading)
							]),
						$elm$core$List$concat(
							_List_fromArray(
								[
									A2(
									$elm$core$List$map,
									$author$project$Api$Column$view(
										A2($author$project$Api$Column$Sortable, model.alA, $author$project$Components$Admin$PartnerApp$Team$SortTable)),
									$author$project$Components$Admin$PartnerApp$Team$columns(model.YP)),
									_List_fromArray(
									[
										A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
									])
								])),
						A2(
							$elm$core$List$map,
							A3($author$project$Components$Admin$PartnerApp$Team$viewTeamMember, model.Hd, model.YP, model.eo),
							teamMembers),
						_List_Nil),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$Admin$PartnerApp$Team$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(
											!$author$project$Api$Data$isSuccess(model.fm))
										]),
									model.ajJ))
							]))
					]))
			]));
};
var $author$project$Pages$Marketplace$Slug_String$Manage$Users$viewBody = function (model) {
	var _v0 = model.kx;
	if (!_v0.$) {
		var partnerAppTeam = _v0.a;
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				$elm$html$Html$map($author$project$Pages$Marketplace$Slug_String$Manage$Users$PartnerAppTeamMsg),
				$author$project$Components$Admin$PartnerApp$Team$modal(partnerAppTeam)),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Pages$Marketplace$Slug_String$Manage$Users$PartnerAppTeamMsg,
					$author$project$Components$Admin$PartnerApp$Team$view(partnerAppTeam))
				]));
	} else {
		var _v1 = model.T8;
		if (_v1.$ === 1) {
			return _List_fromArray(
				[
					$author$project$Ui$Spinner$view(_List_Nil)
				]);
		} else {
			return _List_Nil;
		}
	}
};
var $author$project$Pages$Marketplace$Slug_String$Manage$Users$view = function (model) {
	return {
		fO: $author$project$Pages$Marketplace$Slug_String$Manage$Users$viewBody(model),
		ac9: 'Manage Users'
	};
};
var $author$project$Pages$Marketplace$Slug_String$Manage$Users$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Marketplace$Slug_String$Manage$Users$init, aiq: $author$project$Pages$Marketplace$Slug_String$Manage$Users$load, k8: $author$project$Pages$Marketplace$Slug_String$Manage$Users$save, alO: $author$project$Pages$Marketplace$Slug_String$Manage$Users$subscriptions, adT: $author$project$Pages$Marketplace$Slug_String$Manage$Users$update, amo: $author$project$Pages$Marketplace$Slug_String$Manage$Users$view});
var $author$project$Pages$Marketplace$Top$CategoryDropdownMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Marketplace$Top$GotCategories = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Platform$Marketplace$ProductCategory$productCategoriesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['marketplace', 'product_categories']),
	$author$project$Api$Data$platformPath);
var $author$project$Api$Platform$Marketplace$ProductCategory$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Common$Marketplace$Product$Category$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Platform$Marketplace$ProductCategory$productCategoriesPath));
	});
var $author$project$Pages$Marketplace$Top$productTypeFromQuery = function (queryString) {
	_v0$3:
	while (true) {
		if (!queryString.$) {
			switch (queryString.a) {
				case 'app':
					return $elm$core$Maybe$Just(0);
				case 'integration':
					return $elm$core$Maybe$Just(1);
				case 'solution':
					return $elm$core$Maybe$Just(2);
				default:
					break _v0$3;
			}
		} else {
			break _v0$3;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Pages$Marketplace$Top$init = F3(
	function (session, shared, _v0) {
		var query = _v0.DE;
		var selectedCategories = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$elm$core$String$split(','),
				A2($elm$core$Dict$get, 'category', query)));
		var q = A2($elm$core$Dict$get, 'q', query);
		var productTypeQuery = A2($elm$core$Dict$get, 'type', query);
		var productType = $author$project$Pages$Marketplace$Top$productTypeFromQuery(productTypeQuery);
		return _Utils_Tuple2(
			{
				Gv: shared.Gv,
				Nr: $author$project$Api$Data$Loading,
				mI: $author$project$Ui$Dropdown$init(
					$author$project$Ui$Dropdown$defaultConfig(
						{ahP: 'category-dropdown', al6: $author$project$Pages$Marketplace$Top$CategoryDropdownMsg})),
				H$: false,
				Ij: $author$project$Shared$isHintAdmin(shared),
				Jo: productType,
				akl: q,
				up: $author$project$Ui$SearchInput$init(q),
				cS: selectedCategories,
				aa4: session
			},
			A2($author$project$Api$Platform$Marketplace$ProductCategory$list, shared.Gv, $author$project$Pages$Marketplace$Top$GotCategories));
	});
var $author$project$Pages$Marketplace$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Marketplace$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Marketplace$Top$subscriptions = function (model) {
	return $author$project$Ui$Dropdown$subscriptions(model.mI);
};
var $author$project$Pages$Marketplace$Top$SearchInputMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Marketplace$Top$productTypeToValue = function (productType) {
	switch (productType) {
		case 0:
			return 'app';
		case 1:
			return 'integration';
		default:
			return 'solution';
	}
};
var $author$project$Pages$Marketplace$Top$updateUrl = function (model) {
	var categoryParam = $elm$core$List$isEmpty(model.cS) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		A2(
			$elm$url$Url$Builder$string,
			'category',
			A2($elm$core$String$join, ',', model.cS)));
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('q'),
			model.akl),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Pages$Marketplace$Top$productTypeToValue,
				$elm$url$Url$Builder$string('type')),
			model.Jo),
			categoryParam
		]);
	return $author$project$Ports$Navigation$replaceUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Marketplace__Top)
				]),
			A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)));
};
var $author$project$Pages$Marketplace$Top$andUpdateUrl = function (_v0) {
	var model = _v0.a;
	var cmd = _v0.b;
	var outMsgs = _v0.c;
	return _Utils_Tuple3(
		model,
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					cmd,
					$author$project$Pages$Marketplace$Top$updateUrl(model)
				])),
		outMsgs);
};
var $author$project$Pages$Marketplace$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Ui$SearchInput$update, subMsg, model.up);
				var searchInput = _v1.a;
				var searchInputCmd = _v1.b;
				var searchInputEvent = _v1.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.akl;
					}
				}();
				return $author$project$Pages$Marketplace$Top$andUpdateUrl(
					_Utils_Tuple3(
						_Utils_update(
							model,
							{akl: q, up: searchInput}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Marketplace$Top$SearchInputMsg, searchInputCmd),
						_List_Nil));
			case 1:
				var productType = msg.a;
				return $author$project$Pages$Marketplace$Top$andUpdateUrl(
					_Utils_Tuple3(
						_Utils_update(
							model,
							{Jo: productType}),
						$elm$core$Platform$Cmd$none,
						_List_Nil));
			case 2:
				var dropdownMsg = msg.a;
				var _v3 = A2($author$project$Ui$Dropdown$update, dropdownMsg, model.mI);
				var categoryDropdown = _v3.a;
				var dropdownCmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{mI: categoryDropdown}),
					dropdownCmd,
					_List_Nil);
			case 3:
				var category = msg.a;
				var checked = msg.b;
				var selectedCategories = checked ? A2($elm$core$List$cons, category, model.cS) : A2(
					$elm$core$List$filter,
					$elm$core$Basics$neq(category),
					model.cS);
				return $author$project$Pages$Marketplace$Top$andUpdateUrl(
					_Utils_Tuple3(
						_Utils_update(
							model,
							{cS: selectedCategories}),
						$elm$core$Platform$Cmd$none,
						_List_Nil));
			case 4:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Nr: response}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var hinterMode = msg.a;
				var newModel = _Utils_update(
					model,
					{H$: hinterMode});
				return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Pages$Marketplace$Top$HinterModeToggled = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Marketplace$Top$categoriesToLabel = function (selectedCategories) {
	if (!selectedCategories.b) {
		return 'Categories';
	} else {
		if (!selectedCategories.b.b) {
			var single = selectedCategories.a;
			return single;
		} else {
			var multiple = selectedCategories;
			return 'Categories (' + ($elm$core$String$fromInt(
				$elm$core$List$length(multiple)) + ')');
		}
	}
};
var $author$project$Pages$Marketplace$Top$CategoryToggled = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Marketplace$Top$categoryItems = F2(
	function (selectedCategories, categories) {
		return A2(
			$elm$core$List$map,
			function (cat) {
				var categoryName = $author$project$Api$Common$Marketplace$Product$Category$name(cat);
				var isChecked = A2($elm$core$List$member, categoryName, selectedCategories);
				return A2(
					$author$project$Ui$Dropdown$checkbox,
					_List_fromArray(
						[
							$author$project$Ui$Dropdown$onCheck(
							$author$project$Pages$Marketplace$Top$CategoryToggled(categoryName)),
							$author$project$Ui$Dropdown$checked(isChecked)
						]),
					$elm$html$Html$text(categoryName));
			},
			categories);
	});
var $author$project$Pages$Marketplace$Top$viewBody = function (model) {
	var isPartner = $author$project$Api$Platform$Session$One$organizationIsPartner(model.aa4);
	var categoryAttribute = $elm$core$List$isEmpty(model.cS) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$attribute,
			'category',
			A2($elm$core$String$join, ',', model.cS)));
	var attributes = A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$map,
				$elm$html$Html$Attributes$attribute('q'),
				model.akl),
				A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Pages$Marketplace$Top$productTypeToValue,
					$elm$html$Html$Attributes$attribute('type')),
				model.Jo),
				categoryAttribute,
				$elm$core$Maybe$Just(
				A2(
					$elm$html$Html$Attributes$attribute,
					'is-partner',
					$author$project$Utils$Bool$toString(isPartner))),
				$elm$core$Maybe$Just(
				A2(
					$elm$html$Html$Attributes$attribute,
					'hinter-mode',
					$author$project$Utils$Bool$toString(model.H$)))
			]));
	return A3($elm$html$Html$node, 'hint-marketplace', attributes, _List_Nil);
};
var $author$project$Pages$Marketplace$Top$ProductTypeSelected = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Element$Hidden = function (a) {
	return {$: 11, a: a};
};
var $author$project$Ui$Element$hidden = $author$project$Ui$Element$Hidden(0);
var $author$project$Ui$Element$inlineBlockMd = A2($author$project$Ui$Element$Display, 2, 1);
var $author$project$Pages$Marketplace$Top$viewProductTypeButtons = function (currentProductType) {
	return $author$project$Ui$Button$group(
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{mm: 'All Partners'},
				_List_fromArray(
					[
						$author$project$Ui$Button$active(
						_Utils_eq(currentProductType, $elm$core$Maybe$Nothing)),
						$author$project$Ui$Button$onClick(
						$author$project$Pages$Marketplace$Top$ProductTypeSelected($elm$core$Maybe$Nothing))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('All'),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$hidden, $author$project$Ui$Element$inlineBlockMd, $author$project$Ui$Element$ml1]),
						_List_fromArray(
							[
								$elm$html$Html$text('Partners')
							]))
					])),
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Apps'},
				_List_fromArray(
					[
						$author$project$Ui$Button$active(
						_Utils_eq(
							currentProductType,
							$elm$core$Maybe$Just(0))),
						$author$project$Ui$Button$onClick(
						$author$project$Pages$Marketplace$Top$ProductTypeSelected(
							$elm$core$Maybe$Just(0)))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Apps')
					])),
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Integrations'},
				_List_fromArray(
					[
						$author$project$Ui$Button$active(
						_Utils_eq(
							currentProductType,
							$elm$core$Maybe$Just(1))),
						$author$project$Ui$Button$onClick(
						$author$project$Pages$Marketplace$Top$ProductTypeSelected(
							$elm$core$Maybe$Just(1)))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Integrations')
					])),
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Solutions'},
				_List_fromArray(
					[
						$author$project$Ui$Button$active(
						_Utils_eq(
							currentProductType,
							$elm$core$Maybe$Just(2))),
						$author$project$Ui$Button$onClick(
						$author$project$Pages$Marketplace$Top$ProductTypeSelected(
							$elm$core$Maybe$Just(2)))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Solutions')
					]))
			]));
};
var $author$project$Pages$Marketplace$Top$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A3(
				$author$project$Ui$Element$custom,
				'layout-header',
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
						_List_fromArray(
							[
								$author$project$Ui$Typography$heading(
								_List_fromArray(
									[
										$elm$html$Html$text('Marketplace')
									])),
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap2]),
								_List_fromArray(
									[
										model.Ij ? A3(
										$author$project$Ui$HinterOnly$button,
										{mm: 'Admin Mode'},
										_List_fromArray(
											[
												$author$project$Ui$Button$onClick(
												$author$project$Pages$Marketplace$Top$HinterModeToggled(!model.H$)),
												$author$project$Ui$Button$active(model.H$),
												$author$project$Ui$Button$secondary
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Admin Mode')
											])) : $author$project$Utils$Html$empty,
										$author$project$Api$Platform$Session$One$organizationIsPartner(model.aa4) ? $author$project$Utils$Html$empty : A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Marketplace__Manage,
										_List_fromArray(
											[$author$project$Ui$Link$buttonDefault]),
										_List_fromArray(
											[
												$elm$html$Html$text('Manage partners')
											]))
									]))
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$mt2, $author$project$Ui$Element$mb4]),
						_List_fromArray(
							[
								$elm$html$Html$text('Discover apps, integrations and solutions to extend your Hint experience')
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$row,
								_List_fromArray(
									[$author$project$Ui$Grid$mb4]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$spanSm(4),
												$author$project$Ui$Grid$spanLg(6)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Pages$Marketplace$Top$SearchInputMsg,
												A2(
													$author$project$Ui$SearchInput$view,
													_List_fromArray(
														[
															$author$project$Ui$SearchInput$placeholder('Search Partners...'),
															$author$project$Ui$SearchInput$immediate
														]),
													model.up))
											])),
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$spanSm(8),
												$author$project$Ui$Grid$spanLg(6)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$gap2, $author$project$Ui$Element$flex]),
												_List_fromArray(
													[
														$author$project$Pages$Marketplace$Top$viewProductTypeButtons(model.Jo),
														function () {
														var _v0 = model.Nr;
														if (_v0.$ === 3) {
															var categories = _v0.a;
															return A2(
																$author$project$Ui$Element$view,
																_List_fromArray(
																	[$author$project$Ui$Element$flexAuto]),
																_List_fromArray(
																	[
																		A4(
																		$author$project$Ui$Dropdown$viewSelect,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$elm$html$Html$text(
																				$author$project$Pages$Marketplace$Top$categoriesToLabel(model.cS))
																			]),
																		A2($author$project$Pages$Marketplace$Top$categoryItems, model.cS, categories),
																		model.mI)
																	]));
														} else {
															return $author$project$Utils$Html$empty;
														}
													}()
													]))
											]))
									]))
							]))
					])),
				$author$project$Pages$Marketplace$Top$viewBody(model)
			]),
		ac9: 'Marketplace'
	};
};
var $author$project$Pages$Marketplace$Top$page = $author$project$Spa$Page$applicationPrivate(
	{ah_: $author$project$Pages$Marketplace$Top$init, aiq: $author$project$Pages$Marketplace$Top$load, k8: $author$project$Pages$Marketplace$Top$save, alO: $author$project$Pages$Marketplace$Top$subscriptions, adT: $author$project$Pages$Marketplace$Top$update, amo: $author$project$Pages$Marketplace$Top$view});
var $author$project$Pages$Messages$Calls$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Calls$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Calls$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Messages$Calls$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Phone Calls'};
};
var $author$project$Pages$Messages$Calls$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$Messages$Calls$init,
		aiq: $author$project$Pages$Messages$Calls$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$Messages$Calls$update,
		amo: $author$project$Pages$Messages$Calls$view
	});
var $author$project$Pages$Messages$Chat$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Chat$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Chat$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Messages$Chat$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Messages'};
};
var $author$project$Pages$Messages$Chat$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$Messages$Chat$init,
		aiq: $author$project$Pages$Messages$Chat$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$Messages$Chat$update,
		amo: $author$project$Pages$Messages$Chat$view
	});
var $author$project$Pages$Messages$Drafts$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Drafts$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Drafts$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Messages$Drafts$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'My Drafts'};
};
var $author$project$Pages$Messages$Drafts$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$Messages$Drafts$init,
		aiq: $author$project$Pages$Messages$Drafts$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$Messages$Drafts$update,
		amo: $author$project$Pages$Messages$Drafts$view
	});
var $author$project$Pages$Messages$Fax$New$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Fax$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Fax$New$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Messages$Fax$New$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Inbox'};
};
var $author$project$Pages$Messages$Fax$New$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$Messages$Fax$New$init,
		aiq: $author$project$Pages$Messages$Fax$New$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$Messages$Fax$New$update,
		amo: $author$project$Pages$Messages$Fax$New$view
	});
var $author$project$Pages$Messages$Faxes$MessageId_String$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Faxes$MessageId_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Faxes$MessageId_String$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Messages$Faxes$MessageId_String$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Inbox'};
};
var $author$project$Pages$Messages$Faxes$MessageId_String$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$Messages$Faxes$MessageId_String$init,
		aiq: $author$project$Pages$Messages$Faxes$MessageId_String$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$Messages$Faxes$MessageId_String$update,
		amo: $author$project$Pages$Messages$Faxes$MessageId_String$view
	});
var $author$project$Pages$Messages$Faxes$New$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Faxes$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Faxes$New$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Messages$Faxes$New$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'New Fax'};
};
var $author$project$Pages$Messages$Faxes$New$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$Messages$Faxes$New$init,
		aiq: $author$project$Pages$Messages$Faxes$New$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$Messages$Faxes$New$update,
		amo: $author$project$Pages$Messages$Faxes$New$view
	});
var $author$project$Pages$Messages$Faxes$Top$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Faxes$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Faxes$Top$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Messages$Faxes$Top$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Faxes'};
};
var $author$project$Pages$Messages$Faxes$Top$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$Messages$Faxes$Top$init,
		aiq: $author$project$Pages$Messages$Faxes$Top$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$Messages$Faxes$Top$update,
		amo: $author$project$Pages$Messages$Faxes$Top$view
	});
var $author$project$Pages$Messages$Forms$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Forms$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Forms$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Messages$Forms$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Forms'};
};
var $author$project$Pages$Messages$Forms$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$Messages$Forms$init,
		aiq: $author$project$Pages$Messages$Forms$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$Messages$Forms$update,
		amo: $author$project$Pages$Messages$Forms$view
	});
var $author$project$Pages$Messages$Inbox$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Inbox$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Inbox$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Messages$Inbox$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Inbox'};
};
var $author$project$Pages$Messages$Inbox$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$Messages$Inbox$init,
		aiq: $author$project$Pages$Messages$Inbox$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$Messages$Inbox$update,
		amo: $author$project$Pages$Messages$Inbox$view
	});
var $author$project$Pages$Messages$Labs$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Labs$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Labs$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Messages$Labs$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Lab Results'};
};
var $author$project$Pages$Messages$Labs$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$Messages$Labs$init,
		aiq: $author$project$Pages$Messages$Labs$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$Messages$Labs$update,
		amo: $author$project$Pages$Messages$Labs$view
	});
var $author$project$Pages$Messages$Legacy$Sms$PatientPhoneNumber_String$PracticePhoneNumber_String$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Legacy$Sms$PatientPhoneNumber_String$PracticePhoneNumber_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Legacy$Sms$PatientPhoneNumber_String$PracticePhoneNumber_String$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Messages$Legacy$Sms$PatientPhoneNumber_String$PracticePhoneNumber_String$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Inbox'};
};
var $author$project$Pages$Messages$Legacy$Sms$PatientPhoneNumber_String$PracticePhoneNumber_String$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$Messages$Legacy$Sms$PatientPhoneNumber_String$PracticePhoneNumber_String$init,
		aiq: $author$project$Pages$Messages$Legacy$Sms$PatientPhoneNumber_String$PracticePhoneNumber_String$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$Messages$Legacy$Sms$PatientPhoneNumber_String$PracticePhoneNumber_String$update,
		amo: $author$project$Pages$Messages$Legacy$Sms$PatientPhoneNumber_String$PracticePhoneNumber_String$view
	});
var $author$project$Pages$Messages$LegacyCalls$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$LegacyCalls$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$LegacyCalls$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Messages$LegacyCalls$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Inbox'};
};
var $author$project$Pages$Messages$LegacyCalls$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$Messages$LegacyCalls$init,
		aiq: $author$project$Pages$Messages$LegacyCalls$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$Messages$LegacyCalls$update,
		amo: $author$project$Pages$Messages$LegacyCalls$view
	});
var $author$project$Pages$Messages$Scheduled$New$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Scheduled$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Scheduled$New$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Messages$Scheduled$New$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'New Scheduled Event'};
};
var $author$project$Pages$Messages$Scheduled$New$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$Messages$Scheduled$New$init,
		aiq: $author$project$Pages$Messages$Scheduled$New$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$Messages$Scheduled$New$update,
		amo: $author$project$Pages$Messages$Scheduled$New$view
	});
var $author$project$Pages$Messages$Scheduled$ScheduledId_String$Top$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Scheduled$ScheduledId_String$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Scheduled$ScheduledId_String$Top$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Messages$Scheduled$ScheduledId_String$Top$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Edut Scheduled Event'};
};
var $author$project$Pages$Messages$Scheduled$ScheduledId_String$Top$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$Messages$Scheduled$ScheduledId_String$Top$init,
		aiq: $author$project$Pages$Messages$Scheduled$ScheduledId_String$Top$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$Messages$Scheduled$ScheduledId_String$Top$update,
		amo: $author$project$Pages$Messages$Scheduled$ScheduledId_String$Top$view
	});
var $author$project$Pages$Messages$Scheduled$Top$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Scheduled$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Scheduled$Top$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Messages$Scheduled$Top$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Scheduled'};
};
var $author$project$Pages$Messages$Scheduled$Top$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$Messages$Scheduled$Top$init,
		aiq: $author$project$Pages$Messages$Scheduled$Top$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$Messages$Scheduled$Top$update,
		amo: $author$project$Pages$Messages$Scheduled$Top$view
	});
var $author$project$Pages$Messages$ScheduledMessages$New$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$ScheduledMessages$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$ScheduledMessages$New$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Messages$ScheduledMessages$New$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'New Scheduled Message'};
};
var $author$project$Pages$Messages$ScheduledMessages$New$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$Messages$ScheduledMessages$New$init,
		aiq: $author$project$Pages$Messages$ScheduledMessages$New$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$Messages$ScheduledMessages$New$update,
		amo: $author$project$Pages$Messages$ScheduledMessages$New$view
	});
var $author$project$Pages$Messages$ScheduledMessages$ScheduledEventId_String$Top$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$ScheduledMessages$ScheduledEventId_String$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$ScheduledMessages$ScheduledEventId_String$Top$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Messages$ScheduledMessages$ScheduledEventId_String$Top$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Edit Scheduled Message'};
};
var $author$project$Pages$Messages$ScheduledMessages$ScheduledEventId_String$Top$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$Messages$ScheduledMessages$ScheduledEventId_String$Top$init,
		aiq: $author$project$Pages$Messages$ScheduledMessages$ScheduledEventId_String$Top$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$Messages$ScheduledMessages$ScheduledEventId_String$Top$update,
		amo: $author$project$Pages$Messages$ScheduledMessages$ScheduledEventId_String$Top$view
	});
var $author$project$Pages$Messages$Sms$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Sms$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Sms$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Messages$Sms$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Inbox'};
};
var $author$project$Pages$Messages$Sms$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$Messages$Sms$init,
		aiq: $author$project$Pages$Messages$Sms$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$Messages$Sms$update,
		amo: $author$project$Pages$Messages$Sms$view
	});
var $author$project$Pages$Messages$Sms$PhoneNumber_String$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Sms$PhoneNumber_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Sms$PhoneNumber_String$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Messages$Sms$PhoneNumber_String$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Inbox'};
};
var $author$project$Pages$Messages$Sms$PhoneNumber_String$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$Messages$Sms$PhoneNumber_String$init,
		aiq: $author$project$Pages$Messages$Sms$PhoneNumber_String$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$Messages$Sms$PhoneNumber_String$update,
		amo: $author$project$Pages$Messages$Sms$PhoneNumber_String$view
	});
var $author$project$Pages$Messages$Sms$PhoneNumber_String$PracticeNumber_String$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Sms$PhoneNumber_String$PracticeNumber_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Sms$PhoneNumber_String$PracticeNumber_String$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Messages$Sms$PhoneNumber_String$PracticeNumber_String$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Inbox'};
};
var $author$project$Pages$Messages$Sms$PhoneNumber_String$PracticeNumber_String$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$Messages$Sms$PhoneNumber_String$PracticeNumber_String$init,
		aiq: $author$project$Pages$Messages$Sms$PhoneNumber_String$PracticeNumber_String$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$Messages$Sms$PhoneNumber_String$PracticeNumber_String$update,
		amo: $author$project$Pages$Messages$Sms$PhoneNumber_String$PracticeNumber_String$view
	});
var $author$project$Pages$Messages$V2$Faxes$MessageId_String$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$V2$Faxes$MessageId_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$V2$Faxes$MessageId_String$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Messages$V2$Faxes$MessageId_String$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Inbox'};
};
var $author$project$Pages$Messages$V2$Faxes$MessageId_String$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$Messages$V2$Faxes$MessageId_String$init,
		aiq: $author$project$Pages$Messages$V2$Faxes$MessageId_String$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$Messages$V2$Faxes$MessageId_String$update,
		amo: $author$project$Pages$Messages$V2$Faxes$MessageId_String$view
	});
var $author$project$Pages$NewSettings$AppointmentTypes$Ident_String$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$AppointmentTypes$Ident_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$AppointmentTypes$Ident_String$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$NewSettings$AppointmentTypes$Ident_String$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Edit Appointment Type'};
};
var $author$project$Pages$NewSettings$AppointmentTypes$Ident_String$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$NewSettings$AppointmentTypes$Ident_String$init,
		aiq: $author$project$Pages$NewSettings$AppointmentTypes$Ident_String$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$NewSettings$AppointmentTypes$Ident_String$update,
		amo: $author$project$Pages$NewSettings$AppointmentTypes$Ident_String$view
	});
var $author$project$Pages$NewSettings$AppointmentTypes$New$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$AppointmentTypes$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$AppointmentTypes$New$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$NewSettings$AppointmentTypes$New$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'New Appointment Type'};
};
var $author$project$Pages$NewSettings$AppointmentTypes$New$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$NewSettings$AppointmentTypes$New$init,
		aiq: $author$project$Pages$NewSettings$AppointmentTypes$New$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$NewSettings$AppointmentTypes$New$update,
		amo: $author$project$Pages$NewSettings$AppointmentTypes$New$view
	});
var $author$project$Pages$NewSettings$AppointmentTypes$Top$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$AppointmentTypes$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$AppointmentTypes$Top$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$NewSettings$AppointmentTypes$Top$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Appointment Types'};
};
var $author$project$Pages$NewSettings$AppointmentTypes$Top$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$NewSettings$AppointmentTypes$Top$init,
		aiq: $author$project$Pages$NewSettings$AppointmentTypes$Top$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$NewSettings$AppointmentTypes$Top$update,
		amo: $author$project$Pages$NewSettings$AppointmentTypes$Top$view
	});
var $author$project$Pages$NewSettings$BlockedPhoneNumbers$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$BlockedPhoneNumbers$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$BlockedPhoneNumbers$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$NewSettings$BlockedPhoneNumbers$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Blocked Phone Numbers'};
};
var $author$project$Pages$NewSettings$BlockedPhoneNumbers$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$NewSettings$BlockedPhoneNumbers$init,
		aiq: $author$project$Pages$NewSettings$BlockedPhoneNumbers$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$NewSettings$BlockedPhoneNumbers$update,
		amo: $author$project$Pages$NewSettings$BlockedPhoneNumbers$view
	});
var $author$project$Pages$NewSettings$BookingOverview$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$BookingOverview$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$BookingOverview$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$NewSettings$BookingOverview$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Booking Overview'};
};
var $author$project$Pages$NewSettings$BookingOverview$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$NewSettings$BookingOverview$init,
		aiq: $author$project$Pages$NewSettings$BookingOverview$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$NewSettings$BookingOverview$update,
		amo: $author$project$Pages$NewSettings$BookingOverview$view
	});
var $author$project$Pages$NewSettings$Erx$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$Erx$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$Erx$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$NewSettings$Erx$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'eRx'};
};
var $author$project$Pages$NewSettings$Erx$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$NewSettings$Erx$init,
		aiq: $author$project$Pages$NewSettings$Erx$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$NewSettings$Erx$update,
		amo: $author$project$Pages$NewSettings$Erx$view
	});
var $author$project$Pages$NewSettings$Export$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$Export$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$Export$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$NewSettings$Export$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Export'};
};
var $author$project$Pages$NewSettings$Export$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$NewSettings$Export$init,
		aiq: $author$project$Pages$NewSettings$Export$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$NewSettings$Export$update,
		amo: $author$project$Pages$NewSettings$Export$view
	});
var $author$project$Pages$NewSettings$HinterSettings$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$HinterSettings$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$HinterSettings$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$NewSettings$HinterSettings$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Hinter Settings'};
};
var $author$project$Pages$NewSettings$HinterSettings$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$NewSettings$HinterSettings$init,
		aiq: $author$project$Pages$NewSettings$HinterSettings$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$NewSettings$HinterSettings$update,
		amo: $author$project$Pages$NewSettings$HinterSettings$view
	});
var $author$project$Pages$NewSettings$Locations$BookingLocationId_String$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$Locations$BookingLocationId_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$Locations$BookingLocationId_String$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$NewSettings$Locations$BookingLocationId_String$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Edit Location'};
};
var $author$project$Pages$NewSettings$Locations$BookingLocationId_String$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$NewSettings$Locations$BookingLocationId_String$init,
		aiq: $author$project$Pages$NewSettings$Locations$BookingLocationId_String$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$NewSettings$Locations$BookingLocationId_String$update,
		amo: $author$project$Pages$NewSettings$Locations$BookingLocationId_String$view
	});
var $author$project$Pages$NewSettings$Locations$New$LocationId_String$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$Locations$New$LocationId_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$Locations$New$LocationId_String$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$NewSettings$Locations$New$LocationId_String$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'New Location'};
};
var $author$project$Pages$NewSettings$Locations$New$LocationId_String$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$NewSettings$Locations$New$LocationId_String$init,
		aiq: $author$project$Pages$NewSettings$Locations$New$LocationId_String$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$NewSettings$Locations$New$LocationId_String$update,
		amo: $author$project$Pages$NewSettings$Locations$New$LocationId_String$view
	});
var $author$project$Pages$NewSettings$Locations$Top$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$Locations$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$Locations$Top$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$NewSettings$Locations$Top$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Calendar Locations'};
};
var $author$project$Pages$NewSettings$Locations$Top$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$NewSettings$Locations$Top$init,
		aiq: $author$project$Pages$NewSettings$Locations$Top$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$NewSettings$Locations$Top$update,
		amo: $author$project$Pages$NewSettings$Locations$Top$view
	});
var $author$project$Pages$NewSettings$PracticeInfo$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$PracticeInfo$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$PracticeInfo$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$NewSettings$PracticeInfo$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Practice Info'};
};
var $author$project$Pages$NewSettings$PracticeInfo$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$NewSettings$PracticeInfo$init,
		aiq: $author$project$Pages$NewSettings$PracticeInfo$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$NewSettings$PracticeInfo$update,
		amo: $author$project$Pages$NewSettings$PracticeInfo$view
	});
var $author$project$Pages$NewSettings$Team$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$Team$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$Team$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$NewSettings$Team$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Team'};
};
var $author$project$Pages$NewSettings$Team$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$NewSettings$Team$init,
		aiq: $author$project$Pages$NewSettings$Team$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$NewSettings$Team$update,
		amo: $author$project$Pages$NewSettings$Team$view
	});
var $author$project$Pages$NewSettings$Team$TeamId_String$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$Team$TeamId_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$Team$TeamId_String$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$NewSettings$Team$TeamId_String$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Team Member'};
};
var $author$project$Pages$NewSettings$Team$TeamId_String$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$NewSettings$Team$TeamId_String$init,
		aiq: $author$project$Pages$NewSettings$Team$TeamId_String$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$NewSettings$Team$TeamId_String$update,
		amo: $author$project$Pages$NewSettings$Team$TeamId_String$view
	});
var $author$project$Pages$NewSettings$Team$TeamId_String$AiSettings$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$Team$TeamId_String$AiSettings$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$Team$TeamId_String$AiSettings$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$NewSettings$Team$TeamId_String$AiSettings$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Team Member - AI Settings'};
};
var $author$project$Pages$NewSettings$Team$TeamId_String$AiSettings$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$NewSettings$Team$TeamId_String$AiSettings$init,
		aiq: $author$project$Pages$NewSettings$Team$TeamId_String$AiSettings$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$NewSettings$Team$TeamId_String$AiSettings$update,
		amo: $author$project$Pages$NewSettings$Team$TeamId_String$AiSettings$view
	});
var $author$project$Pages$NewSettings$Team$TeamId_String$BasicInfo$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$Team$TeamId_String$BasicInfo$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$Team$TeamId_String$BasicInfo$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$NewSettings$Team$TeamId_String$BasicInfo$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Team Member - Basic Info'};
};
var $author$project$Pages$NewSettings$Team$TeamId_String$BasicInfo$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$NewSettings$Team$TeamId_String$BasicInfo$init,
		aiq: $author$project$Pages$NewSettings$Team$TeamId_String$BasicInfo$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$NewSettings$Team$TeamId_String$BasicInfo$update,
		amo: $author$project$Pages$NewSettings$Team$TeamId_String$BasicInfo$view
	});
var $author$project$Pages$NewSettings$Team$TeamId_String$CalendarAndAvailability$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$Team$TeamId_String$CalendarAndAvailability$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$Team$TeamId_String$CalendarAndAvailability$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$NewSettings$Team$TeamId_String$CalendarAndAvailability$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Team Member - Calendar & Availability'};
};
var $author$project$Pages$NewSettings$Team$TeamId_String$CalendarAndAvailability$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$NewSettings$Team$TeamId_String$CalendarAndAvailability$init,
		aiq: $author$project$Pages$NewSettings$Team$TeamId_String$CalendarAndAvailability$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$NewSettings$Team$TeamId_String$CalendarAndAvailability$update,
		amo: $author$project$Pages$NewSettings$Team$TeamId_String$CalendarAndAvailability$view
	});
var $author$project$Pages$NewSettings$Templates$New$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$Templates$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$Templates$New$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$NewSettings$Templates$New$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'New Template'};
};
var $author$project$Pages$NewSettings$Templates$New$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$NewSettings$Templates$New$init,
		aiq: $author$project$Pages$NewSettings$Templates$New$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$NewSettings$Templates$New$update,
		amo: $author$project$Pages$NewSettings$Templates$New$view
	});
var $author$project$Pages$NewSettings$Templates$TemplateId_String$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$Templates$TemplateId_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$Templates$TemplateId_String$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$NewSettings$Templates$TemplateId_String$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Edit Template'};
};
var $author$project$Pages$NewSettings$Templates$TemplateId_String$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$NewSettings$Templates$TemplateId_String$init,
		aiq: $author$project$Pages$NewSettings$Templates$TemplateId_String$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$NewSettings$Templates$TemplateId_String$update,
		amo: $author$project$Pages$NewSettings$Templates$TemplateId_String$view
	});
var $author$project$Pages$NewSettings$Templates$Top$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$Templates$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$Templates$Top$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$NewSettings$Templates$Top$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Templates'};
};
var $author$project$Pages$NewSettings$Templates$Top$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$NewSettings$Templates$Top$init,
		aiq: $author$project$Pages$NewSettings$Templates$Top$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$NewSettings$Templates$Top$update,
		amo: $author$project$Pages$NewSettings$Templates$Top$view
	});
var $author$project$Pages$NotFound$init = F2(
	function (shared, _v0) {
		var route = function () {
			var _v1 = shared.aa4;
			if (_v1.$ === 3) {
				var session = _v1.a;
				return A2($author$project$Permission$homeStateFor, session, shared.ahK);
			} else {
				return $author$project$Spa$Generated$Route$Login;
			}
		}();
		return _Utils_Tuple3(
			{e: route, aey: shared.aey},
			$elm$core$Platform$Cmd$none,
			_List_Nil);
	});
var $author$project$Pages$NotFound$load = F2(
	function (shared, model) {
		var _v0 = _Utils_Tuple2(shared.aa4, shared.aey);
		if ((_v0.a.$ === 3) && (_v0.b.$ === 3)) {
			var _v1 = _v0.a;
			var session = _v1.a;
			var _v2 = _v0.b;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						e: A2($author$project$Permission$homeStateFor, session, shared.ahK),
						aey: shared.aey
					}),
				$elm$core$Platform$Cmd$none,
				_List_Nil);
		} else {
			return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Pages$NotFound$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$NotFound$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$NotFound$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Api$WhitelabelSetting$branded = function (_v0) {
	var record = _v0;
	return record.GK;
};
var $author$project$Ui$Icon$Hint404 = 31;
var $author$project$Ui$Icon$hint404 = $author$project$Ui$Icon$viewIcon(31);
var $author$project$Ui$Icon$SpacedBottom = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Icon$mb4 = $author$project$Ui$Icon$SpacedBottom(4);
var $author$project$Api$WhitelabelSetting$practiceFacingLogoUrl = function (_v0) {
	var record = _v0;
	return record.Jh;
};
var $author$project$Pages$NotFound$viewBody = F2(
	function (route, dataWhitelabelSetting) {
		var loading = function () {
			if (dataWhitelabelSetting.$ === 3) {
				return false;
			} else {
				return true;
			}
		}();
		var _v0 = function () {
			if (dataWhitelabelSetting.$ === 3) {
				var whitelabelSetting = dataWhitelabelSetting.a;
				return _Utils_Tuple2(
					$author$project$Api$WhitelabelSetting$branded(whitelabelSetting),
					$author$project$Api$WhitelabelSetting$practiceFacingLogoUrl(whitelabelSetting));
			} else {
				return _Utils_Tuple2(false, $elm$core$Maybe$Nothing);
			}
		}();
		var showCustomLogo = _v0.a;
		var imgUrl = _v0.b;
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$flexCol, $author$project$Ui$Element$mt8]),
				_List_fromArray(
					[
						loading ? $author$project$Ui$Skeleton$card(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$span(2)
							])) : (showCustomLogo ? A3(
						$author$project$Ui$Image$fromSrc,
						{LD: 'App Logo'},
						A2($elm$core$Maybe$withDefault, '', imgUrl),
						_List_Nil) : $author$project$Ui$Icon$hint404(
						_List_fromArray(
							[$author$project$Ui$Icon$mb4]))),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mb2]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('We couldn’t find this page...')
									]))
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$mb2]),
						_List_fromArray(
							[
								$elm$html$Html$text('Sorry, the page you’re looking for doesn’t exist or has been moved')
							])),
						A3(
						$author$project$Ui$Link$route,
						route,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Take me Home')
							]))
					]))
			]);
	});
var $author$project$Pages$NotFound$view = function (_v0) {
	var route = _v0.e;
	var whitelabelSetting = _v0.aey;
	return {
		fO: A2($author$project$Pages$NotFound$viewBody, route, whitelabelSetting),
		ac9: 'Page Not Found'
	};
};
var $author$project$Pages$NotFound$page = $author$project$Spa$Page$application(
	{ah_: $author$project$Pages$NotFound$init, aiq: $author$project$Pages$NotFound$load, k8: $author$project$Pages$NotFound$save, alO: $author$project$Pages$NotFound$subscriptions, adT: $author$project$Pages$NotFound$update, amo: $author$project$Pages$NotFound$view});
var $author$project$Pages$Oauth$Callback$init = F2(
	function (shared, _v0) {
		var query = _v0.DE;
		if ($elm$core$Dict$isEmpty(query)) {
			return _Utils_Tuple3(
				{},
				A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Login),
				_List_Nil);
		} else {
			var _v1 = shared.aa4;
			switch (_v1.$) {
				case 3:
					var session = _v1.a;
					return _Utils_Tuple3(
						{},
						A2(
							$author$project$Utils$Route$navigate,
							$elm$core$Dict$empty,
							A2($author$project$Permission$homeStateFor, session, shared.ahK)),
						_List_Nil);
				case 1:
					return _Utils_Tuple3(
						{},
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				default:
					return _Utils_Tuple3(
						{},
						$author$project$Ports$Session$authorize(
							{aku: true}),
						_List_Nil);
			}
		}
	});
var $author$project$Pages$Oauth$Callback$load = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Oauth$Callback$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Oauth$Callback$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Oauth$Callback$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Oauth$Callback$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Login'};
};
var $author$project$Pages$Oauth$Callback$page = $author$project$Spa$Page$application(
	{ah_: $author$project$Pages$Oauth$Callback$init, aiq: $author$project$Pages$Oauth$Callback$load, k8: $author$project$Pages$Oauth$Callback$save, alO: $author$project$Pages$Oauth$Callback$subscriptions, adT: $author$project$Pages$Oauth$Callback$update, amo: $author$project$Pages$Oauth$Callback$view});
var $author$project$Spa$Page$applicationOnlyPublic = function (page) {
	return {
		ah_: F2(
			function (shared, url) {
				var _v0 = shared.aa4;
				switch (_v0.$) {
					case 3:
						return A2(page.ah_, shared, url);
					case 0:
						var _v1 = A2(page.ah_, shared, url);
						var model = _v1.a;
						var cmd = _v1.b;
						var outMsgs = _v1.c;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										cmd,
										$author$project$Ports$Session$authorize(
										{aku: false})
									])),
							outMsgs);
					default:
						return A2(page.ah_, shared, url);
				}
			}),
		aiq: F2(
			function (shared, model) {
				return A2(page.aiq, shared, model);
			}),
		k8: page.k8,
		alO: page.alO,
		adT: page.adT,
		amo: page.amo
	};
};
var $author$project$Pages$Onboard$DealId_String$Top$GotPracticeOnboarding = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$OnboardingStepper$PracticeInfo = 0;
var $author$project$Components$OnboardingStepper$defaultStepId = 0;
var $author$project$Components$OnboardingStepper$InternalStep = F3(
	function (id, index, label) {
		return {ahP: id, sG: index, aih: label};
	});
var $elm_community$list_extra$List$Extra$findIndexHelp = F3(
	function (index, predicate, list) {
		findIndexHelp:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var x = list.a;
				var xs = list.b;
				if (predicate(x)) {
					return $elm$core$Maybe$Just(index);
				} else {
					var $temp$index = index + 1,
						$temp$predicate = predicate,
						$temp$list = xs;
					index = $temp$index;
					predicate = $temp$predicate;
					list = $temp$list;
					continue findIndexHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$findIndex = $elm_community$list_extra$List$Extra$findIndexHelp(0);
var $elm_community$list_extra$List$Extra$elemIndex = function (x) {
	return $elm_community$list_extra$List$Extra$findIndex(
		$elm$core$Basics$eq(x));
};
var $author$project$Components$OnboardingStepper$Completed = 3;
var $author$project$Components$OnboardingStepper$PaymentSetup = 2;
var $author$project$Components$OnboardingStepper$UserCreation = 1;
var $author$project$Components$OnboardingStepper$stepIds = _List_fromArray(
	[0, 1, 2, 3]);
var $author$project$Components$OnboardingStepper$stepIndex = function (stepId) {
	return A2(
		$elm$core$Maybe$withDefault,
		-1,
		A2($elm_community$list_extra$List$Extra$elemIndex, stepId, $author$project$Components$OnboardingStepper$stepIds));
};
var $author$project$Components$OnboardingStepper$stepLabel = function (stepId) {
	switch (stepId) {
		case 0:
			return 'Account Information';
		case 1:
			return 'Account Owner Setup';
		case 2:
			return 'Billing Setup';
		default:
			return '';
	}
};
var $author$project$Components$OnboardingStepper$buildInternalStep = function (stepId) {
	return A3(
		$author$project$Components$OnboardingStepper$InternalStep,
		stepId,
		$author$project$Components$OnboardingStepper$stepIndex(stepId),
		$author$project$Components$OnboardingStepper$stepLabel(stepId));
};
var $author$project$Components$OnboardingStepper$internalSteps = A2($elm$core$List$map, $author$project$Components$OnboardingStepper$buildInternalStep, $author$project$Components$OnboardingStepper$stepIds);
var $author$project$Components$OnboardingStepper$init = function (stepId) {
	return {
		Hc: $author$project$Components$OnboardingStepper$buildInternalStep(stepId),
		ach: $author$project$Components$OnboardingStepper$internalSteps
	};
};
var $author$project$Api$Provider$PracticeOnboarding$One$PracticeOnboarding = $elm$core$Basics$identity;
var $author$project$Api$Provider$PracticeOnboarding$One$Record = F5(
	function (ident, practiceName, step, emr, dealId) {
		return {agc: dealId, agO: emr, ahQ: ident, ZY: practiceName, acf: step};
	});
var $author$project$Api$Provider$PracticeOnboarding$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'deal_id',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'emr',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Practice$Emr$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'step',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'practice_name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'ident',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticeOnboarding$One$Record))))));
var $author$project$Api$Provider$PracticeOnboarding$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PracticeOnboarding$One$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PracticeOnboarding$retrieve = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$PracticeOnboarding$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$PracticeOnboarding$practiceOnboardingPath(id_)));
	});
var $author$project$Pages$Onboard$DealId_String$Top$init = F2(
	function (shared, _v0) {
		var params = _v0.YL;
		var stepperModel = $author$project$Components$OnboardingStepper$init($author$project$Components$OnboardingStepper$defaultStepId);
		var currentStep = stepperModel.Hc;
		return _Utils_Tuple3(
			{Hc: currentStep, agc: params.agc, kJ: $elm$core$Maybe$Nothing, ZZ: $author$project$Api$Data$NotAsked, lk: shared, acg: stepperModel},
			A3($author$project$Api$Provider$PracticeOnboarding$retrieve, shared.Gv, params.agc, $author$project$Pages$Onboard$DealId_String$Top$GotPracticeOnboarding),
			_List_Nil);
	});
var $author$project$Pages$Onboard$DealId_String$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Onboard$DealId_String$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Onboard$PracticeInfo$GotRecaptchaToken = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Onboard$DealId_String$Top$PracticeInfoMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Onboard$PracticeInfo$subscriptions = function (_v0) {
	var model = _v0;
	return $author$project$Ui$Dropdown$subscriptions(model.nw);
};
var $author$project$Pages$Onboard$DealId_String$Top$subscriptions = function (_v0) {
	var practiceForm = _v0.kJ;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ports$GoogleRecaptcha$gotRecaptchaToken(
				A2($elm$core$Basics$composeL, $author$project$Pages$Onboard$DealId_String$Top$PracticeInfoMsg, $author$project$Components$Onboard$PracticeInfo$GotRecaptchaToken)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Onboard$PracticeInfo$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Pages$Onboard$DealId_String$Top$PracticeInfoMsg)),
					practiceForm))
			]));
};
var $author$project$Pages$Onboard$DealId_String$Top$GotNewPracticeOnboarding = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$PracticeOnboarding$One$dealId = function (_v0) {
	var record = _v0;
	return record.agc;
};
var $author$project$Api$Provider$PracticeOnboarding$One$ident = function (_v0) {
	var record = _v0;
	return record.ahQ;
};
var $author$project$Components$Onboard$PracticeInfo$DateInputMsg = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Onboard$PracticeInfo$EmrDropdownMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Onboard$PracticeInfo$Model = $elm$core$Basics$identity;
var $author$project$Api$Provider$PracticeOnboarding$One$emr = function (_v0) {
	var record = _v0;
	return record.agO;
};
var $author$project$Api$Provider$PracticeOnboarding$One$practiceName = function (_v0) {
	var record = _v0;
	return record.ZY;
};
var $author$project$Components$Onboard$PracticeInfo$init = F3(
	function (dealId, shared, practiceOnboarding) {
		var emr = $author$project$Api$Provider$PracticeOnboarding$One$emr(practiceOnboarding);
		var _v0 = $author$project$Components$DateInput$init;
		var dateInput = _v0.a;
		var dateInputCmd = _v0.b;
		var inittedForm = $author$project$Utils$Form$init(
			{
				l8: $elm$core$Maybe$Nothing,
				rZ: dateInput,
				agc: dealId,
				agO: emr,
				agQ: $elm$core$Maybe$Nothing,
				VQ: $elm$core$Maybe$Nothing,
				Bq: $author$project$Api$Provider$PracticeOnboarding$One$practiceName(practiceOnboarding)
			});
		return _Utils_Tuple2(
			{
				nw: $author$project$Ui$Dropdown$init(
					$author$project$Ui$Dropdown$defaultConfig(
						{ahP: 'emr', al6: $author$project$Components$Onboard$PracticeInfo$EmrDropdownMsg})),
				SD: inittedForm,
				lk: shared,
				lA: false
			},
			A2(
				$elm$core$Platform$Cmd$map,
				$author$project$Components$Onboard$PracticeInfo$DateInputMsg(dateInput),
				dateInputCmd));
	});
var $author$project$Api$Provider$PracticeOnboarding$new = F3(
	function (apiClient, dealId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$PracticeOnboarding$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2($author$project$Api$Param$string, 'deal_id', dealId)
					]),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['new']),
						$author$project$Api$Provider$PracticeOnboarding$practiceOnboardingsPath))));
	});
var $author$project$Components$OnboardingStepper$redirectToLastStep = F2(
	function (step, onboardId) {
		switch (step) {
			case 0:
				return A2(
					$author$project$Utils$Route$navigate,
					$elm$core$Dict$empty,
					$author$project$Spa$Generated$Route$Onboard__OnboardId_String__User(
						{ajz: onboardId}));
			case 1:
				return A2(
					$author$project$Utils$Route$navigate,
					$elm$core$Dict$empty,
					$author$project$Spa$Generated$Route$Onboard__OnboardId_String__Payment(
						{ajz: onboardId}));
			case 2:
				return A2(
					$author$project$Utils$Route$navigate,
					$elm$core$Dict$empty,
					$author$project$Spa$Generated$Route$Onboard__OnboardId_String__Completing(
						{ajz: onboardId}));
			default:
				return A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Practice);
		}
	});
var $author$project$Api$Provider$PracticeOnboarding$One$step = function (_v0) {
	var record = _v0;
	return record.acf;
};
var $author$project$Components$OnboardingStepper$stepToType = function (string) {
	switch (string) {
		case 'practice_info':
			return 0;
		case 'user_creation':
			return 1;
		case 'payment_setup':
			return 2;
		case 'completed':
			return 3;
		default:
			return 0;
	}
};
var $author$project$Components$Onboard$PracticeInfo$Emr = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Onboard$PracticeInfo$EmrOther = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Onboard$PracticeInfo$LaunchDate = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Ports$GoogleRecaptcha$Onboard = 0;
var $author$project$Components$Onboard$PracticeInfo$PracticeOnboardingCreated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$PracticeOnboarding$create = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practice_onboarding',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'deal_id',
								$elm$json$Json$Encode$string(fields.agc)),
								_Utils_Tuple2(
								'emr',
								A2(
									$author$project$Utils$Encode$nullable,
									A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$Emr$toValue, $elm$json$Json$Encode$string),
									fields.agO)),
								_Utils_Tuple2(
								'estimated_memberships_count',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.agY)),
								_Utils_Tuple2(
								'launch_date',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.VQ)),
								_Utils_Tuple2(
								'practice_name',
								$elm$json$Json$Encode$string(fields.ZY))
							]))),
					_Utils_Tuple2(
					'google_recaptcha_token',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.aks))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$PracticeOnboarding$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$PracticeOnboarding$practiceOnboardingsPath)));
	});
var $author$project$Components$Onboard$PracticeInfo$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var name = field.a;
				return _Utils_update(
					fields,
					{Bq: name});
			case 3:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						l8: $elm$core$String$toInt(string)
					});
			case 1:
				var maybeEmr = field.a;
				return _Utils_update(
					fields,
					{agO: maybeEmr});
			case 2:
				var maybeString = field.a;
				return _Utils_update(
					fields,
					{agQ: maybeString});
			default:
				var dateInput = field.a;
				var date = field.b;
				return _Utils_update(
					fields,
					{rZ: dateInput, VQ: date});
		}
	});
var $author$project$Components$Onboard$PracticeInfo$ActiveMembersCountValidation = 1;
var $author$project$Components$Onboard$PracticeInfo$NameValidation = 0;
var $author$project$Components$Onboard$PracticeInfo$LaunchDateValidation = 2;
var $author$project$Components$Onboard$PracticeInfo$validateLaunchDate = function (fields) {
	var _v0 = fields.VQ;
	if (_v0.$ === 1) {
		return _List_fromArray(
			[
				_Utils_Tuple2(2, 'Please enter an estimated launch date.')
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Onboard$PracticeInfo$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.Bq;
			},
			_Utils_Tuple2(0, 'Please enter a practice name.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function (fields) {
				return A2(
					$elm$core$Maybe$withDefault,
					'',
					A2($elm$core$Maybe$map, $elm$core$String$fromInt, fields.l8));
			},
			_Utils_Tuple2(1, 'Please enter an active members count.')),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Onboard$PracticeInfo$validateLaunchDate)
		]));
var $author$project$Components$Onboard$PracticeInfo$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Onboard$PracticeInfo$formFieldsUpdate, field, model.SD);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: newForm}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$Onboard$PracticeInfo$formFieldsValidator, model.SD);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var validForm = _v3.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{SD: validForm, lA: true}),
						$author$project$Ports$GoogleRecaptcha$getRecaptchaToken(0),
						_List_Nil);
				} else {
					var erroredForm = _v2.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{SD: erroredForm}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 6:
				var result = msg.a;
				var recaptchaToken = $elm$core$Result$toMaybe(result);
				var fields = $author$project$Utils$Form$fields(model.SD);
				return _Utils_Tuple3(
					model,
					A3(
						$author$project$Api$Provider$PracticeOnboarding$create,
						model.lk.Gv,
						{agc: fields.agc, agO: fields.agO, agY: fields.l8, VQ: fields.VQ, ZY: fields.Bq, aks: recaptchaToken},
						$author$project$Components$Onboard$PracticeInfo$PracticeOnboardingCreated),
					_List_Nil);
			case 5:
				var response = msg.a;
				switch (response.$) {
					case 3:
						var practiceOnboarding = response.a;
						var onboardId = $author$project$Api$Provider$PracticeOnboarding$One$ident(practiceOnboarding);
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{lA: false}),
							A2(
								$author$project$Utils$Route$navigate,
								$elm$core$Dict$empty,
								$author$project$Spa$Generated$Route$Onboard__OnboardId_String__User(
									{ajz: onboardId})),
							_List_Nil);
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{lA: false}),
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error)),
								$author$project$OutMsg$reportDecodeError(response)));
					default:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{lA: false}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
				}
			case 1:
				var subMsg = msg.a;
				var _v5 = A2($author$project$Ui$Dropdown$update, subMsg, model.nw);
				var newDropdown = _v5.a;
				var cmd = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nw: newDropdown}),
					cmd,
					_List_Nil);
			case 2:
				var emrOption = msg.a;
				var newForm = function () {
					if (!emrOption.$) {
						var emr = emrOption.a;
						return A3(
							$author$project$Utils$Form$update,
							$author$project$Components$Onboard$PracticeInfo$formFieldsUpdate,
							$author$project$Components$Onboard$PracticeInfo$EmrOther($elm$core$Maybe$Nothing),
							A3(
								$author$project$Utils$Form$update,
								$author$project$Components$Onboard$PracticeInfo$formFieldsUpdate,
								$author$project$Components$Onboard$PracticeInfo$Emr(
									$elm$core$Maybe$Just(emr)),
								model.SD));
					} else {
						return A3(
							$author$project$Utils$Form$update,
							$author$project$Components$Onboard$PracticeInfo$formFieldsUpdate,
							$author$project$Components$Onboard$PracticeInfo$Emr($elm$core$Maybe$Nothing),
							model.SD);
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: newForm}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var dateInput = msg.a;
				var subMsg = msg.b;
				var _v7 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
				var newDateInput = _v7.a;
				var subCmd = _v7.b;
				var event = _v7.c;
				var newForm = function () {
					if (event.$ === 1) {
						var date = event.a;
						return A3(
							$author$project$Utils$Form$update,
							$author$project$Components$Onboard$PracticeInfo$formFieldsUpdate,
							A2($author$project$Components$Onboard$PracticeInfo$LaunchDate, newDateInput, date),
							model.SD);
					} else {
						var fields = $author$project$Utils$Form$fields(model.SD);
						return A3(
							$author$project$Utils$Form$update,
							$author$project$Components$Onboard$PracticeInfo$formFieldsUpdate,
							A2($author$project$Components$Onboard$PracticeInfo$LaunchDate, newDateInput, fields.VQ),
							model.SD);
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: newForm}),
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Components$Onboard$PracticeInfo$DateInputMsg(newDateInput),
						subCmd),
					_List_Nil);
		}
	});
var $author$project$Pages$Onboard$DealId_String$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = model.kJ;
				if (_v1.$ === 1) {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				} else {
					var practiceForm = _v1.a;
					var _v2 = A2($author$project$Components$Onboard$PracticeInfo$update, subMsg, practiceForm);
					var practiceInfoFormModel = _v2.a;
					var practiceInfoFormCmd = _v2.b;
					var practiceInfoMsg = _v2.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								kJ: $elm$core$Maybe$Just(practiceInfoFormModel)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Onboard$DealId_String$Top$PracticeInfoMsg, practiceInfoFormCmd),
						practiceInfoMsg);
				}
			case 1:
				var response = msg.a;
				switch (response.$) {
					case 3:
						var practiceOnboarding = response.a;
						var onboardId = $author$project$Api$Provider$PracticeOnboarding$One$ident(practiceOnboarding);
						var currentOnboardingStep = $author$project$Api$Provider$PracticeOnboarding$One$step(practiceOnboarding);
						var currentStepType = $author$project$Components$OnboardingStepper$stepToType(currentOnboardingStep);
						var stepperModel = $author$project$Components$OnboardingStepper$init(currentStepType);
						var currentStep = stepperModel.Hc;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{Hc: currentStep, ZZ: response}),
							A2($author$project$Components$OnboardingStepper$redirectToLastStep, currentStepType, onboardId),
							$author$project$OutMsg$handleErrorResponse(response));
					case 2:
						return _Utils_Tuple3(
							model,
							A3($author$project$Api$Provider$PracticeOnboarding$new, model.lk.Gv, model.agc, $author$project$Pages$Onboard$DealId_String$Top$GotNewPracticeOnboarding),
							_List_Nil);
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var practiceOnboarding = response.a;
					var stepperModel = $author$project$Components$OnboardingStepper$init($author$project$Components$OnboardingStepper$defaultStepId);
					var currentStep = stepperModel.Hc;
					var _v5 = A3(
						$author$project$Components$Onboard$PracticeInfo$init,
						$author$project$Api$Provider$PracticeOnboarding$One$dealId(practiceOnboarding),
						model.lk,
						practiceOnboarding);
					var practiceInfoFormModel = _v5.a;
					var practiceInfoFormCmd = _v5.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Hc: currentStep,
								kJ: $elm$core$Maybe$Just(practiceInfoFormModel)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Onboard$DealId_String$Top$PracticeInfoMsg, practiceInfoFormCmd),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Components$Onboard$PracticeInfo$FormSubmitted = {$: 4};
var $author$project$Components$Onboard$PracticeInfo$ActiveMembersCount = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Onboard$PracticeInfo$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Utils$Form$field = function (getter) {
	return A2($elm$core$Basics$composeR, $author$project$Utils$Form$fields, getter);
};
var $author$project$Components$Onboard$PracticeInfo$viewActiveMembersCount = function (form) {
	var activeMembersCount = A2(
		$author$project$Utils$Form$field,
		function ($) {
			return $.l8;
		},
		form);
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(12),
				$author$project$Ui$Form$Group$labelAbove,
				$author$project$Ui$Form$Group$label('How many active members do you currently have?'),
				$author$project$Ui$Form$Group$required(true),
				$author$project$Ui$Form$Group$test('active-members-count')
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$number,
						$author$project$Ui$Form$Input$value(
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2($elm$core$Maybe$map, $elm$core$String$fromInt, activeMembersCount))),
						$author$project$Ui$Form$Input$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Onboard$PracticeInfo$FormUpdated, $author$project$Components$Onboard$PracticeInfo$ActiveMembersCount)),
						$author$project$Ui$Form$Input$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
						$author$project$Ui$Form$Input$errors(
						A2($author$project$Utils$Form$validationErrors, 1, form))
					]))
			]));
};
var $author$project$Components$Onboard$PracticeInfo$EmrSelected = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$Practice$Emr$isHintClinical = function (_v0) {
	var option = _v0.ay;
	return !option;
};
var $author$project$Components$Onboard$PracticeInfo$emrIsHintClinical = function (emr) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2($elm$core$Maybe$map, $author$project$Api$Provider$Practice$Emr$isHintClinical, emr));
};
var $author$project$Components$Onboard$PracticeInfo$viewEmr = F2(
	function (form, emrDropdown) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(5),
					$author$project$Ui$Form$Group$labelAbove,
					$author$project$Ui$Form$Group$label('EMR')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_Nil,
							_List_fromArray(
								[
									function () {
									var emr = A2(
										$author$project$Utils$Form$field,
										function ($) {
											return $.agO;
										},
										form);
									var currentLabel = function () {
										if (!emr.$) {
											var emrValue = emr.a;
											return $author$project$Api$Provider$Practice$Emr$toLabel(emrValue);
										} else {
											return 'Select an EMR';
										}
									}();
									var availableOptions = $author$project$Components$Onboard$PracticeInfo$emrIsHintClinical(emr) ? $author$project$Api$Provider$Practice$Emr$options : A2(
										$elm$core$List$filter,
										function (emrOption) {
											return !$author$project$Api$Provider$Practice$Emr$isHintClinical(emrOption);
										},
										$author$project$Api$Provider$Practice$Emr$options);
									var items = A2(
										$elm$core$List$map,
										function (emrOption) {
											return A2(
												$author$project$Ui$Dropdown$item,
												_List_fromArray(
													[
														$author$project$Ui$Dropdown$onSelect(
														$author$project$Components$Onboard$PracticeInfo$EmrSelected(
															$elm$core$Maybe$Just(emrOption))),
														$author$project$Ui$Dropdown$selected(
														_Utils_eq(
															emr,
															$elm$core$Maybe$Just(emrOption)))
													]),
												$elm$html$Html$text(
													$author$project$Api$Provider$Practice$Emr$toLabel(emrOption)));
										},
										availableOptions);
									return A4(
										$author$project$Ui$Dropdown$viewSelect,
										_List_fromArray(
											[
												$author$project$Ui$Dropdown$disabled(
												$author$project$Components$Onboard$PracticeInfo$emrIsHintClinical(emr))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(currentLabel)
											]),
										items,
										emrDropdown);
								}()
								]))
						]))
				]));
	});
var $author$project$Components$Onboard$PracticeInfo$viewEmrOther = function (form) {
	var fields = $author$project$Utils$Form$fields(form);
	return _Utils_eq(
		A2($elm$core$Maybe$map, $author$project$Api$Provider$Practice$Emr$toOption, fields.agO),
		$elm$core$Maybe$Just(13)) ? A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(4),
				$author$project$Ui$Form$Group$label('')
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$value(
						A2($elm$core$Maybe$withDefault, '', fields.agQ)),
						$author$project$Ui$Form$Input$onInput(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Components$Onboard$PracticeInfo$FormUpdated, $author$project$Components$Onboard$PracticeInfo$EmrOther),
							$author$project$Utils$String$toMaybe))
					]))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Components$Onboard$PracticeInfo$viewInfoHeader = A2(
	$author$project$Ui$Element$view,
	_List_Nil,
	_List_fromArray(
		[
			$author$project$Ui$Typography$heading(
			_List_fromArray(
				[
					$elm$html$Html$text('Welcome to Hint!')
				])),
			A2(
			$author$project$Ui$Typography$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(' We\'re excited to walk you through setting up your account. This form should be completed by the business owner or an authorized delegate and should take you about 5 minutes.')
				]))
		]));
var $author$project$Components$Onboard$PracticeInfo$viewPracticeLaunchDate = function (form) {
	var fields = $author$project$Utils$Form$fields(form);
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(12),
				$author$project$Ui$Form$Group$labelAbove,
				$author$project$Ui$Form$Group$label('What is your estimated launch / go-live date?'),
				$author$project$Ui$Form$Group$required(true)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Onboard$PracticeInfo$DateInputMsg(fields.rZ),
				A2(
					$author$project$Components$DateInput$view,
					_List_fromArray(
						[
							$author$project$Components$DateInput$value(fields.VQ),
							$author$project$Components$DateInput$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
							$author$project$Components$DateInput$errors(
							A2($author$project$Utils$Form$validationErrors, 2, form))
						]),
					fields.rZ)),
				A2(
				$author$project$Ui$Typography$text,
				_List_fromArray(
					[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
				'This is when you can start billing patients through Hint.')
			]));
};
var $author$project$Components$Onboard$PracticeInfo$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Onboard$PracticeInfo$viewPracticeName = function (form) {
	var name = A2(
		$author$project$Utils$Form$field,
		function ($) {
			return $.Bq;
		},
		form);
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Practice Name'),
				$author$project$Ui$Form$Group$labelSpanSm(4),
				$author$project$Ui$Form$Group$labelAbove,
				$author$project$Ui$Form$Group$required(true)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$value(name),
						$author$project$Ui$Form$Input$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Onboard$PracticeInfo$FormUpdated, $author$project$Components$Onboard$PracticeInfo$Name)),
						$author$project$Ui$Form$Input$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
						$author$project$Ui$Form$Input$errors(
						A2($author$project$Utils$Form$validationErrors, 0, form))
					]))
			]));
};
var $author$project$Components$Onboard$PracticeInfo$viewForm = F3(
	function (form, emrDropdown, submitting) {
		return _List_fromArray(
			[
				$author$project$Components$Onboard$PracticeInfo$viewInfoHeader,
				$author$project$Components$Onboard$PracticeInfo$viewPracticeName(form),
				A2($author$project$Components$Onboard$PracticeInfo$viewEmr, form, emrDropdown),
				$author$project$Components$Onboard$PracticeInfo$viewEmrOther(form),
				$author$project$Components$Onboard$PracticeInfo$viewPracticeLaunchDate(form),
				$author$project$Components$Onboard$PracticeInfo$viewActiveMembersCount(form),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$textRight, $author$project$Ui$Element$mt4]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Submit pratice information'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$submit,
								$author$project$Ui$Button$loading(submitting)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Next')
							]))
					]))
			]);
	});
var $author$project$Components$Onboard$PracticeInfo$view = function (_v0) {
	var model = _v0;
	return A2(
		$author$project$Ui$Form$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$autocomplete(false),
				$author$project$Ui$Form$noValidate(true),
				$author$project$Ui$Form$onSubmit($author$project$Components$Onboard$PracticeInfo$FormSubmitted)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_fromArray(
					[$author$project$Ui$Panel$extraPadding]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						A3($author$project$Components$Onboard$PracticeInfo$viewForm, model.SD, model.nw, model.lA))
					]))
			]));
};
var $author$project$Pages$Onboard$DealId_String$Top$view = function (model) {
	return {
		fO: function () {
			var _v0 = model.kJ;
			if (_v0.$ === 1) {
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$justifyCenter]),
						_List_fromArray(
							[
								$author$project$Ui$Spinner$view(_List_Nil)
							]))
					]);
			} else {
				var practiceForm = _v0.a;
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Pages$Onboard$DealId_String$Top$PracticeInfoMsg,
						$author$project$Components$Onboard$PracticeInfo$view(practiceForm))
					]);
			}
		}(),
		ac9: 'Onboard'
	};
};
var $author$project$Pages$Onboard$DealId_String$Top$page = $author$project$Spa$Page$applicationOnlyPublic(
	{ah_: $author$project$Pages$Onboard$DealId_String$Top$init, aiq: $author$project$Pages$Onboard$DealId_String$Top$load, k8: $author$project$Pages$Onboard$DealId_String$Top$save, alO: $author$project$Pages$Onboard$DealId_String$Top$subscriptions, adT: $author$project$Pages$Onboard$DealId_String$Top$update, amo: $author$project$Pages$Onboard$DealId_String$Top$view});
var $author$project$Pages$Onboard$OnboardId_String$Completed$init = F2(
	function (_v0, _v1) {
		var params = _v1.YL;
		return _Utils_Tuple3(
			{ajz: params.ajz},
			A2($author$project$Utils$Route$navigateAndReload, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Account),
			_List_Nil);
	});
var $author$project$Pages$Onboard$OnboardId_String$Completed$load = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Onboard$OnboardId_String$Completed$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Onboard$OnboardId_String$Completed$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Onboard$OnboardId_String$Completed$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Onboard$OnboardId_String$Completed$view = function (_v0) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$textCenter]),
				_List_fromArray(
					[
						$author$project$Ui$Spinner$view(_List_Nil)
					]))
			]),
		ac9: 'Onboard'
	};
};
var $author$project$Pages$Onboard$OnboardId_String$Completed$page = $author$project$Spa$Page$applicationOnlyPublic(
	{ah_: $author$project$Pages$Onboard$OnboardId_String$Completed$init, aiq: $author$project$Pages$Onboard$OnboardId_String$Completed$load, k8: $author$project$Pages$Onboard$OnboardId_String$Completed$save, alO: $author$project$Pages$Onboard$OnboardId_String$Completed$subscriptions, adT: $author$project$Pages$Onboard$OnboardId_String$Completed$update, amo: $author$project$Pages$Onboard$OnboardId_String$Completed$view});
var $author$project$Pages$Onboard$OnboardId_String$Completing$PracticeOnboardingCompleted = $elm$core$Basics$identity;
var $author$project$Api$Provider$PracticeOnboarding$setupPractice = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['setup_practice']),
					$author$project$Api$Provider$PracticeOnboarding$practiceOnboardingPath(id))));
	});
var $author$project$Pages$Onboard$OnboardId_String$Completing$init = F2(
	function (shared, _v0) {
		var params = _v0.YL;
		return _Utils_Tuple3(
			{ajz: params.ajz},
			A3($author$project$Api$Provider$PracticeOnboarding$setupPractice, shared.Gv, params.ajz, $elm$core$Basics$identity),
			_List_Nil);
	});
var $author$project$Pages$Onboard$OnboardId_String$Completing$load = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Onboard$OnboardId_String$Completing$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Onboard$OnboardId_String$Completing$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Api$Data$errorToStatus = function (errorResponse) {
	switch (errorResponse.$) {
		case 0:
			return '401';
		case 1:
			return '404';
		case 2:
			return '503';
		case 4:
			return '502';
		case 3:
			return '503';
		case 5:
			return '404';
		case 8:
			return '500';
		case 6:
			var code = errorResponse.a;
			return $elm$core$String$fromInt(code);
		case 7:
			return '417';
		case 9:
			return '403';
		default:
			return '409';
	}
};
var $author$project$Pages$Onboard$OnboardId_String$Completing$update = F2(
	function (msg, model) {
		var response = msg;
		switch (response.$) {
			case 3:
				return _Utils_Tuple3(
					model,
					A2(
						$author$project$Utils$Route$navigate,
						$elm$core$Dict$empty,
						$author$project$Spa$Generated$Route$Onboard__OnboardId_String__Completed(
							{ajz: model.ajz})),
					_List_Nil);
			case 2:
				if ((response.a.$ === 6) && (response.a.a === 422)) {
					var _v2 = response.a;
					return _Utils_Tuple3(
						model,
						A2(
							$author$project$Utils$Route$navigate,
							$elm$core$Dict$empty,
							$author$project$Spa$Generated$Route$Onboard__OnboardId_String__Completed(
								{ajz: model.ajz})),
						_List_Nil);
				} else {
					var error = response.a;
					return _Utils_Tuple3(
						model,
						A2(
							$author$project$Utils$Route$navigate,
							$elm$core$Dict$empty,
							$author$project$Spa$Generated$Route$Error__Status_String(
								{
									alH: $author$project$Api$Data$errorToStatus(error)
								})),
						_List_Nil);
				}
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Pages$Onboard$OnboardId_String$Completing$view = function (_v0) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$textCenter]),
				_List_fromArray(
					[
						$author$project$Ui$Spinner$view(_List_Nil),
						$author$project$Ui$Typography$headingSm(
						_List_fromArray(
							[
								$elm$html$Html$text('Please wait while we create your account.')
							])),
						$author$project$Ui$Typography$headingSm(
						_List_fromArray(
							[
								$elm$html$Html$text('You will be able to sign in shortly to continue onboarding.')
							]))
					]))
			]),
		ac9: 'Onboard'
	};
};
var $author$project$Pages$Onboard$OnboardId_String$Completing$page = $author$project$Spa$Page$applicationOnlyPublic(
	{ah_: $author$project$Pages$Onboard$OnboardId_String$Completing$init, aiq: $author$project$Pages$Onboard$OnboardId_String$Completing$load, k8: $author$project$Pages$Onboard$OnboardId_String$Completing$save, alO: $author$project$Pages$Onboard$OnboardId_String$Completing$subscriptions, adT: $author$project$Pages$Onboard$OnboardId_String$Completing$update, amo: $author$project$Pages$Onboard$OnboardId_String$Completing$view});
var $author$project$Pages$Onboard$OnboardId_String$Payment$PaymentSetupMsg = $elm$core$Basics$identity;
var $author$project$Components$Onboard$PaymentSetup$GotPracticeOnboarding = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Onboard$PaymentSetup$GotSetupConfig = function (a) {
	return {$: 0, a: a};
};
var $author$project$Rainforest$Live = 0;
var $author$project$Components$Onboard$PaymentSetup$Loading = {$: 0};
var $author$project$Components$Onboard$PaymentSetup$Model = $elm$core$Basics$identity;
var $author$project$Rainforest$Sandbox = 1;
var $author$project$Ports$Rainforest$rainforestPortLoad = _Platform_outgoingPort('rainforestPortLoad', $elm$json$Json$Encode$string);
var $author$project$Rainforest$toString = function (env) {
	if (!env) {
		return 'production';
	} else {
		return 'sandbox';
	}
};
var $author$project$Ports$Rainforest$load = A2($elm$core$Basics$composeR, $author$project$Rainforest$toString, $author$project$Ports$Rainforest$rainforestPortLoad);
var $author$project$Components$Onboard$PaymentSetup$init = F2(
	function (onboardId, shared) {
		var rainforestEnv = _Utils_eq(
			shared.ahq.ahJ,
			$elm$core$Maybe$Just('production')) ? 0 : 1;
		return _Utils_Tuple2(
			{c2: false, sF: shared.sF, dp: true, ajz: onboardId, ZZ: $author$project$Api$Data$Loading, aA: $author$project$Components$Onboard$PaymentSetup$Loading},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3($author$project$Api$Provider$PracticeOnboarding$retrieve, shared.Gv, onboardId, $author$project$Components$Onboard$PaymentSetup$GotPracticeOnboarding),
						A4(
						$author$project$Api$PaymentMethod$getClientSecret,
						A2(
							$author$project$Api$Data$pathAppend,
							_List_fromArray(
								['practice_onboardings', onboardId]),
							$author$project$Api$Data$providerPath),
						shared.Gv,
						$elm$core$Maybe$Nothing,
						$author$project$Components$Onboard$PaymentSetup$GotSetupConfig),
						$author$project$Ports$Rainforest$load(rainforestEnv)
					])));
	});
var $author$project$Pages$Onboard$OnboardId_String$Payment$init = F2(
	function (shared, _v0) {
		var params = _v0.YL;
		var stepperModel = $author$project$Components$OnboardingStepper$init($author$project$Components$OnboardingStepper$defaultStepId);
		var currentStep = stepperModel.Hc;
		var _v1 = A2($author$project$Components$Onboard$PaymentSetup$init, params.ajz, shared);
		var paymentSetupFormModel = _v1.a;
		var paymentSetupFormCmd = _v1.b;
		return _Utils_Tuple3(
			{Gv: shared.Gv, Hc: currentStep, o4: paymentSetupFormModel, acg: stepperModel},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, paymentSetupFormCmd),
			_List_Nil);
	});
var $author$project$Pages$Onboard$OnboardId_String$Payment$load = F2(
	function (shared, model) {
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{Gv: shared.Gv}),
			$elm$core$Platform$Cmd$none,
			_List_Nil);
	});
var $author$project$Pages$Onboard$OnboardId_String$Payment$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Onboard$PaymentSetup$GotStripePaymentMethod = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Onboard$PaymentSetup$subscriptions = function (_v0) {
	return $author$project$Ports$Stripe$onSetupIntentConfirmed($author$project$Components$Onboard$PaymentSetup$GotStripePaymentMethod);
};
var $author$project$Pages$Onboard$OnboardId_String$Payment$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Onboard$PaymentSetup$subscriptions(model.o4));
};
var $author$project$Components$Onboard$PaymentSetup$Failed = {$: 3};
var $author$project$Components$Onboard$PaymentSetup$Rainforest = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Onboard$PaymentSetup$Stripe = {$: 1};
var $author$project$Components$Onboard$PaymentSetup$andNoop = function (model) {
	return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
};
var $author$project$Components$Onboard$PaymentSetup$stripeElementId = 'card-element';
var $author$project$Components$Onboard$PaymentSetup$buildStripeElement = function (clientSecret) {
	return A6($author$project$Ports$Stripe$buildAndMountElementWithSetupIntent, $elm$core$Maybe$Nothing, clientSecret, '#' + $author$project$Components$Onboard$PaymentSetup$stripeElementId, false, '', '');
};
var $author$project$Components$Onboard$PaymentSetup$PracticeOnboardingUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$PracticeOnboarding$updateProcessorConfig = F4(
	function (apiClient, paymentProcessorParams, id, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practice_onboarding',
					$elm$json$Json$Encode$object(
						$author$project$Api$PaymentProcessorParams$encode(paymentProcessorParams)))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$PracticeOnboarding$practiceOnboardingPath(id))));
	});
var $author$project$Components$Onboard$PaymentSetup$updatePracticeOnboarding = F3(
	function (apiClient, paymentProcessorParams, onboardId) {
		return A4($author$project$Api$Provider$PracticeOnboarding$updateProcessorConfig, apiClient, paymentProcessorParams, onboardId, $author$project$Components$Onboard$PaymentSetup$PracticeOnboardingUpdated);
	});
var $author$project$Components$Onboard$PaymentSetup$updateRainforest = F4(
	function (apiClient, msg, config, model) {
		switch (msg.$) {
			case 0:
				var rainforestId = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aA: $author$project$Components$Onboard$PaymentSetup$Rainforest(config)
						}),
					A3(
						$author$project$Components$Onboard$PaymentSetup$updatePracticeOnboarding,
						apiClient,
						$author$project$Api$PaymentProcessorParams$rainforestParams(rainforestId),
						model.ajz),
					_List_Nil);
			case 1:
				var isValid = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aA: $author$project$Components$Onboard$PaymentSetup$Rainforest(
								_Utils_update(
									config,
									{Ap: isValid}))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aA: $author$project$Components$Onboard$PaymentSetup$Rainforest(
								_Utils_update(
									config,
									{dp: false}))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Components$Onboard$PaymentSetup$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var setup = response.a;
					var _v3 = function () {
						if (!setup.$) {
							var secret = setup.a;
							return _Utils_Tuple2(
								$author$project$Components$Onboard$PaymentSetup$Stripe,
								$author$project$Components$Onboard$PaymentSetup$buildStripeElement(secret));
						} else {
							var sessionKey = setup.a.alo;
							var paymentMethodConfigId = setup.a.ajX;
							var allowedMethods = setup.a.aeX;
							return _Utils_Tuple2(
								$author$project$Components$Onboard$PaymentSetup$Rainforest(
									{aeX: allowedMethods, dp: true, Ap: false, ajX: paymentMethodConfigId, alo: sessionKey}),
								$elm$core$Platform$Cmd$none);
						}
					}();
					var config = _v3.a;
					var processorElement = _v3.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dp: false, aA: config}),
						processorElement,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dp: false}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var portCall = function () {
					var _v5 = model.aA;
					switch (_v5.$) {
						case 1:
							return A2(
								$author$project$Ports$Stripe$confirmSetupIntent,
								'#' + $author$project$Components$Onboard$PaymentSetup$stripeElementId,
								{afh: $elm$core$Maybe$Nothing});
						case 2:
							return $author$project$Ports$Rainforest$submitPaymentMethod;
						default:
							return $elm$core$Platform$Cmd$none;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{c2: true}),
					portCall,
					_List_Nil);
			case 2:
				var cardPaymentMethodResult = msg.a;
				if (!cardPaymentMethodResult.$) {
					var stripeCardPaymentMethod = cardPaymentMethodResult.a;
					var params = $author$project$Api$PaymentProcessorParams$stripeParams(stripeCardPaymentMethod.ahP);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{c2: true}),
						A3($author$project$Components$Onboard$PaymentSetup$updatePracticeOnboarding, apiClient, params, model.ajz),
						_List_Nil);
				} else {
					var _v7 = model.aA;
					if (!_v7.$) {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{c2: false, aA: $author$project$Components$Onboard$PaymentSetup$Failed}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				}
			case 3:
				var response = msg.a;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{c2: false}),
							A2(
								$author$project$Utils$Route$navigate,
								$elm$core$Dict$empty,
								$author$project$Spa$Generated$Route$Onboard__OnboardId_String__Completing(
									{ajz: model.ajz})),
							_List_Nil);
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{c2: false}),
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error)),
								$author$project$OutMsg$reportDecodeError(response)));
					default:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{c2: false}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
				}
			case 4:
				var response = msg.a;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{ZZ: response}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ZZ: $author$project$Api$Data$Failure(error)
								}),
							A2(
								$author$project$Utils$Route$navigate,
								$elm$core$Dict$empty,
								$author$project$Spa$Generated$Route$Error__Status_String(
									{
										alH: $author$project$Api$Data$errorToStatus(error)
									})),
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{ZZ: $author$project$Api$Data$NotAsked}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var rainforestMsg = msg.a;
				var _v10 = model.aA;
				if (_v10.$ === 2) {
					var config = _v10.a;
					return A4($author$project$Components$Onboard$PaymentSetup$updateRainforest, apiClient, rainforestMsg, config, model);
				} else {
					return $author$project$Components$Onboard$PaymentSetup$andNoop(model);
				}
		}
	});
var $author$project$Pages$Onboard$OnboardId_String$Payment$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Onboard$PaymentSetup$update, model.Gv, subMsg, model.o4);
		var paymentSetupModel = _v1.a;
		var paymentSetupFormCmd = _v1.b;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{o4: paymentSetupModel}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, paymentSetupFormCmd),
			_List_Nil);
	});
var $author$project$Components$Onboard$PaymentSetup$viewInfoHeader = A2(
	$author$project$Ui$Element$view,
	_List_fromArray(
		[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap4, $author$project$Ui$Element$mb4]),
	_List_fromArray(
		[
			$author$project$Ui$Typography$heading(
			_List_fromArray(
				[
					$elm$html$Html$text('Add your payment method')
				])),
			A2(
			$author$project$Ui$Element$prose,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('You will not be billed immediately for your application software fees. You can view your billing start date after you complete onboarding.')
				]))
		]));
var $author$project$Components$Onboard$PaymentSetup$Approved = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Onboard$PaymentSetup$Loaded = {$: 2};
var $author$project$Components$Onboard$PaymentSetup$Noop = {$: 3};
var $author$project$Components$Onboard$PaymentSetup$RainforestMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Onboard$PaymentSetup$Save = {$: 1};
var $author$project$Components$Onboard$PaymentSetup$ValidityChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Button$Test = function (a) {
	return {$: 12, a: a};
};
var $author$project$Ui$Button$test = $author$project$Ui$Button$Test;
var $author$project$Components$Onboard$PaymentSetup$viewPaymentElementsForm = function (_v0) {
	var model = _v0;
	var valid = function () {
		var _v4 = model.aA;
		if (_v4.$ === 2) {
			var conf = _v4.a;
			return conf.Ap;
		} else {
			return true;
		}
	}();
	var disabled = !valid;
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$mt4, $author$project$Ui$Element$mb4]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('stripe-card')
					]),
				_List_fromArray(
					[
						function () {
						var _v1 = _Utils_Tuple2(model.dp, model.aA);
						_v1$2:
						while (true) {
							if (!_v1.a) {
								switch (_v1.b.$) {
									case 1:
										var _v2 = _v1.b;
										return A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$id($author$project$Components$Onboard$PaymentSetup$stripeElementId)
												]),
											_List_Nil);
									case 2:
										var config = _v1.b.a;
										var _v3 = config;
										var sessionKey = _v3.alo;
										var paymentMethodConfigId = _v3.ajX;
										var allowedMethods = _v3.aeX;
										return A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$WebComponents$Rainforest$Payment$view,
													{
														ajb: A2($elm$core$Basics$composeR, $author$project$Components$Onboard$PaymentSetup$Approved, $author$project$Components$Onboard$PaymentSetup$RainforestMsg),
														ajc: A2(
															$elm$core$Basics$composeR,
															$elm$core$Basics$always($author$project$Components$Onboard$PaymentSetup$Noop),
															$author$project$Components$Onboard$PaymentSetup$RainforestMsg),
														ajn: $author$project$Components$Onboard$PaymentSetup$RainforestMsg(
															$author$project$Components$Onboard$PaymentSetup$ValidityChanged(false)),
														ajo: $author$project$Components$Onboard$PaymentSetup$RainforestMsg($author$project$Components$Onboard$PaymentSetup$Loaded),
														ajp: A2(
															$elm$core$Basics$composeR,
															$elm$core$Basics$always($author$project$Components$Onboard$PaymentSetup$Noop),
															$author$project$Components$Onboard$PaymentSetup$RainforestMsg),
														ajy: $author$project$Components$Onboard$PaymentSetup$RainforestMsg(
															$author$project$Components$Onboard$PaymentSetup$ValidityChanged(true))
													},
													{aeX: allowedMethods, ajX: paymentMethodConfigId, alo: sessionKey}),
													config.dp ? A2(
													$author$project$Ui$Grid$row,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Grid$column,
															_List_fromArray(
																[
																	$author$project$Ui$Grid$spanSm(8),
																	$author$project$Ui$Grid$justifyCenter
																]),
															_List_fromArray(
																[
																	$author$project$Ui$Spinner$view(
																	_List_fromArray(
																		[$author$project$Ui$Spinner$large]))
																]))
														])) : $author$project$Utils$Html$empty
												]));
									default:
										break _v1$2;
								}
							} else {
								break _v1$2;
							}
						}
						return A2(
							$author$project$Ui$Grid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanSm(8),
											$author$project$Ui$Grid$justifyCenter
										]),
									_List_fromArray(
										[
											$author$project$Ui$Spinner$view(
											_List_fromArray(
												[$author$project$Ui$Spinner$large]))
										]))
								]));
					}()
					])),
				A2(
				$author$project$Ui$Grid$row,
				_List_fromArray(
					[$author$project$Ui$Grid$mt4]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(12),
								$author$project$Ui$Grid$justifyRight
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Submit payment method'},
								_List_fromArray(
									[
										$author$project$Ui$Button$styled(1),
										$author$project$Ui$Button$loading(model.c2),
										$author$project$Ui$Button$disabled(model.c2 || disabled),
										$author$project$Ui$Button$onClick($author$project$Components$Onboard$PaymentSetup$Save),
										$author$project$Ui$Button$test('submit-payment-method')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Next')
									]))
							]))
					]))
			]));
};
var $author$project$Components$Onboard$PaymentSetup$viewForm = function (_v0) {
	var model = _v0;
	return _Utils_eq(model.ZZ, $author$project$Api$Data$Loading) ? _List_fromArray(
		[
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$textCenter]),
			_List_fromArray(
				[
					$author$project$Ui$Spinner$view(_List_Nil)
				]))
		]) : _List_fromArray(
		[
			$author$project$Components$Onboard$PaymentSetup$viewInfoHeader,
			$author$project$Components$Onboard$PaymentSetup$viewPaymentElementsForm(model)
		]);
};
var $author$project$Components$Onboard$PaymentSetup$view = function (model) {
	return A2(
		$author$project$Ui$Form$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$autocomplete(false),
				$author$project$Ui$Form$noValidate(true)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_fromArray(
					[$author$project$Ui$Panel$extraPadding]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						$author$project$Components$Onboard$PaymentSetup$viewForm(model))
					]))
			]));
};
var $author$project$Pages$Onboard$OnboardId_String$Payment$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Onboard$PaymentSetup$view(model.o4))
			]),
		ac9: 'Onboard'
	};
};
var $author$project$Pages$Onboard$OnboardId_String$Payment$page = $author$project$Spa$Page$applicationOnlyPublic(
	{ah_: $author$project$Pages$Onboard$OnboardId_String$Payment$init, aiq: $author$project$Pages$Onboard$OnboardId_String$Payment$load, k8: $author$project$Pages$Onboard$OnboardId_String$Payment$save, alO: $author$project$Pages$Onboard$OnboardId_String$Payment$subscriptions, adT: $author$project$Pages$Onboard$OnboardId_String$Payment$update, amo: $author$project$Pages$Onboard$OnboardId_String$Payment$view});
var $author$project$Pages$Onboard$OnboardId_String$User$GotPracticeOnboarding = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Onboard$OnboardId_String$User$PracticeUserMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Onboard$OnboardId_String$User$ShowingCreateForm = 0;
var $author$project$Pages$Onboard$OnboardId_String$User$ShowingExistingUser = 1;
var $author$project$Components$Onboard$PracticeUser$Model = $elm$core$Basics$identity;
var $author$project$Components$Onboard$PracticeUser$init = F2(
	function (onboardId, shared) {
		var inittedForm = $author$project$Utils$Form$init(
			{Rj: '', Sv: '', VH: '', ajR: '', tF: '', oT: $elm$core$Maybe$Nothing, J5: false});
		return _Utils_Tuple2(
			{SD: inittedForm, ajz: onboardId, lk: shared},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Onboard$OnboardId_String$User$init = F2(
	function (shared, _v0) {
		var params = _v0.YL;
		var stepperModel = $author$project$Components$OnboardingStepper$init($author$project$Components$OnboardingStepper$defaultStepId);
		var maybeSession = function () {
			var _v3 = shared.aa4;
			if (_v3.$ === 3) {
				var session = _v3.a;
				return $elm$core$Maybe$Just(session);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var initialViewMode = function () {
			if (!maybeSession.$) {
				return 1;
			} else {
				return 0;
			}
		}();
		var currentStep = stepperModel.Hc;
		var _v1 = A2($author$project$Components$Onboard$PracticeUser$init, params.ajz, shared);
		var practiceUserFormModel = _v1.a;
		var practiceUserFormCmd = _v1.b;
		return _Utils_Tuple3(
			{Hc: currentStep, gE: false, oB: maybeSession, ajz: params.ajz, ZZ: $author$project$Api$Data$Loading, lk: shared, acg: stepperModel, l$: practiceUserFormModel, l1: initialViewMode},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Onboard$OnboardId_String$User$PracticeUserMsg, practiceUserFormCmd),
						A3($author$project$Api$Provider$PracticeOnboarding$retrieve, shared.Gv, params.ajz, $author$project$Pages$Onboard$OnboardId_String$User$GotPracticeOnboarding)
					])),
			_List_Nil);
	});
var $author$project$Pages$Onboard$OnboardId_String$User$determineViewMode = F3(
	function (maybeSession, practiceOnboardingData, currentViewMode) {
		var _v0 = _Utils_Tuple2(practiceOnboardingData, maybeSession);
		if (!_v0.b.$) {
			if (_v0.a.$ === 3) {
				var _v1 = _v0.a;
				var practiceOnboarding = _v1.a;
				var _v2 = $author$project$Api$Provider$PracticeOnboarding$One$emr(practiceOnboarding);
				if (!_v2.$) {
					var emr = _v2.a;
					return $author$project$Api$Provider$Practice$Emr$isHintClinical(emr) ? 0 : 1;
				} else {
					return 1;
				}
			} else {
				return 1;
			}
		} else {
			return currentViewMode;
		}
	});
var $author$project$Pages$Onboard$OnboardId_String$User$load = F2(
	function (shared, model) {
		var updatedMaybeSession = function () {
			var _v0 = shared.aa4;
			if (_v0.$ === 3) {
				var session = _v0.a;
				return $elm$core$Maybe$Just(session);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var updatedViewMode = A3($author$project$Pages$Onboard$OnboardId_String$User$determineViewMode, updatedMaybeSession, model.ZZ, model.l1);
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{oB: updatedMaybeSession, lk: shared, l1: updatedViewMode}),
			$elm$core$Platform$Cmd$none,
			_List_Nil);
	});
var $author$project$Pages$Onboard$OnboardId_String$User$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Onboard$PracticeUser$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Onboard$PracticeUser$PasswordStrengthCheck = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Onboard$PracticeUser$subscriptions = function (_v0) {
	return $author$project$Ports$PasswordStrength$checked(
		A2(
			$elm$core$Basics$composeL,
			A2($elm$core$Basics$composeL, $author$project$Components$Onboard$PracticeUser$FormUpdated, $author$project$Components$Onboard$PracticeUser$PasswordStrengthCheck),
			$elm$core$Maybe$Just));
};
var $author$project$Pages$Onboard$OnboardId_String$User$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$Onboard$OnboardId_String$User$PracticeUserMsg,
		$author$project$Components$Onboard$PracticeUser$subscriptions(model.l$));
};
var $author$project$Ui$Toast$Info = 0;
var $author$project$Pages$Onboard$OnboardId_String$User$UserLinked = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$PracticeOnboarding$User$onboardIdPath = F2(
	function (basePath, id_) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id_]),
			basePath);
	});
var $author$project$Api$Provider$PracticeOnboarding$User$practiceOnboardingsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['practice_onboardings']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$PracticeOnboarding$User$userPath = function (basePath) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['user']),
		basePath);
};
var $author$project$Api$Provider$PracticeOnboarding$User$linkExistingPath = function (onboardId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['link']),
		$author$project$Api$Provider$PracticeOnboarding$User$userPath(
			A2($author$project$Api$Provider$PracticeOnboarding$User$onboardIdPath, $author$project$Api$Provider$PracticeOnboarding$User$practiceOnboardingsPath, onboardId)));
};
var $author$project$Api$Provider$PracticeOnboarding$User$linkExisting = F3(
	function (apiClient, onboardId, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$PracticeOnboarding$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$PracticeOnboarding$User$linkExistingPath(onboardId)));
	});
var $author$project$Components$Onboard$PracticeUser$OnboardingUserCreated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$PracticeOnboarding$User$onboardingUserPath = function (onboardId) {
	return $author$project$Api$Provider$PracticeOnboarding$User$userPath(
		A2($author$project$Api$Provider$PracticeOnboarding$User$onboardIdPath, $author$project$Api$Provider$PracticeOnboarding$User$practiceOnboardingsPath, onboardId));
};
var $author$project$Api$Provider$PracticeOnboarding$User$create = F3(
	function (apiClient, fields, toMsg) {
		var createOnboardingUserPath = $author$project$Api$Provider$PracticeOnboarding$User$onboardingUserPath(fields.ajz);
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practice_onboarding_user',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'first_name',
								$elm$json$Json$Encode$string(fields.Sv)),
								_Utils_Tuple2(
								'last_name',
								$elm$json$Json$Encode$string(fields.VH)),
								_Utils_Tuple2(
								'terms_accepted',
								$elm$json$Json$Encode$bool(fields.J5)),
								_Utils_Tuple2(
								'email',
								$elm$json$Json$Encode$string(fields.Rj)),
								_Utils_Tuple2(
								'password',
								$elm$json$Json$Encode$string(fields.ajR))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(createOnboardingUserPath)));
	});
var $author$project$Components$Onboard$PracticeUser$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{Sv: string}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var string = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{VH: string}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var string = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{Rj: string}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var string = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{ajR: string, oT: $elm$core$Maybe$Nothing}),
					$author$project$Ports$PasswordStrength$check(string));
			case 4:
				var string = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{tF: string}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var bool = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{J5: bool}),
					$elm$core$Platform$Cmd$none);
			default:
				var check = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{oT: check}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Components$Onboard$PracticeUser$EmailValidation = 2;
var $author$project$Components$Onboard$PracticeUser$FirstNameValidation = 0;
var $author$project$Components$Onboard$PracticeUser$LastNameValidation = 1;
var $author$project$Components$Onboard$PracticeUser$PasswordValidation = 3;
var $author$project$Components$Onboard$PracticeUser$TermsAcceptedValidation = 5;
var $author$project$Components$Onboard$PracticeUser$PasswordConfirmationValidation = 4;
var $author$project$Components$Onboard$PracticeUser$validatePasswordConfirmation = function (fields) {
	return $author$project$Utils$String$isBlank(fields.ajR) ? _List_Nil : (_Utils_eq(fields.ajR, fields.tF) ? _List_Nil : _List_fromArray(
		[
			_Utils_Tuple2(4, 'The password and its confirmation don\'t match.')
		]));
};
var $author$project$Components$Onboard$PracticeUser$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.Sv;
			},
			_Utils_Tuple2(0, 'Please enter a first name.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.VH;
			},
			_Utils_Tuple2(1, 'Please enter a last name.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.ajR;
			},
			_Utils_Tuple2(3, 'Please enter a password.')),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Onboard$PracticeUser$validatePasswordConfirmation),
			A2(
			$rtfeldman$elm_validate$Validate$ifFalse,
			function ($) {
				return $.J5;
			},
			_Utils_Tuple2(5, 'You must accept our Terms of Service when creating your account.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifFalse,
			function (subject) {
				return A2(
					$elm$core$Maybe$withDefault,
					false,
					A2($elm$core$Maybe$map, $author$project$Utils$PasswordStrength$isUnguessable, subject.oT));
			},
			_Utils_Tuple2(3, 'Please enter a secure password.')),
			A3(
			$author$project$Utils$Validate$ifInvalidEmail,
			{aeT: false},
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.Rj;
				},
				$elm$core$Maybe$Just),
			_Utils_Tuple2(2, 'Please enter a valid email.'))
		]));
var $author$project$Components$Onboard$PracticeUser$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var _v2 = A3($author$project$Utils$Form$updateWithCmd, $author$project$Components$Onboard$PracticeUser$formFieldsUpdate, field, model.SD);
				var newForm = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: newForm}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Onboard$PracticeUser$FormUpdated, cmd),
					_List_Nil);
			case 1:
				var _v3 = A2($author$project$Utils$Form$validate, $author$project$Components$Onboard$PracticeUser$formFieldsValidator, model.SD);
				if (!_v3.$) {
					var _v4 = _v3.a;
					var newForm = _v4.a;
					var fields = $author$project$Utils$Form$fields(newForm);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{SD: newForm}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A3(
									$author$project$Api$Provider$PracticeOnboarding$User$create,
									model.lk.Gv,
									{Rj: fields.Rj, Sv: fields.Sv, VH: fields.VH, ajz: model.ajz, ajR: fields.ajR, J5: fields.J5},
									$author$project$Components$Onboard$PracticeUser$OnboardingUserCreated),
									A2($author$project$Ports$LocalStorage$setItem, 'login-email', fields.Rj)
								])),
						_List_Nil);
				} else {
					var newForm = _v3.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{SD: newForm}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 2:
				var response = msg.a;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							model,
							A2(
								$author$project$Utils$Route$navigate,
								$elm$core$Dict$empty,
								$author$project$Spa$Generated$Route$Onboard__OnboardId_String__Payment(
									{ajz: model.ajz})),
							_List_Nil);
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error)),
								$author$project$OutMsg$reportDecodeError(response)));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Ports$Session$persistRedirect(
								$elm$url$Url$toString(model.lk.adY)),
								$author$project$Ports$Session$authorize(
								{aku: true})
							])),
					_List_Nil);
		}
	});
var $author$project$Pages$Onboard$OnboardId_String$User$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Components$Onboard$PracticeUser$update, subMsg, model.l$);
				var practiceUserFormModel = _v1.a;
				var practiceUserFormCmd = _v1.b;
				var practiceUserMsg = _v1.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{l$: practiceUserFormModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Onboard$OnboardId_String$User$PracticeUserMsg, practiceUserFormCmd),
					practiceUserMsg);
			case 1:
				var response = msg.a;
				var updatedViewMode = A3($author$project$Pages$Onboard$OnboardId_String$User$determineViewMode, model.oB, response, 0);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ZZ: response, l1: updatedViewMode}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 2:
				var _v2 = model.ZZ;
				switch (_v2.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{gE: true}),
							A3($author$project$Api$Provider$PracticeOnboarding$User$linkExisting, model.lk.Gv, model.ajz, $author$project$Pages$Onboard$OnboardId_String$User$UserLinked),
							_List_Nil);
					case 1:
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 0, 'Please wait while we load your practice information...')
								]));
					case 2:
						var error = _v2.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error))
								]));
					default:
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 1, 'Unable to continue. Please refresh the page and try again.')
								]));
				}
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{l1: 0}),
					$author$project$Ports$Session$logout(
						{aku: false}),
					_List_Nil);
			default:
				var response = msg.a;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{gE: false}),
							A2(
								$author$project$Utils$Route$navigate,
								$elm$core$Dict$empty,
								$author$project$Spa$Generated$Route$Onboard__OnboardId_String__Payment(
									{ajz: model.ajz})),
							_List_Nil);
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{gE: false}),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error))
								]));
					default:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{gE: false}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
				}
		}
	});
var $author$project$Components$Onboard$PracticeUser$Save = {$: 1};
var $author$project$Components$Onboard$PracticeUser$SignInClicked = {$: 3};
var $author$project$Components$Onboard$PracticeUser$Email = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Onboard$PracticeUser$viewEmail = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.SD);
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$mt3]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$required(true),
						$author$project$Ui$Form$Group$labelAbove,
						$author$project$Ui$Form$Group$label('Email'),
						$author$project$Ui$Form$Group$test('email')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(fields.Rj),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Components$Onboard$PracticeUser$FormUpdated, $author$project$Components$Onboard$PracticeUser$Email)),
								$author$project$Ui$Form$Input$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 2, model.SD)),
								$author$project$Ui$Form$Input$errors(
								A2($author$project$Utils$Form$validationErrors, 2, model.SD))
							]))
					]))
			]));
};
var $author$project$Components$Onboard$PracticeUser$FirstName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Onboard$PracticeUser$viewFirstName = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.SD);
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(4),
				$author$project$Ui$Form$Group$labelAbove,
				$author$project$Ui$Form$Group$required(true),
				$author$project$Ui$Form$Group$label('First Name'),
				$author$project$Ui$Form$Group$test('first-name')
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$value(fields.Sv),
						$author$project$Ui$Form$Input$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Onboard$PracticeUser$FormUpdated, $author$project$Components$Onboard$PracticeUser$FirstName)),
						$author$project$Ui$Form$Input$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 0, model.SD)),
						$author$project$Ui$Form$Input$errors(
						A2($author$project$Utils$Form$validationErrors, 0, model.SD))
					]))
			]));
};
var $author$project$Components$Onboard$PracticeUser$LastName = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Onboard$PracticeUser$viewLastName = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.SD);
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$mb3]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Last Name'),
						$author$project$Ui$Form$Group$required(true),
						$author$project$Ui$Form$Group$labelAbove,
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$test('last-name')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(fields.VH),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Components$Onboard$PracticeUser$FormUpdated, $author$project$Components$Onboard$PracticeUser$LastName)),
								$author$project$Ui$Form$Input$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 1, model.SD)),
								$author$project$Ui$Form$Input$errors(
								A2($author$project$Utils$Form$validationErrors, 1, model.SD))
							]))
					]))
			]));
};
var $author$project$Components$Onboard$PracticeUser$Password = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Onboard$PracticeUser$viewPassword = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.SD);
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(4),
				$author$project$Ui$Form$Group$labelAbove,
				$author$project$Ui$Form$Group$required(true),
				$author$project$Ui$Form$Group$label('Password'),
				$author$project$Ui$Form$Group$invalid(
				A2($author$project$Utils$Form$hasValidationErrors, 3, model.SD))
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$PasswordInput$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$PasswordInput$placeholder('Password'),
						$author$project$Ui$Form$PasswordInput$value(fields.ajR),
						$author$project$Ui$Form$PasswordInput$strengthCheck(fields.oT),
						$author$project$Ui$Form$PasswordInput$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Onboard$PracticeUser$FormUpdated, $author$project$Components$Onboard$PracticeUser$Password)),
						$author$project$Ui$Form$PasswordInput$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 3, model.SD)),
						$author$project$Ui$Form$PasswordInput$withFeedback(
						$author$project$Utils$Form$validated(model.SD))
					]))
			]));
};
var $author$project$Components$Onboard$PracticeUser$PasswordConfirmation = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Onboard$PracticeUser$viewPasswordConfirm = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.SD);
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(4),
				$author$project$Ui$Form$Group$labelAbove,
				$author$project$Ui$Form$Group$required(true),
				$author$project$Ui$Form$Group$label('Password Confirmation'),
				$author$project$Ui$Form$Group$invalid(
				A2($author$project$Utils$Form$hasValidationErrors, 3, model.SD))
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$placeholder('Password Confirmation'),
						$author$project$Ui$Form$Input$password,
						$author$project$Ui$Form$Input$value(fields.tF),
						$author$project$Ui$Form$Input$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Onboard$PracticeUser$FormUpdated, $author$project$Components$Onboard$PracticeUser$PasswordConfirmation)),
						$author$project$Ui$Form$Input$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 4, model.SD)),
						$author$project$Ui$Form$Input$errors(
						A2($author$project$Utils$Form$validationErrors, 4, model.SD))
					]))
			]));
};
var $author$project$Components$Onboard$PracticeUser$TermsAccepted = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Onboard$PracticeUser$viewTermsAccepted = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.SD);
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(12),
				$author$project$Ui$Form$Group$inputSpanSm(12)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Checkbox$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Checkbox$value(fields.J5),
						$author$project$Ui$Form$Checkbox$required(true),
						$author$project$Ui$Form$Checkbox$onCheck(
						A2($elm$core$Basics$composeL, $author$project$Components$Onboard$PracticeUser$FormUpdated, $author$project$Components$Onboard$PracticeUser$TermsAccepted)),
						$author$project$Ui$Form$Checkbox$errors(
						A2($author$project$Utils$Form$validationErrors, 5, model.SD))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('I have read and agree to the '),
						A3(
						$author$project$Ui$Link$externalHref,
						$author$project$Utils$HintUrls$termsUrl,
						_List_fromArray(
							[$author$project$Ui$Link$targetBlank]),
						_List_fromArray(
							[
								$elm$html$Html$text('Terms of Service')
							])),
						$elm$html$Html$text('.')
					]))
			]));
};
var $author$project$Components$Onboard$PracticeUser$viewForm = function (model) {
	return _List_fromArray(
		[
			$author$project$Components$Onboard$PracticeUser$viewFirstName(model),
			$author$project$Components$Onboard$PracticeUser$viewLastName(model),
			$author$project$Components$Onboard$PracticeUser$viewEmail(model),
			$author$project$Components$Onboard$PracticeUser$viewPassword(model),
			$author$project$Components$Onboard$PracticeUser$viewPasswordConfirm(model),
			$author$project$Components$Onboard$PracticeUser$viewTermsAccepted(model),
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$textRight]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{mm: 'Submit user'},
					_List_fromArray(
						[
							$author$project$Ui$Button$primary,
							$author$project$Ui$Button$submit,
							$author$project$Ui$Button$loading(false)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Next')
						]))
				]))
		]);
};
var $author$project$Components$Onboard$PracticeUser$view = F2(
	function (_v0, showSignInPrompt) {
		var model = _v0;
		return A2(
			$author$project$Ui$Form$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$autocomplete(false),
					$author$project$Ui$Form$noValidate(true),
					$author$project$Ui$Form$onSubmit($author$project$Components$Onboard$PracticeUser$Save)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$view,
					_List_fromArray(
						[$author$project$Ui$Panel$extraPadding]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Panel$body,
							_List_Nil,
							A2(
								$elm$core$List$cons,
								$author$project$Ui$Typography$heading(
									_List_fromArray(
										[
											$elm$html$Html$text('Create your account')
										])),
								A2(
									$elm$core$List$cons,
									showSignInPrompt ? A2(
										$author$project$Ui$Element$prose,
										_List_fromArray(
											[$author$project$Ui$Element$mt1, $author$project$Ui$Element$mb2]),
										_List_fromArray(
											[
												$elm$html$Html$text('Already have an account? '),
												A3(
												$author$project$Ui$Button$view,
												{mm: 'Sign in to continue'},
												_List_fromArray(
													[
														$author$project$Ui$Button$link,
														$author$project$Ui$Button$onClick($author$project$Components$Onboard$PracticeUser$SignInClicked)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Sign in to continue')
													]))
											])) : $elm$html$Html$text(''),
									$author$project$Components$Onboard$PracticeUser$viewForm(model))))
						]))
				]));
	});
var $author$project$Pages$Onboard$OnboardId_String$User$ContinueWithExistingUser = {$: 2};
var $author$project$Pages$Onboard$OnboardId_String$User$CreateNewUserInstead = {$: 3};
var $author$project$Ui$FontWeight$Medium = 0;
var $author$project$Pages$Onboard$OnboardId_String$User$viewExistingUserCard = function (model) {
	return A2(
		$author$project$Ui$Panel$view,
		_List_fromArray(
			[$author$project$Ui$Panel$extraPadding]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						function () {
						var _v0 = model.oB;
						if (!_v0.$) {
							var session = _v0.a;
							var user = $author$project$Api$Platform$Session$One$user(session);
							return A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap2]),
										_List_fromArray(
											[
												$author$project$Ui$Typography$heading(
												_List_fromArray(
													[
														$elm$html$Html$text('Confirm the account owner')
													])),
												A2(
												$author$project$Ui$Element$prose,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Account Owner: '),
														A2(
														$author$project$Ui$Typography$text,
														_List_fromArray(
															[
																$author$project$Ui$Typography$fontWeight(0)
															]),
														$author$project$Api$Platform$User$Shared$email(user))
													]))
											])),
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$textRight, $author$project$Ui$Element$mt4]),
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Button$view,
												{mm: 'Create new owner'},
												_List_fromArray(
													[
														$author$project$Ui$Button$secondary,
														$author$project$Ui$Button$onClick($author$project$Pages$Onboard$OnboardId_String$User$CreateNewUserInstead),
														$author$project$Ui$Button$disabled(model.gE)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Create new owner')
													])),
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$ml2]),
												_List_fromArray(
													[
														A3(
														$author$project$Ui$Button$view,
														{mm: 'Next'},
														_List_fromArray(
															[
																$author$project$Ui$Button$primary,
																$author$project$Ui$Button$onClick($author$project$Pages$Onboard$OnboardId_String$User$ContinueWithExistingUser),
																$author$project$Ui$Button$loading(model.gE)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Next')
															]))
													]))
											]))
									]));
						} else {
							return $elm$html$Html$text('');
						}
					}()
					]))
			]));
};
var $author$project$Pages$Onboard$OnboardId_String$User$view = function (model) {
	return {
		fO: function () {
			var _v0 = _Utils_Tuple2(model.l1, model.ZZ);
			_v0$3:
			while (true) {
				if (!_v0.a) {
					if (_v0.b.$ === 3) {
						var _v3 = _v0.a;
						var _v4 = _v0.b;
						var practiceOnboarding = _v4.a;
						var emr = $author$project$Api$Provider$PracticeOnboarding$One$emr(practiceOnboarding);
						var isClinical = A2(
							$elm$core$Maybe$withDefault,
							false,
							A2($elm$core$Maybe$map, $author$project$Api$Provider$Practice$Emr$isHintClinical, emr));
						var showSignInPrompt = (!isClinical) && _Utils_eq(model.oB, $elm$core$Maybe$Nothing);
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Onboard$OnboardId_String$User$PracticeUserMsg,
								A2($author$project$Components$Onboard$PracticeUser$view, model.l$, showSignInPrompt))
							]);
					} else {
						break _v0$3;
					}
				} else {
					switch (_v0.b.$) {
						case 3:
							var _v1 = _v0.a;
							var _v2 = _v0.b;
							return _List_fromArray(
								[
									$author$project$Pages$Onboard$OnboardId_String$User$viewExistingUserCard(model)
								]);
						case 1:
							var _v5 = _v0.a;
							var _v6 = _v0.b;
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textCenter]),
									_List_fromArray(
										[
											$author$project$Ui$Spinner$view(_List_Nil)
										]))
								]);
						default:
							break _v0$3;
					}
				}
			}
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Pages$Onboard$OnboardId_String$User$PracticeUserMsg,
					A2($author$project$Components$Onboard$PracticeUser$view, model.l$, false))
				]);
		}(),
		ac9: 'Onboard'
	};
};
var $author$project$Pages$Onboard$OnboardId_String$User$page = $author$project$Spa$Page$applicationOnlyPublic(
	{ah_: $author$project$Pages$Onboard$OnboardId_String$User$init, aiq: $author$project$Pages$Onboard$OnboardId_String$User$load, k8: $author$project$Pages$Onboard$OnboardId_String$User$save, alO: $author$project$Pages$Onboard$OnboardId_String$User$subscriptions, adT: $author$project$Pages$Onboard$OnboardId_String$User$update, amo: $author$project$Pages$Onboard$OnboardId_String$User$view});
var $author$project$Pages$Onboarding$PracticePaymentSourcesMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Onboarding$GotApplicationFeePlan = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Onboarding$fetchApplicationFeePlan = function (apiClient) {
	return A2($author$project$Api$Provider$Practice$ApplicationFeePlan$retrieve, apiClient, $author$project$Pages$Onboarding$GotApplicationFeePlan);
};
var $author$project$Pages$Onboarding$GotPracticePricing = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Onboarding$fetchPracticePricing = function (apiClient) {
	return A2($author$project$Api$Provider$PracticePricing$retrieve, apiClient, $author$project$Pages$Onboarding$GotPracticePricing);
};
var $author$project$Pages$Onboarding$GotBankAccounts = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Onboarding$GotCards = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Onboarding$fetchSources = function (apiClient) {
	return $elm$core$Platform$Cmd$batch(
		_List_fromArray(
			[
				A3($author$project$Api$Provider$Card$list, $author$project$Api$Data$providerPath, apiClient, $author$project$Pages$Onboarding$GotCards),
				A3($author$project$Api$Provider$BankAccount$list, $author$project$Api$Data$providerPath, apiClient, $author$project$Pages$Onboarding$GotBankAccounts)
			]));
};
var $author$project$Pages$Onboarding$init = F4(
	function (session, practice, shared, _v0) {
		var _v1 = A6(
			$author$project$Components$Practice$PaymentSources$Standard$init,
			session,
			practice,
			shared.sF,
			shared.J7,
			$author$project$Shared$isHintAdmin(shared),
			shared.t9);
		var practicePaymentSources = _v1.a;
		var practicePaymentSourcesCmd = _v1.b;
		return _Utils_Tuple2(
			{
				Gv: shared.Gv,
				dd: shared.dd,
				nI: $author$project$Api$Data$Loading,
				Ij: $author$project$Shared$isHintAdmin(shared),
				ZV: practice,
				bK: practicePaymentSources,
				cP: $author$project$Api$Data$Loading,
				aa4: session
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Pages$Onboarding$fetchSources(shared.Gv),
						$author$project$Pages$Onboarding$fetchApplicationFeePlan(shared.Gv),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Onboarding$PracticePaymentSourcesMsg, practicePaymentSourcesCmd),
						$author$project$Pages$Onboarding$fetchPracticePricing(shared.Gv)
					])));
	});
var $author$project$Pages$Onboarding$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Onboarding$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Onboarding$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$Onboarding$PracticePaymentSourcesMsg,
		$author$project$Components$Practice$PaymentSources$Standard$subscriptions(model.bK));
};
var $author$project$Pages$Onboarding$OnboardingCompleted = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Onboarding$GotPractice = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Onboarding$fetchPractice = function (apiClient) {
	return A3($author$project$Api$Provider$Practice$retrieve, apiClient, $elm$core$Basics$identity, $author$project$Pages$Onboarding$GotPractice);
};
var $author$project$Api$Provider$Practice$onboard = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Practice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['onboard']),
					$author$project$Api$Provider$Practice$practicePath)));
	});
var $author$project$Api$Provider$Practice$skipPaymentRequirement = F2(
	function (apiClient, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practice',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'requires_payment_information',
								$elm$json$Json$Encode$bool(false))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Practice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$practicePath)));
	});
var $author$project$Pages$Onboarding$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nI: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var dataResponse = msg.a;
				if (dataResponse.$ === 3) {
					var practice = dataResponse.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ZV: practice}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(dataResponse));
				}
			case 2:
				var subMsg = msg.a;
				var practicePaymentSourcesResult = A3($author$project$Components$Practice$PaymentSources$Standard$update, model.Gv, subMsg, model.bK);
				var cmds = function () {
					var _v2 = practicePaymentSourcesResult.agZ;
					switch (_v2) {
						case 0:
							return $elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Onboarding$fetchSources(model.Gv),
										$author$project$Pages$Onboarding$fetchPractice(model.Gv)
									]));
						case 3:
							return $elm$core$Platform$Cmd$none;
						case 1:
							return $elm$core$Platform$Cmd$none;
						default:
							return $elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Onboarding$fetchSources(model.Gv),
										$author$project$Pages$Onboarding$fetchPractice(model.Gv)
									]));
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bK: practicePaymentSourcesResult.aiO}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Onboarding$PracticePaymentSourcesMsg, practicePaymentSourcesResult.GZ),
								cmds
							])),
					practicePaymentSourcesResult.aR);
			case 3:
				return _Utils_Tuple3(
					model,
					function (fn) {
						return fn($author$project$Pages$Onboarding$OnboardingCompleted);
					}(
						$author$project$Api$Provider$Practice$onboard(model.Gv)),
					_List_Nil);
			case 4:
				return _Utils_Tuple3(
					model,
					A2($author$project$Api$Provider$Practice$skipPaymentRequirement, model.Gv, $author$project$Pages$Onboarding$OnboardingCompleted),
					_List_Nil);
			case 5:
				var dataResponse = msg.a;
				if (dataResponse.$ === 3) {
					var practice = dataResponse.a;
					var paymentProcessingRoute = (($author$project$Api$Provider$Practice$One$paymentProcessor(practice) === 'stripe') && (!A2($author$project$Api$Provider$Practice$One$featureEnabled, 26, practice))) ? $author$project$Spa$Generated$Route$Admin__Stripe : $author$project$Spa$Generated$Route$Admin__PaymentProcessing;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ZV: practice}),
						A2($author$project$Utils$Route$navigateAndReload, $elm$core$Dict$empty, paymentProcessingRoute),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(dataResponse));
				}
			case 6:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cP: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 7:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bK: A2($author$project$Components$Practice$PaymentSources$Standard$initCards, response, model.bK)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 8:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bK: A2($author$project$Components$Practice$PaymentSources$Standard$initBankAccounts, response, model.bK)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			default:
				var label = msg.a;
				var url = msg.b;
				return _Utils_Tuple3(
					model,
					A3($author$project$Utils$Analytics$HintBilling$logLinkClickedEvent, model.aa4, label, url),
					_List_Nil);
		}
	});
var $author$project$Pages$Onboarding$AnalyticsLinkClicked = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Pages$Onboarding$CompleteOnboardingClicked = {$: 3};
var $author$project$Pages$Onboarding$SkipPaymentRequirementClicked = {$: 4};
var $author$project$Pages$Onboarding$hasAnyPaymentSource = function (model) {
	var _v0 = _Utils_Tuple2(model.rs, model.rC);
	if ((_v0.a.$ === 3) && (_v0.b.$ === 3)) {
		var _v1 = _v0.a;
		var bankAccounts = _v1.a;
		var _v2 = _v0.b;
		var cards = _v2.a;
		return ($elm$core$List$length(bankAccounts) + $elm$core$List$length(cards)) > 0;
	} else {
		return false;
	}
};
var $author$project$Pages$Onboarding$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Onboarding$PracticePaymentSourcesMsg,
				$author$project$Components$Practice$PaymentSources$Standard$modal(model.bK)),
				$author$project$Ui$Typography$heading(
				_List_fromArray(
					[
						$elm$html$Html$text('Welcome to Hint!')
					])),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$bold]),
								_List_fromArray(
									[
										$elm$html$Html$text('Payment Methods')
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$muted]),
								_List_fromArray(
									[
										$elm$html$Html$text('Add a payment method that will be used for Hint fees')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								function () {
								var _v0 = _Utils_Tuple2(model.nI, model.cP);
								_v0$1:
								while (true) {
									_v0$3:
									while (true) {
										switch (_v0.a.$) {
											case 1:
												var _v1 = _v0.a;
												return $author$project$Components$HintBilling$NextBill$skeleton;
											case 3:
												switch (_v0.b.$) {
													case 1:
														break _v0$1;
													case 3:
														var _v3 = _v0.a;
														var feePlan_ = _v3.a;
														var _v4 = _v0.b;
														var practicePricing_ = _v4.a;
														return $author$project$Api$Provider$PracticePricing$One$isLegacyPricing(practicePricing_) ? A4(
															$author$project$Components$HintBilling$LegacyPricing$view,
															model.dd,
															feePlan_,
															$author$project$Api$Provider$PracticePricing$One$pmpmFeeInCents(practicePricing_),
															$author$project$Api$Provider$PracticePricing$One$billableProducts(practicePricing_)) : A2(
															$author$project$Ui$Element$view,
															_List_Nil,
															_List_fromArray(
																[
																	A2($author$project$Components$HintBilling$NextBill$view, practicePricing_, $author$project$Utils$Html$empty),
																	A2($elm$html$Html$br, _List_Nil, _List_Nil),
																	A5(
																	$author$project$Components$HintBilling$Pricing$view,
																	model.nI,
																	model.dd,
																	$author$project$Api$Provider$Practice$One$hasClinicalAccount(model.ZV),
																	$author$project$Pages$Onboarding$AnalyticsLinkClicked,
																	practicePricing_)
																]));
													default:
														break _v0$3;
												}
											default:
												if (_v0.b.$ === 1) {
													break _v0$1;
												} else {
													break _v0$3;
												}
										}
									}
									return $author$project$Components$HintBilling$NextBill$skeleton;
								}
								var _v2 = _v0.b;
								return $author$project$Components$HintBilling$NextBill$skeleton;
							}(),
								$author$project$Ui$HorizontalRule$view(_List_Nil),
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Onboarding$PracticePaymentSourcesMsg,
								A2($author$project$Components$Practice$PaymentSources$Standard$view, model.bK, false))
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_fromArray(
							[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$gap2]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Continue to next step'},
								_List_fromArray(
									[
										$author$project$Ui$Button$primary,
										$author$project$Ui$Button$disabled(
										!$author$project$Pages$Onboarding$hasAnyPaymentSource(model.bK)),
										$author$project$Ui$Button$onClick($author$project$Pages$Onboarding$CompleteOnboardingClicked)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Continue')
									])),
								model.Ij ? A3(
								$author$project$Ui$HinterOnly$button,
								{mm: 'Skip payment requirement'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$onClick($author$project$Pages$Onboarding$SkipPaymentRequirementClicked)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Skip payment requirement')
									])) : $author$project$Utils$Html$empty
							]))
					]))
			]),
		ac9: 'Onboarding'
	};
};
var $author$project$Pages$Onboarding$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Onboarding$init, aiq: $author$project$Pages$Onboarding$load, k8: $author$project$Pages$Onboarding$save, alO: $author$project$Pages$Onboarding$subscriptions, adT: $author$project$Pages$Onboarding$update, amo: $author$project$Pages$Onboarding$view});
var $author$project$Spa$Page$applicationPartner = function (page) {
	return {
		ah_: F2(
			function (shared, url) {
				var _v0 = _Utils_Tuple2(shared.aa4, shared.YN);
				_v0$2:
				while (true) {
					_v0$4:
					while (true) {
						switch (_v0.a.$) {
							case 3:
								switch (_v0.b.$) {
									case 3:
										var _v1 = _v0.a;
										var session = _v1.a;
										var _v2 = _v0.b;
										var partner = _v2.a;
										return (!A3($author$project$Spa$Page$authorizeUrl, session, shared.ahK, shared.adY)) ? _Utils_Tuple3(
											$author$project$Spa$Page$SessionLoading(url),
											A2(
												$author$project$Utils$Route$navigate,
												$elm$core$Dict$empty,
												A2($author$project$Permission$homeStateFor, session, shared.ahK)),
											_List_Nil) : A2(
											$author$project$Utils$Tuple3$mapFirst,
											$author$project$Spa$Page$SessionLoaded,
											A2(
												$author$project$Utils$Tuple3$fromTuple2,
												_List_Nil,
												A4(page.ah_, session, partner, shared, url)));
									case 2:
										break _v0$2;
									default:
										break _v0$4;
								}
							case 2:
								return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
							case 0:
								if (_v0.b.$ === 2) {
									break _v0$2;
								} else {
									var _v3 = _v0.a;
									return _Utils_Tuple3(
										$author$project$Spa$Page$SessionLoading(url),
										$author$project$Ports$Session$authorize(
											{aku: true}),
										_List_Nil);
								}
							default:
								if (_v0.b.$ === 2) {
									break _v0$2;
								} else {
									break _v0$4;
								}
						}
					}
					return _Utils_Tuple3(
						$author$project$Spa$Page$SessionLoading(url),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
				return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
			}),
		aiq: F2(
			function (shared, model) {
				var _v4 = _Utils_Tuple3(shared.aa4, shared.YN, model);
				_v4$2:
				while (true) {
					_v4$3:
					while (true) {
						if (!_v4.c.$) {
							switch (_v4.a.$) {
								case 3:
									switch (_v4.b.$) {
										case 3:
											var _v5 = _v4.a;
											var session = _v5.a;
											var _v6 = _v4.b;
											var partner = _v6.a;
											var url = _v4.c.a;
											if (!A3($author$project$Spa$Page$authorizeUrl, session, shared.ahK, shared.adY)) {
												return _Utils_Tuple3(
													$author$project$Spa$Page$SessionLoading(url),
													A2(
														$author$project$Utils$Route$navigate,
														$elm$core$Dict$empty,
														A2($author$project$Permission$homeStateFor, session, shared.ahK)),
													_List_Nil);
											} else {
												var _v7 = A4(page.ah_, session, partner, shared, url);
												var pageModel = _v7.a;
												var cmd = _v7.b;
												return _Utils_Tuple3(
													$author$project$Spa$Page$SessionLoaded(pageModel),
													cmd,
													_List_Nil);
											}
										case 2:
											break _v4$2;
										default:
											break _v4$3;
									}
								case 2:
									return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
								default:
									if (_v4.b.$ === 2) {
										break _v4$2;
									} else {
										break _v4$3;
									}
							}
						} else {
							break _v4$3;
						}
					}
					if (model.$ === 1) {
						var modelWithSession = model.a;
						return A2(
							$author$project$Utils$Tuple3$fromTuple2,
							_List_Nil,
							A2(
								$elm$core$Tuple$mapFirst,
								$author$project$Spa$Page$SessionLoaded,
								A2(
									page.aiq,
									shared,
									_Utils_update(
										modelWithSession,
										{Gv: shared.Gv}))));
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				}
				return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
			}),
		k8: F2(
			function (model, shared) {
				if (model.$ === 1) {
					var modelWithSession = model.a;
					return A2(page.k8, modelWithSession, shared);
				} else {
					return shared;
				}
			}),
		alO: function (model) {
			if (model.$ === 1) {
				var modelWithSession = model.a;
				return page.alO(modelWithSession);
			} else {
				return $elm$core$Platform$Sub$none;
			}
		},
		adT: F2(
			function (msg, model) {
				if (model.$ === 1) {
					var modelWithSession = model.a;
					return A2(
						$author$project$Utils$Tuple3$mapFirst,
						$author$project$Spa$Page$SessionLoaded,
						A2(page.adT, msg, modelWithSession));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			}),
		amo: function (model) {
			if (model.$ === 1) {
				var modelWithSession = model.a;
				return page.amo(modelWithSession);
			} else {
				return {fO: $author$project$Components$BlankPage$view, ac9: 'Loading...'};
			}
		}
	};
};
var $author$project$Components$Partner$ManageApiKeys$Integrations = {$: 1};
var $author$project$Pages$Partner$ApiKeys$ManageGlobalApiKeysMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Partner$ApiKeys$ManageIntegrationsApiKeysMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$ManageApiKeys$Partner = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Partner$ApiKeys$RequestLimitsMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$ManageApiKeys$IntegrationResourceFilterMsg = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Partner$ManageApiKeys$Model = $elm$core$Basics$identity;
var $author$project$Components$Partner$ManageApiKeys$GotApiKeys = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$ManageApiKeys$fetchParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{ajJ: model.ajJ, akl: model.akl, alA: model.alA});
	};
};
var $author$project$Api$Partner$ApiKey$apiKeysPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['api_keys']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$ApiKey$All$ApiKey = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Partner$ApiKey$All$Record = function (integration) {
	return {T8: integration};
};
var $author$project$Api$Partner$Integration$Shared$Integration = $elm$core$Basics$identity;
var $author$project$Api$Partner$Integration$Shared$Record = F7(
	function (id, status, practiceActive, partnerActive, practice, authorizationCodeExchanged, webhookRequestsStartedFailingAt) {
		return {Mf: authorizationCodeExchanged, ahP: id, YO: partnerActive, ZV: practice, ZW: practiceActive, alH: status, Kq: webhookRequestsStartedFailingAt};
	});
var $author$project$Api$Partner$Practice$Shared$Practice = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Partner$Practice$Shared$Record = F2(
	function (organizationId, hasClinicalAccount) {
		return {S5: hasClinicalAccount, ajD: organizationId};
	});
var $author$project$Api$Partner$Practice$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'has_clinical_account',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'organization_id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Partner$Practice$Shared$Record)));
var $author$project$Api$Partner$Practice$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$Practice$Shared$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Partner$Practice$Min$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Partner$Practice$Shared$Practice)));
var $author$project$Api$Partner$Integration$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'webhook_requests_started_failing_at',
	$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'authorization_code_exchanged',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'practice',
			$author$project$Api$Partner$Practice$Shared$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'partner_active',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'practice_active',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'status',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Api$Partner$Integration$Shared$Record))))))));
var $author$project$Api$Partner$Integration$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$Integration$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$ApiKey$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'integration',
	$elm$json$Json$Decode$nullable($author$project$Api$Partner$Integration$Shared$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Partner$ApiKey$All$Record));
var $author$project$Api$Partner$ApiKey$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$ApiKey$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Partner$ApiKey$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Partner$ApiKey$All$ApiKey)));
var $author$project$Api$Partner$Common$ApiKey$listDefaults = {ajJ: $author$project$Api$Pagination$init, akl: $elm$core$Maybe$Nothing, alA: $author$project$Api$Sort$init};
var $author$project$Api$Partner$Common$ApiKey$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Partner$Common$ApiKey$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ),
				A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (q) {
						return _List_fromArray(
							[
								A2($author$project$Api$Param$string, 'q', q)
							]);
					},
					options.akl))
			]));
};
var $author$project$Api$Partner$ApiKey$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Partner$ApiKey$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Partner$Common$ApiKey$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Partner$ApiKey$apiKeysPath)));
	});
var $author$project$Api$Partner$Integration$integrationsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['integrations']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$Integration$ApiKey$apiKeysPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['api_keys']),
	$author$project$Api$Partner$Integration$integrationsPath);
var $author$project$Api$Partner$Integration$ApiKey$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Partner$ApiKey$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Partner$Common$ApiKey$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Partner$Integration$ApiKey$apiKeysPath)));
	});
var $author$project$Components$Partner$ManageApiKeys$fetchApiKeys = F2(
	function (apiClient, model) {
		var _v0 = model.YD;
		if (!_v0.$) {
			return A3(
				$author$project$Api$Partner$ApiKey$list,
				apiClient,
				$author$project$Components$Partner$ManageApiKeys$fetchParams(model),
				$author$project$Components$Partner$ManageApiKeys$GotApiKeys);
		} else {
			return A3(
				$author$project$Api$Partner$Integration$ApiKey$list,
				apiClient,
				$author$project$Components$Partner$ManageApiKeys$fetchParams(model),
				$author$project$Components$Partner$ManageApiKeys$GotApiKeys);
		}
	});
var $author$project$Components$ResourceFilter$Partner$Integration$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Api$Partner$Integration$All$Integration = $elm$core$Basics$identity;
var $author$project$Api$Partner$Integration$All$dateDecoder = A2(
	$elm$json$Json$Decode$andThen,
	A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromIsoString, $elm_community$json_extra$Json$Decode$Extra$fromResult),
	$elm$json$Json$Decode$string);
var $author$project$Api$Partner$Integration$All$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'next_bill_date',
	$elm$json$Json$Decode$nullable($author$project$Api$Partner$Integration$All$dateDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'subscription',
		$elm$json$Json$Decode$nullable($author$project$Api$Common$PartnerSubscription$Min$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'active_patient_count',
			$elm$json$Json$Decode$int,
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				$author$project$Api$Partner$Integration$Shared$decoder,
				$elm$json$Json$Decode$succeed(
					F4(
						function (shared, count, sub, bill) {
							return {KT: count, XP: bill, lk: shared, acz: sub};
						}))))));
var $author$project$Api$Partner$Integration$listDefaults = {ahP: $elm$core$Maybe$Nothing, ajJ: $author$project$Api$Pagination$init, akl: $elm$core$Maybe$Nothing, alA: $author$project$Api$Sort$init};
var $author$project$Api$Partner$Integration$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Partner$Integration$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ),
				function () {
				var _v0 = options.ahP;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.akl;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}()
			]));
};
var $author$project$Api$Partner$Integration$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Partner$Integration$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Partner$Integration$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Partner$Integration$integrationsPath)));
	});
var $author$project$Components$ResourceFilter$Partner$Integration$list = F3(
	function (apiClient, optionals, toMsg) {
		return A3($author$project$Api$Partner$Integration$list, apiClient, optionals, toMsg);
	});
var $author$project$Components$ResourceFilter$Partner$Integration$fetchResources = F4(
	function (toMsg, apiClient, pagination, query) {
		return A3(
			$author$project$Components$ResourceFilter$Partner$Integration$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{ajJ: pagination, akl: query});
			},
			toMsg);
	});
var $author$project$Components$ResourceFilter$Partner$Integration$retrieveResource = F3(
	function (toMsg, apiClient, id) {
		return A3(
			$author$project$Components$ResourceFilter$Partner$Integration$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						akl: $elm$core$Maybe$Just(id)
					});
			},
			toMsg);
	});
var $author$project$Components$ResourceFilter$Partner$Integration$selectId = 'partner-integrations';
var $author$project$Api$Partner$Practice$Min$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Partner$Practice$Shared$name = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Partner$Practice$Min$name(min);
};
var $author$project$Api$Partner$Integration$Shared$practice = function (_v0) {
	var record = _v0;
	return record.ZV;
};
var $author$project$Api$Partner$Integration$All$practice = function (_v0) {
	var record = _v0;
	return $author$project$Api$Partner$Integration$Shared$practice(record.lk);
};
var $author$project$Components$ResourceFilter$Partner$Integration$toTitle = A2($elm$core$Basics$composeR, $author$project$Api$Partner$Integration$All$practice, $author$project$Api$Partner$Practice$Shared$name);
var $author$project$Components$ResourceFilter$Partner$Integration$toLabel = function (resource) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Components$ResourceFilter$Partner$Integration$toTitle(resource))
		]);
};
var $author$project$Api$Partner$Integration$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Partner$Integration$All$id = function (_v0) {
	var record = _v0;
	return $author$project$Api$Partner$Integration$Shared$id(record.lk);
};
var $author$project$Components$ResourceFilter$Partner$Integration$toValue = $author$project$Api$Partner$Integration$All$id;
var $author$project$Components$ResourceFilter$Partner$Integration$init = F2(
	function (apiClient, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{Sk: $author$project$Components$ResourceFilter$Partner$Integration$fetchResources, ahP: $author$project$Components$ResourceFilter$Partner$Integration$selectId, k$: 'Integrations', uk: $author$project$Components$ResourceFilter$Partner$Integration$retrieveResource, u9: $author$project$Components$ResourceFilter$Partner$Integration$toLabel, lN: $author$project$Components$ResourceFilter$Partner$Integration$toTitle, hX: $author$project$Components$ResourceFilter$Partner$Integration$toValue},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{Jy: $author$project$Components$ResourceFilter$All, b8: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Api$Sort$withPrefix = F2(
	function (prefix, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{t1: prefix});
	});
var $author$project$Components$Partner$ManageApiKeys$init = F4(
	function (apiClient, timeFormatter, owner, query) {
		var prefix = function () {
			if (!owner.$) {
				return 'partner_';
			} else {
				return 'integrations_';
			}
		}();
		var q = A2($elm$core$Dict$get, prefix + 'q', query);
		var _v0 = A2(
			$author$project$Components$ResourceFilter$Partner$Integration$init,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Select a Practice'});
			});
		var integrationResourceFilter = _v0.a;
		var integrationResourceFilterCmd = _v0.b;
		var model = {
			ck: $author$project$Api$Data$Loading,
			je: $elm$core$Maybe$Nothing,
			n_: integrationResourceFilter,
			Io: $elm$core$Maybe$Nothing,
			YD: owner,
			ajJ: A2(
				$author$project$Api$Pagination$fromQuery,
				query,
				A2($author$project$Api$Pagination$withPrefix, prefix, $author$project$Api$Pagination$init)),
			akl: q,
			up: $author$project$Ui$SearchInput$init(q),
			alA: A3(
				$author$project$Api$Sort$withDefault,
				'created_at',
				1,
				A2(
					$author$project$Api$Sort$fromQuery,
					query,
					A2($author$project$Api$Sort$withPrefix, prefix, $author$project$Api$Sort$init))),
			J7: timeFormatter,
			cd: $elm$core$Set$empty,
			dR: $elm$core$Set$empty
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Components$Partner$ManageApiKeys$fetchApiKeys, apiClient, model),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Partner$ManageApiKeys$IntegrationResourceFilterMsg, integrationResourceFilterCmd)
					])));
	});
var $author$project$Components$Partner$RequestLimits$RequestLimitsLoaded = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Partner$RequestLimit$One$One = $elm$core$Basics$identity;
var $author$project$Api$Partner$RequestLimit$One$Record = F4(
	function (secondlyLimit, dailyLimit, dailyCount, perPathLimits) {
		return {Pt: dailyCount, Pu: dailyLimit, Zq: perPathLimits, aaD: secondlyLimit};
	});
var $author$project$Api$Partner$RequestLimit$PerPathLimit$PerPathLimit = $elm$core$Basics$identity;
var $author$project$Api$Partner$RequestLimit$PerPathLimit$Record = F2(
	function (path, limit) {
		return {VZ: limit, YX: path};
	});
var $author$project$Api$Partner$RequestLimit$PerPathLimit$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'limit',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'path',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Partner$RequestLimit$PerPathLimit$Record)));
var $author$project$Api$Partner$RequestLimit$PerPathLimit$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$RequestLimit$PerPathLimit$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$HinterOnly$Hidden = {$: 1};
var $author$project$Api$HinterOnly$Visible = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$HinterOnly$hinterOnly = F2(
	function (key, decoder) {
		return A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			key,
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						$elm$json$Json$Decode$null($author$project$Api$HinterOnly$Hidden),
						A2($elm$json$Json$Decode$map, $author$project$Api$HinterOnly$Visible, decoder)
					])),
			$author$project$Api$HinterOnly$Hidden);
	});
var $author$project$Api$Partner$RequestLimit$One$recordDecoder = A3(
	$author$project$Api$HinterOnly$hinterOnly,
	'per_path_limits',
	$elm$json$Json$Decode$list($author$project$Api$Partner$RequestLimit$PerPathLimit$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'daily_count',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'daily_limit',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'secondly_limit',
				$elm$json$Json$Decode$int,
				$elm$json$Json$Decode$succeed($author$project$Api$Partner$RequestLimit$One$Record)))));
var $author$project$Api$Partner$RequestLimit$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$RequestLimit$One$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$RequestLimit$requestLimitsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['request_limits']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$RequestLimit$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Partner$RequestLimit$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Partner$RequestLimit$requestLimitsPath));
	});
var $author$project$Components$Partner$RequestLimits$init = F2(
	function (apiClient, isHintAdmin) {
		return _Utils_Tuple2(
			{bw: $elm$core$Maybe$Nothing, j0: false, eD: false, Ij: isHintAdmin, cI: false, j2: false, eE: false, kX: $author$project$Api$Data$Loading},
			A2($author$project$Api$Partner$RequestLimit$retrieve, apiClient, $author$project$Components$Partner$RequestLimits$RequestLimitsLoaded));
	});
var $author$project$Pages$Partner$ApiKeys$init = F4(
	function (_v0, partner, shared, _v1) {
		var query = _v1.DE;
		var _v2 = A2(
			$author$project$Components$Partner$RequestLimits$init,
			shared.Gv,
			$author$project$Shared$isHintAdmin(shared));
		var requestLimits = _v2.a;
		var requestLimitsCmd = _v2.b;
		var _v3 = A4($author$project$Components$Partner$ManageApiKeys$init, shared.Gv, shared.J7, $author$project$Components$Partner$ManageApiKeys$Integrations, query);
		var manageIntegrationsApiKeys = _v3.a;
		var manageIntegrationsApiKeysCmd = _v3.b;
		var _v4 = A4(
			$author$project$Components$Partner$ManageApiKeys$init,
			shared.Gv,
			shared.J7,
			$author$project$Components$Partner$ManageApiKeys$Partner(partner),
			query);
		var manageGlobalApiKeys = _v4.a;
		var manageGlobalApiKeysCmd = _v4.b;
		var model = {Gv: shared.Gv, ov: manageGlobalApiKeys, ox: manageIntegrationsApiKeys, kX: requestLimits};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$ApiKeys$RequestLimitsMsg, requestLimitsCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$ApiKeys$ManageGlobalApiKeysMsg, manageGlobalApiKeysCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$ApiKeys$ManageIntegrationsApiKeysMsg, manageIntegrationsApiKeysCmd)
					])));
	});
var $author$project$Pages$Partner$ApiKeys$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Partner$ApiKeys$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Partner$ManageApiKeys$CancelEdit = {$: 6};
var $author$project$Components$ResourceFilter$Partner$Integration$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.b8));
};
var $author$project$Components$Partner$ManageApiKeys$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Partner$ManageApiKeys$CancelEdit)),
					model.Io)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Partner$ManageApiKeys$IntegrationResourceFilterMsg,
				$author$project$Components$ResourceFilter$Partner$Integration$subscriptions(model.n_))
			]));
};
var $author$project$Components$Partner$RequestLimits$BlockConfirmationClosed = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Partner$RequestLimits$DraftCanceled = {$: 9};
var $author$project$Components$Partner$RequestLimits$ResetConfirmationClosed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$RequestLimits$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				function () {
				var _v0 = model.bw;
				if (!_v0.$) {
					return $author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Partner$RequestLimits$DraftCanceled);
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				model.j2 ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$Partner$RequestLimits$ResetConfirmationClosed) : $elm$core$Platform$Sub$none,
				model.j0 ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$Partner$RequestLimits$BlockConfirmationClosed) : $elm$core$Platform$Sub$none
			]));
};
var $author$project$Pages$Partner$ApiKeys$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Partner$ApiKeys$RequestLimitsMsg,
				$author$project$Components$Partner$RequestLimits$subscriptions(model.kX)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Partner$ApiKeys$ManageGlobalApiKeysMsg,
				$author$project$Components$Partner$ManageApiKeys$subscriptions(model.ov)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Partner$ApiKeys$ManageIntegrationsApiKeysMsg,
				$author$project$Components$Partner$ManageApiKeys$subscriptions(model.ox))
			]));
};
var $author$project$Components$Partner$ManageApiKeys$IntegrationField = function (a) {
	return {$: 1, a: a};
};
var $author$project$OutMsg$RefreshPartner = {$: 3};
var $author$project$Components$Partner$ManageApiKeys$SearchInputMsg = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$Partner$ManageApiKeys$WebhooksSignatureApiKeyUpdated = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Components$Partner$ManageApiKeys$Deleted = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Api$Partner$ApiKey$apiKeyPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Partner$ApiKey$apiKeysPath);
};
var $author$project$Api$Partner$ApiKey$delete = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Partner$ApiKey$apiKeyPath(id)));
	});
var $author$project$Api$Partner$Integration$ApiKey$apiKeyPath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		$author$project$Api$Partner$Integration$ApiKey$apiKeysPath);
};
var $author$project$Api$Partner$Integration$ApiKey$delete = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Partner$Integration$ApiKey$apiKeyPath(id)));
	});
var $author$project$Api$Partner$ApiKey$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Partner$ApiKey$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$ApiKey$Shared$id(shared);
};
var $author$project$Components$Partner$ManageApiKeys$deleteItem = F3(
	function (apiClient, owner, item) {
		if (!owner.$) {
			return A3(
				$author$project$Api$Partner$ApiKey$delete,
				apiClient,
				$author$project$Api$Partner$ApiKey$All$id(item),
				$author$project$Components$Partner$ManageApiKeys$Deleted(item));
		} else {
			return A3(
				$author$project$Api$Partner$Integration$ApiKey$delete,
				apiClient,
				$author$project$Api$Partner$ApiKey$All$id(item),
				$author$project$Components$Partner$ManageApiKeys$Deleted(item));
		}
	});
var $author$project$Api$Partner$ApiKey$All$integration = function (_v0) {
	var record = _v0.b;
	return record.T8;
};
var $author$project$Api$Partner$ApiKey$Shared$label = function (_v0) {
	var record = _v0;
	return record.aih;
};
var $author$project$Api$Partner$ApiKey$All$label = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$ApiKey$Shared$label(shared);
};
var $author$project$Components$Partner$ManageApiKeys$formFieldsFromItem = function (apiKey) {
	return _Utils_Tuple2(
		{
			T8: A2(
				$elm$core$Maybe$map,
				$author$project$Api$Partner$Integration$Shared$id,
				$author$project$Api$Partner$ApiKey$All$integration(apiKey)),
			aih: $author$project$Api$Partner$ApiKey$All$label(apiKey)
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Components$Partner$ManageApiKeys$formFieldsInit = _Utils_Tuple2(
	{T8: $elm$core$Maybe$Nothing, aih: $elm$core$Maybe$Nothing},
	$elm$core$Platform$Cmd$none);
var $author$project$Components$Partner$ManageApiKeys$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var string = field.a;
			return _Utils_update(
				fields,
				{
					aih: $author$project$Utils$String$toMaybe(string)
				});
		} else {
			var integration = field.a;
			return _Utils_update(
				fields,
				{T8: integration});
		}
	});
var $author$project$Components$Partner$ManageApiKeys$IntegrationValidation = 0;
var $author$project$Components$Partner$ManageApiKeys$validateIntegration = F2(
	function (owner, fields) {
		if (!owner.$) {
			return _List_Nil;
		} else {
			return _Utils_eq(fields.T8, $elm$core$Maybe$Nothing) ? _List_fromArray(
				[
					_Utils_Tuple2(0, 'Practice is required')
				]) : _List_Nil;
		}
	});
var $author$project$Components$Partner$ManageApiKeys$formFieldsValidator = function (owner) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$Partner$ManageApiKeys$validateIntegration(owner))
			]));
};
var $author$project$Components$Partner$ManageApiKeys$Created = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Partner$ApiKey$One$ApiKey = 0;
var $author$project$Api$Partner$ApiKey$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Partner$ApiKey$create = F3(
	function (apiClient, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'api_key',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'label',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.aih))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$ApiKey$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Partner$ApiKey$apiKeysPath)));
	});
var $author$project$Api$Partner$Integration$ApiKey$create = F3(
	function (apiClient, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'api_key',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'label',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.aih)),
								_Utils_Tuple2(
								'integration',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, params.T8))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$ApiKey$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Partner$Integration$ApiKey$apiKeysPath)));
	});
var $author$project$Components$Partner$ManageApiKeys$integrationApiKeyApiFields = function (fields) {
	return {T8: fields.T8, aih: fields.aih};
};
var $author$project$Components$Partner$ManageApiKeys$partnerApiKeyApiFields = function (fields) {
	return {aih: fields.aih};
};
var $author$project$Components$Partner$ManageApiKeys$createItem = F3(
	function (apiClient, owner, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		if (!owner.$) {
			return A3(
				$author$project$Api$Partner$ApiKey$create,
				apiClient,
				$author$project$Components$Partner$ManageApiKeys$partnerApiKeyApiFields(fields),
				$author$project$Components$Partner$ManageApiKeys$Created);
		} else {
			return A3(
				$author$project$Api$Partner$Integration$ApiKey$create,
				apiClient,
				$author$project$Components$Partner$ManageApiKeys$integrationApiKeyApiFields(fields),
				$author$project$Components$Partner$ManageApiKeys$Created);
		}
	});
var $author$project$Components$Partner$ManageApiKeys$Updated = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Partner$ApiKey$update = F4(
	function (apiClient, id, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'api_key',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'label',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.aih))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Partner$ApiKey$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Partner$ApiKey$apiKeyPath(id))));
	});
var $author$project$Api$Partner$Integration$ApiKey$update = F4(
	function (apiClient, id, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'api_key',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'label',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.aih))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Partner$ApiKey$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Partner$Integration$ApiKey$apiKeyPath(id))));
	});
var $author$project$Components$Partner$ManageApiKeys$updateItem = F4(
	function (apiClient, owner, id, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		if (!owner.$) {
			return A4(
				$author$project$Api$Partner$ApiKey$update,
				apiClient,
				id,
				{aih: fields.aih},
				$author$project$Components$Partner$ManageApiKeys$Updated);
		} else {
			return A4(
				$author$project$Api$Partner$Integration$ApiKey$update,
				apiClient,
				id,
				{aih: fields.aih},
				$author$project$Components$Partner$ManageApiKeys$Updated);
		}
	});
var $author$project$Components$Partner$ManageApiKeys$saveItem = F4(
	function (apiClient, owner, maybeId, formFields) {
		if (!maybeId.$) {
			var id_ = maybeId.a;
			return A4($author$project$Components$Partner$ManageApiKeys$updateItem, apiClient, owner, id_, formFields);
		} else {
			return A3($author$project$Components$Partner$ManageApiKeys$createItem, apiClient, owner, formFields);
		}
	});
var $author$project$Components$ResourceFilter$Partner$Integration$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.b8);
		var modelAfterEvent = function () {
			var _v1 = result.agZ;
			if (!_v1.$) {
				var selected = _v1.a;
				return _Utils_update(
					model,
					{Jy: selected});
			} else {
				return model;
			}
		}();
		return {
			GZ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.GZ),
			agZ: result.agZ,
			aiO: _Utils_update(
				modelAfterEvent,
				{b8: result.aiO}),
			aR: result.aR
		};
	});
var $author$project$Components$Partner$ManageApiKeys$qKey = function (owner) {
	if (!owner.$) {
		return 'partner_q';
	} else {
		return 'integrations_q';
	}
};
var $author$project$Components$Partner$ManageApiKeys$updateUrl = function (model) {
	return $author$project$Ports$Navigation$replaceUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Partner__ApiKeys)
				]),
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$map,
							$elm$url$Url$Builder$string(
								$author$project$Components$Partner$ManageApiKeys$qKey(model.YD)),
							model.akl)
						])),
				_Utils_ap(
					$author$project$Api$Sort$toQuery(model.alA),
					$author$project$Api$Pagination$toPageQuery(model.ajJ)))));
};
var $author$project$Api$Partner$Partner$updateWebhooksSignatureApiKey = F3(
	function (apiClient, id, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'webhooks_signature_api_key',
					$author$project$Utils$Encode$association(id))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Partner$Partner$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['webhooks_signature_api_key']),
						$author$project$Api$Partner$Partner$partnerPath))));
	});
var $author$project$Components$ResourceFilter$Partner$Integration$value = function (model) {
	return A2($author$project$Components$ResourceFilter$choiceToValue, model.b8, model.Jy);
};
var $author$project$Components$Partner$ManageApiKeys$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ck: response,
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ck: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{ck: $author$project$Api$Data$Loading, ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Partner$ManageApiKeys$fetchApiKeys, apiClient, newModel),
								$author$project$Components$Partner$ManageApiKeys$updateUrl(newModel)
							])),
					_List_Nil);
			case 2:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ck: $author$project$Api$Data$Loading,
						alA: A2($author$project$Api$Sort$update, columnId, model.alA)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Partner$ManageApiKeys$fetchApiKeys, apiClient, newModel),
								$author$project$Components$Partner$ManageApiKeys$updateUrl(newModel)
							])),
					_List_Nil);
			case 14:
				var tokenStr = msg.a;
				return _Utils_Tuple3(
					model,
					$author$project$Ports$Clipboard$copy(tokenStr),
					_List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 3, 'Copied to clipboard.')
						]));
			case 3:
				var id = msg.a;
				var visibleApiKeyTokens = A2($elm$core$Set$member, id, model.dR) ? A2($elm$core$Set$remove, id, model.dR) : A2($elm$core$Set$insert, id, model.dR);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dR: visibleApiKeyTokens}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var _v3 = $author$project$Components$Partner$ManageApiKeys$formFieldsInit;
				var formFields = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							Io: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init(formFields),
									$author$project$Api$Data$NotAsked))
						}),
					cmd,
					_List_Nil);
			case 5:
				var item = msg.a;
				var _v4 = $author$project$Components$Partner$ManageApiKeys$formFieldsFromItem(item);
				var formFields = _v4.a;
				var cmd = _v4.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							Io: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(item),
									$author$project$Utils$Form$init(formFields),
									$author$project$Api$Data$NotAsked))
						}),
					cmd,
					_List_Nil);
			case 6:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Io: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 7:
				var field = msg.a;
				var _v5 = model.Io;
				if (!_v5.$) {
					var _v6 = _v5.a;
					var id = _v6.a;
					var form = _v6.b;
					var request = _v6.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Partner$ManageApiKeys$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Io: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, request))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 8:
				var item = msg.a;
				var form = msg.b;
				var _v7 = A2(
					$author$project$Utils$Form$validate,
					$author$project$Components$Partner$ManageApiKeys$formFieldsValidator(model.YD),
					form);
				if (!_v7.$) {
					var _v8 = _v7.a;
					var validatedForm = _v8.a;
					var validFormFields = _v8.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Io: $elm$core$Maybe$Just(
									_Utils_Tuple3(item, validatedForm, $author$project$Api$Data$Loading))
							}),
						A4(
							$author$project$Components$Partner$ManageApiKeys$saveItem,
							apiClient,
							model.YD,
							A2($elm$core$Maybe$map, $author$project$Api$Partner$ApiKey$All$id, item),
							validFormFields),
						_List_Nil);
				} else {
					var validatedForm = _v7.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Io: $elm$core$Maybe$Just(
									_Utils_Tuple3(item, validatedForm, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 9:
				var response = msg.a;
				var _v9 = model.Io;
				if (!_v9.$) {
					var _v10 = _v9.a;
					var id = _v10.a;
					var form = _v10.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{ck: $author$project$Api$Data$Loading, Io: $elm$core$Maybe$Nothing}),
							A2($author$project$Components$Partner$ManageApiKeys$fetchApiKeys, apiClient, model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Successfully created api key'),
									$author$project$OutMsg$RefreshPartner
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									Io: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 10:
				var response = msg.a;
				var _v12 = model.Io;
				if (!_v12.$) {
					var _v13 = _v12.a;
					var id = _v13.a;
					var form = _v13.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{ck: $author$project$Api$Data$Loading, Io: $elm$core$Maybe$Nothing}),
							A2($author$project$Components$Partner$ManageApiKeys$fetchApiKeys, apiClient, model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Successfully updated api key')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									Io: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 11:
				var item = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							je: $elm$core$Maybe$Just(item)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 12:
				var item = msg.a;
				var confirmed = msg.b;
				if (confirmed) {
					var id = $author$project$Api$Partner$ApiKey$All$id(item);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								je: $elm$core$Maybe$Nothing,
								cd: A2($elm$core$Set$insert, id, model.cd)
							}),
						A3($author$project$Components$Partner$ManageApiKeys$deleteItem, apiClient, model.YD, item),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{je: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 13:
				var item = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ck: $author$project$Api$Data$Loading,
									cd: A2(
										$elm$core$Set$remove,
										$author$project$Api$Partner$ApiKey$All$id(item),
										model.cd)
								}),
							A2($author$project$Components$Partner$ManageApiKeys$fetchApiKeys, apiClient, model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Api key was successfully removed.'),
									$author$project$OutMsg$RefreshPartner
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									cd: A2(
										$elm$core$Set$remove,
										$author$project$Api$Partner$ApiKey$All$id(item),
										model.cd)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 15:
				var item = msg.a;
				var _v16 = model.YD;
				if (!_v16.$) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cd: A2(
									$elm$core$Set$insert,
									$author$project$Api$Partner$ApiKey$All$id(item),
									model.cd)
							}),
						A3(
							$author$project$Api$Partner$Partner$updateWebhooksSignatureApiKey,
							apiClient,
							$author$project$Api$Partner$ApiKey$All$id(item),
							$author$project$Components$Partner$ManageApiKeys$WebhooksSignatureApiKeyUpdated(item)),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 16:
				var item = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						var partner = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ck: $author$project$Api$Data$Loading,
									YD: $author$project$Components$Partner$ManageApiKeys$Partner(partner),
									cd: A2(
										$elm$core$Set$remove,
										$author$project$Api$Partner$ApiKey$All$id(item),
										model.cd)
								}),
							A2($author$project$Components$Partner$ManageApiKeys$fetchApiKeys, apiClient, model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Successfully updated webhooks signature api key')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									cd: A2(
										$elm$core$Set$remove,
										$author$project$Api$Partner$ApiKey$All$id(item),
										model.cd)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 17:
				var subMsg = msg.a;
				var integrationResourceResult = A3($author$project$Components$ResourceFilter$Partner$Integration$update, apiClient, subMsg, model.n_);
				var item = function () {
					var _v18 = _Utils_Tuple2(model.Io, integrationResourceResult.agZ);
					if (!_v18.a.$) {
						if (!_v18.b.$) {
							var _v19 = _v18.a.a;
							var id = _v19.a;
							var form = _v19.b;
							var request = _v19.c;
							var updatedForm = A3(
								$author$project$Utils$Form$update,
								$author$project$Components$Partner$ManageApiKeys$formFieldsUpdate,
								$author$project$Components$Partner$ManageApiKeys$IntegrationField(
									$author$project$Components$ResourceFilter$Partner$Integration$value(integrationResourceResult.aiO)),
								form);
							return $elm$core$Maybe$Just(
								_Utils_Tuple3(id, updatedForm, request));
						} else {
							var item_ = _v18.a.a;
							return $elm$core$Maybe$Just(item_);
						}
					} else {
						var _v20 = _v18.a;
						return $elm$core$Maybe$Nothing;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{n_: integrationResourceResult.aiO, Io: item}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Partner$ManageApiKeys$IntegrationResourceFilterMsg, integrationResourceResult.GZ),
					integrationResourceResult.aR);
			default:
				var subMsg = msg.a;
				var _v21 = A2($author$project$Ui$SearchInput$update, subMsg, model.up);
				var searchInput = _v21.a;
				var searchInputCmd = _v21.b;
				var searchInputEvent = _v21.c;
				if (searchInputEvent.$ === 1) {
					var q = searchInputEvent.a;
					var newModel = _Utils_update(
						model,
						{
							ck: $author$project$Api$Data$Loading,
							ajJ: $author$project$Api$Pagination$reset(model.ajJ),
							akl: q,
							up: searchInput
						});
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Partner$ManageApiKeys$SearchInputMsg, searchInputCmd),
									A2($author$project$Components$Partner$ManageApiKeys$fetchApiKeys, apiClient, newModel),
									$author$project$Components$Partner$ManageApiKeys$updateUrl(newModel)
								])),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{up: searchInput}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Partner$ManageApiKeys$SearchInputMsg, searchInputCmd),
						_List_Nil);
				}
		}
	});
var $author$project$Components$Partner$RequestLimits$EditingDraft = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$RequestLimits$NewDraft = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$RequestLimits$PerPathMutated = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Components$Partner$RequestLimits$RequestLimitsBlocked = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Partner$RequestLimits$RequestLimitsReset = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Partner$RequestLimit$blockForDay = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$RequestLimit$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['block_for_day']),
					$author$project$Api$Partner$RequestLimit$requestLimitsPath)));
	});
var $author$project$Api$Partner$RequestLimit$PerPathLimits$encodeBody = function (body) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'per_path_limit',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'path',
							$elm$json$Json$Encode$string(body.YX)),
							_Utils_Tuple2(
							'limit',
							$elm$json$Json$Encode$int(body.VZ))
						])))
			]));
};
var $author$project$Api$Partner$RequestLimit$PerPathLimits$perPathLimitsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['request_limits', 'per_path_limits']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$RequestLimit$PerPathLimits$create = F3(
	function (apiClient, body, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$RequestLimit$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Partner$RequestLimit$PerPathLimits$encodeBody(body),
				$author$project$Api$Data$requestTo($author$project$Api$Partner$RequestLimit$PerPathLimits$perPathLimitsPath)));
	});
var $author$project$Api$Partner$RequestLimit$PerPathLimits$delete = F3(
	function (apiClient, path_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Partner$RequestLimit$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						[
							$elm$url$Url$percentEncode(path_)
						]),
					$author$project$Api$Partner$RequestLimit$PerPathLimits$perPathLimitsPath)));
	});
var $author$project$Components$Partner$RequestLimits$draftForm = function (draft) {
	if (!draft.$) {
		var form = draft.a;
		return form;
	} else {
		var form = draft.a;
		return form;
	}
};
var $author$project$Components$Partner$RequestLimits$LimitValidation = 1;
var $author$project$Components$Partner$RequestLimits$PathValidation = 0;
var $author$project$Components$Partner$RequestLimits$apiPathPrefix = '/api/';
var $author$project$Components$Partner$RequestLimits$isPositiveInt = function (string) {
	var _v0 = $elm$core$String$toInt(string);
	if (!_v0.$) {
		var n = _v0.a;
		return n > 0;
	} else {
		return false;
	}
};
var $author$project$Components$Partner$RequestLimits$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifFalse,
			function (fields) {
				return A2($elm$core$String$startsWith, $author$project$Components$Partner$RequestLimits$apiPathPrefix, fields.YX);
			},
			_Utils_Tuple2(0, 'Path must start with ' + $author$project$Components$Partner$RequestLimits$apiPathPrefix)),
			A2(
			$rtfeldman$elm_validate$Validate$ifFalse,
			function (fields) {
				return $author$project$Components$Partner$RequestLimits$isPositiveInt(fields.VZ);
			},
			_Utils_Tuple2(1, 'Must be a positive integer'))
		]));
var $author$project$Components$Partner$RequestLimits$initFormFields = {VZ: '', YX: $author$project$Components$Partner$RequestLimits$apiPathPrefix};
var $author$project$Api$Partner$RequestLimit$PerPathLimit$limit = function (_v0) {
	var record = _v0;
	return record.VZ;
};
var $author$project$Api$Partner$RequestLimit$PerPathLimit$path = function (_v0) {
	var record = _v0;
	return record.YX;
};
var $author$project$Api$Partner$RequestLimit$resetDailyLimit = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$RequestLimit$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['reset_daily_limit']),
					$author$project$Api$Partner$RequestLimit$requestLimitsPath)));
	});
var $author$project$Components$Partner$RequestLimits$setDraftForm = F2(
	function (form, draft) {
		if (!draft.$) {
			return $author$project$Components$Partner$RequestLimits$NewDraft(form);
		} else {
			return $author$project$Components$Partner$RequestLimits$EditingDraft(form);
		}
	});
var $author$project$Components$Partner$RequestLimits$updateFormFields = F2(
	function (field, fields) {
		if (!field.$) {
			var path = field.a;
			return _Utils_update(
				fields,
				{YX: path});
		} else {
			var limit = field.a;
			return _Utils_update(
				fields,
				{VZ: limit});
		}
	});
var $author$project$Components$Partner$RequestLimits$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{kX: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{j2: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var confirmed = msg.a;
				return model.eE ? _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil) : (confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{eE: true}),
					A2($author$project$Api$Partner$RequestLimit$resetDailyLimit, apiClient, $author$project$Components$Partner$RequestLimits$RequestLimitsReset),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{j2: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil));
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{j2: false, eE: false, kX: response}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Daily request limit reset')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{eE: false}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{j0: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var confirmed = msg.a;
				return model.eD ? _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil) : (confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{eD: true}),
					A2($author$project$Api$Partner$RequestLimit$blockForDay, apiClient, $author$project$Components$Partner$RequestLimits$RequestLimitsBlocked),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{j0: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil));
			case 6:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{j0: false, eD: false, kX: response}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Daily request limit blocked')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{eD: false}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 7:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bw: $elm$core$Maybe$Just(
								$author$project$Components$Partner$RequestLimits$NewDraft(
									$author$project$Utils$Form$init($author$project$Components$Partner$RequestLimits$initFormFields)))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 8:
				var limit = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bw: $elm$core$Maybe$Just(
								$author$project$Components$Partner$RequestLimits$EditingDraft(
									$author$project$Utils$Form$init(
										{
											VZ: $elm$core$String$fromInt(
												$author$project$Api$Partner$RequestLimit$PerPathLimit$limit(limit)),
											YX: $author$project$Api$Partner$RequestLimit$PerPathLimit$path(limit)
										})))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 9:
				return model.cI ? _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{bw: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 10:
				var field = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bw: A2(
								$elm$core$Maybe$map,
								function (draft) {
									return A2(
										$author$project$Components$Partner$RequestLimits$setDraftForm,
										$author$project$Utils$Form$fromValidateResult(
											A2(
												$author$project$Utils$Form$validate,
												$author$project$Components$Partner$RequestLimits$formFieldsValidator,
												A3(
													$author$project$Utils$Form$update,
													$author$project$Components$Partner$RequestLimits$updateFormFields,
													field,
													$author$project$Components$Partner$RequestLimits$draftForm(draft)))),
										draft);
								},
								model.bw)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 11:
				var form = msg.a;
				var _v3 = _Utils_Tuple2(
					A2($author$project$Utils$Form$validate, $author$project$Components$Partner$RequestLimits$formFieldsValidator, form),
					model.bw);
				if (!_v3.a.$) {
					var _v4 = _v3.a.a;
					var validFields = _v4.b;
					var fields = $rtfeldman$elm_validate$Validate$fromValid(validFields);
					var _v5 = $elm$core$String$toInt(fields.VZ);
					if (!_v5.$) {
						var limit = _v5.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{cI: true}),
							A3(
								$author$project$Api$Partner$RequestLimit$PerPathLimits$create,
								apiClient,
								{VZ: limit, YX: fields.YX},
								$author$project$Components$Partner$RequestLimits$PerPathMutated('Per-path override saved')),
							_List_Nil);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				} else {
					if (!_v3.b.$) {
						var invalidForm = _v3.a.a;
						var draft = _v3.b.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bw: $elm$core$Maybe$Just(
										A2($author$project$Components$Partner$RequestLimits$setDraftForm, invalidForm, draft))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						var _v6 = _v3.b;
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				}
			case 13:
				var path = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cI: true}),
					A3(
						$author$project$Api$Partner$RequestLimit$PerPathLimits$delete,
						apiClient,
						path,
						$author$project$Components$Partner$RequestLimits$PerPathMutated('Per-path override removed')),
					_List_Nil);
			default:
				var successToast = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bw: $elm$core$Maybe$Nothing, cI: false, kX: response}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, successToast)
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cI: false}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Partner$ApiKeys$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A3($author$project$Components$Partner$RequestLimits$update, model.Gv, subMsg, model.kX);
				var requestLimits = _v1.a;
				var requestLimitsCmd = _v1.b;
				var requestLimitsOutMsgs = _v1.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{kX: requestLimits}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$ApiKeys$RequestLimitsMsg, requestLimitsCmd),
					requestLimitsOutMsgs);
			case 1:
				var subMsg = msg.a;
				var _v2 = A3($author$project$Components$Partner$ManageApiKeys$update, model.Gv, subMsg, model.ov);
				var manageGlobalApiKeys = _v2.a;
				var manageGlobalApiKeysCmd = _v2.b;
				var manageGlobalApiKeysOutMsgs = _v2.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ov: manageGlobalApiKeys}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$ApiKeys$ManageGlobalApiKeysMsg, manageGlobalApiKeysCmd),
					manageGlobalApiKeysOutMsgs);
			default:
				var subMsg = msg.a;
				var _v3 = A3($author$project$Components$Partner$ManageApiKeys$update, model.Gv, subMsg, model.ox);
				var manageIntegrationsApiKeys = _v3.a;
				var manageIntegrationsApiKeysCmd = _v3.b;
				var manageIntegrationsApiKeysOutMsgs = _v3.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ox: manageIntegrationsApiKeys}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$ApiKeys$ManageIntegrationsApiKeysMsg, manageIntegrationsApiKeysCmd),
					manageIntegrationsApiKeysOutMsgs);
		}
	});
var $author$project$Components$Partner$ManageApiKeys$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Components$Partner$ManageApiKeys$New = {$: 4};
var $author$project$Components$Partner$ManageApiKeys$PaginationMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$ManageApiKeys$FormUpdated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Partner$ManageApiKeys$Label = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$ManageApiKeys$Save = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Components$ResourceFilter$Partner$Integration$view = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$view,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.Jy),
					options),
				model.b8));
	});
var $author$project$Components$Partner$ManageApiKeys$viewCreateEditModal = F5(
	function (owner, integrationResourceFilter, item, form, request) {
		var modalConfig = {
			Tq: $elm$core$Maybe$Nothing,
			aih: 'Api Key',
			V8: _Utils_eq(request, $author$project$Api$Data$Loading),
			WG: A2($elm$core$Maybe$map, $author$project$Api$Partner$ApiKey$All$id, item),
			WH: $elm$core$Maybe$Nothing,
			Yd: $author$project$Components$Partner$ManageApiKeys$CancelEdit,
			Yf: $elm$core$Basics$always(
				A2($author$project$Components$Partner$ManageApiKeys$Save, item, form))
		};
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					function () {
					if (!owner.$) {
						return $author$project$Utils$Html$empty;
					} else {
						return A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$labelSpan(4),
									$author$project$Ui$Form$Group$inputSpan(8),
									$author$project$Ui$Form$Group$label('Practice')
								]),
							_List_fromArray(
								[
									function () {
									if (!item.$) {
										var item_ = item.a;
										return A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2(
														$elm$core$Maybe$withDefault,
														'N/A',
														A2(
															$elm$core$Maybe$map,
															$author$project$Api$Partner$Practice$Shared$name,
															A2(
																$elm$core$Maybe$map,
																$author$project$Api$Partner$Integration$Shared$practice,
																$author$project$Api$Partner$ApiKey$All$integration(item_)))))
												]));
									} else {
										return A2(
											$elm$html$Html$map,
											$author$project$Components$Partner$ManageApiKeys$IntegrationResourceFilterMsg,
											A2(
												$author$project$Components$ResourceFilter$Partner$Integration$view,
												_List_fromArray(
													[
														$author$project$Components$ResourceFilter$invalid(
														A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
														$author$project$Components$ResourceFilter$errors(
														A2($author$project$Utils$Form$validationErrors, 0, form))
													]),
												integrationResourceFilter));
									}
								}()
								]));
					}
				}(),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Label')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(
									A2($elm$core$Maybe$withDefault, '', fields.aih)),
									$author$project$Ui$Form$Input$placeholder('Optional label'),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$Partner$ManageApiKeys$FormUpdated, $author$project$Components$Partner$ManageApiKeys$Label))
								]))
						]))
				]));
	});
var $author$project$Components$Partner$ManageApiKeys$SortTable = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$ManageApiKeys$columns = function (owner) {
	return _Utils_ap(
		function () {
			if (!owner.$) {
				return _List_Nil;
			} else {
				return _List_fromArray(
					[
						A3($author$project$Api$Column$init, 'name', true, 'Practice')
					]);
			}
		}(),
		_List_fromArray(
			[
				A3($author$project$Api$Column$init, 'label', true, 'Label'),
				A3($author$project$Api$Column$init, 'token', true, 'Token'),
				A3($author$project$Api$Column$init, 'created_at', true, 'Created At'),
				A3($author$project$Api$Column$init, 'last_used_at', true, 'Last Used At'),
				A3($author$project$Api$Column$init, 'deactivated_at', true, 'Deactivated At')
			]));
};
var $author$project$Components$Partner$ManageApiKeys$CopyToken = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Partner$ManageApiKeys$ToggleApiKey = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Partner$ManageApiKeys$UseForWebhooksSignature = function (a) {
	return {$: 15, a: a};
};
var $author$project$Api$Partner$ApiKey$Shared$createdAt = function (_v0) {
	var record = _v0;
	return record.O1;
};
var $author$project$Api$Partner$ApiKey$All$createdAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$ApiKey$Shared$createdAt(shared);
};
var $author$project$Api$Partner$ApiKey$Shared$deactivatedAt = function (_v0) {
	var record = _v0;
	return record.PR;
};
var $author$project$Api$Partner$ApiKey$All$deactivatedAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$ApiKey$Shared$deactivatedAt(shared);
};
var $author$project$Api$Partner$ApiKey$Shared$lastUsedAt = function (_v0) {
	var record = _v0;
	return record.VO;
};
var $author$project$Api$Partner$ApiKey$All$lastUsedAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$ApiKey$Shared$lastUsedAt(shared);
};
var $author$project$Api$Partner$ApiKey$Shared$token = function (_v0) {
	var record = _v0;
	return record.adi;
};
var $author$project$Api$Partner$ApiKey$All$token = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$ApiKey$Shared$token(shared);
};
var $author$project$Components$Partner$ManageApiKeys$Delete = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Partner$ManageApiKeys$viewDeleteButton = F3(
	function (disabled, loading, apiKey) {
		return A3(
			$author$project$Ui$Tooltip$view,
			_List_fromArray(
				[
					$author$project$Ui$Tooltip$active(disabled)
				]),
			'Can’t remove the api key being used for the webhooks signature.',
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{mm: 'Delete api key'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$sm,
							$author$project$Ui$Button$loading(loading),
							$author$project$Ui$Button$onClick(
							$author$project$Components$Partner$ManageApiKeys$Delete(apiKey)),
							$author$project$Ui$Button$icon($author$project$Ui$Icon$delete),
							$author$project$Ui$Button$disabled(disabled)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Delete')
						]))
				]));
	});
var $author$project$Components$Partner$ManageApiKeys$Edit = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Partner$ManageApiKeys$viewEditButton = F2(
	function (loading, apiKey) {
		return A3(
			$author$project$Ui$Button$view,
			{mm: 'Edit api key'},
			_List_fromArray(
				[
					$author$project$Ui$Button$link,
					$author$project$Ui$Button$sm,
					$author$project$Ui$Button$onClick(
					$author$project$Components$Partner$ManageApiKeys$Edit(apiKey)),
					$author$project$Ui$Button$icon($author$project$Ui$Icon$edit),
					$author$project$Ui$Button$loading(loading)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Edit')
				]));
	});
var $author$project$Api$Partner$Partner$One$webhooksSignatureApiKey = function (_v0) {
	var record = _v0.b;
	return record.aeu;
};
var $author$project$Components$Partner$ManageApiKeys$viewApiKey = F5(
	function (timeFormatter, owner, updatingItems, visibleApiKeyTokens, apiKey) {
		var id = $author$project$Api$Partner$ApiKey$All$id(apiKey);
		var loading = A2($elm$core$Set$member, id, updatingItems);
		var visible = A2($elm$core$Set$member, id, visibleApiKeyTokens);
		var _v0 = visible ? _Utils_Tuple2($author$project$Ui$Icon$visibilityOff, 'Hide api key') : _Utils_Tuple2($author$project$Ui$Icon$visibility, 'Show api key');
		var visibleIcon = _v0.a;
		var ariaLabel = _v0.b;
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						if (!owner.$) {
							return _List_Nil;
						} else {
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Table$cell,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'N/A',
												A2(
													$elm$core$Maybe$map,
													$author$project$Api$Partner$Practice$Shared$name,
													A2(
														$elm$core$Maybe$map,
														$author$project$Api$Partner$Integration$Shared$practice,
														$author$project$Api$Partner$ApiKey$All$integration(apiKey)))))
										]))
								]);
						}
					}(),
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										$author$project$Api$Partner$ApiKey$All$label(apiKey)))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$gap2]),
									_List_fromArray(
										[
											visible ? A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[$author$project$Ui$Typography$muted]),
											$author$project$Api$Partner$ApiKey$All$token(apiKey)) : A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[$author$project$Ui$Typography$muted]),
											$elm$core$String$concat(
												_List_fromArray(
													[
														A2(
														$elm$core$String$repeat,
														$elm$core$String$length(
															$author$project$Api$Partner$ApiKey$All$token(apiKey)) - 4,
														'*'),
														A2(
														$elm$core$String$right,
														4,
														$author$project$Api$Partner$ApiKey$All$token(apiKey))
													]))),
											A3(
											$author$project$Ui$Button$view,
											{mm: ariaLabel},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick(
													$author$project$Components$Partner$ManageApiKeys$ToggleApiKey(id)),
													$author$project$Ui$Button$icon(visibleIcon)
												]),
											_List_Nil),
											A3(
											$author$project$Ui$Button$view,
											{mm: 'Copy api key'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick(
													$author$project$Components$Partner$ManageApiKeys$CopyToken(
														$author$project$Api$Partner$ApiKey$All$token(apiKey))),
													$author$project$Ui$Button$icon($author$project$Ui$Icon$copy)
												]),
											_List_Nil)
										]))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										timeFormatter,
										0,
										$author$project$Api$Partner$ApiKey$All$createdAt(apiKey)))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										A2(
											$elm$core$Maybe$map,
											timeFormatter(0),
											$author$project$Api$Partner$ApiKey$All$lastUsedAt(apiKey))))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										A2(
											$elm$core$Maybe$map,
											timeFormatter(0),
											$author$project$Api$Partner$ApiKey$All$deactivatedAt(apiKey))))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$gap2, $author$project$Ui$Element$justifyRight]),
									function () {
										if (!owner.$) {
											var partner = owner.a;
											var isWebhooksSignatureApiKey = _Utils_eq(
												A2(
													$elm$core$Maybe$map,
													$author$project$Api$Partner$ApiKey$Shared$id,
													$author$project$Api$Partner$Partner$One$webhooksSignatureApiKey(partner)),
												$elm$core$Maybe$Just(id));
											return isWebhooksSignatureApiKey ? _List_fromArray(
												[
													A2(
													$author$project$Ui$Badge$view,
													_List_fromArray(
														[$author$project$Ui$Badge$info]),
													_List_fromArray(
														[
															$elm$html$Html$text('Webhooks Signature')
														])),
													A2($author$project$Components$Partner$ManageApiKeys$viewEditButton, loading, apiKey),
													A3($author$project$Components$Partner$ManageApiKeys$viewDeleteButton, true, loading, apiKey)
												]) : _List_fromArray(
												[
													A3(
													$author$project$Ui$Button$view,
													{mm: 'Use api key for webhooks signature'},
													_List_fromArray(
														[
															$author$project$Ui$Button$secondary,
															$author$project$Ui$Button$sm,
															$author$project$Ui$Button$onClick(
															$author$project$Components$Partner$ManageApiKeys$UseForWebhooksSignature(apiKey)),
															$author$project$Ui$Button$loading(loading)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Use for webhooks signature')
														])),
													A2($author$project$Components$Partner$ManageApiKeys$viewEditButton, loading, apiKey),
													A3($author$project$Components$Partner$ManageApiKeys$viewDeleteButton, false, loading, apiKey)
												]);
										} else {
											return _List_fromArray(
												[
													A2($author$project$Components$Partner$ManageApiKeys$viewEditButton, loading, apiKey),
													A3($author$project$Components$Partner$ManageApiKeys$viewDeleteButton, false, loading, apiKey)
												]);
										}
									}())
								]))
						])
					])));
	});
var $author$project$Components$Partner$ManageApiKeys$viewTable = function (model) {
	var _v0 = function () {
		var _v1 = model.ck;
		if (_v1.$ === 3) {
			var apiKeys_ = _v1.a;
			return _Utils_Tuple2(false, apiKeys_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var apiKeys = _v0.b;
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any api keys')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		_Utils_ap(
			A2(
				$elm$core$List$map,
				$author$project$Api$Column$view(
					A2($author$project$Api$Column$Sortable, model.alA, $author$project$Components$Partner$ManageApiKeys$SortTable)),
				$author$project$Components$Partner$ManageApiKeys$columns(model.YD)),
			_List_fromArray(
				[
					A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
				])),
		A2(
			$elm$core$List$map,
			A4($author$project$Components$Partner$ManageApiKeys$viewApiKey, model.J7, model.YD, model.cd, model.dR),
			apiKeys),
		_List_Nil);
};
var $author$project$Components$Partner$ManageApiKeys$view = function (_v0) {
	var model = _v0;
	var loading = function () {
		var _v6 = model.ck;
		if (_v6.$ === 3) {
			return false;
		} else {
			return true;
		}
	}();
	return _List_fromArray(
		[
			function () {
			var _v1 = model.Io;
			if (!_v1.$) {
				var _v2 = _v1.a;
				var item = _v2.a;
				var form = _v2.b;
				var request = _v2.c;
				return A5($author$project$Components$Partner$ManageApiKeys$viewCreateEditModal, model.YD, model.n_, item, form, request);
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			function () {
			var _v3 = model.je;
			if (!_v3.$) {
				var item = _v3.a;
				return A2(
					$author$project$Components$HiConfirm$modal,
					$author$project$Components$Partner$ManageApiKeys$HiConfirmClosed(item),
					_List_fromArray(
						[
							$author$project$Components$HiConfirm$verb('delete'),
							$author$project$Components$HiConfirm$noun('api key')
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
							_List_fromArray(
								[
									$author$project$Ui$Panel$title(
									_List_fromArray(
										[
											function () {
											var _v4 = model.YD;
											if (!_v4.$) {
												return $elm$html$Html$text('Partner Api Keys');
											} else {
												return $elm$html$Html$text('Practices Api Keys');
											}
										}()
										])),
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Add new api key'},
									_List_fromArray(
										[
											$author$project$Ui$Button$default,
											$author$project$Ui$Button$onClick($author$project$Components$Partner$ManageApiKeys$New),
											$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('New Api Key')
										]))
								])),
							function () {
							var _v5 = model.YD;
							if (!_v5.$) {
								return $author$project$Utils$Html$empty;
							} else {
								return A2(
									$elm$html$Html$map,
									$author$project$Components$Partner$ManageApiKeys$SearchInputMsg,
									A2(
										$author$project$Ui$SearchInput$view,
										_List_fromArray(
											[
												$author$project$Ui$SearchInput$placeholder('Search by practice name')
											]),
										model.up));
							}
						}()
						])),
					$author$project$Components$Partner$ManageApiKeys$viewTable(model),
					A2(
					$author$project$Ui$Panel$footer,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Components$Partner$ManageApiKeys$PaginationMsg,
							A2(
								$author$project$Api$Pagination$view,
								_List_fromArray(
									[
										$author$project$Ui$Pagination$List$loading(loading)
									]),
								model.ajJ))
						]))
				]))
		]);
};
var $author$project$Components$Partner$RequestLimits$BlockClicked = {$: 4};
var $author$project$Components$Partner$RequestLimits$ResetClicked = {$: 1};
var $author$project$Components$Partner$RequestLimits$viewAdminActions = function (model) {
	return (!model.Ij) ? $author$project$Utils$Html$empty : A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap2]),
		_List_fromArray(
			[
				A3(
				$author$project$Ui$HinterOnly$button,
				{mm: 'Block partner for the day'},
				_List_fromArray(
					[
						$author$project$Ui$Button$danger,
						$author$project$Ui$Button$onClick($author$project$Components$Partner$RequestLimits$BlockClicked),
						$author$project$Ui$Button$loading(model.eD),
						$author$project$Ui$Button$disabled(model.eE)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Block for the day')
					])),
				A3(
				$author$project$Ui$HinterOnly$button,
				{mm: 'Reset daily request limit'},
				_List_fromArray(
					[
						$author$project$Ui$Button$danger,
						$author$project$Ui$Button$onClick($author$project$Components$Partner$RequestLimits$ResetClicked),
						$author$project$Ui$Button$loading(model.eE),
						$author$project$Ui$Button$disabled(model.eD)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Reset daily limit')
					]))
			]));
};
var $author$project$Components$Partner$RequestLimits$viewBlockConfirmModal = function (model) {
	return model.j0 ? A2(
		$author$project$Components$HiConfirm$modal,
		$author$project$Components$Partner$RequestLimits$BlockConfirmationClosed,
		_List_fromArray(
			[
				$author$project$Components$HiConfirm$verb('block'),
				$author$project$Components$HiConfirm$noun('partner for the rest of the day'),
				$author$project$Components$HiConfirm$loading(model.eD)
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Components$Partner$RequestLimits$DraftFormUpdated = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Partner$RequestLimits$DraftSaved = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Partner$RequestLimits$Limit = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$RequestLimits$Path = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$RequestLimits$viewDraftModal = function (model) {
	var _v0 = model.bw;
	if (_v0.$ === 1) {
		return $author$project$Utils$Html$empty;
	} else {
		var draft = _v0.a;
		var isEditing = function () {
			if (draft.$ === 1) {
				return true;
			} else {
				return false;
			}
		}();
		var form = $author$project$Components$Partner$RequestLimits$draftForm(draft);
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			{
				Tq: $elm$core$Maybe$Nothing,
				aih: 'per-path override',
				V8: model.cI,
				WG: isEditing ? $elm$core$Maybe$Just(fields.YX) : $elm$core$Maybe$Nothing,
				WH: $elm$core$Maybe$Nothing,
				Yd: $author$project$Components$Partner$RequestLimits$DraftCanceled,
				Yf: function (_v1) {
					return $author$project$Components$Partner$RequestLimits$DraftSaved(form);
				}
			},
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Path'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(fields.YX),
									$author$project$Ui$Form$Input$placeholder($author$project$Components$Partner$RequestLimits$apiPathPrefix + '...'),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$Partner$RequestLimits$DraftFormUpdated, $author$project$Components$Partner$RequestLimits$Path)),
									$author$project$Ui$Form$Input$disabled(isEditing),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 0, form))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Limit (requests/sec)'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(fields.VZ),
									$author$project$Ui$Form$Input$placeholder('20'),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$Partner$RequestLimits$DraftFormUpdated, $author$project$Components$Partner$RequestLimits$Limit)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 1, form))
								]))
						]))
				]));
	}
};
var $author$project$Api$Partner$RequestLimit$One$dailyCount = function (_v0) {
	var record = _v0;
	return record.Pt;
};
var $author$project$Api$Partner$RequestLimit$One$dailyLimit = function (_v0) {
	var record = _v0;
	return record.Pu;
};
var $author$project$Api$Partner$RequestLimit$One$secondlyLimit = function (_v0) {
	var record = _v0;
	return record.aaD;
};
var $author$project$Api$Partner$RequestLimit$One$perPathLimits = function (_v0) {
	var record = _v0;
	return record.Zq;
};
var $author$project$Components$Partner$RequestLimits$AddPerPathClicked = {$: 7};
var $author$project$Components$Partner$RequestLimits$viewAddButton = function (model) {
	return A3(
		$author$project$Ui$HinterOnly$button,
		{mm: 'Add per-path override'},
		_List_fromArray(
			[
				$author$project$Ui$Button$default,
				$author$project$Ui$Button$icon($author$project$Ui$Icon$add),
				$author$project$Ui$Button$disabled(model.cI),
				$author$project$Ui$Button$onClick($author$project$Components$Partner$RequestLimits$AddPerPathClicked)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Add override')
			]));
};
var $author$project$Components$Partner$RequestLimits$EditPerPathClicked = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Partner$RequestLimits$PerPathDeleteClicked = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Partner$RequestLimits$viewPerPathLimit = F2(
	function (model, limit) {
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$text,
					_List_fromArray(
						[$author$project$Ui$Typography$muted]),
					$author$project$Api$Partner$RequestLimit$PerPathLimit$path(limit) + (' — ' + ($author$project$Formatters$Int$formatNumber(
						$author$project$Api$Partner$RequestLimit$PerPathLimit$limit(limit)) + '/sec'))),
					A3(
					$author$project$Ui$Button$view,
					{
						mm: 'Edit ' + ($author$project$Api$Partner$RequestLimit$PerPathLimit$path(limit) + ' override')
					},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$icon($author$project$Ui$Icon$edit),
							$author$project$Ui$Button$disabled(model.cI),
							$author$project$Ui$Button$onClick(
							$author$project$Components$Partner$RequestLimits$EditPerPathClicked(limit))
						]),
					_List_Nil),
					A3(
					$author$project$Ui$Button$view,
					{
						mm: 'Remove ' + ($author$project$Api$Partner$RequestLimit$PerPathLimit$path(limit) + ' override')
					},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$icon($author$project$Ui$Icon$delete),
							$author$project$Ui$Button$disabled(model.cI),
							$author$project$Ui$Button$onClick(
							$author$project$Components$Partner$RequestLimits$PerPathDeleteClicked(
								$author$project$Api$Partner$RequestLimit$PerPathLimit$path(limit)))
						]),
					_List_Nil)
				]));
	});
var $author$project$Components$Partner$RequestLimits$viewPerPathLimits = F2(
	function (model, limits) {
		var _v0 = _Utils_Tuple2(
			model.Ij,
			$author$project$Api$Partner$RequestLimit$One$perPathLimits(limits));
		if (_v0.a && (!_v0.b.$)) {
			var perPathLimits = _v0.b.a;
			return A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap, $author$project$Ui$Element$mt4]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$flex, $author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$titleSm,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Per-path overrides')
									])),
								$author$project$Components$Partner$RequestLimits$viewAddButton(model)
							])),
						function () {
						if (!perPathLimits.b) {
							return A2(
								$author$project$Ui$Typography$text,
								_List_fromArray(
									[$author$project$Ui$Typography$muted]),
								'No per-path overrides set.');
						} else {
							return A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap]),
								A2(
									$elm$core$List$map,
									$author$project$Components$Partner$RequestLimits$viewPerPathLimit(model),
									perPathLimits));
						}
					}()
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$Partner$RequestLimits$viewRow = F2(
	function (label, value) {
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap2]),
			_List_fromArray(
				[
					A2($author$project$Ui$Typography$text, _List_Nil, label),
					A2(
					$author$project$Ui$Typography$text,
					_List_fromArray(
						[$author$project$Ui$Typography$muted]),
					value)
				]));
	});
var $author$project$Components$Partner$RequestLimits$viewLimits = F2(
	function (model, limits) {
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap2]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Partner$RequestLimits$viewRow,
					'Per second',
					$author$project$Formatters$Int$formatNumber(
						$author$project$Api$Partner$RequestLimit$One$secondlyLimit(limits))),
					A2(
					$author$project$Components$Partner$RequestLimits$viewRow,
					'Per day',
					$author$project$Formatters$Int$formatNumber(
						$author$project$Api$Partner$RequestLimit$One$dailyCount(limits)) + (' / ' + $author$project$Formatters$Int$formatNumber(
						$author$project$Api$Partner$RequestLimit$One$dailyLimit(limits)))),
					A2($author$project$Components$Partner$RequestLimits$viewPerPathLimits, model, limits)
				]));
	});
var $author$project$Components$Partner$RequestLimits$viewResetConfirmModal = function (model) {
	return model.j2 ? A2(
		$author$project$Components$HiConfirm$modal,
		$author$project$Components$Partner$RequestLimits$ResetConfirmationClosed,
		_List_fromArray(
			[
				$author$project$Components$HiConfirm$verb('reset'),
				$author$project$Components$HiConfirm$noun('daily request limit'),
				$author$project$Components$HiConfirm$loading(model.eE)
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Components$Partner$RequestLimits$skeletonRow = A2(
	$author$project$Ui$Element$view,
	_List_fromArray(
		[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap2]),
	_List_fromArray(
		[
			$author$project$Ui$Skeleton$text(
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$span(2)
				])),
			$author$project$Ui$Skeleton$text(
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$span(1)
				]))
		]));
var $author$project$Components$Partner$RequestLimits$viewSkeleton = A2(
	$author$project$Ui$Element$view,
	_List_fromArray(
		[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap2]),
	A2($elm$core$List$repeat, 2, $author$project$Components$Partner$RequestLimits$skeletonRow));
var $author$project$Components$Partner$RequestLimits$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Request Limits')
											])),
										$author$project$Components$Partner$RequestLimits$viewAdminActions(model)
									])),
								A2(
								$elm$html$Html$em,
								_List_Nil,
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Link$externalHref,
										'https://developers.hint.com/reference/making-requests#rate-limits',
										_List_fromArray(
											[$author$project$Ui$Link$targetBlank]),
										_List_fromArray(
											[
												$elm$html$Html$text('Learn more about request limits')
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								function () {
								var _v0 = model.kX;
								switch (_v0.$) {
									case 3:
										var limits = _v0.a;
										return A2($author$project$Components$Partner$RequestLimits$viewLimits, model, limits);
									case 2:
										return A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[$author$project$Ui$Typography$muted]),
											'Could not load request limits.');
									default:
										return $author$project$Components$Partner$RequestLimits$viewSkeleton;
								}
							}()
							]))
					])),
				$author$project$Components$Partner$RequestLimits$viewDraftModal(model),
				$author$project$Components$Partner$RequestLimits$viewResetConfirmModal(model),
				$author$project$Components$Partner$RequestLimits$viewBlockConfirmModal(model)
			]));
};
var $author$project$Pages$Partner$ApiKeys$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(12)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Partner$ApiKeys$RequestLimitsMsg,
								$author$project$Components$Partner$RequestLimits$view(model.kX))
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(12)
							]),
						A2(
							$elm$core$List$map,
							$elm$html$Html$map($author$project$Pages$Partner$ApiKeys$ManageGlobalApiKeysMsg),
							$author$project$Components$Partner$ManageApiKeys$view(model.ov))),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(12)
							]),
						A2(
							$elm$core$List$map,
							$elm$html$Html$map($author$project$Pages$Partner$ApiKeys$ManageIntegrationsApiKeysMsg),
							$author$project$Components$Partner$ManageApiKeys$view(model.ox)))
					]))
			]),
		ac9: 'Partner | Api Keys'
	};
};
var $author$project$Pages$Partner$ApiKeys$page = $author$project$Spa$Page$applicationPartner(
	{ah_: $author$project$Pages$Partner$ApiKeys$init, aiq: $author$project$Pages$Partner$ApiKeys$load, k8: $author$project$Pages$Partner$ApiKeys$save, alO: $author$project$Pages$Partner$ApiKeys$subscriptions, adT: $author$project$Pages$Partner$ApiKeys$update, amo: $author$project$Pages$Partner$ApiKeys$view});
var $author$project$Pages$Partner$Billing$GotAccount = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Partner$RainforestAccount$One$RainforestAccount = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Partner$RainforestAccount$Shared$RainforestAccount = $elm$core$Basics$identity;
var $author$project$Api$Partner$RainforestAccount$Shared$Record = function (status) {
	return {alH: status};
};
var $author$project$Api$Partner$RainforestAccount$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'status',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Partner$RainforestAccount$Shared$Record));
var $author$project$Api$Partner$RainforestAccount$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$RainforestAccount$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$RainforestAccount$One$Record = F8(
	function (merchantId, merchantApplicationId, merchantApplicationStatus, statementDescriptor, depositAccountLast4, depositAccountRoutingNumber, depositAccountBankName, depositAccountAccountType) {
		return {Qn: depositAccountAccountType, Qo: depositAccountBankName, Qp: depositAccountLast4, Qq: depositAccountRoutingNumber, W$: merchantApplicationId, W0: merchantApplicationStatus, W1: merchantId, acc: statementDescriptor};
	});
var $author$project$Api$Partner$RainforestAccount$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'deposit_account_account_type',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'deposit_account_bank_name',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'deposit_account_routing_number',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'deposit_account_last_4',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'statement_descriptor',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'merchant_application_status',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'merchant_application_id',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'merchant_id',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								$elm$json$Json$Decode$succeed($author$project$Api$Partner$RainforestAccount$One$Record)))))))));
var $author$project$Api$Partner$RainforestAccount$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$RainforestAccount$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Partner$RainforestAccount$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Partner$RainforestAccount$One$RainforestAccount)));
var $author$project$Api$Partner$RainforestAccount$rainforestAccountPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['rainforest_account']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$RainforestAccount$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Partner$RainforestAccount$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Partner$RainforestAccount$rainforestAccountPath));
	});
var $author$project$Pages$Partner$Billing$init = F4(
	function (_v0, partner, shared, _v1) {
		return _Utils_Tuple2(
			{
				Gv: shared.Gv,
				f7: $author$project$Api$Data$NotAsked,
				Ij: $author$project$Shared$isHintAdmin(shared),
				AX: false,
				YN: partner,
				cQ: $author$project$Api$Data$Loading,
				DH: $author$project$Rainforest$isSandbox(shared.t9),
				k_: $elm$core$Maybe$Nothing,
				Ey: $elm$core$Maybe$Nothing,
				lr: $elm$core$Maybe$Nothing,
				qr: $author$project$Api$Data$NotAsked
			},
			A2($author$project$Api$Partner$RainforestAccount$retrieve, shared.Gv, $author$project$Pages$Partner$Billing$GotAccount));
	});
var $author$project$Pages$Partner$Billing$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Partner$Billing$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Partner$Billing$ResetAccountModalMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Partner$Billing$SimulateApplicationEventModalMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Partner$Billing$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Rainforest$SimulateApplicationEventModal$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Pages$Partner$Billing$SimulateApplicationEventModalMsg)),
					model.lr)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Rainforest$ResetAccountModal$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Pages$Partner$Billing$ResetAccountModalMsg)),
					model.k_))
			]));
};
var $author$project$Pages$Partner$Billing$GotCreated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Partner$Billing$GotDeleteRainforestAccount = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Partner$Billing$GotSetupSessionKey = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Partner$Billing$PrefilledWithFakeData = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Partner$Billing$Synced = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Partner$RainforestAccount$create = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$RainforestAccount$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Partner$RainforestAccount$rainforestAccountPath));
	});
var $author$project$Api$Partner$RainforestAccount$delete = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Partner$RainforestAccount$rainforestAccountPath));
	});
var $author$project$Api$Partner$RainforestAccount$fakePrefill = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$RainforestAccount$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['fake_prefill']),
					$author$project$Api$Partner$RainforestAccount$rainforestAccountPath)));
	});
var $author$project$Api$Partner$RainforestAccount$reset = F3(
	function (apiClient, merchantName, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'merchant_name',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, merchantName))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$RainforestAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['reset']),
						$author$project$Api$Partner$RainforestAccount$rainforestAccountPath))));
	});
var $author$project$Api$Partner$RainforestAccount$One$record = function (_v0) {
	var record_ = _v0.b;
	return record_;
};
var $author$project$Api$Partner$RainforestAccount$One$merchantApplicationStatus = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Partner$RainforestAccount$One$record,
	function ($) {
		return $.W0;
	});
var $author$project$Api$Partner$RainforestAccount$setup = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			A2($elm$json$Json$Decode$field, 'session_key', $elm$json$Json$Decode$string),
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['setup']),
					$author$project$Api$Partner$RainforestAccount$rainforestAccountPath)));
	});
var $author$project$Pages$Partner$Billing$retrieveSetupSessionKey = F2(
	function (apiClient, rainforestAccount) {
		return ($author$project$Api$Partner$RainforestAccount$One$merchantApplicationStatus(rainforestAccount) !== 'completed') ? A2($author$project$Api$Partner$RainforestAccount$setup, apiClient, $author$project$Pages$Partner$Billing$GotSetupSessionKey) : $elm$core$Platform$Cmd$none;
	});
var $author$project$Api$Partner$RainforestAccount$simulateStatusChange = F4(
	function (apiClient, status, reviewTypes, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'status',
					$elm$json$Json$Encode$string(status)),
					_Utils_Tuple2(
					'review_types',
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, reviewTypes))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$RainforestAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['simulate_status_change']),
						$author$project$Api$Partner$RainforestAccount$rainforestAccountPath))));
	});
var $author$project$Api$Partner$RainforestAccount$sync = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$RainforestAccount$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['sync']),
					$author$project$Api$Partner$RainforestAccount$rainforestAccountPath)));
	});
var $author$project$Pages$Partner$Billing$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				_v1$2:
				while (true) {
					switch (response.$) {
						case 3:
							var rainforestAccount = response.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{cQ: response}),
								A2($author$project$Pages$Partner$Billing$retrieveSetupSessionKey, model.Gv, rainforestAccount),
								_List_Nil);
						case 2:
							if (response.a.$ === 5) {
								var _v2 = response.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{cQ: response}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							} else {
								break _v1$2;
							}
						default:
							break _v1$2;
					}
				}
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cQ: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				return _Utils_Tuple3(
					model,
					A2($author$project$Api$Partner$RainforestAccount$create, model.Gv, $author$project$Pages$Partner$Billing$GotCreated),
					_List_Nil);
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cQ: response}),
						A2($author$project$Api$Partner$RainforestAccount$setup, model.Gv, $author$project$Pages$Partner$Billing$GotSetupSessionKey),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					var sessionKey = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Ey: $elm$core$Maybe$Just(sessionKey)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{AX: true}),
					$elm$core$Platform$Cmd$none,
					_List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 3, 'Payment Processing Application submitted')
						]));
			case 7:
				var _v5 = $author$project$Components$Rainforest$SimulateApplicationEventModal$init($author$project$Api$Partner$RainforestAccount$simulateStatusChange);
				var simulateApplicationEventModal = _v5.a;
				var simulateApplicationEventModalCmd = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							lr: $elm$core$Maybe$Just(simulateApplicationEventModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Billing$SimulateApplicationEventModalMsg, simulateApplicationEventModalCmd),
					_List_Nil);
			case 8:
				var simulateApplicationEventModalMsg = msg.a;
				var _v6 = model.lr;
				if (!_v6.$) {
					var simulateApplicationEventModal = _v6.a;
					var simulateApplicationEventModalResult = A3($author$project$Components$Rainforest$SimulateApplicationEventModal$update, model.Gv, simulateApplicationEventModalMsg, simulateApplicationEventModal);
					var simulateApplicationEventModal_ = function () {
						var _v7 = simulateApplicationEventModalResult.agZ;
						switch (_v7) {
							case 1:
								return $elm$core$Maybe$Nothing;
							case 2:
								return $elm$core$Maybe$Just(simulateApplicationEventModalResult.aiO);
							default:
								return $elm$core$Maybe$Just(simulateApplicationEventModalResult.aiO);
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{lr: simulateApplicationEventModal_}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Billing$SimulateApplicationEventModalMsg, simulateApplicationEventModalResult.GZ),
						simulateApplicationEventModalResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				var _v8 = $author$project$Components$Rainforest$ResetAccountModal$init($author$project$Api$Partner$RainforestAccount$reset);
				var resetAccountModal = _v8.a;
				var resetAccountModalCmd = _v8.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							k_: $elm$core$Maybe$Just(resetAccountModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Billing$ResetAccountModalMsg, resetAccountModalCmd),
					_List_Nil);
			case 6:
				var resetAccountModalMsg = msg.a;
				var _v9 = model.k_;
				if (!_v9.$) {
					var resetAccountModal = _v9.a;
					var resetAccountModalResult = A3($author$project$Components$Rainforest$ResetAccountModal$update, model.Gv, resetAccountModalMsg, resetAccountModal);
					var _v10 = function () {
						var _v11 = resetAccountModalResult.agZ;
						switch (_v11.$) {
							case 1:
								return _Utils_Tuple2($elm$core$Maybe$Nothing, model.cQ);
							case 2:
								var rainforestAccountResponse = _v11.b;
								return _Utils_Tuple2($elm$core$Maybe$Nothing, rainforestAccountResponse);
							default:
								return _Utils_Tuple2(
									$elm$core$Maybe$Just(resetAccountModalResult.aiO),
									model.cQ);
						}
					}();
					var resetAccountModal_ = _v10.a;
					var rainforestAccount = _v10.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cQ: rainforestAccount, k_: resetAccountModal_}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Billing$ResetAccountModalMsg, resetAccountModalResult.GZ),
						resetAccountModalResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qr: $author$project$Api$Data$Loading}),
					A2($author$project$Api$Partner$RainforestAccount$sync, model.Gv, $author$project$Pages$Partner$Billing$Synced),
					_List_Nil);
			case 10:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cQ: response, qr: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Sync with Rainforest was successful.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{qr: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 11:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{f7: $author$project$Api$Data$Loading}),
					A2($author$project$Api$Partner$RainforestAccount$delete, model.Gv, $author$project$Pages$Partner$Billing$GotDeleteRainforestAccount),
					_List_Nil);
			case 12:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								f7: $author$project$Api$Data$NotAsked,
								cQ: $author$project$Api$Data$Failure($author$project$Api$Data$NotFound)
							}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Rainforest account was successfully deleted.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{f7: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 13:
				return _Utils_Tuple3(
					model,
					A2($author$project$Api$Partner$RainforestAccount$fakePrefill, model.Gv, $author$project$Pages$Partner$Billing$PrefilledWithFakeData),
					_List_Nil);
			default:
				var response = msg.a;
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
		}
	});
var $author$project$Pages$Partner$Billing$DeleteRainforestAccount = {$: 11};
var $author$project$Pages$Partner$Billing$OpenResetAccountModal = {$: 5};
var $author$project$Pages$Partner$Billing$OpenSimulateModal = {$: 7};
var $author$project$Pages$Partner$Billing$PrefillWithFakeDataClicked = {$: 13};
var $author$project$Pages$Partner$Billing$Sync = {$: 9};
var $author$project$Pages$Partner$Billing$applicationIsProcessing = F2(
	function (rainforestAccount, _v0) {
		var merchantOnboardingSubmitted = _v0.AX;
		return merchantOnboardingSubmitted || ('processing' === $author$project$Api$Partner$RainforestAccount$One$merchantApplicationStatus(rainforestAccount));
	});
var $author$project$Api$Partner$RainforestAccount$Shared$record = function (_v0) {
	var record_ = _v0;
	return record_;
};
var $author$project$Api$Partner$RainforestAccount$Shared$status = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Partner$RainforestAccount$Shared$record,
	function ($) {
		return $.alH;
	});
var $author$project$Api$Partner$RainforestAccount$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$RainforestAccount$Shared$status(shared);
};
var $author$project$Pages$Partner$Billing$MerchantOnboardingSubmitted = {$: 4};
var $author$project$Api$Partner$RainforestAccount$One$merchantApplicationId = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Partner$RainforestAccount$One$record,
	function ($) {
		return $.W$;
	});
var $author$project$Api$Partner$RainforestAccount$One$merchantId = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Partner$RainforestAccount$One$record,
	function ($) {
		return $.W1;
	});
var $author$project$Api$Partner$RainforestAccount$One$depositAccountAccountType = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Partner$RainforestAccount$One$record,
	function ($) {
		return $.Qn;
	});
var $author$project$Api$Partner$RainforestAccount$One$depositAccountBankName = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Partner$RainforestAccount$One$record,
	function ($) {
		return $.Qo;
	});
var $author$project$Api$Partner$RainforestAccount$One$depositAccountLast4 = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Partner$RainforestAccount$One$record,
	function ($) {
		return $.Qp;
	});
var $author$project$Api$Partner$RainforestAccount$One$depositAccountRoutingNumber = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Partner$RainforestAccount$One$record,
	function ($) {
		return $.Qq;
	});
var $author$project$Api$Partner$RainforestAccount$One$statementDescriptor = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Partner$RainforestAccount$One$record,
	function ($) {
		return $.acc;
	});
var $author$project$Pages$Partner$Billing$viewActive = function (rainforestAccount) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Statement Descriptor'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$elm$core$Maybe$withDefault,
									'N/A',
									$author$project$Api$Partner$RainforestAccount$One$statementDescriptor(rainforestAccount)))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Deposit Account'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$text,
								_List_fromArray(
									[$author$project$Ui$Typography$bold]),
								'Bank Name: '),
								$elm$html$Html$text(
								A2(
									$elm$core$Maybe$withDefault,
									'N/A',
									$author$project$Api$Partner$RainforestAccount$One$depositAccountBankName(rainforestAccount)))
							])),
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$text,
								_List_fromArray(
									[$author$project$Ui$Typography$bold]),
								'Last 4: '),
								$elm$html$Html$text(
								A2(
									$elm$core$Maybe$withDefault,
									'N/A',
									$author$project$Api$Partner$RainforestAccount$One$depositAccountLast4(rainforestAccount)))
							])),
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$text,
								_List_fromArray(
									[$author$project$Ui$Typography$bold]),
								'Routing Number: '),
								$elm$html$Html$text(
								A2(
									$elm$core$Maybe$withDefault,
									'N/A',
									$author$project$Api$Partner$RainforestAccount$One$depositAccountRoutingNumber(rainforestAccount)))
							])),
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$text,
								_List_fromArray(
									[$author$project$Ui$Typography$bold]),
								'Account Type: '),
								$elm$html$Html$text(
								A2(
									$elm$core$Maybe$withDefault,
									'N/A',
									$author$project$Api$Partner$RainforestAccount$One$depositAccountAccountType(rainforestAccount)))
							]))
					]))
			]));
};
var $author$project$Pages$Partner$Billing$viewInProgressAlert = A2(
	$author$project$Ui$Alert$info,
	_List_fromArray(
		[$author$project$Ui$Alert$mb2, $author$project$Ui$Alert$textLeft]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$strong,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Setup Hint Payments')
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('To start processing payments in Hint, please complete the form below. It takes about 5–10 minutes and requires key details like your account’s contact info, tax ID, bank details, and ownership info (including SSN).')
				]))
		]));
var $author$project$Pages$Partner$Billing$viewInReviewAlert = A2(
	$author$project$Ui$Alert$info,
	_List_fromArray(
		[$author$project$Ui$Alert$mb2, $author$project$Ui$Alert$textLeft]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$strong,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Application Submitted — Under Review')
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Thank you for submitting your payment setup form! We’re currently reviewing your details — this usually takes a few business days. No action is needed right now.')
				]))
		]));
var $author$project$Pages$Partner$Billing$viewAccount = F2(
	function (rainforestAccount, model) {
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					function () {
					var _v0 = $author$project$Api$Partner$RainforestAccount$One$merchantApplicationStatus(rainforestAccount);
					switch (_v0) {
						case 'created':
							return $author$project$Pages$Partner$Billing$viewInProgressAlert;
						case 'in_progress':
							return $author$project$Pages$Partner$Billing$viewInProgressAlert;
						case 'processing':
							return $author$project$Pages$Partner$Billing$viewInReviewAlert;
						case 'in_review':
							return $author$project$Pages$Partner$Billing$viewInReviewAlert;
						case 'needs_information':
							return A2(
								$author$project$Ui$Alert$info,
								_List_fromArray(
									[$author$project$Ui$Alert$mb2, $author$project$Ui$Alert$textLeft]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Action Needed — More Info Required')
											])),
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('To finish setting up Hint Payments, we need a bit more information. Please use the form below to provide the missing details. Once submitted, we’ll review and confirm your setup — usually within a few business days. We’ll notify you by email when it\'s complete.')
											]))
									]));
						case 'completed':
							return A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Status'),
										$author$project$Ui$Form$Group$labelSpanSm(4),
										$author$project$Ui$Form$Group$inputSpanSm(8)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Static$view,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Badge$fromString,
												_List_Nil,
												$author$project$Api$Partner$RainforestAccount$One$status(rainforestAccount))
											]))
									]));
						default:
							return $elm$html$Html$text('');
					}
				}(),
					function () {
					var _v1 = _Utils_Tuple3(
						A2($author$project$Pages$Partner$Billing$applicationIsProcessing, rainforestAccount, model),
						$author$project$Api$Partner$RainforestAccount$One$merchantApplicationStatus(rainforestAccount),
						model.Ey);
					_v1$1:
					while (true) {
						if (_v1.a) {
							return A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label(''),
										$author$project$Ui$Form$Group$labelSpanSm(4),
										$author$project$Ui$Form$Group$inputSpanMd(12),
										$author$project$Ui$Form$Group$inputSpanSm(8)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_fromArray(
											[$author$project$Ui$Typography$helpBlock]),
										_List_fromArray(
											[
												A2($author$project$Ui$Typography$text, _List_Nil, 'Your payment processing account is under review, we will notify you when it\'s approved or if more information is needed.')
											]))
									]));
						} else {
							if (!_v1.c.$) {
								if (_v1.b === 'completed') {
									break _v1$1;
								} else {
									var setupSessionKey = _v1.c.a;
									return A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$label(''),
												$author$project$Ui$Form$Group$labelSpanSm(4),
												$author$project$Ui$Form$Group$inputSpanMd(8)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$WebComponents$Rainforest$MerchantOnboarding$view,
												$author$project$Pages$Partner$Billing$MerchantOnboardingSubmitted,
												{
													W$: A2(
														$elm$core$Maybe$withDefault,
														'',
														$author$project$Api$Partner$RainforestAccount$One$merchantApplicationId(rainforestAccount)),
													W1: A2(
														$elm$core$Maybe$withDefault,
														'',
														$author$project$Api$Partner$RainforestAccount$One$merchantId(rainforestAccount)),
													alo: setupSessionKey
												})
											]));
								}
							} else {
								if (_v1.b === 'completed') {
									break _v1$1;
								} else {
									var _v2 = _v1.c;
									return $author$project$Utils$Html$empty;
								}
							}
						}
					}
					return $author$project$Pages$Partner$Billing$viewActive(rainforestAccount);
				}()
				]));
	});
var $author$project$Pages$Partner$Billing$CreateClicked = {$: 1};
var $author$project$Pages$Partner$Billing$viewSetup = A2(
	$author$project$Ui$Element$view,
	_List_fromArray(
		[$author$project$Ui$Element$textCenter]),
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mt2]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Set up your Payment Processing account to start accepting payments.')
						]))
				])),
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mt4]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{mm: 'Get Started'},
					_List_fromArray(
						[
							$author$project$Ui$Button$primary,
							$author$project$Ui$Button$onClick($author$project$Pages$Partner$Billing$CreateClicked)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Get Started')
						]))
				]))
		]));
var $author$project$Pages$Partner$Billing$viewBody = function (model) {
	return _List_fromArray(
		[
			A2(
			$elm$core$Maybe$withDefault,
			$author$project$Utils$Html$empty,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Components$Rainforest$SimulateApplicationEventModal$view,
					$elm$html$Html$map($author$project$Pages$Partner$Billing$SimulateApplicationEventModalMsg)),
				model.lr)),
			A2(
			$elm$core$Maybe$withDefault,
			$author$project$Utils$Html$empty,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Components$Rainforest$ResetAccountModal$view,
					$elm$html$Html$map($author$project$Pages$Partner$Billing$ResetAccountModalMsg)),
				model.k_)),
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
							_List_fromArray(
								[
									$author$project$Ui$Panel$title(
									_List_fromArray(
										[
											$elm$html$Html$text('Payment Processing')
										])),
									function () {
									if (model.Ij) {
										var _v0 = model.cQ;
										if (_v0.$ === 3) {
											var rainforestAccount = _v0.a;
											return A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$gap2, $author$project$Ui$Element$justifyRight]),
												_List_fromArray(
													[
														A3(
														$author$project$Ui$HinterOnly$button,
														{mm: 'Sync with Rainforest'},
														_List_fromArray(
															[
																$author$project$Ui$Button$secondary,
																$author$project$Ui$Button$onClick($author$project$Pages$Partner$Billing$Sync),
																$author$project$Ui$Button$loading(
																_Utils_eq(model.qr, $author$project$Api$Data$Loading))
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Sync with Rainforest')
															])),
														(model.DH && A2($author$project$Pages$Partner$Billing$applicationIsProcessing, rainforestAccount, model)) ? A3(
														$author$project$Ui$HinterOnly$button,
														{mm: 'Simulate status change'},
														_List_fromArray(
															[
																$author$project$Ui$Button$secondary,
																$author$project$Ui$Button$sm,
																$author$project$Ui$Button$onClick($author$project$Pages$Partner$Billing$OpenSimulateModal)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Simulate Status Change')
															])) : $author$project$Utils$Html$empty,
														A3(
														$author$project$Ui$HinterOnly$button,
														{mm: 'Reset Rainforest account'},
														_List_fromArray(
															[
																$author$project$Ui$Button$secondary,
																$author$project$Ui$Button$onClick($author$project$Pages$Partner$Billing$OpenResetAccountModal)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Reset Rainforest account')
															])),
														($author$project$Api$Partner$RainforestAccount$One$status(rainforestAccount) === 'canceled') ? A3(
														$author$project$Ui$HinterOnly$button,
														{mm: 'Delete Rainforest account'},
														_List_fromArray(
															[
																$author$project$Ui$Button$danger,
																$author$project$Ui$Button$onClick($author$project$Pages$Partner$Billing$DeleteRainforestAccount),
																$author$project$Ui$Button$loading(
																_Utils_eq(model.f7, $author$project$Api$Data$Loading))
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Delete Rainforest account')
															])) : $author$project$Utils$Html$empty
													]));
										} else {
											return $author$project$Utils$Html$empty;
										}
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v1 = model.cQ;
							_v1$3:
							while (true) {
								switch (_v1.$) {
									case 3:
										var rainforestAccount = _v1.a;
										return A2($author$project$Pages$Partner$Billing$viewAccount, rainforestAccount, model);
									case 2:
										if (_v1.a.$ === 5) {
											var _v2 = _v1.a;
											return $author$project$Pages$Partner$Billing$viewSetup;
										} else {
											break _v1$3;
										}
									case 1:
										return $elm$html$Html$text('');
									default:
										break _v1$3;
								}
							}
							return $elm$html$Html$text('');
						}()
						])),
					function () {
					var _v3 = model.cQ;
					if (_v3.$ === 3) {
						var rainforestAccount = _v3.a;
						return A2(
							$author$project$Ui$Panel$footer,
							_List_fromArray(
								[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$gap4]),
							_List_fromArray(
								[
									(model.Ij && (model.DH && A2($author$project$Pages$Partner$Billing$applicationIsProcessing, rainforestAccount, model))) ? A3(
									$author$project$Ui$HinterOnly$button,
									{mm: 'Prefill with fake data'},
									_List_fromArray(
										[
											$author$project$Ui$Button$secondary,
											$author$project$Ui$Button$onClick($author$project$Pages$Partner$Billing$PrefillWithFakeDataClicked)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Prefill')
										])) : $author$project$Utils$Html$empty
								]));
					} else {
						return $author$project$Ui$Panel$none;
					}
				}()
				]))
		]);
};
var $author$project$Pages$Partner$Billing$view = function (model) {
	return {
		fO: $author$project$Pages$Partner$Billing$viewBody(model),
		ac9: 'Partner | Payment Processing'
	};
};
var $author$project$Pages$Partner$Billing$page = $author$project$Spa$Page$applicationPartner(
	{ah_: $author$project$Pages$Partner$Billing$init, aiq: $author$project$Pages$Partner$Billing$load, k8: $author$project$Pages$Partner$Billing$save, alO: $author$project$Pages$Partner$Billing$subscriptions, adT: $author$project$Pages$Partner$Billing$update, amo: $author$project$Pages$Partner$Billing$view});
var $author$project$Pages$Partner$Billing$Charges$PartnerChargesMsg = $elm$core$Basics$identity;
var $author$project$Components$Reports$PartnerCharges$DateRangeInputMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Reports$PartnerCharges$DepositDropdownMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Reports$PartnerCharges$PracticeResourceFilterMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Reports$PartnerCharges$StatusDropdownMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Reports$PartnerCharges$dateRangeInputSettings = F2(
	function (start, end) {
		var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
		return _Utils_update(
			defaultSettings,
			{ahy: start, al5: end});
	});
var $author$project$Components$Reports$PartnerCharges$GotDeposits = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Partner$Reports$Deposit$Deposit = $elm$core$Basics$identity;
var $author$project$Api$Partner$Reports$Deposit$Record = F8(
	function (id, availableOn, amountInCents, totalFeeInCents, depositFeeInCents, paymentsCount, status, errorMessage) {
		return {LE: amountInCents, Mp: availableOn, agr: depositFeeInCents, RM: errorMessage, ahP: id, Zj: paymentsCount, alH: status, adn: totalFeeInCents};
	});
var $author$project$Api$Partner$Reports$Deposit$Canceled = 3;
var $author$project$Api$Partner$Reports$Deposit$Failed = 4;
var $author$project$Api$Partner$Reports$Deposit$InTransit = 2;
var $author$project$Api$Partner$Reports$Deposit$Paid = 0;
var $author$project$Api$Partner$Reports$Deposit$Pending = 1;
var $author$project$Api$Partner$Reports$Deposit$Upcoming = 5;
var $author$project$Api$Partner$Reports$Deposit$decodeStatus = function (string) {
	switch (string) {
		case 'paid':
			return $elm$json$Json$Decode$succeed(0);
		case 'pending':
			return $elm$json$Json$Decode$succeed(1);
		case 'in_transit':
			return $elm$json$Json$Decode$succeed(2);
		case 'canceled':
			return $elm$json$Json$Decode$succeed(3);
		case 'failed':
			return $elm$json$Json$Decode$succeed(4);
		case 'upcoming':
			return $elm$json$Json$Decode$succeed(5);
		default:
			return $elm$json$Json$Decode$fail('Unsupported deposit status: ' + string);
	}
};
var $author$project$Api$Partner$Reports$Deposit$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'error_message',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'status',
		A2($elm$json$Json$Decode$andThen, $author$project$Api$Partner$Reports$Deposit$decodeStatus, $elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'payments_count',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'deposit_fee_in_cents',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'total_fee_in_cents',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'amount_in_cents',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'available_on',
							$author$project$Utils$Date$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Api$Partner$Reports$Deposit$Record)))))))));
var $author$project$Api$Partner$Reports$Deposit$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$Reports$Deposit$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$Reports$Deposit$listDefaults = {HB: $elm$core$Maybe$Nothing, ajJ: $author$project$Api$Pagination$init, alA: $author$project$Api$Sort$init, JV: $elm$core$Maybe$Nothing, alH: $elm$core$Maybe$Nothing};
var $author$project$Api$Partner$Reports$Deposit$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Partner$Reports$Deposit$listDefaults);
	return A2(
		$elm$core$List$append,
		$author$project$Api$Pagination$toApiParams(options.ajJ),
		A2(
			$elm$core$List$append,
			$author$project$Api$Sort$toParams(options.alA),
			$elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						var _v0 = options.JV;
						if (!_v0.$) {
							var start_ = _v0.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'start', start_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v1 = options.HB;
						if (!_v1.$) {
							var end_ = _v1.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'end', end_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v2 = options.alH;
						if (!_v2.$) {
							var status_ = _v2.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'status', status_)
								]);
						} else {
							return _List_Nil;
						}
					}()
					]))));
};
var $author$project$Api$Partner$Reports$Deposit$listPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['reports', 'deposits']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$Reports$Deposit$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Partner$Reports$Deposit$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Partner$Reports$Deposit$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Partner$Reports$Deposit$listPath)));
	});
var $author$project$Components$Reports$PartnerCharges$fetchDeposits = function (apiClient) {
	return A3(
		$author$project$Api$Partner$Reports$Deposit$list,
		apiClient,
		function (d) {
			return _Utils_update(
				d,
				{
					alA: A3($author$project$Api$Sort$withDefault, 'available_on', 1, $author$project$Api$Sort$init)
				});
		},
		$author$project$Components$Reports$PartnerCharges$GotDeposits);
};
var $author$project$Components$Reports$PartnerCharges$GotPartnerCharges = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Reports$PartnerCharges$fetchPartnerChargesParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				Hq: model.agt,
				HB: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.HB),
				ajJ: model.ajJ,
				ZV: model.Ji,
				alA: model.alA,
				JV: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.JV),
				alH: model.alH
			});
	};
};
var $author$project$Api$Partner$Reports$PartnerCharge$PartnerCharge = $elm$core$Basics$identity;
var $author$project$Api$Partner$Reports$PartnerCharge$Record = function (id) {
	return function (practice) {
		return function (description) {
			return function (amountInCents) {
				return function (feeInCents) {
					return function (status) {
						return function (source) {
							return function (createdAt) {
								return function (dateInvoiced) {
									return function (datePaid) {
										return {LE: amountInCents, O1: createdAt, PE: dateInvoiced, PG: datePaid, Qr: description, Sh: feeInCents, ahP: id, ZV: practice, JQ: source, alH: status};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Partner$Reports$PartnerCharge$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'date_paid',
	$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'date_invoiced',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'created_at',
			$elm_community$json_extra$Json$Decode$Extra$datetime,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'source',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'status',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'fee_in_cents',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'amount_in_cents',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'description',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'practice',
									$author$project$Api$Partner$Practice$Min$decoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Api$Partner$Reports$PartnerCharge$Record)))))))))));
var $author$project$Api$Partner$Reports$PartnerCharge$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$Reports$PartnerCharge$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$Reports$PartnerCharge$listDefaults = {
	Hq: $elm$core$Maybe$Nothing,
	HB: $elm$core$Maybe$Nothing,
	ajJ: $author$project$Api$Pagination$init,
	ZV: $elm$core$Maybe$Nothing,
	alA: A3($author$project$Api$Sort$withDefault, 'created_at', 1, $author$project$Api$Sort$init),
	JV: $elm$core$Maybe$Nothing,
	alH: $elm$core$Maybe$Nothing
};
var $author$project$Api$Partner$Reports$PartnerCharge$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Partner$Reports$PartnerCharge$listDefaults);
	return A2(
		$elm$core$List$append,
		$author$project$Api$Pagination$toApiParams(options.ajJ),
		A2(
			$elm$core$List$append,
			$author$project$Api$Sort$toParams(options.alA),
			$elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						var _v0 = options.JV;
						if (!_v0.$) {
							var start_ = _v0.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'start', start_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v1 = options.HB;
						if (!_v1.$) {
							var end_ = _v1.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'end', end_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v2 = options.ZV;
						if (!_v2.$) {
							var practice_ = _v2.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'practice', practice_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v3 = options.Hq;
						if (!_v3.$) {
							var string = _v3.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'deposit', string)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v4 = options.alH;
						if (!_v4.$) {
							var status_ = _v4.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'status', status_)
								]);
						} else {
							return _List_Nil;
						}
					}()
					]))));
};
var $author$project$Api$Partner$Reports$PartnerCharge$listPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['reports', 'partner_charges']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$Reports$PartnerCharge$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Partner$Reports$PartnerCharge$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Partner$Reports$PartnerCharge$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Partner$Reports$PartnerCharge$listPath)));
	});
var $author$project$Components$Reports$PartnerCharges$fetchPartnerCharges = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Api$Partner$Reports$PartnerCharge$list,
			apiClient,
			$author$project$Components$Reports$PartnerCharges$fetchPartnerChargesParams(model),
			$author$project$Components$Reports$PartnerCharges$GotPartnerCharges);
	});
var $author$project$Components$ResourceFilter$Partner$Practice$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Api$Partner$Practice$listDefaults = {ajJ: $author$project$Api$Pagination$init, akl: $elm$core$Maybe$Nothing, alA: $author$project$Api$Sort$init};
var $author$project$Api$Partner$Practice$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Partner$Practice$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.akl;
				if (!_v0.$) {
					var query = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', query)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$Partner$Practice$practicesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['practices']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$Practice$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Partner$Practice$Min$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Partner$Practice$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Partner$Practice$practicesPath)));
	});
var $author$project$Components$ResourceFilter$Partner$Practice$list = F3(
	function (apiClient, optionals, toMsg) {
		return A3($author$project$Api$Partner$Practice$list, apiClient, optionals, toMsg);
	});
var $author$project$Components$ResourceFilter$Partner$Practice$fetchResources = F4(
	function (toMsg, apiClient, pagination, query) {
		return A3(
			$author$project$Components$ResourceFilter$Partner$Practice$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{ajJ: pagination, akl: query});
			},
			toMsg);
	});
var $author$project$Components$ResourceFilter$Partner$Practice$retrieveResource = F3(
	function (toMsg, apiClient, id) {
		return A3(
			$author$project$Components$ResourceFilter$Partner$Practice$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						akl: $elm$core$Maybe$Just(id)
					});
			},
			toMsg);
	});
var $author$project$Components$ResourceFilter$Partner$Practice$selectId = 'partner-practices';
var $author$project$Components$ResourceFilter$Partner$Practice$toTitle = $author$project$Api$Partner$Practice$Min$name;
var $author$project$Components$ResourceFilter$Partner$Practice$toLabel = function (resource) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Components$ResourceFilter$Partner$Practice$toTitle(resource))
		]);
};
var $author$project$Api$Partner$Practice$Min$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Components$ResourceFilter$Partner$Practice$toValue = $author$project$Api$Partner$Practice$Min$id;
var $author$project$Components$ResourceFilter$Partner$Practice$init = F2(
	function (apiClient, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{Sk: $author$project$Components$ResourceFilter$Partner$Practice$fetchResources, ahP: $author$project$Components$ResourceFilter$Partner$Practice$selectId, k$: 'Practices', uk: $author$project$Components$ResourceFilter$Partner$Practice$retrieveResource, u9: $author$project$Components$ResourceFilter$Partner$Practice$toLabel, lN: $author$project$Components$ResourceFilter$Partner$Practice$toTitle, hX: $author$project$Components$ResourceFilter$Partner$Practice$toValue},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{Jy: $author$project$Components$ResourceFilter$All, b8: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$Reports$PartnerCharges$initColumns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'created_at', true, 'Date Created'),
		A3($author$project$Api$Column$init, 'description', true, 'Description'),
		A3($author$project$Api$Column$init, 'practice', true, 'Practice'),
		A3($author$project$Api$Column$init, 'amount_in_cents', true, 'Amount'),
		A3($author$project$Api$Column$init, 'fee_in_cents', false, 'Service Fee'),
		A3($author$project$Api$Column$init, 'status', false, 'Status'),
		A3($author$project$Api$Column$init, 'date_invoiced', false, 'Date Invoiced'),
		A3($author$project$Api$Column$init, 'date_paid', false, 'Date Paid'),
		A3($author$project$Api$Column$init, 'source', true, 'Source'),
		A3($author$project$Api$Column$init, 'actions', false, '')
	]);
var $author$project$Components$Reports$PartnerCharges$init = F2(
	function (options, _v0) {
		var currentDate = _v0.dd;
		var apiClient = _v0.Gv;
		var timeFormatter = _v0.J7;
		var _v1 = A2(
			$author$project$Components$ResourceFilter$Partner$Practice$init,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'All Practices'});
			});
		var practiceResourceFilter = _v1.a;
		var practiceResourceFilterCmd = _v1.b;
		var _v2 = A2(
			$author$project$Components$DateRangeInput$init,
			'partner-charges-date-range',
			A2($author$project$Components$Reports$PartnerCharges$dateRangeInputSettings, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing));
		var dateRangeInput = _v2.a;
		var dateRangeInputCmd = _v2.b;
		var model = {
			N3: $author$project$Components$Reports$PartnerCharges$initColumns,
			dd: currentDate,
			i4: dateRangeInput,
			nh: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'partner-charges-deposit-dropdown', al6: $author$project$Components$Reports$PartnerCharges$DepositDropdownMsg})),
			agt: options.agt,
			cC: $author$project$Api$Data$Loading,
			HB: $elm$core$Maybe$Nothing,
			ajJ: $author$project$Api$Pagination$init,
			bc: $author$project$Api$Data$Loading,
			Ji: $elm$core$Maybe$Nothing,
			kL: practiceResourceFilter,
			alA: A3($author$project$Api$Sort$withDefault, 'created_at', 1, $author$project$Api$Sort$init),
			JV: $elm$core$Maybe$Nothing,
			alH: $elm$core$Maybe$Nothing,
			qn: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'partner-charges-status-dropdown', al6: $author$project$Components$Reports$PartnerCharges$StatusDropdownMsg})),
			J7: timeFormatter
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PartnerCharges$DateRangeInputMsg, dateRangeInputCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PartnerCharges$PracticeResourceFilterMsg, practiceResourceFilterCmd),
						A2($author$project$Components$Reports$PartnerCharges$fetchPartnerCharges, apiClient, model),
						$author$project$Components$Reports$PartnerCharges$fetchDeposits(apiClient)
					])));
	});
var $author$project$Pages$Partner$Billing$Charges$init = F4(
	function (_v0, partner, shared, url) {
		var _v1 = A2(
			$author$project$Components$Reports$PartnerCharges$init,
			{
				agt: A2($elm$core$Dict$get, 'deposit', url.DE)
			},
			shared);
		var partnerCharges = _v1.a;
		var partnerChargesCmd = _v1.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, YN: partner, bc: partnerCharges},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, partnerChargesCmd));
	});
var $author$project$Pages$Partner$Billing$Charges$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Partner$Billing$Charges$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$ResourceFilter$Partner$Practice$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.b8));
};
var $author$project$Components$Reports$PartnerCharges$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$PartnerCharges$DateRangeInputMsg,
				$author$project$Components$DateRangeInput$subscriptions(model.i4)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$PartnerCharges$PracticeResourceFilterMsg,
				$author$project$Components$ResourceFilter$Partner$Practice$subscriptions(model.kL)),
				$author$project$Ui$Dropdown$subscriptions(model.qn),
				$author$project$Ui$Dropdown$subscriptions(model.nh)
			]));
};
var $author$project$Pages$Partner$Billing$Charges$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Reports$PartnerCharges$subscriptions(model.bc));
};
var $author$project$Components$Reports$PartnerCharges$GotCancelResult = function (a) {
	return {$: 11, a: a};
};
var $author$project$Api$Partner$PartnerCharge$partnerChargesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['partner_charges']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$PartnerCharge$partnerChargePath = function (chargeId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[chargeId]),
		$author$project$Api$Partner$PartnerCharge$partnerChargesPath);
};
var $author$project$Api$Partner$PartnerCharge$cancel = F3(
	function (apiClient, chargeId, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['cancel']),
					$author$project$Api$Partner$PartnerCharge$partnerChargePath(chargeId))));
	});
var $author$project$Components$ResourceFilter$Partner$Practice$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.b8);
		var modelAfterEvent = function () {
			var _v1 = result.agZ;
			if (!_v1.$) {
				var selected = _v1.a;
				return _Utils_update(
					model,
					{Jy: selected});
			} else {
				return model;
			}
		}();
		return {
			GZ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.GZ),
			agZ: result.agZ,
			aiO: _Utils_update(
				modelAfterEvent,
				{b8: result.aiO}),
			aR: result.aR
		};
	});
var $author$project$Components$Reports$PartnerCharges$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('start'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.dd, 0)),
			model.JV),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('end'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.dd, 0)),
			model.HB),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('deposit'),
			model.agt),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('status'),
			model.alH)
		]);
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Partner__Billing__Charges)
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.ajJ),
				A2(
					$elm$core$List$append,
					$author$project$Api$Sort$toQuery(model.alA),
					A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
};
var $author$project$Components$ResourceFilter$Partner$Practice$value = function (model) {
	return A2($author$project$Components$ResourceFilter$choiceToValue, model.b8, model.Jy);
};
var $author$project$Components$Reports$PartnerCharges$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Components$DateRangeInput$update, subMsg, model.i4);
				var dateRangeInput = _v1.a;
				var subCmd = _v1.b;
				var event = _v1.c;
				var newModel = function () {
					if (event.$ === 1) {
						var fromDate = event.a;
						var toDate = event.b;
						return _Utils_update(
							model,
							{
								i4: dateRangeInput,
								HB: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
								ajJ: $author$project$Api$Pagination$reset(model.ajJ),
								bc: $author$project$Api$Data$Loading,
								JV: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
							});
					} else {
						return _Utils_update(
							model,
							{i4: dateRangeInput});
					}
				}();
				var cmds = (_Utils_eq(newModel.JV, model.JV) && _Utils_eq(newModel.HB, model.HB)) ? _List_Nil : _List_fromArray(
					[
						A2($author$project$Components$Reports$PartnerCharges$fetchPartnerCharges, apiClient, newModel),
						$author$project$Components$Reports$PartnerCharges$updateUrl(newModel)
					]);
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$cons,
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PartnerCharges$DateRangeInputMsg, subCmd),
							cmds)),
					_List_Nil);
			case 1:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ),
								bc: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bc: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 2:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cC: response}),
					$elm$core$Platform$Cmd$none,
					function () {
						if (response.$ === 3) {
							return _List_Nil;
						} else {
							return $author$project$OutMsg$handleErrorResponse(response);
						}
					}());
			case 3:
				var subMsg = msg.a;
				var _v5 = A2($author$project$Ui$Dropdown$update, subMsg, model.nh);
				var depositDropdown = _v5.a;
				var cmd = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nh: depositDropdown}),
					cmd,
					_List_Nil);
			case 4:
				var depositId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						agt: depositId,
						ajJ: $author$project$Api$Pagination$reset(model.ajJ),
						bc: $author$project$Api$Data$Loading
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$PartnerCharges$fetchPartnerCharges, apiClient, newModel),
								$author$project$Components$Reports$PartnerCharges$updateUrl(newModel)
							])),
					_List_Nil);
			case 5:
				var subMsg = msg.a;
				var practiceResourceResult = A3($author$project$Components$ResourceFilter$Partner$Practice$update, apiClient, subMsg, model.kL);
				var practiceId = function () {
					var _v7 = practiceResourceResult.agZ;
					if (!_v7.$) {
						return $author$project$Components$ResourceFilter$Partner$Practice$value(practiceResourceResult.aiO);
					} else {
						return model.Ji;
					}
				}();
				var newModel = _Utils_update(
					model,
					{Ji: practiceId, kL: practiceResourceResult.aiO});
				var _v6 = function () {
					if (_Utils_eq(model.Ji, newModel.Ji)) {
						return _Utils_Tuple3(model.bc, $elm$core$Platform$Cmd$none, model.ajJ);
					} else {
						var paginationReset = $author$project$Api$Pagination$reset(model.ajJ);
						return _Utils_Tuple3(
							$author$project$Api$Data$Loading,
							A2($author$project$Components$Reports$PartnerCharges$fetchPartnerCharges, apiClient, newModel),
							paginationReset);
					}
				}();
				var partnerCharges = _v6.a;
				var cmd = _v6.b;
				var pagination = _v6.c;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{ajJ: pagination, bc: partnerCharges}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PartnerCharges$PracticeResourceFilterMsg, practiceResourceResult.GZ),
								cmd
							])),
					practiceResourceResult.aR);
			case 6:
				var subMsg = msg.a;
				var newPagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{ajJ: newPagination, bc: $author$project$Api$Data$Loading});
				return _Utils_Tuple3(
					newModel,
					A2($author$project$Components$Reports$PartnerCharges$fetchPartnerCharges, apiClient, newModel),
					_List_Nil);
			case 7:
				var columnKey = msg.a;
				var newSort = A2($author$project$Api$Sort$update, columnKey, model.alA);
				var newModel = _Utils_update(
					model,
					{bc: $author$project$Api$Data$Loading, alA: newSort});
				return _Utils_Tuple3(
					newModel,
					A2($author$project$Components$Reports$PartnerCharges$fetchPartnerCharges, apiClient, newModel),
					_List_Nil);
			case 8:
				var subMsg = msg.a;
				var _v8 = A2($author$project$Ui$Dropdown$update, subMsg, model.qn);
				var statusDropdown = _v8.a;
				var statusDropdownCmd = _v8.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qn: statusDropdown}),
					statusDropdownCmd,
					_List_Nil);
			case 9:
				var selectedOption = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ajJ: $author$project$Api$Pagination$reset(model.ajJ),
						bc: $author$project$Api$Data$Loading,
						alH: function () {
							if (selectedOption.$ === 1) {
								return $elm$core$Maybe$Nothing;
							} else {
								var s = selectedOption.a;
								return $elm$core$Maybe$Just(s);
							}
						}()
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$PartnerCharges$fetchPartnerCharges, apiClient, newModel),
								$author$project$Components$Reports$PartnerCharges$updateUrl(newModel)
							])),
					_List_Nil);
			case 10:
				var chargeId = msg.a;
				return _Utils_Tuple3(
					model,
					A3($author$project$Api$Partner$PartnerCharge$cancel, apiClient, chargeId, $author$project$Components$Reports$PartnerCharges$GotCancelResult),
					_List_Nil);
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bc: $author$project$Api$Data$Loading}),
						A2($author$project$Components$Reports$PartnerCharges$fetchPartnerCharges, apiClient, model),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Partner charge cancelled')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Partner$Billing$Charges$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Reports$PartnerCharges$update, model.Gv, subMsg, model.bc);
		var partnerCharges = _v1.a;
		var cmd = _v1.b;
		var outMsgs = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{bc: partnerCharges}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd),
			outMsgs);
	});
var $author$project$Components$Reports$PartnerCharges$PaginationMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Reports$PartnerCharges$DepositSelected = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Partner$Reports$Deposit$amountInCents = function (_v0) {
	var record = _v0;
	return record.LE;
};
var $author$project$Api$Partner$Reports$Deposit$availableOn = function (_v0) {
	var record = _v0;
	return record.Mp;
};
var $author$project$Components$Reports$PartnerCharges$depositLabel = function (deposit) {
	return $author$project$Utils$Currency$fromInt(
		$author$project$Api$Partner$Reports$Deposit$amountInCents(deposit)) + (' on ' + A2(
		$author$project$Formatters$Date$toString,
		$author$project$Formatters$Date$Full,
		$author$project$Api$Partner$Reports$Deposit$availableOn(deposit)));
};
var $author$project$Api$Partner$Reports$Deposit$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Components$Reports$PartnerCharges$depositDropdownItems = F2(
	function (deposits, currentDepositId) {
		return A2(
			$elm$core$List$cons,
			A2(
				$author$project$Ui$Dropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$Dropdown$onSelect(
						$author$project$Components$Reports$PartnerCharges$DepositSelected($elm$core$Maybe$Nothing)),
						$author$project$Ui$Dropdown$selected(
						_Utils_eq(currentDepositId, $elm$core$Maybe$Nothing))
					]),
				$elm$html$Html$text('All Deposits')),
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Ui$Dropdown$item,
					_List_fromArray(
						[
							$author$project$Ui$Dropdown$onSelect(
							$author$project$Components$Reports$PartnerCharges$DepositSelected(
								$elm$core$Maybe$Just(''))),
							$author$project$Ui$Dropdown$selected(
							_Utils_eq(
								currentDepositId,
								$elm$core$Maybe$Just('')))
						]),
					$elm$html$Html$text('No Deposit')),
				A2(
					$elm$core$List$cons,
					$author$project$Ui$Dropdown$separator,
					A2(
						$elm$core$List$map,
						function (deposit) {
							var depositId = $author$project$Api$Partner$Reports$Deposit$id(deposit);
							return A2(
								$author$project$Ui$Dropdown$item,
								_List_fromArray(
									[
										$author$project$Ui$Dropdown$onSelect(
										$author$project$Components$Reports$PartnerCharges$DepositSelected(
											$elm$core$Maybe$Just(depositId))),
										$author$project$Ui$Dropdown$selected(
										_Utils_eq(
											currentDepositId,
											$elm$core$Maybe$Just(depositId)))
									]),
								$elm$html$Html$text(
									$author$project$Components$Reports$PartnerCharges$depositLabel(deposit)));
						},
						deposits))));
	});
var $author$project$Components$Reports$PartnerCharges$viewDepositDropdown = function (model) {
	var placeholder = function () {
		var _v1 = model.agt;
		if (!_v1.$) {
			if (_v1.a === '') {
				return 'No Deposit';
			} else {
				var depositId = _v1.a;
				var _v2 = model.cC;
				if (_v2.$ === 3) {
					var deposits = _v2.a;
					return A2(
						$elm$core$Maybe$withDefault,
						depositId,
						A2(
							$elm$core$Maybe$map,
							$author$project$Components$Reports$PartnerCharges$depositLabel,
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									function (deposit) {
										return _Utils_eq(
											$author$project$Api$Partner$Reports$Deposit$id(deposit),
											depositId);
									},
									deposits))));
				} else {
					return depositId;
				}
			}
		} else {
			return 'All Deposits';
		}
	}();
	var items = function () {
		var _v0 = model.cC;
		if (_v0.$ === 3) {
			var deposits = _v0.a;
			return A2($author$project$Components$Reports$PartnerCharges$depositDropdownItems, deposits, model.agt);
		} else {
			return _List_Nil;
		}
	}();
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(placeholder)
			]),
		items,
		model.nh);
};
var $author$project$Components$ResourceFilter$Partner$Practice$viewMultiSelected = function (model) {
	return A2(
		$elm$core$List$map,
		$elm$html$Html$map($elm$core$Basics$identity),
		A2($author$project$Components$ResourceFilter$viewMultiSelected, model.Jy, model.b8));
};
var $author$project$Components$ResourceFilter$Partner$Practice$view = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$view,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.Jy),
					options),
				model.b8));
	});
var $author$project$Components$Reports$PartnerCharges$viewPracticeResourceFilter = function (practiceResourceFilter) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Reports$PartnerCharges$PracticeResourceFilterMsg,
		A2(
			$author$project$Components$ResourceFilter$Partner$Practice$view,
			_List_fromArray(
				[
					$author$project$Components$ResourceFilter$style(1),
					$author$project$Components$ResourceFilter$multi
				]),
			practiceResourceFilter));
};
var $author$project$Components$Reports$PartnerCharges$NoStatus = {$: 1};
var $author$project$Components$Reports$PartnerCharges$StatusFiltered = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Reports$PartnerCharges$StatusValue = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Reports$PartnerCharges$statusDropdownOptions = function (currentStatus) {
	var statuses = _List_fromArray(
		['pending', 'invoiced', 'paid', 'disputed', 'cancelled']);
	var statusOptions = A2(
		$elm$core$List$map,
		function (s) {
			return A2(
				$author$project$Ui$Dropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$Dropdown$onSelect(
						$author$project$Components$Reports$PartnerCharges$StatusFiltered(
							$author$project$Components$Reports$PartnerCharges$StatusValue(s))),
						$author$project$Ui$Dropdown$selected(
						_Utils_eq(
							$elm$core$Maybe$Just(s),
							currentStatus))
					]),
				$elm$html$Html$text(
					$elm_community$string_extra$String$Extra$humanize(s)));
		},
		statuses);
	return A2(
		$elm$core$List$cons,
		A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Components$Reports$PartnerCharges$StatusFiltered($author$project$Components$Reports$PartnerCharges$NoStatus)),
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(currentStatus, $elm$core$Maybe$Nothing))
				]),
			$elm$html$Html$text('No Filter')),
		A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, statusOptions));
};
var $author$project$Components$Reports$PartnerCharges$viewStatusDropdown = function (model) {
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				A2(
					$elm$core$Maybe$withDefault,
					'All Statuses',
					A2($elm$core$Maybe$map, $elm_community$string_extra$String$Extra$humanize, model.alH)))
			]),
		$author$project$Components$Reports$PartnerCharges$statusDropdownOptions(model.alH),
		model.qn);
};
var $author$project$Components$Reports$PartnerCharges$SortTable = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Partner$Reports$PartnerCharge$amountInCents = function (_v0) {
	var record = _v0;
	return record.LE;
};
var $author$project$Api$Partner$Reports$PartnerCharge$createdAt = function (_v0) {
	var record = _v0;
	return record.O1;
};
var $author$project$Api$Partner$Reports$PartnerCharge$dateInvoiced = function (_v0) {
	var record = _v0;
	return record.PE;
};
var $author$project$Api$Partner$Reports$PartnerCharge$datePaid = function (_v0) {
	var record = _v0;
	return record.PG;
};
var $author$project$Api$Partner$Reports$PartnerCharge$description = function (_v0) {
	var record = _v0;
	return record.Qr;
};
var $author$project$Api$Partner$Reports$PartnerCharge$feeInCents = function (_v0) {
	var record = _v0;
	return record.Sh;
};
var $author$project$Api$Partner$Reports$PartnerCharge$practiceName = function (_v0) {
	var record = _v0;
	return $author$project$Api$Partner$Practice$Min$name(record.ZV);
};
var $author$project$Api$Partner$Reports$PartnerCharge$source = function (_v0) {
	var record = _v0;
	return record.JQ;
};
var $author$project$Api$Partner$Reports$PartnerCharge$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Components$Reports$PartnerCharges$CancelCharge = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Partner$Reports$PartnerCharge$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Components$Reports$PartnerCharges$viewCancelAction = function (partnerCharge) {
	var chargeStatus = $author$project$Api$Partner$Reports$PartnerCharge$status(partnerCharge);
	return ((chargeStatus === 'pending') || (chargeStatus === 'invoiced')) ? A3(
		$author$project$Ui$Button$view,
		{mm: 'Cancel charge'},
		_List_fromArray(
			[
				$author$project$Ui$Button$danger,
				$author$project$Ui$Button$sm,
				$author$project$Ui$Button$onClick(
				$author$project$Components$Reports$PartnerCharges$CancelCharge(
					$author$project$Api$Partner$Reports$PartnerCharge$id(partnerCharge)))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Cancel')
			])) : $elm$html$Html$text('');
};
var $author$project$Components$Reports$PartnerCharges$viewFeeCell = function (feeCents) {
	return (!feeCents) ? $elm$html$Html$text(
		$author$project$Utils$Currency$fromInt(feeCents)) : A2(
		$author$project$Ui$Typography$text,
		_List_fromArray(
			[$author$project$Ui$Typography$danger]),
		'−' + $author$project$Utils$Currency$fromInt(feeCents));
};
var $author$project$Components$Reports$PartnerCharges$viewMaybeDate = function (maybeDate) {
	if (!maybeDate.$) {
		var date = maybeDate.a;
		return $elm$html$Html$text(
			A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, date));
	} else {
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$textMuted]),
			_List_fromArray(
				[
					$elm$html$Html$text('—')
				]));
	}
};
var $author$project$Components$Reports$PartnerCharges$viewTableRow = F2(
	function (timeFormatter, partnerCharge) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								timeFormatter,
								0,
								$author$project$Api$Partner$Reports$PartnerCharge$createdAt(partnerCharge)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Partner$Reports$PartnerCharge$description(partnerCharge))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Partner$Reports$PartnerCharge$practiceName(partnerCharge))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$Currency$fromInt(
								$author$project$Api$Partner$Reports$PartnerCharge$amountInCents(partnerCharge)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Components$Reports$PartnerCharges$viewFeeCell(
							$author$project$Api$Partner$Reports$PartnerCharge$feeInCents(partnerCharge))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Badge$fromString,
							_List_Nil,
							$author$project$Api$Partner$Reports$PartnerCharge$status(partnerCharge))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Components$Reports$PartnerCharges$viewMaybeDate(
							$author$project$Api$Partner$Reports$PartnerCharge$dateInvoiced(partnerCharge))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Components$Reports$PartnerCharges$viewMaybeDate(
							$author$project$Api$Partner$Reports$PartnerCharge$datePaid(partnerCharge))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm_community$string_extra$String$Extra$humanize(
								$author$project$Api$Partner$Reports$PartnerCharge$source(partnerCharge)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Components$Reports$PartnerCharges$viewCancelAction(partnerCharge)
						]))
				]));
	});
var $author$project$Components$Reports$PartnerCharges$viewTable = function (model) {
	var _v0 = function () {
		var _v1 = model.bc;
		if (_v1.$ === 3) {
			var partnerCharges_ = _v1.a;
			return _Utils_Tuple2(false, partnerCharges_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var partnerCharges = _v0.b;
	return A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any data for the time period selected. Try broadening your search to see more results.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		A2(
			$elm$core$List$map,
			$author$project$Api$Column$view(
				A2($author$project$Api$Column$Sortable, model.alA, $author$project$Components$Reports$PartnerCharges$SortTable)),
			model.N3),
		A2(
			$elm$core$List$map,
			$author$project$Components$Reports$PartnerCharges$viewTableRow(model.J7),
			partnerCharges),
		_List_Nil);
};
var $author$project$Components$Reports$PartnerCharges$view = function (model) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Panel$title(
							_List_fromArray(
								[
									$elm$html$Html$text('Partner Charges')
								])),
							A2(
							$author$project$Ui$Grid$row,
							_List_fromArray(
								[$author$project$Ui$Grid$mt4]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanSm(12)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$map,
											$author$project$Components$Reports$PartnerCharges$DateRangeInputMsg,
											$author$project$Components$DateRangeInput$view(model.i4))
										]))
								])),
							A2(
							$author$project$Ui$Grid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanSm(4)
										]),
									_List_fromArray(
										[
											$author$project$Components$Reports$PartnerCharges$viewPracticeResourceFilter(model.kL)
										])),
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanSm(4)
										]),
									_List_fromArray(
										[
											$author$project$Components$Reports$PartnerCharges$viewStatusDropdown(model)
										])),
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanSm(4)
										]),
									_List_fromArray(
										[
											$author$project$Components$Reports$PartnerCharges$viewDepositDropdown(model)
										]))
								])),
							A2(
							$author$project$Ui$Grid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_Nil,
									function () {
										var activeFilters = A2(
											$elm$core$List$map,
											$elm$html$Html$map($author$project$Components$Reports$PartnerCharges$PracticeResourceFilterMsg),
											$author$project$Components$ResourceFilter$Partner$Practice$viewMultiSelected(model.kL));
										return $elm$core$List$isEmpty(activeFilters) ? _List_Nil : _List_fromArray(
											[
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$mt2, $author$project$Ui$Element$mb2]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$strong,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Active filters')
															]))
													])),
												A2($elm$html$Html$span, _List_Nil, activeFilters)
											]);
									}())
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Components$Reports$PartnerCharges$viewTable(model)
						])),
					A2(
					$author$project$Ui$Panel$footer,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Components$Reports$PartnerCharges$PaginationMsg,
							A2(
								$author$project$Api$Pagination$view,
								_List_fromArray(
									[
										$author$project$Ui$Pagination$List$loading(
										!$author$project$Utils$Maybe$toBool(
											$author$project$Api$Data$toMaybe(model.bc)))
									]),
								model.ajJ))
						]))
				]))
		]);
};
var $author$project$Pages$Partner$Billing$Charges$view = function (model) {
	return {
		fO: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			$author$project$Components$Reports$PartnerCharges$view(model.bc)),
		ac9: 'Partner | Charges'
	};
};
var $author$project$Pages$Partner$Billing$Charges$page = $author$project$Spa$Page$applicationPartner(
	{ah_: $author$project$Pages$Partner$Billing$Charges$init, aiq: $author$project$Pages$Partner$Billing$Charges$load, k8: $author$project$Pages$Partner$Billing$Charges$save, alO: $author$project$Pages$Partner$Billing$Charges$subscriptions, adT: $author$project$Pages$Partner$Billing$Charges$update, amo: $author$project$Pages$Partner$Billing$Charges$view});
var $author$project$Pages$Partner$Billing$Deposits$DepositsMsg = $elm$core$Basics$identity;
var $author$project$Components$Reports$PartnerDeposits$DateRangeInputMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Partner$Report$Deposit = 0;
var $author$project$Components$Reports$PartnerDeposits$StatusDropdownMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Reports$PartnerDeposits$dateRangeInputSettings = F2(
	function (start, end) {
		var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
		return _Utils_update(
			defaultSettings,
			{ahy: start, al5: end});
	});
var $author$project$Components$Reports$PartnerDeposits$GotDeposits = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Reports$PartnerDeposits$fetchDepositsParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				HB: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.HB),
				ajJ: model.ajJ,
				alA: model.alA,
				JV: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.JV),
				alH: model.alH
			});
	};
};
var $author$project$Components$Reports$PartnerDeposits$fetchDeposits = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Api$Partner$Reports$Deposit$list,
			apiClient,
			$author$project$Components$Reports$PartnerDeposits$fetchDepositsParams(model),
			$author$project$Components$Reports$PartnerDeposits$GotDeposits);
	});
var $author$project$Components$Reports$PartnerDeposits$initColumns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'available_on', true, 'Est. Available Date'),
		A3($author$project$Api$Column$init, 'amount_in_cents', true, 'Deposit Amount'),
		A3($author$project$Api$Column$init, 'total_fee_in_cents', true, 'Total Fee'),
		A3($author$project$Api$Column$init, 'payments_count', false, 'Payments'),
		A3($author$project$Api$Column$init, 'status', true, 'Status'),
		A3($author$project$Api$Column$init, 'actions', false, '')
	]);
var $author$project$Components$ExportCsv$Partner = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$ExportCsv$initForPartner = function (resource) {
	return $author$project$Components$ExportCsv$emptyModel(
		$author$project$Components$ExportCsv$Partner(resource));
};
var $author$project$Components$Reports$PartnerDeposits$init = function (shared) {
	var _v0 = A2(
		$author$project$Components$DateRangeInput$init,
		'date-range-input',
		A2($author$project$Components$Reports$PartnerDeposits$dateRangeInputSettings, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing));
	var dateRangeInput = _v0.a;
	var dateRangeInputCmd = _v0.b;
	var model = {
		N3: $author$project$Components$Reports$PartnerDeposits$initColumns,
		dd: shared.dd,
		i4: dateRangeInput,
		cC: $author$project$Api$Data$Loading,
		HB: $elm$core$Maybe$Nothing,
		nD: $author$project$Components$ExportCsv$initForPartner(0),
		Ij: $author$project$Shared$isHintAdmin(shared),
		ajJ: $author$project$Api$Pagination$init,
		hq: $elm$core$Maybe$Nothing,
		alA: A3($author$project$Api$Sort$withDefault, 'available_on', 1, $author$project$Api$Sort$init),
		JV: $elm$core$Maybe$Nothing,
		alH: $elm$core$Maybe$Nothing,
		qn: $author$project$Ui$Dropdown$init(
			$author$project$Ui$Dropdown$defaultConfig(
				{ahP: 'deposits-status-dropdown', al6: $author$project$Components$Reports$PartnerDeposits$StatusDropdownMsg}))
	};
	return _Utils_Tuple2(
		model,
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PartnerDeposits$DateRangeInputMsg, dateRangeInputCmd),
					A2($author$project$Components$Reports$PartnerDeposits$fetchDeposits, shared.Gv, model)
				])));
};
var $author$project$Pages$Partner$Billing$Deposits$init = F4(
	function (_v0, _v1, shared, _v2) {
		var _v3 = $author$project$Components$Reports$PartnerDeposits$init(shared);
		var deposits = _v3.a;
		var depositsCmd = _v3.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, cC: deposits},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, depositsCmd));
	});
var $author$project$Pages$Partner$Billing$Deposits$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Partner$Billing$Deposits$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Reports$PartnerDeposits$CloseRainforestDepositModal = {$: 9};
var $author$project$Components$Reports$PartnerDeposits$ExportCsvMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Reports$PartnerDeposits$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$PartnerDeposits$DateRangeInputMsg,
				$author$project$Components$DateRangeInput$subscriptions(model.i4)),
				$author$project$Ui$Dropdown$subscriptions(model.qn),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$PartnerDeposits$ExportCsvMsg,
				$author$project$Components$ExportCsv$subscriptions(model.nD)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Rainforest$SessionModal$subscriptions($author$project$Components$Reports$PartnerDeposits$CloseRainforestDepositModal)),
					model.hq))
			]));
};
var $author$project$Pages$Partner$Billing$Deposits$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Reports$PartnerDeposits$subscriptions(model.cC));
};
var $author$project$Api$Platform$RainforestSession$Deposit = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Reports$PartnerDeposits$RainforestDepositModalMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Reports$PartnerDeposits$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Components$DateRangeInput$update, subMsg, model.i4);
				var dateRangeInput = _v1.a;
				var subCmd = _v1.b;
				var event = _v1.c;
				var newModel = function () {
					if (event.$ === 1) {
						var fromDate = event.a;
						var toDate = event.b;
						return _Utils_update(
							model,
							{
								i4: dateRangeInput,
								cC: $author$project$Api$Data$Loading,
								HB: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
								ajJ: $author$project$Api$Pagination$reset(model.ajJ),
								JV: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
							});
					} else {
						return _Utils_update(
							model,
							{i4: dateRangeInput});
					}
				}();
				var cmds = (_Utils_eq(newModel.JV, model.JV) && _Utils_eq(newModel.HB, model.HB)) ? _List_Nil : _List_fromArray(
					[
						A2($author$project$Components$Reports$PartnerDeposits$fetchDeposits, apiClient, newModel)
					]);
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$cons,
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PartnerDeposits$DateRangeInputMsg, subCmd),
							cmds)),
					_List_Nil);
			case 1:
				var subMsg = msg.a;
				var _v3 = A2($author$project$Ui$Dropdown$update, subMsg, model.qn);
				var statusDropdown = _v3.a;
				var statusDropdownCmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qn: statusDropdown}),
					statusDropdownCmd,
					_List_Nil);
			case 2:
				var selectedOption = msg.a;
				var newModel = _Utils_update(
					model,
					{
						cC: $author$project$Api$Data$Loading,
						ajJ: $author$project$Api$Pagination$reset(model.ajJ),
						alH: function () {
							if (selectedOption.$ === 1) {
								return $elm$core$Maybe$Nothing;
							} else {
								var status = selectedOption.a;
								return $elm$core$Maybe$Just(status);
							}
						}()
					});
				return _Utils_Tuple3(
					newModel,
					A2($author$project$Components$Reports$PartnerDeposits$fetchDeposits, apiClient, newModel),
					_List_Nil);
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cC: response,
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cC: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 4:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{cC: $author$project$Api$Data$Loading, ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					A2($author$project$Components$Reports$PartnerDeposits$fetchDeposits, apiClient, newModel),
					_List_Nil);
			case 5:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						alA: A2($author$project$Api$Sort$update, columnId, model.alA)
					});
				return _Utils_Tuple3(
					newModel,
					A2($author$project$Components$Reports$PartnerDeposits$fetchDeposits, apiClient, newModel),
					_List_Nil);
			case 6:
				var subMsg = msg.a;
				var _v6 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.nD);
				var exportCsv = _v6.a;
				var subCmd = _v6.b;
				var subOutMsg = _v6.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nD: exportCsv}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PartnerDeposits$ExportCsvMsg, subCmd),
					subOutMsg);
			case 7:
				var deposit = msg.a;
				var _v7 = A2(
					$author$project$Components$Rainforest$SessionModal$init,
					apiClient,
					$author$project$Api$Platform$RainforestSession$Deposit(
						$author$project$Api$Partner$Reports$Deposit$id(deposit)));
				var rainforestDepositModal = _v7.a;
				var rainforestDepositModalCmd = _v7.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							hq: $elm$core$Maybe$Just(rainforestDepositModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PartnerDeposits$RainforestDepositModalMsg, rainforestDepositModalCmd),
					_List_Nil);
			case 8:
				var subMsg = msg.a;
				var _v8 = model.hq;
				if (!_v8.$) {
					var rainforestDepositModal = _v8.a;
					var _v9 = A2($author$project$Components$Rainforest$SessionModal$update, subMsg, rainforestDepositModal);
					var newRainforestDepositModal = _v9.a;
					var rainforestDepositModalCmd = _v9.b;
					var rainforestDepositModalOutMsg = _v9.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								hq: $elm$core$Maybe$Just(newRainforestDepositModal)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PartnerDeposits$RainforestDepositModalMsg, rainforestDepositModalCmd),
						rainforestDepositModalOutMsg);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{hq: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
		}
	});
var $author$project$Pages$Partner$Billing$Deposits$update = F2(
	function (msg, model) {
		var depositsMsg = msg;
		return A2(
			$author$project$Utils$Tuple3$mapSecond,
			$elm$core$Platform$Cmd$map($elm$core$Basics$identity),
			A2(
				$author$project$Utils$Tuple3$mapFirst,
				function (d) {
					return _Utils_update(
						model,
						{cC: d});
				},
				A3($author$project$Components$Reports$PartnerDeposits$update, model.Gv, depositsMsg, model.cC)));
	});
var $author$project$Components$Reports$PartnerDeposits$PaginationMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Reports$PartnerDeposits$intFromHeader = F2(
	function (headers, name) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$String$toInt,
				A2($elm$core$Dict$get, name, headers)));
	});
var $author$project$Components$Reports$PartnerDeposits$formatStatus = $elm_community$string_extra$String$Extra$humanize;
var $author$project$Components$Reports$PartnerDeposits$None = {$: 1};
var $author$project$Components$Reports$PartnerDeposits$Status = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Reports$PartnerDeposits$StatusFiltered = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Reports$PartnerDeposits$statusDropdownOptions = function (currentStatus) {
	var baseStatusOptions = _List_fromArray(
		['failed', 'paid', 'pending']);
	var statusOptions = A2(
		$elm$core$List$map,
		function (status) {
			return A2(
				$author$project$Ui$Dropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$Dropdown$onSelect(
						$author$project$Components$Reports$PartnerDeposits$StatusFiltered(
							$author$project$Components$Reports$PartnerDeposits$Status(status))),
						$author$project$Ui$Dropdown$selected(
						_Utils_eq(
							$elm$core$Maybe$Just(status),
							currentStatus))
					]),
				$elm$html$Html$text(
					$author$project$Components$Reports$PartnerDeposits$formatStatus(status)));
		},
		baseStatusOptions);
	return A2(
		$elm$core$List$cons,
		A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Components$Reports$PartnerDeposits$StatusFiltered($author$project$Components$Reports$PartnerDeposits$None)),
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(currentStatus, $elm$core$Maybe$Nothing))
				]),
			$elm$html$Html$text('No Filter')),
		A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, statusOptions));
};
var $author$project$Components$Reports$PartnerDeposits$viewStatusDropdown = function (model) {
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				A2(
					$elm$core$Maybe$withDefault,
					'All Status',
					A2($elm$core$Maybe$map, $author$project$Components$Reports$PartnerDeposits$formatStatus, model.alH)))
			]),
		$author$project$Components$Reports$PartnerDeposits$statusDropdownOptions(model.alH),
		model.qn);
};
var $author$project$Components$Reports$PartnerDeposits$SortTable = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Reports$PartnerDeposits$OpenRainforestDepositModal = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Partner$Reports$Deposit$errorMessage = function (_v0) {
	var record = _v0;
	return record.RM;
};
var $author$project$Api$Partner$Reports$Deposit$paymentsCount = function (_v0) {
	var record = _v0;
	return record.Zj;
};
var $author$project$Api$Partner$Reports$Deposit$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Api$Partner$Reports$Deposit$statusToString = function (status_) {
	switch (status_) {
		case 0:
			return 'paid';
		case 1:
			return 'pending';
		case 2:
			return 'in transit';
		case 3:
			return 'canceled';
		case 4:
			return 'failed';
		default:
			return 'upcoming';
	}
};
var $author$project$Api$Partner$Reports$Deposit$totalFeeInCents = function (_v0) {
	var record = _v0;
	return record.adn;
};
var $author$project$Components$Reports$PartnerDeposits$viewRow = F2(
	function (isHintAdmin, deposit) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Partner__Billing__Charges,
							_List_fromArray(
								[
									$author$project$Ui$Link$routeParams(
									_List_fromArray(
										[
											A2(
											$elm$url$Url$Builder$string,
											'deposit',
											$author$project$Api$Partner$Reports$Deposit$id(deposit))
										]))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$Date$toString,
										$author$project$Formatters$Date$Full,
										$author$project$Api$Partner$Reports$Deposit$availableOn(deposit)))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$Currency$fromInt(
								$author$project$Api$Partner$Reports$Deposit$amountInCents(deposit)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$Currency$fromInt(
								$author$project$Api$Partner$Reports$Deposit$totalFeeInCents(deposit)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(
								$author$project$Api$Partner$Reports$Deposit$paymentsCount(deposit)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = _Utils_Tuple2(
								$author$project$Api$Partner$Reports$Deposit$status(deposit),
								$author$project$Api$Partner$Reports$Deposit$errorMessage(deposit));
							if ((_v0.a === 4) && (!_v0.b.$)) {
								var _v1 = _v0.a;
								var errorMessage = _v0.b.a;
								return A3(
									$author$project$Ui$Tooltip$view,
									_List_fromArray(
										[
											$author$project$Ui$Tooltip$placement(0)
										]),
									errorMessage,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Badge$fromString,
											_List_Nil,
											$author$project$Api$Partner$Reports$Deposit$statusToString(
												$author$project$Api$Partner$Reports$Deposit$status(deposit)))
										]));
							} else {
								return A2(
									$author$project$Ui$Badge$fromString,
									_List_Nil,
									$author$project$Api$Partner$Reports$Deposit$statusToString(
										$author$project$Api$Partner$Reports$Deposit$status(deposit)));
							}
						}()
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							isHintAdmin ? A3(
							$author$project$Ui$HinterOnly$button,
							{mm: 'View on rainforest'},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$onClick(
									$author$project$Components$Reports$PartnerDeposits$OpenRainforestDepositModal(deposit))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('View on Rainforest')
								])) : $author$project$Utils$Html$empty
						]))
				]));
	});
var $author$project$Components$Reports$PartnerDeposits$viewTable = function (model) {
	var _v0 = function () {
		var _v1 = model.cC;
		if (_v1.$ === 3) {
			var deposits_ = _v1.a;
			return _Utils_Tuple2(false, deposits_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var deposits = _v0.b;
	return A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$map,
					$author$project$Api$Column$view(
						A2($author$project$Api$Column$Sortable, model.alA, $author$project$Components$Reports$PartnerDeposits$SortTable)),
					model.N3),
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[$author$project$Ui$Table$textRight]),
						_List_fromArray(
							[
								A2($elm$html$Html$map, $author$project$Components$Reports$PartnerDeposits$ExportCsvMsg, $author$project$Components$ExportCsv$button)
							]))
					])
				])),
		A2(
			$elm$core$List$map,
			$author$project$Components$Reports$PartnerDeposits$viewRow(model.Ij),
			deposits),
		_List_Nil);
};
var $author$project$Components$Reports$PartnerDeposits$view = F2(
	function (apiClient, model) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Reports$PartnerDeposits$ExportCsvMsg,
				A3(
					$author$project$Components$ExportCsv$modal,
					apiClient,
					_List_fromArray(
						[
							$author$project$Components$ExportCsv$report(
							$author$project$Api$Data$totalCount(model.cC)),
							$author$project$Components$ExportCsv$reportParams(
							A2($elm$core$Basics$composeL, $author$project$Api$Partner$Reports$Deposit$listOptionsToParams, $author$project$Components$Reports$PartnerDeposits$fetchDepositsParams)(model))
						]),
					model.nD)),
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					$author$project$Components$Rainforest$SessionModal$view($author$project$Components$Reports$PartnerDeposits$CloseRainforestDepositModal),
					model.hq)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Deposits')
									])),
								$author$project$Ui$Typography$heading(
								function () {
									var _v0 = model.cC;
									if (_v0.$ === 3) {
										var headers = _v0.b;
										return _List_fromArray(
											[
												$elm$html$Html$text(
												'Total: ' + $author$project$Utils$Currency$fromInt(
													A2($author$project$Components$Reports$PartnerDeposits$intFromHeader, headers, 'x-total-amount'))),
												A2(
												$author$project$Ui$Typography$span,
												_List_fromArray(
													[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														' after ' + ($author$project$Utils$Currency$fromInt(
															A2($author$project$Components$Reports$PartnerDeposits$intFromHeader, headers, 'x-total-fee-amount')) + (' in fees across ' + A2(
															$author$project$Formatters$String$pluralize,
															'deposit',
															A2($author$project$Components$Reports$PartnerDeposits$intFromHeader, headers, 'x-total-count')))))
													]))
											]);
									} else {
										return _List_fromArray(
											[
												$author$project$Ui$Skeleton$text(
												_List_fromArray(
													[
														$author$project$Ui$Skeleton$spanFromText('Total: $1000.00')
													]))
											]);
									}
								}()),
								A2(
								$elm$html$Html$map,
								$author$project$Components$Reports$PartnerDeposits$DateRangeInputMsg,
								$author$project$Components$DateRangeInput$view(model.i4)),
								A2(
								$author$project$Ui$Grid$row,
								_List_fromArray(
									[$author$project$Ui$Grid$gutterSm]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(5),
												$author$project$Ui$Grid$spanSm(3),
												$author$project$Ui$Grid$spanMd(4)
											]),
										_List_fromArray(
											[
												$author$project$Components$Reports$PartnerDeposits$viewStatusDropdown(model)
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Components$Reports$PartnerDeposits$viewTable(model)
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$Reports$PartnerDeposits$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(
											!$author$project$Utils$Maybe$toBool(
												$author$project$Api$Data$toMaybe(model.cC)))
										]),
									model.ajJ))
							]))
					]))
			]);
	});
var $author$project$Pages$Partner$Billing$Deposits$view = function (model) {
	return {
		fO: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			A2($author$project$Components$Reports$PartnerDeposits$view, model.Gv, model.cC)),
		ac9: 'Partner | Deposits'
	};
};
var $author$project$Pages$Partner$Billing$Deposits$page = $author$project$Spa$Page$applicationPartner(
	{ah_: $author$project$Pages$Partner$Billing$Deposits$init, aiq: $author$project$Pages$Partner$Billing$Deposits$load, k8: $author$project$Pages$Partner$Billing$Deposits$save, alO: $author$project$Pages$Partner$Billing$Deposits$subscriptions, adT: $author$project$Pages$Partner$Billing$Deposits$update, amo: $author$project$Pages$Partner$Billing$Deposits$view});
var $author$project$Pages$Partner$Billing$Hinter$GotBilling = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Partner$Billing$billingPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['billing']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$Billing$Billing = $elm$core$Basics$identity;
var $author$project$Api$Partner$Billing$Record = function (rules) {
	return {aak: rules};
};
var $author$project$Api$Partner$Billing$Rule = F3(
	function (id, billsBy, effectiveAt) {
		return {afi: billsBy, agH: effectiveAt, ahP: id};
	});
var $author$project$Api$Partner$Billing$Gross = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Partner$Billing$Margin = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Partner$Billing$Transaction = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Partner$Billing$billsByDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (ruleType) {
		switch (ruleType) {
			case 'gross':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Api$Partner$Billing$Gross,
					A2($elm$json$Json$Decode$field, 'fee_percent', $elm$json$Json$Decode$float));
			case 'margin':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Api$Partner$Billing$Margin,
					A2($elm$json$Json$Decode$field, 'fee_percent', $elm$json$Json$Decode$float));
			case 'transaction':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Api$Partner$Billing$Transaction,
					A2($elm$json$Json$Decode$field, 'fee_percent', $elm$json$Json$Decode$float));
			default:
				return $elm$json$Json$Decode$fail('Unknown rule type: ' + ruleType);
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$Api$Partner$Billing$ruleDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Api$Partner$Billing$Rule,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
	$author$project$Api$Partner$Billing$billsByDecoder,
	A2($elm$json$Json$Decode$field, 'effective_at', $elm_community$json_extra$Json$Decode$Extra$datetime));
var $author$project$Api$Partner$Billing$decoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'rules',
		$elm$json$Json$Decode$list($author$project$Api$Partner$Billing$ruleDecoder),
		$elm$json$Json$Decode$succeed($author$project$Api$Partner$Billing$Record)));
var $author$project$Api$Partner$Billing$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Partner$Billing$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Partner$Billing$billingPath));
	});
var $author$project$Pages$Partner$Billing$Hinter$init = F4(
	function (_v0, partner, shared, _v1) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, rt: $author$project$Api$Data$Loading, YN: partner, b9: $elm$core$Maybe$Nothing, J7: shared.J7},
			A2($author$project$Api$Partner$Billing$retrieve, shared.Gv, $author$project$Pages$Partner$Billing$Hinter$GotBilling));
	});
var $author$project$Pages$Partner$Billing$Hinter$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Partner$Billing$Hinter$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Partner$Billing$Hinter$RuleModalClosed = {$: 7};
var $author$project$Pages$Partner$Billing$Hinter$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Pages$Partner$Billing$Hinter$RuleModalClosed);
};
var $author$project$Pages$Partner$Billing$Hinter$GotCreatedBilling = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Partner$Billing$Hinter$GotCreatedRule = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Partner$Billing$Hinter$GotDeletedRule = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Partner$Billing$Hinter$GotUpdatedRule = function (a) {
	return {$: 11, a: a};
};
var $author$project$Api$Partner$Billing$create = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$Billing$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Partner$Billing$billingPath));
	});
var $author$project$Api$Partner$Billing$encodePermittedFields = function (permittedFields) {
	var encodedFields = A3(
		$elm$core$List$foldl,
		F2(
			function (field, acc) {
				if (!field.$) {
					var ruleType = field.a;
					return A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string(ruleType)),
						acc);
				} else {
					var percent = field.a;
					return A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'fee_percent',
							$elm$json$Json$Encode$float(percent)),
						acc);
				}
			}),
		_List_Nil,
		permittedFields);
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'rule',
				$elm$json$Json$Encode$object(encodedFields))
			]));
};
var $author$project$Api$Partner$Billing$createRule = F3(
	function (apiClient, permittedFields, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$Billing$ruleDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Partner$Billing$encodePermittedFields(permittedFields),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['rules']),
						$author$project$Api$Partner$Billing$billingPath))));
	});
var $author$project$Api$Partner$Billing$deleteRule = F3(
	function (apiClient, ruleId, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['rules', ruleId]),
					$author$project$Api$Partner$Billing$billingPath)));
	});
var $author$project$Api$Partner$Billing$RuleFeePercent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Partner$Billing$RuleType = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Partner$Billing$Hinter$formFieldsToPermittedFields = function (fields) {
	return _List_fromArray(
		[
			$author$project$Api$Partner$Billing$RuleType(fields.ak7),
			$author$project$Api$Partner$Billing$RuleFeePercent(
			A2(
				$elm$core$Maybe$withDefault,
				0.0,
				A2($elm$core$Maybe$andThen, $author$project$Percentage$toFloat, fields.jK)))
		]);
};
var $author$project$Pages$Partner$Billing$Hinter$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var ruleType = field.a;
			return _Utils_update(
				fields,
				{ak7: ruleType});
		} else {
			var percentage = field.a;
			return _Utils_update(
				fields,
				{jK: percentage});
		}
	});
var $author$project$Pages$Partner$Billing$Hinter$ruleToFormFields = function (rule) {
	var _v0 = function () {
		var _v1 = rule.afi;
		switch (_v1.$) {
			case 0:
				var percent = _v1.a;
				return _Utils_Tuple2(
					'gross',
					$elm$core$Maybe$Just(
						$author$project$Percentage$fromFloat(percent)));
			case 1:
				var percent = _v1.a;
				return _Utils_Tuple2(
					'margin',
					$elm$core$Maybe$Just(
						$author$project$Percentage$fromFloat(percent)));
			default:
				var percent = _v1.a;
				return _Utils_Tuple2(
					'transaction',
					$elm$core$Maybe$Just(
						$author$project$Percentage$fromFloat(percent)));
		}
	}();
	var ruleType = _v0.a;
	var feePercentage = _v0.b;
	return {jK: feePercentage, ak7: ruleType};
};
var $author$project$Api$Partner$Billing$updateRule = F4(
	function (apiClient, ruleId, permittedFields, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Partner$Billing$ruleDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Partner$Billing$encodePermittedFields(permittedFields),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['rules', ruleId]),
						$author$project$Api$Partner$Billing$billingPath))));
	});
var $author$project$Pages$Partner$Billing$Hinter$FeePercentageValidation = 1;
var $author$project$Pages$Partner$Billing$Hinter$RuleTypeValidation = 0;
var $author$project$Pages$Partner$Billing$Hinter$validate = function (form) {
	var validator = $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_validate$Validate$ifBlank,
				function ($) {
					return $.ak7;
				},
				_Utils_Tuple2(0, 'Rule type is required')),
				A2(
				$rtfeldman$elm_validate$Validate$ifNothing,
				function ($) {
					return $.jK;
				},
				_Utils_Tuple2(1, 'Fee percentage is required'))
			]));
	return A2($author$project$Utils$Form$validate, validator, form);
};
var $author$project$Pages$Partner$Billing$Hinter$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				_v1$2:
				while (true) {
					switch (response.$) {
						case 3:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{rt: response}),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
						case 2:
							if (response.a.$ === 5) {
								var _v2 = response.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{rt: response}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							} else {
								break _v1$2;
							}
						default:
							break _v1$2;
					}
				}
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{rt: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				return _Utils_Tuple3(
					model,
					A2($author$project$Api$Partner$Billing$create, model.Gv, $author$project$Pages$Partner$Billing$Hinter$GotCreatedBilling),
					_List_Nil);
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{rt: response}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 3:
				var form = $author$project$Utils$Form$init(
					{jK: $elm$core$Maybe$Nothing, ak7: 'gross'});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							b9: $elm$core$Maybe$Just(
								_Utils_Tuple2($elm$core$Maybe$Nothing, form))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var ruleId = msg.a;
				var rule = msg.b;
				var form = $author$project$Utils$Form$init(
					$author$project$Pages$Partner$Billing$Hinter$ruleToFormFields(rule));
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							b9: $elm$core$Maybe$Just(
								_Utils_Tuple2(
									$elm$core$Maybe$Just(ruleId),
									form))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var ruleId = msg.a;
				return _Utils_Tuple3(
					model,
					A3($author$project$Api$Partner$Billing$deleteRule, model.Gv, ruleId, $author$project$Pages$Partner$Billing$Hinter$GotDeletedRule),
					_List_Nil);
			case 6:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						A2($author$project$Api$Partner$Billing$retrieve, model.Gv, $author$project$Pages$Partner$Billing$Hinter$GotBilling),
						_List_fromArray(
							[$author$project$OutMsg$RefreshPartner]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 7:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{b9: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 8:
				var field = msg.a;
				var _v5 = model.b9;
				if (!_v5.$) {
					var _v6 = _v5.a;
					var ruleId = _v6.a;
					var form = _v6.b;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Partner$Billing$Hinter$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								b9: $elm$core$Maybe$Just(
									_Utils_Tuple2(ruleId, newForm))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var _v7 = model.b9;
				if (!_v7.$) {
					var _v8 = _v7.a;
					var ruleId = _v8.a;
					var form = _v8.b;
					var _v9 = $author$project$Pages$Partner$Billing$Hinter$validate(form);
					if (!_v9.$) {
						var _v10 = _v9.a;
						var validFields = _v10.b;
						var fields = $rtfeldman$elm_validate$Validate$fromValid(validFields);
						var permittedFields = $author$project$Pages$Partner$Billing$Hinter$formFieldsToPermittedFields(fields);
						var cmd = function () {
							if (!ruleId.$) {
								var id = ruleId.a;
								return A4($author$project$Api$Partner$Billing$updateRule, model.Gv, id, permittedFields, $author$project$Pages$Partner$Billing$Hinter$GotUpdatedRule);
							} else {
								return A3($author$project$Api$Partner$Billing$createRule, model.Gv, permittedFields, $author$project$Pages$Partner$Billing$Hinter$GotCreatedRule);
							}
						}();
						return _Utils_Tuple3(model, cmd, _List_Nil);
					} else {
						var formWithErrors = _v9.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									b9: $elm$core$Maybe$Just(
										_Utils_Tuple2(ruleId, formWithErrors))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 10:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{b9: $elm$core$Maybe$Nothing}),
						A2($author$project$Api$Partner$Billing$retrieve, model.Gv, $author$project$Pages$Partner$Billing$Hinter$GotBilling),
						_List_fromArray(
							[$author$project$OutMsg$RefreshPartner]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{b9: $elm$core$Maybe$Nothing}),
						A2($author$project$Api$Partner$Billing$retrieve, model.Gv, $author$project$Pages$Partner$Billing$Hinter$GotBilling),
						_List_fromArray(
							[$author$project$OutMsg$RefreshPartner]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Partner$Billing$Hinter$AddRuleClicked = {$: 3};
var $author$project$Api$Partner$Billing$rules = function (_v0) {
	var record = _v0;
	return record.aak;
};
var $author$project$Pages$Partner$Billing$Hinter$DeleteRuleClicked = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Partner$Billing$Hinter$EditRuleClicked = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$Partner$Billing$Hinter$viewRule = function (rule) {
	return A2(
		$author$project$Ui$Grid$column,
		_List_fromArray(
			[
				$author$project$Ui$Grid$span(6),
				$author$project$Ui$Grid$spanMd(3)
			]),
		_List_fromArray(
			[
				function () {
				var _v0 = rule.afi;
				switch (_v0.$) {
					case 0:
						var percentage = _v0.a;
						return A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$title,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Gross')
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$mt2]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Fee: ')
												])),
											$elm$html$Html$text(
											$author$project$Formatters$Float$toPercentage(percentage))
										]))
								]));
					case 1:
						var percentage = _v0.a;
						return A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$title,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Margin')
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$mt2]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Fee: ')
												])),
											$elm$html$Html$text(
											$author$project$Formatters$Float$toPercentage(percentage))
										]))
								]));
					default:
						var percentage = _v0.a;
						return A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$title,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Transaction')
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$mt2]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Fee: ')
												])),
											$elm$html$Html$text(
											$author$project$Formatters$Float$toPercentage(percentage))
										]))
								]));
				}
			}(),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mt4, $author$project$Ui$Element$gap2]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Edit rule'},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$icon($author$project$Ui$Icon$edit),
								$author$project$Ui$Button$onClick(
								A2($author$project$Pages$Partner$Billing$Hinter$EditRuleClicked, rule.ahP, rule)),
								$author$project$Ui$Button$sm
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Edit')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Delete rule'},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$icon($author$project$Ui$Icon$delete),
								$author$project$Ui$Button$onClick(
								$author$project$Pages$Partner$Billing$Hinter$DeleteRuleClicked(rule.ahP)),
								$author$project$Ui$Button$sm
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Delete')
							]))
					]))
			]));
};
var $author$project$Pages$Partner$Billing$Hinter$viewBilling = function (billing) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mb4]),
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Billing Details')
						])),
					A3(
					$author$project$Ui$Button$view,
					{mm: 'Add rule'},
					_List_fromArray(
						[
							$author$project$Ui$Button$icon($author$project$Ui$Icon$add),
							$author$project$Ui$Button$onClick($author$project$Pages$Partner$Billing$Hinter$AddRuleClicked)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Add Rule')
						]))
				])),
			A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			A2(
				$elm$core$List$map,
				$author$project$Pages$Partner$Billing$Hinter$viewRule,
				$author$project$Api$Partner$Billing$rules(billing)))
		]);
};
var $author$project$Pages$Partner$Billing$Hinter$CreateClicked = {$: 1};
var $author$project$Pages$Partner$Billing$Hinter$viewBuildBilling = _List_fromArray(
	[
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$flexCol]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mb2]),
				_List_fromArray(
					[
						$elm$html$Html$text('There\'s no billing yet')
					])),
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Set up billing'},
				_List_fromArray(
					[
						$author$project$Ui$Button$primary,
						$author$project$Ui$Button$onClick($author$project$Pages$Partner$Billing$Hinter$CreateClicked)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Set up billing')
					]))
			]))
	]);
var $author$project$Components$Partner$ServiceFeePanel$feeModelLabel = function (billsBy) {
	switch (billsBy.$) {
		case 0:
			return 'Revenue Share';
		case 1:
			return 'Margin Share';
		default:
			return 'Transaction';
	}
};
var $author$project$Components$Partner$ServiceFeePanel$feePercent = function (billsBy) {
	switch (billsBy.$) {
		case 0:
			var p = billsBy.a;
			return p;
		case 1:
			var p = billsBy.a;
			return p;
		default:
			var p = billsBy.a;
			return p;
	}
};
var $author$project$Ui$HorizontalRule$Minimal = 2;
var $author$project$Ui$HorizontalRule$minimal = 2;
var $author$project$Components$Partner$ServiceFeePanel$viewRow = F2(
	function (label, value) {
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$label,
					_List_fromArray(
						[$author$project$Ui$Typography$muted]),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						])),
					value
				]));
	});
var $author$project$Components$Partner$ServiceFeePanel$viewDetails = F2(
	function (rule, timeFormatter) {
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap2]),
			A2(
				$elm$core$List$intersperse,
				$author$project$Ui$HorizontalRule$view(
					_List_fromArray(
						[$author$project$Ui$HorizontalRule$minimal])),
				_List_fromArray(
					[
						A2(
						$author$project$Components$Partner$ServiceFeePanel$viewRow,
						'Fee Model',
						$elm$html$Html$text(
							$author$project$Components$Partner$ServiceFeePanel$feeModelLabel(rule.afi))),
						A2(
						$author$project$Components$Partner$ServiceFeePanel$viewRow,
						'Service Fee Percentage',
						$elm$html$Html$text(
							$author$project$Formatters$Float$toPercentage(
								$author$project$Components$Partner$ServiceFeePanel$feePercent(rule.afi)))),
						A2(
						$author$project$Components$Partner$ServiceFeePanel$viewRow,
						'Effective Date',
						$elm$html$Html$text(
							A2(timeFormatter, 6, rule.agH)))
					])));
	});
var $author$project$Components$Partner$ServiceFeePanel$calculateFeeCents = F2(
	function (billsBy, amountCents) {
		var cents = function (pct) {
			return $elm$core$Basics$round((amountCents * pct) / 100);
		};
		switch (billsBy.$) {
			case 0:
				var p = billsBy.a;
				return cents(p);
			case 1:
				var p = billsBy.a;
				return cents(p);
			default:
				var p = billsBy.a;
				return cents(p);
		}
	});
var $author$project$Components$Partner$ServiceFeePanel$exampleSections = function (rule) {
	var sampleAmountCents = 10000;
	var _v0 = rule.afi;
	if (_v0.$ === 1) {
		var pct = _v0.a;
		var sampleCostCents = 6000;
		var marginCents = sampleAmountCents - sampleCostCents;
		var feeCents = $elm$core$Basics$round((marginCents * pct) / 100);
		var netCents = sampleCostCents + (marginCents - feeCents);
		return {
			H1: _List_fromArray(
				[
					A2(
					$author$project$Components$Partner$ServiceFeePanel$viewRow,
					'Charge amount',
					$elm$html$Html$text(
						$author$project$Utils$Currency$fromInt(sampleAmountCents))),
					A2(
					$author$project$Components$Partner$ServiceFeePanel$viewRow,
					'Partner-Reported Cost',
					$elm$html$Html$text(
						'−' + $author$project$Utils$Currency$fromInt(sampleCostCents))),
					A2(
					$author$project$Components$Partner$ServiceFeePanel$viewRow,
					'Margin',
					$elm$html$Html$text(
						$author$project$Utils$Currency$fromInt(marginCents)))
				]),
			I$: _List_fromArray(
				[
					A2(
					$author$project$Components$Partner$ServiceFeePanel$viewRow,
					'Service Fee (' + ($author$project$Formatters$Float$toPercentage(pct) + ' of margin)'),
					A2(
						$author$project$Ui$Typography$text,
						_List_fromArray(
							[$author$project$Ui$Typography$danger]),
						'−' + $author$project$Utils$Currency$fromInt(feeCents))),
					A2(
					$author$project$Components$Partner$ServiceFeePanel$viewRow,
					'Net to you',
					A2(
						$author$project$Ui$Typography$strong,
						_List_fromArray(
							[$author$project$Ui$Typography$success]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Utils$Currency$fromInt(netCents))
							])))
				])
		};
	} else {
		var feeCents = A2($author$project$Components$Partner$ServiceFeePanel$calculateFeeCents, rule.afi, sampleAmountCents);
		var netCents = sampleAmountCents - feeCents;
		return {
			H1: _List_fromArray(
				[
					A2(
					$author$project$Components$Partner$ServiceFeePanel$viewRow,
					'Charge amount',
					$elm$html$Html$text(
						$author$project$Utils$Currency$fromInt(sampleAmountCents)))
				]),
			I$: _List_fromArray(
				[
					A2(
					$author$project$Components$Partner$ServiceFeePanel$viewRow,
					'Service Fee (' + ($author$project$Formatters$Float$toPercentage(
						$author$project$Components$Partner$ServiceFeePanel$feePercent(rule.afi)) + ')'),
					A2(
						$author$project$Ui$Typography$text,
						_List_fromArray(
							[$author$project$Ui$Typography$danger]),
						'−' + $author$project$Utils$Currency$fromInt(feeCents))),
					A2(
					$author$project$Components$Partner$ServiceFeePanel$viewRow,
					'Net to you',
					A2(
						$author$project$Ui$Typography$strong,
						_List_fromArray(
							[$author$project$Ui$Typography$success]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Utils$Currency$fromInt(netCents))
							])))
				])
		};
	}
};
var $author$project$Components$Partner$ServiceFeePanel$viewExample = function (rule) {
	var sections = $author$project$Components$Partner$ServiceFeePanel$exampleSections(rule);
	return A2(
		$author$project$Ui$Panel$view,
		_List_fromArray(
			[$author$project$Ui$Panel$subtle]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap2]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Example Calculation')
									])),
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap2]),
								sections.H1),
								$author$project$Ui$HorizontalRule$view(
								_List_fromArray(
									[$author$project$Ui$HorizontalRule$minimal])),
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap2]),
								sections.I$)
							]))
					]))
			]));
};
var $author$project$Ui$Typography$Medium = 4;
var $author$project$Ui$Typography$medium = $author$project$Ui$Typography$Decoration(4);
var $author$project$Components$Partner$ServiceFeePanel$viewModelNote = function (billsBy) {
	if (billsBy.$ === 1) {
		return A2(
			$author$project$Ui$Alert$info,
			_List_fromArray(
				[$author$project$Ui$Alert$textLeft]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Margin Share')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Submit '),
							A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[$author$project$Ui$Typography$medium]),
							'cost_in_cents'),
							$elm$html$Html$text(' on each API charge. Missing cost fields are rejected at the API layer.')
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Partner$ServiceFeePanel$view = function (_v0) {
	var rule = _v0.ak6;
	var timeFormatter = _v0.J7;
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap4]),
		_List_fromArray(
			[
				A2($author$project$Components$Partner$ServiceFeePanel$viewDetails, rule, timeFormatter),
				$author$project$Components$Partner$ServiceFeePanel$viewExample(rule),
				$author$project$Components$Partner$ServiceFeePanel$viewModelNote(rule.afi)
			]));
};
var $author$project$Pages$Partner$Billing$Hinter$viewPartnerPreview = function (model) {
	var _v0 = model.rt;
	if (_v0.$ === 3) {
		var billing = _v0.a;
		var _v1 = $author$project$Api$Partner$Billing$rules(billing);
		if (_v1.b) {
			var rule = _v1.a;
			return A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap]),
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Partner Preview')
											])),
										A2(
										$author$project$Ui$Typography$text,
										_List_fromArray(
											[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
										'What the partner sees in the Service Fee section.')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Components$Partner$ServiceFeePanel$view(
								{ak6: rule, J7: model.J7})
							]))
					]));
		} else {
			return $elm$html$Html$text('');
		}
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Pages$Partner$Billing$Hinter$FeePercentage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Partner$Billing$Hinter$FormUpdated = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Partner$Billing$Hinter$SaveRuleClicked = {$: 9};
var $author$project$Pages$Partner$Billing$Hinter$RuleType = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Partner$Billing$Hinter$viewRuleTypeButton = F3(
	function (fields, ruleType, label) {
		return A3(
			$author$project$Ui$Button$view,
			{mm: label},
			_List_fromArray(
				[
					$author$project$Ui$Button$styled(
					_Utils_eq(fields.ak7, ruleType) ? 1 : 0),
					$author$project$Ui$Button$onClick(
					$author$project$Pages$Partner$Billing$Hinter$FormUpdated(
						$author$project$Pages$Partner$Billing$Hinter$RuleType(ruleType)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Pages$Partner$Billing$Hinter$viewRuleModal = F2(
	function (ruleId, form) {
		var modalTitle = function () {
			if (!ruleId.$) {
				return 'Edit Rule';
			} else {
				return 'Add Rule';
			}
		}();
		var fields = $author$project$Utils$Form$fields(form);
		var errorsFor = function (group) {
			return A2($author$project$Utils$Form$validationErrors, group, form);
		};
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Pages$Partner$Billing$Hinter$RuleModalClosed,
			_List_fromArray(
				[
					$author$project$Ui$Modal$onSubmit($author$project$Pages$Partner$Billing$Hinter$SaveRuleClicked)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title(modalTitle)
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Rule Type'),
									$author$project$Ui$Form$Group$required(true),
									$author$project$Ui$Form$Group$labelSpanSm(4),
									$author$project$Ui$Form$Group$inputSpanSm(8)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Button$group(
									_List_fromArray(
										[
											A3($author$project$Pages$Partner$Billing$Hinter$viewRuleTypeButton, fields, 'gross', 'Gross'),
											A3($author$project$Pages$Partner$Billing$Hinter$viewRuleTypeButton, fields, 'margin', 'Margin'),
											A3($author$project$Pages$Partner$Billing$Hinter$viewRuleTypeButton, fields, 'transaction', 'Transaction')
										]))
								])),
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Fee Percentage'),
									$author$project$Ui$Form$Group$required(true),
									$author$project$Ui$Form$Group$labelSpanSm(4),
									$author$project$Ui$Form$Group$inputSpanSm(8)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$PercentageInput$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$PercentageInput$value(fields.jK),
											$author$project$Ui$Form$PercentageInput$onInput(
											A2($elm$core$Basics$composeL, $author$project$Pages$Partner$Billing$Hinter$FormUpdated, $author$project$Pages$Partner$Billing$Hinter$FeePercentage)),
											$author$project$Ui$Form$PercentageInput$errors(
											errorsFor(1)),
											$author$project$Ui$Form$PercentageInput$placeholder('10')
										]))
								]))
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Cancel'},
							_List_fromArray(
								[
									$author$project$Ui$Button$secondary,
									$author$project$Ui$Button$onClick($author$project$Pages$Partner$Billing$Hinter$RuleModalClosed)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Save rule'},
							_List_fromArray(
								[$author$project$Ui$Button$primary, $author$project$Ui$Button$submit]),
							_List_fromArray(
								[
									$elm$html$Html$text('Save')
								]))
						]))
				]));
	});
var $author$project$Pages$Partner$Billing$Hinter$viewBody = function (model) {
	return _List_fromArray(
		[
			function () {
			var _v0 = model.b9;
			if (!_v0.$) {
				var _v1 = _v0.a;
				var ruleId = _v1.a;
				var form = _v1.b;
				return A2($author$project$Pages$Partner$Billing$Hinter$viewRuleModal, ruleId, form);
			} else {
				return $elm$html$Html$text('');
			}
		}(),
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			$elm$core$List$singleton(
				A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					function () {
						var _v2 = model.rt;
						_v2$2:
						while (true) {
							switch (_v2.$) {
								case 3:
									var billing = _v2.a;
									return $author$project$Pages$Partner$Billing$Hinter$viewBilling(billing);
								case 2:
									if (_v2.a.$ === 5) {
										var _v3 = _v2.a;
										return $author$project$Pages$Partner$Billing$Hinter$viewBuildBilling;
									} else {
										break _v2$2;
									}
								default:
									break _v2$2;
							}
						}
						return _List_Nil;
					}()))),
			$author$project$Pages$Partner$Billing$Hinter$viewPartnerPreview(model)
		]);
};
var $author$project$Pages$Partner$Billing$Hinter$view = function (model) {
	return {
		fO: $author$project$Pages$Partner$Billing$Hinter$viewBody(model),
		ac9: 'Partner | Billing'
	};
};
var $author$project$Pages$Partner$Billing$Hinter$page = $author$project$Spa$Page$applicationPartner(
	{ah_: $author$project$Pages$Partner$Billing$Hinter$init, aiq: $author$project$Pages$Partner$Billing$Hinter$load, k8: $author$project$Pages$Partner$Billing$Hinter$save, alO: $author$project$Pages$Partner$Billing$Hinter$subscriptions, adT: $author$project$Pages$Partner$Billing$Hinter$update, amo: $author$project$Pages$Partner$Billing$Hinter$view});
var $author$project$Pages$Partner$Billing$ServiceFee$GotBilling = $elm$core$Basics$identity;
var $author$project$Pages$Partner$Billing$ServiceFee$init = F4(
	function (_v0, partner, shared, _v1) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, rt: $author$project$Api$Data$Loading, YN: partner, J7: shared.J7},
			A2($author$project$Api$Partner$Billing$retrieve, shared.Gv, $elm$core$Basics$identity));
	});
var $author$project$Pages$Partner$Billing$ServiceFee$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Partner$Billing$ServiceFee$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Partner$Billing$ServiceFee$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Partner$Billing$ServiceFee$update = F2(
	function (msg, model) {
		var response = msg;
		_v1$2:
		while (true) {
			switch (response.$) {
				case 3:
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{rt: response}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				case 2:
					if (response.a.$ === 5) {
						var _v2 = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{rt: response}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						break _v1$2;
					}
				default:
					break _v1$2;
			}
		}
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{rt: response}),
			$elm$core$Platform$Cmd$none,
			$author$project$OutMsg$handleErrorResponse(response));
	});
var $author$project$Pages$Partner$Billing$ServiceFee$viewEmpty = A2(
	$author$project$Ui$Typography$p,
	_List_fromArray(
		[$author$project$Ui$Typography$muted]),
	_List_fromArray(
		[
			$elm$html$Html$text('No Service Fee has been configured yet.')
		]));
var $author$project$Pages$Partner$Billing$ServiceFee$viewSkeleton = A2(
	$author$project$Ui$Element$view,
	_List_fromArray(
		[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap2]),
	_List_fromArray(
		[
			$author$project$Ui$Skeleton$text(
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$span(4)
				])),
			$author$project$Ui$Skeleton$text(
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$span(4)
				])),
			$author$project$Ui$Skeleton$text(
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$span(4)
				]))
		]));
var $author$project$Pages$Partner$Billing$ServiceFee$viewBody = function (model) {
	var _v0 = model.rt;
	_v0$2:
	while (true) {
		switch (_v0.$) {
			case 3:
				var billing = _v0.a;
				var _v1 = $author$project$Api$Partner$Billing$rules(billing);
				if (_v1.b) {
					var rule = _v1.a;
					return $author$project$Components$Partner$ServiceFeePanel$view(
						{ak6: rule, J7: model.J7});
				} else {
					return $author$project$Pages$Partner$Billing$ServiceFee$viewEmpty;
				}
			case 2:
				if (_v0.a.$ === 5) {
					var _v2 = _v0.a;
					return $author$project$Pages$Partner$Billing$ServiceFee$viewEmpty;
				} else {
					break _v0$2;
				}
			default:
				break _v0$2;
		}
	}
	return $author$project$Pages$Partner$Billing$ServiceFee$viewSkeleton;
};
var $author$project$Utils$HintUrls$partnerAgreementUrl = 'http://www.hint.com/partner-agreement';
var $author$project$Api$Partner$Partner$One$serviceFeeDocumentAgreement = function (_v0) {
	var record = _v0.b;
	return record.aa1;
};
var $author$project$Pages$Partner$Billing$ServiceFee$viewHeading = function (partner) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap]),
				_List_fromArray(
					[
						$author$project$Ui$Panel$title(
						_List_fromArray(
							[
								$elm$html$Html$text('Service Fee')
							])),
						A2(
						$author$project$Ui$Typography$span,
						_List_fromArray(
							[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
						_List_fromArray(
							[
								$elm$html$Html$text('Your current Service Fee — '),
								A3(
								$author$project$Ui$Link$externalHref,
								$author$project$Utils$HintUrls$partnerAgreementUrl,
								_List_fromArray(
									[$author$project$Ui$Link$targetBlank]),
								_List_fromArray(
									[
										$elm$html$Html$text('Partner Agreement §C.3')
									]))
							]))
					])),
				(!_Utils_eq(
				$author$project$Api$Partner$Partner$One$serviceFeeDocumentAgreement(partner),
				$elm$core$Maybe$Nothing)) ? A2(
				$author$project$Ui$Badge$fromString,
				_List_fromArray(
					[$author$project$Ui$Badge$success]),
				'Active') : $author$project$Utils$Html$empty
			]));
};
var $author$project$Pages$Partner$Billing$ServiceFee$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Pages$Partner$Billing$ServiceFee$viewHeading(model.YN)
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Pages$Partner$Billing$ServiceFee$viewBody(model)
							]))
					]))
			]),
		ac9: 'Partner | Service Fee'
	};
};
var $author$project$Pages$Partner$Billing$ServiceFee$page = $author$project$Spa$Page$applicationPartner(
	{ah_: $author$project$Pages$Partner$Billing$ServiceFee$init, aiq: $author$project$Pages$Partner$Billing$ServiceFee$load, k8: $author$project$Pages$Partner$Billing$ServiceFee$save, alO: $author$project$Pages$Partner$Billing$ServiceFee$subscriptions, adT: $author$project$Pages$Partner$Billing$ServiceFee$update, amo: $author$project$Pages$Partner$Billing$ServiceFee$view});
var $author$project$Pages$Partner$Billing$Subscriptions$GotTemplate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Partner$SubscriptionTemplate$Record = F2(
	function (id, amountInCents) {
		return {LE: amountInCents, ahP: id};
	});
var $author$project$Api$Partner$SubscriptionTemplate$SubscriptionTemplate = $elm$core$Basics$identity;
var $author$project$Api$Partner$SubscriptionTemplate$decoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'amount_in_cents',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Partner$SubscriptionTemplate$Record))));
var $author$project$Api$Partner$SubscriptionTemplate$templatePath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['subscription_template']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$SubscriptionTemplate$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Partner$SubscriptionTemplate$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Partner$SubscriptionTemplate$templatePath));
	});
var $author$project$Pages$Partner$Billing$Subscriptions$init = F4(
	function (_v0, partner, shared, _v1) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, C: $elm$core$Maybe$Nothing, YN: partner, pR: $author$project$Api$Data$NotAsked, hW: $author$project$Api$Data$Loading},
			A2($author$project$Api$Partner$SubscriptionTemplate$retrieve, shared.Gv, $author$project$Pages$Partner$Billing$Subscriptions$GotTemplate));
	});
var $author$project$Pages$Partner$Billing$Subscriptions$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Partner$Billing$Subscriptions$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Partner$Billing$Subscriptions$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Partner$Billing$Subscriptions$GotCreated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Partner$SubscriptionTemplate$amountInCents = function (_v0) {
	var record = _v0;
	return record.LE;
};
var $author$project$Api$Partner$SubscriptionTemplate$encodeCreate = function (params) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'subscription_template',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'amount_in_cents',
							$elm$json$Json$Encode$int(params.LE))
						])))
			]));
};
var $author$project$Api$Partner$SubscriptionTemplate$create = F3(
	function (apiClient, params, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$SubscriptionTemplate$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Partner$SubscriptionTemplate$encodeCreate(params),
				$author$project$Api$Data$requestTo($author$project$Api$Partner$SubscriptionTemplate$templatePath)));
	});
var $author$project$Pages$Partner$Billing$Subscriptions$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				_v1$2:
				while (true) {
					switch (response.$) {
						case 3:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{hW: response}),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
						case 2:
							if (response.a.$ === 5) {
								var _v2 = response.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{hW: response}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							} else {
								break _v1$2;
							}
						default:
							break _v1$2;
					}
				}
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{hW: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var initial = function () {
					var _v3 = model.hW;
					if (_v3.$ === 3) {
						var template = _v3.a;
						return $elm$core$Maybe$Just(
							$author$project$Currency$fromInt(
								$author$project$Api$Partner$SubscriptionTemplate$amountInCents(template)));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							C: $elm$core$Maybe$Just(
								{mk: initial, xq: false})
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{C: $elm$core$Maybe$Nothing, pR: $author$project$Api$Data$NotAsked}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var value = msg.a;
				var _v4 = model.C;
				if (!_v4.$) {
					var edit = _v4.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								C: $elm$core$Maybe$Just(
									_Utils_update(
										edit,
										{mk: value}))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				var _v5 = model.C;
				if (!_v5.$) {
					var edit = _v5.a;
					var _v6 = A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, edit.mk);
					if (!_v6.$) {
						var cents = _v6.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{pR: $author$project$Api$Data$Loading}),
							A3(
								$author$project$Api$Partner$SubscriptionTemplate$create,
								model.Gv,
								{LE: cents},
								$author$project$Pages$Partner$Billing$Subscriptions$GotCreated),
							_List_Nil);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									C: $elm$core$Maybe$Just(
										_Utils_update(
											edit,
											{xq: true}))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{C: $elm$core$Maybe$Nothing, pR: $author$project$Api$Data$NotAsked, hW: response}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{pR: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Partner$Billing$Subscriptions$EditClicked = {$: 1};
var $author$project$Pages$Partner$Billing$Subscriptions$viewActive = function (template) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$span,
						_List_fromArray(
							[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
						_List_fromArray(
							[
								$elm$html$Html$text('Default amount')
							])),
						$author$project$Ui$Typography$heading(
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Utils$Currency$fromInt(
									$author$project$Api$Partner$SubscriptionTemplate$amountInCents(template)))
							]))
					])),
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Edit default amount'},
				_List_fromArray(
					[
						$author$project$Ui$Button$secondary,
						$author$project$Ui$Button$onClick($author$project$Pages$Partner$Billing$Subscriptions$EditClicked)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Edit')
					]))
			]));
};
var $author$project$Pages$Partner$Billing$Subscriptions$viewEmpty = A2(
	$author$project$Ui$Element$view,
	_List_fromArray(
		[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap2, $author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$itemsCenter]),
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Typography$p,
			_List_fromArray(
				[$author$project$Ui$Typography$muted]),
			_List_fromArray(
				[
					$elm$html$Html$text('No default subscription amount set yet.')
				])),
			A3(
			$author$project$Ui$Button$view,
			{mm: 'Set default amount'},
			_List_fromArray(
				[
					$author$project$Ui$Button$primary,
					$author$project$Ui$Button$onClick($author$project$Pages$Partner$Billing$Subscriptions$EditClicked)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Set default amount')
				]))
		]));
var $author$project$Pages$Partner$Billing$Subscriptions$viewSkeleton = A2(
	$author$project$Ui$Element$view,
	_List_fromArray(
		[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap2]),
	_List_fromArray(
		[
			$author$project$Ui$Skeleton$text(
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$span(4)
				])),
			$author$project$Ui$Skeleton$text(
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$span(4)
				]))
		]));
var $author$project$Pages$Partner$Billing$Subscriptions$viewBody = function (model) {
	var _v0 = model.hW;
	switch (_v0.$) {
		case 3:
			var template = _v0.a;
			return $author$project$Pages$Partner$Billing$Subscriptions$viewActive(template);
		case 2:
			if (_v0.a.$ === 5) {
				var _v1 = _v0.a;
				return $author$project$Pages$Partner$Billing$Subscriptions$viewEmpty;
			} else {
				return $author$project$Pages$Partner$Billing$Subscriptions$viewEmpty;
			}
		default:
			return $author$project$Pages$Partner$Billing$Subscriptions$viewSkeleton;
	}
};
var $author$project$Pages$Partner$Billing$Subscriptions$viewHeading = A2(
	$author$project$Ui$Element$view,
	_List_fromArray(
		[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap]),
	_List_fromArray(
		[
			$author$project$Ui$Panel$title(
			_List_fromArray(
				[
					$elm$html$Html$text('Subscriptions')
				])),
			A2(
			$author$project$Ui$Typography$span,
			_List_fromArray(
				[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
			_List_fromArray(
				[
					$elm$html$Html$text('Default subscription amount applied to new connections.')
				]))
		]));
var $author$project$Pages$Partner$Billing$Subscriptions$AmountChanged = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Partner$Billing$Subscriptions$EditCancelled = {$: 2};
var $author$project$Pages$Partner$Billing$Subscriptions$SaveClicked = {$: 4};
var $author$project$Pages$Partner$Billing$Subscriptions$viewModal = function (model) {
	var _v0 = model.C;
	if (!_v0.$) {
		var edit = _v0.a;
		var amountErrors = (edit.xq && _Utils_eq(
			A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, edit.mk),
			$elm$core$Maybe$Nothing)) ? _List_fromArray(
			['Amount is required']) : _List_Nil;
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Pages$Partner$Billing$Subscriptions$EditCancelled,
			_List_fromArray(
				[
					$author$project$Ui$Modal$onSubmit($author$project$Pages$Partner$Billing$Subscriptions$SaveClicked)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('Default amount')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Amount'),
									$author$project$Ui$Form$Group$required(true)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$CurrencyInput$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$CurrencyInput$value(edit.mk),
											$author$project$Ui$Form$CurrencyInput$onInput($author$project$Pages$Partner$Billing$Subscriptions$AmountChanged),
											$author$project$Ui$Form$CurrencyInput$placeholder('50.00'),
											$author$project$Ui$Form$CurrencyInput$errors(amountErrors)
										]))
								]))
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Cancel'},
							_List_fromArray(
								[
									$author$project$Ui$Button$secondary,
									$author$project$Ui$Button$onClick($author$project$Pages$Partner$Billing$Subscriptions$EditCancelled)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Save default amount'},
							_List_fromArray(
								[$author$project$Ui$Button$primary, $author$project$Ui$Button$submit]),
							_List_fromArray(
								[
									$elm$html$Html$text('Save')
								]))
						]))
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Pages$Partner$Billing$Subscriptions$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[$author$project$Pages$Partner$Billing$Subscriptions$viewHeading])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Pages$Partner$Billing$Subscriptions$viewBody(model)
							]))
					])),
				$author$project$Pages$Partner$Billing$Subscriptions$viewModal(model)
			]),
		ac9: 'Partner | Subscriptions'
	};
};
var $author$project$Pages$Partner$Billing$Subscriptions$page = $author$project$Spa$Page$applicationPartner(
	{ah_: $author$project$Pages$Partner$Billing$Subscriptions$init, aiq: $author$project$Pages$Partner$Billing$Subscriptions$load, k8: $author$project$Pages$Partner$Billing$Subscriptions$save, alO: $author$project$Pages$Partner$Billing$Subscriptions$subscriptions, adT: $author$project$Pages$Partner$Billing$Subscriptions$update, amo: $author$project$Pages$Partner$Billing$Subscriptions$view});
var $author$project$Pages$Partner$Dashboard$Top$BaaFormMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Partner$Dashboard$Top$DocumentsAgreementsFormMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Partner$Dashboard$Top$PartnerFormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Partner$Dashboard$Top$Agreements = 1;
var $author$project$Pages$Partner$Dashboard$Top$CompanyDetails = 0;
var $author$project$Pages$Partner$Dashboard$Top$ProductListing = 2;
var $author$project$Pages$Partner$Dashboard$Top$SandboxSetup = 3;
var $author$project$Pages$Partner$Dashboard$Top$WebsiteBacklink = 4;
var $author$project$Api$Partner$Partner$One$managedBy = function (_v0) {
	var record = _v0.b;
	return record.Wq;
};
var $author$project$Api$Partner$Partner$Shared$sandboxEnabled = function (_v0) {
	var record = _v0;
	return record.aao;
};
var $author$project$Api$Partner$Partner$One$sandboxEnabled = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$sandboxEnabled(shared);
};
var $author$project$Pages$Partner$Dashboard$Top$allSteps = function (partner) {
	var isManaged = !_Utils_eq(
		$author$project$Api$Partner$Partner$One$managedBy(partner),
		$elm$core$Maybe$Nothing);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				$author$project$Api$Partner$Partner$One$sandboxEnabled(partner) ? _List_fromArray(
				[3]) : _List_Nil,
				_List_fromArray(
				[0, 1]),
				isManaged ? _List_Nil : _List_fromArray(
				[2, 4])
			]));
};
var $author$project$Api$Partner$Partner$One$baaDocumentAgreement = function (_v0) {
	var record = _v0.b;
	return record.Mr;
};
var $author$project$Api$Partner$Partner$One$baaType = function (_v0) {
	var record = _v0.b;
	return record.Ms;
};
var $author$project$Pages$Partner$Dashboard$Top$baaCount = function (partner) {
	var _v0 = _Utils_Tuple2(
		$author$project$Api$Partner$Partner$One$managedBy(partner),
		$author$project$Api$Partner$Partner$One$baaType(partner));
	if (!_v0.a.$) {
		return {abt: 0, al9: 0};
	} else {
		if (!_v0.b.$) {
			if (_v0.b.a === 1) {
				var _v1 = _v0.a;
				var _v2 = _v0.b.a;
				return {abt: 1, al9: 1};
			} else {
				var _v3 = _v0.a;
				var _v4 = _v0.b.a;
				return (!_Utils_eq(
					$author$project$Api$Partner$Partner$One$baaDocumentAgreement(partner),
					$elm$core$Maybe$Nothing)) ? {abt: 1, al9: 1} : {abt: 0, al9: 1};
			}
		} else {
			var _v5 = _v0.a;
			var _v6 = _v0.b;
			return {abt: 0, al9: 1};
		}
	}
};
var $author$project$Api$Partner$Partner$One$addendumAgreementFileName = function (_v0) {
	var record = _v0.b;
	return record.KX;
};
var $author$project$Api$Partner$Partner$One$addendumDocumentAgreement = function (_v0) {
	var record = _v0.b;
	return record.KY;
};
var $author$project$Api$Partner$Partner$One$apiAccessDocumentAgreement = function (_v0) {
	var record = _v0.b;
	return record.LT;
};
var $author$project$Components$Partner$DocumentsAgreementsForm$firstRule = function (billingData) {
	if (billingData.$ === 3) {
		var billing = billingData.a;
		return $elm$core$List$head(
			$author$project$Api$Partner$Billing$rules(billing));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Partner$Partner$One$partnerDocumentAgreement = function (_v0) {
	var record = _v0.b;
	return record.YQ;
};
var $author$project$Components$Partner$DocumentsAgreementsForm$applicableAgreements = F2(
	function (partner, billingData) {
		var serviceFeeEntry = function () {
			var _v0 = $author$project$Components$Partner$DocumentsAgreementsForm$firstRule(billingData);
			if (!_v0.$) {
				return $elm$core$Maybe$Just(
					$author$project$Api$Partner$Partner$One$serviceFeeDocumentAgreement(partner));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var managed = !_Utils_eq(
			$author$project$Api$Partner$Partner$One$managedBy(partner),
			$elm$core$Maybe$Nothing);
		var partnerEntry = managed ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			$author$project$Api$Partner$Partner$One$partnerDocumentAgreement(partner));
		var apiAccessEntry = managed ? $elm$core$Maybe$Just(
			$author$project$Api$Partner$Partner$One$apiAccessDocumentAgreement(partner)) : $elm$core$Maybe$Nothing;
		var addendumApplies = (!managed) && (!_Utils_eq(
			$author$project$Api$Partner$Partner$One$addendumAgreementFileName(partner),
			$elm$core$Maybe$Nothing));
		var addendumEntry = addendumApplies ? $elm$core$Maybe$Just(
			$author$project$Api$Partner$Partner$One$addendumDocumentAgreement(partner)) : $elm$core$Maybe$Nothing;
		return A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[partnerEntry, addendumEntry, apiAccessEntry, serviceFeeEntry]));
	});
var $author$project$Components$Partner$DocumentsAgreementsForm$signedCount = function (_v0) {
	var model = _v0;
	var applicable = A2($author$project$Components$Partner$DocumentsAgreementsForm$applicableAgreements, model.YN, model.rt);
	return {
		abt: $elm$core$List$length(
			A2(
				$elm$core$List$filter,
				$elm$core$Basics$neq($elm$core$Maybe$Nothing),
				applicable)),
		al9: $elm$core$List$length(applicable)
	};
};
var $author$project$Pages$Partner$Dashboard$Top$agreementsCount = function (model) {
	var sub = $author$project$Components$Partner$DocumentsAgreementsForm$signedCount(model.dh);
	var baa = $author$project$Pages$Partner$Dashboard$Top$baaCount(model.YN);
	return {abt: sub.abt + baa.abt, al9: sub.al9 + baa.al9};
};
var $author$project$Api$Partner$Partner$One$address = function (_v0) {
	var record = _v0.b;
	return record.K2;
};
var $author$project$Api$Partner$Partner$Shared$technicalEmail = function (_v0) {
	var record = _v0;
	return record.ac$;
};
var $author$project$Api$Partner$Partner$One$technicalEmail = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$technicalEmail(shared);
};
var $author$project$Api$Partner$Partner$Shared$websiteUrl = function (_v0) {
	var record = _v0;
	return record.aev;
};
var $author$project$Api$Partner$Partner$One$websiteUrl = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$websiteUrl(shared);
};
var $author$project$Pages$Partner$Dashboard$Top$isCompanyDetailsComplete = function (partner) {
	var _v0 = _Utils_Tuple3(
		$author$project$Api$Partner$Partner$One$websiteUrl(partner),
		$author$project$Api$Partner$Partner$One$technicalEmail(partner),
		$author$project$Api$Partner$Partner$One$address(partner));
	if (((!_v0.a.$) && (!_v0.b.$)) && (!_v0.c.$)) {
		var technicalEmail = _v0.b.a;
		var address = _v0.c.a;
		return (!$author$project$Api$Common$Address$Shared$isAddressIncomplete(address)) && (!$elm$core$String$isEmpty(technicalEmail));
	} else {
		return false;
	}
};
var $author$project$Api$Partner$PartnerProduct$Shared$distributionType = function (_v0) {
	var record = _v0;
	return record.QN;
};
var $author$project$Api$Partner$PartnerProduct$Shared$iconUrl = function (_v0) {
	var record = _v0;
	return record.TJ;
};
var $author$project$Api$Partner$PartnerProduct$Shared$summary = function (_v0) {
	var record = _v0;
	return record.acF;
};
var $author$project$Pages$Partner$Dashboard$Top$isMarketplaceCardComplete = function (product) {
	return (!_Utils_eq(
		$author$project$Api$Partner$PartnerProduct$Shared$summary(product),
		$elm$core$Maybe$Nothing)) && (!_Utils_eq(
		$author$project$Api$Partner$PartnerProduct$Shared$iconUrl(product),
		$elm$core$Maybe$Nothing));
};
var $author$project$Api$Partner$Partner$One$product = function (_v0) {
	var record = _v0.b;
	return record._s;
};
var $author$project$Api$Partner$PartnerProduct$Shared$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Pages$Partner$Dashboard$Top$isProductListingPublished = function (partner) {
	var _v0 = $author$project$Api$Partner$Partner$One$product(partner);
	if (!_v0.$) {
		var product = _v0.a;
		return (!$author$project$Api$Partner$PartnerProduct$Shared$distributionType(product)) && ((!A2(
			$elm$core$List$member,
			$author$project$Api$Partner$PartnerProduct$Shared$status(product),
			_List_fromArray(
				[1, 8]))) && $author$project$Pages$Partner$Dashboard$Top$isMarketplaceCardComplete(product));
	} else {
		return false;
	}
};
var $author$project$Api$Partner$Partner$One$hasSandboxPartners = function (_v0) {
	var record = _v0.b;
	return record.Ti;
};
var $author$project$Api$Partner$Partner$One$hasSandboxPractices = function (_v0) {
	var record = _v0.b;
	return record.Tj;
};
var $author$project$Pages$Partner$Dashboard$Top$isSandboxSetupComplete = function (partner) {
	return $author$project$Api$Partner$Partner$One$hasSandboxPartners(partner) && $author$project$Api$Partner$Partner$One$hasSandboxPractices(partner);
};
var $author$project$Api$Partner$PartnerProduct$Shared$backlinkUrl = function (_v0) {
	var record = _v0;
	return record.Mv;
};
var $author$project$Pages$Partner$Dashboard$Top$isWebsiteBacklinkComplete = function (partner) {
	return $author$project$Pages$Partner$Dashboard$Top$isProductListingPublished(partner) && function () {
		var _v0 = $author$project$Api$Partner$Partner$One$product(partner);
		if (!_v0.$) {
			var product = _v0.a;
			return !_Utils_eq(
				$author$project$Api$Partner$PartnerProduct$Shared$backlinkUrl(product),
				$elm$core$Maybe$Nothing);
		} else {
			return false;
		}
	}();
};
var $author$project$Pages$Partner$Dashboard$Top$isStepComplete = F2(
	function (model, step) {
		switch (step) {
			case 0:
				return $author$project$Pages$Partner$Dashboard$Top$isCompanyDetailsComplete(model.YN);
			case 1:
				var count = $author$project$Pages$Partner$Dashboard$Top$agreementsCount(model);
				return _Utils_eq(count.abt, count.al9);
			case 2:
				return $author$project$Pages$Partner$Dashboard$Top$isProductListingPublished(model.YN);
			case 3:
				return $author$project$Pages$Partner$Dashboard$Top$isSandboxSetupComplete(model.YN);
			default:
				return $author$project$Pages$Partner$Dashboard$Top$isWebsiteBacklinkComplete(model.YN);
		}
	});
var $author$project$Pages$Partner$Dashboard$Top$firstIncompleteStep = function (model) {
	return $elm$core$List$head(
		A2(
			$elm$core$List$filter,
			function (step) {
				return !A2($author$project$Pages$Partner$Dashboard$Top$isStepComplete, model, step);
			},
			$author$project$Pages$Partner$Dashboard$Top$allSteps(model.YN)));
};
var $author$project$Pages$Partner$Dashboard$Top$autoAdvanceSections = function (model) {
	var _v0 = $author$project$Pages$Partner$Dashboard$Top$firstIncompleteStep(model);
	if (!_v0.$) {
		var step = _v0.a;
		return _List_fromArray(
			[step]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Partner$BaaForm$Model = $elm$core$Basics$identity;
var $author$project$Components$Partner$BaaForm$initFormFields = function (partner) {
	return {
		rq: !_Utils_eq(
			$author$project$Api$Partner$Partner$One$baaDocumentAgreement(partner),
			$elm$core$Maybe$Nothing),
		Ms: $author$project$Api$Partner$Partner$One$baaType(partner)
	};
};
var $author$project$Components$Partner$BaaForm$init = F2(
	function (timeFormatter, partner) {
		return _Utils_Tuple2(
			{
				SD: $author$project$Utils$Form$init(
					$author$project$Components$Partner$BaaForm$initFormFields(partner)),
				YN: partner,
				J7: timeFormatter,
				qP: $author$project$Api$Data$NotAsked
			},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Components$Partner$DocumentsAgreementsForm$GotBilling = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Partner$DocumentsAgreementsForm$Model = $elm$core$Basics$identity;
var $author$project$Components$Partner$DocumentsAgreementsForm$initFormFields = function (partner) {
	return {
		Gi: !_Utils_eq(
			$author$project$Api$Partner$Partner$One$addendumDocumentAgreement(partner),
			$elm$core$Maybe$Nothing),
		Gu: !_Utils_eq(
			$author$project$Api$Partner$Partner$One$apiAccessDocumentAgreement(partner),
			$elm$core$Maybe$Nothing),
		I2: !_Utils_eq(
			$author$project$Api$Partner$Partner$One$partnerDocumentAgreement(partner),
			$elm$core$Maybe$Nothing),
		JH: !_Utils_eq(
			$author$project$Api$Partner$Partner$One$serviceFeeDocumentAgreement(partner),
			$elm$core$Maybe$Nothing)
	};
};
var $author$project$Components$Partner$DocumentsAgreementsForm$init = F3(
	function (apiClient, timeFormatter, partner) {
		return _Utils_Tuple2(
			{
				rt: $author$project$Api$Data$Loading,
				SD: $author$project$Utils$Form$init(
					$author$project$Components$Partner$DocumentsAgreementsForm$initFormFields(partner)),
				YN: partner,
				J7: timeFormatter,
				qP: $author$project$Api$Data$NotAsked
			},
			A2($author$project$Api$Partner$Billing$retrieve, apiClient, $author$project$Components$Partner$DocumentsAgreementsForm$GotBilling));
	});
var $author$project$Components$Partner$Form$Model = $elm$core$Basics$identity;
var $author$project$Components$Partner$Form$Address = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Partner$Form$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Partner$Partner$Shared$email = function (_v0) {
	var record = _v0;
	return record.Rj;
};
var $author$project$Api$Partner$Partner$One$email = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$email(shared);
};
var $author$project$Api$Partner$Partner$Shared$logoUrl = function (_v0) {
	var record = _v0;
	return record.Wk;
};
var $author$project$Api$Partner$Partner$One$logoUrl = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$logoUrl(shared);
};
var $author$project$Api$Partner$Partner$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Partner$Partner$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$name(shared);
};
var $author$project$Api$Partner$Partner$Shared$usesIntegrationRecords = function (_v0) {
	var record = _v0;
	return record.ad7;
};
var $author$project$Api$Partner$Partner$One$usesIntegrationRecords = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$usesIntegrationRecords(shared);
};
var $author$project$Components$Partner$Form$initFormFields = function (partner) {
	var _v0 = A2(
		$author$project$Components$AddressInput$initFromApi,
		'partner-address',
		$author$project$Api$Partner$Partner$One$address(partner));
	var address = _v0.a;
	var addressCmd = _v0.b;
	return _Utils_Tuple2(
		{
			K2: address,
			Pg: $author$project$Api$Partner$Partner$One$logoUrl(partner),
			Rj: $author$project$Api$Partner$Partner$One$email(partner),
			Iu: 0,
			Wk: $elm$core$Maybe$Nothing,
			Bq: $author$project$Api$Partner$Partner$One$name(partner),
			ac$: $author$project$Api$Partner$Partner$One$technicalEmail(partner),
			ad7: $author$project$Api$Partner$Partner$One$usesIntegrationRecords(partner),
			aev: $author$project$Api$Partner$Partner$One$websiteUrl(partner)
		},
		A2(
			$elm$core$Platform$Cmd$map,
			A2($elm$core$Basics$composeL, $author$project$Components$Partner$Form$FormUpdated, $author$project$Components$Partner$Form$Address),
			addressCmd));
};
var $author$project$Components$Partner$Form$init = function (partner) {
	var _v0 = $author$project$Components$Partner$Form$initFormFields(partner);
	var formFields = _v0.a;
	var formFieldsCmd = _v0.b;
	return _Utils_Tuple2(
		{
			SD: $author$project$Utils$Form$init(formFields),
			YN: partner
		},
		formFieldsCmd);
};
var $author$project$Pages$Partner$Dashboard$Top$isPartnerOnboarded = function (partner) {
	return $author$project$Pages$Partner$Dashboard$Top$isCompanyDetailsComplete(partner);
};
var $author$project$Api$Platform$Session$One$sandbox = function (_v0) {
	var record = _v0;
	return record.aan;
};
var $author$project$Pages$Partner$Dashboard$Top$init = F4(
	function (session, partner, shared, _v0) {
		var onboarded = $author$project$Pages$Partner$Dashboard$Top$isPartnerOnboarded(partner);
		var _v1 = onboarded ? _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none) : A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map($author$project$Pages$Partner$Dashboard$Top$PartnerFormMsg),
			A2(
				$elm$core$Tuple$mapFirst,
				$elm$core$Maybe$Just,
				$author$project$Components$Partner$Form$init(partner)));
		var partnerForm = _v1.a;
		var partnerFormCmd = _v1.b;
		var _v2 = A3($author$project$Components$Partner$DocumentsAgreementsForm$init, shared.Gv, shared.J7, partner);
		var documentsAgreementsForm = _v2.a;
		var documentsAgreementsFormCmd = _v2.b;
		var _v3 = A2($author$project$Components$Partner$BaaForm$init, shared.J7, partner);
		var baaForm = _v3.a;
		var baaFormCmd = _v3.b;
		var baseModel = {
			Gv: shared.Gv,
			dZ: baaForm,
			fL: A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$andThen,
					$author$project$Api$Partner$PartnerProduct$Shared$backlinkUrl,
					$author$project$Api$Partner$Partner$One$product(partner))),
			mq: $author$project$Api$Data$NotAsked,
			dh: documentsAgreementsForm,
			jH: _List_Nil,
			In: $author$project$Api$Platform$Session$One$sandbox(session),
			Cb: onboarded,
			YN: partner,
			bJ: partnerForm,
			k2: $author$project$Api$Data$NotAsked,
			J7: shared.J7,
			qP: $author$project$Api$Data$NotAsked
		};
		return _Utils_Tuple2(
			_Utils_update(
				baseModel,
				{
					jH: $author$project$Pages$Partner$Dashboard$Top$autoAdvanceSections(baseModel)
				}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						partnerFormCmd,
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Dashboard$Top$BaaFormMsg, baaFormCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Dashboard$Top$DocumentsAgreementsFormMsg, documentsAgreementsFormCmd)
					])));
	});
var $author$project$Pages$Partner$Dashboard$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Partner$Dashboard$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Partner$BaaForm$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Components$Partner$DocumentsAgreementsForm$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Components$Partner$Form$subscriptions = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.SD);
	return A2(
		$elm$core$Platform$Sub$map,
		A2($elm$core$Basics$composeL, $author$project$Components$Partner$Form$FormUpdated, $author$project$Components$Partner$Form$Address),
		$author$project$Components$AddressInput$subscriptions(fields.K2));
};
var $author$project$Pages$Partner$Dashboard$Top$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Partner$Dashboard$Top$PartnerFormMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Partner$Form$subscriptions, model.bJ))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Partner$Dashboard$Top$BaaFormMsg,
				$author$project$Components$Partner$BaaForm$subscriptions(model.dZ)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Partner$Dashboard$Top$DocumentsAgreementsFormMsg,
				$author$project$Components$Partner$DocumentsAgreementsForm$subscriptions(model.dh))
			]));
};
var $author$project$Api$Partner$PartnerProduct$BacklinkUrl = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Partner$Dashboard$Top$GotBacklinkUrlResponse = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Partner$Dashboard$Top$GotReviewResponse = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Partner$Dashboard$Top$GotUpdatedPartner = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Partner$PartnerProduct$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Partner$PartnerProduct$One$PartnerProduct = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Partner$PartnerProduct$One$Record = F5(
	function (ctaUrl, utmCampaign, utmContent, requirement, pricing) {
		return {Pc: ctaUrl, _i: pricing, $E: requirement, aea: utmCampaign, aeb: utmContent};
	});
var $author$project$Api$Common$Marketplace$Product$Requirement$FeatureRequirement = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Common$Marketplace$Product$Requirement$TierRequirement = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Common$Marketplace$Product$Requirement$Feature$decoder = A2($elm$json$Json$Decode$map, $author$project$Api$Common$Marketplace$Product$Requirement$Feature$fromString, $elm$json$Json$Decode$string);
var $author$project$Api$Common$Marketplace$Product$Requirement$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (type_) {
		if (type_ === 'feature') {
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Api$Common$Marketplace$Product$Requirement$FeatureRequirement,
				A2($elm$json$Json$Decode$field, 'feature', $author$project$Api$Common$Marketplace$Product$Requirement$Feature$decoder));
		} else {
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Api$Common$Marketplace$Product$Requirement$TierRequirement,
				A2($elm$json$Json$Decode$field, 'starting_tier', $elm$json$Json$Decode$string));
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$Api$Partner$PartnerProductPricing$Shared$PartnerProductPricing = $elm$core$Basics$identity;
var $author$project$Api$Partner$PartnerProductPricing$Shared$Record = function (description) {
	return {Qr: description};
};
var $author$project$Api$Partner$PartnerProductPricing$Shared$decoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'description',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Partner$PartnerProductPricing$Shared$Record)));
var $author$project$Api$Partner$PartnerProduct$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'pricing',
	$elm$json$Json$Decode$nullable($author$project$Api$Partner$PartnerProductPricing$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'requirement',
		$elm$json$Json$Decode$nullable($author$project$Api$Common$Marketplace$Product$Requirement$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'utm_content',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'utm_campaign',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'cta_url',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					$elm$json$Json$Decode$succeed($author$project$Api$Partner$PartnerProduct$One$Record))))));
var $author$project$Api$Partner$PartnerProduct$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$PartnerProduct$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Partner$PartnerProduct$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Partner$PartnerProduct$One$PartnerProduct)));
var $author$project$Api$Partner$PartnerProduct$productPathWithId = function (productId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['partner_products', productId]),
		$author$project$Api$Data$partnerPath);
};
var $author$project$Api$Partner$PartnerProduct$requestReview = F3(
	function (apiClient, productId, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$PartnerProduct$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['request_review']),
					$author$project$Api$Partner$PartnerProduct$productPathWithId(productId))));
	});
var $author$project$Api$Partner$Partner$update = F3(
	function (apiClient, permittedFields, toMsg) {
		var body = $author$project$Api$Partner$Partner$encodePermittedFields(permittedFields);
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Partner$Partner$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Partner$Partner$partnerPath)));
	});
var $author$project$Api$Common$Marketplace$Product$DistributionType$toString = function (distributionType) {
	if (!distributionType) {
		return 'public';
	} else {
		return 'unlisted';
	}
};
var $author$project$Api$Common$Marketplace$Product$DistributionType$encode = function (distributionType) {
	return $elm$json$Json$Encode$string(
		$author$project$Api$Common$Marketplace$Product$DistributionType$toString(distributionType));
};
var $author$project$Api$Common$Marketplace$Product$ProductType$toString = function (type_) {
	switch (type_) {
		case 0:
			return 'app';
		case 1:
			return 'integration';
		default:
			return 'solution';
	}
};
var $author$project$Api$Common$Marketplace$Product$ProductType$encode = A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$Api$Common$Marketplace$Product$ProductType$toString);
var $author$project$Api$Common$Marketplace$Product$Status$toString = function (status) {
	switch (status) {
		case 0:
			return 'hidden';
		case 1:
			return 'unpublished';
		case 2:
			return 'researching';
		case 3:
			return 'coming_soon';
		case 4:
			return 'beta';
		case 5:
			return 'live';
		case 6:
			return 'sunsetting';
		case 7:
			return 'deprecated';
		default:
			return 'decommissioned';
	}
};
var $author$project$Api$Common$Marketplace$Product$Status$encode = function (status) {
	return $elm$json$Json$Encode$string(
		$author$project$Api$Common$Marketplace$Product$Status$toString(status));
};
var $author$project$Api$Common$Marketplace$Product$Requirement$Feature$toString = function (feature) {
	if (!feature.$) {
		return 'emr';
	} else {
		var string = feature.a;
		return string;
	}
};
var $author$project$Api$Partner$PartnerProduct$encodePermittedFields = function (permittedFields) {
	var encodedFields = A3(
		$elm$core$List$foldl,
		F2(
			function (field, acc) {
				switch (field.$) {
					case 0:
						var slug = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'slug',
								$elm$json$Json$Encode$string(slug)),
							acc);
					case 1:
						var productType = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'product_type',
								$author$project$Api$Common$Marketplace$Product$ProductType$encode(productType)),
							acc);
					case 2:
						var name = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(name)),
							acc);
					case 3:
						var icon = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'icon',
								$elm$json$Json$Encode$string(icon)),
							acc);
					case 4:
						var summary = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'summary',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, summary)),
							acc);
					case 5:
						var builtByName = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'built_by_name',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, builtByName)),
							acc);
					case 6:
						var builtByUrl = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'built_by_url',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, builtByUrl)),
							acc);
					case 7:
						var distributionType = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'distribution_type',
								$author$project$Api$Common$Marketplace$Product$DistributionType$encode(distributionType)),
							acc);
					case 8:
						var featured = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'featured',
								$elm$json$Json$Encode$bool(featured)),
							acc);
					case 9:
						var status = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'status',
								$author$project$Api$Common$Marketplace$Product$Status$encode(status)),
							acc);
					case 10:
						var ctaUrl = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'cta_url',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, ctaUrl)),
							acc);
					case 11:
						var utmCampaign = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'utm_campaign',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, utmCampaign)),
							acc);
					case 12:
						var utmContent = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'utm_content',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, utmContent)),
							acc);
					case 13:
						var req = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'requirement',
								function () {
									if (!req.$) {
										if (!req.a.$) {
											var feature = req.a.a;
											return $elm$json$Json$Encode$object(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'type',
														$elm$json$Json$Encode$string('feature')),
														_Utils_Tuple2(
														'feature',
														$elm$json$Json$Encode$string(
															$author$project$Api$Common$Marketplace$Product$Requirement$Feature$toString(feature)))
													]));
										} else {
											var value = req.a.a;
											return $elm$json$Json$Encode$object(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'type',
														$elm$json$Json$Encode$string('tier')),
														_Utils_Tuple2(
														'starting_tier',
														$elm$json$Json$Encode$string(value))
													]));
										}
									} else {
										return $elm$json$Json$Encode$null;
									}
								}()),
							acc);
					case 14:
						var backlinkUrl = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'backlink_url',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, backlinkUrl)),
							acc);
					case 15:
						var description = field.a.Qr;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'overview',
								$elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'description',
											$elm$json$Json$Encode$string(description))
										]))),
							acc);
					case 16:
						var images = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'overview_images',
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, images)),
							acc);
					case 17:
						var highlights = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'highlights',
								A2(
									$elm$json$Json$Encode$list,
									function (h) {
										return $elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'title',
													$elm$json$Json$Encode$string(h.ac9)),
													_Utils_Tuple2(
													'description',
													$elm$json$Json$Encode$string(h.Qr)),
													_Utils_Tuple2(
													'image',
													A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, h.ahT))
												]));
									},
									highlights)),
							acc);
					case 18:
						var links = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'links',
								A2(
									$elm$json$Json$Encode$list,
									function (l) {
										return $elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'label',
													$elm$json$Json$Encode$string(l.aih)),
													_Utils_Tuple2(
													'url',
													$elm$json$Json$Encode$string(l.adY))
												]));
									},
									links)),
							acc);
					case 19:
						var quotes = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'quotes',
								A2(
									$elm$json$Json$Encode$list,
									function (q) {
										return $elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'text',
													$elm$json$Json$Encode$string(q.ac3)),
													_Utils_Tuple2(
													'author',
													$elm$json$Json$Encode$string(q.Mb)),
													_Utils_Tuple2(
													'author_title',
													$elm$json$Json$Encode$string(q.Md)),
													_Utils_Tuple2(
													'author_image',
													A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, q.ae1))
												]));
									},
									quotes)),
							acc);
					default:
						var categories = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'categories',
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, categories)),
							acc);
				}
			}),
		_List_Nil,
		permittedFields);
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'partner_product',
				$elm$json$Json$Encode$object(encodedFields))
			]));
};
var $author$project$Api$Partner$PartnerProduct$update = F4(
	function (apiClient, productId, permittedFields, toMsg) {
		var body = $author$project$Api$Partner$PartnerProduct$encodePermittedFields(permittedFields);
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Partner$PartnerProduct$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Partner$PartnerProduct$productPathWithId(productId))));
	});
var $author$project$Components$Partner$BaaForm$BaaAccepted = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Partner$Partner$BaaAgreementAccepted = function (a) {
	return {$: 30, a: a};
};
var $author$project$Api$Partner$Partner$BaaType = function (a) {
	return {$: 29, a: a};
};
var $author$project$Components$Partner$BaaForm$GotCustomBaaAgreementUrl = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Partner$BaaForm$GotUpdatedPartner = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$BaaForm$None = {$: 0};
var $author$project$Components$Partner$BaaForm$PartnerUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$BaaForm$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var baaType = field.a;
			return _Utils_update(
				fields,
				{
					Ms: $elm$core$Maybe$Just(baaType)
				});
		} else {
			var bool = field.a;
			return _Utils_update(
				fields,
				{rq: bool});
		}
	});
var $author$project$Components$Partner$BaaForm$BaaTypeValidation = 0;
var $author$project$Components$Partner$BaaForm$BaaAcceptedValidation = 1;
var $author$project$Components$Partner$BaaForm$validateBaaAccepted = function (fields) {
	return (_Utils_eq(
		fields.Ms,
		$elm$core$Maybe$Just(0)) && (!fields.rq)) ? _List_fromArray(
		[
			_Utils_Tuple2(1, 'Please agree to the BAA.')
		]) : _List_Nil;
};
var $author$project$Components$Partner$BaaForm$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.Ms;
			},
			_Utils_Tuple2(0, 'Please select a BAA type.')),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Partner$BaaForm$validateBaaAccepted)
		]));
var $author$project$Api$Partner$Partner$signedCustomBaaAgreementUrl = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string),
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['signed_custom_baa_agreement_url']),
					$author$project$Api$Partner$Partner$partnerPath)));
	});
var $author$project$Components$Partner$BaaForm$toPermittedFields = F2(
	function (partner, fields) {
		return A2(
			$elm$core$List$cons,
			$author$project$Api$Partner$Partner$BaaType(fields.Ms),
			(_Utils_eq(
				$author$project$Api$Partner$Partner$One$baaDocumentAgreement(partner),
				$elm$core$Maybe$Nothing) && _Utils_eq(
				fields.Ms,
				$elm$core$Maybe$Just(0))) ? _List_fromArray(
				[
					$author$project$Api$Partner$Partner$BaaAgreementAccepted(fields.rq)
				]) : _List_Nil);
	});
var $author$project$Components$Partner$BaaForm$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var field = msg.a;
				if ((field.$ === 1) && field.a) {
					var newForm = A3(
						$author$project$Utils$Form$update,
						$author$project$Components$Partner$BaaForm$formFieldsUpdate,
						$author$project$Components$Partner$BaaForm$BaaAccepted(true),
						model.SD);
					var fields = $author$project$Utils$Form$fields(model.SD);
					return {
						GZ: A3(
							$author$project$Api$Partner$Partner$update,
							apiClient,
							_List_fromArray(
								[
									$author$project$Api$Partner$Partner$BaaType(fields.Ms),
									$author$project$Api$Partner$Partner$BaaAgreementAccepted(true)
								]),
							$author$project$Components$Partner$BaaForm$GotUpdatedPartner),
						agZ: $author$project$Components$Partner$BaaForm$None,
						aiO: _Utils_update(
							model,
							{SD: newForm, qP: $author$project$Api$Data$Loading}),
						aR: _List_Nil
					};
				} else {
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Partner$BaaForm$formFieldsUpdate, field, model.SD);
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Partner$BaaForm$None,
						aiO: _Utils_update(
							model,
							{SD: newForm}),
						aR: _List_Nil
					};
				}
			case 1:
				var _v3 = A2($author$project$Utils$Form$validate, $author$project$Components$Partner$BaaForm$formFieldsValidator, model.SD);
				if (!_v3.$) {
					var _v4 = _v3.a;
					var updatedForm = _v4.a;
					var validFormFields = _v4.b;
					var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
					var permittedFields = A2($author$project$Components$Partner$BaaForm$toPermittedFields, model.YN, fields);
					return {
						GZ: A3($author$project$Api$Partner$Partner$update, apiClient, permittedFields, $author$project$Components$Partner$BaaForm$GotUpdatedPartner),
						agZ: $author$project$Components$Partner$BaaForm$None,
						aiO: _Utils_update(
							model,
							{SD: updatedForm, qP: $author$project$Api$Data$Loading}),
						aR: _List_Nil
					};
				} else {
					var updatedForm = _v3.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Partner$BaaForm$None,
						aiO: _Utils_update(
							model,
							{SD: updatedForm, qP: $author$project$Api$Data$NotAsked}),
						aR: _List_Nil
					};
				}
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					var partner = response.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Partner$BaaForm$PartnerUpdated(partner),
						aiO: _Utils_update(
							model,
							{
								SD: $author$project$Utils$Form$init(
									$author$project$Components$Partner$BaaForm$initFormFields(partner)),
								YN: partner,
								qP: response
							}),
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Partner updated successfully!'),
								$author$project$OutMsg$RefreshPartner
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Partner$BaaForm$None,
						aiO: _Utils_update(
							model,
							{qP: response}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 3:
				return {
					GZ: A2($author$project$Api$Partner$Partner$signedCustomBaaAgreementUrl, apiClient, $author$project$Components$Partner$BaaForm$GotCustomBaaAgreementUrl),
					agZ: $author$project$Components$Partner$BaaForm$None,
					aiO: model,
					aR: _List_Nil
				};
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var url = response.a;
					return {
						GZ: $author$project$Ports$Navigation$openInNewWindow(url),
						agZ: $author$project$Components$Partner$BaaForm$None,
						aiO: model,
						aR: _List_Nil
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Partner$BaaForm$None,
						aiO: model,
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
		}
	});
var $author$project$Api$Partner$Partner$AddendumAgreementAccepted = function (a) {
	return {$: 24, a: a};
};
var $author$project$Api$Partner$Partner$ApiAccessAgreementAccepted = function (a) {
	return {$: 31, a: a};
};
var $author$project$Components$Partner$DocumentsAgreementsForm$GotAddendumAgreementUrl = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Partner$DocumentsAgreementsForm$GotApiAccessAgreementUrl = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Partner$DocumentsAgreementsForm$GotCustomPartnerAgreementUrl = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Partner$DocumentsAgreementsForm$GotUpdatedPartner = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$DocumentsAgreementsForm$None = {$: 0};
var $author$project$Api$Partner$Partner$PartnerAgreementAccepted = function (a) {
	return {$: 23, a: a};
};
var $author$project$Components$Partner$DocumentsAgreementsForm$PartnerUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Partner$Partner$ServiceFeeAgreementAccepted = function (a) {
	return {$: 32, a: a};
};
var $author$project$Components$Partner$DocumentsAgreementsForm$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var bool = field.a;
				return _Utils_update(
					fields,
					{I2: bool});
			case 1:
				var bool = field.a;
				return _Utils_update(
					fields,
					{Gi: bool});
			case 2:
				var bool = field.a;
				return _Utils_update(
					fields,
					{Gu: bool});
			default:
				var bool = field.a;
				return _Utils_update(
					fields,
					{JH: bool});
		}
	});
var $author$project$Api$Partner$Partner$signedAddendumAgreementUrl = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string),
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['signed_addendum_agreement_url']),
					$author$project$Api$Partner$Partner$partnerPath)));
	});
var $author$project$Api$Partner$Partner$signedCustomApiAccessAgreementUrl = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string),
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['signed_custom_api_access_agreement_url']),
					$author$project$Api$Partner$Partner$partnerPath)));
	});
var $author$project$Api$Partner$Partner$signedCustomPartnerAgreementUrl = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string),
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['signed_custom_partner_agreement_url']),
					$author$project$Api$Partner$Partner$partnerPath)));
	});
var $author$project$Components$Partner$DocumentsAgreementsForm$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var field = msg.a;
				_v2$4:
				while (true) {
					switch (field.$) {
						case 0:
							if (field.a) {
								return {
									GZ: A3(
										$author$project$Api$Partner$Partner$update,
										apiClient,
										_List_fromArray(
											[
												$author$project$Api$Partner$Partner$PartnerAgreementAccepted(true)
											]),
										$author$project$Components$Partner$DocumentsAgreementsForm$GotUpdatedPartner),
									agZ: $author$project$Components$Partner$DocumentsAgreementsForm$None,
									aiO: _Utils_update(
										model,
										{
											SD: A3($author$project$Utils$Form$update, $author$project$Components$Partner$DocumentsAgreementsForm$formFieldsUpdate, field, model.SD),
											qP: $author$project$Api$Data$Loading
										}),
									aR: _List_Nil
								};
							} else {
								break _v2$4;
							}
						case 1:
							if (field.a) {
								return {
									GZ: A3(
										$author$project$Api$Partner$Partner$update,
										apiClient,
										_List_fromArray(
											[
												$author$project$Api$Partner$Partner$AddendumAgreementAccepted(true)
											]),
										$author$project$Components$Partner$DocumentsAgreementsForm$GotUpdatedPartner),
									agZ: $author$project$Components$Partner$DocumentsAgreementsForm$None,
									aiO: _Utils_update(
										model,
										{
											SD: A3($author$project$Utils$Form$update, $author$project$Components$Partner$DocumentsAgreementsForm$formFieldsUpdate, field, model.SD),
											qP: $author$project$Api$Data$Loading
										}),
									aR: _List_Nil
								};
							} else {
								break _v2$4;
							}
						case 2:
							if (field.a) {
								return {
									GZ: A3(
										$author$project$Api$Partner$Partner$update,
										apiClient,
										_List_fromArray(
											[
												$author$project$Api$Partner$Partner$ApiAccessAgreementAccepted(true)
											]),
										$author$project$Components$Partner$DocumentsAgreementsForm$GotUpdatedPartner),
									agZ: $author$project$Components$Partner$DocumentsAgreementsForm$None,
									aiO: _Utils_update(
										model,
										{
											SD: A3($author$project$Utils$Form$update, $author$project$Components$Partner$DocumentsAgreementsForm$formFieldsUpdate, field, model.SD),
											qP: $author$project$Api$Data$Loading
										}),
									aR: _List_Nil
								};
							} else {
								break _v2$4;
							}
						default:
							if (field.a) {
								return {
									GZ: A3(
										$author$project$Api$Partner$Partner$update,
										apiClient,
										_List_fromArray(
											[
												$author$project$Api$Partner$Partner$ServiceFeeAgreementAccepted(true)
											]),
										$author$project$Components$Partner$DocumentsAgreementsForm$GotUpdatedPartner),
									agZ: $author$project$Components$Partner$DocumentsAgreementsForm$None,
									aiO: _Utils_update(
										model,
										{
											SD: A3($author$project$Utils$Form$update, $author$project$Components$Partner$DocumentsAgreementsForm$formFieldsUpdate, field, model.SD),
											qP: $author$project$Api$Data$Loading
										}),
									aR: _List_Nil
								};
							} else {
								break _v2$4;
							}
					}
				}
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: $author$project$Components$Partner$DocumentsAgreementsForm$None,
					aiO: _Utils_update(
						model,
						{
							SD: A3($author$project$Utils$Form$update, $author$project$Components$Partner$DocumentsAgreementsForm$formFieldsUpdate, field, model.SD)
						}),
					aR: _List_Nil
				};
			case 1:
				var response = msg.a;
				if (response.$ === 3) {
					var partner = response.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Partner$DocumentsAgreementsForm$PartnerUpdated(partner),
						aiO: _Utils_update(
							model,
							{
								SD: $author$project$Utils$Form$init(
									$author$project$Components$Partner$DocumentsAgreementsForm$initFormFields(partner)),
								YN: partner,
								qP: response
							}),
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Partner updated successfully!'),
								$author$project$OutMsg$RefreshPartner
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Partner$DocumentsAgreementsForm$None,
						aiO: _Utils_update(
							model,
							{qP: response}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 2:
				return {
					GZ: A2($author$project$Api$Partner$Partner$signedCustomPartnerAgreementUrl, apiClient, $author$project$Components$Partner$DocumentsAgreementsForm$GotCustomPartnerAgreementUrl),
					agZ: $author$project$Components$Partner$DocumentsAgreementsForm$None,
					aiO: model,
					aR: _List_Nil
				};
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					var url = response.a;
					return {
						GZ: $author$project$Ports$Navigation$openInNewWindow(url),
						agZ: $author$project$Components$Partner$DocumentsAgreementsForm$None,
						aiO: model,
						aR: _List_Nil
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Partner$DocumentsAgreementsForm$None,
						aiO: model,
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 4:
				return {
					GZ: A2($author$project$Api$Partner$Partner$signedAddendumAgreementUrl, apiClient, $author$project$Components$Partner$DocumentsAgreementsForm$GotAddendumAgreementUrl),
					agZ: $author$project$Components$Partner$DocumentsAgreementsForm$None,
					aiO: model,
					aR: _List_Nil
				};
			case 6:
				var response = msg.a;
				if (response.$ === 3) {
					var url = response.a;
					return {
						GZ: $author$project$Ports$Navigation$openInNewWindow(url),
						agZ: $author$project$Components$Partner$DocumentsAgreementsForm$None,
						aiO: model,
						aR: _List_Nil
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Partner$DocumentsAgreementsForm$None,
						aiO: model,
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 3:
				return {
					GZ: A2($author$project$Api$Partner$Partner$signedCustomApiAccessAgreementUrl, apiClient, $author$project$Components$Partner$DocumentsAgreementsForm$GotApiAccessAgreementUrl),
					agZ: $author$project$Components$Partner$DocumentsAgreementsForm$None,
					aiO: model,
					aR: _List_Nil
				};
			case 7:
				var response = msg.a;
				if (response.$ === 3) {
					var url = response.a;
					return {
						GZ: $author$project$Ports$Navigation$openInNewWindow(url),
						agZ: $author$project$Components$Partner$DocumentsAgreementsForm$None,
						aiO: model,
						aR: _List_Nil
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Partner$DocumentsAgreementsForm$None,
						aiO: model,
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			default:
				var response = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: $author$project$Components$Partner$DocumentsAgreementsForm$None,
					aiO: _Utils_update(
						model,
						{rt: response}),
					aR: _List_Nil
				};
		}
	});
var $author$project$Components$Partner$Form$Logo = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Partner$Form$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{Bq: string}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var string = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							aev: $author$project$Utils$String$toMaybe(string)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var _int = field.a;
				var string = field.b;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							Pg: $elm$core$Maybe$Just(string),
							Iu: _int,
							Wk: $elm$core$Maybe$Just(string)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var string = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							Rj: $author$project$Utils$String$toMaybe(string)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var string = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							ac$: $author$project$Utils$String$toMaybe(string)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var bool = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{ad7: bool}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var addressMsg = field.a;
				var _v1 = A2($author$project$Components$AddressInput$update, addressMsg, fields.K2);
				var addressInput = _v1.a;
				var cmd = _v1.b;
				var outMsgs = _v1.c;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{K2: addressInput}),
					A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Partner$Form$FormUpdated, $author$project$Components$Partner$Form$Address),
						cmd),
					outMsgs);
		}
	});
var $author$project$Components$Partner$Form$update = F2(
	function (msg, _v0) {
		var model = _v0;
		if (!msg.$) {
			var field = msg.a;
			var _v2 = A3($author$project$Utils$Form$updateWithCmdAndOutMsgs, $author$project$Components$Partner$Form$formFieldsUpdate, field, model.SD);
			var newForm = _v2.a;
			var cmd = _v2.b;
			var outMsgs = _v2.c;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{SD: newForm}),
				cmd,
				outMsgs);
		} else {
			var logos = msg.a;
			var cmd = A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Cmd$none,
				A2(
					$elm$core$Maybe$map,
					function (_v3) {
						var task = _v3.a;
						var size = _v3.b;
						return A2(
							$elm$core$Task$perform,
							A2(
								$elm$core$Basics$composeL,
								$author$project$Components$Partner$Form$FormUpdated,
								$author$project$Components$Partner$Form$Logo(size)),
							task);
					},
					A2(
						$elm$core$Maybe$map,
						function (logo) {
							return _Utils_Tuple2(
								$elm$file$File$toUrl(logo),
								$elm$file$File$size(logo));
						},
						$elm$core$List$head(logos))));
			return _Utils_Tuple3(model, cmd, _List_Nil);
		}
	});
var $author$project$Components$Partner$Form$LogoValidation = 2;
var $author$project$Components$Partner$Form$NameValidation = 0;
var $author$project$Components$Partner$Form$TechnicalEmailValidation = 4;
var $author$project$Components$Partner$Form$WebsiteUrlValidation = 1;
var $author$project$Components$Partner$Form$maxLogoBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
var $author$project$Components$Partner$Form$AddressValidation = 5;
var $author$project$Components$Partner$Form$validateAddress = function (fields) {
	return $author$project$Components$AddressInput$isValid(fields.K2) ? _List_Nil : _List_fromArray(
		[
			_Utils_Tuple2(5, 'Please enter an address')
		]);
};
var $author$project$Components$Partner$Form$validateRequiredMaybeString = F4(
	function (getter, validationGroup, errorMsg, fields) {
		var _v0 = getter(fields);
		if (_v0.$ === 1) {
			return _List_fromArray(
				[
					_Utils_Tuple2(validationGroup, errorMsg)
				]);
		} else {
			var value = _v0.a;
			return $elm$core$String$isEmpty(value) ? _List_fromArray(
				[
					_Utils_Tuple2(validationGroup, errorMsg)
				]) : _List_Nil;
		}
	});
var $author$project$Components$Partner$Form$validateUrlRequired = F4(
	function (getter, validationGroup, errorMsg, fields) {
		var _v0 = getter(fields);
		if (_v0.$ === 1) {
			return _List_fromArray(
				[
					_Utils_Tuple2(validationGroup, errorMsg)
				]);
		} else {
			var url = _v0.a;
			return $author$project$Utils$Validate$isInvalidUrl(url) ? _List_fromArray(
				[
					_Utils_Tuple2(validationGroup, 'URL must start with http:// or https://')
				]) : _List_Nil;
		}
	});
var $author$project$Components$Partner$Form$formFieldsValidatorAll = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.Bq;
			},
			_Utils_Tuple2(0, 'Please enter a name.')),
			A3(
			$author$project$Utils$Validate$ifIntGreaterThan,
			function ($) {
				return $.Iu;
			},
			$author$project$Components$Partner$Form$maxLogoBytesSize,
			_Utils_Tuple2(2, 'That image is too large! Our maximum image size is 5 mb, please choose a smaller image.')),
			$rtfeldman$elm_validate$Validate$fromErrors(
			A3(
				$author$project$Components$Partner$Form$validateUrlRequired,
				function ($) {
					return $.aev;
				},
				1,
				'Please enter a website URL.')),
			$rtfeldman$elm_validate$Validate$fromErrors(
			A3(
				$author$project$Components$Partner$Form$validateRequiredMaybeString,
				function ($) {
					return $.ac$;
				},
				4,
				'Please enter a technical email.')),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Partner$Form$validateAddress)
		]));
var $author$project$Api$Partner$Partner$Address = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Partner$Partner$WebsiteUrl = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$Form$toPermittedFields = function (fields) {
	return A2(
		$elm$core$List$cons,
		$author$project$Api$Partner$Partner$Name(fields.Bq),
		A2(
			$elm$core$List$cons,
			$author$project$Api$Partner$Partner$WebsiteUrl(fields.aev),
			A2(
				$elm$core$List$cons,
				$author$project$Api$Partner$Partner$Email(fields.Rj),
				A2(
					$elm$core$List$cons,
					$author$project$Api$Partner$Partner$TechnicalEmail(
						A2($elm$core$Maybe$withDefault, '', fields.ac$)),
					A2(
						$elm$core$List$cons,
						$author$project$Api$Partner$Partner$UsesIntegrationRecords(fields.ad7),
						A2(
							$elm$core$List$cons,
							$author$project$Api$Partner$Partner$Address(
								A2($author$project$Components$AddressInput$encodeWithPrefix, '', fields.K2)),
							function () {
								var _v0 = fields.Wk;
								if (!_v0.$) {
									var logoUrl = _v0.a;
									return _List_fromArray(
										[
											$author$project$Api$Partner$Partner$Logo(logoUrl)
										]);
								} else {
									return _List_Nil;
								}
							}()))))));
};
var $author$project$Components$Partner$Form$validate = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.SD);
	var validatedAddress = $author$project$Components$AddressInput$validate(fields.K2);
	var updatedFields = _Utils_update(
		fields,
		{K2: validatedAddress});
	var updatedForm = A2($author$project$Utils$Form$set, updatedFields, model.SD);
	var _v1 = A2($author$project$Utils$Form$validate, $author$project$Components$Partner$Form$formFieldsValidatorAll, updatedForm);
	if (!_v1.$) {
		var _v2 = _v1.a;
		var validFormFields = _v2.b;
		var validFields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
		return $elm$core$Result$Ok(
			$author$project$Components$Partner$Form$toPermittedFields(validFields));
	} else {
		var validatedForm = _v1.a;
		return $elm$core$Result$Err(
			_Utils_update(
				model,
				{SD: validatedForm}));
	}
};
var $author$project$Pages$Partner$Dashboard$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = model.bJ;
				if (!_v1.$) {
					var partnerForm = _v1.a;
					var _v2 = A2($author$project$Components$Partner$Form$update, subMsg, partnerForm);
					var updatedForm = _v2.a;
					var cmd = _v2.b;
					var outMsgs = _v2.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bJ: $elm$core$Maybe$Just(updatedForm)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Dashboard$Top$PartnerFormMsg, cmd),
						outMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 1:
				var subMsg = msg.a;
				var baaFormResult = A3($author$project$Components$Partner$BaaForm$update, model.Gv, subMsg, model.dZ);
				var _v3 = baaFormResult.agZ;
				if (!_v3.$) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dZ: baaFormResult.aiO}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Dashboard$Top$BaaFormMsg, baaFormResult.GZ),
						baaFormResult.aR);
				} else {
					var partner = _v3.a;
					var _v4 = A3($author$project$Components$Partner$DocumentsAgreementsForm$init, model.Gv, model.J7, partner);
					var documentsAgreementsForm = _v4.a;
					var documentsAgreementsFormCmd = _v4.b;
					var nextModel = _Utils_update(
						model,
						{dZ: baaFormResult.aiO, dh: documentsAgreementsForm, YN: partner});
					return _Utils_Tuple3(
						_Utils_update(
							nextModel,
							{
								jH: $author$project$Pages$Partner$Dashboard$Top$autoAdvanceSections(nextModel)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Dashboard$Top$BaaFormMsg, baaFormResult.GZ),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Dashboard$Top$DocumentsAgreementsFormMsg, documentsAgreementsFormCmd)
								])),
						baaFormResult.aR);
				}
			case 2:
				var subMsg = msg.a;
				var documentsAgreementsFormResult = A3($author$project$Components$Partner$DocumentsAgreementsForm$update, model.Gv, subMsg, model.dh);
				var _v5 = documentsAgreementsFormResult.agZ;
				if (!_v5.$) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dh: documentsAgreementsFormResult.aiO}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Dashboard$Top$DocumentsAgreementsFormMsg, documentsAgreementsFormResult.GZ),
						documentsAgreementsFormResult.aR);
				} else {
					var partner = _v5.a;
					var _v6 = A2($author$project$Components$Partner$BaaForm$init, model.J7, partner);
					var baaForm = _v6.a;
					var baaFormCmd = _v6.b;
					var nextModel = _Utils_update(
						model,
						{dZ: baaForm, dh: documentsAgreementsFormResult.aiO, YN: partner});
					return _Utils_Tuple3(
						_Utils_update(
							nextModel,
							{
								jH: $author$project$Pages$Partner$Dashboard$Top$autoAdvanceSections(nextModel)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Dashboard$Top$DocumentsAgreementsFormMsg, documentsAgreementsFormResult.GZ),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Dashboard$Top$BaaFormMsg, baaFormCmd)
								])),
						documentsAgreementsFormResult.aR);
				}
			case 3:
				var _v7 = model.bJ;
				if (!_v7.$) {
					var partnerForm = _v7.a;
					var _v8 = $author$project$Components$Partner$Form$validate(partnerForm);
					if (!_v8.$) {
						var permittedFields = _v8.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{qP: $author$project$Api$Data$Loading}),
							A3($author$project$Api$Partner$Partner$update, model.Gv, permittedFields, $author$project$Pages$Partner$Dashboard$Top$GotUpdatedPartner),
							_List_Nil);
					} else {
						var updatedForm = _v8.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bJ: $elm$core$Maybe$Just(updatedForm),
									qP: $author$project$Api$Data$NotAsked
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					var partner = response.a;
					var onboarded = $author$project$Pages$Partner$Dashboard$Top$isPartnerOnboarded(partner);
					var partnerForm = onboarded ? $elm$core$Maybe$Nothing : model.bJ;
					var _v10 = A3($author$project$Components$Partner$DocumentsAgreementsForm$init, model.Gv, model.J7, partner);
					var documentsAgreementsForm = _v10.a;
					var documentsAgreementsFormCmd = _v10.b;
					var _v11 = A2($author$project$Components$Partner$BaaForm$init, model.J7, partner);
					var baaForm = _v11.a;
					var baaFormCmd = _v11.b;
					var nextModel = _Utils_update(
						model,
						{
							dZ: baaForm,
							fL: A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$andThen,
									$author$project$Api$Partner$PartnerProduct$Shared$backlinkUrl,
									$author$project$Api$Partner$Partner$One$product(partner))),
							dh: documentsAgreementsForm,
							Cb: onboarded,
							YN: partner,
							bJ: partnerForm,
							qP: response
						});
					return _Utils_Tuple3(
						_Utils_update(
							nextModel,
							{
								jH: $author$project$Pages$Partner$Dashboard$Top$autoAdvanceSections(nextModel)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Dashboard$Top$BaaFormMsg, baaFormCmd),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Dashboard$Top$DocumentsAgreementsFormMsg, documentsAgreementsFormCmd)
								])),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Partner updated successfully!'),
								$author$project$OutMsg$RefreshPartner
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{qP: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 5:
				var _v12 = $author$project$Components$Partner$Form$init(model.YN);
				var partnerForm = _v12.a;
				var partnerFormCmd = _v12.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bJ: $elm$core$Maybe$Just(partnerForm)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Dashboard$Top$PartnerFormMsg, partnerFormCmd),
					_List_Nil);
			case 6:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bJ: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 7:
				var id = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{k2: $author$project$Api$Data$Loading}),
					A3($author$project$Api$Partner$PartnerProduct$requestReview, model.Gv, id, $author$project$Pages$Partner$Dashboard$Top$GotReviewResponse),
					_List_Nil);
			case 8:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k2: response}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Review requested! The Hint team will review your listing shortly.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k2: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 9:
				var url = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{fL: url}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 10:
				var _v14 = $author$project$Api$Partner$Partner$One$product(model.YN);
				if (!_v14.$) {
					var product = _v14.a;
					var url = $elm$core$String$isEmpty(
						$elm$core$String$trim(model.fL)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						$elm$core$String$trim(model.fL));
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{mq: $author$project$Api$Data$Loading}),
						A4(
							$author$project$Api$Partner$PartnerProduct$update,
							model.Gv,
							$author$project$Api$Partner$PartnerProduct$Shared$id(product),
							_List_fromArray(
								[
									$author$project$Api$Partner$PartnerProduct$BacklinkUrl(url)
								]),
							$author$project$Pages$Partner$Dashboard$Top$GotBacklinkUrlResponse),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 11:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{mq: response}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Listing link saved!'),
								$author$project$OutMsg$RefreshPartner
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{mq: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var url = msg.a;
				return _Utils_Tuple3(
					model,
					$author$project$Ports$Clipboard$copy(url),
					_List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 3, 'Listing URL copied to clipboard!')
						]));
		}
	});
var $author$project$Components$Partner$BaaForm$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$BaaForm$OpenCustomBaaAgreement = {$: 3};
var $author$project$Components$Partner$AgreementPanel$Pending = {$: 1};
var $author$project$Components$Partner$AgreementPanel$Resolved = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Partner$AgreementPanel$Signed = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Partner$User$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Partner$DocumentAgreement$Shared$signedAt = function (_v0) {
	var record = _v0;
	return record.abu;
};
var $author$project$Api$Partner$DocumentAgreement$Shared$user = function (_v0) {
	var record = _v0;
	return record.ad0;
};
var $author$project$Components$Partner$AgreementPanel$fromAgreement = F2(
	function (timeFormatter, maybeAgreement) {
		if (!maybeAgreement.$) {
			var agreement = maybeAgreement.a;
			return $author$project$Components$Partner$AgreementPanel$Signed(
				{
					co: $author$project$Api$Partner$User$Shared$name(
						$author$project$Api$Partner$DocumentAgreement$Shared$user(agreement)),
					Yb: A2(
						timeFormatter,
						6,
						$author$project$Api$Partner$DocumentAgreement$Shared$signedAt(agreement))
				});
		} else {
			return $author$project$Components$Partner$AgreementPanel$Pending;
		}
	});
var $author$project$Components$Partner$BaaForm$baaStatus = function (model) {
	var _v0 = $author$project$Api$Partner$Partner$One$baaType(model.YN);
	if (!_v0.$) {
		if (_v0.a === 1) {
			var _v1 = _v0.a;
			return $author$project$Components$Partner$AgreementPanel$Resolved('Selected — Independent');
		} else {
			var _v2 = _v0.a;
			return A2(
				$author$project$Components$Partner$AgreementPanel$fromAgreement,
				model.J7,
				$author$project$Api$Partner$Partner$One$baaDocumentAgreement(model.YN));
		}
	} else {
		return $author$project$Components$Partner$AgreementPanel$Pending;
	}
};
var $author$project$Api$Partner$Partner$One$customBaaAgreementFileName = function (_v0) {
	var record = _v0.b;
	return record.Pl;
};
var $author$project$Utils$HintUrls$partnerBaaUrl = 'https://www.hint.com/partnerbaa';
var $author$project$Ui$OrderedList$Roman = 0;
var $author$project$Ui$OrderedList$roman = 0;
var $author$project$Components$Partner$AgreementPanel$badgeFor = function (status) {
	switch (status.$) {
		case 0:
			return A2(
				$author$project$Ui$Badge$fromString,
				_List_fromArray(
					[$author$project$Ui$Badge$success]),
				'Signed');
		case 3:
			return A2(
				$author$project$Ui$Badge$fromString,
				_List_fromArray(
					[$author$project$Ui$Badge$info]),
				'Selected');
		case 1:
			return A2(
				$author$project$Ui$Badge$fromString,
				_List_fromArray(
					[$author$project$Ui$Badge$warning]),
				'Pending Signature');
		default:
			return A2(
				$author$project$Ui$Badge$fromString,
				_List_fromArray(
					[$author$project$Ui$Badge$warning]),
				'Sign required');
	}
};
var $author$project$Ui$Panel$Warning = 3;
var $author$project$Ui$Panel$warning = $author$project$Ui$Panel$Styling(3);
var $author$project$Components$Partner$AgreementPanel$panelOptions = function (status) {
	if (status.$ === 2) {
		return _List_fromArray(
			[$author$project$Ui$Panel$warning]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Partner$AgreementPanel$statusIcon = function (status) {
	if (status.$ === 2) {
		return $author$project$Ui$Icon$warning(
			_List_fromArray(
				[$author$project$Ui$Icon$danger]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Partner$AgreementPanel$subtitleFor = function (status) {
	switch (status.$) {
		case 0:
			var by = status.a.co;
			var on = status.a.Yb;
			return A2(
				$author$project$Ui$Typography$text,
				_List_fromArray(
					[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
				'Signed by ' + (by + (' on ' + on)));
		case 3:
			var label = status.a;
			return A2(
				$author$project$Ui$Typography$text,
				_List_fromArray(
					[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
				label);
		case 1:
			return $author$project$Utils$Html$empty;
		default:
			return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Partner$AgreementPanel$view = function (_v0) {
	var title = _v0.ac9;
	var status = _v0.alH;
	var body = _v0.fO;
	var complete = function () {
		switch (status.$) {
			case 0:
				return true;
			case 3:
				return true;
			case 1:
				return false;
			default:
				return false;
		}
	}();
	return A2(
		$author$project$Ui$Panel$view,
		A2(
			$elm$core$List$cons,
			$author$project$Ui$Panel$collapsed(complete),
			$author$project$Components$Partner$AgreementPanel$panelOptions(status)),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_fromArray(
					[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap4]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
						_List_fromArray(
							[
								$author$project$Components$Partner$AgreementPanel$statusIcon(status),
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap]),
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text(title)
											])),
										$author$project$Components$Partner$AgreementPanel$subtitleFor(status)
									]))
							])),
						$author$project$Components$Partner$AgreementPanel$badgeFor(status)
					])),
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[body]))
			]));
};
var $author$project$Components$Partner$BaaForm$BaaType = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$Radio$Card = {$: 6};
var $author$project$Ui$Form$Radio$card = $author$project$Ui$Form$Radio$Card;
var $author$project$Ui$Typography$FullWidth = {$: 26};
var $author$project$Ui$Typography$fullWidth = $author$project$Ui$Typography$FullWidth;
var $author$project$Components$Partner$BaaForm$viewBaaTypeButton = F2(
	function (currentBaaType, baaType) {
		var _v0 = function () {
			if (!baaType) {
				return _Utils_Tuple2(
					'Subcontractor Business Associate (Under Hint’s BAA)',
					_List_fromArray(
						['You will enter into a Business Associate Agreement with Hint as a subcontractor business associate. This BAA will govern your access to and use of Protected Health Information (PHI) in connection with joint customers.', 'Under this model, Hint maintains BAAs with Covered Entities, and you operate as Hint’s subcontractor.']));
			} else {
				return _Utils_Tuple2(
					'Independent Business Associate (Direct BAAs with Covered Entities)',
					_List_fromArray(
						['You will not enter into a BAA with Hint. If you create, receive, maintain, or transmit Protected Health Information on behalf of your customers, you are responsible for determining whether you are a Business Associate and for entering into any required Business Associate Agreements directly with those Covered Entities.', 'Hint will not be a party to, or responsible for, any such agreements.', 'If your product is made available through the Hint Marketplace, Hint can facilitate the presentation and execution of your BAA (or other required terms) directly between you and participating practices during the onboarding and installation process.']));
			}
		}();
		var label = _v0.a;
		var notes = _v0.b;
		return A2(
			$author$project$Ui$Grid$column,
			_List_fromArray(
				[
					$author$project$Ui$Grid$span(6)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Radio$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Radio$card,
							$author$project$Ui$Form$Radio$value(
							_Utils_eq(
								currentBaaType,
								$elm$core$Maybe$Just(baaType))),
							$author$project$Ui$Form$Radio$onCheck(
							$elm$core$Basics$always(
								$author$project$Components$Partner$BaaForm$FormUpdated(
									$author$project$Components$Partner$BaaForm$BaaType(baaType))))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$titleSm,
									_List_fromArray(
										[$author$project$Ui$Typography$fullWidth]),
									_List_fromArray(
										[
											$elm$html$Html$text(label)
										])),
									A2(
									$elm$html$Html$ul,
									_List_Nil,
									A2(
										$elm$core$List$map,
										function (note) {
											return A2(
												$elm$html$Html$li,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$text,
														_List_fromArray(
															[$author$project$Ui$Typography$small, $author$project$Ui$Typography$helpBlock]),
														note)
													]));
										},
										notes))
								]))
						]))
				]));
	});
var $author$project$Components$Partner$BaaForm$Save = {$: 1};
var $author$project$Components$Partner$BaaForm$viewSaveSection = function (model) {
	var fields = $author$project$Utils$Form$fields(model.SD);
	var hasChanges = !_Utils_eq(
		fields.Ms,
		$author$project$Api$Partner$Partner$One$baaType(model.YN));
	return hasChanges ? A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$mt4]),
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Save BAA selection'},
				_List_fromArray(
					[
						$author$project$Ui$Button$primary,
						$author$project$Ui$Button$onClick($author$project$Components$Partner$BaaForm$Save),
						$author$project$Ui$Button$loading(
						_Utils_eq(model.qP, $author$project$Api$Data$Loading))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Save')
					]))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Components$Partner$BaaForm$panelBody = function (model) {
	var fields = $author$project$Utils$Form$fields(model.SD);
	var baaAgreementLink = function () {
		var _v4 = $author$project$Api$Partner$Partner$One$customBaaAgreementFileName(model.YN);
		if (!_v4.$) {
			return A3(
				$author$project$Ui$Button$view,
				{mm: 'View Business Associate Agreement'},
				_List_fromArray(
					[
						$author$project$Ui$Button$link,
						$author$project$Ui$Button$onClick($author$project$Components$Partner$BaaForm$OpenCustomBaaAgreement)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Business Associate Agreement')
					]));
		} else {
			return A3(
				$author$project$Ui$Link$externalHref,
				$author$project$Utils$HintUrls$partnerBaaUrl,
				_List_fromArray(
					[$author$project$Ui$Link$targetBlank]),
				_List_fromArray(
					[
						$elm$html$Html$text('Business Associate Agreement')
					]));
		}
	}();
	return $author$project$Components$Partner$AgreementPanel$view(
		{
			fO: A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Components$Partner$BaaForm$viewBaaTypeButton, fields.Ms, 0),
								A2($author$project$Components$Partner$BaaForm$viewBaaTypeButton, fields.Ms, 1)
							])),
						A2(
						$author$project$Ui$Grid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$span(12)
									]),
								_List_fromArray(
									[
										function () {
										var _v0 = _Utils_Tuple2(
											fields.Ms,
											$author$project$Api$Partner$Partner$One$baaDocumentAgreement(model.YN));
										if ((!_v0.a.$) && (!_v0.a.a)) {
											if (!_v0.b.$) {
												var _v1 = _v0.a.a;
												return A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2, $author$project$Ui$Element$mt2]),
													_List_fromArray(
														[
															$elm$html$Html$text('View the '),
															baaAgreementLink,
															$elm$html$Html$text('.')
														]));
											} else {
												var _v2 = _v0.a.a;
												var _v3 = _v0.b;
												return A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap4, $author$project$Ui$Element$mt2]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Element$view,
															_List_fromArray(
																[$author$project$Ui$Element$textSm]),
															_List_fromArray(
																[
																	$elm$html$Html$text('By selecting \"I Agree,\" you:'),
																	A2(
																	$author$project$Ui$OrderedList$view,
																	_List_fromArray(
																		[$author$project$Ui$OrderedList$roman]),
																	_List_fromArray(
																		[
																			A2(
																			$author$project$Ui$OrderedList$item,
																			_List_Nil,
																			_List_fromArray(
																				[
																					$elm$html$Html$text('confirm that you have read and agree to Hint\'s '),
																					baaAgreementLink
																				])),
																			A2(
																			$author$project$Ui$OrderedList$item,
																			_List_Nil,
																			_List_fromArray(
																				[
																					$elm$html$Html$text('represent and warrant that you are an authorized representative of '),
																					A2(
																					$author$project$Ui$Typography$strong,
																					_List_Nil,
																					_List_fromArray(
																						[
																							$elm$html$Html$text(
																							$author$project$Api$Partner$Partner$One$name(model.YN))
																						])),
																					$elm$html$Html$text(' with full authority to legally bind the entity to this Agreement; and')
																				])),
																			A2(
																			$author$project$Ui$OrderedList$item,
																			_List_Nil,
																			_List_fromArray(
																				[
																					$elm$html$Html$text('agree that this electronic acceptance constitutes a legally binding agreement between Hint Health, Inc. and '),
																					A2(
																					$author$project$Ui$Typography$strong,
																					_List_Nil,
																					_List_fromArray(
																						[
																							$elm$html$Html$text(
																							$author$project$Api$Partner$Partner$One$name(model.YN))
																						])),
																					$elm$html$Html$text(', effective as of the date of acceptance.')
																				]))
																		])),
																	$elm$html$Html$text('You further agree that your electronic acceptance on behalf of '),
																	A2(
																	$author$project$Ui$Typography$strong,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Api$Partner$Partner$One$name(model.YN))
																		])),
																	$elm$html$Html$text(' has the same legal effect as a handwritten signature and satisfies any requirement that the Agreement be in writing.')
																])),
															A3(
															$author$project$Ui$Button$view,
															{mm: 'I Agree to Business Associate Agreement'},
															_List_fromArray(
																[
																	$author$project$Ui$Button$primary,
																	$author$project$Ui$Button$onClick(
																	$author$project$Components$Partner$BaaForm$FormUpdated(
																		$author$project$Components$Partner$BaaForm$BaaAccepted(true)))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('I Agree')
																]))
														]));
											}
										} else {
											return $author$project$Utils$Html$empty;
										}
									}(),
										$author$project$Utils$FormErrors$view(
										A2($author$project$Utils$Form$validationErrors, 0, model.SD)),
										$author$project$Utils$FormErrors$view(
										A2($author$project$Utils$Form$validationErrors, 1, model.SD))
									]))
							])),
						$author$project$Components$Partner$BaaForm$viewSaveSection(model)
					])),
			alH: $author$project$Components$Partner$BaaForm$baaStatus(model),
			ac9: 'Business Associate Agreement'
		});
};
var $author$project$Components$Partner$BaaForm$viewBody = function (_v0) {
	var model = _v0;
	return $author$project$Components$Partner$BaaForm$panelBody(model);
};
var $author$project$Components$Partner$DocumentsAgreementsForm$AddendumAgreementAccepted = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$DocumentsAgreementsForm$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$DocumentsAgreementsForm$OpenAddendumAgreement = {$: 4};
var $author$project$Components$Partner$DocumentsAgreementsForm$viewSignedBody = function (agreementLink) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$itemsCenter]),
		_List_fromArray(
			[
				$elm$html$Html$text('View the '),
				agreementLink,
				$elm$html$Html$text('.')
			]));
};
var $author$project$Components$Partner$DocumentsAgreementsForm$viewAgreementTerms = F2(
	function (partner, agreementLink) {
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$textSm]),
			_List_fromArray(
				[
					$elm$html$Html$text('By selecting \"I Agree,\" you:'),
					A2(
					$author$project$Ui$OrderedList$view,
					_List_fromArray(
						[$author$project$Ui$OrderedList$roman]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$OrderedList$item,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('confirm that you have read and agree to Hint\'s '),
									agreementLink
								])),
							A2(
							$author$project$Ui$OrderedList$item,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('represent and warrant that you are an authorized representative of '),
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Partner$Partner$One$name(partner))
										])),
									$elm$html$Html$text(' with full authority to legally bind the entity to this Agreement; and')
								])),
							A2(
							$author$project$Ui$OrderedList$item,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('agree that this electronic acceptance constitutes a legally binding agreement between Hint Health, Inc. and '),
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Partner$Partner$One$name(partner))
										])),
									$elm$html$Html$text(', effective as of the date of acceptance.')
								]))
						])),
					$elm$html$Html$text('You further agree that your electronic acceptance on behalf of '),
					A2(
					$author$project$Ui$Typography$strong,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Partner$Partner$One$name(partner))
						])),
					$elm$html$Html$text(' has the same legal effect as a handwritten signature and satisfies any requirement that the Agreement be in writing.')
				]));
	});
var $author$project$Components$Partner$DocumentsAgreementsForm$viewUnsignedAgreement = F3(
	function (partner, agreementLink, agreeMsg) {
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap4]),
			_List_fromArray(
				[
					A2($author$project$Components$Partner$DocumentsAgreementsForm$viewAgreementTerms, partner, agreementLink),
					A3(
					$author$project$Ui$Button$view,
					{mm: 'I Agree'},
					_List_fromArray(
						[
							$author$project$Ui$Button$primary,
							$author$project$Ui$Button$onClick(agreeMsg)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('I Agree')
						]))
				]));
	});
var $author$project$Components$Partner$DocumentsAgreementsForm$viewAddendumAgreement = F2(
	function (timeFormatter, partner) {
		var _v0 = $author$project$Api$Partner$Partner$One$addendumAgreementFileName(partner);
		if (!_v0.$) {
			var agreementLink = A3(
				$author$project$Ui$Button$view,
				{mm: 'View addendum agreement'},
				_List_fromArray(
					[
						$author$project$Ui$Button$link,
						$author$project$Ui$Button$onClick($author$project$Components$Partner$DocumentsAgreementsForm$OpenAddendumAgreement)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Addendum Agreement')
					]));
			var agreement = $author$project$Api$Partner$Partner$One$addendumDocumentAgreement(partner);
			return $author$project$Components$Partner$AgreementPanel$view(
				{
					fO: function () {
						if (!agreement.$) {
							return $author$project$Components$Partner$DocumentsAgreementsForm$viewSignedBody(agreementLink);
						} else {
							return A3(
								$author$project$Components$Partner$DocumentsAgreementsForm$viewUnsignedAgreement,
								partner,
								agreementLink,
								$author$project$Components$Partner$DocumentsAgreementsForm$FormUpdated(
									$author$project$Components$Partner$DocumentsAgreementsForm$AddendumAgreementAccepted(true)));
						}
					}(),
					alH: A2($author$project$Components$Partner$AgreementPanel$fromAgreement, timeFormatter, agreement),
					ac9: 'Addendum Agreement'
				});
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$Partner$DocumentsAgreementsForm$ApiAccessAgreementAccepted = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$DocumentsAgreementsForm$OpenCustomApiAccessAgreement = {$: 3};
var $author$project$Utils$HintUrls$apiAccessAgreementUrl = 'https://www.hint.com/api-access-agreement';
var $author$project$Api$Partner$Partner$One$customApiAccessAgreementFileName = function (_v0) {
	var record = _v0.b;
	return record.Pk;
};
var $author$project$Components$Partner$DocumentsAgreementsForm$viewApiAccessAgreement = F2(
	function (timeFormatter, partner) {
		var agreementLink = function () {
			var _v1 = $author$project$Api$Partner$Partner$One$customApiAccessAgreementFileName(partner);
			if (!_v1.$) {
				return A3(
					$author$project$Ui$Button$view,
					{mm: 'View API access agreement'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$onClick($author$project$Components$Partner$DocumentsAgreementsForm$OpenCustomApiAccessAgreement)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('API Access Agreement')
						]));
			} else {
				return A3(
					$author$project$Ui$Link$externalHref,
					$author$project$Utils$HintUrls$apiAccessAgreementUrl,
					_List_fromArray(
						[$author$project$Ui$Link$targetBlank]),
					_List_fromArray(
						[
							$elm$html$Html$text('API Access Agreement')
						]));
			}
		}();
		var agreement = $author$project$Api$Partner$Partner$One$apiAccessDocumentAgreement(partner);
		return $author$project$Components$Partner$AgreementPanel$view(
			{
				fO: function () {
					if (!agreement.$) {
						return $author$project$Components$Partner$DocumentsAgreementsForm$viewSignedBody(agreementLink);
					} else {
						return A3(
							$author$project$Components$Partner$DocumentsAgreementsForm$viewUnsignedAgreement,
							partner,
							agreementLink,
							$author$project$Components$Partner$DocumentsAgreementsForm$FormUpdated(
								$author$project$Components$Partner$DocumentsAgreementsForm$ApiAccessAgreementAccepted(true)));
					}
				}(),
				alH: A2($author$project$Components$Partner$AgreementPanel$fromAgreement, timeFormatter, agreement),
				ac9: 'API Access Agreement'
			});
	});
var $author$project$Components$Partner$DocumentsAgreementsForm$OpenCustomPartnerAgreement = {$: 2};
var $author$project$Components$Partner$DocumentsAgreementsForm$PartnerAgreementAccepted = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Partner$Partner$One$customPartnerAgreementFileName = function (_v0) {
	var record = _v0.b;
	return record.Pr;
};
var $author$project$Components$Partner$DocumentsAgreementsForm$viewPartnerAgreement = F2(
	function (timeFormatter, partner) {
		var agreementLink = function () {
			var _v1 = $author$project$Api$Partner$Partner$One$customPartnerAgreementFileName(partner);
			if (!_v1.$) {
				return A3(
					$author$project$Ui$Button$view,
					{mm: 'View partner agreement'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$onClick($author$project$Components$Partner$DocumentsAgreementsForm$OpenCustomPartnerAgreement)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Partner Agreement')
						]));
			} else {
				return A3(
					$author$project$Ui$Link$externalHref,
					$author$project$Utils$HintUrls$partnerAgreementUrl,
					_List_fromArray(
						[$author$project$Ui$Link$targetBlank]),
					_List_fromArray(
						[
							$elm$html$Html$text('Partner Agreement')
						]));
			}
		}();
		var agreement = $author$project$Api$Partner$Partner$One$partnerDocumentAgreement(partner);
		return $author$project$Components$Partner$AgreementPanel$view(
			{
				fO: function () {
					if (!agreement.$) {
						return $author$project$Components$Partner$DocumentsAgreementsForm$viewSignedBody(agreementLink);
					} else {
						return A3(
							$author$project$Components$Partner$DocumentsAgreementsForm$viewUnsignedAgreement,
							partner,
							agreementLink,
							$author$project$Components$Partner$DocumentsAgreementsForm$FormUpdated(
								$author$project$Components$Partner$DocumentsAgreementsForm$PartnerAgreementAccepted(true)));
					}
				}(),
				alH: A2($author$project$Components$Partner$AgreementPanel$fromAgreement, timeFormatter, agreement),
				ac9: 'Partner Agreement'
			});
	});
var $author$project$Components$Partner$AgreementPanel$NeedsResign = {$: 2};
var $author$project$Components$Partner$DocumentsAgreementsForm$ServiceFeeAgreementAccepted = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Partner$Partner$One$serviceFeeReSignatureRequired = function (_v0) {
	var record = _v0.b;
	return record.aa2;
};
var $author$project$Components$Partner$DocumentsAgreementsForm$viewReSignAlert = F2(
	function (timeFormatter, rule) {
		return A2(
			$author$project$Ui$Alert$warning,
			_List_fromArray(
				[$author$project$Ui$Alert$textLeft]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Updated — signature required')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							'Your Service Fee terms were updated on ' + (A2(timeFormatter, 6, rule.agH) + '. Please review and sign below.'))
						]))
				]));
	});
var $author$project$Components$Partner$DocumentsAgreementsForm$viewServiceFeeAgreementTerms = function (partner) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$textSm]),
		_List_fromArray(
			[
				$elm$html$Html$text('By selecting \"I Agree,\" you:'),
				A2(
				$author$project$Ui$OrderedList$view,
				_List_fromArray(
					[$author$project$Ui$OrderedList$roman]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$OrderedList$item,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('confirm you have read and agree to these Service Fee terms as shown in the billing section of the Partner Portal;')
							])),
						A2(
						$author$project$Ui$OrderedList$item,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('represent that you are authorized to legally bind '),
								A2(
								$author$project$Ui$Typography$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Api$Partner$Partner$One$name(partner))
									])),
								$elm$html$Html$text(' to these terms; and')
							])),
						A2(
						$author$project$Ui$OrderedList$item,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('agree that your electronic acceptance constitutes a legally binding acknowledgment, effective as of the date of acceptance.')
							]))
					]))
			]));
};
var $author$project$Components$Partner$DocumentsAgreementsForm$viewServiceFeeAgreement = F3(
	function (timeFormatter, partner, billingData) {
		var _v0 = $author$project$Components$Partner$DocumentsAgreementsForm$firstRule(billingData);
		if (!_v0.$) {
			var rule = _v0.a;
			var signButton = A3(
				$author$project$Ui$Button$view,
				{mm: 'I Agree to the Service Fee'},
				_List_fromArray(
					[
						$author$project$Ui$Button$primary,
						$author$project$Ui$Button$onClick(
						$author$project$Components$Partner$DocumentsAgreementsForm$FormUpdated(
							$author$project$Components$Partner$DocumentsAgreementsForm$ServiceFeeAgreementAccepted(true)))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('I Agree')
					]));
			var signSection = _List_fromArray(
				[
					$author$project$Components$Partner$DocumentsAgreementsForm$viewServiceFeeAgreementTerms(partner),
					signButton
				]);
			var needsResign = $author$project$Api$Partner$Partner$One$serviceFeeReSignatureRequired(partner);
			var feePanel = $author$project$Components$Partner$ServiceFeePanel$view(
				{ak6: rule, J7: timeFormatter});
			var agreement = $author$project$Api$Partner$Partner$One$serviceFeeDocumentAgreement(partner);
			var body = function () {
				if (needsResign) {
					return A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap4]),
						A2(
							$elm$core$List$cons,
							A2($author$project$Components$Partner$DocumentsAgreementsForm$viewReSignAlert, timeFormatter, rule),
							A2($elm$core$List$cons, feePanel, signSection)));
				} else {
					if (!agreement.$) {
						return feePanel;
					} else {
						return A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap4]),
							A2($elm$core$List$cons, feePanel, signSection));
					}
				}
			}();
			var status = needsResign ? $author$project$Components$Partner$AgreementPanel$NeedsResign : A2($author$project$Components$Partner$AgreementPanel$fromAgreement, timeFormatter, agreement);
			return $author$project$Components$Partner$AgreementPanel$view(
				{fO: body, alH: status, ac9: 'Service Fee Agreement'});
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$Partner$DocumentsAgreementsForm$panelList = function (model) {
	return _List_fromArray(
		[
			_Utils_eq(
			$author$project$Api$Partner$Partner$One$managedBy(model.YN),
			$elm$core$Maybe$Nothing) ? A2($author$project$Components$Partner$DocumentsAgreementsForm$viewPartnerAgreement, model.J7, model.YN) : $author$project$Utils$Html$empty,
			_Utils_eq(
			$author$project$Api$Partner$Partner$One$managedBy(model.YN),
			$elm$core$Maybe$Nothing) ? A2($author$project$Components$Partner$DocumentsAgreementsForm$viewAddendumAgreement, model.J7, model.YN) : $author$project$Utils$Html$empty,
			(!_Utils_eq(
			$author$project$Api$Partner$Partner$One$managedBy(model.YN),
			$elm$core$Maybe$Nothing)) ? A2($author$project$Components$Partner$DocumentsAgreementsForm$viewApiAccessAgreement, model.J7, model.YN) : $author$project$Utils$Html$empty,
			A3($author$project$Components$Partner$DocumentsAgreementsForm$viewServiceFeeAgreement, model.J7, model.YN, model.rt)
		]);
};
var $author$project$Components$Partner$DocumentsAgreementsForm$viewPanels = function (_v0) {
	var model = _v0;
	return $author$project$Components$Partner$DocumentsAgreementsForm$panelList(model);
};
var $author$project$Pages$Partner$Dashboard$Top$viewAgreementsContent = function (model) {
	var baaSection = function () {
		var _v0 = $author$project$Api$Partner$Partner$One$managedBy(model.YN);
		if (!_v0.$) {
			return _List_Nil;
		} else {
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Pages$Partner$Dashboard$Top$BaaFormMsg,
					$author$project$Components$Partner$BaaForm$viewBody(model.dZ))
				]);
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_Utils_ap(
			A2(
				$elm$core$List$map,
				$elm$html$Html$map($author$project$Pages$Partner$Dashboard$Top$DocumentsAgreementsFormMsg),
				$author$project$Components$Partner$DocumentsAgreementsForm$viewPanels(model.dh)),
			baaSection));
};
var $author$project$Pages$Partner$Dashboard$Top$CancelEdit = {$: 6};
var $author$project$Pages$Partner$Dashboard$Top$EditClicked = {$: 5};
var $author$project$Pages$Partner$Dashboard$Top$Save = {$: 3};
var $author$project$Components$Partner$Form$Minimal = 0;
var $author$project$Components$Partner$Form$minimal = 0;
var $author$project$Components$Partner$Form$Email = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Partner$Form$EmailValidation = 3;
var $author$project$Components$Partner$Form$LogoUploaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$Form$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$Form$TechnicalEmail = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Partner$Form$UsesIntegrationRecords = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Partner$Form$WebsiteUrl = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$Form$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, acc) {
				return _Utils_update(
					acc,
					{gW: true});
			}),
		{gW: false},
		options);
};
var $author$project$Components$Partner$Form$view = F2(
	function (options, _v0) {
		var model = _v0;
		var optionsRecord = $author$project$Components$Partner$Form$optionsToRecord(options);
		var unlessMinimal = function (field) {
			return optionsRecord.gW ? $elm$html$Html$text('') : field;
		};
		var isManaged = !_Utils_eq(
			$author$project$Api$Partner$Partner$One$managedBy(model.YN),
			$elm$core$Maybe$Nothing);
		var fields = $author$project$Utils$Form$fields(model.SD);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpanSm(4),
							$author$project$Ui$Form$Group$inputSpanSm(8),
							$author$project$Ui$Form$Group$label('Legal Name'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(fields.Bq),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$Partner$Form$FormUpdated, $author$project$Components$Partner$Form$Name)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, model.SD)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 0, model.SD))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpanSm(4),
							$author$project$Ui$Form$Group$inputSpanSm(8),
							$author$project$Ui$Form$Group$label('Legal Address'),
							$author$project$Ui$Form$Group$required(!optionsRecord.gW)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							A2($elm$core$Basics$composeL, $author$project$Components$Partner$Form$FormUpdated, $author$project$Components$Partner$Form$Address),
							A2($author$project$Components$AddressInput$view, _List_Nil, fields.K2)),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 5, model.SD))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpanSm(4),
							$author$project$Ui$Form$Group$inputSpanSm(8),
							$author$project$Ui$Form$Group$label('Website URL'),
							$author$project$Ui$Form$Group$required(!optionsRecord.gW)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(
									A2($elm$core$Maybe$withDefault, '', fields.aev)),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$Partner$Form$FormUpdated, $author$project$Components$Partner$Form$WebsiteUrl)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 1, model.SD)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 1, model.SD))
								]))
						])),
					isManaged ? $author$project$Utils$Html$empty : A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$labelSpanSm(4),
									$author$project$Ui$Form$Group$inputSpanSm(8),
									$author$project$Ui$Form$Group$label('Logo (Horizontal)')
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$File$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$File$accept(0),
											$author$project$Ui$Form$File$onInput($author$project$Components$Partner$Form$LogoUploaded),
											$author$project$Ui$Form$File$empty(true)
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Preferred format: SVG or PNG')
												])),
											A2(
											$author$project$Ui$Element$view,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Aspect ratio: Horizontal (aproximately 3:1)')
												])),
											A2(
											$author$project$Ui$Element$view,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Minimum width: 300px')
												])),
											A2(
											$author$project$Ui$Element$view,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Content: May include your company name or wordmark')
												])),
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$mt2]),
											_List_fromArray(
												[
													$elm$html$Html$text('This asset may be used in larger layouts or future branding surfaces.')
												]))
										]))
								])),
							function () {
							var _v1 = fields.Pg;
							if (!_v1.$) {
								var url = _v1.a;
								return $elm$core$String$isEmpty(url) ? $author$project$Utils$Html$empty : A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$labelSpanSm(4),
											$author$project$Ui$Form$Group$inputSpanSm(8),
											$author$project$Ui$Form$Group$label('')
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Image$fromSrc,
											{LD: 'Logo'},
											url,
											_List_fromArray(
												[
													$author$project$Ui$Image$height(50)
												])),
											$author$project$Utils$FormErrors$view(
											A2($author$project$Utils$Form$validationErrors, 2, model.SD))
										]));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpanSm(4),
							$author$project$Ui$Form$Group$inputSpanSm(8),
							$author$project$Ui$Form$Group$label('Technical Notifications'),
							$author$project$Ui$Form$Group$required(!optionsRecord.gW)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(
									A2($elm$core$Maybe$withDefault, '', fields.ac$)),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$Partner$Form$FormUpdated, $author$project$Components$Partner$Form$TechnicalEmail)),
									$author$project$Ui$Form$Input$placeholder('contact@mypartner.com'),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 4, model.SD)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 4, model.SD))
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$mt2, $author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
							_List_fromArray(
								[
									$elm$html$Html$text('Email for technical alerts (e.g., webhook failures, outages, planned downtime); use a shared mailing list to avoid a single point of failure.')
								]))
						])),
					unlessMinimal(
					A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8),
								$author$project$Ui$Form$Group$label('Email'),
								$author$project$Ui$Form$Group$required(!optionsRecord.gW)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$value(
										A2($elm$core$Maybe$withDefault, '', fields.Rj)),
										$author$project$Ui$Form$Input$onInput(
										A2($elm$core$Basics$composeL, $author$project$Components$Partner$Form$FormUpdated, $author$project$Components$Partner$Form$Email)),
										$author$project$Ui$Form$Input$placeholder('contact@mypartner.com'),
										$author$project$Ui$Form$Input$phi(true),
										$author$project$Ui$Form$Input$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 3, model.SD)),
										$author$project$Ui$Form$Input$errors(
										A2($author$project$Utils$Form$validationErrors, 3, model.SD))
									]))
							]))),
					unlessMinimal(
					A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8),
								$author$project$Ui$Form$Group$label('Uses Integration Records')
							]),
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$view(
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$on(fields.ad7),
										$author$project$Ui$ToggleSwitch$onChange(
										A2($elm$core$Basics$composeL, $author$project$Components$Partner$Form$FormUpdated, $author$project$Components$Partner$Form$UsesIntegrationRecords))
									]))
							])))
				]));
	});
var $author$project$Ui$Icon$Location = 14;
var $author$project$Ui$Icon$location = $author$project$Ui$Icon$viewIcon(14);
var $author$project$Ui$Icon$Mail = 95;
var $author$project$Ui$Icon$mail = $author$project$Ui$Icon$viewIcon(95);
var $author$project$Pages$Partner$Dashboard$Top$viewAccount = function (partner) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$gap4, $author$project$Ui$Element$flexCol]),
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$html$Html$text(''),
				A2(
					$elm$core$Maybe$map,
					function (logoUrl) {
						return A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Image$fromSrc,
									{
										LD: $author$project$Api$Partner$Partner$One$name(partner) + ' logo'
									},
									logoUrl,
									_List_fromArray(
										[
											$author$project$Ui$Image$height(100)
										]))
								]));
					},
					$author$project$Api$Partner$Partner$One$logoUrl(partner))),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$html$Html$text(''),
				A2(
					$elm$core$Maybe$map,
					function (address) {
						return A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
							_List_fromArray(
								[
									$author$project$Ui$Icon$location(_List_Nil),
									$author$project$Components$AddressDisplay$view(address)
								]));
					},
					$author$project$Api$Partner$Partner$One$address(partner))),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$html$Html$text(''),
				A2(
					$elm$core$Maybe$map,
					function (url) {
						return A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
							_List_fromArray(
								[
									$author$project$Ui$Icon$translate(_List_Nil),
									A3(
									$author$project$Ui$Link$externalHref,
									url,
									_List_fromArray(
										[$author$project$Ui$Link$targetBlank]),
									_List_fromArray(
										[
											$elm$html$Html$text(url)
										]))
								]));
					},
					$author$project$Api$Partner$Partner$One$websiteUrl(partner))),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$html$Html$text(''),
				A2(
					$elm$core$Maybe$map,
					function (email) {
						return A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
							_List_fromArray(
								[
									$author$project$Ui$Icon$mail(_List_Nil),
									A3(
									$author$project$Ui$Link$mailto,
									email,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(email)
										]))
								]));
					},
					$author$project$Api$Partner$Partner$One$technicalEmail(partner)))
			]));
};
var $author$project$Pages$Partner$Dashboard$Top$viewCompanyDetailsContent = function (model) {
	var editing = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$always(true),
			model.bJ));
	return A2(
		$author$project$Ui$Form$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$autocomplete(false),
				$author$project$Ui$Form$noValidate(true),
				$author$project$Ui$Form$onSubmit($author$project$Pages$Partner$Dashboard$Top$Save)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_fromArray(
							[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
						editing ? _List_Nil : _List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Api$Partner$Partner$One$name(model.YN))
									])),
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Edit account'},
								_List_fromArray(
									[
										$author$project$Ui$Button$onClick($author$project$Pages$Partner$Dashboard$Top$EditClicked),
										$author$project$Ui$Button$sm,
										$author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Edit')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								function () {
								var _v0 = model.bJ;
								if (!_v0.$) {
									var partnerForm = _v0.a;
									return A2(
										$elm$html$Html$map,
										$author$project$Pages$Partner$Dashboard$Top$PartnerFormMsg,
										A2(
											$author$project$Components$Partner$Form$view,
											_List_fromArray(
												[$author$project$Components$Partner$Form$minimal]),
											partnerForm));
								} else {
									return $author$project$Pages$Partner$Dashboard$Top$viewAccount(model.YN);
								}
							}()
							])),
						function () {
						if (editing) {
							var loading = _Utils_eq(model.qP, $author$project$Api$Data$Loading);
							return A2(
								$author$project$Ui$Panel$footer,
								_List_fromArray(
									[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$mt2]),
								_List_fromArray(
									[
										model.Cb ? A3(
										$author$project$Ui$Button$view,
										{mm: 'Cancel editing'},
										_List_fromArray(
											[
												$author$project$Ui$Button$onClick($author$project$Pages$Partner$Dashboard$Top$CancelEdit)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cancel')
											])) : $elm$html$Html$text(''),
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Save partner changes'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$submit,
												$author$project$Ui$Button$loading(loading)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Save')
											]))
									]));
						} else {
							return $author$project$Ui$Panel$none;
						}
					}()
					]))
			]));
};
var $author$project$Api$Partner$PartnerProduct$Shared$builtByName = function (_v0) {
	var record = _v0;
	return record.MV;
};
var $author$project$Api$Partner$PartnerProduct$Shared$builtByUrl = function (_v0) {
	var record = _v0;
	return record.MW;
};
var $author$project$Api$Partner$PartnerProduct$Shared$featured = function (_v0) {
	var record = _v0;
	return record.Se;
};
var $author$project$Api$Partner$PartnerProduct$Shared$installsCount = function (_v0) {
	var record = _v0;
	return record.T5;
};
var $author$project$Api$Partner$PartnerProduct$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Partner$PartnerProduct$Shared$slug = function (_v0) {
	var record = _v0;
	return record.abG;
};
var $author$project$Api$Partner$PartnerProduct$Shared$type_ = function (_v0) {
	var record = _v0;
	return record.amg;
};
var $author$project$Ui$Card$Highlighted = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Card$highlighted = $author$project$Ui$Card$Highlighted;
var $author$project$Ui$Icon$Hourglass = 106;
var $author$project$Ui$Icon$hourglass = $author$project$Ui$Icon$viewIcon(106);
var $author$project$Components$Marketplace$ProductCard$installsLabel = function (product) {
	var _v0 = product.V7;
	switch (_v0) {
		case 2:
			return (product.aeo > 0) ? $elm$core$Maybe$Just(
				_Utils_Tuple2('waitlisted', product.aeo)) : $elm$core$Maybe$Nothing;
		case 3:
			return (product.aeo > 0) ? $elm$core$Maybe$Just(
				_Utils_Tuple2('waitlisted', product.aeo)) : $elm$core$Maybe$Nothing;
		case 4:
			return (product.aeo > 0) ? $elm$core$Maybe$Just(
				_Utils_Tuple2('waitlisted', product.aeo)) : $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Nothing;
		case 0:
			return $elm$core$Maybe$Nothing;
		default:
			if (product.T5 > 0) {
				var label = function () {
					var _v1 = product.amg;
					if (!_v1) {
						return 'installs';
					} else {
						return 'connected';
					}
				}();
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(label, product.T5));
			} else {
				return $elm$core$Maybe$Nothing;
			}
	}
};
var $author$project$Ui$Grid$itemsCenter = $author$project$Ui$Grid$Element($author$project$Ui$Element$itemsCenter);
var $author$project$Ui$Card$Link = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Card$linkTo = $author$project$Ui$Card$Link;
var $author$project$Ui$Card$Muted = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Card$muted = $author$project$Ui$Card$Muted;
var $author$project$Ui$Badge$AccentPrimary = 6;
var $author$project$Ui$Badge$accentPrimary = $author$project$Ui$Badge$Color(6);
var $author$project$Ui$Badge$AccentSecondary = 7;
var $author$project$Ui$Badge$accentSecondary = $author$project$Ui$Badge$Color(7);
var $author$project$Components$Marketplace$Product$Status$listingStatusOptions = function (status) {
	switch (status) {
		case 0:
			return _List_Nil;
		case 1:
			return _List_fromArray(
				[$author$project$Ui$Badge$neutral]);
		case 2:
			return _List_Nil;
		case 3:
			return _List_fromArray(
				[$author$project$Ui$Badge$accentPrimary]);
		case 4:
			return _List_fromArray(
				[$author$project$Ui$Badge$accentSecondary]);
		case 5:
			return _List_fromArray(
				[$author$project$Ui$Badge$success]);
		case 6:
			return _List_fromArray(
				[$author$project$Ui$Badge$warning]);
		case 7:
			return _List_fromArray(
				[$author$project$Ui$Badge$danger]);
		default:
			return _List_fromArray(
				[$author$project$Ui$Badge$danger]);
	}
};
var $author$project$Api$Common$Marketplace$Product$Status$toLabel = function (status) {
	switch (status) {
		case 0:
			return 'Hidden';
		case 1:
			return 'Unpublished';
		case 2:
			return 'Researching';
		case 3:
			return 'Coming Soon';
		case 4:
			return 'Beta';
		case 5:
			return 'Live';
		case 6:
			return 'Sunsetting';
		case 7:
			return 'Deprecated';
		default:
			return 'Decommissioned';
	}
};
var $author$project$Components$Marketplace$Product$Status$view = function (listingStatus) {
	return A2(
		$author$project$Ui$Badge$view,
		$author$project$Components$Marketplace$Product$Status$listingStatusOptions(listingStatus),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Api$Common$Marketplace$Product$Status$toLabel(listingStatus))
			]));
};
var $author$project$Components$Marketplace$ProductCard$viewIntegrationChip = function (product) {
	var _v0 = product.alH;
	if (!_v0.$) {
		switch (_v0.a) {
			case 'inactive':
				return A2(
					$author$project$Ui$Badge$view,
					_List_fromArray(
						[$author$project$Ui$Badge$neutral]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Common$Marketplace$Product$ProductType$toString(product.amg))
						]));
			case 'active':
				return A2(
					$author$project$Ui$Badge$view,
					_List_fromArray(
						[$author$project$Ui$Badge$success]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Common$Marketplace$Product$ProductType$toString(product.amg)),
							$author$project$Ui$Icon$check(_List_Nil)
						]));
			default:
				var status = _v0.a;
				return A2($author$project$Ui$Badge$fromString, _List_Nil, status);
		}
	} else {
		return A2(
			$author$project$Ui$Badge$view,
			_List_fromArray(
				[$author$project$Ui$Badge$neutral]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Api$Common$Marketplace$Product$ProductType$toString(product.amg))
				]));
	}
};
var $author$project$Components$Marketplace$ProductCard$view = F3(
	function (hinterMode, productRoute, product) {
		var listed = (!product.QN) && (!A2(
			$elm$core$List$member,
			product.V7,
			_List_fromArray(
				[1, 8])));
		return A2(
			$author$project$Ui$Card$view,
			_List_fromArray(
				[
					$author$project$Ui$Card$highlighted(product.Se),
					$author$project$Ui$Card$muted(hinterMode && (!listed)),
					$author$project$Ui$Card$linkTo(
					$author$project$Spa$Generated$Route$toString(productRoute))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(4),
									$author$project$Ui$Grid$itemsCenter,
									$author$project$Ui$Grid$justifyCenter
								]),
							_List_fromArray(
								[
									function () {
									var _v0 = product.TJ;
									if (!_v0.$) {
										var url = _v0.a;
										return A3(
											$author$project$Ui$Image$fromSrc,
											{LD: product.Bq + '\'s icon'},
											url,
											_List_fromArray(
												[
													$author$project$Ui$Image$width(64)
												]));
									} else {
										return $elm$html$Html$text('');
									}
								}()
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(8)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$mb4]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$itemsStart, $author$project$Ui$Element$spaceBetween]),
											_List_fromArray(
												[
													$author$project$Ui$Typography$headingSm(
													_List_fromArray(
														[
															$elm$html$Html$text(product.Bq)
														])),
													$author$project$Components$Marketplace$ProductCard$viewIntegrationChip(product)
												]))
										])),
									A3(
									$author$project$Ui$Element$custom,
									'max-h-24',
									_List_fromArray(
										[$author$project$Ui$Element$mb4]),
									_List_fromArray(
										[
											function () {
											var clampClass = function () {
												var _v1 = product.V7;
												if (_v1 === 5) {
													return 'line-clamp-3';
												} else {
													return 'line-clamp-2';
												}
											}();
											return A3(
												$author$project$Ui$Element$custom,
												clampClass,
												_List_fromArray(
													[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$mb2]),
												$elm$core$List$singleton(
													$elm$html$Html$text(
														A2($elm$core$Maybe$withDefault, '', product.acF))));
										}(),
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
											_List_fromArray(
												[
													function () {
													var _v2 = _Utils_Tuple2(hinterMode, product.V7);
													if ((!_v2.a) && (_v2.b === 5)) {
														var _v3 = _v2.b;
														return $elm$html$Html$text('');
													} else {
														return $author$project$Components$Marketplace$Product$Status$view(product.V7);
													}
												}(),
													function () {
													var _v4 = $author$project$Components$Marketplace$ProductCard$installsLabel(product);
													if (!_v4.$) {
														var _v5 = _v4.a;
														var label = _v5.a;
														var count = _v5.b;
														var icon = function () {
															var _v6 = product.V7;
															switch (_v6) {
																case 2:
																	return $author$project$Ui$Icon$hourglass(
																		_List_fromArray(
																			[$author$project$Ui$Icon$sm]));
																case 3:
																	return $author$project$Ui$Icon$hourglass(
																		_List_fromArray(
																			[$author$project$Ui$Icon$sm]));
																case 4:
																	return $author$project$Ui$Icon$hourglass(
																		_List_fromArray(
																			[$author$project$Ui$Icon$sm]));
																default:
																	return $author$project$Ui$Icon$export(
																		_List_fromArray(
																			[$author$project$Ui$Icon$sm]));
															}
														}();
														return A2(
															$author$project$Ui$Element$view,
															_List_fromArray(
																[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap, $author$project$Ui$Element$textSm]),
															_List_fromArray(
																[
																	icon,
																	$elm$html$Html$text(
																	$elm$core$String$fromInt(count) + (' ' + label))
																]));
													} else {
														return $elm$html$Html$text('');
													}
												}()
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Ui$Card$Disabled = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Card$disabled = $author$project$Ui$Card$Disabled;
var $author$project$Ui$Icon$mb3 = $author$project$Ui$Icon$SpacedBottom(3);
var $author$project$Pages$Partner$Dashboard$Top$viewNewProduct = function (model) {
	return A2(
		$author$project$Ui$Card$view,
		_List_fromArray(
			[
				$author$project$Ui$Card$linkTo(
				$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Partner__Products__New)),
				$author$project$Ui$Card$disabled(
				!_Utils_eq(
					$author$project$Api$Partner$Partner$One$product(model.YN),
					$elm$core$Maybe$Nothing))
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(12),
								$author$project$Ui$Grid$itemsCenter,
								$author$project$Ui$Grid$justifyCenter
							]),
						_List_fromArray(
							[
								$author$project$Ui$Icon$add(
								_List_fromArray(
									[$author$project$Ui$Icon$mb3, $author$project$Ui$Icon$xl])),
								$author$project$Ui$Typography$headingSm(
								_List_fromArray(
									[
										$elm$html$Html$text('Add Product')
									])),
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$mt2]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$text,
										_List_fromArray(
											[$author$project$Ui$Typography$muted]),
										'Create a new product listing for the marketplace')
									]))
							]))
					]))
			]));
};
var $author$project$Api$Partner$PartnerProduct$Shared$waitlistedCount = function (_v0) {
	var record = _v0;
	return record.aeo;
};
var $author$project$Pages$Partner$Dashboard$Top$viewProductSummaryCard = function (model) {
	var _v0 = $author$project$Api$Partner$Partner$One$product(model.YN);
	if (!_v0.$) {
		var product = _v0.a;
		var marketplaceProduct = {
			MV: $author$project$Api$Partner$PartnerProduct$Shared$builtByName(product),
			MW: $author$project$Api$Partner$PartnerProduct$Shared$builtByUrl(product),
			QN: $author$project$Api$Partner$PartnerProduct$Shared$distributionType(product),
			Se: $author$project$Api$Partner$PartnerProduct$Shared$featured(product),
			TJ: $author$project$Api$Partner$PartnerProduct$Shared$iconUrl(product),
			T5: $author$project$Api$Partner$PartnerProduct$Shared$installsCount(product),
			V7: $author$project$Api$Partner$PartnerProduct$Shared$status(product),
			Bq: $author$project$Api$Partner$PartnerProduct$Shared$name(product),
			abG: $author$project$Api$Partner$PartnerProduct$Shared$slug(product),
			alH: $elm$core$Maybe$Nothing,
			acF: $author$project$Api$Partner$PartnerProduct$Shared$summary(product),
			amg: $author$project$Api$Partner$PartnerProduct$Shared$type_(product),
			aeo: $author$project$Api$Partner$PartnerProduct$Shared$waitlistedCount(product)
		};
		return A3(
			$author$project$Ui$Element$custom,
			'marketplace-cards',
			_List_Nil,
			_List_fromArray(
				[
					A3(
					$author$project$Components$Marketplace$ProductCard$view,
					false,
					$author$project$Spa$Generated$Route$Partner__Products__Id_String(
						{
							ahP: $author$project$Api$Partner$PartnerProduct$Shared$id(product)
						}),
					marketplaceProduct)
				]));
	} else {
		return $author$project$Pages$Partner$Dashboard$Top$viewNewProduct(model);
	}
};
var $author$project$Pages$Partner$Dashboard$Top$completedStepCount = function (model) {
	return $elm$core$List$length(
		A2(
			$elm$core$List$filter,
			$author$project$Pages$Partner$Dashboard$Top$isStepComplete(model),
			$author$project$Pages$Partner$Dashboard$Top$allSteps(model.YN)));
};
var $author$project$Pages$Partner$Dashboard$Top$totalSteps = function (partner) {
	return $elm$core$List$length(
		$author$project$Pages$Partner$Dashboard$Top$allSteps(partner));
};
var $author$project$Pages$Partner$Dashboard$Top$viewProgressHeader = function (model) {
	var total = $author$project$Pages$Partner$Dashboard$Top$totalSteps(model.YN);
	var completed = $author$project$Pages$Partner$Dashboard$Top$completedStepCount(model);
	var percentage = (!total) ? 0 : (((completed * 100) / total) | 0);
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mb4]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$title,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Go Live in Marketplace')
									])),
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(completed) + (' of ' + ($elm$core$String$fromInt(total) + ' complete')))
									]))
							])),
						$author$project$Ui$ProgressBar$view(
						_List_fromArray(
							[
								$author$project$Ui$ProgressBar$width(percentage)
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$mt4]),
						_List_fromArray(
							[
								$elm$html$Html$text('Complete the steps below, then submit your listing for review.')
							]))
					]))
			]));
};
var $author$project$Pages$Partner$Dashboard$Top$viewLiveDashboardHeader = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$mb4, $author$project$Ui$Element$gap4]),
		_List_fromArray(
			[
				$author$project$Pages$Partner$Dashboard$Top$viewProductSummaryCard(model),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$flexAuto]),
				_List_fromArray(
					[
						$author$project$Pages$Partner$Dashboard$Top$viewProgressHeader(model)
					]))
			]));
};
var $author$project$Pages$Partner$Dashboard$Top$RequestReview = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Partner$Dashboard$Top$statusIcon = function (complete) {
	return complete ? $author$project$Ui$Icon$check(
		_List_fromArray(
			[$author$project$Ui$Icon$circled, $author$project$Ui$Icon$success])) : $author$project$Ui$Icon$circle(
		_List_fromArray(
			[$author$project$Ui$Icon$info, $author$project$Ui$Icon$xl]));
};
var $author$project$Pages$Partner$Dashboard$Top$viewProductChecklist = function (product) {
	var tileComplete = $author$project$Pages$Partner$Dashboard$Top$isMarketplaceCardComplete(product);
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
						_List_fromArray(
							[
								$author$project$Pages$Partner$Dashboard$Top$statusIcon(tileComplete),
								A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Marketplace card')
											])),
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
										_List_fromArray(
											[
												$elm$html$Html$text('Name, summary, and icon')
											]))
									]))
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$mt4]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
								_List_fromArray(
									[
										$author$project$Ui$Icon$edit(
										_List_fromArray(
											[$author$project$Ui$Icon$circled, $author$project$Ui$Icon$info])),
										A2(
										$author$project$Ui$Element$view,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Element$view,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Detail page')
													])),
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
												_List_fromArray(
													[
														$elm$html$Html$text('Overview, highlights, and details')
													]))
											]))
									])),
								A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Partner__Products__Id_String(
									{
										ahP: $author$project$Api$Partner$PartnerProduct$Shared$id(product)
									}),
								_List_fromArray(
									[
										$author$project$Ui$Link$icon($author$project$Ui$Icon$edit),
										$author$project$Ui$Link$sm
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Edit')
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Partner$Dashboard$Top$viewProductListingContent = function (model) {
	var _v0 = $author$project$Api$Partner$Partner$One$product(model.YN);
	if (!_v0.$) {
		var product = _v0.a;
		var published = $author$project$Pages$Partner$Dashboard$Top$isProductListingPublished(model.YN);
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap4]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap2]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Element$custom,
							'marketplace-cards',
							_List_Nil,
							_List_fromArray(
								[
									function () {
									var marketplaceProduct = {
										MV: $author$project$Api$Partner$PartnerProduct$Shared$builtByName(product),
										MW: $author$project$Api$Partner$PartnerProduct$Shared$builtByUrl(product),
										QN: $author$project$Api$Partner$PartnerProduct$Shared$distributionType(product),
										Se: $author$project$Api$Partner$PartnerProduct$Shared$featured(product),
										TJ: $author$project$Api$Partner$PartnerProduct$Shared$iconUrl(product),
										T5: $author$project$Api$Partner$PartnerProduct$Shared$installsCount(product),
										V7: $author$project$Api$Partner$PartnerProduct$Shared$status(product),
										Bq: $author$project$Api$Partner$PartnerProduct$Shared$name(product),
										abG: $author$project$Api$Partner$PartnerProduct$Shared$slug(product),
										alH: $elm$core$Maybe$Nothing,
										acF: $author$project$Api$Partner$PartnerProduct$Shared$summary(product),
										amg: $author$project$Api$Partner$PartnerProduct$Shared$type_(product),
										aeo: $author$project$Api$Partner$PartnerProduct$Shared$waitlistedCount(product)
									};
									return A3(
										$author$project$Components$Marketplace$ProductCard$view,
										false,
										$author$project$Spa$Generated$Route$Partner__Products__Id_String(
											{
												ahP: $author$project$Api$Partner$PartnerProduct$Shared$id(product)
											}),
										marketplaceProduct);
								}()
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm, $author$project$Ui$Element$mt2]),
							_List_fromArray(
								[
									$elm$html$Html$text('This is how your listing will appear in the marketplace. Click to edit.')
								]))
						])),
					$author$project$Pages$Partner$Dashboard$Top$viewProductChecklist(product),
					function () {
					if (published) {
						return $author$project$Utils$Html$empty;
					} else {
						var reviewReady = A2(
							$elm$core$List$all,
							$author$project$Pages$Partner$Dashboard$Top$isStepComplete(model),
							A2(
								$elm$core$List$filter,
								function (s) {
									return (s !== 2) && (s !== 4);
								},
								$author$project$Pages$Partner$Dashboard$Top$allSteps(model.YN)));
						var loading = _Utils_eq(model.k2, $author$project$Api$Data$Loading);
						var alreadyRequested = function () {
							var _v1 = model.k2;
							if (_v1.$ === 3) {
								return true;
							} else {
								return false;
							}
						}();
						return A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$justifyCenter]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Request listing review'},
									_List_fromArray(
										[
											$author$project$Ui$Button$primary,
											$author$project$Ui$Button$disabled((!reviewReady) || alreadyRequested),
											$author$project$Ui$Button$loading(loading),
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Partner$Dashboard$Top$RequestReview(
												$author$project$Api$Partner$PartnerProduct$Shared$id(product)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Request Listing Review')
										]))
								]));
					}
				}()
				]));
	} else {
		return $author$project$Pages$Partner$Dashboard$Top$viewNewProduct(model);
	}
};
var $author$project$Pages$Partner$Dashboard$Top$viewSandboxSetupContent = function (_v0) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$justifyCenter]),
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Link$route,
				$author$project$Spa$Generated$Route$Partner__Sandboxes__Top,
				_List_fromArray(
					[$author$project$Ui$Link$buttonPrimary]),
				_List_fromArray(
					[
						$elm$html$Html$text('Go to Sandboxes')
					]))
			]));
};
var $author$project$Pages$Partner$Dashboard$Top$stepDescription = function (step) {
	switch (step) {
		case 0:
			return 'Legal business name, address, logo, and technical contact';
		case 1:
			return 'Review and sign required agreements';
		case 2:
			return 'Create and configure your marketplace product listing';
		case 3:
			return 'Create and configure a sandbox partner and sandbox practice for testing';
		default:
			return 'Add your marketplace listing link to your website';
	}
};
var $author$project$Pages$Partner$Dashboard$Top$stepTitle = function (step) {
	switch (step) {
		case 0:
			return 'Company Details';
		case 1:
			return 'Agreements';
		case 2:
			return 'Product Listing';
		case 3:
			return 'Sandbox Setup';
		default:
			return 'Link to Your Listing';
	}
};
var $author$project$Pages$Partner$Dashboard$Top$viewSetupSection = F3(
	function (model, step, content) {
		var expanded = A2($elm$core$List$member, step, model.jH);
		var description = function () {
			if (step === 1) {
				var count = $author$project$Pages$Partner$Dashboard$Top$agreementsCount(model);
				return $elm$core$String$fromInt(count.abt) + (' of ' + ($elm$core$String$fromInt(count.al9) + ' signed'));
			} else {
				return $author$project$Pages$Partner$Dashboard$Top$stepDescription(step);
			}
		}();
		var complete = A2($author$project$Pages$Partner$Dashboard$Top$isStepComplete, model, step);
		return A2(
			$author$project$Ui$Panel$view,
			_List_fromArray(
				[
					$author$project$Ui$Panel$collapsed(!expanded)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_fromArray(
						[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap4]),
					_List_fromArray(
						[
							$author$project$Pages$Partner$Dashboard$Top$statusIcon(complete),
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$title,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Pages$Partner$Dashboard$Top$stepTitle(step))
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textMuted]),
									_List_fromArray(
										[
											$elm$html$Html$text(description)
										]))
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[content]))
				]));
	});
var $author$project$Pages$Partner$Dashboard$Top$BacklinkUrlChanged = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Partner$Dashboard$Top$CopyListingUrl = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Partner$Dashboard$Top$SaveBacklinkUrl = {$: 10};
var $author$project$Pages$Partner$Dashboard$Top$viewWebsiteBacklinkContent = function (model) {
	var _v0 = $author$project$Api$Partner$Partner$One$product(model.YN);
	if (!_v0.$) {
		var product = _v0.a;
		var loading = _Utils_eq(model.mq, $author$project$Api$Data$Loading);
		var listingUrl = 'https://www.hint.com/marketplace/' + $author$project$Api$Partner$PartnerProduct$Shared$slug(product);
		return A2(
			$author$project$Ui$Form$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$autocomplete(false),
					$author$project$Ui$Form$noValidate(true),
					$author$project$Ui$Form$onSubmit($author$project$Pages$Partner$Dashboard$Top$SaveBacklinkUrl)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpanSm(4),
							$author$project$Ui$Form$Group$inputSpanSm(8),
							$author$project$Ui$Form$Group$label('Listing URL')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$externalHref,
									listingUrl,
									_List_fromArray(
										[$author$project$Ui$Link$targetBlank]),
									_List_fromArray(
										[
											$elm$html$Html$text(listingUrl)
										])),
									$elm$html$Html$text(' '),
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Copy listing URL'},
									_List_fromArray(
										[
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Partner$Dashboard$Top$CopyListingUrl(listingUrl)),
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$icon($author$project$Ui$Icon$copy)
										]),
									_List_Nil)
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpanSm(4),
							$author$project$Ui$Form$Group$inputSpanSm(8),
							$author$project$Ui$Form$Group$label('Your website page with the listing link')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$url,
									$author$project$Ui$Form$Input$value(model.fL),
									$author$project$Ui$Form$Input$onInput($author$project$Pages$Partner$Dashboard$Top$BacklinkUrlChanged),
									$author$project$Ui$Form$Input$placeholder('https://yoursite.com/integrations'),
									$author$project$Ui$Form$Input$ariaLabel('Your website page with the listing link')
								]))
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$mt2]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Save listing link'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$submit,
									$author$project$Ui$Button$loading(loading),
									$author$project$Ui$Button$disabled(
									$elm$core$String$isEmpty(
										$elm$core$String$trim(model.fL)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Save')
								]))
						]))
				]));
	} else {
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$textMuted]),
			_List_fromArray(
				[
					$elm$html$Html$text('Create a product listing first to get your marketplace URL.')
				]));
	}
};
var $author$project$Pages$Partner$Dashboard$Top$viewLiveDashboard = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				$elm$core$List$concat(
					_List_fromArray(
						[
							$author$project$Api$Partner$Partner$One$sandboxEnabled(model.YN) ? _List_fromArray(
							[
								$author$project$Pages$Partner$Dashboard$Top$viewLiveDashboardHeader(model),
								A3(
								$author$project$Pages$Partner$Dashboard$Top$viewSetupSection,
								model,
								3,
								$author$project$Pages$Partner$Dashboard$Top$viewSandboxSetupContent(model))
							]) : _List_fromArray(
							[
								$author$project$Pages$Partner$Dashboard$Top$viewLiveDashboardHeader(model)
							]),
							_List_fromArray(
							[
								A3(
								$author$project$Pages$Partner$Dashboard$Top$viewSetupSection,
								model,
								0,
								$author$project$Pages$Partner$Dashboard$Top$viewCompanyDetailsContent(model)),
								A3(
								$author$project$Pages$Partner$Dashboard$Top$viewSetupSection,
								model,
								1,
								$author$project$Pages$Partner$Dashboard$Top$viewAgreementsContent(model))
							]),
							(!_Utils_eq(
							$author$project$Api$Partner$Partner$One$managedBy(model.YN),
							$elm$core$Maybe$Nothing)) ? _List_Nil : _List_fromArray(
							[
								A3(
								$author$project$Pages$Partner$Dashboard$Top$viewSetupSection,
								model,
								2,
								$author$project$Pages$Partner$Dashboard$Top$viewProductListingContent(model)),
								A3(
								$author$project$Pages$Partner$Dashboard$Top$viewSetupSection,
								model,
								4,
								$author$project$Pages$Partner$Dashboard$Top$viewWebsiteBacklinkContent(model))
							])
						])))
			]),
		ac9: 'Partner | Dashboard'
	};
};
var $author$project$Pages$Partner$Dashboard$Top$viewGuideStep = F3(
	function (number, title, description) {
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap4]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$textMuted]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text(number)
								]))
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
							_List_fromArray(
								[
									$elm$html$Html$text(description)
								]))
						]))
				]));
	});
var $author$project$Pages$Partner$Dashboard$Top$viewIntegrationGuidePanel = A2(
	$author$project$Ui$Panel$view,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Panel$heading,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Panel$title(
					_List_fromArray(
						[
							$elm$html$Html$text('Building Your Integration')
						]))
				])),
			A2(
			$author$project$Ui$Panel$body,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap4]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textMuted]),
							_List_fromArray(
								[
									$elm$html$Html$text('Follow the steps in the developer documentation to build and test your integration with Hint.')
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									A3($author$project$Pages$Partner$Dashboard$Top$viewGuideStep, '1', 'Define data sync', 'Determine sync direction and source of truth'),
									A3($author$project$Pages$Partner$Dashboard$Top$viewGuideStep, '2', 'Implement activation', 'Set up the practice activation flow'),
									A3($author$project$Pages$Partner$Dashboard$Top$viewGuideStep, '3', 'Initial data sync', 'Backfill existing data safely'),
									A3($author$project$Pages$Partner$Dashboard$Top$viewGuideStep, '4', 'Keep data current', 'Use webhooks to stay in sync'),
									A3($author$project$Pages$Partner$Dashboard$Top$viewGuideStep, '5', 'Integration records', 'Make sync status observable'),
									A3($author$project$Pages$Partner$Dashboard$Top$viewGuideStep, '6', 'Surface key fields', 'Show high-value data in your UI')
								])),
							A3(
							$author$project$Ui$Link$externalHref,
							'https://developers.hint.com/docs/building-an-integration',
							_List_fromArray(
								[$author$project$Ui$Link$buttonPrimary, $author$project$Ui$Link$targetBlank]),
							_List_fromArray(
								[
									$elm$html$Html$text('View Developer Docs')
								]))
						]))
				]))
		]));
var $author$project$Pages$Partner$Dashboard$Top$viewSandboxDashboard = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mb4]),
						_List_fromArray(
							[
								$author$project$Pages$Partner$Dashboard$Top$viewProductSummaryCard(model)
							])),
						$author$project$Pages$Partner$Dashboard$Top$viewIntegrationGuidePanel,
						A3(
						$author$project$Pages$Partner$Dashboard$Top$viewSetupSection,
						model,
						0,
						$author$project$Pages$Partner$Dashboard$Top$viewCompanyDetailsContent(model))
					]))
			]),
		ac9: 'Partner | Dashboard'
	};
};
var $author$project$Pages$Partner$Dashboard$Top$view = function (model) {
	return model.In ? $author$project$Pages$Partner$Dashboard$Top$viewSandboxDashboard(model) : $author$project$Pages$Partner$Dashboard$Top$viewLiveDashboard(model);
};
var $author$project$Pages$Partner$Dashboard$Top$page = $author$project$Spa$Page$applicationPartner(
	{ah_: $author$project$Pages$Partner$Dashboard$Top$init, aiq: $author$project$Pages$Partner$Dashboard$Top$load, k8: $author$project$Pages$Partner$Dashboard$Top$save, alO: $author$project$Pages$Partner$Dashboard$Top$subscriptions, adT: $author$project$Pages$Partner$Dashboard$Top$update, amo: $author$project$Pages$Partner$Dashboard$Top$view});
var $author$project$Pages$Partner$Engagements$StatusDropdownMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Partner$Engagements$GotInstalledCount = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Partner$Engagement$All$Engagement = $elm$core$Basics$identity;
var $author$project$Api$Partner$Engagement$All$Record = F6(
	function (id, practice, status, createdAt, betaAccessGranted, contact) {
		return {MB: betaAccessGranted, Ov: contact, O1: createdAt, ahP: id, ZV: practice, alH: status};
	});
var $author$project$Api$Partner$User$Min$User = $elm$core$Basics$identity;
var $author$project$Api$Partner$User$Min$Record = F2(
	function (name, email) {
		return {Rj: email, Bq: name};
	});
var $author$project$Api$Partner$User$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'email',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Partner$User$Min$Record)));
var $author$project$Api$Partner$User$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$User$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$Engagement$All$decoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'contact',
		$elm$json$Json$Decode$nullable($author$project$Api$Partner$User$Min$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'beta_access_granted',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'created_at',
				$elm_community$json_extra$Json$Decode$Extra$datetime,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'status',
					$author$project$Api$Common$Marketplace$Product$Engagement$Status$decoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'practice',
						$author$project$Api$Partner$Practice$Min$decoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Api$Partner$Engagement$All$Record))))))));
var $author$project$Api$Partner$Engagement$engagementsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['engagements']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Common$Marketplace$Product$Engagement$Status$toString = function (status) {
	switch (status.$) {
		case 0:
			return 'waitlisted';
		case 1:
			return 'interested';
		case 2:
			return 'beta_access_granted';
		case 3:
			return 'install_attempted';
		case 4:
			return 'install_requested';
		default:
			var string = status.a;
			return string;
	}
};
var $author$project$Api$Partner$Engagement$listOptionsToParams = function (optionals) {
	var options = optionals(
		{ajJ: $author$project$Api$Pagination$init, alA: $author$project$Api$Sort$init, JX: _List_Nil});
	var statusParams = function () {
		var _v0 = options.JX;
		if (!_v0.b) {
			return _List_Nil;
		} else {
			var statuses = _v0;
			return _List_fromArray(
				[
					A2(
					$author$project$Api$Param$list,
					'status',
					A2($elm$core$List$map, $author$project$Api$Common$Marketplace$Product$Engagement$Status$toString, statuses))
				]);
		}
	}();
	return _Utils_ap(
		statusParams,
		_Utils_ap(
			$author$project$Api$Pagination$toApiParams(options.ajJ),
			$author$project$Api$Sort$toParams(options.alA)));
};
var $author$project$Api$Partner$Engagement$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Partner$Engagement$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Partner$Engagement$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Partner$Engagement$engagementsPath)));
	});
var $author$project$Pages$Partner$Engagements$fetchInstalledCount = function (apiClient) {
	return A3(
		$author$project$Api$Partner$Engagement$list,
		apiClient,
		function (o) {
			return _Utils_update(
				o,
				{
					ajJ: $author$project$Api$Pagination$empty,
					JX: _List_fromArray(
						[$author$project$Api$Common$Marketplace$Product$Engagement$Status$InstallAttempted, $author$project$Api$Common$Marketplace$Product$Engagement$Status$InstallRequested])
				});
		},
		$author$project$Pages$Partner$Engagements$GotInstalledCount);
};
var $author$project$Pages$Partner$Engagements$GotInterestedCount = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Partner$Engagements$fetchInterestedCount = function (apiClient) {
	return A3(
		$author$project$Api$Partner$Engagement$list,
		apiClient,
		function (o) {
			return _Utils_update(
				o,
				{
					ajJ: $author$project$Api$Pagination$empty,
					JX: _List_fromArray(
						[$author$project$Api$Common$Marketplace$Product$Engagement$Status$Interested])
				});
		},
		$author$project$Pages$Partner$Engagements$GotInterestedCount);
};
var $author$project$Pages$Partner$Engagements$GotWaitlistedCount = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Partner$Engagements$fetchWaitlistedCount = function (apiClient) {
	return A3(
		$author$project$Api$Partner$Engagement$list,
		apiClient,
		function (o) {
			return _Utils_update(
				o,
				{
					ajJ: $author$project$Api$Pagination$empty,
					JX: _List_fromArray(
						[$author$project$Api$Common$Marketplace$Product$Engagement$Status$Waitlisted])
				});
		},
		$author$project$Pages$Partner$Engagements$GotWaitlistedCount);
};
var $author$project$Pages$Partner$Engagements$fetchCountCmds = F2(
	function (apiClient, maybeListingStatus) {
		_v0$4:
		while (true) {
			if (!maybeListingStatus.$) {
				switch (maybeListingStatus.a) {
					case 3:
						var _v1 = maybeListingStatus.a;
						return _List_fromArray(
							[
								$author$project$Pages$Partner$Engagements$fetchInterestedCount(apiClient)
							]);
					case 2:
						var _v2 = maybeListingStatus.a;
						return _List_fromArray(
							[
								$author$project$Pages$Partner$Engagements$fetchInterestedCount(apiClient)
							]);
					case 4:
						var _v3 = maybeListingStatus.a;
						return _List_fromArray(
							[
								$author$project$Pages$Partner$Engagements$fetchInterestedCount(apiClient),
								$author$project$Pages$Partner$Engagements$fetchWaitlistedCount(apiClient),
								$author$project$Pages$Partner$Engagements$fetchInstalledCount(apiClient)
							]);
					case 5:
						var _v4 = maybeListingStatus.a;
						return _List_fromArray(
							[
								$author$project$Pages$Partner$Engagements$fetchInstalledCount(apiClient)
							]);
					default:
						break _v0$4;
				}
			} else {
				break _v0$4;
			}
		}
		return _List_Nil;
	});
var $author$project$Pages$Partner$Engagements$GotEngagements = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Partner$Engagements$fetchEngagements = function (model) {
	return A3(
		$author$project$Api$Partner$Engagement$list,
		model.Gv,
		function (o) {
			return _Utils_update(
				o,
				{ajJ: model.ajJ, alA: model.alA, JX: model.hN});
		},
		$author$project$Pages$Partner$Engagements$GotEngagements);
};
var $author$project$Api$Partner$Partner$Shared$productType = function (_v0) {
	var record = _v0;
	return record.Jo;
};
var $author$project$Api$Partner$Partner$One$productType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$productType(shared);
};
var $author$project$Pages$Partner$Engagements$init = F4(
	function (_v0, partner, shared, _v1) {
		var query = _v1.DE;
		var statusFilter = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$String$split(','),
					$elm$core$List$filterMap($author$project$Api$Common$Marketplace$Product$Engagement$Status$fromString)),
				A2($elm$core$Dict$get, 'status', query)));
		var sort = A3(
			$author$project$Api$Sort$withDefault,
			'created_at',
			1,
			$author$project$Api$Sort$initFromQuery(query));
		var productType = $author$project$Api$Partner$Partner$One$productType(partner);
		var pagination = $author$project$Api$Pagination$initFromQuery(query);
		var listingStatus = A2(
			$elm$core$Maybe$map,
			$author$project$Api$Partner$PartnerProduct$Shared$status,
			$author$project$Api$Partner$Partner$One$product(partner));
		var initModel = {
			Gv: shared.Gv,
			b_: $author$project$Api$Data$Loading,
			sJ: $author$project$Api$Data$NotAsked,
			n$: $author$project$Api$Data$NotAsked,
			V7: listingStatus,
			ajJ: pagination,
			Jo: productType,
			alA: sort,
			qn: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'status-filter', al6: $author$project$Pages$Partner$Engagements$StatusDropdownMsg})),
			hN: statusFilter,
			J7: shared.J7,
			aeo: $author$project$Api$Data$NotAsked
		};
		var countCmds = A2($author$project$Pages$Partner$Engagements$fetchCountCmds, shared.Gv, listingStatus);
		return _Utils_Tuple2(
			initModel,
			$elm$core$Platform$Cmd$batch(
				A2(
					$elm$core$List$cons,
					$author$project$Pages$Partner$Engagements$fetchEngagements(initModel),
					countCmds)));
	});
var $author$project$Pages$Partner$Engagements$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Partner$Engagements$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Partner$Engagements$subscriptions = function (model) {
	return $author$project$Ui$Dropdown$subscriptions(model.qn);
};
var $author$project$Pages$Partner$Engagements$AccessGranted = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Pages$Partner$Engagements$buildUrl = function (model) {
	var params = _Utils_ap(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$core$List$isEmpty(model.hN) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					A2(
						$elm$url$Url$Builder$string,
						'status',
						A2(
							$elm$core$String$join,
							',',
							A2($elm$core$List$map, $author$project$Api$Common$Marketplace$Product$Engagement$Status$toString, model.hN))))
				])),
		_Utils_ap(
			$author$project$Api$Pagination$toPageQuery(model.ajJ),
			$author$project$Api$Sort$toQuery(model.alA)));
	return A2(
		$elm$url$Url$Builder$relative,
		_List_fromArray(
			[
				$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Partner__Engagements)
			]),
		params);
};
var $author$project$Api$Partner$Engagement$grantAccess = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$Engagement$All$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						[id, 'grant_access']),
					$author$project$Api$Partner$Engagement$engagementsPath)));
	});
var $author$project$Api$Partner$Engagement$All$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Pages$Partner$Engagements$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				var pagination = function () {
					if (response.$ === 3) {
						var headers = response.b;
						return A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ);
					} else {
						return model.ajJ;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{b_: response, ajJ: pagination}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var engagement = msg.a;
				return _Utils_Tuple3(
					model,
					A3(
						$author$project$Api$Partner$Engagement$grantAccess,
						model.Gv,
						$author$project$Api$Partner$Engagement$All$id(engagement),
						$author$project$Pages$Partner$Engagements$AccessGranted(engagement)),
					_List_Nil);
			case 2:
				var engagement = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var updated = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								b_: A2(
									$author$project$Api$Data$map,
									$elm$core$List$map(
										function (e) {
											return _Utils_eq(
												$author$project$Api$Partner$Engagement$All$id(e),
												$author$project$Api$Partner$Engagement$All$id(engagement)) ? updated : e;
										}),
									model.b_)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 3:
				var status = msg.a;
				var newFilter = A2($elm$core$List$member, status, model.hN) ? A2(
					$elm$core$List$filter,
					$elm$core$Basics$neq(status),
					model.hN) : _Utils_ap(
					model.hN,
					_List_fromArray(
						[status]));
				var newModel = _Utils_update(
					model,
					{
						b_: $author$project$Api$Data$Loading,
						ajJ: $author$project$Api$Pagination$reset(model.ajJ),
						hN: newFilter
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Partner$Engagements$fetchEngagements(newModel),
								$author$project$Ports$Navigation$replaceUrl(
								$author$project$Pages$Partner$Engagements$buildUrl(newModel))
							])),
					_List_Nil);
			case 4:
				var installedStatuses = _List_fromArray(
					[$author$project$Api$Common$Marketplace$Product$Engagement$Status$InstallAttempted, $author$project$Api$Common$Marketplace$Product$Engagement$Status$InstallRequested]);
				var isActive = A2(
					$elm$core$List$all,
					function (s) {
						return A2($elm$core$List$member, s, model.hN);
					},
					installedStatuses);
				var newFilter = isActive ? A2(
					$elm$core$List$filter,
					function (s) {
						return !A2($elm$core$List$member, s, installedStatuses);
					},
					model.hN) : _Utils_ap(
					model.hN,
					A2(
						$elm$core$List$filter,
						function (s) {
							return !A2($elm$core$List$member, s, model.hN);
						},
						installedStatuses));
				var newModel = _Utils_update(
					model,
					{
						b_: $author$project$Api$Data$Loading,
						ajJ: $author$project$Api$Pagination$reset(model.ajJ),
						hN: newFilter
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Partner$Engagements$fetchEngagements(newModel),
								$author$project$Ports$Navigation$replaceUrl(
								$author$project$Pages$Partner$Engagements$buildUrl(newModel))
							])),
					_List_Nil);
			case 5:
				var dropdownMsg = msg.a;
				var _v3 = A2($author$project$Ui$Dropdown$update, dropdownMsg, model.qn);
				var dropdown = _v3.a;
				var dropdownCmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qn: dropdown}),
					dropdownCmd,
					_List_Nil);
			case 6:
				var paginationMsg = msg.a;
				var newModel = _Utils_update(
					model,
					{
						b_: $author$project$Api$Data$Loading,
						ajJ: A2($author$project$Api$Pagination$update, paginationMsg, model.ajJ)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Partner$Engagements$fetchEngagements(newModel),
								$author$project$Ports$Navigation$replaceUrl(
								$author$project$Pages$Partner$Engagements$buildUrl(newModel))
							])),
					_List_Nil);
			case 8:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{n$: response}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 9:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aeo: response}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 7:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						b_: $author$project$Api$Data$Loading,
						alA: A2($author$project$Api$Sort$update, columnId, model.alA)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Partner$Engagements$fetchEngagements(newModel),
								$author$project$Ports$Navigation$replaceUrl(
								$author$project$Pages$Partner$Engagements$buildUrl(newModel))
							])),
					_List_Nil);
			default:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{sJ: response}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
		}
	});
var $author$project$Pages$Partner$Engagements$PaginationMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Partner$Engagements$viewCombinedStatItem = F3(
	function (label, data1, data2) {
		var count = A2(
			$elm$core$Maybe$withDefault,
			'—',
			A2(
				$elm$core$Maybe$map,
				$elm$core$String$fromInt,
				A3(
					$elm$core$Maybe$map2,
					$elm$core$Basics$add,
					$author$project$Api$Data$totalCount(data1),
					$author$project$Api$Data$totalCount(data2))));
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Typography$heading(
					_List_fromArray(
						[
							$elm$html$Html$text(count)
						])),
					A2(
					$author$project$Ui$Typography$label,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						]))
				]));
	});
var $author$project$Pages$Partner$Engagements$viewStatItem = F2(
	function (label, data) {
		var count = A2(
			$elm$core$Maybe$withDefault,
			'—',
			A2(
				$elm$core$Maybe$map,
				$elm$core$String$fromInt,
				$author$project$Api$Data$totalCount(data)));
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Typography$heading(
					_List_fromArray(
						[
							$elm$html$Html$text(count)
						])),
					A2(
					$author$project$Ui$Typography$label,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						]))
				]));
	});
var $author$project$Pages$Partner$Engagements$viewStatItems = function (items) {
	return $elm$core$List$isEmpty(items) ? $elm$html$Html$text('') : A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$gap4, $author$project$Ui$Element$mb4]),
		items);
};
var $author$project$Pages$Partner$Engagements$viewStats = function (model) {
	var installedLabel = function () {
		var _v5 = model.Jo;
		if (_v5 === 1) {
			return 'Connected';
		} else {
			return 'Installed';
		}
	}();
	var _v0 = model.V7;
	_v0$4:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 3:
					var _v1 = _v0.a;
					return $author$project$Pages$Partner$Engagements$viewStatItems(
						_List_fromArray(
							[
								A2($author$project$Pages$Partner$Engagements$viewStatItem, 'Interested', model.n$)
							]));
				case 2:
					var _v2 = _v0.a;
					return $author$project$Pages$Partner$Engagements$viewStatItems(
						_List_fromArray(
							[
								A2($author$project$Pages$Partner$Engagements$viewStatItem, 'Interested', model.n$)
							]));
				case 4:
					var _v3 = _v0.a;
					return $author$project$Pages$Partner$Engagements$viewStatItems(
						_List_fromArray(
							[
								A3($author$project$Pages$Partner$Engagements$viewCombinedStatItem, 'Waitlisted', model.n$, model.aeo),
								A2($author$project$Pages$Partner$Engagements$viewStatItem, installedLabel, model.sJ)
							]));
				case 5:
					var _v4 = _v0.a;
					return $author$project$Pages$Partner$Engagements$viewStatItems(
						_List_fromArray(
							[
								A2($author$project$Pages$Partner$Engagements$viewStatItem, installedLabel, model.sJ)
							]));
				default:
					break _v0$4;
			}
		} else {
			break _v0$4;
		}
	}
	return $elm$html$Html$text('');
};
var $author$project$Pages$Partner$Engagements$ToggleInstalledFilter = {$: 4};
var $author$project$Pages$Partner$Engagements$isLiveOrAbove = function (maybeStatus) {
	_v0$4:
	while (true) {
		if (!maybeStatus.$) {
			switch (maybeStatus.a) {
				case 5:
					var _v1 = maybeStatus.a;
					return true;
				case 6:
					var _v2 = maybeStatus.a;
					return true;
				case 7:
					var _v3 = maybeStatus.a;
					return true;
				case 8:
					var _v4 = maybeStatus.a;
					return true;
				default:
					break _v0$4;
			}
		} else {
			break _v0$4;
		}
	}
	return false;
};
var $author$project$Api$Common$Marketplace$Product$Engagement$Status$toLabel = function (status) {
	switch (status.$) {
		case 0:
			return 'Waitlisted';
		case 1:
			return 'Interest Expressed';
		case 2:
			return 'Beta Access Granted';
		case 3:
			return 'Install Attempted';
		case 4:
			return 'Install Requested';
		default:
			var string = status.a;
			return string;
	}
};
var $author$project$Pages$Partner$Engagements$ToggleStatusFilter = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Partner$Engagements$viewStatusFilterItem = F2(
	function (activeStatuses, status) {
		return A2(
			$author$project$Ui$Dropdown$checkbox,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$checked(
					A2($elm$core$List$member, status, activeStatuses)),
					$author$project$Ui$Dropdown$onCheck(
					function (_v0) {
						return $author$project$Pages$Partner$Engagements$ToggleStatusFilter(status);
					}),
					$author$project$Ui$Dropdown$onSelectKeepOpen
				]),
			$elm$html$Html$text(
				$author$project$Api$Common$Marketplace$Product$Engagement$Status$toLabel(status)));
	});
var $author$project$Pages$Partner$Engagements$viewStatusFilter = function (model) {
	var installedStatuses = _List_fromArray(
		[$author$project$Api$Common$Marketplace$Product$Engagement$Status$InstallAttempted, $author$project$Api$Common$Marketplace$Product$Engagement$Status$InstallRequested]);
	var installedLabel = function () {
		var _v2 = model.Jo;
		if (_v2 === 1) {
			return 'Connected';
		} else {
			return 'Installed';
		}
	}();
	var installedActive = A2(
		$elm$core$List$all,
		function (s) {
			return A2($elm$core$List$member, s, model.hN);
		},
		installedStatuses);
	var installedItem = A2(
		$author$project$Ui$Dropdown$checkbox,
		_List_fromArray(
			[
				$author$project$Ui$Dropdown$checked(installedActive),
				$author$project$Ui$Dropdown$onCheck(
				function (_v1) {
					return $author$project$Pages$Partner$Engagements$ToggleInstalledFilter;
				}),
				$author$project$Ui$Dropdown$onSelectKeepOpen
			]),
		$elm$html$Html$text(installedLabel));
	var baseStatuses = $author$project$Pages$Partner$Engagements$isLiveOrAbove(model.V7) ? _List_fromArray(
		[$author$project$Api$Common$Marketplace$Product$Engagement$Status$Waitlisted, $author$project$Api$Common$Marketplace$Product$Engagement$Status$Interested]) : _List_fromArray(
		[$author$project$Api$Common$Marketplace$Product$Engagement$Status$Waitlisted, $author$project$Api$Common$Marketplace$Product$Engagement$Status$Interested, $author$project$Api$Common$Marketplace$Product$Engagement$Status$BetaAccessGranted]);
	var activeLabels = _Utils_ap(
		A2(
			$elm$core$List$filterMap,
			function (s) {
				return A2($elm$core$List$member, s, model.hN) ? $elm$core$Maybe$Just(
					$author$project$Api$Common$Marketplace$Product$Engagement$Status$toLabel(s)) : $elm$core$Maybe$Nothing;
			},
			baseStatuses),
		installedActive ? _List_fromArray(
			[installedLabel]) : _List_Nil);
	var triggerLabel = function () {
		if (!activeLabels.b) {
			return 'Status';
		} else {
			var labels = activeLabels;
			return A2($elm$core$String$join, ', ', labels);
		}
	}();
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(triggerLabel)
			]),
		_Utils_ap(
			A2(
				$elm$core$List$map,
				$author$project$Pages$Partner$Engagements$viewStatusFilterItem(model.hN),
				baseStatuses),
			_List_fromArray(
				[installedItem])),
		model.qn);
};
var $author$project$Pages$Partner$Engagements$SortTable = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Partner$Engagements$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'practice', true, 'Practice'),
		A3($author$project$Api$Column$init, '', false, 'Contact Name'),
		A3($author$project$Api$Column$init, '', false, 'Contact Email'),
		A3($author$project$Api$Column$init, 'status', true, 'Status'),
		A3($author$project$Api$Column$init, 'created_at', true, 'First Engaged'),
		A3($author$project$Api$Column$init, '', false, 'Beta Access'),
		A3($author$project$Api$Column$init, '', false, '')
	]);
var $author$project$Pages$Partner$Engagements$GrantAccess = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Partner$Engagement$All$betaAccessGranted = function (_v0) {
	var record = _v0;
	return record.MB;
};
var $author$project$Api$Partner$Engagement$All$contact = function (_v0) {
	var record = _v0;
	return record.Ov;
};
var $author$project$Api$Partner$Engagement$All$createdAt = function (_v0) {
	var record = _v0;
	return record.O1;
};
var $author$project$Api$Partner$User$Min$email = function (_v0) {
	var record = _v0;
	return record.Rj;
};
var $author$project$Api$Partner$User$Min$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Partner$Engagement$All$practice = function (_v0) {
	var record = _v0;
	return record.ZV;
};
var $author$project$Api$Partner$Engagement$All$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Pages$Partner$Engagements$viewRow = F3(
	function (showBetaColumns, timeFormatter, engagement) {
		var baseCells = _List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Partner$Practice$Min$name(
							$author$project$Api$Partner$Engagement$All$practice(engagement)))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$map,
								$author$project$Api$Partner$User$Min$name,
								$author$project$Api$Partner$Engagement$All$contact(engagement))))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$map,
								$author$project$Api$Partner$User$Min$email,
								$author$project$Api$Partner$Engagement$All$contact(engagement))))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Badge$view,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Api$Common$Marketplace$Product$Engagement$Status$toLabel(
									$author$project$Api$Partner$Engagement$All$status(engagement)))
							]))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							timeFormatter,
							5,
							$author$project$Api$Partner$Engagement$All$createdAt(engagement)))
					]))
			]);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_Utils_ap(
				baseCells,
				showBetaColumns ? _List_fromArray(
					[
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Api$Partner$Engagement$All$betaAccessGranted(engagement) ? A2(
								$author$project$Ui$Badge$view,
								_List_fromArray(
									[$author$project$Ui$Badge$success]),
								_List_fromArray(
									[
										$elm$html$Html$text('Granted')
									])) : $elm$html$Html$text('')
							])),
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								(!$author$project$Api$Partner$Engagement$All$betaAccessGranted(engagement)) ? A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$justifyRight]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Grant access'},
										_List_fromArray(
											[
												$author$project$Ui$Button$default,
												$author$project$Ui$Button$sm,
												$author$project$Ui$Button$onClick(
												$author$project$Pages$Partner$Engagements$GrantAccess(engagement))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Grant access')
											]))
									])) : $elm$html$Html$text('')
							]))
					]) : _List_Nil));
	});
var $author$project$Pages$Partner$Engagements$viewTable = function (model) {
	var showBetaColumns = !$author$project$Pages$Partner$Engagements$isLiveOrAbove(model.V7);
	var visibleColumns = showBetaColumns ? $author$project$Pages$Partner$Engagements$columns : A2($elm$core$List$take, 5, $author$project$Pages$Partner$Engagements$columns);
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$loading(
				_Utils_eq(model.b_, $author$project$Api$Data$Loading))
			]),
		A2(
			$elm$core$List$map,
			$author$project$Api$Column$view(
				A2($author$project$Api$Column$Sortable, model.alA, $author$project$Pages$Partner$Engagements$SortTable)),
			visibleColumns),
		A2(
			$elm$core$List$map,
			A2($author$project$Pages$Partner$Engagements$viewRow, showBetaColumns, model.J7),
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$author$project$Api$Data$toMaybe(model.b_))),
		_List_Nil);
};
var $author$project$Pages$Partner$Engagements$viewBody = function (model) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$mb4]),
							_List_fromArray(
								[
									$author$project$Ui$Panel$title(
									_List_fromArray(
										[
											$elm$html$Html$text('Engagements')
										]))
								])),
							$author$project$Pages$Partner$Engagements$viewStats(model),
							A2(
							$author$project$Ui$Grid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanSm(4)
										]),
									_List_fromArray(
										[
											$author$project$Pages$Partner$Engagements$viewStatusFilter(model)
										]))
								]))
						])),
					$author$project$Pages$Partner$Engagements$viewTable(model),
					A2(
					$author$project$Ui$Panel$footer,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Pages$Partner$Engagements$PaginationMsg,
							A2(
								$author$project$Api$Pagination$view,
								_List_fromArray(
									[
										$author$project$Ui$Pagination$List$loading(
										_Utils_eq(model.b_, $author$project$Api$Data$Loading))
									]),
								model.ajJ))
						]))
				]))
		]);
};
var $author$project$Pages$Partner$Engagements$view = function (model) {
	return {
		fO: $author$project$Pages$Partner$Engagements$viewBody(model),
		ac9: 'Partner | Engagements'
	};
};
var $author$project$Pages$Partner$Engagements$page = $author$project$Spa$Page$applicationPartner(
	{ah_: $author$project$Pages$Partner$Engagements$init, aiq: $author$project$Pages$Partner$Engagements$load, k8: $author$project$Pages$Partner$Engagements$save, alO: $author$project$Pages$Partner$Engagements$subscriptions, adT: $author$project$Pages$Partner$Engagements$update, amo: $author$project$Pages$Partner$Engagements$view});
var $author$project$Pages$Partner$Hinter$PartnerDocumentsFormMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Partner$Hinter$PartnerFormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Hinter$EditPartnerForm$Model = $elm$core$Basics$identity;
var $author$project$Api$Partner$Partner$Shared$active = function (_v0) {
	var record = _v0;
	return record.KN;
};
var $author$project$Api$Partner$Partner$One$active = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$active(shared);
};
var $author$project$Api$Partner$Partner$Shared$practicesReadOnly = function (_v0) {
	var record = _v0;
	return record.Z1;
};
var $author$project$Api$Partner$Partner$One$practicesReadOnly = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$practicesReadOnly(shared);
};
var $author$project$Components$Hinter$EditPartnerForm$initFormFields = function (partner) {
	return _Utils_Tuple2(
		{
			KN: $author$project$Api$Partner$Partner$One$active(partner),
			Z1: $author$project$Api$Partner$Partner$One$practicesReadOnly(partner),
			aao: $author$project$Api$Partner$Partner$One$sandboxEnabled(partner)
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Components$Hinter$EditPartnerForm$init = function (partner) {
	var _v0 = $author$project$Components$Hinter$EditPartnerForm$initFormFields(partner);
	var formFields = _v0.a;
	var formFieldsCmd = _v0.b;
	return _Utils_Tuple2(
		{
			SD: $author$project$Utils$Form$init(formFields),
			qP: $author$project$Api$Data$NotAsked
		},
		formFieldsCmd);
};
var $author$project$Components$Partner$AdminSettings$ManagedByForm$Model = $elm$core$Basics$identity;
var $author$project$Components$Partner$AdminSettings$ManagedByForm$init = F2(
	function (_v0, partner) {
		return {a8: $elm$core$Maybe$Nothing, YN: partner};
	});
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$Model = $elm$core$Basics$identity;
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$init = function (partner) {
	return _Utils_Tuple2(
		{bx: $elm$core$Maybe$Nothing, by: $elm$core$Maybe$Nothing, bz: $elm$core$Maybe$Nothing, bA: $elm$core$Maybe$Nothing, YN: partner},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$Partner$Hinter$init = F4(
	function (_v0, partner, shared, _v1) {
		var managedByForm = A2($author$project$Components$Partner$AdminSettings$ManagedByForm$init, shared.Gv, partner);
		var _v2 = $author$project$Components$Hinter$EditPartnerForm$init(partner);
		var partnerForm = _v2.a;
		var partnerFormCmd = _v2.b;
		var _v3 = $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$init(partner);
		var partnerDocumentsForm = _v3.a;
		var partnerDocumentsFormCmd = _v3.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, kh: managedByForm, YN: partner, ky: partnerDocumentsForm, bJ: partnerForm, ll: false},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Hinter$PartnerFormMsg, partnerFormCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Hinter$PartnerDocumentsFormMsg, partnerDocumentsFormCmd)
					])));
	});
var $author$project$Pages$Partner$Hinter$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Partner$Hinter$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Partner$Hinter$ArchiveConfirmClosed = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Partner$Hinter$ManagedByFormMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Hinter$EditPartnerForm$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Components$Partner$AdminSettings$ManagedByForm$CancelEditManagedBy = {$: 2};
var $author$project$Components$Partner$AdminSettings$ManagedByForm$ManagedByInputMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$AdminSettings$ManagedByForm$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				function () {
				var _v1 = model.a8;
				if (!_v1.$) {
					var _v2 = _v1.a;
					var managedByInput = _v2.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Components$Partner$AdminSettings$ManagedByForm$ManagedByInputMsg,
						$author$project$Components$Partner$AdminSettings$ManagedByInput$subscriptions(managedByInput));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Partner$AdminSettings$ManagedByForm$CancelEditManagedBy)),
					model.a8))
			]));
};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CancelEdit = {$: 4};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CancelEdit)),
					model.bA)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CancelEdit)),
					model.bx)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CancelEdit)),
					model.by)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CancelEdit)),
					model.bz))
			]));
};
var $author$project$Pages$Partner$Hinter$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Partner$Hinter$PartnerFormMsg,
				$author$project$Components$Hinter$EditPartnerForm$subscriptions(model.bJ)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Partner$Hinter$ManagedByFormMsg,
				$author$project$Components$Partner$AdminSettings$ManagedByForm$subscriptions(model.kh)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Partner$Hinter$PartnerDocumentsFormMsg,
				$author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$subscriptions(model.ky)),
				model.ll ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Partner$Hinter$ArchiveConfirmClosed) : $elm$core$Platform$Sub$none
			]));
};
var $author$project$Pages$Partner$Hinter$PartnerArchived = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Partner$Partner$archive = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$Partner$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['archive']),
					$author$project$Api$Partner$Partner$partnerPath)));
	});
var $author$project$Components$Hinter$EditPartnerForm$GotUpdatedPartner = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Hinter$EditPartnerForm$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 1:
				var bool = field.a;
				return _Utils_update(
					fields,
					{Z1: bool});
			case 0:
				var bool = field.a;
				return _Utils_update(
					fields,
					{KN: bool});
			default:
				var bool = field.a;
				return _Utils_update(
					fields,
					{aao: bool});
		}
	});
var $author$project$Components$Hinter$EditPartnerForm$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_Nil);
var $author$project$Components$Hinter$EditPartnerForm$toPermittedFields = function (fields) {
	return _List_fromArray(
		[
			$author$project$Api$Partner$Partner$Active(fields.KN),
			$author$project$Api$Partner$Partner$PracticesReadOnly(fields.Z1),
			$author$project$Api$Partner$Partner$SandboxEnabled(fields.aao)
		]);
};
var $author$project$Components$Hinter$EditPartnerForm$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Hinter$EditPartnerForm$formFieldsUpdate, field, model.SD);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: newForm}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$Hinter$EditPartnerForm$formFieldsValidator, model.SD);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var validFormFields = _v3.b;
					var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{qP: $author$project$Api$Data$Loading}),
						A3(
							$author$project$Api$Partner$Partner$update,
							apiClient,
							$author$project$Components$Hinter$EditPartnerForm$toPermittedFields(fields),
							$author$project$Components$Hinter$EditPartnerForm$GotUpdatedPartner),
						_List_Nil);
				} else {
					var updatedForm = _v2.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{SD: updatedForm, qP: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{qP: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Partner updated successfully!'),
								$author$project$OutMsg$RefreshPartner
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{qP: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Components$Partner$AdminSettings$ManagedByInput$ManagedByManagementGroup = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$AdminSettings$ManagedByForm$ManagedBySaved = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Partner$ManagementGroup$Min$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Components$Partner$AdminSettings$ManagedByForm$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v2 = model.a8;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var managedByInput = _v3.a;
					var request = _v3.b;
					var _v4 = A3($author$project$Components$Partner$AdminSettings$ManagedByInput$update, apiClient, subMsg, managedByInput);
					var newManagedByInput = _v4.a;
					var managedByInputCmd = _v4.b;
					var outMsgs = _v4.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								a8: $elm$core$Maybe$Just(
									_Utils_Tuple2(newManagedByInput, request))
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Partner$AdminSettings$ManagedByForm$ManagedByInputMsg, managedByInputCmd),
						outMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 1:
				var initialValue = A2(
					$elm$core$Maybe$map,
					function (managedBy) {
						if (!managedBy.$) {
							var practice = managedBy.a;
							return $author$project$Components$Partner$AdminSettings$ManagedByInput$ManagedByPractice(
								$author$project$Api$Partner$Practice$Min$id(practice));
						} else {
							var managementGroup = managedBy.a;
							return $author$project$Components$Partner$AdminSettings$ManagedByInput$ManagedByManagementGroup(
								$author$project$Api$Partner$ManagementGroup$Min$id(managementGroup));
						}
					},
					$author$project$Api$Partner$Partner$One$managedBy(model.YN));
				var _v5 = A2($author$project$Components$Partner$AdminSettings$ManagedByInput$init, apiClient, initialValue);
				var managedByInput = _v5.a;
				var managedByInputCmd = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							a8: $elm$core$Maybe$Just(
								_Utils_Tuple2(managedByInput, $author$project$Api$Data$NotAsked))
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Partner$AdminSettings$ManagedByForm$ManagedByInputMsg, managedByInputCmd),
					_List_Nil);
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{a8: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var _v7 = model.a8;
				if (!_v7.$) {
					var _v8 = _v7.a;
					var managedByInput = _v8.a;
					var managedByValue = A2(
						$elm$core$Maybe$map,
						function (v) {
							if (!v.$) {
								var practiceId = v.a;
								return $author$project$Api$Partner$Partner$ManagedByPractice(practiceId);
							} else {
								var managementGroupId = v.a;
								return $author$project$Api$Partner$Partner$ManagedByManagementGroup(managementGroupId);
							}
						},
						$author$project$Components$Partner$AdminSettings$ManagedByInput$value(managedByInput));
					var permittedFields = _List_fromArray(
						[
							$author$project$Api$Partner$Partner$ManagedBy(managedByValue)
						]);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								a8: $elm$core$Maybe$Just(
									_Utils_Tuple2(managedByInput, $author$project$Api$Data$Loading))
							}),
						A3($author$project$Api$Partner$Partner$update, apiClient, permittedFields, $author$project$Components$Partner$AdminSettings$ManagedByForm$ManagedBySaved),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var response = msg.a;
				var _v10 = model.a8;
				if (!_v10.$) {
					var _v11 = _v10.a;
					var managedByInput = _v11.a;
					if (response.$ === 3) {
						var partner = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{a8: $elm$core$Maybe$Nothing, YN: partner}),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Partner updated successfully!'),
									$author$project$OutMsg$RefreshPartner
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									a8: $elm$core$Maybe$Just(
										_Utils_Tuple2(managedByInput, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Api$Partner$Partner$AddendumAgreement = function (a) {
	return {$: 26, a: a};
};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$AddendumAgreementProcessed = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$AddendumAgreementSaved = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Partner$Partner$CustomApiAccessAgreement = function (a) {
	return {$: 27, a: a};
};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomApiAccessAgreementProcessed = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomApiAccessAgreementSaved = function (a) {
	return {$: 11, a: a};
};
var $author$project$Api$Partner$Partner$CustomBaaAgreement = function (a) {
	return {$: 28, a: a};
};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomBaaAgreementProcessed = F2(
	function (a, b) {
		return {$: 20, a: a, b: b};
	});
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomBaaAgreementSaved = function (a) {
	return {$: 12, a: a};
};
var $author$project$Api$Partner$Partner$CustomPartnerAgreement = function (a) {
	return {$: 25, a: a};
};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomPartnerAgreementProcessed = F2(
	function (a, b) {
		return {$: 14, a: a, b: b};
	});
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomPartnerAgreementSaved = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$GotAddendumAgreementUrl = function (a) {
	return {$: 24, a: a};
};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$GotCustomApiAccessAgreementUrl = function (a) {
	return {$: 26, a: a};
};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$GotCustomBaaAgreementUrl = function (a) {
	return {$: 28, a: a};
};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$GotCustomPartnerAgreementUrl = function (a) {
	return {$: 22, a: a};
};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$maxFileBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$addendumAgreementValidation = F2(
	function (addendumAgreementType, fileSizeAndUrl) {
		if (addendumAgreementType === 1) {
			if (!fileSizeAndUrl.$) {
				var _v2 = fileSizeAndUrl.a;
				var fileSize = _v2.a;
				return (_Utils_cmp(fileSize, $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$maxFileBytesSize) > 0) ? _List_fromArray(
					['That file is too large! Our maximum file size is 5 mb.']) : _List_Nil;
			} else {
				return _List_fromArray(
					['Please upload a file']);
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$isValidAddendumAgreement = F2(
	function (addendumAgreementType, fileSizeAndUrl) {
		return $elm$core$List$isEmpty(
			A2($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$addendumAgreementValidation, addendumAgreementType, fileSizeAndUrl));
	});
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$customApiAccessAgreementValidation = F2(
	function (customApiAccessAgreementType, fileSizeAndUrl) {
		if (customApiAccessAgreementType === 1) {
			if (!fileSizeAndUrl.$) {
				var _v2 = fileSizeAndUrl.a;
				var fileSize = _v2.a;
				return (_Utils_cmp(fileSize, $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$maxFileBytesSize) > 0) ? _List_fromArray(
					['That file is too large! Our maximum file size is 5 mb.']) : _List_Nil;
			} else {
				return _List_fromArray(
					['Please upload a file']);
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$isValidCustomApiAccessAgreement = F2(
	function (customApiAccessAgreementType, fileSizeAndUrl) {
		return $elm$core$List$isEmpty(
			A2($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$customApiAccessAgreementValidation, customApiAccessAgreementType, fileSizeAndUrl));
	});
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$customBaaAgreementValidation = F2(
	function (customBaaAgreementType, fileSizeAndUrl) {
		if (customBaaAgreementType === 1) {
			if (!fileSizeAndUrl.$) {
				var _v2 = fileSizeAndUrl.a;
				var fileSize = _v2.a;
				return (_Utils_cmp(fileSize, $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$maxFileBytesSize) > 0) ? _List_fromArray(
					['That file is too large! Our maximum file size is 5 mb.']) : _List_Nil;
			} else {
				return _List_fromArray(
					['Please upload a file']);
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$isValidCustomBaaAgreement = F2(
	function (customBaaAgreementType, fileSizeAndUrl) {
		return $elm$core$List$isEmpty(
			A2($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$customBaaAgreementValidation, customBaaAgreementType, fileSizeAndUrl));
	});
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$customPartnerAgreementValidation = F2(
	function (customPartnerAgreementType, fileSizeAndUrl) {
		if (customPartnerAgreementType === 1) {
			if (!fileSizeAndUrl.$) {
				var _v2 = fileSizeAndUrl.a;
				var fileSize = _v2.a;
				return (_Utils_cmp(fileSize, $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$maxFileBytesSize) > 0) ? _List_fromArray(
					['That file is too large! Our maximum file size is 5 mb.']) : _List_Nil;
			} else {
				return _List_fromArray(
					['Please upload a file']);
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$isValidCustomPartnerAgreement = F2(
	function (customPartnerAgreementType, fileSizeAndUrl) {
		return $elm$core$List$isEmpty(
			A2($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$customPartnerAgreementValidation, customPartnerAgreementType, fileSizeAndUrl));
	});
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var customPartnerAgreementType = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bA: $elm$core$Maybe$Just(
								_Utils_Tuple3(customPartnerAgreementType, $elm$core$Maybe$Nothing, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var addendumAgreementType = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bx: $elm$core$Maybe$Just(
								_Utils_Tuple3(addendumAgreementType, $elm$core$Maybe$Nothing, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var customApiAccessAgreementType = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							by: $elm$core$Maybe$Just(
								_Utils_Tuple3(customApiAccessAgreementType, $elm$core$Maybe$Nothing, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var customBaaAgreementType = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bz: $elm$core$Maybe$Just(
								_Utils_Tuple3(customBaaAgreementType, $elm$core$Maybe$Nothing, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bx: $elm$core$Maybe$Nothing, by: $elm$core$Maybe$Nothing, bz: $elm$core$Maybe$Nothing, bA: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var _v2 = model.bA;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var customPartnerAgreementType = _v3.a;
					var fileSizeAndUrl = _v3.b;
					if (A2($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$isValidCustomPartnerAgreement, customPartnerAgreementType, fileSizeAndUrl)) {
						var permittedFields = _List_fromArray(
							[
								$author$project$Api$Partner$Partner$CustomPartnerAgreement(
								function () {
									if (customPartnerAgreementType === 1) {
										return A2($elm$core$Maybe$map, $elm$core$Tuple$second, fileSizeAndUrl);
									} else {
										return $elm$core$Maybe$Nothing;
									}
								}())
							]);
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bA: $elm$core$Maybe$Just(
										_Utils_Tuple3(customPartnerAgreementType, fileSizeAndUrl, $author$project$Api$Data$Loading))
								}),
							A3($author$project$Api$Partner$Partner$update, apiClient, permittedFields, $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomPartnerAgreementSaved),
							_List_Nil);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var _v5 = model.bx;
				if (!_v5.$) {
					var _v6 = _v5.a;
					var addendumAgreementType = _v6.a;
					var fileSizeAndUrl = _v6.b;
					if (A2($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$isValidAddendumAgreement, addendumAgreementType, fileSizeAndUrl)) {
						var permittedFields = _List_fromArray(
							[
								$author$project$Api$Partner$Partner$AddendumAgreement(
								function () {
									if (addendumAgreementType === 1) {
										return A2($elm$core$Maybe$map, $elm$core$Tuple$second, fileSizeAndUrl);
									} else {
										return $elm$core$Maybe$Nothing;
									}
								}())
							]);
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bx: $elm$core$Maybe$Just(
										_Utils_Tuple3(addendumAgreementType, fileSizeAndUrl, $author$project$Api$Data$Loading))
								}),
							A3($author$project$Api$Partner$Partner$update, apiClient, permittedFields, $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$AddendumAgreementSaved),
							_List_Nil);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var _v8 = model.by;
				if (!_v8.$) {
					var _v9 = _v8.a;
					var customApiAccessAgreementType = _v9.a;
					var fileSizeAndUrl = _v9.b;
					if (A2($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$isValidCustomApiAccessAgreement, customApiAccessAgreementType, fileSizeAndUrl)) {
						var permittedFields = _List_fromArray(
							[
								$author$project$Api$Partner$Partner$CustomApiAccessAgreement(
								function () {
									if (customApiAccessAgreementType === 1) {
										return A2($elm$core$Maybe$map, $elm$core$Tuple$second, fileSizeAndUrl);
									} else {
										return $elm$core$Maybe$Nothing;
									}
								}())
							]);
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									by: $elm$core$Maybe$Just(
										_Utils_Tuple3(customApiAccessAgreementType, fileSizeAndUrl, $author$project$Api$Data$Loading))
								}),
							A3($author$project$Api$Partner$Partner$update, apiClient, permittedFields, $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomApiAccessAgreementSaved),
							_List_Nil);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 8:
				var _v11 = model.bz;
				if (!_v11.$) {
					var _v12 = _v11.a;
					var customBaaAgreementType = _v12.a;
					var fileSizeAndUrl = _v12.b;
					if (A2($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$isValidCustomBaaAgreement, customBaaAgreementType, fileSizeAndUrl)) {
						var permittedFields = _List_fromArray(
							[
								$author$project$Api$Partner$Partner$CustomBaaAgreement(
								function () {
									if (customBaaAgreementType === 1) {
										return A2($elm$core$Maybe$map, $elm$core$Tuple$second, fileSizeAndUrl);
									} else {
										return $elm$core$Maybe$Nothing;
									}
								}())
							]);
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bz: $elm$core$Maybe$Just(
										_Utils_Tuple3(customBaaAgreementType, fileSizeAndUrl, $author$project$Api$Data$Loading))
								}),
							A3($author$project$Api$Partner$Partner$update, apiClient, permittedFields, $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomBaaAgreementSaved),
							_List_Nil);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var response = msg.a;
				var _v14 = model.bA;
				if (!_v14.$) {
					var _v15 = _v14.a;
					var customPartnerAgreementType = _v15.a;
					var customPartnerAgreementFile = _v15.b;
					if (response.$ === 3) {
						var partner = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{bA: $elm$core$Maybe$Nothing, YN: partner}),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Partner updated successfully!'),
									$author$project$OutMsg$RefreshPartner
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bA: $elm$core$Maybe$Just(
										_Utils_Tuple3(customPartnerAgreementType, customPartnerAgreementFile, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 10:
				var response = msg.a;
				var _v17 = model.bx;
				if (!_v17.$) {
					var _v18 = _v17.a;
					var addendumAgreementType = _v18.a;
					var addendumAgreementFile = _v18.b;
					if (response.$ === 3) {
						var partner = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{bx: $elm$core$Maybe$Nothing, YN: partner}),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Partner updated successfully!'),
									$author$project$OutMsg$RefreshPartner
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bx: $elm$core$Maybe$Just(
										_Utils_Tuple3(addendumAgreementType, addendumAgreementFile, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 11:
				var response = msg.a;
				var _v20 = model.by;
				if (!_v20.$) {
					var _v21 = _v20.a;
					var customApiAccessAgreementType = _v21.a;
					var customApiAccessAgreementFile = _v21.b;
					if (response.$ === 3) {
						var partner = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{by: $elm$core$Maybe$Nothing, YN: partner}),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Partner updated successfully!'),
									$author$project$OutMsg$RefreshPartner
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									by: $elm$core$Maybe$Just(
										_Utils_Tuple3(customApiAccessAgreementType, customApiAccessAgreementFile, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 12:
				var response = msg.a;
				var _v23 = model.bz;
				if (!_v23.$) {
					var _v24 = _v23.a;
					var customBaaAgreementType = _v24.a;
					var customBaaAgreementFile = _v24.b;
					if (response.$ === 3) {
						var partner = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{bz: $elm$core$Maybe$Nothing, YN: partner}),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Partner updated successfully!'),
									$author$project$OutMsg$RefreshPartner
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bz: $elm$core$Maybe$Just(
										_Utils_Tuple3(customBaaAgreementType, customBaaAgreementFile, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 13:
				var files = msg.a;
				var cmd = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						function (_v26) {
							var task = _v26.a;
							var size = _v26.b;
							return A2(
								$elm$core$Task$perform,
								$author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomPartnerAgreementProcessed(size),
								task);
						},
						A2(
							$elm$core$Maybe$map,
							function (file) {
								return _Utils_Tuple2(
									$elm$file$File$toUrl(file),
									$elm$file$File$size(file));
							},
							$elm$core$List$head(files))));
				return _Utils_Tuple3(model, cmd, _List_Nil);
			case 14:
				var size = msg.a;
				var url = msg.b;
				var _v27 = model.bA;
				if (!_v27.$) {
					var _v28 = _v27.a;
					var customPartnerAgreementType = _v28.a;
					var request = _v28.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bA: $elm$core$Maybe$Just(
									_Utils_Tuple3(
										customPartnerAgreementType,
										$elm$core$Maybe$Just(
											_Utils_Tuple2(size, url)),
										request))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 15:
				var files = msg.a;
				var cmd = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						function (_v29) {
							var task = _v29.a;
							var size = _v29.b;
							return A2(
								$elm$core$Task$perform,
								$author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$AddendumAgreementProcessed(size),
								task);
						},
						A2(
							$elm$core$Maybe$map,
							function (file) {
								return _Utils_Tuple2(
									$elm$file$File$toUrl(file),
									$elm$file$File$size(file));
							},
							$elm$core$List$head(files))));
				return _Utils_Tuple3(model, cmd, _List_Nil);
			case 16:
				var size = msg.a;
				var url = msg.b;
				var _v30 = model.bx;
				if (!_v30.$) {
					var _v31 = _v30.a;
					var addendumAgreementType = _v31.a;
					var request = _v31.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bx: $elm$core$Maybe$Just(
									_Utils_Tuple3(
										addendumAgreementType,
										$elm$core$Maybe$Just(
											_Utils_Tuple2(size, url)),
										request))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 17:
				var files = msg.a;
				var cmd = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						function (_v32) {
							var task = _v32.a;
							var size = _v32.b;
							return A2(
								$elm$core$Task$perform,
								$author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomApiAccessAgreementProcessed(size),
								task);
						},
						A2(
							$elm$core$Maybe$map,
							function (file) {
								return _Utils_Tuple2(
									$elm$file$File$toUrl(file),
									$elm$file$File$size(file));
							},
							$elm$core$List$head(files))));
				return _Utils_Tuple3(model, cmd, _List_Nil);
			case 18:
				var size = msg.a;
				var url = msg.b;
				var _v33 = model.by;
				if (!_v33.$) {
					var _v34 = _v33.a;
					var customApiAccessAgreementType = _v34.a;
					var request = _v34.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								by: $elm$core$Maybe$Just(
									_Utils_Tuple3(
										customApiAccessAgreementType,
										$elm$core$Maybe$Just(
											_Utils_Tuple2(size, url)),
										request))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 19:
				var files = msg.a;
				var cmd = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						function (_v35) {
							var task = _v35.a;
							var size = _v35.b;
							return A2(
								$elm$core$Task$perform,
								$author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomBaaAgreementProcessed(size),
								task);
						},
						A2(
							$elm$core$Maybe$map,
							function (file) {
								return _Utils_Tuple2(
									$elm$file$File$toUrl(file),
									$elm$file$File$size(file));
							},
							$elm$core$List$head(files))));
				return _Utils_Tuple3(model, cmd, _List_Nil);
			case 20:
				var size = msg.a;
				var url = msg.b;
				var _v36 = model.bz;
				if (!_v36.$) {
					var _v37 = _v36.a;
					var customBaaAgreementType = _v37.a;
					var request = _v37.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bz: $elm$core$Maybe$Just(
									_Utils_Tuple3(
										customBaaAgreementType,
										$elm$core$Maybe$Just(
											_Utils_Tuple2(size, url)),
										request))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 21:
				return _Utils_Tuple3(
					model,
					A2($author$project$Api$Partner$Partner$signedCustomPartnerAgreementUrl, apiClient, $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$GotCustomPartnerAgreementUrl),
					_List_Nil);
			case 22:
				var response = msg.a;
				if (response.$ === 3) {
					var url = response.a;
					return _Utils_Tuple3(
						model,
						$author$project$Ports$Navigation$openInNewWindow(url),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 23:
				return _Utils_Tuple3(
					model,
					A2($author$project$Api$Partner$Partner$signedAddendumAgreementUrl, apiClient, $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$GotAddendumAgreementUrl),
					_List_Nil);
			case 24:
				var response = msg.a;
				if (response.$ === 3) {
					var url = response.a;
					return _Utils_Tuple3(
						model,
						$author$project$Ports$Navigation$openInNewWindow(url),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 25:
				return _Utils_Tuple3(
					model,
					A2($author$project$Api$Partner$Partner$signedCustomApiAccessAgreementUrl, apiClient, $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$GotCustomApiAccessAgreementUrl),
					_List_Nil);
			case 26:
				var response = msg.a;
				if (response.$ === 3) {
					var url = response.a;
					return _Utils_Tuple3(
						model,
						$author$project$Ports$Navigation$openInNewWindow(url),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 27:
				return _Utils_Tuple3(
					model,
					A2($author$project$Api$Partner$Partner$signedCustomBaaAgreementUrl, apiClient, $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$GotCustomBaaAgreementUrl),
					_List_Nil);
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var url = response.a;
					return _Utils_Tuple3(
						model,
						$author$project$Ports$Navigation$openInNewWindow(url),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Partner$Hinter$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A3($author$project$Components$Hinter$EditPartnerForm$update, model.Gv, subMsg, model.bJ);
				var partnerForm = _v1.a;
				var cmd = _v1.b;
				var outMsgs = _v1.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bJ: partnerForm}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Hinter$PartnerFormMsg, cmd),
					outMsgs);
			case 1:
				var subMsg = msg.a;
				var _v2 = A3($author$project$Components$Partner$AdminSettings$ManagedByForm$update, model.Gv, subMsg, model.kh);
				var managedByForm = _v2.a;
				var managedByFormCmd = _v2.b;
				var managedByForOutMsgs = _v2.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{kh: managedByForm}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Hinter$ManagedByFormMsg, managedByFormCmd),
					managedByForOutMsgs);
			case 2:
				var subMsg = msg.a;
				var _v3 = A3($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$update, model.Gv, subMsg, model.ky);
				var partnerDocumentsForm = _v3.a;
				var partnerDocumentsFormCmd = _v3.b;
				var partnerDocumentsFormOutMsgs = _v3.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ky: partnerDocumentsForm}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Hinter$PartnerDocumentsFormMsg, partnerDocumentsFormCmd),
					partnerDocumentsFormOutMsgs);
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ll: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var confirmed = msg.a;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{ll: false}),
					A2($author$project$Api$Partner$Partner$archive, model.Gv, $author$project$Pages$Partner$Hinter$PartnerArchived),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{ll: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var partner = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{YN: partner}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[$author$project$OutMsg$RefreshPartner]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Components$Partner$AdminSettings$ManagedByForm$SaveManagedBy = {$: 3};
var $author$project$Api$Partner$Partner$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Partner$Partner$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$id(shared);
};
var $author$project$Components$Partner$AdminSettings$ManagedByForm$viewEditManagedByModal = F3(
	function (managedByInput, request, model) {
		var modalConfig = {
			Tq: $elm$core$Maybe$Nothing,
			aih: 'Managed By',
			V8: _Utils_eq(request, $author$project$Api$Data$Loading),
			WG: $elm$core$Maybe$Just(
				$author$project$Api$Partner$Partner$One$id(model.YN)),
			WH: $elm$core$Maybe$Nothing,
			Yd: $author$project$Components$Partner$AdminSettings$ManagedByForm$CancelEditManagedBy,
			Yf: $elm$core$Basics$always($author$project$Components$Partner$AdminSettings$ManagedByForm$SaveManagedBy)
		};
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Components$Partner$AdminSettings$ManagedByForm$ManagedByInputMsg,
					$author$project$Components$Partner$AdminSettings$ManagedByInput$view(managedByInput))
				]));
	});
var $author$project$Components$Partner$AdminSettings$ManagedByForm$modal = function (_v0) {
	var model = _v0;
	var _v1 = model.a8;
	if (!_v1.$) {
		var _v2 = _v1.a;
		var managedByInput = _v2.a;
		var request = _v2.b;
		return A3($author$project$Components$Partner$AdminSettings$ManagedByForm$viewEditManagedByModal, managedByInput, request, model);
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$AddendumAgreementTypeNone = 0;
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$AddendumAgreementTypePdf = 1;
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$AddendumAgreementUploaded = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$SaveAddendumAgreement = {$: 6};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$EditAddendumAgreement = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewAddendumAgreementTypeButton = F3(
	function (currentAddendumAgreementType, addendumAgreementType, label) {
		return A3(
			$author$project$Ui$Button$view,
			{mm: label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(currentAddendumAgreementType, addendumAgreementType)),
					$author$project$Ui$Button$onClick(
					$author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$EditAddendumAgreement(addendumAgreementType))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewEditAddendumAgreementModal = F4(
	function (addendumAgreementType, fileSizeAndUrl, request, model) {
		var modalConfig = {
			Tq: $elm$core$Maybe$Nothing,
			aih: 'Addendum Agreement',
			V8: _Utils_eq(request, $author$project$Api$Data$Loading),
			WG: $elm$core$Maybe$Just(
				$author$project$Api$Partner$Partner$One$id(model.YN)),
			WH: $elm$core$Maybe$Just('Updating the addendum agreement will remove the acceptance of the addendum agreement.'),
			Yd: $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CancelEdit,
			Yf: $elm$core$Basics$always($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$SaveAddendumAgreement)
		};
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Addendum Agreement')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Button$group(
							_List_fromArray(
								[
									A3($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewAddendumAgreementTypeButton, addendumAgreementType, 0, 'None'),
									A3($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewAddendumAgreementTypeButton, addendumAgreementType, 1, 'PDF')
								]))
						])),
					function () {
					if (addendumAgreementType === 1) {
						return A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$labelSpan(4),
									$author$project$Ui$Form$Group$inputSpan(8),
									$author$project$Ui$Form$Group$label('PDF')
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$File$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$File$accept(2),
											$author$project$Ui$Form$File$onInput($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$AddendumAgreementUploaded)
										])),
									$author$project$Utils$FormErrors$view(
									A2($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$addendumAgreementValidation, addendumAgreementType, fileSizeAndUrl))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]));
	});
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomApiAccessAgreementTypeNone = 0;
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomApiAccessAgreementTypePdf = 1;
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomApiAccessAgreementUploaded = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$SaveCustomApiAccessAgreement = {$: 7};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$EditCustomApiAccessAgreement = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewCustomApiAccessAgreementTypeButton = F3(
	function (currentCustomApiAccessAgreementType, customApiAccessAgreementType, label) {
		return A3(
			$author$project$Ui$Button$view,
			{mm: label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(currentCustomApiAccessAgreementType, customApiAccessAgreementType)),
					$author$project$Ui$Button$onClick(
					$author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$EditCustomApiAccessAgreement(customApiAccessAgreementType))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewEditCustomApiAccessAgreementModal = F4(
	function (customApiAccessAgreementType, fileSizeAndUrl, request, model) {
		var modalConfig = {
			Tq: $elm$core$Maybe$Nothing,
			aih: 'Custom Api Access Agreement',
			V8: _Utils_eq(request, $author$project$Api$Data$Loading),
			WG: $elm$core$Maybe$Just(
				$author$project$Api$Partner$Partner$One$id(model.YN)),
			WH: $elm$core$Maybe$Just('Updating the custom api access agreement will remove the acceptance of the api access agreement.'),
			Yd: $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CancelEdit,
			Yf: $elm$core$Basics$always($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$SaveCustomApiAccessAgreement)
		};
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Custom Api Access Agreement')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Button$group(
							_List_fromArray(
								[
									A3($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewCustomApiAccessAgreementTypeButton, customApiAccessAgreementType, 0, 'None'),
									A3($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewCustomApiAccessAgreementTypeButton, customApiAccessAgreementType, 1, 'PDF')
								]))
						])),
					function () {
					if (customApiAccessAgreementType === 1) {
						return A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$labelSpan(4),
									$author$project$Ui$Form$Group$inputSpan(8),
									$author$project$Ui$Form$Group$label('PDF')
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$File$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$File$accept(2),
											$author$project$Ui$Form$File$onInput($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomApiAccessAgreementUploaded)
										])),
									$author$project$Utils$FormErrors$view(
									A2($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$customApiAccessAgreementValidation, customApiAccessAgreementType, fileSizeAndUrl))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]));
	});
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomBaaAgreementTypeNone = 0;
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomBaaAgreementTypePdf = 1;
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomBaaAgreementUploaded = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$SaveCustomBaaAgreement = {$: 8};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$EditCustomBaaAgreement = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewCustomBaaAgreementTypeButton = F3(
	function (currentCustomBaaAgreementType, customBaaAgreementType, label) {
		return A3(
			$author$project$Ui$Button$view,
			{mm: label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(currentCustomBaaAgreementType, customBaaAgreementType)),
					$author$project$Ui$Button$onClick(
					$author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$EditCustomBaaAgreement(customBaaAgreementType))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewEditCustomBaaAgreementModal = F4(
	function (customBaaAgreementType, fileSizeAndUrl, request, model) {
		var modalConfig = {
			Tq: $elm$core$Maybe$Nothing,
			aih: 'Custom BAA Agreement',
			V8: _Utils_eq(request, $author$project$Api$Data$Loading),
			WG: $elm$core$Maybe$Just(
				$author$project$Api$Partner$Partner$One$id(model.YN)),
			WH: $elm$core$Maybe$Just('Updating the custom BAA agreement will remove the acceptance of the BAA agreement.'),
			Yd: $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CancelEdit,
			Yf: $elm$core$Basics$always($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$SaveCustomBaaAgreement)
		};
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Custom BAA Agreement')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Button$group(
							_List_fromArray(
								[
									A3($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewCustomBaaAgreementTypeButton, customBaaAgreementType, 0, 'None'),
									A3($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewCustomBaaAgreementTypeButton, customBaaAgreementType, 1, 'PDF')
								]))
						])),
					function () {
					if (customBaaAgreementType === 1) {
						return A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$labelSpan(4),
									$author$project$Ui$Form$Group$inputSpan(8),
									$author$project$Ui$Form$Group$label('PDF')
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$File$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$File$accept(2),
											$author$project$Ui$Form$File$onInput($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomBaaAgreementUploaded)
										])),
									$author$project$Utils$FormErrors$view(
									A2($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$customBaaAgreementValidation, customBaaAgreementType, fileSizeAndUrl))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]));
	});
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomPartnerAgreementTypeNone = 0;
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomPartnerAgreementTypePdf = 1;
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomPartnerAgreementUploaded = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$SaveCustomPartnerAgreement = {$: 5};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$EditCustomPartnerAgreement = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewCustomPartnerAgreementTypeButton = F3(
	function (currentCustomPartnerAgreementType, customPartnerAgreementType, label) {
		return A3(
			$author$project$Ui$Button$view,
			{mm: label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(currentCustomPartnerAgreementType, customPartnerAgreementType)),
					$author$project$Ui$Button$onClick(
					$author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$EditCustomPartnerAgreement(customPartnerAgreementType))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewEditCustomPartnerAgreementModal = F4(
	function (customPartnerAgreementType, fileSizeAndUrl, request, model) {
		var modalConfig = {
			Tq: $elm$core$Maybe$Nothing,
			aih: 'Custom Partner Agreement',
			V8: _Utils_eq(request, $author$project$Api$Data$Loading),
			WG: $elm$core$Maybe$Just(
				$author$project$Api$Partner$Partner$One$id(model.YN)),
			WH: $elm$core$Maybe$Just('Updating the custom partner agreement will remove the acceptance of the partner agreement.'),
			Yd: $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CancelEdit,
			Yf: $elm$core$Basics$always($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$SaveCustomPartnerAgreement)
		};
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Custom Partner Agreement')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Button$group(
							_List_fromArray(
								[
									A3($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewCustomPartnerAgreementTypeButton, customPartnerAgreementType, 0, 'None'),
									A3($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewCustomPartnerAgreementTypeButton, customPartnerAgreementType, 1, 'PDF')
								]))
						])),
					function () {
					if (customPartnerAgreementType === 1) {
						return A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$labelSpan(4),
									$author$project$Ui$Form$Group$inputSpan(8),
									$author$project$Ui$Form$Group$label('PDF')
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$File$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$File$accept(2),
											$author$project$Ui$Form$File$onInput($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomPartnerAgreementUploaded)
										])),
									$author$project$Utils$FormErrors$view(
									A2($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$customPartnerAgreementValidation, customPartnerAgreementType, fileSizeAndUrl))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]));
	});
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$modal = function (_v0) {
	var model = _v0;
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				function () {
				var _v1 = model.bA;
				if (!_v1.$) {
					var _v2 = _v1.a;
					var customPartnerAgreementType = _v2.a;
					var fileSizeAndUrl = _v2.b;
					var request = _v2.c;
					return A4($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewEditCustomPartnerAgreementModal, customPartnerAgreementType, fileSizeAndUrl, request, model);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v3 = model.bx;
				if (!_v3.$) {
					var _v4 = _v3.a;
					var addendumAgreementType = _v4.a;
					var fileSizeAndUrl = _v4.b;
					var request = _v4.c;
					return A4($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewEditAddendumAgreementModal, addendumAgreementType, fileSizeAndUrl, request, model);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v5 = model.by;
				if (!_v5.$) {
					var _v6 = _v5.a;
					var customApiAccessAgreementType = _v6.a;
					var fileSizeAndUrl = _v6.b;
					var request = _v6.c;
					return A4($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewEditCustomApiAccessAgreementModal, customApiAccessAgreementType, fileSizeAndUrl, request, model);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v7 = model.bz;
				if (!_v7.$) {
					var _v8 = _v7.a;
					var customBaaAgreementType = _v8.a;
					var fileSizeAndUrl = _v8.b;
					var request = _v8.c;
					return A4($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewEditCustomBaaAgreementModal, customBaaAgreementType, fileSizeAndUrl, request, model);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]));
};
var $author$project$Components$Hinter$EditPartnerForm$Active = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Hinter$EditPartnerForm$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Hinter$EditPartnerForm$PracticesReadOnly = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Hinter$EditPartnerForm$SandboxEnabled = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Hinter$EditPartnerForm$Save = {$: 1};
var $author$project$Components$Hinter$EditPartnerForm$view = function (_v0) {
	var model = _v0;
	var loading = _Utils_eq(model.qP, $author$project$Api$Data$Loading);
	var fields = $author$project$Utils$Form$fields(model.SD);
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Live API Enabled')
					]),
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$view(
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$on(fields.KN),
								$author$project$Ui$ToggleSwitch$onChange(
								A2($elm$core$Basics$composeL, $author$project$Components$Hinter$EditPartnerForm$FormUpdated, $author$project$Components$Hinter$EditPartnerForm$Active))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Sandbox Enabled')
					]),
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$view(
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$on(fields.aao),
								$author$project$Ui$ToggleSwitch$onChange(
								A2($elm$core$Basics$composeL, $author$project$Components$Hinter$EditPartnerForm$FormUpdated, $author$project$Components$Hinter$EditPartnerForm$SandboxEnabled))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Practices Read Only')
					]),
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$view(
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$on(fields.Z1),
								$author$project$Ui$ToggleSwitch$onChange(
								A2($elm$core$Basics$composeL, $author$project$Components$Hinter$EditPartnerForm$FormUpdated, $author$project$Components$Hinter$EditPartnerForm$PracticesReadOnly))
							]))
					])),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$textCenter, $author$project$Ui$Element$mt2]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Save partner changes'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$submit,
								$author$project$Ui$Button$loading(loading),
								$author$project$Ui$Button$onClick($author$project$Components$Hinter$EditPartnerForm$Save)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Save')
							]))
					]))
			]));
};
var $author$project$Components$Partner$AdminSettings$ManagedByForm$EditManagedBy = {$: 1};
var $author$project$Api$Partner$ManagementGroup$Min$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Components$Partner$AdminSettings$ManagedByForm$view = function (_v0) {
	var model = _v0;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('Managed By')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$spaceBetween]),
						_List_fromArray(
							[
								function () {
								var _v1 = $author$project$Api$Partner$Partner$One$managedBy(model.YN);
								if (!_v1.$) {
									if (!_v1.a.$) {
										var practice = _v1.a.a;
										return $elm$html$Html$text(
											$author$project$Api$Partner$Practice$Min$name(practice) + (' (' + ($author$project$Api$Partner$Practice$Min$id(practice) + ')')));
									} else {
										var managementGroup = _v1.a.a;
										return $elm$html$Html$text(
											$author$project$Api$Partner$ManagementGroup$Min$name(managementGroup) + (' (' + ($author$project$Api$Partner$ManagementGroup$Min$id(managementGroup) + ')')));
									}
								} else {
									return $elm$html$Html$text('None');
								}
							}(),
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Change managed by'},
								_List_fromArray(
									[
										$author$project$Ui$Button$sm,
										$author$project$Ui$Button$onClick($author$project$Components$Partner$AdminSettings$ManagedByForm$EditManagedBy)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Change')
									]))
							]))
					]))
			]));
};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$OpenAddendumAgreement = {$: 23};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$OpenCustomApiAccessAgreement = {$: 25};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$OpenCustomBaaAgreement = {$: 27};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$OpenCustomPartnerAgreement = {$: 21};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$view = function (_v0) {
	var model = _v0;
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Custom Partner Agreement')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween]),
								_List_fromArray(
									[
										function () {
										var _v1 = $author$project$Api$Partner$Partner$One$customPartnerAgreementFileName(model.YN);
										if (!_v1.$) {
											return A3(
												$author$project$Ui$Button$view,
												{mm: 'View custom partner agreement'},
												_List_fromArray(
													[
														$author$project$Ui$Button$link,
														$author$project$Ui$Button$onClick($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$OpenCustomPartnerAgreement)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('View custom partner agreement')
													]));
										} else {
											return $elm$html$Html$text('None');
										}
									}(),
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Manage custom partner agreement'},
										_List_fromArray(
											[
												$author$project$Ui$Button$sm,
												$author$project$Ui$Button$onClick(
												$author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$EditCustomPartnerAgreement(0))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Manage')
											]))
									]))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Addendum Agreement')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween]),
								_List_fromArray(
									[
										function () {
										var _v2 = $author$project$Api$Partner$Partner$One$addendumAgreementFileName(model.YN);
										if (!_v2.$) {
											return A3(
												$author$project$Ui$Button$view,
												{mm: 'View addendum agreement'},
												_List_fromArray(
													[
														$author$project$Ui$Button$link,
														$author$project$Ui$Button$onClick($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$OpenAddendumAgreement)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('View addendum agreement')
													]));
										} else {
											return $elm$html$Html$text('None');
										}
									}(),
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Manage addendum agreement'},
										_List_fromArray(
											[
												$author$project$Ui$Button$sm,
												$author$project$Ui$Button$onClick(
												$author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$EditAddendumAgreement(0))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Manage')
											]))
									]))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Custom Api Access Agreement')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween]),
								_List_fromArray(
									[
										function () {
										var _v3 = $author$project$Api$Partner$Partner$One$customApiAccessAgreementFileName(model.YN);
										if (!_v3.$) {
											return A3(
												$author$project$Ui$Button$view,
												{mm: 'View custom api access agreement'},
												_List_fromArray(
													[
														$author$project$Ui$Button$link,
														$author$project$Ui$Button$onClick($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$OpenCustomApiAccessAgreement)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('View custom api access agreement')
													]));
										} else {
											return $elm$html$Html$text('None');
										}
									}(),
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Manage custom api access agreement'},
										_List_fromArray(
											[
												$author$project$Ui$Button$sm,
												$author$project$Ui$Button$onClick(
												$author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$EditCustomApiAccessAgreement(0))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Manage')
											]))
									]))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Custom BAA Agreement')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween]),
								_List_fromArray(
									[
										function () {
										var _v4 = $author$project$Api$Partner$Partner$One$customBaaAgreementFileName(model.YN);
										if (!_v4.$) {
											return A3(
												$author$project$Ui$Button$view,
												{mm: 'View custom BAA agreement'},
												_List_fromArray(
													[
														$author$project$Ui$Button$link,
														$author$project$Ui$Button$onClick($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$OpenCustomBaaAgreement)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('View custom BAA agreement')
													]));
										} else {
											return $elm$html$Html$text('None');
										}
									}(),
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Manage custom BAA agreement'},
										_List_fromArray(
											[
												$author$project$Ui$Button$sm,
												$author$project$Ui$Button$onClick(
												$author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$EditCustomBaaAgreement(0))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Manage')
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Partner$Hinter$ArchiveClicked = {$: 3};
var $author$project$Api$Partner$Partner$Shared$archived = function (_v0) {
	var record = _v0;
	return record.L_;
};
var $author$project$Api$Partner$Partner$One$archived = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$archived(shared);
};
var $author$project$Pages$Partner$Hinter$viewArchive = function (partner) {
	return $author$project$Api$Partner$Partner$One$archived(partner) ? $elm$html$Html$text('') : A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				$author$project$Ui$Typography$headingSm(
				_List_fromArray(
					[
						$elm$html$Html$text('Archive')
					])),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm, $author$project$Ui$Element$mb4]),
				_List_fromArray(
					[
						$elm$html$Html$text('Archive this partner account. This will decommission all products, revoke api keys, deactivate integrations and remove access entirely.')
					])),
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Archive Partner'},
				_List_fromArray(
					[
						$author$project$Ui$Button$danger,
						$author$project$Ui$Button$onClick($author$project$Pages$Partner$Hinter$ArchiveClicked)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Archive')
					]))
			]));
};
var $author$project$Pages$Partner$Hinter$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				model.ll ? A2(
				$author$project$Components$HiConfirm$modal,
				$author$project$Pages$Partner$Hinter$ArchiveConfirmClosed,
				_List_fromArray(
					[
						$author$project$Components$HiConfirm$verb('archive'),
						$author$project$Components$HiConfirm$noun('partner')
					])) : $elm$html$Html$text(''),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Partner$Hinter$ManagedByFormMsg,
				$author$project$Components$Partner$AdminSettings$ManagedByForm$modal(model.kh)),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Partner$Hinter$PartnerDocumentsFormMsg,
				$author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$modal(model.ky)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Admin Actions')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Partner$Hinter$PartnerFormMsg,
								$author$project$Components$Hinter$EditPartnerForm$view(model.bJ)),
								$author$project$Ui$HorizontalRule$view(_List_Nil),
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Partner$Hinter$ManagedByFormMsg,
								$author$project$Components$Partner$AdminSettings$ManagedByForm$view(model.kh)),
								$author$project$Ui$HorizontalRule$view(_List_Nil),
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Partner$Hinter$PartnerDocumentsFormMsg,
								$author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$view(model.ky)),
								$author$project$Pages$Partner$Hinter$viewArchive(model.YN)
							]))
					]))
			]),
		ac9: 'Partner | Admin Settings'
	};
};
var $author$project$Pages$Partner$Hinter$page = $author$project$Spa$Page$applicationPartner(
	{ah_: $author$project$Pages$Partner$Hinter$init, aiq: $author$project$Pages$Partner$Hinter$load, k8: $author$project$Pages$Partner$Hinter$save, alO: $author$project$Pages$Partner$Hinter$subscriptions, adT: $author$project$Pages$Partner$Hinter$update, amo: $author$project$Pages$Partner$Hinter$view});
var $author$project$Pages$Partner$Practices$Top$GotIntegrations = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Partner$Practices$Top$fetchParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{ajJ: model.ajJ, akl: model.akl, alA: model.alA});
	};
};
var $author$project$Pages$Partner$Practices$Top$fetchIntegrations = function (model) {
	return A3(
		$author$project$Api$Partner$Integration$list,
		model.Gv,
		$author$project$Pages$Partner$Practices$Top$fetchParams(model),
		$author$project$Pages$Partner$Practices$Top$GotIntegrations);
};
var $author$project$Pages$Partner$Practices$Top$init = F4(
	function (_v0, partner, shared, _v1) {
		var query = _v1.DE;
		var model = {
			a_: $elm$core$Maybe$Nothing,
			cg: $elm$core$Maybe$Nothing,
			Gv: shared.Gv,
			iV: $elm$core$Maybe$Nothing,
			Ud: $author$project$Api$Data$Loading,
			Ij: $author$project$Shared$isHintAdmin(shared),
			ajJ: $author$project$Api$Pagination$initFromQuery(query),
			YN: partner,
			akl: A2($elm$core$Dict$get, 'q', query),
			up: $author$project$Ui$SearchInput$init(
				A2($elm$core$Dict$get, 'q', query)),
			alA: A3(
				$author$project$Api$Sort$withDefault,
				'status',
				1,
				$author$project$Api$Sort$initFromQuery(query)),
			aD: $elm$core$Maybe$Nothing
		};
		return _Utils_Tuple2(
			model,
			$author$project$Pages$Partner$Practices$Top$fetchIntegrations(model));
	});
var $author$project$Pages$Partner$Practices$Top$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					Ij: $author$project$Shared$isHintAdmin(shared)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Partner$Practices$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Partner$Practices$Top$CreateChargeModalMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Partner$Practices$Top$SubscriptionModalClosed = {$: 17};
var $author$project$Components$Partner$CreatePartnerChargeModal$CloseButtonClicked = {$: 0};
var $author$project$Components$Partner$CreatePartnerChargeModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Partner$CreatePartnerChargeModal$CloseButtonClicked);
};
var $author$project$Pages$Partner$Practices$Top$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				function () {
				var _v0 = model.iV;
				if (!_v0.$) {
					var modalModel = _v0.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Pages$Partner$Practices$Top$CreateChargeModalMsg,
						$author$project$Components$Partner$CreatePartnerChargeModal$subscriptions(modalModel));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				function () {
				var _v1 = model.aD;
				if (!_v1.$) {
					return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Pages$Partner$Practices$Top$SubscriptionModalClosed);
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}()
			]));
};
var $author$project$Api$Partner$Subscription$AmountInCents = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Partner$Subscription$Description = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Partner$Practices$Top$IntegrationActivated = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Pages$Partner$Practices$Top$IntegrationCreated = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Pages$Partner$Practices$Top$SearchInputMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Partner$Practices$Top$SubscriptionSaved = function (a) {
	return {$: 21, a: a};
};
var $author$project$Api$Partner$Integration$One$Integration = 0;
var $author$project$Api$Partner$Integration$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Partner$Integration$integrationPath = function (integrationId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[integrationId]),
		$author$project$Api$Partner$Integration$integrationsPath);
};
var $author$project$Api$Partner$Integration$activate = F3(
	function (apiClient, integrationId, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$Integration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['activate']),
					$author$project$Api$Partner$Integration$integrationPath(integrationId))));
	});
var $author$project$Api$Partner$Integration$Shared$authorizationCodeExchanged = function (_v0) {
	var record = _v0;
	return record.Mf;
};
var $author$project$Api$Partner$Integration$All$authorizationCodeExchanged = function (_v0) {
	var record = _v0;
	return $author$project$Api$Partner$Integration$Shared$authorizationCodeExchanged(record.lk);
};
var $author$project$Api$Partner$Integration$create = F3(
	function (apiClient, practiceId, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'integration',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'practice',
								$author$project$Utils$Encode$association(practiceId))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$Integration$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Partner$Integration$integrationsPath)));
	});
var $author$project$Api$Partner$Subscription$Subscription = 0;
var $author$project$Api$Partner$Subscription$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Partner$Subscription$encodePermittedFields = function (permittedFields) {
	var encodedFields = A3(
		$elm$core$List$foldl,
		F2(
			function (field, acc) {
				if (!field.$) {
					var amount = field.a;
					return A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'amount_in_cents',
							$elm$json$Json$Encode$int(amount)),
						acc);
				} else {
					var description = field.a;
					return A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'description',
							$elm$json$Json$Encode$string(description)),
						acc);
				}
			}),
		_List_Nil,
		permittedFields);
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'subscription',
				$elm$json$Json$Encode$object(encodedFields))
			]));
};
var $author$project$Api$Partner$Subscription$practiceSubscriptionsPath = function (practiceId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['practices', practiceId, 'subscriptions']),
		$author$project$Api$Data$partnerPath);
};
var $author$project$Api$Partner$Subscription$create = F4(
	function (apiClient, practiceId, permittedFields, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$Subscription$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Partner$Subscription$encodePermittedFields(permittedFields),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Partner$Subscription$practiceSubscriptionsPath(practiceId))));
	});
var $author$project$Api$Partner$Integration$exchangeCode = F4(
	function (apiClient, integrationId, code, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'code',
					$elm$json$Json$Encode$string(code))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$Integration$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['exchange_code']),
						$author$project$Api$Partner$Integration$integrationPath(integrationId)))));
	});
var $author$project$Api$Partner$Practice$Shared$id = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Partner$Practice$Min$id(min);
};
var $author$project$Components$Partner$CreatePartnerChargeModal$InvoiceDateInputMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Partner$CreatePartnerChargeModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Partner$CreatePartnerChargeModal$init = F2(
	function (practiceId, practiceName) {
		var _v0 = $author$project$Components$DateInput$init;
		var dateInput = _v0.a;
		var dateInputCmd = _v0.b;
		return _Utils_Tuple2(
			{
				SD: $author$project$Utils$Form$init(
					{LE: $elm$core$Maybe$Nothing, Qr: '', Uq: $elm$core$Maybe$Nothing}),
				n3: dateInput,
				Ji: practiceId,
				ZY: practiceName,
				k9: $author$project$Api$Data$NotAsked
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$Partner$CreatePartnerChargeModal$InvoiceDateInputMsg, dateInputCmd));
	});
var $author$project$Api$Partner$Integration$All$subscription = function (_v0) {
	var record = _v0;
	return record.acz;
};
var $author$project$Components$Partner$CreatePartnerChargeModal$AmountInCents = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$CreatePartnerChargeModal$ChargeCreated = 2;
var $author$project$Components$Partner$CreatePartnerChargeModal$Closed = 1;
var $author$project$Components$Partner$CreatePartnerChargeModal$Description = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$CreatePartnerChargeModal$GotCreateResponse = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Partner$CreatePartnerChargeModal$InvoiceDate = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$CreatePartnerChargeModal$None = 0;
var $author$project$Api$Partner$Reports$PartnerCharge$One$PartnerCharge = 0;
var $author$project$Api$Partner$Reports$PartnerCharge$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Partner$Practice$PartnerCharge$create = F4(
	function (apiClient, practiceId, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'partner_charge',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$filterMap,
							$elm$core$Basics$identity,
							_List_fromArray(
								[
									$elm$core$Maybe$Just(
									_Utils_Tuple2(
										'amount_in_cents',
										$elm$json$Json$Encode$int(params.LE))),
									$elm$core$Maybe$Just(
									_Utils_Tuple2(
										'description',
										$elm$json$Json$Encode$string(params.Qr))),
									A2(
									$elm$core$Maybe$map,
									function (d) {
										return _Utils_Tuple2(
											'invoice_date',
											$author$project$Utils$Date$encode(d));
									},
									params.Uq)
								]))))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$Reports$PartnerCharge$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['practices', practiceId, 'partner_charges']),
						$author$project$Api$Data$partnerPath))));
	});
var $author$project$Components$Partner$CreatePartnerChargeModal$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var amount = field.a;
				return _Utils_update(
					fields,
					{LE: amount});
			case 1:
				var desc = field.a;
				return _Utils_update(
					fields,
					{Qr: desc});
			default:
				var date = field.a;
				return _Utils_update(
					fields,
					{Uq: date});
		}
	});
var $author$project$Components$Partner$CreatePartnerChargeModal$AmountValidation = 0;
var $author$project$Components$Partner$CreatePartnerChargeModal$validateAmount = function (fields) {
	var _v0 = fields.LE;
	if (_v0.$ === 1) {
		return _List_fromArray(
			[
				_Utils_Tuple2(0, 'Please enter an amount.')
			]);
	} else {
		var amount = _v0.a;
		var _v1 = $author$project$Currency$toFloat(amount);
		if (!_v1.$) {
			var n = _v1.a;
			return (n <= 0) ? _List_fromArray(
				[
					_Utils_Tuple2(0, 'Amount must be greater than $0.')
				]) : _List_Nil;
		} else {
			return _List_fromArray(
				[
					_Utils_Tuple2(0, 'Please enter a valid amount.')
				]);
		}
	}
};
var $author$project$Components$Partner$CreatePartnerChargeModal$DescriptionValidation = 1;
var $author$project$Components$Partner$CreatePartnerChargeModal$validateDescription = function (fields) {
	return ($elm$core$String$trim(fields.Qr) === '') ? _List_fromArray(
		[
			_Utils_Tuple2(1, 'Please enter a description.')
		]) : _List_Nil;
};
var $author$project$Components$Partner$CreatePartnerChargeModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Partner$CreatePartnerChargeModal$validateAmount),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Partner$CreatePartnerChargeModal$validateDescription)
		]));
var $author$project$Components$Partner$CreatePartnerChargeModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return _Utils_eq(model.k9, $author$project$Api$Data$Loading) ? {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil} : {GZ: $elm$core$Platform$Cmd$none, agZ: 1, aiO: model, aR: _List_Nil};
			case 2:
				var amount = msg.a;
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Partner$CreatePartnerChargeModal$formFieldsUpdate,
					$author$project$Components$Partner$CreatePartnerChargeModal$AmountInCents(amount),
					model.SD);
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{SD: newForm}),
					aR: _List_Nil
				};
			case 3:
				var desc = msg.a;
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Partner$CreatePartnerChargeModal$formFieldsUpdate,
					$author$project$Components$Partner$CreatePartnerChargeModal$Description(desc),
					model.SD);
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{SD: newForm}),
					aR: _List_Nil
				};
			case 4:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Components$DateInput$update, subMsg, model.n3);
				var newDateInput = _v2.a;
				var subCmd = _v2.b;
				var dateEvent = _v2.c;
				var newForm = function () {
					if (dateEvent.$ === 1) {
						var date = dateEvent.a;
						return A3(
							$author$project$Utils$Form$update,
							$author$project$Components$Partner$CreatePartnerChargeModal$formFieldsUpdate,
							$author$project$Components$Partner$CreatePartnerChargeModal$InvoiceDate(date),
							model.SD);
					} else {
						return A3(
							$author$project$Utils$Form$update,
							$author$project$Components$Partner$CreatePartnerChargeModal$formFieldsUpdate,
							$author$project$Components$Partner$CreatePartnerChargeModal$InvoiceDate(
								$author$project$Utils$Form$fields(model.SD).Uq),
							model.SD);
					}
				}();
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Partner$CreatePartnerChargeModal$InvoiceDateInputMsg, subCmd),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{SD: newForm, n3: newDateInput}),
					aR: _List_Nil
				};
			case 1:
				var _v4 = A2($author$project$Utils$Form$validate, $author$project$Components$Partner$CreatePartnerChargeModal$formFieldsValidator, model.SD);
				if (!_v4.$) {
					var _v5 = _v4.a;
					var newForm = _v5.a;
					var validFormFields = _v5.b;
					var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
					var amountInCents = A2(
						$elm$core$Maybe$withDefault,
						0,
						A2(
							$elm$core$Maybe$map,
							function (f) {
								return $elm$core$Basics$round(f * 100);
							},
							A2($elm$core$Maybe$andThen, $author$project$Currency$toFloat, fields.LE)));
					return {
						GZ: A4(
							$author$project$Api$Partner$Practice$PartnerCharge$create,
							apiClient,
							model.Ji,
							{LE: amountInCents, Qr: fields.Qr, Uq: fields.Uq},
							$author$project$Components$Partner$CreatePartnerChargeModal$GotCreateResponse),
						agZ: 0,
						aiO: _Utils_update(
							model,
							{SD: newForm, k9: $author$project$Api$Data$Loading}),
						aR: _List_Nil
					};
				} else {
					var newForm = _v4.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{SD: newForm}),
						aR: _List_Nil
					};
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 2,
						aiO: _Utils_update(
							model,
							{k9: $author$project$Api$Data$NotAsked}),
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Charge created successfully')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{k9: response}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
		}
	});
var $author$project$Pages$Partner$Practices$Top$updateUrl = function (model) {
	var params = _Utils_ap(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$map,
					$elm$url$Url$Builder$string('q'),
					model.akl)
				])),
		_Utils_ap(
			$author$project$Api$Sort$toQuery(model.alA),
			$author$project$Api$Pagination$toPageQuery(model.ajJ)));
	return $author$project$Ports$Navigation$replaceUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Partner__Practices__Top)
				]),
			params));
};
var $author$project$Pages$Partner$Practices$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Ud: response,
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Ud: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{Ud: $author$project$Api$Data$Loading, ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Partner$Practices$Top$fetchIntegrations(newModel),
								$author$project$Pages$Partner$Practices$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 2:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						Ud: $author$project$Api$Data$Loading,
						alA: A2($author$project$Api$Sort$update, columnId, model.alA)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Partner$Practices$Top$fetchIntegrations(newModel),
								$author$project$Pages$Partner$Practices$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 3:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Ui$SearchInput$update, subMsg, model.up);
				var searchInput = _v2.a;
				var searchInputCmd = _v2.b;
				var searchInputEvent = _v2.c;
				if (searchInputEvent.$ === 1) {
					var q = searchInputEvent.a;
					var newModel = _Utils_update(
						model,
						{
							Ud: $author$project$Api$Data$Loading,
							ajJ: $author$project$Api$Pagination$reset(model.ajJ),
							akl: q,
							up: searchInput
						});
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Practices$Top$SearchInputMsg, searchInputCmd),
									$author$project$Pages$Partner$Practices$Top$fetchIntegrations(newModel),
									$author$project$Pages$Partner$Practices$Top$updateUrl(newModel)
								])),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{up: searchInput}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Practices$Top$SearchInputMsg, searchInputCmd),
						_List_Nil);
				}
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							cg: $elm$core$Maybe$Just(
								_Utils_Tuple2($elm$core$Maybe$Nothing, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cg: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 6:
				var _v4 = model.cg;
				if (!_v4.$) {
					var _v5 = _v4.a;
					var practiceId = _v5.a;
					if (!practiceId.$) {
						var practiceId_ = practiceId.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									cg: $elm$core$Maybe$Just(
										_Utils_Tuple2(
											$elm$core$Maybe$Just(practiceId_),
											$author$project$Api$Data$Loading))
								}),
							A3(
								$author$project$Api$Partner$Integration$create,
								model.Gv,
								practiceId_,
								$author$project$Pages$Partner$Practices$Top$IntegrationCreated(practiceId_)),
							_List_Nil);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var practiceId = msg.a;
				var _v7 = model.cg;
				if (!_v7.$) {
					var _v8 = _v7.a;
					var request = _v8.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cg: $elm$core$Maybe$Just(
									_Utils_Tuple2(
										$author$project$Utils$String$toMaybe(practiceId),
										request))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 8:
				var practiceId = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cg: $elm$core$Maybe$Nothing, Ud: $author$project$Api$Data$Loading}),
						$author$project$Pages$Partner$Practices$Top$fetchIntegrations(model),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Practice added')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cg: $elm$core$Maybe$Just(
									_Utils_Tuple2(
										$elm$core$Maybe$Just(practiceId),
										response))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 9:
				var integration = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							a_: $elm$core$Maybe$Just(
								{xq: false, NN: '', T8: integration, uf: $author$project$Api$Data$NotAsked})
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 10:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{a_: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 11:
				var code = msg.a;
				var _v10 = model.a_;
				if (!_v10.$) {
					var activation = _v10.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								a_: $elm$core$Maybe$Just(
									_Utils_update(
										activation,
										{NN: code, uf: $author$project$Api$Data$NotAsked}))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 12:
				var _v11 = model.a_;
				if (!_v11.$) {
					var activation = _v11.a;
					var updatedActivation = _Utils_update(
						activation,
						{xq: true, uf: $author$project$Api$Data$NotAsked});
					var integrationId = $author$project$Api$Partner$Integration$All$id(activation.T8);
					if ($author$project$Api$Partner$Integration$All$authorizationCodeExchanged(activation.T8)) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									a_: $elm$core$Maybe$Just(
										_Utils_update(
											updatedActivation,
											{uf: $author$project$Api$Data$Loading}))
								}),
							A3(
								$author$project$Api$Partner$Integration$activate,
								model.Gv,
								integrationId,
								$author$project$Pages$Partner$Practices$Top$IntegrationActivated(integrationId)),
							_List_Nil);
					} else {
						var trimmedCode = $elm$core$String$trim(activation.NN);
						return $elm$core$String$isEmpty(trimmedCode) ? _Utils_Tuple3(
							_Utils_update(
								model,
								{
									a_: $elm$core$Maybe$Just(
										_Utils_update(
											updatedActivation,
											{NN: trimmedCode}))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil) : _Utils_Tuple3(
							_Utils_update(
								model,
								{
									a_: $elm$core$Maybe$Just(
										_Utils_update(
											updatedActivation,
											{NN: trimmedCode, uf: $author$project$Api$Data$Loading}))
								}),
							A4(
								$author$project$Api$Partner$Integration$exchangeCode,
								model.Gv,
								integrationId,
								trimmedCode,
								$author$project$Pages$Partner$Practices$Top$IntegrationActivated(integrationId)),
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 13:
				var integrationId = msg.a;
				var response = msg.b;
				var _v12 = model.a_;
				if (!_v12.$) {
					var activation = _v12.a;
					if (_Utils_eq(
						$author$project$Api$Partner$Integration$All$id(activation.T8),
						integrationId)) {
						if (response.$ === 3) {
							var newModel = _Utils_update(
								model,
								{a_: $elm$core$Maybe$Nothing, Ud: $author$project$Api$Data$Loading});
							return _Utils_Tuple3(
								newModel,
								$author$project$Pages$Partner$Practices$Top$fetchIntegrations(newModel),
								_List_fromArray(
									[
										A2($author$project$OutMsg$ShowToast, 3, 'Practice activated')
									]));
						} else {
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										a_: $elm$core$Maybe$Just(
											_Utils_update(
												activation,
												{uf: response}))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$OutMsg$handleErrorResponse(response));
						}
					} else {
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 14:
				var integration = msg.a;
				var practice = $author$project$Api$Partner$Integration$All$practice(integration);
				var _v14 = A2(
					$author$project$Components$Partner$CreatePartnerChargeModal$init,
					$author$project$Api$Partner$Practice$Shared$id(practice),
					$author$project$Api$Partner$Practice$Shared$name(practice));
				var modalModel = _v14.a;
				var modalCmd = _v14.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							iV: $elm$core$Maybe$Just(modalModel)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Practices$Top$CreateChargeModalMsg, modalCmd),
					_List_Nil);
			case 15:
				var subMsg = msg.a;
				var _v15 = model.iV;
				if (!_v15.$) {
					var modalModel = _v15.a;
					var result = A3($author$project$Components$Partner$CreatePartnerChargeModal$update, model.Gv, subMsg, modalModel);
					var _v16 = result.agZ;
					switch (_v16) {
						case 1:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{iV: $elm$core$Maybe$Nothing}),
								$elm$core$Platform$Cmd$none,
								result.aR);
						case 2:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{iV: $elm$core$Maybe$Nothing, Ud: $author$project$Api$Data$Loading}),
								$author$project$Pages$Partner$Practices$Top$fetchIntegrations(model),
								result.aR);
						default:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										iV: $elm$core$Maybe$Just(result.aiO)
									}),
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Practices$Top$CreateChargeModalMsg, result.GZ),
								result.aR);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 16:
				var integration = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aD: $elm$core$Maybe$Just(
								{
									mk: A2(
										$elm$core$Maybe$map,
										A2($elm$core$Basics$composeR, $author$project$Api$Common$PartnerSubscription$Min$amountInCents, $author$project$Currency$fromInt),
										$author$project$Api$Partner$Integration$All$subscription(integration)),
									xq: false,
									Qr: A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											$author$project$Api$Partner$PartnerProduct$Shared$name,
											$author$project$Api$Partner$Partner$One$product(model.YN))),
									T8: integration,
									uf: $author$project$Api$Data$NotAsked
								})
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 17:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aD: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 18:
				var value = msg.a;
				var _v17 = model.aD;
				if (!_v17.$) {
					var modal = _v17.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aD: $elm$core$Maybe$Just(
									_Utils_update(
										modal,
										{mk: value}))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 19:
				var value = msg.a;
				var _v18 = model.aD;
				if (!_v18.$) {
					var modal = _v18.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aD: $elm$core$Maybe$Just(
									_Utils_update(
										modal,
										{Qr: value}))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 20:
				var _v19 = model.aD;
				if (!_v19.$) {
					var modal = _v19.a;
					var _v20 = A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, modal.mk);
					if (!_v20.$) {
						var cents = _v20.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aD: $elm$core$Maybe$Just(
										_Utils_update(
											modal,
											{uf: $author$project$Api$Data$Loading}))
								}),
							A4(
								$author$project$Api$Partner$Subscription$create,
								model.Gv,
								$author$project$Api$Partner$Practice$Shared$id(
									$author$project$Api$Partner$Integration$All$practice(modal.T8)),
								_List_fromArray(
									[
										$author$project$Api$Partner$Subscription$AmountInCents(cents),
										$author$project$Api$Partner$Subscription$Description(modal.Qr)
									]),
								$author$project$Pages$Partner$Practices$Top$SubscriptionSaved),
							_List_Nil);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aD: $elm$core$Maybe$Just(
										_Utils_update(
											modal,
											{xq: true}))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Ud: $author$project$Api$Data$Loading, aD: $elm$core$Maybe$Nothing}),
						$author$project$Pages$Partner$Practices$Top$fetchIntegrations(model),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Subscription saved')
							]));
				} else {
					var _v22 = model.aD;
					if (!_v22.$) {
						var modal = _v22.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aD: $elm$core$Maybe$Just(
										_Utils_update(
											modal,
											{uf: response}))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					} else {
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				}
		}
	});
var $author$project$Pages$Partner$Practices$Top$New = {$: 4};
var $author$project$Pages$Partner$Practices$Top$PaginationMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$CreatePartnerChargeModal$AmountChanged = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$CreatePartnerChargeModal$DescriptionChanged = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Partner$CreatePartnerChargeModal$FormSubmitted = {$: 1};
var $author$project$Components$Partner$CreatePartnerChargeModal$view = function (_v0) {
	var model = _v0;
	var isLoading = _Utils_eq(model.k9, $author$project$Api$Data$Loading);
	var fields = $author$project$Utils$Form$fields(model.SD);
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Partner$CreatePartnerChargeModal$CloseButtonClicked,
		_List_fromArray(
			[
				$author$project$Ui$Modal$onSubmit($author$project$Components$Partner$CreatePartnerChargeModal$FormSubmitted)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Create Charge — ' + model.ZY)
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$spaceY4]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$label('Amount'),
												$author$project$Ui$Form$Group$required(true),
												$author$project$Ui$Form$Group$labelSpan(4),
												$author$project$Ui$Form$Group$inputSpan(8)
											]),
										_List_fromArray(
											[
												$author$project$Ui$Form$CurrencyInput$view(
												_List_fromArray(
													[
														$author$project$Ui$Form$CurrencyInput$value(fields.LE),
														$author$project$Ui$Form$CurrencyInput$onInput($author$project$Components$Partner$CreatePartnerChargeModal$AmountChanged),
														$author$project$Ui$Form$CurrencyInput$invalid(
														A2($author$project$Utils$Form$hasValidationErrors, 0, model.SD)),
														$author$project$Ui$Form$CurrencyInput$errors(
														A2($author$project$Utils$Form$validationErrors, 0, model.SD)),
														$author$project$Ui$Form$CurrencyInput$disabled(isLoading)
													]))
											])),
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$label('Description'),
												$author$project$Ui$Form$Group$required(true),
												$author$project$Ui$Form$Group$labelSpan(4),
												$author$project$Ui$Form$Group$inputSpan(8)
											]),
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$view(
												_List_fromArray(
													[
														$author$project$Ui$Form$Input$value(fields.Qr),
														$author$project$Ui$Form$Input$onInput($author$project$Components$Partner$CreatePartnerChargeModal$DescriptionChanged),
														$author$project$Ui$Form$Input$invalid(
														A2($author$project$Utils$Form$hasValidationErrors, 1, model.SD)),
														$author$project$Ui$Form$Input$errors(
														A2($author$project$Utils$Form$validationErrors, 1, model.SD)),
														$author$project$Ui$Form$Input$disabled(isLoading)
													]))
											])),
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$label('Auto Collection Date'),
												$author$project$Ui$Form$Group$labelSpan(4),
												$author$project$Ui$Form$Group$inputSpan(8)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Components$Partner$CreatePartnerChargeModal$InvoiceDateInputMsg,
												A2(
													$author$project$Components$DateInput$view,
													_List_fromArray(
														[
															$author$project$Components$DateInput$value(fields.Uq),
															$author$project$Components$DateInput$placeholder('Leave blank for next billing date'),
															$author$project$Components$DateInput$disabled(isLoading)
														]),
													model.n3)),
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
												_List_fromArray(
													[
														$elm$html$Html$text('If left blank, aligns with the practice\'s next billing cycle.')
													]))
											]))
									]))
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Partner$CreatePartnerChargeModal$CloseButtonClicked),
								$author$project$Ui$Button$disabled(isLoading)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Create charge'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$onClick($author$project$Components$Partner$CreatePartnerChargeModal$FormSubmitted),
								$author$project$Ui$Button$loading(isLoading),
								$author$project$Ui$Button$disabled(isLoading)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Create Charge')
							]))
					]))
			]));
};
var $author$project$Pages$Partner$Practices$Top$ActivateIntegrationClosed = {$: 10};
var $author$project$Pages$Partner$Practices$Top$ActivateIntegrationCodeChanged = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Partner$Practices$Top$ActivateIntegrationSubmitted = {$: 12};
var $author$project$Pages$Partner$Practices$Top$viewActivateIntegrationModal = function (activation) {
	var practiceName = $author$project$Api$Partner$Practice$Shared$name(
		$author$project$Api$Partner$Integration$All$practice(activation.T8));
	var isLoading = _Utils_eq(activation.uf, $author$project$Api$Data$Loading);
	var codeAlreadyExchanged = $author$project$Api$Partner$Integration$All$authorizationCodeExchanged(activation.T8);
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Pages$Partner$Practices$Top$ActivateIntegrationClosed,
		_List_fromArray(
			[
				$author$project$Ui$Modal$onSubmit($author$project$Pages$Partner$Practices$Top$ActivateIntegrationSubmitted)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Activate Practice Integration')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$spaceY4]),
						function () {
							if (codeAlreadyExchanged) {
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Are you sure you want to activate the integration with ' + (practiceName + '?'))
											]))
									]);
							} else {
								var showCodeError = activation.xq && $elm$core$String$isEmpty(
									$elm$core$String$trim(activation.NN));
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Enter the authorization code ' + (practiceName + ' shared with you to complete the connection.'))
											])),
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$label('Authorization Code'),
												$author$project$Ui$Form$Group$required(true),
												$author$project$Ui$Form$Group$labelSpanSm(4),
												$author$project$Ui$Form$Group$inputSpanSm(8)
											]),
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$view(
												_List_fromArray(
													[
														$author$project$Ui$Form$Input$value(activation.NN),
														$author$project$Ui$Form$Input$onInput($author$project$Pages$Partner$Practices$Top$ActivateIntegrationCodeChanged),
														$author$project$Ui$Form$Input$invalid(showCodeError),
														$author$project$Ui$Form$Input$errors(
														showCodeError ? _List_fromArray(
															['Authorization code is required']) : _List_Nil),
														$author$project$Ui$Form$Input$disabled(isLoading)
													]))
											]))
									]);
							}
						}())
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Pages$Partner$Practices$Top$ActivateIntegrationClosed),
								$author$project$Ui$Button$disabled(isLoading)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Activate practice integration'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$onClick($author$project$Pages$Partner$Practices$Top$ActivateIntegrationSubmitted),
								$author$project$Ui$Button$loading(isLoading),
								$author$project$Ui$Button$disabled(isLoading)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Activate')
							]))
					]))
			]));
};
var $author$project$Pages$Partner$Practices$Top$NewIntegrationClosed = {$: 5};
var $author$project$Pages$Partner$Practices$Top$NewIntegrationPracticeIdUpdated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Partner$Practices$Top$SaveIntegration = {$: 6};
var $author$project$Pages$Partner$Practices$Top$viewAddIntegrationModal = F2(
	function (practiceId, request) {
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Pages$Partner$Practices$Top$NewIntegrationClosed,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('Add Practice')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Practice ID'),
									$author$project$Ui$Form$Group$required(true),
									$author$project$Ui$Form$Group$labelSpanSm(4),
									$author$project$Ui$Form$Group$inputSpanSm(8)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(
											A2($elm$core$Maybe$withDefault, '', practiceId)),
											$author$project$Ui$Form$Input$onInput($author$project$Pages$Partner$Practices$Top$NewIntegrationPracticeIdUpdated),
											$author$project$Ui$Form$Input$invalid(
											_Utils_eq(practiceId, $elm$core$Maybe$Nothing)),
											$author$project$Ui$Form$Input$errors(
											_Utils_eq(practiceId, $elm$core$Maybe$Nothing) ? _List_fromArray(
												['Practice is required']) : _List_Nil)
										]))
								]))
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Cancel and close modal'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Pages$Partner$Practices$Top$NewIntegrationClosed)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Add Practice'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$onClick($author$project$Pages$Partner$Practices$Top$SaveIntegration),
									$author$project$Ui$Button$loading(
									_Utils_eq(request, $author$project$Api$Data$Loading))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Add Practice')
								]))
						]))
				]));
	});
var $author$project$Pages$Partner$Practices$Top$SubscriptionAmountChanged = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$Partner$Practices$Top$SubscriptionDescriptionChanged = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$Partner$Practices$Top$SubscriptionSubmitted = {$: 20};
var $author$project$Pages$Partner$Practices$Top$viewSubscriptionModal = function (modal) {
	var practiceName = $author$project$Api$Partner$Practice$Shared$name(
		$author$project$Api$Partner$Integration$All$practice(modal.T8));
	var title = function () {
		var _v0 = $author$project$Api$Partner$Integration$All$subscription(modal.T8);
		if (!_v0.$) {
			return 'Edit subscription — ' + practiceName;
		} else {
			return 'New subscription — ' + practiceName;
		}
	}();
	var amountErrors = (modal.xq && _Utils_eq(
		A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, modal.mk),
		$elm$core$Maybe$Nothing)) ? _List_fromArray(
		['Amount is required']) : _List_Nil;
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Pages$Partner$Practices$Top$SubscriptionModalClosed,
		_List_fromArray(
			[
				$author$project$Ui$Modal$onSubmit($author$project$Pages$Partner$Practices$Top$SubscriptionSubmitted)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title(title)
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Amount'),
								$author$project$Ui$Form$Group$required(true),
								$author$project$Ui$Form$Group$labelSpan(3),
								$author$project$Ui$Form$Group$inputSpan(9)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$CurrencyInput$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$CurrencyInput$value(modal.mk),
										$author$project$Ui$Form$CurrencyInput$onInput($author$project$Pages$Partner$Practices$Top$SubscriptionAmountChanged),
										$author$project$Ui$Form$CurrencyInput$placeholder('50.00'),
										$author$project$Ui$Form$CurrencyInput$errors(amountErrors)
									]))
							])),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Description'),
								$author$project$Ui$Form$Group$labelSpan(3),
								$author$project$Ui$Form$Group$inputSpan(9)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$value(modal.Qr),
										$author$project$Ui$Form$Input$onInput($author$project$Pages$Partner$Practices$Top$SubscriptionDescriptionChanged)
									]))
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Cancel'},
						_List_fromArray(
							[
								$author$project$Ui$Button$secondary,
								$author$project$Ui$Button$onClick($author$project$Pages$Partner$Practices$Top$SubscriptionModalClosed)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Save subscription'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$submit,
								$author$project$Ui$Button$loading(
								_Utils_eq(modal.uf, $author$project$Api$Data$Loading))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Save')
							]))
					]))
			]));
};
var $author$project$Pages$Partner$Practices$Top$SortTable = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Partner$Practices$Top$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'practice', true, 'Name'),
		A3($author$project$Api$Column$init, 'status', true, 'Status'),
		A3($author$project$Api$Column$init, 'active_patients', false, 'Active patients'),
		A3($author$project$Api$Column$init, 'subscription', false, 'Subscription')
	]);
var $author$project$Pages$Partner$Practices$Top$ActivateIntegrationClicked = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Partner$Practices$Top$CreateChargeClicked = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Partner$Practices$Top$EditSubscriptionClicked = function (a) {
	return {$: 16, a: a};
};
var $author$project$Api$Partner$Integration$All$activePatientCount = function (_v0) {
	var record = _v0;
	return record.KT;
};
var $author$project$Api$Partner$Integration$Shared$partnerActive = function (_v0) {
	var record = _v0;
	return record.YO;
};
var $author$project$Api$Partner$Integration$All$partnerActive = function (_v0) {
	var record = _v0;
	return $author$project$Api$Partner$Integration$Shared$partnerActive(record.lk);
};
var $author$project$Api$Partner$Integration$Shared$practiceActive = function (_v0) {
	var record = _v0;
	return record.ZW;
};
var $author$project$Api$Partner$Integration$All$practiceActive = function (_v0) {
	var record = _v0;
	return $author$project$Api$Partner$Integration$Shared$practiceActive(record.lk);
};
var $author$project$Pages$Partner$Practices$Top$canActivateIntegration = function (integration) {
	return $author$project$Api$Partner$Integration$All$practiceActive(integration) && (!$author$project$Api$Partner$Integration$All$partnerActive(integration));
};
var $author$project$Api$Partner$Practice$Shared$hasClinicalAccount = function (_v0) {
	var record = _v0.b;
	return record.S5;
};
var $author$project$Api$Partner$Integration$All$nextBillDate = function (_v0) {
	var record = _v0;
	return record.XP;
};
var $author$project$Api$Partner$Integration$Shared$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Api$Partner$Integration$All$status = function (_v0) {
	var record = _v0;
	return $author$project$Api$Partner$Integration$Shared$status(record.lk);
};
var $author$project$Pages$Partner$Practices$Top$viewIntegration = F2(
	function (isHintAdmin, integration) {
		var subscriptionLabel = function () {
			var _v0 = $author$project$Api$Partner$Integration$All$subscription(integration);
			if (!_v0.$) {
				var sub = _v0.a;
				var amountLabel = $author$project$Utils$Currency$fromInt(
					$author$project$Api$Common$PartnerSubscription$Min$amountInCents(sub));
				var _v1 = $author$project$Api$Partner$Integration$All$nextBillDate(integration);
				if (!_v1.$) {
					var date = _v1.a;
					return amountLabel + (' (next on ' + (A2($justinmimbs$date$Date$format, 'MMM d', date) + ')'));
				} else {
					return amountLabel;
				}
			} else {
				return 'Set amount';
			}
		}();
		var practice = $author$project$Api$Partner$Integration$All$practice(integration);
		var practiceName = $author$project$Api$Partner$Practice$Shared$name(practice);
		var subscriptionCell = A3(
			$author$project$Ui$Button$view,
			{mm: 'Edit subscription for ' + practiceName},
			_List_fromArray(
				[
					$author$project$Ui$Button$link,
					$author$project$Ui$Button$sm,
					$author$project$Ui$Button$onClick(
					$author$project$Pages$Partner$Practices$Top$EditSubscriptionClicked(integration))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(subscriptionLabel)
				]));
		var actionButtons = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					isHintAdmin ? $elm$core$Maybe$Just(
					A3(
						$author$project$Ui$HinterOnly$button,
						{mm: 'Create charge for ' + practiceName},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$sm,
								$author$project$Ui$Button$onClick(
								$author$project$Pages$Partner$Practices$Top$CreateChargeClicked(integration))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Create Charge')
							]))) : $elm$core$Maybe$Nothing,
					$author$project$Pages$Partner$Practices$Top$canActivateIntegration(integration) ? $elm$core$Maybe$Just(
					A3(
						$author$project$Ui$Button$view,
						{mm: 'Activate ' + (practiceName + ' integration')},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$sm,
								$author$project$Ui$Button$onClick(
								$author$project$Pages$Partner$Practices$Top$ActivateIntegrationClicked(integration))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Activate')
							]))) : $elm$core$Maybe$Nothing
				]));
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(practiceName),
							$author$project$Api$Partner$Practice$Shared$hasClinicalAccount(practice) ? A2(
							$author$project$Ui$Badge$view,
							_List_fromArray(
								[$author$project$Ui$Badge$info]),
							_List_fromArray(
								[
									$elm$html$Html$text('Clinical')
								])) : $author$project$Utils$Html$empty
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Badge$fromString,
							_List_Nil,
							$author$project$Api$Partner$Integration$All$status(integration))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(
								$author$project$Api$Partner$Integration$All$activePatientCount(integration)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[subscriptionCell])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$gap2]),
							actionButtons)
						]))
				]));
	});
var $author$project$Pages$Partner$Practices$Top$viewTable = function (model) {
	var _v0 = function () {
		var _v1 = model.Ud;
		if (_v1.$ === 3) {
			var integrations_ = _v1.a;
			return _Utils_Tuple2(false, integrations_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var integrations = _v0.b;
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any practices')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$map,
					$author$project$Api$Column$view(
						A2($author$project$Api$Column$Sortable, model.alA, $author$project$Pages$Partner$Practices$Top$SortTable)),
					$author$project$Pages$Partner$Practices$Top$columns),
					_List_fromArray(
					[
						A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
					])
				])),
		A2(
			$elm$core$List$map,
			$author$project$Pages$Partner$Practices$Top$viewIntegration(model.Ij),
			integrations),
		_List_Nil);
};
var $author$project$Pages$Partner$Practices$Top$view = function (model) {
	return {
		fO: function () {
			var loading = function () {
				var _v5 = model.Ud;
				if (_v5.$ === 3) {
					return false;
				} else {
					return true;
				}
			}();
			return _List_fromArray(
				[
					function () {
					var _v0 = model.cg;
					if (!_v0.$) {
						var _v1 = _v0.a;
						var item = _v1.a;
						var request = _v1.b;
						return A2($author$project$Pages$Partner$Practices$Top$viewAddIntegrationModal, item, request);
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					function () {
					var _v2 = model.a_;
					if (!_v2.$) {
						var activation = _v2.a;
						return $author$project$Pages$Partner$Practices$Top$viewActivateIntegrationModal(activation);
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					function () {
					var _v3 = model.iV;
					if (!_v3.$) {
						var modalModel = _v3.a;
						return A2(
							$elm$html$Html$map,
							$author$project$Pages$Partner$Practices$Top$CreateChargeModalMsg,
							$author$project$Components$Partner$CreatePartnerChargeModal$view(modalModel));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					function () {
					var _v4 = model.aD;
					if (!_v4.$) {
						var modal = _v4.a;
						return $author$project$Pages$Partner$Practices$Top$viewSubscriptionModal(modal);
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					A2(
					$author$project$Ui$Panel$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Panel$heading,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$mb2]),
									_List_fromArray(
										[
											$author$project$Ui$Panel$title(
											_List_fromArray(
												[
													$elm$html$Html$text('Practices')
												])),
											model.Ij ? A3(
											$author$project$Ui$HinterOnly$button,
											{mm: 'Add practice'},
											_List_fromArray(
												[
													$author$project$Ui$Button$default,
													$author$project$Ui$Button$onClick($author$project$Pages$Partner$Practices$Top$New)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Add Practice')
												])) : $author$project$Utils$Html$empty
										])),
									A2(
									$elm$html$Html$map,
									$author$project$Pages$Partner$Practices$Top$SearchInputMsg,
									A2($author$project$Ui$SearchInput$view, _List_Nil, model.up))
								])),
							$author$project$Pages$Partner$Practices$Top$viewTable(model),
							A2(
							$author$project$Ui$Panel$footer,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Pages$Partner$Practices$Top$PaginationMsg,
									A2(
										$author$project$Api$Pagination$view,
										_List_fromArray(
											[
												$author$project$Ui$Pagination$List$loading(loading)
											]),
										model.ajJ))
								]))
						]))
				]);
		}(),
		ac9: 'Partner | Practices'
	};
};
var $author$project$Pages$Partner$Practices$Top$page = $author$project$Spa$Page$applicationPartner(
	{ah_: $author$project$Pages$Partner$Practices$Top$init, aiq: $author$project$Pages$Partner$Practices$Top$load, k8: $author$project$Pages$Partner$Practices$Top$save, alO: $author$project$Pages$Partner$Practices$Top$subscriptions, adT: $author$project$Pages$Partner$Practices$Top$update, amo: $author$project$Pages$Partner$Practices$Top$view});
var $author$project$Pages$Partner$Products$Id_String$CallToActionMsg = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$CarouselMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$ManagePartnerProductCategoriesMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$ManagePartnerProductDataFlowsMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$ManagePartnerProductHighlightsMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$ManagePartnerProductLinksMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$ManagePartnerProductQuotesMsg = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Partner$GenerateListingModal$Closed = {$: 0};
var $author$project$Components$Partner$GenerateListingModal$init = $author$project$Components$Partner$GenerateListingModal$Closed;
var $author$project$Components$Partner$ManagePartnerProductCategories$CategoryDropdownMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductCategories$GotCategories = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductCategories$Model = $elm$core$Basics$identity;
var $author$project$Components$Partner$ManagePartnerProductCategories$init = F3(
	function (apiClient, productId, partner) {
		return _Utils_Tuple2(
			{
				Nr: $author$project$Api$Data$Loading,
				mI: $author$project$Ui$Dropdown$init(
					$author$project$Ui$Dropdown$defaultConfig(
						{ahP: 'category-dropdown', al6: $author$project$Components$Partner$ManagePartnerProductCategories$CategoryDropdownMsg})),
				cu: $elm$core$Maybe$Nothing,
				YN: partner,
				Q: $elm$core$Maybe$Nothing,
				Jn: productId
			},
			A2($author$project$Api$Platform$Marketplace$ProductCategory$list, apiClient, $author$project$Components$Partner$ManagePartnerProductCategories$GotCategories));
	});
var $author$project$Components$Partner$ManagePartnerProductDataFlows$DragDropMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductDataFlows$Model = $elm$core$Basics$identity;
var $author$project$Components$DragDrop$Model = $elm$core$Basics$identity;
var $author$project$Components$DragDrop$init = function (toMsg_) {
	return {nl: $elm$core$Maybe$Nothing, sA: $elm$core$Maybe$Nothing, al6: toMsg_};
};
var $author$project$Api$Partner$Partner$One$productDataFlows = function (_v0) {
	var record = _v0.b;
	return record._u;
};
var $author$project$Components$Partner$ManagePartnerProductDataFlows$init = F3(
	function (productId, partner, imageStore) {
		return _Utils_Tuple2(
			{
				PA: $author$project$Api$Partner$Partner$One$productDataFlows(partner),
				cA: $elm$core$Maybe$Nothing,
				nk: $author$project$Components$DragDrop$init($author$project$Components$Partner$ManagePartnerProductDataFlows$DragDropMsg),
				sF: imageStore,
				YN: partner,
				R: $elm$core$Maybe$Nothing,
				Jn: productId
			},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Components$Partner$ManagePartnerProductHighlights$DragDropMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductHighlights$Model = $elm$core$Basics$identity;
var $author$project$Api$Partner$Partner$One$productHighlights = function (_v0) {
	var record = _v0.b;
	return record._v;
};
var $author$project$Components$Partner$ManagePartnerProductHighlights$init = F3(
	function (productId, partner, imageStore) {
		return _Utils_Tuple2(
			{
				cw: $elm$core$Maybe$Nothing,
				nk: $author$project$Components$DragDrop$init($author$project$Components$Partner$ManagePartnerProductHighlights$DragDropMsg),
				Tu: $author$project$Api$Partner$Partner$One$productHighlights(partner),
				sF: imageStore,
				YN: partner,
				T: $elm$core$Maybe$Nothing,
				Jn: productId
			},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Components$Partner$ManagePartnerProductLinks$DragDropMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductLinks$Model = $elm$core$Basics$identity;
var $author$project$Api$Partner$Partner$One$productLinks = function (_v0) {
	var record = _v0.b;
	return record._w;
};
var $author$project$Components$Partner$ManagePartnerProductLinks$init = F3(
	function (productId, partner, imageStore) {
		return _Utils_Tuple2(
			{
				cx: $elm$core$Maybe$Nothing,
				nk: $author$project$Components$DragDrop$init($author$project$Components$Partner$ManagePartnerProductLinks$DragDropMsg),
				sF: imageStore,
				V5: $author$project$Api$Partner$Partner$One$productLinks(partner),
				YN: partner,
				Jn: productId,
				U: $elm$core$Maybe$Nothing
			},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Components$Partner$ManagePartnerProductQuotes$Model = $elm$core$Basics$identity;
var $author$project$Components$Partner$ManagePartnerProductQuotes$init = F3(
	function (productId, partner, imageStore) {
		return _Utils_Tuple2(
			{cB: $elm$core$Maybe$Nothing, sF: imageStore, YN: partner, Jn: productId, V: $elm$core$Maybe$Nothing},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Partner$Products$Id_String$GotPartnerProduct = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Partner$PartnerProduct$retrieve = F3(
	function (apiClient, productId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Partner$PartnerProduct$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Partner$PartnerProduct$productPathWithId(productId)));
	});
var $author$project$Pages$Partner$Products$Id_String$retrieveProduct = F2(
	function (apiClient, productId) {
		return A3($author$project$Api$Partner$PartnerProduct$retrieve, apiClient, productId, $author$project$Pages$Partner$Products$Id_String$GotPartnerProduct);
	});
var $author$project$Pages$Partner$Products$Id_String$init = F4(
	function (_v0, partner, shared, _v1) {
		var params = _v1.YL;
		var productId = params.ahP;
		var isHintAdmin = $author$project$Shared$isHintAdmin(shared);
		var _v2 = A3($author$project$Components$Partner$ManagePartnerProductQuotes$init, productId, partner, shared.sF);
		var managePartnerProductQuotes = _v2.a;
		var managePartnerProductQuotesCmd = _v2.b;
		var _v3 = A3($author$project$Components$Partner$ManagePartnerProductLinks$init, productId, partner, shared.sF);
		var managePartnerProductLinks = _v3.a;
		var managePartnerProductLinksCmd = _v3.b;
		var _v4 = A3($author$project$Components$Partner$ManagePartnerProductHighlights$init, productId, partner, shared.sF);
		var managePartnerProductHighlights = _v4.a;
		var managePartnerProductHighlightsCmd = _v4.b;
		var _v5 = A3($author$project$Components$Partner$ManagePartnerProductDataFlows$init, productId, partner, shared.sF);
		var managePartnerProductDataFlows = _v5.a;
		var managePartnerProductDataFlowsCmd = _v5.b;
		var _v6 = A3($author$project$Components$Partner$ManagePartnerProductCategories$init, shared.Gv, productId, partner);
		var manageCategories = _v6.a;
		var manageCategoriesCmd = _v6.b;
		return _Utils_Tuple2(
			{
				Gv: shared.Gv,
				br: $author$project$Components$Marketplace$Product$CallToAction$init(
					{
						zE: F4(
							function (apiClient, productId_, documentId, toMsg) {
								return A4($author$project$Api$Partner$PartnerProductDocument$signedFileUrl, apiClient, productId_, documentId, toMsg);
							}),
						Uy: true,
						al6: $author$project$Pages$Partner$Products$Id_String$CallToActionMsg
					}),
				mH: $author$project$Components$Carousel$init($author$project$Pages$Partner$Products$Id_String$CarouselMsg),
				dc: $elm$core$Maybe$Nothing,
				ga: $elm$core$Maybe$Nothing,
				C: $elm$core$Maybe$Nothing,
				so: 0,
				jN: $author$project$Components$Partner$GenerateListingModal$init,
				sF: shared.sF,
				Ij: isHintAdmin,
				V8: false,
				gN: manageCategories,
				gO: managePartnerProductDataFlows,
				gP: managePartnerProductHighlights,
				gQ: managePartnerProductLinks,
				gS: managePartnerProductQuotes,
				YN: partner,
				_s: $author$project$Api$Data$Loading,
				Jn: productId
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Pages$Partner$Products$Id_String$retrieveProduct, shared.Gv, productId),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Products$Id_String$ManagePartnerProductLinksMsg, managePartnerProductLinksCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Products$Id_String$ManagePartnerProductHighlightsMsg, managePartnerProductHighlightsCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Products$Id_String$ManagePartnerProductDataFlowsMsg, managePartnerProductDataFlowsCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Products$Id_String$ManagePartnerProductCategoriesMsg, manageCategoriesCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Products$Id_String$ManagePartnerProductQuotesMsg, managePartnerProductQuotesCmd)
					])));
	});
var $author$project$Pages$Partner$Products$Id_String$load = F2(
	function (shared, model) {
		var partner = A2(
			$elm$core$Maybe$withDefault,
			model.YN,
			$author$project$Api$Data$toMaybe(shared.YN));
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					Ij: $author$project$Shared$isHintAdmin(shared),
					YN: partner
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Partner$Products$Id_String$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Partner$Products$Id_String$CancelEdit = {$: 2};
var $author$project$Pages$Partner$Products$Id_String$CancelExternalCtaEdit = {$: 21};
var $author$project$Pages$Partner$Products$Id_String$DeleteConfirmClosed = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$GenerateListingModalMsg = function (a) {
	return {$: 25, a: a};
};
var $author$project$Components$Partner$GenerateListingModal$CloseRequested = {$: 8};
var $author$project$Components$Partner$GenerateListingModal$ConfirmSave = function (a) {
	return {$: 29, a: a};
};
var $author$project$Components$Partner$GenerateListingModal$subscriptions = function (model) {
	switch (model.$) {
		case 0:
			return $elm$core$Platform$Sub$none;
		case 4:
			var state = model.a;
			return state.f$ ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$Partner$GenerateListingModal$ConfirmSave) : $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Partner$GenerateListingModal$CloseRequested),
						$author$project$Ui$Dropdown$subscriptions(state.mI)
					]));
		default:
			return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Partner$GenerateListingModal$CloseRequested);
	}
};
var $author$project$Components$Partner$ManagePartnerProductCategories$CancelAdd = {$: 1};
var $author$project$Components$Partner$ManagePartnerProductCategories$DeleteConfirmationClosed = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductCategories$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				function () {
				var _v1 = model.Q;
				if (!_v1.$) {
					return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Partner$ManagePartnerProductCategories$CancelAdd);
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				function () {
				var _v2 = model.cu;
				if (!_v2.$) {
					return $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$Partner$ManagePartnerProductCategories$DeleteConfirmationClosed);
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				$author$project$Ui$Dropdown$subscriptions(model.mI)
			]));
};
var $author$project$Components$Partner$ManagePartnerProductDataFlows$CancelAdd = {$: 1};
var $author$project$Components$Partner$ManagePartnerProductDataFlows$DeleteConfirmationClosed = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductDataFlows$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Partner$ManagePartnerProductDataFlows$CancelAdd)),
					model.R)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$Partner$ManagePartnerProductDataFlows$DeleteConfirmationClosed)),
					model.cA))
			]));
};
var $author$project$Components$Partner$ManagePartnerProductHighlights$CancelAddOrEdit = {$: 1};
var $author$project$Components$Partner$ManagePartnerProductHighlights$DeleteConfirmationClosed = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductHighlights$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Partner$ManagePartnerProductHighlights$CancelAddOrEdit)),
					model.T)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$Partner$ManagePartnerProductHighlights$DeleteConfirmationClosed)),
					model.cw))
			]));
};
var $author$project$Components$Partner$ManagePartnerProductLinks$CancelAdd = {$: 1};
var $author$project$Components$Partner$ManagePartnerProductLinks$DeleteConfirmationClosed = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductLinks$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Partner$ManagePartnerProductLinks$CancelAdd)),
					model.U)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$Partner$ManagePartnerProductLinks$DeleteConfirmationClosed)),
					model.cx))
			]));
};
var $author$project$Components$Partner$ManagePartnerProductQuotes$CancelAddOrEdit = {$: 1};
var $author$project$Components$Partner$ManagePartnerProductQuotes$DeleteConfirmationClosed = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductQuotes$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Partner$ManagePartnerProductQuotes$CancelAddOrEdit)),
					model.V)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$Partner$ManagePartnerProductQuotes$DeleteConfirmationClosed)),
					model.cB))
			]));
};
var $author$project$Pages$Partner$Products$Id_String$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Pages$Partner$Products$Id_String$CancelEdit),
				$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Pages$Partner$Products$Id_String$CancelExternalCtaEdit),
				function () {
				var _v0 = model.ga;
				if (!_v0.$) {
					return $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Partner$Products$Id_String$DeleteConfirmClosed);
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Partner$Products$Id_String$ManagePartnerProductLinksMsg,
				$author$project$Components$Partner$ManagePartnerProductLinks$subscriptions(model.gQ)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Partner$Products$Id_String$ManagePartnerProductHighlightsMsg,
				$author$project$Components$Partner$ManagePartnerProductHighlights$subscriptions(model.gP)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Partner$Products$Id_String$ManagePartnerProductDataFlowsMsg,
				$author$project$Components$Partner$ManagePartnerProductDataFlows$subscriptions(model.gO)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Partner$Products$Id_String$ManagePartnerProductCategoriesMsg,
				$author$project$Components$Partner$ManagePartnerProductCategories$subscriptions(model.gN)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Partner$Products$Id_String$ManagePartnerProductQuotesMsg,
				$author$project$Components$Partner$ManagePartnerProductQuotes$subscriptions(model.gS)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Partner$Products$Id_String$GenerateListingModalMsg,
				$author$project$Components$Partner$GenerateListingModal$subscriptions(model.jN)),
				$author$project$Components$Carousel$subscriptions(model.mH)
			]));
};
var $author$project$Api$Partner$PartnerProduct$CtaUrl = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$Edited = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$ExternalCtaFormMsg = function (a) {
	return {$: 20, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$GotExternalCtaSaved = function (a) {
	return {$: 23, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$GotPartnerUpdated = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$Partner$Products$Id_String$Icon = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$ProductOverviewImages = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$Partner$Products$Id_String$Saved = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Partner$PartnerProduct$UtmCampaign = function (a) {
	return {$: 11, a: a};
};
var $author$project$Api$Partner$PartnerProduct$UtmContent = function (a) {
	return {$: 12, a: a};
};
var $author$project$Api$Partner$PartnerProduct$One$ctaUrl = function (_v0) {
	var record = _v0.b;
	return record.Pc;
};
var $author$project$Utils$Maybe$fromString = function (string) {
	return $elm$core$String$isEmpty(string) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(string);
};
var $author$project$Api$Partner$PartnerProduct$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$PartnerProduct$Shared$id(shared);
};
var $author$project$Api$Partner$ProductImage$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Partner$PartnerProductOverview$Shared$images = function (_v0) {
	var record = _v0;
	return record.TQ;
};
var $author$project$Components$Partner$ExternalCtaForm$Model = $elm$core$Basics$identity;
var $author$project$Components$Partner$ExternalCtaForm$init = function (fields) {
	return {ahi: fields, qW: _List_Nil};
};
var $author$project$Components$Partner$GenerateListingModal$isSaveSuccess = function (msg) {
	if ((msg.$ === 30) && (msg.a.$ === 3)) {
		var _v1 = msg.a;
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$Partner$GenerateListingModal$GotAdvancedDefaults = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Partner$Marketplace$ListingGeneration$Defaults = F4(
	function (provider, model, effort, prompt) {
		return {agI: effort, aiO: model, akj: prompt, akk: provider};
	});
var $author$project$Api$Partner$Marketplace$ListingGeneration$defaultsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'prompt',
	$elm$json$Json$Decode$string,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'effort',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'model',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'provider',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				$elm$json$Json$Decode$succeed($author$project$Api$Partner$Marketplace$ListingGeneration$Defaults)))));
var $author$project$Api$Partner$Marketplace$ListingGeneration$listingGenerationsForProductPath = function (partnerProductId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['marketplace', 'partner_products', partnerProductId, 'listing_generations']),
		$author$project$Api$Data$partnerPath);
};
var $author$project$Api$Partner$Marketplace$ListingGeneration$previewDefaults = F3(
	function (apiClient, partnerProductId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Partner$Marketplace$ListingGeneration$defaultsDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['new']),
					$author$project$Api$Partner$Marketplace$ListingGeneration$listingGenerationsForProductPath(partnerProductId))));
	});
var $author$project$Components$Partner$GenerateListingModal$loadDefaults = F2(
	function (apiClient, _v0) {
		var partnerProductId = _v0.oS;
		var isHintAdmin = _v0.Ij;
		return isHintAdmin ? A3($author$project$Api$Partner$Marketplace$ListingGeneration$previewDefaults, apiClient, partnerProductId, $author$project$Components$Partner$GenerateListingModal$GotAdvancedDefaults) : $elm$core$Platform$Cmd$none;
	});
var $author$project$Components$Partner$GenerateListingModal$EditingUrl = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$GenerateListingModal$emptyOverrides = {i3: '', agI: '', aiO: '', akk: ''};
var $author$project$Components$Partner$GenerateListingModal$open = function (_v0) {
	var isHintAdmin = _v0.Ij;
	return $author$project$Components$Partner$GenerateListingModal$EditingUrl(
		{
			me: isHintAdmin ? $author$project$Api$Data$Loading : $author$project$Api$Data$NotAsked,
			RK: $elm$core$Maybe$Nothing,
			Ij: isHintAdmin,
			az: $author$project$Components$Partner$GenerateListingModal$emptyOverrides,
			adY: ''
		});
};
var $author$project$Api$Partner$Partner$One$productOverview = function (_v0) {
	var record = _v0.b;
	return record._y;
};
var $author$project$Components$Carousel$reset = function (model) {
	return _Utils_update(
		model,
		{sG: 0});
};
var $author$project$Api$Partner$Partner$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Partner$Partner$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Partner$Partner$partnerPath));
	});
var $author$project$Api$Partner$PartnerProduct$BuiltByName = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Partner$PartnerProduct$BuiltByUrl = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$GotPartnerProductUpdated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Partner$PartnerProduct$Icon = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Partner$PartnerProduct$Name = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Partner$Partner$ProductOverviewDescription = function (a) {
	return {$: 20, a: a};
};
var $author$project$Api$Partner$Partner$ProductOverviewImage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Partner$Partner$ProductOverviewImageUrl = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Partner$Partner$ProductOverviewImages = function (a) {
	return {$: 21, a: a};
};
var $author$project$Api$Partner$PartnerProduct$Summary = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Partner$ProductImage$Shared$alt = function (_v0) {
	var record = _v0;
	return A2($elm$core$Maybe$withDefault, '', record.LD);
};
var $author$project$Pages$Partner$Products$Id_String$IconValidation = 1;
var $author$project$Pages$Partner$Products$Id_String$NameValidation = 0;
var $author$project$Pages$Partner$Products$Id_String$maxIconBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
var $author$project$Pages$Partner$Products$Id_String$validator = function (field) {
	switch (field.$) {
		case 0:
			var name = field.a;
			return A2(
				$rtfeldman$elm_validate$Validate$ifBlank,
				$elm$core$Basics$always(name),
				_Utils_Tuple2(0, 'Please enter a name.'));
		case 2:
			var maybeIcon = field.a;
			return $rtfeldman$elm_validate$Validate$all(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_validate$Validate$ifNothing,
						$elm$core$Basics$always(maybeIcon),
						_Utils_Tuple2(1, 'Please select an icon to upload.')),
						function () {
						if (!maybeIcon.$) {
							var _v2 = maybeIcon.a;
							var iconSize = _v2.a;
							return A3(
								$author$project$Utils$Validate$ifIntGreaterThan,
								$elm$core$Basics$always(iconSize),
								$author$project$Pages$Partner$Products$Id_String$maxIconBytesSize,
								_Utils_Tuple2(1, 'That image is too large! Our maximum image size is 5 mb, please choose a smaller image.'));
						} else {
							return $rtfeldman$elm_validate$Validate$all(_List_Nil);
						}
					}()
					]));
		case 5:
			return $rtfeldman$elm_validate$Validate$all(_List_Nil);
		default:
			return $rtfeldman$elm_validate$Validate$all(_List_Nil);
	}
};
var $author$project$Pages$Partner$Products$Id_String$validate = function (form) {
	return A2(
		$author$project$Utils$Form$validate,
		$author$project$Pages$Partner$Products$Id_String$validator(
			$author$project$Utils$Form$fields(form)),
		form);
};
var $author$project$Pages$Partner$Products$Id_String$submit = F2(
	function (model, form) {
		var _v0 = $author$project$Pages$Partner$Products$Id_String$validate(form);
		if (_v0.$ === 1) {
			var invalidForm = _v0.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						C: $elm$core$Maybe$Just(invalidForm)
					}),
				$elm$core$Platform$Cmd$none,
				_List_Nil);
		} else {
			var _v1 = _v0.a;
			var validField = _v1.b;
			var _v2 = model._s;
			if (_v2.$ === 3) {
				var product = _v2.a;
				var field = $rtfeldman$elm_validate$Validate$fromValid(validField);
				var productFields = function () {
					switch (field.$) {
						case 5:
							var maybeName = field.a;
							var maybeUrl = field.b;
							return _List_fromArray(
								[
									$author$project$Api$Partner$PartnerProduct$BuiltByName(maybeName),
									$author$project$Api$Partner$PartnerProduct$BuiltByUrl(maybeUrl)
								]);
						case 0:
							var name = field.a;
							return _List_fromArray(
								[
									$author$project$Api$Partner$PartnerProduct$Name(name)
								]);
						case 1:
							var description = field.a;
							return _List_fromArray(
								[
									$author$project$Api$Partner$PartnerProduct$Summary(
									$author$project$Utils$Maybe$fromString(description))
								]);
						case 2:
							if (!field.a.$) {
								var _v5 = field.a.a;
								var url = _v5.b;
								return _List_fromArray(
									[
										$author$project$Api$Partner$PartnerProduct$Icon(url)
									]);
							} else {
								var _v6 = field.a;
								return _List_Nil;
							}
						default:
							return _List_Nil;
					}
				}();
				if ($elm$core$List$isEmpty(productFields)) {
					switch (field.$) {
						case 3:
							var description = field.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{C: $elm$core$Maybe$Nothing, V8: true}),
								A3(
									$author$project$Api$Partner$Partner$update,
									model.Gv,
									_List_fromArray(
										[
											$author$project$Api$Partner$Partner$ProductOverviewDescription(
											$author$project$Utils$Maybe$fromString(description))
										]),
									$author$project$Pages$Partner$Products$Id_String$GotPartnerUpdated(true)),
								_List_Nil);
						case 4:
							var existingImages = field.a;
							var newUrls = field.b;
							var newImageParams = A2($elm$core$List$map, $author$project$Api$Partner$Partner$ProductOverviewImageUrl, newUrls);
							var existingImageParams = A2(
								$elm$core$List$map,
								function (img) {
									return $author$project$Api$Partner$Partner$ProductOverviewImage(
										{
											LD: $author$project$Api$Partner$ProductImage$Shared$alt(img),
											ahP: $author$project$Api$Partner$ProductImage$Shared$id(img)
										});
								},
								existingImages);
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{C: $elm$core$Maybe$Nothing, V8: true}),
								A3(
									$author$project$Api$Partner$Partner$update,
									model.Gv,
									_List_fromArray(
										[
											$author$project$Api$Partner$Partner$ProductOverviewImages(
											_Utils_ap(existingImageParams, newImageParams))
										]),
									$author$project$Pages$Partner$Products$Id_String$GotPartnerUpdated(true)),
								_List_Nil);
						default:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{C: $elm$core$Maybe$Nothing}),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
					}
				} else {
					var productId = $author$project$Api$Partner$PartnerProduct$One$id(product);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{C: $elm$core$Maybe$Nothing, V8: true}),
						A4($author$project$Api$Partner$PartnerProduct$update, model.Gv, productId, productFields, $author$project$Pages$Partner$Products$Id_String$GotPartnerProductUpdated),
						_List_Nil);
				}
			} else {
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{C: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			}
		}
	});
var $author$project$Api$Partner$PartnerProduct$One$distributionType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$PartnerProduct$Shared$distributionType(shared);
};
var $author$project$Api$Partner$PartnerProduct$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$PartnerProduct$Shared$name(shared);
};
var $author$project$Api$Partner$PartnerProduct$One$slug = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$PartnerProduct$Shared$slug(shared);
};
var $author$project$Api$Partner$PartnerProduct$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$PartnerProduct$Shared$status(shared);
};
var $author$project$Api$Partner$PartnerProduct$One$type_ = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$PartnerProduct$Shared$type_(shared);
};
var $author$project$Pages$Partner$Products$Id_String$toCallToActionProduct = function (product) {
	return {
		MA: false,
		Op: $author$project$Api$Partner$PartnerProduct$One$ctaUrl(product),
		PX: $elm$core$Maybe$Nothing,
		P3: $elm$core$Maybe$Nothing,
		QN: $author$project$Api$Partner$PartnerProduct$One$distributionType(product),
		Rx: $author$project$Api$Common$Marketplace$Product$Engagement$Status$CantEngage,
		T4: $elm$core$Maybe$Nothing,
		V7: $author$project$Api$Partner$PartnerProduct$One$status(product),
		Bq: $author$project$Api$Partner$PartnerProduct$One$name(product),
		YS: _List_Nil,
		I3: _List_Nil,
		Z7: _List_Nil,
		_e: false,
		_i: $elm$core$Maybe$Nothing,
		Jn: $author$project$Api$Partner$PartnerProduct$One$id(product),
		abG: $author$project$Api$Partner$PartnerProduct$One$slug(product),
		alH: $elm$core$Maybe$Nothing,
		amg: $author$project$Api$Partner$PartnerProduct$One$type_(product)
	};
};
var $author$project$Components$Partner$ExternalCtaForm$update = F2(
	function (msg, _v0) {
		var model = _v0;
		var fields = model.ahi;
		switch (msg.$) {
			case 0:
				var url = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ahi: _Utils_update(
								fields,
								{adY: url}),
							qW: _List_Nil
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var campaign = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ahi: _Utils_update(
								fields,
								{aea: campaign})
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var content = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ahi: _Utils_update(
								fields,
								{aeb: content})
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var value = msg.a;
				return _Utils_Tuple3(
					model,
					$author$project$Ports$Clipboard$copy(value),
					_List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 3, 'Copied to clipboard')
						]));
		}
	});
var $author$project$Components$Partner$GenerateListingModal$EditingDraft = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Partner$GenerateListingModal$Failed = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Partner$GenerateListingModal$GotGeneration = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Partner$GenerateListingModal$GotPoll = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Partner$GenerateListingModal$GotSaveResponse = function (a) {
	return {$: 30, a: a};
};
var $author$project$Components$Partner$GenerateListingModal$Polling = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Partner$GenerateListingModal$Submitting = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$GenerateListingModal$anySectionIncluded = function (draft) {
	return draft.Bq.c || (draft.a2.c || (draft.ahO.c || (draft.Nr.c || (draft.acF.c || (draft.YB.c || (draft.ajI.c || (draft.Tu.c || (draft.V5.c || draft._0.c))))))));
};
var $author$project$Api$Partner$Marketplace$ListingGeneration$One$ListingGeneration = $elm$core$Basics$identity;
var $author$project$Api$Partner$Marketplace$ListingGeneration$One$Record = F4(
	function (id, status, result, error) {
		return {RK: error, ahP: id, $U: result, alH: status};
	});
var $author$project$Api$Partner$Marketplace$ListingGeneration$One$Result_ = F2(
	function (existing, generated) {
		return {ag1: existing, ahz: generated};
	});
var $author$project$Api$Partner$Marketplace$ListingGeneration$One$Snapshot = function (name) {
	return function (builtByName) {
		return function (builtByUrl) {
			return function (icon) {
				return function (categories) {
					return function (availableCategories) {
						return function (summary) {
							return function (overview) {
								return function (overviewImages) {
									return function (highlights) {
										return function (links) {
											return function (quotes) {
												return {ae5: availableCategories, MV: builtByName, MW: builtByUrl, Nr: categories, Tu: highlights, ahO: icon, V5: links, Bq: name, YB: overview, ajI: overviewImages, _0: quotes, acF: summary};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Partner$Marketplace$ListingGeneration$One$Highlight = F3(
	function (title, description, image) {
		return {Qr: description, ahT: image, ac9: title};
	});
var $author$project$Api$Partner$Marketplace$ListingGeneration$One$presentString = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Maybe$andThen(
		function (s) {
			return $elm$core$String$isEmpty(s) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(s);
		}),
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Api$Partner$Marketplace$ListingGeneration$One$highlightDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'image',
	$author$project$Api$Partner$Marketplace$ListingGeneration$One$presentString,
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'description',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'title',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Partner$Marketplace$ListingGeneration$One$Highlight))));
var $author$project$Api$Partner$Marketplace$ListingGeneration$One$Link = F2(
	function (label, url) {
		return {aih: label, adY: url};
	});
var $author$project$Api$Partner$Marketplace$ListingGeneration$One$linkDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'url',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'label',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Partner$Marketplace$ListingGeneration$One$Link)));
var $author$project$Api$Partner$Marketplace$ListingGeneration$One$Quote = F4(
	function (text, author, authorTitle, authorImage) {
		return {Mb: author, ae1: authorImage, Md: authorTitle, ac3: text};
	});
var $author$project$Api$Partner$Marketplace$ListingGeneration$One$quoteDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'author_image',
	$author$project$Api$Partner$Marketplace$ListingGeneration$One$presentString,
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'author_title',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'author',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'text',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Partner$Marketplace$ListingGeneration$One$Quote)))));
var $author$project$Api$Partner$Marketplace$ListingGeneration$One$snapshotDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'quotes',
	$elm$json$Json$Decode$list($author$project$Api$Partner$Marketplace$ListingGeneration$One$quoteDecoder),
	_List_Nil,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'links',
		$elm$json$Json$Decode$list($author$project$Api$Partner$Marketplace$ListingGeneration$One$linkDecoder),
		_List_Nil,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'highlights',
			$elm$json$Json$Decode$list($author$project$Api$Partner$Marketplace$ListingGeneration$One$highlightDecoder),
			_List_Nil,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'overview_images',
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$List$filter(
						A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty)),
					$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
				_List_Nil,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'overview',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'summary',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'available_categories',
							$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
							_List_Nil,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'categories',
								$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
								_List_Nil,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'icon',
									$author$project$Api$Partner$Marketplace$ListingGeneration$One$presentString,
									$elm$core$Maybe$Nothing,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'built_by_url',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
										$elm$core$Maybe$Nothing,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'built_by_name',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
											$elm$core$Maybe$Nothing,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'name',
												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
												$elm$core$Maybe$Nothing,
												$elm$json$Json$Decode$succeed($author$project$Api$Partner$Marketplace$ListingGeneration$One$Snapshot)))))))))))));
var $author$project$Api$Partner$Marketplace$ListingGeneration$One$resultDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'generated',
	$author$project$Api$Partner$Marketplace$ListingGeneration$One$snapshotDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'existing',
		$author$project$Api$Partner$Marketplace$ListingGeneration$One$snapshotDecoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Partner$Marketplace$ListingGeneration$One$Result_)));
var $author$project$Api$Partner$Marketplace$ListingGeneration$One$Failed = 3;
var $author$project$Api$Partner$Marketplace$ListingGeneration$One$Pending = 0;
var $author$project$Api$Partner$Marketplace$ListingGeneration$One$Running = 1;
var $author$project$Api$Partner$Marketplace$ListingGeneration$One$Succeeded = 2;
var $author$project$Api$Partner$Marketplace$ListingGeneration$One$statusDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (value) {
		switch (value) {
			case 'pending':
				return $elm$json$Json$Decode$succeed(0);
			case 'running':
				return $elm$json$Json$Decode$succeed(1);
			case 'succeeded':
				return $elm$json$Json$Decode$succeed(2);
			case 'failed':
				return $elm$json$Json$Decode$succeed(3);
			default:
				var other = value;
				return $elm$json$Json$Decode$fail('Unknown status: ' + other);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Partner$Marketplace$ListingGeneration$One$decoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'error',
		$elm$json$Json$Decode$nullable(
			A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string)),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'result',
			$elm$json$Json$Decode$nullable($author$project$Api$Partner$Marketplace$ListingGeneration$One$resultDecoder),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'status',
				$author$project$Api$Partner$Marketplace$ListingGeneration$One$statusDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Partner$Marketplace$ListingGeneration$One$Record))))));
var $author$project$Api$Partner$Marketplace$ListingGeneration$encodeNullableString = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map($elm$json$Json$Encode$string),
	$elm$core$Maybe$withDefault($elm$json$Json$Encode$null));
var $author$project$Api$Partner$Marketplace$ListingGeneration$encodePermittedFields = function (fields) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$map,
			function (field) {
				switch (field.$) {
					case 0:
						var value = field.a;
						return _Utils_Tuple2(
							'source_url',
							$elm$json$Json$Encode$string(value));
					case 1:
						var value = field.a;
						return _Utils_Tuple2(
							'provider',
							$author$project$Api$Partner$Marketplace$ListingGeneration$encodeNullableString(value));
					case 2:
						var value = field.a;
						return _Utils_Tuple2(
							'model',
							$author$project$Api$Partner$Marketplace$ListingGeneration$encodeNullableString(value));
					case 3:
						var value = field.a;
						return _Utils_Tuple2(
							'effort',
							$author$project$Api$Partner$Marketplace$ListingGeneration$encodeNullableString(value));
					default:
						var value = field.a;
						return _Utils_Tuple2(
							'custom_prompt',
							$author$project$Api$Partner$Marketplace$ListingGeneration$encodeNullableString(value));
				}
			},
			fields));
};
var $author$project$Api$Partner$Marketplace$ListingGeneration$create = F4(
	function (apiClient, partnerProductId, permittedFields, toMsg) {
		var body = $author$project$Api$Partner$Marketplace$ListingGeneration$encodePermittedFields(permittedFields);
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$Marketplace$ListingGeneration$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Partner$Marketplace$ListingGeneration$listingGenerationsForProductPath(partnerProductId))));
	});
var $author$project$Api$Partner$Marketplace$ListingGeneration$CustomPrompt = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Partner$Marketplace$ListingGeneration$Effort = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Partner$Marketplace$ListingGeneration$Model = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Partner$Marketplace$ListingGeneration$Provider = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Partner$Marketplace$ListingGeneration$SourceUrl = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$GenerateListingModal$nilIfEmpty = function (s) {
	return $elm$core$String$isEmpty(
		$elm$core$String$trim(s)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(s);
};
var $author$project$Components$Partner$GenerateListingModal$createFields = function (submission) {
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				$elm$core$Maybe$Just(
				$author$project$Api$Partner$Marketplace$ListingGeneration$SourceUrl(submission.adY)),
				submission.Ij ? $elm$core$Maybe$Just(
				$author$project$Api$Partner$Marketplace$ListingGeneration$Provider(
					$author$project$Components$Partner$GenerateListingModal$nilIfEmpty(submission.az.akk))) : $elm$core$Maybe$Nothing,
				submission.Ij ? $elm$core$Maybe$Just(
				$author$project$Api$Partner$Marketplace$ListingGeneration$Model(
					$author$project$Components$Partner$GenerateListingModal$nilIfEmpty(submission.az.aiO))) : $elm$core$Maybe$Nothing,
				submission.Ij ? $elm$core$Maybe$Just(
				$author$project$Api$Partner$Marketplace$ListingGeneration$Effort(
					$author$project$Components$Partner$GenerateListingModal$nilIfEmpty(submission.az.agI))) : $elm$core$Maybe$Nothing,
				submission.Ij ? $elm$core$Maybe$Just(
				$author$project$Api$Partner$Marketplace$ListingGeneration$CustomPrompt(
					$author$project$Components$Partner$GenerateListingModal$nilIfEmpty(submission.az.i3))) : $elm$core$Maybe$Nothing
			]));
};
var $author$project$Components$Partner$GenerateListingModal$errorMessage = function (response) {
	if (response.$ === 2) {
		var error_ = response.a;
		return $author$project$Api$Data$errorToString(error_);
	} else {
		return 'Something went wrong. Please try again.';
	}
};
var $author$project$Components$Partner$GenerateListingModal$formStateFromSubmission = function (submission) {
	return {me: $author$project$Api$Data$NotAsked, RK: $elm$core$Maybe$Nothing, Ij: submission.Ij, az: submission.az, adY: submission.adY};
};
var $author$project$Api$Partner$Marketplace$ListingGeneration$One$id = function (_v0) {
	var r = _v0;
	return r.ahP;
};
var $author$project$Api$Partner$Marketplace$ListingGeneration$One$status = function (_v0) {
	var r = _v0;
	return r.alH;
};
var $author$project$Api$Partner$Marketplace$ListingGeneration$One$isTerminal = function (generation) {
	var _v0 = $author$project$Api$Partner$Marketplace$ListingGeneration$One$status(generation);
	switch (_v0) {
		case 0:
			return false;
		case 1:
			return false;
		case 2:
			return true;
		default:
			return true;
	}
};
var $author$project$Components$Partner$GenerateListingModal$mapValue = F2(
	function (section, fn) {
		return _Utils_update(
			section,
			{
				aee: fn(section.aee)
			});
	});
var $author$project$Components$Partner$GenerateListingModal$maxAttempts = 90;
var $author$project$Components$Partner$GenerateListingModal$preferExisting = F2(
	function (current, incoming) {
		return $elm$core$String$isEmpty(current) ? incoming : current;
	});
var $author$project$Components$Partner$GenerateListingModal$mergeDefaultsIntoOverrides = F2(
	function (defaults, o) {
		return {
			i3: A2($author$project$Components$Partner$GenerateListingModal$preferExisting, o.i3, defaults.akj),
			agI: A2(
				$author$project$Components$Partner$GenerateListingModal$preferExisting,
				o.agI,
				A2($elm$core$Maybe$withDefault, '', defaults.agI)),
			aiO: A2(
				$author$project$Components$Partner$GenerateListingModal$preferExisting,
				o.aiO,
				A2($elm$core$Maybe$withDefault, '', defaults.aiO)),
			akk: A2(
				$author$project$Components$Partner$GenerateListingModal$preferExisting,
				o.akk,
				A2($elm$core$Maybe$withDefault, '', defaults.akk))
		};
	});
var $author$project$Api$Partner$PartnerProduct$Categories = function (a) {
	return {$: 20, a: a};
};
var $author$project$Api$Partner$PartnerProduct$Highlights = function (a) {
	return {$: 17, a: a};
};
var $author$project$Api$Partner$PartnerProduct$Links = function (a) {
	return {$: 18, a: a};
};
var $author$project$Api$Partner$PartnerProduct$Overview = function (a) {
	return {$: 15, a: a};
};
var $author$project$Api$Partner$PartnerProduct$OverviewImages = function (a) {
	return {$: 16, a: a};
};
var $author$project$Api$Partner$PartnerProduct$Quotes = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Partner$GenerateListingModal$nullableString = function (value) {
	return $elm$core$String$isEmpty(
		$elm$core$String$trim(value)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(value);
};
var $author$project$Components$Partner$GenerateListingModal$permittedFieldsFromDraft = function (draft) {
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				draft.Bq.c ? $elm$core$Maybe$Just(
				$author$project$Api$Partner$PartnerProduct$Name(draft.Bq.aee)) : $elm$core$Maybe$Nothing,
				draft.a2.c ? $elm$core$Maybe$Just(
				$author$project$Api$Partner$PartnerProduct$BuiltByName(
					$author$project$Components$Partner$GenerateListingModal$nullableString(draft.a2.aee.Bq))) : $elm$core$Maybe$Nothing,
				draft.a2.c ? $elm$core$Maybe$Just(
				$author$project$Api$Partner$PartnerProduct$BuiltByUrl(
					$author$project$Components$Partner$GenerateListingModal$nullableString(draft.a2.aee.adY))) : $elm$core$Maybe$Nothing,
				draft.ahO.c ? A2($elm$core$Maybe$map, $author$project$Api$Partner$PartnerProduct$Icon, draft.ahO.aee) : $elm$core$Maybe$Nothing,
				draft.Nr.c ? $elm$core$Maybe$Just(
				$author$project$Api$Partner$PartnerProduct$Categories(
					A2(
						$elm$core$List$filter,
						A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
						A2($elm$core$List$map, $elm$core$String$trim, draft.Nr.aee)))) : $elm$core$Maybe$Nothing,
				draft.acF.c ? $elm$core$Maybe$Just(
				$author$project$Api$Partner$PartnerProduct$Summary(
					$elm$core$Maybe$Just(draft.acF.aee))) : $elm$core$Maybe$Nothing,
				draft.YB.c ? $elm$core$Maybe$Just(
				$author$project$Api$Partner$PartnerProduct$Overview(
					{Qr: draft.YB.aee})) : $elm$core$Maybe$Nothing,
				draft.ajI.c ? $elm$core$Maybe$Just(
				$author$project$Api$Partner$PartnerProduct$OverviewImages(draft.ajI.aee)) : $elm$core$Maybe$Nothing,
				draft.Tu.c ? $elm$core$Maybe$Just(
				$author$project$Api$Partner$PartnerProduct$Highlights(draft.Tu.aee)) : $elm$core$Maybe$Nothing,
				draft.V5.c ? $elm$core$Maybe$Just(
				$author$project$Api$Partner$PartnerProduct$Links(draft.V5.aee)) : $elm$core$Maybe$Nothing,
				draft._0.c ? $elm$core$Maybe$Just(
				$author$project$Api$Partner$PartnerProduct$Quotes(draft._0.aee)) : $elm$core$Maybe$Nothing
			]));
};
var $author$project$Components$Partner$GenerateListingModal$removeAt = F2(
	function (index, list) {
		return A2(
			$elm$core$List$map,
			$elm$core$Tuple$second,
			A2(
				$elm$core$List$filter,
				function (_v0) {
					var i = _v0.a;
					return !_Utils_eq(i, index);
				},
				A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, list)));
	});
var $author$project$Api$Partner$PartnerProduct$replaceListing = F4(
	function (apiClient, productId, permittedFields, toMsg) {
		var body = $author$project$Api$Partner$PartnerProduct$encodePermittedFields(permittedFields);
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$PartnerProduct$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['replace_listing']),
						$author$project$Api$Partner$PartnerProduct$productPathWithId(productId)))));
	});
var $author$project$Api$Partner$Marketplace$ListingGeneration$listingGenerationPath = function (generationId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['marketplace', 'listing_generations', generationId]),
		$author$project$Api$Data$partnerPath);
};
var $author$project$Api$Partner$Marketplace$ListingGeneration$retrieve = F3(
	function (apiClient, generationId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Partner$Marketplace$ListingGeneration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Partner$Marketplace$ListingGeneration$listingGenerationPath(generationId)));
	});
var $author$project$Components$Partner$GenerateListingModal$PollTick = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Partner$GenerateListingModal$pollIntervalMs = 2000;
var $author$project$Components$Partner$GenerateListingModal$scheduleNextPoll = function (generationId) {
	return A2(
		$elm$core$Task$perform,
		function (_v0) {
			return $author$project$Components$Partner$GenerateListingModal$PollTick(generationId);
		},
		$elm$core$Process$sleep($author$project$Components$Partner$GenerateListingModal$pollIntervalMs));
};
var $author$project$Components$Partner$GenerateListingModal$setOverrideField = F3(
	function (field, value, overrides) {
		switch (field) {
			case 0:
				return _Utils_update(
					overrides,
					{agI: '', aiO: '', akk: value});
			case 1:
				return _Utils_update(
					overrides,
					{aiO: value});
			case 2:
				return _Utils_update(
					overrides,
					{agI: value});
			default:
				return _Utils_update(
					overrides,
					{i3: value});
		}
	});
var $author$project$Components$Partner$GenerateListingModal$setValue = F2(
	function (section, value) {
		return _Utils_update(
			section,
			{aee: value});
	});
var $author$project$Components$Partner$GenerateListingModal$CategoryDropdownMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Partner$GenerateListingModal$emptyDraft = {
	a2: {
		c: false,
		aee: {Bq: '', adY: ''}
	},
	Nr: {c: false, aee: _List_Nil},
	Tu: {c: false, aee: _List_Nil},
	ahO: {c: false, aee: $elm$core$Maybe$Nothing},
	V5: {c: false, aee: _List_Nil},
	Bq: {c: false, aee: ''},
	YB: {c: false, aee: ''},
	ajI: {c: false, aee: _List_Nil},
	_0: {c: false, aee: _List_Nil},
	acF: {c: false, aee: ''}
};
var $author$project$Components$Partner$GenerateListingModal$isPresent = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map(
		A2(
			$elm$core$Basics$composeR,
			$elm$core$String$trim,
			A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not))),
	$elm$core$Maybe$withDefault(false));
var $author$project$Api$Partner$Marketplace$ListingGeneration$One$result = function (_v0) {
	var r = _v0;
	return r.$U;
};
var $author$project$Components$Partner$GenerateListingModal$draftFromGeneration = function (generation) {
	var _v0 = $author$project$Api$Partner$Marketplace$ListingGeneration$One$result(generation);
	if (!_v0.$) {
		var r = _v0.a;
		var builtByPresent = $author$project$Components$Partner$GenerateListingModal$isPresent(r.ahz.MV) || $author$project$Components$Partner$GenerateListingModal$isPresent(r.ahz.MW);
		return {
			a2: {
				c: builtByPresent,
				aee: {
					Bq: A2($elm$core$Maybe$withDefault, '', r.ahz.MV),
					adY: A2($elm$core$Maybe$withDefault, '', r.ahz.MW)
				}
			},
			Nr: {
				c: !$elm$core$List$isEmpty(r.ahz.Nr),
				aee: r.ahz.Nr
			},
			Tu: {
				c: !$elm$core$List$isEmpty(r.ahz.Tu),
				aee: A2(
					$elm$core$List$map,
					function (h) {
						return {Qr: h.Qr, ahT: h.ahT, ac9: h.ac9};
					},
					r.ahz.Tu)
			},
			ahO: {
				c: $author$project$Components$Partner$GenerateListingModal$isPresent(r.ahz.ahO),
				aee: r.ahz.ahO
			},
			V5: {
				c: !$elm$core$List$isEmpty(r.ahz.V5),
				aee: A2(
					$elm$core$List$map,
					function (l) {
						return {aih: l.aih, adY: l.adY};
					},
					r.ahz.V5)
			},
			Bq: {
				c: $author$project$Components$Partner$GenerateListingModal$isPresent(r.ahz.Bq),
				aee: A2($elm$core$Maybe$withDefault, '', r.ahz.Bq)
			},
			YB: {
				c: $author$project$Components$Partner$GenerateListingModal$isPresent(r.ahz.YB),
				aee: A2($elm$core$Maybe$withDefault, '', r.ahz.YB)
			},
			ajI: {
				c: !$elm$core$List$isEmpty(r.ahz.ajI),
				aee: r.ahz.ajI
			},
			_0: {
				c: !$elm$core$List$isEmpty(r.ahz._0),
				aee: A2(
					$elm$core$List$map,
					function (q) {
						return {Mb: q.Mb, ae1: q.ae1, Md: q.Md, ac3: q.ac3};
					},
					r.ahz._0)
			},
			acF: {
				c: $author$project$Components$Partner$GenerateListingModal$isPresent(r.ahz.acF),
				aee: A2($elm$core$Maybe$withDefault, '', r.ahz.acF)
			}
		};
	} else {
		return $author$project$Components$Partner$GenerateListingModal$emptyDraft;
	}
};
var $author$project$Components$Partner$GenerateListingModal$emptySnapshot = {ae5: _List_Nil, MV: $elm$core$Maybe$Nothing, MW: $elm$core$Maybe$Nothing, Nr: _List_Nil, Tu: _List_Nil, ahO: $elm$core$Maybe$Nothing, V5: _List_Nil, Bq: $elm$core$Maybe$Nothing, YB: $elm$core$Maybe$Nothing, ajI: _List_Nil, _0: _List_Nil, acF: $elm$core$Maybe$Nothing};
var $author$project$Api$Partner$Marketplace$ListingGeneration$One$error = function (_v0) {
	var r = _v0;
	return r.RK;
};
var $author$project$Components$Partner$GenerateListingModal$terminalState = F3(
	function (ctx, generation, submission) {
		var _v0 = $author$project$Api$Partner$Marketplace$ListingGeneration$One$status(generation);
		switch (_v0) {
			case 2:
				var existing = A2(
					$elm$core$Maybe$withDefault,
					$author$project$Components$Partner$GenerateListingModal$emptySnapshot,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.ag1;
						},
						$author$project$Api$Partner$Marketplace$ListingGeneration$One$result(generation)));
				return _Utils_Tuple3(
					$author$project$Components$Partner$GenerateListingModal$EditingDraft(
						{
							mI: $author$project$Ui$Dropdown$init(
								$author$project$Ui$Dropdown$defaultConfig(
									{ahP: 'listing-categories-dropdown', al6: $author$project$Components$Partner$GenerateListingModal$CategoryDropdownMsg})),
							fU: '',
							f$: false,
							bw: $author$project$Components$Partner$GenerateListingModal$draftFromGeneration(generation),
							ag1: existing,
							oS: ctx.oS,
							k8: $author$project$Api$Data$NotAsked,
							aY: submission
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				return _Utils_Tuple3(
					$author$project$Components$Partner$GenerateListingModal$Failed(
						{
							aiH: A2(
								$elm$core$Maybe$withDefault,
								'Generation failed.',
								$author$project$Api$Partner$Marketplace$ListingGeneration$One$error(generation)),
							aY: submission
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				return _Utils_Tuple3($author$project$Components$Partner$GenerateListingModal$Closed, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Components$Partner$GenerateListingModal$setInclude = F2(
	function (section, value) {
		return _Utils_update(
			section,
			{c: value});
	});
var $author$project$Components$Partner$GenerateListingModal$toggleInclude = F3(
	function (section, value, draft) {
		switch (section) {
			case 0:
				return _Utils_update(
					draft,
					{
						Bq: A2($author$project$Components$Partner$GenerateListingModal$setInclude, draft.Bq, value)
					});
			case 1:
				return _Utils_update(
					draft,
					{
						a2: A2($author$project$Components$Partner$GenerateListingModal$setInclude, draft.a2, value)
					});
			case 2:
				return _Utils_update(
					draft,
					{
						ahO: A2($author$project$Components$Partner$GenerateListingModal$setInclude, draft.ahO, value)
					});
			case 3:
				return _Utils_update(
					draft,
					{
						Nr: A2($author$project$Components$Partner$GenerateListingModal$setInclude, draft.Nr, value)
					});
			case 4:
				return _Utils_update(
					draft,
					{
						acF: A2($author$project$Components$Partner$GenerateListingModal$setInclude, draft.acF, value)
					});
			case 5:
				return _Utils_update(
					draft,
					{
						YB: A2($author$project$Components$Partner$GenerateListingModal$setInclude, draft.YB, value)
					});
			case 6:
				return _Utils_update(
					draft,
					{
						ajI: A2($author$project$Components$Partner$GenerateListingModal$setInclude, draft.ajI, value)
					});
			case 7:
				return _Utils_update(
					draft,
					{
						Tu: A2($author$project$Components$Partner$GenerateListingModal$setInclude, draft.Tu, value)
					});
			case 8:
				return _Utils_update(
					draft,
					{
						V5: A2($author$project$Components$Partner$GenerateListingModal$setInclude, draft.V5, value)
					});
			default:
				return _Utils_update(
					draft,
					{
						_0: A2($author$project$Components$Partner$GenerateListingModal$setInclude, draft._0, value)
					});
		}
	});
var $author$project$Components$Partner$GenerateListingModal$updateBuiltBy = F3(
	function (field, value, row) {
		if (!field) {
			return _Utils_update(
				row,
				{Bq: value});
		} else {
			return _Utils_update(
				row,
				{adY: value});
		}
	});
var $author$project$Components$Partner$GenerateListingModal$updateDraft = F2(
	function (model, fn) {
		if (model.$ === 4) {
			var state = model.a;
			return _Utils_Tuple3(
				$author$project$Components$Partner$GenerateListingModal$EditingDraft(
					_Utils_update(
						state,
						{
							bw: fn(state.bw)
						})),
				$elm$core$Platform$Cmd$none,
				_List_Nil);
		} else {
			return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Components$Partner$GenerateListingModal$updateHighlightRow = F5(
	function (targetIndex, field, value, index, row) {
		if (_Utils_eq(index, targetIndex)) {
			if (!field) {
				return _Utils_update(
					row,
					{ac9: value});
			} else {
				return _Utils_update(
					row,
					{Qr: value});
			}
		} else {
			return row;
		}
	});
var $author$project$Components$Partner$GenerateListingModal$updateLinkRow = F5(
	function (targetIndex, field, value, index, row) {
		if (_Utils_eq(index, targetIndex)) {
			if (!field) {
				return _Utils_update(
					row,
					{aih: value});
			} else {
				return _Utils_update(
					row,
					{adY: value});
			}
		} else {
			return row;
		}
	});
var $author$project$Components$Partner$GenerateListingModal$updateQuoteRow = F5(
	function (targetIndex, field, value, index, row) {
		if (_Utils_eq(index, targetIndex)) {
			switch (field) {
				case 0:
					return _Utils_update(
						row,
						{ac3: value});
				case 1:
					return _Utils_update(
						row,
						{Mb: value});
				default:
					return _Utils_update(
						row,
						{Md: value});
			}
		} else {
			return row;
		}
	});
var $author$project$Components$Partner$GenerateListingModal$validateUrl = function (raw) {
	var trimmed = $elm$core$String$trim(raw);
	return $elm$core$String$isEmpty(trimmed) ? $elm$core$Result$Err('Enter a URL to continue.') : ((!(A2($elm$core$String$startsWith, 'http://', trimmed) || A2($elm$core$String$startsWith, 'https://', trimmed))) ? $elm$core$Result$Err('URL must start with http:// or https://') : $elm$core$Result$Ok(trimmed));
};
var $author$project$Components$Partner$GenerateListingModal$update = F4(
	function (apiClient, ctx, msg, model) {
		switch (msg.$) {
			case 8:
				return _Utils_Tuple3($author$project$Components$Partner$GenerateListingModal$Closed, $elm$core$Platform$Cmd$none, _List_Nil);
			case 0:
				var value = msg.a;
				switch (model.$) {
					case 1:
						var form = model.a;
						return _Utils_Tuple3(
							$author$project$Components$Partner$GenerateListingModal$EditingUrl(
								_Utils_update(
									form,
									{RK: $elm$core$Maybe$Nothing, adY: value})),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					case 5:
						var submission = model.a.aY;
						var form = $author$project$Components$Partner$GenerateListingModal$formStateFromSubmission(submission);
						return _Utils_Tuple3(
							$author$project$Components$Partner$GenerateListingModal$EditingUrl(
								_Utils_update(
									form,
									{RK: $elm$core$Maybe$Nothing, adY: value})),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 1:
				var field = msg.a;
				var value = msg.b;
				if (model.$ === 1) {
					var form = model.a;
					return _Utils_Tuple3(
						$author$project$Components$Partner$GenerateListingModal$EditingUrl(
							_Utils_update(
								form,
								{
									az: A3($author$project$Components$Partner$GenerateListingModal$setOverrideField, field, value, form.az)
								})),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				var response = msg.a;
				var _v3 = _Utils_Tuple2(model, response);
				if (_v3.a.$ === 1) {
					if (_v3.b.$ === 3) {
						var form = _v3.a.a;
						var _v4 = _v3.b;
						var defaults = _v4.a;
						return _Utils_Tuple3(
							$author$project$Components$Partner$GenerateListingModal$EditingUrl(
								_Utils_update(
									form,
									{
										me: response,
										az: A2($author$project$Components$Partner$GenerateListingModal$mergeDefaultsIntoOverrides, defaults, form.az)
									})),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						var form = _v3.a.a;
						return _Utils_Tuple3(
							$author$project$Components$Partner$GenerateListingModal$EditingUrl(
								_Utils_update(
									form,
									{me: response})),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				if (model.$ === 1) {
					var form = model.a;
					var _v6 = $author$project$Components$Partner$GenerateListingModal$validateUrl(form.adY);
					if (_v6.$ === 1) {
						var message = _v6.a;
						return _Utils_Tuple3(
							$author$project$Components$Partner$GenerateListingModal$EditingUrl(
								_Utils_update(
									form,
									{
										RK: $elm$core$Maybe$Just(message)
									})),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						var cleanUrl = _v6.a;
						var submission = {Ij: form.Ij, az: form.az, adY: cleanUrl};
						return _Utils_Tuple3(
							$author$project$Components$Partner$GenerateListingModal$Submitting(submission),
							A4(
								$author$project$Api$Partner$Marketplace$ListingGeneration$create,
								apiClient,
								ctx.oS,
								$author$project$Components$Partner$GenerateListingModal$createFields(submission),
								$author$project$Components$Partner$GenerateListingModal$GotGeneration),
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				var response = msg.a;
				var _v7 = _Utils_Tuple2(model, response);
				if (_v7.a.$ === 2) {
					if (_v7.b.$ === 3) {
						var submission = _v7.a.a;
						var _v8 = _v7.b;
						var generation = _v8.a;
						if ($author$project$Api$Partner$Marketplace$ListingGeneration$One$isTerminal(generation)) {
							return A3($author$project$Components$Partner$GenerateListingModal$terminalState, ctx, generation, submission);
						} else {
							var polling = {
								rn: 0,
								zK: $author$project$Api$Partner$Marketplace$ListingGeneration$One$id(generation),
								ajN: $elm$core$Maybe$Just(generation),
								aY: submission
							};
							return _Utils_Tuple3(
								$author$project$Components$Partner$GenerateListingModal$Polling(polling),
								$author$project$Components$Partner$GenerateListingModal$scheduleNextPoll(polling.zK),
								_List_Nil);
						}
					} else {
						var submission = _v7.a.a;
						return _Utils_Tuple3(
							$author$project$Components$Partner$GenerateListingModal$Failed(
								{
									aiH: $author$project$Components$Partner$GenerateListingModal$errorMessage(response),
									aY: submission
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				var generationId = msg.a;
				if (model.$ === 3) {
					var state = model.a;
					return (!_Utils_eq(state.zK, generationId)) ? _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil) : ((_Utils_cmp(state.rn, $author$project$Components$Partner$GenerateListingModal$maxAttempts) > -1) ? _Utils_Tuple3(
						$author$project$Components$Partner$GenerateListingModal$Failed(
							{aiH: 'Generation is taking longer than expected. Please try again.', aY: state.aY}),
						$elm$core$Platform$Cmd$none,
						_List_Nil) : _Utils_Tuple3(
						$author$project$Components$Partner$GenerateListingModal$Polling(
							_Utils_update(
								state,
								{rn: state.rn + 1})),
						A3($author$project$Api$Partner$Marketplace$ListingGeneration$retrieve, apiClient, generationId, $author$project$Components$Partner$GenerateListingModal$GotPoll),
						_List_Nil));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var response = msg.a;
				var _v10 = _Utils_Tuple2(model, response);
				if (_v10.a.$ === 3) {
					if (_v10.b.$ === 3) {
						var state = _v10.a.a;
						var _v11 = _v10.b;
						var generation = _v11.a;
						return $author$project$Api$Partner$Marketplace$ListingGeneration$One$isTerminal(generation) ? A3($author$project$Components$Partner$GenerateListingModal$terminalState, ctx, generation, state.aY) : _Utils_Tuple3(
							$author$project$Components$Partner$GenerateListingModal$Polling(
								_Utils_update(
									state,
									{
										ajN: $elm$core$Maybe$Just(generation)
									})),
							$author$project$Components$Partner$GenerateListingModal$scheduleNextPoll(
								$author$project$Api$Partner$Marketplace$ListingGeneration$One$id(generation)),
							_List_Nil);
					} else {
						var state = _v10.a.a;
						return _Utils_Tuple3(
							$author$project$Components$Partner$GenerateListingModal$Failed(
								{
									aiH: $author$project$Components$Partner$GenerateListingModal$errorMessage(response),
									aY: state.aY
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				switch (model.$) {
					case 5:
						var submission = model.a.aY;
						return _Utils_Tuple3(
							$author$project$Components$Partner$GenerateListingModal$EditingUrl(
								$author$project$Components$Partner$GenerateListingModal$formStateFromSubmission(submission)),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					case 4:
						var state = model.a;
						return _Utils_Tuple3(
							$author$project$Components$Partner$GenerateListingModal$EditingUrl(
								$author$project$Components$Partner$GenerateListingModal$formStateFromSubmission(state.aY)),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var section = msg.a;
				var value = msg.b;
				return A2(
					$author$project$Components$Partner$GenerateListingModal$updateDraft,
					model,
					A2($author$project$Components$Partner$GenerateListingModal$toggleInclude, section, value));
			case 10:
				var value = msg.a;
				return A2(
					$author$project$Components$Partner$GenerateListingModal$updateDraft,
					model,
					function (d) {
						return _Utils_update(
							d,
							{
								Bq: A2($author$project$Components$Partner$GenerateListingModal$setValue, d.Bq, value)
							});
					});
			case 11:
				var field = msg.a;
				var value = msg.b;
				return A2(
					$author$project$Components$Partner$GenerateListingModal$updateDraft,
					model,
					function (d) {
						return _Utils_update(
							d,
							{
								a2: A2(
									$author$project$Components$Partner$GenerateListingModal$mapValue,
									d.a2,
									A2($author$project$Components$Partner$GenerateListingModal$updateBuiltBy, field, value))
							});
					});
			case 16:
				var index = msg.a;
				return A2(
					$author$project$Components$Partner$GenerateListingModal$updateDraft,
					model,
					function (d) {
						return _Utils_update(
							d,
							{
								Nr: A2(
									$author$project$Components$Partner$GenerateListingModal$mapValue,
									d.Nr,
									$author$project$Components$Partner$GenerateListingModal$removeAt(index))
							});
					});
			case 13:
				var subMsg = msg.a;
				if (model.$ === 4) {
					var state = model.a;
					var _v14 = A2($author$project$Ui$Dropdown$update, subMsg, state.mI);
					var updated = _v14.a;
					var cmd = _v14.b;
					return _Utils_Tuple3(
						$author$project$Components$Partner$GenerateListingModal$EditingDraft(
							_Utils_update(
								state,
								{mI: updated})),
						cmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 14:
				var value = msg.a;
				if (model.$ === 4) {
					var state = model.a;
					return _Utils_Tuple3(
						$author$project$Components$Partner$GenerateListingModal$EditingDraft(
							_Utils_update(
								state,
								{fU: value})),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 15:
				var rawName = msg.a;
				if (model.$ === 4) {
					var state = model.a;
					var oldDraft = state.bw;
					var name = $elm$core$String$trim(rawName);
					var alreadySelected = A2($elm$core$List$member, name, state.bw.Nr.aee);
					var newDraft = ($elm$core$String$isEmpty(name) || alreadySelected) ? oldDraft : _Utils_update(
						oldDraft,
						{
							Nr: {
								c: true,
								aee: _Utils_ap(
									oldDraft.Nr.aee,
									_List_fromArray(
										[name]))
							}
						});
					return _Utils_Tuple3(
						$author$project$Components$Partner$GenerateListingModal$EditingDraft(
							_Utils_update(
								state,
								{fU: '', bw: newDraft})),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 12:
				return A2(
					$author$project$Components$Partner$GenerateListingModal$updateDraft,
					model,
					function (d) {
						return _Utils_update(
							d,
							{
								ahO: A2($author$project$Components$Partner$GenerateListingModal$setValue, d.ahO, $elm$core$Maybe$Nothing)
							});
					});
			case 17:
				var value = msg.a;
				return A2(
					$author$project$Components$Partner$GenerateListingModal$updateDraft,
					model,
					function (d) {
						return _Utils_update(
							d,
							{
								acF: A2($author$project$Components$Partner$GenerateListingModal$setValue, d.acF, value)
							});
					});
			case 18:
				var value = msg.a;
				return A2(
					$author$project$Components$Partner$GenerateListingModal$updateDraft,
					model,
					function (d) {
						return _Utils_update(
							d,
							{
								YB: A2($author$project$Components$Partner$GenerateListingModal$setValue, d.YB, value)
							});
					});
			case 19:
				var index = msg.a;
				return A2(
					$author$project$Components$Partner$GenerateListingModal$updateDraft,
					model,
					function (d) {
						return _Utils_update(
							d,
							{
								ajI: A2(
									$author$project$Components$Partner$GenerateListingModal$mapValue,
									d.ajI,
									$author$project$Components$Partner$GenerateListingModal$removeAt(index))
							});
					});
			case 20:
				var index = msg.a;
				var field = msg.b;
				var value = msg.c;
				return A2(
					$author$project$Components$Partner$GenerateListingModal$updateDraft,
					model,
					function (d) {
						return _Utils_update(
							d,
							{
								Tu: A2(
									$author$project$Components$Partner$GenerateListingModal$mapValue,
									d.Tu,
									$elm$core$List$indexedMap(
										A3($author$project$Components$Partner$GenerateListingModal$updateHighlightRow, index, field, value)))
							});
					});
			case 21:
				var index = msg.a;
				return A2(
					$author$project$Components$Partner$GenerateListingModal$updateDraft,
					model,
					function (d) {
						return _Utils_update(
							d,
							{
								Tu: A2(
									$author$project$Components$Partner$GenerateListingModal$mapValue,
									d.Tu,
									$author$project$Components$Partner$GenerateListingModal$removeAt(index))
							});
					});
			case 22:
				var index = msg.a;
				return A2(
					$author$project$Components$Partner$GenerateListingModal$updateDraft,
					model,
					function (d) {
						return _Utils_update(
							d,
							{
								Tu: A2(
									$author$project$Components$Partner$GenerateListingModal$mapValue,
									d.Tu,
									$elm$core$List$indexedMap(
										F2(
											function (i, row) {
												return _Utils_eq(i, index) ? _Utils_update(
													row,
													{ahT: $elm$core$Maybe$Nothing}) : row;
											})))
							});
					});
			case 23:
				var index = msg.a;
				var field = msg.b;
				var value = msg.c;
				return A2(
					$author$project$Components$Partner$GenerateListingModal$updateDraft,
					model,
					function (d) {
						return _Utils_update(
							d,
							{
								V5: A2(
									$author$project$Components$Partner$GenerateListingModal$mapValue,
									d.V5,
									$elm$core$List$indexedMap(
										A3($author$project$Components$Partner$GenerateListingModal$updateLinkRow, index, field, value)))
							});
					});
			case 24:
				var index = msg.a;
				return A2(
					$author$project$Components$Partner$GenerateListingModal$updateDraft,
					model,
					function (d) {
						return _Utils_update(
							d,
							{
								V5: A2(
									$author$project$Components$Partner$GenerateListingModal$mapValue,
									d.V5,
									$author$project$Components$Partner$GenerateListingModal$removeAt(index))
							});
					});
			case 25:
				var index = msg.a;
				var field = msg.b;
				var value = msg.c;
				return A2(
					$author$project$Components$Partner$GenerateListingModal$updateDraft,
					model,
					function (d) {
						return _Utils_update(
							d,
							{
								_0: A2(
									$author$project$Components$Partner$GenerateListingModal$mapValue,
									d._0,
									$elm$core$List$indexedMap(
										A3($author$project$Components$Partner$GenerateListingModal$updateQuoteRow, index, field, value)))
							});
					});
			case 26:
				var index = msg.a;
				return A2(
					$author$project$Components$Partner$GenerateListingModal$updateDraft,
					model,
					function (d) {
						return _Utils_update(
							d,
							{
								_0: A2(
									$author$project$Components$Partner$GenerateListingModal$mapValue,
									d._0,
									$author$project$Components$Partner$GenerateListingModal$removeAt(index))
							});
					});
			case 27:
				var index = msg.a;
				return A2(
					$author$project$Components$Partner$GenerateListingModal$updateDraft,
					model,
					function (d) {
						return _Utils_update(
							d,
							{
								_0: A2(
									$author$project$Components$Partner$GenerateListingModal$mapValue,
									d._0,
									$elm$core$List$indexedMap(
										F2(
											function (i, row) {
												return _Utils_eq(i, index) ? _Utils_update(
													row,
													{ae1: $elm$core$Maybe$Nothing}) : row;
											})))
							});
					});
			case 28:
				if (model.$ === 4) {
					var state = model.a;
					return $author$project$Components$Partner$GenerateListingModal$anySectionIncluded(state.bw) ? _Utils_Tuple3(
						$author$project$Components$Partner$GenerateListingModal$EditingDraft(
							_Utils_update(
								state,
								{f$: true})),
						$elm$core$Platform$Cmd$none,
						_List_Nil) : _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 29:
				var confirmed = msg.a;
				if (model.$ === 4) {
					var state = model.a;
					if (!confirmed) {
						return _Utils_Tuple3(
							$author$project$Components$Partner$GenerateListingModal$EditingDraft(
								_Utils_update(
									state,
									{f$: false})),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						var fields = $author$project$Components$Partner$GenerateListingModal$permittedFieldsFromDraft(state.bw);
						return $elm$core$List$isEmpty(fields) ? _Utils_Tuple3(
							$author$project$Components$Partner$GenerateListingModal$EditingDraft(
								_Utils_update(
									state,
									{f$: false})),
							$elm$core$Platform$Cmd$none,
							_List_Nil) : _Utils_Tuple3(
							$author$project$Components$Partner$GenerateListingModal$EditingDraft(
								_Utils_update(
									state,
									{f$: false, k8: $author$project$Api$Data$Loading})),
							A4($author$project$Api$Partner$PartnerProduct$replaceListing, apiClient, state.oS, fields, $author$project$Components$Partner$GenerateListingModal$GotSaveResponse),
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var response = msg.a;
				var _v19 = _Utils_Tuple2(model, response);
				if (_v19.a.$ === 4) {
					if (_v19.b.$ === 3) {
						var _v20 = _v19.b;
						return _Utils_Tuple3(
							$author$project$Components$Partner$GenerateListingModal$Closed,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Listing updated.'),
									$author$project$OutMsg$RefreshPartner
								]));
					} else {
						var state = _v19.a.a;
						return _Utils_Tuple3(
							$author$project$Components$Partner$GenerateListingModal$EditingDraft(
								_Utils_update(
									state,
									{k8: response})),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Components$Partner$ManagePartnerProductCategories$CategoryCreated = 1;
var $author$project$Components$Partner$ManagePartnerProductCategories$CategoryDeleted = 3;
var $author$project$Components$Partner$ManagePartnerProductCategories$CategoryUpdated = 2;
var $author$project$Components$Partner$ManagePartnerProductCategories$Created = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductCategories$Deleted = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductCategories$None = 0;
var $author$project$Components$Partner$ManagePartnerProductCategories$Updated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Common$Marketplace$Product$Category$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Components$Partner$ManagePartnerProductCategories$categoryFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var name = field.a;
			return _Utils_update(
				fields,
				{Bq: name, pT: $elm$core$Maybe$Nothing});
		} else {
			var category = field.a;
			return _Utils_update(
				fields,
				{
					Bq: $author$project$Api$Common$Marketplace$Product$Category$name(category),
					pT: $elm$core$Maybe$Just(
						$author$project$Api$Common$Marketplace$Product$Category$id(category))
				});
		}
	});
var $author$project$Components$Partner$ManagePartnerProductCategories$NameValidation = 0;
var $author$project$Components$Partner$ManagePartnerProductCategories$categoryValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.Bq;
			},
			_Utils_Tuple2(0, 'Please enter a category name.'))
		]));
var $author$project$Api$Partner$PartnerProductCategory$partnerProductCategoriesPath = function (productId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['partner_products', productId, 'categories']),
		$author$project$Api$Data$partnerPath);
};
var $author$project$Api$Partner$PartnerProductCategory$create = F4(
	function (apiClient, productId, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'partner_product_category',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(params.Bq))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$PartnerProductCategory$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Partner$PartnerProductCategory$partnerProductCategoriesPath(productId))));
	});
var $author$project$Api$Partner$PartnerProductCategory$partnerProductCategoryPath = F2(
	function (productId, id_) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id_]),
			$author$project$Api$Partner$PartnerProductCategory$partnerProductCategoriesPath(productId));
	});
var $author$project$Api$Partner$PartnerProductCategory$delete = F4(
	function (apiClient, productId, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Partner$PartnerProductCategory$partnerProductCategoryPath, productId, id)));
	});
var $author$project$Components$Partner$ManagePartnerProductCategories$initCategoryFields = {Bq: '', pT: $elm$core$Maybe$Nothing};
var $author$project$Api$Partner$PartnerProductCategory$update = F4(
	function (apiClient, productId, id, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Partner$PartnerProductCategory$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Partner$PartnerProductCategory$partnerProductCategoryPath, productId, id)));
	});
var $author$project$Components$Partner$ManagePartnerProductCategories$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		var noOp = {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
		switch (msg.$) {
			case 0:
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							Q: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init($author$project$Components$Partner$ManagePartnerProductCategories$initCategoryFields),
									$author$project$Api$Data$NotAsked))
						}),
					aR: _List_Nil
				};
			case 1:
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{Q: $elm$core$Maybe$Nothing}),
					aR: _List_Nil
				};
			case 2:
				var field = msg.a;
				var _v2 = model.Q;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var id = _v3.a;
					var form = _v3.b;
					var request = _v3.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Partner$ManagePartnerProductCategories$categoryFieldsUpdate, field, form);
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{
								Q: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, request))
							}),
						aR: _List_Nil
					};
				} else {
					return noOp;
				}
			case 3:
				var _v4 = model.Q;
				if (!_v4.$) {
					var _v5 = _v4.a;
					var maybeCategory = _v5.a;
					var form = _v5.b;
					var _v6 = A2($author$project$Utils$Form$validate, $author$project$Components$Partner$ManagePartnerProductCategories$categoryValidator, form);
					if (!_v6.$) {
						var _v7 = _v6.a;
						var validatedForm = _v7.a;
						var validFormFields = _v7.b;
						var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
						var _v8 = fields.pT;
						if (!_v8.$) {
							var categoryId = _v8.a;
							return {
								GZ: A4($author$project$Api$Partner$PartnerProductCategory$update, apiClient, model.Jn, categoryId, $author$project$Components$Partner$ManagePartnerProductCategories$Updated),
								agZ: 0,
								aiO: _Utils_update(
									model,
									{
										Q: $elm$core$Maybe$Just(
											_Utils_Tuple3(maybeCategory, validatedForm, $author$project$Api$Data$Loading))
									}),
								aR: _List_Nil
							};
						} else {
							return {
								GZ: A4(
									$author$project$Api$Partner$PartnerProductCategory$create,
									apiClient,
									model.Jn,
									{Bq: fields.Bq},
									$author$project$Components$Partner$ManagePartnerProductCategories$Created),
								agZ: 0,
								aiO: _Utils_update(
									model,
									{
										Q: $elm$core$Maybe$Just(
											_Utils_Tuple3(maybeCategory, validatedForm, $author$project$Api$Data$Loading))
									}),
								aR: _List_Nil
							};
						}
					} else {
						var validatedForm = _v6.a;
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 0,
							aiO: _Utils_update(
								model,
								{
									Q: $elm$core$Maybe$Just(
										_Utils_Tuple3(maybeCategory, validatedForm, $author$project$Api$Data$NotAsked))
								}),
							aR: _List_Nil
						};
					}
				} else {
					return noOp;
				}
			case 4:
				var response = msg.a;
				var _v9 = model.Q;
				if (!_v9.$) {
					var _v10 = _v9.a;
					var maybeCategory = _v10.a;
					var form = _v10.b;
					if (response.$ === 3) {
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 1,
							aiO: _Utils_update(
								model,
								{Q: $elm$core$Maybe$Nothing}),
							aR: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Category added successfully!')
								])
						};
					} else {
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 0,
							aiO: _Utils_update(
								model,
								{
									Q: $elm$core$Maybe$Just(
										_Utils_Tuple3(maybeCategory, form, response))
								}),
							aR: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
				} else {
					return noOp;
				}
			case 5:
				var response = msg.a;
				var _v12 = model.Q;
				if (!_v12.$) {
					var _v13 = _v12.a;
					var maybeCategory = _v13.a;
					var form = _v13.b;
					if (response.$ === 3) {
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 2,
							aiO: _Utils_update(
								model,
								{Q: $elm$core$Maybe$Nothing}),
							aR: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Category added successfully!')
								])
						};
					} else {
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 0,
							aiO: _Utils_update(
								model,
								{
									Q: $elm$core$Maybe$Just(
										_Utils_Tuple3(maybeCategory, form, response))
								}),
							aR: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
				} else {
					return noOp;
				}
			case 7:
				var id = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							cu: $elm$core$Maybe$Just(
								_Utils_Tuple2(id, $author$project$Api$Data$NotAsked))
						}),
					aR: _List_Nil
				};
			case 8:
				var confirmed = msg.a;
				var _v15 = model.cu;
				if (!_v15.$) {
					var _v16 = _v15.a;
					var id = _v16.a;
					return confirmed ? {
						GZ: A4($author$project$Api$Partner$PartnerProductCategory$delete, apiClient, model.Jn, id, $author$project$Components$Partner$ManagePartnerProductCategories$Deleted),
						agZ: 0,
						aiO: _Utils_update(
							model,
							{
								cu: $elm$core$Maybe$Just(
									_Utils_Tuple2(id, $author$project$Api$Data$Loading))
							}),
						aR: _List_Nil
					} : {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{cu: $elm$core$Maybe$Nothing}),
						aR: _List_Nil
					};
				} else {
					return noOp;
				}
			case 9:
				var response = msg.a;
				var _v17 = model.cu;
				if (!_v17.$) {
					var _v18 = _v17.a;
					var id = _v18.a;
					if (response.$ === 3) {
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 3,
							aiO: _Utils_update(
								model,
								{cu: $elm$core$Maybe$Nothing}),
							aR: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Category removed successfully!')
								])
						};
					} else {
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 0,
							aiO: _Utils_update(
								model,
								{
									cu: $elm$core$Maybe$Just(
										_Utils_Tuple2(id, response))
								}),
							aR: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
				} else {
					return noOp;
				}
			case 6:
				var subMsg = msg.a;
				var _v20 = A2($author$project$Ui$Dropdown$update, subMsg, model.mI);
				var updatedDropdown = _v20.a;
				var dropdownCmd = _v20.b;
				return {
					GZ: dropdownCmd,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{mI: updatedDropdown}),
					aR: _List_Nil
				};
			default:
				var response = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{Nr: response}),
					aR: _List_Nil
				};
		}
	});
var $author$project$Components$Partner$ManagePartnerProductDataFlows$DataFlowsFetched = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductDataFlows$Deleted = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Partner$PartnerProductDataFlow$Position = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductDataFlows$PositionUpdated = function (a) {
	return {$: 12, a: a};
};
var $author$project$Api$Common$Marketplace$Product$SyncDirection$default = 0;
var $author$project$Components$Partner$ManagePartnerProductDataFlows$dataFlowFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var hintName = field.a;
				return _Utils_update(
					fields,
					{TA: hintName});
			case 1:
				var partnerName = field.a;
				return _Utils_update(
					fields,
					{YR: partnerName});
			default:
				var syncDirection = field.a;
				return _Utils_update(
					fields,
					{
						acK: A2(
							$elm$core$Maybe$withDefault,
							$author$project$Api$Common$Marketplace$Product$SyncDirection$default,
							$author$project$Api$Common$Marketplace$Product$SyncDirection$fromString(syncDirection))
					});
		}
	});
var $author$project$Components$Partner$ManagePartnerProductDataFlows$HintNameValidation = 0;
var $author$project$Components$Partner$ManagePartnerProductDataFlows$PartnerNameValidation = 1;
var $author$project$Components$Partner$ManagePartnerProductDataFlows$dataFlowValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.TA;
			},
			_Utils_Tuple2(0, 'Please enter a hint name.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.YR;
			},
			_Utils_Tuple2(1, 'Please enter a partner name.'))
		]));
var $author$project$Api$Partner$PartnerProductDataFlow$partnerProductDataFlowsPath = function (productId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['partner_products', productId, 'data_flows']),
		$author$project$Api$Data$partnerPath);
};
var $author$project$Api$Partner$PartnerProductDataFlow$partnerProductDataFlowPath = F2(
	function (productId, id_) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id_]),
			$author$project$Api$Partner$PartnerProductDataFlow$partnerProductDataFlowsPath(productId));
	});
var $author$project$Api$Partner$PartnerProductDataFlow$delete = F4(
	function (apiClient, productId, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Partner$PartnerProductDataFlow$partnerProductDataFlowPath, productId, id)));
	});
var $author$project$Api$Partner$PartnerProductDataFlow$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Components$Partner$ManagePartnerProductDataFlows$initDataFlowFields = {TA: '', YR: '', acK: 1};
var $author$project$Api$Partner$PartnerProductDataFlow$Shared$hintName = function (_v0) {
	var record = _v0;
	return record.TA;
};
var $author$project$Api$Partner$PartnerProductDataFlow$Shared$partnerName = function (_v0) {
	var record = _v0;
	return record.YR;
};
var $author$project$Api$Partner$PartnerProductDataFlow$Shared$syncDirection = function (_v0) {
	var record = _v0;
	return record.acK;
};
var $author$project$Components$Partner$ManagePartnerProductDataFlows$initDataFlowFieldsForEdit = function (productDataFlow) {
	return {
		TA: $author$project$Api$Partner$PartnerProductDataFlow$Shared$hintName(productDataFlow),
		YR: $author$project$Api$Partner$PartnerProductDataFlow$Shared$partnerName(productDataFlow),
		acK: $author$project$Api$Partner$PartnerProductDataFlow$Shared$syncDirection(productDataFlow)
	};
};
var $author$project$Api$Partner$PartnerProductDataFlow$list = F3(
	function (apiClient, productId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Partner$PartnerProductDataFlow$Shared$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Partner$PartnerProductDataFlow$partnerProductDataFlowsPath(productId)));
	});
var $author$project$Api$Partner$PartnerProductDataFlow$Shared$position = function (_v0) {
	var record = _v0;
	return record.ZP;
};
var $author$project$Components$Partner$ManagePartnerProductDataFlows$Created = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Partner$PartnerProductDataFlow$One$PartnerProductDataFlow = 0;
var $author$project$Api$Partner$PartnerProductDataFlow$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Common$Marketplace$Product$SyncDirection$toString = function (syncDirection) {
	switch (syncDirection) {
		case 0:
			return 'from_hint';
		case 1:
			return 'to_hint';
		default:
			return 'bidirectional';
	}
};
var $author$project$Api$Common$Marketplace$Product$SyncDirection$encode = function (syncDirection) {
	return $elm$json$Json$Encode$string(
		$author$project$Api$Common$Marketplace$Product$SyncDirection$toString(syncDirection));
};
var $author$project$Api$Partner$PartnerProductDataFlow$create = F4(
	function (apiClient, productId, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'partner_product_data_flow',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'hint_name',
								$elm$json$Json$Encode$string(params.TA)),
								_Utils_Tuple2(
								'partner_name',
								$elm$json$Json$Encode$string(params.YR)),
								_Utils_Tuple2(
								'sync_direction',
								$author$project$Api$Common$Marketplace$Product$SyncDirection$encode(params.acK))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$PartnerProductDataFlow$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Partner$PartnerProductDataFlow$partnerProductDataFlowsPath(productId))));
	});
var $author$project$Components$Partner$ManagePartnerProductDataFlows$createLink = F3(
	function (apiClient, productId, formFields) {
		var _v0 = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var hintName = _v0.TA;
		var partnerName = _v0.YR;
		var syncDirection = _v0.acK;
		return A4(
			$author$project$Api$Partner$PartnerProductDataFlow$create,
			apiClient,
			productId,
			{TA: hintName, YR: partnerName, acK: syncDirection},
			$author$project$Components$Partner$ManagePartnerProductDataFlows$Created);
	});
var $author$project$Api$Partner$PartnerProductDataFlow$HintName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Partner$PartnerProductDataFlow$PartnerName = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Partner$PartnerProductDataFlow$SyncDirectionField = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductDataFlows$Updated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Partner$PartnerProductDataFlow$encodePermittedFields = function (permittedFields) {
	var encodedFields = A3(
		$elm$core$List$foldl,
		F2(
			function (field, acc) {
				switch (field.$) {
					case 0:
						var hintName = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'hint_name',
								$elm$json$Json$Encode$string(hintName)),
							acc);
					case 1:
						var partnerName = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'partner_name',
								$elm$json$Json$Encode$string(partnerName)),
							acc);
					case 2:
						var syncDirection = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'sync_direction',
								$author$project$Api$Common$Marketplace$Product$SyncDirection$encode(syncDirection)),
							acc);
					default:
						var position = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'position',
								$elm$json$Json$Encode$int(position)),
							acc);
				}
			}),
		_List_Nil,
		permittedFields);
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'partner_product_data_flow',
				$elm$json$Json$Encode$object(encodedFields))
			]));
};
var $author$project$Api$Partner$PartnerProductDataFlow$update = F5(
	function (apiClient, productId, id, permittedFields, toMsg) {
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Partner$PartnerProductDataFlow$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Partner$PartnerProductDataFlow$encodePermittedFields(permittedFields),
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Partner$PartnerProductDataFlow$partnerProductDataFlowPath, productId, id))));
	});
var $author$project$Components$Partner$ManagePartnerProductDataFlows$updateLink = F4(
	function (apiClient, productId, id, formFields) {
		var _v0 = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var hintName = _v0.TA;
		var partnerName = _v0.YR;
		var syncDirection = _v0.acK;
		return A5(
			$author$project$Api$Partner$PartnerProductDataFlow$update,
			apiClient,
			productId,
			id,
			_List_fromArray(
				[
					$author$project$Api$Partner$PartnerProductDataFlow$HintName(hintName),
					$author$project$Api$Partner$PartnerProductDataFlow$PartnerName(partnerName),
					$author$project$Api$Partner$PartnerProductDataFlow$SyncDirectionField(syncDirection)
				]),
			$author$project$Components$Partner$ManagePartnerProductDataFlows$Updated);
	});
var $author$project$Components$Partner$ManagePartnerProductDataFlows$save = F4(
	function (apiClient, productId, id, formFields) {
		if (!id.$) {
			var id_ = id.a;
			return A4($author$project$Components$Partner$ManagePartnerProductDataFlows$updateLink, apiClient, productId, id_, formFields);
		} else {
			return A3($author$project$Components$Partner$ManagePartnerProductDataFlows$createLink, apiClient, productId, formFields);
		}
	});
var $author$project$Components$DragDrop$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var item = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							nl: $elm$core$Maybe$Just(item)
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{nl: $elm$core$Maybe$Nothing, sA: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
			default:
				var enteredZone = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							sA: $elm$core$Maybe$Just(enteredZone)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Components$Partner$ManagePartnerProductDataFlows$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							R: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init($author$project$Components$Partner$ManagePartnerProductDataFlows$initDataFlowFields),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var productDataFlow = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							R: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(productDataFlow),
									$author$project$Utils$Form$init(
										$author$project$Components$Partner$ManagePartnerProductDataFlows$initDataFlowFieldsForEdit(productDataFlow)),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{R: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var field = msg.a;
				var _v2 = model.R;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var id = _v3.a;
					var form = _v3.b;
					var request = _v3.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Partner$ManagePartnerProductDataFlows$dataFlowFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								R: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, request))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				var _v4 = model.R;
				if (!_v4.$) {
					var _v5 = _v4.a;
					var productDataFlow = _v5.a;
					var form = _v5.b;
					var _v6 = A2($author$project$Utils$Form$validate, $author$project$Components$Partner$ManagePartnerProductDataFlows$dataFlowValidator, form);
					if (!_v6.$) {
						var _v7 = _v6.a;
						var validatedForm = _v7.a;
						var validFormFields = _v7.b;
						var id = A2($elm$core$Maybe$map, $author$project$Api$Partner$PartnerProductDataFlow$Shared$id, productDataFlow);
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									R: $elm$core$Maybe$Just(
										_Utils_Tuple3(productDataFlow, validatedForm, $author$project$Api$Data$Loading))
								}),
							A4($author$project$Components$Partner$ManagePartnerProductDataFlows$save, apiClient, model.Jn, id, validFormFields),
							_List_Nil);
					} else {
						var validatedForm = _v6.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									R: $elm$core$Maybe$Just(
										_Utils_Tuple3(productDataFlow, validatedForm, $author$project$Api$Data$NotAsked))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				var response = msg.a;
				var _v8 = model.R;
				if (!_v8.$) {
					var _v9 = _v8.a;
					var productDataFlow = _v9.a;
					var form = _v9.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{R: $elm$core$Maybe$Nothing}),
							A3($author$project$Api$Partner$PartnerProductDataFlow$list, apiClient, model.Jn, $author$project$Components$Partner$ManagePartnerProductDataFlows$DataFlowsFetched),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Synced field created successfully!')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									R: $elm$core$Maybe$Just(
										_Utils_Tuple3(productDataFlow, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var response = msg.a;
				var _v11 = model.R;
				if (!_v11.$) {
					var _v12 = _v11.a;
					var productDataFlow = _v12.a;
					var form = _v12.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{R: $elm$core$Maybe$Nothing}),
							A3($author$project$Api$Partner$PartnerProductDataFlow$list, apiClient, model.Jn, $author$project$Components$Partner$ManagePartnerProductDataFlows$DataFlowsFetched),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Synced field updated successfully!')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									R: $elm$core$Maybe$Just(
										_Utils_Tuple3(productDataFlow, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var productDataFlow = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							cA: $elm$core$Maybe$Just(
								_Utils_Tuple2(productDataFlow, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 8:
				var confirmed = msg.a;
				var _v14 = model.cA;
				if (!_v14.$) {
					var _v15 = _v14.a;
					var productDataFlow = _v15.a;
					return confirmed ? _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cA: $elm$core$Maybe$Just(
									_Utils_Tuple2(productDataFlow, $author$project$Api$Data$Loading))
							}),
						A4(
							$author$project$Api$Partner$PartnerProductDataFlow$delete,
							apiClient,
							model.Jn,
							$author$project$Api$Partner$PartnerProductDataFlow$Shared$id(productDataFlow),
							$author$project$Components$Partner$ManagePartnerProductDataFlows$Deleted),
						_List_Nil) : _Utils_Tuple3(
						_Utils_update(
							model,
							{cA: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 10:
				var subMsg = msg.a;
				var _v16 = A2($author$project$Components$DragDrop$update, subMsg, model.nk);
				var dragDrop = _v16.a;
				var cmd = _v16.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nk: dragDrop}),
					cmd,
					_List_Nil);
			case 11:
				var draggedDataFlow = msg.a;
				var zoneIdx = msg.b;
				var fromPos = $author$project$Api$Partner$PartnerProductDataFlow$Shared$position(draggedDataFlow);
				var toIdx = (_Utils_cmp(zoneIdx, fromPos) < 0) ? (zoneIdx + 1) : zoneIdx;
				return _Utils_Tuple3(
					model,
					A5(
						$author$project$Api$Partner$PartnerProductDataFlow$update,
						apiClient,
						model.Jn,
						$author$project$Api$Partner$PartnerProductDataFlow$Shared$id(draggedDataFlow),
						_List_fromArray(
							[
								$author$project$Api$Partner$PartnerProductDataFlow$Position(toIdx)
							]),
						$author$project$Components$Partner$ManagePartnerProductDataFlows$PositionUpdated),
					_List_Nil);
			case 12:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						A3($author$project$Api$Partner$PartnerProductDataFlow$list, apiClient, model.Jn, $author$project$Components$Partner$ManagePartnerProductDataFlows$DataFlowsFetched),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 9:
				var response = msg.a;
				var _v18 = model.cA;
				if (!_v18.$) {
					var _v19 = _v18.a;
					var productDataFlow = _v19.a;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{cA: $elm$core$Maybe$Nothing}),
							A3($author$project$Api$Partner$PartnerProductDataFlow$list, apiClient, model.Jn, $author$project$Components$Partner$ManagePartnerProductDataFlows$DataFlowsFetched),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Synced field deleted successfully!')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									cA: $elm$core$Maybe$Just(
										_Utils_Tuple2(productDataFlow, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var dataFlows = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{PA: dataFlows}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Components$Partner$ManagePartnerProductHighlights$Deleted = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductHighlights$FormUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductHighlights$HighlightsFetched = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductHighlights$Image = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Api$Partner$PartnerProductHighlight$Position = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductHighlights$PositionUpdated = function (a) {
	return {$: 13, a: a};
};
var $author$project$Api$Partner$PartnerProductHighlight$partnerProductHighlightsPath = function (productId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['partner_products', productId, 'highlights']),
		$author$project$Api$Data$partnerPath);
};
var $author$project$Api$Partner$PartnerProductHighlight$partnerProductHighlightPath = F2(
	function (productId, id_) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id_]),
			$author$project$Api$Partner$PartnerProductHighlight$partnerProductHighlightsPath(productId));
	});
var $author$project$Api$Partner$PartnerProductHighlight$delete = F4(
	function (apiClient, productId, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Partner$PartnerProductHighlight$partnerProductHighlightPath, productId, id)));
	});
var $author$project$Components$Partner$ManagePartnerProductHighlights$highlightFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var title = field.a;
				return _Utils_update(
					fields,
					{ac9: title});
			case 1:
				var description = field.a;
				return _Utils_update(
					fields,
					{Qr: description});
			default:
				var imageSize = field.a;
				var imageUrl = field.b;
				return _Utils_update(
					fields,
					{
						rQ: $elm$core$Maybe$Just(imageUrl),
						ahT: $elm$core$Maybe$Just(imageUrl),
						nW: imageSize
					});
		}
	});
var $author$project$Components$Partner$ManagePartnerProductHighlights$DescriptionValidation = 1;
var $author$project$Components$Partner$ManagePartnerProductHighlights$ImageValidation = 2;
var $author$project$Components$Partner$ManagePartnerProductHighlights$TitleValidation = 0;
var $author$project$Components$Partner$ManagePartnerProductHighlights$maxLogoBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
var $author$project$Components$Partner$ManagePartnerProductHighlights$highlightValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.ac9;
			},
			_Utils_Tuple2(0, 'Please enter a title.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.Qr;
			},
			_Utils_Tuple2(1, 'Please enter a description.')),
			A3(
			$author$project$Utils$Validate$ifIntGreaterThan,
			function ($) {
				return $.nW;
			},
			$author$project$Components$Partner$ManagePartnerProductHighlights$maxLogoBytesSize,
			_Utils_Tuple2(2, 'That image is too large! Our maximum image size is 5 mb, please choose a smaller image.'))
		]));
var $author$project$Api$Partner$PartnerProductHighlight$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Components$Partner$ManagePartnerProductHighlights$initHighlightFields = {rQ: $elm$core$Maybe$Nothing, Qr: '', ahT: $elm$core$Maybe$Nothing, nW: 0, ac9: ''};
var $author$project$Api$Partner$PartnerProductHighlight$Shared$description = function (_v0) {
	var record = _v0;
	return record.Qr;
};
var $author$project$Api$Partner$PartnerProductHighlight$Shared$imageUrl = function (_v0) {
	var record = _v0;
	return record.TP;
};
var $author$project$Api$Partner$PartnerProductHighlight$Shared$title = function (_v0) {
	var record = _v0;
	return record.ac9;
};
var $author$project$Components$Partner$ManagePartnerProductHighlights$initHighlightFieldsForEdit = function (productHighlight) {
	return {
		rQ: $author$project$Api$Partner$PartnerProductHighlight$Shared$imageUrl(productHighlight),
		Qr: $author$project$Api$Partner$PartnerProductHighlight$Shared$description(productHighlight),
		ahT: $elm$core$Maybe$Nothing,
		nW: 0,
		ac9: $author$project$Api$Partner$PartnerProductHighlight$Shared$title(productHighlight)
	};
};
var $author$project$Api$Partner$PartnerProductHighlight$list = F3(
	function (apiClient, productId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Partner$PartnerProductHighlight$Shared$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Partner$PartnerProductHighlight$partnerProductHighlightsPath(productId)));
	});
var $author$project$Api$Partner$PartnerProductHighlight$Shared$position = function (_v0) {
	var record = _v0;
	return record.ZP;
};
var $author$project$Components$Partner$ManagePartnerProductHighlights$Created = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Partner$PartnerProductHighlight$One$PartnerProductHighlight = 0;
var $author$project$Api$Partner$PartnerProductHighlight$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Partner$PartnerProductHighlight$create = F4(
	function (apiClient, productId, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'partner_product_highlight',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'title',
								$elm$json$Json$Encode$string(params.ac9)),
								_Utils_Tuple2(
								'description',
								$elm$json$Json$Encode$string(params.Qr)),
								_Utils_Tuple2(
								'image',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.ahT))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$PartnerProductHighlight$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Partner$PartnerProductHighlight$partnerProductHighlightsPath(productId))));
	});
var $author$project$Components$Partner$ManagePartnerProductHighlights$createProductHighlight = F3(
	function (apiClient, productId, formFields) {
		var _v0 = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var title = _v0.ac9;
		var description = _v0.Qr;
		var image = _v0.ahT;
		return A4(
			$author$project$Api$Partner$PartnerProductHighlight$create,
			apiClient,
			productId,
			{Qr: description, ahT: image, ac9: title},
			$author$project$Components$Partner$ManagePartnerProductHighlights$Created);
	});
var $author$project$Api$Partner$PartnerProductHighlight$Description = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Partner$PartnerProductHighlight$Image = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Partner$PartnerProductHighlight$Title = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductHighlights$Updated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Partner$PartnerProductHighlight$encodePermittedFields = function (permittedFields) {
	var encodedFields = A3(
		$elm$core$List$foldl,
		F2(
			function (field, acc) {
				switch (field.$) {
					case 0:
						var title = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'title',
								$elm$json$Json$Encode$string(title)),
							acc);
					case 1:
						var description = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'description',
								$elm$json$Json$Encode$string(description)),
							acc);
					case 2:
						var image = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'image',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, image)),
							acc);
					default:
						var position = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'position',
								$elm$json$Json$Encode$int(position)),
							acc);
				}
			}),
		_List_Nil,
		permittedFields);
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'partner_product_highlight',
				$elm$json$Json$Encode$object(encodedFields))
			]));
};
var $author$project$Api$Partner$PartnerProductHighlight$update = F5(
	function (apiClient, productId, id, permittedFields, toMsg) {
		var body = $author$project$Api$Partner$PartnerProductHighlight$encodePermittedFields(permittedFields);
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Partner$PartnerProductHighlight$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Partner$PartnerProductHighlight$partnerProductHighlightPath, productId, id))));
	});
var $author$project$Components$Partner$ManagePartnerProductHighlights$updateProductHighlight = F4(
	function (apiClient, productId, id, formFields) {
		var _v0 = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var title = _v0.ac9;
		var description = _v0.Qr;
		var image = _v0.ahT;
		return A5(
			$author$project$Api$Partner$PartnerProductHighlight$update,
			apiClient,
			productId,
			id,
			A2(
				$elm$core$List$cons,
				$author$project$Api$Partner$PartnerProductHighlight$Title(title),
				A2(
					$elm$core$List$cons,
					$author$project$Api$Partner$PartnerProductHighlight$Description(description),
					function () {
						if (!image.$) {
							var imageUrl = image.a;
							return _List_fromArray(
								[
									$author$project$Api$Partner$PartnerProductHighlight$Image(
									$elm$core$Maybe$Just(imageUrl))
								]);
						} else {
							return _List_Nil;
						}
					}())),
			$author$project$Components$Partner$ManagePartnerProductHighlights$Updated);
	});
var $author$project$Components$Partner$ManagePartnerProductHighlights$saveProductHighlight = F4(
	function (apiClient, productId, id, formFields) {
		if (!id.$) {
			var id_ = id.a;
			return A4($author$project$Components$Partner$ManagePartnerProductHighlights$updateProductHighlight, apiClient, productId, id_, formFields);
		} else {
			return A3($author$project$Components$Partner$ManagePartnerProductHighlights$createProductHighlight, apiClient, productId, formFields);
		}
	});
var $author$project$Components$Partner$ManagePartnerProductHighlights$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init($author$project$Components$Partner$ManagePartnerProductHighlights$initHighlightFields),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{T: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var logos = msg.a;
				var cmd = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						function (_v2) {
							var task = _v2.a;
							var size = _v2.b;
							return A2(
								$elm$core$Task$perform,
								A2(
									$elm$core$Basics$composeL,
									$author$project$Components$Partner$ManagePartnerProductHighlights$FormUpdated,
									$author$project$Components$Partner$ManagePartnerProductHighlights$Image(size)),
								task);
						},
						A2(
							$elm$core$Maybe$map,
							function (logo) {
								return _Utils_Tuple2(
									$elm$file$File$toUrl(logo),
									$elm$file$File$size(logo));
							},
							$elm$core$List$head(logos))));
				return _Utils_Tuple3(model, cmd, _List_Nil);
			case 2:
				var field = msg.a;
				var _v3 = model.T;
				if (!_v3.$) {
					var _v4 = _v3.a;
					var id = _v4.a;
					var form = _v4.b;
					var request = _v4.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Partner$ManagePartnerProductHighlights$highlightFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								T: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, request))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				var productHighlight = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(productHighlight),
									$author$project$Utils$Form$init(
										$author$project$Components$Partner$ManagePartnerProductHighlights$initHighlightFieldsForEdit(productHighlight)),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var _v5 = model.T;
				if (!_v5.$) {
					var _v6 = _v5.a;
					var item = _v6.a;
					var form = _v6.b;
					var _v7 = A2($author$project$Utils$Form$validate, $author$project$Components$Partner$ManagePartnerProductHighlights$highlightValidator, form);
					if (!_v7.$) {
						var _v8 = _v7.a;
						var validatedForm = _v8.a;
						var validFormFields = _v8.b;
						var id = A2($elm$core$Maybe$map, $author$project$Api$Partner$PartnerProductHighlight$Shared$id, item);
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									T: $elm$core$Maybe$Just(
										_Utils_Tuple3(item, validatedForm, $author$project$Api$Data$Loading))
								}),
							A4($author$project$Components$Partner$ManagePartnerProductHighlights$saveProductHighlight, apiClient, model.Jn, id, validFormFields),
							_List_Nil);
					} else {
						var validatedForm = _v7.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									T: $elm$core$Maybe$Just(
										_Utils_Tuple3(item, validatedForm, $author$project$Api$Data$NotAsked))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var response = msg.a;
				var _v9 = model.T;
				if (!_v9.$) {
					var _v10 = _v9.a;
					var productHighlight = _v10.a;
					var form = _v10.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{T: $elm$core$Maybe$Nothing}),
							A3($author$project$Api$Partner$PartnerProductHighlight$list, apiClient, model.Jn, $author$project$Components$Partner$ManagePartnerProductHighlights$HighlightsFetched),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Product highlight created successfully!')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									T: $elm$core$Maybe$Just(
										_Utils_Tuple3(productHighlight, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var response = msg.a;
				var _v12 = model.T;
				if (!_v12.$) {
					var _v13 = _v12.a;
					var item = _v13.a;
					var form = _v13.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{T: $elm$core$Maybe$Nothing}),
							A3($author$project$Api$Partner$PartnerProductHighlight$list, apiClient, model.Jn, $author$project$Components$Partner$ManagePartnerProductHighlights$HighlightsFetched),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Product highlight updated successfully!')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									T: $elm$core$Maybe$Just(
										_Utils_Tuple3(item, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 8:
				var productHighlight = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							cw: $elm$core$Maybe$Just(
								_Utils_Tuple2(productHighlight, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 9:
				var confirmed = msg.a;
				var _v15 = model.cw;
				if (!_v15.$) {
					var _v16 = _v15.a;
					var productHighlight = _v16.a;
					return confirmed ? _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cw: $elm$core$Maybe$Just(
									_Utils_Tuple2(productHighlight, $author$project$Api$Data$Loading))
							}),
						A4(
							$author$project$Api$Partner$PartnerProductHighlight$delete,
							apiClient,
							model.Jn,
							$author$project$Api$Partner$PartnerProductHighlight$Shared$id(productHighlight),
							$author$project$Components$Partner$ManagePartnerProductHighlights$Deleted),
						_List_Nil) : _Utils_Tuple3(
						_Utils_update(
							model,
							{cw: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 10:
				var response = msg.a;
				var _v17 = model.cw;
				if (!_v17.$) {
					var _v18 = _v17.a;
					var productHighlight = _v18.a;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{cw: $elm$core$Maybe$Nothing}),
							A3($author$project$Api$Partner$PartnerProductHighlight$list, apiClient, model.Jn, $author$project$Components$Partner$ManagePartnerProductHighlights$HighlightsFetched),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Product highlight deleted successfully!')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									cw: $elm$core$Maybe$Just(
										_Utils_Tuple2(productHighlight, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 11:
				var subMsg = msg.a;
				var _v20 = A2($author$project$Components$DragDrop$update, subMsg, model.nk);
				var dragDrop = _v20.a;
				var cmd = _v20.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nk: dragDrop}),
					cmd,
					_List_Nil);
			case 12:
				var draggedHighlight = msg.a;
				var zoneIdx = msg.b;
				var fromPos = $author$project$Api$Partner$PartnerProductHighlight$Shared$position(draggedHighlight);
				var toIdx = (_Utils_cmp(zoneIdx, fromPos) < 0) ? (zoneIdx + 1) : zoneIdx;
				return _Utils_Tuple3(
					model,
					A5(
						$author$project$Api$Partner$PartnerProductHighlight$update,
						apiClient,
						model.Jn,
						$author$project$Api$Partner$PartnerProductHighlight$Shared$id(draggedHighlight),
						_List_fromArray(
							[
								$author$project$Api$Partner$PartnerProductHighlight$Position(toIdx)
							]),
						$author$project$Components$Partner$ManagePartnerProductHighlights$PositionUpdated),
					_List_Nil);
			case 13:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						A3($author$project$Api$Partner$PartnerProductHighlight$list, apiClient, model.Jn, $author$project$Components$Partner$ManagePartnerProductHighlights$HighlightsFetched),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var highlights = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Tu: highlights}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Components$Partner$ManagePartnerProductLinks$Deleted = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductLinks$LinkPositionUpdated = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductLinks$LinksFetched = function (a) {
	return {$: 14, a: a};
};
var $author$project$Api$Partner$PartnerProductLink$Position = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Partner$PartnerProductLink$partnerProductLinksPath = function (productId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['partner_products', productId, 'links']),
		$author$project$Api$Data$partnerPath);
};
var $author$project$Api$Partner$PartnerProductLink$partnerProductLinkPath = F2(
	function (productId, id_) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id_]),
			$author$project$Api$Partner$PartnerProductLink$partnerProductLinksPath(productId));
	});
var $author$project$Api$Partner$PartnerProductLink$delete = F4(
	function (apiClient, productId, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Partner$PartnerProductLink$partnerProductLinkPath, productId, id)));
	});
var $author$project$Api$Partner$PartnerProductLink$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Components$Partner$ManagePartnerProductLinks$initLinkFields = {V3: 0, ac9: '', aea: '', aeb: '', aee: ''};
var $author$project$Api$Partner$PartnerProductLink$Shared$linkType = function (_v0) {
	var record = _v0;
	return record.V3;
};
var $author$project$Api$Partner$PartnerProductLink$Shared$title = function (_v0) {
	var record = _v0;
	return record.ac9;
};
var $author$project$Api$Partner$PartnerProductLink$Shared$utmCampaign = function (_v0) {
	var record = _v0;
	return record.aea;
};
var $author$project$Api$Partner$PartnerProductLink$Shared$utmContent = function (_v0) {
	var record = _v0;
	return record.aeb;
};
var $author$project$Api$Partner$PartnerProductLink$Shared$value = function (_v0) {
	var record = _v0;
	return record.aee;
};
var $author$project$Components$Partner$ManagePartnerProductLinks$initLinkFieldsForEdit = function (productLink) {
	return {
		V3: $author$project$Api$Partner$PartnerProductLink$Shared$linkType(productLink),
		ac9: $author$project$Api$Partner$PartnerProductLink$Shared$title(productLink),
		aea: A2(
			$elm$core$Maybe$withDefault,
			'',
			$author$project$Api$Partner$PartnerProductLink$Shared$utmCampaign(productLink)),
		aeb: A2(
			$elm$core$Maybe$withDefault,
			'',
			$author$project$Api$Partner$PartnerProductLink$Shared$utmContent(productLink)),
		aee: $author$project$Api$Partner$PartnerProductLink$Shared$value(productLink)
	};
};
var $author$project$Api$Common$Marketplace$Product$LinkType$default = 0;
var $author$project$Components$Partner$ManagePartnerProductLinks$linkFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var title = field.a;
				return _Utils_update(
					fields,
					{ac9: title});
			case 1:
				var value = field.a;
				return _Utils_update(
					fields,
					{aee: value});
			case 2:
				var linkType = field.a;
				return _Utils_update(
					fields,
					{
						V3: A2(
							$elm$core$Maybe$withDefault,
							$author$project$Api$Common$Marketplace$Product$LinkType$default,
							$author$project$Api$Common$Marketplace$Product$LinkType$fromString(linkType))
					});
			case 3:
				var campaign = field.a;
				return _Utils_update(
					fields,
					{aea: campaign});
			default:
				var content = field.a;
				return _Utils_update(
					fields,
					{aeb: content});
		}
	});
var $author$project$Components$Partner$ManagePartnerProductLinks$TitleValidation = 0;
var $author$project$Components$Partner$ManagePartnerProductLinks$ValueValidation = 1;
var $author$project$Components$Partner$ManagePartnerProductLinks$valueLabel = function (linkType) {
	switch (linkType) {
		case 0:
			return 'URL';
		case 1:
			return 'Email address';
		default:
			return 'Phone number';
	}
};
var $author$project$Components$Partner$ManagePartnerProductLinks$validateValue = function (fields) {
	if ($elm$core$String$isEmpty(fields.aee)) {
		return _List_fromArray(
			[
				_Utils_Tuple2(
				1,
				'Please enter a ' + ($author$project$Components$Partner$ManagePartnerProductLinks$valueLabel(fields.V3) + '.'))
			]);
	} else {
		var _v0 = fields.V3;
		switch (_v0) {
			case 0:
				return $author$project$Utils$Validate$isInvalidUrl(fields.aee) ? _List_fromArray(
					[
						_Utils_Tuple2(1, 'Please enter a valid URL.')
					]) : _List_Nil;
			case 1:
				return A2(
					$author$project$Utils$Validate$isInvalidEmail,
					{aeT: true},
					$elm$core$Maybe$Just(fields.aee)) ? _List_fromArray(
					[
						_Utils_Tuple2(1, 'Please enter a valid email address.')
					]) : _List_Nil;
			default:
				return A2($author$project$Utils$Validate$doesNotMatchRegex, fields.aee, '^\\d+$') ? _List_fromArray(
					[
						_Utils_Tuple2(1, 'Please enter a valid phone number.')
					]) : _List_Nil;
		}
	}
};
var $author$project$Components$Partner$ManagePartnerProductLinks$linkValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.ac9;
			},
			_Utils_Tuple2(0, 'Please enter a title.')),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Partner$ManagePartnerProductLinks$validateValue)
		]));
var $author$project$Api$Partner$PartnerProductLink$list = F3(
	function (apiClient, productId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Partner$PartnerProductLink$Shared$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Partner$PartnerProductLink$partnerProductLinksPath(productId)));
	});
var $author$project$Api$Partner$PartnerProductLink$Shared$position = function (_v0) {
	var record = _v0;
	return record.ZP;
};
var $author$project$Components$Partner$ManagePartnerProductLinks$Created = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Partner$PartnerProductLink$One$PartnerProductLink = 0;
var $author$project$Api$Partner$PartnerProductLink$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Common$Marketplace$Product$LinkType$toString = function (linkType) {
	switch (linkType) {
		case 0:
			return 'url';
		case 1:
			return 'email';
		default:
			return 'phone';
	}
};
var $author$project$Api$Partner$PartnerProductLink$create = F4(
	function (apiClient, productId, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'partner_product_link',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'title',
								$elm$json$Json$Encode$string(params.ac9)),
								_Utils_Tuple2(
								'value',
								$elm$json$Json$Encode$string(params.aee)),
								_Utils_Tuple2(
								'link_type',
								$elm$json$Json$Encode$string(
									$author$project$Api$Common$Marketplace$Product$LinkType$toString(params.V3))),
								_Utils_Tuple2(
								'utm_campaign',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.aea)),
								_Utils_Tuple2(
								'utm_content',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.aeb))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$PartnerProductLink$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Partner$PartnerProductLink$partnerProductLinksPath(productId))));
	});
var $author$project$Components$Partner$ManagePartnerProductLinks$createLink = F3(
	function (apiClient, productId, formFields) {
		var _v0 = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var title = _v0.ac9;
		var linkType = _v0.V3;
		var value = _v0.aee;
		var utmCampaign = _v0.aea;
		var utmContent = _v0.aeb;
		return A4(
			$author$project$Api$Partner$PartnerProductLink$create,
			apiClient,
			productId,
			{
				V3: linkType,
				ac9: title,
				aea: $author$project$Utils$Maybe$fromString(utmCampaign),
				aeb: $author$project$Utils$Maybe$fromString(utmContent),
				aee: value
			},
			$author$project$Components$Partner$ManagePartnerProductLinks$Created);
	});
var $author$project$Api$Partner$PartnerProductLink$LinkTypeField = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Partner$PartnerProductLink$Title = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductLinks$Updated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Partner$PartnerProductLink$UtmCampaign = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Partner$PartnerProductLink$UtmContent = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Partner$PartnerProductLink$Value = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Partner$PartnerProductLink$encodePermittedFields = function (permittedFields) {
	var encodedFields = A3(
		$elm$core$List$foldl,
		F2(
			function (field, acc) {
				switch (field.$) {
					case 0:
						var title = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'title',
								$elm$json$Json$Encode$string(title)),
							acc);
					case 1:
						var value = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'value',
								$elm$json$Json$Encode$string(value)),
							acc);
					case 2:
						var linkType = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'link_type',
								$elm$json$Json$Encode$string(
									$author$project$Api$Common$Marketplace$Product$LinkType$toString(linkType))),
							acc);
					case 3:
						var utmCampaign = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'utm_campaign',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, utmCampaign)),
							acc);
					case 4:
						var utmContent = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'utm_content',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, utmContent)),
							acc);
					default:
						var position = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'position',
								$elm$json$Json$Encode$int(position)),
							acc);
				}
			}),
		_List_Nil,
		permittedFields);
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'partner_product_link',
				$elm$json$Json$Encode$object(encodedFields))
			]));
};
var $author$project$Api$Partner$PartnerProductLink$update = F5(
	function (apiClient, productId, id, permittedFields, toMsg) {
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Partner$PartnerProductLink$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Partner$PartnerProductLink$encodePermittedFields(permittedFields),
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Partner$PartnerProductLink$partnerProductLinkPath, productId, id))));
	});
var $author$project$Components$Partner$ManagePartnerProductLinks$updateLink = F4(
	function (apiClient, productId, id, formFields) {
		var _v0 = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var title = _v0.ac9;
		var linkType = _v0.V3;
		var value = _v0.aee;
		var utmCampaign = _v0.aea;
		var utmContent = _v0.aeb;
		return A5(
			$author$project$Api$Partner$PartnerProductLink$update,
			apiClient,
			productId,
			id,
			_List_fromArray(
				[
					$author$project$Api$Partner$PartnerProductLink$Title(title),
					$author$project$Api$Partner$PartnerProductLink$Value(value),
					$author$project$Api$Partner$PartnerProductLink$LinkTypeField(linkType),
					$author$project$Api$Partner$PartnerProductLink$UtmCampaign(
					$author$project$Utils$Maybe$fromString(utmCampaign)),
					$author$project$Api$Partner$PartnerProductLink$UtmContent(
					$author$project$Utils$Maybe$fromString(utmContent))
				]),
			$author$project$Components$Partner$ManagePartnerProductLinks$Updated);
	});
var $author$project$Components$Partner$ManagePartnerProductLinks$save = F4(
	function (apiClient, productId, id, formFields) {
		if (!id.$) {
			var id_ = id.a;
			return A4($author$project$Components$Partner$ManagePartnerProductLinks$updateLink, apiClient, productId, id_, formFields);
		} else {
			return A3($author$project$Components$Partner$ManagePartnerProductLinks$createLink, apiClient, productId, formFields);
		}
	});
var $author$project$Components$Partner$ManagePartnerProductLinks$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							U: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init($author$project$Components$Partner$ManagePartnerProductLinks$initLinkFields),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var productLink = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							U: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(productLink),
									$author$project$Utils$Form$init(
										$author$project$Components$Partner$ManagePartnerProductLinks$initLinkFieldsForEdit(productLink)),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{U: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var field = msg.a;
				var _v2 = model.U;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var id = _v3.a;
					var form = _v3.b;
					var request = _v3.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Partner$ManagePartnerProductLinks$linkFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								U: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, request))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				var _v4 = model.U;
				if (!_v4.$) {
					var _v5 = _v4.a;
					var productLink = _v5.a;
					var form = _v5.b;
					var _v6 = A2($author$project$Utils$Form$validate, $author$project$Components$Partner$ManagePartnerProductLinks$linkValidator, form);
					if (!_v6.$) {
						var _v7 = _v6.a;
						var validatedForm = _v7.a;
						var validFormFields = _v7.b;
						var id = A2($elm$core$Maybe$map, $author$project$Api$Partner$PartnerProductLink$Shared$id, productLink);
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									U: $elm$core$Maybe$Just(
										_Utils_Tuple3(productLink, validatedForm, $author$project$Api$Data$Loading))
								}),
							A4($author$project$Components$Partner$ManagePartnerProductLinks$save, apiClient, model.Jn, id, validFormFields),
							_List_Nil);
					} else {
						var validatedForm = _v6.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									U: $elm$core$Maybe$Just(
										_Utils_Tuple3(productLink, validatedForm, $author$project$Api$Data$NotAsked))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				var response = msg.a;
				var _v8 = model.U;
				if (!_v8.$) {
					var _v9 = _v8.a;
					var productLink = _v9.a;
					var form = _v9.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{U: $elm$core$Maybe$Nothing}),
							A3($author$project$Api$Partner$PartnerProductLink$list, apiClient, model.Jn, $author$project$Components$Partner$ManagePartnerProductLinks$LinksFetched),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Product link created successfully!')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									U: $elm$core$Maybe$Just(
										_Utils_Tuple3(productLink, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var response = msg.a;
				var _v11 = model.U;
				if (!_v11.$) {
					var _v12 = _v11.a;
					var productLink = _v12.a;
					var form = _v12.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{U: $elm$core$Maybe$Nothing}),
							A3($author$project$Api$Partner$PartnerProductLink$list, apiClient, model.Jn, $author$project$Components$Partner$ManagePartnerProductLinks$LinksFetched),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Product link updated successfully!')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									U: $elm$core$Maybe$Just(
										_Utils_Tuple3(productLink, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var productLink = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							cx: $elm$core$Maybe$Just(
								_Utils_Tuple2(productLink, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 8:
				var confirmed = msg.a;
				var _v14 = model.cx;
				if (!_v14.$) {
					var _v15 = _v14.a;
					var productLink = _v15.a;
					return confirmed ? _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cx: $elm$core$Maybe$Just(
									_Utils_Tuple2(productLink, $author$project$Api$Data$Loading))
							}),
						A4(
							$author$project$Api$Partner$PartnerProductLink$delete,
							apiClient,
							model.Jn,
							$author$project$Api$Partner$PartnerProductLink$Shared$id(productLink),
							$author$project$Components$Partner$ManagePartnerProductLinks$Deleted),
						_List_Nil) : _Utils_Tuple3(
						_Utils_update(
							model,
							{cx: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 10:
				var url = msg.a;
				return _Utils_Tuple3(
					model,
					$author$project$Ports$Clipboard$copy(url),
					_List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 3, 'Copied to clipboard')
						]));
			case 11:
				var subMsg = msg.a;
				var _v16 = A2($author$project$Components$DragDrop$update, subMsg, model.nk);
				var dragDrop = _v16.a;
				var cmd = _v16.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nk: dragDrop}),
					cmd,
					_List_Nil);
			case 12:
				var draggedLink = msg.a;
				var zoneIdx = msg.b;
				var fromPos = $author$project$Api$Partner$PartnerProductLink$Shared$position(draggedLink);
				var toIdx = (_Utils_cmp(zoneIdx, fromPos) < 0) ? (zoneIdx + 1) : zoneIdx;
				return _Utils_Tuple3(
					model,
					A5(
						$author$project$Api$Partner$PartnerProductLink$update,
						apiClient,
						model.Jn,
						$author$project$Api$Partner$PartnerProductLink$Shared$id(draggedLink),
						_List_fromArray(
							[
								$author$project$Api$Partner$PartnerProductLink$Position(toIdx)
							]),
						$author$project$Components$Partner$ManagePartnerProductLinks$LinkPositionUpdated),
					_List_Nil);
			case 13:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						A3($author$project$Api$Partner$PartnerProductLink$list, apiClient, model.Jn, $author$project$Components$Partner$ManagePartnerProductLinks$LinksFetched),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 9:
				var response = msg.a;
				var _v18 = model.cx;
				if (!_v18.$) {
					var _v19 = _v18.a;
					var productLink = _v19.a;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{cx: $elm$core$Maybe$Nothing}),
							A3($author$project$Api$Partner$PartnerProductLink$list, apiClient, model.Jn, $author$project$Components$Partner$ManagePartnerProductLinks$LinksFetched),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Product link deleted successfully!')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									cx: $elm$core$Maybe$Just(
										_Utils_Tuple2(productLink, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var links = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{V5: links}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Components$Partner$ManagePartnerProductQuotes$AuthorImage = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Partner$ManagePartnerProductQuotes$Deleted = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductQuotes$FormUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductQuotes$None = 0;
var $author$project$Components$Partner$ManagePartnerProductQuotes$QuoteCreated = 1;
var $author$project$Components$Partner$ManagePartnerProductQuotes$QuoteDeleted = 3;
var $author$project$Components$Partner$ManagePartnerProductQuotes$QuoteUpdated = 2;
var $author$project$Api$Partner$PartnerProductQuote$partnerProductQuotesPath = function (productId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['partner_products', productId, 'quotes']),
		$author$project$Api$Data$partnerPath);
};
var $author$project$Api$Partner$PartnerProductQuote$partnerProductQuotePath = F2(
	function (productId, id_) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id_]),
			$author$project$Api$Partner$PartnerProductQuote$partnerProductQuotesPath(productId));
	});
var $author$project$Api$Partner$PartnerProductQuote$delete = F4(
	function (apiClient, productId, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Partner$PartnerProductQuote$partnerProductQuotePath, productId, id)));
	});
var $author$project$Api$Partner$PartnerProductQuote$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Components$Partner$ManagePartnerProductQuotes$initQuoteFields = {Mb: '', ae1: $elm$core$Maybe$Nothing, rp: 0, Md: '', rO: $elm$core$Maybe$Nothing, ac3: ''};
var $author$project$Api$Partner$PartnerProductQuote$Shared$author = function (_v0) {
	var record = _v0;
	return record.Mb;
};
var $author$project$Api$Partner$PartnerProductQuote$Shared$authorImageUrl = function (_v0) {
	var record = _v0;
	return record.Mc;
};
var $author$project$Api$Partner$PartnerProductQuote$Shared$authorTitle = function (_v0) {
	var record = _v0;
	return record.Md;
};
var $author$project$Api$Partner$PartnerProductQuote$Shared$text = function (_v0) {
	var record = _v0;
	return record.ac3;
};
var $author$project$Components$Partner$ManagePartnerProductQuotes$initQuoteFieldsForEdit = function (productQuote) {
	return {
		Mb: $author$project$Api$Partner$PartnerProductQuote$Shared$author(productQuote),
		ae1: $elm$core$Maybe$Nothing,
		rp: 0,
		Md: $author$project$Api$Partner$PartnerProductQuote$Shared$authorTitle(productQuote),
		rO: $author$project$Api$Partner$PartnerProductQuote$Shared$authorImageUrl(productQuote),
		ac3: $author$project$Api$Partner$PartnerProductQuote$Shared$text(productQuote)
	};
};
var $author$project$Components$Partner$ManagePartnerProductQuotes$quoteFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var text = field.a;
				return _Utils_update(
					fields,
					{ac3: text});
			case 1:
				var author = field.a;
				return _Utils_update(
					fields,
					{Mb: author});
			case 2:
				var authorTitle = field.a;
				return _Utils_update(
					fields,
					{Md: authorTitle});
			default:
				var imageSize = field.a;
				var imageUrl = field.b;
				return _Utils_update(
					fields,
					{
						ae1: $elm$core$Maybe$Just(imageUrl),
						rp: imageSize,
						rO: $elm$core$Maybe$Just(imageUrl)
					});
		}
	});
var $author$project$Components$Partner$ManagePartnerProductQuotes$AuthorImageValidation = 3;
var $author$project$Components$Partner$ManagePartnerProductQuotes$AuthorTitleValidation = 2;
var $author$project$Components$Partner$ManagePartnerProductQuotes$AuthorValidation = 1;
var $author$project$Components$Partner$ManagePartnerProductQuotes$TextValidation = 0;
var $author$project$Components$Partner$ManagePartnerProductQuotes$maxLogoBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
var $author$project$Components$Partner$ManagePartnerProductQuotes$quoteValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.ac3;
			},
			_Utils_Tuple2(0, 'Please enter a text.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.Mb;
			},
			_Utils_Tuple2(1, 'Please enter an author.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.Md;
			},
			_Utils_Tuple2(2, 'Please enter an author title.')),
			A3(
			$author$project$Utils$Validate$ifIntGreaterThan,
			function ($) {
				return $.rp;
			},
			$author$project$Components$Partner$ManagePartnerProductQuotes$maxLogoBytesSize,
			_Utils_Tuple2(3, 'That image is too large! Our maximum image size is 5 mb, please choose a smaller image.'))
		]));
var $author$project$Components$Partner$ManagePartnerProductQuotes$Created = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Partner$PartnerProductQuote$One$PartnerProductQuote = 0;
var $author$project$Api$Partner$PartnerProductQuote$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Partner$PartnerProductQuote$partnerProductQuoteParams = function (params) {
	var authorImageUrl = function () {
		var _v0 = params.Mc;
		if (!_v0.$) {
			var base64 = _v0.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'author_image',
					$elm$json$Json$Encode$string(base64))
				]);
		} else {
			return _List_Nil;
		}
	}();
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'partner_product_quote',
				$elm$json$Json$Encode$object(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'text',
							$elm$json$Json$Encode$string(params.ac3)),
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'author',
								$elm$json$Json$Encode$string(params.Mb)),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'author_title',
									$elm$json$Json$Encode$string(params.Md)),
								authorImageUrl)))))
			]));
};
var $author$project$Api$Partner$PartnerProductQuote$create = F4(
	function (apiClient, productId, params, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$PartnerProductQuote$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Partner$PartnerProductQuote$partnerProductQuoteParams(params),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Partner$PartnerProductQuote$partnerProductQuotesPath(productId))));
	});
var $author$project$Components$Partner$ManagePartnerProductQuotes$createProductQuote = F3(
	function (apiClient, productId, formFields) {
		var _v0 = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var text = _v0.ac3;
		var author = _v0.Mb;
		var authorTitle = _v0.Md;
		var authorImage = _v0.ae1;
		return A4(
			$author$project$Api$Partner$PartnerProductQuote$create,
			apiClient,
			productId,
			{Mb: author, Mc: authorImage, Md: authorTitle, ac3: text},
			$author$project$Components$Partner$ManagePartnerProductQuotes$Created);
	});
var $author$project$Components$Partner$ManagePartnerProductQuotes$Updated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Partner$PartnerProductQuote$update = F5(
	function (apiClient, productId, id, params, toMsg) {
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Partner$PartnerProductQuote$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Partner$PartnerProductQuote$partnerProductQuoteParams(params),
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Partner$PartnerProductQuote$partnerProductQuotePath, productId, id))));
	});
var $author$project$Components$Partner$ManagePartnerProductQuotes$updateProductQuote = F4(
	function (apiClient, productId, id, formFields) {
		var _v0 = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var text = _v0.ac3;
		var author = _v0.Mb;
		var authorTitle = _v0.Md;
		var authorImage = _v0.ae1;
		return A5(
			$author$project$Api$Partner$PartnerProductQuote$update,
			apiClient,
			productId,
			id,
			{Mb: author, Mc: authorImage, Md: authorTitle, ac3: text},
			$author$project$Components$Partner$ManagePartnerProductQuotes$Updated);
	});
var $author$project$Components$Partner$ManagePartnerProductQuotes$save = F4(
	function (apiClient, productId, id, formFields) {
		if (!id.$) {
			var id_ = id.a;
			return A4($author$project$Components$Partner$ManagePartnerProductQuotes$updateProductQuote, apiClient, productId, id_, formFields);
		} else {
			return A3($author$project$Components$Partner$ManagePartnerProductQuotes$createProductQuote, apiClient, productId, formFields);
		}
	});
var $author$project$Components$Partner$ManagePartnerProductQuotes$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							V: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init($author$project$Components$Partner$ManagePartnerProductQuotes$initQuoteFields),
									$author$project$Api$Data$NotAsked))
						}),
					aR: _List_Nil
				};
			case 1:
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{V: $elm$core$Maybe$Nothing}),
					aR: _List_Nil
				};
			case 3:
				var logos = msg.a;
				var cmd = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						function (_v2) {
							var task = _v2.a;
							var size = _v2.b;
							return A2(
								$elm$core$Task$perform,
								A2(
									$elm$core$Basics$composeL,
									$author$project$Components$Partner$ManagePartnerProductQuotes$FormUpdated,
									$author$project$Components$Partner$ManagePartnerProductQuotes$AuthorImage(size)),
								task);
						},
						A2(
							$elm$core$Maybe$map,
							function (logo) {
								return _Utils_Tuple2(
									$elm$file$File$toUrl(logo),
									$elm$file$File$size(logo));
							},
							$elm$core$List$head(logos))));
				return {GZ: cmd, agZ: 0, aiO: model, aR: _List_Nil};
			case 2:
				var field = msg.a;
				var _v3 = model.V;
				if (!_v3.$) {
					var _v4 = _v3.a;
					var id = _v4.a;
					var form = _v4.b;
					var request = _v4.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Partner$ManagePartnerProductQuotes$quoteFieldsUpdate, field, form);
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{
								V: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, request))
							}),
						aR: _List_Nil
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
			case 4:
				var productQuote = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							V: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(productQuote),
									$author$project$Utils$Form$init(
										$author$project$Components$Partner$ManagePartnerProductQuotes$initQuoteFieldsForEdit(productQuote)),
									$author$project$Api$Data$NotAsked))
						}),
					aR: _List_Nil
				};
			case 5:
				var _v5 = model.V;
				if (!_v5.$) {
					var _v6 = _v5.a;
					var item = _v6.a;
					var form = _v6.b;
					var _v7 = A2($author$project$Utils$Form$validate, $author$project$Components$Partner$ManagePartnerProductQuotes$quoteValidator, form);
					if (!_v7.$) {
						var _v8 = _v7.a;
						var validatedForm = _v8.a;
						var validFormFields = _v8.b;
						var id = A2($elm$core$Maybe$map, $author$project$Api$Partner$PartnerProductQuote$Shared$id, item);
						return {
							GZ: A4($author$project$Components$Partner$ManagePartnerProductQuotes$save, apiClient, model.Jn, id, validFormFields),
							agZ: 0,
							aiO: _Utils_update(
								model,
								{
									V: $elm$core$Maybe$Just(
										_Utils_Tuple3(item, validatedForm, $author$project$Api$Data$Loading))
								}),
							aR: _List_Nil
						};
					} else {
						var validatedForm = _v7.a;
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 0,
							aiO: _Utils_update(
								model,
								{
									V: $elm$core$Maybe$Just(
										_Utils_Tuple3(item, validatedForm, $author$project$Api$Data$NotAsked))
								}),
							aR: _List_Nil
						};
					}
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
			case 6:
				var response = msg.a;
				var _v9 = model.V;
				if (!_v9.$) {
					var _v10 = _v9.a;
					var productQuote = _v10.a;
					var form = _v10.b;
					if (response.$ === 3) {
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 1,
							aiO: _Utils_update(
								model,
								{V: $elm$core$Maybe$Nothing}),
							aR: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Product quote created successfully!')
								])
						};
					} else {
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 0,
							aiO: _Utils_update(
								model,
								{
									V: $elm$core$Maybe$Just(
										_Utils_Tuple3(productQuote, form, response))
								}),
							aR: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
			case 7:
				var response = msg.a;
				var _v12 = model.V;
				if (!_v12.$) {
					var _v13 = _v12.a;
					var item = _v13.a;
					var form = _v13.b;
					if (response.$ === 3) {
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 2,
							aiO: _Utils_update(
								model,
								{V: $elm$core$Maybe$Nothing}),
							aR: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Product quote updated successfully!')
								])
						};
					} else {
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 0,
							aiO: _Utils_update(
								model,
								{
									V: $elm$core$Maybe$Just(
										_Utils_Tuple3(item, form, response))
								}),
							aR: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
			case 8:
				var productQuote = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							cB: $elm$core$Maybe$Just(
								_Utils_Tuple2(productQuote, $author$project$Api$Data$NotAsked))
						}),
					aR: _List_Nil
				};
			case 9:
				var confirmed = msg.a;
				var _v15 = model.cB;
				if (!_v15.$) {
					var _v16 = _v15.a;
					var productQuote = _v16.a;
					return confirmed ? {
						GZ: A4(
							$author$project$Api$Partner$PartnerProductQuote$delete,
							apiClient,
							model.Jn,
							$author$project$Api$Partner$PartnerProductQuote$Shared$id(productQuote),
							$author$project$Components$Partner$ManagePartnerProductQuotes$Deleted),
						agZ: 0,
						aiO: _Utils_update(
							model,
							{
								cB: $elm$core$Maybe$Just(
									_Utils_Tuple2(productQuote, $author$project$Api$Data$Loading))
							}),
						aR: _List_Nil
					} : {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{cB: $elm$core$Maybe$Nothing}),
						aR: _List_Nil
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
			default:
				var response = msg.a;
				var _v17 = model.cB;
				if (!_v17.$) {
					var _v18 = _v17.a;
					var productQuote = _v18.a;
					if (response.$ === 3) {
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 3,
							aiO: _Utils_update(
								model,
								{cB: $elm$core$Maybe$Nothing}),
							aR: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Product quote deleted successfully!')
								])
						};
					} else {
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 0,
							aiO: _Utils_update(
								model,
								{
									cB: $elm$core$Maybe$Just(
										_Utils_Tuple2(productQuote, response))
								}),
							aR: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
		}
	});
var $author$project$Api$Partner$PartnerProduct$One$utmCampaign = function (_v0) {
	var record = _v0.b;
	return record.aea;
};
var $author$project$Api$Partner$PartnerProduct$One$utmContent = function (_v0) {
	var record = _v0.b;
	return record.aeb;
};
var $author$project$Components$Partner$ExternalCtaForm$validate = function (_v0) {
	var model = _v0;
	var errors = $elm$core$String$isEmpty(model.ahi.adY) ? _List_fromArray(
		['Please enter a CTA URL.']) : ($author$project$Utils$Validate$isInvalidUrlStricter(model.ahi.adY) ? _List_fromArray(
		['Please enter a valid URL (e.g. https://partner.example.com).']) : _List_Nil);
	return $elm$core$List$isEmpty(errors) ? $elm$core$Result$Ok(model.ahi) : $elm$core$Result$Err(
		_Utils_update(
			model,
			{qW: errors}));
};
var $author$project$Pages$Partner$Products$Id_String$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 7:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							C: $elm$core$Maybe$Just(
								$author$project$Utils$Form$init(
									$author$project$Pages$Partner$Products$Id_String$Icon($elm$core$Maybe$Nothing)))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 8:
				var icons = msg.a;
				var cmd = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						function (_v1) {
							var task = _v1.a;
							var size = _v1.b;
							return A2(
								$elm$core$Task$perform,
								A2(
									$elm$core$Basics$composeL,
									A2(
										$elm$core$Basics$composeL,
										A2($elm$core$Basics$composeL, $author$project$Pages$Partner$Products$Id_String$Edited, $author$project$Pages$Partner$Products$Id_String$Icon),
										$elm$core$Maybe$Just),
									$elm$core$Tuple$pair(size)),
								task);
						},
						A2(
							$elm$core$Maybe$map,
							function (icon) {
								return _Utils_Tuple2(
									$elm$file$File$toUrl(icon),
									$elm$file$File$size(icon));
							},
							$elm$core$List$head(icons))));
				return _Utils_Tuple3(model, cmd, _List_Nil);
			case 0:
				var field = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							C: $elm$core$Maybe$Just(
								$author$project$Utils$Form$init(field))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{C: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var form = msg.a;
				return A2($author$project$Pages$Partner$Products$Id_String$submit, model, form);
			case 3:
				var field = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							C: $elm$core$Maybe$Just(
								$author$project$Utils$Form$init(field))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 18:
				var ctaMsg = msg.a;
				var ctaResult = A3($author$project$Components$Marketplace$Product$CallToAction$update, model.Gv, ctaMsg, model.br);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{br: ctaResult.aiO}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Products$Id_String$CallToActionMsg, ctaResult.GZ),
					ctaResult.aR);
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					var product = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								br: A2(
									$author$project$Components$Marketplace$Product$CallToAction$setProduct,
									$author$project$Pages$Partner$Products$Id_String$toCallToActionProduct(product),
									model.br),
								_s: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{_s: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 6:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{C: $elm$core$Maybe$Nothing, V8: false, _s: response}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Product updated successfully!'),
								$author$project$OutMsg$RefreshPartner
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{V8: false}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 4:
				var showAlert = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var partner = response.a;
					var _v5 = A3($author$project$Components$Partner$ManagePartnerProductQuotes$init, model.Jn, partner, model.sF);
					var managePartnerProductQuotes = _v5.a;
					var managePartnerProductQuotesCmd = _v5.b;
					var _v6 = A3($author$project$Components$Partner$ManagePartnerProductLinks$init, model.Jn, partner, model.sF);
					var managePartnerProductLinks = _v6.a;
					var managePartnerProductLinksCmd = _v6.b;
					var _v7 = A3($author$project$Components$Partner$ManagePartnerProductHighlights$init, model.Jn, partner, model.sF);
					var managePartnerProductHighlights = _v7.a;
					var managePartnerProductHighlightsCmd = _v7.b;
					var _v8 = A3($author$project$Components$Partner$ManagePartnerProductDataFlows$init, model.Jn, partner, model.sF);
					var managePartnerProductDataFlows = _v8.a;
					var managePartnerProductDataFlowsCmd = _v8.b;
					var _v9 = A3($author$project$Components$Partner$ManagePartnerProductCategories$init, model.Gv, model.Jn, partner);
					var manageCategories = _v9.a;
					var manageCategoriesCmd = _v9.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								mH: $author$project$Components$Carousel$reset(model.mH),
								V8: false,
								gN: manageCategories,
								gO: managePartnerProductDataFlows,
								gP: managePartnerProductHighlights,
								gQ: managePartnerProductLinks,
								gS: managePartnerProductQuotes,
								YN: partner
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Products$Id_String$ManagePartnerProductHighlightsMsg, managePartnerProductHighlightsCmd),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Products$Id_String$ManagePartnerProductLinksMsg, managePartnerProductLinksCmd),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Products$Id_String$ManagePartnerProductDataFlowsMsg, managePartnerProductDataFlowsCmd),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Products$Id_String$ManagePartnerProductCategoriesMsg, manageCategoriesCmd),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Products$Id_String$ManagePartnerProductQuotesMsg, managePartnerProductQuotesCmd)
								])),
						A2(
							$elm$core$List$cons,
							$author$project$OutMsg$RefreshPartner,
							showAlert ? _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Partner updated successfully!')
								]) : _List_Nil));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{V8: false}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 9:
				var subMsg = msg.a;
				return A2(
					$author$project$Utils$Tuple3$fromTuple2,
					_List_Nil,
					A2(
						$elm$core$Tuple$mapFirst,
						function (carousel) {
							return _Utils_update(
								model,
								{mH: carousel});
						},
						A2($author$project$Components$Carousel$update, subMsg, model.mH)));
			case 10:
				var images = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{so: model.so + 1, V8: true}),
					A2(
						$elm$core$Task$perform,
						function (urls) {
							var existingImages = A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									$author$project$Api$Partner$PartnerProductOverview$Shared$images,
									$author$project$Api$Partner$Partner$One$productOverview(model.YN)));
							return $author$project$Pages$Partner$Products$Id_String$Saved(
								$author$project$Utils$Form$init(
									A2($author$project$Pages$Partner$Products$Id_String$ProductOverviewImages, existingImages, urls)));
						},
						$elm$core$Task$sequence(
							A2($elm$core$List$map, $elm$file$File$toUrl, images))),
					_List_Nil);
			case 11:
				var imageId = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ga: $elm$core$Maybe$Just(imageId)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 12:
				var confirmed = msg.a;
				var _v10 = _Utils_Tuple2(confirmed, model.ga);
				if (_v10.a && (!_v10.b.$)) {
					var imageId = _v10.b.a;
					var remainingImages = A2(
						$elm$core$List$filter,
						function (img) {
							return !_Utils_eq(
								$author$project$Api$Partner$ProductImage$Shared$id(img),
								imageId);
						},
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								$author$project$Api$Partner$PartnerProductOverview$Shared$images,
								$author$project$Api$Partner$Partner$One$productOverview(model.YN))));
					return A2(
						$author$project$Pages$Partner$Products$Id_String$submit,
						_Utils_update(
							model,
							{ga: $elm$core$Maybe$Nothing}),
						$author$project$Utils$Form$init(
							A2($author$project$Pages$Partner$Products$Id_String$ProductOverviewImages, remainingImages, _List_Nil)));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ga: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 13:
				var subMsg = msg.a;
				var _v11 = A3($author$project$Components$Partner$ManagePartnerProductLinks$update, model.Gv, subMsg, model.gQ);
				var newModel = _v11.a;
				var cmd = _v11.b;
				var outMsgs = _v11.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{gQ: newModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Products$Id_String$ManagePartnerProductLinksMsg, cmd),
					outMsgs);
			case 14:
				var subMsg = msg.a;
				var _v12 = A3($author$project$Components$Partner$ManagePartnerProductHighlights$update, model.Gv, subMsg, model.gP);
				var newModel = _v12.a;
				var cmd = _v12.b;
				var outMsgs = _v12.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{gP: newModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Products$Id_String$ManagePartnerProductHighlightsMsg, cmd),
					outMsgs);
			case 15:
				var subMsg = msg.a;
				var _v13 = A3($author$project$Components$Partner$ManagePartnerProductDataFlows$update, model.Gv, subMsg, model.gO);
				var newModel = _v13.a;
				var cmd = _v13.b;
				var outMsgs = _v13.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{gO: newModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Products$Id_String$ManagePartnerProductDataFlowsMsg, cmd),
					outMsgs);
			case 16:
				var subMsg = msg.a;
				var result = A3($author$project$Components$Partner$ManagePartnerProductCategories$update, model.Gv, subMsg, model.gN);
				var extraCmd = function () {
					var _v14 = result.agZ;
					switch (_v14) {
						case 0:
							return $elm$core$Platform$Cmd$none;
						case 1:
							return A2(
								$author$project$Api$Partner$Partner$retrieve,
								model.Gv,
								$author$project$Pages$Partner$Products$Id_String$GotPartnerUpdated(false));
						case 2:
							return A2(
								$author$project$Api$Partner$Partner$retrieve,
								model.Gv,
								$author$project$Pages$Partner$Products$Id_String$GotPartnerUpdated(false));
						default:
							return A2(
								$author$project$Api$Partner$Partner$retrieve,
								model.Gv,
								$author$project$Pages$Partner$Products$Id_String$GotPartnerUpdated(false));
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{gN: result.aiO}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Products$Id_String$ManagePartnerProductCategoriesMsg, result.GZ),
								extraCmd
							])),
					result.aR);
			case 17:
				var subMsg = msg.a;
				var result = A3($author$project$Components$Partner$ManagePartnerProductQuotes$update, model.Gv, subMsg, model.gS);
				var extraCmd = function () {
					var _v15 = result.agZ;
					switch (_v15) {
						case 0:
							return $elm$core$Platform$Cmd$none;
						case 1:
							return A2(
								$author$project$Api$Partner$Partner$retrieve,
								model.Gv,
								$author$project$Pages$Partner$Products$Id_String$GotPartnerUpdated(false));
						case 2:
							return A2(
								$author$project$Api$Partner$Partner$retrieve,
								model.Gv,
								$author$project$Pages$Partner$Products$Id_String$GotPartnerUpdated(false));
						default:
							return A2(
								$author$project$Api$Partner$Partner$retrieve,
								model.Gv,
								$author$project$Pages$Partner$Products$Id_String$GotPartnerUpdated(false));
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{gS: result.aiO}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Products$Id_String$ManagePartnerProductQuotesMsg, result.GZ),
								extraCmd
							])),
					result.aR);
			case 19:
				var _v16 = $author$project$Api$Data$toMaybe(model._s);
				if (!_v16.$) {
					var product = _v16.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								dc: $elm$core$Maybe$Just(
									$author$project$Components$Partner$ExternalCtaForm$init(
										{
											adY: A2(
												$elm$core$Maybe$withDefault,
												'',
												$author$project$Api$Partner$PartnerProduct$One$ctaUrl(product)),
											aea: A2(
												$elm$core$Maybe$withDefault,
												'',
												$author$project$Api$Partner$PartnerProduct$One$utmCampaign(product)),
											aeb: A2(
												$elm$core$Maybe$withDefault,
												'',
												$author$project$Api$Partner$PartnerProduct$One$utmContent(product))
										}))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 20:
				var subMsg = msg.a;
				var _v17 = model.dc;
				if (!_v17.$) {
					var ctaForm = _v17.a;
					var _v18 = A2($author$project$Components$Partner$ExternalCtaForm$update, subMsg, ctaForm);
					var newCtaForm = _v18.a;
					var cmd = _v18.b;
					var outMsgs = _v18.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								dc: $elm$core$Maybe$Just(newCtaForm)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Products$Id_String$ExternalCtaFormMsg, cmd),
						outMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 21:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dc: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 22:
				var _v19 = _Utils_Tuple2(
					model.dc,
					$author$project$Api$Data$toMaybe(model._s));
				if ((!_v19.a.$) && (!_v19.b.$)) {
					var ctaForm = _v19.a.a;
					var product = _v19.b.a;
					var _v20 = $author$project$Components$Partner$ExternalCtaForm$validate(ctaForm);
					if (_v20.$ === 1) {
						var invalidCtaForm = _v20.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									dc: $elm$core$Maybe$Just(invalidCtaForm)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						var ctaFields = _v20.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{V8: true}),
							A4(
								$author$project$Api$Partner$PartnerProduct$update,
								model.Gv,
								$author$project$Api$Partner$PartnerProduct$One$id(product),
								_List_fromArray(
									[
										$author$project$Api$Partner$PartnerProduct$CtaUrl(
										$author$project$Utils$Maybe$fromString(ctaFields.adY)),
										$author$project$Api$Partner$PartnerProduct$UtmCampaign(
										$author$project$Utils$Maybe$fromString(ctaFields.aea)),
										$author$project$Api$Partner$PartnerProduct$UtmContent(
										$author$project$Utils$Maybe$fromString(ctaFields.aeb))
									]),
								$author$project$Pages$Partner$Products$Id_String$GotExternalCtaSaved),
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 23:
				var response = msg.a;
				if (response.$ === 3) {
					var product = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								br: A2(
									$author$project$Components$Marketplace$Product$CallToAction$setProduct,
									$author$project$Pages$Partner$Products$Id_String$toCallToActionProduct(product),
									model.br),
								dc: $elm$core$Maybe$Nothing,
								V8: false,
								_s: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Product updated successfully!'),
								$author$project$OutMsg$RefreshPartner
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{V8: false}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 24:
				var _v22 = $author$project$Api$Data$toMaybe(model._s);
				if (!_v22.$) {
					var product = _v22.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								jN: $author$project$Components$Partner$GenerateListingModal$open(
									{Ij: model.Ij})
							}),
						A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Pages$Partner$Products$Id_String$GenerateListingModalMsg,
							A2(
								$author$project$Components$Partner$GenerateListingModal$loadDefaults,
								model.Gv,
								{
									Ij: model.Ij,
									oS: $author$project$Api$Partner$PartnerProduct$One$id(product)
								})),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var subMsg = msg.a;
				var _v23 = $author$project$Api$Data$toMaybe(model._s);
				if (!_v23.$) {
					var product = _v23.a;
					var refreshCmds = $author$project$Components$Partner$GenerateListingModal$isSaveSuccess(subMsg) ? _List_fromArray(
						[
							A2($author$project$Pages$Partner$Products$Id_String$retrieveProduct, model.Gv, model.Jn),
							A2(
							$author$project$Api$Partner$Partner$retrieve,
							model.Gv,
							$author$project$Pages$Partner$Products$Id_String$GotPartnerUpdated(false))
						]) : _List_Nil;
					var _v24 = A4(
						$author$project$Components$Partner$GenerateListingModal$update,
						model.Gv,
						{
							oS: $author$project$Api$Partner$PartnerProduct$One$id(product)
						},
						subMsg,
						model.jN);
					var newModalModel = _v24.a;
					var modalCmd = _v24.b;
					var outMsgs = _v24.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jN: newModalModel}),
						$elm$core$Platform$Cmd$batch(
							A2(
								$elm$core$List$cons,
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Products$Id_String$GenerateListingModalMsg, modalCmd),
								refreshCmds)),
						outMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Components$Partner$ManagePartnerProductCategories$viewDeleteConfirmModal = function (model) {
	var _v0 = model.cu;
	if (!_v0.$) {
		var _v1 = _v0.a;
		var request = _v1.b;
		return A2(
			$author$project$Components$HiConfirm$modal,
			$author$project$Components$Partner$ManagePartnerProductCategories$DeleteConfirmationClosed,
			_List_fromArray(
				[
					$author$project$Components$HiConfirm$verb('remove'),
					$author$project$Components$HiConfirm$noun('category'),
					$author$project$Components$HiConfirm$loading(
					_Utils_eq(request, $author$project$Api$Data$Loading))
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Components$Partner$ManagePartnerProductCategories$FormUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductCategories$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductCategories$Save = {$: 3};
var $author$project$Components$Partner$ManagePartnerProductCategories$SelectedCategory = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductCategories$viewEditModal = function (model) {
	var _v0 = model.Q;
	if (!_v0.$) {
		var _v1 = _v0.a;
		var form = _v1.b;
		var request = _v1.c;
		var modalConfig = {
			Tq: $elm$core$Maybe$Nothing,
			aih: 'Category',
			V8: _Utils_eq(request, $author$project$Api$Data$Loading),
			WG: $elm$core$Maybe$Nothing,
			WH: $elm$core$Maybe$Nothing,
			Yd: $author$project$Components$Partner$ManagePartnerProductCategories$CancelAdd,
			Yf: $elm$core$Basics$always($author$project$Components$Partner$ManagePartnerProductCategories$Save)
		};
		var fields = $author$project$Utils$Form$fields(form);
		var categories = function () {
			var _v2 = model.Nr;
			if (_v2.$ === 3) {
				var cats = _v2.a;
				return cats;
			} else {
				return _List_Nil;
			}
		}();
		var options = A2(
			$elm$core$List$map,
			function (cat) {
				return A2(
					$author$project$Ui$Dropdown$item,
					_List_fromArray(
						[
							$author$project$Ui$Dropdown$onSelect(
							$author$project$Components$Partner$ManagePartnerProductCategories$FormUpdated(
								$author$project$Components$Partner$ManagePartnerProductCategories$SelectedCategory(cat))),
							$author$project$Ui$Dropdown$selected(
							_Utils_eq(
								fields.pT,
								$elm$core$Maybe$Just(
									$author$project$Api$Common$Marketplace$Product$Category$id(cat))))
						]),
					$elm$html$Html$text(
						$author$project$Api$Common$Marketplace$Product$Category$name(cat)));
			},
			categories);
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('Name'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							A4(
							$author$project$Ui$Dropdown$viewCombobox,
							_List_Nil,
							{
								aji: $elm$core$Maybe$Nothing,
								ajm: A2($elm$core$Basics$composeR, $author$project$Components$Partner$ManagePartnerProductCategories$Name, $author$project$Components$Partner$ManagePartnerProductCategories$FormUpdated),
								aee: fields.Bq
							},
							options,
							model.mI)
						]))
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Components$Partner$ManagePartnerProductCategories$modal = function (_v0) {
	var model = _v0;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Components$Partner$ManagePartnerProductCategories$viewDeleteConfirmModal(model),
				$author$project$Components$Partner$ManagePartnerProductCategories$viewEditModal(model)
			]));
};
var $author$project$Components$Partner$ManagePartnerProductDataFlows$viewProductDataFlowDeleteConfirmModal = function (model) {
	var _v0 = model.cA;
	if (!_v0.$) {
		var _v1 = _v0.a;
		var request = _v1.b;
		return A2(
			$author$project$Components$HiConfirm$modal,
			$author$project$Components$Partner$ManagePartnerProductDataFlows$DeleteConfirmationClosed,
			_List_fromArray(
				[
					$author$project$Components$HiConfirm$verb('delete'),
					$author$project$Components$HiConfirm$noun('synced field'),
					$author$project$Components$HiConfirm$loading(
					_Utils_eq(request, $author$project$Api$Data$Loading))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Partner$ManagePartnerProductDataFlows$FormUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductDataFlows$HintName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductDataFlows$PartnerName = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductDataFlows$Save = {$: 4};
var $author$project$Components$Partner$ManagePartnerProductDataFlows$SyncDirection = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductDataFlows$linkTypeOptions = A2(
	$elm$core$List$map,
	function (_v0) {
		var syncDirection = _v0.a;
		var label = _v0.b;
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(
				$author$project$Api$Common$Marketplace$Product$SyncDirection$toString(syncDirection)),
			label);
	},
	_List_fromArray(
		[
			_Utils_Tuple2(1, 'To Hint'),
			_Utils_Tuple2(0, 'From Hint'),
			_Utils_Tuple2(2, 'Two-way')
		]));
var $author$project$Components$Partner$ManagePartnerProductDataFlows$viewProductDataFlowEditModal = function (_v0) {
	var productDataFlow = _v0.R;
	if (!productDataFlow.$) {
		var _v2 = productDataFlow.a;
		var item = _v2.a;
		var form = _v2.b;
		var request = _v2.c;
		var modalConfig = {
			Tq: $elm$core$Maybe$Nothing,
			aih: 'Synced field',
			V8: _Utils_eq(request, $author$project$Api$Data$Loading),
			WG: A2($elm$core$Maybe$map, $author$project$Api$Partner$PartnerProductDataFlow$Shared$id, item),
			WH: $elm$core$Maybe$Nothing,
			Yd: $author$project$Components$Partner$ManagePartnerProductDataFlows$CancelAdd,
			Yf: $elm$core$Basics$always($author$project$Components$Partner$ManagePartnerProductDataFlows$Save)
		};
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Hint name'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(fields.TA),
									$author$project$Ui$Form$Input$placeholder('Invoice'),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeR, $author$project$Components$Partner$ManagePartnerProductDataFlows$HintName, $author$project$Components$Partner$ManagePartnerProductDataFlows$FormUpdated)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 0, form))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Partner name'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(fields.YR),
									$author$project$Ui$Form$Input$placeholder('Expense'),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeR, $author$project$Components$Partner$ManagePartnerProductDataFlows$PartnerName, $author$project$Components$Partner$ManagePartnerProductDataFlows$FormUpdated)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 1, form))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpanSm(4),
							$author$project$Ui$Form$Group$inputSpanSm(8),
							$author$project$Ui$Form$Group$label('Sync Direction')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(
									$elm$core$Maybe$Just(
										$author$project$Api$Common$Marketplace$Product$SyncDirection$toString(fields.acK))),
									$author$project$Ui$Form$Select$onChange(
									A2($elm$core$Basics$composeL, $author$project$Components$Partner$ManagePartnerProductDataFlows$FormUpdated, $author$project$Components$Partner$ManagePartnerProductDataFlows$SyncDirection))
								]),
							$author$project$Components$Partner$ManagePartnerProductDataFlows$linkTypeOptions)
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Partner$ManagePartnerProductDataFlows$modal = function (_v0) {
	var model = _v0;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Components$Partner$ManagePartnerProductDataFlows$viewProductDataFlowDeleteConfirmModal(model),
				$author$project$Components$Partner$ManagePartnerProductDataFlows$viewProductDataFlowEditModal(model)
			]));
};
var $author$project$Components$Partner$ManagePartnerProductHighlights$viewHighlightDeleteConfirmModal = function (model) {
	var _v0 = model.cw;
	if (!_v0.$) {
		var _v1 = _v0.a;
		var request = _v1.b;
		return A2(
			$author$project$Components$HiConfirm$modal,
			$author$project$Components$Partner$ManagePartnerProductHighlights$DeleteConfirmationClosed,
			_List_fromArray(
				[
					$author$project$Components$HiConfirm$verb('delete'),
					$author$project$Components$HiConfirm$noun('highlight'),
					$author$project$Components$HiConfirm$loading(
					_Utils_eq(request, $author$project$Api$Data$Loading))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Partner$ManagePartnerProductHighlights$Description = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductHighlights$ImageUploaded = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductHighlights$SaveHighlight = {$: 5};
var $author$project$Components$Partner$ManagePartnerProductHighlights$Title = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductHighlights$viewHighlightModal = function (_v0) {
	var productHighlight = _v0.T;
	if (!productHighlight.$) {
		var _v2 = productHighlight.a;
		var item = _v2.a;
		var form = _v2.b;
		var request = _v2.c;
		var modalConfig = {
			Tq: $elm$core$Maybe$Nothing,
			aih: 'Highlight',
			V8: _Utils_eq(request, $author$project$Api$Data$Loading),
			WG: A2($elm$core$Maybe$map, $author$project$Api$Partner$PartnerProductHighlight$Shared$id, item),
			WH: $elm$core$Maybe$Nothing,
			Yd: $author$project$Components$Partner$ManagePartnerProductHighlights$CancelAddOrEdit,
			Yf: $elm$core$Basics$always($author$project$Components$Partner$ManagePartnerProductHighlights$SaveHighlight)
		};
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Title')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(fields.ac9),
									$author$project$Ui$Form$Input$placeholder('Highlight title'),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeR, $author$project$Components$Partner$ManagePartnerProductHighlights$Title, $author$project$Components$Partner$ManagePartnerProductHighlights$FormUpdated)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 0, form))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Description')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Textarea$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Textarea$value(fields.Qr),
									$author$project$Ui$Form$Textarea$placeholder('Highlight description'),
									$author$project$Ui$Form$Textarea$onInput(
									A2($elm$core$Basics$composeR, $author$project$Components$Partner$ManagePartnerProductHighlights$Description, $author$project$Components$Partner$ManagePartnerProductHighlights$FormUpdated)),
									$author$project$Ui$Form$Textarea$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
									$author$project$Ui$Form$Textarea$errors(
									A2($author$project$Utils$Form$validationErrors, 1, form))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Image')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$File$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$File$accept(0),
									$author$project$Ui$Form$File$onInput($author$project$Components$Partner$ManagePartnerProductHighlights$ImageUploaded),
									$author$project$Ui$Form$File$empty(true)
								])),
							A2(
							$author$project$Ui$Typography$p,
							_List_fromArray(
								[$author$project$Ui$Typography$helpBlock]),
							_List_fromArray(
								[
									$elm$html$Html$text('Recommended size: 256x160 px or larger.'),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									$elm$html$Html$text('Supported image file: JPG, PNG')
								])),
							function () {
							var _v3 = fields.rQ;
							if (!_v3.$) {
								if (_v3.a === '') {
									return $author$project$Utils$Html$empty;
								} else {
									var url = _v3.a;
									return A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$mt4]),
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Image$fromSrc,
												{LD: 'Uploaded image'},
												url,
												_List_fromArray(
													[
														$author$project$Ui$Image$height(50)
													])),
												$author$project$Utils$FormErrors$view(
												A2($author$project$Utils$Form$validationErrors, 2, form))
											]));
								}
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Partner$ManagePartnerProductHighlights$modal = function (_v0) {
	var model = _v0;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Components$Partner$ManagePartnerProductHighlights$viewHighlightDeleteConfirmModal(model),
				$author$project$Components$Partner$ManagePartnerProductHighlights$viewHighlightModal(model)
			]));
};
var $author$project$Components$Partner$ManagePartnerProductLinks$viewLinkDeleteConfirmModal = function (model) {
	var _v0 = model.cx;
	if (!_v0.$) {
		var _v1 = _v0.a;
		var request = _v1.b;
		return A2(
			$author$project$Components$HiConfirm$modal,
			$author$project$Components$Partner$ManagePartnerProductLinks$DeleteConfirmationClosed,
			_List_fromArray(
				[
					$author$project$Components$HiConfirm$verb('delete'),
					$author$project$Components$HiConfirm$noun('link'),
					$author$project$Components$HiConfirm$loading(
					_Utils_eq(request, $author$project$Api$Data$Loading))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Partner$ManagePartnerProductLinks$CopyUrl = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductLinks$FormUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductLinks$LinkType = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductLinks$Save = {$: 4};
var $author$project$Components$Partner$ManagePartnerProductLinks$Title = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductLinks$UtmCampaign = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductLinks$UtmContent = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductLinks$Value = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductLinks$linkTypeOptions = A2(
	$elm$core$List$map,
	function (_v0) {
		var linkType = _v0.a;
		var label = _v0.b;
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(
				$author$project$Api$Common$Marketplace$Product$LinkType$toString(linkType)),
			label);
	},
	_List_fromArray(
		[
			_Utils_Tuple2(0, 'URL'),
			_Utils_Tuple2(1, 'Email'),
			_Utils_Tuple2(2, 'Phone')
		]));
var $author$project$Components$Partner$UtmLinkPreview$buildPreviewUrl = function (params) {
	if ($elm$core$String$isEmpty(params.adY)) {
		return $elm$core$Maybe$Nothing;
	} else {
		var separator = A2($elm$core$String$contains, '?', params.adY) ? '&' : '?';
		var campaign = $elm$core$String$isEmpty(params.aea) ? 'hint_marketplace' : params.aea;
		var utmParams = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					A2($elm$url$Url$Builder$string, 'utm_source', 'hint')),
					$elm$core$Maybe$Just(
					A2($elm$url$Url$Builder$string, 'utm_medium', 'marketplace')),
					$elm$core$Maybe$Just(
					A2($elm$url$Url$Builder$string, 'utm_campaign', campaign)),
					$elm$core$String$isEmpty(params.aeb) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					A2($elm$url$Url$Builder$string, 'utm_content', params.aeb))
				]));
		return $elm$core$Maybe$Just(
			function (query) {
				return _Utils_ap(
					params.adY,
					_Utils_ap(separator, query));
			}(
				A2(
					$elm$core$String$dropLeft,
					1,
					$elm$url$Url$Builder$toQuery(utmParams))));
	}
};
var $elm$html$Html$code = _VirtualDom_node('code');
var $author$project$Components$Partner$UtmLinkPreview$view = F2(
	function (params, onCopy) {
		var _v0 = $author$project$Components$Partner$UtmLinkPreview$buildPreviewUrl(params);
		if (_v0.$ === 1) {
			return $elm$html$Html$text('');
		} else {
			var previewUrl = _v0.a;
			return A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$pre,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-xs text-muted bg-gray-50 rounded p-2 whitespace-pre-wrap break-all flex-1 m-0')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$code,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(previewUrl)
									]))
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Copy URL'},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$icon($author$project$Ui$Icon$copy),
								$author$project$Ui$Button$sm,
								$author$project$Ui$Button$onClick(
								onCopy(previewUrl))
							]),
						_List_Nil)
					]));
		}
	});
var $author$project$Components$Partner$ManagePartnerProductLinks$viewLinkEditModal = function (_v0) {
	var productLink = _v0.U;
	if (!productLink.$) {
		var _v2 = productLink.a;
		var item = _v2.a;
		var form = _v2.b;
		var request = _v2.c;
		var modalConfig = {
			Tq: $elm$core$Maybe$Just('Add a link to your product that will be displayed on the product page.'),
			aih: 'Link',
			V8: _Utils_eq(request, $author$project$Api$Data$Loading),
			WG: A2($elm$core$Maybe$map, $author$project$Api$Partner$PartnerProductLink$Shared$id, item),
			WH: $elm$core$Maybe$Nothing,
			Yd: $author$project$Components$Partner$ManagePartnerProductLinks$CancelAdd,
			Yf: $elm$core$Basics$always($author$project$Components$Partner$ManagePartnerProductLinks$Save)
		};
		var fields = $author$project$Utils$Form$fields(form);
		var valuePlaceholder = function () {
			var _v3 = fields.V3;
			switch (_v3) {
				case 0:
					return 'https://example.com';
				case 1:
					return 'example@example.com';
				default:
					return '(123) 456-7890';
			}
		}();
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Title'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(fields.ac9),
									$author$project$Ui$Form$Input$placeholder('Link title'),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeR, $author$project$Components$Partner$ManagePartnerProductLinks$Title, $author$project$Components$Partner$ManagePartnerProductLinks$FormUpdated)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 0, form))
								]))
						])),
				A2(
					$elm$core$List$cons,
					A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8),
								$author$project$Ui$Form$Group$label('Type')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Select$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Select$value(
										$elm$core$Maybe$Just(
											$author$project$Api$Common$Marketplace$Product$LinkType$toString(fields.V3))),
										$author$project$Ui$Form$Select$onChange(
										A2($elm$core$Basics$composeL, $author$project$Components$Partner$ManagePartnerProductLinks$FormUpdated, $author$project$Components$Partner$ManagePartnerProductLinks$LinkType))
									]),
								$author$project$Components$Partner$ManagePartnerProductLinks$linkTypeOptions)
							])),
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$labelSpan(4),
									$author$project$Ui$Form$Group$inputSpan(8),
									$author$project$Ui$Form$Group$label(
									$author$project$Components$Partner$ManagePartnerProductLinks$valueLabel(fields.V3)),
									$author$project$Ui$Form$Group$required(true)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(fields.aee),
											$author$project$Ui$Form$Input$placeholder(valuePlaceholder),
											$author$project$Ui$Form$Input$onInput(
											A2($elm$core$Basics$composeR, $author$project$Components$Partner$ManagePartnerProductLinks$Value, $author$project$Components$Partner$ManagePartnerProductLinks$FormUpdated)),
											$author$project$Ui$Form$Input$invalid(
											A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
											$author$project$Ui$Form$Input$errors(
											A2($author$project$Utils$Form$validationErrors, 1, form))
										]))
								])),
						(!fields.V3) ? _List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(8),
										$author$project$Ui$Form$Group$label('UTM Campaign')
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$value(fields.aea),
												$author$project$Ui$Form$Input$placeholder('hint_marketplace'),
												$author$project$Ui$Form$Input$onInput(
												A2($elm$core$Basics$composeR, $author$project$Components$Partner$ManagePartnerProductLinks$UtmCampaign, $author$project$Components$Partner$ManagePartnerProductLinks$FormUpdated))
											]))
									])),
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(8),
										$author$project$Ui$Form$Group$label('UTM Content')
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$value(fields.aeb),
												$author$project$Ui$Form$Input$placeholder('Optional'),
												$author$project$Ui$Form$Input$onInput(
												A2($elm$core$Basics$composeR, $author$project$Components$Partner$ManagePartnerProductLinks$UtmContent, $author$project$Components$Partner$ManagePartnerProductLinks$FormUpdated))
											]))
									])),
								A2(
								$author$project$Components$Partner$UtmLinkPreview$view,
								{adY: fields.aee, aea: fields.aea, aeb: fields.aeb},
								$author$project$Components$Partner$ManagePartnerProductLinks$CopyUrl)
							]) : _List_Nil))));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Partner$ManagePartnerProductLinks$modal = function (_v0) {
	var model = _v0;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Components$Partner$ManagePartnerProductLinks$viewLinkDeleteConfirmModal(model),
				$author$project$Components$Partner$ManagePartnerProductLinks$viewLinkEditModal(model)
			]));
};
var $author$project$Components$Partner$ManagePartnerProductQuotes$viewQuoteDeleteConfirmModal = function (model) {
	var _v0 = model.cB;
	if (!_v0.$) {
		var _v1 = _v0.a;
		var request = _v1.b;
		return A2(
			$author$project$Components$HiConfirm$modal,
			$author$project$Components$Partner$ManagePartnerProductQuotes$DeleteConfirmationClosed,
			_List_fromArray(
				[
					$author$project$Components$HiConfirm$verb('delete'),
					$author$project$Components$HiConfirm$noun('quote'),
					$author$project$Components$HiConfirm$loading(
					_Utils_eq(request, $author$project$Api$Data$Loading))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Partner$ManagePartnerProductQuotes$Author = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductQuotes$AuthorImageUploaded = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductQuotes$AuthorTitle = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductQuotes$Save = {$: 5};
var $author$project$Components$Partner$ManagePartnerProductQuotes$Text = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductQuotes$viewQuoteModal = function (_v0) {
	var productQuote = _v0.V;
	if (!productQuote.$) {
		var _v2 = productQuote.a;
		var item = _v2.a;
		var form = _v2.b;
		var request = _v2.c;
		var modalConfig = {
			Tq: $elm$core$Maybe$Nothing,
			aih: 'Quote',
			V8: _Utils_eq(request, $author$project$Api$Data$Loading),
			WG: A2($elm$core$Maybe$map, $author$project$Api$Partner$PartnerProductQuote$Shared$id, item),
			WH: $elm$core$Maybe$Nothing,
			Yd: $author$project$Components$Partner$ManagePartnerProductQuotes$CancelAddOrEdit,
			Yf: $elm$core$Basics$always($author$project$Components$Partner$ManagePartnerProductQuotes$Save)
		};
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Quote'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Textarea$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Textarea$value(fields.ac3),
									$author$project$Ui$Form$Textarea$placeholder('Quote'),
									$author$project$Ui$Form$Textarea$onInput(
									A2($elm$core$Basics$composeR, $author$project$Components$Partner$ManagePartnerProductQuotes$Text, $author$project$Components$Partner$ManagePartnerProductQuotes$FormUpdated)),
									$author$project$Ui$Form$Textarea$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
									$author$project$Ui$Form$Textarea$errors(
									A2($author$project$Utils$Form$validationErrors, 0, form))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Author'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(fields.Mb),
									$author$project$Ui$Form$Input$placeholder('Author'),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeR, $author$project$Components$Partner$ManagePartnerProductQuotes$Author, $author$project$Components$Partner$ManagePartnerProductQuotes$FormUpdated)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 1, form))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Author Title'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(fields.Md),
									$author$project$Ui$Form$Input$placeholder('Author Title'),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeR, $author$project$Components$Partner$ManagePartnerProductQuotes$AuthorTitle, $author$project$Components$Partner$ManagePartnerProductQuotes$FormUpdated)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 2, form))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Author Image')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$File$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$File$accept(0),
									$author$project$Ui$Form$File$onInput($author$project$Components$Partner$ManagePartnerProductQuotes$AuthorImageUploaded),
									$author$project$Ui$Form$File$empty(true)
								])),
							A2(
							$author$project$Ui$Typography$p,
							_List_fromArray(
								[$author$project$Ui$Typography$helpBlock]),
							_List_fromArray(
								[
									$elm$html$Html$text('Recommended size: 256x160 px or larger.'),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									$elm$html$Html$text('Supported image file: JPG, PNG')
								])),
							function () {
							var _v3 = fields.rO;
							if (!_v3.$) {
								if (_v3.a === '') {
									return $author$project$Utils$Html$empty;
								} else {
									var url = _v3.a;
									return A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$mt4]),
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Image$fromSrc,
												{LD: 'Uploaded image'},
												url,
												_List_fromArray(
													[
														$author$project$Ui$Image$height(50)
													])),
												$author$project$Utils$FormErrors$view(
												A2($author$project$Utils$Form$validationErrors, 3, form))
											]));
								}
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Partner$ManagePartnerProductQuotes$modal = function (_v0) {
	var model = _v0;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Components$Partner$ManagePartnerProductQuotes$viewQuoteDeleteConfirmModal(model),
				$author$project$Components$Partner$ManagePartnerProductQuotes$viewQuoteModal(model)
			]));
};
var $author$project$Pages$Partner$Products$Id_String$Attribution = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Pages$Partner$Products$Id_String$Edit = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$EditIconClicked = {$: 7};
var $author$project$Ui$Image$MarketplaceIconPlaceholder = 16;
var $author$project$Pages$Partner$Products$Id_String$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$ProductDescription = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Partner$PartnerProduct$One$builtByName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$PartnerProduct$Shared$builtByName(shared);
};
var $author$project$Api$Partner$PartnerProduct$One$builtByUrl = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$PartnerProduct$Shared$builtByUrl(shared);
};
var $author$project$Api$Partner$PartnerProduct$One$featured = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$PartnerProduct$Shared$featured(shared);
};
var $author$project$Api$Partner$PartnerProduct$One$iconUrl = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$PartnerProduct$Shared$iconUrl(shared);
};
var $author$project$Api$Partner$PartnerProduct$One$summary = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$PartnerProduct$Shared$summary(shared);
};
var $author$project$Pages$Partner$Products$Id_String$EditExternalCta = {$: 19};
var $author$project$Components$Marketplace$Product$CallToAction$disabled = 0;
var $author$project$Pages$Partner$Products$Id_String$viewCtaButton = F2(
	function (callToAction, product) {
		var _v0 = $author$project$Api$Partner$PartnerProduct$One$type_(product);
		if (_v0 === 2) {
			return A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mt4]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('inline-edit w-full'),
								$elm$html$Html$Events$onClick($author$project$Pages$Partner$Products$Id_String$EditExternalCta)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Components$Marketplace$Product$CallToAction$button,
								_List_fromArray(
									[$author$project$Components$Marketplace$Product$CallToAction$disabled]),
								callToAction),
								$author$project$Ui$Icon$edit(
								_List_fromArray(
									[$author$project$Ui$Icon$xs]))
							]))
					]));
		} else {
			return A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mt4]),
				_List_fromArray(
					[
						A2(
						$author$project$Components$Marketplace$Product$CallToAction$button,
						_List_fromArray(
							[$author$project$Components$Marketplace$Product$CallToAction$disabled]),
						callToAction)
					]));
		}
	});
var $author$project$Pages$Partner$Products$Id_String$viewInlineEdit = F2(
	function (msg, viewView) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('inline-edit'),
					$elm$html$Html$Events$onClick(msg)
				]),
			_List_fromArray(
				[
					A2($elm$html$Html$map, $elm$core$Basics$never, viewView),
					$author$project$Ui$Icon$edit(
					_List_fromArray(
						[$author$project$Ui$Icon$xs]))
				]));
	});
var $author$project$Pages$Partner$Products$Id_String$productCard = F3(
	function (imageStore, product, callToAction) {
		var productSummary = $author$project$Api$Partner$PartnerProduct$One$summary(product);
		var productName = $author$project$Api$Partner$PartnerProduct$One$name(product);
		var builtByUrl = $author$project$Api$Partner$PartnerProduct$One$builtByUrl(product);
		var builtByName = $author$project$Api$Partner$PartnerProduct$One$builtByName(product);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('card'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'card--highlighted',
							$author$project$Api$Partner$PartnerProduct$One$featured(product))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap4, $author$project$Ui$Element$mb4]),
					_List_fromArray(
						[
							A2(
							$author$project$Pages$Partner$Products$Id_String$viewInlineEdit,
							$author$project$Pages$Partner$Products$Id_String$EditIconClicked,
							function () {
								var _v0 = $author$project$Api$Partner$PartnerProduct$One$iconUrl(product);
								if (!_v0.$) {
									var icon = _v0.a;
									return A3(
										$author$project$Ui$Image$fromSrc,
										{LD: productName + ' icon'},
										icon,
										_List_fromArray(
											[
												$author$project$Ui$Image$height(64)
											]));
								} else {
									return A4(
										$author$project$Ui$Image$view,
										imageStore,
										{LD: 'Product icon placeholder'},
										_List_fromArray(
											[
												$author$project$Ui$Image$height(64)
											]),
										16);
								}
							}()),
							A2(
							$author$project$Pages$Partner$Products$Id_String$viewInlineEdit,
							$author$project$Pages$Partner$Products$Id_String$Edit(
								$author$project$Pages$Partner$Products$Id_String$Name(productName)),
							$author$project$Ui$Typography$headingSm(
								$elm$core$List$singleton(
									$elm$html$Html$text(productName))))
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$gap2]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Badge$view,
							_List_fromArray(
								[$author$project$Ui$Badge$neutral]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Common$Marketplace$Product$ProductType$toString(
										$author$project$Api$Partner$PartnerProduct$One$type_(product)))
								])),
							function () {
							var _v1 = $author$project$Api$Partner$PartnerProduct$One$status(product);
							if (_v1 === 5) {
								return $author$project$Utils$Html$empty;
							} else {
								return $author$project$Components$Marketplace$Product$Status$view(
									$author$project$Api$Partner$PartnerProduct$One$status(product));
							}
						}()
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mt4]),
					_List_fromArray(
						[
							A2(
							$author$project$Pages$Partner$Products$Id_String$viewInlineEdit,
							$author$project$Pages$Partner$Products$Id_String$Edit(
								$author$project$Pages$Partner$Products$Id_String$ProductDescription(
									A2($elm$core$Maybe$withDefault, '', productSummary))),
							function () {
								if (!productSummary.$) {
									var description = productSummary.a;
									return A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$textMuted]),
										_List_fromArray(
											[
												$elm$html$Html$text(description)
											]));
								} else {
									return A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-muted')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('N/A')
											]));
								}
							}())
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mt4, $author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Built by ')
								])),
							A2(
							$author$project$Pages$Partner$Products$Id_String$viewInlineEdit,
							$author$project$Pages$Partner$Products$Id_String$Edit(
								A2($author$project$Pages$Partner$Products$Id_String$Attribution, builtByName, builtByUrl)),
							function () {
								var _v3 = _Utils_Tuple2(builtByName, builtByUrl);
								if (!_v3.a.$) {
									if (!_v3.b.$) {
										var name = _v3.a.a;
										var url = _v3.b.a;
										return A3(
											$author$project$Ui$Link$externalHref,
											url,
											_List_fromArray(
												[
													$author$project$Ui$Link$icon($author$project$Ui$Icon$launch),
													$author$project$Ui$Link$targetBlank
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(name)
												]));
									} else {
										var name = _v3.a.a;
										var _v4 = _v3.b;
										return $elm$html$Html$text(name);
									}
								} else {
									return A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-muted')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('N/A')
											]));
								}
							}())
						])),
					A2($author$project$Pages$Partner$Products$Id_String$viewCtaButton, callToAction, product)
				]));
	});
var $author$project$Components$Partner$GenerateListingModal$UrlChanged = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$GenerateListingModal$asyncStatus = function (message) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex flex-col items-center text-center gap-3 py-8')
			]),
		_List_fromArray(
			[
				$author$project$Ui$Spinner$view(_List_Nil),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-sm text-gray-700 max-w-md')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(message)
					]))
			]));
};
var $author$project$Components$Partner$GenerateListingModal$asyncBody = function (model) {
	switch (model.$) {
		case 2:
			return _List_fromArray(
				[
					$author$project$Components$Partner$GenerateListingModal$asyncStatus('Submitting URL...')
				]);
		case 3:
			return _List_fromArray(
				[
					$author$project$Components$Partner$GenerateListingModal$asyncStatus('Reading the page and drafting your summary. This usually takes 30-90 seconds.')
				]);
		case 5:
			var message = model.a.aiH;
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$Alert$danger,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('We couldn\'t generate a draft.')
								])),
							A2($elm$html$Html$br, _List_Nil, _List_Nil),
							$elm$html$Html$text(message)
						]))
				]);
		default:
			return _List_Nil;
	}
};
var $author$project$Components$Partner$GenerateListingModal$liveRegion = function (children) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'aria-live', 'polite'),
				A2($elm$html$Html$Attributes$attribute, 'aria-atomic', 'true'),
				A2($elm$html$Html$Attributes$attribute, 'role', 'status')
			]),
		children);
};
var $author$project$Ui$Element$pt4 = $author$project$Ui$Element$Padding('pt-4');
var $author$project$Components$Partner$GenerateListingModal$CustomPromptField = 3;
var $author$project$Components$Partner$GenerateListingModal$EffortField = 2;
var $author$project$Components$Partner$GenerateListingModal$ModelField = 1;
var $author$project$Components$Partner$GenerateListingModal$OverrideChanged = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Partner$GenerateListingModal$ProviderField = 0;
var $author$project$Components$Partner$GenerateListingModal$effortOptions = _List_fromArray(
	[
		_Utils_Tuple2('low', 'Low'),
		_Utils_Tuple2('medium', 'Medium'),
		_Utils_Tuple2('high', 'High')
	]);
var $author$project$Components$Partner$GenerateListingModal$anthropicModels = _List_fromArray(
	[
		_Utils_Tuple2('claude-haiku-4-5', 'claude-haiku-4-5'),
		_Utils_Tuple2('claude-sonnet-4-6', 'claude-sonnet-4-6'),
		_Utils_Tuple2('claude-opus-4-7', 'claude-opus-4-7')
	]);
var $author$project$Components$Partner$GenerateListingModal$openaiModels = _List_fromArray(
	[
		_Utils_Tuple2('gpt-4', 'gpt-4'),
		_Utils_Tuple2('gpt-4o', 'gpt-4o'),
		_Utils_Tuple2('gpt-4-turbo', 'gpt-4-turbo'),
		_Utils_Tuple2('gpt-4.1', 'gpt-4.1'),
		_Utils_Tuple2('gpt-5', 'gpt-5'),
		_Utils_Tuple2('gpt-5-mini', 'gpt-5-mini'),
		_Utils_Tuple2('gpt-5.5', 'gpt-5.5')
	]);
var $author$project$Components$Partner$GenerateListingModal$modelOptionsFor = function (provider) {
	switch (provider) {
		case 'anthropic':
			return $author$project$Components$Partner$GenerateListingModal$anthropicModels;
		case 'openai':
			return $author$project$Components$Partner$GenerateListingModal$openaiModels;
		default:
			return _Utils_ap($author$project$Components$Partner$GenerateListingModal$openaiModels, $author$project$Components$Partner$GenerateListingModal$anthropicModels);
	}
};
var $author$project$Components$Partner$GenerateListingModal$overrideSelect = F3(
	function (currentValue, onChangeMsg, pairs) {
		return A2(
			$author$project$Ui$Form$Select$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Select$value(
					$elm$core$Maybe$Just(currentValue)),
					$author$project$Ui$Form$Select$onChange(onChangeMsg)
				]),
			A2(
				$elm$core$List$cons,
				A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(''),
					'Default'),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var value = _v0.a;
						var label = _v0.b;
						return A3(
							$author$project$Ui$Form$Select$option,
							_List_Nil,
							$elm$core$Maybe$Just(value),
							label);
					},
					pairs)));
	});
var $author$project$Components$Partner$GenerateListingModal$providerOptions = _List_fromArray(
	[
		_Utils_Tuple2('openai', 'OpenAI'),
		_Utils_Tuple2('anthropic', 'Anthropic')
	]);
var $author$project$Components$Partner$GenerateListingModal$providerSupportsEffort = function (provider) {
	return provider !== 'anthropic';
};
var $author$project$Components$Partner$GenerateListingModal$advancedForm = function (form) {
	var overrides = form.az;
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap2]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$fill]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Provider')
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Components$Partner$GenerateListingModal$overrideSelect,
										overrides.akk,
										$author$project$Components$Partner$GenerateListingModal$OverrideChanged(0),
										$author$project$Components$Partner$GenerateListingModal$providerOptions)
									]))
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$fill]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Model')
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Components$Partner$GenerateListingModal$overrideSelect,
										overrides.aiO,
										$author$project$Components$Partner$GenerateListingModal$OverrideChanged(1),
										$author$project$Components$Partner$GenerateListingModal$modelOptionsFor(overrides.akk))
									]))
							])),
						$author$project$Components$Partner$GenerateListingModal$providerSupportsEffort(overrides.akk) ? A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$fill]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Effort')
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Components$Partner$GenerateListingModal$overrideSelect,
										overrides.agI,
										$author$project$Components$Partner$GenerateListingModal$OverrideChanged(2),
										$author$project$Components$Partner$GenerateListingModal$effortOptions)
									]))
							])) : A2($author$project$Ui$Element$view, _List_Nil, _List_Nil)
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Custom prompt')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Textarea$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Textarea$value(overrides.i3),
								$author$project$Ui$Form$Textarea$placeholder('Leave blank to use the default template. Placeholders like {{source_url}} and {{image_catalog}} are substituted at generation time.'),
								$author$project$Ui$Form$Textarea$onInput(
								$author$project$Components$Partner$GenerateListingModal$OverrideChanged(3)),
								$author$project$Ui$Form$Textarea$rows(6)
							]))
					]))
			]));
};
var $author$project$Components$Partner$GenerateListingModal$advancedFormSkeleton = A2(
	$author$project$Ui$Element$view,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap2]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$fill]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Provider')
								]),
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$input(_List_Nil)
								]))
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$fill]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Model')
								]),
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$input(_List_Nil)
								]))
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$fill]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Effort')
								]),
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$input(_List_Nil)
								]))
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Custom prompt')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$block,
							$author$project$Ui$Skeleton$span(12)
						])),
					$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$block,
							$author$project$Ui$Skeleton$span(12)
						])),
					$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$block,
							$author$project$Ui$Skeleton$span(10)
						]))
				]))
		]));
var $author$project$Components$Partner$GenerateListingModal$viewAdvancedPanelBody = function (form) {
	var _v0 = form.me;
	if (_v0.$ === 3) {
		return $author$project$Components$Partner$GenerateListingModal$advancedForm(form);
	} else {
		return $author$project$Components$Partner$GenerateListingModal$advancedFormSkeleton;
	}
};
var $author$project$Components$Partner$GenerateListingModal$viewAdvancedPanel = function (form) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$pt4]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_fromArray(
					[
						$author$project$Ui$Panel$collapsed(true)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_fromArray(
							[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap4]),
						_List_fromArray(
							[
								$author$project$Ui$HinterOnly$icon(
								_List_fromArray(
									[$author$project$Ui$Icon$circled, $author$project$Ui$Icon$lg])),
								A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$title,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Advanced (hinter only)')
											])),
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$textMuted]),
										_List_fromArray(
											[
												$elm$html$Html$text('Override LLM provider, model, reasoning effort, or the prompt template')
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Components$Partner$GenerateListingModal$viewAdvancedPanelBody(form)
							]))
					]))
			]));
};
var $author$project$Components$Partner$GenerateListingModal$NameS = 0;
var $author$project$Components$Partner$GenerateListingModal$OverviewS = 5;
var $author$project$Components$Partner$GenerateListingModal$SummaryS = 4;
var $author$project$Components$Partner$GenerateListingModal$UpdateName = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Partner$GenerateListingModal$UpdateOverview = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$Partner$GenerateListingModal$UpdateSummary = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Partner$GenerateListingModal$BuiltByNameField = 0;
var $author$project$Components$Partner$GenerateListingModal$BuiltByS = 1;
var $author$project$Components$Partner$GenerateListingModal$BuiltByUrlField = 1;
var $author$project$Components$Partner$GenerateListingModal$UpdateBuiltBy = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Components$Partner$GenerateListingModal$emptyHint = A2(
	$elm$html$Html$p,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('text-sm text-gray-500 italic')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('—')
		]));
var $author$project$Components$Partner$GenerateListingModal$orDash = function (value) {
	return $elm$core$String$isEmpty(value) ? '—' : value;
};
var $author$project$Components$Partner$GenerateListingModal$sideBySide = F2(
	function (existingHtml, generatedHtml) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex gap-3 mt-2 items-stretch')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex-1 basis-0 min-w-0 rounded-md border-l-4 border-gray-300 bg-gray-50 px-3 py-2')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-xs uppercase tracking-wide font-semibold text-gray-500 mb-1')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Current')
								])),
							existingHtml
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex-1 basis-0 min-w-0 rounded-md border-l-4 border-blue-400 bg-blue-50 px-3 py-2')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-xs uppercase tracking-wide font-semibold text-blue-700 mb-1')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Generated draft')
								])),
							generatedHtml
						]))
				]));
	});
var $author$project$Components$Partner$GenerateListingModal$ToggleInclude = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Components$Partner$GenerateListingModal$viewSectionHeader = F3(
	function (heading, section, include) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex gap-2 items-center mt-4')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex gap-2 items-center cursor-pointer')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('checkbox'),
									$elm$html$Html$Attributes$checked(include),
									$elm$html$Html$Events$onCheck(
									$author$project$Components$Partner$GenerateListingModal$ToggleInclude(section))
								]),
							_List_Nil),
							A2(
							$elm$html$Html$map,
							$elm$core$Basics$never,
							$author$project$Ui$Typography$headingSm(
								_List_fromArray(
									[
										$elm$html$Html$text(heading)
									])))
						]))
				]));
	});
var $author$project$Components$Partner$GenerateListingModal$viewBuiltBySection = F2(
	function (existing, state) {
		var generatedHtml = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('opacity-50 pointer-events-none', !state.c)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex gap-2 items-end')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex-1 basis-0 min-w-0')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$label('Name')
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$value(state.aee.Bq),
													$author$project$Ui$Form$Input$onInput(
													$author$project$Components$Partner$GenerateListingModal$UpdateBuiltBy(0))
												]))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex-1 basis-0 min-w-0')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$label('URL')
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$value(state.aee.adY),
													$author$project$Ui$Form$Input$onInput(
													$author$project$Components$Partner$GenerateListingModal$UpdateBuiltBy(1)),
													$author$project$Ui$Form$Input$placeholder('https://example.com')
												]))
										]))
								]))
						]))
				]));
		var existingUrl = $elm$core$String$trim(
			A2($elm$core$Maybe$withDefault, '', existing.MW));
		var existingName = $elm$core$String$trim(
			A2($elm$core$Maybe$withDefault, '', existing.MV));
		var existingHtml = ($elm$core$String$isEmpty(existingName) && $elm$core$String$isEmpty(existingUrl)) ? $author$project$Components$Partner$GenerateListingModal$emptyHint : A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-sm text-gray-700 whitespace-normal break-all')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$strong,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('name: ')
						])),
					$elm$html$Html$text(
					$author$project$Components$Partner$GenerateListingModal$orDash(existingName)),
					$elm$html$Html$text(', '),
					A2(
					$author$project$Ui$Typography$strong,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('url: ')
						])),
					$elm$html$Html$text(
					$author$project$Components$Partner$GenerateListingModal$orDash(existingUrl))
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mt-2')
				]),
			_List_fromArray(
				[
					A3($author$project$Components$Partner$GenerateListingModal$viewSectionHeader, 'Built by', 1, state.c),
					$author$project$Ui$HorizontalRule$view(
					_List_fromArray(
						[$author$project$Ui$HorizontalRule$thin])),
					A2($author$project$Components$Partner$GenerateListingModal$sideBySide, existingHtml, generatedHtml)
				]));
	});
var $author$project$Components$Partner$GenerateListingModal$AddCategory = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Partner$GenerateListingModal$CategoriesS = 3;
var $author$project$Components$Partner$GenerateListingModal$CategoryInputChanged = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Partner$GenerateListingModal$RemoveCategory = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Partner$GenerateListingModal$viewCategoryChip = F2(
	function (index, name) {
		return A3(
			$author$project$Ui$Button$view,
			{mm: 'Remove ' + name},
			_List_fromArray(
				[
					$author$project$Ui$Button$sm,
					$author$project$Ui$Button$onClick(
					$author$project$Components$Partner$GenerateListingModal$RemoveCategory(index))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$inlineBlock, $author$project$Ui$Element$mr2]),
					_List_fromArray(
						[
							$elm$html$Html$text(name)
						])),
					$author$project$Ui$Icon$cross(
					_List_fromArray(
						[$author$project$Ui$Icon$xs]))
				]));
	});
var $author$project$Components$Partner$GenerateListingModal$viewCategoriesSection = function (state) {
	var section = state.bw.Nr;
	var existingCategories = state.ag1.Nr;
	var existingHtml = $elm$core$List$isEmpty(existingCategories) ? $author$project$Components$Partner$GenerateListingModal$emptyHint : A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('text-sm text-gray-700 whitespace-normal break-words')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				A2($elm$core$String$join, ', ', existingCategories))
			]));
	var availableForPicker = A2(
		$elm$core$List$filter,
		function (c) {
			return $elm$core$String$isEmpty(
				$elm$core$String$trim(state.fU)) ? true : A2(
				$elm$core$String$contains,
				$elm$core$String$toLower(state.fU),
				$elm$core$String$toLower(c));
		},
		A2(
			$elm$core$List$filter,
			function (c) {
				return !A2($elm$core$List$member, c, section.aee);
			},
			state.ag1.ae5));
	var dropdownItems = A2(
		$elm$core$List$map,
		function (name) {
			return A2(
				$author$project$Ui$Dropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$Dropdown$onSelect(
						$author$project$Components$Partner$GenerateListingModal$AddCategory(name))
					]),
				$elm$html$Html$text(name));
		},
		availableForPicker);
	var generatedHtml = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('opacity-50 pointer-events-none', !section.c)
					]))
			]),
		_List_fromArray(
			[
				$elm$core$List$isEmpty(section.aee) ? $elm$html$Html$text('') : A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex flex-wrap gap-2 mb-2')
					]),
				A2($elm$core$List$indexedMap, $author$project$Components$Partner$GenerateListingModal$viewCategoryChip, section.aee)),
				A4(
				$author$project$Ui$Dropdown$viewCombobox,
				_List_Nil,
				{
					aji: $elm$core$Maybe$Just(
						$author$project$Components$Partner$GenerateListingModal$AddCategory(state.fU)),
					ajm: $author$project$Components$Partner$GenerateListingModal$CategoryInputChanged,
					aee: state.fU
				},
				dropdownItems,
				state.mI)
			]));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mt-2')
			]),
		_List_fromArray(
			[
				A3($author$project$Components$Partner$GenerateListingModal$viewSectionHeader, 'Categories', 3, section.c),
				$author$project$Ui$HorizontalRule$view(
				_List_fromArray(
					[$author$project$Ui$HorizontalRule$thin])),
				A2($author$project$Components$Partner$GenerateListingModal$sideBySide, existingHtml, generatedHtml)
			]));
};
var $author$project$Components$Partner$GenerateListingModal$HighlightsS = 7;
var $author$project$Components$Partner$GenerateListingModal$viewExistingHighlight = function (h) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-sm font-semibold text-gray-700')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(h.ac9)
					])),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-sm text-gray-600 whitespace-pre-wrap')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(h.Qr)
					]))
			]));
};
var $author$project$Components$Partner$GenerateListingModal$DescriptionField = 1;
var $author$project$Components$Partner$GenerateListingModal$RemoveHighlight = function (a) {
	return {$: 21, a: a};
};
var $author$project$Components$Partner$GenerateListingModal$RemoveHighlightImage = function (a) {
	return {$: 22, a: a};
};
var $author$project$Components$Partner$GenerateListingModal$TitleField = 0;
var $author$project$Components$Partner$GenerateListingModal$UpdateHighlight = F3(
	function (a, b, c) {
		return {$: 20, a: a, b: b, c: c};
	});
var $author$project$Components$Partner$GenerateListingModal$viewImagePreview = function (opts) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('inline-flex items-start gap-1')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$img,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$src(opts.uN),
						$elm$html$Html$Attributes$alt(opts.LD),
						$elm$html$Html$Attributes$class(opts.rF + ' border border-gray-200 bg-white')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('button'),
						$elm$html$Html$Events$onClick(opts.ud),
						A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Remove image'),
						$elm$html$Html$Attributes$class('text-xs text-gray-500 hover:text-danger underline')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('remove')
					]))
			]));
};
var $author$project$Components$Partner$GenerateListingModal$viewHighlightRow = F2(
	function (index, row) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex gap-2 mt-2 items-start')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex-1 basis-0 min-w-0')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Title')
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(row.ac9),
											$author$project$Ui$Form$Input$onInput(
											A2($author$project$Components$Partner$GenerateListingModal$UpdateHighlight, index, 0))
										]))
								])),
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Description')
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Textarea$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Textarea$value(row.Qr),
											$author$project$Ui$Form$Textarea$onInput(
											A2($author$project$Components$Partner$GenerateListingModal$UpdateHighlight, index, 1)),
											$author$project$Ui$Form$Textarea$rows(2)
										]))
								])),
							function () {
							var _v0 = row.ahT;
							if (!_v0.$) {
								var src = _v0.a;
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mt-1')
										]),
									_List_fromArray(
										[
											$author$project$Components$Partner$GenerateListingModal$viewImagePreview(
											{
												LD: 'Highlight image',
												rF: 'w-12 h-12 rounded object-cover',
												ud: $author$project$Components$Partner$GenerateListingModal$RemoveHighlightImage(index),
												uN: src
											})
										]));
							} else {
								return $elm$html$Html$text('');
							}
						}()
						])),
					A3(
					$author$project$Ui$Button$view,
					{mm: 'Remove highlight'},
					_List_fromArray(
						[
							$author$project$Ui$Button$danger,
							$author$project$Ui$Button$onClick(
							$author$project$Components$Partner$GenerateListingModal$RemoveHighlight(index)),
							$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
						]),
					_List_Nil)
				]));
	});
var $author$project$Components$Partner$GenerateListingModal$viewHighlightsSection = F2(
	function (existing, state) {
		var generatedHtml = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('opacity-50 pointer-events-none', !state.c)
						]))
				]),
			A2($elm$core$List$indexedMap, $author$project$Components$Partner$GenerateListingModal$viewHighlightRow, state.aee));
		var existingHtml = $elm$core$List$isEmpty(existing) ? $author$project$Components$Partner$GenerateListingModal$emptyHint : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col gap-2')
				]),
			A2($elm$core$List$map, $author$project$Components$Partner$GenerateListingModal$viewExistingHighlight, existing));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mt-2')
				]),
			_List_fromArray(
				[
					A3($author$project$Components$Partner$GenerateListingModal$viewSectionHeader, 'Highlights', 7, state.c),
					$author$project$Ui$HorizontalRule$view(
					_List_fromArray(
						[$author$project$Ui$HorizontalRule$thin])),
					A2($author$project$Components$Partner$GenerateListingModal$sideBySide, existingHtml, generatedHtml)
				]));
	});
var $author$project$Components$Partner$GenerateListingModal$IconS = 2;
var $author$project$Components$Partner$GenerateListingModal$RemoveIcon = {$: 12};
var $author$project$Components$Partner$GenerateListingModal$viewIconSection = function (state) {
	var generatedHtml = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('opacity-50 pointer-events-none', !state.c)
					]))
			]),
		_List_fromArray(
			[
				function () {
				var _v0 = state.aee;
				if (!_v0.$) {
					var src = _v0.a;
					return $author$project$Components$Partner$GenerateListingModal$viewImagePreview(
						{LD: 'Generated icon', rF: 'w-20 h-20 rounded-md object-cover', ud: $author$project$Components$Partner$GenerateListingModal$RemoveIcon, uN: src});
				} else {
					return $author$project$Components$Partner$GenerateListingModal$emptyHint;
				}
			}()
			]));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mt-2')
			]),
		_List_fromArray(
			[
				A3($author$project$Components$Partner$GenerateListingModal$viewSectionHeader, 'Icon', 2, state.c),
				$author$project$Ui$HorizontalRule$view(
				_List_fromArray(
					[$author$project$Ui$HorizontalRule$thin])),
				A2($author$project$Components$Partner$GenerateListingModal$sideBySide, $author$project$Components$Partner$GenerateListingModal$emptyHint, generatedHtml)
			]));
};
var $author$project$Components$Partner$GenerateListingModal$LinksS = 8;
var $author$project$Components$Partner$GenerateListingModal$viewExistingLink = function (l) {
	return A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('text-sm text-gray-700 whitespace-normal break-all')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$strong,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('label: ')
					])),
				$elm$html$Html$text(l.aih),
				$elm$html$Html$text(', '),
				A2(
				$author$project$Ui$Typography$strong,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('url: ')
					])),
				$elm$html$Html$text(l.adY)
			]));
};
var $author$project$Components$Partner$GenerateListingModal$LabelField = 0;
var $author$project$Components$Partner$GenerateListingModal$RemoveLink = function (a) {
	return {$: 24, a: a};
};
var $author$project$Components$Partner$GenerateListingModal$UpdateLink = F3(
	function (a, b, c) {
		return {$: 23, a: a, b: b, c: c};
	});
var $author$project$Components$Partner$GenerateListingModal$UrlField = 1;
var $author$project$Components$Partner$GenerateListingModal$viewLinkRow = F2(
	function (index, row) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex gap-2 mt-2 items-end')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex-1 basis-0 min-w-0')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Label')
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(row.aih),
											$author$project$Ui$Form$Input$onInput(
											A2($author$project$Components$Partner$GenerateListingModal$UpdateLink, index, 0))
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex-1 basis-0 min-w-0')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('URL')
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(row.adY),
											$author$project$Ui$Form$Input$onInput(
											A2($author$project$Components$Partner$GenerateListingModal$UpdateLink, index, 1)),
											$author$project$Ui$Form$Input$placeholder('https://example.com')
										]))
								]))
						])),
					A3(
					$author$project$Ui$Button$view,
					{mm: 'Remove link'},
					_List_fromArray(
						[
							$author$project$Ui$Button$danger,
							$author$project$Ui$Button$onClick(
							$author$project$Components$Partner$GenerateListingModal$RemoveLink(index)),
							$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
						]),
					_List_Nil)
				]));
	});
var $author$project$Components$Partner$GenerateListingModal$viewLinksSection = F2(
	function (existing, state) {
		var generatedHtml = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('opacity-50 pointer-events-none', !state.c)
						]))
				]),
			A2($elm$core$List$indexedMap, $author$project$Components$Partner$GenerateListingModal$viewLinkRow, state.aee));
		var existingHtml = $elm$core$List$isEmpty(existing) ? $author$project$Components$Partner$GenerateListingModal$emptyHint : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col gap-1')
				]),
			A2($elm$core$List$map, $author$project$Components$Partner$GenerateListingModal$viewExistingLink, existing));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mt-2')
				]),
			_List_fromArray(
				[
					A3($author$project$Components$Partner$GenerateListingModal$viewSectionHeader, 'Links', 8, state.c),
					$author$project$Ui$HorizontalRule$view(
					_List_fromArray(
						[$author$project$Ui$HorizontalRule$thin])),
					A2($author$project$Components$Partner$GenerateListingModal$sideBySide, existingHtml, generatedHtml)
				]));
	});
var $author$project$Components$Partner$GenerateListingModal$OverviewImagesS = 6;
var $author$project$Components$Partner$GenerateListingModal$RemoveOverviewImage = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Partner$GenerateListingModal$viewOverviewImagesSection = function (state) {
	var generatedHtml = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('opacity-50 pointer-events-none', !state.c)
					]))
			]),
		_List_fromArray(
			[
				$elm$core$List$isEmpty(state.aee) ? $author$project$Components$Partner$GenerateListingModal$emptyHint : A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex flex-wrap gap-2')
					]),
				A2(
					$elm$core$List$indexedMap,
					F2(
						function (index, src) {
							return $author$project$Components$Partner$GenerateListingModal$viewImagePreview(
								{
									LD: 'Overview image ' + $elm$core$String$fromInt(index + 1),
									rF: 'w-32 h-32 rounded object-cover',
									ud: $author$project$Components$Partner$GenerateListingModal$RemoveOverviewImage(index),
									uN: src
								});
						}),
					state.aee))
			]));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mt-2')
			]),
		_List_fromArray(
			[
				A3($author$project$Components$Partner$GenerateListingModal$viewSectionHeader, 'Overview images', 6, state.c),
				$author$project$Ui$HorizontalRule$view(
				_List_fromArray(
					[$author$project$Ui$HorizontalRule$thin])),
				A2($author$project$Components$Partner$GenerateListingModal$sideBySide, $author$project$Components$Partner$GenerateListingModal$emptyHint, generatedHtml)
			]));
};
var $author$project$Components$Partner$GenerateListingModal$viewProseSection = F6(
	function (heading, section, existing, state, onInputMsg, multiline) {
		var generatedHtml = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('opacity-50 pointer-events-none', !state.c)
						]))
				]),
			_List_fromArray(
				[
					multiline ? $author$project$Ui$Form$Textarea$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Textarea$value(state.aee),
							$author$project$Ui$Form$Textarea$onInput(onInputMsg),
							$author$project$Ui$Form$Textarea$rows(4)
						])) : $author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$value(state.aee),
							$author$project$Ui$Form$Input$onInput(onInputMsg)
						]))
				]));
		var existingHtml = function () {
			if (!existing.$) {
				var s = existing.a;
				return $elm$core$String$isEmpty(
					$elm$core$String$trim(s)) ? $author$project$Components$Partner$GenerateListingModal$emptyHint : A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-sm text-gray-700 whitespace-pre-wrap')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(s)
						]));
			} else {
				return $author$project$Components$Partner$GenerateListingModal$emptyHint;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mt-2')
				]),
			_List_fromArray(
				[
					A3($author$project$Components$Partner$GenerateListingModal$viewSectionHeader, heading, section, state.c),
					$author$project$Ui$HorizontalRule$view(
					_List_fromArray(
						[$author$project$Ui$HorizontalRule$thin])),
					A2($author$project$Components$Partner$GenerateListingModal$sideBySide, existingHtml, generatedHtml)
				]));
	});
var $author$project$Components$Partner$GenerateListingModal$QuotesS = 9;
var $author$project$Components$Partner$GenerateListingModal$viewExistingQuote = function (q) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-sm text-gray-700 italic whitespace-pre-wrap')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('“' + (q.ac3 + '”'))
					])),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-xs text-gray-500')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('— ' + (q.Mb + (', ' + q.Md)))
					]))
			]));
};
var $author$project$Components$Partner$GenerateListingModal$QuoteAuthorField = 1;
var $author$project$Components$Partner$GenerateListingModal$QuoteAuthorTitleField = 2;
var $author$project$Components$Partner$GenerateListingModal$QuoteTextField = 0;
var $author$project$Components$Partner$GenerateListingModal$RemoveQuote = function (a) {
	return {$: 26, a: a};
};
var $author$project$Components$Partner$GenerateListingModal$RemoveQuoteImage = function (a) {
	return {$: 27, a: a};
};
var $author$project$Components$Partner$GenerateListingModal$UpdateQuote = F3(
	function (a, b, c) {
		return {$: 25, a: a, b: b, c: c};
	});
var $author$project$Components$Partner$GenerateListingModal$viewQuoteRow = F2(
	function (index, row) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex gap-2 mt-2 items-start')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex-1 basis-0 min-w-0')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Quote')
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Textarea$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Textarea$value(row.ac3),
											$author$project$Ui$Form$Textarea$onInput(
											A2($author$project$Components$Partner$GenerateListingModal$UpdateQuote, index, 0)),
											$author$project$Ui$Form$Textarea$rows(2)
										]))
								])),
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Author')
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(row.Mb),
											$author$project$Ui$Form$Input$onInput(
											A2($author$project$Components$Partner$GenerateListingModal$UpdateQuote, index, 1))
										]))
								])),
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Author title')
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(row.Md),
											$author$project$Ui$Form$Input$onInput(
											A2($author$project$Components$Partner$GenerateListingModal$UpdateQuote, index, 2)),
											$author$project$Ui$Form$Input$placeholder('Owner, Acme DPC')
										]))
								])),
							function () {
							var _v0 = row.ae1;
							if (!_v0.$) {
								var src = _v0.a;
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mt-1')
										]),
									_List_fromArray(
										[
											$author$project$Components$Partner$GenerateListingModal$viewImagePreview(
											{
												LD: 'Author image',
												rF: 'w-12 h-12 rounded-full object-cover',
												ud: $author$project$Components$Partner$GenerateListingModal$RemoveQuoteImage(index),
												uN: src
											})
										]));
							} else {
								return $elm$html$Html$text('');
							}
						}()
						])),
					A3(
					$author$project$Ui$Button$view,
					{mm: 'Remove quote'},
					_List_fromArray(
						[
							$author$project$Ui$Button$danger,
							$author$project$Ui$Button$onClick(
							$author$project$Components$Partner$GenerateListingModal$RemoveQuote(index)),
							$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
						]),
					_List_Nil)
				]));
	});
var $author$project$Components$Partner$GenerateListingModal$viewQuotesSection = F2(
	function (existing, state) {
		var generatedHtml = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('opacity-50 pointer-events-none', !state.c)
						]))
				]),
			A2($elm$core$List$indexedMap, $author$project$Components$Partner$GenerateListingModal$viewQuoteRow, state.aee));
		var existingHtml = $elm$core$List$isEmpty(existing) ? $author$project$Components$Partner$GenerateListingModal$emptyHint : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col gap-2')
				]),
			A2($elm$core$List$map, $author$project$Components$Partner$GenerateListingModal$viewExistingQuote, existing));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mt-2')
				]),
			_List_fromArray(
				[
					A3($author$project$Components$Partner$GenerateListingModal$viewSectionHeader, 'Quotes', 9, state.c),
					$author$project$Ui$HorizontalRule$view(
					_List_fromArray(
						[$author$project$Ui$HorizontalRule$thin])),
					A2($author$project$Components$Partner$GenerateListingModal$sideBySide, existingHtml, generatedHtml)
				]));
	});
var $author$project$Components$Partner$GenerateListingModal$viewDraft = function (state) {
	var existing = state.ag1;
	var draft = state.bw;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('listing-generation-draft')
			]),
		_List_fromArray(
			[
				A6($author$project$Components$Partner$GenerateListingModal$viewProseSection, 'Name', 0, existing.Bq, draft.Bq, $author$project$Components$Partner$GenerateListingModal$UpdateName, false),
				A2($author$project$Components$Partner$GenerateListingModal$viewBuiltBySection, existing, draft.a2),
				$author$project$Components$Partner$GenerateListingModal$viewIconSection(draft.ahO),
				$author$project$Components$Partner$GenerateListingModal$viewCategoriesSection(state),
				A6($author$project$Components$Partner$GenerateListingModal$viewProseSection, 'Summary', 4, existing.acF, draft.acF, $author$project$Components$Partner$GenerateListingModal$UpdateSummary, false),
				A6($author$project$Components$Partner$GenerateListingModal$viewProseSection, 'Overview', 5, existing.YB, draft.YB, $author$project$Components$Partner$GenerateListingModal$UpdateOverview, true),
				$author$project$Components$Partner$GenerateListingModal$viewOverviewImagesSection(draft.ajI),
				A2($author$project$Components$Partner$GenerateListingModal$viewHighlightsSection, existing.Tu, draft.Tu),
				A2($author$project$Components$Partner$GenerateListingModal$viewLinksSection, existing.V5, draft.V5),
				A2($author$project$Components$Partner$GenerateListingModal$viewQuotesSection, existing._0, draft._0)
			]));
};
var $author$project$Components$Partner$GenerateListingModal$viewSaveError = function (save) {
	if (save.$ === 2) {
		var error_ = save.a;
		return A2(
			$author$project$Ui$Alert$danger,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Couldn\'t save: '),
					$elm$html$Html$text(
					$author$project$Api$Data$errorToString(error_))
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Components$Partner$GenerateListingModal$viewBody = function (model) {
	switch (model.$) {
		case 0:
			return _List_Nil;
		case 1:
			var form = model.a;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Paste a link to your product\'s website. We\'ll use AI to draft a listing summary you can review.')
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('Product website URL')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(form.adY),
									$author$project$Ui$Form$Input$placeholder('https://example.com'),
									$author$project$Ui$Form$Input$onInput($author$project$Components$Partner$GenerateListingModal$UrlChanged),
									$author$project$Ui$Form$Input$invalid(
									!_Utils_eq(form.RK, $elm$core$Maybe$Nothing)),
									$author$project$Ui$Form$Input$errors(
									A2(
										$elm$core$Maybe$withDefault,
										_List_Nil,
										A2($elm$core$Maybe$map, $elm$core$List$singleton, form.RK)))
								]))
						])),
					form.Ij ? $author$project$Components$Partner$GenerateListingModal$viewAdvancedPanel(form) : $elm$html$Html$text('')
				]);
		case 4:
			var state = model.a;
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$Alert$info,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('AI-generated draft.')
								])),
							$elm$html$Html$text(' Review, edit, and uncheck any sections you want to skip before saving.')
						])),
					$author$project$Components$Partner$GenerateListingModal$viewDraft(state),
					$author$project$Components$Partner$GenerateListingModal$viewSaveError(state.k8)
				]);
		default:
			return _List_fromArray(
				[
					$author$project$Components$Partner$GenerateListingModal$liveRegion(
					$author$project$Components$Partner$GenerateListingModal$asyncBody(model))
				]);
	}
};
var $author$project$Components$Partner$GenerateListingModal$RequestSave = {$: 28};
var $author$project$Components$Partner$GenerateListingModal$Submit = {$: 3};
var $author$project$Components$Partner$GenerateListingModal$TryAgain = {$: 7};
var $author$project$Components$Partner$GenerateListingModal$viewFooter = function (model) {
	switch (model.$) {
		case 1:
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Cancel'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Components$Partner$GenerateListingModal$CloseRequested)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Generate listing draft'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$onClick($author$project$Components$Partner$GenerateListingModal$Submit)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Generate')
								]))
						]))
				]);
		case 2:
			return _List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{mm: 'Cancel'},
					_List_fromArray(
						[
							$author$project$Ui$Button$onClick($author$project$Components$Partner$GenerateListingModal$CloseRequested)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Cancel')
						]))
				]);
		case 3:
			return _List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{mm: 'Cancel'},
					_List_fromArray(
						[
							$author$project$Ui$Button$onClick($author$project$Components$Partner$GenerateListingModal$CloseRequested)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Cancel')
						]))
				]);
		case 4:
			var state = model.a;
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Generate another draft'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Components$Partner$GenerateListingModal$TryAgain)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Generate again')
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Cancel without saving'},
									_List_fromArray(
										[
											$author$project$Ui$Button$onClick($author$project$Components$Partner$GenerateListingModal$CloseRequested)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Cancel')
										])),
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Save draft to listing'},
									_List_fromArray(
										[
											$author$project$Ui$Button$primary,
											$author$project$Ui$Button$onClick($author$project$Components$Partner$GenerateListingModal$RequestSave),
											$author$project$Ui$Button$loading(
											_Utils_eq(state.k8, $author$project$Api$Data$Loading)),
											$author$project$Ui$Button$disabled(
											!$author$project$Components$Partner$GenerateListingModal$anySectionIncluded(state.bw))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Save')
										]))
								]))
						]))
				]);
		case 5:
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Try again'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Components$Partner$GenerateListingModal$TryAgain)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Try again')
								])),
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Close'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Components$Partner$GenerateListingModal$CloseRequested)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Close')
								]))
						]))
				]);
		default:
			return _List_Nil;
	}
};
var $author$project$Components$Partner$GenerateListingModal$includedSectionLabels = function (draft) {
	return A2(
		$elm$core$List$map,
		$elm$core$Tuple$second,
		A2(
			$elm$core$List$filter,
			$elm$core$Tuple$first,
			_List_fromArray(
				[
					_Utils_Tuple2(draft.Bq.c, 'Name'),
					_Utils_Tuple2(draft.a2.c, 'Built by'),
					_Utils_Tuple2(draft.ahO.c, 'Icon'),
					_Utils_Tuple2(draft.Nr.c, 'Categories'),
					_Utils_Tuple2(draft.acF.c, 'Summary'),
					_Utils_Tuple2(draft.YB.c, 'Overview'),
					_Utils_Tuple2(draft.ajI.c, 'Overview images'),
					_Utils_Tuple2(draft.Tu.c, 'Highlights'),
					_Utils_Tuple2(draft.V5.c, 'Links'),
					_Utils_Tuple2(draft._0.c, 'Quotes')
				])));
};
var $author$project$Components$Partner$GenerateListingModal$joinSectionLabels = function (labels) {
	if (!labels.b) {
		return 'the selected sections';
	} else {
		if (!labels.b.b) {
			var one = labels.a;
			return one;
		} else {
			var _v1 = $elm$core$List$reverse(labels);
			if (_v1.b) {
				var last = _v1.a;
				var rest = _v1.b;
				return A2(
					$elm$core$String$join,
					', ',
					$elm$core$List$reverse(rest)) + (', and ' + last);
			} else {
				return A2($elm$core$String$join, ', ', labels);
			}
		}
	}
};
var $author$project$Components$Partner$GenerateListingModal$viewSaveConfirm = function (state) {
	return A2(
		$author$project$Components$HiConfirm$modal,
		$author$project$Components$Partner$GenerateListingModal$ConfirmSave,
		_List_fromArray(
			[
				$author$project$Components$HiConfirm$verb('replace'),
				$author$project$Components$HiConfirm$noun('listing sections'),
				$author$project$Components$HiConfirm$sentence(
				'This will overwrite ' + ($author$project$Components$Partner$GenerateListingModal$joinSectionLabels(
					$author$project$Components$Partner$GenerateListingModal$includedSectionLabels(state.bw)) + '. Sections you didn\'t include are left unchanged.')),
				$author$project$Components$HiConfirm$buttonStyle(1),
				$author$project$Components$HiConfirm$loading(
				_Utils_eq(state.k8, $author$project$Api$Data$Loading))
			]));
};
var $author$project$Components$Partner$GenerateListingModal$view = function (model) {
	switch (model.$) {
		case 0:
			return $elm$html$Html$text('');
		case 4:
			var state = model.a;
			return state.f$ ? $author$project$Components$Partner$GenerateListingModal$viewSaveConfirm(state) : A3(
				$author$project$Ui$Modal$view,
				$author$project$Components$Partner$GenerateListingModal$CloseRequested,
				_List_fromArray(
					[$author$project$Ui$Modal$lg]),
				_List_fromArray(
					[
						$author$project$Ui$Modal$header(
						_List_fromArray(
							[
								$author$project$Ui$Modal$title('Generate listing draft from URL')
							])),
						$author$project$Ui$Modal$body(
						$author$project$Components$Partner$GenerateListingModal$viewBody(model)),
						$author$project$Ui$Modal$footer(
						$author$project$Components$Partner$GenerateListingModal$viewFooter(model))
					]));
		default:
			return A3(
				$author$project$Ui$Modal$view,
				$author$project$Components$Partner$GenerateListingModal$CloseRequested,
				_List_fromArray(
					[$author$project$Ui$Modal$lg]),
				_List_fromArray(
					[
						$author$project$Ui$Modal$header(
						_List_fromArray(
							[
								$author$project$Ui$Modal$title('Generate listing draft from URL')
							])),
						$author$project$Ui$Modal$body(
						$author$project$Components$Partner$GenerateListingModal$viewBody(model)),
						$author$project$Ui$Modal$footer(
						$author$project$Components$Partner$GenerateListingModal$viewFooter(model))
					]));
	}
};
var $author$project$Components$Partner$ManagePartnerProductCategories$Add = {$: 0};
var $author$project$Components$Partner$ManagePartnerProductCategories$Remove = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Partner$PartnerProductCategory$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Partner$PartnerProductCategory$One$id = $author$project$Api$Partner$PartnerProductCategory$Shared$id;
var $author$project$Api$Partner$PartnerProductCategory$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Partner$PartnerProductCategory$One$name = $author$project$Api$Partner$PartnerProductCategory$Shared$name;
var $author$project$Api$Partner$Partner$One$productCategories = function (_v0) {
	var record = _v0.b;
	return record._t;
};
var $author$project$Components$Partner$ManagePartnerProductCategories$view = function (_v0) {
	var model = _v0;
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mb2, $author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$title,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Categories')
						])),
					A3(
					$author$project$Ui$Button$view,
					{mm: 'Add category'},
					_List_fromArray(
						[
							$author$project$Ui$Button$icon($author$project$Ui$Icon$add),
							$author$project$Ui$Button$onClick($author$project$Components$Partner$ManagePartnerProductCategories$Add)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Add Category')
						]))
				])),
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$gap2, $author$project$Ui$Element$wrap]),
			A2(
				$elm$core$List$map,
				function (cat) {
					return A3(
						$author$project$Ui$Button$view,
						{mm: 'Remove category'},
						_List_fromArray(
							[
								$author$project$Ui$Button$sm,
								$author$project$Ui$Button$onClick(
								$author$project$Components$Partner$ManagePartnerProductCategories$Remove(
									$author$project$Api$Partner$PartnerProductCategory$One$id(cat)))
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$inlineBlock, $author$project$Ui$Element$mr2]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Api$Partner$PartnerProductCategory$One$name(cat))
									])),
								$author$project$Ui$Icon$cross(
								_List_fromArray(
									[$author$project$Ui$Icon$xs]))
							]));
				},
				$author$project$Api$Partner$Partner$One$productCategories(model.YN)))
		]);
};
var $author$project$Components$Partner$ManagePartnerProductDataFlows$Add = {$: 0};
var $author$project$Components$Partner$ManagePartnerProductDataFlows$MoveDataFlow = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Components$DragDrop$Off = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$DragDrop$off = $author$project$Components$DragDrop$Off;
var $author$project$Components$DragDrop$OnDrop = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$DragDrop$onDrop = $author$project$Components$DragDrop$OnDrop;
var $author$project$Components$Partner$ManagePartnerProductDataFlows$Delete = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductDataFlows$Edit = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$DragDrop$DragEnded = {$: 1};
var $author$project$Components$DragDrop$DragStarted = function (a) {
	return {$: 0, a: a};
};
var $elm$html$Html$Attributes$draggable = _VirtualDom_attribute('draggable');
var $author$project$Components$DragDrop$draggable = F3(
	function (item, _v0, children) {
		var model = _v0;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$draggable('true'),
					$elm$html$Html$Attributes$class('drag-drop--draggable'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'drag-drop--dragging',
							_Utils_eq(
								model.nl,
								$elm$core$Maybe$Just(item)))
						])),
					A2(
					$elm$html$Html$Events$on,
					'dragstart',
					$elm$json$Json$Decode$succeed(
						model.al6(
							$author$project$Components$DragDrop$DragStarted(item)))),
					A2(
					$elm$html$Html$Events$on,
					'dragend',
					$elm$json$Json$Decode$succeed(
						model.al6($author$project$Components$DragDrop$DragEnded)))
				]),
			children);
	});
var $author$project$Ui$Icon$DragIndicator = 63;
var $author$project$Ui$Icon$dragIndicator = $author$project$Ui$Icon$viewIcon(63);
var $author$project$Components$DragDrop$indicator = A2(
	$elm$html$Html$span,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('drag-drop__indicator')
		]),
	_List_fromArray(
		[
			$author$project$Ui$Icon$dragIndicator(
			_List_fromArray(
				[$author$project$Ui$Icon$xl, $author$project$Ui$Icon$info]))
		]));
var $author$project$Ui$Icon$Package = 93;
var $author$project$Ui$Icon$package = $author$project$Ui$Icon$viewIcon(93);
var $author$project$Components$Partner$ManagePartnerProductDataFlows$viewProductDataFlow = F3(
	function (dragDrop, maybeIcon, productDataFlow) {
		var syncDirection = $author$project$Api$Partner$PartnerProductDataFlow$Shared$syncDirection(productDataFlow);
		var partnerName = $author$project$Api$Partner$PartnerProductDataFlow$Shared$partnerName(productDataFlow);
		var hintName = $author$project$Api$Partner$PartnerProductDataFlow$Shared$hintName(productDataFlow);
		return A3(
			$author$project$Components$DragDrop$draggable,
			productDataFlow,
			dragDrop,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_fromArray(
						[$author$project$Ui$Grid$rowItemsCenter, $author$project$Ui$Grid$mt2]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(5)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
									_List_fromArray(
										[
											$author$project$Components$DragDrop$indicator,
											function () {
											if (!maybeIcon.$) {
												var iconUrl = maybeIcon.a;
												return A3(
													$author$project$Ui$Image$fromSrc,
													{LD: 'icon'},
													iconUrl,
													_List_fromArray(
														[
															$author$project$Ui$Image$height(20)
														]));
											} else {
												return $author$project$Ui$Icon$package(
													_List_fromArray(
														[$author$project$Ui$Icon$xl]));
											}
										}(),
											$elm$html$Html$text(partnerName)
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(2)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$justifyCenter]),
									_List_fromArray(
										[
											function () {
											switch (syncDirection) {
												case 0:
													return $author$project$Ui$Icon$arrowLeft(_List_Nil);
												case 1:
													return $author$project$Ui$Icon$arrowRight(_List_Nil);
												default:
													return $author$project$Ui$Icon$transfer(
														_List_fromArray(
															[$author$project$Ui$Icon$xl]));
											}
										}()
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(5)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
											_List_fromArray(
												[
													$author$project$Ui$Icon$hintHeart(
													_List_fromArray(
														[$author$project$Ui$Icon$xl])),
													$elm$html$Html$text(hintName)
												])),
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$gap2]),
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Button$view,
													{mm: 'Edit synced field'},
													_List_fromArray(
														[
															$author$project$Ui$Button$sm,
															$author$project$Ui$Button$icon($author$project$Ui$Icon$edit),
															$author$project$Ui$Button$onClick(
															$author$project$Components$Partner$ManagePartnerProductDataFlows$Edit(productDataFlow))
														]),
													_List_Nil),
													A3(
													$author$project$Ui$Button$view,
													{mm: 'Delete synced field'},
													_List_fromArray(
														[
															$author$project$Ui$Button$danger,
															$author$project$Ui$Button$sm,
															$author$project$Ui$Button$icon($author$project$Ui$Icon$delete),
															$author$project$Ui$Button$onClick(
															$author$project$Components$Partner$ManagePartnerProductDataFlows$Delete(productDataFlow))
														]),
													_List_Nil)
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$DragDrop$DragEntered = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$DragDrop$applyZoneOption = F2(
	function (option, opts) {
		if (!option.$) {
			var predicate = option.a;
			return _Utils_update(
				opts,
				{
					BV: $elm$core$Maybe$Just(predicate)
				});
		} else {
			var handler = option.a;
			return _Utils_update(
				opts,
				{
					BX: $elm$core$Maybe$Just(handler)
				});
		}
	});
var $author$project$Components$DragDrop$defaultZoneOptions = {BV: $elm$core$Maybe$Nothing, BX: $elm$core$Maybe$Nothing};
var $author$project$Components$DragDrop$zone = F3(
	function (options, zoneId, _v0) {
		var model = _v0;
		var _v1 = model.nl;
		if (_v1.$ === 1) {
			return $elm$html$Html$text('');
		} else {
			var dragItem = _v1.a;
			var opts = A3($elm$core$List$foldl, $author$project$Components$DragDrop$applyZoneOption, $author$project$Components$DragDrop$defaultZoneOptions, options);
			var isOff = A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function (predicate) {
						return predicate(dragItem);
					},
					opts.BV));
			if (isOff) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('drag-drop__zone drag-drop__zone--idle')
						]),
					_List_Nil);
			} else {
				var _v2 = opts.BX;
				if (_v2.$ === 1) {
					return $elm$html$Html$text('');
				} else {
					var handler = _v2.a;
					var isHovered = _Utils_eq(
						model.sA,
						$elm$core$Maybe$Just(zoneId));
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('drag-drop__zone'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('drag-drop__zone--hovered', isHovered)
									])),
								A2(
								$elm$html$Html$Events$on,
								'dragenter',
								$elm$json$Json$Decode$succeed(
									model.al6(
										$author$project$Components$DragDrop$DragEntered(zoneId)))),
								A2(
								$elm$html$Html$Events$custom,
								'drop',
								$elm$json$Json$Decode$succeed(
									{
										aiH: A2(handler, dragItem, zoneId),
										akc: true,
										alJ: true
									}))
							]),
						_List_Nil);
				}
			}
		}
	});
var $author$project$Components$Partner$ManagePartnerProductDataFlows$view = function (_v0) {
	var model = _v0;
	var isNoOp = F2(
		function (zoneIdx, dataFlow) {
			var p = $author$project$Api$Partner$PartnerProductDataFlow$Shared$position(dataFlow);
			return _Utils_eq(zoneIdx, p - 1) || _Utils_eq(zoneIdx, p);
		});
	var viewZone = function (zoneIdx) {
		return A3(
			$author$project$Components$DragDrop$zone,
			_List_fromArray(
				[
					$author$project$Components$DragDrop$off(
					isNoOp(zoneIdx)),
					$author$project$Components$DragDrop$onDrop($author$project$Components$Partner$ManagePartnerProductDataFlows$MoveDataFlow)
				]),
			zoneIdx,
			model.nk);
	};
	var iconUrl = A2(
		$elm$core$Maybe$andThen,
		$author$project$Api$Partner$PartnerProduct$Shared$iconUrl,
		$author$project$Api$Partner$Partner$One$product(model.YN));
	var itemsWithZones = function (items) {
		return _Utils_ap(
			items,
			_List_fromArray(
				[
					viewZone(
					$elm$core$List$length(model.PA))
				]));
	}(
		$elm$core$List$concat(
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (i, d) {
						return _List_fromArray(
							[
								viewZone(i),
								A3($author$project$Components$Partner$ManagePartnerProductDataFlows$viewProductDataFlow, model.nk, iconUrl, d)
							]);
					}),
				model.PA)));
	return A3(
		$author$project$Ui$Element$custom,
		'card',
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
				_List_fromArray(
					[
						$author$project$Ui$Typography$headingSm(
						_List_fromArray(
							[
								$elm$html$Html$text('Data Syncing')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Add field'},
						_List_fromArray(
							[
								$author$project$Ui$Button$icon($author$project$Ui$Icon$add),
								$author$project$Ui$Button$onClick($author$project$Components$Partner$ManagePartnerProductDataFlows$Add)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Add Field')
							]))
					])),
				$author$project$Ui$HorizontalRule$view(
				_List_fromArray(
					[$author$project$Ui$HorizontalRule$thin])),
				A2($elm$html$Html$div, _List_Nil, itemsWithZones)
			]));
};
var $author$project$Components$Partner$ManagePartnerProductHighlights$Add = {$: 0};
var $author$project$Components$Partner$ManagePartnerProductHighlights$MoveHighlight = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Components$Partner$ManagePartnerProductHighlights$Delete = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductHighlights$Edit = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Image$ProductHighlightImagePlaceholder = 15;
var $author$project$Ui$Image$FullWidth = {$: 4};
var $author$project$Ui$Image$fullWidth = $author$project$Ui$Image$FullWidth;
var $author$project$Ui$Image$HeightAuto = function (a) {
	return {$: 6, a: a};
};
var $author$project$Ui$Image$heightAuto = $author$project$Ui$Image$HeightAuto(0);
var $author$project$Ui$Image$Rounded = {$: 5};
var $author$project$Ui$Image$rounded = $author$project$Ui$Image$Rounded;
var $author$project$Components$Partner$ManagePartnerProductHighlights$viewProductHighlight = F2(
	function (model, productHighlight) {
		var title = $author$project$Api$Partner$PartnerProductHighlight$Shared$title(productHighlight);
		var description = $author$project$Api$Partner$PartnerProductHighlight$Shared$description(productHighlight);
		return A3(
			$author$project$Components$DragDrop$draggable,
			productHighlight,
			model.nk,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(3)
								]),
							_List_fromArray(
								[
									function () {
									var _v0 = $author$project$Api$Partner$PartnerProductHighlight$Shared$imageUrl(productHighlight);
									if (!_v0.$) {
										var imageUrl = _v0.a;
										return A2(
											$author$project$Ui$Element$view,
											_List_Nil,
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Image$fromSrc,
													{LD: 'Highlight image'},
													imageUrl,
													_List_fromArray(
														[
															$author$project$Ui$Image$rounded,
															$author$project$Ui$Image$fullWidth,
															$author$project$Ui$Image$heightAuto,
															$author$project$Ui$Image$class('object-contain')
														]))
												]));
									} else {
										return A4(
											$author$project$Ui$Image$view,
											model.sF,
											{LD: title + ' image'},
											_List_fromArray(
												[
													$author$project$Ui$Image$rounded,
													$author$project$Ui$Image$fullWidth,
													$author$project$Ui$Image$heightAuto,
													$author$project$Ui$Image$class('aspect-[8/5] object-contain')
												]),
											15);
									}
								}()
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(9)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$fullWidth]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
													_List_fromArray(
														[
															$author$project$Components$DragDrop$indicator,
															$author$project$Ui$Typography$headingSm(
															_List_fromArray(
																[
																	$elm$html$Html$text(title)
																]))
														])),
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$gap2]),
													_List_fromArray(
														[
															A3(
															$author$project$Ui$Button$view,
															{mm: 'Edit highlight'},
															_List_fromArray(
																[
																	$author$project$Ui$Button$sm,
																	$author$project$Ui$Button$icon($author$project$Ui$Icon$edit),
																	$author$project$Ui$Button$onClick(
																	$author$project$Components$Partner$ManagePartnerProductHighlights$Edit(productHighlight))
																]),
															_List_Nil),
															A3(
															$author$project$Ui$Button$view,
															{mm: 'Delete highlight'},
															_List_fromArray(
																[
																	$author$project$Ui$Button$danger,
																	$author$project$Ui$Button$sm,
																	$author$project$Ui$Button$icon($author$project$Ui$Icon$delete),
																	$author$project$Ui$Button$onClick(
																	$author$project$Components$Partner$ManagePartnerProductHighlights$Delete(productHighlight))
																]),
															_List_Nil)
														]))
												])),
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$mt4]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$map,
													$elm$core$Basics$never,
													A2(
														$author$project$Ui$Typography$p,
														_List_fromArray(
															[$author$project$Ui$Typography$preWrap, $author$project$Ui$Typography$muted]),
														$author$project$Utils$Html$ulFromString(description)))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Partner$ManagePartnerProductHighlights$view = function (_v0) {
	var model = _v0;
	var productHighlights = model.Tu;
	var isNoOp = F2(
		function (zoneIdx, highlight) {
			var p = $author$project$Api$Partner$PartnerProductHighlight$Shared$position(highlight);
			return _Utils_eq(zoneIdx, p - 1) || _Utils_eq(zoneIdx, p);
		});
	var viewZone = function (zoneIdx) {
		return A3(
			$author$project$Components$DragDrop$zone,
			_List_fromArray(
				[
					$author$project$Components$DragDrop$off(
					isNoOp(zoneIdx)),
					$author$project$Components$DragDrop$onDrop($author$project$Components$Partner$ManagePartnerProductHighlights$MoveHighlight)
				]),
			zoneIdx,
			model.nk);
	};
	var itemsWithZones = function (items) {
		return _Utils_ap(
			items,
			_List_fromArray(
				[
					viewZone(
					$elm$core$List$length(productHighlights))
				]));
	}(
		$elm$core$List$concat(
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (i, h) {
						return _List_fromArray(
							[
								viewZone(i),
								A2($author$project$Components$Partner$ManagePartnerProductHighlights$viewProductHighlight, model, h)
							]);
					}),
				productHighlights)));
	return A3(
		$author$project$Ui$Element$custom,
		'card',
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
						_List_fromArray(
							[
								$author$project$Ui$Typography$headingSm(
								_List_fromArray(
									[
										$elm$html$Html$text('Highlights')
									])),
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Add highlight'},
								_List_fromArray(
									[
										$author$project$Ui$Button$icon($author$project$Ui$Icon$add),
										$author$project$Ui$Button$onClick($author$project$Components$Partner$ManagePartnerProductHighlights$Add)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Add Highlight')
									]))
							])),
						$author$project$Ui$HorizontalRule$view(
						_List_fromArray(
							[$author$project$Ui$HorizontalRule$thin])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mt4, $author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap4]),
						itemsWithZones)
					]))
			]));
};
var $author$project$Components$Partner$ManagePartnerProductLinks$Add = {$: 0};
var $author$project$Components$Partner$ManagePartnerProductLinks$MoveLink = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Components$Partner$ManagePartnerProductLinks$Delete = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductLinks$Edit = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Icon$Call = 94;
var $author$project$Ui$Icon$call = $author$project$Ui$Icon$viewIcon(94);
var $author$project$Api$Partner$PartnerProductLink$Shared$composedUrl = function (_v0) {
	var record = _v0;
	return record.Oq;
};
var $author$project$Ui$Link$Tabindex = function (a) {
	return {$: 17, a: a};
};
var $author$project$Ui$Link$preventFocus = $author$project$Ui$Link$Tabindex(-1);
var $author$project$Ui$Link$Tel = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Link$tel = F3(
	function (tel_, options, content) {
		return A2(
			$author$project$Ui$Link$view,
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Link$Tel(tel_),
				options),
			content);
	});
var $author$project$Components$Partner$ManagePartnerProductLinks$viewProductLink = F2(
	function (dragDrop, productLink) {
		var value = $author$project$Api$Partner$PartnerProductLink$Shared$value(productLink);
		var title = $author$project$Api$Partner$PartnerProductLink$Shared$title(productLink);
		var linkType = $author$project$Api$Partner$PartnerProductLink$Shared$linkType(productLink);
		return A3(
			$author$project$Components$DragDrop$draggable,
			productLink,
			dragDrop,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mt2, $author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									$author$project$Components$DragDrop$indicator,
									function () {
									switch (linkType) {
										case 0:
											var href = A2(
												$elm$core$Maybe$withDefault,
												value,
												$author$project$Api$Partner$PartnerProductLink$Shared$composedUrl(productLink));
											return A3(
												$author$project$Ui$Link$externalHref,
												href,
												_List_fromArray(
													[
														$author$project$Ui$Link$icon($author$project$Ui$Icon$launch),
														$author$project$Ui$Link$preventFocus,
														$author$project$Ui$Link$targetBlank
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(title)
													]));
										case 1:
											return A3(
												$author$project$Ui$Link$mailto,
												value,
												_List_fromArray(
													[
														$author$project$Ui$Link$icon($author$project$Ui$Icon$mail),
														$author$project$Ui$Link$preventFocus
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(title)
													]));
										default:
											return A3(
												$author$project$Ui$Link$tel,
												value,
												_List_fromArray(
													[
														$author$project$Ui$Link$icon($author$project$Ui$Icon$call),
														$author$project$Ui$Link$preventFocus
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(title)
													]));
									}
								}()
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Edit link'},
									_List_fromArray(
										[
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$icon($author$project$Ui$Icon$edit),
											$author$project$Ui$Button$onClick(
											$author$project$Components$Partner$ManagePartnerProductLinks$Edit(productLink))
										]),
									_List_Nil),
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Delete link'},
									_List_fromArray(
										[
											$author$project$Ui$Button$danger,
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$icon($author$project$Ui$Icon$delete),
											$author$project$Ui$Button$onClick(
											$author$project$Components$Partner$ManagePartnerProductLinks$Delete(productLink))
										]),
									_List_Nil)
								]))
						]))
				]));
	});
var $author$project$Components$Partner$ManagePartnerProductLinks$view = function (_v0) {
	var model = _v0;
	var isNoOp = F2(
		function (zoneIdx, link) {
			var p = $author$project$Api$Partner$PartnerProductLink$Shared$position(link);
			return _Utils_eq(zoneIdx, p - 1) || _Utils_eq(zoneIdx, p);
		});
	var viewZone = function (zoneIdx) {
		return A3(
			$author$project$Components$DragDrop$zone,
			_List_fromArray(
				[
					$author$project$Components$DragDrop$off(
					isNoOp(zoneIdx)),
					$author$project$Components$DragDrop$onDrop($author$project$Components$Partner$ManagePartnerProductLinks$MoveLink)
				]),
			zoneIdx,
			model.nk);
	};
	var itemsWithZones = function (items) {
		return _Utils_ap(
			items,
			_List_fromArray(
				[
					viewZone(
					$elm$core$List$length(model.V5))
				]));
	}(
		$elm$core$List$concat(
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (i, l) {
						return _List_fromArray(
							[
								viewZone(i),
								A2($author$project$Components$Partner$ManagePartnerProductLinks$viewProductLink, model.nk, l)
							]);
					}),
				model.V5)));
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('Learn More & Support')
								])),
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Add link'},
							_List_fromArray(
								[
									$author$project$Ui$Button$icon($author$project$Ui$Icon$add),
									$author$project$Ui$Button$onClick($author$project$Components$Partner$ManagePartnerProductLinks$Add)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Add Link')
								]))
						])),
				A2(
					$elm$core$List$cons,
					$author$project$Ui$HorizontalRule$view(
						_List_fromArray(
							[$author$project$Ui$HorizontalRule$thin])),
					itemsWithZones)))
		]);
};
var $author$project$Components$Partner$ManagePartnerProductQuotes$Add = {$: 0};
var $author$project$Api$Partner$Partner$One$productQuotes = function (_v0) {
	var record = _v0.b;
	return record._z;
};
var $author$project$Components$Partner$ManagePartnerProductQuotes$Delete = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductQuotes$Edit = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Icon$Quote = 103;
var $author$project$Components$Partner$ManagePartnerProductQuotes$viewProductQuote = F2(
	function (model, productQuote) {
		var text_ = $author$project$Api$Partner$PartnerProductQuote$Shared$text(productQuote);
		var authorTitle = $author$project$Api$Partner$PartnerProductQuote$Shared$authorTitle(productQuote);
		var author = $author$project$Api$Partner$PartnerProductQuote$Shared$author(productQuote);
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mt4]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap4]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Icon$view,
									_List_fromArray(
										[
											$author$project$Ui$Icon$width('50px'),
											$author$project$Ui$Icon$class('icon--primary')
										]),
									103)
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$fullWidth]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
									_List_fromArray(
										[
											$author$project$Ui$Typography$headingSm(
											_List_fromArray(
												[
													$elm$html$Html$text(text_)
												])),
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$gap2]),
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Button$view,
													{mm: 'Edit quote'},
													_List_fromArray(
														[
															$author$project$Ui$Button$sm,
															$author$project$Ui$Button$icon($author$project$Ui$Icon$edit),
															$author$project$Ui$Button$onClick(
															$author$project$Components$Partner$ManagePartnerProductQuotes$Edit(productQuote))
														]),
													_List_Nil),
													A3(
													$author$project$Ui$Button$view,
													{mm: 'Delete quote'},
													_List_fromArray(
														[
															$author$project$Ui$Button$danger,
															$author$project$Ui$Button$sm,
															$author$project$Ui$Button$icon($author$project$Ui$Icon$delete),
															$author$project$Ui$Button$onClick(
															$author$project$Components$Partner$ManagePartnerProductQuotes$Delete(productQuote))
														]),
													_List_Nil)
												]))
										])),
									$author$project$Ui$HorizontalRule$view(
									_List_fromArray(
										[$author$project$Ui$HorizontalRule$thin])),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$mt4]),
									_List_fromArray(
										[
											function () {
											var _v0 = $author$project$Api$Partner$PartnerProductQuote$Shared$authorImageUrl(productQuote);
											if (!_v0.$) {
												var imageUrl = _v0.a;
												return A3(
													$author$project$Ui$Image$fromSrc,
													{LD: author + ' image'},
													imageUrl,
													_List_fromArray(
														[
															$author$project$Ui$Image$rounded,
															$author$project$Ui$Image$height(100),
															$author$project$Ui$Image$width(100)
														]));
											} else {
												return A4(
													$author$project$Ui$Image$view,
													model.sF,
													{LD: author + ' image'},
													_List_fromArray(
														[$author$project$Ui$Image$fullWidth]),
													15);
											}
										}(),
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$inlineBlock, $author$project$Ui$Element$ml2]),
											_List_fromArray(
												[
													$elm$html$Html$text(author),
													A2($elm$html$Html$br, _List_Nil, _List_Nil),
													A2(
													$author$project$Ui$Typography$text,
													_List_fromArray(
														[$author$project$Ui$Typography$muted]),
													authorTitle)
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Partner$ManagePartnerProductQuotes$view = function (_v0) {
	var model = _v0;
	var productQuotes = $author$project$Api$Partner$Partner$One$productQuotes(model.YN);
	return A3(
		$author$project$Ui$Element$custom,
		'card',
		_List_fromArray(
			[$author$project$Ui$Element$mt4]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
						_List_fromArray(
							[
								$author$project$Ui$Typography$headingSm(
								_List_fromArray(
									[
										$elm$html$Html$text('Quotes')
									])),
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Add quote'},
								_List_fromArray(
									[
										$author$project$Ui$Button$icon($author$project$Ui$Icon$add),
										$author$project$Ui$Button$onClick($author$project$Components$Partner$ManagePartnerProductQuotes$Add)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Add Quote')
									]))
							])),
						$author$project$Ui$HorizontalRule$view(
						_List_fromArray(
							[$author$project$Ui$HorizontalRule$thin])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mt4]),
						A2(
							$elm$core$List$map,
							$author$project$Components$Partner$ManagePartnerProductQuotes$viewProductQuote(model),
							productQuotes))
					]))
			]));
};
var $author$project$Pages$Partner$Products$Id_String$viewDeleteConfirmModal = function (model) {
	var _v0 = model.ga;
	if (!_v0.$) {
		return A2(
			$author$project$Components$HiConfirm$modal,
			$author$project$Pages$Partner$Products$Id_String$DeleteConfirmClosed,
			_List_fromArray(
				[
					$author$project$Components$HiConfirm$verb('delete'),
					$author$project$Components$HiConfirm$noun('image'),
					$author$project$Components$HiConfirm$loading(model.V8)
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Partner$Products$Id_String$IconUploaded = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$ProductOverviewDescription = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Partner$ProductIconInstructions$view = A2(
	$author$project$Ui$Element$view,
	_List_fromArray(
		[$author$project$Ui$Element$gap2, $author$project$Ui$Element$flexCol]),
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Preferred format: SVG (vector)')
				])),
			A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Aspect ratio: 1:1 (square)')
				])),
			A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('PNG fallback: 800×800 px recommended, transparent background')
				])),
			A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Content: Icon or symbol only — no text or wordmarks')
				])),
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$textMuted]),
			_List_fromArray(
				[
					$elm$html$Html$text('This icon is designed for dense UI areas where clarity at small sizes is important.')
				]))
		]));
var $author$project$Pages$Partner$Products$Id_String$viewEditModalInput = function (form) {
	var field = $author$project$Utils$Form$fields(form);
	var formGroupOptions = A2(
		$elm$core$List$cons,
		$author$project$Ui$Form$Group$labelSpanSm(4),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$Form$Group$inputSpanSm(8),
			function () {
				switch (field.$) {
					case 0:
						return _List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Name'),
								$author$project$Ui$Form$Group$required(true)
							]);
					case 1:
						return _List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Summary')
							]);
					case 3:
						return _List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Product overview')
							]);
					case 5:
						return _List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Built by')
							]);
					case 2:
						return _List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Icon')
							]);
					default:
						return _List_Nil;
				}
			}()));
	return A2(
		$author$project$Ui$Form$Group$view,
		formGroupOptions,
		function () {
			switch (field.$) {
				case 0:
					var name = field.a;
					return _List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(name),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeR, $author$project$Pages$Partner$Products$Id_String$Name, $author$project$Pages$Partner$Products$Id_String$Edited)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 0, form))
								]))
						]);
				case 1:
					var description = field.a;
					return _List_fromArray(
						[
							$author$project$Ui$Form$Textarea$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Textarea$value(description),
									$author$project$Ui$Form$Textarea$onInput(
									A2($elm$core$Basics$composeR, $author$project$Pages$Partner$Products$Id_String$ProductDescription, $author$project$Pages$Partner$Products$Id_String$Edited))
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$mt2, $author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
							_List_fromArray(
								[
									$elm$html$Html$text('One sentence that describes your product without repeating the product name shown above.')
								]))
						]);
				case 3:
					var description = field.a;
					return _List_fromArray(
						[
							$author$project$Ui$Form$Textarea$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Textarea$value(description),
									$author$project$Ui$Form$Textarea$onInput(
									A2($elm$core$Basics$composeR, $author$project$Pages$Partner$Products$Id_String$ProductOverviewDescription, $author$project$Pages$Partner$Products$Id_String$Edited))
								]))
						]);
				case 5:
					var maybeName = field.a;
					var maybeUrl = field.b;
					return _List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$gap2, $author$project$Ui$Element$flexCol]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$label('Name')
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$value(
													A2($elm$core$Maybe$withDefault, '', maybeName)),
													$author$project$Ui$Form$Input$onInput(
													function (name) {
														return $author$project$Pages$Partner$Products$Id_String$Edited(
															A2(
																$author$project$Pages$Partner$Products$Id_String$Attribution,
																$author$project$Utils$Maybe$fromString(name),
																maybeUrl));
													}),
													$author$project$Ui$Form$Input$placeholder('Example')
												]))
										])),
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$label('URL')
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$value(
													A2($elm$core$Maybe$withDefault, '', maybeUrl)),
													$author$project$Ui$Form$Input$onInput(
													function (url) {
														return $author$project$Pages$Partner$Products$Id_String$Edited(
															A2(
																$author$project$Pages$Partner$Products$Id_String$Attribution,
																maybeName,
																$author$project$Utils$Maybe$fromString(url)));
													}),
													$author$project$Ui$Form$Input$placeholder('https://example.com')
												]))
										]))
								]))
						]);
				case 2:
					return _List_fromArray(
						[
							$author$project$Ui$Form$Group$static(
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$gap4, $author$project$Ui$Element$flexCol]),
									_List_fromArray(
										[
											$author$project$Components$Partner$ProductIconInstructions$view,
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$flexCol]),
											_List_fromArray(
												[
													$author$project$Ui$Form$File$view(
													_List_fromArray(
														[
															$author$project$Ui$Form$File$onInput($author$project$Pages$Partner$Products$Id_String$IconUploaded)
														])),
													$author$project$Utils$FormErrors$view(
													A2($author$project$Utils$Form$validationErrors, 1, form))
												]))
										]))
								]))
						]);
				default:
					return _List_Nil;
			}
		}());
};
var $author$project$Pages$Partner$Products$Id_String$viewEditModal = function (model) {
	var _v0 = model.C;
	if (!_v0.$) {
		var form = _v0.a;
		var field = $author$project$Utils$Form$fields(form);
		var saveDisabled = function () {
			if (field.$ === 2) {
				var maybeIcon = field.a;
				return A2(
					$elm$core$Maybe$withDefault,
					true,
					A2(
						$elm$core$Maybe$map,
						$elm$core$Basics$always(false),
						maybeIcon));
			} else {
				return false;
			}
		}();
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Pages$Partner$Products$Id_String$CancelEdit,
			_List_fromArray(
				[
					$author$project$Ui$Modal$onSubmit(
					$author$project$Pages$Partner$Products$Id_String$Saved(form))
				]),
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('Editing Product')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							$author$project$Pages$Partner$Products$Id_String$viewEditModalInput(form)
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Cancel'},
							_List_fromArray(
								[
									$author$project$Ui$Button$default,
									$author$project$Ui$Button$onClick($author$project$Pages$Partner$Products$Id_String$CancelEdit)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Save product changes'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$submit,
									$author$project$Ui$Button$disabled(saveDisabled)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Save')
								]))
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Partner$Products$Id_String$SaveExternalCta = {$: 22};
var $author$project$Components$Partner$ExternalCtaForm$CampaignChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$ExternalCtaForm$ContentChanged = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$ExternalCtaForm$CopyClicked = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Partner$ExternalCtaForm$UrlChanged = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$ExternalCtaForm$view = function (_v0) {
	var model = _v0;
	var fields = model.ahi;
	var fieldOpts = function (label) {
		return _List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(4),
				$author$project$Ui$Form$Group$inputSpanSm(8),
				$author$project$Ui$Form$Group$label(label)
			]);
	};
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$gap2, $author$project$Ui$Element$flexCol]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_Utils_ap(
					fieldOpts('CTA URL'),
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$required(true)
						])),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(fields.adY),
								$author$project$Ui$Form$Input$onInput($author$project$Components$Partner$ExternalCtaForm$UrlChanged),
								$author$project$Ui$Form$Input$placeholder('https://partner.example.com/signup'),
								$author$project$Ui$Form$Input$invalid(
								!$elm$core$List$isEmpty(model.qW)),
								$author$project$Ui$Form$Input$errors(model.qW)
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				fieldOpts('Campaign'),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(fields.aea),
								$author$project$Ui$Form$Input$onInput($author$project$Components$Partner$ExternalCtaForm$CampaignChanged),
								$author$project$Ui$Form$Input$placeholder('hint_marketplace')
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mt1, $author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
						_List_fromArray(
							[
								$elm$html$Html$text('Defaults to \"hint_marketplace\" if left blank. Used as utm_campaign.')
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				fieldOpts('Content'),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(fields.aeb),
								$author$project$Ui$Form$Input$onInput($author$project$Components$Partner$ExternalCtaForm$ContentChanged),
								$author$project$Ui$Form$Input$placeholder('Optional')
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mt1, $author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
						_List_fromArray(
							[
								$elm$html$Html$text('Optional. Used as utm_content to differentiate placements.')
							]))
					])),
				A2($author$project$Components$Partner$UtmLinkPreview$view, fields, $author$project$Components$Partner$ExternalCtaForm$CopyClicked)
			]));
};
var $author$project$Pages$Partner$Products$Id_String$viewExternalCtaModal = function (model) {
	var _v0 = model.dc;
	if (!_v0.$) {
		var ctaForm = _v0.a;
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Pages$Partner$Products$Id_String$CancelExternalCtaEdit,
			_List_fromArray(
				[
					$author$project$Ui$Modal$onSubmit($author$project$Pages$Partner$Products$Id_String$SaveExternalCta)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('Editing Product')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Pages$Partner$Products$Id_String$ExternalCtaFormMsg,
							$author$project$Components$Partner$ExternalCtaForm$view(ctaForm))
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Cancel'},
							_List_fromArray(
								[
									$author$project$Ui$Button$default,
									$author$project$Ui$Button$onClick($author$project$Pages$Partner$Products$Id_String$CancelExternalCtaEdit)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Save product changes'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$submit,
									$author$project$Ui$Button$loading(model.V8)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Save')
								]))
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Partner$Products$Id_String$OpenGenerateListingModal = {$: 24};
var $author$project$Pages$Partner$Products$Id_String$ProductOverviewImageDeleted = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$ProductOverviewImagesUploaded = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Carousel$AspectVideo = {$: 2};
var $author$project$Components$Carousel$aspectVideo = $author$project$Components$Carousel$AspectVideo;
var $author$project$Ui$Link$ButtonWarning = 5;
var $author$project$Ui$Link$buttonWarning = $author$project$Ui$Link$Style(5);
var $author$project$Api$Partner$PartnerProductOverview$Shared$description = function (_v0) {
	var record = _v0;
	return record.Qr;
};
var $author$project$Components$Carousel$Expand = {$: 3};
var $author$project$Components$Carousel$expand = $author$project$Components$Carousel$Expand;
var $author$project$Ui$Form$File$Key = function (a) {
	return {$: 8, a: a};
};
var $author$project$Ui$Form$File$key = $author$project$Ui$Form$File$Key;
var $author$project$Components$Carousel$OverlayAction = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Carousel$overlay = $author$project$Components$Carousel$OverlayAction;
var $author$project$Components$Carousel$Image = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Carousel$image = F3(
	function (id, src, alt) {
		return $author$project$Components$Carousel$Image(
			{LD: alt, ahP: id, uN: src});
	});
var $author$project$Api$Partner$ProductImage$Shared$url = function (_v0) {
	var record = _v0;
	return record.adY;
};
var $author$project$Pages$Partner$Products$Id_String$productImageToCarouselImage = function (productImage) {
	return A3(
		$author$project$Components$Carousel$image,
		$author$project$Api$Partner$ProductImage$Shared$id(productImage),
		A2(
			$elm$core$Maybe$withDefault,
			'',
			$author$project$Api$Partner$ProductImage$Shared$url(productImage)),
		$author$project$Api$Partner$ProductImage$Shared$alt(productImage));
};
var $author$project$Components$Carousel$Thumbnails = {$: 0};
var $author$project$Components$Carousel$thumbnails = $author$project$Components$Carousel$Thumbnails;
var $author$project$Components$Carousel$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, acc) {
				switch (option.$) {
					case 0:
						return _Utils_update(
							acc,
							{FO: true});
					case 1:
						var action = option.a;
						return _Utils_update(
							acc,
							{
								Cl: $elm$core$Maybe$Just(action)
							});
					case 2:
						return _Utils_update(
							acc,
							{xp: true});
					default:
						return _Utils_update(
							acc,
							{HE: true});
				}
			}),
		{xp: false, HE: false, Cl: $elm$core$Maybe$Nothing, FO: false},
		options);
};
var $author$project$Components$Carousel$JumpTo = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Carousel$boolToString = function (bool) {
	return bool ? 'true' : 'false';
};
var $author$project$Ui$Icon$OpenInFull = 19;
var $author$project$Ui$Icon$openInFull = $author$project$Ui$Icon$viewIcon(19);
var $author$project$Components$Carousel$viewImage = function (img) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('carousel__image')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$img,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$src(img.uN),
						$elm$html$Html$Attributes$alt(''),
						$elm$html$Html$Attributes$class('carousel__image__bg')
					]),
				_List_Nil),
				A3(
				$author$project$Ui$Image$fromSrc,
				{LD: img.LD},
				img.uN,
				_List_Nil)
			]));
};
var $author$project$Components$Carousel$viewItem = function (item) {
	if (!item.$) {
		var img = item.a;
		return $author$project$Components$Carousel$viewImage(img);
	} else {
		var content = item.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('carousel__image')
				]),
			_List_fromArray(
				[
					A2($elm$html$Html$map, $elm$core$Basics$never, content)
				]));
	}
};
var $author$project$Components$Carousel$viewCarousel = F6(
	function (optionsRecord, index, toMsg, items, isFullscreen, expanded) {
		var itemsCount = $elm$core$List$length(items);
		var nextIndex = A2($elm$core$Basics$modBy, itemsCount, index + 1);
		var prevIndex = A2($elm$core$Basics$modBy, itemsCount, index - 1);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('carousel'),
					A2(
					$elm$html$Html$Attributes$attribute,
					'style',
					'--carousel-index:' + $elm$core$String$fromInt(index)),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('aspect-video', optionsRecord.xp && (!isFullscreen)),
							_Utils_Tuple2('carousel--fullscreen-inner', isFullscreen)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					toMsg,
					A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$Components$Carousel$JumpTo(prevIndex)),
								$elm$html$Html$Attributes$class('carousel__control carousel__control--left'),
								A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Previous')
							]),
						_List_fromArray(
							[
								$author$project$Ui$Icon$chevron(
								_List_fromArray(
									[$author$project$Ui$Icon$rotate180]))
							]))),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('carousel__track')
						]),
					A2($elm$core$List$map, $author$project$Components$Carousel$viewItem, items)),
					A2(
					$elm$html$Html$map,
					toMsg,
					A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$Components$Carousel$JumpTo(nextIndex)),
								$elm$html$Html$Attributes$class('carousel__control carousel__control--right'),
								A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Next')
							]),
						_List_fromArray(
							[
								$author$project$Ui$Icon$chevron(_List_Nil)
							]))),
					function () {
					var itemId = A2(
						$elm$core$Maybe$map,
						function (item) {
							if (!item.$) {
								var img = item.a;
								return img.ahP;
							} else {
								var id = item.a;
								return id;
							}
						},
						A2(
							$elm$core$Array$get,
							index,
							$elm$core$Array$fromList(items)));
					var overlayItems = A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								function () {
								var _v0 = _Utils_Tuple2(optionsRecord.Cl, itemId);
								if ((!_v0.a.$) && (!_v0.b.$)) {
									var action = _v0.a.a;
									var itemId_ = _v0.b.a;
									return $elm$core$Maybe$Just(
										action(itemId_));
								} else {
									return $elm$core$Maybe$Nothing;
								}
							}(),
								(optionsRecord.HE && (!isFullscreen)) ? $elm$core$Maybe$Just(
								A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											toMsg($author$project$Components$Carousel$ToggleExpanded)),
											$elm$html$Html$Attributes$class('carousel__expand'),
											A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Expand'),
											A2(
											$elm$html$Html$Attributes$attribute,
											'aria-expanded',
											$author$project$Components$Carousel$boolToString(expanded))
										]),
									_List_fromArray(
										[
											$author$project$Ui$Icon$openInFull(_List_Nil)
										]))) : $elm$core$Maybe$Nothing,
								isFullscreen ? $elm$core$Maybe$Just(
								A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											toMsg($author$project$Components$Carousel$ToggleExpanded)),
											$elm$html$Html$Attributes$class('carousel__fullscreen__close'),
											A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Close')
										]),
									_List_fromArray(
										[
											$author$project$Ui$Icon$cross(_List_Nil)
										]))) : $elm$core$Maybe$Nothing
							]));
					return $elm$core$List$isEmpty(overlayItems) ? $elm$html$Html$text('') : A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('carousel__overlay')
							]),
						overlayItems);
				}()
				]));
	});
var $author$project$Components$Carousel$viewImageThumb = function (img) {
	return A3(
		$author$project$Ui$Image$fromSrc,
		{LD: img.LD},
		img.uN,
		_List_fromArray(
			[
				$author$project$Ui$Image$class('rounded'),
				$author$project$Ui$Image$width(68),
				$author$project$Ui$Image$height(68)
			]));
};
var $author$project$Components$Carousel$viewThumb = F4(
	function (itemsCount, selectedIndex, index, item) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('carousel__thumbnail-button'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'carousel__thumbnail-button--active',
							_Utils_eq(index, selectedIndex))
						])),
					$elm$html$Html$Events$onClick(
					$author$project$Components$Carousel$JumpTo(
						A2($elm$core$Basics$modBy, itemsCount, index)))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$elm$core$Basics$never,
					function () {
						if (!item.$) {
							var img = item.a;
							return $author$project$Components$Carousel$viewImageThumb(img);
						} else {
							var content = item.b;
							return content;
						}
					}())
				]));
	});
var $author$project$Components$Carousel$viewFullscreen = F4(
	function (optionsRecord, index, toMsg, items) {
		return A3(
			$elm$html$Html$node,
			'elm-modal',
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('elm-modal show carousel__fullscreen'),
					$elm$html$Html$Attributes$tabindex(-1),
					A2($elm$html$Html$Attributes$attribute, 'role', 'dialog'),
					A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Image gallery')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('carousel__fullscreen__inner')
						]),
					_List_fromArray(
						[
							A6($author$project$Components$Carousel$viewCarousel, optionsRecord, index, toMsg, items, true, true),
							optionsRecord.FO ? A2(
							$elm$html$Html$map,
							toMsg,
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('carousel__thumbnails carousel__fullscreen__thumbnails')
									]),
								A2(
									$elm$core$List$indexedMap,
									A2(
										$author$project$Components$Carousel$viewThumb,
										$elm$core$List$length(items),
										index),
									items))) : $elm$html$Html$text('')
						]))
				]));
	});
var $author$project$Components$Carousel$view = F3(
	function (options, _v0, items) {
		var index = _v0.sG;
		var toMsg = _v0.al6;
		var expanded = _v0.nB;
		if ($elm$core$List$isEmpty(items)) {
			return $elm$html$Html$text('');
		} else {
			var optionsRecord = $author$project$Components$Carousel$optionsToRecord(options);
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A6($author$project$Components$Carousel$viewCarousel, optionsRecord, index, toMsg, items, false, expanded),
						expanded ? A4($author$project$Components$Carousel$viewFullscreen, optionsRecord, index, toMsg, items) : $elm$html$Html$text('')
					]));
		}
	});
var $author$project$Ui$Form$File$SrOnly = {$: 6};
var $author$project$Ui$Form$File$viewWithContent = F2(
	function (options, content) {
		var optionsRecord = $author$project$Ui$Form$File$optionsToRecord(options);
		return A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('cursor-pointer m-0'),
					$elm$html$Html$Attributes$tabindex(0),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('inline-edit inline-edit--overlay', optionsRecord.sI)
						])),
					A2($elm$html$Html$Attributes$style, 'overflow', 'auto')
				]),
			_List_fromArray(
				[
					A2($elm$html$Html$map, $elm$core$Basics$never, content),
					$author$project$Ui$Form$File$view(
					A2($elm$core$List$cons, $author$project$Ui$Form$File$SrOnly, options)),
					optionsRecord.sI ? $author$project$Ui$Icon$edit(
					_List_fromArray(
						[$author$project$Ui$Icon$xs])) : $elm$html$Html$text('')
				]));
	});
var $author$project$Ui$Icon$WandStars = 113;
var $author$project$Ui$Icon$wandStars = $author$project$Ui$Icon$viewIcon(113);
var $author$project$Pages$Partner$Products$Id_String$viewProductOverview = function (model) {
	var carousel = model.mH;
	var fileKey = model.so;
	var loading = model.V8;
	var partner = model.YN;
	var productOverviewDescription = A2(
		$elm$core$Maybe$andThen,
		$author$project$Api$Partner$PartnerProductOverview$Shared$description,
		$author$project$Api$Partner$Partner$One$productOverview(partner));
	var deleteButton = function (imageId) {
		return A3(
			$author$project$Ui$Button$view,
			{mm: 'Delete image'},
			_List_fromArray(
				[
					$author$project$Ui$Button$danger,
					$author$project$Ui$Button$icon($author$project$Ui$Icon$delete),
					$author$project$Ui$Button$onClick(
					$author$project$Pages$Partner$Products$Id_String$ProductOverviewImageDeleted(imageId))
				]),
			_List_Nil);
	};
	var customElementClasses = 'button button--default [&>*:first-child]:mt-0' + (loading ? 'button--disabled' : '');
	var carouselItems = A2(
		$elm$core$List$map,
		$author$project$Pages$Partner$Products$Id_String$productImageToCarouselImage,
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Partner$PartnerProductOverview$Shared$images,
				$author$project$Api$Partner$Partner$One$productOverview(partner))));
	return A2(
		$author$project$Ui$Card$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$spaceBetween]),
						_List_fromArray(
							[
								$author$project$Ui$Typography$headingSm(
								_List_fromArray(
									[
										$elm$html$Html$text('Overview')
									])),
								function () {
								var _v0 = model._s;
								if (_v0.$ === 3) {
									var product = _v0.a;
									return A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap2]),
										_List_fromArray(
											[
												model.Ij ? A3(
												$author$project$Ui$Button$view,
												{mm: 'Generate listing draft from URL'},
												_List_fromArray(
													[
														$author$project$Ui$Button$sm,
														$author$project$Ui$Button$primary,
														$author$project$Ui$Button$icon($author$project$Ui$Icon$wandStars),
														$author$project$Ui$Button$onClick($author$project$Pages$Partner$Products$Id_String$OpenGenerateListingModal)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Generate from URL')
													])) : $elm$html$Html$text(''),
												A3(
												$author$project$Ui$Link$route,
												$author$project$Spa$Generated$Route$Marketplace__Slug_String(
													{
														abG: $author$project$Api$Partner$PartnerProduct$One$slug(product)
													}),
												_List_fromArray(
													[$author$project$Ui$Link$buttonWarning, $author$project$Ui$Link$targetBlank]),
												_List_fromArray(
													[
														$elm$html$Html$text('View in Marketplace')
													]))
											]));
								} else {
									return $elm$html$Html$text('');
								}
							}()
							])),
						$author$project$Ui$HorizontalRule$view(
						_List_fromArray(
							[$author$project$Ui$HorizontalRule$thin])),
						A3(
						$author$project$Components$Carousel$view,
						_List_fromArray(
							[
								$author$project$Components$Carousel$thumbnails,
								$author$project$Components$Carousel$overlay(deleteButton),
								$author$project$Components$Carousel$aspectVideo,
								$author$project$Components$Carousel$expand
							]),
						carousel,
						carouselItems),
						A2(
						$author$project$Ui$Element$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$File$viewWithContent,
								_List_fromArray(
									[
										$author$project$Ui$Form$File$disabled(loading),
										$author$project$Ui$Form$File$key(
										$elm$core$String$fromInt(fileKey)),
										$author$project$Ui$Form$File$onInput($author$project$Pages$Partner$Products$Id_String$ProductOverviewImagesUploaded)
									]),
								A3(
									$author$project$Ui$Element$custom,
									customElementClasses,
									_List_fromArray(
										[$author$project$Ui$Element$gap2, $author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mt4]),
									_List_fromArray(
										[
											$author$project$Ui$Icon$upload(_List_Nil),
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Upload content')
												]))
										])))
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mt4]),
						_List_fromArray(
							[
								A2(
								$author$project$Pages$Partner$Products$Id_String$viewInlineEdit,
								$author$project$Pages$Partner$Products$Id_String$Edit(
									$author$project$Pages$Partner$Products$Id_String$ProductOverviewDescription(
										A2($elm$core$Maybe$withDefault, '', productOverviewDescription))),
								function () {
									if (!productOverviewDescription.$) {
										var description = productOverviewDescription.a;
										return A2(
											$elm$html$Html$map,
											$elm$core$Basics$never,
											A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$preWrap, $author$project$Ui$Element$textMuted]),
												$author$project$Utils$Html$ulFromString(description)));
									} else {
										return A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-muted')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('N/A')
												]));
									}
								}())
							]))
					]))
			]));
};
var $author$project$Api$Partner$PartnerProductPricing$Shared$description = function (_v0) {
	var record = _v0;
	return record.Qr;
};
var $author$project$Api$Partner$PartnerProduct$One$pricing = function (_v0) {
	var record = _v0.b;
	return record._i;
};
var $author$project$Pages$Partner$Products$Id_String$viewProductPricing = function (product) {
	var _v0 = $author$project$Api$Partner$PartnerProduct$One$pricing(product);
	if (!_v0.$) {
		var pricing = _v0.a;
		return A2(
			$author$project$Ui$Card$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('Pricing')
								])),
							$author$project$Ui$HorizontalRule$view(
							_List_fromArray(
								[$author$project$Ui$HorizontalRule$thin])),
							A2(
							$elm$html$Html$map,
							$elm$core$Basics$never,
							A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$preWrap, $author$project$Ui$Element$textMuted]),
								$author$project$Utils$Html$ulFromString(
									$author$project$Api$Partner$PartnerProductPricing$Shared$description(pricing))))
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Partner$Products$Id_String$viewBody = function (model) {
	var _v0 = model._s;
	if (_v0.$ === 3) {
		var product = _v0.a;
		return _List_fromArray(
			[
				$author$project$Pages$Partner$Products$Id_String$viewEditModal(model),
				$author$project$Pages$Partner$Products$Id_String$viewExternalCtaModal(model),
				$author$project$Pages$Partner$Products$Id_String$viewDeleteConfirmModal(model),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Partner$Products$Id_String$ManagePartnerProductLinksMsg,
				$author$project$Components$Partner$ManagePartnerProductLinks$modal(model.gQ)),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Partner$Products$Id_String$ManagePartnerProductHighlightsMsg,
				$author$project$Components$Partner$ManagePartnerProductHighlights$modal(model.gP)),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Partner$Products$Id_String$ManagePartnerProductDataFlowsMsg,
				$author$project$Components$Partner$ManagePartnerProductDataFlows$modal(model.gO)),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Partner$Products$Id_String$ManagePartnerProductCategoriesMsg,
				$author$project$Components$Partner$ManagePartnerProductCategories$modal(model.gN)),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Partner$Products$Id_String$ManagePartnerProductQuotesMsg,
				$author$project$Components$Partner$ManagePartnerProductQuotes$modal(model.gS)),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Partner$Products$Id_String$GenerateListingModalMsg,
				$author$project$Components$Partner$GenerateListingModal$view(model.jN)),
				A3(
				$author$project$Ui$Element$custom,
				'marketplace-landing',
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Element$custom,
						'marketplace-landing__aside',
						_List_Nil,
						_List_fromArray(
							[
								A3($author$project$Pages$Partner$Products$Id_String$productCard, model.sF, product, model.br),
								A2(
								$author$project$Ui$Card$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$mb2]),
										A2(
											$elm$core$List$map,
											$elm$html$Html$map($author$project$Pages$Partner$Products$Id_String$ManagePartnerProductLinksMsg),
											$author$project$Components$Partner$ManagePartnerProductLinks$view(model.gQ))),
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$mt2]),
										A2(
											$elm$core$List$map,
											$elm$html$Html$map($author$project$Pages$Partner$Products$Id_String$ManagePartnerProductCategoriesMsg),
											$author$project$Components$Partner$ManagePartnerProductCategories$view(model.gN)))
									])),
								$author$project$Pages$Partner$Products$Id_String$viewProductPricing(product)
							])),
						A3(
						$author$project$Ui$Element$custom,
						'marketplace-landing__main',
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Pages$Partner$Products$Id_String$viewProductOverview(model),
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Partner$Products$Id_String$ManagePartnerProductHighlightsMsg,
								$author$project$Components$Partner$ManagePartnerProductHighlights$view(model.gP)),
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Partner$Products$Id_String$ManagePartnerProductDataFlowsMsg,
								$author$project$Components$Partner$ManagePartnerProductDataFlows$view(model.gO)),
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Partner$Products$Id_String$ManagePartnerProductQuotesMsg,
								$author$project$Components$Partner$ManagePartnerProductQuotes$view(model.gS))
							]))
					]))
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Pages$Partner$Products$Id_String$view = function (model) {
	return {
		fO: $author$project$Pages$Partner$Products$Id_String$viewBody(model),
		ac9: 'Partner | Product'
	};
};
var $author$project$Pages$Partner$Products$Id_String$page = $author$project$Spa$Page$applicationPartner(
	{ah_: $author$project$Pages$Partner$Products$Id_String$init, aiq: $author$project$Pages$Partner$Products$Id_String$load, k8: $author$project$Pages$Partner$Products$Id_String$save, alO: $author$project$Pages$Partner$Products$Id_String$subscriptions, adT: $author$project$Pages$Partner$Products$Id_String$update, amo: $author$project$Pages$Partner$Products$Id_String$view});
var $author$project$Pages$Partner$Products$Id_String$ActivationSettings$DocumentsMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$ActivationSettings$PreconditionsMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$Model = $elm$core$Basics$identity;
var $author$project$Components$Partner$ManagePartnerProductDocuments$GotDocuments = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Partner$PartnerProductDocument$All$PartnerProductDocument = $elm$core$Basics$identity;
var $author$project$Api$Partner$PartnerProductDocument$Shared$PartnerProductDocument = $elm$core$Basics$identity;
var $author$project$Api$Partner$PartnerProductDocument$Shared$Record = F5(
	function (id, title, documentType, url, pdfName) {
		return {QU: documentType, ahP: id, Zm: pdfName, ac9: title, adY: url};
	});
var $author$project$Api$Partner$PartnerProductDocument$Shared$PdfDocument = 0;
var $author$project$Api$Partner$PartnerProductDocument$Shared$UrlDocument = 1;
var $author$project$Api$Partner$PartnerProductDocument$Shared$documentTypeFromString = function (string) {
	switch (string) {
		case 'pdf':
			return $elm$core$Maybe$Just(0);
		case 'url':
			return $elm$core$Maybe$Just(1);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Partner$PartnerProductDocument$Shared$documentTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Api$Partner$PartnerProductDocument$Shared$documentTypeFromString,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($elm$json$Json$Decode$succeed),
			$elm$core$Maybe$withDefault(
				$elm$json$Json$Decode$fail('Unsupported document type')))),
	$elm$json$Json$Decode$string);
var $author$project$Api$Partner$PartnerProductDocument$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'pdf_name',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'url',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'document_type',
			$author$project$Api$Partner$PartnerProductDocument$Shared$documentTypeDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'title',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Partner$PartnerProductDocument$Shared$Record))))));
var $author$project$Api$Partner$PartnerProductDocument$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$PartnerProductDocument$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$PartnerProductDocument$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$PartnerProductDocument$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$PartnerProductDocument$listDefaults = {ajJ: $author$project$Api$Pagination$init, akl: $elm$core$Maybe$Nothing, alA: $author$project$Api$Sort$init};
var $author$project$Api$Partner$PartnerProductDocument$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Partner$PartnerProductDocument$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ),
				function () {
				var _v0 = options.akl;
				if (!_v0.$) {
					var q = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', q)
						]);
				} else {
					return _List_Nil;
				}
			}()
			]));
};
var $author$project$Api$Partner$PartnerProductDocument$list = F4(
	function (apiClient, productId, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Partner$PartnerProductDocument$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Partner$PartnerProductDocument$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Partner$PartnerProductDocument$partnerProductDocumentsPath(productId))));
	});
var $author$project$Components$Partner$ManagePartnerProductDocuments$fetchDocuments = F2(
	function (apiClient, model) {
		return A4(
			$author$project$Api$Partner$PartnerProductDocument$list,
			apiClient,
			model.Jn,
			function (d) {
				return _Utils_update(
					d,
					{ajJ: model.ajJ, akl: model.akl, alA: model.alA});
			},
			$author$project$Components$Partner$ManagePartnerProductDocuments$GotDocuments);
	});
var $author$project$Components$Partner$ManagePartnerProductDocuments$init = F3(
	function (apiClient, productId, query) {
		var q = A2($elm$core$Dict$get, 'q', query);
		var initialModel = {
			cv: $elm$core$Maybe$Nothing,
			bZ: $author$project$Api$Data$Loading,
			ajJ: $author$project$Api$Pagination$initFromQuery(query),
			S: $elm$core$Maybe$Nothing,
			Jn: productId,
			akl: q,
			up: $author$project$Ui$SearchInput$init(q),
			alA: $author$project$Api$Sort$initFromQuery(query)
		};
		return _Utils_Tuple2(
			initialModel,
			A2($author$project$Components$Partner$ManagePartnerProductDocuments$fetchDocuments, apiClient, initialModel));
	});
var $author$project$Components$Partner$ManagePartnerProductPreconditions$GotPreconditions = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductPreconditions$Model = $elm$core$Basics$identity;
var $author$project$Api$Partner$PartnerProduct$Precondition$preconditionsPath = function (productId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['partner_products', productId, 'preconditions']),
		$author$project$Api$Data$partnerPath);
};
var $author$project$Api$Partner$PartnerProduct$Precondition$list = F3(
	function (apiClient, productId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Common$Marketplace$Product$Precondition$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Partner$PartnerProduct$Precondition$preconditionsPath(productId)));
	});
var $author$project$Components$Partner$ManagePartnerProductPreconditions$init = F2(
	function (apiClient, productId) {
		return _Utils_Tuple2(
			{aE: $elm$core$Maybe$Nothing, cy: $elm$core$Maybe$Nothing, Z7: $author$project$Api$Data$Loading, Jn: productId},
			A3($author$project$Api$Partner$PartnerProduct$Precondition$list, apiClient, productId, $author$project$Components$Partner$ManagePartnerProductPreconditions$GotPreconditions));
	});
var $author$project$Api$Partner$Partner$Shared$authType = function (_v0) {
	var record = _v0;
	return record.Ma;
};
var $author$project$Api$Partner$Partner$One$authType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$authType(shared);
};
var $author$project$Api$Partner$Partner$Shared$postActivationRedirectUrl = function (_v0) {
	var record = _v0;
	return record.ZQ;
};
var $author$project$Api$Partner$Partner$One$postActivationRedirectUrl = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$postActivationRedirectUrl(shared);
};
var $author$project$Api$Partner$Partner$Shared$redirectUrl = function (_v0) {
	var record = _v0;
	return record.$k;
};
var $author$project$Api$Partner$Partner$One$redirectUrl = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$redirectUrl(shared);
};
var $author$project$Pages$Partner$Products$Id_String$ActivationSettings$initFormFields = function (partner) {
	return _Utils_Tuple2(
		{
			Ma: $author$project$Api$Partner$Partner$One$authType(partner),
			ZQ: $author$project$Api$Partner$Partner$One$postActivationRedirectUrl(partner),
			$k: $author$project$Api$Partner$Partner$One$redirectUrl(partner)
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$Partner$Products$Id_String$ActivationSettings$init = F4(
	function (_v0, partner, shared, _v1) {
		var params = _v1.YL;
		var query = _v1.DE;
		var _v2 = A2($author$project$Components$Partner$ManagePartnerProductPreconditions$init, shared.Gv, params.ahP);
		var preconditionsModel = _v2.a;
		var preconditionsCmd = _v2.b;
		var _v3 = $author$project$Pages$Partner$Products$Id_String$ActivationSettings$initFormFields(partner);
		var formFields = _v3.a;
		var formFieldsCmd = _v3.b;
		var _v4 = A3($author$project$Components$Partner$ManagePartnerProductDocuments$init, shared.Gv, params.ahP, query);
		var documentsModel = _v4.a;
		var documentsCmd = _v4.b;
		return _Utils_Tuple2(
			{
				Gv: shared.Gv,
				SD: $author$project$Utils$Form$init(formFields),
				ke: documentsModel,
				kg: preconditionsModel,
				YN: partner,
				qP: $author$project$Api$Data$NotAsked
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						formFieldsCmd,
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Products$Id_String$ActivationSettings$DocumentsMsg, documentsCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Products$Id_String$ActivationSettings$PreconditionsMsg, preconditionsCmd)
					])));
	});
var $author$project$Pages$Partner$Products$Id_String$ActivationSettings$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Partner$Products$Id_String$ActivationSettings$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Partner$ManagePartnerProductDocuments$CancelAdd = {$: 5};
var $author$project$Components$Partner$ManagePartnerProductDocuments$DeleteConfirmationClosed = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Partner$ManagePartnerProductDocuments$CancelAdd)),
					model.S)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$Partner$ManagePartnerProductDocuments$DeleteConfirmationClosed)),
					model.cv))
			]));
};
var $author$project$Components$Partner$ManagePartnerProductPreconditions$CloseForm = {$: 3};
var $author$project$Components$Partner$ManagePartnerProductPreconditions$DeleteConfirmationClosed = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductPreconditions$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				function () {
				var _v1 = model.aE;
				if (!_v1.$) {
					return $author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Partner$ManagePartnerProductPreconditions$CloseForm);
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				function () {
				var _v2 = model.cy;
				if (!_v2.$) {
					return $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$Partner$ManagePartnerProductPreconditions$DeleteConfirmationClosed);
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}()
			]));
};
var $author$project$Pages$Partner$Products$Id_String$ActivationSettings$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Partner$Products$Id_String$ActivationSettings$DocumentsMsg,
				$author$project$Components$Partner$ManagePartnerProductDocuments$subscriptions(model.ke)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Partner$Products$Id_String$ActivationSettings$PreconditionsMsg,
				$author$project$Components$Partner$ManagePartnerProductPreconditions$subscriptions(model.kg))
			]));
};
var $author$project$Pages$Partner$Products$Id_String$ActivationSettings$GotUpdatedPartner = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$ActivationSettings$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						$k: $author$project$Utils$String$toMaybe(string)
					});
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{Ma: string});
			default:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						ZQ: $author$project$Utils$String$toMaybe(string)
					});
		}
	});
var $author$project$Components$Partner$ManagePartnerProductDocuments$Deleted = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$DocumentCreated = 1;
var $author$project$Components$Partner$ManagePartnerProductDocuments$DocumentDeleted = 3;
var $author$project$Components$Partner$ManagePartnerProductDocuments$DocumentUpdated = 2;
var $author$project$Components$Partner$ManagePartnerProductDocuments$File = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Partner$ManagePartnerProductDocuments$FormUpdated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$GotSignedPdfUrl = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$None = 0;
var $author$project$Components$Partner$ManagePartnerProductDocuments$SearchInputMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Partner$PartnerProductDocument$delete = F4(
	function (apiClient, productId, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Partner$PartnerProductDocument$partnerProductDocumentPath, productId, id)));
	});
var $author$project$Api$Partner$PartnerProductDocument$Shared$documentTypeDefault = 1;
var $author$project$Components$Partner$ManagePartnerProductDocuments$documentFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var title = field.a;
				return _Utils_update(
					fields,
					{ac9: title});
			case 1:
				var docType = field.a;
				return _Utils_update(
					fields,
					{
						QU: A2(
							$elm$core$Maybe$withDefault,
							$author$project$Api$Partner$PartnerProductDocument$Shared$documentTypeDefault,
							$author$project$Api$Partner$PartnerProductDocument$Shared$documentTypeFromString(docType)),
						sp: 0,
						Zl: $elm$core$Maybe$Nothing,
						adY: ''
					});
			case 2:
				var url = field.a;
				return _Utils_update(
					fields,
					{adY: url});
			default:
				var size = field.a;
				var dataUrl = field.b;
				return _Utils_update(
					fields,
					{
						sp: size,
						Zl: $elm$core$Maybe$Just(
							_Utils_Tuple2(size, dataUrl))
					});
		}
	});
var $author$project$Components$Partner$ManagePartnerProductDocuments$TitleValidation = 0;
var $author$project$Components$Partner$ManagePartnerProductDocuments$FileValidation = 2;
var $author$project$Components$Partner$ManagePartnerProductDocuments$UrlValidation = 1;
var $author$project$Utils$FileSize$twentyFiveMegabytes = (25 * 1024) * 1024;
var $author$project$Components$Partner$ManagePartnerProductDocuments$maxFileBytesSize = $author$project$Utils$FileSize$twentyFiveMegabytes;
var $author$project$Components$Partner$ManagePartnerProductDocuments$validateUrlOrFile = function (fields) {
	var _v0 = fields.QU;
	if (_v0 === 1) {
		return $elm$core$String$isEmpty(fields.adY) ? _List_fromArray(
			[
				_Utils_Tuple2(1, 'Please enter a URL.')
			]) : ($author$project$Utils$Validate$isInvalidUrl(fields.adY) ? _List_fromArray(
			[
				_Utils_Tuple2(1, 'Please enter a valid URL.')
			]) : _List_Nil);
	} else {
		return (_Utils_eq(fields.Zl, $elm$core$Maybe$Nothing) && _Utils_eq(fields.zw, $elm$core$Maybe$Nothing)) ? _List_fromArray(
			[
				_Utils_Tuple2(2, 'Please attach a PDF file.')
			]) : ((_Utils_cmp(fields.sp, $author$project$Components$Partner$ManagePartnerProductDocuments$maxFileBytesSize) > 0) ? _List_fromArray(
			[
				_Utils_Tuple2(2, 'That file is too large! Maximum file size is 25 MB.')
			]) : _List_Nil);
	}
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$documentValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.ac9;
			},
			_Utils_Tuple2(0, 'Please enter a title.')),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Partner$ManagePartnerProductDocuments$validateUrlOrFile)
		]));
var $author$project$Api$Partner$PartnerProductDocument$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Partner$PartnerProductDocument$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Partner$PartnerProductDocument$Shared$id(shared);
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$initDocumentFields = {QU: 1, zw: $elm$core$Maybe$Nothing, sp: 0, Zl: $elm$core$Maybe$Nothing, ac9: '', adY: ''};
var $author$project$Api$Partner$PartnerProductDocument$Shared$documentType = function (_v0) {
	var record = _v0;
	return record.QU;
};
var $author$project$Api$Partner$PartnerProductDocument$All$documentType = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Partner$PartnerProductDocument$Shared$documentType(shared);
};
var $author$project$Api$Partner$PartnerProductDocument$Shared$pdfName = function (_v0) {
	var record = _v0;
	return record.Zm;
};
var $author$project$Api$Partner$PartnerProductDocument$All$pdfName = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Partner$PartnerProductDocument$Shared$pdfName(shared);
};
var $author$project$Api$Partner$PartnerProductDocument$Shared$title = function (_v0) {
	var record = _v0;
	return record.ac9;
};
var $author$project$Api$Partner$PartnerProductDocument$All$title = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Partner$PartnerProductDocument$Shared$title(shared);
};
var $author$project$Api$Partner$PartnerProductDocument$Shared$url = function (_v0) {
	var record = _v0;
	return record.adY;
};
var $author$project$Api$Partner$PartnerProductDocument$All$url = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Partner$PartnerProductDocument$Shared$url(shared);
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$initDocumentFieldsForEdit = function (doc) {
	return {
		QU: $author$project$Api$Partner$PartnerProductDocument$All$documentType(doc),
		zw: $author$project$Api$Partner$PartnerProductDocument$All$pdfName(doc),
		sp: 0,
		Zl: $elm$core$Maybe$Nothing,
		ac9: $author$project$Api$Partner$PartnerProductDocument$All$title(doc),
		adY: A2(
			$elm$core$Maybe$withDefault,
			'',
			$author$project$Api$Partner$PartnerProductDocument$All$url(doc))
	};
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$Created = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Partner$PartnerProductDocument$One$PartnerProductDocument = 0;
var $author$project$Api$Partner$PartnerProductDocument$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Partner$PartnerProductDocument$Shared$documentTypeToString = function (docType) {
	if (!docType) {
		return 'pdf';
	} else {
		return 'url';
	}
};
var $author$project$Api$Partner$PartnerProductDocument$create = F4(
	function (apiClient, productId, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'partner_product_document',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'document_type',
								$elm$json$Json$Encode$string(
									$author$project$Api$Partner$PartnerProductDocument$Shared$documentTypeToString(params.QU))),
								_Utils_Tuple2(
								'title',
								$elm$json$Json$Encode$string(params.ac9)),
								_Utils_Tuple2(
								'url',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.adY)),
								_Utils_Tuple2(
								'pdf',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.Zl))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$PartnerProductDocument$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Partner$PartnerProductDocument$partnerProductDocumentsPath(productId))));
	});
var $author$project$Components$Partner$ManagePartnerProductDocuments$createDocument = F3(
	function (apiClient, productId, formFields) {
		var _v0 = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var title = _v0.ac9;
		var documentType = _v0.QU;
		var url = _v0.adY;
		var pdf = _v0.Zl;
		return A4(
			$author$project$Api$Partner$PartnerProductDocument$create,
			apiClient,
			productId,
			{
				QU: documentType,
				Zl: A2($elm$core$Maybe$map, $elm$core$Tuple$second, pdf),
				ac9: title,
				adY: $author$project$Utils$Maybe$fromString(url)
			},
			$author$project$Components$Partner$ManagePartnerProductDocuments$Created);
	});
var $author$project$Components$Partner$ManagePartnerProductDocuments$Updated = function (a) {
	return {$: 11, a: a};
};
var $author$project$Api$Partner$PartnerProductDocument$update = F5(
	function (apiClient, productId, id, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'partner_product_document',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'title',
								$elm$json$Json$Encode$string(params.ac9)),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'url',
									A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.adY)),
								function () {
									var _v0 = params.Zl;
									if (!_v0.$) {
										var pdf = _v0.a;
										return _List_fromArray(
											[
												_Utils_Tuple2(
												'pdf',
												$elm$json$Json$Encode$string(pdf))
											]);
									} else {
										return _List_Nil;
									}
								}()))))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Partner$PartnerProductDocument$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Partner$PartnerProductDocument$partnerProductDocumentPath, productId, id))));
	});
var $author$project$Components$Partner$ManagePartnerProductDocuments$updateDocument = F4(
	function (apiClient, productId, id, formFields) {
		var _v0 = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var title = _v0.ac9;
		var url = _v0.adY;
		var pdf = _v0.Zl;
		return A5(
			$author$project$Api$Partner$PartnerProductDocument$update,
			apiClient,
			productId,
			id,
			{
				Zl: A2($elm$core$Maybe$map, $elm$core$Tuple$second, pdf),
				ac9: title,
				adY: $author$project$Utils$Maybe$fromString(url)
			},
			$author$project$Components$Partner$ManagePartnerProductDocuments$Updated);
	});
var $author$project$Components$Partner$ManagePartnerProductDocuments$save = F4(
	function (apiClient, productId, docId, formFields) {
		if (!docId.$) {
			var id_ = docId.a;
			return A4($author$project$Components$Partner$ManagePartnerProductDocuments$updateDocument, apiClient, productId, id_, formFields);
		} else {
			return A3($author$project$Components$Partner$ManagePartnerProductDocuments$createDocument, apiClient, productId, formFields);
		}
	});
var $author$project$Components$Partner$ManagePartnerProductDocuments$updateUrl = function (model) {
	return $author$project$Ports$Navigation$replaceUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString(
					$author$project$Spa$Generated$Route$Partner__Products__Id_String__ActivationSettings(
						{ahP: model.Jn}))
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.ajJ),
				A2(
					$elm$core$List$append,
					$author$project$Api$Sort$toQuery(model.alA),
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								A2(
								$elm$core$Maybe$map,
								$elm$url$Url$Builder$string('q'),
								model.akl)
							]))))));
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{
								bZ: response,
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
							}),
						aR: _List_Nil
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{bZ: response}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 1:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						bZ: $author$project$Api$Data$Loading,
						alA: A2($author$project$Api$Sort$update, columnId, model.alA)
					});
				return {
					GZ: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Partner$ManagePartnerProductDocuments$fetchDocuments, apiClient, newModel),
								$author$project$Components$Partner$ManagePartnerProductDocuments$updateUrl(newModel)
							])),
					agZ: 0,
					aiO: newModel,
					aR: _List_Nil
				};
			case 2:
				var subMsg = msg.a;
				var newModel = _Utils_update(
					model,
					{
						bZ: $author$project$Api$Data$Loading,
						ajJ: A2($author$project$Api$Pagination$update, subMsg, model.ajJ)
					});
				return {
					GZ: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Partner$ManagePartnerProductDocuments$fetchDocuments, apiClient, newModel),
								$author$project$Components$Partner$ManagePartnerProductDocuments$updateUrl(newModel)
							])),
					agZ: 0,
					aiO: newModel,
					aR: _List_Nil
				};
			case 3:
				var subMsg = msg.a;
				var _v3 = A2($author$project$Ui$SearchInput$update, subMsg, model.up);
				var searchInput = _v3.a;
				var searchInputCmd = _v3.b;
				var searchInputEvent = _v3.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.akl;
					}
				}();
				var _v4 = function () {
					if (_Utils_eq(q, model.akl)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								bZ: $author$project$Api$Data$Loading,
								ajJ: $author$project$Api$Pagination$reset(model.ajJ),
								akl: q
							});
						return _Utils_Tuple2(
							qModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($author$project$Components$Partner$ManagePartnerProductDocuments$fetchDocuments, apiClient, qModel),
										$author$project$Components$Partner$ManagePartnerProductDocuments$updateUrl(qModel)
									])));
					}
				}();
				var newModel = _v4.a;
				var fetchCmd = _v4.b;
				return {
					GZ: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Partner$ManagePartnerProductDocuments$SearchInputMsg, searchInputCmd),
								fetchCmd
							])),
					agZ: 0,
					aiO: _Utils_update(
						newModel,
						{up: searchInput}),
					aR: _List_Nil
				};
			case 4:
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							S: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init($author$project$Components$Partner$ManagePartnerProductDocuments$initDocumentFields),
									$author$project$Api$Data$NotAsked))
						}),
					aR: _List_Nil
				};
			case 5:
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{S: $elm$core$Maybe$Nothing}),
					aR: _List_Nil
				};
			case 6:
				var productDocument = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							S: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(productDocument),
									$author$project$Utils$Form$init(
										$author$project$Components$Partner$ManagePartnerProductDocuments$initDocumentFieldsForEdit(productDocument)),
									$author$project$Api$Data$NotAsked))
						}),
					aR: _List_Nil
				};
			case 7:
				var field = msg.a;
				var _v6 = model.S;
				if (!_v6.$) {
					var _v7 = _v6.a;
					var id = _v7.a;
					var form = _v7.b;
					var request = _v7.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Partner$ManagePartnerProductDocuments$documentFieldsUpdate, field, form);
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{
								S: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, request))
							}),
						aR: _List_Nil
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
			case 8:
				var files = msg.a;
				var cmd = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						function (_v8) {
							var task = _v8.a;
							var size = _v8.b;
							return A2(
								$elm$core$Task$perform,
								A2(
									$elm$core$Basics$composeL,
									$author$project$Components$Partner$ManagePartnerProductDocuments$FormUpdated,
									$author$project$Components$Partner$ManagePartnerProductDocuments$File(size)),
								task);
						},
						A2(
							$elm$core$Maybe$map,
							function (f) {
								return _Utils_Tuple2(
									$elm$file$File$toUrl(f),
									$elm$file$File$size(f));
							},
							$elm$core$List$head(files))));
				return {GZ: cmd, agZ: 0, aiO: model, aR: _List_Nil};
			case 9:
				var _v9 = model.S;
				if (!_v9.$) {
					var _v10 = _v9.a;
					var productDocument = _v10.a;
					var form = _v10.b;
					var _v11 = A2($author$project$Utils$Form$validate, $author$project$Components$Partner$ManagePartnerProductDocuments$documentValidator, form);
					if (!_v11.$) {
						var _v12 = _v11.a;
						var validatedForm = _v12.a;
						var validFormFields = _v12.b;
						var docId = A2($elm$core$Maybe$map, $author$project$Api$Partner$PartnerProductDocument$All$id, productDocument);
						return {
							GZ: A4($author$project$Components$Partner$ManagePartnerProductDocuments$save, apiClient, model.Jn, docId, validFormFields),
							agZ: 0,
							aiO: _Utils_update(
								model,
								{
									S: $elm$core$Maybe$Just(
										_Utils_Tuple3(productDocument, validatedForm, $author$project$Api$Data$Loading))
								}),
							aR: _List_Nil
						};
					} else {
						var validatedForm = _v11.a;
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 0,
							aiO: _Utils_update(
								model,
								{
									S: $elm$core$Maybe$Just(
										_Utils_Tuple3(productDocument, validatedForm, $author$project$Api$Data$NotAsked))
								}),
							aR: _List_Nil
						};
					}
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
			case 10:
				var response = msg.a;
				var _v13 = model.S;
				if (!_v13.$) {
					var _v14 = _v13.a;
					var productDocument = _v14.a;
					var form = _v14.b;
					if (response.$ === 3) {
						var newModel = _Utils_update(
							model,
							{bZ: $author$project$Api$Data$Loading, S: $elm$core$Maybe$Nothing});
						return {
							GZ: A2($author$project$Components$Partner$ManagePartnerProductDocuments$fetchDocuments, apiClient, newModel),
							agZ: 1,
							aiO: newModel,
							aR: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Document created successfully!')
								])
						};
					} else {
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 0,
							aiO: _Utils_update(
								model,
								{
									S: $elm$core$Maybe$Just(
										_Utils_Tuple3(productDocument, form, response))
								}),
							aR: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
			case 11:
				var response = msg.a;
				var _v16 = model.S;
				if (!_v16.$) {
					var _v17 = _v16.a;
					var productDocument = _v17.a;
					var form = _v17.b;
					if (response.$ === 3) {
						var newModel = _Utils_update(
							model,
							{bZ: $author$project$Api$Data$Loading, S: $elm$core$Maybe$Nothing});
						return {
							GZ: A2($author$project$Components$Partner$ManagePartnerProductDocuments$fetchDocuments, apiClient, newModel),
							agZ: 2,
							aiO: newModel,
							aR: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Document updated successfully!')
								])
						};
					} else {
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 0,
							aiO: _Utils_update(
								model,
								{
									S: $elm$core$Maybe$Just(
										_Utils_Tuple3(productDocument, form, response))
								}),
							aR: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
			case 12:
				var doc = msg.a;
				return {
					GZ: A4(
						$author$project$Api$Partner$PartnerProductDocument$signedFileUrl,
						apiClient,
						model.Jn,
						$author$project$Api$Partner$PartnerProductDocument$All$id(doc),
						$author$project$Components$Partner$ManagePartnerProductDocuments$GotSignedPdfUrl),
					agZ: 0,
					aiO: model,
					aR: _List_Nil
				};
			case 13:
				var response = msg.a;
				if (response.$ === 3) {
					var url = response.a;
					return {
						GZ: $author$project$Ports$Navigation$openInNewWindow(url),
						agZ: 0,
						aiO: model,
						aR: _List_Nil
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: model,
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 14:
				var productDocument = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							cv: $elm$core$Maybe$Just(
								_Utils_Tuple2(productDocument, $author$project$Api$Data$NotAsked))
						}),
					aR: _List_Nil
				};
			case 15:
				var confirmed = msg.a;
				var _v20 = model.cv;
				if (!_v20.$) {
					var _v21 = _v20.a;
					var productDocument = _v21.a;
					return confirmed ? {
						GZ: A4(
							$author$project$Api$Partner$PartnerProductDocument$delete,
							apiClient,
							model.Jn,
							$author$project$Api$Partner$PartnerProductDocument$All$id(productDocument),
							$author$project$Components$Partner$ManagePartnerProductDocuments$Deleted),
						agZ: 0,
						aiO: _Utils_update(
							model,
							{
								cv: $elm$core$Maybe$Just(
									_Utils_Tuple2(productDocument, $author$project$Api$Data$Loading))
							}),
						aR: _List_Nil
					} : {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{cv: $elm$core$Maybe$Nothing}),
						aR: _List_Nil
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
			default:
				var response = msg.a;
				var _v22 = model.cv;
				if (!_v22.$) {
					var _v23 = _v22.a;
					var productDocument = _v23.a;
					if (response.$ === 3) {
						var newModel = _Utils_update(
							model,
							{cv: $elm$core$Maybe$Nothing, bZ: $author$project$Api$Data$Loading});
						return {
							GZ: A2($author$project$Components$Partner$ManagePartnerProductDocuments$fetchDocuments, apiClient, newModel),
							agZ: 3,
							aiO: newModel,
							aR: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Document deleted successfully!')
								])
						};
					} else {
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 0,
							aiO: _Utils_update(
								model,
								{
									cv: $elm$core$Maybe$Just(
										_Utils_Tuple2(productDocument, response))
								}),
							aR: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
		}
	});
var $author$project$Components$Partner$ManagePartnerProductPreconditions$GotDeleted = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductPreconditions$GotSaved = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Partner$PartnerProduct$Precondition$Type_ = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Partner$PartnerProduct$Precondition$Url = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Partner$PartnerProduct$Precondition$One$Precondition = 0;
var $author$project$Api$Partner$PartnerProduct$Precondition$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Marketplace$Product$Precondition$decoder,
	$elm$json$Json$Decode$succeed(
		$elm$core$Basics$always(0)));
var $author$project$Api$Common$Marketplace$Product$Precondition$Type$toString = function (t) {
	switch (t) {
		case 0:
			return 'external_install';
		case 1:
			return 'external_account';
		default:
			return 'onboarding_call';
	}
};
var $author$project$Api$Partner$PartnerProduct$Precondition$encodePermittedFields = function (permittedFields) {
	var encodedFields = A3(
		$elm$core$List$foldl,
		F2(
			function (field, acc) {
				if (!field.$) {
					var t = field.a;
					return A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string(
								$author$project$Api$Common$Marketplace$Product$Precondition$Type$toString(t))),
						acc);
				} else {
					var u = field.a;
					return A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'url',
							$elm$json$Json$Encode$string(u)),
						acc);
				}
			}),
		_List_Nil,
		permittedFields);
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'precondition',
				$elm$json$Json$Encode$object(encodedFields))
			]));
};
var $author$project$Api$Partner$PartnerProduct$Precondition$create = F4(
	function (apiClient, productId, permittedFields, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$PartnerProduct$Precondition$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Partner$PartnerProduct$Precondition$encodePermittedFields(permittedFields),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Partner$PartnerProduct$Precondition$preconditionsPath(productId))));
	});
var $author$project$Api$Partner$PartnerProduct$Precondition$preconditionPath = F2(
	function (productId, preconditionId) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[preconditionId]),
			$author$project$Api$Partner$PartnerProduct$Precondition$preconditionsPath(productId));
	});
var $author$project$Api$Partner$PartnerProduct$Precondition$destroy = F4(
	function (apiClient, productId, preconditionId, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Partner$PartnerProduct$Precondition$preconditionPath, productId, preconditionId)));
	});
var $author$project$Components$Partner$ManagePartnerProductPreconditions$emptyForm = {amg: 0, adY: ''};
var $author$project$Components$Partner$ManagePartnerProductPreconditions$formFromPrecondition = function (precondition) {
	return {
		amg: $author$project$Api$Common$Marketplace$Product$Precondition$type_(precondition),
		adY: $author$project$Api$Common$Marketplace$Product$Precondition$url(precondition)
	};
};
var $author$project$Api$Partner$PartnerProduct$Precondition$update = F5(
	function (apiClient, productId, preconditionId, permittedFields, toMsg) {
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Partner$PartnerProduct$Precondition$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Partner$PartnerProduct$Precondition$encodePermittedFields(permittedFields),
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Partner$PartnerProduct$Precondition$preconditionPath, productId, preconditionId))));
	});
var $author$project$Components$Partner$ManagePartnerProductPreconditions$updateForm = F2(
	function (field, form) {
		if (!field.$) {
			var t = field.a;
			return _Utils_update(
				form,
				{amg: t});
		} else {
			var string = field.a;
			return _Utils_update(
				form,
				{adY: string});
		}
	});
var $author$project$Components$Partner$ManagePartnerProductPreconditions$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Z7: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aE: $elm$core$Maybe$Just(
								_Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Components$Partner$ManagePartnerProductPreconditions$emptyForm, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var precondition = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aE: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(precondition),
									$author$project$Components$Partner$ManagePartnerProductPreconditions$formFromPrecondition(precondition),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aE: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var field = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aE: A2(
								$elm$core$Maybe$map,
								function (_v2) {
									var p = _v2.a;
									var f = _v2.b;
									var r = _v2.c;
									return _Utils_Tuple3(
										p,
										A2($author$project$Components$Partner$ManagePartnerProductPreconditions$updateForm, field, f),
										r);
								},
								model.aE)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var maybeId = msg.a;
				var _v3 = model.aE;
				if (!_v3.$) {
					var _v4 = _v3.a;
					var maybePrecondition = _v4.a;
					var form = _v4.b;
					if ($elm$core$String$isEmpty(
						$elm$core$String$trim(form.adY))) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aE: $elm$core$Maybe$Just(
										_Utils_Tuple3(maybePrecondition, form, $author$project$Api$Data$NotAsked))
								}),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 1, 'URL is required.')
								]));
					} else {
						var permittedFields = _List_fromArray(
							[
								$author$project$Api$Partner$PartnerProduct$Precondition$Type_(form.amg),
								$author$project$Api$Partner$PartnerProduct$Precondition$Url(form.adY)
							]);
						var cmd = function () {
							if (!maybeId.$) {
								var id = maybeId.a;
								return A5($author$project$Api$Partner$PartnerProduct$Precondition$update, apiClient, model.Jn, id, permittedFields, $author$project$Components$Partner$ManagePartnerProductPreconditions$GotSaved);
							} else {
								return A4($author$project$Api$Partner$PartnerProduct$Precondition$create, apiClient, model.Jn, permittedFields, $author$project$Components$Partner$ManagePartnerProductPreconditions$GotSaved);
							}
						}();
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aE: $elm$core$Maybe$Just(
										_Utils_Tuple3(maybePrecondition, form, $author$project$Api$Data$Loading))
								}),
							cmd,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{aE: $elm$core$Maybe$Nothing, Z7: $author$project$Api$Data$Loading}),
						A3($author$project$Api$Partner$PartnerProduct$Precondition$list, apiClient, model.Jn, $author$project$Components$Partner$ManagePartnerProductPreconditions$GotPreconditions),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Precondition saved successfully!')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aE: A2(
									$elm$core$Maybe$map,
									function (_v7) {
										var p = _v7.a;
										var f = _v7.b;
										return _Utils_Tuple3(p, f, response);
									},
									model.aE)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 7:
				var precondition = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							cy: $elm$core$Maybe$Just(
								_Utils_Tuple2(precondition, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 8:
				var confirmed = msg.a;
				var _v8 = model.cy;
				if (!_v8.$) {
					var _v9 = _v8.a;
					var precondition = _v9.a;
					return confirmed ? _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cy: $elm$core$Maybe$Just(
									_Utils_Tuple2(precondition, $author$project$Api$Data$Loading))
							}),
						A4(
							$author$project$Api$Partner$PartnerProduct$Precondition$destroy,
							apiClient,
							model.Jn,
							$author$project$Api$Common$Marketplace$Product$Precondition$id(precondition),
							$author$project$Components$Partner$ManagePartnerProductPreconditions$GotDeleted),
						_List_Nil) : _Utils_Tuple3(
						_Utils_update(
							model,
							{cy: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cy: $elm$core$Maybe$Nothing, Z7: $author$project$Api$Data$Loading}),
						A3($author$project$Api$Partner$PartnerProduct$Precondition$list, apiClient, model.Jn, $author$project$Components$Partner$ManagePartnerProductPreconditions$GotPreconditions),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Precondition deleted successfully!')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cy: A2(
									$elm$core$Maybe$map,
									function (_v11) {
										var p = _v11.a;
										return _Utils_Tuple2(p, response);
									},
									model.cy)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var url = msg.a;
				return _Utils_Tuple3(
					model,
					$author$project$Ports$Navigation$openInNewWindow(url),
					_List_Nil);
		}
	});
var $author$project$Pages$Partner$Products$Id_String$ActivationSettings$PostActivationRedirectUrlValidation = 1;
var $author$project$Pages$Partner$Products$Id_String$ActivationSettings$validatePostActivationRedirectUrl = function (fields) {
	var _v0 = fields.ZQ;
	if (_v0.$ === 1) {
		return _List_Nil;
	} else {
		var url = _v0.a;
		return $author$project$Utils$Validate$isInvalidUrl(url) ? _List_fromArray(
			[
				_Utils_Tuple2(1, 'URL must start with http:// or https://')
			]) : _List_Nil;
	}
};
var $author$project$Pages$Partner$Products$Id_String$ActivationSettings$RedirectUrlValidation = 0;
var $author$project$Pages$Partner$Products$Id_String$ActivationSettings$validateRedirectUrl = function (fields) {
	var _v0 = _Utils_Tuple2(fields.Ma !== 'manual', fields.$k);
	if (_v0.a) {
		if (_v0.b.$ === 1) {
			var _v1 = _v0.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(0, 'Redirect URL is required')
				]);
		} else {
			var url = _v0.b.a;
			return $author$project$Utils$Validate$isInvalidUrl(url) ? _List_fromArray(
				[
					_Utils_Tuple2(0, 'URL must start with http:// or https://')
				]) : _List_Nil;
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$Pages$Partner$Products$Id_String$ActivationSettings$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Partner$Products$Id_String$ActivationSettings$validateRedirectUrl),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Partner$Products$Id_String$ActivationSettings$validatePostActivationRedirectUrl)
		]));
var $author$project$Api$Partner$Partner$PostActivationRedirectUrl = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Partner$Partner$RedirectUrl = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$ActivationSettings$toPermittedFields = function (fields) {
	return A2(
		$elm$core$List$cons,
		$author$project$Api$Partner$Partner$AuthType(fields.Ma),
		A2(
			$elm$core$List$cons,
			$author$project$Api$Partner$Partner$RedirectUrl(fields.$k),
			(fields.Ma === 'automatic_headless') ? _List_fromArray(
				[
					$author$project$Api$Partner$Partner$PostActivationRedirectUrl(fields.ZQ)
				]) : _List_Nil));
};
var $author$project$Pages$Partner$Products$Id_String$ActivationSettings$validate = function (model) {
	var _v0 = A2($author$project$Utils$Form$validate, $author$project$Pages$Partner$Products$Id_String$ActivationSettings$formFieldsValidator, model.SD);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var validFormFields = _v1.b;
		var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
		return $elm$core$Result$Ok(
			$author$project$Pages$Partner$Products$Id_String$ActivationSettings$toPermittedFields(fields));
	} else {
		var validatedForm = _v0.a;
		return $elm$core$Result$Err(validatedForm);
	}
};
var $author$project$Pages$Partner$Products$Id_String$ActivationSettings$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Partner$Products$Id_String$ActivationSettings$formFieldsUpdate, field, model.SD);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: newForm}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var _v1 = $author$project$Pages$Partner$Products$Id_String$ActivationSettings$validate(model);
				if (!_v1.$) {
					var permittedFields = _v1.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{qP: $author$project$Api$Data$Loading}),
						A3($author$project$Api$Partner$Partner$update, model.Gv, permittedFields, $author$project$Pages$Partner$Products$Id_String$ActivationSettings$GotUpdatedPartner),
						_List_Nil);
				} else {
					var updatedForm = _v1.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{SD: updatedForm, qP: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					var partner = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{YN: partner, qP: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Partner updated successfully!'),
								$author$project$OutMsg$RefreshPartner
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{qP: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 3:
				var documentsMsg = msg.a;
				var result = A3($author$project$Components$Partner$ManagePartnerProductDocuments$update, model.Gv, documentsMsg, model.ke);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ke: result.aiO}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Products$Id_String$ActivationSettings$DocumentsMsg, result.GZ),
					result.aR);
			default:
				var preconditionsMsg = msg.a;
				var _v3 = A3($author$project$Components$Partner$ManagePartnerProductPreconditions$update, model.Gv, preconditionsMsg, model.kg);
				var preconditionsModel = _v3.a;
				var preconditionsCmd = _v3.b;
				var outMsgs = _v3.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{kg: preconditionsModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Products$Id_String$ActivationSettings$PreconditionsMsg, preconditionsCmd),
					outMsgs);
		}
	});
var $author$project$Pages$Partner$Products$Id_String$ActivationSettings$AuthType = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$ActivationSettings$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$ActivationSettings$PostActivationRedirectUrl = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$ActivationSettings$RedirectUrl = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$ActivationSettings$Save = {$: 1};
var $author$project$Components$Partner$ManagePartnerProductDocuments$viewDocumentDeleteConfirmModal = function (model) {
	var _v0 = model.cv;
	if (!_v0.$) {
		var _v1 = _v0.a;
		var request = _v1.b;
		return A2(
			$author$project$Components$HiConfirm$modal,
			$author$project$Components$Partner$ManagePartnerProductDocuments$DeleteConfirmationClosed,
			_List_fromArray(
				[
					$author$project$Components$HiConfirm$verb('delete'),
					$author$project$Components$HiConfirm$noun('document'),
					$author$project$Components$HiConfirm$loading(
					_Utils_eq(request, $author$project$Api$Data$Loading))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$DocumentType = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$FileUploaded = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$Save = {$: 9};
var $author$project$Components$Partner$ManagePartnerProductDocuments$Title = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$Url = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$documentTypeOptions = A2(
	$elm$core$List$map,
	function (_v0) {
		var docType = _v0.a;
		var label = _v0.b;
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(
				$author$project$Api$Partner$PartnerProductDocument$Shared$documentTypeToString(docType)),
			label);
	},
	_List_fromArray(
		[
			_Utils_Tuple2(1, 'Link to URL'),
			_Utils_Tuple2(0, 'Upload PDF')
		]));
var $author$project$Components$Partner$ManagePartnerProductDocuments$viewDocumentEditModal = function (_v0) {
	var productDocument = _v0.S;
	if (!productDocument.$) {
		var _v2 = productDocument.a;
		var item = _v2.a;
		var form = _v2.b;
		var request = _v2.c;
		var fields = $author$project$Utils$Form$fields(form);
		var updateWarning = function () {
			var _v7 = fields.QU;
			if (!_v7) {
				return 'Uploading a new PDF';
			} else {
				return 'Updating the URL';
			}
		}() + ' will invalidate any existing document agreements.';
		var modalConfig = {
			Tq: $elm$core$Maybe$Just('Attach a document or link to your product listing.'),
			aih: 'Document',
			V8: _Utils_eq(request, $author$project$Api$Data$Loading),
			WG: A2($elm$core$Maybe$map, $author$project$Api$Partner$PartnerProductDocument$All$id, item),
			WH: $elm$core$Maybe$Just(updateWarning),
			Yd: $author$project$Components$Partner$ManagePartnerProductDocuments$CancelAdd,
			Yf: $elm$core$Basics$always($author$project$Components$Partner$ManagePartnerProductDocuments$Save)
		};
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Title'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(fields.ac9),
									$author$project$Ui$Form$Input$placeholder('Document title'),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeR, $author$project$Components$Partner$ManagePartnerProductDocuments$Title, $author$project$Components$Partner$ManagePartnerProductDocuments$FormUpdated)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 0, form))
								]))
						])),
				A2(
					$elm$core$List$cons,
					A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8),
								$author$project$Ui$Form$Group$label('Type')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Select$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Select$value(
										$elm$core$Maybe$Just(
											$author$project$Api$Partner$PartnerProductDocument$Shared$documentTypeToString(fields.QU))),
										$author$project$Ui$Form$Select$onChange(
										A2($elm$core$Basics$composeL, $author$project$Components$Partner$ManagePartnerProductDocuments$FormUpdated, $author$project$Components$Partner$ManagePartnerProductDocuments$DocumentType)),
										$author$project$Ui$Form$Select$disabled(
										!_Utils_eq(item, $elm$core$Maybe$Nothing))
									]),
								$author$project$Components$Partner$ManagePartnerProductDocuments$documentTypeOptions)
							])),
					function () {
						var _v3 = fields.QU;
						if (_v3 === 1) {
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$labelSpan(4),
											$author$project$Ui$Form$Group$inputSpan(8),
											$author$project$Ui$Form$Group$label('URL'),
											$author$project$Ui$Form$Group$required(true)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$value(fields.adY),
													$author$project$Ui$Form$Input$placeholder('https://example.com/docs'),
													$author$project$Ui$Form$Input$onInput(
													A2($elm$core$Basics$composeR, $author$project$Components$Partner$ManagePartnerProductDocuments$Url, $author$project$Components$Partner$ManagePartnerProductDocuments$FormUpdated)),
													$author$project$Ui$Form$Input$invalid(
													A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
													$author$project$Ui$Form$Input$errors(
													A2($author$project$Utils$Form$validationErrors, 1, form))
												]))
										]))
								]);
						} else {
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$labelSpan(4),
											$author$project$Ui$Form$Group$inputSpan(8),
											$author$project$Ui$Form$Group$label('PDF File'),
											$author$project$Ui$Form$Group$required(
											_Utils_eq(item, $elm$core$Maybe$Nothing))
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$File$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$File$accept(2),
													$author$project$Ui$Form$File$onInput($author$project$Components$Partner$ManagePartnerProductDocuments$FileUploaded)
												])),
											function () {
											var _v4 = fields.Zl;
											if (!_v4.$) {
												return A2(
													$author$project$Ui$Typography$p,
													_List_fromArray(
														[$author$project$Ui$Typography$muted]),
													_List_fromArray(
														[
															$elm$html$Html$text('File selected.')
														]));
											} else {
												if (!item.$) {
													var doc = item.a;
													var _v6 = $author$project$Api$Partner$PartnerProductDocument$All$pdfName(doc);
													if (!_v6.$) {
														return A2(
															$author$project$Ui$Typography$p,
															_List_fromArray(
																[$author$project$Ui$Typography$muted]),
															_List_fromArray(
																[
																	$elm$html$Html$text('A file is already uploaded. Select a new file to replace it.')
																]));
													} else {
														return $author$project$Utils$Html$empty;
													}
												} else {
													return $author$project$Utils$Html$empty;
												}
											}
										}(),
											$author$project$Utils$FormErrors$view(
											A2($author$project$Utils$Form$validationErrors, 2, form))
										]))
								]);
						}
					}())));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$modal = function (_v0) {
	var model = _v0;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Components$Partner$ManagePartnerProductDocuments$viewDocumentDeleteConfirmModal(model),
				$author$project$Components$Partner$ManagePartnerProductDocuments$viewDocumentEditModal(model)
			]));
};
var $author$project$Components$Partner$ManagePartnerProductPreconditions$viewDeleteConfirmModal = function (model) {
	var _v0 = model.cy;
	if (!_v0.$) {
		var _v1 = _v0.a;
		var request = _v1.b;
		return A2(
			$author$project$Components$HiConfirm$modal,
			$author$project$Components$Partner$ManagePartnerProductPreconditions$DeleteConfirmationClosed,
			_List_fromArray(
				[
					$author$project$Components$HiConfirm$verb('delete'),
					$author$project$Components$HiConfirm$noun('precondition'),
					$author$project$Components$HiConfirm$loading(
					_Utils_eq(request, $author$project$Api$Data$Loading))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Partner$ManagePartnerProductPreconditions$Save = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductPreconditions$Type_ = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductPreconditions$UpdateForm = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductPreconditions$Url = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductPreconditions$OpenOnboardingUrl = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Marketplace$Product$Precondition$ReadOnly = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Well$FullWidth = {$: 2};
var $author$project$Ui$Well$wFull = $author$project$Ui$Well$FullWidth;
var $author$project$Components$Partner$ManagePartnerProductPreconditions$practicePreview = F2(
	function (type_, url) {
		return A2(
			$author$project$Ui$Well$view,
			_List_fromArray(
				[$author$project$Ui$Well$wFull]),
			_List_fromArray(
				[
					$author$project$Components$Marketplace$Product$Precondition$view(
					{
						aiN: $author$project$Components$Marketplace$Product$Precondition$ReadOnly(
							{
								ajt: $author$project$Components$Partner$ManagePartnerProductPreconditions$OpenOnboardingUrl(url)
							}),
						amg: type_,
						adY: url
					})
				]));
	});
var $author$project$Components$Partner$ManagePartnerProductPreconditions$urlFieldLabel = function (type_) {
	switch (type_) {
		case 2:
			return 'Booking URL';
		case 0:
			return 'URL';
		default:
			return 'URL';
	}
};
var $author$project$Components$Partner$ManagePartnerProductPreconditions$viewFormModal = function (model) {
	var _v0 = model.aE;
	if (!_v0.$) {
		var _v1 = _v0.a;
		var maybePrecondition = _v1.a;
		var form = _v1.b;
		var request = _v1.c;
		var modalConfig = {
			Tq: $elm$core$Maybe$Nothing,
			aih: 'Precondition',
			V8: _Utils_eq(request, $author$project$Api$Data$Loading),
			WG: A2($elm$core$Maybe$map, $author$project$Api$Common$Marketplace$Product$Precondition$id, maybePrecondition),
			WH: $elm$core$Maybe$Nothing,
			Yd: $author$project$Components$Partner$ManagePartnerProductPreconditions$CloseForm,
			Yf: $author$project$Components$Partner$ManagePartnerProductPreconditions$Save
		};
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Type'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(
									$elm$core$Maybe$Just(
										$author$project$Api$Common$Marketplace$Product$Precondition$Type$toString(form.amg))),
									$author$project$Ui$Form$Select$onChange(
									function (val) {
										switch (val) {
											case 'external_account':
												return $author$project$Components$Partner$ManagePartnerProductPreconditions$UpdateForm(
													$author$project$Components$Partner$ManagePartnerProductPreconditions$Type_(1));
											case 'onboarding_call':
												return $author$project$Components$Partner$ManagePartnerProductPreconditions$UpdateForm(
													$author$project$Components$Partner$ManagePartnerProductPreconditions$Type_(2));
											default:
												return $author$project$Components$Partner$ManagePartnerProductPreconditions$UpdateForm(
													$author$project$Components$Partner$ManagePartnerProductPreconditions$Type_(0));
										}
									})
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Form$Select$option,
									_List_Nil,
									$elm$core$Maybe$Just('external_install'),
									'External Install'),
									A3(
									$author$project$Ui$Form$Select$option,
									_List_Nil,
									$elm$core$Maybe$Just('external_account'),
									'External Account'),
									A3(
									$author$project$Ui$Form$Select$option,
									_List_Nil,
									$elm$core$Maybe$Just('onboarding_call'),
									'Onboarding Call')
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label(
							$author$project$Components$Partner$ManagePartnerProductPreconditions$urlFieldLabel(form.amg)),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(form.adY),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$Partner$ManagePartnerProductPreconditions$UpdateForm, $author$project$Components$Partner$ManagePartnerProductPreconditions$Url))
								]))
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap2, $author$project$Ui$Element$mt4]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Preview')
								])),
							A2($author$project$Components$Partner$ManagePartnerProductPreconditions$practicePreview, form.amg, form.adY)
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Partner$ManagePartnerProductPreconditions$modal = function (_v0) {
	var model = _v0;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Components$Partner$ManagePartnerProductPreconditions$viewDeleteConfirmModal(model),
				$author$project$Components$Partner$ManagePartnerProductPreconditions$viewFormModal(model)
			]));
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$Add = {$: 4};
var $author$project$Components$Partner$ManagePartnerProductDocuments$PaginationMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$SortTable = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'title', true, 'Name'),
		A3($author$project$Api$Column$init, 'document_type', true, 'Type'),
		A3($author$project$Api$Column$init, 'content', false, 'Content'),
		A3($author$project$Api$Column$init, 'actions', false, '')
	]);
var $author$project$Components$Partner$ManagePartnerProductDocuments$Delete = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$Edit = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$OpenPdf = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$viewDocumentRow = function (doc) {
	var docType = $author$project$Api$Partner$PartnerProductDocument$All$documentType(doc);
	var typeLabel = function () {
		if (!docType) {
			return 'PDF';
		} else {
			return 'URL';
		}
	}();
	var contentCell = function () {
		if (docType === 1) {
			var _v1 = $author$project$Api$Partner$PartnerProductDocument$All$url(doc);
			if (!_v1.$) {
				var url = _v1.a;
				return A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(url),
									$elm$html$Html$Attributes$target('_blank')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(url)
								]))
						]));
			} else {
				return A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil);
			}
		} else {
			return A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Open PDF'},
						_List_fromArray(
							[
								$author$project$Ui$Button$sm,
								$author$project$Ui$Button$onClick(
								$author$project$Components$Partner$ManagePartnerProductDocuments$OpenPdf(doc))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Open PDF')
							]))
					]));
		}
	}();
	return A2(
		$author$project$Ui$Table$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Partner$PartnerProductDocument$All$title(doc))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(typeLabel)
					])),
				contentCell,
				A2(
				$author$project$Ui$Table$cell,
				_List_fromArray(
					[$author$project$Ui$Table$textRight]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Edit document'},
						_List_fromArray(
							[
								$author$project$Ui$Button$sm,
								$author$project$Ui$Button$icon($author$project$Ui$Icon$edit),
								$author$project$Ui$Button$onClick(
								$author$project$Components$Partner$ManagePartnerProductDocuments$Edit(doc))
							]),
						_List_Nil),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Delete document'},
						_List_fromArray(
							[
								$author$project$Ui$Button$danger,
								$author$project$Ui$Button$sm,
								$author$project$Ui$Button$icon($author$project$Ui$Icon$delete),
								$author$project$Ui$Button$onClick(
								$author$project$Components$Partner$ManagePartnerProductDocuments$Delete(doc))
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$viewDocumentTable = function (model) {
	var _v0 = function () {
		var _v1 = model.bZ;
		if (_v1.$ === 3) {
			var docs = _v1.a;
			return _Utils_Tuple2(false, docs);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var documents = _v0.b;
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('No documents added yet.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		A2(
			$elm$core$List$map,
			$author$project$Api$Column$view(
				A2($author$project$Api$Column$Sortable, model.alA, $author$project$Components$Partner$ManagePartnerProductDocuments$SortTable)),
			$author$project$Components$Partner$ManagePartnerProductDocuments$columns),
		A2($elm$core$List$map, $author$project$Components$Partner$ManagePartnerProductDocuments$viewDocumentRow, documents),
		_List_Nil);
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$view = function (_v0) {
	var model = _v0;
	var loading = _Utils_eq(model.bZ, $author$project$Api$Data$Loading);
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_fromArray(
						[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
					_List_fromArray(
						[
							$author$project$Ui$Panel$title(
							_List_fromArray(
								[
									$elm$html$Html$text('Documents')
								])),
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Add document'},
							_List_fromArray(
								[
									$author$project$Ui$Button$icon($author$project$Ui$Icon$add),
									$author$project$Ui$Button$onClick($author$project$Components$Partner$ManagePartnerProductDocuments$Add)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Add Document')
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Components$Partner$ManagePartnerProductDocuments$SearchInputMsg,
							A2(
								$author$project$Ui$SearchInput$view,
								_List_fromArray(
									[
										$author$project$Ui$SearchInput$placeholder('Filter by title')
									]),
								model.up))
						])),
					$author$project$Components$Partner$ManagePartnerProductDocuments$viewDocumentTable(model),
					A2(
					$author$project$Ui$Panel$footer,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Components$Partner$ManagePartnerProductDocuments$PaginationMsg,
							A2(
								$author$project$Api$Pagination$view,
								_List_fromArray(
									[
										$author$project$Ui$Pagination$List$loading(loading)
									]),
								model.ajJ))
						]))
				]))
		]);
};
var $author$project$Components$Partner$ManagePartnerProductPreconditions$OpenAdd = {$: 1};
var $author$project$Components$Partner$ManagePartnerProductPreconditions$Delete = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductPreconditions$OpenEdit = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Alignment$Self = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Alignment$selfCenter = $author$project$Ui$Alignment$Self(1);
var $author$project$Ui$Element$selfCenter = $author$project$Ui$Element$Alignment($author$project$Ui$Alignment$selfCenter);
var $author$project$Components$Partner$ManagePartnerProductPreconditions$viewPreview = function (precondition) {
	return A2(
		$author$project$Ui$Grid$column,
		_List_fromArray(
			[
				$author$project$Ui$Grid$span(5)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
				_List_fromArray(
					[
						A2(
						$author$project$Components$Partner$ManagePartnerProductPreconditions$practicePreview,
						$author$project$Api$Common$Marketplace$Product$Precondition$type_(precondition),
						$author$project$Api$Common$Marketplace$Product$Precondition$url(precondition)),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$gap2, $author$project$Ui$Element$selfCenter]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Edit precondition'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$onClick(
										$author$project$Components$Partner$ManagePartnerProductPreconditions$OpenEdit(precondition)),
										$author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Edit')
									])),
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Delete precondition'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$icon($author$project$Ui$Icon$delete),
										$author$project$Ui$Button$onClick(
										$author$project$Components$Partner$ManagePartnerProductPreconditions$Delete(precondition))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Remove')
									]))
							]))
					]))
			]));
};
var $author$project$Components$Partner$ManagePartnerProductPreconditions$view = function (_v0) {
	var model = _v0;
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Panel$title(
							_List_fromArray(
								[
									$elm$html$Html$text('Preconditions')
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v1 = model.Z7;
							if (_v1.$ === 3) {
								if (!_v1.a.b) {
									return A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$textMuted]),
										_List_fromArray(
											[
												$elm$html$Html$text('No preconditions added yet.')
											]));
								} else {
									var preconditions = _v1.a;
									return A2(
										$author$project$Ui$Grid$row,
										_List_Nil,
										A2($elm$core$List$map, $author$project$Components$Partner$ManagePartnerProductPreconditions$viewPreview, preconditions));
								}
							} else {
								return $author$project$Utils$Html$empty;
							}
						}(),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$mt4]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Add precondition'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$icon($author$project$Ui$Icon$add),
											$author$project$Ui$Button$onClick($author$project$Components$Partner$ManagePartnerProductPreconditions$OpenAdd)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Add Precondition')
										]))
								]))
						]))
				]))
		]);
};
var $author$project$Pages$Partner$Products$Id_String$ActivationSettings$view = function (model) {
	var fields = $author$project$Utils$Form$fields(model.SD);
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Partner$Products$Id_String$ActivationSettings$DocumentsMsg,
				$author$project$Components$Partner$ManagePartnerProductDocuments$modal(model.ke)),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Partner$Products$Id_String$ActivationSettings$PreconditionsMsg,
				$author$project$Components$Partner$ManagePartnerProductPreconditions$modal(model.kg)),
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$autocomplete(false),
						$author$project$Ui$Form$noValidate(true),
						$author$project$Ui$Form$onSubmit($author$project$Pages$Partner$Products$Id_String$ActivationSettings$Save)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Activation Settings')
											]))
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$labelSpanSm(2),
												$author$project$Ui$Form$Group$inputSpan(10),
												$author$project$Ui$Form$Group$label('Activation Type')
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$gap4]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Form$Radio$view,
														_List_fromArray(
															[
																$author$project$Ui$Form$Radio$card,
																$author$project$Ui$Form$Radio$value(fields.Ma === 'automatic_headless'),
																$author$project$Ui$Form$Radio$onCheck(
																function (_v0) {
																	return $author$project$Pages$Partner$Products$Id_String$ActivationSettings$FormUpdated(
																		$author$project$Pages$Partner$Products$Id_String$ActivationSettings$AuthType('automatic_headless'));
																})
															]),
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Typography$titleSm,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('Headless')
																	])),
																A2(
																$author$project$Ui$Typography$p,
																_List_fromArray(
																	[$author$project$Ui$Typography$small, $author$project$Ui$Typography$helpBlock]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('We post information about a new practice to your server, you can provision or link and them complete the activation. We can redirect the user to a specific location once completed such as an embedded app page within the Hint app.')
																	]))
															])),
														A2(
														$author$project$Ui$Form$Radio$view,
														_List_fromArray(
															[
																$author$project$Ui$Form$Radio$card,
																$author$project$Ui$Form$Radio$value(fields.Ma === 'automatic_redirect'),
																$author$project$Ui$Form$Radio$onCheck(
																function (_v1) {
																	return $author$project$Pages$Partner$Products$Id_String$ActivationSettings$FormUpdated(
																		$author$project$Pages$Partner$Products$Id_String$ActivationSettings$AuthType('automatic_redirect'));
																})
															]),
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Typography$titleSm,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('Automatic')
																	])),
																A2(
																$author$project$Ui$Typography$p,
																_List_fromArray(
																	[$author$project$Ui$Typography$small, $author$project$Ui$Typography$helpBlock]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('A user will be directed to your app\'s sign in or sign up page with a connection code in the url to use with our api to complete the activation process.')
																	]))
															])),
														A2(
														$author$project$Ui$Form$Radio$view,
														_List_fromArray(
															[
																$author$project$Ui$Form$Radio$card,
																$author$project$Ui$Form$Radio$value(fields.Ma === 'manual'),
																$author$project$Ui$Form$Radio$onCheck(
																function (_v2) {
																	return $author$project$Pages$Partner$Products$Id_String$ActivationSettings$FormUpdated(
																		$author$project$Pages$Partner$Products$Id_String$ActivationSettings$AuthType('manual'));
																}),
																$author$project$Ui$Form$Radio$disabled(true)
															]),
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Typography$titleSm,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('Manual (Not Recommended)')
																	])),
																A2(
																$author$project$Ui$Typography$p,
																_List_fromArray(
																	[$author$project$Ui$Typography$small, $author$project$Ui$Typography$helpBlock]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('When installed the user is shown an authorization code they provide to your team. You exchange that via the api to complete the activation process and acquire a practice api key.')
																	]))
															]))
													]))
											])),
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$labelSpanSm(2),
												$author$project$Ui$Form$Group$inputSpan(10),
												$author$project$Ui$Form$Group$label(
												(fields.Ma === 'automatic_headless') ? 'Connect URL' : 'Redirect URL'),
												$author$project$Ui$Form$Group$required(fields.Ma !== 'manual')
											]),
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$view(
												_List_fromArray(
													[
														$author$project$Ui$Form$Input$value(
														A2($elm$core$Maybe$withDefault, '', fields.$k)),
														$author$project$Ui$Form$Input$onInput(
														A2($elm$core$Basics$composeL, $author$project$Pages$Partner$Products$Id_String$ActivationSettings$FormUpdated, $author$project$Pages$Partner$Products$Id_String$ActivationSettings$RedirectUrl)),
														$author$project$Ui$Form$Input$invalid(
														A2($author$project$Utils$Form$hasValidationErrors, 0, model.SD)),
														$author$project$Ui$Form$Input$errors(
														A2($author$project$Utils$Form$validationErrors, 0, model.SD)),
														$author$project$Ui$Form$Input$disabled(fields.Ma === 'manual'),
														$author$project$Ui$Form$Input$placeholder('https://some.example.com/signup?code=')
													])),
												A2(
												$author$project$Ui$Typography$p,
												_List_fromArray(
													[$author$project$Ui$Typography$helpBlock]),
												_List_fromArray(
													[
														$elm$html$Html$text('We\'ll append an authorization code to this url, like this: '),
														A2(
														$author$project$Ui$Typography$b,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(
																A2($elm$core$Maybe$withDefault, 'https://some.example.com/signup?code=', fields.$k) + '2jK3jlOOOpejk7xnKEl')
															]))
													]))
											])),
										(fields.Ma === 'automatic_headless') ? A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$labelSpanSm(2),
												$author$project$Ui$Form$Group$inputSpan(10),
												$author$project$Ui$Form$Group$label('Post Activation Redirect URL')
											]),
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$view(
												_List_fromArray(
													[
														$author$project$Ui$Form$Input$value(
														A2($elm$core$Maybe$withDefault, '', fields.ZQ)),
														$author$project$Ui$Form$Input$onInput(
														A2($elm$core$Basics$composeL, $author$project$Pages$Partner$Products$Id_String$ActivationSettings$FormUpdated, $author$project$Pages$Partner$Products$Id_String$ActivationSettings$PostActivationRedirectUrl)),
														$author$project$Ui$Form$Input$invalid(
														A2($author$project$Utils$Form$hasValidationErrors, 1, model.SD)),
														$author$project$Ui$Form$Input$errors(
														A2($author$project$Utils$Form$validationErrors, 1, model.SD))
													]))
											])) : $author$project$Utils$Html$empty
									])),
								A2(
								$author$project$Ui$Panel$footer,
								_List_fromArray(
									[$author$project$Ui$Element$justifyCenter]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Save partner changes'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$submit,
												$author$project$Ui$Button$loading(
												_Utils_eq(model.qP, $author$project$Api$Data$Loading))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Save')
											]))
									]))
							]))
					])),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mt4]),
				A2(
					$elm$core$List$map,
					$elm$html$Html$map($author$project$Pages$Partner$Products$Id_String$ActivationSettings$DocumentsMsg),
					$author$project$Components$Partner$ManagePartnerProductDocuments$view(model.ke))),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mt4]),
				A2(
					$elm$core$List$map,
					$elm$html$Html$map($author$project$Pages$Partner$Products$Id_String$ActivationSettings$PreconditionsMsg),
					$author$project$Components$Partner$ManagePartnerProductPreconditions$view(model.kg)))
			]),
		ac9: 'Partner | Product | ActivationSettings'
	};
};
var $author$project$Pages$Partner$Products$Id_String$ActivationSettings$page = $author$project$Spa$Page$applicationPartner(
	{ah_: $author$project$Pages$Partner$Products$Id_String$ActivationSettings$init, aiq: $author$project$Pages$Partner$Products$Id_String$ActivationSettings$load, k8: $author$project$Pages$Partner$Products$Id_String$ActivationSettings$save, alO: $author$project$Pages$Partner$Products$Id_String$ActivationSettings$subscriptions, adT: $author$project$Pages$Partner$Products$Id_String$ActivationSettings$update, amo: $author$project$Pages$Partner$Products$Id_String$ActivationSettings$view});
var $author$project$Api$Partner$AppAnchor$CorePage = 0;
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$GotApiKeys = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$GotApp = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$GotServices = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$Unset = 0;
var $author$project$Api$Partner$PartnerService$All$Record = F3(
	function (status, serviceUrl, latestRevision) {
		return {VP: latestRevision, aa3: serviceUrl, alH: status};
	});
var $author$project$Api$Partner$PartnerService$All$Service = $elm$core$Basics$identity;
var $author$project$Api$Partner$App$AppRevision$One$AppRevision = $elm$core$Basics$identity;
var $author$project$Api$Partner$App$AppRevision$One$Record = F4(
	function (id, status, commitSha, anchorType) {
		return {aeY: anchorType, N8: commitSha, ahP: id, alH: status};
	});
var $author$project$Api$Partner$AppAnchor$ClinicalChart = 2;
var $author$project$Api$Partner$AppAnchor$ClinicalInteraction = 1;
var $author$project$Api$Partner$AppAnchor$Settings = 3;
var $author$project$Api$Partner$AppAnchor$decodeAnchorType = A2(
	$elm$json$Json$Decode$andThen,
	function (typeString) {
		switch (typeString) {
			case 'core_page':
				return $elm$json$Json$Decode$succeed(0);
			case 'clinical_interaction':
				return $elm$json$Json$Decode$succeed(1);
			case 'clinical_chart':
				return $elm$json$Json$Decode$succeed(2);
			case 'settings':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('Invalid anchor type ' + typeString);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Partner$App$AppRevision$One$decoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'anchor_type',
		$elm$json$Json$Decode$nullable($author$project$Api$Partner$AppAnchor$decodeAnchorType),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'commit_sha',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'status',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Partner$App$AppRevision$One$Record))))));
var $author$project$Api$Partner$PartnerService$All$decoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'latest_revision',
		$elm$json$Json$Decode$nullable($author$project$Api$Partner$App$AppRevision$One$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'service_url',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'status',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Partner$PartnerService$All$Record)))));
var $author$project$Api$Partner$PartnerService$servicesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['app', 'services']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$PartnerService$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Partner$PartnerService$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Partner$PartnerService$servicesPath));
	});
var $author$project$Api$Partner$App$appPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['app']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$App$App = $elm$core$Basics$identity;
var $author$project$Api$Partner$App$Record = F8(
	function (status, handshakeUrl, partnerRoles, anchors, defaultAdminRole, defaultNonAdminRole, prepopulateRoleMappings, localhostMode) {
		return {Gr: anchors, PX: defaultAdminRole, P3: defaultNonAdminRole, S2: handshakeUrl, V9: localhostMode, I3: partnerRoles, _e: prepopulateRoleMappings, alH: status};
	});
var $author$project$Api$Partner$AppAnchor$AppAnchor = $elm$core$Basics$identity;
var $author$project$Api$Partner$AppAnchor$Record = function (id) {
	return function (type_) {
		return function (sourceUrl) {
			return function (interactionTitle) {
				return function (interactionDescription) {
					return function (interactionType) {
						return function (corePageIconUrl) {
							return function (corePageIconLabel) {
								return function (corePageAutoAdjustHeight) {
									return function (clinicalChartIconUrl) {
										return function (clinicalChartIconLabel) {
											return function (settingsLabel) {
												return {NL: clinicalChartIconLabel, NM: clinicalChartIconUrl, OH: corePageAutoAdjustHeight, OI: corePageIconLabel, OJ: corePageIconUrl, ahP: id, Ue: interactionDescription, Uf: interactionTitle, Ug: interactionType, aa5: settingsLabel, abO: sourceUrl, amg: type_};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Partner$AppAnchor$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'settings_label',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'clinical_chart_icon_label',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'clinical_chart_icon_url',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'core_page_auto_adjust_height',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'core_page_icon_label',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'core_page_icon_url',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'interaction_type',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'interaction_description',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									$elm$core$Maybe$Nothing,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'interaction_title',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
										$elm$core$Maybe$Nothing,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'source_url',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'type',
												$author$project$Api$Partner$AppAnchor$decodeAnchorType,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'id',
													$elm$json$Json$Decode$string,
													$elm$json$Json$Decode$succeed($author$project$Api$Partner$AppAnchor$Record))))))))))))),
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$App$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'localhost_mode',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'prepopulate_role_mappings',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'default_non_admin_role',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'default_admin_role',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'anchors',
						$elm$json$Json$Decode$list($author$project$Api$Partner$AppAnchor$decoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'partner_roles',
							$elm$json$Json$Decode$list($author$project$Api$Common$PartnerApp$PartnerRole$decoder),
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'handshake_url',
								$elm$json$Json$Decode$string,
								'',
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'status',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Api$Partner$App$Record))))))))),
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$App$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Partner$App$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Partner$App$appPath));
	});
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$init = F4(
	function (_v0, partner, shared, _v1) {
		return _Utils_Tuple2(
			{aeY: 0, Gv: shared.Gv, ck: $author$project$Api$Data$Loading, rl: $author$project$Api$Data$Loading, aiN: 0, YN: partner, akj: '', uw: $author$project$Api$Data$Loading, qo: $author$project$Api$Data$NotAsked, vs: false, z: $elm$core$Set$empty},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Api$Partner$PartnerService$list, shared.Gv, $author$project$Pages$Partner$Products$Id_String$AppBuilder$GotServices),
						A2($author$project$Api$Partner$App$retrieve, shared.Gv, $author$project$Pages$Partner$Products$Id_String$AppBuilder$GotApp),
						A3($author$project$Api$Partner$ApiKey$list, shared.Gv, $elm$core$Basics$identity, $author$project$Pages$Partner$Products$Id_String$AppBuilder$GotApiKeys)
					])));
	});
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$PollTick = {$: 15};
var $elm$time$Time$Every = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$State = F2(
	function (taggers, processes) {
		return {_q: processes, acQ: taggers};
	});
var $elm$time$Time$init = $elm$core$Task$succeed(
	A2($elm$time$Time$State, $elm$core$Dict$empty, $elm$core$Dict$empty));
var $elm$time$Time$addMySub = F2(
	function (_v0, state) {
		var interval = _v0.a;
		var tagger = _v0.b;
		var _v1 = A2($elm$core$Dict$get, interval, state);
		if (_v1.$ === 1) {
			return A3(
				$elm$core$Dict$insert,
				interval,
				_List_fromArray(
					[tagger]),
				state);
		} else {
			var taggers = _v1.a;
			return A3(
				$elm$core$Dict$insert,
				interval,
				A2($elm$core$List$cons, tagger, taggers),
				state);
		}
	});
var $elm$time$Time$setInterval = _Time_setInterval;
var $elm$time$Time$spawnHelp = F3(
	function (router, intervals, processes) {
		if (!intervals.b) {
			return $elm$core$Task$succeed(processes);
		} else {
			var interval = intervals.a;
			var rest = intervals.b;
			var spawnTimer = $elm$core$Process$spawn(
				A2(
					$elm$time$Time$setInterval,
					interval,
					A2($elm$core$Platform$sendToSelf, router, interval)));
			var spawnRest = function (id) {
				return A3(
					$elm$time$Time$spawnHelp,
					router,
					rest,
					A3($elm$core$Dict$insert, interval, id, processes));
			};
			return A2($elm$core$Task$andThen, spawnRest, spawnTimer);
		}
	});
var $elm$time$Time$onEffects = F3(
	function (router, subs, _v0) {
		var processes = _v0._q;
		var rightStep = F3(
			function (_v6, id, _v7) {
				var spawns = _v7.a;
				var existing = _v7.b;
				var kills = _v7.c;
				return _Utils_Tuple3(
					spawns,
					existing,
					A2(
						$elm$core$Task$andThen,
						function (_v5) {
							return kills;
						},
						$elm$core$Process$kill(id)));
			});
		var newTaggers = A3($elm$core$List$foldl, $elm$time$Time$addMySub, $elm$core$Dict$empty, subs);
		var leftStep = F3(
			function (interval, taggers, _v4) {
				var spawns = _v4.a;
				var existing = _v4.b;
				var kills = _v4.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, interval, spawns),
					existing,
					kills);
			});
		var bothStep = F4(
			function (interval, taggers, id, _v3) {
				var spawns = _v3.a;
				var existing = _v3.b;
				var kills = _v3.c;
				return _Utils_Tuple3(
					spawns,
					A3($elm$core$Dict$insert, interval, id, existing),
					kills);
			});
		var _v1 = A6(
			$elm$core$Dict$merge,
			leftStep,
			bothStep,
			rightStep,
			newTaggers,
			processes,
			_Utils_Tuple3(
				_List_Nil,
				$elm$core$Dict$empty,
				$elm$core$Task$succeed(0)));
		var spawnList = _v1.a;
		var existingDict = _v1.b;
		var killTask = _v1.c;
		return A2(
			$elm$core$Task$andThen,
			function (newProcesses) {
				return $elm$core$Task$succeed(
					A2($elm$time$Time$State, newTaggers, newProcesses));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v2) {
					return A3($elm$time$Time$spawnHelp, router, spawnList, existingDict);
				},
				killTask));
	});
var $elm$time$Time$onSelfMsg = F3(
	function (router, interval, state) {
		var _v0 = A2($elm$core$Dict$get, interval, state.acQ);
		if (_v0.$ === 1) {
			return $elm$core$Task$succeed(state);
		} else {
			var taggers = _v0.a;
			var tellTaggers = function (time) {
				return $elm$core$Task$sequence(
					A2(
						$elm$core$List$map,
						function (tagger) {
							return A2(
								$elm$core$Platform$sendToApp,
								router,
								tagger(time));
						},
						taggers));
			};
			return A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$succeed(state);
				},
				A2($elm$core$Task$andThen, tellTaggers, $elm$time$Time$now));
		}
	});
var $elm$time$Time$subMap = F2(
	function (f, _v0) {
		var interval = _v0.a;
		var tagger = _v0.b;
		return A2(
			$elm$time$Time$Every,
			interval,
			A2($elm$core$Basics$composeL, f, tagger));
	});
_Platform_effectManagers['Time'] = _Platform_createManager($elm$time$Time$init, $elm$time$Time$onEffects, $elm$time$Time$onSelfMsg, 0, $elm$time$Time$subMap);
var $elm$time$Time$subscription = _Platform_leaf('Time');
var $elm$time$Time$every = F2(
	function (interval, tagger) {
		return $elm$time$Time$subscription(
			A2($elm$time$Time$Every, interval, tagger));
	});
var $author$project$Api$Partner$App$AppRevision$One$id = function (_v0) {
	var r = _v0;
	return r.ahP;
};
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$currentService = function (model) {
	var _v0 = model.uw;
	if (_v0.$ === 3) {
		var list = _v0.a;
		return $elm$core$List$head(list);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Partner$PartnerService$All$latestRevision = function (_v0) {
	var record = _v0;
	return record.VP;
};
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$latestRevisionFromServices = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		$author$project$Api$Partner$PartnerService$All$latestRevision,
		$author$project$Pages$Partner$Products$Id_String$AppBuilder$currentService(model));
};
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$freshestRevision = function (model) {
	var fromSubmit = function () {
		var _v3 = model.qo;
		if (_v3.$ === 3) {
			var revision = _v3.a;
			return $elm$core$Maybe$Just(revision);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	var fromService = $author$project$Pages$Partner$Products$Id_String$AppBuilder$latestRevisionFromServices(model);
	var _v0 = _Utils_Tuple2(fromService, fromSubmit);
	if (!_v0.a.$) {
		if (!_v0.b.$) {
			var sRev = _v0.a.a;
			var bRev = _v0.b.a;
			return _Utils_eq(
				$author$project$Api$Partner$App$AppRevision$One$id(sRev),
				$author$project$Api$Partner$App$AppRevision$One$id(bRev)) ? $elm$core$Maybe$Just(sRev) : $elm$core$Maybe$Just(bRev);
		} else {
			var sRev = _v0.a.a;
			var _v1 = _v0.b;
			return $elm$core$Maybe$Just(sRev);
		}
	} else {
		if (!_v0.b.$) {
			var _v2 = _v0.a;
			var bRev = _v0.b.a;
			return $elm$core$Maybe$Just(bRev);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $author$project$Api$Partner$App$AppRevision$One$status = function (_v0) {
	var r = _v0;
	return r.alH;
};
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$freshestRevisionStatus = function (model) {
	return A2(
		$elm$core$Maybe$map,
		$author$project$Api$Partner$App$AppRevision$One$status,
		$author$project$Pages$Partner$Products$Id_String$AppBuilder$freshestRevision(model));
};
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$isGenerating = function (model) {
	var _v0 = $author$project$Pages$Partner$Products$Id_String$AppBuilder$freshestRevisionStatus(model);
	if ((!_v0.$) && (_v0.a === 'generating')) {
		return true;
	} else {
		return _Utils_eq(model.qo, $author$project$Api$Data$Loading);
	}
};
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$subscriptions = function (model) {
	return $author$project$Pages$Partner$Products$Id_String$AppBuilder$isGenerating(model) ? A2(
		$elm$time$Time$every,
		2000,
		function (_v0) {
			return $author$project$Pages$Partner$Products$Id_String$AppBuilder$PollTick;
		}) : $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$GotWireAnchorResponse = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$GotWireHandshakeResponse = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$GotWireHeadlessResponse = function (a) {
	return {$: 13, a: a};
};
var $author$project$Api$Partner$App$HandshakeUrl = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Partner$AppAnchor$SourceUrl = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$SubmittedRevision = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$anchorTypeFromValue = function (value) {
	switch (value) {
		case 'clinical_interaction':
			return 1;
		case 'settings':
			return 3;
		default:
			return 0;
	}
};
var $author$project$Api$Partner$App$anchors = function (_v0) {
	var record = _v0;
	return record.Gr;
};
var $author$project$Api$Partner$PartnerService$All$serviceUrl = function (_v0) {
	var record = _v0;
	return record.aa3;
};
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$currentServiceUrl = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		$author$project$Api$Partner$PartnerService$All$serviceUrl,
		$author$project$Pages$Partner$Products$Id_String$AppBuilder$currentService(model));
};
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$handshakeRowId = 'handshake';
var $author$project$Api$Partner$App$handshakeUrl = function (_v0) {
	var record = _v0;
	return record.S2;
};
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$headlessAuthType = 'automatic_headless';
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$headlessRowId = 'headless';
var $author$project$Api$Partner$AppAnchor$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Partner$AppAnchor$sourceUrl = function (_v0) {
	var record = _v0;
	return record.abO;
};
var $author$project$Api$Partner$AppAnchor$typeToValue = function (anchorType) {
	switch (anchorType) {
		case 0:
			return 'core_page';
		case 1:
			return 'clinical_interaction';
		case 2:
			return 'clinical_chart';
		default:
			return 'settings';
	}
};
var $author$project$Api$Partner$AppAnchor$type_ = function (_v0) {
	var record = _v0;
	return record.amg;
};
var $author$project$Api$Common$PartnerApp$PartnerRole$encode = function (_v0) {
	var record = _v0;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(record.Bq)),
				_Utils_Tuple2(
				'description',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, record.Qr))
			]));
};
var $author$project$Api$Partner$App$encodePermittedFields = function (permittedFields) {
	var encodedFields = A3(
		$elm$core$List$foldl,
		F2(
			function (field, acc) {
				switch (field.$) {
					case 0:
						var maybeUrl = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'handshake_url',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, maybeUrl)),
							acc);
					case 1:
						var roles = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'partner_roles',
								A2($elm$json$Json$Encode$list, $author$project$Api$Common$PartnerApp$PartnerRole$encode, roles)),
							acc);
					case 2:
						var maybeRole = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'default_admin_role',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, maybeRole)),
							acc);
					case 3:
						var maybeRole = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'default_non_admin_role',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, maybeRole)),
							acc);
					case 4:
						var value = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'prepopulate_role_mappings',
								$elm$json$Json$Encode$bool(value)),
							acc);
					default:
						var value = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'localhost_mode',
								$elm$json$Json$Encode$bool(value)),
							acc);
				}
			}),
		_List_Nil,
		permittedFields);
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'app',
				$elm$json$Json$Encode$object(encodedFields))
			]));
};
var $author$project$Api$Partner$App$update = F3(
	function (apiClient, permittedFields, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Partner$App$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Partner$App$encodePermittedFields(permittedFields),
				$author$project$Api$Data$requestTo($author$project$Api$Partner$App$appPath)));
	});
var $author$project$Api$Partner$AppAnchor$appAnchorsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['app', 'anchors']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$AppAnchor$appAnchorPath = function (anchorId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[anchorId]),
		$author$project$Api$Partner$AppAnchor$appAnchorsPath);
};
var $author$project$Api$Partner$AppAnchor$encodePermittedFields = function (permittedFields) {
	var encodedFields = A3(
		$elm$core$List$foldl,
		F2(
			function (field, acc) {
				switch (field.$) {
					case 0:
						var anchorType = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'type',
								$elm$json$Json$Encode$string(
									$author$project$Api$Partner$AppAnchor$typeToValue(anchorType))),
							acc);
					case 1:
						var url = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'source_url',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, url)),
							acc);
					case 3:
						var description = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'interaction_description',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, description)),
							acc);
					case 2:
						var title = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'interaction_title',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, title)),
							acc);
					case 4:
						var interactionType_ = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'interaction_type',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, interactionType_)),
							acc);
					case 5:
						var icon = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'core_page_icon',
								$elm$json$Json$Encode$string(icon)),
							acc);
					case 6:
						var label = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'core_page_icon_label',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, label)),
							acc);
					case 7:
						var autoAdjustHeight = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'core_page_auto_adjust_height',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$bool, autoAdjustHeight)),
							acc);
					case 8:
						var icon = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'clinical_chart_icon',
								$elm$json$Json$Encode$string(icon)),
							acc);
					case 9:
						var label = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'clinical_chart_icon_label',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, label)),
							acc);
					default:
						var label = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'settings_label',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, label)),
							acc);
				}
			}),
		_List_Nil,
		permittedFields);
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'anchor',
				$elm$json$Json$Encode$object(encodedFields))
			]));
};
var $author$project$Api$Partner$AppAnchor$update = F4(
	function (apiClient, anchorId, permittedFields, toMsg) {
		var body = $author$project$Api$Partner$AppAnchor$encodePermittedFields(permittedFields);
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Partner$AppAnchor$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Partner$AppAnchor$appAnchorPath(anchorId))));
	});
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$connectAll = function (model) {
	var _v0 = _Utils_Tuple2(
		$author$project$Pages$Partner$Products$Id_String$AppBuilder$currentServiceUrl(model),
		model.rl);
	if ((!_v0.a.$) && (_v0.b.$ === 3)) {
		var serviceUrl = _v0.a.a;
		var _v1 = _v0.b;
		var app = _v1.a;
		var redirectProposed = serviceUrl + '/hint/connect/';
		var pendingAnchors = A2(
			$elm$core$List$filter,
			function (a) {
				return !_Utils_eq(
					$author$project$Api$Partner$AppAnchor$sourceUrl(a),
					serviceUrl + ('/hint/' + $author$project$Api$Partner$AppAnchor$typeToValue(
						$author$project$Api$Partner$AppAnchor$type_(a))));
			},
			$author$project$Api$Partner$App$anchors(app));
		var pendingAnchorIds = A2($elm$core$List$map, $author$project$Api$Partner$AppAnchor$id, pendingAnchors);
		var headlessPending = (!_Utils_eq(
			$author$project$Api$Partner$Partner$One$redirectUrl(model.YN),
			$elm$core$Maybe$Just(redirectProposed))) || (!_Utils_eq(
			$author$project$Api$Partner$Partner$One$authType(model.YN),
			$author$project$Pages$Partner$Products$Id_String$AppBuilder$headlessAuthType));
		var headlessRows = headlessPending ? _List_fromArray(
			[$author$project$Pages$Partner$Products$Id_String$AppBuilder$headlessRowId]) : _List_Nil;
		var headlessCmd = headlessPending ? _List_fromArray(
			[
				A3(
				$author$project$Api$Partner$Partner$update,
				model.Gv,
				_List_fromArray(
					[
						$author$project$Api$Partner$Partner$RedirectUrl(
						$elm$core$Maybe$Just(redirectProposed)),
						$author$project$Api$Partner$Partner$AuthType($author$project$Pages$Partner$Products$Id_String$AppBuilder$headlessAuthType)
					]),
				$author$project$Pages$Partner$Products$Id_String$AppBuilder$GotWireHeadlessResponse)
			]) : _List_Nil;
		var handshakeProposed = serviceUrl + '/hint/handshake';
		var handshakePending = !_Utils_eq(
			$author$project$Api$Partner$App$handshakeUrl(app),
			handshakeProposed);
		var handshakeRows = handshakePending ? _List_fromArray(
			[$author$project$Pages$Partner$Products$Id_String$AppBuilder$handshakeRowId]) : _List_Nil;
		var newWiring = A3(
			$elm$core$List$foldl,
			$elm$core$Set$insert,
			model.z,
			_Utils_ap(
				handshakeRows,
				_Utils_ap(headlessRows, pendingAnchorIds)));
		var handshakeCmd = handshakePending ? _List_fromArray(
			[
				A3(
				$author$project$Api$Partner$App$update,
				model.Gv,
				_List_fromArray(
					[
						$author$project$Api$Partner$App$HandshakeUrl(
						$elm$core$Maybe$Just(handshakeProposed))
					]),
				$author$project$Pages$Partner$Products$Id_String$AppBuilder$GotWireHandshakeResponse)
			]) : _List_Nil;
		var anchorCmds = A2(
			$elm$core$List$map,
			function (a) {
				var proposed = serviceUrl + ('/hint/' + $author$project$Api$Partner$AppAnchor$typeToValue(
					$author$project$Api$Partner$AppAnchor$type_(a)));
				return A4(
					$author$project$Api$Partner$AppAnchor$update,
					model.Gv,
					$author$project$Api$Partner$AppAnchor$id(a),
					_List_fromArray(
						[
							$author$project$Api$Partner$AppAnchor$SourceUrl(
							$elm$core$Maybe$Just(proposed))
						]),
					$author$project$Pages$Partner$Products$Id_String$AppBuilder$GotWireAnchorResponse(
						$author$project$Api$Partner$AppAnchor$id(a)));
			},
			pendingAnchors);
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{z: newWiring}),
			$elm$core$Platform$Cmd$batch(
				_Utils_ap(
					handshakeCmd,
					_Utils_ap(headlessCmd, anchorCmds))),
			_List_Nil);
	} else {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	}
};
var $author$project$Api$Partner$App$VibeCode$vibeCodePath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['app', 'vibe_code']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$App$VibeCode$submit = F4(
	function (apiClient, promptText, anchorType, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$App$AppRevision$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'prompt',
							$elm$json$Json$Encode$string(promptText)),
							_Utils_Tuple2(
							'anchor_type',
							$elm$json$Json$Encode$string(
								$author$project$Api$Partner$AppAnchor$typeToValue(anchorType)))
						])),
				$author$project$Api$Data$requestTo($author$project$Api$Partner$App$VibeCode$vibeCodePath)));
	});
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{uw: response}),
					$elm$core$Platform$Cmd$none,
					function () {
						if ((response.$ === 2) && (response.a.$ === 5)) {
							var _v2 = response.a;
							return _List_Nil;
						} else {
							return $author$project$OutMsg$handleErrorResponse(response);
						}
					}());
			case 1:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{rl: response}),
					$elm$core$Platform$Cmd$none,
					function () {
						if ((response.$ === 2) && (response.a.$ === 5)) {
							var _v4 = response.a;
							return _List_Nil;
						} else {
							return $author$project$OutMsg$handleErrorResponse(response);
						}
					}());
			case 2:
				var value = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{akj: value}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var value = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aeY: $author$project$Pages$Partner$Products$Id_String$AppBuilder$anchorTypeFromValue(value)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qo: $author$project$Api$Data$Loading}),
					A4($author$project$Api$Partner$App$VibeCode$submit, model.Gv, model.akj, model.aeY, $author$project$Pages$Partner$Products$Id_String$AppBuilder$SubmittedRevision),
					_List_Nil);
			case 5:
				var response = msg.a;
				var reloadCmds = function () {
					if (response.$ === 3) {
						return $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($author$project$Api$Partner$PartnerService$list, model.Gv, $author$project$Pages$Partner$Products$Id_String$AppBuilder$GotServices),
									A2($author$project$Api$Partner$App$retrieve, model.Gv, $author$project$Pages$Partner$Products$Id_String$AppBuilder$GotApp)
								]));
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qo: response}),
					reloadCmds,
					$author$project$OutMsg$handleErrorResponse(response));
			case 6:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{vs: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 7:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{vs: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 8:
				var proposedUrl = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							z: A2($elm$core$Set$insert, $author$project$Pages$Partner$Products$Id_String$AppBuilder$handshakeRowId, model.z)
						}),
					A3(
						$author$project$Api$Partner$App$update,
						model.Gv,
						_List_fromArray(
							[
								$author$project$Api$Partner$App$HandshakeUrl(
								$elm$core$Maybe$Just(proposedUrl))
							]),
						$author$project$Pages$Partner$Products$Id_String$AppBuilder$GotWireHandshakeResponse),
					_List_Nil);
			case 9:
				var response = msg.a;
				var wiringRows = A2($elm$core$Set$remove, $author$project$Pages$Partner$Products$Id_String$AppBuilder$handshakeRowId, model.z);
				var outMsgs = function () {
					if (response.$ === 3) {
						return _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Handshake URL wired.')
							]);
					} else {
						return $author$project$OutMsg$handleErrorResponse(response);
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							rl: function () {
								if (response.$ === 3) {
									return response;
								} else {
									return model.rl;
								}
							}(),
							z: wiringRows
						}),
					$elm$core$Platform$Cmd$none,
					outMsgs);
			case 10:
				var anchorId = msg.a;
				var proposedUrl = msg.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							z: A2($elm$core$Set$insert, anchorId, model.z)
						}),
					A4(
						$author$project$Api$Partner$AppAnchor$update,
						model.Gv,
						anchorId,
						_List_fromArray(
							[
								$author$project$Api$Partner$AppAnchor$SourceUrl(
								$elm$core$Maybe$Just(proposedUrl))
							]),
						$author$project$Pages$Partner$Products$Id_String$AppBuilder$GotWireAnchorResponse(anchorId)),
					_List_Nil);
			case 11:
				var anchorId = msg.a;
				var response = msg.b;
				var wiringRows = A2($elm$core$Set$remove, anchorId, model.z);
				var refetchAppCmd = function () {
					if (response.$ === 3) {
						return A2($author$project$Api$Partner$App$retrieve, model.Gv, $author$project$Pages$Partner$Products$Id_String$AppBuilder$GotApp);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				var outMsgs = function () {
					if (response.$ === 3) {
						return _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Anchor source URL wired.')
							]);
					} else {
						return $author$project$OutMsg$handleErrorResponse(response);
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{z: wiringRows}),
					refetchAppCmd,
					outMsgs);
			case 12:
				var proposedUrl = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							z: A2($elm$core$Set$insert, $author$project$Pages$Partner$Products$Id_String$AppBuilder$headlessRowId, model.z)
						}),
					A3(
						$author$project$Api$Partner$Partner$update,
						model.Gv,
						_List_fromArray(
							[
								$author$project$Api$Partner$Partner$RedirectUrl(
								$elm$core$Maybe$Just(proposedUrl)),
								$author$project$Api$Partner$Partner$AuthType($author$project$Pages$Partner$Products$Id_String$AppBuilder$headlessAuthType)
							]),
						$author$project$Pages$Partner$Products$Id_String$AppBuilder$GotWireHeadlessResponse),
					_List_Nil);
			case 13:
				var response = msg.a;
				var wiringRows = A2($elm$core$Set$remove, $author$project$Pages$Partner$Products$Id_String$AppBuilder$headlessRowId, model.z);
				var partner = function () {
					if (response.$ === 3) {
						var p = response.a;
						return p;
					} else {
						return model.YN;
					}
				}();
				var outMsgs = function () {
					if (response.$ === 3) {
						return _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Headless auth wired.')
							]);
					} else {
						return $author$project$OutMsg$handleErrorResponse(response);
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{YN: partner, z: wiringRows}),
					$elm$core$Platform$Cmd$none,
					outMsgs);
			case 14:
				return $author$project$Pages$Partner$Products$Id_String$AppBuilder$connectAll(model);
			case 15:
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Api$Partner$PartnerService$list, model.Gv, $author$project$Pages$Partner$Products$Id_String$AppBuilder$GotServices),
								A2($author$project$Api$Partner$App$retrieve, model.Gv, $author$project$Pages$Partner$Products$Id_String$AppBuilder$GotApp)
							])),
					_List_Nil);
			case 16:
				var mode = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aiN: mode}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 17:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aiN: 0}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 18:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ck: response}),
					$elm$core$Platform$Cmd$none,
					function () {
						if ((response.$ === 2) && (response.a.$ === 5)) {
							var _v13 = response.a;
							return _List_Nil;
						} else {
							return $author$project$OutMsg$handleErrorResponse(response);
						}
					}());
			default:
				var token = msg.a;
				return _Utils_Tuple3(
					model,
					$author$project$Ports$Clipboard$copy(token),
					_List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 3, 'Copied API key to clipboard.')
						]));
		}
	});
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$WireModalOpened = {$: 6};
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$allConnected = function (model) {
	var _v0 = _Utils_Tuple2(
		$author$project$Pages$Partner$Products$Id_String$AppBuilder$currentServiceUrl(model),
		model.rl);
	if ((!_v0.a.$) && (_v0.b.$ === 3)) {
		var serviceUrl = _v0.a.a;
		var _v1 = _v0.b;
		var app = _v1.a;
		return _Utils_eq(
			$author$project$Api$Partner$App$handshakeUrl(app),
			serviceUrl + '/hint/handshake') && (_Utils_eq(
			$author$project$Api$Partner$Partner$One$redirectUrl(model.YN),
			$elm$core$Maybe$Just(serviceUrl + '/hint/connect/')) && (_Utils_eq(
			$author$project$Api$Partner$Partner$One$authType(model.YN),
			$author$project$Pages$Partner$Products$Id_String$AppBuilder$headlessAuthType) && A2(
			$elm$core$List$all,
			function (anchor) {
				return _Utils_eq(
					$author$project$Api$Partner$AppAnchor$sourceUrl(anchor),
					serviceUrl + ('/hint/' + $author$project$Api$Partner$AppAnchor$typeToValue(
						$author$project$Api$Partner$AppAnchor$type_(anchor))));
			},
			$author$project$Api$Partner$App$anchors(app))));
	} else {
		return false;
	}
};
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$viewConnectButton = function (model) {
	var connected = $author$project$Pages$Partner$Products$Id_String$AppBuilder$allConnected(model);
	var canWire = !_Utils_eq(
		$author$project$Pages$Partner$Products$Id_String$AppBuilder$currentServiceUrl(model),
		$elm$core$Maybe$Nothing);
	return A3(
		$author$project$Ui$Button$view,
		{mm: 'Connect app'},
		_List_fromArray(
			[
				connected ? $author$project$Ui$Button$success : $author$project$Ui$Button$primary,
				$author$project$Ui$Button$onClick($author$project$Pages$Partner$Products$Id_String$AppBuilder$WireModalOpened),
				$author$project$Ui$Button$disabled(!canWire)
			]),
		_List_fromArray(
			[
				A2($author$project$Ui$Typography$text, _List_Nil, 'Connect')
			]));
};
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$PromptChanged = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$SubmitClicked = {$: 4};
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$AnchorTypeChanged = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Partner$AppAnchor$typeToLabel = function (anchorType) {
	switch (anchorType) {
		case 0:
			return 'Full Page in Core';
		case 1:
			return 'Interaction on Clinical';
		case 2:
			return 'Chart on Clinical';
		default:
			return 'Settings';
	}
};
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$anchorOption = function (anchor) {
	return A3(
		$author$project$Ui$Form$Select$option,
		_List_Nil,
		$elm$core$Maybe$Just(
			$author$project$Api$Partner$AppAnchor$typeToValue(anchor)),
		$author$project$Api$Partner$AppAnchor$typeToLabel(anchor));
};
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$viewAnchorPicker = F2(
	function (busy, selected) {
		return A2(
			$author$project$Ui$Form$Select$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Select$value(
					$elm$core$Maybe$Just(
						$author$project$Api$Partner$AppAnchor$typeToValue(selected))),
					$author$project$Ui$Form$Select$onChange($author$project$Pages$Partner$Products$Id_String$AppBuilder$AnchorTypeChanged),
					$author$project$Ui$Form$Select$disabled(busy)
				]),
			A2(
				$elm$core$List$map,
				$author$project$Pages$Partner$Products$Id_String$AppBuilder$anchorOption,
				_List_fromArray(
					[0, 1, 3])));
	});
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$viewPromptForm = function (model) {
	var busy = $author$project$Pages$Partner$Products$Id_String$AppBuilder$isGenerating(model);
	return A2(
		$author$project$Ui$Form$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mb3]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Ui$Typography$text, _List_Nil, 'Anchor')
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$muted]),
						_List_fromArray(
							[
								A2($author$project$Ui$Typography$text, _List_Nil, 'Which surface of the app is this prompt for?')
							])),
						A2($author$project$Pages$Partner$Products$Id_String$AppBuilder$viewAnchorPicker, busy, model.aeY)
					])),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mb3]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Textarea$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Textarea$value(model.akj),
								$author$project$Ui$Form$Textarea$onInput($author$project$Pages$Partner$Products$Id_String$AppBuilder$PromptChanged),
								$author$project$Ui$Form$Textarea$rows(8),
								$author$project$Ui$Form$Textarea$placeholder('Describe what you want to build...'),
								$author$project$Ui$Form$Textarea$disabled(busy)
							]))
					])),
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Submit prompt'},
				_List_fromArray(
					[
						$author$project$Ui$Button$primary,
						$author$project$Ui$Button$onClick($author$project$Pages$Partner$Products$Id_String$AppBuilder$SubmitClicked),
						$author$project$Ui$Button$loading(busy),
						$author$project$Ui$Button$disabled(
						busy || $elm$core$String$isEmpty(
							$elm$core$String$trim(model.akj)))
					]),
				_List_fromArray(
					[
						A2($author$project$Ui$Typography$text, _List_Nil, 'Submit')
					]))
			]));
};
var $author$project$Api$Partner$PartnerService$All$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$viewService = function (service) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$mb3]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$p,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$text,
						_List_Nil,
						'Status: ' + $author$project$Api$Partner$PartnerService$All$status(service))
					])),
				function () {
				var _v0 = $author$project$Api$Partner$PartnerService$All$serviceUrl(service);
				if (!_v0.$) {
					var url = _v0.a;
					return A2(
						$author$project$Ui$Typography$p,
						_List_Nil,
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Link$externalHref,
								url,
								_List_fromArray(
									[$author$project$Ui$Link$targetBlank]),
								_List_fromArray(
									[
										A2($author$project$Ui$Typography$text, _List_Nil, url)
									]))
							]));
				} else {
					return A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$muted]),
						_List_fromArray(
							[
								A2($author$project$Ui$Typography$text, _List_Nil, 'URL not yet available.')
							]));
				}
			}()
			]));
};
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$viewServicePanel = function (model) {
	var _v0 = model.uw;
	switch (_v0.$) {
		case 0:
			return A2($author$project$Ui$Element$view, _List_Nil, _List_Nil);
		case 1:
			return A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mb3]),
				_List_fromArray(
					[
						$author$project$Ui$Skeleton$text(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$spanFromText('Status: deployed')
							])),
						$author$project$Ui$Skeleton$text(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$spanFromText('https://service.example.com')
							]))
					]));
		case 2:
			return A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$danger]),
				_List_fromArray(
					[
						A2($author$project$Ui$Typography$text, _List_Nil, 'Failed to load service status.')
					]));
		default:
			var list = _v0.a;
			var _v1 = $elm$core$List$head(list);
			if (_v1.$ === 1) {
				return A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Ui$Typography$text, _List_Nil, 'No service deployed yet. Submit a prompt above to create one.')
						]));
			} else {
				var service = _v1.a;
				return $author$project$Pages$Partner$Products$Id_String$AppBuilder$viewService(service);
			}
	}
};
var $author$project$Api$Partner$App$AppRevision$One$commitSha = function (_v0) {
	var r = _v0;
	return r.N8;
};
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$revisionStatusBlock = function (revision) {
	var _v0 = $author$project$Api$Partner$App$AppRevision$One$status(revision);
	switch (_v0) {
		case 'generating':
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Ui$Typography$text, _List_Nil, 'Generating your app — this can take ~30 seconds. The page will refresh when it\'s ready.')
						])),
					$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$spanFromText('Revision prev-xxxxxxxxx — generating')
						]))
				]);
		case 'pushed':
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$text,
							_List_Nil,
							'Generated. Revision ' + $author$project$Api$Partner$App$AppRevision$One$id(revision))
						])),
					function () {
					var _v1 = $author$project$Api$Partner$App$AppRevision$One$commitSha(revision);
					if (!_v1.$) {
						var sha = _v1.a;
						return A2(
							$author$project$Ui$Typography$p,
							_List_fromArray(
								[$author$project$Ui$Typography$muted]),
							_List_fromArray(
								[
									A2($author$project$Ui$Typography$text, _List_Nil, 'Commit: ' + sha)
								]));
					} else {
						return $elm$html$Html$text('');
					}
				}()
				]);
		case 'failed':
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$danger]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$text,
							_List_Nil,
							'Revision ' + ($author$project$Api$Partner$App$AppRevision$One$id(revision) + ' failed. Try a different prompt or check service logs.'))
						]))
				]);
		default:
			var status = _v0;
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$text,
							_List_Nil,
							'Revision ' + ($author$project$Api$Partner$App$AppRevision$One$id(revision) + (' — ' + status)))
						]))
				]);
	}
};
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$viewSubmitResult = function (model) {
	var _v0 = $author$project$Pages$Partner$Products$Id_String$AppBuilder$freshestRevision(model);
	if (_v0.$ === 1) {
		return $elm$html$Html$text('');
	} else {
		var revision = _v0.a;
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mt3]),
			$author$project$Pages$Partner$Products$Id_String$AppBuilder$revisionStatusBlock(revision));
	}
};
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$ClearedMode = {$: 17};
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$viewSwitchModeLink = A3(
	$author$project$Ui$Button$view,
	{mm: 'Switch mode'},
	_List_fromArray(
		[
			$author$project$Ui$Button$link,
			$author$project$Ui$Button$onClick($author$project$Pages$Partner$Products$Id_String$AppBuilder$ClearedMode)
		]),
	_List_fromArray(
		[
			A2($author$project$Ui$Typography$text, _List_Nil, 'Switch mode')
		]));
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$ConnectAllClicked = {$: 14};
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$WireModalClosed = {$: 7};
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$WireAnchorClicked = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Api$Partner$AppAnchor$typeLabel = function (_v0) {
	var record = _v0;
	return $author$project$Api$Partner$AppAnchor$typeToLabel(record.amg);
};
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$viewWireRow = function (opts) {
	var currentDisplay = $elm$core$String$isEmpty(opts.i2) ? '(unset)' : opts.i2;
	var alreadyWired = opts.sq || _Utils_eq(opts.i2, opts.ps);
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$mb3]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$gap2]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Ui$Typography$text, _List_Nil, opts.aih)
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: opts.mm},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$onClick(opts.ts),
								$author$project$Ui$Button$loading(opts.ob),
								$author$project$Ui$Button$disabled(alreadyWired || opts.ob)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$text,
								_List_Nil,
								alreadyWired ? 'Connected' : 'Connect')
							]))
					])),
				A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$muted]),
				_List_fromArray(
					[
						A2($author$project$Ui$Typography$text, _List_Nil, 'Current: ' + currentDisplay)
					])),
				A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$muted]),
				_List_fromArray(
					[
						A2($author$project$Ui$Typography$text, _List_Nil, 'Proposed: ' + opts.ps)
					]))
			]));
};
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$viewAnchorRow = F3(
	function (model, serviceUrl, anchor) {
		var proposed = serviceUrl + ('/hint/' + $author$project$Api$Partner$AppAnchor$typeToValue(
			$author$project$Api$Partner$AppAnchor$type_(anchor)));
		var anchorId = $author$project$Api$Partner$AppAnchor$id(anchor);
		return $author$project$Pages$Partner$Products$Id_String$AppBuilder$viewWireRow(
			{
				mm: 'Wire ' + ($author$project$Api$Partner$AppAnchor$typeLabel(anchor) + ' anchor'),
				i2: $author$project$Api$Partner$AppAnchor$sourceUrl(anchor),
				sq: false,
				ob: A2($elm$core$Set$member, anchorId, model.z),
				aih: $author$project$Api$Partner$AppAnchor$typeLabel(anchor) + ' (anchor)',
				ts: A2($author$project$Pages$Partner$Products$Id_String$AppBuilder$WireAnchorClicked, anchorId, proposed),
				ps: proposed
			});
	});
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$WireHandshakeClicked = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$viewHandshakeRow = F3(
	function (model, app, serviceUrl) {
		var proposed = serviceUrl + '/hint/handshake';
		var currentValue = $author$project$Api$Partner$App$handshakeUrl(app);
		return $author$project$Pages$Partner$Products$Id_String$AppBuilder$viewWireRow(
			{
				mm: 'Wire handshake URL',
				i2: currentValue,
				sq: false,
				ob: A2($elm$core$Set$member, $author$project$Pages$Partner$Products$Id_String$AppBuilder$handshakeRowId, model.z),
				aih: 'Handshake URL',
				ts: $author$project$Pages$Partner$Products$Id_String$AppBuilder$WireHandshakeClicked(proposed),
				ps: proposed
			});
	});
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$WireHeadlessClicked = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$viewHeadlessRow = F2(
	function (model, serviceUrl) {
		var proposed = serviceUrl + '/hint/connect/';
		var currentValue = A2(
			$elm$core$Maybe$withDefault,
			'',
			$author$project$Api$Partner$Partner$One$redirectUrl(model.YN));
		var currentAuthType = $author$project$Api$Partner$Partner$One$authType(model.YN);
		var alreadyWired = _Utils_eq(currentValue, proposed) && _Utils_eq(currentAuthType, $author$project$Pages$Partner$Products$Id_String$AppBuilder$headlessAuthType);
		return $author$project$Pages$Partner$Products$Id_String$AppBuilder$viewWireRow(
			{
				mm: 'Wire headless auth',
				i2: _Utils_eq(currentAuthType, $author$project$Pages$Partner$Products$Id_String$AppBuilder$headlessAuthType) ? currentValue : (currentValue + ('  (auth_type=' + (currentAuthType + ')'))),
				sq: alreadyWired,
				ob: A2($elm$core$Set$member, $author$project$Pages$Partner$Products$Id_String$AppBuilder$headlessRowId, model.z),
				aih: 'Headless Auth (redirect URL + auth_type=automatic_headless)',
				ts: $author$project$Pages$Partner$Products$Id_String$AppBuilder$WireHeadlessClicked(proposed),
				ps: proposed
			});
	});
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$viewWireRows = function (model) {
	var _v0 = _Utils_Tuple2(
		model.rl,
		$author$project$Pages$Partner$Products$Id_String$AppBuilder$currentService(model));
	_v0$3:
	while (true) {
		switch (_v0.a.$) {
			case 3:
				if (!_v0.b.$) {
					var _v1 = _v0.a;
					var app = _v1.a;
					var service = _v0.b.a;
					var _v2 = $author$project$Api$Partner$PartnerService$All$serviceUrl(service);
					if (!_v2.$) {
						var serviceUrl = _v2.a;
						return A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$mt3]),
							A2(
								$elm$core$List$cons,
								A3($author$project$Pages$Partner$Products$Id_String$AppBuilder$viewHandshakeRow, model, app, serviceUrl),
								A2(
									$elm$core$List$cons,
									A2($author$project$Pages$Partner$Products$Id_String$AppBuilder$viewHeadlessRow, model, serviceUrl),
									A2(
										$elm$core$List$map,
										A2($author$project$Pages$Partner$Products$Id_String$AppBuilder$viewAnchorRow, model, serviceUrl),
										$author$project$Api$Partner$App$anchors(app)))));
					} else {
						return A2(
							$author$project$Ui$Typography$p,
							_List_fromArray(
								[$author$project$Ui$Typography$muted]),
							_List_fromArray(
								[
									A2($author$project$Ui$Typography$text, _List_Nil, 'Service URL is not available yet.')
								]));
					}
				} else {
					break _v0$3;
				}
			case 1:
				var _v3 = _v0.a;
				return $author$project$Ui$Skeleton$text(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$spanFromText('Loading app and anchors…')
						]));
			case 2:
				return A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$danger]),
					_List_fromArray(
						[
							A2($author$project$Ui$Typography$text, _List_Nil, 'Failed to load app.')
						]));
			default:
				break _v0$3;
		}
	}
	return A2(
		$author$project$Ui$Typography$p,
		_List_fromArray(
			[$author$project$Ui$Typography$muted]),
		_List_fromArray(
			[
				A2($author$project$Ui$Typography$text, _List_Nil, 'No service or app available.')
			]));
};
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$viewWireModal = function (model) {
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Pages$Partner$Products$Id_String$AppBuilder$WireModalClosed,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Connect app')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$muted]),
						_List_fromArray(
							[
								A2($author$project$Ui$Typography$text, _List_Nil, 'Point this app\'s handshake URL, headless auth redirect, and anchor source URLs at the deployed marketplace template.')
							])),
						$author$project$Pages$Partner$Products$Id_String$AppBuilder$viewWireRows(model)
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Close connect app modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$secondary,
								$author$project$Ui$Button$onClick($author$project$Pages$Partner$Products$Id_String$AppBuilder$WireModalClosed)
							]),
						_List_fromArray(
							[
								A2($author$project$Ui$Typography$text, _List_Nil, 'Close')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Connect all'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$onClick($author$project$Pages$Partner$Products$Id_String$AppBuilder$ConnectAllClicked),
								$author$project$Ui$Button$loading(
								!$elm$core$Set$isEmpty(model.z)),
								$author$project$Ui$Button$disabled(
								$author$project$Pages$Partner$Products$Id_String$AppBuilder$allConnected(model) || _Utils_eq(
									$author$project$Pages$Partner$Products$Id_String$AppBuilder$currentServiceUrl(model),
									$elm$core$Maybe$Nothing))
							]),
						_List_fromArray(
							[
								A2($author$project$Ui$Typography$text, _List_Nil, 'Connect all')
							]))
					]))
			]));
};
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$viewBasic = function (model) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween]),
					_List_fromArray(
						[
							$author$project$Ui$Panel$title(
							_List_fromArray(
								[
									A2($author$project$Ui$Typography$text, _List_Nil, 'Vibe Code')
								])),
							$author$project$Pages$Partner$Products$Id_String$AppBuilder$viewSwitchModeLink
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Partner$Products$Id_String$AppBuilder$viewPromptForm(model),
							$author$project$Pages$Partner$Products$Id_String$AppBuilder$viewSubmitResult(model)
						]))
				])),
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween]),
					_List_fromArray(
						[
							$author$project$Ui$Panel$title(
							_List_fromArray(
								[
									A2($author$project$Ui$Typography$text, _List_Nil, 'Service')
								])),
							$author$project$Pages$Partner$Products$Id_String$AppBuilder$viewConnectButton(model)
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Partner$Products$Id_String$AppBuilder$viewServicePanel(model)
						]))
				])),
			model.vs ? $author$project$Pages$Partner$Products$Id_String$AppBuilder$viewWireModal(model) : $elm$html$Html$text('')
		]);
};
var $author$project$Components$Developers$MarketplaceSkillSteps$BringAll = 1;
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$CopyApiKeyClicked = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Developers$MarketplaceSkillSteps$LoadingKey = {$: 0};
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$apiKeyState = function (model) {
	var _v0 = model.ck;
	switch (_v0.$) {
		case 1:
			return $author$project$Components$Developers$MarketplaceSkillSteps$LoadingKey;
		case 3:
			var keys = _v0.a;
			var _v1 = $elm$core$List$head(keys);
			if (!_v1.$) {
				var key = _v1.a;
				return $author$project$Components$Developers$MarketplaceSkillSteps$KeyReady(
					$author$project$Api$Partner$ApiKey$All$token(key));
			} else {
				return $author$project$Components$Developers$MarketplaceSkillSteps$NoKey;
			}
		default:
			return $author$project$Components$Developers$MarketplaceSkillSteps$NoKey;
	}
};
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$skillStepsConfig = F2(
	function (flow, model) {
		return {
			LU: $author$project$Pages$Partner$Products$Id_String$AppBuilder$apiKeyState(model),
			SB: flow,
			Wo: $elm$core$Maybe$Nothing,
			Wp: false,
			g$: $author$project$Pages$Partner$Products$Id_String$AppBuilder$CopyApiKeyClicked
		};
	});
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$viewBringAll = function (model) {
	return $author$project$Components$Developers$MarketplaceSkillSteps$view(
		A2($author$project$Pages$Partner$Products$Id_String$AppBuilder$skillStepsConfig, 1, model));
};
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$viewBringCode = function (model) {
	return $author$project$Components$Developers$MarketplaceSkillSteps$view(
		A2($author$project$Pages$Partner$Products$Id_String$AppBuilder$skillStepsConfig, 0, model));
};
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$Basic = 1;
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$BringAll = 3;
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$BringCode = 2;
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$SelectedMode = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$viewModePicker = A2(
	$author$project$Ui$Panel$view,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Panel$heading,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Panel$title(
					_List_fromArray(
						[
							A2($author$project$Ui$Typography$text, _List_Nil, 'How are you building this app?')
						]))
				])),
			A2(
			$author$project$Ui$Panel$body,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$muted]),
					_List_fromArray(
						[
							A2($author$project$Ui$Typography$text, _List_Nil, 'Pick how you want to build and deploy. You can switch later.')
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$gap4, $author$project$Ui$Element$mt4]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Radio$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Radio$card,
									$author$project$Ui$Form$Radio$value(false),
									$author$project$Ui$Form$Radio$onCheck(
									function (_v0) {
										return $author$project$Pages$Partner$Products$Id_String$AppBuilder$SelectedMode(1);
									})
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$titleSm,
									_List_Nil,
									_List_fromArray(
										[
											A2($author$project$Ui$Typography$text, _List_Nil, 'Build it in the web')
										])),
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$small, $author$project$Ui$Typography$helpBlock]),
									_List_fromArray(
										[
											A2($author$project$Ui$Typography$text, _List_Nil, 'Use the in-portal AI builder. No setup; everything happens right here.')
										]))
								])),
							A2(
							$author$project$Ui$Form$Radio$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Radio$card,
									$author$project$Ui$Form$Radio$value(false),
									$author$project$Ui$Form$Radio$onCheck(
									function (_v1) {
										return $author$project$Pages$Partner$Products$Id_String$AppBuilder$SelectedMode(2);
									})
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$titleSm,
									_List_Nil,
									_List_fromArray(
										[
											A2($author$project$Ui$Typography$text, _List_Nil, 'Bring your code, we host it')
										])),
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$small, $author$project$Ui$Typography$helpBlock]),
									_List_fromArray(
										[
											A2($author$project$Ui$Typography$text, _List_Nil, 'You write the code in your own stack; we deploy and run it for you.')
										]))
								])),
							A2(
							$author$project$Ui$Form$Radio$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Radio$card,
									$author$project$Ui$Form$Radio$value(false),
									$author$project$Ui$Form$Radio$onCheck(
									function (_v2) {
										return $author$project$Pages$Partner$Products$Id_String$AppBuilder$SelectedMode(3);
									})
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$titleSm,
									_List_Nil,
									_List_fromArray(
										[
											A2($author$project$Ui$Typography$text, _List_Nil, 'Bring everything')
										])),
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$small, $author$project$Ui$Typography$helpBlock]),
									_List_fromArray(
										[
											A2($author$project$Ui$Typography$text, _List_Nil, 'You host the app on your own infrastructure; we just register the URLs.')
										]))
								]))
						]))
				]))
		]));
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$view = function (model) {
	return {
		fO: function () {
			var _v0 = model.aiN;
			switch (_v0) {
				case 0:
					return _List_fromArray(
						[$author$project$Pages$Partner$Products$Id_String$AppBuilder$viewModePicker]);
				case 1:
					return $author$project$Pages$Partner$Products$Id_String$AppBuilder$viewBasic(model);
				case 2:
					return $author$project$Pages$Partner$Products$Id_String$AppBuilder$viewBringCode(model);
				default:
					return $author$project$Pages$Partner$Products$Id_String$AppBuilder$viewBringAll(model);
			}
		}(),
		ac9: 'Partner | Product | App Builder'
	};
};
var $author$project$Pages$Partner$Products$Id_String$AppBuilder$page = $author$project$Spa$Page$applicationPartner(
	{ah_: $author$project$Pages$Partner$Products$Id_String$AppBuilder$init, aiq: $author$project$Pages$Partner$Products$Id_String$AppBuilder$load, k8: $author$project$Pages$Partner$Products$Id_String$AppBuilder$save, alO: $author$project$Pages$Partner$Products$Id_String$AppBuilder$subscriptions, adT: $author$project$Pages$Partner$Products$Id_String$AppBuilder$update, amo: $author$project$Pages$Partner$Products$Id_String$AppBuilder$view});
var $author$project$Pages$Partner$Products$Id_String$AppSettings$GotApp = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$AppAnchors$NavMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Partner$AppAnchors$TypeDropdownMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Partner$AppAnchors$init = F2(
	function (isHintAdmin, anchors) {
		var _v0 = A2($author$project$Ui$Nav$init, 'app-anchors-nav', $author$project$Components$Partner$AppAnchors$NavMsg);
		var navModel = _v0.a;
		var navCmd = _v0.b;
		return _Utils_Tuple2(
			{
				as: $elm$core$Maybe$Nothing,
				ip: $author$project$Api$Data$NotAsked,
				Gr: anchors,
				r$: $author$project$Api$Data$NotAsked,
				nd: false,
				Ij: isHintAdmin,
				kp: navModel,
				bL: A2(
					$elm$core$Maybe$map,
					$author$project$Api$Partner$AppAnchor$id,
					$elm$core$List$head(anchors)),
				qI: $author$project$Ui$Dropdown$init(
					$author$project$Ui$Dropdown$defaultConfig(
						{ahP: 'anchor-type-dropdown', al6: $author$project$Components$Partner$AppAnchors$TypeDropdownMsg}))
			},
			navCmd);
	});
var $author$project$Pages$Partner$Products$Id_String$AppSettings$init = F4(
	function (_v0, partner, shared, _v1) {
		var isHintAdmin = $author$project$Shared$isHintAdmin(shared);
		return _Utils_Tuple2(
			{
				Gv: shared.Gv,
				rl: $author$project$Api$Data$Loading,
				iq: A2($author$project$Components$Partner$AppAnchors$init, isHintAdmin, _List_Nil).a,
				af: $elm$core$Maybe$Nothing,
				Ij: isHintAdmin,
				oL: '',
				kr: '',
				YN: partner,
				u5: false,
				qv: $author$project$Api$Data$NotAsked,
				qP: $author$project$Api$Data$NotAsked
			},
			A2($author$project$Api$Partner$App$retrieve, shared.Gv, $author$project$Pages$Partner$Products$Id_String$AppSettings$GotApp));
	});
var $author$project$Pages$Partner$Products$Id_String$AppSettings$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					Ij: $author$project$Shared$isHintAdmin(shared)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Partner$Products$Id_String$AppSettings$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Partner$Products$Id_String$AppSettings$AppAnchorsMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$AppSettings$EditModalClosed = {$: 4};
var $author$project$Pages$Partner$Products$Id_String$AppSettings$TestHandshakeModalClosed = {$: 9};
var $author$project$Components$Partner$AppAnchors$AnchorModalClosed = {$: 7};
var $author$project$Components$Partner$AppAnchors$DeleteConfirmModalClosed = {$: 4};
var $author$project$Components$Partner$AppAnchors$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Partner$AppAnchors$AnchorModalClosed),
				$author$project$Ui$Nav$subscriptions(model.kp),
				$author$project$Ui$Dropdown$subscriptions(model.qI),
				$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Partner$AppAnchors$DeleteConfirmModalClosed)
			]));
};
var $author$project$Pages$Partner$Products$Id_String$AppSettings$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Partner$Products$Id_String$AppSettings$AppAnchorsMsg,
				$author$project$Components$Partner$AppAnchors$subscriptions(model.iq)),
				$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Pages$Partner$Products$Id_String$AppSettings$TestHandshakeModalClosed),
				$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Pages$Partner$Products$Id_String$AppSettings$EditModalClosed)
			]));
};
var $author$project$Api$Partner$App$DefaultAdminRole = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$AppSettings$DefaultAdminRole = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Partner$App$DefaultNonAdminRole = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$AppSettings$DefaultNonAdminRole = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$AppSettings$GotCreatedApp = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$AppSettings$GotTestHandshakeResult = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$AppSettings$GotUpdatedApp = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Partner$App$LocalhostMode = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Partner$App$PartnerRoles = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$AppSettings$PartnerRoles = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Partner$App$PrepopulateRoleMappings = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Partner$App$create = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$App$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Partner$App$appPath));
	});
var $author$project$Api$Partner$App$defaultAdminRole = function (_v0) {
	var record = _v0;
	return record.PX;
};
var $author$project$Api$Partner$App$defaultNonAdminRole = function (_v0) {
	var record = _v0;
	return record.P3;
};
var $author$project$Pages$Partner$Products$Id_String$AppSettings$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var url = field.a;
				return _Utils_update(
					fields,
					{S2: url});
			case 1:
				var roles = field.a;
				return _Utils_update(
					fields,
					{I3: roles});
			case 2:
				var value = field.a;
				return _Utils_update(
					fields,
					{
						PX: $elm$core$String$isEmpty(value) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(value)
					});
			case 3:
				var value = field.a;
				return _Utils_update(
					fields,
					{
						P3: $elm$core$String$isEmpty(value) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(value)
					});
			case 4:
				var value = field.a;
				return _Utils_update(
					fields,
					{_e: value});
			default:
				var value = field.a;
				return _Utils_update(
					fields,
					{V9: value});
		}
	});
var $author$project$Api$Partner$App$handshakeTest = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['handshake_test']),
					$author$project$Api$Partner$App$appPath)));
	});
var $author$project$Api$Common$PartnerApp$PartnerRole$init = function (record) {
	return record;
};
var $author$project$Api$Partner$App$localhostMode = function (_v0) {
	var record = _v0;
	return record.V9;
};
var $author$project$Api$Partner$App$partnerRoles = function (_v0) {
	var record = _v0;
	return record.I3;
};
var $author$project$Api$Partner$App$prepopulateRoleMappings = function (_v0) {
	var record = _v0;
	return record._e;
};
var $author$project$Api$Common$PartnerApp$PartnerRole$setDescription = F2(
	function (value, _v0) {
		var record = _v0;
		return _Utils_update(
			record,
			{Qr: value});
	});
var $author$project$Components$Partner$AppAnchors$AnchorFormUpdated = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Partner$AppAnchors$AnchorType = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Partner$AppAnchor$ClinicalChartIcon = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Partner$AppAnchors$ClinicalChartIcon = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Api$Partner$AppAnchor$ClinicalChartIconLabel = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Partner$AppAnchor$CorePageAutoAdjustHeight = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Partner$AppAnchor$CorePageIcon = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Partner$AppAnchors$CorePageIcon = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Api$Partner$AppAnchor$CorePageIconLabel = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Partner$AppAnchors$GotAnchorResult = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Partner$AppAnchors$GotDeletedAnchor = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Partner$AppAnchor$InteractionDescription = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Partner$AppAnchor$InteractionTitle = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Partner$AppAnchor$InteractionType = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Partner$AppAnchor$SettingsLabel = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Partner$AppAnchor$Type = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$AppAnchors$ClinicalChartCustomization = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$AppAnchors$ClinicalInteractionCustomization = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$AppAnchors$CorePageCustomization = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$AppAnchors$General = 0;
var $author$project$Components$Partner$AppAnchors$SettingsCustomization = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Partner$AppAnchors$initCustomizationFromType = function (type_) {
	switch (type_) {
		case 0:
			return $author$project$Components$Partner$AppAnchors$CorePageCustomization(
				{OH: true, OI: $elm$core$Maybe$Nothing, yR: 0, OJ: $elm$core$Maybe$Nothing, yZ: $elm$core$Maybe$Nothing});
		case 1:
			return $author$project$Components$Partner$AppAnchors$ClinicalInteractionCustomization(
				{Ue: '', Uf: '', Ug: 0});
		case 2:
			return $author$project$Components$Partner$AppAnchors$ClinicalChartCustomization(
				{NL: $elm$core$Maybe$Nothing, x5: 0, NM: $elm$core$Maybe$Nothing, yY: $elm$core$Maybe$Nothing});
		default:
			return $author$project$Components$Partner$AppAnchors$SettingsCustomization(
				{aa5: $elm$core$Maybe$Nothing});
	}
};
var $author$project$Components$Partner$AppAnchors$Lab = 1;
var $author$project$Components$Partner$AppAnchors$interactionTypeFromString = function (s) {
	switch (s) {
		case 'general':
			return $elm$core$Maybe$Just(0);
		case 'lab':
			return $elm$core$Maybe$Just(1);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Partner$AppAnchors$anchorFormFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var type_ = field.a;
				return _Utils_update(
					fields,
					{
						o: $author$project$Components$Partner$AppAnchors$initCustomizationFromType(type_),
						amg: type_
					});
			case 1:
				var url = field.a;
				return _Utils_update(
					fields,
					{abO: url});
			case 5:
				var _int = field.a;
				var string = field.b;
				var _v1 = fields.o;
				if (!_v1.$) {
					var config = _v1.a;
					return _Utils_update(
						fields,
						{
							o: $author$project$Components$Partner$AppAnchors$CorePageCustomization(
								_Utils_update(
									config,
									{
										yR: _int,
										OJ: $elm$core$Maybe$Just(string),
										yZ: $elm$core$Maybe$Just(string)
									}))
						});
				} else {
					return fields;
				}
			case 6:
				var label = field.a;
				var _v2 = fields.o;
				if (!_v2.$) {
					var config = _v2.a;
					return _Utils_update(
						fields,
						{
							o: $author$project$Components$Partner$AppAnchors$CorePageCustomization(
								_Utils_update(
									config,
									{
										OI: $author$project$Utils$String$toMaybe(label)
									}))
						});
				} else {
					return fields;
				}
			case 7:
				var autoAdjust = field.a;
				var _v3 = fields.o;
				if (!_v3.$) {
					var config = _v3.a;
					return _Utils_update(
						fields,
						{
							o: $author$project$Components$Partner$AppAnchors$CorePageCustomization(
								_Utils_update(
									config,
									{OH: autoAdjust}))
						});
				} else {
					return fields;
				}
			case 8:
				var _int = field.a;
				var string = field.b;
				var _v4 = fields.o;
				if (_v4.$ === 2) {
					var config = _v4.a;
					return _Utils_update(
						fields,
						{
							o: $author$project$Components$Partner$AppAnchors$ClinicalChartCustomization(
								_Utils_update(
									config,
									{
										x5: _int,
										NM: $elm$core$Maybe$Just(string),
										yY: $elm$core$Maybe$Just(string)
									}))
						});
				} else {
					return fields;
				}
			case 9:
				var label = field.a;
				var _v5 = fields.o;
				if (_v5.$ === 2) {
					var config = _v5.a;
					return _Utils_update(
						fields,
						{
							o: $author$project$Components$Partner$AppAnchors$ClinicalChartCustomization(
								_Utils_update(
									config,
									{
										NL: $author$project$Utils$String$toMaybe(label)
									}))
						});
				} else {
					return fields;
				}
			case 2:
				var title = field.a;
				var _v6 = fields.o;
				if (_v6.$ === 1) {
					var config = _v6.a;
					return _Utils_update(
						fields,
						{
							o: $author$project$Components$Partner$AppAnchors$ClinicalInteractionCustomization(
								_Utils_update(
									config,
									{Uf: title}))
						});
				} else {
					return fields;
				}
			case 3:
				var description = field.a;
				var _v7 = fields.o;
				if (_v7.$ === 1) {
					var config = _v7.a;
					return _Utils_update(
						fields,
						{
							o: $author$project$Components$Partner$AppAnchors$ClinicalInteractionCustomization(
								_Utils_update(
									config,
									{Ue: description}))
						});
				} else {
					return fields;
				}
			case 4:
				var string = field.a;
				var _v8 = fields.o;
				if (_v8.$ === 1) {
					var config = _v8.a;
					return _Utils_update(
						fields,
						{
							o: $author$project$Components$Partner$AppAnchors$ClinicalInteractionCustomization(
								_Utils_update(
									config,
									{
										Ug: A2(
											$elm$core$Maybe$withDefault,
											0,
											$author$project$Components$Partner$AppAnchors$interactionTypeFromString(string))
									}))
						});
				} else {
					return fields;
				}
			default:
				var label = field.a;
				var _v9 = fields.o;
				if (_v9.$ === 3) {
					var config = _v9.a;
					return _Utils_update(
						fields,
						{
							o: $author$project$Components$Partner$AppAnchors$SettingsCustomization(
								_Utils_update(
									config,
									{
										aa5: $author$project$Utils$String$toMaybe(label)
									}))
						});
				} else {
					return fields;
				}
		}
	});
var $author$project$Api$Partner$AppAnchor$create = F3(
	function (apiClient, permittedFields, toMsg) {
		var body = $author$project$Api$Partner$AppAnchor$encodePermittedFields(permittedFields);
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$AppAnchor$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Partner$AppAnchor$appAnchorsPath)));
	});
var $author$project$Api$Partner$AppAnchor$delete = F3(
	function (apiClient, anchorId, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Partner$AppAnchor$appAnchorPath(anchorId)));
	});
var $author$project$Api$Partner$AppAnchor$clinicalChartIconLabel = function (_v0) {
	var record = _v0;
	return record.NL;
};
var $author$project$Api$Partner$AppAnchor$clinicalChartIconUrl = function (_v0) {
	var record = _v0;
	return record.NM;
};
var $author$project$Api$Partner$AppAnchor$corePageAutoAdjustHeight = function (_v0) {
	var record = _v0;
	return record.OH;
};
var $author$project$Api$Partner$AppAnchor$corePageIconLabel = function (_v0) {
	var record = _v0;
	return record.OI;
};
var $author$project$Api$Partner$AppAnchor$corePageIconUrl = function (_v0) {
	var record = _v0;
	return record.OJ;
};
var $author$project$Api$Partner$AppAnchor$interactionDescription = function (_v0) {
	var record = _v0;
	return record.Ue;
};
var $author$project$Api$Partner$AppAnchor$interactionTitle = function (_v0) {
	var record = _v0;
	return record.Uf;
};
var $author$project$Api$Partner$AppAnchor$interactionType = function (_v0) {
	var record = _v0;
	return record.Ug;
};
var $author$project$Api$Partner$AppAnchor$settingsLabel = function (_v0) {
	var record = _v0;
	return record.aa5;
};
var $author$project$Components$Partner$AppAnchors$initCustomizationFromAnchor = function (anchor) {
	var _v0 = $author$project$Api$Partner$AppAnchor$type_(anchor);
	switch (_v0) {
		case 0:
			return $author$project$Components$Partner$AppAnchors$CorePageCustomization(
				{
					OH: A2(
						$elm$core$Maybe$withDefault,
						true,
						$author$project$Api$Partner$AppAnchor$corePageAutoAdjustHeight(anchor)),
					OI: $author$project$Api$Partner$AppAnchor$corePageIconLabel(anchor),
					yR: 0,
					OJ: $elm$core$Maybe$Nothing,
					yZ: $author$project$Api$Partner$AppAnchor$corePageIconUrl(anchor)
				});
		case 1:
			return $author$project$Components$Partner$AppAnchors$ClinicalInteractionCustomization(
				{
					Ue: A2(
						$elm$core$Maybe$withDefault,
						'',
						$author$project$Api$Partner$AppAnchor$interactionDescription(anchor)),
					Uf: A2(
						$elm$core$Maybe$withDefault,
						'',
						$author$project$Api$Partner$AppAnchor$interactionTitle(anchor)),
					Ug: A2(
						$elm$core$Maybe$withDefault,
						0,
						A2(
							$elm$core$Maybe$andThen,
							$author$project$Components$Partner$AppAnchors$interactionTypeFromString,
							$author$project$Api$Partner$AppAnchor$interactionType(anchor)))
				});
		case 2:
			return $author$project$Components$Partner$AppAnchors$ClinicalChartCustomization(
				{
					NL: $author$project$Api$Partner$AppAnchor$clinicalChartIconLabel(anchor),
					x5: 0,
					NM: $elm$core$Maybe$Nothing,
					yY: $author$project$Api$Partner$AppAnchor$clinicalChartIconUrl(anchor)
				});
		default:
			return $author$project$Components$Partner$AppAnchors$SettingsCustomization(
				{
					aa5: $author$project$Api$Partner$AppAnchor$settingsLabel(anchor)
				});
	}
};
var $author$project$Components$Partner$AppAnchors$interactionTypeToString = function (type_) {
	if (!type_) {
		return 'general';
	} else {
		return 'lab';
	}
};
var $author$project$Components$Partner$AppAnchors$SourceUrlValidation = 0;
var $author$project$Components$Partner$AppAnchors$ClinicalChartIconValidation = 2;
var $author$project$Components$Partner$AppAnchors$CorePageIconValidation = 1;
var $author$project$Components$Partner$AppAnchors$iconTooLargeMessage = 'That image is too large! Our maximum image size is 5 mb, please choose a smaller image.';
var $author$project$Components$Partner$AppAnchors$maxIconBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
var $author$project$Components$Partner$AppAnchors$validateIconSize = function (fields) {
	var _v0 = fields.o;
	switch (_v0.$) {
		case 0:
			var config = _v0.a;
			return (_Utils_cmp(config.yR, $author$project$Components$Partner$AppAnchors$maxIconBytesSize) > 0) ? _List_fromArray(
				[
					_Utils_Tuple2(1, $author$project$Components$Partner$AppAnchors$iconTooLargeMessage)
				]) : _List_Nil;
		case 2:
			var config = _v0.a;
			return (_Utils_cmp(config.x5, $author$project$Components$Partner$AppAnchors$maxIconBytesSize) > 0) ? _List_fromArray(
				[
					_Utils_Tuple2(2, $author$project$Components$Partner$AppAnchors$iconTooLargeMessage)
				]) : _List_Nil;
		case 1:
			return _List_Nil;
		default:
			return _List_Nil;
	}
};
var $author$project$Components$Partner$AppAnchors$validateAnchor = function (form) {
	var validator = $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_validate$Validate$ifBlank,
				function ($) {
					return $.abO;
				},
				_Utils_Tuple2(0, 'Source URL is required')),
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Partner$AppAnchors$validateIconSize)
			]));
	return A2($author$project$Utils$Form$validate, validator, form);
};
var $author$project$Components$Partner$AppAnchors$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var form = $author$project$Utils$Form$init(
					{
						o: $author$project$Components$Partner$AppAnchors$initCustomizationFromType(0),
						abO: '',
						amg: 0
					});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							as: $elm$core$Maybe$Just(
								_Utils_Tuple2($elm$core$Maybe$Nothing, form))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var id = msg.a;
				var _v1 = A2($author$project$Ui$Nav$init, 'app-anchors-nav', $author$project$Components$Partner$AppAnchors$NavMsg);
				var navModel = _v1.a;
				var navCmd = _v1.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							kp: navModel,
							bL: $elm$core$Maybe$Just(id)
						}),
					navCmd,
					_List_Nil);
			case 2:
				var _v2 = _Utils_Tuple2(
					model.bL,
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (anchor) {
								return _Utils_eq(
									$elm$core$Maybe$Just(
										$author$project$Api$Partner$AppAnchor$id(anchor)),
									model.bL);
							},
							model.Gr)));
				if ((!_v2.a.$) && (!_v2.b.$)) {
					var anchorId = _v2.a.a;
					var selectedAnchor = _v2.b.a;
					var form = $author$project$Utils$Form$init(
						{
							o: $author$project$Components$Partner$AppAnchors$initCustomizationFromAnchor(selectedAnchor),
							abO: $author$project$Api$Partner$AppAnchor$sourceUrl(selectedAnchor),
							amg: $author$project$Api$Partner$AppAnchor$type_(selectedAnchor)
						});
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								as: $elm$core$Maybe$Just(
									_Utils_Tuple2(
										$elm$core$Maybe$Just(anchorId),
										form))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nd: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nd: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var _v3 = model.bL;
				if (!_v3.$) {
					var anchorId = _v3.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{r$: $author$project$Api$Data$Loading}),
						A3($author$project$Api$Partner$AppAnchor$delete, apiClient, anchorId, $author$project$Components$Partner$AppAnchors$GotDeletedAnchor),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var response = msg.a;
				if (response.$ === 3) {
					var updatedAnchors = A2(
						$elm$core$List$filter,
						function (anchor) {
							return !_Utils_eq(
								$elm$core$Maybe$Just(
									$author$project$Api$Partner$AppAnchor$id(anchor)),
								model.bL);
						},
						model.Gr);
					var newSelectedId = A2(
						$elm$core$Maybe$map,
						$author$project$Api$Partner$AppAnchor$id,
						$elm$core$List$head(updatedAnchors));
					var _v5 = A2($author$project$Ui$Nav$init, 'app-anchors-nav', $author$project$Components$Partner$AppAnchors$NavMsg);
					var navModel = _v5.a;
					var navCmd = _v5.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Gr: updatedAnchors, r$: $author$project$Api$Data$NotAsked, nd: false, kp: navModel, bL: newSelectedId}),
						navCmd,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Surface deleted successfully!')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{r$: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 7:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{as: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 8:
				var field = msg.a;
				var _v6 = model.as;
				if (!_v6.$) {
					var _v7 = _v6.a;
					var maybeId = _v7.a;
					var form = _v7.b;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Partner$AppAnchors$anchorFormFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								as: $elm$core$Maybe$Just(
									_Utils_Tuple2(maybeId, newForm))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var _v8 = model.as;
				if (!_v8.$) {
					var _v9 = _v8.a;
					var maybeId = _v9.a;
					var form = _v9.b;
					var _v10 = $author$project$Components$Partner$AppAnchors$validateAnchor(form);
					if (!_v10.$) {
						var _v11 = _v10.a;
						var anchorForm = _v11.a;
						var validFields = _v11.b;
						var fields = $rtfeldman$elm_validate$Validate$fromValid(validFields);
						var permittedFields = A2(
							$elm$core$List$cons,
							$author$project$Api$Partner$AppAnchor$Type(fields.amg),
							A2(
								$elm$core$List$cons,
								$author$project$Api$Partner$AppAnchor$SourceUrl(
									$elm$core$Maybe$Just(fields.abO)),
								function () {
									var _v14 = fields.o;
									switch (_v14.$) {
										case 1:
											var config = _v14.a;
											return _List_fromArray(
												[
													$author$project$Api$Partner$AppAnchor$InteractionTitle(
													$author$project$Utils$Maybe$fromString(config.Uf)),
													$author$project$Api$Partner$AppAnchor$InteractionDescription(
													$author$project$Utils$Maybe$fromString(config.Ue)),
													$author$project$Api$Partner$AppAnchor$InteractionType(
													$elm$core$Maybe$Just(
														$author$project$Components$Partner$AppAnchors$interactionTypeToString(config.Ug)))
												]);
										case 0:
											var config = _v14.a;
											return A2(
												$elm$core$List$cons,
												$author$project$Api$Partner$AppAnchor$CorePageIconLabel(config.OI),
												A2(
													$elm$core$List$cons,
													$author$project$Api$Partner$AppAnchor$CorePageAutoAdjustHeight(
														$elm$core$Maybe$Just(config.OH)),
													function () {
														var _v15 = config.OJ;
														if (!_v15.$) {
															var iconUrl = _v15.a;
															return _List_fromArray(
																[
																	$author$project$Api$Partner$AppAnchor$CorePageIcon(iconUrl)
																]);
														} else {
															return _List_Nil;
														}
													}()));
										case 2:
											var config = _v14.a;
											return A2(
												$elm$core$List$cons,
												$author$project$Api$Partner$AppAnchor$ClinicalChartIconLabel(config.NL),
												function () {
													var _v16 = config.NM;
													if (!_v16.$) {
														var iconUrl = _v16.a;
														return _List_fromArray(
															[
																$author$project$Api$Partner$AppAnchor$ClinicalChartIcon(iconUrl)
															]);
													} else {
														return _List_Nil;
													}
												}());
										default:
											var config = _v14.a;
											return _List_fromArray(
												[
													$author$project$Api$Partner$AppAnchor$SettingsLabel(config.aa5)
												]);
									}
								}()));
						var _v12 = function () {
							if (maybeId.$ === 1) {
								return _Utils_Tuple2(
									A3($author$project$Api$Partner$AppAnchor$create, apiClient, permittedFields, $author$project$Components$Partner$AppAnchors$GotAnchorResult),
									_Utils_update(
										model,
										{
											as: $elm$core$Maybe$Just(
												_Utils_Tuple2(maybeId, anchorForm)),
											ip: $author$project$Api$Data$Loading
										}));
							} else {
								var anchorId = maybeId.a;
								return _Utils_Tuple2(
									A4($author$project$Api$Partner$AppAnchor$update, apiClient, anchorId, permittedFields, $author$project$Components$Partner$AppAnchors$GotAnchorResult),
									_Utils_update(
										model,
										{
											as: $elm$core$Maybe$Just(
												_Utils_Tuple2(maybeId, anchorForm)),
											ip: $author$project$Api$Data$Loading
										}));
							}
						}();
						var cmd = _v12.a;
						var updatedModel = _v12.b;
						return _Utils_Tuple3(updatedModel, cmd, _List_Nil);
					} else {
						var formWithErrors = _v10.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									as: $elm$core$Maybe$Just(
										_Utils_Tuple2(maybeId, formWithErrors))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 10:
				var response = msg.a;
				if (response.$ === 3) {
					var anchor = response.a;
					var _v18 = function () {
						var _v19 = model.as;
						if (!_v19.$) {
							if (_v19.a.a.$ === 1) {
								var _v20 = _v19.a;
								var _v21 = _v20.a;
								return _Utils_Tuple3(
									_Utils_ap(
										model.Gr,
										_List_fromArray(
											[anchor])),
									'Surface created successfully!',
									$elm$core$Maybe$Just(
										$author$project$Api$Partner$AppAnchor$id(anchor)));
							} else {
								var _v22 = _v19.a;
								var anchorId = _v22.a.a;
								return _Utils_Tuple3(
									A2(
										$elm$core$List$map,
										function (a) {
											return _Utils_eq(
												$author$project$Api$Partner$AppAnchor$id(a),
												anchorId) ? anchor : a;
										},
										model.Gr),
									'Surface updated successfully!',
									model.bL);
							}
						} else {
							return _Utils_Tuple3(model.Gr, 'Surface saved successfully!', model.bL);
						}
					}();
					var updatedAnchors = _v18.a;
					var toastMessage = _v18.b;
					var newSelectedId = _v18.c;
					var _v23 = A2($author$project$Ui$Nav$init, 'app-anchors-nav', $author$project$Components$Partner$AppAnchors$NavMsg);
					var navModel = _v23.a;
					var navCmd = _v23.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{as: $elm$core$Maybe$Nothing, ip: $author$project$Api$Data$NotAsked, Gr: updatedAnchors, kp: navModel, bL: newSelectedId}),
						navCmd,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, toastMessage)
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ip: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 11:
				var subMsg = msg.a;
				var _v24 = A2($author$project$Ui$Nav$update, subMsg, model.kp);
				var navModel = _v24.a;
				var navCmd = _v24.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{kp: navModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Partner$AppAnchors$NavMsg, navCmd),
					_List_Nil);
			case 12:
				var subMsg = msg.a;
				var _v25 = A2($author$project$Ui$Dropdown$update, subMsg, model.qI);
				var typeDropdown = _v25.a;
				var cmd = _v25.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qI: typeDropdown}),
					cmd,
					_List_Nil);
			case 13:
				var selectedType = msg.a;
				var _v26 = model.as;
				if (!_v26.$) {
					var _v27 = _v26.a;
					var maybeId = _v27.a;
					var form = _v27.b;
					var newForm = A3(
						$author$project$Utils$Form$update,
						$author$project$Components$Partner$AppAnchors$anchorFormFieldsUpdate,
						$author$project$Components$Partner$AppAnchors$AnchorType(selectedType),
						form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								as: $elm$core$Maybe$Just(
									_Utils_Tuple2(maybeId, newForm))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 14:
				var logos = msg.a;
				var cmd = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						function (_v28) {
							var task = _v28.a;
							var size = _v28.b;
							return A2(
								$elm$core$Task$perform,
								A2(
									$elm$core$Basics$composeL,
									$author$project$Components$Partner$AppAnchors$AnchorFormUpdated,
									$author$project$Components$Partner$AppAnchors$CorePageIcon(size)),
								task);
						},
						A2(
							$elm$core$Maybe$map,
							function (logo) {
								return _Utils_Tuple2(
									$elm$file$File$toUrl(logo),
									$elm$file$File$size(logo));
							},
							$elm$core$List$head(logos))));
				return _Utils_Tuple3(model, cmd, _List_Nil);
			default:
				var logos = msg.a;
				var cmd = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						function (_v29) {
							var task = _v29.a;
							var size = _v29.b;
							return A2(
								$elm$core$Task$perform,
								A2(
									$elm$core$Basics$composeL,
									$author$project$Components$Partner$AppAnchors$AnchorFormUpdated,
									$author$project$Components$Partner$AppAnchors$ClinicalChartIcon(size)),
								task);
						},
						A2(
							$elm$core$Maybe$map,
							function (logo) {
								return _Utils_Tuple2(
									$elm$file$File$toUrl(logo),
									$elm$file$File$size(logo));
							},
							$elm$core$List$head(logos))));
				return _Utils_Tuple3(model, cmd, _List_Nil);
		}
	});
var $author$project$Pages$Partner$Products$Id_String$AppSettings$DefaultAdminRoleValidation = 1;
var $author$project$Pages$Partner$Products$Id_String$AppSettings$DefaultNonAdminRoleValidation = 2;
var $author$project$Pages$Partner$Products$Id_String$AppSettings$RoleDescriptionValidation = 0;
var $author$project$Pages$Partner$Products$Id_String$AppSettings$validate = function (form) {
	var hasRoles = function (fields) {
		return !$elm$core$List$isEmpty(fields.I3);
	};
	var missingDefaultAdminRole = function (fields) {
		return hasRoles(fields) && _Utils_eq(fields.PX, $elm$core$Maybe$Nothing);
	};
	var missingDefaultNonAdminRole = function (fields) {
		return hasRoles(fields) && _Utils_eq(fields.P3, $elm$core$Maybe$Nothing);
	};
	var hasEmptyDescriptions = function (fields) {
		return A2(
			$elm$core$List$any,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Api$Common$PartnerApp$PartnerRole$description,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Maybe$withDefault(''),
					$elm$core$String$isEmpty)),
			fields.I3);
	};
	var validator = $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_validate$Validate$ifTrue,
				hasEmptyDescriptions,
				_Utils_Tuple2(0, 'All roles must have a description')),
				A2(
				$rtfeldman$elm_validate$Validate$ifTrue,
				missingDefaultAdminRole,
				_Utils_Tuple2(1, 'Default admin role is required')),
				A2(
				$rtfeldman$elm_validate$Validate$ifTrue,
				missingDefaultNonAdminRole,
				_Utils_Tuple2(2, 'Default non-admin role is required'))
			]));
	return A2($author$project$Utils$Form$validate, validator, form);
};
var $author$project$Pages$Partner$Products$Id_String$AppSettings$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				_v1$2:
				while (true) {
					switch (response.$) {
						case 3:
							var app = response.a;
							var _v2 = A2(
								$author$project$Components$Partner$AppAnchors$init,
								model.Ij,
								$author$project$Api$Partner$App$anchors(app));
							var appAnchors = _v2.a;
							var appAnchorsCmd = _v2.b;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{rl: response, iq: appAnchors}),
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Products$Id_String$AppSettings$AppAnchorsMsg, appAnchorsCmd),
								_List_Nil);
						case 2:
							if (response.a.$ === 5) {
								var _v3 = response.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{rl: response}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							} else {
								break _v1$2;
							}
						default:
							break _v1$2;
					}
				}
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{rl: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				return _Utils_Tuple3(
					model,
					A2($author$project$Api$Partner$App$create, model.Gv, $author$project$Pages$Partner$Products$Id_String$AppSettings$GotCreatedApp),
					_List_Nil);
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{rl: response}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 3:
				var _v5 = model.rl;
				if (_v5.$ === 3) {
					var app = _v5.a;
					var form = $author$project$Utils$Form$init(
						{
							PX: $author$project$Api$Partner$App$defaultAdminRole(app),
							P3: $author$project$Api$Partner$App$defaultNonAdminRole(app),
							S2: $author$project$Api$Partner$App$handshakeUrl(app),
							V9: $author$project$Api$Partner$App$localhostMode(app),
							I3: $author$project$Api$Partner$App$partnerRoles(app),
							_e: $author$project$Api$Partner$App$prepopulateRoleMappings(app)
						});
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								af: $elm$core$Maybe$Just(form),
								kr: ''
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{af: $elm$core$Maybe$Nothing, qP: $author$project$Api$Data$NotAsked}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 12:
				var value = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{kr: value}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 13:
				var value = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oL: value}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 14:
				var _v6 = model.af;
				if (!_v6.$) {
					var form = _v6.a;
					var roleName = $elm$core$String$trim(model.kr);
					if ($elm$core$String$isEmpty(roleName)) {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					} else {
						var fields = $author$project$Utils$Form$fields(form);
						var alreadyExists = A2(
							$elm$core$List$any,
							function (role) {
								return _Utils_eq(
									$author$project$Api$Common$PartnerApp$PartnerRole$name(role),
									roleName);
							},
							fields.I3);
						var newRoles = function () {
							if (alreadyExists) {
								return fields.I3;
							} else {
								var description = $elm$core$String$trim(model.oL);
								return _Utils_ap(
									fields.I3,
									_List_fromArray(
										[
											$author$project$Api$Common$PartnerApp$PartnerRole$init(
											{
												Qr: $elm$core$Maybe$Just(description),
												Bq: roleName
											})
										]));
							}
						}();
						var newForm = A3(
							$author$project$Utils$Form$update,
							$author$project$Pages$Partner$Products$Id_String$AppSettings$formFieldsUpdate,
							$author$project$Pages$Partner$Products$Id_String$AppSettings$PartnerRoles(newRoles),
							form);
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									af: $elm$core$Maybe$Just(newForm),
									oL: '',
									kr: ''
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 15:
				var roleName = msg.a;
				var _v7 = model.af;
				if (!_v7.$) {
					var form = _v7.a;
					var fields = $author$project$Utils$Form$fields(form);
					var newDefaultAdmin = _Utils_eq(
						fields.PX,
						$elm$core$Maybe$Just(roleName)) ? $elm$core$Maybe$Nothing : fields.PX;
					var newDefaultNonAdmin = _Utils_eq(
						fields.P3,
						$elm$core$Maybe$Just(roleName)) ? $elm$core$Maybe$Nothing : fields.P3;
					var newRoles = A2(
						$elm$core$List$filter,
						function (role) {
							return !_Utils_eq(
								$author$project$Api$Common$PartnerApp$PartnerRole$name(role),
								roleName);
						},
						fields.I3);
					var newForm = A3(
						$author$project$Utils$Form$update,
						$author$project$Pages$Partner$Products$Id_String$AppSettings$formFieldsUpdate,
						$author$project$Pages$Partner$Products$Id_String$AppSettings$DefaultNonAdminRole(
							A2($elm$core$Maybe$withDefault, '', newDefaultNonAdmin)),
						A3(
							$author$project$Utils$Form$update,
							$author$project$Pages$Partner$Products$Id_String$AppSettings$formFieldsUpdate,
							$author$project$Pages$Partner$Products$Id_String$AppSettings$DefaultAdminRole(
								A2($elm$core$Maybe$withDefault, '', newDefaultAdmin)),
							A3(
								$author$project$Utils$Form$update,
								$author$project$Pages$Partner$Products$Id_String$AppSettings$formFieldsUpdate,
								$author$project$Pages$Partner$Products$Id_String$AppSettings$PartnerRoles(newRoles),
								form)));
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								af: $elm$core$Maybe$Just(newForm)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 16:
				var roleName = msg.a;
				var description = msg.b;
				var _v8 = model.af;
				if (!_v8.$) {
					var form = _v8.a;
					var fields = $author$project$Utils$Form$fields(form);
					var newRoles = A2(
						$elm$core$List$map,
						function (role) {
							return _Utils_eq(
								$author$project$Api$Common$PartnerApp$PartnerRole$name(role),
								roleName) ? A2(
								$author$project$Api$Common$PartnerApp$PartnerRole$setDescription,
								$elm$core$Maybe$Just(description),
								role) : role;
						},
						fields.I3);
					var newForm = A3(
						$author$project$Utils$Form$update,
						$author$project$Pages$Partner$Products$Id_String$AppSettings$formFieldsUpdate,
						$author$project$Pages$Partner$Products$Id_String$AppSettings$PartnerRoles(newRoles),
						form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								af: $elm$core$Maybe$Just(newForm)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				var field = msg.a;
				var _v9 = model.af;
				if (!_v9.$) {
					var form = _v9.a;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Partner$Products$Id_String$AppSettings$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								af: $elm$core$Maybe$Just(newForm)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var _v10 = model.af;
				if (!_v10.$) {
					var form = _v10.a;
					var _v11 = $author$project$Pages$Partner$Products$Id_String$AppSettings$validate(form);
					if (!_v11.$) {
						var _v12 = _v11.a;
						var appForm = _v12.a;
						var validFields = _v12.b;
						var fields = $rtfeldman$elm_validate$Validate$fromValid(validFields);
						var permittedFields = _List_fromArray(
							[
								$author$project$Api$Partner$App$HandshakeUrl(
								$elm$core$String$isEmpty(fields.S2) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(fields.S2)),
								$author$project$Api$Partner$App$PartnerRoles(fields.I3),
								$author$project$Api$Partner$App$DefaultAdminRole(fields.PX),
								$author$project$Api$Partner$App$DefaultNonAdminRole(fields.P3),
								$author$project$Api$Partner$App$PrepopulateRoleMappings(fields._e),
								$author$project$Api$Partner$App$LocalhostMode(fields.V9)
							]);
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									af: $elm$core$Maybe$Just(appForm),
									qP: $author$project$Api$Data$Loading
								}),
							A3($author$project$Api$Partner$App$update, model.Gv, permittedFields, $author$project$Pages$Partner$Products$Id_String$AppSettings$GotUpdatedApp),
							_List_Nil);
					} else {
						var formWithErrors = _v11.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									af: $elm$core$Maybe$Just(formWithErrors)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{rl: response, af: $elm$core$Maybe$Nothing, qP: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'App updated successfully!')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{qP: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 8:
				var _v14 = model.rl;
				if (_v14.$ === 3) {
					var app = _v14.a;
					return $elm$core$String$isEmpty(
						$author$project$Api$Partner$App$handshakeUrl(app)) ? _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil) : _Utils_Tuple3(
						_Utils_update(
							model,
							{u5: true, qv: $author$project$Api$Data$Loading}),
						A2($author$project$Api$Partner$App$handshakeTest, model.Gv, $author$project$Pages$Partner$Products$Id_String$AppSettings$GotTestHandshakeResult),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{u5: false, qv: $author$project$Api$Data$NotAsked}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 10:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qv: response}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v15 = A3($author$project$Components$Partner$AppAnchors$update, model.Gv, subMsg, model.iq);
				var appAnchors = _v15.a;
				var cmd = _v15.b;
				var outMsgs = _v15.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{iq: appAnchors}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Products$Id_String$AppSettings$AppAnchorsMsg, cmd),
					outMsgs);
		}
	});
var $author$project$Pages$Partner$Products$Id_String$AppSettings$EditClicked = {$: 3};
var $author$project$Pages$Partner$Products$Id_String$AppSettings$TestHandshakeClicked = {$: 8};
var $author$project$Api$Partner$Partner$One$sandboxOf = function (_v0) {
	var record = _v0.b;
	return record.aap;
};
var $author$project$Pages$Partner$Products$Id_String$AppSettings$isSandboxPartner = function (partner) {
	return !_Utils_eq(
		$author$project$Api$Partner$Partner$One$sandboxOf(partner),
		$elm$core$Maybe$Nothing);
};
var $author$project$Api$Partner$App$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Components$Partner$AppAnchors$ClinicalChartIconLabel = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Partner$AppAnchors$ClinicalChartIconUploaded = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Partner$AppAnchors$CorePageAutoAdjustHeight = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Partner$AppAnchors$CorePageIconLabel = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Partner$AppAnchors$CorePageIconUploaded = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Partner$AppAnchors$InteractionDescription = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Partner$AppAnchors$InteractionTitle = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$AppAnchors$InteractionType = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Partner$AppAnchors$SaveAnchorClicked = {$: 9};
var $author$project$Components$Partner$AppAnchors$SettingsLabel = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Partner$AppAnchors$SourceUrl = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$AppAnchors$TypeSelected = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Partner$AppAnchors$viewAnchorModal = F5(
	function (isHintAdmin, maybeId, form, anchorRequest, typeDropdown) {
		var isLoading = function () {
			if (anchorRequest.$ === 1) {
				return true;
			} else {
				return false;
			}
		}();
		var isEditing = !_Utils_eq(maybeId, $elm$core$Maybe$Nothing);
		var modalTitle = isEditing ? 'Edit Surface' : 'Add Surface';
		var fields = $author$project$Utils$Form$fields(form);
		var errorsFor = function (group) {
			return A2($author$project$Utils$Form$validationErrors, group, form);
		};
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$Partner$AppAnchors$AnchorModalClosed,
			_List_fromArray(
				[
					$author$project$Ui$Modal$onSubmit($author$project$Components$Partner$AppAnchors$SaveAnchorClicked)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title(modalTitle)
						])),
					$author$project$Ui$Modal$body(
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Type'),
									$author$project$Ui$Form$Group$required(true),
									$author$project$Ui$Form$Group$labelSpanSm(4),
									$author$project$Ui$Form$Group$inputSpanSm(8)
								]),
							_List_fromArray(
								[
									isEditing ? $author$project$Ui$Form$Group$static(
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Partner$AppAnchor$typeToLabel(fields.amg))
										])) : A4(
									$author$project$Ui$Dropdown$viewSelect,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Partner$AppAnchor$typeToLabel(fields.amg))
										]),
									A2(
										$elm$core$List$map,
										function (type_) {
											return A2(
												$author$project$Ui$Dropdown$item,
												_List_fromArray(
													[
														$author$project$Ui$Dropdown$onSelect(
														$author$project$Components$Partner$AppAnchors$TypeSelected(type_)),
														$author$project$Ui$Dropdown$selected(
														_Utils_eq(fields.amg, type_))
													]),
												$elm$html$Html$text(
													$author$project$Api$Partner$AppAnchor$typeToLabel(type_)));
										},
										_List_fromArray(
											[0, 1, 2, 3])),
									typeDropdown)
								])),
						A2(
							$elm$core$List$cons,
							A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Source URL'),
										$author$project$Ui$Form$Group$required(true),
										$author$project$Ui$Form$Group$labelSpanSm(4),
										$author$project$Ui$Form$Group$inputSpanSm(8)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$value(fields.abO),
												$author$project$Ui$Form$Input$onInput(
												A2($elm$core$Basics$composeL, $author$project$Components$Partner$AppAnchors$AnchorFormUpdated, $author$project$Components$Partner$AppAnchors$SourceUrl)),
												$author$project$Ui$Form$Input$errors(
												errorsFor(0)),
												$author$project$Ui$Form$Input$placeholder('https://your-app.com/widget')
											]))
									])),
							function () {
								var _v0 = _Utils_Tuple2(fields.amg, fields.o);
								_v0$4:
								while (true) {
									switch (_v0.a) {
										case 0:
											if (!_v0.b.$) {
												var _v1 = _v0.a;
												var config = _v0.b.a;
												return _List_fromArray(
													[
														A2(
														$author$project$Ui$Form$Group$view,
														_List_fromArray(
															[
																$author$project$Ui$Form$Group$labelSpanSm(4),
																$author$project$Ui$Form$Group$inputSpan(8),
																$author$project$Ui$Form$Group$label('Icon')
															]),
														_List_fromArray(
															[
																$author$project$Ui$Form$File$view(
																_List_fromArray(
																	[
																		$author$project$Ui$Form$File$accept(0),
																		$author$project$Ui$Form$File$onInput($author$project$Components$Partner$AppAnchors$CorePageIconUploaded),
																		$author$project$Ui$Form$File$empty(true)
																	]))
															])),
														function () {
														var _v2 = config.yZ;
														if (!_v2.$) {
															var url = _v2.a;
															return $elm$core$String$isEmpty(url) ? $author$project$Utils$Html$empty : A2(
																$author$project$Ui$Form$Group$view,
																_List_fromArray(
																	[
																		$author$project$Ui$Form$Group$labelSpanSm(4),
																		$author$project$Ui$Form$Group$inputSpan(8),
																		$author$project$Ui$Form$Group$label('')
																	]),
																_List_fromArray(
																	[
																		A3(
																		$author$project$Ui$Image$fromSrc,
																		{LD: 'Logo'},
																		url,
																		_List_fromArray(
																			[
																				$author$project$Ui$Image$height(50)
																			])),
																		$author$project$Utils$FormErrors$view(
																		A2($author$project$Utils$Form$validationErrors, 1, form))
																	]));
														} else {
															return $author$project$Utils$Html$empty;
														}
													}(),
														A2(
														$author$project$Ui$Form$Group$view,
														_List_fromArray(
															[
																$author$project$Ui$Form$Group$label('Icon Label'),
																$author$project$Ui$Form$Group$labelSpanSm(4),
																$author$project$Ui$Form$Group$inputSpanSm(8)
															]),
														_List_fromArray(
															[
																$author$project$Ui$Form$Input$view(
																_List_fromArray(
																	[
																		$author$project$Ui$Form$Input$value(
																		A2($elm$core$Maybe$withDefault, '', config.OI)),
																		$author$project$Ui$Form$Input$onInput(
																		A2($elm$core$Basics$composeL, $author$project$Components$Partner$AppAnchors$AnchorFormUpdated, $author$project$Components$Partner$AppAnchors$CorePageIconLabel)),
																		$author$project$Ui$Form$Input$placeholder('Enter icon label'),
																		$author$project$Ui$Form$Input$disabled(!isHintAdmin)
																	]))
															])),
														A2(
														$author$project$Ui$Form$Group$view,
														_List_fromArray(
															[
																$author$project$Ui$Form$Group$labelSpanSm(4),
																$author$project$Ui$Form$Group$inputSpanSm(8),
																$author$project$Ui$Form$Group$label('Auto adjust height')
															]),
														_List_fromArray(
															[
																$author$project$Ui$Form$Group$static(
																_List_fromArray(
																	[
																		A2(
																		$author$project$Ui$Element$view,
																		_List_fromArray(
																			[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm, $author$project$Ui$Element$mb2]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text('When enabled, the iframe height adapts to the embedded app\'s content for a seamless layout without inner scrollbars.'),
																				A2($elm$html$Html$br, _List_Nil, _List_Nil),
																				$elm$html$Html$text('When disabled, the app stays boxed with its own scroll area, allowing sticky elements.')
																			])),
																		$author$project$Ui$ToggleSwitch$view(
																		_List_fromArray(
																			[
																				$author$project$Ui$ToggleSwitch$on(config.OH),
																				$author$project$Ui$ToggleSwitch$onChange(
																				A2($elm$core$Basics$composeL, $author$project$Components$Partner$AppAnchors$AnchorFormUpdated, $author$project$Components$Partner$AppAnchors$CorePageAutoAdjustHeight))
																			]))
																	]))
															]))
													]);
											} else {
												break _v0$4;
											}
										case 1:
											if (_v0.b.$ === 1) {
												var _v3 = _v0.a;
												var config = _v0.b.a;
												return _List_fromArray(
													[
														A2(
														$author$project$Ui$Form$Group$view,
														_List_fromArray(
															[
																$author$project$Ui$Form$Group$label('Interaction Title'),
																$author$project$Ui$Form$Group$labelSpanSm(4),
																$author$project$Ui$Form$Group$inputSpanSm(8)
															]),
														_List_fromArray(
															[
																$author$project$Ui$Form$Input$view(
																_List_fromArray(
																	[
																		$author$project$Ui$Form$Input$value(config.Uf),
																		$author$project$Ui$Form$Input$onInput(
																		A2($elm$core$Basics$composeL, $author$project$Components$Partner$AppAnchors$AnchorFormUpdated, $author$project$Components$Partner$AppAnchors$InteractionTitle)),
																		$author$project$Ui$Form$Input$placeholder('Enter interaction title')
																	]))
															])),
														A2(
														$author$project$Ui$Form$Group$view,
														_List_fromArray(
															[
																$author$project$Ui$Form$Group$label('Interaction Description'),
																$author$project$Ui$Form$Group$labelSpanSm(4),
																$author$project$Ui$Form$Group$inputSpanSm(8)
															]),
														_List_fromArray(
															[
																$author$project$Ui$Form$Input$view(
																_List_fromArray(
																	[
																		$author$project$Ui$Form$Input$value(config.Ue),
																		$author$project$Ui$Form$Input$onInput(
																		A2($elm$core$Basics$composeL, $author$project$Components$Partner$AppAnchors$AnchorFormUpdated, $author$project$Components$Partner$AppAnchors$InteractionDescription)),
																		$author$project$Ui$Form$Input$placeholder('Enter interaction description')
																	]))
															])),
														A2(
														$author$project$Ui$Form$Group$view,
														_List_fromArray(
															[
																$author$project$Ui$Form$Group$label('Interaction Type'),
																$author$project$Ui$Form$Group$labelSpanSm(4),
																$author$project$Ui$Form$Group$inputSpanSm(8)
															]),
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Form$Select$view,
																_List_fromArray(
																	[
																		$author$project$Ui$Form$Select$value(
																		$elm$core$Maybe$Just(
																			$author$project$Components$Partner$AppAnchors$interactionTypeToString(config.Ug))),
																		$author$project$Ui$Form$Select$onChange(
																		A2($elm$core$Basics$composeL, $author$project$Components$Partner$AppAnchors$AnchorFormUpdated, $author$project$Components$Partner$AppAnchors$InteractionType))
																	]),
																_List_fromArray(
																	[
																		A3(
																		$author$project$Ui$Form$Select$option,
																		_List_Nil,
																		$elm$core$Maybe$Just(
																			$author$project$Components$Partner$AppAnchors$interactionTypeToString(0)),
																		'General'),
																		A3(
																		$author$project$Ui$Form$Select$option,
																		_List_Nil,
																		$elm$core$Maybe$Just(
																			$author$project$Components$Partner$AppAnchors$interactionTypeToString(1)),
																		'Lab')
																	]))
															]))
													]);
											} else {
												break _v0$4;
											}
										case 2:
											if (_v0.b.$ === 2) {
												var _v4 = _v0.a;
												var config = _v0.b.a;
												return _List_fromArray(
													[
														A2(
														$author$project$Ui$Form$Group$view,
														_List_fromArray(
															[
																$author$project$Ui$Form$Group$labelSpanSm(4),
																$author$project$Ui$Form$Group$inputSpan(8),
																$author$project$Ui$Form$Group$label('Icon')
															]),
														_List_fromArray(
															[
																$author$project$Ui$Form$File$view(
																_List_fromArray(
																	[
																		$author$project$Ui$Form$File$accept(0),
																		$author$project$Ui$Form$File$onInput($author$project$Components$Partner$AppAnchors$ClinicalChartIconUploaded),
																		$author$project$Ui$Form$File$empty(true)
																	]))
															])),
														function () {
														var _v5 = config.yY;
														if (!_v5.$) {
															var url = _v5.a;
															return $elm$core$String$isEmpty(url) ? $author$project$Utils$Html$empty : A2(
																$author$project$Ui$Form$Group$view,
																_List_fromArray(
																	[
																		$author$project$Ui$Form$Group$labelSpanSm(4),
																		$author$project$Ui$Form$Group$inputSpan(8),
																		$author$project$Ui$Form$Group$label('')
																	]),
																_List_fromArray(
																	[
																		A3(
																		$author$project$Ui$Image$fromSrc,
																		{LD: 'Icon'},
																		url,
																		_List_fromArray(
																			[
																				$author$project$Ui$Image$height(50)
																			])),
																		$author$project$Utils$FormErrors$view(
																		A2($author$project$Utils$Form$validationErrors, 2, form))
																	]));
														} else {
															return $author$project$Utils$Html$empty;
														}
													}(),
														A2(
														$author$project$Ui$Form$Group$view,
														_List_fromArray(
															[
																$author$project$Ui$Form$Group$label('Icon Label'),
																$author$project$Ui$Form$Group$labelSpanSm(4),
																$author$project$Ui$Form$Group$inputSpanSm(8)
															]),
														_List_fromArray(
															[
																$author$project$Ui$Form$Input$view(
																_List_fromArray(
																	[
																		$author$project$Ui$Form$Input$value(
																		A2($elm$core$Maybe$withDefault, '', config.NL)),
																		$author$project$Ui$Form$Input$onInput(
																		A2($elm$core$Basics$composeL, $author$project$Components$Partner$AppAnchors$AnchorFormUpdated, $author$project$Components$Partner$AppAnchors$ClinicalChartIconLabel)),
																		$author$project$Ui$Form$Input$placeholder('Enter icon label'),
																		$author$project$Ui$Form$Input$disabled(!isHintAdmin)
																	]))
															]))
													]);
											} else {
												break _v0$4;
											}
										default:
											if (_v0.b.$ === 3) {
												var _v6 = _v0.a;
												var config = _v0.b.a;
												return _List_fromArray(
													[
														A2(
														$author$project$Ui$Form$Group$view,
														_List_fromArray(
															[
																$author$project$Ui$Form$Group$label('Settings Label'),
																$author$project$Ui$Form$Group$labelSpanSm(4),
																$author$project$Ui$Form$Group$inputSpanSm(8)
															]),
														_List_fromArray(
															[
																$author$project$Ui$Form$Input$view(
																_List_fromArray(
																	[
																		$author$project$Ui$Form$Input$value(
																		A2($elm$core$Maybe$withDefault, '', config.aa5)),
																		$author$project$Ui$Form$Input$onInput(
																		A2($elm$core$Basics$composeL, $author$project$Components$Partner$AppAnchors$AnchorFormUpdated, $author$project$Components$Partner$AppAnchors$SettingsLabel)),
																		$author$project$Ui$Form$Input$placeholder('Enter settings label')
																	]))
															]))
													]);
											} else {
												break _v0$4;
											}
									}
								}
								return _List_Nil;
							}()))),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Cancel'},
							_List_fromArray(
								[
									$author$project$Ui$Button$secondary,
									$author$project$Ui$Button$onClick($author$project$Components$Partner$AppAnchors$AnchorModalClosed)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Save surface'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$loading(isLoading),
									$author$project$Ui$Button$submit
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Save')
								]))
						]))
				]));
	});
var $author$project$Components$Partner$AppAnchors$AddAnchorClicked = {$: 0};
var $author$project$Components$Partner$AppAnchors$AnchorClicked = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Nav$CustomItem = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Ui$Nav$customItem = $author$project$Ui$Nav$CustomItem;
var $author$project$Ui$Nav$Id = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Nav$itemId = $author$project$Ui$Nav$Id;
var $author$project$Ui$Nav$Slim = 0;
var $author$project$Ui$Nav$slim = 0;
var $author$project$Components$Partner$AppAnchors$viewAnchorsAsNavs = function (model) {
	var anchorItems = A2(
		$elm$core$List$indexedMap,
		F2(
			function (index, anchor) {
				return A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$itemId(
							$author$project$Api$Partner$AppAnchor$id(anchor)),
							$author$project$Ui$Nav$activeItem(
							A2(
								$elm$core$Maybe$withDefault,
								!index,
								A2(
									$elm$core$Maybe$map,
									$elm$core$Basics$eq(
										$author$project$Api$Partner$AppAnchor$id(anchor)),
									model.bL))),
							$author$project$Ui$Nav$onItemClick(
							$author$project$Components$Partner$AppAnchors$AnchorClicked(
								$author$project$Api$Partner$AppAnchor$id(anchor)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Partner$AppAnchor$typeLabel(anchor))
						]));
			}),
		model.Gr);
	var addItem = A2(
		$author$project$Ui$Nav$customItem,
		_List_fromArray(
			[
				$author$project$Ui$Nav$onItemClick($author$project$Components$Partner$AppAnchors$AddAnchorClicked)
			]),
		A3(
			$author$project$Ui$Button$view,
			{mm: 'Add surface'},
			_List_fromArray(
				[
					$author$project$Ui$Button$link,
					$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Add surface')
				])));
	return A3(
		$author$project$Ui$Nav$view,
		_List_fromArray(
			[$author$project$Ui$Nav$slim]),
		_Utils_ap(
			anchorItems,
			_List_fromArray(
				[addItem])),
		model.kp);
};
var $author$project$Components$Partner$AppAnchors$ConfirmDeleteAnchor = {$: 5};
var $author$project$Components$Partner$AppAnchors$viewDeleteConfirmModal = A3(
	$author$project$Ui$Modal$view,
	$author$project$Components$Partner$AppAnchors$DeleteConfirmModalClosed,
	_List_Nil,
	_List_fromArray(
		[
			$author$project$Ui$Modal$header(
			_List_fromArray(
				[
					$author$project$Ui$Modal$title('Delete Surface')
				])),
			$author$project$Ui$Modal$body(
			_List_fromArray(
				[
					$elm$html$Html$text('Are you sure you want to delete this surface? This action cannot be undone.')
				])),
			$author$project$Ui$Modal$footer(
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{mm: 'Cancel delete'},
					_List_fromArray(
						[
							$author$project$Ui$Button$secondary,
							$author$project$Ui$Button$onClick($author$project$Components$Partner$AppAnchors$DeleteConfirmModalClosed)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Cancel')
						])),
					A3(
					$author$project$Ui$Button$view,
					{mm: 'Confirm delete'},
					_List_fromArray(
						[
							$author$project$Ui$Button$danger,
							$author$project$Ui$Button$onClick($author$project$Components$Partner$AppAnchors$ConfirmDeleteAnchor)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Delete')
						]))
				]))
		]));
var $author$project$Components$Partner$AppAnchors$DeleteAnchorClicked = {$: 3};
var $author$project$Components$Partner$AppAnchors$EditAnchorClicked = {$: 2};
var $author$project$Components$Partner$AppAnchors$interactionTypeLabel = function (type_) {
	if (!type_) {
		return 'General';
	} else {
		return 'Lab';
	}
};
var $author$project$Components$Partner$AppAnchors$viewSelectedAnchorInfo = function (model) {
	var selectedAnchor = A2(
		$elm$core$Maybe$andThen,
		$elm$core$List$head,
		A2(
			$elm$core$Maybe$map,
			function (anchorId) {
				return A2(
					$elm$core$List$filter,
					function (anchor) {
						return _Utils_eq(
							$author$project$Api$Partner$AppAnchor$id(anchor),
							anchorId);
					},
					model.Gr);
			},
			model.bL));
	if (!selectedAnchor.$) {
		var anchor = selectedAnchor.a;
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mb2, $author$project$Ui$Element$mt2, $author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsStart]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Source URL')
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$static(
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Partner$AppAnchor$sourceUrl(anchor))
										]))
								])),
						function () {
							var _v1 = $author$project$Api$Partner$AppAnchor$type_(anchor);
							switch (_v1) {
								case 0:
									return _List_fromArray(
										[
											function () {
											var _v2 = $author$project$Api$Partner$AppAnchor$corePageIconUrl(anchor);
											if (!_v2.$) {
												var url = _v2.a;
												return A2(
													$author$project$Ui$Form$Group$view,
													_List_fromArray(
														[
															$author$project$Ui$Form$Group$label('Icon')
														]),
													_List_fromArray(
														[
															A3(
															$author$project$Ui$Image$fromSrc,
															{LD: 'App icon'},
															url,
															_List_fromArray(
																[
																	$author$project$Ui$Image$height(50)
																]))
														]));
											} else {
												return $author$project$Utils$Html$empty;
											}
										}(),
											function () {
											var _v3 = $author$project$Api$Partner$AppAnchor$corePageIconLabel(anchor);
											if (!_v3.$) {
												var corePageIconLabel = _v3.a;
												return A2(
													$author$project$Ui$Form$Group$view,
													_List_fromArray(
														[
															$author$project$Ui$Form$Group$label('Icon Label')
														]),
													_List_fromArray(
														[
															$author$project$Ui$Form$Group$static(
															_List_fromArray(
																[
																	$elm$html$Html$text(corePageIconLabel)
																]))
														]));
											} else {
												return $author$project$Utils$Html$empty;
											}
										}(),
											A2(
											$author$project$Ui$Form$Group$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Group$label('Auto Adjust Height')
												]),
											_List_fromArray(
												[
													$author$project$Ui$Form$Group$static(
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2(
																$elm$core$Maybe$withDefault,
																true,
																$author$project$Api$Partner$AppAnchor$corePageAutoAdjustHeight(anchor)) ? 'Enabled' : 'Disabled')
														]))
												]))
										]);
								case 1:
									return _List_fromArray(
										[
											function () {
											var _v4 = $author$project$Api$Partner$AppAnchor$interactionTitle(anchor);
											if (!_v4.$) {
												var title = _v4.a;
												return A2(
													$author$project$Ui$Form$Group$view,
													_List_fromArray(
														[
															$author$project$Ui$Form$Group$label('Interaction Title')
														]),
													_List_fromArray(
														[
															$author$project$Ui$Form$Group$static(
															_List_fromArray(
																[
																	$elm$html$Html$text(title)
																]))
														]));
											} else {
												return $author$project$Utils$Html$empty;
											}
										}(),
											function () {
											var _v5 = $author$project$Api$Partner$AppAnchor$interactionDescription(anchor);
											if (!_v5.$) {
												var description = _v5.a;
												return A2(
													$author$project$Ui$Form$Group$view,
													_List_fromArray(
														[
															$author$project$Ui$Form$Group$label('Interaction Description')
														]),
													_List_fromArray(
														[
															$author$project$Ui$Form$Group$static(
															_List_fromArray(
																[
																	$elm$html$Html$text(description)
																]))
														]));
											} else {
												return $author$project$Utils$Html$empty;
											}
										}(),
											function () {
											var _v6 = $author$project$Api$Partner$AppAnchor$interactionType(anchor);
											if (!_v6.$) {
												var interactionType_ = _v6.a;
												return A2(
													$author$project$Ui$Form$Group$view,
													_List_fromArray(
														[
															$author$project$Ui$Form$Group$label('Interaction Type')
														]),
													_List_fromArray(
														[
															$author$project$Ui$Form$Group$static(
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	A2(
																		$elm$core$Maybe$withDefault,
																		interactionType_,
																		A2(
																			$elm$core$Maybe$map,
																			$author$project$Components$Partner$AppAnchors$interactionTypeLabel,
																			$author$project$Components$Partner$AppAnchors$interactionTypeFromString(interactionType_))))
																]))
														]));
											} else {
												return $author$project$Utils$Html$empty;
											}
										}()
										]);
								case 2:
									return _List_fromArray(
										[
											function () {
											var _v7 = $author$project$Api$Partner$AppAnchor$clinicalChartIconUrl(anchor);
											if (!_v7.$) {
												var url = _v7.a;
												return A2(
													$author$project$Ui$Form$Group$view,
													_List_fromArray(
														[
															$author$project$Ui$Form$Group$label('Icon')
														]),
													_List_fromArray(
														[
															A3(
															$author$project$Ui$Image$fromSrc,
															{LD: 'App icon'},
															url,
															_List_fromArray(
																[
																	$author$project$Ui$Image$height(50)
																]))
														]));
											} else {
												return $author$project$Utils$Html$empty;
											}
										}(),
											function () {
											var _v8 = $author$project$Api$Partner$AppAnchor$clinicalChartIconLabel(anchor);
											if (!_v8.$) {
												var clinicalChartIconLabel = _v8.a;
												return A2(
													$author$project$Ui$Form$Group$view,
													_List_fromArray(
														[
															$author$project$Ui$Form$Group$label('Icon Label')
														]),
													_List_fromArray(
														[
															$author$project$Ui$Form$Group$static(
															_List_fromArray(
																[
																	$elm$html$Html$text(clinicalChartIconLabel)
																]))
														]));
											} else {
												return $author$project$Utils$Html$empty;
											}
										}()
										]);
								default:
									return _List_fromArray(
										[
											function () {
											var _v9 = $author$project$Api$Partner$AppAnchor$settingsLabel(anchor);
											if (!_v9.$) {
												var settingsLabel = _v9.a;
												return A2(
													$author$project$Ui$Form$Group$view,
													_List_fromArray(
														[
															$author$project$Ui$Form$Group$label('Settings Label')
														]),
													_List_fromArray(
														[
															$author$project$Ui$Form$Group$static(
															_List_fromArray(
																[
																	$elm$html$Html$text(settingsLabel)
																]))
														]));
											} else {
												return $author$project$Utils$Html$empty;
											}
										}()
										]);
							}
						}())),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mt2]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Edit surface'},
							_List_fromArray(
								[
									$author$project$Ui$Button$secondary,
									$author$project$Ui$Button$onClick($author$project$Components$Partner$AppAnchors$EditAnchorClicked),
									$author$project$Ui$Button$icon($author$project$Ui$Icon$edit),
									$author$project$Ui$Button$sm
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Edit')
								])),
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Delete surface'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Components$Partner$AppAnchors$DeleteAnchorClicked),
									$author$project$Ui$Button$icon($author$project$Ui$Icon$delete),
									$author$project$Ui$Button$sm
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Remove')
								]))
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Partner$AppAnchors$view = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				function () {
				var _v0 = model.as;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var maybeId = _v1.a;
					var form = _v1.b;
					return A5($author$project$Components$Partner$AppAnchors$viewAnchorModal, model.Ij, maybeId, form, model.ip, model.qI);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				model.nd ? $author$project$Components$Partner$AppAnchors$viewDeleteConfirmModal : $author$project$Utils$Html$empty,
				$author$project$Components$Partner$AppAnchors$viewAnchorsAsNavs(model),
				$author$project$Components$Partner$AppAnchors$viewSelectedAnchorInfo(model)
			]));
};
var $author$project$Pages$Partner$Products$Id_String$AppSettings$viewApp = F2(
	function (model, app) {
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mb4]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('App Settings')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Edit app'},
						_List_fromArray(
							[
								$author$project$Ui$Button$secondary,
								$author$project$Ui$Button$onClick($author$project$Pages$Partner$Products$Id_String$AppSettings$EditClicked),
								$author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Edit')
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Status'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$static(
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Badge$fromString,
								_List_Nil,
								$author$project$Api$Partner$App$status(app))
							]))
					])),
				$author$project$Pages$Partner$Products$Id_String$AppSettings$isSandboxPartner(model.YN) ? A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Localhost Mode'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$static(
						_List_fromArray(
							[
								$author$project$Api$Partner$App$localhostMode(app) ? A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Badge$view,
										_List_fromArray(
											[$author$project$Ui$Badge$accentPrimary]),
										_List_fromArray(
											[
												$elm$html$Html$text('Enabled')
											]))
									])) : $elm$html$Html$text('Disabled'),
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$textMuted]),
								_List_fromArray(
									[
										$elm$html$Html$text('When enabled, allows localhost URLs for local development. Your local server must allow CORS from the provider portal origin.')
									]))
							]))
					])) : $author$project$Utils$Html$empty,
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Partner Roles'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$static(
						_List_fromArray(
							[
								$elm$core$List$isEmpty(
								$author$project$Api$Partner$App$partnerRoles(app)) ? $elm$html$Html$text('No partner roles defined') : A2(
								$elm$html$Html$ul,
								_List_Nil,
								A2(
									$elm$core$List$map,
									function (role) {
										var descText = A2(
											$elm$core$Maybe$withDefault,
											'',
											$author$project$Api$Common$PartnerApp$PartnerRole$description(role));
										return A2(
											$elm$html$Html$li,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Formatters$String$titleize(
														$author$project$Formatters$String$humanize(
															$author$project$Api$Common$PartnerApp$PartnerRole$name(role)))),
													$elm$core$String$isEmpty(descText) ? $elm$html$Html$text('') : A2(
													$author$project$Ui$Typography$text,
													_List_fromArray(
														[$author$project$Ui$Typography$muted]),
													' (' + (descText + ')'))
												]));
									},
									$author$project$Api$Partner$App$partnerRoles(app)))
							]))
					])),
				$elm$core$List$isEmpty(
				$author$project$Api$Partner$App$partnerRoles(app)) ? $author$project$Utils$Html$empty : A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Default Admin Role'),
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$static(
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2(
											$elm$core$Maybe$withDefault,
											'None',
											A2(
												$elm$core$Maybe$map,
												A2($elm$core$Basics$composeR, $author$project$Formatters$String$humanize, $author$project$Formatters$String$titleize),
												$author$project$Api$Partner$App$defaultAdminRole(app))))
									]))
							])),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Default Non-Admin Role'),
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$static(
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2(
											$elm$core$Maybe$withDefault,
											'None',
											A2(
												$elm$core$Maybe$map,
												A2($elm$core$Basics$composeR, $author$project$Formatters$String$humanize, $author$project$Formatters$String$titleize),
												$author$project$Api$Partner$App$defaultNonAdminRole(app))))
									]))
							])),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Prepopulate Role Mappings'),
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$static(
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Api$Partner$App$prepopulateRoleMappings(app) ? 'Yes' : 'No')
									]))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Handshake url'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$static(
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsStart]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												function (handshakeUrl) {
													return $elm$core$String$isEmpty(handshakeUrl) ? 'None' : handshakeUrl;
												}(
													$author$project$Api$Partner$App$handshakeUrl(app))),
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$textMuted]),
												_List_fromArray(
													[
														$elm$html$Html$text('The endpoint where we send a signed request to establish trust. The request includes:'),
														A2(
														$elm$html$Html$ul,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$li,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('user: { id, email, name, first_name, last_name, partner_roles }')
																	])),
																A2(
																$elm$html$Html$li,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('practice: { id }')
																	])),
																A2(
																$elm$html$Html$li,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('patient: { id } | null')
																	])),
																A2(
																$elm$html$Html$li,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('integration: { id } | null')
																	])),
																A2(
																$elm$html$Html$li,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('access_token: string')
																	]))
															])),
														$elm$html$Html$text('Your endpoint must return a session_key, which we will pass into the iframe for authentication.')
													]))
											])),
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Test handshake endpoint'},
										_List_fromArray(
											[
												$author$project$Ui$Button$secondary,
												$author$project$Ui$Button$onClick($author$project$Pages$Partner$Products$Id_String$AppSettings$TestHandshakeClicked),
												$author$project$Ui$Button$sm,
												$author$project$Ui$Button$disabled(
												$elm$core$String$isEmpty(
													$author$project$Api$Partner$App$handshakeUrl(app)))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Test')
											]))
									]))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Surfaces'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$static(
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Partner$Products$Id_String$AppSettings$AppAnchorsMsg,
								$author$project$Components$Partner$AppAnchors$view(model.iq))
							]))
					]))
			]);
	});
var $author$project$Pages$Partner$Products$Id_String$AppSettings$CreateClicked = {$: 1};
var $author$project$Pages$Partner$Products$Id_String$AppSettings$viewBuildApp = _List_fromArray(
	[
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$flexCol]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mb2]),
				_List_fromArray(
					[
						$elm$html$Html$text('There\'s no APP yet')
					])),
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Build your app'},
				_List_fromArray(
					[
						$author$project$Ui$Button$primary,
						$author$project$Ui$Button$onClick($author$project$Pages$Partner$Products$Id_String$AppSettings$CreateClicked)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Start building')
					]))
			]))
	]);
var $author$project$Pages$Partner$Products$Id_String$AppSettings$AddRole = {$: 14};
var $author$project$Pages$Partner$Products$Id_String$AppSettings$FormUpdated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$AppSettings$HandshakeUrl = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$AppSettings$LocalhostMode = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$AppSettings$NewRoleDescriptionUpdated = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$AppSettings$NewRoleNameUpdated = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$AppSettings$PrepopulateRoleMappings = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$AppSettings$RemoveRole = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$AppSettings$RoleDescriptionUpdated = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Pages$Partner$Products$Id_String$AppSettings$SaveClicked = {$: 6};
var $author$project$Pages$Partner$Products$Id_String$AppSettings$viewEditModal = F5(
	function (partner, newRoleName, newRoleDescription, form, updateRequest) {
		var isLoading = function () {
			if (updateRequest.$ === 1) {
				return true;
			} else {
				return false;
			}
		}();
		var fields = $author$project$Utils$Form$fields(form);
		var roleNames = A2($elm$core$List$map, $author$project$Api$Common$PartnerApp$PartnerRole$name, fields.I3);
		var roleOptions = function (emptyLabel) {
			return A2(
				$elm$core$List$cons,
				A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, emptyLabel),
				A2(
					$elm$core$List$map,
					function (role) {
						return A3(
							$author$project$Ui$Form$Select$option,
							_List_Nil,
							$elm$core$Maybe$Just(role),
							$author$project$Formatters$String$titleize(
								$author$project$Formatters$String$humanize(role)));
					},
					roleNames));
		};
		var errorsFor = function (group) {
			return A2($author$project$Utils$Form$validationErrors, group, form);
		};
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Pages$Partner$Products$Id_String$AppSettings$EditModalClosed,
			_List_fromArray(
				[
					$author$project$Ui$Modal$onSubmit($author$project$Pages$Partner$Products$Id_String$AppSettings$SaveClicked)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('Edit App')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							$author$project$Pages$Partner$Products$Id_String$AppSettings$isSandboxPartner(partner) ? A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Localhost Mode'),
									$author$project$Ui$Form$Group$labelSpanSm(4),
									$author$project$Ui$Form$Group$inputSpanSm(8)
								]),
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$view(
									_List_fromArray(
										[
											$author$project$Ui$ToggleSwitch$on(fields.V9),
											$author$project$Ui$ToggleSwitch$onChange(
											A2($elm$core$Basics$composeL, $author$project$Pages$Partner$Products$Id_String$AppSettings$FormUpdated, $author$project$Pages$Partner$Products$Id_String$AppSettings$LocalhostMode))
										])),
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$muted]),
									_List_fromArray(
										[
											$elm$html$Html$text('Enable to use localhost URLs for local development. Your local server must allow CORS from https://app.hint.com.')
										]))
								])) : $author$project$Utils$Html$empty,
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Handshake URL'),
									$author$project$Ui$Form$Group$labelSpanSm(4),
									$author$project$Ui$Form$Group$inputSpanSm(8)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(fields.S2),
											$author$project$Ui$Form$Input$onInput(
											A2($elm$core$Basics$composeL, $author$project$Pages$Partner$Products$Id_String$AppSettings$FormUpdated, $author$project$Pages$Partner$Products$Id_String$AppSettings$HandshakeUrl)),
											$author$project$Ui$Form$Input$placeholder(
											fields.V9 ? 'http://localhost:3000/handshake' : 'https://your-app.com/handshake'),
											$author$project$Ui$Form$Input$disabled(isLoading)
										]))
								])),
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Partner Roles'),
									$author$project$Ui$Form$Group$labelSpanSm(4),
									$author$project$Ui$Form$Group$inputSpanSm(8)
								]),
							$elm$core$List$concat(
								_List_fromArray(
									[
										A2(
										$elm$core$List$map,
										function (role) {
											var roleName = $author$project$Api$Common$PartnerApp$PartnerRole$name(role);
											var descText = A2(
												$elm$core$Maybe$withDefault,
												'',
												$author$project$Api$Common$PartnerApp$PartnerRole$description(role));
											return A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$gap2, $author$project$Ui$Element$mb2]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Element$view,
														_List_fromArray(
															[$author$project$Ui$Element$fullWidth]),
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Typography$p,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text(roleName)
																	]))
															])),
														A2(
														$author$project$Ui$Element$view,
														_List_fromArray(
															[$author$project$Ui$Element$fullWidth]),
														_List_fromArray(
															[
																$author$project$Ui$Form$Input$view(
																A2(
																	$elm$core$List$cons,
																	$author$project$Ui$Form$Input$value(descText),
																	A2(
																		$elm$core$List$cons,
																		$author$project$Ui$Form$Input$onInput(
																			$author$project$Pages$Partner$Products$Id_String$AppSettings$RoleDescriptionUpdated(roleName)),
																		A2(
																			$elm$core$List$cons,
																			$author$project$Ui$Form$Input$placeholder('Description (required)'),
																			A2(
																				$elm$core$List$cons,
																				$author$project$Ui$Form$Input$disabled(isLoading),
																				$elm$core$String$isEmpty(descText) ? _List_fromArray(
																					[
																						$author$project$Ui$Form$Input$errors(
																						errorsFor(0))
																					]) : _List_Nil)))))
															])),
														A3(
														$author$project$Ui$Button$view,
														{mm: 'Remove role ' + roleName},
														_List_fromArray(
															[
																$author$project$Ui$Button$link,
																$author$project$Ui$Button$sm,
																$author$project$Ui$Button$onClick(
																$author$project$Pages$Partner$Products$Id_String$AppSettings$RemoveRole(roleName)),
																$author$project$Ui$Button$icon($author$project$Ui$Icon$delete),
																$author$project$Ui$Button$disabled(isLoading)
															]),
														_List_Nil)
													]));
										},
										fields.I3),
										_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$gap2]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$fullWidth]),
													_List_fromArray(
														[
															$author$project$Ui$Form$Input$view(
															_List_fromArray(
																[
																	$author$project$Ui$Form$Input$value(newRoleName),
																	$author$project$Ui$Form$Input$onInput($author$project$Pages$Partner$Products$Id_String$AppSettings$NewRoleNameUpdated),
																	$author$project$Ui$Form$Input$placeholder('New role name'),
																	$author$project$Ui$Form$Input$disabled(isLoading)
																]))
														])),
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$fullWidth]),
													_List_fromArray(
														[
															$author$project$Ui$Form$Input$view(
															_List_fromArray(
																[
																	$author$project$Ui$Form$Input$value(newRoleDescription),
																	$author$project$Ui$Form$Input$onInput($author$project$Pages$Partner$Products$Id_String$AppSettings$NewRoleDescriptionUpdated),
																	$author$project$Ui$Form$Input$placeholder('Description (required)'),
																	$author$project$Ui$Form$Input$disabled(isLoading)
																]))
														])),
													A3(
													$author$project$Ui$Button$view,
													{mm: 'Add role'},
													_List_fromArray(
														[
															$author$project$Ui$Button$secondary,
															$author$project$Ui$Button$sm,
															$author$project$Ui$Button$onClick($author$project$Pages$Partner$Products$Id_String$AppSettings$AddRole),
															$author$project$Ui$Button$icon($author$project$Ui$Icon$add),
															$author$project$Ui$Button$disabled(
															isLoading || ($elm$core$String$isEmpty(
																$elm$core$String$trim(newRoleName)) || $elm$core$String$isEmpty(
																$elm$core$String$trim(newRoleDescription))))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Add')
														]))
												])),
											A2(
											$author$project$Ui$Typography$p,
											_List_fromArray(
												[$author$project$Ui$Typography$muted]),
											_List_fromArray(
												[
													$elm$html$Html$text('Define roles with descriptions to control access levels for your app.')
												]))
										])
									]))),
							$elm$core$List$isEmpty(roleNames) ? $author$project$Utils$Html$empty : A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$label('Default Admin Role'),
											$author$project$Ui$Form$Group$required(true),
											$author$project$Ui$Form$Group$labelSpanSm(4),
											$author$project$Ui$Form$Group$inputSpanSm(8)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Select$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Select$value(fields.PX),
													$author$project$Ui$Form$Select$onChange(
													A2($elm$core$Basics$composeL, $author$project$Pages$Partner$Products$Id_String$AppSettings$FormUpdated, $author$project$Pages$Partner$Products$Id_String$AppSettings$DefaultAdminRole)),
													$author$project$Ui$Form$Select$disabled(isLoading),
													$author$project$Ui$Form$Select$errors(
													errorsFor(1))
												]),
											roleOptions('Select a role'))
										])),
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$label('Default Non-Admin Role'),
											$author$project$Ui$Form$Group$required(true),
											$author$project$Ui$Form$Group$labelSpanSm(4),
											$author$project$Ui$Form$Group$inputSpanSm(8)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Select$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Select$value(fields.P3),
													$author$project$Ui$Form$Select$onChange(
													A2($elm$core$Basics$composeL, $author$project$Pages$Partner$Products$Id_String$AppSettings$FormUpdated, $author$project$Pages$Partner$Products$Id_String$AppSettings$DefaultNonAdminRole)),
													$author$project$Ui$Form$Select$disabled(isLoading),
													$author$project$Ui$Form$Select$errors(
													errorsFor(2))
												]),
											roleOptions('Select a role'))
										])),
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$label('Prepopulate Role Mappings'),
											$author$project$Ui$Form$Group$labelSpanSm(4),
											$author$project$Ui$Form$Group$inputSpanSm(8)
										]),
									_List_fromArray(
										[
											$author$project$Ui$ToggleSwitch$view(
											_List_fromArray(
												[
													$author$project$Ui$ToggleSwitch$on(fields._e),
													$author$project$Ui$ToggleSwitch$onChange(
													A2($elm$core$Basics$composeL, $author$project$Pages$Partner$Products$Id_String$AppSettings$FormUpdated, $author$project$Pages$Partner$Products$Id_String$AppSettings$PrepopulateRoleMappings))
												])),
											A2(
											$author$project$Ui$Typography$p,
											_List_fromArray(
												[$author$project$Ui$Typography$muted]),
											_List_fromArray(
												[
													$elm$html$Html$text('When enabled, new integrations will have their role mappings pre-filled with the default admin and non-admin roles.')
												]))
										]))
								]))
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Cancel edit'},
							_List_fromArray(
								[
									$author$project$Ui$Button$secondary,
									$author$project$Ui$Button$onClick($author$project$Pages$Partner$Products$Id_String$AppSettings$EditModalClosed),
									$author$project$Ui$Button$disabled(isLoading)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Save changes'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$disabled(isLoading),
									$author$project$Ui$Button$loading(isLoading),
									$author$project$Ui$Button$submit
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Save')
								]))
						]))
				]));
	});
var $author$project$Pages$Partner$Products$Id_String$AppSettings$viewTestHandshakeModal = function (testRequest) {
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Pages$Partner$Products$Id_String$AppSettings$TestHandshakeModalClosed,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Test Handshake Endpoint')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						function () {
						switch (testRequest.$) {
							case 1:
								return $elm$html$Html$text('Testing handshake endpoint...');
							case 3:
								return A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Handshake successful!'),
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$mt2]),
											_List_fromArray(
												[
													$elm$html$Html$text('Your endpoint responded correctly to the test request.')
												]))
										]));
							case 2:
								return A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Handshake failed'),
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$mt2]),
											_List_fromArray(
												[
													$elm$html$Html$text('Please check your endpoint URL and try again.')
												]))
										]));
							default:
								return $elm$html$Html$text('Ready to test handshake endpoint');
						}
					}()
					])),
				$author$project$Ui$Modal$footer(
				A2(
					$elm$core$List$cons,
					A3(
						$author$project$Ui$Button$view,
						{mm: 'Close test modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$secondary,
								$author$project$Ui$Button$onClick($author$project$Pages$Partner$Products$Id_String$AppSettings$TestHandshakeModalClosed)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Close')
							])),
					function () {
						if (testRequest.$ === 2) {
							return _List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Retry handshake test'},
									_List_fromArray(
										[
											$author$project$Ui$Button$primary,
											$author$project$Ui$Button$onClick($author$project$Pages$Partner$Products$Id_String$AppSettings$TestHandshakeClicked)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Retry')
										]))
								]);
						} else {
							return _List_Nil;
						}
					}()))
			]));
};
var $author$project$Pages$Partner$Products$Id_String$AppSettings$viewBody = function (model) {
	return _List_fromArray(
		[
			function () {
			var _v0 = model.af;
			if (!_v0.$) {
				var form = _v0.a;
				return A5($author$project$Pages$Partner$Products$Id_String$AppSettings$viewEditModal, model.YN, model.kr, model.oL, form, model.qP);
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			model.u5 ? $author$project$Pages$Partner$Products$Id_String$AppSettings$viewTestHandshakeModal(model.qv) : $elm$html$Html$text(''),
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			$elm$core$List$singleton(
				A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					function () {
						var _v1 = model.rl;
						_v1$2:
						while (true) {
							switch (_v1.$) {
								case 3:
									var app = _v1.a;
									return A2($author$project$Pages$Partner$Products$Id_String$AppSettings$viewApp, model, app);
								case 2:
									if (_v1.a.$ === 5) {
										var _v2 = _v1.a;
										return $author$project$Pages$Partner$Products$Id_String$AppSettings$viewBuildApp;
									} else {
										break _v1$2;
									}
								default:
									break _v1$2;
							}
						}
						return _List_Nil;
					}())))
		]);
};
var $author$project$Pages$Partner$Products$Id_String$AppSettings$view = function (model) {
	return {
		fO: $author$project$Pages$Partner$Products$Id_String$AppSettings$viewBody(model),
		ac9: 'Partner | Product | AppSettings'
	};
};
var $author$project$Pages$Partner$Products$Id_String$AppSettings$page = $author$project$Spa$Page$applicationPartner(
	{ah_: $author$project$Pages$Partner$Products$Id_String$AppSettings$init, aiq: $author$project$Pages$Partner$Products$Id_String$AppSettings$load, k8: $author$project$Pages$Partner$Products$Id_String$AppSettings$save, alO: $author$project$Pages$Partner$Products$Id_String$AppSettings$subscriptions, adT: $author$project$Pages$Partner$Products$Id_String$AppSettings$update, amo: $author$project$Pages$Partner$Products$Id_String$AppSettings$view});
var $author$project$Pages$Partner$Products$Id_String$Hinter$GotPartnerProduct = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$Hinter$init = F4(
	function (_v0, partner, shared, _v1) {
		var _v2 = $author$project$Api$Partner$Partner$One$product(partner);
		if (!_v2.$) {
			var product = _v2.a;
			var productId = $author$project$Api$Partner$PartnerProduct$Shared$id(product);
			return _Utils_Tuple2(
				{Gv: shared.Gv, gR: $elm$core$Maybe$Nothing, YN: partner, g5: $elm$core$Maybe$Nothing, _s: $author$project$Api$Data$Loading},
				A3($author$project$Api$Partner$PartnerProduct$retrieve, shared.Gv, productId, $author$project$Pages$Partner$Products$Id_String$Hinter$GotPartnerProduct));
		} else {
			return _Utils_Tuple2(
				{Gv: shared.Gv, gR: $elm$core$Maybe$Nothing, YN: partner, g5: $elm$core$Maybe$Nothing, _s: $author$project$Api$Data$NotAsked},
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Partner$Products$Id_String$Hinter$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Partner$Products$Id_String$Hinter$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Partner$Products$Id_String$Hinter$ManagePartnerProductPricingsMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Partner$Products$Id_String$Hinter$PartnerProductFormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Hinter$EditPartnerProductForm$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Components$Partner$ManagePartnerProductPricings$CancelAddOrEdit = {$: 1};
var $author$project$Components$Partner$ManagePartnerProductPricings$DeleteConfirmationClosed = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductPricings$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Partner$ManagePartnerProductPricings$CancelAddOrEdit)),
					model.P)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$Partner$ManagePartnerProductPricings$DeleteConfirmationClosed)),
					model.cz))
			]));
};
var $author$project$Pages$Partner$Products$Id_String$Hinter$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				function () {
				var _v0 = model.g5;
				if (!_v0.$) {
					var partnerProductForm = _v0.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Pages$Partner$Products$Id_String$Hinter$PartnerProductFormMsg,
						$author$project$Components$Hinter$EditPartnerProductForm$subscriptions(partnerProductForm));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				function () {
				var _v1 = model.gR;
				if (!_v1.$) {
					var pricingsModel = _v1.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Pages$Partner$Products$Id_String$Hinter$ManagePartnerProductPricingsMsg,
						$author$project$Components$Partner$ManagePartnerProductPricings$subscriptions(pricingsModel));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}()
			]));
};
var $author$project$Components$Hinter$EditPartnerProductForm$Model = $elm$core$Basics$identity;
var $author$project$Components$Hinter$EditPartnerProductForm$FeatureType = 0;
var $author$project$Components$Hinter$EditPartnerProductForm$TierType = 1;
var $author$project$Api$Partner$PartnerProduct$One$requirement = function (_v0) {
	var record = _v0.b;
	return record.$E;
};
var $author$project$Components$Hinter$EditPartnerProductForm$initFormFields = function (product) {
	var _v0 = function () {
		var _v1 = $author$project$Api$Partner$PartnerProduct$One$requirement(product);
		if (!_v1.$) {
			if (!_v1.a.$) {
				var f = _v1.a.a;
				return _Utils_Tuple3(
					true,
					0,
					$elm$core$Maybe$Just(
						$author$project$Api$Common$Marketplace$Product$Requirement$Feature$toString(f)));
			} else {
				var tier = _v1.a.a;
				return _Utils_Tuple3(
					true,
					1,
					$elm$core$Maybe$Just(tier));
			}
		} else {
			return _Utils_Tuple3(false, 0, $elm$core$Maybe$Nothing);
		}
	}();
	var requirementEnabled = _v0.a;
	var requirementType = _v0.b;
	var requirementValue = _v0.c;
	return _Utils_Tuple2(
		{
			QN: $author$project$Api$Partner$PartnerProduct$One$distributionType(product),
			Se: $author$project$Api$Partner$PartnerProduct$One$featured(product),
			Jo: $author$project$Api$Partner$PartnerProduct$One$type_(product),
			kZ: requirementEnabled,
			pH: requirementType,
			ht: requirementValue,
			abG: $author$project$Api$Partner$PartnerProduct$One$slug(product),
			alH: $author$project$Api$Partner$PartnerProduct$One$status(product)
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Components$Hinter$EditPartnerProductForm$init = function (product) {
	var _v0 = $author$project$Components$Hinter$EditPartnerProductForm$initFormFields(product);
	var formFields = _v0.a;
	var formFieldsCmd = _v0.b;
	return _Utils_Tuple2(
		{
			SD: $author$project$Utils$Form$init(formFields),
			Jn: $author$project$Api$Partner$PartnerProduct$One$id(product),
			qP: $author$project$Api$Data$NotAsked
		},
		formFieldsCmd);
};
var $author$project$Components$Partner$ManagePartnerProductPricings$Model = $elm$core$Basics$identity;
var $author$project$Components$Partner$ManagePartnerProductPricings$init = F2(
	function (productId, maybePricing) {
		return _Utils_Tuple2(
			{cz: $elm$core$Maybe$Nothing, _i: maybePricing, P: $elm$core$Maybe$Nothing, Jn: productId},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Components$Hinter$EditPartnerProductForm$GotUpdatedPartnerProduct = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Hinter$EditPartnerProductForm$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{abG: string});
			case 1:
				var productType = field.a;
				return _Utils_update(
					fields,
					{Jo: productType});
			case 2:
				var distributionType = field.a;
				return _Utils_update(
					fields,
					{QN: distributionType});
			case 3:
				var status = field.a;
				return _Utils_update(
					fields,
					{alH: status});
			case 4:
				var bool = field.a;
				return _Utils_update(
					fields,
					{Se: bool});
			case 5:
				var bool = field.a;
				return _Utils_update(
					fields,
					{kZ: bool, ht: $elm$core$Maybe$Nothing});
			case 6:
				var requirementType = field.a;
				return _Utils_update(
					fields,
					{pH: requirementType, ht: $elm$core$Maybe$Nothing});
			default:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						ht: $author$project$Utils$String$toMaybe(string)
					});
		}
	});
var $author$project$Components$Hinter$EditPartnerProductForm$RequirementValueValidation = 0;
var $author$project$Components$Hinter$EditPartnerProductForm$validateRequirementValue = function (fields) {
	return (fields.kZ && _Utils_eq(fields.ht, $elm$core$Maybe$Nothing)) ? _List_fromArray(
		[
			_Utils_Tuple2(0, 'A value is required')
		]) : _List_Nil;
};
var $author$project$Components$Hinter$EditPartnerProductForm$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Hinter$EditPartnerProductForm$validateRequirementValue)
		]));
var $author$project$Api$Partner$PartnerProduct$DistributionType = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Partner$PartnerProduct$FeatureRequirement = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Partner$PartnerProduct$Featured = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Partner$PartnerProduct$InstallationRequirement = function (a) {
	return {$: 13, a: a};
};
var $author$project$Api$Partner$PartnerProduct$ProductType = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Partner$PartnerProduct$Slug = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Partner$PartnerProduct$Status = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Partner$PartnerProduct$TierRequirement = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Hinter$EditPartnerProductForm$toPermittedFields = function (fields) {
	var installationRequirement = fields.kZ ? A2(
		$elm$core$Maybe$map,
		function (value) {
			var _v0 = fields.pH;
			if (!_v0) {
				return $author$project$Api$Partner$PartnerProduct$FeatureRequirement(
					$author$project$Api$Common$Marketplace$Product$Requirement$Feature$fromString(value));
			} else {
				return $author$project$Api$Partner$PartnerProduct$TierRequirement(value);
			}
		},
		fields.ht) : $elm$core$Maybe$Nothing;
	return _List_fromArray(
		[
			$author$project$Api$Partner$PartnerProduct$Slug(fields.abG),
			$author$project$Api$Partner$PartnerProduct$ProductType(fields.Jo),
			$author$project$Api$Partner$PartnerProduct$DistributionType(fields.QN),
			$author$project$Api$Partner$PartnerProduct$Status(fields.alH),
			$author$project$Api$Partner$PartnerProduct$Featured(fields.Se),
			$author$project$Api$Partner$PartnerProduct$InstallationRequirement(installationRequirement)
		]);
};
var $author$project$Components$Hinter$EditPartnerProductForm$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Hinter$EditPartnerProductForm$formFieldsUpdate, field, model.SD);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: newForm}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$Hinter$EditPartnerProductForm$formFieldsValidator, model.SD);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var validFormFields = _v3.b;
					var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{qP: $author$project$Api$Data$Loading}),
						A4(
							$author$project$Api$Partner$PartnerProduct$update,
							apiClient,
							model.Jn,
							$author$project$Components$Hinter$EditPartnerProductForm$toPermittedFields(fields),
							$author$project$Components$Hinter$EditPartnerProductForm$GotUpdatedPartnerProduct),
						_List_Nil);
				} else {
					var updatedForm = _v2.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{SD: updatedForm, qP: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var updatedProduct = response.a;
					var _v5 = $author$project$Components$Hinter$EditPartnerProductForm$initFormFields(updatedProduct);
					var updatedFormFields = _v5.a;
					var formFieldsCmd = _v5.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								SD: $author$project$Utils$Form$init(updatedFormFields),
								qP: $author$project$Api$Data$NotAsked
							}),
						formFieldsCmd,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Settings saved!'),
								$author$project$OutMsg$RefreshPartner
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{qP: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Components$Partner$ManagePartnerProductPricings$Deleted = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductPricings$None = 0;
var $author$project$Components$Partner$ManagePartnerProductPricings$PricingCreated = 1;
var $author$project$Components$Partner$ManagePartnerProductPricings$PricingDeleted = 3;
var $author$project$Components$Partner$ManagePartnerProductPricings$PricingUpdated = 2;
var $author$project$Api$Partner$PartnerProductPricing$pricingPath = function (productId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['partner_products', productId, 'pricing']),
		$author$project$Api$Data$partnerPath);
};
var $author$project$Api$Partner$PartnerProductPricing$delete = F3(
	function (apiClient, productId, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Partner$PartnerProductPricing$pricingPath(productId)));
	});
var $author$project$Components$Partner$ManagePartnerProductPricings$initPricingFields = {Qr: ''};
var $author$project$Components$Partner$ManagePartnerProductPricings$initPricingFieldsForEdit = function (pricing) {
	return {
		Qr: $author$project$Api$Partner$PartnerProductPricing$Shared$description(pricing)
	};
};
var $author$project$Components$Partner$ManagePartnerProductPricings$pricingFieldsUpdate = F2(
	function (field, fields) {
		var description = field;
		return _Utils_update(
			fields,
			{Qr: description});
	});
var $author$project$Components$Partner$ManagePartnerProductPricings$DescriptionValidation = 0;
var $author$project$Components$Partner$ManagePartnerProductPricings$pricingValidator = A2(
	$rtfeldman$elm_validate$Validate$ifBlank,
	function ($) {
		return $.Qr;
	},
	_Utils_Tuple2(0, 'Please enter a description.'));
var $author$project$Components$Partner$ManagePartnerProductPricings$Created = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductPricings$Updated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Partner$PartnerProductPricing$One$PartnerProductPricing = 0;
var $author$project$Api$Partner$PartnerProductPricing$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Partner$PartnerProductPricing$pricingParams = function (params) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'partner_product_pricing',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'description',
							$elm$json$Json$Encode$string(params.Qr))
						])))
			]));
};
var $author$project$Api$Partner$PartnerProductPricing$create = F4(
	function (apiClient, productId, params, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$PartnerProductPricing$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Partner$PartnerProductPricing$pricingParams(params),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Partner$PartnerProductPricing$pricingPath(productId))));
	});
var $author$project$Api$Partner$PartnerProductPricing$update = F4(
	function (apiClient, productId, params, toMsg) {
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Partner$PartnerProductPricing$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Partner$PartnerProductPricing$pricingParams(params),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Partner$PartnerProductPricing$pricingPath(productId))));
	});
var $author$project$Components$Partner$ManagePartnerProductPricings$savePricing = F4(
	function (apiClient, productId, isEdit, validFormFields) {
		var _v0 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
		var description = _v0.Qr;
		return isEdit ? A4(
			$author$project$Api$Partner$PartnerProductPricing$update,
			apiClient,
			productId,
			{Qr: description},
			$author$project$Components$Partner$ManagePartnerProductPricings$Updated) : A4(
			$author$project$Api$Partner$PartnerProductPricing$create,
			apiClient,
			productId,
			{Qr: description},
			$author$project$Components$Partner$ManagePartnerProductPricings$Created);
	});
var $author$project$Components$Partner$ManagePartnerProductPricings$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							P: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									false,
									$author$project$Utils$Form$init($author$project$Components$Partner$ManagePartnerProductPricings$initPricingFields),
									$author$project$Api$Data$NotAsked))
						}),
					aR: _List_Nil
				};
			case 1:
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{P: $elm$core$Maybe$Nothing}),
					aR: _List_Nil
				};
			case 2:
				var field = msg.a;
				var _v2 = model.P;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var isEdit = _v3.a;
					var form = _v3.b;
					var request = _v3.c;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{
								P: $elm$core$Maybe$Just(
									_Utils_Tuple3(
										isEdit,
										A3($author$project$Utils$Form$update, $author$project$Components$Partner$ManagePartnerProductPricings$pricingFieldsUpdate, field, form),
										request))
							}),
						aR: _List_Nil
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
			case 3:
				var pricing = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							P: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									true,
									$author$project$Utils$Form$init(
										$author$project$Components$Partner$ManagePartnerProductPricings$initPricingFieldsForEdit(pricing)),
									$author$project$Api$Data$NotAsked))
						}),
					aR: _List_Nil
				};
			case 4:
				var _v4 = model.P;
				if (!_v4.$) {
					var _v5 = _v4.a;
					var isEdit = _v5.a;
					var form = _v5.b;
					var _v6 = A2($author$project$Utils$Form$validate, $author$project$Components$Partner$ManagePartnerProductPricings$pricingValidator, form);
					if (!_v6.$) {
						var _v7 = _v6.a;
						var validatedForm = _v7.a;
						var validFormFields = _v7.b;
						return {
							GZ: A4($author$project$Components$Partner$ManagePartnerProductPricings$savePricing, apiClient, model.Jn, isEdit, validFormFields),
							agZ: 0,
							aiO: _Utils_update(
								model,
								{
									P: $elm$core$Maybe$Just(
										_Utils_Tuple3(isEdit, validatedForm, $author$project$Api$Data$Loading))
								}),
							aR: _List_Nil
						};
					} else {
						var validatedForm = _v6.a;
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 0,
							aiO: _Utils_update(
								model,
								{
									P: $elm$core$Maybe$Just(
										_Utils_Tuple3(isEdit, validatedForm, $author$project$Api$Data$NotAsked))
								}),
							aR: _List_Nil
						};
					}
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
			case 5:
				var response = msg.a;
				var _v8 = model.P;
				if (!_v8.$) {
					var _v9 = _v8.a;
					var isEdit = _v9.a;
					var form = _v9.b;
					if (response.$ === 3) {
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 1,
							aiO: _Utils_update(
								model,
								{P: $elm$core$Maybe$Nothing}),
							aR: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Pricing created successfully!')
								])
						};
					} else {
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 0,
							aiO: _Utils_update(
								model,
								{
									P: $elm$core$Maybe$Just(
										_Utils_Tuple3(isEdit, form, response))
								}),
							aR: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
			case 6:
				var response = msg.a;
				var _v11 = model.P;
				if (!_v11.$) {
					var _v12 = _v11.a;
					var isEdit = _v12.a;
					var form = _v12.b;
					if (response.$ === 3) {
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 2,
							aiO: _Utils_update(
								model,
								{P: $elm$core$Maybe$Nothing}),
							aR: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Pricing updated successfully!')
								])
						};
					} else {
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 0,
							aiO: _Utils_update(
								model,
								{
									P: $elm$core$Maybe$Just(
										_Utils_Tuple3(isEdit, form, response))
								}),
							aR: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
			case 7:
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							cz: $elm$core$Maybe$Just($author$project$Api$Data$NotAsked)
						}),
					aR: _List_Nil
				};
			case 8:
				var confirmed = msg.a;
				var _v14 = model.cz;
				if (!_v14.$) {
					return confirmed ? {
						GZ: A3($author$project$Api$Partner$PartnerProductPricing$delete, apiClient, model.Jn, $author$project$Components$Partner$ManagePartnerProductPricings$Deleted),
						agZ: 0,
						aiO: _Utils_update(
							model,
							{
								cz: $elm$core$Maybe$Just($author$project$Api$Data$Loading)
							}),
						aR: _List_Nil
					} : {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{cz: $elm$core$Maybe$Nothing}),
						aR: _List_Nil
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
			default:
				var response = msg.a;
				var _v15 = model.cz;
				if (!_v15.$) {
					if (response.$ === 3) {
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 3,
							aiO: _Utils_update(
								model,
								{cz: $elm$core$Maybe$Nothing}),
							aR: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Pricing deleted successfully!')
								])
						};
					} else {
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 0,
							aiO: _Utils_update(
								model,
								{
									cz: $elm$core$Maybe$Just(response)
								}),
							aR: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
		}
	});
var $author$project$Pages$Partner$Products$Id_String$Hinter$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = model.g5;
				if (!_v1.$) {
					var partnerProductForm = _v1.a;
					var _v2 = A3($author$project$Components$Hinter$EditPartnerProductForm$update, model.Gv, subMsg, partnerProductForm);
					var newPartnerProductForm = _v2.a;
					var cmd = _v2.b;
					var outMsgs = _v2.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								g5: $elm$core$Maybe$Just(newPartnerProductForm)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Products$Id_String$Hinter$PartnerProductFormMsg, cmd),
						outMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 1:
				var response = msg.a;
				if (response.$ === 3) {
					var product = response.a;
					var _v4 = A2(
						$author$project$Components$Partner$ManagePartnerProductPricings$init,
						$author$project$Api$Partner$PartnerProduct$One$id(product),
						$author$project$Api$Partner$PartnerProduct$One$pricing(product));
					var pricingsModel = _v4.a;
					var pricingsCmd = _v4.b;
					var _v5 = $author$project$Components$Hinter$EditPartnerProductForm$init(product);
					var partnerProductForm = _v5.a;
					var partnerProductFormCmd = _v5.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								gR: $elm$core$Maybe$Just(pricingsModel),
								g5: $elm$core$Maybe$Just(partnerProductForm),
								_s: response
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Products$Id_String$Hinter$PartnerProductFormMsg, partnerProductFormCmd),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Products$Id_String$Hinter$ManagePartnerProductPricingsMsg, pricingsCmd)
								])),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{_s: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var subMsg = msg.a;
				var _v6 = model.gR;
				if (!_v6.$) {
					var pricingsModel = _v6.a;
					var result = A3($author$project$Components$Partner$ManagePartnerProductPricings$update, model.Gv, subMsg, pricingsModel);
					var reloadCmd = function () {
						var _v7 = result.agZ;
						if (!_v7) {
							return $elm$core$Platform$Cmd$none;
						} else {
							var _v8 = model._s;
							if (_v8.$ === 3) {
								var product = _v8.a;
								return A3(
									$author$project$Api$Partner$PartnerProduct$retrieve,
									model.Gv,
									$author$project$Api$Partner$PartnerProduct$One$id(product),
									$author$project$Pages$Partner$Products$Id_String$Hinter$GotPartnerProduct);
							} else {
								return $elm$core$Platform$Cmd$none;
							}
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								gR: $elm$core$Maybe$Just(result.aiO)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Products$Id_String$Hinter$ManagePartnerProductPricingsMsg, result.GZ),
									reloadCmd
								])),
						result.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Components$Partner$ManagePartnerProductPricings$viewPricingDeleteConfirmModal = function (model) {
	var _v0 = model.cz;
	if (!_v0.$) {
		var request = _v0.a;
		return A2(
			$author$project$Components$HiConfirm$modal,
			$author$project$Components$Partner$ManagePartnerProductPricings$DeleteConfirmationClosed,
			_List_fromArray(
				[
					$author$project$Components$HiConfirm$verb('delete'),
					$author$project$Components$HiConfirm$noun('pricing'),
					$author$project$Components$HiConfirm$loading(
					_Utils_eq(request, $author$project$Api$Data$Loading))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Partner$ManagePartnerProductPricings$Description = $elm$core$Basics$identity;
var $author$project$Components$Partner$ManagePartnerProductPricings$FormUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductPricings$Save = {$: 4};
var $author$project$Components$Partner$ManagePartnerProductPricings$viewPricingModal = function (_v0) {
	var pricingForm = _v0.P;
	if (!pricingForm.$) {
		var _v2 = pricingForm.a;
		var isEdit = _v2.a;
		var form = _v2.b;
		var request = _v2.c;
		var modalConfig = {
			Tq: $elm$core$Maybe$Nothing,
			aih: 'Pricing',
			V8: _Utils_eq(request, $author$project$Api$Data$Loading),
			WG: isEdit ? $elm$core$Maybe$Just('pricing') : $elm$core$Maybe$Nothing,
			WH: $elm$core$Maybe$Nothing,
			Yd: $author$project$Components$Partner$ManagePartnerProductPricings$CancelAddOrEdit,
			Yf: $elm$core$Basics$always($author$project$Components$Partner$ManagePartnerProductPricings$Save)
		};
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Description'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Textarea$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Textarea$value(fields.Qr),
									$author$project$Ui$Form$Textarea$placeholder('Description'),
									$author$project$Ui$Form$Textarea$onInput(
									A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $author$project$Components$Partner$ManagePartnerProductPricings$FormUpdated)),
									$author$project$Ui$Form$Textarea$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
									$author$project$Ui$Form$Textarea$errors(
									A2($author$project$Utils$Form$validationErrors, 0, form))
								]))
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Partner$ManagePartnerProductPricings$modal = function (_v0) {
	var model = _v0;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Components$Partner$ManagePartnerProductPricings$viewPricingDeleteConfirmModal(model),
				$author$project$Components$Partner$ManagePartnerProductPricings$viewPricingModal(model)
			]));
};
var $author$project$Components$Hinter$EditPartnerProductForm$DistributionType = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Hinter$EditPartnerProductForm$Featured = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Hinter$EditPartnerProductForm$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Hinter$EditPartnerProductForm$ProductType = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Hinter$EditPartnerProductForm$RequirementEnabled = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Hinter$EditPartnerProductForm$RequirementType = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Hinter$EditPartnerProductForm$RequirementValue = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Hinter$EditPartnerProductForm$Save = {$: 1};
var $author$project$Components$Hinter$EditPartnerProductForm$Slug = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Hinter$EditPartnerProductForm$Status = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Common$Marketplace$Product$ProductType$all = _List_fromArray(
	[0, 1, 2]);
var $author$project$Api$Common$Marketplace$Product$Status$all = _List_fromArray(
	[1, 2, 3, 4, 5, 6, 7, 8]);
var $author$project$Api$Common$Marketplace$Product$ProductType$fromString = function (str) {
	switch (str) {
		case 'app':
			return $elm$core$Maybe$Just(0);
		case 'integration':
			return $elm$core$Maybe$Just(1);
		case 'solution':
			return $elm$core$Maybe$Just(2);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Common$Marketplace$Product$Requirement$Feature$all = _List_fromArray(
	[$author$project$Api$Common$Marketplace$Product$Requirement$Feature$Emr]);
var $author$project$Api$Common$Marketplace$Product$Requirement$Feature$toLabel = function (feature) {
	if (!feature.$) {
		return 'EMR - Clinical';
	} else {
		var string = feature.a;
		return string;
	}
};
var $author$project$Components$Hinter$EditPartnerProductForm$requirementValueOptions = function (requirementType) {
	if (!requirementType) {
		return A2(
			$elm$core$List$cons,
			A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, 'Select a feature...'),
			A2(
				$elm$core$List$map,
				function (f) {
					return A3(
						$author$project$Ui$Form$Select$option,
						_List_Nil,
						$elm$core$Maybe$Just(
							$author$project$Api$Common$Marketplace$Product$Requirement$Feature$toString(f)),
						$author$project$Api$Common$Marketplace$Product$Requirement$Feature$toLabel(f));
				},
				$author$project$Api$Common$Marketplace$Product$Requirement$Feature$all));
	} else {
		return _List_fromArray(
			[
				A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, 'Select a tier...')
			]);
	}
};
var $author$project$Components$Hinter$EditPartnerProductForm$view = function (_v0) {
	var model = _v0;
	var loading = _Utils_eq(model.qP, $author$project$Api$Data$Loading);
	var fields = $author$project$Utils$Form$fields(model.SD);
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8),
						$author$project$Ui$Form$Group$label('Slug')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(fields.abG),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Components$Hinter$EditPartnerProductForm$FormUpdated, $author$project$Components$Hinter$EditPartnerProductForm$Slug))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Product Type')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Select$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Select$value(
								$elm$core$Maybe$Just(
									$author$project$Api$Common$Marketplace$Product$ProductType$toString(fields.Jo))),
								$author$project$Ui$Form$Select$onChange(
								function (str) {
									return A2(
										$elm$core$Maybe$withDefault,
										$author$project$Components$Hinter$EditPartnerProductForm$FormUpdated(
											$author$project$Components$Hinter$EditPartnerProductForm$ProductType(fields.Jo)),
										A2(
											$elm$core$Maybe$map,
											A2($elm$core$Basics$composeL, $author$project$Components$Hinter$EditPartnerProductForm$FormUpdated, $author$project$Components$Hinter$EditPartnerProductForm$ProductType),
											$author$project$Api$Common$Marketplace$Product$ProductType$fromString(str)));
								})
							]),
						A2(
							$elm$core$List$map,
							function (type_) {
								return A3(
									$author$project$Ui$Form$Select$option,
									_List_Nil,
									$elm$core$Maybe$Just(
										$author$project$Api$Common$Marketplace$Product$ProductType$toString(type_)),
									$author$project$Api$Common$Marketplace$Product$ProductType$toLabel(type_));
							},
							$author$project$Api$Common$Marketplace$Product$ProductType$all))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Distribution Type')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Select$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Select$value(
								$elm$core$Maybe$Just(
									$author$project$Api$Common$Marketplace$Product$DistributionType$toString(fields.QN))),
								$author$project$Ui$Form$Select$onChange(
								function (str) {
									return A2(
										$elm$core$Maybe$withDefault,
										$author$project$Components$Hinter$EditPartnerProductForm$FormUpdated(
											$author$project$Components$Hinter$EditPartnerProductForm$DistributionType(fields.QN)),
										A2(
											$elm$core$Maybe$map,
											A2($elm$core$Basics$composeL, $author$project$Components$Hinter$EditPartnerProductForm$FormUpdated, $author$project$Components$Hinter$EditPartnerProductForm$DistributionType),
											$author$project$Api$Common$Marketplace$Product$DistributionType$fromString(str)));
								})
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Form$Select$option,
								_List_Nil,
								$elm$core$Maybe$Just('public'),
								'Public'),
								A3(
								$author$project$Ui$Form$Select$option,
								_List_Nil,
								$elm$core$Maybe$Just('unlisted'),
								'Unlisted')
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Featured')
					]),
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$view(
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$on(fields.Se),
								$author$project$Ui$ToggleSwitch$onChange(
								A2($elm$core$Basics$composeL, $author$project$Components$Hinter$EditPartnerProductForm$FormUpdated, $author$project$Components$Hinter$EditPartnerProductForm$Featured))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Status')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Select$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Select$value(
								$elm$core$Maybe$Just(
									$author$project$Api$Common$Marketplace$Product$Status$toString(fields.alH))),
								$author$project$Ui$Form$Select$onChange(
								function (str) {
									return A2(
										$elm$core$Maybe$withDefault,
										$author$project$Components$Hinter$EditPartnerProductForm$FormUpdated(
											$author$project$Components$Hinter$EditPartnerProductForm$Status(fields.alH)),
										A2(
											$elm$core$Maybe$map,
											A2($elm$core$Basics$composeL, $author$project$Components$Hinter$EditPartnerProductForm$FormUpdated, $author$project$Components$Hinter$EditPartnerProductForm$Status),
											$author$project$Api$Common$Marketplace$Product$Status$fromString(str)));
								})
							]),
						A2(
							$elm$core$List$map,
							function (status) {
								return A3(
									$author$project$Ui$Form$Select$option,
									_List_Nil,
									$elm$core$Maybe$Just(
										$author$project$Api$Common$Marketplace$Product$Status$toString(status)),
									$author$project$Api$Common$Marketplace$Product$Status$toLabel(status));
							},
							$author$project$Api$Common$Marketplace$Product$Status$all))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Has a requirement?')
					]),
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$view(
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$on(fields.kZ),
								$author$project$Ui$ToggleSwitch$onChange(
								A2($elm$core$Basics$composeL, $author$project$Components$Hinter$EditPartnerProductForm$FormUpdated, $author$project$Components$Hinter$EditPartnerProductForm$RequirementEnabled))
							]))
					])),
				fields.kZ ? A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label(''),
						$author$project$Ui$Form$Group$inputSpanSm(8),
						$author$project$Ui$Form$Group$labelSpanSm(4)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$group(
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Select$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Select$value(
										$elm$core$Maybe$Just(
											function () {
												var _v1 = fields.pH;
												if (!_v1) {
													return 'feature';
												} else {
													return 'tier';
												}
											}())),
										$author$project$Ui$Form$Select$onChange(
										function (str) {
											if (str === 'feature') {
												return $author$project$Components$Hinter$EditPartnerProductForm$FormUpdated(
													$author$project$Components$Hinter$EditPartnerProductForm$RequirementType(0));
											} else {
												return $author$project$Components$Hinter$EditPartnerProductForm$FormUpdated(
													$author$project$Components$Hinter$EditPartnerProductForm$RequirementType(1));
											}
										})
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Form$Select$option,
										_List_Nil,
										$elm$core$Maybe$Just('feature'),
										'Feature'),
										A3(
										$author$project$Ui$Form$Select$option,
										_List_Nil,
										$elm$core$Maybe$Just('tier'),
										'Tier')
									])),
								A2(
								$author$project$Ui$Form$Select$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Select$value(fields.ht),
										$author$project$Ui$Form$Select$onChange(
										A2($elm$core$Basics$composeL, $author$project$Components$Hinter$EditPartnerProductForm$FormUpdated, $author$project$Components$Hinter$EditPartnerProductForm$RequirementValue)),
										$author$project$Ui$Form$Select$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 0, model.SD)),
										$author$project$Ui$Form$Select$errors(
										A2($author$project$Utils$Form$validationErrors, 0, model.SD))
									]),
								$author$project$Components$Hinter$EditPartnerProductForm$requirementValueOptions(fields.pH))
							]))
					])) : $author$project$Utils$Html$empty,
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$textCenter, $author$project$Ui$Element$mt4]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Save product changes'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$submit,
								$author$project$Ui$Button$loading(loading),
								$author$project$Ui$Button$onClick($author$project$Components$Hinter$EditPartnerProductForm$Save)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Save')
							]))
					]))
			]));
};
var $author$project$Components$Partner$ManagePartnerProductPricings$Add = {$: 0};
var $author$project$Components$Partner$ManagePartnerProductPricings$Delete = {$: 7};
var $author$project$Components$Partner$ManagePartnerProductPricings$Edit = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductPricings$viewPricing = function (pricing) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$mt4]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$elm$core$Basics$never,
						A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$preWrap]),
							$author$project$Utils$Html$ulFromString(
								$author$project$Api$Partner$PartnerProductPricing$Shared$description(pricing)))),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$gap2]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Edit pricing'},
								_List_fromArray(
									[
										$author$project$Ui$Button$sm,
										$author$project$Ui$Button$icon($author$project$Ui$Icon$edit),
										$author$project$Ui$Button$onClick(
										$author$project$Components$Partner$ManagePartnerProductPricings$Edit(pricing))
									]),
								_List_Nil),
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Delete pricing'},
								_List_fromArray(
									[
										$author$project$Ui$Button$danger,
										$author$project$Ui$Button$sm,
										$author$project$Ui$Button$icon($author$project$Ui$Icon$delete),
										$author$project$Ui$Button$onClick($author$project$Components$Partner$ManagePartnerProductPricings$Delete)
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $author$project$Components$Partner$ManagePartnerProductPricings$view = function (_v0) {
	var model = _v0;
	return A3(
		$author$project$Ui$Element$custom,
		'card',
		_List_fromArray(
			[$author$project$Ui$Element$mt4]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
						_List_fromArray(
							[
								$author$project$Ui$Typography$headingSm(
								_List_fromArray(
									[
										$elm$html$Html$text('Pricing')
									])),
								function () {
								var _v1 = model._i;
								if (_v1.$ === 1) {
									return A3(
										$author$project$Ui$Button$view,
										{mm: 'Add pricing'},
										_List_fromArray(
											[
												$author$project$Ui$Button$icon($author$project$Ui$Icon$add),
												$author$project$Ui$Button$onClick($author$project$Components$Partner$ManagePartnerProductPricings$Add)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Add Pricing')
											]));
								} else {
									return $author$project$Utils$Html$empty;
								}
							}()
							])),
						$author$project$Ui$HorizontalRule$view(
						_List_fromArray(
							[$author$project$Ui$HorizontalRule$thin])),
						function () {
						var _v2 = model._i;
						if (!_v2.$) {
							var pricing = _v2.a;
							return $author$project$Components$Partner$ManagePartnerProductPricings$viewPricing(pricing);
						} else {
							return $author$project$Utils$Html$empty;
						}
					}()
					]))
			]));
};
var $author$project$Pages$Partner$Products$Id_String$Hinter$view = function (model) {
	return {
		fO: function () {
			var _v0 = model.g5;
			if (!_v0.$) {
				var partnerProductForm = _v0.a;
				return $elm$core$List$concat(
					_List_fromArray(
						[
							_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Panel$heading,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Ui$Panel$title(
												_List_fromArray(
													[
														$elm$html$Html$text('Admin Settings')
													]))
											])),
										A2(
										$author$project$Ui$Panel$body,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Pages$Partner$Products$Id_String$Hinter$PartnerProductFormMsg,
												$author$project$Components$Hinter$EditPartnerProductForm$view(partnerProductForm))
											]))
									]))
							]),
							function () {
							var _v1 = model.gR;
							if (!_v1.$) {
								var pricingsModel = _v1.a;
								return _List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Pages$Partner$Products$Id_String$Hinter$ManagePartnerProductPricingsMsg,
										$author$project$Components$Partner$ManagePartnerProductPricings$modal(pricingsModel)),
										A2(
										$elm$html$Html$map,
										$author$project$Pages$Partner$Products$Id_String$Hinter$ManagePartnerProductPricingsMsg,
										$author$project$Components$Partner$ManagePartnerProductPricings$view(pricingsModel))
									]);
							} else {
								return _List_Nil;
							}
						}()
						]));
			} else {
				return _List_Nil;
			}
		}(),
		ac9: 'Partner | Product | Admin Settings'
	};
};
var $author$project$Pages$Partner$Products$Id_String$Hinter$page = $author$project$Spa$Page$applicationPartner(
	{ah_: $author$project$Pages$Partner$Products$Id_String$Hinter$init, aiq: $author$project$Pages$Partner$Products$Id_String$Hinter$load, k8: $author$project$Pages$Partner$Products$Id_String$Hinter$save, alO: $author$project$Pages$Partner$Products$Id_String$Hinter$subscriptions, adT: $author$project$Pages$Partner$Products$Id_String$Hinter$update, amo: $author$project$Pages$Partner$Products$Id_String$Hinter$view});
var $author$project$Pages$Partner$Products$New$FormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$NewProduct$Model = $elm$core$Basics$identity;
var $author$project$Components$Partner$ExternalCtaForm$empty = {adY: '', aea: '', aeb: ''};
var $author$project$Api$Partner$Partner$Shared$slug = function (_v0) {
	var record = _v0;
	return record.abG;
};
var $author$project$Api$Partner$Partner$One$slug = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$slug(shared);
};
var $author$project$Components$Partner$NewProduct$initFormFields = function (partner) {
	return _Utils_Tuple2(
		{
			Qr: $elm$core$Maybe$Nothing,
			ahO: $elm$core$Maybe$Nothing,
			Bq: $author$project$Api$Partner$Partner$One$name(partner),
			Jo: $author$project$Api$Partner$Partner$One$productType(partner),
			abG: $author$project$Api$Partner$Partner$One$slug(partner)
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Components$Partner$NewProduct$init = F2(
	function (partner, imageStore) {
		var _v0 = $author$project$Components$Partner$NewProduct$initFormFields(partner);
		var formFields = _v0.a;
		var formFieldsCmd = _v0.b;
		return _Utils_Tuple2(
			{
				i0: $author$project$Components$Partner$ExternalCtaForm$init($author$project$Components$Partner$ExternalCtaForm$empty),
				SD: $author$project$Utils$Form$init(formFields),
				sF: imageStore
			},
			formFieldsCmd);
	});
var $author$project$Pages$Partner$Products$New$init = F4(
	function (_v0, partner, shared, _v1) {
		var _v2 = A2($author$project$Components$Partner$NewProduct$init, partner, shared.sF);
		var form = _v2.a;
		var formCmd = _v2.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, SD: form, k9: $author$project$Api$Data$NotAsked},
			A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Products$New$FormMsg, formCmd));
	});
var $author$project$Pages$Partner$Products$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Partner$Products$New$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Partner$NewProduct$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Partner$Products$New$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$Partner$Products$New$FormMsg,
		$author$project$Components$Partner$NewProduct$subscriptions(model.SD));
};
var $author$project$Pages$Partner$Products$New$Created = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Partner$PartnerProduct$partnerProductPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['partner_products']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$PartnerProduct$create = F3(
	function (apiClient, permittedFields, toMsg) {
		var body = $author$project$Api$Partner$PartnerProduct$encodePermittedFields(permittedFields);
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$PartnerProduct$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Partner$PartnerProduct$partnerProductPath)));
	});
var $author$project$Pages$Partner$Products$New$createProduct = F2(
	function (apiClient, permittedFields) {
		return A3($author$project$Api$Partner$PartnerProduct$create, apiClient, permittedFields, $author$project$Pages$Partner$Products$New$Created);
	});
var $author$project$Components$Partner$NewProduct$CtaFormMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$NewProduct$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$NewProduct$Icon = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Api$Common$Marketplace$Product$ProductType$default = 0;
var $author$project$Components$Partner$NewProduct$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{abG: string});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Jo: A2(
							$elm$core$Maybe$withDefault,
							$author$project$Api$Common$Marketplace$Product$ProductType$default,
							$author$project$Api$Common$Marketplace$Product$ProductType$fromString(string))
					});
			case 2:
				var string = field.a;
				return _Utils_update(
					fields,
					{Bq: string});
			case 3:
				var _int = field.a;
				var string = field.b;
				return _Utils_update(
					fields,
					{
						ahO: $elm$core$Maybe$Just(
							_Utils_Tuple2(_int, string))
					});
			default:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Qr: $author$project$Utils$String$toMaybe(string)
					});
		}
	});
var $author$project$Components$Partner$NewProduct$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Partner$NewProduct$formFieldsUpdate, field, model.SD);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: newForm}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var icons = msg.a;
				var cmd = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						function (_v2) {
							var task = _v2.a;
							var size = _v2.b;
							return A2(
								$elm$core$Task$perform,
								A2(
									$elm$core$Basics$composeL,
									$author$project$Components$Partner$NewProduct$FormUpdated,
									$author$project$Components$Partner$NewProduct$Icon(size)),
								task);
						},
						A2(
							$elm$core$Maybe$map,
							function (icon) {
								return _Utils_Tuple2(
									$elm$file$File$toUrl(icon),
									$elm$file$File$size(icon));
							},
							$elm$core$List$head(icons))));
				return _Utils_Tuple3(model, cmd, _List_Nil);
			default:
				var subMsg = msg.a;
				var _v3 = A2($author$project$Components$Partner$ExternalCtaForm$update, subMsg, model.i0);
				var ctaForm = _v3.a;
				var cmd = _v3.b;
				var outMsgs = _v3.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{i0: ctaForm}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Partner$NewProduct$CtaFormMsg, cmd),
					outMsgs);
		}
	});
var $author$project$Components$Partner$NewProduct$IconValidation = 2;
var $author$project$Components$Partner$NewProduct$NameValidation = 1;
var $author$project$Components$Partner$NewProduct$SlugValidation = 0;
var $author$project$Components$Partner$NewProduct$maxIconBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
var $author$project$Components$Partner$NewProduct$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.abG;
			},
			_Utils_Tuple2(0, 'Please enter a slug.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.Bq;
			},
			_Utils_Tuple2(1, 'Please enter a name.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.ahO;
			},
			_Utils_Tuple2(2, 'Please select an icon to upload.')),
			$rtfeldman$elm_validate$Validate$fromErrors(
			function (fields) {
				var _v0 = fields.ahO;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var iconSize = _v1.a;
					return (_Utils_cmp(iconSize, $author$project$Components$Partner$NewProduct$maxIconBytesSize) > 0) ? _List_fromArray(
						[
							_Utils_Tuple2(2, 'That image is too large! Our maximum image size is 5 mb, please choose a smaller image.')
						]) : _List_Nil;
				} else {
					return _List_Nil;
				}
			})
		]));
var $author$project$Components$Partner$NewProduct$validate = function (_v0) {
	var model = _v0;
	var _v1 = A2($author$project$Utils$Form$validate, $author$project$Components$Partner$NewProduct$formFieldsValidator, model.SD);
	if (!_v1.$) {
		var _v2 = _v1.a;
		var validFormFields = _v2.b;
		var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
		var iconUrl = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm$core$Maybe$map, $elm$core$Tuple$second, fields.ahO));
		var baseFields = _List_fromArray(
			[
				$author$project$Api$Partner$PartnerProduct$Slug(fields.abG),
				$author$project$Api$Partner$PartnerProduct$ProductType(fields.Jo),
				$author$project$Api$Partner$PartnerProduct$Name(fields.Bq),
				$author$project$Api$Partner$PartnerProduct$Icon(iconUrl),
				$author$project$Api$Partner$PartnerProduct$Summary(fields.Qr)
			]);
		if (fields.Jo === 2) {
			var _v3 = $author$project$Components$Partner$ExternalCtaForm$validate(model.i0);
			if (!_v3.$) {
				var ctaFields = _v3.a;
				return $elm$core$Result$Ok(
					_Utils_ap(
						baseFields,
						_List_fromArray(
							[
								$author$project$Api$Partner$PartnerProduct$CtaUrl(
								$author$project$Utils$String$toMaybe(ctaFields.adY)),
								$author$project$Api$Partner$PartnerProduct$UtmCampaign(
								$author$project$Utils$String$toMaybe(ctaFields.aea)),
								$author$project$Api$Partner$PartnerProduct$UtmContent(
								$author$project$Utils$String$toMaybe(ctaFields.aeb))
							])));
			} else {
				var invalidCtaForm = _v3.a;
				return $elm$core$Result$Err(
					_Utils_update(
						model,
						{i0: invalidCtaForm}));
			}
		} else {
			return $elm$core$Result$Ok(baseFields);
		}
	} else {
		var validatedForm = _v1.a;
		return $elm$core$Result$Err(
			_Utils_update(
				model,
				{SD: validatedForm}));
	}
};
var $author$project$Pages$Partner$Products$New$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Components$Partner$NewProduct$update, subMsg, model.SD);
				var form = _v1.a;
				var cmd = _v1.b;
				var outMsgs = _v1.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: form}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Products$New$FormMsg, cmd),
					outMsgs);
			case 1:
				var _v2 = $author$project$Components$Partner$NewProduct$validate(model.SD);
				if (!_v2.$) {
					var permittedFields = _v2.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: $author$project$Api$Data$Loading}),
						A2($author$project$Pages$Partner$Products$New$createProduct, model.Gv, permittedFields),
						_List_Nil);
				} else {
					var updatedForm = _v2.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{SD: updatedForm, k9: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var product = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: response}),
						A2(
							$author$project$Utils$Route$navigate,
							$elm$core$Dict$empty,
							$author$project$Spa$Generated$Route$Partner__Products__Id_String(
								{
									ahP: $author$project$Api$Partner$PartnerProduct$One$id(product)
								})),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Product created'),
								$author$project$OutMsg$RefreshPartner
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Partner$Products$New$Save = {$: 1};
var $author$project$Components$Partner$NewProduct$Description = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Partner$NewProduct$IconUploaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$NewProduct$Name = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$NewProduct$ProductType = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$NewProduct$Slug = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$NewProduct$view = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.SD);
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8),
						$author$project$Ui$Form$Group$label('Icon'),
						$author$project$Ui$Form$Group$required(true)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$gap4, $author$project$Ui$Element$flexCol]),
						_List_fromArray(
							[
								$author$project$Components$Partner$ProductIconInstructions$view,
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$gap2, $author$project$Ui$Element$flexCol]),
								_List_fromArray(
									[
										function () {
										var _v1 = fields.ahO;
										if (!_v1.$) {
											var _v2 = _v1.a;
											var url = _v2.b;
											return A3(
												$author$project$Ui$Image$fromSrc,
												{LD: 'Product icon'},
												url,
												_List_fromArray(
													[
														$author$project$Ui$Image$height(64),
														$author$project$Ui$Image$width(64)
													]));
										} else {
											return $elm$html$Html$text('');
										}
									}(),
										$author$project$Ui$Form$File$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$File$accept(0),
												$author$project$Ui$Form$File$onInput($author$project$Components$Partner$NewProduct$IconUploaded),
												$author$project$Ui$Form$File$empty(
												!_Utils_eq(fields.ahO, $elm$core$Maybe$Nothing))
											])),
										$author$project$Utils$FormErrors$view(
										A2($author$project$Utils$Form$validationErrors, 2, model.SD))
									]))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8),
						$author$project$Ui$Form$Group$label('Name'),
						$author$project$Ui$Form$Group$required(true)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(fields.Bq),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Components$Partner$NewProduct$FormUpdated, $author$project$Components$Partner$NewProduct$Name)),
								$author$project$Ui$Form$Input$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 1, model.SD)),
								$author$project$Ui$Form$Input$errors(
								A2($author$project$Utils$Form$validationErrors, 1, model.SD))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8),
						$author$project$Ui$Form$Group$label('Slug'),
						$author$project$Ui$Form$Group$required(true)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(fields.abG),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Components$Partner$NewProduct$FormUpdated, $author$project$Components$Partner$NewProduct$Slug)),
								$author$project$Ui$Form$Input$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 0, model.SD)),
								$author$project$Ui$Form$Input$errors(
								A2($author$project$Utils$Form$validationErrors, 0, model.SD))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8),
						$author$project$Ui$Form$Group$label('Product Type'),
						$author$project$Ui$Form$Group$required(true)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Select$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Select$value(
								$elm$core$Maybe$Just(
									$author$project$Api$Common$Marketplace$Product$ProductType$toString(fields.Jo))),
								$author$project$Ui$Form$Select$onChange(
								A2($elm$core$Basics$composeL, $author$project$Components$Partner$NewProduct$FormUpdated, $author$project$Components$Partner$NewProduct$ProductType))
							]),
						A2(
							$elm$core$List$map,
							function (type_) {
								return A3(
									$author$project$Ui$Form$Select$option,
									_List_Nil,
									$elm$core$Maybe$Just(
										$author$project$Api$Common$Marketplace$Product$ProductType$toString(type_)),
									$author$project$Api$Common$Marketplace$Product$ProductType$toLabel(type_));
							},
							$author$project$Api$Common$Marketplace$Product$ProductType$all)),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted, $author$project$Ui$Element$mt2]),
						_List_fromArray(
							[
								$elm$html$Html$text('Integration partners sync data between systems, application partners embed partner-powered workflows directly inside Hint, and solutions partners offer strategic or commercial benefits without any technical integration. Learn more '),
								A3(
								$author$project$Ui$Link$externalHref,
								'https://developers.hint.com/docs/marketplace',
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('here')
									])),
								$elm$html$Html$text('.')
							]))
					])),
				(fields.Jo === 2) ? A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mt4, $author$project$Ui$Element$mb4]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Components$Partner$NewProduct$CtaFormMsg,
						$author$project$Components$Partner$ExternalCtaForm$view(model.i0))
					])) : $elm$html$Html$text(''),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8),
						$author$project$Ui$Form$Group$label('Summary')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Textarea$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Textarea$value(
								A2($elm$core$Maybe$withDefault, '', fields.Qr)),
								$author$project$Ui$Form$Textarea$onInput(
								A2($elm$core$Basics$composeL, $author$project$Components$Partner$NewProduct$FormUpdated, $author$project$Components$Partner$NewProduct$Description))
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mt2, $author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
						_List_fromArray(
							[
								$elm$html$Html$text('One sentence that describes your product without repeating the product name shown above.')
							]))
					]))
			]));
};
var $author$project$Pages$Partner$Products$New$view = function (model) {
	var loading = _Utils_eq(model.k9, $author$project$Api$Data$Loading);
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$autocomplete(false),
						$author$project$Ui$Form$noValidate(true),
						$author$project$Ui$Form$onSubmit($author$project$Pages$Partner$Products$New$Save)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('New Product')
											]))
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Pages$Partner$Products$New$FormMsg,
										$author$project$Components$Partner$NewProduct$view(model.SD))
									])),
								A2(
								$author$project$Ui$Panel$footer,
								_List_fromArray(
									[$author$project$Ui$Element$justifyCenter]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Partner__Dashboard__Top,
										_List_fromArray(
											[$author$project$Ui$Link$buttonSecondary]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cancel')
											])),
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Create new product'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$submit,
												$author$project$Ui$Button$loading(loading)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Create')
											]))
									]))
							]))
					]))
			]),
		ac9: 'New Product'
	};
};
var $author$project$Pages$Partner$Products$New$page = $author$project$Spa$Page$applicationPartner(
	{ah_: $author$project$Pages$Partner$Products$New$init, aiq: $author$project$Pages$Partner$Products$New$load, k8: $author$project$Pages$Partner$Products$New$save, alO: $author$project$Pages$Partner$Products$New$subscriptions, adT: $author$project$Pages$Partner$Products$New$update, amo: $author$project$Pages$Partner$Products$New$view});
var $author$project$Pages$Partner$Sandboxes$Top$GotSandboxPartners = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Partner$Sandboxes$Top$fetchSandboxPartnersParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{ajJ: model.e9, alA: model.k5});
	};
};
var $author$project$Api$Partner$Partner$All$Partner = $elm$core$Basics$identity;
var $author$project$Api$Partner$Partner$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$Partner$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$Sandbox$Partner$listDefaults = {ajJ: $author$project$Api$Pagination$init, alA: $author$project$Api$Sort$init};
var $author$project$Api$Partner$Sandbox$Partner$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Partner$Sandbox$Partner$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$Partner$Sandbox$Partner$sandboxesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['sandboxes', 'partners']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$Sandbox$Partner$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Partner$Partner$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Partner$Sandbox$Partner$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Partner$Sandbox$Partner$sandboxesPath)));
	});
var $author$project$Pages$Partner$Sandboxes$Top$fetchSandboxPartners = function (model) {
	return A3(
		$author$project$Api$Partner$Sandbox$Partner$list,
		model.Gv,
		$author$project$Pages$Partner$Sandboxes$Top$fetchSandboxPartnersParams(model),
		$author$project$Pages$Partner$Sandboxes$Top$GotSandboxPartners);
};
var $author$project$Pages$Partner$Sandboxes$Top$GotSandboxPractices = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Partner$Sandboxes$Top$fetchSandboxPracticesParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{ajJ: model.fa, alA: model.k6});
	};
};
var $author$project$Api$Partner$Practice$All$Practice = $elm$core$Basics$identity;
var $author$project$Api$Partner$Practice$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$Practice$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$Sandbox$Practice$listDefaults = {ajJ: $author$project$Api$Pagination$init, alA: $author$project$Api$Sort$init};
var $author$project$Api$Partner$Sandbox$Practice$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Partner$Sandbox$Practice$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$Partner$Sandbox$Practice$sandboxesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['sandboxes', 'practices']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$Sandbox$Practice$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Partner$Practice$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Partner$Sandbox$Practice$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Partner$Sandbox$Practice$sandboxesPath)));
	});
var $author$project$Pages$Partner$Sandboxes$Top$fetchSandboxPractices = function (model) {
	return A3(
		$author$project$Api$Partner$Sandbox$Practice$list,
		model.Gv,
		$author$project$Pages$Partner$Sandboxes$Top$fetchSandboxPracticesParams(model),
		$author$project$Pages$Partner$Sandboxes$Top$GotSandboxPractices);
};
var $author$project$Pages$Partner$Sandboxes$Top$init = F4(
	function (_v0, partner, shared, _v1) {
		var query = _v1.DE;
		var model = {
			ch: $elm$core$Maybe$Nothing,
			ci: $elm$core$Maybe$Nothing,
			Gv: shared.Gv,
			O$: $author$project$Api$Data$NotAsked,
			d4: $elm$core$Set$empty,
			Ij: $author$project$Shared$isHintAdmin(shared),
			YN: partner,
			e8: $author$project$Api$Data$Loading,
			e9: A2(
				$author$project$Api$Pagination$fromQuery,
				query,
				A2($author$project$Api$Pagination$withPrefix, 'sandbox_partners', $author$project$Api$Pagination$init)),
			k5: A3(
				$author$project$Api$Sort$withDefault,
				'name',
				1,
				A2(
					$author$project$Api$Sort$fromQuery,
					query,
					A2($author$project$Api$Sort$withPrefix, 'sandbox_partners', $author$project$Api$Sort$init))),
			pP: $author$project$Api$Data$Loading,
			fa: A2(
				$author$project$Api$Pagination$fromQuery,
				query,
				A2($author$project$Api$Pagination$withPrefix, 'sandbox_practices', $author$project$Api$Pagination$init)),
			k6: A3(
				$author$project$Api$Sort$withDefault,
				'name',
				1,
				A2(
					$author$project$Api$Sort$fromQuery,
					query,
					A2($author$project$Api$Sort$withPrefix, 'sandbox_practices', $author$project$Api$Sort$init)))
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Pages$Partner$Sandboxes$Top$fetchSandboxPartners(model),
						$author$project$Pages$Partner$Sandboxes$Top$fetchSandboxPractices(model)
					])));
	});
var $author$project$Pages$Partner$Sandboxes$Top$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					Ij: $author$project$Shared$isHintAdmin(shared)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Partner$Sandboxes$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Partner$Sandboxes$Top$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Partner$Sandboxes$Top$ClinicalAccountCreated = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$OutMsg$GoToDefaultStateAndReloadAction = {$: 3};
var $author$project$Pages$Partner$Sandboxes$Top$SandboxPartnerCreated = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Pages$Partner$Sandboxes$Top$SandboxPracticeCreated = F2(
	function (a, b) {
		return {$: 15, a: a, b: b};
	});
var $author$project$Api$Partner$Sandbox$Partner$create = F3(
	function (apiClient, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'partner',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.Bq))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$Partner$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Partner$Sandbox$Partner$sandboxesPath)));
	});
var $author$project$Api$Partner$Practice$One$Practice = 0;
var $author$project$Api$Partner$Practice$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Partner$Sandbox$Practice$create = F3(
	function (apiClient, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practice',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.Bq))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$Practice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Partner$Sandbox$Practice$sandboxesPath)));
	});
var $author$project$Api$Partner$Sandbox$Practice$sandboxePath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		$author$project$Api$Partner$Sandbox$Practice$sandboxesPath);
};
var $author$project$Api$Partner$Sandbox$Practice$createClinicalAccount = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['create_clinical_account']),
					$author$project$Api$Partner$Sandbox$Practice$sandboxePath(id))));
	});
var $author$project$Pages$Partner$Sandboxes$Top$updateUrl = function (model) {
	return $author$project$Ports$Navigation$replaceUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Partner__Sandboxes__Top)
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.fa),
				A2(
					$elm$core$List$append,
					$author$project$Api$Sort$toQuery(model.k6),
					A2(
						$elm$core$List$append,
						$author$project$Api$Pagination$toPageQuery(model.e9),
						$author$project$Api$Sort$toQuery(model.k5))))));
};
var $author$project$Pages$Partner$Sandboxes$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								e8: response,
								e9: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.e9)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{e8: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								pP: response,
								fa: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.fa)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{pP: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 2:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.e9);
				var newModel = _Utils_update(
					model,
					{e8: $author$project$Api$Data$Loading, e9: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Partner$Sandboxes$Top$fetchSandboxPartners(newModel),
								$author$project$Pages$Partner$Sandboxes$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 3:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.fa);
				var newModel = _Utils_update(
					model,
					{pP: $author$project$Api$Data$Loading, fa: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Partner$Sandboxes$Top$fetchSandboxPractices(newModel),
								$author$project$Pages$Partner$Sandboxes$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 4:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						e8: $author$project$Api$Data$Loading,
						k5: A2($author$project$Api$Sort$update, columnId, model.k5)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Partner$Sandboxes$Top$fetchSandboxPartners(newModel),
								$author$project$Pages$Partner$Sandboxes$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 5:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						pP: $author$project$Api$Data$Loading,
						k6: A2($author$project$Api$Sort$update, columnId, model.k6)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Partner$Sandboxes$Top$fetchSandboxPractices(newModel),
								$author$project$Pages$Partner$Sandboxes$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 6:
				var name = $author$project$Api$Partner$Partner$One$name(model.YN) + ' Sandbox';
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ch: $elm$core$Maybe$Just(
								_Utils_Tuple2(
									$elm$core$Maybe$Just(name),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 7:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ch: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 8:
				var _v3 = model.ch;
				if (!_v3.$) {
					var _v4 = _v3.a;
					var name = _v4.a;
					if (!name.$) {
						var name_ = name.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ch: $elm$core$Maybe$Just(
										_Utils_Tuple2(
											$elm$core$Maybe$Just(name_),
											$author$project$Api$Data$Loading))
								}),
							A3(
								$author$project$Api$Partner$Sandbox$Partner$create,
								model.Gv,
								{
									Bq: $elm$core$Maybe$Just(name_)
								},
								$author$project$Pages$Partner$Sandboxes$Top$SandboxPartnerCreated(name_)),
							_List_Nil);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var name = msg.a;
				var _v6 = model.ch;
				if (!_v6.$) {
					var _v7 = _v6.a;
					var request = _v7.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ch: $elm$core$Maybe$Just(
									_Utils_Tuple2(
										$author$project$Utils$String$toMaybe(name),
										request))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 10:
				var name = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ch: $elm$core$Maybe$Nothing, e8: $author$project$Api$Data$Loading}),
						$author$project$Pages$Partner$Sandboxes$Top$fetchSandboxPartners(model),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Sandbox added')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ch: $elm$core$Maybe$Just(
									_Utils_Tuple2(
										$elm$core$Maybe$Just(name),
										response))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 11:
				var name = $author$project$Api$Partner$Partner$One$name(model.YN) + ' Sandbox Practice';
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ci: $elm$core$Maybe$Just(
								_Utils_Tuple2(
									$elm$core$Maybe$Just(name),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 12:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ci: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 13:
				var _v9 = model.ci;
				if (!_v9.$) {
					var _v10 = _v9.a;
					var name = _v10.a;
					if (!name.$) {
						var name_ = name.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ci: $elm$core$Maybe$Just(
										_Utils_Tuple2(
											$elm$core$Maybe$Just(name_),
											$author$project$Api$Data$Loading))
								}),
							A3(
								$author$project$Api$Partner$Sandbox$Practice$create,
								model.Gv,
								{
									Bq: $elm$core$Maybe$Just(name_)
								},
								$author$project$Pages$Partner$Sandboxes$Top$SandboxPracticeCreated(name_)),
							_List_Nil);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 14:
				var name = msg.a;
				var _v12 = model.ci;
				if (!_v12.$) {
					var _v13 = _v12.a;
					var request = _v13.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ci: $elm$core$Maybe$Just(
									_Utils_Tuple2(
										$author$project$Utils$String$toMaybe(name),
										request))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 15:
				var name = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ci: $elm$core$Maybe$Nothing, pP: $author$project$Api$Data$Loading}),
						$author$project$Pages$Partner$Sandboxes$Top$fetchSandboxPractices(model),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Sandbox practice added')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ci: $elm$core$Maybe$Just(
									_Utils_Tuple2(
										$elm$core$Maybe$Just(name),
										response))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 16:
				var organizationId = msg.a;
				var postOrganizationSwitchedAction = _Utils_eq(
					$author$project$Api$Partner$Partner$One$sandboxOf(model.YN),
					$elm$core$Maybe$Nothing) ? $author$project$OutMsg$GoToDefaultStateAndReloadAction : $author$project$OutMsg$GoToDefaultStateAction;
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					_List_fromArray(
						[
							A3($author$project$OutMsg$SwitchToOrganization, organizationId, $elm$core$Maybe$Nothing, postOrganizationSwitchedAction)
						]));
			case 17:
				var id = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							d4: A2($elm$core$Set$insert, id, model.d4)
						}),
					A3(
						$author$project$Api$Partner$Sandbox$Practice$createClinicalAccount,
						model.Gv,
						id,
						$author$project$Pages$Partner$Sandboxes$Top$ClinicalAccountCreated(id)),
					_List_Nil);
			default:
				var id = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									d4: A2($elm$core$Set$remove, id, model.d4),
									pP: $author$project$Api$Data$Loading
								}),
							$author$project$Pages$Partner$Sandboxes$Top$fetchSandboxPractices(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Clinical account successfully created')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									d4: A2($elm$core$Set$remove, id, model.d4)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Partner$Sandboxes$Top$NewSandboxPartnerClosed = {$: 7};
var $author$project$Pages$Partner$Sandboxes$Top$NewSandboxPartnerNameUpdated = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Partner$Sandboxes$Top$SaveSandboxPartner = {$: 8};
var $author$project$Pages$Partner$Sandboxes$Top$viewAddSandboxPartnerModal = F2(
	function (name, request) {
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Pages$Partner$Sandboxes$Top$NewSandboxPartnerClosed,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('Add Sandbox')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Name'),
									$author$project$Ui$Form$Group$required(true),
									$author$project$Ui$Form$Group$labelSpanSm(4),
									$author$project$Ui$Form$Group$inputSpanSm(8)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(
											A2($elm$core$Maybe$withDefault, '', name)),
											$author$project$Ui$Form$Input$onInput($author$project$Pages$Partner$Sandboxes$Top$NewSandboxPartnerNameUpdated),
											$author$project$Ui$Form$Input$invalid(
											_Utils_eq(name, $elm$core$Maybe$Nothing)),
											$author$project$Ui$Form$Input$errors(
											_Utils_eq(name, $elm$core$Maybe$Nothing) ? _List_fromArray(
												['Name is required']) : _List_Nil)
										]))
								]))
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Cancel and close modal'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Pages$Partner$Sandboxes$Top$NewSandboxPartnerClosed)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Add Sandbox'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$onClick($author$project$Pages$Partner$Sandboxes$Top$SaveSandboxPartner),
									$author$project$Ui$Button$loading(
									_Utils_eq(request, $author$project$Api$Data$Loading))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Add Sandbox')
								]))
						]))
				]));
	});
var $author$project$Pages$Partner$Sandboxes$Top$NewSandboxPracticeClosed = {$: 12};
var $author$project$Pages$Partner$Sandboxes$Top$NewSandboxPracticeNameUpdated = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Partner$Sandboxes$Top$SaveSandboxPractice = {$: 13};
var $author$project$Pages$Partner$Sandboxes$Top$viewAddSandboxPracticeModal = F2(
	function (name, request) {
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Pages$Partner$Sandboxes$Top$NewSandboxPracticeClosed,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('Add Sandbox')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Name'),
									$author$project$Ui$Form$Group$required(true),
									$author$project$Ui$Form$Group$labelSpanSm(4),
									$author$project$Ui$Form$Group$inputSpanSm(8)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(
											A2($elm$core$Maybe$withDefault, '', name)),
											$author$project$Ui$Form$Input$onInput($author$project$Pages$Partner$Sandboxes$Top$NewSandboxPracticeNameUpdated),
											$author$project$Ui$Form$Input$invalid(
											_Utils_eq(name, $elm$core$Maybe$Nothing)),
											$author$project$Ui$Form$Input$errors(
											_Utils_eq(name, $elm$core$Maybe$Nothing) ? _List_fromArray(
												['Name is required']) : _List_Nil)
										]))
								]))
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Cancel and close modal'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Pages$Partner$Sandboxes$Top$NewSandboxPracticeClosed)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Add Sandbox'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$onClick($author$project$Pages$Partner$Sandboxes$Top$SaveSandboxPractice),
									$author$project$Ui$Button$loading(
									_Utils_eq(request, $author$project$Api$Data$Loading))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Add Sandbox')
								]))
						]))
				]));
	});
var $author$project$Pages$Partner$Sandboxes$Top$NewSandboxPartner = {$: 6};
var $author$project$Pages$Partner$Sandboxes$Top$SandboxPartnersPaginationMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Partner$Sandboxes$Top$SandboxPartnersSortTable = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Partner$Sandboxes$Top$sandboxPartnersColumns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'name', true, 'Name')
	]);
var $author$project$Ui$Table$Success = 0;
var $author$project$Pages$Partner$Sandboxes$Top$SwitchToSandbox = function (a) {
	return {$: 16, a: a};
};
var $author$project$Api$Partner$Partner$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Partner$Partner$Shared$id(shared);
};
var $author$project$Api$Partner$Partner$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Partner$Partner$Shared$name(shared);
};
var $author$project$Api$Partner$Partner$All$organizationId = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Partner$Partner$Shared$organizationId(shared);
};
var $author$project$Pages$Partner$Sandboxes$Top$viewSandboxPartner = F2(
	function (model, sandboxPartner) {
		var sandboxName = $author$project$Api$Partner$Partner$All$name(sandboxPartner);
		var isCurrentSandbox = _Utils_eq(
			$author$project$Api$Partner$Partner$All$id(sandboxPartner),
			$author$project$Api$Partner$Partner$One$id(model.YN));
		var rowOptions = isCurrentSandbox ? _List_fromArray(
			[
				$author$project$Ui$Table$styled(0)
			]) : _List_Nil;
		return A2(
			$author$project$Ui$Table$row,
			rowOptions,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(sandboxName)
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$textRight]),
					_List_fromArray(
						[
							isCurrentSandbox ? $author$project$Utils$Html$empty : A3(
							$author$project$Ui$Button$view,
							{mm: 'Switch' + sandboxName},
							_List_fromArray(
								[
									$author$project$Ui$Button$default,
									$author$project$Ui$Button$sm,
									$author$project$Ui$Button$onClick(
									$author$project$Pages$Partner$Sandboxes$Top$SwitchToSandbox(
										$author$project$Api$Partner$Partner$All$organizationId(sandboxPartner)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Switch')
								]))
						]))
				]));
	});
var $author$project$Pages$Partner$Sandboxes$Top$viewSandboxPartnersTable = function (model) {
	var _v0 = function () {
		var _v1 = model.e8;
		if (_v1.$ === 3) {
			var sandboxPartners_ = _v1.a;
			return _Utils_Tuple2(false, sandboxPartners_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var sandboxPartners = _v0.b;
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any sandbox partners')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$map,
					$author$project$Api$Column$view(
						A2($author$project$Api$Column$Sortable, model.k5, $author$project$Pages$Partner$Sandboxes$Top$SandboxPartnersSortTable)),
					$author$project$Pages$Partner$Sandboxes$Top$sandboxPartnersColumns),
					_List_fromArray(
					[
						A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
					])
				])),
		A2(
			$elm$core$List$map,
			$author$project$Pages$Partner$Sandboxes$Top$viewSandboxPartner(model),
			sandboxPartners),
		_List_Nil);
};
var $author$project$Pages$Partner$Sandboxes$Top$viewSandboxPartners = function (model) {
	var loading = function () {
		var _v2 = model.e8;
		if (_v2.$ === 3) {
			return false;
		} else {
			return true;
		}
	}();
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_fromArray(
					[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
				_List_fromArray(
					[
						$author$project$Ui$Panel$title(
						_List_fromArray(
							[
								$elm$html$Html$text('Sandbox Partners')
							])),
						function () {
						var _v0 = _Utils_Tuple2(
							$author$project$Api$Partner$Partner$One$sandboxOf(model.YN),
							$author$project$Api$Partner$Partner$One$sandboxEnabled(model.YN));
						if ((_v0.a.$ === 1) && _v0.b) {
							var _v1 = _v0.a;
							return A3(
								$author$project$Ui$Button$view,
								{mm: 'Add sandbox partner'},
								_List_fromArray(
									[
										$author$project$Ui$Button$default,
										$author$project$Ui$Button$onClick($author$project$Pages$Partner$Sandboxes$Top$NewSandboxPartner)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Add Sandbox Partner')
									]));
						} else {
							return $author$project$Utils$Html$empty;
						}
					}()
					])),
				$author$project$Pages$Partner$Sandboxes$Top$viewSandboxPartnersTable(model),
				A2(
				$author$project$Ui$Panel$footer,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Pages$Partner$Sandboxes$Top$SandboxPartnersPaginationMsg,
						A2(
							$author$project$Api$Pagination$view,
							_List_fromArray(
								[
									$author$project$Ui$Pagination$List$loading(loading)
								]),
							model.e9))
					]))
			]));
};
var $author$project$Pages$Partner$Sandboxes$Top$NewSandboxPractice = {$: 11};
var $author$project$Pages$Partner$Sandboxes$Top$SandboxPracticesPaginationMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Partner$Sandboxes$Top$SandboxPracticesSortTable = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Partner$Sandboxes$Top$sandboxPracticesColumns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'name', true, 'Name')
	]);
var $author$project$Pages$Partner$Sandboxes$Top$CreateClinicalAccount = function (a) {
	return {$: 17, a: a};
};
var $author$project$Api$Partner$Practice$All$hasClinicalAccount = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Partner$Practice$Shared$hasClinicalAccount(shared);
};
var $author$project$Api$Partner$Practice$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Partner$Practice$Shared$id(shared);
};
var $author$project$Api$Partner$Practice$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Partner$Practice$Shared$name(shared);
};
var $author$project$Api$Partner$Practice$Shared$organizationId = function (_v0) {
	var record = _v0.b;
	return record.ajD;
};
var $author$project$Api$Partner$Practice$All$organizationId = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Partner$Practice$Shared$organizationId(shared);
};
var $author$project$Pages$Partner$Sandboxes$Top$viewSandboxPractice = F2(
	function (model, sandboxPractice) {
		var sandboxName = $author$project$Api$Partner$Practice$All$name(sandboxPractice);
		var sandboxId = $author$project$Api$Partner$Practice$All$id(sandboxPractice);
		var loading = A2($elm$core$Set$member, sandboxId, model.d4);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(sandboxName)
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$textRight]),
					_List_fromArray(
						[
							($author$project$Api$Partner$Practice$All$hasClinicalAccount(sandboxPractice) || (!$author$project$Api$Partner$Partner$One$sandboxEnabled(model.YN))) ? $author$project$Utils$Html$empty : A3(
							$author$project$Ui$Button$view,
							{mm: 'Create Clinical Account'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$sm,
									$author$project$Ui$Button$loading(loading),
									$author$project$Ui$Button$onClick(
									$author$project$Pages$Partner$Sandboxes$Top$CreateClinicalAccount(sandboxId))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Create Clinical Account')
								])),
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Switch ' + sandboxName},
							_List_fromArray(
								[
									$author$project$Ui$Button$default,
									$author$project$Ui$Button$sm,
									$author$project$Ui$Button$loading(loading),
									$author$project$Ui$Button$onClick(
									$author$project$Pages$Partner$Sandboxes$Top$SwitchToSandbox(
										$author$project$Api$Partner$Practice$All$organizationId(sandboxPractice)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Switch')
								]))
						]))
				]));
	});
var $author$project$Pages$Partner$Sandboxes$Top$viewSandboxPracticesTable = function (model) {
	var _v0 = function () {
		var _v1 = model.pP;
		if (_v1.$ === 3) {
			var sandboxPractices_ = _v1.a;
			return _Utils_Tuple2(false, sandboxPractices_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var sandboxPractices = _v0.b;
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any sandbox practices')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$map,
					$author$project$Api$Column$view(
						A2($author$project$Api$Column$Sortable, model.k6, $author$project$Pages$Partner$Sandboxes$Top$SandboxPracticesSortTable)),
					$author$project$Pages$Partner$Sandboxes$Top$sandboxPracticesColumns),
					_List_fromArray(
					[
						A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
					])
				])),
		A2(
			$elm$core$List$map,
			$author$project$Pages$Partner$Sandboxes$Top$viewSandboxPractice(model),
			sandboxPractices),
		_List_Nil);
};
var $author$project$Pages$Partner$Sandboxes$Top$viewSandboxPractices = function (model) {
	var loading = function () {
		var _v2 = model.pP;
		if (_v2.$ === 3) {
			return false;
		} else {
			return true;
		}
	}();
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_fromArray(
					[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
				_List_fromArray(
					[
						$author$project$Ui$Panel$title(
						_List_fromArray(
							[
								$elm$html$Html$text('Sandbox Practices')
							])),
						function () {
						var _v0 = _Utils_Tuple2(
							$author$project$Api$Partner$Partner$One$sandboxOf(model.YN),
							$author$project$Api$Partner$Partner$One$sandboxEnabled(model.YN));
						if ((_v0.a.$ === 1) && _v0.b) {
							var _v1 = _v0.a;
							return A3(
								$author$project$Ui$Button$view,
								{mm: 'Add sandbox practice'},
								_List_fromArray(
									[
										$author$project$Ui$Button$default,
										$author$project$Ui$Button$onClick($author$project$Pages$Partner$Sandboxes$Top$NewSandboxPractice)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Add Sandbox Practice')
									]));
						} else {
							return $author$project$Utils$Html$empty;
						}
					}()
					])),
				$author$project$Pages$Partner$Sandboxes$Top$viewSandboxPracticesTable(model),
				A2(
				$author$project$Ui$Panel$footer,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Pages$Partner$Sandboxes$Top$SandboxPracticesPaginationMsg,
						A2(
							$author$project$Api$Pagination$view,
							_List_fromArray(
								[
									$author$project$Ui$Pagination$List$loading(loading)
								]),
							model.fa))
					]))
			]));
};
var $author$project$Pages$Partner$Sandboxes$Top$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				function () {
				var _v0 = model.ch;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var name = _v1.a;
					var request = _v1.b;
					return A2($author$project$Pages$Partner$Sandboxes$Top$viewAddSandboxPartnerModal, name, request);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v2 = model.ci;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var name = _v3.a;
					var request = _v3.b;
					return A2($author$project$Pages$Partner$Sandboxes$Top$viewAddSandboxPracticeModal, name, request);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(6)
							]),
						_List_fromArray(
							[
								$author$project$Pages$Partner$Sandboxes$Top$viewSandboxPartners(model)
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(6)
							]),
						_List_fromArray(
							[
								$author$project$Pages$Partner$Sandboxes$Top$viewSandboxPractices(model)
							]))
					]))
			]),
		ac9: 'Partner | Sandboxes'
	};
};
var $author$project$Pages$Partner$Sandboxes$Top$page = $author$project$Spa$Page$applicationPartner(
	{ah_: $author$project$Pages$Partner$Sandboxes$Top$init, aiq: $author$project$Pages$Partner$Sandboxes$Top$load, k8: $author$project$Pages$Partner$Sandboxes$Top$save, alO: $author$project$Pages$Partner$Sandboxes$Top$subscriptions, adT: $author$project$Pages$Partner$Sandboxes$Top$update, amo: $author$project$Pages$Partner$Sandboxes$Top$view});
var $author$project$Pages$Partner$Team$GotRoles = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Partner$Team$buildUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('q'),
			model.akl)
		]);
	return A2(
		$elm$url$Url$Builder$relative,
		_List_fromArray(
			[
				$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Partner__Team)
			]),
		A2(
			$elm$core$List$append,
			$author$project$Api$Pagination$toPageQuery(model.ajJ),
			A2(
				$elm$core$List$append,
				$author$project$Api$Sort$toQuery(model.alA),
				A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams))));
};
var $author$project$Pages$Partner$Team$GotTeamMembers = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Partner$PartnerUser$All$PartnerUser = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Partner$PartnerUser$Shared$PartnerUser = $elm$core$Basics$identity;
var $author$project$Api$Partner$PartnerUser$Shared$Record = F8(
	function (id, email, role, notificationsEnabled, invitationPending, isOwner, isDestroyable, user) {
		return {Rj: email, ahP: id, Ui: invitationPending, UN: isDestroyable, U0: isOwner, X$: notificationsEnabled, ak3: role, ad0: user};
	});
var $author$project$Api$Partner$User$One$User = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Partner$User$One$Record = function (mfaStatus) {
	return {W6: mfaStatus};
};
var $author$project$Api$Partner$User$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'mfa_status',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Partner$User$One$Record));
var $author$project$Api$Partner$User$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$User$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Partner$User$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Partner$User$One$User)));
var $author$project$Api$Partner$PartnerUser$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'user',
	$elm$json$Json$Decode$nullable($author$project$Api$Partner$User$One$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'is_destroyable',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'is_owner',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'invitation_pending',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'notifications_enabled',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'role',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'email',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Api$Partner$PartnerUser$Shared$Record)))))))));
var $author$project$Api$Partner$PartnerUser$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$PartnerUser$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$PartnerUser$All$Record = function (invitationUrl) {
	return {Uj: invitationUrl};
};
var $author$project$Api$Partner$PartnerUser$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'invitation_url',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$json$Json$Decode$succeed($author$project$Api$Partner$PartnerUser$All$Record));
var $author$project$Api$Partner$PartnerUser$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$PartnerUser$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Partner$PartnerUser$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Partner$PartnerUser$All$PartnerUser)));
var $author$project$Api$Partner$TeamMember$listOptionalsDefaults = {ajJ: $author$project$Api$Pagination$init, akl: $elm$core$Maybe$Nothing, alA: $author$project$Api$Sort$init};
var $author$project$Api$Partner$TeamMember$listOptionalsToParams = function (optionals) {
	var options = optionals($author$project$Api$Partner$TeamMember$listOptionalsDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.akl;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$Partner$TeamMember$teamMembersPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['team_members']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$TeamMember$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Partner$PartnerUser$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Partner$TeamMember$listOptionalsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Partner$TeamMember$teamMembersPath)));
	});
var $author$project$Pages$Partner$Team$fetchTeamMembers = function (model) {
	return A3(
		$author$project$Api$Partner$TeamMember$list,
		model.Gv,
		function (d) {
			return _Utils_update(
				d,
				{ajJ: model.ajJ, akl: model.akl, alA: model.alA});
		},
		$author$project$Pages$Partner$Team$GotTeamMembers);
};
var $author$project$Api$Partner$Role$rolesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['roles']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$Role$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Common$Role$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Partner$Role$rolesPath));
	});
var $author$project$Pages$Partner$Team$init = F4(
	function (session, partner, shared, _v0) {
		var query = _v0.DE;
		var q = A2($elm$core$Dict$get, 'q', query);
		var model = {
			Gv: shared.Gv,
			Hd: $author$project$Api$Platform$Session$One$user(session),
			nf: $elm$core$Maybe$Nothing,
			eo: $elm$core$Set$empty,
			jq: $elm$core$Maybe$Nothing,
			eC: false,
			Ij: $author$project$Shared$isHintAdmin(shared),
			eI: $elm$core$Set$empty,
			ajG: shared.ahq.ajG,
			ajJ: $author$project$Api$Pagination$initFromQuery(query),
			YN: partner,
			akl: q,
			ak4: $author$project$Api$Data$Loading,
			up: $author$project$Ui$SearchInput$init(q),
			aa4: session,
			alA: A3(
				$author$project$Api$Sort$withDefault,
				'user_first_name',
				0,
				$author$project$Api$Sort$initFromQuery(query)),
			I: $elm$core$Maybe$Nothing,
			fm: $author$project$Api$Data$Loading,
			vb: A2(
				$author$project$Components$Admin$ToogleOrganizationMfa$init,
				session,
				$author$project$Components$Admin$ToogleOrganizationMfa$Partner(partner))
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Pages$Partner$Team$fetchTeamMembers(model),
						A2($author$project$Api$Partner$Role$list, shared.Gv, $author$project$Pages$Partner$Team$GotRoles),
						A2($elm$core$Basics$composeR, $author$project$Pages$Partner$Team$buildUrl, $author$project$Ports$Navigation$replaceUrl)(model)
					])));
	});
var $author$project$Pages$Partner$Team$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Partner$Team$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Partner$Team$CancelTeamMemberEdit = {$: 4};
var $author$project$Pages$Partner$Team$DeleteConfirmClosed = F2(
	function (a, b) {
		return {$: 15, a: a, b: b};
	});
var $author$project$Pages$Partner$Team$DisableMfaConfirmClosed = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$Api$Partner$PartnerUser$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Partner$PartnerUser$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$PartnerUser$Shared$id(shared);
};
var $author$project$Pages$Partner$Team$subscriptions = function (_v0) {
	var teamMember = _v0.I;
	var deletingTeamMember = _v0.nf;
	var disablingMfaTeamMember = _v0.jq;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Partner$Team$CancelTeamMemberEdit)),
					teamMember)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Partner$Team$DeleteConfirmClosed),
						$author$project$Api$Partner$PartnerUser$All$id),
					deletingTeamMember)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Partner$Team$DisableMfaConfirmClosed),
					disablingMfaTeamMember))
			]));
};
var $author$project$Pages$Partner$Team$GotInvitation = F3(
	function (a, b, c) {
		return {$: 22, a: a, b: b, c: c};
	});
var $author$project$Pages$Partner$Team$InviteLinkMsg = function (a) {
	return {$: 21, a: a};
};
var $author$project$Pages$Partner$Team$MfaStatus = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Partner$Team$SearchInputMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Partner$Team$TeamMemberDeleted = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Pages$Partner$Team$TeamMemberMfaDisabled = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$Partner$Team$ToogleOrganizationMfa = function (a) {
	return {$: 23, a: a};
};
var $author$project$Api$Partner$TeamMember$teamMemberPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Partner$TeamMember$teamMembersPath);
};
var $author$project$Api$Partner$TeamMember$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Partner$TeamMember$teamMemberPath(id_)));
	});
var $author$project$Api$Partner$TeamMember$disableMfa = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['mfa']),
					$author$project$Api$Partner$TeamMember$teamMemberPath(id_))));
	});
var $author$project$Api$Partner$PartnerUser$Shared$email = function (_v0) {
	var record = _v0;
	return record.Rj;
};
var $author$project$Api$Partner$PartnerUser$All$email = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$PartnerUser$Shared$email(shared);
};
var $author$project$Api$Partner$User$One$mfaStatus = function (_v0) {
	var record = _v0.b;
	return record.W6;
};
var $author$project$Api$Partner$PartnerUser$Shared$user = function (_v0) {
	var record = _v0;
	return record.ad0;
};
var $author$project$Api$Partner$PartnerUser$All$user = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$PartnerUser$Shared$user(shared);
};
var $author$project$Pages$Partner$Team$mfaStatus = function (teamMember) {
	var _v0 = A2($elm$core$Maybe$andThen, $author$project$Api$Partner$PartnerUser$All$user, teamMember);
	if (!_v0.$) {
		var user = _v0.a;
		return $author$project$Api$Partner$User$One$mfaStatus(user);
	} else {
		return 'invite pending';
	}
};
var $author$project$Api$Partner$PartnerUser$Shared$notificationsEnabled = function (_v0) {
	var record = _v0;
	return record.X$;
};
var $author$project$Api$Partner$PartnerUser$All$notificationsEnabled = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$PartnerUser$Shared$notificationsEnabled(shared);
};
var $author$project$Api$Partner$PartnerUser$Shared$role = function (_v0) {
	var record = _v0;
	return record.ak3;
};
var $author$project$Api$Partner$PartnerUser$All$role = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$PartnerUser$Shared$role(shared);
};
var $author$project$Pages$Partner$Team$formFieldsFromTeamMember = function (teamMember) {
	return {
		Mz: '',
		Rj: $author$project$Api$Partner$PartnerUser$All$email(teamMember),
		n2: false,
		W6: $author$project$Pages$Partner$Team$mfaStatus(
			$elm$core$Maybe$Just(teamMember)),
		X$: $author$project$Api$Partner$PartnerUser$All$notificationsEnabled(teamMember),
		ak3: $author$project$Api$Partner$PartnerUser$All$role(teamMember)
	};
};
var $author$project$Pages$Partner$Team$formFieldsInit = function (origin) {
	return {
		Mz: origin + '/join/',
		Rj: '',
		n2: true,
		W6: $author$project$Pages$Partner$Team$mfaStatus($elm$core$Maybe$Nothing),
		X$: true,
		ak3: ''
	};
};
var $author$project$Pages$Partner$Team$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{Rj: string});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{ak3: string});
			case 2:
				var bool = field.a;
				return _Utils_update(
					fields,
					{X$: bool});
			case 3:
				var string = field.a;
				return _Utils_update(
					fields,
					{W6: string});
			default:
				var bool = field.a;
				return _Utils_update(
					fields,
					{n2: bool});
		}
	});
var $author$project$Pages$Partner$Team$EmailValidation = 0;
var $author$project$Pages$Partner$Team$RoleValidation = 1;
var $author$project$Pages$Partner$Team$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A3(
			$author$project$Utils$Validate$ifInvalidEmail,
			{aeT: false},
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.Rj;
				},
				$elm$core$Maybe$Just),
			_Utils_Tuple2(0, 'Please enter a valid email.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.ak3;
			},
			_Utils_Tuple2(1, 'Please pick a role.'))
		]));
var $author$project$Api$Partner$PartnerUser$One$PartnerUser = 0;
var $author$project$Api$Partner$PartnerUser$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Partner$TeamMember$invite = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$PartnerUser$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['invite']),
					$author$project$Api$Partner$TeamMember$teamMemberPath(id_))));
	});
var $author$project$Api$Partner$TeamMember$AutoAccept = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Partner$TeamMember$BaseUrl = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Partner$TeamMember$Email = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Partner$TeamMember$Invite = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Partner$TeamMember$NotificationsEnabled = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Partner$TeamMember$Role = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Partner$Team$TeamMemberCreated = function (a) {
	return {$: 11, a: a};
};
var $author$project$Api$Partner$TeamMember$encodePermittedFields = function (permittedFields) {
	var _v0 = A3(
		$elm$core$List$foldl,
		F2(
			function (field, _v1) {
				var tm = _v1.a;
				var tl = _v1.b;
				switch (field.$) {
					case 0:
						var email = field.a;
						return _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'email',
									$elm$json$Json$Encode$string(email)),
								tm),
							tl);
					case 1:
						var role = field.a;
						return _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'role',
									$elm$json$Json$Encode$string(role)),
								tm),
							tl);
					case 2:
						var enabled = field.a;
						return _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'notifications_enabled',
									$elm$json$Json$Encode$bool(enabled)),
								tm),
							tl);
					case 3:
						var url = field.a;
						return _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'base_url',
									$elm$json$Json$Encode$string(url)),
								tm),
							tl);
					case 4:
						var inv = field.a;
						return _Utils_Tuple2(
							tm,
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'invite',
									$elm$json$Json$Encode$bool(inv)),
								tl));
					default:
						var autoAccept = field.a;
						return _Utils_Tuple2(
							tm,
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'auto_accept',
									$elm$json$Json$Encode$bool(autoAccept)),
								tl));
				}
			}),
		_Utils_Tuple2(_List_Nil, _List_Nil),
		permittedFields);
	var teamMemberFields = _v0.a;
	var topLevelFields = _v0.b;
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				'team_member',
				$elm$json$Json$Encode$object(teamMemberFields)),
			topLevelFields));
};
var $author$project$Api$Partner$TeamMember$create = F3(
	function (apiClient, permittedFields, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$PartnerUser$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Partner$TeamMember$encodePermittedFields(permittedFields),
				$author$project$Api$Data$requestTo($author$project$Api$Partner$TeamMember$teamMembersPath)));
	});
var $author$project$Pages$Partner$Team$createTeamMember = F3(
	function (apiClient, isAddExistingUser, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var baseFields = _List_fromArray(
			[
				$author$project$Api$Partner$TeamMember$Email(fields.Rj),
				$author$project$Api$Partner$TeamMember$Role(fields.ak3),
				$author$project$Api$Partner$TeamMember$NotificationsEnabled(fields.X$)
			]);
		var permittedFields = isAddExistingUser ? _Utils_ap(
			baseFields,
			_List_fromArray(
				[
					$author$project$Api$Partner$TeamMember$AutoAccept(true)
				])) : _Utils_ap(
			baseFields,
			_List_fromArray(
				[
					$author$project$Api$Partner$TeamMember$BaseUrl(fields.Mz),
					$author$project$Api$Partner$TeamMember$Invite(fields.n2)
				]));
		return A3($author$project$Api$Partner$TeamMember$create, apiClient, permittedFields, $author$project$Pages$Partner$Team$TeamMemberCreated);
	});
var $author$project$Pages$Partner$Team$TeamMemberUpdated = function (a) {
	return {$: 12, a: a};
};
var $author$project$Api$Partner$TeamMember$update = F4(
	function (apiClient, id_, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'team_member',
					$elm$json$Json$Encode$object(
						$elm$core$List$concat(
							_List_fromArray(
								[
									A3($author$project$Utils$Encode$optional, 'role', $elm$json$Json$Encode$string, fields.ak3),
									A3($author$project$Utils$Encode$optional, 'notifications_enabled', $elm$json$Json$Encode$bool, fields.X$)
								]))))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Partner$PartnerUser$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Partner$TeamMember$teamMemberPath(id_))));
	});
var $author$project$Pages$Partner$Team$updateTeamMember = F3(
	function (apiClient, id, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4(
			$author$project$Api$Partner$TeamMember$update,
			apiClient,
			id,
			{
				X$: $elm$core$Maybe$Just(fields.X$),
				ak3: $elm$core$Maybe$Just(fields.ak3)
			},
			$author$project$Pages$Partner$Team$TeamMemberUpdated);
	});
var $author$project$Pages$Partner$Team$saveTeamMember = F4(
	function (apiClient, isAddExistingUser, maybeId, formFields) {
		if (!maybeId.$) {
			var id = maybeId.a;
			return A3($author$project$Pages$Partner$Team$updateTeamMember, apiClient, id, formFields);
		} else {
			return A3($author$project$Pages$Partner$Team$createTeamMember, apiClient, isAddExistingUser, formFields);
		}
	});
var $author$project$Pages$Partner$Team$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ak4: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							eC: false,
							I: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init(
										$author$project$Pages$Partner$Team$formFieldsInit(model.ajG)),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							eC: true,
							I: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init(
										$author$project$Pages$Partner$Team$formFieldsInit(model.ajG)),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 10:
				var field = msg.a;
				var _v1 = model.I;
				if (!_v1.$) {
					var _v2 = _v1.a;
					var teamMember = _v2.a;
					var form = _v2.b;
					var request = _v2.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Partner$Team$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								I: $elm$core$Maybe$Just(
									_Utils_Tuple3(teamMember, newForm, request))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var form = msg.a;
				var teamMember = msg.b;
				var id = msg.c;
				var _v3 = A2($author$project$Utils$Form$validate, $author$project$Pages$Partner$Team$formFieldsValidator, form);
				if (!_v3.$) {
					var _v4 = _v3.a;
					var newForm = _v4.a;
					var validFormFields = _v4.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								I: $elm$core$Maybe$Just(
									_Utils_Tuple3(teamMember, newForm, $author$project$Api$Data$Loading))
							}),
						A4($author$project$Pages$Partner$Team$saveTeamMember, model.Gv, model.eC, id, validFormFields),
						_List_Nil);
				} else {
					var newForm = _v3.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								I: $elm$core$Maybe$Just(
									_Utils_Tuple3(teamMember, newForm, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 3:
				var teamMember = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							eC: false,
							I: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(teamMember),
									$author$project$Utils$Form$init(
										$author$project$Pages$Partner$Team$formFieldsFromTeamMember(teamMember)),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{eC: false, I: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ),
								fm: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{fm: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 6:
				var subMsg = msg.a;
				var _v6 = A2($author$project$Ui$SearchInput$update, subMsg, model.up);
				var searchInput = _v6.a;
				var searchInputCmd = _v6.b;
				var searchInputEvent = _v6.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.akl;
					}
				}();
				var _v7 = function () {
					if (_Utils_eq(q, model.akl)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								ajJ: $author$project$Api$Pagination$reset(model.ajJ),
								akl: q,
								fm: $author$project$Api$Data$Loading
							});
						return _Utils_Tuple2(
							qModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Partner$Team$fetchTeamMembers(qModel),
										A2($elm$core$Basics$composeR, $author$project$Pages$Partner$Team$buildUrl, $author$project$Ports$Navigation$pushUrl)(qModel)
									])));
					}
				}();
				var newModel = _v7.a;
				var cmd = _v7.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{up: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Team$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
			case 7:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{ajJ: pagination, fm: $author$project$Api$Data$Loading});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Partner$Team$fetchTeamMembers(newModel),
								A2($elm$core$Basics$composeR, $author$project$Pages$Partner$Team$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 8:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						alA: A2($author$project$Api$Sort$update, columnId, model.alA),
						fm: $author$project$Api$Data$Loading
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Partner$Team$fetchTeamMembers(newModel),
								A2($elm$core$Basics$composeR, $author$project$Pages$Partner$Team$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 11:
				var response = msg.a;
				var _v9 = model.I;
				if (!_v9.$) {
					var _v10 = _v9.a;
					var teamMember = _v10.a;
					var form = _v10.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{eC: false, I: $elm$core$Maybe$Nothing}),
							$author$project$Pages$Partner$Team$fetchTeamMembers(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Team member successfully added')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									I: $elm$core$Maybe$Just(
										_Utils_Tuple3(teamMember, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 12:
				var response = msg.a;
				var _v12 = model.I;
				if (!_v12.$) {
					var _v13 = _v12.a;
					var id = _v13.a;
					var form = _v13.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{I: $elm$core$Maybe$Nothing}),
							$author$project$Pages$Partner$Team$fetchTeamMembers(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Team member successfully updated')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									I: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 13:
				var id = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									eo: A2($elm$core$Set$remove, id, model.eo),
									fm: $author$project$Api$Data$Loading
								}),
							$author$project$Pages$Partner$Team$fetchTeamMembers(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Team member successfully removed')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									eo: A2($elm$core$Set$remove, id, model.eo)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 14:
				var teamMember = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							nf: $elm$core$Maybe$Just(teamMember)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 15:
				var id = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							nf: $elm$core$Maybe$Nothing,
							eo: A2($elm$core$Set$insert, id, model.eo)
						}),
					A3(
						$author$project$Api$Partner$TeamMember$delete,
						model.Gv,
						id,
						$author$project$Pages$Partner$Team$TeamMemberDeleted(id)),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{nf: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 16:
				var id = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							jq: $elm$core$Maybe$Just(id)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 17:
				var id = msg.a;
				var confirmed = msg.b;
				var _v16 = model.I;
				if (!_v16.$) {
					var _v17 = _v16.a;
					var teamMember = _v17.a;
					var form = _v17.b;
					return confirmed ? _Utils_Tuple3(
						_Utils_update(
							model,
							{
								jq: $elm$core$Maybe$Nothing,
								I: $elm$core$Maybe$Just(
									_Utils_Tuple3(teamMember, form, $author$project$Api$Data$Loading))
							}),
						A3($author$project$Api$Partner$TeamMember$disableMfa, model.Gv, id, $author$project$Pages$Partner$Team$TeamMemberMfaDisabled),
						_List_Nil) : _Utils_Tuple3(
						_Utils_update(
							model,
							{jq: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 18:
				var response = msg.a;
				var _v18 = model.I;
				if (!_v18.$) {
					var _v19 = _v18.a;
					var teamMember = _v19.a;
					var form = _v19.b;
					switch (response.$) {
						case 3:
							var newForm = A3(
								$author$project$Utils$Form$update,
								$author$project$Pages$Partner$Team$formFieldsUpdate,
								$author$project$Pages$Partner$Team$MfaStatus('inactive'),
								form);
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										I: $elm$core$Maybe$Just(
											_Utils_Tuple3(teamMember, newForm, $author$project$Api$Data$NotAsked)),
										fm: $author$project$Api$Data$Loading
									}),
								$author$project$Pages$Partner$Team$fetchTeamMembers(model),
								_List_fromArray(
									[
										A2($author$project$OutMsg$ShowToast, 3, 'Team member mfa successfully disabled')
									]));
						case 2:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										I: $elm$core$Maybe$Just(
											_Utils_Tuple3(teamMember, form, $author$project$Api$Data$NotAsked))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$OutMsg$handleErrorResponse(response));
						default:
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 19:
				var teamMember = msg.a;
				return _Utils_Tuple3(
					model,
					A3(
						$author$project$Api$Partner$TeamMember$invite,
						model.Gv,
						$author$project$Api$Partner$PartnerUser$All$id(teamMember),
						A2(
							$author$project$Pages$Partner$Team$GotInvitation,
							$author$project$Api$Partner$PartnerUser$All$email(teamMember),
							false)),
					_List_Nil);
			case 20:
				var teamMember = msg.a;
				return _Utils_Tuple3(
					model,
					A3(
						$author$project$Api$Partner$TeamMember$invite,
						model.Gv,
						$author$project$Api$Partner$PartnerUser$All$id(teamMember),
						A2(
							$author$project$Pages$Partner$Team$GotInvitation,
							$author$project$Api$Partner$PartnerUser$All$email(teamMember),
							true)),
					_List_Nil);
			case 22:
				var email = msg.a;
				var isReinvite = msg.b;
				var response = msg.c;
				if (response.$ === 3) {
					var prefix = isReinvite ? 'A new' : 'An';
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{fm: $author$project$Api$Data$Loading}),
						$author$project$Pages$Partner$Team$fetchTeamMembers(model),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, prefix + (' invitation is being sent to ' + email))
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 21:
				var subMsg = msg.a;
				var _v22 = $author$project$Components$InviteLink$update(subMsg);
				var inviteLinkCmd = _v22.a;
				var inviteLinkOutMsg = _v22.b;
				return _Utils_Tuple3(
					model,
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Team$InviteLinkMsg, inviteLinkCmd),
					inviteLinkOutMsg);
			default:
				var subMsg = msg.a;
				var toogleOrganizationMfaResult = A3($author$project$Components$Admin$ToogleOrganizationMfa$update, model.Gv, subMsg, model.vb);
				var newModel = function () {
					var _v23 = toogleOrganizationMfaResult.agZ;
					switch (_v23.$) {
						case 0:
							return model;
						case 1:
							return model;
						default:
							var partner = _v23.a;
							return _Utils_update(
								model,
								{YN: partner});
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{vb: toogleOrganizationMfaResult.aiO}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Team$ToogleOrganizationMfa, toogleOrganizationMfaResult.GZ),
					toogleOrganizationMfaResult.aR);
		}
	});
var $author$project$Pages$Partner$Team$AddExistingMember = {$: 2};
var $author$project$Pages$Partner$Team$NewTeamMember = {$: 1};
var $author$project$Pages$Partner$Team$PaginationMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Partner$Team$SortTable = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Partner$Team$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'user_first_name', true, 'Name'),
		A3($author$project$Api$Column$init, 'email', false, 'Email'),
		A3($author$project$Api$Column$init, 'role', true, 'Role'),
		A3($author$project$Api$Column$init, 'notifications', false, 'Notifications'),
		A3($author$project$Api$Column$init, 'mfa', false, 'MFA')
	]);
var $author$project$Pages$Partner$Team$EditTeamMember = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Partner$Team$InviteTeamMember = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$Partner$Team$OpenDeleteConfirm = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$InviteLink$PartnerUser = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Partner$Team$ReInviteTeamMember = function (a) {
	return {$: 20, a: a};
};
var $author$project$Api$Partner$PartnerUser$Shared$isDestroyable = function (_v0) {
	var record = _v0;
	return record.UN;
};
var $author$project$Api$Partner$PartnerUser$All$isDestroyable = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$PartnerUser$Shared$isDestroyable(shared);
};
var $author$project$Api$Partner$PartnerUser$Shared$isOwner = function (_v0) {
	var record = _v0;
	return record.U0;
};
var $author$project$Api$Partner$PartnerUser$All$isOwner = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$PartnerUser$Shared$isOwner(shared);
};
var $author$project$Api$Partner$User$Shared$isAdmin = function (_v0) {
	var record = _v0;
	return record.Uy;
};
var $author$project$Api$Partner$User$One$isAdmin = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$User$Shared$isAdmin(shared);
};
var $author$project$Api$Partner$PartnerUser$All$isHinter = function (_v0) {
	var shared = _v0.a;
	return A2(
		$elm$core$String$contains,
		'@hint.com',
		$author$project$Api$Partner$PartnerUser$Shared$email(shared));
};
var $author$project$Api$Partner$PartnerUser$All$isSuperAdmin = function (partnerUser) {
	var _v0 = $author$project$Api$Partner$PartnerUser$All$user(partnerUser);
	if (_v0.$ === 1) {
		return false;
	} else {
		var user_ = _v0.a;
		return $author$project$Api$Partner$PartnerUser$All$isHinter(partnerUser) && $author$project$Api$Partner$User$One$isAdmin(user_);
	}
};
var $author$project$Api$Partner$User$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$User$Shared$name(shared);
};
var $author$project$Pages$Partner$Team$viewTeamMember = F5(
	function (currentUser, deletingTeamMembers, makingAdminTeamMembers, currentUserIsHintAdmin, teamMember) {
		var notificationsStatus = $author$project$Api$Partner$PartnerUser$All$notificationsEnabled(teamMember) ? 'enabled' : 'disabled';
		var memberIsOwner = $author$project$Api$Partner$PartnerUser$All$isOwner(teamMember);
		var isCurrentUser = _Utils_eq(
			$author$project$Api$Partner$PartnerUser$All$email(teamMember),
			$author$project$Api$Platform$User$Shared$email(currentUser));
		var rowOptions = isCurrentUser ? _List_fromArray(
			[
				$author$project$Ui$Table$styled(1)
			]) : _List_Nil;
		var id = $author$project$Api$Partner$PartnerUser$All$id(teamMember);
		var loading = A2($elm$core$Set$member, id, deletingTeamMembers) || A2($elm$core$Set$member, id, makingAdminTeamMembers);
		return A2(
			$author$project$Ui$Table$row,
			rowOptions,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[
							$author$project$Ui$Table$minWidth('11em')
						]),
					function () {
						var _v0 = $author$project$Api$Partner$PartnerUser$All$user(teamMember);
						if (!_v0.$) {
							var user = _v0.a;
							var memberIsHintAdmin = $author$project$Api$Partner$PartnerUser$All$isSuperAdmin(teamMember);
							var isOwnerOrAdminLabel = function () {
								var _v1 = _Utils_Tuple3(memberIsOwner, memberIsHintAdmin, currentUserIsHintAdmin);
								if (_v1.a) {
									if (_v1.b) {
										if (_v1.c) {
											return $elm$html$Html$text(' (owner | admin)');
										} else {
											return $elm$html$Html$text(' (owner)');
										}
									} else {
										return $elm$html$Html$text(' (owner)');
									}
								} else {
									if (_v1.b && _v1.c) {
										return $elm$html$Html$text(' (admin)');
									} else {
										return $author$project$Utils$Html$empty;
									}
								}
							}();
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Partner$User$One$name(user))
										])),
									isOwnerOrAdminLabel
								]);
						} else {
							var isOwnerLabel = memberIsOwner ? $elm$html$Html$text(' (owner)') : $author$project$Utils$Html$empty;
							return $author$project$Api$Partner$PartnerUser$All$invitationPending(teamMember) ? _List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$em,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Invitation Pending'),
											isOwnerLabel
										])),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{mm: 'Resend invite email'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$sm,
													$author$project$Ui$Button$onClick(
													$author$project$Pages$Partner$Team$ReInviteTeamMember(teamMember)),
													$author$project$Ui$Button$icon($author$project$Ui$Icon$repeat)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Resend')
												])),
											A2(
											$elm$html$Html$map,
											$author$project$Pages$Partner$Team$InviteLinkMsg,
											$author$project$Components$InviteLink$view(
												$author$project$Components$InviteLink$PartnerUser(teamMember)))
										]))
								]) : _List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$em,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Not Invited'),
											isOwnerLabel
										])),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{mm: 'Send invite email'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick(
													$author$project$Pages$Partner$Team$InviteTeamMember(teamMember)),
													$author$project$Ui$Button$icon($author$project$Ui$Icon$send),
													$author$project$Ui$Button$sm
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Send Invite')
												])),
											A2(
											$elm$html$Html$map,
											$author$project$Pages$Partner$Team$InviteLinkMsg,
											$author$project$Components$InviteLink$view(
												$author$project$Components$InviteLink$PartnerUser(teamMember)))
										]))
								]);
						}
					}()),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Partner$PartnerUser$All$email(teamMember))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Formatters$String$titleize(
								$author$project$Formatters$String$humanize(
									$author$project$Api$Partner$PartnerUser$All$role(teamMember))))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Ui$Badge$fromString, _List_Nil, notificationsStatus)
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Badge$fromString,
							_List_Nil,
							$author$project$Pages$Partner$Team$mfaStatus(
								$elm$core$Maybe$Just(teamMember)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Edit team member'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$disabled(
											loading || (memberIsOwner && (!$author$project$Api$Platform$User$Shared$isAdmin(currentUser)))),
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Partner$Team$EditTeamMember(teamMember)),
											$author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit')
										])),
									($author$project$Api$Partner$PartnerUser$All$isDestroyable(teamMember) && (!isCurrentUser)) ? A3(
									$author$project$Ui$Button$view,
									{mm: 'Delete team member'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$loading(loading),
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Partner$Team$OpenDeleteConfirm(teamMember)),
											$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Delete')
										])) : $author$project$Utils$Html$empty
								]))
						]))
				]));
	});
var $author$project$Pages$Partner$Team$viewPanelBody = function (model) {
	var _v0 = function () {
		var _v1 = model.fm;
		if (_v1.$ === 3) {
			var teamMembers_ = _v1.a;
			return _Utils_Tuple2(false, teamMembers_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var teamMembers = _v0.b;
	return _List_fromArray(
		[
			$author$project$Ui$Typography$headingSm(
			_List_fromArray(
				[
					$elm$html$Html$text('Security')
				])),
			A2(
			$elm$html$Html$map,
			$author$project$Pages$Partner$Team$ToogleOrganizationMfa,
			$author$project$Components$Admin$ToogleOrganizationMfa$view(model.vb)),
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mb2]),
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Members')
						]))
				])),
			A2(
			$author$project$Ui$Grid$row,
			_List_fromArray(
				[$author$project$Ui$Grid$mb2]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$span(12)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Pages$Partner$Team$SearchInputMsg,
									A2($author$project$Ui$SearchInput$view, _List_Nil, model.up))
								]))
						]))
				])),
			A4(
			$author$project$Ui$Table$view,
			_List_fromArray(
				[
					$author$project$Ui$Table$verticalCentered,
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('There are no team members.')
						])),
					$author$project$Ui$Table$loading(loading)
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						A2(
						$elm$core$List$map,
						$author$project$Api$Column$view(
							A2($author$project$Api$Column$Sortable, model.alA, $author$project$Pages$Partner$Team$SortTable)),
						$author$project$Pages$Partner$Team$columns),
						_List_fromArray(
						[
							A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
						])
					])),
			A2(
				$elm$core$List$map,
				A4($author$project$Pages$Partner$Team$viewTeamMember, model.Hd, model.eo, model.eI, model.Ij),
				teamMembers),
			_List_Nil)
		]);
};
var $author$project$Pages$Partner$Team$Email = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Partner$Team$FormUpdated = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Partner$Team$Invite = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Partner$Team$NotificationsEnabled = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Partner$Team$OpenDisableMfaConfirm = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Partner$Team$Role = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Partner$Team$SaveTeamMember = F3(
	function (a, b, c) {
		return {$: 9, a: a, b: b, c: c};
	});
var $author$project$Pages$Partner$Team$roleOptions = function (roles) {
	return A2(
		$elm$core$List$cons,
		A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, 'Pick a role'),
		A2(
			$elm$core$List$map,
			function (role) {
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(
						$author$project$Api$Common$Role$All$name(role)),
					$author$project$Formatters$String$titleize(
						$author$project$Formatters$String$humanize(
							$author$project$Api$Common$Role$All$name(role))));
			},
			roles));
};
var $author$project$Pages$Partner$Team$viewPermissionSet = F2(
	function (index, permissionSet) {
		var hasEvenIndex = !A2($elm$core$Basics$modBy, 2, index);
		var offset = hasEvenIndex ? $author$project$Ui$Grid$offsetSm(2) : $author$project$Ui$Grid$offset(1);
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						offset,
						$author$project$Ui$Grid$span(4)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$text,
										_List_fromArray(
											[$author$project$Ui$Typography$muted]),
										$author$project$Formatters$String$humanize(
											$author$project$Api$Common$PermissionSet$Shared$name(permissionSet))),
										$author$project$Api$Common$PermissionSet$Shared$enabled(permissionSet) ? $author$project$Ui$Icon$check(
										_List_fromArray(
											[$author$project$Ui$Icon$success])) : $author$project$Ui$Icon$cross(
										_List_fromArray(
											[$author$project$Ui$Icon$danger]))
									]))
							]))
					]))
			]);
	});
var $author$project$Pages$Partner$Team$viewTeamMemberModal = F4(
	function (model, teamMember, request, form) {
		var modalConfig = {
			Tq: $elm$core$Maybe$Nothing,
			aih: 'Team Member',
			V8: _Utils_eq(request, $author$project$Api$Data$Loading),
			WG: A2($elm$core$Maybe$map, $author$project$Api$Partner$PartnerUser$All$id, teamMember),
			WH: $elm$core$Maybe$Nothing,
			Yd: $author$project$Pages$Partner$Team$CancelTeamMemberEdit,
			Yf: A2($author$project$Pages$Partner$Team$SaveTeamMember, form, teamMember)
		};
		var isNewTeamMember = !$author$project$Utils$Maybe$toBool(teamMember);
		var isCurrentUser = _Utils_eq(
			A2($elm$core$Maybe$map, $author$project$Api$Partner$PartnerUser$All$email, teamMember),
			$elm$core$Maybe$Just(
				$author$project$Api$Platform$User$Shared$email(model.Hd)));
		var roleDisabled = isCurrentUser || A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, $author$project$Api$Partner$PartnerUser$All$isOwner, teamMember));
		var fields = $author$project$Utils$Form$fields(form);
		var _v0 = function () {
			var _v1 = model.ak4;
			if (_v1.$ === 3) {
				var list = _v1.a;
				return _Utils_Tuple2(list, false);
			} else {
				return _Utils_Tuple2(_List_Nil, true);
			}
		}();
		var roles_ = _v0.a;
		var rolesLoading = _v0.b;
		var permissionSets = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Common$Role$All$permissionSets,
				A2(
					$elm_community$list_extra$List$Extra$find,
					function (role) {
						return _Utils_eq(
							$author$project$Api$Common$Role$All$name(role),
							fields.ak3);
					},
					roles_)));
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$required(isNewTeamMember),
							$author$project$Ui$Form$Group$label('Email')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(fields.Rj),
									$author$project$Ui$Form$Input$placeholder('email@example.com'),
									$author$project$Ui$Form$Input$autofocus(true),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Partner$Team$FormUpdated, $author$project$Pages$Partner$Team$Email)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 0, form)),
									$author$project$Ui$Form$Input$disabled(!isNewTeamMember)
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$required(true),
							$author$project$Ui$Form$Group$label('Role')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(
									$elm$core$Maybe$Just(fields.ak3)),
									$author$project$Ui$Form$Select$onChange(
									A2($elm$core$Basics$composeL, $author$project$Pages$Partner$Team$FormUpdated, $author$project$Pages$Partner$Team$Role)),
									$author$project$Ui$Form$Select$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
									$author$project$Ui$Form$Select$errors(
									A2($author$project$Utils$Form$validationErrors, 1, form)),
									$author$project$Ui$Form$Select$loading(rolesLoading),
									$author$project$Ui$Form$Select$disabled(roleDisabled)
								]),
							$author$project$Pages$Partner$Team$roleOptions(roles_)),
							roleDisabled ? A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[$author$project$Ui$Typography$small, $author$project$Ui$Typography$info]),
							'You cannot change your own role.') : $author$project$Utils$Html$empty
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Notifications')
						]),
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$view(
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$on(fields.X$),
									$author$project$Ui$ToggleSwitch$onChange(
									A2($elm$core$Basics$composeL, $author$project$Pages$Partner$Team$FormUpdated, $author$project$Pages$Partner$Team$NotificationsEnabled))
								]))
						])),
					(isNewTeamMember && (!model.eC)) ? A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Send invitation')
						]),
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$view(
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$on(fields.n2),
									$author$project$Ui$ToggleSwitch$onChange(
									A2($elm$core$Basics$composeL, $author$project$Pages$Partner$Team$FormUpdated, $author$project$Pages$Partner$Team$Invite))
								]))
						])) : $author$project$Utils$Html$empty,
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('MFA')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$Ui$Badge$fromString, _List_Nil, fields.W6),
									$author$project$Utils$Html$noBreakSpace,
									function () {
									if (!teamMember.$) {
										var teamMember_ = teamMember.a;
										return ((fields.W6 === 'active') && (!isCurrentUser)) ? A3(
											$author$project$Ui$Button$view,
											{mm: 'Reset MFA device'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick(
													$author$project$Pages$Partner$Team$OpenDisableMfaConfirm(
														$author$project$Api$Partner$PartnerUser$All$id(teamMember_)))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Reset MFA device')
												])) : $author$project$Utils$Html$empty;
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								]))
						])),
					A2(
					$author$project$Ui$Grid$row,
					_List_fromArray(
						[$author$project$Ui$Grid$mb2]),
					$elm$core$List$concat(
						A2($elm$core$List$indexedMap, $author$project$Pages$Partner$Team$viewPermissionSet, permissionSets)))
				]));
	});
var $author$project$Pages$Partner$Team$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				function () {
				var _v0 = model.I;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var teamMember = _v1.a;
					var form = _v1.b;
					var request = _v1.c;
					return A4($author$project$Pages$Partner$Team$viewTeamMemberModal, model, teamMember, request, form);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v2 = model.nf;
				if (!_v2.$) {
					var teamMember = _v2.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Partner$Team$DeleteConfirmClosed(
							$author$project$Api$Partner$PartnerUser$All$id(teamMember)),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('delete'),
								$author$project$Components$HiConfirm$noun('team member'),
								$author$project$Components$HiConfirm$detail(
								$author$project$Api$Partner$PartnerUser$All$email(teamMember))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v3 = model.jq;
				if (!_v3.$) {
					var id = _v3.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Partner$Team$DisableMfaConfirmClosed(id),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('reset'),
								$author$project$Components$HiConfirm$noun('MFA device'),
								$author$project$Components$HiConfirm$titleizeNoun(false),
								$author$project$Components$HiConfirm$customMessage(
								_List_fromArray(
									[
										$elm$html$Html$text('Resetting the MFA device for this user will log them out of all sessions and require them to setup a new MFA device the next time they login.')
									]))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Ui$Panel$title(
												_List_fromArray(
													[
														$elm$html$Html$text('Team')
													])),
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$textSm]),
												_List_fromArray(
													[
														$elm$html$Html$text('Changing settings within the Admin section requires \"Admin\" privileges. Non admin users can\n        view the settings but cannot change them.')
													]))
											])),
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$gap2]),
										_List_fromArray(
											[
												model.Ij ? A3(
												$author$project$Ui$HinterOnly$button,
												{mm: 'Add & Auto Accept member'},
												_List_fromArray(
													[
														$author$project$Ui$Button$default,
														$author$project$Ui$Button$onClick($author$project$Pages$Partner$Team$AddExistingMember)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Add & Auto Accept')
													])) : $author$project$Utils$Html$empty,
												A3(
												$author$project$Ui$Button$view,
												{mm: 'Add new member'},
												_List_fromArray(
													[
														$author$project$Ui$Button$default,
														$author$project$Ui$Button$onClick($author$project$Pages$Partner$Team$NewTeamMember),
														$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Add')
													]))
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						$author$project$Pages$Partner$Team$viewPanelBody(model)),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Partner$Team$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(
											!$author$project$Api$Data$isSuccess(model.fm))
										]),
									model.ajJ))
							]))
					]))
			]),
		ac9: 'Admin | Team'
	};
};
var $author$project$Pages$Partner$Team$page = $author$project$Spa$Page$applicationPartner(
	{ah_: $author$project$Pages$Partner$Team$init, aiq: $author$project$Pages$Partner$Team$load, k8: $author$project$Pages$Partner$Team$save, alO: $author$project$Pages$Partner$Team$subscriptions, adT: $author$project$Pages$Partner$Team$update, amo: $author$project$Pages$Partner$Team$view});
var $author$project$Pages$Partner$Webhooks$Requests$EndpointResourceFilterMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Partner$Webhooks$Requests$PracticeResourceFilterMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Partner$Webhooks$Requests$StatusDropdownMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Partner$Webhooks$Requests$GotWebhookRequests = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Partner$WebhookRequest$All$WebhookRequest = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Partner$WebhookRequest$Shared$WebhookRequest = $elm$core$Basics$identity;
var $author$project$Api$Partner$WebhookRequest$Shared$Record = F9(
	function (status, eventType, attempts, createdAt, deliveredAt, lastAttemptedAt, lastStatusCode, payload, lastResponse) {
		return {L8: attempts, O1: createdAt, Qk: deliveredAt, RQ: eventType, aij: lastAttemptedAt, VK: lastResponse, VN: lastStatusCode, Y8: payload, alH: status};
	});
var $author$project$Api$Partner$WebhookRequest$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'last_response',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'payload',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$value),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'last_status_code',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'last_attempted_at',
				$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'delivered_at',
					$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'created_at',
						$elm_community$json_extra$Json$Decode$Extra$datetime,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'attempts',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'event_type',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'status',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Api$Partner$WebhookRequest$Shared$Record))))))))));
var $author$project$Api$Partner$WebhookRequest$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$WebhookRequest$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$WebhookRequest$All$Record = F2(
	function (webhookEndpoint, practice) {
		return {ZV: practice, aeq: webhookEndpoint};
	});
var $author$project$Api$Partner$WebhookEndpoint$Min$WebhookEndpoint = $elm$core$Basics$identity;
var $author$project$Api$Partner$WebhookEndpoint$Min$Record = F2(
	function (id, webhookUrl) {
		return {ahP: id, aer: webhookUrl};
	});
var $author$project$Api$Partner$WebhookEndpoint$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'webhook_url',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Partner$WebhookEndpoint$Min$Record)));
var $author$project$Api$Partner$WebhookEndpoint$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$WebhookEndpoint$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$WebhookRequest$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'practice',
	$author$project$Api$Partner$Practice$Min$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'webhook_endpoint',
		$author$project$Api$Partner$WebhookEndpoint$Min$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Partner$WebhookRequest$All$Record)));
var $author$project$Api$Partner$WebhookRequest$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$WebhookRequest$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Partner$WebhookRequest$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Partner$WebhookRequest$All$WebhookRequest)));
var $author$project$Api$Partner$WebhookRequest$listDefaults = {ajJ: $author$project$Api$Pagination$init, Ji: $elm$core$Maybe$Nothing, alA: $author$project$Api$Sort$init, alH: $elm$core$Maybe$Nothing, Kp: $elm$core$Maybe$Nothing};
var $author$project$Api$Partner$WebhookRequest$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Partner$WebhookRequest$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ),
				function () {
				var _v0 = options.alH;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'status', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.Kp;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'webhook_endpoint', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.Ji;
				if (!_v2.$) {
					var string = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'practice', string)
						]);
				} else {
					return _List_Nil;
				}
			}()
			]));
};
var $author$project$Api$Partner$WebhookRequest$webhookRequestsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['webhook_requests']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$WebhookRequest$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Partner$WebhookRequest$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Partner$WebhookRequest$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Partner$WebhookRequest$webhookRequestsPath)));
	});
var $author$project$Components$ResourceFilter$Partner$WebhookEndpoint$value = function (model) {
	return A2($author$project$Components$ResourceFilter$choiceToValue, model.b8, model.Jy);
};
var $author$project$Pages$Partner$Webhooks$Requests$fetchWebhookRequests = function (model) {
	return A3(
		$author$project$Api$Partner$WebhookRequest$list,
		model.Gv,
		function (d) {
			return _Utils_update(
				d,
				{
					ajJ: model.ajJ,
					Ji: $author$project$Components$ResourceFilter$Partner$Practice$value(model.kL),
					alA: model.alA,
					alH: model.lg,
					Kp: $author$project$Components$ResourceFilter$Partner$WebhookEndpoint$value(model.gn)
				});
		},
		$author$project$Pages$Partner$Webhooks$Requests$GotWebhookRequests);
};
var $author$project$Components$ResourceFilter$Partner$WebhookEndpoint$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Api$Partner$WebhookEndpoint$All$WebhookEndpoint = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Partner$WebhookEndpoint$Shared$WebhookEndpoint = $elm$core$Basics$identity;
var $author$project$Api$Partner$WebhookEndpoint$Shared$Record = F4(
	function (id, webhookUrl, createdAt, lastDeliveredAt) {
		return {O1: createdAt, ahP: id, VE: lastDeliveredAt, aer: webhookUrl};
	});
var $author$project$Api$Partner$WebhookEndpoint$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'last_delivered_at',
	$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'created_at',
		$elm_community$json_extra$Json$Decode$Extra$datetime,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'webhook_url',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Partner$WebhookEndpoint$Shared$Record)))));
var $author$project$Api$Partner$WebhookEndpoint$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$WebhookEndpoint$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$WebhookEndpoint$All$Record = function (integration) {
	return {T8: integration};
};
var $author$project$Api$Partner$WebhookEndpoint$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'integration',
	$elm$json$Json$Decode$nullable($author$project$Api$Partner$Integration$Shared$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Partner$WebhookEndpoint$All$Record));
var $author$project$Api$Partner$WebhookEndpoint$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$WebhookEndpoint$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Partner$WebhookEndpoint$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Partner$WebhookEndpoint$All$WebhookEndpoint)));
var $author$project$Api$Partner$Common$WebhookEndpoint$listDefaults = {ajJ: $author$project$Api$Pagination$init, akl: $elm$core$Maybe$Nothing, alA: $author$project$Api$Sort$init};
var $author$project$Api$Partner$Common$WebhookEndpoint$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Partner$Common$WebhookEndpoint$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ),
				A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (q) {
						return _List_fromArray(
							[
								A2($author$project$Api$Param$string, 'q', q)
							]);
					},
					options.akl))
			]));
};
var $author$project$Api$Partner$WebhookEndpoint$webhookEndpointsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['webhook_endpoints']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$WebhookEndpoint$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Partner$WebhookEndpoint$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Partner$Common$WebhookEndpoint$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Partner$WebhookEndpoint$webhookEndpointsPath)));
	});
var $author$project$Components$ResourceFilter$Partner$WebhookEndpoint$list = F3(
	function (apiClient, optionals, toMsg) {
		return A3($author$project$Api$Partner$WebhookEndpoint$list, apiClient, optionals, toMsg);
	});
var $author$project$Components$ResourceFilter$Partner$WebhookEndpoint$fetchResources = F4(
	function (toMsg, apiClient, pagination, _v0) {
		return A3(
			$author$project$Components$ResourceFilter$Partner$WebhookEndpoint$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{ajJ: pagination});
			},
			toMsg);
	});
var $author$project$Components$ResourceFilter$Partner$WebhookEndpoint$retrieveResource = F3(
	function (toMsg, apiClient, _v0) {
		return A3($author$project$Components$ResourceFilter$Partner$WebhookEndpoint$list, apiClient, $elm$core$Basics$identity, toMsg);
	});
var $author$project$Components$ResourceFilter$Partner$WebhookEndpoint$selectId = 'partner-webhook-endpoints';
var $author$project$Api$Partner$WebhookEndpoint$Shared$webhookUrl = function (_v0) {
	var record = _v0;
	return record.aer;
};
var $author$project$Api$Partner$WebhookEndpoint$All$webhookUrl = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$WebhookEndpoint$Shared$webhookUrl(shared);
};
var $author$project$Components$ResourceFilter$Partner$WebhookEndpoint$toTitle = $author$project$Api$Partner$WebhookEndpoint$All$webhookUrl;
var $author$project$Components$ResourceFilter$Partner$WebhookEndpoint$toLabel = function (resource) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Components$ResourceFilter$Partner$WebhookEndpoint$toTitle(resource))
		]);
};
var $author$project$Api$Partner$WebhookEndpoint$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Partner$WebhookEndpoint$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$WebhookEndpoint$Shared$id(shared);
};
var $author$project$Components$ResourceFilter$Partner$WebhookEndpoint$toValue = $author$project$Api$Partner$WebhookEndpoint$All$id;
var $author$project$Components$ResourceFilter$Partner$WebhookEndpoint$init = F2(
	function (apiClient, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{Sk: $author$project$Components$ResourceFilter$Partner$WebhookEndpoint$fetchResources, ahP: $author$project$Components$ResourceFilter$Partner$WebhookEndpoint$selectId, k$: 'Webhook Endpoints', uk: $author$project$Components$ResourceFilter$Partner$WebhookEndpoint$retrieveResource, u9: $author$project$Components$ResourceFilter$Partner$WebhookEndpoint$toLabel, lN: $author$project$Components$ResourceFilter$Partner$WebhookEndpoint$toTitle, hX: $author$project$Components$ResourceFilter$Partner$WebhookEndpoint$toValue},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{Jy: $author$project$Components$ResourceFilter$All, b8: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$ResourceFilter$Partner$Practice$preSelectedId = F2(
	function (id, model) {
		var _v0 = A2($author$project$Components$ResourceFilter$preSelectedId, id, model.b8);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{b8: resourceFilter}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$ResourceFilter$Partner$WebhookEndpoint$preSelectedId = F2(
	function (id, model) {
		var _v0 = A2($author$project$Components$ResourceFilter$preSelectedId, id, model.b8);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{b8: resourceFilter}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Pages$Partner$Webhooks$Requests$init = F4(
	function (_v0, _v1, shared, _v2) {
		var query = _v2.DE;
		var _v3 = A2(
			$author$project$Components$ResourceFilter$Partner$Practice$init,
			shared.Gv,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'All Practices'});
			});
		var practiceResourceFilter = _v3.a;
		var practiceResourceFilterCmd = _v3.b;
		var _v4 = A2(
			$author$project$Components$ResourceFilter$Partner$Practice$preSelectedId,
			A2($elm$core$Dict$get, 'practice', query),
			practiceResourceFilter);
		var practiceResourceFilter2 = _v4.a;
		var practiceResourceFilterPreSelectCmd = _v4.b;
		var _v5 = A2(
			$author$project$Components$ResourceFilter$Partner$WebhookEndpoint$init,
			shared.Gv,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'All Endpoints'});
			});
		var endpointResourceFilter = _v5.a;
		var endpointResourceFilterCmd = _v5.b;
		var _v6 = A2(
			$author$project$Components$ResourceFilter$Partner$WebhookEndpoint$preSelectedId,
			A2($elm$core$Dict$get, 'webhook_endpoint', query),
			endpointResourceFilter);
		var endpointResourceFilter2 = _v6.a;
		var endpointResourceFilterPreSelectCmd = _v6.b;
		var model = {
			Gv: shared.Gv,
			gn: endpointResourceFilter2,
			ajJ: $author$project$Api$Pagination$initFromQuery(query),
			kL: practiceResourceFilter2,
			pW: $elm$core$Maybe$Nothing,
			lg: A2($elm$core$Dict$get, 'status', query),
			alA: A3(
				$author$project$Api$Sort$withDefault,
				'created_at',
				1,
				$author$project$Api$Sort$initFromQuery(query)),
			qn: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'webhook-requests-status-dropdown', al6: $author$project$Pages$Partner$Webhooks$Requests$StatusDropdownMsg})),
			J7: shared.J7,
			fu: $author$project$Api$Data$Loading
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Pages$Partner$Webhooks$Requests$fetchWebhookRequests(model),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Webhooks$Requests$EndpointResourceFilterMsg, endpointResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Webhooks$Requests$EndpointResourceFilterMsg, endpointResourceFilterPreSelectCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Webhooks$Requests$PracticeResourceFilterMsg, practiceResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Webhooks$Requests$PracticeResourceFilterMsg, practiceResourceFilterPreSelectCmd)
					])));
	});
var $author$project$Pages$Partner$Webhooks$Requests$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Partner$Webhooks$Requests$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Partner$Webhooks$Requests$CloseDetails = {$: 8};
var $author$project$Components$ResourceFilter$Partner$WebhookEndpoint$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.b8));
};
var $author$project$Pages$Partner$Webhooks$Requests$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$Dropdown$subscriptions(model.qn),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Partner$Webhooks$Requests$EndpointResourceFilterMsg,
				$author$project$Components$ResourceFilter$Partner$WebhookEndpoint$subscriptions(model.gn)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Partner$Webhooks$Requests$PracticeResourceFilterMsg,
				$author$project$Components$ResourceFilter$Partner$Practice$subscriptions(model.kL)),
				function () {
				var _v0 = model.pW;
				if (!_v0.$) {
					return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Pages$Partner$Webhooks$Requests$CloseDetails);
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}()
			]));
};
var $author$project$Components$ResourceFilter$Partner$WebhookEndpoint$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.b8);
		var modelAfterEvent = function () {
			var _v1 = result.agZ;
			if (!_v1.$) {
				var selected = _v1.a;
				return _Utils_update(
					model,
					{Jy: selected});
			} else {
				return model;
			}
		}();
		return {
			GZ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.GZ),
			agZ: result.agZ,
			aiO: _Utils_update(
				modelAfterEvent,
				{b8: result.aiO}),
			aR: result.aR
		};
	});
var $author$project$Pages$Partner$Webhooks$Requests$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('status'),
			model.lg),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('webhook_endpoint'),
			$author$project$Components$ResourceFilter$Partner$WebhookEndpoint$value(model.gn)),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('practice'),
			$author$project$Components$ResourceFilter$Partner$Practice$value(model.kL))
		]);
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Partner__Webhooks__Requests)
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.ajJ),
				A2(
					$elm$core$List$append,
					$author$project$Api$Sort$toQuery(model.alA),
					A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
};
var $author$project$Pages$Partner$Webhooks$Requests$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ),
								fu: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{fu: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Ui$Dropdown$update, subMsg, model.qn);
				var statusDropdown = _v2.a;
				var statusDropdownCmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qn: statusDropdown}),
					statusDropdownCmd,
					_List_Nil);
			case 2:
				var selectedOption = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ajJ: $author$project$Api$Pagination$reset(model.ajJ),
						lg: function () {
							if (selectedOption.$ === 1) {
								return $elm$core$Maybe$Nothing;
							} else {
								var status = selectedOption.a;
								return $elm$core$Maybe$Just(status);
							}
						}(),
						fu: $author$project$Api$Data$Loading
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Partner$Webhooks$Requests$fetchWebhookRequests(newModel),
								$author$project$Pages$Partner$Webhooks$Requests$updateUrl(newModel)
							])),
					_List_Nil);
			case 3:
				var subMsg = msg.a;
				var result = A3($author$project$Components$ResourceFilter$Partner$WebhookEndpoint$update, model.Gv, subMsg, model.gn);
				var newModel = _Utils_update(
					model,
					{gn: result.aiO});
				var _v4 = result.agZ;
				if (!_v4.$) {
					var refreshModel = _Utils_update(
						newModel,
						{
							ajJ: $author$project$Api$Pagination$reset(newModel.ajJ),
							fu: $author$project$Api$Data$Loading
						});
					return _Utils_Tuple3(
						refreshModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Webhooks$Requests$EndpointResourceFilterMsg, result.GZ),
									$author$project$Pages$Partner$Webhooks$Requests$fetchWebhookRequests(refreshModel),
									$author$project$Pages$Partner$Webhooks$Requests$updateUrl(refreshModel)
								])),
						result.aR);
				} else {
					return _Utils_Tuple3(
						newModel,
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Webhooks$Requests$EndpointResourceFilterMsg, result.GZ),
						result.aR);
				}
			case 4:
				var subMsg = msg.a;
				var result = A3($author$project$Components$ResourceFilter$Partner$Practice$update, model.Gv, subMsg, model.kL);
				var newModel = _Utils_update(
					model,
					{kL: result.aiO});
				var _v5 = result.agZ;
				if (!_v5.$) {
					var refreshModel = _Utils_update(
						newModel,
						{
							ajJ: $author$project$Api$Pagination$reset(newModel.ajJ),
							fu: $author$project$Api$Data$Loading
						});
					return _Utils_Tuple3(
						refreshModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Webhooks$Requests$PracticeResourceFilterMsg, result.GZ),
									$author$project$Pages$Partner$Webhooks$Requests$fetchWebhookRequests(refreshModel),
									$author$project$Pages$Partner$Webhooks$Requests$updateUrl(refreshModel)
								])),
						result.aR);
				} else {
					return _Utils_Tuple3(
						newModel,
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Webhooks$Requests$PracticeResourceFilterMsg, result.GZ),
						result.aR);
				}
			case 5:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Partner$Webhooks$Requests$fetchWebhookRequests(newModel),
								$author$project$Pages$Partner$Webhooks$Requests$updateUrl(newModel)
							])),
					_List_Nil);
			case 6:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						alA: A2($author$project$Api$Sort$update, columnId, model.alA)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Partner$Webhooks$Requests$fetchWebhookRequests(newModel),
								$author$project$Pages$Partner$Webhooks$Requests$updateUrl(newModel)
							])),
					_List_Nil);
			case 7:
				var webhookRequest = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							pW: $elm$core$Maybe$Just(webhookRequest)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{pW: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
		}
	});
var $author$project$Pages$Partner$Webhooks$Requests$PaginationMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$ResourceFilter$Partner$WebhookEndpoint$view = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$view,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.Jy),
					options),
				model.b8));
	});
var $author$project$Api$Partner$WebhookRequest$Shared$eventType = function (_v0) {
	var record = _v0;
	return record.RQ;
};
var $author$project$Api$Partner$WebhookRequest$All$eventType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$WebhookRequest$Shared$eventType(shared);
};
var $author$project$Api$Partner$WebhookRequest$Shared$lastResponse = function (_v0) {
	var record = _v0;
	return record.VK;
};
var $author$project$Api$Partner$WebhookRequest$All$lastResponse = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$WebhookRequest$Shared$lastResponse(shared);
};
var $author$project$Api$Partner$WebhookRequest$Shared$lastStatusCode = function (_v0) {
	var record = _v0;
	return record.VN;
};
var $author$project$Api$Partner$WebhookRequest$All$lastStatusCode = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$WebhookRequest$Shared$lastStatusCode(shared);
};
var $author$project$Api$Partner$WebhookRequest$Shared$payload = function (_v0) {
	var record = _v0;
	return record.Y8;
};
var $author$project$Api$Partner$WebhookRequest$All$payload = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$WebhookRequest$Shared$payload(shared);
};
var $author$project$Pages$Partner$Webhooks$Requests$viewDetailSection = F2(
	function (label, content) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label(label),
					$author$project$Ui$Form$Group$labelAbove
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$static(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$pre,
							_List_fromArray(
								[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted, $author$project$Ui$Typography$preWrap]),
							_List_fromArray(
								[
									$elm$html$Html$text(content)
								]))
						]))
				]));
	});
var $author$project$Pages$Partner$Webhooks$Requests$viewDetailsModal = function (model) {
	var _v0 = model.pW;
	if (!_v0.$) {
		var webhookRequest = _v0.a;
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Pages$Partner$Webhooks$Requests$CloseDetails,
			_List_fromArray(
				[$author$project$Ui$Modal$lg]),
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title(
							A2(
								$elm$core$Maybe$withDefault,
								'Webhook Request Details',
								$author$project$Api$Partner$WebhookRequest$All$eventType(webhookRequest)))
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$author$project$Pages$Partner$Webhooks$Requests$viewDetailSection,
							'Last Status Code',
							A2(
								$elm$core$Maybe$withDefault,
								'N/A',
								A2(
									$elm$core$Maybe$map,
									$elm$core$String$fromInt,
									$author$project$Api$Partner$WebhookRequest$All$lastStatusCode(webhookRequest)))),
							A2(
							$author$project$Pages$Partner$Webhooks$Requests$viewDetailSection,
							'Last Response',
							A2(
								$elm$core$Maybe$withDefault,
								'No response',
								$author$project$Api$Partner$WebhookRequest$All$lastResponse(webhookRequest))),
							A2(
							$author$project$Pages$Partner$Webhooks$Requests$viewDetailSection,
							'Payload',
							A2(
								$elm$core$Maybe$withDefault,
								'No payload',
								A2(
									$elm$core$Maybe$map,
									$elm$json$Json$Encode$encode(2),
									$author$project$Api$Partner$WebhookRequest$All$payload(webhookRequest))))
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Close'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Pages$Partner$Webhooks$Requests$CloseDetails)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Close')
								]))
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Partner$Webhooks$Requests$SortTable = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Partner$Webhooks$Requests$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'event_type', true, 'Event Type'),
		A3($author$project$Api$Column$init, 'status', true, 'Status'),
		A3($author$project$Api$Column$init, 'webhook_endpoint', true, 'Endpoint'),
		A3($author$project$Api$Column$init, 'practice', true, 'Practice'),
		A3($author$project$Api$Column$init, 'attempts', true, 'Attempts'),
		A3($author$project$Api$Column$init, 'created_at', true, 'Created'),
		A3($author$project$Api$Column$init, 'delivered_at', true, 'Delivered'),
		A3($author$project$Api$Column$init, 'details', false, '')
	]);
var $author$project$Pages$Partner$Webhooks$Requests$ViewDetails = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Partner$WebhookRequest$Shared$attempts = function (_v0) {
	var record = _v0;
	return record.L8;
};
var $author$project$Api$Partner$WebhookRequest$All$attempts = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$WebhookRequest$Shared$attempts(shared);
};
var $author$project$Api$Partner$WebhookRequest$Shared$createdAt = function (_v0) {
	var record = _v0;
	return record.O1;
};
var $author$project$Api$Partner$WebhookRequest$All$createdAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$WebhookRequest$Shared$createdAt(shared);
};
var $author$project$Api$Partner$WebhookRequest$Shared$deliveredAt = function (_v0) {
	var record = _v0;
	return record.Qk;
};
var $author$project$Api$Partner$WebhookRequest$All$deliveredAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$WebhookRequest$Shared$deliveredAt(shared);
};
var $author$project$Api$Partner$WebhookRequest$All$practice = function (_v0) {
	var record = _v0.b;
	return record.ZV;
};
var $author$project$Api$Partner$WebhookRequest$Shared$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Api$Partner$WebhookRequest$All$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$WebhookRequest$Shared$status(shared);
};
var $author$project$Pages$Partner$Webhooks$Requests$viewStatusBadge = function (status) {
	var badgeOption = function () {
		switch (status) {
			case 'delivered':
				return $author$project$Ui$Badge$success;
			case 'failed':
				return $author$project$Ui$Badge$danger;
			case 'pending':
				return $author$project$Ui$Badge$neutral;
			case 'retrying':
				return $author$project$Ui$Badge$warning;
			case 'attempted':
				return $author$project$Ui$Badge$info;
			default:
				return $author$project$Ui$Badge$neutral;
		}
	}();
	return A2(
		$author$project$Ui$Badge$fromString,
		_List_fromArray(
			[badgeOption]),
		$author$project$Formatters$String$humanize(status));
};
var $author$project$Api$Partner$WebhookRequest$All$webhookEndpoint = function (_v0) {
	var record = _v0.b;
	return record.aeq;
};
var $author$project$Api$Partner$WebhookEndpoint$Min$webhookUrl = function (_v0) {
	var record = _v0;
	return record.aer;
};
var $author$project$Pages$Partner$Webhooks$Requests$viewItem = F2(
	function (timeFormatter, webhookRequest) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'N/A',
								$author$project$Api$Partner$WebhookRequest$All$eventType(webhookRequest)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Partner$Webhooks$Requests$viewStatusBadge(
							$author$project$Api$Partner$WebhookRequest$All$status(webhookRequest))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Partner$WebhookEndpoint$Min$webhookUrl(
								$author$project$Api$Partner$WebhookRequest$All$webhookEndpoint(webhookRequest)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Partner$Practice$Min$name(
								$author$project$Api$Partner$WebhookRequest$All$practice(webhookRequest)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(
								$author$project$Api$Partner$WebhookRequest$All$attempts(webhookRequest)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								timeFormatter,
								4,
								$author$project$Api$Partner$WebhookRequest$All$createdAt(webhookRequest)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'—',
								A2(
									$elm$core$Maybe$map,
									timeFormatter(4),
									$author$project$Api$Partner$WebhookRequest$All$deliveredAt(webhookRequest))))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'View webhook request details'},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$sm,
									$author$project$Ui$Button$onClick(
									$author$project$Pages$Partner$Webhooks$Requests$ViewDetails(webhookRequest))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Details')
								]))
						]))
				]));
	});
var $author$project$Pages$Partner$Webhooks$Requests$viewPanelBody = function (model) {
	var _v0 = function () {
		var _v1 = model.fu;
		if (_v1.$ === 3) {
			var webhookRequests_ = _v1.a;
			return _Utils_Tuple2(false, webhookRequests_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var webhookRequests = _v0.b;
	return _List_fromArray(
		[
			A4(
			$author$project$Ui$Table$view,
			_List_fromArray(
				[
					$author$project$Ui$Table$verticalCentered,
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('There are no webhook requests.')
						])),
					$author$project$Ui$Table$loading(loading)
				]),
			A2(
				$elm$core$List$map,
				$author$project$Api$Column$view(
					A2($author$project$Api$Column$Sortable, model.alA, $author$project$Pages$Partner$Webhooks$Requests$SortTable)),
				$author$project$Pages$Partner$Webhooks$Requests$columns),
			A2(
				$elm$core$List$map,
				$author$project$Pages$Partner$Webhooks$Requests$viewItem(model.J7),
				webhookRequests),
			_List_Nil)
		]);
};
var $author$project$Pages$Partner$Webhooks$Requests$NoStatus = {$: 1};
var $author$project$Pages$Partner$Webhooks$Requests$Status = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Partner$Webhooks$Requests$StatusFiltered = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Partner$Webhooks$Requests$statusDropdownOptions = function (currentStatus) {
	var statusOptions = A2(
		$elm$core$List$map,
		function (status) {
			return A2(
				$author$project$Ui$Dropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$Dropdown$onSelect(
						$author$project$Pages$Partner$Webhooks$Requests$StatusFiltered(
							$author$project$Pages$Partner$Webhooks$Requests$Status(status))),
						$author$project$Ui$Dropdown$selected(
						_Utils_eq(
							$elm$core$Maybe$Just(status),
							currentStatus))
					]),
				$elm$html$Html$text(
					$author$project$Formatters$String$humanize(status)));
		},
		_List_fromArray(
			['pending', 'attempted', 'delivered', 'retrying', 'failed', 'duplicate', 'non_requestable', 'integration_endpoint_failing']));
	return A2(
		$elm$core$List$cons,
		A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Pages$Partner$Webhooks$Requests$StatusFiltered($author$project$Pages$Partner$Webhooks$Requests$NoStatus)),
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(currentStatus, $elm$core$Maybe$Nothing))
				]),
			$elm$html$Html$text('No Filter')),
		A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, statusOptions));
};
var $author$project$Pages$Partner$Webhooks$Requests$viewStatusDropdown = function (model) {
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				A2(
					$elm$core$Maybe$withDefault,
					'All Status',
					A2($elm$core$Maybe$map, $author$project$Formatters$String$humanize, model.lg)))
			]),
		$author$project$Pages$Partner$Webhooks$Requests$statusDropdownOptions(model.lg),
		model.qn);
};
var $author$project$Pages$Partner$Webhooks$Requests$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				$author$project$Pages$Partner$Webhooks$Requests$viewDetailsModal(model),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Webhook Requests')
									])),
								A2(
								$author$project$Ui$Grid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(4),
												$author$project$Ui$Grid$spanSm(3),
												$author$project$Ui$Grid$spanMd(4)
											]),
										_List_fromArray(
											[
												$author$project$Pages$Partner$Webhooks$Requests$viewStatusDropdown(model)
											])),
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(4),
												$author$project$Ui$Grid$spanSm(3),
												$author$project$Ui$Grid$spanMd(4)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Pages$Partner$Webhooks$Requests$EndpointResourceFilterMsg,
												A2($author$project$Components$ResourceFilter$Partner$WebhookEndpoint$view, _List_Nil, model.gn))
											])),
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(4),
												$author$project$Ui$Grid$spanSm(3),
												$author$project$Ui$Grid$spanMd(4)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Pages$Partner$Webhooks$Requests$PracticeResourceFilterMsg,
												A2($author$project$Components$ResourceFilter$Partner$Practice$view, _List_Nil, model.kL))
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						$author$project$Pages$Partner$Webhooks$Requests$viewPanelBody(model)),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Partner$Webhooks$Requests$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(
											!$author$project$Api$Data$isSuccess(model.fu))
										]),
									model.ajJ))
							]))
					]))
			]),
		ac9: 'Partner | Webhook Requests'
	};
};
var $author$project$Pages$Partner$Webhooks$Requests$page = $author$project$Spa$Page$applicationPartner(
	{ah_: $author$project$Pages$Partner$Webhooks$Requests$init, aiq: $author$project$Pages$Partner$Webhooks$Requests$load, k8: $author$project$Pages$Partner$Webhooks$Requests$save, alO: $author$project$Pages$Partner$Webhooks$Requests$subscriptions, adT: $author$project$Pages$Partner$Webhooks$Requests$update, amo: $author$project$Pages$Partner$Webhooks$Requests$view});
var $author$project$Pages$Partner$Webhooks$Settings$GotIntegrationEvents = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Partner$ManageWebhookEndpoints$Integrations = 1;
var $author$project$Pages$Partner$Webhooks$Settings$ListenedEventsDropdownMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Partner$Webhooks$Settings$ManageGlobalWebhookEndpointsMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Partner$Webhooks$Settings$ManageIntegrationWebhookEndpointsMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Partner$ManageWebhookEndpoints$Partner = 0;
var $author$project$Components$Partner$ManageWebhookEndpoints$IntegrationResourceFilterMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Partner$ManageWebhookEndpoints$Model = $elm$core$Basics$identity;
var $author$project$Components$Partner$ManageWebhookEndpoints$GotWebhookEndpoints = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$ManageWebhookEndpoints$fetchParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{ajJ: model.ajJ, akl: model.akl, alA: model.alA});
	};
};
var $author$project$Api$Partner$Integration$WebhookEndpoint$webhookEndpointsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['webhook_endpoints']),
	$author$project$Api$Partner$Integration$integrationsPath);
var $author$project$Api$Partner$Integration$WebhookEndpoint$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Partner$WebhookEndpoint$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Partner$Common$WebhookEndpoint$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Partner$Integration$WebhookEndpoint$webhookEndpointsPath)));
	});
var $author$project$Components$Partner$ManageWebhookEndpoints$fetchWebhookEndpoints = F2(
	function (apiClient, model) {
		var _v0 = model.YD;
		if (!_v0) {
			return A3(
				$author$project$Api$Partner$WebhookEndpoint$list,
				apiClient,
				$author$project$Components$Partner$ManageWebhookEndpoints$fetchParams(model),
				$author$project$Components$Partner$ManageWebhookEndpoints$GotWebhookEndpoints);
		} else {
			return A3(
				$author$project$Api$Partner$Integration$WebhookEndpoint$list,
				apiClient,
				$author$project$Components$Partner$ManageWebhookEndpoints$fetchParams(model),
				$author$project$Components$Partner$ManageWebhookEndpoints$GotWebhookEndpoints);
		}
	});
var $author$project$Components$Partner$ManageWebhookEndpoints$init = F4(
	function (apiClient, timeFormatter, owner, query) {
		var prefix = function () {
			if (!owner) {
				return 'partner_';
			} else {
				return 'integrations_';
			}
		}();
		var q = A2($elm$core$Dict$get, prefix + 'q', query);
		var _v0 = A2(
			$author$project$Components$ResourceFilter$Partner$Integration$init,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Select a Practice'});
			});
		var integrationResourceFilter = _v0.a;
		var integrationResourceFilterCmd = _v0.b;
		var model = {
			je: $elm$core$Maybe$Nothing,
			eg: $elm$core$Set$empty,
			n_: integrationResourceFilter,
			Io: $elm$core$Maybe$Nothing,
			YD: owner,
			ajJ: A2(
				$author$project$Api$Pagination$fromQuery,
				query,
				A2($author$project$Api$Pagination$withPrefix, prefix, $author$project$Api$Pagination$init)),
			akl: q,
			e4: $elm$core$Set$empty,
			up: $author$project$Ui$SearchInput$init(q),
			alA: A3(
				$author$project$Api$Sort$withDefault,
				'created_at',
				1,
				A2(
					$author$project$Api$Sort$fromQuery,
					query,
					A2($author$project$Api$Sort$withPrefix, prefix, $author$project$Api$Sort$init))),
			J7: timeFormatter,
			ia: $author$project$Api$Data$Loading
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Components$Partner$ManageWebhookEndpoints$fetchWebhookEndpoints, apiClient, model),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Partner$ManageWebhookEndpoints$IntegrationResourceFilterMsg, integrationResourceFilterCmd)
					])));
	});
var $author$project$Api$Partner$Partner$Shared$listenedEvents = function (_v0) {
	var record = _v0;
	return record.V6;
};
var $author$project$Api$Partner$Partner$One$listenedEvents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$listenedEvents(shared);
};
var $author$project$Api$Partner$Partner$Shared$maxRequestsPperMinute = function (_v0) {
	var record = _v0;
	return record.WD;
};
var $author$project$Api$Partner$Partner$One$maxRequestsPperMinute = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$maxRequestsPperMinute(shared);
};
var $author$project$Api$Partner$Partner$Shared$unmuteSelfWebhooks = function (_v0) {
	var record = _v0;
	return record.adN;
};
var $author$project$Api$Partner$Partner$One$unmuteSelfWebhooks = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$unmuteSelfWebhooks(shared);
};
var $author$project$Api$Partner$Partner$Shared$webhooksDisabled = function (_v0) {
	var record = _v0;
	return record.aes;
};
var $author$project$Api$Partner$Partner$One$webhooksDisabled = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$webhooksDisabled(shared);
};
var $author$project$Api$Partner$Partner$Shared$webhooksPaused = function (_v0) {
	var record = _v0;
	return record.aet;
};
var $author$project$Api$Partner$Partner$One$webhooksPaused = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$webhooksPaused(shared);
};
var $author$project$Pages$Partner$Webhooks$Settings$initFormFields = function (partner) {
	return _Utils_Tuple2(
		{
			V6: $author$project$Api$Partner$Partner$One$listenedEvents(partner),
			WD: $author$project$Api$Partner$Partner$One$maxRequestsPperMinute(partner),
			adN: $author$project$Api$Partner$Partner$One$unmuteSelfWebhooks(partner),
			aes: $author$project$Api$Partner$Partner$One$webhooksDisabled(partner),
			aet: $author$project$Api$Partner$Partner$One$webhooksPaused(partner)
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Api$Partner$IntegrationEvent$integrationEventsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['integration_events']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$IntegrationEvent$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Partner$IntegrationEvent$integrationEventsPath));
	});
var $author$project$Pages$Partner$Webhooks$Settings$init = F4(
	function (_v0, partner, shared, _v1) {
		var query = _v1.DE;
		var _v2 = A4($author$project$Components$Partner$ManageWebhookEndpoints$init, shared.Gv, shared.J7, 1, query);
		var manageIntegrationsWebhookEndpoints = _v2.a;
		var manageIntegrationsWebhookEndpointsCmd = _v2.b;
		var _v3 = A4($author$project$Components$Partner$ManageWebhookEndpoints$init, shared.Gv, shared.J7, 0, query);
		var manageGlobalWebhookEndpoints = _v3.a;
		var manageGlobalWebhookEndpointsCmd = _v3.b;
		var _v4 = $author$project$Pages$Partner$Webhooks$Settings$initFormFields(partner);
		var formFields = _v4.a;
		var formFieldsCmd = _v4.b;
		var model = {
			Gv: shared.Gv,
			SD: $author$project$Utils$Form$init(formFields),
			Ac: $author$project$Api$Data$Loading,
			Ij: $author$project$Shared$isHintAdmin(shared),
			oq: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'listened-events-dropdown', al6: $author$project$Pages$Partner$Webhooks$Settings$ListenedEventsDropdownMsg})),
			AF: '',
			ow: manageGlobalWebhookEndpoints,
			oy: manageIntegrationsWebhookEndpoints,
			qP: $author$project$Api$Data$NotAsked
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						formFieldsCmd,
						A2($author$project$Api$Partner$IntegrationEvent$list, shared.Gv, $author$project$Pages$Partner$Webhooks$Settings$GotIntegrationEvents),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Webhooks$Settings$ManageGlobalWebhookEndpointsMsg, manageGlobalWebhookEndpointsCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Webhooks$Settings$ManageIntegrationWebhookEndpointsMsg, manageIntegrationsWebhookEndpointsCmd)
					])));
	});
var $author$project$Pages$Partner$Webhooks$Settings$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Partner$Webhooks$Settings$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Partner$ManageWebhookEndpoints$CancelEdit = {$: 5};
var $author$project$Components$Partner$ManageWebhookEndpoints$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Partner$ManageWebhookEndpoints$CancelEdit)),
					model.Io)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Partner$ManageWebhookEndpoints$IntegrationResourceFilterMsg,
				$author$project$Components$ResourceFilter$Partner$Integration$subscriptions(model.n_))
			]));
};
var $author$project$Pages$Partner$Webhooks$Settings$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Partner$Webhooks$Settings$ManageGlobalWebhookEndpointsMsg,
				$author$project$Components$Partner$ManageWebhookEndpoints$subscriptions(model.ow)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Partner$Webhooks$Settings$ManageIntegrationWebhookEndpointsMsg,
				$author$project$Components$Partner$ManageWebhookEndpoints$subscriptions(model.oy)),
				$author$project$Ui$Dropdown$subscriptions(model.oq)
			]));
};
var $author$project$Pages$Partner$Webhooks$Settings$GotUpdatedPartner = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Partner$Webhooks$Settings$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var bool = field.a;
				return _Utils_update(
					fields,
					{aes: bool});
			case 1:
				var bool = field.a;
				return _Utils_update(
					fields,
					{aet: bool});
			case 2:
				var bool = field.a;
				return _Utils_update(
					fields,
					{adN: bool});
			case 4:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						WD: $elm$core$String$toInt(string)
					});
			default:
				var listenedEventField = field.a;
				var checked = field.b;
				return _Utils_update(
					fields,
					{
						V6: function () {
							var _v1 = _Utils_Tuple2(listenedEventField, checked);
							if (_v1.b) {
								switch (_v1.a.$) {
									case 0:
										var avaialbleListenedEvents = _v1.a.a;
										return avaialbleListenedEvents;
									case 1:
										return _List_Nil;
									default:
										var listenedEvents = _v1.a.a;
										return $elm$core$List$isEmpty(listenedEvents) ? _List_Nil : $elm_community$list_extra$List$Extra$unique(
											_Utils_ap(listenedEvents, fields.V6));
								}
							} else {
								switch (_v1.a.$) {
									case 0:
										return _List_Nil;
									case 1:
										var avaialbleListenedEvents = _v1.a.a;
										return avaialbleListenedEvents;
									default:
										var listenedEvents = _v1.a.a;
										return $elm_community$list_extra$List$Extra$unique(
											A2(
												$elm$core$List$filter,
												function (selectedEvent) {
													return !A2($elm$core$List$member, selectedEvent, listenedEvents);
												},
												fields.V6));
								}
							}
						}()
					});
		}
	});
var $author$project$Components$Partner$ManageWebhookEndpoints$IntegrationField = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$ManageWebhookEndpoints$ResetWebhooksResponse = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Components$Partner$ManageWebhookEndpoints$SearchInputMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Partner$ManageWebhookEndpoints$Deleted = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Api$Partner$Integration$WebhookEndpoint$webhookEndpointPath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		$author$project$Api$Partner$Integration$WebhookEndpoint$webhookEndpointsPath);
};
var $author$project$Api$Partner$Integration$WebhookEndpoint$delete = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Partner$Integration$WebhookEndpoint$webhookEndpointPath(id)));
	});
var $author$project$Api$Partner$WebhookEndpoint$webhookEndpointPath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		$author$project$Api$Partner$WebhookEndpoint$webhookEndpointsPath);
};
var $author$project$Api$Partner$WebhookEndpoint$delete = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Partner$WebhookEndpoint$webhookEndpointPath(id)));
	});
var $author$project$Components$Partner$ManageWebhookEndpoints$deleteItem = F3(
	function (apiClient, owner, item) {
		if (!owner) {
			return A3(
				$author$project$Api$Partner$WebhookEndpoint$delete,
				apiClient,
				$author$project$Api$Partner$WebhookEndpoint$All$id(item),
				$author$project$Components$Partner$ManageWebhookEndpoints$Deleted(item));
		} else {
			return A3(
				$author$project$Api$Partner$Integration$WebhookEndpoint$delete,
				apiClient,
				$author$project$Api$Partner$WebhookEndpoint$All$id(item),
				$author$project$Components$Partner$ManageWebhookEndpoints$Deleted(item));
		}
	});
var $author$project$Api$Partner$WebhookEndpoint$All$integration = function (_v0) {
	var record = _v0.b;
	return record.T8;
};
var $author$project$Components$Partner$ManageWebhookEndpoints$formFieldsFromItem = function (webhookEndpoint) {
	return _Utils_Tuple2(
		{
			T8: A2(
				$elm$core$Maybe$map,
				$author$project$Api$Partner$Integration$Shared$id,
				$author$project$Api$Partner$WebhookEndpoint$All$integration(webhookEndpoint)),
			aer: $author$project$Api$Partner$WebhookEndpoint$All$webhookUrl(webhookEndpoint)
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Components$Partner$ManageWebhookEndpoints$formFieldsInit = _Utils_Tuple2(
	{T8: $elm$core$Maybe$Nothing, aer: ''},
	$elm$core$Platform$Cmd$none);
var $author$project$Components$Partner$ManageWebhookEndpoints$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var string = field.a;
			return _Utils_update(
				fields,
				{aer: string});
		} else {
			var integration = field.a;
			return _Utils_update(
				fields,
				{T8: integration});
		}
	});
var $author$project$Components$Partner$ManageWebhookEndpoints$IntegrationValidation = 1;
var $author$project$Components$Partner$ManageWebhookEndpoints$validateIntegration = F2(
	function (owner, fields) {
		if (!owner) {
			return _List_Nil;
		} else {
			return _Utils_eq(fields.T8, $elm$core$Maybe$Nothing) ? _List_fromArray(
				[
					_Utils_Tuple2(1, 'Practice is required')
				]) : _List_Nil;
		}
	});
var $author$project$Components$Partner$ManageWebhookEndpoints$WebhookUrlValidation = 0;
var $author$project$Components$Partner$ManageWebhookEndpoints$validateWebhookUrl = function (fields) {
	return A2($elm$core$String$startsWith, 'https://', fields.aer) ? _List_Nil : _List_fromArray(
		[
			_Utils_Tuple2(0, 'URL must start with https://')
		]);
};
var $author$project$Components$Partner$ManageWebhookEndpoints$formFieldsValidator = function (owner) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Partner$ManageWebhookEndpoints$validateWebhookUrl),
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$Partner$ManageWebhookEndpoints$validateIntegration(owner))
			]));
};
var $author$project$Api$Partner$Integration$resetWebhooks = F3(
	function (apiClient, integrationId, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$Integration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['reset_webhooks']),
					$author$project$Api$Partner$Integration$integrationPath(integrationId))));
	});
var $author$project$Components$Partner$ManageWebhookEndpoints$Created = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Partner$WebhookEndpoint$One$WebhookEndpoint = 0;
var $author$project$Api$Partner$WebhookEndpoint$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Partner$Integration$WebhookEndpoint$create = F3(
	function (apiClient, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'webhook_endpoint',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'webhook_url',
								$elm$json$Json$Encode$string(params.aer)),
								_Utils_Tuple2(
								'integration',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, params.T8))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$WebhookEndpoint$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Partner$Integration$WebhookEndpoint$webhookEndpointsPath)));
	});
var $author$project$Api$Partner$WebhookEndpoint$create = F3(
	function (apiClient, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'webhook_endpoint',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'webhook_url',
								$elm$json$Json$Encode$string(params.aer))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$WebhookEndpoint$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Partner$WebhookEndpoint$webhookEndpointsPath)));
	});
var $author$project$Components$Partner$ManageWebhookEndpoints$integrationWebhookEndpointApiFields = function (fields) {
	return {T8: fields.T8, aer: fields.aer};
};
var $author$project$Components$Partner$ManageWebhookEndpoints$partnerWebhookEndpointApiFields = function (fields) {
	return {aer: fields.aer};
};
var $author$project$Components$Partner$ManageWebhookEndpoints$createItem = F3(
	function (apiClient, owner, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		if (!owner) {
			return A3(
				$author$project$Api$Partner$WebhookEndpoint$create,
				apiClient,
				$author$project$Components$Partner$ManageWebhookEndpoints$partnerWebhookEndpointApiFields(fields),
				$author$project$Components$Partner$ManageWebhookEndpoints$Created);
		} else {
			return A3(
				$author$project$Api$Partner$Integration$WebhookEndpoint$create,
				apiClient,
				$author$project$Components$Partner$ManageWebhookEndpoints$integrationWebhookEndpointApiFields(fields),
				$author$project$Components$Partner$ManageWebhookEndpoints$Created);
		}
	});
var $author$project$Components$Partner$ManageWebhookEndpoints$Updated = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Partner$Integration$WebhookEndpoint$update = F4(
	function (apiClient, id, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'webhook_endpoint',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'webhook_url',
								$elm$json$Json$Encode$string(params.aer))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Partner$WebhookEndpoint$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Partner$Integration$WebhookEndpoint$webhookEndpointPath(id))));
	});
var $author$project$Api$Partner$WebhookEndpoint$update = F4(
	function (apiClient, id, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'webhook_endpoint',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'webhook_url',
								$elm$json$Json$Encode$string(params.aer))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Partner$WebhookEndpoint$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Partner$WebhookEndpoint$webhookEndpointPath(id))));
	});
var $author$project$Components$Partner$ManageWebhookEndpoints$updateItem = F4(
	function (apiClient, owner, id, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		if (!owner) {
			return A4(
				$author$project$Api$Partner$WebhookEndpoint$update,
				apiClient,
				id,
				{aer: fields.aer},
				$author$project$Components$Partner$ManageWebhookEndpoints$Updated);
		} else {
			return A4(
				$author$project$Api$Partner$Integration$WebhookEndpoint$update,
				apiClient,
				id,
				{aer: fields.aer},
				$author$project$Components$Partner$ManageWebhookEndpoints$Updated);
		}
	});
var $author$project$Components$Partner$ManageWebhookEndpoints$saveItem = F4(
	function (apiClient, owner, maybeId, formFields) {
		if (!maybeId.$) {
			var id_ = maybeId.a;
			return A4($author$project$Components$Partner$ManageWebhookEndpoints$updateItem, apiClient, owner, id_, formFields);
		} else {
			return A3($author$project$Components$Partner$ManageWebhookEndpoints$createItem, apiClient, owner, formFields);
		}
	});
var $author$project$Components$Partner$ManageWebhookEndpoints$qKey = function (owner) {
	if (!owner) {
		return 'partner_q';
	} else {
		return 'integrations_q';
	}
};
var $author$project$Components$Partner$ManageWebhookEndpoints$updateUrl = function (model) {
	return $author$project$Ports$Navigation$replaceUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Partner__Webhooks__Settings)
				]),
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$map,
							$elm$url$Url$Builder$string(
								$author$project$Components$Partner$ManageWebhookEndpoints$qKey(model.YD)),
							model.akl)
						])),
				_Utils_ap(
					$author$project$Api$Sort$toQuery(model.alA),
					$author$project$Api$Pagination$toPageQuery(model.ajJ)))));
};
var $author$project$Components$Partner$ManageWebhookEndpoints$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ),
								ia: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ia: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{ajJ: pagination, ia: $author$project$Api$Data$Loading});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Partner$ManageWebhookEndpoints$fetchWebhookEndpoints, apiClient, newModel),
								$author$project$Components$Partner$ManageWebhookEndpoints$updateUrl(newModel)
							])),
					_List_Nil);
			case 2:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						alA: A2($author$project$Api$Sort$update, columnId, model.alA),
						ia: $author$project$Api$Data$Loading
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Partner$ManageWebhookEndpoints$fetchWebhookEndpoints, apiClient, newModel),
								$author$project$Components$Partner$ManageWebhookEndpoints$updateUrl(newModel)
							])),
					_List_Nil);
			case 3:
				var _v3 = $author$project$Components$Partner$ManageWebhookEndpoints$formFieldsInit;
				var formFields = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							Io: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init(formFields),
									$author$project$Api$Data$NotAsked))
						}),
					cmd,
					_List_Nil);
			case 4:
				var item = msg.a;
				var _v4 = $author$project$Components$Partner$ManageWebhookEndpoints$formFieldsFromItem(item);
				var formFields = _v4.a;
				var cmd = _v4.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							Io: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(item),
									$author$project$Utils$Form$init(formFields),
									$author$project$Api$Data$NotAsked))
						}),
					cmd,
					_List_Nil);
			case 5:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Io: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 6:
				var field = msg.a;
				var _v5 = model.Io;
				if (!_v5.$) {
					var _v6 = _v5.a;
					var id = _v6.a;
					var form = _v6.b;
					var item = _v6.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Partner$ManageWebhookEndpoints$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Io: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, item))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var item = msg.a;
				var form = msg.b;
				var _v7 = A2(
					$author$project$Utils$Form$validate,
					$author$project$Components$Partner$ManageWebhookEndpoints$formFieldsValidator(model.YD),
					form);
				if (!_v7.$) {
					var _v8 = _v7.a;
					var validatedForm = _v8.a;
					var validFormFields = _v8.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Io: $elm$core$Maybe$Just(
									_Utils_Tuple3(item, validatedForm, $author$project$Api$Data$Loading))
							}),
						A4(
							$author$project$Components$Partner$ManageWebhookEndpoints$saveItem,
							apiClient,
							model.YD,
							A2($elm$core$Maybe$map, $author$project$Api$Partner$WebhookEndpoint$All$id, item),
							validFormFields),
						_List_Nil);
				} else {
					var validatedForm = _v7.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Io: $elm$core$Maybe$Just(
									_Utils_Tuple3(item, validatedForm, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 8:
				var response = msg.a;
				var _v9 = model.Io;
				if (!_v9.$) {
					var _v10 = _v9.a;
					var id = _v10.a;
					var form = _v10.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{Io: $elm$core$Maybe$Nothing, ia: $author$project$Api$Data$Loading}),
							A2($author$project$Components$Partner$ManageWebhookEndpoints$fetchWebhookEndpoints, apiClient, model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Successfully created webhook endpoint'),
									$author$project$OutMsg$RefreshPractice
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									Io: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var response = msg.a;
				var _v12 = model.Io;
				if (!_v12.$) {
					var _v13 = _v12.a;
					var id = _v13.a;
					var form = _v13.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{Io: $elm$core$Maybe$Nothing, ia: $author$project$Api$Data$Loading}),
							A2($author$project$Components$Partner$ManageWebhookEndpoints$fetchWebhookEndpoints, apiClient, model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Successfully updated webhook endpoint')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									Io: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 10:
				var item = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							je: $elm$core$Maybe$Just(item)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 11:
				var item = msg.a;
				var confirmed = msg.b;
				if (confirmed) {
					var id = $author$project$Api$Partner$WebhookEndpoint$All$id(item);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								je: $elm$core$Maybe$Nothing,
								eg: A2($elm$core$Set$insert, id, model.eg)
							}),
						A3($author$project$Components$Partner$ManageWebhookEndpoints$deleteItem, apiClient, model.YD, item),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{je: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 12:
				var item = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									eg: A2(
										$elm$core$Set$remove,
										$author$project$Api$Partner$WebhookEndpoint$All$id(item),
										model.eg),
									ia: $author$project$Api$Data$Loading
								}),
							A2($author$project$Components$Partner$ManageWebhookEndpoints$fetchWebhookEndpoints, apiClient, model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Webhook endpoint was successfully removed.'),
									$author$project$OutMsg$RefreshPractice
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									eg: A2(
										$elm$core$Set$remove,
										$author$project$Api$Partner$WebhookEndpoint$All$id(item),
										model.eg)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 13:
				var subMsg = msg.a;
				var integrationResourceResult = A3($author$project$Components$ResourceFilter$Partner$Integration$update, apiClient, subMsg, model.n_);
				var item = function () {
					var _v16 = _Utils_Tuple2(model.Io, integrationResourceResult.agZ);
					if (!_v16.a.$) {
						if (!_v16.b.$) {
							var _v17 = _v16.a.a;
							var id = _v17.a;
							var form = _v17.b;
							var request = _v17.c;
							var updatedForm = A3(
								$author$project$Utils$Form$update,
								$author$project$Components$Partner$ManageWebhookEndpoints$formFieldsUpdate,
								$author$project$Components$Partner$ManageWebhookEndpoints$IntegrationField(
									$author$project$Components$ResourceFilter$Partner$Integration$value(integrationResourceResult.aiO)),
								form);
							return $elm$core$Maybe$Just(
								_Utils_Tuple3(id, updatedForm, request));
						} else {
							var item_ = _v16.a.a;
							return $elm$core$Maybe$Just(item_);
						}
					} else {
						var _v18 = _v16.a;
						return $elm$core$Maybe$Nothing;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{n_: integrationResourceResult.aiO, Io: item}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Partner$ManageWebhookEndpoints$IntegrationResourceFilterMsg, integrationResourceResult.GZ),
					integrationResourceResult.aR);
			case 14:
				var subMsg = msg.a;
				var _v19 = A2($author$project$Ui$SearchInput$update, subMsg, model.up);
				var searchInput = _v19.a;
				var searchInputCmd = _v19.b;
				var searchInputEvent = _v19.c;
				if (searchInputEvent.$ === 1) {
					var q = searchInputEvent.a;
					var newModel = _Utils_update(
						model,
						{
							ajJ: $author$project$Api$Pagination$reset(model.ajJ),
							akl: q,
							up: searchInput,
							ia: $author$project$Api$Data$Loading
						});
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Partner$ManageWebhookEndpoints$SearchInputMsg, searchInputCmd),
									A2($author$project$Components$Partner$ManageWebhookEndpoints$fetchWebhookEndpoints, apiClient, newModel),
									$author$project$Components$Partner$ManageWebhookEndpoints$updateUrl(newModel)
								])),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{up: searchInput}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Partner$ManageWebhookEndpoints$SearchInputMsg, searchInputCmd),
						_List_Nil);
				}
			case 15:
				var integrationId = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							e4: A2($elm$core$Set$insert, integrationId, model.e4)
						}),
					A3(
						$author$project$Api$Partner$Integration$resetWebhooks,
						apiClient,
						integrationId,
						$author$project$Components$Partner$ManageWebhookEndpoints$ResetWebhooksResponse(integrationId)),
					_List_Nil);
			default:
				var integrationId = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								e4: A2($elm$core$Set$remove, integrationId, model.e4),
								ia: $author$project$Api$Data$Loading
							}),
						A2($author$project$Components$Partner$ManageWebhookEndpoints$fetchWebhookEndpoints, apiClient, model),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Webhook delivery has been reset.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								e4: A2($elm$core$Set$remove, integrationId, model.e4)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Partner$Webhooks$Settings$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_Nil);
var $author$project$Api$Partner$Partner$UnmuteSelfWebhooks = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Partner$Webhooks$Settings$toPermittedFields = F2(
	function (isHintAdmin, fields) {
		return A2(
			$elm$core$List$cons,
			$author$project$Api$Partner$Partner$ListenedEvents(fields.V6),
			A2(
				$elm$core$List$cons,
				$author$project$Api$Partner$Partner$WebhooksPaused(fields.aet),
				A2(
					$elm$core$List$cons,
					$author$project$Api$Partner$Partner$UnmuteSelfWebhooks(fields.adN),
					A2(
						$elm$core$List$cons,
						$author$project$Api$Partner$Partner$MaxRequestPerMinute(fields.WD),
						isHintAdmin ? _List_fromArray(
							[
								$author$project$Api$Partner$Partner$WebhooksDisabled(fields.aes)
							]) : _List_Nil))));
	});
var $author$project$Pages$Partner$Webhooks$Settings$validate = function (model) {
	var _v0 = A2($author$project$Utils$Form$validate, $author$project$Pages$Partner$Webhooks$Settings$formFieldsValidator, model.SD);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var validFormFields = _v1.b;
		var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
		return $elm$core$Result$Ok(
			A2($author$project$Pages$Partner$Webhooks$Settings$toPermittedFields, model.Ij, fields));
	} else {
		var validatedForm = _v0.a;
		return $elm$core$Result$Err(validatedForm);
	}
};
var $author$project$Pages$Partner$Webhooks$Settings$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Partner$Webhooks$Settings$formFieldsUpdate, field, model.SD);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: newForm}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var _v1 = $author$project$Pages$Partner$Webhooks$Settings$validate(model);
				if (!_v1.$) {
					var permittedFields = _v1.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{qP: $author$project$Api$Data$Loading}),
						A3($author$project$Api$Partner$Partner$update, model.Gv, permittedFields, $author$project$Pages$Partner$Webhooks$Settings$GotUpdatedPartner),
						_List_Nil);
				} else {
					var updatedForm = _v1.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{SD: updatedForm, qP: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{qP: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Partner updated successfully!'),
								$author$project$OutMsg$RefreshPartner
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{qP: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 3:
				var subMsg = msg.a;
				var _v3 = A2($author$project$Ui$Dropdown$update, subMsg, model.oq);
				var listenedEventsDropdown = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oq: listenedEventsDropdown}),
					cmd,
					_List_Nil);
			case 4:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Ac: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 5:
				var text = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{AF: text}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 6:
				var subMsg = msg.a;
				var _v4 = A3($author$project$Components$Partner$ManageWebhookEndpoints$update, model.Gv, subMsg, model.ow);
				var manageGlobalWebhookEndpoints = _v4.a;
				var manageGlobalWebhookEndpointsCmd = _v4.b;
				var manageGlobalWebhookEndpointsOutMsgs = _v4.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ow: manageGlobalWebhookEndpoints}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Webhooks$Settings$ManageGlobalWebhookEndpointsMsg, manageGlobalWebhookEndpointsCmd),
					manageGlobalWebhookEndpointsOutMsgs);
			default:
				var subMsg = msg.a;
				var _v5 = A3($author$project$Components$Partner$ManageWebhookEndpoints$update, model.Gv, subMsg, model.oy);
				var manageIntegrationsWebhookEndpoints = _v5.a;
				var manageIntegrationsWebhookEndpointsCmd = _v5.b;
				var manageIntegrationsWebhookEndpointsOutMsgs = _v5.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oy: manageIntegrationsWebhookEndpoints}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Webhooks$Settings$ManageIntegrationWebhookEndpointsMsg, manageIntegrationsWebhookEndpointsCmd),
					manageIntegrationsWebhookEndpointsOutMsgs);
		}
	});
var $author$project$Components$Partner$ManageWebhookEndpoints$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Components$Partner$ManageWebhookEndpoints$New = {$: 3};
var $author$project$Components$Partner$ManageWebhookEndpoints$PaginationMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$ManageWebhookEndpoints$FormUpdated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Partner$ManageWebhookEndpoints$Save = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Components$Partner$ManageWebhookEndpoints$WebhookUrl = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$ManageWebhookEndpoints$viewCreateEditModal = F5(
	function (owner, integrationResourceFilter, item, form, request) {
		var modalConfig = {
			Tq: $elm$core$Maybe$Nothing,
			aih: 'Webhook Endpoint',
			V8: _Utils_eq(request, $author$project$Api$Data$Loading),
			WG: A2($elm$core$Maybe$map, $author$project$Api$Partner$WebhookEndpoint$All$id, item),
			WH: $elm$core$Maybe$Nothing,
			Yd: $author$project$Components$Partner$ManageWebhookEndpoints$CancelEdit,
			Yf: $elm$core$Basics$always(
				A2($author$project$Components$Partner$ManageWebhookEndpoints$Save, item, form))
		};
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					function () {
					if (!owner) {
						return $author$project$Utils$Html$empty;
					} else {
						return A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$labelSpan(4),
									$author$project$Ui$Form$Group$inputSpan(8),
									$author$project$Ui$Form$Group$label('Practice')
								]),
							_List_fromArray(
								[
									function () {
									if (!item.$) {
										var item_ = item.a;
										return A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2(
														$elm$core$Maybe$withDefault,
														'N/A',
														A2(
															$elm$core$Maybe$map,
															$author$project$Api$Partner$Practice$Shared$name,
															A2(
																$elm$core$Maybe$map,
																$author$project$Api$Partner$Integration$Shared$practice,
																$author$project$Api$Partner$WebhookEndpoint$All$integration(item_)))))
												]));
									} else {
										return A2(
											$elm$html$Html$map,
											$author$project$Components$Partner$ManageWebhookEndpoints$IntegrationResourceFilterMsg,
											A2(
												$author$project$Components$ResourceFilter$Partner$Integration$view,
												_List_fromArray(
													[
														$author$project$Components$ResourceFilter$invalid(
														A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
														$author$project$Components$ResourceFilter$errors(
														A2($author$project$Utils$Form$validationErrors, 1, form))
													]),
												integrationResourceFilter));
									}
								}()
								]));
					}
				}(),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Webhook URL')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(fields.aer),
									$author$project$Ui$Form$Input$placeholder('https://your-webhook-url.com'),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$Partner$ManageWebhookEndpoints$FormUpdated, $author$project$Components$Partner$ManageWebhookEndpoints$WebhookUrl)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 0, form))
								]))
						]))
				]));
	});
var $author$project$Components$Partner$ManageWebhookEndpoints$SortTable = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$ManageWebhookEndpoints$columns = function (owner) {
	if (!owner) {
		return _List_fromArray(
			[
				A3($author$project$Api$Column$init, 'webhook_url', true, 'Webhook URL'),
				A3($author$project$Api$Column$init, 'created_at', true, 'Created At'),
				A3($author$project$Api$Column$init, 'last_delivered_at', true, 'Last Delivered At')
			]);
	} else {
		return _List_fromArray(
			[
				A3($author$project$Api$Column$init, 'name', true, 'Practice'),
				A3($author$project$Api$Column$init, 'webhook_url', true, 'Webhook URL'),
				A3($author$project$Api$Column$init, 'created_at', true, 'Created At'),
				A3($author$project$Api$Column$init, 'last_delivered_at', true, 'Last Delivered At'),
				A3($author$project$Api$Column$init, 'status', false, 'Status')
			]);
	}
};
var $author$project$Components$Partner$ManageWebhookEndpoints$Delete = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Partner$ManageWebhookEndpoints$Edit = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Partner$ManageWebhookEndpoints$ResetWebhooks = function (a) {
	return {$: 15, a: a};
};
var $author$project$Api$Partner$WebhookEndpoint$Shared$createdAt = function (_v0) {
	var record = _v0;
	return record.O1;
};
var $author$project$Api$Partner$WebhookEndpoint$All$createdAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$WebhookEndpoint$Shared$createdAt(shared);
};
var $author$project$Api$Partner$WebhookEndpoint$Shared$lastDeliveredAt = function (_v0) {
	var record = _v0;
	return record.VE;
};
var $author$project$Api$Partner$WebhookEndpoint$All$lastDeliveredAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$WebhookEndpoint$Shared$lastDeliveredAt(shared);
};
var $author$project$Api$Partner$Integration$Shared$webhookRequestsFailing = function (_v0) {
	var record = _v0;
	return !_Utils_eq(record.Kq, $elm$core$Maybe$Nothing);
};
var $author$project$Api$Partner$Integration$Shared$webhookRequestsStartedFailingAt = function (_v0) {
	var record = _v0;
	return record.Kq;
};
var $author$project$Components$Partner$ManageWebhookEndpoints$viewWebhookEndpoint = F5(
	function (timeFormatter, owner, deletingItems, resettingIntegrations, webhookEndpoint) {
		var integration = $author$project$Api$Partner$WebhookEndpoint$All$integration(webhookEndpoint);
		var isFailing = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, $author$project$Api$Partner$Integration$Shared$webhookRequestsFailing, integration));
		var maybeIntegrationId = A2($elm$core$Maybe$map, $author$project$Api$Partner$Integration$Shared$id, integration);
		var id = $author$project$Api$Partner$WebhookEndpoint$All$id(webhookEndpoint);
		var loading = A2($elm$core$Set$member, id, deletingItems);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						if (!owner) {
							return _List_Nil;
						} else {
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Table$cell,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'N/A',
												A2(
													$elm$core$Maybe$map,
													$author$project$Api$Partner$Practice$Shared$name,
													A2(
														$elm$core$Maybe$map,
														$author$project$Api$Partner$Integration$Shared$practice,
														$author$project$Api$Partner$WebhookEndpoint$All$integration(webhookEndpoint)))))
										]))
								]);
						}
					}(),
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Partner$WebhookEndpoint$All$webhookUrl(webhookEndpoint))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										timeFormatter,
										0,
										$author$project$Api$Partner$WebhookEndpoint$All$createdAt(webhookEndpoint)))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										A2(
											$elm$core$Maybe$map,
											timeFormatter(0),
											$author$project$Api$Partner$WebhookEndpoint$All$lastDeliveredAt(webhookEndpoint))))
								]))
						]),
						function () {
						if (!owner) {
							return _List_Nil;
						} else {
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Table$cell,
									_List_Nil,
									_List_fromArray(
										[
											function () {
											if (isFailing) {
												var failingSinceText = A2(
													$elm$core$Maybe$withDefault,
													'Paused due to repeated delivery failures',
													A2(
														$elm$core$Maybe$map,
														function (t) {
															return 'Paused since ' + A2(timeFormatter, 0, t);
														},
														A2($elm$core$Maybe$andThen, $author$project$Api$Partner$Integration$Shared$webhookRequestsStartedFailingAt, integration))) + '. Click to learn more.';
												return A3(
													$author$project$Ui$Tooltip$view,
													_List_fromArray(
														[
															$author$project$Ui$Tooltip$placement(0)
														]),
													failingSinceText,
													_List_fromArray(
														[
															A3(
															$author$project$Ui$Link$externalHref,
															'https://developers.hint.com/reference/webhooks#delivery--retries',
															_List_fromArray(
																[$author$project$Ui$Link$targetBlank, $author$project$Ui$Link$sm]),
															_List_fromArray(
																[
																	A2(
																	$author$project$Ui$Badge$view,
																	_List_fromArray(
																		[$author$project$Ui$Badge$danger, $author$project$Ui$Badge$sm]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Paused')
																		]))
																]))
														]));
											} else {
												return A2(
													$author$project$Ui$Badge$view,
													_List_fromArray(
														[$author$project$Ui$Badge$success, $author$project$Ui$Badge$sm]),
													_List_fromArray(
														[
															$elm$html$Html$text('Active')
														]));
											}
										}()
										]))
								]);
						}
					}(),
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_fromArray(
								[$author$project$Ui$Table$textRight]),
							$elm$core$List$concat(
								_List_fromArray(
									[
										function () {
										var _v2 = _Utils_Tuple2(isFailing, maybeIntegrationId);
										if (_v2.a && (!_v2.b.$)) {
											var integrationId = _v2.b.a;
											return _List_fromArray(
												[
													A3(
													$author$project$Ui$Button$view,
													{mm: 'Reset webhook delivery'},
													_List_fromArray(
														[
															$author$project$Ui$Button$link,
															$author$project$Ui$Button$sm,
															$author$project$Ui$Button$loading(
															A2($elm$core$Set$member, integrationId, resettingIntegrations)),
															$author$project$Ui$Button$onClick(
															$author$project$Components$Partner$ManageWebhookEndpoints$ResetWebhooks(integrationId))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Reset')
														]))
												]);
										} else {
											return _List_Nil;
										}
									}(),
										_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{mm: 'Edit webhook endpoint'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$sm,
													$author$project$Ui$Button$onClick(
													$author$project$Components$Partner$ManageWebhookEndpoints$Edit(webhookEndpoint)),
													$author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Edit')
												])),
											A3(
											$author$project$Ui$Button$view,
											{mm: 'Delete webhook endpoint'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$sm,
													$author$project$Ui$Button$loading(loading),
													$author$project$Ui$Button$onClick(
													$author$project$Components$Partner$ManageWebhookEndpoints$Delete(webhookEndpoint)),
													$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Delete')
												]))
										])
									])))
						])
					])));
	});
var $author$project$Components$Partner$ManageWebhookEndpoints$viewTable = function (model) {
	var _v0 = function () {
		var _v1 = model.ia;
		if (_v1.$ === 3) {
			var webhookEndpoints_ = _v1.a;
			return _Utils_Tuple2(false, webhookEndpoints_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var webhookEndpoints = _v0.b;
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any webhook endpoints')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		_Utils_ap(
			A2(
				$elm$core$List$map,
				$author$project$Api$Column$view(
					A2($author$project$Api$Column$Sortable, model.alA, $author$project$Components$Partner$ManageWebhookEndpoints$SortTable)),
				$author$project$Components$Partner$ManageWebhookEndpoints$columns(model.YD)),
			_List_fromArray(
				[
					A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
				])),
		A2(
			$elm$core$List$map,
			A4($author$project$Components$Partner$ManageWebhookEndpoints$viewWebhookEndpoint, model.J7, model.YD, model.eg, model.e4),
			webhookEndpoints),
		_List_Nil);
};
var $author$project$Components$Partner$ManageWebhookEndpoints$view = function (_v0) {
	var model = _v0;
	var loading = function () {
		var _v6 = model.ia;
		if (_v6.$ === 3) {
			return false;
		} else {
			return true;
		}
	}();
	return _List_fromArray(
		[
			function () {
			var _v1 = model.Io;
			if (!_v1.$) {
				var _v2 = _v1.a;
				var item = _v2.a;
				var form = _v2.b;
				var request = _v2.c;
				return A5($author$project$Components$Partner$ManageWebhookEndpoints$viewCreateEditModal, model.YD, model.n_, item, form, request);
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			function () {
			var _v3 = model.je;
			if (!_v3.$) {
				var item = _v3.a;
				return A2(
					$author$project$Components$HiConfirm$modal,
					$author$project$Components$Partner$ManageWebhookEndpoints$HiConfirmClosed(item),
					_List_fromArray(
						[
							$author$project$Components$HiConfirm$verb('delete'),
							$author$project$Components$HiConfirm$noun('webhook endpoint'),
							$author$project$Components$HiConfirm$detail(
							$author$project$Api$Partner$WebhookEndpoint$All$webhookUrl(item))
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
							_List_fromArray(
								[
									$author$project$Ui$Panel$title(
									_List_fromArray(
										[
											function () {
											var _v4 = model.YD;
											if (!_v4) {
												return $elm$html$Html$text('Partner Webhook Endpoints');
											} else {
												return $elm$html$Html$text('Practices Webhook Endpoints');
											}
										}()
										])),
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Add new webhook endpoint'},
									_List_fromArray(
										[
											$author$project$Ui$Button$default,
											$author$project$Ui$Button$onClick($author$project$Components$Partner$ManageWebhookEndpoints$New),
											$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('New Webhook Endpoint')
										]))
								])),
							function () {
							var _v5 = model.YD;
							if (!_v5) {
								return $author$project$Utils$Html$empty;
							} else {
								return A2(
									$elm$html$Html$map,
									$author$project$Components$Partner$ManageWebhookEndpoints$SearchInputMsg,
									A2(
										$author$project$Ui$SearchInput$view,
										_List_fromArray(
											[
												$author$project$Ui$SearchInput$placeholder('Search by practice name')
											]),
										model.up));
							}
						}()
						])),
					$author$project$Components$Partner$ManageWebhookEndpoints$viewTable(model),
					A2(
					$author$project$Ui$Panel$footer,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Components$Partner$ManageWebhookEndpoints$PaginationMsg,
							A2(
								$author$project$Api$Pagination$view,
								_List_fromArray(
									[
										$author$project$Ui$Pagination$List$loading(loading)
									]),
								model.ajJ))
						]))
				]))
		]);
};
var $author$project$Pages$Partner$Webhooks$Settings$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Partner$Webhooks$Settings$MaxRequestsPperMinute = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Partner$Webhooks$Settings$Save = {$: 1};
var $author$project$Pages$Partner$Webhooks$Settings$UnmuteSelfWebhooks = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Partner$Webhooks$Settings$WebhooksDisabled = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Partner$Webhooks$Settings$WebhooksPaused = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Dropdown$Secondary = 0;
var $author$project$Ui$Dropdown$buttonSecondary = $author$project$Ui$Dropdown$Button(0);
var $elm_community$list_extra$List$Extra$isSubsequenceOf = F2(
	function (subseq, list) {
		isSubsequenceOf:
		while (true) {
			var _v0 = _Utils_Tuple2(subseq, list);
			if (!_v0.a.b) {
				return true;
			} else {
				if (!_v0.b.b) {
					return false;
				} else {
					var _v1 = _v0.a;
					var x = _v1.a;
					var xs = _v1.b;
					var _v2 = _v0.b;
					var y = _v2.a;
					var ys = _v2.b;
					if (_Utils_eq(x, y)) {
						var $temp$subseq = xs,
							$temp$list = ys;
						subseq = $temp$subseq;
						list = $temp$list;
						continue isSubsequenceOf;
					} else {
						var $temp$subseq = subseq,
							$temp$list = ys;
						subseq = $temp$subseq;
						list = $temp$list;
						continue isSubsequenceOf;
					}
				}
			}
		}
	});
var $author$project$Pages$Partner$Webhooks$Settings$ListenedEventFieldAll = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Partner$Webhooks$Settings$ListenedEventFieldNone = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Partner$Webhooks$Settings$ListenedEventFieldOne = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Partner$Webhooks$Settings$ListenedEvents = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Partner$Webhooks$Settings$ListenedEventsSearched = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Dropdown$Item$Indented = {$: 13};
var $author$project$Ui$Dropdown$indented = $author$project$Ui$Dropdown$Item$Indented;
var $elm$core$List$sort = function (xs) {
	return A2($elm$core$List$sortBy, $elm$core$Basics$identity, xs);
};
var $author$project$Pages$Partner$Webhooks$Settings$listenedEventsOptions = F3(
	function (availableListenedEvents, listenedEventsSearch, checkedListenedEvents) {
		var contains = function (availableListenedEvent) {
			return A2(
				$elm$core$String$contains,
				$elm$core$String$toLower(listenedEventsSearch),
				$elm$core$String$toLower(availableListenedEvent));
		};
		var filteredAvailableListenedEvents = A2($elm$core$List$filter, contains, availableListenedEvents);
		var resources = $elm$core$List$sort(
			$elm_community$list_extra$List$Extra$unique(
				A2(
					$elm$core$List$filterMap,
					$elm$core$List$head,
					A2(
						$elm$core$List$map,
						$elm$core$String$split('.'),
						filteredAvailableListenedEvents))));
		return A2(
			$elm$core$List$cons,
			$author$project$Ui$Dropdown$input(
				_List_fromArray(
					[
						$author$project$Ui$Dropdown$onInput($author$project$Pages$Partner$Webhooks$Settings$ListenedEventsSearched),
						$author$project$Ui$Dropdown$value(listenedEventsSearch),
						$author$project$Ui$Dropdown$placeholder('Search...')
					])),
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Ui$Dropdown$checkbox,
					_List_fromArray(
						[
							$author$project$Ui$Dropdown$onCheck(
							A2(
								$elm$core$Basics$composeL,
								$author$project$Pages$Partner$Webhooks$Settings$FormUpdated,
								$author$project$Pages$Partner$Webhooks$Settings$ListenedEvents(
									$author$project$Pages$Partner$Webhooks$Settings$ListenedEventFieldAll(availableListenedEvents)))),
							$author$project$Ui$Dropdown$checked(
							_Utils_eq(
								$elm$core$List$length(checkedListenedEvents),
								$elm$core$List$length(availableListenedEvents)))
						]),
					$elm$html$Html$text('All')),
				A2(
					$elm$core$List$cons,
					A2(
						$author$project$Ui$Dropdown$checkbox,
						_List_fromArray(
							[
								$author$project$Ui$Dropdown$onCheck(
								A2(
									$elm$core$Basics$composeL,
									$author$project$Pages$Partner$Webhooks$Settings$FormUpdated,
									$author$project$Pages$Partner$Webhooks$Settings$ListenedEvents(
										$author$project$Pages$Partner$Webhooks$Settings$ListenedEventFieldNone(availableListenedEvents)))),
								$author$project$Ui$Dropdown$checked(
								$elm$core$List$isEmpty(checkedListenedEvents))
							]),
						$elm$html$Html$text('None')),
					A2(
						$elm$core$List$cons,
						$author$project$Ui$Dropdown$separator,
						A2(
							$elm$core$List$concatMap,
							function (resource) {
								var resourceEvents = A2(
									$elm$core$List$filter,
									$elm$core$String$startsWith(resource),
									filteredAvailableListenedEvents);
								return A2(
									$elm$core$List$map,
									function (listenedEvent) {
										var formFieldValue = A2($elm$core$String$endsWith, '*', listenedEvent) ? $author$project$Pages$Partner$Webhooks$Settings$ListenedEventFieldOne(resourceEvents) : $author$project$Pages$Partner$Webhooks$Settings$ListenedEventFieldOne(
											_List_fromArray(
												[listenedEvent]));
										var checked = A2($elm$core$String$endsWith, '*', listenedEvent) ? A2($elm_community$list_extra$List$Extra$isSubsequenceOf, resourceEvents, checkedListenedEvents) : A2($elm$core$List$member, listenedEvent, checkedListenedEvents);
										var checkboxOptions = A2(
											$elm$core$List$cons,
											$author$project$Ui$Dropdown$onCheck(
												A2(
													$elm$core$Basics$composeL,
													$author$project$Pages$Partner$Webhooks$Settings$FormUpdated,
													$author$project$Pages$Partner$Webhooks$Settings$ListenedEvents(formFieldValue))),
											A2(
												$elm$core$List$cons,
												$author$project$Ui$Dropdown$checked(checked),
												A2($elm$core$String$endsWith, '*', listenedEvent) ? _List_Nil : _List_fromArray(
													[$author$project$Ui$Dropdown$indented])));
										return A2(
											$author$project$Ui$Dropdown$checkbox,
											checkboxOptions,
											$elm$html$Html$text(listenedEvent));
									},
									A2($elm$core$List$cons, resource + '.*', resourceEvents));
							},
							resources)))));
	});
var $author$project$Ui$Dropdown$Loading = function (a) {
	return {$: 8, a: a};
};
var $author$project$Ui$Dropdown$loading = $author$project$Ui$Dropdown$Loading;
var $author$project$Pages$Partner$Webhooks$Settings$viewSettings = function (model) {
	var fields = $author$project$Utils$Form$fields(model.SD);
	var _v0 = function () {
		var _v1 = model.Ac;
		if (_v1.$ === 3) {
			var avaialbleListenedEvents_ = _v1.a;
			return _Utils_Tuple2(false, avaialbleListenedEvents_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var avaialbleListenedEventsLoading = _v0.a;
	var avaialbleListenedEvents = _v0.b;
	return A2(
		$author$project$Ui$Form$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$autocomplete(false),
				$author$project$Ui$Form$noValidate(true),
				$author$project$Ui$Form$onSubmit($author$project$Pages$Partner$Webhooks$Settings$Save)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Settings')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								model.Ij ? A2(
								$author$project$Ui$HinterOnly$formGroup,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$labelSpanSm(4),
										$author$project$Ui$Form$Group$inputSpan(8),
										$author$project$Ui$Form$Group$label('Webhooks Disabled')
									]),
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$view(
										_List_fromArray(
											[
												$author$project$Ui$ToggleSwitch$on(fields.aes),
												$author$project$Ui$ToggleSwitch$onChange(
												A2($elm$core$Basics$composeL, $author$project$Pages$Partner$Webhooks$Settings$FormUpdated, $author$project$Pages$Partner$Webhooks$Settings$WebhooksDisabled))
											]))
									])) : $author$project$Utils$Html$empty,
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$labelSpanSm(4),
										$author$project$Ui$Form$Group$inputSpan(8),
										$author$project$Ui$Form$Group$label('Webhooks Paused')
									]),
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$view(
										_List_fromArray(
											[
												$author$project$Ui$ToggleSwitch$on(fields.aet),
												$author$project$Ui$ToggleSwitch$onChange(
												A2($elm$core$Basics$composeL, $author$project$Pages$Partner$Webhooks$Settings$FormUpdated, $author$project$Pages$Partner$Webhooks$Settings$WebhooksPaused))
											]))
									])),
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$labelSpanSm(4),
										$author$project$Ui$Form$Group$inputSpan(8),
										$author$project$Ui$Form$Group$label('Unmute Self Webhooks')
									]),
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$view(
										_List_fromArray(
											[
												$author$project$Ui$ToggleSwitch$on(fields.adN),
												$author$project$Ui$ToggleSwitch$onChange(
												A2($elm$core$Basics$composeL, $author$project$Pages$Partner$Webhooks$Settings$FormUpdated, $author$project$Pages$Partner$Webhooks$Settings$UnmuteSelfWebhooks))
											]))
									])),
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$labelSpanSm(4),
										$author$project$Ui$Form$Group$inputSpan(8),
										$author$project$Ui$Form$Group$label('Max Requests per Minute')
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$value(
												A2(
													$elm$core$Maybe$withDefault,
													'',
													A2($elm$core$Maybe$map, $elm$core$String$fromInt, fields.WD))),
												$author$project$Ui$Form$Input$number,
												$author$project$Ui$Form$Input$onInput(
												A2($elm$core$Basics$composeL, $author$project$Pages$Partner$Webhooks$Settings$FormUpdated, $author$project$Pages$Partner$Webhooks$Settings$MaxRequestsPperMinute))
											]))
									])),
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$labelSpanSm(4),
										$author$project$Ui$Form$Group$inputSpan(8),
										$author$project$Ui$Form$Group$label('Listened Events')
									]),
								_List_fromArray(
									[
										A4(
										$author$project$Ui$Dropdown$view,
										_List_fromArray(
											[
												$author$project$Ui$Dropdown$buttonSecondary,
												$author$project$Ui$Dropdown$loading(avaialbleListenedEventsLoading)
											]),
										_List_fromArray(
											[
												function () {
												if ($elm$core$List$isEmpty(fields.V6)) {
													return $elm$html$Html$text('None');
												} else {
													if (_Utils_eq(
														$elm$core$List$length(avaialbleListenedEvents),
														$elm$core$List$length(fields.V6))) {
														return $elm$html$Html$text('All');
													} else {
														var selectedResources = $elm$core$List$sort(
															A2(
																$elm$core$List$filter,
																function (resource) {
																	var selectedResourceEvents = $elm$core$List$sort(
																		A2(
																			$elm$core$List$filter,
																			$elm$core$String$startsWith(resource),
																			fields.V6));
																	var avaialbleResourceEvents = $elm$core$List$sort(
																		A2(
																			$elm$core$List$filter,
																			$elm$core$String$startsWith(resource),
																			avaialbleListenedEvents));
																	return A2($elm_community$list_extra$List$Extra$isSubsequenceOf, avaialbleResourceEvents, selectedResourceEvents);
																},
																$elm_community$list_extra$List$Extra$unique(
																	A2(
																		$elm$core$List$filterMap,
																		$elm$core$List$head,
																		A2(
																			$elm$core$List$map,
																			$elm$core$String$split('.'),
																			avaialbleListenedEvents)))));
														var selectedListenedEvents = $elm$core$List$sort(
															$elm$core$List$concat(
																_List_fromArray(
																	[
																		A2(
																		$elm$core$List$map,
																		function (resource) {
																			return resource + '.*';
																		},
																		selectedResources),
																		A2(
																		$elm_community$list_extra$List$Extra$filterNot,
																		function (listenedEvent) {
																			return A2(
																				$elm$core$List$any,
																				function (resource) {
																					return A2($elm$core$String$startsWith, resource, listenedEvent);
																				},
																				selectedResources);
																		},
																		fields.V6)
																	])));
														return $elm$html$Html$text(
															A2($elm$core$String$join, ', ', selectedListenedEvents));
													}
												}
											}()
											]),
										A3($author$project$Pages$Partner$Webhooks$Settings$listenedEventsOptions, avaialbleListenedEvents, model.AF, fields.V6),
										model.oq)
									]))
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_fromArray(
							[$author$project$Ui$Element$textCenter]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Save partner changes'},
								_List_fromArray(
									[
										$author$project$Ui$Button$primary,
										$author$project$Ui$Button$submit,
										$author$project$Ui$Button$loading(
										_Utils_eq(model.qP, $author$project$Api$Data$Loading))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Save')
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Partner$Webhooks$Settings$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(12)
							]),
						_List_fromArray(
							[
								$author$project$Pages$Partner$Webhooks$Settings$viewSettings(model)
							]))
					])),
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(12)
							]),
						A2(
							$elm$core$List$map,
							$elm$html$Html$map($author$project$Pages$Partner$Webhooks$Settings$ManageGlobalWebhookEndpointsMsg),
							$author$project$Components$Partner$ManageWebhookEndpoints$view(model.ow))),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(12)
							]),
						A2(
							$elm$core$List$map,
							$elm$html$Html$map($author$project$Pages$Partner$Webhooks$Settings$ManageIntegrationWebhookEndpointsMsg),
							$author$project$Components$Partner$ManageWebhookEndpoints$view(model.oy)))
					]))
			]),
		ac9: 'Partner | Webhook Settings'
	};
};
var $author$project$Pages$Partner$Webhooks$Settings$page = $author$project$Spa$Page$applicationPartner(
	{ah_: $author$project$Pages$Partner$Webhooks$Settings$init, aiq: $author$project$Pages$Partner$Webhooks$Settings$load, k8: $author$project$Pages$Partner$Webhooks$Settings$save, alO: $author$project$Pages$Partner$Webhooks$Settings$subscriptions, adT: $author$project$Pages$Partner$Webhooks$Settings$update, amo: $author$project$Pages$Partner$Webhooks$Settings$view});
var $author$project$Pages$Patients$Create$FormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Patients$Create$GotWaitlistEntry = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Practice$One$accountType = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.KJ;
	});
var $author$project$Api$Provider$Practice$One$isMce = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$accountType,
	$elm$core$Basics$eq(2));
var $author$project$Api$Provider$WaitlistEntry$retrieve = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$WaitlistEntry$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$WaitlistEntry$waitlistEntryPath(id_)));
	});
var $author$project$Pages$Patients$Create$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.DE;
		var waitlistEntryId = A2($elm$core$Dict$get, 'waitlist_entry_id', query);
		var fetchWaitlistCmd = function () {
			if (!waitlistEntryId.$) {
				var entryId = waitlistEntryId.a;
				return A3($author$project$Api$Provider$WaitlistEntry$retrieve, shared.Gv, entryId, $author$project$Pages$Patients$Create$GotWaitlistEntry);
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		}();
		var _v1 = A6(
			$author$project$Components$Patient$Form$empty,
			shared.Gv,
			session,
			shared.dd,
			$elm$core$Maybe$Nothing,
			false,
			function (settings) {
				return _Utils_update(
					settings,
					{
						afg: $author$project$Api$Provider$Practice$One$labelBillingAsShipping(practice),
						afn: A2($author$project$Api$Provider$Practice$One$featureEnabled, 3, practice),
						Tb: $author$project$Api$Provider$Practice$One$hasLocations(practice),
						Th: $author$project$Api$Provider$Practice$One$hasPractitioners(practice),
						aiC: $author$project$Api$Provider$Practice$One$isMce(practice),
						tc: A2($author$project$Api$Provider$Practice$One$featureEnabled, 10, practice),
						akV: $author$project$Api$Provider$Practice$One$requiresPatientEmail(practice),
						$G: $author$project$Api$Provider$Practice$One$requiresLocation(practice),
						akW: $author$project$Api$Provider$Practice$One$requiresPatientMobile(practice),
						$M: $author$project$Api$Provider$Practice$One$requiresPractitioner(practice),
						$N: $author$project$Api$Provider$Practice$One$requiresSSN(practice),
						ab6: $author$project$Api$Provider$Practice$One$ssnEnabled(practice),
						acI: A2(
							$elm$core$Maybe$withDefault,
							false,
							A2(
								$elm$core$Maybe$map,
								$author$project$Api$Provider$Network$Shared$syncByAffiliation,
								$author$project$Api$Provider$Practice$One$network(practice))),
						al8: A2($author$project$Api$Provider$Practice$One$featureEnabled, 2, practice),
						adt: $author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice),
						adv: $author$project$Api$Provider$Practice$One$transInclusivity(practice),
						F1: A3($author$project$Permission$canGoTo, session, shared.ahK, 0)
					});
			});
		var form = _v1.a;
		var formCmd = _v1.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, SD: form, ZV: practice, aa4: session, lA: false, vq: waitlistEntryId},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$Create$FormMsg, formCmd),
						fetchWaitlistCmd
					])));
	});
var $author$project$Pages$Patients$Create$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Patients$Create$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Patients$Create$subscriptions = function (_v0) {
	var form = _v0.SD;
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$Patients$Create$FormMsg,
		$author$project$Components$Patient$Form$subscriptions(form));
};
var $author$project$Pages$Patients$Create$PatientCreated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$Patient$create = F3(
	function (apiClient, jsonBody, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Patient$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				jsonBody,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Patient$patientsPath)));
	});
var $author$project$Api$Provider$WaitlistEntry$One$email = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$WaitlistEntry$Shared$email(shared);
};
var $author$project$Components$Patient$Form$encode = F2(
	function (validFields, form) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					A2($author$project$Components$Patient$Form$encodePatient, validFields, form)
				]));
	});
var $author$project$Components$Patient$Form$fillFromWaitlist = F2(
	function (entry, _v0) {
		var settings = _v0.a;
		var form = _v0.b;
		var updatedLegalName = $author$project$Components$NameInput$init(
			{Sv: entry.Sv, VH: entry.VH, W7: '', acE: $elm$core$Maybe$Nothing, ac9: ''});
		var fields = $author$project$Utils$Form$fields(form);
		var updatedPhones = function () {
			var _v1 = entry.Zw;
			if (!_v1.$) {
				var phoneNumber = _v1.a;
				return A2(
					$author$project$Components$PhoneInput$require,
					settings.akW,
					A3(
						$author$project$Components$PhoneInput$init,
						'patient-phones',
						_List_fromArray(
							[
								A3($author$project$Components$PhoneInput$initPhone, $author$project$Api$Common$Phone$Shared$Mobile, 0, phoneNumber)
							]),
						function (d) {
							return _Utils_update(
								d,
								{Gh: true});
						}));
			} else {
				return fields.Zy;
			}
		}();
		var updatedFields = _Utils_update(
			fields,
			{Rj: entry.Rj, VU: updatedLegalName, Zy: updatedPhones});
		return A2(
			$author$project$Components$Patient$Form$PatientForm,
			settings,
			A2($author$project$Utils$Form$set, updatedFields, form));
	});
var $author$project$Api$Provider$WaitlistEntry$One$firstName = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$WaitlistEntry$Shared$firstName(shared);
};
var $author$project$Api$Provider$WaitlistEntry$One$lastName = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$WaitlistEntry$Shared$lastName(shared);
};
var $author$project$Api$Provider$WaitlistEntry$One$phone = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$WaitlistEntry$Shared$phone(shared);
};
var $author$project$Pages$Patients$Create$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 1:
				var _v1 = $author$project$Components$Patient$Form$validate(model.SD);
				if (!_v1.$) {
					var _v2 = _v1.a;
					var validForm = _v2.a;
					var validFields = _v2.b;
					var body = function () {
						var _v3 = model.vq;
						if (!_v3.$) {
							var entryId = _v3.a;
							return $elm$json$Json$Encode$object(
								_List_fromArray(
									[
										A2($author$project$Components$Patient$Form$encodePatient, validFields, validForm),
										_Utils_Tuple2(
										'waitlist_entry_id',
										$elm$json$Json$Encode$string(entryId))
									]));
						} else {
							return A2($author$project$Components$Patient$Form$encode, validFields, validForm);
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{lA: true}),
						A3($author$project$Api$Provider$Patient$create, model.Gv, body, $author$project$Pages$Patients$Create$PatientCreated),
						_List_Nil);
				} else {
					var erroredForm = _v1.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{SD: erroredForm}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 0:
				var formMsg = msg.a;
				var _v4 = A5($author$project$Components$Patient$Form$update, model.Gv, model.aa4, $elm$core$Maybe$Nothing, formMsg, model.SD);
				var form = _v4.a;
				var formCmd = _v4.b;
				var formOutMsgs = _v4.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: form}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$Create$FormMsg, formCmd),
					formOutMsgs);
			case 2:
				var response = msg.a;
				switch (response.$) {
					case 3:
						var patient = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{lA: false}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2(
										$author$project$Utils$Route$navigate,
										$elm$core$Dict$empty,
										$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
											{
												YZ: $author$project$Api$Provider$Patient$One$id(patient)
											})),
										A2(
										$elm$core$Platform$Cmd$map,
										$author$project$Pages$Patients$Create$FormMsg,
										A5(
											$author$project$Components$Patient$Form$createAffiliation,
											model.Gv,
											model.aa4,
											$author$project$Api$Provider$Patient$One$id(patient),
											$elm$core$Maybe$Nothing,
											model.SD).GZ)
									])),
							_List_Nil);
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{lA: false}),
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error)),
								$author$project$OutMsg$reportDecodeError(response)));
					default:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{lA: false}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var entry = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								SD: A2(
									$author$project$Components$Patient$Form$fillFromWaitlist,
									{
										Rj: $author$project$Api$Provider$WaitlistEntry$One$email(entry),
										Sv: $author$project$Api$Provider$WaitlistEntry$One$firstName(entry),
										VH: $author$project$Api$Provider$WaitlistEntry$One$lastName(entry),
										Zw: $author$project$Api$Provider$WaitlistEntry$One$phone(entry)
									},
									model.SD)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Patients$Create$FormSubmitted = {$: 1};
var $author$project$Pages$Patients$Create$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('md:ml-8')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$noValidate(true),
								$author$project$Ui$Form$autocomplete(false),
								$author$project$Ui$Form$onSubmit($author$project$Pages$Patients$Create$FormSubmitted)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Panel$heading,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Ui$Panel$title(
												_List_fromArray(
													[
														$elm$html$Html$text(
														(!_Utils_eq(model.vq, $elm$core$Maybe$Nothing)) ? 'Enroll from Waitlist' : 'Create New Patient')
													]))
											])),
										A2(
										$author$project$Ui$Panel$body,
										_List_Nil,
										A2(
											$elm$core$List$map,
											$elm$html$Html$map($author$project$Pages$Patients$Create$FormMsg),
											$author$project$Components$Patient$Form$view(model.SD))),
										A2(
										$author$project$Ui$Panel$footer,
										_List_fromArray(
											[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$gap2]),
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Link$route,
												$author$project$Spa$Generated$Route$Patients__Top,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Cancel')
													])),
												A3(
												$author$project$Ui$Button$view,
												{mm: 'Create new patient'},
												_List_fromArray(
													[
														$author$project$Ui$Button$primary,
														$author$project$Ui$Button$submit,
														$author$project$Ui$Button$loading(model.lA)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														(!_Utils_eq(model.vq, $elm$core$Maybe$Nothing)) ? 'Enroll' : 'Create')
													]))
											]))
									]))
							]))
					]))
			]),
		ac9: 'Patients'
	};
};
var $author$project$Pages$Patients$Create$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Patients$Create$init, aiq: $author$project$Pages$Patients$Create$load, k8: $author$project$Pages$Patients$Create$save, alO: $author$project$Pages$Patients$Create$subscriptions, adT: $author$project$Pages$Patients$Create$update, amo: $author$project$Pages$Patients$Create$view});
var $author$project$OutMsg$InitializePatientsList = function (a) {
	return {$: 11, a: a};
};
var $author$project$Spa$Page$applicationPatient = function (page) {
	return {
		ah_: F2(
			function (shared, url) {
				var _v0 = _Utils_Tuple3(shared.aa4, shared.ZV, shared.G9);
				_v0$5:
				while (true) {
					_v0$6:
					while (true) {
						_v0$7:
						while (true) {
							switch (_v0.a.$) {
								case 3:
									switch (_v0.b.$) {
										case 3:
											if (!_v0.b.a.$) {
												switch (_v0.c.$) {
													case 0:
														var _v1 = _v0.a;
														var _v2 = _v0.b;
														var _v3 = _v0.c;
														return _Utils_Tuple3(
															$author$project$Spa$Page$SessionLoading(url),
															$elm$core$Platform$Cmd$none,
															_List_fromArray(
																[
																	$author$project$OutMsg$RetrievePatient(url.YL.YZ),
																	$author$project$OutMsg$InitializePatientsList(url.DE)
																]));
													case 3:
														var _v4 = _v0.a;
														var session = _v4.a;
														var _v5 = _v0.b;
														var practice = _v5.a.a;
														var _v6 = _v0.c;
														var patient = _v6.a;
														return (!A3($author$project$Spa$Page$authorizeUrl, session, shared.ahK, shared.adY)) ? _Utils_Tuple3(
															$author$project$Spa$Page$SessionLoading(url),
															A2(
																$author$project$Utils$Route$navigate,
																$elm$core$Dict$empty,
																A2($author$project$Permission$homeStateFor, session, shared.ahK)),
															_List_Nil) : ((!_Utils_eq(
															url.YL.YZ,
															$author$project$Api$Provider$Patient$One$id(patient))) ? _Utils_Tuple3(
															$author$project$Spa$Page$SessionLoading(url),
															$elm$core$Platform$Cmd$none,
															_List_fromArray(
																[
																	$author$project$OutMsg$RetrievePatient(url.YL.YZ),
																	$author$project$OutMsg$InitializePatientsList(url.DE)
																])) : A2(
															$author$project$Utils$Tuple3$mapFirst,
															$author$project$Spa$Page$SessionLoaded,
															A2(
																$author$project$Utils$Tuple3$fromTuple2,
																_List_Nil,
																A5(page.ah_, session, practice, patient, shared, url))));
													case 2:
														break _v0$6;
													default:
														break _v0$7;
												}
											} else {
												var _v7 = _v0.a;
												var session = _v7.a;
												var _v8 = _v0.b;
												return _Utils_Tuple3(
													$author$project$Spa$Page$SessionLoading(url),
													A2(
														$author$project$Utils$Route$navigate,
														$elm$core$Dict$empty,
														A2($author$project$Permission$homeStateFor, session, shared.ahK)),
													_List_Nil);
											}
										case 2:
											break _v0$5;
										default:
											if (_v0.c.$ === 2) {
												break _v0$6;
											} else {
												break _v0$7;
											}
									}
								case 2:
									return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
								case 0:
									var _v9 = _v0.a;
									return _Utils_Tuple3(
										$author$project$Spa$Page$SessionLoading(url),
										$author$project$Ports$Session$authorize(
											{aku: true}),
										_List_Nil);
								default:
									if (_v0.b.$ === 2) {
										break _v0$5;
									} else {
										if (_v0.c.$ === 2) {
											break _v0$6;
										} else {
											break _v0$7;
										}
									}
							}
						}
						return _Utils_Tuple3(
							$author$project$Spa$Page$SessionLoading(url),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
					return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
				}
				return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
			}),
		aiq: F2(
			function (shared, model) {
				var _v10 = _Utils_Tuple3(shared.aa4, shared.ZV, shared.G9);
				_v10$4:
				while (true) {
					_v10$5:
					while (true) {
						switch (_v10.a.$) {
							case 3:
								switch (_v10.b.$) {
									case 3:
										if (!_v10.b.a.$) {
											switch (_v10.c.$) {
												case 0:
													var _v11 = _v10.a;
													var _v12 = _v10.b;
													var _v13 = _v10.c;
													if (!model.$) {
														var url = model.a;
														var _v15 = url;
														var params = _v15.YL;
														var query = _v15.DE;
														return _Utils_Tuple3(
															model,
															$elm$core$Platform$Cmd$none,
															_List_fromArray(
																[
																	$author$project$OutMsg$RetrievePatient(params.YZ),
																	$author$project$OutMsg$InitializePatientsList(query)
																]));
													} else {
														return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
													}
												case 3:
													var _v16 = _v10.a;
													var session = _v16.a;
													var _v17 = _v10.b;
													var practice = _v17.a.a;
													var _v18 = _v10.c;
													var patient = _v18.a;
													switch (model.$) {
														case 0:
															var url = model.a;
															if (!A3($author$project$Spa$Page$authorizeUrl, session, shared.ahK, shared.adY)) {
																return _Utils_Tuple3(
																	$author$project$Spa$Page$SessionLoading(url),
																	A2(
																		$author$project$Utils$Route$navigate,
																		$elm$core$Dict$empty,
																		A2($author$project$Permission$homeStateFor, session, shared.ahK)),
																	_List_Nil);
															} else {
																var _v20 = A5(page.ah_, session, practice, patient, shared, url);
																var pageModel = _v20.a;
																var cmd = _v20.b;
																return _Utils_Tuple3(
																	$author$project$Spa$Page$SessionLoaded(pageModel),
																	cmd,
																	_List_Nil);
															}
														case 1:
															var modelWithSession = model.a;
															return A2(
																$author$project$Utils$Tuple3$fromTuple2,
																_List_Nil,
																A2(
																	$elm$core$Tuple$mapFirst,
																	$author$project$Spa$Page$SessionLoaded,
																	A2(
																		page.aiq,
																		shared,
																		_Utils_update(
																			modelWithSession,
																			{Gv: shared.Gv}))));
														default:
															return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
													}
												default:
													break _v10$5;
											}
										} else {
											var _v21 = _v10.a;
											var session = _v21.a;
											var _v22 = _v10.b;
											return _Utils_Tuple3(
												model,
												A2(
													$author$project$Utils$Route$navigate,
													$elm$core$Dict$empty,
													A2($author$project$Permission$homeStateFor, session, shared.ahK)),
												_List_Nil);
										}
									case 2:
										break _v10$4;
									default:
										break _v10$5;
								}
							case 2:
								return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
							default:
								if (_v10.b.$ === 2) {
									break _v10$4;
								} else {
									break _v10$5;
								}
						}
					}
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
				return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
			}),
		k8: F2(
			function (model, shared) {
				if (model.$ === 1) {
					var modelWithSession = model.a;
					return A2(page.k8, modelWithSession, shared);
				} else {
					return shared;
				}
			}),
		alO: function (model) {
			if (model.$ === 1) {
				var modelWithSession = model.a;
				return page.alO(modelWithSession);
			} else {
				return $elm$core$Platform$Sub$none;
			}
		},
		adT: F2(
			function (msg, model) {
				if (model.$ === 1) {
					var modelWithSession = model.a;
					return A2(
						$author$project$Utils$Tuple3$mapFirst,
						$author$project$Spa$Page$SessionLoaded,
						A2(page.adT, msg, modelWithSession));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			}),
		amo: function (model) {
			if (model.$ === 1) {
				var modelWithSession = model.a;
				return page.amo(modelWithSession);
			} else {
				return {fO: $author$project$Components$BlankPage$view, ac9: 'Loading...'};
			}
		}
	};
};
var $author$project$Pages$Patients$PatientId_String$Accounts$Top$PaymentSourcesMsg = $elm$core$Basics$identity;
var $author$project$Pages$Patients$PatientId_String$Accounts$Top$init = F5(
	function (session, practice, patient, shared, _v0) {
		var _v1 = A4(
			$author$project$Components$PaymentSources$init,
			$author$project$Components$PaymentSources$Patient(patient),
			session,
			$author$project$Api$Practice$Provider(practice),
			shared);
		var paymentSources = _v1.a;
		var paymentSourcesCmd = _v1.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, YY: patient, hb: paymentSources, ZV: practice, aa4: session},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, paymentSourcesCmd));
	});
var $author$project$Pages$Patients$PatientId_String$Accounts$Top$load = F2(
	function (shared, model) {
		var _v0 = shared.ZV;
		if ((_v0.$ === 3) && (!_v0.a.$)) {
			var practice = _v0.a.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						hb: A2(
							$author$project$Components$PaymentSources$setPractice,
							$author$project$Api$Practice$Provider(practice),
							model.hb),
						ZV: practice
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Patients$PatientId_String$Accounts$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Patients$PatientId_String$Accounts$Top$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$PaymentSources$subscriptions(model.hb));
};
var $author$project$Pages$Patients$PatientId_String$Accounts$Top$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$PaymentSources$update, model.Gv, subMsg, model.hb);
		var paymentSources = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{hb: paymentSources}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Pages$Patients$PatientId_String$Accounts$Top$view = function (model) {
	return {
		fO: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			$author$project$Components$PaymentSources$view(model.hb)),
		ac9: 'Patient | Payment Methods'
	};
};
var $author$project$Pages$Patients$PatientId_String$Accounts$Top$page = $author$project$Spa$Page$applicationPatient(
	{ah_: $author$project$Pages$Patients$PatientId_String$Accounts$Top$init, aiq: $author$project$Pages$Patients$PatientId_String$Accounts$Top$load, k8: $author$project$Pages$Patients$PatientId_String$Accounts$Top$save, alO: $author$project$Pages$Patients$PatientId_String$Accounts$Top$subscriptions, adT: $author$project$Pages$Patients$PatientId_String$Accounts$Top$update, amo: $author$project$Pages$Patients$PatientId_String$Accounts$Top$view});
var $author$project$Api$Provider$SyncDetail$AdditionalDetails = 0;
var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$GotAffiliateSyncDetail = $elm$core$Basics$identity;
var $author$project$Api$Provider$Patient$SyncDetail$Affiliate = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Api$Provider$Patient$SyncDetail$Record = function (enrollmentStatus) {
	return function (syncStatus) {
		return function (completedAt) {
			return function (startedAt) {
				return function (errorMessage) {
					return function (coveragePlan) {
						return function (coverageType) {
							return function (enrollmentDate) {
								return function (memberType) {
									return function (terminationDate) {
										return function (companyName) {
											return function (membership) {
												return function (plan) {
													return {Og: companyName, Ol: completedAt, OT: coveragePlan, OW: coverageType, RE: enrollmentDate, RG: enrollmentStatus, RM: errorMessage, WN: memberType, kk: membership, Jb: plan, aca: startedAt, acL: syncStatus, ac1: terminationDate};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Patient$SyncDetail$recordDecoder = A3(
	$author$project$Api$Expandable$expandable,
	'plan',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Plan$Min$decoder),
	A3(
		$author$project$Api$Expandable$expandable,
		'membership',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Membership$Min$decoder),
		A3(
			$author$project$Api$Expandable$expandable,
			'company_name',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$author$project$Api$Expandable$expandable,
				'termination_date',
				$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
				A3(
					$author$project$Api$Expandable$expandable,
					'member_type',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$author$project$Api$Expandable$expandable,
						'enrollment_date',
						$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
						A3(
							$author$project$Api$Expandable$expandable,
							'coverage_type',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$author$project$Api$Expandable$expandable,
								'coverage_plan',
								$elm$json$Json$Decode$nullable($author$project$Api$Provider$CoveragePlan$One$decoder),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'error_message',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'started_at',
										$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'completed_at',
											$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'sync_status',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'enrollment_status',
													$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
													$elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$SyncDetail$Record))))))))))))));
var $author$project$Api$Provider$Patient$SyncDetail$affiliateDecoder = $elm$json$Json$Decode$nullable(
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Patient$SyncDetail$recordDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['network', 'name']),
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$SyncDetail$Affiliate))));
var $author$project$Api$Provider$SyncDetail$expandToString = function (expand) {
	if (!expand) {
		return 'additional_details';
	} else {
		return 'coverage_plan';
	}
};
var $author$project$Api$Provider$SyncDetail$listDefaults = {HE: _List_Nil};
var $author$project$Api$Provider$SyncDetail$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$SyncDetail$listDefaults);
	return A2($author$project$Api$Expandable$toParam, $author$project$Api$Provider$SyncDetail$expandToString, options.HE);
};
var $author$project$Api$Provider$SyncDetail$retrieveAffiliate = F4(
	function (apiClient, patientId, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Patient$SyncDetail$affiliateDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$SyncDetail$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['sync_details', 'affiliate']),
						$author$project$Api$Provider$Patient$patientPath(patientId)))));
	});
var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$init = F5(
	function (_v0, practice, patient, shared, _v1) {
		return _Utils_Tuple2(
			{w2: $author$project$Api$Data$Loading, Gv: shared.Gv, YY: patient, ZV: practice, J7: shared.J7},
			A4(
				$author$project$Api$Provider$SyncDetail$retrieveAffiliate,
				shared.Gv,
				$author$project$Api$Provider$Patient$One$id(patient),
				function (d) {
					return _Utils_update(
						d,
						{
							HE: _List_fromArray(
								[0])
						});
				},
				$elm$core$Basics$identity));
	});
var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$update = F2(
	function (msg, model) {
		var data = msg;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{w2: data}),
			$elm$core$Platform$Cmd$none,
			_List_Nil);
	});
var $author$project$Api$Provider$Patient$SyncDetail$record_ = function (detail) {
	if (!detail.$) {
		var r = detail.b;
		return r;
	} else {
		var r = detail.b;
		return r;
	}
};
var $author$project$Api$Provider$Patient$SyncDetail$companyName = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$SyncDetail$record_,
	function ($) {
		return $.Og;
	});
var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewCoverageSponsor = function (syncDetails) {
	var companyName = function () {
		if (!syncDetails.$) {
			var details = syncDetails.a;
			return A2(
				$author$project$Api$Expandable$withDefault,
				$elm$core$Maybe$Nothing,
				$author$project$Api$Provider$Patient$SyncDetail$companyName(details));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	if (!companyName.$) {
		var name = companyName.a;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Coverage Sponsor'),
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(name)
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Api$Provider$Patient$SyncDetail$coverageType = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$SyncDetail$record_,
	function ($) {
		return $.OW;
	});
var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewCoverageType = function (syncDetails) {
	var coverageType = function () {
		if (!syncDetails.$) {
			var details = syncDetails.a;
			return $elm$html$Html$text(
				A2(
					$elm$core$Maybe$withDefault,
					'N/A',
					A2(
						$author$project$Api$Expandable$withDefault,
						$elm$core$Maybe$Nothing,
						$author$project$Api$Provider$Patient$SyncDetail$coverageType(details))));
		} else {
			return $elm$html$Html$text('N/A');
		}
	}();
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Coverage Type'),
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[coverageType]))
			]));
};
var $author$project$Api$Provider$Patient$SyncDetail$terminationDate = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$SyncDetail$record_,
	function ($) {
		return $.ac1;
	});
var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewEndDate = function (syncDetails) {
	var endDate = function () {
		if (!syncDetails.$) {
			var details = syncDetails.a;
			return $elm$html$Html$text(
				A2(
					$elm$core$Maybe$withDefault,
					'-',
					A2(
						$elm$core$Maybe$map,
						$justinmimbs$date$Date$format('MM/dd/yyyy'),
						A2(
							$author$project$Api$Expandable$withDefault,
							$elm$core$Maybe$Nothing,
							$author$project$Api$Provider$Patient$SyncDetail$terminationDate(details)))));
		} else {
			return $elm$html$Html$text('-');
		}
	}();
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('End Date'),
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[endDate]))
			]));
};
var $author$project$Api$Provider$Patient$SyncDetail$completedAt = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$SyncDetail$record_,
	function ($) {
		return $.Ol;
	});
var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewLastSyncDate = F2(
	function (syncDetails, timeFormatter) {
		var lastSyncDate = function () {
			if (!syncDetails.$) {
				var details = syncDetails.a;
				return $elm$html$Html$text(
					A2(
						$elm$core$Maybe$withDefault,
						'-',
						A2(
							$elm$core$Maybe$map,
							timeFormatter(5),
							$author$project$Api$Provider$Patient$SyncDetail$completedAt(details))));
			} else {
				return $elm$html$Html$text('-');
			}
		}();
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Last Sync Date'),
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[lastSyncDate]))
				]));
	});
var $author$project$Api$Provider$Patient$SyncDetail$memberType = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$SyncDetail$record_,
	function ($) {
		return $.WN;
	});
var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewMemberType = function (syncDetails) {
	var memberType = function () {
		if (!syncDetails.$) {
			var details = syncDetails.a;
			return $elm$html$Html$text(
				A2(
					$elm$core$Maybe$withDefault,
					'N/A',
					A2(
						$author$project$Api$Expandable$withDefault,
						$elm$core$Maybe$Nothing,
						$author$project$Api$Provider$Patient$SyncDetail$memberType(details))));
		} else {
			return $elm$html$Html$text('N/A');
		}
	}();
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Member Type'),
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[memberType]))
			]));
};
var $author$project$Api$Provider$Patient$SyncDetail$membership = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$SyncDetail$record_,
	function ($) {
		return $.kk;
	});
var $author$project$Api$Provider$Membership$Min$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewNetworkPaymentStatus = function (syncDetails) {
	var paymentStatus = function () {
		if (!syncDetails.$) {
			var details = syncDetails.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$Membership$Min$status,
				A2(
					$author$project$Api$Expandable$withDefault,
					$elm$core$Maybe$Nothing,
					$author$project$Api$Provider$Patient$SyncDetail$membership(details)));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	var coverageType = function () {
		if (!syncDetails.$) {
			var details = syncDetails.a;
			return A2(
				$author$project$Api$Expandable$withDefault,
				$elm$core$Maybe$Nothing,
				$author$project$Api$Provider$Patient$SyncDetail$coverageType(details));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	var _v0 = _Utils_Tuple2(
		paymentStatus,
		!_Utils_eq(
			coverageType,
			$elm$core$Maybe$Just('Employer')));
	if ((!_v0.a.$) && _v0.b) {
		var status = _v0.a.a;
		var statuses = $elm$core$Dict$fromList(
			_List_fromArray(
				[
					_Utils_Tuple2('active', 'paid'),
					_Utils_Tuple2('unpaid', 'unpaid')
				]));
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Network Payment Status'),
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Badge$fromString,
							_List_Nil,
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2($elm$core$Dict$get, status, statuses)))
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewSkeleton = A2(
	$elm$html$Html$div,
	_List_Nil,
	A2(
		$elm$core$List$map,
		function (label) {
			return A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSkeleton(label),
						$author$project$Ui$Form$Group$labelSpanSm(3),
						$author$project$Ui$Form$Group$inputSpanSm(9)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$text(
								_List_fromArray(
									[
										$author$project$Ui$Skeleton$span(4),
										$author$project$Ui$Skeleton$spanMd(3)
									]))
							]))
					]));
		},
		_List_fromArray(
			['Coverage Type', 'Member Type', 'Sponsor Membership Plan', 'Start date', 'End Date', 'Last sync date'])));
var $author$project$Api$Provider$Patient$SyncDetail$plan = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$SyncDetail$record_,
	function ($) {
		return $.Jb;
	});
var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewSponsorMembershipPlan = function (syncDetails) {
	var plan = function () {
		if (!syncDetails.$) {
			var details = syncDetails.a;
			return $elm$html$Html$text(
				A2(
					$elm$core$Maybe$withDefault,
					'N/A',
					A2(
						$elm$core$Maybe$map,
						$author$project$Api$Provider$Plan$Min$name,
						A2(
							$author$project$Api$Expandable$withDefault,
							$elm$core$Maybe$Nothing,
							$author$project$Api$Provider$Patient$SyncDetail$plan(details)))));
		} else {
			return $elm$html$Html$text('N/A');
		}
	}();
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Sponsor Membership Plan'),
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[plan]))
			]));
};
var $author$project$Api$Provider$Patient$SyncDetail$enrollmentDate = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$SyncDetail$record_,
	function ($) {
		return $.RE;
	});
var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewStartDate = function (syncDetails) {
	var startDate = function () {
		if (!syncDetails.$) {
			var details = syncDetails.a;
			return $elm$html$Html$text(
				A2(
					$elm$core$Maybe$withDefault,
					'-',
					A2(
						$elm$core$Maybe$map,
						$justinmimbs$date$Date$format('MM/dd/yyyy'),
						A2(
							$author$project$Api$Expandable$withDefault,
							$elm$core$Maybe$Nothing,
							$author$project$Api$Provider$Patient$SyncDetail$enrollmentDate(details)))));
		} else {
			return $elm$html$Html$text('-');
		}
	}();
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Start Date'),
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[startDate]))
			]));
};
var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$view = function (_v0) {
	var affiliateSyncDetails = _v0.w2;
	var timeFormatter = _v0.J7;
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Affiliation')
									])),
								function () {
								switch (affiliateSyncDetails.$) {
									case 3:
										var syncDetails = affiliateSyncDetails.a;
										return A2(
											$author$project$Ui$Form$view,
											_List_Nil,
											_List_fromArray(
												[
													$author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewCoverageType(syncDetails),
													$author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewCoverageSponsor(syncDetails),
													$author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewMemberType(syncDetails),
													$author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewSponsorMembershipPlan(syncDetails),
													$author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewStartDate(syncDetails),
													$author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewEndDate(syncDetails),
													A2($author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewLastSyncDate, syncDetails, timeFormatter),
													$author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewNetworkPaymentStatus(syncDetails)
												]));
									case 1:
										return $author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewSkeleton;
									default:
										return $author$project$Utils$Html$empty;
								}
							}()
							]))
					]))
			]),
		ac9: 'Patient | Affiliations'
	};
};
var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$page = $author$project$Spa$Page$applicationPatient(
	{ah_: $author$project$Pages$Patients$PatientId_String$Affiliation$Top$init, aiq: $author$project$Pages$Patients$PatientId_String$Affiliation$Top$load, k8: $author$project$Pages$Patients$PatientId_String$Affiliation$Top$save, alO: $author$project$Pages$Patients$PatientId_String$Affiliation$Top$subscriptions, adT: $author$project$Pages$Patients$PatientId_String$Affiliation$Top$update, amo: $author$project$Pages$Patients$PatientId_String$Affiliation$Top$view});
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$GotAgreement = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$PatientDocument$One$PatientDocument = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$PatientDocument$Shared$PatientDocument = $elm$core$Basics$identity;
var $author$project$Api$Provider$PatientDocument$Shared$Record = F8(
	function (id, agreementId, name, status, signedAt, signedFrom, signature, hasSignedDocument) {
		return {Ll: agreementId, Tk: hasSignedDocument, ahP: id, Bq: name, abs: signature, abu: signedAt, abx: signedFrom, alH: status};
	});
var $author$project$Api$Provider$PatientDocument$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'has_signed_document',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'signature',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'signed_from',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'signed_at',
				$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'status',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'name',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'agreement_id',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'document_id',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Api$Provider$PatientDocument$Shared$Record)))))))));
var $author$project$Api$Provider$PatientDocument$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PatientDocument$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PatientDocument$One$Record = F4(
	function (currentDocumentVersion, signedDocumentVersion, requestDetail, signedByName) {
		return {af1: currentDocumentVersion, $A: requestDetail, abv: signedByName, abw: signedDocumentVersion};
	});
var $author$project$Api$Provider$PatientDocument$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'signed_by_name',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'request_detail',
		$elm$json$Json$Decode$nullable($author$project$Api$Common$RequestDetail$Shared$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'signed_document_version',
			$elm$json$Json$Decode$maybe($author$project$Api$Provider$DocumentVersion$Shared$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'current_document_version',
				$author$project$Api$Provider$DocumentVersion$Shared$decoder,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$PatientDocument$One$Record)))));
var $author$project$Api$Provider$PatientDocument$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PatientDocument$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$PatientDocument$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$PatientDocument$One$PatientDocument)));
var $author$project$Api$Provider$Patient$PatientDocument$patientDocumentsPath = function (patientId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['patient_documents']),
		$author$project$Api$Provider$Patient$patientPath(patientId));
};
var $author$project$Api$Provider$Patient$PatientDocument$patientDocumentPath = F2(
	function (patientId, documentId) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[documentId]),
			$author$project$Api$Provider$Patient$PatientDocument$patientDocumentsPath(patientId));
	});
var $author$project$Api$Provider$Patient$PatientDocument$retrieve = F4(
	function (apiClient, id_, patientId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$PatientDocument$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Provider$Patient$PatientDocument$patientDocumentPath, patientId, id_)));
	});
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$init = F5(
	function (_v0, practice, patient, shared, _v1) {
		var params = _v1.YL;
		return _Utils_Tuple2(
			{fD: $author$project$Api$Data$Loading, dX: $elm$core$Maybe$Nothing, Gv: shared.Gv, rN: true, tx: true, Ch: $author$project$Api$Data$NotAsked, YY: patient, ZV: practice, EF: $author$project$Api$Data$NotAsked, J7: shared.J7},
			A4($author$project$Api$Provider$Patient$PatientDocument$retrieve, shared.Gv, params.Ll, params.YZ, $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$GotAgreement));
	});
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$AgreementAcceptanceModalMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$Closed = {$: 0};
var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$subscriptions = function (model) {
	return model.Yn ? $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Patient$Agreements$AgreementAcceptanceModal$Closed) : $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$AgreementAcceptanceModalMsg,
		A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Platform$Sub$none,
			A2($elm$core$Maybe$map, $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$subscriptions, model.dX)));
};
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$GotSignedFileUrl = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$GotUploadedSignedDocument = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$PatientDocument$One$currentDocumentVersion = function (_v0) {
	var record = _v0.b;
	return record.af1;
};
var $author$project$Api$Provider$PatientDocument$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$PatientDocument$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PatientDocument$Shared$id(shared);
};
var $author$project$Api$Provider$PatientDocument$Shared$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Api$Provider$PatientDocument$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PatientDocument$Shared$status(shared);
};
var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$isAgreementAccepted = function (agreement) {
	var _v0 = $author$project$Api$Provider$PatientDocument$One$status(agreement);
	switch (_v0) {
		case 'accepted':
			return true;
		case 'accepted_and_outdated':
			return true;
		case 'not_accepted':
			return false;
		default:
			return false;
	}
};
var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$resetModel = F4(
	function (practice, patient, agreement, open_) {
		return _Utils_Tuple2(
			{
				Kz: $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$isAgreementAccepted(agreement),
				fD: agreement,
				sp: 0,
				Sp: $elm$core$Maybe$Nothing,
				dp: false,
				Yn: open_,
				YY: patient,
				ZV: practice
			},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$init = F4(
	function (practice, patient, agreement, open_) {
		return A4($author$project$Components$Patient$Agreements$AgreementAcceptanceModal$resetModel, practice, patient, agreement, open_);
	});
var $author$project$Api$Provider$PatientDocument$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$PatientDocument$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PatientDocument$Shared$name(shared);
};
var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$open = function (model) {
	return _Utils_update(
		model,
		{Yn: true});
};
var $author$project$Api$Provider$Patient$PatientDocument$signedDocument = F4(
	function (apiClient, id_, patientId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['uri']),
				$elm$json$Json$Decode$string),
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['signed_document']),
					A2($author$project$Api$Provider$Patient$PatientDocument$patientDocumentPath, patientId, id_))));
	});
var $author$project$Api$Provider$PatientDocument$One$signedDocumentVersion = function (_v0) {
	var record = _v0.b;
	return record.abw;
};
var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$File = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$GotAgreement = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$UpdateFailed = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$UpdateSucceeded = {$: 1};
var $author$project$Api$Provider$Patient$PatientDocument$acceptDocument = F5(
	function (apiClient, id_, patientId, fileUrl, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'signed_document',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fileUrl))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$PatientDocument$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['accept']),
						A2($author$project$Api$Provider$Patient$PatientDocument$patientDocumentPath, patientId, id_)))));
	});
var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$acceptAgreement = F5(
	function (token, documentId, patientId, fileUrl, agreement) {
		return A5($author$project$Api$Provider$Patient$PatientDocument$acceptDocument, token, documentId, patientId, fileUrl, agreement);
	});
var $author$project$Api$Provider$PatientDocument$Shared$agreementId = function (_v0) {
	var record = _v0;
	return record.Ll;
};
var $author$project$Api$Provider$PatientDocument$One$agreementId = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PatientDocument$Shared$agreementId(shared);
};
var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$isAgreementOutOfDate = function (agreement) {
	var _v0 = $author$project$Api$Provider$PatientDocument$One$status(agreement);
	if (_v0 === 'accepted_and_outdated') {
		return true;
	} else {
		return false;
	}
};
var $author$project$Api$Provider$Patient$PatientDocument$removeDocumentAcceptance = F5(
	function (apiClient, id_, patientId, agreementId_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'document_agreement_id',
					$elm$json$Json$Encode$string(agreementId_))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$PatientDocument$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['remove_acceptance']),
						A2($author$project$Api$Provider$Patient$PatientDocument$patientDocumentPath, patientId, id_)))));
	});
var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$removeAcceptance = F5(
	function (token, documentId, patientId, agreementId, agreement) {
		return A5($author$project$Api$Provider$Patient$PatientDocument$removeDocumentAcceptance, token, documentId, patientId, agreementId, agreement);
	});
var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 1:
				var response = msg.a;
				switch (response.$) {
					case 2:
						var error = response.a;
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: $elm$core$Maybe$Just(
								$author$project$Components$Patient$Agreements$AgreementAcceptanceModal$UpdateFailed(error)),
							aiO: _Utils_update(
								model,
								{dp: false})
						};
					case 3:
						var agreement = response.a;
						var _v2 = A4($author$project$Components$Patient$Agreements$AgreementAcceptanceModal$resetModel, model.ZV, model.YY, agreement, false);
						var newModel = _v2.a;
						var cmd = _v2.b;
						return {
							GZ: cmd,
							agZ: $elm$core$Maybe$Just($author$project$Components$Patient$Agreements$AgreementAcceptanceModal$UpdateSucceeded),
							aiO: _Utils_update(
								newModel,
								{dp: false})
						};
					default:
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: $elm$core$Maybe$Nothing,
							aiO: _Utils_update(
								model,
								{dp: false})
						};
				}
			case 0:
				var _v3 = A4($author$project$Components$Patient$Agreements$AgreementAcceptanceModal$resetModel, model.ZV, model.YY, model.fD, false);
				var newModel = _v3.a;
				var cmd = _v3.b;
				return {
					GZ: cmd,
					agZ: $elm$core$Maybe$Nothing,
					aiO: _Utils_update(
						newModel,
						{dp: false})
				};
			case 3:
				var _int = msg.a;
				var string = msg.b;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: $elm$core$Maybe$Nothing,
					aiO: _Utils_update(
						model,
						{
							sp: _int,
							Sp: $elm$core$Maybe$Just(string)
						})
				};
			case 4:
				var files = msg.a;
				var cmd = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						function (_v4) {
							var task = _v4.a;
							var size = _v4.b;
							return A2(
								$elm$core$Task$perform,
								$author$project$Components$Patient$Agreements$AgreementAcceptanceModal$File(size),
								task);
						},
						A2(
							$elm$core$Maybe$map,
							function (file) {
								return _Utils_Tuple2(
									$elm$file$File$toUrl(file),
									$elm$file$File$size(file));
							},
							$elm$core$List$head(files))));
				return {GZ: cmd, agZ: $elm$core$Maybe$Nothing, aiO: model};
			default:
				var patientId = $author$project$Api$Provider$Patient$One$id(model.YY);
				var outOfDate = $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$isAgreementOutOfDate(model.fD);
				var documentId = $author$project$Api$Provider$PatientDocument$One$id(model.fD);
				var cmd = function () {
					if (model.Kz && (!outOfDate)) {
						var agreementId = function () {
							var _v5 = $author$project$Api$Provider$PatientDocument$One$agreementId(model.fD);
							if (!_v5.$) {
								var id = _v5.a;
								return id;
							} else {
								return '';
							}
						}();
						return A5($author$project$Components$Patient$Agreements$AgreementAcceptanceModal$removeAcceptance, apiClient, documentId, patientId, agreementId, $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$GotAgreement);
					} else {
						return A5($author$project$Components$Patient$Agreements$AgreementAcceptanceModal$acceptAgreement, apiClient, documentId, patientId, model.Sp, $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$GotAgreement);
					}
				}();
				return {
					GZ: cmd,
					agZ: $elm$core$Maybe$Nothing,
					aiO: _Utils_update(
						model,
						{dp: true})
				};
		}
	});
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				switch (response.$) {
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{fD: response}),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error))
								]));
					case 3:
						var agreement = response.a;
						var outdatedFileCmd = function () {
							var _v2 = $author$project$Api$Provider$PatientDocument$One$status(agreement);
							if (_v2 === 'accepted_and_outdated') {
								var _v3 = $author$project$Api$Provider$PatientDocument$One$signedDocumentVersion(agreement);
								if (_v3.$ === 1) {
									return $elm$core$Platform$Cmd$none;
								} else {
									var outdatedDoc = _v3.a;
									return A4(
										$author$project$Api$Provider$DocumentVersion$signedFileUrl,
										model.Gv,
										$author$project$Api$Provider$PatientDocument$One$id(agreement),
										$author$project$Api$Provider$DocumentVersion$Shared$id(outdatedDoc),
										$author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$GotSignedFileUrl(false));
								}
							} else {
								return $elm$core$Platform$Cmd$none;
							}
						}();
						var currentFileCmd = A4(
							$author$project$Api$Provider$DocumentVersion$signedFileUrl,
							model.Gv,
							$author$project$Api$Provider$PatientDocument$One$id(agreement),
							$author$project$Api$Provider$DocumentVersion$Shared$id(
								$author$project$Api$Provider$PatientDocument$One$currentDocumentVersion(agreement)),
							$author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$GotSignedFileUrl(true));
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{fD: response}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[currentFileCmd, outdatedFileCmd])),
							_List_Nil);
					default:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{fD: response}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
				}
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{rN: !model.rN}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{tx: !model.tx}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var isCurrent = msg.a;
				var response = msg.b;
				var newModel = isCurrent ? _Utils_update(
					model,
					{EF: response}) : _Utils_update(
					model,
					{Ch: response});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$none,
					function () {
						if (response.$ === 2) {
							var error = response.a;
							return _List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error))
								]);
						} else {
							return _List_Nil;
						}
					}());
			case 2:
				var agreement = msg.a;
				var _v5 = model.dX;
				if (_v5.$ === 1) {
					var _v6 = A4($author$project$Components$Patient$Agreements$AgreementAcceptanceModal$init, model.ZV, model.YY, agreement, true);
					var modal = _v6.a;
					var cmd = _v6.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								dX: $elm$core$Maybe$Just(modal)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$AgreementAcceptanceModalMsg, cmd),
						_List_Nil);
				} else {
					var modal = _v5.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								dX: $elm$core$Maybe$Just(
									$author$project$Components$Patient$Agreements$AgreementAcceptanceModal$open(modal))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 3:
				var modalMsg = msg.a;
				var _v7 = model.dX;
				if (!_v7.$) {
					var modal = _v7.a;
					var result = A3($author$project$Components$Patient$Agreements$AgreementAcceptanceModal$update, model.Gv, modalMsg, modal);
					var _v8 = function () {
						var _v9 = result.agZ;
						if (!_v9.$) {
							if (!_v9.a.$) {
								var error = _v9.a.a;
								return _Utils_Tuple2(
									$elm$core$Platform$Cmd$none,
									_List_fromArray(
										[
											A2(
											$author$project$OutMsg$ShowToast,
											1,
											$author$project$Ui$Toast$serverError(error))
										]));
							} else {
								var _v10 = _v9.a;
								var successText = $author$project$Api$Provider$PatientDocument$One$name(modal.fD) + ' marked as accepted';
								return _Utils_Tuple2(
									A4(
										$author$project$Api$Provider$Patient$PatientDocument$retrieve,
										model.Gv,
										$author$project$Api$Provider$PatientDocument$One$id(modal.fD),
										$author$project$Api$Provider$Patient$One$id(modal.YY),
										$author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$GotAgreement),
									_List_fromArray(
										[
											A2($author$project$OutMsg$ShowToast, 3, successText)
										]));
							}
						} else {
							return _Utils_Tuple2($elm$core$Platform$Cmd$none, _List_Nil);
						}
					}();
					var command = _v8.a;
					var outMsg = _v8.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								dX: $elm$core$Maybe$Just(result.aiO)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$AgreementAcceptanceModalMsg, result.GZ),
									command
								])),
						outMsg);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var id = msg.a;
				return _Utils_Tuple3(
					model,
					A4(
						$author$project$Api$Provider$Patient$PatientDocument$signedDocument,
						model.Gv,
						id,
						$author$project$Api$Provider$Patient$One$id(model.YY),
						$author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$GotUploadedSignedDocument),
					_List_Nil);
			default:
				var response = msg.a;
				return _Utils_Tuple3(
					model,
					$author$project$Ports$Navigation$openInNewWindow(
						A2(
							$elm$core$Maybe$withDefault,
							'',
							$author$project$Api$Data$toMaybe(response))),
					$author$project$OutMsg$handleErrorResponse(response));
		}
	});
var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$Submitted = {$: 2};
var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$FileUploaded = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$viewFileUploader = function (model) {
	var maxFileBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
	var fileSizeError = (_Utils_cmp(model.sp, maxFileBytesSize) > 0) ? 'That file is too large! Our maximum file size is 5 mb.' : '';
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('border-light')
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$File$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$File$accept(2),
						$author$project$Ui$Form$File$onInput($author$project$Components$Patient$Agreements$AgreementAcceptanceModal$FileUploaded)
					])),
				$author$project$Utils$FormErrors$viewError(fileSizeError)
			]));
};
var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$view = function (model) {
	if (model.Yn) {
		var patientName = $author$project$Api$Provider$Patient$One$name(model.YY);
		var outOfDate = $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$isAgreementOutOfDate(model.fD);
		var buttonText = function () {
			if (model.Kz && (!outOfDate)) {
				return 'Confirm';
			} else {
				var _v0 = model.sp;
				if (!_v0) {
					return 'Confirm without Uploading';
				} else {
					return 'Confirm';
				}
			}
		}();
		var footer = _List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Cancel and close modal'},
				_List_fromArray(
					[
						$author$project$Ui$Button$onClick($author$project$Components$Patient$Agreements$AgreementAcceptanceModal$Closed)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Cancel')
					])),
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Confirm'},
				_List_fromArray(
					[
						$author$project$Ui$Button$primary,
						$author$project$Ui$Button$loading(model.dp),
						$author$project$Ui$Button$onClick($author$project$Components$Patient$Agreements$AgreementAcceptanceModal$Submitted)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(buttonText)
					]))
			]);
		var agreementName = $author$project$Api$Provider$PatientDocument$One$name(model.fD);
		var bodyText = (model.Kz && (!outOfDate)) ? ('Are you sure you want to remove the acceptance of the ' + (agreementName + (' for ' + (patientName + '?')))) : ('Do you have a signed copy from ' + (patientName + (' of the ' + (agreementName + '?'))));
		var body = (model.Kz && (!outOfDate)) ? A2(
			$author$project$Ui$Form$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$onSubmit($author$project$Components$Patient$Agreements$AgreementAcceptanceModal$Submitted)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-075')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(bodyText)
						]))
				])) : A2(
			$author$project$Ui$Form$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$onSubmit($author$project$Components$Patient$Agreements$AgreementAcceptanceModal$Submitted)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-075')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(bodyText)
						])),
					$author$project$Components$Patient$Agreements$AgreementAcceptanceModal$viewFileUploader(model)
				]));
		var titleText = (model.Kz && (!outOfDate)) ? ('Remove ' + agreementName) : ('Accept ' + agreementName);
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$Patient$Agreements$AgreementAcceptanceModal$Closed,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title(titleText)
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[body])),
					$author$project$Ui$Modal$footer(footer)
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewAgreementAcceptanceModal = function (model) {
	var _v0 = model.dX;
	if (!_v0.$) {
		var modal = _v0.a;
		return A2(
			$elm$html$Html$map,
			$author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$AgreementAcceptanceModalMsg,
			$author$project$Components$Patient$Agreements$AgreementAcceptanceModal$view(modal));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Ui$Button$GreyLink = 9;
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$ToggleCurrentAgreementVisible = {$: 1};
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$ToggleOutdatedAgreementVisible = {$: 4};
var $author$project$Api$Provider$DocumentVersion$Shared$createdAt = function (_v0) {
	var record = _v0;
	return record.O1;
};
var $elm$html$Html$iframe = _VirtualDom_node('iframe');
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewFromUrl = F2(
	function (patientDocumentName, signedFileUrl) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					function () {
					var _v0 = $author$project$Api$Data$toMaybe(signedFileUrl);
					if (!_v0.$) {
						var url_ = _v0.a;
						var pdfUrl = 'https://docs.google.com/gview?url=' + ($elm$url$Url$percentEncode(url_) + '&embedded=true');
						return A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('embed-responsive embed-responsive-full')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$iframe,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$src(pdfUrl),
													$elm$html$Html$Attributes$title(patientDocumentName),
													A2(
													$elm$html$Html$Attributes$property,
													'frameborder',
													$elm$json$Json$Encode$string('0')),
													A2(
													$elm$html$Html$Attributes$property,
													'allowfullscreen',
													$elm$json$Json$Encode$string('false')),
													$elm$html$Html$Attributes$class('embed-responsive-item ng-scope')
												]),
											_List_Nil)
										]))
								]));
					} else {
						return A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$card(_List_Nil)
								]));
					}
				}()
				]));
	});
var $author$project$Api$Provider$PatientDocument$Shared$hasSignedDocument = function (_v0) {
	var record = _v0;
	return record.Tk;
};
var $author$project$Api$Provider$PatientDocument$One$hasSignedDocument = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PatientDocument$Shared$hasSignedDocument(shared);
};
var $author$project$Api$Provider$PatientDocument$One$requestDetail = function (_v0) {
	var record = _v0.b;
	return record.$A;
};
var $author$project$Api$Provider$PatientDocument$Shared$signature = function (_v0) {
	var record = _v0;
	return record.abs;
};
var $author$project$Api$Provider$PatientDocument$One$signature = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PatientDocument$Shared$signature(shared);
};
var $author$project$Api$Provider$PatientDocument$Shared$signedAt = function (_v0) {
	var record = _v0;
	return record.abu;
};
var $author$project$Api$Provider$PatientDocument$One$signedAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PatientDocument$Shared$signedAt(shared);
};
var $author$project$Api$Provider$PatientDocument$One$signedByName = function (_v0) {
	var record = _v0.b;
	return record.abv;
};
var $author$project$Api$Provider$PatientDocument$Shared$signedFrom = function (_v0) {
	var record = _v0;
	return record.abx;
};
var $author$project$Api$Provider$PatientDocument$One$signedFrom = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PatientDocument$Shared$signedFrom(shared);
};
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$markAsAcceptedLabel = F2(
	function (atOrBy, signedFrom) {
		return ((signedFrom === 'provider_portal') ? 'Marked as accepted' : 'Accepted') + (' ' + atOrBy);
	});
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewAcceptedBySection = F2(
	function (maybeSignedFrom, maybeSignedByName) {
		var label = A2(
			$elm$core$Maybe$map,
			$author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$markAsAcceptedLabel('by'),
			maybeSignedFrom);
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label(
					A2($elm$core$Maybe$withDefault, '', label)),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$p,
							_List_fromArray(
								[
									$author$project$Ui$Typography$phi(true)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($elm$core$Maybe$withDefault, '', maybeSignedByName))
								]))
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewAceeptedAtSection = F3(
	function (timeFormatter, maybeSignedFrom, maybeSignedAt) {
		var signedAt = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				timeFormatter(2),
				maybeSignedAt));
		var label = A2(
			$elm$core$Maybe$map,
			$author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$markAsAcceptedLabel('at'),
			maybeSignedFrom);
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label(
					A2($elm$core$Maybe$withDefault, '', label)),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(signedAt)
								]))
						]))
				]));
	});
var $author$project$Api$Common$RequestDetail$Shared$clientName = function (_v0) {
	var record = _v0;
	return record.NK;
};
var $author$project$Api$Common$RequestDetail$Shared$deviceBrand = function (_v0) {
	var record = _v0;
	return record.Qx;
};
var $author$project$Api$Common$RequestDetail$Shared$deviceName = function (_v0) {
	var record = _v0;
	return record.Qy;
};
var $author$project$Api$Common$RequestDetail$Shared$deviceType = function (_v0) {
	var record = _v0;
	return record.Qz;
};
var $author$project$Api$Common$RequestDetail$Shared$osName = function (_v0) {
	var record = _v0;
	return record.Yx;
};
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewDetailsSection = F2(
	function (maybeSignedFrom, maybeRequestDetails) {
		if (maybeRequestDetails.$ === 1) {
			return $author$project$Utils$Html$empty;
		} else {
			var requestDetails = maybeRequestDetails.a;
			var _v1 = _Utils_Tuple2(
				$author$project$Api$Common$RequestDetail$Shared$clientName(requestDetails),
				maybeSignedFrom);
			if (_v1.a.$ === 1) {
				var _v2 = _v1.a;
				return $author$project$Utils$Html$empty;
			} else {
				if (_v1.b.$ === 1) {
					var _v3 = _v1.b;
					return $author$project$Utils$Html$empty;
				} else {
					var clientName = _v1.a.a;
					var signedFrom = _v1.b.a;
					return (signedFrom === 'provider_portal') ? $author$project$Utils$Html$empty : A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Details'),
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Static$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_Nil,
										function () {
											var _v4 = $author$project$Api$Common$RequestDetail$Shared$deviceType(requestDetails);
											if (_v4.$ === 1) {
												return _List_Nil;
											} else {
												var deviceType = _v4.a;
												return (deviceType === 'desktop') ? _List_fromArray(
													[
														$elm$html$Html$text(
														'Using ' + (clientName + (' on ' + (A2(
															$elm$core$Maybe$withDefault,
															'',
															$author$project$Api$Common$RequestDetail$Shared$osName(requestDetails)) + ' Desktop'))))
													]) : _List_fromArray(
													[
														$elm$html$Html$text(
														'Using ' + (clientName + (' on ' + (A2(
															$elm$core$Maybe$withDefault,
															'',
															$author$project$Api$Common$RequestDetail$Shared$deviceBrand(requestDetails)) + (' ' + A2(
															$elm$core$Maybe$withDefault,
															'',
															$author$project$Api$Common$RequestDetail$Shared$deviceName(requestDetails)))))))
													]);
											}
										}())
									]))
							]));
				}
			}
		}
	});
var $author$project$Api$Common$RequestDetail$Shared$ip = function (_v0) {
	var record = _v0;
	return record.Ux;
};
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewIpSection = F2(
	function (maybeSignedFrom, maybeRequestDetails) {
		if (maybeRequestDetails.$ === 1) {
			return $author$project$Utils$Html$empty;
		} else {
			var requestDetails = maybeRequestDetails.a;
			var _v1 = _Utils_Tuple2(
				$author$project$Api$Common$RequestDetail$Shared$ip(requestDetails),
				maybeSignedFrom);
			if (_v1.a.$ === 1) {
				var _v2 = _v1.a;
				return $author$project$Utils$Html$empty;
			} else {
				if (_v1.b.$ === 1) {
					var _v3 = _v1.b;
					return $author$project$Utils$Html$empty;
				} else {
					var ip = _v1.a.a;
					var signedFrom = _v1.b.a;
					return (signedFrom === 'provider_portal') ? $author$project$Utils$Html$empty : A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('IP Address'),
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Static$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(ip)
											]))
									]))
							]));
				}
			}
		}
	});
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewSignedHeaderSection = F2(
	function (viaSectionText, notSignedElectronically) {
		return notSignedElectronically ? A2(
			$author$project$Ui$Typography$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Signed electronically '),
					A2($author$project$Ui$Typography$text, _List_Nil, viaSectionText)
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$OpenFileDocument = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewUploadedDocumentSection = F3(
	function (id, maybeSignedFrom, hasSignedDocument) {
		if (!maybeSignedFrom.$) {
			var signedFrom = maybeSignedFrom.a;
			return ((signedFrom === 'provider_portal') && hasSignedDocument) ? A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label(''),
						$author$project$Ui$Form$Group$labelSpanSm(3),
						$author$project$Ui$Form$Group$inputSpanSm(9)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{mm: 'View uploaded document'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$onClick(
										$author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$OpenFileDocument(id))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('View uploaded document')
									]))
							]))
					])) : $author$project$Utils$Html$empty;
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewSignedAgreementDetails = F3(
	function (timeFormatter, showSignatureDetails, agreement) {
		if (($author$project$Api$Provider$PatientDocument$One$status(agreement) === 'not_accepted') || (!showSignatureDetails)) {
			return $author$project$Utils$Html$empty;
		} else {
			var maybeSignedFrom = $author$project$Api$Provider$PatientDocument$One$signedFrom(agreement);
			var notSignedElectronically = A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function (signedFrom) {
						return (signedFrom !== 'provider_portal') && (signedFrom !== 'public_api');
					},
					maybeSignedFrom));
			var viaSectionText = function () {
				var _v0 = _Utils_Tuple2(
					$author$project$Api$Provider$PatientDocument$One$signature(agreement),
					maybeSignedFrom);
				if (_v0.a.$ === 1) {
					var _v1 = _v0.a;
					return 'by typing their name';
				} else {
					if (!_v0.b.$) {
						var signedFrom = _v0.b.a;
						return (signedFrom === 'online_signup') ? 'via checkbox on online signup.' : 'via checkbox';
					} else {
						var _v2 = _v0.b;
						return 'via checkbox';
					}
				}
			}();
			var maybeSignedByName = $author$project$Api$Provider$PatientDocument$One$signedByName(agreement);
			var maybeSignedAt = $author$project$Api$Provider$PatientDocument$One$signedAt(agreement);
			var maybeRequestDetails = $author$project$Api$Provider$PatientDocument$One$requestDetail(agreement);
			var hasSignedDocument = $author$project$Api$Provider$PatientDocument$One$hasSignedDocument(agreement);
			return A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(8),
								$author$project$Ui$Grid$offset(2)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Well$view,
								_List_fromArray(
									[$author$project$Ui$Well$small]),
								_List_fromArray(
									[
										A2($author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewSignedHeaderSection, viaSectionText, notSignedElectronically),
										A2($author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewAcceptedBySection, maybeSignedFrom, maybeSignedByName),
										A3($author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewAceeptedAtSection, timeFormatter, maybeSignedFrom, maybeSignedAt),
										A3(
										$author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewUploadedDocumentSection,
										$author$project$Api$Provider$PatientDocument$One$id(agreement),
										maybeSignedFrom,
										hasSignedDocument),
										A2($author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewDetailsSection, maybeSignedFrom, maybeRequestDetails),
										A2($author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewIpSection, maybeSignedFrom, maybeRequestDetails)
									]))
							]))
					]));
		}
	});
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewAgreement = F5(
	function (timeFormatter, showSignatureDetails, agreementVisibilityRecord, agreement, document) {
		if (agreementVisibilityRecord.oa) {
			var documentBody = function () {
				var _v0 = $author$project$Api$Provider$DocumentVersion$Shared$documentVersionType(document);
				switch (_v0) {
					case 1:
						return _List_fromArray(
							[
								A2($author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewFromUrl, 'name', agreementVisibilityRecord.Sp)
							]);
					case 0:
						return _List_fromArray(
							[
								A3(
								$author$project$Ui$Link$externalHref,
								A2(
									$elm$core$Maybe$withDefault,
									'',
									$author$project$Api$Provider$DocumentVersion$Shared$linkUrl(document)),
								_List_fromArray(
									[$author$project$Ui$Link$targetBlank]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2(
											$elm$core$Maybe$withDefault,
											'',
											$author$project$Api$Provider$DocumentVersion$Shared$linkUrl(document)))
									]))
							]);
					default:
						return A2(
							$elm$core$List$map,
							$elm$html$Html$map($elm$core$Basics$never),
							$author$project$Utils$Dom$textToHtml(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									$author$project$Api$Provider$DocumentVersion$Shared$content(document))));
				}
			}();
			return A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				A2(
					$elm$core$List$cons,
					A3($author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewSignedAgreementDetails, timeFormatter, showSignatureDetails, agreement),
					documentBody));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewAgreements = F4(
	function (timeFormatter, agreement, current, outdated) {
		var isOutdated = function () {
			var _v3 = $author$project$Api$Provider$PatientDocument$One$status(agreement);
			if (_v3 === 'accepted_and_outdated') {
				return true;
			} else {
				return false;
			}
		}();
		var agreementVisibleName = function () {
			var _v2 = $author$project$Api$Provider$PatientDocument$One$status(agreement);
			if (_v2 === 'accepted') {
				return 'Signed Agreement';
			} else {
				return 'Current Agreement';
			}
		}();
		var _v0 = _Utils_Tuple2(current.oa, outdated.oa);
		var currentAgreementVisible = _v0.a;
		var outdatedAgreementVisible = _v0.b;
		var agreementIcon = currentAgreementVisible ? $author$project$Ui$Icon$chevron(
			_List_fromArray(
				[$author$project$Ui$Icon$rotate180])) : $author$project$Ui$Icon$chevronDown(_List_Nil);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			function () {
				if (isOutdated) {
					var _v1 = $author$project$Api$Provider$PatientDocument$One$signedDocumentVersion(agreement);
					if (_v1.$ === 1) {
						return _List_Nil;
					} else {
						var signedDocumentVersion = _v1.a;
						return _List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{mm: 'View ' + agreementVisibleName},
										_List_fromArray(
											[
												$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$ToggleCurrentAgreementVisible),
												$author$project$Ui$Button$styled(9)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(agreementVisibleName),
												$author$project$Utils$Html$noBreakSpace,
												agreementIcon
											])),
										A5(
										$author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewAgreement,
										timeFormatter,
										false,
										current,
										agreement,
										$author$project$Api$Provider$PatientDocument$One$currentDocumentVersion(agreement))
									])),
								A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Signed Out Of Date Agreement'},
										_List_fromArray(
											[
												$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$ToggleOutdatedAgreementVisible),
												$author$project$Ui$Button$styled(9)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Signed Out Of Date Agreement'),
												$author$project$Utils$Html$noBreakSpace,
												outdatedAgreementVisible ? $author$project$Ui$Icon$chevron(
												_List_fromArray(
													[$author$project$Ui$Icon$rotate180])) : $author$project$Ui$Icon$chevronDown(_List_Nil)
											])),
										function () {
										if (outdatedAgreementVisible) {
											var currentDocumentVersionDate = A2(
												timeFormatter,
												2,
												$author$project$Api$Provider$DocumentVersion$Shared$createdAt(
													$author$project$Api$Provider$PatientDocument$One$currentDocumentVersion(agreement)));
											return A2(
												$author$project$Ui$Typography$p,
												_List_fromArray(
													[$author$project$Ui$Typography$small]),
												_List_fromArray(
													[
														$elm$html$Html$text('Agreement was later updated, the most recent version was added on ' + currentDocumentVersionDate)
													]));
										} else {
											return $author$project$Utils$Html$empty;
										}
									}(),
										A5($author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewAgreement, timeFormatter, true, outdated, agreement, signedDocumentVersion)
									]))
							]);
					}
				} else {
					return _List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'View ' + agreementVisibleName},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$ToggleCurrentAgreementVisible),
									$author$project$Ui$Button$styled(9)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(agreementVisibleName),
									$author$project$Utils$Html$noBreakSpace,
									agreementIcon
								])),
							A5(
							$author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewAgreement,
							timeFormatter,
							true,
							current,
							agreement,
							$author$project$Api$Provider$PatientDocument$One$currentDocumentVersion(agreement))
						]);
				}
			}());
	});
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewBreadcrumbs = F2(
	function (patientId, agreementName) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Link$route,
					$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
						{YZ: patientId}),
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Patient')
						])),
					A2(
					$author$project$Ui$Typography$text,
					_List_fromArray(
						[$author$project$Ui$Typography$gray]),
					'  /  ' + agreementName),
					$author$project$Ui$HorizontalRule$view(
					_List_fromArray(
						[$author$project$Ui$HorizontalRule$thin]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$OpenAgreementAcceptanceModal = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Badge$Inline = {$: 0};
var $author$project$Ui$Badge$inline = $author$project$Ui$Badge$Inline;
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewHeader = F3(
	function (agreement, patient, practice) {
		var practiceAddress = function () {
			var _v2 = $author$project$Api$Provider$Practice$One$address(practice);
			if (!_v2.$) {
				var practiceAddress_ = _v2.a;
				return $author$project$Components$AddressDisplay$view(practiceAddress_);
			} else {
				return $author$project$Utils$Html$empty;
			}
		}();
		var patientAddress = function () {
			var _v1 = $author$project$Api$Provider$Patient$One$address(patient);
			if (!_v1.$) {
				var address = _v1.a;
				return $author$project$Components$AddressDisplay$view(address);
			} else {
				return $author$project$Utils$Html$empty;
			}
		}();
		var buttonText = function () {
			var _v0 = $author$project$Api$Provider$PatientDocument$One$status(agreement);
			switch (_v0) {
				case 'accepted':
					return 'Mark as Not Accepted';
				case 'not_accepted':
					return 'Mark as Accepted';
				default:
					return 'Mark Current Agreement as Accepted';
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsStart]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$itemsCenter]),
							_List_fromArray(
								[
									$author$project$Ui$Typography$headingSm(
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Provider$PatientDocument$One$name(agreement))
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$mr2]),
									_List_Nil),
									A2(
									$author$project$Ui$Badge$fromString,
									_List_fromArray(
										[$author$project$Ui$Badge$inline]),
									$author$project$Api$Provider$PatientDocument$One$status(agreement))
								])),
							A3(
							$author$project$Ui$Button$view,
							{mm: buttonText},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$onClick(
									$author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$OpenAgreementAcceptanceModal(agreement))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(buttonText)
								]))
						])),
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(2)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$label,
									_List_fromArray(
										[$author$project$Ui$Typography$hintLabel, $author$project$Ui$Typography$textLeft, $author$project$Ui$Typography$p0]),
									_List_fromArray(
										[
											$elm$html$Html$text('Member')
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(10)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$strong,
									_List_fromArray(
										[
											$author$project$Ui$Typography$phi(true)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Provider$Patient$One$name(patient))
										])),
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[patientAddress]))
								]))
						])),
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(2)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$label,
									_List_fromArray(
										[$author$project$Ui$Typography$hintLabel, $author$project$Ui$Typography$textLeft, $author$project$Ui$Typography$p0]),
									_List_fromArray(
										[
											$elm$html$Html$text('Business')
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(10)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Provider$Practice$One$name(practice))
										])),
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[practiceAddress]))
								]))
						])),
					$author$project$Ui$HorizontalRule$view(_List_Nil)
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewSkeleton = _List_fromArray(
	[
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$itemsStart]),
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$text(
				_List_fromArray(
					[
						$author$project$Ui$Skeleton$spanFromText('Patient')
					])),
				A2($author$project$Ui$Typography$text, _List_Nil, '  /  '),
				$author$project$Ui$Skeleton$text(
				_List_fromArray(
					[
						$author$project$Ui$Skeleton$span(2)
					]))
			])),
		$author$project$Ui$HorizontalRule$view(
		_List_fromArray(
			[$author$project$Ui$HorizontalRule$thin])),
		A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsStart]),
				_List_fromArray(
					[
						$author$project$Ui$Typography$headingSm(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$text(
								_List_fromArray(
									[
										$author$project$Ui$Skeleton$block,
										$author$project$Ui$Skeleton$spanFromText('Some Agreement')
									]))
							])),
						$author$project$Ui$Skeleton$input(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$span(2)
							]))
					])),
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(2)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$text(_List_Nil)
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(10)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$text(
								_List_fromArray(
									[
										$author$project$Ui$Skeleton$span(3)
									]))
							]))
					])),
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(2)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$text(_List_Nil)
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(10)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$text(
								_List_fromArray(
									[
										$author$project$Ui$Skeleton$span(4)
									]))
							]))
					])),
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$itemsStart, $author$project$Ui$Element$spaceX2]),
				_List_fromArray(
					[
						$author$project$Ui$Skeleton$text(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$spanFromText('Signed Agreement')
							])),
						$author$project$Ui$Skeleton$card(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$span(8)
							]))
					]))
			]))
	]);
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$view = function (model) {
	var _v0 = model;
	var timeFormatter = _v0.J7;
	var practice = _v0.ZV;
	var patient = _v0.YY;
	var agreement = _v0.fD;
	var signedFileUrl = _v0.EF;
	var currentAgreementVisible = _v0.rN;
	var outdatedSignedFileUrl = _v0.Ch;
	var outdatedAgreementVisible = _v0.tx;
	return {
		fO: function () {
			if (agreement.$ === 3) {
				var agreement_ = agreement.a;
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewBreadcrumbs,
										$author$project$Api$Provider$Patient$One$id(model.YY),
										$author$project$Api$Provider$PatientDocument$One$name(agreement_)),
										$author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewAgreementAcceptanceModal(model),
										A3($author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewHeader, agreement_, patient, practice),
										A4(
										$author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewAgreements,
										timeFormatter,
										agreement_,
										{Sp: signedFileUrl, oa: currentAgreementVisible},
										{Sp: outdatedSignedFileUrl, oa: outdatedAgreementVisible})
									]))
							]))
					]);
			} else {
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Ui$Panel$body, _List_Nil, $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewSkeleton)
							]))
					]);
			}
		}(),
		ac9: 'Patient | Agreements'
	};
};
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$page = $author$project$Spa$Page$applicationPatient(
	{ah_: $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$init, aiq: $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$load, k8: $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$save, alO: $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$subscriptions, adT: $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$update, amo: $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$view});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotIntegrationRecords = function (a) {
	return {$: 54, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotTaxProfiles = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$OtherActionsDropdownMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$TaxProfileDropdownMsg = function (a) {
	return {$: 42, a: a};
};
var $author$project$Api$Provider$CustomerInvoice$integrationRecords = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$IntegrationRecord$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['integration_records']),
					$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id))));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotInvoice = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$CustomerInvoice$MembershipPaymentSource = 4;
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceExpands = _List_fromArray(
	[0, 1, 2, 3, 4]);
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice = F2(
	function (apiClient, invoiceId) {
		return A4($author$project$Api$Provider$CustomerInvoice$retrieve, apiClient, invoiceId, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceExpands, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotInvoice);
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$init = F5(
	function (session, practice, patient, shared, _v0) {
		var params = _v0.YL;
		return _Utils_Tuple2(
			{
				ik: $elm$core$Maybe$Nothing,
				Gv: shared.Gv,
				iw: $elm$core$Maybe$Nothing,
				iy: false,
				rs: $author$project$Api$Data$Loading,
				rC: $author$project$Api$Data$Loading,
				iI: _List_Nil,
				fX: $elm$core$Maybe$Nothing,
				yU: $elm$core$Dict$empty,
				m$: $elm$core$Maybe$Nothing,
				i$: $elm$core$Maybe$Nothing,
				dd: shared.dd,
				m5: $author$project$Components$CustomerEmailModal$init,
				i7: false,
				jt: $author$project$Components$Invoice$DownloadFile$init(shared.adY),
				jw: $elm$core$Maybe$Nothing,
				ahK: shared.ahK,
				Ub: $author$project$Api$Data$Loading,
				Uk: $author$project$Api$Data$NotAsked,
				Us: params.Us,
				Ij: $author$project$Shared$isHintAdmin(shared),
				od: false,
				Is: $author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__Top(
					{YZ: params.YZ}),
				oO: $author$project$Ui$Dropdown$init(
					$author$project$Ui$Dropdown$defaultConfig(
						{ahP: 'other-actions-dropdown-menu', al6: $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$OtherActionsDropdownMsg})),
				YV: $author$project$Api$Data$NotAsked,
				YY: patient,
				YZ: params.YZ,
				kD: A4(
					$author$project$Components$PaymentsList$init,
					shared.J7,
					$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(params.Us),
					session,
					false),
				ZV: practice,
				kO: $elm$core$Maybe$Nothing,
				t9: shared.t9,
				hw: $author$project$Components$CustomerSchedulePaymentModal$init,
				la: _List_Nil,
				aa4: session,
				lk: shared,
				lJ: $author$project$Ui$Dropdown$init(
					$author$project$Ui$Dropdown$defaultConfig(
						{ahP: 'tax-profiles-dropdown', al6: $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$TaxProfileDropdownMsg})),
				hU: $author$project$Api$Data$NotAsked,
				J7: shared.J7,
				adY: shared.adY
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, shared.Gv, params.Us),
						A2($author$project$Api$Provider$TaxProfile$list, shared.Gv, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotTaxProfiles),
						$author$project$Shared$isHintAdmin(shared) ? A3($author$project$Api$Provider$CustomerInvoice$integrationRecords, shared.Gv, params.Us, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotIntegrationRecords) : $elm$core$Platform$Cmd$none
					])));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$AdjustVoidModalMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$AuditTrailLogMsg = function (a) {
	return {$: 47, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$BadDebtHiConfirmClosed = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ChargeModalMsg = function (a) {
	return {$: 39, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CreatePaymentModalMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CreateScheduledPaymentModalMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CustomerEmailModalMsg = function (a) {
	return {$: 45, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$DeleteInvoiceHiConfirmClosed = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$DownloadInvoiceMsg = function (a) {
	return {$: 44, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$EditInvoiceModalMsg = function (a) {
	return {$: 34, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$PaymentsListMsg = function (a) {
	return {$: 46, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ProcessRefundModalMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$SchedulePaymentModalMsg = function (a) {
	return {$: 41, a: a};
};
var $author$project$Components$CustomerInvoice$AdjustVoidModal$Close = {$: 1};
var $author$project$Components$CustomerInvoice$AdjustVoidModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$CustomerInvoice$AdjustVoidModal$Close);
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$Close = {$: 1};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$CustomerInvoice$ProcessRefundModal$Close);
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$Close = {$: 0};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$subscriptions = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.SD);
	var dropdownSubs = A2(
		$elm$core$List$map,
		function (sp) {
			return $author$project$Ui$Dropdown$subscriptions(sp.o5);
		},
		fields.i);
	return $elm$core$Platform$Sub$batch(
		A2(
			$elm$core$List$cons,
			$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Invoice$CreateScheduledPaymentModal$Close),
			dropdownSubs));
};
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$CancelInvoiceEdit = {$: 2};
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$LocationResourceFilterMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$PatientResourceFilterMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				function () {
				var _v0 = model.av;
				if (!_v0.$) {
					return $author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$CancelInvoiceEdit);
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$ResourceFilter$Patient$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$PatientResourceFilterMsg)),
					model.oY)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$ResourceFilter$Location$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$LocationResourceFilterMsg)),
					model.os))
			]));
};
var $author$project$Components$Patient$Charges$ChargeModal$CategoryResourceFilterMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Patient$Charges$ChargeModal$ChargeItemResourceFilterMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Patient$Charges$ChargeModal$CloseClicked = {$: 0};
var $author$project$Components$Patient$Charges$ChargeModal$LimitedPatientSelectorMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Patient$Charges$ChargeModal$LocationResourceFilterMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Patient$Charges$ChargeModal$PractitionerResourceFilterMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Patient$Charges$ChargeModal$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Patient$Charges$ChargeModal$CloseClicked),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Patient$Charges$ChargeModal$LimitedPatientSelectorMsg,
				$author$project$Components$LimitedPatientSelector$subscriptions(
					$author$project$Utils$Form$fields(model.SD).oj)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Patient$Charges$ChargeModal$PractitionerResourceFilterMsg,
				$author$project$Components$ResourceFilter$Practitioner$subscriptions(
					$author$project$Utils$Form$fields(model.SD).hk)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Patient$Charges$ChargeModal$CategoryResourceFilterMsg,
				$author$project$Components$ResourceFilter$Category$subscriptions(
					$author$project$Utils$Form$fields(model.SD).c8)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Patient$Charges$ChargeModal$ChargeItemResourceFilterMsg,
				$author$project$Components$ResourceFilter$ChargeItem$subscriptions(
					$author$project$Utils$Form$fields(model.SD).cq)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Patient$Charges$ChargeModal$LocationResourceFilterMsg,
				$author$project$Components$ResourceFilter$Location$subscriptions(
					$author$project$Utils$Form$fields(model.SD).os))
			]));
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$SchedulePaymentModalMsg,
				$author$project$Components$CustomerSchedulePaymentModal$subscriptions(model.hw)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CreatePaymentModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Invoice$CreatePaymentModal$subscriptions, model.m$))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CreateScheduledPaymentModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Invoice$CreateScheduledPaymentModal$subscriptions, model.i$))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ChargeModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Patient$Charges$ChargeModal$subscriptions, model.fX))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$EditInvoiceModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$subscriptions, model.jw))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$AdjustVoidModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$CustomerInvoice$AdjustVoidModal$subscriptions, model.ik))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ProcessRefundModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$CustomerInvoice$ProcessRefundModal$subscriptions, model.kO))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$DownloadInvoiceMsg,
				$author$project$Components$Invoice$DownloadFile$subscriptions(model.jt)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CustomerEmailModalMsg,
				$author$project$Components$CustomerEmailModal$subscriptions(model.m5)),
				model.i7 ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$DeleteInvoiceHiConfirmClosed) : $elm$core$Platform$Sub$none,
				model.iy ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$BadDebtHiConfirmClosed) : $elm$core$Platform$Sub$none,
				function () {
				var _v0 = model.iw;
				if (!_v0.$) {
					var auditTrailLog = _v0.a;
					return $author$project$Components$AuditTrailLog$isOpen(auditTrailLog) ? A2(
						$elm$core$Platform$Sub$map,
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$AuditTrailLogMsg,
						$author$project$Components$AuditTrailLog$subscriptions(auditTrailLog)) : $elm$core$Platform$Sub$none;
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				$author$project$Ui$Dropdown$subscriptions(model.lJ),
				$author$project$Ui$Dropdown$subscriptions(model.oO),
				$elm$core$Platform$Sub$batch(
				A2(
					$elm$core$List$map,
					A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $author$project$Ui$Dropdown$subscriptions),
					model.iI)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$PaymentsListMsg,
				$author$project$Components$PaymentsList$subscriptions(model.kD))
			]));
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ChargeDeleted = function (a) {
	return {$: 22, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotBankAccounts = function (a) {
	return {$: 50, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotCards = function (a) {
	return {$: 51, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotCoverageDiscounts = F2(
	function (a, b) {
		return {$: 36, a: a, b: b};
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotScheduledPayments = function (a) {
	return {$: 49, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$InvoiceIssued = function (a) {
	return {$: 19, a: a};
};
var $author$project$Api$FeatureGate$ScheduledPartialPayments = 12;
var $author$project$Api$Provider$CustomerInvoice$applyCredits = F4(
	function (apiClient, id, expand, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CustomerInvoice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2(
						$author$project$Api$Param$list,
						'expand',
						A2($elm$core$List$map, $author$project$Api$Provider$CustomerInvoice$expandToString, expand))
					]),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['apply_credits']),
						$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id)))));
	});
var $author$project$Api$Provider$CustomerInvoice$cancelPayment = F4(
	function (apiClient, id, expand, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CustomerInvoice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2(
						$author$project$Api$Param$list,
						'expand',
						A2($elm$core$List$map, $author$project$Api$Provider$CustomerInvoice$expandToString, expand))
					]),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['cancel_payment']),
						$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id)))));
	});
var $author$project$Api$Provider$CustomerInvoice$One$createdAt = function (_v0) {
	var record = _v0.b;
	return record.O1;
};
var $author$project$Api$Provider$CustomerInvoice$Charge$chargesPath = function (customerInvoiceId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['charges']),
		A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[customerInvoiceId]),
			A2(
				$author$project$Api$Data$pathAppend,
				_List_fromArray(
					['customer_invoices']),
				$author$project$Api$Data$providerPath)));
};
var $author$project$Api$Provider$CustomerInvoice$Charge$chargePath = F2(
	function (customerInvoiceId, id_) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id_]),
			$author$project$Api$Provider$CustomerInvoice$Charge$chargesPath(customerInvoiceId));
	});
var $author$project$Api$Provider$CustomerInvoice$Charge$delete = F4(
	function (apiClient, customerInvoiceId, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Provider$CustomerInvoice$Charge$chargePath, customerInvoiceId, id_)));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$InvoiceDeleted = function (a) {
	return {$: 17, a: a};
};
var $author$project$Api$Provider$CustomerInvoice$delete = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id)));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$deleteInvoice = function (model) {
	var _v0 = model.Uk;
	if (_v0.$ === 3) {
		var invoice = _v0.a;
		return _Utils_Tuple3(
			model,
			A3(
				$author$project$Api$Provider$CustomerInvoice$delete,
				model.Gv,
				$author$project$Api$Provider$CustomerInvoice$One$id(invoice),
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$InvoiceDeleted),
			_List_Nil);
	} else {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	}
};
var $author$project$Api$Provider$ScheduledPayment$Shared$paymentSource = function (_v0) {
	var record = _v0;
	return record.Zg;
};
var $author$project$Api$Provider$ScheduledPayment$Shared$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$allScheduledPaymentsAreNonCard = function (scheduledPayments) {
	var scheduled = A2(
		$elm$core$List$filter,
		function (sp) {
			return $author$project$Api$Provider$ScheduledPayment$Shared$status(sp) === 'scheduled';
		},
		scheduledPayments);
	return (!$elm$core$List$isEmpty(scheduled)) && A2(
		$elm$core$List$all,
		function (sp) {
			var _v0 = $author$project$Api$Provider$ScheduledPayment$Shared$paymentSource(sp);
			if (!_v0.$) {
				var source = _v0.a;
				return !_Utils_eq(
					$author$project$Api$Common$Source$Shared$type_(source),
					$elm$core$Maybe$Just('Card'));
			} else {
				return false;
			}
		},
		scheduled);
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewDefaultCard = function (cards) {
	if (cards.$ === 3) {
		var cards_ = cards.a;
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				$author$project$Api$Source$default,
				A2($elm$core$List$map, $author$project$Api$Source$Card, cards_)));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$effectivePaymentSource = F4(
	function (practice, invoice, cards, scheduledPayments) {
		if ($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$allScheduledPaymentsAreNonCard(scheduledPayments)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = $author$project$Api$Provider$Practice$One$allowMultipleRetailMemberships(practice) ? $author$project$Api$Provider$CustomerInvoice$One$membershipPaymentSource(invoice) : $elm$core$Maybe$Nothing;
			if (!_v0.$) {
				var source = _v0.a;
				return _Utils_eq(
					$author$project$Api$Common$Source$Shared$type_(source),
					$elm$core$Maybe$Just('Card')) ? $elm$core$Maybe$Just(
					$author$project$Api$Source$Source(source)) : $elm$core$Maybe$Nothing;
			} else {
				return $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewDefaultCard(cards);
			}
		}
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotPassthroughFees = function (a) {
	return {$: 53, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$fetchPassthroughFeesCmd = F4(
	function (apiClient, amount, sourceChoice, patientId) {
		var _v0 = A2($elm$core$Maybe$map, $author$project$Api$Source$id, sourceChoice);
		if (!_v0.$) {
			var sourceId = _v0.a;
			return A6(
				$author$project$Api$Provider$PassthroughFee$One$calculatePassthroughFees,
				apiClient,
				patientId,
				$elm$core$Maybe$Just(sourceId),
				$elm$core$Maybe$Nothing,
				amount,
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotPassthroughFees);
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$DateInputMsg = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Api$Provider$CustomerInvoice$Shared$date = function (_v0) {
	var record = _v0;
	return record.PB;
};
var $author$project$Api$Provider$CustomerInvoice$One$date = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CustomerInvoice$Shared$date(shared);
};
var $author$project$Api$Provider$CustomerInvoice$One$location = function (_v0) {
	var record = _v0.b;
	return record.ais;
};
var $author$project$Api$Provider$CustomerInvoice$One$owner = function (_v0) {
	var record = _v0.b;
	return record.YD;
};
var $author$project$Components$Membership$Form$Records$patientFromShared = function (patient) {
	return {
		Lj: $author$project$Api$Provider$Patient$Shared$age(patient),
		ahP: $author$project$Api$Provider$Patient$Shared$id(patient),
		ais: $elm$core$Maybe$Nothing,
		WX: $author$project$Api$Provider$Patient$Shared$membershipStatus(patient),
		Bq: $author$project$Api$Provider$Patient$Shared$name(patient),
		aka: $elm$core$Maybe$Nothing,
		ad9: $author$project$Api$Provider$Patient$Shared$usesTobacco(patient)
	};
};
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$formFieldsFromInvoice = function (invoice) {
	var payer = function () {
		var _v2 = $author$project$Api$Provider$CustomerInvoice$One$owner(invoice);
		if (!_v2.$) {
			var patient = _v2.a;
			return $author$project$Components$Membership$Form$Records$patientFromShared(patient);
		} else {
			return {Lj: $elm$core$Maybe$Nothing, ahP: '', ais: $elm$core$Maybe$Nothing, WX: '', Bq: '', aka: $elm$core$Maybe$Nothing, ad9: $elm$core$Maybe$Nothing};
		}
	}();
	var locationId = function () {
		var _v1 = $author$project$Api$Provider$CustomerInvoice$One$location(invoice);
		if (!_v1.$) {
			var location = _v1.a;
			return $author$project$Api$Provider$Location$Min$id(location);
		} else {
			return '';
		}
	}();
	var _v0 = $author$project$Components$DateInput$init;
	var dateInput = _v0.a;
	var dateInputCmd = _v0.b;
	return _Utils_Tuple2(
		{
			rZ: dateInput,
			Uq: $elm$core$Maybe$Just(
				$author$project$Api$Provider$CustomerInvoice$One$date(invoice)),
			We: $elm$core$Maybe$Just(locationId),
			I6: $elm$core$Maybe$Just(payer)
		},
		A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$DateInputMsg(dateInput),
			dateInputCmd));
};
var $author$project$Components$ResourceFilter$Location$resourceFromMin = $elm$core$Maybe$map(
	function (location) {
		return {
			Li: $elm$core$Maybe$Nothing,
			ahP: $author$project$Api$Provider$Location$Min$id(location),
			UV: false,
			Vf: false,
			Wf: '',
			Bq: $author$project$Api$Provider$Location$Min$name(location),
			ZY: ''
		};
	});
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$initLocationResourceFilter = F2(
	function (apiClient, invoice) {
		var invoiceLocation = $author$project$Api$Provider$CustomerInvoice$One$location(invoice);
		var _v0 = A4(
			$author$project$Components$ResourceFilter$Location$init,
			apiClient,
			$elm$core$Maybe$Nothing,
			$elm$core$Basics$identity,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Select a location', Lr: false});
			});
		var locationResourceFilterModel = _v0.a;
		var locationResourceFilterCmd = _v0.b;
		var locationResourceFilter = function () {
			if (!invoiceLocation.$) {
				var location = invoiceLocation.a;
				return function (value) {
					return A2($author$project$Components$ResourceFilter$Location$setValue, value, locationResourceFilterModel);
				}(
					$author$project$Components$ResourceFilter$Location$resourceFromMin(
						$elm$core$Maybe$Just(location)));
			} else {
				return locationResourceFilterModel;
			}
		}();
		return _Utils_Tuple2(locationResourceFilter, locationResourceFilterCmd);
	});
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$initPatientResourceFilter = F2(
	function (apiClient, preselectedPatient) {
		return A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Components$ResourceFilter$Patient$extraItems(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (patient_) {
							return _List_fromArray(
								[
									{
									Lj: $author$project$Api$Provider$Patient$Shared$age(patient_),
									ahP: $author$project$Api$Provider$Patient$Shared$id(patient_),
									WX: $author$project$Api$Provider$Patient$Shared$membershipStatus(patient_),
									Bq: $author$project$Api$Provider$Patient$Shared$name(patient_)
								}
								]);
						},
						preselectedPatient))),
			A2(
				$author$project$Components$ResourceFilter$Patient$init,
				apiClient,
				function (d) {
					return _Utils_update(
						d,
						{
							Gp: 'Select a Payer',
							Lr: false,
							akb: A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Shared$id, preselectedPatient)
						});
				}));
	});
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$init = F2(
	function (apiClient, invoice) {
		var invoicePayer = $author$project$Api$Provider$CustomerInvoice$One$owner(invoice);
		var _v0 = A2($author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$initPatientResourceFilter, apiClient, invoicePayer);
		var patientResourceFilter = _v0.a;
		var patientResourceFilterCmd = _v0.b;
		var _v1 = A2($author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$initLocationResourceFilter, apiClient, invoice);
		var locationResourceFilter = _v1.a;
		var locationResourceFilterCmd = _v1.b;
		var _v2 = $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$formFieldsFromInvoice(invoice);
		var form = _v2.a;
		var formCmd = _v2.b;
		return _Utils_Tuple2(
			{
				Aa: true,
				av: $elm$core$Maybe$Just(
					_Utils_Tuple3(
						$author$project$Api$Provider$CustomerInvoice$One$id(invoice),
						$author$project$Utils$Form$init(form),
						invoice)),
				V8: false,
				os: $elm$core$Maybe$Just(locationResourceFilter),
				oY: $elm$core$Maybe$Just(patientResourceFilter)
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$PatientResourceFilterMsg, patientResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$LocationResourceFilterMsg, locationResourceFilterCmd),
						formCmd
					])));
	});
var $author$project$Components$Patient$Charges$ChargeModal$EndDateInputMsg = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$Patient$Charges$ChargeModal$StartDateInputMsg = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$age = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$age(shared);
};
var $author$project$Components$Patient$Charges$ChargeModal$chargeItemResourceConfig = function (d) {
	return _Utils_update(
		d,
		{Gp: 'None', Lr: false, ahw: true, ahx: '', ahG: true, ahH: true, ai5: false});
};
var $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$location = function (_v0) {
	var record = _v0.b;
	return record.ais;
};
var $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$membershipStatus = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$membershipStatus(shared);
};
var $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$practitioner = function (_v0) {
	var record = _v0.b;
	return record.aka;
};
var $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$usesTobacco = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$usesTobacco(shared);
};
var $author$project$Components$Patient$Charges$ChargeModal$initLimitedPatientSelector = F3(
	function (apiClient, probablePatients, patient) {
		return A4(
			$author$project$Components$LimitedPatientSelector$init,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Select a Patient', Lr: false});
			},
			A2(
				$elm$core$List$map,
				function (patient_) {
					return {
						Lj: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$age(patient_),
						ahP: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$id(patient_),
						ais: A2(
							$elm$core$Maybe$map,
							function (location) {
								return {
									ahP: $author$project$Api$Provider$Location$Min$id(location),
									Bq: $author$project$Api$Provider$Location$Min$name(location)
								};
							},
							$author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$location(patient_)),
						WX: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$membershipStatus(patient_),
						Bq: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$name(patient_),
						aka: A2(
							$elm$core$Maybe$map,
							function (practitioner) {
								return {
									ahP: $author$project$Api$Provider$Practitioner$Min$id(practitioner),
									Bq: $author$project$Api$Provider$Practitioner$Min$name(practitioner)
								};
							},
							$author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$practitioner(patient_)),
						ad9: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$usesTobacco(patient_)
					};
				},
				probablePatients),
			patient);
	});
var $author$project$Components$Patient$Charges$ChargeModal$formFieldsFromItem = F5(
	function (apiClient, showItemTypeInTitle, session, probablePatients, charge) {
		var practitioner = $author$project$Api$Provider$Charge$One$practitioner(charge);
		var patient = $author$project$Api$Provider$Charge$One$patient(charge);
		var location = $author$project$Api$Provider$Charge$One$location(charge);
		var formPatient = A2(
			$elm$core$Maybe$map,
			function (patient_) {
				return {
					ahP: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$id(patient_),
					Bq: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$name(patient_)
				};
			},
			patient);
		var chargeItem = A2(
			$elm$core$Maybe$map,
			function (chargeItem_) {
				return {
					Lm: $author$project$Api$Provider$ChargeItem$ForCharge$alertQuantity(chargeItem_),
					GW: $author$project$Api$Provider$Charge$One$category(charge),
					NN: $author$project$Api$Provider$ChargeItem$ForCharge$code(chargeItem_),
					NP: $author$project$Api$Provider$ChargeItem$ForCharge$codeType(chargeItem_),
					Qr: $author$project$Api$Provider$ChargeItem$ForCharge$description(chargeItem_),
					ahP: $author$project$Api$Provider$ChargeItem$ForCharge$id(chargeItem_),
					aid: $author$project$Api$Provider$ChargeItem$ForCharge$isPackage(chargeItem_),
					sW: $author$project$Api$Provider$ChargeItem$ForCharge$isPackage(chargeItem_) ? 1 : 0,
					Wt: $author$project$Api$Provider$ChargeItem$ForCharge$manufacturer(chargeItem_),
					Bq: $author$project$Api$Provider$ChargeItem$ForCharge$name(chargeItem_),
					Dw: $author$project$Api$Provider$ChargeItem$ForCharge$priceInCents(chargeItem_),
					_P: $author$project$Api$Provider$ChargeItem$ForCharge$quantityInStock(chargeItem_),
					acZ: $author$project$Api$Provider$ChargeItem$ForCharge$taxable(chargeItem_),
					ads: $author$project$Api$Provider$ChargeItem$ForCharge$trackInventory(chargeItem_),
					adP: $author$project$Api$Provider$ChargeItem$ForCharge$uom(chargeItem_)
				};
			},
			$author$project$Api$Provider$Charge$One$chargeItem(charge));
		var category = $author$project$Api$Provider$Charge$One$category(charge);
		var _v0 = $author$project$Components$DateInput$init;
		var startDateInput = _v0.a;
		var startDateInputCmd = _v0.b;
		var _v1 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Components$ResourceFilter$Practitioner$extraItems(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (practitioner_) {
							return _List_fromArray(
								[
									{
									ahP: $author$project$Api$Provider$Practitioner$Shared$id(practitioner_),
									Bq: $author$project$Api$Provider$Practitioner$Shared$name(practitioner_)
								}
								]);
						},
						practitioner))),
			A3(
				$author$project$Components$ResourceFilter$Practitioner$init,
				apiClient,
				$elm$core$Basics$identity,
				function (d) {
					return _Utils_update(
						d,
						{
							Gp: 'Unassigned',
							ai5: false,
							akb: A2($elm$core$Maybe$map, $author$project$Api$Provider$Practitioner$Shared$id, practitioner)
						});
				}));
		var practitionerResourceFilter = _v1.a;
		var practitionerResourceFilterCmd = _v1.b;
		var _v2 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Components$ResourceFilter$Location$extraItems(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (location_) {
							return _List_fromArray(
								[
									{
									ahP: $author$project$Api$Provider$Location$Min$id(location_),
									Bq: $author$project$Api$Provider$Location$Min$name(location_)
								}
								]);
						},
						location))),
			A4(
				$author$project$Components$ResourceFilter$Location$init,
				apiClient,
				$elm$core$Maybe$Nothing,
				$elm$core$Basics$identity,
				function (d) {
					return _Utils_update(
						d,
						{
							Gp: 'Unassigned',
							ai5: false,
							akb: A2($elm$core$Maybe$map, $author$project$Api$Provider$Location$Min$id, location)
						});
				}));
		var locationResourceFilter = _v2.a;
		var locationResourceFilterCmd = _v2.b;
		var _v3 = A3(
			$author$project$Components$Patient$Charges$ChargeModal$initLimitedPatientSelector,
			apiClient,
			probablePatients,
			A2(
				$elm$core$Maybe$map,
				function (patient_) {
					return {
						Lj: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$age(patient_),
						ahP: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$id(patient_),
						ais: A2(
							$elm$core$Maybe$map,
							function (location_) {
								return {
									ahP: $author$project$Api$Provider$Location$Min$id(location_),
									Bq: $author$project$Api$Provider$Location$Min$name(location_)
								};
							},
							$author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$location(patient_)),
						WX: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$membershipStatus(patient_),
						Bq: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$name(patient_),
						aka: A2(
							$elm$core$Maybe$map,
							function (practitioner_) {
								return {
									ahP: $author$project$Api$Provider$Practitioner$Min$id(practitioner_),
									Bq: $author$project$Api$Provider$Practitioner$Min$name(practitioner_)
								};
							},
							$author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$practitioner(patient_)),
						ad9: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$usesTobacco(patient_)
					};
				},
				patient));
		var limitedPatientSelector = _v3.a;
		var limitedPatientSelectorCmd = _v3.b;
		var _v4 = $author$project$Components$DateInput$init;
		var endDateInput = _v4.a;
		var endDateInputCmd = _v4.b;
		var _v5 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Components$ResourceFilter$ChargeItem$setValue(
				A2(
					$elm$core$Maybe$withDefault,
					$author$project$Components$ResourceFilter$FreeText(
						A2(
							$elm$core$Maybe$withDefault,
							'',
							$author$project$Api$Provider$Charge$One$name(charge))),
					A2(
						$elm$core$Maybe$map,
						function (chargeItem_) {
							return $author$project$Components$ResourceFilter$One(
								{Lm: chargeItem_.Lm, GW: chargeItem_.GW, NN: chargeItem_.NN, NP: chargeItem_.NP, Qr: chargeItem_.Qr, ahP: chargeItem_.ahP, aid: chargeItem_.aid, sW: chargeItem_.sW, Wt: chargeItem_.Wt, Bq: chargeItem_.Bq, Dw: chargeItem_.Dw, _P: chargeItem_._P, acZ: chargeItem_.acZ, ads: chargeItem_.ads, adP: chargeItem_.adP});
						},
						chargeItem))),
			A4($author$project$Components$ResourceFilter$ChargeItem$initWithItemType, showItemTypeInTitle, apiClient, $elm$core$Basics$identity, $author$project$Components$Patient$Charges$ChargeModal$chargeItemResourceConfig));
		var chargeItemResourceFilter = _v5.a;
		var chargeItemResourceFilterCmd = _v5.b;
		var _v6 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Components$ResourceFilter$Category$extraItems(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (category_) {
							return _List_fromArray(
								[
									{
									ahP: $author$project$Api$Provider$Category$Shared$id(category_),
									Bq: $author$project$Api$Provider$Category$Shared$name(category_)
								}
								]);
						},
						category))),
			A3(
				$author$project$Components$ResourceFilter$Category$init,
				apiClient,
				session,
				function (d) {
					return _Utils_update(
						d,
						{
							Gp: 'Unassigned',
							ai5: false,
							akb: A2($elm$core$Maybe$map, $author$project$Api$Provider$Category$Shared$id, category)
						});
				}));
		var categoryResourceFilter = _v6.a;
		var categoryResourceFilterCmd = _v6.b;
		return _Utils_Tuple2(
			{
				GW: A2(
					$elm$core$Maybe$map,
					$author$project$Api$Provider$Category$Shared$id,
					$author$project$Api$Provider$Charge$One$category(charge)),
				c8: categoryResourceFilter,
				mL: chargeItem,
				cq: chargeItemResourceFilter,
				Qr: $author$project$Api$Provider$Charge$One$description(charge),
				QD: $author$project$Api$Provider$Charge$One$discountInCents(charge),
				QE: $author$project$Api$Provider$Charge$One$discountOverridden(charge),
				sb: $author$project$Api$Provider$Charge$One$endDate(charge),
				sd: endDateInput,
				ahP: $elm$core$Maybe$Just(
					$author$project$Api$Provider$Charge$One$id(charge)),
				oj: limitedPatientSelector,
				ais: A2($elm$core$Maybe$map, $author$project$Api$Provider$Location$Min$id, location),
				os: locationResourceFilter,
				Bq: $author$project$Api$Provider$Charge$One$name(charge),
				YY: formPatient,
				aka: A2($elm$core$Maybe$map, $author$project$Api$Provider$Practitioner$Shared$id, practitioner),
				hk: practitionerResourceFilter,
				Dw: $author$project$Currency$fromMaybeInt(
					$author$project$Api$Provider$Charge$One$priceInCents(charge)),
				_h: $elm$core$Maybe$Just(
					$author$project$Api$Provider$Charge$One$priceUom(charge)),
				Dz: $elm$core$Maybe$Just(
					$author$project$Api$Provider$Charge$One$quantity(charge)),
				DA: $elm$core$Maybe$Just(
					$author$project$Api$Provider$Charge$One$quantityUom(charge)),
				ab7: $elm$core$Maybe$Just(
					$author$project$Api$Provider$Charge$One$date(charge)),
				lx: startDateInput,
				acZ: A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						$author$project$Api$Provider$ChargeItem$ForCharge$taxable,
						$author$project$Api$Provider$Charge$One$chargeItem(charge)))
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Components$Patient$Charges$ChargeModal$StartDateInputMsg(startDateInput),
						startDateInputCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Components$Patient$Charges$ChargeModal$EndDateInputMsg(endDateInput),
						endDateInputCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$LimitedPatientSelectorMsg, limitedPatientSelectorCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$ChargeItemResourceFilterMsg, chargeItemResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$CategoryResourceFilterMsg, categoryResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$PractitionerResourceFilterMsg, practitionerResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$LocationResourceFilterMsg, locationResourceFilterCmd)
					])));
	});
var $author$project$Components$Patient$Charges$ChargeModal$initFormFields = F6(
	function (apiClient, showItemTypeInTitle, session, date, probablePatients, patient) {
		var maybePractitioner = A2(
			$elm$core$Maybe$map,
			function (prac) {
				return {
					Li: $elm$core$Maybe$Nothing,
					ahP: $author$project$Api$Provider$Practitioner$Shared$id(prac),
					UV: $author$project$Api$Provider$Practitioner$Shared$isMaster(prac),
					Vf: $author$project$Api$Provider$Practitioner$Shared$isSynced(prac),
					Bq: $author$project$Api$Provider$Practitioner$Shared$name(prac),
					Yp: $author$project$Api$Provider$Practitioner$Shared$openingsSize(prac),
					ZY: '',
					Z3: ''
				};
			},
			$author$project$Api$Provider$Patient$One$practitioner(patient));
		var maybeLocation = A2(
			$elm$core$Maybe$map,
			function (loc) {
				return {
					Li: $elm$core$Maybe$Nothing,
					ahP: $author$project$Api$Provider$Location$Shared$id(loc),
					UV: false,
					Vf: false,
					Wf: '',
					Bq: $author$project$Api$Provider$Location$Shared$name(loc),
					ZY: ''
				};
			},
			$author$project$Api$Provider$Patient$One$location(patient));
		var _v0 = $author$project$Components$DateInput$init;
		var startDateInput = _v0.a;
		var startDateInputCmd = _v0.b;
		var _v1 = A2(
			$elm$core$Tuple$mapFirst,
			function (filter) {
				return A2($author$project$Components$ResourceFilter$Practitioner$setValue, maybePractitioner, filter);
			},
			A3(
				$author$project$Components$ResourceFilter$Practitioner$init,
				apiClient,
				$elm$core$Basics$identity,
				function (d) {
					return _Utils_update(
						d,
						{Gp: 'Unassigned', ai5: false});
				}));
		var practitionerResourceFilter = _v1.a;
		var practitionerResourceFilterCmd = _v1.b;
		var _v2 = A2(
			$elm$core$Tuple$mapFirst,
			function (filter) {
				return A2($author$project$Components$ResourceFilter$Location$setValue, maybeLocation, filter);
			},
			A4(
				$author$project$Components$ResourceFilter$Location$init,
				apiClient,
				$elm$core$Maybe$Nothing,
				$elm$core$Basics$identity,
				function (d) {
					return _Utils_update(
						d,
						{Gp: 'Unassigned', ai5: false});
				}));
		var locationResourceFilter = _v2.a;
		var locationResourceFilterCmd = _v2.b;
		var _v3 = A3(
			$author$project$Components$Patient$Charges$ChargeModal$initLimitedPatientSelector,
			apiClient,
			probablePatients,
			$elm$core$Maybe$Just(
				{
					Lj: $author$project$Api$Provider$Patient$One$age(patient),
					ahP: $author$project$Api$Provider$Patient$One$id(patient),
					ais: A2(
						$elm$core$Maybe$map,
						function (location) {
							return {
								ahP: $author$project$Api$Provider$Location$Shared$id(location),
								Bq: $author$project$Api$Provider$Location$Shared$name(location)
							};
						},
						$author$project$Api$Provider$Patient$One$location(patient)),
					WX: $author$project$Api$Provider$Patient$One$membershipStatus(patient),
					Bq: $author$project$Api$Provider$Patient$One$name(patient),
					aka: A2(
						$elm$core$Maybe$map,
						function (practitioner) {
							return {
								ahP: $author$project$Api$Provider$Practitioner$Shared$id(practitioner),
								Bq: $author$project$Api$Provider$Practitioner$Shared$name(practitioner)
							};
						},
						$author$project$Api$Provider$Patient$One$practitioner(patient)),
					ad9: $author$project$Api$Provider$Patient$One$usesTobacco(patient)
				}));
		var limitedPatientSelector = _v3.a;
		var limitedPatientSelectorCmd = _v3.b;
		var _v4 = $author$project$Components$DateInput$init;
		var endDateInput = _v4.a;
		var endDateInputCmd = _v4.b;
		var _v5 = A4($author$project$Components$ResourceFilter$ChargeItem$initWithItemType, showItemTypeInTitle, apiClient, $elm$core$Basics$identity, $author$project$Components$Patient$Charges$ChargeModal$chargeItemResourceConfig);
		var chargeItemResourceFilter = _v5.a;
		var chargeItemResourceFilterCmd = _v5.b;
		var _v6 = A3(
			$author$project$Components$ResourceFilter$Category$init,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Unassigned', ai5: false});
			});
		var categoryResourceFilter = _v6.a;
		var categoryResourceFilterCmd = _v6.b;
		return _Utils_Tuple2(
			{
				GW: $elm$core$Maybe$Nothing,
				c8: categoryResourceFilter,
				mL: $elm$core$Maybe$Nothing,
				cq: chargeItemResourceFilter,
				Qr: '',
				QD: 0,
				QE: false,
				sb: $elm$core$Maybe$Nothing,
				sd: endDateInput,
				ahP: $elm$core$Maybe$Nothing,
				oj: limitedPatientSelector,
				ais: A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.ahP;
					},
					maybeLocation),
				os: locationResourceFilter,
				Bq: $elm$core$Maybe$Nothing,
				YY: $elm$core$Maybe$Just(
					{
						ahP: $author$project$Api$Provider$Patient$One$id(patient),
						Bq: $author$project$Api$Provider$Patient$One$name(patient)
					}),
				aka: A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.ahP;
					},
					maybePractitioner),
				hk: practitionerResourceFilter,
				Dw: $elm$core$Maybe$Nothing,
				_h: $elm$core$Maybe$Nothing,
				Dz: $elm$core$Maybe$Just(1),
				DA: $elm$core$Maybe$Nothing,
				ab7: $elm$core$Maybe$Just(date),
				lx: startDateInput,
				acZ: false
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Components$Patient$Charges$ChargeModal$StartDateInputMsg(startDateInput),
						startDateInputCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Components$Patient$Charges$ChargeModal$EndDateInputMsg(endDateInput),
						endDateInputCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$LimitedPatientSelectorMsg, limitedPatientSelectorCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$ChargeItemResourceFilterMsg, chargeItemResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$CategoryResourceFilterMsg, categoryResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$PractitionerResourceFilterMsg, practitionerResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$LocationResourceFilterMsg, locationResourceFilterCmd)
					])));
	});
var $author$project$Api$Provider$CustomerInvoice$One$probablePatients = function (_v0) {
	var record = _v0.b;
	return record._m;
};
var $author$project$Components$Patient$Charges$ChargeModal$init = F6(
	function (apiClient, session, practice, patient, invoice, charge) {
		var showItemTypeInTitle = A2(
			$author$project$Utils$FeatureGate$gateAvailable,
			14,
			$author$project$Api$Practice$Provider(practice));
		var _v0 = function () {
			if (!charge.$) {
				var charge_ = charge.a;
				return A5(
					$author$project$Components$Patient$Charges$ChargeModal$formFieldsFromItem,
					apiClient,
					showItemTypeInTitle,
					session,
					$author$project$Api$Provider$CustomerInvoice$One$probablePatients(invoice),
					charge_);
			} else {
				var date = $author$project$Api$Provider$CustomerInvoice$One$date(invoice);
				return A6(
					$author$project$Components$Patient$Charges$ChargeModal$initFormFields,
					apiClient,
					showItemTypeInTitle,
					session,
					date,
					$author$project$Api$Provider$CustomerInvoice$One$probablePatients(invoice),
					patient);
			}
		}();
		var formFields = _v0.a;
		var formCmd = _v0.b;
		return _Utils_Tuple2(
			{
				xM: A2(
					$elm$core$Maybe$withDefault,
					true,
					A2(
						$elm$core$Maybe$map,
						$author$project$Api$Provider$Charge$Meta$priceInCentsEditable,
						A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$One$meta, charge))),
				afx: charge,
				SD: $author$project$Utils$Form$init(formFields),
				Uk: invoice,
				YY: patient,
				ZV: practice,
				akd: $author$project$Api$Data$NotAsked,
				eW: $jinjor$elm_debounce$Debounce$init,
				pR: false,
				aa4: session,
				hD: false
			},
			formCmd);
	});
var $author$project$Components$CustomerInvoice$AdjustVoidModal$AdjustmentsFormMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$ChargeAdjustmentFormMsg = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$CustomerInvoice$AdjustmentsForm$Model = $elm$core$Basics$identity;
var $author$project$Components$CustomerInvoice$AdjustmentsForm$VoidAll = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$CustomerInvoice$One$charges = function (_v0) {
	var record = _v0.b;
	return record.NA;
};
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$Model = $elm$core$Basics$identity;
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$initFormFields = F2(
	function (charge, voidOnly) {
		return {
			afx: charge,
			mL: $author$project$Api$Provider$Charge$One$chargeItem(charge),
			PB: $author$project$Api$Provider$Charge$One$date(charge),
			zh: false,
			sb: $author$project$Api$Provider$Charge$One$endDate(charge),
			sd: A2(
				$elm$core$Maybe$map,
				$author$project$Components$DateInput$initFromDate,
				$author$project$Api$Provider$Charge$One$endDate(charge)),
			Dw: A2(
				$elm$core$Maybe$map,
				$author$project$Currency$fromInt,
				$author$project$Api$Provider$Charge$One$priceInCents(charge)),
			Dz: $elm$core$Maybe$Just(
				$author$project$Api$Provider$Charge$One$quantity(charge)),
			DA: $author$project$Api$Provider$Charge$One$quantityUom(charge),
			e6: false,
			_: (!$author$project$Api$Provider$Charge$One$quantity(charge)) || voidOnly,
			Ko: false
		};
	});
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$init = F2(
	function (charge, voidOnly) {
		var form = $author$project$Utils$Form$init(
			A2($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$initFormFields, charge, voidOnly));
		return _Utils_Tuple2(
			{vD: $elm$core$Maybe$Nothing, SD: form, F8: voidOnly},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Components$CustomerInvoice$AdjustmentsForm$init = F2(
	function (invoice, _v0) {
		var voidOnly = _v0.F8;
		var refunding = _v0.akC;
		var voidCmd = voidOnly ? A2(
			$elm$core$Task$perform,
			$author$project$Components$CustomerInvoice$AdjustmentsForm$VoidAll,
			$elm$core$Task$succeed(true)) : $elm$core$Platform$Cmd$none;
		var adjustments = A2(
			$elm$core$List$map,
			function (charge) {
				return _Utils_Tuple2(
					$author$project$Api$Provider$Charge$One$id(charge),
					A2($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$init, charge, voidOnly));
			},
			A2(
				$author$project$Api$Expandable$withDefault,
				_List_Nil,
				$author$project$Api$Provider$CustomerInvoice$One$charges(invoice)));
		var adjustmentsCmds = A2(
			$elm$core$List$map,
			function (_v2) {
				var chargeId = _v2.a;
				var adjustment = _v2.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Components$CustomerInvoice$AdjustmentsForm$ChargeAdjustmentFormMsg(chargeId),
					adjustment.b);
			},
			adjustments);
		var forms = A2(
			$elm$core$List$map,
			function (_v1) {
				var chargeId = _v1.a;
				var adjustment = _v1.b;
				return _Utils_Tuple2(chargeId, adjustment.a);
			},
			adjustments);
		return _Utils_Tuple2(
			{ap: forms, agX: _List_Nil, Uk: invoice, aiG: $elm$core$Maybe$Nothing, akd: $author$project$Api$Data$NotAsked, akC: refunding, qD: 0, F8: voidOnly},
			$elm$core$Platform$Cmd$batch(
				A2($elm$core$List$cons, voidCmd, adjustmentsCmds)));
	});
var $author$project$Components$CustomerInvoice$AdjustVoidModal$init = F2(
	function (invoice, voidOnly) {
		var _v0 = A2(
			$author$project$Components$CustomerInvoice$AdjustmentsForm$init,
			invoice,
			{akC: false, F8: voidOnly});
		var adjustmentsFormModel = _v0.a;
		var adjustmentsFormCmd = _v0.b;
		return _Utils_Tuple2(
			{bQ: adjustmentsFormModel, Uk: invoice, lA: false, F8: voidOnly},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerInvoice$AdjustVoidModal$AdjustmentsFormMsg, adjustmentsFormCmd));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$initAdjustVoidModal = F3(
	function (model, invoice, voidOnly) {
		var _v0 = A2($author$project$Components$CustomerInvoice$AdjustVoidModal$init, invoice, voidOnly);
		var adjustVoidModal = _v0.a;
		var adjustVoidModalCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					ik: $elm$core$Maybe$Just(adjustVoidModal)
				}),
			A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$AdjustVoidModalMsg, adjustVoidModalCmd));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ChargeDropdownsMsg = F2(
	function (a, b) {
		return {$: 48, a: a, b: b};
	});
var $author$project$Api$Provider$Charge$Shared$isPersisted = function (_v0) {
	var record = _v0;
	return record.U4;
};
var $author$project$Api$Provider$Charge$One$isPersisted = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Charge$Shared$isPersisted(shared);
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$initChargeDropdowns = function (invoice) {
	return A2(
		$elm$core$List$map,
		function (charge) {
			return _Utils_Tuple2(
				$author$project$Api$Provider$Charge$One$id(charge),
				$author$project$Ui$Dropdown$init(
					$author$project$Ui$Dropdown$toDownLeft(
						$author$project$Ui$Dropdown$defaultConfig(
							{
								ahP: 'charge-dropdown-' + $author$project$Api$Provider$Charge$One$id(charge),
								al6: $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ChargeDropdownsMsg(charge)
							}))));
		},
		A2(
			$elm$core$List$filter,
			$author$project$Api$Provider$Charge$One$isPersisted,
			A2(
				$author$project$Api$Expandable$withDefault,
				_List_Nil,
				$author$project$Api$Provider$CustomerInvoice$One$charges(invoice))));
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$patientPath = function (invoice) {
	return A2(
		$elm$core$Maybe$map,
		$author$project$Api$Provider$Patient$patientPath,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$Patient$Shared$id,
			$author$project$Api$Provider$CustomerInvoice$One$owner(invoice)));
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$initCreatePaymentModal = F5(
	function (model, invoice, external, displayModal, passthroughFees) {
		var _v0 = $author$project$Components$Invoice$CreatePaymentModal$init(model.dd)(model.J7)(
			$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(
				$author$project$Api$Provider$CustomerInvoice$One$id(invoice)))(
			$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$patientPath(invoice))(model.Gv)(model.aa4)(
			$author$project$Api$Practice$Provider(model.ZV))(model.Ij)(model.t9)(
			function (d) {
				return _Utils_update(
					d,
					{r2: displayModal, R5: external, YV: passthroughFees, alv: model.Ij});
			})(
			A2($author$project$Components$Invoice$CreatePaymentModal$CustomerInvoice, model.YZ, invoice));
		var createPaymentModal = _v0.a;
		var createPaymentModalCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					m$: $elm$core$Maybe$Just(createPaymentModal)
				}),
			A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CreatePaymentModalMsg, createPaymentModalCmd));
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Invoice$CreateScheduledPaymentModal$GotBankAccounts = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$GotCards = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$fetchPaymentSources = F3(
	function (apiClient, session, sourcePath) {
		if (!sourcePath.$) {
			var sourcePath_ = sourcePath.a;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A4($author$project$Api$Card$list, sourcePath_, apiClient, session, $author$project$Components$Invoice$CreateScheduledPaymentModal$GotCards),
						A4($author$project$Api$BankAccount$list, sourcePath_, apiClient, session, $author$project$Components$Invoice$CreateScheduledPaymentModal$GotBankAccounts)
					]));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnSelected = F3(
	function (a, b, c) {
		return {$: 10, a: a, b: b, c: c};
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$formFieldsFromPayable = function (customerInvoice) {
	var _v0 = $author$project$Components$DateInput$init;
	var dateInput = _v0.a;
	var dateInputCmd = _v0.b;
	return _Utils_Tuple2(
		{
			j$: $author$project$Api$Provider$CustomerInvoice$One$dueInCents(customerInvoice),
			i: _List_Nil
		},
		A2(
			$elm$core$Platform$Cmd$map,
			A2($author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnSelected, 0, dateInput),
			dateInputCmd));
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$init = F9(
	function (today, timeFormatter, sourcePath, apiClient, session, practice, customerInvoice, patientId, shouldChargeCreditCardFees) {
		var _v0 = $author$project$Components$Invoice$CreateScheduledPaymentModal$formFieldsFromPayable(customerInvoice);
		var fields = _v0.a;
		var fieldsCmd = _v0.b;
		return _Utils_Tuple2(
			{
				rs: $author$project$Api$Data$Loading,
				rC: $author$project$Api$Data$Loading,
				m6: customerInvoice,
				SD: $author$project$Utils$Form$init(fields),
				dp: true,
				YZ: patientId,
				ZV: practice,
				k9: $author$project$Api$Data$NotAsked,
				aa4: session,
				abh: shouldChargeCreditCardFees,
				JR: sourcePath,
				J7: timeFormatter,
				FR: today
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						fieldsCmd,
						A3($author$project$Components$Invoice$CreateScheduledPaymentModal$fetchPaymentSources, apiClient, session, sourcePath)
					])));
	});
var $author$project$Api$Provider$Patient$One$shouldChargeCreditCardFees = function (_v0) {
	var record = _v0.b;
	return record.abh;
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$initCreateScheduledPaymentModal = F2(
	function (model, invoice) {
		var _v0 = A9(
			$author$project$Components$Invoice$CreateScheduledPaymentModal$init,
			model.dd,
			model.J7,
			$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$patientPath(invoice),
			model.Gv,
			model.aa4,
			model.ZV,
			invoice,
			model.YZ,
			$author$project$Api$Provider$Patient$One$shouldChargeCreditCardFees(model.YY));
		var createScheduledPaymentModal = _v0.a;
		var createScheduledPaymentModalCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					i$: $elm$core$Maybe$Just(createScheduledPaymentModal)
				}),
			A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CreateScheduledPaymentModalMsg, createScheduledPaymentModalCmd));
	});
var $author$project$Components$CustomerInvoice$ProcessRefundModal$AdjustmentsFormMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$Check = 1;
var $author$project$Components$CustomerInvoice$ProcessRefundModal$RefundsFormMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$CustomerInvoice$RefundsForm$Model = $elm$core$Basics$identity;
var $author$project$Components$CustomerInvoice$RefundsForm$init = F3(
	function (refunds, timeFormatter, invoice) {
		var forms = A2(
			$elm$core$List$map,
			function (payment) {
				return _Utils_Tuple2(
					$author$project$Api$Payment$id(payment),
					$author$project$Utils$Form$init(
						{LE: $elm$core$Maybe$Nothing, Y9: payment}));
			},
			refunds);
		return _Utils_Tuple2(
			{rb: 0, agX: _List_Nil, aL: forms, Uk: invoice, $n: refunds, J7: timeFormatter},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Components$CustomerInvoice$RefundsForm$AmountInCentsValidation = 0;
var $author$project$Components$CustomerInvoice$RefundsForm$validateAmountInCents = function (fields) {
	var paymentAmount = $author$project$Api$Payment$amountInCents(fields.Y9);
	var isInvalidCurrency = function (amount) {
		return A2(
			$author$project$Utils$Validate$isInvalidCurrency,
			{
				aeU: false,
				AU: $elm$core$Maybe$Just(paymentAmount),
				W9: $elm$core$Maybe$Just(0)
			},
			amount);
	};
	return ((!_Utils_eq(fields.LE, $elm$core$Maybe$Nothing)) && isInvalidCurrency(fields.LE)) ? _List_fromArray(
		[
			_Utils_Tuple2(
			0,
			'Enter a positive amount below or equal to ' + ($author$project$Utils$Currency$fromInt(paymentAmount) + '.'))
		]) : _List_Nil;
};
var $author$project$Components$CustomerInvoice$RefundsForm$refundValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$CustomerInvoice$RefundsForm$validateAmountInCents)
		]));
var $author$project$Components$CustomerInvoice$RefundsForm$TotalRefundValidation = 1;
var $author$project$Components$CustomerInvoice$RefundsForm$totalRefundAmount = function (forms) {
	return $elm$core$List$sum(
		A2(
			$elm$core$List$map,
			$elm$core$Maybe$withDefault(0),
			A2(
				$elm$core$List$map,
				$elm$core$Maybe$andThen($author$project$Currency$toInt),
				A2(
					$elm$core$List$map,
					function ($) {
						return $.LE;
					},
					A2(
						$elm$core$List$map,
						$author$project$Utils$Form$fields,
						A2($elm$core$List$map, $elm$core$Tuple$second, forms))))));
};
var $author$project$Components$CustomerInvoice$RefundsForm$RefundsValidation = 0;
var $author$project$Components$CustomerInvoice$RefundsForm$validateRefunds = function (model) {
	var anyRefundError = A2(
		$elm$core$List$any,
		A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $author$project$Utils$Form$hasAnyValidationError),
		model.aL);
	return anyRefundError ? _List_fromArray(
		[0]) : _List_Nil;
};
var $author$project$Components$CustomerInvoice$RefundsForm$validator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$CustomerInvoice$RefundsForm$validateRefunds),
			A2(
			$rtfeldman$elm_validate$Validate$ifTrue,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.aL;
				},
				A2(
					$elm$core$Basics$composeR,
					$author$project$Components$CustomerInvoice$RefundsForm$totalRefundAmount,
					function (_int) {
						return _int <= 0;
					})),
			1)
		]));
var $author$project$Components$CustomerInvoice$RefundsForm$validate = function (_v0) {
	var model = _v0;
	var newForms = A2(
		$elm$core$List$map,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Tuple$mapSecond(
				$author$project$Utils$Form$validate($author$project$Components$CustomerInvoice$RefundsForm$refundValidator)),
			$elm$core$Tuple$mapSecond($author$project$Utils$Form$fromValidateResult)),
		model.aL);
	var newModel = _Utils_update(
		model,
		{agX: _List_Nil, aL: newForms});
	return $author$project$Utils$Result$merge(
		A2(
			$elm$core$Result$mapError,
			function (errors) {
				return _Utils_update(
					newModel,
					{agX: errors});
			},
			A2(
				$elm$core$Result$map,
				$rtfeldman$elm_validate$Validate$fromValid,
				A2($rtfeldman$elm_validate$Validate$validate, $author$project$Components$CustomerInvoice$RefundsForm$validator, newModel))));
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$init = function (basePath) {
	return function (payments) {
		return function (invoice) {
			return function (patient) {
				return function (shared) {
					return function (session) {
						return function (practice) {
							return function (voidOnly) {
								return function (timeFormatter) {
									return function (isHintAdmin) {
										return function (rainforestEnv) {
											var paymentProcessorRefundablePayments = A2($elm$core$List$filter, $author$project$Api$Payment$isRefundableOnPaymentProcessor, payments);
											var refundType = $elm$core$List$isEmpty(paymentProcessorRefundablePayments) ? $elm$core$Maybe$Just(1) : $elm$core$Maybe$Nothing;
											var _v0 = A2(
												$elm$core$Tuple$mapFirst,
												$author$project$Components$CustomerInvoice$RefundsForm$validate,
												A3($author$project$Components$CustomerInvoice$RefundsForm$init, payments, timeFormatter, invoice));
											var refundsFormModel = _v0.a;
											var refundsFormCmd = _v0.b;
											var _v1 = A2(
												$author$project$Components$CustomerInvoice$AdjustmentsForm$init,
												invoice,
												{akC: true, F8: voidOnly});
											var adjustmentsFormModel = _v1.a;
											var adjustmentsFormCmd = _v1.b;
											return _Utils_Tuple2(
												{
													bQ: adjustmentsFormModel,
													xx: basePath,
													m$: $elm$core$Maybe$Nothing,
													SD: $author$project$Utils$Form$init(
														{aiG: $elm$core$Maybe$Nothing}),
													Uk: invoice,
													gD: true,
													Ij: isHintAdmin,
													tt: false,
													YY: patient,
													Zi: payments,
													ZV: practice,
													t9: rainforestEnv,
													e$: $author$project$Api$Data$NotAsked,
													hs: refundType,
													e0: refundsFormModel,
													aa4: session,
													lk: shared,
													J7: timeFormatter,
													vp: false
												},
												$elm$core$Platform$Cmd$batch(
													_List_fromArray(
														[
															A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerInvoice$ProcessRefundModal$AdjustmentsFormMsg, adjustmentsFormCmd),
															A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerInvoice$ProcessRefundModal$RefundsFormMsg, refundsFormCmd)
														])));
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$CustomerInvoice$One$payments = function (_v0) {
	var record = _v0.b;
	return record.Zi;
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoicePayments = function (invoice) {
	return A2(
		$elm$core$List$map,
		$author$project$Api$Payment$Provider_One,
		A2(
			$author$project$Api$Expandable$withDefault,
			_List_Nil,
			$author$project$Api$Provider$CustomerInvoice$One$payments(invoice)));
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$initProcessRefundModal = F2(
	function (model, invoice) {
		var _v0 = $author$project$Components$CustomerInvoice$ProcessRefundModal$init($author$project$Api$Data$providerPath)(
			$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoicePayments(invoice))(invoice)(model.YY)(model.lk)(model.aa4)(model.ZV)(false)(model.J7)(model.Ij)(model.t9);
		var processRefundModal = _v0.a;
		var processRefundModalCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					kO: $elm$core$Maybe$Just(processRefundModal)
				}),
			A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ProcessRefundModalMsg, processRefundModalCmd));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceRedirect = F2(
	function (patientId, invoiceId) {
		return A2(
			$author$project$Utils$Route$navigate,
			$elm$core$Dict$empty,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top(
				{Us: invoiceId, YZ: patientId}));
	});
var $author$project$Api$Provider$ScheduledPayment$Shared$ScheduledPayment = $elm$core$Basics$identity;
var $author$project$Api$Provider$ScheduledPayment$Shared$Record = F9(
	function (id, amountInCents, passthroughFeesInCents, payable, payment, paymentSource, scheduledOn, status, memo) {
		return {LE: amountInCents, ahP: id, aiG: memo, YW: passthroughFeesInCents, ajV: payable, Y9: payment, Zg: paymentSource, ale: scheduledOn, alH: status};
	});
var $author$project$Api$Provider$ScheduledPayment$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'memo',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'status',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'scheduled_on',
			$author$project$Utils$Date$decode,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'payment_source',
				$elm$json$Json$Decode$nullable($author$project$Api$Common$Source$Shared$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'payment',
					$elm$json$Json$Decode$nullable($author$project$Api$Provider$Payment$One$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'payable',
						$author$project$Api$Common$Payable$Invoice$Min$decoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'passthrough_fees_in_cents',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'amount_in_cents',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'id',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Api$Provider$ScheduledPayment$Shared$Record))))))))));
var $author$project$Api$Provider$ScheduledPayment$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ScheduledPayment$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$ScheduledPayment$schedulePaymentsPath = function (payableId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['scheduled_payments']),
		A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				['customer_invoices', payableId]),
			$author$project$Api$Data$providerPath));
};
var $author$project$Api$Provider$ScheduledPayment$list = F3(
	function (apiClient, payableId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$ScheduledPayment$Shared$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$ScheduledPayment$schedulePaymentsPath(payableId)));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$MarkedAsBadDebt = function (a) {
	return {$: 18, a: a};
};
var $author$project$Api$Provider$CustomerInvoice$markAsBadDebt = F4(
	function (apiClient, id, expand, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CustomerInvoice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2(
						$author$project$Api$Param$list,
						'expand',
						A2($elm$core$List$map, $author$project$Api$Provider$CustomerInvoice$expandToString, expand))
					]),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['mark_as_bad_debt']),
						$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id)))));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$markAsBadDebt = function (model) {
	var _v0 = model.Uk;
	if (_v0.$ === 3) {
		var invoice = _v0.a;
		return _Utils_Tuple3(
			model,
			A4(
				$author$project$Api$Provider$CustomerInvoice$markAsBadDebt,
				model.Gv,
				$author$project$Api$Provider$CustomerInvoice$One$id(invoice),
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceExpands,
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$MarkedAsBadDebt),
			_List_Nil);
	} else {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	}
};
var $author$project$Api$Provider$CustomerInvoice$markAsSent = F4(
	function (apiClient, id, expand, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CustomerInvoice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2(
						$author$project$Api$Param$list,
						'expand',
						A2($elm$core$List$map, $author$project$Api$Provider$CustomerInvoice$expandToString, expand))
					]),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['mark_as_sent']),
						$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id)))));
	});
var $author$project$Api$Provider$CustomerInvoice$markAsUnsent = F4(
	function (apiClient, id, expand, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CustomerInvoice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2(
						$author$project$Api$Param$list,
						'expand',
						A2($elm$core$List$map, $author$project$Api$Provider$CustomerInvoice$expandToString, expand))
					]),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['mark_as_unsent']),
						$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id)))));
	});
var $author$project$Api$Provider$CustomerInvoice$removeCredits = F4(
	function (apiClient, id, expand, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CustomerInvoice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2(
						$author$project$Api$Param$list,
						'expand',
						A2($elm$core$List$map, $author$project$Api$Provider$CustomerInvoice$expandToString, expand))
					]),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['remove_credits']),
						$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id)))));
	});
var $author$project$Api$Provider$CustomerInvoice$returnToDraft = F4(
	function (apiClient, id, expand, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CustomerInvoice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2(
						$author$project$Api$Param$list,
						'expand',
						A2($elm$core$List$map, $author$project$Api$Provider$CustomerInvoice$expandToString, expand))
					]),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['return_to_draft']),
						$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id)))));
	});
var $author$project$Api$Provider$CustomerInvoice$reverseBadDebt = F4(
	function (apiClient, id, expand, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CustomerInvoice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2(
						$author$project$Api$Param$list,
						'expand',
						A2($elm$core$List$map, $author$project$Api$Provider$CustomerInvoice$expandToString, expand))
					]),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['reverse_bad_debt']),
						$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id)))));
	});
var $author$project$Api$Provider$CustomerInvoice$reverseCreditTransfer = F4(
	function (apiClient, id, expand, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CustomerInvoice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2(
						$author$project$Api$Param$list,
						'expand',
						A2($elm$core$List$map, $author$project$Api$Provider$CustomerInvoice$expandToString, expand))
					]),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['reverse_credit_transfer']),
						$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id)))));
	});
var $author$project$Api$Provider$CustomerInvoice$stopRetrying = F4(
	function (apiClient, id, expand, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CustomerInvoice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2(
						$author$project$Api$Param$list,
						'expand',
						A2($elm$core$List$map, $author$project$Api$Provider$CustomerInvoice$expandToString, expand))
					]),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['stop_retrying']),
						$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id)))));
	});
var $author$project$Api$Provider$CustomerInvoice$transferToCredit = F4(
	function (apiClient, id, expand, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CustomerInvoice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2(
						$author$project$Api$Param$list,
						'expand',
						A2($elm$core$List$map, $author$project$Api$Provider$CustomerInvoice$expandToString, expand))
					]),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['transfer_to_credit']),
						$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id)))));
	});
var $author$project$Api$Provider$CustomerInvoice$update = F5(
	function (apiClient, invoiceId, fields, expand, toMsg) {
		var taxProfile = function () {
			var _v3 = fields.acX;
			if (!_v3.$) {
				var profile = _v3.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'tax_profile',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'id',
									$elm$json$Json$Encode$string(profile))
								])))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var owner = function () {
			var _v2 = fields.YD;
			if (!_v2.$) {
				var owner_ = _v2.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'owner',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'id',
									$elm$json$Json$Encode$string(owner_))
								])))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var location = function () {
			var _v1 = fields.ais;
			if (!_v1.$) {
				var location_ = _v1.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'location',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'id',
									$elm$json$Json$Encode$string(location_))
								])))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var date = function () {
			var _v0 = fields.PB;
			if (!_v0.$) {
				var date_ = _v0.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'date',
						$author$project$Utils$Date$encode(date_))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var body = $elm$json$Json$Encode$object(
			_Utils_ap(
				owner,
				_Utils_ap(
					location,
					_Utils_ap(date, taxProfile))));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$CustomerInvoice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2(
						$author$project$Api$Param$list,
						'expand',
						A2($elm$core$List$map, $author$project$Api$Provider$CustomerInvoice$expandToString, expand))
					]),
				A2(
					$author$project$Api$Data$requestWithJson,
					body,
					$author$project$Api$Data$requestTo(
						$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(invoiceId)))));
	});
var $author$project$Components$CustomerInvoice$AdjustVoidModal$Closed = 1;
var $author$project$Components$CustomerInvoice$AdjustVoidModal$None = 0;
var $author$project$Components$CustomerInvoice$AdjustVoidModal$Revised = 2;
var $author$project$Components$CustomerInvoice$AdjustVoidModal$handleResponse = F3(
	function (model, data, successMsg) {
		if (data.$ === 3) {
			return {
				GZ: $elm$core$Platform$Cmd$none,
				agZ: 2,
				aiO: _Utils_update(
					model,
					{lA: false}),
				aR: _List_fromArray(
					[
						A2($author$project$OutMsg$ShowToast, 3, successMsg)
					])
			};
		} else {
			return {
				GZ: $elm$core$Platform$Cmd$none,
				agZ: 1,
				aiO: _Utils_update(
					model,
					{lA: false}),
				aR: $author$project$OutMsg$handleErrorResponse(data)
			};
		}
	});
var $author$project$Components$CustomerInvoice$AdjustVoidModal$Created = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$CustomerInvoice$AdjustVoidModal$Voided = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$voided = function (_v0) {
	var form = _v0.SD;
	return $author$project$Utils$Form$fields(form)._;
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$allVoided = function (_v0) {
	var model = _v0;
	return model.F8 || A2(
		$elm$core$List$all,
		$author$project$Components$CustomerInvoice$ChargeAdjustmentForm$voided,
		A2($elm$core$List$map, $elm$core$Tuple$second, model.ap));
};
var $author$project$Api$Provider$InvoiceAdjustment$One$InvoiceAdjustment = 0;
var $author$project$Api$Provider$InvoiceAdjustment$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Provider$InvoiceAdjustment$invoiceAdjustmentsPath = function (customerInvoiceId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['invoice_adjustments']),
		$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(customerInvoiceId));
};
var $author$project$Api$Provider$InvoiceAdjustment$create = F4(
	function (apiClient, customerInvoiceId, body, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$InvoiceAdjustment$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$InvoiceAdjustment$invoiceAdjustmentsPath(customerInvoiceId))));
	});
var $author$project$Api$Provider$Uom$Shared$encode = function (uom) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'code',
				$elm$json$Json$Encode$string(
					$author$project$Api$Provider$Uom$Shared$code(uom))),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(
					$author$project$Api$Provider$Uom$Shared$name(uom))),
				_Utils_Tuple2(
				'period_quantity',
				A2(
					$author$project$Utils$Encode$nullable,
					$elm$json$Json$Encode$int,
					$author$project$Api$Provider$Uom$Shared$periodQuantity(uom))),
				_Utils_Tuple2(
				'period_unit',
				A2(
					$author$project$Utils$Encode$nullable,
					$elm$json$Json$Encode$string,
					A2(
						$elm$core$Maybe$map,
						$author$project$Api$Provider$Uom$PeriodUnit$toString,
						$author$project$Api$Provider$Uom$Shared$periodUnit(uom)))),
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string(
					$author$project$Api$Provider$Uom$Shared$type_(uom))),
				_Utils_Tuple2(
				'unit_class',
				$elm$json$Json$Encode$string(
					$author$project$Api$Provider$Uom$Shared$unitClass(uom)))
			]));
};
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$trackInventory = function (charge) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$ChargeItem$ForCharge$trackInventory,
			$author$project$Api$Provider$Charge$One$chargeItem(charge)));
};
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$encodedForm = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.SD);
	var quantity = fields._ ? $elm$core$Maybe$Just(0) : fields.Dz;
	var returnToInventory = ($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$trackInventory(fields.afx) && fields._) ? $elm$core$Maybe$Just(fields.e6) : $elm$core$Maybe$Nothing;
	var encodedCharge = $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(
					$author$project$Api$Provider$Charge$One$id(fields.afx)))
			]));
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'date',
				$author$project$Utils$Date$encode(
					$author$project$Api$Provider$Charge$One$date(fields.afx))),
				_Utils_Tuple2(
				'end_date',
				A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.sb)),
				_Utils_Tuple2('charge', encodedCharge),
				_Utils_Tuple2(
				'price_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.Dw)),
				_Utils_Tuple2(
				'return_to_inventory',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$bool, returnToInventory)),
				_Utils_Tuple2(
				'void',
				$elm$json$Json$Encode$bool(fields._)),
				_Utils_Tuple2(
				'quantity_uom',
				$author$project$Api$Provider$Uom$Shared$encode(fields.DA)),
				_Utils_Tuple2(
				'quantity',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, quantity))
			]));
};
var $author$project$Api$Provider$CustomerInvoice$One$revisionNumber = function (_v0) {
	var record = _v0.b;
	return record.$5;
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$encodedForm = function (_v0) {
	var model = _v0;
	var encodedAdjustments = A2(
		$elm$json$Json$Encode$list,
		$author$project$Components$CustomerInvoice$ChargeAdjustmentForm$encodedForm,
		A2($elm$core$List$map, $elm$core$Tuple$second, model.ap));
	return _List_fromArray(
		[
			_Utils_Tuple2('charge_adjustments', encodedAdjustments),
			_Utils_Tuple2(
			'reason',
			A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, model.aiG)),
			_Utils_Tuple2(
			'revision_number',
			$elm$json$Json$Encode$int(
				$author$project$Api$Provider$CustomerInvoice$One$revisionNumber(model.Uk)))
		]);
};
var $author$project$Api$Provider$CustomerInvoice$void = F4(
	function (apiClient, id, _v0, toMsg) {
		var voidReason = _v0.amq;
		var refundPayments = _v0.akB;
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'refund_payments',
					$elm$json$Json$Encode$bool(refundPayments)),
					_Utils_Tuple2(
					'void_reason',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, voidReason))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CustomerInvoice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['void']),
						$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id)))));
	});
var $author$project$Components$CustomerInvoice$AdjustmentsForm$voidParams = function (_v0) {
	var model = _v0;
	return {akB: false, amq: model.aiG};
};
var $author$project$Components$CustomerInvoice$AdjustVoidModal$submitCmd = F2(
	function (model, apiClient) {
		return $author$project$Components$CustomerInvoice$AdjustmentsForm$allVoided(model.bQ) ? A4(
			$author$project$Api$Provider$CustomerInvoice$void,
			apiClient,
			$author$project$Api$Provider$CustomerInvoice$One$id(model.Uk),
			$author$project$Components$CustomerInvoice$AdjustmentsForm$voidParams(model.bQ),
			$author$project$Components$CustomerInvoice$AdjustVoidModal$Voided) : A4(
			$author$project$Api$Provider$InvoiceAdjustment$create,
			apiClient,
			$author$project$Api$Provider$CustomerInvoice$One$id(model.Uk),
			$elm$json$Json$Encode$object(
				$author$project$Components$CustomerInvoice$AdjustmentsForm$encodedForm(model.bQ)),
			$author$project$Components$CustomerInvoice$AdjustVoidModal$Created);
	});
var $author$project$Components$CustomerInvoice$AdjustmentsForm$AdjustmentCreated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$None = {$: 0};
var $author$project$Api$Provider$ChargeAdjustment$Preview$endDate = function (_v0) {
	var record = _v0.b;
	return record.sb;
};
var $author$project$Api$Provider$ChargeAdjustment$Shared$quantityAdjustment = function (_v0) {
	var record = _v0;
	return record._O;
};
var $author$project$Api$Provider$ChargeAdjustment$Preview$quantityAdjustment = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeAdjustment$Shared$quantityAdjustment(shared);
};
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$adjustmentPreviewed = F2(
	function (preview, _v0) {
		var model = _v0;
		var fields = $author$project$Utils$Form$fields(model.SD);
		var quantity = A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$always(
				$author$project$Api$Provider$Charge$One$quantity(fields.afx) + $author$project$Api$Provider$ChargeAdjustment$Preview$quantityAdjustment(preview)),
			fields.Dz);
		var newForm = A2(
			$author$project$Utils$Form$set,
			_Utils_update(
				fields,
				{
					sb: $author$project$Api$Provider$ChargeAdjustment$Preview$endDate(preview),
					Dz: quantity
				}),
			model.SD);
		return _Utils_update(
			model,
			{
				vD: $elm$core$Maybe$Just(preview),
				SD: newForm
			});
	});
var $author$project$Api$Provider$ChargeAdjustment$Shared$charge = function (_v0) {
	var record = _v0;
	return record.afx;
};
var $author$project$Api$Provider$ChargeAdjustment$Preview$charge = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeAdjustment$Shared$charge(shared);
};
var $author$project$Api$Provider$InvoiceAdjustment$Preview$chargeAdjustments = function (_v0) {
	var record = _v0.b;
	return record.Nv;
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$chargeForm = F2(
	function (chargeId, adjustmentsForms) {
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$second,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$first,
						$elm$core$Basics$eq(chargeId)),
					adjustmentsForms)));
	});
var $author$project$Utils$Tuple3$first = function (_v0) {
	var first_ = _v0.a;
	return first_;
};
var $author$project$Api$Provider$Charge$Min$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$CustomerInvoice$Shared$paidInCents = function (_v0) {
	var record = _v0;
	return record.YI;
};
var $author$project$Api$Provider$CustomerInvoice$One$paidInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CustomerInvoice$Shared$paidInCents(shared);
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$GotPreview = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$hasAnyValidationError = function (_v0) {
	var errors = _v0.agX;
	return !$elm$core$List$isEmpty(errors);
};
var $author$project$Api$Provider$InvoiceAdjustment$Preview$InvoiceAdjustment = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$InvoiceAdjustment$Preview$Record = function (chargeAdjustments) {
	return {Nv: chargeAdjustments};
};
var $author$project$Api$Provider$ChargeAdjustment$Preview$ChargeAdjustment = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$ChargeAdjustment$Shared$ChargeAdjustment = $elm$core$Basics$identity;
var $author$project$Api$Provider$ChargeAdjustment$Shared$Record = F6(
	function (priceAdjustmentInCents, quantityAdjustment, subtotalAdjustmentInCents, taxAdjustmentInCents, totalAdjustmentInCents, charge) {
		return {afx: charge, ake: priceAdjustmentInCents, _O: quantityAdjustment, acC: subtotalAdjustmentInCents, alW: taxAdjustmentInCents, ama: totalAdjustmentInCents};
	});
var $author$project$Api$Provider$Charge$Min$Charge = $elm$core$Basics$identity;
var $author$project$Api$Provider$Charge$Min$Record = function (id) {
	return {ahP: id};
};
var $author$project$Api$Provider$Charge$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'id',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Charge$Min$Record));
var $author$project$Api$Provider$Charge$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Charge$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$ChargeAdjustment$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'charge',
	$author$project$Api$Provider$Charge$Min$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'total_adjustment_in_cents',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'tax_adjustment_in_cents',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'subtotal_adjustment_in_cents',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'quantity_adjustment',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'price_adjustment_in_cents',
						$elm$json$Json$Decode$int,
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeAdjustment$Shared$Record)))))));
var $author$project$Api$Provider$ChargeAdjustment$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ChargeAdjustment$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$ChargeAdjustment$Preview$Record = F2(
	function (date, endDate) {
		return {PB: date, sb: endDate};
	});
var $author$project$Api$Provider$ChargeAdjustment$Preview$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'end_date',
	$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'date',
		$author$project$Utils$Date$decode,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeAdjustment$Preview$Record)));
var $author$project$Api$Provider$ChargeAdjustment$Preview$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ChargeAdjustment$Preview$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$ChargeAdjustment$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeAdjustment$Preview$ChargeAdjustment)));
var $author$project$Api$Provider$InvoiceAdjustment$Preview$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'charge_adjustments',
	$elm$json$Json$Decode$list($author$project$Api$Provider$ChargeAdjustment$Preview$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$InvoiceAdjustment$Preview$Record));
var $author$project$Api$Provider$InvoiceAdjustment$Preview$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$InvoiceAdjustment$Preview$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$InvoiceAdjustment$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$InvoiceAdjustment$Preview$InvoiceAdjustment)));
var $author$project$Api$Provider$InvoiceAdjustment$previewPath = function (customerInvoiceId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['preview']),
		$author$project$Api$Provider$InvoiceAdjustment$invoiceAdjustmentsPath(customerInvoiceId));
};
var $author$project$Api$Provider$InvoiceAdjustment$preview = F4(
	function (apiClient, customerInvoiceId, body, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$InvoiceAdjustment$Preview$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$InvoiceAdjustment$previewPath(customerInvoiceId))));
	});
var $author$project$Components$CustomerInvoice$AdjustmentsForm$previewAdjustmentCmd = F2(
	function (apiClient, model) {
		var modelRecord = model;
		return $author$project$Components$CustomerInvoice$AdjustmentsForm$hasAnyValidationError(model) ? $elm$core$Platform$Cmd$none : A4(
			$author$project$Api$Provider$InvoiceAdjustment$preview,
			apiClient,
			$author$project$Api$Provider$CustomerInvoice$One$id(modelRecord.Uk),
			$elm$json$Json$Encode$object(
				$author$project$Components$CustomerInvoice$AdjustmentsForm$encodedForm(model)),
			$author$project$Components$CustomerInvoice$AdjustmentsForm$GotPreview);
	});
var $author$project$Utils$Tuple3$second = function (_v0) {
	var second_ = _v0.b;
	return second_;
};
var $author$project$Api$Provider$InvoiceAdjustment$Shared$totalAdjustmentInCents = function (_v0) {
	var record = _v0;
	return record.ama;
};
var $author$project$Api$Provider$InvoiceAdjustment$Preview$totalAdjustmentInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$InvoiceAdjustment$Shared$totalAdjustmentInCents(shared);
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$totalAdjustmentAmount = function (dataPreview) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$InvoiceAdjustment$Preview$totalAdjustmentInCents,
			$author$project$Api$Data$toMaybe(dataPreview)));
};
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$EndDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$FieldUpdated = $elm$core$Basics$identity;
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$InputChanged = 1;
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$None = 0;
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$updateField = F2(
	function (field, formFields) {
		switch (field.$) {
			case 0:
				var dateInputMsg = field.a;
				var _v1 = formFields.sd;
				if (!_v1.$) {
					var endDateInput = _v1.a;
					var _v2 = A2($author$project$Components$DateInput$update, dateInputMsg, endDateInput);
					var dateInput = _v2.a;
					var dateInputCmd = _v2.b;
					var inputEvent = _v2.c;
					var _v3 = function () {
						if (inputEvent.$ === 1) {
							var date = inputEvent.a;
							return _Utils_Tuple2(date, 1);
						} else {
							return _Utils_Tuple2(formFields.sb, 0);
						}
					}();
					var newValue = _v3.a;
					var event = _v3.b;
					var quantityUom = A2(
						$elm$core$Maybe$withDefault,
						$author$project$Api$Provider$Uom$Shared$day,
						A2(
							$elm$core$Maybe$map,
							$author$project$Utils$Uom$matchRange(formFields.PB),
							newValue));
					var quantity = $elm$core$Maybe$Just(
						A3($author$project$Utils$Uom$quantityBetween, quantityUom, formFields.PB, newValue));
					return _Utils_Tuple3(
						_Utils_update(
							formFields,
							{
								sb: newValue,
								sd: $elm$core$Maybe$Just(dateInput),
								Dz: quantity,
								DA: quantityUom
							}),
						A2(
							$elm$core$Platform$Cmd$map,
							A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$EndDate),
							dateInputCmd),
						event);
				} else {
					return _Utils_Tuple3(formFields, $elm$core$Platform$Cmd$none, 0);
				}
			case 1:
				var bool = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						formFields,
						{
							Dz: $elm$core$Maybe$Just(
								$author$project$Api$Provider$Charge$One$quantity(formFields.afx)),
							e6: bool,
							_: bool
						}),
					$elm$core$Platform$Cmd$none,
					1);
			case 2:
				var bool = field.a;
				var returnToInventory = bool ? false : formFields.e6;
				return _Utils_Tuple3(
					_Utils_update(
						formFields,
						{
							Dz: $elm$core$Maybe$Just(
								$author$project$Api$Provider$Charge$One$quantity(formFields.afx)),
							e6: returnToInventory,
							_: bool,
							Ko: bool
						}),
					$elm$core$Platform$Cmd$none,
					1);
			case 3:
				var str = field.a;
				var quantity = $elm$core$String$toInt(str);
				var returnToInventory = A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						function (quantity_) {
							return _Utils_cmp(
								$author$project$Api$Provider$Charge$One$quantity(formFields.afx),
								quantity_) > 0;
						},
						quantity));
				var endDate = A3(
					$author$project$Utils$Uom$addTo,
					$elm$core$Maybe$Just(formFields.PB),
					formFields.DA,
					A2($elm$core$Maybe$withDefault, 0, quantity));
				return _Utils_Tuple3(
					_Utils_update(
						formFields,
						{sb: endDate, Dz: quantity, e6: returnToInventory}),
					$elm$core$Platform$Cmd$none,
					1);
			case 4:
				var str = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						formFields,
						{
							DA: A2(
								$elm$core$Maybe$withDefault,
								$author$project$Api$Provider$Uom$Shared$day,
								$author$project$Utils$Uom$fromCode(str))
						}),
					$elm$core$Platform$Cmd$none,
					1);
			case 5:
				var currency = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						formFields,
						{Dw: currency}),
					$elm$core$Platform$Cmd$none,
					1);
			case 6:
				var bool = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						formFields,
						{e6: bool}),
					$elm$core$Platform$Cmd$none,
					1);
			default:
				var itemPriceInCents = A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeR, $author$project$Api$Provider$ChargeItem$ForCharge$priceInCents, $author$project$Currency$fromFloat),
					formFields.mL);
				return _Utils_Tuple3(
					_Utils_update(
						formFields,
						{zh: true, Dw: itemPriceInCents}),
					$elm$core$Platform$Cmd$none,
					1);
		}
	});
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$update = F2(
	function (msg, _v0) {
		var model = _v0;
		var form = model.SD;
		var field = msg;
		var _v2 = A3($author$project$Utils$Form$updateWithCmdAndEvent, $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$updateField, field, form);
		var newForm = _v2.a;
		var newFormCmd = _v2.b;
		var event = _v2.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{SD: newForm}),
			newFormCmd,
			event);
	});
var $author$project$Components$CustomerInvoice$AdjustmentsForm$updateChargeForm = F3(
	function (chargeId, newForm, adjustmentsForms) {
		return A2(
			$elm$core$List$map,
			function (_v0) {
				var id = _v0.a;
				var form = _v0.b;
				return _Utils_eq(id, chargeId) ? _Utils_Tuple2(id, newForm) : _Utils_Tuple2(id, form);
			},
			adjustmentsForms);
	});
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$formFromResult = function (result) {
	if (!result.$) {
		var _v1 = result.a;
		var form = _v1.a;
		return form;
	} else {
		var form = result.a;
		return form;
	}
};
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$updateForm = F2(
	function (model, form) {
		return _Utils_update(
			model,
			{SD: form});
	});
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$PriceInCentsValidation = 0;
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$QuantityValidation = 1;
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$validator = function () {
	var negativeQuantity = function (fields) {
		return (!fields._) && (A2($elm$core$Maybe$withDefault, 0, fields.Dz) < 0);
	};
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_validate$Validate$ifNothing,
				function ($) {
					return $.Dw;
				},
				_Utils_Tuple2(0, 'Please enter a price.')),
				A2(
				$rtfeldman$elm_validate$Validate$ifTrue,
				negativeQuantity,
				_Utils_Tuple2(1, 'Please enter a valid quantity.'))
			]));
}();
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$validate = function (_v0) {
	var model = _v0;
	return A2(
		$elm$core$Result$mapError,
		$author$project$Components$CustomerInvoice$ChargeAdjustmentForm$updateForm(model),
		A2(
			$elm$core$Result$map,
			$elm$core$Tuple$mapFirst(
				$author$project$Components$CustomerInvoice$ChargeAdjustmentForm$updateForm(model)),
			A2($author$project$Utils$Form$validate, $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$validator, model.SD)));
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$AdjustmentsValidation = 0;
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$hasAnyValidationError = function (_v0) {
	var model = _v0;
	return $author$project$Utils$Form$hasAnyValidationError(model.SD);
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$validateAdjustments = function (model) {
	var anyAdjustmentError = A2(
		$elm$core$List$any,
		A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$hasAnyValidationError),
		model.ap);
	return anyAdjustmentError ? _List_fromArray(
		[0]) : _List_Nil;
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$NewDueValidation = 1;
var $author$project$Components$CustomerInvoice$AdjustmentsForm$newDueAmount = F3(
	function (totalInCents, totalPayments, totalAdjustment) {
		return (totalInCents + totalAdjustment) - totalPayments;
	});
var $author$project$Api$Provider$CustomerInvoice$Shared$totalInCents = function (_v0) {
	var record = _v0;
	return record.adp;
};
var $author$project$Api$Provider$CustomerInvoice$One$totalInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CustomerInvoice$Shared$totalInCents(shared);
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$totalPaymentsAmount = function (invoice) {
	return $elm$core$List$sum(
		A2(
			$elm$core$List$map,
			$author$project$Api$Provider$Payment$One$amountInCents,
			A2(
				$author$project$Api$Expandable$withDefault,
				_List_Nil,
				$author$project$Api$Provider$CustomerInvoice$One$payments(invoice))));
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$validateNewDue = function (model) {
	var _v0 = model.akd;
	if (_v0.$ === 3) {
		var preview = _v0.a;
		var totalPayments = $author$project$Components$CustomerInvoice$AdjustmentsForm$totalPaymentsAmount(model.Uk);
		var totalInCents = $author$project$Api$Provider$CustomerInvoice$One$totalInCents(model.Uk);
		var totalAdjustment = $author$project$Api$Provider$InvoiceAdjustment$Preview$totalAdjustmentInCents(preview);
		var newDue = A3($author$project$Components$CustomerInvoice$AdjustmentsForm$newDueAmount, totalInCents, totalPayments, totalAdjustment);
		return (newDue < 0) ? _List_fromArray(
			[1]) : _List_Nil;
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$validator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$CustomerInvoice$AdjustmentsForm$validateAdjustments),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$CustomerInvoice$AdjustmentsForm$validateNewDue)
		]));
var $author$project$Components$CustomerInvoice$AdjustmentsForm$validate = function (_v0) {
	var model = _v0;
	var newForms = A2(
		$elm$core$List$map,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Tuple$mapSecond($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$validate),
			$elm$core$Tuple$mapSecond($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$formFromResult)),
		model.ap);
	var newModel = _Utils_update(
		model,
		{ap: newForms, agX: _List_Nil});
	return $author$project$Utils$Result$merge(
		A2(
			$elm$core$Result$mapError,
			function (errors) {
				return _Utils_update(
					newModel,
					{agX: errors});
			},
			A2(
				$elm$core$Result$map,
				$rtfeldman$elm_validate$Validate$fromValid,
				A2($rtfeldman$elm_validate$Validate$validate, $author$project$Components$CustomerInvoice$AdjustmentsForm$validator, newModel))));
};
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$VoidAll = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$voidAll = F2(
	function (bool, model) {
		return A2(
			$author$project$Components$CustomerInvoice$ChargeAdjustmentForm$update,
			$author$project$Components$CustomerInvoice$ChargeAdjustmentForm$VoidAll(bool),
			model);
	});
var $author$project$Components$CustomerInvoice$AdjustmentsForm$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var chargeId = msg.a;
				var subMsg = msg.b;
				var _v2 = A2($author$project$Components$CustomerInvoice$AdjustmentsForm$chargeForm, chargeId, model.ap);
				if (!_v2.$) {
					var form = _v2.a;
					var _v3 = A2($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$update, subMsg, form);
					var newForm = _v3.a;
					var newFormCmd = _v3.b;
					var event = _v3.c;
					var newPreview = function () {
						if (event === 1) {
							return $author$project$Api$Data$NotAsked;
						} else {
							return model.akd;
						}
					}();
					var newModel = $author$project$Components$CustomerInvoice$AdjustmentsForm$validate(
						_Utils_update(
							model,
							{
								ap: A3($author$project$Components$CustomerInvoice$AdjustmentsForm$updateChargeForm, chargeId, newForm, model.ap),
								akd: newPreview
							}));
					var previewCmd = function () {
						if (event === 1) {
							return A2($author$project$Components$CustomerInvoice$AdjustmentsForm$previewAdjustmentCmd, apiClient, newModel);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}();
					return {
						GZ: $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(
									$elm$core$Platform$Cmd$map,
									$author$project$Components$CustomerInvoice$AdjustmentsForm$ChargeAdjustmentFormMsg(chargeId),
									newFormCmd),
									previewCmd
								])),
						agZ: $author$project$Components$CustomerInvoice$AdjustmentsForm$None,
						aiO: newModel,
						aR: _List_Nil
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$CustomerInvoice$AdjustmentsForm$None, aiO: model, aR: _List_Nil};
				}
			case 1:
				var bool = msg.a;
				var voidedForms = A2(
					$elm$core$List$map,
					$elm$core$Tuple$mapSecond(
						$author$project$Components$CustomerInvoice$ChargeAdjustmentForm$voidAll(bool)),
					model.ap);
				var newForms = A2(
					$elm$core$List$map,
					$elm$core$Tuple$mapSecond($author$project$Utils$Tuple3$first),
					voidedForms);
				var newModel = $author$project$Components$CustomerInvoice$AdjustmentsForm$validate(
					_Utils_update(
						model,
						{ap: newForms, akd: $author$project$Api$Data$NotAsked}));
				var cmds = A2(
					$elm$core$List$map,
					function (_v6) {
						var chargeId = _v6.a;
						var cmd = _v6.b;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Components$CustomerInvoice$AdjustmentsForm$ChargeAdjustmentFormMsg(chargeId),
							cmd);
					},
					A2(
						$elm$core$List$map,
						$elm$core$Tuple$mapSecond($author$project$Utils$Tuple3$second),
						voidedForms));
				return {
					GZ: $elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$cons,
							A2($author$project$Components$CustomerInvoice$AdjustmentsForm$previewAdjustmentCmd, apiClient, newModel),
							cmds)),
					agZ: $author$project$Components$CustomerInvoice$AdjustmentsForm$None,
					aiO: newModel,
					aR: _List_Nil
				};
			case 2:
				var dataPreview = msg.a;
				if (dataPreview.$ === 3) {
					var preview = dataPreview.a;
					var totalRefundedAmount = model.akC ? A2(
						$elm$core$Basics$min,
						$author$project$Api$Provider$CustomerInvoice$One$paidInCents(model.Uk),
						A2(
							$elm$core$Basics$max,
							-$author$project$Components$CustomerInvoice$AdjustmentsForm$totalAdjustmentAmount(dataPreview),
							0)) : 0;
					var adjustmentPreview = function (chargeId) {
						return $elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Api$Provider$ChargeAdjustment$Preview$charge,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Api$Provider$Charge$Min$id,
										$elm$core$Basics$eq(chargeId))),
								$author$project$Api$Provider$InvoiceAdjustment$Preview$chargeAdjustments(preview)));
					};
					var newForms = A2(
						$elm$core$List$map,
						function (_v8) {
							var chargeId = _v8.a;
							var form = _v8.b;
							return _Utils_Tuple2(
								chargeId,
								function () {
									var _v9 = adjustmentPreview(chargeId);
									if (!_v9.$) {
										var adjustmentPreview_ = _v9.a;
										return A2($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$adjustmentPreviewed, adjustmentPreview_, form);
									} else {
										return form;
									}
								}());
						},
						model.ap);
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$CustomerInvoice$AdjustmentsForm$AdjustmentCreated(
							A2(
								$elm$core$Basics$max,
								-$author$project$Components$CustomerInvoice$AdjustmentsForm$totalAdjustmentAmount(dataPreview),
								0)),
						aiO: $author$project$Components$CustomerInvoice$AdjustmentsForm$validate(
							_Utils_update(
								model,
								{ap: newForms, akd: dataPreview, qD: totalRefundedAmount})),
						aR: _List_Nil
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$CustomerInvoice$AdjustmentsForm$None,
						aiO: $author$project$Components$CustomerInvoice$AdjustmentsForm$validate(
							_Utils_update(
								model,
								{akd: dataPreview})),
						aR: _List_Nil
					};
				}
			default:
				var string = msg.a;
				var memo = $elm$core$String$isEmpty(string) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(string);
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: $author$project$Components$CustomerInvoice$AdjustmentsForm$None,
					aiO: _Utils_update(
						model,
						{aiG: memo}),
					aR: _List_Nil
				};
		}
	});
var $author$project$Components$CustomerInvoice$AdjustVoidModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var newModel = _Utils_update(
					model,
					{
						bQ: $author$project$Components$CustomerInvoice$AdjustmentsForm$validate(model.bQ),
						lA: true
					});
				return {
					GZ: A2($author$project$Components$CustomerInvoice$AdjustVoidModal$submitCmd, newModel, apiClient),
					agZ: 0,
					aiO: newModel,
					aR: _List_Nil
				};
			case 1:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: 1, aiO: model, aR: _List_Nil};
			case 2:
				var subMsg = msg.a;
				var adjustmentsFormResult = A3($author$project$Components$CustomerInvoice$AdjustmentsForm$update, apiClient, subMsg, model.bQ);
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerInvoice$AdjustVoidModal$AdjustmentsFormMsg, adjustmentsFormResult.GZ),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{bQ: adjustmentsFormResult.aiO}),
					aR: adjustmentsFormResult.aR
				};
			case 3:
				var dataAdjustments = msg.a;
				return A3($author$project$Components$CustomerInvoice$AdjustVoidModal$handleResponse, model, dataAdjustments, 'Revision created!');
			default:
				var dataVoid = msg.a;
				return A3($author$project$Components$CustomerInvoice$AdjustVoidModal$handleResponse, model, dataVoid, 'Invoice voided!');
		}
	});
var $author$project$Components$CustomerInvoice$ProcessRefundModal$Closed = 1;
var $author$project$Components$CustomerInvoice$ProcessRefundModal$CreatePaymentModalMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$None = 0;
var $author$project$Components$CustomerInvoice$ProcessRefundModal$ReloadInvoiceForPartialRefund = 3;
var $author$project$Components$CustomerInvoice$ProcessRefundModal$ReloadInvoiceForPaymentOrVoid = 4;
var $author$project$Components$CustomerInvoice$ProcessRefundModal$ReloadInvoiceForRefund = 2;
var $author$project$Components$CustomerInvoice$ProcessRefundModal$FullRefundCreated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$isAnExternalRefund = function (refundType) {
	_v0$2:
	while (true) {
		if (!refundType.$) {
			switch (refundType.a) {
				case 1:
					var _v1 = refundType.a;
					return true;
				case 2:
					var _v2 = refundType.a;
					return true;
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return false;
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$createRefund = F6(
	function (apiClient, model, fields, payment, amountInCents, toMsg) {
		if ($author$project$Api$Payment$amountInCents(payment) > 0) {
			var paymentPath = A2(
				$author$project$Api$Payment$paymentPath,
				model.xx,
				$author$project$Api$Payment$id(payment));
			return A4(
				$author$project$Api$Provider$Refund$create,
				paymentPath,
				apiClient,
				{
					LE: amountInCents,
					R5: $author$project$Components$CustomerInvoice$ProcessRefundModal$isAnExternalRefund(model.hs) || (!$author$project$Api$Payment$isRefundableOnPaymentProcessor(payment)),
					aiG: fields.aiG
				},
				toMsg);
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Components$CustomerInvoice$ProcessRefundModal$createFullRefund = F3(
	function (model, apiClient, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A2(
			$elm$core$List$map,
			function (payment) {
				return A6(
					$author$project$Components$CustomerInvoice$ProcessRefundModal$createRefund,
					apiClient,
					model,
					fields,
					payment,
					$author$project$Currency$fromInt(
						$author$project$Api$Payment$amountInCents(payment)),
					$author$project$Components$CustomerInvoice$ProcessRefundModal$FullRefundCreated);
			},
			model.Zi);
	});
var $author$project$Components$CustomerInvoice$ProcessRefundModal$InvoiceAdjustmentCreated = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$PartialRefundCreated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$CustomerInvoice$RefundsForm$encodedForm = F2(
	function (external, form) {
		var fields = $author$project$Utils$Form$fields(form);
		var encodedRefund = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(
						$author$project$Api$Payment$id(fields.Y9)))
				]));
		var encodedExternal = $elm$json$Json$Encode$bool(
			external || (!$author$project$Api$Payment$isRefundableOnPaymentProcessor(fields.Y9)));
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2('payment', encodedRefund),
					_Utils_Tuple2(
					'amount_in_cents',
					A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.LE)),
					_Utils_Tuple2('external', encodedExternal)
				]));
	});
var $author$project$Components$CustomerInvoice$RefundsForm$positiveAmountInCents = function (form) {
	var amountInCents = A2(
		$elm$core$Maybe$withDefault,
		0,
		A2(
			$elm$core$Maybe$andThen,
			$author$project$Currency$toInt,
			$author$project$Utils$Form$fields(form).LE));
	return amountInCents > 0;
};
var $author$project$Components$CustomerInvoice$RefundsForm$validRefundForms = function (forms) {
	return A2(
		$elm$core$List$filter,
		$author$project$Components$CustomerInvoice$RefundsForm$positiveAmountInCents,
		A2($elm$core$List$map, $elm$core$Tuple$second, forms));
};
var $author$project$Components$CustomerInvoice$RefundsForm$encodedForms = F2(
	function (_v0, external) {
		var model = _v0;
		var encodedRefunds = A2(
			$elm$json$Json$Encode$list,
			$author$project$Components$CustomerInvoice$RefundsForm$encodedForm(external),
			$author$project$Components$CustomerInvoice$RefundsForm$validRefundForms(model.aL));
		return _List_fromArray(
			[
				_Utils_Tuple2('refunds', encodedRefunds)
			]);
	});
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$hasAnyChange = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.SD);
	return !_Utils_eq(
		fields,
		A2($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$initFormFields, fields.afx, false));
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$hasAnyChange = function (_v0) {
	var model = _v0;
	return A2(
		$elm$core$List$any,
		A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$hasAnyChange),
		model.ap);
};
var $author$project$Components$CustomerInvoice$RefundsForm$hasAnyValidationError = function (_v0) {
	var errors = _v0.agX;
	return !$elm$core$List$isEmpty(errors);
};
var $author$project$Components$CustomerInvoice$RefundsForm$paymentsRefundAmounts = function (_v0) {
	var model = _v0;
	return A2(
		$elm$core$List$map,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Tuple$second,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Utils$Form$fields,
				function (fields) {
					return _Utils_Tuple2(fields.Y9, fields.LE);
				})),
		model.aL);
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$createPartialRefund = F2(
	function (apiClient, model) {
		if ($author$project$Components$CustomerInvoice$RefundsForm$hasAnyValidationError(model.e0)) {
			return $elm$core$Platform$Cmd$none;
		} else {
			if ($author$project$Components$CustomerInvoice$AdjustmentsForm$hasAnyChange(model.bQ)) {
				var encodedBody = $elm$json$Json$Encode$object(
					_Utils_ap(
						$author$project$Components$CustomerInvoice$AdjustmentsForm$encodedForm(model.bQ),
						A2(
							$author$project$Components$CustomerInvoice$RefundsForm$encodedForms,
							model.e0,
							$author$project$Components$CustomerInvoice$ProcessRefundModal$isAnExternalRefund(model.hs))));
				return A4(
					$author$project$Api$Provider$InvoiceAdjustment$create,
					apiClient,
					$author$project$Api$Provider$CustomerInvoice$One$id(model.Uk),
					encodedBody,
					$author$project$Components$CustomerInvoice$ProcessRefundModal$InvoiceAdjustmentCreated);
			} else {
				return $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						function (_v0) {
							var payment = _v0.a;
							var amountInCents = _v0.b;
							if (!amountInCents.$) {
								var amountInCents_ = amountInCents.a;
								return A6(
									$author$project$Components$CustomerInvoice$ProcessRefundModal$createRefund,
									apiClient,
									model,
									$author$project$Utils$Form$fields(model.SD),
									payment,
									amountInCents_,
									$author$project$Components$CustomerInvoice$ProcessRefundModal$PartialRefundCreated);
							} else {
								return $elm$core$Platform$Cmd$none;
							}
						},
						$author$project$Components$CustomerInvoice$RefundsForm$paymentsRefundAmounts(model.e0)));
			}
		}
	});
var $author$project$Components$CustomerInvoice$ProcessRefundModal$formFieldsUpdate = F2(
	function (field, fields) {
		var string = field;
		return _Utils_update(
			fields,
			{
				aiG: $author$project$Utils$String$toMaybe(string)
			});
	});
var $author$project$Components$CustomerInvoice$ProcessRefundModal$GotInvoice = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$invoiceExpands = _List_fromArray(
	[0, 1, 2, 3]);
var $author$project$Components$CustomerInvoice$ProcessRefundModal$retrieveInvoice = F2(
	function (apiClient, invoiceId) {
		return A4($author$project$Api$Provider$CustomerInvoice$retrieve, apiClient, invoiceId, $author$project$Components$CustomerInvoice$ProcessRefundModal$invoiceExpands, $author$project$Components$CustomerInvoice$ProcessRefundModal$GotInvoice);
	});
var $author$project$Components$CustomerInvoice$ProcessRefundModal$initCreatePaymentModal = F4(
	function (apiClient, model, external, invoice) {
		var patientPath = A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$Patient$patientPath,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$Patient$Shared$id,
				$author$project$Api$Provider$CustomerInvoice$One$owner(model.Uk)));
		var _v0 = $author$project$Components$Invoice$CreatePaymentModal$init(model.lk.dd)(model.lk.J7)(
			$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(
				$author$project$Api$Provider$CustomerInvoice$One$id(invoice)))(patientPath)(apiClient)(model.aa4)(
			$author$project$Api$Practice$Provider(model.ZV))(model.Ij)(model.t9)(
			function (d) {
				return _Utils_update(
					d,
					{R5: external, alv: model.Ij});
			})(
			A2(
				$author$project$Components$Invoice$CreatePaymentModal$CustomerInvoice,
				$author$project$Api$Provider$Patient$One$id(model.YY),
				invoice));
		var createPaymentModal = _v0.a;
		var createPaymentModalCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					m$: $elm$core$Maybe$Just(createPaymentModal)
				}),
			A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerInvoice$ProcessRefundModal$CreatePaymentModalMsg, createPaymentModalCmd));
	});
var $author$project$Components$CustomerInvoice$ProcessRefundModal$showPaymentModal = F3(
	function (apiClient, model, external) {
		return A2(
			$author$project$Utils$Tuple3$fromTuple2,
			_List_Nil,
			A4($author$project$Components$CustomerInvoice$ProcessRefundModal$initCreatePaymentModal, apiClient, model, external, model.Uk));
	});
var $author$project$Components$CustomerInvoice$RefundsForm$None = {$: 0};
var $author$project$Components$CustomerInvoice$RefundsForm$TotalRefundAmountChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$CustomerInvoice$RefundsForm$PartialRefundAmountInCents = $elm$core$Basics$identity;
var $author$project$Components$CustomerInvoice$RefundsForm$formFieldsUpdate = F2(
	function (field, fields) {
		var currency = field;
		return _Utils_update(
			fields,
			{LE: currency});
	});
var $author$project$Components$CustomerInvoice$RefundsForm$assignMaxiumumRefund = F2(
	function (remainingAmount, _v0) {
		var paymentId = _v0.a;
		var form = _v0.b;
		var refundAmount = A2(
			$elm$core$Basics$min,
			remainingAmount,
			$author$project$Api$Payment$amountInCents(
				$author$project$Utils$Form$fields(form).Y9));
		var newRemainingAmount = remainingAmount - refundAmount;
		var newForm = $author$project$Utils$Form$fromValidateResult(
			A2(
				$author$project$Utils$Form$validate,
				$author$project$Components$CustomerInvoice$RefundsForm$refundValidator,
				A3(
					$author$project$Utils$Form$update,
					$author$project$Components$CustomerInvoice$RefundsForm$formFieldsUpdate,
					$elm$core$Maybe$Just(
						$author$project$Currency$fromInt(refundAmount)),
					form)));
		return _Utils_Tuple2(
			newRemainingAmount,
			_Utils_Tuple2(paymentId, newForm));
	});
var $author$project$Components$CustomerInvoice$RefundsForm$findRefundForm = F2(
	function (paymentId, forms) {
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$second,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$first,
						$elm$core$Basics$eq(paymentId)),
					forms)));
	});
var $elm_community$list_extra$List$Extra$mapAccuml = F3(
	function (f, acc0, list) {
		var _v0 = A3(
			$elm$core$List$foldl,
			F2(
				function (x, _v1) {
					var acc1 = _v1.a;
					var ys = _v1.b;
					var _v2 = A2(f, acc1, x);
					var acc2 = _v2.a;
					var y = _v2.b;
					return _Utils_Tuple2(
						acc2,
						A2($elm$core$List$cons, y, ys));
				}),
			_Utils_Tuple2(acc0, _List_Nil),
			list);
		var accFinal = _v0.a;
		var generatedList = _v0.b;
		return _Utils_Tuple2(
			accFinal,
			$elm$core$List$reverse(generatedList));
	});
var $author$project$Components$CustomerInvoice$RefundsForm$updateRefundForm = F3(
	function (paymentId, newForm, forms) {
		return A2(
			$elm$core$List$map,
			function (_v0) {
				var id = _v0.a;
				var form = _v0.b;
				return _Utils_eq(id, paymentId) ? _Utils_Tuple2(id, newForm) : _Utils_Tuple2(id, form);
			},
			forms);
	});
var $author$project$Components$CustomerInvoice$RefundsForm$update = F2(
	function (msg, _v0) {
		var model = _v0;
		if (!msg.$) {
			var adjustmentAmount = msg.a;
			var _v2 = A3($elm_community$list_extra$List$Extra$mapAccuml, $author$project$Components$CustomerInvoice$RefundsForm$assignMaxiumumRefund, adjustmentAmount, model.aL);
			var newForms = _v2.b;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{rb: adjustmentAmount, aL: newForms}),
				$elm$core$Platform$Cmd$none,
				$author$project$Components$CustomerInvoice$RefundsForm$None);
		} else {
			var paymentId = msg.a;
			var field = msg.b;
			var _v3 = A2($author$project$Components$CustomerInvoice$RefundsForm$findRefundForm, paymentId, model.aL);
			if (!_v3.$) {
				var form = _v3.a;
				var newForm = $author$project$Utils$Form$fromValidateResult(
					A2(
						$author$project$Utils$Form$validate,
						$author$project$Components$CustomerInvoice$RefundsForm$refundValidator,
						A3($author$project$Utils$Form$update, $author$project$Components$CustomerInvoice$RefundsForm$formFieldsUpdate, field, form)));
				var newForms = A3($author$project$Components$CustomerInvoice$RefundsForm$updateRefundForm, paymentId, newForm, model.aL);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aL: newForms}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$CustomerInvoice$RefundsForm$TotalRefundAmountChanged(
						$author$project$Components$CustomerInvoice$RefundsForm$totalRefundAmount(newForms)));
			} else {
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Components$CustomerInvoice$RefundsForm$None);
			}
		}
	});
var $author$project$Components$CustomerInvoice$RefundsForm$GotAdjustmentAmount = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$CustomerInvoice$RefundsForm$updateAdjustmentAmount = function (adjustmentAmount) {
	return A2(
		$elm$core$Task$perform,
		$elm$core$Basics$identity,
		$elm$core$Task$succeed(
			$author$project$Components$CustomerInvoice$RefundsForm$GotAdjustmentAmount(adjustmentAmount)));
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$updateRefundAmount = F2(
	function (amount, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{qD: amount});
	});
var $author$project$Components$CustomerInvoice$ProcessRefundModal$InvoiceVoided = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$voidInvoice = F2(
	function (model, apiClient) {
		return A4(
			$author$project$Api$Provider$CustomerInvoice$void,
			apiClient,
			$author$project$Api$Provider$CustomerInvoice$One$id(model.Uk),
			{
				akB: false,
				amq: $elm$core$Maybe$Just('')
			},
			$author$project$Components$CustomerInvoice$ProcessRefundModal$InvoiceVoided);
	});
var $author$project$Components$CustomerInvoice$ProcessRefundModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var _v1 = A2(
					$author$project$Utils$Form$validate,
					$rtfeldman$elm_validate$Validate$all(_List_Nil),
					model.SD);
				if (!_v1.$) {
					var _v2 = _v1.a;
					var newForm = _v2.a;
					var validFormFields = _v2.b;
					var cmd = model.gD ? $elm$core$Platform$Cmd$batch(
						A3($author$project$Components$CustomerInvoice$ProcessRefundModal$createFullRefund, model, apiClient, validFormFields)) : A2($author$project$Components$CustomerInvoice$ProcessRefundModal$createPartialRefund, apiClient, model);
					return {
						GZ: cmd,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{SD: newForm, e$: $author$project$Api$Data$Loading}),
						aR: _List_Nil
					};
				} else {
					var newForm = _v1.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{SD: newForm}),
						aR: _List_Nil
					};
				}
			case 1:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: 1, aiO: model, aR: _List_Nil};
			case 2:
				var toggle = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{gD: toggle}),
					aR: _List_Nil
				};
			case 14:
				var toggle = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							hs: $elm$core$Maybe$Just(toggle)
						}),
					aR: _List_Nil
				};
			case 3:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$CustomerInvoice$ProcessRefundModal$formFieldsUpdate, field, model.SD);
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{SD: newForm}),
					aR: _List_Nil
				};
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					var invoiceId = $author$project$Api$Provider$CustomerInvoice$One$id(model.Uk);
					return {
						GZ: A2($author$project$Components$CustomerInvoice$ProcessRefundModal$retrieveInvoice, apiClient, invoiceId),
						agZ: 2,
						aiO: _Utils_update(
							model,
							{e$: response}),
						aR: _List_Nil
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 2,
						aiO: _Utils_update(
							model,
							{e$: response}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 5:
				var response = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 3,
					aiO: model,
					aR: $author$project$OutMsg$handleErrorResponse(response)
				};
			case 8:
				var _v4 = A3($author$project$Components$CustomerInvoice$ProcessRefundModal$showPaymentModal, apiClient, model, false);
				var newModel = _v4.a;
				var cmd = _v4.b;
				var outMsgs = _v4.c;
				return {
					GZ: cmd,
					agZ: 0,
					aiO: _Utils_update(
						newModel,
						{tt: true}),
					aR: outMsgs
				};
			case 11:
				var subMsg = msg.a;
				var _v5 = model.m$;
				if (!_v5.$) {
					var createPaymentModal = _v5.a;
					var createPaymentModalResult = A3($author$project$Components$Invoice$CreatePaymentModal$update, apiClient, subMsg, createPaymentModal);
					var _v6 = function () {
						var _v7 = createPaymentModalResult.agZ;
						switch (_v7) {
							case 1:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(createPaymentModalResult.aiO),
									model.Uk,
									0);
							case 2:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.Uk, 4);
							default:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.Uk, 0);
						}
					}();
					var createPaymentModal_ = _v6.a;
					var invoice = _v6.b;
					var event = _v6.c;
					return {
						GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerInvoice$ProcessRefundModal$CreatePaymentModalMsg, createPaymentModalResult.GZ),
						agZ: event,
						aiO: _Utils_update(
							model,
							{m$: createPaymentModal_, Uk: invoice, tt: false}),
						aR: createPaymentModalResult.aR
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
			case 6:
				var subMsg = msg.a;
				var adjustmentsFormResult = A3($author$project$Components$CustomerInvoice$AdjustmentsForm$update, apiClient, subMsg, model.bQ);
				var _v8 = function () {
					var _v9 = adjustmentsFormResult.agZ;
					if (!_v9.$) {
						return _Utils_Tuple3(adjustmentsFormResult.aiO, 0, $elm$core$Platform$Cmd$none);
					} else {
						var adjustmentAmount = _v9.a;
						var refundsFormCmd = A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Components$CustomerInvoice$ProcessRefundModal$RefundsFormMsg,
							$author$project$Components$CustomerInvoice$RefundsForm$updateAdjustmentAmount(adjustmentAmount));
						return _Utils_Tuple3(adjustmentsFormResult.aiO, 0, refundsFormCmd);
					}
				}();
				var adjustmentsForm_ = _v8.a;
				var event = _v8.b;
				var cmd = _v8.c;
				return {
					GZ: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								cmd,
								A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerInvoice$ProcessRefundModal$AdjustmentsFormMsg, adjustmentsFormResult.GZ)
							])),
					agZ: event,
					aiO: _Utils_update(
						model,
						{bQ: adjustmentsForm_}),
					aR: adjustmentsFormResult.aR
				};
			case 12:
				var response = msg.a;
				var newModel = function () {
					if (response.$ === 3) {
						var invoice_ = response.a;
						return _Utils_update(
							model,
							{Uk: invoice_});
					} else {
						return model;
					}
				}();
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: newModel,
					aR: $author$project$OutMsg$handleErrorResponse(response)
				};
			case 9:
				return {
					GZ: A2($author$project$Components$CustomerInvoice$ProcessRefundModal$voidInvoice, model, apiClient),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{vp: true}),
					aR: _List_Nil
				};
			case 7:
				var subMsg = msg.a;
				var _v11 = A2(
					$author$project$Utils$Tuple3$mapFirst,
					$author$project$Components$CustomerInvoice$RefundsForm$validate,
					A2($author$project$Components$CustomerInvoice$RefundsForm$update, subMsg, model.e0));
				var newRefundsFormModel = _v11.a;
				var newRefundsFormCmd = _v11.b;
				var refundEvent = _v11.c;
				var newAdjustmentForms = function () {
					if (refundEvent.$ === 1) {
						var amount = refundEvent.a;
						return A2($author$project$Components$CustomerInvoice$AdjustmentsForm$updateRefundAmount, amount, model.bQ);
					} else {
						return model.bQ;
					}
				}();
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerInvoice$ProcessRefundModal$RefundsFormMsg, newRefundsFormCmd),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{bQ: newAdjustmentForms, e0: newRefundsFormModel}),
					aR: _List_Nil
				};
			case 10:
				var response = msg.a;
				var newModel = function () {
					if (response.$ === 3) {
						var invoice_ = response.a;
						return _Utils_update(
							model,
							{Uk: invoice_});
					} else {
						return model;
					}
				}();
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 4,
					aiO: _Utils_update(
						newModel,
						{vp: false}),
					aR: _List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 3, 'Invoice voided')
						])
				};
			default:
				var response = msg.a;
				switch (response.$) {
					case 3:
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 4,
							aiO: model,
							aR: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Invoice adjustment created')
								])
						};
					case 2:
						var error = response.a;
						var errorString = $author$project$Api$Data$errorToString(error);
						var errorMessage = $elm$core$String$isEmpty(errorString) ? 'Unexpected error processing your invoice adjustment' : errorString;
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 4,
							aiO: model,
							aR: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 1, errorMessage)
								])
						};
					default:
						return {GZ: $elm$core$Platform$Cmd$none, agZ: 4, aiO: model, aR: _List_Nil};
				}
		}
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$AddNewUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$Closed = 0;
var $author$project$Components$Invoice$CreateScheduledPaymentModal$None = 1;
var $author$project$Components$Invoice$CreateScheduledPaymentModal$PaymentCreated = 2;
var $author$project$Components$Invoice$CreateScheduledPaymentModal$PaymentSourceDropdownFieldUpdated = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$PaymentSourceFieldUpdated = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$PaymentSourceSearchFieldUpdated = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$AmountInCentsValidation = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$validateAmountInCents = F3(
	function (invoiceDueInCents, index, scheduledPayment) {
		return A2(
			$author$project$Utils$Validate$isInvalidCurrency,
			{
				aeU: false,
				AU: $elm$core$Maybe$Nothing,
				W9: $elm$core$Maybe$Just(50)
			},
			scheduledPayment.LE) ? _List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Components$Invoice$CreateScheduledPaymentModal$AmountInCentsValidation(index),
				'Must be more than $0.50')
			]) : (A2(
			$author$project$Utils$Validate$isInvalidCurrency,
			{
				aeU: false,
				AU: $elm$core$Maybe$Just(invoiceDueInCents),
				W9: $elm$core$Maybe$Just(50)
			},
			scheduledPayment.LE) ? _List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Components$Invoice$CreateScheduledPaymentModal$AmountInCentsValidation(index),
				'Invalid number.')
			]) : _List_Nil);
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$amountInCentsFormValidation = F2(
	function (invoiceDueInCents, scheduledPayment) {
		return $rtfeldman$elm_validate$Validate$fromErrors(
			function (_v0) {
				return A3($author$project$Components$Invoice$CreateScheduledPaymentModal$validateAmountInCents, invoiceDueInCents, scheduledPayment.sG, scheduledPayment);
			});
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledPaymentsCreated = function (a) {
	return {$: 11, a: a};
};
var $author$project$Api$Provider$ScheduledPayment$create = F4(
	function (apiClient, payableId, scheduledPaymentsList, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'scheduled_payments',
					A2(
						$elm$json$Json$Encode$list,
						function (fieldMap) {
							return $elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'id',
										A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fieldMap.ahP)),
										_Utils_Tuple2(
										'scheduled_on',
										A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fieldMap.ale)),
										_Utils_Tuple2(
										'payment_source_id',
										$elm$json$Json$Encode$string(
											A2(
												$elm$core$Maybe$withDefault,
												'',
												A2($elm$core$Maybe$map, $author$project$Api$Source$id, fieldMap.Zg)))),
										_Utils_Tuple2(
										'amount_in_cents',
										A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fieldMap.LE)),
										_Utils_Tuple2(
										'memo',
										A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fieldMap.aiG))
									]));
						},
						scheduledPaymentsList))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$ScheduledPayment$Shared$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$ScheduledPayment$schedulePaymentsPath(payableId))));
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$editableScheduledPaymentFields = function (formFields) {
	return A2(
		$elm$core$List$filter,
		function (scheduledPaymentField) {
			return !scheduledPaymentField.$v;
		},
		formFields);
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$createScheduledPayment = F3(
	function (apiClient, customerInvoice, formFields) {
		var scheduledPaymentsList = A2(
			$elm$core$List$map,
			function (scheduledPaymentField) {
				return {
					LE: A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Maybe$Just(0),
						A2($elm$core$Maybe$map, $author$project$Currency$toInt, scheduledPaymentField.LE)),
					ahP: scheduledPaymentField.ahP,
					aiG: scheduledPaymentField.aiG,
					Zg: scheduledPaymentField.Zg,
					ale: scheduledPaymentField.ale
				};
			},
			$author$project$Components$Invoice$CreateScheduledPaymentModal$editableScheduledPaymentFields(formFields));
		return A4(
			$author$project$Api$Provider$ScheduledPayment$create,
			apiClient,
			$author$project$Api$Provider$CustomerInvoice$One$id(customerInvoice),
			scheduledPaymentsList,
			$author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledPaymentsCreated);
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$GotPassthroughFees = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$sourceIsACreditCard = function (source) {
	return _Utils_eq(
		A2($elm$core$Maybe$andThen, $author$project$Api$Source$type_, source),
		$elm$core$Maybe$Just('Card'));
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$fetchPassthroughFeesCmd = F6(
	function (shouldChargeCreditCardFees, apiClient, amount, sourceChoice, patientId, index) {
		if (shouldChargeCreditCardFees && $author$project$Components$Invoice$CreateScheduledPaymentModal$sourceIsACreditCard(sourceChoice)) {
			var _v0 = A2($elm$core$Maybe$map, $author$project$Api$Source$id, sourceChoice);
			if (!_v0.$) {
				var sourceId = _v0.a;
				return A6(
					$author$project$Api$Provider$PassthroughFee$One$calculatePassthroughFees,
					apiClient,
					patientId,
					$elm$core$Maybe$Just(sourceId),
					$elm$core$Maybe$Nothing,
					amount,
					$author$project$Components$Invoice$CreateScheduledPaymentModal$GotPassthroughFees(index));
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$GotScheduledPayments = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$fetchScheduledPayments = F2(
	function (apiClient, customerInvoice) {
		return A3(
			$author$project$Api$Provider$ScheduledPayment$list,
			apiClient,
			$author$project$Api$Provider$CustomerInvoice$One$id(customerInvoice),
			$author$project$Components$Invoice$CreateScheduledPaymentModal$GotScheduledPayments);
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 1:
				var index = field.a;
				var amountInCents = field.b;
				var updatedScheduledPayment = A3(
					$elm_community$list_extra$List$Extra$updateAt,
					index,
					function (scheduledPaymentForm) {
						return _Utils_update(
							scheduledPaymentForm,
							{LE: amountInCents, jl: true});
					},
					fields.i);
				return _Utils_update(
					fields,
					{i: updatedScheduledPayment});
			case 4:
				var index = field.a;
				var source = field.b;
				var updatedPassthroughFees = $author$project$Components$Invoice$CreateScheduledPaymentModal$sourceIsACreditCard(source) ? A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Maybe$Nothing,
					A2(
						$elm$core$Maybe$map,
						function (scheduledPaymentForm) {
							return scheduledPaymentForm.YW;
						},
						A2($elm_community$list_extra$List$Extra$getAt, index, fields.i))) : $elm$core$Maybe$Nothing;
				var updatedScheduledPayment = A3(
					$elm_community$list_extra$List$Extra$updateAt,
					index,
					function (scheduledPaymentForm) {
						return _Utils_update(
							scheduledPaymentForm,
							{YW: updatedPassthroughFees, Zg: source});
					},
					fields.i);
				return _Utils_update(
					fields,
					{i: updatedScheduledPayment});
			case 5:
				var index = field.a;
				var dropdown = field.b;
				var updatedScheduledPayment = A3(
					$elm_community$list_extra$List$Extra$updateAt,
					index,
					function (scheduledPaymentForm) {
						return _Utils_update(
							scheduledPaymentForm,
							{o5: dropdown});
					},
					fields.i);
				return _Utils_update(
					fields,
					{i: updatedScheduledPayment});
			case 6:
				var index = field.a;
				var query = field.b;
				var updatedScheduledPayment = A3(
					$elm_community$list_extra$List$Extra$updateAt,
					index,
					function (scheduledPaymentForm) {
						return _Utils_update(
							scheduledPaymentForm,
							{o6: query});
					},
					fields.i);
				return _Utils_update(
					fields,
					{i: updatedScheduledPayment});
			case 3:
				var index = field.a;
				var memo = field.b;
				var updatedScheduledPayment = A3(
					$elm_community$list_extra$List$Extra$updateAt,
					index,
					function (scheduledPaymentForm) {
						return _Utils_update(
							scheduledPaymentForm,
							{
								jl: true,
								aiG: $elm$core$Maybe$Just(memo)
							});
					},
					fields.i);
				return _Utils_update(
					fields,
					{i: updatedScheduledPayment});
			case 7:
				var index = field.a;
				var date = field.b;
				var updatedScheduledPayment = A3(
					$elm_community$list_extra$List$Extra$updateAt,
					index,
					function (scheduledPaymentForm) {
						return _Utils_update(
							scheduledPaymentForm,
							{jl: true, ale: date});
					},
					fields.i);
				return _Utils_update(
					fields,
					{i: updatedScheduledPayment});
			case 8:
				var index = field.a;
				var dateInput = field.b;
				var updatedScheduledPayment = A3(
					$elm_community$list_extra$List$Extra$updateAt,
					index,
					function (scheduledPaymentForm) {
						return _Utils_update(
							scheduledPaymentForm,
							{pS: dateInput});
					},
					fields.i);
				return _Utils_update(
					fields,
					{i: updatedScheduledPayment});
			case 2:
				var index = field.a;
				var updatedScheduledPayment = A3(
					$elm_community$list_extra$List$Extra$updateAt,
					index,
					function (scheduledPaymentForm) {
						return _Utils_update(
							scheduledPaymentForm,
							{$v: true});
					},
					fields.i);
				return _Utils_update(
					fields,
					{i: updatedScheduledPayment});
			default:
				var updatedScheduledPaymentsList = field.a;
				return _Utils_update(
					fields,
					{i: updatedScheduledPaymentsList});
		}
	});
var $author$project$Api$Provider$ScheduledPayment$Shared$payment = function (_v0) {
	var record = _v0;
	return record.Y9;
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$existingPayment = function (scheduledPayment) {
	return A2($elm$core$Maybe$andThen, $author$project$Api$Provider$ScheduledPayment$Shared$payment, scheduledPayment.oN);
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$isScheduledPaymentDisabled = function (scheduledPayment) {
	var _v0 = _Utils_Tuple2(
		scheduledPayment.oN,
		$author$project$Components$Invoice$CreateScheduledPaymentModal$existingPayment(scheduledPayment));
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var originalScheduledPayment = _v0.a.a;
		return $author$project$Api$Provider$ScheduledPayment$Shared$status(originalScheduledPayment) === 'processed';
	} else {
		return (_Utils_eq(scheduledPayment.ahP, $elm$core$Maybe$Nothing) || scheduledPayment.jl) ? false : (scheduledPayment.alH === 'processed');
	}
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$activeScheduledPaymentFields = function (formFields) {
	return A2(
		$elm$core$List$filter,
		function (scheduledPaymentField) {
			return !$author$project$Components$Invoice$CreateScheduledPaymentModal$isScheduledPaymentDisabled(scheduledPaymentField);
		},
		$author$project$Components$Invoice$CreateScheduledPaymentModal$editableScheduledPaymentFields(formFields));
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$PaymentSourceValidation = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$validatePaymentSource = F2(
	function (index, scheduledPayment) {
		return _Utils_eq(scheduledPayment.Zg, $elm$core$Maybe$Nothing) ? _List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Components$Invoice$CreateScheduledPaymentModal$PaymentSourceValidation(index),
				'Please pick a source.')
			]) : _List_Nil;
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnValidation = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$validateScheduledOn = F3(
	function (index, today, scheduledPayment) {
		var _v0 = scheduledPayment.ale;
		if (!_v0.$) {
			var scheduledOn = _v0.a;
			return A2($author$project$Utils$Date$isBeforeOrEqual, scheduledOn, today) ? _List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnValidation(index),
					'Select a future date.')
				]) : _List_Nil;
		} else {
			return _List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnValidation(index),
					'Select a future date.')
				]);
		}
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$validateForm = F3(
	function (invoiceDueInCents, today, formFields) {
		var scheduledPaymentsToValidate = $author$project$Components$Invoice$CreateScheduledPaymentModal$activeScheduledPaymentFields(formFields.i);
		var sourceValidations = A2(
			$elm$core$List$concatMap,
			function (scheduledPayment) {
				return A2($author$project$Components$Invoice$CreateScheduledPaymentModal$validatePaymentSource, scheduledPayment.sG, scheduledPayment);
			},
			scheduledPaymentsToValidate);
		var scheduleOnValidations = A2(
			$elm$core$List$concatMap,
			function (scheduledPayment) {
				return A3($author$project$Components$Invoice$CreateScheduledPaymentModal$validateScheduledOn, scheduledPayment.sG, today, scheduledPayment);
			},
			scheduledPaymentsToValidate);
		var amountInCentsValidations = A2(
			$elm$core$List$concatMap,
			function (scheduledPayment) {
				return A3($author$project$Components$Invoice$CreateScheduledPaymentModal$validateAmountInCents, invoiceDueInCents, scheduledPayment.sG, scheduledPayment);
			},
			scheduledPaymentsToValidate);
		return $elm$core$List$concat(
			_List_fromArray(
				[amountInCentsValidations, sourceValidations, scheduleOnValidations]));
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnPaymentSourceCombinationValidation = {$: 3};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$hasScheduledOnPaymentSourceCombinedErrors = function (fields) {
	var scheduledPaymentsToValidate = $author$project$Components$Invoice$CreateScheduledPaymentModal$activeScheduledPaymentFields(fields.i);
	var allPairs = A2(
		$elm$core$List$map,
		function (scheduledPayment) {
			var _v0 = _Utils_Tuple2(scheduledPayment.Zg, scheduledPayment.ale);
			if (_v0.a.$ === 1) {
				if (!_v0.b.$) {
					var _v1 = _v0.a;
					var scheduledOn = _v0.b.a;
					return '-1|' + $justinmimbs$date$Date$toIsoString(scheduledOn);
				} else {
					return '0|0';
				}
			} else {
				if (!_v0.b.$) {
					var paymentSource = _v0.a.a;
					var scheduledOn = _v0.b.a;
					return $author$project$Api$Source$id(paymentSource) + ('|' + $justinmimbs$date$Date$toIsoString(scheduledOn));
				} else {
					var paymentSource = _v0.a.a;
					return $author$project$Api$Source$id(paymentSource) + '|1';
				}
			}
		},
		scheduledPaymentsToValidate);
	var uniquePairs = $elm_community$list_extra$List$Extra$unique(allPairs);
	return !_Utils_eq(uniquePairs, allPairs);
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$validateScheduledOnPaymentSourceCombined = function (fields) {
	return $author$project$Components$Invoice$CreateScheduledPaymentModal$hasScheduledOnPaymentSourceCombinedErrors(fields) ? _List_fromArray(
		[
			_Utils_Tuple2($author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnPaymentSourceCombinationValidation, 'The same source can not be used for more than single scheduled payment per day')
		]) : _List_Nil;
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$formValidation = F2(
	function (invoiceDueInCents, today) {
		return $rtfeldman$elm_validate$Validate$all(
			_List_fromArray(
				[
					$rtfeldman$elm_validate$Validate$fromErrors(
					A2($author$project$Components$Invoice$CreateScheduledPaymentModal$validateForm, invoiceDueInCents, today)),
					$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Invoice$CreateScheduledPaymentModal$validateScheduledOnPaymentSourceCombined)
				]));
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$PaymentSourceDropdownMsg = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Api$Provider$ScheduledPayment$Shared$amountInCents = function (_v0) {
	var record = _v0;
	return record.LE;
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$calculateExistingSourceValue = F2(
	function (scheduledPaymentSource, sources) {
		if (!scheduledPaymentSource.$) {
			var source = scheduledPaymentSource.a;
			return A2(
				$elm$core$List$any,
				function (s) {
					return _Utils_eq(
						$author$project$Api$Source$id(s),
						$author$project$Api$Source$id(source));
				},
				sources) ? ((!_Utils_eq(
				$author$project$Api$Source$status(source),
				$elm$core$Maybe$Just('failed'))) ? scheduledPaymentSource : $elm$core$Maybe$Nothing) : $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$calculateScheduledPaymentSourceDefault = F2(
	function (model, scheduledPayments) {
		var defaultSource = A2(
			$elm$core$Maybe$map,
			$author$project$Api$Source$Source,
			$author$project$Api$Provider$CustomerInvoice$One$source(model.m6));
		var _v0 = $elm$core$List$head(
			$elm$core$List$reverse(scheduledPayments));
		if (!_v0.$) {
			var scheduledPaymentForm = _v0.a;
			var _v1 = A2($elm$core$Maybe$andThen, $author$project$Api$Source$status, scheduledPaymentForm.Zg);
			if ((!_v1.$) && (_v1.a === 'failed')) {
				return $elm$core$Maybe$Nothing;
			} else {
				var _v2 = A2($elm$core$Maybe$andThen, $author$project$Api$Source$status, defaultSource);
				if ((!_v2.$) && (_v2.a === 'failed')) {
					return $elm$core$Maybe$Nothing;
				} else {
					return A2(
						$elm$core$Maybe$withDefault,
						defaultSource,
						A2($elm$core$Maybe$map, $elm$core$Maybe$Just, scheduledPaymentForm.Zg));
				}
			}
		} else {
			return defaultSource;
		}
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$deriveScheduledPaymentSource = function (scheduledPayment) {
	return A2(
		$elm$core$Maybe$map,
		$author$project$Api$Source$Source,
		$author$project$Api$Provider$ScheduledPayment$Shared$paymentSource(scheduledPayment));
};
var $author$project$Api$Provider$ScheduledPayment$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$ScheduledPayment$Shared$memo = function (_v0) {
	var record = _v0;
	return record.aiG;
};
var $author$project$Api$Provider$ScheduledPayment$Shared$passthroughFeesInCents = function (_v0) {
	var record = _v0;
	return record.YW;
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$patientSources = function (model) {
	var _v0 = _Utils_Tuple2(model.rC, model.rs);
	if ((_v0.a.$ === 3) && (_v0.b.$ === 3)) {
		var _v1 = _v0.a;
		var cards = _v1.a;
		var _v2 = _v0.b;
		var bankAccounts = _v2.a;
		return $elm$core$List$reverse(
			A2(
				$elm$core$List$sortBy,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Api$Source$createdAt,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map($elm$time$Time$posixToMillis),
						$elm$core$Maybe$withDefault(0))),
				_Utils_ap(
					A2($elm$core$List$map, $author$project$Api$Source$Card, cards),
					A2($elm$core$List$map, $author$project$Api$Source$BankAccount, bankAccounts))));
	} else {
		return _List_Nil;
	}
};
var $author$project$Api$Provider$ScheduledPayment$Shared$scheduledOn = function (_v0) {
	var record = _v0;
	return record.ale;
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$generateScheduledPaymentsList = F2(
	function (model, _v0) {
		var index = _v0.a;
		var scheduledPayment_ = _v0.b;
		var sourceDropdown = $author$project$Ui$Dropdown$init(
			$author$project$Ui$Dropdown$defaultConfig(
				{
					ahP: 'schpmt-source-select-' + $elm$core$String$fromInt(index),
					al6: $author$project$Components$Invoice$CreateScheduledPaymentModal$PaymentSourceDropdownMsg(index)
				}));
		var amountInCents = function () {
			if (!scheduledPayment_.$) {
				var scheduledPayment = scheduledPayment_.a;
				return $author$project$Currency$fromMaybeInt(
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$ScheduledPayment$Shared$amountInCents(scheduledPayment)));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var _v1 = $author$project$Components$DateInput$init;
		var dateInput = _v1.a;
		var dateInputCmd = _v1.b;
		var updatedScheduledPayment = function () {
			if (!scheduledPayment_.$) {
				var scheduledPayment = scheduledPayment_.a;
				var paymentSource = A2(
					$author$project$Components$Invoice$CreateScheduledPaymentModal$calculateExistingSourceValue,
					$author$project$Components$Invoice$CreateScheduledPaymentModal$deriveScheduledPaymentSource(scheduledPayment),
					$author$project$Components$Invoice$CreateScheduledPaymentModal$patientSources(model));
				return {
					LE: amountInCents,
					jl: false,
					ahP: $elm$core$Maybe$Just(
						$author$project$Api$Provider$ScheduledPayment$Shared$id(scheduledPayment)),
					sG: index,
					aiG: $author$project$Api$Provider$ScheduledPayment$Shared$memo(scheduledPayment),
					oN: $elm$core$Maybe$Just(scheduledPayment),
					YW: $author$project$Api$Provider$ScheduledPayment$Shared$passthroughFeesInCents(scheduledPayment),
					Zg: paymentSource,
					o5: sourceDropdown,
					o6: '',
					$v: false,
					ale: $elm$core$Maybe$Just(
						$author$project$Api$Provider$ScheduledPayment$Shared$scheduledOn(scheduledPayment)),
					pS: dateInput,
					alH: $author$project$Api$Provider$ScheduledPayment$Shared$status(scheduledPayment)
				};
			} else {
				var tomorrow = A3($justinmimbs$date$Date$add, 3, 1, model.FR);
				var fields = $author$project$Utils$Form$fields(model.SD);
				var lastDate = A2(
					$elm$core$Maybe$withDefault,
					model.FR,
					$elm$core$List$head(
						$elm$core$List$reverse(
							A2(
								$elm$core$List$sortBy,
								$justinmimbs$date$Date$toRataDie,
								A2(
									$elm$core$List$map,
									function (scheduledPayment) {
										return A2($elm$core$Maybe$withDefault, tomorrow, scheduledPayment.ale);
									},
									A2(
										$elm$core$List$filter,
										function (scheduledPayment) {
											return !A2(
												$author$project$Utils$Date$isBefore,
												A2($elm$core$Maybe$withDefault, model.FR, scheduledPayment.ale),
												model.FR);
										},
										$author$project$Components$Invoice$CreateScheduledPaymentModal$editableScheduledPaymentFields(fields.i)))))));
				return {
					LE: amountInCents,
					jl: true,
					ahP: $elm$core$Maybe$Nothing,
					sG: index,
					aiG: $elm$core$Maybe$Nothing,
					oN: $elm$core$Maybe$Nothing,
					YW: $elm$core$Maybe$Just(0),
					Zg: A2($author$project$Components$Invoice$CreateScheduledPaymentModal$calculateScheduledPaymentSourceDefault, model, fields.i),
					o5: sourceDropdown,
					o6: '',
					$v: false,
					ale: $elm$core$Maybe$Just(
						A3($justinmimbs$date$Date$add, 3, 1, lastDate)),
					pS: dateInput,
					alH: 'scheduled'
				};
			}
		}();
		return _Utils_Tuple2(
			updatedScheduledPayment,
			A2(
				$elm$core$Platform$Cmd$map,
				A2($author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnSelected, index, dateInput),
				dateInputCmd));
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnFieldUpdated = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnInputFieldUpdated = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$updateScheduledOnFormField = F5(
	function (model, index, dateInput, subMsg, toMsg) {
		var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
		var newDateInput = _v0.a;
		var subCmd = _v0.b;
		var event = _v0.c;
		var changedForm = A3(
			$author$project$Utils$Form$update,
			$author$project$Components$Invoice$CreateScheduledPaymentModal$formFieldsUpdate,
			A2($author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnInputFieldUpdated, index, newDateInput),
			model.SD);
		var newForm = function () {
			if (event.$ === 1) {
				var date = event.a;
				return A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Invoice$CreateScheduledPaymentModal$formFieldsUpdate,
					A2($author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnFieldUpdated, index, date),
					changedForm);
			} else {
				return changedForm;
			}
		}();
		return {
			GZ: A2(
				$elm$core$Platform$Cmd$map,
				A2(toMsg, index, newDateInput),
				subCmd),
			agZ: 1,
			aiO: _Utils_update(
				model,
				{SD: newForm}),
			aR: _List_Nil
		};
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					var scheduledPayments = response.a;
					if ($elm$core$List$length(scheduledPayments) > 0) {
						var scheduledPaymentsIndexedTuples = A2(
							$elm$core$List$indexedMap,
							F2(
								function (index, scheduledPayment) {
									return _Utils_Tuple2(
										index,
										$elm$core$Maybe$Just(scheduledPayment));
								}),
							scheduledPayments);
						var updatedScheduledPaymentsAndCmds = A2(
							$elm$core$List$map,
							$author$project$Components$Invoice$CreateScheduledPaymentModal$generateScheduledPaymentsList(model),
							scheduledPaymentsIndexedTuples);
						var newForm = A3(
							$author$project$Utils$Form$update,
							$author$project$Components$Invoice$CreateScheduledPaymentModal$formFieldsUpdate,
							$author$project$Components$Invoice$CreateScheduledPaymentModal$AddNewUpdated(
								A2($elm$core$List$map, $elm$core$Tuple$first, updatedScheduledPaymentsAndCmds)),
							model.SD);
						return {
							GZ: $elm$core$Platform$Cmd$batch(
								A2($elm$core$List$map, $elm$core$Tuple$second, updatedScheduledPaymentsAndCmds)),
							agZ: 1,
							aiO: _Utils_update(
								model,
								{SD: newForm, dp: false}),
							aR: _List_Nil
						};
					} else {
						var fields = $author$project$Utils$Form$fields(model.SD);
						var _v3 = A2(
							$author$project$Components$Invoice$CreateScheduledPaymentModal$generateScheduledPaymentsList,
							model,
							_Utils_Tuple2(0, $elm$core$Maybe$Nothing));
						var defaultScheduledPayment = _v3.a;
						var dateInputCmd = _v3.b;
						var updatedScheduledPayment = _Utils_ap(
							fields.i,
							_List_fromArray(
								[defaultScheduledPayment]));
						var newForm = A3(
							$author$project$Utils$Form$update,
							$author$project$Components$Invoice$CreateScheduledPaymentModal$formFieldsUpdate,
							$author$project$Components$Invoice$CreateScheduledPaymentModal$AddNewUpdated(updatedScheduledPayment),
							model.SD);
						return {
							GZ: dateInputCmd,
							agZ: 1,
							aiO: _Utils_update(
								model,
								{SD: newForm, dp: false}),
							aR: _List_Nil
						};
					}
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 1, aiO: model, aR: _List_Nil};
				}
			case 4:
				var response = msg.a;
				var cmd = _Utils_eq(model.rs, $author$project$Api$Data$Loading) ? $elm$core$Platform$Cmd$none : A2($author$project$Components$Invoice$CreateScheduledPaymentModal$fetchScheduledPayments, apiClient, model.m6);
				return {
					GZ: cmd,
					agZ: 1,
					aiO: _Utils_update(
						model,
						{rC: response}),
					aR: $author$project$OutMsg$handleErrorResponse(response)
				};
			case 3:
				var response = msg.a;
				var cmd = _Utils_eq(model.rC, $author$project$Api$Data$Loading) ? $elm$core$Platform$Cmd$none : A2($author$project$Components$Invoice$CreateScheduledPaymentModal$fetchScheduledPayments, apiClient, model.m6);
				return {
					GZ: cmd,
					agZ: 1,
					aiO: _Utils_update(
						model,
						{rs: response}),
					aR: $author$project$OutMsg$handleErrorResponse(response)
				};
			case 0:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
			case 2:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Invoice$CreateScheduledPaymentModal$formFieldsUpdate, field, model.SD);
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 1,
					aiO: _Utils_update(
						model,
						{SD: newForm}),
					aR: _List_Nil
				};
			case 1:
				var fields = $author$project$Utils$Form$fields(model.SD);
				var newIndex = $elm$core$List$length(fields.i);
				var _v4 = A2(
					$author$project$Components$Invoice$CreateScheduledPaymentModal$generateScheduledPaymentsList,
					model,
					_Utils_Tuple2(newIndex, $elm$core$Maybe$Nothing));
				var newScheduledPayment = _v4.a;
				var dateInputCmd = _v4.b;
				var updatedScheduledPayment = _Utils_ap(
					fields.i,
					_List_fromArray(
						[newScheduledPayment]));
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Invoice$CreateScheduledPaymentModal$formFieldsUpdate,
					$author$project$Components$Invoice$CreateScheduledPaymentModal$AddNewUpdated(updatedScheduledPayment),
					model.SD);
				return {
					GZ: dateInputCmd,
					agZ: 1,
					aiO: _Utils_update(
						model,
						{SD: newForm}),
					aR: _List_Nil
				};
			case 6:
				var index = msg.a;
				var dropdownMsg = msg.b;
				var _v5 = $author$project$Utils$Form$fields(model.SD);
				var scheduledPaymentsForm = _v5.i;
				var scheduledPaymentFormItem = A2($elm_community$list_extra$List$Extra$getAt, index, scheduledPaymentsForm);
				if (!scheduledPaymentFormItem.$) {
					var scheduledPaymentFormItem_ = scheduledPaymentFormItem.a;
					var _v7 = A2($author$project$Ui$Dropdown$update, dropdownMsg, scheduledPaymentFormItem_.o5);
					var newDropdown = _v7.a;
					var dropdownCmd = _v7.b;
					var newForm = A3(
						$author$project$Utils$Form$update,
						$author$project$Components$Invoice$CreateScheduledPaymentModal$formFieldsUpdate,
						A2($author$project$Components$Invoice$CreateScheduledPaymentModal$PaymentSourceDropdownFieldUpdated, index, newDropdown),
						model.SD);
					return {
						GZ: dropdownCmd,
						agZ: 1,
						aiO: _Utils_update(
							model,
							{SD: newForm}),
						aR: _List_Nil
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 1, aiO: model, aR: _List_Nil};
				}
			case 7:
				var index = msg.a;
				var query = msg.b;
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Invoice$CreateScheduledPaymentModal$formFieldsUpdate,
					A2($author$project$Components$Invoice$CreateScheduledPaymentModal$PaymentSourceSearchFieldUpdated, index, query),
					model.SD);
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 1,
					aiO: _Utils_update(
						model,
						{SD: newForm}),
					aR: _List_Nil
				};
			case 8:
				var index = msg.a;
				var maybeSource = msg.b;
				var _v8 = $author$project$Utils$Form$fields(model.SD);
				var scheduledPaymentsForm = _v8.i;
				var scheduledPaymentFormItem = A2($elm_community$list_extra$List$Extra$getAt, index, scheduledPaymentsForm);
				if (!scheduledPaymentFormItem.$) {
					var scheduledPaymentFormItem_ = scheduledPaymentFormItem.a;
					var newForm = A3(
						$author$project$Utils$Form$update,
						$author$project$Components$Invoice$CreateScheduledPaymentModal$formFieldsUpdate,
						A2($author$project$Components$Invoice$CreateScheduledPaymentModal$PaymentSourceSearchFieldUpdated, index, ''),
						A3(
							$author$project$Utils$Form$update,
							$author$project$Components$Invoice$CreateScheduledPaymentModal$formFieldsUpdate,
							A2($author$project$Components$Invoice$CreateScheduledPaymentModal$PaymentSourceFieldUpdated, index, maybeSource),
							model.SD));
					var amountInCents = A2(
						$elm$core$Maybe$withDefault,
						0,
						$author$project$Currency$toInt(
							A2($elm$core$Maybe$withDefault, $author$project$Currency$zero, scheduledPaymentFormItem_.LE)));
					return {
						GZ: A6($author$project$Components$Invoice$CreateScheduledPaymentModal$fetchPassthroughFeesCmd, model.abh, apiClient, amountInCents, maybeSource, model.YZ, index),
						agZ: 1,
						aiO: _Utils_update(
							model,
							{SD: newForm}),
						aR: _List_Nil
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 1, aiO: model, aR: _List_Nil};
				}
			case 12:
				var index = msg.a;
				var _v10 = $author$project$Utils$Form$fields(model.SD);
				var invoiceDueInCents = _v10.j$;
				var scheduledPaymentsForm = _v10.i;
				var scheduledPaymentForm = A2($elm_community$list_extra$List$Extra$getAt, index, scheduledPaymentsForm);
				if (!scheduledPaymentForm.$) {
					var scheduledPaymentFormItem_ = scheduledPaymentForm.a;
					var _v12 = A2(
						$author$project$Utils$Form$validate,
						A2($author$project$Components$Invoice$CreateScheduledPaymentModal$amountInCentsFormValidation, invoiceDueInCents, scheduledPaymentFormItem_),
						model.SD);
					if (!_v12.$) {
						var _v13 = _v12.a;
						var newForm = _v13.a;
						var passthroughFeesCmd = function () {
							var amountInCents = A2(
								$elm$core$Maybe$withDefault,
								0,
								$author$project$Currency$toInt(
									A2($elm$core$Maybe$withDefault, $author$project$Currency$zero, scheduledPaymentFormItem_.LE)));
							return A6($author$project$Components$Invoice$CreateScheduledPaymentModal$fetchPassthroughFeesCmd, model.abh, apiClient, amountInCents, scheduledPaymentFormItem_.Zg, model.YZ, index);
						}();
						return {
							GZ: passthroughFeesCmd,
							agZ: 1,
							aiO: _Utils_update(
								model,
								{SD: newForm}),
							aR: _List_Nil
						};
					} else {
						var newForm = _v12.a;
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 1,
							aiO: _Utils_update(
								model,
								{SD: newForm}),
							aR: _List_Nil
						};
					}
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 1, aiO: model, aR: _List_Nil};
				}
			case 13:
				var index = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var passthroughFees = response.a;
					var passthroughFeesInCents = $author$project$Api$Provider$PassthroughFee$One$passthroughFeeInCents(passthroughFees);
					var updatedScheduledPayment = A3(
						$elm_community$list_extra$List$Extra$updateAt,
						index,
						function (scheduledPaymentForm) {
							return _Utils_update(
								scheduledPaymentForm,
								{
									YW: $elm$core$Maybe$Just(passthroughFeesInCents)
								});
						},
						$author$project$Utils$Form$fields(model.SD).i);
					var newForm = A3(
						$author$project$Utils$Form$update,
						$author$project$Components$Invoice$CreateScheduledPaymentModal$formFieldsUpdate,
						$author$project$Components$Invoice$CreateScheduledPaymentModal$AddNewUpdated(updatedScheduledPayment),
						model.SD);
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 1,
						aiO: _Utils_update(
							model,
							{SD: newForm}),
						aR: _List_Nil
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 1, aiO: model, aR: _List_Nil};
				}
			case 9:
				var _v15 = $author$project$Utils$Form$fields(model.SD);
				var invoiceDueInCents = _v15.j$;
				var scheduledPaymentsForm = _v15.i;
				var _v16 = A2(
					$author$project$Utils$Form$validate,
					A2($author$project$Components$Invoice$CreateScheduledPaymentModal$formValidation, invoiceDueInCents, model.FR),
					model.SD);
				if (!_v16.$) {
					var _v17 = _v16.a;
					var newForm = _v17.a;
					var createScheduledPaymentCmd = A3($author$project$Components$Invoice$CreateScheduledPaymentModal$createScheduledPayment, apiClient, model.m6, scheduledPaymentsForm);
					return {
						GZ: createScheduledPaymentCmd,
						agZ: 1,
						aiO: _Utils_update(
							model,
							{SD: newForm, k9: $author$project$Api$Data$Loading}),
						aR: _List_Nil
					};
				} else {
					var newForm = _v16.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 1,
						aiO: _Utils_update(
							model,
							{SD: newForm}),
						aR: _List_Nil
					};
				}
			case 11:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 2,
						aiO: _Utils_update(
							model,
							{k9: response}),
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Successfully created scheduled payments')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 1,
						aiO: model,
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			default:
				var index = msg.a;
				var dateInput = msg.b;
				var subMsg = msg.c;
				return A5($author$project$Components$Invoice$CreateScheduledPaymentModal$updateScheduledOnFormField, model, index, dateInput, subMsg, $author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnSelected);
		}
	});
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$Date = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$GotPatient = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$Location = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$Payer = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$UpdateFailed = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$UpdateSucceeded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var maybePatient = field.a;
				return _Utils_update(
					fields,
					{I6: maybePatient});
			case 1:
				var maybeLocation = field.a;
				return _Utils_update(
					fields,
					{We: maybeLocation});
			default:
				var dateInput = field.a;
				var maybeDate = field.b;
				return _Utils_update(
					fields,
					{rZ: dateInput, Uq: maybeDate});
		}
	});
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_Nil);
var $author$project$Components$Membership$Form$Records$locationFromMin = function (location) {
	return {
		ahP: $author$project$Api$Provider$Location$Min$id(location),
		Bq: $author$project$Api$Provider$Location$Min$name(location)
	};
};
var $author$project$Components$Membership$Form$Records$practitionerFromMin = function (practitioner) {
	return {
		ahP: $author$project$Api$Provider$Practitioner$Min$id(practitioner),
		Bq: $author$project$Api$Provider$Practitioner$Min$name(practitioner)
	};
};
var $author$project$Components$Membership$Form$Records$patientFromAll = function (patient) {
	return {
		Lj: $author$project$Api$Provider$Patient$All$age(patient),
		ahP: $author$project$Api$Provider$Patient$All$id(patient),
		ais: A2(
			$elm$core$Maybe$map,
			$author$project$Components$Membership$Form$Records$locationFromMin,
			$author$project$Api$Provider$Patient$All$location(patient)),
		WX: $author$project$Api$Provider$Patient$All$membershipStatus(patient),
		Bq: $author$project$Api$Provider$Patient$All$name(patient),
		aka: A2(
			$elm$core$Maybe$map,
			$author$project$Components$Membership$Form$Records$practitionerFromMin,
			$author$project$Api$Provider$Patient$All$practitioner(patient)),
		ad9: $author$project$Api$Provider$Patient$All$usesTobacco(patient)
	};
};
var $author$project$Components$ResourceFilter$Location$preSelectedId = F2(
	function (id, model) {
		var _v0 = A2($author$project$Components$ResourceFilter$preSelectedId, id, model.b8);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{b8: resourceFilter}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$InvoiceUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$updateInvoice = F3(
	function (apiClient, invoiceId, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var apiFields = function () {
			var _v0 = _Utils_Tuple2(fields.I6, fields.We);
			if (!_v0.a.$) {
				var payer = _v0.a.a;
				var maybeLocationId = _v0.b;
				return {
					PB: fields.Uq,
					ais: maybeLocationId,
					YD: $elm$core$Maybe$Just(payer.ahP),
					acX: $elm$core$Maybe$Nothing
				};
			} else {
				return {PB: $elm$core$Maybe$Nothing, ais: $elm$core$Maybe$Nothing, YD: $elm$core$Maybe$Nothing, acX: $elm$core$Maybe$Nothing};
			}
		}();
		return A5(
			$author$project$Api$Provider$CustomerInvoice$update,
			apiClient,
			invoiceId,
			apiFields,
			_List_fromArray(
				[0]),
			$author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$InvoiceUpdated);
	});
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 6:
				var response = msg.a;
				if (response.$ === 3) {
					var patient = response.a;
					var _v2 = model.os;
					if (!_v2.$) {
						var locationResourceFilter_ = _v2.a;
						var _v3 = model.av;
						if (!_v3.$) {
							var _v4 = _v3.a;
							var invoice = _v4.c;
							var locationFieldEnabled = $author$project$Api$Provider$CustomerInvoice$One$humanStatus(invoice) === 'draft';
							var _v5 = function () {
								var _v6 = _Utils_Tuple3(
									$author$project$Api$Provider$Patient$One$location(patient),
									locationFieldEnabled,
									model.Aa);
								if (((!_v6.a.$) && _v6.b) && (!_v6.c)) {
									var location = _v6.a.a;
									return _Utils_Tuple2(
										$elm$core$Maybe$Just(
											function (value) {
												return A2($author$project$Components$ResourceFilter$Location$setValue, value, locationResourceFilter_);
											}(
												$author$project$Components$ResourceFilter$Location$resourceFromShared(
													$elm$core$Maybe$Just(
														$author$project$Api$Location$Shared$Provider(location))))),
										$elm$core$Maybe$Just(
											$author$project$Api$Provider$Location$Shared$id(location)));
								} else {
									return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
								}
							}();
							var maybeLocationResourceFilter = _v5.a;
							var preSelectedId = _v5.b;
							var _v7 = function () {
								if (!maybeLocationResourceFilter.$) {
									var locationResourceFilter = maybeLocationResourceFilter.a;
									return A2(
										$elm$core$Tuple$mapFirst,
										$elm$core$Maybe$Just,
										A2($author$project$Components$ResourceFilter$Location$preSelectedId, preSelectedId, locationResourceFilter));
								} else {
									return A2(
										$elm$core$Tuple$mapFirst,
										$elm$core$Maybe$Just,
										A2($author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$initLocationResourceFilter, apiClient, invoice));
								}
							}();
							var newLocationResourceFilter = _v7.a;
							var newLocationResourceFilterCmd = _v7.b;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{Aa: false, os: newLocationResourceFilter}),
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$LocationResourceFilterMsg, newLocationResourceFilterCmd),
								$elm$core$Maybe$Nothing);
						} else {
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
						}
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
				}
			case 4:
				var subMsg = msg.a;
				var _v9 = model.oY;
				if (!_v9.$) {
					var patientResourceFilter = _v9.a;
					var patientResourceResult = A3($author$project$Components$ResourceFilter$Patient$update, apiClient, subMsg, patientResourceFilter);
					var _v10 = function () {
						var _v11 = patientResourceResult.agZ;
						if ((!_v11.$) && (!_v11.a.$)) {
							var patient = _v11.a.a;
							var _v12 = model.av;
							if (!_v12.$) {
								var _v13 = _v12.a;
								var id = _v13.a;
								var form = _v13.b;
								var invoice = _v13.c;
								var patientRequestCmd = A3(
									$author$project$Api$Provider$Patient$retrieve,
									apiClient,
									$author$project$Api$Provider$Patient$All$id(patient),
									$author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$GotPatient);
								var patientRecord = $author$project$Components$Membership$Form$Records$patientFromAll(patient);
								var newForm = A3(
									$author$project$Utils$Form$update,
									$author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$formFieldsUpdate,
									$author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$Payer(
										$elm$core$Maybe$Just(patientRecord)),
									form);
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											av: $elm$core$Maybe$Just(
												_Utils_Tuple3(id, newForm, invoice)),
											oY: $elm$core$Maybe$Just(patientResourceResult.aiO)
										}),
									$elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[
												A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$PatientResourceFilterMsg, patientResourceResult.GZ),
												patientRequestCmd
											])));
							} else {
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										oY: $elm$core$Maybe$Just(patientResourceResult.aiO)
									}),
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$PatientResourceFilterMsg, patientResourceResult.GZ));
						}
					}();
					var newModel = _v10.a;
					var cmd = _v10.b;
					return _Utils_Tuple3(newModel, cmd, $elm$core$Maybe$Nothing);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
				}
			case 5:
				var subMsg = msg.a;
				var _v14 = model.os;
				if (!_v14.$) {
					var locationResourceFilter = _v14.a;
					var locationResourceResult = A3($author$project$Components$ResourceFilter$Location$update, apiClient, subMsg, locationResourceFilter);
					var _v15 = function () {
						var _v16 = model.av;
						if (!_v16.$) {
							var _v17 = _v16.a;
							var id = _v17.a;
							var form = _v17.b;
							var invoice = _v17.c;
							var newForm = A3(
								$author$project$Utils$Form$update,
								$author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$formFieldsUpdate,
								$author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$Location(
									$author$project$Components$ResourceFilter$Location$value(locationResourceResult.aiO)),
								form);
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										av: $elm$core$Maybe$Just(
											_Utils_Tuple3(id, newForm, invoice)),
										os: $elm$core$Maybe$Just(locationResourceResult.aiO)
									}),
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$LocationResourceFilterMsg, locationResourceResult.GZ));
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					}();
					var newModel = _v15.a;
					var formCmd = _v15.b;
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									formCmd,
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$LocationResourceFilterMsg, locationResourceResult.GZ)
								])),
						$elm$core$Maybe$Nothing);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
				}
			case 0:
				var form = msg.a;
				var maybeInvoiceId = msg.b;
				if (!maybeInvoiceId.$) {
					var invoiceId = maybeInvoiceId.a;
					var _v19 = model.av;
					if (!_v19.$) {
						var _v20 = _v19.a;
						var invoice = _v20.c;
						var _v21 = A2($author$project$Utils$Form$validate, $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$formFieldsValidator, form);
						if (!_v21.$) {
							var _v22 = _v21.a;
							var newForm = _v22.a;
							var validFormFields = _v22.b;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										av: $elm$core$Maybe$Just(
											_Utils_Tuple3(invoiceId, newForm, invoice)),
										V8: true
									}),
								A3($author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$updateInvoice, apiClient, invoiceId, validFormFields),
								$elm$core$Maybe$Nothing);
						} else {
							var newForm = _v21.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										av: $elm$core$Maybe$Just(
											_Utils_Tuple3(invoiceId, newForm, invoice))
									}),
								$elm$core$Platform$Cmd$none,
								$elm$core$Maybe$Nothing);
						}
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
				}
			case 1:
				var response = msg.a;
				var _v23 = model.av;
				if (!_v23.$) {
					switch (response.$) {
						case 3:
							var invoice = response.a;
							var ownerId = function () {
								var _v25 = $author$project$Api$Provider$CustomerInvoice$One$owner(invoice);
								if (!_v25.$) {
									var patient = _v25.a;
									return $author$project$Api$Provider$Patient$Shared$id(patient);
								} else {
									return '';
								}
							}();
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{V8: false}),
								$elm$core$Platform$Cmd$none,
								$elm$core$Maybe$Just(
									$author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$UpdateSucceeded(ownerId)));
						case 2:
							var error = response.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{V8: false}),
								$elm$core$Platform$Cmd$none,
								$elm$core$Maybe$Just(
									$author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$UpdateFailed(error)));
						default:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{V8: false}),
								$elm$core$Platform$Cmd$none,
								$elm$core$Maybe$Nothing);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
				}
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{av: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					$elm$core$Maybe$Nothing);
			default:
				var dateInput = msg.a;
				var subMsg = msg.b;
				var _v26 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
				var newDateInput = _v26.a;
				var subCmd = _v26.b;
				var event = _v26.c;
				var _v27 = model.av;
				if (!_v27.$) {
					var _v28 = _v27.a;
					var id = _v28.a;
					var form = _v28.b;
					var invoice = _v28.c;
					var newForm = function () {
						if (event.$ === 1) {
							var date = event.a;
							return A3(
								$author$project$Utils$Form$update,
								$author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$formFieldsUpdate,
								A2($author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$Date, newDateInput, date),
								form);
						} else {
							var _v30 = $author$project$Utils$Form$fields(form);
							var invoiceDate = _v30.Uq;
							return A3(
								$author$project$Utils$Form$update,
								$author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$formFieldsUpdate,
								A2($author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$Date, newDateInput, invoiceDate),
								form);
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								av: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, invoice))
							}),
						subCmd,
						$elm$core$Maybe$Nothing);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
				}
		}
	});
var $author$project$Components$Patient$Charges$ChargeModal$Category = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Patient$Charges$ChargeModal$ChargeCreated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Patient$Charges$ChargeModal$ChargeItem = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Patient$Charges$ChargeModal$ChargeUpdated = {$: 3};
var $author$project$Components$Patient$Charges$ChargeModal$Closed = {$: 1};
var $author$project$Components$Patient$Charges$ChargeModal$EndDate = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Components$Patient$Charges$ChargeModal$Location = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Patient$Charges$ChargeModal$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Patient$Charges$ChargeModal$None = {$: 0};
var $author$project$Components$Patient$Charges$ChargeModal$Patient = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Patient$Charges$ChargeModal$Practitioner = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Patient$Charges$ChargeModal$StartDate = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Components$Patient$Charges$ChargeModal$clearFormFields = F3(
	function (apiClient, showItemTypeInTitle, existingFormFields) {
		var newCategoryResourceFilter = A2($author$project$Components$ResourceFilter$Category$setValue, $elm$core$Maybe$Nothing, existingFormFields.c8);
		var _v0 = $author$project$Components$DateInput$init;
		var startDateInput = _v0.a;
		var startDateInputCmd = _v0.b;
		var _v1 = $author$project$Components$DateInput$init;
		var endDateInput = _v1.a;
		var endDateInputCmd = _v1.b;
		var _v2 = A4($author$project$Components$ResourceFilter$ChargeItem$initWithItemType, showItemTypeInTitle, apiClient, $elm$core$Basics$identity, $author$project$Components$Patient$Charges$ChargeModal$chargeItemResourceConfig);
		var chargeItemResourceFilter = _v2.a;
		var chargeItemResourceFilterCmd = _v2.b;
		return _Utils_Tuple2(
			_Utils_update(
				existingFormFields,
				{
					GW: $elm$core$Maybe$Nothing,
					c8: newCategoryResourceFilter,
					mL: $elm$core$Maybe$Nothing,
					cq: chargeItemResourceFilter,
					Qr: '',
					QD: 0,
					QE: false,
					sb: $elm$core$Maybe$Nothing,
					sd: endDateInput,
					ahP: $elm$core$Maybe$Nothing,
					Bq: $elm$core$Maybe$Nothing,
					Dw: $elm$core$Maybe$Nothing,
					_h: $elm$core$Maybe$Nothing,
					Dz: $elm$core$Maybe$Just(1),
					DA: $elm$core$Maybe$Nothing,
					lx: startDateInput,
					acZ: false
				}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Components$Patient$Charges$ChargeModal$StartDateInputMsg(startDateInput),
						startDateInputCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Components$Patient$Charges$ChargeModal$EndDateInputMsg(endDateInput),
						endDateInputCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$ChargeItemResourceFilterMsg, chargeItemResourceFilterCmd)
					])));
	});
var $author$project$Components$Patient$Charges$ChargeModal$PreviewDebounced = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Patient$Charges$ChargeModal$debouncePreview = function (cmd) {
	return A2(
		$elm$core$Task$perform,
		$author$project$Components$Patient$Charges$ChargeModal$PreviewDebounced,
		$elm$core$Task$succeed(cmd));
};
var $author$project$Components$Patient$Charges$ChargeModal$ChargeItemValidation = 1;
var $author$project$Components$Patient$Charges$ChargeModal$PatientValidation = 0;
var $author$project$Components$Patient$Charges$ChargeModal$PriceInCentsValidation = 3;
var $author$project$Components$Patient$Charges$ChargeModal$QuantityValidation = 2;
var $author$project$Components$Patient$Charges$ChargeModal$StartDateValidation = 4;
var $author$project$Components$Patient$Charges$ChargeModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.Bq;
			},
			_Utils_Tuple2(1, 'Please pick a charge.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.YY;
			},
			_Utils_Tuple2(0, 'Please pick a patient.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.Dz;
			},
			_Utils_Tuple2(2, 'Can\'t be blank.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.Dw;
			},
			_Utils_Tuple2(3, 'Please enter an amount.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.ab7;
			},
			_Utils_Tuple2(4, 'Please pick a date.'))
		]));
var $author$project$Components$Patient$Charges$ChargeModal$GotChargeOverridden = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Components$Patient$Charges$ChargeModal$overrideChargeDiscount = F5(
	function (model, apiClient, charge, form, shouldClose) {
		var fields = $author$project$Utils$Form$fields(form);
		if (fields.QE && (!$author$project$Api$Provider$Charge$One$discountOverridden(charge))) {
			return _Utils_Tuple3(
				A3(
					$author$project$Api$Provider$Charge$CoverageDiscount$override,
					apiClient,
					$author$project$Api$Provider$Charge$One$id(charge),
					$author$project$Components$Patient$Charges$ChargeModal$GotChargeOverridden(shouldClose)),
				$author$project$Components$Patient$Charges$ChargeModal$None,
				_List_Nil);
		} else {
			if ((!fields.QE) && $author$project$Api$Provider$Charge$One$discountOverridden(charge)) {
				return _Utils_Tuple3(
					A3(
						$author$project$Api$Provider$Charge$CoverageDiscount$reset,
						apiClient,
						$author$project$Api$Provider$Charge$One$id(charge),
						$author$project$Components$Patient$Charges$ChargeModal$GotChargeOverridden(shouldClose)),
					$author$project$Components$Patient$Charges$ChargeModal$None,
					_List_Nil);
			} else {
				var message = _Utils_eq(model.afx, $elm$core$Maybe$Nothing) ? 'Charge created.' : 'Charge updated.';
				return _Utils_Tuple3(
					$elm$core$Platform$Cmd$none,
					_Utils_eq(model.afx, $elm$core$Maybe$Nothing) ? $author$project$Components$Patient$Charges$ChargeModal$ChargeCreated(shouldClose) : $author$project$Components$Patient$Charges$ChargeModal$ChargeUpdated,
					_List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 3, message)
						]));
			}
		}
	});
var $author$project$Components$Patient$Charges$ChargeModal$PreviewDebouncedMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Patient$Charges$ChargeModal$previewDebounceConfig = {
	alK: $jinjor$elm_debounce$Debounce$later(1000),
	ame: $author$project$Components$Patient$Charges$ChargeModal$PreviewDebouncedMsg
};
var $author$project$Components$Patient$Charges$ChargeModal$GotChargeCreated = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Components$Patient$Charges$ChargeModal$paramsWithPrice = F2(
	function (model, fields) {
		var priceInCents = function () {
			if (!(!fields.QD)) {
				var _v0 = _Utils_Tuple2(fields.mL, model.akd);
				if (!_v0.a.$) {
					var chargeItem = _v0.a.a;
					return $elm$core$Maybe$Just(chargeItem.Dw | 0);
				} else {
					if (_v0.b.$ === 3) {
						var _v1 = _v0.a;
						var _v2 = _v0.b;
						var preview = _v2.a;
						return $elm$core$Maybe$Just(
							$author$project$Api$Provider$Charge$Calculate$issuedSubtotalInCents(preview) + $author$project$Api$Provider$Charge$Calculate$discountInCents(preview));
					} else {
						var _v3 = _v0.a;
						return $elm$core$Maybe$Just(
							fields.QD + A2(
								$elm$core$Maybe$withDefault,
								0,
								A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.Dw)));
					}
				}
			} else {
				return A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.Dw);
			}
		}();
		return {
			GW: fields.GW,
			mL: A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.ahP;
				},
				fields.mL),
			PB: fields.ab7,
			Qr: fields.Qr,
			QE: fields.QE,
			sb: fields.sb,
			Uk: $author$project$Api$Provider$Charge$Invoice(
				$elm$core$Maybe$Just(
					{
						ahP: $elm$core$Maybe$Just(
							$author$project$Api$Provider$CustomerInvoice$One$id(model.Uk)),
						amg: $elm$core$Maybe$Just('customer_invoice')
					})),
			ais: fields.ais,
			Bq: fields.Bq,
			YY: A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.ahP;
				},
				fields.YY),
			I6: $elm$core$Maybe$Nothing,
			aka: fields.aka,
			Dw: priceInCents,
			Dz: A2($elm$core$Maybe$withDefault, 1, fields.Dz),
			DA: A2($elm$core$Maybe$map, $author$project$Api$Provider$Uom$Shared$code, fields.DA)
		};
	});
var $author$project$Components$Patient$Charges$ChargeModal$createCharge = F4(
	function (model, apiClient, formFields, shouldClose) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4(
			$author$project$Api$Provider$Charge$create,
			$author$project$Api$Data$providerPath,
			apiClient,
			A2($author$project$Components$Patient$Charges$ChargeModal$paramsWithPrice, model, fields),
			$author$project$Components$Patient$Charges$ChargeModal$GotChargeCreated(shouldClose));
	});
var $author$project$Components$Patient$Charges$ChargeModal$GotChargeUpdated = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Patient$Charges$ChargeModal$updateCharge = F4(
	function (model, apiClient, id, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var apiFields = A2($author$project$Components$Patient$Charges$ChargeModal$paramsWithPrice, model, fields);
		return A5(
			$author$project$Api$Provider$Charge$update,
			$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(
				$author$project$Api$Provider$CustomerInvoice$One$id(model.Uk)),
			apiClient,
			id,
			apiFields,
			$author$project$Components$Patient$Charges$ChargeModal$GotChargeUpdated);
	});
var $author$project$Components$Patient$Charges$ChargeModal$save = F4(
	function (model, apiClient, formFields, shouldClose) {
		var _v0 = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var id = _v0.ahP;
		if (!id.$) {
			var id_ = id.a;
			return A4($author$project$Components$Patient$Charges$ChargeModal$updateCharge, model, apiClient, id_, formFields);
		} else {
			return A4($author$project$Components$Patient$Charges$ChargeModal$createCharge, model, apiClient, formFields, shouldClose);
		}
	});
var $author$project$Components$Patient$Charges$ChargeModal$GotPreview = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Patient$Charges$ChargeModal$shouldCalculatePreview = function (field) {
	switch (field.$) {
		case 1:
			return true;
		case 0:
			return true;
		case 2:
			return true;
		case 3:
			return true;
		case 4:
			return false;
		case 5:
			return false;
		case 6:
			return false;
		case 7:
			return true;
		case 8:
			return true;
		case 9:
			return true;
		case 10:
			return true;
		case 11:
			return true;
		case 12:
			return true;
		default:
			return true;
	}
};
var $author$project$Components$Patient$Charges$ChargeModal$validPreviewFields = function (fields) {
	return $author$project$Utils$Maybe$toBool(fields.Bq) && (A2($elm$core$Maybe$withDefault, 0, fields.Dz) > 0);
};
var $author$project$Components$Patient$Charges$ChargeModal$calculatePreview = F4(
	function (field, form, apiClient, model) {
		var fields = $author$project$Utils$Form$fields(form);
		var _v0 = (model.xM && ($author$project$Components$Patient$Charges$ChargeModal$shouldCalculatePreview(field) && $author$project$Components$Patient$Charges$ChargeModal$validPreviewFields(fields))) ? _Utils_Tuple2(
			A3(
				$jinjor$elm_debounce$Debounce$push,
				$author$project$Components$Patient$Charges$ChargeModal$previewDebounceConfig,
				A4(
					$author$project$Api$Provider$Charge$calculate,
					$author$project$Api$Provider$Charge$chargesPath($author$project$Api$Data$providerPath),
					apiClient,
					A2($author$project$Components$Patient$Charges$ChargeModal$paramsWithPrice, model, fields),
					$author$project$Components$Patient$Charges$ChargeModal$GotPreview),
				model.eW),
			$author$project$Api$Data$Loading) : _Utils_Tuple2(
			_Utils_Tuple2(model.eW, $elm$core$Platform$Cmd$none),
			$author$project$Api$Data$NotAsked);
		var _v1 = _v0.a;
		var newDebouncer = _v1.a;
		var cmd = _v1.b;
		var preview = _v0.b;
		return _Utils_Tuple2(
			($author$project$Components$Patient$Charges$ChargeModal$shouldCalculatePreview(field) && $author$project$Components$Patient$Charges$ChargeModal$validPreviewFields(fields)) ? _Utils_update(
				model,
				{akd: preview, eW: newDebouncer}) : ((!$author$project$Components$Patient$Charges$ChargeModal$validPreviewFields(fields)) ? _Utils_update(
				model,
				{akd: $author$project$Api$Data$NotAsked, eW: newDebouncer}) : _Utils_update(
				model,
				{eW: newDebouncer})),
			cmd);
	});
var $author$project$Components$Patient$Charges$ChargeModal$resetEndDate = function (fields) {
	var _v0 = _Utils_Tuple2(fields.Dz, fields.DA);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var quantity = _v0.a.a;
		var quantityUom = _v0.b.a;
		return _Utils_update(
			fields,
			{
				sb: A3($author$project$Utils$Uom$addTo, fields.ab7, quantityUom, quantity)
			});
	} else {
		return fields;
	}
};
var $author$project$Components$Patient$Charges$ChargeModal$translateLocation = function (location) {
	return {Li: $elm$core$Maybe$Nothing, ahP: location.ahP, UV: false, Vf: false, Wf: '', Bq: location.Bq, ZY: ''};
};
var $author$project$Components$Patient$Charges$ChargeModal$translatePractitioner = function (practitioner) {
	return {Li: $elm$core$Maybe$Nothing, ahP: practitioner.ahP, UV: false, Vf: false, Bq: practitioner.Bq, Yp: $elm$core$Maybe$Nothing, ZY: '', Z3: ''};
};
var $author$project$Components$Patient$Charges$ChargeModal$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 1:
				var patient = field.a;
				var _v1 = function () {
					if (!patient.$) {
						var pat = patient.a;
						return _Utils_Tuple3(
							$elm$core$Maybe$Just(
								{ahP: pat.ahP, Bq: pat.Bq}),
							A2($elm$core$Maybe$map, $author$project$Components$Patient$Charges$ChargeModal$translateLocation, pat.ais),
							A2($elm$core$Maybe$map, $author$project$Components$Patient$Charges$ChargeModal$translatePractitioner, pat.aka));
					} else {
						return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
					}
				}();
				var formPatient = _v1.a;
				var locationResource = _v1.b;
				var practitionerResource = _v1.c;
				return _Utils_update(
					fields,
					{
						ais: A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.ahP;
							},
							locationResource),
						os: A2($author$project$Components$ResourceFilter$Location$setValue, locationResource, fields.os),
						YY: formPatient,
						aka: A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.ahP;
							},
							practitionerResource),
						hk: A2($author$project$Components$ResourceFilter$Practitioner$setValue, practitionerResource, fields.hk)
					});
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						mL: $elm$core$Maybe$Nothing,
						Bq: $author$project$Utils$String$toMaybe(string),
						_h: $elm$core$Maybe$Nothing,
						DA: $elm$core$Maybe$Nothing
					});
			case 2:
				var chargeItem = field.a;
				var category = A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.GW;
					},
					chargeItem);
				return $author$project$Components$Patient$Charges$ChargeModal$resetEndDate(
					_Utils_update(
						fields,
						{
							GW: A2($elm$core$Maybe$map, $author$project$Api$Provider$Category$Shared$id, category),
							c8: A2(
								$author$project$Components$ResourceFilter$Category$setValue,
								A2(
									$elm$core$Maybe$map,
									function (category_) {
										return {
											ahP: $author$project$Api$Provider$Category$Shared$id(category_),
											Bq: $author$project$Api$Provider$Category$Shared$name(category_)
										};
									},
									category),
								fields.c8),
							mL: chargeItem,
							Qr: A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$andThen,
									function ($) {
										return $.Qr;
									},
									chargeItem)),
							Bq: A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.Bq;
								},
								chargeItem),
							Dw: A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.Dw;
									},
									$author$project$Currency$fromFloat),
								chargeItem),
							_h: A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.adP;
								},
								chargeItem),
							Dz: $elm$core$Maybe$Just(1),
							DA: A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.adP;
								},
								chargeItem)
						}));
			case 3:
				var maybeString = field.a;
				return _Utils_update(
					fields,
					{GW: maybeString});
			case 4:
				var practitioner = field.a;
				return _Utils_update(
					fields,
					{
						aka: A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.ahP;
							},
							practitioner),
						hk: A2($author$project$Components$ResourceFilter$Practitioner$setValue, practitioner, fields.hk)
					});
			case 5:
				var location = field.a;
				return _Utils_update(
					fields,
					{
						ais: A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.ahP;
							},
							location),
						os: A2($author$project$Components$ResourceFilter$Location$setValue, location, fields.os)
					});
			case 6:
				var string = field.a;
				return _Utils_update(
					fields,
					{Qr: string});
			case 7:
				var string = field.a;
				return $author$project$Components$Patient$Charges$ChargeModal$resetEndDate(
					_Utils_update(
						fields,
						{
							Dz: $elm$core$String$toInt(string)
						}));
			case 8:
				var string = field.a;
				var _v3 = $author$project$Utils$Uom$fromCode(string);
				if (!_v3.$) {
					var quantityUom = _v3.a;
					var quantity = function () {
						var _v4 = _Utils_Tuple2(fields.ab7, fields.sb);
						if ((!_v4.a.$) && (!_v4.b.$)) {
							var startDate = _v4.a.a;
							var endDate = _v4.b.a;
							return $elm$core$Maybe$Just(
								A3(
									$author$project$Utils$Uom$quantityBetween,
									quantityUom,
									startDate,
									$elm$core$Maybe$Just(endDate)));
						} else {
							return fields.Dz;
						}
					}();
					return $author$project$Components$Patient$Charges$ChargeModal$resetEndDate(
						_Utils_update(
							fields,
							{
								Dz: quantity,
								DA: $elm$core$Maybe$Just(quantityUom)
							}));
				} else {
					return _Utils_update(
						fields,
						{DA: $elm$core$Maybe$Nothing});
				}
			case 9:
				var dateInput = field.a;
				var date = field.b;
				return $author$project$Components$Patient$Charges$ChargeModal$resetEndDate(
					_Utils_update(
						fields,
						{ab7: date, lx: dateInput}));
			case 10:
				var dateInput = field.a;
				var date = field.b;
				var _v5 = function () {
					var _v6 = _Utils_Tuple2(fields.ab7, date);
					if ((!_v6.a.$) && (!_v6.b.$)) {
						var startDate_ = _v6.a.a;
						var endDate = _v6.b.a;
						var startDate__ = (A2($justinmimbs$date$Date$compare, startDate_, endDate) === 2) ? endDate : startDate_;
						var quantityUom_ = A2($author$project$Utils$Uom$matchRange, startDate__, endDate);
						return _Utils_Tuple3(
							$elm$core$Maybe$Just(startDate__),
							$elm$core$Maybe$Just(quantityUom_),
							$elm$core$Maybe$Just(
								A3(
									$author$project$Utils$Uom$quantityBetween,
									quantityUom_,
									startDate__,
									$elm$core$Maybe$Just(endDate))));
					} else {
						return _Utils_Tuple3(fields.ab7, fields.DA, fields.Dz);
					}
				}();
				var startDate = _v5.a;
				var quantityUom = _v5.b;
				var quantity = _v5.c;
				return _Utils_update(
					fields,
					{sb: date, sd: dateInput, Dz: quantity, DA: quantityUom, ab7: startDate});
			case 11:
				var _int = field.a;
				return _Utils_update(
					fields,
					{Dw: _int});
			case 12:
				var bool = field.a;
				var priceInCents = bool ? fields.Dw : A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.Dw;
						},
						$author$project$Currency$fromFloat),
					fields.mL);
				return _Utils_update(
					fields,
					{QE: bool, Dw: priceInCents});
			default:
				var _int = field.a;
				return _Utils_update(
					fields,
					{QD: _int});
		}
	});
var $author$project$Components$Patient$Charges$ChargeModal$updateForm = F4(
	function (model, apiClient, field, form) {
		var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Patient$Charges$ChargeModal$formFieldsUpdate, field, form);
		return A4(
			$author$project$Components$Patient$Charges$ChargeModal$calculatePreview,
			field,
			newForm,
			apiClient,
			_Utils_update(
				model,
				{SD: newForm}));
	});
var $author$project$Components$Patient$Charges$ChargeModal$updateDateInputFormField = F7(
	function (model, apiClient, dateInput, subMsg, toMsg, field, fieldGetter) {
		var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
		var newDateInput = _v0.a;
		var subCmd = _v0.b;
		var event = _v0.c;
		var dateField = function () {
			if (event.$ === 1) {
				var date = event.a;
				return A2(field, newDateInput, date);
			} else {
				return A2(
					field,
					newDateInput,
					fieldGetter(
						$author$project$Utils$Form$fields(model.SD)));
			}
		}();
		var _v1 = A4($author$project$Components$Patient$Charges$ChargeModal$updateForm, model, apiClient, dateField, model.SD);
		var newModel = _v1.a;
		var formCmd = _v1.b;
		return {
			GZ: $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						formCmd,
						A2(
						$elm$core$Platform$Cmd$map,
						toMsg(newDateInput),
						subCmd)
					])),
			agZ: $author$project$Components$Patient$Charges$ChargeModal$None,
			aiO: newModel,
			aR: _List_Nil
		};
	});
var $author$project$Components$Patient$Charges$ChargeModal$DiscountInCents = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Patient$Charges$ChargeModal$PriceInCents = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Patient$Charges$ChargeModal$updateFormFromPreview = F2(
	function (preview, form) {
		return A3(
			$author$project$Utils$Form$update,
			$author$project$Components$Patient$Charges$ChargeModal$formFieldsUpdate,
			$author$project$Components$Patient$Charges$ChargeModal$DiscountInCents(
				$author$project$Api$Provider$Charge$Calculate$discountInCents(preview)),
			A3(
				$author$project$Utils$Form$update,
				$author$project$Components$Patient$Charges$ChargeModal$formFieldsUpdate,
				$author$project$Components$Patient$Charges$ChargeModal$PriceInCents(
					$elm$core$Maybe$Just(
						$author$project$Currency$fromInt(
							$author$project$Api$Provider$Charge$Calculate$priceInCents(preview)))),
				form));
	});
var $author$project$Components$Patient$Charges$ChargeModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$Patient$Charges$ChargeModal$Closed, aiO: model, aR: _List_Nil};
			case 1:
				var _v1 = A2($author$project$Utils$Form$validate, $author$project$Components$Patient$Charges$ChargeModal$formFieldsValidator, model.SD);
				if (!_v1.$) {
					var _v2 = _v1.a;
					var newForm = _v2.a;
					var validFormFields = _v2.b;
					return {
						GZ: A4($author$project$Components$Patient$Charges$ChargeModal$save, model, apiClient, validFormFields, true),
						agZ: $author$project$Components$Patient$Charges$ChargeModal$None,
						aiO: _Utils_update(
							model,
							{SD: newForm, pR: true}),
						aR: _List_Nil
					};
				} else {
					var newForm = _v1.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Patient$Charges$ChargeModal$None,
						aiO: _Utils_update(
							model,
							{SD: newForm}),
						aR: _List_Nil
					};
				}
			case 2:
				var _v3 = A2($author$project$Utils$Form$validate, $author$project$Components$Patient$Charges$ChargeModal$formFieldsValidator, model.SD);
				if (!_v3.$) {
					var _v4 = _v3.a;
					var newForm = _v4.a;
					var validFormFields = _v4.b;
					return {
						GZ: A4($author$project$Components$Patient$Charges$ChargeModal$save, model, apiClient, validFormFields, false),
						agZ: $author$project$Components$Patient$Charges$ChargeModal$None,
						aiO: _Utils_update(
							model,
							{SD: newForm, pR: true}),
						aR: _List_Nil
					};
				} else {
					var newForm = _v3.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Patient$Charges$ChargeModal$None,
						aiO: _Utils_update(
							model,
							{SD: newForm}),
						aR: _List_Nil
					};
				}
			case 3:
				var dateInput = msg.a;
				var subMsg = msg.b;
				return A7(
					$author$project$Components$Patient$Charges$ChargeModal$updateDateInputFormField,
					model,
					apiClient,
					dateInput,
					subMsg,
					$author$project$Components$Patient$Charges$ChargeModal$StartDateInputMsg,
					$author$project$Components$Patient$Charges$ChargeModal$StartDate,
					function ($) {
						return $.ab7;
					});
			case 4:
				var dateInput = msg.a;
				var subMsg = msg.b;
				return A7(
					$author$project$Components$Patient$Charges$ChargeModal$updateDateInputFormField,
					model,
					apiClient,
					dateInput,
					subMsg,
					$author$project$Components$Patient$Charges$ChargeModal$EndDateInputMsg,
					$author$project$Components$Patient$Charges$ChargeModal$EndDate,
					function ($) {
						return $.sb;
					});
			case 5:
				var subMsg = msg.a;
				var fields = $author$project$Utils$Form$fields(model.SD);
				var limitedPatientSelectorResult = A3($author$project$Components$LimitedPatientSelector$update, apiClient, subMsg, fields.oj);
				var newForm = A2(
					$author$project$Utils$Form$set,
					_Utils_update(
						fields,
						{oj: limitedPatientSelectorResult.aiO}),
					model.SD);
				var _v5 = function () {
					var _v6 = limitedPatientSelectorResult.agZ;
					_v6$2:
					while (true) {
						if (_v6.$ === 1) {
							switch (_v6.a.$) {
								case 0:
									var patient = _v6.a.a;
									return A4(
										$author$project$Components$Patient$Charges$ChargeModal$updateForm,
										model,
										apiClient,
										$author$project$Components$Patient$Charges$ChargeModal$Patient(
											$elm$core$Maybe$Just(patient)),
										newForm);
								case 3:
									var _v7 = _v6.a;
									return A4(
										$author$project$Components$Patient$Charges$ChargeModal$updateForm,
										model,
										apiClient,
										$author$project$Components$Patient$Charges$ChargeModal$Patient($elm$core$Maybe$Nothing),
										newForm);
								default:
									break _v6$2;
							}
						} else {
							break _v6$2;
						}
					}
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{SD: newForm}),
						$elm$core$Platform$Cmd$none);
				}();
				var newModel = _v5.a;
				var formCmd = _v5.b;
				return {
					GZ: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$LimitedPatientSelectorMsg, limitedPatientSelectorResult.GZ),
								formCmd
							])),
					agZ: $author$project$Components$Patient$Charges$ChargeModal$None,
					aiO: newModel,
					aR: limitedPatientSelectorResult.aR
				};
			case 6:
				var subMsg = msg.a;
				var fields = $author$project$Utils$Form$fields(model.SD);
				var chargeItemResourceResult = A3($author$project$Components$ResourceFilter$ChargeItem$update, apiClient, subMsg, fields.cq);
				var newForm = A2(
					$author$project$Utils$Form$set,
					_Utils_update(
						fields,
						{cq: chargeItemResourceResult.aiO}),
					model.SD);
				var _v8 = function () {
					var _v9 = chargeItemResourceResult.agZ;
					_v9$2:
					while (true) {
						if (!_v9.$) {
							switch (_v9.a.$) {
								case 0:
									var item = _v9.a.a;
									return A4(
										$author$project$Components$Patient$Charges$ChargeModal$updateForm,
										model,
										apiClient,
										$author$project$Components$Patient$Charges$ChargeModal$ChargeItem(
											$elm$core$Maybe$Just(item)),
										newForm);
								case 5:
									var string = _v9.a.a;
									return A4(
										$author$project$Components$Patient$Charges$ChargeModal$updateForm,
										model,
										apiClient,
										$author$project$Components$Patient$Charges$ChargeModal$Name(string),
										newForm);
								default:
									break _v9$2;
							}
						} else {
							break _v9$2;
						}
					}
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{SD: newForm}),
						$elm$core$Platform$Cmd$none);
				}();
				var newModel = _v8.a;
				var formCmd = _v8.b;
				return {
					GZ: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$ChargeItemResourceFilterMsg, chargeItemResourceResult.GZ),
								formCmd
							])),
					agZ: $author$project$Components$Patient$Charges$ChargeModal$None,
					aiO: newModel,
					aR: _List_Nil
				};
			case 7:
				var subMsg = msg.a;
				var fields = $author$project$Utils$Form$fields(model.SD);
				var categoryResourceResult = A3($author$project$Components$ResourceFilter$Category$update, apiClient, subMsg, fields.c8);
				var newForm = A2(
					$author$project$Utils$Form$set,
					_Utils_update(
						fields,
						{c8: categoryResourceResult.aiO}),
					model.SD);
				var _v10 = function () {
					var _v11 = categoryResourceResult.agZ;
					if (!_v11.$) {
						return A4(
							$author$project$Components$Patient$Charges$ChargeModal$updateForm,
							model,
							apiClient,
							$author$project$Components$Patient$Charges$ChargeModal$Category(
								$author$project$Components$ResourceFilter$Category$value(categoryResourceResult.aiO)),
							newForm);
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{SD: newForm}),
							$elm$core$Platform$Cmd$none);
					}
				}();
				var newModel = _v10.a;
				var formCmd = _v10.b;
				return {
					GZ: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$CategoryResourceFilterMsg, categoryResourceResult.GZ),
								formCmd
							])),
					agZ: $author$project$Components$Patient$Charges$ChargeModal$None,
					aiO: newModel,
					aR: categoryResourceResult.aR
				};
			case 8:
				var subMsg = msg.a;
				var fields = $author$project$Utils$Form$fields(model.SD);
				var practitionerResourceResult = A3($author$project$Components$ResourceFilter$Practitioner$update, apiClient, subMsg, fields.hk);
				var newForm = A2(
					$author$project$Utils$Form$set,
					_Utils_update(
						fields,
						{hk: practitionerResourceResult.aiO}),
					model.SD);
				var _v12 = function () {
					var _v13 = practitionerResourceResult.agZ;
					_v13$2:
					while (true) {
						if (!_v13.$) {
							switch (_v13.a.$) {
								case 0:
									var practitioner = _v13.a.a;
									return A4(
										$author$project$Components$Patient$Charges$ChargeModal$updateForm,
										model,
										apiClient,
										$author$project$Components$Patient$Charges$ChargeModal$Practitioner(
											$elm$core$Maybe$Just(practitioner)),
										newForm);
								case 2:
									var _v14 = _v13.a;
									return A4(
										$author$project$Components$Patient$Charges$ChargeModal$updateForm,
										model,
										apiClient,
										$author$project$Components$Patient$Charges$ChargeModal$Practitioner($elm$core$Maybe$Nothing),
										newForm);
								default:
									break _v13$2;
							}
						} else {
							break _v13$2;
						}
					}
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{SD: newForm}),
						$elm$core$Platform$Cmd$none);
				}();
				var newModel = _v12.a;
				var formCmd = _v12.b;
				return {
					GZ: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$PractitionerResourceFilterMsg, practitionerResourceResult.GZ),
								formCmd
							])),
					agZ: $author$project$Components$Patient$Charges$ChargeModal$None,
					aiO: newModel,
					aR: practitionerResourceResult.aR
				};
			case 9:
				var subMsg = msg.a;
				var fields = $author$project$Utils$Form$fields(model.SD);
				var locationResourceResult = A3($author$project$Components$ResourceFilter$Location$update, apiClient, subMsg, fields.os);
				var newForm = A2(
					$author$project$Utils$Form$set,
					_Utils_update(
						fields,
						{os: locationResourceResult.aiO}),
					model.SD);
				var _v15 = function () {
					var _v16 = locationResourceResult.agZ;
					_v16$2:
					while (true) {
						if (!_v16.$) {
							switch (_v16.a.$) {
								case 0:
									var location = _v16.a.a;
									return A4(
										$author$project$Components$Patient$Charges$ChargeModal$updateForm,
										model,
										apiClient,
										$author$project$Components$Patient$Charges$ChargeModal$Location(
											$elm$core$Maybe$Just(location)),
										newForm);
								case 2:
									var _v17 = _v16.a;
									return A4(
										$author$project$Components$Patient$Charges$ChargeModal$updateForm,
										model,
										apiClient,
										$author$project$Components$Patient$Charges$ChargeModal$Location($elm$core$Maybe$Nothing),
										newForm);
								default:
									break _v16$2;
							}
						} else {
							break _v16$2;
						}
					}
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{SD: newForm}),
						$elm$core$Platform$Cmd$none);
				}();
				var newModel = _v15.a;
				var formCmd = _v15.b;
				return {
					GZ: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$LocationResourceFilterMsg, locationResourceResult.GZ),
								formCmd
							])),
					agZ: $author$project$Components$Patient$Charges$ChargeModal$None,
					aiO: newModel,
					aR: locationResourceResult.aR
				};
			case 10:
				var field = msg.a;
				var _v18 = A4($author$project$Components$Patient$Charges$ChargeModal$updateForm, model, apiClient, field, model.SD);
				var newModel = _v18.a;
				var formCmd = _v18.b;
				return {GZ: formCmd, agZ: $author$project$Components$Patient$Charges$ChargeModal$None, aiO: newModel, aR: _List_Nil};
			case 11:
				var shouldClose = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var charge = response.a;
					var _v20 = A2(
						$elm$core$Tuple$mapFirst,
						function (clearedFormFields) {
							return A2($author$project$Utils$Form$set, clearedFormFields, model.SD);
						},
						A3(
							$author$project$Components$Patient$Charges$ChargeModal$clearFormFields,
							apiClient,
							A2(
								$author$project$Utils$FeatureGate$gateAvailable,
								14,
								$author$project$Api$Practice$Provider(model.ZV)),
							$author$project$Utils$Form$fields(model.SD)));
					var resetForm = _v20.a;
					var resetCmds = _v20.b;
					var newModel = _Utils_update(
						model,
						{SD: resetForm, pR: false});
					var _v21 = A5($author$project$Components$Patient$Charges$ChargeModal$overrideChargeDiscount, model, apiClient, charge, model.SD, shouldClose);
					var cmd = _v21.a;
					var event = _v21.b;
					var outMsg = _v21.c;
					return {
						GZ: $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[resetCmds, cmd])),
						agZ: event,
						aiO: newModel,
						aR: outMsg
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Patient$Charges$ChargeModal$None,
						aiO: _Utils_update(
							model,
							{pR: false}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 12:
				var response = msg.a;
				var newModel = _Utils_update(
					model,
					{pR: false});
				if (response.$ === 3) {
					var charge = response.a;
					var _v23 = A5($author$project$Components$Patient$Charges$ChargeModal$overrideChargeDiscount, model, apiClient, charge, model.SD, true);
					var cmd = _v23.a;
					var event = _v23.b;
					var outMsg = _v23.c;
					return {GZ: cmd, agZ: event, aiO: newModel, aR: outMsg};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Patient$Charges$ChargeModal$None,
						aiO: newModel,
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 13:
				var shouldClose = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var message = _Utils_eq(model.afx, $elm$core$Maybe$Nothing) ? 'Charge created.' : 'Charge updated.';
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: _Utils_eq(model.afx, $elm$core$Maybe$Nothing) ? $author$project$Components$Patient$Charges$ChargeModal$ChargeCreated(shouldClose) : $author$project$Components$Patient$Charges$ChargeModal$ChargeUpdated,
						aiO: model,
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, message)
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Patient$Charges$ChargeModal$None,
						aiO: model,
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 14:
				var debounceMsg = msg.a;
				var _v25 = A4(
					$jinjor$elm_debounce$Debounce$update,
					$author$project$Components$Patient$Charges$ChargeModal$previewDebounceConfig,
					$jinjor$elm_debounce$Debounce$takeLast($author$project$Components$Patient$Charges$ChargeModal$debouncePreview),
					debounceMsg,
					model.eW);
				var newDebouncer = _v25.a;
				var cmd = _v25.b;
				return {
					GZ: cmd,
					agZ: $author$project$Components$Patient$Charges$ChargeModal$None,
					aiO: _Utils_update(
						model,
						{eW: newDebouncer}),
					aR: _List_Nil
				};
			case 15:
				var cmd = msg.a;
				return {GZ: cmd, agZ: $author$project$Components$Patient$Charges$ChargeModal$None, aiO: model, aR: _List_Nil};
			case 16:
				var response = msg.a;
				if (response.$ === 3) {
					var preview = response.a;
					var newForm = A2($author$project$Components$Patient$Charges$ChargeModal$updateFormFromPreview, preview, model.SD);
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Patient$Charges$ChargeModal$None,
						aiO: _Utils_update(
							model,
							{SD: newForm, akd: response}),
						aR: _List_Nil
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Patient$Charges$ChargeModal$None,
						aiO: _Utils_update(
							model,
							{akd: response}),
						aR: _List_Nil
					};
				}
			default:
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: $author$project$Components$Patient$Charges$ChargeModal$None,
					aiO: _Utils_update(
						model,
						{hD: !model.hD}),
					aR: _List_Nil
				};
		}
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$updateChargeDropdown = F3(
	function (msg, charge, dropdowns) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v2, _v3) {
					var id = _v2.a;
					var dropdown = _v2.b;
					var cmd = _v2.c;
					var dropdownsAcc = _v3.a;
					var cmdAcc = _v3.b;
					return _Utils_Tuple2(
						_Utils_ap(
							dropdownsAcc,
							_List_fromArray(
								[
									_Utils_Tuple2(id, dropdown)
								])),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[cmd, cmdAcc])));
				}),
			_Utils_Tuple2(_List_Nil, $elm$core$Platform$Cmd$none),
			A2(
				$elm$core$List$map,
				function (_v0) {
					var chargeId = _v0.a;
					var dropdown = _v0.b;
					if (_Utils_eq(
						chargeId,
						$author$project$Api$Provider$Charge$One$id(charge))) {
						var _v1 = A2($author$project$Ui$Dropdown$update, msg, dropdown);
						var newDropdown = _v1.a;
						var dropdownCmd = _v1.b;
						return _Utils_Tuple3(chargeId, newDropdown, dropdownCmd);
					} else {
						return _Utils_Tuple3(chargeId, dropdown, $elm$core$Platform$Cmd$none);
					}
				},
				dropdowns));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var invoice = response.a;
					var cmd = function () {
						var _v2 = $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$patientPath(invoice);
						if (!_v2.$) {
							var patientPath_ = _v2.a;
							return A2(
								$author$project$Utils$FeatureGate$gateAvailable,
								12,
								$author$project$Api$Practice$Provider(model.ZV)) ? $elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A3(
										$author$project$Api$Provider$ScheduledPayment$list,
										model.Gv,
										$author$project$Api$Provider$CustomerInvoice$One$id(invoice),
										$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotScheduledPayments),
										A4($author$project$Api$Card$list, patientPath_, model.Gv, model.aa4, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotCards),
										A4($author$project$Api$BankAccount$list, patientPath_, model.Gv, model.aa4, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotBankAccounts)
									])) : ($author$project$Api$Provider$Patient$One$shouldChargeCreditCardFees(model.YY) ? A4($author$project$Api$Card$list, patientPath_, model.Gv, model.aa4, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotCards) : $elm$core$Platform$Cmd$none);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}();
					var auditTrailLog = A7(
						$author$project$Components$AuditTrailLog$init,
						model.aa4,
						model.lk.adY,
						model.lk.J7,
						$elm$core$Maybe$Just('customer_invoice'),
						$elm$core$Maybe$Just(model.Us),
						$elm$core$Maybe$Just(
							$author$project$Api$Provider$CustomerInvoice$One$createdAt(invoice)),
						$elm$core$Maybe$Nothing);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								iw: $elm$core$Maybe$Just(auditTrailLog),
								iI: $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$initChargeDropdowns(invoice),
								Uk: response
							}),
						cmd,
						_List_fromArray(
							[
								$author$project$OutMsg$RetrievePatient(
								$author$project$Api$Provider$Patient$One$id(model.YY))
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{hU: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 2:
				var subMsg = msg.a;
				var _v3 = A2($author$project$Ui$Dropdown$update, subMsg, model.oO);
				var dropdown = _v3.a;
				var dropdownCmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oO: dropdown}),
					dropdownCmd,
					_List_Nil);
			case 23:
				var invoice = msg.a;
				return _Utils_Tuple3(
					model,
					A4(
						$author$project$Api$Provider$CustomerInvoice$markAsSent,
						model.Gv,
						$author$project$Api$Provider$CustomerInvoice$One$id(invoice),
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceExpands,
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotInvoice),
					_List_Nil);
			case 24:
				var invoice = msg.a;
				return _Utils_Tuple3(
					model,
					A4(
						$author$project$Api$Provider$CustomerInvoice$markAsUnsent,
						model.Gv,
						$author$project$Api$Provider$CustomerInvoice$One$id(invoice),
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceExpands,
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotInvoice),
					_List_Nil);
			case 28:
				var invoice = msg.a;
				return _Utils_Tuple3(
					model,
					A4(
						$author$project$Api$Provider$CustomerInvoice$applyCredits,
						model.Gv,
						$author$project$Api$Provider$CustomerInvoice$One$id(invoice),
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceExpands,
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotInvoice),
					_List_Nil);
			case 29:
				var invoice = msg.a;
				return _Utils_Tuple3(
					model,
					A4(
						$author$project$Api$Provider$CustomerInvoice$removeCredits,
						model.Gv,
						$author$project$Api$Provider$CustomerInvoice$One$id(invoice),
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceExpands,
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotInvoice),
					_List_Nil);
			case 30:
				var invoice = msg.a;
				return _Utils_Tuple3(
					model,
					A4(
						$author$project$Api$Provider$CustomerInvoice$transferToCredit,
						model.Gv,
						$author$project$Api$Provider$CustomerInvoice$One$id(invoice),
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceExpands,
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotInvoice),
					_List_Nil);
			case 31:
				var invoice = msg.a;
				return _Utils_Tuple3(
					model,
					A4(
						$author$project$Api$Provider$CustomerInvoice$reverseCreditTransfer,
						model.Gv,
						$author$project$Api$Provider$CustomerInvoice$One$id(invoice),
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceExpands,
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotInvoice),
					_List_Nil);
			case 25:
				var invoice = msg.a;
				return _Utils_Tuple3(
					model,
					A4(
						$author$project$Api$Provider$CustomerInvoice$stopRetrying,
						model.Gv,
						$author$project$Api$Provider$CustomerInvoice$One$id(invoice),
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceExpands,
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotInvoice),
					_List_Nil);
			case 26:
				var invoice = msg.a;
				return _Utils_Tuple3(
					model,
					A4(
						$author$project$Api$Provider$CustomerInvoice$returnToDraft,
						model.Gv,
						$author$project$Api$Provider$CustomerInvoice$One$id(invoice),
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceExpands,
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotInvoice),
					_List_Nil);
			case 27:
				var invoice = msg.a;
				return _Utils_Tuple3(
					model,
					A4(
						$author$project$Api$Provider$CustomerInvoice$reverseBadDebt,
						model.Gv,
						$author$project$Api$Provider$CustomerInvoice$One$id(invoice),
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceExpands,
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotInvoice),
					_List_Nil);
			case 33:
				var invoice = msg.a;
				var _v4 = A2($author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$init, model.Gv, invoice);
				var editInvoiceModal = _v4.a;
				var cmd = _v4.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							jw: $elm$core$Maybe$Just(editInvoiceModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$EditInvoiceModalMsg, cmd),
					_List_Nil);
			case 34:
				var modalMsg = msg.a;
				var _v5 = model.jw;
				if (!_v5.$) {
					var modal = _v5.a;
					var _v6 = A3($author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$update, model.Gv, modalMsg, modal);
					var editInvoiceModel = _v6.a;
					var editInvoiceCmd = _v6.b;
					var event = _v6.c;
					var _v7 = function () {
						if (!event.$) {
							if (!event.a.$) {
								var error = event.a.a;
								return _Utils_Tuple3(
									$elm$core$Platform$Cmd$none,
									_List_fromArray(
										[
											A2(
											$author$project$OutMsg$ShowToast,
											1,
											$author$project$Ui$Toast$serverError(error))
										]),
									$elm$core$Maybe$Just(editInvoiceModel));
							} else {
								var patientId = event.a.a;
								var successText = model.Us + ' was successfully updated.';
								var currentPayer = function () {
									var _v10 = model.Uk;
									if (_v10.$ === 3) {
										var invoice = _v10.a;
										return $author$project$Api$Provider$CustomerInvoice$One$owner(invoice);
									} else {
										return $elm$core$Maybe$Nothing;
									}
								}();
								var redirectCommand = function () {
									if (!currentPayer.$) {
										var currentPayer_ = currentPayer.a;
										return _Utils_eq(
											$author$project$Api$Provider$Patient$Shared$id(currentPayer_),
											patientId) ? A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, model.Gv, model.Us) : A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceRedirect, patientId, model.Us);
									} else {
										return $elm$core$Platform$Cmd$none;
									}
								}();
								return _Utils_Tuple3(
									redirectCommand,
									_List_fromArray(
										[
											A2($author$project$OutMsg$ShowToast, 3, successText)
										]),
									$elm$core$Maybe$Nothing);
							}
						} else {
							return _Utils_Tuple3(
								$elm$core$Platform$Cmd$none,
								_List_Nil,
								$elm$core$Maybe$Just(editInvoiceModel));
						}
					}();
					var cmd = _v7.a;
					var outMsg = _v7.b;
					var newEditInvoiceModal = _v7.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jw: newEditInvoiceModal}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$EditInvoiceModalMsg, editInvoiceCmd),
									cmd
								])),
						outMsg);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var subMsg = msg.a;
				var _v11 = model.m$;
				if (!_v11.$) {
					var createPaymentModal = _v11.a;
					var createPaymentModalResult = A3($author$project$Components$Invoice$CreatePaymentModal$update, model.Gv, subMsg, createPaymentModal);
					var _v12 = function () {
						var _v13 = createPaymentModalResult.agZ;
						switch (_v13) {
							case 1:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(createPaymentModalResult.aiO),
									model.Uk,
									$elm$core$Platform$Cmd$none);
							case 2:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Api$Data$Loading,
									A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, model.Gv, model.Us));
							default:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.Uk, $elm$core$Platform$Cmd$none);
						}
					}();
					var createPaymentModal_ = _v12.a;
					var invoice = _v12.b;
					var cmd = _v12.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{m$: createPaymentModal_, Uk: invoice}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CreatePaymentModalMsg, createPaymentModalResult.GZ),
									cmd
								])),
						createPaymentModalResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 10:
				var subMsg = msg.a;
				var _v14 = model.i$;
				if (!_v14.$) {
					var createScheduledPaymentModal = _v14.a;
					var createScheduledPaymentModalResult = A3($author$project$Components$Invoice$CreateScheduledPaymentModal$update, model.Gv, subMsg, createScheduledPaymentModal);
					var _v15 = function () {
						var _v16 = createScheduledPaymentModalResult.agZ;
						switch (_v16) {
							case 1:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(createScheduledPaymentModalResult.aiO),
									model.Uk,
									$elm$core$Platform$Cmd$none);
							case 2:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Api$Data$Loading,
									A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, model.Gv, model.Us));
							default:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.Uk, $elm$core$Platform$Cmd$none);
						}
					}();
					var createScheduledPaymentModal_ = _v15.a;
					var invoice = _v15.b;
					var cmd = _v15.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{i$: createScheduledPaymentModal_, Uk: invoice}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CreateScheduledPaymentModalMsg, createScheduledPaymentModalResult.GZ),
									cmd
								])),
						createScheduledPaymentModalResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var subMsg = msg.a;
				var _v17 = model.ik;
				if (!_v17.$) {
					var adjustVoidModal = _v17.a;
					var adjustVoidModalResult = A3($author$project$Components$CustomerInvoice$AdjustVoidModal$update, model.Gv, subMsg, adjustVoidModal);
					var _v18 = function () {
						var _v19 = adjustVoidModalResult.agZ;
						switch (_v19) {
							case 0:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(adjustVoidModalResult.aiO),
									model.Uk,
									$elm$core$Platform$Cmd$none);
							case 2:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Api$Data$Loading,
									A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, model.Gv, model.Us));
							default:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.Uk, $elm$core$Platform$Cmd$none);
						}
					}();
					var newAdjustVoidModal = _v18.a;
					var invoice = _v18.b;
					var cmd = _v18.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ik: newAdjustVoidModal, Uk: invoice}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$AdjustVoidModalMsg, adjustVoidModalResult.GZ),
									cmd
								])),
						adjustVoidModalResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var invoice = msg.a;
				return A2(
					$author$project$Utils$Tuple3$fromTuple2,
					_List_Nil,
					A3($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$initAdjustVoidModal, model, invoice, false));
			case 7:
				var subMsg = msg.a;
				var _v20 = model.kO;
				if (!_v20.$) {
					var processRefundModal = _v20.a;
					var processRefundModalResult = A3($author$project$Components$CustomerInvoice$ProcessRefundModal$update, model.Gv, subMsg, processRefundModal);
					var _v21 = function () {
						var _v22 = processRefundModalResult.agZ;
						switch (_v22) {
							case 0:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(processRefundModalResult.aiO),
									model.Uk,
									$elm$core$Platform$Cmd$none);
							case 1:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.Uk, $elm$core$Platform$Cmd$none);
							case 2:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(processRefundModalResult.aiO),
									model.Uk,
									A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, model.Gv, model.Us));
							case 3:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									model.Uk,
									A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, model.Gv, model.Us));
							default:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									model.Uk,
									A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, model.Gv, model.Us));
						}
					}();
					var newProcessRefundModal = _v21.a;
					var invoice = _v21.b;
					var cmd = _v21.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Uk: invoice, kO: newProcessRefundModal}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ProcessRefundModalMsg, processRefundModalResult.GZ),
									cmd
								])),
						processRefundModalResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				var invoice = msg.a;
				return A2(
					$author$project$Utils$Tuple3$fromTuple2,
					_List_Nil,
					A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$initProcessRefundModal, model, invoice));
			case 5:
				var invoice = msg.a;
				return A2(
					$author$project$Utils$Tuple3$fromTuple2,
					_List_Nil,
					A3($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$initAdjustVoidModal, model, invoice, true));
			case 8:
				var invoice = msg.a;
				return A2(
					$author$project$Utils$Tuple3$fromTuple2,
					_List_Nil,
					A5($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$initCreatePaymentModal, model, invoice, true, 1, $elm$core$Maybe$Nothing));
			case 11:
				var invoice = msg.a;
				return A2(
					$author$project$Utils$Tuple3$fromTuple2,
					_List_Nil,
					A5($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$initCreatePaymentModal, model, invoice, false, 0, $elm$core$Maybe$Nothing));
			case 12:
				var invoice = msg.a;
				return A2(
					$author$project$Utils$Tuple3$fromTuple2,
					_List_Nil,
					A5(
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$initCreatePaymentModal,
						model,
						invoice,
						false,
						0,
						$elm$core$Maybe$Just(
							{YZ: model.YZ})));
			case 21:
				var charge = msg.a;
				return _Utils_Tuple3(
					model,
					A4(
						$author$project$Api$Provider$CustomerInvoice$Charge$delete,
						model.Gv,
						model.Us,
						$author$project$Api$Provider$Charge$One$id(charge),
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ChargeDeleted),
					_List_Nil);
			case 22:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, model.Gv, model.Us),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 13:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{i7: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 14:
				var confirmed = msg.a;
				return confirmed ? $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$deleteInvoice(
					_Utils_update(
						model,
						{i7: false})) : _Utils_Tuple3(
					_Utils_update(
						model,
						{i7: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 15:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{iy: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 16:
				var confirmed = msg.a;
				return confirmed ? $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$markAsBadDebt(
					_Utils_update(
						model,
						{iy: false})) : _Utils_Tuple3(
					_Utils_update(
						model,
						{iy: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 17:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						A2(
							$author$project$Utils$Route$navigate,
							$elm$core$Dict$empty,
							$author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__Top(
								{
									YZ: $author$project$Api$Provider$Patient$One$id(model.YY)
								})),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Invoice removed')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 18:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Uk: response}),
						A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, model.Gv, model.Us),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 20:
				var invoice = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{od: true}),
					A4(
						$author$project$Api$Provider$CustomerInvoice$issue,
						model.Gv,
						$author$project$Api$Provider$CustomerInvoice$One$id(invoice),
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceExpands,
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$InvoiceIssued),
					_List_Nil);
			case 19:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Uk: response, od: false}),
						A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, model.Gv, model.Us),
						_List_fromArray(
							[
								$author$project$OutMsg$RetrievePatient(
								$author$project$Api$Provider$Patient$One$id(model.YY))
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{od: false}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 35:
				var id = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							yU: A3($elm$core$Dict$insert, id, $author$project$Api$Data$Loading, model.yU)
						}),
					A3(
						$author$project$Api$Provider$Charge$CoverageDiscount$list,
						model.Gv,
						id,
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotCoverageDiscounts(id)),
					_List_Nil);
			case 36:
				var chargeId = msg.a;
				var response = msg.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							yU: A3($elm$core$Dict$insert, chargeId, response, model.yU)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 37:
				var _v27 = model.Uk;
				if (_v27.$ === 3) {
					var invoice = _v27.a;
					var _v28 = A6($author$project$Components$Patient$Charges$ChargeModal$init, model.Gv, model.aa4, model.ZV, model.YY, invoice, $elm$core$Maybe$Nothing);
					var modal = _v28.a;
					var modalCmd = _v28.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								fX: $elm$core$Maybe$Just(modal)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ChargeModalMsg, modalCmd),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 38:
				var charge = msg.a;
				var _v29 = model.Uk;
				if (_v29.$ === 3) {
					var invoice = _v29.a;
					var _v30 = A6(
						$author$project$Components$Patient$Charges$ChargeModal$init,
						model.Gv,
						model.aa4,
						model.ZV,
						model.YY,
						invoice,
						$elm$core$Maybe$Just(charge));
					var modal = _v30.a;
					var modalCmd = _v30.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								fX: $elm$core$Maybe$Just(modal)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ChargeModalMsg, modalCmd),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 39:
				var subMsg = msg.a;
				var _v31 = model.fX;
				if (!_v31.$) {
					var chargeModal = _v31.a;
					var chargeModalResult = A3($author$project$Components$Patient$Charges$ChargeModal$update, model.Gv, subMsg, chargeModal);
					var _v32 = function () {
						var _v33 = chargeModalResult.agZ;
						switch (_v33.$) {
							case 0:
								return _Utils_Tuple2(
									$elm$core$Maybe$Just(chargeModalResult.aiO),
									$elm$core$Platform$Cmd$none);
							case 2:
								var shouldClose = _v33.a;
								return shouldClose ? _Utils_Tuple2(
									$elm$core$Maybe$Nothing,
									A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, model.Gv, model.Us)) : _Utils_Tuple2(
									$elm$core$Maybe$Just(chargeModalResult.aiO),
									A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, model.Gv, model.Us));
							case 3:
								return _Utils_Tuple2(
									$elm$core$Maybe$Nothing,
									A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, model.Gv, model.Us));
							default:
								return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
						}
					}();
					var newModalModel = _v32.a;
					var cmd = _v32.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{fX: newModalModel}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									cmd,
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ChargeModalMsg, chargeModalResult.GZ)
								])),
						chargeModalResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 40:
				var invoice = msg.a;
				var _v34 = A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$SchedulePaymentModalMsg),
					A2(
						$author$project$Components$CustomerSchedulePaymentModal$open,
						$author$project$Api$Provider$CustomerInvoice$One$id(invoice),
						model.dd));
				var schedulePaymentModal = _v34.a;
				var schedulePaymentModalCmd = _v34.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{hw: schedulePaymentModal}),
					schedulePaymentModalCmd,
					_List_Nil);
			case 41:
				var subMsg = msg.a;
				var schedulePaymentResult = A3($author$project$Components$CustomerSchedulePaymentModal$update, model.Gv, subMsg, model.hw);
				var invoice = function () {
					var _v35 = schedulePaymentResult.agZ;
					if (!_v35.$) {
						return model.Uk;
					} else {
						var invoice_ = _v35.b;
						return invoice_;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Uk: invoice, hw: schedulePaymentResult.aiO}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$SchedulePaymentModalMsg, schedulePaymentResult.GZ),
					schedulePaymentResult.aR);
			case 32:
				var invoice = msg.a;
				return _Utils_Tuple3(
					model,
					A4(
						$author$project$Api$Provider$CustomerInvoice$cancelPayment,
						model.Gv,
						$author$project$Api$Provider$CustomerInvoice$One$id(invoice),
						_List_fromArray(
							[0, 1]),
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotInvoice),
					_List_Nil);
			case 42:
				var subMsg = msg.a;
				var _v36 = A2($author$project$Ui$Dropdown$update, subMsg, model.lJ);
				var taxDropdown = _v36.a;
				var taxDropdownCmd = _v36.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{lJ: taxDropdown}),
					taxDropdownCmd,
					_List_Nil);
			case 43:
				var profile = msg.a;
				var fields = {
					PB: $elm$core$Maybe$Nothing,
					ais: $elm$core$Maybe$Nothing,
					YD: $elm$core$Maybe$Nothing,
					acX: $elm$core$Maybe$Just(
						$author$project$Api$Provider$TaxProfile$All$id(profile))
				};
				return _Utils_Tuple3(
					model,
					A5($author$project$Api$Provider$CustomerInvoice$update, model.Gv, model.Us, fields, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceExpands, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotInvoice),
					_List_Nil);
			case 44:
				var subMsg = msg.a;
				var downloadInvoiceResult = A3($author$project$Components$Invoice$DownloadFile$update, model.Gv, subMsg, model.jt);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{jt: downloadInvoiceResult.aiO}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$DownloadInvoiceMsg, downloadInvoiceResult.GZ),
					downloadInvoiceResult.aR);
			case 45:
				var subMsg = msg.a;
				var _v37 = A3($author$project$Components$CustomerEmailModal$update, model.Gv, subMsg, model.m5);
				var customerEmailModal = _v37.a;
				var subCmd = _v37.b;
				var subOutMsg = _v37.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{m5: customerEmailModal}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CustomerEmailModalMsg, subCmd),
					subOutMsg);
			case 46:
				var subMsg = msg.a;
				var refreshInvoice = _Utils_Tuple2(
					$author$project$Api$Data$Loading,
					A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, model.Gv, model.Us));
				var paymentsListResult = A3($author$project$Components$PaymentsList$update, model.Gv, subMsg, model.kD);
				var _v38 = function () {
					var _v39 = paymentsListResult.agZ;
					switch (_v39) {
						case 1:
							return refreshInvoice;
						case 4:
							return refreshInvoice;
						case 2:
							return refreshInvoice;
						case 3:
							return refreshInvoice;
						case 5:
							return refreshInvoice;
						default:
							return _Utils_Tuple2(model.Uk, $elm$core$Platform$Cmd$none);
					}
				}();
				var invoice = _v38.a;
				var cmd = _v38.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Uk: invoice, kD: paymentsListResult.aiO}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$PaymentsListMsg, paymentsListResult.GZ),
								cmd
							])),
					paymentsListResult.aR);
			case 47:
				var subMsg = msg.a;
				var _v40 = function () {
					var _v41 = model.iw;
					if (!_v41.$) {
						var auditTrailLog = _v41.a;
						var result = A3($author$project$Components$AuditTrailLog$update, model.Gv, subMsg, auditTrailLog);
						return _Utils_Tuple3(
							$elm$core$Maybe$Just(result.aiO),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$AuditTrailLogMsg, result.GZ),
							result.aR);
					} else {
						return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				}();
				var auditTrailLogResultModel = _v40.a;
				var auditTrailLogResultCmd = _v40.b;
				var auditTrailLogResultOutMsgs = _v40.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{iw: auditTrailLogResultModel}),
					auditTrailLogResultCmd,
					auditTrailLogResultOutMsgs);
			case 48:
				var charge = msg.a;
				var subMsg = msg.b;
				var _v42 = A3($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$updateChargeDropdown, subMsg, charge, model.iI);
				var chargesDropdowns = _v42.a;
				var dropdownCmd = _v42.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{iI: chargesDropdowns}),
					dropdownCmd,
					_List_Nil);
			case 49:
				var response = msg.a;
				if (response.$ === 3) {
					var scheduledPayments = response.a;
					var passthroughFeesCmd = function () {
						var _v44 = _Utils_Tuple2(
							$author$project$Api$Provider$Patient$One$shouldChargeCreditCardFees(model.YY),
							model.Uk);
						if (_v44.a && (_v44.b.$ === 3)) {
							var _v45 = _v44.b;
							var invoice = _v45.a;
							return A4(
								$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$fetchPassthroughFeesCmd,
								model.Gv,
								$author$project$Api$Provider$CustomerInvoice$One$dueInCents(invoice),
								A4($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$effectivePaymentSource, model.ZV, invoice, model.rC, scheduledPayments),
								model.YZ);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{la: scheduledPayments}),
						passthroughFeesCmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 51:
				var response = msg.a;
				var passthroughFeesCmd = function () {
					var _v46 = _Utils_Tuple2(
						$author$project$Api$Provider$Patient$One$shouldChargeCreditCardFees(model.YY),
						model.Uk);
					if (_v46.a && (_v46.b.$ === 3)) {
						var _v47 = _v46.b;
						var invoice = _v47.a;
						return A4(
							$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$fetchPassthroughFeesCmd,
							model.Gv,
							$author$project$Api$Provider$CustomerInvoice$One$dueInCents(invoice),
							A4($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$effectivePaymentSource, model.ZV, invoice, response, model.la),
							model.YZ);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{rC: response}),
					passthroughFeesCmd,
					$author$project$OutMsg$handleErrorResponse(response));
			case 50:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{rs: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 52:
				var invoice = msg.a;
				return A2(
					$author$project$Utils$Tuple3$fromTuple2,
					_List_Nil,
					A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$initCreateScheduledPaymentModal, model, invoice));
			case 53:
				var fees = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{YV: fees}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Ub: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
		}
	});
var $author$project$Api$Provider$CustomerInvoice$Shared$invoiceNumber = function (_v0) {
	var record = _v0;
	return record.Uu;
};
var $author$project$Api$Provider$CustomerInvoice$One$invoiceNumber = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CustomerInvoice$Shared$invoiceNumber(shared);
};
var $author$project$Api$Provider$CustomerInvoice$Meta$issueAction = function (_v0) {
	var meta = _v0;
	return meta.vy.Vm;
};
var $author$project$Api$Provider$CustomerInvoice$One$meta = function (_v0) {
	var record = _v0.b;
	return record.W4;
};
var $author$project$Components$CustomerInvoice$AdjustVoidModal$Submit = {$: 0};
var $author$project$Api$Provider$Charge$Shared$type_ = function (_v0) {
	var record = _v0;
	return record.amg;
};
var $author$project$Api$Provider$Charge$One$type_ = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Charge$Shared$type_(shared);
};
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$chargeSentence = F2(
	function (charge, canEdit) {
		var practitioner = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (name) {
					return ' with ' + name;
				},
				A2(
					$elm$core$Maybe$map,
					$author$project$Api$Provider$Practitioner$Shared$name,
					$author$project$Api$Provider$Charge$One$practitioner(charge))));
		var patient = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$name,
				$author$project$Api$Provider$Charge$One$patient(charge)));
		var date = A2(
			$justinmimbs$date$Date$format,
			'MM/dd/yyyy',
			$author$project$Api$Provider$Charge$One$date(charge));
		var period = function () {
			if ($author$project$Api$Provider$Charge$One$type_(charge) === 'service') {
				return ' on ' + date;
			} else {
				if (canEdit) {
					return ' from ' + (date + ' to ');
				} else {
					var endDate = A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							$justinmimbs$date$Date$format('MM/dd/yyyy'),
							$author$project$Api$Provider$Charge$One$endDate(charge)));
					return ' from ' + (date + (' to ' + endDate));
				}
			}
		}();
		return _Utils_ap(
			patient,
			_Utils_ap(practitioner, period));
	});
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$viewChargeNameCell = function (fields) {
	var strikeOption = fields._ ? _List_fromArray(
		[$author$project$Ui$Typography$strike]) : _List_Nil;
	return A2(
		$author$project$Ui$Table$cell,
		_List_fromArray(
			[$author$project$Ui$Table$alignCenter]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$text,
				strikeOption,
				A2(
					$elm$core$Maybe$withDefault,
					'',
					$author$project$Api$Provider$Charge$One$name(fields.afx)))
			]));
};
var $author$project$Components$DateInput$Attr = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$DateInput$attr = function (attributes) {
	return $author$project$Components$DateInput$Attr(attributes);
};
var $author$project$Components$DateInput$Inline = {$: 8};
var $author$project$Components$DateInput$inline = $author$project$Components$DateInput$Inline;
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$viewEndDateInput = F2(
	function (canEdit, fields) {
		if (canEdit && ($author$project$Api$Provider$Charge$One$type_(fields.afx) === 'coverage')) {
			var _v0 = fields.sd;
			if (!_v0.$) {
				var endDateInput = _v0.a;
				return A2(
					$elm$html$Html$map,
					A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$EndDate),
					A2(
						$author$project$Components$DateInput$view,
						_List_fromArray(
							[
								$author$project$Components$DateInput$value(fields.sb),
								$author$project$Components$DateInput$attr(
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'width', '150px')
									])),
								$author$project$Components$DateInput$inline,
								$author$project$Components$DateInput$disabled(fields._)
							]),
						endDateInput));
			} else {
				return $author$project$Utils$Html$empty;
			}
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$DiscountOverridden = {$: 7};
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$PriceInCents = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$Charge$One$consumedPrepaidCharges = function (_v0) {
	var record = _v0.b;
	return record.Ot;
};
var $author$project$Api$Provider$Charge$Meta$revisableAction = function (_v0) {
	var meta = _v0;
	return meta.vy.$4;
};
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$viewPriceCell = F2(
	function (form, fields) {
		var isRevisable = $author$project$Api$Provider$Charge$Meta$revisableAction(
			$author$project$Api$Provider$Charge$One$meta(fields.afx));
		var hasDiscount = (!(!$author$project$Api$Provider$Charge$One$discountInCents(fields.afx))) && (!fields.zh);
		return A2(
			$author$project$Ui$Table$cell,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Form$CurrencyInput$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$CurrencyInput$value(fields.Dw),
							$author$project$Ui$Form$CurrencyInput$onInput(
							A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$PriceInCents)),
							$author$project$Ui$Form$CurrencyInput$disabled(fields._ || (hasDiscount || (!isRevisable))),
							$author$project$Ui$Form$CurrencyInput$errors(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						])),
					function () {
					if ($author$project$Api$Provider$Uom$Shared$isTimeBased(fields.DA)) {
						var strikeOption = fields._ ? _List_fromArray(
							[$author$project$Ui$Typography$strike]) : _List_Nil;
						var priceUom = $author$project$Api$Provider$Charge$One$priceUom(fields.afx);
						return A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flex, $author$project$Ui$Element$justifyRight]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$text,
									A2(
										$elm$core$List$cons,
										$author$project$Ui$Typography$muted,
										A2($elm$core$List$cons, $author$project$Ui$Typography$small, strikeOption)),
									'per ' + $author$project$Api$Provider$Uom$Shared$name(priceUom))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					function () {
					if (hasDiscount) {
						var isChargeItemPackage = !$elm$core$List$isEmpty(
							$author$project$Api$Provider$Charge$One$consumedPrepaidCharges(fields.afx));
						var removeRuleLabel = isChargeItemPackage ? 'Remove package rule' : 'Remove membership rule';
						return A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{mm: removeRuleLabel},
									_List_fromArray(
										[
											$author$project$Ui$Button$onClick($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$DiscountOverridden),
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$sm
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(removeRuleLabel)
										]))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]));
	});
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$Quantity = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$QuantityUom = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$viewQuantityCell = F2(
	function (form, fields) {
		var isRevisable = $author$project$Api$Provider$Charge$Meta$revisableAction(
			$author$project$Api$Provider$Charge$One$meta(fields.afx));
		var quantityInput = $author$project$Ui$Form$Input$view(
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$number,
					$author$project$Ui$Form$Input$value(
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2($elm$core$Maybe$map, $elm$core$String$fromInt, fields.Dz))),
					$author$project$Ui$Form$Input$onInput(
					A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$Quantity)),
					$author$project$Ui$Form$Input$errors(
					A2($author$project$Utils$Form$validationErrors, 1, form)),
					$author$project$Ui$Form$Input$disabled(fields._ || (!isRevisable))
				]));
		return A2(
			$author$project$Ui$Table$cell,
			_List_Nil,
			_List_fromArray(
				[
					function () {
					if ($author$project$Api$Provider$Uom$Shared$isTimeBased(fields.DA)) {
						var uomOptions = A2(
							$elm$core$List$map,
							function (uom_) {
								return A3(
									$author$project$Ui$Form$Select$option,
									_List_Nil,
									$elm$core$Maybe$Just(
										$author$project$Api$Provider$Uom$Shared$code(uom_)),
									$author$project$Api$Provider$Uom$Shared$name(uom_));
							},
							$author$project$Api$Provider$Uom$list(
								function (d) {
									return _Utils_update(
										d,
										{
											Kg: $elm$core$Maybe$Just('time')
										});
								}));
						return A2(
							$author$project$Ui$Grid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(5)
										]),
									_List_fromArray(
										[quantityInput])),
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(7)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Select$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Select$value(
													$elm$core$Maybe$Just(
														$author$project$Api$Provider$Uom$Shared$code(fields.DA))),
													$author$project$Ui$Form$Select$onChange(
													A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$QuantityUom)),
													$author$project$Ui$Form$Select$disabled(fields._ || (!isRevisable))
												]),
											uomOptions)
										]))
								]));
					} else {
						return quantityInput;
					}
				}()
				]));
	});
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$ReturnToInventory = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$viewReturnToInventory = F2(
	function (fields, voidOnly) {
		var quantityReduced = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (quantity_) {
					return _Utils_cmp(
						$author$project$Api$Provider$Charge$One$quantity(fields.afx),
						quantity_) > 0;
				},
				fields.Dz));
		return ($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$trackInventory(fields.afx) && (fields._ || quantityReduced)) ? A2(
			$author$project$Ui$Form$Checkbox$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Checkbox$value(fields.e6),
					$author$project$Ui$Form$Checkbox$onCheck(
					A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$ReturnToInventory)),
					$author$project$Ui$Form$Checkbox$inline,
					$author$project$Ui$Form$Checkbox$disabled(voidOnly)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Return to Inventory')
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Api$Provider$ChargeAdjustment$Shared$subtotalAdjustmentInCents = function (_v0) {
	var record = _v0;
	return record.acC;
};
var $author$project$Api$Provider$ChargeAdjustment$Preview$subtotalAdjustmentInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeAdjustment$Shared$subtotalAdjustmentInCents(shared);
};
var $author$project$Api$Provider$Charge$Shared$subtotalInCents = function (_v0) {
	var record = _v0;
	return record.acD;
};
var $author$project$Api$Provider$Charge$One$subtotalInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Charge$Shared$subtotalInCents(shared);
};
var $author$project$Api$Provider$Charge$Shared$taxable = function (_v0) {
	var record = _v0;
	return record.acZ;
};
var $author$project$Api$Provider$Charge$One$taxable = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Charge$Shared$taxable(shared);
};
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$viewSubtotalCell = F3(
	function (adjustmentPreview, fields, voidOnly) {
		var taxLabel = $author$project$Api$Provider$Charge$One$taxable(fields.afx) ? $elm$html$Html$text(' + tax') : $author$project$Utils$Html$empty;
		var subtotalAdjustmentInCents = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$ChargeAdjustment$Preview$subtotalAdjustmentInCents, adjustmentPreview));
		var strikeOption = fields._ ? _List_fromArray(
			[
				$elm$html$Html$Attributes$class('line-through')
			]) : _List_Nil;
		var isRevisable = $author$project$Api$Provider$Charge$Meta$revisableAction(
			$author$project$Api$Provider$Charge$One$meta(fields.afx));
		var tooltipIcon = function () {
			if ((!isRevisable) && (!voidOnly)) {
				var isChargeItemPackage = A2(
					$elm$core$Maybe$withDefault,
					false,
					A2($elm$core$Maybe$map, $author$project$Api$Provider$ChargeItem$ForCharge$isPackage, fields.mL));
				var tooltipMessage = isChargeItemPackage ? 'Packages cannot be revised on invoices.' : 'Items included in a package cannot be revised on invoices.';
				return _List_fromArray(
					[
						A3(
						$author$project$Ui$Tooltip$view,
						_List_fromArray(
							[$author$project$Ui$Tooltip$wide]),
						tooltipMessage,
						_List_fromArray(
							[
								$author$project$Ui$Icon$help(_List_Nil)
							])),
						$author$project$Utils$Html$noBreakSpace
					]);
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$author$project$Ui$Table$cell,
			_List_fromArray(
				[$author$project$Ui$Table$alignCenter]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('text-right'),
						strikeOption),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$prose,
							_List_Nil,
							(!subtotalAdjustmentInCents) ? _Utils_ap(
								tooltipIcon,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$text,
										_List_fromArray(
											[$author$project$Ui$Typography$bold]),
										$author$project$Utils$Currency$fromInt(
											$author$project$Api$Provider$Charge$One$subtotalInCents(fields.afx))),
										A2(
										$author$project$Ui$Element$view,
										_List_Nil,
										_List_fromArray(
											[taxLabel]))
									])) : _Utils_ap(
								tooltipIcon,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$text,
										_List_fromArray(
											[$author$project$Ui$Typography$muted]),
										$author$project$Utils$Currency$fromInt(
											$author$project$Api$Provider$Charge$One$subtotalInCents(fields.afx))),
										$author$project$Utils$Html$noBreakSpace,
										A2(
										$author$project$Ui$Typography$text,
										_List_fromArray(
											[$author$project$Ui$Typography$bold]),
										$author$project$Utils$Currency$fromInt(
											$author$project$Api$Provider$Charge$One$subtotalInCents(fields.afx) + subtotalAdjustmentInCents)),
										A2(
										$author$project$Ui$Element$view,
										_List_Nil,
										_List_fromArray(
											[taxLabel]))
									])))
						]))
				]));
	});
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$Void = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$viewVoidCell = F2(
	function (fields, voidOnly) {
		var isRevisable = $author$project$Api$Provider$Charge$Meta$revisableAction(
			$author$project$Api$Provider$Charge$One$meta(fields.afx));
		return A2(
			$author$project$Ui$Table$cell,
			_List_fromArray(
				[$author$project$Ui$Table$alignCenter]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Checkbox$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Checkbox$value(fields._),
							$author$project$Ui$Form$Checkbox$onCheck(
							A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$Void)),
							$author$project$Ui$Form$Checkbox$disabled(voidOnly || (!isRevisable))
						]),
					_List_Nil)
				]));
	});
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$view = function (_v0) {
	var form = _v0.SD;
	var adjustmentPreview = _v0.vD;
	var voidOnly = _v0.F8;
	var fields = $author$project$Utils$Form$fields(form);
	var canEdit = $author$project$Api$Provider$Charge$Meta$editAction(
		$author$project$Api$Provider$Charge$One$meta(fields.afx));
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Table$row,
			_List_fromArray(
				[
					$author$project$Ui$Table$styled(1)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[
							$author$project$Ui$Table$colspan(5),
							$author$project$Ui$Table$alignCenter
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$spaceBetween]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$text,
											_List_Nil,
											A2($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$chargeSentence, fields.afx, canEdit)),
											A2($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$viewEndDateInput, canEdit, fields)
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$justifyRight]),
									_List_fromArray(
										[
											A2($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$viewReturnToInventory, fields, voidOnly)
										]))
								]))
						]))
				])),
			A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$viewVoidCell, fields, voidOnly),
					$author$project$Components$CustomerInvoice$ChargeAdjustmentForm$viewChargeNameCell(fields),
					A2($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$viewQuantityCell, form, fields),
					A2($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$viewPriceCell, form, fields),
					A3($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$viewSubtotalCell, adjustmentPreview, fields, voidOnly)
				]))
		]);
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$viewChargesTable = function (model) {
	var adjustmentRows = A2(
		$elm$core$List$concatMap,
		function (_v0) {
			var chargeId = _v0.a;
			var form = _v0.b;
			return A2(
				$elm$core$List$map,
				$author$project$Ui$Table$mapRow(
					$author$project$Components$CustomerInvoice$AdjustmentsForm$ChargeAdjustmentFormMsg(chargeId)),
				$author$project$Components$CustomerInvoice$ChargeAdjustmentForm$view(form));
		},
		model.ap);
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A4(
				$author$project$Ui$Panel$table,
				_List_fromArray(
					[
						$author$project$Ui$Table$zeroState(
						_List_fromArray(
							[
								$elm$html$Html$text('There are no charges.')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[
								$author$project$Ui$Table$cellSpan(1)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Checkbox$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Checkbox$value(
										$author$project$Components$CustomerInvoice$AdjustmentsForm$allVoided(model)),
										$author$project$Ui$Form$Checkbox$onCheck($author$project$Components$CustomerInvoice$AdjustmentsForm$VoidAll),
										$author$project$Ui$Form$Checkbox$disabled(model.F8)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$text,
										_List_fromArray(
											[$author$project$Ui$Typography$medium]),
										'Void')
									]))
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[
								$author$project$Ui$Table$cellSpan(3)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Charge')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[
								$author$project$Ui$Table$cellSpan(3)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Qty')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[
								$author$project$Ui$Table$cellSpan(3)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Price')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[
								$author$project$Ui$Table$cellSpan(2),
								$author$project$Ui$Table$textRight
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Amount')
							]))
					]),
				adjustmentRows,
				_List_Nil)
			]));
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$viewCharges = function (_v0) {
	var model = _v0;
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mb2]),
				_List_fromArray(
					[
						$author$project$Ui$Typography$headingSm(
						_List_fromArray(
							[
								$elm$html$Html$text('Charges')
							]))
					])),
				$author$project$Components$CustomerInvoice$AdjustmentsForm$viewChargesTable(model)
			]));
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$MemoUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$viewNewDue = F4(
	function (totalInCents, totalPayments, totalAdjustment, totalRefundedAmount) {
		if (!(!totalAdjustment)) {
			var newDue = A3($author$project$Components$CustomerInvoice$AdjustmentsForm$newDueAmount, totalInCents, totalPayments, totalAdjustment) + totalRefundedAmount;
			return A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanSm(4)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$text,
								_List_fromArray(
									[
										$author$project$Ui$Typography$attrs(
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-label-md')
											]))
									]),
								'New due:')
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanSm(8)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$textRight]),
								_List_fromArray(
									[
										$author$project$Ui$Typography$headingSm(
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Utils$Currency$fromInt(newDue))
											]))
									]))
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Utils$Currency$fromIntWithPlus = function (cents) {
	return (cents >= 0) ? ('+' + $author$project$Utils$Currency$fromInt(cents)) : $author$project$Utils$Currency$fromInt(cents);
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$viewPayments = F2(
	function (totalPayments, totalAdjustment) {
		return (!(!totalAdjustment)) ? A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(4)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[
									$author$project$Ui$Typography$attrs(
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-label-md')
										]))
								]),
							'Payments:')
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(8)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textRight]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$bold]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Utils$Currency$fromIntWithPlus(-totalPayments))
										]))
								]))
						]))
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Components$CustomerInvoice$AdjustmentsForm$viewRefunds = function (totalRefundedAmount) {
	return (!(!totalRefundedAmount)) ? A2(
		$author$project$Ui$Grid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$spanSm(4)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$text,
						_List_fromArray(
							[
								$author$project$Ui$Typography$attrs(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-label-md')
									]))
							]),
						'New refunds:')
					])),
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$spanSm(8)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$textRight]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$bold]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Utils$Currency$fromIntWithPlus(totalRefundedAmount))
									]))
							]))
					]))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$viewRevision = function (totalAdjustment) {
	if (!(!totalAdjustment)) {
		var color = (totalAdjustment > 0) ? $author$project$Ui$Typography$success : $author$project$Ui$Typography$danger;
		return A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(4)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[
									$author$project$Ui$Typography$attrs(
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-label-md')
										]))
								]),
							'New revision:')
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(8)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textRight]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$bold, color]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Utils$Currency$fromIntWithPlus(totalAdjustment))
										]))
								]))
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$viewSummaryContent = function (model) {
	var totalPayments = $author$project$Components$CustomerInvoice$AdjustmentsForm$totalPaymentsAmount(model.Uk);
	var totalAdjustment = A2(
		$elm$core$Maybe$withDefault,
		0,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$InvoiceAdjustment$Preview$totalAdjustmentInCents,
			$author$project$Api$Data$toMaybe(model.akd)));
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanSm(4)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$text,
										_List_fromArray(
											[
												$author$project$Ui$Typography$attrs(
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('text-label-md')
													]))
											]),
										'Original total:')
									])),
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanSm(8)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$textRight]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$p,
												_List_fromArray(
													[$author$project$Ui$Typography$bold]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Utils$Currency$fromInt(
															$author$project$Api$Provider$CustomerInvoice$One$totalInCents(model.Uk)))
													]))
											]))
									]))
							])),
						$author$project$Components$CustomerInvoice$AdjustmentsForm$viewRevision(totalAdjustment),
						$author$project$Ui$HorizontalRule$view(
						_List_fromArray(
							[$author$project$Ui$HorizontalRule$thin])),
						A2($author$project$Components$CustomerInvoice$AdjustmentsForm$viewPayments, totalPayments, totalAdjustment),
						$author$project$Ui$HorizontalRule$view(
						_List_fromArray(
							[$author$project$Ui$HorizontalRule$thin])),
						$author$project$Components$CustomerInvoice$AdjustmentsForm$viewRefunds(model.qD),
						A4(
						$author$project$Components$CustomerInvoice$AdjustmentsForm$viewNewDue,
						$author$project$Api$Provider$CustomerInvoice$One$totalInCents(model.Uk),
						totalPayments,
						totalAdjustment,
						model.qD),
						$author$project$Ui$Form$Textarea$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Textarea$phi(true),
								$author$project$Ui$Form$Textarea$placeholder('Reason / memo for revision'),
								$author$project$Ui$Form$Textarea$onInput($author$project$Components$CustomerInvoice$AdjustmentsForm$MemoUpdated),
								$author$project$Ui$Form$Textarea$value(
								A2($elm$core$Maybe$withDefault, '', model.aiG))
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$helpBlock]),
						_List_fromArray(
							[
								$elm$html$Html$text('This is an internal note and does not appear on the printed invoice.')
							]))
					]))
			]));
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$viewSummary = function (_v0) {
	var model = _v0;
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mb2]),
				_List_fromArray(
					[
						$author$project$Ui$Typography$headingSm(
						_List_fromArray(
							[
								$elm$html$Html$text('Summary')
							]))
					])),
				$author$project$Components$CustomerInvoice$AdjustmentsForm$viewSummaryContent(model)
			]));
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$view = function (model) {
	return A2(
		$author$project$Ui$Grid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$spanSm(8)
					]),
				_List_fromArray(
					[
						$author$project$Components$CustomerInvoice$AdjustmentsForm$viewCharges(model)
					])),
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$spanSm(4)
					]),
				_List_fromArray(
					[
						$author$project$Components$CustomerInvoice$AdjustmentsForm$viewSummary(model)
					]))
			]));
};
var $author$project$Components$CustomerInvoice$AdjustVoidModal$view = function (model) {
	return A2(
		$author$project$Ui$Form$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$noValidate(true),
				$author$project$Ui$Form$autocomplete(false),
				$author$project$Ui$Form$onSubmit($author$project$Components$CustomerInvoice$AdjustVoidModal$Submit)
			]),
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Modal$view,
				$author$project$Components$CustomerInvoice$AdjustVoidModal$Close,
				_List_fromArray(
					[$author$project$Ui$Modal$lg]),
				_List_fromArray(
					[
						$author$project$Ui$Modal$header(
						_List_fromArray(
							[
								$author$project$Ui$Modal$title('Create Revision')
							])),
						$author$project$Ui$Modal$body(
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$CustomerInvoice$AdjustVoidModal$AdjustmentsFormMsg,
								$author$project$Components$CustomerInvoice$AdjustmentsForm$view(model.bQ))
							])),
						$author$project$Ui$Modal$footer(
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Cancel and close modal'},
								_List_fromArray(
									[
										$author$project$Ui$Button$onClick($author$project$Components$CustomerInvoice$AdjustVoidModal$Close)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Cancel')
									])),
								function () {
								var verb = (model.F8 || $author$project$Components$CustomerInvoice$AdjustmentsForm$allVoided(model.bQ)) ? 'Void' : 'Revise';
								return A3(
									$author$project$Ui$Button$view,
									{mm: verb + ' invoice'},
									_List_fromArray(
										[
											$author$project$Ui$Button$primary,
											$author$project$Ui$Button$loading(model.lA),
											$author$project$Ui$Button$disabled(
											$author$project$Components$CustomerInvoice$AdjustmentsForm$hasAnyValidationError(model.bQ)),
											$author$project$Ui$Button$submit
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(verb)
										]));
							}()
							]))
					]))
			]));
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$Submit = {$: 0};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$Pay = {$: 8};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$Void = {$: 9};
var $author$project$Api$Provider$Patient$One$hasPaymentMethod = function (_v0) {
	var record = _v0.b;
	return record.Tf;
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$viewAfterRefundActions = function (model) {
	var patientHasPaymentMethod = $author$project$Api$Provider$Patient$One$hasPaymentMethod(model.YY);
	return _List_fromArray(
		[
			A3(
			$author$project$Ui$Button$view,
			{mm: 'Void'},
			_List_fromArray(
				[
					$author$project$Ui$Button$danger,
					$author$project$Ui$Button$onClick($author$project$Components$CustomerInvoice$ProcessRefundModal$Void),
					$author$project$Ui$Button$loading(model.vp)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Void')
				])),
			patientHasPaymentMethod ? A3(
			$author$project$Ui$Button$view,
			{mm: 'Process new payment'},
			_List_fromArray(
				[
					$author$project$Ui$Button$success,
					$author$project$Ui$Button$onClick($author$project$Components$CustomerInvoice$ProcessRefundModal$Pay),
					$author$project$Ui$Button$loading(model.tt),
					$author$project$Ui$Button$icon($author$project$Ui$Icon$bolt)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(' Process New Payment')
				])) : A3(
			$author$project$Ui$Link$route,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__Accounts__Top(
				{
					YZ: $author$project$Api$Provider$Patient$One$id(model.YY)
				}),
			_List_fromArray(
				[$author$project$Ui$Link$buttonSuccess]),
			_List_fromArray(
				[
					$elm$html$Html$text('Add Payment Source')
				]))
		]);
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$viewFooter = F2(
	function (model, notRefunded) {
		return notRefunded ? _List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Cancel and close modal'},
				_List_fromArray(
					[
						$author$project$Ui$Button$onClick($author$project$Components$CustomerInvoice$ProcessRefundModal$Close)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Cancel')
					])),
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Process refund'},
				_List_fromArray(
					[
						$author$project$Ui$Button$styled(4),
						$author$project$Ui$Button$loading(
						_Utils_eq(model.e$, $author$project$Api$Data$Loading)),
						$author$project$Ui$Button$disabled(
						(!model.gD) && $author$project$Components$CustomerInvoice$RefundsForm$hasAnyValidationError(model.e0)),
						$author$project$Ui$Button$submit,
						$author$project$Ui$Button$icon($author$project$Ui$Icon$repeat)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Process Refund')
					]))
			]) : $author$project$Components$CustomerInvoice$ProcessRefundModal$viewAfterRefundActions(model);
	});
var $author$project$Components$CustomerInvoice$ProcessRefundModal$FormUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$Memo = $elm$core$Basics$identity;
var $author$project$Components$CustomerInvoice$ProcessRefundModal$MemoValidation = 0;
var $author$project$Ui$Form$Textarea$CustomHeight = function (a) {
	return {$: 11, a: a};
};
var $author$project$Ui$Form$Textarea$customHeight = function (height) {
	return $author$project$Ui$Form$Textarea$CustomHeight(height);
};
var $author$project$Api$Provider$CustomerInvoice$Shared$passthroughFeesInCents = function (_v0) {
	var record = _v0;
	return record.YW;
};
var $author$project$Api$Provider$CustomerInvoice$One$passthroughFeesInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CustomerInvoice$Shared$passthroughFeesInCents(shared);
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$viewFullRefundSection = F2(
	function (model, fields) {
		var feesCharged = $author$project$Api$Provider$CustomerInvoice$One$passthroughFeesInCents(model.Uk);
		var feesChargedText = (feesCharged > 0) ? ' (includes fees)' : '';
		return A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(6)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Textarea$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Textarea$value(
									A2($elm$core$Maybe$withDefault, '', fields.aiG)),
									$author$project$Ui$Form$Textarea$phi(true),
									$author$project$Ui$Form$Textarea$customHeight('63px'),
									$author$project$Ui$Form$Textarea$placeholder('Memo for revision'),
									$author$project$Ui$Form$Textarea$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, model.SD)),
									$author$project$Ui$Form$Textarea$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$CustomerInvoice$ProcessRefundModal$FormUpdated, $elm$core$Basics$identity))
								])),
							A2(
							$author$project$Ui$Typography$p,
							_List_fromArray(
								[$author$project$Ui$Typography$small, $author$project$Ui$Typography$helpBlock]),
							_List_fromArray(
								[
									$elm$html$Html$text('This is an internal note and does not appear on the printed invoice.')
								]))
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(6)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Panel$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Panel$body,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Grid$row,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Grid$column,
													_List_fromArray(
														[
															$author$project$Ui$Grid$spanMd(6)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Total refund' + (feesChargedText + ' :'))
														])),
													A2(
													$author$project$Ui$Grid$column,
													_List_fromArray(
														[
															$author$project$Ui$Grid$spanMd(6)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Element$view,
															_List_fromArray(
																[$author$project$Ui$Element$textRight]),
															_List_fromArray(
																[
																	A2(
																	$author$project$Ui$Typography$p,
																	_List_fromArray(
																		[$author$project$Ui$Typography$bold]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Utils$Currency$fromInt(
																				$author$project$Api$Provider$CustomerInvoice$One$paidInCents(model.Uk) + feesCharged))
																		]))
																]))
														]))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$CustomerInvoice$RefundsForm$FormUpdated = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$CustomerInvoice$RefundsForm$formHasErrors = F2(
	function (model, paymentId) {
		var _v0 = A2($author$project$Components$CustomerInvoice$RefundsForm$findRefundForm, paymentId, model.aL);
		if (!_v0.$) {
			var form = _v0.a;
			return A2($author$project$Utils$Form$validationErrors, 0, form);
		} else {
			return _List_fromArray(
				['']);
		}
	});
var $author$project$Components$CustomerInvoice$RefundsForm$viewRefundablePaymentRow = F2(
	function (model, _v0) {
		var paymentId = _v0.a;
		var form = _v0.b;
		var fields = $author$project$Utils$Form$fields(form);
		var source = $author$project$Api$Payment$source(fields.Y9);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(3)
						]),
					_List_fromArray(
						[
							function () {
							var _v1 = $author$project$Api$Payment$paidAt(fields.Y9);
							if (!_v1.$) {
								var paidAt_ = _v1.a;
								return $elm$html$Html$text(
									A2(model.J7, 5, paidAt_));
							} else {
								return $elm$html$Html$text(
									A2(
										model.J7,
										5,
										$author$project$Api$Payment$createdAt(fields.Y9)));
							}
						}()
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(4)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Badge$fromString,
							_List_Nil,
							$author$project$Api$Payment$status(fields.Y9)),
							$author$project$Api$Payment$external(fields.Y9) ? $elm$html$Html$text(' with ') : $elm$html$Html$text(' on '),
							A2(
							$author$project$Components$PaymentSourceDisplayer$view,
							model.J7,
							_List_fromArray(
								[
									$author$project$Components$PaymentSourceDisplayer$source(
									A2($elm$core$Maybe$map, $author$project$Api$Source$Source, source)),
									$author$project$Components$PaymentSourceDisplayer$limitedView(true),
									$author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus(true),
									$author$project$Components$PaymentSourceDisplayer$paymentProcessor(
									$author$project$Api$Payment$paymentProcessor(fields.Y9))
								])),
							($author$project$Api$Payment$status(fields.Y9) === 'failed') ? $elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									$author$project$Formatters$String$humanize,
									$author$project$Api$Payment$errorMessage(fields.Y9)))) : $author$project$Utils$Html$empty,
							function () {
							var _v2 = $author$project$Api$Payment$memo(fields.Y9);
							if (!_v2.$) {
								var memo = _v2.a;
								return A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[
											$author$project$Ui$Typography$phi(true)
										]),
									' - ' + memo);
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(3)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$CurrencyInput$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$CurrencyInput$value(fields.LE),
									$author$project$Ui$Form$CurrencyInput$onInput(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Components$CustomerInvoice$RefundsForm$FormUpdated(paymentId),
										$elm$core$Basics$identity)),
									$author$project$Ui$Form$CurrencyInput$errors(
									A2($author$project$Components$CustomerInvoice$RefundsForm$formHasErrors, model, paymentId))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(2)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textRight]),
							_List_fromArray(
								[
									_Utils_eq(
									$author$project$Api$Payment$attemptedInCents(fields.Y9),
									$author$project$Api$Payment$amountInCents(fields.Y9)) ? $author$project$Utils$Html$empty : A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$strike]),
											$author$project$Utils$Currency$fromInt(
												$author$project$Api$Payment$attemptedInCents(fields.Y9)))
										])),
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											'from ' + $author$project$Utils$Currency$fromInt(
												$author$project$Api$Payment$amountInCents(fields.Y9)))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$CustomerInvoice$RefundsForm$view = function (_v0) {
	var model = _v0;
	var refundRows = A2(
		$elm$core$List$map,
		$author$project$Components$CustomerInvoice$RefundsForm$viewRefundablePaymentRow(model),
		model.aL);
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Typography$headingSm(
				_List_fromArray(
					[
						$elm$html$Html$text('Refunds')
					])),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								function () {
								if (model.rb > 0) {
									var overPaidAmount = A2(
										$elm$core$Basics$min,
										$author$project$Api$Provider$CustomerInvoice$One$paidInCents(model.Uk),
										model.rb);
									return A2(
										$author$project$Ui$Element$prose,
										_List_Nil,
										_List_fromArray(
											[
												A2($author$project$Ui$Typography$text, _List_Nil, 'Overpaid amount (with current adjustment): '),
												A2(
												$author$project$Ui$Typography$text,
												_List_fromArray(
													[$author$project$Ui$Typography$bold]),
												$author$project$Utils$Currency$fromInt(overPaidAmount))
											]));
								} else {
									return $author$project$Utils$Html$empty;
								}
							}()
							])),
						A4(
						$author$project$Ui$Panel$table,
						_List_fromArray(
							[
								$author$project$Ui$Table$zeroState(
								_List_fromArray(
									[
										$elm$html$Html$text('There are no refunds.')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Table$header,
								_List_fromArray(
									[
										$author$project$Ui$Table$cellSpan(3)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Payment Date')
									])),
								A2(
								$author$project$Ui$Table$header,
								_List_fromArray(
									[
										$author$project$Ui$Table$cellSpan(4)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Payment Details')
									])),
								A2(
								$author$project$Ui$Table$header,
								_List_fromArray(
									[
										$author$project$Ui$Table$cellSpan(3)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('')
									])),
								A2(
								$author$project$Ui$Table$header,
								_List_fromArray(
									[
										$author$project$Ui$Table$cellSpan(2),
										$author$project$Ui$Table$textRight
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Amount')
									]))
							]),
						refundRows,
						_List_Nil),
						A2($author$project$Ui$Panel$footer, _List_Nil, _List_Nil)
					]))
			]));
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$viewPartialRefundSection = function (model) {
	return A2(
		$author$project$Ui$Grid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$spanSm(8)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Components$CustomerInvoice$ProcessRefundModal$AdjustmentsFormMsg,
						$author$project$Components$CustomerInvoice$AdjustmentsForm$viewCharges(model.bQ)),
						A2(
						$elm$html$Html$map,
						$author$project$Components$CustomerInvoice$ProcessRefundModal$RefundsFormMsg,
						$author$project$Components$CustomerInvoice$RefundsForm$view(model.e0))
					])),
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$spanSm(4)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Components$CustomerInvoice$ProcessRefundModal$AdjustmentsFormMsg,
						$author$project$Components$CustomerInvoice$AdjustmentsForm$viewSummary(model.bQ))
					]))
			]));
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$Other = 2;
var $author$project$Components$CustomerInvoice$ProcessRefundModal$viewRefundAlertMessage = function (model) {
	return A2(
		$author$project$Ui$Grid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$column,
				_List_Nil,
				(_Utils_eq(
					model.hs,
					$elm$core$Maybe$Just(1)) || _Utils_eq(
					model.hs,
					$elm$core$Maybe$Just(2))) ? _List_fromArray(
					[
						A2(
						$author$project$Ui$Alert$warning,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Ui$Typography$text, _List_Nil, 'By selecting an external refund method, you acknowledge that you are responsible for refunding the patient outside of this platform.')
							]))
					]) : _List_fromArray(
					[$author$project$Utils$Html$empty]))
			]));
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$viewRefundConfirmation = function (model) {
	var refundAmount = function () {
		var _v0 = model.e$;
		if (_v0.$ === 3) {
			var refund = _v0.a;
			return $author$project$Api$Provider$Refund$One$amountInCents(refund);
		} else {
			return 0;
		}
	}();
	var name = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$Patient$Shared$name,
			$author$project$Api$Provider$CustomerInvoice$One$owner(model.Uk)));
	return A2(
		$author$project$Ui$Grid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$column,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Alert$warning,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Ui$Typography$text, _List_Nil, 'You have successfully recorded a refund of '),
								A2(
								$author$project$Ui$Typography$text,
								_List_fromArray(
									[$author$project$Ui$Typography$bold]),
								$author$project$Utils$Currency$fromInt(refundAmount)),
								A2($author$project$Ui$Typography$text, _List_Nil, ' to '),
								A2(
								$author$project$Ui$Typography$text,
								_List_fromArray(
									[$author$project$Ui$Typography$bold]),
								name)
							]))
					])),
				A2(
				$author$project$Ui$Grid$column,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Panel$body,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Grid$row,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Grid$column,
														_List_fromArray(
															[
																$author$project$Ui$Grid$spanMd(6)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Previous due:')
															])),
														A2(
														$author$project$Ui$Grid$column,
														_List_fromArray(
															[
																$author$project$Ui$Grid$spanMd(6)
															]),
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Element$view,
																_List_fromArray(
																	[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$mb1]),
																_List_fromArray(
																	[
																		A2(
																		$author$project$Ui$Typography$p,
																		_List_fromArray(
																			[$author$project$Ui$Typography$bold]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text(
																				$author$project$Utils$Currency$fromInt(
																					$author$project$Api$Provider$CustomerInvoice$One$paidInCents(model.Uk)))
																			]))
																	]))
															]))
													])),
												$author$project$Ui$HorizontalRule$view(
												_List_fromArray(
													[$author$project$Ui$HorizontalRule$thin])),
												A2(
												$author$project$Ui$Grid$row,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Grid$column,
														_List_fromArray(
															[
																$author$project$Ui$Grid$spanMd(6)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Current due:')
															])),
														A2(
														$author$project$Ui$Grid$column,
														_List_fromArray(
															[
																$author$project$Ui$Grid$spanMd(6)
															]),
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Element$view,
																_List_fromArray(
																	[$author$project$Ui$Element$justifyRight]),
																_List_fromArray(
																	[
																		$author$project$Ui$Typography$headingSm(
																		_List_fromArray(
																			[
																				$elm$html$Html$text(
																				$author$project$Utils$Currency$fromInt(refundAmount))
																			]))
																	]))
															]))
													]))
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$viewRefundFailedMessage = function (model) {
	var maybePatient = $author$project$Api$Provider$CustomerInvoice$One$owner(model.Uk);
	var name = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Shared$name, maybePatient));
	return A2(
		$author$project$Ui$Grid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$column,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Alert$danger,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Ui$Typography$text, _List_Nil, 'A refund of '),
								A2(
								$author$project$Ui$Typography$text,
								_List_fromArray(
									[$author$project$Ui$Typography$bold]),
								$author$project$Utils$Currency$fromInt(
									$author$project$Api$Provider$CustomerInvoice$One$paidInCents(model.Uk))),
								A2($author$project$Ui$Typography$text, _List_Nil, ' to '),
								A2(
								$author$project$Ui$Typography$text,
								_List_fromArray(
									[$author$project$Ui$Typography$bold]),
								name),
								A2($author$project$Ui$Typography$text, _List_Nil, ' failed to process ')
							]))
					]))
			]));
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$OriginalSource = 0;
var $author$project$Components$CustomerInvoice$ProcessRefundModal$RefundTypeUpdated = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$viewRefundMethod = function (model) {
	return A2(
		$author$project$Ui$Grid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$spanSm(7)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Refund method')
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$textMuted]),
						_List_fromArray(
							[
								$elm$html$Html$text('How do you want to issue a refund?')
							]))
					])),
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$spanSm(5),
						$author$project$Ui$Grid$justifyRight
					]),
				function () {
					var _v0 = model.hs;
					if (!_v0.$) {
						var refundType = _v0.a;
						var refundablePayments = A2(
							$elm$core$List$filter,
							function (payment) {
								return !$author$project$Api$Payment$external(payment);
							},
							A2($elm$core$List$filter, $author$project$Api$Payment$isRefundableOnPaymentProcessor, model.Zi));
						return _List_fromArray(
							[
								$author$project$Ui$Button$group(
								_List_fromArray(
									[
										function () {
										if (!$elm$core$List$isEmpty(refundablePayments)) {
											var originalSourceName = function () {
												if ($elm$core$List$length(refundablePayments) > 1) {
													return 'Original Souce';
												} else {
													var firstSource = A2(
														$elm$core$Maybe$withDefault,
														$elm$core$Maybe$Nothing,
														A2(
															$elm$core$Maybe$map,
															$author$project$Api$Payment$source,
															$elm$core$List$head(refundablePayments)));
													if (!firstSource.$) {
														var source = firstSource.a;
														var nameSource = A2(
															$elm$core$Maybe$withDefault,
															'',
															$author$project$Api$Common$Source$Shared$name(source));
														var lastFour = A2(
															$elm$core$Maybe$withDefault,
															'',
															$author$project$Api$Common$Source$Shared$lastFour(source));
														return nameSource + (' *' + lastFour);
													} else {
														return '';
													}
												}
											}();
											return A3(
												$author$project$Ui$Button$view,
												{mm: 'Select original source ' + originalSourceName},
												_List_fromArray(
													[
														$author$project$Ui$Button$active(!refundType),
														$author$project$Ui$Button$onClick(
														$author$project$Components$CustomerInvoice$ProcessRefundModal$RefundTypeUpdated(0))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(originalSourceName)
													]));
										} else {
											return $author$project$Utils$Html$empty;
										}
									}(),
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Select check'},
										_List_fromArray(
											[
												$author$project$Ui$Button$active(refundType === 1),
												$author$project$Ui$Button$onClick(
												$author$project$Components$CustomerInvoice$ProcessRefundModal$RefundTypeUpdated(1))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Check')
											])),
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Select other'},
										_List_fromArray(
											[
												$author$project$Ui$Button$active(refundType === 2),
												$author$project$Ui$Button$onClick(
												$author$project$Components$CustomerInvoice$ProcessRefundModal$RefundTypeUpdated(2))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Other')
											]))
									]))
							]);
					} else {
						return _List_fromArray(
							[
								$author$project$Ui$Button$group(
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Change refund method'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$onClick(
												$author$project$Components$CustomerInvoice$ProcessRefundModal$RefundTypeUpdated(0))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Change refund method')
											]))
									]))
							]);
					}
				}())
			]));
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$ToggledRefundType = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$Payment$Shared$passthroughFees = function (_v0) {
	var record = _v0;
	return record.YV;
};
var $author$project$Api$Provider$Payment$One$passthroughFees = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$passthroughFees(shared);
};
var $author$project$Api$Provider$Payment$SharedWithRefunds$passthroughFees = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$passthroughFees(shared);
};
var $author$project$Api$Payment$passthroughFees = function (payment) {
	switch (payment.$) {
		case 1:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$One$passthroughFees(payment_);
		case 0:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$SharedWithRefunds$passthroughFees(payment_);
		default:
			return false;
	}
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$thereIsAtLeastOnePaymentWithPassthroughFees = function (payments) {
	return function (paymentWithPassthroughFees) {
		return !_Utils_eq(paymentWithPassthroughFees, $elm$core$Maybe$Nothing);
	}(
		A2(
			$elm_community$list_extra$List$Extra$find,
			function (payment) {
				return $author$project$Api$Payment$passthroughFees(payment);
			},
			payments));
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$viewRefundType = function (model) {
	return A2(
		$author$project$Ui$Grid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$spanSm(7)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Refund type')
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$textMuted]),
						_List_fromArray(
							[
								$elm$html$Html$text('Do you want to issue a full or partial refund?')
							]))
					])),
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$spanSm(5),
						$author$project$Ui$Grid$justifyRight
					]),
				_List_fromArray(
					[
						$author$project$Ui$Button$group(
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Select partial refund'},
								_List_fromArray(
									[
										$author$project$Ui$Button$active(!model.gD),
										$author$project$Ui$Button$onClick(
										$author$project$Components$CustomerInvoice$ProcessRefundModal$ToggledRefundType(false)),
										$author$project$Ui$Button$disabled(
										$author$project$Components$CustomerInvoice$ProcessRefundModal$thereIsAtLeastOnePaymentWithPassthroughFees(model.Zi))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Partial refund')
									])),
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Select full refund'},
								_List_fromArray(
									[
										$author$project$Ui$Button$active(model.gD),
										$author$project$Ui$Button$onClick(
										$author$project$Components$CustomerInvoice$ProcessRefundModal$ToggledRefundType(true))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Full refund')
									]))
							]))
					]))
			]));
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$viewRefundBody = F3(
	function (model, refundStatus, notRefunded) {
		return notRefunded ? _List_fromArray(
			[
				(refundStatus === 'failed') ? $author$project$Components$CustomerInvoice$ProcessRefundModal$viewRefundFailedMessage(model) : $author$project$Utils$Html$empty,
				$author$project$Components$CustomerInvoice$ProcessRefundModal$viewRefundType(model),
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				$author$project$Components$CustomerInvoice$ProcessRefundModal$viewRefundMethod(model),
				$author$project$Components$CustomerInvoice$ProcessRefundModal$viewRefundAlertMessage(model),
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				model.gD ? A2(
				$author$project$Components$CustomerInvoice$ProcessRefundModal$viewFullRefundSection,
				model,
				$author$project$Utils$Form$fields(model.SD)) : $author$project$Components$CustomerInvoice$ProcessRefundModal$viewPartialRefundSection(model)
			]) : _List_fromArray(
			[
				$author$project$Components$CustomerInvoice$ProcessRefundModal$viewRefundConfirmation(model)
			]);
	});
var $author$project$Components$CustomerInvoice$ProcessRefundModal$view = function (model) {
	var _v0 = model.m$;
	if (!_v0.$) {
		var createPaymentModal = _v0.a;
		return A2(
			$elm$html$Html$map,
			$author$project$Components$CustomerInvoice$ProcessRefundModal$CreatePaymentModalMsg,
			$author$project$Components$Invoice$CreatePaymentModal$view(createPaymentModal));
	} else {
		var refundStatus = function () {
			var _v1 = model.e$;
			switch (_v1.$) {
				case 3:
					var refund_ = _v1.a;
					return $author$project$Api$Provider$Refund$One$status(refund_);
				case 2:
					return 'failed';
				default:
					return '';
			}
		}();
		var notRefunded = ((refundStatus !== 'successful') && (refundStatus !== 'waiting_for_processor')) || _Utils_eq(model.e$, $author$project$Api$Data$NotAsked);
		return A2(
			$author$project$Ui$Form$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$noValidate(true),
					$author$project$Ui$Form$autocomplete(false),
					$author$project$Ui$Form$onSubmit($author$project$Components$CustomerInvoice$ProcessRefundModal$Submit)
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Modal$view,
					$author$project$Components$CustomerInvoice$ProcessRefundModal$Close,
					_List_fromArray(
						[$author$project$Ui$Modal$lg]),
					_List_fromArray(
						[
							$author$project$Ui$Modal$header(
							_List_fromArray(
								[
									$author$project$Ui$Modal$title('Process Refund')
								])),
							$author$project$Ui$Modal$body(
							A3($author$project$Components$CustomerInvoice$ProcessRefundModal$viewRefundBody, model, refundStatus, notRefunded)),
							$author$project$Ui$Modal$footer(
							A2($author$project$Components$CustomerInvoice$ProcessRefundModal$viewFooter, model, notRefunded))
						]))
				]));
	}
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$AddNewClicked = {$: 1};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$SaveScheduledPaymentsClicked = {$: 9};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$sumScheduledPaymentsAmountInCents = function (scheduledPaymentsForm) {
	return $elm$core$List$sum(
		A2(
			$elm$core$List$map,
			function (scheduledPayment) {
				return scheduledPayment.$v ? 0 : ((!_Utils_eq(
					$author$project$Components$Invoice$CreateScheduledPaymentModal$existingPayment(scheduledPayment),
					$elm$core$Maybe$Nothing)) ? 0 : A2(
					$elm$core$Maybe$withDefault,
					0,
					A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, scheduledPayment.LE)));
			},
			scheduledPaymentsForm));
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$sumScheduledPaymentsPassthroughFeesInCents = function (scheduledPaymentsForm) {
	return $elm$core$List$sum(
		A2(
			$elm$core$List$map,
			function (scheduledPayment) {
				return scheduledPayment.$v ? 0 : ((!_Utils_eq(
					$author$project$Components$Invoice$CreateScheduledPaymentModal$existingPayment(scheduledPayment),
					$elm$core$Maybe$Nothing)) ? 0 : A2($elm$core$Maybe$withDefault, 0, scheduledPayment.YW));
			},
			scheduledPaymentsForm));
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$viewErrorBox = F3(
	function (fields, scheduledAmountInCents, amountInCentsString) {
		var hasCombinationErrors = $author$project$Components$Invoice$CreateScheduledPaymentModal$hasScheduledOnPaymentSourceCombinedErrors(fields);
		var errorHtml = function () {
			var _v0 = _Utils_Tuple2(
				_Utils_cmp(scheduledAmountInCents, fields.j$) > 0,
				hasCombinationErrors);
			if (_v0.a) {
				return _List_fromArray(
					[
						$elm$html$Html$text('The total scheduled payments amount '),
						$elm$html$Html$text(amountInCentsString),
						$elm$html$Html$text(' exceeds the total amount due '),
						$elm$html$Html$text(
						$author$project$Utils$Currency$fromInt(fields.j$)),
						$elm$html$Html$text('. Please adjust one of the payments to a lower amount.')
					]);
			} else {
				if (_v0.b) {
					return _List_fromArray(
						[
							$elm$html$Html$text(' '),
							$elm$html$Html$text('The same source can not be used for more than single scheduled payment per day.'),
							$elm$html$Html$text(' ')
						]);
				} else {
					return _List_Nil;
				}
			}
		}();
		return $elm$core$List$isEmpty(errorHtml) ? $author$project$Utils$Html$empty : A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mb2]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Alert$view,
					3,
					_List_fromArray(
						[
							$author$project$Ui$Alert$icon(61),
							$author$project$Ui$Alert$alignment($author$project$Ui$Alignment$textLeft)
						]),
					_List_fromArray(
						[
							A2($author$project$Ui$Element$prose, _List_Nil, errorHtml)
						]))
				]));
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$viewProcessedPayment = F2(
	function (timeFormatter, scheduledPayment) {
		var humanStatus = function () {
			var _v5 = $author$project$Api$Provider$ScheduledPayment$Shared$payment(scheduledPayment);
			if (!_v5.$) {
				var payment_ = _v5.a;
				return $author$project$Api$Provider$Payment$One$status(payment_);
			} else {
				return $author$project$Api$Provider$ScheduledPayment$Shared$status(scheduledPayment);
			}
		}();
		var _v0 = function () {
			var _v1 = $author$project$Api$Provider$ScheduledPayment$Shared$paymentSource(scheduledPayment);
			if (!_v1.$) {
				var source = _v1.a;
				return _Utils_Tuple2(
					$elm$html$Html$text('on '),
					A2(
						$author$project$Components$PaymentSourceDisplayer$view,
						timeFormatter,
						_List_fromArray(
							[
								$author$project$Components$PaymentSourceDisplayer$source(
								$elm$core$Maybe$Just(
									$author$project$Api$Source$Source(source))),
								$author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus(true),
								$author$project$Components$PaymentSourceDisplayer$limitedView(true)
							])));
			} else {
				return _Utils_Tuple2(
					$elm$html$Html$text('No payment info'),
					$author$project$Utils$Html$empty);
			}
		}();
		var paymentInfoText = _v0.a;
		var paymentInfoHtml = _v0.b;
		return A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$span(4),
							$author$project$Ui$Grid$justifyLeft
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$text,
							_List_Nil,
							A2(
								$author$project$Formatters$Date$toString,
								$author$project$Formatters$Date$Full,
								$author$project$Api$Provider$ScheduledPayment$Shared$scheduledOn(scheduledPayment)))
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$span(4),
							$author$project$Ui$Grid$justifyCenter
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$Ui$Badge$fromString, _List_Nil, humanStatus),
									$elm$html$Html$text(' '),
									paymentInfoText,
									paymentInfoHtml,
									function () {
									var _v2 = $author$project$Api$Provider$ScheduledPayment$Shared$memo(scheduledPayment);
									if (!_v2.$) {
										var memo = _v2.a;
										return A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[
													$author$project$Ui$Typography$phi(true)
												]),
											' - ' + memo);
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								])),
							function () {
							var _v3 = $author$project$Api$Provider$ScheduledPayment$Shared$payment(scheduledPayment);
							if (!_v3.$) {
								var payment = _v3.a;
								return A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											'Created by ' + (A2(
												$elm$core$Maybe$withDefault,
												'this platform',
												A2(
													$elm$core$Maybe$map,
													$author$project$Api$Provider$Payment$Creator$displayName,
													$author$project$Api$Provider$Payment$One$createdBy(payment))) + (' on ' + A2(
												timeFormatter,
												0,
												$author$project$Api$Provider$Payment$One$createdAt(payment)))))
										]));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$span(4),
							$author$project$Ui$Grid$justifyRight
						]),
					function () {
						var _v4 = $author$project$Api$Provider$ScheduledPayment$Shared$payment(scheduledPayment);
						if (!_v4.$) {
							var payment = _v4.a;
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$justifyRight]),
									_List_fromArray(
										[
											_Utils_eq(
											$author$project$Api$Provider$Payment$One$attemptedInCents(payment),
											$author$project$Api$Provider$Payment$One$amountInCents(payment)) ? $author$project$Utils$Html$empty : A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$strike]),
											$author$project$Utils$Currency$fromInt(
												$author$project$Api$Provider$Payment$One$attemptedInCents(payment))),
											A2(
											$author$project$Ui$Typography$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Utils$Currency$fromInt(
														$author$project$Api$Provider$Payment$One$amountInCents(payment)))
												]))
										]))
								]);
						} else {
							return _List_fromArray(
								[$author$project$Utils$Html$empty]);
						}
					}())
				]));
	});
var $author$project$Ui$Table$rowspan = $author$project$Ui$Table$Rowspan;
var $author$project$Components$Invoice$CreateScheduledPaymentModal$AmountInCentsBlur = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$AmountInCentsFieldUpdated = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$FormUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$viewAmount = F2(
	function (scheduledPayment, form) {
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Form$CurrencyInput$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$CurrencyInput$value(scheduledPayment.LE),
							$author$project$Ui$Form$CurrencyInput$disabled(
							$author$project$Components$Invoice$CreateScheduledPaymentModal$isScheduledPaymentDisabled(scheduledPayment)),
							$author$project$Ui$Form$CurrencyInput$onInput(
							A2(
								$elm$core$Basics$composeL,
								$author$project$Components$Invoice$CreateScheduledPaymentModal$FormUpdated,
								$author$project$Components$Invoice$CreateScheduledPaymentModal$AmountInCentsFieldUpdated(scheduledPayment.sG))),
							$author$project$Ui$Form$CurrencyInput$onBlur(
							$author$project$Components$Invoice$CreateScheduledPaymentModal$AmountInCentsBlur(scheduledPayment.sG)),
							$author$project$Ui$Form$CurrencyInput$invalid(
							A2(
								$author$project$Utils$Form$hasValidationErrors,
								$author$project$Components$Invoice$CreateScheduledPaymentModal$AmountInCentsValidation(scheduledPayment.sG),
								form)),
							$author$project$Ui$Form$CurrencyInput$errors(
							A2(
								$author$project$Utils$Form$validationErrors,
								$author$project$Components$Invoice$CreateScheduledPaymentModal$AmountInCentsValidation(scheduledPayment.sG),
								form))
						]))
				]));
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$DeleteFieldUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$viewDestroy = function (scheduledPayment) {
	return $author$project$Components$Invoice$CreateScheduledPaymentModal$isScheduledPaymentDisabled(scheduledPayment) ? $author$project$Utils$Html$empty : A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$textCenter]),
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Remove scheduled payment'},
				_List_fromArray(
					[
						$author$project$Ui$Button$link,
						$author$project$Ui$Button$sm,
						$author$project$Ui$Button$onClick(
						$author$project$Components$Invoice$CreateScheduledPaymentModal$FormUpdated(
							$author$project$Components$Invoice$CreateScheduledPaymentModal$DeleteFieldUpdated(scheduledPayment.sG))),
						$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
					]),
				_List_Nil)
			]));
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$MemoFieldUpdated = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$viewMemo = function (scheduledPayment) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$value(
						A2($elm$core$Maybe$withDefault, '', scheduledPayment.aiG)),
						$author$project$Ui$Form$Input$disabled(
						$author$project$Components$Invoice$CreateScheduledPaymentModal$isScheduledPaymentDisabled(scheduledPayment)),
						$author$project$Ui$Form$Input$placeholder('Additional notes about this payment'),
						$author$project$Ui$Form$Input$onInput(
						A2(
							$elm$core$Basics$composeL,
							$author$project$Components$Invoice$CreateScheduledPaymentModal$FormUpdated,
							$author$project$Components$Invoice$CreateScheduledPaymentModal$MemoFieldUpdated(scheduledPayment.sG)))
					]))
			]));
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$PaymentSourceSearchChanged = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$PaymentSourceSelected = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$paymentSourceSelectName = function (source_) {
	var _v0 = A2(
		$elm$core$Maybe$andThen,
		$author$project$Utils$String$toMaybe,
		$author$project$Api$Source$name(source_));
	if (!_v0.$) {
		var label = _v0.a;
		return $elm$core$Maybe$Just(label);
	} else {
		return $author$project$Api$Source$type_(source_);
	}
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$paymentSourceSelectLabel = function (source) {
	return A2(
		$elm$core$String$join,
		' ',
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$map,
					$author$project$Formatters$String$titleize,
					$author$project$Components$Invoice$CreateScheduledPaymentModal$paymentSourceSelectName(source)),
					A2(
					$elm$core$Maybe$map,
					function (lastFour) {
						return ' * ' + lastFour;
					},
					$author$project$Api$Source$lastFour(source)),
					A2(
					$elm$core$Maybe$map,
					function (funding) {
						return ' (' + (funding + ')');
					},
					$author$project$Api$Source$funding(source))
				])));
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$viewPaymentSourceSelect = function (source) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					function () {
					var _v0 = $author$project$Components$Invoice$CreateScheduledPaymentModal$paymentSourceSelectName(source);
					if (!_v0.$) {
						var name = _v0.a;
						return A2(
							$elm$html$Html$strong,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('inline')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Formatters$String$titleize(name))
										]))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					$author$project$Utils$Html$noBreakSpace,
					function () {
					var _v1 = $author$project$Api$Source$lastFour(source);
					if (!_v1.$) {
						var lastFour = _v1.a;
						return A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[
									$author$project$Ui$Typography$phi(true)
								]),
							'*' + lastFour);
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					$author$project$Utils$Html$noBreakSpace,
					function () {
					var _v2 = $author$project$Api$Source$funding(source);
					if (!_v2.$) {
						var funding = _v2.a;
						return A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[
									$author$project$Ui$Typography$phi(true)
								]),
							'(' + (funding + ')'));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					$author$project$Utils$Html$noBreakSpace,
					A2(
					$author$project$Ui$Badge$fromString,
					_List_Nil,
					A2(
						$elm$core$Maybe$withDefault,
						'N/A',
						$author$project$Api$Source$status(source))),
					$author$project$Utils$Html$noBreakSpace,
					function () {
					var _v3 = $author$project$Api$Source$label(source);
					if (!_v3.$) {
						var label = _v3.a;
						return A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$em,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-muted')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[
													$author$project$Ui$Typography$phi(true),
													$author$project$Ui$Typography$overflowWrap($author$project$Ui$OverflowWrap$breakWord)
												]),
											label)
										]))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]))
		]);
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$viewPaymentSource = F2(
	function (model, scheduledPayment) {
		return A4(
			$author$project$Ui$Dropdown$viewSelect,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$disabled(
					$author$project$Components$Invoice$CreateScheduledPaymentModal$isScheduledPaymentDisabled(scheduledPayment)),
					$author$project$Ui$Dropdown$invalid(
					A2(
						$author$project$Utils$Form$hasValidationErrors,
						$author$project$Components$Invoice$CreateScheduledPaymentModal$PaymentSourceValidation(scheduledPayment.sG),
						model.SD)),
					$author$project$Ui$Dropdown$errors(
					A2(
						$author$project$Utils$Form$validationErrors,
						$author$project$Components$Invoice$CreateScheduledPaymentModal$PaymentSourceValidation(scheduledPayment.sG),
						model.SD))
				]),
			function () {
				var _v0 = scheduledPayment.Zg;
				if (!_v0.$) {
					var source = _v0.a;
					return $author$project$Components$Invoice$CreateScheduledPaymentModal$viewPaymentSourceSelect(source);
				} else {
					return _List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[$author$project$Ui$Typography$muted]),
							'Select a Source')
						]);
				}
			}(),
			function () {
				if ($author$project$Components$Invoice$CreateScheduledPaymentModal$isScheduledPaymentDisabled(scheduledPayment)) {
					return _List_Nil;
				} else {
					var sources = $author$project$Components$Invoice$CreateScheduledPaymentModal$patientSources(model);
					var selectedSourceId = A2($elm$core$Maybe$map, $author$project$Api$Source$id, scheduledPayment.Zg);
					var query = $elm$core$String$toLower(scheduledPayment.o6);
					var isSelectedInList = A2(
						$elm$core$Maybe$withDefault,
						true,
						A2(
							$elm$core$Maybe$map,
							function (id) {
								return A2(
									$elm$core$List$any,
									function (s) {
										return _Utils_eq(
											$author$project$Api$Source$id(s),
											id);
									},
									sources);
							},
							selectedSourceId));
					var allSources = function () {
						var _v1 = _Utils_Tuple2(scheduledPayment.Zg, isSelectedInList);
						if ((!_v1.a.$) && (!_v1.b)) {
							var selectedSource = _v1.a.a;
							return A2($elm$core$List$cons, selectedSource, sources);
						} else {
							return sources;
						}
					}();
					return A2(
						$elm$core$List$cons,
						$author$project$Ui$Dropdown$input(
							_List_fromArray(
								[
									$author$project$Ui$Dropdown$onInput(
									$author$project$Components$Invoice$CreateScheduledPaymentModal$PaymentSourceSearchChanged(scheduledPayment.sG)),
									$author$project$Ui$Dropdown$value(scheduledPayment.o6),
									$author$project$Ui$Dropdown$placeholder('Search...')
								])),
						A2(
							$elm$core$List$map,
							function (s) {
								return A2(
									$author$project$Ui$Dropdown$item,
									_List_fromArray(
										[
											$author$project$Ui$Dropdown$onSelect(
											A2(
												$author$project$Components$Invoice$CreateScheduledPaymentModal$PaymentSourceSelected,
												scheduledPayment.sG,
												$elm$core$Maybe$Just(s))),
											$author$project$Ui$Dropdown$selected(
											_Utils_eq(
												A2($elm$core$Maybe$map, $author$project$Api$Source$id, scheduledPayment.Zg),
												$elm$core$Maybe$Just(
													$author$project$Api$Source$id(s))))
										]),
									A2(
										$elm$html$Html$span,
										_List_Nil,
										$author$project$Components$Invoice$CreateScheduledPaymentModal$viewPaymentSourceSelect(s)));
							},
							A2(
								$elm$core$List$filter,
								function (s) {
									return $elm$core$String$isEmpty(query) || A2(
										$elm$core$String$contains,
										query,
										$elm$core$String$toLower(
											$author$project$Components$Invoice$CreateScheduledPaymentModal$paymentSourceSelectLabel(s)));
								},
								allSources)));
				}
			}(),
			scheduledPayment.o5);
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$viewScheduleOn = F2(
	function (model, scheduledPayment) {
		return A2(
			$elm$html$Html$map,
			A2($author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnSelected, scheduledPayment.sG, scheduledPayment.pS),
			A2(
				$author$project$Components$DateInput$view,
				_List_fromArray(
					[
						$author$project$Components$DateInput$value(scheduledPayment.ale),
						$author$project$Components$DateInput$disabled(
						$author$project$Components$Invoice$CreateScheduledPaymentModal$isScheduledPaymentDisabled(scheduledPayment)),
						$author$project$Components$DateInput$invalid(
						A2(
							$author$project$Utils$Form$hasValidationErrors,
							$author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnValidation(scheduledPayment.sG),
							model.SD)),
						$author$project$Components$DateInput$errors(
						A2(
							$author$project$Utils$Form$validationErrors,
							$author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnValidation(scheduledPayment.sG),
							model.SD)),
						$author$project$Components$DateInput$disabledPickerDates(
						function (date) {
							return A2($author$project$Utils$Date$isBefore, date, model.FR);
						})
					]),
				scheduledPayment.pS));
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$viewScheduledPayment = F2(
	function (scheduledPayment, model) {
		return scheduledPayment.$v ? _List_Nil : _List_fromArray(
			[
				A2(
				$author$project$Ui$Table$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Components$Invoice$CreateScheduledPaymentModal$viewScheduleOn, model, scheduledPayment)
							])),
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Components$Invoice$CreateScheduledPaymentModal$viewPaymentSource, model, scheduledPayment)
							])),
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Components$Invoice$CreateScheduledPaymentModal$viewAmount, scheduledPayment, model.SD)
							])),
						A2(
						$author$project$Ui$Table$cell,
						_List_fromArray(
							[
								$author$project$Ui$Table$colspan(5),
								$author$project$Ui$Table$alignCenter,
								$author$project$Ui$Table$rowspan(2)
							]),
						_List_fromArray(
							[
								$author$project$Components$Invoice$CreateScheduledPaymentModal$viewDestroy(scheduledPayment)
							]))
					])),
				A2(
				$author$project$Ui$Table$row,
				_List_fromArray(
					[$author$project$Ui$Table$noBorder]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$cell,
						_List_fromArray(
							[
								$author$project$Ui$Table$colspan(3)
							]),
						_List_fromArray(
							[
								$author$project$Components$Invoice$CreateScheduledPaymentModal$viewMemo(scheduledPayment)
							]))
					]))
			]);
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$viewScheduledPaymentsTable = F2(
	function (model, fields) {
		return A4(
			$author$project$Ui$Table$view,
			_List_fromArray(
				[
					$author$project$Ui$Table$loading(model.dp),
					$author$project$Ui$Table$containerClasses(
					_List_fromArray(
						['table-wrapper-overflow-visible']))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$header,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(4)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Date')
						])),
					A2(
					$author$project$Ui$Table$header,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(4)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Source')
						])),
					A2(
					$author$project$Ui$Table$header,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(4),
							$author$project$Ui$Table$textRight
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Amount')
						])),
					A2(
					$author$project$Ui$Table$header,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(1)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('')
						]))
				]),
			A2(
				$elm$core$List$concatMap,
				function (scheduledPayment) {
					var _v0 = _Utils_Tuple2(
						scheduledPayment.oN,
						$author$project$Components$Invoice$CreateScheduledPaymentModal$existingPayment(scheduledPayment));
					if ((!_v0.a.$) && (!_v0.b.$)) {
						var originalscheduledPayment_ = _v0.a.a;
						return _List_fromArray(
							[
								A2(
								$author$project$Ui$Table$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Table$cell,
										_List_fromArray(
											[
												$author$project$Ui$Table$colspan(3)
											]),
										_List_fromArray(
											[
												A2($author$project$Components$Invoice$CreateScheduledPaymentModal$viewProcessedPayment, model.J7, originalscheduledPayment_)
											]))
									]))
							]);
					} else {
						return A2($author$project$Components$Invoice$CreateScheduledPaymentModal$viewScheduledPayment, scheduledPayment, model);
					}
				},
				fields.i),
			_List_Nil);
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$viewWarningBox = F2(
	function (fields, amountInCentsString) {
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mb2]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Alert$view,
					2,
					_List_fromArray(
						[
							$author$project$Ui$Alert$icon(67)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('The total scheduled payments amount '),
							$elm$html$Html$text(amountInCentsString),
							$elm$html$Html$text(' is less than the total amount due '),
							$elm$html$Html$text(
							$author$project$Utils$Currency$fromInt(fields.j$)),
							$elm$html$Html$text('.')
						]))
				]));
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$view = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.SD);
	var _v1 = $author$project$Utils$Form$fields(model.SD);
	var scheduledPaymentsForm = _v1.i;
	var scheduledAmountInCents = $author$project$Components$Invoice$CreateScheduledPaymentModal$sumScheduledPaymentsAmountInCents(scheduledPaymentsForm);
	var amountInCentsString = $author$project$Currency$format(
		$author$project$Currency$fromInt(scheduledAmountInCents));
	var disableSaveButton = (!$author$project$Utils$Form$dirty(model.SD)) || ((_Utils_cmp(scheduledAmountInCents, fields.j$) > 0) || $author$project$Components$Invoice$CreateScheduledPaymentModal$hasScheduledOnPaymentSourceCombinedErrors(fields));
	var totalPassthroughFees = model.abh ? $author$project$Components$Invoice$CreateScheduledPaymentModal$sumScheduledPaymentsPassthroughFeesInCents(scheduledPaymentsForm) : 0;
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Invoice$CreateScheduledPaymentModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Scheduled Payment(s)')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$onSubmit($author$project$Components$Invoice$CreateScheduledPaymentModal$SaveScheduledPaymentsClicked)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$Components$Invoice$CreateScheduledPaymentModal$viewScheduledPaymentsTable, model, fields),
										((!(!scheduledAmountInCents)) && (_Utils_cmp(scheduledAmountInCents, fields.j$) < 0)) ? A2($author$project$Components$Invoice$CreateScheduledPaymentModal$viewWarningBox, fields, amountInCentsString) : $author$project$Utils$Html$empty,
										A3($author$project$Components$Invoice$CreateScheduledPaymentModal$viewErrorBox, fields, scheduledAmountInCents, amountInCentsString),
										A2(
										$author$project$Ui$Grid$row,
										_List_fromArray(
											[$author$project$Ui$Grid$rowItemsCenter, $author$project$Ui$Grid$mt2]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Grid$column,
												_List_fromArray(
													[
														$author$project$Ui$Grid$span(4)
													]),
												_List_fromArray(
													[
														A3(
														$author$project$Ui$Button$view,
														{mm: 'Add another payment'},
														_List_fromArray(
															[
																$author$project$Ui$Button$onClick($author$project$Components$Invoice$CreateScheduledPaymentModal$AddNewClicked)
															]),
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Typography$text,
																_List_fromArray(
																	[
																		$author$project$Ui$Typography$overflowWrap($author$project$Ui$OverflowWrap$breakWord),
																		$author$project$Ui$Typography$preWrap
																	]),
																'Add Another Payment')
															]))
													])),
												A2(
												$author$project$Ui$Grid$column,
												_List_fromArray(
													[
														$author$project$Ui$Grid$span(1)
													]),
												_List_fromArray(
													[$author$project$Utils$Html$empty])),
												A2(
												$author$project$Ui$Grid$column,
												_List_fromArray(
													[
														$author$project$Ui$Grid$span(7)
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Grid$row,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Grid$column,
																_List_fromArray(
																	[
																		$author$project$Ui$Grid$span(12)
																	]),
																_List_fromArray(
																	[
																		A2(
																		$author$project$Ui$Form$Group$view,
																		_List_fromArray(
																			[
																				$author$project$Ui$Form$Group$label('Total'),
																				$author$project$Ui$Form$Group$labelSpan(6),
																				$author$project$Ui$Form$Group$inputSpan(6)
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$author$project$Ui$Form$Static$view,
																				_List_Nil,
																				_List_fromArray(
																					[
																						A2(
																						$author$project$Ui$Typography$text,
																						_List_fromArray(
																							[$author$project$Ui$Typography$bold]),
																						amountInCentsString),
																						$elm$html$Html$text(' of '),
																						A2(
																						$author$project$Ui$Typography$text,
																						_List_fromArray(
																							[$author$project$Ui$Typography$bold]),
																						$author$project$Utils$Currency$fromInt(fields.j$)),
																						$elm$html$Html$text(' due')
																					]))
																			]))
																	]))
															])),
														A2(
														$author$project$Ui$Grid$row,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Grid$column,
																_List_fromArray(
																	[
																		$author$project$Ui$Grid$span(12)
																	]),
																_List_fromArray(
																	[
																		(totalPassthroughFees > 0) ? A2(
																		$author$project$Ui$Form$Group$view,
																		_List_fromArray(
																			[
																				$author$project$Ui$Form$Group$label('Total Credit Card Fees'),
																				$author$project$Ui$Form$Group$labelSpan(6),
																				$author$project$Ui$Form$Group$inputSpan(6)
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$author$project$Ui$Form$Static$view,
																				_List_Nil,
																				_List_fromArray(
																					[
																						A2(
																						$author$project$Ui$Typography$text,
																						_List_fromArray(
																							[$author$project$Ui$Typography$bold]),
																						$author$project$Utils$Currency$fromInt(totalPassthroughFees))
																					]))
																			])) : $author$project$Utils$Html$empty
																	]))
															]))
													]))
											]))
									]))
							])),
						$author$project$Utils$Html$empty
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Invoice$CreateScheduledPaymentModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Schedule paymnets'},
						_List_fromArray(
							[
								$author$project$Ui$Button$styled(3),
								$author$project$Ui$Button$loading(
								_Utils_eq(model.k9, $author$project$Api$Data$Loading)),
								$author$project$Ui$Button$onClick($author$project$Components$Invoice$CreateScheduledPaymentModal$SaveScheduledPaymentsClicked),
								$author$project$Ui$Button$disabled(disableSaveButton),
								$author$project$Ui$Button$icon($author$project$Ui$Icon$bolt)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(' Schedule Payments ')
							]))
					]))
			]));
};
var $author$project$Components$Patient$Charges$ChargeModal$SaveAndAddAnotherClicked = {$: 2};
var $author$project$Components$Patient$Charges$ChargeModal$SaveClicked = {$: 1};
var $author$project$Api$Provider$Charge$Meta$categoryEditable = function (_v0) {
	var meta = _v0;
	return meta.GW.Q4;
};
var $author$project$Components$Patient$Charges$ChargeModal$withDisabledTooltip = F2(
	function (disabled, contents) {
		return A3(
			$author$project$Ui$Tooltip$view,
			_List_fromArray(
				[
					$author$project$Ui$Tooltip$active(disabled)
				]),
			'To change the item, price, or quantity you must revise the invoice.',
			contents);
	});
var $author$project$Components$Patient$Charges$ChargeModal$viewCategoryFormGroup = F2(
	function (form, meta) {
		var canEdit = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$Meta$categoryEditable, meta));
		var _v0 = $author$project$Utils$Form$fields(form);
		var categoryResourceFilter = _v0.c8;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Category'),
					$author$project$Ui$Form$Group$labelSpan(3),
					$author$project$Ui$Form$Group$inputSpan(9)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Patient$Charges$ChargeModal$withDisabledTooltip,
					!canEdit,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Components$Patient$Charges$ChargeModal$CategoryResourceFilterMsg,
							A2(
								$author$project$Components$ResourceFilter$Category$view,
								_List_fromArray(
									[
										$author$project$Components$ResourceFilter$style(0),
										$author$project$Components$ResourceFilter$disabled(!canEdit)
									]),
								categoryResourceFilter))
						]))
				]));
	});
var $author$project$Api$Provider$Charge$Meta$nameEditable = function (_v0) {
	var meta = _v0;
	return meta.Bq.Q4;
};
var $author$project$Components$Patient$Charges$ChargeModal$viewChargeFormGroup = F2(
	function (form, meta) {
		var canEdit = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$Meta$nameEditable, meta));
		var _v0 = $author$project$Utils$Form$fields(form);
		var chargeItemResourceFilter = _v0.cq;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Item'),
					$author$project$Ui$Form$Group$required(canEdit),
					$author$project$Ui$Form$Group$labelSpan(3),
					$author$project$Ui$Form$Group$inputSpan(9)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Patient$Charges$ChargeModal$withDisabledTooltip,
					!canEdit,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Components$Patient$Charges$ChargeModal$ChargeItemResourceFilterMsg,
							A2(
								$author$project$Components$ResourceFilter$ChargeItem$view,
								_List_fromArray(
									[
										$author$project$Components$ResourceFilter$style(0),
										$author$project$Components$ResourceFilter$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
										$author$project$Components$ResourceFilter$errors(
										A2($author$project$Utils$Form$validationErrors, 1, form)),
										$author$project$Components$ResourceFilter$disabled(!canEdit)
									]),
								chargeItemResourceFilter))
						]))
				]));
	});
var $author$project$Api$Provider$Charge$Meta$dateEditable = function (_v0) {
	var meta = _v0;
	return meta.PB.Q4;
};
var $author$project$Api$Provider$Charge$Meta$endDateEditable = function (_v0) {
	var meta = _v0;
	return meta.sb.Q4;
};
var $author$project$Components$Patient$Charges$ChargeModal$isTimeBased = function (uom) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$eq('time'),
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Uom$Shared$unitClass, uom)));
};
var $author$project$Components$Patient$Charges$ChargeModal$viewDatesFormGroup = F2(
	function (form, meta) {
		var canEditDate = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$Meta$dateEditable, meta));
		var _v0 = $author$project$Utils$Form$fields(form);
		var startDate = _v0.ab7;
		var startDateInput = _v0.lx;
		var endDate = _v0.sb;
		var endDateInput = _v0.sd;
		var quantityUom = _v0.DA;
		var timeBased = $author$project$Components$Patient$Charges$ChargeModal$isTimeBased(quantityUom);
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label(
					timeBased ? 'Dates' : 'Date'),
					$author$project$Ui$Form$Group$labelSpan(3),
					$author$project$Ui$Form$Group$inputSpan(9),
					$author$project$Ui$Form$Group$required(true)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Components$Patient$Charges$ChargeModal$withDisabledTooltip,
									!canEditDate,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$map,
											$author$project$Components$Patient$Charges$ChargeModal$StartDateInputMsg(startDateInput),
											A2(
												$author$project$Components$DateInput$view,
												_List_fromArray(
													[
														$author$project$Components$DateInput$value(startDate),
														$author$project$Components$DateInput$invalid(
														A2($author$project$Utils$Form$hasValidationErrors, 4, form)),
														$author$project$Components$DateInput$errors(
														A2($author$project$Utils$Form$validationErrors, 4, form)),
														$author$project$Components$DateInput$disabled(!canEditDate)
													]),
												startDateInput))
										]))
								])),
							function () {
							if (timeBased) {
								var canEditEndDate = A2(
									$elm$core$Maybe$withDefault,
									true,
									A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$Meta$endDateEditable, meta));
								return A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(6)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Components$Patient$Charges$ChargeModal$withDisabledTooltip,
											!canEditEndDate,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$map,
													$author$project$Components$Patient$Charges$ChargeModal$EndDateInputMsg(endDateInput),
													A2(
														$author$project$Components$DateInput$view,
														_List_fromArray(
															[
																$author$project$Components$DateInput$value(endDate),
																$author$project$Components$DateInput$disabled(!canEditEndDate)
															]),
														endDateInput))
												]))
										]));
							} else {
								return $author$project$Ui$Grid$none;
							}
						}()
						]))
				]));
	});
var $author$project$Components$Patient$Charges$ChargeModal$Description = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Patient$Charges$ChargeModal$FormUpdated = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Provider$Charge$Meta$descriptionEditable = function (_v0) {
	var meta = _v0;
	return meta.Qr.Q4;
};
var $author$project$Components$Patient$Charges$ChargeModal$viewDescriptionFormGroup = F2(
	function (form, meta) {
		var canEdit = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$Meta$descriptionEditable, meta));
		var _v0 = $author$project$Utils$Form$fields(form);
		var description = _v0.Qr;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Description'),
					$author$project$Ui$Form$Group$labelSpan(3),
					$author$project$Ui$Form$Group$inputSpan(9)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Patient$Charges$ChargeModal$withDisabledTooltip,
					!canEdit,
					_List_fromArray(
						[
							$author$project$Ui$Form$Textarea$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Textarea$value(description),
									$author$project$Ui$Form$Textarea$placeholder('e.g. Examination'),
									$author$project$Ui$Form$Textarea$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$Patient$Charges$ChargeModal$FormUpdated, $author$project$Components$Patient$Charges$ChargeModal$Description)),
									$author$project$Ui$Form$Textarea$disabled(!canEdit)
								]))
						]))
				]));
	});
var $author$project$Api$Provider$Charge$Meta$locationEditable = function (_v0) {
	var meta = _v0;
	return meta.ais.Q4;
};
var $author$project$Components$Patient$Charges$ChargeModal$viewLocationFormGroup = F2(
	function (form, meta) {
		var canEdit = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$Meta$locationEditable, meta));
		var _v0 = $author$project$Utils$Form$fields(form);
		var locationResourceFilter = _v0.os;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Location'),
					$author$project$Ui$Form$Group$labelSpan(3),
					$author$project$Ui$Form$Group$inputSpan(9)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Patient$Charges$ChargeModal$withDisabledTooltip,
					!canEdit,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Components$Patient$Charges$ChargeModal$LocationResourceFilterMsg,
							A2(
								$author$project$Components$ResourceFilter$Location$view,
								_List_fromArray(
									[
										$author$project$Components$ResourceFilter$style(0),
										$author$project$Components$ResourceFilter$disabled(!canEdit)
									]),
								locationResourceFilter))
						]))
				]));
	});
var $author$project$Api$Provider$Charge$Meta$patientEditable = function (_v0) {
	var meta = _v0;
	return meta.YY.Q4;
};
var $author$project$Components$Patient$Charges$ChargeModal$viewPatientFormGroup = F2(
	function (form, meta) {
		var canEdit = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$Meta$patientEditable, meta));
		var _v0 = $author$project$Utils$Form$fields(form);
		var limitedPatientSelector = _v0.oj;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Patient'),
					$author$project$Ui$Form$Group$labelSpan(3),
					$author$project$Ui$Form$Group$inputSpan(9)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Patient$Charges$ChargeModal$withDisabledTooltip,
					!canEdit,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Components$Patient$Charges$ChargeModal$LimitedPatientSelectorMsg,
							A2(
								$author$project$Components$LimitedPatientSelector$view,
								_List_fromArray(
									[
										$author$project$Components$LimitedPatientSelector$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
										$author$project$Components$LimitedPatientSelector$errors(
										A2($author$project$Utils$Form$validationErrors, 0, form))
									]),
								limitedPatientSelector))
						]))
				]));
	});
var $author$project$Components$Patient$Charges$ChargeModal$DiscountOverridden = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Patient$Charges$ChargeModal$viewPriceFormGroup = F2(
	function (model, meta) {
		var _v0 = $author$project$Utils$Form$fields(model.SD);
		var priceInCents = _v0.Dw;
		var quantityUom = _v0.DA;
		var priceUom = _v0._h;
		var discountOverridden = _v0.QE;
		var chargeItem = _v0.mL;
		var chargeItemPriceEditable = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeL,
					$elm$core$Basics$not,
					function ($) {
						return $.aid;
					}),
				chargeItem));
		var priceEditableByChargeItem = A2(
			$elm$core$Maybe$withDefault,
			chargeItemPriceEditable,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$Meta$priceInCentsEditable, meta));
		var canEdit = priceEditableByChargeItem;
		var discountNotRemoved = function () {
			var _v4 = $author$project$Api$Data$toMaybe(model.akd);
			if (!_v4.$) {
				var preview = _v4.a;
				return (!discountOverridden) && (!(!$author$project$Api$Provider$Charge$Calculate$discountInCents(preview)));
			} else {
				return false;
			}
		}();
		var timeBased = $author$project$Components$Patient$Charges$ChargeModal$isTimeBased(quantityUom);
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Price'),
					$author$project$Ui$Form$Group$required(canEdit),
					$author$project$Ui$Form$Group$labelSpan(3),
					$author$project$Ui$Form$Group$inputSpan(9)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Components$Patient$Charges$ChargeModal$withDisabledTooltip,
									!canEdit,
									_List_fromArray(
										[
											$author$project$Ui$Form$CurrencyInput$view(
											_Utils_ap(
												function () {
													var _v1 = _Utils_Tuple2(
														timeBased,
														A2(
															$elm$core$Maybe$map,
															$elm$core$String$toLower,
															A2($elm$core$Maybe$map, $author$project$Api$Provider$Uom$Shared$name, priceUom)));
													if (_v1.a && (!_v1.b.$)) {
														var name = _v1.b.a;
														return _List_fromArray(
															[
																$author$project$Ui$Form$CurrencyInput$postfix('per ' + name)
															]);
													} else {
														return _List_Nil;
													}
												}(),
												_List_fromArray(
													[
														$author$project$Ui$Form$CurrencyInput$value(priceInCents),
														$author$project$Ui$Form$CurrencyInput$placeholder('e.g. 50.00'),
														$author$project$Ui$Form$CurrencyInput$onInput(
														A2($elm$core$Basics$composeL, $author$project$Components$Patient$Charges$ChargeModal$FormUpdated, $author$project$Components$Patient$Charges$ChargeModal$PriceInCents)),
														$author$project$Ui$Form$CurrencyInput$invalid(
														A2($author$project$Utils$Form$hasValidationErrors, 3, model.SD)),
														$author$project$Ui$Form$CurrencyInput$disabled((!canEdit) || discountNotRemoved)
													]))),
											$author$project$Utils$FormErrors$view(
											A2($author$project$Utils$Form$validationErrors, 3, model.SD)),
											function () {
											if (discountNotRemoved) {
												var hasPrepaidDiscount = function () {
													var _v3 = $author$project$Api$Data$toMaybe(model.akd);
													if (!_v3.$) {
														var preview = _v3.a;
														return $author$project$Api$Provider$Charge$Calculate$prepaidAllocatedQuantity(preview) > 0;
													} else {
														return false;
													}
												}();
												var hasMembershipDiscount = function () {
													var _v2 = $author$project$Api$Data$toMaybe(model.akd);
													if (!_v2.$) {
														var preview = _v2.a;
														return !$elm$core$List$isEmpty(
															$author$project$Api$Provider$Charge$Calculate$coveredCharges(preview));
													} else {
														return false;
													}
												}();
												var removeRuleLabel = (hasPrepaidDiscount && (!hasMembershipDiscount)) ? 'Remove package rule' : 'Remove membership rule';
												return A2(
													$author$project$Ui$Form$Static$view,
													_List_Nil,
													_List_fromArray(
														[
															A3(
															$author$project$Ui$Button$view,
															{mm: removeRuleLabel},
															_List_fromArray(
																[
																	$author$project$Ui$Button$onClick(
																	$author$project$Components$Patient$Charges$ChargeModal$FormUpdated(
																		$author$project$Components$Patient$Charges$ChargeModal$DiscountOverridden(true)))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(removeRuleLabel)
																]))
														]));
											} else {
												return $author$project$Utils$Html$empty;
											}
										}()
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$textLeft]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Amounts can be negative')
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Api$Provider$Charge$Meta$practitionerEditable = function (_v0) {
	var meta = _v0;
	return meta.aka.Q4;
};
var $author$project$Components$Patient$Charges$ChargeModal$viewProviderFormGroup = F2(
	function (form, meta) {
		var canEdit = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$Meta$practitionerEditable, meta));
		var _v0 = $author$project$Utils$Form$fields(form);
		var practitionerResourceFilter = _v0.hk;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Provider'),
					$author$project$Ui$Form$Group$labelSpan(3),
					$author$project$Ui$Form$Group$inputSpan(9)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Patient$Charges$ChargeModal$withDisabledTooltip,
					!canEdit,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Components$Patient$Charges$ChargeModal$PractitionerResourceFilterMsg,
							A2(
								$author$project$Components$ResourceFilter$Practitioner$view,
								_List_fromArray(
									[
										$author$project$Components$ResourceFilter$style(0),
										$author$project$Components$ResourceFilter$disabled(!canEdit)
									]),
								practitionerResourceFilter))
						]))
				]));
	});
var $author$project$Components$Patient$Charges$ChargeModal$Quantity = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Patient$Charges$ChargeModal$QuantityUom = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$Charge$Meta$quantityEditable = function (_v0) {
	var meta = _v0;
	return meta.Dz.Q4;
};
var $author$project$Api$Provider$Charge$Meta$quantityUomEditable = function (_v0) {
	var meta = _v0;
	return meta.DA.Q4;
};
var $author$project$Components$Patient$Charges$ChargeModal$uomOptions = A2(
	$elm$core$List$map,
	function (uom_) {
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(
				$author$project$Api$Provider$Uom$Shared$code(uom_)),
			$author$project$Api$Provider$Uom$Shared$name(uom_));
	},
	$author$project$Api$Provider$Uom$list(
		function (d) {
			return _Utils_update(
				d,
				{
					Kg: $elm$core$Maybe$Just('time')
				});
		}));
var $author$project$Components$Patient$Charges$ChargeModal$viewQuantityFormGroup = F2(
	function (form, meta) {
		var canEditQuantity = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$Meta$quantityEditable, meta));
		var _v0 = $author$project$Utils$Form$fields(form);
		var quantity = _v0.Dz;
		var quantityUom = _v0.DA;
		var chargeItem = _v0.mL;
		var timeBased = $author$project$Components$Patient$Charges$ChargeModal$isTimeBased(quantityUom);
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('QTY'),
					$author$project$Ui$Form$Group$labelSpan(3),
					$author$project$Ui$Form$Group$inputSpan(9),
					$author$project$Ui$Form$Group$required(canEditQuantity)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Components$Patient$Charges$ChargeModal$withDisabledTooltip,
									!canEditQuantity,
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$number,
													$author$project$Ui$Form$Input$value(
													A2(
														$elm$core$Maybe$withDefault,
														'',
														A2($elm$core$Maybe$map, $elm$core$String$fromInt, quantity))),
													$author$project$Ui$Form$Input$onInput(
													A2($elm$core$Basics$composeL, $author$project$Components$Patient$Charges$ChargeModal$FormUpdated, $author$project$Components$Patient$Charges$ChargeModal$Quantity)),
													$author$project$Ui$Form$Input$invalid(
													A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
													$author$project$Ui$Form$Input$errors(
													A2($author$project$Utils$Form$validationErrors, 2, form)),
													$author$project$Ui$Form$Input$disabled(!canEditQuantity)
												]))
										]))
								])),
							function () {
							if (timeBased) {
								var canEditQuantityUom = A2(
									$elm$core$Maybe$withDefault,
									true,
									A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$Meta$quantityUomEditable, meta));
								return A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(6)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Components$Patient$Charges$ChargeModal$withDisabledTooltip,
											!canEditQuantityUom,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Form$Select$view,
													_List_fromArray(
														[
															$author$project$Ui$Form$Select$value(
															A2($elm$core$Maybe$map, $author$project$Api$Provider$Uom$Shared$code, quantityUom)),
															$author$project$Ui$Form$Select$onChange(
															A2($elm$core$Basics$composeL, $author$project$Components$Patient$Charges$ChargeModal$FormUpdated, $author$project$Components$Patient$Charges$ChargeModal$QuantityUom)),
															$author$project$Ui$Form$Select$disabled(!canEditQuantityUom)
														]),
													$author$project$Components$Patient$Charges$ChargeModal$uomOptions)
												]))
										]));
							} else {
								return $author$project$Ui$Grid$none;
							}
						}()
						])),
					A2(
					$author$project$Components$InventoryWarning$view,
					A2(
						$elm$core$Maybe$map,
						function (item) {
							return {Lm: item.Lm, _P: item._P, ads: item.ads};
						},
						chargeItem),
					quantity)
				]));
	});
var $author$project$Components$Patient$Charges$ChargeModal$ToggleAdditionalDetails = {$: 17};
var $author$project$Components$Patient$Charges$ChargeModal$viewShowAdditionalDetails = function (showAdditionalDetails) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label(''),
				$author$project$Ui$Form$Group$labelSpan(3),
				$author$project$Ui$Form$Group$inputSpan(9)
			]),
		_List_fromArray(
			[
				function () {
				var _v0 = showAdditionalDetails ? _Utils_Tuple2(
					'Hide additional charge details',
					$author$project$Ui$Icon$chevron(
						_List_fromArray(
							[$author$project$Ui$Icon$rotate180]))) : _Utils_Tuple2(
					'See additional charge details',
					$author$project$Ui$Icon$chevronDown(_List_Nil));
				var label = _v0.a;
				var icon = _v0.b;
				return A3(
					$author$project$Ui$Button$view,
					{mm: label},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$sm,
							$author$project$Ui$Button$onClick($author$project$Components$Patient$Charges$ChargeModal$ToggleAdditionalDetails)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label),
							$author$project$Utils$Html$noBreakSpace,
							icon
						]));
			}()
			]));
};
var $author$project$Components$Patient$Charges$ChargeModal$viewDiscount = F3(
	function (_v0, meta, preview) {
		var form = _v0.SD;
		var canEdit = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$Meta$priceInCentsEditable, meta));
		var _v1 = $author$project$Utils$Form$fields(form);
		var discountOverridden = _v1.QE;
		var chargeItem = _v1.mL;
		var discountRemoved = discountOverridden && (!$author$project$Api$Provider$Charge$Calculate$discountInCents(preview));
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					function () {
					if (!$elm$core$List$isEmpty(
						$author$project$Api$Provider$Charge$Calculate$coveredCharges(preview))) {
						var totalWithoutLabel = ($author$project$Api$Provider$Charge$Calculate$prepaidAllocatedQuantity(preview) > 0) ? 'Total without package: ' : 'Total without membership: ';
						return A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(totalWithoutLabel),
									$author$project$Components$Invoice$ChargeDiscount$view(preview)
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					discountRemoved ? A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Membership rule was removed')
						])) : $author$project$Utils$Html$empty,
					(canEdit && (discountRemoved && $author$project$Utils$Maybe$toBool(chargeItem))) ? A3(
					$author$project$Ui$Button$view,
					{mm: 'Revert to original'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$onClick(
							$author$project$Components$Patient$Charges$ChargeModal$FormUpdated(
								$author$project$Components$Patient$Charges$ChargeModal$DiscountOverridden(false)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Revert to original')
						])) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$Patient$Charges$ChargeModal$viewTotalFormGroup = F2(
	function (model, meta) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Total'),
					$author$project$Ui$Form$Group$labelSpan(3),
					$author$project$Ui$Form$Group$inputSpan(9)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					function () {
						var _v0 = _Utils_Tuple2(model.xM, model.akd);
						if (!_v0.a) {
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Ui$Typography$headingSm(
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Utils$Currency$fromInt(
														A2(
															$elm$core$Maybe$withDefault,
															0,
															A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$One$subtotalInCents, model.afx))))
												]))
										]))
								]);
						} else {
							switch (_v0.b.$) {
								case 3:
									var _v1 = _v0.b;
									var preview = _v1.a;
									var total = $author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$Charge$Calculate$subtotalInCents(preview));
									var routingWarning = A2(
										$elm$core$Maybe$withDefault,
										$elm$html$Html$text(''),
										A2($author$project$Components$ChargeRoutingWarning$viewWithChargeCalculate, 0, preview));
									var discountInfo = A3($author$project$Components$Patient$Charges$ChargeModal$viewDiscount, model, meta, preview);
									return _List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_Nil,
											_List_fromArray(
												[
													$author$project$Ui$Typography$headingSm(
													_List_fromArray(
														[
															$elm$html$Html$text(total)
														]))
												])),
											discountInfo,
											routingWarning
										]);
								case 1:
									var _v2 = _v0.b;
									return _List_fromArray(
										[
											$author$project$Ui$Spinner$view(
											_List_fromArray(
												[$author$project$Ui$Spinner$small]))
										]);
								default:
									return _List_fromArray(
										[
											$elm$html$Html$text('N/A')
										]);
							}
						}
					}())
				]));
	});
var $author$project$Components$Patient$Charges$ChargeModal$viewFormGroups = function (model) {
	var meta = A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$One$meta, model.afx);
	var form = model.SD;
	var basicFormGroups = _List_fromArray(
		[
			A2($author$project$Components$Patient$Charges$ChargeModal$viewPatientFormGroup, form, meta),
			A2($author$project$Components$Patient$Charges$ChargeModal$viewChargeFormGroup, form, meta),
			A2($author$project$Components$Patient$Charges$ChargeModal$viewQuantityFormGroup, form, meta),
			A2($author$project$Components$Patient$Charges$ChargeModal$viewPriceFormGroup, model, meta),
			A2($author$project$Components$Patient$Charges$ChargeModal$viewTotalFormGroup, model, meta),
			$author$project$Components$Patient$Charges$ChargeModal$viewShowAdditionalDetails(model.hD)
		]);
	var additionalFormGroups = model.hD ? _List_fromArray(
		[
			A2($author$project$Components$Patient$Charges$ChargeModal$viewCategoryFormGroup, form, meta),
			A2($author$project$Components$Patient$Charges$ChargeModal$viewDescriptionFormGroup, form, meta),
			A2($author$project$Components$Patient$Charges$ChargeModal$viewDatesFormGroup, form, meta),
			A2($author$project$Components$Patient$Charges$ChargeModal$viewProviderFormGroup, form, meta),
			A2($author$project$Components$Patient$Charges$ChargeModal$viewLocationFormGroup, form, meta)
		]) : _List_Nil;
	return $elm$core$List$concat(
		_List_fromArray(
			[basicFormGroups, additionalFormGroups]));
};
var $author$project$Components$Patient$Charges$ChargeModal$viewBody = function (model) {
	return A2(
		$author$project$Ui$Form$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$onSubmit($author$project$Components$Patient$Charges$ChargeModal$SaveClicked)
			]),
		$author$project$Components$Patient$Charges$ChargeModal$viewFormGroups(model));
};
var $author$project$Components$Patient$Charges$ChargeModal$view = function (model) {
	var previewLoading = _Utils_eq(model.akd, $author$project$Api$Data$Loading);
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Patient$Charges$ChargeModal$CloseClicked,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title(
						_Utils_eq(model.afx, $elm$core$Maybe$Nothing) ? 'Add Charge' : 'Edit Charge')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						$author$project$Components$Patient$Charges$ChargeModal$viewBody(model)
					])),
				$author$project$Ui$Modal$footer(
				$elm$core$List$concat(
					_List_fromArray(
						[
							_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Cancel and close modal'},
								_List_fromArray(
									[
										$author$project$Ui$Button$onClick($author$project$Components$Patient$Charges$ChargeModal$CloseClicked),
										$author$project$Ui$Button$link
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Cancel')
									]))
							]),
							function () {
							var _v0 = model.afx;
							if (!_v0.$) {
								return _List_fromArray(
									[$author$project$Utils$Html$empty]);
							} else {
								return _List_fromArray(
									[
										$author$project$Utils$Html$noBreakSpace,
										A3(
										$author$project$Ui$Button$view,
										{mm: 'save & Add another'},
										_List_fromArray(
											[
												$author$project$Ui$Button$styled(0),
												$author$project$Ui$Button$loading(model.pR),
												$author$project$Ui$Button$disabled(previewLoading),
												$author$project$Ui$Button$onClick($author$project$Components$Patient$Charges$ChargeModal$SaveAndAddAnotherClicked)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Save & Add Another')
											]))
									]);
							}
						}(),
							_List_fromArray(
							[
								$author$project$Utils$Html$noBreakSpace,
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Save'},
								_List_fromArray(
									[
										$author$project$Ui$Button$onClick($author$project$Components$Patient$Charges$ChargeModal$SaveClicked),
										$author$project$Ui$Button$primary,
										$author$project$Ui$Button$disabled(previewLoading),
										$author$project$Ui$Button$loading(model.pR)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Save')
									]))
							])
						])))
			]));
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ChargeModalOpened = {$: 37};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewAddChargeButton = A3(
	$author$project$Ui$Button$view,
	{mm: 'Add charge'},
	_List_fromArray(
		[
			$author$project$Ui$Button$secondary,
			$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ChargeModalOpened),
			$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('Add Charge')
		]));
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$findChargeDropdown = F2(
	function (charge, dropdowns) {
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$second,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$mapFirst(
							$elm$core$Basics$eq(
								$author$project$Api$Provider$Charge$One$id(charge))),
						$elm$core$Tuple$first),
					dropdowns)));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$DeleteCharge = function (a) {
	return {$: 21, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$EditCharge = function (a) {
	return {$: 38, a: a};
};
var $author$project$Api$Provider$CustomerInvoice$Meta$destroyAction = function (_v0) {
	var meta = _v0;
	return meta.vy.Qu;
};
var $author$project$Ui$Icon$Dots = 62;
var $author$project$Ui$Icon$dots = $author$project$Ui$Icon$viewIcon(62);
var $author$project$Api$Provider$Charge$One$isLocked = function (_v0) {
	var record = _v0.b;
	return record.UU;
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeActions = F3(
	function (charge, customerInvoiceMeta, maybeDropdown) {
		if ($author$project$Api$Provider$Charge$One$isLocked(charge)) {
			var tooltipText = 'An admin must unlock the charge\'s reporting period before editing this charge';
			return A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Tooltip$view,
						_List_fromArray(
							[
								$author$project$Ui$Tooltip$placement(2)
							]),
						tooltipText,
						_List_fromArray(
							[
								$author$project$Ui$Icon$lock(
								_List_fromArray(
									[$author$project$Ui$Icon$info]))
							]))
					]));
		} else {
			return A2(
				$author$project$Ui$Table$cell,
				_List_fromArray(
					[$author$project$Ui$Table$textRight]),
				function () {
					if (maybeDropdown.$ === 1) {
						return _List_Nil;
					} else {
						var dropdown = maybeDropdown.a;
						return $elm$core$List$singleton(
							A4(
								$author$project$Ui$Dropdown$view,
								_List_fromArray(
									[$author$project$Ui$Dropdown$buttonSecondary, $author$project$Ui$Dropdown$buttonSm]),
								_List_fromArray(
									[
										$author$project$Ui$Icon$dots(_List_Nil)
									]),
								A2(
									$elm$core$List$cons,
									A2(
										$author$project$Ui$Dropdown$item,
										_List_fromArray(
											[
												$author$project$Ui$Dropdown$onSelect(
												$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$EditCharge(charge))
											]),
										A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$textLeft, $author$project$Ui$Element$flex, $author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
											_List_fromArray(
												[
													$author$project$Ui$Icon$edit(_List_Nil),
													A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Edit')
														]))
												]))),
									$author$project$Api$Provider$CustomerInvoice$Meta$destroyAction(customerInvoiceMeta) ? _List_fromArray(
										[
											A2(
											$author$project$Ui$Dropdown$item,
											_List_fromArray(
												[
													$author$project$Ui$Dropdown$onSelect(
													$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$DeleteCharge(charge))
												]),
											A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$textDanger, $author$project$Ui$Element$textLeft, $author$project$Ui$Element$flex, $author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
												_List_fromArray(
													[
														$author$project$Ui$Icon$delete(_List_Nil),
														A2(
														$elm$html$Html$span,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Delete')
															]))
													])))
										]) : _List_Nil),
								dropdown));
					}
				}());
		}
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$AmountDetailHovered = function (a) {
	return {$: 35, a: a};
};
var $author$project$Api$Provider$Charge$Shared$issuedSubtotalInCents = function (_v0) {
	var record = _v0;
	return record.Vr;
};
var $author$project$Api$Provider$Charge$One$issuedSubtotalInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Charge$Shared$issuedSubtotalInCents(shared);
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewCoverageDiscount = function (coverageDiscount) {
	var coverageRule = $author$project$Api$Provider$CoveredCharge$All$coverageRule(coverageDiscount);
	return A2(
		$author$project$Components$CoverageRuleDescription$view,
		$author$project$Components$CoverageRuleDescription$Shared(coverageRule),
		false);
};
var $author$project$Api$Provider$PrepaidCharge$packageName = function (_v0) {
	var record = _v0;
	return A2(
		$elm$core$Maybe$map,
		function ($) {
			return $.Bq;
		},
		record.afx);
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewPrepaidCharges = F2(
	function (hasCoverageRules, prepaidCharges) {
		var packageNames = A2($elm$core$List$filterMap, $author$project$Api$Provider$PrepaidCharge$packageName, prepaidCharges);
		if ($elm$core$List$isEmpty(packageNames)) {
			return _List_Nil;
		} else {
			var packageText = function () {
				if (hasCoverageRules) {
					var joinedNames = function () {
						if (!packageNames.b) {
							return '';
						} else {
							if (!packageNames.b.b) {
								var single = packageNames.a;
								return single;
							} else {
								var last = A2(
									$elm$core$Maybe$withDefault,
									'',
									$elm$core$List$head(
										A2(
											$elm$core$List$drop,
											$elm$core$List$length(packageNames) - 1,
											packageNames)));
								var allButLast = A2(
									$elm$core$List$take,
									$elm$core$List$length(packageNames) - 1,
									packageNames);
								return A2($elm$core$String$join, ', ', allButLast) + (' and ' + last);
							}
						}
					}();
					return 'and included in ' + joinedNames;
				} else {
					return 'This item is covered by the patient\'s package. No additional charge will be applied.';
				}
			}();
			return _List_fromArray(
				[
					A2($author$project$Ui$Typography$text, _List_Nil, packageText)
				]);
		}
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeAmount = F2(
	function (charge, maybeCoverageDiscounts) {
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$justifyRight]),
			_List_fromArray(
				[
					function () {
					if (!(!$author$project$Api$Provider$Charge$One$discountInCents(charge))) {
						var coverageDiscountContent = function () {
							if ((!maybeCoverageDiscounts.$) && (maybeCoverageDiscounts.a.$ === 3)) {
								var _v2 = maybeCoverageDiscounts.a;
								var coverageDiscounts = _v2.a;
								return A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewCoverageDiscount, coverageDiscounts);
							} else {
								return _List_Nil;
							}
						}();
						var hasCoverageRules = !$elm$core$List$isEmpty(coverageDiscountContent);
						var costBeforeDiscount = $author$project$Api$Provider$Charge$One$issuedSubtotalInCents(charge) + $author$project$Api$Provider$Charge$One$discountInCents(charge);
						var consumedPrepaidCharges = $author$project$Api$Provider$Charge$One$consumedPrepaidCharges(charge);
						var prepaidContent = A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewPrepaidCharges, hasCoverageRules, consumedPrepaidCharges);
						var popoverContent = _Utils_ap(coverageDiscountContent, prepaidContent);
						return A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									function () {
									if ((!$elm$core$List$isEmpty(popoverContent)) || _Utils_eq(maybeCoverageDiscounts, $elm$core$Maybe$Nothing)) {
										var popoverOptions = function () {
											if (!maybeCoverageDiscounts.$) {
												return _List_Nil;
											} else {
												return $elm$core$List$isEmpty(consumedPrepaidCharges) ? _List_fromArray(
													[
														$author$project$Ui$Popover$onHover(
														$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$AmountDetailHovered(
															$author$project$Api$Provider$Charge$One$id(charge)))
													]) : _List_Nil;
											}
										}();
										return A3(
											$author$project$Ui$Popover$view,
											popoverOptions,
											_List_fromArray(
												[
													$author$project$Ui$Icon$help(_List_Nil)
												]),
											_List_fromArray(
												[
													A2($author$project$Ui$Popover$body, _List_Nil, popoverContent)
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}(),
									$author$project$Utils$Html$noBreakSpace,
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$strike, $author$project$Ui$Typography$muted]),
									$author$project$Utils$Currency$fromInt(costBeforeDiscount))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					(!_Utils_eq(
					$author$project$Api$Provider$Charge$One$issuedSubtotalInCents(charge),
					$author$project$Api$Provider$Charge$One$subtotalInCents(charge))) ? A2(
					$author$project$Ui$Typography$text,
					_List_fromArray(
						[$author$project$Ui$Typography$strike, $author$project$Ui$Typography$muted]),
					$author$project$Utils$Currency$fromInt(
						$author$project$Api$Provider$Charge$One$issuedSubtotalInCents(charge))) : $author$project$Utils$Html$empty,
					$author$project$Utils$Html$noBreakSpace,
					$elm$html$Html$text(
					$author$project$Utils$Currency$fromInt(
						$author$project$Api$Provider$Charge$One$subtotalInCents(charge))),
					$author$project$Api$Provider$Charge$One$taxable(charge) ? A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(' + tax')
						])) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeDetail = F2(
	function (label, value) {
		return $elm$core$String$isEmpty(value) ? $elm$html$Html$text('') : A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
			_List_fromArray(
				[
					$elm$html$Html$text(label + ':  '),
					$elm$html$Html$text(value)
				]));
	});
var $author$project$Api$Provider$PrepaidCharge$chargeItem = function (_v0) {
	var record = _v0;
	return record.mL;
};
var $author$project$Api$Provider$PrepaidCharge$originalQuantity = function (_v0) {
	var record = _v0;
	return record.Yw;
};
var $author$project$Api$Provider$Charge$One$prepaidCharges = function (_v0) {
	var record = _v0.b;
	return record._b;
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargePackageItems = function (charge) {
	var toItemText = function (prepaidCharge) {
		var quantity = $author$project$Api$Provider$PrepaidCharge$originalQuantity(prepaidCharge);
		var chargeItem = $author$project$Api$Provider$PrepaidCharge$chargeItem(prepaidCharge);
		var name = $author$project$Api$Provider$ChargeItem$Min$name(chargeItem);
		return $elm$core$String$fromInt(quantity) + (' ' + name);
	};
	var itemsText = A2(
		$elm$core$String$join,
		', ',
		A2(
			$elm$core$List$map,
			toItemText,
			$author$project$Api$Provider$Charge$One$prepaidCharges(charge)));
	return A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeDetail, 'Includes', itemsText);
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeDetails = function (charge) {
	var date = A2(
		$author$project$Formatters$Date$toString,
		$author$project$Formatters$Date$Full,
		$author$project$Api$Provider$Charge$One$date(charge));
	var detailsRow = A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$wrap, $author$project$Ui$Element$spaceX2]),
		_List_fromArray(
			[
				function () {
				var _v0 = $author$project$Api$Provider$Charge$One$endDate(charge);
				if (!_v0.$) {
					var endDate = _v0.a;
					return A2(
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeDetail,
						'Dates',
						date + (' - ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, endDate)));
				} else {
					return A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeDetail, 'Date', date);
				}
			}(),
				A2(
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeDetail,
				'Description',
				$author$project$Api$Provider$Charge$One$description(charge)),
				A2(
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeDetail,
				'Practitioner',
				A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						$author$project$Api$Provider$Practitioner$Shared$name,
						$author$project$Api$Provider$Charge$One$practitioner(charge)))),
				A2(
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeDetail,
				'Patient',
				A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						$author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$name,
						$author$project$Api$Provider$Charge$One$patient(charge)))),
				A2(
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeDetail,
				'Location',
				A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						$author$project$Api$Provider$Location$Min$name,
						$author$project$Api$Provider$Charge$One$location(charge)))),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$textSm]),
				_List_fromArray(
					[
						A2(
						$author$project$Components$InventoryWarning$view,
						A2(
							$elm$core$Maybe$map,
							function (chargeItem) {
								return {
									Lm: $author$project$Api$Provider$ChargeItem$ForCharge$alertQuantity(chargeItem),
									_P: $author$project$Api$Provider$ChargeItem$ForCharge$quantityInStock(chargeItem),
									ads: $author$project$Api$Provider$ChargeItem$ForCharge$trackInventory(chargeItem)
								};
							},
							$author$project$Api$Provider$Charge$One$chargeItem(charge)),
						$elm$core$Maybe$Just(
							$author$project$Api$Provider$Charge$One$quantity(charge)))
					]))
			]));
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$spaceY2]),
		_List_fromArray(
			[
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargePackageItems(charge),
				detailsRow
			]));
};
var $author$project$Formatters$ChargeItem$ifPresent = function (string) {
	return $elm$core$String$isEmpty(string) ? '' : A2($elm$core$String$append, ' - ', string);
};
var $author$project$Formatters$ChargeItem$toTitle = function (chargeItem) {
	var codeTypeAndCode = $author$project$Formatters$ChargeItemCode$toString(
		$author$project$Formatters$ChargeItemCode$CodeTypeAndCode(
			_Utils_Tuple2(
				$author$project$Api$Provider$ChargeItem$ForCharge$codeType(chargeItem),
				$author$project$Api$Provider$ChargeItem$ForCharge$code(chargeItem))));
	return $elm$core$String$concat(
		_List_fromArray(
			[
				$author$project$Api$Provider$ChargeItem$ForCharge$name(chargeItem),
				$author$project$Formatters$ChargeItem$ifPresent(codeTypeAndCode),
				$author$project$Formatters$ChargeItem$ifPresent(
				$author$project$Api$Provider$ChargeItem$ForCharge$manufacturer(chargeItem))
			]));
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeName = function (charge) {
	var name = function () {
		var _v1 = $author$project$Api$Provider$Charge$One$chargeItem(charge);
		if (!_v1.$) {
			var chargeItem = _v1.a;
			return $author$project$Formatters$ChargeItem$toTitle(chargeItem);
		} else {
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Api$Provider$Charge$One$name(charge));
		}
	}();
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$text,
				_List_fromArray(
					[$author$project$Ui$Typography$bold]),
				name),
				function () {
				var _v0 = A2(
					$elm$core$Basics$composeR,
					$author$project$Api$Provider$Charge$One$category,
					$elm$core$Maybe$map($author$project$Api$Provider$Category$Shared$name))(charge);
				if (!_v0.$) {
					var categoryName = _v0.a;
					return A2($author$project$Ui$Typography$text, _List_Nil, ' - ' + categoryName);
				} else {
					return $elm$html$Html$text('');
				}
			}()
			]));
};
var $author$project$Api$Provider$Charge$Shared$issuedPriceInCents = function (_v0) {
	var record = _v0;
	return record.Vo;
};
var $author$project$Api$Provider$Charge$One$issuedPriceInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Charge$Shared$issuedPriceInCents(shared);
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargePrice = function (charge) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				function () {
				var _v0 = _Utils_Tuple2(
					$author$project$Api$Provider$Charge$One$issuedPriceInCents(charge),
					$author$project$Api$Provider$Charge$One$priceInCents(charge));
				if ((!_v0.a.$) && (!_v0.b.$)) {
					var issuedPrice = _v0.a.a;
					var price = _v0.b.a;
					return (!_Utils_eq(issuedPrice, price)) ? A2(
						$author$project$Ui$Typography$text,
						_List_fromArray(
							[$author$project$Ui$Typography$strike, $author$project$Ui$Typography$muted]),
						$author$project$Utils$Currency$fromInt(issuedPrice)) : $author$project$Utils$Html$empty;
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				$author$project$Utils$Html$noBreakSpace,
				function () {
				var _v1 = $author$project$Api$Provider$Charge$One$priceInCents(charge);
				if (!_v1.$) {
					var price = _v1.a;
					return $elm$html$Html$text(
						$author$project$Utils$Currency$fromInt(price));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				($author$project$Api$Provider$Charge$One$type_(charge) === 'coverage') ? A2(
				$author$project$Ui$Typography$text,
				_List_fromArray(
					[$author$project$Ui$Typography$italic, $author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
				$elm$core$String$concat(
					_List_fromArray(
						[
							' per ',
							$elm$core$String$toLower(
							$author$project$Api$Provider$Uom$Shared$name(
								$author$project$Api$Provider$Charge$One$priceUom(charge)))
						]))) : $author$project$Utils$Html$empty
			]));
};
var $author$project$Api$Provider$Charge$Shared$issuedQuantity = function (_v0) {
	var record = _v0;
	return record.Vp;
};
var $author$project$Api$Provider$Charge$One$issuedQuantity = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Charge$Shared$issuedQuantity(shared);
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeQuantity = function (charge) {
	var showQuantityWithUnit = F2(
		function (quantity, uom) {
			return $author$project$Api$Provider$Uom$Shared$isTimeBased(uom) ? A2(
				$author$project$Formatters$String$pluralize,
				$author$project$Api$Provider$Uom$Shared$name(uom),
				quantity) : $elm$core$String$fromInt(quantity);
		});
	var diffInQuantityUom = !_Utils_eq(
		$author$project$Api$Provider$Uom$Shared$code(
			$author$project$Api$Provider$Charge$One$issuedQuantityUom(charge)),
		$author$project$Api$Provider$Uom$Shared$code(
			$author$project$Api$Provider$Charge$One$quantityUom(charge)));
	var diffInQuantity = !_Utils_eq(
		$author$project$Api$Provider$Charge$One$issuedQuantity(charge),
		$author$project$Api$Provider$Charge$One$quantity(charge));
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				(diffInQuantity || diffInQuantityUom) ? A2(
				$author$project$Ui$Typography$text,
				_List_fromArray(
					[$author$project$Ui$Typography$strike]),
				A2(
					showQuantityWithUnit,
					$author$project$Api$Provider$Charge$One$issuedQuantity(charge),
					$author$project$Api$Provider$Charge$One$issuedQuantityUom(charge))) : $author$project$Utils$Html$empty,
				$author$project$Utils$Html$noBreakSpace,
				$elm$html$Html$text(
				A2(
					showQuantityWithUnit,
					$author$project$Api$Provider$Charge$One$quantity(charge),
					$author$project$Api$Provider$Charge$One$quantityUom(charge)))
			]));
};
var $author$project$Components$ChargeRoutingWarning$One = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$ChargeRoutingWarning$viewWithChargeOne = F2(
	function (selectedPayer, charge) {
		return A2(
			$author$project$Components$ChargeRoutingWarning$view,
			selectedPayer,
			$author$project$Components$ChargeRoutingWarning$One(charge));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewCharge = F4(
	function (charge, customerInvoiceMeta, coverageDiscounts, dropdown) {
		var warning = A2($author$project$Components$ChargeRoutingWarning$viewWithChargeOne, 0, charge);
		return A2(
			$elm$core$List$cons,
			A2(
				$author$project$Ui$Table$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeName(charge)
							])),
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargePrice(charge)
							])),
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeQuantity(charge)
							])),
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeAmount, charge, coverageDiscounts)
							])),
						A3($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeActions, charge, customerInvoiceMeta, dropdown)
					])),
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Ui$Table$row,
					_List_fromArray(
						[$author$project$Ui$Table$noBorder]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_fromArray(
								[
									$author$project$Ui$Table$colspan(3)
								]),
							_List_fromArray(
								[
									$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeDetails(charge)
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_fromArray(
								[
									$author$project$Ui$Table$colspan(3)
								]),
							_List_fromArray(
								[
									$author$project$Api$Provider$Charge$One$discountOverridden(charge) ? A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$flex, $author$project$Ui$Element$justifyRight]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
											'Membership rule was removed')
										])) : $author$project$Utils$Html$empty
								])),
							A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil)
						])),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (warning_) {
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Table$row,
									_List_fromArray(
										[$author$project$Ui$Table$noBorder]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Table$cell,
											_List_fromArray(
												[
													$author$project$Ui$Table$colspan(12)
												]),
											_List_fromArray(
												[warning_]))
										]))
								]);
						},
						warning))));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargesTable = function (model) {
	var _v0 = function () {
		var _v1 = model.Uk;
		if (_v1.$ === 3) {
			var invoice = _v1.a;
			var meta = $author$project$Api$Provider$CustomerInvoice$One$meta(invoice);
			return _Utils_Tuple2(
				false,
				A2(
					$elm$core$List$concatMap,
					function (charge) {
						return A4(
							$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewCharge,
							charge,
							meta,
							A2(
								$elm$core$Dict$get,
								$author$project$Api$Provider$Charge$One$id(charge),
								model.yU),
							A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$findChargeDropdown, charge, model.iI));
					},
					A2(
						$elm$core$List$filter,
						$author$project$Api$Provider$Charge$One$isPersisted,
						A2(
							$author$project$Api$Expandable$withDefault,
							_List_Nil,
							$author$project$Api$Provider$CustomerInvoice$One$charges(invoice)))));
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var charges = _v0.b;
	return A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('There are no charges.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(6)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Item')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(2)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Price')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(1)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Qty')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(2),
						$author$project$Ui$Table$textRight
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Amount')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(1)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('')
					]))
			]),
		charges,
		_List_Nil);
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$DeleteInvoiceHiConfirmOpened = {$: 13};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewDeleteButton = F2(
	function (model, invoice) {
		return $author$project$Api$Provider$CustomerInvoice$Meta$destroyAction(
			$author$project$Api$Provider$CustomerInvoice$One$meta(invoice)) ? A3(
			$author$project$Ui$Button$view,
			{mm: 'Delete invoice'},
			_List_fromArray(
				[
					$author$project$Ui$Button$secondary,
					$author$project$Ui$Button$loading(
					_Utils_eq(model.Uk, $author$project$Api$Data$Loading)),
					$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$DeleteInvoiceHiConfirmOpened)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Delete')
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$EditInvoiceClicked = function (a) {
	return {$: 33, a: a};
};
var $author$project$Api$Provider$Patient$Shared$phones = function (_v0) {
	var shared = _v0;
	return shared.Zy;
};
var $author$project$Ui$Element$Test = function (a) {
	return {$: 10, a: a};
};
var $author$project$Ui$Element$test = $author$project$Ui$Element$Test;
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewEditButtonDisabled = function (invoice) {
	var invoiceStatus = $author$project$Api$Provider$CustomerInvoice$One$humanStatus(invoice);
	var hasLockedCharges = A2(
		$elm$core$List$any,
		function (charge) {
			return $author$project$Api$Provider$Charge$One$isLocked(charge);
		},
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			$author$project$Api$Expandable$toMaybe(
				$author$project$Api$Provider$CustomerInvoice$One$charges(invoice))));
	return (hasLockedCharges && (invoiceStatus !== 'draft')) || A2(
		$elm$core$List$member,
		invoiceStatus,
		_List_fromArray(
			['bad_debt', 'cancelled']));
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewIntegrationRecord = F2(
	function (timeFormatter, record) {
		var unsyncedReason = function () {
			var _v2 = $author$project$Api$Provider$IntegrationRecord$All$unsyncedReason(record);
			if (!_v2.$) {
				var reason = _v2.a;
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ml-1')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(reason)
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}();
		var lastSyncedAt = function () {
			var _v1 = $author$project$Api$Provider$IntegrationRecord$All$integrationLastSyncedAt(record);
			if (!_v1.$) {
				var time = _v1.a;
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ml-1')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							'on ' + A2(timeFormatter, 0, time))
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}();
		var integrationName = $author$project$Api$Provider$Integration$SharedWithInlinePartner$displayName(
			$author$project$Api$Provider$IntegrationRecord$All$integration(record));
		var errorMessage = function () {
			var _v0 = $author$project$Api$Provider$IntegrationRecord$All$errorMessage(record);
			if (!_v0.$) {
				var message = _v0.a;
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ml-1')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(message)
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}();
		var additionalInfo = A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-control--static'),
					$elm$html$Html$Attributes$class('text-muted'),
					$elm$html$Html$Attributes$class('text-body-sm')
				]),
			_List_fromArray(
				[unsyncedReason, errorMessage, lastSyncedAt]));
		return A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$span(7)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flexAuto, $author$project$Ui$Element$spaceX2]),
							_List_fromArray(
								[
									$author$project$Ui$HinterOnly$icon(_List_Nil),
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$hintLabel, $author$project$Ui$Typography$p0, $author$project$Ui$Typography$textLeft]),
									integrationName)
								]))
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$span(5)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$itemsStart]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Badge$fromString,
									_List_Nil,
									$author$project$Api$IntegrationRecord$Status$toString(
										$author$project$Api$Provider$IntegrationRecord$All$integrationSyncStatus(record)))
								])),
							additionalInfo
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewIntegrationRecords = F2(
	function (formatter, response) {
		if (response.$ === 3) {
			var integrationRecords = response.a;
			return A2(
				$elm$core$List$map,
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewIntegrationRecord(formatter),
				integrationRecords);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Formatters$Phone$phoneParts = function (phone) {
	var countryAt = $elm$core$String$length(phone) - 10;
	var rest = A2($elm$core$String$dropLeft, countryAt, phone);
	var country = A3($elm$core$String$slice, 0, countryAt, phone);
	return _Utils_Tuple2(country, rest);
};
var $author$project$Formatters$Phone$formatWithCountry = function (phoneNumber) {
	var parsedNumber = A2(
		$elm$core$String$filter,
		function (_char) {
			return _char !== '+';
		},
		$elm$core$String$trim(phoneNumber));
	var length = $elm$core$String$length(parsedNumber);
	if (A2($elm$core$String$contains, '-', parsedNumber) || ((length < 10) || (length > 13))) {
		return phoneNumber;
	} else {
		var phoneWithCountry = (length === 10) ? ('1' + parsedNumber) : parsedNumber;
		var _v0 = $author$project$Formatters$Phone$phoneParts(phoneWithCountry);
		var country = _v0.a;
		var rest = _v0.b;
		return country + (' ' + $author$project$Formatters$Phone$format(rest));
	}
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewPhone = function (phone) {
	var formattedPhone = function (number) {
		return $author$project$Formatters$Phone$formatWithCountry(number) + (' (' + ($author$project$Formatters$PhoneType$toString(
			$author$project$Api$Common$Phone$Shared$type_(phone)) + ')'));
	};
	var _v0 = $author$project$Api$Common$Phone$Shared$number(phone);
	if (!_v0.$) {
		var number = _v0.a;
		return A2(
			$author$project$Ui$Typography$text,
			_List_fromArray(
				[
					$author$project$Ui$Typography$phi(true)
				]),
			formattedPhone(number));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewDetails = F5(
	function (timeFormatter, isHintAdmin, integrationRecords, practice, invoice) {
		var editButtonDisabled = $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewEditButtonDisabled(invoice);
		var editButton = A3(
			$author$project$Ui$Button$view,
			{mm: 'Edit details'},
			_List_fromArray(
				[
					$author$project$Ui$Button$sm,
					$author$project$Ui$Button$secondary,
					$author$project$Ui$Button$onClick(
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$EditInvoiceClicked(invoice)),
					$author$project$Ui$Button$disabled(editButtonDisabled),
					$author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Edit Details')
				]));
		var _v0 = function () {
			var _v1 = $author$project$Api$Provider$CustomerInvoice$One$owner(invoice);
			if (!_v1.$) {
				var patient = _v1.a;
				return _Utils_Tuple2(
					$author$project$Api$Provider$Patient$Shared$name(patient),
					A2(
						$author$project$Api$Expandable$withDefault,
						_List_Nil,
						$author$project$Api$Provider$Patient$Shared$phones(patient)));
			} else {
				return _Utils_Tuple2('', _List_Nil);
			}
		}();
		var ownerName = _v0.a;
		var ownerPhones = _v0.b;
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[
					$author$project$Ui$Element$test('invoice-details'),
					$author$project$Ui$Element$mb4
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanMd(2),
									$author$project$Ui$Grid$span(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$hintLabel, $author$project$Ui$Typography$p0, $author$project$Ui$Typography$textLeft]),
									'Payer')
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanMd(4),
									$author$project$Ui$Grid$span(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[
											$author$project$Ui$Typography$bold,
											$author$project$Ui$Typography$phi(true)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(ownerName)
										])),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewPhone, ownerPhones))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanMd(4)
								]),
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$Ui$Grid$row,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$spanMd(7),
													$author$project$Ui$Grid$span(6)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$text,
													_List_fromArray(
														[$author$project$Ui$Typography$hintLabel, $author$project$Ui$Typography$p0, $author$project$Ui$Typography$textLeft]),
													'Invoice Date')
												])),
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$span(5)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$text,
													_List_Nil,
													A2(
														$author$project$Formatters$Date$toString,
														$author$project$Formatters$Date$Full,
														$author$project$Api$Provider$CustomerInvoice$One$date(invoice)))
												]))
										])),
								A2(
									$elm$core$List$cons,
									A2(
										$author$project$Ui$Grid$row,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Grid$column,
												_List_fromArray(
													[
														$author$project$Ui$Grid$spanMd(7),
														$author$project$Ui$Grid$span(6)
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$text,
														_List_fromArray(
															[$author$project$Ui$Typography$hintLabel, $author$project$Ui$Typography$p0, $author$project$Ui$Typography$textLeft]),
														'Location')
													])),
												A2(
												$author$project$Ui$Grid$column,
												_List_fromArray(
													[
														$author$project$Ui$Grid$span(5)
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$text,
														_List_Nil,
														A2(
															$elm$core$Maybe$withDefault,
															'',
															A2(
																$elm$core$Maybe$map,
																$author$project$Api$Provider$Location$Min$name,
																$author$project$Api$Provider$CustomerInvoice$One$location(invoice))))
													]))
											])),
									A2(
										$elm$core$List$cons,
										((!$elm$core$List$isEmpty(
											$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoicePayments(invoice))) || $author$project$Api$Provider$CustomerInvoice$One$isPaymentScheduled(invoice)) ? $author$project$Utils$Html$empty : A2(
											$author$project$Ui$Grid$row,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Grid$column,
													_List_fromArray(
														[
															$author$project$Ui$Grid$spanMd(7),
															$author$project$Ui$Grid$span(6)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Typography$text,
															_List_fromArray(
																[$author$project$Ui$Typography$hintLabel, $author$project$Ui$Typography$p0, $author$project$Ui$Typography$textLeft]),
															'Default Payment Source')
														])),
													A2(
													$author$project$Ui$Grid$column,
													_List_fromArray(
														[
															$author$project$Ui$Grid$span(5)
														]),
													_List_fromArray(
														[
															function () {
															var _v2 = $author$project$Api$Provider$Practice$One$allowMultipleRetailMemberships(practice) ? $author$project$Api$Provider$CustomerInvoice$One$membershipPaymentSource(invoice) : $elm$core$Maybe$Nothing;
															if (!_v2.$) {
																var source = _v2.a;
																return A2(
																	$author$project$Components$PaymentSourceDisplayer$view,
																	timeFormatter,
																	_List_fromArray(
																		[
																			$author$project$Components$PaymentSourceDisplayer$source(
																			$elm$core$Maybe$Just(
																				$author$project$Api$Source$Source(source))),
																			$author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus(true),
																			$author$project$Components$PaymentSourceDisplayer$limitedView(true)
																		]));
															} else {
																var _v3 = $author$project$Api$Provider$CustomerInvoice$One$source(invoice);
																if (!_v3.$) {
																	var source = _v3.a;
																	return A2(
																		$author$project$Components$PaymentSourceDisplayer$view,
																		timeFormatter,
																		_List_fromArray(
																			[
																				$author$project$Components$PaymentSourceDisplayer$source(
																				$elm$core$Maybe$Just(
																					$author$project$Api$Source$Source(source))),
																				$author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus(true),
																				$author$project$Components$PaymentSourceDisplayer$limitedView(true)
																			]));
																} else {
																	return A2(
																		$author$project$Ui$Element$view,
																		_List_Nil,
																		_List_fromArray(
																			[
																				A2($author$project$Ui$Badge$fromString, _List_Nil, 'none')
																			]));
																}
															}
														}()
														]))
												])),
										isHintAdmin ? A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewIntegrationRecords, timeFormatter, integrationRecords) : _List_Nil)))),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanMd(2),
									$author$project$Ui$Grid$justifyRight
								]),
							_List_fromArray(
								[editButton]))
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewDetailsSkeleton = A2(
	$author$project$Ui$Element$view,
	_List_fromArray(
		[$author$project$Ui$Element$mb4]),
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanMd(2),
							$author$project$Ui$Grid$span(6)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$spanFromText('Payer')
										]))
								]))
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanMd(4),
							$author$project$Ui$Grid$span(6)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$span(4)
										]))
								]))
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanMd(4)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanMd(7),
											$author$project$Ui$Grid$span(6)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$span,
											_List_fromArray(
												[$author$project$Ui$Typography$p0]),
											_List_fromArray(
												[
													$author$project$Ui$Skeleton$text(
													_List_fromArray(
														[
															$author$project$Ui$Skeleton$spanFromText('Invoice Date')
														]))
												]))
										])),
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(5)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$text(
											_List_fromArray(
												[
													$author$project$Ui$Skeleton$span(4)
												]))
										]))
								])),
							A2(
							$author$project$Ui$Grid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanMd(7),
											$author$project$Ui$Grid$span(6)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$author$project$Ui$Skeleton$text(
													_List_fromArray(
														[
															$author$project$Ui$Skeleton$spanFromText('Location')
														]))
												]))
										])),
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(5)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$text(
											_List_fromArray(
												[
													$author$project$Ui$Skeleton$span(5)
												]))
										]))
								]))
						]))
				]))
		]));
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$SaveInvoice = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$viewLocationInput = F2(
	function (locationResourceFilter, disable) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8),
					$author$project$Ui$Form$Group$label('Location')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$LocationResourceFilterMsg,
					A2(
						$author$project$Components$ResourceFilter$Location$view,
						_List_fromArray(
							[
								$author$project$Components$ResourceFilter$disabled(disable)
							]),
						locationResourceFilter))
				]));
	});
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$viewPatientInput = function (patientResourceFilter) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(4),
				$author$project$Ui$Form$Group$inputSpanSm(8),
				$author$project$Ui$Form$Group$label('Payer')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$PatientResourceFilterMsg,
				A2($author$project$Components$ResourceFilter$Patient$view, _List_Nil, patientResourceFilter))
			]));
};
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$view = function (model) {
	var _v0 = model.av;
	if (!_v0.$) {
		var _v1 = _v0.a;
		var invoiceId = _v1.a;
		var form = _v1.b;
		var invoice = _v1.c;
		var _v2 = $author$project$Utils$Form$fields(form);
		var invoiceDate = _v2.Uq;
		var dateInput = _v2.rZ;
		var _v3 = _Utils_Tuple2(model.oY, model.os);
		if ((!_v3.a.$) && (!_v3.b.$)) {
			var patientResourceFilter = _v3.a.a;
			var locationResourceFilter = _v3.b.a;
			var modalConfig = {
				Tq: $elm$core$Maybe$Nothing,
				aih: 'Customer Invoice',
				V8: model.V8,
				WG: $elm$core$Maybe$Just(invoiceId),
				WH: $elm$core$Maybe$Nothing,
				Yd: $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$CancelInvoiceEdit,
				Yf: $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$SaveInvoice(form)
			};
			var disabled = $author$project$Api$Provider$CustomerInvoice$One$humanStatus(invoice) !== 'draft';
			return A2(
				$author$project$Components$Admin$CreateEditModal$modal,
				modalConfig,
				_List_fromArray(
					[
						$author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$viewPatientInput(patientResourceFilter),
						A2($author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$viewLocationInput, locationResourceFilter, disabled),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Invoice Date'),
								$author$project$Ui$Form$Group$labelSpan(4),
								$author$project$Ui$Form$Group$inputSpan(8)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$DateInputMsg(dateInput),
								A2(
									$author$project$Components$DateInput$view,
									_List_fromArray(
										[
											$author$project$Components$DateInput$value(invoiceDate),
											$author$project$Components$DateInput$disabled(disabled)
										]),
									dateInput))
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewEditInvoiceModal = function (maybeModal) {
	if (!maybeModal.$) {
		var modal = maybeModal.a;
		return A2(
			$elm$html$Html$map,
			$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$EditInvoiceModalMsg,
			$author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$view(modal));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$MarkAsSentClicked = function (a) {
	return {$: 23, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$MarkAsUnsentClicked = function (a) {
	return {$: 24, a: a};
};
var $author$project$Components$CustomerEmailModal$PatientShared = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$StopRetryingClicked = function (a) {
	return {$: 25, a: a};
};
var $author$project$Components$CustomerEmailModal$OpenModal = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $author$project$Components$CustomerEmailModal$Sm = 0;
var $author$project$Components$CustomerEmailModal$defaultOptions = {ep: false, aly: 0};
var $author$project$Components$CustomerEmailModal$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				if (!option.$) {
					var bool = option.a;
					return _Utils_update(
						record,
						{ep: bool});
				} else {
					var size_ = option.a;
					return _Utils_update(
						record,
						{aly: size_});
				}
			}),
		$author$project$Components$CustomerEmailModal$defaultOptions,
		options);
};
var $author$project$Components$CustomerEmailModal$button = F5(
	function (session, options, type_, contextId, recipient) {
		var optionsRecord = $author$project$Components$CustomerEmailModal$optionsToRecord(options);
		return A3(
			$author$project$Ui$Tooltip$view,
			_List_Nil,
			'Send Invoice via Email',
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{mm: 'Send invoice via email'},
					_List_fromArray(
						[
							function () {
							var _v0 = optionsRecord.aly;
							return $author$project$Ui$Button$sm;
						}(),
							$author$project$Ui$Button$onClick(
							A4($author$project$Components$CustomerEmailModal$OpenModal, session, type_, contextId, recipient)),
							$author$project$Ui$Button$disabled(optionsRecord.ep),
							$author$project$Ui$Button$icon($author$project$Ui$Icon$send)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Email')
						]))
				]));
	});
var $author$project$Api$Provider$CustomerInvoice$Shared$issuedTotalInCents = function (_v0) {
	var record = _v0;
	return record.Vs;
};
var $author$project$Api$Provider$CustomerInvoice$One$issuedTotalInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CustomerInvoice$Shared$issuedTotalInCents(shared);
};
var $author$project$Api$Provider$CustomerInvoice$One$lastSentAt = function (_v0) {
	var record = _v0.b;
	return record.VL;
};
var $author$project$Api$Provider$CustomerInvoice$Meta$markAsSentAction = function (_v0) {
	var meta = _v0;
	return meta.vy.Ww;
};
var $author$project$Api$Provider$CustomerInvoice$Meta$markAsUnsentAction = function (_v0) {
	var meta = _v0;
	return meta.vy.Wx;
};
var $author$project$Api$Provider$CustomerInvoice$Shared$securePdfInlineToken = function (_v0) {
	var record = _v0;
	return record.aaE;
};
var $author$project$Api$Provider$CustomerInvoice$One$securePdfInlineToken = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CustomerInvoice$Shared$securePdfInlineToken(shared);
};
var $author$project$Components$CustomerEmailModal$Size = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$CustomerEmailModal$sm = $author$project$Components$CustomerEmailModal$Size(0);
var $author$project$Api$Provider$CustomerInvoice$Meta$stopRetryingAction = function (_v0) {
	var meta = _v0;
	return meta.vy.aci;
};
var $author$project$Ui$Badge$Test = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Badge$test = $author$project$Ui$Badge$Test;
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ConvertToCreditClicked = function (a) {
	return {$: 30, a: a};
};
var $author$project$Api$FeatureGate$PatientCredits = 4;
var $author$project$Ui$Button$mx2 = $author$project$Ui$Button$Attrs(
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mx-2')
		]));
var $author$project$Api$Provider$CustomerInvoice$Meta$transferToCreditAction = function (_v0) {
	var meta = _v0;
	return meta.vy.ady;
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewConvertToCreditButton = F2(
	function (model, invoice) {
		return (A2(
			$author$project$Utils$FeatureGate$gateAvailable,
			4,
			$author$project$Api$Practice$Provider(model.ZV)) && $author$project$Api$Provider$CustomerInvoice$Meta$transferToCreditAction(
			$author$project$Api$Provider$CustomerInvoice$One$meta(invoice))) ? A3(
			$author$project$Ui$Button$view,
			{mm: 'Convert amount to credit'},
			_List_fromArray(
				[
					$author$project$Ui$Button$primary,
					$author$project$Ui$Button$mx2,
					$author$project$Ui$Button$loading(
					_Utils_eq(model.Uk, $author$project$Api$Data$Loading)),
					$author$project$Ui$Button$onClick(
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ConvertToCreditClicked(invoice))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Convert to Credit')
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$BadDebtHiConfirmOpened = {$: 15};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$RecordPayment = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ReturnToDraftClicked = function (a) {
	return {$: 26, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ReverseBadDebtClicked = function (a) {
	return {$: 27, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$Revise = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$SchedulePartialPaymentsClicked = function (a) {
	return {$: 52, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$SchedulePaymentClicked = function (a) {
	return {$: 40, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$Void = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$CustomerInvoice$Meta$cancel = function (_v0) {
	var meta = _v0;
	return meta.vy.Nl;
};
var $author$project$Api$Provider$CustomerInvoice$Meta$createAdjustment = function (_v0) {
	var meta = _v0;
	return meta.vy.OZ;
};
var $author$project$Ui$Dropdown$Item$HiddenLg = {$: 11};
var $author$project$Ui$Dropdown$hiddenLg = $author$project$Ui$Dropdown$Item$HiddenLg;
var $author$project$Api$Provider$CustomerInvoice$Meta$markAsBadDebtAction = function (_v0) {
	var meta = _v0;
	return meta.vy.Wu;
};
var $author$project$Api$Provider$CustomerInvoice$Meta$recordPaymentAction = function (_v0) {
	var meta = _v0;
	return meta.vy.$e;
};
var $author$project$Api$Provider$CustomerInvoice$Meta$returnToDraftAction = function (_v0) {
	var meta = _v0;
	return meta.vy.$Z;
};
var $author$project$Api$Provider$CustomerInvoice$Meta$reverseBadDebtAction = function (_v0) {
	var meta = _v0;
	return meta.vy.$1;
};
var $author$project$Api$Provider$CustomerInvoice$Meta$schedulePartialPaymentsAction = function (_v0) {
	var meta = _v0;
	return meta.vy.aau;
};
var $author$project$Api$Provider$CustomerInvoice$Meta$schedulePaymentAction = function (_v0) {
	var meta = _v0;
	return meta.vy.aav;
};
var $author$project$Api$Provider$CustomerInvoice$Meta$updateAction = function (_v0) {
	var meta = _v0;
	return meta.vy.adT;
};
var $author$project$Ui$Icon$Void = 58;
var $author$project$Ui$Icon$void = $author$project$Ui$Icon$viewIcon(58);
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewOtherDropdown = F2(
	function (model, invoice) {
		var ifAllowed = F2(
			function (condition, dropdownItem) {
				return condition(
					$author$project$Api$Provider$CustomerInvoice$One$meta(invoice)) ? $elm$core$Maybe$Just(dropdownItem) : $elm$core$Maybe$Nothing;
			});
		var schedulePaymentsOption = A2(
			$author$project$Utils$FeatureGate$gateAvailable,
			12,
			$author$project$Api$Practice$Provider(model.ZV)) ? A2(
			ifAllowed,
			$author$project$Api$Provider$CustomerInvoice$Meta$schedulePartialPaymentsAction,
			A2(
				$author$project$Ui$Dropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$Dropdown$onSelect(
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$SchedulePartialPaymentsClicked(invoice))
					]),
				A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
					_List_fromArray(
						[
							$author$project$Ui$Icon$calendar(_List_Nil),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Schedule Payments')
								]))
						])))) : A2(
			ifAllowed,
			$author$project$Api$Provider$CustomerInvoice$Meta$schedulePaymentAction,
			A2(
				$author$project$Ui$Dropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$Dropdown$onSelect(
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$SchedulePaymentClicked(invoice))
					]),
				A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
					_List_fromArray(
						[
							$author$project$Ui$Icon$calendar(_List_Nil),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Schedule Payment')
								]))
						]))));
		var canRevise = function (meta) {
			return $author$project$Api$Provider$CustomerInvoice$Meta$updateAction(meta) && ($author$project$Api$Provider$CustomerInvoice$Meta$createAdjustment(meta) && A3($author$project$Permission$canGoTo, model.aa4, model.lk.ahK, 54));
		};
		return function (options) {
			return $elm$core$List$isEmpty(options) ? $author$project$Utils$Html$empty : A4(
				$author$project$Ui$Dropdown$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Other ')
							]))
					]),
				options,
				model.oO);
		}(
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2(
						ifAllowed,
						$author$project$Api$Provider$CustomerInvoice$Meta$recordPaymentAction,
						A2(
							$author$project$Ui$Dropdown$item,
							_List_fromArray(
								[
									$author$project$Ui$Dropdown$onSelect(
									$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$RecordPayment(invoice)),
									$author$project$Ui$Dropdown$hiddenLg
								]),
							A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
								_List_fromArray(
									[
										$author$project$Ui$Icon$check(_List_Nil),
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Record Payment')
											]))
									])))),
						A2(
						ifAllowed,
						canRevise,
						A2(
							$author$project$Ui$Dropdown$item,
							_List_fromArray(
								[
									$author$project$Ui$Dropdown$onSelect(
									$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$Revise(invoice)),
									$author$project$Ui$Dropdown$hiddenLg
								]),
							A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
								_List_fromArray(
									[
										$author$project$Ui$Icon$edit(_List_Nil),
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Revise')
											]))
									])))),
						schedulePaymentsOption,
						A2(
						ifAllowed,
						$author$project$Api$Provider$CustomerInvoice$Meta$markAsBadDebtAction,
						A2(
							$author$project$Ui$Dropdown$item,
							_List_fromArray(
								[
									$author$project$Ui$Dropdown$onSelect($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$BadDebtHiConfirmOpened)
								]),
							A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
								_List_fromArray(
									[
										$author$project$Ui$Icon$stop(_List_Nil),
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Bad Debt')
											]))
									])))),
						A2(
						ifAllowed,
						$author$project$Api$Provider$CustomerInvoice$Meta$returnToDraftAction,
						A2(
							$author$project$Ui$Dropdown$item,
							_List_fromArray(
								[
									$author$project$Ui$Dropdown$onSelect(
									$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ReturnToDraftClicked(invoice))
								]),
							A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
								_List_fromArray(
									[
										$author$project$Ui$Icon$arrowLeft(
										_List_fromArray(
											[$author$project$Ui$Icon$xs])),
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Return To Draft')
											]))
									])))),
						A2(
						ifAllowed,
						$author$project$Api$Provider$CustomerInvoice$Meta$reverseBadDebtAction,
						A2(
							$author$project$Ui$Dropdown$item,
							_List_fromArray(
								[
									$author$project$Ui$Dropdown$onSelect(
									$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ReverseBadDebtClicked(invoice))
								]),
							A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
								_List_fromArray(
									[
										$author$project$Ui$Icon$arrowLeft(_List_Nil),
										$elm$html$Html$text('Return To Issued')
									])))),
						A2(
						ifAllowed,
						$author$project$Api$Provider$CustomerInvoice$Meta$cancel,
						A2(
							$author$project$Ui$Dropdown$item,
							_List_fromArray(
								[
									$author$project$Ui$Dropdown$onSelect(
									$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$Void(invoice))
								]),
							A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap2, $author$project$Ui$Element$textDanger, $author$project$Ui$Element$itemsCenter]),
								_List_fromArray(
									[
										$author$project$Ui$Icon$void(_List_Nil),
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Void')
											]))
									]))))
					])));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$Pay = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$PayWithPassthroughFees = function (a) {
	return {$: 12, a: a};
};
var $author$project$Api$Provider$CustomerInvoice$Meta$createPaymentAction = function (_v0) {
	var meta = _v0;
	return meta.vy.Zc;
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewProcessPayment = F2(
	function (model, invoice) {
		var usesCardReaders = $author$project$Api$Provider$Practice$One$usesCardReaders(model.ZV);
		var hasPaymentMethod = $author$project$Utils$Maybe$toBool(
			$author$project$Api$Provider$CustomerInvoice$One$source(invoice));
		var canCreatePaymentAction = $author$project$Api$Provider$CustomerInvoice$Meta$createPaymentAction(
			$author$project$Api$Provider$CustomerInvoice$One$meta(invoice));
		return (canCreatePaymentAction && ((hasPaymentMethod || usesCardReaders) && $author$project$Api$Provider$Patient$One$shouldChargeCreditCardFees(model.YY))) ? A3(
			$author$project$Ui$Button$view,
			{mm: 'Process payment'},
			_List_fromArray(
				[
					$author$project$Ui$Button$success,
					$author$project$Ui$Button$loading(
					_Utils_eq(model.Uk, $author$project$Api$Data$Loading)),
					$author$project$Ui$Button$onClick(
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$PayWithPassthroughFees(invoice)),
					$author$project$Ui$Button$icon($author$project$Ui$Icon$dollarSign)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Process Payment')
				])) : ((canCreatePaymentAction && (hasPaymentMethod || usesCardReaders)) ? A3(
			$author$project$Ui$Button$view,
			{mm: 'Process payment'},
			_List_fromArray(
				[
					$author$project$Ui$Button$success,
					$author$project$Ui$Button$loading(
					_Utils_eq(model.Uk, $author$project$Api$Data$Loading)),
					$author$project$Ui$Button$onClick(
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$Pay(invoice)),
					$author$project$Ui$Button$icon($author$project$Ui$Icon$dollarSign)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Process Payment')
				])) : ((canCreatePaymentAction && ((!hasPaymentMethod) && (!usesCardReaders))) ? A3(
			$author$project$Ui$Link$route,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__Accounts__Top(
				{YZ: model.YZ}),
			_List_fromArray(
				[$author$project$Ui$Link$buttonSuccess]),
			_List_fromArray(
				[
					$elm$html$Html$text('Add Payment Source')
				])) : $author$project$Utils$Html$empty));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ProcessRefund = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$permittedButton = F2(
	function (permitted, button) {
		return permitted ? button : A3(
			$author$project$Ui$Popover$view,
			_List_Nil,
			_List_fromArray(
				[button]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Popover$body,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Please contact your practice administrator to be granted permission.')
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewProcessRefund = F2(
	function (model, invoice) {
		if ($author$project$Api$Provider$CustomerInvoice$One$paidInCents(invoice) > 0) {
			var canIssueRefunds = A3($author$project$Permission$canGoTo, model.aa4, model.lk.ahK, 55);
			var buttonStyle = ($author$project$Api$Provider$CustomerInvoice$One$humanStatus(invoice) === 'paid') ? 4 : 6;
			return A2(
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$permittedButton,
				canIssueRefunds,
				A3(
					$author$project$Ui$Button$view,
					{mm: 'Process refund'},
					_List_fromArray(
						[
							$author$project$Ui$Button$styled(buttonStyle),
							$author$project$Ui$Button$loading(
							_Utils_eq(model.Uk, $author$project$Api$Data$Loading)),
							$author$project$Ui$Button$onClick(
							$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ProcessRefund(invoice)),
							$author$project$Ui$Button$disabled(!canIssueRefunds),
							$author$project$Ui$Button$icon($author$project$Ui$Icon$repeat)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Process Refund')
						])));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Ui$Button$Display = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Ui$Button$displayLg = A2($author$project$Ui$Button$Display, true, 3);
var $author$project$Ui$Button$hidden = A2($author$project$Ui$Button$Display, false, 0);
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewRecordPayment = F2(
	function (model, invoice) {
		return $author$project$Api$Provider$CustomerInvoice$Meta$recordPaymentAction(
			$author$project$Api$Provider$CustomerInvoice$One$meta(invoice)) ? A3(
			$author$project$Ui$Button$view,
			{mm: 'Record payment'},
			_List_fromArray(
				[
					$author$project$Ui$Button$secondary,
					$author$project$Ui$Button$loading(
					_Utils_eq(model.Uk, $author$project$Api$Data$Loading)),
					$author$project$Ui$Button$onClick(
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$RecordPayment(invoice)),
					$author$project$Ui$Button$icon($author$project$Ui$Icon$check),
					$author$project$Ui$Button$hidden,
					$author$project$Ui$Button$displayLg
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Record Payment')
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewRevise = F2(
	function (model, invoice) {
		var meta = $author$project$Api$Provider$CustomerInvoice$One$meta(invoice);
		if ($author$project$Api$Provider$CustomerInvoice$Meta$updateAction(meta) && $author$project$Api$Provider$CustomerInvoice$Meta$createAdjustment(meta)) {
			var canRevise = A3($author$project$Permission$canGoTo, model.aa4, model.lk.ahK, 54);
			return A2(
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$permittedButton,
				canRevise,
				A3(
					$author$project$Ui$Button$view,
					{mm: 'Revise invoice'},
					_List_fromArray(
						[
							$author$project$Ui$Button$styled(4),
							$author$project$Ui$Button$loading(
							_Utils_eq(model.Uk, $author$project$Api$Data$Loading)),
							$author$project$Ui$Button$onClick(
							$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$Revise(invoice)),
							$author$project$Ui$Button$disabled(!canRevise),
							$author$project$Ui$Button$icon($author$project$Ui$Icon$edit),
							$author$project$Ui$Button$hidden,
							$author$project$Ui$Button$displayLg
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Revise')
						])));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewHeader = F3(
	function (model, meta, invoice) {
		var statusLabel = function () {
			var _v1 = $author$project$Api$Provider$CustomerInvoice$One$humanStatus(invoice);
			if (_v1 === 'sent') {
				return A3(
					$author$project$Ui$Tooltip$view,
					_List_Nil,
					'on ' + A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							model.J7(0),
							$author$project$Api$Provider$CustomerInvoice$One$lastSentAt(invoice))),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Badge$fromString,
							_List_fromArray(
								[
									$author$project$Ui$Badge$test('invoice-status')
								]),
							$author$project$Api$Provider$CustomerInvoice$One$humanStatus(invoice))
						]));
			} else {
				return A2(
					$author$project$Ui$Badge$fromString,
					_List_fromArray(
						[
							$author$project$Ui$Badge$test('invoice-status')
						]),
					$author$project$Api$Provider$CustomerInvoice$One$humanStatus(invoice));
			}
		}();
		var markAsSentButton = $author$project$Api$Provider$CustomerInvoice$Meta$markAsSentAction(meta) ? A3(
			$author$project$Ui$Button$view,
			{mm: 'Mark as sent'},
			_List_fromArray(
				[
					$author$project$Ui$Button$link,
					$author$project$Ui$Button$sm,
					$author$project$Ui$Button$onClick(
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$MarkAsSentClicked(invoice))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Mark as Sent')
				])) : ($author$project$Api$Provider$CustomerInvoice$Meta$markAsUnsentAction(meta) ? A3(
			$author$project$Ui$Button$view,
			{mm: 'Mark as not sent'},
			_List_fromArray(
				[
					$author$project$Ui$Button$link,
					$author$project$Ui$Button$sm,
					$author$project$Ui$Button$onClick(
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$MarkAsUnsentClicked(invoice))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Mark as Not Sent')
				])) : ($author$project$Api$Provider$CustomerInvoice$Meta$stopRetryingAction(meta) ? A3(
			$author$project$Ui$Button$view,
			{mm: 'Stop retrying'},
			_List_fromArray(
				[
					$author$project$Ui$Button$link,
					$author$project$Ui$Button$sm,
					$author$project$Ui$Button$onClick(
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$StopRetryingClicked(invoice))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Stop Retrying')
				])) : $author$project$Utils$Html$empty));
		var emailButton = A2(
			$elm$core$Maybe$map,
			function (owner) {
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CustomerEmailModalMsg,
					A5(
						$author$project$Components$CustomerEmailModal$button,
						model.aa4,
						_List_fromArray(
							[$author$project$Components$CustomerEmailModal$sm]),
						0,
						$author$project$Api$Provider$CustomerInvoice$One$id(invoice),
						$author$project$Components$CustomerEmailModal$PatientShared(owner)));
			},
			$author$project$Api$Provider$CustomerInvoice$One$owner(invoice));
		var downloadPdfButton = A2(
			$elm$core$Maybe$map,
			function (securePdfInlineToken) {
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$DownloadInvoiceMsg,
					A4(
						$author$project$Components$Invoice$DownloadFile$view,
						model.jt,
						securePdfInlineToken,
						_List_fromArray(
							[
								$author$project$Components$Invoice$DownloadFile$label('Export to PDF'),
								$author$project$Components$Invoice$DownloadFile$tooltip(true)
							]),
						_List_fromArray(
							[$author$project$Ui$Button$sm])));
			},
			$author$project$Api$Provider$CustomerInvoice$One$securePdfInlineToken(invoice));
		var buttons = _List_fromArray(
			[
				A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewOtherDropdown, model, invoice),
				A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewProcessRefund, model, invoice),
				A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewRevise, model, invoice),
				A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewRecordPayment, model, invoice),
				A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewProcessPayment, model, invoice),
				A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewConvertToCreditButton, model, invoice)
			]);
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanLg(4),
									$author$project$Ui$Grid$span(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mb2, $author$project$Ui$Element$gap2]),
									_List_fromArray(
										[
											$author$project$Ui$Panel$title(
											_List_fromArray(
												[
													$elm$html$Html$text(
													'Invoice #' + $elm$core$String$fromInt(
														$author$project$Api$Provider$CustomerInvoice$One$invoiceNumber(invoice))),
													A2(
													$author$project$Ui$Typography$text,
													_List_fromArray(
														[$author$project$Ui$Typography$small]),
													' for '),
													(!_Utils_eq(
													$author$project$Api$Provider$CustomerInvoice$One$issuedTotalInCents(invoice),
													$author$project$Api$Provider$CustomerInvoice$One$totalInCents(invoice))) ? A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Typography$text,
															_List_fromArray(
																[$author$project$Ui$Typography$strike, $author$project$Ui$Typography$muted]),
															$author$project$Utils$Currency$fromInt(
																$author$project$Api$Provider$CustomerInvoice$One$issuedTotalInCents(invoice))),
															$author$project$Utils$Html$noBreakSpace
														])) : $author$project$Utils$Html$empty,
													A2($author$project$Ui$Typography$text, _List_Nil, ' '),
													$elm$html$Html$text(
													$author$project$Utils$Currency$fromInt(
														$author$project$Api$Provider$CustomerInvoice$One$totalInCents(invoice))),
													(!(!$author$project$Api$Provider$CustomerInvoice$One$revisionNumber(invoice))) ? A2(
													$author$project$Ui$Typography$text,
													_List_fromArray(
														[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
													' (rev. ' + ($elm$core$String$fromInt(
														$author$project$Api$Provider$CustomerInvoice$One$revisionNumber(invoice)) + ')')) : $author$project$Utils$Html$empty
												])),
											statusLabel
										])),
									function () {
									var _v0 = model.iw;
									if (!_v0.$) {
										var auditTrailLog = _v0.a;
										return A2(
											$author$project$Ui$Element$view,
											_List_Nil,
											$elm$core$List$singleton(
												A2(
													$elm$html$Html$map,
													$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$AuditTrailLogMsg,
													$author$project$Components$AuditTrailLog$view(auditTrailLog))));
									} else {
										return A2($author$project$Ui$Element$view, _List_Nil, _List_Nil);
									}
								}(),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$mt2, $author$project$Ui$Element$gap2]),
									A2(
										$elm$core$List$filterMap,
										$elm$core$Basics$identity,
										_List_fromArray(
											[
												emailButton,
												downloadPdfButton,
												$elm$core$Maybe$Just(markAsSentButton)
											])))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanLg(8),
									$author$project$Ui$Grid$span(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$wrap, $author$project$Ui$Element$gap2]),
									buttons)
								]))
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewHeaderSkeleton = A2(
	$author$project$Ui$Element$view,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanLg(4),
							$author$project$Ui$Grid$span(6)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Panel$title(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$spanFromText('Invoice #100 for $50.00')
										]))
								])),
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$block,
									$author$project$Ui$Skeleton$span(3)
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$mt2, $author$project$Ui$Element$spaceX2]),
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$span(2)
										])),
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$span(2)
										]))
								]))
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanLg(8),
							$author$project$Ui$Grid$span(6)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$wrap, $author$project$Ui$Element$spaceX2]),
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$input(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$span(2)
										])),
									$author$project$Ui$Skeleton$input(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$span(2)
										]))
								]))
						]))
				]))
		]));
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewHiConfirmModals = F2(
	function (model, invoice_) {
		if (model.i7) {
			var due = $author$project$Utils$Currency$fromInt(
				$author$project$Api$Provider$CustomerInvoice$One$dueInCents(invoice_));
			var deleteInvoiceModalText = 'You\'re about to delete Invoice #' + ($elm$core$String$fromInt(
				$author$project$Api$Provider$CustomerInvoice$One$invoiceNumber(invoice_)) + (' for ' + (due + '. This action cannot be undone.')));
			return A2(
				$author$project$Components$HiConfirm$modal,
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$DeleteInvoiceHiConfirmClosed,
				_List_fromArray(
					[
						$author$project$Components$HiConfirm$verb('delete'),
						$author$project$Components$HiConfirm$noun('invoice'),
						$author$project$Components$HiConfirm$customMessage(
						_List_fromArray(
							[
								$elm$html$Html$text(deleteInvoiceModalText)
							]))
					]));
		} else {
			if (model.iy) {
				var modalHeaderText = 'invoice #' + ($elm$core$String$fromInt(
					$author$project$Api$Provider$CustomerInvoice$One$invoiceNumber(invoice_)) + ' as bad debt');
				var modalBodyText = '\n                Marking an invoice as bad debt will remove it from your outstanding invoices report,\n                but your revenue is unaffected, and it remains on the patient\'s balance\n                ';
				return A2(
					$author$project$Components$HiConfirm$modal,
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$BadDebtHiConfirmClosed,
					_List_fromArray(
						[
							$author$project$Components$HiConfirm$verb('mark'),
							$author$project$Components$HiConfirm$noun(modalHeaderText),
							$author$project$Components$HiConfirm$customMessage(
							_List_fromArray(
								[
									$elm$html$Html$text(modalBodyText)
								]))
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}
	});
var $author$project$Api$Provider$CustomerInvoice$One$adjustments = function (_v0) {
	var record = _v0.b;
	return record.Lb;
};
var $author$project$Formatters$Time$Time__Only = 3;
var $author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$createdAt = function (_v0) {
	var record = _v0.b;
	return record.O1;
};
var $author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$position = function (_v0) {
	var record = _v0.b;
	return record.ZP;
};
var $author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$reason = function (_v0) {
	var record = _v0.b;
	return record._7;
};
var $author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$totalAdjustmentInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$InvoiceAdjustment$Shared$totalAdjustmentInCents(shared);
};
var $author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$user = function (_v0) {
	var record = _v0.b;
	return record.ad0;
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewInvoiceRevision = F2(
	function (timeFormatter, adjustment) {
		var totalAdjustment = $author$project$Utils$Currency$fromInt(
			$author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$totalAdjustmentInCents(adjustment));
		var revisionDescription = $elm$html$Html$text(
			$elm$core$String$concat(
				_List_fromArray(
					[
						'Revision #',
						$elm$core$String$fromInt(
						$author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$position(adjustment)),
						' by ',
						A2(
						$elm$core$Maybe$withDefault,
						'N/A',
						A2(
							$elm$core$Maybe$map,
							$author$project$Api$Provider$User$Shared$name,
							$author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$user(adjustment))),
						' at ',
						A2(
						timeFormatter,
						3,
						$author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$createdAt(adjustment))
					])));
		var revisionAmount = ($author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$totalAdjustmentInCents(adjustment) < 0) ? A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$flex, $author$project$Ui$Element$justifyRight]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$strong,
					_List_fromArray(
						[$author$project$Ui$Typography$danger]),
					_List_fromArray(
						[
							$elm$html$Html$text(totalAdjustment)
						]))
				])) : A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$flex, $author$project$Ui$Element$justifyRight]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$strong,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(totalAdjustment)
						]))
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('revision__item')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(2)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										timeFormatter,
										5,
										$author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$createdAt(adjustment)))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(7)
								]),
							_List_fromArray(
								[
									revisionDescription,
									function () {
									var _v0 = $author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$reason(adjustment);
									if (!_v0.$) {
										var reason = _v0.a;
										return A2(
											$author$project$Ui$Typography$p,
											_List_fromArray(
												[$author$project$Ui$Typography$helpBlock, $author$project$Ui$Typography$small]),
											_List_fromArray(
												[
													$elm$html$Html$text(reason)
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(2)
								]),
							_List_fromArray(
								[revisionAmount])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(1)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('')
								]))
						]))
				]));
	});
var $author$project$Api$Provider$CustomerInvoice$One$voidReason = function (_v0) {
	var record = _v0.b;
	return record.amq;
};
var $author$project$Api$Provider$CustomerInvoice$One$voidedAt = function (_v0) {
	var record = _v0.b;
	return record.ael;
};
var $author$project$Api$Provider$CustomerInvoice$One$voidedByName = function (_v0) {
	var record = _v0.b;
	return record.aem;
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewVoidRevision = F2(
	function (timeFormatter, invoice) {
		var voidDescription = function () {
			var _v1 = _Utils_Tuple2(
				$author$project$Api$Provider$CustomerInvoice$One$voidedByName(invoice),
				$author$project$Api$Provider$CustomerInvoice$One$voidedAt(invoice));
			if ((!_v1.a.$) && (!_v1.b.$)) {
				var name = _v1.a.a;
				var time = _v1.b.a;
				return A2(
					$author$project$Ui$Typography$text,
					_List_Nil,
					$elm$core$String$concat(
						_List_fromArray(
							[
								name,
								' at ',
								A2(timeFormatter, 3, time)
							])));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('revision__item--voided')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(2)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											timeFormatter(5),
											$author$project$Api$Provider$CustomerInvoice$One$voidedAt(invoice))))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(7)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Voided by '),
									voidDescription,
									function () {
									var _v0 = $author$project$Api$Provider$CustomerInvoice$One$voidReason(invoice);
									if (!_v0.$) {
										var reason = _v0.a;
										return A2(
											$author$project$Ui$Typography$p,
											_List_fromArray(
												[$author$project$Ui$Typography$helpBlock, $author$project$Ui$Typography$small]),
											_List_fromArray(
												[
													$elm$html$Html$text(reason)
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(3)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('')
								]))
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewInvoiceRevisions = function (model) {
	var _v0 = model.Uk;
	if (_v0.$ === 3) {
		var invoice = _v0.a;
		var isVoided = ($author$project$Api$Provider$CustomerInvoice$One$humanStatus(invoice) === 'cancelled') && $author$project$Utils$Maybe$toBool(
			$author$project$Api$Provider$CustomerInvoice$One$voidedAt(invoice));
		var adjustments = A2(
			$author$project$Api$Expandable$withDefault,
			_List_Nil,
			$author$project$Api$Provider$CustomerInvoice$One$adjustments(invoice));
		var adjustmentsCount = isVoided ? ($elm$core$List$length(adjustments) + 1) : $elm$core$List$length(adjustments);
		return (adjustmentsCount > 0) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('invoice-revisions mt-4')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$title,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Invoice Revisions')
								])),
							A2(
							$author$project$Ui$Badge$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(adjustmentsCount))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewInvoiceRevision(model.J7),
						adjustments)),
					isVoided ? A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewVoidRevision, model.J7, invoice) : $author$project$Utils$Html$empty
				])) : $author$project$Utils$Html$empty;
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$Issue = function (a) {
	return {$: 20, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewIssueButton = F2(
	function (model, invoice) {
		if ($author$project$Api$Provider$CustomerInvoice$Meta$issueAction(
			$author$project$Api$Provider$CustomerInvoice$One$meta(invoice))) {
			var due = $author$project$Utils$Currency$fromInt(
				$author$project$Api$Provider$CustomerInvoice$One$dueInCents(invoice));
			var buttonText = 'Issue ' + (due + ' Invoice');
			return A3(
				$author$project$Ui$Button$view,
				{mm: buttonText},
				_List_fromArray(
					[
						$author$project$Ui$Button$primary,
						$author$project$Ui$Button$loading(model.od),
						$author$project$Ui$Button$onClick(
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$Issue(invoice))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(buttonText)
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewDefaultSourceFromList = function (model) {
	var allSources = function () {
		var _v0 = _Utils_Tuple2(model.rC, model.rs);
		if ((_v0.a.$ === 3) && (_v0.b.$ === 3)) {
			var _v1 = _v0.a;
			var cards = _v1.a;
			var _v2 = _v0.b;
			var bankAccounts = _v2.a;
			return $elm$core$List$reverse(
				A2(
					$elm$core$List$sortBy,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Api$Source$createdAt,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$map($elm$time$Time$posixToMillis),
							$elm$core$Maybe$withDefault(0))),
					_Utils_ap(
						A2($elm$core$List$map, $author$project$Api$Source$Card, cards),
						A2($elm$core$List$map, $author$project$Api$Source$BankAccount, bankAccounts))));
		} else {
			return _List_Nil;
		}
	}();
	var defaultSource = $elm$core$List$head(
		A2($elm$core$List$filter, $author$project$Api$Source$default, allSources));
	return (!_Utils_eq(defaultSource, $elm$core$Maybe$Nothing)) ? defaultSource : $elm$core$List$head(allSources);
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$UnschedulePaymentClicked = function (a) {
	return {$: 32, a: a};
};
var $author$project$Api$Provider$CustomerInvoice$Shared$paymentScheduledOn = function (_v0) {
	var record = _v0;
	return record.Zf;
};
var $author$project$Api$Provider$CustomerInvoice$One$paymentScheduledOn = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CustomerInvoice$Shared$paymentScheduledOn(shared);
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewScheduledPayment = F2(
	function (timeFormatter, invoice) {
		if ($author$project$Api$Provider$CustomerInvoice$One$isPaymentScheduled(invoice)) {
			var paymentScheduledOn = A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
					$author$project$Api$Provider$CustomerInvoice$One$paymentScheduledOn(invoice)));
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('payment__scheduled')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$span(2)
									]),
								_List_fromArray(
									[
										A2($author$project$Ui$Typography$text, _List_Nil, paymentScheduledOn)
									])),
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$span(7)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Api$Provider$CustomerInvoice$One$hasGoodPaymentSource(invoice) ? A2($author$project$Ui$Badge$fromString, _List_Nil, 'scheduled') : A2($author$project$Ui$Badge$fromString, _List_Nil, 'scheduled_without_source')
											])),
										$elm$html$Html$text(' '),
										function () {
										var _v0 = $author$project$Api$Provider$CustomerInvoice$One$membershipPaymentSource(invoice);
										if (!_v0.$) {
											var source = _v0.a;
											return A2(
												$elm$html$Html$span,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('on '),
														A2(
														$author$project$Components$PaymentSourceDisplayer$view,
														timeFormatter,
														_List_fromArray(
															[
																$author$project$Components$PaymentSourceDisplayer$source(
																$elm$core$Maybe$Just(
																	$author$project$Api$Source$Source(source))),
																$author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus(false),
																$author$project$Components$PaymentSourceDisplayer$limitedView(true)
															]))
													]));
										} else {
											var _v1 = $author$project$Api$Provider$CustomerInvoice$One$source(invoice);
											if (!_v1.$) {
												var source = _v1.a;
												return A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('on '),
															A2(
															$author$project$Components$PaymentSourceDisplayer$view,
															timeFormatter,
															_List_fromArray(
																[
																	$author$project$Components$PaymentSourceDisplayer$source(
																	$elm$core$Maybe$Just(
																		$author$project$Api$Source$Source(source))),
																	$author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus(false),
																	$author$project$Components$PaymentSourceDisplayer$limitedView(true)
																]))
														]));
											} else {
												return A2($author$project$Ui$Typography$text, _List_Nil, 'No payment info');
											}
										}
									}()
									])),
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$span(2),
										$author$project$Ui$Grid$justifyRight
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Utils$Currency$fromInt(
													$author$project$Api$Provider$CustomerInvoice$One$dueInCents(invoice)))
											]))
									])),
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$span(1)
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Unschedule payment'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$sm,
												$author$project$Ui$Button$onClick(
												$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$UnschedulePaymentClicked(invoice))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Unschedule')
											]))
									]))
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewScheduledPaymentRow = F4(
	function (patient, timeFormatter, scheduledPayment, defaultSource) {
		var totalInCents = $author$project$Utils$Currency$fromInt(
			$author$project$Api$Provider$ScheduledPayment$Shared$amountInCents(scheduledPayment) + ($author$project$Api$Provider$Patient$One$shouldChargeCreditCardFees(patient) ? A2(
				$elm$core$Maybe$withDefault,
				0,
				$author$project$Api$Provider$ScheduledPayment$Shared$passthroughFeesInCents(scheduledPayment)) : 0));
		var humanStatus = function () {
			var _v4 = $author$project$Api$Provider$ScheduledPayment$Shared$payment(scheduledPayment);
			if (!_v4.$) {
				var payment_ = _v4.a;
				return $author$project$Api$Provider$Payment$One$status(payment_);
			} else {
				return $author$project$Api$Provider$ScheduledPayment$Shared$status(scheduledPayment);
			}
		}();
		var _v0 = function () {
			var _v1 = $author$project$Api$Provider$ScheduledPayment$Shared$paymentSource(scheduledPayment);
			if (!_v1.$) {
				var source = _v1.a;
				return _Utils_Tuple2(
					$elm$html$Html$text('on '),
					A2(
						$author$project$Components$PaymentSourceDisplayer$view,
						timeFormatter,
						_List_fromArray(
							[
								$author$project$Components$PaymentSourceDisplayer$source(
								$elm$core$Maybe$Just(
									$author$project$Api$Source$Source(source))),
								$author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus(true),
								$author$project$Components$PaymentSourceDisplayer$limitedView(true)
							])));
			} else {
				return (!_Utils_eq(defaultSource, $elm$core$Maybe$Nothing)) ? _Utils_Tuple2(
					$elm$html$Html$text('on '),
					A2(
						$author$project$Components$PaymentSourceDisplayer$view,
						timeFormatter,
						_List_fromArray(
							[
								$author$project$Components$PaymentSourceDisplayer$source(defaultSource),
								$author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus(true),
								$author$project$Components$PaymentSourceDisplayer$limitedView(true)
							]))) : _Utils_Tuple2(
					$elm$html$Html$text('No payment info'),
					$author$project$Utils$Html$empty);
			}
		}();
		var paymentInfoText = _v0.a;
		var paymentInfoHtml = _v0.b;
		return A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$span(2)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$text,
							_List_Nil,
							A2(
								$author$project$Formatters$Date$toString,
								$author$project$Formatters$Date$Full,
								$author$project$Api$Provider$ScheduledPayment$Shared$scheduledOn(scheduledPayment)))
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$span(7)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$Ui$Badge$fromString, _List_Nil, humanStatus),
									$elm$html$Html$text(' '),
									paymentInfoText,
									paymentInfoHtml,
									function () {
									var _v2 = $author$project$Api$Provider$ScheduledPayment$Shared$memo(scheduledPayment);
									if (!_v2.$) {
										var memo = _v2.a;
										return A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[
													$author$project$Ui$Typography$phi(true)
												]),
											' - ' + memo);
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								])),
							function () {
							var _v3 = $author$project$Api$Provider$ScheduledPayment$Shared$payment(scheduledPayment);
							if (!_v3.$) {
								var payment = _v3.a;
								return A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											'Created by ' + (A2(
												$elm$core$Maybe$withDefault,
												'this platform',
												A2(
													$elm$core$Maybe$map,
													$author$project$Api$Provider$Payment$Creator$displayName,
													$author$project$Api$Provider$Payment$One$createdBy(payment))) + (' on ' + A2(
												timeFormatter,
												0,
												$author$project$Api$Provider$Payment$One$createdAt(payment)))))
										]));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$span(2),
							$author$project$Ui$Grid$justifyRight
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(totalInCents)
								]))
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewScheduledPaymentList = F5(
	function (patient, timeFormatter, scheduledPayments, payments, defaultSource) {
		var existingPaymentIds = A2(
			$elm$core$List$map,
			function (p) {
				return $author$project$Api$Payment$id(p);
			},
			payments);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('payment__scheduled')
				]),
			A2(
				$elm$core$List$map,
				function (scheduledPayment) {
					var _v0 = $author$project$Api$Provider$ScheduledPayment$Shared$payment(scheduledPayment);
					if (!_v0.$) {
						var scheduledPaymentPayment_ = _v0.a;
						return A2(
							$elm$core$List$member,
							$author$project$Api$Provider$Payment$One$id(scheduledPaymentPayment_),
							existingPaymentIds) ? $author$project$Utils$Html$empty : A4($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewScheduledPaymentRow, patient, timeFormatter, scheduledPayment, defaultSource);
					} else {
						return A4($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewScheduledPaymentRow, patient, timeFormatter, scheduledPayment, defaultSource);
					}
				},
				scheduledPayments));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewPaymentsList = F2(
	function (model, invoice) {
		var showScheduledPayments = A2(
			$author$project$Utils$FeatureGate$gateAvailable,
			12,
			$author$project$Api$Practice$Provider(model.ZV)) && (!$elm$core$List$isEmpty(model.la));
		var payments = A2(
			$elm$core$List$map,
			$author$project$Api$Payment$Provider_One,
			A2(
				$author$project$Api$Expandable$withDefault,
				_List_Nil,
				$author$project$Api$Provider$CustomerInvoice$One$payments(invoice)));
		return ((!$elm$core$List$isEmpty(payments)) || ($author$project$Api$Provider$CustomerInvoice$One$isPaymentScheduled(invoice) || showScheduledPayments)) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('payments-history mb-4'),
					$author$project$Utils$Html$Attributes$test('payments-history')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(8)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$title,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Payments')
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(4),
									$author$project$Ui$Grid$justifyRight
								]),
							_List_fromArray(
								[
									(showScheduledPayments && ($author$project$Api$Provider$CustomerInvoice$Meta$schedulePartialPaymentsAction(
									$author$project$Api$Provider$CustomerInvoice$One$meta(invoice)) && (!$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewEditButtonDisabled(invoice)))) ? A3(
									$author$project$Ui$Button$view,
									{mm: 'Edit scheduled payments'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$icon($author$project$Ui$Icon$edit),
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$SchedulePartialPaymentsClicked(invoice))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit Scheduled Payments')
										])) : $author$project$Utils$Html$empty
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(1)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('')
								]))
						])),
					A2(
					$elm$html$Html$map,
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$PaymentsListMsg,
					A3(
						$author$project$Components$PaymentsList$view,
						_List_fromArray(
							[
								$author$project$Components$PaymentsList$showCreatedBy(true),
								$author$project$Components$PaymentsList$showRefundMemo(true),
								$author$project$Components$PaymentsList$allowDisputes(true),
								$author$project$Components$PaymentsList$isHintAdmin(model.Ij)
							]),
						payments,
						model.kD)),
					showScheduledPayments ? A5(
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewScheduledPaymentList,
					model.YY,
					model.J7,
					model.la,
					payments,
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewDefaultSourceFromList(model)) : A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewScheduledPayment, model.J7, invoice)
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Api$Provider$CustomerInvoice$Shared$estimatedDueInCents = function (_v0) {
	var record = _v0;
	return record.RP;
};
var $author$project$Api$Provider$CustomerInvoice$One$estimatedDueInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CustomerInvoice$Shared$estimatedDueInCents(shared);
};
var $author$project$Api$Provider$CustomerInvoice$Shared$subtotalInCents = function (_v0) {
	var record = _v0;
	return record.acD;
};
var $author$project$Api$Provider$CustomerInvoice$One$subtotalInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CustomerInvoice$Shared$subtotalInCents(shared);
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ApplyCreditsClicked = function (a) {
	return {$: 28, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$RemoveCreditsClicked = function (a) {
	return {$: 29, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ReverseCreditTransferClicked = function (a) {
	return {$: 31, a: a};
};
var $author$project$Api$Provider$CustomerInvoice$Meta$applyCreditsAction = function (_v0) {
	var meta = _v0;
	return meta.vy.LX;
};
var $author$project$Api$Provider$CustomerInvoice$Shared$creditInCents = function (_v0) {
	var record = _v0;
	return record.O7;
};
var $author$project$Api$Provider$CustomerInvoice$One$creditInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CustomerInvoice$Shared$creditInCents(shared);
};
var $author$project$Api$Provider$CustomerInvoice$One$creditToAutoApplyInCents = function (_v0) {
	var record = _v0.b;
	return record.O8;
};
var $author$project$Api$Provider$CustomerInvoice$Meta$removeCreditsAction = function (_v0) {
	var meta = _v0;
	return meta.vy.$u;
};
var $author$project$Api$Provider$CustomerInvoice$Meta$reverseCreditTransferAction = function (_v0) {
	var meta = _v0;
	return meta.vy.$2;
};
var $author$project$Api$Provider$CustomerInvoice$One$transferredToCreditInCents = function (_v0) {
	var record = _v0.b;
	return record.adA;
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewCreditDetail = F3(
	function (invoice, customerInvoiceMeta, hasPassthoughFees) {
		if ((!(!$author$project$Api$Provider$CustomerInvoice$One$creditInCents(invoice))) || (!(!$author$project$Api$Provider$CustomerInvoice$One$creditToAutoApplyInCents(invoice)))) {
			var creditTotal = $author$project$Api$Provider$CustomerInvoice$One$creditInCents(invoice) + $author$project$Api$Provider$CustomerInvoice$One$creditToAutoApplyInCents(invoice);
			return A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$offsetMd(7),
								$author$project$Ui$Grid$spanMd(4),
								$author$project$Ui$Grid$span(11)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$label,
										_List_fromArray(
											[$author$project$Ui$Typography$hintLabel, $author$project$Ui$Typography$m0, $author$project$Ui$Typography$p0]),
										_List_fromArray(
											[
												$elm$html$Html$text('Credit')
											])),
										hasPassthoughFees ? A2(
										$author$project$Ui$Typography$text,
										_List_Nil,
										$author$project$Utils$Currency$fromInt(-creditTotal)) : $author$project$Ui$Typography$headingSm(
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Utils$Currency$fromInt(-creditTotal))
											]))
									]))
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(1)
							]),
						_List_fromArray(
							[
								$author$project$Api$Provider$CustomerInvoice$Meta$removeCreditsAction(customerInvoiceMeta) ? A3(
								$author$project$Ui$Button$view,
								{mm: 'Remove credit'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$sm,
										$author$project$Ui$Button$onClick(
										$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$RemoveCreditsClicked(invoice))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Remove')
									])) : $author$project$Utils$Html$empty
							]))
					]));
		} else {
			if ($author$project$Api$Provider$CustomerInvoice$Meta$applyCreditsAction(customerInvoiceMeta)) {
				return A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$offsetMd(7),
									$author$project$Ui$Grid$spanMd(4),
									$author$project$Ui$Grid$span(11)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$label,
											_List_fromArray(
												[$author$project$Ui$Typography$hintLabel, $author$project$Ui$Typography$m0, $author$project$Ui$Typography$p0]),
											_List_fromArray(
												[
													$elm$html$Html$text('Credit')
												])),
											hasPassthoughFees ? A2(
											$author$project$Ui$Typography$text,
											_List_Nil,
											$author$project$Utils$Currency$fromInt(0)) : $author$project$Ui$Typography$headingSm(
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Utils$Currency$fromInt(0))
												]))
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(1)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Apply credits'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ApplyCreditsClicked(invoice))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Apply')
										]))
								]))
						]));
			} else {
				if ($author$project$Api$Provider$CustomerInvoice$One$transferredToCreditInCents(invoice) > 0) {
					return A2(
						$author$project$Ui$Grid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$offsetMd(7),
										$author$project$Ui$Grid$spanMd(4),
										$author$project$Ui$Grid$span(11)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$label,
												_List_fromArray(
													[$author$project$Ui$Typography$hintLabel, $author$project$Ui$Typography$m0, $author$project$Ui$Typography$p0]),
												_List_fromArray(
													[
														$elm$html$Html$text('Transferred to Credit')
													])),
												$author$project$Ui$Typography$headingSm(
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Utils$Currency$fromInt(
															$author$project$Api$Provider$CustomerInvoice$One$transferredToCreditInCents(invoice)))
													]))
											]))
									])),
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$span(1)
									]),
								_List_fromArray(
									[
										$author$project$Api$Provider$CustomerInvoice$Meta$reverseCreditTransferAction(customerInvoiceMeta) ? A3(
										$author$project$Ui$Button$view,
										{mm: 'Undo credit transfer'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$sm,
												$author$project$Ui$Button$onClick(
												$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ReverseCreditTransferClicked(invoice))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Undo')
											])) : $author$project$Utils$Html$empty
									]))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}
		}
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$effectivePaymentSourceIsACreditCard = F4(
	function (practice, invoice, cards, scheduledPayments) {
		if ($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$allScheduledPaymentsAreNonCard(scheduledPayments)) {
			return false;
		} else {
			var _v0 = $author$project$Api$Provider$Practice$One$allowMultipleRetailMemberships(practice) ? $author$project$Api$Provider$CustomerInvoice$One$membershipPaymentSource(invoice) : $elm$core$Maybe$Nothing;
			if (!_v0.$) {
				var source = _v0.a;
				return _Utils_eq(
					$author$project$Api$Common$Source$Shared$type_(source),
					$elm$core$Maybe$Just('Card'));
			} else {
				return !_Utils_eq(
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewDefaultCard(cards),
					$elm$core$Maybe$Nothing);
			}
		}
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$passthroughFeesInCents = function (passthroughFees) {
	if (passthroughFees.$ === 3) {
		var passthrough = passthroughFees.a;
		return $author$project$Api$Provider$PassthroughFee$One$passthroughFeeInCents(passthrough);
	} else {
		return 0;
	}
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$passthroughFeesTotalAmount = function (passthroughFees) {
	if (passthroughFees.$ === 3) {
		var passthrough = passthroughFees.a;
		return $author$project$Api$Provider$PassthroughFee$One$totalInCents(passthrough);
	} else {
		return 0;
	}
};
var $author$project$Api$Provider$TaxProfile$Shared$forDisplay = function (taxProfile) {
	return $elm$core$String$concat(
		_List_fromArray(
			[
				$author$project$Api$Provider$TaxProfile$Shared$name(taxProfile),
				$author$project$Utils$String$noBreakSpace,
				'Tax',
				$author$project$Utils$String$noBreakSpace,
				$elm$core$String$fromFloat(
				$author$project$Api$Provider$TaxProfile$Shared$rate(taxProfile)),
				'%'
			]));
};
var $author$project$Api$Provider$CustomerInvoice$Shared$taxInCents = function (_v0) {
	var record = _v0;
	return record.acV;
};
var $author$project$Api$Provider$CustomerInvoice$One$taxInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CustomerInvoice$Shared$taxInCents(shared);
};
var $author$project$Api$Provider$CustomerInvoice$One$taxProfile = function (_v0) {
	var record = _v0.b;
	return record.acX;
};
var $author$project$Api$Provider$CustomerInvoice$Meta$taxProfileEditable = function (_v0) {
	var meta = _v0;
	return meta.acX.Q4;
};
var $author$project$Api$Provider$CustomerInvoice$Meta$taxProfileViewable = function (_v0) {
	var meta = _v0;
	return meta.acX.aeh;
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTaxDetailWithLabel = F3(
	function (invoice, hasPassthoughFees, label) {
		return A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$offsetMd(7),
							$author$project$Ui$Grid$spanMd(4),
							$author$project$Ui$Grid$span(11)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
							_List_fromArray(
								[
									label,
									hasPassthoughFees ? A2(
									$author$project$Ui$Typography$text,
									_List_Nil,
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$CustomerInvoice$One$taxInCents(invoice))) : $author$project$Ui$Typography$headingSm(
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Utils$Currency$fromInt(
												$author$project$Api$Provider$CustomerInvoice$One$taxInCents(invoice)))
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$TaxProfileChanged = function (a) {
	return {$: 43, a: a};
};
var $author$project$Api$Provider$TaxProfile$One$forDisplay = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$TaxProfile$Shared$forDisplay(shared);
};
var $author$project$Api$Provider$TaxProfile$All$forDisplay = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$TaxProfile$One$forDisplay(one);
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTaxProfileOption = function (taxProfile) {
	return A2(
		$author$project$Ui$Dropdown$item,
		_List_fromArray(
			[
				$author$project$Ui$Dropdown$onSelect(
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$TaxProfileChanged(taxProfile))
			]),
		A2(
			$author$project$Ui$Typography$text,
			_List_fromArray(
				[$author$project$Ui$Typography$hintLabel]),
			$author$project$Api$Provider$TaxProfile$All$forDisplay(taxProfile)));
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTaxDetail = F5(
	function (invoice, customerInvoiceMeta, taxProfiles, taxProfileDropdown, hasPassthoughFees) {
		var taxProfileIsViewable = $author$project$Api$Provider$CustomerInvoice$Meta$taxProfileViewable(customerInvoiceMeta) || (!(!$author$project$Api$Provider$CustomerInvoice$One$taxInCents(invoice)));
		var taxProfileIsEditable = $author$project$Api$Provider$CustomerInvoice$Meta$taxProfileEditable(customerInvoiceMeta);
		var maybeTaxProfile = $author$project$Api$Provider$CustomerInvoice$One$taxProfile(invoice);
		var _v0 = _Utils_Tuple3(taxProfileIsViewable, taxProfileIsEditable, maybeTaxProfile);
		_v0$2:
		while (true) {
			if (_v0.a) {
				if (_v0.b) {
					var currentTaxProfileLabel = A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							$author$project$Api$Provider$TaxProfile$Shared$forDisplay,
							$author$project$Api$Provider$CustomerInvoice$One$taxProfile(invoice)));
					return A3(
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTaxDetailWithLabel,
						invoice,
						hasPassthoughFees,
						A4(
							$author$project$Ui$Dropdown$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$hintLabel]),
									currentTaxProfileLabel)
								]),
							A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTaxProfileOption, taxProfiles),
							taxProfileDropdown));
				} else {
					if (!_v0.c.$) {
						var taxProfile = _v0.c.a;
						return A3(
							$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTaxDetailWithLabel,
							invoice,
							hasPassthoughFees,
							A2(
								$author$project$Ui$Typography$label,
								_List_fromArray(
									[$author$project$Ui$Typography$hintLabel, $author$project$Ui$Typography$m0, $author$project$Ui$Typography$p0]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Api$Provider$TaxProfile$Shared$forDisplay(taxProfile))
									])));
					} else {
						break _v0$2;
					}
				}
			} else {
				break _v0$2;
			}
		}
		return $author$project$Utils$Html$empty;
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTotalDetail = F2(
	function (label, content) {
		return A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$offsetMd(7),
							$author$project$Ui$Grid$spanMd(4),
							$author$project$Ui$Grid$span(11)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$label,
									_List_fromArray(
										[$author$project$Ui$Typography$hintLabel, $author$project$Ui$Typography$m0, $author$project$Ui$Typography$p0]),
									_List_fromArray(
										[
											$elm$html$Html$text(label)
										])),
									content
								]))
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTotalDetailInBold = F2(
	function (label, content) {
		return A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$offsetMd(7),
							$author$project$Ui$Grid$spanMd(4),
							$author$project$Ui$Grid$span(11)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$label,
									_List_fromArray(
										[$author$project$Ui$Typography$hintLabel, $author$project$Ui$Typography$m0, $author$project$Ui$Typography$p0]),
									_List_fromArray(
										[
											$elm$html$Html$text(label)
										])),
									$author$project$Ui$Typography$headingSm(
									_List_fromArray(
										[content]))
								]))
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewNewInvoiceTotalsSummary = F5(
	function (model, invoice, meta, taxProfiles, dueTotal) {
		var totalToHtml = function (value) {
			return $elm$html$Html$text(
				$author$project$Utils$Currency$fromInt(value));
		};
		var invoiceHumanStatus = $author$project$Api$Provider$CustomerInvoice$One$humanStatus(invoice);
		var showCreditCardFeesForDueAmount = $author$project$Api$Provider$Patient$One$shouldChargeCreditCardFees(model.YY) && (A4($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$effectivePaymentSourceIsACreditCard, model.ZV, invoice, model.rC, model.la) && A2(
			$elm$core$List$member,
			invoiceHumanStatus,
			_List_fromArray(
				['issued', 'sent', 'retrying'])));
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mt4]),
			_List_fromArray(
				[
					A2(
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTotalDetail,
					'Subtotal',
					totalToHtml(
						$author$project$Api$Provider$CustomerInvoice$One$subtotalInCents(invoice))),
					A5($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTaxDetail, invoice, meta, taxProfiles, model.lJ, true),
					A2(
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTotalDetailInBold,
					'Invoice Total',
					totalToHtml(
						$author$project$Api$Provider$CustomerInvoice$One$totalInCents(invoice))),
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$offsetMd(7),
									$author$project$Ui$Grid$spanMd(4)
								]),
							_List_fromArray(
								[
									$author$project$Ui$HorizontalRule$view(
									_List_fromArray(
										[$author$project$Ui$HorizontalRule$minimal]))
								]))
						])),
					A3($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewCreditDetail, invoice, meta, true),
					(invoiceHumanStatus !== 'draft') ? A2(
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTotalDetail,
					'Paid',
					totalToHtml(
						$author$project$Api$Provider$CustomerInvoice$One$paidInCents(invoice) * (-1))) : $author$project$Utils$Html$empty,
					(!(!$author$project$Api$Provider$CustomerInvoice$One$passthroughFeesInCents(invoice))) ? A2(
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTotalDetail,
					'Credit Card Fees Paid',
					totalToHtml(
						$author$project$Api$Provider$CustomerInvoice$One$passthroughFeesInCents(invoice) * (-1))) : $author$project$Utils$Html$empty,
					(invoiceHumanStatus !== 'draft') ? A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$offsetMd(7),
									$author$project$Ui$Grid$spanMd(4)
								]),
							_List_fromArray(
								[
									$author$project$Ui$HorizontalRule$view(
									_List_fromArray(
										[$author$project$Ui$HorizontalRule$minimal]))
								]))
						])) : $author$project$Utils$Html$empty,
					showCreditCardFeesForDueAmount ? A2(
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTotalDetail,
					'Total Credit Card Fees',
					totalToHtml(
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$passthroughFeesInCents(model.YV))) : $author$project$Utils$Html$empty,
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$offsetMd(7),
									$author$project$Ui$Grid$spanMd(4),
									$author$project$Ui$Grid$span(11)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$label,
											_List_fromArray(
												[$author$project$Ui$Typography$hintLabel, $author$project$Ui$Typography$m0, $author$project$Ui$Typography$p0]),
											_List_fromArray(
												[
													$elm$html$Html$text('Due')
												])),
											showCreditCardFeesForDueAmount ? $author$project$Ui$Typography$heading(
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Utils$Currency$fromInt(
														$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$passthroughFeesTotalAmount(model.YV)))
												])) : $author$project$Ui$Typography$heading(
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Utils$Currency$fromInt(dueTotal))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTotals = function (model) {
	var _v0 = _Utils_Tuple2(model.Uk, model.hU);
	if ((_v0.a.$ === 3) && (_v0.b.$ === 3)) {
		var _v1 = _v0.a;
		var invoice = _v1.a;
		var _v2 = _v0.b;
		var taxProfiles = _v2.a;
		var totalToHtml = function (value) {
			return $elm$html$Html$text(
				$author$project$Utils$Currency$fromInt(value));
		};
		var meta = $author$project$Api$Provider$CustomerInvoice$One$meta(invoice);
		var invoiceHumanStatus = $author$project$Api$Provider$CustomerInvoice$One$humanStatus(invoice);
		var dueTotal = (invoiceHumanStatus === 'draft') ? $author$project$Api$Provider$CustomerInvoice$One$estimatedDueInCents(invoice) : $author$project$Api$Provider$CustomerInvoice$One$dueInCents(invoice);
		return $author$project$Api$Provider$Patient$One$shouldChargeCreditCardFees(model.YY) ? A5($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewNewInvoiceTotalsSummary, model, invoice, meta, taxProfiles, dueTotal) : A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mt4]),
			_List_fromArray(
				[
					A2(
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTotalDetailInBold,
					'Subtotal',
					totalToHtml(
						$author$project$Api$Provider$CustomerInvoice$One$subtotalInCents(invoice))),
					A5($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTaxDetail, invoice, meta, taxProfiles, model.lJ, false),
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$offsetMd(7),
									$author$project$Ui$Grid$spanMd(4),
									$author$project$Ui$Grid$span(11)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$label,
											_List_fromArray(
												[$author$project$Ui$Typography$hintLabel, $author$project$Ui$Typography$m0, $author$project$Ui$Typography$p0]),
											_List_fromArray(
												[
													$elm$html$Html$text('Total')
												])),
											$author$project$Ui$Typography$heading(
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Utils$Currency$fromInt(
														$author$project$Api$Provider$CustomerInvoice$One$totalInCents(invoice)))
												]))
										]))
								]))
						])),
					A3($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewCreditDetail, invoice, meta, false),
					(invoiceHumanStatus !== 'draft') ? A2(
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTotalDetailInBold,
					'Paid',
					totalToHtml(
						$author$project$Api$Provider$CustomerInvoice$One$paidInCents(invoice))) : $author$project$Utils$Html$empty,
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$offsetMd(7),
									$author$project$Ui$Grid$spanMd(4)
								]),
							_List_fromArray(
								[
									$author$project$Ui$HorizontalRule$view(
									_List_fromArray(
										[$author$project$Ui$HorizontalRule$thin]))
								]))
						])),
					A2(
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTotalDetailInBold,
					'Due',
					totalToHtml(dueTotal))
				]));
	} else {
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mt4]),
			_List_fromArray(
				[
					A2(
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTotalDetailInBold,
					'Subtotal',
					$author$project$Ui$Skeleton$text(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$spanFromText('$100.00')
							]))),
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$offsetMd(7),
									$author$project$Ui$Grid$spanMd(4),
									$author$project$Ui$Grid$span(11)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$label,
											_List_fromArray(
												[$author$project$Ui$Typography$hintLabel, $author$project$Ui$Typography$m0, $author$project$Ui$Typography$p0]),
											_List_fromArray(
												[
													$elm$html$Html$text('Total')
												])),
											$author$project$Ui$Typography$heading(
											_List_fromArray(
												[
													$author$project$Ui$Skeleton$text(
													_List_fromArray(
														[
															$author$project$Ui$Skeleton$spanFromText('$100.00')
														]))
												]))
										]))
								]))
						])),
					A2(
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTotalDetailInBold,
					'Paid',
					$author$project$Ui$Skeleton$text(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$spanFromText('$100.00')
							]))),
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$offsetMd(7),
									$author$project$Ui$Grid$spanMd(4)
								]),
							_List_fromArray(
								[
									$author$project$Ui$HorizontalRule$view(
									_List_fromArray(
										[$author$project$Ui$HorizontalRule$thin]))
								]))
						])),
					A2(
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTotalDetailInBold,
					'Due',
					$author$project$Ui$Skeleton$text(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$spanFromText('$100.00')
							])))
				]));
	}
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewBody = function (model) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$map,
			$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$SchedulePaymentModalMsg,
			$author$project$Components$CustomerSchedulePaymentModal$view(model.hw)),
			A2(
			$elm$html$Html$map,
			$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CustomerEmailModalMsg,
			$author$project$Components$CustomerEmailModal$modal(model.m5)),
			A2(
			$elm$html$Html$map,
			$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$PaymentsListMsg,
			$author$project$Components$PaymentsList$modal(model.kD)),
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$withDefault,
							$author$project$Utils$Html$empty,
							A2(
								$elm$core$Maybe$map,
								$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewHiConfirmModals(model),
								$author$project$Api$Data$toMaybe(model.Uk))),
							$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewEditInvoiceModal(model.jw),
							A2(
							$elm$html$Html$map,
							$elm$core$Basics$never,
							A2(
								$author$project$Ui$Breadcrumb$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Breadcrumb$item,
										_List_Nil,
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Link$route,
												model.Is,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Invoices')
													]))
											])),
										A2(
										$author$project$Ui$Breadcrumb$item,
										_List_fromArray(
											[
												$author$project$Ui$Breadcrumb$active(true)
											]),
										_List_fromArray(
											[
												function () {
												var _v0 = model.Uk;
												if (_v0.$ === 3) {
													var invoice = _v0.a;
													return $elm$html$Html$text(
														'#' + $elm$core$String$fromInt(
															$author$project$Api$Provider$CustomerInvoice$One$invoiceNumber(invoice)));
												} else {
													return $author$project$Ui$Skeleton$text(
														_List_fromArray(
															[
																$author$project$Ui$Skeleton$spanFromText('#1234')
															]));
												}
											}()
											]))
									]))),
							function () {
							var _v1 = model.Uk;
							if (_v1.$ === 3) {
								var invoice = _v1.a;
								return A3(
									$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewHeader,
									model,
									$author$project$Api$Provider$CustomerInvoice$One$meta(invoice),
									invoice);
							} else {
								return $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewHeaderSkeleton;
							}
						}(),
							$author$project$Ui$HorizontalRule$view(_List_Nil),
							A2(
							$elm$core$Maybe$withDefault,
							$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewDetailsSkeleton,
							A2(
								$elm$core$Maybe$map,
								A4($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewDetails, model.J7, model.Ij, model.Ub, model.ZV),
								$author$project$Api$Data$toMaybe(model.Uk))),
							A2(
							$elm$core$Maybe$withDefault,
							$author$project$Utils$Html$empty,
							A2(
								$elm$core$Maybe$map,
								$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewPaymentsList(model),
								$author$project$Api$Data$toMaybe(model.Uk))),
							$author$project$Ui$Panel$title(
							_List_fromArray(
								[
									$elm$html$Html$text('Charges')
								])),
							$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargesTable(model),
							function () {
							var _v2 = model.Uk;
							if (_v2.$ === 3) {
								var invoice = _v2.a;
								return ($author$project$Api$Provider$CustomerInvoice$One$humanStatus(invoice) === 'draft') ? A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$mt4]),
									_List_fromArray(
										[$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewAddChargeButton])) : $author$project$Utils$Html$empty;
							} else {
								return $author$project$Utils$Html$empty;
							}
						}(),
							$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTotals(model),
							$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewInvoiceRevisions(model)
						])),
					A2(
					$author$project$Ui$Panel$footer,
					_List_fromArray(
						[$author$project$Ui$Element$justifyRight]),
					function () {
						var _v3 = model.Uk;
						if (_v3.$ === 3) {
							var invoice = _v3.a;
							return _List_fromArray(
								[
									A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewDeleteButton, model, invoice),
									$author$project$Api$Provider$CustomerInvoice$Meta$issueAction(
									$author$project$Api$Provider$CustomerInvoice$One$meta(invoice)) ? A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewIssueButton, model, invoice) : $author$project$Utils$Html$empty
								]);
						} else {
							return _List_Nil;
						}
					}())
				])),
			function () {
			var _v4 = model.m$;
			if (!_v4.$) {
				var createPaymentModal = _v4.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CreatePaymentModalMsg,
					$author$project$Components$Invoice$CreatePaymentModal$view(createPaymentModal));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			function () {
			var _v5 = model.i$;
			if (!_v5.$) {
				var createScheduledPaymentModal = _v5.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CreateScheduledPaymentModalMsg,
					$author$project$Components$Invoice$CreateScheduledPaymentModal$view(createScheduledPaymentModal));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			function () {
			var _v6 = model.fX;
			if (!_v6.$) {
				var chargeModal = _v6.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ChargeModalMsg,
					$author$project$Components$Patient$Charges$ChargeModal$view(chargeModal));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			function () {
			var _v7 = model.ik;
			if (!_v7.$) {
				var adjustVoidModal = _v7.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$AdjustVoidModalMsg,
					$author$project$Components$CustomerInvoice$AdjustVoidModal$view(adjustVoidModal));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			function () {
			var _v8 = model.kO;
			if (!_v8.$) {
				var processRefundModal = _v8.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ProcessRefundModalMsg,
					$author$project$Components$CustomerInvoice$ProcessRefundModal$view(processRefundModal));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}()
		]);
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$view = function (model) {
	return {
		fO: $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewBody(model),
		ac9: 'Patient | Invoices'
	};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$page = $author$project$Spa$Page$applicationPatient(
	{ah_: $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$init, aiq: $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$load, k8: $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$save, alO: $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$subscriptions, adT: $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$update, amo: $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$view});
var $author$project$Pages$Patients$PatientId_String$Charges$Top$DateRangeInputMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$DateRangeInput$additionalItem = F4(
	function (id, label, start, end) {
		return {HB: end, ahP: id, aih: label, JV: start};
	});
var $author$project$Pages$Patients$PatientId_String$Charges$Top$additionalMonthOptions = function (currentDate) {
	var currentYear = $justinmimbs$date$Date$year(currentDate);
	var firstDayCurrentYear = A3($justinmimbs$date$Date$fromCalendarDate, currentYear, 0, 1);
	var firstDayLastYear = A3($justinmimbs$date$Date$fromCalendarDate, currentYear - 1, 0, 1);
	var lastDayCurrentYear = A3($justinmimbs$date$Date$fromCalendarDate, currentYear, 11, 31);
	var lastDayLastYear = A3($justinmimbs$date$Date$fromCalendarDate, currentYear - 1, 11, 31);
	return _List_fromArray(
		[
			A4(
			$author$project$Components$DateRangeInput$additionalItem,
			'current_year',
			'Current Year',
			$elm$core$Maybe$Just(firstDayCurrentYear),
			$elm$core$Maybe$Just(lastDayCurrentYear)),
			A4(
			$author$project$Components$DateRangeInput$additionalItem,
			'last_year',
			'Last Year',
			$elm$core$Maybe$Just(firstDayLastYear),
			$elm$core$Maybe$Just(lastDayLastYear))
		]);
};
var $author$project$Pages$Patients$PatientId_String$Charges$Top$dateRangeInputSettings = F2(
	function (start, end) {
		var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
		return _Utils_update(
			defaultSettings,
			{
				ma: $author$project$Pages$Patients$PatientId_String$Charges$Top$additionalMonthOptions,
				y0: _List_fromArray(
					[
						$author$project$Ui$Grid$span(6)
					]),
				ahy: start,
				HT: true,
				al5: end
			});
	});
var $author$project$Pages$Patients$PatientId_String$Charges$Top$GotInvoices = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$Top$fetchInvoices = function (model) {
	var options = function (d) {
		return _Utils_update(
			d,
			{
				HB: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.HB),
				YD: $elm$core$Maybe$Just(
					$author$project$Api$Provider$Patient$One$id(model.YY)),
				ajJ: model.ajJ,
				alA: A3($author$project$Api$Sort$withDefault, 'date', 1, $author$project$Api$Sort$init),
				JV: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.JV),
				alH: $elm$core$Maybe$Nothing
			});
	};
	return A3($author$project$Api$Provider$CustomerInvoice$list, model.Gv, options, $author$project$Pages$Patients$PatientId_String$Charges$Top$GotInvoices);
};
var $author$project$Pages$Patients$PatientId_String$Charges$Top$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('start'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.dd, 0)),
			model.JV),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('end'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.dd, 0)),
			model.HB)
		]);
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString(
					$author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__Top(
						{
							YZ: $author$project$Api$Provider$Patient$One$id(model.YY)
						}))
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.ajJ),
				A2(
					$elm$core$List$append,
					$author$project$Api$Sort$toQuery(model.alA),
					A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
};
var $author$project$Pages$Patients$PatientId_String$Charges$Top$init = F5(
	function (_v0, practice, patient, _v1, _v2) {
		var apiClient = _v1.Gv;
		var timeFormatter = _v1.J7;
		var url = _v1.adY;
		var currentDate = _v1.dd;
		var query = _v2.DE;
		var _v3 = $author$project$Utils$DateWithDefault$fromQuery(query);
		var start = _v3.a;
		var end = _v3.b;
		var _v4 = A2(
			$author$project$Components$DateRangeInput$init,
			'date-range',
			A2(
				$author$project$Pages$Patients$PatientId_String$Charges$Top$dateRangeInputSettings,
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					start),
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					end)));
		var dateRangeInput = _v4.a;
		var dateRangeInputCmd = _v4.b;
		var model = {
			Gv: apiClient,
			dd: currentDate,
			i4: dateRangeInput,
			Hj: '',
			jt: $author$project$Components$Invoice$DownloadFile$init(url),
			HB: end,
			sP: $author$project$Api$Data$NotAsked,
			ajJ: $author$project$Api$Pagination$init,
			YY: patient,
			ZV: practice,
			alA: A3(
				$author$project$Api$Sort$withDefault,
				'date',
				1,
				$author$project$Api$Sort$initFromQuery(query)),
			JV: start,
			J7: timeFormatter,
			adY: url
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$Top$DateRangeInputMsg, dateRangeInputCmd),
						$author$project$Pages$Patients$PatientId_String$Charges$Top$fetchInvoices(model),
						$author$project$Pages$Patients$PatientId_String$Charges$Top$updateUrl(model)
					])));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Patients$PatientId_String$Charges$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Patients$PatientId_String$Charges$Top$DownloadInvoiceMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$Top$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Charges$Top$DateRangeInputMsg,
				$author$project$Components$DateRangeInput$subscriptions(model.i4)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Charges$Top$DownloadInvoiceMsg,
				$author$project$Components$Invoice$DownloadFile$subscriptions(model.jt))
			]));
};
var $author$project$Pages$Patients$PatientId_String$Charges$Top$NewInvoiceCreated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$CustomerInvoice$create = F3(
	function (apiClient, patientId, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'customer_invoice',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'patient',
								$elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'id',
											$elm$json$Json$Encode$string(patientId))
										])))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CustomerInvoice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$CustomerInvoice$customerInvoicesPath)));
	});
var $author$project$Api$Provider$CustomerInvoice$One$ownerId = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$CustomerInvoice$One$owner,
	$elm$core$Maybe$map($author$project$Api$Provider$Patient$Shared$id));
var $author$project$Pages$Patients$PatientId_String$Charges$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								sP: response,
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{sP: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{sP: $author$project$Api$Data$Loading, ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Patients$PatientId_String$Charges$Top$fetchInvoices(newModel),
								$author$project$Pages$Patients$PatientId_String$Charges$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 2:
				var subMsg = msg.a;
				var downloadInvoiceResult = A3($author$project$Components$Invoice$DownloadFile$update, model.Gv, subMsg, model.jt);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{jt: downloadInvoiceResult.aiO}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$Top$DownloadInvoiceMsg, downloadInvoiceResult.GZ),
					downloadInvoiceResult.aR);
			case 3:
				return _Utils_Tuple3(
					model,
					A3(
						$author$project$Api$Provider$CustomerInvoice$create,
						model.Gv,
						$author$project$Api$Provider$Patient$One$id(model.YY),
						$author$project$Pages$Patients$PatientId_String$Charges$Top$NewInvoiceCreated),
					_List_Nil);
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					var invoice = response.a;
					var _v3 = $author$project$Api$Provider$CustomerInvoice$One$ownerId(invoice);
					if (!_v3.$) {
						var ownerId = _v3.a;
						return _Utils_Tuple3(
							model,
							A2(
								$author$project$Utils$Route$navigate,
								$elm$core$Dict$empty,
								$author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top(
									{
										Us: $author$project$Api$Provider$CustomerInvoice$One$id(invoice),
										YZ: ownerId
									})),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Invoice created.')
								]));
					} else {
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 1, 'We were unable to create an invoice.')
								]));
					}
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var subMsg = msg.a;
				var _v4 = A2($author$project$Components$DateRangeInput$update, subMsg, model.i4);
				var dateRangeInput = _v4.a;
				var subCmd = _v4.b;
				var event = _v4.c;
				var newModel = function () {
					if (event.$ === 1) {
						var fromDate = event.a;
						var toDate = event.b;
						var label = event.c;
						return _Utils_update(
							model,
							{
								i4: dateRangeInput,
								Hj: label,
								HB: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
								JV: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
							});
					} else {
						return _Utils_update(
							model,
							{i4: dateRangeInput});
					}
				}();
				var cmds = (_Utils_eq(newModel.JV, model.JV) && _Utils_eq(newModel.HB, model.HB)) ? _List_Nil : _List_fromArray(
					[
						$author$project$Pages$Patients$PatientId_String$Charges$Top$fetchInvoices(newModel),
						$author$project$Pages$Patients$PatientId_String$Charges$Top$updateUrl(newModel)
					]);
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$cons,
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$Top$DateRangeInputMsg, subCmd),
							cmds)),
					_List_Nil);
		}
	});
var $author$project$Pages$Patients$PatientId_String$Charges$Top$PaginationMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Patient$One$overdueAmountInCents = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$One$record_,
	function ($) {
		return $.YA;
	});
var $author$project$Api$Provider$Patient$One$owedInCents = function (_v0) {
	var record = _v0.b;
	return record.YC;
};
var $author$project$Components$Invoice$DownloadFile$FetchToken = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Components$Invoice$DownloadFile$viewAndGenerateToken = F3(
	function (model, path, options) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('inline text-left')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{mm: 'Download ' + options.aih},
					_List_fromArray(
						[
							$author$project$Ui$Button$onClick(
							A2($author$project$Components$Invoice$DownloadFile$FetchToken, path, options.PD)),
							$author$project$Ui$Button$icon($author$project$Ui$Icon$export)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(options.aih)
						])),
					model.U5 ? $author$project$Components$Invoice$DownloadFile$viewModal : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Api$Provider$CustomerInvoice$All$dueInCents = function (_v0) {
	var record = _v0;
	return record.QY;
};
var $author$project$Api$Provider$CustomerInvoice$All$isPaymentScheduled = function (_v0) {
	var record = _v0;
	return record.U3;
};
var $author$project$Api$Provider$CustomerInvoice$All$issuedTotalInCents = function (_v0) {
	var record = _v0;
	return record.Vs;
};
var $author$project$Api$Provider$CustomerInvoice$All$lastSentAt = function (_v0) {
	var record = _v0;
	return record.VL;
};
var $author$project$Api$Provider$CustomerInvoice$All$nextScheduledPaymentDate = function (_v0) {
	var record = _v0;
	return record.XU;
};
var $author$project$Api$Provider$CustomerInvoice$All$paidAt = function (_v0) {
	var record = _v0;
	return record.YH;
};
var $author$project$Api$Provider$CustomerInvoice$All$paymentScheduledOn = function (_v0) {
	var record = _v0;
	return record.Zf;
};
var $author$project$Pages$Patients$PatientId_String$Charges$Top$scheduledDateValueFormatted = function (scheduledDate) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
			scheduledDate));
};
var $author$project$Api$Provider$CustomerInvoice$All$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Api$Provider$CustomerInvoice$All$totalInCents = function (_v0) {
	var record = _v0;
	return record.adp;
};
var $author$project$Pages$Patients$PatientId_String$Charges$Top$viewInvoiceRow = F4(
	function (timeFormatter, patientId, practice, invoice) {
		var issuedTotalInCents = $author$project$Api$Provider$CustomerInvoice$All$issuedTotalInCents(invoice);
		var issueDate = A2(
			$author$project$Formatters$Date$toString,
			$author$project$Formatters$Date$Full,
			$author$project$Api$Provider$CustomerInvoice$All$date(invoice));
		var invoiceId = $author$project$Api$Provider$CustomerInvoice$All$id(invoice);
		var invoiceRoute = $author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top(
			{Us: invoiceId, YZ: patientId});
		var humanStatus = _List_fromArray(
			[
				A2(
				$author$project$Ui$Badge$fromString,
				_List_Nil,
				$author$project$Api$Provider$CustomerInvoice$All$humanStatus(invoice)),
				function () {
				if ($author$project$Api$Provider$CustomerInvoice$All$isPaymentScheduled(invoice)) {
					var paymentScheduledOnTextValue = (A2(
						$author$project$Utils$FeatureGate$gateAvailable,
						12,
						$author$project$Api$Practice$Provider(practice)) && (!_Utils_eq(
						$author$project$Api$Provider$CustomerInvoice$All$nextScheduledPaymentDate(invoice),
						$elm$core$Maybe$Nothing))) ? $author$project$Pages$Patients$PatientId_String$Charges$Top$scheduledDateValueFormatted(
						$author$project$Api$Provider$CustomerInvoice$All$nextScheduledPaymentDate(invoice)) : $author$project$Pages$Patients$PatientId_String$Charges$Top$scheduledDateValueFormatted(
						$author$project$Api$Provider$CustomerInvoice$All$paymentScheduledOn(invoice));
					var paymentScheduledOnFullText = $elm$core$String$isEmpty(paymentScheduledOnTextValue) ? '' : A2($elm$core$String$append, ' payment scheduled for ', paymentScheduledOnTextValue);
					return A2(
						$author$project$Ui$Typography$text,
						_List_fromArray(
							[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
						paymentScheduledOnFullText);
				} else {
					if ($author$project$Api$Provider$CustomerInvoice$All$status(invoice) === 'sent') {
						var lastSentAtText = A2(
							$elm$core$String$append,
							' last sent at ',
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									timeFormatter(5),
									$author$project$Api$Provider$CustomerInvoice$All$lastSentAt(invoice))));
						return A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
							lastSentAtText);
					} else {
						return $author$project$Utils$Html$empty;
					}
				}
			}(),
				function () {
				if ($author$project$Api$Provider$CustomerInvoice$All$status(invoice) === 'paid') {
					var paidAtText = A2(
						$elm$core$String$append,
						' on ',
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$map,
								timeFormatter(5),
								$author$project$Api$Provider$CustomerInvoice$All$paidAt(invoice))));
					return A2(
						$author$project$Ui$Typography$text,
						_List_fromArray(
							[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
						paidAtText);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]);
		var dueInCents = $author$project$Api$Provider$CustomerInvoice$All$dueInCents(invoice);
		var amount = _List_fromArray(
			[
				function () {
				if ($author$project$Api$Provider$CustomerInvoice$All$status(invoice) === 'draft') {
					return A2(
						$author$project$Ui$Typography$text,
						_List_fromArray(
							[$author$project$Ui$Typography$muted]),
						$author$project$Utils$Currency$fromInt(issuedTotalInCents));
				} else {
					var totalInCents = $author$project$Api$Provider$CustomerInvoice$All$totalInCents(invoice);
					return (!_Utils_eq(totalInCents, issuedTotalInCents)) ? A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$text,
								_List_fromArray(
									[$author$project$Ui$Typography$strike, $author$project$Ui$Typography$muted]),
								$author$project$Utils$Currency$fromInt(issuedTotalInCents)),
								$elm$html$Html$text(
								' ' + $author$project$Utils$Currency$fromInt(totalInCents))
							])) : $elm$html$Html$text(
						$author$project$Utils$Currency$fromInt(totalInCents));
				}
			}(),
				(!_Utils_eq(
				dueInCents,
				$author$project$Api$Provider$CustomerInvoice$All$totalInCents(invoice))) ? ((dueInCents > 0) ? A2(
				$author$project$Ui$Typography$text,
				_List_fromArray(
					[$author$project$Ui$Typography$small]),
				' (' + ($author$project$Utils$Currency$fromInt(dueInCents) + ' owed)')) : ((dueInCents < 0) ? A2(
				$author$project$Ui$Typography$text,
				_List_fromArray(
					[$author$project$Ui$Typography$small]),
				' (-' + ($author$project$Utils$Currency$fromInt(dueInCents) + ' overpaid)')) : $elm$html$Html$text(''))) : $elm$html$Html$text('')
			]);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							invoiceRoute,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(issueDate)
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							invoiceRoute,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									'#' + $elm$core$String$fromInt(
										$author$project$Api$Provider$CustomerInvoice$All$invoiceNumber(invoice)))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[
							$author$project$Ui$Table$minWidth('12em')
						]),
					amount),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[
							$author$project$Ui$Table$minWidth('12em')
						]),
					humanStatus)
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$Top$NewInvoiceButtonClicked = {$: 3};
var $author$project$Pages$Patients$PatientId_String$Charges$Top$viewNewInvoiceButton = A3(
	$author$project$Ui$Button$view,
	{mm: 'Add invoice'},
	_List_fromArray(
		[
			$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Charges$Top$NewInvoiceButtonClicked),
			$author$project$Ui$Button$icon($author$project$Ui$Icon$add),
			$author$project$Ui$Button$default
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('Add Invoice')
		]));
var $author$project$Pages$Patients$PatientId_String$Charges$Top$view = function (_v0) {
	var invoices = _v0.sP;
	var pagination = _v0.ajJ;
	var timeFormatter = _v0.J7;
	var patient = _v0.YY;
	var currentDate = _v0.dd;
	var downloadInvoice = _v0.jt;
	var dateRangeInput = _v0.i4;
	var start = _v0.JV;
	var end = _v0.HB;
	var practice = _v0.ZV;
	var patientId = $author$project$Api$Provider$Patient$One$id(patient);
	var path = A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[patientId]),
		A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				['patients']),
			$author$project$Api$Data$providerPath));
	var _v1 = function () {
		if (invoices.$ === 3) {
			var inv = invoices.a;
			return _Utils_Tuple2(false, inv);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v1.a;
	var invoices_ = _v1.b;
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Invoices')
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$spanLg(3),
												$author$project$Ui$Grid$spanSm(12)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Pages$Patients$PatientId_String$Charges$Top$DateRangeInputMsg,
												$author$project$Components$DateRangeInput$view(dateRangeInput))
											])),
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$spanLg(1),
												$author$project$Ui$Grid$spanSm(6)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$ml2]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$text,
														_List_fromArray(
															[$author$project$Ui$Typography$primary]),
														'Balance:'),
														A2($elm$html$Html$br, _List_Nil, _List_Nil),
														A2(
														$author$project$Ui$Typography$text,
														_List_Nil,
														$author$project$Utils$Currency$fromInt(
															$author$project$Api$Provider$Patient$One$owedInCents(patient)))
													]))
											])),
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$spanLg(2),
												$author$project$Ui$Grid$spanSm(6)
											]),
										_List_fromArray(
											[
												(!(!$author$project$Api$Provider$Patient$One$overdueAmountInCents(patient))) ? A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$ml2]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$text,
														_List_fromArray(
															[$author$project$Ui$Typography$primary]),
														' Past Due:'),
														A2($elm$html$Html$br, _List_Nil, _List_Nil),
														A2(
														$author$project$Ui$Typography$text,
														_List_fromArray(
															[$author$project$Ui$Typography$danger]),
														$author$project$Utils$Currency$fromInt(
															$author$project$Api$Provider$Patient$One$overdueAmountInCents(patient)))
													])) : $author$project$Utils$Html$empty
											])),
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$spanLg(6),
												$author$project$Ui$Grid$spanSm(12),
												$author$project$Ui$Grid$justifyRight
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$gap2]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$map,
														$author$project$Pages$Patients$PatientId_String$Charges$Top$DownloadInvoiceMsg,
														A3(
															$author$project$Components$Invoice$DownloadFile$viewAndGenerateToken,
															downloadInvoice,
															path,
															{
																ae4: true,
																PD: {
																	HY: A2(
																		$elm$core$Maybe$withDefault,
																		'',
																		A2(
																			$elm$core$Maybe$map,
																			$justinmimbs$date$Date$toIsoString,
																			A2(
																				$elm$core$Maybe$map,
																				A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
																				start))),
																	Iw: A2(
																		$elm$core$Maybe$withDefault,
																		'',
																		A2(
																			$elm$core$Maybe$map,
																			$justinmimbs$date$Date$toIsoString,
																			A2(
																				$elm$core$Maybe$map,
																				A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
																				end)))
																},
																aih: 'Export Account Statement'
															})),
														$author$project$Pages$Patients$PatientId_String$Charges$Top$viewNewInvoiceButton
													]))
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A4(
								$author$project$Ui$Table$view,
								_List_fromArray(
									[
										$author$project$Ui$Table$verticalCentered,
										$author$project$Ui$Table$loading(loading),
										$author$project$Ui$Table$zeroState(
										_List_fromArray(
											[
												$elm$html$Html$text('This patient has no invoices')
											]))
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Table$header,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Date')
											])),
										A2(
										$author$project$Ui$Table$header,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Number')
											])),
										A2(
										$author$project$Ui$Table$header,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Amount')
											])),
										A2(
										$author$project$Ui$Table$header,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Status')
											]))
									]),
								A2(
									$elm$core$List$map,
									A3($author$project$Pages$Patients$PatientId_String$Charges$Top$viewInvoiceRow, timeFormatter, patientId, practice),
									invoices_),
								_List_Nil)
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Patients$PatientId_String$Charges$Top$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(loading)
										]),
									pagination))
							]))
					]))
			]),
		ac9: 'Patient | Invoices'
	};
};
var $author$project$Pages$Patients$PatientId_String$Charges$Top$page = $author$project$Spa$Page$applicationPatient(
	{ah_: $author$project$Pages$Patients$PatientId_String$Charges$Top$init, aiq: $author$project$Pages$Patients$PatientId_String$Charges$Top$load, k8: $author$project$Pages$Patients$PatientId_String$Charges$Top$save, alO: $author$project$Pages$Patients$PatientId_String$Charges$Top$subscriptions, adT: $author$project$Pages$Patients$PatientId_String$Charges$Top$update, amo: $author$project$Pages$Patients$PatientId_String$Charges$Top$view});
var $author$project$Pages$Patients$PatientId_String$Chart$init = F5(
	function (_v0, _v1, _v2, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Patients$PatientId_String$Chart$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Patients$PatientId_String$Chart$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Patients$PatientId_String$Chart$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Patient Chart'};
};
var $author$project$Pages$Patients$PatientId_String$Chart$page = $author$project$Spa$Page$applicationPatient(
	{
		ah_: $author$project$Pages$Patients$PatientId_String$Chart$init,
		aiq: $author$project$Pages$Patients$PatientId_String$Chart$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$Patients$PatientId_String$Chart$update,
		amo: $author$project$Pages$Patients$PatientId_String$Chart$view
	});
var $author$project$Pages$Patients$PatientId_String$Edit$GotCompany = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Edit$GotMeta = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Edit$init = F5(
	function (session, practice, patient, shared, _v0) {
		var params = _v0.YL;
		var _v1 = function () {
			var _v2 = $author$project$Api$Provider$Patient$One$company(patient);
			if (!_v2.$) {
				var company_ = _v2.a;
				return _Utils_Tuple2(
					$author$project$Api$Data$Loading,
					A3(
						$author$project$Api$Provider$Company$retrieve,
						shared.Gv,
						$author$project$Api$Provider$Company$Min$id(company_),
						$author$project$Pages$Patients$PatientId_String$Edit$GotCompany));
			} else {
				return _Utils_Tuple2($author$project$Api$Data$NotAsked, $elm$core$Platform$Cmd$none);
			}
		}();
		var company = _v1.a;
		var retrieveCompanyCmd = _v1.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, afQ: company, dd: shared.dd, SD: $elm$core$Maybe$Nothing, ahK: shared.ahK, ahP: params.YZ, W4: $author$project$Api$Data$Loading, g0: $elm$core$Maybe$Nothing, YY: patient, ZV: practice, aa4: session, lA: false},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						retrieveCompanyCmd,
						A4(
						$author$project$Api$Patient$Meta$retrieve,
						shared.Gv,
						session,
						$author$project$Api$Provider$Patient$One$id(patient),
						$author$project$Pages$Patients$PatientId_String$Edit$GotMeta)
					])));
	});
var $author$project$Pages$Patients$PatientId_String$Edit$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Patients$PatientId_String$Edit$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Patients$PatientId_String$Edit$CloseArchiveModalClicked = {$: 6};
var $author$project$Pages$Patients$PatientId_String$Edit$ConfirmArchiveModalClicked = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Edit$FormMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Edit$subscriptions = function (_v0) {
	var form = _v0.SD;
	var openModal = _v0.g0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Patient$Form$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Pages$Patients$PatientId_String$Edit$FormMsg)),
					form)),
				function () {
				if (!openModal.$) {
					if (!openModal.a) {
						var _v2 = openModal.a;
						return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Pages$Patients$PatientId_String$Edit$CloseArchiveModalClicked);
					} else {
						var _v3 = openModal.a;
						return $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Patients$PatientId_String$Edit$ConfirmArchiveModalClicked);
					}
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}()
			]));
};
var $author$project$Pages$Patients$PatientId_String$Edit$PatientArchived = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Edit$PatientUpdated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Patient$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Patient$patientPath(id_)));
	});
var $author$project$Pages$Patients$PatientId_String$Edit$fillPatientForm = F8(
	function (session, practice, hinterViewOff, patient, apiClient, currentDate, company, meta) {
		return A8(
			$author$project$Components$Patient$Form$fill,
			apiClient,
			session,
			currentDate,
			A2($elm$core$Maybe$map, $author$project$Api$Company$Provider, company),
			false,
			$author$project$Api$Patient$One$Provider(patient),
			meta,
			function (settings) {
				return _Utils_update(
					settings,
					{
						afg: $author$project$Api$Provider$Practice$One$labelBillingAsShipping(practice),
						afn: A2($author$project$Api$Provider$Practice$One$featureEnabled, 3, practice),
						Tb: $author$project$Api$Provider$Practice$One$hasLocations(practice),
						Th: $author$project$Api$Provider$Practice$One$hasPractitioners(practice),
						aiC: $author$project$Api$Provider$Practice$One$isMce(practice),
						tc: A2($author$project$Api$Provider$Practice$One$featureEnabled, 10, practice),
						akV: $author$project$Api$Provider$Practice$One$requiresPatientEmail(practice),
						$G: $author$project$Api$Provider$Practice$One$requiresLocation(practice),
						akW: $author$project$Api$Provider$Practice$One$requiresPatientMobile(practice),
						$M: $author$project$Api$Provider$Practice$One$requiresPractitioner(practice),
						$N: $author$project$Api$Provider$Practice$One$requiresSSN(practice),
						ab6: $author$project$Api$Provider$Practice$One$ssnEnabled(practice),
						acI: A2(
							$elm$core$Maybe$withDefault,
							false,
							A2(
								$elm$core$Maybe$map,
								$author$project$Api$Provider$Network$Shared$syncByAffiliation,
								$author$project$Api$Provider$Practice$One$network(practice))),
						al8: A2($author$project$Api$Provider$Practice$One$featureEnabled, 2, practice),
						adt: $author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice),
						adv: $author$project$Api$Provider$Practice$One$transInclusivity(practice),
						F1: A3($author$project$Permission$canGoTo, session, hinterViewOff, 0)
					});
			});
	});
var $author$project$Pages$Patients$PatientId_String$Edit$initPatientForm = function (model) {
	var _v0 = _Utils_Tuple2(model.afQ, model.W4);
	_v0$2:
	while (true) {
		if (_v0.b.$ === 3) {
			switch (_v0.a.$) {
				case 3:
					var _v1 = _v0.a;
					var company_ = _v1.a;
					var _v2 = _v0.b;
					var meta = _v2.a;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Platform$Cmd$map($author$project$Pages$Patients$PatientId_String$Edit$FormMsg),
						A2(
							$elm$core$Tuple$mapFirst,
							$elm$core$Maybe$Just,
							A8(
								$author$project$Pages$Patients$PatientId_String$Edit$fillPatientForm,
								model.aa4,
								model.ZV,
								model.ahK,
								model.YY,
								model.Gv,
								model.dd,
								$elm$core$Maybe$Just(company_),
								meta)));
				case 0:
					var _v3 = _v0.a;
					var _v4 = _v0.b;
					var meta = _v4.a;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Platform$Cmd$map($author$project$Pages$Patients$PatientId_String$Edit$FormMsg),
						A2(
							$elm$core$Tuple$mapFirst,
							$elm$core$Maybe$Just,
							A8($author$project$Pages$Patients$PatientId_String$Edit$fillPatientForm, model.aa4, model.ZV, model.ahK, model.YY, model.Gv, model.dd, $elm$core$Maybe$Nothing, meta)));
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
};
var $author$project$Api$Provider$Patient$update = F4(
	function (apiClient, id_, jsonBody, toMsg) {
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Patient$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				jsonBody,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Patient$patientPath(id_))));
	});
var $author$project$Pages$Patients$PatientId_String$Edit$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				var modelWithCompany = _Utils_update(
					model,
					{afQ: response});
				var _v1 = $author$project$Pages$Patients$PatientId_String$Edit$initPatientForm(modelWithCompany);
				var form = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple3(
					_Utils_update(
						modelWithCompany,
						{SD: form}),
					cmd,
					_List_Nil);
			case 1:
				var response = msg.a;
				var modelWithMeta = _Utils_update(
					model,
					{W4: response});
				var _v2 = $author$project$Pages$Patients$PatientId_String$Edit$initPatientForm(modelWithMeta);
				var form = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						modelWithMeta,
						{SD: form}),
					cmd,
					_List_Nil);
			case 2:
				var formMsg = msg.a;
				if (formMsg.$ === 3) {
					return _Utils_Tuple3(
						model,
						A2(
							$author$project$Utils$Route$navigate,
							$elm$core$Dict$empty,
							$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
								{
									YZ: $author$project$Api$Provider$Patient$One$id(model.YY)
								})),
						_List_fromArray(
							[
								$author$project$OutMsg$RetrievePatient(
								$author$project$Api$Provider$Patient$One$id(model.YY)),
								A2(
								$author$project$OutMsg$ShowToast,
								3,
								'Successfully updated ' + $author$project$Api$Provider$Patient$One$id(model.YY))
							]));
				} else {
					var _v4 = model.SD;
					if (!_v4.$) {
						var form = _v4.a;
						var _v5 = function () {
							var _v6 = model.afQ;
							if (_v6.$ === 3) {
								var company_ = _v6.a;
								return A5(
									$author$project$Components$Patient$Form$update,
									model.Gv,
									model.aa4,
									$elm$core$Maybe$Just(
										$author$project$Api$Company$Provider(company_)),
									formMsg,
									form);
							} else {
								return A5($author$project$Components$Patient$Form$update, model.Gv, model.aa4, $elm$core$Maybe$Nothing, formMsg, form);
							}
						}();
						var newForm = _v5.a;
						var formCmd = _v5.b;
						var formOutMsgs = _v5.c;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									SD: $elm$core$Maybe$Just(newForm)
								}),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Edit$FormMsg, formCmd),
							formOutMsgs);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				}
			case 3:
				var _v7 = model.SD;
				if (!_v7.$) {
					var form = _v7.a;
					var _v8 = $author$project$Components$Patient$Form$validate(form);
					if (!_v8.$) {
						var _v9 = _v8.a;
						var validForm = _v9.a;
						var validFields = _v9.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{lA: true}),
							A4(
								$author$project$Api$Provider$Patient$update,
								model.Gv,
								model.ahP,
								A2($author$project$Components$Patient$Form$encode, validFields, validForm),
								$author$project$Pages$Patients$PatientId_String$Edit$PatientUpdated),
							_List_Nil);
					} else {
						var erroredForm = _v8.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									SD: $elm$core$Maybe$Just(erroredForm)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				var response = msg.a;
				switch (response.$) {
					case 3:
						var patient = response.a;
						var createAffiliationResult = function () {
							var _v12 = model.SD;
							if (!_v12.$) {
								var form = _v12.a;
								var affiliationId = A2(
									$elm$core$Maybe$map,
									$author$project$Api$Provider$Affiliate$AffiliateMin$id,
									$author$project$Api$Provider$Patient$One$assignedAffiliation(model.YY));
								return A5(
									$author$project$Components$Patient$Form$createAffiliation,
									model.Gv,
									model.aa4,
									$author$project$Api$Provider$Patient$One$id(patient),
									affiliationId,
									form);
							} else {
								return {xZ: false, GZ: $elm$core$Platform$Cmd$none};
							}
						}();
						var _v11 = createAffiliationResult.xZ ? _Utils_Tuple2(
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Edit$FormMsg, createAffiliationResult.GZ),
							_List_Nil) : _Utils_Tuple2(
							A2(
								$author$project$Utils$Route$navigate,
								$elm$core$Dict$empty,
								$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
									{
										YZ: $author$project$Api$Provider$Patient$One$id(patient)
									})),
							_List_fromArray(
								[
									$author$project$OutMsg$RetrievePatient(
									$author$project$Api$Provider$Patient$One$id(patient)),
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									'Successfully updated ' + $author$project$Api$Provider$Patient$One$id(patient))
								]));
						var cmd = _v11.a;
						var outMsgs = _v11.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{lA: false}),
							cmd,
							outMsgs);
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{lA: false}),
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error)),
								$author$project$OutMsg$reportDecodeError(response)));
					default:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{lA: false}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
				}
			case 5:
				var openModal = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							g0: $elm$core$Maybe$Just(openModal)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 6:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{g0: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 7:
				var confirmed = msg.a;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{g0: $elm$core$Maybe$Nothing}),
					A3($author$project$Api$Provider$Patient$delete, model.Gv, model.ahP, $author$project$Pages$Patients$PatientId_String$Edit$PatientArchived),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{g0: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 8:
				var response = msg.a;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							model,
							A2(
								$author$project$Utils$Route$navigate,
								$elm$core$Dict$empty,
								$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
									{YZ: model.ahP})),
							_List_fromArray(
								[
									$author$project$OutMsg$RetrievePatient(model.ahP),
									A2($author$project$OutMsg$ShowToast, 3, 'Successfully archived ' + model.ahP)
								]));
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error)),
								$author$project$OutMsg$reportDecodeError(response)));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				return _Utils_Tuple3(model, $author$project$Ports$Navigation$back, _List_Nil);
		}
	});
var $author$project$Pages$Patients$PatientId_String$Edit$CancelButtonClicked = {$: 9};
var $author$project$Pages$Patients$PatientId_String$Edit$FormSubmitted = {$: 3};
var $author$project$Api$Provider$Patient$Shared$archived = function (_v0) {
	var shared = _v0;
	return shared.L_;
};
var $author$project$Api$Provider$Patient$One$archived = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$archived(shared);
};
var $author$project$Api$Provider$Patient$One$isSynced = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$One$record_,
	function ($) {
		return $.Vf;
	});
var $author$project$Components$AddressInput$skeleton = A2(
	$elm$html$Html$div,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$input(_List_Nil)
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$input(_List_Nil)
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanMd(7)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$input(_List_Nil)
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanMd(5)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$input(_List_Nil)
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanMd(4)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$input(_List_Nil)
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanMd(8)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$input(_List_Nil)
						]))
				]))
		]));
var $author$project$Components$NameInput$skeleton = A2(
	$author$project$Ui$Grid$row,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Grid$column,
			_List_fromArray(
				[
					$author$project$Ui$Grid$spanSm(2)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$input(_List_Nil)
				])),
			A2(
			$author$project$Ui$Grid$column,
			_List_fromArray(
				[
					$author$project$Ui$Grid$spanSm(6),
					$author$project$Ui$Grid$spanMd(3)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$input(_List_Nil)
				])),
			A2(
			$author$project$Ui$Grid$column,
			_List_fromArray(
				[
					$author$project$Ui$Grid$spanSm(4),
					$author$project$Ui$Grid$spanMd(2)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$input(_List_Nil)
				])),
			A2(
			$author$project$Ui$Grid$column,
			_List_fromArray(
				[
					$author$project$Ui$Grid$spanSm(7),
					$author$project$Ui$Grid$spanMd(3)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$input(_List_Nil)
				])),
			A2(
			$author$project$Ui$Grid$column,
			_List_fromArray(
				[
					$author$project$Ui$Grid$spanSm(5),
					$author$project$Ui$Grid$spanMd(2)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$input(_List_Nil)
				]))
		]));
var $author$project$Components$PhoneInput$skeleton = function (repeat) {
	return _Utils_ap(
		A2(
			$elm$core$List$repeat,
			repeat,
			A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(4)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$input(_List_Nil)
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(8)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$input(_List_Nil)
							]))
					]))),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Skeleton$text(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$spanFromText('Add Another Phone')
							]))
					]))
			]));
};
var $author$project$Components$Patient$Form$skeleton = _List_fromArray(
	[
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSkeleton('Legal Name'),
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpanMd(8)
			]),
		_List_fromArray(
			[
				$author$project$Components$NameInput$skeleton,
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mt2]),
				_List_fromArray(
					[
						$author$project$Ui$Skeleton$text(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$span(4)
							]))
					]))
			])),
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSkeleton('Date of Birth'),
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpanMd(8)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$input(_List_Nil)
			])),
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSkeleton('Sex'),
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpanMd(8)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Skeleton$text(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$span(3)
							]))
					]))
			])),
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSkeleton('Gender Identity'),
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpanMd(8)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$input(_List_Nil)
			])),
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSkeleton('Pronoun'),
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpanMd(8)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$input(_List_Nil)
			])),
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSkeleton('Email'),
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpanMd(8)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$input(_List_Nil)
			])),
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSkeleton('Phones'),
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpanMd(8)
			]),
		$author$project$Components$PhoneInput$skeleton(1)),
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSkeleton('Address'),
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpanMd(8)
			]),
		_List_fromArray(
			[$author$project$Components$AddressInput$skeleton])),
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSkeleton('Provider'),
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpanMd(8)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$input(_List_Nil)
			])),
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSkeleton('Location'),
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpanMd(8)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$input(_List_Nil)
			])),
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSkeleton('Health Insurance'),
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpanMd(8)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$input(_List_Nil)
			])),
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSkeleton('Lead Source'),
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpanMd(8)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$input(_List_Nil)
			]))
	]);
var $author$project$Pages$Patients$PatientId_String$Edit$unlessRestricted = F2(
	function (hideSection, body) {
		return hideSection ? $author$project$Utils$Html$empty : body;
	});
var $author$project$Pages$Patients$PatientId_String$Edit$ArchiveButtonClicked = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Edit$CannotArchive = 0;
var $author$project$Pages$Patients$PatientId_String$Edit$ConfirmArchive = 1;
var $author$project$Api$Patient$Meta$archive = function (_v0) {
	var actions = _v0.b;
	return actions.LZ;
};
var $author$project$Utils$MetaFields$isActionable = $elm$core$Basics$identity;
var $author$project$Pages$Patients$PatientId_String$Edit$viewArchiveButton = F2(
	function (patient, meta) {
		var openArchiveModalMsg = $author$project$Utils$MetaFields$isActionable(
			$author$project$Api$Patient$Meta$archive(meta)) ? $author$project$Pages$Patients$PatientId_String$Edit$ArchiveButtonClicked(1) : $author$project$Pages$Patients$PatientId_String$Edit$ArchiveButtonClicked(0);
		return A3(
			$author$project$Ui$Button$view,
			{mm: 'Archive patient'},
			_List_fromArray(
				[
					$author$project$Ui$Button$danger,
					$author$project$Ui$Button$disabled(
					$author$project$Api$Provider$Patient$One$archived(patient)),
					$author$project$Ui$Button$onClick(openArchiveModalMsg)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Archive')
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Edit$viewCannotArchiveModal = A3(
	$author$project$Ui$Modal$view,
	$author$project$Pages$Patients$PatientId_String$Edit$CloseArchiveModalClicked,
	_List_Nil,
	_List_fromArray(
		[
			$author$project$Ui$Modal$header(
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Cannot Archive Patient')
						]))
				])),
			$author$project$Ui$Modal$body(
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('You cannot archive a patient in the following situations:')
						])),
					A2(
					$elm$html$Html$ul,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('If they have an uncollected balance')
								])),
							A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('If they have an active membership')
								])),
							A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('If they are actively linked to a company')
								]))
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('To archive the patient, cancel any charges or mark them as bad debt, end any memberships, and unlink any companies.')
						]))
				])),
			$author$project$Ui$Modal$footer(
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{mm: 'Close'},
					_List_fromArray(
						[
							$author$project$Ui$Button$styled(0),
							$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Edit$CloseArchiveModalClicked)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('OK')
						]))
				]))
		]));
var $author$project$Pages$Patients$PatientId_String$Edit$confirmArchiveMessage = _List_fromArray(
	[
		A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Are you sure you want to archive this patient? This will disable all payments and emails to this patient.')
					]))
			]))
	]);
var $author$project$Pages$Patients$PatientId_String$Edit$viewConfirmArchiveModal = A2(
	$author$project$Components$HiConfirm$modal,
	$author$project$Pages$Patients$PatientId_String$Edit$ConfirmArchiveModalClicked,
	_List_fromArray(
		[
			$author$project$Components$HiConfirm$verb('archive'),
			$author$project$Components$HiConfirm$noun('patient'),
			$author$project$Components$HiConfirm$customMessage($author$project$Pages$Patients$PatientId_String$Edit$confirmArchiveMessage)
		]));
var $author$project$Pages$Patients$PatientId_String$Edit$viewMergeButton = function (patient) {
	var button = A3(
		$author$project$Ui$Link$route,
		$author$project$Spa$Generated$Route$Patients__PatientId_String__Merge(
			{
				YZ: $author$project$Api$Provider$Patient$One$id(patient)
			}),
		_List_fromArray(
			[
				$author$project$Ui$Link$buttonWarning,
				$author$project$Ui$Link$disabled(
				$author$project$Api$Provider$Patient$One$membershipStatus(patient) !== 'inactive')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Merge')
			]));
	return ($author$project$Api$Provider$Patient$One$membershipStatus(patient) === 'inactive') ? button : A3(
		$author$project$Ui$Popover$view,
		_List_Nil,
		_List_fromArray(
			[button]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Popover$body,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Patient must be inactive in order to be merged into another record.')
					]))
			]));
};
var $author$project$Pages$Patients$PatientId_String$Edit$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				function () {
				var _v0 = model.g0;
				if (!_v0.$) {
					if (!_v0.a) {
						var _v1 = _v0.a;
						return $author$project$Pages$Patients$PatientId_String$Edit$viewCannotArchiveModal;
					} else {
						var _v2 = _v0.a;
						return $author$project$Pages$Patients$PatientId_String$Edit$viewConfirmArchiveModal;
					}
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$noValidate(true),
						$author$project$Ui$Form$autocomplete(false),
						$author$project$Ui$Form$onSubmit($author$project$Pages$Patients$PatientId_String$Edit$FormSubmitted)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Link$route,
												$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
													{YZ: model.ahP}),
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Patient')
													])),
												A2(
												$author$project$Ui$Typography$text,
												_List_fromArray(
													[$author$project$Ui$Typography$gray]),
												'  /  Edit Patient')
											])),
										$author$project$Ui$HorizontalRule$view(
										_List_fromArray(
											[$author$project$Ui$HorizontalRule$thin])),
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Edit Patient')
											])),
										function () {
										var _v3 = model.SD;
										if (!_v3.$) {
											var form = _v3.a;
											return A2(
												$elm$html$Html$div,
												_List_Nil,
												A2(
													$elm$core$List$map,
													$elm$html$Html$map($author$project$Pages$Patients$PatientId_String$Edit$FormMsg),
													$author$project$Components$Patient$Form$view(form)));
										} else {
											return A2($elm$html$Html$div, _List_Nil, $author$project$Components$Patient$Form$skeleton);
										}
									}()
									])),
								A2(
								$author$project$Ui$Panel$footer,
								_List_fromArray(
									[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$gap2]),
								function () {
									var _v4 = model.W4;
									if (_v4.$ === 3) {
										var meta = _v4.a;
										return _List_fromArray(
											[
												A3(
												$author$project$Ui$Button$view,
												{mm: 'Cancel and go back'},
												_List_fromArray(
													[
														$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Edit$CancelButtonClicked)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Cancel')
													])),
												A2(
												$author$project$Pages$Patients$PatientId_String$Edit$unlessRestricted,
												$author$project$Api$Provider$Patient$One$isSynced(model.YY),
												A2($author$project$Pages$Patients$PatientId_String$Edit$viewArchiveButton, model.YY, meta)),
												$author$project$Pages$Patients$PatientId_String$Edit$viewMergeButton(model.YY),
												A3(
												$author$project$Ui$Button$view,
												{mm: 'Update patient'},
												_List_fromArray(
													[
														$author$project$Ui$Button$primary,
														$author$project$Ui$Button$disabled(
														$author$project$Api$Provider$Patient$One$archived(model.YY)),
														$author$project$Ui$Button$submit,
														$author$project$Ui$Button$loading(model.lA)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Update')
													]))
											]);
									} else {
										return _List_Nil;
									}
								}())
							]))
					]))
			]),
		ac9: 'Patient | ' + model.ahP
	};
};
var $author$project$Pages$Patients$PatientId_String$Edit$page = $author$project$Spa$Page$applicationPatient(
	{ah_: $author$project$Pages$Patients$PatientId_String$Edit$init, aiq: $author$project$Pages$Patients$PatientId_String$Edit$load, k8: $author$project$Pages$Patients$PatientId_String$Edit$save, alO: $author$project$Pages$Patients$PatientId_String$Edit$subscriptions, adT: $author$project$Pages$Patients$PatientId_String$Edit$update, amo: $author$project$Pages$Patients$PatientId_String$Edit$view});
var $author$project$Pages$Patients$PatientId_String$GrowthChart$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Patients$PatientId_String$GrowthChart$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Patients$PatientId_String$GrowthChart$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Patients$PatientId_String$GrowthChart$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Growth Chart'};
};
var $author$project$Pages$Patients$PatientId_String$GrowthChart$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$Patients$PatientId_String$GrowthChart$init,
		aiq: $author$project$Pages$Patients$PatientId_String$GrowthChart$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$Patients$PatientId_String$GrowthChart$update,
		amo: $author$project$Pages$Patients$PatientId_String$GrowthChart$view
	});
var $author$project$Pages$Patients$PatientId_String$LabTrends$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Patients$PatientId_String$LabTrends$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Patients$PatientId_String$LabTrends$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Patients$PatientId_String$LabTrends$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Lab Trends'};
};
var $author$project$Pages$Patients$PatientId_String$LabTrends$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$Patients$PatientId_String$LabTrends$init,
		aiq: $author$project$Pages$Patients$PatientId_String$LabTrends$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$Patients$PatientId_String$LabTrends$update,
		amo: $author$project$Pages$Patients$PatientId_String$LabTrends$view
	});
var $author$project$Pages$Patients$PatientId_String$ManageCredits$CreditCategoryResourceFilterMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$StatusDropdownMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$GotCredits = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Patient$Credit$creditsPath = function (patientId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['credits']),
		$author$project$Api$Provider$Patient$patientPath(patientId));
};
var $author$project$Api$Provider$Credit$All$Credit = $elm$core$Basics$identity;
var $author$project$Api$Provider$Credit$Shared$Credit = $elm$core$Basics$identity;
var $author$project$Api$Provider$Credit$Shared$Record = function (id) {
	return function (name) {
		return function (amountInCents) {
			return function (balanceInCents) {
				return function (createdAt) {
					return function (expiresOn) {
						return function (expiresSoon) {
							return function (isEditable) {
								return function (isExpired) {
									return function (issuedOn) {
										return function (reason) {
											return function (transferredInCents) {
												return function (creditCategory) {
													return {LE: amountInCents, afa: balanceInCents, O1: createdAt, O5: creditCategory, R0: expiresOn, R1: expiresSoon, ahP: id, aic: isEditable, UQ: isExpired, Vn: issuedOn, Bq: name, _7: reason, adz: transferredInCents};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Credit$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'credit_category',
	$author$project$Api$Provider$CreditCategory$Shared$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'transferred_in_cents',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'reason',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'issued_on',
				$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'is_expired',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'is_editable',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'expires_soon',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'expires_on',
								$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'created_at',
									$elm_community$json_extra$Json$Decode$Extra$datetime,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'balance_in_cents',
										$elm$json$Json$Decode$int,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'amount_in_cents',
											$elm$json$Json$Decode$int,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'name',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'id',
													$elm$json$Json$Decode$string,
													$elm$json$Json$Decode$succeed($author$project$Api$Provider$Credit$Shared$Record))))))))))))));
var $author$project$Api$Provider$Credit$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Credit$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Credit$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Credit$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Patient$Credit$listDefaults = {
	ajJ: $author$project$Api$Pagination$init,
	alA: A3($author$project$Api$Sort$withDefault, 'issued_on', 0, $author$project$Api$Sort$init),
	alH: $elm$core$Maybe$Nothing
};
var $author$project$Api$Provider$Patient$Credit$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Patient$Credit$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.alH;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'status', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$Provider$Patient$Credit$list = F4(
	function (apiClient, patientId, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Credit$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Patient$Credit$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Patient$Credit$creditsPath(patientId))));
	});
var $author$project$Pages$Patients$PatientId_String$ManageCredits$statusOptionToValue = function (option) {
	switch (option) {
		case 1:
			return 'zero_balance';
		case 2:
			return 'outstanding';
		default:
			return 'all';
	}
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$fetchCredits = function (model) {
	var options = function (d) {
		return _Utils_update(
			d,
			{
				ajJ: model.ajJ,
				alA: A3($author$project$Api$Sort$withDefault, 'issued_on', 1, $author$project$Api$Sort$init),
				alH: $elm$core$Maybe$Just(
					$author$project$Pages$Patients$PatientId_String$ManageCredits$statusOptionToValue(model.alH))
			});
	};
	return A4(
		$author$project$Api$Provider$Patient$Credit$list,
		model.Gv,
		$author$project$Api$Provider$Patient$One$id(model.YY),
		options,
		$author$project$Pages$Patients$PatientId_String$ManageCredits$GotCredits);
};
var $author$project$Components$ResourceFilter$CreditCategory$list = $author$project$Api$Provider$CreditCategory$list;
var $author$project$Components$ResourceFilter$CreditCategory$resourceFromAll = function (category) {
	return {
		LE: $author$project$Api$Provider$CreditCategory$All$amountInCents(category),
		R$: $author$project$Api$Provider$CreditCategory$All$expiresInDays(category),
		ahP: $author$project$Api$Provider$CreditCategory$All$id(category),
		Bq: $author$project$Api$Provider$CreditCategory$All$name(category)
	};
};
var $author$project$Components$ResourceFilter$CreditCategory$fetchResources = F4(
	function (toMsg, apiClient, pagination, query) {
		return A3(
			$author$project$Components$ResourceFilter$CreditCategory$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{ajJ: pagination, akl: query});
			},
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Components$ResourceFilter$CreditCategory$resourceFromAll))));
	});
var $author$project$Components$ResourceFilter$CreditCategory$retrieveResource = F3(
	function (toMsg, apiClient, id) {
		return A3(
			$author$project$Components$ResourceFilter$CreditCategory$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						ahP: $elm$core$Maybe$Just(id)
					});
			},
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Components$ResourceFilter$CreditCategory$resourceFromAll))));
	});
var $author$project$Components$ResourceFilter$CreditCategory$selectId = 'credit_category';
var $author$project$Components$ResourceFilter$CreditCategory$toTitle = function ($) {
	return $.Bq;
};
var $author$project$Components$ResourceFilter$CreditCategory$toLabel = function (resource) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Components$ResourceFilter$CreditCategory$toTitle(resource))
		]);
};
var $author$project$Components$ResourceFilter$CreditCategory$toValue = function ($) {
	return $.ahP;
};
var $author$project$Components$ResourceFilter$CreditCategory$init = F2(
	function (apiClient, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{Sk: $author$project$Components$ResourceFilter$CreditCategory$fetchResources, ahP: $author$project$Components$ResourceFilter$CreditCategory$selectId, k$: 'Category', uk: $author$project$Components$ResourceFilter$CreditCategory$retrieveResource, u9: $author$project$Components$ResourceFilter$CreditCategory$toLabel, lN: $author$project$Components$ResourceFilter$CreditCategory$toTitle, hX: $author$project$Components$ResourceFilter$CreditCategory$toValue},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{Jy: $author$project$Components$ResourceFilter$All, b8: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Pages$Patients$PatientId_String$ManageCredits$initColumns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'issued_on', false, 'Issued On'),
		A3($author$project$Api$Column$init, '', false, 'Category'),
		A3($author$project$Api$Column$init, '', false, 'Reason'),
		A3($author$project$Api$Column$init, 'expires_on', false, 'Expires'),
		A3($author$project$Api$Column$init, 'amount_in_cents', false, 'Total Amount'),
		A3($author$project$Api$Column$init, 'used_in_cents', false, 'Amount Left')
	]);
var $author$project$Pages$Patients$PatientId_String$ManageCredits$All = 0;
var $author$project$Pages$Patients$PatientId_String$ManageCredits$Outstanding = 2;
var $author$project$Pages$Patients$PatientId_String$ManageCredits$ZeroBalance = 1;
var $author$project$Pages$Patients$PatientId_String$ManageCredits$statusOptionFromQuery = function (queryString) {
	_v0$2:
	while (true) {
		if (!queryString.$) {
			switch (queryString.a) {
				case 'zero_balance':
					return 1;
				case 'outstanding':
					return 2;
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return 0;
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$url$Url$Builder$string,
			'status',
			$author$project$Pages$Patients$PatientId_String$ManageCredits$statusOptionToValue(model.alH))
		]);
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString(
					$author$project$Spa$Generated$Route$Patients__PatientId_String__ManageCredits(
						{
							YZ: $author$project$Api$Provider$Patient$One$id(model.YY)
						}))
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.ajJ),
				A2(
					$elm$core$List$append,
					$author$project$Api$Sort$toQuery(model.alA),
					queryParams))));
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$init = F5(
	function (_v0, practice, patient, _v1, _v2) {
		var apiClient = _v1.Gv;
		var currentDate = _v1.dd;
		var query = _v2.DE;
		var _v3 = A2(
			$author$project$Components$ResourceFilter$CreditCategory$init,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Select a Credit Category', Lr: false, ai5: false});
			});
		var creditCategoriesResourceFilter = _v3.a;
		var creditCategoriesResourceFilterCmd = _v3.b;
		var model = {
			Gv: apiClient,
			N3: $author$project$Pages$Patients$PatientId_String$ManageCredits$initColumns,
			v: $elm$core$Maybe$Nothing,
			f2: creditCategoriesResourceFilter,
			bt: $author$project$Api$Data$Loading,
			dd: currentDate,
			ajJ: $author$project$Api$Pagination$initFromQuery(query),
			YY: patient,
			ZV: practice,
			alA: A3(
				$author$project$Api$Sort$withDefault,
				'issued_on',
				1,
				$author$project$Api$Sort$initFromQuery(query)),
			alH: $author$project$Pages$Patients$PatientId_String$ManageCredits$statusOptionFromQuery(
				A2($elm$core$Dict$get, 'status', query)),
			qn: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'credits-status-dropdown-filter', al6: $author$project$Pages$Patients$PatientId_String$ManageCredits$StatusDropdownMsg}))
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Pages$Patients$PatientId_String$ManageCredits$fetchCredits(model),
						$author$project$Pages$Patients$PatientId_String$ManageCredits$updateUrl(model),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$ManageCredits$CreditCategoryResourceFilterMsg, creditCategoriesResourceFilterCmd)
					])));
	});
var $author$project$Pages$Patients$PatientId_String$ManageCredits$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Patients$PatientId_String$ManageCredits$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Patients$PatientId_String$ManageCredits$CancelCreditEdit = {$: 2};
var $author$project$Components$ResourceFilter$CreditCategory$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.b8));
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$subscriptions = function (_v0) {
	var credit = _v0.v;
	var statusDropdown = _v0.qn;
	var creditCategoriesResourceFilter = _v0.f2;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$Dropdown$subscriptions(statusDropdown),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$ManageCredits$CreditCategoryResourceFilterMsg,
				$author$project$Components$ResourceFilter$CreditCategory$subscriptions(creditCategoriesResourceFilter)),
				function () {
				if (!credit.$) {
					return $author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Patients$PatientId_String$ManageCredits$CancelCreditEdit);
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}()
			]));
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$CreditCategory = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$CreditCategoryOnly = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$Date = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Api$Provider$Credit$Shared$category = function (_v0) {
	var record = _v0;
	return record.O5;
};
var $author$project$Api$Provider$Credit$All$category = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Credit$Shared$category(shared);
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$DateInputMsg = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Api$Provider$Credit$Shared$amountInCents = function (_v0) {
	var record = _v0;
	return record.LE;
};
var $author$project$Api$Provider$Credit$All$amountInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Credit$Shared$amountInCents(shared);
};
var $author$project$Api$Provider$Credit$Shared$expiresOn = function (_v0) {
	var record = _v0;
	return record.R0;
};
var $author$project$Api$Provider$Credit$All$expiresOn = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Credit$Shared$expiresOn(shared);
};
var $author$project$Api$Provider$Credit$Shared$reason = function (_v0) {
	var record = _v0;
	return record._7;
};
var $author$project$Api$Provider$Credit$All$reason = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Credit$Shared$reason(shared);
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$formFieldsFromCredit = function (credit) {
	var _v0 = $author$project$Components$DateInput$init;
	var dateInput = _v0.a;
	var dateInputCmd = _v0.b;
	return _Utils_Tuple2(
		{
			LE: $elm$core$Maybe$Just(
				$author$project$Currency$fromInt(
					$author$project$Api$Provider$Credit$All$amountInCents(credit))),
			O5: $elm$core$Maybe$Nothing,
			rZ: dateInput,
			R0: $author$project$Api$Provider$Credit$All$expiresOn(credit),
			_7: A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Api$Provider$Credit$All$reason(credit))
		},
		A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Pages$Patients$PatientId_String$ManageCredits$DateInputMsg(dateInput),
			dateInputCmd));
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$formFieldsInit = function () {
	var _v0 = $author$project$Components$DateInput$init;
	var dateInput = _v0.a;
	var dateInputCmd = _v0.b;
	return _Utils_Tuple2(
		{LE: $elm$core$Maybe$Nothing, O5: $elm$core$Maybe$Nothing, rZ: dateInput, R0: $elm$core$Maybe$Nothing, _7: ''},
		A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Pages$Patients$PatientId_String$ManageCredits$DateInputMsg(dateInput),
			dateInputCmd));
}();
var $author$project$Pages$Patients$PatientId_String$ManageCredits$formFieldsUpdate = F3(
	function (currentDate, field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{_7: string});
			case 1:
				var maybeCurrency = field.a;
				return _Utils_update(
					fields,
					{LE: maybeCurrency});
			case 2:
				var dateInput = field.a;
				var maybeDate = field.b;
				return _Utils_update(
					fields,
					{rZ: dateInput, R0: maybeDate});
			case 3:
				var creditCategory = field.a;
				return _Utils_update(
					fields,
					{
						LE: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, creditCategory.LE),
						O5: $elm$core$Maybe$Just(creditCategory),
						R0: function () {
							var _v1 = creditCategory.R$;
							if (!_v1.$) {
								var days = _v1.a;
								return $elm$core$Maybe$Just(
									A3($justinmimbs$date$Date$add, 3, days, currentDate));
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}()
					});
			default:
				var creditCategory = field.a;
				return _Utils_update(
					fields,
					{
						O5: $elm$core$Maybe$Just(creditCategory)
					});
		}
	});
var $author$project$Pages$Patients$PatientId_String$ManageCredits$NameValidation = 0;
var $author$project$Pages$Patients$PatientId_String$ManageCredits$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.O5;
			},
			_Utils_Tuple2(0, 'Please enter a category.'))
		]));
var $author$project$Api$Provider$Credit$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Credit$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Credit$Shared$id(shared);
};
var $author$project$Api$Provider$Credit$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$Credit$One$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Credit$Shared$name(shared);
};
var $author$project$Components$ResourceFilter$CreditCategory$preSelectedId = F2(
	function (id, model) {
		var _v0 = A2($author$project$Components$ResourceFilter$preSelectedId, id, model.b8);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{b8: resourceFilter}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Pages$Patients$PatientId_String$ManageCredits$CreditCreated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$Credit$One$Credit = $elm$core$Basics$identity;
var $author$project$Api$Provider$Credit$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Credit$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Patient$Credit$create = F4(
	function (apiClient, patientId, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'credit',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'credit_category',
								$elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'id',
											$elm$json$Json$Encode$string(fields.G6))
										]))),
								_Utils_Tuple2(
								'amount_in_cents',
								$elm$json$Json$Encode$int(fields.LE)),
								_Utils_Tuple2(
								'expires_on',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.R0)),
								_Utils_Tuple2(
								'reason',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields._7))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Credit$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Patient$Credit$creditsPath(patientId))));
	});
var $author$project$Pages$Patients$PatientId_String$ManageCredits$createCredit = F3(
	function (apiClient, patientId, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var apiFields = {
			LE: A2(
				$elm$core$Maybe$withDefault,
				0,
				A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.LE)),
			G6: A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.ahP;
					},
					fields.O5)),
			R0: fields.R0,
			_7: (fields._7 === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(fields._7)
		};
		return A4($author$project$Api$Provider$Patient$Credit$create, apiClient, patientId, apiFields, $author$project$Pages$Patients$PatientId_String$ManageCredits$CreditCreated);
	});
var $author$project$Pages$Patients$PatientId_String$ManageCredits$CreditUpdated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$Patient$Credit$creditPath = F2(
	function (patientId, id_) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id_]),
			$author$project$Api$Provider$Patient$Credit$creditsPath(patientId));
	});
var $author$project$Api$Provider$Patient$Credit$update = F5(
	function (apiClient, patientId, id_, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'credit',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'credit_category',
								$elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'id',
											$elm$json$Json$Encode$string(fields.G6))
										]))),
								_Utils_Tuple2(
								'amount_in_cents',
								$elm$json$Json$Encode$int(fields.LE)),
								_Utils_Tuple2(
								'expires_on',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.R0)),
								_Utils_Tuple2(
								'reason',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields._7))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Credit$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Provider$Patient$Credit$creditPath, patientId, id_))));
	});
var $author$project$Pages$Patients$PatientId_String$ManageCredits$updateCredit = F4(
	function (apiClient, patientId, id, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var apiFields = {
			LE: A2(
				$elm$core$Maybe$withDefault,
				0,
				A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.LE)),
			G6: A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.ahP;
					},
					fields.O5)),
			R0: fields.R0,
			_7: $elm$core$Maybe$Just(fields._7)
		};
		return A5($author$project$Api$Provider$Patient$Credit$update, apiClient, patientId, id, apiFields, $author$project$Pages$Patients$PatientId_String$ManageCredits$CreditUpdated);
	});
var $author$project$Pages$Patients$PatientId_String$ManageCredits$saveCredit = F4(
	function (patientId, maybeId, apiClient, formFields) {
		if (!maybeId.$) {
			var id_ = maybeId.a;
			return A4($author$project$Pages$Patients$PatientId_String$ManageCredits$updateCredit, apiClient, patientId, id_, formFields);
		} else {
			return A3($author$project$Pages$Patients$PatientId_String$ManageCredits$createCredit, apiClient, patientId, formFields);
		}
	});
var $author$project$Components$ResourceFilter$CreditCategory$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.b8);
		var modelAfterEvent = function () {
			var _v1 = result.agZ;
			if (!_v1.$) {
				var selected = _v1.a;
				return _Utils_update(
					model,
					{Jy: selected});
			} else {
				return model;
			}
		}();
		return {
			GZ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.GZ),
			agZ: result.agZ,
			aiO: _Utils_update(
				modelAfterEvent,
				{b8: result.aiO}),
			aR: result.aR
		};
	});
var $author$project$Pages$Patients$PatientId_String$ManageCredits$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bt: response,
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bt: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var field = msg.a;
				var _v2 = model.v;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var id = _v3.a;
					var form = _v3.b;
					var credit = _v3.c;
					var newForm = A3(
						$author$project$Utils$Form$update,
						$author$project$Pages$Patients$PatientId_String$ManageCredits$formFieldsUpdate(model.dd),
						field,
						form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								v: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, credit))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{v: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var _v4 = $author$project$Pages$Patients$PatientId_String$ManageCredits$formFieldsInit;
				var form = _v4.a;
				var cmd = _v4.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							v: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init(form),
									$author$project$Api$Data$NotAsked))
						}),
					cmd,
					_List_Nil);
			case 5:
				var form = msg.a;
				var maybeId = msg.b;
				var _v5 = A2($author$project$Utils$Form$validate, $author$project$Pages$Patients$PatientId_String$ManageCredits$formFieldsValidator, form);
				if (!_v5.$) {
					var _v6 = _v5.a;
					var newForm = _v6.a;
					var validFormFields = _v6.b;
					var patientId = $author$project$Api$Provider$Patient$One$id(model.YY);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								v: $elm$core$Maybe$Just(
									_Utils_Tuple3(maybeId, newForm, $author$project$Api$Data$Loading))
							}),
						A4($author$project$Pages$Patients$PatientId_String$ManageCredits$saveCredit, patientId, maybeId, model.Gv, validFormFields),
						_List_Nil);
				} else {
					var newForm = _v5.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								v: $elm$core$Maybe$Just(
									_Utils_Tuple3(maybeId, newForm, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 4:
				var credit = msg.a;
				var _v7 = function (categoryId) {
					return A2($author$project$Components$ResourceFilter$CreditCategory$preSelectedId, categoryId, model.f2);
				}(
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$CreditCategory$Shared$id(
							$author$project$Api$Provider$Credit$All$category(credit))));
				var newFilter = _v7.a;
				var filterCmd = _v7.b;
				var _v8 = $author$project$Pages$Patients$PatientId_String$ManageCredits$formFieldsFromCredit(credit);
				var newForm = _v8.a;
				var cmd = _v8.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							v: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(
										$author$project$Api$Provider$Credit$All$id(credit)),
									$author$project$Utils$Form$init(newForm),
									$author$project$Api$Data$NotAsked)),
							f2: newFilter
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								cmd,
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$ManageCredits$CreditCategoryResourceFilterMsg, filterCmd)
							])),
					_List_Nil);
			case 6:
				var response = msg.a;
				var _v9 = model.v;
				if (!_v9.$) {
					var _v10 = _v9.a;
					var id = _v10.a;
					var form = _v10.b;
					if (response.$ === 3) {
						var credit = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{v: $elm$core$Maybe$Nothing, bt: $author$project$Api$Data$Loading}),
							$author$project$Pages$Patients$PatientId_String$ManageCredits$fetchCredits(model),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									'Successfully created ' + $author$project$Api$Provider$Credit$One$name(credit)),
									$author$project$OutMsg$RetrievePatient(
									$author$project$Api$Provider$Patient$One$id(model.YY))
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									v: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var response = msg.a;
				var _v12 = model.v;
				if (!_v12.$) {
					var _v13 = _v12.a;
					var id = _v13.a;
					var form = _v13.b;
					if (response.$ === 3) {
						var credit = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{v: $elm$core$Maybe$Nothing, bt: $author$project$Api$Data$Loading}),
							$author$project$Pages$Patients$PatientId_String$ManageCredits$fetchCredits(model),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Provider$Credit$One$name(credit) + ' was successfully updated.'),
									$author$project$OutMsg$RetrievePatient(
									$author$project$Api$Provider$Patient$One$id(model.YY))
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									v: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 8:
				var dateInput = msg.a;
				var subMsg = msg.b;
				var _v15 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
				var newDateInput = _v15.a;
				var subCmd = _v15.b;
				var event = _v15.c;
				var _v16 = model.v;
				if (!_v16.$) {
					var _v17 = _v16.a;
					var id = _v17.a;
					var form = _v17.b;
					var credit = _v17.c;
					var newForm = function () {
						if (event.$ === 1) {
							var date = event.a;
							return A3(
								$author$project$Utils$Form$update,
								$author$project$Pages$Patients$PatientId_String$ManageCredits$formFieldsUpdate(model.dd),
								A2($author$project$Pages$Patients$PatientId_String$ManageCredits$Date, newDateInput, date),
								form);
						} else {
							var _v19 = $author$project$Utils$Form$fields(form);
							var expiresOn = _v19.R0;
							return A3(
								$author$project$Utils$Form$update,
								$author$project$Pages$Patients$PatientId_String$ManageCredits$formFieldsUpdate(model.dd),
								A2($author$project$Pages$Patients$PatientId_String$ManageCredits$Date, newDateInput, expiresOn),
								form);
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								v: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, credit))
							}),
						subCmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var subMsg = msg.a;
				var _v20 = A2($author$project$Ui$Dropdown$update, subMsg, model.qn);
				var dropdown = _v20.a;
				var dropdownCmd = _v20.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qn: dropdown}),
					dropdownCmd,
					_List_Nil);
			case 10:
				var status = msg.a;
				var newModel = _Utils_update(
					model,
					{bt: $author$project$Api$Data$Loading, alH: status});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Patients$PatientId_String$ManageCredits$fetchCredits(newModel),
								$author$project$Pages$Patients$PatientId_String$ManageCredits$updateUrl(newModel)
							])),
					_List_Nil);
			case 11:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{bt: $author$project$Api$Data$Loading, ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Patients$PatientId_String$ManageCredits$fetchCredits(newModel),
								$author$project$Pages$Patients$PatientId_String$ManageCredits$updateUrl(newModel)
							])),
					_List_Nil);
			case 12:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						bt: $author$project$Api$Data$Loading,
						alA: A2($author$project$Api$Sort$update, columnId, model.alA)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Patients$PatientId_String$ManageCredits$fetchCredits(newModel),
								$author$project$Pages$Patients$PatientId_String$ManageCredits$updateUrl(newModel)
							])),
					_List_Nil);
			default:
				var subMsg = msg.a;
				var resourceResult = A3($author$project$Components$ResourceFilter$CreditCategory$update, model.Gv, subMsg, model.f2);
				var newCredit = A2(
					$elm$core$Maybe$map,
					function (_v21) {
						var id = _v21.a;
						var form = _v21.b;
						var credit = _v21.c;
						var newForm = function () {
							var _v22 = resourceResult.agZ;
							if ((!_v22.$) && (!_v22.a.$)) {
								var creditCategory = _v22.a.a;
								var formField = function () {
									if (!id.$) {
										return $author$project$Pages$Patients$PatientId_String$ManageCredits$CreditCategoryOnly(creditCategory);
									} else {
										return $author$project$Pages$Patients$PatientId_String$ManageCredits$CreditCategory(creditCategory);
									}
								}();
								return A3(
									$author$project$Utils$Form$update,
									$author$project$Pages$Patients$PatientId_String$ManageCredits$formFieldsUpdate(model.dd),
									formField,
									form);
							} else {
								return form;
							}
						}();
						return _Utils_Tuple3(id, newForm, credit);
					},
					model.v);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{v: newCredit, f2: resourceResult.aiO}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$ManageCredits$CreditCategoryResourceFilterMsg, resourceResult.GZ),
					_List_Nil);
		}
	});
var $author$project$Pages$Patients$PatientId_String$ManageCredits$NewCredit = {$: 3};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$PaginationMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$SortTable = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$AmountInCents = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$FormUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$Reason = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$SaveCredit = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Ui$Form$Accessible$CreditCategoryFilter = F3(
	function (a, b, c) {
		return {$: 12, a: a, b: b, c: c};
	});
var $author$project$Ui$Form$Accessible$creditCategoryFilter = $author$project$Ui$Form$Accessible$CreditCategoryFilter;
var $author$project$Pages$Patients$PatientId_String$ManageCredits$viewCreditModal = F4(
	function (creditCategoryResourceFilter, maybeId, form, credit) {
		var modalConfig = {
			Tq: $elm$core$Maybe$Nothing,
			aih: 'Credit',
			V8: _Utils_eq(credit, $author$project$Api$Data$Loading),
			WG: maybeId,
			WH: $elm$core$Maybe$Nothing,
			Yd: $author$project$Pages$Patients$PatientId_String$ManageCredits$CancelCreditEdit,
			Yf: $author$project$Pages$Patients$PatientId_String$ManageCredits$SaveCredit(form)
		};
		var _v0 = $author$project$Utils$Form$fields(form);
		var amountInCents = _v0.LE;
		var expiresOn = _v0.R0;
		var reason = _v0._7;
		var dateInput = _v0.rZ;
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A4(
					$author$project$Ui$Form$Accessible$single,
					'Category',
					_List_fromArray(
						[
							$author$project$Ui$Form$Accessible$labelSpan(4),
							$author$project$Ui$Form$Accessible$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Accessible$errors(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						]),
					A3(
						$author$project$Ui$Form$Accessible$creditCategoryFilter,
						$author$project$Pages$Patients$PatientId_String$ManageCredits$CreditCategoryResourceFilterMsg,
						_List_fromArray(
							[
								$author$project$Components$ResourceFilter$disabled(
								$author$project$Utils$Maybe$toBool(maybeId))
							]),
						creditCategoryResourceFilter)),
					A4(
					$author$project$Ui$Form$Accessible$single,
					'Reason',
					_List_fromArray(
						[
							$author$project$Ui$Form$Accessible$labelSpan(4)
						]),
					_List_Nil,
					$author$project$Ui$Form$Accessible$textInput(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(reason),
								$author$project$Ui$Form$Input$placeholder('Extra info about credit'),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Pages$Patients$PatientId_String$ManageCredits$FormUpdated, $author$project$Pages$Patients$PatientId_String$ManageCredits$Reason))
							]))),
					A4(
					$author$project$Ui$Form$Accessible$single,
					'Expires',
					_List_fromArray(
						[
							$author$project$Ui$Form$Accessible$labelSpan(4)
						]),
					_List_Nil,
					A3(
						$author$project$Ui$Form$Accessible$dateInput,
						$author$project$Pages$Patients$PatientId_String$ManageCredits$DateInputMsg(dateInput),
						_List_fromArray(
							[
								$author$project$Components$DateInput$value(expiresOn)
							]),
						dateInput)),
					A4(
					$author$project$Ui$Form$Accessible$single,
					'Amount',
					_List_fromArray(
						[
							$author$project$Ui$Form$Accessible$labelSpan(4),
							$author$project$Ui$Form$Accessible$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Accessible$inputSpan(8)
						]),
					$author$project$Ui$Form$Accessible$currencyInput(
						_List_fromArray(
							[
								$author$project$Ui$Form$CurrencyInput$value(amountInCents),
								$author$project$Ui$Form$CurrencyInput$onInput(
								A2($elm$core$Basics$composeL, $author$project$Pages$Patients$PatientId_String$ManageCredits$FormUpdated, $author$project$Pages$Patients$PatientId_String$ManageCredits$AmountInCents)),
								$author$project$Ui$Form$CurrencyInput$placeholder('100.00')
							])))
				]));
	});
var $author$project$Ui$Table$Danger = 3;
var $author$project$Pages$Patients$PatientId_String$ManageCredits$EditCredit = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Credit$Shared$balanceInCents = function (_v0) {
	var record = _v0;
	return record.afa;
};
var $author$project$Api$Provider$Credit$All$balanceInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Credit$Shared$balanceInCents(shared);
};
var $author$project$Api$Provider$Credit$Shared$expiresSoon = function (_v0) {
	var record = _v0;
	return record.R1;
};
var $author$project$Api$Provider$Credit$All$expiresSoon = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Credit$Shared$expiresSoon(shared);
};
var $author$project$Api$Provider$Credit$Shared$isExpired = function (_v0) {
	var record = _v0;
	return record.UQ;
};
var $author$project$Api$Provider$Credit$All$isExpired = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Credit$Shared$isExpired(shared);
};
var $author$project$Api$Provider$Credit$Shared$issuedOn = function (_v0) {
	var record = _v0;
	return record.Vn;
};
var $author$project$Api$Provider$Credit$All$issuedOn = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Credit$Shared$issuedOn(shared);
};
var $author$project$Api$Provider$Credit$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Credit$Shared$name(shared);
};
var $author$project$Api$Provider$Credit$Shared$transferredInCents = function (_v0) {
	var record = _v0;
	return record.adz;
};
var $author$project$Api$Provider$Credit$All$transferredInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Credit$Shared$transferredInCents(shared);
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$viewCreditRow = function (credit) {
	var zeroBalance = !$author$project$Api$Provider$Credit$All$balanceInCents(credit);
	var rowOptions = zeroBalance ? _List_fromArray(
		[
			$author$project$Ui$Table$styled(3)
		]) : _List_Nil;
	var reason = A2(
		$elm$core$Maybe$withDefault,
		'-',
		$author$project$Api$Provider$Credit$All$reason(credit));
	var name = $author$project$Formatters$String$humanize(
		$author$project$Api$Provider$Credit$All$name(credit));
	var issuedOn = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
			$author$project$Api$Provider$Credit$All$issuedOn(credit)));
	var expiresOn = function () {
		var _v0 = $author$project$Api$Provider$Credit$All$expiresOn(credit);
		if (!_v0.$) {
			var expiration = _v0.a;
			return $author$project$Api$Provider$Credit$All$isExpired(credit) ? $elm$html$Html$text('Expired') : ($author$project$Api$Provider$Credit$All$expiresSoon(credit) ? A2(
				$author$project$Ui$Typography$text,
				_List_fromArray(
					[$author$project$Ui$Typography$danger]),
				A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, expiration)) : $elm$html$Html$text(
				A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, expiration)));
		} else {
			return $elm$html$Html$text('Never');
		}
	}();
	var amountLeft = (!$author$project$Api$Provider$Credit$All$amountInCents(credit)) ? $author$project$Api$Provider$Credit$All$transferredInCents(credit) : $author$project$Api$Provider$Credit$All$amountInCents(credit);
	return A2(
		$author$project$Ui$Table$row,
		rowOptions,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(issuedOn)
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(name)
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Tooltip$view,
						_List_fromArray(
							[
								$author$project$Ui$Tooltip$placement(0)
							]),
						reason,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$Formatters$String$ellipsis, 35, reason))
							]))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[expiresOn])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Utils$Currency$fromInt(amountLeft))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Utils$Currency$fromInt(
							$author$project$Api$Provider$Credit$All$balanceInCents(credit)))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_fromArray(
					[$author$project$Ui$Table$textRight]),
				_List_fromArray(
					[
						zeroBalance ? $author$project$Utils$Html$empty : A3(
						$author$project$Ui$Button$view,
						{mm: 'Edit credit'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick(
								$author$project$Pages$Patients$PatientId_String$ManageCredits$EditCredit(credit)),
								$author$project$Ui$Button$icon($author$project$Ui$Icon$edit),
								$author$project$Ui$Button$link
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Edit')
							]))
					]))
			]));
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$StatusFiltered = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$statusOptionToLabel = function (option) {
	switch (option) {
		case 1:
			return 'Applied';
		case 2:
			return 'Outstanding';
		default:
			return 'All Credits';
	}
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$statusDropdownOptions = function (currentStatusOption) {
	var statusOptionToItem = function (option) {
		return A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(currentStatusOption, option)),
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Pages$Patients$PatientId_String$ManageCredits$StatusFiltered(option))
				]),
			$elm$html$Html$text(
				$author$project$Pages$Patients$PatientId_String$ManageCredits$statusOptionToLabel(option)));
	};
	return A2(
		$elm$core$List$cons,
		statusOptionToItem(0),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$Dropdown$separator,
			A2(
				$elm$core$List$map,
				statusOptionToItem,
				_List_fromArray(
					[1, 2]))));
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$viewStatusDropdown = function (model) {
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Pages$Patients$PatientId_String$ManageCredits$statusOptionToLabel(model.alH))
			]),
		$author$project$Pages$Patients$PatientId_String$ManageCredits$statusDropdownOptions(model.alH),
		model.qn);
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$view = function (model) {
	var patient = model.YY;
	var credits = model.bt;
	var credit = model.v;
	var patientId = $author$project$Api$Provider$Patient$One$id(patient);
	var _v0 = function () {
		if (credits.$ === 3) {
			var data = credits.a;
			return _Utils_Tuple2(false, data);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var creds = _v0.b;
	return {
		fO: _List_fromArray(
			[
				function () {
				if (!credit.$) {
					var _v3 = credit.a;
					var id = _v3.a;
					var form = _v3.b;
					var credit_ = _v3.c;
					return A4($author$project$Pages$Patients$PatientId_String$ManageCredits$viewCreditModal, model.f2, id, form, credit_);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Link$route,
												$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
													{YZ: patientId}),
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Patient')
													])),
												A2(
												$author$project$Ui$Typography$text,
												_List_fromArray(
													[$author$project$Ui$Typography$gray]),
												'  /  Manage Credits')
											])),
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Add credit'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$ManageCredits$NewCredit),
												$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Add Credit')
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(4)
											]),
										_List_fromArray(
											[
												$author$project$Pages$Patients$PatientId_String$ManageCredits$viewStatusDropdown(model)
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$HorizontalRule$view(
								_List_fromArray(
									[$author$project$Ui$HorizontalRule$thin])),
								A4(
								$author$project$Ui$Table$view,
								_List_fromArray(
									[
										$author$project$Ui$Table$verticalCentered,
										$author$project$Ui$Table$loading(loading),
										$author$project$Ui$Table$zeroState(
										_List_fromArray(
											[
												$elm$html$Html$text('This patient has no credits. You can add credits by clicking \'Add Credit\' above.')
											]))
									]),
								$elm$core$List$concat(
									_List_fromArray(
										[
											A2(
											$elm$core$List$map,
											$author$project$Api$Column$view(
												A2($author$project$Api$Column$Sortable, model.alA, $author$project$Pages$Patients$PatientId_String$ManageCredits$SortTable)),
											model.N3),
											_List_fromArray(
											[
												A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
											])
										])),
								A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$ManageCredits$viewCreditRow, creds),
								_List_Nil)
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Patients$PatientId_String$ManageCredits$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(loading)
										]),
									model.ajJ))
							]))
					]))
			]),
		ac9: 'Patient | Credits'
	};
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$page = $author$project$Spa$Page$applicationPatient(
	{ah_: $author$project$Pages$Patients$PatientId_String$ManageCredits$init, aiq: $author$project$Pages$Patients$PatientId_String$ManageCredits$load, k8: $author$project$Pages$Patients$PatientId_String$ManageCredits$save, alO: $author$project$Pages$Patients$PatientId_String$ManageCredits$subscriptions, adT: $author$project$Pages$Patients$PatientId_String$ManageCredits$update, amo: $author$project$Pages$Patients$PatientId_String$ManageCredits$view});
var $author$project$Api$Provider$Membership$CoveragePlan = 0;
var $author$project$Components$Membership$Form$GotCancellationReasons = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Membership$Form$GotItem = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Membership$new = F5(
	function (apiClient, ownerId, companyAccountId, expand, toMsg) {
		var query = A2(
			$elm$core$List$cons,
			A2($author$project$Api$Param$string, 'owner', ownerId),
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Api$Param$list,
					'expand',
					A2($elm$core$List$map, $author$project$Api$Provider$Membership$expandToString, expand)),
				function () {
					if (!companyAccountId.$) {
						var string = companyAccountId.a;
						return _List_fromArray(
							[
								A2($author$project$Api$Param$string, 'company_account', string)
							]);
					} else {
						return _List_Nil;
					}
				}()));
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Membership$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				query,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['new']),
						$author$project$Api$Provider$Membership$membershipsPath))));
	});
var $author$project$Components$Membership$Form$retrieveItem = F2(
	function (apiClient, id) {
		return A4(
			$author$project$Api$Provider$Membership$retrieve,
			apiClient,
			id,
			_List_fromArray(
				[0]),
			$author$project$Components$Membership$Form$GotItem);
	});
var $author$project$Components$Membership$Form$init = function (apiClient) {
	return function (timeZone) {
		return function (currentDate) {
			return function (session) {
				return function (practice) {
					return function (hinterViewOff) {
						return function (query) {
							return function (patient) {
								return function (id) {
									return function (currentTime) {
										return function (url) {
											var cmd = function () {
												if (!id.$) {
													var id_ = id.a;
													return A2($author$project$Components$Membership$Form$retrieveItem, apiClient, id_);
												} else {
													return A5(
														$author$project$Api$Provider$Membership$new,
														apiClient,
														$author$project$Api$Provider$Patient$One$id(patient),
														A2($elm$core$Dict$get, 'company_account', query),
														_List_fromArray(
															[0]),
														$author$project$Components$Membership$Form$GotItem);
												}
											}();
											return _Utils_Tuple2(
												{
													d$: $elm$core$Maybe$Nothing,
													afq: $author$project$Api$Data$Loading,
													dd: currentDate,
													f7: $elm$core$Maybe$Nothing,
													ahK: hinterViewOff,
													ahP: id,
													j1: !$author$project$Utils$Maybe$toBool(id),
													kk: $elm$core$Maybe$Nothing,
													g3: $elm$core$Maybe$Nothing,
													YY: patient,
													dC: $elm$core$Maybe$Nothing,
													ZV: practice,
													hm: $author$project$Api$Data$NotAsked,
													eX: $jinjor$elm_debounce$Debounce$init,
													kU: $elm$core$Maybe$Nothing,
													k0: $elm$core$Maybe$Nothing,
													hv: true,
													k9: $author$project$Api$Data$NotAsked,
													m: $elm$core$Maybe$Nothing,
													aa4: session,
													J7: A2($author$project$Formatters$Time$init, timeZone, currentTime),
													J8: timeZone,
													adY: url
												},
												$elm$core$Platform$Cmd$batch(
													_List_fromArray(
														[
															cmd,
															A4(
															$author$project$Api$CancellationReason$list,
															apiClient,
															session,
															function (d) {
																return _Utils_update(
																	d,
																	{
																		ajJ: A2($author$project$Api$Pagination$withItemsPerPage, 100, $author$project$Api$Pagination$init)
																	});
															},
															$author$project$Components$Membership$Form$GotCancellationReasons)
														])));
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Patients$PatientId_String$Memberships$MembershipId_String$Top$init = F5(
	function (session, practice, patient, _v0, _v1) {
		var apiClient = _v0.Gv;
		var timeZone = _v0.J8;
		var currentDate = _v0.dd;
		var hinterViewOff = _v0.ahK;
		var currentTime = _v0.af3;
		var url = _v0.adY;
		var params = _v1.YL;
		var query = _v1.DE;
		var _v2 = $author$project$Components$Membership$Form$init(apiClient)(timeZone)(currentDate)(session)(practice)(hinterViewOff)(query)(patient)(
			$elm$core$Maybe$Just(params.AW))(currentTime)(url);
		var form = _v2.a;
		var cmd = _v2.b;
		return _Utils_Tuple2(
			{Gv: apiClient, SD: form},
			cmd);
	});
var $author$project$Pages$Patients$PatientId_String$Memberships$MembershipId_String$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Components$Membership$Form$save = F2(
	function (model, shared) {
		var pendingChangesExists = (!model.j1) && (!model.hv);
		return _Utils_update(
			shared,
			{
				ajY: pendingChangesExists ? $elm$core$Maybe$Just('You have draft changes to your membership. Are you sure you want to leave?') : $elm$core$Maybe$Nothing
			});
	});
var $author$project$Pages$Patients$PatientId_String$Memberships$MembershipId_String$Top$save = F2(
	function (_v0, shared) {
		var form = _v0.SD;
		return A2($author$project$Components$Membership$Form$save, form, shared);
	});
var $author$project$Components$Membership$Form$CancelModalMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Membership$Form$ContractsMsg = function (a) {
	return {$: 21, a: a};
};
var $author$project$Components$Membership$Form$DeleteHiConfirmClosed = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Components$Membership$Form$MembersMsg = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Membership$Form$OutsideAgeRangeModalClosed = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Membership$Form$PlanChangeMsg = function (a) {
	return {$: 23, a: a};
};
var $author$project$Components$Membership$Form$PricingMsg = function (a) {
	return {$: 20, a: a};
};
var $author$project$Components$Membership$Form$RecurringChargesMsg = function (a) {
	return {$: 22, a: a};
};
var $author$project$Components$Membership$Form$RenewContractModalMsg = function (a) {
	return {$: 26, a: a};
};
var $author$project$Components$Membership$Form$RestartModalMsg = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Membership$Form$SummaryMsg = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$Membership$Form$CancelModal$Close = {$: 1};
var $author$project$Components$Membership$Form$CancelModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Membership$Form$CancelModal$Close);
};
var $author$project$Components$Membership$Form$OutsideAgeRangeModal$subscriptions = F2(
	function (onClose, _v0) {
		return $author$project$Ui$Modal$subscribeToEscapeKeyPress(
			onClose(false));
	});
var $author$project$Components$Membership$Form$RenewContractModal$Close = {$: 0};
var $author$project$Components$Membership$Form$RenewContractModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Membership$Form$RenewContractModal$Close);
};
var $author$project$Components$Membership$Form$RestartModal$Close = {$: 1};
var $author$project$Components$Membership$Form$RestartModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Membership$Form$RestartModal$Close);
};
var $author$project$Components$Membership$Form$Sections$Contracts$CancelHiConfirmClosed = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Components$Membership$Form$Sections$Contracts$subscriptions = function (_v0) {
	var model = _v0;
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Platform$Sub$none,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Membership$Form$Sections$Contracts$CancelHiConfirmClosed),
			A2($elm$core$Maybe$map, $elm$core$Tuple$second, model.fR)));
};
var $author$project$Components$Membership$Form$Sections$Members$MembershipPatientMsg = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$CreatePatientModalMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$PatientResourceFilterMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$CreatePatientModal$Close = {$: 0};
var $author$project$Components$CreatePatientModal$PatientFormMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$CreatePatientModal$subscriptions = function (_v0) {
	var form = _v0.SD;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$CreatePatientModal$Close),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$CreatePatientModal$PatientFormMsg,
				$author$project$Components$Patient$Form$subscriptions(form))
			]));
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Membership$Form$Members$MembershipPatient$CreatePatientModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$CreatePatientModal$subscriptions, model.iZ))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Membership$Form$Members$MembershipPatient$PatientResourceFilterMsg,
				$author$project$Components$ResourceFilter$Patient$subscriptions(model.oY))
			]));
};
var $author$project$Components$Membership$Form$Sections$Members$subscriptions = function (_v0) {
	var membershipPatients = _v0.WR;
	return $elm$core$Platform$Sub$batch(
		A2(
			$elm$core$List$map,
			function (_v1) {
				var id = _v1.a;
				var _v2 = _v1.b;
				var membershipPatient = _v2.b;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Components$Membership$Form$Sections$Members$MembershipPatientMsg(id),
					$author$project$Components$Membership$Form$Members$MembershipPatient$subscriptions(membershipPatient));
			},
			$elm$core$Dict$toList(membershipPatients)));
};
var $author$project$Components$Membership$Form$Sections$PlanChange$CloseModal = {$: 1};
var $author$project$Components$Membership$Form$Sections$PlanChange$DeleteHiConfirmClosed = F3(
	function (a, b, c) {
		return {$: 7, a: a, b: b, c: c};
	});
var $author$project$Components$Membership$Form$Sections$PlanChange$PlanResourceFilterMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Membership$Form$Sections$PlanChange$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				function () {
				var _v1 = model.SD;
				if (!_v1.$) {
					return $author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Membership$Form$Sections$PlanChange$CloseModal);
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					function (_v2) {
						var membershipId = _v2.a;
						var scheduledChange = _v2.c;
						return $author$project$Components$HiConfirm$subscribeToEscapeKeyPress(
							A2($author$project$Components$Membership$Form$Sections$PlanChange$DeleteHiConfirmClosed, membershipId, scheduledChange));
					},
					model.f7)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Membership$Form$Sections$PlanChange$PlanResourceFilterMsg,
				$author$project$Components$ResourceFilter$Plan$subscriptions(model.hi))
			]));
};
var $author$project$Components$Membership$Form$Sections$Pricing$subscriptions = function (_v0) {
	var model = _v0;
	return $author$project$Ui$Dropdown$subscriptions(model.o0);
};
var $author$project$Components$Membership$Form$Sections$RecurringCharges$CreateEditModalMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$CancelEdit = {$: 0};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$ChargeItemResourceFilterMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$LimitedPatientSelectorMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$PractitionerResourceFilterMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$CancelEdit),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$LimitedPatientSelectorMsg,
				$author$project$Components$LimitedPatientSelector$subscriptions(model.oj)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$PractitionerResourceFilterMsg,
				$author$project$Components$ResourceFilter$Practitioner$subscriptions(model.hk)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$ChargeItemResourceFilterMsg,
				$author$project$Components$ResourceFilter$ChargeItem$subscriptions(model.cq))
			]));
};
var $author$project$Components$Membership$Form$Sections$RecurringCharges$subscriptions = function (_v0) {
	var model = _v0;
	var _v1 = model.f1;
	if (!_v1.$) {
		var createEditModal = _v1.a;
		return A2(
			$elm$core$Platform$Sub$map,
			$author$project$Components$Membership$Form$Sections$RecurringCharges$CreateEditModalMsg,
			$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$subscriptions(createEditModal));
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Components$Membership$Form$Sections$Summary$AuditTrailLogMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Membership$Form$Sections$Summary$CreateModalMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Membership$Form$Sections$Summary$PatientResourceFilterMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Membership$Form$Sections$Summary$PlanResourceFilterMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Membership$Form$Sections$Summary$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Membership$Form$Sections$Summary$CreateModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2(
						$elm$core$Maybe$map,
						A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $author$project$Components$BrokerDeal$CreateModal$subscriptions),
						model.iX))),
				$author$project$Components$AuditTrailLog$isOpen(model.iw) ? A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Membership$Form$Sections$Summary$AuditTrailLogMsg,
				$author$project$Components$AuditTrailLog$subscriptions(model.iw)) : $elm$core$Platform$Sub$none,
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Membership$Form$Sections$Summary$PatientResourceFilterMsg,
				$author$project$Components$ResourceFilter$Patient$subscriptions(model.oY)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Membership$Form$Sections$Summary$PlanResourceFilterMsg,
				$author$project$Components$ResourceFilter$Plan$subscriptions(model.hi))
			]));
};
var $author$project$Components$Membership$Form$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				function () {
				var _v0 = model.d$;
				if (!_v0.$) {
					var cancelModal = _v0.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Components$Membership$Form$CancelModalMsg,
						$author$project$Components$Membership$Form$CancelModal$subscriptions(cancelModal));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				function () {
				var _v1 = model.k0;
				if (!_v1.$) {
					var restartModal = _v1.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Components$Membership$Form$RestartModalMsg,
						$author$project$Components$Membership$Form$RestartModal$subscriptions(restartModal));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				function () {
				var _v2 = model.g3;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var outsideAgeRangeModal = _v3.a;
					return A2($author$project$Components$Membership$Form$OutsideAgeRangeModal$subscriptions, $author$project$Components$Membership$Form$OutsideAgeRangeModalClosed, outsideAgeRangeModal);
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				function () {
				var _v4 = model.m;
				if (!_v4.$) {
					var sections = _v4.a;
					return $elm$core$Platform$Sub$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Platform$Sub$map,
								$author$project$Components$Membership$Form$SummaryMsg,
								$author$project$Components$Membership$Form$Sections$Summary$subscriptions(sections.acF)),
								A2(
								$elm$core$Platform$Sub$map,
								$author$project$Components$Membership$Form$MembersMsg,
								$author$project$Components$Membership$Form$Sections$Members$subscriptions(sections.N)),
								A2(
								$elm$core$Platform$Sub$map,
								$author$project$Components$Membership$Form$PricingMsg,
								$author$project$Components$Membership$Form$Sections$Pricing$subscriptions(sections._i)),
								A2(
								$elm$core$Platform$Sub$map,
								$author$project$Components$Membership$Form$RecurringChargesMsg,
								$author$project$Components$Membership$Form$Sections$RecurringCharges$subscriptions(sections.$h)),
								A2(
								$elm$core$Platform$Sub$map,
								$author$project$Components$Membership$Form$ContractsMsg,
								$author$project$Components$Membership$Form$Sections$Contracts$subscriptions(sections.a4)),
								function () {
								var _v5 = sections.kG;
								if (!_v5.$) {
									var planChange = _v5.a;
									return A2(
										$elm$core$Platform$Sub$map,
										$author$project$Components$Membership$Form$PlanChangeMsg,
										$author$project$Components$Membership$Form$Sections$PlanChange$subscriptions(planChange));
								} else {
									return $elm$core$Platform$Sub$none;
								}
							}()
							]));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				function () {
				var _v6 = model.kU;
				if (!_v6.$) {
					var renewContractModal = _v6.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Components$Membership$Form$RenewContractModalMsg,
						$author$project$Components$Membership$Form$RenewContractModal$subscriptions(renewContractModal));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Membership$Form$DeleteHiConfirmClosed),
					A2($elm$core$Maybe$map, $elm$core$Tuple$first, model.f7)))
			]));
};
var $author$project$Pages$Patients$PatientId_String$Memberships$MembershipId_String$Top$subscriptions = function (model) {
	return $author$project$Components$Membership$Form$subscriptions(model.SD);
};
var $author$project$Components$Membership$Form$BillsOverviewMsg = function (a) {
	return {$: 24, a: a};
};
var $author$project$Components$Membership$Form$Confirmed = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Membership$Form$Contract = {$: 3};
var $author$project$Components$Membership$Form$Deleted = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Components$Membership$Form$Members = {$: 1};
var $author$project$Components$Membership$Form$Pricing = {$: 2};
var $author$project$Components$Membership$Form$RecurringCharges = {$: 4};
var $author$project$Components$Membership$Form$Summary = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Membership$confirm = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Membership$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['confirm']),
					$author$project$Api$Provider$Membership$membershipPath(id))));
	});
var $author$project$Components$Membership$Form$PriceCheckDebounced = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Membership$Form$debouncePriceCheck = function (cmd) {
	return A2(
		$elm$core$Task$perform,
		$author$project$Components$Membership$Form$PriceCheckDebounced,
		$elm$core$Task$succeed(cmd));
};
var $author$project$Api$Provider$Membership$delete = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Membership$membershipPath(id)));
	});
var $author$project$Api$Provider$MembershipContract$Shared$endDate = function (_v0) {
	var record = _v0;
	return record.sb;
};
var $author$project$Components$Membership$Form$CancelModal$EndDateInputMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Membership$Form$CancelModal$Model = $elm$core$Basics$identity;
var $author$project$Api$Provider$Membership$Meta$endDateDefaultValue = function (_v0) {
	var meta = _v0;
	return meta.sb.Qf;
};
var $author$project$Api$Provider$Membership$One$meta = function (_v0) {
	var record = _v0.b;
	return record.W4;
};
var $author$project$Components$Membership$Form$CancelModal$initFormFields = function (membership) {
	return {
		afo: $elm$core$Maybe$Nothing,
		afp: $elm$core$Maybe$Nothing,
		sb: $author$project$Api$Provider$Membership$Meta$endDateDefaultValue(
			$author$project$Api$Provider$Membership$One$meta(membership))
	};
};
var $author$project$Components$Membership$Form$CancelModal$init = F2(
	function (currentDate, membership) {
		var fields = $author$project$Components$Membership$Form$CancelModal$initFormFields(membership);
		var _v0 = $author$project$Components$DateInput$init;
		var endDateInput = _v0.a;
		var endDateInputCmd = _v0.b;
		return _Utils_Tuple2(
			{
				fR: $author$project$Api$Data$NotAsked,
				dd: currentDate,
				sd: endDateInput,
				SD: $author$project$Utils$Form$init(fields),
				kk: membership
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$CancelModal$EndDateInputMsg, endDateInputCmd));
	});
var $author$project$Components$Membership$Form$OutsideAgeRangeModal$init = F4(
	function (minimumAge, maximumAge, belowAgePatients, aboveAgePatients) {
		return {vw: aboveAgePatients, xA: belowAgePatients, WF: maximumAge, Xd: minimumAge};
	});
var $author$project$Components$Membership$Form$RenewContractModal$init = F2(
	function (membershipId, lastContractEndDate) {
		return {Ip: lastContractEndDate, AW: membershipId, aiG: $elm$core$Maybe$Nothing, pE: $author$project$Api$Data$NotAsked};
	});
var $author$project$Components$Membership$Form$RestartModal$GotPriceCheck = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$Membership$restart = F5(
	function (apiClient, id, priceCheck, nextBillDate, toMsg) {
		var body = $elm$json$Json$Encode$object(
			$elm$core$List$concat(
				_List_fromArray(
					[
						priceCheck ? _List_fromArray(
						[
							_Utils_Tuple2(
							'check_price',
							$elm$json$Json$Encode$bool(true))
						]) : _List_Nil,
						_List_fromArray(
						[
							_Utils_Tuple2(
							'next_bill_date',
							A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, nextBillDate))
						])
					])));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Membership$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['restart']),
						$author$project$Api$Provider$Membership$membershipPath(id)))));
	});
var $author$project$Components$Membership$Form$RestartModal$init = F4(
	function (apiClient, currentDate, nextBillDate, membership) {
		var dateInput = $author$project$Components$DateInput$initFromDate(
			A2($elm$core$Maybe$withDefault, currentDate, nextBillDate));
		return _Utils_Tuple2(
			{dd: currentDate, rZ: dateInput, kk: membership, XP: $elm$core$Maybe$Nothing, dC: $elm$core$Maybe$Nothing, uj: $author$project$Api$Data$NotAsked},
			A5(
				$author$project$Api$Provider$Membership$restart,
				apiClient,
				$author$project$Api$Provider$Membership$One$id(membership),
				true,
				nextBillDate,
				$author$project$Components$Membership$Form$RestartModal$GotPriceCheck));
	});
var $author$project$Components$Membership$Form$Sections$Pricing$fixedPeriodRateInCentsEdited = function (_v0) {
	var form = _v0.SD;
	var _v1 = $author$project$Utils$Form$fields(form);
	var manuallySet = _v1.cK;
	return manuallySet._1;
};
var $elm_community$list_extra$List$Extra$count = function (predicate) {
	return A2(
		$elm$core$List$foldl,
		F2(
			function (x, acc) {
				return predicate(x) ? (acc + 1) : acc;
			}),
		0);
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$fixedPeriodRateInCentsEdited = function (_v0) {
	var editFixedPeriodRateInCents = _v0.es;
	return editFixedPeriodRateInCents;
};
var $author$project$Components$Membership$Form$Sections$Members$fixedPeriodRateInCentsEditedCount = function (_v0) {
	var membershipPatients = _v0.WR;
	return A2(
		$elm_community$list_extra$List$Extra$count,
		$author$project$Components$Membership$Form$Members$MembershipPatient$fixedPeriodRateInCentsEdited,
		A2(
			$elm$core$List$map,
			$elm$core$Tuple$second,
			$elm$core$Dict$values(membershipPatients)));
};
var $author$project$Components$Membership$Form$Sections$Members$membersFields = function (_v0) {
	var membershipPatients = _v0.WR;
	return membershipPatients;
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$membershipPatientFields = function (_v0) {
	var form = _v0.SD;
	return $author$project$Utils$Form$fields(form);
};
var $author$project$Components$Membership$Form$Sections$RecurringCharges$membershipTaxProfileId = function (_v0) {
	var model = _v0;
	return model.E;
};
var $author$project$Components$Membership$Form$initSectionsShared = F5(
	function (patient, membership, pendingMembership, sections, model) {
		var _v0 = sections;
		var pricing = _v0._i;
		var members = _v0.N;
		var patients = A2(
			$elm$core$List$filterMap,
			function ($) {
				return $.YY;
			},
			A2(
				$elm$core$List$map,
				$author$project$Components$Membership$Form$Members$MembershipPatient$membershipPatientFields,
				A2(
					$elm$core$List$map,
					$elm$core$Tuple$second,
					A2(
						$elm$core$List$sortBy,
						$elm$core$Tuple$first,
						$elm$core$Dict$values(
							$author$project$Components$Membership$Form$Sections$Members$membersFields(members))))));
		var fixedPeriodRateInCentsEditedCount = $author$project$Components$Membership$Form$Sections$Members$fixedPeriodRateInCentsEditedCount(members) + ($author$project$Components$Membership$Form$Sections$Pricing$fixedPeriodRateInCentsEdited(pricing) ? 1 : 0);
		var onlyOneFixedPeriodRateInCentsEditable = _Utils_eq(
			fixedPeriodRateInCentsEditedCount,
			$elm$core$List$length(patients));
		return {
			j1: model.j1,
			kk: membership,
			aiE: $author$project$Components$Membership$Form$Sections$RecurringCharges$membershipTaxProfileId(sections.$h),
			ajA: onlyOneFixedPeriodRateInCentsEditable,
			YD: patient,
			CM: patients,
			dC: pendingMembership,
			akf: _Utils_eq(model.hm, $author$project$Api$Data$Loading),
			hv: model.hv
		};
	});
var $author$project$Components$Membership$Form$isBusy = function (model) {
	return _Utils_eq(model.k9, $author$project$Api$Data$Loading) || _Utils_eq(model.hm, $author$project$Api$Data$Loading);
};
var $author$project$Components$Membership$Form$patientsOutsideAgeRange = F2(
	function (plan, sections) {
		var patients = A2(
			$elm$core$List$filterMap,
			function ($) {
				return $.YY;
			},
			A2(
				$elm$core$List$map,
				$author$project$Components$Membership$Form$Members$MembershipPatient$membershipPatientFields,
				A2(
					$elm$core$List$map,
					$elm$core$Tuple$second,
					$elm$core$Dict$values(
						$author$project$Components$Membership$Form$Sections$Members$membersFields(sections.N)))));
		var belowAgePatients = A2(
			$elm$core$List$filter,
			function (patient) {
				var _v1 = _Utils_Tuple2(
					$author$project$Api$Provider$Plan$SharedWithContractInfo$minimumAge(plan),
					patient.Lj);
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var minimumAge = _v1.a.a;
					var age = _v1.b.a;
					return _Utils_cmp(age, minimumAge) < 0;
				} else {
					return false;
				}
			},
			patients);
		var aboveAgePatients = A2(
			$elm$core$List$filter,
			function (patient) {
				var _v0 = _Utils_Tuple2(
					$author$project$Api$Provider$Plan$SharedWithContractInfo$maximumAge(plan),
					patient.Lj);
				if ((!_v0.a.$) && (!_v0.b.$)) {
					var maximumAge = _v0.a.a;
					var age = _v0.b.a;
					return _Utils_cmp(age, maximumAge) > 0;
				} else {
					return false;
				}
			},
			patients);
		return _Utils_Tuple2(belowAgePatients, aboveAgePatients);
	});
var $author$project$Components$Membership$Form$PriceCheckDebouncedMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Membership$Form$priceCheckDebounceConfig = {
	alK: $jinjor$elm_debounce$Debounce$later(1000),
	ame: $author$project$Components$Membership$Form$PriceCheckDebouncedMsg
};
var $author$project$Api$Provider$Membership$CompanyAccount = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$Membership$AutoRenew = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$Membership$BillDate = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Membership$ContractEndDate = function (a) {
	return {$: 12, a: a};
};
var $author$project$Api$Provider$Membership$ContractExpires = function (a) {
	return {$: 13, a: a};
};
var $author$project$Api$Provider$Membership$ContractPeriodInMonths = function (a) {
	return {$: 14, a: a};
};
var $author$project$Api$Provider$Membership$ContractType = function (a) {
	return {$: 15, a: a};
};
var $author$project$Api$Provider$Membership$Coupon = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Provider$Membership$FixedPeriodRateInCents = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Provider$Membership$FixedRegistrationFeeInCents = function (a) {
	return {$: 11, a: a};
};
var $author$project$Api$Provider$Membership$MinimumEnrollmentPeriodInMonths = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$Membership$NextBillDate = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$Membership$Owner = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Membership$PaymentSource = function (a) {
	return {$: 18, a: a};
};
var $author$project$Api$Provider$Membership$PeriodInMonths = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$Membership$Plan = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Membership$RecurringCharges = function (a) {
	return {$: 16, a: a};
};
var $author$project$Api$Provider$Membership$StartDate = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Membership$TaxProfile = function (a) {
	return {$: 17, a: a};
};
var $author$project$Api$Provider$Membership$Meta$autoRenewEditable = function (_v0) {
	var meta = _v0;
	return meta.Mk.Q4;
};
var $author$project$Api$Provider$Membership$Meta$billDateEditable = function (_v0) {
	var meta = _v0;
	return meta.xB.Q4;
};
var $author$project$Api$Provider$Membership$Meta$contractEndDateEditable = function (_v0) {
	var meta = _v0;
	return meta.yQ.Q4;
};
var $author$project$Api$Provider$Membership$Meta$contractExpiresEditable = function (_v0) {
	var meta = _v0;
	return meta.OB.Q4;
};
var $author$project$Components$Membership$Form$Sections$Contracts$contractFields = function (_v0) {
	var form = _v0.SD;
	return $author$project$Utils$Form$fields(form);
};
var $author$project$Api$Provider$Membership$Meta$contractPeriodInMonthsEditable = function (_v0) {
	var meta = _v0;
	return meta.OC.Q4;
};
var $author$project$Api$Provider$Membership$Meta$contractTypeEditable = function (_v0) {
	var meta = _v0;
	return meta.G3.Q4;
};
var $author$project$Api$Provider$Membership$Meta$couponEditable = function (_v0) {
	var meta = _v0;
	return meta.OP.Q4;
};
var $author$project$Api$Provider$Membership$Meta$fixedPeriodRateInCentsEditable = function (_v0) {
	var meta = _v0;
	return meta.Sx.Q4;
};
var $author$project$Api$Provider$Membership$Meta$fixedRegistrationFeeInCentsEditable = function (_v0) {
	var meta = _v0;
	return meta.Sy.Q4;
};
var $author$project$Api$Provider$Membership$Meta$minimumEnrollmentPeriodInMonthsEditable = function (_v0) {
	var meta = _v0;
	return meta.Xf.Q4;
};
var $author$project$Api$Provider$Membership$Meta$nextBillDateEditable = function (_v0) {
	var meta = _v0;
	return meta.XP.Q4;
};
var $author$project$Api$Provider$Membership$Meta$ownerEditable = function (_v0) {
	var meta = _v0;
	return meta.YD.Q4;
};
var $author$project$Api$Provider$Membership$Meta$paymentSourceEditable = function (_v0) {
	var meta = _v0;
	return meta.Zg.Q4;
};
var $author$project$Api$Provider$Membership$Meta$periodInMonthsEditable = function (_v0) {
	var meta = _v0;
	return meta.Zs.Q4;
};
var $author$project$Api$Provider$Membership$Meta$planEditable = function (_v0) {
	var meta = _v0;
	return meta.Jb.Q4;
};
var $author$project$Components$Membership$Form$Sections$Pricing$pricingFields = function (_v0) {
	var form = _v0.SD;
	return $author$project$Utils$Form$fields(form);
};
var $author$project$Api$Provider$Membership$Meta$recurringChargesEditable = function (_v0) {
	var meta = _v0;
	return meta.$h.Q4;
};
var $author$project$Components$Membership$Form$Sections$RecurringCharges$recurringChargesFields = function (_v0) {
	var form = _v0.SD;
	return $author$project$Utils$Form$fields(form);
};
var $author$project$Api$Provider$Membership$Meta$startDateEditable = function (_v0) {
	var meta = _v0;
	return meta.ab7.Q4;
};
var $author$project$Components$Membership$Form$Sections$Summary$summaryFields = function (_v0) {
	var form = _v0.SD;
	return $author$project$Utils$Form$fields(form);
};
var $author$project$Components$Membership$Form$apiFields = F2(
	function (membership, sections) {
		var summary = $author$project$Components$Membership$Form$Sections$Summary$summaryFields(sections.acF);
		var recurringCharges = $author$project$Components$Membership$Form$Sections$RecurringCharges$recurringChargesFields(sections.$h);
		var pricing = $author$project$Components$Membership$Form$Sections$Pricing$pricingFields(sections._i);
		var meta = $author$project$Api$Provider$Membership$One$meta(membership);
		var membershipPatients = $author$project$Components$Membership$Form$Sections$Members$membersFields(sections.N);
		var contract = $author$project$Components$Membership$Form$Sections$Contracts$contractFields(sections.a4);
		return _Utils_Tuple2(
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2(
					$elm$core$List$filter,
					$elm$core$Tuple$second,
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Api$Provider$Membership$Owner(
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.ahP;
									},
									summary.YD)),
							$author$project$Api$Provider$Membership$Meta$ownerEditable(meta)),
							_Utils_Tuple2(
							$author$project$Api$Provider$Membership$Plan(
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.ahP;
									},
									summary.Jb)),
							$author$project$Api$Provider$Membership$Meta$planEditable(meta)),
							_Utils_Tuple2(
							$author$project$Api$Provider$Membership$StartDate(summary.ab7),
							$author$project$Api$Provider$Membership$Meta$startDateEditable(meta)),
							_Utils_Tuple2(
							$author$project$Api$Provider$Membership$BillDate(summary.xB),
							$author$project$Api$Provider$Membership$Meta$billDateEditable(meta)),
							_Utils_Tuple2(
							$author$project$Api$Provider$Membership$NextBillDate(summary.XP),
							$author$project$Api$Provider$Membership$Meta$nextBillDateEditable(meta)),
							_Utils_Tuple2(
							$author$project$Api$Provider$Membership$AutoRenew(summary.Mk),
							$author$project$Api$Provider$Membership$Meta$autoRenewEditable(meta)),
							_Utils_Tuple2(
							$author$project$Api$Provider$Membership$PeriodInMonths(summary.Zs),
							$author$project$Api$Provider$Membership$Meta$periodInMonthsEditable(meta)),
							_Utils_Tuple2(
							$author$project$Api$Provider$Membership$MinimumEnrollmentPeriodInMonths(summary.Xf),
							$author$project$Api$Provider$Membership$Meta$minimumEnrollmentPeriodInMonthsEditable(meta)),
							_Utils_Tuple2(
							$author$project$Api$Provider$Membership$FixedPeriodRateInCents(pricing.Sx),
							$author$project$Api$Provider$Membership$Meta$fixedPeriodRateInCentsEditable(meta)),
							_Utils_Tuple2(
							$author$project$Api$Provider$Membership$Coupon(pricing.OP),
							$author$project$Api$Provider$Membership$Meta$couponEditable(meta)),
							_Utils_Tuple2(
							$author$project$Api$Provider$Membership$FixedRegistrationFeeInCents(pricing.Sy),
							$author$project$Api$Provider$Membership$Meta$fixedRegistrationFeeInCentsEditable(meta)),
							_Utils_Tuple2(
							$author$project$Api$Provider$Membership$PaymentSource(pricing.Zg),
							$author$project$Utils$Maybe$toBool(pricing.Zg) && $author$project$Api$Provider$Membership$Meta$paymentSourceEditable(meta)),
							_Utils_Tuple2(
							$author$project$Api$Provider$Membership$ContractEndDate(contract.sb),
							$author$project$Api$Provider$Membership$Meta$contractEndDateEditable(meta)),
							_Utils_Tuple2(
							$author$project$Api$Provider$Membership$ContractExpires(contract.RZ),
							$author$project$Api$Provider$Membership$Meta$contractExpiresEditable(meta)),
							_Utils_Tuple2(
							$author$project$Api$Provider$Membership$ContractPeriodInMonths(contract.Zs),
							$author$project$Api$Provider$Membership$Meta$contractPeriodInMonthsEditable(meta)),
							_Utils_Tuple2(
							$author$project$Api$Provider$Membership$ContractType(contract.amg),
							$author$project$Api$Provider$Membership$Meta$contractTypeEditable(meta)),
							_Utils_Tuple2(
							$author$project$Api$Provider$Membership$RecurringCharges(
								A2(
									$elm$core$List$map,
									function (recurringCharge) {
										return {
											mL: recurringCharge.mL.ahP,
											aho: recurringCharge.aho,
											ahp: recurringCharge.ahp,
											ahP: recurringCharge.ahP,
											YY: A2(
												$elm$core$Maybe$map,
												function ($) {
													return $.ahP;
												},
												recurringCharge.YY),
											Zs: recurringCharge.Zs,
											aj1: recurringCharge.aj1,
											aka: A2(
												$elm$core$Maybe$map,
												function ($) {
													return $.ahP;
												},
												recurringCharge.aka),
											Dz: recurringCharge.Dz
										};
									},
									recurringCharges.$h)),
							$author$project$Api$Provider$Membership$Meta$recurringChargesEditable(meta)),
							_Utils_Tuple2(
							$author$project$Api$Provider$Membership$TaxProfile(
								$author$project$Components$Membership$Form$Sections$RecurringCharges$membershipTaxProfileId(sections.$h)),
							true)
						]))),
			A2(
				$elm$core$List$map,
				function (_v0) {
					var membershipPatient = _v0.b;
					var membershipPatientRecord = $author$project$Components$Membership$Form$Members$MembershipPatient$membershipPatientFields(membershipPatient);
					return {
						Gg: membershipPatientRecord.Gg,
						afo: A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.ahP;
							},
							membershipPatientRecord.afo),
						afp: membershipPatientRecord.afp,
						sb: membershipPatientRecord.sb,
						RF: membershipPatientRecord.RF,
						Sx: A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, membershipPatientRecord.Sx),
						ahP: membershipPatientRecord.ahP,
						WN: membershipPatientRecord.WN,
						YY: A2(
							$elm$core$Maybe$map,
							function (patient) {
								return {ahP: patient.ahP, ad9: patient.ad9};
							},
							membershipPatientRecord.YY),
						abS: A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.ahP;
							},
							membershipPatientRecord.abS),
						ab7: membershipPatientRecord.ab7
					};
				},
				$elm$core$Dict$values(membershipPatients)));
	});
var $author$project$Components$Membership$Form$Created = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$Membership$encodePaymentSource = function (maybePaymentSource) {
	if (!maybePaymentSource.$) {
		var paymentSource = maybePaymentSource.a;
		var _v1 = paymentSource.ahP;
		if (!_v1.$) {
			var id_ = _v1.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'id',
						$elm$json$Json$Encode$string(id_))
					]));
		} else {
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2('id', $elm$json$Json$Encode$null)
					]));
		}
	} else {
		return $elm$json$Json$Encode$null;
	}
};
var $author$project$Api$Provider$Membership$encodeRecurringCharge = function (fields) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ahP)),
				_Utils_Tuple2(
				'fixed_price_in_cents',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$float, fields.ahp)),
				_Utils_Tuple2(
				'fixed_description',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.aho)),
				_Utils_Tuple2(
				'quantity',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Dz)),
				_Utils_Tuple2(
				'periods_remaining',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.aj1)),
				_Utils_Tuple2(
				'period_in_months',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Zs)),
				_Utils_Tuple2(
				'charge_item',
				$author$project$Utils$Encode$association(fields.mL)),
				_Utils_Tuple2(
				'patient',
				A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.YY)),
				_Utils_Tuple2(
				'practitioner',
				A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.aka))
			]));
};
var $author$project$Api$Provider$Membership$encodeMembershipField = function (field) {
	switch (field.$) {
		case 0:
			var owner = field.a;
			return _Utils_Tuple2(
				'owner',
				A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, owner));
		case 1:
			var plan = field.a;
			return _Utils_Tuple2(
				'plan',
				A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, plan));
		case 2:
			var companyAccount = field.a;
			return _Utils_Tuple2(
				'company_account',
				A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, companyAccount));
		case 3:
			var startDate = field.a;
			return _Utils_Tuple2(
				'start_date',
				A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, startDate));
		case 4:
			var billDate = field.a;
			return _Utils_Tuple2(
				'bill_date',
				A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, billDate));
		case 5:
			var nextBillDate = field.a;
			return _Utils_Tuple2(
				'next_bill_date',
				A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, nextBillDate));
		case 6:
			var autoRenew = field.a;
			return _Utils_Tuple2(
				'auto_renew',
				$elm$json$Json$Encode$bool(autoRenew));
		case 7:
			var periodInMonths = field.a;
			return _Utils_Tuple2(
				'period_in_months',
				$elm$json$Json$Encode$int(periodInMonths));
		case 8:
			var minimumEnrollmentPeriodInMonths = field.a;
			return _Utils_Tuple2(
				'minimum_enrollment_period_in_months',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, minimumEnrollmentPeriodInMonths));
		case 9:
			var fixedPeriodRateInCents = field.a;
			return _Utils_Tuple2(
				'fixed_period_rate_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fixedPeriodRateInCents));
		case 10:
			var coupon = field.a;
			return _Utils_Tuple2(
				'coupon',
				A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, coupon));
		case 11:
			var fixedRegistrationFeeInCents = field.a;
			return _Utils_Tuple2(
				'fixed_registration_fee_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fixedRegistrationFeeInCents));
		case 12:
			var contractEndDate = field.a;
			return _Utils_Tuple2(
				'contract_end_date',
				A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, contractEndDate));
		case 13:
			var contractExpires = field.a;
			return _Utils_Tuple2(
				'contract_expires',
				$elm$json$Json$Encode$bool(contractExpires));
		case 14:
			var contractPeriodInMonths = field.a;
			return _Utils_Tuple2(
				'contract_period_in_months',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, contractPeriodInMonths));
		case 15:
			var contractType = field.a;
			return _Utils_Tuple2(
				'contract_type',
				A2($author$project$Utils$Encode$nullable, $author$project$Api$ContractType$encode, contractType));
		case 16:
			var recurringCharges = field.a;
			return _Utils_Tuple2(
				'recurring_charges',
				A2($elm$json$Json$Encode$list, $author$project$Api$Provider$Membership$encodeRecurringCharge, recurringCharges));
		case 17:
			var taxProfile = field.a;
			return _Utils_Tuple2(
				'tax_profile',
				A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, taxProfile));
		default:
			var maybePaymentSource = field.a;
			return _Utils_Tuple2(
				'payment_source',
				$author$project$Api$Provider$Membership$encodePaymentSource(maybePaymentSource));
	}
};
var $author$project$Api$MemberRelationship$encode = function (memberRelationship) {
	switch (memberRelationship) {
		case 0:
			return $elm$json$Json$Encode$string('employee');
		case 1:
			return $elm$json$Json$Encode$string('spouse');
		case 2:
			return $elm$json$Json$Encode$string('child');
		default:
			return $elm$json$Json$Encode$string('other');
	}
};
var $author$project$Api$Provider$Membership$encodePatient = function (fields) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(fields.ahP)),
				_Utils_Tuple2(
				'uses_tobacco',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$bool, fields.ad9))
			]));
};
var $author$project$Api$Provider$Membership$encodeMembershipPatient = function (fields) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(fields.ahP)),
				_Utils_Tuple2(
				'member_type',
				$author$project$Api$MemberRelationship$encode(fields.WN)),
				_Utils_Tuple2(
				'patient',
				A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Membership$encodePatient, fields.YY)),
				_Utils_Tuple2(
				'enrollment_requested_on',
				A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.RF)),
				_Utils_Tuple2(
				'start_date',
				A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.ab7)),
				_Utils_Tuple2(
				'end_date',
				A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.sb)),
				_Utils_Tuple2(
				'fixed_period_rate_in_cents',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Sx)),
				_Utils_Tuple2(
				'special_rate',
				A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.abS)),
				_Utils_Tuple2(
				'cancellation_reason',
				A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.afo)),
				_Utils_Tuple2(
				'cancellation_reason_other',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.afp)),
				_Utils_Tuple2(
				'_action',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Gg))
			]));
};
var $author$project$Api$Provider$Membership$encodeMembership = F2(
	function (fields, membershipPatients) {
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'membership_patients',
					A2($elm$json$Json$Encode$list, $author$project$Api$Provider$Membership$encodeMembershipPatient, membershipPatients)),
				A2($elm$core$List$map, $author$project$Api$Provider$Membership$encodeMembershipField, fields)));
	});
var $author$project$Api$Provider$Membership$create = F7(
	function (apiClient, fields, membershipPatients, priceCheck, expand, billNow, toMsg) {
		var body = $elm$json$Json$Encode$object(
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							_Utils_Tuple2(
							'membership',
							A2($author$project$Api$Provider$Membership$encodeMembership, fields, membershipPatients))
						]),
						priceCheck ? _List_fromArray(
						[
							_Utils_Tuple2(
							'check_price',
							$elm$json$Json$Encode$bool(true))
						]) : _List_Nil,
						billNow ? _List_fromArray(
						[
							_Utils_Tuple2(
							'create_and_bill_now',
							$elm$json$Json$Encode$bool(true))
						]) : _List_Nil
					])));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Membership$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				A2(
					$author$project$Api$Data$requestWithQuery,
					_List_fromArray(
						[
							A2(
							$author$project$Api$Param$list,
							'expand',
							A2($elm$core$List$map, $author$project$Api$Provider$Membership$expandToString, expand))
						]),
					$author$project$Api$Data$requestTo($author$project$Api$Provider$Membership$membershipsPath))));
	});
var $author$project$Components$Membership$Form$createItem = F4(
	function (apiClient, membershipApiFields, membershipPatientsApiFields, billNow) {
		return A7(
			$author$project$Api$Provider$Membership$create,
			apiClient,
			membershipApiFields,
			membershipPatientsApiFields,
			false,
			_List_fromArray(
				[0]),
			billNow,
			$author$project$Components$Membership$Form$Created);
	});
var $author$project$Components$Membership$Form$Updated = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$Membership$update = F7(
	function (apiClient, id, fields, membershipPatients, priceCheck, expand, toMsg) {
		var body = $elm$json$Json$Encode$object(
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							_Utils_Tuple2(
							'membership',
							A2($author$project$Api$Provider$Membership$encodeMembership, fields, membershipPatients))
						]),
						priceCheck ? _List_fromArray(
						[
							_Utils_Tuple2(
							'check_price',
							$elm$json$Json$Encode$bool(true))
						]) : _List_Nil
					])));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Membership$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				A2(
					$author$project$Api$Data$requestWithQuery,
					_List_fromArray(
						[
							A2(
							$author$project$Api$Param$list,
							'expand',
							A2($elm$core$List$map, $author$project$Api$Provider$Membership$expandToString, expand))
						]),
					$author$project$Api$Data$requestTo(
						$author$project$Api$Provider$Membership$membershipPath(id)))));
	});
var $author$project$Components$Membership$Form$updateItem = F4(
	function (apiClient, id, membershipApiFields, membershipPatientsApiFields) {
		return A7(
			$author$project$Api$Provider$Membership$update,
			apiClient,
			id,
			membershipApiFields,
			membershipPatientsApiFields,
			false,
			_List_fromArray(
				[0]),
			$author$project$Components$Membership$Form$Updated);
	});
var $author$project$Components$Membership$Form$saveItem = F5(
	function (apiClient, maybeId, membership, sections, billNow) {
		var _v0 = A2($author$project$Components$Membership$Form$apiFields, membership, sections);
		var membershipApiFields = _v0.a;
		var membershipPatientsApiFields = _v0.b;
		if (!maybeId.$) {
			var id_ = maybeId.a;
			return A4($author$project$Components$Membership$Form$updateItem, apiClient, id_, membershipApiFields, membershipPatientsApiFields);
		} else {
			var summary = $author$project$Components$Membership$Form$Sections$Summary$summaryFields(sections.acF);
			return A4(
				$author$project$Components$Membership$Form$createItem,
				apiClient,
				A2(
					$elm$core$List$cons,
					$author$project$Api$Provider$Membership$CompanyAccount(summary.Ob),
					membershipApiFields),
				membershipPatientsApiFields,
				billNow);
		}
	});
var $author$project$Api$Provider$Membership$Shared$isUpdatable = function (_v0) {
	var record = _v0;
	return record.Vk;
};
var $author$project$Api$Provider$Membership$One$isUpdatable = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Membership$Shared$isUpdatable(shared);
};
var $author$project$Components$Membership$Form$GotPriceCheck = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Membership$Form$priceCheck = F4(
	function (apiClient, membership, sections, model) {
		var _v0 = A2(
			$elm$core$Tuple$mapSecond,
			function (membershipPatients) {
				return A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.YY;
						},
						$author$project$Utils$Maybe$toBool),
					membershipPatients);
			},
			A2($author$project$Components$Membership$Form$apiFields, membership, sections));
		var membershipApiFields = _v0.a;
		var membershipPatientsApiFields = _v0.b;
		var _v1 = model.ahP;
		if (!_v1.$) {
			var id = _v1.a;
			return A7(
				$author$project$Api$Provider$Membership$update,
				apiClient,
				id,
				membershipApiFields,
				membershipPatientsApiFields,
				true,
				_List_fromArray(
					[0]),
				$author$project$Components$Membership$Form$GotPriceCheck);
		} else {
			var summary = $author$project$Components$Membership$Form$Sections$Summary$summaryFields(sections.acF);
			return A7(
				$author$project$Api$Provider$Membership$create,
				apiClient,
				A2(
					$elm$core$List$cons,
					$author$project$Api$Provider$Membership$CompanyAccount(summary.Ob),
					membershipApiFields),
				membershipPatientsApiFields,
				true,
				_List_fromArray(
					[0]),
				false,
				$author$project$Components$Membership$Form$GotPriceCheck);
		}
	});
var $author$project$Components$Membership$Form$validPriceCheckFields = function (sections) {
	var summary = $author$project$Components$Membership$Form$Sections$Summary$summaryFields(sections.acF);
	var membershipPatients = $author$project$Components$Membership$Form$Sections$Members$membersFields(sections.N);
	var contract = $author$project$Components$Membership$Form$Sections$Contracts$contractFields(sections.a4);
	return (!$elm$core$Dict$isEmpty(membershipPatients)) && ($author$project$Utils$Maybe$toBool(summary.Jb) && ((!contract.RZ) || ($author$project$Utils$Maybe$toBool(contract.Zs) && $author$project$Utils$Maybe$toBool(contract.amg))));
};
var $author$project$Components$Membership$Form$checkPrice = F4(
	function (apiClient, membership, newSections, model) {
		var shouldCheckPrice = $author$project$Api$Provider$Membership$One$isUpdatable(membership) && $author$project$Components$Membership$Form$validPriceCheckFields(newSections);
		var _v0 = shouldCheckPrice ? A3(
			$jinjor$elm_debounce$Debounce$push,
			$author$project$Components$Membership$Form$priceCheckDebounceConfig,
			A4($author$project$Components$Membership$Form$priceCheck, apiClient, membership, newSections, model),
			model.eX) : _Utils_Tuple2(model.eX, $elm$core$Platform$Cmd$none);
		var newDebouncer = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			shouldCheckPrice ? _Utils_update(
				model,
				{hm: $author$project$Api$Data$Loading, eX: newDebouncer}) : ((!$author$project$Components$Membership$Form$validPriceCheckFields(newSections)) ? _Utils_update(
				model,
				{hm: $author$project$Api$Data$NotAsked, eX: newDebouncer}) : _Utils_update(
				model,
				{eX: newDebouncer})),
			cmd);
	});
var $author$project$Components$Membership$Form$Sections$BillsOverview$init = F2(
	function (currentDate, membershipId) {
		return {mt: $author$project$Api$Data$NotAsked, dd: currentDate, AW: membershipId};
	});
var $author$project$Components$Membership$Form$initBillsOverview = F2(
	function (membership, model) {
		return _Utils_Tuple2(
			A2(
				$author$project$Components$Membership$Form$Sections$BillsOverview$init,
				model.dd,
				$author$project$Api$Provider$Membership$One$id(membership)),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Components$Membership$Form$Sections$Contracts$GotMembershipContracts = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Membership$Form$Sections$Contracts$Model = $elm$core$Basics$identity;
var $author$project$Api$Provider$Membership$Shared$contractEndDate = function (_v0) {
	var record = _v0;
	return record.yQ;
};
var $author$project$Api$Provider$Membership$One$contractEndDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Membership$Shared$contractEndDate(shared);
};
var $author$project$Api$Provider$Membership$Shared$contractExpires = function (_v0) {
	var record = _v0;
	return record.OB;
};
var $author$project$Api$Provider$Membership$One$contractExpires = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Membership$Shared$contractExpires(shared);
};
var $author$project$Api$Provider$Membership$One$contractPeriodInMonths = function (_v0) {
	var record = _v0.b;
	return record.OC;
};
var $author$project$Api$Provider$Membership$Shared$contractType = function (_v0) {
	var record = _v0;
	return record.G3;
};
var $author$project$Api$Provider$Membership$One$contractType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Membership$Shared$contractType(shared);
};
var $author$project$Components$Membership$Form$Sections$Contracts$initFormFields = function (membership) {
	return {
		sb: $author$project$Api$Provider$Membership$One$contractEndDate(membership),
		RZ: $author$project$Api$Provider$Membership$One$contractExpires(membership),
		Zs: $author$project$Api$Provider$Membership$One$contractPeriodInMonths(membership),
		amg: $author$project$Api$Provider$Membership$One$contractType(membership)
	};
};
var $author$project$Api$Provider$MembershipContract$All$MembershipContract = $elm$core$Basics$identity;
var $author$project$Api$Provider$MembershipContract$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$MembershipContract$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Membership$MembershipContract$membershipContractsPath = function (membershipId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['contracts']),
		$author$project$Api$Provider$Membership$membershipPath(membershipId));
};
var $author$project$Api$Provider$Membership$MembershipContract$list = F3(
	function (apiClient, membershipId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$MembershipContract$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Membership$MembershipContract$membershipContractsPath(membershipId)));
	});
var $author$project$Components$Membership$Form$Sections$Contracts$init = F3(
	function (apiClient, isNew, membership) {
		var formFields = $author$project$Components$Membership$Form$Sections$Contracts$initFormFields(membership);
		var _v0 = (!isNew) ? _Utils_Tuple2(
			$author$project$Api$Data$Loading,
			A3(
				$author$project$Api$Provider$Membership$MembershipContract$list,
				apiClient,
				$author$project$Api$Provider$Membership$One$id(membership),
				$author$project$Components$Membership$Form$Sections$Contracts$GotMembershipContracts)) : _Utils_Tuple2($author$project$Api$Data$NotAsked, $elm$core$Platform$Cmd$none);
		var membershipContracts = _v0.a;
		var membershipContractsCmd = _v0.b;
		return _Utils_Tuple2(
			{
				fR: $elm$core$Maybe$Nothing,
				jv: false,
				SD: $author$project$Utils$Form$init(formFields),
				kk: membership,
				AV: membershipContracts,
				uy: false
			},
			membershipContractsCmd);
	});
var $author$project$Components$Membership$Form$initContracts = F3(
	function (apiClient, membership, model) {
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map($author$project$Components$Membership$Form$ContractsMsg),
			A3($author$project$Components$Membership$Form$Sections$Contracts$init, apiClient, model.j1, membership));
	});
var $author$project$Components$Membership$Form$Sections$Members$GotNewMembershipPatient = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $author$project$Api$Provider$MembershipPatient$New$MembershipPatient = $elm$core$Basics$identity;
var $author$project$Api$Provider$MembershipPatient$New$Record = function (id) {
	return {ahP: id};
};
var $author$project$Api$Provider$MembershipPatient$New$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'id',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$MembershipPatient$New$Record));
var $author$project$Api$Provider$MembershipPatient$New$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$MembershipPatient$New$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$MembershipPatient$membershipPatientsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['membership_patients']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$MembershipPatient$build = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$MembershipPatient$New$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['build']),
					$author$project$Api$Provider$MembershipPatient$membershipPatientsPath)));
	});
var $author$project$Components$Membership$Form$Sections$Members$addMember = F4(
	function (apiClient, memberType, patient, startDate) {
		return A2(
			$author$project$Api$Provider$MembershipPatient$build,
			apiClient,
			A3($author$project$Components$Membership$Form$Sections$Members$GotNewMembershipPatient, memberType, patient, startDate));
	});
var $author$project$Api$Provider$Membership$One$billedThroughDate = function (_v0) {
	var record = _v0.b;
	return record.ME;
};
var $author$project$Api$Provider$Membership$One$companyAccount = function (_v0) {
	var record = _v0.b;
	return record.Ob;
};
var $author$project$Api$Provider$MembershipPatient$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$MembershipPatient$Shared$id(shared);
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$Model = $elm$core$Basics$identity;
var $author$project$Components$Membership$Form$Members$MembershipPatient$initPatientResourceFilter = F2(
	function (apiClient, patient) {
		return function (_v0) {
			var patientResourceFilter = _v0.a;
			var patientResourceFilterCmd = _v0.b;
			return A2(
				$elm$core$Maybe$withDefault,
				_Utils_Tuple2(patientResourceFilter, patientResourceFilterCmd),
				A2(
					$elm$core$Maybe$map,
					function (patient_) {
						var _v1 = A2(
							$author$project$Components$ResourceFilter$Patient$preSelectedId,
							$elm$core$Maybe$Just(patient_.ahP),
							patientResourceFilter);
						var withPreSelectedModel = _v1.a;
						var withPreSelectedCmd = _v1.b;
						return _Utils_Tuple2(
							A2(
								$author$project$Components$ResourceFilter$Patient$extraItems,
								_List_fromArray(
									[
										{Lj: patient_.Lj, ahP: patient_.ahP, WX: patient_.WX, Bq: patient_.Bq}
									]),
								withPreSelectedModel),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[withPreSelectedCmd, patientResourceFilterCmd])));
					},
					patient));
		}(
			A2(
				$author$project$Components$ResourceFilter$Patient$init,
				apiClient,
				function (d) {
					return _Utils_update(
						d,
						{Gp: 'Select a Patient', Lr: true});
				}));
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$init = F9(
	function (apiClient, currentDate, session, practice, hinterViewOff, isNew, originalPatient, originalMembershipPatient, formFields) {
		var _v0 = A2($author$project$Components$Membership$Form$Members$MembershipPatient$initPatientResourceFilter, apiClient, formFields.YY);
		var patientResourceFilter = _v0.a;
		var patientResourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{
				iZ: $elm$core$Maybe$Nothing,
				dd: currentDate,
				r4: false,
				es: $author$project$Utils$Maybe$toBool(formFields.Sx),
				r5: false,
				et: function () {
					if (!originalPatient.$) {
						var originalPatient_ = originalPatient.a;
						return _Utils_eq(originalPatient_.ad9, $elm$core$Maybe$Nothing);
					} else {
						return false;
					}
				}(),
				sd: $author$project$Components$DateInput$initFromDate(currentDate),
				sh: $author$project$Components$DateInput$initFromDate(currentDate),
				SD: $author$project$Utils$Form$init(formFields),
				ahK: hinterViewOff,
				j1: isNew,
				b2: $author$project$Utils$Maybe$toBool(formFields.abS),
				IZ: originalMembershipPatient,
				Cf: formFields,
				Yv: originalPatient,
				oY: patientResourceFilter,
				ZV: practice,
				bf: false,
				aa4: session,
				qk: false,
				lx: $author$project$Components$DateInput$initFromDate(currentDate)
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Members$MembershipPatient$PatientResourceFilterMsg, patientResourceFilterCmd));
	});
var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$cancellationReason = function (_v0) {
	var record = _v0.b;
	return record.afo;
};
var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$cancellationReasonOther = function (_v0) {
	var record = _v0.b;
	return record.afp;
};
var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$companyRegistration = function (_v0) {
	var record = _v0.b;
	return record.Oi;
};
var $author$project$Api$Provider$MembershipPatient$Shared$effectiveEndDate = function (_v0) {
	var record = _v0;
	return record.Q8;
};
var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$effectiveEndDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$MembershipPatient$Shared$effectiveEndDate(shared);
};
var $author$project$Api$Provider$MembershipPatient$Shared$endDate = function (_v0) {
	var record = _v0;
	return record.sb;
};
var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$endDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$MembershipPatient$Shared$endDate(shared);
};
var $author$project$Api$Provider$MembershipPatient$Shared$enrollmentRequestedOn = function (_v0) {
	var record = _v0;
	return record.RF;
};
var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$enrollmentRequestedOn = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$MembershipPatient$Shared$enrollmentRequestedOn(shared);
};
var $author$project$Api$Provider$MembershipPatient$Shared$firstBillStartDate = function (_v0) {
	var record = _v0;
	return record.St;
};
var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$firstBillStartDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$MembershipPatient$Shared$firstBillStartDate(shared);
};
var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$fixedPeriodRateInCents = function (_v0) {
	var record = _v0.b;
	return record.Sx;
};
var $author$project$Api$Provider$SpecialRate$Min$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$SpecialRate$Min$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Components$SpecialRate$SpecialRateRecord$fromMin = function (specialRate) {
	return {
		ahP: $author$project$Api$Provider$SpecialRate$Min$id(specialRate),
		Bq: $author$project$Api$Provider$SpecialRate$Min$name(specialRate)
	};
};
var $author$project$Components$CancellationReason$CancellationReasonRecord$fromShared = function (cancellationReason) {
	return {
		Qr: $author$project$Api$Provider$CancellationReason$Shared$description(cancellationReason),
		ahP: $author$project$Api$Provider$CancellationReason$Shared$id(cancellationReason)
	};
};
var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$memberType = function (_v0) {
	var record = _v0.b;
	return record.WN;
};
var $author$project$Api$Provider$CompanyRegistration$Meta$meta = function (_v0) {
	var record = _v0;
	return record.W4;
};
var $author$project$Components$Membership$Form$Records$patientFromSharedWithMinPractitionerAndLocation = function (patient) {
	return {
		Lj: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$age(patient),
		ahP: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$id(patient),
		ais: A2(
			$elm$core$Maybe$map,
			$author$project$Components$Membership$Form$Records$locationFromMin,
			$author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$location(patient)),
		WX: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$membershipStatus(patient),
		Bq: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$name(patient),
		aka: A2(
			$elm$core$Maybe$map,
			$author$project$Components$Membership$Form$Records$practitionerFromMin,
			$author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$practitioner(patient)),
		ad9: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$usesTobacco(patient)
	};
};
var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$specialRate = function (_v0) {
	var record = _v0.b;
	return record.abS;
};
var $author$project$Api$Provider$MembershipPatient$Shared$startDate = function (_v0) {
	var record = _v0;
	return record.ab7;
};
var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$startDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$MembershipPatient$Shared$startDate(shared);
};
var $author$project$Components$Membership$Form$Records$membershipPatientFromOne = function (membershipPatient) {
	var patient = $author$project$Api$Provider$MembershipPatient$ForMembershipOne$patient(membershipPatient);
	var companyRegistration = $author$project$Api$Provider$MembershipPatient$ForMembershipOne$companyRegistration(membershipPatient);
	var companyRegistrationRecord = A2(
		$elm$core$Maybe$map,
		function (companyRegistration_) {
			return {
				W4: $author$project$Api$Provider$CompanyRegistration$Meta$meta(companyRegistration_)
			};
		},
		companyRegistration);
	return {
		Gg: $elm$core$Maybe$Nothing,
		afo: A2(
			$elm$core$Maybe$map,
			$author$project$Components$CancellationReason$CancellationReasonRecord$fromShared,
			$author$project$Api$Provider$MembershipPatient$ForMembershipOne$cancellationReason(membershipPatient)),
		afp: $author$project$Api$Provider$MembershipPatient$ForMembershipOne$cancellationReasonOther(membershipPatient),
		Oi: companyRegistrationRecord,
		Q8: $author$project$Api$Provider$MembershipPatient$ForMembershipOne$effectiveEndDate(membershipPatient),
		sb: $author$project$Api$Provider$MembershipPatient$ForMembershipOne$endDate(membershipPatient),
		RF: $elm$core$Maybe$Just(
			$author$project$Api$Provider$MembershipPatient$ForMembershipOne$enrollmentRequestedOn(membershipPatient)),
		St: $author$project$Api$Provider$MembershipPatient$ForMembershipOne$firstBillStartDate(membershipPatient),
		Sx: A2(
			$elm$core$Maybe$map,
			$author$project$Currency$fromInt,
			$author$project$Api$Provider$MembershipPatient$ForMembershipOne$fixedPeriodRateInCents(membershipPatient)),
		ahP: $author$project$Api$Provider$MembershipPatient$ForMembershipOne$id(membershipPatient),
		WN: $author$project$Api$Provider$MembershipPatient$ForMembershipOne$memberType(membershipPatient),
		YY: $elm$core$Maybe$Just(
			$author$project$Components$Membership$Form$Records$patientFromSharedWithMinPractitionerAndLocation(patient)),
		abS: A2(
			$elm$core$Maybe$map,
			$author$project$Components$SpecialRate$SpecialRateRecord$fromMin,
			$author$project$Api$Provider$MembershipPatient$ForMembershipOne$specialRate(membershipPatient)),
		ab7: $elm$core$Maybe$Just(
			$author$project$Api$Provider$MembershipPatient$ForMembershipOne$startDate(membershipPatient))
	};
};
var $author$project$Components$Membership$Form$Sections$Members$initMembersFields = F8(
	function (apiClient, currentDate, session, practice, hinterViewOff, isNew, patient, membership) {
		var startDate = isNew ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Maybe$withDefault,
				$author$project$Api$Provider$Membership$One$startDate(membership),
				$author$project$Api$Provider$Membership$One$billedThroughDate(membership))) : $author$project$Api$Provider$Membership$One$billedThroughDate(membership);
		var membershipPatients = $author$project$Api$Provider$Membership$One$membershipPatients(membership);
		var membershipPatientsWithCmds = A2(
			$elm$core$List$map,
			function (membershipPatient) {
				var originalMembershipPatient = A2(
					$elm_community$list_extra$List$Extra$find,
					function (membershipPatient_) {
						return _Utils_eq(
							$author$project$Api$Provider$MembershipPatient$ForMembershipOne$id(membershipPatient_),
							$author$project$Api$Provider$MembershipPatient$ForMembershipOne$id(membershipPatient));
					},
					$author$project$Api$Provider$Membership$One$membershipPatients(membership));
				var originalPatient = A2(
					$elm$core$Maybe$map,
					$author$project$Components$Membership$Form$Records$patientFromSharedWithMinPractitionerAndLocation,
					A2($elm$core$Maybe$map, $author$project$Api$Provider$MembershipPatient$ForMembershipOne$patient, originalMembershipPatient));
				var membershipPatientRecord = $author$project$Components$Membership$Form$Records$membershipPatientFromOne(membershipPatient);
				return A2(
					$author$project$Utils$Tuple3$fromTuple2,
					membershipPatientRecord,
					A9($author$project$Components$Membership$Form$Members$MembershipPatient$init, apiClient, currentDate, session, practice, hinterViewOff, isNew, originalPatient, originalMembershipPatient, membershipPatientRecord));
			},
			membershipPatients);
		var membershipPatientsCmds = A2(
			$elm$core$List$map,
			function (_v2) {
				var cmd = _v2.b;
				var membershipPatientRecord = _v2.c;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Components$Membership$Form$Sections$Members$MembershipPatientMsg(membershipPatientRecord.ahP),
					cmd);
			},
			membershipPatientsWithCmds);
		var companyAccount = $author$project$Api$Provider$Membership$One$companyAccount(membership);
		var addMembershipPatientCmd = function () {
			var _v1 = _Utils_Tuple3(
				isNew,
				companyAccount,
				$author$project$Api$Provider$Patient$One$company(patient));
			if (_v1.a) {
				if ((!_v1.b.$) && (!_v1.c.$)) {
					return A4(
						$author$project$Components$Membership$Form$Sections$Members$addMember,
						apiClient,
						0,
						$elm$core$Maybe$Just(patient),
						startDate);
				} else {
					return A4(
						$author$project$Components$Membership$Form$Sections$Members$addMember,
						apiClient,
						1,
						$elm$core$Maybe$Just(patient),
						startDate);
				}
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		}();
		return _Utils_Tuple2(
			$elm$core$Dict$fromList(
				A2(
					$elm$core$List$indexedMap,
					F2(
						function (index, _v0) {
							var membershipPatientModel = _v0.a;
							var membershipPatientRecord = _v0.c;
							return _Utils_Tuple2(
								membershipPatientRecord.ahP,
								_Utils_Tuple2(index, membershipPatientModel));
						}),
					membershipPatientsWithCmds)),
			$elm$core$Platform$Cmd$batch(
				A2($elm$core$List$cons, addMembershipPatientCmd, membershipPatientsCmds)));
	});
var $author$project$Api$Provider$Membership$Meta$membershipPatientsMaxCount = function (_v0) {
	var meta = _v0;
	return meta.WS;
};
var $author$project$Components$Membership$Form$Sections$Members$init = F8(
	function (apiClient, currentDate, session, practice, patient, hinterViewOff, isNew, membership) {
		var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
		var _v0 = A8($author$project$Components$Membership$Form$Sections$Members$initMembersFields, apiClient, currentDate, session, practice, hinterViewOff, isNew, patient, membership);
		var membershipPatients = _v0.a;
		var formFieldsCmd = _v0.b;
		return _Utils_Tuple2(
			{
				dd: currentDate,
				Q1: false,
				ahK: hinterViewOff,
				j1: isNew,
				Iy: $author$project$Api$Provider$Membership$Meta$membershipPatientsMaxCount(membershipMeta),
				WR: membershipPatients,
				I_: $elm$core$Set$fromList(
					$elm$core$Dict$keys(membershipPatients)),
				ZV: practice,
				aa4: session
			},
			formFieldsCmd);
	});
var $author$project$Components$Membership$Form$initMembers = F3(
	function (apiClient, membership, model) {
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map($author$project$Components$Membership$Form$MembersMsg),
			A8($author$project$Components$Membership$Form$Sections$Members$init, apiClient, model.dd, model.aa4, model.ZV, model.YY, model.ahK, model.j1, membership));
	});
var $author$project$Api$Provider$Membership$Shared$billsAtEndOfPeriod = function (_v0) {
	var record = _v0;
	return A2($elm$core$Maybe$withDefault, false, record.MI);
};
var $author$project$Api$Provider$Membership$One$billsAtEndOfPeriod = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Membership$Shared$billsAtEndOfPeriod(shared);
};
var $author$project$Api$Provider$Membership$One$company = function (_v0) {
	var record = _v0.b;
	return record.afQ;
};
var $author$project$Components$Membership$Form$Sections$PlanChange$Model = $elm$core$Basics$identity;
var $author$project$Components$Membership$Form$Sections$PlanChange$initPlanResourceFilter = F5(
	function (apiClient, session, planType, billsAtEndOfPeriod, companyId) {
		var listOptionals = function () {
			if (!companyId.$) {
				var companyId_ = companyId.a;
				return function (d) {
					return _Utils_update(
						d,
						{
							Gz: $elm$core$Maybe$Just(companyId_),
							HE: _List_fromArray(
								[3])
						});
				};
			} else {
				return function (d) {
					return _Utils_update(
						d,
						{
							MI: billsAtEndOfPeriod ? $elm$core$Maybe$Just(true) : $elm$core$Maybe$Nothing,
							HE: _List_fromArray(
								[3]),
							De: _List_fromArray(
								[planType])
						});
				};
			}
		}();
		return A4(
			$author$project$Components$ResourceFilter$Plan$init,
			apiClient,
			session,
			listOptionals,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Select a Plan', Lr: true});
			});
	});
var $author$project$Components$Membership$Form$Sections$PlanChange$init = F7(
	function (apiClient, session, currentDate, membershipId, planType, billsAtEndOfPeriod, companyId) {
		var _v0 = A5($author$project$Components$Membership$Form$Sections$PlanChange$initPlanResourceFilter, apiClient, session, planType, billsAtEndOfPeriod, companyId);
		var planResourceFilter = _v0.a;
		var planResourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{
				dd: currentDate,
				f7: $elm$core$Maybe$Nothing,
				SD: $elm$core$Maybe$Nothing,
				sS: !$author$project$Utils$Maybe$toBool(membershipId),
				AW: membershipId,
				hi: planResourceFilter,
				k9: $author$project$Api$Data$NotAsked
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$PlanChange$PlanResourceFilterMsg, planResourceFilterCmd));
	});
var $author$project$Components$Membership$Form$initPlanChange = F3(
	function (apiClient, membership, model) {
		if (A2(
			$author$project$Utils$FeatureGate$gateAvailable,
			6,
			$author$project$Api$Practice$Provider(model.ZV))) {
			var plan = $author$project$Api$Provider$Membership$One$plan(membership);
			return A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Platform$Cmd$map($author$project$Components$Membership$Form$PlanChangeMsg),
				A2(
					$elm$core$Tuple$mapFirst,
					$elm$core$Maybe$Just,
					A7(
						$author$project$Components$Membership$Form$Sections$PlanChange$init,
						apiClient,
						model.aa4,
						model.dd,
						model.ahP,
						$author$project$Api$Provider$Plan$SharedWithContractInfo$planType(plan),
						$author$project$Api$Provider$Membership$One$billsAtEndOfPeriod(membership),
						A2(
							$elm$core$Maybe$map,
							$author$project$Api$Provider$Company$Shared$id,
							$author$project$Api$Provider$Membership$One$company(membership)))));
		} else {
			return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Components$Membership$Form$Sections$Pricing$GotCoupons = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Membership$Form$Sections$Pricing$GotPaymentMethods = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Membership$Form$Sections$Pricing$Model = $elm$core$Basics$identity;
var $author$project$Components$Membership$Form$Sections$Pricing$PaymentMethodDropdownMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$Membership$One$coupon = function (_v0) {
	var record = _v0.b;
	return record.OP;
};
var $author$project$Api$Provider$Membership$Shared$fixedPeriodRateInCents = function (_v0) {
	var record = _v0;
	return record.Sx;
};
var $author$project$Api$Provider$Membership$One$fixedPeriodRateInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Membership$Shared$fixedPeriodRateInCents(shared);
};
var $author$project$Api$Provider$Membership$Shared$fixedRegistrationFeeInCents = function (_v0) {
	var record = _v0;
	return record.Sy;
};
var $author$project$Api$Provider$Membership$One$fixedRegistrationFeeInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Membership$Shared$fixedRegistrationFeeInCents(shared);
};
var $author$project$Components$Membership$Form$Sections$Pricing$initFormFields = function (membership) {
	var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
	return {
		OP: A2(
			$elm$core$Maybe$map,
			$author$project$Api$Common$Coupon$Shared$id,
			$author$project$Api$Provider$Membership$One$coupon(membership)),
		Sx: A2(
			$elm$core$Maybe$map,
			$author$project$Currency$fromInt,
			$author$project$Api$Provider$Membership$One$fixedPeriodRateInCents(membership)),
		Sy: A2(
			$elm$core$Maybe$map,
			$author$project$Currency$fromInt,
			$author$project$Api$Provider$Membership$One$fixedRegistrationFeeInCents(membership)),
		cK: {
			_1: $author$project$Utils$Maybe$toBool(
				$author$project$Api$Provider$Membership$One$fixedPeriodRateInCents(membership)) && $author$project$Api$Provider$Membership$Meta$fixedPeriodRateInCentsEditable(membershipMeta),
			e1: $author$project$Utils$Maybe$toBool(
				$author$project$Api$Provider$Membership$One$fixedRegistrationFeeInCents(membership)) && $author$project$Api$Provider$Membership$Meta$fixedRegistrationFeeInCentsEditable(membershipMeta)
		},
		Zg: $elm$core$Maybe$Nothing
	};
};
var $author$project$Components$Membership$Form$Sections$Pricing$init = F3(
	function (apiClient, patientId, membership) {
		var formFields = $author$project$Components$Membership$Form$Sections$Pricing$initFormFields(membership);
		return _Utils_Tuple2(
			{
				yT: $author$project$Api$Data$Loading,
				Q1: $author$project$Utils$Maybe$toBool(formFields.OP),
				nq: false,
				SD: $author$project$Utils$Form$init(formFields),
				o0: $author$project$Ui$Dropdown$init(
					$author$project$Ui$Dropdown$defaultConfig(
						{ahP: 'payment-method-select', al6: $author$project$Components$Membership$Form$Sections$Pricing$PaymentMethodDropdownMsg})),
				o1: '',
				C8: $author$project$Api$Data$Loading,
				lf: $elm$core$Maybe$Nothing
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3(
						$author$project$Api$Provider$Coupon$list,
						apiClient,
						function (d) {
							return _Utils_update(
								d,
								{
									Jt: $elm$core$Maybe$Just(true)
								});
						},
						$author$project$Components$Membership$Form$Sections$Pricing$GotCoupons),
						A3($author$project$Api$Provider$Patient$PaymentMethod$list, apiClient, patientId, $author$project$Components$Membership$Form$Sections$Pricing$GotPaymentMethods)
					])));
	});
var $author$project$Components$Membership$Form$initPricing = F3(
	function (apiClient, patientId, membership) {
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map($author$project$Components$Membership$Form$PricingMsg),
			A3($author$project$Components$Membership$Form$Sections$Pricing$init, apiClient, patientId, membership));
	});
var $author$project$Components$Membership$Form$Sections$RecurringCharges$GotTaxableChargeItemsCount = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Membership$Form$Sections$RecurringCharges$Model = $elm$core$Basics$identity;
var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$chargeItem = function (_v0) {
	var record = _v0.b;
	return record.mL;
};
var $author$project$Api$Provider$ChargeItem$ForRecurringCharge$description = function (_v0) {
	var record = _v0.b;
	return record.Qr;
};
var $author$project$Api$Provider$ChargeItem$ForRecurringCharge$id = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Min$id(min);
};
var $author$project$Api$Provider$ChargeItem$ForRecurringCharge$name = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Min$name(min);
};
var $author$project$Api$Provider$ChargeItem$ForRecurringCharge$priceInCents = function (_v0) {
	var record = _v0.b;
	return record.Dw;
};
var $author$project$Api$Provider$ChargeItem$ForRecurringCharge$taxable = function (_v0) {
	var record = _v0.b;
	return record.acZ;
};
var $author$project$Components$Membership$Form$Records$chargeItemFromForRecurringCharge = function (chargeItem) {
	return {
		Qr: $author$project$Api$Provider$ChargeItem$ForRecurringCharge$description(chargeItem),
		ahP: $author$project$Api$Provider$ChargeItem$ForRecurringCharge$id(chargeItem),
		Bq: $author$project$Api$Provider$ChargeItem$ForRecurringCharge$name(chargeItem),
		Dw: $author$project$Api$Provider$ChargeItem$ForRecurringCharge$priceInCents(chargeItem),
		acZ: $author$project$Api$Provider$ChargeItem$ForRecurringCharge$taxable(chargeItem)
	};
};
var $author$project$Api$Provider$RecurringCharge$Shared$fixedDescription = function (_v0) {
	var record = _v0;
	return record.aho;
};
var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$fixedDescription = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$RecurringCharge$Shared$fixedDescription(shared);
};
var $author$project$Api$Provider$RecurringCharge$Shared$fixedPriceInCents = function (_v0) {
	var record = _v0;
	return record.ahp;
};
var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$fixedPriceInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$RecurringCharge$Shared$fixedPriceInCents(shared);
};
var $author$project$Api$Provider$RecurringCharge$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$RecurringCharge$Shared$id(shared);
};
var $author$project$Api$Provider$RecurringCharge$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$RecurringCharge$Shared$name(shared);
};
var $author$project$Api$Provider$RecurringCharge$Shared$nextBillDate = function (_v0) {
	var record = _v0;
	return record.XP;
};
var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$nextBillDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$RecurringCharge$Shared$nextBillDate(shared);
};
var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$patient = function (_v0) {
	var record = _v0.b;
	return record.YY;
};
var $author$project$Components$Membership$Form$Records$patientFromMin = function (patient) {
	return {
		Lj: $elm$core$Maybe$Nothing,
		ahP: $author$project$Api$Provider$Patient$Min$id(patient),
		ais: $elm$core$Maybe$Nothing,
		WX: '',
		Bq: $author$project$Api$Provider$Patient$Min$name(patient),
		aka: $elm$core$Maybe$Nothing,
		ad9: $elm$core$Maybe$Nothing
	};
};
var $author$project$Api$Provider$RecurringCharge$Shared$periodInMonths = function (_v0) {
	var record = _v0;
	return record.Zs;
};
var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$periodInMonths = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$RecurringCharge$Shared$periodInMonths(shared);
};
var $author$project$Api$Provider$RecurringCharge$Shared$periodsMax = function (_v0) {
	var record = _v0;
	return record.Zu;
};
var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$periodsMax = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$RecurringCharge$Shared$periodsMax(shared);
};
var $author$project$Api$Provider$RecurringCharge$Shared$periodsRemaining = function (_v0) {
	var record = _v0;
	return record.aj1;
};
var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$periodsRemaining = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$RecurringCharge$Shared$periodsRemaining(shared);
};
var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$practitioner = function (_v0) {
	var record = _v0.b;
	return record.aka;
};
var $author$project$Api$Provider$RecurringCharge$Shared$quantity = function (_v0) {
	var record = _v0;
	return record.Dz;
};
var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$quantity = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$RecurringCharge$Shared$quantity(shared);
};
var $author$project$Api$Provider$RecurringCharge$Shared$startDate = function (_v0) {
	var record = _v0;
	return record.ab7;
};
var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$startDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$RecurringCharge$Shared$startDate(shared);
};
var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$uom = function (_v0) {
	var record = _v0.b;
	return record.adP;
};
var $author$project$Components$Membership$Form$Records$recurringChargeFromForMembershipOne = function (recurringCharge) {
	var practitioner = $author$project$Api$Provider$RecurringCharge$ForMembershipOne$practitioner(recurringCharge);
	var patient = $author$project$Api$Provider$RecurringCharge$ForMembershipOne$patient(recurringCharge);
	var chargeItem = $author$project$Api$Provider$RecurringCharge$ForMembershipOne$chargeItem(recurringCharge);
	return {
		mL: $author$project$Components$Membership$Form$Records$chargeItemFromForRecurringCharge(chargeItem),
		aho: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$fixedDescription(recurringCharge),
		ahp: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$fixedPriceInCents(recurringCharge),
		ahP: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$id(recurringCharge),
		Bq: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$name(recurringCharge),
		XP: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$nextBillDate(recurringCharge),
		YY: $elm$core$Maybe$Just(
			$author$project$Components$Membership$Form$Records$patientFromMin(patient)),
		Zs: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$periodInMonths(recurringCharge),
		Zu: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$periodsMax(recurringCharge),
		aj1: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$periodsRemaining(recurringCharge),
		aka: A2($elm$core$Maybe$map, $author$project$Components$Membership$Form$Records$practitionerFromMin, practitioner),
		Dz: $elm$core$Maybe$Just(
			$author$project$Api$Provider$RecurringCharge$ForMembershipOne$quantity(recurringCharge)),
		ab7: $elm$core$Maybe$Just(
			$author$project$Api$Provider$RecurringCharge$ForMembershipOne$startDate(recurringCharge)),
		adP: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$uom(recurringCharge)
	};
};
var $author$project$Api$Provider$Membership$One$recurringCharges = function (_v0) {
	var record = _v0.b;
	return record.$h;
};
var $author$project$Components$Membership$Form$Sections$RecurringCharges$formFieldsInit = function (membership) {
	var recurringCharges = $author$project$Api$Provider$Membership$One$recurringCharges(membership);
	return {
		$h: A2($elm$core$List$map, $author$project$Components$Membership$Form$Records$recurringChargeFromForMembershipOne, recurringCharges)
	};
};
var $author$project$Api$Provider$Membership$One$taxProfileId = function (_v0) {
	var record = _v0.b;
	return record.acY;
};
var $author$project$Components$Membership$Form$Sections$RecurringCharges$init = F3(
	function (apiClient, practice, membership) {
		var showItemTypeInTitle = A2(
			$author$project$Utils$FeatureGate$gateAvailable,
			14,
			$author$project$Api$Practice$Provider(practice));
		var formFields = $author$project$Components$Membership$Form$Sections$RecurringCharges$formFieldsInit(membership);
		var initialMembershipTaxProfileId = A2(
			$elm$core$List$any,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.mL;
				},
				function ($) {
					return $.acZ;
				}),
			formFields.$h) ? $author$project$Api$Provider$Membership$One$taxProfileId(membership) : $elm$core$Maybe$Nothing;
		return _Utils_Tuple2(
			{
				f1: $elm$core$Maybe$Nothing,
				SD: $author$project$Utils$Form$init(formFields),
				sv: false,
				E: initialMembershipTaxProfileId,
				EC: showItemTypeInTitle
			},
			A3(
				$author$project$Api$Provider$ChargeItem$list,
				apiClient,
				function (d) {
					return _Utils_update(
						d,
						{
							ajJ: A2($author$project$Api$Pagination$withItemsPerPage, 0, $author$project$Api$Pagination$init),
							acZ: $elm$core$Maybe$Just(false)
						});
				},
				$author$project$Components$Membership$Form$Sections$RecurringCharges$GotTaxableChargeItemsCount));
	});
var $author$project$Components$Membership$Form$initRecurringCharges = F3(
	function (apiClient, practice, membership) {
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map($author$project$Components$Membership$Form$RecurringChargesMsg),
			A3($author$project$Components$Membership$Form$Sections$RecurringCharges$init, apiClient, practice, membership));
	});
var $author$project$Components$Membership$Form$Sections$Summary$Model = $elm$core$Basics$identity;
var $author$project$Components$Membership$Form$Sections$Summary$NextBillDateInputMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Membership$Form$Sections$Summary$StartDateInputMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$Membership$One$createdAt = function (_v0) {
	var record = _v0.b;
	return record.O1;
};
var $author$project$Components$BrokerDeal$BrokerDealRecord$fromProviderOne = function (brokerDeal) {
	return {
		xF: $author$project$Api$Provider$BrokerDeal$One$broker(brokerDeal),
		afQ: $author$project$Api$Provider$BrokerDeal$One$company(brokerDeal),
		PS: $author$project$Api$Provider$BrokerDeal$One$dealName(brokerDeal),
		PT: $author$project$Api$Provider$BrokerDeal$One$dealType(brokerDeal),
		sb: $author$project$Api$Provider$BrokerDeal$One$endDate(brokerDeal),
		ahP: $author$project$Api$Provider$BrokerDeal$One$id(brokerDeal),
		W4: $author$project$Api$Provider$BrokerDeal$One$meta(brokerDeal),
		_4: $author$project$Api$Provider$BrokerDeal$One$rates(brokerDeal)
	};
};
var $author$project$Components$Membership$Form$Sections$Summary$initPatientResourceFilter = function (apiClient) {
	return A2(
		$author$project$Components$ResourceFilter$Patient$init,
		apiClient,
		function (d) {
			return _Utils_update(
				d,
				{Lr: false});
		});
};
var $author$project$Api$Provider$Membership$One$neverBeenBilled = function (_v0) {
	var record = _v0.b;
	return record.XH;
};
var $author$project$Components$Membership$Form$Sections$Summary$initPlanResourceFilter = F3(
	function (apiClient, session, membership) {
		var listOptionals = function () {
			var _v0 = $author$project$Api$Provider$Membership$One$company(membership);
			if (!_v0.$) {
				var company = _v0.a;
				return function (d) {
					return _Utils_update(
						d,
						{
							Gz: $elm$core$Maybe$Just(
								$author$project$Api$Provider$Company$Shared$id(company))
						});
				};
			} else {
				var planType = _List_fromArray(
					[2, 3]);
				var billsAtEndOfPeriod = $author$project$Api$Provider$Membership$One$billsAtEndOfPeriod(membership) && (!$author$project$Api$Provider$Membership$One$neverBeenBilled(membership));
				return function (d) {
					return _Utils_update(
						d,
						{
							MI: billsAtEndOfPeriod ? $elm$core$Maybe$Just(true) : $elm$core$Maybe$Nothing,
							De: planType
						});
				};
			}
		}();
		return A4(
			$author$project$Components$ResourceFilter$Plan$init,
			apiClient,
			session,
			listOptionals,
			function (d) {
				return _Utils_update(
					d,
					{Lr: false});
			});
	});
var $author$project$Api$Provider$Membership$One$autoRenew = function (_v0) {
	var record = _v0.b;
	return record.Mk;
};
var $author$project$Api$Provider$Membership$Shared$billDate = function (_v0) {
	var record = _v0;
	return record.xB;
};
var $author$project$Api$Provider$Membership$One$billDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Membership$Shared$billDate(shared);
};
var $author$project$Api$Provider$Membership$Shared$minimumEnrollmentPeriodInMonths = function (_v0) {
	var record = _v0;
	return record.Xf;
};
var $author$project$Api$Provider$Membership$One$minimumEnrollmentPeriodInMonths = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Membership$Shared$minimumEnrollmentPeriodInMonths(shared);
};
var $author$project$Api$Provider$Membership$Shared$nextBillDate = function (_v0) {
	var record = _v0;
	return record.XP;
};
var $author$project$Api$Provider$Membership$One$nextBillDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Membership$Shared$nextBillDate(shared);
};
var $author$project$Api$Provider$Membership$One$periodInMonths = function (_v0) {
	var record = _v0.b;
	return record.Zs;
};
var $author$project$Components$Membership$Form$Records$planFromSharedWithContractInfo = function (plan) {
	return {
		ahP: $author$project$Api$Provider$Plan$SharedWithContractInfo$id(plan),
		Bq: $author$project$Api$Provider$Plan$SharedWithContractInfo$name(plan)
	};
};
var $author$project$Api$Provider$Membership$One$status = function (_v0) {
	var record = _v0.b;
	return record.alH;
};
var $author$project$Components$Membership$Form$Sections$Summary$initSummaryFields = F4(
	function (currentDate, isNew, practice, membership) {
		var minimumEnrollmentPeriodInMonths = $author$project$Api$Provider$Membership$One$minimumEnrollmentPeriodInMonths(membership);
		var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
		var setBillDate = ($author$project$Api$Provider$Membership$Meta$nextBillDateEditable(membershipMeta) && $author$project$Api$Provider$Membership$Meta$billDateEditable(membershipMeta)) ? _Utils_eq(
			$author$project$Api$Provider$Membership$One$billDate(membership),
			$author$project$Api$Provider$Membership$One$nextBillDate(membership)) : ($author$project$Api$Provider$Membership$Meta$nextBillDateEditable(membershipMeta) ? false : $author$project$Api$Provider$Membership$Meta$billDateEditable(membershipMeta));
		var companyAccount = $author$project$Api$Provider$Membership$One$companyAccount(membership);
		var _v0 = function () {
			var _v1 = _Utils_Tuple2(isNew, companyAccount);
			if (_v1.a && (!_v1.b.$)) {
				var companyAccount_ = _v1.b.a;
				var eligibilityStartDate = A2(
					$elm$core$Maybe$withDefault,
					currentDate,
					$author$project$Api$Provider$CompanyAccount$Shared$eligibilityStartDate(companyAccount_));
				return _Utils_Tuple2(
					(A2($justinmimbs$date$Date$compare, eligibilityStartDate, currentDate) === 2) ? $elm$core$Maybe$Just(eligibilityStartDate) : $elm$core$Maybe$Nothing,
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$Membership$One$startDate(membership)));
			} else {
				return _Utils_Tuple2(
					$elm$core$Maybe$Nothing,
					$author$project$Api$Provider$Membership$One$nextBillDate(membership));
			}
		}();
		var futureEligibilityDate = _v0.a;
		var nextBillDate = _v0.b;
		return {
			Mk: $author$project$Api$Provider$Membership$One$autoRenew(membership),
			xB: $author$project$Api$Provider$Membership$Meta$billDateEditable(membershipMeta) ? (setBillDate ? $author$project$Api$Provider$Membership$One$billDate(membership) : $elm$core$Maybe$Nothing) : $elm$core$Maybe$Nothing,
			Ob: A2($elm$core$Maybe$map, $author$project$Api$Provider$CompanyAccount$Shared$id, companyAccount),
			HU: futureEligibilityDate,
			cK: {ab7: false},
			Xf: minimumEnrollmentPeriodInMonths,
			XP: $author$project$Api$Provider$Membership$Meta$nextBillDateEditable(membershipMeta) ? nextBillDate : $elm$core$Maybe$Nothing,
			YD: A2(
				$elm$core$Maybe$map,
				$author$project$Components$Membership$Form$Records$patientFromShared,
				$author$project$Api$Provider$Membership$One$owner(membership)),
			Zs: $author$project$Api$Provider$Membership$One$periodInMonths(membership),
			Jb: (isNew && A2($author$project$Api$Provider$Practice$One$featureEnabled, 17, practice)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				$author$project$Components$Membership$Form$Records$planFromSharedWithContractInfo(
					$author$project$Api$Provider$Membership$One$plan(membership))),
			ff: setBillDate,
			ab7: function () {
				if ($author$project$Api$Provider$Membership$Meta$startDateEditable(membershipMeta)) {
					var startDateMembership = $author$project$Api$Provider$Membership$One$startDate(membership);
					var startDate = (($author$project$Api$Provider$Membership$One$status(membership) === 'unconfirmed') && A2($author$project$Utils$Date$isBefore, startDateMembership, currentDate)) ? currentDate : startDateMembership;
					return $elm$core$Maybe$Just(startDate);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}()
		};
	});
var $author$project$Components$Membership$Form$Sections$Summary$init = function (apiClient) {
	return function (timeZone) {
		return function (currentDate) {
			return function (session) {
				return function (practice) {
					return function (isNew) {
						return function (timeFormatter) {
							return function (hinterViewOff) {
								return function (url) {
									return function (membership) {
										var membershipCreatedAt = $author$project$Api$Provider$Membership$One$createdAt(membership);
										var formFields = A4($author$project$Components$Membership$Form$Sections$Summary$initSummaryFields, currentDate, isNew, practice, membership);
										var brokerDeals = A2(
											$elm$core$List$map,
											$author$project$Components$BrokerDeal$BrokerDealRecord$fromProviderOne,
											$author$project$Api$Provider$Membership$One$brokerDeals(membership));
										var _v0 = $author$project$Components$DateInput$init;
										var startDateInput = _v0.a;
										var startDateInputCmd = _v0.b;
										var _v1 = A3($author$project$Components$Membership$Form$Sections$Summary$initPlanResourceFilter, apiClient, session, membership);
										var planResourceFilter = _v1.a;
										var planResourceFilterCmd = _v1.b;
										var _v2 = $author$project$Components$Membership$Form$Sections$Summary$initPatientResourceFilter(apiClient);
										var patientResourceFilter = _v2.a;
										var patientResourceFilterCmd = _v2.b;
										var _v3 = $author$project$Components$DateInput$init;
										var nextBillDateInput = _v3.a;
										var nextBillDateInputCmd = _v3.b;
										return _Utils_Tuple2(
											{
												iw: A7(
													$author$project$Components$AuditTrailLog$init,
													session,
													url,
													timeFormatter,
													$elm$core$Maybe$Just('membership'),
													$elm$core$Maybe$Just(
														$author$project$Api$Provider$Membership$One$id(membership)),
													membershipCreatedAt,
													$elm$core$Maybe$Nothing),
												MR: brokerDeals,
												fR: $elm$core$Maybe$Nothing,
												iX: $elm$core$Maybe$Nothing,
												dd: currentDate,
												jv: false,
												SD: $author$project$Utils$Form$init(formFields),
												ahK: hinterViewOff,
												j1: isNew,
												BM: false,
												tj: nextBillDateInput,
												oY: patientResourceFilter,
												hi: planResourceFilter,
												ZV: practice,
												aa4: session,
												p0: {
													fx: (!$author$project$Utils$Maybe$toBool(formFields.Xf)) && $author$project$Api$Provider$Membership$One$neverBeenBilled(membership),
													XP: false,
													YD: false,
													Jb: isNew && A2($author$project$Api$Provider$Practice$One$featureEnabled, 17, practice)
												},
												lx: startDateInput,
												J8: timeZone
											},
											$elm$core$Platform$Cmd$batch(
												_List_fromArray(
													[
														A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$Summary$PatientResourceFilterMsg, patientResourceFilterCmd),
														A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$Summary$PlanResourceFilterMsg, planResourceFilterCmd),
														A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$Summary$StartDateInputMsg, startDateInputCmd),
														A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$Summary$NextBillDateInputMsg, nextBillDateInputCmd)
													])));
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Membership$Form$initSummary = F3(
	function (apiClient, membership, model) {
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map($author$project$Components$Membership$Form$SummaryMsg),
			$author$project$Components$Membership$Form$Sections$Summary$init(apiClient)(model.J8)(model.dd)(model.aa4)(model.ZV)(model.j1)(model.J7)(model.ahK)(model.adY)(membership));
	});
var $author$project$Components$Membership$Form$setupMembershipOnScope = F3(
	function (apiClient, membership, model) {
		var _v0 = A3($author$project$Components$Membership$Form$initSummary, apiClient, membership, model);
		var summary = _v0.a;
		var summaryCmd = _v0.b;
		var _v1 = A3($author$project$Components$Membership$Form$initRecurringCharges, apiClient, model.ZV, membership);
		var recurringCharges = _v1.a;
		var recurringChargesCmd = _v1.b;
		var _v2 = A3(
			$author$project$Components$Membership$Form$initPricing,
			apiClient,
			$author$project$Api$Provider$Patient$One$id(model.YY),
			membership);
		var pricing = _v2.a;
		var pricingCmd = _v2.b;
		var _v3 = A3($author$project$Components$Membership$Form$initPlanChange, apiClient, membership, model);
		var planChange = _v3.a;
		var planChangeCmd = _v3.b;
		var _v4 = A3($author$project$Components$Membership$Form$initMembers, apiClient, membership, model);
		var members = _v4.a;
		var membersCmd = _v4.b;
		var _v5 = A3($author$project$Components$Membership$Form$initContracts, apiClient, membership, model);
		var contracts = _v5.a;
		var contractsCmd = _v5.b;
		var _v6 = A2($author$project$Components$Membership$Form$initBillsOverview, membership, model);
		var billsOverview = _v6.a;
		var billsOverviewCmd = _v6.b;
		var sections = {rv: billsOverview, a4: contracts, N: members, kG: planChange, _i: pricing, $h: recurringCharges, acF: summary};
		var newModel = _Utils_update(
			model,
			{
				kk: $elm$core$Maybe$Just(membership),
				dC: $elm$core$Maybe$Just(membership),
				hv: true,
				m: $elm$core$Maybe$Just(sections)
			});
		return A2(
			$elm$core$Tuple$mapSecond,
			function (checkPriceCmd) {
				return $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[summaryCmd, membersCmd, pricingCmd, contractsCmd, recurringChargesCmd, billsOverviewCmd, planChangeCmd, checkPriceCmd]));
			},
			A4($author$project$Components$Membership$Form$checkPrice, apiClient, membership, sections, newModel));
	});
var $author$project$Components$Membership$Form$CancelModal$Cancelled = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Membership$Form$CancelModal$Closed = {$: 1};
var $author$project$Components$Membership$Form$CancelModal$EndDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Membership$Form$CancelModal$MembershipCancelled = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Membership$Form$CancelModal$None = {$: 0};
var $author$project$Api$Provider$Membership$cancel = F4(
	function (apiClient, id, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'membership',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'end_date',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.sb)),
								_Utils_Tuple2(
								'cancellation_reason',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.afo)),
								_Utils_Tuple2(
								'cancellation_reason_other',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.afp))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Membership$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['cancel']),
						$author$project$Api$Provider$Membership$membershipPath(id)))));
	});
var $author$project$Components$Membership$Form$CancelModal$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var date = field.a;
			return _Utils_update(
				fields,
				{sb: date});
		} else {
			var _v1 = field.a;
			var cancellationReason = _v1.a;
			var cancellationReasonOther = _v1.b;
			return _Utils_update(
				fields,
				{afo: cancellationReason, afp: cancellationReasonOther});
		}
	});
var $author$project$Components$Membership$Form$CancelModal$CancellationReasonOtherValidation = 2;
var $author$project$Components$Membership$Form$CancelModal$CancellationReasonValidation = 1;
var $author$project$Components$Membership$Form$CancelModal$EndDateValidation = 0;
var $author$project$Api$Provider$Membership$Meta$endDateSponsoredMin = function (_v0) {
	var meta = _v0;
	return meta.sb.ab3;
};
var $author$project$Components$Membership$Form$CancelModal$validateEndDate = F2(
	function (membership, fields) {
		var minEndDate = $author$project$Api$Provider$Membership$One$isSponsored(membership) ? $author$project$Api$Provider$Membership$Meta$endDateSponsoredMin(
			$author$project$Api$Provider$Membership$One$meta(membership)) : $elm$core$Maybe$Nothing;
		var _v0 = _Utils_Tuple2(fields.sb, minEndDate);
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				var endDate = _v0.a.a;
				var minEndDate_ = _v0.b.a;
				return (!A2($justinmimbs$date$Date$compare, endDate, minEndDate_)) ? _List_fromArray(
					[
						_Utils_Tuple2(
						0,
						'Please enter a date greater or equal than ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, minEndDate_))
					]) : _List_Nil;
			} else {
				var _v1 = _v0.b;
				return _List_Nil;
			}
		} else {
			var _v2 = _v0.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(0, 'Please enter a date.')
				]);
		}
	});
var $author$project$Components$Membership$Form$CancelModal$formFieldsValidator = function (membership) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$Membership$Form$CancelModal$validateEndDate(membership)),
				$rtfeldman$elm_validate$Validate$fromErrors(
				A2($author$project$Components$CancellationReason$Input$validate, 1, 2))
			]));
};
var $author$project$Components$Membership$Form$CancelModal$updateDateInputFormField = F7(
	function (model, dateInputGetter, dateInputSetter, subMsg, toMsg, field, fieldGetter) {
		var dateInput = dateInputGetter(model);
		var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
		var newDateInput = _v0.a;
		var subCmd = _v0.b;
		var event = _v0.c;
		var newForm = function () {
			if (event.$ === 1) {
				var date = event.a;
				return A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Membership$Form$CancelModal$formFieldsUpdate,
					field(date),
					model.SD);
			} else {
				var fields = $author$project$Utils$Form$fields(model.SD);
				return A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Membership$Form$CancelModal$formFieldsUpdate,
					field(
						fieldGetter(fields)),
					model.SD);
			}
		}();
		return {
			GZ: A2($elm$core$Platform$Cmd$map, toMsg, subCmd),
			agZ: $author$project$Components$Membership$Form$CancelModal$None,
			aiO: A2(
				dateInputSetter,
				newDateInput,
				_Utils_update(
					model,
					{SD: newForm})),
			aR: _List_Nil
		};
	});
var $author$project$Components$Membership$Form$CancelModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 1:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$Membership$Form$CancelModal$Closed, aiO: model, aR: _List_Nil};
			case 0:
				var _v2 = A2(
					$author$project$Utils$Form$validate,
					$author$project$Components$Membership$Form$CancelModal$formFieldsValidator(model.kk),
					model.SD);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var newForm = _v3.a;
					var validFormFields = _v3.b;
					var validFields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
					var apiFields = {
						afo: A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.ahP;
							},
							validFields.afo),
						afp: validFields.afp,
						sb: validFields.sb
					};
					return {
						GZ: A4(
							$author$project$Api$Provider$Membership$cancel,
							apiClient,
							$author$project$Api$Provider$Membership$One$id(model.kk),
							apiFields,
							$author$project$Components$Membership$Form$CancelModal$MembershipCancelled),
						agZ: $author$project$Components$Membership$Form$CancelModal$None,
						aiO: _Utils_update(
							model,
							{fR: $author$project$Api$Data$Loading, SD: newForm}),
						aR: _List_Nil
					};
				} else {
					var newForm = _v2.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Membership$Form$CancelModal$None,
						aiO: _Utils_update(
							model,
							{SD: newForm}),
						aR: _List_Nil
					};
				}
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					var membership = response.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Membership$Form$CancelModal$Cancelled(membership),
						aiO: model,
						aR: _List_Nil
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Membership$Form$CancelModal$None,
						aiO: _Utils_update(
							model,
							{fR: $author$project$Api$Data$NotAsked}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 3:
				var subMsg = msg.a;
				return A7(
					$author$project$Components$Membership$Form$CancelModal$updateDateInputFormField,
					model,
					function ($) {
						return $.sd;
					},
					F2(
						function (newDateInput, model_) {
							return _Utils_update(
								model_,
								{sd: newDateInput});
						}),
					subMsg,
					$author$project$Components$Membership$Form$CancelModal$EndDateInputMsg,
					$author$project$Components$Membership$Form$CancelModal$EndDate,
					function ($) {
						return $.sb;
					});
			default:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Membership$Form$CancelModal$formFieldsUpdate, field, model.SD);
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: $author$project$Components$Membership$Form$CancelModal$None,
					aiO: _Utils_update(
						model,
						{SD: newForm}),
					aR: _List_Nil
				};
		}
	});
var $author$project$Components$Membership$Form$RenewContractModal$Closed = 1;
var $author$project$Components$Membership$Form$RenewContractModal$GotRenewResponse = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Membership$Form$RenewContractModal$None = 0;
var $author$project$Components$Membership$Form$RenewContractModal$Renwed = 2;
var $author$project$Api$Provider$MembershipContract$One$MembershipContract = 0;
var $author$project$Api$Provider$MembershipContract$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Provider$Membership$MembershipContract$renew = F4(
	function (apiClient, membershipId, memo, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'memo',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, memo))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$MembershipContract$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['renew']),
						$author$project$Api$Provider$Membership$MembershipContract$membershipContractsPath(membershipId)))));
	});
var $author$project$Components$Membership$Form$RenewContractModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: 1, aiO: model, aR: _List_Nil};
			case 1:
				var memo = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							aiG: $author$project$Utils$String$toMaybe(memo)
						}),
					aR: _List_Nil
				};
			case 2:
				return {
					GZ: A4($author$project$Api$Provider$Membership$MembershipContract$renew, apiClient, model.AW, model.aiG, $author$project$Components$Membership$Form$RenewContractModal$GotRenewResponse),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{pE: $author$project$Api$Data$Loading}),
					aR: _List_Nil
				};
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 2,
						aiO: _Utils_update(
							model,
							{pE: response}),
						aR: _List_Nil
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{pE: response}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
		}
	});
var $author$project$Components$Membership$Form$RestartModal$Closed = {$: 1};
var $author$project$Components$Membership$Form$RestartModal$MembershipRestarted = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Membership$Form$RestartModal$None = {$: 0};
var $author$project$Components$Membership$Form$RestartModal$Restarted = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Membership$Form$RestartModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 1:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$Membership$Form$RestartModal$Closed, aiO: model, aR: _List_Nil};
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					var pendingMembership = response.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Membership$Form$RestartModal$None,
						aiO: _Utils_update(
							model,
							{
								dC: $elm$core$Maybe$Just(pendingMembership)
							}),
						aR: _List_Nil
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Membership$Form$RestartModal$Closed,
						aiO: model,
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 0:
				return {
					GZ: A5(
						$author$project$Api$Provider$Membership$restart,
						apiClient,
						$author$project$Api$Provider$Membership$One$id(model.kk),
						false,
						model.XP,
						$author$project$Components$Membership$Form$RestartModal$MembershipRestarted),
					agZ: $author$project$Components$Membership$Form$RestartModal$None,
					aiO: _Utils_update(
						model,
						{uj: $author$project$Api$Data$Loading}),
					aR: _List_Nil
				};
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					var membership = response.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Membership$Form$RestartModal$Restarted(membership),
						aiO: model,
						aR: _List_Nil
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Membership$Form$RestartModal$None,
						aiO: _Utils_update(
							model,
							{uj: $author$project$Api$Data$NotAsked}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			default:
				var dateInputModel = msg.a;
				var dateInputMsg = msg.b;
				var _v3 = A2($author$project$Components$DateInput$update, dateInputMsg, dateInputModel);
				var newDateInput = _v3.a;
				var subCmd = _v3.b;
				var event = _v3.c;
				if (event.$ === 1) {
					var maybeDate = event.a;
					return {
						GZ: $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									subCmd,
									A5(
									$author$project$Api$Provider$Membership$restart,
									apiClient,
									$author$project$Api$Provider$Membership$One$id(model.kk),
									true,
									maybeDate,
									$author$project$Components$Membership$Form$RestartModal$GotPriceCheck)
								])),
						agZ: $author$project$Components$Membership$Form$RestartModal$None,
						aiO: _Utils_update(
							model,
							{rZ: newDateInput, XP: maybeDate}),
						aR: _List_Nil
					};
				} else {
					return {
						GZ: subCmd,
						agZ: $author$project$Components$Membership$Form$RestartModal$None,
						aiO: _Utils_update(
							model,
							{rZ: newDateInput}),
						aR: _List_Nil
					};
				}
		}
	});
var $author$project$Components$Membership$Form$Sections$BillsOverview$Billed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Membership$Form$Sections$BillsOverview$MembershipBilled = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Membership$Form$Sections$BillsOverview$None = {$: 0};
var $author$project$Api$Provider$Membership$bill = F4(
	function (apiClient, id, startDate, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'membership',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'start_date',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, startDate))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Membership$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['bill']),
						$author$project$Api$Provider$Membership$membershipPath(id)))));
	});
var $author$project$Components$Membership$Form$Sections$BillsOverview$update = F3(
	function (apiClient, msg, model) {
		if (!msg.$) {
			var startDate = msg.a;
			return {
				GZ: A4($author$project$Api$Provider$Membership$bill, apiClient, model.AW, startDate, $author$project$Components$Membership$Form$Sections$BillsOverview$Billed),
				agZ: $author$project$Components$Membership$Form$Sections$BillsOverview$None,
				aiO: _Utils_update(
					model,
					{mt: $author$project$Api$Data$Loading}),
				aR: _List_Nil
			};
		} else {
			var response = msg.a;
			if (response.$ === 3) {
				var membership = response.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: $author$project$Components$Membership$Form$Sections$BillsOverview$MembershipBilled(membership),
					aiO: _Utils_update(
						model,
						{mt: $author$project$Api$Data$NotAsked}),
					aR: _List_Nil
				};
			} else {
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: $author$project$Components$Membership$Form$Sections$BillsOverview$None,
					aiO: _Utils_update(
						model,
						{mt: response}),
					aR: $author$project$OutMsg$handleErrorResponse(response)
				};
			}
		}
	});
var $author$project$Components$Membership$Form$Sections$Contracts$Canceled = 1;
var $author$project$Components$Membership$Form$Sections$Contracts$GotCanceledResponse = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Components$Membership$Form$Sections$Contracts$None = 0;
var $author$project$Components$Membership$Form$Sections$Contracts$Updated = 2;
var $author$project$Api$Provider$Membership$MembershipContract$cancel = F3(
	function (apiClient, membershipId, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['cancel']),
					$author$project$Api$Provider$Membership$MembershipContract$membershipContractsPath(membershipId))));
	});
var $author$project$Components$Membership$Form$Sections$Contracts$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var bool = field.a;
				return _Utils_update(
					fields,
					{RZ: bool});
			case 1:
				var date = field.a;
				return _Utils_update(
					fields,
					{
						sb: $elm$core$Result$toMaybe(
							$justinmimbs$date$Date$fromIsoString(date))
					});
			case 2:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Zs: $elm$core$String$toInt(string)
					});
			default:
				var type_ = field.a;
				return _Utils_update(
					fields,
					{
						amg: $author$project$Api$ContractType$fromString(type_)
					});
		}
	});
var $author$project$Components$Membership$Form$Sections$Contracts$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{AV: response}),
					aR: $author$project$OutMsg$handleErrorResponse(response)
				};
			case 1:
				var endDate = msg.a;
				var fields = $author$project$Utils$Form$fields(model.SD);
				var newFields = _Utils_update(
					fields,
					{sb: endDate});
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 2,
					aiO: _Utils_update(
						model,
						{
							jv: !model.jv,
							SD: A2($author$project$Utils$Form$set, newFields, model.SD)
						}),
					aR: _List_Nil
				};
			case 2:
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{uy: !model.uy}),
					aR: _List_Nil
				};
			case 4:
				var membershipId = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							fR: $elm$core$Maybe$Just(
								_Utils_Tuple2($author$project$Api$Data$NotAsked, membershipId))
						}),
					aR: _List_Nil
				};
			case 5:
				var membershipId = msg.a;
				var confirmed = msg.b;
				return confirmed ? {
					GZ: A3(
						$author$project$Api$Provider$Membership$MembershipContract$cancel,
						apiClient,
						membershipId,
						$author$project$Components$Membership$Form$Sections$Contracts$GotCanceledResponse(membershipId)),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							fR: $elm$core$Maybe$Just(
								_Utils_Tuple2($author$project$Api$Data$Loading, membershipId))
						}),
					aR: _List_Nil
				} : {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{fR: $elm$core$Maybe$Nothing}),
					aR: _List_Nil
				};
			case 3:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Membership$Form$Sections$Contracts$formFieldsUpdate, field, model.SD);
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 2,
					aiO: _Utils_update(
						model,
						{SD: newForm}),
					aR: _List_Nil
				};
			default:
				var membershipId = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 1,
						aiO: _Utils_update(
							model,
							{fR: $elm$core$Maybe$Nothing}),
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Contract canceled.')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{
								fR: $elm$core$Maybe$Just(
									_Utils_Tuple2($author$project$Api$Data$NotAsked, membershipId))
							}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
		}
	});
var $author$project$Components$Membership$Form$Sections$Members$None = 0;
var $author$project$Components$Membership$Form$Sections$Members$Updated = 1;
var $author$project$Api$Provider$MembershipPatient$New$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Components$Membership$Form$Records$locationFromShared = function (location) {
	return {
		ahP: $author$project$Api$Provider$Location$Shared$id(location),
		Bq: $author$project$Api$Provider$Location$Shared$name(location)
	};
};
var $author$project$Components$Membership$Form$Records$practitionerFromShared = function (practitioner) {
	return {
		ahP: $author$project$Api$Provider$Practitioner$Shared$id(practitioner),
		Bq: $author$project$Api$Provider$Practitioner$Shared$name(practitioner)
	};
};
var $author$project$Components$Membership$Form$Records$patientFromOne = function (patient) {
	return {
		Lj: $author$project$Api$Provider$Patient$One$age(patient),
		ahP: $author$project$Api$Provider$Patient$One$id(patient),
		ais: A2(
			$elm$core$Maybe$map,
			$author$project$Components$Membership$Form$Records$locationFromShared,
			$author$project$Api$Provider$Patient$One$location(patient)),
		WX: $author$project$Api$Provider$Patient$One$membershipStatus(patient),
		Bq: $author$project$Api$Provider$Patient$One$name(patient),
		aka: A2(
			$elm$core$Maybe$map,
			$author$project$Components$Membership$Form$Records$practitionerFromShared,
			$author$project$Api$Provider$Patient$One$practitioner(patient)),
		ad9: $author$project$Api$Provider$Patient$One$usesTobacco(patient)
	};
};
var $author$project$Components$Membership$Form$Records$membershipPatientFromNew = F5(
	function (currentDate, membershipPatient, memberType, patient, startDate) {
		return {
			Gg: $elm$core$Maybe$Just('create'),
			afo: $elm$core$Maybe$Nothing,
			afp: $elm$core$Maybe$Nothing,
			Oi: $elm$core$Maybe$Nothing,
			Q8: $elm$core$Maybe$Nothing,
			sb: $elm$core$Maybe$Nothing,
			RF: $elm$core$Maybe$Just(currentDate),
			St: $elm$core$Maybe$Nothing,
			Sx: $elm$core$Maybe$Nothing,
			ahP: $author$project$Api$Provider$MembershipPatient$New$id(membershipPatient),
			WN: memberType,
			YY: A2($elm$core$Maybe$map, $author$project$Components$Membership$Form$Records$patientFromOne, patient),
			abS: $elm$core$Maybe$Nothing,
			ab7: startDate
		};
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$EndDate = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$EndDateInputMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$EnrollmentRequestedOn = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$EnrollmentRequestedOnInputMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$None = 0;
var $author$project$Components$Membership$Form$Members$MembershipPatient$Patient = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$Removed = 2;
var $author$project$Components$Membership$Form$Members$MembershipPatient$Restarted = 3;
var $author$project$Components$Membership$Form$Members$MembershipPatient$StartDate = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$StartDateInputMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$Updated = 1;
var $author$project$Components$Membership$Form$Members$MembershipPatient$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var patient = field.a;
				return _Utils_update(
					fields,
					{YY: patient});
			case 1:
				var string = field.a;
				var patient = A2(
					$elm$core$Maybe$map,
					function (patient_) {
						return _Utils_update(
							patient_,
							{
								ad9: $author$project$Utils$Bool$fromString(string)
							});
					},
					fields.YY);
				return _Utils_update(
					fields,
					{YY: patient});
			case 2:
				var date = field.a;
				return _Utils_update(
					fields,
					{RF: date});
			case 3:
				var date = field.a;
				return _Utils_update(
					fields,
					{ab7: date});
			case 4:
				var string = field.a;
				return _Utils_update(
					fields,
					{abS: string});
			case 5:
				var currency = field.a;
				return _Utils_update(
					fields,
					{Sx: currency});
			case 6:
				var date = field.a;
				return _Utils_update(
					fields,
					{sb: date});
			default:
				var _v1 = field.a;
				var cancellationReason = _v1.a;
				var cancellationReasonOther = _v1.b;
				return _Utils_update(
					fields,
					{afo: cancellationReason, afp: cancellationReasonOther});
		}
	});
var $author$project$Components$Patient$Form$withAddress = F2(
	function (address, _v0) {
		var settings = _v0.a;
		var form = _v0.b;
		var fields = $author$project$Utils$Form$fields(form);
		var _v1 = A2($author$project$Components$AddressInput$initFromApi, 'patient-address', address);
		var addressInput = _v1.a;
		var addressInputCmd = _v1.b;
		var newFields = _Utils_update(
			fields,
			{K2: addressInput});
		return _Utils_Tuple2(
			A2(
				$author$project$Components$Patient$Form$PatientForm,
				settings,
				A2($author$project$Utils$Form$set, newFields, form)),
			A2(
				$elm$core$Platform$Cmd$map,
				A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Address),
				addressInputCmd));
	});
var $author$project$Components$Patient$Form$withLeadSource = F4(
	function (apiClient, leadSource, leadSourceOther, _v0) {
		var settings = _v0.a;
		var form = _v0.b;
		var fields = $author$project$Utils$Form$fields(form);
		var _v1 = A3(
			$author$project$Components$LeadSourceInput$init,
			apiClient,
			A2($elm$core$Maybe$map, $author$project$Api$LeadSource$Shared$id, leadSource),
			leadSourceOther);
		var leadSourceInput = _v1.a;
		var leadSourceInputCmd = _v1.b;
		var newFields = _Utils_update(
			fields,
			{VR: leadSourceInput});
		return _Utils_Tuple2(
			A2(
				$author$project$Components$Patient$Form$PatientForm,
				settings,
				A2($author$project$Utils$Form$set, newFields, form)),
			A2(
				$elm$core$Platform$Cmd$map,
				A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$LeadSource),
				leadSourceInputCmd));
	});
var $author$project$Components$Patient$Form$withPractitioner = F3(
	function (apiClient, practitioner, _v0) {
		var settings = _v0.a;
		var form = _v0.b;
		var fields = $author$project$Utils$Form$fields(form);
		var _v1 = A3($author$project$Components$PractitionerInput$init, apiClient, $elm$core$Basics$identity, practitioner);
		var practitionerInput = _v1.a;
		var practitionerInputCmd = _v1.b;
		var newFields = _Utils_update(
			fields,
			{aka: practitionerInput});
		return _Utils_Tuple2(
			A2(
				$author$project$Components$Patient$Form$PatientForm,
				settings,
				A2($author$project$Utils$Form$set, newFields, form)),
			A2(
				$elm$core$Platform$Cmd$map,
				A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Practitioner),
				practitionerInputCmd));
	});
var $author$project$Components$Patient$Form$withSyncToEmr = F2(
	function (syncToEmr, _v0) {
		var settings = _v0.a;
		var form = _v0.b;
		var fields = $author$project$Utils$Form$fields(form);
		var newFields = _Utils_update(
			fields,
			{acM: syncToEmr});
		return A2(
			$author$project$Components$Patient$Form$PatientForm,
			settings,
			A2($author$project$Utils$Form$set, newFields, form));
	});
var $author$project$Components$CreatePatientModal$init = F6(
	function (apiClient, currentDate, session, practice, hinterViewOff, patient) {
		var _v0 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Components$Patient$Form$withSyncToEmr(true),
			function (_v3) {
				var f = _v3.a;
				var cmd = _v3.b;
				return A2(
					$elm$core$Tuple$mapSecond,
					A2(
						$elm$core$Basics$composeL,
						A2(
							$elm$core$Basics$composeL,
							$elm$core$Platform$Cmd$batch,
							$elm$core$List$append(
								_List_fromArray(
									[cmd]))),
						$elm$core$List$singleton),
					A3(
						$author$project$Components$Patient$Form$withPractitioner,
						apiClient,
						A2(
							$elm$core$Maybe$map,
							$author$project$Api$Practitioner$Shared$Provider,
							$author$project$Api$Provider$Patient$One$practitioner(patient)),
						f));
			}(
				function (_v2) {
					var f = _v2.a;
					var cmd = _v2.b;
					return A2(
						$elm$core$Tuple$mapSecond,
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								$elm$core$Platform$Cmd$batch,
								$elm$core$List$append(
									_List_fromArray(
										[cmd]))),
							$elm$core$List$singleton),
						A4(
							$author$project$Components$Patient$Form$withLeadSource,
							apiClient,
							A2(
								$elm$core$Maybe$map,
								$author$project$Api$LeadSource$Shared$Provider,
								$author$project$Api$Provider$Patient$One$leadSource(patient)),
							$author$project$Api$Provider$Patient$One$leadSourceOther(patient),
							f));
				}(
					function (_v1) {
						var f = _v1.a;
						var cmd = _v1.b;
						return A2(
							$elm$core$Tuple$mapSecond,
							A2(
								$elm$core$Basics$composeL,
								A2(
									$elm$core$Basics$composeL,
									$elm$core$Platform$Cmd$batch,
									$elm$core$List$append(
										_List_fromArray(
											[cmd]))),
								$elm$core$List$singleton),
							A2(
								$author$project$Components$Patient$Form$withAddress,
								$author$project$Api$Provider$Patient$One$address(patient),
								f));
					}(
						A6(
							$author$project$Components$Patient$Form$empty,
							apiClient,
							session,
							currentDate,
							$elm$core$Maybe$Nothing,
							false,
							function (settings) {
								return _Utils_update(
									settings,
									{
										afg: $author$project$Api$Provider$Practice$One$labelBillingAsShipping(practice),
										afn: A2($author$project$Api$Provider$Practice$One$featureEnabled, 3, practice),
										Tb: $author$project$Api$Provider$Practice$One$hasLocations(practice),
										Th: $author$project$Api$Provider$Practice$One$hasPractitioners(practice),
										aiC: $author$project$Api$Provider$Practice$One$isMce(practice),
										tc: A2($author$project$Api$Provider$Practice$One$featureEnabled, 10, practice),
										akV: $author$project$Api$Provider$Practice$One$requiresPatientEmail(practice),
										$G: $author$project$Api$Provider$Practice$One$requiresLocation(practice),
										akW: $author$project$Api$Provider$Practice$One$requiresPatientMobile(practice),
										$M: $author$project$Api$Provider$Practice$One$requiresPractitioner(practice),
										$N: $author$project$Api$Provider$Practice$One$requiresSSN(practice),
										ab6: $author$project$Api$Provider$Practice$One$ssnEnabled(practice),
										acI: A2(
											$elm$core$Maybe$withDefault,
											false,
											A2(
												$elm$core$Maybe$map,
												$author$project$Api$Provider$Network$Shared$syncByAffiliation,
												$author$project$Api$Provider$Practice$One$network(practice))),
										al8: A2($author$project$Api$Provider$Practice$One$featureEnabled, 2, practice),
										adt: $author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice),
										adv: $author$project$Api$Provider$Practice$One$transInclusivity(practice),
										F1: A3($author$project$Permission$canGoTo, session, hinterViewOff, 0)
									});
							})))));
		var form = _v0.a;
		var formCmd = _v0.b;
		return _Utils_Tuple2(
			{SD: form, aa4: session, lA: false},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$CreatePatientModal$PatientFormMsg, formCmd));
	});
var $author$project$Components$CreatePatientModal$Closed = {$: 1};
var $author$project$Components$CreatePatientModal$Created = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$CreatePatientModal$None = {$: 0};
var $author$project$Components$CreatePatientModal$PatientCreated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$CreatePatientModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$CreatePatientModal$Closed, aiO: model, aR: _List_Nil};
			case 1:
				var formMsg = msg.a;
				var _v1 = A5($author$project$Components$Patient$Form$update, apiClient, model.aa4, $elm$core$Maybe$Nothing, formMsg, model.SD);
				var form = _v1.a;
				var formCmd = _v1.b;
				var formOutMsgs = _v1.c;
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$CreatePatientModal$PatientFormMsg, formCmd),
					agZ: $author$project$Components$CreatePatientModal$None,
					aiO: _Utils_update(
						model,
						{SD: form}),
					aR: formOutMsgs
				};
			case 2:
				var _v2 = $author$project$Components$Patient$Form$validate(model.SD);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var validForm = _v3.a;
					var validFields = _v3.b;
					return {
						GZ: A3(
							$author$project$Api$Provider$Patient$create,
							apiClient,
							A2($author$project$Components$Patient$Form$encode, validFields, validForm),
							$author$project$Components$CreatePatientModal$PatientCreated),
						agZ: $author$project$Components$CreatePatientModal$None,
						aiO: _Utils_update(
							model,
							{lA: true}),
						aR: _List_Nil
					};
				} else {
					var erroredForm = _v2.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$CreatePatientModal$None,
						aiO: _Utils_update(
							model,
							{SD: erroredForm}),
						aR: _List_Nil
					};
				}
			default:
				var response = msg.a;
				switch (response.$) {
					case 3:
						var patient = response.a;
						return {
							GZ: A2(
								$elm$core$Platform$Cmd$map,
								$author$project$Components$CreatePatientModal$PatientFormMsg,
								A5(
									$author$project$Components$Patient$Form$createAffiliation,
									apiClient,
									model.aa4,
									$author$project$Api$Provider$Patient$One$id(patient),
									$elm$core$Maybe$Nothing,
									model.SD).GZ),
							agZ: $author$project$Components$CreatePatientModal$Created(patient),
							aiO: _Utils_update(
								model,
								{lA: false}),
							aR: _List_Nil
						};
					case 2:
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: $author$project$Components$CreatePatientModal$None,
							aiO: _Utils_update(
								model,
								{lA: false}),
							aR: $author$project$OutMsg$handleErrorResponse(response)
						};
					default:
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: $author$project$Components$CreatePatientModal$None,
							aiO: _Utils_update(
								model,
								{lA: false}),
							aR: _List_Nil
						};
				}
		}
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$updateDateInputFormField = F6(
	function (model, dateInputGetter, dateInputSetter, subMsg, toMsg, toField) {
		var dateInput = dateInputGetter(model);
		var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
		var newDateInput = _v0.a;
		var subCmd = _v0.b;
		var dateInputEvent = _v0.c;
		var _v1 = function () {
			if (dateInputEvent.$ === 1) {
				var date = dateInputEvent.a;
				var field_ = toField(date);
				return _Utils_Tuple2(
					A3(
						$author$project$Utils$Form$update,
						$author$project$Components$Membership$Form$Members$MembershipPatient$formFieldsUpdate,
						toField(date),
						model.SD),
					$elm$core$Maybe$Just(field_));
			} else {
				return _Utils_Tuple2(model.SD, $elm$core$Maybe$Nothing);
			}
		}();
		var newForm = _v1.a;
		var field = _v1.b;
		return {
			GZ: A2($elm$core$Platform$Cmd$map, toMsg, subCmd),
			agZ: A2(
				$elm$core$Maybe$withDefault,
				0,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(1),
					field)),
			aiO: A2(
				dateInputSetter,
				newDateInput,
				_Utils_update(
					model,
					{SD: newForm})),
			aR: _List_Nil
		};
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var membershipPatient = $author$project$Utils$Form$fields(model.SD);
				var newMembershipPatient = _Utils_update(
					membershipPatient,
					{
						Gg: $elm$core$Maybe$Just('restart'),
						afo: $elm$core$Maybe$Nothing,
						afp: $elm$core$Maybe$Nothing,
						sb: $elm$core$Maybe$Nothing
					});
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 3,
					aiO: _Utils_update(
						model,
						{
							SD: A2($author$project$Utils$Form$set, newMembershipPatient, model.SD),
							bf: false
						}),
					aR: _List_Nil
				};
			case 1:
				var endDate = msg.a;
				var membershipPatient = $author$project$Utils$Form$fields(model.SD);
				var _v2 = function () {
					if (_Utils_eq(
						membershipPatient.Gg,
						$elm$core$Maybe$Just('create'))) {
						return _Utils_Tuple2(2, membershipPatient);
					} else {
						var newMembershipPatient_ = _Utils_update(
							membershipPatient,
							{
								Gg: $elm$core$Maybe$Just('terminate'),
								sb: endDate
							});
						return _Utils_Tuple2(1, newMembershipPatient_);
					}
				}();
				var event = _v2.a;
				var newMembershipPatient = _v2.b;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: event,
					aiO: _Utils_update(
						model,
						{
							SD: A2($author$project$Utils$Form$set, newMembershipPatient, model.SD),
							bf: true
						}),
					aR: _List_Nil
				};
			case 2:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Membership$Form$Members$MembershipPatient$formFieldsUpdate, field, model.SD);
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 1,
					aiO: _Utils_update(
						model,
						{SD: newForm}),
					aR: _List_Nil
				};
			case 3:
				var subMsg = msg.a;
				var patientResourceResult = A3($author$project$Components$ResourceFilter$Patient$update, apiClient, subMsg, model.oY);
				var _v3 = function () {
					var _v4 = patientResourceResult.agZ;
					_v4$2:
					while (true) {
						if (!_v4.$) {
							switch (_v4.a.$) {
								case 0:
									var patient = _v4.a.a;
									var patientRecord = $author$project$Components$Membership$Form$Records$patientFromAll(patient);
									var field = $author$project$Components$Membership$Form$Members$MembershipPatient$Patient(
										$elm$core$Maybe$Just(patientRecord));
									var newForm_ = A3($author$project$Utils$Form$update, $author$project$Components$Membership$Form$Members$MembershipPatient$formFieldsUpdate, field, model.SD);
									return _Utils_Tuple3(
										newForm_,
										_Utils_eq(patientRecord.ad9, $elm$core$Maybe$Nothing),
										1);
								case 2:
									var _v5 = _v4.a;
									var field = $author$project$Components$Membership$Form$Members$MembershipPatient$Patient($elm$core$Maybe$Nothing);
									var newForm_ = A3($author$project$Utils$Form$update, $author$project$Components$Membership$Form$Members$MembershipPatient$formFieldsUpdate, field, model.SD);
									return _Utils_Tuple3(newForm_, false, 1);
								default:
									break _v4$2;
							}
						} else {
							break _v4$2;
						}
					}
					return _Utils_Tuple3(model.SD, model.et, 0);
				}();
				var newForm = _v3.a;
				var editTobaccoUsage = _v3.b;
				var event = _v3.c;
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Members$MembershipPatient$PatientResourceFilterMsg, patientResourceResult.GZ),
					agZ: event,
					aiO: _Utils_update(
						model,
						{et: editTobaccoUsage, SD: newForm, oY: patientResourceResult.aiO}),
					aR: patientResourceResult.aR
				};
			case 4:
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{r4: true}),
					aR: _List_Nil
				};
			case 5:
				var subMsg = msg.a;
				return A6(
					$author$project$Components$Membership$Form$Members$MembershipPatient$updateDateInputFormField,
					model,
					function ($) {
						return $.sh;
					},
					F2(
						function (newDateInput, model_) {
							return _Utils_update(
								model_,
								{sh: newDateInput});
						}),
					subMsg,
					$author$project$Components$Membership$Form$Members$MembershipPatient$EnrollmentRequestedOnInputMsg,
					$author$project$Components$Membership$Form$Members$MembershipPatient$EnrollmentRequestedOn);
			case 6:
				var date = msg.a;
				var field = $author$project$Components$Membership$Form$Members$MembershipPatient$StartDate(date);
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Membership$Form$Members$MembershipPatient$formFieldsUpdate, field, model.SD);
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 1,
					aiO: _Utils_update(
						model,
						{r5: true, SD: newForm}),
					aR: _List_Nil
				};
			case 7:
				var subMsg = msg.a;
				return A6(
					$author$project$Components$Membership$Form$Members$MembershipPatient$updateDateInputFormField,
					model,
					function ($) {
						return $.lx;
					},
					F2(
						function (newDateInput, model_) {
							return _Utils_update(
								model_,
								{lx: newDateInput});
						}),
					subMsg,
					$author$project$Components$Membership$Form$Members$MembershipPatient$StartDateInputMsg,
					$author$project$Components$Membership$Form$Members$MembershipPatient$StartDate);
			case 8:
				var fields = $author$project$Utils$Form$fields(model.SD);
				var specialRate = model.b2 ? $elm$core$Maybe$Nothing : fields.abS;
				var newFields = _Utils_update(
					fields,
					{abS: specialRate});
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 1,
					aiO: _Utils_update(
						model,
						{
							SD: A2($author$project$Utils$Form$set, newFields, model.SD),
							b2: !model.b2
						}),
					aR: _List_Nil
				};
			case 9:
				var defaultValue = msg.a;
				var fields = $author$project$Utils$Form$fields(model.SD);
				var fixedPeriodRateInCents = function () {
					var _v6 = _Utils_Tuple2(model.es, fields.Sx);
					if (_v6.a) {
						return $elm$core$Maybe$Nothing;
					} else {
						if (!_v6.b.$) {
							var fixedPeriodRateInCents_ = _v6.b.a;
							return $elm$core$Maybe$Just(fixedPeriodRateInCents_);
						} else {
							var _v7 = _v6.b;
							return defaultValue;
						}
					}
				}();
				var newFields = _Utils_update(
					fields,
					{Sx: fixedPeriodRateInCents});
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 1,
					aiO: _Utils_update(
						model,
						{
							es: !model.es,
							SD: A2($author$project$Utils$Form$set, newFields, model.SD)
						}),
					aR: _List_Nil
				};
			case 10:
				var subMsg = msg.a;
				return A6(
					$author$project$Components$Membership$Form$Members$MembershipPatient$updateDateInputFormField,
					model,
					function ($) {
						return $.sd;
					},
					F2(
						function (newDateInput, model_) {
							return _Utils_update(
								model_,
								{sd: newDateInput});
						}),
					subMsg,
					$author$project$Components$Membership$Form$Members$MembershipPatient$EndDateInputMsg,
					$author$project$Components$Membership$Form$Members$MembershipPatient$EndDate);
			case 11:
				var patient = msg.a;
				var _v8 = A6($author$project$Components$CreatePatientModal$init, apiClient, model.dd, model.aa4, model.ZV, model.ahK, patient);
				var createPatientModal = _v8.a;
				var createPatientModalCmd = _v8.b;
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Members$MembershipPatient$CreatePatientModalMsg, createPatientModalCmd),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							iZ: $elm$core$Maybe$Just(createPatientModal)
						}),
					aR: _List_Nil
				};
			default:
				var subMsg = msg.a;
				var _v9 = model.iZ;
				if (!_v9.$) {
					var createPatientModal = _v9.a;
					var createPatientModalResult = A3($author$project$Components$CreatePatientModal$update, apiClient, subMsg, createPatientModal);
					var _v10 = function () {
						var _v11 = createPatientModalResult.agZ;
						switch (_v11.$) {
							case 0:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(createPatientModalResult.aiO),
									$elm$core$Maybe$Nothing,
									_List_Nil);
							case 1:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, _List_Nil);
							default:
								var patient = _v11.a;
								var outMsgs_ = model.j1 ? _List_Nil : _List_fromArray(
									[
										A2(
										$author$project$OutMsg$ShowToast,
										3,
										$author$project$Api$Provider$Patient$One$name(patient) + ' was added as a new patient to this membership. Click \" Update \" to confirm adding them to this membership.')
									]);
								var field_ = $author$project$Components$Membership$Form$Members$MembershipPatient$Patient(
									$elm$core$Maybe$Just(
										$author$project$Components$Membership$Form$Records$patientFromOne(patient)));
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$elm$core$Maybe$Just(field_),
									outMsgs_);
						}
					}();
					var createPatientModal_ = _v10.a;
					var field = _v10.b;
					var outMsgs = _v10.c;
					var editTobaccoUsage = function () {
						if (((!field.$) && (!field.a.$)) && (!field.a.a.$)) {
							var patientRecord = field.a.a.a;
							return _Utils_eq(patientRecord.ad9, $elm$core$Maybe$Nothing);
						} else {
							return model.et;
						}
					}();
					var _v12 = A2(
						$elm$core$Maybe$withDefault,
						_Utils_Tuple2(model.SD, 0),
						A2(
							$elm$core$Maybe$map,
							function (field_) {
								var newForm_ = A3($author$project$Utils$Form$update, $author$project$Components$Membership$Form$Members$MembershipPatient$formFieldsUpdate, field_, model.SD);
								return _Utils_Tuple2(newForm_, 1);
							},
							field));
					var newForm = _v12.a;
					var event = _v12.b;
					return {
						GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Members$MembershipPatient$CreatePatientModalMsg, createPatientModalResult.GZ),
						agZ: event,
						aiO: _Utils_update(
							model,
							{iZ: createPatientModal_, et: editTobaccoUsage, SD: newForm}),
						aR: _Utils_ap(createPatientModalResult.aR, outMsgs)
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
		}
	});
var $author$project$Components$Membership$Form$Sections$Members$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var memberType = msg.a;
				var patient = msg.b;
				var startDate = msg.c;
				var response = msg.d;
				if (response.$ === 3) {
					var membershipPatient = response.a;
					var membershipPatientRecord = A5($author$project$Components$Membership$Form$Records$membershipPatientFromNew, model.dd, membershipPatient, memberType, patient, startDate);
					var _v2 = A9($author$project$Components$Membership$Form$Members$MembershipPatient$init, apiClient, model.dd, model.aa4, model.ZV, model.ahK, model.j1, membershipPatientRecord.YY, $elm$core$Maybe$Nothing, membershipPatientRecord);
					var membershipPatientModel = _v2.a;
					var membershipPatientCmd = _v2.b;
					var membershipPatients = A3(
						$elm$core$Dict$insert,
						membershipPatientRecord.ahP,
						_Utils_Tuple2(
							$elm$core$Dict$size(model.WR),
							membershipPatientModel),
						model.WR);
					return {
						GZ: A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Components$Membership$Form$Sections$Members$MembershipPatientMsg(membershipPatientRecord.ahP),
							membershipPatientCmd),
						agZ: 1,
						aiO: _Utils_update(
							model,
							{WR: membershipPatients}),
						aR: _List_Nil
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: model,
						aR: $author$project$OutMsg$reportDecodeError(response)
					};
				}
			case 1:
				var memberType = msg.a;
				var startDate = msg.b;
				return {
					GZ: A4($author$project$Components$Membership$Form$Sections$Members$addMember, apiClient, memberType, $elm$core$Maybe$Nothing, startDate),
					agZ: 0,
					aiO: model,
					aR: _List_Nil
				};
			default:
				var id = msg.a;
				var subMsg = msg.b;
				var _v3 = A2($elm$core$Dict$get, id, model.WR);
				if (!_v3.$) {
					var _v4 = _v3.a;
					var originalIndex = _v4.a;
					var membershipPatient = _v4.b;
					var membershipPatientResult = A3($author$project$Components$Membership$Form$Members$MembershipPatient$update, apiClient, subMsg, membershipPatient);
					var _v5 = function () {
						var _v6 = membershipPatientResult.agZ;
						switch (_v6) {
							case 0:
								return _Utils_Tuple2(
									A3(
										$elm$core$Dict$insert,
										id,
										_Utils_Tuple2(originalIndex, membershipPatientResult.aiO),
										model.WR),
									0);
							case 1:
								var newMembershipPatients_ = A3(
									$elm$core$Dict$insert,
									id,
									_Utils_Tuple2(originalIndex, membershipPatientResult.aiO),
									model.WR);
								return _Utils_Tuple2(newMembershipPatients_, 1);
							case 2:
								var newMembershipPatients_ = A2($elm$core$Dict$remove, id, model.WR);
								return _Utils_Tuple2(newMembershipPatients_, 1);
							default:
								var newMembershipPatients_ = A3(
									$elm$core$Dict$insert,
									id,
									_Utils_Tuple2(originalIndex, membershipPatientResult.aiO),
									model.WR);
								return _Utils_Tuple2(newMembershipPatients_, 1);
						}
					}();
					var newMembershipPatients = _v5.a;
					var event = _v5.b;
					return {
						GZ: A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Components$Membership$Form$Sections$Members$MembershipPatientMsg(id),
							membershipPatientResult.GZ),
						agZ: event,
						aiO: _Utils_update(
							model,
							{WR: newMembershipPatients}),
						aR: membershipPatientResult.aR
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
		}
	});
var $author$project$Components$Membership$Form$Sections$PlanChange$ChangeOnDate = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Membership$Form$Sections$PlanChange$ChangeOnDateDateInputMsg = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$Membership$Form$Sections$PlanChange$Created = 2;
var $author$project$Components$Membership$Form$Sections$PlanChange$Deleted = 1;
var $author$project$Components$Membership$Form$Sections$PlanChange$GotDeletedResponse = F3(
	function (a, b, c) {
		return {$: 8, a: a, b: b, c: c};
	});
var $author$project$Components$Membership$Form$Sections$PlanChange$None = 0;
var $author$project$Components$Membership$Form$Sections$PlanChange$ToPlan = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Membership$Form$Sections$PlanChange$Updated = 3;
var $author$project$Api$Provider$Membership$ScheduledChange$scheduledChangesPath = function (membershipId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['scheduled_changes']),
		$author$project$Api$Provider$Membership$membershipPath(membershipId));
};
var $author$project$Api$Provider$Membership$ScheduledChange$scheduledChangePath = F2(
	function (membershipId, id_) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id_]),
			$author$project$Api$Provider$Membership$ScheduledChange$scheduledChangesPath(membershipId));
	});
var $author$project$Api$Provider$Membership$ScheduledChange$delete = F4(
	function (apiClient, membershipId, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Provider$Membership$ScheduledChange$scheduledChangePath, membershipId, id)));
	});
var $author$project$Components$Membership$Form$Sections$PlanChange$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var type_ = field.a;
				return _Utils_update(
					fields,
					{amg: type_});
			case 1:
				var dateInput = field.a;
				var date = field.b;
				return _Utils_update(
					fields,
					{Nu: date, xY: dateInput});
			case 2:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Nt: $elm$core$String$toInt(string)
					});
			default:
				var planId = field.a;
				return _Utils_update(
					fields,
					{adc: planId});
		}
	});
var $author$project$Api$Provider$MembershipScheduledChange$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Components$Membership$Form$Sections$PlanChange$initFormFields = F3(
	function (contract, membershipMeta, currentPlanSpecialRateNames) {
		var type_ = contract.RZ ? 2 : 1;
		var _v0 = $author$project$Components$DateInput$init;
		var changeOnDateDateInput = _v0.a;
		var changeOnDateDateInputCmd = _v0.b;
		return _Utils_Tuple2(
			{Nt: $elm$core$Maybe$Nothing, Nu: $elm$core$Maybe$Nothing, xY: changeOnDateDateInput, G2: contract, Ha: currentPlanSpecialRateNames, Iz: membershipMeta, adc: $elm$core$Maybe$Nothing, amg: type_},
			A2(
				$elm$core$Platform$Cmd$map,
				$author$project$Components$Membership$Form$Sections$PlanChange$ChangeOnDateDateInputMsg(changeOnDateDateInput),
				changeOnDateDateInputCmd));
	});
var $author$project$Components$Membership$Form$Sections$PlanChange$GotCreatedResponse = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Membership$Form$Sections$PlanChange$GotUpdatedResponse = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Membership$Form$Sections$PlanChange$apiFields = function (validFormFields) {
	var _v0 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
	var changeOnDate = _v0.Nu;
	var changeAfterMonths = _v0.Nt;
	var toPlan = _v0.adc;
	return {Nt: changeAfterMonths, Nu: changeOnDate, adc: toPlan};
};
var $author$project$Api$Provider$MembershipScheduledChange$One$MembershipScheduledChange = 0;
var $author$project$Api$Provider$MembershipScheduledChange$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Provider$Membership$ScheduledChange$create = F4(
	function (apiClient, membershipId, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'scheduled_change',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'change_after_months',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Nt)),
								_Utils_Tuple2(
								'change_on_date',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.Nu)),
								_Utils_Tuple2(
								'to_plan',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.adc))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$MembershipScheduledChange$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Membership$ScheduledChange$scheduledChangesPath(membershipId))));
	});
var $author$project$Components$Membership$Form$Sections$PlanChange$ToPlanValidation = 2;
var $author$project$Components$Membership$Form$Sections$PlanChange$ChangeAfterMonthsValidation = 1;
var $author$project$Components$Membership$Form$Sections$PlanChange$validateChangeAfterMonths = function (fields) {
	var _v0 = _Utils_Tuple2(fields.amg, fields.Nt);
	if (_v0.a === 1) {
		if (!_v0.b.$) {
			var _v1 = _v0.a;
			var changeAfterMonths = _v0.b.a;
			return ((changeAfterMonths >= 1) && (changeAfterMonths <= 48)) ? _List_Nil : _List_fromArray(
				[
					_Utils_Tuple2(1, 'Please enter a number between 1 and 48')
				]);
		} else {
			var _v2 = _v0.a;
			var _v3 = _v0.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(1, 'Please enter a number.')
				]);
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Membership$Form$Sections$PlanChange$ChangeOnDateValidation = 0;
var $author$project$Components$Membership$Form$Sections$PlanChange$validateChangeOnDate = F2(
	function (currentDate, fields) {
		var _v0 = _Utils_Tuple2(fields.amg, fields.Nu);
		if (!_v0.a) {
			if (!_v0.b.$) {
				var _v1 = _v0.a;
				var changeOnDate = _v0.b.a;
				var tomorrowDate = A3($justinmimbs$date$Date$add, 3, -1, currentDate);
				return (A2($justinmimbs$date$Date$compare, tomorrowDate, changeOnDate) !== 2) ? _List_Nil : _List_fromArray(
					[
						_Utils_Tuple2(0, 'Please enter a date greater or equal than tomorrow')
					]);
			} else {
				var _v2 = _v0.a;
				var _v3 = _v0.b;
				return _List_fromArray(
					[
						_Utils_Tuple2(0, 'Please enter a date.')
					]);
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Membership$Form$Sections$PlanChange$formFieldsValidator = function (currentDate) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$Membership$Form$Sections$PlanChange$validateChangeOnDate(currentDate)),
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Membership$Form$Sections$PlanChange$validateChangeAfterMonths),
				A2(
				$rtfeldman$elm_validate$Validate$ifNothing,
				function ($) {
					return $.adc;
				},
				_Utils_Tuple2(2, 'Please pick a plan'))
			]));
};
var $author$project$Api$Provider$Membership$ScheduledChange$update = F5(
	function (apiClient, membershipId, id, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'scheduled_change',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'change_after_months',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Nt)),
								_Utils_Tuple2(
								'change_on_date',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.Nu)),
								_Utils_Tuple2(
								'to_plan',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.adc))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$MembershipScheduledChange$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Provider$Membership$ScheduledChange$scheduledChangePath, membershipId, id))));
	});
var $author$project$Components$Membership$Form$Sections$PlanChange$save = F3(
	function (apiClient, id, model) {
		var _v0 = _Utils_Tuple3(
			model.AW,
			A2(
				$elm$core$Maybe$map,
				$author$project$Utils$Form$validate(
					$author$project$Components$Membership$Form$Sections$PlanChange$formFieldsValidator(model.dd)),
				model.SD),
			id);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			if (_v0.b.a.$ === 1) {
				var newForm = _v0.b.a.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							SD: $elm$core$Maybe$Just(newForm)
						}),
					aR: _List_Nil
				};
			} else {
				if (!_v0.c.$) {
					var membershipId = _v0.a.a;
					var _v1 = _v0.b.a.a;
					var newForm = _v1.a;
					var validFormFields = _v1.b;
					var id_ = _v0.c.a;
					return {
						GZ: A5(
							$author$project$Api$Provider$Membership$ScheduledChange$update,
							apiClient,
							membershipId,
							id_,
							$author$project$Components$Membership$Form$Sections$PlanChange$apiFields(validFormFields),
							$author$project$Components$Membership$Form$Sections$PlanChange$GotUpdatedResponse),
						agZ: 0,
						aiO: _Utils_update(
							model,
							{
								SD: $elm$core$Maybe$Just(newForm),
								k9: $author$project$Api$Data$Loading
							}),
						aR: _List_Nil
					};
				} else {
					var membershipId = _v0.a.a;
					var _v2 = _v0.b.a.a;
					var newForm = _v2.a;
					var validFormFields = _v2.b;
					var _v3 = _v0.c;
					return {
						GZ: A4(
							$author$project$Api$Provider$Membership$ScheduledChange$create,
							apiClient,
							membershipId,
							$author$project$Components$Membership$Form$Sections$PlanChange$apiFields(validFormFields),
							$author$project$Components$Membership$Form$Sections$PlanChange$GotCreatedResponse),
						agZ: 0,
						aiO: _Utils_update(
							model,
							{
								SD: $elm$core$Maybe$Just(newForm),
								k9: $author$project$Api$Data$Loading
							}),
						aR: _List_Nil
					};
				}
			}
		} else {
			return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
		}
	});
var $author$project$Components$Membership$Form$Sections$PlanChange$updateDateInputFormField = F6(
	function (model, dateInput, subMsg, toMsg, field, fieldGetter) {
		var _v0 = model.SD;
		if (!_v0.$) {
			var form = _v0.a;
			var _v1 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
			var newDateInput = _v1.a;
			var subCmd = _v1.b;
			var event = _v1.c;
			var newForm = function () {
				if (event.$ === 1) {
					var date = event.a;
					return A3(
						$author$project$Utils$Form$update,
						$author$project$Components$Membership$Form$Sections$PlanChange$formFieldsUpdate,
						A2(field, newDateInput, date),
						form);
				} else {
					var fields = $author$project$Utils$Form$fields(form);
					return A3(
						$author$project$Utils$Form$update,
						$author$project$Components$Membership$Form$Sections$PlanChange$formFieldsUpdate,
						A2(
							field,
							newDateInput,
							fieldGetter(fields)),
						form);
				}
			}();
			return {
				GZ: A2(
					$elm$core$Platform$Cmd$map,
					toMsg(newDateInput),
					subCmd),
				agZ: 0,
				aiO: _Utils_update(
					model,
					{
						SD: $elm$core$Maybe$Just(newForm)
					}),
				aR: _List_Nil
			};
		} else {
			return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
		}
	});
var $author$project$Components$Membership$Form$Sections$PlanChange$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var contract = msg.a;
				var membershipMeta = msg.b;
				var memberSpecialRateNames = msg.c;
				var _v2 = A3($author$project$Components$Membership$Form$Sections$PlanChange$initFormFields, contract, membershipMeta, memberSpecialRateNames);
				var formFields = _v2.a;
				var formFieldsCmd = _v2.b;
				return {
					GZ: formFieldsCmd,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							SD: $elm$core$Maybe$Just(
								$author$project$Utils$Form$init(formFields))
						}),
					aR: _List_Nil
				};
			case 1:
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{SD: $elm$core$Maybe$Nothing}),
					aR: _List_Nil
				};
			case 2:
				var membershipId = msg.a;
				var scheduledChange = msg.b;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							f7: $elm$core$Maybe$Just(
								_Utils_Tuple3(membershipId, $author$project$Api$Data$NotAsked, scheduledChange))
						}),
					aR: _List_Nil
				};
			case 7:
				var membershipId = msg.a;
				var scheduledChange = msg.b;
				var confirmed = msg.c;
				return confirmed ? {
					GZ: A4(
						$author$project$Api$Provider$Membership$ScheduledChange$delete,
						apiClient,
						membershipId,
						$author$project$Api$Provider$MembershipScheduledChange$Shared$id(scheduledChange),
						A2($author$project$Components$Membership$Form$Sections$PlanChange$GotDeletedResponse, membershipId, scheduledChange)),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							f7: $elm$core$Maybe$Just(
								_Utils_Tuple3(membershipId, $author$project$Api$Data$Loading, scheduledChange))
						}),
					aR: _List_Nil
				} : {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{f7: $elm$core$Maybe$Nothing}),
					aR: _List_Nil
				};
			case 3:
				var field = msg.a;
				var _v3 = model.SD;
				if (!_v3.$) {
					var form = _v3.a;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Membership$Form$Sections$PlanChange$formFieldsUpdate, field, form);
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{
								SD: $elm$core$Maybe$Just(newForm)
							}),
						aR: _List_Nil
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
			case 4:
				var dateInput = msg.a;
				var subMsg = msg.b;
				return A6(
					$author$project$Components$Membership$Form$Sections$PlanChange$updateDateInputFormField,
					model,
					dateInput,
					subMsg,
					$author$project$Components$Membership$Form$Sections$PlanChange$ChangeOnDateDateInputMsg,
					$author$project$Components$Membership$Form$Sections$PlanChange$ChangeOnDate,
					function ($) {
						return $.Nu;
					});
			case 5:
				var subMsg = msg.a;
				var planResourceResult = A3($author$project$Components$ResourceFilter$Plan$update, apiClient, subMsg, model.hi);
				var newForm = A2(
					$elm$core$Maybe$map,
					function (form) {
						var _v4 = planResourceResult.agZ;
						if (!_v4.$) {
							var planId = $author$project$Components$ResourceFilter$Plan$value(planResourceResult.aiO);
							return A3(
								$author$project$Utils$Form$update,
								$author$project$Components$Membership$Form$Sections$PlanChange$formFieldsUpdate,
								$author$project$Components$Membership$Form$Sections$PlanChange$ToPlan(planId),
								form);
						} else {
							return form;
						}
					},
					model.SD);
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$PlanChange$PlanResourceFilterMsg, planResourceResult.GZ),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{SD: newForm, hi: planResourceResult.aiO}),
					aR: planResourceResult.aR
				};
			case 8:
				var membershipId = msg.a;
				var scheduledChange = msg.b;
				var response = msg.c;
				if (response.$ === 3) {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 1,
						aiO: _Utils_update(
							model,
							{f7: $elm$core$Maybe$Nothing}),
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Scheduled plan change removed.')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{
								f7: $elm$core$Maybe$Just(
									_Utils_Tuple3(membershipId, $author$project$Api$Data$NotAsked, scheduledChange))
							}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 6:
				var id = msg.a;
				return A3($author$project$Components$Membership$Form$Sections$PlanChange$save, apiClient, id, model);
			case 9:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 2,
						aiO: _Utils_update(
							model,
							{k9: response}),
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Scheduled plan change applied.')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{k9: $author$project$Api$Data$NotAsked}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 3,
						aiO: _Utils_update(
							model,
							{k9: response}),
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Scheduled plan change applied.')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{k9: $author$project$Api$Data$NotAsked}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
		}
	});
var $author$project$Components$Membership$Form$Sections$Pricing$None = 0;
var $author$project$Components$Membership$Form$Sections$Pricing$Updated = 1;
var $author$project$Components$Membership$Form$Sections$Pricing$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var currency = field.a;
				return _Utils_update(
					fields,
					{Sx: currency});
			case 1:
				var coupon = field.a;
				return _Utils_update(
					fields,
					{
						OP: $author$project$Utils$String$toMaybe(coupon)
					});
			default:
				var currency = field.a;
				return _Utils_update(
					fields,
					{Sy: currency});
		}
	});
var $author$project$Api$Provider$PaymentMethod$Min$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$MembershipBill$Shared$registrationFeeInCents = function (_v0) {
	var record = _v0;
	return record.$p;
};
var $author$project$Api$Provider$MembershipBill$ForMembershipOne$registrationFeeInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$MembershipBill$Shared$registrationFeeInCents(shared);
};
var $author$project$Api$Provider$Membership$One$revenueInCents = function (_v0) {
	var record = _v0.b;
	return record.$_;
};
var $author$project$Api$Provider$Membership$One$upcomingAndOutstandingBills = function (_v0) {
	var record = _v0.b;
	return record.adQ;
};
var $author$project$Components$Membership$Form$Sections$Pricing$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{yT: response}),
					aR: $author$project$OutMsg$handleErrorResponse(response)
				};
			case 1:
				var pendingMembership = msg.a;
				var fields = $author$project$Utils$Form$fields(model.SD);
				var manuallySet = fields.cK;
				var fixedPeriodRateInCents = function () {
					var _v2 = _Utils_Tuple2(manuallySet._1, fields.Sx);
					if (_v2.a) {
						return $elm$core$Maybe$Nothing;
					} else {
						if (!_v2.b.$) {
							var fixedPeriodRateInCents_ = _v2.b.a;
							return $elm$core$Maybe$Just(fixedPeriodRateInCents_);
						} else {
							var _v3 = _v2.b;
							return $elm$core$Maybe$Just(
								$author$project$Currency$fromInt(
									$author$project$Api$Provider$Membership$One$revenueInCents(pendingMembership)));
						}
					}
				}();
				var newFields = _Utils_update(
					fields,
					{
						Sx: fixedPeriodRateInCents,
						cK: _Utils_update(
							manuallySet,
							{_1: !manuallySet._1})
					});
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 1,
					aiO: _Utils_update(
						model,
						{
							SD: A2($author$project$Utils$Form$set, newFields, model.SD)
						}),
					aR: _List_Nil
				};
			case 2:
				var pendingMembership = msg.a;
				var fields = $author$project$Utils$Form$fields(model.SD);
				var manuallySet = fields.cK;
				var fixedRegistrationFeeInCents = function () {
					var _v4 = _Utils_Tuple2(manuallySet.e1, fields.Sy);
					if (_v4.a) {
						return $elm$core$Maybe$Nothing;
					} else {
						if (!_v4.b.$) {
							var fixedRegistrationFeeInCents_ = _v4.b.a;
							return $elm$core$Maybe$Just(fixedRegistrationFeeInCents_);
						} else {
							var _v5 = _v4.b;
							return A2(
								$elm$core$Maybe$map,
								$author$project$Currency$fromInt,
								A2(
									$elm$core$Maybe$andThen,
									$author$project$Api$Provider$MembershipBill$ForMembershipOne$registrationFeeInCents,
									$elm$core$List$head(
										$author$project$Api$Provider$Membership$One$upcomingAndOutstandingBills(pendingMembership))));
						}
					}
				}();
				var newFields = _Utils_update(
					fields,
					{
						Sy: fixedRegistrationFeeInCents,
						cK: _Utils_update(
							manuallySet,
							{e1: !manuallySet.e1})
					});
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 1,
					aiO: _Utils_update(
						model,
						{
							SD: A2($author$project$Utils$Form$set, newFields, model.SD)
						}),
					aR: _List_Nil
				};
			case 3:
				var fields = $author$project$Utils$Form$fields(model.SD);
				var newFields = model.Q1 ? _Utils_update(
					fields,
					{OP: $elm$core$Maybe$Nothing}) : fields;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 1,
					aiO: _Utils_update(
						model,
						{
							Q1: !model.Q1,
							SD: A2($author$project$Utils$Form$set, newFields, model.SD)
						}),
					aR: _List_Nil
				};
			case 4:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Membership$Form$Sections$Pricing$formFieldsUpdate, field, model.SD);
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 1,
					aiO: _Utils_update(
						model,
						{SD: newForm}),
					aR: _List_Nil
				};
			case 5:
				var response = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{C8: response}),
					aR: $author$project$OutMsg$handleErrorResponse(response)
				};
			case 6:
				var _v6 = function () {
					if (model.nq) {
						var fields = $author$project$Utils$Form$fields(model.SD);
						return _Utils_Tuple2(
							$elm$core$Maybe$Nothing,
							A2(
								$author$project$Utils$Form$set,
								_Utils_update(
									fields,
									{Zg: $elm$core$Maybe$Nothing}),
								model.SD));
					} else {
						return _Utils_Tuple2(model.lf, model.SD);
					}
				}();
				var newSelectedPaymentMethod = _v6.a;
				var newForm = _v6.b;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{nq: !model.nq, SD: newForm, lf: newSelectedPaymentMethod}),
					aR: _List_Nil
				};
			case 7:
				var dropdownMsg = msg.a;
				var _v7 = A2($author$project$Ui$Dropdown$update, dropdownMsg, model.o0);
				var newDropdown = _v7.a;
				var dropdownCmd = _v7.b;
				return {
					GZ: dropdownCmd,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{o0: newDropdown}),
					aR: _List_Nil
				};
			case 8:
				var query = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{o1: query}),
					aR: _List_Nil
				};
			default:
				var maybePaymentMethod = msg.a;
				var newPaymentSource = function () {
					if (!maybePaymentMethod.$) {
						var pm = maybePaymentMethod.a;
						return $elm$core$Maybe$Just(
							{
								ahP: $elm$core$Maybe$Just(
									$author$project$Api$Provider$PaymentMethod$Min$id(pm))
							});
					} else {
						return $elm$core$Maybe$Just(
							{ahP: $elm$core$Maybe$Nothing});
					}
				}();
				var fields = $author$project$Utils$Form$fields(model.SD);
				var newForm = A2(
					$author$project$Utils$Form$set,
					_Utils_update(
						fields,
						{Zg: newPaymentSource}),
					model.SD);
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 1,
					aiO: _Utils_update(
						model,
						{SD: newForm, o1: '', lf: maybePaymentMethod}),
					aR: _List_Nil
				};
		}
	});
var $author$project$Components$Membership$Form$Sections$RecurringCharges$None = 0;
var $author$project$Components$Membership$Form$Sections$RecurringCharges$PeriodsRemaining = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Membership$Form$Sections$RecurringCharges$Updated = 1;
var $author$project$Api$Provider$Uom$Shared$periodInMonths = function (_v0) {
	var record = _v0;
	return record.Zs;
};
var $author$project$Components$Membership$Form$Sections$RecurringCharges$formFieldsUpdate = F3(
	function (index, field, fields) {
		var recurringCharges = A3(
			$elm_community$list_extra$List$Extra$updateAt,
			index,
			function (recurringCharge) {
				switch (field.$) {
					case 0:
						var _int = field.a;
						var quantity = function () {
							var _v1 = _Utils_Tuple2(
								$author$project$Api$Provider$Uom$Shared$periodInMonths(recurringCharge.adP),
								_int);
							if ((!_v1.a.$) && (!_v1.b.$)) {
								var chargeItemPeriod = _v1.a.a;
								var periodInMonths = _v1.b.a;
								return $elm$core$Maybe$Just((periodInMonths / chargeItemPeriod) | 0);
							} else {
								return recurringCharge.Dz;
							}
						}();
						return _Utils_update(
							recurringCharge,
							{Zs: _int, Dz: quantity});
					case 1:
						var _int = field.a;
						return _Utils_update(
							recurringCharge,
							{aj1: _int});
					default:
						var _int = field.a;
						return _Utils_update(
							recurringCharge,
							{Dz: _int});
				}
			},
			fields.$h);
		return _Utils_update(
			fields,
			{$h: recurringCharges});
	});
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$GotTaxProfiles = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$initChargeItemResourceFilter = F2(
	function (apiClient, showItemTypeInTitle) {
		return A4(
			$author$project$Components$ResourceFilter$ChargeItem$initWithItemType,
			showItemTypeInTitle,
			apiClient,
			$elm$core$Basics$identity,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Select an item', Lr: true});
			});
	});
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$initFormFields = function (patient) {
	return {mL: $elm$core$Maybe$Nothing, afD: false, aho: $elm$core$Maybe$Nothing, ahp: $elm$core$Maybe$Nothing, YY: patient, aj1: $elm$core$Maybe$Nothing, aka: $elm$core$Maybe$Nothing, fe: $elm$core$Maybe$Nothing, adP: $elm$core$Maybe$Nothing};
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$initFormFieldsFromItem = function (recurringCharge) {
	return {
		mL: $elm$core$Maybe$Just(recurringCharge.mL),
		afD: recurringCharge.mL.acZ,
		aho: recurringCharge.aho,
		ahp: A2($elm$core$Maybe$map, $author$project$Currency$fromFloat, recurringCharge.ahp),
		YY: recurringCharge.YY,
		aj1: recurringCharge.aj1,
		aka: recurringCharge.aka,
		fe: $elm$core$Maybe$Nothing,
		adP: $elm$core$Maybe$Just(recurringCharge.adP)
	};
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$initLimitedPatientSelector = F3(
	function (apiClient, patients, patient) {
		return A4(
			$author$project$Components$LimitedPatientSelector$init,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Select a Patient', Lr: true});
			},
			patients,
			patient);
	});
var $author$project$Components$ResourceFilter$Practitioner$preSelectedId = F2(
	function (id, model) {
		var _v0 = A2($author$project$Components$ResourceFilter$preSelectedId, id, model.b8);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{b8: resourceFilter}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$initPractitionerResourceFilter = F2(
	function (apiClient, practitioner) {
		return function (_v0) {
			var practitionerResourceFilter = _v0.a;
			var practitionerResourceFilterCmd = _v0.b;
			return A2(
				$elm$core$Maybe$withDefault,
				_Utils_Tuple2(practitionerResourceFilter, practitionerResourceFilterCmd),
				A2(
					$elm$core$Maybe$map,
					function (practitioner_) {
						var _v1 = A2(
							$author$project$Components$ResourceFilter$Practitioner$preSelectedId,
							$elm$core$Maybe$Just(practitioner_.ahP),
							practitionerResourceFilter);
						var withPreSelectedModel = _v1.a;
						var withPreSelectedCmd = _v1.b;
						return _Utils_Tuple2(
							A2(
								$author$project$Components$ResourceFilter$Practitioner$extraItems,
								_List_fromArray(
									[
										{ahP: practitioner_.ahP, Bq: practitioner_.ahP}
									]),
								withPreSelectedModel),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[withPreSelectedCmd, practitionerResourceFilterCmd])));
					},
					practitioner));
		}(
			A3(
				$author$project$Components$ResourceFilter$Practitioner$init,
				apiClient,
				$elm$core$Basics$identity,
				function (d) {
					return _Utils_update(
						d,
						{Gp: 'Unassigned'});
				}));
	});
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$init = F7(
	function (apiClient, showItemTypeInTitle, patients, patient, index, recurringCharge, lockedTaxProfileId) {
		var baseFormFields = function () {
			if (!recurringCharge.$) {
				var recurringCharge_ = recurringCharge.a;
				return $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$initFormFieldsFromItem(recurringCharge_);
			} else {
				return $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$initFormFields(patient);
			}
		}();
		var formFields = _Utils_update(
			baseFormFields,
			{fe: lockedTaxProfileId});
		var _v0 = A2(
			$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$initPractitionerResourceFilter,
			apiClient,
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.aka;
				},
				recurringCharge));
		var practitionerResourceFilter = _v0.a;
		var practitionerResourceFilterCmd = _v0.b;
		var _v1 = A3($author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$initLimitedPatientSelector, apiClient, patients, formFields.YY);
		var limitedPatientSelector = _v1.a;
		var limitedPatientSelectorCmd = _v1.b;
		var _v2 = A2($author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$initChargeItemResourceFilter, apiClient, showItemTypeInTitle);
		var chargeItemResourceFilter = _v2.a;
		var chargeItemResourceFilterCmd = _v2.b;
		return _Utils_Tuple2(
			{
				cq: chargeItemResourceFilter,
				SD: $author$project$Utils$Form$init(formFields),
				sG: index,
				oj: limitedPatientSelector,
				kb: lockedTaxProfileId,
				hk: practitionerResourceFilter,
				hU: $author$project$Api$Data$Loading
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$LimitedPatientSelectorMsg, limitedPatientSelectorCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$ChargeItemResourceFilterMsg, chargeItemResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$PractitionerResourceFilterMsg, practitionerResourceFilterCmd),
						A2($author$project$Api$Provider$TaxProfile$list, apiClient, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$GotTaxProfiles)
					])));
	});
var $author$project$Components$Membership$Form$Records$recurringChargeFromNew = function (newRecurringCharge) {
	var _v0 = _Utils_Tuple2(newRecurringCharge.mL, newRecurringCharge.adP);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var chargeItem = _v0.a.a;
		var uom = _v0.b.a;
		return $elm$core$Maybe$Just(
			{
				mL: chargeItem,
				aho: $elm$core$Maybe$Nothing,
				ahp: $elm$core$Maybe$Nothing,
				ahP: $elm$core$Maybe$Nothing,
				Bq: $elm$core$Maybe$Nothing,
				XP: $elm$core$Maybe$Nothing,
				YY: newRecurringCharge.YY,
				Zs: $elm$core$Maybe$Just(
					A2(
						$elm$core$Maybe$withDefault,
						1,
						$author$project$Api$Provider$Uom$Shared$periodInMonths(uom))),
				Zu: newRecurringCharge.aj1,
				aj1: newRecurringCharge.aj1,
				aka: newRecurringCharge.aka,
				Dz: $elm$core$Maybe$Just(1),
				ab7: $elm$core$Maybe$Nothing,
				adP: uom
			});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Added = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$ChargeItem = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$ChargeItemValidation = 1;
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Closed = {$: 1};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$None = {$: 0};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Patient = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Practitioner = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$TaxProfileValidation = 2;
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Updated = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$effectiveTaxProfileId = function (model) {
	var fields = $author$project$Utils$Form$fields(model.SD);
	if (fields.afD) {
		var _v0 = model.kb;
		if (!_v0.$) {
			var id = _v0.a;
			return $elm$core$Maybe$Just(id);
		} else {
			return fields.fe;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Membership$Form$Records$chargeItemFromResourceFilter = function (chargeItem) {
	return {Qr: chargeItem.Qr, ahP: chargeItem.ahP, Bq: chargeItem.Bq, Dw: chargeItem.Dw, acZ: chargeItem.acZ};
};
var $author$project$Components$Membership$Form$Records$patientFromLimitedPatientSelector = $elm$core$Basics$identity;
var $author$project$Components$Membership$Form$Records$practitionerFromResourceFilter = function (practitioner) {
	return {ahP: practitioner.ahP, Bq: practitioner.Bq};
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var patient = field.a;
				return _Utils_update(
					fields,
					{
						YY: A2($elm$core$Maybe$map, $author$project$Components$Membership$Form$Records$patientFromLimitedPatientSelector, patient),
						aka: A2(
							$elm$core$Maybe$andThen,
							function ($) {
								return $.aka;
							},
							patient)
					});
			case 1:
				var chargeItem = field.a;
				return _Utils_update(
					fields,
					{
						mL: A2($elm$core$Maybe$map, $author$project$Components$Membership$Form$Records$chargeItemFromResourceFilter, chargeItem),
						afD: A2(
							$elm$core$Maybe$withDefault,
							false,
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.acZ;
								},
								chargeItem)),
						adP: A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.adP;
							},
							chargeItem)
					});
			case 2:
				var practitioner = field.a;
				return _Utils_update(
					fields,
					{
						aka: A2($elm$core$Maybe$map, $author$project$Components$Membership$Form$Records$practitionerFromResourceFilter, practitioner)
					});
			case 3:
				var currency = field.a;
				return _Utils_update(
					fields,
					{ahp: currency});
			case 4:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						aho: $author$project$Utils$String$toMaybe(string)
					});
			default:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						fe: $elm$core$String$isEmpty(string) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(string)
					});
		}
	});
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$PatientValidation = 0;
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$validateTaxProfile = F2(
	function (model, fields) {
		if ((!fields.afD) || (!_Utils_eq(model.kb, $elm$core$Maybe$Nothing))) {
			return _List_Nil;
		} else {
			var _v0 = model.hU;
			switch (_v0.$) {
				case 2:
					return _List_fromArray(
						[
							_Utils_Tuple2(2, 'Tax profiles failed to load. Please close and try again.')
						]);
				case 3:
					var taxProfiles = _v0.a;
					if ($elm$core$List$length(taxProfiles) > 1) {
						var _v1 = fields.fe;
						if (!_v1.$) {
							return _List_Nil;
						} else {
							return _List_fromArray(
								[
									_Utils_Tuple2(2, 'Please select a tax profile.')
								]);
						}
					} else {
						return _List_Nil;
					}
				default:
					return _List_Nil;
			}
		}
	});
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$formFieldsValidator = function (model) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_validate$Validate$ifNothing,
				function ($) {
					return $.YY;
				},
				_Utils_Tuple2(0, 'Please pick a patient')),
				A2(
				$rtfeldman$elm_validate$Validate$ifNothing,
				function ($) {
					return $.mL;
				},
				_Utils_Tuple2(1, 'Please pick a charge item')),
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$validateTaxProfile(model))
			]));
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Closed, aiO: model, aR: _List_Nil};
			case 1:
				var field = msg.a;
				var updatedForm = A3($author$project$Utils$Form$update, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$formFieldsUpdate, field, model.SD);
				var newForm = function () {
					switch (field.$) {
						case 5:
							return A2($author$project$Utils$Form$clearGroupErrors, 2, updatedForm);
						case 1:
							return A2(
								$author$project$Utils$Form$clearGroupErrors,
								2,
								A2($author$project$Utils$Form$clearGroupErrors, 1, updatedForm));
						default:
							return updatedForm;
					}
				}();
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$None,
					aiO: _Utils_update(
						model,
						{SD: newForm}),
					aR: _List_Nil
				};
			case 2:
				var subMsg = msg.a;
				var patientResourceResult = A3($author$project$Components$LimitedPatientSelector$update, apiClient, subMsg, model.oj);
				var newForm = function () {
					var _v3 = patientResourceResult.agZ;
					_v3$2:
					while (true) {
						if (_v3.$ === 1) {
							switch (_v3.a.$) {
								case 0:
									var patient = _v3.a.a;
									return A3(
										$author$project$Utils$Form$update,
										$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$formFieldsUpdate,
										$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Patient(
											$elm$core$Maybe$Just(patient)),
										model.SD);
								case 3:
									var _v4 = _v3.a;
									return A3(
										$author$project$Utils$Form$update,
										$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$formFieldsUpdate,
										$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Patient($elm$core$Maybe$Nothing),
										model.SD);
								default:
									break _v3$2;
							}
						} else {
							break _v3$2;
						}
					}
					return model.SD;
				}();
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$LimitedPatientSelectorMsg, patientResourceResult.GZ),
					agZ: $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$None,
					aiO: _Utils_update(
						model,
						{SD: newForm, oj: patientResourceResult.aiO}),
					aR: patientResourceResult.aR
				};
			case 3:
				var subMsg = msg.a;
				var chargeItemResourceResult = A3($author$project$Components$ResourceFilter$ChargeItem$update, apiClient, subMsg, model.cq);
				var newForm = function () {
					var _v5 = chargeItemResourceResult.agZ;
					_v5$2:
					while (true) {
						if (!_v5.$) {
							switch (_v5.a.$) {
								case 0:
									var chargeItem = _v5.a.a;
									return A3(
										$author$project$Utils$Form$update,
										$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$formFieldsUpdate,
										$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$ChargeItem(
											$elm$core$Maybe$Just(chargeItem)),
										model.SD);
								case 2:
									var _v6 = _v5.a;
									return A3(
										$author$project$Utils$Form$update,
										$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$formFieldsUpdate,
										$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$ChargeItem($elm$core$Maybe$Nothing),
										model.SD);
								default:
									break _v5$2;
							}
						} else {
							break _v5$2;
						}
					}
					return model.SD;
				}();
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$ChargeItemResourceFilterMsg, chargeItemResourceResult.GZ),
					agZ: $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$None,
					aiO: _Utils_update(
						model,
						{cq: chargeItemResourceResult.aiO, SD: newForm}),
					aR: chargeItemResourceResult.aR
				};
			case 4:
				var subMsg = msg.a;
				var practitionerResourceResult = A3($author$project$Components$ResourceFilter$Practitioner$update, apiClient, subMsg, model.hk);
				var newForm = function () {
					var _v7 = practitionerResourceResult.agZ;
					_v7$2:
					while (true) {
						if (!_v7.$) {
							switch (_v7.a.$) {
								case 0:
									var practitioner = _v7.a.a;
									return A3(
										$author$project$Utils$Form$update,
										$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$formFieldsUpdate,
										$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Practitioner(
											$elm$core$Maybe$Just(practitioner)),
										model.SD);
								case 2:
									var _v8 = _v7.a;
									return A3(
										$author$project$Utils$Form$update,
										$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$formFieldsUpdate,
										$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Practitioner($elm$core$Maybe$Nothing),
										model.SD);
								default:
									break _v7$2;
							}
						} else {
							break _v7$2;
						}
					}
					return model.SD;
				}();
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$PractitionerResourceFilterMsg, practitionerResourceResult.GZ),
					agZ: $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$None,
					aiO: _Utils_update(
						model,
						{SD: newForm, hk: practitionerResourceResult.aiO}),
					aR: practitionerResourceResult.aR
				};
			case 5:
				var data = msg.a;
				var currentFields = $author$project$Utils$Form$fields(model.SD);
				var autoSelectedTaxProfileId = function () {
					if (((data.$ === 3) && data.a.b) && (!data.a.b.b)) {
						var _v10 = data.a;
						var single = _v10.a;
						return $elm$core$Maybe$Just(
							$author$project$Api$Provider$TaxProfile$All$id(single));
					} else {
						return $author$project$Utils$Form$fields(model.SD).fe;
					}
				}();
				var newForm = A2(
					$author$project$Utils$Form$set,
					_Utils_update(
						currentFields,
						{fe: autoSelectedTaxProfileId}),
					model.SD);
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$None,
					aiO: _Utils_update(
						model,
						{SD: newForm, hU: data}),
					aR: $author$project$OutMsg$handleErrorResponse(data)
				};
			default:
				var periodsRemaining = msg.a;
				var validator = $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$formFieldsValidator(
					{kb: model.kb, hU: model.hU});
				var _v11 = A2($author$project$Utils$Form$validate, validator, model.SD);
				if (!_v11.$) {
					var _v12 = _v11.a;
					var newForm = _v12.a;
					var validFormFields = _v12.b;
					var formFields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
					var chargeResult = {
						afx: {mL: formFields.mL, aho: formFields.aho, ahp: formFields.ahp, YY: formFields.YY, aj1: periodsRemaining, aka: formFields.aka, adP: formFields.adP},
						acY: $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$effectiveTaxProfileId(model)
					};
					var event = function () {
						var _v13 = model.sG;
						if (!_v13.$) {
							var index = _v13.a;
							return A2($author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Updated, index, chargeResult);
						} else {
							return $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Added(chargeResult);
						}
					}();
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: event,
						aiO: _Utils_update(
							model,
							{SD: newForm}),
						aR: _List_Nil
					};
				} else {
					var newForm = _v11.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$None,
						aiO: _Utils_update(
							model,
							{SD: newForm}),
						aR: _List_Nil
					};
				}
		}
	});
var $author$project$Components$Membership$Form$Sections$RecurringCharges$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					var taxableChargeItemsCount = A2(
						$elm$core$Maybe$withDefault,
						0,
						A2(
							$elm$core$Maybe$andThen,
							$elm$core$String$toInt,
							A2($elm$core$Dict$get, 'x-total-count', headers)));
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{sv: taxableChargeItemsCount > 0}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: model,
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 1:
				var index = msg.a;
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Membership$Form$Sections$RecurringCharges$formFieldsUpdate(index),
					$author$project$Components$Membership$Form$Sections$RecurringCharges$PeriodsRemaining(
						$elm$core$Maybe$Just(1)),
					model.SD);
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{SD: newForm}),
					aR: _List_Nil
				};
			case 2:
				var index = msg.a;
				var formFields = $author$project$Utils$Form$fields(model.SD);
				var newFormFields = _Utils_update(
					formFields,
					{
						$h: A2($elm_community$list_extra$List$Extra$removeAt, index, formFields.$h)
					});
				var updatedMembershipTaxProfileId = A2(
					$elm$core$List$any,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.mL;
						},
						function ($) {
							return $.acZ;
						}),
					newFormFields.$h) ? model.E : $elm$core$Maybe$Nothing;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 1,
					aiO: _Utils_update(
						model,
						{
							SD: A2($author$project$Utils$Form$set, newFormFields, model.SD),
							E: updatedMembershipTaxProfileId
						}),
					aR: _List_Nil
				};
			case 3:
				var patients = msg.a;
				var index = msg.b;
				var _v3 = $author$project$Utils$Form$fields(model.SD);
				var recurringCharges = _v3.$h;
				var _v4 = A2($elm_community$list_extra$List$Extra$getAt, index, recurringCharges);
				if (!_v4.$) {
					var recurringCharge = _v4.a;
					var _v5 = A7(
						$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$init,
						apiClient,
						model.EC,
						patients,
						$elm$core$Maybe$Nothing,
						$elm$core$Maybe$Just(index),
						$elm$core$Maybe$Just(recurringCharge),
						model.E);
					var createEditModal = _v5.a;
					var createEditModalCmd = _v5.b;
					return {
						GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$RecurringCharges$CreateEditModalMsg, createEditModalCmd),
						agZ: 0,
						aiO: _Utils_update(
							model,
							{
								f1: $elm$core$Maybe$Just(createEditModal)
							}),
						aR: _List_Nil
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
			case 4:
				var index = msg.a;
				var field = msg.b;
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Membership$Form$Sections$RecurringCharges$formFieldsUpdate(index),
					field,
					model.SD);
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 1,
					aiO: _Utils_update(
						model,
						{SD: newForm}),
					aR: _List_Nil
				};
			case 5:
				var patients = msg.a;
				var patient = $elm$core$List$head(patients);
				var _v6 = A7($author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$init, apiClient, model.EC, patients, patient, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, model.E);
				var createEditModal = _v6.a;
				var createEditModalCmd = _v6.b;
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$RecurringCharges$CreateEditModalMsg, createEditModalCmd),
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							f1: $elm$core$Maybe$Just(createEditModal)
						}),
					aR: _List_Nil
				};
			default:
				var subMsg = msg.a;
				var _v7 = model.f1;
				if (!_v7.$) {
					var createEditModal = _v7.a;
					var createEditModalResult = A3($author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$update, apiClient, subMsg, createEditModal);
					var modalOutcome = function () {
						var _v8 = createEditModalResult.agZ;
						switch (_v8.$) {
							case 0:
								return {
									agZ: 0,
									SD: model.SD,
									E: model.E,
									bH: $elm$core$Maybe$Just(createEditModalResult.aiO)
								};
							case 1:
								return {agZ: 0, SD: model.SD, E: model.E, bH: $elm$core$Maybe$Nothing};
							case 2:
								var chargeResult = _v8.a;
								var _v9 = $author$project$Components$Membership$Form$Records$recurringChargeFromNew(chargeResult.afx);
								if (!_v9.$) {
									var recurringCharge = _v9.a;
									var updatedMembershipTaxProfileId = function () {
										var _v10 = chargeResult.acY;
										if (!_v10.$) {
											var id = _v10.a;
											return $elm$core$Maybe$Just(id);
										} else {
											return model.E;
										}
									}();
									var formFields = $author$project$Utils$Form$fields(model.SD);
									var newFormFields = _Utils_update(
										formFields,
										{
											$h: _Utils_ap(
												formFields.$h,
												_List_fromArray(
													[recurringCharge]))
										});
									return {
										agZ: 1,
										SD: A2($author$project$Utils$Form$set, newFormFields, model.SD),
										E: updatedMembershipTaxProfileId,
										bH: $elm$core$Maybe$Nothing
									};
								} else {
									return {agZ: 0, SD: model.SD, E: model.E, bH: $elm$core$Maybe$Nothing};
								}
							default:
								var index = _v8.a;
								var chargeResult = _v8.b;
								var updatedMembershipTaxProfileId = function () {
									var _v11 = chargeResult.acY;
									if (!_v11.$) {
										var id = _v11.a;
										return $elm$core$Maybe$Just(id);
									} else {
										return model.E;
									}
								}();
								var formFields = $author$project$Utils$Form$fields(model.SD);
								var newRecurringCharges = A3(
									$elm_community$list_extra$List$Extra$updateAt,
									index,
									function (recurringCharge) {
										return _Utils_update(
											recurringCharge,
											{
												aho: chargeResult.afx.aho,
												ahp: A2($elm$core$Maybe$andThen, $author$project$Currency$toFloat, chargeResult.afx.ahp),
												YY: chargeResult.afx.YY,
												aka: chargeResult.afx.aka
											});
									},
									formFields.$h);
								var newFormFields = _Utils_update(
									formFields,
									{$h: newRecurringCharges});
								return {
									agZ: 1,
									SD: A2($author$project$Utils$Form$set, newFormFields, model.SD),
									E: updatedMembershipTaxProfileId,
									bH: $elm$core$Maybe$Nothing
								};
						}
					}();
					return {
						GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$RecurringCharges$CreateEditModalMsg, createEditModalResult.GZ),
						agZ: modalOutcome.agZ,
						aiO: _Utils_update(
							model,
							{f1: modalOutcome.bH, SD: modalOutcome.SD, E: modalOutcome.E}),
						aR: createEditModalResult.aR
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
		}
	});
var $author$project$Components$Membership$Form$Sections$Summary$NextBillDate = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Membership$Form$Sections$Summary$None = {$: 0};
var $author$project$Components$Membership$Form$Sections$Summary$Owner = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Membership$Form$Sections$Summary$Plan = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Membership$Form$Sections$Summary$StartDate = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Membership$Form$Sections$Summary$Updated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Membership$Form$Sections$Summary$FormUpdated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Membership$Form$Sections$Summary$asynUpdateForm = function (field) {
	return A2(
		$elm$core$Task$perform,
		function (_v0) {
			return $author$project$Components$Membership$Form$Sections$Summary$FormUpdated(field);
		},
		$elm$core$Process$sleep(0));
};
var $author$project$Components$ResourceFilter$Plan$extraItems = F2(
	function (list_, model) {
		var extraItems_ = A2(
			$elm$core$List$map,
			function (item) {
				return {aih: item.Bq, aee: item.ahP};
			},
			list_);
		return _Utils_update(
			model,
			{
				b8: A2($author$project$Components$ResourceFilter$extraItems, extraItems_, model.b8)
			});
	});
var $author$project$Components$Membership$Form$Sections$Summary$GotBrokerDeals = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Membership$Form$Sections$Summary$fetchBrokerDeals = F3(
	function (apiClient, isNew, membershipId) {
		return isNew ? $elm$core$Platform$Cmd$none : A3(
			$author$project$Api$Provider$BrokerDeal$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						kk: $elm$core$Maybe$Just(membershipId)
					});
			},
			$author$project$Components$Membership$Form$Sections$Summary$GotBrokerDeals);
	});
var $author$project$Components$Membership$Form$Sections$Summary$PeriodInMonths = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Membership$Form$Records$planFromApiPlan = function (plan) {
	return {
		ahP: $author$project$Api$Plan$id(plan),
		Bq: $author$project$Api$Plan$name(plan)
	};
};
var $author$project$Components$Membership$Form$Sections$Summary$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var patient = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{
							YD: A2($elm$core$Maybe$map, $author$project$Components$Membership$Form$Records$patientFromAll, patient)
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var plan = field.a;
				var cmd = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						function (plan_) {
							var allowedPeriodInMonths = A2(
								$elm$core$List$map,
								$author$project$Api$Period$numberOfMonths,
								$author$project$Api$Plan$periods(plan_));
							return (!A2($elm$core$List$member, fields.Zs, allowedPeriodInMonths)) ? $author$project$Components$Membership$Form$Sections$Summary$asynUpdateForm(
								$author$project$Components$Membership$Form$Sections$Summary$PeriodInMonths(
									A2(
										$elm$core$Maybe$withDefault,
										1,
										$elm$core$List$head(allowedPeriodInMonths)))) : $elm$core$Platform$Cmd$none;
						},
						plan));
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{
							Jb: A2($elm$core$Maybe$map, $author$project$Components$Membership$Form$Records$planFromApiPlan, plan)
						}),
					cmd);
			case 2:
				var date = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{ab7: date}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var date = field.a;
				var billDate = fields.ff ? date : $elm$core$Maybe$Nothing;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{xB: billDate, XP: date}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var bool = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{Mk: bool}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var _int = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{Zs: _int}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var string = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{
							Xf: $elm$core$String$toInt(string)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var bool = field.a;
				var billDate = bool ? fields.XP : $elm$core$Maybe$Nothing;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{xB: billDate, ff: bool}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Components$ResourceFilter$Plan$preSelectedId = F2(
	function (id, model) {
		var _v0 = A2($author$project$Components$ResourceFilter$preSelectedId, id, model.b8);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{b8: resourceFilter}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Api$Employer$Plan$Shared$billsAtEndOfPeriod = function (_v0) {
	var record = _v0;
	return record.MI;
};
var $author$project$Api$Employer$Plan$All$billsAtEndOfPeriod = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$billsAtEndOfPeriod(shared);
};
var $author$project$Api$Employer$Plan$One$billsAtEndOfPeriod = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$billsAtEndOfPeriod(shared);
};
var $author$project$Api$Provider$Plan$All$billsAtEndOfPeriod = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$billsAtEndOfPeriod(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$billsAtEndOfPeriod = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$billsAtEndOfPeriod(shared);
};
var $author$project$Api$Plan$billsAtEndOfPeriod = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$Shared$billsAtEndOfPeriod(plan_);
		case 1:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$SharedWithContractInfo$billsAtEndOfPeriod(plan_);
		case 4:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$Shared$billsAtEndOfPeriod(plan_);
		case 2:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$All$billsAtEndOfPeriod(plan_);
		case 6:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$All$billsAtEndOfPeriod(plan_);
		case 3:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$One$billsAtEndOfPeriod(plan_);
		default:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$One$billsAtEndOfPeriod(plan_);
	}
};
var $author$project$Components$Membership$Form$Sections$Summary$planBillsAtEndOfPeriodChanged = F2(
	function (pendingMembership, plan) {
		var pendingMembershipPlan = $author$project$Api$Provider$Membership$One$plan(pendingMembership);
		return !_Utils_eq(
			$author$project$Api$Provider$Plan$SharedWithContractInfo$billsAtEndOfPeriod(pendingMembershipPlan),
			$author$project$Api$Plan$billsAtEndOfPeriod(plan));
	});
var $author$project$Components$Membership$Form$Sections$Summary$resetBillDate = F3(
	function (pendingMembership, newPlan, model) {
		if (A2($author$project$Components$Membership$Form$Sections$Summary$planBillsAtEndOfPeriodChanged, pendingMembership, newPlan)) {
			var fields = $author$project$Utils$Form$fields(model.SD);
			var newFields = _Utils_update(
				fields,
				{xB: $elm$core$Maybe$Nothing});
			return _Utils_update(
				model,
				{
					SD: A2($author$project$Utils$Form$set, newFields, model.SD)
				});
		} else {
			return model;
		}
	});
var $author$project$Api$Employer$Plan$Shared$minimumEnrollmentPeriodInMonths = function (_v0) {
	var record = _v0;
	return record.Xf;
};
var $author$project$Api$Employer$Plan$All$minimumEnrollmentPeriodInMonths = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$minimumEnrollmentPeriodInMonths(shared);
};
var $author$project$Api$Employer$Plan$One$minimumEnrollmentPeriodInMonths = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$minimumEnrollmentPeriodInMonths(shared);
};
var $author$project$Api$Provider$Plan$All$minimumEnrollmentPeriodInMonths = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$minimumEnrollmentPeriodInMonths(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$minimumEnrollmentPeriodInMonths = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$minimumEnrollmentPeriodInMonths(shared);
};
var $author$project$Api$Plan$minimumEnrollmentPeriodInMonths = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$Shared$minimumEnrollmentPeriodInMonths(plan_);
		case 1:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$SharedWithContractInfo$minimumEnrollmentPeriodInMonths(plan_);
		case 4:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$Shared$minimumEnrollmentPeriodInMonths(plan_);
		case 2:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$All$minimumEnrollmentPeriodInMonths(plan_);
		case 6:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$All$minimumEnrollmentPeriodInMonths(plan_);
		case 3:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$One$minimumEnrollmentPeriodInMonths(plan_);
		default:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$One$minimumEnrollmentPeriodInMonths(plan_);
	}
};
var $author$project$Components$Membership$Form$Sections$Summary$planMinimumEnrollmentPeriodInMonthsChanged = F2(
	function (pendingMembership, plan) {
		var pendingMembershipPlan = $author$project$Api$Provider$Membership$One$plan(pendingMembership);
		return !_Utils_eq(
			$author$project$Api$Provider$Plan$SharedWithContractInfo$minimumEnrollmentPeriodInMonths(pendingMembershipPlan),
			$author$project$Api$Plan$minimumEnrollmentPeriodInMonths(plan));
	});
var $author$project$Components$Membership$Form$Sections$Summary$resetMinimumEnrollmentPeriod = F3(
	function (pendingMembership, newPlan, model) {
		if (A2($author$project$Components$Membership$Form$Sections$Summary$planMinimumEnrollmentPeriodInMonthsChanged, pendingMembership, newPlan)) {
			var show = model.p0;
			var fields = $author$project$Utils$Form$fields(model.SD);
			var newFields = _Utils_update(
				fields,
				{
					Xf: $author$project$Api$Plan$minimumEnrollmentPeriodInMonths(newPlan)
				});
			return _Utils_update(
				model,
				{
					SD: A2($author$project$Utils$Form$set, newFields, model.SD),
					p0: _Utils_update(
						show,
						{fx: !show.fx})
				});
		} else {
			return model;
		}
	});
var $author$project$Components$Membership$Form$Sections$Summary$updateDateInputFormField = F6(
	function (model, dateInputGetter, dateInputSetter, subMsg, toMsg, toField) {
		var dateInput = dateInputGetter(model);
		var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
		var newDateInput = _v0.a;
		var subCmd = _v0.b;
		var dateInputEvent = _v0.c;
		var newFormCmd = function () {
			if (dateInputEvent.$ === 1) {
				var date = dateInputEvent.a;
				var field_ = toField(date);
				return $author$project$Components$Membership$Form$Sections$Summary$asynUpdateForm(field_);
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		}();
		return {
			GZ: $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						newFormCmd,
						A2($elm$core$Platform$Cmd$map, toMsg, subCmd)
					])),
			agZ: $author$project$Components$Membership$Form$Sections$Summary$None,
			aiO: A2(dateInputSetter, newDateInput, model),
			aR: _List_Nil
		};
	});
var $author$project$Components$Membership$Form$Sections$Summary$updateMembershipNextBillDate = F3(
	function (membership, startDate, model) {
		var fields = $author$project$Utils$Form$fields(model.SD);
		var calculatedStartDate = $author$project$Api$Provider$Membership$One$billsAtEndOfPeriod(membership) ? A3(
			$justinmimbs$date$Date$add,
			1,
			$author$project$Api$Provider$Membership$One$periodInMonths(membership),
			startDate) : startDate;
		var nextBillDate = model.BM ? A2(
			$elm_community$list_extra$List$Extra$maximumBy,
			$justinmimbs$date$Date$toRataDie,
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						function () {
						var _v0 = _Utils_Tuple2(
							fields.XP,
							$author$project$Api$Provider$Membership$One$nextBillDate(membership));
						if (!_v0.a.$) {
							var nextBillDate_ = _v0.a.a;
							return $elm$core$Maybe$Just(nextBillDate_);
						} else {
							if (!_v0.b.$) {
								var _v1 = _v0.a;
								var nextBillDate_ = _v0.b.a;
								return $elm$core$Maybe$Just(nextBillDate_);
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}
					}(),
						$elm$core$Maybe$Just(calculatedStartDate)
					]))) : $elm$core$Maybe$Just(calculatedStartDate);
		return _Utils_eq(nextBillDate, fields.XP) ? $elm$core$Platform$Cmd$none : $author$project$Components$Membership$Form$Sections$Summary$asynUpdateForm(
			$author$project$Components$Membership$Form$Sections$Summary$NextBillDate(nextBillDate));
	});
var $author$project$Components$Membership$Form$Sections$Summary$update = F4(
	function (apiClient, sectionsShared, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var show = model.p0;
				var _v2 = $author$project$Utils$Form$fields(model.SD);
				var owner = _v2.YD;
				var _v3 = A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model.oY, $elm$core$Platform$Cmd$none),
					A2(
						$elm$core$Maybe$map,
						function (owner_) {
							var _v4 = A2(
								$author$project$Components$ResourceFilter$Patient$preSelectedId,
								$elm$core$Maybe$Just(owner_.ahP),
								model.oY);
							var withPreSelectedModel = _v4.a;
							var withPreSelectedCmd = _v4.b;
							return _Utils_Tuple2(
								A2(
									$author$project$Components$ResourceFilter$Patient$extraItems,
									_List_fromArray(
										[
											{Lj: owner_.Lj, ahP: owner_.ahP, WX: owner_.WX, Bq: owner_.Bq}
										]),
									withPreSelectedModel),
								withPreSelectedCmd);
						},
						owner));
				var patientResourceFilter = _v3.a;
				var patientResourceFilterCmd = _v3.b;
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$Summary$PatientResourceFilterMsg, patientResourceFilterCmd),
					agZ: $author$project$Components$Membership$Form$Sections$Summary$None,
					aiO: _Utils_update(
						model,
						{
							oY: patientResourceFilter,
							p0: _Utils_update(
								show,
								{YD: !show.YD})
						}),
					aR: _List_Nil
				};
			case 1:
				var show = model.p0;
				var _v5 = $author$project$Utils$Form$fields(model.SD);
				var plan = _v5.Jb;
				var _v6 = A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model.hi, $elm$core$Platform$Cmd$none),
					A2(
						$elm$core$Maybe$map,
						function (plan_) {
							var _v7 = A2(
								$author$project$Components$ResourceFilter$Plan$preSelectedId,
								$elm$core$Maybe$Just(plan_.ahP),
								model.hi);
							var withPreSelectedModel = _v7.a;
							var withPreSelectedCmd = _v7.b;
							return _Utils_Tuple2(
								A2(
									$author$project$Components$ResourceFilter$Plan$extraItems,
									_List_fromArray(
										[
											{ahP: plan_.ahP, Bq: plan_.Bq}
										]),
									withPreSelectedModel),
								withPreSelectedCmd);
						},
						plan));
				var planResourceFilter = _v6.a;
				var planResourceFilterCmd = _v6.b;
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$Summary$PlanResourceFilterMsg, planResourceFilterCmd),
					agZ: $author$project$Components$Membership$Form$Sections$Summary$None,
					aiO: _Utils_update(
						model,
						{
							hi: planResourceFilter,
							p0: _Utils_update(
								show,
								{Jb: !show.Jb})
						}),
					aR: _List_Nil
				};
			case 2:
				var fields = $author$project$Utils$Form$fields(model.SD);
				var manuallySet = fields.cK;
				var newFields = _Utils_update(
					fields,
					{
						cK: _Utils_update(
							manuallySet,
							{ab7: true})
					});
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: $author$project$Components$Membership$Form$Sections$Summary$None,
					aiO: _Utils_update(
						model,
						{
							SD: A2($author$project$Utils$Form$set, newFields, model.SD)
						}),
					aR: _List_Nil
				};
			case 3:
				var show = model.p0;
				var newModel = _Utils_update(
					model,
					{
						BM: true,
						p0: _Utils_update(
							show,
							{XP: true})
					});
				var fields = $author$project$Utils$Form$fields(model.SD);
				var cmd = (!$author$project$Utils$Maybe$toBool(fields.XP)) ? A3(
					$author$project$Components$Membership$Form$Sections$Summary$updateMembershipNextBillDate,
					sectionsShared.kk,
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$Api$Provider$Membership$One$startDate(sectionsShared.dC),
						fields.ab7),
					newModel) : $elm$core$Platform$Cmd$none;
				return {GZ: cmd, agZ: $author$project$Components$Membership$Form$Sections$Summary$None, aiO: newModel, aR: _List_Nil};
			case 4:
				var show = model.p0;
				var fields = $author$project$Utils$Form$fields(model.SD);
				var minimumEnrollmentPeriodInMonths = show.fx ? fields.Xf : $elm$core$Maybe$Nothing;
				var newFields = _Utils_update(
					fields,
					{Xf: minimumEnrollmentPeriodInMonths});
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: $author$project$Components$Membership$Form$Sections$Summary$None,
					aiO: _Utils_update(
						model,
						{
							SD: A2($author$project$Utils$Form$set, newFields, model.SD),
							p0: _Utils_update(
								show,
								{fx: !show.fx})
						}),
					aR: _List_Nil
				};
			case 5:
				var field = msg.a;
				var _v8 = A3($author$project$Utils$Form$updateWithCmd, $author$project$Components$Membership$Form$Sections$Summary$formFieldsUpdate, field, model.SD);
				var newForm = _v8.a;
				var newFormCmd = _v8.b;
				var newModel = function () {
					if ((field.$ === 1) && (!field.a.$)) {
						var plan = field.a.a;
						return A2(
							$elm$core$Basics$composeL,
							A2($author$project$Components$Membership$Form$Sections$Summary$resetBillDate, sectionsShared.dC, plan),
							A2($author$project$Components$Membership$Form$Sections$Summary$resetMinimumEnrollmentPeriod, sectionsShared.dC, plan));
					} else {
						return $elm$core$Basics$identity;
					}
				}()(
					_Utils_update(
						model,
						{SD: newForm}));
				var updateNextBillCmd = function () {
					var _v9 = _Utils_Tuple2(
						A2(
							$author$project$Utils$Form$field,
							function ($) {
								return $.ab7;
							},
							newForm),
						_Utils_eq(
							A2(
								$author$project$Utils$Form$field,
								function ($) {
									return $.ab7;
								},
								newForm),
							A2(
								$author$project$Utils$Form$field,
								function ($) {
									return $.ab7;
								},
								model.SD)));
					if ((!_v9.a.$) && (!_v9.b)) {
						var newStartDate = _v9.a.a;
						return A3($author$project$Components$Membership$Form$Sections$Summary$updateMembershipNextBillDate, sectionsShared.kk, newStartDate, newModel);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return {
					GZ: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[updateNextBillCmd, newFormCmd])),
					agZ: $author$project$Components$Membership$Form$Sections$Summary$Updated(field),
					aiO: newModel,
					aR: _List_Nil
				};
			case 6:
				var subMsg = msg.a;
				var patientResourceResult = A3($author$project$Components$ResourceFilter$Patient$update, apiClient, subMsg, model.oY);
				var _v11 = function () {
					var _v13 = patientResourceResult.agZ;
					if ((!_v13.$) && (!_v13.a.$)) {
						var patient = _v13.a.a;
						var field_ = $author$project$Components$Membership$Form$Sections$Summary$Owner(
							$elm$core$Maybe$Just(patient));
						var newForm_ = A3($author$project$Utils$Form$updateWithCmd, $author$project$Components$Membership$Form$Sections$Summary$formFieldsUpdate, field_, model.SD);
						return _Utils_Tuple2(
							newForm_,
							$elm$core$Maybe$Just(field_));
					} else {
						return _Utils_Tuple2(
							_Utils_Tuple2(model.SD, $elm$core$Platform$Cmd$none),
							$elm$core$Maybe$Nothing);
					}
				}();
				var _v12 = _v11.a;
				var newForm = _v12.a;
				var newFormCmd = _v12.b;
				var field = _v11.b;
				return {
					GZ: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								newFormCmd,
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$Summary$PatientResourceFilterMsg, patientResourceResult.GZ)
							])),
					agZ: A2(
						$elm$core$Maybe$withDefault,
						$author$project$Components$Membership$Form$Sections$Summary$None,
						A2($elm$core$Maybe$map, $author$project$Components$Membership$Form$Sections$Summary$Updated, field)),
					aiO: _Utils_update(
						model,
						{SD: newForm, oY: patientResourceResult.aiO}),
					aR: patientResourceResult.aR
				};
			case 7:
				var subMsg = msg.a;
				var planResourceResult = A3($author$project$Components$ResourceFilter$Plan$update, apiClient, subMsg, model.hi);
				var updateFormCmd = function () {
					var _v14 = planResourceResult.agZ;
					if ((!_v14.$) && (!_v14.a.$)) {
						var plan = _v14.a.a;
						return $author$project$Components$Membership$Form$Sections$Summary$asynUpdateForm(
							$author$project$Components$Membership$Form$Sections$Summary$Plan(
								$elm$core$Maybe$Just(plan)));
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return {
					GZ: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								updateFormCmd,
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$Summary$PlanResourceFilterMsg, planResourceResult.GZ)
							])),
					agZ: $author$project$Components$Membership$Form$Sections$Summary$None,
					aiO: _Utils_update(
						model,
						{hi: planResourceResult.aiO}),
					aR: planResourceResult.aR
				};
			case 8:
				var subMsg = msg.a;
				return A6(
					$author$project$Components$Membership$Form$Sections$Summary$updateDateInputFormField,
					model,
					function ($) {
						return $.lx;
					},
					F2(
						function (newDateInput, model_) {
							return _Utils_update(
								model_,
								{lx: newDateInput});
						}),
					subMsg,
					$author$project$Components$Membership$Form$Sections$Summary$StartDateInputMsg,
					$author$project$Components$Membership$Form$Sections$Summary$StartDate);
			case 9:
				var subMsg = msg.a;
				return A6(
					$author$project$Components$Membership$Form$Sections$Summary$updateDateInputFormField,
					model,
					function ($) {
						return $.tj;
					},
					F2(
						function (newDateInput, model_) {
							return _Utils_update(
								model_,
								{tj: newDateInput});
						}),
					subMsg,
					$author$project$Components$Membership$Form$Sections$Summary$NextBillDateInputMsg,
					$author$project$Components$Membership$Form$Sections$Summary$NextBillDate);
			case 10:
				var membership = msg.a;
				var _v15 = A5(
					$author$project$Components$BrokerDeal$CreateModal$init,
					apiClient,
					model.aa4,
					model.dd,
					model.J8,
					{
						xF: $elm$core$Maybe$Nothing,
						xG: $elm$core$Maybe$Nothing,
						N7: $author$project$Api$Provider$Practice$One$commissionsTrackingFrom(model.ZV),
						afQ: $elm$core$Maybe$Nothing,
						PT: 1,
						kk: $elm$core$Maybe$Just(membership),
						ak0: false
					});
				var createModal = _v15.a;
				var createModalCmd = _v15.b;
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$Summary$CreateModalMsg, createModalCmd),
					agZ: $author$project$Components$Membership$Form$Sections$Summary$None,
					aiO: _Utils_update(
						model,
						{
							iX: $elm$core$Maybe$Just(
								_Utils_Tuple2(
									$author$project$Api$Provider$Membership$One$id(membership),
									createModal))
						}),
					aR: _List_Nil
				};
			case 11:
				var subMsg = msg.a;
				var _v16 = model.iX;
				if (!_v16.$) {
					var _v17 = _v16.a;
					var membershipId = _v17.a;
					var createModal = _v17.b;
					var createModalResult = A3($author$project$Components$BrokerDeal$CreateModal$update, apiClient, subMsg, createModal);
					var _v18 = function () {
						var _v19 = createModalResult.agZ;
						switch (_v19) {
							case 0:
								return _Utils_Tuple2(
									$elm$core$Maybe$Just(
										_Utils_Tuple2(membershipId, createModalResult.aiO)),
									$elm$core$Platform$Cmd$none);
							case 1:
								return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
							case 2:
								return _Utils_Tuple2(
									$elm$core$Maybe$Nothing,
									A3($author$project$Components$Membership$Form$Sections$Summary$fetchBrokerDeals, apiClient, model.j1, membershipId));
							default:
								return _Utils_Tuple2(
									$elm$core$Maybe$Nothing,
									A3($author$project$Components$Membership$Form$Sections$Summary$fetchBrokerDeals, apiClient, model.j1, membershipId));
						}
					}();
					var createModal_ = _v18.a;
					var cmd = _v18.b;
					return {
						GZ: $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$Summary$CreateModalMsg, createModalResult.GZ),
									cmd
								])),
						agZ: $author$project$Components$Membership$Form$Sections$Summary$None,
						aiO: _Utils_update(
							model,
							{iX: createModal_}),
						aR: createModalResult.aR
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$Membership$Form$Sections$Summary$None, aiO: model, aR: _List_Nil};
				}
			case 12:
				var response = msg.a;
				if (response.$ === 3) {
					var brokerDeals = response.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Membership$Form$Sections$Summary$None,
						aiO: _Utils_update(
							model,
							{
								MR: A2($elm$core$List$map, $author$project$Components$BrokerDeal$BrokerDealRecord$fromProviderAll, brokerDeals)
							}),
						aR: _List_Nil
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: $author$project$Components$Membership$Form$Sections$Summary$None,
						aiO: model,
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			default:
				var subMsg = msg.a;
				var auditTrailLogResult = A3($author$project$Components$AuditTrailLog$update, apiClient, subMsg, model.iw);
				return {
					GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$Summary$AuditTrailLogMsg, auditTrailLogResult.GZ),
					agZ: $author$project$Components$Membership$Form$Sections$Summary$None,
					aiO: _Utils_update(
						model,
						{iw: auditTrailLogResult.aiO}),
					aR: auditTrailLogResult.aR
				};
		}
	});
var $author$project$Api$Provider$Plan$All$contractExpires = function (_v0) {
	var record = _v0.b;
	return record.OB;
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$contractExpires = function (_v0) {
	var record = _v0.b;
	return record.OB;
};
var $author$project$Api$Plan$contractExpires = function (plan) {
	switch (plan.$) {
		case 0:
			return false;
		case 1:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$SharedWithContractInfo$contractExpires(plan_);
		case 4:
			return false;
		case 2:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$All$contractExpires(plan_);
		case 6:
			return false;
		case 3:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$One$contractExpires(plan_);
		default:
			return false;
	}
};
var $author$project$Api$Provider$Plan$All$contractPeriodInMonths = function (_v0) {
	var record = _v0.b;
	return record.OC;
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$contractPeriodInMonths = function (_v0) {
	var record = _v0.b;
	return record.OC;
};
var $author$project$Api$Plan$contractPeriodInMonths = function (plan) {
	switch (plan.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$SharedWithContractInfo$contractPeriodInMonths(plan_);
		case 4:
			return $elm$core$Maybe$Nothing;
		case 2:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$All$contractPeriodInMonths(plan_);
		case 6:
			return $elm$core$Maybe$Nothing;
		case 3:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$One$contractPeriodInMonths(plan_);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$Plan$All$contractType = function (_v0) {
	var record = _v0.b;
	return record.G3;
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$contractType = function (_v0) {
	var record = _v0.b;
	return record.G3;
};
var $author$project$Api$Plan$contractType = function (plan) {
	switch (plan.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$SharedWithContractInfo$contractType(plan_);
		case 4:
			return $elm$core$Maybe$Nothing;
		case 2:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$All$contractType(plan_);
		case 6:
			return $elm$core$Maybe$Nothing;
		case 3:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$One$contractType(plan_);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Membership$Form$Sections$Contracts$resetContractFields = F3(
	function (isNew, newPlan, _v0) {
		var model = _v0;
		if (isNew) {
			var fields = $author$project$Utils$Form$fields(model.SD);
			var newFields = ($author$project$Api$Plan$contractExpires(newPlan) ? function (f) {
				return _Utils_update(
					f,
					{
						sb: $elm$core$Maybe$Nothing,
						Zs: $author$project$Api$Plan$contractPeriodInMonths(newPlan),
						amg: $author$project$Api$Plan$contractType(newPlan)
					});
			} : $elm$core$Basics$identity)(
				_Utils_update(
					fields,
					{
						RZ: $author$project$Api$Plan$contractExpires(newPlan)
					}));
			var editEndDate = $author$project$Api$Plan$contractExpires(newPlan) ? false : model.jv;
			return _Utils_update(
				model,
				{
					jv: editEndDate,
					SD: A2($author$project$Utils$Form$set, newFields, model.SD)
				});
		} else {
			return model;
		}
	});
var $author$project$Components$Membership$Form$Sections$Pricing$FixedPeriodRateInCents = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Membership$Form$Sections$Pricing$FormUpdated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Membership$Form$Sections$Pricing$updateFixedPeriodRateInCents = F3(
	function (newPeriodInMonths, oldPeriodInMonths, _v0) {
		var model = _v0;
		var _v1 = $author$project$Utils$Form$fields(model.SD);
		var fixedPeriodRateInCents = _v1.Sx;
		var _v2 = A2($elm$core$Maybe$andThen, $author$project$Currency$toFloat, fixedPeriodRateInCents);
		if (!_v2.$) {
			var fixedPeriodRateInCents_ = _v2.a;
			var ratio = newPeriodInMonths / oldPeriodInMonths;
			var newFixedPeriodRateInCents = fixedPeriodRateInCents_ * ratio;
			return _Utils_eq(newFixedPeriodRateInCents, fixedPeriodRateInCents_) ? $elm$core$Platform$Cmd$none : A2(
				$elm$core$Task$perform,
				function (_v3) {
					return $author$project$Components$Membership$Form$Sections$Pricing$FormUpdated(
						$author$project$Components$Membership$Form$Sections$Pricing$FixedPeriodRateInCents(
							$elm$core$Maybe$Just(
								$author$project$Currency$fromFloat(newFixedPeriodRateInCents))));
				},
				$elm$core$Process$sleep(0));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$updateStartDates = F3(
	function (startDate, previousStartDate, _v0) {
		var model = _v0;
		var membershipPatientRecord = $author$project$Utils$Form$fields(model.SD);
		var newMembershipPatientRecord = (_Utils_eq(previousStartDate, $elm$core$Maybe$Nothing) || _Utils_eq(membershipPatientRecord.ab7, previousStartDate)) ? _Utils_update(
			membershipPatientRecord,
			{ab7: startDate}) : membershipPatientRecord;
		return _Utils_update(
			model,
			{
				SD: A2($author$project$Utils$Form$set, newMembershipPatientRecord, model.SD)
			});
	});
var $author$project$Components$Membership$Form$Sections$Members$updateMembershipPatientsStartDates = F3(
	function (startDate, previousStartDate, model) {
		var membershipPatients = A2(
			$elm$core$Dict$map,
			F2(
				function (_v0, _v1) {
					var originalIndex = _v1.a;
					var membershipPatientModel = _v1.b;
					var newMembershipPatientModel = A3($author$project$Components$Membership$Form$Members$MembershipPatient$updateStartDates, startDate, previousStartDate, membershipPatientModel);
					return _Utils_Tuple2(originalIndex, newMembershipPatientModel);
				}),
			model.WR);
		return _Utils_update(
			model,
			{WR: membershipPatients});
	});
var $author$project$Components$Membership$Form$updateForm = F6(
	function (apiClient, membership, model, oldSections, section, currentSections) {
		var _v0 = function () {
			_v1$3:
			while (true) {
				if (!section.$) {
					switch (section.a.$) {
						case 1:
							if (!section.a.a.$) {
								var plan = section.a.a.a;
								var newContracts = A3($author$project$Components$Membership$Form$Sections$Contracts$resetContractFields, model.j1, plan, currentSections.a4);
								return _Utils_Tuple2(
									_Utils_update(
										currentSections,
										{a4: newContracts}),
									$elm$core$Platform$Cmd$none);
							} else {
								break _v1$3;
							}
						case 2:
							var startDate = section.a.a;
							var updatedMembers = A3($author$project$Components$Membership$Form$Sections$Members$updateMembershipPatientsStartDates, startDate, $elm$core$Maybe$Nothing, currentSections.N);
							return _Utils_Tuple2(
								_Utils_update(
									currentSections,
									{N: updatedMembers}),
								$elm$core$Platform$Cmd$none);
						case 6:
							var newPeriodInMonths = section.a.a;
							var _v2 = $author$project$Components$Membership$Form$Sections$Summary$summaryFields(oldSections.acF);
							var periodInMonths = _v2.Zs;
							return _Utils_Tuple2(
								currentSections,
								A2(
									$elm$core$Platform$Cmd$map,
									$author$project$Components$Membership$Form$PricingMsg,
									A3($author$project$Components$Membership$Form$Sections$Pricing$updateFixedPeriodRateInCents, newPeriodInMonths, periodInMonths, currentSections._i)));
						default:
							break _v1$3;
					}
				} else {
					break _v1$3;
				}
			}
			return _Utils_Tuple2(currentSections, $elm$core$Platform$Cmd$none);
		}();
		var newSections = _v0.a;
		var newSectionsCmd = _v0.b;
		return A2(
			$elm$core$Tuple$mapSecond,
			function (checkPriceCmd) {
				return $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[newSectionsCmd, checkPriceCmd]));
			},
			A4(
				$author$project$Components$Membership$Form$checkPrice,
				apiClient,
				membership,
				newSections,
				_Utils_update(
					model,
					{
						m: $elm$core$Maybe$Just(newSections)
					})));
	});
var $author$project$Components$Membership$Form$brokerDealForMatching = function (brokerDeal) {
	return {
		xF: {
			ahP: $author$project$Api$Provider$Broker$Shared$id(
				$author$project$Api$Provider$BrokerDeal$One$broker(brokerDeal))
		}
	};
};
var $author$project$Api$Provider$Membership$Shared$isConfirmed = function (_v0) {
	var record = _v0;
	return record.UH;
};
var $author$project$Api$Provider$Membership$One$isConfirmed = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Membership$Shared$isConfirmed(shared);
};
var $author$project$Components$Membership$Form$membershipPatientForMatching = function (membershipPatient) {
	return {
		afo: {
			ahP: A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$CancellationReason$Shared$id,
				$author$project$Api$Provider$MembershipPatient$ForMembershipOne$cancellationReason(membershipPatient))
		},
		sb: $author$project$Api$Provider$MembershipPatient$ForMembershipOne$endDate(membershipPatient),
		RF: $author$project$Api$Provider$MembershipPatient$ForMembershipOne$enrollmentRequestedOn(membershipPatient),
		Sx: $author$project$Api$Provider$MembershipPatient$ForMembershipOne$fixedPeriodRateInCents(membershipPatient),
		ahP: $author$project$Api$Provider$MembershipPatient$ForMembershipOne$id(membershipPatient),
		WN: $author$project$Api$Provider$MembershipPatient$ForMembershipOne$memberType(membershipPatient),
		YY: {
			ahP: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$id(
				$author$project$Api$Provider$MembershipPatient$ForMembershipOne$patient(membershipPatient)),
			amn: false
		},
		abS: {
			ahP: A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$SpecialRate$Min$id,
				$author$project$Api$Provider$MembershipPatient$ForMembershipOne$specialRate(membershipPatient))
		},
		ab7: $author$project$Api$Provider$MembershipPatient$ForMembershipOne$startDate(membershipPatient)
	};
};
var $author$project$Components$Membership$Form$recurringChargeForMatching = function (recurringCharge) {
	return {
		mL: {
			ahP: $author$project$Api$Provider$ChargeItem$ForRecurringCharge$id(
				$author$project$Api$Provider$RecurringCharge$ForMembershipOne$chargeItem(recurringCharge))
		},
		aho: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$fixedDescription(recurringCharge),
		ahp: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$fixedPriceInCents(recurringCharge),
		YY: {
			ahP: $author$project$Api$Provider$Patient$Min$id(
				$author$project$Api$Provider$RecurringCharge$ForMembershipOne$patient(recurringCharge))
		},
		Zs: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$periodInMonths(recurringCharge),
		aj1: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$periodsRemaining(recurringCharge),
		aka: {
			ahP: A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$Practitioner$Min$id,
				$author$project$Api$Provider$RecurringCharge$ForMembershipOne$practitioner(recurringCharge))
		},
		Dz: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$quantity(recurringCharge),
		ab7: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$startDate(recurringCharge)
	};
};
var $author$project$Components$Membership$Form$membershipForMatching = function (membership) {
	return {
		Mk: $author$project$Api$Provider$Membership$One$autoRenew(membership),
		xB: $author$project$Api$Provider$Membership$One$billDate(membership),
		MI: $author$project$Api$Provider$Membership$One$billsAtEndOfPeriod(membership),
		MR: A2(
			$elm$core$List$map,
			$author$project$Components$Membership$Form$brokerDealForMatching,
			$author$project$Api$Provider$Membership$One$brokerDeals(membership)),
		Ob: {
			ahP: A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$CompanyAccount$Shared$id,
				$author$project$Api$Provider$Membership$One$companyAccount(membership))
		},
		yQ: $author$project$Api$Provider$Membership$One$contractEndDate(membership),
		OB: $author$project$Api$Provider$Membership$One$contractExpires(membership),
		OC: $author$project$Api$Provider$Membership$One$contractPeriodInMonths(membership),
		G3: $author$project$Api$Provider$Membership$One$contractType(membership),
		OP: {
			ahP: A2(
				$elm$core$Maybe$map,
				$author$project$Api$Common$Coupon$Shared$id,
				$author$project$Api$Provider$Membership$One$coupon(membership))
		},
		Sx: $author$project$Api$Provider$Membership$One$fixedPeriodRateInCents(membership),
		Sy: $author$project$Api$Provider$Membership$One$fixedRegistrationFeeInCents(membership),
		UH: $author$project$Api$Provider$Membership$One$isConfirmed(membership),
		WR: A2(
			$elm$core$List$map,
			$author$project$Components$Membership$Form$membershipPatientForMatching,
			$author$project$Api$Provider$Membership$One$membershipPatients(membership)),
		Xf: $author$project$Api$Provider$Membership$One$minimumEnrollmentPeriodInMonths(membership),
		XP: $author$project$Api$Provider$Membership$One$nextBillDate(membership),
		YD: {
			ahP: A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$Patient$Shared$id,
				$author$project$Api$Provider$Membership$One$owner(membership))
		},
		Zs: $author$project$Api$Provider$Membership$One$periodInMonths(membership),
		Jb: {
			ahP: $author$project$Api$Provider$Plan$SharedWithContractInfo$id(
				$author$project$Api$Provider$Membership$One$plan(membership))
		},
		$h: A2(
			$elm$core$List$map,
			$author$project$Components$Membership$Form$recurringChargeForMatching,
			$author$project$Api$Provider$Membership$One$recurringCharges(membership)),
		ab7: $author$project$Api$Provider$Membership$One$startDate(membership)
	};
};
var $author$project$Components$Membership$Form$membershipsMatch = F2(
	function (membership, otherMembership) {
		return _Utils_eq(
			$author$project$Components$Membership$Form$membershipForMatching(membership),
			$author$project$Components$Membership$Form$membershipForMatching(otherMembership));
	});
var $author$project$Components$SpecialRate$SpecialRateRecord$fromOne = function (specialRate) {
	return {
		ahP: $author$project$Api$Provider$SpecialRate$Shared$id(specialRate),
		Bq: $author$project$Api$Provider$SpecialRate$Shared$name(specialRate)
	};
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$reconcileSpecialRateAfterPlanChange = F2(
	function (newPlanSpecialRates, _v0) {
		var model = _v0;
		var fields = $author$project$Utils$Form$fields(model.SD);
		var rateToReconcile = model.b2 ? fields.abS : model.Cf.abS;
		if (rateToReconcile.$ === 1) {
			return _Utils_update(
				model,
				{
					SD: A2(
						$author$project$Utils$Form$set,
						_Utils_update(
							fields,
							{abS: $elm$core$Maybe$Nothing}),
						model.SD),
					qk: false
				});
		} else {
			var rateToCheck = rateToReconcile.a;
			var _v2 = A2(
				$elm_community$list_extra$List$Extra$find,
				function (sr) {
					return _Utils_eq(
						$author$project$Api$Provider$SpecialRate$Shared$name(sr),
						rateToCheck.Bq);
				},
				newPlanSpecialRates);
			if (!_v2.$) {
				var matchingSr = _v2.a;
				var newFields = _Utils_update(
					fields,
					{
						abS: $elm$core$Maybe$Just(
							$author$project$Components$SpecialRate$SpecialRateRecord$fromOne(matchingSr))
					});
				return _Utils_update(
					model,
					{
						SD: A2($author$project$Utils$Form$set, newFields, model.SD),
						b2: true,
						qk: false
					});
			} else {
				var newFields = _Utils_update(
					fields,
					{abS: $elm$core$Maybe$Nothing});
				return _Utils_update(
					model,
					{
						SD: A2($author$project$Utils$Form$set, newFields, model.SD),
						b2: false,
						qk: true
					});
			}
		}
	});
var $author$project$Components$Membership$Form$Sections$Members$reconcileSpecialRatesAfterPlanChange = F2(
	function (newPlanSpecialRates, model) {
		return _Utils_update(
			model,
			{
				WR: A2(
					$elm$core$Dict$map,
					F2(
						function (_v0, _v1) {
							var originalIndex = _v1.a;
							var membershipPatientModel = _v1.b;
							return _Utils_Tuple2(
								originalIndex,
								A2($author$project$Components$Membership$Form$Members$MembershipPatient$reconcileSpecialRateAfterPlanChange, newPlanSpecialRates, membershipPatientModel));
						}),
					model.WR)
			});
	});
var $author$project$Components$Membership$Form$Sections$RecurringCharges$updateNextBillDates = F2(
	function (pendingMembership, _v0) {
		var model = _v0;
		var formFields = $author$project$Utils$Form$fields(model.SD);
		var newRecurringCharges = A2(
			$elm$core$List$map,
			function (recurringCharge) {
				var _v1 = recurringCharge.ahP;
				if (!_v1.$) {
					var id = _v1.a;
					var pendingRecurringCharge = A2(
						$elm_community$list_extra$List$Extra$find,
						function (pendingRecurringCharge_) {
							return _Utils_eq(
								$author$project$Api$Provider$RecurringCharge$ForMembershipOne$id(pendingRecurringCharge_),
								$elm$core$Maybe$Just(id));
						},
						$author$project$Api$Provider$Membership$One$recurringCharges(pendingMembership));
					return A2(
						$elm$core$Maybe$withDefault,
						recurringCharge,
						A2(
							$elm$core$Maybe$map,
							function (pendingRecurringCharge_) {
								return _Utils_update(
									recurringCharge,
									{
										XP: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$nextBillDate(pendingRecurringCharge_)
									});
							},
							pendingRecurringCharge));
				} else {
					return recurringCharge;
				}
			},
			formFields.$h);
		var newFormFields = _Utils_update(
			formFields,
			{$h: newRecurringCharges});
		return _Utils_update(
			model,
			{
				SD: A2($author$project$Utils$Form$set, newFormFields, model.SD)
			});
	});
var $author$project$Components$Membership$Form$Sections$Summary$updateStartDate = F3(
	function (pendingMembership, newStartDate, _v0) {
		var model = _v0;
		var membershipMeta = $author$project$Api$Provider$Membership$One$meta(pendingMembership);
		var _v1 = $author$project$Utils$Form$fields(model.SD);
		var startDate = _v1.ab7;
		return (_Utils_eq(
			$elm$core$Maybe$Just(newStartDate),
			startDate) || (!$author$project$Api$Provider$Membership$Meta$startDateEditable(membershipMeta))) ? $elm$core$Platform$Cmd$none : $author$project$Components$Membership$Form$Sections$Summary$asynUpdateForm(
			$author$project$Components$Membership$Form$Sections$Summary$StartDate(
				$elm$core$Maybe$Just(newStartDate)));
	});
var $author$project$Components$Membership$Form$updateFromPriceCheck = F3(
	function (pendingMembership, sections, model) {
		var startDate = $author$project$Api$Provider$Membership$One$startDate(pendingMembership);
		var summaryCmd = A3($author$project$Components$Membership$Form$Sections$Summary$updateStartDate, pendingMembership, startDate, sections.acF);
		var sameAsOriginal = model.j1 ? model.hv : A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$author$project$Components$Membership$Form$membershipsMatch(pendingMembership),
				model.kk));
		var recurringCharges = A2($author$project$Components$Membership$Form$Sections$RecurringCharges$updateNextBillDates, pendingMembership, sections.$h);
		var previousStartDate = A2($elm$core$Maybe$map, $author$project$Api$Provider$Membership$One$startDate, model.dC);
		var newPlanSpecialRates = $author$project$Api$Provider$Plan$SharedWithContractInfo$specialRates(
			$author$project$Api$Provider$Membership$One$plan(pendingMembership));
		var members = A2(
			$author$project$Components$Membership$Form$Sections$Members$reconcileSpecialRatesAfterPlanChange,
			newPlanSpecialRates,
			A3(
				$author$project$Components$Membership$Form$Sections$Members$updateMembershipPatientsStartDates,
				$elm$core$Maybe$Just(startDate),
				previousStartDate,
				sections.N));
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					dC: $elm$core$Maybe$Just(pendingMembership),
					hv: sameAsOriginal,
					m: $elm$core$Maybe$Just(
						_Utils_update(
							sections,
							{N: members, $h: recurringCharges}))
				}),
			A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$SummaryMsg, summaryCmd));
	});
var $author$project$Components$Membership$Form$Sections$Contracts$PeriodInMonthsValidation = 1;
var $author$project$Components$Membership$Form$Sections$Contracts$TypeValidation = 0;
var $author$project$Components$Membership$Form$Sections$Contracts$validateContracts = function (contract) {
	return contract.RZ ? $elm$core$List$concat(
		_List_fromArray(
			[
				_Utils_eq(contract.Zs, $elm$core$Maybe$Nothing) ? _List_fromArray(
				[
					_Utils_Tuple2(1, 'Please enter a number.')
				]) : _List_Nil,
				_Utils_eq(contract.amg, $elm$core$Maybe$Nothing) ? _List_fromArray(
				[
					_Utils_Tuple2(0, 'Please pick an action.')
				]) : _List_Nil
			])) : _List_Nil;
};
var $author$project$Components$Membership$Form$Sections$Contracts$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Membership$Form$Sections$Contracts$validateContracts)
		]));
var $author$project$Components$Membership$Form$Sections$Contracts$validate = F2(
	function (_v0, _v1) {
		var model = _v1;
		var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$Membership$Form$Sections$Contracts$formFieldsValidator, model.SD);
		if (!_v2.$) {
			var _v3 = _v2.a;
			var newForm = _v3.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{SD: newForm}),
				true);
		} else {
			var newForm = _v2.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{SD: newForm}),
				false);
		}
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$CancellationReasonOtherValidation = 8;
var $author$project$Components$Membership$Form$Members$MembershipPatient$CancellationReasonValidation = 7;
var $author$project$Components$Membership$Form$Members$MembershipPatient$PatientValidation = 0;
var $author$project$Components$Membership$Form$Members$MembershipPatient$EndDateValidation = 6;
var $author$project$Api$Provider$Membership$Shared$billFromDate = function (_v0) {
	var record = _v0;
	return record.MD;
};
var $author$project$Api$Provider$Membership$One$billFromDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Membership$Shared$billFromDate(shared);
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$validateEndDate = F2(
	function (_v0, fields) {
		var pendingMembership = _v0.dC;
		var min = fields.ab7;
		var max = $author$project$Api$Provider$Membership$One$isSponsored(pendingMembership) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			A3(
				$justinmimbs$date$Date$add,
				3,
				1,
				$author$project$Api$Provider$Membership$One$billFromDate(pendingMembership)));
		return A2(
			$author$project$Utils$Validate$isOutsideDateRange,
			{aeU: false, AU: max, W9: min},
			fields.sb) ? _List_fromArray(
			[
				_Utils_Tuple2(6, 'Please pick an option.')
			]) : _List_Nil;
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$EnrollmentRequestedOnValidation = 2;
var $author$project$Components$Membership$Form$Members$MembershipPatient$validateEnrollmentRequestedOn = F2(
	function (_v0, fields) {
		var editEnrollmentRequestedOn = _v0.r4;
		var _v1 = _Utils_Tuple2(editEnrollmentRequestedOn, fields.RF);
		if (_v1.a) {
			if (!_v1.b.$) {
				return _List_Nil;
			} else {
				var _v2 = _v1.b;
				return _List_fromArray(
					[
						_Utils_Tuple2(2, 'Please pick a date.')
					]);
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$FixedPeriodRateInCentsValidation = 5;
var $author$project$Components$Membership$Form$Members$MembershipPatient$validateFixedPeriodRateInCents = F2(
	function (model, fields) {
		if (model.es) {
			var min = 0;
			var max = 999999999;
			return A2(
				$author$project$Utils$Validate$isInvalidCurrency,
				{
					aeU: false,
					AU: $elm$core$Maybe$Just(max),
					W9: $elm$core$Maybe$Just(min)
				},
				fields.Sx) ? _List_fromArray(
				[
					_Utils_Tuple2(
					5,
					'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + $author$project$Utils$Currency$fromInt(max))))
				]) : _List_Nil;
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$PatientUsesTobaccoValidation = 1;
var $author$project$Components$Membership$Form$Members$MembershipPatient$validatePatientUsesTobacco = F3(
	function (_v0, model, fields) {
		var pendingMembership = _v0.dC;
		var showTobaccoUsage = A2($author$project$Api$Provider$Practice$One$featureEnabled, 2, model.ZV) && $author$project$Utils$Maybe$toBool(
			$author$project$Api$Provider$Plan$SharedWithContractInfo$tobaccoSurchargeType(
				$author$project$Api$Provider$Membership$One$plan(pendingMembership)));
		var _v1 = _Utils_Tuple2(showTobaccoUsage && model.et, fields.YY);
		if (_v1.a && (!_v1.b.$)) {
			var patient = _v1.b.a;
			return _Utils_eq(patient.ad9, $elm$core$Maybe$Nothing) ? _List_fromArray(
				[
					_Utils_Tuple2(1, 'Please pick an option.')
				]) : _List_Nil;
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$SpecialRateValidation = 4;
var $author$project$Components$Membership$Form$Members$MembershipPatient$validateSetSpecialRate = F2(
	function (model, fields) {
		return model.b2 ? (_Utils_eq(fields.abS, $elm$core$Maybe$Nothing) ? _List_fromArray(
			[
				_Utils_Tuple2(4, 'Please pick a rate.')
			]) : _List_Nil) : _List_Nil;
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$StartDateValidation = 3;
var $author$project$Components$Membership$Form$Members$MembershipPatient$validateStartDate = F3(
	function (_v0, _v1, fields) {
		var pendingMembership = _v0.dC;
		var editStartDate = _v1.r5;
		var _v2 = _Utils_Tuple2(editStartDate, fields.ab7);
		if (_v2.a) {
			if (!_v2.b.$) {
				var startDate = _v2.b.a;
				var min = $author$project$Api$Provider$Membership$One$startDate(pendingMembership);
				var max = A2(
					$elm$core$Maybe$withDefault,
					$author$project$Api$Provider$Membership$One$billFromDate(pendingMembership),
					fields.St);
				return (A2($author$project$Utils$Date$isBefore, startDate, min) || A2($author$project$Utils$Date$isAfter, startDate, max)) ? _List_fromArray(
					[
						_Utils_Tuple2(
						3,
						'Please pick a date between ' + (A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, min) + (' and ' + (A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, max) + '.'))))
					]) : _List_Nil;
			} else {
				var _v3 = _v2.b;
				return _List_fromArray(
					[
						_Utils_Tuple2(3, 'Please pick a date.')
					]);
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$formFieldsValidator = F2(
	function (sectionsShared, model) {
		return $rtfeldman$elm_validate$Validate$all(
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_validate$Validate$ifNothing,
					function ($) {
						return $.YY;
					},
					_Utils_Tuple2(0, 'Please pick a patient.')),
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_validate$Validate$fromErrors(
						$author$project$Components$Membership$Form$Members$MembershipPatient$validateEnrollmentRequestedOn(model)),
					A2(
						$elm$core$List$cons,
						$rtfeldman$elm_validate$Validate$fromErrors(
							A2($author$project$Components$Membership$Form$Members$MembershipPatient$validateStartDate, sectionsShared, model)),
						A2(
							$elm$core$List$cons,
							$rtfeldman$elm_validate$Validate$fromErrors(
								A2($author$project$Components$Membership$Form$Members$MembershipPatient$validatePatientUsesTobacco, sectionsShared, model)),
							A2(
								$elm$core$List$cons,
								$rtfeldman$elm_validate$Validate$fromErrors(
									$author$project$Components$Membership$Form$Members$MembershipPatient$validateFixedPeriodRateInCents(model)),
								A2(
									$elm$core$List$cons,
									$rtfeldman$elm_validate$Validate$fromErrors(
										$author$project$Components$Membership$Form$Members$MembershipPatient$validateSetSpecialRate(model)),
									model.bf ? _List_fromArray(
										[
											$rtfeldman$elm_validate$Validate$fromErrors(
											$author$project$Components$Membership$Form$Members$MembershipPatient$validateEndDate(sectionsShared)),
											$rtfeldman$elm_validate$Validate$fromErrors(
											A2($author$project$Components$CancellationReason$Input$validate, 7, 8))
										]) : _List_Nil)))))));
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$validate = F2(
	function (sectionsShared, _v0) {
		var model = _v0;
		var _v1 = A2(
			$author$project$Utils$Form$validate,
			A2($author$project$Components$Membership$Form$Members$MembershipPatient$formFieldsValidator, sectionsShared, model),
			model.SD);
		if (!_v1.$) {
			var _v2 = _v1.a;
			var newForm = _v2.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{SD: newForm}),
				true);
		} else {
			var newForm = _v1.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{SD: newForm}),
				false);
		}
	});
var $author$project$Components$Membership$Form$Sections$Members$validate = F2(
	function (sectionsShared, model) {
		var membershipPatientsWithValid = A2(
			$elm$core$Dict$map,
			F2(
				function (_v3, _v4) {
					var membershipPatientModel = _v4.b;
					return A2($author$project$Components$Membership$Form$Members$MembershipPatient$validate, sectionsShared, membershipPatientModel);
				}),
			model.WR);
		var valid = A2(
			$elm$core$List$all,
			$elm$core$Tuple$second,
			$elm$core$Dict$values(membershipPatientsWithValid));
		var membershipPatients = A2(
			$elm$core$Dict$map,
			F2(
				function (id, _v0) {
					var originalIndex = _v0.a;
					var membershipPatientModel = _v0.b;
					var _v1 = A2($elm$core$Dict$get, id, membershipPatientsWithValid);
					if (!_v1.$) {
						var _v2 = _v1.a;
						var newMembershipPatientModel = _v2.a;
						return _Utils_Tuple2(originalIndex, newMembershipPatientModel);
					} else {
						return _Utils_Tuple2(originalIndex, membershipPatientModel);
					}
				}),
			model.WR);
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{WR: membershipPatients}),
			valid);
	});
var $author$project$Components$Membership$Form$Sections$Pricing$FixedPeriodRateInCentsValidation = 0;
var $author$project$Components$Membership$Form$Sections$Pricing$FixedRegistrationFeeInCentsValidation = 1;
var $author$project$Components$Membership$Form$Sections$Pricing$validatePricing = function (pricing) {
	return $elm$core$List$concat(
		_List_fromArray(
			[
				A2(
				$author$project$Utils$Validate$isInvalidCurrency,
				{
					aeU: !pricing.cK._1,
					AU: $elm$core$Maybe$Nothing,
					W9: $elm$core$Maybe$Just(0)
				},
				pricing.Sx) ? _List_fromArray(
				[
					_Utils_Tuple2(0, 'Please enter a valid amount.')
				]) : _List_Nil,
				A2(
				$author$project$Utils$Validate$isInvalidCurrency,
				{
					aeU: !pricing.cK.e1,
					AU: $elm$core$Maybe$Nothing,
					W9: $elm$core$Maybe$Just(0)
				},
				pricing.Sy) ? _List_fromArray(
				[
					_Utils_Tuple2(1, 'Please enter a valid amount.')
				]) : _List_Nil
			]));
};
var $author$project$Components$Membership$Form$Sections$Pricing$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Membership$Form$Sections$Pricing$validatePricing)
		]));
var $author$project$Components$Membership$Form$Sections$Pricing$validate = F2(
	function (_v0, _v1) {
		var model = _v1;
		var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$Membership$Form$Sections$Pricing$formFieldsValidator, model.SD);
		if (!_v2.$) {
			var _v3 = _v2.a;
			var newForm = _v3.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{SD: newForm}),
				true);
		} else {
			var newForm = _v2.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{SD: newForm}),
				false);
		}
	});
var $author$project$Components$Membership$Form$Sections$RecurringCharges$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_Nil);
var $author$project$Components$Membership$Form$Sections$RecurringCharges$validate = F2(
	function (_v0, _v1) {
		var model = _v1;
		var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$Membership$Form$Sections$RecurringCharges$formFieldsValidator, model.SD);
		if (!_v2.$) {
			var _v3 = _v2.a;
			var newForm = _v3.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{SD: newForm}),
				true);
		} else {
			var newForm = _v2.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{SD: newForm}),
				false);
		}
	});
var $author$project$Components$Membership$Form$Sections$Summary$NextBillDateValidation = 3;
var $author$project$Components$Membership$Form$Sections$Summary$OwnerValidation = 0;
var $author$project$Components$Membership$Form$Sections$Summary$PlanValidation = 1;
var $author$project$Components$Membership$Form$Sections$Summary$StartDateValidation = 2;
var $author$project$Api$Provider$Membership$Meta$billDateMin = function (_v0) {
	var meta = _v0;
	return meta.xB.W9;
};
var $author$project$Api$Provider$Membership$Meta$nextBillDateMax = function (_v0) {
	var meta = _v0;
	return meta.XP.AU;
};
var $author$project$Api$Provider$Membership$Meta$nextBillDateMin = function (_v0) {
	var meta = _v0;
	return meta.XP.W9;
};
var $author$project$Api$Provider$Membership$Meta$startDateMax = function (_v0) {
	var meta = _v0;
	return meta.ab7.AU;
};
var $author$project$Api$Provider$Membership$Meta$startDateMin = function (_v0) {
	var meta = _v0;
	return meta.ab7.W9;
};
var $author$project$Components$Membership$Form$Sections$Summary$validateSummary = F3(
	function (pendingMembership, show, summary) {
		var membershipMeta = $author$project$Api$Provider$Membership$One$meta(pendingMembership);
		return $elm$core$List$concat(
			_List_fromArray(
				[
					_Utils_eq(summary.YD, $elm$core$Maybe$Nothing) ? _List_fromArray(
					[
						_Utils_Tuple2(0, 'Please pick an owner.')
					]) : _List_Nil,
					_Utils_eq(summary.Jb, $elm$core$Maybe$Nothing) ? _List_fromArray(
					[
						_Utils_Tuple2(1, 'Please select a plan.')
					]) : _List_Nil,
					function () {
					var _v0 = _Utils_Tuple2(
						$author$project$Api$Provider$Membership$Meta$startDateEditable(membershipMeta),
						summary.ab7);
					if (!_v0.a) {
						return _List_Nil;
					} else {
						if (_v0.b.$ === 1) {
							var _v1 = _v0.b;
							return _List_fromArray(
								[
									_Utils_Tuple2(2, 'Please enter a valid date.')
								]);
						} else {
							var startDate = _v0.b.a;
							var pendingMembershipMeta = $author$project$Api$Provider$Membership$One$meta(pendingMembership);
							var min = $author$project$Api$Provider$Membership$Meta$startDateMin(pendingMembershipMeta);
							if (!A2($justinmimbs$date$Date$compare, startDate, min)) {
								return _List_fromArray(
									[
										_Utils_Tuple2(
										2,
										'A membership cannot be started before ' + (A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, min) + '.'))
									]);
							} else {
								var max = A2(
									$elm$core$Maybe$withDefault,
									startDate,
									$author$project$Api$Provider$Membership$Meta$startDateMax(pendingMembershipMeta));
								return (A2($justinmimbs$date$Date$compare, startDate, max) === 2) ? _List_fromArray(
									[
										_Utils_Tuple2(2, 'A membership cannot be started after the first bill.')
									]) : _List_Nil;
							}
						}
					}
				}(),
					function () {
					var _v2 = _Utils_Tuple2(show.XP, summary.XP);
					if (!_v2.a) {
						return _List_Nil;
					} else {
						if (_v2.b.$ === 1) {
							var _v3 = _v2.b;
							return _List_fromArray(
								[
									_Utils_Tuple2(3, 'Please enter a valid date.')
								]);
						} else {
							var nextBillDate = _v2.b.a;
							var pendingMembershipMeta = $author$project$Api$Provider$Membership$One$meta(pendingMembership);
							var nextBillDateMin = A2(
								$elm$core$Maybe$withDefault,
								nextBillDate,
								$author$project$Api$Provider$Membership$Meta$nextBillDateMin(pendingMembershipMeta));
							var nextBillDateMax = A2(
								$elm$core$Maybe$withDefault,
								nextBillDate,
								$author$project$Api$Provider$Membership$Meta$nextBillDateMax(pendingMembershipMeta));
							var billDateMin = $author$project$Api$Provider$Membership$Meta$billDateMin(pendingMembershipMeta);
							return $elm$core$List$concat(
								_List_fromArray(
									[
										(summary.ff && (!A2($justinmimbs$date$Date$compare, nextBillDate, nextBillDateMin))) ? _List_fromArray(
										[
											_Utils_Tuple2(
											3,
											'Must change all bills for dates before ' + (A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, nextBillDateMin) + '.'))
										]) : _List_Nil,
										(summary.ff && (A2($justinmimbs$date$Date$compare, nextBillDate, nextBillDateMax) === 2)) ? _List_fromArray(
										[
											_Utils_Tuple2(
											3,
											'Must change all bills for dates after ' + (A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, nextBillDateMax) + '.'))
										]) : _List_Nil,
										(summary.ff && (!A2($justinmimbs$date$Date$compare, nextBillDate, billDateMin))) ? _List_fromArray(
										[
											_Utils_Tuple2(
											3,
											'Bill date cannot be set before ' + (A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, billDateMin) + '.'))
										]) : _List_Nil,
										((!summary.ff) && (!A2($justinmimbs$date$Date$compare, nextBillDate, nextBillDateMin))) ? _List_fromArray(
										[
											_Utils_Tuple2(
											3,
											'Next bill date cannot be set before ' + (A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, nextBillDateMin) + '.'))
										]) : _List_Nil,
										(A2($justinmimbs$date$Date$compare, nextBillDate, nextBillDateMax) === 2) ? _List_fromArray(
										[
											_Utils_Tuple2(
											3,
											'Next bill date cannot be set after ' + (A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, nextBillDateMax) + '.'))
										]) : _List_Nil
									]));
						}
					}
				}()
				]));
	});
var $author$project$Components$Membership$Form$Sections$Summary$formFieldsValidator = F2(
	function (pendingMembership, show) {
		return $rtfeldman$elm_validate$Validate$all(
			_List_fromArray(
				[
					$rtfeldman$elm_validate$Validate$fromErrors(
					A2($author$project$Components$Membership$Form$Sections$Summary$validateSummary, pendingMembership, show))
				]));
	});
var $author$project$Components$Membership$Form$Sections$Summary$validate = F2(
	function (_v0, _v1) {
		var pendingMembership = _v0.dC;
		var model = _v1;
		var _v2 = A2(
			$author$project$Utils$Form$validate,
			A2($author$project$Components$Membership$Form$Sections$Summary$formFieldsValidator, pendingMembership, model.p0),
			model.SD);
		if (!_v2.$) {
			var _v3 = _v2.a;
			var newForm = _v3.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{SD: newForm}),
				true);
		} else {
			var newForm = _v2.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{SD: newForm}),
				false);
		}
	});
var $author$project$Components$Membership$Form$validateSections = F2(
	function (sectionsShared, sections) {
		var _v0 = A2($author$project$Components$Membership$Form$Sections$Summary$validate, sectionsShared, sections.acF);
		var summary = _v0.a;
		var summaryIsValid = _v0.b;
		var _v1 = A2($author$project$Components$Membership$Form$Sections$RecurringCharges$validate, sectionsShared, sections.$h);
		var recurringCharges = _v1.a;
		var recurringChargesIsValid = _v1.b;
		var _v2 = A2($author$project$Components$Membership$Form$Sections$Pricing$validate, sectionsShared, sections._i);
		var pricing = _v2.a;
		var pricingIsValid = _v2.b;
		var _v3 = A2($author$project$Components$Membership$Form$Sections$Members$validate, sectionsShared, sections.N);
		var members = _v3.a;
		var membersIsValid = _v3.b;
		var _v4 = A2($author$project$Components$Membership$Form$Sections$Contracts$validate, sectionsShared, sections.a4);
		var contracts = _v4.a;
		var contractsIsValid = _v4.b;
		return _Utils_Tuple2(
			summaryIsValid && (membersIsValid && (pricingIsValid && (recurringChargesIsValid && contractsIsValid))),
			_Utils_update(
				sections,
				{a4: contracts, N: members, _i: pricing, $h: recurringCharges, acF: summary}));
	});
var $author$project$Components$Membership$Form$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var membership = response.a;
					return A2(
						$author$project$Utils$Tuple3$fromTuple2,
						_List_Nil,
						A3($author$project$Components$Membership$Form$setupMembershipOnScope, apiClient, membership, model));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var response = msg.a;
				var _v2 = model.m;
				if (!_v2.$) {
					var sections = _v2.a;
					var _v3 = function () {
						if (response.$ === 3) {
							var membership = response.a;
							return A3(
								$author$project$Components$Membership$Form$updateFromPriceCheck,
								membership,
								sections,
								_Utils_update(
									model,
									{hm: response}));
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{hm: response}),
								$elm$core$Platform$Cmd$none);
						}
					}();
					var newModel = _v3.a;
					var cmd = _v3.b;
					return _Utils_Tuple3(
						newModel,
						cmd,
						$author$project$OutMsg$handleErrorResponse(response));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				var debounceMsg = msg.a;
				var _v5 = A4(
					$jinjor$elm_debounce$Debounce$update,
					$author$project$Components$Membership$Form$priceCheckDebounceConfig,
					$jinjor$elm_debounce$Debounce$takeLast($author$project$Components$Membership$Form$debouncePriceCheck),
					debounceMsg,
					model.eX);
				var newDebouncer = _v5.a;
				var cmd = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{eX: newDebouncer}),
					cmd,
					_List_Nil);
			case 3:
				var cmd = msg.a;
				return _Utils_Tuple3(model, cmd, _List_Nil);
			case 4:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{afq: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 5:
				var billNow = msg.a;
				if ($author$project$Components$Membership$Form$isBusy(model)) {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				} else {
					var _v6 = _Utils_Tuple3(model.m, model.kk, model.dC);
					if (((!_v6.a.$) && (!_v6.b.$)) && (!_v6.c.$)) {
						var sections = _v6.a.a;
						var membership = _v6.b.a;
						var pendingMembership = _v6.c.a;
						var shared = A5($author$project$Components$Membership$Form$initSectionsShared, model.YY, membership, pendingMembership, sections, model);
						var _v7 = A2($author$project$Components$Membership$Form$validateSections, shared, sections);
						if (_v7.a) {
							var newSections = _v7.b;
							var saveCmd = A5($author$project$Components$Membership$Form$saveItem, apiClient, model.ahP, membership, newSections, billNow);
							var plan = $author$project$Api$Provider$Membership$One$plan(pendingMembership);
							var _v8 = A2($author$project$Components$Membership$Form$patientsOutsideAgeRange, plan, newSections);
							var belowAgePatients = _v8.a;
							var aboveAgePatients = _v8.b;
							var _v9 = (($elm$core$List$length(belowAgePatients) > 0) || ($elm$core$List$length(aboveAgePatients) > 0)) ? _Utils_Tuple3(
								$elm$core$Platform$Cmd$none,
								$author$project$Api$Data$NotAsked,
								$elm$core$Maybe$Just(
									_Utils_Tuple2(
										A4(
											$author$project$Components$Membership$Form$OutsideAgeRangeModal$init,
											$author$project$Api$Provider$Plan$SharedWithContractInfo$minimumAge(plan),
											$author$project$Api$Provider$Plan$SharedWithContractInfo$maximumAge(plan),
											belowAgePatients,
											aboveAgePatients),
										saveCmd))) : _Utils_Tuple3(saveCmd, $author$project$Api$Data$Loading, $elm$core$Maybe$Nothing);
							var cmd = _v9.a;
							var saveRequest = _v9.b;
							var outsideAgeRangeModal = _v9.c;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										g3: outsideAgeRangeModal,
										k9: saveRequest,
										m: $elm$core$Maybe$Just(newSections)
									}),
								cmd,
								_List_Nil);
						} else {
							var newSections = _v7.b;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										k9: $author$project$Api$Data$NotAsked,
										m: $elm$core$Maybe$Just(newSections)
									}),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
						}
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				}
			case 6:
				var confirmed = msg.a;
				var _v10 = model.g3;
				if (!_v10.$) {
					var _v11 = _v10.a;
					var saveCmd = _v11.b;
					return (confirmed && (!$author$project$Components$Membership$Form$isBusy(model))) ? _Utils_Tuple3(
						_Utils_update(
							model,
							{g3: $elm$core$Maybe$Nothing, k9: $author$project$Api$Data$Loading}),
						saveCmd,
						_List_Nil) : _Utils_Tuple3(
						_Utils_update(
							model,
							{g3: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var response = msg.a;
				var _v12 = model.m;
				if (!_v12.$) {
					if (response.$ === 3) {
						var membership = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{k9: response}),
							A2(
								$author$project$Utils$Route$navigate,
								$elm$core$Dict$empty,
								$author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__MembershipId_String__Top(
									{
										AW: $author$project$Api$Provider$Membership$One$id(membership),
										YZ: $author$project$Api$Provider$Patient$One$id(model.YY)
									})),
							_List_fromArray(
								[
									$author$project$OutMsg$RetrievePatient(
									$author$project$Api$Provider$Patient$One$id(model.YY)),
									A2($author$project$OutMsg$ShowToast, 3, 'Membership successfully started')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{k9: response}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 8:
				var response = msg.a;
				var _v14 = model.m;
				if (!_v14.$) {
					if (response.$ === 3) {
						var membership = response.a;
						return A2(
							$author$project$Utils$Tuple3$fromTuple2,
							_List_fromArray(
								[
									$author$project$OutMsg$RetrievePatient(
									$author$project$Api$Provider$Patient$One$id(model.YY)),
									A2($author$project$OutMsg$ShowToast, 3, 'Membership successfully updated')
								]),
							A3(
								$author$project$Components$Membership$Form$setupMembershipOnScope,
								apiClient,
								membership,
								_Utils_update(
									model,
									{k9: response})));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{k9: response}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var membership = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{k9: $author$project$Api$Data$Loading}),
					A3(
						$author$project$Api$Provider$Membership$confirm,
						apiClient,
						$author$project$Api$Provider$Membership$One$id(membership),
						$author$project$Components$Membership$Form$Confirmed),
					_List_Nil);
			case 10:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: response}),
						A2(
							$author$project$Utils$Route$navigate,
							$elm$core$Dict$empty,
							$author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__Top(
								{
									YZ: $author$project$Api$Provider$Patient$One$id(model.YY)
								})),
						_List_fromArray(
							[
								$author$project$OutMsg$RetrievePatient(
								$author$project$Api$Provider$Patient$One$id(model.YY)),
								A2($author$project$OutMsg$ShowToast, 3, 'Membership successfully confirmed')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 11:
				var membership = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							f7: $elm$core$Maybe$Just(
								_Utils_Tuple2(membership, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 12:
				var membership = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							f7: $elm$core$Maybe$Just(
								_Utils_Tuple2(membership, $author$project$Api$Data$Loading))
						}),
					A3(
						$author$project$Api$Provider$Membership$delete,
						apiClient,
						$author$project$Api$Provider$Membership$One$id(membership),
						$author$project$Components$Membership$Form$Deleted(membership)),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{f7: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 13:
				var membership = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						A2(
							$author$project$Utils$Route$navigate,
							$elm$core$Dict$empty,
							$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
								{
									YZ: $author$project$Api$Provider$Patient$One$id(model.YY)
								})),
						_List_fromArray(
							[
								$author$project$OutMsg$RetrievePatient(
								$author$project$Api$Provider$Patient$One$id(model.YY)),
								A2($author$project$OutMsg$ShowToast, 3, 'Membership successfully deleted')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								f7: $elm$core$Maybe$Just(
									_Utils_Tuple2(membership, response))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 14:
				var membership = msg.a;
				var _v18 = A2($author$project$Components$Membership$Form$CancelModal$init, model.dd, membership);
				var cancelModal = _v18.a;
				var cancelModalCmd = _v18.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							d$: $elm$core$Maybe$Just(cancelModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$CancelModalMsg, cancelModalCmd),
					_List_Nil);
			case 15:
				var subMsg = msg.a;
				var _v19 = model.d$;
				if (!_v19.$) {
					var cancelModal = _v19.a;
					var cancelModalResult = A3($author$project$Components$Membership$Form$CancelModal$update, apiClient, subMsg, cancelModal);
					var _v20 = function () {
						var _v21 = cancelModalResult.agZ;
						switch (_v21.$) {
							case 0:
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											d$: $elm$core$Maybe$Just(cancelModalResult.aiO)
										}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							case 1:
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{d$: $elm$core$Maybe$Nothing}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							default:
								var membership = _v21.a;
								return A2(
									$author$project$Utils$Tuple3$fromTuple2,
									_List_Nil,
									A3(
										$author$project$Components$Membership$Form$setupMembershipOnScope,
										apiClient,
										membership,
										_Utils_update(
											model,
											{d$: $elm$core$Maybe$Nothing})));
						}
					}();
					var newModel = _v20.a;
					var cmd = _v20.b;
					var outMsgs = _v20.c;
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$CancelModalMsg, cancelModalResult.GZ),
									cmd
								])),
						_Utils_ap(cancelModalResult.aR, outMsgs));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 16:
				var membership = msg.a;
				var _v22 = A4($author$project$Components$Membership$Form$RestartModal$init, apiClient, model.dd, $elm$core$Maybe$Nothing, membership);
				var restartModal = _v22.a;
				var restartModalCmd = _v22.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							k0: $elm$core$Maybe$Just(restartModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$RestartModalMsg, restartModalCmd),
					_List_Nil);
			case 17:
				var subMsg = msg.a;
				var _v23 = model.k0;
				if (!_v23.$) {
					var restartModal = _v23.a;
					var restartModalResult = A3($author$project$Components$Membership$Form$RestartModal$update, apiClient, subMsg, restartModal);
					var _v24 = function () {
						var _v25 = restartModalResult.agZ;
						switch (_v25.$) {
							case 0:
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											k0: $elm$core$Maybe$Just(restartModalResult.aiO)
										}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							case 1:
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{k0: $elm$core$Maybe$Nothing}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							default:
								var membership = _v25.a;
								return A2(
									$author$project$Utils$Tuple3$fromTuple2,
									_List_Nil,
									A3(
										$author$project$Components$Membership$Form$setupMembershipOnScope,
										apiClient,
										membership,
										_Utils_update(
											model,
											{k0: $elm$core$Maybe$Nothing})));
						}
					}();
					var newModel = _v24.a;
					var cmd = _v24.b;
					var outMsgs = _v24.c;
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$RestartModalMsg, restartModalResult.GZ),
									cmd
								])),
						_Utils_ap(restartModalResult.aR, outMsgs));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 18:
				var subMsg = msg.a;
				var _v26 = _Utils_Tuple3(model.kk, model.dC, model.m);
				if (((!_v26.a.$) && (!_v26.b.$)) && (!_v26.c.$)) {
					var membership = _v26.a.a;
					var pendingMembership = _v26.b.a;
					var sections = _v26.c.a;
					var shared = A5($author$project$Components$Membership$Form$initSectionsShared, model.YY, membership, pendingMembership, sections, model);
					var summaryResult = A4($author$project$Components$Membership$Form$Sections$Summary$update, apiClient, shared, subMsg, sections.acF);
					var newSections = _Utils_update(
						sections,
						{acF: summaryResult.aiO});
					var _v27 = function () {
						var _v28 = summaryResult.agZ;
						if (!_v28.$) {
							return _Utils_Tuple2(
								$elm$core$Platform$Cmd$none,
								_Utils_update(
									model,
									{
										m: $elm$core$Maybe$Just(newSections)
									}));
						} else {
							var summaryField = _v28.a;
							var _v29 = A6(
								$author$project$Components$Membership$Form$updateForm,
								apiClient,
								membership,
								model,
								sections,
								$author$project$Components$Membership$Form$Summary(summaryField),
								newSections);
							var newModel = _v29.a;
							var formCmd = _v29.b;
							return _Utils_Tuple2(formCmd, newModel);
						}
					}();
					var cmd = _v27.a;
					var newModel_ = _v27.b;
					return _Utils_Tuple3(
						newModel_,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$SummaryMsg, summaryResult.GZ),
									cmd
								])),
						summaryResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 19:
				var subMsg = msg.a;
				var _v30 = _Utils_Tuple2(model.kk, model.m);
				if ((!_v30.a.$) && (!_v30.b.$)) {
					var membership = _v30.a.a;
					var sections = _v30.b.a;
					var membersResult = A3($author$project$Components$Membership$Form$Sections$Members$update, apiClient, subMsg, sections.N);
					var newSections = _Utils_update(
						sections,
						{N: membersResult.aiO});
					var _v31 = function () {
						var _v32 = membersResult.agZ;
						if (!_v32) {
							return _Utils_Tuple2(
								$elm$core$Platform$Cmd$none,
								_Utils_update(
									model,
									{
										m: $elm$core$Maybe$Just(newSections)
									}));
						} else {
							var _v33 = A6($author$project$Components$Membership$Form$updateForm, apiClient, membership, model, sections, $author$project$Components$Membership$Form$Members, newSections);
							var newModel = _v33.a;
							var formCmd = _v33.b;
							return _Utils_Tuple2(formCmd, newModel);
						}
					}();
					var cmd = _v31.a;
					var newModel_ = _v31.b;
					return _Utils_Tuple3(
						newModel_,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$MembersMsg, membersResult.GZ),
									cmd
								])),
						membersResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 20:
				var subMsg = msg.a;
				var _v34 = _Utils_Tuple2(model.kk, model.m);
				if ((!_v34.a.$) && (!_v34.b.$)) {
					var membership = _v34.a.a;
					var sections = _v34.b.a;
					var pricingResult = A2($author$project$Components$Membership$Form$Sections$Pricing$update, subMsg, sections._i);
					var newSections = _Utils_update(
						sections,
						{_i: pricingResult.aiO});
					var _v35 = function () {
						var _v36 = pricingResult.agZ;
						if (!_v36) {
							return _Utils_Tuple2(
								$elm$core$Platform$Cmd$none,
								_Utils_update(
									model,
									{
										m: $elm$core$Maybe$Just(newSections)
									}));
						} else {
							var _v37 = A6($author$project$Components$Membership$Form$updateForm, apiClient, membership, model, sections, $author$project$Components$Membership$Form$Pricing, newSections);
							var newModel = _v37.a;
							var formCmd = _v37.b;
							return _Utils_Tuple2(formCmd, newModel);
						}
					}();
					var cmd = _v35.a;
					var newModel_ = _v35.b;
					return _Utils_Tuple3(
						newModel_,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$PricingMsg, pricingResult.GZ),
									cmd
								])),
						pricingResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 21:
				var subMsg = msg.a;
				var _v38 = _Utils_Tuple2(model.kk, model.m);
				if ((!_v38.a.$) && (!_v38.b.$)) {
					var membership = _v38.a.a;
					var sections = _v38.b.a;
					var contractsResult = A3($author$project$Components$Membership$Form$Sections$Contracts$update, apiClient, subMsg, sections.a4);
					var newSections = _Utils_update(
						sections,
						{a4: contractsResult.aiO});
					var _v39 = function () {
						var _v40 = contractsResult.agZ;
						switch (_v40) {
							case 0:
								return _Utils_Tuple2(
									$elm$core$Platform$Cmd$none,
									_Utils_update(
										model,
										{
											m: $elm$core$Maybe$Just(newSections)
										}));
							case 1:
								return _Utils_Tuple2(
									A2(
										$author$project$Components$Membership$Form$retrieveItem,
										apiClient,
										A2($elm$core$Maybe$withDefault, '', model.ahP)),
									model);
							default:
								var _v41 = A6($author$project$Components$Membership$Form$updateForm, apiClient, membership, model, sections, $author$project$Components$Membership$Form$Contract, newSections);
								var newModel = _v41.a;
								var formCmd = _v41.b;
								return _Utils_Tuple2(formCmd, newModel);
						}
					}();
					var cmd = _v39.a;
					var newModel_ = _v39.b;
					return _Utils_Tuple3(
						newModel_,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$ContractsMsg, contractsResult.GZ),
									cmd
								])),
						contractsResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 22:
				var subMsg = msg.a;
				var _v42 = _Utils_Tuple2(model.kk, model.m);
				if ((!_v42.a.$) && (!_v42.b.$)) {
					var membership = _v42.a.a;
					var sections = _v42.b.a;
					var recurringChargesResult = A3($author$project$Components$Membership$Form$Sections$RecurringCharges$update, apiClient, subMsg, sections.$h);
					var newSections = _Utils_update(
						sections,
						{$h: recurringChargesResult.aiO});
					var _v43 = function () {
						var _v44 = recurringChargesResult.agZ;
						if (!_v44) {
							return _Utils_Tuple2(
								$elm$core$Platform$Cmd$none,
								_Utils_update(
									model,
									{
										m: $elm$core$Maybe$Just(newSections)
									}));
						} else {
							var _v45 = A6($author$project$Components$Membership$Form$updateForm, apiClient, membership, model, sections, $author$project$Components$Membership$Form$RecurringCharges, newSections);
							var newModel = _v45.a;
							var formCmd = _v45.b;
							return _Utils_Tuple2(formCmd, newModel);
						}
					}();
					var cmd = _v43.a;
					var newModel_ = _v43.b;
					return _Utils_Tuple3(
						newModel_,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$RecurringChargesMsg, recurringChargesResult.GZ),
									cmd
								])),
						recurringChargesResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 23:
				var subMsg = msg.a;
				var _v46 = model.m;
				if (!_v46.$) {
					var sections = _v46.a;
					var _v47 = sections.kG;
					if (!_v47.$) {
						var planChange = _v47.a;
						var planChangeResult = A3($author$project$Components$Membership$Form$Sections$PlanChange$update, apiClient, subMsg, planChange);
						var id = A2($elm$core$Maybe$withDefault, '', model.ahP);
						var cmd = function () {
							var _v48 = planChangeResult.agZ;
							switch (_v48) {
								case 0:
									return $elm$core$Platform$Cmd$none;
								case 1:
									return A2($author$project$Components$Membership$Form$retrieveItem, apiClient, id);
								case 2:
									return A2($author$project$Components$Membership$Form$retrieveItem, apiClient, id);
								default:
									return A2($author$project$Components$Membership$Form$retrieveItem, apiClient, id);
							}
						}();
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									m: $elm$core$Maybe$Just(
										_Utils_update(
											sections,
											{
												kG: $elm$core$Maybe$Just(planChangeResult.aiO)
											}))
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$PlanChangeMsg, planChangeResult.GZ),
										cmd
									])),
							planChangeResult.aR);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 24:
				var subMsg = msg.a;
				var _v49 = model.m;
				if (!_v49.$) {
					var sections = _v49.a;
					var billsOverviewResult = A3($author$project$Components$Membership$Form$Sections$BillsOverview$update, apiClient, subMsg, sections.rv);
					var _v50 = function () {
						var _v51 = billsOverviewResult.agZ;
						if (!_v51.$) {
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										m: $elm$core$Maybe$Just(
											_Utils_update(
												sections,
												{rv: billsOverviewResult.aiO}))
									}),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
						} else {
							var membership = _v51.a;
							return A2(
								$author$project$Utils$Tuple3$fromTuple2,
								_List_Nil,
								A3($author$project$Components$Membership$Form$setupMembershipOnScope, apiClient, membership, model));
						}
					}();
					var newModel = _v50.a;
					var cmd = _v50.b;
					var outMsgs = _v50.c;
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$BillsOverviewMsg, billsOverviewResult.GZ),
									cmd
								])),
						_Utils_ap(billsOverviewResult.aR, outMsgs));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 25:
				var membershipId = msg.a;
				var lastContract = msg.b;
				var endDate = A2($elm$core$Maybe$andThen, $author$project$Api$Provider$MembershipContract$Shared$endDate, lastContract);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							kU: $elm$core$Maybe$Just(
								A2($author$project$Components$Membership$Form$RenewContractModal$init, membershipId, endDate))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v52 = model.kU;
				if (!_v52.$) {
					var renewContractModal = _v52.a;
					var renewContractModalResult = A3($author$project$Components$Membership$Form$RenewContractModal$update, apiClient, subMsg, renewContractModal);
					var _v53 = function () {
						var _v54 = renewContractModalResult.agZ;
						switch (_v54) {
							case 0:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(renewContractModalResult.aiO),
									$elm$core$Platform$Cmd$none,
									model);
							case 1:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none, model);
							default:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									A2(
										$author$project$Components$Membership$Form$retrieveItem,
										apiClient,
										A2($elm$core$Maybe$withDefault, '', model.ahP)),
									model);
						}
					}();
					var renewContractModal_ = _v53.a;
					var cmd = _v53.b;
					var newModel_ = _v53.c;
					return _Utils_Tuple3(
						_Utils_update(
							newModel_,
							{kU: renewContractModal_}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$RenewContractModalMsg, renewContractModalResult.GZ),
									cmd
								])),
						renewContractModalResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Patients$PatientId_String$Memberships$MembershipId_String$Top$update = F2(
	function (msg, model) {
		var _v0 = A3($author$project$Components$Membership$Form$update, model.Gv, msg, model.SD);
		var form = _v0.a;
		var cmd = _v0.b;
		var outMsgs = _v0.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{SD: form}),
			cmd,
			outMsgs);
	});
var $author$project$Components$Membership$Form$Sections$Contracts$dirty = function (_v0) {
	var model = _v0;
	return $author$project$Utils$Form$dirty(model.SD);
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$dirty = function (_v0) {
	var model = _v0;
	return $author$project$Utils$Form$dirty(model.SD);
};
var $author$project$Components$Membership$Form$Sections$Members$dirty = function (model) {
	return (!_Utils_eq(
		model.I_,
		$elm$core$Set$fromList(
			$elm$core$Dict$keys(model.WR)))) || A2(
		$elm$core$List$any,
		function (_v0) {
			var _v1 = _v0.b;
			var membershipPatientModel = _v1.b;
			return $author$project$Components$Membership$Form$Members$MembershipPatient$dirty(membershipPatientModel);
		},
		$elm$core$Dict$toList(model.WR));
};
var $author$project$Components$Membership$Form$Sections$Pricing$dirty = function (_v0) {
	var model = _v0;
	return $author$project$Utils$Form$dirty(model.SD);
};
var $author$project$Components$Membership$Form$Sections$RecurringCharges$dirty = function (_v0) {
	var model = _v0;
	return $author$project$Utils$Form$dirty(model.SD);
};
var $author$project$Components$Membership$Form$Sections$Summary$dirty = function (_v0) {
	var model = _v0;
	return $author$project$Utils$Form$dirty(model.SD);
};
var $author$project$Components$Membership$Form$Sections$Contracts$modal = function (_v0) {
	var model = _v0;
	var _v1 = model.fR;
	if (!_v1.$) {
		var _v2 = _v1.a;
		var cancelRequest = _v2.a;
		var membershipId = _v2.b;
		return A2(
			$author$project$Components$HiConfirm$modal,
			$author$project$Components$Membership$Form$Sections$Contracts$CancelHiConfirmClosed(membershipId),
			_List_fromArray(
				[
					$author$project$Components$HiConfirm$noun('Contract'),
					$author$project$Components$HiConfirm$verb('Cancel'),
					$author$project$Components$HiConfirm$loading(
					_Utils_eq(cancelRequest, $author$project$Api$Data$Loading))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$CreatePatientModal$Create = {$: 2};
var $author$project$Components$CreatePatientModal$view = F2(
	function (title, model) {
		return A2(
			$author$project$Ui$Form$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$noValidate(true),
					$author$project$Ui$Form$autocomplete(false),
					$author$project$Ui$Form$onSubmit($author$project$Components$CreatePatientModal$Create)
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Modal$view,
					$author$project$Components$CreatePatientModal$Close,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Modal$header(
							_List_fromArray(
								[
									$author$project$Ui$Modal$title(title)
								])),
							$author$project$Ui$Modal$body(
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									A2(
										$elm$core$List$map,
										$elm$html$Html$map($author$project$Components$CreatePatientModal$PatientFormMsg),
										$author$project$Components$Patient$Form$view(model.SD)))
								])),
							$author$project$Ui$Modal$footer(
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Cancel and close modal'},
									_List_fromArray(
										[
											$author$project$Ui$Button$onClick($author$project$Components$CreatePatientModal$Close)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Cancel')
										])),
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Create patient'},
									_List_fromArray(
										[
											$author$project$Ui$Button$primary,
											$author$project$Ui$Button$loading(model.lA),
											$author$project$Ui$Button$submit
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Create')
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$modal = function (_v0) {
	var model = _v0;
	var _v1 = model.iZ;
	if (!_v1.$) {
		var createPatientModal = _v1.a;
		return A2(
			$elm$html$Html$map,
			$author$project$Components$Membership$Form$Members$MembershipPatient$CreatePatientModalMsg,
			A2($author$project$Components$CreatePatientModal$view, 'Add New Patient to Membership', createPatientModal));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Membership$Form$Sections$Members$modal = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (_v0) {
				var id = _v0.a;
				var _v1 = _v0.b;
				var membershipPatient = _v1.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Components$Membership$Form$Sections$Members$MembershipPatientMsg(id),
					$author$project$Components$Membership$Form$Members$MembershipPatient$modal(membershipPatient));
			},
			$elm$core$Dict$toList(model.WR)));
};
var $author$project$Components$Membership$Form$Sections$PlanChange$Save = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Membership$Form$Sections$PlanChange$ChangeAfterMonths = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Membership$Form$Sections$PlanChange$FormUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Membership$Meta$contractEndDateDefault = function (_v0) {
	var meta = _v0;
	return meta.yQ.PW;
};
var $author$project$Components$Membership$Form$Sections$PlanChange$Type = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Membership$Form$Sections$PlanChange$viewTypeButton = F3(
	function (currentType_, type_, label) {
		return A3(
			$author$project$Ui$Button$view,
			{mm: 'Select ' + label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(currentType_, type_)),
					$author$project$Ui$Button$onClick(
					$author$project$Components$Membership$Form$Sections$PlanChange$FormUpdated(
						$author$project$Components$Membership$Form$Sections$PlanChange$Type(type_)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Components$Membership$Form$Sections$PlanChange$viewEffectiveDate = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var type_ = _v0.amg;
	var changeOnDate = _v0.Nu;
	var changeAfterMonths = _v0.Nt;
	var changeOnDateDateInput = _v0.xY;
	var contract = _v0.G2;
	var membershipMeta = _v0.Iz;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9),
				$author$project$Ui$Form$Group$label('Effective date'),
				$author$project$Ui$Form$Group$required(true)
			]),
		function () {
			if (type_ === 2) {
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								function () {
								var _v2 = contract.Zs;
								if (!_v2.$) {
									var contractPeriodInMonths_ = _v2.a;
									var effectiveDate = function () {
										var _v3 = _Utils_Tuple2(
											contract.sb,
											$author$project$Api$Provider$Membership$Meta$contractEndDateDefault(membershipMeta));
										if (!_v3.a.$) {
											var contractEndDate_ = _v3.a.a;
											return $elm$core$Maybe$Just(contractEndDate_);
										} else {
											var _v4 = _v3.a;
											var defaultContractEndDate = _v3.b;
											return defaultContractEndDate;
										}
									}();
									return A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2($author$project$Formatters$String$pluralize, 'month', contractPeriodInMonths_)),
												$elm$html$Html$text(' ('),
												$elm$html$Html$text(
												A2(
													$elm$core$Maybe$withDefault,
													'N/A',
													A2(
														$elm$core$Maybe$map,
														$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
														effectiveDate))),
												$elm$html$Html$text(')')
											]));
								} else {
									return $elm$html$Html$text('Contract end date');
								}
							}()
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$helpBlock]),
						_List_fromArray(
							[
								$elm$html$Html$text('When contract periods are enabled, the plan can only be changed after the contract is ended.')
							]))
					]);
			} else {
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$span(7)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Button$group(
										_List_fromArray(
											[
												A3($author$project$Components$Membership$Form$Sections$PlanChange$viewTypeButton, type_, 1, 'Periods of months'),
												A3($author$project$Components$Membership$Form$Sections$PlanChange$viewTypeButton, type_, 0, 'Date')
											]))
									])),
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$span(5)
									]),
								_List_fromArray(
									[
										function () {
										switch (type_) {
											case 2:
												return $author$project$Utils$Html$empty;
											case 1:
												return $author$project$Ui$Form$PeriodInMonthsInput$view(
													{
														agX: A2($author$project$Utils$Form$validationErrors, 1, form),
														sM: A2($author$project$Utils$Form$hasValidationErrors, 1, form),
														ajm: A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Sections$PlanChange$FormUpdated, $author$project$Components$Membership$Form$Sections$PlanChange$ChangeAfterMonths),
														aee: changeAfterMonths
													});
											default:
												return A2(
													$elm$html$Html$map,
													$author$project$Components$Membership$Form$Sections$PlanChange$ChangeOnDateDateInputMsg(changeOnDateDateInput),
													A2(
														$author$project$Components$DateInput$view,
														_List_fromArray(
															[
																$author$project$Components$DateInput$value(changeOnDate),
																$author$project$Components$DateInput$invalid(
																A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
																$author$project$Components$DateInput$errors(
																A2($author$project$Utils$Form$validationErrors, 0, form))
															]),
														changeOnDateDateInput));
										}
									}()
									]))
							]))
					]);
			}
		}());
};
var $author$project$Components$ResourceFilter$Plan$selectedResource = function (model) {
	var _v0 = model.Jy;
	if (!_v0.$) {
		var plan = _v0.a;
		return $elm$core$Maybe$Just(plan);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Membership$Form$Sections$PlanChange$viewSpecialRatesWarning = F2(
	function (model, form) {
		var currentPlanSpecialRateNames = $author$project$Utils$Form$fields(form).Ha;
		var _v0 = _Utils_Tuple2(
			currentPlanSpecialRateNames,
			$author$project$Components$ResourceFilter$Plan$selectedResource(model.hi));
		_v0$0:
		while (true) {
			if (_v0.b.$ === 1) {
				if (!_v0.a.b) {
					break _v0$0;
				} else {
					var _v1 = _v0.b;
					return $author$project$Utils$Html$empty;
				}
			} else {
				if (!_v0.a.b) {
					break _v0$0;
				} else {
					var rates = _v0.a;
					var plan = _v0.b.a;
					return A2(
						$elm$core$List$any,
						function (name) {
							return !A2(
								$elm$core$List$member,
								name,
								$author$project$Api$Plan$specialRateNames(plan));
						},
						rates) ? $author$project$Components$SpecialRate$PlanChangeWarning$view(true) : $author$project$Utils$Html$empty;
				}
			}
		}
		return $author$project$Utils$Html$empty;
	});
var $author$project$Components$Membership$Form$Sections$PlanChange$viewToPlan = F2(
	function (model, form) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('New plan'),
					$author$project$Ui$Form$Group$required(true)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Components$Membership$Form$Sections$PlanChange$PlanResourceFilterMsg,
					A2(
						$author$project$Components$ResourceFilter$Plan$view,
						_List_fromArray(
							[
								$author$project$Components$ResourceFilter$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
								$author$project$Components$ResourceFilter$errors(
								A2($author$project$Utils$Form$validationErrors, 2, form))
							]),
						model.hi))
				]));
	});
var $author$project$Components$Membership$Form$Sections$PlanChange$viewForm = F2(
	function (model, form) {
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Components$Membership$Form$Sections$PlanChange$viewEffectiveDate(form),
					A2($author$project$Components$Membership$Form$Sections$PlanChange$viewToPlan, model, form),
					A2($author$project$Components$Membership$Form$Sections$PlanChange$viewSpecialRatesWarning, model, form)
				]));
	});
var $author$project$Components$Membership$Form$Sections$PlanChange$modal = function (_v0) {
	var model = _v0;
	var _v1 = _Utils_Tuple2(model.SD, model.f7);
	if (!_v1.a.$) {
		var form = _v1.a.a;
		var modalConfig = {
			Tq: $elm$core$Maybe$Nothing,
			aih: 'Plan Change',
			V8: _Utils_eq(model.k9, $author$project$Api$Data$Loading),
			WG: $elm$core$Maybe$Nothing,
			WH: $elm$core$Maybe$Nothing,
			Yd: $author$project$Components$Membership$Form$Sections$PlanChange$CloseModal,
			Yf: $author$project$Components$Membership$Form$Sections$PlanChange$Save
		};
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2($author$project$Components$Membership$Form$Sections$PlanChange$viewForm, model, form)
				]));
	} else {
		if (!_v1.b.$) {
			var _v2 = _v1.a;
			var _v3 = _v1.b.a;
			var membershipId = _v3.a;
			var deleteRequest = _v3.b;
			var scheduledChange = _v3.c;
			return A2(
				$author$project$Components$HiConfirm$modal,
				A2($author$project$Components$Membership$Form$Sections$PlanChange$DeleteHiConfirmClosed, membershipId, scheduledChange),
				_List_fromArray(
					[
						$author$project$Components$HiConfirm$noun('Plan change'),
						$author$project$Components$HiConfirm$verb('Remove'),
						$author$project$Components$HiConfirm$loading(
						_Utils_eq(deleteRequest, $author$project$Api$Data$Loading))
					]));
		} else {
			var _v4 = _v1.a;
			var _v5 = _v1.b;
			return $author$project$Utils$Html$empty;
		}
	}
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Save = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$viewChargeItemInput = function (model) {
	var editing = $author$project$Utils$Maybe$toBool(model.sG);
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9),
				$author$project$Ui$Form$Group$label('Charge Item'),
				$author$project$Ui$Form$Group$required(!editing)
			]),
		_List_fromArray(
			[
				function () {
				if (editing) {
					var recurringCharge = $author$project$Utils$Form$fields(model.SD);
					return A2(
						$author$project$Ui$Form$Static$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Static$phi(true)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2(
											$elm$core$Maybe$withDefault,
											'N/A',
											A2(
												$elm$core$Maybe$map,
												function ($) {
													return $.Bq;
												},
												recurringCharge.mL)))
									]))
							]));
				} else {
					return A2(
						$elm$html$Html$map,
						$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$ChargeItemResourceFilterMsg,
						A2(
							$author$project$Components$ResourceFilter$ChargeItem$view,
							_List_fromArray(
								[
									$author$project$Components$ResourceFilter$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 1, model.SD)),
									$author$project$Components$ResourceFilter$errors(
									A2($author$project$Utils$Form$validationErrors, 1, model.SD))
								]),
							model.cq));
				}
			}()
			]));
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$FixedDescription = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$FormUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$viewDescriptionInput = function (model) {
	var _v0 = $author$project$Utils$Form$fields(model.SD);
	var fixedDescription = _v0.aho;
	var chargeItem = _v0.mL;
	var placeholder = A2(
		$elm$core$Maybe$withDefault,
		'Additional details for receipt (e.g. ICD-10 Codes)',
		A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.Qr;
			},
			chargeItem));
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9),
				$author$project$Ui$Form$Group$label('Description')
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Textarea$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Textarea$rows(2),
						$author$project$Ui$Form$Textarea$phi(true),
						$author$project$Ui$Form$Textarea$value(
						A2($elm$core$Maybe$withDefault, '', fixedDescription)),
						$author$project$Ui$Form$Textarea$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$FormUpdated, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$FixedDescription)),
						$author$project$Ui$Form$Textarea$placeholder(placeholder)
					]))
			]));
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$FixedPriceInCents = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$viewFixedPriceInCentsInput = function (model) {
	var _v0 = $author$project$Utils$Form$fields(model.SD);
	var fixedPriceInCents = _v0.ahp;
	var chargeItem = _v0.mL;
	var placeholder = $author$project$Utils$Currency$fromFloat(
		A2(
			$elm$core$Maybe$withDefault,
			0.0,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Dw;
				},
				chargeItem)));
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9),
				$author$project$Ui$Form$Group$label('Price')
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$CurrencyInput$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$CurrencyInput$value(fixedPriceInCents),
						$author$project$Ui$Form$CurrencyInput$placeholder(placeholder),
						$author$project$Ui$Form$CurrencyInput$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$FormUpdated, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$FixedPriceInCents))
					]))
			]));
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$viewPatientInput = function (model) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9),
				$author$project$Ui$Form$Group$label('Patient'),
				$author$project$Ui$Form$Group$required(true)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$LimitedPatientSelectorMsg,
				A2(
					$author$project$Components$LimitedPatientSelector$view,
					_List_fromArray(
						[
							$author$project$Components$LimitedPatientSelector$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 0, model.SD)),
							$author$project$Components$LimitedPatientSelector$errors(
							A2($author$project$Utils$Form$validationErrors, 0, model.SD))
						]),
					model.oj))
			]));
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$viewPractitionerInput = function (model) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9),
				$author$project$Ui$Form$Group$label('Provider')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$PractitionerResourceFilterMsg,
				A2($author$project$Components$ResourceFilter$Practitioner$view, _List_Nil, model.hk))
			]));
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$TaxProfileSelected = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$viewTaxProfileFormGroup = function (model) {
	var form = model.SD;
	var _v0 = $author$project$Utils$Form$fields(form);
	var chargeItemTaxable = _v0.afD;
	if (!chargeItemTaxable) {
		return $elm$core$Maybe$Nothing;
	} else {
		var _v1 = model.hU;
		if (_v1.$ === 3) {
			var taxProfiles = _v1.a;
			if (!taxProfiles.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				if (!taxProfiles.b.b) {
					var single = taxProfiles.a;
					return $elm$core$Maybe$Just(
						A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$labelSpanSm(3),
									$author$project$Ui$Form$Group$inputSpanSm(9),
									$author$project$Ui$Form$Group$label('Tax Profile')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Select$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Select$value(
											$elm$core$Maybe$Just(
												$author$project$Api$Provider$TaxProfile$All$id(single))),
											$author$project$Ui$Form$Select$disabled(true)
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Form$Select$option,
											_List_Nil,
											$elm$core$Maybe$Just(
												$author$project$Api$Provider$TaxProfile$All$id(single)),
											$author$project$Api$Provider$TaxProfile$All$forDisplay(single))
										]))
								])));
				} else {
					var effectiveId = $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$effectiveTaxProfileId(model);
					var dropdownEnabled = _Utils_eq(model.kb, $elm$core$Maybe$Nothing);
					return $elm$core$Maybe$Just(
						A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$labelSpanSm(3),
									$author$project$Ui$Form$Group$inputSpanSm(9),
									$author$project$Ui$Form$Group$label('Tax Profile'),
									$author$project$Ui$Form$Group$required(dropdownEnabled)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Select$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Select$value(effectiveId),
											$author$project$Ui$Form$Select$disabled(!dropdownEnabled),
											$author$project$Ui$Form$Select$onChange(
											A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$FormUpdated, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$TaxProfileSelected)),
											$author$project$Ui$Form$Select$invalid(
											A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
											$author$project$Ui$Form$Select$errors(
											A2($author$project$Utils$Form$validationErrors, 2, form))
										]),
									A2(
										$elm$core$List$cons,
										A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, 'Select a tax profile'),
										A2(
											$elm$core$List$map,
											function (tp) {
												return A3(
													$author$project$Ui$Form$Select$option,
													_List_Nil,
													$elm$core$Maybe$Just(
														$author$project$Api$Provider$TaxProfile$All$id(tp)),
													$author$project$Api$Provider$TaxProfile$All$forDisplay(tp));
											},
											taxProfiles)))
								])));
				}
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$view = function (_v0) {
	var model = _v0;
	var editing = $author$project$Utils$Maybe$toBool(model.sG);
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$CancelEdit,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title(
						editing ? 'Edit Charge' : 'New Charge')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_Nil,
						A2(
							$elm$core$List$cons,
							$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$viewChargeItemInput(model),
							A2(
								$elm$core$List$cons,
								$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$viewPatientInput(model),
								editing ? A2(
									$elm$core$List$cons,
									$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$viewPractitionerInput(model),
									A2(
										$elm$core$List$cons,
										$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$viewFixedPriceInCentsInput(model),
										A2(
											$elm$core$List$cons,
											$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$viewDescriptionInput(model),
											A2(
												$elm$core$List$filterMap,
												$elm$core$Basics$identity,
												_List_fromArray(
													[
														$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$viewTaxProfileFormGroup(model)
													]))))) : A2(
									$elm$core$List$filterMap,
									$elm$core$Basics$identity,
									_List_fromArray(
										[
											$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$viewTaxProfileFormGroup(model)
										])))))
					])),
				$author$project$Ui$Modal$footer(
				A2(
					$elm$core$List$cons,
					A3(
						$author$project$Ui$Button$view,
						{mm: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$CancelEdit)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
					editing ? _List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Save recurring charge'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick(
									$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Save($elm$core$Maybe$Nothing)),
									$author$project$Ui$Button$primary
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Save')
								]))
						]) : _List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Add charge once'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick(
									$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Save(
										$elm$core$Maybe$Just(1))),
									$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Add Once')
								])),
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Add charge recurring'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick(
									$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Save($elm$core$Maybe$Nothing)),
									$author$project$Ui$Button$icon($author$project$Ui$Icon$repeat)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Add Recurring')
								]))
						])))
			]));
};
var $author$project$Components$Membership$Form$Sections$RecurringCharges$modal = function (_v0) {
	var model = _v0;
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				function () {
				var _v1 = model.f1;
				if (!_v1.$) {
					var createEditModal = _v1.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$Membership$Form$Sections$RecurringCharges$CreateEditModalMsg,
						$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$view(createEditModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]));
};
var $author$project$Components$Membership$Form$Sections$Summary$modal = function (_v0) {
	var model = _v0;
	var _v1 = model.iX;
	if (!_v1.$) {
		var _v2 = _v1.a;
		var createModal = _v2.b;
		return A2(
			$elm$html$Html$map,
			$author$project$Components$Membership$Form$Sections$Summary$CreateModalMsg,
			$author$project$Components$BrokerDeal$CreateModal$view(createModal));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Api$MemberRelationship$toString = function (memberRelationship) {
	switch (memberRelationship) {
		case 0:
			return 'employee';
		case 1:
			return 'spouse';
		case 2:
			return 'child';
		default:
			return 'other';
	}
};
var $author$project$Components$Membership$Form$CancelModal$Cancel = {$: 0};
var $author$project$Components$Membership$Form$CancelModal$CancellationReason = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Membership$Form$CancelModal$FormUpdated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Formatters$Date$Timeago = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Api$Provider$Membership$Meta$endDateRetailValues = function (_v0) {
	var meta = _v0;
	return meta.sb.$Y;
};
var $author$project$Components$Membership$Form$CancelModal$endDateOptions = function (membership) {
	return $author$project$Ui$Form$Select$dateOptions(
		$author$project$Api$Provider$Membership$Meta$endDateRetailValues(
			$author$project$Api$Provider$Membership$One$meta(membership)));
};
var $author$project$Api$Provider$Membership$One$lastContract = function (_v0) {
	var record = _v0.b;
	return record.VD;
};
var $author$project$Api$Provider$Membership$Meta$endDateSponsoredMinWithoutProration = function (_v0) {
	var meta = _v0;
	return meta.sb.ab4;
};
var $author$project$Components$Membership$Form$Utils$mayHaveCancellableInvoice = F2(
	function (membership, endDate) {
		var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
		var minWithoutProration = $author$project$Api$Provider$Membership$Meta$endDateSponsoredMinWithoutProration(membershipMeta);
		var billFromDate = $author$project$Api$Provider$Membership$One$billFromDate(membership);
		var _v0 = _Utils_Tuple2(endDate, minWithoutProration);
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				var endDate_ = _v0.a.a;
				var minWithoutProration_ = _v0.b.a;
				return A3($justinmimbs$date$Date$isBetween, minWithoutProration_, billFromDate, endDate_) && (!_Utils_eq(endDate_, billFromDate));
			} else {
				var endDate_ = _v0.a.a;
				var _v1 = _v0.b;
				return !A2($justinmimbs$date$Date$compare, endDate_, billFromDate);
			}
		} else {
			var _v2 = _v0.a;
			return false;
		}
	});
var $author$project$Api$Provider$Membership$Shared$billingStartDate = function (_v0) {
	var record = _v0;
	return record.MH;
};
var $author$project$Api$Provider$Membership$One$billingStartDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Membership$Shared$billingStartDate(shared);
};
var $author$project$Components$Membership$Form$Utils$billedFromDate = F2(
	function (membership, endDate) {
		return A2(
			$elm_community$list_extra$List$Extra$maximumBy,
			$justinmimbs$date$Date$toRataDie,
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						endDate,
						$elm$core$Maybe$Just(
						$author$project$Api$Provider$Membership$One$billingStartDate(membership))
					])));
	});
var $author$project$Api$Provider$Membership$Meta$endDateSponsoredMaxWithoutBilling = function (_v0) {
	var meta = _v0;
	return meta.sb.ab2;
};
var $author$project$Components$Membership$Form$Utils$mayNeedProration = F2(
	function (membership, endDate) {
		if ($author$project$Api$Provider$Membership$One$isSponsored(membership)) {
			var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
			var minWithoutProration = $author$project$Api$Provider$Membership$Meta$endDateSponsoredMinWithoutProration(membershipMeta);
			var maxWithoutBilling = $author$project$Api$Provider$Membership$Meta$endDateSponsoredMaxWithoutBilling(membershipMeta);
			var _v0 = _Utils_Tuple3(minWithoutProration, maxWithoutBilling, endDate);
			if (((!_v0.a.$) && (!_v0.b.$)) && (!_v0.c.$)) {
				var minWithoutProration_ = _v0.a.a;
				var maxWithoutBilling_ = _v0.b.a;
				var endDate_ = _v0.c.a;
				return A3($justinmimbs$date$Date$isBetween, maxWithoutBilling_, minWithoutProration_, endDate_) && (!_Utils_eq(endDate_, minWithoutProration_));
			} else {
				return false;
			}
		} else {
			if (!endDate.$) {
				var endDate_ = endDate.a;
				return !A2(
					$justinmimbs$date$Date$compare,
					endDate_,
					$author$project$Api$Provider$Membership$One$billFromDate(membership));
			} else {
				return false;
			}
		}
	});
var $author$project$Components$Membership$Form$Utils$prorationWarning = F4(
	function (noun, supportUrl, startDate, endDate) {
		return A2(
			$author$project$Ui$Form$Static$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Alert$warning,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('We have billed this '),
							$elm$html$Html$text(noun),
							$elm$html$Html$text(' through '),
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
									endDate))),
							$elm$html$Html$text('. If you’d like to credit the period of '),
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
									startDate))),
							$elm$html$Html$text(' through '),
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
									endDate))),
							$elm$html$Html$text(', you can learn how to do that '),
							A3(
							$author$project$Ui$Link$externalHref,
							supportUrl,
							_List_fromArray(
								[$author$project$Ui$Link$targetBlank]),
							_List_fromArray(
								[
									$elm$html$Html$text('here')
								])),
							$elm$html$Html$text('.')
						]))
				]));
	});
var $author$project$Components$Membership$Form$Utils$mayNeedProrationWarning = F3(
	function (noun, membership, endDate) {
		if (A2($author$project$Components$Membership$Form$Utils$mayNeedProration, membership, endDate)) {
			if ($author$project$Api$Provider$Membership$One$isSponsored(membership)) {
				var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
				return A4(
					$author$project$Components$Membership$Form$Utils$prorationWarning,
					noun,
					'https://support.hint.com/en/articles/4622730-adding-an-employer-credit-or-one-off-charge',
					A2($author$project$Components$Membership$Form$Utils$billedFromDate, membership, endDate),
					$author$project$Api$Provider$Membership$Meta$endDateSponsoredMinWithoutProration(membershipMeta));
			} else {
				return A4(
					$author$project$Components$Membership$Form$Utils$prorationWarning,
					noun,
					'https://support.hint.com/invoices/creating-a-prorated-membership-invoice',
					endDate,
					$author$project$Api$Provider$Membership$One$billedThroughDate(membership));
			}
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Api$Provider$Membership$Shared$minimumEnrollmentEndDate = function (_v0) {
	var record = _v0;
	return record.Xe;
};
var $author$project$Api$Provider$Membership$One$minimumEnrollmentEndDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Membership$Shared$minimumEnrollmentEndDate(shared);
};
var $author$project$Api$Provider$Membership$One$periodRateInCents = function (_v0) {
	var record = _v0.b;
	return record.Zt;
};
var $author$project$Components$Membership$Form$CancelModal$viewMembershipPatient = function (membershipPatient) {
	var patient = $author$project$Api$Provider$MembershipPatient$ForMembershipOne$patient(membershipPatient);
	var memberType = $author$project$Api$Provider$MembershipPatient$ForMembershipOne$memberType(membershipPatient);
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label(
				(memberType === 1) ? 'Adult' : $author$project$Formatters$String$titleize(
					$author$project$Api$MemberRelationship$toString(memberType))),
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
							{
								YZ: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$id(patient)
							}),
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$text,
								_List_fromArray(
									[
										$author$project$Ui$Typography$phi(true)
									]),
								$author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$name(patient))
							]))
					]))
			]));
};
var $author$project$Components$Membership$Form$CancelModal$view = F2(
	function (cancellationReasons, _v0) {
		var model = _v0;
		var membershipPatients = $author$project$Api$Provider$Membership$One$membershipPatients(model.kk);
		var fields = $author$project$Utils$Form$fields(model.SD);
		var earlyTermination = function () {
			var _v1 = _Utils_Tuple2(
				fields.sb,
				$author$project$Api$Provider$Membership$One$minimumEnrollmentEndDate(model.kk));
			if ((!_v1.a.$) && (!_v1.b.$)) {
				var endDate = _v1.a.a;
				var minimumEnrollmentEndDate = _v1.b.a;
				return !A2($justinmimbs$date$Date$compare, endDate, minimumEnrollmentEndDate);
			} else {
				return false;
			}
		}();
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$Membership$Form$CancelModal$Close,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('End Membership')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							earlyTermination ? A2(
							$author$project$Ui$Alert$warning,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('This patient\'s minimum enrollment is scheduled to end '),
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										A2(
											$elm$core$Maybe$map,
											$author$project$Formatters$Date$toString(
												A2(
													$author$project$Formatters$Date$Timeago,
													model.dd,
													$elm$core$Maybe$Just('days'))),
											$author$project$Api$Provider$Membership$One$minimumEnrollmentEndDate(model.kk)))),
									$elm$html$Html$text(' on '),
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										A2(
											$elm$core$Maybe$map,
											$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
											$author$project$Api$Provider$Membership$One$minimumEnrollmentEndDate(model.kk)))),
									$elm$html$Html$text('. If you end their membership early they will not pay for the remaining time.')
								])) : $author$project$Utils$Html$empty,
							A2(
							$author$project$Ui$Form$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$onSubmit($author$project$Components$Membership$Form$CancelModal$Cancel)
								]),
							$elm$core$List$concat(
								_List_fromArray(
									[
										_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Group$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Group$label('Membership Started'),
													$author$project$Ui$Form$Group$labelSpan(4),
													$author$project$Ui$Form$Group$inputSpan(8)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Form$Static$view,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2(
																$author$project$Formatters$Date$toString,
																$author$project$Formatters$Date$Full,
																$author$project$Api$Provider$Membership$One$startDate(model.kk)))
														]))
												])),
											$author$project$Api$Provider$Membership$One$contractExpires(model.kk) ? A2(
											$author$project$Ui$Form$Group$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Group$label('Contract end date'),
													$author$project$Ui$Form$Group$labelSpan(4),
													$author$project$Ui$Form$Group$inputSpan(8)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2(
														$elm$core$Maybe$withDefault,
														'N/A',
														A2(
															$elm$core$Maybe$map,
															$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
															A2(
																$elm$core$Maybe$andThen,
																$author$project$Api$Provider$MembershipContract$Shared$endDate,
																$author$project$Api$Provider$Membership$One$lastContract(model.kk)))))
												])) : $author$project$Utils$Html$empty,
											A2(
											$author$project$Ui$Form$Group$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Group$label('End Date'),
													$author$project$Ui$Form$Group$labelSpan(4),
													$author$project$Ui$Form$Group$inputSpan(8),
													$author$project$Ui$Form$Group$required(true)
												]),
											_List_fromArray(
												[
													$author$project$Api$Provider$Membership$One$isSponsored(model.kk) ? A2(
													$elm$html$Html$map,
													$author$project$Components$Membership$Form$CancelModal$EndDateInputMsg,
													A2(
														$author$project$Components$DateInput$view,
														_List_fromArray(
															[
																$author$project$Components$DateInput$value(fields.sb),
																$author$project$Components$DateInput$invalid(
																A2($author$project$Utils$Form$hasValidationErrors, 0, model.SD)),
																$author$project$Components$DateInput$errors(
																A2($author$project$Utils$Form$validationErrors, 0, model.SD))
															]),
														model.sd)) : A2(
													$author$project$Ui$Form$Select$view,
													_List_fromArray(
														[
															$author$project$Ui$Form$Select$value(
															A2($elm$core$Maybe$map, $justinmimbs$date$Date$toIsoString, fields.sb)),
															$author$project$Ui$Form$Select$onChange(
															A2(
																$elm$core$Basics$composeL,
																A2(
																	$elm$core$Basics$composeL,
																	A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$CancelModal$FormUpdated, $author$project$Components$Membership$Form$CancelModal$EndDate),
																	$elm$core$Result$toMaybe),
																$justinmimbs$date$Date$fromIsoString)),
															$author$project$Ui$Form$Select$invalid(
															A2($author$project$Utils$Form$hasValidationErrors, 0, model.SD)),
															$author$project$Ui$Form$Select$errors(
															A2($author$project$Utils$Form$validationErrors, 0, model.SD))
														]),
													$author$project$Components$Membership$Form$CancelModal$endDateOptions(model.kk)),
													A2($author$project$Components$Membership$Form$Utils$mayHaveCancellableInvoice, model.kk, fields.sb) ? A2(
													$author$project$Ui$Form$Static$view,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Alert$warning,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Invoices after this date will be automatically cancelled unless paid.')
																]))
														])) : $author$project$Utils$Html$empty,
													A3($author$project$Components$Membership$Form$Utils$mayNeedProrationWarning, 'membership', model.kk, fields.sb)
												])),
											A2($author$project$Components$Membership$Form$Utils$mayHaveCancellableInvoice, model.kk, fields.sb) ? A2(
											$author$project$Ui$Form$Group$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Group$label('Amount'),
													$author$project$Ui$Form$Group$labelSpan(4),
													$author$project$Ui$Form$Group$inputSpan(8)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Form$Static$view,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Utils$Currency$fromInt(
																$author$project$Api$Provider$Membership$One$periodRateInCents(model.kk))),
															$author$project$Utils$Html$noBreakSpace,
															$elm$html$Html$text(
															$author$project$Formatters$Int$asPeriod(
																$author$project$Api$Provider$Membership$One$periodInMonths(model.kk)))
														]))
												])) : $author$project$Utils$Html$empty,
											$author$project$Components$CancellationReason$Input$view(
											{
												afq: cancellationReasons,
												agX: A2($author$project$Utils$Form$validationErrors, 1, model.SD),
												RO: A2($author$project$Utils$Form$validationErrors, 2, model.SD),
												aii: $elm$core$Maybe$Nothing,
												ajd: A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$CancelModal$FormUpdated, $author$project$Components$Membership$Form$CancelModal$CancellationReason),
												aee: _Utils_Tuple2(fields.afo, fields.afp)
											})
										]),
										A2($elm$core$List$map, $author$project$Components$Membership$Form$CancelModal$viewMembershipPatient, membershipPatients)
									])))
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Cancel and close modal'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Components$Membership$Form$CancelModal$Close)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{mm: 'End membership'},
							_List_fromArray(
								[
									$author$project$Ui$Button$danger,
									$author$project$Ui$Button$loading(
									_Utils_eq(model.fR, $author$project$Api$Data$Loading)),
									$author$project$Ui$Button$onClick($author$project$Components$Membership$Form$CancelModal$Cancel)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('End Membership')
								]))
						]))
				]));
	});
var $author$project$Components$Membership$Form$OutsideAgeRangeModal$viewPatient = function (patient) {
	return A2(
		$elm$html$Html$li,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$text,
				_List_fromArray(
					[
						$author$project$Ui$Typography$phi(true)
					]),
				patient.Bq),
				$elm$html$Html$text(' is '),
				A2(
				$author$project$Ui$Typography$text,
				_List_fromArray(
					[
						$author$project$Ui$Typography$phi(true)
					]),
				A2(
					$elm$core$Maybe$withDefault,
					'N/A',
					A2($elm$core$Maybe$map, $elm$core$String$fromInt, patient.Lj))),
				$elm$html$Html$text(' years old.')
			]));
};
var $author$project$Components$Membership$Form$OutsideAgeRangeModal$viewPatientsOutsideRange = F3(
	function (range, limit, patients) {
		return A2(
			$author$project$Ui$Typography$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('The '),
					$elm$html$Html$text(range),
					$elm$html$Html$text(' age defined for this plan is '),
					$elm$html$Html$text(
					A2(
						$elm$core$Maybe$withDefault,
						'N/A',
						A2($elm$core$Maybe$map, $elm$core$String$fromInt, limit))),
					$elm$html$Html$text('.'),
					A2(
					$elm$html$Html$ul,
					_List_Nil,
					A2($elm$core$List$map, $author$project$Components$Membership$Form$OutsideAgeRangeModal$viewPatient, patients))
				]));
	});
var $author$project$Components$Membership$Form$OutsideAgeRangeModal$view = F2(
	function (onClose, model) {
		return A3(
			$author$project$Ui$Modal$view,
			onClose(false),
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('Warning - patient outside of plan age range')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							($elm$core$List$length(model.xA) >= 1) ? A3($author$project$Components$Membership$Form$OutsideAgeRangeModal$viewPatientsOutsideRange, 'minimum', model.Xd, model.xA) : $author$project$Utils$Html$empty,
							($elm$core$List$length(model.vw) >= 1) ? A3($author$project$Components$Membership$Form$OutsideAgeRangeModal$viewPatientsOutsideRange, 'maximum', model.WF, model.vw) : $author$project$Utils$Html$empty,
							A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Do you want to proceed anyway?')
								]))
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Cancel'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick(
									onClose(false))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Proceed anyway'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$onClick(
									onClose(true))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Confirm')
								]))
						]))
				]));
	});
var $author$project$Components$Membership$Form$RenewContractModal$MemoUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Membership$Form$RenewContractModal$Renew = {$: 2};
var $author$project$Components$Membership$Form$RenewContractModal$view = function (model) {
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Membership$Form$RenewContractModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Set contract to renew?')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Current contract expires: '),
								$elm$html$Html$text(
								A2(
									$elm$core$Maybe$withDefault,
									'N/A',
									A2(
										$elm$core$Maybe$map,
										$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
										model.Ip)))
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Memo:')
							])),
						$author$project$Ui$Form$Textarea$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Textarea$rows(4),
								$author$project$Ui$Form$Textarea$value(
								A2($elm$core$Maybe$withDefault, '', model.aiG)),
								$author$project$Ui$Form$Textarea$onInput($author$project$Components$Membership$Form$RenewContractModal$MemoUpdated)
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Membership$Form$RenewContractModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Confirm contract renewal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$loading(
								_Utils_eq(model.pE, $author$project$Api$Data$Loading)),
								$author$project$Ui$Button$onClick($author$project$Components$Membership$Form$RenewContractModal$Renew)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Confirm')
							]))
					]))
			]));
};
var $author$project$Components$Membership$Form$RestartModal$DateInputMsg = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$Membership$Form$RestartModal$Restart = {$: 0};
var $author$project$Formatters$Date$Relative = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Api$Provider$MembershipBill$Shared$amountInCents = function (_v0) {
	var record = _v0;
	return record.LE;
};
var $author$project$Api$Provider$MembershipBill$ForMembershipOne$amountInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$MembershipBill$Shared$amountInCents(shared);
};
var $author$project$Api$Provider$MembershipBill$Shared$date = function (_v0) {
	var record = _v0;
	return record.PB;
};
var $author$project$Api$Provider$MembershipBill$ForMembershipOne$date = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$MembershipBill$Shared$date(shared);
};
var $author$project$Api$Common$Payable$Invoice$Min$humanStatus = function (_v0) {
	var record = _v0;
	return record.TH;
};
var $author$project$Api$Provider$MembershipBill$ForMembershipOne$invoice = function (_v0) {
	var record = _v0.b;
	return record.Uk;
};
var $author$project$Api$Provider$MembershipBill$Shared$startDate = function (_v0) {
	var record = _v0;
	return record.ab7;
};
var $author$project$Api$Provider$MembershipBill$ForMembershipOne$startDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$MembershipBill$Shared$startDate(shared);
};
var $author$project$Components$Membership$Form$RestartModal$viewMembershipBill = F3(
	function (currentDate, membership, membershipBill) {
		var invoice = $author$project$Api$Provider$MembershipBill$ForMembershipOne$invoice(membershipBill);
		var date = $author$project$Api$Provider$MembershipBill$ForMembershipOne$date(membershipBill);
		var startDate = A2(
			$elm$core$Maybe$withDefault,
			date,
			$author$project$Api$Provider$MembershipBill$ForMembershipOne$startDate(membershipBill));
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label(
					A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$MonthAndYear, startDate)),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_fromArray(
								[$author$project$Ui$Typography$primary]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$MembershipBill$ForMembershipOne$amountInCents(membershipBill))),
									function () {
									if (!invoice.$) {
										var invoice_ = invoice.a;
										return A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$author$project$Utils$Html$noBreakSpace,
													A2(
													$author$project$Ui$Badge$fromString,
													_List_Nil,
													$author$project$Api$Common$Payable$Invoice$Min$humanStatus(invoice_))
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}(),
									function () {
									if (!invoice.$) {
										var invoice_ = invoice.a;
										var invoiceRoute = function () {
											if ($author$project$Api$Provider$Membership$One$isSponsored(membership)) {
												return A2(
													$elm$core$Maybe$map,
													function (company_) {
														return $author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String(
															{
																fZ: $author$project$Api$Provider$Company$Shared$id(company_),
																ahP: $author$project$Api$Common$Payable$Invoice$Min$id(invoice_)
															});
													},
													$author$project$Api$Provider$Membership$One$company(membership));
											} else {
												var owner = $author$project$Api$Provider$Membership$One$owner(membership);
												return A2(
													$elm$core$Maybe$map,
													function (owner_) {
														return $author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top(
															{
																Us: $author$project$Api$Common$Payable$Invoice$Min$id(invoice_),
																YZ: $author$project$Api$Provider$Patient$Shared$id(owner_)
															});
													},
													owner);
											}
										}();
										if (!invoiceRoute.$) {
											var route = invoiceRoute.a;
											return A2(
												$elm$html$Html$span,
												_List_Nil,
												_List_fromArray(
													[
														$author$project$Utils$Html$noBreakSpace,
														A3(
														$author$project$Ui$Link$route,
														route,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('#'),
																$elm$html$Html$text(
																$elm$core$String$fromInt(
																	$author$project$Api$Common$Payable$Invoice$Min$invoiceNumber(invoice_)))
															]))
													]));
										} else {
											return A2(
												$elm$html$Html$span,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(' #'),
														$elm$html$Html$text(
														$elm$core$String$fromInt(
															$author$project$Api$Common$Payable$Invoice$Min$invoiceNumber(invoice_)))
													]));
										}
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textMuted]),
							_List_fromArray(
								[
									$elm$html$Html$text('due '),
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$Date$toString,
										A2(
											$author$project$Formatters$Date$Relative,
											currentDate,
											$elm$core$Maybe$Just('bill')),
										date))
								]))
						]))
				]));
	});
var $author$project$Components$Membership$Form$RestartModal$viewMembershipPatient = function (membershipPatient) {
	var patient = $author$project$Api$Provider$MembershipPatient$ForMembershipOne$patient(membershipPatient);
	var memberType = $author$project$Api$Provider$MembershipPatient$ForMembershipOne$memberType(membershipPatient);
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Link$route,
				$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
					{
						YZ: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$id(patient)
					}),
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$text,
						_List_fromArray(
							[
								$author$project$Ui$Typography$phi(true)
							]),
						$author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$name(patient))
					])),
				$author$project$Utils$Html$noBreakSpace,
				(memberType === 1) ? A2(
				$author$project$Ui$Typography$text,
				_List_fromArray(
					[$author$project$Ui$Typography$muted]),
				'Adult') : A2(
				$author$project$Ui$Typography$text,
				_List_fromArray(
					[$author$project$Ui$Typography$muted]),
				$author$project$Formatters$String$titleize(
					$author$project$Api$MemberRelationship$toString(memberType)))
			]));
};
var $author$project$Components$Membership$Form$RestartModal$viewModal = F4(
	function (pendingMembership, model, maybeDate, dateInput) {
		var upcomingAndOutstandingBills = $author$project$Api$Provider$Membership$One$upcomingAndOutstandingBills(pendingMembership);
		var membershipPatients = $author$project$Api$Provider$Membership$One$membershipPatients(model.kk);
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$Membership$Form$RestartModal$Close,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('Restart Membership')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Alert$info,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('This membership will no longer end and it\'s next billing date will be '),
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										A2(
											$elm$core$Maybe$map,
											$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
											$author$project$Api$Provider$Membership$One$nextBillDate(pendingMembership)))),
									$elm$html$Html$text('.')
								])),
							A2(
							$author$project$Ui$Form$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$onSubmit($author$project$Components$Membership$Form$RestartModal$Restart)
								]),
							$elm$core$List$concat(
								_List_fromArray(
									[
										_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Group$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Group$label('Start Date'),
													$author$project$Ui$Form$Group$labelSpan(4),
													$author$project$Ui$Form$Group$inputSpan(8)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Form$Static$view,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2(
																$author$project$Formatters$Date$toString,
																$author$project$Formatters$Date$Full,
																$author$project$Api$Provider$Membership$One$startDate(pendingMembership)))
														]))
												])),
											A2(
											$author$project$Ui$Form$Group$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Group$label('Next Bill Date'),
													$author$project$Ui$Form$Group$labelSpan(4),
													$author$project$Ui$Form$Group$inputSpan(8),
													$author$project$Ui$Form$Group$inputSpan(6),
													$author$project$Ui$Form$Group$inputSpanSm(4)
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$map,
													$author$project$Components$Membership$Form$RestartModal$DateInputMsg(dateInput),
													A2(
														$author$project$Components$DateInput$view,
														_List_fromArray(
															[
																$author$project$Components$DateInput$value(maybeDate)
															]),
														dateInput))
												])),
											(!$elm$core$List$isEmpty(membershipPatients)) ? A2(
											$author$project$Ui$Form$Group$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Group$label('Members'),
													$author$project$Ui$Form$Group$labelSpan(4),
													$author$project$Ui$Form$Group$inputSpan(8)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Form$Static$view,
													_List_Nil,
													A2($elm$core$List$map, $author$project$Components$Membership$Form$RestartModal$viewMembershipPatient, membershipPatients))
												])) : $author$project$Utils$Html$empty,
											A2(
											$author$project$Ui$Form$Group$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Group$label('Upcoming Bills'),
													$author$project$Ui$Form$Group$labelSpan(4),
													$author$project$Ui$Form$Group$inputSpan(8)
												]),
											_List_Nil)
										]),
										A2(
										$elm$core$List$map,
										A2($author$project$Components$Membership$Form$RestartModal$viewMembershipBill, model.dd, model.kk),
										upcomingAndOutstandingBills)
									])))
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Cancel and close modal'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Components$Membership$Form$RestartModal$Close)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Restart membership'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$loading(
									_Utils_eq(model.uj, $author$project$Api$Data$Loading)),
									$author$project$Ui$Button$onClick($author$project$Components$Membership$Form$RestartModal$Restart)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Restart Membership')
								]))
						]))
				]));
	});
var $author$project$Components$Membership$Form$RestartModal$view = function (model) {
	var _v0 = model.dC;
	if (_v0.$ === 1) {
		return $author$project$Utils$Html$empty;
	} else {
		var pendingMembership = _v0.a;
		return A4(
			$author$project$Components$Membership$Form$RestartModal$viewModal,
			pendingMembership,
			model,
			$author$project$Api$Provider$Membership$One$nextBillDate(pendingMembership),
			model.rZ);
	}
};
var $author$project$Components$Membership$Form$modal = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		$elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						function () {
						var _v0 = model.f7;
						if (!_v0.$) {
							var _v1 = _v0.a;
							var membership = _v1.a;
							var deleteRequest = _v1.b;
							var membershipPatients = $author$project$Api$Provider$Membership$One$membershipPatients(membership);
							return A2(
								$author$project$Components$HiConfirm$modal,
								$author$project$Components$Membership$Form$DeleteHiConfirmClosed(membership),
								_List_fromArray(
									[
										$author$project$Components$HiConfirm$noun('membership'),
										$author$project$Components$HiConfirm$verb('delete'),
										$author$project$Components$HiConfirm$customMessage(
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Alert$danger,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Are you sure you want to delete this membership? This cannot be undone.')
													])),
												(!$elm$core$List$isEmpty(membershipPatients)) ? A2(
												$author$project$Ui$Element$view,
												_List_Nil,
												A2(
													$elm$core$List$cons,
													A2(
														$author$project$Ui$Typography$em,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('These related patients will also have their membership deleted.')
															])),
													A2(
														$elm$core$List$map,
														function (membershipPatient) {
															var patient = $author$project$Api$Provider$MembershipPatient$ForMembershipOne$patient(membershipPatient);
															var memberType = $author$project$Api$Provider$MembershipPatient$ForMembershipOne$memberType(membershipPatient);
															return A2(
																$author$project$Ui$Form$Group$view,
																_List_fromArray(
																	[
																		$author$project$Ui$Form$Group$labelSpan(4),
																		$author$project$Ui$Form$Group$inputSpan(4),
																		$author$project$Ui$Form$Group$label(
																		(memberType === 1) ? 'Adult' : $author$project$Formatters$String$titleize(
																			$author$project$Api$MemberRelationship$toString(memberType)))
																	]),
																_List_fromArray(
																	[
																		A2(
																		$author$project$Ui$Form$Static$view,
																		_List_Nil,
																		_List_fromArray(
																			[
																				A3(
																				$author$project$Ui$Link$route,
																				$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
																					{
																						YZ: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$id(patient)
																					}),
																				_List_Nil,
																				_List_fromArray(
																					[
																						A2(
																						$author$project$Ui$Typography$text,
																						_List_fromArray(
																							[
																								$author$project$Ui$Typography$phi(true)
																							]),
																						$author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$name(patient))
																					]))
																			]))
																	]));
														},
														membershipPatients))) : $author$project$Utils$Html$empty
											])),
										$author$project$Components$HiConfirm$loading(
										_Utils_eq(deleteRequest, $author$project$Api$Data$Loading))
									]));
						} else {
							return $author$project$Utils$Html$empty;
						}
					}(),
						function () {
						var _v2 = model.d$;
						if (!_v2.$) {
							var cancelModal = _v2.a;
							return A2(
								$elm$html$Html$map,
								$author$project$Components$Membership$Form$CancelModalMsg,
								A2($author$project$Components$Membership$Form$CancelModal$view, model.afq, cancelModal));
						} else {
							return $author$project$Utils$Html$empty;
						}
					}(),
						function () {
						var _v3 = model.k0;
						if (!_v3.$) {
							var restartModal = _v3.a;
							return A2(
								$elm$html$Html$map,
								$author$project$Components$Membership$Form$RestartModalMsg,
								$author$project$Components$Membership$Form$RestartModal$view(restartModal));
						} else {
							return $author$project$Utils$Html$empty;
						}
					}(),
						function () {
						var _v4 = model.g3;
						if (!_v4.$) {
							var _v5 = _v4.a;
							var outsideAgeRangeModal = _v5.a;
							return A2($author$project$Components$Membership$Form$OutsideAgeRangeModal$view, $author$project$Components$Membership$Form$OutsideAgeRangeModalClosed, outsideAgeRangeModal);
						} else {
							return $author$project$Utils$Html$empty;
						}
					}()
					]),
					function () {
					var _v6 = model.m;
					if (!_v6.$) {
						var sections = _v6.a;
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$Membership$Form$SummaryMsg,
								$author$project$Components$Membership$Form$Sections$Summary$modal(sections.acF)),
								A2(
								$elm$html$Html$map,
								$author$project$Components$Membership$Form$MembersMsg,
								$author$project$Components$Membership$Form$Sections$Members$modal(sections.N)),
								A2(
								$elm$html$Html$map,
								$author$project$Components$Membership$Form$ContractsMsg,
								$author$project$Components$Membership$Form$Sections$Contracts$modal(sections.a4)),
								A2(
								$elm$html$Html$map,
								$author$project$Components$Membership$Form$RecurringChargesMsg,
								$author$project$Components$Membership$Form$Sections$RecurringCharges$modal(sections.$h)),
								function () {
								var _v7 = sections.kG;
								if (!_v7.$) {
									var planChange = _v7.a;
									return A2(
										$elm$html$Html$map,
										$author$project$Components$Membership$Form$PlanChangeMsg,
										$author$project$Components$Membership$Form$Sections$PlanChange$modal(planChange));
								} else {
									return $author$project$Utils$Html$empty;
								}
							}()
							]);
					} else {
						return _List_Nil;
					}
				}(),
					_List_fromArray(
					[
						function () {
						var _v8 = model.kU;
						if (!_v8.$) {
							var renewContractModal = _v8.a;
							return A2(
								$elm$html$Html$map,
								$author$project$Components$Membership$Form$RenewContractModalMsg,
								$author$project$Components$Membership$Form$RenewContractModal$view(renewContractModal));
						} else {
							return $author$project$Utils$Html$empty;
						}
					}()
					])
				])));
};
var $author$project$Components$Membership$Form$CancelMembership = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Membership$Form$ConfirmMembership = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Membership$Form$DeleteMembership = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Membership$Form$RestartMembership = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Membership$Form$Save = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$Membership$Shared$endDate = function (_v0) {
	var record = _v0;
	return record.sb;
};
var $author$project$Api$Provider$Membership$One$endDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Membership$Shared$endDate(shared);
};
var $author$project$Api$Provider$Membership$Shared$endDateFarInThePast = function (_v0) {
	var record = _v0;
	return record.Ru;
};
var $author$project$Api$Provider$Membership$One$endDateFarInThePast = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Membership$Shared$endDateFarInThePast(shared);
};
var $author$project$Ui$Typography$HiddenXs = {$: 19};
var $author$project$Ui$Typography$hiddenXs = $author$project$Ui$Typography$HiddenXs;
var $author$project$Api$Provider$Membership$One$isCancellable = function (_v0) {
	var record = _v0.b;
	return record.UF;
};
var $author$project$Api$Provider$Membership$One$isConfirmable = function (_v0) {
	var record = _v0.b;
	return record.UG;
};
var $author$project$Api$Provider$Membership$One$isDestroyable = function (_v0) {
	var record = _v0.b;
	return record.UN;
};
var $author$project$Api$Provider$Membership$Shared$isRestartable = function (_v0) {
	var record = _v0;
	return record.Vb;
};
var $author$project$Api$Provider$Membership$One$isRestartable = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Membership$Shared$isRestartable(shared);
};
var $author$project$Components$Membership$Form$RenewContract = F2(
	function (a, b) {
		return {$: 25, a: a, b: b};
	});
var $author$project$Components$Membership$Form$viewRenewContractButton = F2(
	function (dirty, membership) {
		return ($author$project$Api$Provider$Membership$One$contractExpires(membership) && ((!(dirty && $author$project$Api$Provider$Membership$One$isUpdatable(membership))) && (!$author$project$Api$Provider$Membership$One$isRestartable(membership)))) ? A3(
			$author$project$Ui$Button$view,
			{mm: 'Renew contract'},
			_List_fromArray(
				[
					$author$project$Ui$Button$success,
					$author$project$Ui$Button$onClick(
					A2(
						$author$project$Components$Membership$Form$RenewContract,
						$author$project$Api$Provider$Membership$One$id(membership),
						$author$project$Api$Provider$Membership$One$lastContract(membership)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Renew Contract')
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Components$Membership$Form$viewEditButtons = F3(
	function (dirty, membership, model) {
		return _List_fromArray(
			[
				A2($author$project$Components$Membership$Form$viewRenewContractButton, dirty, membership),
				(dirty && $author$project$Api$Provider$Membership$One$isUpdatable(membership)) ? A3(
				$author$project$Ui$Button$view,
				{mm: 'Update membership'},
				_List_fromArray(
					[
						$author$project$Ui$Button$primary,
						$author$project$Ui$Button$loading(
						$author$project$Components$Membership$Form$isBusy(model)),
						$author$project$Ui$Button$onClick(
						$author$project$Components$Membership$Form$Save(false))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Update')
					])) : $author$project$Utils$Html$empty,
				((!dirty) && $author$project$Api$Provider$Membership$One$isCancellable(membership)) ? A3(
				$author$project$Ui$Button$view,
				{mm: 'End membership'},
				_List_fromArray(
					[
						$author$project$Ui$Button$danger,
						$author$project$Ui$Button$loading(
						_Utils_eq(model.k9, $author$project$Api$Data$Loading)),
						$author$project$Ui$Button$onClick(
						$author$project$Components$Membership$Form$CancelMembership(membership))
					]),
				_List_fromArray(
					[
						$author$project$Ui$Icon$stop(_List_Nil),
						$elm$html$Html$text(' End'),
						A2(
						$author$project$Ui$Typography$text,
						_List_fromArray(
							[$author$project$Ui$Typography$hiddenXs]),
						' Membership')
					])) : $author$project$Utils$Html$empty,
				$author$project$Api$Provider$Membership$One$isDestroyable(membership) ? A3(
				$author$project$Ui$Button$view,
				{mm: 'Delete membership'},
				_List_fromArray(
					[
						$author$project$Ui$Button$danger,
						$author$project$Ui$Button$loading(
						_Utils_eq(model.k9, $author$project$Api$Data$Loading)),
						$author$project$Ui$Button$onClick(
						$author$project$Components$Membership$Form$DeleteMembership(membership)),
						$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Delete'),
						A2(
						$author$project$Ui$Typography$text,
						_List_fromArray(
							[$author$project$Ui$Typography$hiddenXs]),
						' Membership')
					])) : $author$project$Utils$Html$empty,
				function () {
				var _v0 = $author$project$Api$Provider$Membership$One$endDate(membership);
				if (!_v0.$) {
					var isRestartable = $author$project$Api$Provider$Membership$One$isRestartable(membership);
					var endDateFarInThePast = $author$project$Api$Provider$Membership$One$endDateFarInThePast(membership);
					var button = A3(
						$author$project$Ui$Button$view,
						{mm: 'Restart memberhsip'},
						_List_fromArray(
							[
								$author$project$Ui$Button$styled(1),
								$author$project$Ui$Button$loading(
								_Utils_eq(model.k9, $author$project$Api$Data$Loading)),
								$author$project$Ui$Button$onClick(
								$author$project$Components$Membership$Form$RestartMembership(membership)),
								$author$project$Ui$Button$disabled(
								!$author$project$Api$Provider$Membership$One$isRestartable(membership))
							]),
						_List_fromArray(
							[
								$author$project$Ui$Icon$repeat(_List_Nil),
								$elm$html$Html$text(' Restart'),
								A2(
								$author$project$Ui$Typography$text,
								_List_fromArray(
									[$author$project$Ui$Typography$hiddenXs]),
								' Membership')
							]));
					var _v1 = _Utils_Tuple2(isRestartable, endDateFarInThePast);
					if (_v1.a) {
						return button;
					} else {
						if (_v1.b) {
							return A3(
								$author$project$Ui$Tooltip$view,
								_List_Nil,
								'Memberships which ended more than 3 months in the past cannot be restarted. Please create a new membership for the patient.',
								_List_fromArray(
									[button]));
						} else {
							return A3(
								$author$project$Ui$Tooltip$view,
								_List_Nil,
								'This membership is not restartable',
								_List_fromArray(
									[button]));
						}
					}
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				((!dirty) && $author$project$Api$Provider$Membership$One$isConfirmable(membership)) ? A3(
				$author$project$Ui$Button$view,
				{mm: 'Confirm membership'},
				_List_fromArray(
					[
						$author$project$Ui$Button$primary,
						$author$project$Ui$Button$loading(
						_Utils_eq(model.k9, $author$project$Api$Data$Loading)),
						$author$project$Ui$Button$onClick(
						$author$project$Components$Membership$Form$ConfirmMembership(membership))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Confirm'),
						A2(
						$author$project$Ui$Typography$text,
						_List_fromArray(
							[$author$project$Ui$Typography$hiddenXs]),
						' Membership')
					])) : $author$project$Utils$Html$empty
			]);
	});
var $author$project$Components$Membership$Form$Sections$BillsOverview$IssueInvoice = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$MembershipBill$ForMembershipOne$charges = function (_v0) {
	var record = _v0.b;
	return record.NA;
};
var $author$project$Api$Provider$MembershipBill$Shared$couponDiscountInCents = function (_v0) {
	var record = _v0;
	return record.OQ;
};
var $author$project$Api$Provider$MembershipBill$ForMembershipOne$couponDiscountInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$MembershipBill$Shared$couponDiscountInCents(shared);
};
var $author$project$Api$Provider$MembershipBill$Shared$couponDiscountMonths = function (_v0) {
	var record = _v0;
	return record.OR;
};
var $author$project$Api$Provider$MembershipBill$ForMembershipOne$couponDiscountMonths = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$MembershipBill$Shared$couponDiscountMonths(shared);
};
var $author$project$Api$Provider$Membership$Meta$invoiceNowAction = function (_v0) {
	var meta = _v0;
	return meta.vy.Ut;
};
var $author$project$Utils$Date$isAfterOrEqual = F2(
	function (date, otherDate) {
		return A2($author$project$Utils$Date$isAfter, date, otherDate) || _Utils_eq(date, otherDate);
	});
var $author$project$Components$Membership$Form$Sections$BillsOverview$isFirstUninvoicedBill = F3(
	function (isNew, membershipBills, index) {
		return isNew ? false : _Utils_eq(
			A2(
				$elm_community$list_extra$List$Extra$findIndex,
				function (membershipBill) {
					return !$author$project$Utils$Maybe$toBool(
						$author$project$Api$Provider$MembershipBill$ForMembershipOne$invoice(membershipBill));
				},
				membershipBills),
			$elm$core$Maybe$Just(index));
	});
var $author$project$Api$Provider$MembershipBill$Shared$membershipAmountInCents = function (_v0) {
	var record = _v0;
	return record.WP;
};
var $author$project$Api$Provider$MembershipBill$ForMembershipOne$membershipAmountInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$MembershipBill$Shared$membershipAmountInCents(shared);
};
var $author$project$Api$Common$Payable$Invoice$Min$paymentScheduledOn = function (_v0) {
	var record = _v0;
	return record.Zf;
};
var $author$project$Api$Provider$MembershipBill$Shared$periodInMonths = function (_v0) {
	var record = _v0;
	return record.Zs;
};
var $author$project$Api$Provider$MembershipBill$ForMembershipOne$periodInMonths = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$MembershipBill$Shared$periodInMonths(shared);
};
var $author$project$Api$Provider$Membership$One$shouldBeBilledUpToDate = function (_v0) {
	var record = _v0.b;
	return record.abf;
};
var $author$project$Api$Provider$MembershipBillCharge$ForMembershipOne$amountInCents = function (_v0) {
	var record = _v0;
	return record.LE;
};
var $author$project$Api$Provider$MembershipBillCharge$ForMembershipOne$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$MembershipBillCharge$ForMembershipOne$quantity = function (_v0) {
	var record = _v0;
	return record.Dz;
};
var $author$project$Components$Membership$Form$Sections$BillsOverview$viewMembershipBillCharge = function (membershipBillCharge) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$strong,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$text,
								_List_fromArray(
									[
										$author$project$Ui$Typography$phi(true)
									]),
								A2(
									$author$project$Formatters$String$ellipsis,
									27,
									$author$project$Api$Provider$MembershipBillCharge$ForMembershipOne$name(membershipBillCharge))),
								A2(
								$author$project$Ui$Typography$text,
								_List_fromArray(
									[
										$author$project$Ui$Typography$phi(true)
									]),
								' x ')
							])),
						$elm$html$Html$text(
						$elm$core$String$fromInt(
							$author$project$Api$Provider$MembershipBillCharge$ForMembershipOne$quantity(membershipBillCharge)))
					])),
				$author$project$Utils$Html$noBreakSpace,
				$elm$html$Html$text(
				$author$project$Utils$Currency$fromInt(
					$author$project$Api$Provider$MembershipBillCharge$ForMembershipOne$amountInCents(membershipBillCharge)))
			]));
};
var $author$project$Components$Membership$Form$Sections$BillsOverview$viewMembershipBill = F5(
	function (shared, model, membershipBills, index, membershipBill) {
		var startDate = $author$project$Api$Provider$MembershipBill$ForMembershipOne$startDate(membershipBill);
		var invoice = $author$project$Api$Provider$MembershipBill$ForMembershipOne$invoice(membershipBill);
		var date = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Api$Provider$MembershipBill$ForMembershipOne$date(membershipBill),
			startDate);
		var couponDiscountInCents = $author$project$Api$Provider$MembershipBill$ForMembershipOne$couponDiscountInCents(membershipBill);
		var _v0 = shared;
		var membership = _v0.kk;
		var pendingMembership = _v0.dC;
		var isNew = _v0.j1;
		var sameAsOriginal = _v0.hv;
		var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
		var owner = $author$project$Api$Provider$Membership$One$owner(membership);
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label(
					A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$MonthAndYear, date))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$primary]),
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$MembershipBill$ForMembershipOne$amountInCents(membershipBill))),
									function () {
									if (!invoice.$) {
										var invoice_ = invoice.a;
										return A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$author$project$Utils$Html$noBreakSpace,
													A2(
													$author$project$Ui$Badge$fromString,
													_List_Nil,
													$author$project$Api$Common$Payable$Invoice$Min$humanStatus(invoice_))
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}(),
									($author$project$Api$Provider$Membership$Meta$invoiceNowAction(membershipMeta) && ($author$project$Api$Provider$Membership$One$isConfirmed(membership) && A3($author$project$Components$Membership$Form$Sections$BillsOverview$isFirstUninvoicedBill, isNew, membershipBills, index))) ? A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Utils$Html$noBreakSpace,
											A3(
											$author$project$Ui$Button$view,
											{mm: 'Invoice now'},
											_List_fromArray(
												[
													$author$project$Ui$Button$sm,
													$author$project$Ui$Button$onClick(
													$author$project$Components$Membership$Form$Sections$BillsOverview$IssueInvoice(startDate)),
													$author$project$Ui$Button$disabled(!sameAsOriginal),
													$author$project$Ui$Button$loading(
													_Utils_eq(model.mt, $author$project$Api$Data$Loading)),
													$author$project$Ui$Button$icon($author$project$Ui$Icon$check)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(' Invoice Now')
												]))
										])) : $author$project$Utils$Html$empty,
									function () {
									if (!invoice.$) {
										var invoice_ = invoice.a;
										var invoiceRoute = $author$project$Api$Provider$Membership$One$isSponsored(membership) ? A2(
											$elm$core$Maybe$map,
											function (company_) {
												return $author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String(
													{
														fZ: $author$project$Api$Provider$Company$Shared$id(company_),
														ahP: $author$project$Api$Common$Payable$Invoice$Min$id(invoice_)
													});
											},
											$author$project$Api$Provider$Membership$One$company(pendingMembership)) : A2(
											$elm$core$Maybe$map,
											function (owner_) {
												return $author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top(
													{
														Us: $author$project$Api$Common$Payable$Invoice$Min$id(invoice_),
														YZ: $author$project$Api$Provider$Patient$Shared$id(owner_)
													});
											},
											owner);
										if (!invoiceRoute.$) {
											var route = invoiceRoute.a;
											return A2(
												$elm$html$Html$span,
												_List_Nil,
												_List_fromArray(
													[
														$author$project$Utils$Html$noBreakSpace,
														A3(
														$author$project$Ui$Link$route,
														route,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('#'),
																$elm$html$Html$text(
																$elm$core$String$fromInt(
																	$author$project$Api$Common$Payable$Invoice$Min$invoiceNumber(invoice_)))
															]))
													]));
										} else {
											return A2(
												$author$project$Ui$Typography$text,
												_List_fromArray(
													[$author$project$Ui$Typography$primary]),
												' #' + $elm$core$String$fromInt(
													$author$project$Api$Common$Payable$Invoice$Min$invoiceNumber(invoice_)));
										}
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								]))
						])),
					function () {
					var _v4 = $author$project$Api$Provider$Membership$One$shouldBeBilledUpToDate(pendingMembership);
					if (!_v4.$) {
						var shouldBeBilledUpToDate_ = _v4.a;
						var autopay = A2(
							$elm$core$Maybe$withDefault,
							false,
							A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Shared$autopay, owner));
						return (autopay && ((!(!A2(
							$justinmimbs$date$Date$compare,
							shouldBeBilledUpToDate_,
							$author$project$Api$Provider$MembershipBill$ForMembershipOne$date(membershipBill)))) && ((!$author$project$Utils$Maybe$toBool(invoice)) && (!$author$project$Api$Provider$Membership$One$isSponsored(membership))))) ? A2(
							$author$project$Ui$Typography$p,
							_List_fromArray(
								[$author$project$Ui$Typography$small]),
							_List_fromArray(
								[
									$elm$html$Html$text('Will automatically invoice '),
									A2(
									$author$project$Utils$Date$isAfterOrEqual,
									model.dd,
									$author$project$Api$Provider$MembershipBill$ForMembershipOne$date(membershipBill)) ? $elm$html$Html$text('and bill ') : $elm$html$Html$text(' '),
									$elm$html$Html$text('tonight.')
								])) : $author$project$Utils$Html$empty;
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					function () {
					var _v5 = _Utils_Tuple2(
						$author$project$Api$Provider$Membership$One$isSponsored(membership),
						A2($elm$core$Maybe$andThen, $author$project$Api$Common$Payable$Invoice$Min$paymentScheduledOn, invoice));
					if (!_v5.a) {
						if (!_v5.b.$) {
							var paymenScheduledOn = _v5.b.a;
							var contents = (!A2($justinmimbs$date$Date$compare, model.dd, paymenScheduledOn)) ? _List_fromArray(
								[
									$elm$html$Html$text('Payment scheduled for '),
									$elm$html$Html$text(
									A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, paymenScheduledOn)),
									$elm$html$Html$text('.')
								]) : _List_fromArray(
								[
									$elm$html$Html$text('Payment scheduled for tonight.')
								]);
							return A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$small]),
								contents);
						} else {
							var _v6 = _v5.b;
							return $author$project$Utils$Html$empty;
						}
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$muted]),
					_List_fromArray(
						[
							$author$project$Api$Provider$Membership$One$isSponsored(membership) ? $author$project$Utils$Html$empty : $elm$html$Html$text('Due '),
							$elm$html$Html$text(
							A2(
								$author$project$Formatters$Date$toString,
								$author$project$Formatters$Date$Full,
								$author$project$Api$Provider$MembershipBill$ForMembershipOne$date(membershipBill)))
						])),
					function () {
					var _v7 = $author$project$Api$Provider$MembershipBill$ForMembershipOne$registrationFeeInCents(membershipBill);
					if (!_v7.$) {
						var registrationFeeInCents = _v7.a;
						return (registrationFeeInCents > 0) ? A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Registration Fee')
										])),
									$author$project$Utils$Html$noBreakSpace,
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(registrationFeeInCents))
								])) : $author$project$Utils$Html$empty;
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$author$project$Components$Membership$Form$Sections$BillsOverview$viewMembershipBillCharge,
						$author$project$Api$Provider$MembershipBill$ForMembershipOne$charges(membershipBill))),
					function () {
					if (($author$project$Api$Provider$MembershipBill$ForMembershipOne$membershipAmountInCents(membershipBill) > 0) || ($author$project$Api$Provider$MembershipBill$ForMembershipOne$couponDiscountInCents(membershipBill) > 0)) {
						var periodInMonths = A2(
							$elm$core$Maybe$withDefault,
							0,
							$author$project$Api$Provider$MembershipBill$ForMembershipOne$periodInMonths(membershipBill));
						return A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Membership')
										])),
									$author$project$Utils$Html$noBreakSpace,
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$MembershipBill$ForMembershipOne$membershipAmountInCents(membershipBill))),
									$author$project$Utils$Html$noBreakSpace,
									$elm$html$Html$text(
									$author$project$Formatters$Int$asPeriod(periodInMonths))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					function () {
					if (couponDiscountInCents > 0) {
						var periodInMonths = A2(
							$elm$core$Maybe$withDefault,
							0,
							$author$project$Api$Provider$MembershipBill$ForMembershipOne$periodInMonths(membershipBill));
						var couponDiscountMonths = A2(
							$elm$core$Maybe$withDefault,
							0,
							$author$project$Api$Provider$MembershipBill$ForMembershipOne$couponDiscountMonths(membershipBill));
						return A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$muted]),
									'Includes '),
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$muted]),
									$author$project$Utils$Currency$fromInt(couponDiscountInCents)),
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$muted]),
									' coupon discount'),
									(_Utils_cmp(couponDiscountMonths, periodInMonths) < 0) ? A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[$author$project$Ui$Typography$muted]),
											'('),
											A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[$author$project$Ui$Typography$muted]),
											$author$project$Utils$Currency$fromInt((couponDiscountInCents / couponDiscountMonths) | 0)),
											A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[$author$project$Ui$Typography$muted]),
											') off for '),
											A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[$author$project$Ui$Typography$muted]),
											A2($author$project$Formatters$String$pluralize, 'month', couponDiscountMonths))
										])) : $author$project$Utils$Html$empty
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]));
	});
var $author$project$Components$Membership$Form$Sections$BillsOverview$viewMembershipBillOrSkeleton = F6(
	function (shared, model, membershipBills, priceCheckLoading, index, membershipBill) {
		return (priceCheckLoading && _Utils_eq(
			$author$project$Api$Provider$MembershipBill$ForMembershipOne$invoice(membershipBill),
			$elm$core$Maybe$Nothing)) ? A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$labelSkeleton('Jan 2025')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$static(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$span(3)
								]))
						]))
				])) : A5($author$project$Components$Membership$Form$Sections$BillsOverview$viewMembershipBill, shared, model, membershipBills, index, membershipBill);
	});
var $author$project$Components$Membership$Form$Sections$BillsOverview$viewBillsOverview = F2(
	function (shared, model) {
		var _v0 = shared;
		var pendingMembership = _v0.dC;
		var priceCheckLoading = _v0.akf;
		var owner = $author$project$Api$Provider$Membership$One$owner(pendingMembership);
		var autopay = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Shared$autopay, owner));
		var upcomingAndOutstandingBills = $author$project$Api$Provider$Membership$One$upcomingAndOutstandingBills(pendingMembership);
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							$author$project$Ui$HorizontalRule$view(_List_Nil),
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('Bills overview')
								])),
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$labelSpanSm(3),
									$author$project$Ui$Form$Group$inputSpanSm(9),
									$author$project$Ui$Form$Group$label('Autopay')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$strong,
											_List_Nil,
											_List_fromArray(
												[
													autopay ? $elm$html$Html$text('Enabled') : $elm$html$Html$text('Disabled')
												]))
										]))
								]))
						]),
						A2(
						$elm$core$List$indexedMap,
						A4($author$project$Components$Membership$Form$Sections$BillsOverview$viewMembershipBillOrSkeleton, shared, model, upcomingAndOutstandingBills, priceCheckLoading),
						upcomingAndOutstandingBills)
					])));
	});
var $author$project$Components$Membership$Form$Sections$BillsOverview$view = F2(
	function (shared, model) {
		return $elm$core$List$isEmpty(
			$author$project$Api$Provider$Membership$One$upcomingAndOutstandingBills(shared.dC)) ? $author$project$Utils$Html$empty : A2($author$project$Components$Membership$Form$Sections$BillsOverview$viewBillsOverview, shared, model);
	});
var $author$project$Components$Membership$Form$Sections$Contracts$ToggleAllContracts = {$: 2};
var $author$project$Api$Provider$Membership$One$firstContract = function (_v0) {
	var record = _v0.b;
	return record.Su;
};
var $author$project$Api$Provider$MembershipContract$Shared$isUpcoming = function (_v0) {
	var record = _v0;
	return record.Vj;
};
var $author$project$Api$Provider$MembershipContract$All$endDate = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$MembershipContract$Shared$endDate(shared);
};
var $author$project$Api$Provider$MembershipContract$Shared$memo = function (_v0) {
	var record = _v0;
	return record.aiG;
};
var $author$project$Api$Provider$MembershipContract$All$memo = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$MembershipContract$Shared$memo(shared);
};
var $author$project$Api$Provider$MembershipContract$Shared$startDate = function (_v0) {
	var record = _v0;
	return record.ab7;
};
var $author$project$Api$Provider$MembershipContract$All$startDate = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$MembershipContract$Shared$startDate(shared);
};
var $author$project$Components$Membership$Form$Sections$Contracts$CancelContract = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Membership$Form$Sections$Contracts$viewMembershipContract = F7(
	function (canCancel, isNew, membership, period, startDate, endDate, memo) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label(
					'Contract period ' + $elm$core$String$fromInt(period))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_fromArray(
						[$author$project$Ui$Form$Static$flex, $author$project$Ui$Form$Static$spaceBetween, $author$project$Ui$Form$Static$itemsCenter]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										A2(
											$elm$core$Maybe$map,
											$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
											startDate))),
									$elm$html$Html$text(' - '),
									A3(
									$author$project$Ui$Tooltip$view,
									_List_fromArray(
										[
											$author$project$Ui$Tooltip$placement(0)
										]),
									memo,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[$author$project$Ui$Typography$gray, $author$project$Ui$Typography$ellipsis]),
											memo)
										])),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										A2(
											$elm$core$Maybe$map,
											$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
											endDate)))
								])),
							function () {
							var _v0 = _Utils_Tuple2(canCancel, isNew);
							if (_v0.a && _v0.b) {
								return A3(
									$author$project$Ui$Button$view,
									{mm: 'Cancel contract'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick(
											$author$project$Components$Membership$Form$Sections$Contracts$CancelContract(
												$author$project$Api$Provider$Membership$One$id(membership)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Cancel contract')
										]));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						]))
				]));
	});
var $author$project$Components$Membership$Form$Sections$Contracts$viewMembershipContractAll = F6(
	function (membershipContracts, canCancel, isNew, membership, index, membershipContract) {
		if ((!index) || _Utils_eq(
			index,
			$elm$core$List$length(membershipContracts) - 1)) {
			return $author$project$Utils$Html$empty;
		} else {
			var startDate = $author$project$Api$Provider$MembershipContract$All$startDate(membershipContract);
			var memo = A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Api$Provider$MembershipContract$All$memo(membershipContract));
			var endDate = $author$project$Api$Provider$MembershipContract$All$endDate(membershipContract);
			return A7(
				$author$project$Components$Membership$Form$Sections$Contracts$viewMembershipContract,
				canCancel,
				isNew,
				membership,
				index + 1,
				$elm$core$Maybe$Just(startDate),
				endDate,
				memo);
		}
	});
var $author$project$Components$Membership$Form$Sections$Contracts$viewMembershipContractShared = F5(
	function (canCancel, isNew, membership, period, membershipContract) {
		var startDate = A2($elm$core$Maybe$map, $author$project$Api$Provider$MembershipContract$Shared$startDate, membershipContract);
		var memo = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm$core$Maybe$andThen, $author$project$Api$Provider$MembershipContract$Shared$memo, membershipContract));
		var endDate = A2($elm$core$Maybe$andThen, $author$project$Api$Provider$MembershipContract$Shared$endDate, membershipContract);
		return A7($author$project$Components$Membership$Form$Sections$Contracts$viewMembershipContract, canCancel, isNew, membership, period, startDate, endDate, memo);
	});
var $author$project$Components$Membership$Form$Sections$Contracts$viewContracts = F4(
	function (showAllContracts, isNew, membership, membershipContracts) {
		var firstContract = $author$project$Api$Provider$Membership$One$firstContract(membership);
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A5($author$project$Components$Membership$Form$Sections$Contracts$viewMembershipContractShared, false, isNew, membership, 1, firstContract)
						]),
						(($elm$core$List$length(membershipContracts) > 2) && (!showAllContracts)) ? _List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$labelSpanSm(3),
									$author$project$Ui$Form$Group$inputSpanSm(9),
									$author$project$Ui$Form$Group$label('')
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Show more contracts'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$Contracts$ToggleAllContracts)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Show more')
										]))
								]))
						]) : _List_Nil,
						showAllContracts ? A2(
						$elm$core$List$indexedMap,
						A4($author$project$Components$Membership$Form$Sections$Contracts$viewMembershipContractAll, membershipContracts, false, isNew, membership),
						membershipContracts) : _List_Nil,
						function () {
						if ($elm$core$List$length(membershipContracts) > 1) {
							var lastContract = $author$project$Api$Provider$Membership$One$lastContract(membership);
							return _List_fromArray(
								[
									A5(
									$author$project$Components$Membership$Form$Sections$Contracts$viewMembershipContractShared,
									A2(
										$elm$core$Maybe$withDefault,
										false,
										A2($elm$core$Maybe$map, $author$project$Api$Provider$MembershipContract$Shared$isUpcoming, lastContract)),
									isNew,
									membership,
									$elm$core$List$length(membershipContracts),
									lastContract)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						showAllContracts ? _List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$labelSpanSm(3),
									$author$project$Ui$Form$Group$inputSpanSm(9),
									$author$project$Ui$Form$Group$label('')
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Show less contracts'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$Contracts$ToggleAllContracts)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Show less')
										]))
								]))
						]) : _List_Nil
					])));
	});
var $author$project$Components$Membership$Form$Sections$Contracts$FormUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Membership$Form$Sections$Contracts$PeriodInMonths = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Membership$Form$Sections$Contracts$viewContractPeriodInMonthsField = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var periodInMonths = _v0.Zs;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(4),
				$author$project$Ui$Form$Group$label('Contract period'),
				$author$project$Ui$Form$Group$required(true)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$PeriodInMonthsInput$view(
				{
					agX: A2($author$project$Utils$Form$validationErrors, 1, form),
					sM: A2($author$project$Utils$Form$hasValidationErrors, 1, form),
					ajm: A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Sections$Contracts$FormUpdated, $author$project$Components$Membership$Form$Sections$Contracts$PeriodInMonths),
					aee: periodInMonths
				})
			]));
};
var $author$project$Components$Membership$Form$Sections$Contracts$Type = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Membership$Meta$contractTypeValues = function (_v0) {
	var meta = _v0;
	return meta.G3.q_;
};
var $author$project$Components$Membership$Form$Sections$Contracts$typeOptions = function (membershipMeta) {
	var types = $author$project$Api$Provider$Membership$Meta$contractTypeValues(membershipMeta);
	return A2(
		$elm$core$List$cons,
		A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(''),
			'Choose an action'),
		A2(
			$elm$core$List$map,
			function (type_) {
				var typeString = $author$project$Api$ContractType$toString(type_);
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(typeString),
					$author$project$Formatters$String$titleize(
						$author$project$Formatters$String$humanize(typeString)));
			},
			types));
};
var $author$project$Components$Membership$Form$Sections$Contracts$viewContractTypeField = F2(
	function (membershipMeta, form) {
		var _v0 = $author$project$Utils$Form$fields(form);
		var type_ = _v0.amg;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(4),
					$author$project$Ui$Form$Group$label('At End Of Period'),
					$author$project$Ui$Form$Group$required(true)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Select$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Select$value(
							A2($elm$core$Maybe$map, $author$project$Api$ContractType$toString, type_)),
							$author$project$Ui$Form$Select$onChange(
							A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Sections$Contracts$FormUpdated, $author$project$Components$Membership$Form$Sections$Contracts$Type)),
							$author$project$Ui$Form$Select$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
							$author$project$Ui$Form$Select$errors(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						]),
					$author$project$Components$Membership$Form$Sections$Contracts$typeOptions(membershipMeta))
				]));
	});
var $author$project$Components$Membership$Form$Sections$Contracts$EndDate = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Membership$Form$Sections$Contracts$ToggleEditEndDate = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Membership$Meta$contractEndDateValues = function (_v0) {
	var meta = _v0;
	return meta.yQ.q_;
};
var $author$project$Components$Membership$Form$Sections$Contracts$validContractEndDates = function (pendingMembership) {
	var membershipMeta = $author$project$Api$Provider$Membership$One$meta(pendingMembership);
	var contractEndDates = $author$project$Api$Provider$Membership$Meta$contractEndDateValues(membershipMeta);
	var contractEndDate = function () {
		var _v1 = $author$project$Api$Provider$Membership$One$contractEndDate(pendingMembership);
		if (!_v1.$) {
			var date = _v1.a;
			return $elm$core$Maybe$Just(date);
		} else {
			return $author$project$Api$Provider$Membership$Meta$contractEndDateDefault(membershipMeta);
		}
	}();
	return A2(
		$elm$core$List$sortBy,
		$justinmimbs$date$Date$toRataDie,
		function () {
			if (!contractEndDate.$) {
				var date = contractEndDate.a;
				return A2($elm$core$List$member, date, contractEndDates) ? contractEndDates : A2($elm$core$List$cons, date, contractEndDates);
			} else {
				return contractEndDates;
			}
		}());
};
var $author$project$Components$Membership$Form$Sections$Contracts$endDatesOptions = function (pendingMembership) {
	return A2(
		$elm$core$List$map,
		function (date) {
			var dateString = $justinmimbs$date$Date$toIsoString(date);
			return A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(dateString),
				A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, date));
		},
		$author$project$Components$Membership$Form$Sections$Contracts$validContractEndDates(pendingMembership));
};
var $author$project$Api$Provider$Membership$One$finalBillingEndDate = function (_v0) {
	var record = _v0.b;
	return record.Sq;
};
var $author$project$Components$Membership$Form$Sections$Contracts$viewEndDateField = F3(
	function (pendingMembership, editEndDate, form) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Contract End Date')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					function () {
						if ((!editEndDate) && $author$project$Api$Provider$Membership$One$contractExpires(pendingMembership)) {
							var meta = $author$project$Api$Provider$Membership$One$meta(pendingMembership);
							var contractEndDate = function () {
								var _v0 = _Utils_Tuple2(
									$author$project$Api$Provider$Membership$One$contractEndDate(pendingMembership),
									$author$project$Api$Provider$Membership$Meta$contractEndDateDefault(meta));
								if (!_v0.a.$) {
									var date = _v0.a.a;
									return $elm$core$Maybe$Just(date);
								} else {
									var _v1 = _v0.a;
									var contractEndDateDefault = _v0.b;
									return contractEndDateDefault;
								}
							}();
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Static$view,
											_List_fromArray(
												[$author$project$Ui$Form$Static$flex, $author$project$Ui$Form$Static$spaceBetween, $author$project$Ui$Form$Static$itemsCenter]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2(
														$elm$core$Maybe$withDefault,
														'N/A',
														A2(
															$elm$core$Maybe$map,
															$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
															contractEndDate))),
													A3(
													$author$project$Ui$Button$view,
													{mm: 'Change contract end date'},
													_List_fromArray(
														[
															$author$project$Ui$Button$link,
															$author$project$Ui$Button$onClick(
															$author$project$Components$Membership$Form$Sections$Contracts$ToggleEditEndDate(
																$author$project$Api$Provider$Membership$One$contractEndDate(pendingMembership)))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Change Contract End Date')
														]))
												]))
										]))
								]);
						} else {
							var _v2 = $author$project$Utils$Form$fields(form);
							var endDate = _v2.sb;
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanSm(5)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Select$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Select$value(
													A2($elm$core$Maybe$map, $justinmimbs$date$Date$toIsoString, endDate)),
													$author$project$Ui$Form$Select$onChange(
													A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Sections$Contracts$FormUpdated, $author$project$Components$Membership$Form$Sections$Contracts$EndDate))
												]),
											$author$project$Components$Membership$Form$Sections$Contracts$endDatesOptions(pendingMembership))
										])),
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanSm(7)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$flex, $author$project$Ui$Element$justifyRight]),
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Button$view,
													{mm: ' Cancel end date edition'},
													_List_fromArray(
														[
															$author$project$Ui$Button$link,
															$author$project$Ui$Button$onClick(
															$author$project$Components$Membership$Form$Sections$Contracts$ToggleEditEndDate(
																$author$project$Api$Provider$Membership$One$contractEndDate(pendingMembership)))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Cancel')
														]))
												]))
										]))
								]);
						}
					}()),
					(!_Utils_eq(
					$author$project$Api$Provider$Membership$One$finalBillingEndDate(pendingMembership),
					$author$project$Api$Provider$Membership$One$contractEndDate(pendingMembership))) ? A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(12)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$label,
									_List_fromArray(
										[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
									_List_fromArray(
										[
											$elm$html$Html$text('Contract end date does not align with the billing periods')
										]))
								]))
						])) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$Membership$Form$Sections$Contracts$Expires = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Membership$Form$Sections$Contracts$viewExpiresField = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var expires = _v0.RZ;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9),
				$author$project$Ui$Form$Group$label('Contract Expires')
			]),
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$view(
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$on(expires),
						$author$project$Ui$ToggleSwitch$onChange(
						A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Sections$Contracts$FormUpdated, $author$project$Components$Membership$Form$Sections$Contracts$Expires))
					]))
			]));
};
var $author$project$Components$Membership$Form$Sections$Contracts$viewForm = F3(
	function (model, pendingMembership, form) {
		var _v0 = $author$project$Utils$Form$fields(form);
		var expires = _v0.RZ;
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mb2]),
			A2(
				$elm$core$List$cons,
				$author$project$Components$Membership$Form$Sections$Contracts$viewExpiresField(form),
				function () {
					if (expires) {
						var membershipMeta = $author$project$Api$Provider$Membership$One$meta(pendingMembership);
						return _List_fromArray(
							[
								$author$project$Api$Provider$Membership$Meta$contractEndDateEditable(membershipMeta) ? A3($author$project$Components$Membership$Form$Sections$Contracts$viewEndDateField, pendingMembership, model.jv, form) : $author$project$Utils$Html$empty,
								$author$project$Api$Provider$Membership$Meta$contractPeriodInMonthsEditable(membershipMeta) ? $author$project$Components$Membership$Form$Sections$Contracts$viewContractPeriodInMonthsField(form) : $author$project$Utils$Html$empty,
								$author$project$Api$Provider$Membership$Meta$contractTypeEditable(membershipMeta) ? A2($author$project$Components$Membership$Form$Sections$Contracts$viewContractTypeField, membershipMeta, form) : $author$project$Utils$Html$empty
							]);
					} else {
						return _List_Nil;
					}
				}()));
	});
var $author$project$Components$Membership$Form$Sections$Contracts$view = F2(
	function (_v0, _v1) {
		var isNew = _v0.j1;
		var membership = _v0.kk;
		var pendingMembership = _v0.dC;
		var model = _v1;
		var plan = $author$project$Api$Provider$Membership$One$plan(membership);
		var pendingMembershipMeta = $author$project$Api$Provider$Membership$One$meta(pendingMembership);
		if (($author$project$Api$Provider$Plan$SharedWithContractInfo$contractExpires(plan) || $author$project$Api$Provider$Membership$One$contractExpires(pendingMembership)) && $author$project$Api$Provider$Membership$Meta$contractExpiresEditable(pendingMembershipMeta)) {
			var membershipContracts = A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$author$project$Api$Data$toMaybe(model.AV));
			var fields = $author$project$Utils$Form$fields(model.SD);
			return A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$HorizontalRule$view(_List_Nil),
						$author$project$Ui$Typography$headingSm(
						_List_fromArray(
							[
								$elm$html$Html$text('Contract Periods')
							])),
						A3($author$project$Components$Membership$Form$Sections$Contracts$viewForm, model, pendingMembership, model.SD),
						(fields.RZ && ((!$elm$core$List$isEmpty(membershipContracts)) && $author$project$Api$Provider$Membership$One$contractExpires(pendingMembership))) ? A4($author$project$Components$Membership$Form$Sections$Contracts$viewContracts, model.uy, isNew, membership, membershipContracts) : $author$project$Utils$Html$empty
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$Membership$Form$Sections$Members$AddMember = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Membership$Form$Sections$Members$membershipPatientSortValue = F2(
	function (membership, _v0) {
		var originalIndex = _v0.a;
		var membershipPatient = _v0.b;
		var membershipPatientRecord = $author$project$Components$Membership$Form$Members$MembershipPatient$membershipPatientFields(membershipPatient);
		var original = A2(
			$elm_community$list_extra$List$Extra$find,
			function (membershipPatient_) {
				return _Utils_eq(
					$author$project$Api$Provider$MembershipPatient$ForMembershipOne$id(membershipPatient_),
					membershipPatientRecord.ahP);
			},
			$author$project$Api$Provider$Membership$One$membershipPatients(membership));
		var _v1 = function () {
			if (!original.$) {
				var original_ = original.a;
				return _Utils_Tuple2(
					$elm$core$Maybe$Nothing,
					$author$project$Api$Provider$MembershipPatient$ForMembershipOne$endDate(original_));
			} else {
				return _Utils_Tuple2(membershipPatientRecord.Gg, membershipPatientRecord.sb);
			}
		}();
		var action = _v1.a;
		var endDate = _v1.b;
		return _Utils_eq(
			action,
			$elm$core$Maybe$Just('create')) ? _Utils_Tuple2(4, originalIndex) : (_Utils_eq(
			action,
			$elm$core$Maybe$Just('restart')) ? _Utils_Tuple2(1, originalIndex) : ((_Utils_eq(
			action,
			$elm$core$Maybe$Just('terminate')) || _Utils_eq(
			action,
			$elm$core$Maybe$Just('destroy'))) ? _Utils_Tuple2(2, originalIndex) : ((!$author$project$Utils$Maybe$toBool(endDate)) ? _Utils_Tuple2(0, originalIndex) : _Utils_Tuple2(3, originalIndex))));
	});
var $author$project$Api$Provider$Membership$Meta$membershipPatientsPatient = function (_v0) {
	var meta = _v0;
	return meta.WR.YY;
};
var $author$project$Components$Membership$Form$Sections$Members$overMaxMembershipPatientsWarning = F2(
	function (maxMembershipPatients, membershipPatients) {
		return (_Utils_cmp(
			$elm$core$Dict$size(membershipPatients),
			maxMembershipPatients) > 0) ? A2(
			$author$project$Ui$Alert$warning,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('This sponsored membership '),
					function () {
					if (maxMembershipPatients === 1) {
						return $elm$html$Html$text('does not allow dependents');
					} else {
						return $elm$html$Html$text(
							'only allows ' + A2($author$project$Formatters$String$pluralize, 'dependent', maxMembershipPatients - 1));
					}
				}(),
					$elm$html$Html$text(', by saving this membership you are choosing to exceed that limit.')
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Api$Provider$Plan$SharedWithContractInfo$isMcePlan = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$isMcePlan(shared);
};
var $author$project$Api$Provider$Membership$One$isSynced = function (_v0) {
	var record = _v0.b;
	return record.Vf;
};
var $author$project$Components$CancellationReason$Display$view = F2(
	function (cancellationReason, cancellationReasonOther) {
		var isTerminatedByPatient = cancellationReason.Qr === 'Termination by Patient';
		var patientNoteView = isTerminatedByPatient ? A2(
			$author$project$Ui$Typography$text,
			_List_fromArray(
				[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
			'\"' + (A2($elm$core$Maybe$withDefault, '', cancellationReasonOther) + '\"')) : $author$project$Utils$Html$empty;
		var descriptionText = function () {
			if (isTerminatedByPatient) {
				return 'Termination by Patient';
			} else {
				var _v0 = _Utils_Tuple2(cancellationReason.Qr, cancellationReasonOther);
				if ((_v0.a === 'Other') && (!_v0.b.$)) {
					var customReason = _v0.b.a;
					return customReason;
				} else {
					return cancellationReason.Qr;
				}
			}
		}();
		return A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(descriptionText),
							patientNoteView
						]))
				]));
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$viewCancellationReason = F2(
	function (membershipPatient, cancellationReason) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Cancellation Reason')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Components$CancellationReason$Display$view, cancellationReason, membershipPatient.afp)
						]))
				]));
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$CancellationReason = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$FormUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$viewCancellationReasonInput = F3(
	function (cancellationReasons, membershipPatient, model) {
		return $author$project$Components$CancellationReason$Input$view(
			{
				afq: cancellationReasons,
				agX: A2($author$project$Utils$Form$validationErrors, 7, model.SD),
				RO: A2($author$project$Utils$Form$validationErrors, 8, model.SD),
				aii: $elm$core$Maybe$Just(3),
				ajd: A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Members$MembershipPatient$FormUpdated, $author$project$Components$Membership$Form$Members$MembershipPatient$CancellationReason),
				aee: _Utils_Tuple2(membershipPatient.afo, membershipPatient.afp)
			});
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$viewEndDateInput = F3(
	function (pendingMembership, membershipPatient, model) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('End date'),
					$author$project$Ui$Form$Group$required(true)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Components$Membership$Form$Members$MembershipPatient$EndDateInputMsg,
					A2(
						$author$project$Components$DateInput$view,
						_List_fromArray(
							[
								$author$project$Components$DateInput$value(membershipPatient.sb),
								$author$project$Components$DateInput$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 6, model.SD)),
								$author$project$Components$DateInput$errors(
								A2($author$project$Utils$Form$validationErrors, 6, model.SD))
							]),
						model.sd)),
					($author$project$Utils$Maybe$toBool(membershipPatient.St) && (!_Utils_eq(membershipPatient.sb, model.Cf.sb))) ? A3($author$project$Components$Membership$Form$Utils$mayNeedProrationWarning, 'patient', pendingMembership, membershipPatient.sb) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$EditEnrollmentRequestedOn = {$: 4};
var $author$project$Api$Provider$Membership$Meta$membershipPatientsEnrollmentRequestedOn = function (_v0) {
	var meta = _v0;
	return meta.WR.RF;
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$viewEnrollmentRequestedOnInput = F4(
	function (membership, isPatientActive, membershipPatient, model) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Enrollment Requested')
				]),
			_List_fromArray(
				[
					function () {
					if (model.r4) {
						return A2(
							$elm$html$Html$map,
							$author$project$Components$Membership$Form$Members$MembershipPatient$EnrollmentRequestedOnInputMsg,
							A2(
								$author$project$Components$DateInput$view,
								_List_fromArray(
									[
										$author$project$Components$DateInput$value(membershipPatient.RF),
										$author$project$Components$DateInput$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 2, model.SD)),
										$author$project$Components$DateInput$errors(
										A2($author$project$Utils$Form$validationErrors, 2, model.SD))
									]),
								model.sh));
					} else {
						var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
						var enrollmentRequestedOnIsEditable = (!model.bf) && $author$project$Api$Provider$Membership$Meta$membershipPatientsEnrollmentRequestedOn(membershipMeta);
						return A2(
							$author$project$Ui$Form$Static$view,
							_List_fromArray(
								[$author$project$Ui$Form$Static$flex, $author$project$Ui$Form$Static$spaceBetween, $author$project$Ui$Form$Static$itemsCenter]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										A2(
											$elm$core$Maybe$map,
											$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
											membershipPatient.RF))),
									(isPatientActive && enrollmentRequestedOnIsEditable) ? A3(
									$author$project$Ui$Button$view,
									{mm: 'Change enrollment requested on date'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Members$MembershipPatient$EditEnrollmentRequestedOn)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Change Date')
										])) : $author$project$Utils$Html$empty
								]));
					}
				}()
				]));
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$FixedPeriodRateInCents = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$ToggleFixedPeriodRateInCentsOverride = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$billAffiliateRateEnabled = F2(
	function (practice, company) {
		var ratesFromAffiliate = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$Network$Shared$ratesFromAffiliate,
				$author$project$Api$Provider$Practice$One$network(practice)));
		var billAffiliateRateCompanySetting = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Company$Shared$billAffiliateRate, company));
		return ratesFromAffiliate && billAffiliateRateCompanySetting;
	});
var $author$project$Api$Provider$Membership$Meta$membershipPatientsFixedPeriodRateInCents = function (_v0) {
	var meta = _v0;
	return meta.WR.Sx;
};
var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$revenueInCents = function (_v0) {
	var record = _v0.b;
	return record.$_;
};
var $author$project$Formatters$Int$asPeriodHuman = function (periodInMonths) {
	switch (periodInMonths) {
		case 1:
			return 'Monthly';
		case 3:
			return 'Quarterly';
		case 6:
			return 'Semi-annually';
		case 12:
			return 'Annually';
		default:
			return 'Every ' + ($elm$core$String$fromInt(periodInMonths) + ' Months');
	}
};
var $author$project$Components$FixedRate$view = F3(
	function (_v0, onInput, toggleEdit) {
		var editable = _v0.Q4;
		var disabled = _v0.ep;
		var editing = _v0.C;
		var current = _v0.Pd;
		var period = _v0.aj0;
		var value = _v0.aee;
		var billAffiliateRate = _v0.MC;
		var defaultValue = _v0.Qf;
		var errors = _v0.agX;
		return A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$span(6)
						]),
					_List_fromArray(
						[
							editing ? A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Form$CurrencyInput$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$CurrencyInput$value(value),
											$author$project$Ui$Form$CurrencyInput$onInput(onInput),
											$author$project$Ui$Form$CurrencyInput$invalid(
											!$elm$core$List$isEmpty(errors)),
											$author$project$Ui$Form$CurrencyInput$placeholder('10.00')
										])),
									$author$project$Utils$FormErrors$view(errors)
								])) : A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Currency$format(
										A2(
											$elm$core$Maybe$withDefault,
											$author$project$Currency$fromInt(0),
											defaultValue))),
									$author$project$Utils$Html$noBreakSpace,
									$elm$html$Html$text(
									$author$project$Formatters$Int$asPeriodHuman(period))
								]))
						])),
					editable ? A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$span(6),
							$author$project$Ui$Grid$justifyRight
						]),
					_List_fromArray(
						[
							function () {
							var verb = editing ? 'Remove Override' : 'Override Rate';
							return A3(
								$author$project$Ui$Button$view,
								{mm: verb},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$onClick(toggleEdit),
										$author$project$Ui$Button$disabled((!editing) && disabled)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(verb)
									]));
						}()
						])) : $author$project$Ui$Grid$none,
					function () {
					if (!current.$) {
						return A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(12)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$helpBlock]),
									_List_fromArray(
										[
											$elm$html$Html$text('Fixed price ('),
											$elm$html$Html$text(
											$author$project$Formatters$Int$asPeriodHuman(period)),
											$elm$html$Html$text(')')
										]))
								]));
					} else {
						return $author$project$Ui$Grid$none;
					}
				}(),
					((!editable) || $author$project$Utils$Maybe$toBool(current)) ? $author$project$Ui$Grid$none : (billAffiliateRate ? A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$span(12)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$p,
							_List_fromArray(
								[$author$project$Ui$Typography$helpBlock]),
							_List_fromArray(
								[
									$elm$html$Html$text('Automatically calculated using Affiliate Rate')
								]))
						])) : A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$span(12)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$p,
							_List_fromArray(
								[$author$project$Ui$Typography$helpBlock]),
							_List_fromArray(
								[
									$elm$html$Html$text('Automatically calculated')
								]))
						])))
				]));
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$viewFixedPeriodRateInput = F5(
	function (_v0, pendingMembershipPatient, isPatientActive, membershipPatient, model) {
		var membership = _v0.kk;
		var pendingMembership = _v0.dC;
		var onlyOneFixedPeriodRateInCentsEditable = _v0.ajA;
		var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
		var fixedPeriodRateInCentsIsEditable = (!model.bf) && $author$project$Api$Provider$Membership$Meta$membershipPatientsFixedPeriodRateInCents(membershipMeta);
		var defaultValue = A2(
			$elm$core$Maybe$map,
			$author$project$Currency$fromInt,
			A2($elm$core$Maybe$andThen, $author$project$Api$Provider$MembershipPatient$ForMembershipOne$revenueInCents, pendingMembershipPatient));
		var billAffiliateRate = A2(
			$author$project$Components$Membership$Form$Members$MembershipPatient$billAffiliateRateEnabled,
			model.ZV,
			$author$project$Api$Provider$Membership$One$company(membership));
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Rate'),
					$author$project$Ui$Form$Group$required(model.es)
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Components$FixedRate$view,
					{
						MC: billAffiliateRate,
						Pd: A2($elm$core$Maybe$andThen, $author$project$Api$Provider$MembershipPatient$ForMembershipOne$fixedPeriodRateInCents, pendingMembershipPatient),
						Qf: defaultValue,
						ep: onlyOneFixedPeriodRateInCentsEditable,
						Q4: isPatientActive && fixedPeriodRateInCentsIsEditable,
						C: model.es,
						agX: A2($author$project$Utils$Form$validationErrors, 5, model.SD),
						aj0: $author$project$Api$Provider$Membership$One$periodInMonths(pendingMembership),
						aee: membershipPatient.Sx
					},
					A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Members$MembershipPatient$FormUpdated, $author$project$Components$Membership$Form$Members$MembershipPatient$FixedPeriodRateInCents),
					$author$project$Components$Membership$Form$Members$MembershipPatient$ToggleFixedPeriodRateInCentsOverride(defaultValue))
				]));
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$AddNewPatient = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$Remove = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$Restart = {$: 0};
var $author$project$Components$Membership$Form$Members$MembershipPatient$viewPatientInput = F8(
	function (practice, owner, membership, pendingMembership, activePatientsCount, isPatientActive, membershipPatient, model) {
		var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
		var patientIsEditable = (!model.bf) && $author$project$Api$Provider$Membership$Meta$membershipPatientsPatient(membershipMeta);
		var memberType = membershipPatient.WN;
		var isActive = !$author$project$Utils$Maybe$toBool(membershipPatient.Q8);
		var humanMemberType = ($author$project$Api$Provider$Practice$One$usesSponsors(practice) && (!memberType)) ? 'primary member' : ((memberType === 1) ? 'adult' : $author$project$Api$MemberRelationship$toString(memberType));
		var canRestartPatient = (isPatientActive || ((!$author$project$Api$Provider$Membership$Meta$membershipPatientsPatient(membershipMeta)) || (!memberType))) ? false : ($author$project$Api$Provider$Membership$One$isSponsored(pendingMembership) ? A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$Meta$CompanyRegistration$enrollAction,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.W4;
					},
					membershipPatient.Oi))) : true);
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label(
					$author$project$Formatters$String$titleize(humanMemberType))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(9)
								]),
							_List_fromArray(
								[
									function () {
									var _v0 = membershipPatient.YY;
									if (!_v0.$) {
										var patient = _v0.a;
										return A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
														{YZ: patient.ahP}),
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Typography$text,
															_List_fromArray(
																[
																	$author$project$Ui$Typography$phi(true)
																]),
															patient.Bq)
														]))
												]));
									} else {
										return A2(
											$author$project$Ui$Element$view,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$map,
													$author$project$Components$Membership$Form$Members$MembershipPatient$PatientResourceFilterMsg,
													A2(
														$author$project$Components$ResourceFilter$Patient$view,
														_List_fromArray(
															[
																$author$project$Components$ResourceFilter$invalid(
																A2($author$project$Utils$Form$hasValidationErrors, 0, model.SD)),
																$author$project$Components$ResourceFilter$errors(
																A2($author$project$Utils$Form$validationErrors, 0, model.SD))
															]),
														model.oY)),
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$textSm]),
													_List_fromArray(
														[
															$elm$html$Html$text(' or '),
															A3(
															$author$project$Ui$Button$view,
															{mm: 'Add a new patient'},
															_List_fromArray(
																[
																	$author$project$Ui$Button$link,
																	$author$project$Ui$Button$sm,
																	$author$project$Ui$Button$onClick(
																	$author$project$Components$Membership$Form$Members$MembershipPatient$AddNewPatient(owner))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Add a new patient')
																]))
														]))
												]));
									}
								}(),
									(isActive || model.bf) ? $author$project$Utils$Html$empty : A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$helpBlock]),
									_List_fromArray(
										[
											$elm$html$Html$text('Member from '),
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'',
												A2(
													$elm$core$Maybe$map,
													$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
													membershipPatient.ab7))),
											$elm$html$Html$text(' to '),
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'',
												A2(
													$elm$core$Maybe$map,
													$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
													membershipPatient.Q8)))
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(3)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$justifyRight]),
									_List_fromArray(
										[
											canRestartPatient ? A3(
											$author$project$Ui$Button$view,
											{mm: 'Restart patient'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Members$MembershipPatient$Restart)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Restart Patient')
												])) : $author$project$Utils$Html$empty,
											function () {
											if ((isPatientActive || model.bf) && (patientIsEditable && (!(!memberType)))) {
												var removeError = (!membershipPatient.WN) ? $elm$core$Maybe$Just('You cannot remove the employee from a sponsored membership.') : ((activePatientsCount === 1) ? $elm$core$Maybe$Just('You can\'t remove the only patient on a membership. Please add another patient first, or if you\'d like to just end the membership, you can click that button below.') : $elm$core$Maybe$Nothing);
												var endDate = A2(
													$elm_community$list_extra$List$Extra$maximumBy,
													$justinmimbs$date$Date$toRataDie,
													A2(
														$elm$core$List$filterMap,
														$elm$core$Basics$identity,
														_List_fromArray(
															[
																membershipPatient.ab7,
																$author$project$Api$Provider$Membership$Meta$endDateDefaultValue(membershipMeta)
															])));
												return A3(
													$author$project$Ui$Tooltip$view,
													_List_fromArray(
														[
															$author$project$Ui$Tooltip$placement(0),
															$author$project$Ui$Tooltip$active(
															$author$project$Utils$Maybe$toBool(removeError))
														]),
													A2($elm$core$Maybe$withDefault, '', removeError),
													_List_fromArray(
														[
															A3(
															$author$project$Ui$Button$view,
															{mm: 'Remove patient'},
															_List_fromArray(
																[
																	$author$project$Ui$Button$link,
																	$author$project$Ui$Button$onClick(
																	$author$project$Components$Membership$Form$Members$MembershipPatient$Remove(endDate)),
																	$author$project$Ui$Button$disabled(
																	$author$project$Utils$Maybe$toBool(removeError))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Remove Patient')
																]))
														]));
											} else {
												return $author$project$Utils$Html$empty;
											}
										}()
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$PatientUsesTobacco = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$patientUsesTobaccoOptions = _List_fromArray(
	[
		A3(
		$author$project$Ui$Form$Select$option,
		_List_Nil,
		$elm$core$Maybe$Just(''),
		'Choose an option'),
		A3(
		$author$project$Ui$Form$Select$option,
		_List_Nil,
		$elm$core$Maybe$Just(
			$author$project$Utils$Bool$toString(true)),
		'Uses tobacco'),
		A3(
		$author$project$Ui$Form$Select$option,
		_List_Nil,
		$elm$core$Maybe$Just(
			$author$project$Utils$Bool$toString(false)),
		'Does not use tobacco')
	]);
var $author$project$Components$Membership$Form$Members$MembershipPatient$viewPatientUsesTobaccoInput = F3(
	function (pendingMembershipPatient, patient, model) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Tobacco use'),
					$author$project$Ui$Form$Group$required(model.et)
				]),
			_List_fromArray(
				[
					model.et ? A2(
					$author$project$Ui$Form$Select$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Select$value(
							A2($elm$core$Maybe$map, $author$project$Utils$Bool$toString, patient.ad9)),
							$author$project$Ui$Form$Select$onChange(
							A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Members$MembershipPatient$FormUpdated, $author$project$Components$Membership$Form$Members$MembershipPatient$PatientUsesTobacco)),
							$author$project$Ui$Form$Select$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 1, model.SD)),
							$author$project$Ui$Form$Select$errors(
							A2($author$project$Utils$Form$validationErrors, 1, model.SD))
						]),
					$author$project$Components$Membership$Form$Members$MembershipPatient$patientUsesTobaccoOptions) : A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$withDefault,
							false,
							A2(
								$elm$core$Maybe$andThen,
								A2($elm$core$Basics$composeR, $author$project$Api$Provider$MembershipPatient$ForMembershipOne$patient, $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$usesTobacco),
								pendingMembershipPatient)) ? $elm$html$Html$text('Uses tobacco') : $elm$html$Html$text('Does not use tobacco')
						]))
				]));
	});
var $author$project$Api$Plan$ProviderSharedWithContractInfo = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$SpecialRate = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$ToggleSpecialRateOverride = {$: 8};
var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$discountRule = function (_v0) {
	var record = _v0.b;
	return record.QF;
};
var $author$project$Api$Provider$Membership$Meta$membershipPatientsSpecialRate = function (_v0) {
	var meta = _v0;
	return meta.WR.abS;
};
var $author$project$Api$Provider$DiscountRule$Min$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$rateRule = function (_v0) {
	var record = _v0.b;
	return record._3;
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$specialRateOptions = F2(
	function (periodInMonths, specialRates) {
		return A2(
			$elm$core$List$cons,
			A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(''),
				'Choose an option'),
			A2(
				$elm$core$List$map,
				function (specialRate) {
					var amountInCents = A2(
						$elm$core$Maybe$withDefault,
						0,
						function () {
							switch (periodInMonths) {
								case 1:
									return $author$project$Api$Provider$SpecialRate$Shared$monthAmountInCents(specialRate);
								case 3:
									return $author$project$Api$Provider$SpecialRate$Shared$quarterAmountInCents(specialRate);
								case 6:
									return $author$project$Api$Provider$SpecialRate$Shared$semiAnnualAmountInCents(specialRate);
								case 12:
									return $author$project$Api$Provider$SpecialRate$Shared$annualAmountInCents(specialRate);
								default:
									return $elm$core$Maybe$Nothing;
							}
						}());
					return A3(
						$author$project$Ui$Form$Select$option,
						_List_Nil,
						$elm$core$Maybe$Just(
							$author$project$Api$Provider$SpecialRate$Shared$id(specialRate)),
						$author$project$Api$Provider$SpecialRate$Shared$name(specialRate) + (' - ' + ($author$project$Utils$Currency$fromInt(amountInCents) + (' ' + $author$project$Formatters$Int$asPeriod(periodInMonths)))));
				},
				A2($elm$core$List$sortBy, $author$project$Api$Provider$SpecialRate$Shared$name, specialRates)));
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$viewSpecialRateInput = F6(
	function (membership, pendingMembership, pendingMembershipPatient, isPatientActive, membershipPatient, model) {
		var pendingMembershipPlan = $author$project$Api$Provider$Membership$One$plan(pendingMembership);
		var planHasSpecialRates = !$elm$core$List$isEmpty(
			$author$project$Api$Provider$Plan$SharedWithContractInfo$specialRates(pendingMembershipPlan));
		var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
		var specialRateIsEditable = (!model.bf) && $author$project$Api$Provider$Membership$Meta$membershipPatientsSpecialRate(membershipMeta);
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Rule'),
					$author$project$Ui$Form$Group$required(model.b2)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(6)
								]),
							($author$project$Api$Provider$Plan$SharedWithContractInfo$planType(pendingMembershipPlan) === 4) ? _List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									$author$project$Components$Plan$Summary$Percentage$view(
										$author$project$Api$Plan$ProviderSharedWithContractInfo(pendingMembershipPlan)))
								]) : _List_fromArray(
								[
									function () {
									if (model.b2) {
										var specialRates = $author$project$Api$Provider$Plan$SharedWithContractInfo$specialRates(pendingMembershipPlan);
										return A2(
											$author$project$Ui$Form$Select$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Select$value(
													A2(
														$elm$core$Maybe$map,
														function ($) {
															return $.ahP;
														},
														membershipPatient.abS)),
													$author$project$Ui$Form$Select$onChange(
													function (str) {
														return $author$project$Components$Membership$Form$Members$MembershipPatient$FormUpdated(
															$author$project$Components$Membership$Form$Members$MembershipPatient$SpecialRate(
																A2(
																	$elm$core$Maybe$map,
																	$author$project$Components$SpecialRate$SpecialRateRecord$fromOne,
																	A2(
																		$elm$core$Maybe$andThen,
																		function (rateId) {
																			return A2(
																				$elm_community$list_extra$List$Extra$find,
																				function (sr) {
																					return _Utils_eq(
																						$author$project$Api$Provider$SpecialRate$Shared$id(sr),
																						rateId);
																				},
																				specialRates);
																		},
																		$author$project$Utils$String$toMaybe(str)))));
													}),
													$author$project$Ui$Form$Select$invalid(
													A2($author$project$Utils$Form$hasValidationErrors, 4, model.SD)),
													$author$project$Ui$Form$Select$errors(
													A2($author$project$Utils$Form$validationErrors, 4, model.SD)),
													$author$project$Ui$Form$Select$loading(
													$elm$core$List$isEmpty(specialRates))
												]),
											A2(
												$author$project$Components$Membership$Form$Members$MembershipPatient$specialRateOptions,
												$author$project$Api$Provider$Membership$One$periodInMonths(pendingMembership),
												specialRates));
									} else {
										var ruleDescription = function () {
											if ($author$project$Api$Provider$Plan$SharedWithContractInfo$planType(pendingMembershipPlan) === 1) {
												return 'Fixed Fee';
											} else {
												var rateRuleName = A2(
													$elm$core$Maybe$withDefault,
													'N/A',
													A2(
														$elm$core$Maybe$map,
														$author$project$Api$Provider$RateRule$Min$name,
														A2($elm$core$Maybe$andThen, $author$project$Api$Provider$MembershipPatient$ForMembershipOne$rateRule, pendingMembershipPatient)));
												var discountRuleDescription = function () {
													var _v0 = A2(
														$elm$core$Maybe$map,
														$author$project$Api$Provider$DiscountRule$Min$name,
														A2($elm$core$Maybe$andThen, $author$project$Api$Provider$MembershipPatient$ForMembershipOne$discountRule, pendingMembershipPatient));
													if (!_v0.$) {
														var discountRuleName = _v0.a;
														return ' (' + (discountRuleName + ' discount)');
													} else {
														return '';
													}
												}();
												return _Utils_ap(rateRuleName, discountRuleDescription);
											}
										}();
										return A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(ruleDescription)
												]));
									}
								}()
								])),
							(($author$project$Api$Provider$Plan$SharedWithContractInfo$planType(pendingMembershipPlan) !== 4) && (isPatientActive && (planHasSpecialRates && specialRateIsEditable))) ? A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$flex, $author$project$Ui$Element$justifyRight]),
									_List_fromArray(
										[
											function () {
											var label = model.b2 ? 'Remove Override' : 'Override Rule';
											return A3(
												$author$project$Ui$Button$view,
												{mm: label},
												_List_fromArray(
													[
														$author$project$Ui$Button$link,
														$author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Members$MembershipPatient$ToggleSpecialRateOverride)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(label)
													]));
										}()
										]))
								])) : $author$project$Ui$Grid$none
						])),
					model.qk ? A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$danger]),
					_List_fromArray(
						[
							$elm$html$Html$text('The special rate was removed because the new plan does not have a matching rate.')
						])) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$EditStartDate = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$Membership$Meta$membershipPatientsStartDate = function (_v0) {
	var meta = _v0;
	return meta.WR.ab7;
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$viewStartDateInput = F6(
	function (membership, pendingMembership, pendingMembershipPatient, isPatientActive, membershipPatient, model) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Membership Start Date')
				]),
			function () {
				if (model.r5) {
					var min = $author$project$Api$Provider$Membership$One$startDate(pendingMembership);
					var max = A2(
						$elm$core$Maybe$withDefault,
						$author$project$Api$Provider$Membership$One$billFromDate(pendingMembership),
						membershipPatient.St);
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Components$Membership$Form$Members$MembershipPatient$StartDateInputMsg,
							A2(
								$author$project$Components$DateInput$view,
								_List_fromArray(
									[
										$author$project$Components$DateInput$value(membershipPatient.ab7),
										$author$project$Components$DateInput$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 3, model.SD)),
										$author$project$Components$DateInput$errors(
										A2($author$project$Utils$Form$validationErrors, 3, model.SD)),
										$author$project$Components$DateInput$disabledPickerDates(
										function (date) {
											return A2($author$project$Utils$Date$isBefore, date, min) || A2($author$project$Utils$Date$isAfter, date, max);
										})
									]),
								model.lx)),
							function () {
							var _v0 = membershipPatient.ab7;
							if (!_v0.$) {
								var membershipPatientStartDate = _v0.a;
								return A2(
									$author$project$Utils$Date$isBefore,
									membershipPatientStartDate,
									$author$project$Api$Provider$Membership$One$billFromDate(pendingMembership)) ? ($author$project$Api$Provider$Membership$One$isSponsored(pendingMembership) ? A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('We will charge for this patient starting on the '),
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'',
												A2(
													$elm$core$Maybe$map,
													$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
													A2(
														$elm$core$Maybe$andThen,
														$author$project$Api$Provider$Company$Shared$nextInvoiceDate,
														$author$project$Api$Provider$Membership$One$company(pendingMembership))))),
											$elm$html$Html$text(' invoice.')
										])) : (($author$project$Utils$Maybe$toBool(membershipPatient.St) && (!_Utils_eq(
									membershipPatient.ab7,
									A2($elm$core$Maybe$map, $author$project$Api$Provider$MembershipPatient$ForMembershipOne$startDate, model.IZ)))) ? A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$helpBlock]),
									_List_fromArray(
										[
											$elm$html$Html$text('We will continue billing this patient on '),
											$elm$html$Html$text(
											A2(
												$author$project$Formatters$Date$toString,
												$author$project$Formatters$Date$Full,
												$author$project$Api$Provider$Membership$One$billFromDate(pendingMembership)))
										])) : ((!$author$project$Utils$Maybe$toBool(membershipPatient.St)) ? A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$helpBlock]),
									_List_fromArray(
										[
											$elm$html$Html$text('We will bill this patient starting on '),
											$elm$html$Html$text(
											A2(
												$author$project$Formatters$Date$toString,
												$author$project$Formatters$Date$Full,
												$author$project$Api$Provider$Membership$One$billFromDate(pendingMembership))),
											$elm$html$Html$text('. If you\'d like to prorate for the period of '),
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'',
												A2(
													$elm$core$Maybe$map,
													$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
													membershipPatient.ab7))),
											$elm$html$Html$text(' - '),
											$elm$html$Html$text(
											A2(
												$author$project$Formatters$Date$toString,
												$author$project$Formatters$Date$Full,
												$author$project$Api$Provider$Membership$One$billFromDate(pendingMembership))),
											$elm$html$Html$text(', you can learn how to do that '),
											A3(
											$author$project$Ui$Link$externalHref,
											'https://support.hint.com/invoices/creating-a-prorated-membership-invoice',
											_List_fromArray(
												[$author$project$Ui$Link$targetBlank]),
											_List_fromArray(
												[
													$elm$html$Html$text('here')
												])),
											$elm$html$Html$text('.')
										])) : $author$project$Utils$Html$empty))) : $author$project$Utils$Html$empty;
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						]);
				} else {
					var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
					var startDateIsEditable = (!model.bf) && $author$project$Api$Provider$Membership$Meta$membershipPatientsStartDate(membershipMeta);
					return _List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_fromArray(
								[$author$project$Ui$Form$Static$flex, $author$project$Ui$Form$Static$spaceBetween, $author$project$Ui$Form$Static$itemsCenter]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										A2(
											$elm$core$Maybe$map,
											$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
											membershipPatient.ab7))),
									(isPatientActive && startDateIsEditable) ? A3(
									$author$project$Ui$Button$view,
									{mm: 'Change start date'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick(
											$author$project$Components$Membership$Form$Members$MembershipPatient$EditStartDate(
												A2($elm$core$Maybe$map, $author$project$Api$Provider$MembershipPatient$ForMembershipOne$startDate, pendingMembershipPatient)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Change Date')
										])) : $author$project$Utils$Html$empty
								]))
						]);
				}
			}());
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$view = F5(
	function (practice, sectionsShared, cancellationReasons, activePatientsCount, _v0) {
		var model = _v0;
		var membershipPatient = $author$project$Utils$Form$fields(model.SD);
		var isPatientActive = !$author$project$Utils$Maybe$toBool(membershipPatient.sb);
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					A8($author$project$Components$Membership$Form$Members$MembershipPatient$viewPatientInput, practice, sectionsShared.YD, sectionsShared.kk, sectionsShared.dC, activePatientsCount, isPatientActive, membershipPatient, model),
					function () {
					var _v1 = membershipPatient.YY;
					if (!_v1.$) {
						var patient = _v1.a;
						var showTobaccoUsage = A2($author$project$Api$Provider$Practice$One$featureEnabled, 2, practice) && $author$project$Utils$Maybe$toBool(
							$author$project$Api$Provider$Plan$SharedWithContractInfo$tobaccoSurchargeType(
								$author$project$Api$Provider$Membership$One$plan(sectionsShared.dC)));
						var pendingMembershipPatient = A2(
							$elm_community$list_extra$List$Extra$find,
							function (membershipPatient_) {
								return _Utils_eq(
									$author$project$Api$Provider$MembershipPatient$ForMembershipOne$id(membershipPatient_),
									membershipPatient.ahP);
							},
							$author$project$Api$Provider$Membership$One$membershipPatients(sectionsShared.dC));
						var isTerminated = $author$project$Utils$Maybe$toBool(membershipPatient.sb) && ((!_Utils_eq(
							membershipPatient.Gg,
							$elm$core$Maybe$Just('terminate'))) && (!_Utils_eq(
							membershipPatient.Gg,
							$elm$core$Maybe$Just('destroy'))));
						return A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									showTobaccoUsage ? A3($author$project$Components$Membership$Form$Members$MembershipPatient$viewPatientUsesTobaccoInput, pendingMembershipPatient, patient, model) : $author$project$Utils$Html$empty,
									function () {
									var _v2 = _Utils_Tuple2((!isPatientActive) && (!model.bf), membershipPatient.afo);
									if (_v2.a && (!_v2.b.$)) {
										var cancellationReason = _v2.b.a;
										return A2($author$project$Components$Membership$Form$Members$MembershipPatient$viewCancellationReason, membershipPatient, cancellationReason);
									} else {
										return $author$project$Utils$Html$empty;
									}
								}(),
									function () {
									if ((!isTerminated) && ($author$project$Api$Provider$Membership$One$isUpdatable(sectionsShared.dC) || $author$project$Api$Provider$Membership$One$isSynced(sectionsShared.dC))) {
										var pendingMembershipPlan = $author$project$Api$Provider$Membership$One$plan(sectionsShared.dC);
										return A2(
											$author$project$Ui$Element$view,
											_List_Nil,
											_List_fromArray(
												[
													A4($author$project$Components$Membership$Form$Members$MembershipPatient$viewEnrollmentRequestedOnInput, sectionsShared.kk, isPatientActive, membershipPatient, model),
													A6($author$project$Components$Membership$Form$Members$MembershipPatient$viewStartDateInput, sectionsShared.kk, sectionsShared.dC, pendingMembershipPatient, isPatientActive, membershipPatient, model),
													(!$author$project$Api$Provider$Plan$SharedWithContractInfo$isMcePlan(pendingMembershipPlan)) ? A6($author$project$Components$Membership$Form$Members$MembershipPatient$viewSpecialRateInput, sectionsShared.kk, sectionsShared.dC, pendingMembershipPatient, isPatientActive, membershipPatient, model) : $author$project$Utils$Html$empty,
													((!$author$project$Api$Provider$Plan$SharedWithContractInfo$isMcePlan(pendingMembershipPlan)) && ($author$project$Api$Provider$Plan$SharedWithContractInfo$planType(pendingMembershipPlan) !== 1)) ? A5($author$project$Components$Membership$Form$Members$MembershipPatient$viewFixedPeriodRateInput, sectionsShared, pendingMembershipPatient, isPatientActive, membershipPatient, model) : $author$project$Utils$Html$empty
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					model.bf ? A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							A3($author$project$Components$Membership$Form$Members$MembershipPatient$viewEndDateInput, sectionsShared.dC, membershipPatient, model),
							A3($author$project$Components$Membership$Form$Members$MembershipPatient$viewCancellationReasonInput, cancellationReasons, membershipPatient, model)
						])) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$Membership$Form$Sections$Members$viewMembershipPatient = F8(
	function (practice, sectionsShared, cancellationReasons, lastIndex, canEditMembershipPatients, activePatientsCount, index, _v0) {
		var membershipPatient = _v0.b;
		var membershipPatientRecord = $author$project$Components$Membership$Form$Members$MembershipPatient$membershipPatientFields(membershipPatient);
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Components$Membership$Form$Sections$Members$MembershipPatientMsg(membershipPatientRecord.ahP),
					A5($author$project$Components$Membership$Form$Members$MembershipPatient$view, practice, sectionsShared, cancellationReasons, activePatientsCount, membershipPatient)),
					((!_Utils_eq(index, lastIndex)) || canEditMembershipPatients) ? A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(11),
									$author$project$Ui$Grid$offset(1)
								]),
							_List_fromArray(
								[
									$author$project$Ui$HorizontalRule$view(_List_Nil)
								]))
						])) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$Membership$Form$Sections$Members$viewMembershipPatients = F5(
	function (sectionsShared, cancellationReasons, canEditMembershipPatients, membershipPatients, model) {
		var lastIndex = $elm$core$List$length(membershipPatients) - 1;
		var activePatientsCount = A2(
			$elm_community$list_extra$List$Extra$count,
			function (_v0) {
				var membershipPatient = _v0.b;
				var membershipPatientRecord = $author$project$Components$Membership$Form$Members$MembershipPatient$membershipPatientFields(membershipPatient);
				return !$author$project$Utils$Maybe$toBool(membershipPatientRecord.sb);
			},
			membershipPatients);
		return A2(
			$elm$core$List$indexedMap,
			A6($author$project$Components$Membership$Form$Sections$Members$viewMembershipPatient, model.ZV, sectionsShared, cancellationReasons, lastIndex, canEditMembershipPatients, activePatientsCount),
			membershipPatients);
	});
var $author$project$Components$Membership$Form$Sections$Members$view = F3(
	function (sectionsShared, cancellationReasons, model) {
		var membershipPatients = A2(
			$elm$core$List$sortBy,
			$author$project$Components$Membership$Form$Sections$Members$membershipPatientSortValue(sectionsShared.kk),
			$elm$core$Dict$values(model.WR));
		var membershipMeta = $author$project$Api$Provider$Membership$One$meta(sectionsShared.kk);
		var canEditMembershipPatients = $author$project$Api$Provider$Membership$Meta$membershipPatientsPatient(membershipMeta);
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							$author$project$Ui$HorizontalRule$view(_List_Nil),
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('Members')
								]))
						]),
						A5($author$project$Components$Membership$Form$Sections$Members$viewMembershipPatients, sectionsShared, cancellationReasons, canEditMembershipPatients, membershipPatients, model),
						function () {
						if (canEditMembershipPatients) {
							var startDate = $author$project$Api$Provider$Membership$One$billedThroughDate(sectionsShared.dC);
							return _List_fromArray(
								[
									function () {
									var _v0 = model.Iy;
									if (!_v0.$) {
										var maxMembershipPatients = _v0.a;
										return A2(
											$author$project$Ui$Grid$row,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Grid$column,
													_List_fromArray(
														[
															$author$project$Ui$Grid$span(11),
															$author$project$Ui$Grid$offset(1)
														]),
													_List_fromArray(
														[
															A2($author$project$Components$Membership$Form$Sections$Members$overMaxMembershipPatientsWarning, maxMembershipPatients, model.WR)
														]))
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}(),
									A2(
									$author$project$Ui$Grid$row,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$span(9),
													$author$project$Ui$Grid$offset(3)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$gap2]),
													_List_fromArray(
														[
															A3(
															$author$project$Ui$Button$view,
															{mm: 'Add adult'},
															_List_fromArray(
																[
																	$author$project$Ui$Button$onClick(
																	A2($author$project$Components$Membership$Form$Sections$Members$AddMember, 1, startDate)),
																	$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Add Adult')
																])),
															A3(
															$author$project$Ui$Button$view,
															{mm: 'Add child'},
															_List_fromArray(
																[
																	$author$project$Ui$Button$onClick(
																	A2($author$project$Components$Membership$Form$Sections$Members$AddMember, 2, startDate)),
																	$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Add Child')
																]))
														]))
												]))
										]))
								]);
						} else {
							return _List_Nil;
						}
					}()
					])));
	});
var $author$project$Components$Membership$Form$Sections$PlanChange$Add = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Components$Membership$Form$Sections$PlanChange$Remove = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Api$Provider$Membership$Meta$membershipScheduledChangeEditable = function (_v0) {
	var meta = _v0;
	return meta.WV.Q4;
};
var $author$project$Api$Provider$Membership$One$scheduledChange = function (_v0) {
	var record = _v0.b;
	return record.aaw;
};
var $author$project$Api$Provider$MembershipScheduledChange$Shared$changeAfterMonths = function (_v0) {
	var record = _v0;
	return record.Nt;
};
var $author$project$Api$Provider$MembershipScheduledChange$Shared$changeOnDate = function (_v0) {
	var record = _v0;
	return record.Nu;
};
var $author$project$Api$Provider$MembershipScheduledChange$Shared$effectiveDate = function (_v0) {
	var record = _v0;
	return record.Q7;
};
var $author$project$Api$Provider$MembershipScheduledChange$Shared$toPlan = function (_v0) {
	var record = _v0;
	return record.adc;
};
var $author$project$Api$Provider$MembershipScheduledChange$Shared$type_ = function (_v0) {
	var record = _v0;
	return record.amg;
};
var $author$project$Components$Membership$Form$Sections$PlanChange$viewScheduledChange = F2(
	function (contractPeriodInMonths, scheduledChange) {
		var type_ = $author$project$Api$Provider$MembershipScheduledChange$Shared$type_(scheduledChange);
		var effectiveDate = $author$project$Api$Provider$MembershipScheduledChange$Shared$effectiveDate(scheduledChange);
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpanSm(3),
							$author$project$Ui$Form$Group$inputSpanSm(9),
							$author$project$Ui$Form$Group$label('Status')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Scheduled')
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpanSm(3),
							$author$project$Ui$Form$Group$inputSpanSm(9),
							$author$project$Ui$Form$Group$label('Effective date')
						]),
					_List_fromArray(
						[
							function () {
							switch (type_) {
								case 2:
									return A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2(
													$author$project$Formatters$String$pluralize,
													'month',
													A2($elm$core$Maybe$withDefault, 0, contractPeriodInMonths))),
												$elm$html$Html$text(' ('),
												$elm$html$Html$text(
												A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, effectiveDate)),
												$elm$html$Html$text(')')
											]));
								case 1:
									var changeAfterMonths = $author$project$Api$Provider$MembershipScheduledChange$Shared$changeAfterMonths(scheduledChange);
									return A2(
										$author$project$Ui$Form$Static$view,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2(
															$author$project$Formatters$String$pluralize,
															'month',
															A2($elm$core$Maybe$withDefault, 0, changeAfterMonths))),
														$elm$html$Html$text(' ('),
														$elm$html$Html$text(
														A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, effectiveDate)),
														$elm$html$Html$text(')')
													]))
											]));
								default:
									var changeOnDate = $author$project$Api$Provider$MembershipScheduledChange$Shared$changeOnDate(scheduledChange);
									return A2(
										$author$project$Ui$Form$Static$view,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2(
													$elm$core$Maybe$withDefault,
													'N/A',
													A2(
														$elm$core$Maybe$map,
														$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
														changeOnDate)))
											]));
							}
						}()
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpanSm(3),
							$author$project$Ui$Form$Group$inputSpanSm(9),
							$author$project$Ui$Form$Group$label('New plan')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										A2(
											$elm$core$Maybe$map,
											$author$project$Api$Provider$Plan$Shared$name,
											$author$project$Api$Provider$MembershipScheduledChange$Shared$toPlan(scheduledChange))))
								]))
						]))
				]));
	});
var $author$project$Components$Membership$Form$Sections$PlanChange$view = F3(
	function (_v0, contract, _v1) {
		var membership = _v0.kk;
		var pendingMembership = _v0.dC;
		var model = _v1;
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$HorizontalRule$view(_List_Nil),
					A2(
					$author$project$Ui$Grid$row,
					_List_fromArray(
						[$author$project$Ui$Grid$rowItemsCenter]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(5)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Typography$headingSm(
									_List_fromArray(
										[
											$elm$html$Html$text('Plan Change')
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(7)
								]),
							function () {
								var _v2 = $author$project$Api$Provider$Membership$One$scheduledChange(pendingMembership);
								if (!_v2.$) {
									var scheduledChange = _v2.a;
									var buttonOption = function () {
										var _v3 = model.AW;
										if (!_v3.$) {
											var membershipId = _v3.a;
											return $author$project$Ui$Button$onClick(
												A2($author$project$Components$Membership$Form$Sections$PlanChange$Remove, membershipId, scheduledChange));
										} else {
											return $author$project$Ui$Button$disabled(true);
										}
									}();
									return _List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$flex, $author$project$Ui$Element$justifyRight]),
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Tooltip$view,
													_List_fromArray(
														[
															$author$project$Ui$Tooltip$placement(0),
															$author$project$Ui$Tooltip$active(model.sS)
														]),
													'This plan change is set automatically and can be removed after saving the membership.',
													_List_fromArray(
														[
															A3(
															$author$project$Ui$Button$view,
															{mm: 'Remove schedule change'},
															_List_fromArray(
																[$author$project$Ui$Button$link, buttonOption]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Remove')
																]))
														]))
												]))
										]);
								} else {
									var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
									return _List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$spaceBetween]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$text,
													_List_fromArray(
														[$author$project$Ui$Typography$muted]),
													'None'),
													function () {
													if ($author$project$Api$Provider$Membership$Meta$membershipScheduledChangeEditable(membershipMeta)) {
														var currentPlanSpecialRateNames = $author$project$Api$Plan$specialRateNames(
															$author$project$Api$Plan$ProviderSharedWithContractInfo(
																$author$project$Api$Provider$Membership$One$plan(membership)));
														return A3(
															$author$project$Ui$Tooltip$view,
															_List_fromArray(
																[
																	$author$project$Ui$Tooltip$placement(0),
																	$author$project$Ui$Tooltip$active(model.sS)
																]),
															'You will be able to add a plan change after the membership is created.',
															_List_fromArray(
																[
																	A3(
																	$author$project$Ui$Button$view,
																	{mm: 'Add plan change'},
																	_List_fromArray(
																		[
																			$author$project$Ui$Button$link,
																			$author$project$Ui$Button$disabled(model.sS),
																			$author$project$Ui$Button$onClick(
																			A3($author$project$Components$Membership$Form$Sections$PlanChange$Add, contract, membershipMeta, currentPlanSpecialRateNames))
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Add plan change')
																		]))
																]));
													} else {
														return $author$project$Utils$Html$empty;
													}
												}()
												]))
										]);
								}
							}()),
							A2(
							$author$project$Ui$Grid$column,
							_List_Nil,
							_List_fromArray(
								[
									function () {
									var _v4 = $author$project$Api$Provider$Membership$One$scheduledChange(pendingMembership);
									if (!_v4.$) {
										var scheduledChange = _v4.a;
										return A2($author$project$Components$Membership$Form$Sections$PlanChange$viewScheduledChange, contract.Zs, scheduledChange);
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								]))
						]))
				]));
	});
var $author$project$Components$Membership$Form$Sections$Pricing$planIsFixedFee = function (pendingMembership) {
	return $author$project$Api$Provider$Plan$SharedWithContractInfo$planType(
		$author$project$Api$Provider$Membership$One$plan(pendingMembership)) === 1;
};
var $author$project$Components$Membership$Form$Sections$Pricing$Coupon = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Membership$Form$Sections$Pricing$ToggleEditCoupon = {$: 3};
var $author$project$Components$Membership$Form$Sections$Pricing$formatCoupon = F5(
	function (percentOff, amountOffInCents, applyToEachPatient, durationInMonths, code) {
		return function (string) {
			return A2($elm$core$String$append, string, ' (' + (code + ')'));
		}(
			function (string) {
				return A2(
					$elm$core$String$append,
					string,
					function () {
						if (!durationInMonths.$) {
							var durationInMonths_ = durationInMonths.a;
							return ' for ' + ($elm$core$String$fromInt(durationInMonths_) + ' months');
						} else {
							return '';
						}
					}());
			}(
				function () {
					var _v0 = _Utils_Tuple2(percentOff, amountOffInCents);
					if (!_v0.a.$) {
						var percentOff_ = _v0.a.a;
						return $elm$core$String$fromFloat(percentOff_) + '% off';
					} else {
						if (!_v0.b.$) {
							var _v1 = _v0.a;
							var amountOffInCents_ = _v0.b.a;
							return $author$project$Utils$Currency$fromInt(amountOffInCents_) + (' / ' + (applyToEachPatient ? 'patient' : 'membership'));
						} else {
							var _v2 = _v0.a;
							var _v3 = _v0.b;
							return '';
						}
					}
				}()));
	});
var $author$project$Components$Membership$Form$Sections$Pricing$formatCouponAll = function (coupon) {
	return A5(
		$author$project$Components$Membership$Form$Sections$Pricing$formatCoupon,
		$author$project$Api$Provider$Coupon$All$percentOff(coupon),
		$author$project$Api$Provider$Coupon$All$amountOffInCents(coupon),
		$author$project$Api$Provider$Coupon$All$applyToEachPatient(coupon),
		$author$project$Api$Provider$Coupon$All$durationInMonths(coupon),
		$author$project$Api$Provider$Coupon$All$code(coupon));
};
var $author$project$Components$Membership$Form$Sections$Pricing$couponOptions = function (coupons) {
	return A2(
		$elm$core$List$cons,
		A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(''),
			'None'),
		A2(
			$elm$core$List$map,
			function (coupon) {
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$Coupon$All$id(coupon)),
					$author$project$Components$Membership$Form$Sections$Pricing$formatCouponAll(coupon));
			},
			coupons));
};
var $author$project$Components$Membership$Form$Sections$Pricing$formatCouponShared = function (coupon) {
	if (!coupon.$) {
		var coupon_ = coupon.a;
		return A5(
			$author$project$Components$Membership$Form$Sections$Pricing$formatCoupon,
			$author$project$Api$Common$Coupon$Shared$percentOff(coupon_),
			$author$project$Api$Common$Coupon$Shared$amountOffInCents(coupon_),
			$author$project$Api$Common$Coupon$Shared$applyToEachPatient(coupon_),
			$author$project$Api$Common$Coupon$Shared$durationInMonths(coupon_),
			$author$project$Api$Common$Coupon$Shared$code(coupon_));
	} else {
		return '';
	}
};
var $author$project$Components$Membership$Form$Sections$Pricing$viewCouponField = F5(
	function (membership, pendingMembership, coupons, editCoupon, form) {
		var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
		var _v0 = function () {
			if (coupons.$ === 3) {
				var list = coupons.a;
				return _Utils_Tuple2(false, list);
			} else {
				return _Utils_Tuple2(true, _List_Nil);
			}
		}();
		var couponsLoading = _v0.a;
		var coupons_ = _v0.b;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Coupon')
				]),
			_List_fromArray(
				[
					function () {
					if ($author$project$Api$Provider$Membership$Meta$couponEditable(membershipMeta)) {
						if (editCoupon) {
							var _v2 = $author$project$Utils$Form$fields(form);
							var coupon = _v2.OP;
							return A2(
								$author$project$Ui$Grid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(6)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Select$view,
												_List_fromArray(
													[
														$author$project$Ui$Form$Select$value(coupon),
														$author$project$Ui$Form$Select$onChange(
														A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Sections$Pricing$FormUpdated, $author$project$Components$Membership$Form$Sections$Pricing$Coupon)),
														$author$project$Ui$Form$Select$loading(couponsLoading)
													]),
												$author$project$Components$Membership$Form$Sections$Pricing$couponOptions(coupons_))
											])),
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(6)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$flex, $author$project$Ui$Element$justifyRight]),
												_List_fromArray(
													[
														A3(
														$author$project$Ui$Button$view,
														{mm: 'Remoce coupon'},
														_List_fromArray(
															[
																$author$project$Ui$Button$link,
																$author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$Pricing$ToggleEditCoupon)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Remove Coupon')
															]))
													]))
											])),
										function () {
										var _v3 = $author$project$Api$Provider$Membership$One$coupon(pendingMembership);
										if (!_v3.$) {
											var coupon_ = _v3.a;
											return A2(
												$author$project$Ui$Grid$column,
												_List_fromArray(
													[
														$author$project$Ui$Grid$span(12)
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$p,
														_List_fromArray(
															[$author$project$Ui$Typography$helpBlock]),
														function () {
															var _v4 = $author$project$Api$Common$Coupon$Shared$durationInMonths(coupon_);
															if (!_v4.$) {
																var durationInMonths = _v4.a;
																return _List_fromArray(
																	[
																		$elm$html$Html$text(
																		A2($author$project$Formatters$String$pluralize, 'month', durationInMonths)),
																		$elm$html$Html$text('  coupon')
																	]);
															} else {
																return _List_fromArray(
																	[
																		$elm$html$Html$text('Unlimited duration coupon')
																	]);
															}
														}())
													]));
										} else {
											return $author$project$Ui$Grid$none;
										}
									}()
									]));
						} else {
							return A2(
								$author$project$Ui$Form$Static$view,
								_List_fromArray(
									[$author$project$Ui$Form$Static$muted, $author$project$Ui$Form$Static$flex, $author$project$Ui$Form$Static$spaceBetween, $author$project$Ui$Form$Static$itemsCenter]),
								_List_fromArray(
									[
										$elm$html$Html$text('None'),
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Add coupon'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$Pricing$ToggleEditCoupon)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Add Coupon')
											]))
									]));
						}
					} else {
						return A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Components$Membership$Form$Sections$Pricing$formatCouponShared(
										$author$project$Api$Provider$Membership$One$coupon(membership)))
								]));
					}
				}()
				]));
	});
var $author$project$Components$Membership$Form$Sections$Pricing$ToggleFixedPeriodRateInCentsOverride = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Membership$Form$Sections$Pricing$viewFixedRateField = F3(
	function (pendingMembership, onlyOneFixedPeriodRateInCentsEditable, form) {
		var membershipMeta = $author$project$Api$Provider$Membership$One$meta(pendingMembership);
		var _v0 = $author$project$Utils$Form$fields(form);
		var fixedPeriodRateInCents = _v0.Sx;
		var manuallySet = _v0.cK;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Total Rate'),
					$author$project$Ui$Form$Group$required(manuallySet._1)
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Components$FixedRate$view,
					{
						MC: false,
						Pd: $author$project$Api$Provider$Membership$One$fixedPeriodRateInCents(pendingMembership),
						Qf: $elm$core$Maybe$Just(
							$author$project$Currency$fromInt(
								$author$project$Api$Provider$Membership$One$revenueInCents(pendingMembership))),
						ep: onlyOneFixedPeriodRateInCentsEditable,
						Q4: $author$project$Api$Provider$Membership$Meta$fixedPeriodRateInCentsEditable(membershipMeta),
						C: manuallySet._1,
						agX: A2($author$project$Utils$Form$validationErrors, 0, form),
						aj0: $author$project$Api$Provider$Membership$One$periodInMonths(pendingMembership),
						aee: fixedPeriodRateInCents
					},
					A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Sections$Pricing$FormUpdated, $author$project$Components$Membership$Form$Sections$Pricing$FixedPeriodRateInCents),
					$author$project$Components$Membership$Form$Sections$Pricing$ToggleFixedPeriodRateInCentsOverride(pendingMembership))
				]));
	});
var $author$project$Components$Membership$Form$Sections$Pricing$PaymentMethodSearchChanged = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Membership$Form$Sections$Pricing$PaymentMethodSelected = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Membership$Form$Sections$Pricing$ToggleEditPaymentMethod = {$: 6};
var $author$project$Api$Provider$PaymentMethod$Min$label = function (_v0) {
	var record = _v0;
	return record.aih;
};
var $author$project$Components$Membership$Form$Sections$Pricing$paymentMethodTitle = function (paymentMethod) {
	var _v0 = $author$project$Api$Provider$PaymentMethod$Min$label(paymentMethod);
	if (!_v0.$) {
		var lbl = _v0.a;
		return lbl;
	} else {
		var lastFour = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (lf) {
					return ' *' + lf;
				},
				$author$project$Api$Provider$PaymentMethod$Min$lastFour(paymentMethod)));
		var brand = $author$project$Formatters$String$titleize(
			$author$project$Api$Provider$PaymentMethod$Min$paymentMethodBrand(paymentMethod));
		return _Utils_ap(brand, lastFour);
	}
};
var $author$project$Api$Provider$Membership$One$source = function (_v0) {
	var record = _v0.b;
	return record.JQ;
};
var $author$project$Api$Provider$Membership$Source$expMonth = function (_v0) {
	var record = _v0;
	return record.ag3;
};
var $author$project$Api$Provider$Membership$Source$expYear = function (_v0) {
	var record = _v0;
	return record.ag4;
};
var $author$project$Api$Provider$Membership$Source$funding = function (_v0) {
	var record = _v0;
	return record.SN;
};
var $author$project$Api$Provider$Membership$Source$lastFour = function (_v0) {
	var record = _v0;
	return record.VG;
};
var $author$project$Api$Provider$Membership$Source$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$Membership$Source$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Api$Provider$Membership$Source$type_ = function (_v0) {
	var record = _v0;
	return record.amg;
};
var $author$project$Api$Provider$Membership$Source$zip = function (_v0) {
	var record = _v0;
	return record.vv;
};
var $author$project$Components$Membership$Form$Sections$Pricing$viewPaymentMethodDisplay = F2(
	function (source, isEditable) {
		var sourceType = $author$project$Api$Provider$Membership$Source$type_(source);
		var isCard = sourceType === 'Card';
		var zipText = isCard ? A2(
			$elm$core$Maybe$map,
			function (zip) {
				return 'ZIP code ' + zip;
			},
			$author$project$Api$Provider$Membership$Source$zip(source)) : $elm$core$Maybe$Nothing;
		var expiresText = function () {
			if (isCard) {
				var _v1 = _Utils_Tuple2(
					$author$project$Api$Provider$Membership$Source$expMonth(source),
					$author$project$Api$Provider$Membership$Source$expYear(source));
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var expMonth = _v1.a.a;
					var expYear = _v1.b.a;
					return $elm$core$Maybe$Just(
						'Expires ' + ($elm$core$String$fromInt(expMonth) + ('/' + $elm$core$String$fromInt(expYear))));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var secondLineText = A2(
			$elm$core$String$join,
			', ',
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[expiresText, zipText])));
		return A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$span(6)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$mb2]),
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$strong,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('inline')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Formatters$String$titleize(
														$author$project$Api$Provider$Membership$Source$name(source)))
												])),
											$elm$html$Html$text(' '),
											A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[
													$author$project$Ui$Typography$phi(true)
												]),
											'*' + $author$project$Api$Provider$Membership$Source$lastFour(source)),
											$elm$html$Html$text(' '),
											function () {
											var _v0 = $author$project$Api$Provider$Membership$Source$funding(source);
											if (!_v0.$) {
												var funding = _v0.a;
												return A2($author$project$Ui$Typography$text, _List_Nil, '(' + (funding + ')'));
											} else {
												return $author$project$Utils$Html$empty;
											}
										}(),
											$elm$html$Html$text(' '),
											A2(
											$author$project$Ui$Badge$fromString,
											_List_Nil,
											$author$project$Api$Provider$Membership$Source$status(source))
										])),
								$elm$core$String$isEmpty(secondLineText) ? _List_Nil : _List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_fromArray(
											[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
										_List_fromArray(
											[
												$elm$html$Html$text(secondLineText)
											]))
									])))
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$span(6)
						]),
					_List_fromArray(
						[
							isEditable ? A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flex, $author$project$Ui$Element$justifyRight]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Change Payment Method'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$Pricing$ToggleEditPaymentMethod)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Change Payment Method')
										]))
								])) : $author$project$Utils$Html$empty
						]))
				]));
	});
var $author$project$Components$Membership$Form$Sections$Pricing$viewPaymentMethodOption = function (paymentMethod) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$strong,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('inline')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Formatters$String$titleize(
								$author$project$Api$Provider$PaymentMethod$Min$paymentMethodBrand(paymentMethod)))
						])),
					$elm$html$Html$text(' '),
					function () {
					var _v0 = $author$project$Api$Provider$PaymentMethod$Min$lastFour(paymentMethod);
					if (!_v0.$) {
						var lastFour = _v0.a;
						return A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[
									$author$project$Ui$Typography$phi(true)
								]),
							'*' + lastFour);
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]))
		]);
};
var $author$project$Components$Membership$Form$Sections$Pricing$viewPaymentMethodField = F2(
	function (membership, model) {
		var _v0 = function () {
			var _v1 = model.C8;
			if (_v1.$ === 3) {
				if (!_v1.a.$) {
					var list = _v1.a.a;
					return _Utils_Tuple2(false, list);
				} else {
					var _v2 = _v1.a;
					return _Utils_Tuple2(false, _List_Nil);
				}
			} else {
				return _Utils_Tuple2(true, _List_Nil);
			}
		}();
		var paymentMethodsLoading = _v0.a;
		var paymentMethodsList = _v0.b;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Payment Method')
				]),
			_List_fromArray(
				[
					function () {
					if (model.nq) {
						return A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$row,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$span(6)
												]),
											_List_fromArray(
												[
													A4(
													$author$project$Ui$Dropdown$viewSelect,
													_List_fromArray(
														[
															$author$project$Ui$Dropdown$loading(paymentMethodsLoading)
														]),
													function () {
														var _v3 = model.lf;
														if (!_v3.$) {
															var pm = _v3.a;
															return $author$project$Components$Membership$Form$Sections$Pricing$viewPaymentMethodOption(pm);
														} else {
															return _List_fromArray(
																[
																	A2(
																	$author$project$Ui$Typography$text,
																	_List_fromArray(
																		[$author$project$Ui$Typography$muted]),
																	'Select a payment method')
																]);
														}
													}(),
													function () {
														if (paymentMethodsLoading) {
															return _List_Nil;
														} else {
															var query = $elm$core$String$toLower(model.o1);
															return A2(
																$elm$core$List$cons,
																$author$project$Ui$Dropdown$input(
																	_List_fromArray(
																		[
																			$author$project$Ui$Dropdown$onInput($author$project$Components$Membership$Form$Sections$Pricing$PaymentMethodSearchChanged),
																			$author$project$Ui$Dropdown$value(model.o1),
																			$author$project$Ui$Dropdown$placeholder('Search...')
																		])),
																A2(
																	$elm$core$List$map,
																	function (pm) {
																		return A2(
																			$author$project$Ui$Dropdown$item,
																			_List_fromArray(
																				[
																					$author$project$Ui$Dropdown$onSelect(
																					$author$project$Components$Membership$Form$Sections$Pricing$PaymentMethodSelected(
																						$elm$core$Maybe$Just(pm))),
																					$author$project$Ui$Dropdown$selected(
																					_Utils_eq(
																						A2($elm$core$Maybe$map, $author$project$Api$Provider$PaymentMethod$Min$id, model.lf),
																						$elm$core$Maybe$Just(
																							$author$project$Api$Provider$PaymentMethod$Min$id(pm))))
																				]),
																			A2(
																				$elm$html$Html$span,
																				_List_Nil,
																				$author$project$Components$Membership$Form$Sections$Pricing$viewPaymentMethodOption(pm)));
																	},
																	A2(
																		$elm$core$List$filter,
																		function (pm) {
																			return $elm$core$String$isEmpty(query) || A2(
																				$elm$core$String$contains,
																				query,
																				$elm$core$String$toLower(
																					$author$project$Components$Membership$Form$Sections$Pricing$paymentMethodTitle(pm)));
																		},
																		paymentMethodsList)));
														}
													}(),
													model.o0)
												])),
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$span(6)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$flex, $author$project$Ui$Element$justifyRight]),
													_List_fromArray(
														[
															A3(
															$author$project$Ui$Button$view,
															{mm: 'Cancel'},
															_List_fromArray(
																[
																	$author$project$Ui$Button$link,
																	$author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$Pricing$ToggleEditPaymentMethod)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Cancel')
																]))
														]))
												]))
										])),
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$helpBlock]),
									_List_fromArray(
										[
											$elm$html$Html$text('Any upcoming payments for this membership will be charged to the new payment method.')
										]))
								]));
					} else {
						var source = $author$project$Api$Provider$Membership$One$source(membership);
						var isEditable = $author$project$Api$Provider$Membership$Meta$paymentSourceEditable(
							$author$project$Api$Provider$Membership$One$meta(membership));
						if (!source.$) {
							var src = source.a;
							return A2(
								$author$project$Ui$Form$Static$view,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$Components$Membership$Form$Sections$Pricing$viewPaymentMethodDisplay, src, isEditable)
									]));
						} else {
							return A2(
								$author$project$Ui$Form$Static$view,
								_List_fromArray(
									[$author$project$Ui$Form$Static$muted, $author$project$Ui$Form$Static$flex, $author$project$Ui$Form$Static$spaceBetween, $author$project$Ui$Form$Static$itemsCenter]),
								_List_fromArray(
									[
										$elm$html$Html$text('No payment method'),
										(isEditable && (!$elm$core$List$isEmpty(paymentMethodsList))) ? A3(
										$author$project$Ui$Button$view,
										{mm: 'Change Payment Method'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$Pricing$ToggleEditPaymentMethod)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Change Payment Method')
											])) : $author$project$Utils$Html$empty
									]));
						}
					}
				}()
				]));
	});
var $author$project$Components$Membership$Form$Sections$Pricing$FixedRegistrationFeeInCents = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Membership$Form$Sections$Pricing$ToggleRegistrationFeeOverride = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Membership$Form$Sections$Pricing$viewRegistrationFeeField = F2(
	function (pendingMembership, form) {
		var _v0 = $author$project$Utils$Form$fields(form);
		var fixedRegistrationFeeInCents = _v0.Sy;
		var manuallySet = _v0.cK;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Registration Fee'),
					$author$project$Ui$Form$Group$required(manuallySet.e1)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(6)
								]),
							_List_fromArray(
								[
									function () {
									if (manuallySet.e1) {
										return A2(
											$author$project$Ui$Element$view,
											_List_Nil,
											_List_fromArray(
												[
													$author$project$Ui$Form$CurrencyInput$view(
													_List_fromArray(
														[
															$author$project$Ui$Form$CurrencyInput$value(fixedRegistrationFeeInCents),
															$author$project$Ui$Form$CurrencyInput$onInput(
															A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Sections$Pricing$FormUpdated, $author$project$Components$Membership$Form$Sections$Pricing$FixedRegistrationFeeInCents)),
															$author$project$Ui$Form$CurrencyInput$invalid(
															A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
															$author$project$Ui$Form$CurrencyInput$placeholder('10.00')
														])),
													$author$project$Utils$FormErrors$view(
													A2($author$project$Utils$Form$validationErrors, 1, form))
												]));
									} else {
										var registrationFeeInCents = A2(
											$elm$core$Maybe$withDefault,
											0,
											A2(
												$elm$core$Maybe$andThen,
												$author$project$Api$Provider$MembershipBill$ForMembershipOne$registrationFeeInCents,
												$elm$core$List$head(
													$author$project$Api$Provider$Membership$One$upcomingAndOutstandingBills(pendingMembership))));
										return A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Utils$Currency$fromInt(registrationFeeInCents))
												]));
									}
								}()
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(6),
									$author$project$Ui$Grid$justifyRight
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									_List_fromArray(
										[
											function () {
											var label = manuallySet.e1 ? 'Remove Override' : 'Override Registration Fee';
											return A3(
												$author$project$Ui$Button$view,
												{mm: label},
												_List_fromArray(
													[
														$author$project$Ui$Button$link,
														$author$project$Ui$Button$onClick(
														$author$project$Components$Membership$Form$Sections$Pricing$ToggleRegistrationFeeOverride(pendingMembership))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(label)
													]));
										}()
										]))
								]))
						])),
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(12)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$helpBlock]),
									_List_fromArray(
										[
											manuallySet.e1 ? $elm$html$Html$text('Fixed registration fee') : $elm$html$Html$text('Standard registration fee')
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Membership$Form$Sections$Pricing$viewForm = F2(
	function (_v0, model) {
		var membership = _v0.kk;
		var pendingMembership = _v0.dC;
		var onlyOneFixedPeriodRateInCentsEditable = _v0.ajA;
		var pendingMembershipMeta = $author$project$Api$Provider$Membership$One$meta(pendingMembership);
		var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					(!$author$project$Components$Membership$Form$Sections$Pricing$planIsFixedFee(pendingMembership)) ? A3($author$project$Components$Membership$Form$Sections$Pricing$viewFixedRateField, pendingMembership, onlyOneFixedPeriodRateInCentsEditable, model.SD) : $author$project$Utils$Html$empty,
					($author$project$Utils$Maybe$toBool(
					$author$project$Api$Provider$Membership$One$coupon(membership)) || $author$project$Api$Provider$Membership$Meta$couponEditable(membershipMeta)) ? A5($author$project$Components$Membership$Form$Sections$Pricing$viewCouponField, membership, pendingMembership, model.yT, model.Q1, model.SD) : $author$project$Utils$Html$empty,
					((!$author$project$Api$Provider$Membership$One$isSponsored(membership)) && $author$project$Api$Provider$Membership$Meta$paymentSourceEditable(
					$author$project$Api$Provider$Membership$One$meta(membership))) ? A2($author$project$Components$Membership$Form$Sections$Pricing$viewPaymentMethodField, membership, model) : $author$project$Utils$Html$empty,
					($author$project$Api$Provider$Membership$Meta$fixedRegistrationFeeInCentsEditable(pendingMembershipMeta) && (!$author$project$Components$Membership$Form$Sections$Pricing$planIsFixedFee(pendingMembership))) ? A2($author$project$Components$Membership$Form$Sections$Pricing$viewRegistrationFeeField, pendingMembership, model.SD) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$Membership$Form$Sections$Pricing$view = F2(
	function (sectionsShared, _v0) {
		var model = _v0;
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$HorizontalRule$view(_List_Nil),
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Pricing')
						])),
					$author$project$Utils$Maybe$toBool(
					$author$project$Api$Provider$Membership$One$nextBillDate(sectionsShared.dC)) ? A2($author$project$Components$Membership$Form$Sections$Pricing$viewForm, sectionsShared, model) : A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$offset(5),
									$author$project$Ui$Grid$span(7)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$em,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('This membership has no upcoming bills.')
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Membership$Form$Sections$RecurringCharges$AddRecurringCharge = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Membership$Form$Sections$RecurringCharges$AddEndDate = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Membership$Form$Sections$RecurringCharges$Edit = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Membership$Form$Sections$RecurringCharges$FormUpdated = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$Membership$Form$Sections$RecurringCharges$PeriodInMonths = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Membership$Form$Sections$RecurringCharges$Quantity = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Membership$Form$Sections$RecurringCharges$Remove = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Form$Static$Numeric = {$: 1};
var $author$project$Ui$Form$Static$numeric = $author$project$Ui$Form$Static$Numeric;
var $author$project$Components$Membership$Form$Sections$RecurringCharges$validQuantities = function (recurringCharge) {
	var _v0 = $author$project$Api$Provider$Uom$Shared$periodInMonths(recurringCharge.adP);
	if (_v0.$ === 1) {
		return A2($elm$core$List$range, 1, 100);
	} else {
		var periodInMonths = _v0.a;
		return (periodInMonths === 1) ? (_Utils_eq(
			recurringCharge.Zu,
			$elm$core$Maybe$Just(1)) ? A2($elm$core$List$range, 1, 12) : _List_fromArray(
			[1, 3, 6, 12])) : A2($elm$core$List$range, 1, 4);
	}
};
var $author$project$Components$Membership$Form$Sections$RecurringCharges$validRecurringChargePeriods = function (recurringCharge) {
	var _v0 = $author$project$Api$Provider$Uom$Shared$periodInMonths(recurringCharge.adP);
	if (_v0.$ === 1) {
		return _List_fromArray(
			[1, 3, 6, 12]);
	} else {
		var periodInMonths = _v0.a;
		return A2(
			$elm$core$List$map,
			function (quantity) {
				return quantity * periodInMonths;
			},
			$author$project$Components$Membership$Form$Sections$RecurringCharges$validQuantities(recurringCharge));
	}
};
var $author$project$Components$Membership$Form$Sections$RecurringCharges$periodInMonthsOptions = function (recurringCharge) {
	return A2(
		$elm$core$List$map,
		function (period) {
			return A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(
					$elm$core$String$fromInt(period)),
				$author$project$Formatters$Int$asPeriodHuman(period));
		},
		$author$project$Components$Membership$Form$Sections$RecurringCharges$validRecurringChargePeriods(recurringCharge));
};
var $author$project$Components$Membership$Form$Sections$RecurringCharges$validEndPeriods = function (recurringCharge) {
	var periodInMonths = A2($elm$core$Maybe$withDefault, 0, recurringCharge.Zs);
	return A2($elm$core$List$range, 1, (((23 / periodInMonths) | 0) + ((periodInMonths / 4) | 0)) + 1);
};
var $author$project$Components$Membership$Form$Sections$RecurringCharges$periodsRemainingOptions = function (recurringCharge) {
	var periodInMonths = A2($elm$core$Maybe$withDefault, 0, recurringCharge.Zs);
	return A2(
		$elm$core$List$cons,
		A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, 'Unlimited'),
		A2(
			$elm$core$List$map,
			function (remaining) {
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(
						$elm$core$String$fromInt(remaining)),
					A2($author$project$Formatters$String$pluralize, 'month', remaining * periodInMonths));
			},
			$author$project$Components$Membership$Form$Sections$RecurringCharges$validEndPeriods(recurringCharge)));
};
var $author$project$Components$Membership$Form$Sections$RecurringCharges$quantityOptions = function (recurringCharge) {
	var uom = recurringCharge.adP;
	if ($author$project$Api$Provider$Uom$Shared$isTimeBased(uom)) {
		var periodInMonths = A2(
			$elm$core$Maybe$withDefault,
			0,
			$author$project$Api$Provider$Uom$Shared$periodInMonths(uom));
		return A2(
			$elm$core$List$map,
			function (quantity) {
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(
						$elm$core$String$fromInt(quantity)),
					A2($author$project$Formatters$String$pluralize, 'month', quantity * periodInMonths));
			},
			$author$project$Components$Membership$Form$Sections$RecurringCharges$validQuantities(recurringCharge));
	} else {
		return A2(
			$elm$core$List$map,
			function (quantity) {
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(
						$elm$core$String$fromInt(quantity)),
					$elm$core$String$fromInt(quantity));
			},
			A2($elm$core$List$range, 1, 99));
	}
};
var $author$project$Ui$Typography$SrOnly = {$: 24};
var $author$project$Ui$Typography$srOnly = $author$project$Ui$Typography$SrOnly;
var $author$project$Components$Membership$Form$Sections$RecurringCharges$viewRecurringCharge = F4(
	function (pendingMembership, patients, index, recurringCharge) {
		var uom = recurringCharge.adP;
		var quantity = A2($elm$core$Maybe$withDefault, 0, recurringCharge.Dz);
		var pendingMembershipMeta = $author$project$Api$Provider$Membership$One$meta(pendingMembership);
		var chargeItem = recurringCharge.mL;
		var priceInCents = A2($elm$core$Maybe$withDefault, chargeItem.Dw, recurringCharge.ahp);
		return A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$spaceBetween]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_Nil,
											_List_fromArray(
												[
													_Utils_eq(
													recurringCharge.Zu,
													$elm$core$Maybe$Just(1)) ? A2(
													$author$project$Ui$Typography$text,
													_List_fromArray(
														[$author$project$Ui$Typography$muted]),
													'On next invoice') : A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Typography$text,
															_List_fromArray(
																[$author$project$Ui$Typography$muted]),
															'Invoiced'),
															$author$project$Utils$Html$noBreakSpace,
															A2(
															$author$project$Ui$Form$Select$view,
															_List_fromArray(
																[
																	$author$project$Ui$Form$Select$inline,
																	$author$project$Ui$Form$Select$value(
																	A2($elm$core$Maybe$map, $elm$core$String$fromInt, recurringCharge.Zs)),
																	$author$project$Ui$Form$Select$onChange(
																	A2(
																		$elm$core$Basics$composeL,
																		A2(
																			$elm$core$Basics$composeL,
																			$author$project$Components$Membership$Form$Sections$RecurringCharges$FormUpdated(index),
																			$author$project$Components$Membership$Form$Sections$RecurringCharges$PeriodInMonths),
																		$elm$core$String$toInt))
																]),
															$author$project$Components$Membership$Form$Sections$RecurringCharges$periodInMonthsOptions(recurringCharge)),
															$author$project$Utils$Html$noBreakSpace,
															(A2($elm$core$Maybe$withDefault, 0, recurringCharge.aj1) > 0) ? A2(
															$elm$html$Html$span,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	$author$project$Ui$Typography$text,
																	_List_fromArray(
																		[$author$project$Ui$Typography$muted]),
																	'for'),
																	$author$project$Utils$Html$noBreakSpace,
																	A2(
																	$author$project$Ui$Form$Select$view,
																	_List_fromArray(
																		[
																			$author$project$Ui$Form$Select$inline,
																			$author$project$Ui$Form$Select$value(
																			A2($elm$core$Maybe$map, $elm$core$String$fromInt, recurringCharge.aj1)),
																			$author$project$Ui$Form$Select$onChange(
																			A2(
																				$elm$core$Basics$composeL,
																				A2(
																					$elm$core$Basics$composeL,
																					$author$project$Components$Membership$Form$Sections$RecurringCharges$FormUpdated(index),
																					$author$project$Components$Membership$Form$Sections$RecurringCharges$PeriodsRemaining),
																				$elm$core$String$toInt))
																		]),
																	$author$project$Components$Membership$Form$Sections$RecurringCharges$periodsRemainingOptions(recurringCharge))
																])) : A2(
															$elm$html$Html$span,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	$author$project$Ui$Typography$text,
																	_List_fromArray(
																		[$author$project$Ui$Typography$muted]),
																	' until membership ends '),
																	A3(
																	$author$project$Ui$Button$view,
																	{mm: 'Add end date'},
																	_List_fromArray(
																		[
																			$author$project$Ui$Button$sm,
																			$author$project$Ui$Button$onClick(
																			$author$project$Components$Membership$Form$Sections$RecurringCharges$AddEndDate(index))
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Add End Date')
																		]))
																]))
														]))
												])),
											$author$project$Api$Provider$Membership$Meta$recurringChargesEditable(pendingMembershipMeta) ? A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Button$view,
													{mm: 'Remove recurring charge'},
													_List_fromArray(
														[
															$author$project$Ui$Button$sm,
															$author$project$Ui$Button$onClick(
															$author$project$Components$Membership$Form$Sections$RecurringCharges$Remove(index)),
															$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Remove')
														])),
													A3(
													$author$project$Ui$Button$view,
													{mm: 'Edit recurring charge'},
													_List_fromArray(
														[
															$author$project$Ui$Button$sm,
															$author$project$Ui$Button$onClick(
															A2($author$project$Components$Membership$Form$Sections$RecurringCharges$Edit, patients, index)),
															$author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Edit')
														]))
												])) : $author$project$Utils$Html$empty
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[
													$author$project$Ui$Typography$phi(true)
												]),
											A2(
												$elm$core$Maybe$withDefault,
												'No Patient',
												A2(
													$elm$core$Maybe$map,
													function ($) {
														return $.Bq;
													},
													recurringCharge.YY))),
											function () {
											var _v0 = recurringCharge.aka;
											if (!_v0.$) {
												var practitioner = _v0.a;
												return A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(' with '),
															$elm$html$Html$text(practitioner.Bq)
														]));
											} else {
												return $author$project$Utils$Html$empty;
											}
										}(),
											(!_Utils_eq(
											recurringCharge.Zu,
											$elm$core$Maybe$Just(1))) ? A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													function () {
													var _v1 = recurringCharge.Zs;
													if (!_v1.$) {
														var periodInMonths = _v1.a;
														return A2(
															$elm$html$Html$span,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(' repeating every '),
																	$elm$html$Html$text(
																	A2($author$project$Formatters$String$pluralize, 'month', periodInMonths))
																]));
													} else {
														return $author$project$Utils$Html$empty;
													}
												}(),
													function () {
													var _v2 = _Utils_Tuple2(recurringCharge.aj1, recurringCharge.Zs);
													if ((!_v2.a.$) && (!_v2.b.$)) {
														var periodsRemaining = _v2.a.a;
														var periodInMonths = _v2.b.a;
														return A2(
															$elm$html$Html$span,
															_List_Nil,
															_List_fromArray(
																[
																	_Utils_eq(
																	$elm$core$Maybe$Just(periodsRemaining),
																	recurringCharge.Zu) ? $elm$html$Html$text(' for ') : $elm$html$Html$text(' for the next '),
																	$elm$html$Html$text(
																	A2($author$project$Formatters$String$pluralize, 'month', periodsRemaining * periodInMonths))
																]));
													} else {
														return $author$project$Utils$Html$empty;
													}
												}()
												])) : $author$project$Utils$Html$empty
										])),
									A2(
									$author$project$Ui$Grid$row,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$span(5)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$label,
													_List_fromArray(
														[$author$project$Ui$Typography$controlLabel, $author$project$Ui$Typography$srOnly]),
													_List_fromArray(
														[
															$elm$html$Html$text('Item')
														])),
													A2(
													$author$project$Ui$Form$Static$view,
													_List_fromArray(
														[
															$author$project$Ui$Form$Static$phi(true)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Typography$strong,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	A2($elm$core$Maybe$withDefault, chargeItem.Bq, recurringCharge.Bq))
																]))
														]))
												])),
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$span(2)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$label,
													_List_fromArray(
														[$author$project$Ui$Typography$controlLabel, $author$project$Ui$Typography$srOnly]),
													_List_fromArray(
														[
															$elm$html$Html$text('Quantity')
														])),
													A2(
													$author$project$Ui$Form$Select$view,
													_List_fromArray(
														[
															$author$project$Ui$Form$Select$inline,
															$author$project$Ui$Form$Select$value(
															A2($elm$core$Maybe$map, $elm$core$String$fromInt, recurringCharge.Dz)),
															$author$project$Ui$Form$Select$onChange(
															A2(
																$elm$core$Basics$composeL,
																A2(
																	$elm$core$Basics$composeL,
																	$author$project$Components$Membership$Form$Sections$RecurringCharges$FormUpdated(index),
																	$author$project$Components$Membership$Form$Sections$RecurringCharges$Quantity),
																$elm$core$String$toInt)),
															$author$project$Ui$Form$Select$disabled(
															$author$project$Api$Provider$Uom$Shared$isTimeBased(uom) && (!_Utils_eq(
																recurringCharge.Zu,
																$elm$core$Maybe$Just(1))))
														]),
													$author$project$Components$Membership$Form$Sections$RecurringCharges$quantityOptions(recurringCharge))
												])),
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$span(3)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$label,
													_List_fromArray(
														[$author$project$Ui$Typography$controlLabel, $author$project$Ui$Typography$srOnly]),
													_List_fromArray(
														[
															$elm$html$Html$text('Price')
														])),
													A2(
													$author$project$Ui$Form$Static$view,
													_List_fromArray(
														[$author$project$Ui$Form$Static$numeric]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Currency$format(
																$author$project$Currency$fromFloat(priceInCents))),
															A2($elm$html$Html$br, _List_Nil, _List_Nil),
															$author$project$Api$Provider$Uom$Shared$isTimeBased(uom) ? A2(
															$elm$html$Html$span,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	$author$project$Ui$Typography$text,
																	_List_fromArray(
																		[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
																	'per '),
																	A2(
																	$author$project$Ui$Typography$text,
																	_List_fromArray(
																		[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
																	$author$project$Api$Provider$Uom$Shared$name(uom))
																])) : $author$project$Utils$Html$empty
														]))
												])),
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$span(2)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$label,
													_List_fromArray(
														[$author$project$Ui$Typography$controlLabel, $author$project$Ui$Typography$srOnly]),
													_List_fromArray(
														[
															$elm$html$Html$text('Price')
														])),
													A2(
													$author$project$Ui$Form$Static$view,
													_List_fromArray(
														[$author$project$Ui$Form$Static$numeric]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Typography$strong,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Currency$format(
																		$author$project$Currency$fromFloat(priceInCents * quantity)))
																]))
														]))
												]))
										])),
									A2(
									$author$project$Ui$Grid$row,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$span(8)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Form$Static$view,
													_List_fromArray(
														[
															$author$project$Ui$Form$Static$phi(true),
															$author$project$Ui$Form$Static$muted
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2(
																$elm$core$Maybe$withDefault,
																A2($elm$core$Maybe$withDefault, 'No Description', chargeItem.Qr),
																recurringCharge.aho))
														]))
												])),
											((!_Utils_eq(
											recurringCharge.Zu,
											$elm$core$Maybe$Just(1))) && (!_Utils_eq(
											recurringCharge.aj1,
											$elm$core$Maybe$Just(0)))) ? A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$span(4)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$textMuted]),
													_List_fromArray(
														[
															function () {
															if ((!$author$project$Utils$Maybe$toBool(recurringCharge.ab7)) || _Utils_eq(recurringCharge.ab7, recurringCharge.XP)) {
																var startDate = A2(
																	$elm$core$Maybe$withDefault,
																	$author$project$Api$Provider$Membership$One$billFromDate(pendingMembership),
																	recurringCharge.ab7);
																return A2(
																	$elm$html$Html$span,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			$author$project$Ui$Typography$text,
																			_List_fromArray(
																				[
																					$author$project$Ui$Typography$phi(true)
																				]),
																			'Starting on '),
																			A2(
																			$author$project$Ui$Typography$text,
																			_List_fromArray(
																				[
																					$author$project$Ui$Typography$phi(true)
																				]),
																			A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, startDate))
																		]));
															} else {
																return $author$project$Utils$Html$empty;
															}
														}(),
															function () {
															var _v3 = _Utils_Tuple2(
																recurringCharge.XP,
																!_Utils_eq(recurringCharge.XP, recurringCharge.ab7));
															if ((!_v3.a.$) && _v3.b) {
																var nextBillDate = _v3.a.a;
																return A2(
																	$elm$html$Html$span,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			$author$project$Ui$Typography$text,
																			_List_fromArray(
																				[
																					$author$project$Ui$Typography$phi(true)
																				]),
																			'Recurring on '),
																			A2(
																			$author$project$Ui$Typography$text,
																			_List_fromArray(
																				[
																					$author$project$Ui$Typography$phi(true)
																				]),
																			A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, nextBillDate))
																		]));
															} else {
																return $author$project$Utils$Html$empty;
															}
														}()
														]))
												])) : $author$project$Ui$Grid$none
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Membership$Form$Sections$RecurringCharges$viewRecurringCharges = F4(
	function (pendingMembership, patients, hasChargeItems, recurringCharges) {
		var pendingMembershipMeta = $author$project$Api$Provider$Membership$One$meta(pendingMembership);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_Utils_ap(
				A2(
					$elm$core$List$indexedMap,
					A2($author$project$Components$Membership$Form$Sections$RecurringCharges$viewRecurringCharge, pendingMembership, patients),
					recurringCharges),
				(hasChargeItems && $author$project$Api$Provider$Membership$Meta$recurringChargesEditable(pendingMembershipMeta)) ? _List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$textCenter]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Add charge'},
								_List_fromArray(
									[
										$author$project$Ui$Button$onClick(
										$author$project$Components$Membership$Form$Sections$RecurringCharges$AddRecurringCharge(patients)),
										$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Add Charge')
									]))
							]))
					]) : _List_Nil));
	});
var $author$project$Components$Membership$Form$Sections$RecurringCharges$view = F2(
	function (_v0, _v1) {
		var pendingMembership = _v0.dC;
		var patients = _v0.CM;
		var model = _v1;
		var _v2 = $author$project$Utils$Form$fields(model.SD);
		var recurringCharges = _v2.$h;
		return ((!model.sv) && $elm$core$List$isEmpty(recurringCharges)) ? $author$project$Utils$Html$empty : A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$HorizontalRule$view(_List_Nil),
					A2(
					$author$project$Ui$Grid$row,
					_List_fromArray(
						[$author$project$Ui$Grid$rowItemsCenter]),
					$elm$core$List$concat(
						_List_fromArray(
							[
								_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(5)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Typography$headingSm(
											_List_fromArray(
												[
													$elm$html$Html$text('Additional Charges')
												]))
										]))
								]),
								function () {
								if ($elm$core$List$isEmpty(recurringCharges)) {
									var pendingMembershipMeta = $author$project$Api$Provider$Membership$One$meta(pendingMembership);
									return _List_fromArray(
										[
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$span(7)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$spaceBetween]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Typography$text,
															_List_fromArray(
																[$author$project$Ui$Typography$muted]),
															'None'),
															$author$project$Api$Provider$Membership$Meta$recurringChargesEditable(pendingMembershipMeta) ? A3(
															$author$project$Ui$Button$view,
															{mm: 'Add charge'},
															_List_fromArray(
																[
																	$author$project$Ui$Button$link,
																	$author$project$Ui$Button$onClick(
																	$author$project$Components$Membership$Form$Sections$RecurringCharges$AddRecurringCharge(patients))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Add Charge')
																])) : $author$project$Utils$Html$empty
														]))
												]))
										]);
								} else {
									return _List_fromArray(
										[
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$span(2)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$textRight]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Typography$text,
															_List_fromArray(
																[$author$project$Ui$Typography$hintLabel]),
															'Qty')
														]))
												])),
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$span(3)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$textRight]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Typography$text,
															_List_fromArray(
																[$author$project$Ui$Typography$hintLabel]),
															'Price')
														]))
												])),
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$span(2)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$textRight]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Typography$text,
															_List_fromArray(
																[$author$project$Ui$Typography$hintLabel]),
															'Amount')
														]))
												]))
										]);
								}
							}()
							]))),
					(!$elm$core$List$isEmpty(recurringCharges)) ? A4($author$project$Components$Membership$Form$Sections$RecurringCharges$viewRecurringCharges, pendingMembership, patients, model.sv, recurringCharges) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Api$Feature$MembershipAutoRenewEditable = 5;
var $author$project$Api$Provider$Practice$One$anyRetailBrokers = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.LS;
	});
var $author$project$Api$Provider$Membership$One$cancellationReason = function (_v0) {
	var record = _v0.b;
	return record.afo;
};
var $author$project$Components$Membership$Form$Sections$Summary$isMembershipStatus = F2(
	function (statuses, membership) {
		return A2(
			$elm$core$List$member,
			$author$project$Api$Provider$Membership$One$status(membership),
			statuses);
	});
var $author$project$Components$Membership$Form$Sections$Summary$AutoRenew = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Membership$Form$Sections$Summary$viewAutoRenewInput = F2(
	function (membership, _v0) {
		var autoRenew = _v0.Mk;
		var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Auto Invoice')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Checkbox$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Checkbox$value(autoRenew),
							$author$project$Ui$Form$Checkbox$onCheck(
							A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Sections$Summary$FormUpdated, $author$project$Components$Membership$Form$Sections$Summary$AutoRenew)),
							$author$project$Ui$Form$Checkbox$disabled(
							!$author$project$Api$Provider$Membership$Meta$autoRenewEditable(membershipMeta))
						]),
					_List_fromArray(
						[
							autoRenew ? A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[$author$project$Ui$Typography$small]),
							'Invoices are currently being automatically generated for this membership') : $author$project$Utils$Html$empty,
							($author$project$Api$Provider$Membership$Meta$autoRenewEditable(membershipMeta) && (!autoRenew)) ? A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$small, $author$project$Ui$Typography$gray]),
									'We are currently '),
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('not')
										])),
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$small, $author$project$Ui$Typography$gray]),
									' automatically creating invoices for this membership. Check the box to the left to start generating automated invoices.')
								])) : $author$project$Utils$Html$empty
						]))
				]));
	});
var $author$project$Components$Membership$Form$Sections$Summary$AddBroker = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$BrokerDeal$Timeline$viewWithoutControls = F2(
	function (options, brokerDeal) {
		return A5(
			$author$project$Components$BrokerDeal$Timeline$view,
			options.alu,
			brokerDeal,
			$author$project$Utils$Html$empty,
			$author$project$Utils$Html$empty,
			$elm$core$Basics$always($author$project$Utils$Html$empty));
	});
var $author$project$Components$Membership$Form$Sections$Summary$viewBrokerDeal = F3(
	function (brokerDeals, index, brokerDeal) {
		var isLast = _Utils_eq(
			index,
			$elm$core$List$length(brokerDeals) - 1);
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$Broker$Shared$name(brokerDeal.xF)),
							$elm$html$Html$text(' ('),
							$elm$html$Html$text(
							$author$project$Api$Provider$BrokerAccount$Shared$name(
								$author$project$Api$Provider$Broker$Shared$brokerAccount(brokerDeal.xF))),
							$elm$html$Html$text(')')
						])),
					A2(
					$author$project$Components$BrokerDeal$Timeline$viewWithoutControls,
					{alu: false},
					brokerDeal),
					(!isLast) ? $author$project$Ui$HorizontalRule$view(_List_Nil) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$Membership$Form$Sections$Summary$viewBrokerInput = F3(
	function (isNew, membership, model) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Broker')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						$author$project$Components$Membership$Form$Sections$Summary$viewBrokerDeal(model.MR),
						model.MR)),
					A3(
					$author$project$Ui$Button$view,
					{mm: 'Add broker'},
					_List_fromArray(
						[
							$author$project$Ui$Button$disabled(isNew),
							$author$project$Ui$Button$onClick(
							$author$project$Components$Membership$Form$Sections$Summary$AddBroker(membership)),
							$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Add broker')
						])),
					isNew ? A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
					_List_fromArray(
						[
							$elm$html$Html$text('You will be able to assign a broker after the membership is created.')
						])) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Api$Provider$Membership$One$cancellationReasonOther = function (_v0) {
	var record = _v0.b;
	return record.afp;
};
var $author$project$Components$CancellationReason$Display$viewShared = F2(
	function (cancellationReason, cancellationReasonOther) {
		return A2(
			$author$project$Components$CancellationReason$Display$view,
			$author$project$Components$CancellationReason$CancellationReasonRecord$fromShared(cancellationReason),
			cancellationReasonOther);
	});
var $author$project$Components$Membership$Form$Sections$Summary$viewCancellationReason = F2(
	function (membership, cancellationReason) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Cancellation Reason')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Components$CancellationReason$Display$viewShared,
							cancellationReason,
							$author$project$Api$Provider$Membership$One$cancellationReasonOther(membership))
						]))
				]));
	});
var $author$project$Components$Membership$Form$Sections$Summary$viewCompanyName = F2(
	function (company, model) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label(
					A2($author$project$Formatters$String$sponsorize, model.ZV, 'Employer') + ' Name')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top(
								{
									fZ: $author$project$Api$Provider$Company$Shared$id(company)
								}),
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$Company$Shared$name(company))
								]))
						]))
				]));
	});
var $author$project$Components$Membership$Form$Sections$Summary$viewEndDate = F2(
	function (membership, model) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('End Date')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'N/A',
								A2(
									$elm$core$Maybe$map,
									$author$project$Formatters$Date$toString(
										A2($author$project$Formatters$Date$Relative, model.dd, $elm$core$Maybe$Nothing)),
									$author$project$Api$Provider$Membership$One$endDate(membership))))
						]))
				]));
	});
var $author$project$Components$Membership$Form$Sections$Summary$viewMembershipType = function (model) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9),
				$author$project$Ui$Form$Group$label('Membership Type')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($author$project$Formatters$String$sponsorize, model.ZV, 'Employer'))
					]))
			]));
};
var $author$project$Components$Membership$Form$Sections$Summary$MinimumEnrollmentPeriodInMonths = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Membership$Form$Sections$Summary$ToggleMinimumEnrollmentPeriodInMonths = {$: 4};
var $author$project$Api$Provider$Membership$Shared$minimumEnrollmentStartDate = function (_v0) {
	var record = _v0;
	return record.Xg;
};
var $author$project$Api$Provider$Membership$One$minimumEnrollmentStartDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Membership$Shared$minimumEnrollmentStartDate(shared);
};
var $author$project$Components$Membership$Form$Sections$Summary$viewMinimumEnrollmentPeriodInMonthsInput = F3(
	function (pendingMembership, _v0, model) {
		var minimumEnrollmentPeriodInMonths = _v0.Xf;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Minimum Enrollment')
				]),
			_List_fromArray(
				[
					model.p0.fx ? A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$flex, $author$project$Ui$Element$justifyRight]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Add minimum enrollment'},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$Summary$ToggleMinimumEnrollmentPeriodInMonths)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Add Minimum Enrollment')
								]))
						])) : A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(9)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$PeriodInMonthsSelect$view(
											{
												XY: 'Choose an option',
												ajd: A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Sections$Summary$FormUpdated, $author$project$Components$Membership$Form$Sections$Summary$MinimumEnrollmentPeriodInMonths),
												Cd: A2($elm$core$List$range, 1, 12),
												aee: minimumEnrollmentPeriodInMonths
											})
										])),
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(3),
											$author$project$Ui$Grid$justifyRight,
											$author$project$Ui$Grid$itemsCenter
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{mm: 'Remove minimum enrollment'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$Summary$ToggleMinimumEnrollmentPeriodInMonths)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Remove')
												]))
										]))
								])),
							function () {
							var _v1 = $author$project$Api$Provider$Membership$One$minimumEnrollmentStartDate(pendingMembership);
							if (!_v1.$) {
								var minimumEnrollmentStartDate = _v1.a;
								return A2(
									$author$project$Ui$Grid$row,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$span(12)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$p,
													_List_fromArray(
														[$author$project$Ui$Typography$helpBlock]),
													_List_fromArray(
														[
															$elm$html$Html$text('Cannot cancel between '),
															$elm$html$Html$text(
															A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, minimumEnrollmentStartDate)),
															$elm$html$Html$text(' and '),
															$elm$html$Html$text(
															A2(
																$elm$core$Maybe$withDefault,
																'',
																A2(
																	$elm$core$Maybe$map,
																	$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
																	$author$project$Api$Provider$Membership$One$minimumEnrollmentEndDate(pendingMembership))))
														]))
												]))
										]));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						]))
				]));
	});
var $author$project$Components$Membership$Form$Sections$Summary$EditNextBillDate = {$: 3};
var $author$project$Components$Membership$Form$Sections$Summary$SetBillDate = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Membership$Meta$billDateValues = function (_v0) {
	var meta = _v0;
	return meta.xB.q_;
};
var $author$project$Components$Membership$Form$Sections$Summary$nextBillDateOptions = function (membership) {
	var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
	var minBillDate = $author$project$Api$Provider$Membership$Meta$billDateMin(membershipMeta);
	return $author$project$Ui$Form$Select$dateOptions(
		A2(
			$elm$core$List$filter,
			function (date) {
				return !(!A2($justinmimbs$date$Date$compare, date, minBillDate));
			},
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$author$project$Api$Provider$Membership$Meta$billDateValues(
					$author$project$Api$Provider$Membership$One$meta(membership)))));
};
var $author$project$Components$Membership$Form$Sections$Summary$viewNextBillDateInput = F5(
	function (currentDate, membership, pendingMembership, form, model) {
		var pendingMembershipMeta = $author$project$Api$Provider$Membership$One$meta(pendingMembership);
		var _v0 = $author$project$Utils$Form$fields(form);
		var nextBillDate = _v0.XP;
		var setBillDate = _v0.ff;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Next Bill Due'),
					$author$project$Ui$Form$Group$required(model.p0.XP)
				]),
			_List_fromArray(
				[
					model.p0.XP ? A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							(setBillDate && $author$project$Api$Provider$Membership$One$isSponsored(membership)) ? A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(
									A2($elm$core$Maybe$map, $justinmimbs$date$Date$toIsoString, nextBillDate)),
									$author$project$Ui$Form$Select$onChange(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Components$Membership$Form$Sections$Summary$FormUpdated,
										A2(
											$elm$core$Basics$composeL,
											A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Sections$Summary$NextBillDate, $elm$core$Result$toMaybe),
											$justinmimbs$date$Date$fromIsoString))),
									$author$project$Ui$Form$Select$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 3, form)),
									$author$project$Ui$Form$Select$errors(
									A2($author$project$Utils$Form$validationErrors, 3, form))
								]),
							$author$project$Components$Membership$Form$Sections$Summary$nextBillDateOptions(membership)) : A2(
							$elm$html$Html$map,
							$author$project$Components$Membership$Form$Sections$Summary$NextBillDateInputMsg,
							A2(
								$author$project$Components$DateInput$view,
								_List_fromArray(
									[
										$author$project$Components$DateInput$value(nextBillDate),
										$author$project$Components$DateInput$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 3, form)),
										$author$project$Components$DateInput$errors(
										A2($author$project$Utils$Form$validationErrors, 3, form))
									]),
								model.tj)),
							($author$project$Api$Provider$Membership$Meta$billDateEditable(pendingMembershipMeta) && $author$project$Api$Provider$Membership$Meta$nextBillDateEditable(pendingMembershipMeta)) ? A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Radio$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Radio$value(setBillDate),
											$author$project$Ui$Form$Radio$onCheck(
											A2(
												$elm$core$Basics$composeL,
												$author$project$Components$Membership$Form$Sections$Summary$FormUpdated,
												$elm$core$Basics$always(
													$author$project$Components$Membership$Form$Sections$Summary$SetBillDate(true)))),
											$author$project$Ui$Form$Radio$disabled(
											!A2($author$project$Utils$Form$hasValidationErrors, 3, form))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('All future bills')
										])),
									A2(
									$author$project$Ui$Form$Radio$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Radio$value(!setBillDate),
											$author$project$Ui$Form$Radio$onCheck(
											A2(
												$elm$core$Basics$composeL,
												$author$project$Components$Membership$Form$Sections$Summary$FormUpdated,
												$elm$core$Basics$always(
													$author$project$Components$Membership$Form$Sections$Summary$SetBillDate(false)))),
											$author$project$Ui$Form$Radio$disabled(
											!A2($author$project$Utils$Form$hasValidationErrors, 3, form))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Only next bill')
										]))
								])) : $author$project$Utils$Html$empty
						])) : A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									_List_fromArray(
										[
											function () {
											var _v1 = _Utils_Tuple3(
												$author$project$Api$Provider$Membership$One$billDate(pendingMembership),
												$author$project$Api$Provider$Membership$One$nextBillDate(pendingMembership),
												nextBillDate);
											_v1$3:
											while (true) {
												if (_v1.a.$ === 1) {
													if (_v1.b.$ === 1) {
														var _v2 = _v1.a;
														var _v3 = _v1.b;
														return $elm$html$Html$text('Never');
													} else {
														break _v1$3;
													}
												} else {
													if (!_v1.c.$) {
														var nextBillDate_ = _v1.c.a;
														return $elm$html$Html$text(
															A2(
																$author$project$Formatters$Date$toString,
																A2($author$project$Formatters$Date$Relative, currentDate, $elm$core$Maybe$Nothing),
																nextBillDate_));
													} else {
														if (!_v1.b.$) {
															var nextBillDate_ = _v1.b.a;
															var _v4 = _v1.c;
															return $elm$html$Html$text(
																A2(
																	$author$project$Formatters$Date$toString,
																	A2($author$project$Formatters$Date$Relative, currentDate, $elm$core$Maybe$Nothing),
																	nextBillDate_));
														} else {
															break _v1$3;
														}
													}
												}
											}
											return $author$project$Utils$Html$empty;
										}()
										]))
								])),
							($author$project$Api$Provider$Membership$Meta$billDateEditable(pendingMembershipMeta) || $author$project$Api$Provider$Membership$Meta$nextBillDateEditable(pendingMembershipMeta)) ? A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$flex, $author$project$Ui$Element$justifyRight]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{mm: 'Change billing date'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$Summary$EditNextBillDate)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Change Billing Date')
												]))
										]))
								])) : $author$project$Ui$Grid$none
						]))
				]));
	});
var $author$project$Components$Membership$Form$Sections$Summary$EditOwner = {$: 0};
var $author$project$Components$Membership$Form$Sections$Summary$viewOwnerInput = F4(
	function (membership, pendingMembership, form, model) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$required(model.p0.YD),
					$author$project$Ui$Form$Group$label('Payer')
				]),
			function () {
				if (model.p0.YD) {
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Components$Membership$Form$Sections$Summary$PatientResourceFilterMsg,
							A2(
								$author$project$Components$ResourceFilter$Patient$view,
								_List_fromArray(
									[
										$author$project$Components$ResourceFilter$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
										$author$project$Components$ResourceFilter$errors(
										A2($author$project$Utils$Form$validationErrors, 0, form))
									]),
								model.oY))
						]);
				} else {
					var meta = $author$project$Api$Provider$Membership$One$meta(membership);
					return _List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_fromArray(
								[$author$project$Ui$Form$Static$flex, $author$project$Ui$Form$Static$spaceBetween, $author$project$Ui$Form$Static$itemsCenter]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[
											$author$project$Ui$Typography$phi(true)
										]),
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											$author$project$Api$Provider$Patient$Shared$name,
											$author$project$Api$Provider$Membership$One$owner(pendingMembership)))),
									$author$project$Api$Provider$Membership$Meta$ownerEditable(meta) ? A3(
									$author$project$Ui$Button$view,
									{mm: 'Change payer'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$Summary$EditOwner)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Change Payer')
										])) : $author$project$Utils$Html$empty
								]))
						]);
				}
			}());
	});
var $author$project$Api$Provider$MembershipBill$ForMembershipPrepayOptions$periodInMonths = function (_v0) {
	var record = _v0;
	return record.Zs;
};
var $author$project$Api$Provider$Membership$One$prepayOptions = function (_v0) {
	var record = _v0.b;
	return record._d;
};
var $author$project$Components$Membership$Form$Sections$Summary$periodInMonthsOptions = function (pendingMembership) {
	return A2(
		$elm$core$List$map,
		function (membershipBill) {
			var periodInMonths = $author$project$Api$Provider$MembershipBill$ForMembershipPrepayOptions$periodInMonths(membershipBill);
			return A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				A2($elm$core$Maybe$map, $elm$core$String$fromInt, periodInMonths),
				A2(
					$elm$core$Maybe$withDefault,
					'N/A',
					A2($elm$core$Maybe$map, $author$project$Formatters$Int$asPeriod, periodInMonths)));
		},
		$author$project$Api$Provider$Membership$One$prepayOptions(pendingMembership));
};
var $author$project$Components$Membership$Form$Sections$Summary$viewPeriodInMonthsInput = F3(
	function (membership, pendingMembership, _v0) {
		var periodInMonths = _v0.Zs;
		var pendingMembershipMeta = $author$project$Api$Provider$Membership$One$meta(pendingMembership);
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Billed')
				]),
			_List_fromArray(
				[
					$author$project$Api$Provider$Membership$One$billsAtEndOfPeriod(pendingMembership) ? A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('At end of monthly billing period')
						])) : ($author$project$Api$Provider$Membership$Meta$periodInMonthsEditable(pendingMembershipMeta) ? A2(
					$author$project$Ui$Form$Select$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Select$value(
							$elm$core$Maybe$Just(
								$elm$core$String$fromInt(periodInMonths))),
							$author$project$Ui$Form$Select$onChange(
							A2(
								$elm$core$Basics$composeL,
								$author$project$Components$Membership$Form$Sections$Summary$FormUpdated,
								function (string) {
									return $author$project$Components$Membership$Form$Sections$Summary$PeriodInMonths(
										A2(
											$elm$core$Maybe$withDefault,
											1,
											$elm$core$String$toInt(string)));
								}))
						]),
					$author$project$Components$Membership$Form$Sections$Summary$periodInMonthsOptions(pendingMembership)) : $author$project$Utils$Html$empty),
					((!$author$project$Api$Provider$Membership$One$billsAtEndOfPeriod(membership)) && (!$author$project$Api$Provider$Membership$Meta$periodInMonthsEditable(pendingMembershipMeta))) ? A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Formatters$Int$asPeriodHuman(
								$author$project$Api$Provider$Membership$One$periodInMonths(pendingMembership)))
						])) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$Membership$Form$Sections$Summary$EditPlan = {$: 1};
var $author$project$Components$Membership$Form$Sections$Summary$viewPlanInput = F4(
	function (membership, pendingMembership, form, model) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$required(model.p0.Jb),
					$author$project$Ui$Form$Group$label('Plan')
				]),
			function () {
				if (model.p0.Jb) {
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Components$Membership$Form$Sections$Summary$PlanResourceFilterMsg,
							A2(
								$author$project$Components$ResourceFilter$Plan$view,
								_List_fromArray(
									[
										$author$project$Components$ResourceFilter$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
										$author$project$Components$ResourceFilter$errors(
										A2($author$project$Utils$Form$validationErrors, 1, form))
									]),
								model.hi))
						]);
				} else {
					var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
					return _List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_fromArray(
								[$author$project$Ui$Form$Static$flex, $author$project$Ui$Form$Static$spaceBetween, $author$project$Ui$Form$Static$itemsCenter]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$Plan$SharedWithContractInfo$name(
										$author$project$Api$Provider$Membership$One$plan(pendingMembership))),
									$author$project$Api$Provider$Membership$Meta$planEditable(membershipMeta) ? A3(
									$author$project$Ui$Button$view,
									{mm: 'Change plan'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$Summary$EditPlan)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Change Plan')
										])) : $author$project$Utils$Html$empty
								]))
						]);
				}
			}());
	});
var $author$project$Components$Membership$Form$Sections$Summary$EditStartDate = {$: 2};
var $author$project$Components$Membership$Form$Sections$Summary$startDateOptions = function (membership) {
	return $author$project$Ui$Form$Select$dateOptions(
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			$author$project$Api$Provider$Membership$Meta$billDateValues(
				$author$project$Api$Provider$Membership$One$meta(membership))));
};
var $author$project$Components$Membership$Form$Sections$Summary$viewStartDateInput = F5(
	function (currentDate, membership, pendingMembership, form, model) {
		var _v0 = $author$project$Utils$Form$fields(form);
		var startDate = _v0.ab7;
		var futureEligibilityDate = _v0.HU;
		var manuallySet = _v0.cK;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label(
					A2(
						$author$project$Components$Membership$Form$Sections$Summary$isMembershipStatus,
						_List_fromArray(
							['pending', 'unconfirmed']),
						membership) ? 'Starting' : 'Start Date'),
					$author$project$Ui$Form$Group$required(manuallySet.ab7)
				]),
			_List_fromArray(
				[
					function () {
					if (manuallySet.ab7) {
						return A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Api$Provider$Membership$One$isSponsored(membership) ? A2(
									$author$project$Ui$Form$Select$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Select$value(
											A2($elm$core$Maybe$map, $justinmimbs$date$Date$toIsoString, startDate)),
											$author$project$Ui$Form$Select$onChange(
											A2(
												$elm$core$Basics$composeL,
												$author$project$Components$Membership$Form$Sections$Summary$FormUpdated,
												A2(
													$elm$core$Basics$composeL,
													A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Sections$Summary$StartDate, $elm$core$Result$toMaybe),
													$justinmimbs$date$Date$fromIsoString))),
											$author$project$Ui$Form$Select$invalid(
											A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
											$author$project$Ui$Form$Select$errors(
											A2($author$project$Utils$Form$validationErrors, 2, form))
										]),
									$author$project$Components$Membership$Form$Sections$Summary$startDateOptions(membership)) : A2(
									$elm$html$Html$map,
									$author$project$Components$Membership$Form$Sections$Summary$StartDateInputMsg,
									A2(
										$author$project$Components$DateInput$view,
										_List_fromArray(
											[
												$author$project$Components$DateInput$value(startDate),
												$author$project$Components$DateInput$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
												$author$project$Components$DateInput$errors(
												A2($author$project$Utils$Form$validationErrors, 2, form))
											]),
										model.lx)),
									function () {
									if (!futureEligibilityDate.$) {
										var futureEligibilityDate_ = futureEligibilityDate.a;
										return A2(
											$author$project$Ui$Alert$warning,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$text,
													_List_fromArray(
														[
															$author$project$Ui$Typography$phi(true)
														]),
													A2(
														$elm$core$Maybe$withDefault,
														'',
														A2(
															$elm$core$Maybe$map,
															$author$project$Api$Provider$Patient$Shared$name,
															$author$project$Api$Provider$Membership$One$owner(membership)))),
													$elm$html$Html$text(' is not eligible for coverage under '),
													$elm$html$Html$text(
													A2(
														$elm$core$Maybe$withDefault,
														'',
														A2(
															$elm$core$Maybe$map,
															$author$project$Api$Provider$Company$Shared$name,
															$author$project$Api$Provider$Membership$One$company(membership)))),
													$elm$html$Html$text('\'s plan until '),
													$elm$html$Html$text(
													A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, futureEligibilityDate_))
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								]));
					} else {
						var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
						return A2(
							$author$project$Ui$Grid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(6)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2(
														$author$project$Formatters$Date$toString,
														A2($author$project$Formatters$Date$Relative, currentDate, $elm$core$Maybe$Nothing),
														$author$project$Api$Provider$Membership$One$startDate(pendingMembership)))
												]))
										])),
									$author$project$Api$Provider$Membership$Meta$startDateEditable(membershipMeta) ? A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(6)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$flex, $author$project$Ui$Element$justifyRight]),
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Button$view,
													{mm: 'Change start date'},
													_List_fromArray(
														[
															$author$project$Ui$Button$link,
															$author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$Summary$EditStartDate)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Change Start Date')
														]))
												]))
										])) : $author$project$Ui$Grid$none
								]));
					}
				}()
				]));
	});
var $author$project$Components$Membership$Form$Sections$Summary$viewStatus = function (membership) {
	var status = $author$project$Api$Provider$Membership$One$status(membership);
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9),
				$author$project$Ui$Form$Group$label('Status')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$Ui$Badge$fromString, _List_Nil, status),
						function () {
						var _v0 = _Utils_Tuple2(
							status === 'active',
							$author$project$Api$Provider$Membership$One$endDate(membership));
						if (_v0.a && (!_v0.b.$)) {
							var endDate = _v0.b.a;
							return A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$text,
										_List_fromArray(
											[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
										' until '),
										A2(
										$author$project$Ui$Typography$text,
										_List_fromArray(
											[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
										A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, endDate))
									]));
						} else {
							return $author$project$Utils$Html$empty;
						}
					}()
					]))
			]));
};
var $author$project$Components$Membership$Form$Sections$Summary$view = F2(
	function (_v0, _v1) {
		var membership = _v0.kk;
		var pendingMembership = _v0.dC;
		var isNew = _v0.j1;
		var model = _v1;
		var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
		var fields = $author$project$Utils$Form$fields(model.SD);
		var autoRenewEditable = A2($author$project$Api$Provider$Practice$One$featureEnabled, 5, model.ZV);
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$itemsCenter]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('Summary')
								])),
							isNew ? $author$project$Utils$Html$empty : A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$ml2]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Components$Membership$Form$Sections$Summary$AuditTrailLogMsg,
									$author$project$Components$AuditTrailLog$view(model.iw))
								]))
						])),
					A4($author$project$Components$Membership$Form$Sections$Summary$viewOwnerInput, membership, pendingMembership, model.SD, model),
					A4($author$project$Components$Membership$Form$Sections$Summary$viewPlanInput, membership, pendingMembership, model.SD, model),
					(!isNew) ? $author$project$Components$Membership$Form$Sections$Summary$viewStatus(membership) : $author$project$Utils$Html$empty,
					A5($author$project$Components$Membership$Form$Sections$Summary$viewStartDateInput, model.dd, membership, pendingMembership, model.SD, model),
					((!A2(
					$author$project$Components$Membership$Form$Sections$Summary$isMembershipStatus,
					_List_fromArray(
						['unconfirmed']),
					membership)) && (A2(
					$author$project$Components$Membership$Form$Sections$Summary$isMembershipStatus,
					_List_fromArray(
						['active', 'unpaid']),
					membership) || ($author$project$Api$Provider$Membership$Meta$billDateEditable(membershipMeta) || $author$project$Api$Provider$Membership$Meta$nextBillDateEditable(membershipMeta)))) ? A5($author$project$Components$Membership$Form$Sections$Summary$viewNextBillDateInput, model.dd, membership, pendingMembership, model.SD, model) : $author$project$Utils$Html$empty,
					($author$project$Api$Provider$Membership$One$isRestartable(membership) || $author$project$Utils$Maybe$toBool(
					$author$project$Api$Provider$Membership$One$endDate(pendingMembership))) ? A2($author$project$Components$Membership$Form$Sections$Summary$viewEndDate, membership, model) : $author$project$Utils$Html$empty,
					$author$project$Utils$Maybe$toBool(
					$author$project$Api$Provider$Membership$One$company(pendingMembership)) ? $author$project$Components$Membership$Form$Sections$Summary$viewMembershipType(model) : $author$project$Utils$Html$empty,
					function () {
					var _v2 = $author$project$Api$Provider$Membership$One$company(pendingMembership);
					if (!_v2.$) {
						var company = _v2.a;
						return A2($author$project$Components$Membership$Form$Sections$Summary$viewCompanyName, company, model);
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					A3($author$project$Components$Membership$Form$Sections$Summary$viewPeriodInMonthsInput, membership, pendingMembership, fields),
					$author$project$Api$Provider$Membership$Meta$minimumEnrollmentPeriodInMonthsEditable(membershipMeta) ? A3($author$project$Components$Membership$Form$Sections$Summary$viewMinimumEnrollmentPeriodInMonthsInput, pendingMembership, fields, model) : $author$project$Utils$Html$empty,
					autoRenewEditable ? A2($author$project$Components$Membership$Form$Sections$Summary$viewAutoRenewInput, membership, fields) : $author$project$Utils$Html$empty,
					($author$project$Api$Provider$Practice$One$anyRetailBrokers(model.ZV) && ((!$author$project$Api$Provider$Membership$One$isSponsored(membership)) && (!A2(
					$author$project$Permission$disallowForRoles,
					model.aa4,
					_List_fromArray(
						['practice_staff_limited']))))) ? A3($author$project$Components$Membership$Form$Sections$Summary$viewBrokerInput, model.j1, membership, model) : $author$project$Utils$Html$empty,
					function () {
					var _v3 = $author$project$Api$Provider$Membership$One$cancellationReason(membership);
					if (!_v3.$) {
						var cancellationReason = _v3.a;
						return A2($author$project$Components$Membership$Form$Sections$Summary$viewCancellationReason, membership, cancellationReason);
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]));
	});
var $author$project$Components$Membership$Form$viewForm = F4(
	function (membership, pendingMembership, sections, model) {
		var shared = A5($author$project$Components$Membership$Form$initSectionsShared, model.YY, membership, pendingMembership, sections, model);
		var _v0 = sections;
		var summary = _v0.acF;
		var members = _v0.N;
		var pricing = _v0._i;
		var contracts = _v0.a4;
		var recurringCharges = _v0.$h;
		var planChange = _v0.kG;
		var billsOverview = _v0.rv;
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Membership$Form$SummaryMsg,
				A2($author$project$Components$Membership$Form$Sections$Summary$view, shared, summary)),
				A2(
				$elm$html$Html$map,
				$author$project$Components$Membership$Form$MembersMsg,
				A3($author$project$Components$Membership$Form$Sections$Members$view, shared, model.afq, members)),
				A2(
				$elm$html$Html$map,
				$author$project$Components$Membership$Form$PricingMsg,
				A2($author$project$Components$Membership$Form$Sections$Pricing$view, shared, pricing)),
				A2(
				$elm$html$Html$map,
				$author$project$Components$Membership$Form$ContractsMsg,
				A2($author$project$Components$Membership$Form$Sections$Contracts$view, shared, contracts)),
				A2(
				$elm$html$Html$map,
				$author$project$Components$Membership$Form$RecurringChargesMsg,
				A2($author$project$Components$Membership$Form$Sections$RecurringCharges$view, shared, recurringCharges)),
				function () {
				if (!planChange.$) {
					var planChange_ = planChange.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$Membership$Form$PlanChangeMsg,
						A3(
							$author$project$Components$Membership$Form$Sections$PlanChange$view,
							shared,
							$author$project$Components$Membership$Form$Sections$Contracts$contractFields(contracts),
							planChange_));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$elm$html$Html$map,
				$author$project$Components$Membership$Form$BillsOverviewMsg,
				A2($author$project$Components$Membership$Form$Sections$BillsOverview$view, shared, billsOverview))
			]);
	});
var $author$project$Components$Membership$Form$viewNewButtons = F3(
	function (membership, pendingMembership, model) {
		var startDate = $author$project$Api$Provider$Membership$One$startDate(pendingMembership);
		return _List_fromArray(
			[
				function () {
				if (A2($author$project$Utils$Date$isAfter, startDate, model.dd) || $author$project$Api$Provider$Membership$One$isSponsored(pendingMembership)) {
					return $author$project$Utils$Html$empty;
				} else {
					var dueAmountInCents = A3(
						$elm$core$List$foldl,
						F2(
							function (membershipBill, acc) {
								return $author$project$Api$Provider$MembershipBill$ForMembershipOne$amountInCents(membershipBill) + acc;
							}),
						0,
						A2(
							$elm$core$List$filter,
							function (membershipBill) {
								return A2(
									$justinmimbs$date$Date$compare,
									$author$project$Api$Provider$MembershipBill$ForMembershipOne$date(membershipBill),
									model.dd) !== 2;
							},
							$author$project$Api$Provider$Membership$One$upcomingAndOutstandingBills(pendingMembership)));
					var label = A2(
						$elm$core$String$join,
						' ',
						_List_fromArray(
							[
								'Create membership and',
								A2(
								$elm$core$Maybe$withDefault,
								false,
								A2(
									$elm$core$Maybe$map,
									$author$project$Api$Provider$Patient$Shared$autopay,
									$author$project$Api$Provider$Membership$One$owner(membership))) ? 'Bill' : 'Invoice',
								$author$project$Utils$Currency$fromInt(dueAmountInCents),
								'Now'
							]));
					return A3(
						$author$project$Ui$Button$view,
						{mm: label},
						_List_fromArray(
							[
								$author$project$Ui$Button$styled(0),
								$author$project$Ui$Button$loading(
								$author$project$Components$Membership$Form$isBusy(model)),
								$author$project$Ui$Button$onClick(
								$author$project$Components$Membership$Form$Save(true))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(label)
							]));
				}
			}(),
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Create membership'},
				_List_fromArray(
					[
						$author$project$Ui$Button$primary,
						$author$project$Ui$Button$loading(
						$author$project$Components$Membership$Form$isBusy(model)),
						$author$project$Ui$Button$onClick(
						$author$project$Components$Membership$Form$Save(false))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Create')
					]))
			]);
	});
var $author$project$Components$Membership$Form$view = function (model) {
	return _List_fromArray(
		[
			$author$project$Components$Membership$Form$modal(model),
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$noValidate(true),
									$author$project$Ui$Form$autocomplete(false)
								]),
							function () {
								var _v0 = _Utils_Tuple3(model.kk, model.dC, model.m);
								if (((!_v0.a.$) && (!_v0.b.$)) && (!_v0.c.$)) {
									var membership = _v0.a.a;
									var pendingMembership = _v0.b.a;
									var sections = _v0.c.a;
									return A4($author$project$Components$Membership$Form$viewForm, membership, pendingMembership, sections, model);
								} else {
									return _List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$textCenter]),
											_List_fromArray(
												[
													$author$project$Ui$Spinner$view(_List_Nil)
												]))
										]);
								}
							}())
						])),
					A2(
					$author$project$Ui$Panel$footer,
					_List_fromArray(
						[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
					A2(
						$elm$core$List$cons,
						A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__Top(
								{
									YZ: $author$project$Api$Provider$Patient$One$id(model.YY)
								}),
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
						function () {
							var _v1 = _Utils_Tuple3(model.kk, model.dC, model.m);
							if (((!_v1.a.$) && (!_v1.b.$)) && (!_v1.c.$)) {
								var membership = _v1.a.a;
								var pendingMembership = _v1.b.a;
								var sections = _v1.c.a;
								if (model.j1) {
									return A3($author$project$Components$Membership$Form$viewNewButtons, membership, pendingMembership, model);
								} else {
									var summaryDirty = $author$project$Components$Membership$Form$Sections$Summary$dirty(sections.acF);
									var recurringChargesDirty = $author$project$Components$Membership$Form$Sections$RecurringCharges$dirty(sections.$h);
									var pricingDirty = $author$project$Components$Membership$Form$Sections$Pricing$dirty(sections._i);
									var membersDirty = $author$project$Components$Membership$Form$Sections$Members$dirty(sections.N);
									var contractsDirty = $author$project$Components$Membership$Form$Sections$Contracts$dirty(sections.a4);
									var dirty = summaryDirty || (membersDirty || (pricingDirty || (recurringChargesDirty || contractsDirty)));
									return A3($author$project$Components$Membership$Form$viewEditButtons, dirty, membership, model);
								}
							} else {
								return _List_fromArray(
									[$author$project$Utils$Html$empty]);
							}
						}()))
				]))
		]);
};
var $author$project$Pages$Patients$PatientId_String$Memberships$MembershipId_String$Top$view = function (model) {
	return {
		fO: $author$project$Components$Membership$Form$view(model.SD),
		ac9: 'Patient | Memberships'
	};
};
var $author$project$Pages$Patients$PatientId_String$Memberships$MembershipId_String$Top$page = $author$project$Spa$Page$applicationPatient(
	{ah_: $author$project$Pages$Patients$PatientId_String$Memberships$MembershipId_String$Top$init, aiq: $author$project$Pages$Patients$PatientId_String$Memberships$MembershipId_String$Top$load, k8: $author$project$Pages$Patients$PatientId_String$Memberships$MembershipId_String$Top$save, alO: $author$project$Pages$Patients$PatientId_String$Memberships$MembershipId_String$Top$subscriptions, adT: $author$project$Pages$Patients$PatientId_String$Memberships$MembershipId_String$Top$update, amo: $author$project$Pages$Patients$PatientId_String$Memberships$MembershipId_String$Top$view});
var $author$project$Pages$Patients$PatientId_String$Memberships$New$init = F5(
	function (session, practice, patient, _v0, _v1) {
		var apiClient = _v0.Gv;
		var timeZone = _v0.J8;
		var currentDate = _v0.dd;
		var hinterViewOff = _v0.ahK;
		var currentTime = _v0.af3;
		var url = _v0.adY;
		var query = _v1.DE;
		var _v2 = $author$project$Components$Membership$Form$init(apiClient)(timeZone)(currentDate)(session)(practice)(hinterViewOff)(query)(patient)($elm$core$Maybe$Nothing)(currentTime)(url);
		var form = _v2.a;
		var cmd = _v2.b;
		return _Utils_Tuple2(
			{Gv: apiClient, SD: form},
			cmd);
	});
var $author$project$Pages$Patients$PatientId_String$Memberships$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Patients$PatientId_String$Memberships$New$save = F2(
	function (_v0, shared) {
		var form = _v0.SD;
		return A2($author$project$Components$Membership$Form$save, form, shared);
	});
var $author$project$Pages$Patients$PatientId_String$Memberships$New$subscriptions = function (model) {
	return $author$project$Components$Membership$Form$subscriptions(model.SD);
};
var $author$project$Pages$Patients$PatientId_String$Memberships$New$update = F2(
	function (msg, model) {
		var _v0 = A3($author$project$Components$Membership$Form$update, model.Gv, msg, model.SD);
		var form = _v0.a;
		var cmd = _v0.b;
		var outMsgs = _v0.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{SD: form}),
			cmd,
			outMsgs);
	});
var $author$project$Pages$Patients$PatientId_String$Memberships$New$view = function (model) {
	return {
		fO: $author$project$Components$Membership$Form$view(model.SD),
		ac9: 'Patient | Memberships'
	};
};
var $author$project$Pages$Patients$PatientId_String$Memberships$New$page = $author$project$Spa$Page$applicationPatient(
	{ah_: $author$project$Pages$Patients$PatientId_String$Memberships$New$init, aiq: $author$project$Pages$Patients$PatientId_String$Memberships$New$load, k8: $author$project$Pages$Patients$PatientId_String$Memberships$New$save, alO: $author$project$Pages$Patients$PatientId_String$Memberships$New$subscriptions, adT: $author$project$Pages$Patients$PatientId_String$Memberships$New$update, amo: $author$project$Pages$Patients$PatientId_String$Memberships$New$view});
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$GotMemberships = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Membership$All$Membership = $elm$core$Basics$identity;
var $author$project$Api$Provider$Membership$All$Record = F9(
	function (id, startDate, nextBillDate, status, plan, periodRateInCents, periodInMonths, state, isPrimary) {
		return {ahP: id, aie: isPrimary, XP: nextBillDate, Zs: periodInMonths, Zt: periodRateInCents, Jb: plan, ab7: startDate, uP: state, alH: status};
	});
var $author$project$Api$Provider$Membership$All$EndingOrEnded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$Membership$All$Renewing = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Membership$All$Started = {$: 1};
var $author$project$Api$Provider$Membership$All$Starting = {$: 0};
var $author$project$Api$Provider$Membership$All$Terminating = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Membership$All$decodeMembershipState = A2(
	$elm$json$Json$Decode$andThen,
	function (_v0) {
		var isCurrent = _v0.a;
		var endDate = _v0.b;
		var contractExpires = _v0.c;
		var _v1 = _Utils_Tuple3(isCurrent, endDate, contractExpires);
		_v1$3:
		while (true) {
			if (!_v1.a) {
				if (_v1.b.$ === 1) {
					var _v2 = _v1.b;
					return $elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$All$Starting);
				} else {
					break _v1$3;
				}
			} else {
				if (_v1.b.$ === 1) {
					var _v3 = _v1.b;
					return $elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$All$Started);
				} else {
					if (_v1.c) {
						return A3(
							$elm$json$Json$Decode$map2,
							F2(
								function (type_, contractEndDate) {
									return (type_ === 'terminating') ? $author$project$Api$Provider$Membership$All$Terminating(contractEndDate) : $author$project$Api$Provider$Membership$All$Renewing(contractEndDate);
								}),
							A2($elm$json$Json$Decode$field, 'contract_type', $elm$json$Json$Decode$string),
							A2(
								$elm$json$Json$Decode$field,
								'contract_end_date',
								$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode)));
					} else {
						break _v1$3;
					}
				}
			}
		}
		return A2(
			$elm$json$Json$Decode$map,
			$author$project$Api$Provider$Membership$All$EndingOrEnded,
			A2($elm$json$Json$Decode$field, 'end_date', $author$project$Utils$Date$decode));
	},
	A4(
		$elm$json$Json$Decode$map3,
		F3(
			function (isCurrent, endDate, contractExpires) {
				return _Utils_Tuple3(isCurrent, endDate, contractExpires);
			}),
		A2($elm$json$Json$Decode$field, 'is_current', $elm$json$Json$Decode$bool),
		A2(
			$elm$json$Json$Decode$field,
			'end_date',
			$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode)),
		A2($elm$json$Json$Decode$field, 'contract_expires', $elm$json$Json$Decode$bool)));
var $author$project$Api$Provider$Membership$All$Other = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Membership$All$Unconfirmed = {$: 0};
var $author$project$Api$Provider$Membership$All$membershipStatusFromString = function (stringStatus) {
	if (stringStatus === 'unconfirmed') {
		return $author$project$Api$Provider$Membership$All$Unconfirmed;
	} else {
		return $author$project$Api$Provider$Membership$All$Other(stringStatus);
	}
};
var $author$project$Api$Provider$Membership$All$decoder = $elm$json$Json$Decode$list(
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Basics$identity,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'is_primary',
			$elm$json$Json$Decode$bool,
			false,
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				$author$project$Api$Provider$Membership$All$decodeMembershipState,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'period_in_months',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'period_rate_in_cents',
						$author$project$Currency$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'plan',
							$author$project$Api$Provider$Plan$Min$decoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'status',
								A2($elm$json$Json$Decode$map, $author$project$Api$Provider$Membership$All$membershipStatusFromString, $elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'next_bill_date',
									$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'start_date',
										$author$project$Utils$Date$decode,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'id',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$All$Record))))))))))));
var $author$project$Api$Provider$Membership$listDefaults = {ajJ: $author$project$Api$Pagination$init};
var $author$project$Api$Provider$Membership$list = F4(
	function (apiClient, ownerId, optionals, toMsg) {
		var options = optionals($author$project$Api$Provider$Membership$listDefaults);
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Membership$All$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				A2(
					$elm$core$List$cons,
					A2($author$project$Api$Param$string, 'owner', ownerId),
					$author$project$Api$Pagination$toApiParams(options.ajJ)),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Membership$membershipsPath)));
	});
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$fetchMemberships = function (model) {
	return A4(
		$author$project$Api$Provider$Membership$list,
		model.Gv,
		$author$project$Api$Provider$Patient$One$id(model.YY),
		function (opts) {
			return _Utils_update(
				opts,
				{ajJ: model.ajJ});
		},
		$author$project$Pages$Patients$PatientId_String$Memberships$Top$GotMemberships);
};
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$GotPackages = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$PatientPackage$All$PatientPackage = $elm$core$Basics$identity;
var $author$project$Api$Provider$PatientPackage$All$PatientPackageRecord = F8(
	function (id, packageName, priceInCents, purchasedOn, endedAt, expiresAt, status, prepaidCharges) {
		return {agU: endedAt, R_: expiresAt, ahP: id, YG: packageName, _b: prepaidCharges, Dw: priceInCents, _L: purchasedOn, alH: status};
	});
var $author$project$Api$Provider$PatientPackage$All$PrepaidCharge = $elm$core$Basics$identity;
var $author$project$Api$Provider$PatientPackage$All$PrepaidChargeRecord = F6(
	function (id, originalQuantity, remainingQuantity, priceInCents, chargeItem, consumptionEvents) {
		return {mL: chargeItem, Ou: consumptionEvents, ahP: id, Yw: originalQuantity, Dw: priceInCents, $t: remainingQuantity};
	});
var $author$project$Api$Provider$PatientPackage$All$ConsumptionEvent = $elm$core$Basics$identity;
var $author$project$Api$Provider$PatientPackage$All$ConsumptionEventRecord = F4(
	function (occurredAt, quantity, chargeItemName, invoiceId) {
		return {afB: chargeItemName, Us: invoiceId, X8: occurredAt, Dz: quantity};
	});
var $author$project$Api$Provider$PatientPackage$All$consumptionEventDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'invoice_id',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'charge_item_name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'quantity',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'occurred_at',
					$author$project$Utils$Date$decode,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$PatientPackage$All$ConsumptionEventRecord))))));
var $author$project$Api$Provider$PatientPackage$All$prepaidChargeDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'consumption_events',
		$elm$json$Json$Decode$list($author$project$Api$Provider$PatientPackage$All$consumptionEventDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'charge_item',
			$author$project$Api$Provider$ChargeItem$Min$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'price_in_cents',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'remaining_quantity',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'original_quantity',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Api$Provider$PatientPackage$All$PrepaidChargeRecord))))))));
var $author$project$Api$Provider$PatientPackage$All$Active = 0;
var $author$project$Api$Provider$PatientPackage$All$Ended = 1;
var $author$project$Api$Provider$PatientPackage$All$Inactive = 2;
var $author$project$Api$Provider$PatientPackage$All$statusDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'active':
				return $elm$json$Json$Decode$succeed(0);
			case 'ended':
				return $elm$json$Json$Decode$succeed(1);
			case 'inactive':
				return $elm$json$Json$Decode$succeed(2);
			default:
				var other = str;
				return $elm$json$Json$Decode$fail('Unknown status: ' + other);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$PatientPackage$All$patientPackageDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'prepaid_charges',
		$elm$json$Json$Decode$list($author$project$Api$Provider$PatientPackage$All$prepaidChargeDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'status',
			$author$project$Api$Provider$PatientPackage$All$statusDecoder,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'expires_at',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Utils$Date$decode),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'ended_at',
					A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Utils$Date$decode),
					$elm$core$Maybe$Nothing,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'purchased_on',
						$author$project$Utils$Date$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'price_in_cents',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'package_name',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'id',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Api$Provider$PatientPackage$All$PatientPackageRecord))))))))));
var $author$project$Api$Provider$PatientPackage$All$listDecoder = $elm$json$Json$Decode$list($author$project$Api$Provider$PatientPackage$All$patientPackageDecoder);
var $author$project$Api$Provider$PatientPackage$All$packagesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['patient_packages']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$PatientPackage$All$list = F3(
	function (client, patientId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			client,
			$author$project$Api$Provider$PatientPackage$All$listDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2($author$project$Api$Param$string, 'patient_id', patientId)
					]),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$PatientPackage$All$packagesPath)));
	});
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$fetchPackages = function (model) {
	return A3(
		$author$project$Api$Provider$PatientPackage$All$list,
		model.Gv,
		$author$project$Api$Provider$Patient$One$id(model.YY),
		$author$project$Pages$Patients$PatientId_String$Memberships$Top$GotPackages);
};
var $author$project$Components$Patient$PackageDetailsModal$init = {dl: $elm$core$Set$empty, Ao: false, YE: $elm$core$Maybe$Nothing, oQ: $elm$core$Maybe$Nothing, YZ: $elm$core$Maybe$Nothing};
var $author$project$Components$PatientsList$urlParams = function (model) {
	var filters = model.h;
	var queryParams = _List_fromArray(
		[
			$elm$core$List$isEmpty(filters.h) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			A2(
				$elm$url$Url$Builder$string,
				'filter',
				A2(
					$elm$core$String$join,
					',',
					A2($elm$core$List$map, $author$project$Api$Provider$Patient$filterToString, filters.h)))),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('patients_q'),
			filters.akl),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('patients_company'),
			filters.fZ),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('patients_plan'),
			filters.aj4),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('patients_location_group'),
			filters.gL),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('patients_location'),
			filters.We),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('patients_practitioner'),
			filters.Z2),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('patients_affiliate'),
			filters.rd)
		]);
	return A2(
		$elm$core$List$append,
		$author$project$Api$Pagination$toPageQuery(model.ajJ),
		A2(
			$elm$core$List$append,
			$author$project$Api$Sort$toQuery(model.alA),
			A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)));
};
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$init = F5(
	function (session, practice, patient, shared, _v0) {
		var query = _v0.DE;
		var model = {
			Gv: shared.Gv,
			kl: $author$project$Api$Data$NotAsked,
			bH: $elm$core$Maybe$Nothing,
			dA: $author$project$Components$Patient$PackageDetailsModal$init,
			Cm: A2(
				$author$project$Utils$FeatureGate$gateAvailable,
				14,
				$author$project$Api$Practice$Provider(practice)) ? $author$project$Api$Data$Loading : $author$project$Api$Data$NotAsked,
			ajJ: $author$project$Api$Pagination$initFromQuery(query),
			YY: patient,
			ZV: practice,
			aa4: session,
			F0: A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Maybe$map, $author$project$Components$PatientsList$urlParams, shared.ajU))
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Pages$Patients$PatientId_String$Memberships$Top$fetchMemberships(model),
						A2(
						$author$project$Utils$FeatureGate$gateAvailable,
						14,
						$author$project$Api$Practice$Provider(practice)) ? $author$project$Pages$Patients$PatientId_String$Memberships$Top$fetchPackages(model) : $elm$core$Platform$Cmd$none
					])));
	});
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$ModalMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$PackageDetailsModalMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Patient$CreateMembershipModal$CloseButtonClicked = {$: 1};
var $author$project$Components$Patient$CreateMembershipModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Patient$CreateMembershipModal$CloseButtonClicked);
};
var $author$project$Components$Patient$PackageDetailsModal$Close = {$: 0};
var $author$project$Components$Patient$PackageDetailsModal$subscriptions = function (model) {
	return model.Ao ? $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Patient$PackageDetailsModal$Close) : $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$subscriptions = function (_v0) {
	var modal = _v0.bH;
	var packageDetailsModal = _v0.dA;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Memberships$Top$ModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Patient$CreateMembershipModal$subscriptions, modal))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Memberships$Top$PackageDetailsModalMsg,
				$author$project$Components$Patient$PackageDetailsModal$subscriptions(packageDetailsModal))
			]));
};
var $author$project$Components$Patient$CreateMembershipModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Patient$CreateMembershipModal$Retail = {$: 0};
var $author$project$Components$Patient$CreateMembershipModal$init = F3(
	function (urlParams, companyAccounts, patient) {
		return {Od: companyAccounts, YY: patient, ut: $author$project$Components$Patient$CreateMembershipModal$Retail, F0: urlParams};
	});
var $author$project$Utils$NonEmpty$NonEmpty = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Utils$NonEmpty$init = $author$project$Utils$NonEmpty$NonEmpty;
var $author$project$Api$Provider$CompanyAccount$ForPatient$isEligible = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyAccount$Shared$isEligible(shared);
};
var $author$project$Components$Patient$PackageDetailsModal$open = F3(
	function (patientId, _package, model) {
		return _Utils_update(
			model,
			{
				dl: $elm$core$Set$empty,
				Ao: true,
				YE: $elm$core$Maybe$Just(_package),
				oQ: $elm$core$Maybe$Nothing,
				YZ: $elm$core$Maybe$Just(patientId)
			});
	});
var $author$project$Components$Patient$PackageDetailsModal$openWithPrice = F4(
	function (patientId, _package, price, model) {
		return _Utils_update(
			model,
			{
				dl: $elm$core$Set$empty,
				Ao: true,
				YE: $elm$core$Maybe$Just(_package),
				oQ: $elm$core$Maybe$Just(price),
				YZ: $elm$core$Maybe$Just(patientId)
			});
	});
var $author$project$Api$Provider$PatientPackage$All$priceInCents = function (_v0) {
	var record = _v0;
	return record.Dw;
};
var $author$project$Components$Patient$CreateMembershipModal$CloseModal = {$: 0};
var $author$project$Components$Patient$CreateMembershipModal$CreationFailed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Patient$CreateMembershipModal$CreationSucceeded = {$: 2};
var $author$project$Api$Provider$CompanyAccount$ForPatient$companyRegistrations = function (_v0) {
	var record = _v0.b;
	return record.Oj;
};
var $author$project$Components$Patient$CreateMembershipModal$Enrolled = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$CompanyAccount$ForPatient$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyAccount$Shared$id(shared);
};
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyRegistration$Shared$id(shared);
};
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$patient = function (_v0) {
	var record = _v0.b;
	return record.YY;
};
var $author$project$Components$Patient$CreateMembershipModal$enrollDependent = F3(
	function (apiClient, companyAccount, patient) {
		var maybeCompanyRegistrationId = A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$id,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (registration) {
						return _Utils_eq(
							$author$project$Api$Provider$Patient$Min$id(
								$author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$patient(registration)),
							$author$project$Api$Provider$Patient$One$id(patient));
					},
					$author$project$Api$Provider$CompanyAccount$ForPatient$companyRegistrations(companyAccount))));
		if (!maybeCompanyRegistrationId.$) {
			var companyRegistrationId = maybeCompanyRegistrationId.a;
			var companyId = $author$project$Api$Provider$Company$Min$id(
				$author$project$Api$Provider$CompanyAccount$ForPatient$company(companyAccount));
			return A6(
				$author$project$Api$Provider$Company$Registration$enroll,
				apiClient,
				companyId,
				$author$project$Api$Provider$CompanyAccount$ForPatient$id(companyAccount),
				companyRegistrationId,
				$elm$json$Json$Encode$object(_List_Nil),
				$author$project$Components$Patient$CreateMembershipModal$Enrolled);
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$isCurrentMember = function (_v0) {
	var record = _v0.b;
	return record.UI;
};
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$isSubscriber = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyRegistration$Shared$isSubscriber(shared);
};
var $author$project$Api$Provider$CompanyAccount$ForPatient$subscriber = function (_v0) {
	var record = _v0.b;
	return record.acy;
};
var $author$project$Components$Patient$CreateMembershipModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var patientId = $author$project$Api$Provider$Patient$One$id(model.YY);
				var _v2 = model.ut;
				if (!_v2.$) {
					return _Utils_Tuple3(
						model,
						A2(
							$author$project$Ports$Navigation$pushRoute,
							model.F0,
							$author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__New(
								{YZ: patientId})),
						$elm$core$Maybe$Nothing);
				} else {
					var sponsor = _v2.a;
					var subscriber = $author$project$Api$Provider$CompanyAccount$ForPatient$subscriber(sponsor);
					var isSubscriberEnrolled = A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$map,
							$author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$isCurrentMember,
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									$author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$isSubscriber,
									$author$project$Api$Provider$CompanyAccount$ForPatient$companyRegistrations(sponsor)))));
					var isSubscriber = A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$map,
							$elm$core$Basics$eq(patientId),
							A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Min$id, subscriber)));
					var _v3 = _Utils_Tuple2(isSubscriber, isSubscriberEnrolled);
					if (!_v3.a) {
						if (!_v3.b) {
							var companyId = $author$project$Api$Provider$Company$Min$id(
								$author$project$Api$Provider$CompanyAccount$ForPatient$company(sponsor));
							return _Utils_Tuple3(
								model,
								A2(
									$author$project$Ports$Navigation$pushRoute,
									$author$project$Utils$QueryParameter$fromList(
										_List_fromArray(
											[
												_Utils_Tuple2('filter', 'all'),
												_Utils_Tuple2(
												'q',
												A2(
													$elm$core$Maybe$withDefault,
													'',
													A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Min$name, subscriber)))
											])),
									$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top(
										{fZ: companyId})),
								$elm$core$Maybe$Nothing);
						} else {
							return _Utils_Tuple3(
								model,
								A3($author$project$Components$Patient$CreateMembershipModal$enrollDependent, apiClient, sponsor, model.YY),
								$elm$core$Maybe$Nothing);
						}
					} else {
						var companyAccountId = $author$project$Api$Provider$CompanyAccount$ForPatient$id(sponsor);
						return _Utils_Tuple3(
							model,
							A2(
								$author$project$Ports$Navigation$pushRoute,
								A2(
									$elm$core$List$append,
									$author$project$Utils$QueryParameter$fromList(
										_List_fromArray(
											[
												_Utils_Tuple2('company_account', companyAccountId)
											])),
									model.F0),
								$author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__New(
									{YZ: patientId})),
							$elm$core$Maybe$Nothing);
					}
				}
			case 1:
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$elm$core$Maybe$Just($author$project$Components$Patient$CreateMembershipModal$CloseModal));
			case 2:
				var membershipType = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ut: membershipType}),
					$elm$core$Platform$Cmd$none,
					$elm$core$Maybe$Nothing);
			default:
				var response = msg.a;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$elm$core$Maybe$Just($author$project$Components$Patient$CreateMembershipModal$CreationSucceeded));
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$elm$core$Maybe$Just(
								$author$project$Components$Patient$CreateMembershipModal$CreationFailed(error)));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
				}
		}
	});
var $author$project$Components$Patient$PackageDetailsModal$close = function (model) {
	return _Utils_update(
		model,
		{dl: $elm$core$Set$empty, Ao: false, YE: $elm$core$Maybe$Nothing, oQ: $elm$core$Maybe$Nothing, YZ: $elm$core$Maybe$Nothing});
};
var $author$project$Components$Patient$PackageDetailsModal$update = F2(
	function (msg, model) {
		if (!msg.$) {
			return _Utils_Tuple2(
				$author$project$Components$Patient$PackageDetailsModal$close(model),
				$elm$core$Platform$Cmd$none);
		} else {
			var chargeId = msg.a;
			var newExpanded = A2($elm$core$Set$member, chargeId, model.dl) ? A2($elm$core$Set$remove, chargeId, model.dl) : A2($elm$core$Set$insert, chargeId, model.dl);
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{dl: newExpanded}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$buildUrl = function (model) {
	return A2(
		$elm$url$Url$Builder$relative,
		_List_fromArray(
			[
				$author$project$Spa$Generated$Route$toString(
				$author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__Top(
					{
						YZ: $author$project$Api$Provider$Patient$One$id(model.YY)
					}))
			]),
		$author$project$Api$Pagination$toPageQuery(model.ajJ));
};
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$updateUrl = function (model) {
	return $author$project$Ports$Navigation$pushUrl(
		$author$project$Pages$Patients$PatientId_String$Memberships$Top$buildUrl(model));
};
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$update = F2(
	function (msg, model) {
		var patient = model.YY;
		switch (msg.$) {
			case 0:
				var membershipId = msg.a;
				return _Utils_Tuple3(
					model,
					A2(
						$author$project$Utils$Route$navigate,
						$elm$core$Dict$empty,
						$author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__MembershipId_String__Top(
							{
								AW: membershipId,
								YZ: $author$project$Api$Provider$Patient$One$id(patient)
							})),
					_List_Nil);
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								kl: response,
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{kl: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var eligibleCompanyAccounts = A2(
					$elm$core$List$filter,
					$author$project$Api$Provider$CompanyAccount$ForPatient$isEligible,
					$author$project$Api$Provider$Patient$One$companyAccounts(patient));
				if (!eligibleCompanyAccounts.b) {
					return _Utils_Tuple3(
						model,
						A2(
							$author$project$Ports$Navigation$pushRoute,
							model.F0,
							$author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__New(
								{
									YZ: $author$project$Api$Provider$Patient$One$id(patient)
								})),
						_List_Nil);
				} else {
					var x = eligibleCompanyAccounts.a;
					var xs = eligibleCompanyAccounts.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bH: $elm$core$Maybe$Just(
									A3(
										$author$project$Components$Patient$CreateMembershipModal$init,
										model.F0,
										A2($author$project$Utils$NonEmpty$init, x, xs),
										model.YY))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 2:
				return _Utils_Tuple3(
					model,
					A2(
						$author$project$Utils$Route$navigate,
						$elm$core$Dict$fromList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'patient',
									$author$project$Api$Provider$Patient$One$id(patient))
								])),
						$author$project$Spa$Generated$Route$Charges__New),
					_List_Nil);
			case 3:
				var subMsg = msg.a;
				var _v3 = model.bH;
				if (!_v3.$) {
					var modal = _v3.a;
					var _v4 = A3($author$project$Components$Patient$CreateMembershipModal$update, model.Gv, subMsg, modal);
					var createModal_ = _v4.a;
					var cmd = _v4.b;
					var maybeEvent = _v4.c;
					var _v5 = function () {
						if (!maybeEvent.$) {
							switch (maybeEvent.a.$) {
								case 0:
									var _v7 = maybeEvent.a;
									return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none, _List_Nil);
								case 2:
									var _v8 = maybeEvent.a;
									return _Utils_Tuple3(
										$elm$core$Maybe$Nothing,
										A2(
											$author$project$Ports$Navigation$pushRoute,
											model.F0,
											$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
												{
													YZ: $author$project$Api$Provider$Patient$One$id(patient)
												})),
										_List_fromArray(
											[
												$author$project$OutMsg$RetrievePatient(
												$author$project$Api$Provider$Patient$One$id(model.YY))
											]));
								default:
									var error = maybeEvent.a.a;
									return _Utils_Tuple3(
										$elm$core$Maybe$Just(createModal_),
										$elm$core$Platform$Cmd$none,
										_List_fromArray(
											[
												A2(
												$author$project$OutMsg$ShowToast,
												1,
												$author$project$Ui$Toast$serverError(error))
											]));
							}
						} else {
							return _Utils_Tuple3(
								$elm$core$Maybe$Just(createModal_),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
						}
					}();
					var newModal = _v5.a;
					var cmdFromEvent = _v5.b;
					var outMsgs = _v5.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bH: newModal}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									cmdFromEvent,
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Memberships$Top$ModalMsg, cmd)
								])),
						outMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{kl: $author$project$Api$Data$Loading, ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Patients$PatientId_String$Memberships$Top$fetchMemberships(newModel),
								$author$project$Pages$Patients$PatientId_String$Memberships$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 6:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Cm: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 7:
				var _package = msg.a;
				var patientId = $author$project$Api$Provider$Patient$One$id(model.YY);
				var modalWithPackage = function () {
					var _v9 = $author$project$Api$Provider$PatientPackage$All$priceInCents(_package);
					if (!_v9.$) {
						var price = _v9.a;
						return A4($author$project$Components$Patient$PackageDetailsModal$openWithPrice, patientId, _package, price, model.dA);
					} else {
						return A3($author$project$Components$Patient$PackageDetailsModal$open, patientId, _package, model.dA);
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dA: modalWithPackage}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v10 = A2($author$project$Components$Patient$PackageDetailsModal$update, subMsg, model.dA);
				var newModal = _v10.a;
				var cmd = _v10.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dA: newModal}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Memberships$Top$PackageDetailsModalMsg, cmd),
					_List_Nil);
		}
	});
var $author$project$Components$Patient$CreateMembershipModal$MembershipTypeChanged = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Patient$CreateMembershipModal$Sponsored = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Patient$CreateMembershipModal$companyAccountDescription = F2(
	function (companyAccount, patient) {
		var name = $author$project$Api$Provider$Company$Min$name(
			$author$project$Api$Provider$CompanyAccount$ForPatient$company(companyAccount));
		var maybeSubscriber = $author$project$Api$Provider$CompanyAccount$ForPatient$subscriber(companyAccount);
		var isSubscriber = function () {
			var _v0 = A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Min$id, maybeSubscriber);
			if (!_v0.$) {
				var id = _v0.a;
				return _Utils_eq(
					id,
					$author$project$Api$Provider$Patient$One$id(patient));
			} else {
				return false;
			}
		}();
		return _Utils_ap(
			name,
			function () {
				if (isSubscriber) {
					return ' (employee)';
				} else {
					var subscriberName = A2(
						$elm$core$Maybe$withDefault,
						'',
						A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Min$name, maybeSubscriber));
					return ' (dependent of ' + (subscriberName + ')');
				}
			}());
	});
var $author$project$Utils$NonEmpty$head = function (_v0) {
	var head_ = _v0.a;
	return head_;
};
var $author$project$Utils$NonEmpty$toList = function (_v0) {
	var head_ = _v0.a;
	var rest = _v0.b;
	return A2($elm$core$List$cons, head_, rest);
};
var $author$project$Components$Patient$CreateMembershipModal$viewAlerts = F2(
	function (selectedCompanyAccount, patient) {
		var maybeSelectedSponsorshipIsSubscriber = A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$eq(
				$author$project$Api$Provider$Patient$One$id(patient)),
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$Patient$Min$id,
				$author$project$Api$Provider$CompanyAccount$ForPatient$subscriber(selectedCompanyAccount)));
		var maybeIsSubscriberEnrolled = A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$isCurrentMember,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					$author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$isSubscriber,
					$author$project$Api$Provider$CompanyAccount$ForPatient$companyRegistrations(selectedCompanyAccount))));
		var _v0 = _Utils_Tuple2(maybeSelectedSponsorshipIsSubscriber, maybeIsSubscriberEnrolled);
		if (((!_v0.a.$) && (!_v0.a.a)) && (!_v0.b.$)) {
			var bool = _v0.b.a;
			var selectedSponsorshipName = A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					$author$project$Api$Provider$Patient$Min$name,
					$author$project$Api$Provider$CompanyAccount$ForPatient$subscriber(selectedCompanyAccount)));
			return A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label(''),
						$author$project$Ui$Form$Group$labelSpanMd(4),
						$author$project$Ui$Form$Group$inputSpanMd(8)
					]),
				_List_fromArray(
					[
						bool ? A2(
						$author$project$Ui$Alert$warning,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								'This will enroll ' + ($author$project$Api$Provider$Patient$One$name(patient) + (' in membership of ' + selectedSponsorshipName)))
							])) : A2(
						$author$project$Ui$Alert$warning,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('You will be redirected to ' + (selectedSponsorshipName + '\'s Employment Page'))
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$Patient$CreateMembershipModal$viewBody = F3(
	function (selectedType, companyAccounts, patient) {
		return A2(
			$author$project$Ui$Form$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('Membership Type'),
							$author$project$Ui$Form$Group$labelSpanMd(4),
							$author$project$Ui$Form$Group$inputSpanMd(8)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Button$group(
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Select retail membership'},
									_List_fromArray(
										[
											$author$project$Ui$Button$active(
											_Utils_eq($author$project$Components$Patient$CreateMembershipModal$Retail, selectedType)),
											$author$project$Ui$Button$onClick(
											$author$project$Components$Patient$CreateMembershipModal$MembershipTypeChanged($author$project$Components$Patient$CreateMembershipModal$Retail))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Retail')
										])),
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Select sponsored membership'},
									_List_fromArray(
										[
											$author$project$Ui$Button$active(
											!_Utils_eq($author$project$Components$Patient$CreateMembershipModal$Retail, selectedType)),
											$author$project$Ui$Button$onClick(
											$author$project$Components$Patient$CreateMembershipModal$MembershipTypeChanged(
												$author$project$Components$Patient$CreateMembershipModal$Sponsored(
													$author$project$Utils$NonEmpty$head(companyAccounts))))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Sponsored')
										]))
								]))
						])),
					function () {
					if (selectedType.$ === 1) {
						var companyAccount = selectedType.a;
						var onSponsorSelected = function (companyAccountId) {
							return $author$project$Components$Patient$CreateMembershipModal$MembershipTypeChanged(
								$author$project$Components$Patient$CreateMembershipModal$Sponsored(
									A2(
										$elm$core$Maybe$withDefault,
										companyAccount,
										$elm$core$List$head(
											A2(
												$elm$core$List$filter,
												function (elem) {
													return _Utils_eq(
														$author$project$Api$Provider$CompanyAccount$ForPatient$id(elem),
														companyAccountId);
												},
												$author$project$Utils$NonEmpty$toList(companyAccounts))))));
						};
						var companyAccountOptions = A2(
							$elm$core$List$map,
							function (companyAccount_) {
								return A3(
									$author$project$Ui$Form$Select$option,
									_List_Nil,
									$elm$core$Maybe$Just(
										$author$project$Api$Provider$CompanyAccount$ForPatient$id(companyAccount_)),
									A2($author$project$Components$Patient$CreateMembershipModal$companyAccountDescription, companyAccount_, patient));
							},
							$author$project$Utils$NonEmpty$toList(companyAccounts));
						return A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$label('Sponsor'),
											$author$project$Ui$Form$Group$labelSpanMd(4),
											$author$project$Ui$Form$Group$inputSpanMd(8)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Select$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Select$value(
													$elm$core$Maybe$Just(
														$author$project$Api$Provider$CompanyAccount$ForPatient$id(companyAccount))),
													$author$project$Ui$Form$Select$onChange(onSponsorSelected)
												]),
											companyAccountOptions)
										])),
									A2($author$project$Components$Patient$CreateMembershipModal$viewAlerts, companyAccount, patient)
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]));
	});
var $author$project$Components$Patient$CreateMembershipModal$ConfirmButtonClicked = {$: 0};
var $author$project$Components$Patient$CreateMembershipModal$viewFooter = _List_fromArray(
	[
		A3(
		$author$project$Ui$Button$view,
		{mm: 'Cancel and close modal'},
		_List_fromArray(
			[
				$author$project$Ui$Button$link,
				$author$project$Ui$Button$onClick($author$project$Components$Patient$CreateMembershipModal$CloseButtonClicked)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Cancel')
			])),
		A3(
		$author$project$Ui$Button$view,
		{mm: 'Confirm membership'},
		_List_fromArray(
			[
				$author$project$Ui$Button$primary,
				$author$project$Ui$Button$onClick($author$project$Components$Patient$CreateMembershipModal$ConfirmButtonClicked)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Confirm')
			]))
	]);
var $author$project$Components$Patient$CreateMembershipModal$view = function (_v0) {
	var selectedMembershipType = _v0.ut;
	var companyAccounts = _v0.Od;
	var patient = _v0.YY;
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Patient$CreateMembershipModal$CloseButtonClicked,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Create a membership')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A3($author$project$Components$Patient$CreateMembershipModal$viewBody, selectedMembershipType, companyAccounts, patient)
					])),
				$author$project$Ui$Modal$footer($author$project$Components$Patient$CreateMembershipModal$viewFooter)
			]));
};
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$viewModal = function (maybeModal) {
	if (!maybeModal.$) {
		var modal = maybeModal.a;
		return A2(
			$elm$html$Html$map,
			$author$project$Pages$Patients$PatientId_String$Memberships$Top$ModalMsg,
			$author$project$Components$Patient$CreateMembershipModal$view(modal));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Api$Provider$PatientPackage$All$expiresAt = function (_v0) {
	var record = _v0;
	return record.R_;
};
var $author$project$Api$Provider$PatientPackage$All$packageName = function (_v0) {
	var record = _v0;
	return record.YG;
};
var $author$project$Api$Provider$PatientPackage$All$prepaidCharges = function (_v0) {
	var record = _v0;
	return record._b;
};
var $author$project$Components$Patient$PackageDetailsModal$ToggleChargeExpand = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$PatientPackage$All$chargeItemName = function (_v0) {
	var record = _v0;
	return $author$project$Api$Provider$ChargeItem$Min$name(record.mL);
};
var $author$project$Api$Provider$PatientPackage$All$consumptionEvents = function (_v0) {
	var record = _v0;
	return record.Ou;
};
var $author$project$Api$Provider$PatientPackage$All$originalQuantity = function (_v0) {
	var record = _v0;
	return record.Yw;
};
var $author$project$Api$Provider$PatientPackage$All$prepaidChargeId = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$PatientPackage$All$remainingQuantity = function (_v0) {
	var record = _v0;
	return record.$t;
};
var $author$project$Api$Provider$PatientPackage$All$eventInvoiceId = function (_v0) {
	var record = _v0;
	return record.Us;
};
var $author$project$Api$Provider$PatientPackage$All$eventOccurredAt = function (_v0) {
	var record = _v0;
	return record.X8;
};
var $author$project$Api$Provider$PatientPackage$All$eventQuantity = function (_v0) {
	var record = _v0;
	return record.Dz;
};
var $author$project$Components$Patient$PackageDetailsModal$consumptionEventToTimelineEvent = F2(
	function (maybePatientId, event) {
		var qty = $author$project$Api$Provider$PatientPackage$All$eventQuantity(event);
		var invoiceId = $author$project$Api$Provider$PatientPackage$All$eventInvoiceId(event);
		var date = $author$project$Api$Provider$PatientPackage$All$eventOccurredAt(event);
		var dateText = A2($justinmimbs$date$Date$format, 'MM/dd/yyyy', date);
		return {
			G1: A2(
				$author$project$Ui$Element$prose,
				_List_Nil,
				_List_fromArray(
					[
						function () {
						var _v0 = _Utils_Tuple2(invoiceId, maybePatientId);
						if ((!_v0.a.$) && (!_v0.b.$)) {
							var invId = _v0.a.a;
							var patientId = _v0.b.a;
							return A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top(
									{Us: invId, YZ: patientId}),
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(dateText)
									]));
						} else {
							return $elm$html$Html$text(dateText);
						}
					}(),
						A2(
						$author$project$Ui$Typography$text,
						_List_fromArray(
							[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
						'  ' + ($elm$core$String$fromInt(qty) + ' utilized'))
					])),
			PB: date,
			af6: $elm$core$Maybe$Nothing
		};
	});
var $author$project$Ui$Timeline$Vertical = {$: 0};
var $author$project$Ui$Timeline$vertical = $author$project$Ui$Timeline$Vertical;
var $author$project$Components$Patient$PackageDetailsModal$viewConsumptionEvents = F2(
	function (maybePatientId, events) {
		return A2(
			$author$project$Ui$Timeline$view,
			_List_fromArray(
				[$author$project$Ui$Timeline$vertical]),
			A2(
				$elm$core$List$map,
				$author$project$Components$Patient$PackageDetailsModal$consumptionEventToTimelineEvent(maybePatientId),
				events));
	});
var $author$project$Components$Patient$PackageDetailsModal$viewPrepaidCharge = F3(
	function (maybePatientId, expandedCharges, prepaidCharge) {
		var remainingQty = $author$project$Api$Provider$PatientPackage$All$remainingQuantity(prepaidCharge);
		var originalQty = $author$project$Api$Provider$PatientPackage$All$originalQuantity(prepaidCharge);
		var name = $author$project$Api$Provider$PatientPackage$All$chargeItemName(prepaidCharge);
		var events = $author$project$Api$Provider$PatientPackage$All$consumptionEvents(prepaidCharge);
		var hasEvents = !$elm$core$List$isEmpty(events);
		var chargeId = $author$project$Api$Provider$PatientPackage$All$prepaidChargeId(prepaidCharge);
		var isExpanded = A2($elm$core$Set$member, chargeId, expandedCharges);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'margin-bottom', '20px')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$text,
							_List_Nil,
							$elm$core$String$fromInt(originalQty) + (' ' + name)),
							$elm$html$Html$text(' '),
							hasEvents ? A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$Components$Patient$PackageDetailsModal$ToggleChargeExpand(chargeId)),
									A2($elm$html$Html$Attributes$attribute, 'role', 'button'),
									$elm$html$Html$Attributes$tabindex(0),
									A2(
									$elm$html$Html$Attributes$attribute,
									'aria-expanded',
									isExpanded ? 'true' : 'false'),
									A2($elm$html$Html$Attributes$style, 'cursor', 'pointer'),
									$elm$html$Html$Attributes$class('link text-primary'),
									A2($elm$html$Html$Attributes$style, 'text-decoration', 'none')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											'(' + ($elm$core$String$fromInt(remainingQty) + ' remaining)'))
										])),
									isExpanded ? A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'display', 'inline-flex'),
											A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
											A2($elm$html$Html$Attributes$style, 'vertical-align', 'middle'),
											A2($elm$html$Html$Attributes$style, 'margin-left', '4px')
										]),
									_List_fromArray(
										[
											$author$project$Ui$Icon$chevronDown(
											_List_fromArray(
												[$author$project$Ui$Icon$xs]))
										])) : $elm$html$Html$text('')
								])) : A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									'(' + ($elm$core$String$fromInt(remainingQty) + ' remaining)'))
								]))
						])),
					(isExpanded && hasEvents) ? A2($author$project$Components$Patient$PackageDetailsModal$viewConsumptionEvents, maybePatientId, events) : $elm$html$Html$text('')
				]));
	});
var $author$project$Components$Patient$PackageDetailsModal$viewModal = F4(
	function (_package, maybePrice, maybePatientId, expandedCharges) {
		var prepaidCharges_ = $author$project$Api$Provider$PatientPackage$All$prepaidCharges(_package);
		var packageTotal = A2(
			$elm$core$Maybe$withDefault,
			'Price not available',
			A2(
				$elm$core$Maybe$map,
				function (currency) {
					return '$' + $author$project$Currency$toString(currency);
				},
				A2(
					$elm$core$Maybe$map,
					function (price) {
						return $author$project$Currency$fromFloat(price);
					},
					maybePrice)));
		var packageName_ = $author$project$Api$Provider$PatientPackage$All$packageName(_package);
		var expiresAt_ = A2(
			$elm$core$Maybe$map,
			$justinmimbs$date$Date$format('MM/dd/yyyy'),
			$author$project$Api$Provider$PatientPackage$All$expiresAt(_package));
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$Patient$PackageDetailsModal$Close,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('Package Details')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$label('Package'),
											$author$project$Ui$Form$Group$labelSpanSm(3),
											$author$project$Ui$Form$Group$inputSpanSm(9)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$strong,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(packageName_)
														]))
												]))
										])),
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$label('Price'),
											$author$project$Ui$Form$Group$labelSpanSm(3),
											$author$project$Ui$Form$Group$inputSpanSm(9)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$strong,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(packageTotal)
														]))
												]))
										])),
									function () {
									if (!expiresAt_.$) {
										var expiryDate = expiresAt_.a;
										return A2(
											$author$project$Ui$Form$Group$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Group$label('Expires'),
													$author$project$Ui$Form$Group$labelSpanSm(3),
													$author$project$Ui$Form$Group$inputSpanSm(9)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Form$Static$view,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$strong,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(expiryDate)
																]))
														]))
												]));
									} else {
										return $elm$html$Html$text('');
									}
								}(),
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$label('Includes'),
											$author$project$Ui$Form$Group$labelSpanSm(3),
											$author$project$Ui$Form$Group$inputSpanSm(9)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_Nil,
													A2(
														$elm$core$List$map,
														A2($author$project$Components$Patient$PackageDetailsModal$viewPrepaidCharge, maybePatientId, expandedCharges),
														prepaidCharges_))
												]))
										]))
								]))
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textCenter]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Close modal'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick($author$project$Components$Patient$PackageDetailsModal$Close)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Close')
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Patient$PackageDetailsModal$view = function (model) {
	if (model.Ao) {
		var _v0 = model.YE;
		if (!_v0.$) {
			var _package = _v0.a;
			return A4($author$project$Components$Patient$PackageDetailsModal$viewModal, _package, model.oQ, model.YZ, model.dl);
		} else {
			return $elm$html$Html$text('');
		}
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$viewPackageDetailsModal = function (modal) {
	return A2(
		$elm$html$Html$map,
		$author$project$Pages$Patients$PatientId_String$Memberships$Top$PackageDetailsModalMsg,
		$author$project$Components$Patient$PackageDetailsModal$view(modal));
};
var $author$project$Api$Provider$PatientPackage$All$activePackages = $elm$core$List$filter(
	function (_v0) {
		var record = _v0;
		return !record.alH;
	});
var $author$project$Ui$Element$p0 = $author$project$Ui$Element$Padding('p-0');
var $author$project$Ui$Panel$viewKeyed = F2(
	function (options, keyedSections) {
		var optionsRecord = $author$project$Ui$Panel$optionsToRecord(options);
		return A3(
			$elm$html$Html$Keyed$node,
			'div',
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('panel'),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class(optionsRecord.JZ),
					optionsRecord.xs)),
			A2(
				$elm$core$List$filterMap,
				function (_v0) {
					var key = _v0.a;
					var maybeSection = _v0.b;
					return A2(
						$elm$core$Maybe$map,
						function (section) {
							return _Utils_Tuple2(key, section);
						},
						maybeSection);
				},
				A2(
					$elm$core$List$map,
					$elm$core$Tuple$mapSecond(
						$author$project$Ui$Panel$sectionToContents(optionsRecord)),
					keyedSections)));
	});
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$NewPackageClicked = {$: 2};
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$viewNewPackageButton = A3(
	$author$project$Ui$Button$view,
	{mm: 'New package'},
	_List_fromArray(
		[
			$author$project$Ui$Button$styled(0),
			$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Memberships$Top$NewPackageClicked),
			$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('New Package')
		]));
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$OpenPackageDetailsModal = function (a) {
	return {$: 7, a: a};
};
var $author$project$Ui$Button$mb8 = $author$project$Ui$Button$Attrs(
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mb-8')
		]));
var $author$project$Api$Provider$PatientPackage$All$purchasedOn = function (_v0) {
	var record = _v0;
	return record._L;
};
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$viewPrepaidCharge = function (prepaidCharge) {
	var remainingQty = $author$project$Api$Provider$PatientPackage$All$remainingQuantity(prepaidCharge);
	var originalQty = $author$project$Api$Provider$PatientPackage$All$originalQuantity(prepaidCharge);
	var name = $author$project$Api$Provider$PatientPackage$All$chargeItemName(prepaidCharge);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('text-muted'),
				A2($elm$html$Html$Attributes$style, 'margin-bottom', '20px')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$elm$core$String$fromInt(originalQty) + (' ' + (name + ' '))),
				A2(
				$elm$html$Html$strong,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						'(' + ($elm$core$String$fromInt(remainingQty) + ' remaining)'))
					]))
			]));
};
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$viewPackageItem = function (packageItem) {
	var purchasedOn = $author$project$Api$Provider$PatientPackage$All$purchasedOn(packageItem);
	var prepaidCharges = $author$project$Api$Provider$PatientPackage$All$prepaidCharges(packageItem);
	var packageName = $author$project$Api$Provider$PatientPackage$All$packageName(packageItem);
	var packageDetailsButton = A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$mt2]),
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{mm: 'See package details'},
				_List_fromArray(
					[
						$author$project$Ui$Button$mb8,
						$author$project$Ui$Button$sm,
						$author$project$Ui$Button$styled(0),
						$author$project$Ui$Button$onClick(
						$author$project$Pages$Patients$PatientId_String$Memberships$Top$OpenPackageDetailsModal(packageItem))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('See Package Details')
					]))
			]));
	var expiresAt = $author$project$Api$Provider$PatientPackage$All$expiresAt(packageItem);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('list__item')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mt2]),
				_List_fromArray(
					[
						$author$project$Ui$Typography$headingSm(
						_List_fromArray(
							[
								$elm$html$Html$text(packageName)
							]))
					])),
				(!$elm$core$List$isEmpty(prepaidCharges)) ? A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mb2]),
				A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Memberships$Top$viewPrepaidCharge, prepaidCharges)) : $author$project$Utils$Html$empty,
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-body-sm text-muted mb-1')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						'Purchased on ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, purchasedOn))
					])),
				function () {
				if (!expiresAt.$) {
					var expiryDate = expiresAt.a;
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-sm text-muted mb-1')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								'Expires on ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, expiryDate))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				packageDetailsButton
			]));
};
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$viewPackagesPanel = function (model) {
	var _v0 = model.Cm;
	switch (_v0.$) {
		case 3:
			var patientPackages = _v0.a;
			var activePackages = $author$project$Api$Provider$PatientPackage$All$activePackages(patientPackages);
			return A2(
				$author$project$Ui$Panel$viewKeyed,
				_List_Nil,
				_List_fromArray(
					[
						_Utils_Tuple2(
						'title',
						A2(
							$author$project$Ui$Panel$heading,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Panel$title(
									_List_fromArray(
										[
											$elm$html$Html$text('Packages')
										]))
								]))),
						(!$elm$core$List$isEmpty(activePackages)) ? _Utils_Tuple2(
						'packages-body',
						A2(
							$author$project$Ui$Panel$body,
							_List_fromArray(
								[$author$project$Ui$Element$p0]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('list')
										]),
									A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Memberships$Top$viewPackageItem, activePackages))
								]))) : _Utils_Tuple2(
						'no-packages',
						A2(
							$author$project$Ui$Panel$body,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('This patient has no packages')
								]))),
						_Utils_Tuple2(
						'footer',
						A2(
							$author$project$Ui$Panel$footer,
							_List_Nil,
							_List_fromArray(
								[$author$project$Pages$Patients$PatientId_String$Memberships$Top$viewNewPackageButton])))
					]));
		case 1:
			return A2(
				$author$project$Ui$Panel$viewKeyed,
				_List_Nil,
				_List_fromArray(
					[
						_Utils_Tuple2(
						'title',
						A2(
							$author$project$Ui$Panel$heading,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Panel$title(
									_List_fromArray(
										[
											$elm$html$Html$text('Packages')
										]))
								]))),
						_Utils_Tuple2(
						'loading',
						A2(
							$author$project$Ui$Panel$body,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textCenter]),
									_List_fromArray(
										[
											$author$project$Ui$Spinner$view(_List_Nil)
										]))
								])))
					]));
		default:
			return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$NewMembershipClicked = {$: 1};
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$PaginationMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Phi$Phi = $elm$core$Basics$identity;
var $author$project$Api$Phi$from = function (thing) {
	return thing;
};
var $author$project$Api$Pagination$headerTotalCount = function (_v0) {
	var model = _v0;
	return model.qC;
};
var $author$project$Api$Provider$Patient$One$membershipThrough = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$One$record_,
	function ($) {
		return $.WY;
	});
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$MembershipClicked = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Membership$All$record_ = function (_v0) {
	var record = _v0;
	return record;
};
var $author$project$Api$Provider$Membership$All$id = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Membership$All$record_,
	function ($) {
		return $.ahP;
	});
var $author$project$Api$Provider$Membership$All$nextBillDate = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Membership$All$record_,
	function ($) {
		return $.XP;
	});
var $author$project$Api$Provider$Membership$All$periodInMonths = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Membership$All$record_,
	function ($) {
		return $.Zs;
	});
var $author$project$Api$Provider$Membership$All$periodRateInCents = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Membership$All$record_,
	function ($) {
		return $.Zt;
	});
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$periodToString = function (periodInMonths) {
	switch (periodInMonths) {
		case 1:
			return 'Monthly';
		case 3:
			return 'Quarterly';
		case 6:
			return 'Semi-annually';
		case 12:
			return 'Annually';
		default:
			return '/ ' + $elm$core$String$fromInt(periodInMonths);
	}
};
var $author$project$Api$Provider$Membership$All$plan = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Membership$All$record_,
	function ($) {
		return $.Jb;
	});
var $author$project$Api$Provider$Membership$All$startDate = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Membership$All$record_,
	function ($) {
		return $.ab7;
	});
var $author$project$Api$Provider$Membership$All$state = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Membership$All$record_,
	function ($) {
		return $.uP;
	});
var $author$project$Api$Provider$Membership$All$status = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Membership$All$record_,
	function ($) {
		return $.alH;
	});
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$statusToBadge = function (status) {
	var statusText = function () {
		if (!status.$) {
			return 'unconfirmed';
		} else {
			var status_ = status.a;
			return status_;
		}
	}();
	return A2($author$project$Ui$Badge$fromString, _List_Nil, statusText);
};
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$viewMembership = function (membership) {
	var status = $author$project$Api$Provider$Membership$All$status(membership);
	var startDate = $author$project$Api$Provider$Membership$All$startDate(membership);
	var planName = $author$project$Api$Provider$Plan$Min$name(
		$author$project$Api$Provider$Membership$All$plan(membership));
	return A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('list__item'),
				$elm$html$Html$Attributes$class('list__item--clickable'),
				$elm$html$Html$Events$onClick(
				$author$project$Pages$Patients$PatientId_String$Memberships$Top$MembershipClicked(
					$author$project$Api$Provider$Membership$All$id(membership)))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex items-center mb-025')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Typography$headingSm(
						_List_fromArray(
							[
								function () {
								var _v0 = $author$project$Api$Provider$Membership$All$nextBillDate(membership);
								if (!_v0.$) {
									return A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('mr-025')
											]),
										$elm$core$List$singleton(
											$elm$html$Html$text(
												$author$project$Currency$format(
													$author$project$Api$Provider$Membership$All$periodRateInCents(membership)))));
								} else {
									return $elm$html$Html$text('');
								}
							}(),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mr-025')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(planName)
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mr-025')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Pages$Patients$PatientId_String$Memberships$Top$periodToString(
											$author$project$Api$Provider$Membership$All$periodInMonths(membership)))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex items-center')
							]),
						_List_fromArray(
							[
								$author$project$Pages$Patients$PatientId_String$Memberships$Top$statusToBadge(status)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-body-sm text-muted')
					]),
				function () {
					var _v1 = _Utils_Tuple2(
						status,
						$author$project$Api$Provider$Membership$All$state(membership));
					_v1$0:
					while (true) {
						switch (_v1.b.$) {
							case 0:
								if (!_v1.a.$) {
									break _v1$0;
								} else {
									var _v3 = _v1.b;
									return _List_fromArray(
										[
											$elm$html$Html$text(
											'Starting on ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, startDate))
										]);
								}
							case 1:
								if (!_v1.a.$) {
									break _v1$0;
								} else {
									var _v4 = _v1.b;
									return _List_fromArray(
										[
											$elm$html$Html$text(
											'Memberships started on ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, startDate))
										]);
								}
							case 3:
								if (!_v1.a.$) {
									break _v1$0;
								} else {
									var on = _v1.b.a;
									return _List_fromArray(
										[
											$elm$html$Html$text(
											'Contract terminating on ' + A2(
												$elm$core$Maybe$withDefault,
												'N/A',
												A2(
													$elm$core$Maybe$map,
													$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
													on)))
										]);
								}
							case 4:
								if (!_v1.a.$) {
									break _v1$0;
								} else {
									var on = _v1.b.a;
									return _List_fromArray(
										[
											$elm$html$Html$text(
											'Contract renewing on ' + A2(
												$elm$core$Maybe$withDefault,
												'N/A',
												A2(
													$elm$core$Maybe$map,
													$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
													on)))
										]);
								}
							default:
								if (!_v1.a.$) {
									break _v1$0;
								} else {
									var on = _v1.b.a;
									return _List_fromArray(
										[
											$elm$html$Html$text(
											'From ' + (A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, startDate) + (' to ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, on))))
										]);
								}
						}
					}
					var _v2 = _v1.a;
					return _List_fromArray(
						[
							$elm$html$Html$text(
							'Signed up on ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, startDate))
						]);
				}())
			]));
};
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$viewPanel = F2(
	function (model, memberships) {
		var _v0 = model;
		var patient = _v0.YY;
		var urlParams = _v0.F0;
		var pagination = _v0.ajJ;
		var membershipsData = _v0.kl;
		var loading = function () {
			if (membershipsData.$ === 1) {
				return true;
			} else {
				return false;
			}
		}();
		var hasPagination = $author$project$Api$Pagination$headerTotalCount(pagination) > 10;
		return A2(
			$author$project$Ui$Panel$viewKeyed,
			_List_Nil,
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						$elm$core$Maybe$Just(
						_Utils_Tuple2(
							'title',
							A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Memberships')
											]))
									])))),
						function () {
						var _v1 = _Utils_Tuple2(
							$author$project$Api$Provider$Patient$One$membershipThrough(patient),
							$elm$core$List$length(memberships));
						if (!_v1.a.$) {
							var through = _v1.a.a;
							return $elm$core$Maybe$Just(
								A2(
									$elm$core$Tuple$pair,
									'heading',
									A2(
										$author$project$Ui$Panel$heading,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Membership through '),
												A3(
												$author$project$Ui$Link$route,
												$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
													{
														YZ: $author$project$Api$Provider$Patient$Min$id(through)
													}),
												_List_fromArray(
													[
														$author$project$Ui$Link$routeParams(urlParams)
													]),
												_List_fromArray(
													[
														$author$project$Api$Phi$text(
														$author$project$Api$Phi$from(
															$author$project$Api$Provider$Patient$Min$name(through)))
													]))
											]))));
						} else {
							if (!_v1.b) {
								return loading ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
									A2(
										$elm$core$Tuple$pair,
										'body',
										A2(
											$author$project$Ui$Panel$body,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('This patient has no memberships')
												]))));
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}
					}(),
						$elm$core$Maybe$Just(
						_Utils_Tuple2(
							'widget',
							A2(
								$author$project$Ui$Panel$body,
								_List_fromArray(
									[$author$project$Ui$Element$p0]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('list')
											]),
										A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Memberships$Top$viewMembership, memberships))
									])))),
						hasPagination ? $elm$core$Maybe$Just(
						A2(
							$elm$core$Tuple$pair,
							'pagination',
							A2(
								$author$project$Ui$Panel$footer,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Pages$Patients$PatientId_String$Memberships$Top$PaginationMsg,
										A2(
											$author$project$Api$Pagination$view,
											_List_fromArray(
												[
													$author$project$Ui$Pagination$List$loading(loading)
												]),
											pagination))
									])))) : $elm$core$Maybe$Nothing,
						$author$project$Api$Provider$Patient$One$isSynced(patient) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						A2(
							$elm$core$Tuple$pair,
							'footer',
							A2(
								$author$project$Ui$Panel$footer,
								_List_Nil,
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{mm: 'New membership'},
										_List_fromArray(
											[
												$author$project$Ui$Button$styled(0),
												$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Memberships$Top$NewMembershipClicked),
												$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('New Membership')
											]))
									]))))
					])));
	});
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$view = function (model) {
	var pageTitle = A2(
		$author$project$Utils$FeatureGate$gateAvailable,
		14,
		$author$project$Api$Practice$Provider(model.ZV)) ? 'Patient | Memberships & Packages' : 'Patient | Memberships';
	return {
		fO: function () {
			var _v0 = model.kl;
			switch (_v0.$) {
				case 3:
					var memberships = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Pages$Patients$PatientId_String$Memberships$Top$viewPanel, model, memberships),
							A2(
							$author$project$Utils$FeatureGate$gateAvailable,
							14,
							$author$project$Api$Practice$Provider(model.ZV)) ? $author$project$Pages$Patients$PatientId_String$Memberships$Top$viewPackagesPanel(model) : $author$project$Utils$Html$empty,
							$author$project$Pages$Patients$PatientId_String$Memberships$Top$viewModal(model.bH),
							$author$project$Pages$Patients$PatientId_String$Memberships$Top$viewPackageDetailsModal(model.dA)
						]);
				case 1:
					return _List_fromArray(
						[
							A2($author$project$Pages$Patients$PatientId_String$Memberships$Top$viewPanel, model, _List_Nil),
							A2(
							$author$project$Utils$FeatureGate$gateAvailable,
							14,
							$author$project$Api$Practice$Provider(model.ZV)) ? $author$project$Pages$Patients$PatientId_String$Memberships$Top$viewPackagesPanel(model) : $author$project$Utils$Html$empty,
							$author$project$Pages$Patients$PatientId_String$Memberships$Top$viewModal(model.bH),
							$author$project$Pages$Patients$PatientId_String$Memberships$Top$viewPackageDetailsModal(model.dA)
						]);
				default:
					return _List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textCenter]),
							_List_fromArray(
								[
									$author$project$Ui$Spinner$view(_List_Nil)
								]))
						]);
			}
		}(),
		ac9: pageTitle
	};
};
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$page = $author$project$Spa$Page$applicationPatient(
	{ah_: $author$project$Pages$Patients$PatientId_String$Memberships$Top$init, aiq: $author$project$Pages$Patients$PatientId_String$Memberships$Top$load, k8: $author$project$Pages$Patients$PatientId_String$Memberships$Top$save, alO: $author$project$Pages$Patients$PatientId_String$Memberships$Top$subscriptions, adT: $author$project$Pages$Patients$PatientId_String$Memberships$Top$update, amo: $author$project$Pages$Patients$PatientId_String$Memberships$Top$view});
var $author$project$Pages$Patients$PatientId_String$Merge$PatientResourceFilterMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Merge$init = F5(
	function (_v0, practice, patient, _v1, _v2) {
		var apiClient = _v1.Gv;
		var _v3 = A2(
			$elm$core$Tuple$mapFirst,
			$elm$core$Maybe$Just,
			A2(
				$author$project$Components$ResourceFilter$Patient$init,
				apiClient,
				function (d) {
					return _Utils_update(
						d,
						{
							Gp: 'Search for a patient... ',
							aeQ: $elm$core$Maybe$Nothing,
							ag$: $elm$core$Maybe$Just(
								$author$project$Api$Provider$Patient$One$id(patient))
						});
				}));
		var patientResourceFilter = _v3.a;
		var patientResourceFilterCmd = _v3.b;
		return _Utils_Tuple2(
			{Gv: apiClient, iQ: false, aP: false, oE: _List_Nil, cL: _List_Nil, dr: _List_Nil, ds: _List_Nil, eK: $elm$core$Maybe$Nothing, dy: $elm$core$Maybe$Nothing, YY: patient, oY: patientResourceFilter, ZV: practice, dF: $elm$core$Maybe$Nothing},
			A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Merge$PatientResourceFilterMsg, patientResourceFilterCmd));
	});
var $author$project$Pages$Patients$PatientId_String$Merge$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Patients$PatientId_String$Merge$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Patients$PatientId_String$Merge$MergeConfirmationModalClosed = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Merge$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				model.iQ ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Patients$PatientId_String$Merge$MergeConfirmationModalClosed) : $elm$core$Platform$Sub$none,
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$ResourceFilter$Patient$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Pages$Patients$PatientId_String$Merge$PatientResourceFilterMsg)),
					model.oY))
			]));
};
var $author$project$Api$Provider$PatientMerge$associations = function (_v0) {
	var record = _v0;
	return record.L2;
};
var $author$project$Api$Provider$PatientMerge$attributes = function (_v0) {
	var record = _v0;
	return record.xr;
};
var $author$project$Api$Provider$PatientMerge$externalRecords = function (_v0) {
	var record = _v0;
	return record.zy;
};
var $author$project$Pages$Patients$PatientId_String$Merge$GotPreview = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$PatientMerge$patientMergesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['patient_merges']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$PatientMerge$Merge = $elm$core$Basics$identity;
var $author$project$Api$Provider$PatientMerge$MergeRecords = F5(
	function (attributes, paymentOptions, externalRecords, integrationRecords, associations) {
		return {L2: associations, xr: attributes, zy: externalRecords, Ub: integrationRecords, Zb: paymentOptions};
	});
var $author$project$Api$Provider$PatientMerge$Association = $elm$core$Basics$identity;
var $author$project$Api$Provider$PatientMerge$AssociationRecord = F3(
	function (key, message, count) {
		return {OK: count, At: key, aiH: message};
	});
var $author$project$Api$Provider$PatientMerge$associationRecordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'count',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'message',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'key',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$PatientMerge$AssociationRecord))));
var $author$project$Api$Provider$PatientMerge$associationDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PatientMerge$associationRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PatientMerge$Attribute = $elm$core$Basics$identity;
var $author$project$Api$Provider$PatientMerge$AttributeRecord = F4(
	function (key, field, fromValue, toValue) {
		return {Sl: field, gu: fromValue, At: key, hX: toValue};
	});
var $author$project$Api$Provider$PatientMerge$attributeRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'to_value',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'from_value',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'field',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'key',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$PatientMerge$AttributeRecord)))));
var $author$project$Api$Provider$PatientMerge$attributeDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PatientMerge$attributeRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PatientMerge$ExternalRecord = $elm$core$Basics$identity;
var $author$project$Api$Provider$PatientMerge$ExternalRecordRecord = F3(
	function (source, fromValue, toValue) {
		return {gu: fromValue, JQ: source, hX: toValue};
	});
var $author$project$Api$Provider$PatientMerge$externalRecordRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'to_value',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'from_value',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'source',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$PatientMerge$ExternalRecordRecord))));
var $author$project$Api$Provider$PatientMerge$externalRecordDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PatientMerge$externalRecordRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PatientMerge$Integration = $elm$core$Basics$identity;
var $author$project$Api$Provider$PatientMerge$IntegrationRecord = F3(
	function (partner, fromValue, toValue) {
		return {gu: fromValue, YN: partner, hX: toValue};
	});
var $author$project$Api$Provider$PatientMerge$integrationRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'to_value',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'from_value',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'partner',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$PatientMerge$IntegrationRecord))));
var $author$project$Api$Provider$PatientMerge$integrationDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PatientMerge$integrationRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PatientMerge$PaymentOptions = $elm$core$Basics$identity;
var $author$project$Api$Provider$PatientMerge$PaymentOptionsRecord = F2(
	function (fromValue, toValue) {
		return {gu: fromValue, hX: toValue};
	});
var $author$project$Api$Provider$PatientMerge$PaymentSources = $elm$core$Basics$identity;
var $author$project$Api$Provider$PatientMerge$PaymentSourcesRecord = F4(
	function (defaultSource, sources, stripeConnectId, cantKeep) {
		return {Nn: cantKeep, Qc: defaultSource, abP: sources, acl: stripeConnectId};
	});
var $author$project$Api$Provider$PatientMerge$paymentSourcesRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'cant_keep',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'stripe_connect_id',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'sources',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'default_source',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$PatientMerge$PaymentSourcesRecord)))));
var $author$project$Api$Provider$PatientMerge$paymentSourcesDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PatientMerge$paymentSourcesRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PatientMerge$paymentOptionsRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'to_value',
	$author$project$Api$Provider$PatientMerge$paymentSourcesDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'from_value',
		$author$project$Api$Provider$PatientMerge$paymentSourcesDecoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$PatientMerge$PaymentOptionsRecord)));
var $author$project$Api$Provider$PatientMerge$paymentOptionsDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PatientMerge$paymentOptionsRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PatientMerge$mergeRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'associations',
	$elm$json$Json$Decode$list($author$project$Api$Provider$PatientMerge$associationDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'integration_records',
		$elm$json$Json$Decode$list($author$project$Api$Provider$PatientMerge$integrationDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'external_records',
			$elm$json$Json$Decode$list($author$project$Api$Provider$PatientMerge$externalRecordDecoder),
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'payment_options',
				$elm$json$Json$Decode$nullable($author$project$Api$Provider$PatientMerge$paymentOptionsDecoder),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'attributes',
					$elm$json$Json$Decode$list($author$project$Api$Provider$PatientMerge$attributeDecoder),
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$PatientMerge$MergeRecords))))));
var $author$project$Api$Provider$PatientMerge$mergeDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PatientMerge$mergeRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PatientMerge$resultDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['result']),
	$author$project$Api$Provider$PatientMerge$mergeDecoder);
var $author$project$Api$Provider$PatientMerge$postToPatientMerges = F6(
	function (apiClient, fromId, toId, isPreview, maybeOptions, toMsg) {
		var values = $elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						_Utils_Tuple2(
						'from_id',
						$elm$json$Json$Encode$string(fromId)),
						_Utils_Tuple2(
						'to_id',
						$elm$json$Json$Encode$string(toId)),
						_Utils_Tuple2(
						'preview',
						$elm$json$Json$Encode$bool(isPreview))
					]),
					function () {
					if (!maybeOptions.$) {
						var options = maybeOptions.a;
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'attributes',
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, options.xr)),
								_Utils_Tuple2(
								'transfer_payment_options',
								$elm$json$Json$Encode$bool(options.adx)),
								_Utils_Tuple2(
								'integration_records',
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, options.Ub)),
								_Utils_Tuple2(
								'external_records',
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, options.zy))
							]);
					} else {
						return _List_Nil;
					}
				}()
				]));
		var body = $elm$json$Json$Encode$object(values);
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$PatientMerge$resultDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$PatientMerge$patientMergesPath)));
	});
var $author$project$Api$Provider$PatientMerge$preview = F4(
	function (apiClient, fromId, toId, toMsg) {
		return A6($author$project$Api$Provider$PatientMerge$postToPatientMerges, apiClient, fromId, toId, true, $elm$core$Maybe$Nothing, toMsg);
	});
var $author$project$Pages$Patients$PatientId_String$Merge$fetchPreview = F3(
	function (apiClient, fromId, toId) {
		return A4($author$project$Api$Provider$PatientMerge$preview, apiClient, fromId, toId, $author$project$Pages$Patients$PatientId_String$Merge$GotPreview);
	});
var $author$project$Api$Provider$PatientMerge$attributeField = function (_v0) {
	var record = _v0;
	return record.Sl;
};
var $author$project$Api$Provider$PatientMerge$attributeFromValue = function (_v0) {
	var record = _v0;
	return record.gu;
};
var $author$project$Api$Provider$PatientMerge$attributeKey = function (_v0) {
	var record = _v0;
	return record.At;
};
var $author$project$Api$Provider$PatientMerge$attributeToValue = function (_v0) {
	var record = _v0;
	return record.hX;
};
var $author$project$Pages$Patients$PatientId_String$Merge$initAttributeRowModel = function (attribute) {
	var keep = function () {
		var _v0 = $author$project$Api$Provider$PatientMerge$attributeToValue(attribute);
		if (!_v0.$) {
			return 'toValue';
		} else {
			return 'fromValue';
		}
	}();
	return {
		bm: $author$project$Api$Provider$PatientMerge$attributeFromValue(attribute),
		a1: $author$project$Api$Provider$PatientMerge$attributeToValue(attribute),
		Sl: $author$project$Api$Provider$PatientMerge$attributeField(attribute),
		w: keep,
		At: $author$project$Api$Provider$PatientMerge$attributeKey(attribute)
	};
};
var $author$project$Api$Provider$PatientMerge$externalRecordFromValue = function (_v0) {
	var record = _v0;
	return record.gu;
};
var $author$project$Api$Provider$PatientMerge$externalRecordSource = function (_v0) {
	var record = _v0;
	return record.JQ;
};
var $author$project$Api$Provider$PatientMerge$externalRecordToValue = function (_v0) {
	var record = _v0;
	return record.hX;
};
var $author$project$Pages$Patients$PatientId_String$Merge$initExternalRecordRow = function (externalRecord) {
	var keep = function () {
		var _v0 = $author$project$Api$Provider$PatientMerge$externalRecordToValue(externalRecord);
		if (!_v0.$) {
			return 'toValue';
		} else {
			return 'fromValue';
		}
	}();
	return {
		bm: $author$project$Api$Provider$PatientMerge$externalRecordFromValue(externalRecord),
		a1: $author$project$Api$Provider$PatientMerge$externalRecordToValue(externalRecord),
		w: keep,
		JQ: $author$project$Api$Provider$PatientMerge$externalRecordSource(externalRecord)
	};
};
var $author$project$Api$Provider$PatientMerge$integrationFromValue = function (_v0) {
	var record = _v0;
	return record.gu;
};
var $author$project$Api$Provider$PatientMerge$integrationPartner = function (_v0) {
	var record = _v0;
	return record.YN;
};
var $author$project$Api$Provider$PatientMerge$integrationToValue = function (_v0) {
	var record = _v0;
	return record.hX;
};
var $author$project$Pages$Patients$PatientId_String$Merge$initIntegrationRow = function (integration) {
	var keep = function () {
		var _v0 = $author$project$Api$Provider$PatientMerge$integrationToValue(integration);
		if (!_v0.$) {
			return 'toValue';
		} else {
			return 'fromValue';
		}
	}();
	return {
		bm: $author$project$Api$Provider$PatientMerge$integrationFromValue(integration),
		a1: $author$project$Api$Provider$PatientMerge$integrationToValue(integration),
		w: keep,
		YN: $author$project$Api$Provider$PatientMerge$integrationPartner(integration)
	};
};
var $author$project$Api$Provider$PatientMerge$paymentOptionsFromValue = function (_v0) {
	var record = _v0;
	return record.gu;
};
var $author$project$Api$Provider$PatientMerge$paymentOptionsToValue = function (_v0) {
	var record = _v0;
	return record.hX;
};
var $author$project$Api$Provider$PatientMerge$paymentSourcesStripeConnectId = function (_v0) {
	var record = _v0;
	return record.acl;
};
var $author$project$Pages$Patients$PatientId_String$Merge$initPaymentMethodRowModel = function (mergePaymentOptions) {
	var toValueHasNoStripeId = $author$project$Utils$Maybe$isNothing(
		$author$project$Api$Provider$PatientMerge$paymentSourcesStripeConnectId(
			$author$project$Api$Provider$PatientMerge$paymentOptionsToValue(mergePaymentOptions)));
	var toValue = $author$project$Api$Provider$PatientMerge$paymentOptionsToValue(mergePaymentOptions);
	var fromValue = $author$project$Api$Provider$PatientMerge$paymentOptionsFromValue(mergePaymentOptions);
	return {bm: fromValue, a1: toValue, hY: toValueHasNoStripeId};
};
var $author$project$Api$Provider$PatientMerge$integrations = function (_v0) {
	var record = _v0;
	return record.Ub;
};
var $author$project$Pages$Patients$PatientId_String$Merge$PatientsMerged = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$PatientMerge$merge = F5(
	function (apiClient, fromId, toId, options, toMsg) {
		return A6(
			$author$project$Api$Provider$PatientMerge$postToPatientMerges,
			apiClient,
			fromId,
			toId,
			false,
			$elm$core$Maybe$Just(options),
			toMsg);
	});
var $author$project$Pages$Patients$PatientId_String$Merge$merge = function (model) {
	var toId = A2($elm$core$Maybe$withDefault, '', model.dy);
	var mergeOptions = {
		xr: A2(
			$elm$core$List$map,
			function (att) {
				return att.At;
			},
			A2(
				$elm$core$List$filter,
				function (att) {
					return att.w === 'fromValue';
				},
				model.cL)),
		zy: A2(
			$elm$core$List$map,
			function (att) {
				return att.JQ;
			},
			A2(
				$elm$core$List$filter,
				function (att) {
					return att.w === 'fromValue';
				},
				model.dr)),
		Ub: A2(
			$elm$core$List$map,
			function (att) {
				return att.YN;
			},
			A2(
				$elm$core$List$filter,
				function (att) {
					return att.w === 'fromValue';
				},
				model.ds)),
		adx: A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (opt) {
					return opt.hY;
				},
				model.eK))
	};
	var fromId = $author$project$Api$Provider$Patient$One$id(model.YY);
	return A5($author$project$Api$Provider$PatientMerge$merge, model.Gv, fromId, toId, mergeOptions, $author$project$Pages$Patients$PatientId_String$Merge$PatientsMerged);
};
var $author$project$Api$Provider$PatientMerge$paymentOptions = function (_v0) {
	var record = _v0;
	return record.Zb;
};
var $author$project$Components$ResourceFilter$Patient$value = function (model) {
	return A2($author$project$Components$ResourceFilter$choiceToValue, model.b8, model.Jy);
};
var $author$project$Pages$Patients$PatientId_String$Merge$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = model.oY;
				if (!_v1.$) {
					var patientResourceFilter = _v1.a;
					var patientResourceResult = A3($author$project$Components$ResourceFilter$Patient$update, model.Gv, subMsg, patientResourceFilter);
					var _v2 = function () {
						var _v3 = patientResourceResult.agZ;
						if (!_v3.$) {
							return {
								HL: A2(
									$elm$core$Maybe$withDefault,
									$elm$core$Platform$Cmd$none,
									A2(
										$elm$core$Maybe$map,
										A2(
											$author$project$Pages$Patients$PatientId_String$Merge$fetchPreview,
											model.Gv,
											$author$project$Api$Provider$Patient$One$id(model.YY)),
										$author$project$Components$ResourceFilter$Patient$value(patientResourceResult.aiO))),
								V8: true,
								dF: $elm$core$Maybe$Nothing,
								Eq: $author$project$Components$ResourceFilter$Patient$value(patientResourceResult.aiO)
							};
						} else {
							return {HL: $elm$core$Platform$Cmd$none, V8: model.aP, dF: model.dF, Eq: model.dy};
						}
					}();
					var selectedPatientId = _v2.Eq;
					var loading = _v2.V8;
					var previewError = _v2.dF;
					var fetchMergeCmd = _v2.HL;
					var commands = _List_fromArray(
						[
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Merge$PatientResourceFilterMsg, patientResourceResult.GZ),
							fetchMergeCmd
						]);
					var newModel = _Utils_update(
						model,
						{
							aP: loading,
							dy: selectedPatientId,
							oY: $elm$core$Maybe$Just(patientResourceResult.aiO),
							dF: previewError
						});
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(commands),
						patientResourceResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 1:
				var response = msg.a;
				_v4$2:
				while (true) {
					switch (response.$) {
						case 3:
							var data = response.a;
							var paymentMethodRowModel = A2(
								$elm$core$Maybe$map,
								$author$project$Pages$Patients$PatientId_String$Merge$initPaymentMethodRowModel,
								$author$project$Api$Provider$PatientMerge$paymentOptions(data));
							var integrationModels = A2(
								$elm$core$List$map,
								$author$project$Pages$Patients$PatientId_String$Merge$initIntegrationRow,
								$author$project$Api$Provider$PatientMerge$integrations(data));
							var externalRecordModels = A2(
								$elm$core$List$map,
								$author$project$Pages$Patients$PatientId_String$Merge$initExternalRecordRow,
								$author$project$Api$Provider$PatientMerge$externalRecords(data));
							var attributeRowModels = A2(
								$elm$core$List$map,
								$author$project$Pages$Patients$PatientId_String$Merge$initAttributeRowModel,
								$author$project$Api$Provider$PatientMerge$attributes(data));
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aP: false,
										oE: $author$project$Api$Provider$PatientMerge$associations(data),
										cL: attributeRowModels,
										dr: externalRecordModels,
										ds: integrationModels,
										eK: paymentMethodRowModel
									}),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
						case 2:
							if (response.a.$ === 6) {
								var _v5 = response.a;
								var status = _v5.a;
								var errorMsg = _v5.b;
								var baseError = 'We are not able to automatically merge into the selected patient, ';
								var previewError = (status === 406) ? _Utils_ap(baseError, errorMsg) : (baseError + 'please contact Customer Support to get further assistance.');
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aP: false,
											oE: _List_Nil,
											cL: _List_Nil,
											dr: _List_Nil,
											ds: _List_Nil,
											eK: $elm$core$Maybe$Nothing,
											dF: $elm$core$Maybe$Just(previewError)
										}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							} else {
								break _v4$2;
							}
						default:
							break _v4$2;
					}
				}
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aP: false, oE: _List_Nil, cL: _List_Nil, dr: _List_Nil, ds: _List_Nil, eK: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 2:
				var idx = msg.a;
				var option = msg.b;
				var _v6 = A2($elm_community$list_extra$List$Extra$getAt, idx, model.cL);
				if (!_v6.$) {
					var attributesRow = _v6.a;
					var newList = A3(
						$elm_community$list_extra$List$Extra$setAt,
						idx,
						_Utils_update(
							attributesRow,
							{w: option}),
						model.cL);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cL: newList}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var option = msg.a;
				var newModel = function () {
					var _v7 = model.eK;
					if (!_v7.$) {
						var paymentOptions = _v7.a;
						return _Utils_update(
							model,
							{
								eK: $elm$core$Maybe$Just(
									_Utils_update(
										paymentOptions,
										{hY: option === 'fromValue'}))
							});
					} else {
						return model;
					}
				}();
				return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, _List_Nil);
			case 4:
				var idx = msg.a;
				var option = msg.b;
				var _v8 = A2($elm_community$list_extra$List$Extra$getAt, idx, model.dr);
				if (!_v8.$) {
					var recordRow = _v8.a;
					var newList = A3(
						$elm_community$list_extra$List$Extra$setAt,
						idx,
						_Utils_update(
							recordRow,
							{w: option}),
						model.dr);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dr: newList}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				var idx = msg.a;
				var option = msg.b;
				var _v9 = A2($elm_community$list_extra$List$Extra$getAt, idx, model.ds);
				if (!_v9.$) {
					var integrationRow = _v9.a;
					var newList = A3(
						$elm_community$list_extra$List$Extra$setAt,
						idx,
						_Utils_update(
							integrationRow,
							{w: option}),
						model.ds);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ds: newList}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{iQ: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 7:
				var confirmed = msg.a;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{iQ: false}),
					$author$project$Pages$Patients$PatientId_String$Merge$merge(model),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{iQ: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var response = msg.a;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							model,
							A2(
								$author$project$Utils$Route$navigate,
								$elm$core$Dict$empty,
								$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
									{
										YZ: A2($elm$core$Maybe$withDefault, '', model.dy)
									})),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Patients merged.')
								]));
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error))
								]));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Patients$PatientId_String$Merge$MergeConfirmationModalOpened = {$: 6};
var $author$project$Pages$Patients$PatientId_String$Merge$mergeDisabled = function (model) {
	return $author$project$Utils$Maybe$isNothing(model.dy) || model.aP;
};
var $author$project$Api$Provider$PatientMerge$associationKey = function (_v0) {
	var record = _v0;
	return record.At;
};
var $author$project$Pages$Patients$PatientId_String$Merge$showAssociation = function (association) {
	var visibleAssociations = _List_fromArray(
		['note', 'membership', 'credit', 'company_account', 'invoices', 'phone']);
	return A2(
		$elm$core$List$member,
		$author$project$Api$Provider$PatientMerge$associationKey(association),
		visibleAssociations);
};
var $author$project$Api$Provider$PatientMerge$associationCount = function (_v0) {
	var record = _v0;
	return record.OK;
};
var $author$project$Api$Provider$PatientMerge$associationMessage = function (_v0) {
	var record = _v0;
	return record.aiH;
};
var $author$project$Pages$Patients$PatientId_String$Merge$viewAssociation = function (association) {
	return A2(
		$elm$html$Html$li,
		_List_Nil,
		_List_fromArray(
			[
				function () {
				var _v0 = $author$project$Api$Provider$PatientMerge$associationCount(association);
				if (!_v0.$) {
					var count = _v0.a;
					return A2(
						$author$project$Ui$Typography$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(count))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				$author$project$Utils$Html$noBreakSpace,
				A2(
				$author$project$Ui$Typography$text,
				_List_Nil,
				$author$project$Api$Provider$PatientMerge$associationMessage(association))
			]));
};
var $author$project$Pages$Patients$PatientId_String$Merge$viewAssociations = function (_v0) {
	var loadingPreview = _v0.aP;
	var mergeAssociations = _v0.oE;
	var shownAssociations = A2($elm$core$List$filter, $author$project$Pages$Patients$PatientId_String$Merge$showAssociation, mergeAssociations);
	return (loadingPreview || $elm$core$List$isEmpty(shownAssociations)) ? $author$project$Utils$Html$empty : A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Associated Changes')
					])),
				A2(
				$elm$html$Html$ul,
				_List_Nil,
				A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Merge$viewAssociation, shownAssociations))
			]));
};
var $author$project$Pages$Patients$PatientId_String$Merge$SelectOptionForAttribute = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Pages$Patients$PatientId_String$Merge$keepOptions = function (_v0) {
	var disableA = _v0.a;
	var disableB = _v0.b;
	return _List_fromArray(
		[
			A3(
			$author$project$Ui$Form$Select$option,
			_List_fromArray(
				[
					$author$project$Ui$Form$Select$itemDisabled(disableA)
				]),
			$elm$core$Maybe$Just('fromValue'),
			'Keep Option A'),
			A3(
			$author$project$Ui$Form$Select$option,
			_List_fromArray(
				[
					$author$project$Ui$Form$Select$itemDisabled(disableB)
				]),
			$elm$core$Maybe$Just('toValue'),
			'Keep Option B')
		]);
};
var $author$project$Pages$Patients$PatientId_String$Merge$cellStyle = function (selected) {
	return selected ? _List_fromArray(
		[
			$elm$html$Html$Attributes$class('text-success')
		]) : _List_fromArray(
		[
			$elm$html$Html$Attributes$class('text-danger'),
			$elm$html$Html$Attributes$class('line-through')
		]);
};
var $author$project$Pages$Patients$PatientId_String$Merge$viewHtml = function (string) {
	var _v0 = $hecrj$html_parser$Html$Parser$run(string);
	if (!_v0.$) {
		var html = _v0.a;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			$hecrj$html_parser$Html$Parser$Util$toVirtualDom(html));
	} else {
		return $elm$html$Html$text(string);
	}
};
var $author$project$Pages$Patients$PatientId_String$Merge$viewAttributeValueCell = F3(
	function (selectedOption, key, value) {
		var actualValue = function () {
			if (!value.$) {
				var str = value.a;
				return (key === 'address') ? $author$project$Pages$Patients$PatientId_String$Merge$viewHtml(str) : $elm$html$Html$text(str);
			} else {
				return $elm$html$Html$text('[Blank]');
			}
		}();
		return A2(
			$author$project$Ui$Table$cell,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					$author$project$Pages$Patients$PatientId_String$Merge$cellStyle(selectedOption),
					_List_fromArray(
						[actualValue]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Merge$viewAttributeRow = F2(
	function (idx, rowModel) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(rowModel.Sl)
								]))
						])),
					A3($author$project$Pages$Patients$PatientId_String$Merge$viewAttributeValueCell, rowModel.w === 'fromValue', rowModel.At, rowModel.bm),
					A3($author$project$Pages$Patients$PatientId_String$Merge$viewAttributeValueCell, rowModel.w === 'toValue', rowModel.At, rowModel.a1),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(
									$elm$core$Maybe$Just(rowModel.w)),
									$author$project$Ui$Form$Select$onChange(
									$author$project$Pages$Patients$PatientId_String$Merge$SelectOptionForAttribute(idx))
								]),
							$author$project$Pages$Patients$PatientId_String$Merge$keepOptions(
								_Utils_Tuple2(false, false)))
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Merge$viewAttributesTable = function (_v0) {
	var mergeAttributes = _v0.cL;
	var loadingPreview = _v0.aP;
	return (loadingPreview || $elm$core$List$isEmpty(mergeAttributes)) ? $author$project$Utils$Html$empty : A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A4(
				$author$project$Ui$Table$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Field')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Option A')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Option B')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('')
							]))
					]),
				A2($elm$core$List$indexedMap, $author$project$Pages$Patients$PatientId_String$Merge$viewAttributeRow, mergeAttributes),
				_List_Nil)
			]));
};
var $author$project$Pages$Patients$PatientId_String$Merge$SelectOptionForExternalRecord = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$Patients$PatientId_String$Merge$viewExternalRecordRow = F2(
	function (idx, model) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(model.JQ)
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							$author$project$Pages$Patients$PatientId_String$Merge$cellStyle(model.w === 'fromValue'),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($elm$core$Maybe$withDefault, '[Blank]', model.bm))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							$author$project$Pages$Patients$PatientId_String$Merge$cellStyle(model.w === 'toValue'),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($elm$core$Maybe$withDefault, '[Blank]', model.a1))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(
									$elm$core$Maybe$Just(model.w)),
									$author$project$Ui$Form$Select$onChange(
									$author$project$Pages$Patients$PatientId_String$Merge$SelectOptionForExternalRecord(idx))
								]),
							$author$project$Pages$Patients$PatientId_String$Merge$keepOptions(
								_Utils_Tuple2(false, false)))
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Merge$viewExternalRecordsTable = function (_v0) {
	var loadingPreview = _v0.aP;
	var mergeExternalRecords = _v0.dr;
	return (loadingPreview || $elm$core$List$isEmpty(mergeExternalRecords)) ? $author$project$Utils$Html$empty : A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('External Records')
					])),
				A4(
				$author$project$Ui$Table$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Service')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Option A')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Option B')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('')
							]))
					]),
				A2($elm$core$List$indexedMap, $author$project$Pages$Patients$PatientId_String$Merge$viewExternalRecordRow, mergeExternalRecords),
				_List_Nil)
			]));
};
var $author$project$Pages$Patients$PatientId_String$Merge$SelectOptionForIntegration = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Pages$Patients$PatientId_String$Merge$viewIntegrationRow = F2(
	function (idx, model) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(model.YN)
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							$author$project$Pages$Patients$PatientId_String$Merge$cellStyle(model.w === 'fromValue'),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($elm$core$Maybe$withDefault, '[Blank]', model.bm))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							$author$project$Pages$Patients$PatientId_String$Merge$cellStyle(model.w === 'toValue'),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($elm$core$Maybe$withDefault, '[Blank]', model.a1))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(
									$elm$core$Maybe$Just(model.w)),
									$author$project$Ui$Form$Select$onChange(
									$author$project$Pages$Patients$PatientId_String$Merge$SelectOptionForIntegration(idx))
								]),
							$author$project$Pages$Patients$PatientId_String$Merge$keepOptions(
								_Utils_Tuple2(false, false)))
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Merge$viewIntegrationsTable = function (_v0) {
	var loadingPreview = _v0.aP;
	var mergeIntegrations = _v0.ds;
	return (loadingPreview || $elm$core$List$isEmpty(mergeIntegrations)) ? $author$project$Utils$Html$empty : A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Integrations')
					])),
				A4(
				$author$project$Ui$Table$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Service')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Option A')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Option B')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('')
							]))
					]),
				A2($elm$core$List$indexedMap, $author$project$Pages$Patients$PatientId_String$Merge$viewIntegrationRow, mergeIntegrations),
				_List_Nil)
			]));
};
var $author$project$Pages$Patients$PatientId_String$Merge$viewMergeConfirmModal = function (model) {
	return model.iQ ? A2(
		$author$project$Components$HiConfirm$modal,
		$author$project$Pages$Patients$PatientId_String$Merge$MergeConfirmationModalClosed,
		_List_fromArray(
			[
				$author$project$Components$HiConfirm$verb('merge'),
				$author$project$Components$HiConfirm$noun('patient record'),
				$author$project$Components$HiConfirm$detail(
				$author$project$Api$Provider$Patient$One$id(model.YY) + (' into patient record ' + A2($elm$core$Maybe$withDefault, '', model.dy)))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Pages$Patients$PatientId_String$Merge$SelectOptionForPaymentMethod = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$PatientMerge$paymentSourcesCantKeep = function (_v0) {
	var record = _v0;
	return record.Nn;
};
var $author$project$Api$Provider$PatientMerge$paymentSourcesDefaultSource = function (_v0) {
	var record = _v0;
	return record.Qc;
};
var $author$project$Api$Provider$PatientMerge$paymentSourcesSources = function (_v0) {
	var record = _v0;
	return record.abP;
};
var $author$project$Pages$Patients$PatientId_String$Merge$viewPaymentOption = F2(
	function (paymentSource, selectedOption) {
		return A2(
			$author$project$Ui$Table$cell,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					$author$project$Pages$Patients$PatientId_String$Merge$cellStyle(selectedOption),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Stripe ID:')
										])),
									$elm$html$Html$text(
									' ' + A2(
										$elm$core$Maybe$withDefault,
										'[Blank]',
										$author$project$Api$Provider$PatientMerge$paymentSourcesStripeConnectId(paymentSource)))
								])),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Default Source:')
										])),
									$elm$html$Html$text(
									' ' + A2(
										$elm$core$Maybe$withDefault,
										' [Blank]',
										$author$project$Api$Provider$PatientMerge$paymentSourcesDefaultSource(paymentSource)))
								])),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Payment Sources:')
										])),
									$elm$core$List$isEmpty(
									$author$project$Api$Provider$PatientMerge$paymentSourcesSources(paymentSource)) ? $elm$html$Html$text(' None') : A2(
									$elm$html$Html$ul,
									_List_Nil,
									A2(
										$elm$core$List$map,
										function (source) {
											return A2(
												$elm$html$Html$li,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(source)
													]));
										},
										$author$project$Api$Provider$PatientMerge$paymentSourcesSources(paymentSource)))
								]))
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Merge$viewPaymentOptionsTable = function (_v0) {
	var loadingPreview = _v0.aP;
	var mergePaymentOptions = _v0.eK;
	if (loadingPreview) {
		return $author$project$Utils$Html$empty;
	} else {
		if (mergePaymentOptions.$ === 1) {
			return $author$project$Utils$Html$empty;
		} else {
			var paymentOptions = mergePaymentOptions.a;
			var keepOption = paymentOptions.hY ? 'fromValue' : 'toValue';
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Payment options')
							])),
						A4(
						$author$project$Ui$Table$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Table$header,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Option A')
									])),
								A2(
								$author$project$Ui$Table$header,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Option B')
									])),
								A2(
								$author$project$Ui$Table$header,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Table$row,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$Pages$Patients$PatientId_String$Merge$viewPaymentOption, paymentOptions.bm, paymentOptions.hY),
										A2($author$project$Pages$Patients$PatientId_String$Merge$viewPaymentOption, paymentOptions.a1, !paymentOptions.hY),
										A2(
										$author$project$Ui$Table$cell,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Select$view,
												_List_fromArray(
													[
														$author$project$Ui$Form$Select$value(
														$elm$core$Maybe$Just(keepOption)),
														$author$project$Ui$Form$Select$onChange($author$project$Pages$Patients$PatientId_String$Merge$SelectOptionForPaymentMethod)
													]),
												$author$project$Pages$Patients$PatientId_String$Merge$keepOptions(
													_Utils_Tuple2(
														$author$project$Api$Provider$PatientMerge$paymentSourcesCantKeep(paymentOptions.bm),
														$author$project$Api$Provider$PatientMerge$paymentSourcesCantKeep(paymentOptions.a1))))
											]))
									]))
							]),
						_List_Nil),
						(paymentOptions.hY && $author$project$Utils$Maybe$toBool(
						$author$project$Api$Provider$PatientMerge$paymentSourcesStripeConnectId(paymentOptions.a1))) ? A2(
						$author$project$Ui$Alert$warning,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Migrating payment options will override the current payment options on the destination patient. This will prevent refunds of old payments that used the discarded options.')
							])) : $author$project$Utils$Html$empty
					]));
		}
	}
};
var $author$project$Pages$Patients$PatientId_String$Merge$conflictsPresent = function (_v0) {
	var mergeAttributes = _v0.cL;
	return !$elm$core$List$isEmpty(mergeAttributes);
};
var $author$project$Pages$Patients$PatientId_String$Merge$viewPatientOptions = function (patientResourceFilter) {
	if (!patientResourceFilter.$) {
		var dependentResourceFilter = patientResourceFilter.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-group')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Pages$Patients$PatientId_String$Merge$PatientResourceFilterMsg,
					A2(
						$author$project$Components$ResourceFilter$Patient$view,
						_List_fromArray(
							[
								$author$project$Components$ResourceFilter$style(0)
							]),
						dependentResourceFilter))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Merge$viewTopSection = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
							{
								YZ: $author$project$Api$Provider$Patient$One$id(model.YY)
							}),
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Patient')
							])),
						A2(
						$author$project$Ui$Typography$text,
						_List_fromArray(
							[$author$project$Ui$Typography$gray]),
						'  /  Merge ')
					])),
				$author$project$Ui$HorizontalRule$view(
				_List_fromArray(
					[$author$project$Ui$HorizontalRule$thin])),
				$author$project$Ui$Typography$headingSm(
				_List_fromArray(
					[
						$elm$html$Html$text('Merge Duplicate Patients')
					])),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-body-sm text-muted')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('We will attempt to merge all the information we can, including Demographics, Notes, Payment Options, Invoices, Memberships, and Employment Info. After merging, this patient record will automatically be archived.')
					])),
				A2(
				$elm$html$Html$strong,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Merge this patient record ')
					])),
				$elm$html$Html$text(
				$author$project$Api$Provider$Patient$One$id(model.YY)),
				A2(
				$elm$html$Html$strong,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(' with ')
					])),
				function () {
				var _v0 = model.dy;
				if (!_v0.$) {
					var id = _v0.a;
					return $elm$html$Html$text(id);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				$author$project$Pages$Patients$PatientId_String$Merge$viewPatientOptions(model.oY),
				function () {
				var _v1 = model.dF;
				if (!_v1.$) {
					var error = _v1.a;
					return A2(
						$author$project$Ui$Alert$danger,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(error)
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				model.aP ? A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Typography$headingSm(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$text(
								_List_fromArray(
									[
										$author$project$Ui$Skeleton$spanFromText('Resolve differences')
									]))
							])),
						A4(
						$author$project$Ui$Table$view,
						_List_fromArray(
							[
								$author$project$Ui$Table$loading(true)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Table$header,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Field')
									])),
								A2(
								$author$project$Ui$Table$header,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Option A')
									])),
								A2(
								$author$project$Ui$Table$header,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Option B')
									])),
								A2(
								$author$project$Ui$Table$header,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('')
									]))
							]),
						_List_Nil,
						_List_Nil)
					])) : ($author$project$Pages$Patients$PatientId_String$Merge$conflictsPresent(model) ? $author$project$Ui$Typography$headingSm(
				_List_fromArray(
					[
						$elm$html$Html$text('Resolve differences')
					])) : $author$project$Utils$Html$empty)
			]));
};
var $author$project$Pages$Patients$PatientId_String$Merge$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				$author$project$Pages$Patients$PatientId_String$Merge$viewMergeConfirmModal(model),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Pages$Patients$PatientId_String$Merge$viewTopSection(model),
								$author$project$Pages$Patients$PatientId_String$Merge$viewAttributesTable(model),
								$author$project$Pages$Patients$PatientId_String$Merge$viewPaymentOptionsTable(model),
								$author$project$Pages$Patients$PatientId_String$Merge$viewExternalRecordsTable(model),
								$author$project$Pages$Patients$PatientId_String$Merge$viewIntegrationsTable(model),
								$author$project$Pages$Patients$PatientId_String$Merge$viewAssociations(model),
								($author$project$Utils$Maybe$toBool(model.dy) && ((!model.aP) && $author$project$Utils$Maybe$isNothing(model.dF))) ? A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$Api$Provider$Practice$One$featureEnabled, 6, model.ZV) ? $elm$html$Html$text('Merging this patient does not preserve clinical interactions, communication history, or health summary data. Confirm the winning patient chart contains all relevant clinical information before proceeding.') : $elm$html$Html$text('All other fields will be unchanged on the destination patient.')
									])) : $author$project$Utils$Html$empty
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_fromArray(
							[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$gap2]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Patients__PatientId_String__Edit(
									{
										YZ: $author$project$Api$Provider$Patient$One$id(model.YY)
									}),
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Cancel')
									])),
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Merge patients'},
								_List_fromArray(
									[
										$author$project$Ui$Button$danger,
										$author$project$Ui$Button$disabled(
										$author$project$Pages$Patients$PatientId_String$Merge$mergeDisabled(model)),
										$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Merge$MergeConfirmationModalOpened)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Merge')
									]))
							]))
					]))
			]),
		ac9: 'Patient | Merge'
	};
};
var $author$project$Pages$Patients$PatientId_String$Merge$page = $author$project$Spa$Page$applicationPatient(
	{ah_: $author$project$Pages$Patients$PatientId_String$Merge$init, aiq: $author$project$Pages$Patients$PatientId_String$Merge$load, k8: $author$project$Pages$Patients$PatientId_String$Merge$save, alO: $author$project$Pages$Patients$PatientId_String$Merge$subscriptions, adT: $author$project$Pages$Patients$PatientId_String$Merge$update, amo: $author$project$Pages$Patients$PatientId_String$Merge$view});
var $author$project$Pages$Patients$PatientId_String$Notes$NoteId_String$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Patients$PatientId_String$Notes$NoteId_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Patients$PatientId_String$Notes$NoteId_String$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Patients$PatientId_String$Notes$NoteId_String$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Note'};
};
var $author$project$Pages$Patients$PatientId_String$Notes$NoteId_String$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$Patients$PatientId_String$Notes$NoteId_String$init,
		aiq: $author$project$Pages$Patients$PatientId_String$Notes$NoteId_String$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$Patients$PatientId_String$Notes$NoteId_String$update,
		amo: $author$project$Pages$Patients$PatientId_String$Notes$NoteId_String$view
	});
var $author$project$Pages$Patients$PatientId_String$Notes$Top$NotesMsg = $elm$core$Basics$identity;
var $author$project$Api$Provider$Note$Patient = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Notes$Top$init = F5(
	function (session, _v0, _v1, shared, _v2) {
		var query = _v2.DE;
		var params = _v2.YL;
		var _v3 = A6(
			$author$project$Components$Notes$init,
			shared.Gv,
			shared.J7,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__Notes__Top(
				{YZ: params.YZ}),
			query,
			$author$project$Api$Provider$Note$Patient(params.YZ),
			$author$project$Api$Platform$Session$One$userIsPracticeAdmin(session));
		var notes = _v3.a;
		var notesCmd = _v3.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, s1: notes},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, notesCmd));
	});
var $author$project$Pages$Patients$PatientId_String$Notes$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Patients$PatientId_String$Notes$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Patients$PatientId_String$Notes$Top$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Notes$subscriptions(model.s1));
};
var $author$project$Pages$Patients$PatientId_String$Notes$Top$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Notes$update, model.Gv, subMsg, model.s1);
		var notes = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{s1: notes}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Pages$Patients$PatientId_String$Notes$Top$view = function (model) {
	return {
		fO: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			$author$project$Components$Notes$view(model.s1)),
		ac9: 'Patient | Notes'
	};
};
var $author$project$Pages$Patients$PatientId_String$Notes$Top$page = $author$project$Spa$Page$applicationPatient(
	{ah_: $author$project$Pages$Patients$PatientId_String$Notes$Top$init, aiq: $author$project$Pages$Patients$PatientId_String$Notes$Top$load, k8: $author$project$Pages$Patients$PatientId_String$Notes$Top$save, alO: $author$project$Pages$Patients$PatientId_String$Notes$Top$subscriptions, adT: $author$project$Pages$Patients$PatientId_String$Notes$Top$update, amo: $author$project$Pages$Patients$PatientId_String$Notes$Top$view});
var $author$project$Pages$Patients$PatientId_String$Notifications$Top$GotEmailAddress = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$EmailAddress$One$EmailAddress = $elm$core$Basics$identity;
var $author$project$Api$Provider$EmailAddress$One$Record = F6(
	function (id, email, portalEnabled, isBounced, isRejected, isUnsubscribed) {
		return {Rj: email, ahP: id, UD: isBounced, Va: isRejected, Vi: isUnsubscribed, ZO: portalEnabled};
	});
var $author$project$Api$Provider$EmailAddress$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'is_unsubscribed',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'is_rejected',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'is_bounced',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'portal_enabled',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'email',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$EmailAddress$One$Record)))))));
var $author$project$Api$Provider$EmailAddress$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$EmailAddress$One$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$EmailAddress$emailAddressPath = function (patientId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['email_address']),
		A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[patientId]),
			A2(
				$author$project$Api$Data$pathAppend,
				_List_fromArray(
					['patients']),
				$author$project$Api$Data$providerPath)));
};
var $author$project$Api$Provider$EmailAddress$retrieve = F3(
	function (apiClient, emailAddressId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$EmailAddress$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$EmailAddress$emailAddressPath(emailAddressId)));
	});
var $author$project$Pages$Patients$PatientId_String$Notifications$Top$fetchEmailAddress = F2(
	function (apiClient, patientId) {
		return A3($author$project$Api$Provider$EmailAddress$retrieve, apiClient, patientId, $author$project$Pages$Patients$PatientId_String$Notifications$Top$GotEmailAddress);
	});
var $author$project$Pages$Patients$PatientId_String$Notifications$Top$GotPatientNotifications = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Notification$All$Notification = $elm$core$Basics$identity;
var $author$project$Api$Provider$Notification$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Notification$One$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Notification$listDefaults = {ajJ: $author$project$Api$Pagination$init, alA: $author$project$Api$Sort$init};
var $author$project$Api$Provider$Notification$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Notification$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$Provider$Notification$recipientNotificationsPath = function (recipient) {
	if (!recipient.$) {
		var patientId = recipient.a;
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				['notifications']),
			$author$project$Api$Provider$Patient$patientPath(patientId));
	} else {
		var companyId = recipient.a;
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				['notifications']),
			$author$project$Api$Provider$Company$companyPath(companyId));
	}
};
var $author$project$Api$Provider$Notification$list = F4(
	function (apiClient, recipient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Notification$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Notification$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Notification$recipientNotificationsPath(recipient))));
	});
var $author$project$Pages$Patients$PatientId_String$Notifications$Top$fetchList = function (model) {
	return A4(
		$author$project$Api$Provider$Notification$list,
		model.Gv,
		$author$project$Api$Provider$Notification$Patient(
			$author$project$Api$Provider$Patient$One$id(model.YY)),
		function (d) {
			return _Utils_update(
				d,
				{ajJ: model.ajJ, alA: model.alA});
		},
		$author$project$Pages$Patients$PatientId_String$Notifications$Top$GotPatientNotifications);
};
var $author$project$Pages$Patients$PatientId_String$Notifications$Top$init = F5(
	function (_v0, practice, patient, _v1, _v2) {
		var timeFormatter = _v1.J7;
		var apiClient = _v1.Gv;
		var query = _v2.DE;
		var model = {
			Gv: apiClient,
			GI: false,
			r7: $elm$core$Maybe$Nothing,
			tm: $author$project$Api$Data$Loading,
			ajJ: $author$project$Api$Pagination$initFromQuery(query),
			YY: patient,
			ZV: practice,
			pV: $elm$core$Maybe$Nothing,
			alA: A3($author$project$Api$Sort$withDefault, 'created_at', 1, $author$project$Api$Sort$init),
			J7: timeFormatter
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Pages$Patients$PatientId_String$Notifications$Top$fetchList(model),
						A2(
						$author$project$Pages$Patients$PatientId_String$Notifications$Top$fetchEmailAddress,
						apiClient,
						$author$project$Api$Provider$Patient$One$id(patient))
					])));
	});
var $author$project$Pages$Patients$PatientId_String$Notifications$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Patients$PatientId_String$Notifications$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Patients$PatientId_String$Notifications$Top$CloseModal = {$: 4};
var $author$project$Pages$Patients$PatientId_String$Notifications$Top$subscriptions = function (model) {
	var _v0 = model.pV;
	if (!_v0.$) {
		return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Pages$Patients$PatientId_String$Notifications$Top$CloseModal);
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Pages$Patients$PatientId_String$Notifications$Top$updateUrl = function (model) {
	var baseRoute = $author$project$Spa$Generated$Route$toString(
		$author$project$Spa$Generated$Route$Patients__PatientId_String__Notifications__Top(
			{
				YZ: $author$project$Api$Provider$Patient$One$id(model.YY)
			}));
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[baseRoute]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.ajJ),
				$author$project$Api$Sort$toQuery(model.alA))));
};
var $author$project$Pages$Patients$PatientId_String$Notifications$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								tm: response,
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{tm: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Patients$PatientId_String$Notifications$Top$fetchList(newModel),
								$author$project$Pages$Patients$PatientId_String$Notifications$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 2:
				var response = msg.a;
				switch (response.$) {
					case 3:
						var emailAddress = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									r7: $elm$core$Maybe$Just(emailAddress)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					case 2:
						var error = response.a;
						if (error.$ === 5) {
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{r7: $elm$core$Maybe$Nothing}),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
						} else {
							return _Utils_Tuple3(
								model,
								$elm$core$Platform$Cmd$none,
								$author$project$OutMsg$handleErrorResponse(response));
						}
					default:
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
				}
			case 3:
				var notification = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							pV: $elm$core$Maybe$Just(notification)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{pV: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
		}
	});
var $author$project$Pages$Patients$PatientId_String$Notifications$Top$PaginationMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$EmailAddress$One$email = function (_v0) {
	var record = _v0;
	return record.Rj;
};
var $author$project$Api$Provider$EmailAddress$One$isBounced = function (_v0) {
	var record = _v0;
	return record.UD;
};
var $author$project$Pages$Patients$PatientId_String$Notifications$Top$viewBouncedEmailAlert = F2(
	function (emailAddress, bouncedEmailReset) {
		var _v0 = _Utils_Tuple2(
			bouncedEmailReset,
			$author$project$Api$Provider$EmailAddress$One$isBounced(emailAddress));
		if ((!_v0.a) && _v0.b) {
			return A2(
				$author$project$Ui$Alert$warning,
				_List_fromArray(
					[
						$author$project$Ui$Alert$alignment($author$project$Ui$Alignment$itemsCenter),
						$author$project$Ui$Alert$alignment($author$project$Ui$Alignment$spaceBetween)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Icon$warning(
								_List_fromArray(
									[$author$project$Ui$Icon$danger])),
								$elm$html$Html$text(
								' Emails to ' + ($author$project$Api$Provider$EmailAddress$One$email(emailAddress) + ' have bounced.'))
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Api$Provider$Notification$All$bodyHtml = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Notification$One$bodyHtml(one);
};
var $author$project$Api$Provider$Notification$Shared$recipientEmail = function (_v0) {
	var record = _v0;
	return record.$d;
};
var $author$project$Api$Provider$Notification$One$recipientEmail = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Notification$Shared$recipientEmail(shared);
};
var $author$project$Api$Provider$Notification$All$recipientEmail = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Notification$One$recipientEmail(one);
};
var $author$project$Api$Provider$Notification$All$subject = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Notification$One$subject(one);
};
var $author$project$Api$Provider$Notification$All$subjectHtml = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Notification$One$subjectHtml(one);
};
var $author$project$Pages$Patients$PatientId_String$Notifications$Top$viewEmailModal = function (notification) {
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Pages$Patients$PatientId_String$Notifications$Top$CloseModal,
		_List_fromArray(
			[$author$project$Ui$Modal$lg]),
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Notification Email')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$phi]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('email-preview')
									]),
								_List_fromArray(
									[
										function () {
										var _v0 = $author$project$Api$Provider$Notification$All$recipientEmail(notification);
										if (!_v0.$) {
											var email = _v0.a;
											return A2(
												$elm$html$Html$div,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$strong,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('To ')
															])),
														A2($author$project$Ui$Typography$text, _List_Nil, '<' + (email + '>')),
														$author$project$Ui$HorizontalRule$view(_List_Nil)
													]));
										} else {
											return $author$project$Utils$Html$empty;
										}
									}(),
										A2(
										$author$project$Ui$Typography$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Subject ')
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('subject')
											]),
										A2(
											$elm$core$List$map,
											$elm$html$Html$map($elm$core$Basics$never),
											$author$project$Utils$Dom$textToHtml(
												A2(
													$elm$core$Maybe$withDefault,
													A2(
														$elm$core$Maybe$withDefault,
														'',
														$author$project$Api$Provider$Notification$All$subject(notification)),
													$author$project$Api$Provider$Notification$All$subjectHtml(notification))))),
										$author$project$Ui$HorizontalRule$view(_List_Nil),
										A2(
										$elm$html$Html$div,
										A2(
											$elm$core$List$cons,
											$elm$html$Html$Attributes$class('body'),
											$author$project$Api$Phi$displayAttr),
										A2(
											$elm$core$List$map,
											$elm$html$Html$map($elm$core$Basics$never),
											$author$project$Utils$Dom$textToHtml(
												A2(
													$elm$core$Maybe$withDefault,
													'',
													$author$project$Api$Provider$Notification$All$bodyHtml(notification)))))
									]))
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Close'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Notifications$Top$CloseModal)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Close')
							]))
					]))
			]));
};
var $author$project$Pages$Patients$PatientId_String$Notifications$Top$viewNotificationSkeleton = A2(
	$author$project$Ui$ListGroup$item,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$spanFromText('mm/dd/yyyy at l:%MM %pp')
						]))
				])),
			A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$spanFromText('Sent notification to email')
						]))
				])),
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$textSm]),
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$spanFromText('Patient clicked notification at: Uknown')
						]))
				])),
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$textSm]),
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$spanFromText('Patient opened notification at: Uknown')
						]))
				]))
		]));
var $author$project$Pages$Patients$PatientId_String$Notifications$Top$ViewNotification = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Notification$Shared$attemptedAt = function (_v0) {
	var record = _v0;
	return record.L6;
};
var $author$project$Api$Provider$Notification$One$attemptedAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Notification$Shared$attemptedAt(shared);
};
var $author$project$Api$Provider$Notification$All$attemptedAt = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Notification$One$attemptedAt(one);
};
var $author$project$Api$Provider$Notification$Shared$clickedAt = function (_v0) {
	var record = _v0;
	return record.NI;
};
var $author$project$Api$Provider$Notification$One$clickedAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Notification$Shared$clickedAt(shared);
};
var $author$project$Api$Provider$Notification$All$clickedAt = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Notification$One$clickedAt(one);
};
var $author$project$Api$Provider$Notification$Shared$errorMessage = function (_v0) {
	var record = _v0;
	return record.RM;
};
var $author$project$Api$Provider$Notification$One$errorMessage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Notification$Shared$errorMessage(shared);
};
var $author$project$Api$Provider$Notification$All$errorMessage = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Notification$One$errorMessage(one);
};
var $author$project$Api$Provider$Notification$Shared$failedAt = function (_v0) {
	var record = _v0;
	return record.R6;
};
var $author$project$Api$Provider$Notification$One$failedAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Notification$Shared$failedAt(shared);
};
var $author$project$Api$Provider$Notification$All$failedAt = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Notification$One$failedAt(one);
};
var $author$project$Api$Provider$Notification$Shared$openedAt = function (_v0) {
	var record = _v0;
	return record.Yo;
};
var $author$project$Api$Provider$Notification$One$openedAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Notification$Shared$openedAt(shared);
};
var $author$project$Api$Provider$Notification$All$openedAt = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Notification$One$openedAt(one);
};
var $author$project$Utils$Maybe$orElse = F2(
	function (elseMaybe, maybe) {
		if (!maybe.$) {
			return maybe;
		} else {
			return elseMaybe;
		}
	});
var $author$project$Api$Provider$Notification$Shared$shortDescription = function (_v0) {
	var record = _v0;
	return record.abc;
};
var $author$project$Api$Provider$Notification$One$shortDescription = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Notification$Shared$shortDescription(shared);
};
var $author$project$Api$Provider$Notification$All$shortDescription = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Notification$One$shortDescription(one);
};
var $author$project$Api$Provider$Notification$One$shortDescriptionHtml = function (_v0) {
	var record = _v0.b;
	return record.abd;
};
var $author$project$Api$Provider$Notification$All$shortDescriptionHtml = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Notification$One$shortDescriptionHtml(one);
};
var $author$project$Pages$Patients$PatientId_String$Notifications$Top$viewNotification = F2(
	function (timeFormatter, notification) {
		var description = (A2(
			$elm$core$Maybe$withDefault,
			'',
			$author$project$Api$Provider$Notification$All$shortDescription(notification)) === 'Custom Message') ? $author$project$Api$Provider$Notification$All$subjectHtml(notification) : $author$project$Api$Provider$Notification$All$shortDescriptionHtml(notification);
		var attemptedOrFailedAt = A2(
			$author$project$Utils$Maybe$orElse,
			$author$project$Api$Provider$Notification$All$failedAt(notification),
			$author$project$Api$Provider$Notification$All$attemptedAt(notification));
		return A2(
			$author$project$Ui$ListGroup$item,
			_List_fromArray(
				[$author$project$Ui$ListGroup$dashed]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							if (!attemptedOrFailedAt.$) {
								var dateTime = attemptedOrFailedAt.a;
								return $elm$html$Html$text(
									A2(timeFormatter, 0, dateTime));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v1 = $author$project$Api$Provider$Notification$All$failedAt(notification);
							if (!_v1.$) {
								return A2($author$project$Ui$Typography$text, _List_Nil, 'Attempted to send');
							} else {
								return A2($author$project$Ui$Typography$text, _List_Nil, 'Sent');
							}
						}(),
							$author$project$Utils$Html$noBreakSpace,
							A3(
							$author$project$Ui$Button$view,
							{
								mm: 'View email: ' + A2($elm$core$Maybe$withDefault, 'notification', description)
							},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$onClick(
									$author$project$Pages$Patients$PatientId_String$Notifications$Top$ViewNotification(notification))
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2($elm$core$Maybe$withDefault, '', description))
										]))
								])),
							$author$project$Utils$Html$noBreakSpace,
							function () {
							var _v2 = $author$project$Api$Provider$Notification$All$recipientEmail(notification);
							if (!_v2.$) {
								var email = _v2.a;
								return $author$project$Api$Phi$text(
									$author$project$Api$Phi$from('to ' + email));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						])),
					function () {
					var _v3 = $author$project$Api$Provider$Notification$All$failedAt(notification);
					if (!_v3.$) {
						return A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$Ui$Badge$fromString, _List_Nil, 'failed'),
									$author$project$Utils$Html$noBreakSpace,
									$author$project$Utils$FormErrors$viewError(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										$author$project$Api$Provider$Notification$All$errorMessage(notification)))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$small]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[$author$project$Utils$Html$noBreakSpace, $author$project$Utils$Html$noBreakSpace])),
							A2($author$project$Ui$Typography$text, _List_Nil, 'Patient clicked notification at:'),
							$author$project$Utils$Html$noBreakSpace,
							function () {
							var _v4 = $author$project$Api$Provider$Notification$All$clickedAt(notification);
							if (!_v4.$) {
								var dateTime = _v4.a;
								return A2(
									$author$project$Ui$Typography$text,
									_List_Nil,
									A2(timeFormatter, 4, dateTime));
							} else {
								return A2($author$project$Ui$Typography$text, _List_Nil, 'Never');
							}
						}()
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$small]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[$author$project$Utils$Html$noBreakSpace, $author$project$Utils$Html$noBreakSpace])),
							A2($author$project$Ui$Typography$text, _List_Nil, 'Patient opened notification at:'),
							$author$project$Utils$Html$noBreakSpace,
							function () {
							var _v5 = $author$project$Api$Provider$Notification$All$openedAt(notification);
							if (!_v5.$) {
								var dateTime = _v5.a;
								return A2(
									$author$project$Ui$Typography$text,
									_List_Nil,
									A2(timeFormatter, 4, dateTime));
							} else {
								return A2($author$project$Ui$Typography$text, _List_Nil, 'Unknown');
							}
						}()
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Notifications$Top$viewNotifications = F2(
	function (notifications, timeFormatter) {
		return A2(
			$author$project$Ui$ListGroup$view,
			_List_Nil,
			A2(
				$elm$core$List$map,
				$author$project$Pages$Patients$PatientId_String$Notifications$Top$viewNotification(timeFormatter),
				notifications));
	});
var $author$project$Pages$Patients$PatientId_String$Notifications$Top$view = function (_v0) {
	var notifications = _v0.tm;
	var timeFormatter = _v0.J7;
	var pagination = _v0.ajJ;
	var bouncedEmailReset = _v0.GI;
	var emailAddress = _v0.r7;
	var selectedNotification = _v0.pV;
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Notifications')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								function () {
								if (!emailAddress.$) {
									var emailAddress_ = emailAddress.a;
									return A2($author$project$Pages$Patients$PatientId_String$Notifications$Top$viewBouncedEmailAlert, emailAddress_, bouncedEmailReset);
								} else {
									return $elm$html$Html$text('');
								}
							}(),
								function () {
								if (notifications.$ === 3) {
									var notifications_ = notifications.a;
									return $elm$core$List$isEmpty(notifications_) ? A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('This patient has no notifications.')
											])) : A2($author$project$Pages$Patients$PatientId_String$Notifications$Top$viewNotifications, notifications_, timeFormatter);
								} else {
									return A2(
										$author$project$Ui$ListGroup$view,
										_List_Nil,
										A2($elm$core$List$repeat, 10, $author$project$Pages$Patients$PatientId_String$Notifications$Top$viewNotificationSkeleton));
								}
							}(),
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Patients$PatientId_String$Notifications$Top$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(
											!$author$project$Api$Data$isSuccess(notifications))
										]),
									pagination))
							]))
					])),
				function () {
				if (!selectedNotification.$) {
					var notification = selectedNotification.a;
					return $author$project$Pages$Patients$PatientId_String$Notifications$Top$viewEmailModal(notification);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]),
		ac9: 'Patient | Notifications'
	};
};
var $author$project$Pages$Patients$PatientId_String$Notifications$Top$page = $author$project$Spa$Page$applicationPatient(
	{ah_: $author$project$Pages$Patients$PatientId_String$Notifications$Top$init, aiq: $author$project$Pages$Patients$PatientId_String$Notifications$Top$load, k8: $author$project$Pages$Patients$PatientId_String$Notifications$Top$save, alO: $author$project$Pages$Patients$PatientId_String$Notifications$Top$subscriptions, adT: $author$project$Pages$Patients$PatientId_String$Notifications$Top$update, amo: $author$project$Pages$Patients$PatientId_String$Notifications$Top$view});
var $author$project$Pages$Patients$PatientId_String$Top$PopoverMsg = function (a) {
	return {$: 61, a: a};
};
var $author$project$Api$Provider$Patient$One$accountAccessSentAt = function (_v0) {
	var record = _v0.b;
	return record.KG;
};
var $author$project$Pages$Patients$PatientId_String$Top$GotEmailAddress = function (a) {
	return {$: 64, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$fetchEmailAddress = F2(
	function (apiClient, patientId) {
		return A3($author$project$Api$Provider$EmailAddress$retrieve, apiClient, patientId, $author$project$Pages$Patients$PatientId_String$Top$GotEmailAddress);
	});
var $author$project$Pages$Patients$PatientId_String$Top$GotIntegrationRecords = function (a) {
	return {$: 23, a: a};
};
var $author$project$Api$Provider$Patient$integrationRecords = F3(
	function (apiClient, patientId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$IntegrationRecord$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['integration_records']),
					$author$project$Api$Provider$Patient$patientPath(patientId))));
	});
var $author$project$Pages$Patients$PatientId_String$Top$fetchIntegrationRecords = F2(
	function (apiClient, patientId) {
		return A3($author$project$Api$Provider$Patient$integrationRecords, apiClient, patientId, $author$project$Pages$Patients$PatientId_String$Top$GotIntegrationRecords);
	});
var $author$project$Pages$Patients$PatientId_String$Top$GotMembershipPatients = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$MembershipPatient$ForPatientOne$MembershipPatient = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$MembershipPatient$ForPatientOne$Record = F7(
	function (billedThroughDate, nextBillDate, nextInvoiceDueDate, isSponsored, owner, company, plan) {
		return {ME: billedThroughDate, afQ: company, Vc: isSponsored, XP: nextBillDate, XT: nextInvoiceDueDate, YD: owner, Jb: plan};
	});
var $author$project$Api$Provider$MembershipPatient$ForPatientOne$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'plan',
	$author$project$Api$Provider$Plan$Min$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'company',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Company$Min$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'owner',
			$elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Min$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'is_sponsored',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'next_invoice_due_date',
					$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'next_bill_date',
						$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'billed_through_date',
							$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
							$elm$json$Json$Decode$succeed($author$project$Api$Provider$MembershipPatient$ForPatientOne$Record))))))));
var $author$project$Api$Provider$MembershipPatient$ForPatientOne$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$MembershipPatient$ForPatientOne$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$MembershipPatient$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$MembershipPatient$ForPatientOne$MembershipPatient)));
var $author$project$Api$Provider$Patient$MembershipPatient$membershipPatientsPath = function (patientId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['membership_patients']),
		$author$project$Api$Provider$Patient$patientPath(patientId));
};
var $author$project$Api$Provider$Patient$MembershipPatient$list = F3(
	function (apiClient, patientId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$MembershipPatient$ForPatientOne$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Patient$MembershipPatient$membershipPatientsPath(patientId)));
	});
var $author$project$Pages$Patients$PatientId_String$Top$fetchMembershipPatients = F2(
	function (apiClient, patientId) {
		return A3($author$project$Api$Provider$Patient$MembershipPatient$list, apiClient, patientId, $author$project$Pages$Patients$PatientId_String$Top$GotMembershipPatients);
	});
var $author$project$Pages$Patients$PatientId_String$Top$GotOutdatedDocuments = function (a) {
	return {$: 32, a: a};
};
var $author$project$Api$Provider$PatientDocument$All$PatientDocument = $elm$core$Basics$identity;
var $author$project$Api$Provider$PatientDocument$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PatientDocument$One$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Patient$PatientDocument$outdatedDocumentsPath = function (patientId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['outdated_signed_documents']),
		$author$project$Api$Provider$Patient$PatientDocument$patientDocumentsPath(patientId));
};
var $author$project$Api$Provider$Patient$PatientDocument$listOutdated = F3(
	function (apiClient, patientId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$PatientDocument$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Patient$PatientDocument$outdatedDocumentsPath(patientId)));
	});
var $author$project$Pages$Patients$PatientId_String$Top$fetchOutdatedPatientDocuments = F2(
	function (apiClient, patientId) {
		return A3($author$project$Api$Provider$Patient$PatientDocument$listOutdated, apiClient, patientId, $author$project$Pages$Patients$PatientId_String$Top$GotOutdatedDocuments);
	});
var $author$project$Pages$Patients$PatientId_String$Top$GotPackages = function (a) {
	return {$: 69, a: a};
};
var $author$project$Api$Provider$PatientPackage$patientPackagesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['patient_packages']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$PatientPackage$list = F3(
	function (apiClient, patientId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$PatientPackage$All$listDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2($author$project$Api$Param$string, 'patient_id', patientId)
					]),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$PatientPackage$patientPackagesPath)));
	});
var $author$project$Pages$Patients$PatientId_String$Top$fetchPackages = F2(
	function (apiClient, patientIdent) {
		return A3($author$project$Api$Provider$PatientPackage$list, apiClient, patientIdent, $author$project$Pages$Patients$PatientId_String$Top$GotPackages);
	});
var $author$project$Pages$Patients$PatientId_String$Top$GotDocuments = function (a) {
	return {$: 34, a: a};
};
var $author$project$Api$Provider$Patient$PatientDocument$list = F3(
	function (apiClient, patientId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$PatientDocument$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Patient$PatientDocument$patientDocumentsPath(patientId)));
	});
var $author$project$Pages$Patients$PatientId_String$Top$fetchPatientDocuments = F2(
	function (apiClient, patientId) {
		return A3($author$project$Api$Provider$Patient$PatientDocument$list, apiClient, patientId, $author$project$Pages$Patients$PatientId_String$Top$GotDocuments);
	});
var $author$project$Pages$Patients$PatientId_String$Top$GotPatientMceEligibilities = function (a) {
	return {$: 53, a: a};
};
var $author$project$Api$Provider$PatientMceEligibility$All$PatientMceEligibility = $elm$core$Basics$identity;
var $author$project$Api$Provider$PatientMceEligibility$Shared$PatientMceEligibility = $elm$core$Basics$identity;
var $author$project$Api$Provider$PatientMceEligibility$Shared$Record = F4(
	function (id, name, status, message) {
		return {ahP: id, aiH: message, Bq: name, alH: status};
	});
var $author$project$Api$Provider$PatientMceEligibility$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'message',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'status',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$PatientMceEligibility$Shared$Record)))));
var $author$project$Api$Provider$PatientMceEligibility$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PatientMceEligibility$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PatientMceEligibility$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PatientMceEligibility$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Patient$MceEligibility$mceEligibilitiesPath = function (patientId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['patient_mce_eligibilities']),
		$author$project$Api$Provider$Patient$patientPath(patientId));
};
var $author$project$Api$Provider$Patient$MceEligibility$list = F3(
	function (apiClient, patientId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$PatientMceEligibility$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Patient$MceEligibility$mceEligibilitiesPath(patientId)));
	});
var $author$project$Pages$Patients$PatientId_String$Top$fetchPatientMceEligibility = F3(
	function (client, practice, patientId) {
		return $elm$core$List$isEmpty(
			$author$project$Api$Provider$Practice$One$addons(practice)) ? $elm$core$Platform$Cmd$none : A3($author$project$Api$Provider$Patient$MceEligibility$list, client, patientId, $author$project$Pages$Patients$PatientId_String$Top$GotPatientMceEligibilities);
	});
var $author$project$Api$Provider$Patient$One$integrations = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$One$record_,
	function ($) {
		return $.Ud;
	});
var $author$project$Api$Provider$Patient$One$lastPortalAccessedAt = function (_v0) {
	var record = _v0.b;
	return record.VJ;
};
var $author$project$Api$Provider$Patient$One$requestPendingDocumentsAcceptanceSentAt = function (_v0) {
	var record = _v0.b;
	return record.$C;
};
var $author$project$Api$Provider$SyncDetail$CoveragePlan = 1;
var $author$project$Pages$Patients$PatientId_String$Top$GotAffiliateSyncDetail = function (a) {
	return {$: 65, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$retrieveSyncDetails = F2(
	function (apiClient, patientId) {
		return A4(
			$author$project$Api$Provider$SyncDetail$retrieveAffiliate,
			apiClient,
			patientId,
			function (d) {
				return _Utils_update(
					d,
					{
						HE: _List_fromArray(
							[0, 1])
					});
			},
			$author$project$Pages$Patients$PatientId_String$Top$GotAffiliateSyncDetail);
	});
var $author$project$Pages$Patients$PatientId_String$Top$init = F5(
	function (session, practice, patient, shared, _v0) {
		return _Utils_Tuple2(
			{
				l5: false,
				KG: $author$project$Api$Provider$Patient$One$accountAccessSentAt(patient),
				$8: $elm$core$Maybe$Nothing,
				dU: $elm$core$Maybe$Nothing,
				ii: $elm$core$Set$empty,
				w2: $author$project$Api$Data$Loading,
				Gv: shared.Gv,
				iw: A7(
					$author$project$Components$AuditTrailLog$init,
					session,
					shared.adY,
					shared.J7,
					$elm$core$Maybe$Just('patient'),
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$Patient$One$id(patient)),
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$Patient$One$createdAt(patient)),
					$elm$core$Maybe$Nothing),
				GI: false,
				OT: $elm$core$Maybe$Nothing,
				OV: $author$project$Api$Data$NotAsked,
				iW: $elm$core$Maybe$Nothing,
				dd: shared.dd,
				rR: $elm$core$Maybe$Nothing,
				jk: false,
				ju: $elm$core$Maybe$Nothing,
				gj: $elm$core$Maybe$Nothing,
				r7: $author$project$Api$Data$NotAsked,
				HC: $author$project$Api$Data$NotAsked,
				nO: false,
				ahJ: shared.ahJ,
				ahK: shared.ahK,
				sK: A2(
					$elm$core$List$map,
					function (_v1) {
						return false;
					},
					$author$project$Api$Provider$Patient$One$integrations(patient)),
				gy: _List_Nil,
				Ub: $author$project$Api$Data$NotAsked,
				Ij: $author$project$Shared$isHintAdmin(shared),
				VJ: $author$project$Api$Provider$Patient$One$lastPortalAccessedAt(patient),
				kf: $elm$core$Maybe$Nothing,
				kj: $elm$core$Set$empty,
				oC: $elm$core$List$isEmpty(
					$author$project$Api$Provider$Practice$One$addons(practice)) ? $author$project$Api$Data$NotAsked : $author$project$Api$Data$Loading,
				kk: $author$project$Api$Data$NotAsked,
				oD: false,
				WR: $author$project$Api$Data$Loading,
				XA: $elm$core$Maybe$Nothing,
				ty: false,
				tz: $author$project$Api$Data$Loading,
				dA: $author$project$Components$Patient$PackageDetailsModal$init,
				Cm: $author$project$Api$Data$Loading,
				YY: patient,
				oW: $author$project$Api$Data$Loading,
				CL: $author$project$Api$Provider$Patient$One$requestPayInfoSentAt(patient),
				tH: $author$project$Api$Provider$Patient$One$requestPendingDocumentsAcceptanceSentAt(patient),
				Dd: $author$project$Api$Data$NotAsked,
				aT: A3($author$project$Ui$Popover$init, 'engagement', false, $author$project$Pages$Patients$PatientId_String$Top$PopoverMsg),
				ZV: practice,
				pD: false,
				dI: _Utils_Tuple2(false, $elm$core$Maybe$Nothing),
				k1: false,
				pX: false,
				li: false,
				hA: false,
				aa4: session,
				uI: false,
				qb: false,
				hK: $author$project$Api$Provider$Patient$One$companyAccounts(patient),
				J7: A2($author$project$Formatters$Time$init, shared.J8, shared.af3),
				F0: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Maybe$map, $author$project$Components$PatientsList$urlParams, shared.ajU))
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$author$project$Pages$Patients$PatientId_String$Top$fetchMembershipPatients,
						shared.Gv,
						$author$project$Api$Provider$Patient$One$id(patient)),
						A2(
						$author$project$Pages$Patients$PatientId_String$Top$fetchIntegrationRecords,
						shared.Gv,
						$author$project$Api$Provider$Patient$One$id(patient)),
						A2(
						$author$project$Pages$Patients$PatientId_String$Top$fetchPatientDocuments,
						shared.Gv,
						$author$project$Api$Provider$Patient$One$id(patient)),
						A2(
						$author$project$Pages$Patients$PatientId_String$Top$fetchOutdatedPatientDocuments,
						shared.Gv,
						$author$project$Api$Provider$Patient$One$id(patient)),
						A3(
						$author$project$Pages$Patients$PatientId_String$Top$fetchPatientMceEligibility,
						shared.Gv,
						practice,
						$author$project$Api$Provider$Patient$One$id(patient)),
						A2(
						$author$project$Pages$Patients$PatientId_String$Top$fetchEmailAddress,
						shared.Gv,
						$author$project$Api$Provider$Patient$One$id(patient)),
						A2(
						$author$project$Pages$Patients$PatientId_String$Top$retrieveSyncDetails,
						shared.Gv,
						$author$project$Api$Provider$Patient$One$id(patient)),
						A2(
						$author$project$Pages$Patients$PatientId_String$Top$fetchPackages,
						shared.Gv,
						$author$project$Api$Provider$Patient$One$id(patient))
					])));
	});
var $author$project$Pages$Patients$PatientId_String$Top$load = F2(
	function (shared, model) {
		var _v0 = shared.G9;
		if (_v0.$ === 3) {
			var patient = _v0.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						Ij: $author$project$Shared$isHintAdmin(shared),
						YY: patient,
						hK: $author$project$Api$Provider$Patient$One$companyAccounts(patient)
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						Ij: $author$project$Shared$isHintAdmin(shared)
					}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Patients$PatientId_String$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Patients$PatientId_String$Top$AcceptEphiWaiverModalClosed = function (a) {
	return {$: 48, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$AddDependentModalMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$AddSponsorshipModalMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$AuditTrailLogMsg = function (a) {
	return {$: 58, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$ConfirmDetachPatientModalClicked = F2(
	function (a, b) {
		return {$: 36, a: a, b: b};
	});
var $author$project$Pages$Patients$PatientId_String$Top$ConfirmRestorePatientModalClicked = F2(
	function (a, b) {
		return {$: 20, a: a, b: b};
	});
var $author$project$Pages$Patients$PatientId_String$Top$CoveragePlanMsg = function (a) {
	return {$: 42, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$CreateMembershipModalMsg = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$EditCustomFormAnswerModalMsg = function (a) {
	return {$: 39, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$EditPartnerIdModalMsg = function (a) {
	return {$: 66, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$ElationForcePushConfirmationModalClosed = function (a) {
	return {$: 28, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$ManagePortalAccessModalMsg = function (a) {
	return {$: 63, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$MembershipDetailsModalClosed = {$: 41};
var $author$project$Pages$Patients$PatientId_String$Top$NetworkCoveragePlanMsg = function (a) {
	return {$: 43, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$PackageDetailsModalMsg = function (a) {
	return {$: 72, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$RemoveEphiWaiverModalClosed = function (a) {
	return {$: 49, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$RemoveSponsorshipModalClosed = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Pages$Patients$PatientId_String$Top$integrationRecordDropdownsSubscriptions = function (models) {
	return A2(
		$elm$core$List$map,
		function (model) {
			return $author$project$Ui$Dropdown$subscriptions(model);
		},
		models);
};
var $author$project$Components$Patient$AddDependentModal$Closed = {$: 0};
var $author$project$Components$Patient$AddDependentModal$DependentResourceFilterMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Patient$AddDependentModal$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				model.Yn ? $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Patient$AddDependentModal$Closed) : $elm$core$Platform$Sub$none,
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$ResourceFilter$Patient$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Components$Patient$AddDependentModal$DependentResourceFilterMsg)),
					model.ng))
			]));
};
var $author$project$Components$Patient$AddSponsorshipModal$Closed = {$: 0};
var $author$project$Components$Patient$AddSponsorshipModal$CompanyResourceFilterMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Patient$AddSponsorshipModal$SubscriberResourceFilterMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Patient$AddSponsorshipModal$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				model.Yn ? $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Patient$AddSponsorshipModal$Closed) : $elm$core$Platform$Sub$none,
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$ResourceFilter$Company$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Components$Patient$AddSponsorshipModal$CompanyResourceFilterMsg)),
					model.mZ)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$ResourceFilter$Patient$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Components$Patient$AddSponsorshipModal$SubscriberResourceFilterMsg)),
					model.lD))
			]));
};
var $author$project$Components$Patient$EditAthenaIdModal$Close = {$: 0};
var $author$project$Components$Patient$EditAthenaIdModal$subscriptions = function (_v0) {
	var model = _v0;
	return model.Yn ? $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Patient$EditAthenaIdModal$Close) : $elm$core$Platform$Sub$none;
};
var $author$project$Components$Patient$EditCustomFormAnswerModal$Close = {$: 0};
var $author$project$Components$Patient$EditCustomFormAnswerModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Patient$EditCustomFormAnswerModal$Close);
};
var $author$project$Components$Patient$ManagePortalAccessModal$Closed = {$: 0};
var $author$project$Components$Patient$ManagePortalAccessModal$subscriptions = function (_v0) {
	var model = _v0;
	return model.Yn ? $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Patient$ManagePortalAccessModal$Closed) : $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Patients$PatientId_String$Top$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$elm$core$Platform$Sub$batch(
				$author$project$Pages$Patients$PatientId_String$Top$integrationRecordDropdownsSubscriptions(model.gy)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Top$AddDependentModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Patient$AddDependentModal$subscriptions, model.$8))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Top$AddSponsorshipModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Patient$AddSponsorshipModal$subscriptions, model.dU))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Top$CreateMembershipModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Patient$CreateMembershipModal$subscriptions, model.iW))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Top$EditCustomFormAnswerModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Patient$EditCustomFormAnswerModal$subscriptions, model.gj))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Top$PackageDetailsModalMsg,
				$author$project$Components$Patient$PackageDetailsModal$subscriptions(model.dA)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Top$CoveragePlanMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Admin$CoveragePlans$Rules$subscriptions, model.OT))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Top$NetworkCoveragePlanMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Admin$CoveragePlans$Rules$subscriptions, model.XA))),
				model.oD ? $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Pages$Patients$PatientId_String$Top$MembershipDetailsModalClosed) : $elm$core$Platform$Sub$none,
				model.jk ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress(
				$author$project$Pages$Patients$PatientId_String$Top$ConfirmDetachPatientModalClicked(
					$author$project$Api$Provider$Patient$One$id(model.YY))) : $elm$core$Platform$Sub$none,
				model.k1 ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress(
				$author$project$Pages$Patients$PatientId_String$Top$ConfirmRestorePatientModalClicked(
					$author$project$Api$Provider$Patient$One$id(model.YY))) : $elm$core$Platform$Sub$none,
				model.nO ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Patients$PatientId_String$Top$ElationForcePushConfirmationModalClosed) : $elm$core$Platform$Sub$none,
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Patients$PatientId_String$Top$RemoveSponsorshipModalClosed),
					model.dI.b)),
				model.l5 ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Patients$PatientId_String$Top$AcceptEphiWaiverModalClosed) : $elm$core$Platform$Sub$none,
				model.pD ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Patients$PatientId_String$Top$RemoveEphiWaiverModalClosed) : $elm$core$Platform$Sub$none,
				$author$project$Components$AuditTrailLog$isOpen(model.iw) ? A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Top$AuditTrailLogMsg,
				$author$project$Components$AuditTrailLog$subscriptions(model.iw)) : $elm$core$Platform$Sub$none,
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Top$ManagePortalAccessModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Patient$ManagePortalAccessModal$subscriptions, model.kf))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Top$EditPartnerIdModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Patient$EditAthenaIdModal$subscriptions, model.ju)))
			]));
};
var $author$project$Pages$Patients$PatientId_String$Top$AddonRequestEmailSent = F2(
	function (a, b) {
		return {$: 55, a: a, b: b};
	});
var $author$project$Pages$Patients$PatientId_String$Top$BouncedEmailReset = function (a) {
	return {$: 68, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$DropdownMenuMsg = F2(
	function (a, b) {
		return {$: 22, a: a, b: b};
	});
var $author$project$Pages$Patients$PatientId_String$Top$GotEngagement = function (a) {
	return {$: 60, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$GotMembership = function (a) {
	return {$: 44, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$GotPayInfoUpdate = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$GotPendingDocsAcceptanceUpdate = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$MceActivationEmailSent = F2(
	function (a, b) {
		return {$: 57, a: a, b: b};
	});
var $author$project$Pages$Patients$PatientId_String$Top$PatientDetached = F2(
	function (a, b) {
		return {$: 37, a: a, b: b};
	});
var $author$project$Pages$Patients$PatientId_String$Top$PatientRestored = F2(
	function (a, b) {
		return {$: 21, a: a, b: b};
	});
var $author$project$Pages$Patients$PatientId_String$Top$EphiWaiverAccepted = function (a) {
	return {$: 50, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$acceptEphiWaiver = F2(
	function (apiClient, patientId) {
		return A3($author$project$Api$Provider$Patient$acceptHipaaAuthorization, apiClient, patientId, $author$project$Pages$Patients$PatientId_String$Top$EphiWaiverAccepted);
	});
var $author$project$Api$Provider$Patient$AccountAccess$accountAccessSentAt = function (_v0) {
	var record = _v0;
	return record.KG;
};
var $author$project$Api$Provider$IntegrationRecord$One$metadata = function (_v0) {
	var record = _v0.b;
	return record.W5;
};
var $author$project$Api$Provider$IntegrationRecord$One$athenaMetadata = function (record) {
	var _v0 = $author$project$Api$Provider$IntegrationRecord$One$metadata(record);
	if (!_v0.$) {
		var metadata_ = _v0.a;
		return $elm$core$Maybe$Just(metadata_);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$IntegrationRecord$All$athenaMetadata = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$IntegrationRecord$One$athenaMetadata(one);
};
var $author$project$Api$Provider$Patient$SyncDetail$coveragePlan = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$SyncDetail$record_,
	function ($) {
		return $.OT;
	});
var $author$project$Api$Provider$Patient$MceActivation$mceActivationsPath = function (patientId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['mce_activation']),
		$author$project$Api$Provider$Patient$patientPath(patientId));
};
var $author$project$Api$Provider$Patient$MceActivation$create = F4(
	function (apiClient, patientId, mcePracticeId, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'mce_practice_id',
					$elm$json$Json$Encode$string(mcePracticeId))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Patient$MceActivation$mceActivationsPath(patientId))));
	});
var $author$project$Pages$Patients$PatientId_String$Top$GotAccountAccessToken = function (a) {
	return {$: 74, a: a};
};
var $author$project$Api$Provider$Patient$AccountAccessToken$AccountAccessToken = $elm$core$Basics$identity;
var $author$project$Api$Provider$Patient$AccountAccessToken$Record = F2(
	function (token, url) {
		return {adi: token, adY: url};
	});
var $author$project$Api$Provider$Patient$AccountAccessToken$decoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'url',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'token',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$AccountAccessToken$Record))));
var $author$project$Api$Provider$Patient$AccountAccessToken$impersonate = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Patient$AccountAccessToken$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['account_access_tokens', 'impersonate']),
					$author$project$Api$Provider$Patient$patientPath(id_))));
	});
var $author$project$Pages$Patients$PatientId_String$Top$createAccountAccessToken = F2(
	function (apiClient, patient) {
		return A3(
			$author$project$Api$Provider$Patient$AccountAccessToken$impersonate,
			apiClient,
			$author$project$Api$Provider$Patient$One$id(patient),
			$author$project$Pages$Patients$PatientId_String$Top$GotAccountAccessToken);
	});
var $author$project$Api$Provider$Patient$disableSyncing = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['disable_syncing']),
					$author$project$Api$Provider$Patient$patientPath(id_))));
	});
var $author$project$Api$Provider$Patient$Shared$engagementStatus = function (_v0) {
	var shared = _v0;
	return shared.Ry;
};
var $author$project$Api$Provider$Patient$One$engagementStatus = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$engagementStatus(shared);
};
var $author$project$Pages$Patients$PatientId_String$Top$GotPlainSSN = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$fetchPlainSSN = F2(
	function (apiClient, patient) {
		return A3(
			$author$project$Api$Provider$SocialSecurityNumber$retrieve,
			apiClient,
			$author$project$Api$Provider$Patient$One$id(patient),
			$author$project$Pages$Patients$PatientId_String$Top$GotPlainSSN);
	});
var $author$project$Pages$Patients$PatientId_String$Top$ElationForcePushed = function (a) {
	return {$: 29, a: a};
};
var $author$project$Api$Provider$Patient$forcePushElation = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Patient$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['force_push_elation']),
					$author$project$Api$Provider$Patient$patientPath(id_))));
	});
var $author$project$Pages$Patients$PatientId_String$Top$forcePushElation = F2(
	function (apiClient, patientId) {
		return A3($author$project$Api$Provider$Patient$forcePushElation, apiClient, patientId, $author$project$Pages$Patients$PatientId_String$Top$ElationForcePushed);
	});
var $author$project$Api$Provider$CompanyRegistration$ForPatientOne$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyRegistration$Shared$id(shared);
};
var $author$project$Api$Provider$Integration$SharedWithInlinePartner$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Integration$Shared$id(shared);
};
var $author$project$Api$Provider$PatientMceEligibility$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$PatientMceEligibility$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PatientMceEligibility$Shared$id(shared);
};
var $author$project$Components$Patient$AddSponsorshipModal$Employee = 0;
var $author$project$Components$Patient$AddSponsorshipModal$Invalid = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Patient$AddSponsorshipModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Patient$AddSponsorshipModal$resetModel = F7(
	function (type_, apiClient, practice, patient, open_, usesEmployeeDivisions, requiresEmployeeDivisions) {
		if (!type_) {
			var _v1 = ($author$project$Api$Provider$Practice$One$companiesCount(practice) > 0) ? A2(
				$elm$core$Tuple$mapFirst,
				$elm$core$Maybe$Just,
				A2(
					$author$project$Components$ResourceFilter$Company$init,
					apiClient,
					function (d) {
						return _Utils_update(
							d,
							{Gp: 'Search for a company... ', aeQ: $elm$core$Maybe$Nothing});
					})) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
			var companyResourceFilter = _v1.a;
			var companyResourceFilterCmd = _v1.b;
			return _Utils_Tuple2(
				{
					mZ: companyResourceFilter,
					zr: $author$project$Api$Data$NotAsked,
					Yn: open_,
					YY: patient,
					ZV: practice,
					$F: requiresEmployeeDivisions,
					hx: $elm$core$Maybe$Nothing,
					dJ: $elm$core$Maybe$Nothing,
					fc: $elm$core$Maybe$Nothing,
					lh: $elm$core$Maybe$Nothing,
					uu: 0,
					alH: $author$project$Components$Patient$AddSponsorshipModal$Invalid($elm$core$Maybe$Nothing),
					lC: $elm$core$Maybe$Nothing,
					lD: $elm$core$Maybe$Nothing,
					ad6: usesEmployeeDivisions
				},
				A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$AddSponsorshipModal$CompanyResourceFilterMsg, companyResourceFilterCmd));
		} else {
			var _v2 = A2(
				$elm$core$Tuple$mapFirst,
				$elm$core$Maybe$Just,
				A2(
					$author$project$Components$ResourceFilter$Patient$init,
					apiClient,
					function (d) {
						return _Utils_update(
							d,
							{Gp: 'Search for a patient... ', aeQ: $elm$core$Maybe$Nothing});
					}));
			var patientResourceFilter = _v2.a;
			var patientResourceFilterCmd = _v2.b;
			return _Utils_Tuple2(
				{
					mZ: $elm$core$Maybe$Nothing,
					zr: $author$project$Api$Data$NotAsked,
					Yn: open_,
					YY: patient,
					ZV: practice,
					$F: requiresEmployeeDivisions,
					hx: $elm$core$Maybe$Nothing,
					dJ: $elm$core$Maybe$Nothing,
					fc: $elm$core$Maybe$Nothing,
					lh: $elm$core$Maybe$Nothing,
					uu: type_,
					alH: $author$project$Components$Patient$AddSponsorshipModal$Invalid($elm$core$Maybe$Nothing),
					lC: $elm$core$Maybe$Nothing,
					lD: patientResourceFilter,
					ad6: usesEmployeeDivisions
				},
				A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$AddSponsorshipModal$SubscriberResourceFilterMsg, patientResourceFilterCmd));
		}
	});
var $author$project$Components$Patient$AddSponsorshipModal$init = F3(
	function (apiClient, practice, patient) {
		return A7($author$project$Components$Patient$AddSponsorshipModal$resetModel, 0, apiClient, practice, patient, true, false, false);
	});
var $author$project$Api$Provider$CustomForm$answers = function (_v0) {
	var record = _v0;
	return record.rk;
};
var $author$project$Api$Provider$CustomForm$initEmptyAnswers = _List_fromArray(
	[
		{Qu: $elm$core$Maybe$Nothing, ahP: '', ac3: ''}
	]);
var $author$project$Api$Provider$CustomForm$questionId = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$CustomForm$questionType = function (_v0) {
	var record = _v0;
	return record.amg;
};
var $author$project$Api$Provider$CustomForm$title = function (_v0) {
	var record = _v0;
	return record.ac9;
};
var $author$project$Components$Patient$EditCustomFormAnswerModal$init = F4(
	function (patientId, question, formId, formResponseId) {
		var answers = $elm$core$List$isEmpty(
			$author$project$Api$Provider$CustomForm$answers(question)) ? $author$project$Api$Provider$CustomForm$initEmptyAnswers : $author$project$Api$Provider$CustomForm$answers(question);
		return _Utils_Tuple2(
			{
				rk: answers,
				HP: formId,
				HQ: $author$project$Api$Provider$CustomForm$questionId(question),
				zJ: formResponseId,
				YZ: patientId,
				ac9: $author$project$Api$Provider$CustomForm$title(question),
				amg: $author$project$Api$Provider$CustomForm$questionType(question)
			},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Api$Provider$Plan$SharedWithContractInfo$coveragePlan = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$coveragePlan(shared);
};
var $author$project$Pages$Patients$PatientId_String$Top$initCoveragePlanRules = F3(
	function (model, plan, coverageRuleUsages) {
		var _v0 = A2(
			$author$project$Api$Expandable$withDefault,
			$elm$core$Maybe$Nothing,
			$author$project$Api$Provider$Plan$SharedWithContractInfo$coveragePlan(plan));
		if (!_v0.$) {
			var coveragePlan = _v0.a;
			return A3(
				$elm$core$Tuple$mapBoth,
				$elm$core$Maybe$Just,
				$elm$core$Platform$Cmd$map($author$project$Pages$Patients$PatientId_String$Top$CoveragePlanMsg),
				A6(
					$author$project$Components$Admin$CoveragePlans$Rules$init,
					model.Gv,
					model.aa4,
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$CoveragePlan$One$id(coveragePlan)),
					$author$project$Api$Provider$CoveragePlan$One$coverageRules(coveragePlan),
					$elm$core$Maybe$Just(coverageRuleUsages),
					{_6: true}));
		} else {
			return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Patients$PatientId_String$Top$initNetworkCoveragePlanRules = F3(
	function (model, coveragePlan, coverageRuleUsages) {
		if (!coveragePlan.$) {
			var coveragePlan_ = coveragePlan.a;
			return A3(
				$elm$core$Tuple$mapBoth,
				$elm$core$Maybe$Just,
				$elm$core$Platform$Cmd$map($author$project$Pages$Patients$PatientId_String$Top$NetworkCoveragePlanMsg),
				A6(
					$author$project$Components$Admin$CoveragePlans$Rules$init,
					model.Gv,
					model.aa4,
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$CoveragePlan$One$id(coveragePlan_)),
					$author$project$Api$Provider$CoveragePlan$One$coverageRules(coveragePlan_),
					$elm$core$Maybe$Just(coverageRuleUsages),
					{_6: true}));
		} else {
			return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Api$Provider$IntegrationRecord$Shared$integrationRecordId = function (_v0) {
	var record = _v0;
	return record.Ua;
};
var $author$project$Api$Provider$IntegrationRecord$One$integrationRecordId = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$IntegrationRecord$Shared$integrationRecordId(shared);
};
var $author$project$Api$Provider$IntegrationRecord$All$integrationRecordId = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$IntegrationRecord$One$integrationRecordId(one);
};
var $author$project$Components$Patient$AddDependentModal$Adult = 0;
var $author$project$Components$Patient$AddDependentModal$Invalid = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Patient$AddDependentModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Patient$AddDependentModal$open = F4(
	function (apiClient, practice, patient, companyAccount) {
		var _v0 = ($author$project$Api$Provider$Practice$One$companiesCount(practice) > 0) ? A2(
			$elm$core$Tuple$mapFirst,
			$elm$core$Maybe$Just,
			A2(
				$author$project$Components$ResourceFilter$Patient$init,
				apiClient,
				function (d) {
					return _Utils_update(
						d,
						{Gp: 'Search for a dependent... ', aeQ: $elm$core$Maybe$Nothing});
				})) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
		var patientResourceFilter = _v0.a;
		var patientResourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{
				Ob: companyAccount,
				ng: patientResourceFilter,
				Yn: true,
				YY: patient,
				ZV: practice,
				ld: $elm$core$Maybe$Nothing,
				uu: 0,
				alH: $author$project$Components$Patient$AddDependentModal$Invalid($elm$core$Maybe$Nothing)
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$AddDependentModal$DependentResourceFilterMsg, patientResourceFilterCmd));
	});
var $author$project$Components$Patient$AddSponsorshipModal$open = function (_v0) {
	var model = _v0;
	return _Utils_update(
		model,
		{Yn: true});
};
var $author$project$Components$Patient$EditAthenaIdModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Patient$EditAthenaIdModal$open = F5(
	function (_v0, practice, integrationRecord, maybeMetadataRecord, patient) {
		var newLocalPatientId = function () {
			if (!maybeMetadataRecord.$) {
				var metadataRecord = maybeMetadataRecord.a;
				return A2($elm$core$Maybe$withDefault, '', metadataRecord.air);
			} else {
				return '';
			}
		}();
		return _Utils_Tuple2(
			{sL: integrationRecord, th: newLocalPatientId, Yn: true, YY: patient, ZV: practice, _r: false},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Components$Patient$ManagePortalAccessModal$Model = $elm$core$Basics$identity;
var $author$project$Api$Provider$EmailAddress$One$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Components$Patient$ManagePortalAccessModal$GotPatientEmails = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$PatientEmail$All$PatientEmail = $elm$core$Basics$identity;
var $author$project$Api$Provider$PatientEmail$All$Record = F3(
	function (id, portalEnabled, patient) {
		return {ahP: id, YY: patient, ZO: portalEnabled};
	});
var $author$project$Api$Provider$PatientEmail$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'patient',
	$author$project$Api$Provider$Patient$Min$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'portal_enabled',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$PatientEmail$All$Record))));
var $author$project$Api$Provider$PatientEmail$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PatientEmail$All$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PatientEmail$patientEmailsPath = function (emailAddressId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['patient_emails']),
		A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[emailAddressId]),
			A2(
				$author$project$Api$Data$pathAppend,
				_List_fromArray(
					['email_addresses']),
				$author$project$Api$Data$providerPath)));
};
var $author$project$Api$Provider$PatientEmail$retrieve = F3(
	function (apiClient, emailAddressId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$PatientEmail$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$PatientEmail$patientEmailsPath(emailAddressId)));
	});
var $author$project$Components$Patient$ManagePortalAccessModal$retrievePatientEmails = F2(
	function (apiClient, patientId) {
		return A3($author$project$Api$Provider$PatientEmail$retrieve, apiClient, patientId, $author$project$Components$Patient$ManagePortalAccessModal$GotPatientEmails);
	});
var $author$project$Components$Patient$ManagePortalAccessModal$open = F4(
	function (apiClient, practice, emailAddress, patient) {
		var emailAddressId = A2($elm$core$Maybe$map, $author$project$Api$Provider$EmailAddress$One$id, emailAddress);
		var cmd = function () {
			if (!emailAddressId.$) {
				var id = emailAddressId.a;
				return A2($author$project$Components$Patient$ManagePortalAccessModal$retrievePatientEmails, apiClient, id);
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		}();
		return _Utils_Tuple2(
			{Hy: emailAddressId, Yn: true, YY: patient, CJ: $author$project$Api$Data$NotAsked, oX: _List_Nil, ZV: practice, _r: false},
			cmd);
	});
var $author$project$Pages$Patients$PatientId_String$Top$IntegrationPushed = function (a) {
	return {$: 26, a: a};
};
var $author$project$Api$Provider$Patient$Integration$integrationsPath = function (patientId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['integrations']),
		A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[patientId]),
			A2(
				$author$project$Api$Data$pathAppend,
				_List_fromArray(
					['patients']),
				$author$project$Api$Data$providerPath)));
};
var $author$project$Api$Provider$Patient$Integration$integrationPath = F2(
	function (patientId, id_) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id_]),
			$author$project$Api$Provider$Patient$Integration$integrationsPath(patientId));
	});
var $author$project$Api$Provider$Patient$Integration$forcePush = F4(
	function (apiClient, patientId, integrationId, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['force_push']),
					A2($author$project$Api$Provider$Patient$Integration$integrationPath, patientId, integrationId))));
	});
var $author$project$Pages$Patients$PatientId_String$Top$pushIntegration = F3(
	function (apiClient, patientId, integrationId) {
		return A4($author$project$Api$Provider$Patient$Integration$forcePush, apiClient, patientId, integrationId, $author$project$Pages$Patients$PatientId_String$Top$IntegrationPushed);
	});
var $author$project$Pages$Patients$PatientId_String$Top$RemoveSponsorshipCompleted = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Pages$Patients$PatientId_String$Top$removeDependent = F3(
	function (apiClient, companyAccount, companyRegistrationId) {
		return A5(
			$author$project$Api$Provider$Company$Registration$delete,
			apiClient,
			$author$project$Api$Provider$Company$Min$id(
				$author$project$Api$Provider$CompanyAccount$ForPatient$company(companyAccount)),
			$author$project$Api$Provider$CompanyAccount$ForPatient$id(companyAccount),
			companyRegistrationId,
			$author$project$Pages$Patients$PatientId_String$Top$RemoveSponsorshipCompleted(
				$author$project$Api$Provider$CompanyAccount$ForPatient$id(companyAccount)));
	});
var $author$project$Pages$Patients$PatientId_String$Top$removeEmployee = F2(
	function (apiClient, companyAccount) {
		return A4(
			$author$project$Api$Provider$Company$Account$delete,
			apiClient,
			$author$project$Api$Provider$Company$Min$id(
				$author$project$Api$Provider$CompanyAccount$ForPatient$company(companyAccount)),
			$author$project$Api$Provider$CompanyAccount$ForPatient$id(companyAccount),
			$author$project$Pages$Patients$PatientId_String$Top$RemoveSponsorshipCompleted(
				$author$project$Api$Provider$CompanyAccount$ForPatient$id(companyAccount)));
	});
var $author$project$Pages$Patients$PatientId_String$Top$EphiWaiverRemoved = function (a) {
	return {$: 51, a: a};
};
var $author$project$Api$Provider$Patient$removeHipaaAuthorization = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Patient$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['remove_hipaa_authorization']),
					$author$project$Api$Provider$Patient$patientPath(id_))));
	});
var $author$project$Pages$Patients$PatientId_String$Top$removeEphiWaiver = F2(
	function (apiClient, patientId) {
		return A3($author$project$Api$Provider$Patient$removeHipaaAuthorization, apiClient, patientId, $author$project$Pages$Patients$PatientId_String$Top$EphiWaiverRemoved);
	});
var $author$project$Api$Provider$Patient$RequestPendingDocumentsAcceptanceOne$RequestPendingDocumentsAcceptance = $elm$core$Basics$identity;
var $author$project$Api$Provider$Patient$RequestPendingDocumentsAcceptanceOne$Record = function (requestPendingDocumentsAcceptanceSentAt) {
	return {$C: requestPendingDocumentsAcceptanceSentAt};
};
var $author$project$Api$Provider$Patient$RequestPendingDocumentsAcceptanceOne$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'request_pending_documents_acceptance_sent_at',
	$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$RequestPendingDocumentsAcceptanceOne$Record));
var $author$project$Api$Provider$Patient$RequestPendingDocumentsAcceptanceOne$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Patient$RequestPendingDocumentsAcceptanceOne$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Patient$PatientDocument$requestPendingDocumentsAcceptance = F3(
	function (apiClient, patientId, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Patient$RequestPendingDocumentsAcceptanceOne$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['request_acceptance']),
					$author$project$Api$Provider$Patient$PatientDocument$patientDocumentsPath(patientId))));
	});
var $author$project$Api$Provider$Patient$RequestPendingDocumentsAcceptanceOne$requestPendingDocumentsAcceptanceSentAt = function (_v0) {
	var record = _v0;
	return record.$C;
};
var $author$project$Api$Provider$Patient$resetBouncedEmail = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['reset_bounced_email']),
					$author$project$Api$Provider$Patient$patientPath(id_))));
	});
var $author$project$Api$Provider$Patient$restore = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Patient$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['restore']),
					$author$project$Api$Provider$Patient$patientPath(id_))));
	});
var $author$project$Api$Provider$Patient$Engagement$Engagement = $elm$core$Basics$identity;
var $author$project$Api$Provider$Patient$Engagement$Record = F2(
	function (lastEngagementDate, invoice) {
		return {Uk: invoice, VF: lastEngagementDate};
	});
var $author$project$Api$Provider$Patient$Engagement$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'invoice',
	$elm$json$Json$Decode$nullable($author$project$Api$Common$Payable$Invoice$MinWithOwner$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'last_engagement_date',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$Engagement$Record)));
var $author$project$Api$Provider$Patient$Engagement$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Patient$Engagement$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Patient$Engagement$retrieve = F3(
	function (apiClient, patientId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Patient$Engagement$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['engagement']),
					$author$project$Api$Provider$Patient$patientPath(patientId))));
	});
var $author$project$Pages$Patients$PatientId_String$Top$GotCoverageRuleUsages = function (a) {
	return {$: 45, a: a};
};
var $author$project$Api$Provider$CoverageRuleUsage$coverageRuleUsagePath = function (membershipPatientId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['coverage_rule_usage']),
		A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				['membership_patients', membershipPatientId]),
			$author$project$Api$Data$providerPath));
};
var $author$project$Api$Provider$CoverageRuleUsage$All$CoverageRuleUsage = $elm$core$Basics$identity;
var $author$project$Api$Provider$CoverageRuleUsage$Shared$CoverageRuleUsage = $elm$core$Basics$identity;
var $author$project$Api$Provider$CoverageRuleUsage$Shared$Record = F4(
	function (coverageRule, coveredCharges, remainingItems, remainingItemsUntil) {
		return {OU: coverageRule, OX: coveredCharges, $r: remainingItems, $s: remainingItemsUntil};
	});
var $author$project$Api$Provider$CoveredCharge$Min$CoveredCharge = $elm$core$Basics$identity;
var $author$project$Api$Provider$CoveredCharge$Min$Record = F3(
	function (id, quantity, coveredDate) {
		return {OY: coveredDate, ahP: id, Dz: quantity};
	});
var $author$project$Api$Provider$CoveredCharge$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'covered_date',
	$author$project$Utils$Date$decode,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'quantity',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$CoveredCharge$Min$Record))));
var $author$project$Api$Provider$CoveredCharge$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CoveredCharge$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CoverageRuleUsage$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'remaining_items_until',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'remaining_items',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'covered_charges',
			$elm$json$Json$Decode$list($author$project$Api$Provider$CoveredCharge$Min$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'coverage_rule',
				$author$project$Api$Provider$CoverageRule$One$decoder,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$CoverageRuleUsage$Shared$Record)))));
var $author$project$Api$Provider$CoverageRuleUsage$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CoverageRuleUsage$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CoverageRuleUsage$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CoverageRuleUsage$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CoverageRuleUsage$list = F3(
	function (apiClient, membershipPatientId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$CoverageRuleUsage$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$CoverageRuleUsage$coverageRuleUsagePath(membershipPatientId)));
	});
var $author$project$Pages$Patients$PatientId_String$Top$retrieveCoverageRuleUsages = F2(
	function (apiClient, membershipPatientId) {
		return A3($author$project$Api$Provider$CoverageRuleUsage$list, apiClient, membershipPatientId, $author$project$Pages$Patients$PatientId_String$Top$GotCoverageRuleUsages);
	});
var $author$project$Pages$Patients$PatientId_String$Top$retrieveMembership = F3(
	function (apiClient, membershipId, toMsg) {
		return A4(
			$author$project$Api$Provider$Membership$retrieve,
			apiClient,
			membershipId,
			_List_fromArray(
				[0]),
			toMsg);
	});
var $author$project$Pages$Patients$PatientId_String$Top$AccessLinkSent = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Patient$AccountAccess$Patient = $elm$core$Basics$identity;
var $author$project$Api$Provider$Patient$AccountAccess$Record = function (accountAccessSentAt) {
	return {KG: accountAccessSentAt};
};
var $author$project$Api$Provider$Patient$AccountAccess$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'account_access_sent_at',
	$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$AccountAccess$Record));
var $author$project$Api$Provider$Patient$AccountAccess$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Patient$AccountAccess$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Patient$requestAccountAccess = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Patient$AccountAccess$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['account_access']),
					$author$project$Api$Provider$Patient$patientPath(id_))));
	});
var $author$project$Pages$Patients$PatientId_String$Top$sendAccountAccess = F2(
	function (apiClient, patient) {
		return A3(
			$author$project$Api$Provider$Patient$requestAccountAccess,
			apiClient,
			$author$project$Api$Provider$Patient$One$id(patient),
			$author$project$Pages$Patients$PatientId_String$Top$AccessLinkSent);
	});
var $author$project$Api$Provider$AddonRequest$addonRequestsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['addon_requests']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$AddonRequest$addonRequestPath = function (addonId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[addonId]),
		$author$project$Api$Provider$AddonRequest$addonRequestsPath);
};
var $author$project$Api$Provider$AddonRequest$sendEmail = F4(
	function (apiClient, addonId, patientId, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'patient_id',
					$elm$json$Json$Encode$string(patientId))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['send_email']),
						$author$project$Api$Provider$AddonRequest$addonRequestPath(addonId)))));
	});
var $author$project$Pages$Patients$PatientId_String$Top$IntegrationUnlinked = function (a) {
	return {$: 25, a: a};
};
var $author$project$Api$Provider$Patient$Integration$unlink = F4(
	function (apiClient, patientId, integrationId, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$IntegrationRecord$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['unlink']),
					A2($author$project$Api$Provider$Patient$Integration$integrationPath, patientId, integrationId))));
	});
var $author$project$Pages$Patients$PatientId_String$Top$unlinkIntegration = F3(
	function (apiClient, patientId, integrationId) {
		return A4($author$project$Api$Provider$Patient$Integration$unlink, apiClient, patientId, integrationId, $author$project$Pages$Patients$PatientId_String$Top$IntegrationUnlinked);
	});
var $author$project$Components$Patient$AddDependentModal$CreatedCompanyRegistration = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Company$Registration$encodeCreateParams = function (_v0) {
	var type_ = _v0.amg;
	var patientId = _v0.YZ;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'registration',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string(type_)),
							_Utils_Tuple2(
							'patient',
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'id',
										$elm$json$Json$Encode$string(patientId))
									])))
						])))
			]));
};
var $author$project$Components$Patient$AddDependentModal$typeToCode = function (t) {
	if (!t) {
		return 'spouse';
	} else {
		return 'child';
	}
};
var $author$project$Components$Patient$AddDependentModal$createCompanyRegistration = F5(
	function (apiClient, companyId, companyAccountId, patientId, type_) {
		var params = {
			YZ: patientId,
			amg: $author$project$Components$Patient$AddDependentModal$typeToCode(type_)
		};
		var encodedParams = $author$project$Api$Provider$Company$Registration$encodeCreateParams(params);
		return A5($author$project$Api$Provider$Company$Registration$create, apiClient, companyId, companyAccountId, encodedParams, $author$project$Components$Patient$AddDependentModal$CreatedCompanyRegistration);
	});
var $author$project$Components$Patient$AddDependentModal$GotDependent = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Patient$AddDependentModal$fetchPatient = F2(
	function (token, patientId) {
		return A3($author$project$Api$Provider$Patient$retrieve, token, patientId, $author$project$Components$Patient$AddDependentModal$GotDependent);
	});
var $author$project$Components$Patient$AddDependentModal$Child = 1;
var $author$project$Components$Patient$AddDependentModal$typeFromLabel = function (str) {
	if (str === 'Adult') {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$Components$Patient$AddDependentModal$Valid = {$: 0};
var $author$project$Components$Patient$AddDependentModal$findCompanyAccountForSameCompanyAndSubscriber = F3(
	function (accounts, companyId, patientId) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (account) {
					return _Utils_eq(
						$author$project$Api$Provider$Company$Min$id(
							$author$project$Api$Provider$CompanyAccount$ForPatient$company(account)),
						companyId) && _Utils_eq(
						A2(
							$elm$core$Maybe$map,
							$author$project$Api$Provider$Patient$Min$id,
							$author$project$Api$Provider$CompanyAccount$ForPatient$subscriber(account)),
						$elm$core$Maybe$Just(patientId));
				},
				accounts));
	});
var $author$project$Components$Patient$AddDependentModal$validateModel = function (model) {
	var status = function () {
		var _v0 = model.ld;
		if (_v0.$ === 1) {
			return $author$project$Components$Patient$AddDependentModal$Invalid($elm$core$Maybe$Nothing);
		} else {
			var dependent = _v0.a;
			var accounts = $author$project$Api$Provider$Patient$One$companyAccounts(dependent);
			var existingCompanyAccount = A3(
				$author$project$Components$Patient$AddDependentModal$findCompanyAccountForSameCompanyAndSubscriber,
				accounts,
				$author$project$Api$Provider$Company$Min$id(
					$author$project$Api$Provider$CompanyAccount$ForPatient$company(model.Ob)),
				$author$project$Api$Provider$Patient$One$id(model.YY));
			if (!existingCompanyAccount.$) {
				var subscriberName = $author$project$Api$Provider$Patient$One$name(model.YY);
				var dependentName = $author$project$Api$Provider$Patient$One$name(dependent);
				var companyName = $author$project$Api$Provider$Company$Min$name(
					$author$project$Api$Provider$CompanyAccount$ForPatient$company(model.Ob));
				return $author$project$Components$Patient$AddDependentModal$Invalid(
					$elm$core$Maybe$Just(
						A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('alert'),
									$elm$html$Html$Attributes$class('alert-warning')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('It looks like ' + (dependentName + (' is already linked with ' + (companyName + (', through ' + (subscriberName + '.'))))))
								]))));
			} else {
				return $author$project$Components$Patient$AddDependentModal$Valid;
			}
		}
	}();
	return _Utils_update(
		model,
		{alH: status});
};
var $author$project$Components$Patient$AddDependentModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return {
					GZ: $elm$core$Platform$Cmd$none,
					aiO: _Utils_update(
						model,
						{Yn: false}),
					aR: _List_Nil
				};
			case 1:
				var command = function () {
					var _v2 = model.ld;
					if (!_v2.$) {
						var dependent = _v2.a;
						return A5(
							$author$project$Components$Patient$AddDependentModal$createCompanyRegistration,
							apiClient,
							$author$project$Api$Provider$Company$Min$id(
								$author$project$Api$Provider$CompanyAccount$ForPatient$company(model.Ob)),
							$author$project$Api$Provider$CompanyAccount$ForPatient$id(model.Ob),
							$author$project$Api$Provider$Patient$One$id(dependent),
							model.uu);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return {GZ: command, aiO: model, aR: _List_Nil};
			case 2:
				var type_ = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					aiO: _Utils_update(
						model,
						{
							uu: $author$project$Components$Patient$AddDependentModal$typeFromLabel(type_)
						}),
					aR: _List_Nil
				};
			case 3:
				var subMsg = msg.a;
				var _v3 = model.ng;
				if (!_v3.$) {
					var subscriberResourceFilter = _v3.a;
					var patientResourceResult = A3($author$project$Components$ResourceFilter$Patient$update, apiClient, subMsg, subscriberResourceFilter);
					var _v4 = function () {
						var _v5 = patientResourceResult.agZ;
						if (!_v5.$) {
							return _Utils_Tuple2(
								$elm$core$Maybe$Nothing,
								A2(
									$elm$core$Maybe$withDefault,
									$elm$core$Platform$Cmd$none,
									A2(
										$elm$core$Maybe$map,
										$author$project$Components$Patient$AddDependentModal$fetchPatient(apiClient),
										$author$project$Components$ResourceFilter$Patient$value(patientResourceResult.aiO))));
						} else {
							return _Utils_Tuple2(model.ld, $elm$core$Platform$Cmd$none);
						}
					}();
					var selectedDependent = _v4.a;
					var fetchPatientCmd = _v4.b;
					var commands = _List_fromArray(
						[
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$AddDependentModal$DependentResourceFilterMsg, patientResourceResult.GZ),
							fetchPatientCmd
						]);
					var newModel = $author$project$Components$Patient$AddDependentModal$validateModel(
						_Utils_update(
							model,
							{
								ng: $elm$core$Maybe$Just(patientResourceResult.aiO),
								ld: selectedDependent
							}));
					return {
						GZ: $elm$core$Platform$Cmd$batch(commands),
						aiO: newModel,
						aR: patientResourceResult.aR
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, aiO: model, aR: _List_Nil};
				}
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						aiO: _Utils_update(
							model,
							{Yn: false}),
						aR: _List_fromArray(
							[
								$author$project$OutMsg$RetrievePatient(
								$author$project$Api$Provider$Patient$One$id(model.YY))
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						aiO: model,
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var pat = response.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						aiO: $author$project$Components$Patient$AddDependentModal$validateModel(
							_Utils_update(
								model,
								{
									ld: $elm$core$Maybe$Just(pat)
								})),
						aR: _List_Nil
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, aiO: model, aR: _List_Nil};
				}
		}
	});
var $author$project$Components$Patient$AddSponsorshipModal$CreatedCompanyAccount = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Api$Provider$Company$Account$encodeCreateParams = function (_v0) {
	var divisionId = _v0.QP;
	var type_ = _v0.amg;
	var patientId = _v0.YZ;
	var encodePatient = function (patId) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'patient',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'id',
								$elm$json$Json$Encode$string(patId))
							])))
				]));
	};
	var encodeRegistrations = function (patId) {
		return A2(
			$elm$json$Json$Encode$list,
			encodePatient,
			_List_fromArray(
				[patId]));
	};
	var encodeDivision = function (divId) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(divId))
				]));
	};
	var add = F2(
		function (item, list_) {
			return _Utils_ap(
				list_,
				_List_fromArray(
					[item]));
		});
	var maybeAdd = F2(
		function (_v2, list_) {
			var key = _v2.a;
			var item = _v2.b;
			if (!item.$) {
				var item_ = item.a;
				return A2(
					add,
					_Utils_Tuple2(key, item_),
					list_);
			} else {
				return list_;
			}
		});
	return function (fields) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'account',
					$elm$json$Json$Encode$object(fields))
				]));
	}(
		A2(
			maybeAdd,
			_Utils_Tuple2(
				'division',
				A2($elm$core$Maybe$map, encodeDivision, divisionId)),
			A2(
				maybeAdd,
				_Utils_Tuple2(
					'registrations',
					A2($elm$core$Maybe$map, encodeRegistrations, patientId)),
				A2(
					maybeAdd,
					_Utils_Tuple2(
						'type',
						A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, type_)),
					_List_Nil))));
};
var $author$project$Components$Patient$AddSponsorshipModal$createCompanyAccount = F4(
	function (token, companyId, divisionId, patientId) {
		var params = {
			QP: divisionId,
			YZ: $elm$core$Maybe$Just(patientId),
			amg: $elm$core$Maybe$Just('employee')
		};
		var encodedParams = $author$project$Api$Provider$Company$Account$encodeCreateParams(params);
		return A4(
			$author$project$Api$Provider$Company$Account$create,
			token,
			$author$project$Api$Provider$Company$companyPath(companyId),
			encodedParams,
			$author$project$Components$Patient$AddSponsorshipModal$CreatedCompanyAccount(companyId));
	});
var $author$project$Components$Patient$AddSponsorshipModal$CreatedCompanyRegistration = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Patient$AddSponsorshipModal$typeToCode = function (t) {
	switch (t) {
		case 0:
			return 'employee';
		case 1:
			return 'spouse';
		default:
			return 'child';
	}
};
var $author$project$Components$Patient$AddSponsorshipModal$createCompanyRegistration = F5(
	function (token, companyId, companyAccountId, patientId, type_) {
		var params = {
			YZ: patientId,
			amg: $author$project$Components$Patient$AddSponsorshipModal$typeToCode(type_)
		};
		var encodedParams = $author$project$Api$Provider$Company$Registration$encodeCreateParams(params);
		return A5($author$project$Api$Provider$Company$Registration$create, token, companyId, companyAccountId, encodedParams, $author$project$Components$Patient$AddSponsorshipModal$CreatedCompanyRegistration);
	});
var $author$project$Components$Patient$AddSponsorshipModal$GotAccountDivisions = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Patient$AddSponsorshipModal$fetchAccountDivisions = F2(
	function (token, companyId) {
		return A4(
			$author$project$Api$Provider$Company$EmployeeDivision$list,
			token,
			companyId,
			function (d) {
				return d;
			},
			$author$project$Components$Patient$AddSponsorshipModal$GotAccountDivisions);
	});
var $author$project$Components$Patient$AddSponsorshipModal$GotSubscriber = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Patient$AddSponsorshipModal$fetchPatient = F2(
	function (token, patientId) {
		return A3($author$project$Api$Provider$Patient$retrieve, token, patientId, $author$project$Components$Patient$AddSponsorshipModal$GotSubscriber);
	});
var $author$project$Api$Provider$Company$All$requiresEmployeeDivisions = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$requiresEmployeeDivisions(shared);
};
var $author$project$Components$ResourceFilter$Company$requiresEmployeeDivisions = $author$project$Api$Provider$Company$All$requiresEmployeeDivisions;
var $author$project$Components$Patient$AddSponsorshipModal$Adult = 1;
var $author$project$Components$Patient$AddSponsorshipModal$Child = 2;
var $author$project$Components$Patient$AddSponsorshipModal$typeFromLabel = function (str) {
	switch (str) {
		case 'Adult':
			return 1;
		case 'Child':
			return 2;
		default:
			return 0;
	}
};
var $author$project$Api$Provider$Company$All$usesEmployeeDivisions = function (_v0) {
	var record = _v0.b;
	return record.ad6;
};
var $author$project$Components$ResourceFilter$Company$usesEmployeeDivisions = $author$project$Api$Provider$Company$All$usesEmployeeDivisions;
var $author$project$Components$Patient$AddSponsorshipModal$Valid = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Patient$AddSponsorshipModal$findCompanyAccount = F2(
	function (accounts, companyAccountId) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (account) {
					return _Utils_eq(
						$author$project$Api$Provider$CompanyAccount$ForPatient$id(account),
						companyAccountId);
				},
				accounts));
	});
var $author$project$Components$Patient$AddSponsorshipModal$validateDependentModel = function (model) {
	var hasNoAccountsWarning = function (subscriber) {
		return A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('alert'),
					$elm$html$Html$Attributes$class('alert-warning')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Api$Provider$Patient$One$name(subscriber) + ' is not an employee at a company. Visit their page '),
					A3(
					$author$project$Ui$Link$route,
					$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
						{
							YZ: $author$project$Api$Provider$Patient$One$id(subscriber)
						}),
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('here')
						])),
					$elm$html$Html$text(' to add employment.')
				]));
	};
	var _v0 = _Utils_Tuple2(model.lh, model.hx);
	if (_v0.a.$ === 1) {
		var _v1 = _v0.a;
		return $author$project$Components$Patient$AddSponsorshipModal$Invalid($elm$core$Maybe$Nothing);
	} else {
		if (_v0.b.$ === 1) {
			var subscriber = _v0.a.a;
			var _v2 = _v0.b;
			return $author$project$Components$Patient$AddSponsorshipModal$Invalid(
				$elm$core$Maybe$Just(
					hasNoAccountsWarning(subscriber)));
		} else {
			var subscriber = _v0.a.a;
			var companyAccountId = _v0.b.a;
			var _v3 = function () {
				var _v4 = model.lC;
				if (!_v4.$) {
					var ownedAccounts = _v4.a;
					if ($elm$core$List$isEmpty(ownedAccounts)) {
						return _Utils_Tuple2(true, $elm$core$Maybe$Nothing);
					} else {
						var found = A2(
							$author$project$Components$Patient$AddSponsorshipModal$findCompanyAccount,
							$author$project$Api$Provider$Patient$One$companyAccounts(model.YY),
							companyAccountId);
						return _Utils_Tuple2(false, found);
					}
				} else {
					return _Utils_Tuple2(false, $elm$core$Maybe$Nothing);
				}
			}();
			var hasNoAccounts = _v3.a;
			var maybeAlreadyRegisteredOn = _v3.b;
			if (hasNoAccounts) {
				return $author$project$Components$Patient$AddSponsorshipModal$Invalid(
					$elm$core$Maybe$Just(
						hasNoAccountsWarning(subscriber)));
			} else {
				var subscriberName = $author$project$Api$Provider$Patient$One$name(subscriber);
				var patientName = $author$project$Api$Provider$Patient$One$name(model.YY);
				if (!maybeAlreadyRegisteredOn.$) {
					var companyAccount = maybeAlreadyRegisteredOn.a;
					return $author$project$Components$Patient$AddSponsorshipModal$Invalid(
						$elm$core$Maybe$Just(
							A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('alert'),
										$elm$html$Html$Attributes$class('alert-warning')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										'It looks like ' + (patientName + (' is already linked with ' + ($author$project$Api$Provider$Company$Min$name(
											$author$project$Api$Provider$CompanyAccount$ForPatient$company(companyAccount)) + (', through ' + (subscriberName + '.'))))))
									]))));
				} else {
					var companyName = A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							$author$project$Api$Provider$Company$Min$name,
							A2(
								$elm$core$Maybe$map,
								$author$project$Api$Provider$CompanyAccount$ForPatient$company,
								$elm$core$List$head(
									A2(
										$elm$core$List$filter,
										function (account) {
											return _Utils_eq(
												$author$project$Api$Provider$CompanyAccount$ForPatient$id(account),
												companyAccountId);
										},
										$author$project$Api$Provider$Patient$One$companyAccounts(subscriber))))));
					return $author$project$Components$Patient$AddSponsorshipModal$Valid(
						$elm$core$Maybe$Just(
							A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('alert'),
										$elm$html$Html$Attributes$class('alert-info')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(patientName + (' will be added to ' + (companyName + (', through ' + (subscriberName + '\'s account.')))))
									]))));
				}
			}
		}
	}
};
var $author$project$Components$Patient$AddSponsorshipModal$findCompanyAccountForSameCompanyAndSubscriber = F3(
	function (accounts, companyId, patientId) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (account) {
					return _Utils_eq(
						$author$project$Api$Provider$Company$Min$id(
							$author$project$Api$Provider$CompanyAccount$ForPatient$company(account)),
						companyId) && _Utils_eq(
						A2(
							$elm$core$Maybe$map,
							$author$project$Api$Provider$Patient$Min$id,
							$author$project$Api$Provider$CompanyAccount$ForPatient$subscriber(account)),
						$elm$core$Maybe$Just(patientId));
				},
				accounts));
	});
var $author$project$Components$Patient$AddSponsorshipModal$validateEmployeeModel = function (model) {
	var _v0 = model.dJ;
	if (!_v0.$) {
		var selectedCompanyId = _v0.a;
		var accounts = $author$project$Api$Provider$Patient$One$companyAccounts(model.YY);
		var alreadyRegistered = A3(
			$author$project$Components$Patient$AddSponsorshipModal$findCompanyAccountForSameCompanyAndSubscriber,
			accounts,
			selectedCompanyId,
			$author$project$Api$Provider$Patient$One$id(model.YY));
		if (!alreadyRegistered.$) {
			var companyAccount = alreadyRegistered.a;
			var patientName = $author$project$Api$Provider$Patient$One$name(model.YY);
			return $author$project$Components$Patient$AddSponsorshipModal$Invalid(
				$elm$core$Maybe$Just(
					A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('alert'),
								$elm$html$Html$Attributes$class('alert-warning')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								'It looks like ' + (patientName + (' is already linked with ' + $author$project$Api$Provider$Company$Min$name(
									$author$project$Api$Provider$CompanyAccount$ForPatient$company(companyAccount)))))
							]))));
		} else {
			return $author$project$Components$Patient$AddSponsorshipModal$Valid($elm$core$Maybe$Nothing);
		}
	} else {
		return $author$project$Components$Patient$AddSponsorshipModal$Invalid($elm$core$Maybe$Nothing);
	}
};
var $author$project$Components$Patient$AddSponsorshipModal$validateModel = function (model) {
	var status = function () {
		var _v0 = model.uu;
		if (!_v0) {
			return $author$project$Components$Patient$AddSponsorshipModal$validateEmployeeModel(model);
		} else {
			return $author$project$Components$Patient$AddSponsorshipModal$validateDependentModel(model);
		}
	}();
	return _Utils_update(
		model,
		{alH: status});
};
var $author$project$Components$Patient$AddSponsorshipModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var _v2 = A7($author$project$Components$Patient$AddSponsorshipModal$resetModel, 0, apiClient, model.ZV, model.YY, false, model.ad6, model.$F);
				var newModel = _v2.a;
				var cmd = _v2.b;
				return {GZ: cmd, aiO: newModel, aR: _List_Nil};
			case 1:
				var _v3 = model.uu;
				if (!_v3) {
					var command = function () {
						var _v4 = model.dJ;
						if (!_v4.$) {
							var companyId = _v4.a;
							return A4(
								$author$project$Components$Patient$AddSponsorshipModal$createCompanyAccount,
								apiClient,
								companyId,
								model.fc,
								$author$project$Api$Provider$Patient$One$id(model.YY));
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}();
					return {GZ: command, aiO: model, aR: _List_Nil};
				} else {
					var type_ = _v3;
					var command = function () {
						var _v5 = _Utils_Tuple2(model.dJ, model.hx);
						if ((!_v5.a.$) && (!_v5.b.$)) {
							var companyId = _v5.a.a;
							var companyAccountId = _v5.b.a;
							return A5(
								$author$project$Components$Patient$AddSponsorshipModal$createCompanyRegistration,
								apiClient,
								companyId,
								companyAccountId,
								$author$project$Api$Provider$Patient$One$id(model.YY),
								type_);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}();
					return {GZ: command, aiO: model, aR: _List_Nil};
				}
			case 2:
				var type_ = msg.a;
				var _v6 = A7(
					$author$project$Components$Patient$AddSponsorshipModal$resetModel,
					$author$project$Components$Patient$AddSponsorshipModal$typeFromLabel(type_),
					apiClient,
					model.ZV,
					model.YY,
					true,
					model.ad6,
					model.$F);
				var newModel = _v6.a;
				var cmd = _v6.b;
				return {GZ: cmd, aiO: newModel, aR: _List_Nil};
			case 3:
				var subMsg = msg.a;
				var _v7 = model.mZ;
				if (!_v7.$) {
					var companyResourceFilter = _v7.a;
					var companyResourceResult = A3($author$project$Components$ResourceFilter$Company$update, apiClient, subMsg, companyResourceFilter);
					var _v8 = function () {
						var _v9 = companyResourceResult.agZ;
						if ((!_v9.$) && (!_v9.a.$)) {
							var company = _v9.a.a;
							return _Utils_Tuple2(
								$author$project$Components$ResourceFilter$Company$usesEmployeeDivisions(company),
								$author$project$Components$ResourceFilter$Company$requiresEmployeeDivisions(company));
						} else {
							return _Utils_Tuple2(model.ad6, model.$F);
						}
					}();
					var usesEmployeeDivisions = _v8.a;
					var requiresEmployeeDivision = _v8.b;
					var _v10 = function () {
						var _v11 = companyResourceResult.agZ;
						if (!_v11.$) {
							return _Utils_Tuple2(
								$author$project$Components$ResourceFilter$Company$value(companyResourceResult.aiO),
								A2(
									$elm$core$Maybe$withDefault,
									$elm$core$Platform$Cmd$none,
									A2(
										$elm$core$Maybe$map,
										$author$project$Components$Patient$AddSponsorshipModal$fetchAccountDivisions(apiClient),
										$author$project$Components$ResourceFilter$Company$value(companyResourceResult.aiO))));
						} else {
							return _Utils_Tuple2(model.dJ, $elm$core$Platform$Cmd$none);
						}
					}();
					var companyId = _v10.a;
					var fetchDivisionsCmd = _v10.b;
					var newModel = $author$project$Components$Patient$AddSponsorshipModal$validateModel(
						_Utils_update(
							model,
							{
								mZ: $elm$core$Maybe$Just(companyResourceResult.aiO),
								$F: requiresEmployeeDivision,
								dJ: companyId,
								fc: $elm$core$Maybe$Nothing,
								ad6: usesEmployeeDivisions
							}));
					var commands = _List_fromArray(
						[
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$AddSponsorshipModal$CompanyResourceFilterMsg, companyResourceResult.GZ),
							fetchDivisionsCmd
						]);
					return {
						GZ: $elm$core$Platform$Cmd$batch(commands),
						aiO: newModel,
						aR: companyResourceResult.aR
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, aiO: model, aR: _List_Nil};
				}
			case 4:
				var subMsg = msg.a;
				var _v12 = model.lD;
				if (!_v12.$) {
					var subscriberResourceFilter = _v12.a;
					var patientResourceResult = A3($author$project$Components$ResourceFilter$Patient$update, apiClient, subMsg, subscriberResourceFilter);
					var _v13 = function () {
						var _v14 = patientResourceResult.agZ;
						if (!_v14.$) {
							return _Utils_Tuple2(
								$elm$core$Maybe$Nothing,
								A2(
									$elm$core$Maybe$withDefault,
									$elm$core$Platform$Cmd$none,
									A2(
										$elm$core$Maybe$map,
										$author$project$Components$Patient$AddSponsorshipModal$fetchPatient(apiClient),
										$author$project$Components$ResourceFilter$Patient$value(patientResourceResult.aiO))));
						} else {
							return _Utils_Tuple2(model.lh, $elm$core$Platform$Cmd$none);
						}
					}();
					var newSelectedSubscriber = _v13.a;
					var fetchPatientCmd = _v13.b;
					var commands = _List_fromArray(
						[
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$AddSponsorshipModal$SubscriberResourceFilterMsg, patientResourceResult.GZ),
							fetchPatientCmd
						]);
					var newModel = $author$project$Components$Patient$AddSponsorshipModal$validateModel(
						_Utils_update(
							model,
							{
								lh: newSelectedSubscriber,
								lD: $elm$core$Maybe$Just(patientResourceResult.aiO)
							}));
					return {
						GZ: $elm$core$Platform$Cmd$batch(commands),
						aiO: newModel,
						aR: patientResourceResult.aR
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, aiO: model, aR: _List_Nil};
				}
			case 5:
				var response = msg.a;
				var newModel = function () {
					if (model.$F) {
						var selectedDivisionId = function () {
							if (response.$ === 3) {
								var data = response.a;
								return A2(
									$elm$core$Maybe$map,
									$author$project$Api$Provider$EmployeeDivision$All$id,
									$elm$core$List$head(data));
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}();
						return $author$project$Components$Patient$AddSponsorshipModal$validateModel(
							_Utils_update(
								model,
								{zr: response, fc: selectedDivisionId}));
					} else {
						return $author$project$Components$Patient$AddSponsorshipModal$validateModel(
							_Utils_update(
								model,
								{zr: response}));
					}
				}();
				return {GZ: $elm$core$Platform$Cmd$none, aiO: newModel, aR: _List_Nil};
			case 6:
				var divisionId = msg.a;
				if (divisionId === '') {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						aiO: _Utils_update(
							model,
							{fc: $elm$core$Maybe$Nothing}),
						aR: _List_Nil
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						aiO: $author$project$Components$Patient$AddSponsorshipModal$validateModel(
							_Utils_update(
								model,
								{
									fc: $elm$core$Maybe$Just(divisionId)
								})),
						aR: _List_Nil
					};
				}
			case 7:
				var companyId = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var data = response.a;
					return {
						GZ: A5(
							$author$project$Components$Patient$AddSponsorshipModal$createCompanyRegistration,
							apiClient,
							companyId,
							$author$project$Api$Provider$CompanyAccount$One$id(data),
							$author$project$Api$Provider$Patient$One$id(model.YY),
							model.uu),
						aiO: model,
						aR: _List_Nil
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						aiO: model,
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 8:
				var response = msg.a;
				if (response.$ === 3) {
					var _v19 = A7($author$project$Components$Patient$AddSponsorshipModal$resetModel, 0, apiClient, model.ZV, model.YY, false, model.ad6, model.$F);
					var newModel = _v19.a;
					var cmd = _v19.b;
					return {
						GZ: cmd,
						aiO: newModel,
						aR: _List_fromArray(
							[
								$author$project$OutMsg$RetrievePatient(
								$author$project$Api$Provider$Patient$One$id(model.YY))
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						aiO: model,
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 9:
				var response = msg.a;
				if (response.$ === 3) {
					var pat = response.a;
					var subscriberOwnedCompanyAccounts = A2(
						$elm$core$List$filter,
						function (acc) {
							return _Utils_eq(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									A2(
										$elm$core$Maybe$map,
										$author$project$Api$Provider$Patient$Min$id,
										$author$project$Api$Provider$CompanyAccount$ForPatient$subscriber(acc))),
								$author$project$Api$Provider$Patient$One$id(pat));
						},
						$author$project$Api$Provider$Patient$One$companyAccounts(pat));
					var selectedCompanyAccount = $elm$core$List$head(subscriberOwnedCompanyAccounts);
					var selectedCompanyId = A2(
						$elm$core$Maybe$map,
						$author$project$Api$Provider$Company$Min$id,
						A2($elm$core$Maybe$map, $author$project$Api$Provider$CompanyAccount$ForPatient$company, selectedCompanyAccount));
					return {
						GZ: $elm$core$Platform$Cmd$none,
						aiO: $author$project$Components$Patient$AddSponsorshipModal$validateModel(
							_Utils_update(
								model,
								{
									hx: A2($elm$core$Maybe$map, $author$project$Api$Provider$CompanyAccount$ForPatient$id, selectedCompanyAccount),
									dJ: selectedCompanyId,
									lh: $elm$core$Maybe$Just(pat),
									lC: $elm$core$Maybe$Just(subscriberOwnedCompanyAccounts)
								})),
						aR: _List_Nil
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, aiO: model, aR: _List_Nil};
				}
			default:
				var id = msg.a;
				var companyId = A2(
					$elm$core$Maybe$map,
					$author$project$Api$Provider$Company$Min$id,
					A2(
						$elm$core$Maybe$map,
						$author$project$Api$Provider$CompanyAccount$ForPatient$company,
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (acc) {
									return _Utils_eq(
										$author$project$Api$Provider$CompanyAccount$ForPatient$id(acc),
										id);
								},
								A2($elm$core$Maybe$withDefault, _List_Nil, model.lC)))));
				return {
					GZ: $elm$core$Platform$Cmd$none,
					aiO: $author$project$Components$Patient$AddSponsorshipModal$validateModel(
						_Utils_update(
							model,
							{
								hx: $elm$core$Maybe$Just(id),
								dJ: companyId
							})),
					aR: _List_Nil
				};
		}
	});
var $author$project$Components$Patient$EditAthenaIdModal$Closed = {$: 0};
var $author$project$Components$Patient$EditAthenaIdModal$None = {$: 2};
var $author$project$Components$Patient$EditAthenaIdModal$Success = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Patient$EditAthenaIdModal$MetadataUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Patient$Integration$metadataRecordEncoder = function (metadata) {
	var innerObject = $elm$json$Json$Encode$object(
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (idVal) {
					return ($elm$core$String$trim(idVal) === '') ? _List_Nil : _List_fromArray(
						[
							_Utils_Tuple2(
							'athena_local_patient_id',
							$elm$json$Json$Encode$string(idVal))
						]);
				},
				metadata.air)));
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2('metadata', innerObject)
			]));
};
var $author$project$Api$Provider$Patient$Integration$updateMetadata = F5(
	function (apiClient, patientId, integrationId, metadata, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$IntegrationRecord$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Provider$Patient$Integration$metadataRecordEncoder(metadata),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['metadata']),
						A2($author$project$Api$Provider$Patient$Integration$integrationPath, patientId, integrationId)))));
	});
var $author$project$Components$Patient$EditAthenaIdModal$updateLocalPatientId = F4(
	function (apiClient, patientId, integrationId, localPatientId) {
		var metadata = {
			air: $elm$core$Maybe$Just(localPatientId)
		};
		return A5($author$project$Api$Provider$Patient$Integration$updateMetadata, apiClient, patientId, integrationId, metadata, $author$project$Components$Patient$EditAthenaIdModal$MetadataUpdated);
	});
var $author$project$Components$Patient$EditAthenaIdModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 1:
				var newLocalPatientId = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: $author$project$Components$Patient$EditAthenaIdModal$None,
					aiO: _Utils_update(
						model,
						{th: newLocalPatientId}),
					aR: _List_Nil
				};
			case 0:
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: $author$project$Components$Patient$EditAthenaIdModal$Closed,
					aiO: _Utils_update(
						model,
						{Yn: false}),
					aR: _List_Nil
				};
			case 2:
				var cmd = A4(
					$author$project$Components$Patient$EditAthenaIdModal$updateLocalPatientId,
					apiClient,
					$author$project$Api$Provider$Patient$One$id(model.YY),
					$author$project$Api$Provider$Integration$SharedWithInlinePartner$id(
						$author$project$Api$Provider$IntegrationRecord$All$integration(model.sL)),
					model.th);
				return {
					GZ: cmd,
					agZ: $author$project$Components$Patient$EditAthenaIdModal$None,
					aiO: _Utils_update(
						model,
						{_r: true}),
					aR: _List_Nil
				};
			default:
				var response = msg.a;
				switch (response.$) {
					case 3:
						var newModel = _Utils_update(
							model,
							{Yn: false, _r: false});
						var integrationId = $author$project$Api$Provider$Integration$SharedWithInlinePartner$id(
							$author$project$Api$Provider$IntegrationRecord$All$integration(model.sL));
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: $author$project$Components$Patient$EditAthenaIdModal$Success(integrationId),
							aiO: newModel,
							aR: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Local ID saved')
								])
						};
					case 2:
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: $author$project$Components$Patient$EditAthenaIdModal$None,
							aiO: model,
							aR: $author$project$OutMsg$handleErrorResponse(response)
						};
					default:
						return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$Patient$EditAthenaIdModal$None, aiO: model, aR: _List_Nil};
				}
		}
	});
var $author$project$Components$Patient$EditCustomFormAnswerModal$Closed = 1;
var $author$project$Components$Patient$EditCustomFormAnswerModal$FormResponseUpdated = 2;
var $author$project$Components$Patient$EditCustomFormAnswerModal$None = 0;
var $author$project$Api$Provider$CustomForm$answerId = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Components$Patient$EditCustomFormAnswerModal$FormAnswerUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$CustomForm$answerText = function (_v0) {
	var record = _v0;
	return record.ac3;
};
var $author$project$Api$Provider$CustomForm$formResponsesPath = function (patientId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['form_responses']),
		A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[patientId]),
			A2(
				$author$project$Api$Data$pathAppend,
				_List_fromArray(
					['patients']),
				$author$project$Api$Data$providerPath)));
};
var $author$project$Api$Provider$CustomForm$create = F5(
	function (apiClient, patientId, formId, fields, toMsg) {
		var encodeFormResponseItems = function (item) {
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'answer',
						$elm$json$Json$Encode$string(item.ac3)),
						_Utils_Tuple2(
						'form_item',
						$author$project$Utils$Encode$association(item.HQ))
					]));
		};
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'form_response_items',
					A2($elm$json$Json$Encode$list, encodeFormResponseItems, fields)),
					_Utils_Tuple2(
					'form',
					$author$project$Utils$Encode$association(formId))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$CustomForm$formResponsesPath(patientId))));
	});
var $author$project$Api$Provider$CustomForm$destroy = function (_v0) {
	var record = _v0;
	return record.Qu;
};
var $author$project$Api$Provider$CustomForm$formResponsePath = F2(
	function (patientId, id_) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id_]),
			$author$project$Api$Provider$CustomForm$formResponsesPath(patientId));
	});
var $author$project$Api$Provider$CustomForm$update = F5(
	function (apiClient, patientId, id_, fields, toMsg) {
		var encodeFormResponseItems = function (item) {
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'id',
						A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, item.ahP)),
						_Utils_Tuple2(
						'answer',
						$elm$json$Json$Encode$string(item.ac3)),
						_Utils_Tuple2(
						'form_item',
						$author$project$Utils$Encode$association(item.HQ)),
						_Utils_Tuple2(
						'_destroy',
						A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$bool, item.Qu))
					]));
		};
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'form_response_items',
					A2($elm$json$Json$Encode$list, encodeFormResponseItems, fields))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Provider$CustomForm$formResponsePath, patientId, id_))));
	});
var $author$project$Components$Patient$EditCustomFormAnswerModal$createOrUpdateFormResponse = F2(
	function (apiClient, model) {
		var payload = A2(
			$elm$core$List$map,
			function (answer) {
				return {
					Qu: $author$project$Api$Provider$CustomForm$destroy(answer),
					HQ: model.HQ,
					ahP: $elm$core$String$isEmpty(
						$author$project$Api$Provider$CustomForm$answerId(answer)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						$author$project$Api$Provider$CustomForm$answerId(answer)),
					ac3: $author$project$Api$Provider$CustomForm$answerText(answer)
				};
			},
			model.rk);
		return $elm$core$String$isEmpty(model.zJ) ? A5($author$project$Api$Provider$CustomForm$create, apiClient, model.YZ, model.HP, payload, $author$project$Components$Patient$EditCustomFormAnswerModal$FormAnswerUpdated) : A5($author$project$Api$Provider$CustomForm$update, apiClient, model.YZ, model.zJ, payload, $author$project$Components$Patient$EditCustomFormAnswerModal$FormAnswerUpdated);
	});
var $author$project$Api$Provider$CustomForm$updateDestroy = F2(
	function (_v0, bool) {
		var formAnswer = _v0;
		return _Utils_update(
			formAnswer,
			{
				Qu: $elm$core$Maybe$Just(bool)
			});
	});
var $author$project$Api$Provider$CustomForm$updateText = F2(
	function (newValue, _v0) {
		var formAnswer = _v0;
		return _Utils_update(
			formAnswer,
			{ac3: newValue});
	});
var $author$project$Components$Patient$EditCustomFormAnswerModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: 1, aiO: model, aR: _List_Nil};
			case 1:
				return {
					GZ: A2($author$project$Components$Patient$EditCustomFormAnswerModal$createOrUpdateFormResponse, apiClient, model),
					agZ: 0,
					aiO: model,
					aR: _List_Nil
				};
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 2,
						aiO: model,
						aR: _List_fromArray(
							[
								$author$project$OutMsg$RetrievePatient(model.YZ),
								A2($author$project$OutMsg$ShowToast, 3, 'Answer updated succesfully')
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: model,
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 3:
				var formAnswer = msg.a;
				var string = msg.b;
				var newAnswer = A2($author$project$Api$Provider$CustomForm$updateText, string, formAnswer);
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{
							rk: _List_fromArray(
								[newAnswer])
						}),
					aR: _List_Nil
				};
			case 4:
				var newAnswers = A2($elm$core$List$append, model.rk, $author$project$Api$Provider$CustomForm$initEmptyAnswers);
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{rk: newAnswers}),
					aR: _List_Nil
				};
			case 5:
				var index = msg.a;
				var newValue = msg.b;
				var newAnswers = A3(
					$elm_community$list_extra$List$Extra$updateAt,
					index,
					function (answer) {
						return A2($author$project$Api$Provider$CustomForm$updateText, newValue, answer);
					},
					model.rk);
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{rk: newAnswers}),
					aR: _List_Nil
				};
			default:
				var index = msg.a;
				var maybeAnswer = A2($elm_community$list_extra$List$Extra$getAt, index, model.rk);
				var newAnswers = function () {
					if (maybeAnswer.$ === 1) {
						return model.rk;
					} else {
						var answer_ = maybeAnswer.a;
						return ($author$project$Api$Provider$CustomForm$answerId(answer_) === '') ? A2($elm_community$list_extra$List$Extra$removeAt, index, model.rk) : A3(
							$elm_community$list_extra$List$Extra$updateAt,
							index,
							function (answer) {
								return A2($author$project$Api$Provider$CustomForm$updateDestroy, answer, true);
							},
							model.rk);
					}
				}();
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: _Utils_update(
						model,
						{rk: newAnswers}),
					aR: _List_Nil
				};
		}
	});
var $author$project$Components$Patient$ManagePortalAccessModal$None = 1;
var $author$project$Components$Patient$ManagePortalAccessModal$PortalStatusChanged = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $author$project$Components$Patient$ManagePortalAccessModal$ToggledPortalStatus = 0;
var $author$project$Api$Provider$PatientEmail$authorize = F4(
	function (apiClient, emailAddressId, patientEmailId, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['authorize']),
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							[patientEmailId]),
						$author$project$Api$Provider$PatientEmail$patientEmailsPath(emailAddressId)))));
	});
var $author$project$Api$Provider$PatientEmail$All$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$PatientEmail$All$isPortalEnabled = function (_v0) {
	var record = _v0;
	return record.ZO;
};
var $author$project$Api$Provider$PatientEmail$revoke = F4(
	function (apiClient, emailAddressId, patientEmailId, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['revoke']),
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							[patientEmailId]),
						$author$project$Api$Provider$PatientEmail$patientEmailsPath(emailAddressId)))));
	});
var $author$project$Components$Patient$ManagePortalAccessModal$toggleisPortalEnabled = F3(
	function (isPortalEnabled, patientEmailId, _v0) {
		var id = _v0.a;
		var enabled = _v0.b;
		return _Utils_eq(id, patientEmailId) ? _Utils_Tuple2(id, isPortalEnabled) : _Utils_Tuple2(id, enabled);
	});
var $author$project$Components$Patient$ManagePortalAccessModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 1:
				var response = msg.a;
				var patientEmailsEnabled = function () {
					if (response.$ === 3) {
						var patientEmails = response.a;
						return A2(
							$elm$core$List$map,
							function (p) {
								return _Utils_Tuple2(
									$author$project$Api$Provider$PatientEmail$All$id(p),
									$author$project$Api$Provider$PatientEmail$All$isPortalEnabled(p));
							},
							patientEmails);
					} else {
						return _List_Nil;
					}
				}();
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 1,
					aiO: _Utils_update(
						model,
						{CJ: response, oX: patientEmailsEnabled}),
					aR: $author$project$OutMsg$handleErrorResponse(response)
				};
			case 0:
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 1,
					aiO: _Utils_update(
						model,
						{Yn: false}),
					aR: _List_Nil
				};
			case 2:
				var patientEmail = msg.a;
				var isPortalEnabled = msg.b;
				var _v3 = model.Hy;
				if (!_v3.$) {
					var emailAddressId = _v3.a;
					var patientEmailId = $author$project$Api$Provider$PatientEmail$All$id(patientEmail);
					var requestPortalChange = isPortalEnabled ? A4(
						$author$project$Api$Provider$PatientEmail$authorize,
						apiClient,
						emailAddressId,
						patientEmailId,
						A2($author$project$Components$Patient$ManagePortalAccessModal$PortalStatusChanged, patientEmailId, isPortalEnabled)) : A4(
						$author$project$Api$Provider$PatientEmail$revoke,
						apiClient,
						emailAddressId,
						patientEmailId,
						A2($author$project$Components$Patient$ManagePortalAccessModal$PortalStatusChanged, patientEmailId, isPortalEnabled));
					return {
						GZ: requestPortalChange,
						agZ: 1,
						aiO: _Utils_update(
							model,
							{_r: true}),
						aR: _List_Nil
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 1,
						aiO: model,
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 1, 'No email address found for this patient.')
							])
					};
				}
			default:
				var patientEmailId = msg.a;
				var isPortalEnabled = msg.b;
				var response = msg.c;
				if (response.$ === 3) {
					var statusText = isPortalEnabled ? 'authorized' : 'revoked';
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: _Utils_update(
							model,
							{
								oX: A2(
									$elm$core$List$map,
									A2($author$project$Components$Patient$ManagePortalAccessModal$toggleisPortalEnabled, isPortalEnabled, patientEmailId),
									model.oX),
								_r: false
							}),
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Patient has been ' + (statusText + ' to use the portal.'))
							])
					};
				} else {
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 1,
						aiO: _Utils_update(
							model,
							{_r: false}),
						aR: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
		}
	});
var $author$project$Api$Provider$Patient$AccountAccessToken$url = function (_v0) {
	var record = _v0;
	return record.adY;
};
var $author$project$Pages$Patients$PatientId_String$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 65:
				var data = msg.a;
				if (data.$ === 3) {
					var syncDetail = data.a;
					if (!syncDetail.$) {
						var syncDetail_ = syncDetail.a;
						var coveragePlanAll = A2(
							$author$project$Api$Expandable$withDefault,
							$elm$core$Maybe$Nothing,
							$author$project$Api$Provider$Patient$SyncDetail$coveragePlan(syncDetail_));
						var _v3 = A3($author$project$Pages$Patients$PatientId_String$Top$initNetworkCoveragePlanRules, model, coveragePlanAll, _List_Nil);
						var coveragePlan = _v3.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{w2: data, XA: coveragePlan}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{w2: data}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{w2: data}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(data));
				}
			case 0:
				return _Utils_Tuple3(
					model,
					A2($author$project$Pages$Patients$PatientId_String$Top$fetchPlainSSN, model.Gv, model.YY),
					_List_Nil);
			case 2:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Dd: response}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{WR: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{pX: true}),
					A2($author$project$Pages$Patients$PatientId_String$Top$sendAccountAccess, model.Gv, model.YY),
					_List_Nil);
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					var data = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								KG: $author$project$Api$Provider$Patient$AccountAccess$accountAccessSentAt(data),
								pX: false
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{pX: false}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 5:
				var employeeOrDependent = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							dI: _Utils_Tuple2(
								true,
								$elm$core$Maybe$Just(employeeOrDependent))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 6:
				var employeeOrDependant = msg.a;
				var confirmed = msg.b;
				if (confirmed) {
					var newModel = _Utils_update(
						model,
						{
							dI: _Utils_Tuple2(
								false,
								$elm$core$Maybe$Just(employeeOrDependant))
						});
					switch (employeeOrDependant.$) {
						case 0:
							var companyAccount = employeeOrDependant.a;
							return _Utils_Tuple3(
								newModel,
								A2($author$project$Pages$Patients$PatientId_String$Top$removeEmployee, model.Gv, companyAccount),
								_List_Nil);
						case 1:
							var companyAccount = employeeOrDependant.a;
							var companyRegistration = employeeOrDependant.b;
							return _Utils_Tuple3(
								newModel,
								A3(
									$author$project$Pages$Patients$PatientId_String$Top$removeDependent,
									model.Gv,
									companyAccount,
									$author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$id(companyRegistration)),
								_List_Nil);
						default:
							var companyAccount = employeeOrDependant.a;
							var companyRegistration = employeeOrDependant.b;
							return _Utils_Tuple3(
								newModel,
								A3(
									$author$project$Pages$Patients$PatientId_String$Top$removeDependent,
									model.Gv,
									companyAccount,
									$author$project$Api$Provider$CompanyRegistration$ForPatientOne$id(companyRegistration)),
								_List_Nil);
					}
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								dI: _Utils_Tuple2(false, $elm$core$Maybe$Nothing)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 7:
				var cacId = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var newList = A2(
						$elm$core$List$filter,
						function (cac) {
							return !_Utils_eq(
								$author$project$Api$Provider$CompanyAccount$ForPatient$id(cac),
								cacId);
						},
						model.hK);
					var newModel = _Utils_update(
						model,
						{
							dI: _Utils_Tuple2(false, $elm$core$Maybe$Nothing),
							hK: newList
						});
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Successfully removed')
							]));
				} else {
					var newModel = _Utils_update(
						model,
						{
							dI: _Utils_Tuple2(false, $elm$core$Maybe$Nothing)
						});
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 12:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qb: !model.qb}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 8:
				var _v7 = model.dU;
				if (_v7.$ === 1) {
					var _v8 = A3($author$project$Components$Patient$AddSponsorshipModal$init, model.Gv, model.ZV, model.YY);
					var modal = _v8.a;
					var cmd = _v8.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								dU: $elm$core$Maybe$Just(modal)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$AddSponsorshipModalMsg, cmd),
						_List_Nil);
				} else {
					var modal = _v7.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								dU: $elm$core$Maybe$Just(
									$author$project$Components$Patient$AddSponsorshipModal$open(modal))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 9:
				var account = msg.a;
				var _v9 = A4($author$project$Components$Patient$AddDependentModal$open, model.Gv, model.ZV, model.YY, account);
				var modal = _v9.a;
				var cmd = _v9.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							$8: $elm$core$Maybe$Just(modal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$AddDependentModalMsg, cmd),
					_List_Nil);
			case 10:
				var modalMsg = msg.a;
				var _v10 = model.dU;
				if (!_v10.$) {
					var modal = _v10.a;
					var result = A3($author$project$Components$Patient$AddSponsorshipModal$update, model.Gv, modalMsg, modal);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								dU: $elm$core$Maybe$Just(result.aiO)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$AddSponsorshipModalMsg, result.GZ),
						result.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 11:
				var modalMsg = msg.a;
				var _v11 = model.$8;
				if (!_v11.$) {
					var modal = _v11.a;
					var result = A3($author$project$Components$Patient$AddDependentModal$update, model.Gv, modalMsg, modal);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								$8: $elm$core$Maybe$Just(result.aiO)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$AddDependentModalMsg, result.GZ),
						result.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 13:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{hA: true}),
					A4(
						$author$project$Api$Provider$Patient$requestPaymentInfo,
						model.Gv,
						$author$project$Api$Provider$Patient$One$id(model.YY),
						$elm$core$Maybe$Nothing,
						$author$project$Pages$Patients$PatientId_String$Top$GotPayInfoUpdate),
					_List_Nil);
			case 14:
				var response = msg.a;
				switch (response.$) {
					case 3:
						var payInfo = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									CL: $author$project$Api$Provider$Patient$RequestPaymentInfoOne$requestPayInfoSentAt(payInfo),
									hA: false
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{hA: false}),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error))
								]));
					default:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{hA: false}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
				}
			case 15:
				var cmd = A3(
					$author$project$Api$Provider$Patient$PatientDocument$requestPendingDocumentsAcceptance,
					model.Gv,
					$author$project$Api$Provider$Patient$One$id(model.YY),
					$author$project$Pages$Patients$PatientId_String$Top$GotPendingDocsAcceptanceUpdate);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{li: true}),
					cmd,
					_List_Nil);
			case 16:
				var response = msg.a;
				switch (response.$) {
					case 3:
						var pendingDocs = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									tH: $author$project$Api$Provider$Patient$RequestPendingDocumentsAcceptanceOne$requestPendingDocumentsAcceptanceSentAt(pendingDocs),
									li: false
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{li: false}),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error))
								]));
					default:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{li: false}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
				}
			case 17:
				var eligibleCompanyAccounts = A2(
					$elm$core$List$filter,
					$author$project$Api$Provider$CompanyAccount$ForPatient$isEligible,
					$author$project$Api$Provider$Patient$One$companyAccounts(model.YY));
				if (!eligibleCompanyAccounts.b) {
					return _Utils_Tuple3(
						model,
						A2(
							$author$project$Ports$Navigation$pushRoute,
							model.F0,
							$author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__New(
								{
									YZ: $author$project$Api$Provider$Patient$One$id(model.YY)
								})),
						_List_Nil);
				} else {
					var x = eligibleCompanyAccounts.a;
					var xs = eligibleCompanyAccounts.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								iW: $elm$core$Maybe$Just(
									A3(
										$author$project$Components$Patient$CreateMembershipModal$init,
										model.F0,
										A2($author$project$Utils$NonEmpty$init, x, xs),
										model.YY))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 18:
				var subMsg = msg.a;
				var _v15 = model.iW;
				if (!_v15.$) {
					var modal = _v15.a;
					var _v16 = A3($author$project$Components$Patient$CreateMembershipModal$update, model.Gv, subMsg, modal);
					var createModal_ = _v16.a;
					var cmd = _v16.b;
					var maybeEvent = _v16.c;
					var _v17 = function () {
						if (!maybeEvent.$) {
							switch (maybeEvent.a.$) {
								case 0:
									var _v19 = maybeEvent.a;
									return _Utils_Tuple2($elm$core$Maybe$Nothing, _List_Nil);
								case 2:
									var _v20 = maybeEvent.a;
									return _Utils_Tuple2(
										$elm$core$Maybe$Nothing,
										_List_fromArray(
											[
												$author$project$OutMsg$RetrievePatient(
												$author$project$Api$Provider$Patient$One$id(model.YY))
											]));
								default:
									var error = maybeEvent.a.a;
									return _Utils_Tuple2(
										$elm$core$Maybe$Just(createModal_),
										_List_fromArray(
											[
												A2(
												$author$project$OutMsg$ShowToast,
												1,
												$author$project$Ui$Toast$serverError(error))
											]));
							}
						} else {
							return _Utils_Tuple2(
								$elm$core$Maybe$Just(createModal_),
								_List_Nil);
						}
					}();
					var newModal = _v17.a;
					var outMsgs = _v17.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{iW: newModal}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$CreateMembershipModalMsg, cmd),
						outMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 19:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{k1: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 20:
				var patientId = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{k1: false}),
					A3(
						$author$project$Api$Provider$Patient$restore,
						model.Gv,
						patientId,
						$author$project$Pages$Patients$PatientId_String$Top$PatientRestored(patientId)),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{k1: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 21:
				var id = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									$author$project$OutMsg$RetrievePatient(id),
									A2($author$project$OutMsg$ShowToast, 3, 'This patient is successfully restored.')
								]));
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error)),
								$author$project$OutMsg$reportDecodeError(response)));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 23:
				var response = msg.a;
				var _v22 = function () {
					if (response.$ === 3) {
						var data = response.a;
						return _Utils_Tuple3(
							A2(
								$elm$core$List$indexedMap,
								F2(
									function (index, record) {
										return $author$project$Ui$Dropdown$init(
											$author$project$Ui$Dropdown$toDownLeft(
												$author$project$Ui$Dropdown$defaultConfig(
													{
														ahP: $author$project$Api$Provider$Integration$SharedWithInlinePartner$id(
															$author$project$Api$Provider$IntegrationRecord$All$integration(record)) + '-integration-record-dropdown',
														al6: $author$project$Pages$Patients$PatientId_String$Top$DropdownMenuMsg(index)
													})));
									}),
								data),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						return _Utils_Tuple3(
							_List_Nil,
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				}();
				var integrationRecordDropdowns = _v22.a;
				var errorReport = _v22.b;
				var outMsgs = _v22.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{gy: integrationRecordDropdowns, Ub: response}),
					errorReport,
					outMsgs);
			case 22:
				var index = msg.a;
				var subMsg = msg.b;
				var _v24 = A2($elm_community$list_extra$List$Extra$getAt, index, model.gy);
				if (_v24.$ === 1) {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				} else {
					var dropdownModel = _v24.a;
					var _v25 = A2($author$project$Ui$Dropdown$update, subMsg, dropdownModel);
					var dropdownMenu = _v25.a;
					var cmd = _v25.b;
					var newList = A3($elm_community$list_extra$List$Extra$setAt, index, dropdownMenu, model.gy);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{gy: newList}),
						cmd,
						_List_Nil);
				}
			case 24:
				var action = msg.a;
				var record = msg.b;
				var patientId = $author$project$Api$Provider$Patient$One$id(model.YY);
				var integrationId = $author$project$Api$Provider$Integration$SharedWithInlinePartner$id(
					$author$project$Api$Provider$IntegrationRecord$All$integration(record));
				switch (action) {
					case 0:
						return _Utils_Tuple3(
							model,
							A3($author$project$Pages$Patients$PatientId_String$Top$unlinkIntegration, model.Gv, patientId, integrationId),
							_List_Nil);
					case 1:
						var metadataRecord = $author$project$Api$Provider$IntegrationRecord$All$athenaMetadata(record);
						var externalPatientId = function () {
							if (!metadataRecord.$) {
								var metadataRecord_ = metadataRecord.a;
								return A2($elm$core$Maybe$withDefault, '', metadataRecord_.air);
							} else {
								return A2(
									$elm$core$Maybe$withDefault,
									'',
									$author$project$Api$Provider$IntegrationRecord$All$integrationRecordId(record));
							}
						}();
						return _Utils_Tuple3(
							model,
							$author$project$Ports$Clipboard$copy(externalPatientId),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Copied to clipboard!')
								]));
					case 2:
						return _Utils_Tuple3(
							model,
							A3($author$project$Pages$Patients$PatientId_String$Top$pushIntegration, model.Gv, patientId, integrationId),
							_List_Nil);
					default:
						var metadataRecord = $author$project$Api$Provider$IntegrationRecord$All$athenaMetadata(record);
						var _v28 = A2(
							$elm$core$Tuple$mapFirst,
							$elm$core$Maybe$Just,
							A5($author$project$Components$Patient$EditAthenaIdModal$open, model.Gv, model.ZV, record, metadataRecord, model.YY));
						var modal = _v28.a;
						var cmd = _v28.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{ju: modal}),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$EditPartnerIdModalMsg, cmd),
							_List_Nil);
				}
			case 26:
				var response = msg.a;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Record pushed, this might take a while')
								]));
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error))
								]));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 25:
				var response = msg.a;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Record unlinked')
								]));
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error))
								]));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 27:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nO: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 28:
				var confirmed = msg.a;
				var cmd = confirmed ? A2(
					$author$project$Pages$Patients$PatientId_String$Top$forcePushElation,
					model.Gv,
					$author$project$Api$Provider$Patient$One$id(model.YY)) : $elm$core$Platform$Cmd$none;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nO: false}),
					cmd,
					_List_Nil);
			case 29:
				var response = msg.a;
				switch (response.$) {
					case 3:
						var patient = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{YY: patient}),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Successfully synced with Elation')
								]));
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error))
								]));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 30:
				var idx = msg.a;
				var bool = msg.b;
				var newList = A3($elm_community$list_extra$List$Extra$setAt, idx, bool, model.sK);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{sK: newList}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 31:
				var url = msg.a;
				return _Utils_Tuple3(
					model,
					$author$project$Ports$Navigation$openInNewWindow(url),
					_List_Nil);
			case 34:
				var response = msg.a;
				if (response.$ === 2) {
					var error = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{oW: response}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2(
								$author$project$OutMsg$ShowToast,
								1,
								$author$project$Ui$Toast$serverError(error))
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{oW: response}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 32:
				var response = msg.a;
				if (response.$ === 2) {
					var error = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{tz: response}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2(
								$author$project$OutMsg$ShowToast,
								1,
								$author$project$Ui$Toast$serverError(error))
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{tz: response}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 33:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ty: !model.ty}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 38:
				var formQuestion = msg.a;
				var formId = msg.b;
				var formResponseId = msg.c;
				var _v34 = model.gj;
				if (_v34.$ === 1) {
					var _v35 = A4(
						$author$project$Components$Patient$EditCustomFormAnswerModal$init,
						$author$project$Api$Provider$Patient$One$id(model.YY),
						formQuestion,
						formId,
						formResponseId);
					var modal = _v35.a;
					var cmd = _v35.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								gj: $elm$core$Maybe$Just(modal)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$EditCustomFormAnswerModalMsg, cmd),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 35:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{jk: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 36:
				var patientId = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{jk: false}),
					A3(
						$author$project$Api$Provider$Patient$disableSyncing,
						model.Gv,
						patientId,
						$author$project$Pages$Patients$PatientId_String$Top$PatientDetached(patientId)),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{jk: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 37:
				var patientId = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									$author$project$OutMsg$RetrievePatient(patientId),
									A2($author$project$OutMsg$ShowToast, 3, 'Record detached')
								]));
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error)),
								$author$project$OutMsg$reportDecodeError(response)));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 39:
				var subMsg = msg.a;
				var _v37 = model.gj;
				if (!_v37.$) {
					var modal = _v37.a;
					var result = A3($author$project$Components$Patient$EditCustomFormAnswerModal$update, model.Gv, subMsg, modal);
					var newModal = function () {
						var _v38 = result.agZ;
						if (!_v38) {
							return $elm$core$Maybe$Just(result.aiO);
						} else {
							return $elm$core$Maybe$Nothing;
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{gj: newModal}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$EditCustomFormAnswerModalMsg, result.GZ),
						result.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 44:
				var response = msg.a;
				if (response.$ === 3) {
					var membership = response.a;
					var cmd = ($author$project$Api$Provider$Membership$One$status(membership) === 'ended') ? $elm$core$Platform$Cmd$none : A2(
						$author$project$Pages$Patients$PatientId_String$Top$retrieveCoverageRuleUsages,
						model.Gv,
						A2($elm$core$Maybe$withDefault, '', model.rR));
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{kk: response}),
						cmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{kk: response}),
						A2(
							$author$project$Pages$Patients$PatientId_String$Top$retrieveCoverageRuleUsages,
							model.Gv,
							A2($elm$core$Maybe$withDefault, '', model.rR)),
						_List_Nil);
				}
			case 45:
				var response = msg.a;
				var _v40 = _Utils_Tuple2(response, model.kk);
				if ((_v40.a.$ === 3) && (_v40.b.$ === 3)) {
					var _v41 = _v40.a;
					var coverageRuleUsages = _v41.a;
					var _v42 = _v40.b;
					var membership = _v42.a;
					var plan = $author$project$Api$Provider$Membership$One$plan(membership);
					var _v43 = A3($author$project$Pages$Patients$PatientId_String$Top$initCoveragePlanRules, model, plan, coverageRuleUsages);
					var coveragePlan = _v43.a;
					var coveragePlanRulesCmd = _v43.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{OT: coveragePlan, OV: response}),
						coveragePlanRulesCmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{OV: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 40:
				var membershipId = msg.a;
				var membershipPatientId = msg.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							rR: $elm$core$Maybe$Just(membershipPatientId),
							kk: $author$project$Api$Data$Loading,
							oD: true
						}),
					A3($author$project$Pages$Patients$PatientId_String$Top$retrieveMembership, model.Gv, membershipId, $author$project$Pages$Patients$PatientId_String$Top$GotMembership),
					_List_Nil);
			case 41:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{OT: $elm$core$Maybe$Nothing, kk: $author$project$Api$Data$NotAsked, oD: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 42:
				var subMsg = msg.a;
				var _v44 = model.OT;
				if (!_v44.$) {
					var coveragePlan = _v44.a;
					var _v45 = A3($author$project$Components$Admin$CoveragePlans$Rules$update, model.Gv, subMsg, coveragePlan);
					var newCoveragePlan = _v45.a;
					var coveragePlanCmd = _v45.b;
					var coveragePlanOutMsgs = _v45.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								OT: $elm$core$Maybe$Just(newCoveragePlan)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$CoveragePlanMsg, coveragePlanCmd),
						coveragePlanOutMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 43:
				var subMsg = msg.a;
				var _v46 = model.XA;
				if (!_v46.$) {
					var networkCoveragePlan = _v46.a;
					var _v47 = A3($author$project$Components$Admin$CoveragePlans$Rules$update, model.Gv, subMsg, networkCoveragePlan);
					var newNetworkCoveragePlan = _v47.a;
					var networkCoveragePlanCmd = _v47.b;
					var networkCoveragePlanOutMsgs = _v47.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								XA: $elm$core$Maybe$Just(newNetworkCoveragePlan)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$NetworkCoveragePlanMsg, networkCoveragePlanCmd),
						networkCoveragePlanOutMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 46:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{l5: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 48:
				var confirmed = msg.a;
				var cmd = confirmed ? A2(
					$author$project$Pages$Patients$PatientId_String$Top$acceptEphiWaiver,
					model.Gv,
					$author$project$Api$Provider$Patient$One$id(model.YY)) : $elm$core$Platform$Cmd$none;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{l5: false}),
					cmd,
					_List_Nil);
			case 47:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{pD: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 49:
				var confirmed = msg.a;
				var cmd = confirmed ? A2(
					$author$project$Pages$Patients$PatientId_String$Top$removeEphiWaiver,
					model.Gv,
					$author$project$Api$Provider$Patient$One$id(model.YY)) : $elm$core$Platform$Cmd$none;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{pD: false}),
					cmd,
					_List_Nil);
			case 50:
				var response = msg.a;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									$author$project$OutMsg$RetrievePatient(
									$author$project$Api$Provider$Patient$One$id(model.YY)),
									A2($author$project$OutMsg$ShowToast, 3, 'Ephi Waiver Accepted')
								]));
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error)),
								$author$project$OutMsg$reportDecodeError(response)));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 51:
				var response = msg.a;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									$author$project$OutMsg$RetrievePatient(
									$author$project$Api$Provider$Patient$One$id(model.YY)),
									A2($author$project$OutMsg$ShowToast, 3, 'Ephi Waiver Removed')
								]));
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error)),
								$author$project$OutMsg$reportDecodeError(response)));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 52:
				var patientValue = msg.a;
				return _Utils_Tuple3(
					model,
					$author$project$Ports$Clipboard$copy(patientValue),
					_List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 3, 'Copied to clipboard')
						]));
			case 73:
				return _Utils_Tuple3(
					model,
					A2($author$project$Pages$Patients$PatientId_String$Top$createAccountAccessToken, model.Gv, model.YY),
					_List_Nil);
			case 74:
				var response = msg.a;
				if (response.$ === 3) {
					var accountAccessToken = response.a;
					return _Utils_Tuple3(
						model,
						$author$project$Ports$Clipboard$copy(
							$author$project$Api$Provider$Patient$AccountAccessToken$url(accountAccessToken)),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Portal URL copied to clipboard')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 53:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oC: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 54:
				var addon = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ii: A2(
								$elm$core$Set$insert,
								$author$project$Api$Provider$Addon$Min$id(addon),
								model.ii)
						}),
					A4(
						$author$project$Api$Provider$AddonRequest$sendEmail,
						model.Gv,
						$author$project$Api$Provider$Addon$Min$id(addon),
						$author$project$Api$Provider$Patient$One$id(model.YY),
						$author$project$Pages$Patients$PatientId_String$Top$AddonRequestEmailSent(addon)),
					_List_Nil);
			case 55:
				var addon = msg.a;
				var response = msg.b;
				var ourMsgs = function () {
					if (response.$ === 3) {
						return _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Email has been sent')
							]);
					} else {
						return _List_Nil;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ii: A2(
								$elm$core$Set$remove,
								$author$project$Api$Provider$Addon$Min$id(addon),
								model.ii)
						}),
					$elm$core$Platform$Cmd$none,
					_Utils_ap(
						ourMsgs,
						$author$project$OutMsg$handleErrorResponse(response)));
			case 56:
				var patientMceEligibility = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							kj: A2(
								$elm$core$Set$insert,
								$author$project$Api$Provider$PatientMceEligibility$All$id(patientMceEligibility),
								model.kj)
						}),
					A4(
						$author$project$Api$Provider$Patient$MceActivation$create,
						model.Gv,
						$author$project$Api$Provider$Patient$One$id(model.YY),
						$author$project$Api$Provider$PatientMceEligibility$All$id(patientMceEligibility),
						$author$project$Pages$Patients$PatientId_String$Top$MceActivationEmailSent(patientMceEligibility)),
					_List_Nil);
			case 57:
				var patientMceEligibility = msg.a;
				var response = msg.b;
				var ourMsgs = function () {
					if (response.$ === 3) {
						return _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Email has been sent')
							]);
					} else {
						return _List_Nil;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							kj: A2(
								$elm$core$Set$remove,
								$author$project$Api$Provider$PatientMceEligibility$All$id(patientMceEligibility),
								model.kj)
						}),
					$elm$core$Platform$Cmd$none,
					_Utils_ap(
						ourMsgs,
						$author$project$OutMsg$handleErrorResponse(response)));
			case 58:
				var subMsg = msg.a;
				var auditTrailLogResult = A3($author$project$Components$AuditTrailLog$update, model.Gv, subMsg, model.iw);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{iw: auditTrailLogResult.aiO}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$AuditTrailLogMsg, auditTrailLogResult.GZ),
					auditTrailLogResult.aR);
			case 59:
				var popover = A3(
					$author$project$Ui$Popover$init,
					'engagement',
					!$author$project$Ui$Popover$isOpen(model.aT),
					$author$project$Pages$Patients$PatientId_String$Top$PopoverMsg);
				var engagementStatus = $author$project$Api$Provider$Patient$One$engagementStatus(model.YY);
				var _v53 = _Utils_Tuple2(model.HC, engagementStatus !== 'never_engaged');
				if ((!_v53.a.$) && _v53.b) {
					var _v54 = _v53.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{HC: $author$project$Api$Data$Loading, aT: popover}),
						A3(
							$author$project$Api$Provider$Patient$Engagement$retrieve,
							model.Gv,
							$author$project$Api$Provider$Patient$One$id(model.YY),
							$author$project$Pages$Patients$PatientId_String$Top$GotEngagement),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{aT: popover}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 60:
				var data = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{HC: data}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(data));
			case 61:
				var subMsg = msg.a;
				var popoverModel = A2($author$project$Ui$Popover$update, subMsg, model.aT);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aT: popoverModel}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 62:
				var _v55 = A4(
					$author$project$Components$Patient$ManagePortalAccessModal$open,
					model.Gv,
					model.ZV,
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Maybe$Nothing,
						$author$project$Api$Data$toMaybe(model.r7)),
					model.YY);
				var modal = _v55.a;
				var cmd = _v55.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							kf: $elm$core$Maybe$Just(modal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$ManagePortalAccessModalMsg, cmd),
					_List_Nil);
			case 63:
				var modalMsg = msg.a;
				var _v56 = model.kf;
				if (!_v56.$) {
					var modal = _v56.a;
					var result = A3($author$project$Components$Patient$ManagePortalAccessModal$update, model.Gv, modalMsg, modal);
					var cmd = function () {
						var _v57 = result.agZ;
						if (!_v57) {
							return A2(
								$author$project$Pages$Patients$PatientId_String$Top$fetchEmailAddress,
								model.Gv,
								$author$project$Api$Provider$Patient$One$id(model.YY));
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								kf: $elm$core$Maybe$Just(result.aiO)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$ManagePortalAccessModalMsg, result.GZ),
									cmd
								])),
						result.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 64:
				var response = msg.a;
				if (response.$ === 2) {
					var error = response.a;
					if (error.$ === 5) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									r7: A2($author$project$Api$Data$Success, $elm$core$Maybe$Nothing, $elm$core$Dict$empty)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								r7: A2($author$project$Api$Data$map, $elm$core$Maybe$Just, response)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 66:
				var modalMsg = msg.a;
				var _v60 = model.ju;
				if (!_v60.$) {
					var modal = _v60.a;
					var result = A3($author$project$Components$Patient$EditAthenaIdModal$update, model.Gv, modalMsg, modal);
					var _v61 = function () {
						var _v62 = result.agZ;
						switch (_v62.$) {
							case 1:
								var integrationId = _v62.a;
								return _Utils_Tuple2(
									$elm$core$Maybe$Nothing,
									$elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[
												A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$EditPartnerIdModalMsg, result.GZ),
												A2(
												$author$project$Pages$Patients$PatientId_String$Top$fetchIntegrationRecords,
												model.Gv,
												$author$project$Api$Provider$Patient$One$id(model.YY)),
												A3(
												$author$project$Pages$Patients$PatientId_String$Top$pushIntegration,
												model.Gv,
												$author$project$Api$Provider$Patient$One$id(model.YY),
												integrationId)
											])));
							case 2:
								return _Utils_Tuple2(
									$elm$core$Maybe$Just(result.aiO),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$EditPartnerIdModalMsg, result.GZ));
							default:
								return _Utils_Tuple2(
									$elm$core$Maybe$Nothing,
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$EditPartnerIdModalMsg, result.GZ));
						}
					}();
					var newModal = _v61.a;
					var cmds = _v61.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ju: newModal}),
						cmds,
						result.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 67:
				return _Utils_Tuple3(
					model,
					A3(
						$author$project$Api$Provider$Patient$resetBouncedEmail,
						model.Gv,
						$author$project$Api$Provider$Patient$One$id(model.YY),
						$author$project$Pages$Patients$PatientId_String$Top$BouncedEmailReset),
					_List_Nil);
			case 68:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{GI: true}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2(
								$author$project$OutMsg$ShowToast,
								3,
								A2(
									$elm$core$String$append,
									'You should now be able to send emails to ',
									A2(
										$elm$core$Maybe$withDefault,
										'',
										$author$project$Api$Provider$Patient$One$email(model.YY))))
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 69:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Cm: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 70:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{uI: !model.uI}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 71:
				var _package = msg.a;
				var patientId = $author$project$Api$Provider$Patient$One$id(model.YY);
				var modalWithPackage = function () {
					var _v64 = $author$project$Api$Provider$PatientPackage$All$priceInCents(_package);
					if (!_v64.$) {
						var price = _v64.a;
						return A4($author$project$Components$Patient$PackageDetailsModal$openWithPrice, patientId, _package, price, model.dA);
					} else {
						return A3($author$project$Components$Patient$PackageDetailsModal$open, patientId, _package, model.dA);
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dA: modalWithPackage}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v65 = A2($author$project$Components$Patient$PackageDetailsModal$update, subMsg, model.dA);
				var newModal = _v65.a;
				var cmd = _v65.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dA: newModal}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$PackageDetailsModalMsg, cmd),
					_List_Nil);
		}
	});
var $author$project$Api$FeatureGate$PatientPortal = 5;
var $author$project$Api$Platform$Session$One$practiceReadOnlyRole = function (_v0) {
	var record = _v0;
	return (record.ak3 === 'practice_read_only') || (record.ak3 === 'practice_read_only_and_reports');
};
var $author$project$Permission$hideIfReadOnly = F2(
	function (session, html) {
		return $author$project$Api$Platform$Session$One$practiceReadOnlyRole(session) ? $author$project$Utils$Html$empty : html;
	});
var $author$project$Components$HiConfirm$CenterText = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$HiConfirm$centerText = $author$project$Components$HiConfirm$CenterText;
var $author$project$Pages$Patients$PatientId_String$Top$viewAcceptEphiWaiverModal = function (model) {
	return model.l5 ? A2(
		$author$project$Components$HiConfirm$modal,
		$author$project$Pages$Patients$PatientId_String$Top$AcceptEphiWaiverModalClosed,
		_List_fromArray(
			[
				$author$project$Components$HiConfirm$verb('Accept'),
				$author$project$Components$HiConfirm$noun('ePHI Waiver'),
				$author$project$Components$HiConfirm$titleizeNoun(false),
				$author$project$Components$HiConfirm$centerText(false),
				$author$project$Components$HiConfirm$customMessage(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('We need authorization from this customer that allows us to send them unencrypted communications which may contain Protected Health Information.')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Without this authorization we cannot communicate electronically on your behalf with this customer.')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Do you have signed authorization that allows us to send unencrypted communication, which may include Protected Health Information, to this customer?')
							]))
					]))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Components$Patient$AddDependentModal$Submitted = {$: 1};
var $author$project$Utils$Maybe$appendMaybe = F2(
	function (maybe, list) {
		return _Utils_ap(
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Maybe$map, $elm$core$List$singleton, maybe)),
			list);
	});
var $author$project$Components$Patient$AddDependentModal$viewDependentOptions = function (model) {
	var _v0 = model.ng;
	if (!_v0.$) {
		var dependentResourceFilter = _v0.a;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Dependent'),
					$author$project$Ui$Form$Group$labelSpanMd(3),
					$author$project$Ui$Form$Group$inputSpanMd(9),
					$author$project$Ui$Form$Group$required(true)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Components$Patient$AddDependentModal$DependentResourceFilterMsg,
					A2(
						$author$project$Components$ResourceFilter$Patient$view,
						_List_fromArray(
							[
								$author$project$Components$ResourceFilter$style(0)
							]),
						dependentResourceFilter))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Patient$AddDependentModal$TypeSelected = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Patient$AddDependentModal$typeToLabel = function (t) {
	if (!t) {
		return 'Adult';
	} else {
		return 'Child';
	}
};
var $author$project$Components$Patient$AddDependentModal$types = _List_fromArray(
	[
		$author$project$Components$Patient$AddDependentModal$typeToLabel(0),
		$author$project$Components$Patient$AddDependentModal$typeToLabel(1)
	]);
var $author$project$Components$Patient$AddDependentModal$typeOptions = A2(
	$elm$core$List$map,
	function (typeStr) {
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(typeStr),
			typeStr);
	},
	$author$project$Components$Patient$AddDependentModal$types);
var $author$project$Components$Patient$AddDependentModal$viewTypeOptions = function (model) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Type'),
				$author$project$Ui$Form$Group$labelSpanMd(3),
				$author$project$Ui$Form$Group$inputSpanMd(9),
				$author$project$Ui$Form$Group$required(true)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Select$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Select$value(
						$elm$core$Maybe$Just(
							$author$project$Components$Patient$AddDependentModal$typeToLabel(model.uu))),
						$author$project$Ui$Form$Select$onChange($author$project$Components$Patient$AddDependentModal$TypeSelected)
					]),
				$author$project$Components$Patient$AddDependentModal$typeOptions)
			]));
};
var $author$project$Components$Patient$AddDependentModal$view = function (_v0) {
	var model = _v0;
	if (model.Yn) {
		var _v1 = function () {
			var _v2 = model.alH;
			if (!_v2.$) {
				return _Utils_Tuple2(true, $elm$core$Maybe$Nothing);
			} else {
				var msg = _v2.a;
				return _Utils_Tuple2(false, msg);
			}
		}();
		var canSubmit = _v1.a;
		var statusBadge = _v1.b;
		var footerContent = _List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Cancel and close modal'},
				_List_fromArray(
					[
						$author$project$Ui$Button$onClick($author$project$Components$Patient$AddDependentModal$Closed)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Cancel')
					])),
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Add dependent to company'},
				_List_fromArray(
					[
						$author$project$Ui$Button$success,
						$author$project$Ui$Button$disabled(!canSubmit),
						$author$project$Ui$Button$onClick($author$project$Components$Patient$AddDependentModal$Submitted)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Add to company')
					]))
			]);
		var body = A2(
			$author$project$Ui$Form$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$onSubmit($author$project$Components$Patient$AddDependentModal$Submitted)
				]),
			A2(
				$author$project$Utils$Maybe$appendMaybe,
				statusBadge,
				_List_fromArray(
					[
						$author$project$Components$Patient$AddDependentModal$viewDependentOptions(model),
						$author$project$Components$Patient$AddDependentModal$viewTypeOptions(model)
					])));
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$Patient$AddDependentModal$Closed,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('Add Dependent')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[body])),
					$author$project$Ui$Modal$footer(footerContent)
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Top$viewAddDependentModal = function (model) {
	var _v0 = model.$8;
	if (!_v0.$) {
		var modal = _v0.a;
		return A2(
			$elm$html$Html$map,
			$author$project$Pages$Patients$PatientId_String$Top$AddDependentModalMsg,
			$author$project$Components$Patient$AddDependentModal$view(modal));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Patient$AddSponsorshipModal$Submitted = {$: 1};
var $author$project$Components$Patient$AddSponsorshipModal$viewCompanyOptions = function (model) {
	var _v0 = model.mZ;
	if (!_v0.$) {
		var companyResourceFilter = _v0.a;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Company'),
					$author$project$Ui$Form$Group$labelSpanMd(3),
					$author$project$Ui$Form$Group$inputSpanMd(9),
					$author$project$Ui$Form$Group$required(true)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Components$Patient$AddSponsorshipModal$CompanyResourceFilterMsg,
					A2(
						$author$project$Components$ResourceFilter$Company$view,
						_List_fromArray(
							[
								$author$project$Components$ResourceFilter$style(0)
							]),
						companyResourceFilter))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Patient$AddSponsorshipModal$DivisionSelected = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Patient$AddSponsorshipModal$divisionOptions = F2(
	function (requiresEmployeeDivisions, divisions) {
		var optionsList = A2(
			$elm$core$List$map,
			function (division) {
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$EmployeeDivision$All$id(division)),
					$author$project$Api$Provider$EmployeeDivision$All$name(division));
			},
			divisions);
		return requiresEmployeeDivisions ? optionsList : A2(
			$elm$core$List$cons,
			A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(''),
				''),
			optionsList);
	});
var $author$project$Components$Patient$AddSponsorshipModal$viewDivisionsOptions = function (model) {
	if (model.ad6) {
		var _v0 = model.zr;
		if (_v0.$ === 3) {
			var divisions = _v0.a;
			return ($elm$core$List$length(divisions) > 0) ? A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Division'),
						$author$project$Ui$Form$Group$labelSpanMd(3),
						$author$project$Ui$Form$Group$inputSpanMd(9),
						$author$project$Ui$Form$Group$required(model.$F)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Select$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Select$value(model.fc),
								$author$project$Ui$Form$Select$onChange($author$project$Components$Patient$AddSponsorshipModal$DivisionSelected)
							]),
						A2($author$project$Components$Patient$AddSponsorshipModal$divisionOptions, model.$F, divisions))
					])) : $author$project$Utils$Html$empty;
		} else {
			return $author$project$Utils$Html$empty;
		}
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Patient$AddSponsorshipModal$SubscriberCompanyAccountSelected = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Patient$AddSponsorshipModal$companyAccountOptions = function (companyAccounts) {
	return A2(
		$elm$core$List$map,
		function (companyAccount) {
			return A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(
					$author$project$Api$Provider$CompanyAccount$ForPatient$id(companyAccount)),
				$author$project$Api$Provider$Company$Min$name(
					$author$project$Api$Provider$CompanyAccount$ForPatient$company(companyAccount)));
		},
		companyAccounts);
};
var $author$project$Components$Patient$AddSponsorshipModal$viewPatientCompanyAccountOptions = function (model) {
	var _v0 = model.lC;
	if (!_v0.$) {
		var accounts = _v0.a;
		return ($elm$core$List$length(accounts) > 1) ? A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Company'),
					$author$project$Ui$Form$Group$labelSpanMd(3),
					$author$project$Ui$Form$Group$inputSpanMd(9),
					$author$project$Ui$Form$Group$required(true)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Select$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Select$value(model.hx),
							$author$project$Ui$Form$Select$onChange($author$project$Components$Patient$AddSponsorshipModal$SubscriberCompanyAccountSelected)
						]),
					$author$project$Components$Patient$AddSponsorshipModal$companyAccountOptions(accounts))
				])) : $author$project$Utils$Html$empty;
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Patient$AddSponsorshipModal$viewSubscriberOptions = function (model) {
	var _v0 = model.lD;
	if (!_v0.$) {
		var subscriberResourceFilter = _v0.a;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Dependent of'),
					$author$project$Ui$Form$Group$labelSpanMd(3),
					$author$project$Ui$Form$Group$inputSpanMd(9),
					$author$project$Ui$Form$Group$required(true)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Components$Patient$AddSponsorshipModal$SubscriberResourceFilterMsg,
					A2(
						$author$project$Components$ResourceFilter$Patient$view,
						_List_fromArray(
							[
								$author$project$Components$ResourceFilter$style(0)
							]),
						subscriberResourceFilter))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Patient$AddSponsorshipModal$TypeSelected = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Patient$AddSponsorshipModal$typeToLabel = function (t) {
	switch (t) {
		case 0:
			return 'Employee';
		case 1:
			return 'Adult';
		default:
			return 'Child';
	}
};
var $author$project$Components$Patient$AddSponsorshipModal$typeLabels = _List_fromArray(
	[
		$author$project$Components$Patient$AddSponsorshipModal$typeToLabel(0),
		$author$project$Components$Patient$AddSponsorshipModal$typeToLabel(1),
		$author$project$Components$Patient$AddSponsorshipModal$typeToLabel(2)
	]);
var $author$project$Components$Patient$AddSponsorshipModal$typeOptions = A2(
	$elm$core$List$map,
	function (typeStr) {
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(typeStr),
			typeStr);
	},
	$author$project$Components$Patient$AddSponsorshipModal$typeLabels);
var $author$project$Components$Patient$AddSponsorshipModal$viewTypeOptions = function (model) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Type'),
				$author$project$Ui$Form$Group$labelSpanMd(3),
				$author$project$Ui$Form$Group$inputSpanMd(9),
				$author$project$Ui$Form$Group$required(true)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Select$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Select$value(
						$elm$core$Maybe$Just(
							$author$project$Components$Patient$AddSponsorshipModal$typeToLabel(model.uu))),
						$author$project$Ui$Form$Select$onChange($author$project$Components$Patient$AddSponsorshipModal$TypeSelected)
					]),
				$author$project$Components$Patient$AddSponsorshipModal$typeOptions)
			]));
};
var $author$project$Components$Patient$AddSponsorshipModal$view = function (_v0) {
	var model = _v0;
	if (model.Yn) {
		var _v1 = function () {
			var _v2 = model.alH;
			if (!_v2.$) {
				var msg = _v2.a;
				return _Utils_Tuple2(true, msg);
			} else {
				var msg = _v2.a;
				return _Utils_Tuple2(false, msg);
			}
		}();
		var canSubmit = _v1.a;
		var statusBadge = _v1.b;
		var footerContent = _List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Cancel and close modal'},
				_List_fromArray(
					[
						$author$project$Ui$Button$onClick($author$project$Components$Patient$AddSponsorshipModal$Closed)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Cancel')
					])),
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Link employer to company'},
				_List_fromArray(
					[
						$author$project$Ui$Button$success,
						$author$project$Ui$Button$disabled(!canSubmit),
						$author$project$Ui$Button$onClick($author$project$Components$Patient$AddSponsorshipModal$Submitted)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Add to company')
					]))
			]);
		var body = A2(
			$author$project$Ui$Form$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$onSubmit($author$project$Components$Patient$AddSponsorshipModal$Submitted)
				]),
			A2(
				$author$project$Utils$Maybe$appendMaybe,
				statusBadge,
				_List_fromArray(
					[
						$author$project$Components$Patient$AddSponsorshipModal$viewTypeOptions(model),
						$author$project$Components$Patient$AddSponsorshipModal$viewCompanyOptions(model),
						$author$project$Components$Patient$AddSponsorshipModal$viewSubscriberOptions(model),
						$author$project$Components$Patient$AddSponsorshipModal$viewDivisionsOptions(model),
						$author$project$Components$Patient$AddSponsorshipModal$viewPatientCompanyAccountOptions(model)
					])));
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$Patient$AddSponsorshipModal$Closed,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('Link Employer')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[body])),
					$author$project$Ui$Modal$footer(footerContent)
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Top$viewAddSponsorshipModal = function (model) {
	var _v0 = model.dU;
	if (!_v0.$) {
		var modal = _v0.a;
		return A2(
			$elm$html$Html$map,
			$author$project$Pages$Patients$PatientId_String$Top$AddSponsorshipModalMsg,
			$author$project$Components$Patient$AddSponsorshipModal$view(modal));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Top$PatientValueCopiedToClipboard = function (a) {
	return {$: 52, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$viewCopyButton = F2(
	function (description, value) {
		return ($elm$core$String$length(
			$elm$core$String$trim(value)) > 0) ? A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$ml2]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{mm: 'Copy ' + description},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$icon($author$project$Ui$Icon$copy),
							$author$project$Ui$Button$onClick(
							$author$project$Pages$Patients$PatientId_String$Top$PatientValueCopiedToClipboard(value))
						]),
					_List_Nil)
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Components$AddressDisplay$formatSegment = function (maybeSegment) {
	return function (segment) {
		return $elm$core$String$isEmpty(segment) ? '' : segment;
	}(
		A2($elm$core$Maybe$withDefault, '', maybeSegment));
};
var $author$project$Components$AddressDisplay$addCommaIfNotEmpty = function (segment) {
	var formatted = $author$project$Components$AddressDisplay$formatSegment(segment);
	return $elm$core$String$isEmpty(formatted) ? '' : (formatted + ', ');
};
var $author$project$Components$AddressDisplay$viewOneLineAddress = function (address) {
	return $author$project$Components$AddressDisplay$addCommaIfNotEmpty(
		$author$project$Api$Common$Address$Shared$line1(address)) + ($author$project$Components$AddressDisplay$addCommaIfNotEmpty(
		$author$project$Api$Common$Address$Shared$line2(address)) + ($author$project$Components$AddressDisplay$addCommaIfNotEmpty(
		$author$project$Api$Common$Address$Shared$city(address)) + ($author$project$Components$AddressDisplay$formatSegment(
		$author$project$Api$Common$Address$Shared$state(address)) + (' ' + $author$project$Components$AddressDisplay$formatSegment(
		$author$project$Api$Common$Address$Shared$zip(address))))));
};
var $author$project$Pages$Patients$PatientId_String$Top$viewAddressesSection = F2(
	function (practice, patient) {
		var primaryAddressTitle = $author$project$Api$Provider$Patient$One$usesBillingAddress(patient) ? A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-label-md'),
					$elm$html$Html$Attributes$class('mb-025')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Primary Address')
				])) : $author$project$Utils$Html$empty;
		var billingAddress = function () {
			var _v2 = _Utils_Tuple2(
				$author$project$Api$Provider$Patient$One$usesBillingAddress(patient),
				$author$project$Api$Provider$Patient$One$billingAddress(patient));
			if (_v2.a && (!_v2.b.$)) {
				var billingAddress_ = _v2.b.a;
				var billingAddressTitle = $author$project$Api$Provider$Practice$One$labelBillingAsShipping(practice) ? 'Shipping Address' : 'Billing Address';
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-label-md'),
									$elm$html$Html$Attributes$class('mb-025')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(billingAddressTitle)
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$itemsEnd]),
							_List_fromArray(
								[
									$author$project$Components$AddressDisplay$view(billingAddress_),
									A2(
									$author$project$Pages$Patients$PatientId_String$Top$viewCopyButton,
									'patient billing address',
									$author$project$Components$AddressDisplay$viewOneLineAddress(billingAddress_))
								]))
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}();
		var _v0 = function () {
			var _v1 = $author$project$Api$Provider$Patient$One$address(patient);
			if (!_v1.$) {
				var address = _v1.a;
				return _Utils_Tuple2(
					$author$project$Components$AddressDisplay$view(address),
					A2(
						$author$project$Pages$Patients$PatientId_String$Top$viewCopyButton,
						'patient primary address',
						$author$project$Components$AddressDisplay$viewOneLineAddress(address)));
			} else {
				return _Utils_Tuple2($author$project$Utils$Html$empty, $author$project$Utils$Html$empty);
			}
		}();
		var primaryAddress = _v0.a;
		var primaryAddressCopyButton = _v0.b;
		return A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(6)
						]),
					_List_fromArray(
						[
							primaryAddressTitle,
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$itemsEnd]),
							_List_fromArray(
								[primaryAddress, primaryAddressCopyButton]))
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(6)
						]),
					_List_fromArray(
						[billingAddress]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Top$RequestPendingDocsAcceptanceButtonClicked = {$: 15};
var $author$project$Ui$Skeleton$ifLoading = F3(
	function (data, skeleton, content) {
		switch (data.$) {
			case 1:
				return skeleton;
			case 3:
				return content;
			default:
				return $elm$html$Html$text('');
		}
	});
var $author$project$Api$Provider$PatientDocument$All$name = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$PatientDocument$One$name(one);
};
var $author$project$Api$Provider$PatientDocument$All$signedAt = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$PatientDocument$One$signedAt(one);
};
var $author$project$Api$Provider$PatientDocument$All$status = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$PatientDocument$One$status(one);
};
var $author$project$Api$Provider$PatientDocument$All$id = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$PatientDocument$One$id(one);
};
var $author$project$Pages$Patients$PatientId_String$Top$viewAgreementLink = F2(
	function (patient, document) {
		return $author$project$Api$Provider$Patient$One$archived(patient) ? $author$project$Utils$Html$empty : A3(
			$author$project$Ui$Link$route,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__Agreements__AgreementId_String__Top(
				{
					Ll: $author$project$Api$Provider$PatientDocument$All$id(document),
					YZ: $author$project$Api$Provider$Patient$One$id(patient)
				}),
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('View Details')
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewAgreement = F3(
	function (timeFormatter, patient, document) {
		var signedAt = A2(
			$elm$core$Maybe$map,
			timeFormatter(0),
			$author$project$Api$Provider$PatientDocument$All$signedAt(document));
		var signedAtText = function () {
			if (!signedAt.$) {
				var text = signedAt.a;
				return ' on ' + text;
			} else {
				return '';
			}
		}();
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label(
					$author$project$Api$Provider$PatientDocument$All$name(document)),
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$labelClass('control-label')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$spaceBetween]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Badge$fromString,
											_List_Nil,
											$author$project$Api$Provider$PatientDocument$All$status(document)),
											A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[$author$project$Ui$Typography$small]),
											signedAtText)
										])),
									A2($author$project$Pages$Patients$PatientId_String$Top$viewAgreementLink, patient, document)
								]))
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewAgreementsLastRequestSent = function (model) {
	var _v0 = model.tH;
	if (!_v0.$) {
		var sentAt = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				model.J7(1),
				model.tH));
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$justifyRight]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
					_List_fromArray(
						[
							$elm$html$Html$text('Last request sent ' + (sentAt + '.'))
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Api$Provider$Patient$Shared$hipaaAuthorizationAccepted = function (_v0) {
	var shared = _v0;
	return shared.TB;
};
var $author$project$Api$Provider$Patient$One$hipaaAuthorizationAccepted = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$hipaaAuthorizationAccepted(shared);
};
var $author$project$Api$Provider$Patient$Shared$hipaaAuthorizationAcceptedAt = function (_v0) {
	var shared = _v0;
	return shared.TC;
};
var $author$project$Api$Provider$Patient$One$hipaaAuthorizationAcceptedAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$hipaaAuthorizationAcceptedAt(shared);
};
var $author$project$Pages$Patients$PatientId_String$Top$AcceptEphiWaiverClicked = {$: 46};
var $author$project$Pages$Patients$PatientId_String$Top$RemoveEphiWaiverClicked = {$: 47};
var $author$project$Pages$Patients$PatientId_String$Top$viewEphiWaiverLink = function (patient) {
	var _v0 = $author$project$Api$Provider$Patient$One$hipaaAuthorizationAccepted(patient) ? _Utils_Tuple2('Remove ePHI waiver', $author$project$Pages$Patients$PatientId_String$Top$RemoveEphiWaiverClicked) : _Utils_Tuple2('Accept ePHI waiver', $author$project$Pages$Patients$PatientId_String$Top$AcceptEphiWaiverClicked);
	var linkText = _v0.a;
	var linkMsg = _v0.b;
	return A3(
		$author$project$Ui$Button$view,
		{mm: linkText},
		_List_fromArray(
			[
				$author$project$Ui$Button$onClick(linkMsg),
				$author$project$Ui$Button$sm
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(linkText)
			]));
};
var $author$project$Pages$Patients$PatientId_String$Top$viewEphiWaiver = function (model) {
	var accepted = $author$project$Api$Provider$Patient$One$hipaaAuthorizationAccepted(model.YY);
	var signedAt = accepted ? A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function (date) {
				return ' on ' + A2(model.J7, 0, date);
			},
			$author$project$Api$Provider$Patient$One$hipaaAuthorizationAcceptedAt(model.YY))) : '';
	var status = accepted ? 'accepted' : 'not_accepted';
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('ePHI Waiver'),
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$spaceBetween]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$Ui$Badge$fromString, _List_Nil, status),
										A2(
										$author$project$Ui$Typography$text,
										_List_fromArray(
											[$author$project$Ui$Typography$small]),
										signedAt)
									])),
								A2(
								$author$project$Permission$hideIfReadOnly,
								model.aa4,
								$author$project$Pages$Patients$PatientId_String$Top$viewEphiWaiverLink(model.YY))
							]))
					]))
			]));
};
var $author$project$Pages$Patients$PatientId_String$Top$ToggleViewOutdatedDocuments = {$: 33};
var $author$project$Pages$Patients$PatientId_String$Top$viewOutdatedAgreements = function (_v0) {
	var outdatedPatientDocuments = _v0.tz;
	var outdatedDocumentsVisible = _v0.ty;
	var patient = _v0.YY;
	var timeFormatter = _v0.J7;
	if (outdatedPatientDocuments.$ === 3) {
		var documents = outdatedPatientDocuments.a;
		return ($elm$core$List$length(documents) > 0) ? A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					function () {
					var _v2 = outdatedDocumentsVisible ? _Utils_Tuple2(
						'Hide additional signed agreements ',
						$author$project$Ui$Icon$chevron(
							_List_fromArray(
								[$author$project$Ui$Icon$rotate180]))) : _Utils_Tuple2(
						'Show additional signed agreements ',
						$author$project$Ui$Icon$chevronDown(_List_Nil));
					var label = _v2.a;
					var icon = _v2.b;
					return A3(
						$author$project$Ui$Button$view,
						{mm: label},
						_List_fromArray(
							[
								$author$project$Ui$Button$styled(9),
								$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$ToggleViewOutdatedDocuments)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(label),
								icon
							]));
				}(),
					outdatedDocumentsVisible ? A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$prose,
							_List_fromArray(
								[$author$project$Ui$Element$mt1, $author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
							_List_fromArray(
								[
									$elm$html$Html$text('These are previously signed agreements that are no longer required for the patient. These agreements may be related to an old plan or location assignment, or from agreements that have since become unpublished.')
								])),
							A2(
							$author$project$Ui$Form$view,
							_List_Nil,
							A2(
								$elm$core$List$map,
								A2($author$project$Pages$Patients$PatientId_String$Top$viewAgreement, timeFormatter, patient),
								documents))
						])) : $author$project$Utils$Html$empty
				])) : $author$project$Utils$Html$empty;
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Top$viewAgreementsSection = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		A2(
			$elm$core$List$cons,
			$author$project$Ui$HorizontalRule$view(_List_Nil),
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Panel$title(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Skeleton$ifLoading,
							model.oW,
							$author$project$Ui$Skeleton$text(
								_List_fromArray(
									[
										$author$project$Ui$Skeleton$spanFromText('Agreements')
									])),
							$elm$html$Html$text('Agreements'))
						])),
				function () {
					var _v0 = model.oW;
					switch (_v0.$) {
						case 3:
							var documents = _v0.a;
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Form$view,
									_List_Nil,
									$elm$core$List$concat(
										_List_fromArray(
											[
												A2(
												$elm$core$List$map,
												A2($author$project$Pages$Patients$PatientId_String$Top$viewAgreement, model.J7, model.YY),
												documents),
												_List_fromArray(
												[
													$author$project$Pages$Patients$PatientId_String$Top$viewEphiWaiver(model)
												])
											]))),
									A2(
									$author$project$Permission$hideIfReadOnly,
									model.aa4,
									$author$project$Pages$Patients$PatientId_String$Top$viewOutdatedAgreements(model)),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$justifyRight]),
									_List_fromArray(
										[
											A2(
											$author$project$Permission$hideIfReadOnly,
											model.aa4,
											A3(
												$author$project$Ui$Button$view,
												{mm: 'Request acceptance by email'},
												_List_fromArray(
													[
														$author$project$Ui$Button$primary,
														$author$project$Ui$Button$disabled(
														$author$project$Api$Provider$Patient$One$archived(model.YY)),
														$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$RequestPendingDocsAcceptanceButtonClicked),
														$author$project$Ui$Button$loading(model.li),
														$author$project$Ui$Button$sm,
														$author$project$Ui$Button$icon($author$project$Ui$Icon$send)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Request acceptance by email')
													])))
										])),
									$author$project$Pages$Patients$PatientId_String$Top$viewAgreementsLastRequestSent(model)
								]);
						case 1:
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Form$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Group$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Group$labelSkeleton('Agreement'),
													$author$project$Ui$Form$Group$labelSpanSm(3),
													$author$project$Ui$Form$Group$inputSpanSm(9)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Form$Static$view,
													_List_Nil,
													_List_fromArray(
														[
															$author$project$Ui$Skeleton$text(
															_List_fromArray(
																[
																	$author$project$Ui$Skeleton$span(3)
																]))
														]))
												])),
											A2(
											$author$project$Ui$Form$Group$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Group$labelSkeleton('Other Agreement'),
													$author$project$Ui$Form$Group$labelSpanSm(3),
													$author$project$Ui$Form$Group$inputSpanSm(9)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Form$Static$view,
													_List_Nil,
													_List_fromArray(
														[
															$author$project$Ui$Skeleton$text(
															_List_fromArray(
																[
																	$author$project$Ui$Skeleton$span(4)
																]))
														]))
												]))
										]))
								]);
						default:
							return _List_Nil;
					}
				}())));
};
var $author$project$Ui$Button$Outline = 7;
var $author$project$Pages$Patients$PatientId_String$Top$RestorePatientButtonClicked = {$: 19};
var $author$project$Pages$Patients$PatientId_String$Top$viewArchivedPatientAlert = function (patient) {
	return $author$project$Api$Provider$Patient$One$archived(patient) ? A2(
		$author$project$Ui$Alert$danger,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$row,
				_List_fromArray(
					[$author$project$Ui$Grid$rowItemsCenter]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanSm(1),
								$author$project$Ui$Grid$span(2),
								$author$project$Ui$Grid$textCenter
							]),
						_List_fromArray(
							[
								$author$project$Ui$Icon$warning(
								_List_fromArray(
									[$author$project$Ui$Icon$lg, $author$project$Ui$Icon$danger]))
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanSm(8),
								$author$project$Ui$Grid$span(10)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('This patient has been archived and is currently read-only.')
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanSm(3)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$flex, $author$project$Ui$Element$justifyRight]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{
											mm: 'Restore ' + $author$project$Api$Provider$Patient$One$name(patient)
										},
										_List_fromArray(
											[
												$author$project$Ui$Button$styled(7),
												$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$RestorePatientButtonClicked)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												'Restore ' + $author$project$Api$Provider$Patient$One$name(patient))
											]))
									]))
							]))
					]))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Pages$Patients$PatientId_String$Top$viewCreateMembershipModal = function (model) {
	var _v0 = model.iW;
	if (!_v0.$) {
		var modal = _v0.a;
		return A2(
			$elm$html$Html$map,
			$author$project$Pages$Patients$PatientId_String$Top$CreateMembershipModalMsg,
			$author$project$Components$Patient$CreateMembershipModal$view(modal));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Api$Provider$Patient$One$customForms = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$One$record_,
	function ($) {
		return $.Pn;
	});
var $author$project$Api$Provider$Practice$One$customForms = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Pn;
	});
var $author$project$Api$Provider$CustomForm$mergeForms = F2(
	function (practiceForms, patientForms) {
		var mergedForms = _Utils_ap(patientForms, practiceForms);
		return A2(
			$elm_community$list_extra$List$Extra$uniqueBy,
			function (_v0) {
				var record = _v0;
				return record.ahP;
			},
			mergedForms);
	});
var $author$project$Api$Provider$CustomForm$formResponseId = function (_v0) {
	var record = _v0;
	return record.zJ;
};
var $author$project$Api$Provider$CustomForm$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$CustomForm$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$CustomForm$questions = function (_v0) {
	var record = _v0;
	return record.DF;
};
var $author$project$Pages$Patients$PatientId_String$Top$OpenEditCustomFormAnswerModal = F3(
	function (a, b, c) {
		return {$: 38, a: a, b: b, c: c};
	});
var $author$project$Utils$String$boolStringToYesNo = function (boolString) {
	return (boolString === 'true') ? 'Yes' : 'No';
};
var $author$project$Pages$Patients$PatientId_String$Top$viewCustomFormAnswer = F2(
	function (answer, type_) {
		var text_ = function () {
			if (!type_) {
				return $author$project$Utils$String$boolStringToYesNo(answer);
			} else {
				return answer;
			}
		}();
		return A2(
			$author$project$Ui$Typography$p,
			_List_fromArray(
				[
					$author$project$Ui$Typography$phi(true)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(text_)
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewCustomFormQuestion = F3(
	function (formId, formResponseId, question) {
		return A2(
			$author$project$Ui$Form$Static$view,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanMd(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Provider$CustomForm$title(question))
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanMd(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$justifyRight]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{mm: 'Edit answer'},
											_List_fromArray(
												[
													$author$project$Ui$Button$sm,
													$author$project$Ui$Button$onClick(
													A3($author$project$Pages$Patients$PatientId_String$Top$OpenEditCustomFormAnswerModal, question, formId, formResponseId))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Edit Answer')
												]))
										]))
								]))
						])),
				$elm$core$List$isEmpty(
					$author$project$Api$Provider$CustomForm$answers(question)) ? _List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$italic, $author$project$Ui$Typography$muted]),
						_List_fromArray(
							[
								$elm$html$Html$text('None')
							]))
					]) : A2(
					$elm$core$List$map,
					function (answer) {
						return A2(
							$author$project$Pages$Patients$PatientId_String$Top$viewCustomFormAnswer,
							$author$project$Api$Provider$CustomForm$answerText(answer),
							$author$project$Api$Provider$CustomForm$questionType(question));
					},
					$author$project$Api$Provider$CustomForm$answers(question))));
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewCustomForm = function (customForm) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label(
				$author$project$Api$Provider$CustomForm$name(customForm)),
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				A2(
					$elm$core$List$map,
					A2(
						$author$project$Pages$Patients$PatientId_String$Top$viewCustomFormQuestion,
						$author$project$Api$Provider$CustomForm$id(customForm),
						$author$project$Api$Provider$CustomForm$formResponseId(customForm)),
					$author$project$Api$Provider$CustomForm$questions(customForm)))
			]));
};
var $author$project$Pages$Patients$PatientId_String$Top$viewCustomFormsSection = function (_v0) {
	var patient = _v0.YY;
	var practice = _v0.ZV;
	var customForms = A2(
		$author$project$Api$Provider$CustomForm$mergeForms,
		$author$project$Api$Provider$Practice$One$customForms(practice),
		$author$project$Api$Provider$Patient$One$customForms(patient));
	return $elm$core$List$isEmpty(customForms) ? $author$project$Utils$Html$empty : A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				$author$project$Ui$Panel$title(
				_List_fromArray(
					[
						$elm$html$Html$text('Additional Info')
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Top$viewCustomForm, customForms))
			]));
};
var $author$project$Pages$Patients$PatientId_String$Top$viewDetachPatientModal = function (model) {
	return model.jk ? A2(
		$author$project$Components$HiConfirm$modal,
		$author$project$Pages$Patients$PatientId_String$Top$ConfirmDetachPatientModalClicked(
			$author$project$Api$Provider$Patient$One$id(model.YY)),
		_List_fromArray(
			[
				$author$project$Components$HiConfirm$verb('detach'),
				$author$project$Components$HiConfirm$noun('patient'),
				$author$project$Components$HiConfirm$customMessage(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('This patient will become independent of the network and be attached to your practice only.')
									]))
							]))
					]))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Api$Provider$Patient$One$dpcPatient = function (_v0) {
	var record = _v0.b;
	return record.QW;
};
var $author$project$Ui$Form$Static$NoValue = {$: 3};
var $author$project$Ui$Form$Static$noValue = $author$project$Ui$Form$Static$NoValue;
var $author$project$Api$Provider$Patient$DpcPatient$status = function (_v0) {
	var dpc = _v0;
	return dpc.alH;
};
var $author$project$Pages$Patients$PatientId_String$Top$viewDpcPractice = F2(
	function (practice, patient) {
		var _v0 = $author$project$Api$Provider$Practice$One$accountType(practice);
		if (_v0 === 2) {
			return A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('DPC Practice'),
						$author$project$Ui$Form$Group$labelSpanSm(3),
						$author$project$Ui$Form$Group$inputSpanSm(9)
					]),
				_List_fromArray(
					[
						function () {
						var _v1 = $author$project$Api$Provider$Patient$One$knownPractice(patient);
						if (!_v1.$) {
							var knownPractice = _v1.a;
							return A2(
								$author$project$Ui$Form$Static$view,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Api$Provider$KnownPractice$Shared$name(knownPractice) + ' '),
										function () {
										var _v2 = $author$project$Api$Provider$Patient$One$dpcPatient(patient);
										if (!_v2.$) {
											var dpcPatient = _v2.a;
											var _v3 = $author$project$Api$Provider$Patient$DpcPatient$status(dpcPatient);
											if (!_v3.$) {
												var status = _v3.a;
												return A2($author$project$Ui$Badge$fromString, _List_Nil, status);
											} else {
												return $author$project$Utils$Html$empty;
											}
										} else {
											return $author$project$Utils$Html$empty;
										}
									}()
									]));
						} else {
							return A2(
								$author$project$Ui$Form$Static$view,
								_List_fromArray(
									[$author$project$Ui$Form$Static$noValue]),
								_List_Nil);
						}
					}()
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$Patient$EditAthenaIdModal$FormUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Patient$EditAthenaIdModal$Submit = {$: 2};
var $author$project$Components$Patient$EditAthenaIdModal$view = function (_v0) {
	var model = _v0;
	if (model.Yn) {
		var footerContent = _List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Cancel and close modal'},
				_List_fromArray(
					[
						$author$project$Ui$Button$onClick($author$project$Components$Patient$EditAthenaIdModal$Close)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Cancel')
					])),
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Save'},
				_List_fromArray(
					[
						$author$project$Ui$Button$primary,
						$author$project$Ui$Button$onClick($author$project$Components$Patient$EditAthenaIdModal$Submit)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Save')
					]))
			]);
		var enterpriseID = $author$project$Api$Provider$IntegrationRecord$All$integrationRecordId(model.sL);
		var body = _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Partner IDs'),
						$author$project$Ui$Form$Group$labelSpanSm(4)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('You can find patient ID on athena’s patient chart next to their age and date of birth.')
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted, $author$project$Ui$Typography$m0]),
						_List_fromArray(
							[
								$elm$html$Html$text('Changing the linked patient id will immediately push data to athena for this patient. If any conflicts arise, athena’s data will be automatically overwritten.')
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label(''),
						$author$project$Ui$Form$Group$labelSpanSm(4)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$group(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$addon(
								_List_fromArray(
									[
										$elm$html$Html$text('#')
									])),
								$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$value(model.th),
										$author$project$Ui$Form$Input$onInput($author$project$Components$Patient$EditAthenaIdModal$FormUpdated)
									]))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label(''),
						$author$project$Ui$Form$Group$labelSpanSm(4)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$group(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$addon(
								_List_fromArray(
									[
										$elm$html$Html$text('E#')
									])),
								$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$value(
										A2($elm$core$Maybe$withDefault, '', enterpriseID)),
										$author$project$Ui$Form$Input$disabled(true)
									]))
							]))
					]))
			]);
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$Patient$EditAthenaIdModal$Close,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('Edit Partner ID')
						])),
					$author$project$Ui$Modal$body(body),
					$author$project$Ui$Modal$footer(footerContent)
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Top$viewEditAthenaIdModal = function (model) {
	var _v0 = model.ju;
	if (!_v0.$) {
		var modal = _v0.a;
		return A2(
			$elm$html$Html$map,
			$author$project$Pages$Patients$PatientId_String$Top$EditPartnerIdModalMsg,
			$author$project$Components$Patient$EditAthenaIdModal$view(modal));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Patient$EditCustomFormAnswerModal$MultipleStringAnswerCreated = {$: 4};
var $author$project$Components$Patient$EditCustomFormAnswerModal$Update = {$: 1};
var $author$project$Components$Patient$EditCustomFormAnswerModal$BooleanAnswerChanged = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Patient$EditCustomFormAnswerModal$toggleBooleanAnswer = F3(
	function (answer, newAnswer, displayAnswer) {
		return A3(
			$author$project$Ui$Button$view,
			{mm: displayAnswer},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(
						$author$project$Api$Provider$CustomForm$answerText(answer),
						newAnswer)),
					$author$project$Ui$Button$onClick(
					A2($author$project$Components$Patient$EditCustomFormAnswerModal$BooleanAnswerChanged, answer, newAnswer))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$text,
					_List_fromArray(
						[
							$author$project$Ui$Typography$phi(true)
						]),
					displayAnswer)
				]));
	});
var $author$project$Components$Patient$EditCustomFormAnswerModal$viewBooleanAnswers = function (formAnswer) {
	return $author$project$Ui$Button$group(
		_List_fromArray(
			[
				A3($author$project$Components$Patient$EditCustomFormAnswerModal$toggleBooleanAnswer, formAnswer, 'true', 'Yes'),
				A3($author$project$Components$Patient$EditCustomFormAnswerModal$toggleBooleanAnswer, formAnswer, 'false', 'No')
			]));
};
var $author$project$Components$Patient$EditCustomFormAnswerModal$MultipleStringAnswerDeleted = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Patient$EditCustomFormAnswerModal$MultipleStringAnswerUpdated = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Components$Patient$EditCustomFormAnswerModal$viewStringInput = F2(
	function (index, value) {
		return $author$project$Ui$Form$Input$view(
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$value(value),
					$author$project$Ui$Form$Input$onInput(
					$author$project$Components$Patient$EditCustomFormAnswerModal$MultipleStringAnswerUpdated(index)),
					$author$project$Ui$Form$Input$phi(true)
				]));
	});
var $author$project$Components$Patient$EditCustomFormAnswerModal$viewMultipleStringAnswer = F3(
	function (index, value, isDestroyed) {
		if ((!isDestroyed.$) && isDestroyed.a) {
			return $author$project$Utils$Html$empty;
		} else {
			return A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanSm(11)
							]),
						_List_fromArray(
							[
								A2($author$project$Components$Patient$EditCustomFormAnswerModal$viewStringInput, index, value)
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanSm(1)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$mt3]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Delete multiple string answer'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$sm,
												$author$project$Ui$Button$onClick(
												$author$project$Components$Patient$EditCustomFormAnswerModal$MultipleStringAnswerDeleted(index)),
												$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
											]),
										_List_Nil)
									]))
							]))
					]));
		}
	});
var $author$project$Components$Patient$EditCustomFormAnswerModal$viewStringAnswer = F2(
	function (index, value) {
		return A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanSm(12)
						]),
					_List_fromArray(
						[
							A2($author$project$Components$Patient$EditCustomFormAnswerModal$viewStringInput, index, value)
						]))
				]));
	});
var $author$project$Components$Patient$EditCustomFormAnswerModal$viewBody = function (model) {
	return A2(
		$author$project$Ui$Form$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$onSubmit($author$project$Components$Patient$EditCustomFormAnswerModal$Update)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Answers to the Question'),
						$author$project$Ui$Form$Group$labelSpanSm(3),
						$author$project$Ui$Form$Group$inputSpanSm(9)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						A2(
							$elm$core$List$cons,
							A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$bold]),
								_List_fromArray(
									[
										$elm$html$Html$text(model.ac9)
									])),
							function () {
								var _v0 = model.amg;
								switch (_v0) {
									case 0:
										return A2($elm$core$List$map, $author$project$Components$Patient$EditCustomFormAnswerModal$viewBooleanAnswers, model.rk);
									case 2:
										return A2(
											$elm$core$List$indexedMap,
											F2(
												function (index, answer) {
													return A2(
														$author$project$Components$Patient$EditCustomFormAnswerModal$viewStringAnswer,
														index,
														$author$project$Api$Provider$CustomForm$answerText(answer));
												}),
											model.rk);
									default:
										return _Utils_ap(
											A2(
												$elm$core$List$indexedMap,
												F2(
													function (index, answer) {
														return A3(
															$author$project$Components$Patient$EditCustomFormAnswerModal$viewMultipleStringAnswer,
															index,
															$author$project$Api$Provider$CustomForm$answerText(answer),
															$author$project$Api$Provider$CustomForm$destroy(answer));
													}),
												model.rk),
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Button$view,
													{mm: 'Add answer'},
													_List_fromArray(
														[
															$author$project$Ui$Button$onClick($author$project$Components$Patient$EditCustomFormAnswerModal$MultipleStringAnswerCreated),
															$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Add Answer')
														]))
												]));
								}
							}()))
					]))
			]));
};
var $author$project$Components$Patient$EditCustomFormAnswerModal$viewFooter = _List_fromArray(
	[
		A3(
		$author$project$Ui$Button$view,
		{mm: 'Cancel and close modal'},
		_List_fromArray(
			[
				$author$project$Ui$Button$onClick($author$project$Components$Patient$EditCustomFormAnswerModal$Close)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Cancel')
			])),
		A3(
		$author$project$Ui$Button$view,
		{mm: 'Update'},
		_List_fromArray(
			[
				$author$project$Ui$Button$primary,
				$author$project$Ui$Button$onClick($author$project$Components$Patient$EditCustomFormAnswerModal$Update)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Update')
			]))
	]);
var $author$project$Components$Patient$EditCustomFormAnswerModal$view = function (model) {
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Patient$EditCustomFormAnswerModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Edit Answer')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						$author$project$Components$Patient$EditCustomFormAnswerModal$viewBody(model)
					])),
				$author$project$Ui$Modal$footer($author$project$Components$Patient$EditCustomFormAnswerModal$viewFooter)
			]));
};
var $author$project$Pages$Patients$PatientId_String$Top$viewEditCustomFormAnswerModal = function (model) {
	var _v0 = model.gj;
	if (!_v0.$) {
		var modal = _v0.a;
		return A2(
			$elm$html$Html$map,
			$author$project$Pages$Patients$PatientId_String$Top$EditCustomFormAnswerModalMsg,
			$author$project$Components$Patient$EditCustomFormAnswerModal$view(modal));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Top$viewElationForcePushConfirmModal = function (model) {
	return model.nO ? A2(
		$author$project$Components$HiConfirm$modal,
		$author$project$Pages$Patients$PatientId_String$Top$ElationForcePushConfirmationModalClosed,
		_List_fromArray(
			[
				$author$project$Components$HiConfirm$verb('sync To'),
				$author$project$Components$HiConfirm$noun('elation'),
				$author$project$Components$HiConfirm$customMessage(
				_List_fromArray(
					[
						$elm$html$Html$text('You\'re about to sync to elation and override the conflicting values with their values here. This action cannot be undone.')
					]))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Pages$Patients$PatientId_String$Top$ResetBouncedEmail = {$: 67};
var $author$project$Api$Provider$EmailAddress$One$isRejected = function (_v0) {
	var record = _v0;
	return record.Va;
};
var $author$project$Api$Provider$EmailAddress$One$isUnsubscribed = function (_v0) {
	var record = _v0;
	return record.Vi;
};
var $author$project$Pages$Patients$PatientId_String$Top$viewEmailSection = F2(
	function (patient, emailAddressData) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_Nil,
			function () {
				if (emailAddressData.$ === 3) {
					if (!emailAddressData.a.$) {
						var emailAddress = emailAddressData.a.a;
						return _List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$itemsCenter]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Static$view,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$text,
												_List_fromArray(
													[
														$author$project$Ui$Typography$phi(true)
													]),
												$author$project$Api$Provider$EmailAddress$One$email(emailAddress)),
												$author$project$Api$Provider$EmailAddress$One$isRejected(emailAddress) ? A2(
												$author$project$Ui$Typography$span,
												_List_fromArray(
													[$author$project$Ui$Typography$muted]),
												_List_fromArray(
													[
														A3(
														$author$project$Ui$Popover$view,
														_List_fromArray(
															[$author$project$Ui$Popover$dark]),
														_List_fromArray(
															[
																$author$project$Ui$Icon$cross(
																_List_fromArray(
																	[$author$project$Ui$Icon$danger])),
																$elm$html$Html$text('Invalid')
															]),
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Popover$heading,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('Email is invalid and will not be used')
																	]))
															]))
													])) : $author$project$Utils$Html$empty
											])),
										A2(
										$author$project$Pages$Patients$PatientId_String$Top$viewCopyButton,
										'patient email',
										A2(
											$elm$core$Maybe$withDefault,
											'',
											$author$project$Api$Provider$Patient$One$email(patient)))
									])),
								A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[
										$author$project$Ui$Typography$phi(true)
									]),
								_List_fromArray(
									[
										$author$project$Api$Provider$EmailAddress$One$isBounced(emailAddress) ? A2(
										$author$project$Ui$Typography$span,
										_List_fromArray(
											[$author$project$Ui$Typography$muted]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Badge$view,
														_List_fromArray(
															[$author$project$Ui$Badge$danger]),
														_List_fromArray(
															[
																$elm$html$Html$text('Bounced')
															]))
													])),
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$mt3]),
												_List_fromArray(
													[
														A3(
														$author$project$Ui$Button$view,
														{mm: 'Reset bounced status'},
														_List_fromArray(
															[
																$author$project$Ui$Button$styled(7),
																$author$project$Ui$Button$primary,
																$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$ResetBouncedEmail),
																$author$project$Ui$Button$sm,
																$author$project$Ui$Button$icon($author$project$Ui$Icon$repeat)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Reset Bounced Status')
															]))
													]))
											])) : ($author$project$Api$Provider$EmailAddress$One$isUnsubscribed(emailAddress) ? A2(
										$author$project$Ui$Typography$p,
										_List_fromArray(
											[$author$project$Ui$Typography$muted]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Badge$view,
												_List_fromArray(
													[$author$project$Ui$Badge$warning]),
												_List_fromArray(
													[
														$elm$html$Html$text('Unsubscribed')
													]))
											])) : $author$project$Utils$Html$empty)
									]))
							]);
					} else {
						var _v1 = emailAddressData.a;
						return _List_fromArray(
							[$author$project$Utils$Html$empty]);
					}
				} else {
					return _List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$span(2)
										]))
								]))
						]);
				}
			}());
	});
var $author$project$Api$Common$EmergencyContact$Shared$name = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Common$EmergencyContact$Shared$record,
	function ($) {
		return $.Bq;
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewPhone = function (phone) {
	var formattedPhone = function (number) {
		return $author$project$Formatters$Phone$formatWithCountry(number) + (' (' + ($author$project$Formatters$PhoneType$toString(
			$author$project$Api$Common$Phone$Shared$type_(phone)) + ')'));
	};
	var _v0 = $author$project$Api$Common$Phone$Shared$number(phone);
	if (!_v0.$) {
		var number = _v0.a;
		return A2(
			$author$project$Ui$Typography$p,
			_List_fromArray(
				[
					$author$project$Ui$Typography$phi(true)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					formattedPhone(number)),
					A2(
					$author$project$Pages$Patients$PatientId_String$Top$viewCopyButton,
					'patient phone',
					$author$project$Formatters$Phone$formatWithCountry(number))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Top$viewEmergencyContact = function (emergencyContact) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$andThen,
					function (name) {
						return $elm$core$String$isEmpty(name) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$div,
								_List_Nil,
								$elm$core$List$singleton(
									$elm$html$Html$text(name))));
					},
					$author$project$Api$Common$EmergencyContact$Shared$name(emergencyContact)),
					A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Formatters$String$titleize,
						A2(
							$elm$core$Basics$composeR,
							$elm$html$Html$text,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$singleton,
								$elm$html$Html$div(_List_Nil)))),
					$author$project$Api$Common$EmergencyContact$Shared$relationship(emergencyContact)),
					A2(
					$elm$core$Maybe$map,
					function (email) {
						return A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(email),
									A2($author$project$Pages$Patients$PatientId_String$Top$viewCopyButton, 'emergency contact email', email)
								]));
					},
					$author$project$Api$Common$EmergencyContact$Shared$email(emergencyContact)),
					A2(
					$elm$core$Maybe$map,
					function (phone) {
						return $author$project$Pages$Patients$PatientId_String$Top$viewPhone(phone);
					},
					$author$project$Api$Common$EmergencyContact$Shared$phone(emergencyContact))
				])));
};
var $author$project$Api$Provider$Patient$One$isMaster = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$One$record_,
	function ($) {
		return $.UV;
	});
var $author$project$Pages$Patients$PatientId_String$Top$EngagementClicked = {$: 59};
var $author$project$Pages$Patients$PatientId_String$Top$viewEngagementBadge = function (status) {
	var _v0 = function () {
		switch (status) {
			case 'currently_engaged':
				return _Utils_Tuple2($author$project$Ui$Badge$success, 'Currently Engaged');
			case 'previously_engaged':
				return _Utils_Tuple2($author$project$Ui$Badge$primary, 'Previously Engaged');
			default:
				return _Utils_Tuple2($author$project$Ui$Badge$danger, 'Never Engaged');
		}
	}();
	var color = _v0.a;
	var engagementStatus = _v0.b;
	return A3(
		$author$project$Ui$Button$view,
		{mm: engagementStatus},
		_List_fromArray(
			[
				$author$project$Ui$Button$link,
				$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$EngagementClicked)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Badge$view,
				_List_fromArray(
					[color]),
				_List_fromArray(
					[
						$elm$html$Html$text(engagementStatus)
					]))
			]));
};
var $author$project$Api$Provider$Patient$Engagement$invoice = function (_v0) {
	var engagement = _v0;
	return engagement.Uk;
};
var $author$project$Api$Provider$Patient$Engagement$lastEngagementDate = function (_v0) {
	var engagement = _v0;
	return engagement.VF;
};
var $author$project$Pages$Patients$PatientId_String$Top$viewEngagementPopover = function (model) {
	var engagementStatus = $author$project$Api$Provider$Patient$One$engagementStatus(model.YY);
	var _v0 = _Utils_Tuple2(model.HC, engagementStatus === 'never_engaged');
	if (!_v0.b) {
		if (_v0.a.$ === 3) {
			var _v1 = _v0.a;
			var engagement = _v1.a;
			var maybeLastEngagementDate = $author$project$Api$Provider$Patient$Engagement$lastEngagementDate(engagement);
			var maybeInvoice = $author$project$Api$Provider$Patient$Engagement$invoice(engagement);
			var _v2 = _Utils_Tuple2(maybeLastEngagementDate, maybeInvoice);
			if ((!_v2.a.$) && (!_v2.b.$)) {
				var lastEngagementDate = _v2.a.a;
				var invoice = _v2.b.a;
				var invoiceType = $author$project$Api$Common$Payable$Invoice$MinWithOwner$type_(invoice);
				var invoiceNumber = $author$project$Api$Common$Payable$Invoice$MinWithOwner$invoiceNumber(invoice);
				var invoiceId = $author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice);
				var invoiceLink = function () {
					switch (invoiceType) {
						case 1:
							var patientId = $author$project$Api$Provider$Patient$One$id(model.YY);
							return A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top(
									{Us: invoiceId, YZ: patientId}),
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										'#' + $elm$core$String$fromInt(invoiceNumber))
									]));
						case 0:
							var companyId = function () {
								var _v5 = $author$project$Api$Common$Payable$Invoice$MinWithOwner$owner(invoice);
								if (!_v5.$) {
									var company = _v5.a;
									return $author$project$Api$Common$Payable$Owner$Min$id(company);
								} else {
									return '';
								}
							}();
							return A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String(
									{fZ: companyId, ahP: invoiceId}),
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										'#' + $elm$core$String$fromInt(invoiceNumber))
									]));
						default:
							return $author$project$Utils$Html$empty;
					}
				}();
				var engagementThreshold = $elm$core$String$fromInt(
					$author$project$Api$Provider$Practice$One$engagementThreshold(model.ZV));
				var topText = function () {
					switch (engagementStatus) {
						case 'currently_engaged':
							return 'Received services within ' + (engagementThreshold + ' months');
						case 'previously_engaged':
							return 'Previously utilized services, none received in the past ' + (engagementThreshold + ' months');
						default:
							return '';
					}
				}();
				return A2(
					$author$project$Ui$Popover$body,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(topText)
								])),
							$author$project$Ui$HorizontalRule$view(
							_List_fromArray(
								[$author$project$Ui$HorizontalRule$thin])),
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									'Most recent service date: ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, lastEngagementDate))
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Invoice: '),
									invoiceLink
								]))
						]));
			} else {
				return A2($author$project$Ui$Popover$body, _List_Nil, _List_Nil);
			}
		} else {
			return A2($author$project$Ui$Popover$body, _List_Nil, _List_Nil);
		}
	} else {
		return A2(
			$author$project$Ui$Popover$body,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Individuals who have never received services')
						]))
				]));
	}
};
var $author$project$Pages$Patients$PatientId_String$Top$viewEngagement = function (model) {
	var hasSyncedRecord = $author$project$Api$Provider$Patient$One$isSynced(model.YY) || $author$project$Api$Provider$Patient$One$isMaster(model.YY);
	var gateIsAvailable = A2(
		$author$project$Utils$FeatureGate$gateAvailable,
		11,
		$author$project$Api$Practice$Provider(model.ZV));
	if (gateIsAvailable || hasSyncedRecord) {
		var engagementStatus = $author$project$Api$Provider$Patient$One$engagementStatus(model.YY);
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Engagement'),
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A4(
							$author$project$Ui$Popover$viewAsClickable,
							_List_fromArray(
								[
									$author$project$Ui$Popover$dark,
									$author$project$Ui$Popover$visible(
									$author$project$Ui$Popover$isOpen(model.aT))
								]),
							_List_fromArray(
								[
									$author$project$Pages$Patients$PatientId_String$Top$viewEngagementBadge(engagementStatus)
								]),
							_List_fromArray(
								[
									$author$project$Pages$Patients$PatientId_String$Top$viewEngagementPopover(model)
								]),
							model.aT)
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Top$viewAutopaySection = function (patient) {
	var autopayStatus = $author$project$Api$Provider$Patient$One$autopay(patient) ? 'Enabled' : 'Disabled';
	return A2(
		$author$project$Ui$Form$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Autopay'),
						$author$project$Ui$Form$Group$labelSpanSm(3),
						$author$project$Ui$Form$Group$inputSpanSm(9)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(autopayStatus)
									]))
							]))
					]))
			]));
};
var $author$project$Api$Provider$Patient$One$creditExpiresSoon = function (_v0) {
	var record = _v0.b;
	return record.O6;
};
var $author$project$Api$Provider$Patient$One$creditInCents = function (_v0) {
	var record = _v0.b;
	return record.O7;
};
var $author$project$Pages$Patients$PatientId_String$Top$viewCreditsSection = F3(
	function (practice, session, patient) {
		var manageCreditsLink = function () {
			var patientId = $author$project$Api$Provider$Patient$One$id(patient);
			return A2(
				$author$project$Permission$hideIfReadOnly,
				session,
				A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$flex, $author$project$Ui$Element$justifyRight]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Patients__PatientId_String__ManageCredits(
								{YZ: patientId}),
							_List_fromArray(
								[
									$author$project$Ui$Link$buttonDefault,
									$author$project$Ui$Link$disabled(
									$author$project$Api$Provider$Patient$One$archived(patient)),
									$author$project$Ui$Link$xs
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Manage Credits')
								]))
						])));
		}();
		var expirationText = $author$project$Api$Provider$Patient$One$creditExpiresSoon(patient) ? A2(
			$author$project$Ui$Typography$text,
			_List_fromArray(
				[$author$project$Ui$Typography$small, $author$project$Ui$Typography$danger]),
			' Expires soon') : $author$project$Utils$Html$empty;
		var creditInCents = $author$project$Utils$Currency$fromInt(
			$author$project$Api$Provider$Patient$One$creditInCents(patient));
		return A3(
			$author$project$Utils$FeatureGate$gate,
			4,
			$author$project$Api$Practice$Provider(practice),
			A2(
				$author$project$Ui$Form$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Credits'),
								$author$project$Ui$Form$Group$labelSpanSm(3),
								$author$project$Ui$Form$Group$inputSpanSm(9)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Static$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(creditInCents),
												expirationText,
												manageCreditsLink
											]))
									]))
							]))
					])));
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewInvoicesLink = function (patient) {
	var patientId = $author$project$Api$Provider$Patient$One$id(patient);
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$flex, $author$project$Ui$Element$justifyRight]),
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Link$route,
				$author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__Top(
					{YZ: patientId}),
				_List_fromArray(
					[
						$author$project$Ui$Link$disabled(
						$author$project$Api$Provider$Patient$One$archived(patient))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('See Invoices')
					]))
			]));
};
var $author$project$Api$Provider$Patient$One$defaultSource = function (_v0) {
	var record = _v0.b;
	return record.Qc;
};
var $author$project$Pages$Patients$PatientId_String$Top$viewNoPaymentMessage = function (patient) {
	return (($author$project$Api$Provider$Patient$One$overdueAmountInCents(patient) > 0) && $author$project$Utils$Maybe$isNothing(
		$author$project$Api$Provider$Patient$One$defaultSource(patient))) ? $elm$html$Html$text('There is no payment method for this account') : $author$project$Utils$Html$empty;
};
var $author$project$Pages$Patients$PatientId_String$Top$RequestPaymentInfoUpdateButtonClicked = {$: 13};
var $author$project$Api$Provider$Patient$One$sourcesCount = function (_v0) {
	var record = _v0.b;
	return record.abQ;
};
var $author$project$Pages$Patients$PatientId_String$Top$viewPaymentSourcesSection = F7(
	function (sendingRequestForPaymentInfo, patient, practice, patientRequestInfoSentAt, session, timeFormatter, isHintAdmin) {
		var lastRequestSent = function () {
			if (!patientRequestInfoSentAt.$) {
				var patientRequestInfoSentAt_ = patientRequestInfoSentAt.a;
				var sentAt = A2(timeFormatter, 1, patientRequestInfoSentAt_);
				return A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$justifyRight]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$p,
							_List_fromArray(
								[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
							_List_fromArray(
								[
									$elm$html$Html$text('Last request sent ' + (sentAt + '.'))
								]))
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}();
		return A2(
			$author$project$Ui$Form$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('Default Payment Method'),
							$author$project$Ui$Form$Group$labelSpanSm(3),
							$author$project$Ui$Form$Group$inputSpanSm(9)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									function () {
									var _v0 = $author$project$Api$Provider$Patient$One$defaultSource(patient);
									if (!_v0.$) {
										var defaultSource = _v0.a;
										var sourcesCount = $author$project$Api$Provider$Patient$One$sourcesCount(patient);
										var sourcesCountText = function () {
											if (sourcesCount > 1) {
												var additionalCount = sourcesCount - 1;
												return A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$mt2]),
													_List_fromArray(
														[
															A3(
															$author$project$Ui$Link$route,
															$author$project$Spa$Generated$Route$Patients__PatientId_String__Accounts__Top(
																{
																	YZ: $author$project$Api$Provider$Patient$One$id(patient)
																}),
															_List_fromArray(
																[
																	$author$project$Ui$Link$disabled(
																	$author$project$Api$Provider$Patient$One$archived(patient))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	'View ' + A2($author$project$Formatters$String$pluralize, 'additional payment option', additionalCount))
																]))
														]));
											} else {
												return $author$project$Utils$Html$empty;
											}
										}();
										var source = function () {
											if (!defaultSource.$) {
												var cardOne = defaultSource.a;
												return $author$project$Api$Source$Card(
													$author$project$Api$Card$ProviderOne(cardOne));
											} else {
												var bankAccountOne = defaultSource.a;
												return $author$project$Api$Source$BankAccount(
													$author$project$Api$BankAccount$ProviderOne(bankAccountOne));
											}
										}();
										return A2(
											$author$project$Ui$Grid$row,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Grid$column,
													_List_fromArray(
														[
															$author$project$Ui$Grid$spanMd(6)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Components$PaymentSourceDisplayer$view,
															timeFormatter,
															_List_fromArray(
																[
																	$author$project$Components$PaymentSourceDisplayer$source(
																	$elm$core$Maybe$Just(source)),
																	$author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus(false),
																	$author$project$Components$PaymentSourceDisplayer$limitedView(false),
																	$author$project$Components$PaymentSourceDisplayer$showProcessor(isHintAdmin)
																])),
															sourcesCountText
														]))
												]));
									} else {
										var patientId = $author$project$Api$Provider$Patient$One$id(patient);
										var goToOrManagePaymentOptionsText = ($author$project$Api$Provider$Patient$One$sourcesCount(patient) > 0) ? 'Manage Payment Options' : 'Go to Payment Options';
										return A2(
											$author$project$Ui$Grid$row,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Grid$column,
													_List_fromArray(
														[
															$author$project$Ui$Grid$spanMd(6)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Element$view,
															_List_Nil,
															_List_fromArray(
																[
																	A2($author$project$Ui$Badge$fromString, _List_Nil, 'none')
																]))
														])),
													A2(
													$author$project$Ui$Grid$column,
													_List_fromArray(
														[
															$author$project$Ui$Grid$spanMd(6)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Permission$hideIfReadOnly,
															session,
															A2(
																$author$project$Ui$Element$view,
																_List_fromArray(
																	[$author$project$Ui$Element$justifyRight]),
																_List_fromArray(
																	[
																		A3(
																		$author$project$Ui$Link$route,
																		$author$project$Spa$Generated$Route$Patients__PatientId_String__Accounts__Top(
																			{YZ: patientId}),
																		_List_fromArray(
																			[
																				$author$project$Ui$Link$disabled(
																				$author$project$Api$Provider$Patient$One$archived(patient))
																			]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text(goToOrManagePaymentOptionsText)
																			]))
																	])))
														]))
												]));
									}
								}(),
									function () {
									if ((!$author$project$Api$Provider$Practice$One$acceptsAch(practice)) && (!$author$project$Api$Provider$Practice$One$acceptsCards(practice))) {
										return $author$project$Utils$Html$empty;
									} else {
										if (!$author$project$Api$Provider$Practice$One$collectPaymentSourceOnSignup(practice)) {
											return $author$project$Utils$Html$empty;
										} else {
											var sendOrResendRequestTest = function () {
												if (!patientRequestInfoSentAt.$) {
													return ' Resend Request For Payment Info';
												} else {
													return ' Send Request For Payment Info';
												}
											}();
											return A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$justifyRight]),
												_List_fromArray(
													[
														A2(
														$author$project$Permission$hideIfReadOnly,
														session,
														A3(
															$author$project$Ui$Button$view,
															{mm: sendOrResendRequestTest},
															_List_fromArray(
																[
																	$author$project$Ui$Button$primary,
																	$author$project$Ui$Button$disabled(
																	$author$project$Api$Provider$Patient$One$archived(patient)),
																	$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$RequestPaymentInfoUpdateButtonClicked),
																	$author$project$Ui$Button$loading(sendingRequestForPaymentInfo),
																	$author$project$Ui$Button$sm,
																	$author$project$Ui$Button$icon($author$project$Ui$Icon$send)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(sendOrResendRequestTest)
																])))
													]));
										}
									}
								}(),
									lastRequestSent
								]))
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewSurchargeEligibilitySection = function (patient) {
	var _v0 = $author$project$Api$Provider$Patient$One$shouldChargeCreditCardFees(patient) ? _Utils_Tuple2('Enabled', 'Fees will be passed through to the patient if they pay by credit card') : _Utils_Tuple2('Disabled', 'This patient is excluded from credit card passthrough fees');
	var surchargeStatus = _v0.a;
	var surchargeTooltip = _v0.b;
	return A2(
		$author$project$Ui$Form$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Surcharging'),
						$author$project$Ui$Form$Group$labelSpanSm(3),
						$author$project$Ui$Form$Group$inputSpanSm(9)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Tooltip$view,
								_List_fromArray(
									[$author$project$Ui$Tooltip$wide]),
								surchargeTooltip,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(surchargeStatus)
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Patients$PatientId_String$Top$viewUnpaidWarning = function (patient) {
	return ($author$project$Api$Provider$Patient$One$overdueAmountInCents(patient) > 0) ? A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap]),
		_List_fromArray(
			[
				$author$project$Ui$Icon$warning(
				_List_fromArray(
					[$author$project$Ui$Icon$danger])),
				A2(
				$author$project$Ui$Typography$text,
				_List_fromArray(
					[$author$project$Ui$Typography$small, $author$project$Ui$Typography$danger]),
				'Unpaid Charges')
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Pages$Patients$PatientId_String$Top$viewFinancialInformation = function (_v0) {
	var patient = _v0.YY;
	var session = _v0.aa4;
	var practice = _v0.ZV;
	var timeFormatter = _v0.J7;
	var patientRequestInfoSentAt = _v0.CL;
	var sendingRequestForPaymentInfo = _v0.hA;
	var isHintAdmin = _v0.Ij;
	var owedInCents = $author$project$Utils$Currency$fromInt(
		$author$project$Api$Provider$Patient$One$owedInCents(patient));
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				$author$project$Ui$Panel$title(
				_List_fromArray(
					[
						$elm$html$Html$text('Financial Info')
					])),
				A2(
				$author$project$Ui$Form$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Balance'),
								$author$project$Ui$Form$Group$labelSpanSm(3),
								$author$project$Ui$Form$Group$inputSpanSm(9)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Static$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(owedInCents),
												$author$project$Pages$Patients$PatientId_String$Top$viewUnpaidWarning(patient),
												A2(
												$author$project$Permission$hideIfReadOnly,
												session,
												$author$project$Pages$Patients$PatientId_String$Top$viewInvoicesLink(patient))
											])),
										$author$project$Pages$Patients$PatientId_String$Top$viewNoPaymentMessage(patient)
									]))
							]))
					])),
				A3($author$project$Pages$Patients$PatientId_String$Top$viewCreditsSection, practice, session, patient),
				$author$project$Pages$Patients$PatientId_String$Top$viewAutopaySection(patient),
				A2(
				$author$project$Utils$Html$htmlIf,
				$author$project$Api$Provider$Practice$One$chargePatientsCreditCardFees(practice),
				$author$project$Pages$Patients$PatientId_String$Top$viewSurchargeEligibilitySection(patient)),
				A7($author$project$Pages$Patients$PatientId_String$Top$viewPaymentSourcesSection, sendingRequestForPaymentInfo, patient, practice, patientRequestInfoSentAt, session, timeFormatter, isHintAdmin)
			]));
};
var $author$project$Pages$Patients$PatientId_String$Top$fullGenderIdentity = function (pat) {
	var fields = A2(
		$elm$core$List$map,
		$elm_community$string_extra$String$Extra$toSentenceCase,
		A2(
			$elm$core$List$filter,
			function (val) {
				return val !== 'not listed';
			},
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						$author$project$Api$Provider$Patient$One$sex(pat),
						$author$project$Api$Provider$Patient$One$genderIdentity(pat),
						$author$project$Api$Provider$Patient$One$genderOther(pat),
						$author$project$Api$Provider$Patient$One$pronoun(pat)
					]))));
	return $elm$html$Html$text(
		A2($elm$core$String$join, ', ', fields));
};
var $author$project$Pages$Patients$PatientId_String$Top$viewGenderSection = F2(
	function (practice, patient) {
		var gender = function () {
			if ($author$project$Api$Provider$Practice$One$transInclusivity(practice)) {
				return $author$project$Pages$Patients$PatientId_String$Top$fullGenderIdentity(patient);
			} else {
				var _v0 = $author$project$Api$Provider$Patient$One$gender(patient);
				if (!_v0.$) {
					var gender_ = _v0.a;
					return (gender_ === 'other') ? $elm$html$Html$text(
						A2(
							$elm$core$Maybe$withDefault,
							'',
							$author$project$Api$Provider$Patient$One$genderOther(patient))) : $elm$html$Html$text(gender_);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$span,
					_List_fromArray(
						[
							$author$project$Ui$Typography$phi(true)
						]),
					_List_fromArray(
						[gender]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewHealthInsurance = function (patient) {
	var content = function () {
		var _v0 = $author$project$Api$Provider$Patient$One$healthInsurance(patient);
		if (!_v0.$) {
			var insurance = _v0.a;
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[
											$author$project$Ui$Typography$phi(true)
										]),
									A2(
										$elm$core$Maybe$withDefault,
										'',
										$author$project$Api$Provider$HealthInsurance$Shared$payerName(insurance)))
								]))
						])),
					function () {
					var _v1 = $author$project$Api$Provider$HealthInsurance$Shared$groupId(insurance);
					if (!_v1.$) {
						var groupId = _v1.a;
						return A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Group ID: '),
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[
											$author$project$Ui$Typography$phi(true)
										]),
									groupId)
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					function () {
					var _v2 = $author$project$Api$Provider$HealthInsurance$Shared$memberId(insurance);
					if (!_v2.$) {
						var memberId = _v2.a;
						return A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Member ID: '),
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[
											$author$project$Ui$Typography$phi(true)
										]),
									memberId)
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					function () {
					var _v3 = $author$project$Api$Provider$HealthInsurance$Shared$highDeductible(insurance);
					if (!_v3.$) {
						var highDeductible = _v3.a;
						var icon = highDeductible ? $author$project$Ui$Icon$check(
							_List_fromArray(
								[$author$project$Ui$Icon$success])) : $author$project$Ui$Icon$cross(
							_List_fromArray(
								[$author$project$Ui$Icon$danger]));
						return A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									icon,
									$elm$html$Html$text('  High Deductible Plan')
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]);
		} else {
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_fromArray(
						[$author$project$Ui$Form$Static$noValue]),
					_List_Nil)
				]);
		}
	}();
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Insurance Carrier'),
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9)
			]),
		content);
};
var $author$project$Pages$Patients$PatientId_String$Top$ElationForcePushConfirmationModalOpened = {$: 27};
var $author$project$Pages$Patients$PatientId_String$Top$ToggleIntegrationConflicts = F2(
	function (a, b) {
		return {$: 30, a: a, b: b};
	});
var $author$project$Api$Provider$ExternalRecord$conflicts = function (_v0) {
	var record = _v0;
	return record.Or;
};
var $author$project$Api$Provider$ExternalRecord$errorMessage = function (_v0) {
	var record = _v0;
	return record.RM;
};
var $author$project$Api$Provider$ExternalRecord$source = function (_v0) {
	var record = _v0;
	return record.JQ;
};
var $author$project$Pages$Patients$PatientId_String$Top$viewConflict = function (_v0) {
	var name = _v0.Bq;
	var ours = _v0.ajH;
	var theirs = _v0.al1;
	return A2(
		$author$project$Ui$Grid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$span(3)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$strong,
						_List_fromArray(
							[
								$author$project$Ui$Typography$phi(true)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(name)
							]))
					])),
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$span(4)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$text,
						_List_fromArray(
							[
								$author$project$Ui$Typography$phi(true)
							]),
						ours)
					])),
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$span(4)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$text,
						_List_fromArray(
							[
								$author$project$Ui$Typography$phi(true)
							]),
						theirs)
					]))
			]));
};
var $author$project$Api$Provider$ExternalRecord$statusCode = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Pages$Patients$PatientId_String$Top$viewExternalRecordStatusBadge = function (record) {
	var _v0 = $author$project$Api$Provider$ExternalRecord$statusCode(record);
	switch (_v0) {
		case 2:
			return A2($author$project$Ui$Badge$fromString, _List_Nil, 'errored');
		case 0:
			return A2($author$project$Ui$Badge$fromString, _List_Nil, 'synced');
		default:
			return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Top$viewExternalRecord = F3(
	function (idx, conflictsVisible, record) {
		var source = $author$project$Api$Provider$ExternalRecord$source(record);
		var showConflicts = A2($elm$core$Maybe$withDefault, false, conflictsVisible);
		var maybeErrorMsg = $author$project$Api$Provider$ExternalRecord$errorMessage(record);
		var conflictsList = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			$author$project$Api$Provider$ExternalRecord$conflicts(record));
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label(
					$author$project$Formatters$String$titleize(source)),
					$author$project$Ui$Form$Group$labelSpan(3),
					$author$project$Ui$Form$Group$inputSpan(9)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(2)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('form-control--static')
										]),
									_List_fromArray(
										[
											(source === 'elation') ? $author$project$Pages$Patients$PatientId_String$Top$viewExternalRecordStatusBadge(record) : $author$project$Utils$Html$empty
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(10)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Static$view,
									_List_fromArray(
										[$author$project$Ui$Form$Static$spaceBetween]),
									_List_fromArray(
										[
											function () {
											if (!maybeErrorMsg.$) {
												var error = maybeErrorMsg.a;
												return A2(
													$author$project$Ui$Typography$text,
													_List_fromArray(
														[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
													error);
											} else {
												return $author$project$Utils$Html$empty;
											}
										}()
										])),
									$elm$core$List$isEmpty(conflictsList) ? $author$project$Utils$Html$empty : (showConflicts ? A3(
									$author$project$Ui$Button$view,
									{mm: 'Hide conflicts'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick(
											A2($author$project$Pages$Patients$PatientId_String$Top$ToggleIntegrationConflicts, idx, false))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Hide conflicts')
										])) : A3(
									$author$project$Ui$Button$view,
									{mm: 'Show conflicts'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick(
											A2($author$project$Pages$Patients$PatientId_String$Top$ToggleIntegrationConflicts, idx, true))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Show conflicts')
										])))
								]))
						])),
					showConflicts ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('well'),
							$elm$html$Html$Attributes$class('well--sm')
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$Ui$Grid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(3)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-label-md')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Field')
												]))
										])),
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(4)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-label-md')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Our Value')
												]))
										])),
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(4)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-label-md')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Elation\'s Value')
												]))
										]))
								])),
						A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Top$viewConflict, conflictsList))) : $author$project$Utils$Html$empty,
					showConflicts ? A3(
					$author$project$Ui$Button$view,
					{mm: 'Sync to elation anyways'},
					_List_fromArray(
						[
							$author$project$Ui$Button$sm,
							$author$project$Ui$Button$styled(4),
							$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$ElationForcePushConfirmationModalOpened)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Sync to Elation Anyway')
						])) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Top$WebLinkClicked = function (a) {
	return {$: 31, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$ExecuteActionForIntegrationRecord = F2(
	function (a, b) {
		return {$: 24, a: a, b: b};
	});
var $author$project$Api$Provider$IntegrationRecord$Meta$actions = function (_v0) {
	var record = _v0;
	return record.vy;
};
var $author$project$Api$Provider$IntegrationRecord$Shared$meta = function (_v0) {
	var record = _v0;
	return record.W4;
};
var $author$project$Api$Provider$IntegrationRecord$One$meta = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$IntegrationRecord$Shared$meta(shared);
};
var $author$project$Api$Provider$IntegrationRecord$All$meta = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$IntegrationRecord$One$meta(one);
};
var $author$project$Pages$Patients$PatientId_String$Top$viewIntegrationRecordActions = F2(
	function (maybeMenu, record) {
		if (maybeMenu.$ === 1) {
			return $author$project$Utils$Html$empty;
		} else {
			var menuModel = maybeMenu.a;
			var actions = A2(
				$elm$core$List$filterMap,
				function (action) {
					return action.ae4 ? $elm$core$Maybe$Just(
						A2(
							$author$project$Ui$Dropdown$item,
							_List_fromArray(
								[
									$author$project$Ui$Dropdown$onSelect(
									A2($author$project$Pages$Patients$PatientId_String$Top$ExecuteActionForIntegrationRecord, action.Bq, record))
								]),
							$elm$html$Html$text(action.Qr))) : $elm$core$Maybe$Nothing;
				},
				$author$project$Api$Provider$IntegrationRecord$Meta$actions(
					$author$project$Api$Provider$IntegrationRecord$All$meta(record)));
			return A4(
				$author$project$Ui$Dropdown$view,
				_List_fromArray(
					[$author$project$Ui$Dropdown$buttonSm]),
				_List_fromArray(
					[
						$elm$html$Html$text('Actions')
					]),
				actions,
				menuModel);
		}
	});
var $author$project$Api$Provider$IntegrationRecord$Shared$webLink = function (_v0) {
	var record = _v0;
	return record.aep;
};
var $author$project$Api$Provider$IntegrationRecord$One$webLink = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$IntegrationRecord$Shared$webLink(shared);
};
var $author$project$Api$Provider$IntegrationRecord$All$webLink = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$IntegrationRecord$One$webLink(one);
};
var $author$project$Pages$Patients$PatientId_String$Top$viewIntegrationRecord = F4(
	function (pat, timeFormatter, maybeMenu, record) {
		var integration = $author$project$Api$Provider$IntegrationRecord$All$integration(record);
		var partnerName = $author$project$Api$Provider$Integration$SharedWithInlinePartner$partnerName(integration);
		if ((!$author$project$Api$Provider$Patient$One$syncToEmr(pat)) && (partnerName === 'Elation')) {
			return $author$project$Utils$Html$empty;
		} else {
			var unsyncedReason = function () {
				var _v3 = $author$project$Api$Provider$IntegrationRecord$All$unsyncedReason(record);
				if (!_v3.$) {
					var reason = _v3.a;
					return A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('ml-1')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(reason)
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}();
			var lastSyncedAt = function () {
				var _v2 = $author$project$Api$Provider$IntegrationRecord$All$integrationLastSyncedAt(record);
				if (!_v2.$) {
					var time = _v2.a;
					return A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('ml-1')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								'on ' + A2(timeFormatter, 0, time))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}();
			var integrationName = $author$project$Api$Provider$Integration$SharedWithInlinePartner$displayName(integration);
			var webLink = function () {
				var _v1 = $author$project$Api$Provider$IntegrationRecord$All$webLink(record);
				if (!_v1.$) {
					var link = _v1.a;
					return A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-control--static')
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{mm: 'View in ' + integrationName},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$onClick(
										$author$project$Pages$Patients$PatientId_String$Top$WebLinkClicked(link)),
										$author$project$Ui$Button$icon($author$project$Ui$Icon$launch)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(' View in ' + integrationName)
									]))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}();
			var errorMessage = function () {
				var _v0 = $author$project$Api$Provider$IntegrationRecord$All$errorMessage(record);
				if (!_v0.$) {
					var message = _v0.a;
					return A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('ml-1')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(message)
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}();
			var additionalInfo = A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-control--static'),
						$elm$html$Html$Attributes$class('text-muted'),
						$elm$html$Html$Attributes$class('text-body-sm')
					]),
				_List_fromArray(
					[unsyncedReason, errorMessage, lastSyncedAt]));
			return A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label(integrationName),
						$author$project$Ui$Form$Group$labelSpan(3),
						$author$project$Ui$Form$Group$inputSpan(9)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Badge$fromString,
												_List_Nil,
												$author$project$Api$IntegrationRecord$Status$toString(
													$author$project$Api$Provider$IntegrationRecord$All$integrationSyncStatus(record))),
												additionalInfo,
												webLink
											])),
										A2(
										$author$project$Ui$Element$view,
										_List_Nil,
										_List_fromArray(
											[
												A2($author$project$Pages$Patients$PatientId_String$Top$viewIntegrationRecordActions, maybeMenu, record)
											]))
									]))
							]))
					]));
		}
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewIntegrationsSection = function (_v0) {
	var patient = _v0.YY;
	var timeFormatter = _v0.J7;
	var integrationRecordDropdowns = _v0.gy;
	var integrationRecords = _v0.Ub;
	var integrationConflictsVisible = _v0.sK;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				$author$project$Ui$Panel$title(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Skeleton$ifLoading,
						integrationRecords,
						$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$spanFromText('Integrations')
								])),
						$elm$html$Html$text('Integrations'))
					])),
				A2(
				$author$project$Ui$Form$view,
				_List_Nil,
				_List_fromArray(
					[
						function () {
						if (integrationRecords.$ === 3) {
							var integrationRecords_ = integrationRecords.a;
							var externalRecords_ = $author$project$Api$Provider$Patient$One$integrations(patient);
							return ($elm$core$List$isEmpty(externalRecords_) && $elm$core$List$isEmpty(integrationRecords_)) ? A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('No integrations are active. View integrations '),
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Marketplace__Manage,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('here.')
											]))
									])) : A2(
								$elm$html$Html$div,
								_List_Nil,
								A2(
									$elm$core$List$append,
									A2(
										$elm$core$List$indexedMap,
										function (idx) {
											return A2(
												$author$project$Pages$Patients$PatientId_String$Top$viewExternalRecord,
												idx,
												A2($elm_community$list_extra$List$Extra$getAt, idx, integrationConflictsVisible));
										},
										externalRecords_),
									A2(
										$elm$core$List$indexedMap,
										function (idx) {
											return A3(
												$author$project$Pages$Patients$PatientId_String$Top$viewIntegrationRecord,
												patient,
												timeFormatter,
												A2($elm_community$list_extra$List$Extra$getAt, idx, integrationRecordDropdowns));
										},
										integrationRecords_)));
						} else {
							return A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$labelSkeleton('Integration name'),
										$author$project$Ui$Form$Group$labelSpan(3),
										$author$project$Ui$Form$Group$inputSpan(9)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Static$view,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Ui$Skeleton$text(
												_List_fromArray(
													[
														$author$project$Ui$Skeleton$span(3)
													]))
											]))
									]));
						}
					}()
					]))
			]));
};
var $author$project$Pages$Patients$PatientId_String$Top$viewJoinDate = function (patient) {
	var _v0 = $author$project$Api$Provider$Patient$One$joinedPracticeDate(patient);
	if (!_v0.$) {
		var date = _v0.a;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Joined Practice'),
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, date))
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Top$viewLeadSource = function (patient) {
	var content = function () {
		var _v0 = $author$project$Api$Provider$Patient$One$leadSource(patient);
		if (!_v0.$) {
			var leadSource = _v0.a;
			var leadSourceName = $author$project$Api$Provider$LeadSource$Shared$name(leadSource);
			var leadSourceStr = (leadSourceName === 'Other') ? A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Api$Provider$Patient$One$leadSourceOther(patient)) : leadSourceName;
			return A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(leadSourceStr)
					]));
		} else {
			return A2(
				$author$project$Ui$Form$Static$view,
				_List_fromArray(
					[$author$project$Ui$Form$Static$noValue]),
				_List_Nil);
		}
	}();
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Lead Source'),
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9)
			]),
		_List_fromArray(
			[content]));
};
var $author$project$Pages$Patients$PatientId_String$Top$viewLocation = F2(
	function (practice, patient) {
		var trackPatientsByLocation = $author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice);
		var maybeLocation = $author$project$Api$Provider$Patient$One$location(patient);
		var _v0 = _Utils_Tuple2(trackPatientsByLocation, maybeLocation);
		if (_v0.a && (!_v0.b.$)) {
			var location = _v0.b.a;
			return A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Location'),
						$author$project$Ui$Form$Group$labelSpanSm(3),
						$author$project$Ui$Form$Group$inputSpanSm(9)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Api$Provider$Location$Shared$name(location))
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Api$Provider$PatientEmail$All$patient = function (_v0) {
	var record = _v0;
	return record.YY;
};
var $author$project$Components$Patient$ManagePortalAccessModal$PortalStatusToggled = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Patient$ManagePortalAccessModal$patientInfo = F2(
	function (isCurrentPatient, patientEmail) {
		var thisPatientText = isCurrentPatient ? A2($author$project$Ui$Typography$text, _List_Nil, ' (this patient)') : $author$project$Utils$Html$empty;
		var patient = $author$project$Api$Provider$PatientEmail$All$patient(patientEmail);
		return A2(
			$author$project$Ui$Element$prose,
			_List_Nil,
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Link$route,
					$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
						{
							YZ: $author$project$Api$Provider$Patient$Min$id(patient)
						}),
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$Patient$Min$name(patient))
						])),
					thisPatientText
				]));
	});
var $author$project$Ui$ToggleSwitch$Sm = {$: 3};
var $author$project$Ui$ToggleSwitch$sm = $author$project$Ui$ToggleSwitch$Sm;
var $author$project$Components$Patient$ManagePortalAccessModal$viewPatientEmail = F3(
	function (patientEmailsEnabled, isCurrentPatient, patientEmail) {
		var isPortalEnabled = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$second,
				A2(
					$elm_community$list_extra$List$Extra$find,
					function (pe) {
						return _Utils_eq(
							pe.a,
							$author$project$Api$Provider$PatientEmail$All$id(patientEmail));
					},
					patientEmailsEnabled)));
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(5)
								]),
							_List_fromArray(
								[
									A2($author$project$Components$Patient$ManagePortalAccessModal$patientInfo, isCurrentPatient, patientEmail)
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(1),
									$author$project$Ui$Grid$offset(6)
								]),
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$view(
									_List_fromArray(
										[
											$author$project$Ui$ToggleSwitch$sm,
											$author$project$Ui$ToggleSwitch$on(isPortalEnabled),
											$author$project$Ui$ToggleSwitch$onChange(
											$author$project$Components$Patient$ManagePortalAccessModal$PortalStatusToggled(patientEmail))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Patient$ManagePortalAccessModal$viewPatientEmails = F3(
	function (patientEmailsEnabled, data, currentPatientId) {
		switch (data.$) {
			case 3:
				var patientEmails = data.a;
				var _v1 = A2(
					$elm$core$List$partition,
					function (patientEmail) {
						return _Utils_eq(
							$author$project$Api$Provider$Patient$Min$id(
								$author$project$Api$Provider$PatientEmail$All$patient(patientEmail)),
							currentPatientId);
					},
					patientEmails);
				var thesePatients = _v1.a;
				var otherPatientEmails = _v1.b;
				return _Utils_ap(
					A2(
						$elm$core$List$map,
						A2($author$project$Components$Patient$ManagePortalAccessModal$viewPatientEmail, patientEmailsEnabled, true),
						thesePatients),
					A2(
						$elm$core$List$map,
						A2($author$project$Components$Patient$ManagePortalAccessModal$viewPatientEmail, patientEmailsEnabled, false),
						otherPatientEmails));
			case 1:
				return _List_fromArray(
					[
						$elm$html$Html$text('Loading...')
					]);
			default:
				return _List_fromArray(
					[$author$project$Utils$Html$empty]);
		}
	});
var $author$project$Components$Patient$ManagePortalAccessModal$view = function (_v0) {
	var model = _v0;
	if (model.Yn) {
		var body = A2(
			$author$project$Ui$Form$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Portal access for members using this patient\'s email address:')
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					A3(
						$author$project$Components$Patient$ManagePortalAccessModal$viewPatientEmails,
						model.oX,
						model.CJ,
						$author$project$Api$Provider$Patient$One$id(model.YY)))
				]));
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$Patient$ManagePortalAccessModal$Closed,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('Manage Portal Access')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[body]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Top$viewManagePortalAccessModal = function (model) {
	var _v0 = model.kf;
	if (!_v0.$) {
		var modal = _v0.a;
		return A2(
			$elm$html$Html$map,
			$author$project$Pages$Patients$PatientId_String$Top$ManagePortalAccessModalMsg,
			$author$project$Components$Patient$ManagePortalAccessModal$view(modal));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Top$viewCoveragePlanName = function (membership) {
	return $elm$html$Html$text(
		A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$CoveragePlan$One$name,
				A2(
					$author$project$Api$Expandable$withDefault,
					$elm$core$Maybe$Nothing,
					$author$project$Api$Provider$Plan$SharedWithContractInfo$coveragePlan(
						$author$project$Api$Provider$Membership$One$plan(membership))))));
};
var $author$project$Pages$Patients$PatientId_String$Top$viewCoverageRules = F2(
	function (model, membership) {
		var _v0 = model.OT;
		if (!_v0.$) {
			var modelCoveragePlanRules = _v0.a;
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpanSm(3),
							$author$project$Ui$Form$Group$inputSpanSm(9),
							$author$project$Ui$Form$Group$label('Coverage Plan')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$p,
											_List_fromArray(
												[$author$project$Ui$Typography$bold]),
											_List_fromArray(
												[
													$author$project$Pages$Patients$PatientId_String$Top$viewCoveragePlanName(membership)
												]))
										]))
								])),
							function () {
							var coverageDocuments = A2(
								$elm$core$Maybe$map,
								$author$project$Api$Provider$CoveragePlan$One$coverageDocuments,
								A2(
									$author$project$Api$Expandable$withDefault,
									$elm$core$Maybe$Nothing,
									$author$project$Api$Provider$Plan$SharedWithContractInfo$coveragePlan(
										$author$project$Api$Provider$Membership$One$plan(membership))));
							return A2(
								$elm$core$Maybe$withDefault,
								$author$project$Utils$Html$empty,
								A2($elm$core$Maybe$map, $author$project$Components$Admin$CoverageDocuments$Form$viewAsList, coverageDocuments));
						}()
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpanSm(3),
							$author$project$Ui$Form$Group$inputSpanSm(9),
							$author$project$Ui$Form$Group$label('')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Pages$Patients$PatientId_String$Top$CoveragePlanMsg,
									$author$project$Components$Admin$CoveragePlans$Rules$view(modelCoveragePlanRules))
								]))
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewCoverageSponsor = function (syncDetails) {
	if (!syncDetails.$) {
		var details = syncDetails.a;
		var companyName = A2(
			$author$project$Api$Expandable$withDefault,
			$elm$core$Maybe$Nothing,
			$author$project$Api$Provider$Patient$SyncDetail$companyName(details));
		if (!companyName.$) {
			var name = companyName.a;
			return A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Coverage Sponsor'),
						$author$project$Ui$Form$Group$labelSpanSm(3),
						$author$project$Ui$Form$Group$inputSpanSm(9)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$bold]),
								_List_fromArray(
									[
										$elm$html$Html$text(name)
									]))
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Top$viewCoverageType = function (syncDetails) {
	if (!syncDetails.$) {
		var details = syncDetails.a;
		var coverageType = $elm$html$Html$text(
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$author$project$Api$Expandable$withDefault,
					$elm$core$Maybe$Nothing,
					$author$project$Api$Provider$Patient$SyncDetail$coverageType(details))));
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Coverage Type'),
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$p,
							_List_fromArray(
								[$author$project$Ui$Typography$bold]),
							_List_fromArray(
								[coverageType]))
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Top$viewInformationalAlert = F3(
	function (networkCoveragePlan, coveragePlan, coverageRuleUsages) {
		var _v0 = _Utils_Tuple3(networkCoveragePlan, coveragePlan, coverageRuleUsages);
		if (((!_v0.a.$) && (_v0.b.$ === 1)) && (_v0.c.$ === 3)) {
			var _v1 = _v0.b;
			var _v2 = _v0.c;
			return A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$HorizontalRule$view(_List_Nil),
						A2(
						$author$project$Ui$Alert$warning,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Icon$alert(_List_Nil),
								$author$project$Utils$Html$noBreakSpace,
								$elm$html$Html$text('These rules are for informational purposes and will not be applied to charges. Please contact your affiliated network with any questions.')
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewMemberType = function (syncDetails) {
	if (!syncDetails.$) {
		var details = syncDetails.a;
		var memberType = $elm$html$Html$text(
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$author$project$Api$Expandable$withDefault,
					$elm$core$Maybe$Nothing,
					$author$project$Api$Provider$Patient$SyncDetail$memberType(details))));
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Member Type'),
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$p,
							_List_fromArray(
								[$author$project$Ui$Typography$bold]),
							_List_fromArray(
								[memberType]))
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Top$viewMembershipName = function (membership) {
	return $elm$html$Html$text(
		$author$project$Api$Provider$Plan$SharedWithContractInfo$name(
			$author$project$Api$Provider$Membership$One$plan(membership)));
};
var $author$project$Pages$Patients$PatientId_String$Top$viewMembershipPlan = function (membership) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9),
				$author$project$Ui$Form$Group$label('Membership Plan')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$fontBold]),
						_List_fromArray(
							[
								$author$project$Pages$Patients$PatientId_String$Top$viewMembershipName(membership)
							]))
					]))
			]));
};
var $author$project$Pages$Patients$PatientId_String$Top$periodName = function (periodInMonths) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Period$rateName,
			$author$project$Api$Period$retrieveByNumberOfMonths(periodInMonths)));
};
var $author$project$Pages$Patients$PatientId_String$Top$viewMembershipRate = function (membership) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9),
				$author$project$Ui$Form$Group$label('Rate')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$bold]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Utils$Currency$fromInt(
											$author$project$Api$Provider$Membership$One$periodRateInCents(membership)) + (' ' + $author$project$Pages$Patients$PatientId_String$Top$periodName(
											$author$project$Api$Provider$Membership$One$periodInMonths(membership))))
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Patients$PatientId_String$Top$viewNetworkCoverageDocuments = function (coverageDouments) {
	if (!coverageDouments.$) {
		var coverageDocuments_ = coverageDouments.a;
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mb3]),
			_List_fromArray(
				[
					$author$project$Components$Admin$CoverageDocuments$Form$viewAsList(coverageDocuments_)
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Top$viewNetworkCoverageRules = F2(
	function (model, syncDetails) {
		var _v0 = _Utils_Tuple3(model.XA, model.OT, model.OV);
		if (((!_v0.a.$) && (_v0.b.$ === 1)) && (_v0.c.$ === 3)) {
			var networkRules = _v0.a.a;
			var _v1 = _v0.b;
			var _v2 = _v0.c;
			var coveragePlan = A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Api$Provider$Patient$SyncDetail$coveragePlan,
					$author$project$Api$Expandable$withDefault($elm$core$Maybe$Nothing)),
				syncDetails);
			var coverageDocuments = A2($elm$core$Maybe$map, $author$project$Api$Provider$CoveragePlan$One$coverageDocuments, coveragePlan);
			return A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(3),
						$author$project$Ui$Form$Group$inputSpanSm(9),
						$author$project$Ui$Form$Group$label('Network Coverage Plan')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Pages$Patients$PatientId_String$Top$viewNetworkCoverageDocuments(coverageDocuments),
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Patients$PatientId_String$Top$NetworkCoveragePlanMsg,
								$author$project$Components$Admin$CoveragePlans$Rules$view(networkRules))
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewMembershipDetailsModal = function (model) {
	return model.oD ? A3(
		$author$project$Ui$Modal$view,
		$author$project$Pages$Patients$PatientId_String$Top$MembershipDetailsModalClosed,
		_List_fromArray(
			[$author$project$Ui$Modal$lg]),
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Memberships Details')
					])),
				$author$project$Ui$Modal$body(
				function () {
					var _v0 = _Utils_Tuple2(model.kk, model.OV);
					_v0$3:
					while (true) {
						switch (_v0.a.$) {
							case 3:
								switch (_v0.b.$) {
									case 3:
										var _v1 = _v0.a;
										var membership = _v1.a;
										var _v2 = _v0.b;
										var affiliateSyncDetails = function () {
											var _v3 = model.w2;
											if (_v3.$ === 3) {
												var details = _v3.a;
												return details;
											} else {
												return $elm$core$Maybe$Nothing;
											}
										}();
										return A2(
											$elm$core$List$cons,
											$author$project$Pages$Patients$PatientId_String$Top$viewMembershipPlan(membership),
											A2(
												$elm$core$List$cons,
												$author$project$Pages$Patients$PatientId_String$Top$viewMembershipRate(membership),
												A2(
													$elm$core$List$cons,
													A3($author$project$Pages$Patients$PatientId_String$Top$viewInformationalAlert, model.XA, model.OT, model.OV),
													A2(
														$elm$core$List$cons,
														$author$project$Pages$Patients$PatientId_String$Top$viewCoverageType(affiliateSyncDetails),
														A2(
															$elm$core$List$cons,
															$author$project$Pages$Patients$PatientId_String$Top$viewCoverageSponsor(affiliateSyncDetails),
															A2(
																$elm$core$List$cons,
																$author$project$Pages$Patients$PatientId_String$Top$viewMemberType(affiliateSyncDetails),
																A2(
																	$elm$core$List$cons,
																	A2($author$project$Pages$Patients$PatientId_String$Top$viewNetworkCoverageRules, model, affiliateSyncDetails),
																	A2($author$project$Pages$Patients$PatientId_String$Top$viewCoverageRules, model, membership))))))));
									case 0:
										var _v4 = _v0.a;
										var membership = _v4.a;
										var _v5 = _v0.b;
										var affiliateSyncDetails = function () {
											var _v6 = model.w2;
											if (_v6.$ === 3) {
												var details = _v6.a;
												return details;
											} else {
												return $elm$core$Maybe$Nothing;
											}
										}();
										return _List_fromArray(
											[
												$author$project$Pages$Patients$PatientId_String$Top$viewMembershipPlan(membership),
												$author$project$Pages$Patients$PatientId_String$Top$viewMembershipRate(membership),
												$author$project$Pages$Patients$PatientId_String$Top$viewCoverageType(affiliateSyncDetails),
												$author$project$Pages$Patients$PatientId_String$Top$viewCoverageSponsor(affiliateSyncDetails),
												$author$project$Pages$Patients$PatientId_String$Top$viewMemberType(affiliateSyncDetails)
											]);
									default:
										break _v0$3;
								}
							case 1:
								var _v7 = _v0.a;
								return A2(
									$elm$core$List$repeat,
									3,
									A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$labelSpanSm(3),
												$author$project$Ui$Form$Group$inputSpanSm(9),
												$author$project$Ui$Form$Group$labelSkeleton('Detail')
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Static$view,
												_List_Nil,
												_List_fromArray(
													[
														$author$project$Ui$Skeleton$text(
														_List_fromArray(
															[
																$author$project$Ui$Skeleton$span(4)
															]))
													]))
											])));
							default:
								break _v0$3;
						}
					}
					return _List_Nil;
				}()),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$textCenter]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Close modal'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$MembershipDetailsModalClosed)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Close')
									]))
							]))
					]))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Api$Provider$MembershipPatient$Shared$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Api$Provider$MembershipPatient$ForPatientOne$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$MembershipPatient$Shared$status(shared);
};
var $author$project$Pages$Patients$PatientId_String$Top$NewMembershipButtonClicked = {$: 17};
var $author$project$Pages$Patients$PatientId_String$Top$MembershipDetailsModalShown = F2(
	function (a, b) {
		return {$: 40, a: a, b: b};
	});
var $author$project$Api$Provider$MembershipPatient$ForPatientOne$effectiveEndDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$MembershipPatient$Shared$effectiveEndDate(shared);
};
var $justinmimbs$date$Date$min = F2(
	function (dateA, dateB) {
		var a = dateA;
		var b = dateB;
		return (_Utils_cmp(a, b) < 0) ? dateA : dateB;
	});
var $author$project$Api$Provider$MembershipPatient$ForPatientOne$nextBillDate = function (_v0) {
	var record = _v0.b;
	return record.XP;
};
var $author$project$Api$Provider$MembershipPatient$ForPatientOne$nextInvoiceDueDate = function (_v0) {
	var record = _v0.b;
	return record.XT;
};
var $author$project$Pages$Patients$PatientId_String$Top$descriptionForActiveOrUnpaidMemberships = F2(
	function (currentDate, membershipPatient) {
		var nextInvoiceDueDate = $author$project$Api$Provider$MembershipPatient$ForPatientOne$nextInvoiceDueDate(membershipPatient);
		var nextBillDate = $author$project$Api$Provider$MembershipPatient$ForPatientOne$nextBillDate(membershipPatient);
		var effectiveEndDate = $author$project$Api$Provider$MembershipPatient$ForPatientOne$effectiveEndDate(membershipPatient);
		return _Utils_ap(
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function (date) {
						return ' until ' + A2($justinmimbs$date$Date$format, 'MM/dd/yyyy', date);
					},
					effectiveEndDate)),
			_Utils_ap(
				function () {
					if (!nextInvoiceDueDate.$) {
						var date = nextInvoiceDueDate.a;
						return _Utils_ap(
							_Utils_eq(
								A2($justinmimbs$date$Date$min, date, currentDate),
								date) ? ' past due invoices starting ' : ' next invoice due ',
							A2($justinmimbs$date$Date$format, 'MMMM d, yyyy', date));
					} else {
						return '';
					}
				}(),
				function () {
					var _v1 = _Utils_Tuple2(nextBillDate, nextInvoiceDueDate);
					if ((!_v1.a.$) && (_v1.b.$ === 1)) {
						var date = _v1.a.a;
						var _v2 = _v1.b;
						return ' next due ' + A2($justinmimbs$date$Date$format, 'MMMM d, yyyy', date);
					} else {
						return '';
					}
				}()));
	});
var $author$project$Api$Provider$MembershipPatient$ForPatientOne$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$MembershipPatient$Shared$id(shared);
};
var $author$project$Api$Provider$MembershipPatient$Shared$membership = function (_v0) {
	var record = _v0;
	return record.kk;
};
var $author$project$Api$Provider$MembershipPatient$ForPatientOne$membership = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$MembershipPatient$Shared$membership(shared);
};
var $author$project$Api$Provider$MembershipPatient$ForPatientOne$owner = function (_v0) {
	var record = _v0.b;
	return record.YD;
};
var $author$project$Api$Provider$MembershipPatient$ForPatientOne$plan = function (_v0) {
	var record = _v0.b;
	return record.Jb;
};
var $author$project$Api$Provider$MembershipPatient$ForPatientOne$startDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$MembershipPatient$Shared$startDate(shared);
};
var $author$project$Pages$Patients$PatientId_String$Top$viewMembershipActions = F3(
	function (session, patient, membershipPatient) {
		var patientId = $author$project$Api$Provider$Patient$One$id(patient);
		var membershipId = $author$project$Api$Provider$Membership$Min$id(
			$author$project$Api$Provider$MembershipPatient$ForPatientOne$membership(membershipPatient));
		var disabled = $author$project$Api$Provider$Patient$One$archived(patient);
		var actionText = (($author$project$Api$Provider$MembershipPatient$ForPatientOne$status(membershipPatient) === 'ended') || $author$project$Api$Provider$Patient$One$isSynced(patient)) ? 'See Membership' : (($author$project$Api$Provider$MembershipPatient$ForPatientOne$status(membershipPatient) !== 'ended') ? 'Edit Membership' : '');
		var body = A3(
			$author$project$Ui$Link$route,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__MembershipId_String__Top(
				{AW: membershipId, YZ: patientId}),
			_List_fromArray(
				[
					$author$project$Ui$Link$disabled(disabled)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(actionText)
				]));
		return A2($author$project$Permission$hideIfReadOnly, session, body);
	});
var $author$project$Api$Provider$MembershipPatient$ForPatientOne$isSponsored = function (_v0) {
	var record = _v0.b;
	return record.Vc;
};
var $author$project$Pages$Patients$PatientId_String$Top$viewPayerInfo = F2(
	function (patient, membershipPatient) {
		var _v0 = $author$project$Api$Provider$MembershipPatient$ForPatientOne$owner(membershipPatient);
		if (!_v0.$) {
			var owner = _v0.a;
			var patientId = $author$project$Api$Provider$Patient$One$id(patient);
			var ownerId = $author$project$Api$Provider$Patient$Min$id(owner);
			if (!_Utils_eq(patientId, ownerId)) {
				var _v1 = $author$project$Api$Provider$MembershipPatient$ForPatientOne$isSponsored(membershipPatient);
				if (!_v1.$) {
					var isSponsored = _v1.a;
					var ownerName = $author$project$Api$Provider$Patient$Min$name(owner);
					var link = A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
							{YZ: ownerId}),
						_List_fromArray(
							[
								$author$project$Ui$Link$disabled(
								$author$project$Api$Provider$Patient$One$archived(patient))
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$text,
								_List_fromArray(
									[
										$author$project$Ui$Typography$phi(true)
									]),
								ownerName)
							]));
					return isSponsored ? A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Dependent of '),
								link
							])) : A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Paid by '),
								link
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			} else {
				return $author$project$Utils$Html$empty;
			}
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Api$Provider$MembershipPatient$ForPatientOne$company = function (_v0) {
	var record = _v0.b;
	return record.afQ;
};
var $author$project$Pages$Patients$PatientId_String$Top$viewSponsorInfo = F2(
	function (patient, membershipPatient) {
		var maybeCompany = $author$project$Api$Provider$MembershipPatient$ForPatientOne$company(membershipPatient);
		var _v0 = _Utils_Tuple2(
			$author$project$Api$Provider$MembershipPatient$ForPatientOne$isSponsored(membershipPatient),
			maybeCompany);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var company = _v0.b.a;
			return A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Api$Provider$Patient$One$isSynced(patient) ? $elm$html$Html$text('Network: ') : $elm$html$Html$text('Employer: '),
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top(
							{
								fZ: $author$project$Api$Provider$Company$Min$id(company)
							}),
						_List_fromArray(
							[
								$author$project$Ui$Link$disabled(
								$author$project$Api$Provider$Patient$One$archived(patient))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Api$Provider$Company$Min$name(company))
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewMembershipPatient = F5(
	function (session, patient, currentDate, affiliateSyncDetails, membershipPatient) {
		var status = $author$project$Api$Provider$MembershipPatient$ForPatientOne$status(membershipPatient);
		var showSponsorInfo = $author$project$Api$Provider$Patient$One$isSynced(patient) && ((status === 'active') || (status === 'unpaid'));
		var description = function () {
			switch (status) {
				case 'pending':
					return ' begins ' + A2(
						$justinmimbs$date$Date$format,
						'MM/dd/yyyy',
						$author$project$Api$Provider$MembershipPatient$ForPatientOne$startDate(membershipPatient));
				case 'unconfirmed':
					return ' awaiting confirmation';
				case 'active':
					return A2($author$project$Pages$Patients$PatientId_String$Top$descriptionForActiveOrUnpaidMemberships, currentDate, membershipPatient);
				case 'unpaid':
					return A2($author$project$Pages$Patients$PatientId_String$Top$descriptionForActiveOrUnpaidMemberships, currentDate, membershipPatient);
				case 'ended':
					var _v5 = $author$project$Api$Provider$MembershipPatient$ForPatientOne$effectiveEndDate(membershipPatient);
					if (!_v5.$) {
						var date = _v5.a;
						return ' ended on ' + A2($justinmimbs$date$Date$format, 'MM/dd/yyyy', date);
					} else {
						return '';
					}
				default:
					return '';
			}
		}();
		var button = A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mt2]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{mm: 'See membership details'},
					_List_fromArray(
						[
							$author$project$Ui$Button$mb8,
							$author$project$Ui$Button$sm,
							$author$project$Ui$Button$styled(0),
							$author$project$Ui$Button$onClick(
							A2(
								$author$project$Pages$Patients$PatientId_String$Top$MembershipDetailsModalShown,
								$author$project$Api$Provider$Membership$Min$id(
									$author$project$Api$Provider$MembershipPatient$ForPatientOne$membership(membershipPatient)),
								$author$project$Api$Provider$MembershipPatient$ForPatientOne$id(membershipPatient)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('See Membership Details')
						]))
				]));
		var badge = function () {
			var _v3 = $author$project$Api$Provider$MembershipPatient$ForPatientOne$owner(membershipPatient);
			if (!_v3.$) {
				var owner = _v3.a;
				return A3(
					$author$project$Ui$Link$route,
					$author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__Top(
						{
							YZ: $author$project$Api$Provider$Patient$Min$id(owner)
						}),
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Badge$fromString,
							_List_fromArray(
								[
									$author$project$Ui$Badge$test('membership-status')
								]),
							status)
						]));
			} else {
				return A2($author$project$Ui$Badge$fromString, _List_Nil, status);
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
									_List_fromArray(
										[
											badge,
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Api$Provider$Plan$Min$name(
														$author$project$Api$Provider$MembershipPatient$ForPatientOne$plan(membershipPatient)))
												])),
											A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
											description)
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											A3($author$project$Pages$Patients$PatientId_String$Top$viewMembershipActions, session, patient, membershipPatient)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$Pages$Patients$PatientId_String$Top$viewPayerInfo, patient, membershipPatient)
								])),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$Pages$Patients$PatientId_String$Top$viewSponsorInfo, patient, membershipPatient)
								])),
							function () {
							if (showSponsorInfo) {
								var syncDetails = function () {
									if (affiliateSyncDetails.$ === 3) {
										var details = affiliateSyncDetails.a;
										return details;
									} else {
										return $elm$core$Maybe$Nothing;
									}
								}();
								var companyName = function () {
									if (!syncDetails.$) {
										var details_ = syncDetails.a;
										return A2(
											$author$project$Api$Expandable$withDefault,
											$elm$core$Maybe$Nothing,
											$author$project$Api$Provider$Patient$SyncDetail$companyName(details_));
									} else {
										return $elm$core$Maybe$Nothing;
									}
								}();
								return A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											function () {
											if (!companyName.$) {
												var name = companyName.a;
												return A2(
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Employer: ' + name)
														]));
											} else {
												return A2(
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Retail ')
														]));
											}
										}()
										]));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}(),
							button
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewCurrentMemberships = F5(
	function (session, currentDate, patient, syncDetails, membershipPatients) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Current and Pending'),
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9)
				]),
			function () {
				if ($author$project$Api$Provider$Patient$One$membershipStatus(patient) === 'inactive') {
					return _List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_fromArray(
								[$author$project$Ui$Form$Static$flex, $author$project$Ui$Form$Static$spaceBetween, $author$project$Ui$Form$Static$itemsCenter]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Badge$fromString,
									_List_fromArray(
										[
											$author$project$Ui$Badge$test('membership-status')
										]),
									'inactive'),
									A3(
									$author$project$Ui$Button$view,
									{mm: 'New membership'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$NewMembershipButtonClicked)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('New Membership')
										]))
								]))
						]);
				} else {
					if ($elm$core$List$isEmpty(membershipPatients)) {
						return _List_fromArray(
							[$author$project$Utils$Html$empty]);
					} else {
						var firstFiveMembershipPatients = A2($elm$core$List$take, 5, membershipPatients);
						return _List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Static$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_Nil,
										A2(
											$elm$core$List$map,
											A4($author$project$Pages$Patients$PatientId_String$Top$viewMembershipPatient, session, patient, currentDate, syncDetails),
											firstFiveMembershipPatients)),
										($elm$core$List$length(membershipPatients) > 5) ? A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__Top(
											{
												YZ: $author$project$Api$Provider$Patient$One$id(patient)
											}),
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('See all memberships')
											])) : $author$project$Utils$Html$empty
									]))
							]);
					}
				}
			}());
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewPastMemberships = F5(
	function (session, currentDate, patient, syncDetails, membershipPatients) {
		var firstFiveMembershipPatients = A2($elm$core$List$take, 5, membershipPatients);
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Past'),
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							A2(
								$elm$core$List$map,
								A4($author$project$Pages$Patients$PatientId_String$Top$viewMembershipPatient, session, patient, currentDate, syncDetails),
								firstFiveMembershipPatients)),
							($elm$core$List$length(membershipPatients) > 5) ? A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__Top(
								{
									YZ: $author$project$Api$Provider$Patient$One$id(patient)
								}),
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('See all memberships')
								])) : $author$project$Utils$Html$empty
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewMembershipSection = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				$author$project$Ui$Panel$title(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Skeleton$ifLoading,
						model.WR,
						$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$spanFromText('Memberships')
								])),
						$elm$html$Html$text('Memberships'))
					])),
				A2(
				$author$project$Ui$Form$view,
				_List_Nil,
				function () {
					var _v0 = model.WR;
					if (_v0.$ === 3) {
						var membershipPatients = _v0.a;
						var _v1 = A2(
							$elm$core$List$partition,
							function (item) {
								return $author$project$Api$Provider$MembershipPatient$ForPatientOne$status(item) === 'ended';
							},
							membershipPatients);
						var endedMembershipPatients = _v1.a;
						var currentMembershipPatients = _v1.b;
						return _List_fromArray(
							[
								(($author$project$Api$Provider$Patient$One$membershipStatus(model.YY) === 'inactive') || (!$elm$core$List$isEmpty(currentMembershipPatients))) ? A5($author$project$Pages$Patients$PatientId_String$Top$viewCurrentMemberships, model.aa4, model.dd, model.YY, model.w2, currentMembershipPatients) : $author$project$Utils$Html$empty,
								$elm$core$List$isEmpty(endedMembershipPatients) ? $author$project$Utils$Html$empty : A5($author$project$Pages$Patients$PatientId_String$Top$viewPastMemberships, model.aa4, model.dd, model.YY, model.w2, endedMembershipPatients)
							]);
					} else {
						return _List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$labelSkeleton('Membership'),
										$author$project$Ui$Form$Group$labelSpanSm(3),
										$author$project$Ui$Form$Group$inputSpanSm(9)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Static$view,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Ui$Skeleton$text(
												_List_fromArray(
													[
														$author$project$Ui$Skeleton$span(10),
														$author$project$Ui$Skeleton$block
													])),
												$author$project$Ui$Skeleton$text(
												_List_fromArray(
													[
														$author$project$Ui$Skeleton$span(2),
														$author$project$Ui$Skeleton$block
													]))
											]))
									]))
							]);
					}
				}())
			]));
};
var $author$project$Api$Provider$Patient$One$mergedInto = function (_v0) {
	var record = _v0.b;
	return record.W3;
};
var $author$project$Pages$Patients$PatientId_String$Top$viewMergedInto = function (patient) {
	var _v0 = $author$project$Api$Provider$Patient$One$mergedInto(patient);
	if (!_v0.$) {
		var merged = _v0.a;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Merged Into'),
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
										{
											YZ: $author$project$Api$Provider$Patient$Min$id(merged)
										}),
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Provider$Patient$Min$name(merged))
										]))
								]))
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Top$DetachPatientButtonClicked = {$: 35};
var $author$project$Pages$Patients$PatientId_String$Top$viewNetworkLinkageAlert = function (patient) {
	return ($author$project$Api$Provider$Patient$One$isSynced(patient) && ($author$project$Api$Provider$Patient$One$membershipStatus(patient) === 'inactive')) ? A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$mb2]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Alert$info,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$row,
						_List_fromArray(
							[$author$project$Ui$Grid$rowItemsCenter]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanSm(1),
										$author$project$Ui$Grid$span(2),
										$author$project$Ui$Grid$textCenter
									]),
								_List_fromArray(
									[
										$author$project$Ui$Icon$lock(
										_List_fromArray(
											[$author$project$Ui$Icon$lg]))
									])),
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanSm(8),
										$author$project$Ui$Grid$span(10)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$mb2]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$strong,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('This patient\'s record is still linked to the network.')
													]))
											])),
										A2(
										$author$project$Ui$Element$view,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Detach this patient from the network to manage their complete profile and memberships.')
											]))
									])),
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanSm(3),
										$author$project$Ui$Grid$justifyRight
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Detach the patient'},
										_List_fromArray(
											[
												$author$project$Ui$Button$styled(7),
												$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$DetachPatientButtonClicked)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Detach the patient')
											]))
									]))
							]))
					]))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Api$Provider$PatientPackage$All$endedPackages = $elm$core$List$filter(
	function (_v0) {
		var record = _v0;
		return record.alH === 1;
	});
var $author$project$Pages$Patients$PatientId_String$Top$OpenPackageDetailsModal = function (a) {
	return {$: 71, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$viewPrepaidCharge = function (prepaidCharge) {
	var remainingQty = $author$project$Api$Provider$PatientPackage$All$remainingQuantity(prepaidCharge);
	var remainingText = '(' + ($elm$core$String$fromInt(remainingQty) + ' remaining)');
	var originalQty = $author$project$Api$Provider$PatientPackage$All$originalQuantity(prepaidCharge);
	var name = $author$project$Api$Provider$PatientPackage$All$chargeItemName(prepaidCharge);
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$text,
				_List_fromArray(
					[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
				$elm$core$String$fromInt(originalQty) + (' ' + name)),
				A2(
				$author$project$Ui$Typography$text,
				_List_fromArray(
					[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted, $author$project$Ui$Typography$bold]),
				' ' + remainingText)
			]));
};
var $author$project$Pages$Patients$PatientId_String$Top$viewPackage = function (_package) {
	var purchasedOn_ = A2(
		$justinmimbs$date$Date$format,
		'MM/dd/yyyy',
		$author$project$Api$Provider$PatientPackage$All$purchasedOn(_package));
	var prepaidCharges_ = $author$project$Api$Provider$PatientPackage$All$prepaidCharges(_package);
	var prepaidChargesView = A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Top$viewPrepaidCharge, prepaidCharges_);
	var packageName_ = $author$project$Api$Provider$PatientPackage$All$packageName(_package);
	var packageDetailsButton = A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$mt2]),
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{mm: 'See package details'},
				_List_fromArray(
					[
						$author$project$Ui$Button$mb8,
						$author$project$Ui$Button$sm,
						$author$project$Ui$Button$styled(0),
						$author$project$Ui$Button$onClick(
						$author$project$Pages$Patients$PatientId_String$Top$OpenPackageDetailsModal(_package))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('See Package Details')
					]))
			]));
	var expiresAt_ = A2(
		$elm$core$Maybe$map,
		$justinmimbs$date$Date$format('MM/dd/yyyy'),
		$author$project$Api$Provider$PatientPackage$All$expiresAt(_package));
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(packageName_),
								A2($elm$html$Html$div, _List_Nil, prepaidChargesView),
								A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$text,
										_List_fromArray(
											[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
										'Purchased on ' + purchasedOn_)
									])),
								function () {
								if (!expiresAt_.$) {
									var expiryDate = expiresAt_.a;
									return A2(
										$author$project$Ui$Element$view,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$text,
												_List_fromArray(
													[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
												'Expires on ' + expiryDate)
											]));
								} else {
									return $elm$html$Html$text('');
								}
							}()
							]))
					])),
				packageDetailsButton
			]));
};
var $author$project$Pages$Patients$PatientId_String$Top$viewActivePackages = function (packages) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Active'),
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Top$viewPackage, packages))
					]))
			]));
};
var $author$project$Pages$Patients$PatientId_String$Top$ToggleEndedPackages = {$: 70};
var $author$project$Pages$Patients$PatientId_String$Top$viewEndedPackages = F2(
	function (showingEnded, packages) {
		var icon = showingEnded ? $author$project$Ui$Icon$chevron(
			_List_fromArray(
				[$author$project$Ui$Icon$rotate180])) : $author$project$Ui$Icon$chevronDown(_List_Nil);
		var endedCount = $elm$core$List$length(packages);
		var buttonText = 'View Ended (' + ($elm$core$String$fromInt(endedCount) + ')');
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Ended'),
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: buttonText},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$ToggleEndedPackages)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(buttonText),
									$author$project$Utils$Html$noBreakSpace,
									icon
								])),
							showingEnded ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mt-2')
								]),
							A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Top$viewPackage, packages)) : $author$project$Utils$Html$empty
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewNoActivePackages = A2(
	$author$project$Ui$Form$Group$view,
	_List_fromArray(
		[
			$author$project$Ui$Form$Group$label('Active'),
			$author$project$Ui$Form$Group$labelSpanSm(3),
			$author$project$Ui$Form$Group$inputSpanSm(9)
		]),
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Form$Static$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$italic, $author$project$Ui$Typography$muted]),
					_List_fromArray(
						[
							$elm$html$Html$text('None')
						]))
				]))
		]));
var $author$project$Pages$Patients$PatientId_String$Top$viewNoEndedPackages = A2(
	$author$project$Ui$Form$Group$view,
	_List_fromArray(
		[
			$author$project$Ui$Form$Group$label('Ended'),
			$author$project$Ui$Form$Group$labelSpanSm(3),
			$author$project$Ui$Form$Group$inputSpanSm(9)
		]),
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Form$Static$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$italic, $author$project$Ui$Typography$muted]),
					_List_fromArray(
						[
							$elm$html$Html$text('None')
						]))
				]))
		]));
var $author$project$Pages$Patients$PatientId_String$Top$viewPackagesSection = function (model) {
	var packagesEnabled = A2(
		$author$project$Utils$FeatureGate$gateAvailable,
		14,
		$author$project$Api$Practice$Provider(model.ZV));
	return packagesEnabled ? A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				$author$project$Ui$Panel$title(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Skeleton$ifLoading,
						model.Cm,
						$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$spanFromText('Packages')
								])),
						$elm$html$Html$text('Packages'))
					])),
				A2(
				$author$project$Ui$Form$view,
				_List_Nil,
				function () {
					var _v0 = model.Cm;
					if (_v0.$ === 3) {
						var patientPackages = _v0.a;
						var endedPackages_ = $author$project$Api$Provider$PatientPackage$All$endedPackages(patientPackages);
						var activePackages_ = $author$project$Api$Provider$PatientPackage$All$activePackages(patientPackages);
						return _List_fromArray(
							[
								(!$elm$core$List$isEmpty(activePackages_)) ? $author$project$Pages$Patients$PatientId_String$Top$viewActivePackages(activePackages_) : $author$project$Pages$Patients$PatientId_String$Top$viewNoActivePackages,
								(!$elm$core$List$isEmpty(endedPackages_)) ? A2($author$project$Pages$Patients$PatientId_String$Top$viewEndedPackages, model.uI, endedPackages_) : $author$project$Pages$Patients$PatientId_String$Top$viewNoEndedPackages
							]);
					} else {
						return _List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$labelSkeleton('Package'),
										$author$project$Ui$Form$Group$labelSpanSm(3),
										$author$project$Ui$Form$Group$inputSpanSm(9)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Static$view,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Ui$Skeleton$text(
												_List_fromArray(
													[
														$author$project$Ui$Skeleton$span(10),
														$author$project$Ui$Skeleton$block
													])),
												$author$project$Ui$Skeleton$text(
												_List_fromArray(
													[
														$author$project$Ui$Skeleton$span(2),
														$author$project$Ui$Skeleton$block
													]))
											]))
									]))
							]);
					}
				}())
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Pages$Patients$PatientId_String$Top$viewPhonesSection = function (patient) {
	var phones = $author$project$Api$Provider$Patient$One$phones(patient);
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Top$viewPhone, phones));
};
var $author$project$Pages$Patients$PatientId_String$Top$viewPractitioner = function (patient) {
	var _v0 = $author$project$Api$Provider$Patient$One$practitioner(patient);
	if (!_v0.$) {
		var practitioner = _v0.a;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Practitioner'),
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$Practitioner$Shared$name(practitioner))
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Top$viewPreferredLanguage = F2(
	function (practice, patient) {
		var multiLanguage = A2($author$project$Api$Provider$Practice$One$featureEnabled, 10, practice);
		return multiLanguage ? A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Preferred Language'),
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Language$toLabel(
								$author$project$Api$Provider$Patient$One$preferredLanguage(patient)))
						]))
				])) : $elm$html$Html$text('');
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewPrimaryCareClinic = F2(
	function (practice, patient) {
		var syncByAffiliation = A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$Network$Shared$syncByAffiliation,
			$author$project$Api$Provider$Practice$One$network(practice));
		var affiliationName = A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Maybe$Nothing,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$Affiliate$AffiliateMin$name,
				$author$project$Api$Provider$Patient$One$assignedAffiliation(patient)));
		var _v0 = _Utils_Tuple2(affiliationName, syncByAffiliation);
		if (((!_v0.a.$) && (!_v0.b.$)) && _v0.b.a) {
			var name = _v0.a.a;
			return A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Primary Care Clinic'),
						$author$project$Ui$Form$Group$labelSpanSm(3),
						$author$project$Ui$Form$Group$inputSpanSm(9)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(name)
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Ui$ProfilePicture$Alt = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$ProfilePicture$alt = $author$project$Ui$ProfilePicture$Alt;
var $author$project$Ui$ProfilePicture$Size = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$ProfilePicture$size = $author$project$Ui$ProfilePicture$Size;
var $author$project$Ui$ProfilePicture$defaultOptions = {xr: _List_Nil, sE: _List_Nil};
var $author$project$Ui$ProfilePicture$pxSize = function (px) {
	return $elm$core$String$fromInt(px) + 'px';
};
var $author$project$Ui$ProfilePicture$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var px = option.a;
						return _Utils_update(
							record,
							{
								xr: $elm$core$List$concat(
									_List_fromArray(
										[
											_List_fromArray(
											[
												A2(
												$elm$html$Html$Attributes$style,
												'width',
												$author$project$Ui$ProfilePicture$pxSize(px)),
												A2(
												$elm$html$Html$Attributes$style,
												'height',
												$author$project$Ui$ProfilePicture$pxSize(px))
											]),
											record.xr
										]))
							});
					case 1:
						var string = option.a;
						return _Utils_update(
							record,
							{
								sE: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$alt(string),
									record.sE)
							});
					default:
						var string = option.a;
						return _Utils_update(
							record,
							{
								xr: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class(string),
									record.xr)
							});
				}
			}),
		$author$project$Ui$ProfilePicture$defaultOptions,
		options);
};
var $author$project$Ui$ProfilePicture$view = F2(
	function (options, profilePictureUrl) {
		var optionsRecord = $author$project$Ui$ProfilePicture$optionsToRecord(options);
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('profile-picture'),
				optionsRecord.xr),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$src(profilePictureUrl),
						optionsRecord.sE),
					_List_Nil)
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewProfilePicture = function (_v0) {
	var patient = _v0.YY;
	var profilePictureUrl = A2(
		$elm$core$Maybe$withDefault,
		'',
		$author$project$Api$Provider$Patient$One$profilePictureUrl(patient));
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Profile Picture'),
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9)
			]),
		_List_fromArray(
			[
				($elm$core$String$length(profilePictureUrl) > 0) ? A2(
				$author$project$Ui$ProfilePicture$view,
				_List_fromArray(
					[
						$author$project$Ui$ProfilePicture$alt(
						$author$project$Api$Provider$Patient$One$name(patient)),
						$author$project$Ui$ProfilePicture$size(80)
					]),
				profilePictureUrl) : A2(
				$author$project$Ui$Form$Static$view,
				_List_fromArray(
					[$author$project$Ui$Form$Static$noValue]),
				_List_Nil)
			]));
};
var $author$project$Pages$Patients$PatientId_String$Top$viewRemoveEphiWaiverModal = function (model) {
	return model.pD ? A2(
		$author$project$Components$HiConfirm$modal,
		$author$project$Pages$Patients$PatientId_String$Top$RemoveEphiWaiverModalClosed,
		_List_fromArray(
			[
				$author$project$Components$HiConfirm$verb('Remove'),
				$author$project$Components$HiConfirm$noun('ePHI Waiver'),
				$author$project$Components$HiConfirm$titleizeNoun(false),
				$author$project$Components$HiConfirm$centerText(false),
				$author$project$Components$HiConfirm$customMessage(
				_List_fromArray(
					[
						$elm$html$Html$text('You\'re about to remove ePHI waiver for this patient. You will no longer be able to send emails to this patient. You can re-authorize at any time.')
					]))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Pages$Patients$PatientId_String$Top$viewRemoveSponsorshipModal = function (model) {
	var _v0 = model.dI;
	if (_v0.a && (!_v0.b.$)) {
		var employeeOrDependant = _v0.b.a;
		var _v1 = function () {
			switch (employeeOrDependant.$) {
				case 0:
					var account = employeeOrDependant.a;
					return _Utils_Tuple2(
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$map,
								$author$project$Api$Provider$Patient$Min$name,
								$author$project$Api$Provider$CompanyAccount$ForPatient$subscriber(account))),
						$author$project$Api$Provider$Company$Min$name(
							$author$project$Api$Provider$CompanyAccount$ForPatient$company(account)));
				case 1:
					var account = employeeOrDependant.a;
					var registration = employeeOrDependant.b;
					return _Utils_Tuple2(
						$author$project$Api$Provider$Patient$Min$name(
							$author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$patient(registration)),
						$author$project$Api$Provider$Company$Min$name(
							$author$project$Api$Provider$CompanyAccount$ForPatient$company(account)));
				default:
					var account = employeeOrDependant.a;
					var patient = employeeOrDependant.c;
					return _Utils_Tuple2(
						$author$project$Api$Provider$Patient$One$name(patient),
						$author$project$Api$Provider$Company$Min$name(
							$author$project$Api$Provider$CompanyAccount$ForPatient$company(account)));
			}
		}();
		var patientName = _v1.a;
		var companyName = _v1.b;
		var details = 'This will permanently remove ' + (patientName + (' from ' + (companyName + '. Are you sure?')));
		return A2(
			$author$project$Components$HiConfirm$modal,
			$author$project$Pages$Patients$PatientId_String$Top$RemoveSponsorshipModalClosed(employeeOrDependant),
			_List_fromArray(
				[
					$author$project$Components$HiConfirm$customMessage(
					_List_fromArray(
						[
							$elm$html$Html$text(details)
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Top$confirmRestorePatientMessage = function (patientName) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Are you sure you want to restore ' + (patientName + '? This will allow you to restart their membership, payments, and emails.'))
						]))
				]))
		]);
};
var $author$project$Pages$Patients$PatientId_String$Top$viewRestorePatientModal = function (model) {
	return model.k1 ? A2(
		$author$project$Components$HiConfirm$modal,
		$author$project$Pages$Patients$PatientId_String$Top$ConfirmRestorePatientModalClicked(
			$author$project$Api$Provider$Patient$One$id(model.YY)),
		_List_fromArray(
			[
				$author$project$Components$HiConfirm$verb('restore'),
				$author$project$Components$HiConfirm$noun('patient'),
				$author$project$Components$HiConfirm$customMessage(
				$author$project$Pages$Patients$PatientId_String$Top$confirmRestorePatientMessage(
					$author$project$Api$Provider$Patient$One$name(model.YY)))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Pages$Patients$PatientId_String$Top$FetchPlainSSN = {$: 0};
var $author$project$Api$Common$SocialSecurityNumber$Masked$maskedNumber = function (_v0) {
	var record = _v0;
	return record.Wy;
};
var $author$project$Api$Provider$Patient$One$ssn = function (_v0) {
	var record = _v0.b;
	return record.ab5;
};
var $author$project$Pages$Patients$PatientId_String$Top$viewSSNSection = function (_v0) {
	var session = _v0.aa4;
	var practice = _v0.ZV;
	var patient = _v0.YY;
	var plainSSN = _v0.Dd;
	var hinterViewOff = _v0.ahK;
	if ($author$project$Api$Provider$Practice$One$ssnEnabled(practice)) {
		var maybeSSN = function () {
			if (plainSSN.$ === 3) {
				var data = plainSSN.a;
				return $author$project$Api$Provider$SocialSecurityNumber$One$formattedNumber(data);
			} else {
				return A2(
					$elm$core$Maybe$andThen,
					$author$project$Api$Common$SocialSecurityNumber$Masked$maskedNumber,
					$author$project$Api$Provider$Patient$One$ssn(patient));
			}
		}();
		if (!maybeSSN.$) {
			var ssn = maybeSSN.a;
			return A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('SSN'),
						$author$project$Ui$Form$Group$labelSpanSm(3),
						$author$project$Ui$Form$Group$inputSpanSm(9)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$text,
										_List_fromArray(
											[
												$author$project$Ui$Typography$phi(true)
											]),
										ssn),
										function () {
										if (plainSSN.$ === 3) {
											return $author$project$Utils$Html$empty;
										} else {
											return A3($author$project$Permission$canGoTo, session, hinterViewOff, 0) ? A3(
												$author$project$Ui$Button$view,
												{mm: 'Show full number'},
												_List_fromArray(
													[
														$author$project$Ui$Button$sm,
														$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$FetchPlainSSN)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Show Full Number')
													])) : $author$project$Utils$Html$empty;
										}
									}()
									]))
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Top$GenerateDebugPortalUrl = {$: 73};
var $author$project$Pages$Patients$PatientId_String$Top$ManagePortalAccessModalOpened = {$: 62};
var $author$project$Pages$Patients$PatientId_String$Top$SendAccessLink = {$: 3};
var $author$project$Api$Provider$EmailAddress$One$isPortalEnabled = function (_v0) {
	var record = _v0;
	return record.ZO;
};
var $author$project$Pages$Patients$PatientId_String$Top$viewSelfService = F8(
	function (sendingAccessLink, timeFormatter, accountAccessSentAt, lastPortalAccessedAt, dataEmailAddress, patient, isHintAdmin, hintEnv) {
		var patientArchived = $author$project$Api$Provider$Patient$One$archived(patient);
		var noEmail = _Utils_eq(
			$author$project$Api$Provider$Patient$One$email(patient),
			$elm$core$Maybe$Nothing);
		var hasDisabledPortal = function () {
			if ((dataEmailAddress.$ === 3) && (!dataEmailAddress.a.$)) {
				var emailAddress = dataEmailAddress.a.a;
				return !$author$project$Api$Provider$EmailAddress$One$isPortalEnabled(emailAddress);
			} else {
				return false;
			}
		}();
		var cannotRequestAccountAccess = patientArchived || noEmail;
		var accessLinkButton = A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mt3]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{mm: 'Send access link to patient'},
					_List_fromArray(
						[
							$author$project$Ui$Button$primary,
							$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$SendAccessLink),
							$author$project$Ui$Button$sm,
							$author$project$Ui$Button$disabled(cannotRequestAccountAccess || hasDisabledPortal),
							$author$project$Ui$Button$loading(sendingAccessLink),
							$author$project$Ui$Button$icon($author$project$Ui$Icon$send)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Send an Access Link')
						]))
				]));
		var links = function () {
			if (cannotRequestAccountAccess) {
				var tooltipMsg = patientArchived ? 'The patient is archived.' : (noEmail ? 'The patient must have a valid email address to send the access link.' : '');
				return A3(
					$author$project$Ui$Tooltip$view,
					_List_Nil,
					tooltipMsg,
					_List_fromArray(
						[accessLinkButton]));
			} else {
				var managePortalAccessButton = A3(
					$author$project$Ui$Button$view,
					{mm: 'Manage portal access'},
					_List_fromArray(
						[
							$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$ManagePortalAccessModalOpened),
							$author$project$Ui$Button$sm,
							$author$project$Ui$Button$disabled(cannotRequestAccountAccess)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Manage Portal Access')
						]));
				var lastSent = function () {
					if (!accountAccessSentAt.$) {
						var time = accountAccessSentAt.a;
						return A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm, $author$project$Ui$Element$mt2]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									'Last sent ' + (A2(timeFormatter, 1, time) + '.'))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}();
				var debugPortalUrlButton = (isHintAdmin && (!_Utils_eq(
					hintEnv,
					$elm$core$Maybe$Just(0)))) ? A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mt3]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$HinterOnly$button,
							{mm: 'View as member'},
							_List_fromArray(
								[
									$author$project$Ui$Button$sm,
									$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$GenerateDebugPortalUrl)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('View as Member')
								]))
						])) : $author$project$Utils$Html$empty;
				var accessLink = hasDisabledPortal ? A3(
					$author$project$Ui$Tooltip$view,
					_List_Nil,
					'This patient\'s portal access is disabled. You can manage this access using the Manage Portal Access button above.',
					_List_fromArray(
						[accessLinkButton])) : accessLinkButton;
				return A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$itemsEnd]),
					_List_fromArray(
						[managePortalAccessButton, accessLink, debugPortalUrlButton, lastSent]));
			}
		}();
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Patient Portal'),
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									function () {
									if (!lastPortalAccessedAt.$) {
										var time = lastPortalAccessedAt.a;
										return $elm$html$Html$text(
											'Last accessed ' + A2(timeFormatter, 1, time));
									} else {
										return $elm$html$Html$text('Never accessed');
									}
								}()
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[links]))
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Top$AddSponsorshipModalOpened = {$: 8};
var $author$project$Pages$Patients$PatientId_String$Top$ToggleViewPastSponsorships = {$: 12};
var $author$project$Api$Provider$Practice$One$hasActiveCompanies = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.S3;
	});
var $author$project$Api$Provider$CompanyAccount$Shared$needsApproval = function (_v0) {
	var record = _v0.b;
	return record.Xx;
};
var $author$project$Api$Provider$CompanyAccount$ForPatient$needsApproval = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyAccount$Shared$needsApproval(shared);
};
var $author$project$Pages$Patients$PatientId_String$Top$Dependent = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Pages$Patients$PatientId_String$Top$Employee = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$RemoveSponsorshipModalOpened = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$CompanyRegistration$ForPatientOne$account = function (_v0) {
	var record = _v0.b;
	return record.KF;
};
var $author$project$Api$Provider$Patient$One$companyRegistrations = function (_v0) {
	var record = _v0.b;
	return record.Oj;
};
var $elm$html$Html$small = _VirtualDom_node('small');
var $author$project$Pages$Patients$PatientId_String$Top$AddDependentModalOpened = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Provider$CompanyAccount$Shared$terminationRequestedAt = function (_v0) {
	var record = _v0.b;
	return record.al0;
};
var $author$project$Api$Provider$CompanyAccount$ForPatient$terminationRequestedAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyAccount$Shared$terminationRequestedAt(shared);
};
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$type_ = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyRegistration$Shared$type_(shared);
};
var $author$project$Pages$Patients$PatientId_String$Top$DependentThrough = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewDependent = F5(
	function (session, account, removingSponsorship, index, registration) {
		var isBeingRemoved = function () {
			if (((!removingSponsorship.a) && (!removingSponsorship.b.$)) && (removingSponsorship.b.a.$ === 1)) {
				var _v2 = removingSponsorship.b.a;
				var reg = _v2.b;
				return _Utils_eq(
					$author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$id(reg),
					$author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$id(registration)) ? A2(
					$author$project$Ui$Grid$column,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Removing')
						])) : $author$project$Ui$Grid$none;
			} else {
				return $author$project$Ui$Grid$none;
			}
		}();
		var canRemove = !$author$project$Api$Provider$CompanyAccount$ForPatient$isEligible(account);
		var removeLink = canRemove ? A3(
			$author$project$Ui$Button$view,
			{mm: 'Delete dependent'},
			_List_fromArray(
				[
					$author$project$Ui$Button$link,
					$author$project$Ui$Button$onClick(
					$author$project$Pages$Patients$PatientId_String$Top$RemoveSponsorshipModalOpened(
						A2($author$project$Pages$Patients$PatientId_String$Top$DependentThrough, account, registration))),
					$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
				]),
			_List_Nil) : $author$project$Utils$Html$empty;
		var _v0 = (index > 0) ? _Utils_Tuple2(
			_List_fromArray(
				[
					$author$project$Ui$Grid$offset(2),
					$author$project$Ui$Grid$span(4)
				]),
			$author$project$Ui$Grid$none) : _Utils_Tuple2(
			_List_fromArray(
				[
					$author$project$Ui$Grid$span(4)
				]),
			A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$span(2)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Dependents: ')
					])));
		var style = _v0.a;
		var dependentsTitle = _v0.b;
		return A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					dependentsTitle,
					A2(
					$author$project$Ui$Grid$column,
					style,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
										{
											YZ: $author$project$Api$Provider$Patient$Min$id(
												$author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$patient(registration))
										}),
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[
													$author$project$Ui$Typography$phi(true)
												]),
											$author$project$Api$Provider$Patient$Min$name(
												$author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$patient(registration)))
										])),
									A2($author$project$Permission$hideIfReadOnly, session, removeLink)
								]))
						])),
					isBeingRemoved
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewDependents = F4(
	function (session, patient, companyAccount, removingSponsorship) {
		var dependents = A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$type_,
				$elm$core$Basics$neq('employee')),
			$author$project$Api$Provider$CompanyAccount$ForPatient$companyRegistrations(companyAccount));
		var canAddDependent = (!$author$project$Utils$Maybe$toBool(
			$author$project$Api$Provider$CompanyAccount$ForPatient$terminationRequestedAt(companyAccount))) && (!$author$project$Api$Provider$Patient$One$isSynced(patient));
		var addDependentButton = canAddDependent ? A3(
			$author$project$Ui$Button$view,
			{mm: 'Add dependent'},
			_List_fromArray(
				[
					$author$project$Ui$Button$sm,
					$author$project$Ui$Button$onClick(
					$author$project$Pages$Patients$PatientId_String$Top$AddDependentModalOpened(companyAccount)),
					$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Add Dependent')
				])) : $author$project$Utils$Html$empty;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					($elm$core$List$length(dependents) > 0) ? A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						A3($author$project$Pages$Patients$PatientId_String$Top$viewDependent, session, companyAccount, removingSponsorship),
						dependents)) : $author$project$Utils$Html$empty,
					addDependentButton
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewCompanyAccount = F2(
	function (_v0, companyAccount) {
		var session = _v0.aa4;
		var patient = _v0.YY;
		var removingSponsorship = _v0.dI;
		var patientIsEmployee = _Utils_eq(
			$elm$core$Maybe$Just(
				$author$project$Api$Provider$Patient$One$id(patient)),
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$Patient$Min$id,
				$author$project$Api$Provider$CompanyAccount$ForPatient$subscriber(companyAccount)));
		var isBeingRemoved = function () {
			_v3$2:
			while (true) {
				if ((!removingSponsorship.a) && (!removingSponsorship.b.$)) {
					switch (removingSponsorship.b.a.$) {
						case 0:
							var account = removingSponsorship.b.a.a;
							return _Utils_eq(
								$author$project$Api$Provider$CompanyAccount$ForPatient$id(account),
								$author$project$Api$Provider$CompanyAccount$ForPatient$id(companyAccount)) ? A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Removing')
									])) : $author$project$Utils$Html$empty;
						case 2:
							var _v4 = removingSponsorship.b.a;
							var account = _v4.a;
							return _Utils_eq(
								$author$project$Api$Provider$CompanyAccount$ForPatient$id(account),
								$author$project$Api$Provider$CompanyAccount$ForPatient$id(companyAccount)) ? A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Removing')
									])) : $author$project$Utils$Html$empty;
						default:
							break _v3$2;
					}
				} else {
					break _v3$2;
				}
			}
			return $author$project$Utils$Html$empty;
		}();
		var employeeOrDependentText = patientIsEmployee ? _List_fromArray(
			[
				$elm$html$Html$text(' Employee ')
			]) : _List_fromArray(
			[
				$elm$html$Html$text(' Dependent through '),
				function () {
				var _v2 = $author$project$Api$Provider$CompanyAccount$ForPatient$subscriber(companyAccount);
				if (!_v2.$) {
					var pat = _v2.a;
					return A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
							{
								YZ: $author$project$Api$Provider$Patient$Min$id(pat)
							}),
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$text,
								_List_fromArray(
									[
										$author$project$Ui$Typography$phi(true)
									]),
								$author$project$Api$Provider$Patient$Min$name(pat))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]);
		var employeeOrDependant = A2($elm$html$Html$span, _List_Nil, employeeOrDependentText);
		var canRemove = patientIsEmployee ? (!($author$project$Api$Provider$CompanyAccount$ForPatient$isEligible(companyAccount) || $author$project$Api$Provider$Patient$One$isSynced(patient))) : (!$author$project$Api$Provider$CompanyAccount$ForPatient$isEligible(companyAccount));
		var removeLink = function () {
			if (canRemove) {
				if (patientIsEmployee) {
					return A3(
						$author$project$Ui$Button$view,
						{mm: 'Remove sponsorship'},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$onClick(
								$author$project$Pages$Patients$PatientId_String$Top$RemoveSponsorshipModalOpened(
									$author$project$Pages$Patients$PatientId_String$Top$Employee(companyAccount))),
								$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
							]),
						_List_Nil);
				} else {
					var registrationForAccount = $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (reg) {
								return _Utils_eq(
									A2(
										$elm$core$Maybe$map,
										$author$project$Api$Provider$CompanyAccount$Min$id,
										$author$project$Api$Provider$CompanyRegistration$ForPatientOne$account(reg)),
									$elm$core$Maybe$Just(
										$author$project$Api$Provider$CompanyAccount$ForPatient$id(companyAccount)));
							},
							$author$project$Api$Provider$Patient$One$companyRegistrations(patient)));
					if (!registrationForAccount.$) {
						var registration = registrationForAccount.a;
						return A3(
							$author$project$Ui$Button$view,
							{mm: 'Remove sponsorship'},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$onClick(
									$author$project$Pages$Patients$PatientId_String$Top$RemoveSponsorshipModalOpened(
										A3($author$project$Pages$Patients$PatientId_String$Top$Dependent, companyAccount, registration, patient))),
									$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
								]),
							_List_Nil);
					} else {
						return $author$project$Utils$Html$empty;
					}
				}
			} else {
				return $author$project$Utils$Html$empty;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Element$custom,
							'inline-flex',
							_List_fromArray(
								[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
							A2(
								$elm$core$List$filterMap,
								$elm$core$Basics$identity,
								_List_fromArray(
									[
										$author$project$Api$Provider$CompanyAccount$ForPatient$needsApproval(companyAccount) ? $elm$core$Maybe$Just(
										A2(
											$author$project$Ui$Badge$view,
											_List_fromArray(
												[
													$author$project$Ui$Badge$warning,
													$author$project$Ui$Badge$test('sponsorship-needs-approval')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Needs Approval')
												]))) : $elm$core$Maybe$Nothing,
										$elm$core$Maybe$Just(
										A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top(
												{
													fZ: $author$project$Api$Provider$Company$Min$id(
														$author$project$Api$Provider$CompanyAccount$ForPatient$company(companyAccount))
												}),
											_List_fromArray(
												[
													$author$project$Ui$Link$routeParams(
													_List_fromArray(
														[
															A2(
															$elm$url$Url$Builder$string,
															'q',
															$author$project$Api$Provider$Patient$One$name(patient))
														]))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Api$Provider$Company$Min$name(
														$author$project$Api$Provider$CompanyAccount$ForPatient$company(companyAccount)))
												])))
									]))),
							A2(
							$elm$html$Html$small,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-muted')
								]),
							_List_fromArray(
								[
									employeeOrDependant,
									A2($author$project$Permission$hideIfReadOnly, session, removeLink)
								]))
						])),
					isBeingRemoved,
					patientIsEmployee ? A4($author$project$Pages$Patients$PatientId_String$Top$viewDependents, session, patient, companyAccount, removingSponsorship) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewSponsorshipsSection = function (model) {
	if ($author$project$Api$Provider$Practice$One$hasActiveCompanies(model.ZV)) {
		var pendingSponsorships = A2($elm$core$List$filter, $author$project$Api$Provider$CompanyAccount$ForPatient$needsApproval, model.hK);
		var pastSponsorships = A2(
			$elm$core$List$filter,
			function (account) {
				return (!$author$project$Api$Provider$CompanyAccount$ForPatient$isEligible(account)) && (!$author$project$Api$Provider$CompanyAccount$ForPatient$needsApproval(account));
			},
			model.hK);
		var eligibleSponsorships = A2($elm$core$List$filter, $author$project$Api$Provider$CompanyAccount$ForPatient$isEligible, model.hK);
		var anyPendingSponsorship = $elm$core$List$length(pendingSponsorships) > 0;
		var anyPastSponsorship = $elm$core$List$length(pastSponsorships) > 0;
		var anyEligibleSponsorship = $elm$core$List$length(eligibleSponsorships) > 0;
		var addSponsorshipLink = $author$project$Api$Provider$Patient$One$isSynced(model.YY) ? $author$project$Utils$Html$empty : A2(
			$author$project$Permission$hideIfReadOnly,
			model.aa4,
			A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$flex, $author$project$Ui$Element$justifyRight]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Add sponsorship'},
						_List_fromArray(
							[
								$author$project$Ui$Button$disabled(
								$author$project$Api$Provider$Patient$One$archived(model.YY)),
								$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$AddSponsorshipModalOpened),
								$author$project$Ui$Button$sm
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Add Sponsorship')
							]))
					])));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$HorizontalRule$view(_List_Nil),
					$author$project$Ui$Panel$title(
					_List_fromArray(
						[
							$elm$html$Html$text('Sponsorships')
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('Eligible Sponsorship'),
							$author$project$Ui$Form$Group$labelSpanSm(3),
							$author$project$Ui$Form$Group$inputSpanSm(9)
						]),
					A2(
						$elm$core$List$cons,
						addSponsorshipLink,
						anyEligibleSponsorship ? A2(
							$elm$core$List$map,
							$author$project$Pages$Patients$PatientId_String$Top$viewCompanyAccount(model),
							eligibleSponsorships) : _List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Static$view,
								_List_fromArray(
									[$author$project$Ui$Form$Static$noValue]),
								_List_Nil)
							]))),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('Pending Sponsorship'),
							$author$project$Ui$Form$Group$labelSpanSm(3),
							$author$project$Ui$Form$Group$inputSpanSm(9)
						]),
					A2(
						$elm$core$List$cons,
						addSponsorshipLink,
						anyPendingSponsorship ? A2(
							$elm$core$List$map,
							$author$project$Pages$Patients$PatientId_String$Top$viewCompanyAccount(model),
							pendingSponsorships) : _List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Static$view,
								_List_fromArray(
									[$author$project$Ui$Form$Static$noValue]),
								_List_Nil)
							]))),
					model.qb ? A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('Past Sponsorship'),
							$author$project$Ui$Form$Group$labelSpanSm(3),
							$author$project$Ui$Form$Group$inputSpanSm(9)
						]),
					A2(
						$elm$core$List$map,
						$author$project$Pages$Patients$PatientId_String$Top$viewCompanyAccount(model),
						pastSponsorships)) : $author$project$Utils$Html$empty,
					anyPastSponsorship ? A2(
					$author$project$Ui$Form$Group$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$offsetSm(3),
											$author$project$Ui$Grid$spanSm(9)
										]),
									_List_fromArray(
										[
											function () {
											var _v0 = model.qb ? _Utils_Tuple2(
												'Hide past sponsorships ',
												$author$project$Ui$Icon$chevron(
													_List_fromArray(
														[$author$project$Ui$Icon$rotate180]))) : _Utils_Tuple2(
												'See past sponsorships ',
												$author$project$Ui$Icon$chevronDown(_List_Nil));
											var label = _v0.a;
											var icon = _v0.b;
											return A3(
												$author$project$Ui$Button$view,
												{mm: label},
												_List_fromArray(
													[
														$author$project$Ui$Button$link,
														$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$ToggleViewPastSponsorships)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(label),
														icon
													]));
										}()
										]))
								]))
						])) : $author$project$Utils$Html$empty
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Top$viewTobaccoSection = F2(
	function (practice, patient) {
		var tobaccoEnabled = A2($author$project$Api$Provider$Practice$One$featureEnabled, 2, practice);
		return tobaccoEnabled ? A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Tobacco Use'),
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9)
				]),
			_List_fromArray(
				[
					function () {
					var _v0 = $author$project$Api$Provider$Patient$One$usesTobacco(patient);
					if (!_v0.$) {
						var usesTobaccoBool = _v0.a;
						var usesTobaccoStr = usesTobaccoBool ? 'Uses tobacco' : 'Does not use tobacco';
						return A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(usesTobaccoStr)
								]));
					} else {
						return A2(
							$author$project$Ui$Form$Static$view,
							_List_fromArray(
								[$author$project$Ui$Form$Static$noValue]),
							_List_Nil);
					}
				}()
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Api$Provider$Addon$Min$sendsExternalEmail = function (_v0) {
	var record = _v0;
	return record.aaW;
};
var $author$project$Api$Provider$PatientMceEligibility$Shared$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Api$Provider$PatientMceEligibility$All$status = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PatientMceEligibility$Shared$status(shared);
};
var $author$project$Pages$Patients$PatientId_String$Top$SendAddonEmail = function (a) {
	return {$: 54, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$viewEmailableAddon = F2(
	function (addonRequestsLoading, addon) {
		return A2(
			$author$project$Ui$Form$Static$view,
			_List_fromArray(
				[$author$project$Ui$Form$Static$flex, $author$project$Ui$Form$Static$spaceBetween, $author$project$Ui$Form$Static$itemsCenter]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Api$Provider$Addon$Min$name(addon)),
					A3(
					$author$project$Ui$Button$view,
					{mm: 'Send enrollment email'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$onClick(
							$author$project$Pages$Patients$PatientId_String$Top$SendAddonEmail(addon)),
							$author$project$Ui$Button$loading(
							A2(
								$elm$core$Set$member,
								$author$project$Api$Provider$Addon$Min$id(addon),
								addonRequestsLoading))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Send Enrollment Email')
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Top$SendMceActivationEmail = function (a) {
	return {$: 56, a: a};
};
var $author$project$Api$Provider$PatientMceEligibility$Shared$message = function (_v0) {
	var record = _v0;
	return record.aiH;
};
var $author$project$Api$Provider$PatientMceEligibility$All$message = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PatientMceEligibility$Shared$message(shared);
};
var $author$project$Pages$Patients$PatientId_String$Top$viewMceSendActivationButton = F2(
	function (mceActivationsLoading, patientMceEligibility) {
		var message = A2(
			$elm$core$Maybe$withDefault,
			'',
			$author$project$Api$Provider$PatientMceEligibility$All$message(patientMceEligibility));
		return $elm$core$String$isEmpty(message) ? A3(
			$author$project$Ui$Button$view,
			{mm: ' Send enrollment email'},
			_List_fromArray(
				[
					$author$project$Ui$Button$link,
					$author$project$Ui$Button$primary,
					$author$project$Ui$Button$onClick(
					$author$project$Pages$Patients$PatientId_String$Top$SendMceActivationEmail(patientMceEligibility)),
					$author$project$Ui$Button$loading(
					A2(
						$elm$core$Set$member,
						$author$project$Api$Provider$PatientMceEligibility$All$id(patientMceEligibility),
						mceActivationsLoading)),
					$author$project$Ui$Button$icon($author$project$Ui$Icon$send),
					$author$project$Ui$Button$sm
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Send Enrollment Email')
				])) : A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(message)
				]));
	});
var $author$project$Api$Provider$PatientMceEligibility$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$PatientMceEligibility$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PatientMceEligibility$Shared$name(shared);
};
var $author$project$Pages$Patients$PatientId_String$Top$viewPatientMceEligibility = function (patientMceEligibility) {
	var message = A2(
		$elm$core$Maybe$withDefault,
		'',
		$author$project$Api$Provider$PatientMceEligibility$All$message(patientMceEligibility));
	return A2(
		$elm$html$Html$span,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Api$Provider$PatientMceEligibility$All$name(patientMceEligibility)),
				$author$project$Utils$Html$noBreakSpace,
				(($author$project$Api$Provider$PatientMceEligibility$All$status(patientMceEligibility) === 'active') || (!$elm$core$String$isEmpty(message))) ? A2(
				$author$project$Ui$Badge$fromString,
				_List_Nil,
				$author$project$Api$Provider$PatientMceEligibility$All$status(patientMceEligibility)) : $author$project$Utils$Html$empty
			]));
};
var $author$project$Pages$Patients$PatientId_String$Top$viewInactivePatientMceEligibility = F2(
	function (mceActivationsLoading, patientMceEligibility) {
		return A2(
			$author$project$Ui$Form$Static$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween]),
					_List_fromArray(
						[
							$author$project$Pages$Patients$PatientId_String$Top$viewPatientMceEligibility(patientMceEligibility),
							A2($author$project$Pages$Patients$PatientId_String$Top$viewMceSendActivationButton, mceActivationsLoading, patientMceEligibility)
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewWrapArounds = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		A2(
			$elm$core$List$cons,
			function () {
				var _v0 = model.oC;
				if (!_v0.$) {
					return $author$project$Utils$Html$empty;
				} else {
					return $author$project$Ui$HorizontalRule$view(_List_Nil);
				}
			}(),
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Panel$title(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Skeleton$ifLoading,
							model.oC,
							$author$project$Ui$Skeleton$text(
								_List_fromArray(
									[
										$author$project$Ui$Skeleton$spanFromText('Wrap-Arounds')
									])),
							$elm$html$Html$text('Wrap-Arounds'))
						])),
				function () {
					var _v1 = model.oC;
					switch (_v1.$) {
						case 3:
							var mcePractices = _v1.a;
							var emailableAddons = A2(
								$elm$core$List$filter,
								function (addon) {
									return $author$project$Api$Provider$Addon$Min$sendsExternalEmail(addon);
								},
								$author$project$Api$Provider$Practice$One$addons(model.ZV));
							if ($elm$core$List$isEmpty(mcePractices) && $elm$core$List$isEmpty(emailableAddons)) {
								return _List_Nil;
							} else {
								var mceInactivePractices = A2(
									$elm$core$List$filter,
									function (mcePractice) {
										return $author$project$Api$Provider$PatientMceEligibility$All$status(mcePractice) === 'inactive';
									},
									mcePractices);
								var mceActivePractices = A2(
									$elm$core$List$filter,
									function (mcePractice) {
										return $author$project$Api$Provider$PatientMceEligibility$All$status(mcePractice) === 'active';
									},
									mcePractices);
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$Form$view,
										_List_Nil,
										_List_fromArray(
											[
												(!$elm$core$List$isEmpty(mceActivePractices)) ? A2(
												$author$project$Ui$Form$Group$view,
												_List_fromArray(
													[
														$author$project$Ui$Form$Group$label('Current and Pending'),
														$author$project$Ui$Form$Group$labelSpanSm(3),
														$author$project$Ui$Form$Group$inputSpanSm(9)
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Form$Static$view,
														_List_Nil,
														A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Top$viewPatientMceEligibility, mceActivePractices))
													])) : $author$project$Utils$Html$empty,
												($elm$core$List$isEmpty(mceInactivePractices) && $elm$core$List$isEmpty(emailableAddons)) ? $author$project$Utils$Html$empty : A2(
												$author$project$Ui$Form$Group$view,
												_List_fromArray(
													[
														$author$project$Ui$Form$Group$label('Available'),
														$author$project$Ui$Form$Group$labelSpanSm(3),
														$author$project$Ui$Form$Group$inputSpanSm(9)
													]),
												_Utils_ap(
													A2(
														$elm$core$List$map,
														$author$project$Pages$Patients$PatientId_String$Top$viewInactivePatientMceEligibility(model.kj),
														mceInactivePractices),
													A2(
														$elm$core$List$map,
														$author$project$Pages$Patients$PatientId_String$Top$viewEmailableAddon(model.ii),
														emailableAddons)))
											]))
									]);
							}
						case 1:
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$labelSkeleton('Wrap around'),
											$author$project$Ui$Form$Group$labelSpanSm(3),
											$author$project$Ui$Form$Group$inputSpanSm(9)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													$author$project$Ui$Skeleton$text(
													_List_fromArray(
														[
															$author$project$Ui$Skeleton$span(3)
														]))
												]))
										]))
								]);
						default:
							return _List_fromArray(
								[$author$project$Utils$Html$empty]);
					}
				}())));
};
var $author$project$Pages$Patients$PatientId_String$Top$view = function (model) {
	var name = _Utils_ap(
		function () {
			var _v1 = $author$project$Api$Provider$Patient$One$chosenTitle(model.YY);
			if (!_v1.$) {
				var chosenTitle = _v1.a;
				return chosenTitle + ' ';
			} else {
				var title = A2(
					$elm$core$Maybe$withDefault,
					'',
					$author$project$Api$Provider$Patient$One$title(model.YY));
				return (title === '') ? '' : (title + ' ');
			}
		}(),
		$author$project$Api$Provider$Patient$One$name(model.YY));
	var dob = function () {
		var _v0 = $author$project$Api$Provider$Patient$One$dob(model.YY);
		if (!_v0.$) {
			var date = _v0.a;
			return A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, date);
		} else {
			return '';
		}
	}();
	return {
		fO: _List_fromArray(
			[
				$author$project$Pages$Patients$PatientId_String$Top$viewAddSponsorshipModal(model),
				$author$project$Pages$Patients$PatientId_String$Top$viewAddDependentModal(model),
				$author$project$Pages$Patients$PatientId_String$Top$viewRemoveSponsorshipModal(model),
				$author$project$Pages$Patients$PatientId_String$Top$viewCreateMembershipModal(model),
				$author$project$Pages$Patients$PatientId_String$Top$viewRestorePatientModal(model),
				$author$project$Pages$Patients$PatientId_String$Top$viewElationForcePushConfirmModal(model),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Patients$PatientId_String$Top$PackageDetailsModalMsg,
				$author$project$Components$Patient$PackageDetailsModal$view(model.dA)),
				$author$project$Pages$Patients$PatientId_String$Top$viewDetachPatientModal(model),
				$author$project$Pages$Patients$PatientId_String$Top$viewEditCustomFormAnswerModal(model),
				$author$project$Pages$Patients$PatientId_String$Top$viewMembershipDetailsModal(model),
				$author$project$Pages$Patients$PatientId_String$Top$viewAcceptEphiWaiverModal(model),
				$author$project$Pages$Patients$PatientId_String$Top$viewRemoveEphiWaiverModal(model),
				$author$project$Pages$Patients$PatientId_String$Top$viewManagePortalAccessModal(model),
				$author$project$Pages$Patients$PatientId_String$Top$viewEditAthenaIdModal(model),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Pages$Patients$PatientId_String$Top$viewArchivedPatientAlert(model.YY),
								$author$project$Pages$Patients$PatientId_String$Top$viewNetworkLinkageAlert(model.YY),
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$itemsCenter]),
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Patient')
											])),
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$ml2]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Pages$Patients$PatientId_String$Top$AuditTrailLogMsg,
												$author$project$Components$AuditTrailLog$view(model.iw))
											]))
									])),
								A2(
								$author$project$Ui$Form$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$label('Patient Info'),
												$author$project$Ui$Form$Group$labelSpanSm(3),
												$author$project$Ui$Form$Group$inputSpanSm(9)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Form$Static$view,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Element$view,
																_List_fromArray(
																	[$author$project$Ui$Element$spaceBetween]),
																_List_fromArray(
																	[
																		A2(
																		$author$project$Ui$Element$view,
																		_List_fromArray(
																			[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap]),
																		_List_fromArray(
																			[
																				A2(
																				$author$project$Ui$Typography$text,
																				_List_fromArray(
																					[
																						$author$project$Ui$Typography$phi(true)
																					]),
																				name),
																				A2(
																				$author$project$Ui$Typography$text,
																				_List_fromArray(
																					[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small, $author$project$Ui$Typography$italic]),
																				$author$project$Api$Provider$Patient$One$id(model.YY)),
																				A2(
																				$author$project$Pages$Patients$PatientId_String$Top$viewCopyButton,
																				'patient identifier ',
																				$author$project$Api$Provider$Patient$One$id(model.YY))
																			])),
																		A2(
																		$author$project$Permission$hideIfReadOnly,
																		model.aa4,
																		A3(
																			$author$project$Ui$Link$route,
																			$author$project$Spa$Generated$Route$Patients__PatientId_String__Edit(
																				{
																					YZ: $author$project$Api$Provider$Patient$One$id(model.YY)
																				}),
																			_List_fromArray(
																				[
																					$author$project$Ui$Link$buttonDefault,
																					$author$project$Ui$Link$disabled(
																					$author$project$Api$Provider$Patient$One$archived(model.YY)),
																					$author$project$Ui$Link$xs,
																					$author$project$Ui$Link$icon($author$project$Ui$Icon$edit)
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text('Edit Patient Details')
																				])))
																	]))
															])),
														A2(
														$elm$html$Html$div,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Typography$text,
																_List_fromArray(
																	[
																		$author$project$Ui$Typography$phi(true)
																	]),
																dob)
															])),
														A2($author$project$Pages$Patients$PatientId_String$Top$viewGenderSection, model.ZV, model.YY),
														A2($author$project$Pages$Patients$PatientId_String$Top$viewEmailSection, model.YY, model.r7),
														$author$project$Pages$Patients$PatientId_String$Top$viewPhonesSection(model.YY),
														A2($author$project$Pages$Patients$PatientId_String$Top$viewAddressesSection, model.ZV, model.YY)
													]))
											])),
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$label('Emergency Contact'),
												$author$project$Ui$Form$Group$labelSpanSm(3),
												$author$project$Ui$Form$Group$inputSpanSm(9)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Static$view,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$core$Maybe$withDefault,
														A2(
															$author$project$Ui$Typography$p,
															_List_fromArray(
																[$author$project$Ui$Typography$italic, $author$project$Ui$Typography$muted]),
															_List_fromArray(
																[
																	$elm$html$Html$text('None')
																])),
														A2(
															$elm$core$Maybe$map,
															$author$project$Pages$Patients$PatientId_String$Top$viewEmergencyContact,
															$author$project$Api$Provider$Patient$One$emergencyContact(model.YY)))
													]))
											])),
										A2($author$project$Pages$Patients$PatientId_String$Top$viewPreferredLanguage, model.ZV, model.YY),
										$author$project$Pages$Patients$PatientId_String$Top$viewProfilePicture(model),
										$author$project$Pages$Patients$PatientId_String$Top$viewSSNSection(model),
										$author$project$Pages$Patients$PatientId_String$Top$viewHealthInsurance(model.YY),
										$author$project$Pages$Patients$PatientId_String$Top$viewPractitioner(model.YY),
										A2($author$project$Pages$Patients$PatientId_String$Top$viewLocation, model.ZV, model.YY),
										A2($author$project$Pages$Patients$PatientId_String$Top$viewDpcPractice, model.ZV, model.YY),
										A2($author$project$Pages$Patients$PatientId_String$Top$viewPrimaryCareClinic, model.ZV, model.YY),
										A2($author$project$Pages$Patients$PatientId_String$Top$viewTobaccoSection, model.ZV, model.YY),
										$author$project$Pages$Patients$PatientId_String$Top$viewJoinDate(model.YY),
										$author$project$Pages$Patients$PatientId_String$Top$viewLeadSource(model.YY),
										A3(
										$author$project$Utils$FeatureGate$gate,
										5,
										$author$project$Api$Practice$Provider(model.ZV),
										A8($author$project$Pages$Patients$PatientId_String$Top$viewSelfService, model.pX, model.J7, model.KG, model.VJ, model.r7, model.YY, model.Ij, model.ahJ)),
										$author$project$Pages$Patients$PatientId_String$Top$viewEngagement(model),
										$author$project$Pages$Patients$PatientId_String$Top$viewMergedInto(model.YY),
										$author$project$Pages$Patients$PatientId_String$Top$viewSponsorshipsSection(model)
									])),
								$author$project$Pages$Patients$PatientId_String$Top$viewMembershipSection(model),
								$author$project$Pages$Patients$PatientId_String$Top$viewPackagesSection(model),
								$author$project$Pages$Patients$PatientId_String$Top$viewWrapArounds(model),
								$author$project$Pages$Patients$PatientId_String$Top$viewFinancialInformation(model),
								$author$project$Pages$Patients$PatientId_String$Top$viewAgreementsSection(model),
								$author$project$Pages$Patients$PatientId_String$Top$viewIntegrationsSection(model),
								$author$project$Pages$Patients$PatientId_String$Top$viewCustomFormsSection(model)
							]))
					]))
			]),
		ac9: 'Patient | ' + $author$project$Api$Provider$Patient$One$id(model.YY)
	};
};
var $author$project$Pages$Patients$PatientId_String$Top$page = $author$project$Spa$Page$applicationPatient(
	{ah_: $author$project$Pages$Patients$PatientId_String$Top$init, aiq: $author$project$Pages$Patients$PatientId_String$Top$load, k8: $author$project$Pages$Patients$PatientId_String$Top$save, alO: $author$project$Pages$Patients$PatientId_String$Top$subscriptions, adT: $author$project$Pages$Patients$PatientId_String$Top$update, amo: $author$project$Pages$Patients$PatientId_String$Top$view});
var $author$project$Pages$Patients$PatientId_String$VitalsTrends$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Patients$PatientId_String$VitalsTrends$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Patients$PatientId_String$VitalsTrends$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Patients$PatientId_String$VitalsTrends$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Vitals Trends'};
};
var $author$project$Pages$Patients$PatientId_String$VitalsTrends$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$Patients$PatientId_String$VitalsTrends$init,
		aiq: $author$project$Pages$Patients$PatientId_String$VitalsTrends$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$Patients$PatientId_String$VitalsTrends$update,
		amo: $author$project$Pages$Patients$PatientId_String$VitalsTrends$view
	});
var $author$project$Api$Provider$Report$Patient = 0;
var $author$project$Pages$Patients$Top$PatientsListMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$PatientsList$GotTodaysDate = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$PatientsList$PracticePulseMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$PatientsList$GotPatients = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$PatientsList$fetchParams = function (_v0) {
	var filters = _v0.h;
	var pagination = _v0.ajJ;
	var sort = _v0.alA;
	return function (d) {
		return _Utils_update(
			d,
			{Li: filters.rd, afQ: filters.fZ, HM: filters.h, ais: filters.We, s4: filters.gL, ajJ: pagination, Jb: filters.aj4, aka: filters.Z2, akl: filters.akl, alA: sort});
	};
};
var $author$project$Components$PatientsList$fetchPatients = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Api$Provider$Patient$list,
			apiClient,
			$author$project$Components$PatientsList$fetchParams(model),
			$author$project$Components$PatientsList$GotPatients(model.h.akl));
	});
var $author$project$Components$PracticePulse$GotPulse = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Pulse$One$Pulse = $elm$core$Basics$identity;
var $author$project$Api$Provider$Pulse$One$Record = function (activePatients) {
	return function (newPatients) {
		return function (newTerminations) {
			return function (patientInvoicesDueInCents) {
				return function (sponsorInvoicesDueInCents) {
					return function (totalPractitioners) {
						return function (activePatientsPercentage) {
							return function (newPatientsPercentage) {
								return function (newTerminationsPercentage) {
									return function (patientInvoicesDueInCentsPercentage) {
										return function (sponsorInvoicesDueInCentsPercentage) {
											return function (upcomingBirthdayPatients) {
												return {KU: activePatients, KV: activePatientsPercentage, XJ: newPatients, XK: newPatientsPercentage, XN: newTerminations, XO: newTerminationsPercentage, Y$: patientInvoicesDueInCents, Y0: patientInvoicesDueInCentsPercentage, ab$: sponsorInvoicesDueInCents, ab0: sponsorInvoicesDueInCentsPercentage, adq: totalPractitioners, adR: upcomingBirthdayPatients};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Pulse$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'upcoming_birthday_patients',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'sponsor_invoices_due_in_cents_percentage',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'patient_invoices_due_in_cents_percentage',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'new_terminations_percentage',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'new_patients_percentage',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'active_patients_percentage',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'total_practitioners',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'sponsor_invoices_due_in_cents',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'patient_invoices_due_in_cents',
									$elm$json$Json$Decode$int,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'new_terminations',
										$elm$json$Json$Decode$int,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'new_patients',
											$elm$json$Json$Decode$int,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'active_patients',
												$elm$json$Json$Decode$int,
												$elm$json$Json$Decode$succeed($author$project$Api$Provider$Pulse$One$Record)))))))))))));
var $author$project$Api$Provider$Pulse$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Pulse$One$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Pulse$pulsePath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['pulse']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Pulse$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Pulse$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Pulse$pulsePath));
	});
var $author$project$Components$PracticePulse$init = F2(
	function (apiClient, session) {
		return _Utils_Tuple2(
			{t6: $author$project$Api$Data$Loading, aa4: session},
			A2($author$project$Api$Provider$Pulse$retrieve, apiClient, $author$project$Components$PracticePulse$GotPulse));
	});
var $author$project$Components$PatientsList$AffiliateResourceFilterMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$PatientsList$CompanyResourceFilterMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$PatientsList$GroupLocationAndPractitionerFiltersMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$PatientsList$PlanResourceFilterMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$LocationGroupResourceFilterMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$LocationResourceFilterMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$PractitionerResourceFilterMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$initLocationFilter = F4(
	function (apiClient, locationsFilterVisible, locationGroupId, locationId) {
		return locationsFilterVisible ? A2(
			$elm$core$Tuple$mapFirst,
			$elm$core$Maybe$Just,
			A4(
				$author$project$Components$ResourceFilter$Location$init,
				apiClient,
				locationGroupId,
				$elm$core$Basics$identity,
				function (d) {
					return _Utils_update(
						d,
						{
							Gp: 'All Locations',
							ai5: _Utils_eq(locationGroupId, $elm$core$Maybe$Nothing),
							akb: locationId
						});
				})) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
	});
var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$initPractitionerFilter = F5(
	function (apiClient, hidePractitioner, locationGroupId, locationId, practitionerId) {
		return (!hidePractitioner) ? A2(
			$elm$core$Tuple$mapFirst,
			$elm$core$Maybe$Just,
			A3(
				$author$project$Components$ResourceFilter$Practitioner$init,
				apiClient,
				function (d) {
					return _Utils_update(
						d,
						{ais: locationId, s4: locationGroupId});
				},
				function (d) {
					return _Utils_update(
						d,
						{Gp: 'All Providers', ai5: true, akb: practitionerId});
				})) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
	});
var $author$project$Api$Platform$Session$One$restrictedByGroups = function (_v0) {
	var record = _v0;
	return A2($elm$core$Maybe$withDefault, false, record.$T);
};
var $author$project$Api$Platform$Session$One$locationGroups = function (_v0) {
	var record = _v0;
	return record.Wa;
};
var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$userCanSelectLocationGroup = F2(
	function (session, practice) {
		return $author$project$Api$Platform$Session$One$restrictedByGroups(session) ? A3(
			$elm$core$Basics$composeL,
			$elm$core$Basics$not,
			$elm$core$List$isEmpty,
			$author$project$Api$Platform$Session$One$locationGroups(session)) : ($author$project$Api$Provider$Practice$One$locationGroupsCount(practice) > 0);
	});
var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$init = F7(
	function (apiClient, session, practice, hidePractitioner, locationGroupId, locationId, practitionerId) {
		var locationsFilterVisible = $author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice);
		var locationGroupsFilterVisible = locationsFilterVisible && A2($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$userCanSelectLocationGroup, session, practice);
		var _v0 = A5($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$initPractitionerFilter, apiClient, hidePractitioner, locationGroupId, locationId, practitionerId);
		var practitionerResourceFilter = _v0.a;
		var practitionerResourceFilterCmd = _v0.b;
		var _v1 = A4($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$initLocationFilter, apiClient, locationsFilterVisible, locationGroupId, locationId);
		var locationResourceFilter = _v1.a;
		var locationResourceFilterCmd = _v1.b;
		var _v2 = function () {
			if (locationGroupsFilterVisible) {
				var userRestrictedByGroups = $author$project$Api$Platform$Session$One$restrictedByGroups(session);
				return A2(
					$elm$core$Tuple$mapFirst,
					$elm$core$Maybe$Just,
					A2(
						$author$project$Components$ResourceFilter$LocationGroup$init,
						apiClient,
						function (d) {
							return _Utils_update(
								d,
								{Gp: 'All Groups', ai5: !userRestrictedByGroups, akb: locationGroupId});
						}));
			} else {
				return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
			}
		}();
		var locationGroupResourceFilter = _v2.a;
		var locationGroupResourceFilterCmd = _v2.b;
		return _Utils_Tuple2(
			{zU: hidePractitioner, or: locationGroupResourceFilter, Wc: locationGroupsFilterVisible, os: locationResourceFilter, It: locationsFilterVisible, hk: practitionerResourceFilter},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$LocationGroupResourceFilterMsg, locationGroupResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$LocationResourceFilterMsg, locationResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$PractitionerResourceFilterMsg, practitionerResourceFilterCmd)
					])));
	});
var $author$project$Api$Provider$Practice$One$plansCount = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.ZH;
	});
var $author$project$Components$PatientsList$initFilters = F4(
	function (apiClient, session, practice, query) {
		var q = A2($elm$core$Dict$get, 'patients_q', query);
		var practitionerId = A2($elm$core$Dict$get, 'patients_practitioner', query);
		var planId = A2($elm$core$Dict$get, 'patients_plan', query);
		var locationId = A2($elm$core$Dict$get, 'patients_location', query);
		var locationGroupId = A2($elm$core$Dict$get, 'patients_location_group', query);
		var initialFilters = function (maybeFilters) {
			var _v5 = _Utils_Tuple2(
				maybeFilters,
				$author$project$Api$Provider$Practice$One$defaultToActivePatientsFilter(practice));
			if (_v5.a.$ === 1) {
				if (_v5.b) {
					var _v6 = _v5.a;
					return _List_fromArray(
						[
							$author$project$Api$Provider$Patient$Status(0)
						]);
				} else {
					var _v7 = _v5.a;
					return _List_Nil;
				}
			} else {
				var justFilters = _v5.a.a;
				return justFilters;
			}
		}(
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$filterMap($author$project$Api$Provider$Patient$filterFromString),
				A2(
					$elm$core$Maybe$map,
					$elm$core$String$split(','),
					A2($elm$core$Dict$get, 'filter', query))));
		var companyId = A2($elm$core$Dict$get, 'patients_company', query);
		var affiliateId = A2($elm$core$Dict$get, 'patients_affiliate', query);
		var _v0 = ($author$project$Api$Provider$Practice$One$plansCount(practice) > 0) ? A2(
			$elm$core$Tuple$mapFirst,
			$elm$core$Maybe$Just,
			A4($author$project$Utils$Report$PlanResourceFilter$init, apiClient, $elm$core$Basics$identity, session, planId)) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
		var planResourceFilter = _v0.a;
		var planResourceFilterCmd = _v0.b;
		var _v1 = A7($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$init, apiClient, session, practice, false, locationGroupId, locationId, practitionerId);
		var groupLocationAndPractitionerFilters = _v1.a;
		var groupLocationAndPractitionerFiltersCmd = _v1.b;
		var _v2 = ($author$project$Api$Provider$Practice$One$companiesCount(practice) > 0) ? A2(
			$elm$core$Tuple$mapFirst,
			$elm$core$Maybe$Just,
			A4(
				$author$project$Utils$Report$CompanyResourceFilter$init,
				apiClient,
				function (d) {
					return _Utils_update(
						d,
						{ai5: true});
				},
				$author$project$Api$Practice$Provider(practice),
				companyId)) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
		var companyResourceFilter = _v2.a;
		var companyResourceFilterCmd = _v2.b;
		var _v3 = function () {
			if ($author$project$Api$Provider$Practice$One$isNetwork(practice)) {
				var _v4 = A4(
					$author$project$Components$ResourceFilter$Affiliate$init,
					apiClient,
					session,
					$elm$core$Basics$identity,
					function (d) {
						return _Utils_update(
							d,
							{Gp: 'All Affiliates', Lr: true, ai5: true});
					});
				var filter = _v4.a;
				var cmd = _v4.b;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(filter),
					cmd);
			} else {
				return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
			}
		}();
		var affiliateResourceFilter = _v3.a;
		var affiliateResourceFilterCmd = _v3.b;
		return _Utils_Tuple2(
			{
				rd: affiliateId,
				mh: affiliateResourceFilter,
				fZ: companyId,
				mZ: companyResourceFilter,
				h: initialFilters,
				dn: groupLocationAndPractitionerFilters,
				gL: locationGroupId,
				We: locationId,
				kz: $author$project$Components$PatientFilter$init,
				aj4: planId,
				hi: planResourceFilter,
				Z2: practitionerId,
				akl: q,
				up: $author$project$Ui$SearchInput$init(q)
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$PatientsList$AffiliateResourceFilterMsg, affiliateResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$PatientsList$CompanyResourceFilterMsg, companyResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$PatientsList$PlanResourceFilterMsg, planResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$PatientsList$GroupLocationAndPractitionerFiltersMsg, groupLocationAndPractitionerFiltersCmd)
					])));
	});
var $author$project$Api$Provider$Practice$One$practicePulse = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Z_;
	});
var $author$project$Components$PatientsList$init = F4(
	function (session, practice, patientId, _v0) {
		var apiClient = _v0.Gv;
		var query = _v0.DE;
		var timeFormatter = _v0.J7;
		var timeZone = _v0.J8;
		var url = _v0.adY;
		var _v1 = $author$project$Api$Provider$Practice$One$practicePulse(practice) ? A2(
			$elm$core$Tuple$mapFirst,
			$elm$core$Maybe$Just,
			A2($author$project$Components$PracticePulse$init, apiClient, session)) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
		var practicePulse = _v1.a;
		var practicePulseCmd = _v1.b;
		var _v2 = A4($author$project$Components$PatientsList$initFilters, apiClient, session, practice, query);
		var filters = _v2.a;
		var filtersCmd = _v2.b;
		var model = {
			h: filters,
			ajJ: A2(
				$author$project$Api$Pagination$fromQuery,
				query,
				A2($author$project$Api$Pagination$withPrefix, 'patients_', $author$project$Api$Pagination$init)),
			YZ: patientId,
			CM: $author$project$Api$Data$Loading,
			tQ: false,
			ZV: practice,
			Z_: practicePulse,
			aa4: session,
			alA: A3(
				$author$project$Api$Sort$withDefault,
				'last_name',
				0,
				A2(
					$author$project$Api$Sort$fromQuery,
					query,
					A2($author$project$Api$Sort$withPrefix, 'patients_', $author$project$Api$Sort$init))),
			J7: timeFormatter,
			J8: timeZone,
			qA: $elm$core$Maybe$Nothing,
			adY: url
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Components$PatientsList$fetchPatients, apiClient, model),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$PatientsList$PracticePulseMsg, practicePulseCmd),
						filtersCmd,
						A2($elm$core$Task$perform, $author$project$Components$PatientsList$GotTodaysDate, $justinmimbs$date$Date$today)
					])));
	});
var $author$project$Pages$Patients$Top$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.DE;
		var accountStep = A2(
			$elm$core$Maybe$withDefault,
			8,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$PracticeOnboarding$Shared$accountStep,
				$author$project$Api$Provider$Practice$One$practiceOnboarding(practice)));
		var _v1 = function () {
			var _v2 = shared.ajU;
			if (_v2.$ === 1) {
				return A4(
					$author$project$Components$PatientsList$init,
					session,
					practice,
					$elm$core$Maybe$Nothing,
					{Gv: shared.Gv, DE: query, J7: shared.J7, J8: shared.J8, adY: shared.adY});
			} else {
				var patientsList_ = _v2.a;
				return _Utils_Tuple2(patientsList_, $elm$core$Platform$Cmd$none);
			}
		}();
		var patientsList = _v1.a;
		var patientListCmd = _v1.b;
		return _Utils_Tuple2(
			{
				KI: accountStep,
				Gv: shared.Gv,
				nD: $author$project$Components$ExportCsv$initForPractice(0),
				ajU: patientsList,
				ZV: practice,
				aa4: session
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$Top$PatientsListMsg, patientListCmd));
	});
var $author$project$Pages$Patients$Top$load = F2(
	function (shared, model) {
		var _v0 = shared.ajU;
		if (_v0.$ === 1) {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var patientsList = _v0.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{ajU: patientsList}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Patients$Top$save = F2(
	function (_v0, shared) {
		var patientsList = _v0.ajU;
		return _Utils_update(
			shared,
			{
				ajU: $elm$core$Maybe$Just(patientsList)
			});
	});
var $author$project$Pages$Patients$Top$ExportCsvMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$PatientsList$PatientFilterMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$ResourceFilter$Location$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$LocationResourceFilterMsg)),
					model.os),
					A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$ResourceFilter$LocationGroup$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$LocationGroupResourceFilterMsg)),
					model.or),
					A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$ResourceFilter$Practitioner$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$PractitionerResourceFilterMsg)),
					model.hk)
				])));
};
var $author$project$Components$PatientsList$subscriptions = function (_v0) {
	var filters = _v0.h;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$PatientsList$PatientFilterMsg,
				$author$project$Components$PatientFilter$subscriptions(filters.kz)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$ResourceFilter$Company$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Components$PatientsList$CompanyResourceFilterMsg)),
					filters.mZ)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$PatientsList$GroupLocationAndPractitionerFiltersMsg,
				$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$subscriptions(filters.dn)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$ResourceFilter$Plan$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Components$PatientsList$PlanResourceFilterMsg)),
					filters.hi)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$ResourceFilter$Affiliate$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Components$PatientsList$AffiliateResourceFilterMsg)),
					filters.mh))
			]));
};
var $author$project$Pages$Patients$Top$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$Top$PatientsListMsg,
				$author$project$Components$PatientsList$subscriptions(model.ajU)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$Top$ExportCsvMsg,
				$author$project$Components$ExportCsv$subscriptions(model.nD))
			]));
};
var $author$project$Utils$PracticeOnboarding$redirectToLastAccountStep = F2(
	function (accountStep, practice) {
		switch (accountStep) {
			case 0:
				return A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Account);
			case 1:
				return A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Plans);
			case 2:
				return A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Documents);
			case 3:
				return A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Team);
			case 4:
				return (!A2(
					$elm$core$Maybe$withDefault,
					13,
					A2(
						$elm$core$Maybe$map,
						$author$project$Api$Provider$Practice$Emr$toOption,
						$author$project$Api$Provider$Practice$One$emr(practice)))) ? A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Communications) : A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__PaymentProcessing);
			case 5:
				return A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Legal);
			case 6:
				return A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__PaymentProcessing);
			case 7:
				return A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Patients__Top);
			default:
				return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Components$ResourceFilter$Affiliate$reset = function (model) {
	return _Utils_update(
		model,
		{Jy: $author$project$Components$ResourceFilter$All});
};
var $author$project$Components$ResourceFilter$Company$reset = function (model) {
	return _Utils_update(
		model,
		{Jy: $author$project$Components$ResourceFilter$All});
};
var $author$project$Components$ResourceFilter$Location$reset = function (model) {
	return _Utils_update(
		model,
		{Jy: $author$project$Components$ResourceFilter$All});
};
var $author$project$Components$ResourceFilter$LocationGroup$reset = function (model) {
	return _Utils_update(
		model,
		{Jy: $author$project$Components$ResourceFilter$All});
};
var $author$project$Components$ResourceFilter$Practitioner$reset = function (model) {
	return _Utils_update(
		model,
		{Jy: $author$project$Components$ResourceFilter$All});
};
var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$reset = function (model) {
	return _Utils_update(
		model,
		{
			or: A2($elm$core$Maybe$map, $author$project$Components$ResourceFilter$LocationGroup$reset, model.or),
			os: A2($elm$core$Maybe$map, $author$project$Components$ResourceFilter$Location$reset, model.os),
			hk: A2($elm$core$Maybe$map, $author$project$Components$ResourceFilter$Practitioner$reset, model.hk)
		});
};
var $author$project$Components$ResourceFilter$Plan$reset = function (model) {
	return _Utils_update(
		model,
		{Jy: $author$project$Components$ResourceFilter$All});
};
var $author$project$Components$PracticePulse$FilterSelected = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$PracticePulse$None = {$: 0};
var $author$project$Components$PracticePulse$cancellationReasonReportEmbeddedId = 'rpt-OEmUlF2gSktd';
var $author$project$Components$PracticePulse$courseUrl = 'https://accelerator.hint.com/watch';
var $author$project$Components$PracticePulse$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: $author$project$Components$PracticePulse$None,
					aiO: _Utils_update(
						model,
						{t6: response}),
					aR: $author$project$OutMsg$handleErrorResponse(response)
				};
			case 1:
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: $author$project$Components$PracticePulse$FilterSelected($author$project$Api$Provider$Patient$NewActivationsSinceDate),
					aiO: model,
					aR: _List_Nil
				};
			case 2:
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: $author$project$Components$PracticePulse$FilterSelected($author$project$Api$Provider$Patient$NewTerminationsSinceDate),
					aiO: model,
					aR: _List_Nil
				};
			case 3:
				return {
					GZ: A2(
						$author$project$Utils$Route$navigate,
						$elm$core$Dict$fromList(
							_List_fromArray(
								[
									_Utils_Tuple2('status', 'issued,sent,retrying')
								])),
						$author$project$Spa$Generated$Route$Reports__Invoices),
					agZ: $author$project$Components$PracticePulse$None,
					aiO: model,
					aR: _List_Nil
				};
			case 4:
				return {
					GZ: A2(
						$author$project$Utils$Route$navigate,
						$elm$core$Dict$fromList(
							_List_fromArray(
								[
									_Utils_Tuple2('status', 'issued,failed')
								])),
						$author$project$Spa$Generated$Route$Reports__CompanyInvoices),
					agZ: $author$project$Components$PracticePulse$None,
					aiO: model,
					aR: _List_Nil
				};
			case 5:
				return {
					GZ: A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Notifications__Patient),
					agZ: $author$project$Components$PracticePulse$None,
					aiO: model,
					aR: _List_Nil
				};
			case 6:
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: $author$project$Components$PracticePulse$FilterSelected($author$project$Api$Provider$Patient$WithoutEmail),
					aiO: model,
					aR: _List_Nil
				};
			case 7:
				return {
					GZ: A2(
						$author$project$Utils$Route$navigate,
						$elm$core$Dict$empty,
						$author$project$Spa$Generated$Route$Reports__Custom__Id_String(
							{ahP: $author$project$Components$PracticePulse$cancellationReasonReportEmbeddedId})),
					agZ: $author$project$Components$PracticePulse$None,
					aiO: model,
					aR: _List_Nil
				};
			case 8:
				return {
					GZ: $author$project$Ports$Navigation$openInNewWindow($author$project$Components$PracticePulse$courseUrl),
					agZ: $author$project$Components$PracticePulse$None,
					aiO: model,
					aR: _List_Nil
				};
			default:
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: $author$project$Components$PracticePulse$FilterSelected($author$project$Api$Provider$Patient$WithUpcomingBirthday),
					aiO: model,
					aR: _List_Nil
				};
		}
	});
var $author$project$Components$PatientsList$SearchInputMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$FiltersUpdated = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$None = {$: 1};
var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$noop = function (model) {
	return {GZ: $elm$core$Platform$Cmd$none, agZ: $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$None, aiO: model, aR: _List_Nil};
};
var $author$project$Components$ResourceFilter$LocationGroup$value = function (model) {
	return A2($author$project$Components$ResourceFilter$choiceToValue, model.b8, model.Jy);
};
var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = model.or;
				if (!_v1.$) {
					var locationGroupResourceFilter = _v1.a;
					var locationGroupResourceResult = A3($author$project$Components$ResourceFilter$LocationGroup$update, apiClient, subMsg, locationGroupResourceFilter);
					var event = function () {
						var _v6 = locationGroupResourceResult.agZ;
						if (!_v6.$) {
							return A3(
								$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$FiltersUpdated,
								$author$project$Components$ResourceFilter$LocationGroup$value(locationGroupResourceResult.aiO),
								$elm$core$Maybe$Nothing,
								$elm$core$Maybe$Nothing);
						} else {
							return $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$None;
						}
					}();
					var _v2 = function () {
						if (!event.$) {
							var locationGroupId = event.a;
							return A5($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$initPractitionerFilter, apiClient, model.zU, locationGroupId, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
						} else {
							return _Utils_Tuple2(model.hk, $elm$core$Platform$Cmd$none);
						}
					}();
					var practitionerResourceFilter = _v2.a;
					var practitionerResourceFilterCmd = _v2.b;
					var _v4 = function () {
						if (!event.$) {
							var locationGroupId = event.a;
							return A4($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$initLocationFilter, apiClient, model.It, locationGroupId, $elm$core$Maybe$Nothing);
						} else {
							return _Utils_Tuple2(model.os, $elm$core$Platform$Cmd$none);
						}
					}();
					var locationResourceFilter = _v4.a;
					var locationResourceFilterCmd = _v4.b;
					return {
						GZ: $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$LocationGroupResourceFilterMsg, locationGroupResourceResult.GZ),
									A2($elm$core$Platform$Cmd$map, $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$LocationResourceFilterMsg, locationResourceFilterCmd),
									A2($elm$core$Platform$Cmd$map, $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$PractitionerResourceFilterMsg, practitionerResourceFilterCmd)
								])),
						agZ: event,
						aiO: _Utils_update(
							model,
							{
								or: $elm$core$Maybe$Just(locationGroupResourceResult.aiO),
								os: locationResourceFilter,
								hk: practitionerResourceFilter
							}),
						aR: locationGroupResourceResult.aR
					};
				} else {
					return $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$noop(model);
				}
			case 1:
				var subMsg = msg.a;
				var _v7 = model.os;
				if (!_v7.$) {
					var locationResourceFilter = _v7.a;
					var locationResourceResult = A3($author$project$Components$ResourceFilter$Location$update, apiClient, subMsg, locationResourceFilter);
					var event = function () {
						var _v10 = locationResourceResult.agZ;
						if (!_v10.$) {
							return A3(
								$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$FiltersUpdated,
								A2($elm$core$Maybe$andThen, $author$project$Components$ResourceFilter$LocationGroup$value, model.or),
								$author$project$Components$ResourceFilter$Location$value(locationResourceResult.aiO),
								$elm$core$Maybe$Nothing);
						} else {
							return $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$None;
						}
					}();
					var _v8 = function () {
						if (!event.$) {
							var locationGroupId = event.a;
							var locationId = event.b;
							return A5($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$initPractitionerFilter, apiClient, model.zU, locationGroupId, locationId, $elm$core$Maybe$Nothing);
						} else {
							return _Utils_Tuple2(model.hk, $elm$core$Platform$Cmd$none);
						}
					}();
					var practitionerResourceFilter = _v8.a;
					var practitionerResourceFilterCmd = _v8.b;
					return {
						GZ: $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$LocationResourceFilterMsg, locationResourceResult.GZ),
									A2($elm$core$Platform$Cmd$map, $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$PractitionerResourceFilterMsg, practitionerResourceFilterCmd)
								])),
						agZ: event,
						aiO: _Utils_update(
							model,
							{
								os: $elm$core$Maybe$Just(locationResourceResult.aiO),
								hk: practitionerResourceFilter
							}),
						aR: locationResourceResult.aR
					};
				} else {
					return $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$noop(model);
				}
			default:
				var subMsg = msg.a;
				var _v11 = model.hk;
				if (!_v11.$) {
					var practitionerResourceFilter = _v11.a;
					var practitionerResourceResult = A3($author$project$Components$ResourceFilter$Practitioner$update, apiClient, subMsg, practitionerResourceFilter);
					var event = function () {
						var _v12 = practitionerResourceResult.agZ;
						if (!_v12.$) {
							return A3(
								$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$FiltersUpdated,
								A2($elm$core$Maybe$andThen, $author$project$Components$ResourceFilter$LocationGroup$value, model.or),
								A2($elm$core$Maybe$andThen, $author$project$Components$ResourceFilter$Location$value, model.os),
								$author$project$Components$ResourceFilter$Practitioner$value(practitionerResourceResult.aiO));
						} else {
							return $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$None;
						}
					}();
					return {
						GZ: A2($elm$core$Platform$Cmd$map, $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$PractitionerResourceFilterMsg, practitionerResourceResult.GZ),
						agZ: event,
						aiO: _Utils_update(
							model,
							{
								hk: $elm$core$Maybe$Just(practitionerResourceResult.aiO)
							}),
						aR: practitionerResourceResult.aR
					};
				} else {
					return $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$noop(model);
				}
		}
	});
var $author$project$Components$PatientsList$updateUrl = function (model) {
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[model.adY.YX]),
			$author$project$Components$PatientsList$urlParams(model)));
};
var $author$project$Components$ResourceFilter$Affiliate$value = function (model) {
	return A2($author$project$Components$ResourceFilter$choiceToValue, model.b8, model.Jy);
};
var $author$project$Components$PatientsList$updateCurrentFilters = F3(
	function (apiClient, msg, model) {
		var filters = model.h;
		switch (msg.$) {
			case 6:
				var subMsg = msg.a;
				var result = A3($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$update, apiClient, subMsg, filters.dn);
				var _v1 = result.agZ;
				if (!_v1.$) {
					var locationGroupId = _v1.a;
					var locationId = _v1.b;
					var practitionerId = _v1.c;
					var newFilters = _Utils_update(
						filters,
						{dn: result.aiO, gL: locationGroupId, We: locationId, Z2: practitionerId});
					var newFiltersAreDifferent = (!_Utils_eq(filters.We, newFilters.We)) || ((!_Utils_eq(filters.Z2, newFilters.Z2)) || (!_Utils_eq(filters.gL, newFilters.gL)));
					var newModel = newFiltersAreDifferent ? _Utils_update(
						model,
						{
							h: newFilters,
							ajJ: $author$project$Api$Pagination$reset(model.ajJ),
							CM: $author$project$Api$Data$Loading
						}) : _Utils_update(
						model,
						{h: newFilters});
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$PatientsList$GroupLocationAndPractitionerFiltersMsg, result.GZ),
									newFiltersAreDifferent ? $elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2($author$project$Components$PatientsList$fetchPatients, apiClient, newModel),
											$author$project$Components$PatientsList$updateUrl(newModel)
										])) : $elm$core$Platform$Cmd$none
								])),
						result.aR);
				} else {
					var newFilters = _Utils_update(
						filters,
						{dn: result.aiO});
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{h: newFilters}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$PatientsList$GroupLocationAndPractitionerFiltersMsg, result.GZ),
						result.aR);
				}
			case 5:
				var subMsg = msg.a;
				var _v2 = filters.hi;
				if (!_v2.$) {
					var planResourceFilter = _v2.a;
					var planResourceResult = A3($author$project$Components$ResourceFilter$Plan$update, apiClient, subMsg, planResourceFilter);
					var planId = function () {
						var _v4 = planResourceResult.agZ;
						if (!_v4.$) {
							return $author$project$Components$ResourceFilter$Plan$value(planResourceResult.aiO);
						} else {
							return filters.aj4;
						}
					}();
					var pagination = _Utils_eq(filters.aj4, planId) ? model.ajJ : $author$project$Api$Pagination$reset(model.ajJ);
					var newFilters = _Utils_update(
						filters,
						{
							aj4: planId,
							hi: $elm$core$Maybe$Just(planResourceResult.aiO)
						});
					var newModel = _Utils_update(
						model,
						{h: newFilters, ajJ: pagination});
					var _v3 = _Utils_eq(filters.aj4, newFilters.aj4) ? _Utils_Tuple2(model.CM, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
						$author$project$Api$Data$Loading,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($author$project$Components$PatientsList$fetchPatients, apiClient, newModel),
									$author$project$Components$PatientsList$updateUrl(newModel)
								])));
					var patients = _v3.a;
					var cmd = _v3.b;
					return _Utils_Tuple3(
						_Utils_update(
							newModel,
							{ajJ: pagination, CM: patients}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$PatientsList$PlanResourceFilterMsg, planResourceResult.GZ),
									cmd
								])),
						planResourceResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				var subMsg = msg.a;
				var _v5 = filters.mZ;
				if (!_v5.$) {
					var companyResourceFilter = _v5.a;
					var companyResourceResult = A3($author$project$Components$ResourceFilter$Company$update, apiClient, subMsg, companyResourceFilter);
					var companyId = function () {
						var _v7 = companyResourceResult.agZ;
						if (!_v7.$) {
							return $author$project$Components$ResourceFilter$Company$value(companyResourceResult.aiO);
						} else {
							return filters.fZ;
						}
					}();
					var newFilters = _Utils_update(
						filters,
						{
							fZ: companyId,
							mZ: $elm$core$Maybe$Just(companyResourceResult.aiO)
						});
					var pagination = _Utils_eq(filters.fZ, companyId) ? model.ajJ : $author$project$Api$Pagination$reset(model.ajJ);
					var newModel = _Utils_update(
						model,
						{h: newFilters, ajJ: pagination});
					var _v6 = _Utils_eq(filters.fZ, newFilters.fZ) ? _Utils_Tuple2(model.CM, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
						$author$project$Api$Data$Loading,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($author$project$Components$PatientsList$fetchPatients, apiClient, newModel),
									$author$project$Components$PatientsList$updateUrl(newModel)
								])));
					var patients = _v6.a;
					var cmd = _v6.b;
					return _Utils_Tuple3(
						_Utils_update(
							newModel,
							{ajJ: pagination, CM: patients}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$PatientsList$CompanyResourceFilterMsg, companyResourceResult.GZ),
									cmd
								])),
						companyResourceResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var subMsg = msg.a;
				var _v8 = filters.mh;
				if (!_v8.$) {
					var affiliateResourceFilter = _v8.a;
					var affiliateResourceResult = A3($author$project$Components$ResourceFilter$Affiliate$update, apiClient, subMsg, affiliateResourceFilter);
					var affiliateId = function () {
						var _v10 = affiliateResourceResult.agZ;
						if (!_v10.$) {
							return $author$project$Components$ResourceFilter$Affiliate$value(affiliateResourceResult.aiO);
						} else {
							return filters.rd;
						}
					}();
					var newFilters = _Utils_update(
						filters,
						{
							rd: affiliateId,
							mh: $elm$core$Maybe$Just(affiliateResourceResult.aiO)
						});
					var pagination = _Utils_eq(filters.rd, affiliateId) ? model.ajJ : $author$project$Api$Pagination$reset(model.ajJ);
					var newModel = _Utils_update(
						model,
						{h: newFilters, ajJ: pagination});
					var _v9 = _Utils_eq(filters.rd, newFilters.rd) ? _Utils_Tuple2(model.CM, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
						$author$project$Api$Data$Loading,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($author$project$Components$PatientsList$fetchPatients, apiClient, newModel),
									$author$project$Components$PatientsList$updateUrl(newModel)
								])));
					var patients = _v9.a;
					var cmd = _v9.b;
					return _Utils_Tuple3(
						_Utils_update(
							newModel,
							{ajJ: pagination, CM: patients}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$PatientsList$AffiliateResourceFilterMsg, affiliateResourceResult.GZ),
									cmd
								])),
						affiliateResourceResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				var subMsg = msg.a;
				var _v11 = A2($author$project$Ui$SearchInput$update, subMsg, filters.up);
				var searchInput = _v11.a;
				var searchInputCmd = _v11.b;
				var searchInputEvent = _v11.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return filters.akl;
					}
				}();
				var newFilters = _Utils_update(
					filters,
					{akl: q, up: searchInput});
				var _v12 = function () {
					if (_Utils_eq(q, filters.akl)) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{h: newFilters}),
							$elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								h: newFilters,
								ajJ: $author$project$Api$Pagination$reset(model.ajJ),
								CM: $author$project$Api$Data$Loading
							});
						return _Utils_Tuple2(
							qModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($author$project$Components$PatientsList$fetchPatients, apiClient, qModel),
										$author$project$Components$PatientsList$updateUrl(qModel)
									])));
					}
				}();
				var newModel = _v12.a;
				var cmd = _v12.b;
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$PatientsList$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
			case 1:
				var subMsg = msg.a;
				var _v14 = A2($author$project$Components$PatientFilter$update, subMsg, filters.kz);
				var patientFilter = _v14.a;
				var cmd = _v14.b;
				var event = _v14.c;
				if (event.$ === 1) {
					var selectedFilters = event.a;
					var newFilters = _Utils_update(
						filters,
						{h: selectedFilters, kz: patientFilter});
					var newModel = _Utils_update(
						model,
						{
							h: newFilters,
							ajJ: $author$project$Api$Pagination$reset(model.ajJ),
							CM: $author$project$Api$Data$Loading
						});
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($author$project$Components$PatientsList$fetchPatients, apiClient, newModel),
									$author$project$Components$PatientsList$updateUrl(newModel),
									A2($elm$core$Platform$Cmd$map, $author$project$Components$PatientsList$PatientFilterMsg, cmd)
								])),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								h: _Utils_update(
									filters,
									{kz: patientFilter})
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$PatientsList$PatientFilterMsg, cmd),
						_List_Nil);
				}
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Components$PatientsList$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var responseQuery = msg.a;
				var response = msg.b;
				if (!_Utils_eq(responseQuery, model.h.akl)) {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				} else {
					if (response.$ === 3) {
						var headers = response.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ),
									CM: response
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{CM: response}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				}
			case 1:
				return A3($author$project$Components$PatientsList$updateCurrentFilters, apiClient, msg, model);
			case 2:
				return A3($author$project$Components$PatientsList$updateCurrentFilters, apiClient, msg, model);
			case 3:
				return A3($author$project$Components$PatientsList$updateCurrentFilters, apiClient, msg, model);
			case 4:
				return A3($author$project$Components$PatientsList$updateCurrentFilters, apiClient, msg, model);
			case 5:
				return A3($author$project$Components$PatientsList$updateCurrentFilters, apiClient, msg, model);
			case 6:
				return A3($author$project$Components$PatientsList$updateCurrentFilters, apiClient, msg, model);
			case 7:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						CM: $author$project$Api$Data$Loading,
						alA: A2($author$project$Api$Sort$update, columnId, model.alA)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$PatientsList$fetchPatients, apiClient, newModel),
								$author$project$Components$PatientsList$updateUrl(newModel)
							])),
					_List_Nil);
			case 8:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{ajJ: pagination, CM: $author$project$Api$Data$Loading});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$PatientsList$fetchPatients, apiClient, newModel),
								$author$project$Components$PatientsList$updateUrl(newModel)
							])),
					_List_Nil);
			case 9:
				var subMsg = msg.a;
				var _v2 = model.Z_;
				if (!_v2.$) {
					var practicePulse = _v2.a;
					var practicePulseResult = A2($author$project$Components$PracticePulse$update, subMsg, practicePulse);
					var _v3 = function () {
						var _v4 = practicePulseResult.agZ;
						if (!_v4.$) {
							return _Utils_Tuple2(model, false);
						} else {
							var filter = _v4.a;
							var newFilters = function (filters) {
								return _Utils_update(
									filters,
									{
										h: _List_fromArray(
											[filter])
									});
							}(model.h);
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										h: newFilters,
										ajJ: $author$project$Api$Pagination$reset(model.ajJ),
										CM: $author$project$Api$Data$Loading
									}),
								true);
						}
					}();
					var newModel = _v3.a;
					var reloadPatients = _v3.b;
					return _Utils_Tuple3(
						_Utils_update(
							newModel,
							{
								Z_: $elm$core$Maybe$Just(practicePulseResult.aiO)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									reloadPatients ? A2($author$project$Components$PatientsList$fetchPatients, apiClient, newModel) : $elm$core$Platform$Cmd$none,
									A2($elm$core$Platform$Cmd$map, $author$project$Components$PatientsList$PracticePulseMsg, practicePulseResult.GZ)
								])),
						practicePulseResult.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 10:
				var phiMode = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{tQ: phiMode}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 11:
				var patientId = msg.a;
				var url = $elm$url$Url$fromString(
					$author$project$Spa$Generated$Route$toString(
						$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
							{YZ: patientId})));
				var newModel = _Utils_update(
					model,
					{
						YZ: $elm$core$Maybe$Just(patientId)
					});
				if (!url.$) {
					var value = url.a;
					return _Utils_Tuple3(
						_Utils_update(
							newModel,
							{adY: value}),
						$author$project$Components$PatientsList$updateUrl(newModel),
						_List_Nil);
				} else {
					return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 12:
				var date = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							qA: $elm$core$Maybe$Just(date)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 13:
				var filters_ = model.h;
				var newFilters = _Utils_update(
					filters_,
					{
						rd: $elm$core$Maybe$Nothing,
						mh: A2($elm$core$Maybe$map, $author$project$Components$ResourceFilter$Affiliate$reset, filters_.mh),
						fZ: $elm$core$Maybe$Nothing,
						mZ: A2($elm$core$Maybe$map, $author$project$Components$ResourceFilter$Company$reset, filters_.mZ),
						h: _List_Nil,
						dn: $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$reset(filters_.dn),
						gL: $elm$core$Maybe$Nothing,
						We: $elm$core$Maybe$Nothing,
						aj4: $elm$core$Maybe$Nothing,
						hi: A2($elm$core$Maybe$map, $author$project$Components$ResourceFilter$Plan$reset, filters_.hi),
						Z2: $elm$core$Maybe$Nothing
					});
				var newModel = _Utils_update(
					model,
					{h: newFilters});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$PatientsList$fetchPatients, apiClient, newModel),
								$author$project$Components$PatientsList$updateUrl(newModel)
							])),
					_List_Nil);
			default:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{CM: $author$project$Api$Data$Loading}),
					A2($author$project$Components$PatientsList$fetchPatients, apiClient, model),
					_List_Nil);
		}
	});
var $author$project$Pages$Patients$Top$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var patientsListMsg = msg.a;
			var _v1 = A3($author$project$Components$PatientsList$update, model.Gv, patientsListMsg, model.ajU);
			var patientsListModel = _v1.a;
			var patientsListCmd = _v1.b;
			var outMsgs = _v1.c;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{ajU: patientsListModel}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$Top$PatientsListMsg, patientsListCmd),
							A2($author$project$Utils$PracticeOnboarding$redirectToLastAccountStep, model.KI, model.ZV)
						])),
				outMsgs);
		} else {
			var subMsg = msg.a;
			var _v2 = A3($author$project$Components$ExportCsv$update, model.Gv, subMsg, model.nD);
			var exportCsv = _v2.a;
			var subCmd = _v2.b;
			var subOutMsg = _v2.c;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{nD: exportCsv}),
				A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$Top$ExportCsvMsg, subCmd),
				subOutMsg);
		}
	});
var $author$project$Components$PracticePulse$ViewNewPatients = {$: 1};
var $author$project$Components$PracticePulse$ViewRetailInvoices = {$: 3};
var $author$project$Components$PracticePulse$ViewSponsorInvoices = {$: 4};
var $author$project$Components$PracticePulse$ViewTerminatedPatients = {$: 2};
var $author$project$Api$Provider$Pulse$One$activePatients = function (_v0) {
	var record = _v0;
	return record.KU;
};
var $author$project$Api$Provider$Pulse$One$activePatientsPercentage = function (_v0) {
	var record = _v0;
	return record.KV;
};
var $author$project$Ui$Panel$Info = 2;
var $author$project$Ui$Panel$info = $author$project$Ui$Panel$Styling(2);
var $author$project$Api$Provider$Pulse$One$newPatients = function (_v0) {
	var record = _v0;
	return record.XJ;
};
var $author$project$Api$Provider$Pulse$One$newPatientsPercentage = function (_v0) {
	var record = _v0;
	return record.XK;
};
var $author$project$Api$Provider$Pulse$One$newTerminations = function (_v0) {
	var record = _v0;
	return record.XN;
};
var $author$project$Api$Provider$Pulse$One$newTerminationsPercentage = function (_v0) {
	var record = _v0;
	return record.XO;
};
var $author$project$Api$Provider$Pulse$One$patientInvoicesDueInCents = function (_v0) {
	var record = _v0;
	return record.Y$;
};
var $author$project$Api$Provider$Pulse$One$patientInvoicesDueInCentsPercentage = function (_v0) {
	var record = _v0;
	return record.Y0;
};
var $author$project$Components$PracticePulse$period = 14;
var $author$project$Components$PracticePulse$periodType = 'day';
var $author$project$Ui$Element$pt0 = $author$project$Ui$Element$Padding('pt-0');
var $author$project$Api$Provider$Pulse$One$sponsorInvoicesDueInCents = function (_v0) {
	var record = _v0;
	return record.ab$;
};
var $author$project$Api$Provider$Pulse$One$sponsorInvoicesDueInCentsPercentage = function (_v0) {
	var record = _v0;
	return record.ab0;
};
var $author$project$Ui$Panel$Success = 1;
var $author$project$Ui$Panel$success = $author$project$Ui$Panel$Styling(1);
var $author$project$Api$Provider$Pulse$One$totalPractitioners = function (_v0) {
	var record = _v0;
	return record.adq;
};
var $author$project$Components$PracticePulse$EnableEmailSequence = {$: 5};
var $author$project$Components$PracticePulse$SeeCancellationReasons = {$: 7};
var $author$project$Components$PracticePulse$StartCourse = {$: 8};
var $author$project$Components$PracticePulse$ViewPatientsWithoutEmail = {$: 6};
var $author$project$Components$PracticePulse$ViewUpcomingBirthdayPatients = {$: 9};
var $author$project$Ui$Icon$Gift = 90;
var $author$project$Ui$Icon$gift = $author$project$Ui$Icon$viewIcon(90);
var $author$project$Utils$Html$middleDot = $elm$core$String$fromChar('·');
var $author$project$Ui$Icon$Task = 85;
var $author$project$Ui$Icon$task = $author$project$Ui$Icon$viewIcon(85);
var $author$project$Api$Provider$Pulse$One$upcomingBirthdayPatients = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Components$PracticePulse$viewActionPlanRow = F6(
	function (colorOptions, icon, title, description, buttonTitle, msg) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex items-center p-4 border-b border-primary-100 last:border-b-0')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mr-5')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							colorOptions,
							_List_fromArray(
								[icon]))
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$fill]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$p,
							A2($elm$core$List$cons, $author$project$Ui$Typography$small, colorOptions),
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								])),
							A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(description)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ml-auto')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: buttonTitle},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick(msg)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(buttonTitle)
								]))
						]))
				]));
	});
var $author$project$Ui$Icon$Wrench = 78;
var $author$project$Ui$Icon$wrench = $author$project$Ui$Icon$viewIcon(78);
var $author$project$Components$PracticePulse$viewActionPlan = function (pulse) {
	return _List_fromArray(
		[
			A6(
			$author$project$Components$PracticePulse$viewActionPlanRow,
			_List_fromArray(
				[$author$project$Ui$Typography$success]),
			$author$project$Ui$Icon$wrench(_List_Nil),
			'Action ' + ($author$project$Utils$Html$middleDot + ' New Patients'),
			'Reach out to schedule first appointments with ' + (A2(
				$author$project$Formatters$String$pluralize,
				'patient',
				$author$project$Api$Provider$Pulse$One$newPatients(pulse)) + (' that joined in the last ' + A2($author$project$Formatters$String$pluralize, $author$project$Components$PracticePulse$periodType, $author$project$Components$PracticePulse$period))),
			'See patients',
			$author$project$Components$PracticePulse$ViewNewPatients),
			A6(
			$author$project$Components$PracticePulse$viewActionPlanRow,
			_List_fromArray(
				[$author$project$Ui$Typography$info]),
			$author$project$Ui$Icon$wrench(_List_Nil),
			'Action ' + ($author$project$Utils$Html$middleDot + ' Panel Size'),
			'Enable email sequence for people that didn\'t finish enrollment',
			'Enable email sequence',
			$author$project$Components$PracticePulse$EnableEmailSequence),
			A6(
			$author$project$Components$PracticePulse$viewActionPlanRow,
			_List_fromArray(
				[$author$project$Ui$Typography$danger]),
			$author$project$Ui$Icon$wrench(_List_Nil),
			'Action ' + ($author$project$Utils$Html$middleDot + ' Panel Churn'),
			'Add emails to 56 patients missing out on communications',
			'See patients',
			$author$project$Components$PracticePulse$ViewPatientsWithoutEmail),
			A6(
			$author$project$Components$PracticePulse$viewActionPlanRow,
			_List_fromArray(
				[$author$project$Ui$Typography$danger]),
			$author$project$Ui$Icon$wrench(_List_Nil),
			'Action ' + ($author$project$Utils$Html$middleDot + ' Panel Churn'),
			'View cancellation reasons for ' + (A2(
				$author$project$Formatters$String$pluralize,
				'patient',
				$author$project$Api$Provider$Pulse$One$newTerminations(pulse)) + (' patients that terminated in last ' + A2($author$project$Formatters$String$pluralize, $author$project$Components$PracticePulse$periodType, $author$project$Components$PracticePulse$period))),
			'See cancellation reasons',
			$author$project$Components$PracticePulse$SeeCancellationReasons),
			A6(
			$author$project$Components$PracticePulse$viewActionPlanRow,
			_List_fromArray(
				[$author$project$Ui$Typography$muted]),
			$author$project$Ui$Icon$task(_List_Nil),
			'Learning',
			'If you want to improve your metrics, check out our DPC Accelerator courses on growth, retention and revenue management',
			'Start the course',
			$author$project$Components$PracticePulse$StartCourse),
			A6(
			$author$project$Components$PracticePulse$viewActionPlanRow,
			_List_fromArray(
				[$author$project$Ui$Typography$muted]),
			$author$project$Ui$Icon$gift(_List_Nil),
			'Engagement',
			'Wish a happy birthday to ' + (A2(
				$author$project$Formatters$String$pluralize,
				'patient',
				$author$project$Api$Provider$Pulse$One$upcomingBirthdayPatients(pulse)) + (' who have birthdays in the next ' + A2($author$project$Formatters$String$pluralize, $author$project$Components$PracticePulse$periodType, $author$project$Components$PracticePulse$period))),
			'See patients',
			$author$project$Components$PracticePulse$ViewUpcomingBirthdayPatients)
		]);
};
var $author$project$Ui$Panel$Tile = {$: 7};
var $author$project$Ui$Panel$tile = $author$project$Ui$Panel$Tile;
var $author$project$Ui$Icon$Decrease = 83;
var $author$project$Ui$Icon$decrease = $author$project$Ui$Icon$viewIcon(83);
var $author$project$Components$PracticePulse$PercentageDisplay$positiveInteger = function (value) {
	return value > 0;
};
var $author$project$Components$PracticePulse$PercentageDisplay$goodForPractice = F2(
	function (value, increaseIsGood) {
		return _Utils_eq(
			increaseIsGood,
			$author$project$Components$PracticePulse$PercentageDisplay$positiveInteger(value));
	});
var $author$project$Ui$Icon$Increase = 84;
var $author$project$Ui$Icon$increase = $author$project$Ui$Icon$viewIcon(84);
var $author$project$Components$PracticePulse$PercentageDisplay$view = function (_v0) {
	var value = _v0.aee;
	var increaseIsGood = _v0.ahX;
	var period = _v0.aj0;
	var type_ = _v0.amg;
	if (!value.$) {
		var value_ = value.a;
		var icon = $author$project$Components$PracticePulse$PercentageDisplay$positiveInteger(value_) ? $author$project$Ui$Icon$increase(_List_Nil) : $author$project$Ui$Icon$decrease(_List_Nil);
		var colorOption = A2($author$project$Components$PracticePulse$PercentageDisplay$goodForPractice, value_, increaseIsGood) ? $author$project$Ui$Typography$success : $author$project$Ui$Typography$danger;
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mt2]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[colorOption]),
							_List_fromArray(
								[
									icon,
									$author$project$Utils$Html$noBreakSpace,
									$elm$html$Html$text(
									$author$project$Formatters$Float$toPercentage(value_))
								]))
						])),
					A2(
					$author$project$Ui$Typography$text,
					_List_fromArray(
						[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
					'Compared to previous '),
					A2(
					$author$project$Ui$Typography$text,
					_List_fromArray(
						[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
					A2($author$project$Formatters$String$pluralize, type_, period))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$PracticePulse$viewBox = F8(
	function (panelOptions, title, button, getMainNumber, getDescription, getPercentage, increaseIsGood, model) {
		var _v0 = model.t6;
		if (_v0.$ === 3) {
			var pulse = _v0.a;
			return A2(
				$author$project$Ui$Panel$view,
				A2($elm$core$List$cons, $author$project$Ui$Panel$tile, panelOptions),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_fromArray(
							[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
						A2(
							$elm$core$List$cons,
							$author$project$Ui$Typography$headingSm(
								_List_fromArray(
									[
										$elm$html$Html$text(title)
									])),
							button)),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Typography$heading(
								_List_fromArray(
									[
										$elm$html$Html$text(
										getMainNumber(pulse))
									])),
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$inlineBlock, $author$project$Ui$Element$textMuted, $author$project$Ui$Element$mt2]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										getDescription(pulse))
									])),
								$author$project$Components$PracticePulse$PercentageDisplay$view(
								{
									ahX: increaseIsGood,
									aj0: $author$project$Components$PracticePulse$period,
									amg: $author$project$Components$PracticePulse$periodType,
									aee: getPercentage(pulse)
								})
							]))
					]));
		} else {
			return A2(
				$author$project$Ui$Panel$view,
				A2($elm$core$List$cons, $author$project$Ui$Panel$tile, panelOptions),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$card(_List_Nil)
							]))
					]));
		}
	});
var $author$project$Components$PracticePulse$view = function (model) {
	return A2(
		$author$project$Ui$Panel$view,
		_List_fromArray(
			[
				$author$project$Ui$Panel$collapsed(false)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Practice Pulse')
									])),
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm, $author$project$Ui$Element$inlineBlock]),
								_List_fromArray(
									[
										$elm$html$Html$text('Last '),
										$elm$html$Html$text(
										A2($author$project$Formatters$String$pluralize, $author$project$Components$PracticePulse$periodType, $author$project$Components$PracticePulse$period))
									]))
							]))
					])),
				A2(
				$author$project$Ui$Panel$body,
				_List_fromArray(
					[$author$project$Ui$Element$pt0]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$flex, $author$project$Ui$Element$wrap, $author$project$Ui$Element$gap4, $author$project$Ui$Element$mb3]),
						_List_fromArray(
							[
								A8(
								$author$project$Components$PracticePulse$viewBox,
								_List_fromArray(
									[$author$project$Ui$Panel$info]),
								'Total Active Patients',
								_List_Nil,
								A2($elm$core$Basics$composeR, $author$project$Api$Provider$Pulse$One$activePatients, $elm$core$String$fromInt),
								function (pulse) {
									return 'Total across ' + A2(
										$author$project$Formatters$String$pluralize,
										'provider',
										$author$project$Api$Provider$Pulse$One$totalPractitioners(pulse));
								},
								$author$project$Api$Provider$Pulse$One$activePatientsPercentage,
								true,
								model),
								A8(
								$author$project$Components$PracticePulse$viewBox,
								_List_fromArray(
									[$author$project$Ui$Panel$success]),
								'New Patients',
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{mm: 'View new patients'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$onClick($author$project$Components$PracticePulse$ViewNewPatients)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('View')
											]))
									]),
								function (pulse) {
									return '+' + $elm$core$String$fromInt(
										$author$project$Api$Provider$Pulse$One$newPatients(pulse));
								},
								function (_v0) {
									return 'Enrolled in the last ' + A2($author$project$Formatters$String$pluralize, $author$project$Components$PracticePulse$periodType, $author$project$Components$PracticePulse$period);
								},
								$author$project$Api$Provider$Pulse$One$newPatientsPercentage,
								true,
								model),
								A8(
								$author$project$Components$PracticePulse$viewBox,
								_List_fromArray(
									[$author$project$Ui$Panel$danger]),
								'Terminations',
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{mm: 'View terminations'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$onClick($author$project$Components$PracticePulse$ViewTerminatedPatients)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('View')
											]))
									]),
								function (pulse) {
									return '-' + $elm$core$String$fromInt(
										$author$project$Api$Provider$Pulse$One$newTerminations(pulse));
								},
								function (_v1) {
									return 'Terminated in the last ' + A2($author$project$Formatters$String$pluralize, $author$project$Components$PracticePulse$periodType, $author$project$Components$PracticePulse$period);
								},
								$author$project$Api$Provider$Pulse$One$newTerminationsPercentage,
								false,
								model),
								A8(
								$author$project$Components$PracticePulse$viewBox,
								_List_fromArray(
									[$author$project$Ui$Panel$warning]),
								'Past Due - Retail',
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{mm: 'View retail past due'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$onClick($author$project$Components$PracticePulse$ViewRetailInvoices)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('View')
											]))
									]),
								function (pulse) {
									return $author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$Pulse$One$patientInvoicesDueInCents(pulse));
								},
								$elm$core$Basics$always('Patients\' due invoices'),
								$author$project$Api$Provider$Pulse$One$patientInvoicesDueInCentsPercentage,
								false,
								model),
								A8(
								$author$project$Components$PracticePulse$viewBox,
								_List_fromArray(
									[$author$project$Ui$Panel$warning]),
								'Past Due - Sponsor',
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{mm: 'View sponsor past due'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$onClick($author$project$Components$PracticePulse$ViewSponsorInvoices)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('View')
											]))
									]),
								function (pulse) {
									return $author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$Pulse$One$sponsorInvoicesDueInCents(pulse));
								},
								$elm$core$Basics$always('Sponsors\' due invoices'),
								$author$project$Api$Provider$Pulse$One$sponsorInvoicesDueInCentsPercentage,
								false,
								model)
							])),
						A2(
						$author$project$Ui$Panel$view,
						_List_fromArray(
							[
								$author$project$Ui$Panel$info,
								$author$project$Ui$Panel$collapsed(true)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Action Plan')
											]))
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								function () {
									var _v2 = model.t6;
									if (_v2.$ === 3) {
										var pulse = _v2.a;
										return $author$project$Components$PracticePulse$viewActionPlan(pulse);
									} else {
										return _List_Nil;
									}
								}())
							]))
					]))
			]));
};
var $author$project$Components$PatientsList$PaginationMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$PatientsList$viewPagination = F2(
	function (paginationOptions, _v0) {
		var patients = _v0.CM;
		var pagination = _v0.ajJ;
		return A2(
			$elm$html$Html$map,
			$author$project$Components$PatientsList$PaginationMsg,
			A2(
				$author$project$Api$Pagination$view,
				A2(
					$elm$core$List$cons,
					$author$project$Ui$Pagination$List$loading(
						!$author$project$Utils$Maybe$toBool(
							$author$project$Api$Data$toMaybe(patients))),
					paginationOptions),
				pagination));
	});
var $author$project$Components$PatientsList$SortTable = function (a) {
	return {$: 7, a: a};
};
var $author$project$Ui$Table$Md = 2;
var $author$project$Ui$Table$displayMd = $author$project$Ui$Table$Display(2);
var $author$project$Ui$Table$hidden = $author$project$Ui$Table$Hidden(0);
var $author$project$Components$PatientsList$columns = F2(
	function (mini, practice) {
		var hiddenOnMiniOrSm = function (col) {
			return mini ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				A2(
					$author$project$Api$Column$withOption,
					$author$project$Ui$Table$displayMd,
					A2($author$project$Api$Column$withOption, $author$project$Ui$Table$hidden, col)));
		};
		return A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					hiddenOnMiniOrSm(
					A3($author$project$Api$Column$init, 'last_name', true, 'Patient')),
					hiddenOnMiniOrSm(
					A3($author$project$Api$Column$init, 'status', false, 'Status')),
					hiddenOnMiniOrSm(
					A3($author$project$Api$Column$init, 'dob', true, 'Date of Birth')),
					hiddenOnMiniOrSm(
					A3($author$project$Api$Column$init, 'joined_practice_date', true, 'Joined Practice')),
					hiddenOnMiniOrSm(
					A3($author$project$Api$Column$init, 'email', true, 'Email')),
					hiddenOnMiniOrSm(
					A3($author$project$Api$Column$init, 'practitioner', true, 'Provider')),
					$author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice) ? hiddenOnMiniOrSm(
					A3($author$project$Api$Column$init, 'location', true, 'Location')) : $elm$core$Maybe$Nothing,
					hiddenOnMiniOrSm(
					A3(
						$author$project$Api$Column$init,
						'',
						false,
						A2($author$project$Formatters$String$sponsorize, practice, 'Employer'))),
					hiddenOnMiniOrSm(
					A3($author$project$Api$Column$init, '', false, 'Plan'))
				]));
	});
var $author$project$Ui$Table$active = function (value) {
	return $author$project$Ui$Table$CellActive(value);
};
var $author$project$Api$Provider$Patient$All$affiliateSyncStatus = function (_v0) {
	var record = _v0.b;
	return record.Lh;
};
var $author$project$Ui$Typography$Age = {$: 18};
var $author$project$Ui$Typography$age = $author$project$Ui$Typography$Age;
var $author$project$Ui$Icon$ArrowRightBottom = 66;
var $author$project$Ui$Icon$arrowRightBottom = $author$project$Ui$Icon$viewIcon(66);
var $author$project$Api$Provider$Patient$All$dob = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$dob(shared);
};
var $author$project$Api$Provider$Patient$All$flaggedNotesCount = function (_v0) {
	var record = _v0.b;
	return record.Sz;
};
var $author$project$Formatters$Patient$formatAge = F3(
	function (currentDate, maybeDob, maybeAge) {
		if (!maybeDob.$) {
			var dob = maybeDob.a;
			var ageInMonths = A3($justinmimbs$date$Date$diff, 1, dob, currentDate);
			return (ageInMonths < 24) ? ($elm$core$String$fromInt(ageInMonths) + 'm') : $elm$core$String$fromInt((ageInMonths / 12) | 0);
		} else {
			if (!maybeAge.$) {
				var ageValue = maybeAge.a;
				return (!ageValue) ? '0m' : $elm$core$String$fromInt(ageValue);
			} else {
				return '';
			}
		}
	});
var $author$project$Api$Provider$Patient$All$isAffiliated = function (_v0) {
	var record = _v0.b;
	return record.UA;
};
var $author$project$Api$Provider$Patient$All$isMaster = function (_v0) {
	var record = _v0.b;
	return record.UV;
};
var $author$project$Api$Provider$Patient$All$isSynced = function (_v0) {
	var record = _v0.b;
	return record.Vf;
};
var $author$project$Api$Provider$Patient$All$joinedPracticeDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$joinedPracticeDate(shared);
};
var $author$project$Api$Provider$Patient$All$membershipThrough = function (_v0) {
	var record = _v0.b;
	return record.WY;
};
var $author$project$Components$PatientsList$membershipStatus = function (patient) {
	return _Utils_ap(
		$author$project$Formatters$String$humanize(
			$author$project$Api$Provider$Patient$All$membershipStatus(patient)),
		function () {
			var _v0 = $author$project$Api$Provider$Patient$All$membershipThrough(patient);
			if (!_v0.$) {
				var membershipThrough = _v0.a;
				return ' through ' + $author$project$Api$Provider$Patient$Min$name(membershipThrough);
			} else {
				return '';
			}
		}());
};
var $author$project$Api$Provider$Patient$All$networkSyncStatus = function (_v0) {
	var record = _v0.b;
	return record.XG;
};
var $author$project$Api$Provider$MembershipPatient$ForPatientAll$plan = function (_v0) {
	var record = _v0;
	return record.Jb;
};
var $author$project$Components$PatientsList$SelectPatient = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$PatientsList$selectPatient = function (patientId) {
	return $author$project$Components$PatientsList$SelectPatient(patientId);
};
var $author$project$Api$Provider$Patient$All$sponsorName = function (_v0) {
	var record = _v0.b;
	return record.ab1;
};
var $author$project$Api$Provider$MembershipPatient$ForPatientAll$startDate = function (_v0) {
	var record = _v0;
	return record.ab7;
};
var $author$project$Components$PatientsList$viewMembershipPatient = F2(
	function (todaysDate, membershipPatient) {
		var isCurrentMembership = function () {
			if (!todaysDate.$) {
				var today = todaysDate.a;
				return A2(
					$author$project$Utils$Date$isBeforeOrEqual,
					$author$project$Api$Provider$MembershipPatient$ForPatientAll$startDate(membershipPatient),
					today);
			} else {
				return true;
			}
		}();
		var typOptions = isCurrentMembership ? _List_Nil : _List_fromArray(
			[$author$project$Ui$Typography$small, $author$project$Ui$Typography$italic]);
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$text,
					typOptions,
					$author$project$Api$Provider$Plan$Min$name(
						$author$project$Api$Provider$MembershipPatient$ForPatientAll$plan(membershipPatient))),
					isCurrentMembership ? $author$project$Utils$Html$empty : A2(
					$author$project$Ui$Typography$text,
					typOptions,
					'on ' + A2(
						$author$project$Formatters$Date$toString,
						$author$project$Formatters$Date$Full,
						$author$project$Api$Provider$MembershipPatient$ForPatientAll$startDate(membershipPatient)))
				]));
	});
var $author$project$Components$PatientsList$viewPatient = F3(
	function (mini, model, patient) {
		var responsiveCell = function (cellChildren) {
			return mini ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$hidden, $author$project$Ui$Table$displayMd]),
					cellChildren));
		};
		var practitionerName = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$Practitioner$Min$name,
				$author$project$Api$Provider$Patient$All$practitioner(patient)));
		var id = $author$project$Api$Provider$Patient$All$id(patient);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						$elm$core$Maybe$Just(
						A2(
							$author$project$Ui$Table$cell,
							_List_fromArray(
								[
									$author$project$Ui$Table$active(
									_Utils_eq(
										model.YZ,
										$elm$core$Maybe$Just(id)))
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$gap]),
									_List_fromArray(
										[
											function () {
											var isClinical = A2($author$project$Api$Provider$Practice$One$featureEnabled, 6, model.ZV) && A2($author$project$Api$Provider$Practice$One$featureEnabled, 19, model.ZV);
											var _v0 = isClinical ? _Utils_Tuple2(
												$author$project$Spa$Generated$Route$Patients__PatientId_String__Chart(
													{YZ: id}),
												_List_fromArray(
													[
														$author$project$Ui$Link$onClick(
														$author$project$Components$PatientsList$selectPatient(id))
													])) : _Utils_Tuple2(
												$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
													{YZ: id}),
												_List_fromArray(
													[
														$author$project$Ui$Link$routeParams(
														$author$project$Components$PatientsList$urlParams(model)),
														$author$project$Ui$Link$onClick(
														$author$project$Components$PatientsList$selectPatient(id))
													]));
											var patientRoute = _v0.a;
											var linkOptions = _v0.b;
											return A3(
												$author$project$Ui$Link$route,
												patientRoute,
												linkOptions,
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Element$prose,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Typography$text,
																_List_fromArray(
																	[
																		$author$project$Ui$Typography$phi(true)
																	]),
																$author$project$Api$Provider$Patient$All$name(patient)),
																function () {
																var _v1 = model.qA;
																if (!_v1.$) {
																	var currentDate = _v1.a;
																	var ageDisplay = A3(
																		$author$project$Formatters$Patient$formatAge,
																		currentDate,
																		$author$project$Api$Provider$Patient$All$dob(patient),
																		$author$project$Api$Provider$Patient$All$age(patient));
																	return $elm$core$String$isEmpty(ageDisplay) ? $author$project$Utils$Html$empty : A2(
																		$author$project$Ui$Typography$text,
																		_List_fromArray(
																			[$author$project$Ui$Typography$age]),
																		', ' + ageDisplay);
																} else {
																	var _v2 = $author$project$Api$Provider$Patient$All$age(patient);
																	if (!_v2.$) {
																		var age = _v2.a;
																		return A2(
																			$author$project$Ui$Typography$text,
																			_List_fromArray(
																				[$author$project$Ui$Typography$age]),
																			', ' + $elm$core$String$fromInt(age));
																	} else {
																		return $author$project$Utils$Html$empty;
																	}
																}
															}()
															]))
													]));
										}(),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2('md:hidden', !mini)
														]))
												]),
											_List_fromArray(
												[
													function () {
													var _v3 = $author$project$Api$Provider$Patient$All$membershipThrough(patient);
													if (!_v3.$) {
														return A3(
															$author$project$Ui$Tooltip$view,
															_List_fromArray(
																[
																	$author$project$Ui$Tooltip$placement(0)
																]),
															$author$project$Components$PatientsList$membershipStatus(patient),
															_List_fromArray(
																[
																	A3(
																	$author$project$Ui$Badge$fromStringWithIcon,
																	_List_Nil,
																	$author$project$Api$Provider$Patient$All$membershipStatus(patient),
																	$author$project$Ui$Icon$arrowRightBottom(_List_Nil))
																]));
													} else {
														return A2(
															$author$project$Ui$Badge$fromString,
															_List_Nil,
															$author$project$Api$Provider$Patient$All$membershipStatus(patient));
													}
												}()
												]))
										])),
									function () {
									var _v4 = $author$project$Api$Provider$Patient$All$membershipPatients(patient);
									if (_v4.b) {
										var membershipPatient = _v4.a;
										return A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2('md:hidden', !mini)
														]))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Api$Provider$Plan$Min$name(
														$author$project$Api$Provider$MembershipPatient$ForPatientAll$plan(membershipPatient)))
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}(),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-muted'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('md:hidden', !mini)
												]))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(practitionerName)
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$gap2]),
									$elm$core$List$concat(
										_List_fromArray(
											[
												($author$project$Api$Provider$Patient$All$flaggedNotesCount(patient) > 0) ? _List_fromArray(
												[
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Patients__PatientId_String__Notes__Top(
														{
															YZ: $author$project$Api$Provider$Patient$All$id(patient)
														}),
													_List_fromArray(
														[
															$author$project$Ui$Link$routeParams(
															_List_fromArray(
																[
																	A2($elm$url$Url$Builder$string, 'flagged', '1')
																])),
															$author$project$Ui$Link$icon($author$project$Ui$Icon$flag)
														]),
													_List_Nil)
												]) : _List_Nil,
												($author$project$Api$Provider$Patient$All$isMaster(patient) && $author$project$Api$Provider$Patient$All$isAffiliated(patient)) ? _List_fromArray(
												[
													$author$project$Components$SyncedIcon$view(
													_List_fromArray(
														[
															$author$project$Components$SyncedIcon$master,
															$author$project$Components$SyncedIcon$status(
															$author$project$Api$Provider$Patient$All$networkSyncStatus(patient))
														]))
												]) : _List_Nil,
												($author$project$Api$Provider$Patient$All$isSynced(patient) && $author$project$Api$Provider$Patient$All$isAffiliated(patient)) ? _List_fromArray(
												[
													$author$project$Components$SyncedIcon$view(
													_List_fromArray(
														[
															$author$project$Components$SyncedIcon$synced,
															$author$project$Components$SyncedIcon$status(
															$author$project$Api$Provider$Patient$All$affiliateSyncStatus(patient))
														]))
												]) : _List_Nil
											])))
								]))),
						responsiveCell(
						_List_fromArray(
							[
								function () {
								var _v5 = $author$project$Api$Provider$Patient$All$membershipThrough(patient);
								if (!_v5.$) {
									return A3(
										$author$project$Ui$Tooltip$view,
										_List_fromArray(
											[
												$author$project$Ui$Tooltip$placement(0)
											]),
										$author$project$Components$PatientsList$membershipStatus(patient),
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Badge$fromStringWithIcon,
												_List_Nil,
												$author$project$Api$Provider$Patient$All$membershipStatus(patient),
												$author$project$Ui$Icon$arrowRightBottom(_List_Nil))
											]));
								} else {
									return A2(
										$author$project$Ui$Badge$fromString,
										_List_Nil,
										$author$project$Api$Provider$Patient$All$membershipStatus(patient));
								}
							}()
							])),
						responsiveCell(
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$text,
								_List_fromArray(
									[
										$author$project$Ui$Typography$phi(true)
									]),
								A2(
									$elm$core$Maybe$withDefault,
									'',
									A2(
										$elm$core$Maybe$map,
										$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
										$author$project$Api$Provider$Patient$All$dob(patient)))),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('md:hidden', !mini)
											]))
									]),
								A2(
									$elm$core$List$map,
									$author$project$Components$PatientsList$viewMembershipPatient(model.qA),
									$author$project$Api$Provider$Patient$All$membershipPatients(patient)))
							])),
						responsiveCell(
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									A2(
										$elm$core$Maybe$map,
										$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
										$author$project$Api$Provider$Patient$All$joinedPracticeDate(patient)))),
								$author$project$Utils$Html$noBreakSpace,
								($author$project$Api$Provider$Patient$All$membershipStatus(patient) === 'unconfirmed') ? $elm$html$Html$text('(unconfirmed)') : $author$project$Utils$Html$empty
							])),
						responsiveCell(
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$text,
								_List_fromArray(
									[
										$author$project$Ui$Typography$phi(true)
									]),
								A2(
									$elm$core$Maybe$withDefault,
									'',
									$author$project$Api$Provider$Patient$All$email(patient)))
							])),
						responsiveCell(
						_List_fromArray(
							[
								$elm$html$Html$text(practitionerName)
							])),
						$author$project$Api$Provider$Practice$One$trackPatientsByLocation(model.ZV) ? responsiveCell(
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									A2(
										$elm$core$Maybe$map,
										$author$project$Api$Provider$Location$Min$name,
										$author$project$Api$Provider$Patient$All$location(patient))))
							])) : $elm$core$Maybe$Nothing,
						responsiveCell(
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$text,
								_List_fromArray(
									[
										$author$project$Ui$Typography$phi(true)
									]),
								A2(
									$elm$core$Maybe$withDefault,
									'',
									$author$project$Api$Provider$Patient$All$sponsorName(patient)))
							])),
						responsiveCell(
						A2(
							$elm$core$List$map,
							$author$project$Components$PatientsList$viewMembershipPatient(model.qA),
							$author$project$Api$Provider$Patient$All$membershipPatients(patient)))
					])));
	});
var $author$project$Components$PatientsList$viewPatientsTable = F2(
	function (mini, model) {
		var _v0 = function () {
			var _v1 = model.CM;
			if (_v1.$ === 3) {
				var patients_ = _v1.a;
				return _Utils_Tuple2(false, patients_);
			} else {
				return _Utils_Tuple2(true, _List_Nil);
			}
		}();
		var loading = _v0.a;
		var patients = _v0.b;
		return A4(
			$author$project$Ui$Panel$table,
			_List_fromArray(
				[
					$author$project$Ui$Table$verticalCentered,
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('No patients found.')
						])),
					$author$project$Ui$Table$loading(loading)
				]),
			A2(
				$elm$core$List$map,
				$author$project$Api$Column$view(
					A2($author$project$Api$Column$Sortable, model.alA, $author$project$Components$PatientsList$SortTable)),
				A2($author$project$Components$PatientsList$columns, mini, model.ZV)),
			A2(
				$elm$core$List$map,
				A2($author$project$Components$PatientsList$viewPatient, mini, model),
				patients),
			_List_Nil);
	});
var $author$project$Api$Feature$AddressSearch = 29;
var $author$project$Components$PatientsList$ResetFilters = {$: 13};
var $author$project$Ui$Grid$Conditional = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Grid$conditional = $author$project$Ui$Grid$Conditional;
var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$Multi = 0;
var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$multi = 0;
var $author$project$Ui$FilterChips$Reset = $elm$core$Basics$identity;
var $author$project$Ui$FilterChips$reset = $elm$core$Basics$identity;
var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$view = F2(
	function (options, model) {
		var optionsRecord = A3(
			$elm$core$List$foldl,
			F2(
				function (opt, acc) {
					return _Utils_update(
						acc,
						{Bn: true});
				}),
			{Bn: false},
			options);
		var multiOption = optionsRecord.Bn ? _List_fromArray(
			[$author$project$Components$ResourceFilter$multi]) : _List_Nil;
		return A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$map,
					function (locationGroupResourceFilter) {
						return A2(
							$elm$html$Html$map,
							$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$LocationGroupResourceFilterMsg,
							A2(
								$author$project$Components$ResourceFilter$LocationGroup$view,
								A2(
									$elm$core$List$cons,
									$author$project$Components$ResourceFilter$style(1),
									multiOption),
								locationGroupResourceFilter));
					},
					model.or),
					A2(
					$elm$core$Maybe$map,
					function (locationResourceFilter) {
						return A2(
							$elm$html$Html$map,
							$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$LocationResourceFilterMsg,
							A2(
								$author$project$Components$ResourceFilter$Location$view,
								A2(
									$elm$core$List$cons,
									$author$project$Components$ResourceFilter$style(1),
									multiOption),
								locationResourceFilter));
					},
					model.os),
					A2(
					$elm$core$Maybe$map,
					function (practitionerResourceFilter) {
						return A2(
							$elm$html$Html$map,
							$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$PractitionerResourceFilterMsg,
							A2(
								$author$project$Components$ResourceFilter$Practitioner$view,
								A2(
									$elm$core$List$cons,
									$author$project$Components$ResourceFilter$style(1),
									multiOption),
								practitionerResourceFilter));
					},
					model.hk)
				]));
	});
var $author$project$Ui$FilterChips$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, acc) {
				var msg = option;
				return _Utils_update(
					acc,
					{
						Jx: $elm$core$Maybe$Just(msg)
					});
			}),
		{Jx: $elm$core$Maybe$Nothing},
		options);
};
var $author$project$Ui$FilterChips$view = F2(
	function (options, activeFilters) {
		if ($elm$core$List$isEmpty(activeFilters)) {
			return $elm$html$Html$text('');
		} else {
			var optionsRecord = $author$project$Ui$FilterChips$optionsToRecord(options);
			return A3(
				$author$project$Ui$Element$custom,
				'filter-chips',
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('filter-chips__title')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Active filters')
									])),
								A2(
								$elm$core$Maybe$withDefault,
								$elm$html$Html$text(''),
								A2(
									$elm$core$Maybe$map,
									function (msg) {
										return A3(
											$author$project$Ui$Button$view,
											{mm: 'Reset filters'},
											_List_fromArray(
												[
													$author$project$Ui$Button$icon($author$project$Ui$Icon$cross),
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick(msg)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Reset filters')
												]));
									},
									optionsRecord.Jx))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('filter-chips__wrapper')
							]),
						activeFilters)
					]));
		}
	});
var $author$project$Components$PatientFilter$viewMultiSelected = function (selected) {
	return A2(
		$elm$core$List$map,
		function (filter) {
			return A3(
				$author$project$Ui$Button$view,
				{mm: 'Remove selection'},
				_List_fromArray(
					[
						$author$project$Ui$Button$onClick(
						$author$project$Components$PatientFilter$FilterSelected_(
							A2($author$project$Components$PatientFilter$checkedItem, filter, selected))),
						$author$project$Ui$Button$sm,
						$author$project$Ui$Button$mb2
					]),
				A2(
					$elm$core$List$map,
					$elm$html$Html$map($elm$core$Basics$never),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Components$PatientFilter$filterToLabel(filter)),
							$author$project$Ui$Icon$cross(
							_List_fromArray(
								[$author$project$Ui$Icon$xs, $author$project$Ui$Icon$spacedLeft]))
						])));
		},
		selected);
};
var $author$project$Components$ResourceFilter$Company$viewMultiSelected = function (model) {
	return A2(
		$elm$core$List$map,
		$elm$html$Html$map($elm$core$Basics$identity),
		A2($author$project$Components$ResourceFilter$viewMultiSelected, model.Jy, model.b8));
};
var $author$project$Components$ResourceFilter$Location$viewMultiSelected = function (model) {
	return A2(
		$elm$core$List$map,
		$elm$html$Html$map($elm$core$Basics$identity),
		A2($author$project$Components$ResourceFilter$viewMultiSelected, model.Jy, model.b8));
};
var $author$project$Components$ResourceFilter$LocationGroup$viewMultiSelected = function (model) {
	return A2(
		$elm$core$List$map,
		$elm$html$Html$map($elm$core$Basics$identity),
		A2($author$project$Components$ResourceFilter$viewMultiSelected, model.Jy, model.b8));
};
var $author$project$Components$ResourceFilter$Practitioner$viewMultiSelected = function (model) {
	return A2(
		$elm$core$List$map,
		$elm$html$Html$map($elm$core$Basics$identity),
		A2($author$project$Components$ResourceFilter$viewMultiSelected, model.Jy, model.b8));
};
var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewMultiSelected = function (model) {
	return $elm$core$List$concat(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (locationGroupResourceFilter) {
						return A2(
							$elm$core$List$map,
							$elm$html$Html$map($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$LocationGroupResourceFilterMsg),
							$author$project$Components$ResourceFilter$LocationGroup$viewMultiSelected(locationGroupResourceFilter));
					},
					model.or)),
				A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (locationResourceFilter) {
						return A2(
							$elm$core$List$map,
							$elm$html$Html$map($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$LocationResourceFilterMsg),
							$author$project$Components$ResourceFilter$Location$viewMultiSelected(locationResourceFilter));
					},
					model.os)),
				A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (practitionerResourceFilter) {
						return A2(
							$elm$core$List$map,
							$elm$html$Html$map($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$PractitionerResourceFilterMsg),
							$author$project$Components$ResourceFilter$Practitioner$viewMultiSelected(practitionerResourceFilter));
					},
					model.hk))
			]));
};
var $author$project$Components$ResourceFilter$Plan$viewMultiSelected = function (model) {
	return A2(
		$elm$core$List$map,
		$elm$html$Html$map($elm$core$Basics$identity),
		A2($author$project$Components$ResourceFilter$viewMultiSelected, model.Jy, model.b8));
};
var $author$project$Components$PatientsList$viewSearchAndFilters = F2(
	function (miniView, model) {
		var filters = model.h;
		var unlessMini = function (option) {
			return $author$project$Ui$Grid$conditional(
				_Utils_Tuple2(!miniView, option));
		};
		var searchPlaceholder = A2($author$project$Api$Provider$Practice$One$featureEnabled, 29, model.ZV) ? 'Search by name, email, ID, DOB, phone, or address' : 'Search by name, email, ID, DOB, phone';
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$row,
				_List_fromArray(
					[$author$project$Ui$Grid$mb2]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$PatientsList$SearchInputMsg,
								A2(
									$author$project$Ui$SearchInput$view,
									_List_fromArray(
										[
											$author$project$Ui$SearchInput$phi(true),
											$author$project$Ui$SearchInput$placeholder(searchPlaceholder)
										]),
									filters.up))
							]))
					])),
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				A2(
					$elm$core$List$cons,
					A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								unlessMini(
								$author$project$Ui$Grid$spanMd(2)),
								$author$project$Ui$Grid$span(6)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$PatientsList$PatientFilterMsg,
								A3($author$project$Components$PatientFilter$view, model.ZV, filters.h, filters.kz))
							])),
					A2(
						$elm$core$List$cons,
						function () {
							var _v0 = filters.mZ;
							if (!_v0.$) {
								var companyResourceFilter = _v0.a;
								return A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											unlessMini(
											$author$project$Ui$Grid$spanMd(2)),
											$author$project$Ui$Grid$span(6)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$map,
											$author$project$Components$PatientsList$CompanyResourceFilterMsg,
											A2(
												$author$project$Components$ResourceFilter$Company$view,
												_List_fromArray(
													[
														$author$project$Components$ResourceFilter$style(1),
														$author$project$Components$ResourceFilter$multi
													]),
												companyResourceFilter))
										]));
							} else {
								return $author$project$Ui$Grid$none;
							}
						}(),
						A2(
							$elm$core$List$cons,
							function () {
								var _v1 = filters.hi;
								if (!_v1.$) {
									var planResourceFilter = _v1.a;
									return A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												unlessMini(
												$author$project$Ui$Grid$spanMd(2)),
												$author$project$Ui$Grid$span(6)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Components$PatientsList$PlanResourceFilterMsg,
												A2(
													$author$project$Components$ResourceFilter$Plan$view,
													_List_fromArray(
														[
															$author$project$Components$ResourceFilter$style(1),
															$author$project$Components$ResourceFilter$multi
														]),
													planResourceFilter))
											]));
								} else {
									return $author$project$Ui$Grid$none;
								}
							}(),
							_Utils_ap(
								A2(
									$elm$core$List$map,
									A2(
										$elm$core$Basics$composeR,
										$elm$core$List$singleton,
										$author$project$Ui$Grid$column(
											_List_fromArray(
												[
													$author$project$Ui$Grid$span(6),
													unlessMini(
													$author$project$Ui$Grid$spanMd(2))
												]))),
									A2(
										$elm$core$List$map,
										$elm$html$Html$map($author$project$Components$PatientsList$GroupLocationAndPractitionerFiltersMsg),
										A2(
											$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$view,
											_List_fromArray(
												[$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$multi]),
											filters.dn))),
								_List_fromArray(
									[
										function () {
										var _v2 = filters.mh;
										if (!_v2.$) {
											var affiliateResourceFilter = _v2.a;
											return A2(
												$author$project$Ui$Grid$column,
												_List_fromArray(
													[
														unlessMini(
														$author$project$Ui$Grid$spanMd(2)),
														$author$project$Ui$Grid$span(6)
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$map,
														$author$project$Components$PatientsList$AffiliateResourceFilterMsg,
														A2(
															$author$project$Components$ResourceFilter$Affiliate$view,
															_List_fromArray(
																[
																	$author$project$Components$ResourceFilter$style(1)
																]),
															affiliateResourceFilter))
													]));
										} else {
											return $author$project$Ui$Grid$none;
										}
									}()
									])))))),
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_Nil,
						function () {
							var activeFilters = _Utils_ap(
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										A2(
											$elm$core$Basics$composeR,
											$author$project$Components$ResourceFilter$Plan$viewMultiSelected,
											$elm$core$List$map(
												$elm$html$Html$map($author$project$Components$PatientsList$PlanResourceFilterMsg))),
										model.h.hi)),
								_Utils_ap(
									A2(
										$elm$core$Maybe$withDefault,
										_List_Nil,
										A2(
											$elm$core$Maybe$map,
											A2(
												$elm$core$Basics$composeR,
												$author$project$Components$ResourceFilter$Company$viewMultiSelected,
												$elm$core$List$map(
													$elm$html$Html$map($author$project$Components$PatientsList$CompanyResourceFilterMsg))),
											model.h.mZ)),
									_Utils_ap(
										A2(
											$elm$core$List$map,
											$elm$html$Html$map($author$project$Components$PatientsList$GroupLocationAndPractitionerFiltersMsg),
											$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewMultiSelected(filters.dn)),
										A2(
											$elm$core$List$map,
											$elm$html$Html$map($author$project$Components$PatientsList$PatientFilterMsg),
											$author$project$Components$PatientFilter$viewMultiSelected(model.h.h)))));
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$FilterChips$view,
									_List_fromArray(
										[
											$author$project$Ui$FilterChips$reset($author$project$Components$PatientsList$ResetFilters)
										]),
									activeFilters)
								]);
						}())
					]))
			]);
	});
var $author$project$Components$PatientsList$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('patients-list')
			]),
		_List_fromArray(
			[
				function () {
				var _v0 = model.Z_;
				if (!_v0.$) {
					var practicePulse = _v0.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$PatientsList$PracticePulseMsg,
						$author$project$Components$PracticePulse$view(practicePulse));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						A2($author$project$Components$PatientsList$viewSearchAndFilters, false, model)),
						A2($author$project$Components$PatientsList$viewPatientsTable, false, model),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Components$PatientsList$viewPagination, _List_Nil, model)
							]))
					]))
			]));
};
var $author$project$Pages$Patients$Top$viewActions = _List_fromArray(
	[
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$gap4]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$hidden, $author$project$Ui$Element$flexMd, $author$project$Ui$Element$gap4]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Patients__Upload,
						_List_fromArray(
							[
								$author$project$Ui$Link$icon($author$project$Ui$Icon$upload)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Upload from CSV')
							])),
						A2($elm$html$Html$map, $author$project$Pages$Patients$Top$ExportCsvMsg, $author$project$Components$ExportCsv$link)
					])),
				A3(
				$author$project$Ui$Link$route,
				$author$project$Spa$Generated$Route$Charges__New,
				_List_fromArray(
					[
						$author$project$Ui$Link$buttonSecondary,
						$author$project$Ui$Link$icon($author$project$Ui$Icon$dollarSign),
						$author$project$Ui$Link$test('add-charge')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Add Charge')
					])),
				A3(
				$author$project$Ui$Link$route,
				$author$project$Spa$Generated$Route$Patients__Create,
				_List_fromArray(
					[
						$author$project$Ui$Link$buttonPrimary,
						$author$project$Ui$Link$icon($author$project$Ui$Icon$add)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Add Patient ')
					]))
			]))
	]);
var $author$project$Pages$Patients$Top$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Patients$Top$ExportCsvMsg,
				A3(
					$author$project$Components$ExportCsv$modal,
					model.Gv,
					_List_fromArray(
						[
							$author$project$Components$ExportCsv$path($author$project$Api$Provider$Patient$patientsPath),
							$author$project$Components$ExportCsv$params(
							A2($elm$core$Basics$composeL, $author$project$Api$Provider$Patient$listOptionsToParams, $author$project$Components$PatientsList$fetchParams)(model.ajU))
						]),
					model.nD)),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mb4, $author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
				_List_fromArray(
					[
						$author$project$Ui$Typography$heading(
						_List_fromArray(
							[
								$elm$html$Html$text('Patients')
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$itemsCenter]),
						$author$project$Pages$Patients$Top$viewActions)
					])),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Patients$Top$PatientsListMsg,
				$author$project$Components$PatientsList$view(model.ajU))
			]),
		ac9: 'Patients'
	};
};
var $author$project$Pages$Patients$Top$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Patients$Top$init, aiq: $author$project$Pages$Patients$Top$load, k8: $author$project$Pages$Patients$Top$save, alO: $author$project$Pages$Patients$Top$subscriptions, adT: $author$project$Pages$Patients$Top$update, amo: $author$project$Pages$Patients$Top$view});
var $author$project$Api$Upload$McePlanResource$McePlan = 0;
var $author$project$Api$Upload$Resource$Patient = 3;
var $author$project$Pages$Patients$Upload$Patient = 0;
var $author$project$Pages$Patients$Upload$UploadFormMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Practice$One$canDeleteAllPatients = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.M6;
	});
var $author$project$Api$Upload$ClinicalResource$AtlasClinical = 0;
var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$GotClinicalUploadResults = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$ClinicalUploadResult$clinicalUploadsPath = F2(
	function (clinicalResource, basePath) {
		var resourcePath = function () {
			if (!clinicalResource) {
				return 'atlas';
			} else {
				return 'ccda';
			}
		}();
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				['emr', 'file_imports', resourcePath]),
			basePath);
	});
var $author$project$Api$Provider$ClinicalUploadResult$All$ClinicalUploadResult = $elm$core$Basics$identity;
var $author$project$Api$Provider$ClinicalUploadResult$Shared$ClinicalUploadResult = $elm$core$Basics$identity;
var $author$project$Api$Provider$ClinicalUploadResult$Shared$Record = F5(
	function (fileName, status, result, createdAt, id) {
		return {O1: createdAt, Sn: fileName, ahP: id, $U: result, alH: status};
	});
var $author$project$Api$Provider$ClinicalUploadResult$Data$Data = $elm$core$Basics$identity;
var $author$project$Api$Provider$ClinicalUploadResult$Data$Record = F2(
	function (code, message) {
		return {NN: code, aiH: message};
	});
var $author$project$Api$Provider$ClinicalUploadResult$Data$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'message',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'code',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		$elm$core$Maybe$Nothing,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$ClinicalUploadResult$Data$Record)));
var $author$project$Api$Provider$ClinicalUploadResult$Data$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ClinicalUploadResult$Data$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$ClinicalUploadResult$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'id',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'created_at',
		$elm_community$json_extra$Json$Decode$Extra$datetime,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'result',
			$elm$json$Json$Decode$nullable($author$project$Api$Provider$ClinicalUploadResult$Data$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'status',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'file_name',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$ClinicalUploadResult$Shared$Record))))));
var $author$project$Api$Provider$ClinicalUploadResult$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ClinicalUploadResult$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$ClinicalUploadResult$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ClinicalUploadResult$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$ClinicalUploadResult$listDefaults = {ajJ: $author$project$Api$Pagination$init};
var $author$project$Api$ClinicalUploadResult$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$ClinicalUploadResult$listDefaults);
	return $author$project$Api$Pagination$toApiParams(options.ajJ);
};
var $author$project$Api$ClinicalUploadResult$list = F4(
	function (clinicalResource, apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$ClinicalUploadResult$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$ClinicalUploadResult$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$ClinicalUploadResult$clinicalUploadsPath, clinicalResource, $author$project$Api$Data$providerPath))));
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$fetchClinicalUploadResults = F2(
	function (pagination, apiClient) {
		return A4(
			$author$project$Api$ClinicalUploadResult$list,
			0,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{ajJ: pagination});
			},
			$author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$GotClinicalUploadResults);
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$init = F2(
	function (timeFormatter, apiClient) {
		var newPagination = $author$project$Api$Pagination$init;
		return _Utils_Tuple2(
			{Gv: apiClient, n9: false, ajJ: newPagination, lp: false, J7: timeFormatter, vi: $elm$core$Maybe$Nothing, qV: $author$project$Api$Data$Loading},
			A2($author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$fetchClinicalUploadResults, newPagination, apiClient));
	});
var $author$project$Api$Upload$ClinicalResource$CcdaClinical = 1;
var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$GotClinicalUploadResults = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$fetchClinicalUploadResults = F2(
	function (pagination, apiClient) {
		return A4(
			$author$project$Api$ClinicalUploadResult$list,
			1,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{ajJ: pagination});
			},
			$author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$GotClinicalUploadResults);
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$NewUpload = {$: 0};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$Idle = {$: 0};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$init = {ln: false, vi: $elm$core$Maybe$Nothing, F$: $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$NewUpload, l_: $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$Idle};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$init = {bH: $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$init, hc: _List_Nil, lW: $elm$core$Maybe$Nothing, F$: $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$NewUpload};
var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$init = F2(
	function (timeFormatter, apiClient) {
		var newPagination = $author$project$Api$Pagination$init;
		return _Utils_Tuple2(
			{ajJ: newPagination, pp: $elm$core$Maybe$Nothing, J7: timeFormatter, F$: $elm$core$Maybe$Nothing, h7: $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$init, qV: $author$project$Api$Data$Loading},
			A2($author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$fetchClinicalUploadResults, newPagination, apiClient));
	});
var $author$project$Api$Upload$McePlanResource$McePlanCreate = 0;
var $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$init = F3(
	function (timeFormatter, apiClient, mcePlanResource) {
		return _Utils_Tuple2(
			{KM: 0, Gv: apiClient, WI: mcePlanResource, lp: false, J7: timeFormatter, vi: $elm$core$Maybe$Nothing},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Patients$Upload$init = F4(
	function (_v0, practice, shared, _v1) {
		var isHintAdmin = $author$project$Shared$isHintAdmin(shared);
		var _v2 = A4($author$project$Components$Upload$Form$init, shared.J7, shared.Gv, 3, $elm$core$Maybe$Nothing);
		var uploadForm = _v2.a;
		var uploadFormCmd = _v2.b;
		var _v3 = A3($author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$init, shared.J7, shared.Gv, 0);
		var mcePlanUploadForm = _v3.a;
		var _v4 = A2($author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$init, shared.J7, shared.Gv);
		var ccdaClinicalUploadForm = _v4.a;
		var _v5 = A2($author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$init, shared.J7, shared.Gv);
		var atlasClinicalUploadForm = _v5.a;
		return _Utils_Tuple2(
			{
				xh: $author$project$Api$Provider$Practice$One$canDeleteAllPatients(practice),
				Gv: shared.Gv,
				fJ: atlasClinicalUploadForm,
				fV: ccdaClinicalUploadForm,
				d0: $elm$core$Maybe$Nothing,
				i9: false,
				Ij: isHintAdmin,
				WI: $elm$core$Maybe$Nothing,
				gU: mcePlanUploadForm,
				ZV: practice,
				Jy: $elm$core$Maybe$Just(0),
				J7: shared.J7,
				h4: uploadForm
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$Upload$UploadFormMsg, uploadFormCmd));
	});
var $author$project$Pages$Patients$Upload$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Patients$Upload$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Patients$Upload$AtlasClinicalUploadFormMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Patients$Upload$CcdaClinicalUploadFormMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Patients$Upload$HiConfirmClosed = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Patients$Upload$McePlanUploadFormMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$UploadModal = {$: 2};
var $author$project$Components$Admin$Uploads$UploadModal$subscribeToEscapeKeyPress = function (onClose) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress(onClose);
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$subscriptions = function (model) {
	return model.lp ? $author$project$Components$Admin$Uploads$UploadModal$subscribeToEscapeKeyPress($author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$UploadModal) : $elm$core$Platform$Sub$none;
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$UploaderMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$ModalMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$ReceivedFilePath = function (a) {
	return {$: 6, a: a};
};
var $author$project$Ports$FilePaths$receiveFilePath = _Platform_incomingPort(
	'receiveFilePath',
	A2(
		$elm$json$Json$Decode$andThen,
		function (_v0) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (_v1) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (_v2) {
							return $elm$json$Json$Decode$succeed(
								_Utils_Tuple3(_v0, _v1, _v2));
						},
						A2($elm$json$Json$Decode$index, 2, $elm$json$Json$Decode$int));
				},
				A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string)));
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$CloseModal = {$: 0};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$subscriptions = function (model) {
	return model.ln ? $author$project$Components$Admin$Uploads$UploadModal$subscribeToEscapeKeyPress($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$CloseModal) : $elm$core$Platform$Sub$none;
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$ModalMsg,
				$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$subscriptions(model.bH)),
				$author$project$Ports$FilePaths$receiveFilePath($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$ReceivedFilePath)
			]));
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$UploaderMsg,
		$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$subscriptions(model.h7));
};
var $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$UploadModal = {$: 2};
var $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$subscriptions = function (model) {
	return model.lp ? $author$project$Components$Admin$Uploads$UploadModal$subscribeToEscapeKeyPress($author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$UploadModal) : $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Patients$Upload$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$Upload$UploadFormMsg,
				$author$project$Components$Upload$Form$subscriptions(model.h4)),
				model.i9 ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Patients$Upload$HiConfirmClosed) : $elm$core$Platform$Sub$none,
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$Upload$AtlasClinicalUploadFormMsg,
				$author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$subscriptions(model.fJ)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$Upload$CcdaClinicalUploadFormMsg,
				$author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$subscriptions(model.fV)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$Upload$McePlanUploadFormMsg,
				$author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$subscriptions(model.gU))
			]));
};
var $author$project$Api$Upload$Resource$Charge = 4;
var $author$project$Pages$Patients$Upload$GotPatientDestroyAll = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Upload$Resource$PatientNote = 7;
var $author$project$Api$Provider$Patient$destroyAll = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Patient$patientsPath));
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$GotResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$ClinicalUploadResult$createAtlas = F3(
	function (apiClient, files, toMsg) {
		var filesPart = A2(
			$elm$core$List$map,
			function (file) {
				return A2($elm$http$Http$filePart, 'files[]', file);
			},
			files);
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestMultipartBody,
				filesPart,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['emr', 'file_imports', 'atlas']),
						$author$project$Api$Data$providerPath))));
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var files = msg.a;
				return $elm$core$List$isEmpty(files) ? _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{n9: true}),
					A3($author$project$Api$ClinicalUploadResult$createAtlas, apiClient, files, $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$GotResponse),
					_List_Nil);
			case 1:
				var response = msg.a;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{n9: false, lp: true, vi: $elm$core$Maybe$Nothing}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									n9: false,
									lp: true,
									vi: $elm$core$Maybe$Just(
										$author$project$Api$Data$errorToString(error))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{lp: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ),
								qV: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{qV: response}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			default:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{ajJ: pagination, qV: $author$project$Api$Data$Loading});
				return _Utils_Tuple3(
					newModel,
					A2($author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$fetchClinicalUploadResults, pagination, newModel.Gv),
					_List_Nil);
		}
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$AddToExisting = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$NewUpload = {$: 0};
var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$ProcessUploadResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$AddToExisting = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$initForExistingUpload = function (uploadId) {
	return {
		ln: false,
		vi: $elm$core$Maybe$Nothing,
		F$: $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$AddToExisting(uploadId),
		l_: $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$Idle
	};
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$initForExistingUpload = function (uploadId) {
	return {
		bH: $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$initForExistingUpload(uploadId),
		hc: _List_Nil,
		lW: $elm$core$Maybe$Nothing,
		F$: $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$AddToExisting(uploadId)
	};
};
var $author$project$Api$ClinicalUploadResult$processUpload = F4(
	function (clinicalResource, apiClient, uploadId, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$elm$json$Json$Encode$object(_List_Nil),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							[uploadId, 'process_upload']),
						A2($author$project$Api$ClinicalUploadResult$clinicalUploadsPath, clinicalResource, $author$project$Api$Data$providerPath)))));
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$withModal = F2(
	function (f, model) {
		return f(model);
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$showModal = function (model) {
	return _Utils_update(
		model,
		{
			bH: A2(
				$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$withModal,
				function (m) {
					return _Utils_update(
						m,
						{ln: true});
				},
				model.bH)
		});
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$CreatingUpload = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$UploadCreated = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$UploadFile = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$Uploading = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadRunner$continueOrFinish = F2(
	function (toMsg, proc) {
		var _v0 = proc.uc;
		if (_v0.b) {
			var next = _v0.a;
			return A2(
				$elm$core$Task$perform,
				function (_v1) {
					return A2(toMsg, proc.Kj, next);
				},
				$elm$core$Task$succeed(0));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Api$Provider$ClinicalUploadResult$One$ClinicalUploadResult = $elm$core$Basics$identity;
var $author$project$Api$Provider$ClinicalUploadResult$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ClinicalUploadResult$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$ClinicalUploadResult$createCcda = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$ClinicalUploadResult$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$elm$json$Json$Encode$object(_List_Nil),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['emr', 'file_imports', 'ccda']),
						$author$project$Api$Data$providerPath))));
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadRunner$initWithCandidates = F2(
	function (uploadId, candidates) {
		return {
			zA: _List_Nil,
			uc: candidates,
			al9: $elm$core$List$length(candidates),
			Kj: uploadId,
			adV: 0
		};
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$setUploadState = F2(
	function (state, model) {
		return _Utils_update(
			model,
			{ln: true, vi: $elm$core$Maybe$Nothing, l_: state});
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$onCreateUpload = F3(
	function (apiClient, candidates, model) {
		if ($elm$core$List$isEmpty(candidates)) {
			return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		} else {
			var _v0 = model.F$;
			if (_v0.$ === 1) {
				var uploadId = _v0.a;
				var uploadProcess = A2($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadRunner$initWithCandidates, uploadId, candidates);
				var nextCmd = A2($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadRunner$continueOrFinish, $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$UploadFile, uploadProcess);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bH: A2(
								$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$setUploadState,
								$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$Uploading(uploadProcess),
								model.bH)
						}),
					nextCmd,
					_List_Nil);
			} else {
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bH: A2(
								$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$setUploadState,
								A2(
									$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$CreatingUpload,
									0,
									$elm$core$List$length(candidates)),
								model.bH)
						}),
					A2(
						$author$project$Api$ClinicalUploadResult$createCcda,
						apiClient,
						$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$UploadCreated(candidates)),
					_List_Nil);
			}
		}
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$CreateUpload = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$onFilePath = F2(
	function (_v0, model) {
		var filename = _v0.a;
		var relativePath = _v0.b;
		var size = _v0.c;
		var _v1 = model.lW;
		if (!_v1.$) {
			var candidates = _v1.a;
			var updateFirstMatch = function (candidateList) {
				if (!candidateList.b) {
					return _List_Nil;
				} else {
					var first = candidateList.a;
					var rest = candidateList.b;
					return (_Utils_eq(
						$elm$file$File$name(first.ahj),
						filename) && (_Utils_eq(
						$elm$file$File$size(first.ahj),
						size) && _Utils_eq(first.YX, $elm$core$Maybe$Nothing))) ? A2(
						$elm$core$List$cons,
						_Utils_update(
							first,
							{
								YX: $elm$core$Maybe$Just(relativePath)
							}),
						rest) : A2(
						$elm$core$List$cons,
						first,
						updateFirstMatch(rest));
				}
			};
			var updatedCandidates = updateFirstMatch(candidates);
			var totalCount = $elm$core$List$length(updatedCandidates);
			var processedCount = $elm$core$List$length(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.YX;
						},
						$elm$core$Basics$neq($elm$core$Maybe$Nothing)),
					updatedCandidates));
			var updatedModal = A2(
				$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$setUploadState,
				A2($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$CreatingUpload, processedCount, totalCount),
				model.bH);
			var allPathsResolved = A2(
				$elm$core$List$all,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.YX;
					},
					$elm$core$Basics$neq($elm$core$Maybe$Nothing)),
				updatedCandidates);
			var shouldTriggerCreate = allPathsResolved && (!A2(
				$elm$core$List$all,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.YX;
					},
					$elm$core$Basics$neq($elm$core$Maybe$Nothing)),
				candidates));
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						bH: updatedModal,
						lW: $elm$core$Maybe$Just(updatedCandidates)
					}),
				shouldTriggerCreate ? A2(
					$elm$core$Task$perform,
					$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$CreateUpload,
					$elm$core$Task$succeed(updatedCandidates)) : $elm$core$Platform$Cmd$none,
				_List_Nil);
		} else {
			return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$UploadingComplete = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$nextCmdAndState = function (process) {
	return $elm$core$List$isEmpty(process.uc) ? _Utils_Tuple2(
		$elm$core$Platform$Cmd$none,
		$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$UploadingComplete(
			{
				zz: A2(
					$elm$core$List$map,
					function (file) {
						return _Utils_Tuple3(file.Bq, file.YX, file.RK);
					},
					process.zA),
				ado: process.al9
			})) : _Utils_Tuple2(
		A2($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadRunner$continueOrFinish, $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$UploadFile, process),
		$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$Uploading(process));
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadRunner$step = F2(
	function (proc, result) {
		var newRemaining = function () {
			var _v1 = proc.uc;
			if (!_v1.b) {
				return _List_Nil;
			} else {
				var rest = _v1.b;
				return rest;
			}
		}();
		var newFailures = function () {
			if (result.$ === 1) {
				var failedFile = result.a;
				return _Utils_ap(
					proc.zA,
					_List_fromArray(
						[failedFile]));
			} else {
				return proc.zA;
			}
		}();
		return _Utils_update(
			proc,
			{zA: newFailures, uc: newRemaining, adV: proc.adV + 1});
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$onFileUploadResponse = F4(
	function (_v0, candidate, response, model) {
		var _v1 = _Utils_Tuple2(model.bH.l_, response);
		_v1$2:
		while (true) {
			if (_v1.a.$ === 2) {
				switch (_v1.b.$) {
					case 3:
						var process = _v1.a.a;
						var _v2 = _v1.b;
						var updatedProcess = A2(
							$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadRunner$step,
							process,
							$elm$core$Result$Ok(0));
						var _v3 = $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$nextCmdAndState(updatedProcess);
						var nextCmd = _v3.a;
						var newState = _v3.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bH: A2($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$setUploadState, newState, model.bH)
								}),
							nextCmd,
							_List_Nil);
					case 2:
						var process = _v1.a.a;
						var error = _v1.b.a;
						if (error.$ === 10) {
							var updatedProcess = A2(
								$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadRunner$step,
								process,
								$elm$core$Result$Ok(0));
							var _v5 = $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$nextCmdAndState(updatedProcess);
							var nextCmd = _v5.a;
							var newState = _v5.b;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										bH: A2($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$setUploadState, newState, model.bH)
									}),
								nextCmd,
								_List_Nil);
						} else {
							var failedFile = {
								RK: $author$project$Api$Data$errorToString(error),
								Bq: $elm$file$File$name(candidate.ahj),
								YX: A2($elm$core$Maybe$withDefault, '', candidate.YX)
							};
							var updatedProcess = A2(
								$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadRunner$step,
								process,
								$elm$core$Result$Err(failedFile));
							var _v6 = $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$nextCmdAndState(updatedProcess);
							var nextCmd = _v6.a;
							var newState = _v6.b;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										bH: A2($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$setUploadState, newState, model.bH)
									}),
								nextCmd,
								_List_Nil);
						}
					default:
						break _v1$2;
				}
			} else {
				break _v1$2;
			}
		}
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$ProcessNextBatch = {$: 7};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$isXmlFile = function (file) {
	return A2(
		$elm$core$String$endsWith,
		'.xml',
		$elm$file$File$name(file)) && (!A2(
		$elm$core$String$startsWith,
		'.',
		$elm$file$File$name(file)));
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$onFilesSelected = F2(
	function (rawFiles, model) {
		var _v0 = model.bH.l_;
		if (_v0.$ === 3) {
			return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		} else {
			var candidates = A2(
				$elm$core$List$map,
				function (f) {
					return {ahj: f, YX: $elm$core$Maybe$Nothing};
				},
				A2($elm$core$List$filter, $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$isXmlFile, rawFiles));
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						bH: A2(
							$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$setUploadState,
							A2(
								$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$CreatingUpload,
								0,
								$elm$core$List$length(candidates)),
							model.bH),
						hc: candidates,
						lW: $elm$core$Maybe$Just(candidates)
					}),
				A2(
					$elm$core$Task$perform,
					$elm$core$Basics$identity,
					$elm$core$Task$succeed($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$ProcessNextBatch)),
				_List_Nil);
		}
	});
var $author$project$Api$Provider$ClinicalUploadResult$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$ClinicalUploadResult$One$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ClinicalUploadResult$Shared$id(shared);
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$onUploadCreated = F4(
	function (_v0, candidates, response, model) {
		switch (response.$) {
			case 3:
				var uploadData = response.a;
				var uploadProcess = A2(
					$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadRunner$initWithCandidates,
					$author$project$Api$Provider$ClinicalUploadResult$One$id(uploadData),
					candidates);
				var nextCmd = A2($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadRunner$continueOrFinish, $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$UploadFile, uploadProcess);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bH: A2(
								$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$setUploadState,
								$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$Uploading(uploadProcess),
								model.bH)
						}),
					nextCmd,
					_List_Nil);
			case 2:
				var error = response.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bH: A2(
								$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$withModal,
								function (m) {
									return _Utils_update(
										m,
										{
											ln: true,
											vi: $elm$core$Maybe$Just(
												$author$project$Api$Data$errorToString(error)),
											l_: $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$Idle
										});
								},
								model.bH)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$FileUploadResponse = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Api$ClinicalUploadResult$uploadCcdaFile = F5(
	function (apiClient, uploadId, file, maybeRelativePath, toMsg) {
		var filePart = A2($elm$http$Http$filePart, 'file', file);
		var parts = function () {
			if (!maybeRelativePath.$) {
				var relativePath = maybeRelativePath.a;
				return _List_fromArray(
					[
						filePart,
						A2($elm$http$Http$stringPart, 'relative_path', relativePath)
					]);
			} else {
				return _List_fromArray(
					[filePart]);
			}
		}();
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestMultipartBody,
				parts,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['emr', 'file_imports', 'ccda', uploadId, 'upload_file']),
						$author$project$Api$Data$providerPath))));
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$onUploadFile = F4(
	function (apiClient, uploadId, candidate, model) {
		return _Utils_Tuple3(
			model,
			A5(
				$author$project$Api$ClinicalUploadResult$uploadCcdaFile,
				apiClient,
				uploadId,
				candidate.ahj,
				candidate.YX,
				$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$FileUploadResponse(candidate)),
			_List_Nil);
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$fileProcessingBatchSize = 20;
var $author$project$Ports$FilePaths$getFilePath = _Platform_outgoingPort(
	'getFilePath',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string($.Bq)),
					_Utils_Tuple2(
					'size',
					$elm$json$Json$Encode$int($.aly))
				]));
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$processNextBatch = function (model) {
	var _v0 = function (batch) {
		return _Utils_Tuple2(
			batch,
			A2($elm$core$List$drop, $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$fileProcessingBatchSize, model.hc));
	}(
		A2($elm$core$List$take, $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$fileProcessingBatchSize, model.hc));
	var currentBatch = _v0.a;
	var remainingCandidates = _v0.b;
	var batchCommands = A2(
		$elm$core$List$map,
		function (candidate) {
			return $author$project$Ports$FilePaths$getFilePath(
				{
					Bq: $elm$file$File$name(candidate.ahj),
					aly: $elm$file$File$size(candidate.ahj)
				});
		},
		currentBatch);
	var hasMoreBatches = !$elm$core$List$isEmpty(remainingCandidates);
	var nextBatchCmd = hasMoreBatches ? A2(
		$elm$core$Task$perform,
		$elm$core$Basics$identity,
		$elm$core$Task$succeed($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$ProcessNextBatch)) : $elm$core$Platform$Cmd$none;
	return _Utils_Tuple3(
		_Utils_update(
			model,
			{hc: remainingCandidates}),
		$elm$core$Platform$Cmd$batch(
			_Utils_ap(
				batchCommands,
				_List_fromArray(
					[nextBatchCmd]))),
		_List_Nil);
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$FileUploaded = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$update = F3(
	function (config, msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ln: false, vi: $elm$core$Maybe$Nothing, l_: $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$Idle}),
					$elm$core$Platform$Cmd$none,
					config.tr(_List_Nil));
			case 1:
				var _v1 = model.l_;
				if (_v1.$ === 2) {
					var process = _v1.a;
					return _Utils_Tuple3(
						A2(
							$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$withModal,
							$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$setUploadState(
								$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$UploadingComplete(
									{
										zz: A2(
											$elm$core$List$cons,
											_Utils_Tuple3(
												'Upload canceled',
												'',
												'The upload was canceled by the user. ' + ($elm$core$String$fromInt(process.adV) + (' of ' + ($elm$core$String$fromInt(process.al9) + (' files were uploaded successfully' + (($elm$core$List$length(process.zA) > 0) ? (', ' + ($elm$core$String$fromInt(
													$elm$core$List$length(process.zA)) + ' failed.')) : '.')))))),
											A2(
												$elm$core$List$map,
												function (f) {
													return _Utils_Tuple3(f.Bq, f.YX, f.RK);
												},
												process.zA)),
										ado: process.al9
									})),
							model),
						$elm$core$Platform$Cmd$none,
						config.tr(_List_Nil));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						config.tr(_List_Nil));
				}
			default:
				var files = msg.a;
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					config.tr(files));
		}
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$updateModal = F3(
	function (_v0, modalMsg, model) {
		var config = {tr: $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$FileUploaded};
		var _v1 = A3($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$update, config, modalMsg, model.bH);
		var newModal = _v1.a;
		var cmd = _v1.b;
		var parentMsg = _v1.c;
		switch (modalMsg.$) {
			case 0:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bH: newModal, hc: _List_Nil, lW: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bH: newModal}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bH: newModal}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$ModalMsg, cmd),
								A2(
								$elm$core$Task$perform,
								$elm$core$Basics$identity,
								$elm$core$Task$succeed(parentMsg))
							])),
					_List_Nil);
		}
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$update = F3(
	function (api, msg, model) {
		switch (msg.$) {
			case 5:
				var mm = msg.a;
				return A3($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$updateModal, api, mm, model);
			case 0:
				var files = msg.a;
				return A2($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$onFilesSelected, files, model);
			case 1:
				var candidates = msg.a;
				return A3($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$onCreateUpload, api, candidates, model);
			case 2:
				var candidates = msg.a;
				var resp = msg.b;
				return A4($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$onUploadCreated, api, candidates, resp, model);
			case 3:
				var id = msg.a;
				var candidate = msg.b;
				return A4($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$onUploadFile, api, id, candidate, model);
			case 4:
				var candidate = msg.a;
				var rsp = msg.b;
				return A4($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$onFileUploadResponse, api, candidate, rsp, model);
			case 6:
				var _v1 = msg.a;
				var filename = _v1.a;
				var relativePath = _v1.b;
				var size = _v1.c;
				return A2(
					$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$onFilePath,
					_Utils_Tuple3(filename, relativePath, size),
					model);
			default:
				return $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$processNextBatch(model);
		}
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$uploadState = function (model) {
	return model.bH.l_;
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ),
								qV: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{qV: response}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 0:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{ajJ: pagination, qV: $author$project$Api$Data$Loading});
				return _Utils_Tuple3(
					newModel,
					A2($author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$fetchClinicalUploadResults, pagination, apiClient),
					_List_Nil);
			case 1:
				var uploadId = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							pp: $elm$core$Maybe$Just(uploadId)
						}),
					A4($author$project$Api$ClinicalUploadResult$processUpload, 1, apiClient, uploadId, $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$ProcessUploadResponse),
					_List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 3, 'Processing started for the upload.')
						]));
			case 2:
				var response = msg.a;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{pp: $elm$core$Maybe$Nothing}),
							A2($author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$fetchClinicalUploadResults, model.ajJ, apiClient),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Processing completed successfully.')
								]));
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{pp: $elm$core$Maybe$Nothing}),
							A2($author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$fetchClinicalUploadResults, model.ajJ, apiClient),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									1,
									'Processing failed: ' + $author$project$Api$Data$errorToString(error))
								]));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var uploadId = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							F$: $elm$core$Maybe$Just(
								$author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$AddToExisting(uploadId)),
							h7: $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$showModal(
								$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$initForExistingUpload(uploadId))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							F$: $elm$core$Maybe$Just($author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$NewUpload),
							h7: $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$showModal($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$init)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var uploaderMsg = msg.a;
				var _v3 = A3($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$update, apiClient, uploaderMsg, model.h7);
				var newUploader = _v3.a;
				var cmd = _v3.b;
				var outMsgs = _v3.c;
				var refreshCmd = function () {
					var _v4 = $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$uploadState(newUploader);
					if (_v4.$ === 3) {
						return A2($author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$fetchClinicalUploadResults, model.ajJ, apiClient);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{h7: newUploader}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$UploaderMsg, cmd),
								refreshCmd
							])),
					outMsgs);
		}
	});
var $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$GotResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$McePlanUpload$mcePlanUploadsPath = function (basePath) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['mce_plan_upload']),
		basePath);
};
var $author$project$Api$McePlanUpload$create = F3(
	function (apiClient, file, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A3(
				$author$project$Api$Data$requestWithFile,
				'file',
				file,
				$author$project$Api$Data$requestTo(
					$author$project$Api$McePlanUpload$mcePlanUploadsPath($author$project$Api$Data$providerPath))));
	});
var $author$project$Api$McePlanUpload$update = F3(
	function (apiClient, file, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A3(
				$author$project$Api$Data$requestWithFile,
				'file',
				file,
				$author$project$Api$Data$requestTo(
					$author$project$Api$McePlanUpload$mcePlanUploadsPath($author$project$Api$Data$providerPath))));
	});
var $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var files = msg.a;
				return $elm$core$List$isEmpty(files) ? _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil) : _Utils_Tuple3(
					model,
					function () {
						var _v1 = $elm$core$List$head(files);
						if (!_v1.$) {
							var file = _v1.a;
							var _v2 = model.KM;
							if (!_v2) {
								return A3($author$project$Api$McePlanUpload$create, apiClient, file, $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$GotResponse);
							} else {
								return A3($author$project$Api$McePlanUpload$update, apiClient, file, $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$GotResponse);
							}
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}(),
					_List_Nil);
			case 1:
				var response = msg.a;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{lp: true, vi: $elm$core$Maybe$Nothing}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									lp: true,
									vi: $elm$core$Maybe$Just(
										$author$project$Api$Data$errorToString(error))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{lp: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var actionType = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{KM: actionType}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
		}
	});
var $author$project$Pages$Patients$Upload$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var resource = msg.a;
				var uploadResource = function () {
					switch (resource) {
						case 0:
							return 3;
						case 1:
							return 5;
						case 2:
							return 4;
						default:
							return 7;
					}
				}();
				var _v1 = A4($author$project$Components$Upload$Form$init, model.J7, model.Gv, uploadResource, $elm$core$Maybe$Nothing);
				var uploadForm = _v1.a;
				var uploadFormCmd = _v1.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							d0: $elm$core$Maybe$Nothing,
							WI: $elm$core$Maybe$Nothing,
							Jy: $elm$core$Maybe$Just(resource),
							h4: uploadForm
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$Upload$UploadFormMsg, uploadFormCmd),
					_List_Nil);
			case 1:
				var clinicalResource = msg.a;
				if (!clinicalResource) {
					var _v4 = A2($author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$init, model.J7, model.Gv);
					var atlasClinicalUploadForm = _v4.a;
					var atlasClinicalUploadFormCmd = _v4.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								fJ: atlasClinicalUploadForm,
								d0: $elm$core$Maybe$Just(clinicalResource),
								WI: $elm$core$Maybe$Nothing,
								Jy: $elm$core$Maybe$Nothing
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$Upload$AtlasClinicalUploadFormMsg, atlasClinicalUploadFormCmd),
						_List_Nil);
				} else {
					var _v5 = A2($author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$init, model.J7, model.Gv);
					var ccdaClinicalUploadForm = _v5.a;
					var ccdaClinicalUploadFormCmd = _v5.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								fV: ccdaClinicalUploadForm,
								d0: $elm$core$Maybe$Just(clinicalResource),
								WI: $elm$core$Maybe$Nothing,
								Jy: $elm$core$Maybe$Nothing
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$Upload$CcdaClinicalUploadFormMsg, ccdaClinicalUploadFormCmd),
						_List_Nil);
				}
			case 8:
				var mcePlanResource = msg.a;
				var uploadResource = 0;
				var _v6 = A3($author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$init, model.J7, model.Gv, uploadResource);
				var mcePlanUploadForm = _v6.a;
				var mcePlanUploadCmd = _v6.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							d0: $elm$core$Maybe$Nothing,
							WI: $elm$core$Maybe$Just(mcePlanResource),
							gU: mcePlanUploadForm,
							Jy: $elm$core$Maybe$Nothing
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$Upload$McePlanUploadFormMsg, mcePlanUploadCmd),
					_List_Nil);
			case 9:
				var subMsg = msg.a;
				var _v7 = A3($author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$update, model.Gv, subMsg, model.gU);
				var mcePlanUploadForm = _v7.a;
				var subCmd = _v7.b;
				var subOutMsgs = _v7.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{gU: mcePlanUploadForm}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$Upload$McePlanUploadFormMsg, subCmd),
					subOutMsgs);
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{i9: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var confirmed = msg.a;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{i9: false}),
					A2($author$project$Api$Provider$Patient$destroyAll, model.Gv, $author$project$Pages$Patients$Upload$GotPatientDestroyAll),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{i9: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{xh: false}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Patients were successfully removed.')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 4:
				var subMsg = msg.a;
				var _v9 = A3($author$project$Components$Upload$Form$update, model.Gv, subMsg, model.h4);
				var uploadForm = _v9.a;
				var subCmd = _v9.b;
				var subOutMsgs = _v9.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{h4: uploadForm}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$Upload$UploadFormMsg, subCmd),
					subOutMsgs);
			case 6:
				var subMsg = msg.a;
				var _v10 = A3($author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$update, model.Gv, subMsg, model.fJ);
				var atlasClinicalUploadForm = _v10.a;
				var subCmd = _v10.b;
				var subOutMsgs = _v10.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{fJ: atlasClinicalUploadForm}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$Upload$AtlasClinicalUploadFormMsg, subCmd),
					subOutMsgs);
			default:
				var subMsg = msg.a;
				var _v11 = A3($author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$update, model.Gv, subMsg, model.fV);
				var ccdaClinicalUploadForm = _v11.a;
				var subCmd = _v11.b;
				var subOutMsgs = _v11.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{fV: ccdaClinicalUploadForm}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$Upload$CcdaClinicalUploadFormMsg, subCmd),
					subOutMsgs);
		}
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$uploadingModal = A3(
	$author$project$Ui$Modal$view,
	$author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$UploadModal,
	_List_fromArray(
		[$author$project$Ui$Modal$lg]),
	_List_fromArray(
		[
			$author$project$Ui$Modal$header(_List_Nil),
			$author$project$Ui$Modal$body(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-center')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Spinner$view(_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mt-3')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Uploading files, please wait...')
								]))
						]))
				]))
		]));
var $author$project$Components$Admin$Uploads$UploadModal$viewModalBody = F2(
	function (isError, message) {
		return isError ? _List_fromArray(
			[
				A2(
				$author$project$Ui$Alert$danger,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(message)
					]))
			]) : _List_fromArray(
			[
				A2(
				$author$project$Ui$Alert$success,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(message)
					]))
			]);
	});
var $author$project$Components$Admin$Uploads$UploadModal$view = F3(
	function (onClose, isError, message) {
		return A3(
			$author$project$Ui$Modal$view,
			onClose,
			_List_fromArray(
				[$author$project$Ui$Modal$lg]),
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(_List_Nil),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-center')
								]),
							A2($author$project$Components$Admin$Uploads$UploadModal$viewModalBody, isError, message))
						]))
				]));
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$modal = function (model) {
	if (model.n9) {
		return $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$uploadingModal;
	} else {
		var _v0 = _Utils_Tuple2(model.lp, model.vi);
		if (_v0.a) {
			if (!_v0.b.$) {
				var errorMessage = _v0.b.a;
				return A3($author$project$Components$Admin$Uploads$UploadModal$view, $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$UploadModal, true, errorMessage);
			} else {
				var _v1 = _v0.b;
				return A3($author$project$Components$Admin$Uploads$UploadModal$view, $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$UploadModal, false, 'Your files were uploaded successfully.');
			}
		} else {
			return $author$project$Utils$Html$empty;
		}
	}
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$FileSelected = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Form$File$Xml = 5;
var $author$project$Ui$Form$File$Directory = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Form$File$directory = $author$project$Ui$Form$File$Directory;
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$FailedFile = F3(
	function (name, path, error) {
		return {RK: error, Bq: name, YX: path};
	});
var $author$project$Ui$Table$Bordered = {$: 0};
var $author$project$Ui$Table$bordered = $author$project$Ui$Table$Bordered;
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$viewFailures = function (failedFiles) {
	var hasFailedFiles = !$elm$core$List$isEmpty(failedFiles);
	return hasFailedFiles ? A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$mt4, $author$project$Ui$Element$textLeft]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$title,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Failed files:')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('table-wrapper overflow-y-auto max-h-[400px]')
					]),
				_List_fromArray(
					[
						A4(
						$author$project$Ui$Table$view,
						_List_fromArray(
							[
								$author$project$Ui$Table$bordered,
								$author$project$Ui$Table$containerClasses(
								_List_fromArray(
									['table-wrapper', 'overflow-y-auto', 'max-h-[400px]']))
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Api$Column$view,
								$author$project$Api$Column$NonSortable,
								A3($author$project$Api$Column$init, 'filename', true, 'File Name')),
								A2(
								$author$project$Api$Column$view,
								$author$project$Api$Column$NonSortable,
								A3($author$project$Api$Column$init, 'path', true, 'Path')),
								A2(
								$author$project$Api$Column$view,
								$author$project$Api$Column$NonSortable,
								A3($author$project$Api$Column$init, 'error', true, 'Error Message'))
							]),
						A2(
							$elm$core$List$map,
							function (_v0) {
								var name = _v0.Bq;
								var path = _v0.YX;
								var error = _v0.RK;
								return A2(
									$author$project$Ui$Table$row,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Table$cell,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$fontBold, $author$project$Ui$Element$textDanger]),
													_List_fromArray(
														[
															$elm$html$Html$text(name)
														]))
												])),
											A2(
											$author$project$Ui$Table$cell,
											_List_Nil,
											_List_fromArray(
												[
													$elm$core$String$isEmpty(path) ? $elm$html$Html$text('-') : $elm$html$Html$text(path)
												])),
											A2(
											$author$project$Ui$Table$cell,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$textDanger]),
													_List_fromArray(
														[
															$elm$html$Html$text(error)
														]))
												]))
										]));
							},
							failedFiles),
						_List_Nil)
					])),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mt2]),
				_List_fromArray(
					[
						$elm$html$Html$text('Note: Failed files will be skipped, but the upload process will continue.')
					]))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$CancelUpload = {$: 1};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$viewFooter = function (_v0) {
	var allowCancel = _v0.Lu;
	var hasFailures = _v0.S9;
	var finished = _v0.Sr;
	return allowCancel ? _List_fromArray(
		[
			A3(
			$author$project$Ui$Button$view,
			{mm: 'Cancel upload'},
			_List_fromArray(
				[
					$author$project$Ui$Button$onClick($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$CancelUpload),
					$author$project$Ui$Button$danger
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Cancel Upload')
				]))
		]) : ((hasFailures || finished) ? _List_fromArray(
		[
			A3(
			$author$project$Ui$Button$view,
			{mm: 'Cancel and close modal'},
			_List_fromArray(
				[
					$author$project$Ui$Button$onClick($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$CloseModal),
					$author$project$Ui$Button$primary
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Close')
				]))
		]) : _List_Nil);
};
var $author$project$Ui$ProgressBar$Animated = {$: 1};
var $author$project$Ui$ProgressBar$animated = $author$project$Ui$ProgressBar$Animated;
var $author$project$Ui$ProgressBar$ShowProgress = {$: 5};
var $author$project$Ui$ProgressBar$showProgress = $author$project$Ui$ProgressBar$ShowProgress;
var $author$project$Ui$ProgressBar$Striped = {$: 0};
var $author$project$Ui$ProgressBar$striped = $author$project$Ui$ProgressBar$Striped;
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$viewProgress = F2(
	function (current, total) {
		if (total > 0) {
			var progress = ((current * 100) / total) | 0;
			var displayCount = (progress >= 100) ? total : current;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mt2, $author$project$Ui$Element$mb3]),
						_List_fromArray(
							[
								$author$project$Ui$ProgressBar$view(
								_List_fromArray(
									[
										$author$project$Ui$ProgressBar$striped,
										$author$project$Ui$ProgressBar$animated,
										$author$project$Ui$ProgressBar$width(progress),
										$author$project$Ui$ProgressBar$showProgress
									]))
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mt2, $author$project$Ui$Element$mb3]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(displayCount) + (' of ' + ($elm$core$String$fromInt(total) + ' XML files')))
							]))
					]));
		} else {
			return $author$project$Ui$Spinner$view(_List_Nil);
		}
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$uploadingModal = F5(
	function (message, current, total, failedFiles, allowCancel) {
		var progress = (!total) ? 0 : (((current * 100) / total) | 0);
		var failedCount = $elm$core$List$length(failedFiles);
		var config = {
			Pd: current,
			zz: A2(
				$elm$core$List$map,
				function (_v0) {
					var name = _v0.a;
					var path = _v0.b;
					var error = _v0.c;
					return A3($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$FailedFile, name, path, error);
				},
				failedFiles),
			ahr: {Lu: allowCancel, Sr: progress >= 100, S9: failedCount > 0},
			aiH: message,
			al9: total
		};
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$CloseModal,
			_List_fromArray(
				[$author$project$Ui$Modal$lg]),
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(_List_Nil),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-center')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$mb3]),
									_List_fromArray(
										[
											$elm$html$Html$text(config.aiH)
										])),
									A2($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$viewProgress, config.Pd, config.al9),
									$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$viewFailures(config.zz)
								]))
						])),
					$author$project$Ui$Modal$footer(
					$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$viewFooter(config.ahr))
				]));
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$view = function (model) {
	if (!model.ln) {
		return $author$project$Utils$Html$empty;
	} else {
		var _v0 = model.l_;
		switch (_v0.$) {
			case 1:
				var current = _v0.a;
				var total = _v0.b;
				return A5(
					$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$uploadingModal,
					'Reading ' + ($elm$core$String$fromInt(current) + (' of ' + ($elm$core$String$fromInt(total) + ' files'))),
					current,
					total,
					_List_Nil,
					false);
			case 2:
				var process = _v0.a;
				return A5(
					$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$uploadingModal,
					'Uploading files',
					process.adV,
					process.al9,
					A2(
						$elm$core$List$map,
						function (f) {
							return _Utils_Tuple3(f.Bq, f.YX, f.RK);
						},
						process.zA),
					true);
			case 3:
				var failedFiles = _v0.a.zz;
				var totalFiles = _v0.a.ado;
				return $elm$core$List$isEmpty(failedFiles) ? A5($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$uploadingModal, 'Upload complete!', totalFiles, totalFiles, _List_Nil, false) : A5($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$uploadingModal, 'Upload complete with errors', totalFiles, totalFiles, failedFiles, false);
			default:
				var _v1 = model.vi;
				if (!_v1.$) {
					var errorMessage = _v1.a;
					return A3($author$project$Components$Admin$Uploads$UploadModal$view, $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$CloseModal, true, errorMessage);
				} else {
					var _v2 = function () {
						var _v3 = model.F$;
						if (!_v3.$) {
							return _Utils_Tuple2('Select Files to Upload', 'Select a folder containing CCDA (.xml) files. All CCDA files in the folder and its subfolders will be processed.');
						} else {
							return _Utils_Tuple2('Upload More Files', 'Select additional CCDA (.xml) files to add to this upload.');
						}
					}();
					var headerText = _v2.a;
					var helpText = _v2.b;
					return A3(
						$author$project$Ui$Modal$view,
						$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$CloseModal,
						_List_fromArray(
							[$author$project$Ui$Modal$lg]),
						_List_fromArray(
							[
								$author$project$Ui$Modal$header(
								_List_fromArray(
									[
										$elm$html$Html$text(headerText)
									])),
								$author$project$Ui$Modal$body(
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_fromArray(
											[$author$project$Ui$Typography$helpText]),
										_List_fromArray(
											[
												$elm$html$Html$text(helpText)
											])),
										A2(
										$author$project$Ui$Form$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$noValidate(true),
												$author$project$Ui$Form$autocomplete(false)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Group$view,
												_List_Nil,
												_List_fromArray(
													[
														$author$project$Ui$Form$File$view(
														_List_fromArray(
															[
																$author$project$Ui$Form$File$directory(true),
																$author$project$Ui$Form$File$accept(5),
																$author$project$Ui$Form$File$onInput($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$FileSelected)
															]))
													]))
											]))
									]))
							]));
				}
		}
	}
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$view = function (model) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$ModalMsg,
		$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$view(model.bH));
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$modal = function (model) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$UploaderMsg,
		$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$view(model.h7));
};
var $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$modal = function (model) {
	var _v0 = _Utils_Tuple2(model.lp, model.vi);
	if (_v0.a) {
		if (!_v0.b.$) {
			var errorMessage = _v0.b.a;
			return A3($author$project$Components$Admin$Uploads$UploadModal$view, $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$UploadModal, true, errorMessage);
		} else {
			var _v1 = _v0.b;
			return A3($author$project$Components$Admin$Uploads$UploadModal$view, $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$UploadModal, false, 'Your files were uploaded successfully.');
		}
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Api$Feature$CcdaExtraction = 31;
var $author$project$Pages$Patients$Upload$DeleteAllPatients = {$: 2};
var $author$project$Pages$Patients$Upload$Membership = 1;
var $author$project$Pages$Patients$Upload$PatientNote = 3;
var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$PaginationMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'file_name', true, 'File name'),
		A3($author$project$Api$Column$init, 'status', true, 'Status'),
		A3($author$project$Api$Column$init, 'result', true, 'Result'),
		A3($author$project$Api$Column$init, 'created_at', true, 'Created At')
	]);
var $author$project$Api$Provider$ClinicalUploadResult$Shared$createdAt = function (_v0) {
	var record = _v0;
	return record.O1;
};
var $author$project$Api$Provider$ClinicalUploadResult$All$createdAt = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ClinicalUploadResult$Shared$createdAt(shared);
};
var $author$project$Api$Provider$ClinicalUploadResult$Data$message = function (_v0) {
	var record = _v0;
	return record.aiH;
};
var $author$project$Api$Provider$ClinicalUploadResult$Shared$result = function (_v0) {
	var record = _v0;
	return record.$U;
};
var $author$project$Api$Provider$ClinicalUploadResult$All$errorMessage = function (_v0) {
	var shared = _v0;
	return A2(
		$elm$core$Maybe$andThen,
		$author$project$Api$Provider$ClinicalUploadResult$Data$message,
		$author$project$Api$Provider$ClinicalUploadResult$Shared$result(shared));
};
var $author$project$Api$Provider$ClinicalUploadResult$Shared$fileName = function (_v0) {
	var record = _v0;
	return record.Sn;
};
var $author$project$Api$Provider$ClinicalUploadResult$All$fileName = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ClinicalUploadResult$Shared$fileName(shared);
};
var $author$project$Api$Provider$ClinicalUploadResult$Shared$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Api$Provider$ClinicalUploadResult$All$Enqueued = {$: 0};
var $author$project$Api$Provider$ClinicalUploadResult$All$Failed = {$: 5};
var $author$project$Api$Provider$ClinicalUploadResult$All$PartiallyProcessed = {$: 6};
var $author$project$Api$Provider$ClinicalUploadResult$All$Processed = {$: 4};
var $author$project$Api$Provider$ClinicalUploadResult$All$Processing = {$: 3};
var $author$project$Api$Provider$ClinicalUploadResult$All$ReadyForProcessing = {$: 2};
var $author$project$Api$Provider$ClinicalUploadResult$All$ReadyForUploading = {$: 1};
var $author$project$Api$Provider$ClinicalUploadResult$All$Unknown = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$ClinicalUploadResult$All$stringToStatus = function (str) {
	switch (str) {
		case 'enqueued':
			return $author$project$Api$Provider$ClinicalUploadResult$All$Enqueued;
		case 'ready_for_uploading':
			return $author$project$Api$Provider$ClinicalUploadResult$All$ReadyForUploading;
		case 'ready_for_processing':
			return $author$project$Api$Provider$ClinicalUploadResult$All$ReadyForProcessing;
		case 'processing':
			return $author$project$Api$Provider$ClinicalUploadResult$All$Processing;
		case 'processed':
			return $author$project$Api$Provider$ClinicalUploadResult$All$Processed;
		case 'failed':
			return $author$project$Api$Provider$ClinicalUploadResult$All$Failed;
		case 'partially_processed':
			return $author$project$Api$Provider$ClinicalUploadResult$All$PartiallyProcessed;
		default:
			return $author$project$Api$Provider$ClinicalUploadResult$All$Unknown(str);
	}
};
var $author$project$Api$Provider$ClinicalUploadResult$All$status = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ClinicalUploadResult$All$stringToStatus(
		$author$project$Api$Provider$ClinicalUploadResult$Shared$status(shared));
};
var $author$project$Api$Provider$ClinicalUploadResult$All$statusToString = function (uploadStatus) {
	switch (uploadStatus.$) {
		case 0:
			return 'enqueued';
		case 1:
			return 'ready_for_uploading';
		case 2:
			return 'ready_for_processing';
		case 3:
			return 'processing';
		case 4:
			return 'processed';
		case 5:
			return 'failed';
		case 6:
			return 'partially_processed';
		default:
			var str = uploadStatus.a;
			return str;
	}
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$viewRow = F2(
	function (model, upload) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$ClinicalUploadResult$All$fileName(upload))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$ClinicalUploadResult$All$statusToString(
								$author$project$Api$Provider$ClinicalUploadResult$All$status(upload)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$limitWidth]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								$author$project$Api$Provider$ClinicalUploadResult$All$errorMessage(upload)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								model.J7,
								0,
								$author$project$Api$Provider$ClinicalUploadResult$All$createdAt(upload)))
						]))
				]));
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$viewTable = function (model) {
	var _v0 = function () {
		var _v1 = model.qV;
		if (_v1.$ === 3) {
			var uploads_ = _v1.a;
			return _Utils_Tuple2(false, uploads_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var uploads = _v0.b;
	return A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You have no uploads yet!')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		A2(
			$elm$core$List$map,
			$author$project$Api$Column$view($author$project$Api$Column$NonSortable),
			$author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$columns),
		A2(
			$elm$core$List$map,
			$author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$viewRow(model),
			uploads),
		_List_Nil);
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$viewClinicalUploadResults = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Typography$headingSm(
				_List_fromArray(
					[
						$elm$html$Html$text('Previous Atlas uploads')
					])),
				$author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$viewTable(model),
				A2(
				$elm$html$Html$map,
				$author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$PaginationMsg,
				A2($author$project$Api$Pagination$view, _List_Nil, model.ajJ))
			]));
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$FileUploaded = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$File$Zip = 4;
var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$isZipFile = function (file) {
	var fileName = $elm$file$File$name(file);
	return A2($elm$core$String$endsWith, '.zip', fileName) && (!A2($elm$core$String$startsWith, '.', fileName));
};
var $author$project$Ui$Form$File$Multiple = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Form$File$multiple = $author$project$Ui$Form$File$Multiple;
var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$viewUploadForm = A2(
	$elm$html$Html$div,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Typography$p,
			_List_fromArray(
				[$author$project$Ui$Typography$helpText]),
			_List_fromArray(
				[
					$elm$html$Html$text('Upload files (.zip only)')
				])),
			A2(
			$author$project$Ui$Form$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$noValidate(true),
					$author$project$Ui$Form$autocomplete(false)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Form$File$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$File$directory(true),
									$author$project$Ui$Form$File$accept(4),
									$author$project$Ui$Form$File$onInput(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$FileUploaded,
										$elm$core$List$filter($author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$isZipFile))),
									$author$project$Ui$Form$File$multiple(true)
								]))
						]))
				]))
		]));
var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$title,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Step 2. Upload Atlas clinical information.')
					])),
				$author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$viewUploadForm,
				$author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$viewClinicalUploadResults(model)
			]));
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$PaginationMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'file_name', true, 'File name'),
		A3($author$project$Api$Column$init, 'status', true, 'Status'),
		A3($author$project$Api$Column$init, 'result', true, 'Result'),
		A3($author$project$Api$Column$init, 'created_at', true, 'Created At'),
		A3($author$project$Api$Column$init, 'actions', false, 'Actions')
	]);
var $author$project$Ui$Alignment$justifyStart = $author$project$Ui$Alignment$Content(0);
var $author$project$Ui$Element$justifyLeft = $author$project$Ui$Element$Alignment($author$project$Ui$Alignment$justifyStart);
var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$ProcessUpload = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$UploadMoreFiles = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$ClinicalUploadResult$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ClinicalUploadResult$Shared$id(shared);
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$viewActionButtons = F3(
	function (model, upload, status) {
		switch (status.$) {
			case 3:
				return _List_Nil;
			case 4:
				return _List_Nil;
			default:
				var uploadId = $author$project$Api$Provider$ClinicalUploadResult$All$id(upload);
				var isProcessing = _Utils_eq(
					model.pp,
					$elm$core$Maybe$Just(uploadId));
				var buttonText = function () {
					switch (status.$) {
						case 6:
							return 'Re-process failed ones';
						case 5:
							return 'Re-process failed ones';
						default:
							return 'Process';
					}
				}();
				return _List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: buttonText},
						_List_fromArray(
							[
								$author$project$Ui$Button$sm,
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$onClick(
								$author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$ProcessUpload(uploadId)),
								$author$project$Ui$Button$loading(isProcessing)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(buttonText)
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Upload more'},
						_List_fromArray(
							[
								$author$project$Ui$Button$sm,
								$author$project$Ui$Button$onClick(
								$author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$UploadMoreFiles(uploadId))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Upload more')
							]))
					]);
		}
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$viewReportsLink = F2(
	function (config, upload) {
		return config.ahc ? _List_fromArray(
			[
				A3(
				$author$project$Ui$Link$route,
				$author$project$Spa$Generated$Route$CcdaImports__CcdaId_String__Top(
					{
						afv: $author$project$Api$Provider$ClinicalUploadResult$All$id(upload)
					}),
				_List_fromArray(
					[$author$project$Ui$Link$buttonDefault, $author$project$Ui$Link$sm]),
				_List_fromArray(
					[
						$elm$html$Html$text('View reports')
					]))
			]) : _List_Nil;
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$viewRow = F3(
	function (config, model, upload) {
		var uploadStatus = $author$project$Api$Provider$ClinicalUploadResult$All$status(upload);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$ClinicalUploadResult$All$fileName(upload))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$ClinicalUploadResult$All$statusToString(uploadStatus))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$limitWidth]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								$author$project$Api$Provider$ClinicalUploadResult$All$errorMessage(upload)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								model.J7,
								0,
								$author$project$Api$Provider$ClinicalUploadResult$All$createdAt(upload)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$noWrap]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$justifyLeft, $author$project$Ui$Element$gap2]),
							_Utils_ap(
								A3($author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$viewActionButtons, model, upload, uploadStatus),
								A2($author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$viewReportsLink, config, upload)))
						]))
				]));
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$viewTable = F2(
	function (config, model) {
		var _v0 = function () {
			var _v1 = model.qV;
			if (_v1.$ === 3) {
				var uploads_ = _v1.a;
				return _Utils_Tuple2(false, uploads_);
			} else {
				return _Utils_Tuple2(true, _List_Nil);
			}
		}();
		var loading = _v0.a;
		var uploads = _v0.b;
		return A4(
			$author$project$Ui$Table$view,
			_List_fromArray(
				[
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('You have no uploads yet!')
						])),
					$author$project$Ui$Table$loading(loading)
				]),
			A2(
				$elm$core$List$map,
				$author$project$Api$Column$view($author$project$Api$Column$NonSortable),
				$author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$columns),
			A2(
				$elm$core$List$map,
				A2($author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$viewRow, config, model),
				uploads),
			_List_Nil);
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$viewClinicalUploadResults = F2(
	function (config, model) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Previous CCDA uploads')
						])),
					A2($author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$viewTable, config, model),
					A2(
					$elm$html$Html$map,
					$author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$PaginationMsg,
					A2($author$project$Api$Pagination$view, _List_Nil, model.ajJ))
				]));
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$OpenFileSelectionModal = {$: 4};
var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$viewUploadForm = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				function () {
				var _v0 = model.F$;
				if ((!_v0.$) && (_v0.a.$ === 1)) {
					var uploadId = _v0.a.a;
					return A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$helpText]),
						_List_fromArray(
							[
								$elm$html$Html$text('Adding files to upload ' + uploadId)
							]));
				} else {
					return A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$helpText]),
						_List_fromArray(
							[
								$elm$html$Html$text('Click the button below to select a folder containing CCDA (.xml) files. All CCDA files in the folder and its subfolders will be processed.')
							]));
				}
			}(),
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Create upload'},
				_List_fromArray(
					[
						$author$project$Ui$Button$onClick($author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$OpenFileSelectionModal),
						$author$project$Ui$Button$primary
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Create Upload')
					]))
			]));
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$view = F2(
	function (config, model) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$title,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Step 2. Upload CCDA clinical information.')
						])),
					$author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$viewUploadForm(model),
					A2($author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$viewClinicalUploadResults, config, model)
				]));
	});
var $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$MceActionTypeUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Upload$McePlanResource$McePlanUpdate = 1;
var $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$viewColumns = function (isCreate) {
	var viewColumn = function (_v0) {
		var name = _v0.a;
		var isRequired = _v0.b;
		return A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(name),
					isRequired ? A2(
					$author$project$Ui$Typography$em,
					_List_fromArray(
						[$author$project$Ui$Typography$danger, $author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
					_List_fromArray(
						[
							$elm$html$Html$text(' * required')
						])) : $author$project$Utils$Html$empty
				]));
	};
	var baseColumns = _List_fromArray(
		[
			_Utils_Tuple2('Tier', isCreate),
			_Utils_Tuple2('Ages', isCreate),
			_Utils_Tuple2('IUA Level', isCreate)
		]);
	var actionSpecificColumns = isCreate ? _List_fromArray(
		[
			_Utils_Tuple2('Plan Name', true)
		]) : _List_fromArray(
		[
			_Utils_Tuple2('Plan ID', true)
		]);
	var csvColumns = _Utils_ap(baseColumns, actionSpecificColumns);
	return A2(
		$elm$html$Html$ul,
		_List_Nil,
		A2($elm$core$List$map, viewColumn, csvColumns));
};
var $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$FileUploaded = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$viewUploadForm = A2(
	$author$project$Ui$Form$view,
	_List_fromArray(
		[
			$author$project$Ui$Form$noValidate(true),
			$author$project$Ui$Form$autocomplete(false)
		]),
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Form$Group$view,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Form$File$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$File$accept(1),
							$author$project$Ui$Form$File$onInput($author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$FileUploaded),
							$author$project$Ui$Form$File$multiple(true)
						]))
				]))
		]));
var $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$title,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Step 2. Select desired change.')
					])),
				$author$project$Ui$Button$group(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Create mce plan'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick(
								$author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$MceActionTypeUpdated(0)),
								$author$project$Ui$Button$active(!model.KM)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Create')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Update mce plan'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick(
								$author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$MceActionTypeUpdated(1)),
								$author$project$Ui$Button$active(model.KM === 1)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Update')
							]))
					])),
				A2(
				$author$project$Ui$Typography$title,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Step 3. Create a CSV file.')
					])),
				A2(
				$author$project$Ui$Typography$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('It should include these exact headers:')
					])),
				(!model.KM) ? $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$viewColumns(true) : $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$viewColumns(false),
				A2(
				$author$project$Ui$Typography$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Get started with our ready-to-go template'),
						$author$project$Utils$Html$noBreakSpace,
						A3(
						$author$project$Ui$Link$externalHref,
						'https://docs.google.com/spreadsheets/d/1QNttlhfBQm-LV-a0WCvsiqNOONyzYTE99WG7BLkVIso/edit?gid=0#gid=0',
						_List_fromArray(
							[$author$project$Ui$Link$targetBlank]),
						_List_fromArray(
							[
								$elm$html$Html$text('here.')
							]))
					])),
				A2($elm$html$Html$br, _List_Nil, _List_Nil),
				A2(
				$author$project$Ui$Typography$title,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Step 4. Upload the file.')
					])),
				$author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$viewUploadForm
			]));
};
var $author$project$Pages$Patients$Upload$Charge = 2;
var $author$project$Api$FeatureGate$ChargeUploader = 1;
var $author$project$Pages$Patients$Upload$ResourceSelected = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Patients$Upload$buttonStyle = function (bool) {
	return bool ? 1 : 0;
};
var $author$project$Pages$Patients$Upload$viewChargeResourceButton = function (model) {
	var hasFeatureGate = A2(
		$author$project$Utils$FeatureGate$gateAvailable,
		1,
		$author$project$Api$Practice$Provider(model.ZV));
	return hasFeatureGate ? A3(
		$author$project$Ui$Button$view,
		{mm: 'Charges'},
		_List_fromArray(
			[
				$author$project$Ui$Button$active(
				_Utils_eq(
					model.Jy,
					$elm$core$Maybe$Just(2))),
				$author$project$Ui$Button$styled(
				$author$project$Pages$Patients$Upload$buttonStyle(
					_Utils_eq(
						model.Jy,
						$elm$core$Maybe$Just(2)))),
				$author$project$Ui$Button$onClick(
				$author$project$Pages$Patients$Upload$ResourceSelected(2))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Charges')
			])) : (model.Ij ? A3(
		$author$project$Ui$HinterOnly$button,
		{mm: 'Charges'},
		_List_fromArray(
			[
				$author$project$Ui$Button$active(
				_Utils_eq(
					model.Jy,
					$elm$core$Maybe$Just(2))),
				$author$project$Ui$Button$styled(
				$author$project$Pages$Patients$Upload$buttonStyle(
					_Utils_eq(
						model.Jy,
						$elm$core$Maybe$Just(2)))),
				$author$project$Ui$Button$onClick(
				$author$project$Pages$Patients$Upload$ResourceSelected(2))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Charges')
			])) : $author$project$Utils$Html$empty);
};
var $author$project$Pages$Patients$Upload$ClinicalResourceSelected = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Patients$Upload$viewClinicalResourceButton = F4(
	function (clinicalResource, label, flag, model) {
		return flag ? A3(
			$author$project$Ui$HinterOnly$button,
			{mm: 'Select ' + label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(
						model.d0,
						$elm$core$Maybe$Just(clinicalResource))),
					$author$project$Ui$Button$styled(
					$author$project$Pages$Patients$Upload$buttonStyle(
						_Utils_eq(
							model.d0,
							$elm$core$Maybe$Just(clinicalResource)))),
					$author$project$Ui$Button$onClick(
					$author$project$Pages$Patients$Upload$ClinicalResourceSelected(clinicalResource))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Pages$Patients$Upload$McePlanResourceSelected = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Patients$Upload$viewMcePlanResourceButton = F2(
	function (mcePlanResource, model) {
		return ($author$project$Api$Provider$Practice$One$accountType(model.ZV) === 2) ? A3(
			$author$project$Ui$Button$view,
			{mm: 'Select Healthshare Plan'},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(
						model.WI,
						$elm$core$Maybe$Just(0))),
					$author$project$Ui$Button$styled(
					$author$project$Pages$Patients$Upload$buttonStyle(
						_Utils_eq(
							model.WI,
							$elm$core$Maybe$Just(0)))),
					$author$project$Ui$Button$onClick(
					$author$project$Pages$Patients$Upload$McePlanResourceSelected(mcePlanResource))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Healthshare Plan')
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Pages$Patients$Upload$viewResourceButton = F4(
	function (resource, label, isHinter, model) {
		return isHinter ? A3(
			$author$project$Ui$HinterOnly$button,
			{mm: label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(
						model.Jy,
						$elm$core$Maybe$Just(resource))),
					$author$project$Ui$Button$styled(
					$author$project$Pages$Patients$Upload$buttonStyle(
						_Utils_eq(
							model.Jy,
							$elm$core$Maybe$Just(resource))))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				])) : A3(
			$author$project$Ui$Button$view,
			{mm: label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(
						model.Jy,
						$elm$core$Maybe$Just(resource))),
					$author$project$Ui$Button$styled(
					$author$project$Pages$Patients$Upload$buttonStyle(
						_Utils_eq(
							model.Jy,
							$elm$core$Maybe$Just(resource)))),
					$author$project$Ui$Button$onClick(
					$author$project$Pages$Patients$Upload$ResourceSelected(resource))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Pages$Patients$Upload$viewBody = function (model) {
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Panel$title(
						_List_fromArray(
							[
								$elm$html$Html$text('Data Uploader')
							]))
					])),
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						model.xh ? A2(
						$author$project$Ui$Well$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Want to Start Over?')
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Click the button below to remove all existing patients before uploading a new list of patients.')
									])),
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Delete all patients'},
								_List_fromArray(
									[
										$author$project$Ui$Button$danger,
										$author$project$Ui$Button$onClick($author$project$Pages$Patients$Upload$DeleteAllPatients)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Delete All Patients')
									]))
							])) : $author$project$Utils$Html$empty,
						A2(
						$author$project$Ui$Grid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanMd(6)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$title,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Step 1. Choose a data type.')
											])),
										$author$project$Ui$Button$group(
										_List_fromArray(
											[
												A4($author$project$Pages$Patients$Upload$viewResourceButton, 0, 'Patients', false, model),
												A4($author$project$Pages$Patients$Upload$viewResourceButton, 1, 'Memberships', false, model),
												$author$project$Pages$Patients$Upload$viewChargeResourceButton(model),
												A4($author$project$Pages$Patients$Upload$viewResourceButton, 3, 'Patient Notes', false, model),
												A4($author$project$Pages$Patients$Upload$viewClinicalResourceButton, 0, 'Atlas Clinical', model.Ij, model),
												A4($author$project$Pages$Patients$Upload$viewClinicalResourceButton, 1, 'CCDA Clinical', model.Ij, model),
												A2($author$project$Pages$Patients$Upload$viewMcePlanResourceButton, 0, model)
											]))
									]))
							])),
						function () {
						var _v0 = _Utils_Tuple3(model.Jy, model.d0, model.WI);
						_v0$3:
						while (true) {
							if (_v0.a.$ === 1) {
								if (!_v0.b.$) {
									if (!_v0.b.a) {
										if (_v0.c.$ === 1) {
											var _v1 = _v0.a;
											var _v2 = _v0.b.a;
											var _v3 = _v0.c;
											return A2(
												$elm$html$Html$map,
												$author$project$Pages$Patients$Upload$AtlasClinicalUploadFormMsg,
												$author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$view(model.fJ));
										} else {
											break _v0$3;
										}
									} else {
										if (_v0.c.$ === 1) {
											var _v4 = _v0.a;
											var _v5 = _v0.b.a;
											var _v6 = _v0.c;
											return A2(
												$elm$html$Html$map,
												$author$project$Pages$Patients$Upload$CcdaClinicalUploadFormMsg,
												A2(
													$author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$view,
													{
														ahc: A2($author$project$Api$Provider$Practice$One$featureEnabled, 31, model.ZV)
													},
													model.fV));
										} else {
											break _v0$3;
										}
									}
								} else {
									if (!_v0.c.$) {
										var _v7 = _v0.a;
										var _v8 = _v0.b;
										var _v9 = _v0.c.a;
										return A2(
											$elm$html$Html$map,
											$author$project$Pages$Patients$Upload$McePlanUploadFormMsg,
											$author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$view(model.gU));
									} else {
										break _v0$3;
									}
								}
							} else {
								break _v0$3;
							}
						}
						return A2(
							$elm$html$Html$map,
							$author$project$Pages$Patients$Upload$UploadFormMsg,
							A2($author$project$Components$Upload$Form$view, model.Gv, model.h4));
					}()
					])),
				A2(
				$author$project$Ui$Panel$footer,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Patients__Top,
						_List_fromArray(
							[$author$project$Ui$Link$buttonDefault]),
						_List_fromArray(
							[
								$author$project$Ui$Icon$arrowLeft(_List_Nil),
								$author$project$Utils$Html$noBreakSpace,
								$elm$html$Html$text('Go Back')
							]))
					]))
			]));
};
var $author$project$Pages$Patients$Upload$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				model.i9 ? A2(
				$author$project$Components$HiConfirm$modal,
				$author$project$Pages$Patients$Upload$HiConfirmClosed,
				_List_fromArray(
					[
						$author$project$Components$HiConfirm$verb('Delete All Patients'),
						$author$project$Components$HiConfirm$customMessage(
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Warning: ')
									])),
								$elm$html$Html$text('this will delete all the patients from the practice.')
							]))
					])) : $author$project$Utils$Html$empty,
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Patients$Upload$UploadFormMsg,
				A2($author$project$Components$Upload$Form$modal, model.Gv, model.h4)),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Patients$Upload$AtlasClinicalUploadFormMsg,
				$author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$modal(model.fJ)),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Patients$Upload$CcdaClinicalUploadFormMsg,
				$author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$modal(model.fV)),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Patients$Upload$McePlanUploadFormMsg,
				$author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$modal(model.gU)),
				$author$project$Pages$Patients$Upload$viewBody(model)
			]),
		ac9: 'Patients'
	};
};
var $author$project$Pages$Patients$Upload$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Patients$Upload$init, aiq: $author$project$Pages$Patients$Upload$load, k8: $author$project$Pages$Patients$Upload$save, alO: $author$project$Pages$Patients$Upload$subscriptions, adT: $author$project$Pages$Patients$Upload$update, amo: $author$project$Pages$Patients$Upload$view});
var $author$project$Pages$PracticeSetup$Account$AccountFormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$PracticeSetup$Account$GotPractice = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Platform$Organization$Shared$onboardingClinical = function (_v0) {
	var record = _v0.b;
	return record.Yk;
};
var $author$project$Pages$PracticeSetup$Account$onboardingClinical = function (session) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Platform$Organization$Shared$onboardingClinical,
			$author$project$Api$Platform$Session$One$organization(session)));
};
var $author$project$Api$Provider$Practice$DefaultPlan = 1;
var $author$project$Pages$PracticeSetup$Account$practiceOptionals = function (optionals) {
	return _Utils_update(
		optionals,
		{
			HE: _List_fromArray(
				[1])
		});
};
var $author$project$Pages$PracticeSetup$Account$init = F4(
	function (session, practice, shared, _v0) {
		var _v1 = A4(
			$author$project$Components$Practice$AccountForm$init,
			practice,
			shared.aey,
			shared,
			{
				bb: true,
				Yk: $author$project$Pages$PracticeSetup$Account$onboardingClinical(session)
			});
		var accountFormModel = _v1.a;
		var accountFormCmd = _v1.b;
		return _Utils_Tuple2(
			{
				cX: accountFormModel,
				Gv: shared.Gv,
				P9: '',
				Ij: $author$project$Shared$isHintAdmin(shared),
				ZV: practice,
				k9: $author$project$Api$Data$NotAsked,
				aa4: session,
				lk: shared
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$PracticeSetup$Account$AccountFormMsg, accountFormCmd),
						A3($author$project$Api$Provider$Practice$retrieve, shared.Gv, $author$project$Pages$PracticeSetup$Account$practiceOptionals, $author$project$Pages$PracticeSetup$Account$GotPractice)
					])));
	});
var $author$project$Utils$PracticeSetup$redirectIfOnboardingComplete = F2(
	function (sessionData, hinterViewOff) {
		if (sessionData.$ === 3) {
			var session = sessionData.a;
			var practiceIsOnboarding = A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					$author$project$Api$Platform$Organization$Shared$practiceIsOnboarding,
					$author$project$Api$Platform$Session$One$organization(session)));
			return practiceIsOnboarding ? $elm$core$Platform$Cmd$none : A2(
				$author$project$Utils$Route$navigate,
				$elm$core$Dict$empty,
				A2($author$project$Permission$homeStateFor, session, hinterViewOff));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Pages$PracticeSetup$Account$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			model,
			A2($author$project$Utils$PracticeSetup$redirectIfOnboardingComplete, shared.aa4, shared.ahK));
	});
var $author$project$Pages$PracticeSetup$Account$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$PracticeSetup$Account$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$PracticeSetup$Account$AccountFormMsg,
		$author$project$Components$Practice$AccountForm$subscriptions(model.cX));
};
var $author$project$Api$Provider$Practice$One$defaultPlanId = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.P9;
	});
var $author$project$Pages$PracticeSetup$Account$Updated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$PracticeSetup$Account$updatePractice = F2(
	function (apiClient, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A3(
			$author$project$Api$Provider$Practice$update,
			apiClient,
			$author$project$Components$Practice$AccountForm$practiceFromFields(fields),
			$author$project$Pages$PracticeSetup$Account$Updated);
	});
var $author$project$Pages$PracticeSetup$Account$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Components$Practice$AccountForm$update, subMsg, model.cX);
				var accountFormModel = _v1.a;
				var accountFormCmd = _v1.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cX: accountFormModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$PracticeSetup$Account$AccountFormMsg, accountFormCmd),
					_List_Nil);
			case 1:
				var _v2 = $author$project$Components$Practice$AccountForm$validate(model.cX);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var validatedForm = _v3.a;
					var validFormFields = _v3.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cX: validatedForm, k9: $author$project$Api$Data$Loading}),
						A2($author$project$Pages$PracticeSetup$Account$updatePractice, model.Gv, validFormFields),
						_List_Nil);
				} else {
					var erroredForm = _v2.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cX: erroredForm, k9: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					var practice = response.a;
					var _v5 = A4(
						$author$project$Components$Practice$AccountForm$init,
						practice,
						model.lk.aey,
						model.lk,
						{
							bb: true,
							Yk: $author$project$Pages$PracticeSetup$Account$onboardingClinical(model.aa4)
						});
					var form = _v5.a;
					var cmds = _v5.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cX: form, k9: response}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$PracticeSetup$Account$AccountFormMsg, cmds),
									A2(
									$author$project$Utils$Route$navigate,
									$elm$core$Dict$empty,
									$author$project$Spa$Generated$Route$PracticeSetup__Plans__Id_String__Edit(
										{ahP: model.P9}))
								])),
						_List_fromArray(
							[
								$author$project$OutMsg$PracticeUpdated(response)
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: response}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var practice = response.a;
					var defaultPlanId = A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$author$project$Api$Expandable$withDefault,
							$elm$core$Maybe$Nothing,
							$author$project$Api$Provider$Practice$One$defaultPlanId(practice)));
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{P9: defaultPlanId}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$PracticeSetup$Account$FormSubmitted = {$: 1};
var $author$project$Pages$PracticeSetup$Account$view = function (model) {
	var usingClinicalEmr = $author$project$Api$Provider$Practice$One$hasClinicalAccount(model.ZV) || $author$project$Pages$PracticeSetup$Account$onboardingClinical(model.aa4);
	var practiceIsOnboarding = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Platform$Organization$Shared$practiceIsOnboarding,
			$author$project$Api$Platform$Session$One$organization(model.aa4)));
	var loading = _Utils_eq(model.k9, $author$project$Api$Data$Loading);
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$autocomplete(false),
						$author$project$Ui$Form$noValidate(true),
						$author$project$Ui$Form$onSubmit($author$project$Pages$PracticeSetup$Account$FormSubmitted)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						practiceIsOnboarding ? _List_fromArray(
							[$author$project$Ui$Panel$onlyBorderLeft]) : _List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Contact Information')
											])),
										A2(
										$author$project$Ui$Typography$p,
										_List_fromArray(
											[$author$project$Ui$Typography$muted]),
										_List_fromArray(
											[
												$elm$html$Html$text('This information will be displayed to patients on communications and sign-up pages so they know how to reach you.'),
												usingClinicalEmr ? A2(
												$author$project$Ui$Element$view,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Practice phone and fax will be added later.')
													])) : $author$project$Utils$Html$empty
											]))
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Pages$PracticeSetup$Account$AccountFormMsg,
										$author$project$Components$Practice$AccountForm$view(model.cX)),
										function () {
										var _v0 = model.k9;
										if (_v0.$ === 2) {
											var error = _v0.a;
											return A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$mt4]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Alert$danger,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(
																$author$project$Api$Data$errorToString(error))
															]))
													]));
										} else {
											return $author$project$Utils$Html$empty;
										}
									}()
									])),
								A2(
								$author$project$Ui$Panel$footer,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween]),
								_List_fromArray(
									[
										A2($author$project$Ui$Element$view, _List_Nil, _List_Nil),
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Next'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$submit,
												$author$project$Ui$Button$loading(loading)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Next')
											]))
									]))
							]))
					]))
			]),
		ac9: 'Practice Setup'
	};
};
var $author$project$Pages$PracticeSetup$Account$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$PracticeSetup$Account$init, aiq: $author$project$Pages$PracticeSetup$Account$load, k8: $author$project$Pages$PracticeSetup$Account$save, alO: $author$project$Pages$PracticeSetup$Account$subscriptions, adT: $author$project$Pages$PracticeSetup$Account$update, amo: $author$project$Pages$PracticeSetup$Account$view});
var $author$project$Pages$PracticeSetup$Communications$GetNewNumbers = 0;
var $author$project$Pages$PracticeSetup$Communications$initFormFields = {jJ: 0, nG: '', hg: 0, o8: ''};
var $author$project$Pages$PracticeSetup$Communications$init = F4(
	function (session, practice, shared, _v0) {
		var phoneInputOptions = function (opts) {
			return _Utils_update(
				opts,
				{Gh: true, aeW: false, agl: $author$project$Api$Common$Phone$Shared$Office, agy: true, nS: true, AU: 1});
		};
		return _Utils_Tuple2(
			{
				Gv: shared.Gv,
				RM: $elm$core$Maybe$Nothing,
				gr: A3($author$project$Components$PhoneInput$init, 'practice-fax', _List_Nil, phoneInputOptions),
				SD: $author$project$Utils$Form$init($author$project$Pages$PracticeSetup$Communications$initFormFields),
				Ij: $author$project$Shared$isHintAdmin(shared),
				gF: false,
				b6: A3($author$project$Components$PhoneInput$init, 'practice-phone', _List_Nil, phoneInputOptions),
				ZV: practice,
				aa4: session
			},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$PracticeSetup$Communications$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					Ij: $author$project$Shared$isHintAdmin(shared)
				}),
			A2($author$project$Utils$PracticeSetup$redirectIfOnboardingComplete, shared.aa4, shared.ahK));
	});
var $author$project$Pages$PracticeSetup$Communications$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$PracticeSetup$Communications$FaxInputMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$PracticeSetup$Communications$PhoneInputMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$PracticeSetup$Communications$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$PracticeSetup$Communications$PhoneInputMsg,
				$author$project$Components$PhoneInput$subscriptions(model.b6)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$PracticeSetup$Communications$FaxInputMsg,
				$author$project$Components$PhoneInput$subscriptions(model.gr))
			]));
};
var $author$project$Pages$PracticeSetup$Communications$GotResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$PracticeSetup$Communications$PortExistingNumbers = 1;
var $author$project$Api$CommunicationsSetup$communicationsSetupPath = function (basePath) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['communications_setup']),
		basePath);
};
var $author$project$Api$CommunicationsSetup$listDefaults = {HK: $elm$core$Maybe$Nothing, Zw: $elm$core$Maybe$Nothing};
var $author$project$Api$CommunicationsSetup$encodeRequest = function (optionals) {
	var options = optionals($author$project$Api$CommunicationsSetup$listDefaults);
	var encodePhoneOrFax = function (data) {
		return $elm$json$Json$Encode$object(
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							_Utils_Tuple2(
							'action',
							$elm$json$Json$Encode$string(data.Gg))
						]),
						A3($author$project$Utils$Encode$optional, 'area_code', $elm$json$Json$Encode$string, data.Gx),
						A3($author$project$Utils$Encode$optional, 'number', $elm$json$Json$Encode$string, data.IO)
					])));
	};
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'phone',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, encodePhoneOrFax, options.Zw))),
				_Utils_Tuple2(
				'fax',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, encodePhoneOrFax, options.HK)))
			]));
};
var $author$project$Api$CommunicationsSetup$create = F3(
	function (apiClient, query, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$CommunicationsSetup$encodeRequest(query),
				$author$project$Api$Data$requestTo(
					$author$project$Api$CommunicationsSetup$communicationsSetupPath($author$project$Api$Data$providerPath))));
	});
var $author$project$Api$CommunicationsSetup$FaxData = F3(
	function (action, area_code, number) {
		return {Gg: action, Gx: area_code, IO: number};
	});
var $author$project$Api$CommunicationsSetup$PhoneData = F3(
	function (action, area_code, number) {
		return {Gg: action, Gx: area_code, IO: number};
	});
var $author$project$Pages$PracticeSetup$Communications$createParams = F2(
	function (fields, model) {
		return function (d) {
			var phoneData = function () {
				var _v1 = fields.hg;
				if (!_v1) {
					return A3(
						$author$project$Api$CommunicationsSetup$PhoneData,
						'buy',
						$elm$core$Maybe$Just(fields.o8),
						$elm$core$Maybe$Nothing);
				} else {
					var phoneNumber = A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.IO;
							},
							A2(
								$elm$core$Maybe$andThen,
								$elm$core$List$head,
								$author$project$Components$PhoneInput$getPhones(model.b6))));
					return A3(
						$author$project$Api$CommunicationsSetup$PhoneData,
						'port',
						$elm$core$Maybe$Nothing,
						$elm$core$Maybe$Just(phoneNumber));
				}
			}();
			var faxData = function () {
				var _v0 = fields.jJ;
				if (!_v0) {
					return A3(
						$author$project$Api$CommunicationsSetup$FaxData,
						'buy',
						$elm$core$Maybe$Just(fields.nG),
						$elm$core$Maybe$Nothing);
				} else {
					var faxNumber = A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.IO;
							},
							A2(
								$elm$core$Maybe$andThen,
								$elm$core$List$head,
								$author$project$Components$PhoneInput$getPhones(model.gr))));
					return A3(
						$author$project$Api$CommunicationsSetup$FaxData,
						'port',
						$elm$core$Maybe$Nothing,
						$elm$core$Maybe$Just(faxNumber));
				}
			}();
			return _Utils_update(
				d,
				{
					HK: $elm$core$Maybe$Just(faxData),
					Zw: $elm$core$Maybe$Just(phoneData)
				});
		};
	});
var $author$project$Pages$PracticeSetup$Communications$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var option = field.a;
				return _Utils_update(
					fields,
					{hg: option});
			case 1:
				var areaCode = field.a;
				return _Utils_update(
					fields,
					{o8: areaCode});
			case 2:
				var option = field.a;
				return _Utils_update(
					fields,
					{jJ: option});
			default:
				var areaCode = field.a;
				return _Utils_update(
					fields,
					{nG: areaCode});
		}
	});
var $author$project$Pages$PracticeSetup$Communications$FaxAreaCodeValidation = 2;
var $author$project$Pages$PracticeSetup$Communications$FaxNumberValidation = 3;
var $author$project$Pages$PracticeSetup$Communications$validateNumber = F6(
	function (action, areaCode, phoneInput, areaCodeValidation, numberValidation, numberType) {
		if (!action) {
			return (!$elm$core$String$length(
				A2($elm$core$String$filter, $elm$core$Char$isDigit, areaCode))) ? _List_fromArray(
				[
					_Utils_Tuple2(areaCodeValidation, 'You must enter a preferred area code for ' + (numberType + '.'))
				]) : (($elm$core$String$length(
				A2($elm$core$String$filter, $elm$core$Char$isDigit, areaCode)) !== 3) ? _List_fromArray(
				[
					_Utils_Tuple2(areaCodeValidation, 'Area code must be exactly 3 digits.')
				]) : _List_Nil);
		} else {
			if ($author$project$Components$PhoneInput$hasErrors(phoneInput)) {
				return _List_fromArray(
					[
						_Utils_Tuple2(numberValidation, 'Please enter a valid ' + (numberType + ' number.'))
					]);
			} else {
				var number = A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.IO;
						},
						A2(
							$elm$core$Maybe$andThen,
							$elm$core$List$head,
							$author$project$Components$PhoneInput$getPhones(phoneInput))));
				return (!$elm$core$String$length(number)) ? _List_fromArray(
					[
						_Utils_Tuple2(numberValidation, 'You must enter a ' + (numberType + ' number to port.'))
					]) : _List_Nil;
			}
		}
	});
var $author$project$Pages$PracticeSetup$Communications$validateFax = F2(
	function (model, fields) {
		return A6($author$project$Pages$PracticeSetup$Communications$validateNumber, fields.jJ, fields.nG, model.gr, 2, 3, 'fax');
	});
var $author$project$Pages$PracticeSetup$Communications$PhoneAreaCodeValidation = 0;
var $author$project$Pages$PracticeSetup$Communications$PhoneNumberValidation = 1;
var $author$project$Pages$PracticeSetup$Communications$validatePhone = F2(
	function (model, fields) {
		return A6($author$project$Pages$PracticeSetup$Communications$validateNumber, fields.hg, fields.o8, model.b6, 0, 1, 'phone');
	});
var $author$project$Pages$PracticeSetup$Communications$formFieldsValidator = function (model) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Pages$PracticeSetup$Communications$validatePhone(model)),
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Pages$PracticeSetup$Communications$validateFax(model))
			]));
};
var $author$project$Pages$PracticeSetup$Communications$navigateToLegal = A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Legal);
var $author$project$Pages$PracticeSetup$Communications$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var _v1 = A2(
					$author$project$Utils$Form$validate,
					$author$project$Pages$PracticeSetup$Communications$formFieldsValidator(model),
					model.SD);
				if (!_v1.$) {
					var _v2 = _v1.a;
					var newForm = _v2.a;
					var validFormFields = _v2.b;
					var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
					var _v3 = fields.hg;
					if (!_v3) {
						var cmd = A3(
							$author$project$Api$CommunicationsSetup$create,
							model.Gv,
							A2($author$project$Pages$PracticeSetup$Communications$createParams, fields, model),
							$author$project$Pages$PracticeSetup$Communications$GotResponse);
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{RM: $elm$core$Maybe$Nothing, SD: newForm, gF: true}),
							cmd,
							_List_Nil);
					} else {
						var cmd = A3(
							$author$project$Api$CommunicationsSetup$create,
							model.Gv,
							A2($author$project$Pages$PracticeSetup$Communications$createParams, fields, model),
							$author$project$Pages$PracticeSetup$Communications$GotResponse);
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{RM: $elm$core$Maybe$Nothing, SD: newForm, gF: true}),
							cmd,
							_List_Nil);
					}
				} else {
					var newForm = _v1.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{SD: newForm}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 2:
				var response = msg.a;
				switch (response.$) {
					case 3:
						var fields = $author$project$Utils$Form$fields(model.SD);
						var isFaxPorting = fields.jJ === 1;
						var isPhonePorting = fields.hg === 1;
						var portingType = function () {
							var _v6 = _Utils_Tuple2(isPhonePorting, isFaxPorting);
							if (_v6.a) {
								if (_v6.b) {
									return $elm$core$Maybe$Just('phone, fax');
								} else {
									return $elm$core$Maybe$Just('phone');
								}
							} else {
								if (_v6.b) {
									return $elm$core$Maybe$Just('fax');
								} else {
									return $elm$core$Maybe$Nothing;
								}
							}
						}();
						var logPortingEventCmd = function () {
							if (!portingType.$) {
								var typeValue = portingType.a;
								return A2(
									$author$project$Utils$Analytics$Shared$logSimpleEvent,
									'self onboarding phone port requested',
									_List_fromArray(
										[
											A2($author$project$Utils$Analytics$Shared$property, 'type', typeValue)
										]));
							} else {
								return $elm$core$Platform$Cmd$none;
							}
						}();
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{RM: $elm$core$Maybe$Nothing, gF: false}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[$author$project$Pages$PracticeSetup$Communications$navigateToLegal, logPortingEventCmd])),
							_List_Nil);
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									RM: $elm$core$Maybe$Just(
										$author$project$Api$Data$errorToString(error)),
									gF: false
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					default:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{gF: false}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
				}
			case 1:
				var field = msg.a;
				var form = A3($author$project$Utils$Form$update, $author$project$Pages$PracticeSetup$Communications$formFieldsUpdate, field, model.SD);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: form}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var subMsg = msg.a;
				var _v7 = A2($author$project$Components$PhoneInput$update, subMsg, model.b6);
				var phoneInput = _v7.a;
				var phoneCmd = _v7.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{b6: phoneInput}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$PracticeSetup$Communications$PhoneInputMsg, phoneCmd),
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v8 = A2($author$project$Components$PhoneInput$update, subMsg, model.gr);
				var faxInput = _v8.a;
				var faxCmd = _v8.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{gr: faxInput}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$PracticeSetup$Communications$FaxInputMsg, faxCmd),
					_List_Nil);
		}
	});
var $author$project$Pages$PracticeSetup$Communications$FormSubmitted = {$: 0};
var $author$project$Ui$Alert$m0 = $author$project$Ui$Alert$Attrs(
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('m-0')
		]));
var $author$project$Pages$PracticeSetup$Communications$SetFaxAction = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$PracticeSetup$Communications$SetFaxAreaCode = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$PracticeSetup$Communications$FormUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$PracticeSetup$Communications$areaCodeInput = function (config) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(4),
				$author$project$Ui$Form$Group$required(true),
				$author$project$Ui$Form$Group$label('Area Code')
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$value(config.xo),
						$author$project$Ui$Form$Input$onInput(
						function (str) {
							return $author$project$Pages$PracticeSetup$Communications$FormUpdated(
								config.BW(str));
						}),
						$author$project$Ui$Form$Input$maxLength(3),
						$author$project$Ui$Form$Input$placeholder('000'),
						$author$project$Ui$Form$Input$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, config.rm, config.SD))
					])),
				A2(
				$author$project$Ui$Typography$text,
				_List_fromArray(
					[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
				'Enter a 3-digit area code to use for any new numbers.'),
				$author$project$Utils$FormErrors$view(
				A2($author$project$Utils$Form$validationErrors, config.rm, config.SD))
			]));
};
var $author$project$Pages$PracticeSetup$Communications$existingNumberInput = function (config) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(5),
				$author$project$Ui$Form$Group$required(true),
				$author$project$Ui$Form$Group$label('Existing ' + (config.aih + ' Number'))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				config.Db,
				$author$project$Components$PhoneInput$view(config.b6)),
				$author$project$Utils$FormErrors$view(
				A2($author$project$Utils$Form$validationErrors, config.BT, config.SD))
			]));
};
var $author$project$Pages$PracticeSetup$Communications$viewOptions = function (config) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(3),
						$author$project$Ui$Form$Group$inputSpanSm(9),
						$author$project$Ui$Form$Group$label(config.aih)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$row,
						_List_fromArray(
							[$author$project$Ui$Grid$mt2]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanSm(3)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Radio$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Radio$value(!config.m2),
												$author$project$Ui$Form$Radio$onCheck(
												function (_v0) {
													return $author$project$Pages$PracticeSetup$Communications$FormUpdated(
														config.to(0));
												})
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Get a New Number')
											]))
									])),
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanSm(6)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Radio$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Radio$value(config.m2 === 1),
												$author$project$Ui$Form$Radio$onCheck(
												function (_v1) {
													return $author$project$Pages$PracticeSetup$Communications$FormUpdated(
														config.to(1));
												})
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Port an Existing Number')
											]))
									]))
							]))
					])),
				(!config.m2) ? $author$project$Pages$PracticeSetup$Communications$areaCodeInput(config) : $author$project$Pages$PracticeSetup$Communications$existingNumberInput(config)
			]));
};
var $author$project$Pages$PracticeSetup$Communications$viewFaxOptions = F2(
	function (model, fields) {
		return $author$project$Pages$PracticeSetup$Communications$viewOptions(
			{xo: fields.nG, rm: 2, m2: fields.jJ, SD: model.SD, aih: 'Fax', BT: 3, to: $author$project$Pages$PracticeSetup$Communications$SetFaxAction, BW: $author$project$Pages$PracticeSetup$Communications$SetFaxAreaCode, b6: model.gr, Db: $author$project$Pages$PracticeSetup$Communications$FaxInputMsg});
	});
var $author$project$Pages$PracticeSetup$Communications$SetPhoneAction = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$PracticeSetup$Communications$SetPhoneAreaCode = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$PracticeSetup$Communications$viewPhoneOptions = F2(
	function (model, fields) {
		return $author$project$Pages$PracticeSetup$Communications$viewOptions(
			{xo: fields.o8, rm: 0, m2: fields.hg, SD: model.SD, aih: 'Phone', BT: 1, to: $author$project$Pages$PracticeSetup$Communications$SetPhoneAction, BW: $author$project$Pages$PracticeSetup$Communications$SetPhoneAreaCode, b6: model.b6, Db: $author$project$Pages$PracticeSetup$Communications$PhoneInputMsg});
	});
var $author$project$Pages$PracticeSetup$Communications$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Set up your practice phone & fax')
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$muted]),
								_List_fromArray(
									[
										$elm$html$Html$text('If you\'re getting a new number, we\'ll assign it right away based upon the area code that you enter. If you\'re porting, your onboarding manager will follow up with next steps. If you\'re porting multiple numbers, just enter your main practice number here.')
									]))
							])),
						function () {
						var fields = $author$project$Utils$Form$fields(model.SD);
						return A2(
							$author$project$Ui$Panel$body,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$Pages$PracticeSetup$Communications$viewPhoneOptions, model, fields),
									$author$project$Utils$Html$noBreakSpace,
									A2($author$project$Pages$PracticeSetup$Communications$viewFaxOptions, model, fields),
									function () {
									var _v0 = model.RM;
									if (!_v0.$) {
										var error = _v0.a;
										return A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$mt2]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Alert$danger,
													_List_fromArray(
														[$author$project$Ui$Alert$m0]),
													_List_fromArray(
														[
															$elm$html$Html$text(error)
														]))
												]));
									} else {
										return $elm$html$Html$text('');
									}
								}(),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$flex, $author$project$Ui$Element$justifyRight]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$mt2]),
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Button$view,
													{mm: 'Next'},
													_List_fromArray(
														[
															$author$project$Ui$Button$primary,
															$author$project$Ui$Button$onClick($author$project$Pages$PracticeSetup$Communications$FormSubmitted),
															$author$project$Ui$Button$loading(model.gF)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Next')
														]))
												]))
										]))
								]));
					}()
					]))
			]),
		ac9: 'Admin Setup'
	};
};
var $author$project$Pages$PracticeSetup$Communications$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$PracticeSetup$Communications$init, aiq: $author$project$Pages$PracticeSetup$Communications$load, k8: $author$project$Pages$PracticeSetup$Communications$save, alO: $author$project$Pages$PracticeSetup$Communications$subscriptions, adT: $author$project$Pages$PracticeSetup$Communications$update, amo: $author$project$Pages$PracticeSetup$Communications$view});
var $author$project$Pages$PracticeSetup$Complete$GotDefaultSignupPage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$PracticeSetup$Complete$GotPractice = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$PracticeSetup$Complete$fetchPractice = function (apiClient) {
	return A3($author$project$Api$Provider$Practice$retrieve, apiClient, $elm$core$Basics$identity, $author$project$Pages$PracticeSetup$Complete$GotPractice);
};
var $author$project$Pages$PracticeSetup$Complete$init = F4(
	function (_v0, _v1, shared, _v2) {
		return _Utils_Tuple2(
			{
				Gv: shared.Gv,
				Qb: $elm$core$Maybe$Nothing,
				sF: shared.sF,
				Ij: $author$project$Shared$isHintAdmin(shared),
				ZV: $author$project$Api$Data$Loading
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Api$Provider$SignupPage$getDefault, shared.Gv, $author$project$Pages$PracticeSetup$Complete$GotDefaultSignupPage),
						$author$project$Pages$PracticeSetup$Complete$fetchPractice(shared.Gv)
					])));
	});
var $author$project$Pages$PracticeSetup$Complete$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$PracticeSetup$Complete$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$PracticeSetup$Complete$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$OutMsg$RefreshSession = {$: 4};
var $author$project$Pages$PracticeSetup$Complete$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(
					model,
					A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Patients__Top),
					_List_fromArray(
						[
							$author$project$OutMsg$PracticeUpdated(model.ZV)
						]));
			case 1:
				var response = msg.a;
				if (response.$ === 3) {
					var signupPages = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Qb: $elm$core$List$head(signupPages)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$reportDecodeError(response));
				}
			case 2:
				var url = msg.a;
				return _Utils_Tuple3(
					model,
					$author$project$Ports$Clipboard$copy(url),
					_List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 3, 'Copied signup url to clipboard')
						]));
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ZV: response}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[$author$project$OutMsg$RefreshSession]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$PracticeSetup$Complete$Completed = {$: 0};
var $author$project$Ui$Image$OnboardingComplete = 14;
var $author$project$Ui$Grid$rowItemsJustifySpaceBetween = $author$project$Ui$Grid$RowElement($author$project$Ui$Element$spaceBetween);
var $author$project$Pages$PracticeSetup$Complete$CopyToClipboard = function (a) {
	return {$: 2, a: a};
};
var $author$project$Utils$Phone$displayPhoneNumber = F2(
	function (region, number_) {
		if (!region) {
			return $author$project$Formatters$Phone$format(number_);
		} else {
			return number_;
		}
	});
var $author$project$Utils$Phone$displayPhone = function (phoneInfo) {
	return A2(
		$author$project$Utils$Phone$displayPhoneNumber,
		phoneInfo.Kl ? 0 : 1,
		phoneInfo.IO);
};
var $author$project$Pages$PracticeSetup$Complete$practicePhone = function (practice) {
	return $elm$core$List$head(
		$author$project$Api$Provider$Practice$One$phones(practice));
};
var $author$project$Pages$PracticeSetup$Complete$viewPracticePhone = function (practice) {
	var _v0 = $author$project$Pages$PracticeSetup$Complete$practicePhone(practice);
	if (!_v0.$) {
		var phone = _v0.a;
		var formattedNumber = $author$project$Utils$Phone$displayPhone(
			{
				IO: A2(
					$elm$core$Maybe$withDefault,
					'',
					$author$project$Api$Common$Phone$Shared$number(phone)),
				Kl: $author$project$Api$Common$Phone$Shared$usFormattable(phone)
			});
		return A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Your practice phone number: '),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$inline, $author$project$Ui$Element$gap]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$tel,
							formattedNumber,
							_List_fromArray(
								[$author$project$Ui$Link$targetBlank]),
							_List_fromArray(
								[
									$elm$html$Html$text(formattedNumber)
								])),
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Copy Practice Phone Number'},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$icon($author$project$Ui$Icon$copy),
									$author$project$Ui$Button$onClick(
									$author$project$Pages$PracticeSetup$Complete$CopyToClipboard(formattedNumber))
								]),
							_List_Nil)
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$PracticeSetup$Complete$viewSkeletonText = A2(
	$author$project$Ui$Element$view,
	_List_fromArray(
		[$author$project$Ui$Element$mb3]),
	_List_fromArray(
		[
			$author$project$Ui$Skeleton$text(
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$block,
					$author$project$Ui$Skeleton$span(10)
				]))
		]));
var $author$project$Pages$PracticeSetup$Complete$viewSignupPageUrl = function (maybeSignupPage) {
	if (!maybeSignupPage.$) {
		var signupPage = maybeSignupPage.a;
		var signupUrl = $author$project$Api$Provider$SignupPage$All$baseUrl(signupPage);
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mb3, $author$project$Ui$Element$gap]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Link$externalHref,
					signupUrl,
					_List_fromArray(
						[$author$project$Ui$Link$targetBlank]),
					_List_fromArray(
						[
							$elm$html$Html$text(signupUrl)
						])),
					A3(
					$author$project$Ui$Button$view,
					{mm: 'Copy Signup URL'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$icon($author$project$Ui$Icon$copy),
							$author$project$Ui$Button$onClick(
							$author$project$Pages$PracticeSetup$Complete$CopyToClipboard(signupUrl))
						]),
					_List_Nil)
				]));
	} else {
		return $author$project$Pages$PracticeSetup$Complete$viewSkeletonText;
	}
};
var $author$project$Pages$PracticeSetup$Complete$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$row,
				_List_fromArray(
					[$author$project$Ui$Grid$rowItemsCenter, $author$project$Ui$Grid$rowItemsJustifySpaceBetween]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanSm(12),
								$author$project$Ui$Grid$justifyCenter
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$textLeft, $author$project$Ui$Element$mb2]),
								_List_fromArray(
									[
										$author$project$Ui$Typography$heading(
										_List_fromArray(
											[
												$elm$html$Html$text('Congratulations on setting up your account! What\'s next?')
											]))
									])),
								A2(
								$author$project$Ui$Grid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$spanSm(6),
												$author$project$Ui$Grid$justifyLeft
											]),
										_List_fromArray(
											[
												A4(
												$author$project$Ui$Image$view,
												model.sF,
												{LD: 'Congratulations illustration showing completed setup'},
												_List_Nil,
												14)
											])),
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$spanSm(6),
												$author$project$Ui$Grid$justifyLeft
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$fontBold]),
												_List_fromArray(
													[
														$elm$html$Html$text('Patients can now signup with your practice')
													])),
												A2(
												$elm$html$Html$ul,
												_List_Nil,
												function () {
													var signupItems = function () {
														var _v1 = model.Qb;
														if (!_v1.$) {
															return _List_fromArray(
																[
																	A2(
																	$author$project$Ui$Typography$span,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$author$project$Pages$PracticeSetup$Complete$viewSignupPageUrl(model.Qb)
																		]))
																]);
														} else {
															return _List_fromArray(
																[$author$project$Pages$PracticeSetup$Complete$viewSkeletonText]);
														}
													}();
													var practiceItems = function () {
														var _v0 = model.ZV;
														if (_v0.$ === 3) {
															var practice = _v0.a;
															return _List_fromArray(
																[
																	$author$project$Pages$PracticeSetup$Complete$viewPracticePhone(practice)
																]);
														} else {
															return _List_Nil;
														}
													}();
													return A2(
														$elm$core$List$cons,
														A2(
															$elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	$author$project$Ui$Element$view,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Use the following link to sign-up for your practice. We recommend posting this on your website:')
																		]))
																])),
														_Utils_ap(signupItems, practiceItems));
												}()),
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$mt4]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$text,
														_List_fromArray(
															[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$bold]),
														'Expect an email from your onboarding manager within 2 business days')
													])),
												A2(
												$elm$html$Html$ul,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$li,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Typography$p,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('You will receive emails from your onboarding manager at '),
																		A3(
																		$author$project$Ui$Link$mailto,
																		'onboarding@hint.com',
																		_List_fromArray(
																			[$author$project$Ui$Link$targetBlank]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text('onboarding@hint.com')
																			])),
																		$elm$html$Html$text('.')
																	]))
															]))
													])),
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$mt4]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$text,
														_List_fromArray(
															[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$bold]),
														'Complete your onboarding checklist')
													])),
												A2(
												$elm$html$Html$ul,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$li,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Typography$p,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('After clicking \'Next,\' you will see an onboarding checklist with additional next steps.')
																	]))
															]))
													])),
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$mt4]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$text,
														_List_fromArray(
															[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$bold]),
														'Learn more on Hint Community')
													])),
												A2(
												$elm$html$Html$ul,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$li,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Typography$p,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('You now have access to '),
																		A3(
																		$author$project$Ui$Link$externalHref,
																		'https://community.hint.com/c/account-configuration?automatic_login=true',
																		_List_fromArray(
																			[
																				$author$project$Ui$Link$targetBlank,
																				$author$project$Ui$Link$test('help-community')
																			]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text('Hint Community')
																			])),
																		$elm$html$Html$text('! View resources on how to jumpstart your Hint Experience!')
																	]))
															]))
													]))
											]))
									])),
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$textRight]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Next'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$loading(false),
												$author$project$Ui$Button$submit,
												$author$project$Ui$Button$onClick($author$project$Pages$PracticeSetup$Complete$Completed)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Next')
											]))
									]))
							]))
					]))
			]),
		ac9: 'Practice Setup'
	};
};
var $author$project$Pages$PracticeSetup$Complete$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$PracticeSetup$Complete$init, aiq: $author$project$Pages$PracticeSetup$Complete$load, k8: $author$project$Pages$PracticeSetup$Complete$save, alO: $author$project$Pages$PracticeSetup$Complete$subscriptions, adT: $author$project$Pages$PracticeSetup$Complete$update, amo: $author$project$Pages$PracticeSetup$Complete$view});
var $author$project$Pages$PracticeSetup$Documents$DocumentFormMsg = $elm$core$Basics$identity;
var $author$project$Pages$PracticeSetup$Documents$init = F4(
	function (session, practice, shared, _v0) {
		var _v1 = A5(
			$author$project$Components$Admin$Documents$Form$init,
			shared.Gv,
			session,
			$elm$core$Maybe$Nothing,
			practice,
			{bb: true});
		var form = _v1.a;
		var cmd = _v1.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, SD: form},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
	});
var $author$project$Pages$PracticeSetup$Documents$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			model,
			A2($author$project$Utils$PracticeSetup$redirectIfOnboardingComplete, shared.aa4, shared.ahK));
	});
var $author$project$Pages$PracticeSetup$Documents$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$PracticeSetup$Documents$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Admin$Documents$Form$subscriptions(model.SD));
};
var $author$project$Pages$PracticeSetup$Documents$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Admin$Documents$Form$update, model.Gv, subMsg, model.SD);
		var form = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{SD: form}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Pages$PracticeSetup$Documents$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Admin$Documents$Form$view(model.SD))
			]),
		ac9: 'Practice Setup'
	};
};
var $author$project$Pages$PracticeSetup$Documents$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$PracticeSetup$Documents$init, aiq: $author$project$Pages$PracticeSetup$Documents$load, k8: $author$project$Pages$PracticeSetup$Documents$save, alO: $author$project$Pages$PracticeSetup$Documents$subscriptions, adT: $author$project$Pages$PracticeSetup$Documents$update, amo: $author$project$Pages$PracticeSetup$Documents$view});
var $author$project$Pages$PracticeSetup$Legal$AddressInputMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$PracticeSetup$Legal$initFormFields = function () {
	var _v0 = $author$project$Components$AddressInput$init('practice-legal-address');
	var addressInput = _v0.a;
	var addressInputCmd = _v0.b;
	return _Utils_Tuple2(
		{Q9: $elm$core$Maybe$Nothing, ain: addressInput, VU: $elm$core$Maybe$Nothing},
		A2($elm$core$Platform$Cmd$map, $author$project$Pages$PracticeSetup$Legal$AddressInputMsg, addressInputCmd));
}();
var $author$project$Pages$PracticeSetup$Legal$init = F4(
	function (session, practice, shared, _v0) {
		var _v1 = $author$project$Pages$PracticeSetup$Legal$initFormFields;
		var formFields = _v1.a;
		var formFieldsCmd = _v1.b;
		var form = $author$project$Utils$Form$init(formFields);
		return _Utils_Tuple2(
			{Gv: shared.Gv, SD: form, ZV: practice, aa4: session},
			formFieldsCmd);
	});
var $author$project$Pages$PracticeSetup$Legal$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			model,
			A2($author$project$Utils$PracticeSetup$redirectIfOnboardingComplete, shared.aa4, shared.ahK));
	});
var $author$project$Pages$PracticeSetup$Legal$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$PracticeSetup$Legal$subscriptions = function (model) {
	var _v0 = $author$project$Utils$Form$fields(model.SD);
	var legalAddress = _v0.ain;
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$PracticeSetup$Legal$AddressInputMsg,
		$author$project$Components$AddressInput$subscriptions(legalAddress));
};
var $author$project$Pages$PracticeSetup$Legal$GotResponse = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$PracticeSetup$Legal$LegalAddress = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$PracticeBusinessProfile$practiceBusinessProfilePath = function (basePath) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['practice_business_profile']),
		basePath);
};
var $author$project$Api$Provider$PracticeBusinessProfile$create = F3(
	function (apiClient, fields, toMsg) {
		var addressField = function () {
			var _v0 = fields.ain;
			if (!_v0.$) {
				var address_ = _v0.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'legal_address',
						$author$project$Api$Common$Address$Shared$encode(address_))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practice_business_profile',
					$elm$json$Json$Encode$object(
						$elm$core$List$concat(
							_List_fromArray(
								[
									A3($author$project$Utils$Encode$optional, 'legal_name', $elm$json$Json$Encode$string, fields.VU),
									A3($author$project$Utils$Encode$optional, 'ein', $elm$json$Json$Encode$string, fields.Q9),
									addressField
								]))))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$PracticeBusinessProfile$practiceBusinessProfilePath($author$project$Api$Data$providerPath))));
	});
var $author$project$Pages$PracticeSetup$Legal$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						VU: $elm$core$Maybe$Just(string)
					});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Q9: $author$project$Utils$String$toMaybe(string)
					});
			default:
				var address = field.a;
				return _Utils_update(
					fields,
					{ain: address});
		}
	});
var $author$project$Pages$PracticeSetup$Legal$EinValidation = 0;
var $author$project$Pages$PracticeSetup$Legal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Form$Ein$ifInvalid,
			function ($) {
				return $.Q9;
			},
			_Utils_Tuple2(0, 'Please enter a valid EIN or leave empty'))
		]));
var $author$project$Pages$PracticeSetup$Legal$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var form = A3($author$project$Utils$Form$update, $author$project$Pages$PracticeSetup$Legal$formFieldsUpdate, field, model.SD);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: form}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var subMsg = msg.a;
				var _v1 = $author$project$Utils$Form$fields(model.SD);
				var legalAddress = _v1.ain;
				var _v2 = A2($author$project$Components$AddressInput$update, subMsg, legalAddress);
				var addressInputModel = _v2.a;
				var addressInputCmd = _v2.b;
				var outMsgs = _v2.c;
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Pages$PracticeSetup$Legal$formFieldsUpdate,
					$author$project$Pages$PracticeSetup$Legal$LegalAddress(addressInputModel),
					model.SD);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: newForm}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$PracticeSetup$Legal$AddressInputMsg, addressInputCmd),
					outMsgs);
			case 2:
				var _v3 = A2($author$project$Utils$Form$validate, $author$project$Pages$PracticeSetup$Legal$formFieldsValidator, model.SD);
				if (!_v3.$) {
					var _v4 = _v3.a;
					var newForm = _v4.a;
					var validFormFields = _v4.b;
					var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
					var legalAddress = $author$project$Components$AddressInput$getAddress(fields.ain);
					var hasAnyAddressField = A2(
						$elm$core$List$any,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								!_Utils_eq(legalAddress.rE, $elm$core$Maybe$Nothing),
								!_Utils_eq(legalAddress.rK, $elm$core$Maybe$Nothing),
								!_Utils_eq(legalAddress.s$, $elm$core$Maybe$Nothing),
								!_Utils_eq(legalAddress.AD, $elm$core$Maybe$Nothing),
								!_Utils_eq(legalAddress.uP, $elm$core$Maybe$Nothing),
								!_Utils_eq(legalAddress.vv, $elm$core$Maybe$Nothing)
							]));
					var legalName = fields.VU;
					var ein = fields.Q9;
					var cmd = A3(
						$author$project$Api$Provider$PracticeBusinessProfile$create,
						model.Gv,
						{
							Q9: ein,
							ain: hasAnyAddressField ? $elm$core$Maybe$Just(
								{rE: legalAddress.rE, rK: legalAddress.rK, s$: legalAddress.s$, AD: legalAddress.AD, uP: legalAddress.uP, vv: legalAddress.vv}) : $elm$core$Maybe$Nothing,
							VU: legalName
						},
						$author$project$Pages$PracticeSetup$Legal$GotResponse);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{SD: newForm}),
						cmd,
						_List_Nil);
				} else {
					var newForm = _v3.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{SD: newForm}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						A2($author$project$Utils$Route$navigateAndReload, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__PaymentProcessing),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$PracticeSetup$Legal$Ein = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$PracticeSetup$Legal$FormSubmitted = {$: 2};
var $author$project$Pages$PracticeSetup$Legal$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$PracticeSetup$Legal$LegalName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$Ein$Placeholder = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Form$Ein$placeholder = $author$project$Ui$Form$Ein$Placeholder;
var $author$project$Pages$PracticeSetup$Legal$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Verify your business information')
									]))
							])),
						function () {
						var fields = $author$project$Utils$Form$fields(model.SD);
						return A2(
							$author$project$Ui$Panel$body,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$muted]),
									_List_fromArray(
										[
											$elm$html$Html$text('This information should be used to verify your business when necessary for services including phone registration for fax and text messages, eRX, payment processing, and more.')
										])),
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$muted]),
									_List_fromArray(
										[
											$elm$html$Html$text('All information should match your IRS SS-4 form or there may be delays in activating some features on your account. If you have not yet registered your business with the IRS, leave this information blank.')
										])),
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$labelSpanSm(3),
											$author$project$Ui$Form$Group$inputSpanSm(9),
											$author$project$Ui$Form$Group$label('Legal Business Name')
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$value(
													A2($elm$core$Maybe$withDefault, '', fields.VU)),
													$author$project$Ui$Form$Input$onInput(
													function (name) {
														return $author$project$Pages$PracticeSetup$Legal$FormUpdated(
															$author$project$Pages$PracticeSetup$Legal$LegalName(name));
													}),
													$author$project$Ui$Form$Input$placeholder('Legal name from IRS SS-4 Form')
												]))
										])),
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$labelSpanSm(3),
											$author$project$Ui$Form$Group$inputSpanSm(9),
											$author$project$Ui$Form$Group$label('EIN')
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$Ein$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$Ein$value(fields.Q9),
													$author$project$Ui$Form$Ein$onInput(
													A2($elm$core$Basics$composeL, $author$project$Pages$PracticeSetup$Legal$FormUpdated, $author$project$Pages$PracticeSetup$Legal$Ein)),
													$author$project$Ui$Form$Ein$invalid(
													A2($author$project$Utils$Form$hasValidationErrors, 0, model.SD)),
													$author$project$Ui$Form$Ein$errors(
													A2($author$project$Utils$Form$validationErrors, 0, model.SD)),
													$author$project$Ui$Form$Ein$placeholder('12-3456789')
												]))
										])),
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$labelSpanSm(3),
											$author$project$Ui$Form$Group$inputSpanSm(9),
											$author$project$Ui$Form$Group$label('Legal Address')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$map,
											$author$project$Pages$PracticeSetup$Legal$AddressInputMsg,
											A2($author$project$Components$AddressInput$view, _List_Nil, fields.ain))
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$flex, $author$project$Ui$Element$justifyRight]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$mt2]),
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Button$view,
													{mm: 'Next'},
													_List_fromArray(
														[
															$author$project$Ui$Button$primary,
															$author$project$Ui$Button$onClick($author$project$Pages$PracticeSetup$Legal$FormSubmitted)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Next')
														]))
												]))
										]))
								]));
					}()
					]))
			]),
		ac9: 'Practice Setup - Legal Information'
	};
};
var $author$project$Pages$PracticeSetup$Legal$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$PracticeSetup$Legal$init, aiq: $author$project$Pages$PracticeSetup$Legal$load, k8: $author$project$Pages$PracticeSetup$Legal$save, alO: $author$project$Pages$PracticeSetup$Legal$subscriptions, adT: $author$project$Pages$PracticeSetup$Legal$update, amo: $author$project$Pages$PracticeSetup$Legal$view});
var $author$project$Pages$PracticeSetup$PaymentProcessing$PaymentProcessing = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$PracticeSetup$PaymentProcessing$PaymentProcessingMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$PracticeSetup$PaymentProcessing$Stripe = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$PracticeSetup$PaymentProcessing$StripeMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$PracticeSetup$PaymentProcessing$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.DE;
		var _v1 = function () {
			if ($author$project$Api$Provider$Practice$One$paymentProcessor(practice) === 'rainforest') {
				var _v2 = A5(
					$author$project$Components$PaymentProcessing$init,
					session,
					practice,
					shared,
					query,
					{bb: true});
				var paymentProcessing = _v2.a;
				var paymentProcessingCmd = _v2.b;
				return _Utils_Tuple2(
					$author$project$Pages$PracticeSetup$PaymentProcessing$PaymentProcessing(paymentProcessing),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$PracticeSetup$PaymentProcessing$PaymentProcessingMsg, paymentProcessingCmd));
			} else {
				var _v3 = A5(
					$author$project$Components$Stripe$init,
					session,
					practice,
					shared,
					query,
					{bb: true});
				var stripe = _v3.a;
				var stripeCmd = _v3.b;
				return _Utils_Tuple2(
					$author$project$Pages$PracticeSetup$PaymentProcessing$Stripe(stripe),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$PracticeSetup$PaymentProcessing$StripeMsg, stripeCmd));
			}
		}();
		var paymentProcessor = _v1.a;
		var paymentProcessorCmd = _v1.b;
		return _Utils_Tuple2(
			{
				Gv: shared.Gv,
				Ij: $author$project$Shared$isHintAdmin(shared),
				Zd: paymentProcessor
			},
			paymentProcessorCmd);
	});
var $author$project$Pages$PracticeSetup$PaymentProcessing$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					Ij: $author$project$Shared$isHintAdmin(shared)
				}),
			A2($author$project$Utils$PracticeSetup$redirectIfOnboardingComplete, shared.aa4, shared.ahK));
	});
var $author$project$Pages$PracticeSetup$PaymentProcessing$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$PracticeSetup$PaymentProcessing$subscriptions = function (model) {
	var _v0 = model.Zd;
	if (_v0.$ === 1) {
		var paymentProcessing = _v0.a;
		return A2(
			$elm$core$Platform$Sub$map,
			$author$project$Pages$PracticeSetup$PaymentProcessing$PaymentProcessingMsg,
			$author$project$Components$PaymentProcessing$subscriptions(paymentProcessing));
	} else {
		var stripe = _v0.a;
		return A2(
			$elm$core$Platform$Sub$map,
			$author$project$Pages$PracticeSetup$PaymentProcessing$StripeMsg,
			$author$project$Components$Stripe$subscriptions(stripe));
	}
};
var $author$project$Pages$PracticeSetup$PaymentProcessing$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var subMsg = msg.a;
			var _v1 = model.Zd;
			if (!_v1.$) {
				var stripe = _v1.a;
				var _v2 = A3($author$project$Components$Stripe$update, subMsg, stripe, model.Gv);
				var newStripe = _v2.a;
				var stripeCmd = _v2.b;
				var outMsgs = _v2.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							Zd: $author$project$Pages$PracticeSetup$PaymentProcessing$Stripe(newStripe)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$PracticeSetup$PaymentProcessing$StripeMsg, stripeCmd),
					outMsgs);
			} else {
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
			}
		} else {
			var subMsg = msg.a;
			var _v3 = model.Zd;
			if (_v3.$ === 1) {
				var paymentProcessing = _v3.a;
				var _v4 = A3($author$project$Components$PaymentProcessing$update, subMsg, paymentProcessing, model.Gv);
				var newPaymentProcessing = _v4.a;
				var paymentProcessingCmd = _v4.b;
				var outMsgs = _v4.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							Zd: $author$project$Pages$PracticeSetup$PaymentProcessing$PaymentProcessing(newPaymentProcessing)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$PracticeSetup$PaymentProcessing$PaymentProcessingMsg, paymentProcessingCmd),
					outMsgs);
			} else {
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
			}
		}
	});
var $author$project$Pages$PracticeSetup$PaymentProcessing$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				function () {
				var _v0 = model.Zd;
				if (_v0.$ === 1) {
					var paymentProcessing = _v0.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$PracticeSetup$PaymentProcessing$PaymentProcessingMsg,
						$author$project$Components$PaymentProcessing$view(paymentProcessing));
				} else {
					var stripe = _v0.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$PracticeSetup$PaymentProcessing$StripeMsg,
						$author$project$Components$Stripe$view(stripe));
				}
			}()
			]),
		ac9: 'Practice Setup'
	};
};
var $author$project$Pages$PracticeSetup$PaymentProcessing$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$PracticeSetup$PaymentProcessing$init, aiq: $author$project$Pages$PracticeSetup$PaymentProcessing$load, k8: $author$project$Pages$PracticeSetup$PaymentProcessing$save, alO: $author$project$Pages$PracticeSetup$PaymentProcessing$subscriptions, adT: $author$project$Pages$PracticeSetup$PaymentProcessing$update, amo: $author$project$Pages$PracticeSetup$PaymentProcessing$view});
var $author$project$Pages$PracticeSetup$Plans$ListMsg = $elm$core$Basics$identity;
var $author$project$Pages$PracticeSetup$Plans$init = F4(
	function (session, practice, shared, params) {
		var _v0 = $author$project$Components$Admin$Plans$List$init(shared.Gv)(session)(
			$author$project$Api$Platform$User$Shared$isAdmin(
				$author$project$Api$Platform$Session$One$user(session)))(
			_List_fromArray(
				[2, 3]))($author$project$Spa$Generated$Route$Admin__Plans__Top)($author$project$Spa$Generated$Route$Admin__Plans__New)($author$project$Spa$Generated$Route$Admin__Plans__Id_String)(
			_List_fromArray(
				[
					$elm$html$Html$text('To edit or add more plans later, you can go to Admin → Membership Options page in the product.')
				]))(params.DE)(
			{bb: true})(
			$elm$core$Maybe$Just(practice));
		var list = _v0.a;
		var listCmd = _v0.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, s1: list},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, listCmd));
	});
var $author$project$Pages$PracticeSetup$Plans$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			model,
			A2($author$project$Utils$PracticeSetup$redirectIfOnboardingComplete, shared.aa4, shared.ahK));
	});
var $author$project$Pages$PracticeSetup$Plans$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$PracticeSetup$Plans$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$PracticeSetup$Plans$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Admin$Plans$List$update, model.Gv, subMsg, model.s1);
		var list = _v1.a;
		var listCmd = _v1.b;
		var outMsgs = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{s1: list}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, listCmd),
			outMsgs);
	});
var $author$project$Pages$PracticeSetup$Plans$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Admin$Plans$List$view(model.s1))
			]),
		ac9: 'Practice Setup'
	};
};
var $author$project$Pages$PracticeSetup$Plans$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$PracticeSetup$Plans$init, aiq: $author$project$Pages$PracticeSetup$Plans$load, k8: $author$project$Pages$PracticeSetup$Plans$save, alO: $author$project$Pages$PracticeSetup$Plans$subscriptions, adT: $author$project$Pages$PracticeSetup$Plans$update, amo: $author$project$Pages$PracticeSetup$Plans$view});
var $author$project$Pages$PracticeSetup$Plans$Id_String$Edit$init = F4(
	function (session, practice, _v0, _v1) {
		var apiClient = _v0.Gv;
		var timeZone = _v0.J8;
		var currentDate = _v0.dd;
		var hinterViewOff = _v0.ahK;
		var query = _v1.DE;
		var params = _v1.YL;
		return A2(
			$elm$core$Tuple$mapFirst,
			function (planForm) {
				return {Gv: apiClient, pd: planForm};
			},
			A9(
				$author$project$Components$Plan$Form$init,
				apiClient,
				timeZone,
				currentDate,
				session,
				practice,
				query,
				$author$project$Spa$Generated$Route$Admin__Plans__Top,
				params.ahP,
				{ahK: hinterViewOff, ZX: true}));
	});
var $author$project$Pages$PracticeSetup$Plans$Id_String$Edit$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			model,
			A2($author$project$Utils$PracticeSetup$redirectIfOnboardingComplete, shared.aa4, shared.ahK));
	});
var $author$project$Pages$PracticeSetup$Plans$Id_String$Edit$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$PracticeSetup$Plans$Id_String$Edit$subscriptions = function (model) {
	return $author$project$Components$Plan$Form$subscriptions(model.pd);
};
var $author$project$Pages$PracticeSetup$Plans$Id_String$Edit$update = F2(
	function (msg, model) {
		return A2(
			$author$project$Utils$Tuple3$mapFirst,
			function (planForm) {
				return _Utils_update(
					model,
					{pd: planForm});
			},
			A3($author$project$Components$Plan$Form$update, model.Gv, msg, model.pd));
	});
var $author$project$Pages$PracticeSetup$Plans$Id_String$Edit$view = function (model) {
	return {
		fO: $author$project$Components$Plan$Form$view(model.pd),
		ac9: 'Practice Setup'
	};
};
var $author$project$Pages$PracticeSetup$Plans$Id_String$Edit$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$PracticeSetup$Plans$Id_String$Edit$init, aiq: $author$project$Pages$PracticeSetup$Plans$Id_String$Edit$load, k8: $author$project$Pages$PracticeSetup$Plans$Id_String$Edit$save, alO: $author$project$Pages$PracticeSetup$Plans$Id_String$Edit$subscriptions, adT: $author$project$Pages$PracticeSetup$Plans$Id_String$Edit$update, amo: $author$project$Pages$PracticeSetup$Plans$Id_String$Edit$view});
var $author$project$Components$Plan$PracticeSetupNewPlan$Model = $elm$core$Basics$identity;
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$initEmptyRules = {
	TZ: {Ro: false},
	WC: {Ro: false}
};
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$empty = $author$project$Utils$Form$init(
	{c8: $elm$core$Maybe$Nothing, TZ: $elm$core$Maybe$Nothing, WC: $elm$core$Maybe$Nothing, aak: $author$project$Components$Plan$Form$RegistrationFeePricingFields$initEmptyRules});
var $author$project$Components$Plan$BasicForm$initEmptyRules = {
	Xf: {Ro: false}
};
var $author$project$Components$Plan$BasicForm$empty = F2(
	function (practice, isViewingAsHinter) {
		var settings = {Aq: isViewingAsHinter, ZV: practice, ZX: true};
		return A2(
			$author$project$Components$Plan$BasicForm$BasicPlanForm,
			settings,
			$author$project$Utils$Form$init(
				{
					K$: false,
					xk: $elm$core$Maybe$Nothing,
					xl: false,
					MI: false,
					MZ: false,
					rQ: $elm$core$Maybe$Nothing,
					y6: $elm$core$Maybe$Nothing,
					y7: 'Membership Fee',
					P6: 'month',
					Qr: A2($author$project$Components$TranslatedRichText$init, $elm$core$Dict$empty, 'plan-description-language-dropdown'),
					r6: false,
					jB: false,
					nr: false,
					nW: 0,
					TP: $elm$core$Maybe$Nothing,
					Xf: $elm$core$Maybe$Nothing,
					Bi: $elm$core$Maybe$Nothing,
					Bj: false,
					Bq: '',
					DB: $elm$core$Maybe$Nothing,
					DC: false,
					DL: $elm$core$Maybe$Nothing,
					ub: 'Unassigned',
					DM: '',
					DN: 'Registration Fee',
					dH: $author$project$Components$Plan$Form$RegistrationFeePricingFields$empty,
					aak: $author$project$Components$Plan$BasicForm$initEmptyRules,
					Es: $elm$core$Maybe$Nothing,
					Et: false,
					JS: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$initEmptyRules = {
	vB: {Ro: false},
	vC: {Ro: false},
	x2: {Ro: false},
	x3: {Ro: false},
	yS: {Ro: false},
	zB: {Ro: false},
	zC: {Ro: false},
	BR: {Ro: false},
	EG: {Ro: false}
};
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$empty = $author$project$Utils$Form$init(
	{vB: $elm$core$Maybe$Nothing, vC: $elm$core$Maybe$Nothing, x2: $elm$core$Maybe$Nothing, x3: $elm$core$Maybe$Nothing, yS: $elm$core$Maybe$Nothing, zB: $elm$core$Maybe$Nothing, zC: $elm$core$Maybe$Nothing, BR: $elm$core$Maybe$Nothing, aak: $author$project$Components$Plan$Form$FamilyMembershipPricingFields$initEmptyRules, EG: $elm$core$Maybe$Nothing});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$empty = $author$project$Utils$Form$init(
	{
		Lk: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$defaultAgeRules('month')
	});
var $author$project$Components$Plan$PracticeSetupNewPlan$initFormFields = F2(
	function (practice, isViewingAsHinter) {
		var membershipPricingForm = $author$project$Components$Plan$Form$IndividualMembershipPricingFields$empty;
		var familyPricingForm = $author$project$Components$Plan$Form$FamilyMembershipPricingFields$empty;
		var defaultGroupPricingType = 'family';
		var basicPlanForm = A2($author$project$Components$Plan$BasicForm$empty, practice, isViewingAsHinter);
		return {ab: basicPlanForm, zi: false, dm: familyPricingForm, S1: defaultGroupPricingType, dq: membershipPricingForm};
	});
var $author$project$Components$Plan$PracticeSetupNewPlan$init = F3(
	function (apiClient, practice, isViewingAsHinter) {
		return _Utils_Tuple2(
			{
				Gv: apiClient,
				SD: $author$project$Utils$Form$init(
					A2($author$project$Components$Plan$PracticeSetupNewPlan$initFormFields, practice, isViewingAsHinter)),
				ZV: practice
			},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$PracticeSetup$Plans$New$init = F4(
	function (_v0, practice, shared, _v1) {
		var _v2 = A3(
			$author$project$Components$Plan$PracticeSetupNewPlan$init,
			shared.Gv,
			practice,
			$author$project$Shared$isHintAdmin(shared));
		var practiceSetupNewPlan = _v2.a;
		return _Utils_Tuple2(
			{
				Gv: shared.Gv,
				Ij: $author$project$Shared$isHintAdmin(shared),
				tZ: practiceSetupNewPlan
			},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$PracticeSetup$Plans$New$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			model,
			A2($author$project$Utils$PracticeSetup$redirectIfOnboardingComplete, shared.aa4, shared.ahK));
	});
var $author$project$Pages$PracticeSetup$Plans$New$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$PracticeSetup$Plans$New$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$PracticeSetup$Plans$New$NewPlanMsg = $elm$core$Basics$identity;
var $author$project$Components$Plan$PracticeSetupNewPlan$BasicPlan = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Plan$PracticeSetupNewPlan$BasicPlanFormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Plan$PracticeSetupNewPlan$FamilyMembershipPricingFields = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Plan$PracticeSetupNewPlan$FamilyMembershipPricingFieldsUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Plan$PracticeSetupNewPlan$IndividualMembershipPricingFieldsUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Plan$PracticeSetupNewPlan$MembershipPricingFields = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Plan$PracticeSetupNewPlan$ToggleFixedMembershipPricing = {$: 3};
var $author$project$Components$Plan$PracticeSetupNewPlan$Created = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Plan$encodeCreateFullFields = function (fields) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(fields.Bq)),
				_Utils_Tuple2(
				'buyable',
				$elm$json$Json$Encode$bool(fields.MZ)),
				_Utils_Tuple2(
				'plan_type',
				$elm$json$Json$Encode$string(
					$author$project$Api$PlanType$toString(2))),
				_Utils_Tuple2(
				'default_period',
				$elm$json$Json$Encode$string(fields.P6)),
				_Utils_Tuple2(
				'discounts_enabled',
				$elm$json$Json$Encode$bool(false)),
				_Utils_Tuple2(
				'bills_at_end_of_period',
				$elm$json$Json$Encode$bool(fields.MI)),
				_Utils_Tuple2(
				'individual_registration_fee_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.TZ)),
				_Utils_Tuple2(
				'minimum_enrollment_period_in_months',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Xf)),
				_Utils_Tuple2(
				'default_charge_name',
				$elm$json$Json$Encode$string(fields.y7)),
				_Utils_Tuple2(
				'default_charge_description',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.y6)),
				_Utils_Tuple2(
				'registration_fee_category',
				A2(
					$author$project$Utils$Encode$nullable,
					function (id) {
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'id',
									$elm$json$Json$Encode$string(id))
								]));
					},
					fields.DL)),
				_Utils_Tuple2(
				'max_registration_fee_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.WC)),
				_Utils_Tuple2(
				'month_adjustment_percent',
				$author$project$Percentage$encode(fields.Bi)),
				_Utils_Tuple2(
				'month_allowed',
				$elm$json$Json$Encode$bool(fields.Bj)),
				_Utils_Tuple2(
				'quarter_adjustment_percent',
				$author$project$Percentage$encode(fields.DB)),
				_Utils_Tuple2(
				'quarter_allowed',
				$elm$json$Json$Encode$bool(fields.DC)),
				_Utils_Tuple2(
				'semi_annual_adjustment_percent',
				$author$project$Percentage$encode(fields.Es)),
				_Utils_Tuple2(
				'semi_annual_allowed',
				$elm$json$Json$Encode$bool(fields.Et)),
				_Utils_Tuple2(
				'annual_adjustment_percent',
				$author$project$Percentage$encode(fields.xk)),
				_Utils_Tuple2(
				'annual_allowed',
				$elm$json$Json$Encode$bool(fields.xl)),
				_Utils_Tuple2(
				'age_rate_rules',
				A2($elm$json$Json$Encode$list, $author$project$Api$Provider$Plan$encodeAgeRateRuleFields, fields.Lk)),
				_Utils_Tuple2(
				'group_pricing_type',
				$elm$json$Json$Encode$string(fields.S1)),
				_Utils_Tuple2(
				'family_num_children_included',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.zC)),
				_Utils_Tuple2(
				'number_additional_children_allowed',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.BR)),
				_Utils_Tuple2(
				'children_age_limit',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.x2)),
				_Utils_Tuple2(
				'couple_discount_rule',
				A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, fields.yS)),
				_Utils_Tuple2(
				'family_discount_rule',
				A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, fields.zB)),
				_Utils_Tuple2(
				'single_parent_discount_rule',
				A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, fields.EG)),
				_Utils_Tuple2(
				'additional_adult_discount_rule',
				A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, fields.vB)),
				_Utils_Tuple2(
				'additional_child_discount_rule',
				A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, fields.vC)),
				_Utils_Tuple2(
				'children_only_discount_rule',
				A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, fields.x3)),
				_Utils_Tuple2(
				'discounts_enabled',
				$elm$json$Json$Encode$bool(fields.zi)),
				_Utils_Tuple2(
				'registration_fee_name',
				$elm$json$Json$Encode$string(fields.DN)),
				_Utils_Tuple2(
				'registration_fee_description',
				$elm$json$Json$Encode$string(fields.DM))
			]));
};
var $author$project$Api$Provider$Plan$createFull = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'plan',
					$author$project$Api$Provider$Plan$encodeCreateFullFields(fields))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Plan$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Plan$plansPath)));
	});
var $author$project$Components$Plan$PracticeSetupNewPlan$createPlanFields = F2(
	function (sharedFields, formFields) {
		var membershipPricingFormFields = $author$project$Components$Plan$Form$IndividualMembershipPricingFields$formFields(formFields.dq);
		var familyMembershipPricingFormFields = $author$project$Components$Plan$Form$FamilyMembershipPricingFields$formFields(formFields.dm);
		var basicPlanFormFields = $author$project$Components$Plan$BasicForm$formFields(formFields.ab);
		var registrationFeeFields = $author$project$Components$Plan$Form$RegistrationFeePricingFields$formFields(basicPlanFormFields.dH);
		return {
			vB: A2(
				$elm$core$Maybe$map,
				function (familyDiscountRule) {
					return {LL: familyDiscountRule.LL, LM: familyDiscountRule.LM, Xn: familyDiscountRule.Xn, Xo: familyDiscountRule.Xo, _U: familyDiscountRule._U, _V: familyDiscountRule._V, aaN: familyDiscountRule.aaN, aaO: familyDiscountRule.aaO};
				},
				familyMembershipPricingFormFields.vB),
			vC: A2(
				$elm$core$Maybe$map,
				function (familyDiscountRule) {
					return {LL: familyDiscountRule.LL, LM: familyDiscountRule.LM, Xn: familyDiscountRule.Xn, Xo: familyDiscountRule.Xo, _U: familyDiscountRule._U, _V: familyDiscountRule._V, aaN: familyDiscountRule.aaN, aaO: familyDiscountRule.aaO};
				},
				familyMembershipPricingFormFields.vC),
			Lk: A2(
				$elm$core$List$map,
				function (ageRateRule) {
					return {
						LH: ageRateRule.dE.LH,
						fE: ageRateRule.dE.fE,
						OM: A2(
							$elm$core$Maybe$map,
							function (coupleRule) {
								return {LH: coupleRule.dE.LH, fE: coupleRule.dE.fE, Xk: coupleRule.dE.Xk, gX: coupleRule.dE.gX, _Q: coupleRule.dE._Q, ho: coupleRule.dE.ho, aaJ: coupleRule.dE.aaJ, hz: coupleRule.dE.hz};
							},
							ageRateRule.OM),
						SK: $elm$core$Maybe$Just(ageRateRule.SK),
						Xk: ageRateRule.dE.Xk,
						gX: ageRateRule.dE.gX,
						_Q: ageRateRule.dE._Q,
						ho: ageRateRule.dE.ho,
						aaJ: ageRateRule.dE.aaJ,
						hz: ageRateRule.dE.hz,
						adb: ageRateRule.adb,
						adL: ageRateRule.adL
					};
				},
				membershipPricingFormFields.Lk),
			xk: A2($elm$core$Maybe$withDefault, $author$project$Percentage$zero, basicPlanFormFields.xk),
			xl: basicPlanFormFields.xl,
			MI: basicPlanFormFields.MI,
			MZ: basicPlanFormFields.MZ,
			x2: familyMembershipPricingFormFields.x2,
			x3: A2(
				$elm$core$Maybe$map,
				function (familyDiscountRule) {
					return {LL: familyDiscountRule.LL, LM: familyDiscountRule.LM, Xn: familyDiscountRule.Xn, Xo: familyDiscountRule.Xo, _U: familyDiscountRule._U, _V: familyDiscountRule._V, aaN: familyDiscountRule.aaN, aaO: familyDiscountRule.aaO};
				},
				familyMembershipPricingFormFields.x3),
			yS: A2(
				$elm$core$Maybe$map,
				function (familyDiscountRule) {
					return {LL: familyDiscountRule.LL, LM: familyDiscountRule.LM, Xn: familyDiscountRule.Xn, Xo: familyDiscountRule.Xo, _U: familyDiscountRule._U, _V: familyDiscountRule._V, aaN: familyDiscountRule.aaN, aaO: familyDiscountRule.aaO};
				},
				familyMembershipPricingFormFields.yS),
			y6: basicPlanFormFields.y6,
			y7: basicPlanFormFields.y7,
			P6: basicPlanFormFields.P6,
			zi: formFields.zi,
			zB: A2(
				$elm$core$Maybe$map,
				function (familyDiscountRule) {
					return {LL: familyDiscountRule.LL, LM: familyDiscountRule.LM, Xn: familyDiscountRule.Xn, Xo: familyDiscountRule.Xo, _U: familyDiscountRule._U, _V: familyDiscountRule._V, aaN: familyDiscountRule.aaN, aaO: familyDiscountRule.aaO};
				},
				familyMembershipPricingFormFields.zB),
			zC: familyMembershipPricingFormFields.zC,
			S1: sharedFields.S1,
			TZ: registrationFeeFields.TZ,
			WC: registrationFeeFields.WC,
			Xf: basicPlanFormFields.Xf,
			Bi: A2($elm$core$Maybe$withDefault, $author$project$Percentage$zero, basicPlanFormFields.Bi),
			Bj: basicPlanFormFields.Bj,
			Bq: basicPlanFormFields.Bq,
			BR: familyMembershipPricingFormFields.BR,
			DB: A2($elm$core$Maybe$withDefault, $author$project$Percentage$zero, basicPlanFormFields.DB),
			DC: basicPlanFormFields.DC,
			DL: basicPlanFormFields.DL,
			DM: basicPlanFormFields.DM,
			DN: basicPlanFormFields.DN,
			Es: A2($elm$core$Maybe$withDefault, $author$project$Percentage$zero, basicPlanFormFields.Es),
			Et: basicPlanFormFields.Et,
			EG: A2(
				$elm$core$Maybe$map,
				function (familyDiscountRule) {
					return {LL: familyDiscountRule.LL, LM: familyDiscountRule.LM, Xn: familyDiscountRule.Xn, Xo: familyDiscountRule.Xo, _U: familyDiscountRule._U, _V: familyDiscountRule._V, aaN: familyDiscountRule.aaN, aaO: familyDiscountRule.aaO};
				},
				familyMembershipPricingFormFields.EG),
			JS: basicPlanFormFields.JS
		};
	});
var $author$project$Components$Plan$PracticeSetupNewPlan$createPlan = F3(
	function (sharedFields, apiClient, validFormFields) {
		var formFields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
		return A3(
			$author$project$Api$Provider$Plan$createFull,
			apiClient,
			A2($author$project$Components$Plan$PracticeSetupNewPlan$createPlanFields, sharedFields, formFields),
			$author$project$Components$Plan$PracticeSetupNewPlan$Created);
	});
var $author$project$Components$Plan$PracticeSetupNewPlan$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var basicPlanForm = field.a;
				return _Utils_update(
					fields,
					{ab: basicPlanForm});
			case 1:
				var membershipPricingForm = field.a;
				return _Utils_update(
					fields,
					{dq: membershipPricingForm});
			case 2:
				var familyMembershipPricingForm = field.a;
				return _Utils_update(
					fields,
					{dm: familyMembershipPricingForm});
			case 3:
				var groupPricingType = (fields.S1 === 'fixed_pricing') ? 'family' : 'fixed_pricing';
				return _Utils_update(
					fields,
					{S1: groupPricingType});
			default:
				var bool = field.a;
				return _Utils_update(
					fields,
					{zi: bool});
		}
	});
var $author$project$Components$Plan$PracticeSetupNewPlan$BasicPlanFieldValidation = 0;
var $author$project$Components$Plan$PracticeSetupNewPlan$validateBasicPlanFormFields = function (_v0) {
	var basicPlan = _v0.ab;
	return $author$project$Components$Plan$BasicForm$hasErrors(basicPlan) ? _List_fromArray(
		[
			_Utils_Tuple2(0, '')
		]) : _List_Nil;
};
var $author$project$Components$Plan$PracticeSetupNewPlan$FamilyMembershipPricingFieldsValidation = 2;
var $author$project$Components$Plan$PracticeSetupNewPlan$validateFamilyMembershipPricingFields = function (_v0) {
	var familyMembershipPricingForm = _v0.dm;
	return $author$project$Components$Plan$Form$FamilyMembershipPricingFields$hasErrors(familyMembershipPricingForm) ? _List_fromArray(
		[
			_Utils_Tuple2(2, '')
		]) : _List_Nil;
};
var $author$project$Components$Plan$PracticeSetupNewPlan$IndividualMembershipPricingFieldsValidation = 1;
var $author$project$Components$Plan$PracticeSetupNewPlan$validateIndividualMembershipPricingFields = function (_v0) {
	var membershipPricingForm = _v0.dq;
	return $author$project$Components$Plan$Form$IndividualMembershipPricingFields$hasErrors(membershipPricingForm) ? _List_fromArray(
		[
			_Utils_Tuple2(1, '')
		]) : _List_Nil;
};
var $author$project$Components$Plan$PracticeSetupNewPlan$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Plan$PracticeSetupNewPlan$validateBasicPlanFormFields),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Plan$PracticeSetupNewPlan$validateIndividualMembershipPricingFields),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Plan$PracticeSetupNewPlan$validateFamilyMembershipPricingFields)
		]));
var $author$project$Components$Plan$PracticeSetupNewPlan$initSharedFields = F2(
	function (maybePlan, form) {
		var _v0 = $author$project$Utils$Form$fields(form);
		var groupPricingType = _v0.S1;
		var basicPlan = _v0.ab;
		var _v1 = $author$project$Components$Plan$BasicForm$formFields(basicPlan);
		var defaultPeriod = _v1.P6;
		return {P6: defaultPeriod, S1: groupPricingType, Jb: maybePlan};
	});
var $author$project$Components$Plan$PracticeSetupNewPlan$updateForm = F3(
	function (model, field, newPlanForm) {
		var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Plan$PracticeSetupNewPlan$formFieldsUpdate, field, newPlanForm);
		return _Utils_update(
			model,
			{SD: newForm});
	});
var $author$project$Components$Plan$PracticeSetupNewPlan$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var planFormMsg = msg.a;
				var _v2 = $author$project$Utils$Form$fields(model.SD);
				var basicPlan = _v2.ab;
				var updateResult = A4($author$project$Components$Plan$BasicForm$update, apiClient, planFormMsg, basicPlan, $elm$core$Maybe$Nothing);
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Plan$PracticeSetupNewPlan$formFieldsUpdate,
					$author$project$Components$Plan$PracticeSetupNewPlan$BasicPlan(updateResult.aiO),
					model.SD);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: newForm}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$PracticeSetupNewPlan$BasicPlanFormUpdated, updateResult.GZ),
					updateResult.aR);
			case 1:
				var membershipPricingFieldsMsg = msg.a;
				var sharedFields = A2($author$project$Components$Plan$PracticeSetupNewPlan$initSharedFields, $elm$core$Maybe$Nothing, model.SD);
				var _v3 = $author$project$Utils$Form$fields(model.SD);
				var membershipPricingForm = _v3.dq;
				var newMembershipPricingResult = A3($author$project$Components$Plan$Form$IndividualMembershipPricingFields$update, sharedFields, membershipPricingFieldsMsg, membershipPricingForm);
				var newModel = function () {
					var _v4 = newMembershipPricingResult.agZ;
					if (!_v4.$) {
						var newForm = A3(
							$author$project$Utils$Form$update,
							$author$project$Components$Plan$PracticeSetupNewPlan$formFieldsUpdate,
							$author$project$Components$Plan$PracticeSetupNewPlan$MembershipPricingFields(newMembershipPricingResult.aiO),
							model.SD);
						return _Utils_update(
							model,
							{SD: newForm});
					} else {
						return A3($author$project$Components$Plan$PracticeSetupNewPlan$updateForm, model, $author$project$Components$Plan$PracticeSetupNewPlan$ToggleFixedMembershipPricing, model.SD);
					}
				}();
				return _Utils_Tuple3(
					newModel,
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$PracticeSetupNewPlan$IndividualMembershipPricingFieldsUpdated, newMembershipPricingResult.GZ),
					newMembershipPricingResult.aR);
			case 2:
				var familyPricingFieldsMsg = msg.a;
				var _v5 = $author$project$Utils$Form$fields(model.SD);
				var familyMembershipPricingForm = _v5.dm;
				var newFamilyMembershipPricingResult = A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$update, familyPricingFieldsMsg, familyMembershipPricingForm, $elm$core$Maybe$Nothing);
				var newModel = function () {
					var newForm = A3(
						$author$project$Utils$Form$update,
						$author$project$Components$Plan$PracticeSetupNewPlan$formFieldsUpdate,
						$author$project$Components$Plan$PracticeSetupNewPlan$FamilyMembershipPricingFields(newFamilyMembershipPricingResult.aiO),
						model.SD);
					return _Utils_update(
						model,
						{SD: newForm});
				}();
				return _Utils_Tuple3(
					newModel,
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$PracticeSetupNewPlan$FamilyMembershipPricingFieldsUpdated, newFamilyMembershipPricingResult.GZ),
					newFamilyMembershipPricingResult.aR);
			case 3:
				var field = msg.a;
				var newModel = A3($author$project$Components$Plan$PracticeSetupNewPlan$updateForm, model, field, model.SD);
				return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, _List_Nil);
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Plans),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Plan successfully created.'),
								$author$project$OutMsg$RefreshPractice
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var sharedFields = A2($author$project$Components$Plan$PracticeSetupNewPlan$initSharedFields, $elm$core$Maybe$Nothing, model.SD);
				var fields = $author$project$Utils$Form$fields(model.SD);
				var validatedFamilyMembershipPricingForm = function () {
					var _v13 = A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$validate, fields.dm, sharedFields, $elm$core$Maybe$Nothing);
					if (!_v13.$) {
						var _v14 = _v13.a;
						var newForm_ = _v14.a;
						return newForm_;
					} else {
						var newForm_ = _v13.a;
						return newForm_;
					}
				}();
				var validatedMembershipPricingForm = function () {
					var _v11 = A3($author$project$Components$Plan$Form$IndividualMembershipPricingFields$validate, sharedFields, fields.dq, $elm$core$Maybe$Nothing);
					if (!_v11.$) {
						var _v12 = _v11.a;
						var newForm = _v12.a;
						return newForm;
					} else {
						var newForm = _v11.a;
						return newForm;
					}
				}();
				var basicPlanForm = function () {
					var _v9 = A2($author$project$Components$Plan$BasicForm$validate, fields.ab, $elm$core$Maybe$Nothing);
					if (!_v9.$) {
						var _v10 = _v9.a;
						var newForm = _v10.a;
						return newForm;
					} else {
						var newForm = _v9.a;
						return newForm;
					}
				}();
				var newValidForm = A2(
					$author$project$Utils$Form$set,
					_Utils_update(
						fields,
						{ab: basicPlanForm, dm: validatedFamilyMembershipPricingForm, dq: validatedMembershipPricingForm}),
					model.SD);
				var _v7 = A2($author$project$Utils$Form$validate, $author$project$Components$Plan$PracticeSetupNewPlan$formFieldsValidator, newValidForm);
				if (!_v7.$) {
					var _v8 = _v7.a;
					var newForm = _v8.a;
					var validFormFields = _v8.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{SD: newForm}),
						A3($author$project$Components$Plan$PracticeSetupNewPlan$createPlan, sharedFields, apiClient, validFormFields),
						_List_Nil);
				} else {
					var newForm = _v7.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{SD: newForm}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
		}
	});
var $author$project$Pages$PracticeSetup$Plans$New$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Plan$PracticeSetupNewPlan$update, model.Gv, subMsg, model.tZ);
		var practiceSetupNewPlanModel = _v1.a;
		var practiceSetupNewPlanCmd = _v1.b;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{tZ: practiceSetupNewPlanModel}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, practiceSetupNewPlanCmd),
			_List_Nil);
	});
var $author$project$Components$Plan$PracticeSetupNewPlan$Save = {$: 5};
var $author$project$Components$Plan$PracticeSetupNewPlan$DiscountsEnabled = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Plan$PracticeSetupNewPlan$FormUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Plan$PracticeSetupNewPlan$viewFamilyDiscountsToggle = function (model) {
	var _v0 = $author$project$Utils$Form$fields(model.SD);
	var discountsEnabled = _v0.zi;
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Typography$headingSm(
				_List_fromArray(
					[
						$elm$html$Html$text('Do you offer discounts to family members who enroll together?'),
						$author$project$Utils$Html$noBreakSpace,
						A2(
						$elm$html$Html$map,
						$elm$core$Basics$never,
						$author$project$Ui$SupportDocumentLink$view('https://support.hint.com/account-configuration/configuring-your-membership-rates-and-billing-options'))
					])),
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanSm(1)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Radio$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Radio$value(discountsEnabled),
										$author$project$Ui$Form$Radio$onCheck(
										A2(
											$elm$core$Basics$composeL,
											$author$project$Components$Plan$PracticeSetupNewPlan$FormUpdated,
											$elm$core$Basics$always(
												$author$project$Components$Plan$PracticeSetupNewPlan$DiscountsEnabled(true))))
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Yes')
											]))
									]))
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanSm(1)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Radio$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Radio$value(!discountsEnabled),
										$author$project$Ui$Form$Radio$inline,
										$author$project$Ui$Form$Radio$onCheck(
										A2(
											$elm$core$Basics$composeL,
											$author$project$Components$Plan$PracticeSetupNewPlan$FormUpdated,
											$elm$core$Basics$always(
												$author$project$Components$Plan$PracticeSetupNewPlan$DiscountsEnabled(false))))
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('No')
											]))
									]))
							]))
					])),
				$author$project$Utils$Html$noBreakSpace
			]));
};
var $author$project$Components$Plan$PracticeSetupNewPlan$view = function (_v0) {
	var model = _v0;
	var sharedFields = A2($author$project$Components$Plan$PracticeSetupNewPlan$initSharedFields, $elm$core$Maybe$Nothing, model.SD);
	var _v1 = $author$project$Utils$Form$fields(model.SD);
	var basicPlan = _v1.ab;
	var membershipPricingForm = _v1.dq;
	var familyMembershipPricingForm = _v1.dm;
	var discountsEnabled = _v1.zi;
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Panel$view,
			_List_fromArray(
				[$author$project$Ui$Panel$onlyBorderLeft]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_Nil,
									A2(
										$elm$core$List$map,
										$elm$html$Html$map($author$project$Components$Plan$PracticeSetupNewPlan$BasicPlanFormUpdated),
										A2($author$project$Components$Plan$BasicForm$view, basicPlan, $elm$core$Maybe$Nothing)))
								])),
							A2(
							$author$project$Ui$Grid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$map,
											$author$project$Components$Plan$PracticeSetupNewPlan$IndividualMembershipPricingFieldsUpdated,
											A4($author$project$Components$Plan$Form$IndividualMembershipPricingFields$view, sharedFields, model.ZV, $elm$core$Maybe$Nothing, membershipPricingForm))
										]))
								])),
							A2(
							$author$project$Ui$Grid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Components$Plan$PracticeSetupNewPlan$viewFamilyDiscountsToggle(model),
											discountsEnabled ? A2(
											$elm$html$Html$map,
											$author$project$Components$Plan$PracticeSetupNewPlan$FamilyMembershipPricingFieldsUpdated,
											A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$view, sharedFields, $elm$core$Maybe$Nothing, familyMembershipPricingForm)) : $author$project$Utils$Html$empty
										]))
								]))
						])),
					A2(
					$author$project$Ui$Panel$footer,
					_List_fromArray(
						[$author$project$Ui$Element$flexCol]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Well$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$info]),
									_List_fromArray(
										[
											$elm$html$Html$text('If you\'re looking for additional options, or have more than one plan, you can access advanced settings after saving your plan.')
										]))
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$justifyRight]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Save new plan'},
									_List_fromArray(
										[
											$author$project$Ui$Button$primary,
											$author$project$Ui$Button$onClick($author$project$Components$Plan$PracticeSetupNewPlan$Save)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Save')
										]))
								]))
						]))
				]))
		]);
};
var $author$project$Pages$PracticeSetup$Plans$New$view = function (model) {
	return {
		fO: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			$author$project$Components$Plan$PracticeSetupNewPlan$view(model.tZ)),
		ac9: 'Practice Setup'
	};
};
var $author$project$Pages$PracticeSetup$Plans$New$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$PracticeSetup$Plans$New$init, aiq: $author$project$Pages$PracticeSetup$Plans$New$load, k8: $author$project$Pages$PracticeSetup$Plans$New$save, alO: $author$project$Pages$PracticeSetup$Plans$New$subscriptions, adT: $author$project$Pages$PracticeSetup$Plans$New$update, amo: $author$project$Pages$PracticeSetup$Plans$New$view});
var $author$project$Pages$PracticeSetup$Team$TeamFormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$PracticeSetup$Team$init = F4(
	function (session, practice, shared, _v0) {
		var onboardingClinical = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Platform$Organization$Shared$onboardingClinical,
				$author$project$Api$Platform$Session$One$organization(session)));
		var usingClinicalEmr = $author$project$Api$Provider$Practice$One$hasClinicalAccount(practice) || onboardingClinical;
		var _v1 = A4(
			$author$project$Components$TeamForm$init,
			shared.dd,
			session,
			practice,
			{bb: true, fr: usingClinicalEmr});
		var teamFormModel = _v1.a;
		var teamFormCmd = _v1.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, ZV: practice, k9: $author$project$Api$Data$NotAsked, aa4: session, hV: teamFormModel, fr: usingClinicalEmr},
			A2($elm$core$Platform$Cmd$map, $author$project$Pages$PracticeSetup$Team$TeamFormMsg, teamFormCmd));
	});
var $author$project$Pages$PracticeSetup$Team$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			model,
			A2($author$project$Utils$PracticeSetup$redirectIfOnboardingComplete, shared.aa4, shared.ahK));
	});
var $author$project$Pages$PracticeSetup$Team$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$PracticeSetup$Team$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$PracticeSetup$Team$Updated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Platform$User$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Pages$PracticeSetup$Team$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A3($author$project$Components$TeamForm$update, subMsg, model.hV, model.Gv);
				var teamFormModel = _v1.a;
				var teamFormCmd = _v1.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{hV: teamFormModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$PracticeSetup$Team$TeamFormMsg, teamFormCmd),
					_List_Nil);
			case 1:
				var _v2 = $author$project$Components$TeamForm$validate(model.hV);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var validatedForm = _v3.a;
					var fields = $author$project$Components$TeamForm$teamMemberFormFields(validatedForm);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: $author$project$Api$Data$Loading, hV: validatedForm}),
						A4(
							$author$project$Api$Provider$TeamMember$update,
							model.Gv,
							$author$project$Api$Platform$User$Shared$id(
								$author$project$Api$Platform$Session$One$user(model.aa4)),
							{PF: fields.PF, nb: fields.nb, Hp: fields.Hp, Wa: $elm$core$Maybe$Nothing, X$: $elm$core$Maybe$Nothing, X0: fields.X0, Zx: fields.Zx, _g: fields._g, _G: fields._G, $x: $elm$core$Maybe$Nothing, $T: $elm$core$Maybe$Nothing, ak3: $elm$core$Maybe$Nothing, qm: fields.qm},
							$author$project$Pages$PracticeSetup$Team$Updated),
						_List_Nil);
				} else {
					var erroredForm = _v2.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: $author$project$Api$Data$NotAsked, hV: erroredForm}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var nextRoute = model.fr ? $author$project$Spa$Generated$Route$PracticeSetup__Communications : $author$project$Spa$Generated$Route$PracticeSetup__PaymentProcessing;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: $author$project$Api$Data$NotAsked}),
						A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, nextRoute),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k9: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$PracticeSetup$Team$FormSubmitted = {$: 1};
var $author$project$Pages$PracticeSetup$Team$view = function (model) {
	var loading = _Utils_eq(model.k9, $author$project$Api$Data$Loading);
	var headerText = model.fr ? 'Create your Clinical Profile' : 'Create your Profile';
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$autocomplete(false),
						$author$project$Ui$Form$noValidate(true),
						$author$project$Ui$Form$onSubmit($author$project$Pages$PracticeSetup$Team$FormSubmitted)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text(headerText)
											]))
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Pages$PracticeSetup$Team$TeamFormMsg,
										$author$project$Components$TeamForm$view(model.hV))
									])),
								A2(
								$author$project$Ui$Panel$footer,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween]),
								_List_fromArray(
									[
										A2($author$project$Ui$Element$view, _List_Nil, _List_Nil),
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Next'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$submit,
												$author$project$Ui$Button$loading(loading)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Next')
											]))
									]))
							]))
					]))
			]),
		ac9: 'User Profile Setup'
	};
};
var $author$project$Pages$PracticeSetup$Team$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$PracticeSetup$Team$init, aiq: $author$project$Pages$PracticeSetup$Team$load, k8: $author$project$Pages$PracticeSetup$Team$save, alO: $author$project$Pages$PracticeSetup$Team$subscriptions, adT: $author$project$Pages$PracticeSetup$Team$update, amo: $author$project$Pages$PracticeSetup$Team$view});
var $author$project$Pages$PracticeSetup$Top$view = function (_v0) {
	return {
		fO: _List_fromArray(
			[
				$elm$html$Html$text('Practice Setup')
			]),
		ac9: 'Practice Setup'
	};
};
var $author$project$Pages$PracticeSetup$Top$page = $author$project$Spa$Page$static($author$project$Pages$PracticeSetup$Top$view);
var $author$project$Pages$RefillRequests$init = F4(
	function (session, practice, shared, _v0) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, ZV: practice, aa4: session},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$RefillRequests$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$RefillRequests$view = function (_v0) {
	return {
		fO: _List_fromArray(
			[
				$elm$html$Html$text('RefillRequests')
			]),
		ac9: 'RefillRequests'
	};
};
var $author$project$Pages$RefillRequests$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$RefillRequests$init,
		aiq: F2(
			function (_v0, model) {
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}),
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v1) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$RefillRequests$update,
		amo: $author$project$Pages$RefillRequests$view
	});
var $author$project$Pages$Reports$AncillaryCharges$Id_String$ViewDetailsMsg = $elm$core$Basics$identity;
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$AncillaryChargesListMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$CategoryResourceFilterMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$GotAncillaryChargePreview = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$Report$AffiliateAncillaryCharge = 23;
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$CompanyResourceFilterMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$DateRangeInputMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$PracticeResourceFilterMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$buildQueryParams = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('start'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.dd, 0)),
			model.JV),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('end'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.dd, 0)),
			model.HB),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('company'),
			model.fZ),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('affiliate_practice'),
			model.aeM)
		]);
	return A2(
		$elm$core$List$append,
		$author$project$Api$Pagination$toPageQuery(model.ajJ),
		A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams));
};
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$buildUrl = function (model) {
	var route = function () {
		var _v0 = model.ahP;
		if (!_v0.$) {
			var id = _v0.a;
			return $author$project$Spa$Generated$Route$Reports__AncillaryCharges__Id_String(
				{ahP: id});
		} else {
			return $author$project$Spa$Generated$Route$Reports__AncillaryCharges__Top;
		}
	}();
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString(route)
				]),
			$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$buildQueryParams(model)));
};
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$dateRangeInputSettings = F2(
	function (start, end) {
		var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
		return _Utils_update(
			defaultSettings,
			{ahy: start, al5: end});
	});
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$GotAncillaryCharges = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$fetchAncillaryChargesParams = F2(
	function (model, pagination) {
		return function (d) {
			return _Utils_update(
				d,
				{
					Le: model.aeM,
					afQ: model.fZ,
					HB: A2(
						$elm$core$Maybe$map,
						A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
						model.HB),
					ajJ: pagination,
					JV: A2(
						$elm$core$Maybe$map,
						A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
						model.JV)
				});
		};
	});
var $author$project$Api$Provider$Reports$AncillaryCharge$AncillaryCharge = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$AncillaryCharge$Record = F7(
	function (id, status, charge, sponsor, affiliate, affiliatePractice, sponsorCharge) {
		return {Gn: affiliate, Le: affiliatePractice, afx: charge, ahP: id, abX: sponsor, abY: sponsorCharge, alH: status};
	});
var $author$project$Api$Provider$Affiliate$Min$Affiliate = $elm$core$Basics$identity;
var $author$project$Api$Provider$Affiliate$Min$Record = function (id) {
	return {ahP: id};
};
var $author$project$Api$Provider$Affiliate$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'id',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Affiliate$Min$Record));
var $author$project$Api$Provider$Affiliate$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Affiliate$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$Charge = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$Record = F5(
	function (createdAt, category, patient, priceInCents, invoice) {
		return {GW: category, O1: createdAt, Uk: invoice, YY: patient, Dw: priceInCents};
	});
var $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'invoice',
	$elm$json$Json$Decode$nullable($author$project$Api$Common$Payable$Invoice$Min$decoder),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'price_in_cents',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'patient',
			$author$project$Api$Provider$Patient$Min$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'category',
				$elm$json$Json$Decode$nullable($author$project$Api$Provider$Category$Min$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'created_at',
					$elm_community$json_extra$Json$Decode$Extra$datetime,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$Record))))));
var $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Charge$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$Charge)));
var $author$project$Api$Provider$Reports$AncillaryCharge$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'sponsor_charge',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$decoder),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'affiliate_practice',
		$author$project$Api$Provider$Practice$Min$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'affiliate',
			$author$project$Api$Provider$Affiliate$Min$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'sponsor',
				$author$project$Api$Provider$Company$Min$decoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'charge',
					$author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$decoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'status',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$AncillaryCharge$Record))))))));
var $author$project$Api$Provider$Reports$AncillaryCharge$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Reports$AncillaryCharge$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$AncillaryCharge$listDefaults = {Le: $elm$core$Maybe$Nothing, afQ: $elm$core$Maybe$Nothing, HB: $elm$core$Maybe$Nothing, ajJ: $author$project$Api$Pagination$init, JV: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$Reports$AncillaryCharge$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Reports$AncillaryCharge$listDefaults);
	return A2(
		$elm$core$List$append,
		$author$project$Api$Pagination$toApiParams(options.ajJ),
		$elm$core$List$concat(
			_List_fromArray(
				[
					function () {
					var _v0 = options.JV;
					if (!_v0.$) {
						var start_ = _v0.a;
						return _List_fromArray(
							[
								A2($author$project$Api$Param$date, 'start', start_)
							]);
					} else {
						return _List_Nil;
					}
				}(),
					function () {
					var _v1 = options.HB;
					if (!_v1.$) {
						var end_ = _v1.a;
						return _List_fromArray(
							[
								A2($author$project$Api$Param$date, 'end', end_)
							]);
					} else {
						return _List_Nil;
					}
				}(),
					function () {
					var _v2 = options.afQ;
					if (!_v2.$) {
						var string = _v2.a;
						return _List_fromArray(
							[
								A2($author$project$Api$Param$string, 'sponsor', string)
							]);
					} else {
						return _List_Nil;
					}
				}(),
					function () {
					var _v3 = options.Le;
					if (!_v3.$) {
						var string = _v3.a;
						return _List_fromArray(
							[
								A2($author$project$Api$Param$string, 'affiliate_practice', string)
							]);
					} else {
						return _List_Nil;
					}
				}()
				])));
};
var $author$project$Api$Provider$Reports$AncillaryCharge$listPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['reports', 'affiliate_ancillary_charges']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Reports$AncillaryCharge$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Reports$AncillaryCharge$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Reports$AncillaryCharge$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$AncillaryCharge$listPath)));
	});
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$fetchAncillaryCharges = F3(
	function (apiClient, model, pagination) {
		return A3(
			$author$project$Api$Provider$Reports$AncillaryCharge$list,
			apiClient,
			A2($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$fetchAncillaryChargesParams, model, pagination),
			$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$GotAncillaryCharges);
	});
var $author$project$Components$ResourceFilter$Affiliates$Practice$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Components$ResourceFilter$Affiliates$Practice$list = $author$project$Api$Platform$User$Practice$list;
var $author$project$Components$ResourceFilter$Affiliates$Practice$fetchResources = F4(
	function (toMsg, apiClient, pagination, query) {
		return A4(
			$author$project$Components$ResourceFilter$Affiliates$Practice$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						Go: $elm$core$Maybe$Just(true),
						ajJ: pagination,
						akl: query
					});
			},
			$elm$core$Maybe$Nothing,
			toMsg);
	});
var $author$project$Components$ResourceFilter$Affiliates$Practice$retrieveResource = F3(
	function (toMsg, apiClient, id) {
		return A4(
			$author$project$Components$ResourceFilter$Affiliates$Practice$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						Go: $elm$core$Maybe$Just(true),
						HE: _List_fromArray(
							[0]),
						akl: $elm$core$Maybe$Just(id)
					});
			},
			$elm$core$Maybe$Nothing,
			toMsg);
	});
var $author$project$Components$ResourceFilter$Affiliates$Practice$selectId = 'practices';
var $author$project$Components$ResourceFilter$Affiliates$Practice$toTitle = $author$project$Api$Platform$Practice$All$name;
var $author$project$Components$ResourceFilter$Affiliates$Practice$toLabel = function (resource) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Components$ResourceFilter$Affiliates$Practice$toTitle(resource))
		]);
};
var $author$project$Components$ResourceFilter$Affiliates$Practice$toValue = $author$project$Api$Platform$Practice$All$id;
var $author$project$Components$ResourceFilter$Affiliates$Practice$init = F2(
	function (apiClient, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{Sk: $author$project$Components$ResourceFilter$Affiliates$Practice$fetchResources, ahP: $author$project$Components$ResourceFilter$Affiliates$Practice$selectId, k$: 'Practices', uk: $author$project$Components$ResourceFilter$Affiliates$Practice$retrieveResource, u9: $author$project$Components$ResourceFilter$Affiliates$Practice$toLabel, lN: $author$project$Components$ResourceFilter$Affiliates$Practice$toTitle, hX: $author$project$Components$ResourceFilter$Affiliates$Practice$toValue},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{Jy: $author$project$Components$ResourceFilter$All, b8: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Utils$Report$PracticeResourceFilter$init = F4(
	function (apiClient, optionals, practice, practiceId) {
		return A2(
			$author$project$Components$ResourceFilter$Affiliates$Practice$init,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				optionals,
				function (d) {
					return _Utils_update(
						d,
						{
							Gp: 'All ' + A2($author$project$Api$Practice$sponsorize, practice, 'Affiliates'),
							akb: practiceId
						});
				}));
	});
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$initColumns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'charge_added', false, 'Charge Added Date'),
		A3($author$project$Api$Column$init, 'sponsor', false, 'Sponsor'),
		A3($author$project$Api$Column$init, 'patient', false, 'Patient'),
		A3($author$project$Api$Column$init, 'affiliate', false, 'Affiliate'),
		A3($author$project$Api$Column$init, 'charge', false, 'Charge'),
		A2(
		$author$project$Api$Column$withOption,
		$author$project$Ui$Table$textCenter,
		A3($author$project$Api$Column$init, 'sponsor_invoice', false, 'Sponsor Invoice'))
	]);
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$init = F4(
	function (practice, _v0, query, paramsId) {
		var apiClient = _v0.Gv;
		var timeZone = _v0.J8;
		var currentDate = _v0.dd;
		var pagination = A2($author$project$Api$Pagination$fromQuery, query, $author$project$Api$Pagination$init);
		var companyId = A2($elm$core$Dict$get, 'company', query);
		var affiliatePracticeId = A2($elm$core$Dict$get, 'affiliate_practice', query);
		var _v1 = A4(
			$author$project$Utils$Report$PracticeResourceFilter$init,
			apiClient,
			$elm$core$Basics$identity,
			$author$project$Api$Practice$Provider(practice),
			affiliatePracticeId);
		var practiceResourceFilter = _v1.a;
		var practiceResourceFilterCmd = _v1.b;
		var _v2 = $author$project$Utils$DateWithDefault$fromQuery(query);
		var start = _v2.a;
		var end = _v2.b;
		var _v3 = A2(
			$author$project$Components$DateRangeInput$init,
			'date-range-input',
			A2(
				$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$dateRangeInputSettings,
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					start),
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					end)));
		var dateRangeInput = _v3.a;
		var dateRangeInputCmd = _v3.b;
		var _v4 = A4(
			$author$project$Utils$Report$CompanyResourceFilter$init,
			apiClient,
			$elm$core$Basics$identity,
			$author$project$Api$Practice$Provider(practice),
			companyId);
		var companyResourceFilter = _v4.a;
		var companyResourceFilterCmd = _v4.b;
		var model = {
			aeM: affiliatePracticeId,
			aF: $author$project$Api$Data$Loading,
			N3: $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$initColumns,
			fZ: companyId,
			mZ: companyResourceFilter,
			dd: currentDate,
			i4: dateRangeInput,
			HB: end,
			nD: $author$project$Components$ExportCsv$initForPractice(23),
			ahP: paramsId,
			ajJ: pagination,
			kL: practiceResourceFilter,
			JV: start,
			J8: timeZone
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$DateRangeInputMsg, dateRangeInputCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$CompanyResourceFilterMsg, companyResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$PracticeResourceFilterMsg, practiceResourceFilterCmd),
						A3($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$fetchAncillaryCharges, apiClient, model, pagination),
						$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$buildUrl(model)
					])));
	});
var $author$project$Api$Provider$AffiliateAncillaryCharge$AffiliateAncillaryChargePreview = $elm$core$Basics$identity;
var $author$project$Api$Provider$AffiliateAncillaryCharge$Record = F5(
	function (id, status, charge, category, networkCoveragePlan) {
		return {GW: category, afx: charge, ahP: id, XA: networkCoveragePlan, alH: status};
	});
var $author$project$Api$Provider$AffiliateAncillaryCharge$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'network_coverage_plan',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$CoveragePlan$One$decoder),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'category',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Category$Min$decoder),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'charge',
			$author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'status',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$AffiliateAncillaryCharge$Record))))));
var $author$project$Api$Provider$AffiliateAncillaryCharge$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$AffiliateAncillaryCharge$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$AffiliateAncillaryCharge$preview = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$AffiliateAncillaryCharge$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['affiliate_ancillary_charges', id, 'preview']),
					$author$project$Api$Data$providerPath)));
	});
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$init = F4(
	function (practice, shared, _v0, session) {
		var params = _v0.YL;
		var query = _v0.DE;
		var _v1 = A4(
			$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$init,
			practice,
			shared,
			query,
			$elm$core$Maybe$Just(params.ahP));
		var ancillaryCharges = _v1.a;
		var cmd = _v1.b;
		var _v2 = A3(
			$author$project$Components$ResourceFilter$Category$init,
			shared.Gv,
			session,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Unassigned', ai5: false});
			});
		var categoryResourceFilter = _v2.a;
		var categoryResourceFilterCmd = _v2.b;
		return _Utils_Tuple2(
			{w0: $elm$core$Maybe$Nothing, aF: ancillaryCharges, c8: categoryResourceFilter, OT: $elm$core$Maybe$Nothing, ahP: params.ahP, XA: $elm$core$Maybe$Nothing, lc: $elm$core$Maybe$Nothing, aa4: session, adY: shared.adY},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$AncillaryCharges$ViewDetails$AncillaryChargesListMsg, cmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$AncillaryCharges$ViewDetails$CategoryResourceFilterMsg, categoryResourceFilterCmd),
						A3($author$project$Api$Provider$AffiliateAncillaryCharge$preview, shared.Gv, params.ahP, $author$project$Components$Reports$AncillaryCharges$ViewDetails$GotAncillaryChargePreview)
					])));
	});
var $author$project$Pages$Reports$AncillaryCharges$Id_String$init = F4(
	function (session, practice, shared, urlParams) {
		var _v0 = A4($author$project$Components$Reports$AncillaryCharges$ViewDetails$init, practice, shared, urlParams, session);
		var viewDetails = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, q1: viewDetails},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
	});
var $author$project$Pages$Reports$AncillaryCharges$Id_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$AncillaryCharges$Id_String$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$NetworkCoveragePlanMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$AncillaryCharges$ViewDetails$NetworkCoveragePlanMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Admin$CoveragePlans$Rules$subscriptions, model.XA))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$AncillaryCharges$ViewDetails$CategoryResourceFilterMsg,
				$author$project$Components$ResourceFilter$Category$subscriptions(model.c8))
			]));
};
var $author$project$Pages$Reports$AncillaryCharges$Id_String$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Reports$AncillaryCharges$ViewDetails$subscriptions(model.q1));
};
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$AncillaryChargeApproved = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$AffiliateAncillaryCharge$approve = F4(
	function (apiClient, id, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'charge',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'category',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, params.GW))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['affiliate_ancillary_charges', id, 'approve']),
						$author$project$Api$Data$providerPath))));
	});
var $author$project$Spa$Url$toQuery = function (queryString) {
	var second = A2(
		$elm$core$Basics$composeR,
		$elm$core$List$drop(1),
		$elm$core$List$head);
	var toTuple = function (list) {
		return A2(
			$elm$core$Maybe$map,
			function (first) {
				return _Utils_Tuple2(
					first,
					A2(
						$elm$core$Maybe$withDefault,
						'',
						second(list)));
			},
			$elm$core$List$head(list));
	};
	var decode = A2(
		$elm$core$Basics$composeR,
		$elm$url$Url$percentDecode,
		$elm$core$Maybe$withDefault(''));
	return A2(
		$elm$core$List$map,
		A2($elm$core$Tuple$mapBoth, decode, decode),
		A2(
			$elm$core$List$filterMap,
			toTuple,
			A2(
				$elm$core$List$map,
				$elm$core$String$split('='),
				A2($elm$core$String$split, '&', queryString))));
};
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$buildRouteFromUrl = F3(
	function (maybePageSize, maybeSelectedPageNumber, model) {
		var queryParamsList = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$map(
					function (_v3) {
						var key = _v3.a;
						var value = _v3.b;
						return A2($elm$url$Url$Builder$string, key, value);
					}),
				A2(
					$elm$core$Maybe$map,
					$elm$core$List$filter(
						function (_v2) {
							var key = _v2.a;
							return A2(
								$elm$core$List$member,
								key,
								_List_fromArray(
									['company', 'start', 'end', 'affiliate_practice']));
						}),
					A2($elm$core$Maybe$map, $author$project$Spa$Url$toQuery, model.adY.DE))));
		var perPageQuery = function () {
			if (!maybePageSize.$) {
				var pageSize = maybePageSize.a;
				return _List_fromArray(
					[
						A2($elm$url$Url$Builder$int, 'per_page', pageSize)
					]);
			} else {
				return $author$project$Api$Pagination$toPageQuery(model.aF.ajJ);
			}
		}();
		var pageQuery = function () {
			if (!maybeSelectedPageNumber.$) {
				var pageNumber = maybeSelectedPageNumber.a;
				return _List_fromArray(
					[
						A2($elm$url$Url$Builder$int, 'page', pageNumber)
					]);
			} else {
				return $author$project$Api$Pagination$toPageQuery(model.aF.ajJ);
			}
		}();
		return $author$project$Ports$Navigation$pushUrl(
			A2(
				$elm$url$Url$Builder$relative,
				_List_fromArray(
					[
						$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__AncillaryCharges__Top)
					]),
				A2(
					$elm$core$List$append,
					pageQuery,
					A2($elm$core$List$append, perPageQuery, queryParamsList))));
	});
var $author$project$Api$Provider$AffiliateAncillaryCharge$category = function (_v0) {
	var record = _v0;
	return record.GW;
};
var $author$project$Api$Provider$Reports$AncillaryCharge$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$initCategoryResourceFilter = F3(
	function (apiClient, session, id) {
		return A3(
			$author$project$Components$ResourceFilter$Category$init,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'Unassigned', ai5: false, akb: id});
			});
	});
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$initNetworkCoveragePlanRules = F4(
	function (apiClient, session, coveragePlan, coverageRuleUsages) {
		if (!coveragePlan.$) {
			var coveragePlan_ = coveragePlan.a;
			return A3(
				$elm$core$Tuple$mapBoth,
				$elm$core$Maybe$Just,
				$elm$core$Platform$Cmd$map($author$project$Components$Reports$AncillaryCharges$ViewDetails$NetworkCoveragePlanMsg),
				A6(
					$author$project$Components$Admin$CoveragePlans$Rules$init,
					apiClient,
					session,
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$CoveragePlan$One$id(coveragePlan_)),
					$author$project$Api$Provider$CoveragePlan$One$coverageRules(coveragePlan_),
					$elm$core$Maybe$Just(coverageRuleUsages),
					{_6: true}));
		} else {
			return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Api$Provider$AffiliateAncillaryCharge$networkCoveragePlan = function (_v0) {
	var record = _v0;
	return record.XA;
};
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$selectAncillaryCharge = F2(
	function (model, id) {
		var _v0 = model.aF;
		if (_v0.$ === 3) {
			var charges = _v0.a;
			return $elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (ancillaryCharge) {
						return _Utils_eq(
							$author$project$Api$Provider$Reports$AncillaryCharge$id(ancillaryCharge),
							id);
					},
					charges));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$AncillaryChargeApproved = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$ExportCsvMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$ResourceFilter$Affiliates$Practice$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.b8);
		var modelAfterEvent = function () {
			var _v1 = result.agZ;
			if (!_v1.$) {
				var selected = _v1.a;
				return _Utils_update(
					model,
					{Jy: selected});
			} else {
				return model;
			}
		}();
		return {
			GZ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.GZ),
			agZ: result.agZ,
			aiO: _Utils_update(
				modelAfterEvent,
				{b8: result.aiO}),
			aR: result.aR
		};
	});
var $author$project$Components$ResourceFilter$Affiliates$Practice$value = function (model) {
	return A2($author$project$Components$ResourceFilter$choiceToValue, model.b8, model.Jy);
};
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$update = F3(
	function (msg, model, apiClient) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					var totalCount = A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{aF: response, ajJ: totalCount}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{aF: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var ancillaryCharge = msg.a;
				return _Utils_Tuple3(
					model,
					A4(
						$author$project$Api$Provider$AffiliateAncillaryCharge$approve,
						apiClient,
						$author$project$Api$Provider$Reports$AncillaryCharge$id(ancillaryCharge),
						{GW: $elm$core$Maybe$Nothing},
						$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$AncillaryChargeApproved),
					_List_Nil);
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						A3($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$fetchAncillaryCharges, apiClient, model, model.ajJ),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Affiliate ancillary charge approved')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 3:
				var subMsg = msg.a;
				var _v3 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.nD);
				var exportCsv = _v3.a;
				var subCmd = _v3.b;
				var subOutMsg = _v3.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nD: exportCsv}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$ExportCsvMsg, subCmd),
					subOutMsg);
			case 4:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{aF: $author$project$Api$Data$Loading, ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A3($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$fetchAncillaryCharges, apiClient, newModel, pagination),
								$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$buildUrl(newModel)
							])),
					_List_Nil);
			case 5:
				var subMsg = msg.a;
				var _v4 = A2($author$project$Components$DateRangeInput$update, subMsg, model.i4);
				var dateRangeInput = _v4.a;
				var subCmd = _v4.b;
				var event = _v4.c;
				var newModel = function () {
					if (event.$ === 1) {
						var fromDate = event.a;
						var toDate = event.b;
						return _Utils_update(
							model,
							{
								aF: $author$project$Api$Data$Loading,
								i4: dateRangeInput,
								HB: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
								JV: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
							});
					} else {
						return _Utils_update(
							model,
							{i4: dateRangeInput});
					}
				}();
				var _v5 = function () {
					if (_Utils_eq(newModel.JV, model.JV) && _Utils_eq(newModel.HB, model.HB)) {
						return _Utils_Tuple2(_List_Nil, model.ajJ);
					} else {
						var paginationReset = $author$project$Api$Pagination$reset(model.ajJ);
						return _Utils_Tuple2(
							_List_fromArray(
								[
									A3($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$fetchAncillaryCharges, apiClient, newModel, paginationReset),
									$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$buildUrl(newModel)
								]),
							paginationReset);
					}
				}();
				var cmds = _v5.a;
				var pagination = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{ajJ: pagination}),
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$cons,
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$DateRangeInputMsg, subCmd),
							cmds)),
					_List_Nil);
			case 6:
				var subMsg = msg.a;
				var companyResourceResult = A3($author$project$Components$ResourceFilter$Company$update, apiClient, subMsg, model.mZ);
				var companyId = function () {
					var _v8 = companyResourceResult.agZ;
					if (!_v8.$) {
						return $author$project$Components$ResourceFilter$Company$value(companyResourceResult.aiO);
					} else {
						return model.fZ;
					}
				}();
				var newModel = _Utils_update(
					model,
					{fZ: companyId, mZ: companyResourceResult.aiO});
				var _v7 = function () {
					if (_Utils_eq(model.fZ, newModel.fZ)) {
						return _Utils_Tuple3(model.aF, $elm$core$Platform$Cmd$none, model.ajJ);
					} else {
						var paginationReset = $author$project$Api$Pagination$reset(model.ajJ);
						return _Utils_Tuple3(
							$author$project$Api$Data$Loading,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A3($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$fetchAncillaryCharges, apiClient, newModel, paginationReset),
										$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$buildUrl(newModel)
									])),
							paginationReset);
					}
				}();
				var ancillaryCharges = _v7.a;
				var cmd = _v7.b;
				var pagination = _v7.c;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{aF: ancillaryCharges, ajJ: pagination}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$CompanyResourceFilterMsg, companyResourceResult.GZ),
								cmd
							])),
					companyResourceResult.aR);
			default:
				var subMsg = msg.a;
				var practiceResourceResult = A3($author$project$Components$ResourceFilter$Affiliates$Practice$update, apiClient, subMsg, model.kL);
				var affiliatePracticeId = function () {
					var _v10 = practiceResourceResult.agZ;
					if (!_v10.$) {
						return $author$project$Components$ResourceFilter$Affiliates$Practice$value(practiceResourceResult.aiO);
					} else {
						return model.aeM;
					}
				}();
				var newModel = _Utils_update(
					model,
					{aeM: affiliatePracticeId, kL: practiceResourceResult.aiO});
				var _v9 = function () {
					if (_Utils_eq(model.aeM, newModel.aeM)) {
						return _Utils_Tuple3(model.aF, $elm$core$Platform$Cmd$none, model.ajJ);
					} else {
						var paginationReset = $author$project$Api$Pagination$reset(model.ajJ);
						return _Utils_Tuple3(
							$author$project$Api$Data$Loading,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A3($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$fetchAncillaryCharges, apiClient, newModel, paginationReset),
										$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$buildUrl(newModel)
									])),
							paginationReset);
					}
				}();
				var ancillaryCharges = _v9.a;
				var cmd = _v9.b;
				var pagination = _v9.c;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{aF: ancillaryCharges, ajJ: pagination}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$PracticeResourceFilterMsg, practiceResourceResult.GZ),
								cmd
							])),
					practiceResourceResult.aR);
		}
	});
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$update = F3(
	function (msg, model, apiClient) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A3($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$update, subMsg, model.aF, apiClient);
				var ancillaryChargesModel = _v1.a;
				var cmd = _v1.b;
				var outMsgs = _v1.c;
				var selectedAncillaryCharge = A2($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$selectAncillaryCharge, ancillaryChargesModel, model.ahP);
				var newCmd = function () {
					if (subMsg.$ === 4) {
						var paginationMsg = subMsg.a;
						if (!paginationMsg.$) {
							var selectedPageNumber = paginationMsg.a;
							return A3(
								$author$project$Components$Reports$AncillaryCharges$ViewDetails$buildRouteFromUrl,
								$elm$core$Maybe$Nothing,
								$elm$core$Maybe$Just(selectedPageNumber),
								model);
						} else {
							var perPage = paginationMsg.a;
							return A3(
								$author$project$Components$Reports$AncillaryCharges$ViewDetails$buildRouteFromUrl,
								$elm$core$Maybe$Just(perPage),
								$elm$core$Maybe$Nothing,
								model);
						}
					} else {
						return A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$AncillaryCharges$ViewDetails$AncillaryChargesListMsg, cmd);
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aF: ancillaryChargesModel, lc: selectedAncillaryCharge}),
					newCmd,
					outMsgs);
			case 1:
				return _Utils_Tuple3(
					model,
					A3($author$project$Components$Reports$AncillaryCharges$ViewDetails$buildRouteFromUrl, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, model),
					_List_Nil);
			case 2:
				var response = msg.a;
				switch (response.$) {
					case 3:
						var affiliateAncillaryChargePreview = response.a;
						var previewSponsorChargeCategoryId = A2(
							$elm$core$Maybe$map,
							$author$project$Api$Provider$Category$Min$id,
							$author$project$Api$Provider$AffiliateAncillaryCharge$category(affiliateAncillaryChargePreview));
						var coveragePlan = $author$project$Api$Provider$AffiliateAncillaryCharge$networkCoveragePlan(affiliateAncillaryChargePreview);
						var _v5 = A4($author$project$Components$Reports$AncillaryCharges$ViewDetails$initNetworkCoveragePlanRules, apiClient, model.aa4, coveragePlan, _List_Nil);
						var networkCoveragePlan = _v5.a;
						var _v6 = A3($author$project$Components$Reports$AncillaryCharges$ViewDetails$initCategoryResourceFilter, apiClient, model.aa4, previewSponsorChargeCategoryId);
						var categoryResourceFilter = _v6.a;
						var categoryResourceFilterCmd = _v6.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									w0: $elm$core$Maybe$Just(affiliateAncillaryChargePreview),
									c8: categoryResourceFilter,
									OT: coveragePlan,
									XA: networkCoveragePlan
								}),
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$AncillaryCharges$ViewDetails$CategoryResourceFilterMsg, categoryResourceFilterCmd),
							_List_Nil);
					case 2:
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var subMsg = msg.a;
				var categoryResourceResult = A3($author$project$Components$ResourceFilter$Category$update, apiClient, subMsg, model.c8);
				var newCategoryResourceFilter = categoryResourceResult.aiO;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{c8: newCategoryResourceFilter}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$AncillaryCharges$ViewDetails$CategoryResourceFilterMsg, categoryResourceResult.GZ),
					categoryResourceResult.aR);
			case 4:
				var ancillaryCharge = msg.a;
				var category = $author$project$Components$ResourceFilter$Category$value(model.c8);
				return _Utils_Tuple3(
					model,
					A4(
						$author$project$Api$Provider$AffiliateAncillaryCharge$approve,
						apiClient,
						$author$project$Api$Provider$Reports$AncillaryCharge$id(ancillaryCharge),
						{GW: category},
						$author$project$Components$Reports$AncillaryCharges$ViewDetails$AncillaryChargeApproved),
					_List_Nil);
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						A3($author$project$Components$Reports$AncillaryCharges$ViewDetails$buildRouteFromUrl, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, model),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Affiliate ancillary charge approved')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var subMsg = msg.a;
				var _v8 = model.XA;
				if (!_v8.$) {
					var networkCoveragePlan = _v8.a;
					var _v9 = A3($author$project$Components$Admin$CoveragePlans$Rules$update, apiClient, subMsg, networkCoveragePlan);
					var newNetworkCoveragePlan = _v9.a;
					var networkCoveragePlanCmd = _v9.b;
					var networkCoveragePlanOutMsgs = _v9.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								XA: $elm$core$Maybe$Just(newNetworkCoveragePlan)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$AncillaryCharges$ViewDetails$NetworkCoveragePlanMsg, networkCoveragePlanCmd),
						networkCoveragePlanOutMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Reports$AncillaryCharges$Id_String$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Reports$AncillaryCharges$ViewDetails$update, subMsg, model.q1, model.Gv);
		var viewDetails = _v1.a;
		var cmd = _v1.b;
		var outMsgs = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{q1: viewDetails}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd),
			outMsgs);
	});
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$initMiniColumns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'charge_added', false, 'Charge Added Date'),
		A3($author$project$Api$Column$init, 'sponsor', false, 'Sponsor'),
		A3($author$project$Api$Column$init, 'patient', false, 'Patient'),
		A3($author$project$Api$Column$init, 'affiliate', false, 'Affiliate'),
		A3($author$project$Api$Column$init, 'charge', false, 'Charge')
	]);
var $author$project$Api$Provider$Reports$AncillaryCharge$affiliate = function (_v0) {
	var record = _v0;
	return record.Gn;
};
var $author$project$Api$Provider$Reports$AncillaryCharge$affiliatePractice = function (_v0) {
	var record = _v0;
	return record.Le;
};
var $author$project$Api$Provider$Reports$AncillaryCharge$charge = function (_v0) {
	var record = _v0;
	return record.afx;
};
var $author$project$Api$Provider$Affiliate$Min$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$invoice = function (_v0) {
	var record = _v0.b;
	return record.Uk;
};
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewAffiliateCell = function (ancillaryCharge) {
	var invoice = $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$invoice(
		$author$project$Api$Provider$Reports$AncillaryCharge$charge(ancillaryCharge));
	var invoiceId = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Maybe$map, $author$project$Api$Common$Payable$Invoice$Min$id, invoice));
	var affiliationId = $author$project$Api$Provider$Affiliate$Min$id(
		$author$project$Api$Provider$Reports$AncillaryCharge$affiliate(ancillaryCharge));
	return A2(
		$author$project$Ui$Table$cell,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Api$Provider$Practice$Min$name(
					$author$project$Api$Provider$Reports$AncillaryCharge$affiliatePractice(ancillaryCharge))),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Invoice: ')
							])),
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Id_String(
							{rd: affiliationId, ahP: invoiceId}),
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								'#' + $elm$core$String$fromInt(
									A2(
										$elm$core$Maybe$withDefault,
										0,
										A2($elm$core$Maybe$map, $author$project$Api$Common$Payable$Invoice$Min$invoiceNumber, invoice))))
							])),
						A2(
						$elm$core$Maybe$withDefault,
						$author$project$Utils$Html$empty,
						A2(
							$elm$core$Maybe$map,
							$author$project$Ui$Badge$fromString(_List_Nil),
							A2($elm$core$Maybe$map, $author$project$Api$Common$Payable$Invoice$Min$humanStatus, invoice)))
					]))
			]));
};
var $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$createdAt = function (_v0) {
	var record = _v0.b;
	return record.O1;
};
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewChargeAddedCell = F2(
	function (model, ancillaryCharge) {
		var chargeAdded = A2(
			$justinmimbs$date$Date$fromPosix,
			model.J8,
			$author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$createdAt(
				$author$project$Api$Provider$Reports$AncillaryCharge$charge(ancillaryCharge)));
		return A2(
			$author$project$Ui$Table$cell,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, chargeAdded))
				]));
	});
var $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$category = function (_v0) {
	var record = _v0.b;
	return record.GW;
};
var $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$name = function (_v0) {
	var shared = _v0.a;
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		$author$project$Api$Provider$Charge$Shared$name(shared));
};
var $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$totalInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Charge$Shared$totalInCents(shared);
};
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewChargeDetailsCell = function (ancillaryCharge) {
	var totalAmountInCents = $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$totalInCents(
		$author$project$Api$Provider$Reports$AncillaryCharge$charge(ancillaryCharge));
	var chargeCategory = $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$category(
		$author$project$Api$Provider$Reports$AncillaryCharge$charge(ancillaryCharge));
	return A2(
		$author$project$Ui$Table$cell,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$name(
					$author$project$Api$Provider$Reports$AncillaryCharge$charge(ancillaryCharge))),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2($elm$core$Maybe$map, $author$project$Api$Provider$Category$Min$name, chargeCategory)))
					])),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Utils$Currency$fromInt(totalAmountInCents))
					]))
			]));
};
var $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$patient = function (_v0) {
	var record = _v0.b;
	return record.YY;
};
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewPatientCell = function (ancillaryCharge) {
	var patientName = $author$project$Api$Provider$Patient$Min$name(
		$author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$patient(
			$author$project$Api$Provider$Reports$AncillaryCharge$charge(ancillaryCharge)));
	return A2(
		$author$project$Ui$Table$cell,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(patientName)
			]));
};
var $author$project$Api$Provider$Reports$AncillaryCharge$sponsor = function (_v0) {
	var record = _v0;
	return record.abX;
};
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewSponsorCell = function (ancillaryCharge) {
	return A2(
		$author$project$Ui$Table$cell,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Api$Provider$Company$Min$name(
					$author$project$Api$Provider$Reports$AncillaryCharge$sponsor(ancillaryCharge)))
			]));
};
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewMiniAncillaryCharge = F2(
	function (model, ancillaryCharge) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewChargeAddedCell, model, ancillaryCharge),
					$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewSponsorCell(ancillaryCharge),
					$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewPatientCell(ancillaryCharge),
					$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewAffiliateCell(ancillaryCharge),
					$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewChargeDetailsCell(ancillaryCharge)
				]));
	});
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewCompanyResourceFilter = function (companyResourceFilter) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$CompanyResourceFilterMsg,
		A2(
			$author$project$Components$ResourceFilter$Company$view,
			_List_fromArray(
				[
					$author$project$Components$ResourceFilter$style(1),
					$author$project$Components$ResourceFilter$multi
				]),
			companyResourceFilter));
};
var $author$project$Components$ResourceFilter$Affiliates$Practice$viewMultiSelected = function (model) {
	return A2(
		$elm$core$List$map,
		$elm$html$Html$map($elm$core$Basics$identity),
		A2($author$project$Components$ResourceFilter$viewMultiSelected, model.Jy, model.b8));
};
var $author$project$Components$ResourceFilter$Affiliates$Practice$view = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$view,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.Jy),
					options),
				model.b8));
	});
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewPracticeResourceFilter = function (practiceResourceFilter) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$PracticeResourceFilterMsg,
		A2(
			$author$project$Components$ResourceFilter$Affiliates$Practice$view,
			_List_fromArray(
				[
					$author$project$Components$ResourceFilter$style(1),
					$author$project$Components$ResourceFilter$multi
				]),
			practiceResourceFilter));
};
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewMiniFilters = function (model) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$itemsCenter,
							$author$project$Ui$Grid$spanLg(2)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Charge Added Date')
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanLg(2)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$DateRangeInputMsg,
							$author$project$Components$DateRangeInput$view(model.i4))
						]))
				])),
			A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanLg(2)
						]),
					_List_fromArray(
						[
							$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewCompanyResourceFilter(model.mZ)
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanLg(2)
						]),
					_List_fromArray(
						[
							$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewPracticeResourceFilter(model.kL)
						]))
				])),
			A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_Nil,
					function () {
						var activeFilters = _Utils_ap(
							A2(
								$elm$core$List$map,
								$elm$html$Html$map($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$CompanyResourceFilterMsg),
								$author$project$Components$ResourceFilter$Company$viewMultiSelected(model.mZ)),
							A2(
								$elm$core$List$map,
								$elm$html$Html$map($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$PracticeResourceFilterMsg),
								$author$project$Components$ResourceFilter$Affiliates$Practice$viewMultiSelected(model.kL)));
						return $elm$core$List$isEmpty(activeFilters) ? _List_Nil : _List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$mt2, $author$project$Ui$Element$mb2]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Active filters')
											]))
									])),
								A2($elm$html$Html$span, _List_Nil, activeFilters)
							]);
					}())
				]))
		]);
};
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$PaginationMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewPagination = function (model) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$PaginationMsg,
		A2(
			$author$project$Api$Pagination$view,
			_List_fromArray(
				[
					$author$project$Ui$Pagination$List$loading(
					!$author$project$Utils$Maybe$toBool(
						$author$project$Api$Data$toMaybe(model.aF)))
				]),
			model.ajJ));
};
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewMini = function (model) {
	var _v0 = function () {
		var _v1 = model.aF;
		if (_v1.$ === 3) {
			var charges = _v1.a;
			return _Utils_Tuple2(false, charges);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var ancillaryCharges = _v0.b;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewMiniFilters(model)),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A4(
								$author$project$Ui$Table$view,
								_List_fromArray(
									[
										$author$project$Ui$Table$zeroState(
										_List_fromArray(
											[
												$elm$html$Html$text('No matching results.')
											])),
										$author$project$Ui$Table$loading(loading)
									]),
								$elm$core$List$concat(
									_List_fromArray(
										[
											A2(
											$elm$core$List$map,
											$author$project$Api$Column$view($author$project$Api$Column$NonSortable),
											$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$initMiniColumns),
											_List_fromArray(
											[
												A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
											])
										])),
								A2(
									$elm$core$List$map,
									$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewMiniAncillaryCharge(model),
									ancillaryCharges),
								_List_Nil)
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewPagination(model)
							]))
					]))
			]));
};
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$viewAncillaryChargesList = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('w-1/2')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Affiliate Ancillary Charges')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$Reports$AncillaryCharges$ViewDetails$AncillaryChargesListMsg,
								$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewMini(model.aF))
							]))
					]))
			]));
};
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$Close = {$: 1};
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$ApproveAncillaryCharge = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Reports$AncillaryCharge$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$viewApproveButton = function (ancillaryCharge) {
	return ($author$project$Api$Provider$Reports$AncillaryCharge$status(ancillaryCharge) !== 'approved') ? A3(
		$author$project$Ui$Button$view,
		{mm: 'Approve charge'},
		_List_fromArray(
			[
				$author$project$Ui$Button$primary,
				$author$project$Ui$Button$onClick(
				$author$project$Components$Reports$AncillaryCharges$ViewDetails$ApproveAncillaryCharge(ancillaryCharge))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Approve')
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$viewCategory = function (model) {
	var chargeCategory = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$Category$Min$name,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$Basics$identity,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeR, $author$project$Api$Provider$Reports$AncillaryCharge$charge, $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$category),
					model.lc))));
	return A2(
		$author$project$Ui$Grid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$spanMd(4),
						$author$project$Ui$Grid$justifyRight
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Category')
							]),
						_List_Nil)
					])),
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$spanMd(4)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(chargeCategory)
							]))
					])),
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$spanMd(4)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('category-resource-filter')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Static$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Components$Reports$AncillaryCharges$ViewDetails$CategoryResourceFilterMsg,
										A2(
											$author$project$Components$ResourceFilter$Category$view,
											_List_fromArray(
												[
													$author$project$Components$ResourceFilter$style(0)
												]),
											model.c8))
									]))
							]))
					]))
			]));
};
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$viewChargeName = function (model) {
	var chargeName = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Api$Provider$Reports$AncillaryCharge$charge, $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$name),
			model.lc));
	return A2(
		$author$project$Ui$Grid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$spanMd(4),
						$author$project$Ui$Grid$justifyRight
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Charge')
							]),
						_List_Nil)
					])),
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$spanMd(4)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(chargeName)
							]))
					])),
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$spanMd(4)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(chargeName)
							]))
					]))
			]));
};
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$viewCoveragePlanName = function (model) {
	var planName = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$CoveragePlan$One$name,
			A2($elm$core$Maybe$andThen, $author$project$Api$Provider$AffiliateAncillaryCharge$networkCoveragePlan, model.w0)));
	return A2(
		$author$project$Ui$Grid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$spanMd(4),
						$author$project$Ui$Grid$justifyRight
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Coverage Plan')
							]),
						_List_Nil)
					])),
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$spanMd(4)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(planName)
							]))
					]))
			]));
};
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$viewNetworkCoverageDocuments = function (coverageDouments) {
	if (!coverageDouments.$) {
		var coverageDocuments_ = coverageDouments.a;
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mb3]),
			_List_fromArray(
				[
					$author$project$Components$Admin$CoverageDocuments$Form$viewAsList(coverageDocuments_)
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$viewCoverageRules = function (model) {
	var _v0 = model.XA;
	if (!_v0.$) {
		var networkRules = _v0.a;
		var coverageDocuments = A2($elm$core$Maybe$map, $author$project$Api$Provider$CoveragePlan$One$coverageDocuments, model.OT);
		return A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanMd(12)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$labelSpanSm(1),
									$author$project$Ui$Form$Group$inputSpanSm(11),
									$author$project$Ui$Form$Group$label('')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Components$Reports$AncillaryCharges$ViewDetails$viewNetworkCoverageDocuments(coverageDocuments),
											A2(
											$elm$html$Html$map,
											$author$project$Components$Reports$AncillaryCharges$ViewDetails$NetworkCoveragePlanMsg,
											$author$project$Components$Admin$CoveragePlans$Rules$view(networkRules))
										]))
								]))
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$viewHeaders = A2(
	$author$project$Ui$Grid$row,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Grid$column,
			_List_fromArray(
				[
					$author$project$Ui$Grid$spanMd(4)
				]),
			_List_fromArray(
				[
					A2($elm$html$Html$div, _List_Nil, _List_Nil)
				])),
			A2(
			$author$project$Ui$Grid$column,
			_List_fromArray(
				[
					$author$project$Ui$Grid$spanMd(4)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$title,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Affiliate Invoice')
						]))
				])),
			A2(
			$author$project$Ui$Grid$column,
			_List_fromArray(
				[
					$author$project$Ui$Grid$spanMd(4)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$title,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Sponsor Invoice')
						]))
				]))
		]));
var $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$date = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Charge$Shared$date(shared);
};
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$viewServiceDate = function (model) {
	var chargeDate = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Api$Provider$Reports$AncillaryCharge$charge,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$date,
					$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full))),
			model.lc));
	return A2(
		$author$project$Ui$Grid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$spanMd(4),
						$author$project$Ui$Grid$justifyRight
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Service Date')
							]),
						_List_Nil)
					])),
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$spanMd(4)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(chargeDate)
							]))
					]))
			]));
};
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$viewChargeDetails = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('w-1/2 view-details')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_fromArray(
							[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Charge Details')
									])),
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Close details'},
								_List_fromArray(
									[
										$author$project$Ui$Button$close,
										$author$project$Ui$Button$onClick($author$project$Components$Reports$AncillaryCharges$ViewDetails$Close)
									]),
								_List_Nil)
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Components$Reports$AncillaryCharges$ViewDetails$viewHeaders,
										$author$project$Components$Reports$AncillaryCharges$ViewDetails$viewChargeName(model),
										$author$project$Components$Reports$AncillaryCharges$ViewDetails$viewCategory(model),
										$author$project$Ui$HorizontalRule$view(_List_Nil),
										$author$project$Components$Reports$AncillaryCharges$ViewDetails$viewServiceDate(model),
										$author$project$Components$Reports$AncillaryCharges$ViewDetails$viewCoveragePlanName(model),
										$author$project$Components$Reports$AncillaryCharges$ViewDetails$viewCoverageRules(model)
									]))
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_fromArray(
							[$author$project$Ui$Element$justifyRight]),
						_List_fromArray(
							[
								A2(
								$elm$core$Maybe$withDefault,
								$elm$html$Html$text(''),
								A2($elm$core$Maybe$map, $author$project$Components$Reports$AncillaryCharges$ViewDetails$viewApproveButton, model.lc))
							]))
					]))
			]));
};
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex')
			]),
		_List_fromArray(
			[
				$author$project$Components$Reports$AncillaryCharges$ViewDetails$viewAncillaryChargesList(model),
				$author$project$Components$Reports$AncillaryCharges$ViewDetails$viewChargeDetails(model)
			]));
};
var $author$project$Pages$Reports$AncillaryCharges$Id_String$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Reports$AncillaryCharges$ViewDetails$view(model.q1))
			]),
		ac9: 'Reports | Affiliate Ancillary Charges'
	};
};
var $author$project$Pages$Reports$AncillaryCharges$Id_String$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Reports$AncillaryCharges$Id_String$init, aiq: $author$project$Pages$Reports$AncillaryCharges$Id_String$load, k8: $author$project$Pages$Reports$AncillaryCharges$Id_String$save, alO: $author$project$Pages$Reports$AncillaryCharges$Id_String$subscriptions, adT: $author$project$Pages$Reports$AncillaryCharges$Id_String$update, amo: $author$project$Pages$Reports$AncillaryCharges$Id_String$view});
var $author$project$Pages$Reports$AncillaryCharges$Top$AncillaryChargesMsg = $elm$core$Basics$identity;
var $author$project$Pages$Reports$AncillaryCharges$Top$init = F4(
	function (_v0, practice, shared, _v1) {
		var query = _v1.DE;
		var _v2 = A4($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$init, practice, shared, query, $elm$core$Maybe$Nothing);
		var ancillaryChargesModel = _v2.a;
		var ancillaryChargesCmd = _v2.b;
		return _Utils_Tuple2(
			{aF: ancillaryChargesModel, Gv: shared.Gv, ZV: practice},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, ancillaryChargesCmd));
	});
var $author$project$Pages$Reports$AncillaryCharges$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$AncillaryCharges$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$ResourceFilter$Affiliates$Practice$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.b8));
};
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$ExportCsvMsg,
				$author$project$Components$ExportCsv$subscriptions(model.nD)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$PracticeResourceFilterMsg,
				$author$project$Components$ResourceFilter$Affiliates$Practice$subscriptions(model.kL)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$CompanyResourceFilterMsg,
				$author$project$Components$ResourceFilter$Company$subscriptions(model.mZ))
			]));
};
var $author$project$Pages$Reports$AncillaryCharges$Top$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$subscriptions(model.aF));
};
var $author$project$Pages$Reports$AncillaryCharges$Top$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$update, subMsg, model.aF, model.Gv);
		var ancillaryChargesModel = _v1.a;
		var cmd = _v1.b;
		var outMsgs = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{aF: ancillaryChargesModel}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd),
			outMsgs);
	});
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$ApproveAncillaryCharge = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$buildViewDetailsRoute = function (model) {
	return $author$project$Ui$Link$routeParams(
		$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$buildQueryParams(model));
};
var $author$project$Api$Provider$Reports$AncillaryCharge$sponsorCharge = function (_v0) {
	var record = _v0;
	return record.abY;
};
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewApprovedSponsorInvoice = function (ancillaryCharge) {
	var sponsorInvoice = A2(
		$elm$core$Maybe$andThen,
		$author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$invoice,
		$author$project$Api$Provider$Reports$AncillaryCharge$sponsorCharge(ancillaryCharge));
	if (!sponsorInvoice.$) {
		var sponsorInvoice_ = sponsorInvoice.a;
		var companyId = $author$project$Api$Provider$Company$Min$id(
			$author$project$Api$Provider$Reports$AncillaryCharge$sponsor(ancillaryCharge));
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$textCenter]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Link$route,
					$author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String(
						{
							fZ: companyId,
							ahP: $author$project$Api$Common$Payable$Invoice$Min$id(sponsorInvoice_)
						}),
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							'#' + $elm$core$String$fromInt(
								$author$project$Api$Common$Payable$Invoice$Min$invoiceNumber(sponsorInvoice_)))
						]))
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewSponsorInvoiceCell = F2(
	function (model, ancillaryCharge) {
		return A2(
			$author$project$Ui$Table$cell,
			_List_fromArray(
				[$author$project$Ui$Table$noWrap]),
			_List_fromArray(
				[
					($author$project$Api$Provider$Reports$AncillaryCharge$status(ancillaryCharge) === 'approved') ? $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewApprovedSponsorInvoice(ancillaryCharge) : A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$textCenter]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Approve ancilliary chage'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$onClick(
									$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$ApproveAncillaryCharge(ancillaryCharge))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Approve')
								])),
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Reports__AncillaryCharges__Id_String(
								{
									ahP: $author$project$Api$Provider$Reports$AncillaryCharge$id(ancillaryCharge)
								}),
							_List_fromArray(
								[
									$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$buildViewDetailsRoute(model),
									$author$project$Ui$Link$buttonSecondary
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('View Details')
								]))
						]))
				]));
	});
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewAncillaryCharge = F2(
	function (model, ancillaryCharge) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewChargeAddedCell, model, ancillaryCharge),
					$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewSponsorCell(ancillaryCharge),
					$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewPatientCell(ancillaryCharge),
					$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewAffiliateCell(ancillaryCharge),
					$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewChargeDetailsCell(ancillaryCharge),
					A2($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewSponsorInvoiceCell, model, ancillaryCharge)
				]));
	});
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$view = F2(
	function (apiClient, model) {
		var _v0 = function () {
			var _v1 = model.aF;
			if (_v1.$ === 3) {
				var charges = _v1.a;
				return _Utils_Tuple2(false, charges);
			} else {
				return _Utils_Tuple2(true, _List_Nil);
			}
		}();
		var loading = _v0.a;
		var ancillaryCharges = _v0.b;
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$ExportCsvMsg,
				A3(
					$author$project$Components$ExportCsv$modal,
					apiClient,
					_List_fromArray(
						[
							$author$project$Components$ExportCsv$report(
							$author$project$Api$Data$totalCount(model.aF)),
							$author$project$Components$ExportCsv$reportParams(
							A2(
								$elm$core$Basics$composeL,
								$author$project$Api$Provider$Reports$AncillaryCharge$listOptionsToParams,
								$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$fetchAncillaryChargesParams(model))(model.ajJ))
						]),
					model.nD)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Affiliate Ancillary Charges')
									])),
								A2(
								$author$project$Ui$Grid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$itemsCenter,
												$author$project$Ui$Grid$spanMd(2)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Charge Added Date')
											])),
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$spanMd(6)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$DateRangeInputMsg,
												$author$project$Components$DateRangeInput$view(model.i4))
											]))
									])),
								A2(
								$author$project$Ui$Grid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$spanMd(2)
											]),
										_List_fromArray(
											[
												$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewCompanyResourceFilter(model.mZ)
											])),
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$spanMd(2)
											]),
										_List_fromArray(
											[
												$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewPracticeResourceFilter(model.kL)
											]))
									])),
								A2(
								$author$project$Ui$Grid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_Nil,
										function () {
											var activeFilters = _Utils_ap(
												A2(
													$elm$core$List$map,
													$elm$html$Html$map($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$CompanyResourceFilterMsg),
													$author$project$Components$ResourceFilter$Company$viewMultiSelected(model.mZ)),
												A2(
													$elm$core$List$map,
													$elm$html$Html$map($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$PracticeResourceFilterMsg),
													$author$project$Components$ResourceFilter$Affiliates$Practice$viewMultiSelected(model.kL)));
											return $elm$core$List$isEmpty(activeFilters) ? _List_Nil : _List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$mt2, $author$project$Ui$Element$mb2]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$strong,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Active filters')
																]))
														])),
													A2($elm$html$Html$span, _List_Nil, activeFilters)
												]);
										}())
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A4(
								$author$project$Ui$Table$view,
								_List_fromArray(
									[
										$author$project$Ui$Table$zeroState(
										_List_fromArray(
											[
												$elm$html$Html$text('You don\'t have any results for the time period and filters selected. Try broadening your search to see more results.')
											])),
										$author$project$Ui$Table$loading(loading)
									]),
								$elm$core$List$concat(
									_List_fromArray(
										[
											A2(
											$elm$core$List$map,
											$author$project$Api$Column$view($author$project$Api$Column$NonSortable),
											model.N3),
											_List_fromArray(
											[
												A2(
												$author$project$Ui$Table$header,
												_List_fromArray(
													[$author$project$Ui$Table$textRight]),
												_List_fromArray(
													[
														A2($elm$html$Html$map, $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$ExportCsvMsg, $author$project$Components$ExportCsv$button)
													]))
											])
										])),
								A2(
									$elm$core$List$map,
									$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewAncillaryCharge(model),
									ancillaryCharges),
								_List_Nil)
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewPagination(model)
							]))
					]))
			]);
	});
var $author$project$Pages$Reports$AncillaryCharges$Top$view = function (model) {
	return {
		fO: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			A2($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$view, model.Gv, model.aF)),
		ac9: 'Reports | Affiliate Ancillary Charges'
	};
};
var $author$project$Pages$Reports$AncillaryCharges$Top$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Reports$AncillaryCharges$Top$init, aiq: $author$project$Pages$Reports$AncillaryCharges$Top$load, k8: $author$project$Pages$Reports$AncillaryCharges$Top$save, alO: $author$project$Pages$Reports$AncillaryCharges$Top$subscriptions, adT: $author$project$Pages$Reports$AncillaryCharges$Top$update, amo: $author$project$Pages$Reports$AncillaryCharges$Top$view});
var $author$project$Pages$Reports$CompanyInvoices$ReportMsg = $elm$core$Basics$identity;
var $author$project$Components$Reports$CompanyInvoices$CompanyResourceFilterMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Reports$CompanyInvoices$DateRangeInputMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Reports$CompanyInvoices$StatusDropdownMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Reports$CompanyInvoices$statusToString = function (status) {
	switch (status) {
		case 0:
			return 'issued,failed';
		case 1:
			return 'paid,processing';
		case 2:
			return 'paid';
		default:
			return 'processing';
	}
};
var $author$project$Components$Reports$CompanyInvoices$buildUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('start'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.dd, 0)),
			model.JV),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('end'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.dd, 0)),
			model.HB),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('status'),
			A2($elm$core$Maybe$map, $author$project$Components$Reports$CompanyInvoices$statusToString, model.alH)),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('company'),
			model.fZ)
		]);
	return A2(
		$elm$url$Url$Builder$relative,
		_List_fromArray(
			[
				$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__CompanyInvoices)
			]),
		A2(
			$elm$core$List$append,
			$author$project$Api$Pagination$toPageQuery(model.ajJ),
			A2(
				$elm$core$List$append,
				$author$project$Api$Sort$toQuery(model.alA),
				A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams))));
};
var $author$project$Components$Reports$CompanyInvoices$dateRangeInputSettings = F2(
	function (start, end) {
		var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
		return _Utils_update(
			defaultSettings,
			{ahy: start, al5: end});
	});
var $author$project$Components$Reports$CompanyInvoices$GotInvoices = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Reports$CompanyInvoices$fetchParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				afQ: model.fZ,
				HB: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.HB),
				ajJ: model.ajJ,
				alA: model.alA,
				JV: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.JV),
				alH: A2(
					$elm$core$Maybe$map,
					$elm$core$String$split(','),
					A2($elm$core$Maybe$map, $author$project$Components$Reports$CompanyInvoices$statusToString, model.alH))
			});
	};
};
var $author$project$Api$Provider$Reports$Invoice$Invoice = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$Invoice$Record = F9(
	function (id, invoiceDate, invoiceNumber, amountInCents, dueInCents, paidInCents, description, humanStatus, company) {
		return {LE: amountInCents, afQ: company, Qr: description, QY: dueInCents, TH: humanStatus, ahP: id, Uq: invoiceDate, Uu: invoiceNumber, YI: paidInCents};
	});
var $author$project$Api$Provider$Reports$Invoice$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'company',
	$author$project$Api$Provider$Company$Min$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'human_status',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'description',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'paid_in_cents',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'due_in_cents',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'amount_in_cents',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'invoice_number',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'invoice_date',
								$author$project$Utils$Date$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'id',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$Invoice$Record))))))))));
var $author$project$Api$Provider$Reports$Invoice$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Reports$Invoice$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$Invoice$listDefaults = {
	afQ: $elm$core$Maybe$Nothing,
	HB: $elm$core$Maybe$Nothing,
	ajJ: $author$project$Api$Pagination$init,
	alA: A3($author$project$Api$Sort$withDefault, 'date', 0, $author$project$Api$Sort$init),
	JV: $elm$core$Maybe$Nothing,
	alH: $elm$core$Maybe$Nothing
};
var $author$project$Api$Provider$Reports$Invoice$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Reports$Invoice$listDefaults);
	return A2(
		$elm$core$List$append,
		$author$project$Api$Pagination$toApiParams(options.ajJ),
		A2(
			$elm$core$List$append,
			$author$project$Api$Sort$toParams(options.alA),
			$elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						var _v0 = options.JV;
						if (!_v0.$) {
							var start_ = _v0.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'start', start_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v1 = options.HB;
						if (!_v1.$) {
							var end_ = _v1.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'end', end_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v2 = options.alH;
						if (!_v2.$) {
							var list_ = _v2.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$list, 'status', list_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v3 = options.afQ;
						if (!_v3.$) {
							var string = _v3.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'company', string)
								]);
						} else {
							return _List_Nil;
						}
					}()
					]))));
};
var $author$project$Api$Provider$Reports$Invoice$listPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['reports', 'invoices']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Reports$Invoice$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Reports$Invoice$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Reports$Invoice$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$Invoice$listPath)));
	});
var $author$project$Components$Reports$CompanyInvoices$fetchInvoices = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Api$Provider$Reports$Invoice$list,
			apiClient,
			$author$project$Components$Reports$CompanyInvoices$fetchParams(model),
			$author$project$Components$Reports$CompanyInvoices$GotInvoices);
	});
var $author$project$Components$Reports$CompanyInvoices$initColumns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'invoice_date', true, 'Date'),
		A3($author$project$Api$Column$init, 'invoice_number', true, 'Invoice Number'),
		A3($author$project$Api$Column$init, 'status', true, 'Invoice Status'),
		A3($author$project$Api$Column$init, 'amount_in_cents', true, 'Total'),
		A3($author$project$Api$Column$init, 'company', true, 'Company'),
		A3($author$project$Api$Column$init, 'description', false, 'Description')
	]);
var $author$project$Components$Reports$CompanyInvoices$IssuedOrFailed = 0;
var $author$project$Components$Reports$CompanyInvoices$Paid = 2;
var $author$project$Components$Reports$CompanyInvoices$PaidOrProcessing = 1;
var $author$project$Components$Reports$CompanyInvoices$Processing = 3;
var $author$project$Components$Reports$CompanyInvoices$statusFromString = function (status) {
	switch (status) {
		case 'issued,failed':
			return $elm$core$Maybe$Just(0);
		case 'paid,processing':
			return $elm$core$Maybe$Just(1);
		case 'paid':
			return $elm$core$Maybe$Just(2);
		case 'processing':
			return $elm$core$Maybe$Just(3);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Reports$CompanyInvoices$init = F3(
	function (practice, _v0, query) {
		var currentDate = _v0.dd;
		var apiClient = _v0.Gv;
		var companyId = A2($elm$core$Dict$get, 'company', query);
		var _v1 = $author$project$Utils$DateWithDefault$fromQuery(query);
		var start = _v1.a;
		var end = _v1.b;
		var _v2 = A2(
			$author$project$Components$DateRangeInput$init,
			'date-range-input',
			A2(
				$author$project$Components$Reports$CompanyInvoices$dateRangeInputSettings,
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					start),
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					end)));
		var dateRangeInput = _v2.a;
		var dateRangeInputCmd = _v2.b;
		var _v3 = A4(
			$author$project$Utils$Report$CompanyResourceFilter$init,
			apiClient,
			$elm$core$Basics$identity,
			$author$project$Api$Practice$Provider(practice),
			companyId);
		var companyResourceFilter = _v3.a;
		var companyResourceFilterCmd = _v3.b;
		var model = {
			N3: $author$project$Components$Reports$CompanyInvoices$initColumns,
			fZ: companyId,
			mZ: companyResourceFilter,
			dd: currentDate,
			i4: dateRangeInput,
			HB: end,
			nD: $author$project$Components$ExportCsv$initForPractice(3),
			sP: $author$project$Api$Data$Loading,
			ajJ: $author$project$Api$Pagination$initFromQuery(query),
			alA: A3(
				$author$project$Api$Sort$withDefault,
				'invoice_date',
				0,
				A2($author$project$Api$Sort$fromQuery, query, $author$project$Api$Sort$init)),
			JV: start,
			alH: $author$project$Components$Reports$CompanyInvoices$statusFromString(
				A2(
					$elm$core$Maybe$withDefault,
					'',
					A2($elm$core$Dict$get, 'status', query))),
			qn: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'status-dropdown', al6: $author$project$Components$Reports$CompanyInvoices$StatusDropdownMsg}))
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CompanyInvoices$DateRangeInputMsg, dateRangeInputCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CompanyInvoices$CompanyResourceFilterMsg, companyResourceFilterCmd),
						A2($author$project$Components$Reports$CompanyInvoices$fetchInvoices, apiClient, model),
						A2($elm$core$Basics$composeR, $author$project$Components$Reports$CompanyInvoices$buildUrl, $author$project$Ports$Navigation$replaceUrl)(model)
					])));
	});
var $author$project$Pages$Reports$CompanyInvoices$init = F4(
	function (_v0, practice, shared, _v1) {
		var query = _v1.DE;
		var _v2 = A3($author$project$Components$Reports$CompanyInvoices$init, practice, shared, query);
		var report = _v2.a;
		var reportCmd = _v2.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, ZV: practice, kV: report},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportCmd));
	});
var $author$project$Pages$Reports$CompanyInvoices$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$CompanyInvoices$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Reports$CompanyInvoices$ExportCsvMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Reports$CompanyInvoices$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$CompanyInvoices$DateRangeInputMsg,
				$author$project$Components$DateRangeInput$subscriptions(model.i4)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$CompanyInvoices$ExportCsvMsg,
				$author$project$Components$ExportCsv$subscriptions(model.nD)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$CompanyInvoices$CompanyResourceFilterMsg,
				$author$project$Components$ResourceFilter$Company$subscriptions(model.mZ)),
				$author$project$Ui$Dropdown$subscriptions(model.qn)
			]));
};
var $author$project$Pages$Reports$CompanyInvoices$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Reports$CompanyInvoices$subscriptions(model.kV));
};
var $author$project$Components$Reports$CompanyInvoices$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Components$DateRangeInput$update, subMsg, model.i4);
				var dateRangeInput = _v1.a;
				var subCmd = _v1.b;
				var event = _v1.c;
				var newModel = function () {
					if (event.$ === 1) {
						var fromDate = event.a;
						var toDate = event.b;
						return _Utils_update(
							model,
							{
								i4: dateRangeInput,
								HB: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
								sP: $author$project$Api$Data$Loading,
								ajJ: $author$project$Api$Pagination$reset(model.ajJ),
								JV: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
							});
					} else {
						return _Utils_update(
							model,
							{i4: dateRangeInput});
					}
				}();
				var cmds = (_Utils_eq(newModel.JV, model.JV) && _Utils_eq(newModel.HB, model.HB)) ? _List_Nil : _List_fromArray(
					[
						A2($author$project$Components$Reports$CompanyInvoices$fetchInvoices, apiClient, newModel),
						A2($elm$core$Basics$composeR, $author$project$Components$Reports$CompanyInvoices$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
					]);
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$cons,
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CompanyInvoices$DateRangeInputMsg, subCmd),
							cmds)),
					_List_Nil);
			case 1:
				var subMsg = msg.a;
				var _v3 = A2($author$project$Ui$Dropdown$update, subMsg, model.qn);
				var statusDropdown = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qn: statusDropdown}),
					cmd,
					_List_Nil);
			case 2:
				var status = msg.a;
				var newModel = _Utils_update(
					model,
					{
						sP: $author$project$Api$Data$Loading,
						ajJ: $author$project$Api$Pagination$reset(model.ajJ),
						alH: status
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$CompanyInvoices$fetchInvoices, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$CompanyInvoices$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 3:
				var subMsg = msg.a;
				var companyResourceResult = A3($author$project$Components$ResourceFilter$Company$update, apiClient, subMsg, model.mZ);
				var companyId = function () {
					var _v5 = companyResourceResult.agZ;
					if (!_v5.$) {
						return $author$project$Components$ResourceFilter$Company$value(companyResourceResult.aiO);
					} else {
						return model.fZ;
					}
				}();
				var newModel = _Utils_update(
					model,
					{fZ: companyId, mZ: companyResourceResult.aiO});
				var _v4 = _Utils_eq(model.fZ, newModel.fZ) ? _Utils_Tuple2(model.sP, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					$author$project$Api$Data$Loading,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$CompanyInvoices$fetchInvoices, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$CompanyInvoices$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])));
				var invoices = _v4.a;
				var cmd = _v4.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{sP: invoices}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CompanyInvoices$CompanyResourceFilterMsg, companyResourceResult.GZ),
								cmd
							])),
					companyResourceResult.aR);
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								sP: response,
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{sP: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 5:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{sP: $author$project$Api$Data$Loading, ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$CompanyInvoices$fetchInvoices, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$CompanyInvoices$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 6:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						alA: A2($author$project$Api$Sort$update, columnId, model.alA)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$CompanyInvoices$fetchInvoices, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$CompanyInvoices$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v7 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.nD);
				var exportCsv = _v7.a;
				var subCmd = _v7.b;
				var subOutMsg = _v7.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nD: exportCsv}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CompanyInvoices$ExportCsvMsg, subCmd),
					subOutMsg);
		}
	});
var $author$project$Pages$Reports$CompanyInvoices$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Reports$CompanyInvoices$update, model.Gv, subMsg, model.kV);
		var report = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{kV: report}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Components$Reports$CompanyInvoices$PaginationMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Reports$CompanyInvoices$intFromHeader = F2(
	function (headers, name) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$String$toInt,
				A2($elm$core$Dict$get, name, headers)));
	});
var $author$project$Components$Reports$CompanyInvoices$viewCompanyResourceFilter = function (companyResourceFilter) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Reports$CompanyInvoices$CompanyResourceFilterMsg,
		A2(
			$author$project$Components$ResourceFilter$Company$view,
			_List_fromArray(
				[
					$author$project$Components$ResourceFilter$style(1),
					$author$project$Components$ResourceFilter$multi
				]),
			companyResourceFilter));
};
var $author$project$Components$Reports$CompanyInvoices$StatusSelected = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Reports$CompanyInvoices$statusToDisplayName = function (status) {
	switch (status) {
		case 0:
			return 'Issued (Overdue, Viewed, Sent, Failed)';
		case 1:
			return 'Collected (Paid, Processing)';
		case 2:
			return 'Paid';
		default:
			return 'Processing';
	}
};
var $author$project$Components$Reports$CompanyInvoices$statusDropdownItems = function (currentStatus) {
	return A2(
		$elm$core$List$cons,
		A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Components$Reports$CompanyInvoices$StatusSelected($elm$core$Maybe$Nothing)),
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(currentStatus, $elm$core$Maybe$Nothing))
				]),
			$elm$html$Html$text('All Statuses')),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$Dropdown$separator,
			A2(
				$elm$core$List$map,
				function (status) {
					return A2(
						$author$project$Ui$Dropdown$item,
						_List_fromArray(
							[
								$author$project$Ui$Dropdown$onSelect(
								$author$project$Components$Reports$CompanyInvoices$StatusSelected(
									$elm$core$Maybe$Just(status))),
								$author$project$Ui$Dropdown$selected(
								_Utils_eq(
									currentStatus,
									$elm$core$Maybe$Just(status)))
							]),
						$elm$html$Html$text(
							$author$project$Components$Reports$CompanyInvoices$statusToDisplayName(status)));
				},
				_List_fromArray(
					[0, 1, 2, 3]))));
};
var $author$project$Components$Reports$CompanyInvoices$viewStatusDropdown = function (model) {
	var placeholder = function () {
		var _v0 = model.alH;
		if (!_v0.$) {
			var status = _v0.a;
			return $author$project$Components$Reports$CompanyInvoices$statusToDisplayName(status);
		} else {
			return 'Status';
		}
	}();
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(placeholder)
			]),
		$author$project$Components$Reports$CompanyInvoices$statusDropdownItems(model.alH),
		model.qn);
};
var $author$project$Components$Reports$CompanyInvoices$SortTable = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$Reports$Invoice$amountInCents = function (_v0) {
	var record = _v0;
	return record.LE;
};
var $author$project$Api$Provider$Reports$Invoice$company = function (_v0) {
	var record = _v0;
	return record.afQ;
};
var $author$project$Api$Provider$Reports$Invoice$description = function (_v0) {
	var record = _v0;
	return record.Qr;
};
var $author$project$Api$Provider$Reports$Invoice$dueInCents = function (_v0) {
	var record = _v0;
	return record.QY;
};
var $author$project$Api$Provider$Reports$Invoice$humanStatus = function (_v0) {
	var record = _v0;
	return record.TH;
};
var $author$project$Api$Provider$Reports$Invoice$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Reports$Invoice$invoiceDate = function (_v0) {
	var record = _v0;
	return record.Uq;
};
var $author$project$Api$Provider$Reports$Invoice$invoiceNumber = function (_v0) {
	var record = _v0;
	return record.Uu;
};
var $author$project$Api$Provider$Reports$Invoice$paidInCents = function (_v0) {
	var record = _v0;
	return record.YI;
};
var $author$project$Components$Reports$CompanyInvoices$viewRow = function (invoice) {
	var company = $author$project$Api$Provider$Reports$Invoice$company(invoice);
	return A2(
		$author$project$Ui$Table$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$author$project$Formatters$Date$toString,
							$author$project$Formatters$Date$Full,
							$author$project$Api$Provider$Reports$Invoice$invoiceDate(invoice)))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String(
							{
								fZ: $author$project$Api$Provider$Company$Min$id(company),
								ahP: $author$project$Api$Provider$Reports$Invoice$id(invoice)
							}),
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(
									$author$project$Api$Provider$Reports$Invoice$invoiceNumber(invoice)))
							]))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Badge$fromString,
						_List_Nil,
						$author$project$Api$Provider$Reports$Invoice$humanStatus(invoice))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Utils$Currency$fromInt(
							$author$project$Api$Provider$Reports$Invoice$amountInCents(invoice))),
						(($author$project$Api$Provider$Reports$Invoice$dueInCents(invoice) > 0) && ($author$project$Api$Provider$Reports$Invoice$paidInCents(invoice) > 0)) ? $elm$html$Html$text(
						$author$project$Utils$Currency$fromInt(
							$author$project$Api$Provider$Reports$Invoice$dueInCents(invoice)) + ' due') : $author$project$Utils$Html$empty
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Companies__CompanyId_String__Top(
							{
								fZ: $author$project$Api$Provider$Company$Min$id(company)
							}),
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Api$Provider$Company$Min$name(company))
							]))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$author$project$Formatters$String$ellipsis,
							20,
							$author$project$Api$Provider$Reports$Invoice$description(invoice)))
					]))
			]));
};
var $author$project$Components$Reports$CompanyInvoices$viewTable = function (model) {
	var _v0 = function () {
		var _v1 = model.sP;
		if (_v1.$ === 3) {
			var invoices_ = _v1.a;
			return _Utils_Tuple2(false, invoices_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var invoices = _v0.b;
	return A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$map,
					$author$project$Api$Column$view(
						A2($author$project$Api$Column$Sortable, model.alA, $author$project$Components$Reports$CompanyInvoices$SortTable)),
					model.N3),
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[$author$project$Ui$Table$textRight]),
						_List_fromArray(
							[
								A2($elm$html$Html$map, $author$project$Components$Reports$CompanyInvoices$ExportCsvMsg, $author$project$Components$ExportCsv$button)
							]))
					])
				])),
		A2($elm$core$List$map, $author$project$Components$Reports$CompanyInvoices$viewRow, invoices),
		_List_Nil);
};
var $author$project$Components$Reports$CompanyInvoices$view = F2(
	function (apiClient, model) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Reports$CompanyInvoices$ExportCsvMsg,
				A3(
					$author$project$Components$ExportCsv$modal,
					apiClient,
					_List_fromArray(
						[
							$author$project$Components$ExportCsv$report(
							$author$project$Api$Data$totalCount(model.sP)),
							$author$project$Components$ExportCsv$reportParams(
							A2($elm$core$Basics$composeL, $author$project$Api$Provider$Reports$Invoice$listOptionsToParams, $author$project$Components$Reports$CompanyInvoices$fetchParams)(model))
						]),
					model.nD)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Employer Invoices')
									])),
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								function () {
									var _v0 = model.sP;
									if (_v0.$ === 3) {
										var headers = _v0.b;
										var totalDueAmount = A2($author$project$Components$Reports$CompanyInvoices$intFromHeader, headers, 'x-total-due-amount');
										return _List_fromArray(
											[
												$elm$html$Html$text(
												'Total: ' + $author$project$Utils$Currency$fromInt(
													A2($author$project$Components$Reports$CompanyInvoices$intFromHeader, headers, 'x-total-amount'))),
												(totalDueAmount > 0) ? $author$project$Ui$Typography$headingSm(
												_List_fromArray(
													[
														$elm$html$Html$text(
														'Total Due: ' + $author$project$Utils$Currency$fromInt(totalDueAmount))
													])) : $author$project$Utils$Html$empty
											]);
									} else {
										return _List_fromArray(
											[
												$author$project$Ui$Spinner$view(_List_Nil)
											]);
									}
								}()),
								A2(
								$elm$html$Html$map,
								$author$project$Components$Reports$CompanyInvoices$DateRangeInputMsg,
								$author$project$Components$DateRangeInput$view(model.i4)),
								A2(
								$author$project$Ui$Grid$row,
								_List_fromArray(
									[$author$project$Ui$Grid$gutterSm]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(6),
												$author$project$Ui$Grid$spanSm(4),
												$author$project$Ui$Grid$spanMd(4)
											]),
										_List_fromArray(
											[
												$author$project$Components$Reports$CompanyInvoices$viewStatusDropdown(model)
											])),
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(5),
												$author$project$Ui$Grid$spanSm(3),
												$author$project$Ui$Grid$spanMd(4)
											]),
										_List_fromArray(
											[
												$author$project$Components$Reports$CompanyInvoices$viewCompanyResourceFilter(model.mZ)
											]))
									])),
								A2(
								$author$project$Ui$Grid$row,
								_List_fromArray(
									[$author$project$Ui$Grid$gutterSm]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_Nil,
										function () {
											var activeFilters = A2(
												$elm$core$List$map,
												$elm$html$Html$map($author$project$Components$Reports$CompanyInvoices$CompanyResourceFilterMsg),
												$author$project$Components$ResourceFilter$Company$viewMultiSelected(model.mZ));
											return $elm$core$List$isEmpty(activeFilters) ? _List_Nil : _List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$mt2, $author$project$Ui$Element$mb2]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$strong,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Active filters')
																]))
														])),
													A2($elm$html$Html$span, _List_Nil, activeFilters)
												]);
										}())
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Components$Reports$CompanyInvoices$viewTable(model)
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$Reports$CompanyInvoices$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(
											!$author$project$Utils$Maybe$toBool(
												$author$project$Api$Data$toMaybe(model.sP)))
										]),
									model.ajJ))
							]))
					]))
			]);
	});
var $author$project$Pages$Reports$CompanyInvoices$view = function (model) {
	return {
		fO: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			A2($author$project$Components$Reports$CompanyInvoices$view, model.Gv, model.kV)),
		ac9: 'Reports | ' + (A2($author$project$Formatters$String$sponsorize, model.ZV, 'Companies') + ' Invoices')
	};
};
var $author$project$Pages$Reports$CompanyInvoices$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Reports$CompanyInvoices$init, aiq: $author$project$Pages$Reports$CompanyInvoices$load, k8: $author$project$Pages$Reports$CompanyInvoices$save, alO: $author$project$Pages$Reports$CompanyInvoices$subscriptions, adT: $author$project$Pages$Reports$CompanyInvoices$update, amo: $author$project$Pages$Reports$CompanyInvoices$view});
var $author$project$Pages$Reports$CreditOutstanding$ReportMsg = $elm$core$Basics$identity;
var $author$project$Components$Reports$CreditOutstanding$Table = 0;
var $author$project$Components$Reports$CreditOutstanding$ByDropdownMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Report$Credit = 15;
var $author$project$Components$Reports$CreditOutstanding$CreditCategoryResourceFilterMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Reports$CreditOutstanding$DateRangeInputMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Reports$CreditOutstanding$GroupLocationAndPractitionerFiltersMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Reports$CreditOutstanding$dateRangeInputSettings = F2(
	function (start, end) {
		var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
		return _Utils_update(
			defaultSettings,
			{ahy: start, al5: end});
	});
var $author$project$Components$Reports$CreditOutstanding$GotCredits = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Reports$CreditOutstanding$fetchCreditsParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				O5: model.G6,
				HB: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.HB),
				ais: model.We,
				s4: model.gL,
				ajJ: model.ajJ,
				aka: model.Z2,
				alA: model.alA,
				JV: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.JV)
			});
	};
};
var $author$project$Api$Provider$Reports$Credit$Credit = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$Credit$Record = F8(
	function (issuedOn, expiresOn, balanceInCents, amountInCents, transferredInCents, patient, creditCategory, practitioner) {
		return {LE: amountInCents, afa: balanceInCents, O5: creditCategory, R0: expiresOn, Vn: issuedOn, YY: patient, aka: practitioner, adz: transferredInCents};
	});
var $author$project$Api$Provider$CreditCategory$Min$CreditCategory = $elm$core$Basics$identity;
var $author$project$Api$Provider$CreditCategory$Min$Record = function (name) {
	return {Bq: name};
};
var $author$project$Api$Provider$CreditCategory$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$CreditCategory$Min$Record));
var $author$project$Api$Provider$CreditCategory$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CreditCategory$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$Credit$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'practitioner',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Practitioner$Min$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'credit_category',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$CreditCategory$Min$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'patient',
			$elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Min$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'transferred_in_cents',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'amount_in_cents',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'balance_in_cents',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'expires_on',
							$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'issued_on',
								$author$project$Utils$Date$decode,
								$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$Credit$Record)))))))));
var $author$project$Api$Provider$Reports$Credit$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Reports$Credit$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$Credit$listDefaults = {O5: $elm$core$Maybe$Nothing, HB: $elm$core$Maybe$Nothing, ais: $elm$core$Maybe$Nothing, s4: $elm$core$Maybe$Nothing, ajJ: $author$project$Api$Pagination$init, aka: $elm$core$Maybe$Nothing, alA: $author$project$Api$Sort$init, JV: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$Reports$Credit$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Reports$Credit$listDefaults);
	return A2(
		$elm$core$List$append,
		$author$project$Api$Pagination$toApiParams(options.ajJ),
		A2(
			$elm$core$List$append,
			$author$project$Api$Sort$toParams(options.alA),
			$elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						var _v0 = options.JV;
						if (!_v0.$) {
							var start_ = _v0.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'start', start_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v1 = options.HB;
						if (!_v1.$) {
							var end_ = _v1.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'end', end_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v2 = options.aka;
						if (!_v2.$) {
							var practitioner_ = _v2.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'practitioner', practitioner_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v3 = options.O5;
						if (!_v3.$) {
							var taxJurisdiction_ = _v3.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'credit_category', taxJurisdiction_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v4 = options.s4;
						if (!_v4.$) {
							var locationGroup_ = _v4.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'location_group', locationGroup_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v5 = options.ais;
						if (!_v5.$) {
							var location_ = _v5.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'location', location_)
								]);
						} else {
							return _List_Nil;
						}
					}()
					]))));
};
var $author$project$Api$Provider$Reports$Credit$listPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['reports', 'credits']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Reports$Credit$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Reports$Credit$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Reports$Credit$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$Credit$listPath)));
	});
var $author$project$Components$Reports$CreditOutstanding$fetchCredits = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Api$Provider$Reports$Credit$list,
			apiClient,
			$author$project$Components$Reports$CreditOutstanding$fetchCreditsParams(model),
			$author$project$Components$Reports$CreditOutstanding$GotCredits);
	});
var $author$project$Components$Reports$CreditOutstanding$GotSummary = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Reports$CreditOutstanding$fetchSummaryParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				O5: model.G6,
				HB: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.HB),
				ais: model.We,
				s4: model.gL,
				aka: model.Z2,
				JV: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.JV)
			});
	};
};
var $author$project$Api$Provider$Reports$Credit$summary = F4(
	function (apiClient, by, optionals, toMsg) {
		return A5(
			$author$project$Api$Provider$Reports$Summary$retrieve,
			apiClient,
			$author$project$Api$Provider$Reports$Credit$listPath,
			by,
			$author$project$Api$Provider$Reports$Credit$listOptionsToParams(optionals),
			toMsg);
	});
var $author$project$Components$Reports$CreditOutstanding$fetchSummary = F2(
	function (apiClient, model) {
		return A4(
			$author$project$Api$Provider$Reports$Credit$summary,
			apiClient,
			A2($elm$core$Maybe$withDefault, '', model.co),
			$author$project$Components$Reports$CreditOutstanding$fetchSummaryParams(model),
			$author$project$Components$Reports$CreditOutstanding$GotSummary);
	});
var $author$project$Components$Reports$CreditOutstanding$fetchData = F2(
	function (apiClient, model) {
		var _v0 = model.amg;
		if (!_v0) {
			return A2($author$project$Components$Reports$CreditOutstanding$fetchCredits, apiClient, model);
		} else {
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Components$Reports$CreditOutstanding$fetchSummary, apiClient, model),
						A2($author$project$Components$Reports$CreditOutstanding$fetchCredits, apiClient, model)
					]));
		}
	});
var $author$project$Components$Reports$CreditOutstanding$initColumns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'issued_on', true, 'Issued On'),
		A3($author$project$Api$Column$init, 'expires_on', true, 'Expires On'),
		A3($author$project$Api$Column$init, 'amount_in_cents', true, 'Outstanding'),
		A3($author$project$Api$Column$init, 'patient', false, 'Patient'),
		A3($author$project$Api$Column$init, 'credit_category', true, 'Category'),
		A3($author$project$Api$Column$init, 'practitioner', true, 'Provider')
	]);
var $author$project$Components$Reports$CreditOutstanding$urlParams = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Tuple$pair('start'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.dd, 0)),
			model.JV),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Tuple$pair('end'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.dd, 0)),
			model.HB),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('credit_category'),
			model.G6),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('location_group'),
			model.gL),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('location'),
			model.We),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('practitioner'),
			model.Z2),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('by'),
			model.co)
		]);
	return $elm$core$Dict$fromList(
		A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams));
};
var $author$project$Components$Reports$CreditOutstanding$updateUrl = function (model) {
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					function () {
					var _v0 = model.co;
					if (!_v0.$) {
						return $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__CreditOutstanding__Summary);
					} else {
						return $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__CreditOutstanding);
					}
				}()
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.ajJ),
				A2(
					$elm$core$List$append,
					$author$project$Api$Sort$toQuery(model.alA),
					$author$project$Utils$QueryParameter$fromDict(
						$author$project$Components$Reports$CreditOutstanding$urlParams(model))))));
};
var $author$project$Components$Reports$CreditOutstanding$init = F5(
	function (type_, session, practice, _v0, query) {
		var currentDate = _v0.dd;
		var apiClient = _v0.Gv;
		var hinterViewOff = _v0.ahK;
		var practitionerId = A2($elm$core$Dict$get, 'practitioner', query);
		var locationId = A2($elm$core$Dict$get, 'location', query);
		var locationGroupId = A2($elm$core$Dict$get, 'location_group', query);
		var _v1 = function () {
			if (!type_) {
				return _Utils_Tuple2($author$project$Api$Data$Loading, $author$project$Api$Data$NotAsked);
			} else {
				return _Utils_Tuple2($author$project$Api$Data$NotAsked, $author$project$Api$Data$Loading);
			}
		}();
		var credits = _v1.a;
		var summary = _v1.b;
		var _v3 = A7($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$init, apiClient, session, practice, false, locationGroupId, locationId, practitionerId);
		var groupLocationAndPractitionerFilters = _v3.a;
		var groupLocationAndPractitionerFiltersCmd = _v3.b;
		var _v4 = $author$project$Utils$DateWithDefault$fromQuery(query);
		var start = _v4.a;
		var end = _v4.b;
		var _v5 = A2(
			$author$project$Components$DateRangeInput$init,
			'date-range-input',
			A2(
				$author$project$Components$Reports$CreditOutstanding$dateRangeInputSettings,
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					start),
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					end)));
		var dateRangeInput = _v5.a;
		var dateRangeInputCmd = _v5.b;
		var _v6 = A2(
			$author$project$Components$ResourceFilter$CreditCategory$init,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						Gp: 'All Categories',
						akb: A2($elm$core$Dict$get, 'credit_category', query)
					});
			});
		var creditCategoryResourceFilter = _v6.a;
		var creditCategoryResourceFilterCmd = _v6.b;
		var model = {
			co: A2($elm$core$Dict$get, 'by', query),
			mB: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'by-dropdown', al6: $author$project$Components$Reports$CreditOutstanding$ByDropdownMsg})),
			GQ: A3($author$project$Permission$canGoTo, session, hinterViewOff, 50),
			N3: $author$project$Components$Reports$CreditOutstanding$initColumns,
			G6: A2($elm$core$Dict$get, 'credit_category', query),
			f3: creditCategoryResourceFilter,
			bt: credits,
			dd: currentDate,
			i4: dateRangeInput,
			HB: end,
			nD: $author$project$Components$ExportCsv$initForPractice(15),
			dn: groupLocationAndPractitionerFilters,
			gL: locationGroupId,
			We: locationId,
			ajJ: $author$project$Api$Pagination$initFromQuery(query),
			Z2: practitionerId,
			alA: A3(
				$author$project$Api$Sort$withDefault,
				'issued_on',
				0,
				$author$project$Api$Sort$initFromQuery(query)),
			JV: start,
			acF: summary,
			amg: type_
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditOutstanding$DateRangeInputMsg, dateRangeInputCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditOutstanding$GroupLocationAndPractitionerFiltersMsg, groupLocationAndPractitionerFiltersCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditOutstanding$CreditCategoryResourceFilterMsg, creditCategoryResourceFilterCmd),
						A2($author$project$Components$Reports$CreditOutstanding$fetchData, apiClient, model),
						$author$project$Components$Reports$CreditOutstanding$updateUrl(model)
					])));
	});
var $author$project$Pages$Reports$CreditOutstanding$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.DE;
		var _v1 = A5($author$project$Components$Reports$CreditOutstanding$init, 0, session, practice, shared, query);
		var report = _v1.a;
		var reportTaxCmd = _v1.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, kV: report},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportTaxCmd));
	});
var $author$project$Pages$Reports$CreditOutstanding$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$CreditOutstanding$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Reports$CreditOutstanding$ExportCsvMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Reports$CreditOutstanding$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$CreditOutstanding$DateRangeInputMsg,
				$author$project$Components$DateRangeInput$subscriptions(model.i4)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$CreditOutstanding$ExportCsvMsg,
				$author$project$Components$ExportCsv$subscriptions(model.nD)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$CreditOutstanding$CreditCategoryResourceFilterMsg,
				$author$project$Components$ResourceFilter$CreditCategory$subscriptions(model.f3)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$CreditOutstanding$GroupLocationAndPractitionerFiltersMsg,
				$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$subscriptions(model.dn)),
				$author$project$Ui$Dropdown$subscriptions(model.mB)
			]));
};
var $author$project$Pages$Reports$CreditOutstanding$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Reports$CreditOutstanding$subscriptions(model.kV));
};
var $author$project$Components$ResourceFilter$CreditCategory$value = function (model) {
	return A2($author$project$Components$ResourceFilter$choiceToValue, model.b8, model.Jy);
};
var $author$project$Components$Reports$CreditOutstanding$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 2:
				var subMsg = msg.a;
				var result = A3($author$project$Components$ResourceFilter$CreditCategory$update, apiClient, subMsg, model.f3);
				var _v1 = result.agZ;
				if (!_v1.$) {
					var newCreditCategoryId = $author$project$Components$ResourceFilter$CreditCategory$value(result.aiO);
					var newModel = _Utils_update(
						model,
						{
							G6: newCreditCategoryId,
							f3: result.aiO,
							bt: $author$project$Api$Data$Loading,
							ajJ: $author$project$Api$Pagination$reset(model.ajJ)
						});
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditOutstanding$CreditCategoryResourceFilterMsg, result.GZ),
									A2($author$project$Components$Reports$CreditOutstanding$fetchData, apiClient, newModel),
									$author$project$Components$Reports$CreditOutstanding$updateUrl(newModel)
								])),
						result.aR);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{f3: result.aiO}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditOutstanding$CreditCategoryResourceFilterMsg, result.GZ),
						result.aR);
				}
			case 3:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Ui$Dropdown$update, subMsg, model.mB);
				var byDropdown = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{mB: byDropdown}),
					cmd,
					_List_Nil);
			case 4:
				var by = msg.a;
				var newModel = _Utils_update(
					model,
					{
						co: by,
						bt: $author$project$Api$Data$Loading,
						ajJ: $author$project$Api$Pagination$reset(model.ajJ)
					});
				var cmds = function () {
					var _v3 = _Utils_Tuple2(model.amg, newModel.co);
					if (!_v3.a) {
						if (!_v3.b.$) {
							var _v4 = _v3.a;
							return _List_fromArray(
								[
									$author$project$Components$Reports$CreditOutstanding$updateUrl(newModel)
								]);
						} else {
							var _v5 = _v3.a;
							var _v6 = _v3.b;
							return _List_fromArray(
								[$elm$core$Platform$Cmd$none]);
						}
					} else {
						if (_v3.b.$ === 1) {
							var _v7 = _v3.a;
							var _v8 = _v3.b;
							return _List_fromArray(
								[
									$author$project$Components$Reports$CreditOutstanding$updateUrl(newModel)
								]);
						} else {
							var _v9 = _v3.a;
							return _List_fromArray(
								[
									A2($author$project$Components$Reports$CreditOutstanding$fetchData, apiClient, newModel),
									$author$project$Components$Reports$CreditOutstanding$updateUrl(newModel)
								]);
						}
					}
				}();
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(cmds),
					_List_Nil);
			case 0:
				var subMsg = msg.a;
				var _v10 = A2($author$project$Components$DateRangeInput$update, subMsg, model.i4);
				var dateRangeInput = _v10.a;
				var subCmd = _v10.b;
				var event = _v10.c;
				var newModel = function () {
					if (event.$ === 1) {
						var fromDate = event.a;
						var toDate = event.b;
						return _Utils_update(
							model,
							{
								bt: $author$project$Api$Data$Loading,
								i4: dateRangeInput,
								HB: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
								ajJ: $author$project$Api$Pagination$reset(model.ajJ),
								JV: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
							});
					} else {
						return _Utils_update(
							model,
							{i4: dateRangeInput});
					}
				}();
				var cmds = (_Utils_eq(newModel.JV, model.JV) && _Utils_eq(newModel.HB, model.HB)) ? _List_Nil : _List_fromArray(
					[
						A2($author$project$Components$Reports$CreditOutstanding$fetchData, apiClient, newModel),
						$author$project$Components$Reports$CreditOutstanding$updateUrl(newModel)
					]);
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$cons,
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditOutstanding$DateRangeInputMsg, subCmd),
							cmds)),
					_List_Nil);
			case 1:
				var subMsg = msg.a;
				var result = A3($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$update, apiClient, subMsg, model.dn);
				var _v12 = result.agZ;
				if (!_v12.$) {
					var locationGroupId = _v12.a;
					var locationId = _v12.b;
					var practitionerId = _v12.c;
					var newModel = _Utils_update(
						model,
						{
							bt: $author$project$Api$Data$Loading,
							dn: result.aiO,
							gL: locationGroupId,
							We: locationId,
							ajJ: $author$project$Api$Pagination$reset(model.ajJ),
							Z2: practitionerId
						});
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditOutstanding$GroupLocationAndPractitionerFiltersMsg, result.GZ),
									A2($author$project$Components$Reports$CreditOutstanding$fetchData, apiClient, newModel),
									$author$project$Components$Reports$CreditOutstanding$updateUrl(newModel)
								])),
						result.aR);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dn: result.aiO}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditOutstanding$GroupLocationAndPractitionerFiltersMsg, result.GZ),
						result.aR);
				}
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bt: response,
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bt: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 6:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{acF: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 7:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{bt: $author$project$Api$Data$Loading, ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$CreditOutstanding$fetchData, apiClient, newModel),
								$author$project$Components$Reports$CreditOutstanding$updateUrl(newModel)
							])),
					_List_Nil);
			case 8:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						alA: A2($author$project$Api$Sort$update, columnId, model.alA)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$CreditOutstanding$fetchData, apiClient, newModel),
								$author$project$Components$Reports$CreditOutstanding$updateUrl(newModel)
							])),
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v14 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.nD);
				var exportCsv = _v14.a;
				var subCmd = _v14.b;
				var subOutMsg = _v14.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nD: exportCsv}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditOutstanding$ExportCsvMsg, subCmd),
					subOutMsg);
		}
	});
var $author$project$Pages$Reports$CreditOutstanding$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Reports$CreditOutstanding$update, model.Gv, subMsg, model.kV);
		var report = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{kV: report}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Components$Reports$CreditOutstanding$PaginationMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Reports$CreditOutstanding$amountFromHeader = F2(
	function (headers, name) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$String$toInt,
				A2($elm$core$Dict$get, name, headers)));
	});
var $author$project$Components$Reports$CreditOutstanding$BySelected = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Reports$CreditOutstanding$byDropdownItems = function (currentBy) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Components$Reports$CreditOutstanding$BySelected($elm$core$Maybe$Nothing)),
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(currentBy, $elm$core$Maybe$Nothing))
				]),
			$elm$html$Html$text('No Summary')),
			$author$project$Ui$Dropdown$separator,
			A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Components$Reports$CreditOutstanding$BySelected(
						$elm$core$Maybe$Just('credit_category'))),
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(
						currentBy,
						$elm$core$Maybe$Just('credit_category')))
				]),
			$elm$html$Html$text('Category')),
			A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Components$Reports$CreditOutstanding$BySelected(
						$elm$core$Maybe$Just('practitioner'))),
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(
						currentBy,
						$elm$core$Maybe$Just('practitioner')))
				]),
			$elm$html$Html$text('Provider'))
		]);
};
var $author$project$Components$Reports$CreditOutstanding$byToDisplayName = function (by) {
	switch (by) {
		case 'credit_category':
			return 'Category';
		case 'practitioner':
			return 'Provider';
		default:
			return by;
	}
};
var $author$project$Components$Reports$CreditOutstanding$viewByDropdown = function (model) {
	var placeholder = function () {
		var _v0 = model.co;
		if (!_v0.$) {
			var by = _v0.a;
			return $author$project$Components$Reports$CreditOutstanding$byToDisplayName(by);
		} else {
			return 'Summary By';
		}
	}();
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(placeholder)
			]),
		$author$project$Components$Reports$CreditOutstanding$byDropdownItems(model.co),
		model.mB);
};
var $author$project$Components$Reports$CreditOutstanding$viewCreditCategoryResourceFilter = function (model) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Reports$CreditOutstanding$CreditCategoryResourceFilterMsg,
		A2(
			$author$project$Components$ResourceFilter$CreditCategory$view,
			_List_fromArray(
				[$author$project$Components$ResourceFilter$multi]),
			model.f3));
};
var $author$project$Components$ResourceFilter$CreditCategory$viewMultiSelected = function (model) {
	return A2(
		$elm$core$List$map,
		$elm$html$Html$map($elm$core$Basics$identity),
		A2($author$project$Components$ResourceFilter$viewMultiSelected, model.Jy, model.b8));
};
var $author$project$Components$Reports$CreditOutstanding$viewSummaryRow = F2(
	function (model, summaryRow) {
		var routeParams = _List_fromArray(
			[
				$author$project$Ui$Link$routeParams(
				A2(
					$author$project$Utils$Report$summaryRowTableParams,
					$author$project$Components$Reports$CreditOutstanding$urlParams(model),
					summaryRow))
			]);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_fromArray(
								[
									$author$project$Ui$Typography$info,
									$author$project$Ui$Typography$phi(true)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Reports__CreditOutstanding,
									routeParams,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'None',
												$author$project$Api$Provider$Reports$Summary$summaryRowName(summaryRow)))
										]))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Reports__CreditOutstanding,
							routeParams,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$String$pluralize,
										'credit',
										$author$project$Api$Provider$Reports$Summary$summaryRowCount(summaryRow)))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$spaceBetween]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Reports__CreditOutstanding,
									routeParams,
									_List_fromArray(
										[
											$elm$html$Html$text('Outstanding')
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('numeric')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$strong,
											_List_Nil,
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Reports__CreditOutstanding,
													routeParams,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Utils$Currency$fromInt(
																$author$project$Api$Provider$Reports$Summary$summaryRowAmountInCents(summaryRow)))
														]))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Reports$CreditOutstanding$viewSummaryTable = function (model) {
	var summaryType = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Api$Provider$Reports$Summary$summaryType, $author$project$Formatters$String$humanize),
			$author$project$Api$Data$toMaybe(model.acF)));
	var summaryRows = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$Reports$Summary$summaryRows,
			$author$project$Api$Data$toMaybe(model.acF)));
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$loading(
				!$author$project$Api$Data$isSuccess(model.acF)),
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mb4]),
						_List_fromArray(
							[
								$elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
							]))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(summaryType)
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Number of Credits')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4),
						$author$project$Ui$Table$textRight
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Amount')
					]))
			]),
		A2(
			$elm$core$List$map,
			$author$project$Components$Reports$CreditOutstanding$viewSummaryRow(model),
			summaryRows),
		_List_Nil);
};
var $author$project$Components$Reports$CreditOutstanding$SortTable = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$Reports$Credit$amountInCents = function (_v0) {
	var record = _v0;
	return record.LE;
};
var $author$project$Api$Provider$Reports$Credit$balanceInCents = function (_v0) {
	var record = _v0;
	return record.afa;
};
var $author$project$Api$Provider$Reports$Credit$creditCategory = function (_v0) {
	var record = _v0;
	return record.O5;
};
var $author$project$Api$Provider$Reports$Credit$expiresOn = function (_v0) {
	var record = _v0;
	return record.R0;
};
var $author$project$Api$Provider$Reports$Credit$issuedOn = function (_v0) {
	var record = _v0;
	return record.Vn;
};
var $author$project$Api$Provider$CreditCategory$Min$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$Reports$Credit$patient = function (_v0) {
	var record = _v0;
	return record.YY;
};
var $author$project$Api$Provider$Reports$Credit$practitioner = function (_v0) {
	var record = _v0;
	return record.aka;
};
var $author$project$Api$Provider$Reports$Credit$transferredInCents = function (_v0) {
	var record = _v0;
	return record.adz;
};
var $author$project$Components$Reports$CreditOutstanding$viewRow = F2(
	function (canGoToPatients, credit) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$author$project$Formatters$Date$toString,
								$author$project$Formatters$Date$Full,
								$author$project$Api$Provider$Reports$Credit$issuedOn(credit)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
									$author$project$Api$Provider$Reports$Credit$expiresOn(credit))))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$Currency$fromInt(
								$author$project$Api$Provider$Reports$Credit$balanceInCents(credit))),
							($author$project$Api$Provider$Reports$Credit$amountInCents(credit) > 0) ? A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									(!_Utils_eq(
									$author$project$Api$Provider$Reports$Credit$balanceInCents(credit),
									$author$project$Api$Provider$Reports$Credit$amountInCents(credit))) ? A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$Reports$Credit$amountInCents(credit))) : $author$project$Utils$Html$empty,
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
									' Issued')
								])) : $author$project$Utils$Html$empty,
							($author$project$Api$Provider$Reports$Credit$transferredInCents(credit) > 0) ? A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									(!_Utils_eq(
									$author$project$Api$Provider$Reports$Credit$balanceInCents(credit),
									$author$project$Api$Provider$Reports$Credit$transferredInCents(credit))) ? A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$Reports$Credit$transferredInCents(credit))) : $author$project$Utils$Html$empty,
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
									' Transferred')
								])) : $author$project$Utils$Html$empty
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					function () {
						var _v0 = _Utils_Tuple2(
							$author$project$Api$Provider$Reports$Credit$patient(credit),
							canGoToPatients);
						if (!_v0.a.$) {
							if (_v0.b) {
								var patient = _v0.a.a;
								return _List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
											{
												YZ: $author$project$Api$Provider$Patient$Min$id(patient)
											}),
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$text,
												_List_fromArray(
													[
														$author$project$Ui$Typography$phi(true)
													]),
												$author$project$Api$Provider$Patient$Min$name(patient))
											]))
									]);
							} else {
								var patient = _v0.a.a;
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$text,
										_List_fromArray(
											[
												$author$project$Ui$Typography$phi(true)
											]),
										$author$project$Api$Provider$Patient$Min$name(patient))
									]);
							}
						} else {
							return _List_Nil;
						}
					}()),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									$author$project$Api$Provider$CreditCategory$Min$name,
									$author$project$Api$Provider$Reports$Credit$creditCategory(credit))))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[
							$author$project$Ui$Table$colspan(2)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$author$project$Formatters$String$ellipsis,
								20,
								A2(
									$elm$core$Maybe$withDefault,
									'',
									A2(
										$elm$core$Maybe$map,
										$author$project$Api$Provider$Practitioner$Min$name,
										$author$project$Api$Provider$Reports$Credit$practitioner(credit)))))
						]))
				]));
	});
var $author$project$Components$Reports$CreditOutstanding$viewTable = function (model) {
	var _v0 = function () {
		var _v1 = model.bt;
		if (_v1.$ === 3) {
			var credits_ = _v1.a;
			return _Utils_Tuple2(false, credits_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var credits = _v0.b;
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$map,
					$author$project$Api$Column$view(
						A2($author$project$Api$Column$Sortable, model.alA, $author$project$Components$Reports$CreditOutstanding$SortTable)),
					model.N3),
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[$author$project$Ui$Table$textRight]),
						_List_fromArray(
							[
								A2($elm$html$Html$map, $author$project$Components$Reports$CreditOutstanding$ExportCsvMsg, $author$project$Components$ExportCsv$button)
							]))
					])
				])),
		A2(
			$elm$core$List$map,
			$author$project$Components$Reports$CreditOutstanding$viewRow(model.GQ),
			credits),
		_List_Nil);
};
var $author$project$Components$Reports$CreditOutstanding$view = F2(
	function (apiClient, model) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Reports$CreditOutstanding$ExportCsvMsg,
				A3(
					$author$project$Components$ExportCsv$modal,
					apiClient,
					_List_fromArray(
						[
							$author$project$Components$ExportCsv$report(
							$author$project$Api$Data$totalCount(model.bt)),
							$author$project$Components$ExportCsv$reportParams(
							A2($elm$core$Basics$composeL, $author$project$Api$Provider$Reports$Credit$listOptionsToParams, $author$project$Components$Reports$CreditOutstanding$fetchCreditsParams)(model))
						]),
					model.nD)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Credit Outstanding')
									])),
								$author$project$Ui$Panel$title(
								function () {
									var _v0 = model.bt;
									if (_v0.$ === 3) {
										var headers = _v0.b;
										return _List_fromArray(
											[
												$elm$html$Html$text(
												'Total Outstanding: ' + $author$project$Utils$Currency$fromInt(
													A2($author$project$Components$Reports$CreditOutstanding$amountFromHeader, headers, 'x-total-balance')))
											]);
									} else {
										return _List_fromArray(
											[
												$author$project$Ui$Skeleton$text(
												_List_fromArray(
													[
														$author$project$Ui$Skeleton$spanFromText('Total Outstanding: $1000.00')
													]))
											]);
									}
								}()),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpBlock]),
								_List_fromArray(
									[
										$elm$html$Html$text('All outstanding credits for retail customers')
									])),
								A2(
								$author$project$Ui$Grid$row,
								_List_fromArray(
									[$author$project$Ui$Grid$gutterSm]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$spanSm(1)
											]),
										_List_fromArray(
											[
												$author$project$Ui$Typography$headingSm(
												_List_fromArray(
													[
														$elm$html$Html$text('Issued')
													]))
											])),
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$spanSm(11)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Components$Reports$CreditOutstanding$DateRangeInputMsg,
												$author$project$Components$DateRangeInput$view(model.i4))
											]))
									])),
								A2(
								$author$project$Ui$Grid$row,
								_List_fromArray(
									[$author$project$Ui$Grid$gutterSm]),
								_Utils_ap(
									A2(
										$elm$core$List$map,
										A2(
											$elm$core$Basics$composeR,
											$elm$core$List$singleton,
											$author$project$Ui$Grid$column(
												_List_fromArray(
													[
														$author$project$Ui$Grid$span(6),
														$author$project$Ui$Grid$spanSm(3),
														$author$project$Ui$Grid$spanMd(4)
													]))),
										A2(
											$elm$core$List$map,
											$elm$html$Html$map($author$project$Components$Reports$CreditOutstanding$GroupLocationAndPractitionerFiltersMsg),
											A2(
												$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$view,
												_List_fromArray(
													[$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$multi]),
												model.dn))),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$span(6),
													$author$project$Ui$Grid$spanSm(3),
													$author$project$Ui$Grid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$CreditOutstanding$viewCreditCategoryResourceFilter(model)
												])),
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$span(6),
													$author$project$Ui$Grid$spanSm(3),
													$author$project$Ui$Grid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$CreditOutstanding$viewByDropdown(model)
												]))
										]))),
								A2(
								$author$project$Ui$Grid$row,
								_List_fromArray(
									[$author$project$Ui$Grid$gutterSm]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_Nil,
										function () {
											var activeFilters = _Utils_ap(
												A2(
													$elm$core$List$map,
													$elm$html$Html$map($author$project$Components$Reports$CreditOutstanding$GroupLocationAndPractitionerFiltersMsg),
													$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewMultiSelected(model.dn)),
												A2(
													$elm$core$List$map,
													$elm$html$Html$map($author$project$Components$Reports$CreditOutstanding$CreditCategoryResourceFilterMsg),
													$author$project$Components$ResourceFilter$CreditCategory$viewMultiSelected(model.f3)));
											return $elm$core$List$isEmpty(activeFilters) ? _List_Nil : _List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$mt2, $author$project$Ui$Element$mb2]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$strong,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Active filters')
																]))
														])),
													A2($elm$html$Html$span, _List_Nil, activeFilters)
												]);
										}())
									]))
							])),
						function () {
						var _v1 = model.amg;
						if (!_v1) {
							return $author$project$Components$Reports$CreditOutstanding$viewTable(model);
						} else {
							return $author$project$Components$Reports$CreditOutstanding$viewSummaryTable(model);
						}
					}(),
						function () {
						var _v2 = model.amg;
						if (!_v2) {
							return A2(
								$author$project$Ui$Panel$footer,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Components$Reports$CreditOutstanding$PaginationMsg,
										A2(
											$author$project$Api$Pagination$view,
											_List_fromArray(
												[
													$author$project$Ui$Pagination$List$loading(
													!$author$project$Utils$Maybe$toBool(
														$author$project$Api$Data$toMaybe(model.bt)))
												]),
											model.ajJ))
									]));
						} else {
							return $author$project$Ui$Panel$none;
						}
					}()
					]))
			]);
	});
var $author$project$Pages$Reports$CreditOutstanding$view = function (model) {
	return {
		fO: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			A2($author$project$Components$Reports$CreditOutstanding$view, model.Gv, model.kV)),
		ac9: 'Reports | Credit Outstanding'
	};
};
var $author$project$Pages$Reports$CreditOutstanding$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Reports$CreditOutstanding$init, aiq: $author$project$Pages$Reports$CreditOutstanding$load, k8: $author$project$Pages$Reports$CreditOutstanding$save, alO: $author$project$Pages$Reports$CreditOutstanding$subscriptions, adT: $author$project$Pages$Reports$CreditOutstanding$update, amo: $author$project$Pages$Reports$CreditOutstanding$view});
var $author$project$Pages$Reports$CreditOutstanding$Summary$ReportMsg = $elm$core$Basics$identity;
var $author$project$Components$Reports$CreditOutstanding$Summary = 1;
var $author$project$Pages$Reports$CreditOutstanding$Summary$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.DE;
		var _v1 = A5($author$project$Components$Reports$CreditOutstanding$init, 1, session, practice, shared, query);
		var report = _v1.a;
		var reportCmd = _v1.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, kV: report},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportCmd));
	});
var $author$project$Pages$Reports$CreditOutstanding$Summary$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$CreditOutstanding$Summary$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Reports$CreditOutstanding$Summary$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Reports$CreditOutstanding$subscriptions(model.kV));
};
var $author$project$Pages$Reports$CreditOutstanding$Summary$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Reports$CreditOutstanding$update, model.Gv, subMsg, model.kV);
		var report = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{kV: report}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Pages$Reports$CreditOutstanding$Summary$view = function (model) {
	return {
		fO: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			A2($author$project$Components$Reports$CreditOutstanding$view, model.Gv, model.kV)),
		ac9: 'Reports | Credit Outstanding'
	};
};
var $author$project$Pages$Reports$CreditOutstanding$Summary$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Reports$CreditOutstanding$Summary$init, aiq: $author$project$Pages$Reports$CreditOutstanding$Summary$load, k8: $author$project$Pages$Reports$CreditOutstanding$Summary$save, alO: $author$project$Pages$Reports$CreditOutstanding$Summary$subscriptions, adT: $author$project$Pages$Reports$CreditOutstanding$Summary$update, amo: $author$project$Pages$Reports$CreditOutstanding$Summary$view});
var $author$project$Pages$Reports$CreditTransactions$ReportMsg = $elm$core$Basics$identity;
var $author$project$Components$Reports$CreditTransactions$Table = 0;
var $author$project$Components$Reports$CreditTransactions$ByDropdownMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Reports$CreditTransactions$CreditCategoryResourceFilterMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$Report$CreditLine = 14;
var $author$project$Components$Reports$CreditTransactions$DateRangeInputMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Reports$CreditTransactions$GroupLocationAndPractitionerFiltersMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Reports$CreditTransactions$TypeDropdownMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Reports$CreditTransactions$urlParams = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Tuple$pair('start'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.dd, 0)),
			model.JV),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Tuple$pair('end'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.dd, 0)),
			model.HB),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('credit_category'),
			model.G6),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('location_group'),
			model.gL),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('location'),
			model.We),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('practitioner'),
			model.Z2),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('type'),
			model.h0),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('by'),
			model.co)
		]);
	return $elm$core$Dict$fromList(
		A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams));
};
var $author$project$Components$Reports$CreditTransactions$buildUrl = function (model) {
	return A2(
		$elm$url$Url$Builder$relative,
		_List_fromArray(
			[
				function () {
				var _v0 = model.co;
				if (!_v0.$) {
					return $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__CreditTransactions__Summary);
				} else {
					return $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__CreditTransactions);
				}
			}()
			]),
		A2(
			$elm$core$List$append,
			$author$project$Api$Pagination$toPageQuery(model.ajJ),
			A2(
				$elm$core$List$append,
				$author$project$Api$Sort$toQuery(model.alA),
				$author$project$Utils$QueryParameter$fromDict(
					$author$project$Components$Reports$CreditTransactions$urlParams(model)))));
};
var $author$project$Components$Reports$CreditTransactions$dateRangeInputSettings = F2(
	function (start, end) {
		var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
		return _Utils_update(
			defaultSettings,
			{ahy: start, al5: end});
	});
var $author$project$Components$Reports$CreditTransactions$GotCreditLines = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Reports$CreditTransactions$fetchCreditLinesParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				O5: model.G6,
				HB: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.HB),
				ais: model.We,
				s4: model.gL,
				ajJ: model.ajJ,
				aka: model.Z2,
				alA: model.alA,
				JV: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.JV),
				amg: model.h0
			});
	};
};
var $author$project$Api$Provider$Reports$CreditLine$CreditLine = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$CreditLine$Record = F8(
	function (transactionDate, amountInCents, type_, invoice, patient, creditCategory, practitioner, location) {
		return {LE: amountInCents, O5: creditCategory, Uk: invoice, ais: location, YY: patient, aka: practitioner, adw: transactionDate, amg: type_};
	});
var $author$project$Api$Provider$Reports$CreditLine$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'location',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Location$Min$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'practitioner',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Practitioner$Min$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'credit_category',
			$elm$json$Json$Decode$nullable($author$project$Api$Provider$CreditCategory$Min$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'patient',
				$elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Min$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'invoice',
					$elm$json$Json$Decode$nullable($author$project$Api$Common$Payable$Invoice$MinWithOwner$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'type',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'amount_in_cents',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'transaction_date',
								$author$project$Utils$Date$decode,
								$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$CreditLine$Record)))))))));
var $author$project$Api$Provider$Reports$CreditLine$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Reports$CreditLine$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$CreditLine$listDefaults = {O5: $elm$core$Maybe$Nothing, HB: $elm$core$Maybe$Nothing, ais: $elm$core$Maybe$Nothing, s4: $elm$core$Maybe$Nothing, ajJ: $author$project$Api$Pagination$init, aka: $elm$core$Maybe$Nothing, alA: $author$project$Api$Sort$init, JV: $elm$core$Maybe$Nothing, amg: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$Reports$CreditLine$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Reports$CreditLine$listDefaults);
	return A2(
		$elm$core$List$append,
		$author$project$Api$Pagination$toApiParams(options.ajJ),
		A2(
			$elm$core$List$append,
			$author$project$Api$Sort$toParams(options.alA),
			$elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						var _v0 = options.JV;
						if (!_v0.$) {
							var start_ = _v0.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'start', start_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v1 = options.HB;
						if (!_v1.$) {
							var end_ = _v1.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'end', end_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v2 = options.aka;
						if (!_v2.$) {
							var practitioner_ = _v2.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'practitioner', practitioner_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v3 = options.O5;
						if (!_v3.$) {
							var taxJurisdiction_ = _v3.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'credit_category', taxJurisdiction_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v4 = options.s4;
						if (!_v4.$) {
							var locationGroup_ = _v4.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'location_group', locationGroup_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v5 = options.ais;
						if (!_v5.$) {
							var location_ = _v5.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'location', location_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v6 = options.amg;
						if (!_v6.$) {
							var string = _v6.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'type', string)
								]);
						} else {
							return _List_Nil;
						}
					}()
					]))));
};
var $author$project$Api$Provider$Reports$CreditLine$listPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['reports', 'credit_lines']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Reports$CreditLine$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Reports$CreditLine$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Reports$CreditLine$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$CreditLine$listPath)));
	});
var $author$project$Components$Reports$CreditTransactions$fetchCreditLines = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Api$Provider$Reports$CreditLine$list,
			apiClient,
			$author$project$Components$Reports$CreditTransactions$fetchCreditLinesParams(model),
			$author$project$Components$Reports$CreditTransactions$GotCreditLines);
	});
var $author$project$Components$Reports$CreditTransactions$GotSummary = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Reports$CreditTransactions$fetchSummaryParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				O5: model.G6,
				HB: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.HB),
				ais: model.We,
				s4: model.gL,
				aka: model.Z2,
				JV: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.JV),
				amg: model.h0
			});
	};
};
var $author$project$Api$Provider$Reports$CreditLine$summary = F4(
	function (apiClient, by, optionals, toMsg) {
		return A5(
			$author$project$Api$Provider$Reports$Summary$retrieve,
			apiClient,
			$author$project$Api$Provider$Reports$CreditLine$listPath,
			by,
			$author$project$Api$Provider$Reports$CreditLine$listOptionsToParams(optionals),
			toMsg);
	});
var $author$project$Components$Reports$CreditTransactions$fetchSummary = F2(
	function (apiClient, model) {
		return A4(
			$author$project$Api$Provider$Reports$CreditLine$summary,
			apiClient,
			A2($elm$core$Maybe$withDefault, '', model.co),
			$author$project$Components$Reports$CreditTransactions$fetchSummaryParams(model),
			$author$project$Components$Reports$CreditTransactions$GotSummary);
	});
var $author$project$Components$Reports$CreditTransactions$fetchData = F2(
	function (apiClient, model) {
		var _v0 = model.amg;
		if (!_v0) {
			return A2($author$project$Components$Reports$CreditTransactions$fetchCreditLines, apiClient, model);
		} else {
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Components$Reports$CreditTransactions$fetchSummary, apiClient, model),
						A2($author$project$Components$Reports$CreditTransactions$fetchCreditLines, apiClient, model)
					]));
		}
	});
var $author$project$Components$Reports$CreditTransactions$initColumns = function (trackPatientsByLocation) {
	return $elm$core$List$concat(
		_List_fromArray(
			[
				_List_fromArray(
				[
					A3($author$project$Api$Column$init, 'transaction_date', true, 'Txn Date'),
					A3($author$project$Api$Column$init, 'amount_in_cents', true, 'Amount'),
					A3($author$project$Api$Column$init, 'type', true, 'Type'),
					A3($author$project$Api$Column$init, 'invoice', false, 'Invoice'),
					A3($author$project$Api$Column$init, 'patient', true, 'Patient'),
					A3($author$project$Api$Column$init, 'credit_category', true, 'Category'),
					A3($author$project$Api$Column$init, 'practitioner', true, 'Provider')
				]),
				trackPatientsByLocation ? _List_fromArray(
				[
					A3($author$project$Api$Column$init, 'location', true, 'Location')
				]) : _List_Nil
			]));
};
var $author$project$Components$Reports$CreditTransactions$init = F5(
	function (type_, session, practice, _v0, query) {
		var currentDate = _v0.dd;
		var apiClient = _v0.Gv;
		var hinterViewOff = _v0.ahK;
		var trackPatientsByLocation = $author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice);
		var practitionerId = A2($elm$core$Dict$get, 'practitioner', query);
		var locationId = A2($elm$core$Dict$get, 'location', query);
		var locationGroupId = A2($elm$core$Dict$get, 'location_group', query);
		var _v1 = function () {
			if (!type_) {
				return _Utils_Tuple2($author$project$Api$Data$Loading, $author$project$Api$Data$NotAsked);
			} else {
				return _Utils_Tuple2($author$project$Api$Data$NotAsked, $author$project$Api$Data$Loading);
			}
		}();
		var creditLines = _v1.a;
		var summary = _v1.b;
		var _v3 = A7($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$init, apiClient, session, practice, false, locationGroupId, locationId, practitionerId);
		var groupLocationAndPractitionerFilters = _v3.a;
		var groupLocationAndPractitionerFiltersCmd = _v3.b;
		var _v4 = $author$project$Utils$DateWithDefault$fromQuery(query);
		var start = _v4.a;
		var end = _v4.b;
		var _v5 = A2(
			$author$project$Components$DateRangeInput$init,
			'date-range-input',
			A2(
				$author$project$Components$Reports$CreditTransactions$dateRangeInputSettings,
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					start),
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					end)));
		var dateRangeInput = _v5.a;
		var dateRangeInputCmd = _v5.b;
		var _v6 = A2(
			$author$project$Components$ResourceFilter$CreditCategory$init,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						Gp: 'All Categories',
						akb: A2($elm$core$Dict$get, 'credit_category', query)
					});
			});
		var creditCategoryResourceFilter = _v6.a;
		var creditCategoryResourceFilterCmd = _v6.b;
		var model = {
			co: A2($elm$core$Dict$get, 'by', query),
			mB: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'by-dropdown', al6: $author$project$Components$Reports$CreditTransactions$ByDropdownMsg})),
			GQ: A3($author$project$Permission$canGoTo, session, hinterViewOff, 50),
			N3: $author$project$Components$Reports$CreditTransactions$initColumns(trackPatientsByLocation),
			G6: A2($elm$core$Dict$get, 'credit_category', query),
			f3: creditCategoryResourceFilter,
			a5: creditLines,
			dd: currentDate,
			i4: dateRangeInput,
			HB: end,
			nD: $author$project$Components$ExportCsv$initForPractice(14),
			dn: groupLocationAndPractitionerFilters,
			gL: locationGroupId,
			We: locationId,
			ajJ: $author$project$Api$Pagination$initFromQuery(query),
			Z2: practitionerId,
			alA: A3(
				$author$project$Api$Sort$withDefault,
				'transaction_date',
				1,
				$author$project$Api$Sort$initFromQuery(query)),
			JV: start,
			acF: summary,
			adt: trackPatientsByLocation,
			qI: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'type-dropdown', al6: $author$project$Components$Reports$CreditTransactions$TypeDropdownMsg})),
			h0: A2($elm$core$Dict$get, 'type', query),
			amg: type_
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditTransactions$DateRangeInputMsg, dateRangeInputCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditTransactions$GroupLocationAndPractitionerFiltersMsg, groupLocationAndPractitionerFiltersCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditTransactions$CreditCategoryResourceFilterMsg, creditCategoryResourceFilterCmd),
						A2($author$project$Components$Reports$CreditTransactions$fetchData, apiClient, model),
						A2($elm$core$Basics$composeR, $author$project$Components$Reports$CreditTransactions$buildUrl, $author$project$Ports$Navigation$replaceUrl)(model)
					])));
	});
var $author$project$Pages$Reports$CreditTransactions$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.DE;
		var _v1 = A5($author$project$Components$Reports$CreditTransactions$init, 0, session, practice, shared, query);
		var report = _v1.a;
		var reportTaxCmd = _v1.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, kV: report},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportTaxCmd));
	});
var $author$project$Pages$Reports$CreditTransactions$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$CreditTransactions$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Reports$CreditTransactions$ExportCsvMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Reports$CreditTransactions$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$CreditTransactions$DateRangeInputMsg,
				$author$project$Components$DateRangeInput$subscriptions(model.i4)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$CreditTransactions$ExportCsvMsg,
				$author$project$Components$ExportCsv$subscriptions(model.nD)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$CreditTransactions$CreditCategoryResourceFilterMsg,
				$author$project$Components$ResourceFilter$CreditCategory$subscriptions(model.f3)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$CreditTransactions$GroupLocationAndPractitionerFiltersMsg,
				$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$subscriptions(model.dn)),
				$author$project$Ui$Dropdown$subscriptions(model.mB),
				$author$project$Ui$Dropdown$subscriptions(model.qI)
			]));
};
var $author$project$Pages$Reports$CreditTransactions$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Reports$CreditTransactions$subscriptions(model.kV));
};
var $author$project$Components$Reports$CreditTransactions$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 2:
				var subMsg = msg.a;
				var result = A3($author$project$Components$ResourceFilter$CreditCategory$update, apiClient, subMsg, model.f3);
				var _v1 = result.agZ;
				if (!_v1.$) {
					var newCreditCategoryId = $author$project$Components$ResourceFilter$CreditCategory$value(result.aiO);
					var newModel = _Utils_update(
						model,
						{
							G6: newCreditCategoryId,
							f3: result.aiO,
							a5: $author$project$Api$Data$Loading,
							ajJ: $author$project$Api$Pagination$reset(model.ajJ)
						});
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditTransactions$CreditCategoryResourceFilterMsg, result.GZ),
									A2($author$project$Components$Reports$CreditTransactions$fetchData, apiClient, newModel),
									A2($elm$core$Basics$composeR, $author$project$Components$Reports$CreditTransactions$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
								])),
						result.aR);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{f3: result.aiO}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditTransactions$CreditCategoryResourceFilterMsg, result.GZ),
						result.aR);
				}
			case 3:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Ui$Dropdown$update, subMsg, model.qI);
				var typeDropdown = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qI: typeDropdown}),
					cmd,
					_List_Nil);
			case 4:
				var typeFilter = msg.a;
				var newModel = _Utils_update(
					model,
					{
						a5: $author$project$Api$Data$Loading,
						ajJ: $author$project$Api$Pagination$reset(model.ajJ),
						h0: typeFilter
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$CreditTransactions$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$CreditTransactions$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 5:
				var subMsg = msg.a;
				var _v3 = A2($author$project$Ui$Dropdown$update, subMsg, model.mB);
				var byDropdown = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{mB: byDropdown}),
					cmd,
					_List_Nil);
			case 6:
				var by = msg.a;
				var newModel = _Utils_update(
					model,
					{
						co: by,
						a5: $author$project$Api$Data$Loading,
						ajJ: $author$project$Api$Pagination$reset(model.ajJ)
					});
				var cmds = function () {
					var _v4 = _Utils_Tuple2(model.amg, newModel.co);
					if (!_v4.a) {
						if (!_v4.b.$) {
							var _v5 = _v4.a;
							return _List_fromArray(
								[
									A2($elm$core$Basics$composeR, $author$project$Components$Reports$CreditTransactions$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
								]);
						} else {
							var _v6 = _v4.a;
							var _v7 = _v4.b;
							return _List_fromArray(
								[$elm$core$Platform$Cmd$none]);
						}
					} else {
						if (_v4.b.$ === 1) {
							var _v8 = _v4.a;
							var _v9 = _v4.b;
							return _List_fromArray(
								[
									A2($elm$core$Basics$composeR, $author$project$Components$Reports$CreditTransactions$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
								]);
						} else {
							var _v10 = _v4.a;
							return _List_fromArray(
								[
									A2($author$project$Components$Reports$CreditTransactions$fetchData, apiClient, newModel),
									A2($elm$core$Basics$composeR, $author$project$Components$Reports$CreditTransactions$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
								]);
						}
					}
				}();
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(cmds),
					_List_Nil);
			case 0:
				var subMsg = msg.a;
				var _v11 = A2($author$project$Components$DateRangeInput$update, subMsg, model.i4);
				var dateRangeInput = _v11.a;
				var subCmd = _v11.b;
				var event = _v11.c;
				var newModel = function () {
					if (event.$ === 1) {
						var fromDate = event.a;
						var toDate = event.b;
						return _Utils_update(
							model,
							{
								a5: $author$project$Api$Data$Loading,
								i4: dateRangeInput,
								HB: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
								ajJ: $author$project$Api$Pagination$reset(model.ajJ),
								JV: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
							});
					} else {
						return _Utils_update(
							model,
							{i4: dateRangeInput});
					}
				}();
				var cmds = (_Utils_eq(newModel.JV, model.JV) && _Utils_eq(newModel.HB, model.HB)) ? _List_Nil : _List_fromArray(
					[
						A2($author$project$Components$Reports$CreditTransactions$fetchData, apiClient, newModel),
						A2($elm$core$Basics$composeR, $author$project$Components$Reports$CreditTransactions$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
					]);
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$cons,
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditTransactions$DateRangeInputMsg, subCmd),
							cmds)),
					_List_Nil);
			case 1:
				var subMsg = msg.a;
				var result = A3($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$update, apiClient, subMsg, model.dn);
				var _v13 = result.agZ;
				if (!_v13.$) {
					var locationGroupId = _v13.a;
					var locationId = _v13.b;
					var practitionerId = _v13.c;
					var newModel = _Utils_update(
						model,
						{
							a5: $author$project$Api$Data$Loading,
							dn: result.aiO,
							gL: locationGroupId,
							We: locationId,
							ajJ: $author$project$Api$Pagination$reset(model.ajJ),
							Z2: practitionerId
						});
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditTransactions$GroupLocationAndPractitionerFiltersMsg, result.GZ),
									A2($author$project$Components$Reports$CreditTransactions$fetchData, apiClient, newModel),
									A2($elm$core$Basics$composeR, $author$project$Components$Reports$CreditTransactions$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
								])),
						result.aR);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dn: result.aiO}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditTransactions$GroupLocationAndPractitionerFiltersMsg, result.GZ),
						result.aR);
				}
			case 7:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								a5: response,
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{a5: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 8:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{acF: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 9:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{a5: $author$project$Api$Data$Loading, ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$CreditTransactions$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$CreditTransactions$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 10:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						alA: A2($author$project$Api$Sort$update, columnId, model.alA)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$CreditTransactions$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$CreditTransactions$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v15 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.nD);
				var exportCsv = _v15.a;
				var subCmd = _v15.b;
				var subOutMsg = _v15.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nD: exportCsv}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditTransactions$ExportCsvMsg, subCmd),
					subOutMsg);
		}
	});
var $author$project$Pages$Reports$CreditTransactions$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Reports$CreditTransactions$update, model.Gv, subMsg, model.kV);
		var report = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{kV: report}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Components$Reports$CreditTransactions$PaginationMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Reports$CreditTransactions$amountFromHeader = F2(
	function (headers, name) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$String$toInt,
				A2($elm$core$Dict$get, name, headers)));
	});
var $author$project$Components$Reports$CreditTransactions$BySelected = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Reports$CreditTransactions$byDropdownItems = F2(
	function (trackPatientsByLocation, currentBy) {
		return A2(
			$elm$core$List$cons,
			A2(
				$author$project$Ui$Dropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$Dropdown$onSelect(
						$author$project$Components$Reports$CreditTransactions$BySelected($elm$core$Maybe$Nothing)),
						$author$project$Ui$Dropdown$selected(
						_Utils_eq(currentBy, $elm$core$Maybe$Nothing))
					]),
				$elm$html$Html$text('No Summary')),
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Dropdown$separator,
				A2(
					$elm$core$List$cons,
					A2(
						$author$project$Ui$Dropdown$item,
						_List_fromArray(
							[
								$author$project$Ui$Dropdown$onSelect(
								$author$project$Components$Reports$CreditTransactions$BySelected(
									$elm$core$Maybe$Just('credit_category'))),
								$author$project$Ui$Dropdown$selected(
								_Utils_eq(
									currentBy,
									$elm$core$Maybe$Just('credit_category')))
							]),
						$elm$html$Html$text('Category')),
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$Ui$Dropdown$item,
							_List_fromArray(
								[
									$author$project$Ui$Dropdown$onSelect(
									$author$project$Components$Reports$CreditTransactions$BySelected(
										$elm$core$Maybe$Just('practitioner'))),
									$author$project$Ui$Dropdown$selected(
									_Utils_eq(
										currentBy,
										$elm$core$Maybe$Just('practitioner')))
								]),
							$elm$html$Html$text('Provider')),
						trackPatientsByLocation ? _List_fromArray(
							[
								A2(
								$author$project$Ui$Dropdown$item,
								_List_fromArray(
									[
										$author$project$Ui$Dropdown$onSelect(
										$author$project$Components$Reports$CreditTransactions$BySelected(
											$elm$core$Maybe$Just('location'))),
										$author$project$Ui$Dropdown$selected(
										_Utils_eq(
											currentBy,
											$elm$core$Maybe$Just('location')))
									]),
								$elm$html$Html$text('Location'))
							]) : _List_Nil))));
	});
var $author$project$Components$Reports$CreditTransactions$byToDisplayName = function (by) {
	switch (by) {
		case 'credit_category':
			return 'Category';
		case 'practitioner':
			return 'Provider';
		case 'location':
			return 'Location';
		default:
			return by;
	}
};
var $author$project$Components$Reports$CreditTransactions$viewByDropdown = function (model) {
	var placeholder = function () {
		var _v0 = model.co;
		if (!_v0.$) {
			var by = _v0.a;
			return $author$project$Components$Reports$CreditTransactions$byToDisplayName(by);
		} else {
			return 'Summary By';
		}
	}();
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(placeholder)
			]),
		A2($author$project$Components$Reports$CreditTransactions$byDropdownItems, model.adt, model.co),
		model.mB);
};
var $author$project$Components$Reports$CreditTransactions$viewCreditCategoryResourceFilter = function (model) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Reports$CreditTransactions$CreditCategoryResourceFilterMsg,
		A2(
			$author$project$Components$ResourceFilter$CreditCategory$view,
			_List_fromArray(
				[$author$project$Components$ResourceFilter$multi]),
			model.f3));
};
var $author$project$Components$Reports$CreditTransactions$viewSummaryRow = F2(
	function (model, summaryRow) {
		var routeParams = _List_fromArray(
			[
				$author$project$Ui$Link$routeParams(
				A2(
					$author$project$Utils$Report$summaryRowTableParams,
					$author$project$Components$Reports$CreditTransactions$urlParams(model),
					summaryRow))
			]);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_fromArray(
								[
									$author$project$Ui$Typography$info,
									$author$project$Ui$Typography$phi(true)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Reports__CreditTransactions,
									routeParams,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'None',
												$author$project$Api$Provider$Reports$Summary$summaryRowName(summaryRow)))
										]))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Reports__CreditTransactions,
							routeParams,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$String$pluralize,
										'credit',
										$author$project$Api$Provider$Reports$Summary$summaryRowCount(summaryRow)))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('numeric')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$Reports__CreditTransactions,
											routeParams,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Utils$Currency$fromInt(
														$author$project$Api$Provider$Reports$Summary$summaryRowAmountInCents(summaryRow)))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Reports$CreditTransactions$viewSummaryTable = function (model) {
	var summaryType = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Api$Provider$Reports$Summary$summaryType, $author$project$Formatters$String$humanize),
			$author$project$Api$Data$toMaybe(model.acF)));
	var summaryRows = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$Reports$Summary$summaryRows,
			$author$project$Api$Data$toMaybe(model.acF)));
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$loading(
				!$author$project$Api$Data$isSuccess(model.acF)),
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mb4]),
						_List_fromArray(
							[
								$elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
							]))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(summaryType)
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Number of Credits')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4),
						$author$project$Ui$Table$textRight
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Amount')
					]))
			]),
		A2(
			$elm$core$List$map,
			$author$project$Components$Reports$CreditTransactions$viewSummaryRow(model),
			summaryRows),
		_List_Nil);
};
var $author$project$Components$Reports$CreditTransactions$SortTable = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Provider$Reports$CreditLine$amountInCents = function (_v0) {
	var record = _v0;
	return record.LE;
};
var $author$project$Api$Provider$Reports$CreditLine$creditCategory = function (_v0) {
	var record = _v0;
	return record.O5;
};
var $author$project$Api$Provider$Reports$CreditLine$invoice = function (_v0) {
	var record = _v0;
	return record.Uk;
};
var $author$project$Api$Provider$Reports$CreditLine$location = function (_v0) {
	var record = _v0;
	return record.ais;
};
var $author$project$Api$Provider$Reports$CreditLine$patient = function (_v0) {
	var record = _v0;
	return record.YY;
};
var $author$project$Api$Provider$Reports$CreditLine$practitioner = function (_v0) {
	var record = _v0;
	return record.aka;
};
var $author$project$Api$Provider$Reports$CreditLine$transactionDate = function (_v0) {
	var record = _v0;
	return record.adw;
};
var $author$project$Api$Provider$Reports$CreditLine$type_ = function (_v0) {
	var record = _v0;
	return record.amg;
};
var $author$project$Components$Reports$CreditTransactions$viewRow = F3(
	function (trackPatientsByLocation, canGoToPatients, creditLine) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$Date$toString,
										$author$project$Formatters$Date$Full,
										$author$project$Api$Provider$Reports$CreditLine$transactionDate(creditLine)))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$Reports$CreditLine$amountInCents(creditLine)))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Formatters$String$humanize(
										$author$project$Api$Provider$Reports$CreditLine$type_(creditLine)))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							function () {
								var _v0 = $author$project$Api$Provider$Reports$CreditLine$invoice(creditLine);
								if (!_v0.$) {
									var invoice = _v0.a;
									var _v1 = $author$project$Api$Common$Payable$Invoice$MinWithOwner$owner(invoice);
									if (!_v1.$) {
										var owner = _v1.a;
										return _Utils_ap(
											canGoToPatients ? _List_fromArray(
												[
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top(
														{
															Us: $author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice),
															YZ: $author$project$Api$Common$Payable$Owner$Min$id(owner)
														}),
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															'#' + ($elm$core$String$fromInt(
																$author$project$Api$Common$Payable$Invoice$MinWithOwner$invoiceNumber(invoice)) + ' ')),
															A2(
															$author$project$Ui$Badge$fromString,
															_List_Nil,
															$author$project$Api$Common$Payable$Invoice$MinWithOwner$status(invoice))
														]))
												]) : _List_fromArray(
												[
													$elm$html$Html$text(
													'#' + ($elm$core$String$fromInt(
														$author$project$Api$Common$Payable$Invoice$MinWithOwner$invoiceNumber(invoice)) + ' ')),
													A2(
													$author$project$Ui$Badge$fromString,
													_List_Nil,
													$author$project$Api$Common$Payable$Invoice$MinWithOwner$status(invoice))
												]),
											_List_fromArray(
												[
													A2($elm$html$Html$br, _List_Nil, _List_Nil),
													A2(
													$author$project$Ui$Typography$text,
													_List_fromArray(
														[
															$author$project$Ui$Typography$small,
															$author$project$Ui$Typography$muted,
															$author$project$Ui$Typography$phi(true)
														]),
													'for ' + $author$project$Api$Common$Payable$Owner$Min$name(owner))
												]));
									} else {
										return _List_Nil;
									}
								} else {
									return _List_Nil;
								}
							}()),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							function () {
								var _v2 = _Utils_Tuple2(
									$author$project$Api$Provider$Reports$CreditLine$patient(creditLine),
									canGoToPatients);
								if (!_v2.a.$) {
									if (_v2.b) {
										var patient = _v2.a.a;
										return _List_fromArray(
											[
												A3(
												$author$project$Ui$Link$route,
												$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
													{
														YZ: $author$project$Api$Provider$Patient$Min$id(patient)
													}),
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$text,
														_List_fromArray(
															[
																$author$project$Ui$Typography$phi(true)
															]),
														$author$project$Api$Provider$Patient$Min$name(patient))
													]))
											]);
									} else {
										var patient = _v2.a.a;
										return _List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$text,
												_List_fromArray(
													[
														$author$project$Ui$Typography$phi(true)
													]),
												$author$project$Api$Provider$Patient$Min$name(patient))
											]);
									}
								} else {
									return _List_Nil;
								}
							}()),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											$author$project$Api$Provider$CreditCategory$Min$name,
											$author$project$Api$Provider$Reports$CreditLine$creditCategory(creditLine))))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_fromArray(
								[
									$author$project$Ui$Table$colspan(
									trackPatientsByLocation ? 1 : 2)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											$author$project$Api$Provider$Practitioner$Min$name,
											$author$project$Api$Provider$Reports$CreditLine$practitioner(creditLine))))
								]))
						]),
						trackPatientsByLocation ? _List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$String$ellipsis,
										20,
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Maybe$map,
												$author$project$Api$Provider$Location$Min$name,
												$author$project$Api$Provider$Reports$CreditLine$location(creditLine)))))
								]))
						]) : _List_Nil
					])));
	});
var $author$project$Components$Reports$CreditTransactions$viewTable = function (model) {
	var _v0 = function () {
		var _v1 = model.a5;
		if (_v1.$ === 3) {
			var creditLines_ = _v1.a;
			return _Utils_Tuple2(false, creditLines_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var creditLines = _v0.b;
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$map,
					$author$project$Api$Column$view(
						A2($author$project$Api$Column$Sortable, model.alA, $author$project$Components$Reports$CreditTransactions$SortTable)),
					model.N3),
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[$author$project$Ui$Table$textRight]),
						_List_fromArray(
							[
								A2($elm$html$Html$map, $author$project$Components$Reports$CreditTransactions$ExportCsvMsg, $author$project$Components$ExportCsv$button)
							]))
					])
				])),
		A2(
			$elm$core$List$map,
			A2($author$project$Components$Reports$CreditTransactions$viewRow, model.adt, model.GQ),
			creditLines),
		_List_Nil);
};
var $author$project$Components$Reports$CreditTransactions$TypeSelected = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Reports$CreditTransactions$typeDropdownItems = function (currentType) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Components$Reports$CreditTransactions$TypeSelected($elm$core$Maybe$Nothing)),
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(currentType, $elm$core$Maybe$Nothing))
				]),
			$elm$html$Html$text('All Types')),
			$author$project$Ui$Dropdown$separator,
			A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Components$Reports$CreditTransactions$TypeSelected(
						$elm$core$Maybe$Just('expired'))),
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(
						currentType,
						$elm$core$Maybe$Just('expired')))
				]),
			$elm$html$Html$text('Expired')),
			A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Components$Reports$CreditTransactions$TypeSelected(
						$elm$core$Maybe$Just('applied'))),
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(
						currentType,
						$elm$core$Maybe$Just('applied')))
				]),
			$elm$html$Html$text('Applied')),
			A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Components$Reports$CreditTransactions$TypeSelected(
						$elm$core$Maybe$Just('issued'))),
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(
						currentType,
						$elm$core$Maybe$Just('issued')))
				]),
			$elm$html$Html$text('Issued')),
			A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Components$Reports$CreditTransactions$TypeSelected(
						$elm$core$Maybe$Just('transferred'))),
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(
						currentType,
						$elm$core$Maybe$Just('transferred')))
				]),
			$elm$html$Html$text('Transferred'))
		]);
};
var $author$project$Components$Reports$CreditTransactions$typeToDisplayName = function (typeFilter) {
	switch (typeFilter) {
		case 'expired':
			return 'Expired';
		case 'applied':
			return 'Applied';
		case 'issued':
			return 'Issued';
		case 'transferred':
			return 'Transferred';
		default:
			return typeFilter;
	}
};
var $author$project$Components$Reports$CreditTransactions$viewTypeDropdown = function (model) {
	var placeholder = function () {
		var _v0 = model.h0;
		if (!_v0.$) {
			var typeFilter = _v0.a;
			return $author$project$Components$Reports$CreditTransactions$typeToDisplayName(typeFilter);
		} else {
			return 'Type';
		}
	}();
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(placeholder)
			]),
		$author$project$Components$Reports$CreditTransactions$typeDropdownItems(model.h0),
		model.qI);
};
var $author$project$Components$Reports$CreditTransactions$view = F2(
	function (apiClient, model) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Reports$CreditTransactions$ExportCsvMsg,
				A3(
					$author$project$Components$ExportCsv$modal,
					apiClient,
					_List_fromArray(
						[
							$author$project$Components$ExportCsv$report(
							$author$project$Api$Data$totalCount(model.a5)),
							$author$project$Components$ExportCsv$reportParams(
							A2($elm$core$Basics$composeL, $author$project$Api$Provider$Reports$CreditLine$listOptionsToParams, $author$project$Components$Reports$CreditTransactions$fetchCreditLinesParams)(model))
						]),
					model.nD)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Credit Transactions')
									])),
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								function () {
									var _v0 = model.a5;
									if (_v0.$ === 3) {
										var headers = _v0.b;
										return _List_fromArray(
											[
												$elm$html$Html$text(
												'Total: ' + $author$project$Utils$Currency$fromInt(
													A2($author$project$Components$Reports$CreditTransactions$amountFromHeader, headers, 'x-total-amount')))
											]);
									} else {
										return _List_fromArray(
											[
												$author$project$Ui$Spinner$view(_List_Nil)
											]);
									}
								}()),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpBlock]),
								_List_fromArray(
									[
										$elm$html$Html$text('Total credit transactions for retail customers')
									])),
								A2(
								$elm$html$Html$map,
								$author$project$Components$Reports$CreditTransactions$DateRangeInputMsg,
								$author$project$Components$DateRangeInput$view(model.i4)),
								A2(
								$author$project$Ui$Grid$row,
								_List_fromArray(
									[$author$project$Ui$Grid$gutterSm]),
								_Utils_ap(
									A2(
										$elm$core$List$map,
										A2(
											$elm$core$Basics$composeR,
											$elm$core$List$singleton,
											$author$project$Ui$Grid$column(
												_List_fromArray(
													[
														$author$project$Ui$Grid$span(6),
														$author$project$Ui$Grid$spanMd(4)
													]))),
										A2(
											$elm$core$List$map,
											$elm$html$Html$map($author$project$Components$Reports$CreditTransactions$GroupLocationAndPractitionerFiltersMsg),
											A2(
												$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$view,
												_List_fromArray(
													[$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$multi]),
												model.dn))),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$span(6),
													$author$project$Ui$Grid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$CreditTransactions$viewCreditCategoryResourceFilter(model)
												])),
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$span(6),
													$author$project$Ui$Grid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$CreditTransactions$viewTypeDropdown(model)
												])),
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$span(6),
													$author$project$Ui$Grid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$CreditTransactions$viewByDropdown(model)
												]))
										]))),
								A2(
								$author$project$Ui$Grid$row,
								_List_fromArray(
									[$author$project$Ui$Grid$gutterSm]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_Nil,
										function () {
											var activeFilters = _Utils_ap(
												A2(
													$elm$core$List$map,
													$elm$html$Html$map($author$project$Components$Reports$CreditTransactions$GroupLocationAndPractitionerFiltersMsg),
													$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewMultiSelected(model.dn)),
												A2(
													$elm$core$List$map,
													$elm$html$Html$map($author$project$Components$Reports$CreditTransactions$CreditCategoryResourceFilterMsg),
													$author$project$Components$ResourceFilter$CreditCategory$viewMultiSelected(model.f3)));
											return $elm$core$List$isEmpty(activeFilters) ? _List_Nil : _List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$mt2, $author$project$Ui$Element$mb2]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$strong,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Active filters')
																]))
														])),
													A2($elm$html$Html$span, _List_Nil, activeFilters)
												]);
										}())
									]))
							])),
						function () {
						var _v1 = model.amg;
						if (!_v1) {
							return $author$project$Components$Reports$CreditTransactions$viewTable(model);
						} else {
							return $author$project$Components$Reports$CreditTransactions$viewSummaryTable(model);
						}
					}(),
						function () {
						var _v2 = model.amg;
						if (!_v2) {
							return A2(
								$author$project$Ui$Panel$footer,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Components$Reports$CreditTransactions$PaginationMsg,
										A2(
											$author$project$Api$Pagination$view,
											_List_fromArray(
												[
													$author$project$Ui$Pagination$List$loading(
													!$author$project$Utils$Maybe$toBool(
														$author$project$Api$Data$toMaybe(model.a5)))
												]),
											model.ajJ))
									]));
						} else {
							return $author$project$Ui$Panel$none;
						}
					}()
					]))
			]);
	});
var $author$project$Pages$Reports$CreditTransactions$view = function (model) {
	return {
		fO: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			A2($author$project$Components$Reports$CreditTransactions$view, model.Gv, model.kV)),
		ac9: 'Reports | Credit Transactions'
	};
};
var $author$project$Pages$Reports$CreditTransactions$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Reports$CreditTransactions$init, aiq: $author$project$Pages$Reports$CreditTransactions$load, k8: $author$project$Pages$Reports$CreditTransactions$save, alO: $author$project$Pages$Reports$CreditTransactions$subscriptions, adT: $author$project$Pages$Reports$CreditTransactions$update, amo: $author$project$Pages$Reports$CreditTransactions$view});
var $author$project$Pages$Reports$CreditTransactions$Summary$ReportMsg = $elm$core$Basics$identity;
var $author$project$Components$Reports$CreditTransactions$Summary = 1;
var $author$project$Pages$Reports$CreditTransactions$Summary$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.DE;
		var _v1 = A5($author$project$Components$Reports$CreditTransactions$init, 1, session, practice, shared, query);
		var report = _v1.a;
		var reportCmd = _v1.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, kV: report},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportCmd));
	});
var $author$project$Pages$Reports$CreditTransactions$Summary$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$CreditTransactions$Summary$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Reports$CreditTransactions$Summary$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Reports$CreditTransactions$subscriptions(model.kV));
};
var $author$project$Pages$Reports$CreditTransactions$Summary$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Reports$CreditTransactions$update, model.Gv, subMsg, model.kV);
		var report = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{kV: report}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Pages$Reports$CreditTransactions$Summary$view = function (model) {
	return {
		fO: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			A2($author$project$Components$Reports$CreditTransactions$view, model.Gv, model.kV)),
		ac9: 'Reports | Credit Transactions'
	};
};
var $author$project$Pages$Reports$CreditTransactions$Summary$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Reports$CreditTransactions$Summary$init, aiq: $author$project$Pages$Reports$CreditTransactions$Summary$load, k8: $author$project$Pages$Reports$CreditTransactions$Summary$save, alO: $author$project$Pages$Reports$CreditTransactions$Summary$subscriptions, adT: $author$project$Pages$Reports$CreditTransactions$Summary$update, amo: $author$project$Pages$Reports$CreditTransactions$Summary$view});
var $author$project$Pages$Reports$Custom$Id_String$GotEmbeddedReport = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$EmbeddedReport$One$EmbeddedReport = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$EmbeddedReport$Shared$EmbeddedReport = $elm$core$Basics$identity;
var $author$project$Api$Provider$EmbeddedReport$Shared$Record = F2(
	function (id, name) {
		return {ahP: id, Bq: name};
	});
var $author$project$Api$Provider$EmbeddedReport$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$EmbeddedReport$Shared$Record)));
var $author$project$Api$Provider$EmbeddedReport$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$EmbeddedReport$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$EmbeddedReport$One$Record = F2(
	function (service, descriptionLink) {
		return {Qs: descriptionLink, aa_: service};
	});
var $author$project$Api$Provider$EmbeddedReport$One$Periscope = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$EmbeddedReport$One$ThoughtSpot = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$EmbeddedReport$One$reportFromServiceName = function (string) {
	switch (string) {
		case 'periscope':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Api$Provider$EmbeddedReport$One$Periscope,
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['signed_url']),
					$elm$json$Json$Decode$string));
		case 'thoughtspot':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Api$Provider$EmbeddedReport$One$ThoughtSpot,
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['report_id']),
					$elm$json$Json$Decode$string));
		default:
			return $elm$json$Json$Decode$fail('Invalid report type: ');
	}
};
var $author$project$Api$Provider$EmbeddedReport$One$recordDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Api$Provider$EmbeddedReport$One$Record,
	A2(
		$elm$json$Json$Decode$andThen,
		$author$project$Api$Provider$EmbeddedReport$One$reportFromServiceName,
		A2($elm$json$Json$Decode$field, 'service_name', $elm$json$Json$Decode$string)),
	A2(
		$elm$json$Json$Decode$field,
		'description_link',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)));
var $author$project$Api$Provider$EmbeddedReport$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$EmbeddedReport$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$EmbeddedReport$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$EmbeddedReport$One$EmbeddedReport)));
var $author$project$Api$Provider$EmbeddedReport$embeddedReportsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['embedded_reports']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$EmbeddedReport$embeddedReportPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$EmbeddedReport$embeddedReportsPath);
};
var $author$project$Api$Provider$EmbeddedReport$retrieveDefaults = {Jk: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$EmbeddedReport$retrieveOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$EmbeddedReport$retrieveDefaults);
	var _v0 = options.Jk;
	if (!_v0.$) {
		var filter = _v0.a;
		return _List_fromArray(
			[
				A2($author$project$Api$Param$list, 'practices_filter', filter)
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Api$Provider$EmbeddedReport$retrieve = F4(
	function (apiClient, id_, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$EmbeddedReport$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$EmbeddedReport$retrieveOptionsToParams(optionals),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$EmbeddedReport$embeddedReportPath(id_))));
	});
var $author$project$Pages$Reports$Custom$Id_String$init = F4(
	function (session, practice, shared, _v0) {
		var params = _v0.YL;
		var model = {
			Gv: shared.Gv,
			Ij: $author$project$Shared$isHintAdmin(shared),
			ZV: practice,
			kM: $author$project$Api$Data$NotAsked,
			kV: $author$project$Api$Data$Loading,
			$w: params.ahP,
			uh: false,
			aa4: session
		};
		return _Utils_Tuple2(
			model,
			A4($author$project$Api$Provider$EmbeddedReport$retrieve, shared.Gv, params.ahP, $elm$core$Basics$identity, $author$project$Pages$Reports$Custom$Id_String$GotEmbeddedReport));
	});
var $author$project$Pages$Reports$Custom$Id_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$Custom$Id_String$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Reports$Custom$Id_String$ThoughtSpotTokenRequested = {$: 1};
var $author$project$Ports$ThoughtSpot$onThoughtSpotTokenRequestPort = _Platform_incomingPort(
	'onThoughtSpotTokenRequestPort',
	$elm$json$Json$Decode$null(0));
var $author$project$Ports$ThoughtSpot$onTokenRequested = A2($elm$core$Basics$composeR, $elm$core$Basics$always, $author$project$Ports$ThoughtSpot$onThoughtSpotTokenRequestPort);
var $author$project$Pages$Reports$Custom$Id_String$subscriptions = function (_v0) {
	return $author$project$Ports$ThoughtSpot$onTokenRequested($author$project$Pages$Reports$Custom$Id_String$ThoughtSpotTokenRequested);
};
var $author$project$Pages$Reports$Custom$Id_String$ThoughtSpotGotToken = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$EmbeddedReport$tokenDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['token']),
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$EmbeddedReport$managementGroupToken = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$EmbeddedReport$tokenDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['management_group_token']),
					$author$project$Api$Provider$EmbeddedReport$embeddedReportsPath)));
	});
var $author$project$Api$Provider$EmbeddedReport$token = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$EmbeddedReport$tokenDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['token']),
					$author$project$Api$Provider$EmbeddedReport$embeddedReportsPath)));
	});
var $author$project$Pages$Reports$Custom$Id_String$andRequestToken = function (model) {
	return _Utils_Tuple2(
		model,
		model.uh ? A2($author$project$Api$Provider$EmbeddedReport$managementGroupToken, model.Gv, $author$project$Pages$Reports$Custom$Id_String$ThoughtSpotGotToken) : A2($author$project$Api$Provider$EmbeddedReport$token, model.Gv, $author$project$Pages$Reports$Custom$Id_String$ThoughtSpotGotToken));
};
var $author$project$Ports$ThoughtSpot$authenticateThoughtSpotPort = _Platform_outgoingPort('authenticateThoughtSpotPort', $elm$json$Json$Encode$string);
var $author$project$Ports$ThoughtSpot$authenticate = $author$project$Ports$ThoughtSpot$authenticateThoughtSpotPort;
var $author$project$Ports$ThoughtSpot$ReportRecord = F2(
	function (id, email) {
		return {Rj: email, ahP: id};
	});
var $author$project$Ports$ThoughtSpot$embedThoughtSpotPort = _Platform_outgoingPort(
	'embedThoughtSpotPort',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string($.Rj)),
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string($.ahP))
				]));
	});
var $author$project$Ports$ThoughtSpot$embed = F2(
	function (id, email) {
		return $author$project$Ports$ThoughtSpot$embedThoughtSpotPort(
			A2($author$project$Ports$ThoughtSpot$ReportRecord, id, email));
	});
var $author$project$Pages$Reports$Custom$Id_String$performThoughtSpotAction = F3(
	function (action, reportId, model) {
		return function (email) {
			return A2(action, reportId, email);
		}(
			$author$project$Api$Platform$User$Shared$email(
				$author$project$Api$Platform$Session$One$user(model.aa4)));
	});
var $author$project$Api$Provider$EmbeddedReport$One$service = function (_v0) {
	var record = _v0.b;
	return record.aa_;
};
var $author$project$Pages$Reports$Custom$Id_String$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 3:
				var bool = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{uh: bool}),
					function () {
						var _v1 = model.kV;
						if (_v1.$ === 3) {
							var report = _v1.a;
							var _v2 = $author$project$Api$Provider$EmbeddedReport$One$service(report);
							if (_v2.$ === 1) {
								var reportId = _v2.a;
								return A3($author$project$Pages$Reports$Custom$Id_String$performThoughtSpotAction, $author$project$Ports$ThoughtSpot$embed, reportId, model);
							} else {
								return $elm$core$Platform$Cmd$none;
							}
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}(),
					_List_Nil);
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{kV: response}),
					function () {
						if (response.$ === 3) {
							var report = response.a;
							var _v4 = $author$project$Api$Provider$EmbeddedReport$One$service(report);
							if (_v4.$ === 1) {
								var reportId = _v4.a;
								return A3($author$project$Pages$Reports$Custom$Id_String$performThoughtSpotAction, $author$project$Ports$ThoughtSpot$embed, reportId, model);
							} else {
								return $elm$core$Platform$Cmd$none;
							}
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}(),
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				return A2(
					$author$project$Utils$Tuple3$fromTuple2,
					_List_Nil,
					$author$project$Pages$Reports$Custom$Id_String$andRequestToken(model));
			default:
				var dataReport = msg.a;
				return _Utils_Tuple3(
					model,
					function () {
						if (dataReport.$ === 3) {
							var token = dataReport.a;
							return $author$project$Ports$ThoughtSpot$authenticate(token);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}(),
					$author$project$OutMsg$handleErrorResponse(dataReport));
		}
	});
var $author$project$Api$Provider$EmbeddedReport$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$EmbeddedReport$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$EmbeddedReport$Shared$name(shared);
};
var $author$project$Pages$Reports$Custom$Id_String$viewPeriscope = F2(
	function (signedUrl, embeddedReport) {
		return A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
							_List_fromArray(
								[
									$author$project$Ui$Panel$title(
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Provider$EmbeddedReport$One$name(embeddedReport))
										]))
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$iframe,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(signedUrl),
									A2($elm$html$Html$Attributes$attribute, 'width', '100%'),
									$elm$html$Html$Attributes$height(480),
									A2($elm$html$Html$Attributes$attribute, 'frameborder', '0')
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$Pages$Reports$Custom$Id_String$ToughtSpotTokenRequestAsManagementGroup = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$EmbeddedReport$One$descriptionLink = function (_v0) {
	var record = _v0.b;
	return record.Qs;
};
var $author$project$Pages$Reports$Custom$Id_String$viewThoughtspot = F2(
	function (embeddedReport, model) {
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mb2]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Panel$title(
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Provider$EmbeddedReport$One$name(embeddedReport))
										])),
									A2(
									$elm$core$Maybe$withDefault,
									$elm$html$Html$text(''),
									A2(
										$elm$core$Maybe$map,
										A2(
											$elm$core$Basics$composeR,
											function (link) {
												return _List_fromArray(
													[
														$elm$html$Html$text('Report description '),
														A3(
														$author$project$Ui$Link$externalHref,
														link,
														_List_fromArray(
															[$author$project$Ui$Link$targetBlank]),
														_List_fromArray(
															[
																$elm$html$Html$text('here')
															]))
													]);
											},
											$author$project$Ui$Element$view(
												_List_fromArray(
													[$author$project$Ui$Element$textMuted]))),
										$author$project$Api$Provider$EmbeddedReport$One$descriptionLink(embeddedReport)))
								])),
							model.Ij ? A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceX2]),
							_List_fromArray(
								[
									$author$project$Ui$HinterOnly$icon(_List_Nil),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$inlineBlock]),
									_List_fromArray(
										[
											$elm$html$Html$text('view as management group')
										])),
									$author$project$Ui$ToggleSwitch$view(
									_List_fromArray(
										[
											$author$project$Ui$ToggleSwitch$sm,
											$author$project$Ui$ToggleSwitch$on(model.uh),
											$author$project$Ui$ToggleSwitch$onChange($author$project$Pages$Reports$Custom$Id_String$ToughtSpotTokenRequestAsManagementGroup)
										]))
								])) : $elm$html$Html$text('')
						]))
				]));
	});
var $author$project$Pages$Reports$Custom$Id_String$viewBody = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				function () {
				var _v0 = model.kV;
				if (_v0.$ === 3) {
					var embeddedReport = _v0.a;
					var _v1 = $author$project$Api$Provider$EmbeddedReport$One$service(embeddedReport);
					if (!_v1.$) {
						var signedUrl = _v1.a;
						return A2($author$project$Pages$Reports$Custom$Id_String$viewPeriscope, signedUrl, embeddedReport);
					} else {
						return A2($author$project$Pages$Reports$Custom$Id_String$viewThoughtspot, embeddedReport, model);
					}
				} else {
					return $elm$html$Html$text('');
				}
			}(),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id('ts-embed'),
						A2($elm$html$Html$Attributes$style, 'margin-left', '-30px'),
						A2($elm$html$Html$Attributes$style, 'margin-right', '-30px'),
						A2($elm$html$Html$Attributes$style, 'min-height', 'calc(100vh - 55px - 60px - 60px)')
					]),
				_List_Nil)
			]));
};
var $author$project$Pages$Reports$Custom$Id_String$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				$author$project$Pages$Reports$Custom$Id_String$viewBody(model)
			]),
		ac9: 'Reports'
	};
};
var $author$project$Pages$Reports$Custom$Id_String$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Reports$Custom$Id_String$init, aiq: $author$project$Pages$Reports$Custom$Id_String$load, k8: $author$project$Pages$Reports$Custom$Id_String$save, alO: $author$project$Pages$Reports$Custom$Id_String$subscriptions, adT: $author$project$Pages$Reports$Custom$Id_String$update, amo: $author$project$Pages$Reports$Custom$Id_String$view});
var $author$project$Ports$ThoughtSpot$SearchRecord = function (email) {
	return {Rj: email};
};
var $author$project$Ports$ThoughtSpot$embedSearchThoughtSpotPort = _Platform_outgoingPort(
	'embedSearchThoughtSpotPort',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string($.Rj))
				]));
	});
var $author$project$Ports$ThoughtSpot$embedSearch = A2($elm$core$Basics$composeR, $author$project$Ports$ThoughtSpot$SearchRecord, $author$project$Ports$ThoughtSpot$embedSearchThoughtSpotPort);
var $author$project$Pages$Reports$Custom$New$init = F4(
	function (session, practice, shared, _v0) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, ZV: practice, aa4: session},
			$author$project$Ports$ThoughtSpot$embedSearch(
				$author$project$Api$Platform$User$Shared$email(
					$author$project$Api$Platform$Session$One$user(session))));
	});
var $author$project$Pages$Reports$Custom$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$Custom$New$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Reports$Custom$New$ThoughtSpotTokenRequested = {$: 0};
var $author$project$Pages$Reports$Custom$New$subscriptions = function (_v0) {
	return $author$project$Ports$ThoughtSpot$onTokenRequested($author$project$Pages$Reports$Custom$New$ThoughtSpotTokenRequested);
};
var $author$project$Pages$Reports$Custom$New$ThoughtSpotGotToken = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Reports$Custom$New$update = F2(
	function (msg, model) {
		if (!msg.$) {
			return _Utils_Tuple3(
				model,
				A2($author$project$Api$Provider$EmbeddedReport$token, model.Gv, $author$project$Pages$Reports$Custom$New$ThoughtSpotGotToken),
				_List_Nil);
		} else {
			var dataReport = msg.a;
			return _Utils_Tuple3(
				model,
				function () {
					if (dataReport.$ === 3) {
						var token = dataReport.a;
						return $author$project$Ports$ThoughtSpot$authenticate(token);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}(),
				_List_Nil);
		}
	});
var $author$project$Pages$Reports$Custom$New$viewBody = function (_v0) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('ts-search-embed'),
					A2($elm$html$Html$Attributes$style, 'height', 'calc(100vh - 55px - 60px - 60px)')
				]),
			_List_Nil)
		]);
};
var $author$project$Pages$Reports$Custom$New$view = function (model) {
	return {
		fO: $author$project$Pages$Reports$Custom$New$viewBody(model),
		ac9: 'Reports'
	};
};
var $author$project$Pages$Reports$Custom$New$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Reports$Custom$New$init, aiq: $author$project$Pages$Reports$Custom$New$load, k8: $author$project$Pages$Reports$Custom$New$save, alO: $author$project$Pages$Reports$Custom$New$subscriptions, adT: $author$project$Pages$Reports$Custom$New$update, amo: $author$project$Pages$Reports$Custom$New$view});
var $author$project$Pages$Reports$Dashboard$ActiveGrowthAttrition = 0;
var $author$project$Pages$Reports$Dashboard$CompanyResourceFilterMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Reports$Dashboard$DateRangeInputMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Reports$Dashboard$GroupLocationAndPractitionerFiltersMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Reports$Dashboard$PlanResourceFilterMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Utils$Date$toEndOfMonth = function (date) {
	var lastDayOfMonth = A2(
		$author$project$Utils$Date$daysInMonth,
		$justinmimbs$date$Date$year(date),
		$justinmimbs$date$Date$month(date));
	return A2($author$project$Utils$Date$changeDay, lastDayOfMonth, date);
};
var $author$project$Utils$Date$monthRange = function (referenceDate) {
	return _Utils_Tuple2(
		$author$project$Utils$Date$toBeginningOfMonth(referenceDate),
		$author$project$Utils$Date$toEndOfMonth(referenceDate));
};
var $author$project$Utils$Date$changeMonth = F2(
	function (month, date) {
		var year = $justinmimbs$date$Date$year(date);
		var day = $justinmimbs$date$Date$day(date);
		return A3($justinmimbs$date$Date$fromCalendarDate, year, month, day);
	});
var $author$project$Utils$Date$quarterRange = function (referenceDate) {
	var quarter = $justinmimbs$date$Date$quarter(referenceDate);
	return _Utils_Tuple2(
		$author$project$Utils$Date$toBeginningOfMonth(
			A2(
				$author$project$Utils$Date$changeMonth,
				A2(
					$elm$core$Maybe$withDefault,
					0,
					$author$project$Utils$Date$monthFromInt((quarter * 3) - 3)),
				referenceDate)),
		$author$project$Utils$Date$toEndOfMonth(
			A2(
				$author$project$Utils$Date$changeMonth,
				A2(
					$elm$core$Maybe$withDefault,
					0,
					$author$project$Utils$Date$monthFromInt(quarter * 3)),
				referenceDate)));
};
var $author$project$Utils$Date$trailingRange = F2(
	function (months_, referenceDate) {
		return _Utils_Tuple2(
			$author$project$Utils$Date$toEndOfMonth(
				A3($justinmimbs$date$Date$add, 1, -(months_ - 1), referenceDate)),
			$author$project$Utils$Date$toEndOfMonth(referenceDate));
	});
var $author$project$Pages$Reports$Dashboard$trailingMonthOption = F2(
	function (currentDate, months) {
		return function (_v0) {
			var start = _v0.a;
			var end = _v0.b;
			return A4(
				$author$project$Components$DateRangeInput$additionalItem,
				'trailing_' + $elm$core$String$fromInt(months),
				'Trailing ' + ($elm$core$String$fromInt(months) + ' months'),
				$elm$core$Maybe$Just(start),
				$elm$core$Maybe$Just(end));
		}(
			A2($author$project$Utils$Date$trailingRange, months, currentDate));
	});
var $author$project$Utils$Date$yearRange = function (referenceDate) {
	return _Utils_Tuple2(
		$author$project$Utils$Date$toBeginningOfMonth(
			A2($author$project$Utils$Date$changeMonth, 0, referenceDate)),
		$author$project$Utils$Date$toEndOfMonth(
			A2($author$project$Utils$Date$changeMonth, 11, referenceDate)));
};
var $author$project$Utils$Date$yearToDateRange = function (referenceDate) {
	return _Utils_Tuple2(
		A2(
			$author$project$Utils$Date$changeDay,
			1,
			A2($author$project$Utils$Date$changeMonth, 0, referenceDate)),
		$author$project$Utils$Date$toEndOfMonth(referenceDate));
};
var $author$project$Pages$Reports$Dashboard$additionalMonthOptions = function (currentDate) {
	return _List_fromArray(
		[
			function (_v0) {
			var start = _v0.a;
			var end = _v0.b;
			return A4(
				$author$project$Components$DateRangeInput$additionalItem,
				'this_month',
				'This Month',
				$elm$core$Maybe$Just(start),
				$elm$core$Maybe$Just(end));
		}(
			$author$project$Utils$Date$monthRange(currentDate)),
			A2($author$project$Pages$Reports$Dashboard$trailingMonthOption, currentDate, 3),
			A2($author$project$Pages$Reports$Dashboard$trailingMonthOption, currentDate, 6),
			A2($author$project$Pages$Reports$Dashboard$trailingMonthOption, currentDate, 12),
			function (item) {
			return _Utils_update(
				item,
				{aih: 'Trailing 24 months'});
		}(
			A2($author$project$Pages$Reports$Dashboard$trailingMonthOption, currentDate, 24)),
			function (_v1) {
			var start = _v1.a;
			var end = _v1.b;
			return A4(
				$author$project$Components$DateRangeInput$additionalItem,
				'this_quarter',
				'This Quarter',
				$elm$core$Maybe$Just(start),
				$elm$core$Maybe$Just(end));
		}(
			$author$project$Utils$Date$quarterRange(currentDate)),
			function (_v2) {
			var start = _v2.a;
			var end = _v2.b;
			return A4(
				$author$project$Components$DateRangeInput$additionalItem,
				'last_quarter',
				'Last Quarter',
				$elm$core$Maybe$Just(start),
				$elm$core$Maybe$Just(end));
		}(
			$author$project$Utils$Date$quarterRange(
				A3($justinmimbs$date$Date$add, 1, -3, currentDate))),
			function (_v3) {
			var start = _v3.a;
			var end = _v3.b;
			return A4(
				$author$project$Components$DateRangeInput$additionalItem,
				'ytd',
				'YTD',
				$elm$core$Maybe$Just(start),
				$elm$core$Maybe$Just(end));
		}(
			$author$project$Utils$Date$yearToDateRange(currentDate)),
			function (_v4) {
			var start = _v4.a;
			var end = _v4.b;
			return A4(
				$author$project$Components$DateRangeInput$additionalItem,
				'this_year',
				'This Year',
				$elm$core$Maybe$Just(start),
				$elm$core$Maybe$Just(end));
		}(
			$author$project$Utils$Date$yearRange(currentDate)),
			function (_v5) {
			var start = _v5.a;
			var end = _v5.b;
			return A4(
				$author$project$Components$DateRangeInput$additionalItem,
				'last_year',
				'Last Year',
				$elm$core$Maybe$Just(start),
				$elm$core$Maybe$Just(end));
		}(
			$author$project$Utils$Date$yearRange(
				A3($justinmimbs$date$Date$add, 0, -1, currentDate)))
		]);
};
var $author$project$Pages$Reports$Dashboard$dateRangeInputSettings = F2(
	function (start, end) {
		var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
		return _Utils_update(
			defaultSettings,
			{ma: $author$project$Pages$Reports$Dashboard$additionalMonthOptions, ahy: start, IE: 1, al5: end});
	});
var $author$project$Pages$Reports$Dashboard$GotIssuedAmount = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Reports$Dashboard$headerFromData = function (stringCurrency) {
	return $author$project$Currency$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			0,
			$elm$core$String$toInt(stringCurrency)));
};
var $author$project$Pages$Reports$Dashboard$issuedInvoicesParams = function (d) {
	return _Utils_update(
		d,
		{
			ajJ: $author$project$Api$Pagination$empty,
			alH: $elm$core$Maybe$Just(
				_List_fromArray(
					['issued']))
		});
};
var $author$project$Api$Provider$Reports$CustomerInvoice$CustomerInvoice = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$CustomerInvoice$Record = function (id) {
	return function (invoiceNumber) {
		return function (dueDate) {
			return function (humanStatus) {
				return function (status) {
					return function (paymentScheduledOn) {
						return function (lastSentAt) {
							return function (paidAt) {
								return function (issuedTotalInCents) {
									return function (totalInCents) {
										return function (creditInCents) {
											return function (paidInCents) {
												return function (dueInCents) {
													return function (isPastDue) {
														return function (isPaymentScheduled) {
															return function (isCustomerViewable) {
																return function (securePdfInlineToken) {
																	return function (owner) {
																		return function (location) {
																			return {O7: creditInCents, QX: dueDate, QY: dueInCents, TH: humanStatus, ahP: id, Uu: invoiceNumber, UK: isCustomerViewable, U1: isPastDue, U3: isPaymentScheduled, Vs: issuedTotalInCents, VL: lastSentAt, ais: location, YD: owner, YH: paidAt, YI: paidInCents, Zf: paymentScheduledOn, aaE: securePdfInlineToken, alH: status, adp: totalInCents};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Reports$Patient$One = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$Patient$Patient = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$Patient$OneRecord = F5(
	function (id, name, email, phoneNumber, hipaaAuthorizationAccepted) {
		return {Rj: email, TB: hipaaAuthorizationAccepted, ahP: id, Bq: name, Zx: phoneNumber};
	});
var $author$project$Api$Provider$Reports$Patient$oneRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'hipaa_authorization_accepted',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'phone_number',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'email',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$Patient$OneRecord))))));
var $author$project$Api$Provider$Reports$Patient$oneDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $author$project$Api$Provider$Reports$Patient$oneRecordDecoder),
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$CustomerInvoice$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'location',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Location$Min$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'owner',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Reports$Patient$oneDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'secure_pdf_inline_token',
			$author$project$Api$File$Token$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'is_customer_viewable',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'is_payment_scheduled',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'is_past_due',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'due_in_cents',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'paid_in_cents',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'credit_in_cents',
									$elm$json$Json$Decode$int,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'total_in_cents',
										$elm$json$Json$Decode$int,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'issued_total_in_cents',
											$elm$json$Json$Decode$int,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'paid_at',
												$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'last_sent_at',
													$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'payment_scheduled_on',
														$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'status',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'human_status',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'due_date',
																	$author$project$Utils$Date$decode,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'invoice_number',
																		$elm$json$Json$Decode$int,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'id',
																			$elm$json$Json$Decode$string,
																			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$CustomerInvoice$Record))))))))))))))))))));
var $author$project$Api$Provider$Reports$CustomerInvoice$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Reports$CustomerInvoice$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$CustomerInvoice$listDefaults = {
	Mm: $elm$core$Maybe$Nothing,
	HB: $elm$core$Maybe$Nothing,
	ais: $elm$core$Maybe$Nothing,
	s4: $elm$core$Maybe$Nothing,
	ajJ: $author$project$Api$Pagination$init,
	alA: A3($author$project$Api$Sort$withDefault, 'date', 0, $author$project$Api$Sort$init),
	JV: $elm$core$Maybe$Nothing,
	alH: $elm$core$Maybe$Nothing
};
var $author$project$Api$Provider$Reports$CustomerInvoice$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Reports$CustomerInvoice$listDefaults);
	return A2(
		$elm$core$List$append,
		$author$project$Api$Pagination$toApiParams(options.ajJ),
		A2(
			$elm$core$List$append,
			$author$project$Api$Sort$toParams(options.alA),
			$elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						var _v0 = _Utils_Tuple2(options.JV, options.HB);
						if ((_v0.a.$ === 1) && (_v0.b.$ === 1)) {
							var _v1 = _v0.a;
							var _v2 = _v0.b;
							return _List_Nil;
						} else {
							var dates = A2(
								$elm$json$Json$Encode$encode,
								0,
								$elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'gte',
											A2(
												$author$project$Utils$Encode$nullable,
												A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$Utils$Date$toQuery),
												options.JV)),
											_Utils_Tuple2(
											'lte',
											A2(
												$author$project$Utils$Encode$nullable,
												A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$Utils$Date$toQuery),
												options.HB))
										])));
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'date', dates)
								]);
						}
					}(),
						function () {
						var _v3 = options.alH;
						if (!_v3.$) {
							var list_ = _v3.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$list, 'status', list_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v4 = options.Mm;
						if (!_v4.$) {
							var bool = _v4.a;
							return _List_fromArray(
								[
									A2(
									$author$project$Api$Param$string,
									'owner',
									A2(
										$elm$json$Json$Encode$encode,
										0,
										$elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'autopay',
													$elm$json$Json$Encode$bool(bool))
												]))))
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v5 = options.s4;
						if (!_v5.$) {
							var string = _v5.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'location_group', string)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v6 = options.ais;
						if (!_v6.$) {
							var string = _v6.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'location', string)
								]);
						} else {
							return _List_Nil;
						}
					}()
					]))));
};
var $author$project$Api$Provider$Reports$CustomerInvoice$listPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['reports', 'customer_invoices']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Reports$CustomerInvoice$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Reports$CustomerInvoice$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Reports$CustomerInvoice$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$CustomerInvoice$listPath)));
	});
var $author$project$Api$Data$mapHeader = F3(
	function (headerName, func, data) {
		switch (data.$) {
			case 3:
				var headers = data.b;
				return A2(
					$elm$core$Maybe$withDefault,
					$author$project$Api$Data$Failure(
						$author$project$Api$Data$Decoder('Header with name ' + (headerName + ' missing'))),
					A2(
						$elm$core$Maybe$map,
						function (header) {
							return A2(
								$author$project$Api$Data$Success,
								func(header),
								headers);
						},
						A2($elm$core$Dict$get, headerName, headers)));
			case 0:
				return $author$project$Api$Data$NotAsked;
			case 1:
				return $author$project$Api$Data$Loading;
			default:
				var error = data.a;
				return $author$project$Api$Data$Failure(error);
		}
	});
var $author$project$Pages$Reports$Dashboard$fetchIssued = function (client) {
	return A3(
		$author$project$Api$Provider$Reports$CustomerInvoice$list,
		client,
		$author$project$Pages$Reports$Dashboard$issuedInvoicesParams,
		A2(
			$elm$core$Basics$composeR,
			A2($author$project$Api$Data$mapHeader, 'x-total-billed-amount', $author$project$Pages$Reports$Dashboard$headerFromData),
			$author$project$Pages$Reports$Dashboard$GotIssuedAmount));
};
var $author$project$Pages$Reports$Dashboard$GotActiveMembersMetric = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Reports$Dashboard$GotEndedMembersMetric = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Reports$Dashboard$GotEnrolledMembersMetric = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$Metric$Metric = $elm$core$Basics$identity;
var $author$project$Api$Provider$Metric$compareTick = F2(
	function (_v0, _v1) {
		var date1 = _v0.a;
		var date2 = _v1.a;
		return A2($justinmimbs$date$Date$compare, date1, date2);
	});
var $author$project$Api$Provider$Metric$monthDecoder = A2(
	$elm$json$Json$Decode$andThen,
	A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromIsoString, $elm_community$json_extra$Json$Decode$Extra$fromResult),
	A2(
		$elm$json$Json$Decode$map,
		function (s) {
			return s + '-01';
		},
		$elm$json$Json$Decode$string));
var $author$project$Api$Provider$Metric$tickDecoder = A3(
	$elm$json$Json$Decode$map2,
	$elm$core$Tuple$pair,
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['x']),
		$author$project$Api$Provider$Metric$monthDecoder),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['y']),
		A2($elm$json$Json$Decode$map, $elm$core$Basics$toFloat, $elm$json$Json$Decode$int)));
var $author$project$Api$Provider$Metric$metricDataDecoder = A3(
	$elm$json$Json$Decode$map2,
	$elm$core$Tuple$pair,
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['key']),
		$elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$List$sortWith($author$project$Api$Provider$Metric$compareTick),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['values']),
			$elm$json$Json$Decode$list($author$project$Api$Provider$Metric$tickDecoder))));
var $author$project$Api$Provider$Metric$metricsDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['data']),
		$elm$json$Json$Decode$list($author$project$Api$Provider$Metric$metricDataDecoder)));
var $author$project$Api$Provider$Metric$metricsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['metrics']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Metric$defaults = {GL: $elm$core$Maybe$Nothing, afQ: $elm$core$Maybe$Nothing, HB: $elm$core$Maybe$Nothing, HC: $elm$core$Maybe$Nothing, ais: $elm$core$Maybe$Nothing, s4: $elm$core$Maybe$Nothing, Jb: $elm$core$Maybe$Nothing, aka: $elm$core$Maybe$Nothing, JV: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$Metric$optionalsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Metric$defaults);
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$map,
				$author$project$Api$Param$date('start'),
				options.JV),
				A2(
				$elm$core$Maybe$map,
				$author$project$Api$Param$date('end'),
				options.HB),
				A2(
				$elm$core$Maybe$map,
				$author$project$Api$Param$string('practitioner'),
				options.aka),
				A2(
				$elm$core$Maybe$map,
				$author$project$Api$Param$string('location'),
				options.ais),
				A2(
				$elm$core$Maybe$map,
				$author$project$Api$Param$string('location_group'),
				options.s4),
				A2(
				$elm$core$Maybe$map,
				$author$project$Api$Param$string('company'),
				options.afQ),
				A2(
				$elm$core$Maybe$map,
				$author$project$Api$Param$string('plan'),
				options.Jb),
				A2(
				$elm$core$Maybe$map,
				$author$project$Api$Param$string('engagement'),
				options.HC),
				A2(
				$elm$core$Maybe$map,
				$author$project$Api$Param$string('breakout'),
				options.GL)
			]));
};
var $author$project$Api$Provider$Metric$activeMembers = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Metric$metricsDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Metric$optionalsToParams(optionals),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['active_members']),
						$author$project$Api$Provider$Metric$metricsPath))));
	});
var $author$project$Pages$Reports$Dashboard$breakoutToValue = function (breakout) {
	switch (breakout) {
		case 0:
			return 'plan';
		case 1:
			return 'practitioner';
		case 2:
			return 'location_group';
		case 3:
			return 'location';
		case 4:
			return 'employer';
		case 5:
			return 'employer-retail';
		case 6:
			return 'lead_source';
		default:
			return 'cancellation_reason';
	}
};
var $author$project$Pages$Reports$Dashboard$engagementToValue = function (engagement) {
	_v0$3:
	while (true) {
		if (!engagement.$) {
			switch (engagement.a) {
				case 1:
					var _v1 = engagement.a;
					return $elm$core$Maybe$Just('currently_engaged');
				case 2:
					var _v2 = engagement.a;
					return $elm$core$Maybe$Just('previously_engaged');
				case 3:
					var _v3 = engagement.a;
					return $elm$core$Maybe$Just('never_engaged');
				default:
					break _v0$3;
			}
		} else {
			break _v0$3;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Api$Provider$Metric$totalEnrollments = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Metric$metricsDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Metric$optionalsToParams(optionals),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['enrolled_members']),
						$author$project$Api$Provider$Metric$metricsPath))));
	});
var $author$project$Api$Provider$Metric$totalTerminations = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Metric$metricsDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Metric$optionalsToParams(optionals),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['ended_members']),
						$author$project$Api$Provider$Metric$metricsPath))));
	});
var $author$project$Pages$Reports$Dashboard$fetchMetrics = function (_v0) {
	var apiClient = _v0.Gv;
	var today = _v0.FR;
	var start = _v0.JV;
	var end = _v0.HB;
	var practitionerId = _v0.Z2;
	var locationId = _v0.We;
	var locationGroupId = _v0.gL;
	var planId = _v0.aj4;
	var companyId = _v0.fZ;
	var engagement = _v0.HC;
	var breakout = _v0.GL;
	var _v1 = _Utils_Tuple2(
		A2(
			$elm$core$Maybe$map,
			A2($author$project$Utils$DateWithDefault$toDate, today, 0),
			start),
		A2(
			$elm$core$Maybe$map,
			A2($author$project$Utils$DateWithDefault$toDate, today, 0),
			end));
	var startDate = _v1.a;
	var endDate = _v1.b;
	var optionals = function (d) {
		return _Utils_update(
			d,
			{
				GL: A2($elm$core$Maybe$map, $author$project$Pages$Reports$Dashboard$breakoutToValue, breakout),
				afQ: companyId,
				HB: endDate,
				HC: $author$project$Pages$Reports$Dashboard$engagementToValue(engagement),
				ais: locationId,
				s4: locationGroupId,
				Jb: planId,
				aka: practitionerId,
				JV: startDate
			});
	};
	return $elm$core$Platform$Cmd$batch(
		_List_fromArray(
			[
				A3($author$project$Api$Provider$Metric$activeMembers, apiClient, optionals, $author$project$Pages$Reports$Dashboard$GotActiveMembersMetric),
				A3($author$project$Api$Provider$Metric$totalEnrollments, apiClient, optionals, $author$project$Pages$Reports$Dashboard$GotEnrolledMembersMetric),
				A3($author$project$Api$Provider$Metric$totalTerminations, apiClient, optionals, $author$project$Pages$Reports$Dashboard$GotEndedMembersMetric)
			]));
};
var $author$project$Pages$Reports$Dashboard$GotOutstanding30To59Amount = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Reports$Dashboard$outstandingInvoicesStatuses = _List_fromArray(
	['issued', 'sent', 'retrying']);
var $author$project$Pages$Reports$Dashboard$invoicesFrom30To59DaysParams = function (today) {
	return function (d) {
		return _Utils_update(
			d,
			{
				HB: $elm$core$Maybe$Just(
					A3($justinmimbs$date$Date$add, 3, -30, today)),
				ajJ: $author$project$Api$Pagination$empty,
				JV: $elm$core$Maybe$Just(
					A3($justinmimbs$date$Date$add, 3, -59, today)),
				alH: $elm$core$Maybe$Just($author$project$Pages$Reports$Dashboard$outstandingInvoicesStatuses)
			});
	};
};
var $author$project$Pages$Reports$Dashboard$fetchOutstandingInvoicesFrom30To59Days = F2(
	function (client, today) {
		return A3(
			$author$project$Api$Provider$Reports$CustomerInvoice$list,
			client,
			$author$project$Pages$Reports$Dashboard$invoicesFrom30To59DaysParams(today),
			A2(
				$elm$core$Basics$composeR,
				A2($author$project$Api$Data$mapHeader, 'x-total-receivable-amount', $author$project$Pages$Reports$Dashboard$headerFromData),
				$author$project$Pages$Reports$Dashboard$GotOutstanding30To59Amount));
	});
var $author$project$Pages$Reports$Dashboard$GotOutstanding60PlusAmount = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Reports$Dashboard$invoicesFrom60PlusDaysParams = function (today) {
	return function (d) {
		return _Utils_update(
			d,
			{
				HB: $elm$core$Maybe$Just(
					A3($justinmimbs$date$Date$add, 3, -60, today)),
				ajJ: $author$project$Api$Pagination$empty,
				alH: $elm$core$Maybe$Just($author$project$Pages$Reports$Dashboard$outstandingInvoicesStatuses)
			});
	};
};
var $author$project$Pages$Reports$Dashboard$fetchOutstandingInvoicesFrom60PlusDays = F2(
	function (client, today) {
		return A3(
			$author$project$Api$Provider$Reports$CustomerInvoice$list,
			client,
			$author$project$Pages$Reports$Dashboard$invoicesFrom60PlusDaysParams(today),
			A2(
				$elm$core$Basics$composeR,
				A2($author$project$Api$Data$mapHeader, 'x-total-receivable-amount', $author$project$Pages$Reports$Dashboard$headerFromData),
				$author$project$Pages$Reports$Dashboard$GotOutstanding60PlusAmount));
	});
var $author$project$Pages$Reports$Dashboard$GotOutstandingLt30Amount = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Reports$Dashboard$invoicesFromLessThan30DaysParams = function (today) {
	return function (d) {
		return _Utils_update(
			d,
			{
				HB: $elm$core$Maybe$Just(today),
				ajJ: $author$project$Api$Pagination$empty,
				JV: $elm$core$Maybe$Just(
					A3($justinmimbs$date$Date$add, 3, -29, today)),
				alH: $elm$core$Maybe$Just($author$project$Pages$Reports$Dashboard$outstandingInvoicesStatuses)
			});
	};
};
var $author$project$Pages$Reports$Dashboard$fetchOutstandingInvoicesFromLessThan30Days = F2(
	function (client, today) {
		return A3(
			$author$project$Api$Provider$Reports$CustomerInvoice$list,
			client,
			$author$project$Pages$Reports$Dashboard$invoicesFromLessThan30DaysParams(today),
			A2(
				$elm$core$Basics$composeR,
				A2($author$project$Api$Data$mapHeader, 'x-total-receivable-amount', $author$project$Pages$Reports$Dashboard$headerFromData),
				$author$project$Pages$Reports$Dashboard$GotOutstandingLt30Amount));
	});
var $author$project$Pages$Reports$Dashboard$initMetrics = {q8: $author$project$Api$Data$Loading, sf: $author$project$Api$Data$Loading, sg: $author$project$Api$Data$Loading};
var $author$project$Pages$Reports$Dashboard$AllEngagements = 0;
var $author$project$Pages$Reports$Dashboard$CurrentlyEngaged = 1;
var $author$project$Pages$Reports$Dashboard$NeverEngaged = 3;
var $author$project$Pages$Reports$Dashboard$PreviouslyEngaged = 2;
var $author$project$Pages$Reports$Dashboard$valueToEngagement = function (stringEngagement) {
	switch (stringEngagement) {
		case 'all':
			return $elm$core$Maybe$Just(0);
		case 'currently_engaged':
			return $elm$core$Maybe$Just(1);
		case 'previously_engaged':
			return $elm$core$Maybe$Just(2);
		case 'never_engaged':
			return $elm$core$Maybe$Just(3);
		default:
			return $elm$core$Maybe$Just(0);
	}
};
var $author$project$Pages$Reports$Dashboard$init = F4(
	function (session, practice, _v0, _v1) {
		var apiClient = _v0.Gv;
		var currentDate = _v0.dd;
		var query = _v1.DE;
		var practitionerId = A2($elm$core$Dict$get, 'practitioner', query);
		var planId = A2($elm$core$Dict$get, 'plan', query);
		var locationId = A2($elm$core$Dict$get, 'location', query);
		var locationGroupId = A2($elm$core$Dict$get, 'location_group', query);
		var engagement = $author$project$Pages$Reports$Dashboard$valueToEngagement(
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Dict$get, 'engagement', query)));
		var companyId = A2($elm$core$Dict$get, 'company', query);
		var _v2 = A4($author$project$Utils$Report$PlanResourceFilter$init, apiClient, $elm$core$Basics$identity, session, planId);
		var planResourceFilter = _v2.a;
		var planResourceFilterCmd = _v2.b;
		var _v3 = A7($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$init, apiClient, session, practice, false, locationGroupId, locationId, practitionerId);
		var groupLocationAndPractitionerFilters = _v3.a;
		var groupLocationAndPractitionerFiltersCmd = _v3.b;
		var _v4 = $author$project$Utils$DateWithDefault$fromQuery(query);
		var start = _v4.a;
		var end = _v4.b;
		var _v5 = _Utils_Tuple2(
			A2(
				$elm$core$Maybe$map,
				A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
				start),
			A2(
				$elm$core$Maybe$map,
				A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
				end));
		var startDate = _v5.a;
		var endDate = _v5.b;
		var _v6 = A2(
			$author$project$Components$DateRangeInput$init,
			'date-range-input',
			A2($author$project$Pages$Reports$Dashboard$dateRangeInputSettings, startDate, endDate));
		var dateRangeInput = _v6.a;
		var dateRangeInputCmd = _v6.b;
		var _v7 = A4(
			$author$project$Utils$Report$CompanyResourceFilter$init,
			apiClient,
			$elm$core$Basics$identity,
			$author$project$Api$Practice$Provider(practice),
			companyId);
		var companyResourceFilter = _v7.a;
		var companyResourceFilterCmd = _v7.b;
		var model = {Gv: apiClient, GL: $elm$core$Maybe$Nothing, fZ: companyId, mZ: companyResourceFilter, i4: dateRangeInput, HB: end, HC: engagement, dn: groupLocationAndPractitionerFilters, Ar: $author$project$Api$Data$Loading, gL: locationGroupId, We: locationId, aw: $author$project$Pages$Reports$Dashboard$initMetrics, Ci: $author$project$Api$Data$Loading, Cj: $author$project$Api$Data$Loading, Ck: $author$project$Api$Data$Loading, tO: $elm$core$Maybe$Nothing, aj4: planId, hi: planResourceFilter, ZV: practice, Z2: practitionerId, aa4: session, uH: 0, JV: start, FR: currentDate};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Pages$Reports$Dashboard$fetchOutstandingInvoicesFromLessThan30Days, apiClient, currentDate),
						A2($author$project$Pages$Reports$Dashboard$fetchOutstandingInvoicesFrom30To59Days, apiClient, currentDate),
						A2($author$project$Pages$Reports$Dashboard$fetchOutstandingInvoicesFrom60PlusDays, apiClient, currentDate),
						$author$project$Pages$Reports$Dashboard$fetchIssued(apiClient),
						$author$project$Pages$Reports$Dashboard$fetchMetrics(model),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Reports$Dashboard$DateRangeInputMsg, dateRangeInputCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Reports$Dashboard$GroupLocationAndPractitionerFiltersMsg, groupLocationAndPractitionerFiltersCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Reports$Dashboard$PlanResourceFilterMsg, planResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Reports$Dashboard$CompanyResourceFilterMsg, companyResourceFilterCmd)
					])));
	});
var $author$project$Pages$Reports$Dashboard$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$Dashboard$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Reports$Dashboard$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Reports$Dashboard$GroupLocationAndPractitionerFiltersMsg,
				$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$subscriptions(model.dn)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Reports$Dashboard$CompanyResourceFilterMsg,
				$author$project$Components$ResourceFilter$Company$subscriptions(model.mZ)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Reports$Dashboard$PlanResourceFilterMsg,
				$author$project$Components$ResourceFilter$Plan$subscriptions(model.hi))
			]));
};
var $author$project$Pages$Reports$Dashboard$Metrics = F3(
	function (activeMembers, enrolledMembers, endedMembers) {
		return {q8: activeMembers, sf: endedMembers, sg: enrolledMembers};
	});
var $author$project$Api$Provider$Metric$datesRange = function (_v0) {
	var data = _v0;
	return _Utils_Tuple2(
		A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$first,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$List$head,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$second,
					$elm$core$List$head(data)))),
		A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$first,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$List$head,
				A2(
					$elm$core$Maybe$map,
					$elm$core$List$reverse,
					A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$second,
						$elm$core$List$head(data))))));
};
var $author$project$Api$Provider$Metric$filter = F2(
	function (filterFunc, _v0) {
		var metricData = _v0;
		return A2(
			$elm$core$List$map,
			function (_v1) {
				var key = _v1.a;
				var data = _v1.b;
				return _Utils_Tuple2(
					key,
					A2($elm$core$List$filter, filterFunc, data));
			},
			metricData);
	});
var $author$project$Api$Provider$Metric$filterByMonth = F2(
	function (month, metric) {
		return A2(
			$author$project$Api$Provider$Metric$filter,
			function (_v0) {
				var date = _v0.a;
				return _Utils_eq(date, month);
			},
			metric);
	});
var $author$project$Api$Provider$Metric$values = function (_v0) {
	var data = _v0;
	return A2(
		$elm$core$List$map,
		function (_v1) {
			var ticks = _v1.b;
			return A2($elm$core$List$map, $elm$core$Tuple$second, ticks);
		},
		data);
};
var $author$project$Api$Provider$Metric$total = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Metric$values,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$map($elm$core$List$sum),
		$elm$core$List$sum));
var $author$project$Pages$Reports$Dashboard$buildPeriodSummary = F4(
	function (today, active, ended, enrolled) {
		var _v0 = A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Maybe$withDefault(
				$author$project$Utils$Date$toEndOfMonth(today)),
			A2(
				$elm$core$Tuple$mapFirst,
				$elm$core$Maybe$withDefault(
					$author$project$Utils$Date$toBeginningOfMonth(today)),
				$author$project$Api$Provider$Metric$datesRange(active)));
		var firstMonth = _v0.a;
		var lastMonth = _v0.b;
		var activeDuringFirstMonth = $elm$core$Basics$round(
			$author$project$Api$Provider$Metric$total(
				A2($author$project$Api$Provider$Metric$filterByMonth, firstMonth, active)));
		var endedDuringFirstMonth = $elm$core$Basics$round(
			$author$project$Api$Provider$Metric$total(
				A2($author$project$Api$Provider$Metric$filterByMonth, firstMonth, ended)));
		var enrolledDuringFirstMonth = $elm$core$Basics$round(
			$author$project$Api$Provider$Metric$total(
				A2($author$project$Api$Provider$Metric$filterByMonth, firstMonth, enrolled)));
		var activeDuringLastMonth = $elm$core$Basics$round(
			$author$project$Api$Provider$Metric$total(
				A2($author$project$Api$Provider$Metric$filterByMonth, lastMonth, active)));
		return {
			vz: activeDuringLastMonth,
			vA: (activeDuringFirstMonth - enrolledDuringFirstMonth) + endedDuringFirstMonth,
			HD: $elm$core$Basics$round(
				$author$project$Api$Provider$Metric$total(enrolled)),
			J4: $elm$core$Basics$round(
				$author$project$Api$Provider$Metric$total(ended))
		};
	});
var $author$project$Pages$Reports$Dashboard$andBuildSummary = function (original) {
	var model = original.a;
	var metrics = model.aw;
	var cmds = original.b;
	var outMsgs = original.c;
	var _v0 = _Utils_Tuple3(metrics.q8, metrics.sf, metrics.sg);
	if (((_v0.a.$ === 3) && (_v0.b.$ === 3)) && (_v0.c.$ === 3)) {
		var _v1 = _v0.a;
		var active = _v1.a;
		var _v2 = _v0.b;
		var ended = _v2.a;
		var _v3 = _v0.c;
		var enrolled = _v3.a;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{
					tO: $elm$core$Maybe$Just(
						A4($author$project$Pages$Reports$Dashboard$buildPeriodSummary, model.FR, active, ended, enrolled))
				}),
			cmds,
			outMsgs);
	} else {
		return original;
	}
};
var $author$project$Pages$Reports$Dashboard$isForbidden = function (data) {
	if (((data.$ === 2) && (data.a.$ === 6)) && (data.a.a === 403)) {
		var _v1 = data.a;
		return true;
	} else {
		return false;
	}
};
var $author$project$Pages$Reports$Dashboard$andHandleAmountResponse = F2(
	function (amount, model) {
		return _Utils_Tuple3(
			model,
			$elm$core$Platform$Cmd$none,
			$author$project$Pages$Reports$Dashboard$isForbidden(amount) ? _List_Nil : $author$project$OutMsg$handleErrorResponse(amount));
	});
var $author$project$Pages$Reports$Dashboard$activeColor = 'rgba(103, 173, 226, 0.45)';
var $author$project$Ports$DashboardChart$YAxis$Left = 1;
var $author$project$Ports$DashboardChart$YAxis$YAxis = $elm$core$Basics$identity;
var $author$project$Ports$DashboardChart$YAxis$axis = function (attributes) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (attribute, record) {
				switch (attribute.$) {
					case 0:
						var id_ = attribute.a;
						return _Utils_update(
							record,
							{ahP: id_});
					case 1:
						var position = attribute.a;
						return _Utils_update(
							record,
							{ZP: position});
					case 2:
						var label_ = attribute.a;
						return _Utils_update(
							record,
							{
								aih: $elm$core$Maybe$Just(label_)
							});
					case 3:
						var suffix = attribute.a;
						return _Utils_update(
							record,
							{
								FP: $elm$core$Maybe$Just(suffix)
							});
					default:
						var stacked_ = attribute.a;
						return _Utils_update(
							record,
							{EJ: stacked_});
				}
			}),
		{GE: true, ahP: '', aih: $elm$core$Maybe$Nothing, ZP: 1, EJ: false, FP: $elm$core$Maybe$Nothing},
		attributes);
};
var $author$project$Ports$DashboardChart$Chart = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Ports$DashboardChart$chartAttributesToRecord = function (attributes) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (attr, record) {
				if (!attr.$) {
					var labels_ = attr.a;
					return _Utils_update(
						record,
						{Ax: labels_});
				} else {
					var axis = attr.a;
					return _Utils_update(
						record,
						{
							vu: _Utils_ap(
								record.vu,
								_List_fromArray(
									[axis]))
						});
				}
			}),
		{Ax: _List_Nil, vu: _List_Nil},
		attributes);
};
var $author$project$Ports$DashboardChart$chart = F2(
	function (attributes, datasets) {
		return A2(
			$author$project$Ports$DashboardChart$Chart,
			$author$project$Ports$DashboardChart$chartAttributesToRecord(attributes),
			datasets);
	});
var $author$project$Ports$DashboardChart$DataSet$Color = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ports$DashboardChart$DataSet$ColorConfig = F4(
	function (backgroundColor, borderColor, pointBackgroundColor, pointBorderColor) {
		return {Mu: backgroundColor, MP: borderColor, ZL: pointBackgroundColor, ZM: pointBorderColor};
	});
var $author$project$Ports$DashboardChart$DataSet$color = function (rgbaString) {
	return $author$project$Ports$DashboardChart$DataSet$Color(
		$elm$core$Maybe$Just(
			A4($author$project$Ports$DashboardChart$DataSet$ColorConfig, rgbaString, rgbaString, rgbaString, rgbaString)));
};
var $author$project$Ports$DashboardChart$DataSet$colorAuto = $author$project$Ports$DashboardChart$DataSet$Color($elm$core$Maybe$Nothing);
var $author$project$Api$Provider$Metric$months = function (_v0) {
	var data = _v0;
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			$elm$core$List$map($elm$core$Tuple$first),
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$second,
				$elm$core$List$head(data))));
};
var $author$project$Api$Provider$Metric$combine = F2(
	function (key, metric) {
		var months_ = $author$project$Api$Provider$Metric$months(metric);
		return $elm$core$List$singleton(
			A2(
				$elm$core$Tuple$pair,
				key,
				A3(
					$elm$core$List$map2,
					F2(
						function (date, ticks) {
							return _Utils_Tuple2(date, ticks);
						}),
					months_,
					A3(
						$elm$core$List$foldl,
						$elm$core$List$map2(
							F2(
								function (y, accY) {
									return y + accY;
								})),
						A2(
							$elm$core$List$repeat,
							$elm$core$List$length(months_),
							0),
						$author$project$Api$Provider$Metric$values(metric)))));
	});
var $author$project$Ports$DashboardChart$DataSet$Bar = 1;
var $author$project$Ports$DashboardChart$DataSet$DataSet = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Ports$DashboardChart$DataSet$dataset = F2(
	function (attributes, data) {
		return A2(
			$author$project$Ports$DashboardChart$DataSet$DataSet,
			data,
			A3(
				$elm$core$List$foldl,
				F2(
					function (attribute, record) {
						switch (attribute.$) {
							case 0:
								var axisId = attribute.a;
								return _Utils_update(
									record,
									{
										xw: $elm$core$Maybe$Just(axisId)
									});
							case 2:
								var type_ = attribute.a;
								return _Utils_update(
									record,
									{amg: type_});
							case 1:
								var string = attribute.a;
								return _Utils_update(
									record,
									{
										aih: $elm$core$Maybe$Just(string)
									});
							case 3:
								var maybeColorConfig = attribute.a;
								return _Utils_update(
									record,
									{iL: maybeColorConfig});
							default:
								var suffix_ = attribute.a;
								return _Utils_update(
									record,
									{
										acE: $elm$core$Maybe$Just(suffix_)
									});
						}
					}),
				{xw: $elm$core$Maybe$Nothing, iL: $elm$core$Maybe$Nothing, aih: $elm$core$Maybe$Nothing, acE: $elm$core$Maybe$Nothing, amg: 1},
				attributes));
	});
var $author$project$Pages$Reports$Dashboard$enrollmentsColor = 'rgba(75, 192, 192, 1)';
var $author$project$Api$Provider$Metric$fromList = F2(
	function (key, tick) {
		return $elm$core$List$singleton(
			_Utils_Tuple2(key, tick));
	});
var $author$project$Pages$Reports$Dashboard$growthAndAttritionMetric = F3(
	function (active, ended, enrolled) {
		var months = $author$project$Api$Provider$Metric$months(active);
		return A3(
			$elm$core$Tuple$mapBoth,
			$author$project$Api$Provider$Metric$fromList('growth'),
			$author$project$Api$Provider$Metric$fromList('attrition'),
			A3(
				$elm$core$List$foldl,
				F2(
					function (month, _v0) {
						var growth = _v0.a;
						var attrition = _v0.b;
						var terminations = $author$project$Api$Provider$Metric$total(
							A2($author$project$Api$Provider$Metric$filterByMonth, month, ended));
						var enrollments = $author$project$Api$Provider$Metric$total(
							A2($author$project$Api$Provider$Metric$filterByMonth, month, enrolled));
						var activeAtEnd = $author$project$Api$Provider$Metric$total(
							A2($author$project$Api$Provider$Metric$filterByMonth, month, active));
						var activeAtBeginning = (activeAtEnd - enrollments) + terminations;
						return _Utils_Tuple2(
							_Utils_ap(
								growth,
								_List_fromArray(
									[
										_Utils_Tuple2(
										month,
										(!activeAtBeginning) ? 0 : A2($myrho$elm_round$Round$roundNum, 2, (enrollments * 100) / activeAtBeginning))
									])),
							_Utils_ap(
								attrition,
								_List_fromArray(
									[
										_Utils_Tuple2(
										month,
										(!activeAtBeginning) ? 0 : A2($myrho$elm_round$Round$roundNum, 2, (terminations * 100) / activeAtBeginning))
									])));
					}),
				_Utils_Tuple2(_List_Nil, _List_Nil),
				months));
	});
var $author$project$Ports$DashboardChart$YAxis$Id = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ports$DashboardChart$YAxis$id = $author$project$Ports$DashboardChart$YAxis$Id;
var $author$project$Ports$DashboardChart$DataSet$Label = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ports$DashboardChart$DataSet$label = $author$project$Ports$DashboardChart$DataSet$Label;
var $author$project$Ports$DashboardChart$YAxis$Label = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ports$DashboardChart$YAxis$label = $author$project$Ports$DashboardChart$YAxis$Label;
var $author$project$Ports$DashboardChart$XLabels = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ports$DashboardChart$labels = $author$project$Ports$DashboardChart$XLabels;
var $author$project$Ports$DashboardChart$YAxis$Position = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ports$DashboardChart$YAxis$left = $author$project$Ports$DashboardChart$YAxis$Position(1);
var $author$project$Ports$DashboardChart$DataSet$ChartType = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ports$DashboardChart$DataSet$Line = 0;
var $author$project$Ports$DashboardChart$DataSet$line = $author$project$Ports$DashboardChart$DataSet$ChartType(0);
var $author$project$Api$Provider$Metric$map = F2(
	function (func, _v0) {
		var data = _v0;
		return A2(
			$elm$core$List$map,
			function (_v1) {
				var key = _v1.a;
				var ticks = _v1.b;
				return func(
					_Utils_Tuple2(
						key,
						A2($elm$core$List$map, $elm$core$Tuple$second, ticks)));
			},
			data);
	});
var $author$project$Ports$DashboardChart$DataSet$encode = function (_v0) {
	var data = _v0.a;
	var record = _v0.b;
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					_Utils_Tuple2(
						'data',
						A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$float, data))),
					A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$pair('label'),
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, record.aih)),
					$elm$core$Maybe$Just(
					_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string(
							function () {
								var _v1 = record.amg;
								if (_v1 === 1) {
									return 'bar';
								} else {
									return 'line';
								}
							}()))),
					A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$pair('yAxisID'),
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, record.xw)),
					$elm$core$Maybe$Just(
					_Utils_Tuple2(
						'fill',
						$elm$json$Json$Encode$bool(
							function () {
								var _v2 = record.amg;
								if (_v2 === 1) {
									return true;
								} else {
									return false;
								}
							}()))),
					$elm$core$Maybe$Just(
					_Utils_Tuple2(
						'tension',
						$elm$json$Json$Encode$float(0.4))),
					A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$pair('backgroundColor'),
					A2(
						$elm$core$Maybe$map,
						$elm$json$Json$Encode$string,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.Mu;
							},
							record.iL))),
					A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$pair('borderColor'),
					A2(
						$elm$core$Maybe$map,
						$elm$json$Json$Encode$string,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.MP;
							},
							record.iL))),
					A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$pair('pointBackgroundColor'),
					A2(
						$elm$core$Maybe$map,
						$elm$json$Json$Encode$string,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.ZL;
							},
							record.iL))),
					A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$pair('pointBorderColor'),
					A2(
						$elm$core$Maybe$map,
						$elm$json$Json$Encode$string,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.ZM;
							},
							record.iL))),
					A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$pair('suffix'),
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, record.acE))
				])));
};
var $author$project$Ports$DashboardChart$YAxis$encode = function (_v0) {
	var record = _v0;
	return _Utils_Tuple2(
		record.ahP,
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(record.ahP)),
					_Utils_Tuple2(
					'axis',
					$elm$json$Json$Encode$string('y')),
					_Utils_Tuple2(
					'display',
					$elm$json$Json$Encode$bool(true)),
					_Utils_Tuple2(
					'stacked',
					$elm$json$Json$Encode$bool(record.EJ)),
					_Utils_Tuple2(
					'position',
					$elm$json$Json$Encode$string(
						function () {
							var _v1 = record.ZP;
							if (!_v1) {
								return 'right';
							} else {
								return 'left';
							}
						}())),
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('linear')),
					_Utils_Tuple2(
					'beginAtZero',
					$elm$json$Json$Encode$bool(record.GE)),
					_Utils_Tuple2(
					'suggestedMax',
					$elm$json$Json$Encode$int(20)),
					_Utils_Tuple2(
					'ticks',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'suffix',
								A2(
									$elm$core$Maybe$withDefault,
									$elm$json$Json$Encode$null,
									A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, record.FP)))
							]))),
					_Utils_Tuple2(
					'title',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'display',
								$elm$json$Json$Encode$bool(true)),
								_Utils_Tuple2(
								'text',
								A2(
									$elm$core$Maybe$withDefault,
									$elm$json$Json$Encode$null,
									A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, record.aih))),
								_Utils_Tuple2(
								'fontSize',
								$elm$json$Json$Encode$int(16))
							])))
				])));
};
var $author$project$Ports$DashboardChart$DataSet$isEmpty = function (_v0) {
	var data = _v0.a;
	return A2(
		$elm$core$List$all,
		function (val) {
			return !val;
		},
		data);
};
var $author$project$Ports$DashboardChart$encode = function (_v0) {
	var record = _v0.a;
	var datasets = _v0.b;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'datasets',
				A2(
					$elm$json$Json$Encode$list,
					$author$project$Ports$DashboardChart$DataSet$encode,
					A2($elm$core$List$all, $author$project$Ports$DashboardChart$DataSet$isEmpty, datasets) ? _List_Nil : datasets)),
				_Utils_Tuple2(
				'labels',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, record.Ax)),
				_Utils_Tuple2(
				'options',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'plugins',
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'tooltip',
										$elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'mode',
													$elm$json$Json$Encode$string('index'))
												])))
									]))),
							_Utils_Tuple2(
							'scales',
							$elm$json$Json$Encode$object(
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										'x',
										$elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'axis',
													$elm$json$Json$Encode$string('x')),
													_Utils_Tuple2(
													'id',
													$elm$json$Json$Encode$string('x')),
													_Utils_Tuple2(
													'stacked',
													$elm$json$Json$Encode$bool(true))
												]))),
									A2($elm$core$List$map, $author$project$Ports$DashboardChart$YAxis$encode, record.vu))))
						])))
			]));
};
var $author$project$Ports$DashboardChart$mountDashboardChart = _Platform_outgoingPort('mountDashboardChart', $elm$core$Basics$identity);
var $author$project$Ports$DashboardChart$mount = A2($elm$core$Basics$composeR, $author$project$Ports$DashboardChart$encode, $author$project$Ports$DashboardChart$mountDashboardChart);
var $author$project$Ports$DashboardChart$YAxis$Right = 0;
var $author$project$Ports$DashboardChart$YAxis$right = $author$project$Ports$DashboardChart$YAxis$Position(0);
var $author$project$Ports$DashboardChart$YAxis$Stacked = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ports$DashboardChart$YAxis$stacked = $author$project$Ports$DashboardChart$YAxis$Stacked(true);
var $author$project$Ports$DashboardChart$DataSet$Suffix = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ports$DashboardChart$DataSet$suffix = $author$project$Ports$DashboardChart$DataSet$Suffix;
var $author$project$Pages$Reports$Dashboard$terminationsColor = 'rgba(255, 99, 132, 1)';
var $author$project$Ports$DashboardChart$YAxis$TickSuffix = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ports$DashboardChart$YAxis$tickSuffix = $author$project$Ports$DashboardChart$YAxis$TickSuffix;
var $author$project$Ports$DashboardChart$YAxis = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ports$DashboardChart$yAxis = $author$project$Ports$DashboardChart$YAxis;
var $author$project$Ports$DashboardChart$DataSet$YAxisId = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ports$DashboardChart$DataSet$yAxis = $author$project$Ports$DashboardChart$DataSet$YAxisId;
var $author$project$Pages$Reports$Dashboard$andRenderChart = function (original) {
	var model = original.a;
	var metrics = model.aw;
	var showing = model.uH;
	var breakout = model.GL;
	var cmds = original.b;
	var outMsgs = original.c;
	var _v0 = _Utils_Tuple3(metrics.q8, metrics.sf, metrics.sg);
	if (((_v0.a.$ === 3) && (_v0.b.$ === 3)) && (_v0.c.$ === 3)) {
		var _v1 = _v0.a;
		var active = _v1.a;
		var _v2 = _v0.b;
		var ended = _v2.a;
		var _v3 = _v0.c;
		var enrolled = _v3.a;
		var monthsLabels = A2(
			$elm$core$List$map,
			function (date) {
				return A2($justinmimbs$date$Date$format, 'MMM yyyy', date);
			},
			$author$project$Api$Provider$Metric$months(active));
		var ifBrokenOut = F2(
			function (_this, _default) {
				return A2(
					$elm$core$Maybe$withDefault,
					_default,
					A2(
						$elm$core$Maybe$map,
						$elm$core$Basics$always(_this),
						breakout));
			});
		return _Utils_Tuple3(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						cmds,
						function () {
						switch (showing) {
							case 0:
								return $author$project$Ports$DashboardChart$mount(
									A2(
										$author$project$Ports$DashboardChart$chart,
										_List_fromArray(
											[
												$author$project$Ports$DashboardChart$labels(monthsLabels),
												$author$project$Ports$DashboardChart$yAxis(
												$author$project$Ports$DashboardChart$YAxis$axis(
													_List_fromArray(
														[
															$author$project$Ports$DashboardChart$YAxis$id('y-1'),
															$author$project$Ports$DashboardChart$YAxis$left,
															$author$project$Ports$DashboardChart$YAxis$label('Active Members'),
															$author$project$Ports$DashboardChart$YAxis$stacked
														]))),
												$author$project$Ports$DashboardChart$yAxis(
												$author$project$Ports$DashboardChart$YAxis$axis(
													_List_fromArray(
														[
															$author$project$Ports$DashboardChart$YAxis$id('y-2'),
															$author$project$Ports$DashboardChart$YAxis$right,
															$author$project$Ports$DashboardChart$YAxis$label('Growth / Attrition'),
															$author$project$Ports$DashboardChart$YAxis$tickSuffix('%')
														])))
											]),
										$elm$core$List$concat(
											function (_v5) {
												var growth = _v5.a;
												var attrition = _v5.b;
												return _List_fromArray(
													[
														A2(
														$author$project$Api$Provider$Metric$map,
														function (_v6) {
															var key = _v6.a;
															var values = _v6.b;
															return A2(
																$author$project$Ports$DashboardChart$DataSet$dataset,
																_List_fromArray(
																	[
																		$author$project$Ports$DashboardChart$DataSet$color($author$project$Pages$Reports$Dashboard$activeColor),
																		$author$project$Ports$DashboardChart$DataSet$yAxis('y-1'),
																		$author$project$Ports$DashboardChart$DataSet$label(
																		A2(ifBrokenOut, key, 'Active')),
																		A2(
																		ifBrokenOut,
																		$author$project$Ports$DashboardChart$DataSet$colorAuto,
																		$author$project$Ports$DashboardChart$DataSet$color($author$project$Pages$Reports$Dashboard$activeColor))
																	]),
																values);
														},
														active),
														A2(
														$author$project$Api$Provider$Metric$map,
														function (_v7) {
															var key = _v7.a;
															var values = _v7.b;
															return A2(
																$author$project$Ports$DashboardChart$DataSet$dataset,
																_List_fromArray(
																	[
																		$author$project$Ports$DashboardChart$DataSet$yAxis('y-2'),
																		$author$project$Ports$DashboardChart$DataSet$color($author$project$Pages$Reports$Dashboard$enrollmentsColor),
																		$author$project$Ports$DashboardChart$DataSet$line,
																		$author$project$Ports$DashboardChart$DataSet$label(key),
																		$author$project$Ports$DashboardChart$DataSet$suffix('%')
																	]),
																values);
														},
														A2($author$project$Api$Provider$Metric$combine, 'Enrollments', growth)),
														A2(
														$author$project$Api$Provider$Metric$map,
														function (_v8) {
															var key = _v8.a;
															var values = _v8.b;
															return A2(
																$author$project$Ports$DashboardChart$DataSet$dataset,
																_List_fromArray(
																	[
																		$author$project$Ports$DashboardChart$DataSet$yAxis('y-2'),
																		$author$project$Ports$DashboardChart$DataSet$color($author$project$Pages$Reports$Dashboard$terminationsColor),
																		$author$project$Ports$DashboardChart$DataSet$line,
																		$author$project$Ports$DashboardChart$DataSet$label(key),
																		$author$project$Ports$DashboardChart$DataSet$suffix('%')
																	]),
																values);
														},
														A2($author$project$Api$Provider$Metric$combine, 'Terminations', attrition))
													]);
											}(
												A3($author$project$Pages$Reports$Dashboard$growthAndAttritionMetric, active, ended, enrolled)))));
							case 1:
								return $author$project$Ports$DashboardChart$mount(
									A2(
										$author$project$Ports$DashboardChart$chart,
										_List_fromArray(
											[
												$author$project$Ports$DashboardChart$labels(monthsLabels),
												$author$project$Ports$DashboardChart$yAxis(
												$author$project$Ports$DashboardChart$YAxis$axis(
													_List_fromArray(
														[
															$author$project$Ports$DashboardChart$YAxis$id('y-1'),
															$author$project$Ports$DashboardChart$YAxis$left,
															$author$project$Ports$DashboardChart$YAxis$label('Active Members'),
															$author$project$Ports$DashboardChart$YAxis$stacked
														])))
											]),
										A2(
											$author$project$Api$Provider$Metric$map,
											function (_v9) {
												var key = _v9.a;
												var values = _v9.b;
												return A2(
													$author$project$Ports$DashboardChart$DataSet$dataset,
													_List_fromArray(
														[
															$author$project$Ports$DashboardChart$DataSet$color($author$project$Pages$Reports$Dashboard$activeColor),
															$author$project$Ports$DashboardChart$DataSet$label(
															A2(ifBrokenOut, key, 'Active')),
															A2(
															ifBrokenOut,
															$author$project$Ports$DashboardChart$DataSet$colorAuto,
															$author$project$Ports$DashboardChart$DataSet$color($author$project$Pages$Reports$Dashboard$activeColor))
														]),
													values);
											},
											active)));
							case 2:
								return $author$project$Ports$DashboardChart$mount(
									A2(
										$author$project$Ports$DashboardChart$chart,
										_List_fromArray(
											[
												$author$project$Ports$DashboardChart$labels(monthsLabels),
												$author$project$Ports$DashboardChart$yAxis(
												$author$project$Ports$DashboardChart$YAxis$axis(
													_List_fromArray(
														[
															$author$project$Ports$DashboardChart$YAxis$id('y-1'),
															$author$project$Ports$DashboardChart$YAxis$left,
															$author$project$Ports$DashboardChart$YAxis$label('Terminations'),
															$author$project$Ports$DashboardChart$YAxis$stacked
														])))
											]),
										A2(
											$author$project$Api$Provider$Metric$map,
											function (_v10) {
												var key = _v10.a;
												var values = _v10.b;
												return A2(
													$author$project$Ports$DashboardChart$DataSet$dataset,
													_List_fromArray(
														[
															A2(
															ifBrokenOut,
															$author$project$Ports$DashboardChart$DataSet$colorAuto,
															$author$project$Ports$DashboardChart$DataSet$color($author$project$Pages$Reports$Dashboard$terminationsColor)),
															$author$project$Ports$DashboardChart$DataSet$label(
															A2(ifBrokenOut, key, 'Terminations'))
														]),
													values);
											},
											ended)));
							default:
								return $author$project$Ports$DashboardChart$mount(
									A2(
										$author$project$Ports$DashboardChart$chart,
										_List_fromArray(
											[
												$author$project$Ports$DashboardChart$labels(monthsLabels),
												$author$project$Ports$DashboardChart$yAxis(
												$author$project$Ports$DashboardChart$YAxis$axis(
													_List_fromArray(
														[
															$author$project$Ports$DashboardChart$YAxis$id('y-1'),
															$author$project$Ports$DashboardChart$YAxis$left,
															$author$project$Ports$DashboardChart$YAxis$label('Enrollments'),
															$author$project$Ports$DashboardChart$YAxis$stacked
														])))
											]),
										A2(
											$author$project$Api$Provider$Metric$map,
											function (_v11) {
												var key = _v11.a;
												var values = _v11.b;
												return A2(
													$author$project$Ports$DashboardChart$DataSet$dataset,
													_List_fromArray(
														[
															$author$project$Ports$DashboardChart$DataSet$label(
															A2(ifBrokenOut, key, 'Enrollments')),
															A2(
															ifBrokenOut,
															$author$project$Ports$DashboardChart$DataSet$colorAuto,
															$author$project$Ports$DashboardChart$DataSet$color($author$project$Pages$Reports$Dashboard$enrollmentsColor))
														]),
													values);
											},
											enrolled)));
						}
					}()
					])),
			outMsgs);
	} else {
		return original;
	}
};
var $author$project$Pages$Reports$Dashboard$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('start'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.FR, 0)),
			model.JV),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('end'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.FR, 0)),
			model.HB),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('location_group'),
			model.gL),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('location'),
			model.We),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('practitioner'),
			model.Z2),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('plan'),
			model.aj4),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('engagement'),
			$author$project$Pages$Reports$Dashboard$engagementToValue(model.HC)),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('company'),
			model.fZ)
		]);
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__Dashboard)
				]),
			A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)));
};
var $author$project$Pages$Reports$Dashboard$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var amount = msg.a;
				return A2(
					$author$project$Pages$Reports$Dashboard$andHandleAmountResponse,
					amount,
					_Utils_update(
						model,
						{Ck: amount}));
			case 1:
				var amount = msg.a;
				return A2(
					$author$project$Pages$Reports$Dashboard$andHandleAmountResponse,
					amount,
					_Utils_update(
						model,
						{Ci: amount}));
			case 2:
				var amount = msg.a;
				return A2(
					$author$project$Pages$Reports$Dashboard$andHandleAmountResponse,
					amount,
					_Utils_update(
						model,
						{Cj: amount}));
			case 3:
				var amount = msg.a;
				return A2(
					$author$project$Pages$Reports$Dashboard$andHandleAmountResponse,
					amount,
					_Utils_update(
						model,
						{Ar: amount}));
			case 5:
				var metric = msg.a;
				return function (metrics) {
					return $author$project$Pages$Reports$Dashboard$andRenderChart(
						$author$project$Pages$Reports$Dashboard$andBuildSummary(
							_Utils_Tuple3(
								_Utils_update(
									model,
									{aw: metrics}),
								$elm$core$Platform$Cmd$none,
								$author$project$OutMsg$handleErrorResponse(metric))));
				}(
					function (metrics) {
						return _Utils_update(
							metrics,
							{q8: metric});
					}(model.aw));
			case 6:
				var metric = msg.a;
				return function (metrics) {
					return $author$project$Pages$Reports$Dashboard$andRenderChart(
						$author$project$Pages$Reports$Dashboard$andBuildSummary(
							_Utils_Tuple3(
								_Utils_update(
									model,
									{aw: metrics}),
								$elm$core$Platform$Cmd$none,
								$author$project$OutMsg$handleErrorResponse(metric))));
				}(
					function (metrics) {
						return _Utils_update(
							metrics,
							{sg: metric});
					}(model.aw));
			case 7:
				var metric = msg.a;
				return function (metrics) {
					return $author$project$Pages$Reports$Dashboard$andRenderChart(
						$author$project$Pages$Reports$Dashboard$andBuildSummary(
							_Utils_Tuple3(
								_Utils_update(
									model,
									{aw: metrics}),
								$elm$core$Platform$Cmd$none,
								$author$project$OutMsg$handleErrorResponse(metric))));
				}(
					function (metrics) {
						return _Utils_update(
							metrics,
							{sf: metric});
					}(model.aw));
			case 8:
				var showing = msg.a;
				return $author$project$Pages$Reports$Dashboard$andRenderChart(
					_Utils_Tuple3(
						_Utils_update(
							model,
							{uH: showing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil));
			case 9:
				var breakout = msg.a;
				return function (newModel) {
					return _Utils_Tuple3(
						newModel,
						$author$project$Pages$Reports$Dashboard$fetchMetrics(newModel),
						_List_Nil);
				}(
					_Utils_update(
						model,
						{GL: breakout, aw: $author$project$Pages$Reports$Dashboard$initMetrics}));
			case 10:
				var engagement = msg.a;
				return function (newModel) {
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Pages$Reports$Dashboard$fetchMetrics(newModel),
									$author$project$Pages$Reports$Dashboard$updateUrl(newModel)
								])),
						_List_Nil);
				}(
					_Utils_update(
						model,
						{HC: engagement, aw: $author$project$Pages$Reports$Dashboard$initMetrics}));
			case 4:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Components$DateRangeInput$update, subMsg, model.i4);
				var dateRangeInput = _v1.a;
				var subCmd = _v1.b;
				var event = _v1.c;
				var newModel = function () {
					if (event.$ === 1) {
						var fromDate = event.a;
						var toDate = event.b;
						return _Utils_update(
							model,
							{
								i4: dateRangeInput,
								HB: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
								aw: A3($author$project$Pages$Reports$Dashboard$Metrics, $author$project$Api$Data$Loading, $author$project$Api$Data$Loading, $author$project$Api$Data$Loading),
								tO: $elm$core$Maybe$Nothing,
								JV: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
							});
					} else {
						return _Utils_update(
							model,
							{i4: dateRangeInput});
					}
				}();
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Reports$Dashboard$DateRangeInputMsg, subCmd),
								(_Utils_eq(newModel.JV, model.JV) && _Utils_eq(newModel.HB, model.HB)) ? $elm$core$Platform$Cmd$none : $elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Reports$Dashboard$updateUrl(newModel),
										$author$project$Pages$Reports$Dashboard$fetchMetrics(newModel)
									]))
							])),
					_List_Nil);
			case 11:
				var subMsg = msg.a;
				var result = A3($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$update, model.Gv, subMsg, model.dn);
				var _v3 = result.agZ;
				if (!_v3.$) {
					var locationGroupId = _v3.a;
					var locationId = _v3.b;
					var practitionerId = _v3.c;
					var newModel = _Utils_update(
						model,
						{dn: result.aiO, gL: locationGroupId, We: locationId, aw: $author$project$Pages$Reports$Dashboard$initMetrics, Z2: practitionerId});
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Reports$Dashboard$GroupLocationAndPractitionerFiltersMsg, result.GZ),
									$author$project$Pages$Reports$Dashboard$fetchMetrics(newModel),
									$author$project$Pages$Reports$Dashboard$updateUrl(newModel)
								])),
						result.aR);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dn: result.aiO}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Reports$Dashboard$GroupLocationAndPractitionerFiltersMsg, result.GZ),
						result.aR);
				}
			case 13:
				var subMsg = msg.a;
				return function (original) {
					var newModel = original.a;
					var cmd = original.b;
					var outMsgs = original.c;
					return (!_Utils_eq(newModel.fZ, model.fZ)) ? _Utils_Tuple3(
						_Utils_update(
							newModel,
							{aw: $author$project$Pages$Reports$Dashboard$initMetrics}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									cmd,
									$author$project$Pages$Reports$Dashboard$fetchMetrics(newModel),
									$author$project$Pages$Reports$Dashboard$updateUrl(newModel)
								])),
						outMsgs) : original;
				}(
					function (result) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									fZ: function () {
										var _v4 = result.agZ;
										if (!_v4.$) {
											return $author$project$Components$ResourceFilter$Company$value(result.aiO);
										} else {
											return model.fZ;
										}
									}(),
									mZ: result.aiO
								}),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Reports$Dashboard$CompanyResourceFilterMsg, result.GZ),
							result.aR);
					}(
						A3($author$project$Components$ResourceFilter$Company$update, model.Gv, subMsg, model.mZ)));
			default:
				var subMsg = msg.a;
				return function (original) {
					var newModel = original.a;
					var cmd = original.b;
					var outMsgs = original.c;
					return (!_Utils_eq(newModel.aj4, model.aj4)) ? _Utils_Tuple3(
						_Utils_update(
							newModel,
							{aw: $author$project$Pages$Reports$Dashboard$initMetrics}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									cmd,
									$author$project$Pages$Reports$Dashboard$fetchMetrics(newModel),
									$author$project$Pages$Reports$Dashboard$updateUrl(newModel)
								])),
						outMsgs) : original;
				}(
					function (result) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aj4: function () {
										var _v5 = result.agZ;
										if (!_v5.$) {
											return $author$project$Components$ResourceFilter$Plan$value(result.aiO);
										} else {
											return model.aj4;
										}
									}(),
									hi: result.aiO
								}),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Reports$Dashboard$PlanResourceFilterMsg, result.GZ),
							result.aR);
					}(
						A3($author$project$Components$ResourceFilter$Plan$update, model.Gv, subMsg, model.hi)));
		}
	});
var $author$project$Pages$Reports$Dashboard$Active = 1;
var $author$project$Pages$Reports$Dashboard$BreakoutChanged = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Reports$Dashboard$CancellationReason = 7;
var $author$project$Pages$Reports$Dashboard$Employer = 4;
var $author$project$Pages$Reports$Dashboard$EmployerVsRetail = 5;
var $author$project$Pages$Reports$Dashboard$EngagementChanged = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Reports$Dashboard$Enrollments = 3;
var $author$project$Pages$Reports$Dashboard$LeadSource = 6;
var $author$project$Pages$Reports$Dashboard$Location = 3;
var $author$project$Pages$Reports$Dashboard$LocationGroup = 2;
var $author$project$Pages$Reports$Dashboard$Plan = 0;
var $author$project$Pages$Reports$Dashboard$Provider = 1;
var $author$project$Pages$Reports$Dashboard$ShowingChanged = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Reports$Dashboard$Terminations = 2;
var $author$project$Pages$Reports$Dashboard$breakoutToLabel = function (breakout) {
	switch (breakout) {
		case 0:
			return 'Plan';
		case 1:
			return 'Provider';
		case 2:
			return 'Location Group';
		case 3:
			return 'Location';
		case 4:
			return 'Employer';
		case 5:
			return 'Employer vs Retail';
		case 6:
			return 'Lead Source';
		default:
			return 'Cancellation Reason';
	}
};
var $author$project$Pages$Reports$Dashboard$buildBreakoutOption = function (breakout) {
	return A3(
		$author$project$Ui$Form$Select$option,
		_List_Nil,
		$elm$core$Maybe$Just(
			$author$project$Pages$Reports$Dashboard$breakoutToValue(breakout)),
		$author$project$Pages$Reports$Dashboard$breakoutToLabel(breakout));
};
var $author$project$Pages$Reports$Dashboard$engagementToLabel = function (engagement) {
	switch (engagement) {
		case 0:
			return 'All Engagement Statuses';
		case 1:
			return 'Currently Engaged';
		case 2:
			return 'Previously Engaged';
		default:
			return 'Never Engaged';
	}
};
var $author$project$Pages$Reports$Dashboard$buildEngagementOption = function (engagement) {
	return A3(
		$author$project$Ui$Form$Select$option,
		_List_Nil,
		$author$project$Pages$Reports$Dashboard$engagementToValue(
			$elm$core$Maybe$Just(engagement)),
		$author$project$Pages$Reports$Dashboard$engagementToLabel(engagement));
};
var $author$project$Pages$Reports$Dashboard$showingToLabel = function (showing) {
	switch (showing) {
		case 0:
			return 'Active, growth, attrition';
		case 1:
			return 'Active';
		case 2:
			return 'Terminations';
		default:
			return 'Enrollments';
	}
};
var $author$project$Pages$Reports$Dashboard$showingToValue = function (showing) {
	switch (showing) {
		case 0:
			return 'all';
		case 1:
			return 'active';
		case 2:
			return 'terminations';
		default:
			return 'enrollments';
	}
};
var $author$project$Pages$Reports$Dashboard$buildShowingOption = function (showing) {
	return A3(
		$author$project$Ui$Form$Select$option,
		_List_Nil,
		$elm$core$Maybe$Just(
			$author$project$Pages$Reports$Dashboard$showingToValue(showing)),
		$author$project$Pages$Reports$Dashboard$showingToLabel(showing));
};
var $author$project$Pages$Reports$Dashboard$valueToBreakout = function (stringBreakout) {
	switch (stringBreakout) {
		case 'plan':
			return $elm$core$Maybe$Just(0);
		case 'practitioner':
			return $elm$core$Maybe$Just(1);
		case 'location_group':
			return $elm$core$Maybe$Just(2);
		case 'location':
			return $elm$core$Maybe$Just(3);
		case 'employer':
			return $elm$core$Maybe$Just(4);
		case 'employer-retail':
			return $elm$core$Maybe$Just(5);
		case 'lead_source':
			return $elm$core$Maybe$Just(6);
		case 'cancellation_reason':
			return $elm$core$Maybe$Just(7);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$Reports$Dashboard$valueToShowing = function (stringShowing) {
	switch (stringShowing) {
		case 'active':
			return 1;
		case 'terminations':
			return 2;
		case 'enrollments':
			return 3;
		default:
			return 0;
	}
};
var $author$project$Pages$Reports$Dashboard$viewPeriodSummary = function (maybePeriodSummary) {
	var showSumaryItem = function (valAccessor) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Ui$Spinner$view(_List_Nil),
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					valAccessor,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$String$fromInt,
						function (val) {
							return A2(
								$author$project$Ui$Typography$text,
								_List_fromArray(
									[
										$author$project$Ui$Typography$gray,
										$author$project$Ui$Typography$attrs(
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-lg')
											]))
									]),
								val);
						})),
				maybePeriodSummary));
	};
	var netGrowth = function (_v0) {
		var activeAtStart = _v0.vA;
		var activeAtEnd = _v0.vz;
		var growth = 100 * ((activeAtEnd - activeAtStart) / activeAtStart);
		var attrs = _List_fromArray(
			[
				$elm$html$Html$Attributes$class('text-lg'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('text-danger', growth < 0),
						_Utils_Tuple2('text-grey', !growth),
						_Utils_Tuple2('text-success', growth > 0)
					]))
			]);
		return $elm$core$Basics$isInfinite(growth) ? A2(
			$author$project$Ui$Typography$text,
			_List_fromArray(
				[
					$author$project$Ui$Typography$attrs(attrs)
				]),
			'--') : A2(
			$author$project$Ui$Typography$text,
			_List_fromArray(
				[
					$author$project$Ui$Typography$attrs(attrs)
				]),
			function (percentage) {
				return percentage + '%';
			}(
				A2($myrho$elm_round$Round$round, 2, growth)));
	};
	var item = F2(
		function (label, child) {
			return A2(
				$author$project$Ui$Panel$view,
				_List_fromArray(
					[$author$project$Ui$Panel$tile]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$body,
						_List_fromArray(
							[$author$project$Ui$Element$textCenter]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$muted]),
								_List_fromArray(
									[
										$elm$html$Html$text(label)
									])),
								child
							]))
					]));
		});
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$flex, $author$project$Ui$Element$wrap, $author$project$Ui$Element$gap4, $author$project$Ui$Element$mt4, $author$project$Ui$Element$mb4]),
		_List_fromArray(
			[
				A2(
				item,
				'Active at Start',
				showSumaryItem(
					function ($) {
						return $.vA;
					})),
				A2(
				item,
				'Enrollments',
				showSumaryItem(
					function ($) {
						return $.HD;
					})),
				A2(
				item,
				'Terminations',
				showSumaryItem(
					function ($) {
						return $.J4;
					})),
				A2(
				item,
				'Active At End',
				showSumaryItem(
					function ($) {
						return $.vz;
					})),
				A2(
				item,
				'Net Growth',
				A2(
					$elm$core$Maybe$withDefault,
					$author$project$Ui$Spinner$view(_List_Nil),
					A2($elm$core$Maybe$map, netGrowth, maybePeriodSummary)))
			]));
};
var $author$project$Pages$Reports$Dashboard$viewMemberAnalytics = function (_v0) {
	var dateRangeInput = _v0.i4;
	var periodSummary = _v0.tO;
	var showing = _v0.uH;
	var groupLocationAndPractitionerFilters = _v0.dn;
	var planResourceFilter = _v0.hi;
	var companyResourceFilter = _v0.mZ;
	var breakout = _v0.GL;
	var engagement = _v0.HC;
	var practice = _v0.ZV;
	var practiceIsAffiliateOrNetwork = $author$project$Api$Provider$Practice$One$isNetwork(practice) || $author$project$Api$Provider$Practice$One$isAffiliate(practice);
	var gateIsAvailable = A2(
		$author$project$Utils$FeatureGate$gateAvailable,
		11,
		$author$project$Api$Practice$Provider(practice));
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Panel$title(
						_List_fromArray(
							[
								$elm$html$Html$text('Member Analytics')
							]))
					])),
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$span(12)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Typography$headingSm(
										_List_fromArray(
											[
												$elm$html$Html$text('Reporting Period')
											]))
									])),
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$span(12)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Pages$Reports$Dashboard$DateRangeInputMsg,
										$author$project$Components$DateRangeInput$view(dateRangeInput))
									]))
							])),
						$author$project$Pages$Reports$Dashboard$viewPeriodSummary(periodSummary),
						$author$project$Ui$HorizontalRule$view(_List_Nil),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mb3, $author$project$Ui$Element$gap2]),
						_List_fromArray(
							[
								$author$project$Ui$Typography$headingSm(
								_List_fromArray(
									[
										$elm$html$Html$text('Show me ')
									])),
								A2(
								$author$project$Ui$Form$Select$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Select$inline,
										$author$project$Ui$Form$Select$value(
										$elm$core$Maybe$Just(
											$author$project$Pages$Reports$Dashboard$showingToValue(showing))),
										$author$project$Ui$Form$Select$onChange(
										A2($elm$core$Basics$composeR, $author$project$Pages$Reports$Dashboard$valueToShowing, $author$project$Pages$Reports$Dashboard$ShowingChanged))
									]),
								_List_fromArray(
									[
										$author$project$Pages$Reports$Dashboard$buildShowingOption(0),
										$author$project$Pages$Reports$Dashboard$buildShowingOption(1),
										$author$project$Pages$Reports$Dashboard$buildShowingOption(2),
										$author$project$Pages$Reports$Dashboard$buildShowingOption(3)
									])),
								$author$project$Ui$Typography$headingSm(
								_List_fromArray(
									[
										$elm$html$Html$text(' broken out by ')
									])),
								A2(
								$author$project$Ui$Form$Select$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Select$inline,
										$author$project$Ui$Form$Select$value(
										A2($elm$core$Maybe$map, $author$project$Pages$Reports$Dashboard$breakoutToValue, breakout)),
										$author$project$Ui$Form$Select$onChange(
										A2($elm$core$Basics$composeR, $author$project$Pages$Reports$Dashboard$valueToBreakout, $author$project$Pages$Reports$Dashboard$BreakoutChanged))
									]),
								A2(
									$elm$core$List$cons,
									A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, 'No Breakout'),
									A2(
										$elm$core$List$cons,
										$author$project$Pages$Reports$Dashboard$buildBreakoutOption(0),
										A2(
											$elm$core$List$cons,
											$author$project$Pages$Reports$Dashboard$buildBreakoutOption(1),
											A2(
												$elm$core$List$cons,
												$author$project$Pages$Reports$Dashboard$buildBreakoutOption(3),
												A2(
													$elm$core$List$cons,
													$author$project$Pages$Reports$Dashboard$buildBreakoutOption(2),
													A2(
														$elm$core$List$cons,
														$author$project$Pages$Reports$Dashboard$buildBreakoutOption(4),
														A2(
															$elm$core$List$cons,
															$author$project$Pages$Reports$Dashboard$buildBreakoutOption(5),
															A2(
																$elm$core$List$cons,
																$author$project$Pages$Reports$Dashboard$buildBreakoutOption(6),
																function () {
																	if (showing === 2) {
																		return _List_fromArray(
																			[
																				$author$project$Pages$Reports$Dashboard$buildBreakoutOption(7)
																			]);
																	} else {
																		return _List_Nil;
																	}
																}())))))))))
							])),
						A2(
						$author$project$Ui$Grid$row,
						_List_Nil,
						_Utils_ap(
							A2(
								$elm$core$List$map,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$List$singleton,
									$author$project$Ui$Grid$column(
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(6),
												$author$project$Ui$Grid$spanSm(4)
											]))),
								A2(
									$elm$core$List$map,
									$elm$html$Html$map($author$project$Pages$Reports$Dashboard$GroupLocationAndPractitionerFiltersMsg),
									A2($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$view, _List_Nil, groupLocationAndPractitionerFilters))),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanSm(4),
											$author$project$Ui$Grid$span(6)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$map,
											$author$project$Pages$Reports$Dashboard$CompanyResourceFilterMsg,
											A2(
												$author$project$Components$ResourceFilter$Company$view,
												_List_fromArray(
													[
														$author$project$Components$ResourceFilter$style(1)
													]),
												companyResourceFilter))
										])),
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanSm(4),
											$author$project$Ui$Grid$span(6)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$map,
											$author$project$Pages$Reports$Dashboard$PlanResourceFilterMsg,
											A2(
												$author$project$Components$ResourceFilter$Plan$view,
												_List_fromArray(
													[
														$author$project$Components$ResourceFilter$style(1)
													]),
												planResourceFilter))
										])),
									(gateIsAvailable || practiceIsAffiliateOrNetwork) ? A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanSm(4),
											$author$project$Ui$Grid$span(6)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Select$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Select$inline,
													$author$project$Ui$Form$Select$value(
													$author$project$Pages$Reports$Dashboard$engagementToValue(engagement)),
													$author$project$Ui$Form$Select$onChange(
													A2($elm$core$Basics$composeR, $author$project$Pages$Reports$Dashboard$valueToEngagement, $author$project$Pages$Reports$Dashboard$EngagementChanged))
												]),
											_List_fromArray(
												[
													$author$project$Pages$Reports$Dashboard$buildEngagementOption(0),
													$author$project$Pages$Reports$Dashboard$buildEngagementOption(1),
													$author$project$Pages$Reports$Dashboard$buildEngagementOption(2),
													$author$project$Pages$Reports$Dashboard$buildEngagementOption(3)
												]))
										])) : $author$project$Ui$Grid$none
								]))),
						A2($elm$html$Html$br, _List_Nil, _List_Nil),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('dashboard-chart'),
								A2($elm$html$Html$Attributes$style, 'position', 'relative'),
								A2($elm$html$Html$Attributes$style, 'height', '540px')
							]),
						_List_Nil)
					]))
			]));
};
var $elm$html$Html$h2 = _VirtualDom_node('h2');
var $author$project$Ui$Typography$headingLg = function (content) {
	return A2(
		$elm$html$Html$map,
		$elm$core$Basics$never,
		A2(
			$elm$html$Html$h2,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-heading-lg text-main')
				]),
			content));
};
var $author$project$Ui$ProgressBar$Label = function (a) {
	return {$: 7, a: a};
};
var $author$project$Ui$ProgressBar$label = $author$project$Ui$ProgressBar$Label;
var $author$project$Pages$Reports$Dashboard$listOptionalsToUrlParams = function (optionalsFunc) {
	var options = optionalsFunc($author$project$Api$Provider$Reports$CustomerInvoice$listDefaults);
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeL,
					$elm$url$Url$Builder$string('start'),
					$author$project$Utils$Date$toQuery),
				options.JV),
				A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeL,
					$elm$url$Url$Builder$string('end'),
					$author$project$Utils$Date$toQuery),
				options.HB),
				A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeL,
					$elm$url$Url$Builder$string('status'),
					$elm$core$String$join(',')),
				options.alH)
			]));
};
var $author$project$Ui$ProgressBar$Slim = {$: 8};
var $author$project$Ui$ProgressBar$slim = $author$project$Ui$ProgressBar$Slim;
var $author$project$Pages$Reports$Dashboard$viewIssuedInvoices = function (issuedAmount) {
	if (issuedAmount.$ === 3) {
		var amount = issuedAmount.a;
		return A2(
			$author$project$Ui$Panel$view,
			_List_fromArray(
				[$author$project$Ui$Panel$subtle]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$wrap, $author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2, $author$project$Ui$Element$wrap]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[$author$project$Ui$Typography$muted]),
											'Issued, but unsent'),
											A2(
											$author$project$Ui$Typography$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Currency$format(amount))
												])),
											A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
											'not included in total above')
										])),
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Reports__Invoices,
									_List_fromArray(
										[
											$author$project$Ui$Link$routeParams(
											$author$project$Pages$Reports$Dashboard$listOptionalsToUrlParams($author$project$Pages$Reports$Dashboard$issuedInvoicesParams))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('View invoices')
										]))
								]))
						]))
				]));
	} else {
		return $author$project$Ui$Spinner$view(
			_List_fromArray(
				[$author$project$Ui$Spinner$small]));
	}
};
var $author$project$Pages$Reports$Dashboard$viewOutstandingBucket = F5(
	function (title, data, totalInt, colorOption, queryParams) {
		if (data.$ === 3) {
			var amount = data.a;
			var intCurrency = A2(
				$elm$core$Maybe$withDefault,
				0,
				$author$project$Currency$toInt(amount));
			var percentage = (totalInt > 0) ? ((intCurrency / totalInt) * 100) : 0;
			var dotStyle = _Utils_eq(colorOption, $author$project$Ui$ProgressBar$danger) ? A2($elm$html$Html$Attributes$style, 'background-color', 'var(--color-danger-300)') : (_Utils_eq(colorOption, $author$project$Ui$ProgressBar$warning) ? A2($elm$html$Html$Attributes$style, 'background-color', 'var(--color-warning-300)') : A2($elm$html$Html$Attributes$style, 'background-color', 'var(--color-success-300)'));
			return A2(
				$author$project$Ui$Panel$view,
				_List_fromArray(
					[$author$project$Ui$Panel$tile]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap, $author$project$Ui$Element$mb2]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('inline-block w-2 h-2 rounded-full'),
												dotStyle
											]),
										_List_Nil),
										A2(
										$author$project$Ui$Typography$label,
										_List_fromArray(
											[$author$project$Ui$Typography$muted]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$elm$core$String$toUpper(title))
											]))
									])),
								$author$project$Ui$Typography$headingSm(
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Currency$format(amount))
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2($myrho$elm_round$Round$round, 1, percentage) + '% of total')
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										(intCurrency > 0) ? A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Reports__Invoices,
										_List_fromArray(
											[
												$author$project$Ui$Link$routeParams(queryParams)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('View outstanding')
											])) : $elm$html$Html$text('No outstanding')
									]))
							]))
					]));
		} else {
			return $author$project$Ui$Spinner$view(
				_List_fromArray(
					[$author$project$Ui$Spinner$small]));
		}
	});
var $author$project$Pages$Reports$Dashboard$viewPatientInvoices = function (_v0) {
	var today = _v0.FR;
	var outstandingLt30Amount = _v0.Ck;
	var outstanding30To59Amount = _v0.Ci;
	var outstanding60PlusAmount = _v0.Cj;
	var issuedAmount = _v0.Ar;
	var toAmount = function (data) {
		if (data.$ === 3) {
			var amount = data.a;
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$author$project$Currency$toInt(amount));
		} else {
			return 0;
		}
	};
	var lt30Int = toAmount(outstandingLt30Amount);
	var from60plusInt = toAmount(outstanding60PlusAmount);
	var from30to59Int = toAmount(outstanding30To59Amount);
	var totalInt = (lt30Int + from30to59Int) + from60plusInt;
	var pct = function (amount) {
		return (totalInt > 0) ? ((amount / totalInt) * 100) : 0;
	};
	var allLoaded = $author$project$Api$Data$isSuccess(outstandingLt30Amount) && ($author$project$Api$Data$isSuccess(outstanding30To59Amount) && $author$project$Api$Data$isSuccess(outstanding60PlusAmount));
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Panel$title(
						_List_fromArray(
							[
								$elm$html$Html$text('Patient Invoices')
							]))
					])),
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						function () {
						if (allLoaded) {
							var allOutstandingParams = _List_fromArray(
								[
									A2(
									$elm$url$Url$Builder$string,
									'status',
									A2($elm$core$String$join, ',', $author$project$Pages$Reports$Dashboard$outstandingInvoicesStatuses)),
									A2(
									$elm$url$Url$Builder$string,
									'end',
									$author$project$Utils$Date$toQuery(today))
								]);
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$label,
												_List_fromArray(
													[$author$project$Ui$Typography$muted]),
												_List_fromArray(
													[
														$elm$html$Html$text('TOTAL OUTSTANDING')
													])),
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$wrap]),
												_List_fromArray(
													[
														$author$project$Ui$Typography$headingLg(
														_List_fromArray(
															[
																$elm$html$Html$text(
																$author$project$Currency$format(
																	$author$project$Currency$fromInt(totalInt)))
															])),
														A3(
														$author$project$Ui$Link$route,
														$author$project$Spa$Generated$Route$Reports__Invoices,
														_List_fromArray(
															[
																$author$project$Ui$Link$routeParams(allOutstandingParams)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('View all outstanding')
															]))
													]))
											])),
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$mt2, $author$project$Ui$Element$mb4]),
										_List_fromArray(
											[
												$author$project$Ui$ProgressBar$stacked(
												_List_fromArray(
													[
														$author$project$Ui$ProgressBar$bar(
														_List_fromArray(
															[
																$author$project$Ui$ProgressBar$success,
																$author$project$Ui$ProgressBar$slim,
																$author$project$Ui$ProgressBar$width(
																pct(lt30Int)),
																$author$project$Ui$ProgressBar$label(
																A2(
																	$myrho$elm_round$Round$round,
																	1,
																	pct(lt30Int)) + ('% — ' + ($author$project$Currency$format(
																	$author$project$Currency$fromInt(lt30Int)) + ' of < 30 day AR')))
															])),
														$author$project$Ui$ProgressBar$bar(
														_List_fromArray(
															[
																$author$project$Ui$ProgressBar$warning,
																$author$project$Ui$ProgressBar$slim,
																$author$project$Ui$ProgressBar$width(
																pct(from30to59Int)),
																$author$project$Ui$ProgressBar$label(
																A2(
																	$myrho$elm_round$Round$round,
																	1,
																	pct(from30to59Int)) + ('% — ' + ($author$project$Currency$format(
																	$author$project$Currency$fromInt(from30to59Int)) + ' of 30-59 day AR')))
															])),
														$author$project$Ui$ProgressBar$bar(
														_List_fromArray(
															[
																$author$project$Ui$ProgressBar$danger,
																$author$project$Ui$ProgressBar$slim,
																$author$project$Ui$ProgressBar$width(
																pct(from60plusInt)),
																$author$project$Ui$ProgressBar$label(
																A2(
																	$myrho$elm_round$Round$round,
																	1,
																	pct(from60plusInt)) + ('% — ' + ($author$project$Currency$format(
																	$author$project$Currency$fromInt(from60plusInt)) + ' of 60+ day AR')))
															]))
													]))
											]))
									]));
						} else {
							return $author$project$Ui$Spinner$view(
								_List_fromArray(
									[$author$project$Ui$Spinner$small]));
						}
					}(),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$flex, $author$project$Ui$Element$wrap, $author$project$Ui$Element$gap4]),
						_List_fromArray(
							[
								A5(
								$author$project$Pages$Reports$Dashboard$viewOutstandingBucket,
								'< 30 Days Old',
								outstandingLt30Amount,
								totalInt,
								$author$project$Ui$ProgressBar$success,
								$author$project$Pages$Reports$Dashboard$listOptionalsToUrlParams(
									$author$project$Pages$Reports$Dashboard$invoicesFromLessThan30DaysParams(today))),
								A5(
								$author$project$Pages$Reports$Dashboard$viewOutstandingBucket,
								'30-59 Days Old',
								outstanding30To59Amount,
								totalInt,
								$author$project$Ui$ProgressBar$warning,
								$author$project$Pages$Reports$Dashboard$listOptionalsToUrlParams(
									$author$project$Pages$Reports$Dashboard$invoicesFrom30To59DaysParams(today))),
								A5(
								$author$project$Pages$Reports$Dashboard$viewOutstandingBucket,
								'60+ Days Old',
								outstanding60PlusAmount,
								totalInt,
								$author$project$Ui$ProgressBar$danger,
								$author$project$Pages$Reports$Dashboard$listOptionalsToUrlParams(
									$author$project$Pages$Reports$Dashboard$invoicesFrom60PlusDaysParams(today)))
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mt4]),
						_List_fromArray(
							[
								$author$project$Pages$Reports$Dashboard$viewIssuedInvoices(issuedAmount)
							]))
					]))
			]));
};
var $author$project$Pages$Reports$Dashboard$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				$author$project$Pages$Reports$Dashboard$viewPatientInvoices(model),
				$author$project$Pages$Reports$Dashboard$viewMemberAnalytics(model)
			]),
		ac9: 'Reports | Dashboard'
	};
};
var $author$project$Pages$Reports$Dashboard$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Reports$Dashboard$init, aiq: $author$project$Pages$Reports$Dashboard$load, k8: $author$project$Pages$Reports$Dashboard$save, alO: $author$project$Pages$Reports$Dashboard$subscriptions, adT: $author$project$Pages$Reports$Dashboard$update, amo: $author$project$Pages$Reports$Dashboard$view});
var $author$project$Pages$Reports$DeferredRevenue$ReportMsg = $elm$core$Basics$identity;
var $author$project$Components$Reports$DeferredRevenue$Table = 0;
var $author$project$Components$Reports$DeferredRevenue$ByDropdownMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Reports$DeferredRevenue$CategoryResourceFilterMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Reports$DeferredRevenue$DateRangeInputMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Report$DeferredRevenueLine = 7;
var $author$project$Components$Reports$DeferredRevenue$GroupLocationAndPractitionerFiltersMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Reports$DeferredRevenue$urlParams = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Tuple$pair('start'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.dd, 0)),
			model.JV),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Tuple$pair('end'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.dd, 0)),
			model.HB),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('category'),
			model.iF),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('location_group'),
			model.gL),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('location'),
			model.We),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('practitioner'),
			model.Z2),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('by'),
			model.co)
		]);
	return $elm$core$Dict$fromList(
		A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams));
};
var $author$project$Components$Reports$DeferredRevenue$buildUrl = function (model) {
	return A2(
		$elm$url$Url$Builder$relative,
		_List_fromArray(
			[
				function () {
				var _v0 = model.co;
				if (!_v0.$) {
					return $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__DeferredRevenue__Summary);
				} else {
					return $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__DeferredRevenue);
				}
			}()
			]),
		A2(
			$elm$core$List$append,
			$author$project$Api$Pagination$toPageQuery(model.ajJ),
			A2(
				$elm$core$List$append,
				$author$project$Api$Sort$toQuery(model.alA),
				$author$project$Utils$QueryParameter$fromDict(
					$author$project$Components$Reports$DeferredRevenue$urlParams(model)))));
};
var $author$project$Components$Reports$DeferredRevenue$dateRangeInputSettings = F2(
	function (start, end) {
		var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
		return _Utils_update(
			defaultSettings,
			{ahy: start, al5: end});
	});
var $author$project$Components$Reports$DeferredRevenue$GotDeferredRevenueLines = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Reports$DeferredRevenue$fetchDeferredRevenueLinesParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				GW: model.iF,
				HB: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.HB),
				ais: model.We,
				s4: model.gL,
				ajJ: model.ajJ,
				aka: model.Z2,
				alA: model.alA,
				JV: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.JV)
			});
	};
};
var $author$project$Api$Provider$Reports$DeferredRevenueLine$DeferredRevenueLine = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$DeferredRevenueLine$Record = F8(
	function (transactionDate, amountInCents, category, charge, invoice, client, practitioner, location) {
		return {LE: amountInCents, GW: category, afx: charge, NJ: client, Uk: invoice, ais: location, aka: practitioner, adw: transactionDate};
	});
var $author$project$Api$Provider$Reports$Charge$Charge = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$Charge$Record = F2(
	function (name, serviceDate) {
		return {Bq: name, aa$: serviceDate};
	});
var $author$project$Api$Provider$Reports$Charge$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'service_date',
	$author$project$Utils$Date$decode,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$Charge$Record)));
var $author$project$Api$Provider$Reports$Charge$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Reports$Charge$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$RevenueLine$Client$Client = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$RevenueLine$Client$Record = F3(
	function (id, type_, name) {
		return {ahP: id, Bq: name, amg: type_};
	});
var $author$project$Api$Provider$Reports$RevenueLine$Client$Company = 1;
var $author$project$Api$Provider$Reports$RevenueLine$Client$Patient = 0;
var $author$project$Api$Provider$Reports$RevenueLine$Client$decodeType = function (string) {
	switch (string) {
		case 'Patient':
			return $elm$json$Json$Decode$succeed(0);
		case 'Company':
			return $elm$json$Json$Decode$succeed(1);
		default:
			return $elm$json$Json$Decode$fail('Unsupported client type: ' + string);
	}
};
var $author$project$Api$Provider$Reports$RevenueLine$Client$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'type',
		A2($elm$json$Json$Decode$andThen, $author$project$Api$Provider$Reports$RevenueLine$Client$decodeType, $elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$RevenueLine$Client$Record))));
var $author$project$Api$Provider$Reports$RevenueLine$Client$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Reports$RevenueLine$Client$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$DeferredRevenueLine$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'location',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Location$Min$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'practitioner',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Practitioner$Min$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'client',
			$elm$json$Json$Decode$nullable($author$project$Api$Provider$Reports$RevenueLine$Client$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'invoice',
				$elm$json$Json$Decode$nullable($author$project$Api$Common$Payable$Invoice$MinWithOwner$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'charge',
					$elm$json$Json$Decode$nullable($author$project$Api$Provider$Reports$Charge$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'category',
						$elm$json$Json$Decode$nullable($author$project$Api$Provider$Category$Min$decoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'amount_in_cents',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'transaction_date',
								$author$project$Utils$Date$decode,
								$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$DeferredRevenueLine$Record)))))))));
var $author$project$Api$Provider$Reports$DeferredRevenueLine$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Reports$DeferredRevenueLine$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$DeferredRevenueLine$listDefaults = {GW: $elm$core$Maybe$Nothing, HB: $elm$core$Maybe$Nothing, ais: $elm$core$Maybe$Nothing, s4: $elm$core$Maybe$Nothing, ajJ: $author$project$Api$Pagination$init, aka: $elm$core$Maybe$Nothing, alA: $author$project$Api$Sort$init, JV: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$Reports$DeferredRevenueLine$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Reports$DeferredRevenueLine$listDefaults);
	return A2(
		$elm$core$List$append,
		$author$project$Api$Pagination$toApiParams(options.ajJ),
		A2(
			$elm$core$List$append,
			$author$project$Api$Sort$toParams(options.alA),
			$elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						var _v0 = options.JV;
						if (!_v0.$) {
							var start_ = _v0.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'start', start_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v1 = options.HB;
						if (!_v1.$) {
							var end_ = _v1.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'end', end_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v2 = options.GW;
						if (!_v2.$) {
							var category_ = _v2.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'category', category_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v3 = options.s4;
						if (!_v3.$) {
							var locationGroup_ = _v3.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'location_group', locationGroup_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v4 = options.ais;
						if (!_v4.$) {
							var location_ = _v4.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'location', location_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v5 = options.aka;
						if (!_v5.$) {
							var practitioner_ = _v5.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'practitioner', practitioner_)
								]);
						} else {
							return _List_Nil;
						}
					}()
					]))));
};
var $author$project$Api$Provider$Reports$DeferredRevenueLine$listPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['reports', 'deferred_revenue_lines']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Reports$DeferredRevenueLine$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Reports$DeferredRevenueLine$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Reports$DeferredRevenueLine$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$DeferredRevenueLine$listPath)));
	});
var $author$project$Components$Reports$DeferredRevenue$fetchDeferredRevenueLines = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Api$Provider$Reports$DeferredRevenueLine$list,
			apiClient,
			$author$project$Components$Reports$DeferredRevenue$fetchDeferredRevenueLinesParams(model),
			$author$project$Components$Reports$DeferredRevenue$GotDeferredRevenueLines);
	});
var $author$project$Components$Reports$DeferredRevenue$GotSummary = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Reports$DeferredRevenue$fetchSummaryParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				GW: model.iF,
				HB: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.HB),
				ais: model.We,
				s4: model.gL,
				aka: model.Z2,
				JV: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.JV)
			});
	};
};
var $author$project$Api$Provider$Reports$DeferredRevenueLine$summary = F4(
	function (apiClient, by, optionals, toMsg) {
		return A5(
			$author$project$Api$Provider$Reports$Summary$retrieve,
			apiClient,
			$author$project$Api$Provider$Reports$DeferredRevenueLine$listPath,
			by,
			$author$project$Api$Provider$Reports$DeferredRevenueLine$listOptionsToParams(optionals),
			toMsg);
	});
var $author$project$Components$Reports$DeferredRevenue$fetchSummary = F2(
	function (apiClient, model) {
		return A4(
			$author$project$Api$Provider$Reports$DeferredRevenueLine$summary,
			apiClient,
			A2($elm$core$Maybe$withDefault, '', model.co),
			$author$project$Components$Reports$DeferredRevenue$fetchSummaryParams(model),
			$author$project$Components$Reports$DeferredRevenue$GotSummary);
	});
var $author$project$Components$Reports$DeferredRevenue$fetchData = F2(
	function (apiClient, model) {
		var _v0 = model.amg;
		if (!_v0) {
			return A2($author$project$Components$Reports$DeferredRevenue$fetchDeferredRevenueLines, apiClient, model);
		} else {
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Components$Reports$DeferredRevenue$fetchSummary, apiClient, model),
						A2($author$project$Components$Reports$DeferredRevenue$fetchDeferredRevenueLines, apiClient, model)
					]));
		}
	});
var $author$project$Components$Reports$DeferredRevenue$initColumns = function (trackPatientsByLocation) {
	return A2(
		$elm$core$List$cons,
		A3($author$project$Api$Column$init, 'transaction_date', true, 'Txn Date'),
		A2(
			$elm$core$List$cons,
			A3($author$project$Api$Column$init, 'amount_in_cents', true, 'Charge'),
			A2(
				$elm$core$List$cons,
				A3($author$project$Api$Column$init, 'invoice', false, 'Invoice'),
				A2(
					$elm$core$List$cons,
					A3($author$project$Api$Column$init, 'client', true, 'Client'),
					A2(
						$elm$core$List$cons,
						A3($author$project$Api$Column$init, 'category', true, 'Category'),
						A2(
							$elm$core$List$cons,
							A3($author$project$Api$Column$init, 'practitioner', true, 'Provider'),
							trackPatientsByLocation ? _List_fromArray(
								[
									A3($author$project$Api$Column$init, 'location', true, 'Location')
								]) : _List_Nil))))));
};
var $author$project$Components$Reports$DeferredRevenue$init = F5(
	function (type_, session, practice, _v0, query) {
		var currentDate = _v0.dd;
		var apiClient = _v0.Gv;
		var hinterViewOff = _v0.ahK;
		var trackPatientsByLocation = $author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice);
		var practitionerId = A2($elm$core$Dict$get, 'practitioner', query);
		var locationId = A2($elm$core$Dict$get, 'location', query);
		var locationGroupId = A2($elm$core$Dict$get, 'location_group', query);
		var categoryId = A2($elm$core$Dict$get, 'category', query);
		var _v1 = function () {
			if (!type_) {
				return _Utils_Tuple2($author$project$Api$Data$Loading, $author$project$Api$Data$NotAsked);
			} else {
				return _Utils_Tuple2($author$project$Api$Data$NotAsked, $author$project$Api$Data$Loading);
			}
		}();
		var deferredRevenueLines = _v1.a;
		var summary = _v1.b;
		var _v3 = A7($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$init, apiClient, session, practice, false, locationGroupId, locationId, practitionerId);
		var groupLocationAndPractitionerFilters = _v3.a;
		var groupLocationAndPractitionerFiltersCmd = _v3.b;
		var _v4 = $author$project$Utils$DateWithDefault$fromQuery(query);
		var start = _v4.a;
		var end = _v4.b;
		var _v5 = A2(
			$author$project$Components$DateRangeInput$init,
			'date-range-input',
			A2(
				$author$project$Components$Reports$DeferredRevenue$dateRangeInputSettings,
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					start),
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					end)));
		var dateRangeInput = _v5.a;
		var dateRangeInputCmd = _v5.b;
		var _v6 = A3($author$project$Utils$Report$CategoryResourceFilter$init, apiClient, session, categoryId);
		var categoryResourceFilter = _v6.a;
		var categoryResourceFilterCmd = _v6.b;
		var model = {
			co: A2($elm$core$Dict$get, 'by', query),
			mB: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'by-dropdown', al6: $author$project$Components$Reports$DeferredRevenue$ByDropdownMsg})),
			GP: A3($author$project$Permission$canGoTo, session, hinterViewOff, 18),
			GQ: A3($author$project$Permission$canGoTo, session, hinterViewOff, 50),
			iF: categoryId,
			c8: categoryResourceFilter,
			N3: $author$project$Components$Reports$DeferredRevenue$initColumns(trackPatientsByLocation),
			dd: currentDate,
			i4: dateRangeInput,
			a6: deferredRevenueLines,
			HB: end,
			nD: $author$project$Components$ExportCsv$initForPractice(7),
			dn: groupLocationAndPractitionerFilters,
			gL: locationGroupId,
			We: locationId,
			ajJ: $author$project$Api$Pagination$initFromQuery(query),
			Z2: practitionerId,
			alA: A3(
				$author$project$Api$Sort$withDefault,
				'transaction_date',
				1,
				$author$project$Api$Sort$initFromQuery(query)),
			JV: start,
			acF: summary,
			adt: trackPatientsByLocation,
			amg: type_
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$DeferredRevenue$CategoryResourceFilterMsg, categoryResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$DeferredRevenue$DateRangeInputMsg, dateRangeInputCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$DeferredRevenue$GroupLocationAndPractitionerFiltersMsg, groupLocationAndPractitionerFiltersCmd),
						A2($author$project$Components$Reports$DeferredRevenue$fetchData, apiClient, model),
						A2($elm$core$Basics$composeR, $author$project$Components$Reports$DeferredRevenue$buildUrl, $author$project$Ports$Navigation$replaceUrl)(model)
					])));
	});
var $author$project$Pages$Reports$DeferredRevenue$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.DE;
		var _v1 = A5($author$project$Components$Reports$DeferredRevenue$init, 0, session, practice, shared, query);
		var report = _v1.a;
		var reportCmd = _v1.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, kV: report},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportCmd));
	});
var $author$project$Pages$Reports$DeferredRevenue$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$DeferredRevenue$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Reports$DeferredRevenue$ExportCsvMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Reports$DeferredRevenue$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$DeferredRevenue$DateRangeInputMsg,
				$author$project$Components$DateRangeInput$subscriptions(model.i4)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$DeferredRevenue$ExportCsvMsg,
				$author$project$Components$ExportCsv$subscriptions(model.nD)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$DeferredRevenue$GroupLocationAndPractitionerFiltersMsg,
				$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$subscriptions(model.dn)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$DeferredRevenue$CategoryResourceFilterMsg,
				$author$project$Components$ResourceFilter$Category$subscriptions(model.c8)),
				$author$project$Ui$Dropdown$subscriptions(model.mB)
			]));
};
var $author$project$Pages$Reports$DeferredRevenue$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Reports$DeferredRevenue$subscriptions(model.kV));
};
var $author$project$Components$Reports$DeferredRevenue$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 2:
				var subMsg = msg.a;
				var categoryResourceResult = A3($author$project$Components$ResourceFilter$Category$update, apiClient, subMsg, model.c8);
				var categoryId = function () {
					var _v2 = categoryResourceResult.agZ;
					if (!_v2.$) {
						return $author$project$Components$ResourceFilter$Category$value(categoryResourceResult.aiO);
					} else {
						return model.iF;
					}
				}();
				var newModel = _Utils_update(
					model,
					{iF: categoryId, c8: categoryResourceResult.aiO});
				var _v1 = _Utils_eq(model.iF, newModel.iF) ? _Utils_Tuple2(model.a6, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					$author$project$Api$Data$Loading,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$DeferredRevenue$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$DeferredRevenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])));
				var deferredRevenueLines = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{a6: deferredRevenueLines}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$DeferredRevenue$CategoryResourceFilterMsg, categoryResourceResult.GZ),
								cmd
							])),
					categoryResourceResult.aR);
			case 3:
				var subMsg = msg.a;
				var _v3 = A2($author$project$Ui$Dropdown$update, subMsg, model.mB);
				var byDropdown = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{mB: byDropdown}),
					cmd,
					_List_Nil);
			case 4:
				var by = msg.a;
				var newModel = _Utils_update(
					model,
					{
						co: by,
						a6: $author$project$Api$Data$Loading,
						ajJ: $author$project$Api$Pagination$reset(model.ajJ)
					});
				var cmds = function () {
					var _v4 = _Utils_Tuple2(model.amg, newModel.co);
					if (!_v4.a) {
						if (!_v4.b.$) {
							var _v5 = _v4.a;
							return _List_fromArray(
								[
									A2($elm$core$Basics$composeR, $author$project$Components$Reports$DeferredRevenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
								]);
						} else {
							var _v6 = _v4.a;
							var _v7 = _v4.b;
							return _List_fromArray(
								[$elm$core$Platform$Cmd$none]);
						}
					} else {
						if (_v4.b.$ === 1) {
							var _v8 = _v4.a;
							var _v9 = _v4.b;
							return _List_fromArray(
								[
									A2($elm$core$Basics$composeR, $author$project$Components$Reports$DeferredRevenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
								]);
						} else {
							var _v10 = _v4.a;
							return _List_fromArray(
								[
									A2($author$project$Components$Reports$DeferredRevenue$fetchData, apiClient, newModel),
									A2($elm$core$Basics$composeR, $author$project$Components$Reports$DeferredRevenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
								]);
						}
					}
				}();
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(cmds),
					_List_Nil);
			case 0:
				var subMsg = msg.a;
				var _v11 = A2($author$project$Components$DateRangeInput$update, subMsg, model.i4);
				var dateRangeInput = _v11.a;
				var subCmd = _v11.b;
				var event = _v11.c;
				var newModel = function () {
					if (event.$ === 1) {
						var fromDate = event.a;
						var toDate = event.b;
						return _Utils_update(
							model,
							{
								i4: dateRangeInput,
								a6: $author$project$Api$Data$Loading,
								HB: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
								ajJ: $author$project$Api$Pagination$reset(model.ajJ),
								JV: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
							});
					} else {
						return _Utils_update(
							model,
							{i4: dateRangeInput});
					}
				}();
				var cmds = (_Utils_eq(newModel.JV, model.JV) && _Utils_eq(newModel.HB, model.HB)) ? _List_Nil : _List_fromArray(
					[
						A2($author$project$Components$Reports$DeferredRevenue$fetchData, apiClient, newModel),
						A2($elm$core$Basics$composeR, $author$project$Components$Reports$DeferredRevenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
					]);
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$cons,
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$DeferredRevenue$DateRangeInputMsg, subCmd),
							cmds)),
					_List_Nil);
			case 1:
				var subMsg = msg.a;
				var result = A3($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$update, apiClient, subMsg, model.dn);
				var _v13 = result.agZ;
				if (!_v13.$) {
					var locationGroupId = _v13.a;
					var locationId = _v13.b;
					var practitionerId = _v13.c;
					var newModel = _Utils_update(
						model,
						{
							a6: $author$project$Api$Data$Loading,
							dn: result.aiO,
							gL: locationGroupId,
							We: locationId,
							ajJ: $author$project$Api$Pagination$reset(model.ajJ),
							Z2: practitionerId
						});
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$DeferredRevenue$GroupLocationAndPractitionerFiltersMsg, result.GZ),
									A2($author$project$Components$Reports$DeferredRevenue$fetchData, apiClient, newModel),
									A2($elm$core$Basics$composeR, $author$project$Components$Reports$DeferredRevenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
								])),
						result.aR);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dn: result.aiO}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$DeferredRevenue$GroupLocationAndPractitionerFiltersMsg, result.GZ),
						result.aR);
				}
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								a6: response,
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{a6: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 6:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{acF: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 7:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{a6: $author$project$Api$Data$Loading, ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$DeferredRevenue$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$DeferredRevenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 8:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						alA: A2($author$project$Api$Sort$update, columnId, model.alA)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$DeferredRevenue$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$DeferredRevenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v15 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.nD);
				var exportCsv = _v15.a;
				var subCmd = _v15.b;
				var subOutMsg = _v15.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nD: exportCsv}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$DeferredRevenue$ExportCsvMsg, subCmd),
					subOutMsg);
		}
	});
var $author$project$Pages$Reports$DeferredRevenue$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Reports$DeferredRevenue$update, model.Gv, subMsg, model.kV);
		var report = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{kV: report}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Components$Reports$DeferredRevenue$PaginationMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Reports$DeferredRevenue$amountFromHeader = F2(
	function (headers, name) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$String$toInt,
				A2($elm$core$Dict$get, name, headers)));
	});
var $author$project$Components$Reports$DeferredRevenue$BySelected = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Reports$DeferredRevenue$byDropdownItems = F2(
	function (trackPatientsByLocation, currentBy) {
		return A2(
			$elm$core$List$cons,
			A2(
				$author$project$Ui$Dropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$Dropdown$onSelect(
						$author$project$Components$Reports$DeferredRevenue$BySelected($elm$core$Maybe$Nothing)),
						$author$project$Ui$Dropdown$selected(
						_Utils_eq(currentBy, $elm$core$Maybe$Nothing))
					]),
				$elm$html$Html$text('No Summary')),
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Dropdown$separator,
				A2(
					$elm$core$List$cons,
					A2(
						$author$project$Ui$Dropdown$item,
						_List_fromArray(
							[
								$author$project$Ui$Dropdown$onSelect(
								$author$project$Components$Reports$DeferredRevenue$BySelected(
									$elm$core$Maybe$Just('category'))),
								$author$project$Ui$Dropdown$selected(
								_Utils_eq(
									currentBy,
									$elm$core$Maybe$Just('category')))
							]),
						$elm$html$Html$text('Category')),
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$Ui$Dropdown$item,
							_List_fromArray(
								[
									$author$project$Ui$Dropdown$onSelect(
									$author$project$Components$Reports$DeferredRevenue$BySelected(
										$elm$core$Maybe$Just('practitioner'))),
									$author$project$Ui$Dropdown$selected(
									_Utils_eq(
										currentBy,
										$elm$core$Maybe$Just('practitioner')))
								]),
							$elm$html$Html$text('Provider')),
						trackPatientsByLocation ? _List_fromArray(
							[
								A2(
								$author$project$Ui$Dropdown$item,
								_List_fromArray(
									[
										$author$project$Ui$Dropdown$onSelect(
										$author$project$Components$Reports$DeferredRevenue$BySelected(
											$elm$core$Maybe$Just('location'))),
										$author$project$Ui$Dropdown$selected(
										_Utils_eq(
											currentBy,
											$elm$core$Maybe$Just('location')))
									]),
								$elm$html$Html$text('Location'))
							]) : _List_Nil))));
	});
var $author$project$Components$Reports$DeferredRevenue$byToDisplayName = function (by) {
	switch (by) {
		case 'category':
			return 'Category';
		case 'practitioner':
			return 'Provider';
		case 'location':
			return 'Location';
		default:
			return by;
	}
};
var $author$project$Components$Reports$DeferredRevenue$viewByDropdown = function (model) {
	var placeholder = function () {
		var _v0 = model.co;
		if (!_v0.$) {
			var by = _v0.a;
			return $author$project$Components$Reports$DeferredRevenue$byToDisplayName(by);
		} else {
			return 'Summarize by';
		}
	}();
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(placeholder)
			]),
		A2($author$project$Components$Reports$DeferredRevenue$byDropdownItems, model.adt, model.co),
		model.mB);
};
var $author$project$Components$Reports$DeferredRevenue$viewCategoryResourceFilter = function (categoryResourceFilter) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Reports$DeferredRevenue$CategoryResourceFilterMsg,
		A2(
			$author$project$Components$ResourceFilter$Category$view,
			_List_fromArray(
				[
					$author$project$Components$ResourceFilter$style(1),
					$author$project$Components$ResourceFilter$multi
				]),
			categoryResourceFilter));
};
var $author$project$Components$ResourceFilter$Category$viewMultiSelected = function (model) {
	return A2(
		$elm$core$List$map,
		$elm$html$Html$map($elm$core$Basics$identity),
		A2($author$project$Components$ResourceFilter$viewMultiSelected, model.Jy, model.b8));
};
var $author$project$Components$Reports$DeferredRevenue$viewSummaryRow = F2(
	function (model, summaryRow) {
		var routeParams = _List_fromArray(
			[
				$author$project$Ui$Link$routeParams(
				A2(
					$author$project$Utils$Report$summaryRowTableParams,
					$author$project$Components$Reports$DeferredRevenue$urlParams(model),
					summaryRow))
			]);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_fromArray(
								[
									$author$project$Ui$Typography$info,
									$author$project$Ui$Typography$phi(true)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Reports__DeferredRevenue,
									routeParams,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'Unassigned',
												$author$project$Api$Provider$Reports$Summary$summaryRowName(summaryRow)))
										]))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Reports__DeferredRevenue,
							routeParams,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$String$pluralize,
										'charge',
										$author$project$Api$Provider$Reports$Summary$summaryRowCount(summaryRow)))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$textRight]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Reports__DeferredRevenue,
									routeParams,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Utils$Currency$fromInt(
												$author$project$Api$Provider$Reports$Summary$summaryRowAmountInCents(summaryRow)))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Reports$DeferredRevenue$viewSummaryTable = function (model) {
	var summaryType = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Api$Provider$Reports$Summary$summaryType, $author$project$Formatters$String$humanize),
			$author$project$Api$Data$toMaybe(model.acF)));
	var summaryRows = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$Reports$Summary$summaryRows,
			$author$project$Api$Data$toMaybe(model.acF)));
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$loading(
				!$author$project$Api$Data$isSuccess(model.acF)),
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mb4]),
						_List_fromArray(
							[
								$elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
							]))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(summaryType)
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Number of Charges')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4),
						$author$project$Ui$Table$textRight
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Amount')
					]))
			]),
		A2(
			$elm$core$List$map,
			$author$project$Components$Reports$DeferredRevenue$viewSummaryRow(model),
			summaryRows),
		_List_Nil);
};
var $author$project$Components$Reports$DeferredRevenue$SortTable = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$Reports$DeferredRevenueLine$amountInCents = function (_v0) {
	var record = _v0;
	return record.LE;
};
var $author$project$Api$Provider$Reports$DeferredRevenueLine$category = function (_v0) {
	var record = _v0;
	return record.GW;
};
var $author$project$Api$Provider$Reports$DeferredRevenueLine$charge = function (_v0) {
	var record = _v0;
	return record.afx;
};
var $author$project$Api$Provider$Reports$DeferredRevenueLine$client = function (_v0) {
	var record = _v0;
	return record.NJ;
};
var $author$project$Api$Provider$Reports$RevenueLine$Client$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Reports$DeferredRevenueLine$invoice = function (_v0) {
	var record = _v0;
	return record.Uk;
};
var $author$project$Api$Provider$Reports$DeferredRevenueLine$location = function (_v0) {
	var record = _v0;
	return record.ais;
};
var $author$project$Api$Provider$Reports$Charge$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$Reports$RevenueLine$Client$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$Reports$DeferredRevenueLine$practitioner = function (_v0) {
	var record = _v0;
	return record.aka;
};
var $author$project$Api$Provider$Reports$Charge$serviceDate = function (_v0) {
	var record = _v0;
	return record.aa$;
};
var $author$project$Api$Provider$Reports$DeferredRevenueLine$transactionDate = function (_v0) {
	var record = _v0;
	return record.adw;
};
var $author$project$Api$Provider$Reports$RevenueLine$Client$type_ = function (_v0) {
	var record = _v0;
	return record.amg;
};
var $author$project$Components$Reports$DeferredRevenue$viewRow = F4(
	function (trackPatientsByLocation, canGoToPatients, canGoToCompany, deferredRevenueLine) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$Date$toString,
										$author$project$Formatters$Date$Full,
										$author$project$Api$Provider$Reports$DeferredRevenueLine$transactionDate(deferredRevenueLine)))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$Reports$DeferredRevenueLine$amountInCents(deferredRevenueLine))),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
									'for '),
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[
											$author$project$Ui$Typography$phi(true)
										]),
									A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										A2(
											$elm$core$Maybe$map,
											$author$project$Api$Provider$Reports$Charge$name,
											$author$project$Api$Provider$Reports$DeferredRevenueLine$charge(deferredRevenueLine)))),
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
									' on ' + A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										A2(
											$elm$core$Maybe$map,
											$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
											A2(
												$elm$core$Maybe$map,
												$author$project$Api$Provider$Reports$Charge$serviceDate,
												$author$project$Api$Provider$Reports$DeferredRevenueLine$charge(deferredRevenueLine)))))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							function () {
								var _v0 = $author$project$Api$Provider$Reports$DeferredRevenueLine$invoice(deferredRevenueLine);
								if (!_v0.$) {
									var invoice = _v0.a;
									var invoiceStatus = A2(
										$author$project$Ui$Badge$fromString,
										_List_Nil,
										$author$project$Api$Common$Payable$Invoice$MinWithOwner$status(invoice));
									var invoicePath_ = function () {
										var _v2 = $author$project$Api$Common$Payable$Invoice$MinWithOwner$type_(invoice);
										switch (_v2) {
											case 1:
												var _v3 = _Utils_Tuple2(
													canGoToPatients,
													$author$project$Api$Common$Payable$Invoice$MinWithOwner$owner(invoice));
												if (_v3.a && (!_v3.b.$)) {
													var owner = _v3.b.a;
													return $elm$core$Maybe$Just(
														$author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top(
															{
																Us: $author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice),
																YZ: $author$project$Api$Common$Payable$Owner$Min$id(owner)
															}));
												} else {
													return $elm$core$Maybe$Nothing;
												}
											case 0:
												var _v4 = _Utils_Tuple2(
													canGoToCompany,
													$author$project$Api$Common$Payable$Invoice$MinWithOwner$owner(invoice));
												if (_v4.a && (!_v4.b.$)) {
													var owner = _v4.b.a;
													return $elm$core$Maybe$Just(
														$author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String(
															{
																fZ: $author$project$Api$Common$Payable$Owner$Min$id(owner),
																ahP: $author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice)
															}));
												} else {
													return $elm$core$Maybe$Nothing;
												}
											default:
												return $elm$core$Maybe$Nothing;
										}
									}();
									var invoiceNumber = $elm$html$Html$text(
										'#' + ($elm$core$String$fromInt(
											$author$project$Api$Common$Payable$Invoice$MinWithOwner$invoiceNumber(invoice)) + ' '));
									var _for = A2(
										$author$project$Ui$Typography$text,
										_List_fromArray(
											[
												$author$project$Ui$Typography$phi(true),
												$author$project$Ui$Typography$small,
												$author$project$Ui$Typography$muted
											]),
										'for ' + A2(
											$elm$core$Maybe$withDefault,
											'N/A',
											A2(
												$elm$core$Maybe$map,
												$author$project$Api$Common$Payable$Owner$Min$name,
												$author$project$Api$Common$Payable$Invoice$MinWithOwner$owner(invoice))));
									if (!invoicePath_.$) {
										var path = invoicePath_.a;
										return _List_fromArray(
											[
												A3(
												$author$project$Ui$Link$route,
												path,
												_List_Nil,
												_List_fromArray(
													[invoiceNumber, invoiceStatus])),
												A2($elm$html$Html$br, _List_Nil, _List_Nil),
												_for
											]);
									} else {
										return _List_fromArray(
											[
												invoiceNumber,
												invoiceStatus,
												A2($elm$html$Html$br, _List_Nil, _List_Nil),
												_for
											]);
									}
								} else {
									return _List_Nil;
								}
							}()),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							function () {
								var _v5 = $author$project$Api$Provider$Reports$DeferredRevenueLine$client(deferredRevenueLine);
								if (!_v5.$) {
									var client = _v5.a;
									var path = function () {
										var _v7 = $author$project$Api$Provider$Reports$RevenueLine$Client$type_(client);
										if (!_v7) {
											return canGoToPatients ? $elm$core$Maybe$Just(
												$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
													{
														YZ: $author$project$Api$Provider$Reports$RevenueLine$Client$id(client)
													})) : $elm$core$Maybe$Nothing;
										} else {
											return canGoToCompany ? $elm$core$Maybe$Just(
												$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top(
													{
														fZ: $author$project$Api$Provider$Reports$RevenueLine$Client$id(client)
													})) : $elm$core$Maybe$Nothing;
										}
									}();
									var clientName = A2(
										$author$project$Ui$Typography$text,
										_List_fromArray(
											[
												$author$project$Ui$Typography$phi(true)
											]),
										A2(
											$author$project$Formatters$String$ellipsis,
											20,
											$author$project$Api$Provider$Reports$RevenueLine$Client$name(client)));
									if (!path.$) {
										var path_ = path.a;
										return _List_fromArray(
											[
												A3(
												$author$project$Ui$Link$route,
												path_,
												_List_Nil,
												_List_fromArray(
													[clientName]))
											]);
									} else {
										return _List_fromArray(
											[clientName]);
									}
								} else {
									return _List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[
													$author$project$Ui$Typography$phi(true)
												]),
											'N/A')
										]);
								}
							}()),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											$author$project$Api$Provider$Category$Min$name,
											$author$project$Api$Provider$Reports$DeferredRevenueLine$category(deferredRevenueLine))))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_fromArray(
								[
									$author$project$Ui$Table$colspan(
									trackPatientsByLocation ? 1 : 2)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$String$ellipsis,
										20,
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Maybe$map,
												$author$project$Api$Provider$Practitioner$Min$name,
												$author$project$Api$Provider$Reports$DeferredRevenueLine$practitioner(deferredRevenueLine)))))
								]))
						]),
						trackPatientsByLocation ? _List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$String$ellipsis,
										20,
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Maybe$map,
												$author$project$Api$Provider$Location$Min$name,
												$author$project$Api$Provider$Reports$DeferredRevenueLine$location(deferredRevenueLine)))))
								]))
						]) : _List_Nil
					])));
	});
var $author$project$Components$Reports$DeferredRevenue$viewTable = function (model) {
	var _v0 = function () {
		var _v1 = model.a6;
		if (_v1.$ === 3) {
			var deferredRevenueLines_ = _v1.a;
			return _Utils_Tuple2(false, deferredRevenueLines_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var deferredRevenueLines = _v0.b;
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$map,
					$author$project$Api$Column$view(
						A2($author$project$Api$Column$Sortable, model.alA, $author$project$Components$Reports$DeferredRevenue$SortTable)),
					model.N3),
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[$author$project$Ui$Table$textRight]),
						_List_fromArray(
							[
								A2($elm$html$Html$map, $author$project$Components$Reports$DeferredRevenue$ExportCsvMsg, $author$project$Components$ExportCsv$button)
							]))
					])
				])),
		A2(
			$elm$core$List$map,
			A3($author$project$Components$Reports$DeferredRevenue$viewRow, model.adt, model.GQ, model.GP),
			deferredRevenueLines),
		_List_Nil);
};
var $author$project$Components$Reports$DeferredRevenue$view = F2(
	function (apiClient, model) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Reports$DeferredRevenue$ExportCsvMsg,
				A3(
					$author$project$Components$ExportCsv$modal,
					apiClient,
					_List_fromArray(
						[
							$author$project$Components$ExportCsv$report(
							$author$project$Api$Data$totalCount(model.a6)),
							$author$project$Components$ExportCsv$reportParams(
							A2($elm$core$Basics$composeL, $author$project$Api$Provider$Reports$DeferredRevenueLine$listOptionsToParams, $author$project$Components$Reports$DeferredRevenue$fetchDeferredRevenueLinesParams)(model))
						]),
					model.nD)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Packages Deferred Revenue')
									])),
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								function () {
									var _v0 = model.a6;
									if (_v0.$ === 3) {
										var headers = _v0.b;
										return _List_fromArray(
											[
												$elm$html$Html$text(
												'Total: ' + $author$project$Utils$Currency$fromInt(
													A2($author$project$Components$Reports$DeferredRevenue$amountFromHeader, headers, 'x-total-amount')))
											]);
									} else {
										return _List_fromArray(
											[
												$author$project$Ui$Skeleton$text(
												_List_fromArray(
													[
														$author$project$Ui$Skeleton$spanFromText('Total: $1000.00')
													]))
											]);
									}
								}()),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpBlock]),
								_List_fromArray(
									[
										$elm$html$Html$text('Total deferred revenue from packages across retail customers and employers')
									])),
								A2(
								$author$project$Ui$Grid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$spanSm(12)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Components$Reports$DeferredRevenue$DateRangeInputMsg,
												$author$project$Components$DateRangeInput$view(model.i4))
											]))
									])),
								A2(
								$author$project$Ui$Grid$row,
								_List_Nil,
								_Utils_ap(
									A2(
										$elm$core$List$map,
										A2(
											$elm$core$Basics$composeR,
											$elm$core$List$singleton,
											$author$project$Ui$Grid$column(
												_List_fromArray(
													[
														$author$project$Ui$Grid$span(6),
														$author$project$Ui$Grid$spanMd(4)
													]))),
										A2(
											$elm$core$List$map,
											$elm$html$Html$map($author$project$Components$Reports$DeferredRevenue$GroupLocationAndPractitionerFiltersMsg),
											A2(
												$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$view,
												_List_fromArray(
													[$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$multi]),
												model.dn))),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$span(6),
													$author$project$Ui$Grid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$DeferredRevenue$viewCategoryResourceFilter(model.c8)
												])),
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$span(6),
													$author$project$Ui$Grid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$DeferredRevenue$viewByDropdown(model)
												]))
										]))),
								A2(
								$author$project$Ui$Grid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_Nil,
										function () {
											var activeFilters = _Utils_ap(
												A2(
													$elm$core$List$map,
													$elm$html$Html$map($author$project$Components$Reports$DeferredRevenue$CategoryResourceFilterMsg),
													$author$project$Components$ResourceFilter$Category$viewMultiSelected(model.c8)),
												A2(
													$elm$core$List$map,
													$elm$html$Html$map($author$project$Components$Reports$DeferredRevenue$GroupLocationAndPractitionerFiltersMsg),
													$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewMultiSelected(model.dn)));
											return $elm$core$List$isEmpty(activeFilters) ? _List_Nil : _List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$mt2, $author$project$Ui$Element$mb2]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$strong,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Active filters')
																]))
														])),
													A2($elm$html$Html$span, _List_Nil, activeFilters)
												]);
										}())
									]))
							])),
						function () {
						var _v1 = model.amg;
						if (!_v1) {
							return $author$project$Components$Reports$DeferredRevenue$viewTable(model);
						} else {
							return $author$project$Components$Reports$DeferredRevenue$viewSummaryTable(model);
						}
					}(),
						function () {
						var _v2 = model.amg;
						if (!_v2) {
							return A2(
								$author$project$Ui$Panel$footer,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Components$Reports$DeferredRevenue$PaginationMsg,
										A2(
											$author$project$Api$Pagination$view,
											_List_fromArray(
												[
													$author$project$Ui$Pagination$List$loading(
													!$author$project$Utils$Maybe$toBool(
														$author$project$Api$Data$toMaybe(model.a6)))
												]),
											model.ajJ))
									]));
						} else {
							return $author$project$Ui$Panel$none;
						}
					}()
					]))
			]);
	});
var $author$project$Pages$Reports$DeferredRevenue$view = function (model) {
	return {
		fO: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			A2($author$project$Components$Reports$DeferredRevenue$view, model.Gv, model.kV)),
		ac9: 'Reports | Packages Deferred Revenue'
	};
};
var $author$project$Pages$Reports$DeferredRevenue$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Reports$DeferredRevenue$init, aiq: $author$project$Pages$Reports$DeferredRevenue$load, k8: $author$project$Pages$Reports$DeferredRevenue$save, alO: $author$project$Pages$Reports$DeferredRevenue$subscriptions, adT: $author$project$Pages$Reports$DeferredRevenue$update, amo: $author$project$Pages$Reports$DeferredRevenue$view});
var $author$project$Pages$Reports$DeferredRevenue$Summary$ReportMsg = $elm$core$Basics$identity;
var $author$project$Components$Reports$DeferredRevenue$Summary = 1;
var $author$project$Pages$Reports$DeferredRevenue$Summary$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.DE;
		var _v1 = A5($author$project$Components$Reports$DeferredRevenue$init, 1, session, practice, shared, query);
		var report = _v1.a;
		var reportCmd = _v1.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, kV: report},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportCmd));
	});
var $author$project$Pages$Reports$DeferredRevenue$Summary$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$DeferredRevenue$Summary$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Reports$DeferredRevenue$Summary$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Reports$DeferredRevenue$subscriptions(model.kV));
};
var $author$project$Pages$Reports$DeferredRevenue$Summary$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Reports$DeferredRevenue$update, model.Gv, subMsg, model.kV);
		var report = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{kV: report}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Pages$Reports$DeferredRevenue$Summary$view = function (model) {
	return {
		fO: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			A2($author$project$Components$Reports$DeferredRevenue$view, model.Gv, model.kV)),
		ac9: 'Reports | Packages Deferred Revenue'
	};
};
var $author$project$Pages$Reports$DeferredRevenue$Summary$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Reports$DeferredRevenue$Summary$init, aiq: $author$project$Pages$Reports$DeferredRevenue$Summary$load, k8: $author$project$Pages$Reports$DeferredRevenue$Summary$save, alO: $author$project$Pages$Reports$DeferredRevenue$Summary$subscriptions, adT: $author$project$Pages$Reports$DeferredRevenue$Summary$update, amo: $author$project$Pages$Reports$DeferredRevenue$Summary$view});
var $author$project$Pages$Reports$Deposits$ReportMsg = $elm$core$Basics$identity;
var $author$project$Components$Reports$Deposits$DateRangeInputMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Report$Deposit = 13;
var $author$project$Components$Reports$Deposits$StatusDropdownMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Reports$Deposits$dateRangeInputSettings = F2(
	function (start, end) {
		var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
		return _Utils_update(
			defaultSettings,
			{ahy: start, al5: end});
	});
var $author$project$Components$Reports$Deposits$GotDepositSummary = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Reports$DepositSummary$DepositSummary = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$DepositSummary$Record = F3(
	function (nextDepositAvailableOn, nextDepositAmountInCents, availableSoonAmountInCents) {
		return {Mq: availableSoonAmountInCents, XQ: nextDepositAmountInCents, XR: nextDepositAvailableOn};
	});
var $author$project$Api$Provider$Reports$DepositSummary$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'available_soon_amount_in_cents',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'next_deposit_amount_in_cents',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'next_deposit_available_on',
			$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$DepositSummary$Record))));
var $author$project$Api$Provider$Reports$DepositSummary$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Reports$DepositSummary$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$DepositSummary$depositSummaryPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['deposits', 'summary']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Reports$DepositSummary$depositSummary = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Reports$DepositSummary$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$DepositSummary$depositSummaryPath));
	});
var $author$project$Components$Reports$Deposits$fetchDepositSummary = F2(
	function (apiClient, _v0) {
		return A2($author$project$Api$Provider$Reports$DepositSummary$depositSummary, apiClient, $author$project$Components$Reports$Deposits$GotDepositSummary);
	});
var $author$project$Components$Reports$Deposits$GotDeposits = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Reports$Deposits$fetchDepositsParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				HB: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.HB),
				ajJ: model.ajJ,
				alA: model.alA,
				JV: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.JV),
				alH: model.alH
			});
	};
};
var $author$project$Api$Provider$Reports$Deposit$Deposit = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$Deposit$Record = function (id) {
	return function (availableOn) {
		return function (amountInCents) {
			return function (stripeFeeInCents) {
				return function (hintFeeInCents) {
					return function (totalFeeInCents) {
						return function (discrepancyInCents) {
							return function (receiptsCount) {
								return function (status) {
									return function (errorMessage) {
										return function (paymentProcessor) {
											return function (canReconcile) {
												return {LE: amountInCents, Mp: availableOn, Ng: canReconcile, QJ: discrepancyInCents, RM: errorMessage, Ty: hintFeeInCents, ahP: id, Zd: paymentProcessor, $b: receiptsCount, alH: status, aco: stripeFeeInCents, adn: totalFeeInCents};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Reports$Deposit$Canceled = 3;
var $author$project$Api$Provider$Reports$Deposit$Failed = 4;
var $author$project$Api$Provider$Reports$Deposit$InTransit = 2;
var $author$project$Api$Provider$Reports$Deposit$Paid = 0;
var $author$project$Api$Provider$Reports$Deposit$Pending = 1;
var $author$project$Api$Provider$Reports$Deposit$Upcoming = 5;
var $author$project$Api$Provider$Reports$Deposit$decodeStatus = function (string) {
	switch (string) {
		case 'paid':
			return $elm$json$Json$Decode$succeed(0);
		case 'pending':
			return $elm$json$Json$Decode$succeed(1);
		case 'in_transit':
			return $elm$json$Json$Decode$succeed(2);
		case 'canceled':
			return $elm$json$Json$Decode$succeed(3);
		case 'failed':
			return $elm$json$Json$Decode$succeed(4);
		case 'upcoming':
			return $elm$json$Json$Decode$succeed(5);
		default:
			return $elm$json$Json$Decode$fail('Unsupported deposit status: ' + string);
	}
};
var $author$project$Api$Provider$Reports$Deposit$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'can_reconcile',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'payment_processor',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'error_message',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'status',
				A2($elm$json$Json$Decode$andThen, $author$project$Api$Provider$Reports$Deposit$decodeStatus, $elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'receipts_count',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'discrepancy_in_cents',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'total_fee_in_cents',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'hint_fee_in_cents',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'stripe_fee_in_cents',
									$elm$json$Json$Decode$int,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'amount_in_cents',
										$elm$json$Json$Decode$int,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'available_on',
											$author$project$Utils$Date$decode,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'id',
												$elm$json$Json$Decode$string,
												$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$Deposit$Record)))))))))))));
var $author$project$Api$Provider$Reports$Deposit$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Reports$Deposit$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$Deposit$listDefaults = {HB: $elm$core$Maybe$Nothing, ajJ: $author$project$Api$Pagination$init, alA: $author$project$Api$Sort$init, JV: $elm$core$Maybe$Nothing, alH: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$Reports$Deposit$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Reports$Deposit$listDefaults);
	return A2(
		$elm$core$List$append,
		$author$project$Api$Pagination$toApiParams(options.ajJ),
		A2(
			$elm$core$List$append,
			$author$project$Api$Sort$toParams(options.alA),
			$elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						var _v0 = options.JV;
						if (!_v0.$) {
							var start_ = _v0.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'start', start_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v1 = options.HB;
						if (!_v1.$) {
							var end_ = _v1.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'end', end_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v2 = options.alH;
						if (!_v2.$) {
							var status_ = _v2.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'status', status_)
								]);
						} else {
							return _List_Nil;
						}
					}()
					]))));
};
var $author$project$Api$Provider$Reports$Deposit$listPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['reports', 'deposits']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Reports$Deposit$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Reports$Deposit$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Reports$Deposit$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$Deposit$listPath)));
	});
var $author$project$Components$Reports$Deposits$fetchDeposits = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Api$Provider$Reports$Deposit$list,
			apiClient,
			$author$project$Components$Reports$Deposits$fetchDepositsParams(model),
			$author$project$Components$Reports$Deposits$GotDeposits);
	});
var $author$project$Components$Reports$Deposits$initColumns = function (feePlanType) {
	return $elm$core$List$concat(
		_List_fromArray(
			[
				_List_fromArray(
				[
					A3($author$project$Api$Column$init, 'available_on', true, 'Est. Available Date'),
					A3($author$project$Api$Column$init, 'amount_in_cents', true, 'Deposit Amount')
				]),
				function () {
				if (!feePlanType) {
					return _List_fromArray(
						[
							A3($author$project$Api$Column$init, 'stripe_fee_in_cents', true, 'Processing Fee'),
							A3($author$project$Api$Column$init, 'hint_fee_in_cents', true, 'Platform Fee')
						]);
				} else {
					return _List_fromArray(
						[
							A3($author$project$Api$Column$init, 'total_fee_in_cents', true, 'Transaction Fee')
						]);
				}
			}(),
				_List_fromArray(
				[
					A3($author$project$Api$Column$init, 'discrepancy_in_cents', true, 'Discrepancies'),
					A3($author$project$Api$Column$init, 'receipts_count', false, 'Payment Count'),
					A3($author$project$Api$Column$init, 'payment_processor', false, 'Payment Processor'),
					A3($author$project$Api$Column$init, 'status', false, 'Status')
				])
			]));
};
var $author$project$Components$Reports$Deposits$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('start'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.dd, 0)),
			model.JV),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('end'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.dd, 0)),
			model.HB),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('status'),
			model.alH)
		]);
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__Deposits)
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.ajJ),
				A2(
					$elm$core$List$append,
					$author$project$Api$Sort$toQuery(model.alA),
					A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
};
var $author$project$Components$Reports$Deposits$init = F3(
	function (practice, shared, query) {
		var feePlanType = $author$project$Api$Provider$Practice$One$feePlanType(practice);
		var _v0 = $author$project$Utils$DateWithDefault$fromQuery(query);
		var start = _v0.a;
		var end = _v0.b;
		var _v1 = A2(
			$author$project$Components$DateRangeInput$init,
			'date-range-input',
			A2(
				$author$project$Components$Reports$Deposits$dateRangeInputSettings,
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, shared.dd, 0),
					start),
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, shared.dd, 0),
					end)));
		var dateRangeInput = _v1.a;
		var dateRangeInputCmd = _v1.b;
		var model = {
			N3: $author$project$Components$Reports$Deposits$initColumns(feePlanType),
			dd: shared.dd,
			i4: dateRangeInput,
			zc: $author$project$Api$Data$Loading,
			cC: $author$project$Api$Data$Loading,
			HB: end,
			nD: $author$project$Components$ExportCsv$initForPractice(13),
			Si: feePlanType,
			Ij: $author$project$Shared$isHintAdmin(shared),
			ajJ: $author$project$Api$Pagination$initFromQuery(query),
			ZV: practice,
			hq: $elm$core$Maybe$Nothing,
			alA: A3(
				$author$project$Api$Sort$withDefault,
				'available_on',
				1,
				$author$project$Api$Sort$initFromQuery(query)),
			JV: start,
			alH: A2($elm$core$Dict$get, 'status', query),
			qn: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'deposits-status-dropdown', al6: $author$project$Components$Reports$Deposits$StatusDropdownMsg}))
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Deposits$DateRangeInputMsg, dateRangeInputCmd),
						A2($author$project$Components$Reports$Deposits$fetchDeposits, shared.Gv, model),
						A2($author$project$Components$Reports$Deposits$fetchDepositSummary, shared.Gv, model),
						$author$project$Components$Reports$Deposits$updateUrl(model)
					])));
	});
var $author$project$Pages$Reports$Deposits$init = F4(
	function (_v0, practice, shared, _v1) {
		var query = _v1.DE;
		var _v2 = A3($author$project$Components$Reports$Deposits$init, practice, shared, query);
		var report = _v2.a;
		var reportCmd = _v2.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, kV: report},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportCmd));
	});
var $author$project$Pages$Reports$Deposits$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$Deposits$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Reports$Deposits$CloseRainforestDepositModal = {$: 10};
var $author$project$Components$Reports$Deposits$ExportCsvMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Reports$Deposits$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$Deposits$DateRangeInputMsg,
				$author$project$Components$DateRangeInput$subscriptions(model.i4)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$Deposits$ExportCsvMsg,
				$author$project$Components$ExportCsv$subscriptions(model.nD)),
				$author$project$Ui$Dropdown$subscriptions(model.qn),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Rainforest$SessionModal$subscriptions($author$project$Components$Reports$Deposits$CloseRainforestDepositModal)),
					model.hq))
			]));
};
var $author$project$Pages$Reports$Deposits$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Reports$Deposits$subscriptions(model.kV));
};
var $author$project$Components$Reports$Deposits$RainforestDepositModalMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Provider$Reports$Deposit$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Components$Reports$Deposits$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Components$DateRangeInput$update, subMsg, model.i4);
				var dateRangeInput = _v1.a;
				var subCmd = _v1.b;
				var event = _v1.c;
				var newModel = function () {
					if (event.$ === 1) {
						var fromDate = event.a;
						var toDate = event.b;
						return _Utils_update(
							model,
							{
								i4: dateRangeInput,
								cC: $author$project$Api$Data$Loading,
								HB: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
								ajJ: $author$project$Api$Pagination$reset(model.ajJ),
								JV: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
							});
					} else {
						return _Utils_update(
							model,
							{i4: dateRangeInput});
					}
				}();
				var cmds = (_Utils_eq(newModel.JV, model.JV) && _Utils_eq(newModel.HB, model.HB)) ? _List_Nil : _List_fromArray(
					[
						A2($author$project$Components$Reports$Deposits$fetchDeposits, apiClient, newModel),
						$author$project$Components$Reports$Deposits$updateUrl(newModel)
					]);
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$cons,
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Deposits$DateRangeInputMsg, subCmd),
							cmds)),
					_List_Nil);
			case 1:
				var subMsg = msg.a;
				var _v3 = A2($author$project$Ui$Dropdown$update, subMsg, model.qn);
				var statusDropdown = _v3.a;
				var statusDropdownCmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qn: statusDropdown}),
					statusDropdownCmd,
					_List_Nil);
			case 2:
				var selectedOption = msg.a;
				var newModel = _Utils_update(
					model,
					{
						cC: $author$project$Api$Data$Loading,
						ajJ: $author$project$Api$Pagination$reset(model.ajJ),
						alH: function () {
							if (selectedOption.$ === 1) {
								return $elm$core$Maybe$Nothing;
							} else {
								var status = selectedOption.a;
								return $elm$core$Maybe$Just(status);
							}
						}()
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$Deposits$fetchDeposits, apiClient, newModel),
								$author$project$Components$Reports$Deposits$updateUrl(newModel)
							])),
					_List_Nil);
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cC: response,
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cC: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{zc: response}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 5:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{cC: $author$project$Api$Data$Loading, ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$Deposits$fetchDeposits, apiClient, newModel),
								$author$project$Components$Reports$Deposits$updateUrl(newModel)
							])),
					_List_Nil);
			case 6:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						alA: A2($author$project$Api$Sort$update, columnId, model.alA)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$Deposits$fetchDeposits, apiClient, newModel),
								$author$project$Components$Reports$Deposits$updateUrl(newModel)
							])),
					_List_Nil);
			case 7:
				var subMsg = msg.a;
				var _v7 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.nD);
				var exportCsv = _v7.a;
				var subCmd = _v7.b;
				var subOutMsg = _v7.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nD: exportCsv}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Deposits$ExportCsvMsg, subCmd),
					subOutMsg);
			case 8:
				var deposit = msg.a;
				var _v8 = A2(
					$author$project$Components$Rainforest$SessionModal$init,
					apiClient,
					$author$project$Api$Platform$RainforestSession$Deposit(
						$author$project$Api$Provider$Reports$Deposit$id(deposit)));
				var rainforestDepositModal = _v8.a;
				var rainforestDepositModalCmd = _v8.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							hq: $elm$core$Maybe$Just(rainforestDepositModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Deposits$RainforestDepositModalMsg, rainforestDepositModalCmd),
					_List_Nil);
			case 9:
				var subMsg = msg.a;
				var _v9 = model.hq;
				if (!_v9.$) {
					var rainforestDepositModal = _v9.a;
					var _v10 = A2($author$project$Components$Rainforest$SessionModal$update, subMsg, rainforestDepositModal);
					var newRainforestDepositModal = _v10.a;
					var rainforestDepositModalCmd = _v10.b;
					var rainforestDepositModalOutMsg = _v10.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								hq: $elm$core$Maybe$Just(newRainforestDepositModal)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Deposits$RainforestDepositModalMsg, rainforestDepositModalCmd),
						rainforestDepositModalOutMsg);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{hq: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
		}
	});
var $author$project$Pages$Reports$Deposits$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Reports$Deposits$update, model.Gv, subMsg, model.kV);
		var report = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{kV: report}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Components$Reports$Deposits$PaginationMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Reports$Deposits$intFromHeader = F2(
	function (headers, name) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$String$toInt,
				A2($elm$core$Dict$get, name, headers)));
	});
var $author$project$Api$Provider$Reports$DepositSummary$availableSoonAmountInCents = function (_v0) {
	var record = _v0;
	return record.Mq;
};
var $author$project$Components$Reports$Deposits$viewSummaryCard = F5(
	function (panelOptions, title, mainNumber, subtitle, description) {
		var subtitleElement = function () {
			if (!subtitle.$) {
				var text_ = subtitle.a;
				return A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$italic]),
					_List_fromArray(
						[
							$elm$html$Html$text(text_)
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}();
		return A2(
			$author$project$Ui$Panel$view,
			panelOptions,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Typography$heading(
							_List_fromArray(
								[
									$elm$html$Html$text(mainNumber)
								])),
							subtitleElement,
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$inlineBlock, $author$project$Ui$Element$textMuted, $author$project$Ui$Element$mt2]),
							_List_fromArray(
								[
									$elm$html$Html$text(description)
								]))
						]))
				]));
	});
var $author$project$Components$Reports$Deposits$viewAvailableSoonCard = function (depositSummary) {
	return A5(
		$author$project$Components$Reports$Deposits$viewSummaryCard,
		_List_fromArray(
			[$author$project$Ui$Panel$tile, $author$project$Ui$Panel$info]),
		'Available Soon',
		$author$project$Utils$Currency$fromInt(
			$author$project$Api$Provider$Reports$DepositSummary$availableSoonAmountInCents(depositSummary)),
		$elm$core$Maybe$Just('Estimate expected within a few business days'),
		'Total amount of payments in progress. These have been collected, but not yet deposited.');
};
var $author$project$Api$Provider$Reports$DepositSummary$nextDepositAmountInCents = function (_v0) {
	var record = _v0;
	return record.XQ;
};
var $author$project$Api$Provider$Reports$DepositSummary$nextDepositAvailableOn = function (_v0) {
	var record = _v0;
	return record.XR;
};
var $author$project$Components$Reports$Deposits$viewNextDepositCard = function (depositSummary) {
	var nextDepositAvailableOn = A2(
		$elm$core$Maybe$map,
		function (d) {
			return 'Estimate expected ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$MonthAndDayAndYear, d);
		},
		$author$project$Api$Provider$Reports$DepositSummary$nextDepositAvailableOn(depositSummary));
	var nextDepositAmount = function () {
		var _v0 = $author$project$Api$Provider$Reports$DepositSummary$nextDepositAmountInCents(depositSummary);
		if (!_v0.$) {
			var amount = _v0.a;
			return $author$project$Utils$Currency$fromInt(amount);
		} else {
			return 'N/A';
		}
	}();
	return A5(
		$author$project$Components$Reports$Deposits$viewSummaryCard,
		_List_fromArray(
			[$author$project$Ui$Panel$tile, $author$project$Ui$Panel$success]),
		'Next Deposit',
		nextDepositAmount,
		nextDepositAvailableOn,
		'This reflects the portion of the “Available Soon” amount that is scheduled to be paid out next.');
};
var $author$project$Components$Reports$Deposits$viewDepositSummary = F2(
	function (depositSummaryData, practice) {
		if ($author$project$Api$Provider$Practice$One$paymentProcessor(practice) === 'rainforest') {
			if (depositSummaryData.$ === 3) {
				var depositSummary = depositSummaryData.a;
				return A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mb6]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flex, $author$project$Ui$Element$wrap, $author$project$Ui$Element$gap4, $author$project$Ui$Element$mt4, $author$project$Ui$Element$mb2]),
							_List_fromArray(
								[
									$author$project$Components$Reports$Deposits$viewNextDepositCard(depositSummary),
									$author$project$Components$Reports$Deposits$viewAvailableSoonCard(depositSummary)
								])),
							A2(
							$author$project$Ui$Typography$p,
							_List_fromArray(
								[$author$project$Ui$Typography$helpBlock]),
							_List_fromArray(
								[
									$elm$html$Html$text('The numbers above are estimates based on pending transactions. Stripe payments are excluded. Final deposit amounts may change as payments and refunds process.')
								]))
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$Reports$Deposits$formatStatus = $elm_community$string_extra$String$Extra$humanize;
var $author$project$Components$Reports$Deposits$None = {$: 1};
var $author$project$Components$Reports$Deposits$Status = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Reports$Deposits$StatusFiltered = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Reports$Deposits$statusDropdownOptions = function (currentStatus) {
	var baseStatusOptions = _List_fromArray(
		['failed', 'paid', 'pending', 'in_transit', 'canceled', 'upcoming']);
	var statusOptions = A2(
		$elm$core$List$map,
		function (status) {
			return A2(
				$author$project$Ui$Dropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$Dropdown$onSelect(
						$author$project$Components$Reports$Deposits$StatusFiltered(
							$author$project$Components$Reports$Deposits$Status(status))),
						$author$project$Ui$Dropdown$selected(
						_Utils_eq(
							$elm$core$Maybe$Just(status),
							currentStatus))
					]),
				$elm$html$Html$text(
					$author$project$Components$Reports$Deposits$formatStatus(status)));
		},
		baseStatusOptions);
	return A2(
		$elm$core$List$cons,
		A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Components$Reports$Deposits$StatusFiltered($author$project$Components$Reports$Deposits$None)),
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(currentStatus, $elm$core$Maybe$Nothing))
				]),
			$elm$html$Html$text('No Filter')),
		A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, statusOptions));
};
var $author$project$Components$Reports$Deposits$viewStatusDropdown = function (model) {
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				A2(
					$elm$core$Maybe$withDefault,
					'All Status',
					A2($elm$core$Maybe$map, $author$project$Components$Reports$Deposits$formatStatus, model.alH)))
			]),
		$author$project$Components$Reports$Deposits$statusDropdownOptions(model.alH),
		model.qn);
};
var $author$project$Components$Reports$Deposits$SortTable = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Reports$Deposits$OpenRainforestDepositModal = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$Reports$Deposit$amountInCents = function (_v0) {
	var record = _v0;
	return record.LE;
};
var $author$project$Api$Provider$Reports$Deposit$availableOn = function (_v0) {
	var record = _v0;
	return record.Mp;
};
var $author$project$Api$Provider$Reports$Deposit$canReconcile = function (_v0) {
	var record = _v0;
	return record.Ng;
};
var $author$project$Api$Provider$Reports$Deposit$discrepancyInCents = function (_v0) {
	var record = _v0;
	return record.QJ;
};
var $author$project$Api$Provider$Reports$Deposit$errorMessage = function (_v0) {
	var record = _v0;
	return record.RM;
};
var $author$project$Api$Provider$Reports$Deposit$hintFeeInCents = function (_v0) {
	var record = _v0;
	return record.Ty;
};
var $author$project$Api$Provider$Reports$Deposit$paymentProcessor = function (_v0) {
	var record = _v0;
	return record.Zd;
};
var $author$project$Api$Provider$Reports$Deposit$receiptsCount = function (_v0) {
	var record = _v0;
	return record.$b;
};
var $author$project$Api$Provider$Reports$Deposit$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Api$Provider$Reports$Deposit$statusToString = function (status_) {
	switch (status_) {
		case 0:
			return 'paid';
		case 1:
			return 'pending';
		case 2:
			return 'in transit';
		case 3:
			return 'canceled';
		case 4:
			return 'failed';
		default:
			return 'upcoming';
	}
};
var $author$project$Api$Provider$Reports$Deposit$stripeFeeInCents = function (_v0) {
	var record = _v0;
	return record.aco;
};
var $author$project$Api$Provider$Reports$Deposit$totalFeeInCents = function (_v0) {
	var record = _v0;
	return record.adn;
};
var $author$project$Components$Reports$Deposits$viewRow = F3(
	function (isHintAdmin, feePlanType, deposit) {
		var availableDate = ($author$project$Api$Provider$Reports$Deposit$status(deposit) === 5) ? $elm$html$Html$text(
			A2(
				$author$project$Formatters$Date$toString,
				$author$project$Formatters$Date$Full,
				$author$project$Api$Provider$Reports$Deposit$availableOn(deposit))) : A3(
			$author$project$Ui$Link$route,
			$author$project$Spa$Generated$Route$Reports__PaymentApplications,
			_List_fromArray(
				[
					$author$project$Ui$Link$routeParams(
					_List_fromArray(
						[
							A2(
							$elm$url$Url$Builder$string,
							'deposit',
							$author$project$Api$Provider$Reports$Deposit$id(deposit))
						]))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2(
						$author$project$Formatters$Date$toString,
						$author$project$Formatters$Date$Full,
						$author$project$Api$Provider$Reports$Deposit$availableOn(deposit)))
				]));
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[availableDate])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$Reports$Deposit$amountInCents(deposit)))
								]))
						]),
						function () {
						if (!feePlanType) {
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Table$cell,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Utils$Currency$fromInt(
												$author$project$Api$Provider$Reports$Deposit$stripeFeeInCents(deposit)))
										])),
									A2(
									$author$project$Ui$Table$cell,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Utils$Currency$fromInt(
												$author$project$Api$Provider$Reports$Deposit$hintFeeInCents(deposit)))
										]))
								]);
						} else {
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Table$cell,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Utils$Currency$fromInt(
												$author$project$Api$Provider$Reports$Deposit$totalFeeInCents(deposit)))
										]))
								]);
						}
					}(),
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							$author$project$Api$Provider$Reports$Deposit$canReconcile(deposit) ? _List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$Reports$Deposit$discrepancyInCents(deposit))),
									(!(!$author$project$Api$Provider$Reports$Deposit$discrepancyInCents(deposit))) ? A3(
									$author$project$Ui$Tooltip$view,
									_List_fromArray(
										[
											$author$project$Ui$Tooltip$placement(0)
										]),
									'Occasionally there are discrepancies due to failed ACH or disputed payments',
									_List_fromArray(
										[
											$author$project$Utils$Html$noBreakSpace,
											$author$project$Ui$Icon$help(_List_Nil)
										])) : $author$project$Utils$Html$empty
								]) : _List_fromArray(
								[
									$elm$html$Html$text('N/A'),
									A3(
									$author$project$Ui$Tooltip$view,
									_List_fromArray(
										[
											$author$project$Ui$Tooltip$placement(0)
										]),
									'Non Automated Deposits cannot be reconciled',
									_List_fromArray(
										[
											$author$project$Utils$Html$noBreakSpace,
											$author$project$Ui$Icon$help(_List_Nil)
										]))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(
										$author$project$Api$Provider$Reports$Deposit$receiptsCount(deposit)))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$core$Maybe$withDefault,
									$author$project$Utils$Html$empty,
									A4(
										$author$project$Utils$PaymentProcessor$toBadge,
										true,
										isHintAdmin,
										deposit,
										A2($elm$core$Basics$composeR, $author$project$Api$Provider$Reports$Deposit$paymentProcessor, $elm$core$Maybe$Just)))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									function () {
									var _v1 = _Utils_Tuple2(
										$author$project$Api$Provider$Reports$Deposit$status(deposit),
										$author$project$Api$Provider$Reports$Deposit$errorMessage(deposit));
									if ((_v1.a === 4) && (!_v1.b.$)) {
										var _v2 = _v1.a;
										var errorMessage = _v1.b.a;
										return A3(
											$author$project$Ui$Tooltip$view,
											_List_fromArray(
												[
													$author$project$Ui$Tooltip$placement(0)
												]),
											errorMessage,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Badge$fromString,
													_List_Nil,
													$author$project$Api$Provider$Reports$Deposit$statusToString(
														$author$project$Api$Provider$Reports$Deposit$status(deposit)))
												]));
									} else {
										return A2(
											$author$project$Ui$Badge$fromString,
											_List_Nil,
											$author$project$Api$Provider$Reports$Deposit$statusToString(
												$author$project$Api$Provider$Reports$Deposit$status(deposit)));
									}
								}()
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									function () {
									var _v3 = _Utils_Tuple2(
										isHintAdmin,
										$author$project$Api$Provider$Reports$Deposit$paymentProcessor(deposit));
									if (_v3.a && (_v3.b === 'rainforest')) {
										return A3(
											$author$project$Ui$HinterOnly$button,
											{mm: 'View on rainforest'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick(
													$author$project$Components$Reports$Deposits$OpenRainforestDepositModal(deposit))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('View on Rainforest')
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								]))
						])
					])));
	});
var $author$project$Components$Reports$Deposits$viewTable = function (model) {
	var _v0 = function () {
		var _v1 = model.cC;
		if (_v1.$ === 3) {
			var deposits_ = _v1.a;
			return _Utils_Tuple2(false, deposits_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var deposits = _v0.b;
	return A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$map,
					$author$project$Api$Column$view(
						A2($author$project$Api$Column$Sortable, model.alA, $author$project$Components$Reports$Deposits$SortTable)),
					model.N3),
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[$author$project$Ui$Table$textRight]),
						_List_fromArray(
							[
								A2($elm$html$Html$map, $author$project$Components$Reports$Deposits$ExportCsvMsg, $author$project$Components$ExportCsv$button)
							]))
					])
				])),
		A2(
			$elm$core$List$map,
			A2($author$project$Components$Reports$Deposits$viewRow, model.Ij, model.Si),
			deposits),
		_List_Nil);
};
var $author$project$Components$Reports$Deposits$view = F2(
	function (apiClient, model) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Reports$Deposits$ExportCsvMsg,
				A3(
					$author$project$Components$ExportCsv$modal,
					apiClient,
					_List_fromArray(
						[
							$author$project$Components$ExportCsv$report(
							$author$project$Api$Data$totalCount(model.cC)),
							$author$project$Components$ExportCsv$reportParams(
							A2($elm$core$Basics$composeL, $author$project$Api$Provider$Reports$Deposit$listOptionsToParams, $author$project$Components$Reports$Deposits$fetchDepositsParams)(model))
						]),
					model.nD)),
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					$author$project$Components$Rainforest$SessionModal$view($author$project$Components$Reports$Deposits$CloseRainforestDepositModal),
					model.hq)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Deposits')
									])),
								A2($author$project$Components$Reports$Deposits$viewDepositSummary, model.zc, model.ZV),
								$author$project$Ui$Typography$heading(
								function () {
									var _v0 = model.cC;
									if (_v0.$ === 3) {
										var headers = _v0.b;
										return _List_fromArray(
											[
												$elm$html$Html$text(
												'Total: ' + $author$project$Utils$Currency$fromInt(
													A2($author$project$Components$Reports$Deposits$intFromHeader, headers, 'x-total-amount'))),
												A2(
												$author$project$Ui$Typography$text,
												_List_fromArray(
													[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
												function () {
													var _v1 = model.Si;
													if (!_v1) {
														return ' after ' + ($author$project$Utils$Currency$fromInt(
															A2($author$project$Components$Reports$Deposits$intFromHeader, headers, 'x-total-stripe-fee-amount')) + (' in Processing fees and ' + ($author$project$Utils$Currency$fromInt(
															A2($author$project$Components$Reports$Deposits$intFromHeader, headers, 'x-total-hint-fee-amount')) + (' in Platform fees across ' + A2(
															$author$project$Formatters$String$pluralize,
															'deposit',
															A2($author$project$Components$Reports$Deposits$intFromHeader, headers, 'x-total-count'))))));
													} else {
														return ' after ' + ($author$project$Utils$Currency$fromInt(
															A2($author$project$Components$Reports$Deposits$intFromHeader, headers, 'x-total-fee-amount')) + (' in transaction fees across ' + A2(
															$author$project$Formatters$String$pluralize,
															'deposit',
															A2($author$project$Components$Reports$Deposits$intFromHeader, headers, 'x-total-count'))));
													}
												}())
											]);
									} else {
										return _List_fromArray(
											[
												$author$project$Ui$Skeleton$text(
												_List_fromArray(
													[
														$author$project$Ui$Skeleton$spanFromText('Total: $1000.00')
													]))
											]);
									}
								}()),
								A2(
								$elm$html$Html$map,
								$author$project$Components$Reports$Deposits$DateRangeInputMsg,
								$author$project$Components$DateRangeInput$view(model.i4)),
								A2(
								$author$project$Ui$Grid$row,
								_List_fromArray(
									[$author$project$Ui$Grid$gutterSm]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(5),
												$author$project$Ui$Grid$spanSm(3),
												$author$project$Ui$Grid$spanMd(4)
											]),
										_List_fromArray(
											[
												$author$project$Components$Reports$Deposits$viewStatusDropdown(model)
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Components$Reports$Deposits$viewTable(model)
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$Reports$Deposits$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(
											!$author$project$Utils$Maybe$toBool(
												$author$project$Api$Data$toMaybe(model.cC)))
										]),
									model.ajJ))
							]))
					]))
			]);
	});
var $author$project$Pages$Reports$Deposits$view = function (model) {
	return {
		fO: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			A2($author$project$Components$Reports$Deposits$view, model.Gv, model.kV)),
		ac9: 'Reports | Deposits'
	};
};
var $author$project$Pages$Reports$Deposits$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Reports$Deposits$init, aiq: $author$project$Pages$Reports$Deposits$load, k8: $author$project$Pages$Reports$Deposits$save, alO: $author$project$Pages$Reports$Deposits$subscriptions, adT: $author$project$Pages$Reports$Deposits$update, amo: $author$project$Pages$Reports$Deposits$view});
var $author$project$Pages$Reports$Disputes$ReportMsg = $elm$core$Basics$identity;
var $author$project$Components$Reports$Disputes$DateRangeInputMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Report$Dispute = 22;
var $author$project$Components$Reports$Disputes$StatusDropdownMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Reports$Disputes$dateRangeInputSettings = F2(
	function (start, end) {
		var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
		return _Utils_update(
			defaultSettings,
			{ahy: start, al5: end});
	});
var $author$project$Components$Reports$Disputes$GotDisputes = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Reports$Disputes$fetchDisputesParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				HB: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.HB),
				ajJ: model.ajJ,
				alA: model.alA,
				JV: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.JV),
				alH: model.alH
			});
	};
};
var $author$project$Api$Provider$Reports$Dispute$Dispute = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$Dispute$Record = F7(
	function (id, paymentProcessor, dueDate, amountInCents, status, reasonCode, reasonDescription) {
		return {LE: amountInCents, QX: dueDate, ahP: id, Zd: paymentProcessor, _8: reasonCode, _9: reasonDescription, alH: status};
	});
var $author$project$Api$Provider$Reports$Dispute$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'reason_description',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'reason_code',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'status',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'amount_in_cents',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'due_date',
					$author$project$Utils$Date$decode,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'payment_processor',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$Dispute$Record))))))));
var $author$project$Api$Provider$Reports$Dispute$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Reports$Dispute$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$Dispute$listDefaults = {HB: $elm$core$Maybe$Nothing, ajJ: $author$project$Api$Pagination$init, alA: $author$project$Api$Sort$init, JV: $elm$core$Maybe$Nothing, alH: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$Reports$Dispute$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Reports$Dispute$listDefaults);
	return A2(
		$elm$core$List$append,
		$author$project$Api$Pagination$toApiParams(options.ajJ),
		A2(
			$elm$core$List$append,
			$author$project$Api$Sort$toParams(options.alA),
			$elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						var _v0 = options.JV;
						if (!_v0.$) {
							var start_ = _v0.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'start', start_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v1 = options.HB;
						if (!_v1.$) {
							var end_ = _v1.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'end', end_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v2 = options.alH;
						if (!_v2.$) {
							var status_ = _v2.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'status', status_)
								]);
						} else {
							return _List_Nil;
						}
					}()
					]))));
};
var $author$project$Api$Provider$Reports$Dispute$listPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['reports', 'disputes']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Reports$Dispute$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Reports$Dispute$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Reports$Dispute$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$Dispute$listPath)));
	});
var $author$project$Components$Reports$Disputes$fetchDisputes = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Api$Provider$Reports$Dispute$list,
			apiClient,
			$author$project$Components$Reports$Disputes$fetchDisputesParams(model),
			$author$project$Components$Reports$Disputes$GotDisputes);
	});
var $author$project$Components$Reports$Disputes$initColumns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'due_date', true, 'Due Date'),
		A3($author$project$Api$Column$init, 'amount_in_cents', true, 'Amount'),
		A3($author$project$Api$Column$init, 'reason_code', true, 'Reason Code'),
		A3($author$project$Api$Column$init, 'status', true, 'Status')
	]);
var $author$project$Components$Reports$Disputes$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('start'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.dd, 0)),
			model.JV),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('end'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.dd, 0)),
			model.HB),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('status'),
			model.alH)
		]);
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__Disputes)
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.ajJ),
				A2(
					$elm$core$List$append,
					$author$project$Api$Sort$toQuery(model.alA),
					A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
};
var $author$project$Components$Reports$Disputes$init = F3(
	function (session, shared, query) {
		var _v0 = $author$project$Utils$DateWithDefault$fromQuery(query);
		var start = _v0.a;
		var end = _v0.b;
		var _v1 = A2(
			$author$project$Components$DateRangeInput$init,
			'date-range-input',
			A2(
				$author$project$Components$Reports$Disputes$dateRangeInputSettings,
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, shared.dd, 0),
					start),
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, shared.dd, 0),
					end)));
		var dateRangeInput = _v1.a;
		var dateRangeInputCmd = _v1.b;
		var model = {
			N3: $author$project$Components$Reports$Disputes$initColumns,
			dd: shared.dd,
			i4: dateRangeInput,
			gg: $elm$core$Maybe$Nothing,
			cD: $author$project$Api$Data$Loading,
			HB: end,
			nD: $author$project$Components$ExportCsv$initForPractice(22),
			Ij: $author$project$Shared$isHintAdmin(shared),
			Im: $author$project$Api$Platform$Session$One$userIsPracticeAdmin(session),
			ajJ: $author$project$Api$Pagination$initFromQuery(query),
			alA: A3(
				$author$project$Api$Sort$withDefault,
				'due_date',
				1,
				$author$project$Api$Sort$initFromQuery(query)),
			JV: start,
			alH: A2($elm$core$Dict$get, 'status', query),
			qn: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'disputes-status-dropdown', al6: $author$project$Components$Reports$Disputes$StatusDropdownMsg}))
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Disputes$DateRangeInputMsg, dateRangeInputCmd),
						A2($author$project$Components$Reports$Disputes$fetchDisputes, shared.Gv, model),
						$author$project$Components$Reports$Disputes$updateUrl(model)
					])));
	});
var $author$project$Pages$Reports$Disputes$init = F4(
	function (session, _v0, shared, _v1) {
		var query = _v1.DE;
		var _v2 = A3($author$project$Components$Reports$Disputes$init, session, shared, query);
		var report = _v2.a;
		var reportCmd = _v2.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, kV: report},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportCmd));
	});
var $author$project$Pages$Reports$Disputes$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$Disputes$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Reports$Disputes$CloseDisputeModal = {$: 8};
var $author$project$Components$Reports$Disputes$ExportCsvMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Reports$Disputes$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$Disputes$DateRangeInputMsg,
				$author$project$Components$DateRangeInput$subscriptions(model.i4)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$Disputes$ExportCsvMsg,
				$author$project$Components$ExportCsv$subscriptions(model.nD)),
				$author$project$Ui$Dropdown$subscriptions(model.qn),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$DisputeModal$subscriptions($author$project$Components$Reports$Disputes$CloseDisputeModal)),
					model.gg))
			]));
};
var $author$project$Pages$Reports$Disputes$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Reports$Disputes$subscriptions(model.kV));
};
var $author$project$Components$Reports$Disputes$DisputeModalMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Provider$Reports$Dispute$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Components$Reports$Disputes$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Components$DateRangeInput$update, subMsg, model.i4);
				var dateRangeInput = _v1.a;
				var subCmd = _v1.b;
				var event = _v1.c;
				var newModel = function () {
					if (event.$ === 1) {
						var fromDate = event.a;
						var toDate = event.b;
						return _Utils_update(
							model,
							{
								i4: dateRangeInput,
								cD: $author$project$Api$Data$Loading,
								HB: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
								ajJ: $author$project$Api$Pagination$reset(model.ajJ),
								JV: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
							});
					} else {
						return _Utils_update(
							model,
							{i4: dateRangeInput});
					}
				}();
				var cmds = (_Utils_eq(newModel.JV, model.JV) && _Utils_eq(newModel.HB, model.HB)) ? _List_Nil : _List_fromArray(
					[
						A2($author$project$Components$Reports$Disputes$fetchDisputes, apiClient, newModel),
						$author$project$Components$Reports$Disputes$updateUrl(newModel)
					]);
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$cons,
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Disputes$DateRangeInputMsg, subCmd),
							cmds)),
					_List_Nil);
			case 1:
				var subMsg = msg.a;
				var _v3 = A2($author$project$Ui$Dropdown$update, subMsg, model.qn);
				var statusDropdown = _v3.a;
				var statusDropdownCmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qn: statusDropdown}),
					statusDropdownCmd,
					_List_Nil);
			case 2:
				var selectedOption = msg.a;
				var newModel = _Utils_update(
					model,
					{
						cD: $author$project$Api$Data$Loading,
						ajJ: $author$project$Api$Pagination$reset(model.ajJ),
						alH: function () {
							if (selectedOption.$ === 1) {
								return $elm$core$Maybe$Nothing;
							} else {
								var status = selectedOption.a;
								return $elm$core$Maybe$Just(status);
							}
						}()
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$Disputes$fetchDisputes, apiClient, newModel),
								$author$project$Components$Reports$Disputes$updateUrl(newModel)
							])),
					_List_Nil);
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cD: response,
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cD: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 4:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{cD: $author$project$Api$Data$Loading, ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$Disputes$fetchDisputes, apiClient, newModel),
								$author$project$Components$Reports$Disputes$updateUrl(newModel)
							])),
					_List_Nil);
			case 5:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						alA: A2($author$project$Api$Sort$update, columnId, model.alA)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$Disputes$fetchDisputes, apiClient, newModel),
								$author$project$Components$Reports$Disputes$updateUrl(newModel)
							])),
					_List_Nil);
			case 6:
				var subMsg = msg.a;
				var _v6 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.nD);
				var exportCsv = _v6.a;
				var subCmd = _v6.b;
				var subOutMsg = _v6.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nD: exportCsv}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Disputes$ExportCsvMsg, subCmd),
					subOutMsg);
			case 7:
				var dispute = msg.a;
				var _v7 = A3(
					$author$project$Components$DisputeModal$init,
					$author$project$Api$Data$providerPath,
					apiClient,
					$author$project$Api$Provider$Reports$Dispute$id(dispute));
				var disputeModal = _v7.a;
				var disputeModalCmd = _v7.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							gg: $elm$core$Maybe$Just(disputeModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Disputes$DisputeModalMsg, disputeModalCmd),
					_List_Nil);
			case 8:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{gg: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v8 = model.gg;
				if (!_v8.$) {
					var disputeModal = _v8.a;
					var _v9 = A2($author$project$Components$DisputeModal$update, subMsg, disputeModal);
					var newDisputeModal = _v9.a;
					var disputeModalCmd = _v9.b;
					var disputeModalOutMsgs = _v9.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								gg: $elm$core$Maybe$Just(newDisputeModal)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Disputes$DisputeModalMsg, disputeModalCmd),
						disputeModalOutMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Reports$Disputes$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Reports$Disputes$update, model.Gv, subMsg, model.kV);
		var report = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{kV: report}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Components$Reports$Disputes$PaginationMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Reports$Disputes$intFromHeader = F2(
	function (headers, name) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$String$toInt,
				A2($elm$core$Dict$get, name, headers)));
	});
var $author$project$Components$Reports$Disputes$None = {$: 1};
var $author$project$Components$Reports$Disputes$Status = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Reports$Disputes$StatusFiltered = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Reports$Disputes$statusDropdownOptions = function (currentStatus) {
	var statusOptions = A2(
		$elm$core$List$map,
		function (status) {
			return A2(
				$author$project$Ui$Dropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$Dropdown$onSelect(
						$author$project$Components$Reports$Disputes$StatusFiltered(
							$author$project$Components$Reports$Disputes$Status(status))),
						$author$project$Ui$Dropdown$selected(
						_Utils_eq(
							$elm$core$Maybe$Just(status),
							currentStatus))
					]),
				$elm$html$Html$text(
					$author$project$Formatters$String$humanize(status)));
		},
		_List_fromArray(
			['created', 'action_required', 'processing', 'won', 'lost']));
	return A2(
		$elm$core$List$cons,
		A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Components$Reports$Disputes$StatusFiltered($author$project$Components$Reports$Disputes$None)),
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(currentStatus, $elm$core$Maybe$Nothing))
				]),
			$elm$html$Html$text('No Filter')),
		A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, statusOptions));
};
var $author$project$Components$Reports$Disputes$viewStatusDropdown = function (model) {
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				A2(
					$elm$core$Maybe$withDefault,
					'All Status',
					A2($elm$core$Maybe$map, $author$project$Formatters$String$humanize, model.alH)))
			]),
		$author$project$Components$Reports$Disputes$statusDropdownOptions(model.alH),
		model.qn);
};
var $author$project$Components$Reports$Disputes$SortTable = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Reports$Disputes$OpenDisputeModal = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$Reports$Dispute$amountInCents = function (_v0) {
	var record = _v0;
	return record.LE;
};
var $author$project$Api$Provider$Reports$Dispute$dueDate = function (_v0) {
	var record = _v0;
	return record.QX;
};
var $author$project$Api$Provider$Reports$Dispute$paymentProcessor = function (_v0) {
	var record = _v0;
	return record.Zd;
};
var $author$project$Api$Provider$Reports$Dispute$reasonCode = function (_v0) {
	var record = _v0;
	return record._8;
};
var $author$project$Api$Provider$Reports$Dispute$reasonDescription = function (_v0) {
	var record = _v0;
	return record._9;
};
var $author$project$Api$Provider$Reports$Dispute$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Components$Reports$Disputes$viewRow = F3(
	function (isHintAdmin, isPracticeAdmin, dispute) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$author$project$Formatters$Date$toString,
								$author$project$Formatters$Date$Full,
								$author$project$Api$Provider$Reports$Dispute$dueDate(dispute)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$Currency$fromInt(
								$author$project$Api$Provider$Reports$Dispute$amountInCents(dispute)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = $author$project$Api$Provider$Reports$Dispute$reasonDescription(dispute);
							if (!_v0.$) {
								var reasonDescription = _v0.a;
								return A3(
									$author$project$Ui$Tooltip$view,
									_List_fromArray(
										[
											$author$project$Ui$Tooltip$placement(0)
										]),
									reasonDescription,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Badge$fromString,
											_List_Nil,
											$author$project$Api$Provider$Reports$Dispute$reasonCode(dispute))
										]));
							} else {
								return A2(
									$author$project$Ui$Badge$fromString,
									_List_Nil,
									$author$project$Api$Provider$Reports$Dispute$reasonCode(dispute));
							}
						}()
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Badge$fromString,
							_List_Nil,
							$author$project$Api$Provider$Reports$Dispute$status(dispute))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[
							$author$project$Ui$Table$colspan(2),
							$author$project$Ui$Table$textRight
						]),
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$withDefault,
							$author$project$Utils$Html$empty,
							A4(
								$author$project$Utils$PaymentProcessor$toBadge,
								isHintAdmin,
								isHintAdmin,
								dispute,
								A2($elm$core$Basics$composeR, $author$project$Api$Provider$Reports$Dispute$paymentProcessor, $elm$core$Maybe$Just))),
							function () {
							var _v1 = _Utils_Tuple2(
								$author$project$Api$Provider$Reports$Dispute$paymentProcessor(dispute),
								isPracticeAdmin);
							if ((_v1.a === 'rainforest') && _v1.b) {
								return A3(
									$author$project$Ui$Button$view,
									{mm: 'View dispute'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick(
											$author$project$Components$Reports$Disputes$OpenDisputeModal(dispute))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('View Dispute')
										]));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						]))
				]));
	});
var $author$project$Components$Reports$Disputes$viewTable = function (model) {
	var _v0 = function () {
		var _v1 = model.cD;
		if (_v1.$ === 3) {
			var disputes_ = _v1.a;
			return _Utils_Tuple2(false, disputes_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var disputes = _v0.b;
	return A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$map,
					$author$project$Api$Column$view(
						A2($author$project$Api$Column$Sortable, model.alA, $author$project$Components$Reports$Disputes$SortTable)),
					model.N3),
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[$author$project$Ui$Table$textRight]),
						_List_fromArray(
							[
								A2($elm$html$Html$map, $author$project$Components$Reports$Disputes$ExportCsvMsg, $author$project$Components$ExportCsv$button)
							]))
					])
				])),
		A2(
			$elm$core$List$map,
			A2($author$project$Components$Reports$Disputes$viewRow, model.Ij, model.Im),
			disputes),
		_List_Nil);
};
var $author$project$Components$Reports$Disputes$view = F2(
	function (apiClient, model) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Reports$Disputes$ExportCsvMsg,
				A3(
					$author$project$Components$ExportCsv$modal,
					apiClient,
					_List_fromArray(
						[
							$author$project$Components$ExportCsv$report(
							$author$project$Api$Data$totalCount(model.cD)),
							$author$project$Components$ExportCsv$reportParams(
							A2($elm$core$Basics$composeL, $author$project$Api$Provider$Reports$Dispute$listOptionsToParams, $author$project$Components$Reports$Disputes$fetchDisputesParams)(model))
						]),
					model.nD)),
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					$author$project$Components$DisputeModal$view($author$project$Components$Reports$Disputes$CloseDisputeModal),
					model.gg)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Disputes')
									])),
								$author$project$Ui$Typography$heading(
								function () {
									var _v0 = model.cD;
									if (_v0.$ === 3) {
										var headers = _v0.b;
										return _List_fromArray(
											[
												$elm$html$Html$text(
												'Total: ' + $author$project$Utils$Currency$fromInt(
													A2($author$project$Components$Reports$Disputes$intFromHeader, headers, 'x-total-amount'))),
												A2(
												$author$project$Ui$Typography$text,
												_List_fromArray(
													[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
												' after ' + ($author$project$Utils$Currency$fromInt(
													A2($author$project$Components$Reports$Disputes$intFromHeader, headers, 'x-total-fee-amount')) + (' in transaction fees across ' + A2(
													$author$project$Formatters$String$pluralize,
													'dispute',
													A2($author$project$Components$Reports$Disputes$intFromHeader, headers, 'x-total-count')))))
											]);
									} else {
										return _List_fromArray(
											[
												$author$project$Ui$Skeleton$text(
												_List_fromArray(
													[
														$author$project$Ui$Skeleton$spanFromText('Total: $1000.00')
													]))
											]);
									}
								}()),
								A2(
								$elm$html$Html$map,
								$author$project$Components$Reports$Disputes$DateRangeInputMsg,
								$author$project$Components$DateRangeInput$view(model.i4)),
								A2(
								$author$project$Ui$Grid$row,
								_List_fromArray(
									[$author$project$Ui$Grid$gutterSm]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(5),
												$author$project$Ui$Grid$spanSm(3),
												$author$project$Ui$Grid$spanMd(4)
											]),
										_List_fromArray(
											[
												$author$project$Components$Reports$Disputes$viewStatusDropdown(model)
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Components$Reports$Disputes$viewTable(model)
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$Reports$Disputes$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(
											!$author$project$Utils$Maybe$toBool(
												$author$project$Api$Data$toMaybe(model.cD)))
										]),
									model.ajJ))
							]))
					]))
			]);
	});
var $author$project$Pages$Reports$Disputes$view = function (model) {
	return {
		fO: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			A2($author$project$Components$Reports$Disputes$view, model.Gv, model.kV)),
		ac9: 'Reports | Disputes'
	};
};
var $author$project$Pages$Reports$Disputes$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Reports$Disputes$init, aiq: $author$project$Pages$Reports$Disputes$load, k8: $author$project$Pages$Reports$Disputes$save, alO: $author$project$Pages$Reports$Disputes$subscriptions, adT: $author$project$Pages$Reports$Disputes$update, amo: $author$project$Pages$Reports$Disputes$view});
var $author$project$Pages$Reports$Invoices$ReportMsg = $elm$core$Basics$identity;
var $author$project$Components$Reports$Invoices$AutopayDropdownMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Report$CustomerInvoice = 12;
var $author$project$Components$Reports$Invoices$DateRangeInputMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Reports$Invoices$GroupLocationAndPractitionerFiltersMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Reports$Invoices$StatusDropdownMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Reports$Invoices$Disabled = 1;
var $author$project$Components$Reports$Invoices$Enabled = 0;
var $author$project$Components$Reports$Invoices$autopayStatusFromString = function (string) {
	switch (string) {
		case 'enabled':
			return $elm$core$Maybe$Just(0);
		case 'disabled':
			return $elm$core$Maybe$Just(1);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Reports$Invoices$additionalMonthOptions = function (currentDate) {
	return _List_fromArray(
		[
			A4(
			$author$project$Components$DateRangeInput$additionalItem,
			'upcoming',
			'Upcoming',
			$elm$core$Maybe$Just(
				A3($justinmimbs$date$Date$add, 3, 1, currentDate)),
			$elm$core$Maybe$Nothing),
			A4(
			$author$project$Components$DateRangeInput$additionalItem,
			'date_under_30_days',
			'< 30 Days',
			$elm$core$Maybe$Just(
				A3($justinmimbs$date$Date$add, 3, -29, currentDate)),
			$elm$core$Maybe$Just(currentDate)),
			A4(
			$author$project$Components$DateRangeInput$additionalItem,
			'date_30_to_59_days',
			'30 - 59 Days',
			$elm$core$Maybe$Just(
				A3($justinmimbs$date$Date$add, 3, -59, currentDate)),
			$elm$core$Maybe$Just(
				A3($justinmimbs$date$Date$add, 3, -30, currentDate))),
			A4(
			$author$project$Components$DateRangeInput$additionalItem,
			'date_60_plus_days',
			'60+ Days',
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Just(
				A3($justinmimbs$date$Date$add, 3, -60, currentDate)))
		]);
};
var $author$project$Components$Reports$Invoices$dateRangeInputSettings = F2(
	function (start, end) {
		var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
		return _Utils_update(
			defaultSettings,
			{ma: $author$project$Components$Reports$Invoices$additionalMonthOptions, ahy: start, al5: end});
	});
var $author$project$Components$Reports$Invoices$GotCustomerInvoices = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Reports$Invoices$autopayFromString = function (string) {
	switch (string) {
		case 'disabled':
			return $elm$core$Maybe$Just(false);
		case 'enabled':
			return $elm$core$Maybe$Just(true);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Reports$Invoices$autopayStatusToString = function (autopay) {
	if (!autopay) {
		return 'enabled';
	} else {
		return 'disabled';
	}
};
var $author$project$Components$Reports$Invoices$invoiceStatusToString = function (status) {
	switch (status) {
		case 0:
			return 'draft';
		case 1:
			return 'issued';
		case 2:
			return 'issued,sent,retrying';
		case 3:
			return 'paid';
		case 4:
			return 'sent';
		case 5:
			return 'retrying';
		case 6:
			return 'cancelled';
		case 7:
			return 'bad_debt';
		default:
			return 'disputed';
	}
};
var $author$project$Components$Reports$Invoices$fetchParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				Mm: A2(
					$elm$core$Maybe$andThen,
					A2($elm$core$Basics$composeR, $author$project$Components$Reports$Invoices$autopayStatusToString, $author$project$Components$Reports$Invoices$autopayFromString),
					model.Mm),
				HB: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.HB),
				ais: model.We,
				s4: model.gL,
				ajJ: model.ajJ,
				alA: model.alA,
				JV: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.JV),
				alH: A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Reports$Invoices$invoiceStatusToString,
						$elm$core$String$split(',')),
					model.alH)
			});
	};
};
var $author$project$Components$Reports$Invoices$fetchInvoices = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Api$Provider$Reports$CustomerInvoice$list,
			apiClient,
			$author$project$Components$Reports$Invoices$fetchParams(model),
			$author$project$Components$Reports$Invoices$GotCustomerInvoices);
	});
var $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$Closed = {$: 0};
var $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$init = $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$Closed;
var $author$project$Components$Reports$Invoices$initColumns = function (trackPatientsByLocation) {
	return $elm$core$List$concat(
		_List_fromArray(
			[
				_List_fromArray(
				[
					A3($author$project$Api$Column$init, 'date', true, 'Date'),
					A3($author$project$Api$Column$init, 'invoice_number', true, 'Invoice Number'),
					A3($author$project$Api$Column$init, 'status', true, 'Invoice Status'),
					A3($author$project$Api$Column$init, 'total_in_cents', true, 'Billed'),
					A3($author$project$Api$Column$init, 'paid_in_cents', true, 'Paid'),
					A3($author$project$Api$Column$init, 'due_in_cents', true, 'Due'),
					A3($author$project$Api$Column$init, 'owner', true, 'Payer')
				]),
				trackPatientsByLocation ? _List_fromArray(
				[
					A3($author$project$Api$Column$init, 'location', true, 'Location')
				]) : _List_Nil
			]));
};
var $author$project$Components$Reports$Invoices$BadDebt = 7;
var $author$project$Components$Reports$Invoices$Cancelled = 6;
var $author$project$Components$Reports$Invoices$Disputed = 8;
var $author$project$Components$Reports$Invoices$Draft = 0;
var $author$project$Components$Reports$Invoices$Issued = 1;
var $author$project$Components$Reports$Invoices$Outstanding = 2;
var $author$project$Components$Reports$Invoices$Paid = 3;
var $author$project$Components$Reports$Invoices$Retrying = 5;
var $author$project$Components$Reports$Invoices$Sent = 4;
var $author$project$Components$Reports$Invoices$invoiceStatusFromString = function (string) {
	switch (string) {
		case 'draft':
			return $elm$core$Maybe$Just(0);
		case 'issued':
			return $elm$core$Maybe$Just(1);
		case 'issued,sent,retrying':
			return $elm$core$Maybe$Just(2);
		case 'paid':
			return $elm$core$Maybe$Just(3);
		case 'sent':
			return $elm$core$Maybe$Just(4);
		case 'retrying':
			return $elm$core$Maybe$Just(5);
		case 'cancelled':
			return $elm$core$Maybe$Just(6);
		case 'bad_debt':
			return $elm$core$Maybe$Just(7);
		case 'disputed':
			return $elm$core$Maybe$Just(8);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Reports$Invoices$urlFromModel = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('start'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.dd, 0)),
			model.JV),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('end'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.dd, 0)),
			model.HB),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('location_group'),
			model.gL),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('location'),
			model.We),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('status'),
				$author$project$Components$Reports$Invoices$invoiceStatusToString),
			model.alH),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('autopay'),
				$author$project$Components$Reports$Invoices$autopayStatusToString),
			model.Mm)
		]);
	return A2(
		$elm$url$Url$Builder$relative,
		_List_fromArray(
			[
				$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__Invoices)
			]),
		A2(
			$elm$core$List$append,
			$author$project$Api$Pagination$toPageQuery(model.ajJ),
			A2(
				$elm$core$List$append,
				$author$project$Api$Sort$toQuery(model.alA),
				A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams))));
};
var $author$project$Components$Reports$Invoices$init = F4(
	function (session, practice, _v0, query) {
		var currentDate = _v0.dd;
		var timeFormatter = _v0.J7;
		var apiClient = _v0.Gv;
		var url = _v0.adY;
		var hinterViewOff = _v0.ahK;
		var trackPatientsByLocation = $author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice);
		var locationId = A2($elm$core$Dict$get, 'location', query);
		var locationGroupId = A2($elm$core$Dict$get, 'location_group', query);
		var _v1 = A7($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$init, apiClient, session, practice, true, locationGroupId, locationId, $elm$core$Maybe$Nothing);
		var groupLocationAndPractitionerFilters = _v1.a;
		var groupLocationAndPractitionerFiltersCmd = _v1.b;
		var _v2 = $author$project$Utils$DateWithDefault$fromQuery(query);
		var start = _v2.a;
		var end = _v2.b;
		var _v3 = A2(
			$author$project$Components$DateRangeInput$init,
			'date-range-input',
			A2(
				$author$project$Components$Reports$Invoices$dateRangeInputSettings,
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					start),
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					end)));
		var dateRangeInput = _v3.a;
		var dateRangeInputCmd = _v3.b;
		var model = {
			Mm: A2(
				$elm$core$Maybe$andThen,
				$author$project$Components$Reports$Invoices$autopayStatusFromString,
				A2($elm$core$Dict$get, 'autopay', query)),
			mp: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'autopay-dropdown', al6: $author$project$Components$Reports$Invoices$AutopayDropdownMsg})),
			rw: false,
			GQ: A3($author$project$Permission$canGoTo, session, hinterViewOff, 50),
			N3: $author$project$Components$Reports$Invoices$initColumns(trackPatientsByLocation),
			dd: currentDate,
			m5: $author$project$Components$CustomerEmailModal$init,
			m7: $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$init,
			ct: $author$project$Api$Data$Loading,
			i4: dateRangeInput,
			jt: $author$project$Components$Invoice$DownloadFile$init(url),
			HB: end,
			nD: $author$project$Components$ExportCsv$initForPractice(12),
			dn: groupLocationAndPractitionerFilters,
			gL: locationGroupId,
			We: locationId,
			ajJ: $author$project$Api$Pagination$initFromQuery(query),
			Jc: $author$project$Api$Provider$Practice$One$deactivated(practice),
			aa4: session,
			alA: A3(
				$author$project$Api$Sort$withDefault,
				'date',
				1,
				$author$project$Api$Sort$initFromQuery(query)),
			JV: start,
			alH: A2(
				$elm$core$Maybe$andThen,
				$author$project$Components$Reports$Invoices$invoiceStatusFromString,
				A2($elm$core$Dict$get, 'status', query)),
			qn: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'status-dropdown', al6: $author$project$Components$Reports$Invoices$StatusDropdownMsg})),
			J7: timeFormatter,
			adt: trackPatientsByLocation
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Invoices$DateRangeInputMsg, dateRangeInputCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Invoices$GroupLocationAndPractitionerFiltersMsg, groupLocationAndPractitionerFiltersCmd),
						A2($author$project$Components$Reports$Invoices$fetchInvoices, apiClient, model),
						$author$project$Ports$Navigation$replaceUrl(
						$author$project$Components$Reports$Invoices$urlFromModel(model))
					])));
	});
var $author$project$Pages$Reports$Invoices$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.DE;
		var _v1 = A4($author$project$Components$Reports$Invoices$init, session, practice, shared, query);
		var report = _v1.a;
		var reportCmd = _v1.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, kV: report},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportCmd));
	});
var $author$project$Pages$Reports$Invoices$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$Invoices$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Reports$Invoices$CustomerEmailModalMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Reports$Invoices$CustomerInvoiceBulkPaymentModalMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Reports$Invoices$DownloadInvoiceMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Reports$Invoices$ExportCsvMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$Close = {$: 2};
var $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$subscriptions = function (model) {
	if (model.$ === 1) {
		return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$Close);
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Components$Reports$Invoices$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$Invoices$DateRangeInputMsg,
				$author$project$Components$DateRangeInput$subscriptions(model.i4)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$Invoices$CustomerEmailModalMsg,
				$author$project$Components$CustomerEmailModal$subscriptions(model.m5)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$Invoices$CustomerInvoiceBulkPaymentModalMsg,
				$author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$subscriptions(model.m7)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$Invoices$ExportCsvMsg,
				$author$project$Components$ExportCsv$subscriptions(model.nD)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$Invoices$DownloadInvoiceMsg,
				$author$project$Components$Invoice$DownloadFile$subscriptions(model.jt)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$Invoices$GroupLocationAndPractitionerFiltersMsg,
				$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$subscriptions(model.dn)),
				$author$project$Ui$Dropdown$subscriptions(model.qn),
				$author$project$Ui$Dropdown$subscriptions(model.mp)
			]));
};
var $author$project$Pages$Reports$Invoices$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Reports$Invoices$subscriptions(model.kV));
};
var $author$project$Components$Reports$Invoices$BulkIssueTriggered = {$: 12};
var $author$project$Api$Provider$CustomerInvoice$Bulk$bulkPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['customer_invoices', 'bulk']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$CustomerInvoice$Bulk$issue = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Reports$CustomerInvoice$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['issue']),
						$author$project$Api$Provider$CustomerInvoice$Bulk$bulkPath))));
	});
var $author$project$Components$Reports$Invoices$issueInvoices = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Api$Provider$CustomerInvoice$Bulk$issue,
			apiClient,
			$author$project$Components$Reports$Invoices$fetchParams(model),
			$elm$core$Basics$always($author$project$Components$Reports$Invoices$BulkIssueTriggered));
	});
var $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$BulkProcessPaymentsStarted = 1;
var $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$None = 0;
var $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$Open = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$CustomerInvoice$Bulk$processPayments = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Reports$CustomerInvoice$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['process_payments']),
						$author$project$Api$Provider$CustomerInvoice$Bulk$bulkPath))));
	});
var $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$update = F2(
	function (msg, model) {
		if (model.$ === 1) {
			var open = model.a;
			switch (msg.$) {
				case 2:
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$Closed, aR: _List_Nil};
				case 0:
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				default:
					return {
						GZ: A3(
							$author$project$Api$Provider$CustomerInvoice$Bulk$processPayments,
							open.Gv,
							open.YL,
							$elm$core$Basics$always($author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$Close)),
						agZ: 1,
						aiO: model,
						aR: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Bulk process payments started. This may take a while to process.')
							])
					};
			}
		} else {
			if (!msg.$) {
				var apiClient = msg.a;
				var params = msg.b;
				var totalCount = msg.c;
				var status = msg.d;
				var start = msg.e;
				var end = msg.f;
				var currentDate = msg.g;
				var open = {Gv: apiClient, dd: currentDate, HB: end, YL: params, JV: start, alH: status, qC: totalCount};
				return {
					GZ: $elm$core$Platform$Cmd$none,
					agZ: 0,
					aiO: $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$Open(open),
					aR: _List_Nil
				};
			} else {
				return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
			}
		}
	});
var $author$project$Components$Reports$Invoices$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Components$DateRangeInput$update, subMsg, model.i4);
				var dateRangeInput = _v1.a;
				var subCmd = _v1.b;
				var event = _v1.c;
				var newModel = function () {
					if (event.$ === 1) {
						var fromDate = event.a;
						var toDate = event.b;
						return _Utils_update(
							model,
							{
								ct: $author$project$Api$Data$Loading,
								i4: dateRangeInput,
								HB: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
								ajJ: $author$project$Api$Pagination$reset(model.ajJ),
								JV: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
							});
					} else {
						return _Utils_update(
							model,
							{i4: dateRangeInput});
					}
				}();
				var cmds = (_Utils_eq(newModel.JV, model.JV) && _Utils_eq(newModel.HB, model.HB)) ? _List_Nil : _List_fromArray(
					[
						A2($author$project$Components$Reports$Invoices$fetchInvoices, apiClient, newModel),
						A2($elm$core$Basics$composeR, $author$project$Components$Reports$Invoices$urlFromModel, $author$project$Ports$Navigation$pushUrl)(newModel)
					]);
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$cons,
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Invoices$DateRangeInputMsg, subCmd),
							cmds)),
					_List_Nil);
			case 1:
				var subMsg = msg.a;
				var result = A3($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$update, apiClient, subMsg, model.dn);
				var _v3 = result.agZ;
				if (!_v3.$) {
					var locationGroupId = _v3.a;
					var locationId = _v3.b;
					var newModel = _Utils_update(
						model,
						{
							ct: $author$project$Api$Data$Loading,
							dn: result.aiO,
							gL: locationGroupId,
							We: locationId,
							ajJ: $author$project$Api$Pagination$reset(model.ajJ)
						});
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Invoices$GroupLocationAndPractitionerFiltersMsg, result.GZ),
									A2($author$project$Components$Reports$Invoices$fetchInvoices, apiClient, newModel),
									A2($elm$core$Basics$composeR, $author$project$Components$Reports$Invoices$urlFromModel, $author$project$Ports$Navigation$pushUrl)(newModel)
								])),
						result.aR);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dn: result.aiO}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Invoices$GroupLocationAndPractitionerFiltersMsg, result.GZ),
						result.aR);
				}
			case 2:
				var subMsg = msg.a;
				var _v4 = A2($author$project$Ui$Dropdown$update, subMsg, model.qn);
				var statusDropdown = _v4.a;
				var cmd = _v4.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qn: statusDropdown}),
					cmd,
					_List_Nil);
			case 3:
				var status = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ct: $author$project$Api$Data$Loading,
						ajJ: $author$project$Api$Pagination$reset(model.ajJ),
						alH: status
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$Invoices$fetchInvoices, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$Invoices$urlFromModel, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 4:
				var subMsg = msg.a;
				var _v5 = A2($author$project$Ui$Dropdown$update, subMsg, model.mp);
				var autopayDropdown = _v5.a;
				var cmd = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{mp: autopayDropdown}),
					cmd,
					_List_Nil);
			case 5:
				var autopay = msg.a;
				var newModel = _Utils_update(
					model,
					{
						Mm: autopay,
						ct: $author$project$Api$Data$Loading,
						ajJ: $author$project$Api$Pagination$reset(model.ajJ)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$Invoices$fetchInvoices, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$Invoices$urlFromModel, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 6:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								rw: false,
								ct: response,
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ct: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 7:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{ct: $author$project$Api$Data$Loading, ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$Invoices$fetchInvoices, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$Invoices$urlFromModel, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 8:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						alA: A2($author$project$Api$Sort$update, columnId, model.alA)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$Invoices$fetchInvoices, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$Invoices$urlFromModel, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 9:
				var subMsg = msg.a;
				var _v7 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.nD);
				var exportCsv = _v7.a;
				var subCmd = _v7.b;
				var subOutMsg = _v7.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nD: exportCsv}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Invoices$ExportCsvMsg, subCmd),
					subOutMsg);
			case 10:
				var subMsg = msg.a;
				var _v8 = A3($author$project$Components$CustomerEmailModal$update, apiClient, subMsg, model.m5);
				var customerEmailModal = _v8.a;
				var subCmd = _v8.b;
				var subOutMsg = _v8.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{m5: customerEmailModal}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Invoices$CustomerEmailModalMsg, subCmd),
					subOutMsg);
			case 11:
				var subMsg = msg.a;
				var downloadInvoiceResult = A3($author$project$Components$Invoice$DownloadFile$update, apiClient, subMsg, model.jt);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{jt: downloadInvoiceResult.aiO}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Invoices$DownloadInvoiceMsg, downloadInvoiceResult.GZ),
					downloadInvoiceResult.aR);
			case 13:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{rw: true}),
					A2($author$project$Components$Reports$Invoices$issueInvoices, apiClient, model),
					_List_Nil);
			case 12:
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					_List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 3, 'Bulk issue invoices started. This may take a while to process.')
						]));
			default:
				var subMsg = msg.a;
				var customerInvoiceBulkPaymentModalResult = A2($author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$update, subMsg, model.m7);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{m7: customerInvoiceBulkPaymentModalResult.aiO}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Invoices$CustomerInvoiceBulkPaymentModalMsg, customerInvoiceBulkPaymentModalResult.GZ),
					customerInvoiceBulkPaymentModalResult.aR);
		}
	});
var $author$project$Pages$Reports$Invoices$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Reports$Invoices$update, model.Gv, subMsg, model.kV);
		var report = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{kV: report}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Components$Reports$Invoices$PaginationMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Reports$Invoices$intFromHeader = F2(
	function (headers, name) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$String$toInt,
				A2($elm$core$Dict$get, name, headers)));
	});
var $author$project$Components$Reports$Invoices$IssueButtonClicked = {$: 13};
var $author$project$Components$Reports$Invoices$viewIssueButton = function (bulkIssueTriggered) {
	return bulkIssueTriggered ? $author$project$Utils$Html$empty : A3(
		$author$project$Ui$Button$view,
		{mm: 'Issue invoices'},
		_List_fromArray(
			[
				$author$project$Ui$Button$primary,
				$author$project$Ui$Button$onClick($author$project$Components$Reports$Invoices$IssueButtonClicked)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Issue Invoices')
			]));
};
var $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$OpenModal = F7(
	function (a, b, c, d, e, f, g) {
		return {$: 0, a: a, b: b, c: c, d: d, e: e, f: f, g: g};
	});
var $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$button = F7(
	function (apiClient, params, totalCount, status, start, end, currentDate) {
		return A3(
			$author$project$Ui$Button$view,
			{mm: 'Process payments'},
			_List_fromArray(
				[
					$author$project$Ui$Button$success,
					$author$project$Ui$Button$onClick(
					A7($author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$OpenModal, apiClient, params, totalCount, status, start, end, currentDate))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('$ Process Payments')
				]));
	});
var $author$project$Components$Reports$Invoices$viewProcessPaymentsButton = F2(
	function (apiClient, model) {
		return A2(
			$elm$html$Html$map,
			$author$project$Components$Reports$Invoices$CustomerInvoiceBulkPaymentModalMsg,
			A7(
				$author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$button,
				apiClient,
				$author$project$Components$Reports$Invoices$fetchParams(model),
				$author$project$Api$Pagination$headerTotalCount(model.ajJ),
				A2($elm$core$Maybe$map, $author$project$Components$Reports$Invoices$invoiceStatusToString, model.alH),
				model.JV,
				model.HB,
				model.dd));
	});
var $author$project$Components$Reports$Invoices$issueOrProcessPaymentButton = F2(
	function (apiClient, model) {
		var anyInvoices = function () {
			var _v6 = model.ct;
			if (_v6.$ === 3) {
				var customerInvoices = _v6.a;
				return !$elm$core$List$isEmpty(customerInvoices);
			} else {
				return false;
			}
		}();
		var _v0 = _Utils_Tuple2(model.alH, anyInvoices);
		_v0$5:
		while (true) {
			if ((!_v0.a.$) && _v0.b) {
				switch (_v0.a.a) {
					case 0:
						var _v1 = _v0.a.a;
						return $author$project$Components$Reports$Invoices$viewIssueButton(model.rw);
					case 1:
						var _v2 = _v0.a.a;
						return A2($author$project$Components$Reports$Invoices$viewProcessPaymentsButton, apiClient, model);
					case 4:
						var _v3 = _v0.a.a;
						return A2($author$project$Components$Reports$Invoices$viewProcessPaymentsButton, apiClient, model);
					case 5:
						var _v4 = _v0.a.a;
						return A2($author$project$Components$Reports$Invoices$viewProcessPaymentsButton, apiClient, model);
					case 2:
						var _v5 = _v0.a.a;
						return A2($author$project$Components$Reports$Invoices$viewProcessPaymentsButton, apiClient, model);
					default:
						break _v0$5;
				}
			} else {
				break _v0$5;
			}
		}
		return $author$project$Utils$Html$empty;
	});
var $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$BulkProcessPaymentsClicked = {$: 1};
var $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$formatDateRange = F3(
	function (start, end, currentDate) {
		var startDate = function () {
			if (!start.$) {
				var date = start.a;
				return A2(
					$author$project$Formatters$Date$toString,
					$author$project$Formatters$Date$Full,
					A3($author$project$Utils$DateWithDefault$toDate, currentDate, 0, date));
			} else {
				return '';
			}
		}();
		var endDate = function () {
			if (!end.$) {
				var date = end.a;
				return A2(
					$author$project$Formatters$Date$toString,
					$author$project$Formatters$Date$Full,
					A3($author$project$Utils$DateWithDefault$toDate, currentDate, 0, date));
			} else {
				return '';
			}
		}();
		var _v0 = _Utils_Tuple2(
			$elm$core$String$isEmpty(startDate),
			$elm$core$String$isEmpty(endDate));
		if (_v0.a) {
			if (!_v0.b) {
				return $elm$html$Html$text(' < ' + endDate);
			} else {
				return $elm$html$Html$text('All Dates');
			}
		} else {
			if (!_v0.b) {
				return $elm$html$Html$text(startDate + (' - ' + endDate));
			} else {
				return $elm$html$Html$text(startDate + ' > ');
			}
		}
	});
var $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$viewMovePaymentMethodsModal = function (open) {
	return A2(
		$author$project$Ui$Form$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$noValidate(true),
				$author$project$Ui$Form$autocomplete(true),
				$author$project$Ui$Form$onSubmit($author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$Close)
			]),
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Modal$view,
				$author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$Close,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Modal$header(
						_List_fromArray(
							[
								$author$project$Ui$Modal$title('Process Payments')
							])),
						$author$project$Ui$Modal$body(
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$labelSpanSm(3),
												$author$project$Ui$Form$Group$inputSpanSm(9),
												$author$project$Ui$Form$Group$label('Enabled Filters')
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Static$view,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Element$view,
														_List_Nil,
														_List_fromArray(
															[
																A3($author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$formatDateRange, open.JV, open.HB, open.dd)
															])),
														A2(
														$author$project$Ui$Typography$text,
														_List_fromArray(
															[$author$project$Ui$Typography$capitalized]),
														function () {
															var _v0 = open.alH;
															if (!_v0.$) {
																var status = _v0.a;
																return A2(
																	$elm$core$String$join,
																	', ',
																	A2($elm$core$String$split, ',', status));
															} else {
																return '';
															}
														}())
													]))
											])),
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$labelSpanSm(3),
												$author$project$Ui$Form$Group$inputSpanSm(9),
												$author$project$Ui$Form$Group$label('Invoices to Process')
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Static$view,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$text,
														_List_fromArray(
															[$author$project$Ui$Typography$bold]),
														$elm$core$String$fromInt(open.qC) + ' patient invoices')
													]))
											])),
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$mt1, $author$project$Ui$Element$mb2]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Alert$info,
												_List_fromArray(
													[
														$author$project$Ui$Alert$alignment($author$project$Ui$Alignment$textLeft)
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Element$view,
														_List_fromArray(
															[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap]),
														_List_fromArray(
															[
																$author$project$Ui$Icon$alert(
																_List_fromArray(
																	[$author$project$Ui$Icon$xl])),
																A2(
																$author$project$Ui$Typography$text,
																_List_fromArray(
																	[$author$project$Ui$Typography$black]),
																'You will receive an email notification for payments that fail to process.')
															]))
													]))
											]))
									]))
							])),
						$author$project$Ui$Modal$footer(
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$textRight, $author$project$Ui$Element$gap2]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Cancel and close modal'},
										_List_fromArray(
											[
												$author$project$Ui$Button$onClick($author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$Close)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cancel')
											])),
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Process payments'},
										_List_fromArray(
											[
												$author$project$Ui$Button$success,
												$author$project$Ui$Button$submit,
												$author$project$Ui$Button$onClick($author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$BulkProcessPaymentsClicked),
												$author$project$Ui$Button$icon($author$project$Ui$Icon$bolt)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												' Process ' + ($elm$core$String$fromInt(open.qC) + ' payments'))
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$modal = function (model) {
	if (model.$ === 1) {
		var open = model.a;
		return $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$viewMovePaymentMethodsModal(open);
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Reports$Invoices$AutopaySelected = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Reports$Invoices$autopayToDisplayName = function (autopay) {
	if (!autopay) {
		return 'Autopay Enabled';
	} else {
		return 'Autopay Disabled';
	}
};
var $author$project$Components$Reports$Invoices$autopayDropdownItems = function (current) {
	var toItem = function (autopay) {
		return A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Components$Reports$Invoices$AutopaySelected(
						$elm$core$Maybe$Just(autopay))),
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(
						current,
						$elm$core$Maybe$Just(autopay)))
				]),
			$elm$html$Html$text(
				$author$project$Components$Reports$Invoices$autopayToDisplayName(autopay)));
	};
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Components$Reports$Invoices$AutopaySelected($elm$core$Maybe$Nothing)),
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(current, $elm$core$Maybe$Nothing))
				]),
			$elm$html$Html$text('All Autopay')),
			$author$project$Ui$Dropdown$separator,
			toItem(0),
			toItem(1)
		]);
};
var $author$project$Components$Reports$Invoices$viewAutopayDropdown = function (model) {
	var placeholder = function () {
		var _v0 = model.Mm;
		if (!_v0.$) {
			var autopay = _v0.a;
			return $author$project$Components$Reports$Invoices$autopayToDisplayName(autopay);
		} else {
			return 'Autopay';
		}
	}();
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(placeholder)
			]),
		$author$project$Components$Reports$Invoices$autopayDropdownItems(model.Mm),
		model.mp);
};
var $author$project$Components$Reports$Invoices$StatusSelected = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Reports$Invoices$statusToDisplayName = function (status) {
	switch (status) {
		case 0:
			return 'Draft';
		case 1:
			return 'Issued (Not Sent)';
		case 2:
			return 'Outstanding (Issued, Sent, Retrying)';
		case 3:
			return 'Paid';
		case 4:
			return 'Sent';
		case 5:
			return 'Retrying';
		case 6:
			return 'Cancelled';
		case 7:
			return 'Bad Debt';
		default:
			return 'Disputed';
	}
};
var $author$project$Components$Reports$Invoices$statusDropdownItems = function (current) {
	var toItem = function (status) {
		return A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Components$Reports$Invoices$StatusSelected(
						$elm$core$Maybe$Just(status))),
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(
						current,
						$elm$core$Maybe$Just(status)))
				]),
			$elm$html$Html$text(
				$author$project$Components$Reports$Invoices$statusToDisplayName(status)));
	};
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Components$Reports$Invoices$StatusSelected($elm$core$Maybe$Nothing)),
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(current, $elm$core$Maybe$Nothing))
				]),
			$elm$html$Html$text('All Statuses')),
			$author$project$Ui$Dropdown$separator,
			toItem(0),
			toItem(1),
			toItem(2),
			$author$project$Ui$Dropdown$separator,
			toItem(3),
			toItem(4),
			toItem(5),
			toItem(6),
			toItem(7),
			toItem(8)
		]);
};
var $author$project$Components$Reports$Invoices$viewStatusDropdown = function (model) {
	var placeholder = function () {
		var _v0 = model.alH;
		if (!_v0.$) {
			var status = _v0.a;
			return $author$project$Components$Reports$Invoices$statusToDisplayName(status);
		} else {
			return 'Status';
		}
	}();
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(placeholder)
			]),
		$author$project$Components$Reports$Invoices$statusDropdownItems(model.alH),
		model.qn);
};
var $author$project$Components$Reports$Invoices$SortTable = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$CustomerEmailModal$ReportsPatient = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Table$Warning = 2;
var $author$project$Api$Provider$Reports$CustomerInvoice$creditInCents = function (_v0) {
	var record = _v0;
	return record.O7;
};
var $author$project$Components$CustomerEmailModal$Disabled = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$CustomerEmailModal$disabled = $author$project$Components$CustomerEmailModal$Disabled;
var $author$project$Api$Provider$Reports$CustomerInvoice$dueDate = function (_v0) {
	var record = _v0;
	return record.QX;
};
var $author$project$Api$Provider$Reports$CustomerInvoice$dueInCents = function (_v0) {
	var record = _v0;
	return record.QY;
};
var $author$project$Api$Provider$Reports$CustomerInvoice$humanStatus = function (_v0) {
	var record = _v0;
	return record.TH;
};
var $author$project$Api$Provider$Reports$CustomerInvoice$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Reports$CustomerInvoice$invoiceNumber = function (_v0) {
	var record = _v0;
	return record.Uu;
};
var $author$project$Api$Provider$Reports$CustomerInvoice$isCustomerViewable = function (_v0) {
	var record = _v0;
	return record.UK;
};
var $author$project$Api$Provider$Reports$CustomerInvoice$isPastDue = function (_v0) {
	var record = _v0;
	return record.U1;
};
var $author$project$Api$Provider$Reports$CustomerInvoice$isPaymentScheduled = function (_v0) {
	var record = _v0;
	return record.U3;
};
var $author$project$Api$Provider$Reports$CustomerInvoice$issuedTotalInCents = function (_v0) {
	var record = _v0;
	return record.Vs;
};
var $author$project$Api$Provider$Reports$CustomerInvoice$lastSentAt = function (_v0) {
	var record = _v0;
	return record.VL;
};
var $author$project$Api$Provider$Reports$CustomerInvoice$location = function (_v0) {
	var record = _v0;
	return record.ais;
};
var $author$project$Api$Provider$Reports$Patient$onePhoneNumber = function (_v0) {
	var record = _v0;
	return record.Zx;
};
var $author$project$Api$Provider$Reports$CustomerInvoice$owner = function (_v0) {
	var record = _v0;
	return record.YD;
};
var $author$project$Api$Provider$Reports$CustomerInvoice$paidAt = function (_v0) {
	var record = _v0;
	return record.YH;
};
var $author$project$Api$Provider$Reports$CustomerInvoice$paidInCents = function (_v0) {
	var record = _v0;
	return record.YI;
};
var $author$project$Api$Provider$Reports$CustomerInvoice$paymentScheduledOn = function (_v0) {
	var record = _v0;
	return record.Zf;
};
var $author$project$Api$Provider$Reports$CustomerInvoice$securePdfInlineToken = function (_v0) {
	var record = _v0;
	return record.aaE;
};
var $author$project$Api$Provider$Reports$CustomerInvoice$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Api$Provider$Reports$CustomerInvoice$totalInCents = function (_v0) {
	var record = _v0;
	return record.adp;
};
var $author$project$Components$Reports$Invoices$viewRow = F2(
	function (model, customerInvoice) {
		var isPastDue = $author$project$Api$Provider$Reports$CustomerInvoice$isPastDue(customerInvoice);
		return A2(
			$author$project$Ui$Table$row,
			isPastDue ? _List_fromArray(
				[
					$author$project$Ui$Table$styled(2)
				]) : _List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$text,
									isPastDue ? _List_fromArray(
										[$author$project$Ui$Typography$danger]) : _List_Nil,
									A2(
										$author$project$Formatters$Date$toString,
										$author$project$Formatters$Date$Full,
										$author$project$Api$Provider$Reports$CustomerInvoice$dueDate(customerInvoice)))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							function () {
								var _v0 = _Utils_Tuple2(
									model.GQ,
									$author$project$Api$Provider$Reports$CustomerInvoice$owner(customerInvoice));
								if (_v0.a && (!_v0.b.$)) {
									var owner = _v0.b.a;
									return _List_fromArray(
										[
											A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top(
												{
													Us: $author$project$Api$Provider$Reports$CustomerInvoice$id(customerInvoice),
													YZ: $author$project$Api$Provider$Reports$Patient$oneId(owner)
												}),
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													'#' + $elm$core$String$fromInt(
														$author$project$Api$Provider$Reports$CustomerInvoice$invoiceNumber(customerInvoice)))
												]))
										]);
								} else {
									return _List_fromArray(
										[
											$elm$html$Html$text(
											'#' + $elm$core$String$fromInt(
												$author$project$Api$Provider$Reports$CustomerInvoice$invoiceNumber(customerInvoice)))
										]);
								}
							}()),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									function () {
									var _v1 = _Utils_Tuple2(
										model.GQ,
										$author$project$Api$Provider$Reports$CustomerInvoice$owner(customerInvoice));
									if (_v1.a && (!_v1.b.$)) {
										var owner = _v1.b.a;
										return A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top(
												{
													Us: $author$project$Api$Provider$Reports$CustomerInvoice$id(customerInvoice),
													YZ: $author$project$Api$Provider$Reports$Patient$oneId(owner)
												}),
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Badge$fromString,
													_List_Nil,
													$author$project$Api$Provider$Reports$CustomerInvoice$humanStatus(customerInvoice))
												]));
									} else {
										return A2(
											$author$project$Ui$Badge$fromString,
											_List_Nil,
											$author$project$Api$Provider$Reports$CustomerInvoice$humanStatus(customerInvoice));
									}
								}(),
									$author$project$Api$Provider$Reports$CustomerInvoice$isPaymentScheduled(customerInvoice) ? A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$small]),
									' scheduled for ' + A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
											$author$project$Api$Provider$Reports$CustomerInvoice$paymentScheduledOn(customerInvoice)))) : (($author$project$Api$Provider$Reports$CustomerInvoice$status(customerInvoice) === 'sent') ? A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$small]),
									' on ' + A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											model.J7(5),
											$author$project$Api$Provider$Reports$CustomerInvoice$lastSentAt(customerInvoice)))) : (($author$project$Api$Provider$Reports$CustomerInvoice$humanStatus(customerInvoice) === 'paid') ? A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$small]),
									' on ' + A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											model.J7(5),
											$author$project$Api$Provider$Reports$CustomerInvoice$paidAt(customerInvoice)))) : $author$project$Utils$Html$empty))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									($author$project$Api$Provider$Reports$CustomerInvoice$status(customerInvoice) === 'draft') ? A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$muted]),
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$Reports$CustomerInvoice$issuedTotalInCents(customerInvoice))) : A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											(!_Utils_eq(
											$author$project$Api$Provider$Reports$CustomerInvoice$issuedTotalInCents(customerInvoice),
											$author$project$Api$Provider$Reports$CustomerInvoice$totalInCents(customerInvoice))) ? A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[$author$project$Ui$Typography$muted]),
											$author$project$Utils$Currency$fromInt(
												$author$project$Api$Provider$Reports$CustomerInvoice$issuedTotalInCents(customerInvoice))) : $author$project$Utils$Html$empty,
											$elm$html$Html$text(
											$author$project$Utils$Currency$fromInt(
												$author$project$Api$Provider$Reports$CustomerInvoice$totalInCents(customerInvoice)))
										]))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$Reports$CustomerInvoice$paidInCents(customerInvoice) + $author$project$Api$Provider$Reports$CustomerInvoice$creditInCents(customerInvoice)))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$Reports$CustomerInvoice$dueInCents(customerInvoice)))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							function () {
								var _v2 = $author$project$Api$Provider$Reports$CustomerInvoice$owner(customerInvoice);
								if (!_v2.$) {
									var owner = _v2.a;
									return _List_fromArray(
										[
											model.GQ ? A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
												{
													YZ: $author$project$Api$Provider$Reports$Patient$oneId(owner)
												}),
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$text,
													_List_fromArray(
														[
															$author$project$Ui$Typography$phi(true)
														]),
													$author$project$Api$Provider$Reports$Patient$oneName(owner))
												])) : A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[
													$author$project$Ui$Typography$phi(true)
												]),
											$author$project$Api$Provider$Reports$Patient$oneName(owner)),
											A2($elm$html$Html$br, _List_Nil, _List_Nil),
											function () {
											var _v3 = $author$project$Api$Provider$Reports$Patient$oneEmail(owner);
											if (!_v3.$) {
												var email = _v3.a;
												return A3(
													$author$project$Ui$Link$mailto,
													email,
													_List_fromArray(
														[$author$project$Ui$Link$targetBlank]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Typography$text,
															_List_fromArray(
																[
																	$author$project$Ui$Typography$phi(true)
																]),
															email)
														]));
											} else {
												return $author$project$Utils$Html$empty;
											}
										}(),
											A2($elm$html$Html$br, _List_Nil, _List_Nil),
											A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[
													$author$project$Ui$Typography$phi(true)
												]),
											A2(
												$elm$core$Maybe$withDefault,
												'',
												A2(
													$elm$core$Maybe$map,
													$author$project$Formatters$Phone$format,
													$author$project$Api$Provider$Reports$Patient$onePhoneNumber(owner))))
										]);
								} else {
									return _List_Nil;
								}
							}())
						]),
						model.adt ? _List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											$author$project$Api$Provider$Location$Min$name,
											$author$project$Api$Provider$Reports$CustomerInvoice$location(customerInvoice))))
								]))
						]) : _List_Nil,
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_fromArray(
								[
									$author$project$Ui$Table$colspan(2)
								]),
							$author$project$Api$Provider$Reports$CustomerInvoice$isCustomerViewable(customerInvoice) ? _List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$gap2, $author$project$Ui$Element$flexCol, $author$project$Ui$Element$itemsEnd]),
									_List_fromArray(
										[
											function () {
											var _v4 = $author$project$Api$Provider$Reports$CustomerInvoice$owner(customerInvoice);
											if (!_v4.$) {
												var owner = _v4.a;
												return A2(
													$elm$html$Html$map,
													$author$project$Components$Reports$Invoices$CustomerEmailModalMsg,
													A5(
														$author$project$Components$CustomerEmailModal$button,
														model.aa4,
														_List_fromArray(
															[
																$author$project$Components$CustomerEmailModal$disabled(model.Jc)
															]),
														0,
														$author$project$Api$Provider$Reports$CustomerInvoice$id(customerInvoice),
														$author$project$Components$CustomerEmailModal$ReportsPatient(owner)));
											} else {
												return $author$project$Utils$Html$empty;
											}
										}(),
											A2(
											$elm$html$Html$map,
											$author$project$Components$Reports$Invoices$DownloadInvoiceMsg,
											A4(
												$author$project$Components$Invoice$DownloadFile$view,
												model.jt,
												$author$project$Api$Provider$Reports$CustomerInvoice$securePdfInlineToken(customerInvoice),
												_List_Nil,
												_List_fromArray(
													[$author$project$Ui$Button$sm])))
										]))
								]) : _List_Nil)
						])
					])));
	});
var $author$project$Components$Reports$Invoices$viewTable = function (model) {
	var _v0 = function () {
		var _v1 = model.ct;
		if (_v1.$ === 3) {
			var invoices_ = _v1.a;
			return _Utils_Tuple2(false, invoices_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var customerInvoices = _v0.b;
	return A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$map,
					$author$project$Api$Column$view(
						A2($author$project$Api$Column$Sortable, model.alA, $author$project$Components$Reports$Invoices$SortTable)),
					model.N3),
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[$author$project$Ui$Table$textRight]),
						_List_fromArray(
							[
								A2($elm$html$Html$map, $author$project$Components$Reports$Invoices$ExportCsvMsg, $author$project$Components$ExportCsv$button)
							]))
					])
				])),
		A2(
			$elm$core$List$map,
			$author$project$Components$Reports$Invoices$viewRow(model),
			customerInvoices),
		_List_Nil);
};
var $author$project$Components$Reports$Invoices$view = F2(
	function (apiClient, model) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Reports$Invoices$ExportCsvMsg,
				A3(
					$author$project$Components$ExportCsv$modal,
					apiClient,
					_List_fromArray(
						[
							$author$project$Components$ExportCsv$report(
							$author$project$Api$Data$totalCount(model.ct)),
							$author$project$Components$ExportCsv$reportParams(
							A2($elm$core$Basics$composeL, $author$project$Api$Provider$Reports$CustomerInvoice$listOptionsToParams, $author$project$Components$Reports$Invoices$fetchParams)(model))
						]),
					model.nD)),
				A2(
				$elm$html$Html$map,
				$author$project$Components$Reports$Invoices$CustomerEmailModalMsg,
				$author$project$Components$CustomerEmailModal$modal(model.m5)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween]),
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Patient Invoices')
											])),
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$gap2]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Components$Reports$Invoices$CustomerInvoiceBulkPaymentModalMsg,
												$author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$modal(model.m7)),
												A2($author$project$Components$Reports$Invoices$issueOrProcessPaymentButton, apiClient, model)
											]))
									])),
								A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								function () {
									var _v0 = model.ct;
									if (_v0.$ === 3) {
										var headers = _v0.b;
										var totalReceivableAmount = A2($author$project$Components$Reports$Invoices$intFromHeader, headers, 'x-total-receivable-amount');
										return _List_fromArray(
											[
												$author$project$Ui$Typography$headingSm(
												_List_fromArray(
													[
														$elm$html$Html$text(
														'Total: ' + $author$project$Utils$Currency$fromInt(
															A2($author$project$Components$Reports$Invoices$intFromHeader, headers, 'x-total-billed-amount')))
													])),
												(totalReceivableAmount > 0) ? $author$project$Ui$Typography$headingSm(
												_List_fromArray(
													[
														$elm$html$Html$text(
														'Total Due: ' + $author$project$Utils$Currency$fromInt(totalReceivableAmount))
													])) : $author$project$Utils$Html$empty
											]);
									} else {
										return _List_fromArray(
											[
												$author$project$Ui$Spinner$view(_List_Nil)
											]);
									}
								}()),
								A2(
								$elm$html$Html$map,
								$author$project$Components$Reports$Invoices$DateRangeInputMsg,
								$author$project$Components$DateRangeInput$view(model.i4)),
								A2(
								$author$project$Ui$Grid$row,
								_List_fromArray(
									[$author$project$Ui$Grid$gutterSm]),
								_Utils_ap(
									A2(
										$elm$core$List$map,
										A2(
											$elm$core$Basics$composeR,
											$elm$core$List$singleton,
											$author$project$Ui$Grid$column(
												_List_fromArray(
													[
														$author$project$Ui$Grid$span(6),
														$author$project$Ui$Grid$spanMd(4)
													]))),
										A2(
											$elm$core$List$map,
											$elm$html$Html$map($author$project$Components$Reports$Invoices$GroupLocationAndPractitionerFiltersMsg),
											A2(
												$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$view,
												_List_fromArray(
													[$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$multi]),
												model.dn))),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$span(6),
													$author$project$Ui$Grid$spanSm(4),
													$author$project$Ui$Grid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$Invoices$viewStatusDropdown(model)
												])),
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$span(5),
													$author$project$Ui$Grid$spanSm(3),
													$author$project$Ui$Grid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$Invoices$viewAutopayDropdown(model)
												]))
										]))),
								A2(
								$author$project$Ui$Grid$row,
								_List_fromArray(
									[$author$project$Ui$Grid$gutterSm]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_Nil,
										function () {
											var activeFilters = A2(
												$elm$core$List$map,
												$elm$html$Html$map($author$project$Components$Reports$Invoices$GroupLocationAndPractitionerFiltersMsg),
												$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewMultiSelected(model.dn));
											return $elm$core$List$isEmpty(activeFilters) ? _List_Nil : _List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$mt2, $author$project$Ui$Element$mb2]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$strong,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Active filters')
																]))
														])),
													A2($elm$html$Html$span, _List_Nil, activeFilters)
												]);
										}())
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Components$Reports$Invoices$viewTable(model)
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$Reports$Invoices$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(
											!$author$project$Utils$Maybe$toBool(
												$author$project$Api$Data$toMaybe(model.ct)))
										]),
									model.ajJ))
							]))
					]))
			]);
	});
var $author$project$Pages$Reports$Invoices$view = function (model) {
	return {
		fO: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			A2($author$project$Components$Reports$Invoices$view, model.Gv, model.kV)),
		ac9: 'Reports | Patient Invoices'
	};
};
var $author$project$Pages$Reports$Invoices$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Reports$Invoices$init, aiq: $author$project$Pages$Reports$Invoices$load, k8: $author$project$Pages$Reports$Invoices$save, alO: $author$project$Pages$Reports$Invoices$subscriptions, adT: $author$project$Pages$Reports$Invoices$update, amo: $author$project$Pages$Reports$Invoices$view});
var $author$project$Pages$Reports$Memberships$ReportMsg = $elm$core$Basics$identity;
var $author$project$Components$Reports$Memberships$AutopayDropdownMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Reports$Memberships$BillingPeriodDropdownMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Reports$Memberships$CompanyResourceFilterMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Reports$Memberships$CouponResourceFilterMsg = function (a) {
	return {$: 20, a: a};
};
var $author$project$Components$Reports$Memberships$DateRangeInputMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Reports$Memberships$FilterDropdownMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Reports$Memberships$GroupLocationAndPractitionerFiltersMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Reports$Memberships$MembershipPatients = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Reports$Memberships$Model = $elm$core$Basics$identity;
var $author$project$Components$Reports$Memberships$PlanResourceFilterMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Reports$Memberships$RateCalculationDropdownMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Reports$Memberships$SourceStatusDropdownMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Reports$Memberships$AllAutopay = 0;
var $author$project$Components$Reports$Memberships$AutopayDisabled = 2;
var $author$project$Components$Reports$Memberships$AutopayEnabled = 1;
var $author$project$Components$Reports$Memberships$autopayStatusFromQuery = function (queryString) {
	_v0$2:
	while (true) {
		if (!queryString.$) {
			switch (queryString.a) {
				case 'enabled':
					return 1;
				case 'disabled':
					return 2;
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return 0;
};
var $author$project$Components$Reports$Memberships$AllBillingPeriods = 0;
var $author$project$Components$Reports$Memberships$Annually = 5;
var $author$project$Components$Reports$Memberships$Monthly = 1;
var $author$project$Components$Reports$Memberships$NonMonthly = 2;
var $author$project$Components$Reports$Memberships$Quarterly = 3;
var $author$project$Components$Reports$Memberships$SemiAnnually = 4;
var $author$project$Components$Reports$Memberships$billingPeriodFromQuery = function (queryString) {
	_v0$5:
	while (true) {
		if (!queryString.$) {
			switch (queryString.a) {
				case '1':
					return 1;
				case '3,6,12':
					return 2;
				case '3':
					return 3;
				case '6':
					return 4;
				case '12':
					return 5;
				default:
					break _v0$5;
			}
		} else {
			break _v0$5;
		}
	}
	return 0;
};
var $author$project$Components$Reports$Memberships$filterTypeToValue = function (filterType) {
	switch (filterType) {
		case 0:
			return 'unconfirmed';
		case 1:
			return 'starting';
		case 2:
			return 'ending';
		case 3:
			return 'current';
		case 4:
			return 'last_or_next_billing';
		case 5:
			return 'contracts_ending';
		default:
			return 'contracts_renewed';
	}
};
var $author$project$Components$Reports$Memberships$sourceStatusToValue = function (sourceStatus) {
	switch (sourceStatus) {
		case 0:
			return '';
		case 1:
			return 'source_valid';
		case 2:
			return 'source_has_warning';
		default:
			return 'source_requires_action';
	}
};
var $author$project$Components$Reports$Memberships$buildUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			$elm$core$Maybe$Just(
			A2(
				$elm$url$Url$Builder$string,
				'filter',
				$author$project$Components$Reports$Memberships$filterTypeToValue(model.HM))),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('start'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.dd, 0)),
			model.JV),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('end'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.dd, 0)),
			model.HB),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('location_group'),
			model.gL),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('location'),
			model.We),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('practitioner'),
			model.Z2),
			function () {
			var _v0 = model.ru;
			switch (_v0) {
				case 0:
					return $elm$core$Maybe$Nothing;
				case 1:
					return $elm$core$Maybe$Just(
						A2($elm$url$Url$Builder$string, 'period_in_months', '1'));
				case 2:
					return $elm$core$Maybe$Just(
						A2($elm$url$Url$Builder$string, 'period_in_months', '3,6,12'));
				case 3:
					return $elm$core$Maybe$Just(
						A2($elm$url$Url$Builder$string, 'period_in_months', '3'));
				case 4:
					return $elm$core$Maybe$Just(
						A2($elm$url$Url$Builder$string, 'period_in_months', '6'));
				default:
					return $elm$core$Maybe$Just(
						A2($elm$url$Url$Builder$string, 'period_in_months', '12'));
			}
		}(),
			function () {
			var _v1 = model.uM;
			if (!_v1) {
				return $elm$core$Maybe$Nothing;
			} else {
				return $elm$core$Maybe$Just(
					A2(
						$elm$url$Url$Builder$string,
						'source_status',
						$author$project$Components$Reports$Memberships$sourceStatusToValue(model.uM)));
			}
		}(),
			function () {
			var _v2 = model.Mm;
			switch (_v2) {
				case 0:
					return $elm$core$Maybe$Nothing;
				case 1:
					return $elm$core$Maybe$Just(
						A2($elm$url$Url$Builder$string, 'autopay', 'enabled'));
				default:
					return $elm$core$Maybe$Just(
						A2($elm$url$Url$Builder$string, 'autopay', 'disabled'));
			}
		}(),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('plan'),
			model.aj4),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('company'),
			model.fZ),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('coupon'),
			model.f0),
			function () {
			var _v3 = model.Jr;
			switch (_v3) {
				case 0:
					return $elm$core$Maybe$Nothing;
				case 1:
					return $elm$core$Maybe$Just(
						A2($elm$url$Url$Builder$string, 'rate_calculation', 'auto_calculated'));
				case 2:
					return $elm$core$Maybe$Just(
						A2($elm$url$Url$Builder$string, 'rate_calculation', 'overridden_off_rate'));
				default:
					return $elm$core$Maybe$Just(
						A2($elm$url$Url$Builder$string, 'rate_calculation', 'overridden_on_rate'));
			}
		}()
		]);
	return A2(
		$elm$url$Url$Builder$relative,
		_List_fromArray(
			[
				$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__Memberships)
			]),
		A2(
			$elm$core$List$append,
			$author$project$Api$Pagination$toPageQuery(model.ajJ),
			A2(
				$elm$core$List$append,
				$author$project$Api$Sort$toQuery(model.alA),
				A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams))));
};
var $author$project$Components$Reports$Memberships$dateRangeInputSettings = F2(
	function (start, end) {
		var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
		return _Utils_update(
			defaultSettings,
			{ahy: start, al5: end});
	});
var $author$project$Components$Reports$Memberships$GotData = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Reports$Memberships$fetchParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				Mm: function () {
					var _v0 = model.Mm;
					switch (_v0) {
						case 0:
							return $elm$core$Maybe$Nothing;
						case 1:
							return $elm$core$Maybe$Just(true);
						default:
							return $elm$core$Maybe$Just(false);
					}
				}(),
				afQ: model.fZ,
				OP: model.f0,
				HB: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.HB),
				HM: $elm$core$Maybe$Just(
					$author$project$Components$Reports$Memberships$filterTypeToValue(model.HM)),
				ais: model.We,
				s4: model.gL,
				ajJ: model.ajJ,
				Zs: function () {
					var _v1 = model.ru;
					switch (_v1) {
						case 0:
							return $elm$core$Maybe$Nothing;
						case 1:
							return $elm$core$Maybe$Just(
								_List_fromArray(
									['1']));
						case 2:
							return $elm$core$Maybe$Just(
								_List_fromArray(
									['3', '6', '12']));
						case 3:
							return $elm$core$Maybe$Just(
								_List_fromArray(
									['3']));
						case 4:
							return $elm$core$Maybe$Just(
								_List_fromArray(
									['6']));
						default:
							return $elm$core$Maybe$Just(
								_List_fromArray(
									['12']));
					}
				}(),
				Jb: model.aj4,
				aka: model.Z2,
				Jr: function () {
					var _v2 = model.Jr;
					switch (_v2) {
						case 0:
							return $elm$core$Maybe$Nothing;
						case 1:
							return $elm$core$Maybe$Just('auto_calculated');
						case 2:
							return $elm$core$Maybe$Just('overridden_off_rate');
						default:
							return $elm$core$Maybe$Just('overridden_on_rate');
					}
				}(),
				alA: model.alA,
				uM: function () {
					var _v3 = model.uM;
					if (!_v3) {
						return $elm$core$Maybe$Nothing;
					} else {
						return $elm$core$Maybe$Just(
							$author$project$Components$Reports$Memberships$sourceStatusToValue(model.uM));
					}
				}(),
				JV: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.JV)
			});
	};
};
var $author$project$Api$Provider$Reports$MembershipPatient$MembershipPatient = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$MembershipPatient$Record = F5(
	function (status, startDate, endDate, patient, membership) {
		return {sb: endDate, kk: membership, YY: patient, ab7: startDate, alH: status};
	});
var $author$project$Api$Provider$Reports$Membership$Membership = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Reports$Membership$One = 0;
var $author$project$Api$Provider$Reports$Membership$OneRecord = function (lastBillAmountInCents) {
	return function (lastBillDate) {
		return function (startDate) {
			return function (endDate) {
				return function (nextBillDate) {
					return function (periodRateInCents) {
						return function (periodInMonths) {
							return function (sourceStatus) {
								return function (status) {
									return function (owner) {
										return function (plan) {
											return {sb: endDate, VB: lastBillAmountInCents, VC: lastBillDate, XP: nextBillDate, YD: owner, Zs: periodInMonths, Zt: periodRateInCents, Jb: plan, uM: sourceStatus, ab7: startDate, alH: status};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Reports$Patient$ForMembership = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$Patient$ForMembershipRecord = F3(
	function (id, name, autopay) {
		return {Mm: autopay, ahP: id, Bq: name};
	});
var $author$project$Api$Provider$Reports$Patient$forMembershipRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'autopay',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$Patient$ForMembershipRecord))));
var $author$project$Api$Provider$Reports$Patient$forMembershipDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $author$project$Api$Provider$Reports$Patient$forMembershipRecordDecoder),
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$Plan$Min$Plan = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$Plan$Min$Record = F3(
	function (id, planType, name) {
		return {ahP: id, Bq: name, ZF: planType};
	});
var $author$project$Api$Provider$Reports$Plan$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'plan_type',
		$elm$json$Json$Decode$nullable($author$project$Api$PlanType$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$Plan$Min$Record))));
var $author$project$Api$Provider$Reports$Plan$Min$minDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Reports$Plan$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$Membership$oneRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'plan',
	$author$project$Api$Provider$Reports$Plan$Min$minDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'owner',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Reports$Patient$forMembershipDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'status',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'source_status',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'period_in_months',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'period_rate_in_cents',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'next_bill_date',
							$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'end_date',
								$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'start_date',
									$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'last_bill_date',
										$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'last_bill_amount_in_cents',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
											$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$Membership$OneRecord))))))))))));
var $author$project$Api$Provider$Reports$Membership$oneDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
	0,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Reports$Membership$oneRecordDecoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$Membership$Membership)));
var $author$project$Api$Provider$Reports$MembershipPatient$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'membership',
	$author$project$Api$Provider$Reports$Membership$oneDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'patient',
		$author$project$Api$Provider$Patient$Min$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'end_date',
			$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'start_date',
				$author$project$Utils$Date$decode,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'status',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$MembershipPatient$Record))))));
var $author$project$Api$Provider$Reports$MembershipPatient$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Reports$MembershipPatient$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$MembershipPatient$listDefaults = {
	Mm: $elm$core$Maybe$Nothing,
	afQ: $elm$core$Maybe$Nothing,
	OP: $elm$core$Maybe$Nothing,
	HB: $elm$core$Maybe$Nothing,
	HM: $elm$core$Maybe$Nothing,
	ais: $elm$core$Maybe$Nothing,
	s4: $elm$core$Maybe$Nothing,
	ajJ: $author$project$Api$Pagination$init,
	Zs: $elm$core$Maybe$Nothing,
	Jb: $elm$core$Maybe$Nothing,
	aka: $elm$core$Maybe$Nothing,
	Jr: $elm$core$Maybe$Nothing,
	alA: A3($author$project$Api$Sort$withDefault, 'start_date', 0, $author$project$Api$Sort$init),
	uM: $elm$core$Maybe$Nothing,
	JV: $elm$core$Maybe$Nothing
};
var $author$project$Api$Provider$Reports$MembershipPatient$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Reports$MembershipPatient$listDefaults);
	return A2(
		$elm$core$List$append,
		$author$project$Api$Pagination$toApiParams(options.ajJ),
		A2(
			$elm$core$List$append,
			$author$project$Api$Sort$toParams(options.alA),
			$elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						var _v0 = options.HM;
						if (!_v0.$) {
							var string = _v0.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'filter', string)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v1 = options.JV;
						if (!_v1.$) {
							var start_ = _v1.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'start', start_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v2 = options.HB;
						if (!_v2.$) {
							var end_ = _v2.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'end', end_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v3 = options.s4;
						if (!_v3.$) {
							var locationGroup_ = _v3.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'location_group', locationGroup_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v4 = options.ais;
						if (!_v4.$) {
							var location_ = _v4.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'location', location_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v5 = options.aka;
						if (!_v5.$) {
							var practitioner_ = _v5.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'practitioner', practitioner_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v6 = options.Zs;
						if (!_v6.$) {
							var list_ = _v6.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$list, 'period_in_months', list_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v7 = options.uM;
						if (!_v7.$) {
							var string = _v7.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'source_status', string)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v8 = options.Mm;
						if (!_v8.$) {
							var bool = _v8.a;
							return _List_fromArray(
								[
									A2(
									$author$project$Api$Param$string,
									'owner',
									A2(
										$elm$json$Json$Encode$encode,
										0,
										$elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'autopay',
													$elm$json$Json$Encode$bool(bool))
												]))))
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v9 = options.Jb;
						if (!_v9.$) {
							var string = _v9.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'plan', string)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v10 = options.afQ;
						if (!_v10.$) {
							var string = _v10.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'company', string)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v11 = options.Jr;
						if (!_v11.$) {
							var string = _v11.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'rate_calculation', string)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v12 = options.OP;
						if (!_v12.$) {
							var string = _v12.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'coupon', string)
								]);
						} else {
							return _List_Nil;
						}
					}()
					]))));
};
var $author$project$Api$Provider$Reports$MembershipPatient$listPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['reports', 'membership_patients']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Reports$MembershipPatient$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Reports$MembershipPatient$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Reports$MembershipPatient$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$MembershipPatient$listPath)));
	});
var $author$project$Components$Reports$Memberships$fetchMembershipPatients = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Api$Provider$Reports$MembershipPatient$list,
			apiClient,
			$author$project$Components$Reports$Memberships$fetchParams(model),
			A2($elm$core$Basics$composeL, $author$project$Components$Reports$Memberships$GotData, $author$project$Components$Reports$Memberships$MembershipPatients));
	});
var $author$project$Components$Reports$Memberships$Memberships = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Reports$Membership$All = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$Membership$AllRecord = function (membershipPatients) {
	return {WR: membershipPatients};
};
var $author$project$Api$Provider$Reports$MembershipPatient$ForMembership$ForMembership = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$MembershipPatient$ForMembership$Record = function (patient) {
	return {YY: patient};
};
var $author$project$Api$Provider$Reports$MembershipPatient$ForMembership$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'patient',
	$author$project$Api$Provider$Patient$Min$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$MembershipPatient$ForMembership$Record));
var $author$project$Api$Provider$Reports$MembershipPatient$ForMembership$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Reports$MembershipPatient$ForMembership$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$Membership$allRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'membership_patients',
	$elm$json$Json$Decode$list($author$project$Api$Provider$Reports$MembershipPatient$ForMembership$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$Membership$AllRecord));
var $author$project$Api$Provider$Reports$Membership$allDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $author$project$Api$Provider$Reports$Membership$allRecordDecoder),
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Reports$Membership$oneRecordDecoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$Membership$Membership)));
var $author$project$Api$Provider$Reports$Membership$listDefaults = {
	Mm: $elm$core$Maybe$Nothing,
	afQ: $elm$core$Maybe$Nothing,
	OP: $elm$core$Maybe$Nothing,
	HB: $elm$core$Maybe$Nothing,
	HM: $elm$core$Maybe$Nothing,
	ais: $elm$core$Maybe$Nothing,
	s4: $elm$core$Maybe$Nothing,
	ajJ: $author$project$Api$Pagination$init,
	Zs: $elm$core$Maybe$Nothing,
	Jb: $elm$core$Maybe$Nothing,
	aka: $elm$core$Maybe$Nothing,
	Jr: $elm$core$Maybe$Nothing,
	alA: A3($author$project$Api$Sort$withDefault, 'start_date', 0, $author$project$Api$Sort$init),
	uM: $elm$core$Maybe$Nothing,
	JV: $elm$core$Maybe$Nothing
};
var $author$project$Api$Provider$Reports$Membership$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Reports$Membership$listDefaults);
	return A2(
		$elm$core$List$append,
		$author$project$Api$Pagination$toApiParams(options.ajJ),
		A2(
			$elm$core$List$append,
			$author$project$Api$Sort$toParams(options.alA),
			$elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						var _v0 = options.HM;
						if (!_v0.$) {
							var string = _v0.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'filter', string)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v1 = options.JV;
						if (!_v1.$) {
							var start_ = _v1.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'start', start_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v2 = options.HB;
						if (!_v2.$) {
							var end_ = _v2.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'end', end_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v3 = options.s4;
						if (!_v3.$) {
							var locationGroup_ = _v3.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'location_group', locationGroup_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v4 = options.ais;
						if (!_v4.$) {
							var location_ = _v4.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'location', location_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v5 = options.aka;
						if (!_v5.$) {
							var practitioner_ = _v5.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'practitioner', practitioner_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v6 = options.Zs;
						if (!_v6.$) {
							var list_ = _v6.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$list, 'period_in_months', list_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v7 = options.uM;
						if (!_v7.$) {
							var string = _v7.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'source_status', string)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v8 = options.Mm;
						if (!_v8.$) {
							var bool = _v8.a;
							return _List_fromArray(
								[
									A2(
									$author$project$Api$Param$string,
									'owner',
									A2(
										$elm$json$Json$Encode$encode,
										0,
										$elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'autopay',
													$elm$json$Json$Encode$bool(bool))
												]))))
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v9 = options.Jb;
						if (!_v9.$) {
							var string = _v9.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'plan', string)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v10 = options.afQ;
						if (!_v10.$) {
							var string = _v10.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'company', string)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v11 = options.Jr;
						if (!_v11.$) {
							var string = _v11.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'rate_calculation', string)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v12 = options.OP;
						if (!_v12.$) {
							var string = _v12.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'coupon', string)
								]);
						} else {
							return _List_Nil;
						}
					}()
					]))));
};
var $author$project$Api$Provider$Reports$Membership$listPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['reports', 'memberships']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Reports$Membership$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Reports$Membership$allDecoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Reports$Membership$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$Membership$listPath)));
	});
var $author$project$Components$Reports$Memberships$fetchMemberships = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Api$Provider$Reports$Membership$list,
			apiClient,
			$author$project$Components$Reports$Memberships$fetchParams(model),
			A2($elm$core$Basics$composeL, $author$project$Components$Reports$Memberships$GotData, $author$project$Components$Reports$Memberships$Memberships));
	});
var $author$project$Components$Reports$Memberships$fetchData = F2(
	function (apiClient, model) {
		var _v0 = model.Pw;
		if (!_v0.$) {
			return A2($author$project$Components$Reports$Memberships$fetchMembershipPatients, apiClient, model);
		} else {
			return A2($author$project$Components$Reports$Memberships$fetchMemberships, apiClient, model);
		}
	});
var $author$project$Components$Reports$Memberships$ContractsEnding = 5;
var $author$project$Components$Reports$Memberships$ContractsRenewed = 6;
var $author$project$Components$Reports$Memberships$Current = 3;
var $author$project$Components$Reports$Memberships$Ending = 2;
var $author$project$Components$Reports$Memberships$LastOrNextBilling = 4;
var $author$project$Components$Reports$Memberships$Starting = 1;
var $author$project$Components$Reports$Memberships$Unconfirmed = 0;
var $author$project$Components$Reports$Memberships$filterTypeFromQuery = function (queryString) {
	_v0$6:
	while (true) {
		if (!queryString.$) {
			switch (queryString.a) {
				case 'unconfirmed':
					return 0;
				case 'starting':
					return 1;
				case 'ending':
					return 2;
				case 'current':
					return 3;
				case 'contracts_ending':
					return 5;
				case 'contracts_renewed':
					return 6;
				default:
					break _v0$6;
			}
		} else {
			break _v0$6;
		}
	}
	return 4;
};
var $author$project$Components$ResourceFilter$Coupon$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Components$ResourceFilter$Coupon$list = $author$project$Api$Provider$Coupon$list;
var $author$project$Components$ResourceFilter$Coupon$fetchResources = F4(
	function (toMsg, apiClient, pagination, query) {
		return A3(
			$author$project$Components$ResourceFilter$Coupon$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						ajJ: pagination,
						akl: query,
						Jt: $elm$core$Maybe$Just(true)
					});
			},
			toMsg);
	});
var $author$project$Components$ResourceFilter$Coupon$retrieveResource = F3(
	function (toMsg, apiClient, id) {
		return A3(
			$author$project$Components$ResourceFilter$Coupon$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						ahP: $elm$core$Maybe$Just(id)
					});
			},
			toMsg);
	});
var $author$project$Components$ResourceFilter$Coupon$selectId = 'coupons';
var $author$project$Components$ResourceFilter$Coupon$toTitle = $author$project$Api$Provider$Coupon$All$code;
var $author$project$Components$ResourceFilter$Coupon$toLabel = function (resource) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Components$ResourceFilter$Coupon$toTitle(resource))
		]);
};
var $author$project$Components$ResourceFilter$Coupon$toValue = $author$project$Api$Provider$Coupon$All$id;
var $author$project$Components$ResourceFilter$Coupon$init = F2(
	function (apiClient, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{Sk: $author$project$Components$ResourceFilter$Coupon$fetchResources, ahP: $author$project$Components$ResourceFilter$Coupon$selectId, k$: 'Coupon', uk: $author$project$Components$ResourceFilter$Coupon$retrieveResource, u9: $author$project$Components$ResourceFilter$Coupon$toLabel, lN: $author$project$Components$ResourceFilter$Coupon$toTitle, hX: $author$project$Components$ResourceFilter$Coupon$toValue},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{Jy: $author$project$Components$ResourceFilter$All, b8: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Utils$Report$CouponResourceFilter$init = F3(
	function (apiClient, optionals, couponId) {
		return A2(
			$author$project$Components$ResourceFilter$Coupon$init,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				optionals,
				function (d) {
					return _Utils_update(
						d,
						{Gp: 'All Coupons', akb: couponId});
				}));
	});
var $author$project$Components$Reports$Memberships$initColumns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'owner', false, 'Owner'),
		A3($author$project$Api$Column$init, 'patient', false, 'Patients'),
		A3($author$project$Api$Column$init, 'plan', false, 'Plan'),
		A3($author$project$Api$Column$init, 'status', false, 'Status'),
		A3($author$project$Api$Column$init, 'last_bill_date', true, 'Last Bill'),
		A3($author$project$Api$Column$init, 'next_bill_date', true, 'Next Bill'),
		A3($author$project$Api$Column$init, 'period_in_months', true, 'Billed'),
		A3($author$project$Api$Column$init, 'payment_info', false, 'Payment Info')
	]);
var $author$project$Api$Provider$Report$Membership = 11;
var $author$project$Api$Provider$Report$MembershipPatient = 10;
var $author$project$Components$Reports$Memberships$initExportCsv = function (showBy) {
	var resource = function () {
		if (!showBy.$) {
			return 10;
		} else {
			return 11;
		}
	}();
	return $author$project$Components$ExportCsv$initForPractice(resource);
};
var $author$project$Components$Reports$Memberships$AllRateCalculations = 0;
var $author$project$Components$Reports$Memberships$AutoCalculated = 1;
var $author$project$Components$Reports$Memberships$OverriddenOffRate = 2;
var $author$project$Components$Reports$Memberships$OverriddenOnRate = 3;
var $author$project$Components$Reports$Memberships$rateCalculationFromQuery = function (queryString) {
	_v0$3:
	while (true) {
		if (!queryString.$) {
			switch (queryString.a) {
				case 'auto_calculated':
					return 1;
				case 'overridden_off_rate':
					return 2;
				case 'overridden_on_rate':
					return 3;
				default:
					break _v0$3;
			}
		} else {
			break _v0$3;
		}
	}
	return 0;
};
var $author$project$Components$Reports$Memberships$AllSources = 0;
var $author$project$Components$Reports$Memberships$SourceRequiresAction = 3;
var $author$project$Components$Reports$Memberships$SourceWithWarning = 2;
var $author$project$Components$Reports$Memberships$ValidSource = 1;
var $author$project$Components$Reports$Memberships$sourceStatusFromQuery = function (queryString) {
	_v0$3:
	while (true) {
		if (!queryString.$) {
			switch (queryString.a) {
				case 'source_valid':
					return 1;
				case 'source_has_warning':
					return 2;
				case 'source_requires_action':
					return 3;
				default:
					break _v0$3;
			}
		} else {
			break _v0$3;
		}
	}
	return 0;
};
var $author$project$Components$Reports$Memberships$init = F4(
	function (session, practice, _v0, query) {
		var currentDate = _v0.dd;
		var apiClient = _v0.Gv;
		var hinterViewOff = _v0.ahK;
		var practitionerId = A2($elm$core$Dict$get, 'practitioner', query);
		var planId = A2($elm$core$Dict$get, 'plan', query);
		var locationId = A2($elm$core$Dict$get, 'location', query);
		var locationGroupId = A2($elm$core$Dict$get, 'location_group', query);
		var data = $author$project$Components$Reports$Memberships$MembershipPatients($author$project$Api$Data$Loading);
		var couponId = A2($elm$core$Dict$get, 'coupon', query);
		var companyId = A2($elm$core$Dict$get, 'company', query);
		var _v1 = A4($author$project$Utils$Report$PlanResourceFilter$init, apiClient, $elm$core$Basics$identity, session, planId);
		var planResourceFilter = _v1.a;
		var planResourceFilterCmd = _v1.b;
		var _v2 = A7($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$init, apiClient, session, practice, false, locationGroupId, locationId, practitionerId);
		var groupLocationAndPractitionerFilters = _v2.a;
		var groupLocationAndPractitionerFiltersCmd = _v2.b;
		var _v3 = $author$project$Utils$DateWithDefault$fromQuery(query);
		var start = _v3.a;
		var end = _v3.b;
		var _v4 = A2(
			$author$project$Components$DateRangeInput$init,
			'date-range-input',
			A2(
				$author$project$Components$Reports$Memberships$dateRangeInputSettings,
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					start),
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					end)));
		var dateRangeInput = _v4.a;
		var dateRangeInputCmd = _v4.b;
		var _v5 = A3($author$project$Utils$Report$CouponResourceFilter$init, apiClient, $elm$core$Basics$identity, couponId);
		var couponResourceFilter = _v5.a;
		var couponResourceFilterCmd = _v5.b;
		var _v6 = A4(
			$author$project$Utils$Report$CompanyResourceFilter$init,
			apiClient,
			$elm$core$Basics$identity,
			$author$project$Api$Practice$Provider(practice),
			companyId);
		var companyResourceFilter = _v6.a;
		var companyResourceFilterCmd = _v6.b;
		var model = {
			Mm: $author$project$Components$Reports$Memberships$autopayStatusFromQuery(
				A2($elm$core$Dict$get, 'autopay', query)),
			mp: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'autopay-dropdown-filter', al6: $author$project$Components$Reports$Memberships$AutopayDropdownMsg})),
			ru: $author$project$Components$Reports$Memberships$billingPeriodFromQuery(
				A2($elm$core$Dict$get, 'period_in_months', query)),
			mv: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'billing-period-dropdown-filter', al6: $author$project$Components$Reports$Memberships$BillingPeriodDropdownMsg})),
			GO: A3($author$project$Permission$canGoTo, session, hinterViewOff, 0),
			GQ: A3($author$project$Permission$canGoTo, session, hinterViewOff, 50),
			N3: $author$project$Components$Reports$Memberships$initColumns,
			fZ: companyId,
			mZ: companyResourceFilter,
			f0: couponId,
			iU: couponResourceFilter,
			dd: currentDate,
			m5: $author$project$Components$CustomerEmailModal$init,
			Pw: data,
			i4: dateRangeInput,
			HB: end,
			nD: $author$project$Components$Reports$Memberships$initExportCsv(data),
			HM: $author$project$Components$Reports$Memberships$filterTypeFromQuery(
				A2($elm$core$Dict$get, 'filter', query)),
			nK: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'filter-dropdown-filter', al6: $author$project$Components$Reports$Memberships$FilterDropdownMsg})),
			dn: groupLocationAndPractitionerFilters,
			gL: locationGroupId,
			We: locationId,
			ajJ: $author$project$Api$Pagination$initFromQuery(query),
			aj4: planId,
			hi: planResourceFilter,
			Z2: practitionerId,
			Jr: $author$project$Components$Reports$Memberships$rateCalculationFromQuery(
				A2($elm$core$Dict$get, 'rate_calculation', query)),
			pu: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'rate-calculation-dropdown-filter', al6: $author$project$Components$Reports$Memberships$RateCalculationDropdownMsg})),
			alA: A3(
				$author$project$Api$Sort$withDefault,
				'next_bill_date',
				0,
				$author$project$Api$Sort$initFromQuery(query)),
			uM: $author$project$Components$Reports$Memberships$sourceStatusFromQuery(
				A2($elm$core$Dict$get, 'source_status', query)),
			qj: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'source-status-dropdown-filter', al6: $author$project$Components$Reports$Memberships$SourceStatusDropdownMsg})),
			JV: start
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Memberships$DateRangeInputMsg, dateRangeInputCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Memberships$GroupLocationAndPractitionerFiltersMsg, groupLocationAndPractitionerFiltersCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Memberships$PlanResourceFilterMsg, planResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Memberships$CompanyResourceFilterMsg, companyResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Memberships$CouponResourceFilterMsg, couponResourceFilterCmd),
						A2($author$project$Components$Reports$Memberships$fetchData, apiClient, model),
						A2($elm$core$Basics$composeR, $author$project$Components$Reports$Memberships$buildUrl, $author$project$Ports$Navigation$replaceUrl)(model)
					])));
	});
var $author$project$Pages$Reports$Memberships$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.DE;
		var _v1 = A4($author$project$Components$Reports$Memberships$init, session, practice, shared, query);
		var report = _v1.a;
		var reportCmd = _v1.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, kV: report},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportCmd));
	});
var $author$project$Pages$Reports$Memberships$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$Memberships$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Reports$Memberships$CustomerEmailModalMsg = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Reports$Memberships$ExportCsvMsg = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$ResourceFilter$Coupon$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.b8));
};
var $author$project$Components$Reports$Memberships$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$Memberships$DateRangeInputMsg,
				$author$project$Components$DateRangeInput$subscriptions(model.i4)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$Memberships$CustomerEmailModalMsg,
				$author$project$Components$CustomerEmailModal$subscriptions(model.m5)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$Memberships$ExportCsvMsg,
				$author$project$Components$ExportCsv$subscriptions(model.nD)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$Memberships$PlanResourceFilterMsg,
				$author$project$Components$ResourceFilter$Plan$subscriptions(model.hi)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$Memberships$CompanyResourceFilterMsg,
				$author$project$Components$ResourceFilter$Company$subscriptions(model.mZ)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$Memberships$GroupLocationAndPractitionerFiltersMsg,
				$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$subscriptions(model.dn)),
				$author$project$Ui$Dropdown$subscriptions(model.qj),
				$author$project$Ui$Dropdown$subscriptions(model.mp),
				$author$project$Ui$Dropdown$subscriptions(model.mv),
				$author$project$Ui$Dropdown$subscriptions(model.pu),
				$author$project$Ui$Dropdown$subscriptions(model.nK),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$Memberships$CouponResourceFilterMsg,
				$author$project$Components$ResourceFilter$Coupon$subscriptions(model.iU))
			]));
};
var $author$project$Pages$Reports$Memberships$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Reports$Memberships$subscriptions(model.kV));
};
var $author$project$Components$Reports$Memberships$dataLoading = function (showBy) {
	if (!showBy.$) {
		return $author$project$Components$Reports$Memberships$MembershipPatients($author$project$Api$Data$Loading);
	} else {
		return $author$project$Components$Reports$Memberships$Memberships($author$project$Api$Data$Loading);
	}
};
var $author$project$Components$ResourceFilter$Coupon$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.b8);
		var modelAfterEvent = function () {
			var _v1 = result.agZ;
			if (!_v1.$) {
				var selected = _v1.a;
				return _Utils_update(
					model,
					{Jy: selected});
			} else {
				return model;
			}
		}();
		return {
			GZ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.GZ),
			agZ: result.agZ,
			aiO: _Utils_update(
				modelAfterEvent,
				{b8: result.aiO}),
			aR: result.aR
		};
	});
var $author$project$Components$ResourceFilter$Coupon$value = function (model) {
	return A2($author$project$Components$ResourceFilter$choiceToValue, model.b8, model.Jy);
};
var $author$project$Components$Reports$Memberships$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Ui$Dropdown$update, subMsg, model.nK);
				var dropdown = _v2.a;
				var dropdownCmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nK: dropdown}),
					dropdownCmd,
					_List_Nil);
			case 1:
				var filterType = msg.a;
				var newModel = _Utils_update(
					model,
					{
						Pw: $author$project$Components$Reports$Memberships$dataLoading(model.Pw),
						HM: filterType,
						ajJ: $author$project$Api$Pagination$reset(model.ajJ)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$Memberships$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$Memberships$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 2:
				var subMsg = msg.a;
				var _v3 = A2($author$project$Components$DateRangeInput$update, subMsg, model.i4);
				var dateRangeInput = _v3.a;
				var subCmd = _v3.b;
				var event = _v3.c;
				var newModel = function () {
					if (event.$ === 1) {
						var fromDate = event.a;
						var toDate = event.b;
						return _Utils_update(
							model,
							{
								Pw: $author$project$Components$Reports$Memberships$dataLoading(model.Pw),
								i4: dateRangeInput,
								HB: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
								ajJ: $author$project$Api$Pagination$reset(model.ajJ),
								JV: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
							});
					} else {
						return _Utils_update(
							model,
							{i4: dateRangeInput});
					}
				}();
				var cmds = (_Utils_eq(newModel.JV, model.JV) && _Utils_eq(newModel.HB, model.HB)) ? _List_Nil : _List_fromArray(
					[
						A2($author$project$Components$Reports$Memberships$fetchData, apiClient, newModel),
						A2($elm$core$Basics$composeR, $author$project$Components$Reports$Memberships$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
					]);
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$cons,
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Memberships$DateRangeInputMsg, subCmd),
							cmds)),
					_List_Nil);
			case 4:
				var data = msg.a;
				var newModel = _Utils_update(
					model,
					{
						Pw: data,
						nD: $author$project$Components$Reports$Memberships$initExportCsv(data),
						ajJ: $author$project$Api$Pagination$reset(model.ajJ)
					});
				return _Utils_Tuple3(
					newModel,
					A2($author$project$Components$Reports$Memberships$fetchData, apiClient, newModel),
					_List_Nil);
			case 3:
				var subMsg = msg.a;
				var result = A3($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$update, apiClient, subMsg, model.dn);
				var _v5 = result.agZ;
				if (!_v5.$) {
					var locationGroupId = _v5.a;
					var locationId = _v5.b;
					var practitionerId = _v5.c;
					var newModel = _Utils_update(
						model,
						{
							Pw: $author$project$Components$Reports$Memberships$dataLoading(model.Pw),
							dn: result.aiO,
							gL: locationGroupId,
							We: locationId,
							ajJ: $author$project$Api$Pagination$reset(model.ajJ),
							Z2: practitionerId
						});
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Memberships$GroupLocationAndPractitionerFiltersMsg, result.GZ),
									A2($author$project$Components$Reports$Memberships$fetchData, apiClient, newModel),
									A2($elm$core$Basics$composeR, $author$project$Components$Reports$Memberships$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
								])),
						result.aR);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dn: result.aiO}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Memberships$GroupLocationAndPractitionerFiltersMsg, result.GZ),
						result.aR);
				}
			case 5:
				var subMsg = msg.a;
				var _v6 = A2($author$project$Ui$Dropdown$update, subMsg, model.mv);
				var dropdown = _v6.a;
				var dropdownCmd = _v6.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{mv: dropdown}),
					dropdownCmd,
					_List_Nil);
			case 6:
				var period = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ru: period,
						Pw: $author$project$Components$Reports$Memberships$dataLoading(model.Pw),
						ajJ: $author$project$Api$Pagination$reset(model.ajJ)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$Memberships$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$Memberships$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 7:
				var subMsg = msg.a;
				var _v7 = A2($author$project$Ui$Dropdown$update, subMsg, model.qj);
				var dropdown = _v7.a;
				var dropdownCmd = _v7.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qj: dropdown}),
					dropdownCmd,
					_List_Nil);
			case 8:
				var status = msg.a;
				var newModel = _Utils_update(
					model,
					{
						Pw: $author$project$Components$Reports$Memberships$dataLoading(model.Pw),
						ajJ: $author$project$Api$Pagination$reset(model.ajJ),
						uM: status
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$Memberships$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$Memberships$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 9:
				var subMsg = msg.a;
				var _v8 = A2($author$project$Ui$Dropdown$update, subMsg, model.mp);
				var dropdown = _v8.a;
				var dropdownCmd = _v8.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{mp: dropdown}),
					dropdownCmd,
					_List_Nil);
			case 10:
				var status = msg.a;
				var newModel = _Utils_update(
					model,
					{
						Mm: status,
						Pw: $author$project$Components$Reports$Memberships$dataLoading(model.Pw),
						ajJ: $author$project$Api$Pagination$reset(model.ajJ)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$Memberships$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$Memberships$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 12:
				var subMsg = msg.a;
				var companyResourceResult = A3($author$project$Components$ResourceFilter$Company$update, apiClient, subMsg, model.mZ);
				var companyId = function () {
					var _v10 = companyResourceResult.agZ;
					if (!_v10.$) {
						return $author$project$Components$ResourceFilter$Company$value(companyResourceResult.aiO);
					} else {
						return model.fZ;
					}
				}();
				var newModel = _Utils_update(
					model,
					{fZ: companyId, mZ: companyResourceResult.aiO});
				var _v9 = _Utils_eq(model.fZ, newModel.fZ) ? _Utils_Tuple2(model.Pw, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					$author$project$Components$Reports$Memberships$dataLoading(model.Pw),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$Memberships$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$Memberships$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])));
				var data = _v9.a;
				var cmd = _v9.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{Pw: data}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Memberships$CompanyResourceFilterMsg, companyResourceResult.GZ),
								cmd
							])),
					companyResourceResult.aR);
			case 11:
				var subMsg = msg.a;
				var planResourceResult = A3($author$project$Components$ResourceFilter$Plan$update, apiClient, subMsg, model.hi);
				var planId = function () {
					var _v12 = planResourceResult.agZ;
					if (!_v12.$) {
						return $author$project$Components$ResourceFilter$Plan$value(planResourceResult.aiO);
					} else {
						return model.aj4;
					}
				}();
				var newModel = _Utils_update(
					model,
					{aj4: planId, hi: planResourceResult.aiO});
				var _v11 = _Utils_eq(model.aj4, newModel.aj4) ? _Utils_Tuple2(model.Pw, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					$author$project$Components$Reports$Memberships$dataLoading(model.Pw),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$Memberships$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$Memberships$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])));
				var data = _v11.a;
				var cmd = _v11.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{Pw: data}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Memberships$PlanResourceFilterMsg, planResourceResult.GZ),
								cmd
							])),
					planResourceResult.aR);
			case 13:
				var subMsg = msg.a;
				var _v13 = A2($author$project$Ui$Dropdown$update, subMsg, model.pu);
				var dropdown = _v13.a;
				var dropdownCmd = _v13.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{pu: dropdown}),
					dropdownCmd,
					_List_Nil);
			case 14:
				var calculation = msg.a;
				var newModel = _Utils_update(
					model,
					{
						Pw: $author$project$Components$Reports$Memberships$dataLoading(model.Pw),
						ajJ: $author$project$Api$Pagination$reset(model.ajJ),
						Jr: calculation
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$Memberships$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$Memberships$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 15:
				var showBy = msg.a;
				if (!showBy.$) {
					var response = showBy.a;
					if (response.$ === 3) {
						var headers = response.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									Pw: $author$project$Components$Reports$Memberships$MembershipPatients(response),
									ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									Pw: $author$project$Components$Reports$Memberships$MembershipPatients(response)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					var response = showBy.a;
					if (response.$ === 3) {
						var headers = response.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									Pw: $author$project$Components$Reports$Memberships$Memberships(response),
									ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									Pw: $author$project$Components$Reports$Memberships$Memberships(response)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				}
			case 16:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{
						Pw: $author$project$Components$Reports$Memberships$dataLoading(model.Pw),
						ajJ: pagination
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$Memberships$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$Memberships$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 17:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						alA: A2($author$project$Api$Sort$update, columnId, model.alA)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$Memberships$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$Memberships$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 18:
				var subMsg = msg.a;
				var _v17 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.nD);
				var exportCsv = _v17.a;
				var subCmd = _v17.b;
				var subOutMsg = _v17.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nD: exportCsv}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Memberships$ExportCsvMsg, subCmd),
					subOutMsg);
			case 19:
				var subMsg = msg.a;
				var _v18 = A3($author$project$Components$CustomerEmailModal$update, apiClient, subMsg, model.m5);
				var customerEmailModal = _v18.a;
				var subCmd = _v18.b;
				var subOutMsg = _v18.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{m5: customerEmailModal}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Memberships$CustomerEmailModalMsg, subCmd),
					subOutMsg);
			default:
				var subMsg = msg.a;
				var couponResourceResult = A3($author$project$Components$ResourceFilter$Coupon$update, apiClient, subMsg, model.iU);
				var couponId = function () {
					var _v20 = couponResourceResult.agZ;
					if (!_v20.$) {
						return $author$project$Components$ResourceFilter$Coupon$value(couponResourceResult.aiO);
					} else {
						return model.f0;
					}
				}();
				var newModel = _Utils_update(
					model,
					{f0: couponId, iU: couponResourceResult.aiO});
				var _v19 = _Utils_eq(model.f0, newModel.f0) ? _Utils_Tuple2(model.Pw, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					$author$project$Components$Reports$Memberships$dataLoading(model.Pw),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$Memberships$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$Memberships$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])));
				var data = _v19.a;
				var cmd = _v19.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{Pw: data}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Memberships$CouponResourceFilterMsg, couponResourceResult.GZ),
								cmd
							])),
					couponResourceResult.aR);
		}
	});
var $author$project$Pages$Reports$Memberships$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Reports$Memberships$update, model.Gv, subMsg, model.kV);
		var report = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{kV: report}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Components$Reports$Memberships$PaginationMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Reports$Memberships$autopayStatusToLabel = function (status) {
	switch (status) {
		case 0:
			return 'All Autopay';
		case 1:
			return 'Autopay Enabled';
		default:
			return 'Autopay Disabled';
	}
};
var $author$project$Components$Reports$Memberships$AutopaySelected = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Reports$Memberships$autopayStatuses = function (currentStatus) {
	var autopayStatusToItem = function (status) {
		return A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(currentStatus, status)),
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Components$Reports$Memberships$AutopaySelected(status))
				]),
			$elm$html$Html$text(
				$author$project$Components$Reports$Memberships$autopayStatusToLabel(status)));
	};
	return A2(
		$elm$core$List$cons,
		autopayStatusToItem(0),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$Dropdown$separator,
			A2(
				$elm$core$List$map,
				autopayStatusToItem,
				_List_fromArray(
					[1, 2]))));
};
var $author$project$Components$Reports$Memberships$viewAutopayDropdown = function (model) {
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Components$Reports$Memberships$autopayStatusToLabel(model.Mm))
			]),
		$author$project$Components$Reports$Memberships$autopayStatuses(model.Mm),
		model.mp);
};
var $author$project$Components$Reports$Memberships$billingPeriodToLabel = function (period) {
	switch (period) {
		case 0:
			return 'All Billing Periods';
		case 1:
			return 'Billed Monthly';
		case 2:
			return 'Billed Non Monthly';
		case 3:
			return 'Billed Quarterly';
		case 4:
			return 'Billed Semi-annually';
		default:
			return 'Billed Annually';
	}
};
var $author$project$Components$Reports$Memberships$BillingPeriodSelected = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Reports$Memberships$billingPeriods = function (currentPeriod) {
	var billingPeriodToItem = function (period) {
		return A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(currentPeriod, period)),
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Components$Reports$Memberships$BillingPeriodSelected(period))
				]),
			$elm$html$Html$text(
				$author$project$Components$Reports$Memberships$billingPeriodToLabel(period)));
	};
	return A2(
		$elm$core$List$cons,
		billingPeriodToItem(0),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$Dropdown$separator,
			_Utils_ap(
				A2(
					$elm$core$List$map,
					billingPeriodToItem,
					_List_fromArray(
						[1, 2])),
				A2(
					$elm$core$List$cons,
					$author$project$Ui$Dropdown$separator,
					A2(
						$elm$core$List$map,
						billingPeriodToItem,
						_List_fromArray(
							[3, 4, 5]))))));
};
var $author$project$Components$Reports$Memberships$viewBillingPeriodDropdown = function (model) {
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Components$Reports$Memberships$billingPeriodToLabel(model.ru))
			]),
		$author$project$Components$Reports$Memberships$billingPeriods(model.ru),
		model.mv);
};
var $author$project$Components$Reports$Memberships$viewCompanyResourceFilter = function (companyResourceFilter) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Reports$Memberships$CompanyResourceFilterMsg,
		A2(
			$author$project$Components$ResourceFilter$Company$view,
			_List_fromArray(
				[
					$author$project$Components$ResourceFilter$style(1),
					$author$project$Components$ResourceFilter$multi
				]),
			companyResourceFilter));
};
var $author$project$Components$ResourceFilter$Coupon$view = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$view,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.Jy),
					options),
				model.b8));
	});
var $author$project$Components$Reports$Memberships$viewCouponResourceFilter = function (couponResourceFilter) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Reports$Memberships$CouponResourceFilterMsg,
		A2(
			$author$project$Components$ResourceFilter$Coupon$view,
			_List_fromArray(
				[
					$author$project$Components$ResourceFilter$style(1),
					$author$project$Components$ResourceFilter$multi
				]),
			couponResourceFilter));
};
var $author$project$Components$Reports$Memberships$filterTypeToLabel = function (filterType) {
	switch (filterType) {
		case 0:
			return 'Unconfirmed';
		case 1:
			return 'Starting';
		case 2:
			return 'Ending';
		case 3:
			return 'Active';
		case 4:
			return 'Last Billed or Billing';
		case 5:
			return 'Contract Ending';
		default:
			return 'Contracts Renewed';
	}
};
var $author$project$Components$Reports$Memberships$FilterSelected = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Reports$Memberships$filterTypes = function (currentFilter) {
	var filterTypeToItem = function (filterType) {
		return A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(currentFilter, filterType)),
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Components$Reports$Memberships$FilterSelected(filterType))
				]),
			$elm$html$Html$text(
				$author$project$Components$Reports$Memberships$filterTypeToLabel(filterType)));
	};
	return A2(
		$elm$core$List$map,
		filterTypeToItem,
		_List_fromArray(
			[0, 1, 2, 3, 4, 5, 6]));
};
var $author$project$Components$Reports$Memberships$viewFilterDropdown = function (model) {
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Components$Reports$Memberships$filterTypeToLabel(model.HM))
			]),
		$author$project$Components$Reports$Memberships$filterTypes(model.HM),
		model.nK);
};
var $author$project$Components$ResourceFilter$Coupon$viewMultiSelected = function (model) {
	return A2(
		$elm$core$List$map,
		$elm$html$Html$map($elm$core$Basics$identity),
		A2($author$project$Components$ResourceFilter$viewMultiSelected, model.Jy, model.b8));
};
var $author$project$Components$Reports$Memberships$viewPlanResourceFilter = function (planResourceFilter) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Reports$Memberships$PlanResourceFilterMsg,
		A2(
			$author$project$Components$ResourceFilter$Plan$view,
			_List_fromArray(
				[
					$author$project$Components$ResourceFilter$style(1),
					$author$project$Components$ResourceFilter$multi
				]),
			planResourceFilter));
};
var $author$project$Components$Reports$Memberships$rateCalculationToLabel = function (calculation) {
	switch (calculation) {
		case 0:
			return 'All Rate Overrides';
		case 1:
			return 'Automatic Rate';
		case 2:
			return 'Overridden (Off Rate)';
		default:
			return 'Overridden (On Rate)';
	}
};
var $author$project$Components$Reports$Memberships$RateCalculationSelected = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Reports$Memberships$rateCalculations = function (currentCalculation) {
	var rateCalculationToItem = function (calculation) {
		return A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(currentCalculation, calculation)),
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Components$Reports$Memberships$RateCalculationSelected(calculation))
				]),
			$elm$html$Html$text(
				$author$project$Components$Reports$Memberships$rateCalculationToLabel(calculation)));
	};
	return A2(
		$elm$core$List$cons,
		rateCalculationToItem(0),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$Dropdown$separator,
			A2(
				$elm$core$List$map,
				rateCalculationToItem,
				_List_fromArray(
					[1, 2, 3]))));
};
var $author$project$Components$Reports$Memberships$viewRateCalculationDropdown = function (model) {
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Components$Reports$Memberships$rateCalculationToLabel(model.Jr))
			]),
		$author$project$Components$Reports$Memberships$rateCalculations(model.Jr),
		model.pu);
};
var $author$project$Components$Reports$Memberships$ShowByChanged = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Reports$Memberships$viewShowByButtonGroup = function (model) {
	var _v0 = function () {
		var _v1 = model.Pw;
		if (!_v1.$) {
			return _Utils_Tuple2(true, false);
		} else {
			return _Utils_Tuple2(false, true);
		}
	}();
	var membershipPatientsActive = _v0.a;
	var membershipsActive = _v0.b;
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$itemsCenter]),
		_List_fromArray(
			[
				$elm$html$Html$text('Show by: '),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mr2]),
				_List_Nil),
				$author$project$Ui$Button$group(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Shhow by patients'},
						_List_fromArray(
							[
								$author$project$Ui$Button$active(membershipPatientsActive),
								$author$project$Ui$Button$onClick(
								$author$project$Components$Reports$Memberships$ShowByChanged(
									$author$project$Components$Reports$Memberships$MembershipPatients($author$project$Api$Data$Loading)))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Patients')
							])),
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Shhow by membership owners'},
						_List_fromArray(
							[
								$author$project$Ui$Button$active(membershipsActive),
								$author$project$Ui$Button$onClick(
								$author$project$Components$Reports$Memberships$ShowByChanged(
									$author$project$Components$Reports$Memberships$Memberships($author$project$Api$Data$Loading)))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Membership owners')
							]))
					]))
			]));
};
var $author$project$Components$Reports$Memberships$sourceStatusToLabel = function (status) {
	switch (status) {
		case 0:
			return 'All Payment Source';
		case 1:
			return 'Source Valid ';
		case 2:
			return 'Source Has Warning';
		default:
			return 'Source Requires Action';
	}
};
var $author$project$Components$Reports$Memberships$SourceStatusSelected = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Reports$Memberships$sourceStatuses = function (currentStatus) {
	var sourceStatusToItem = function (status) {
		return A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(currentStatus, status)),
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Components$Reports$Memberships$SourceStatusSelected(status))
				]),
			$elm$html$Html$text(
				$author$project$Components$Reports$Memberships$sourceStatusToLabel(status)));
	};
	return A2(
		$elm$core$List$cons,
		sourceStatusToItem(0),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$Dropdown$separator,
			A2(
				$elm$core$List$map,
				sourceStatusToItem,
				_List_fromArray(
					[1, 2, 3]))));
};
var $author$project$Components$Reports$Memberships$viewSourceStatusDropdown = function (model) {
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Components$Reports$Memberships$sourceStatusToLabel(model.uM))
			]),
		$author$project$Components$Reports$Memberships$sourceStatuses(model.uM),
		model.qj);
};
var $author$project$Components$Reports$Memberships$SortTable = function (a) {
	return {$: 17, a: a};
};
var $author$project$Api$Provider$Reports$Membership$endDate = function (_v0) {
	var one = _v0.a;
	return one.sb;
};
var $author$project$Api$Provider$Reports$MembershipPatient$endDate = function (_v0) {
	var record = _v0;
	return record.sb;
};
var $author$project$Api$Provider$Reports$Patient$forMembershipAutopay = function (_v0) {
	var record = _v0;
	return record.Mm;
};
var $author$project$Api$Provider$Reports$Plan$Min$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Reports$Membership$lastBillAmountInCents = function (_v0) {
	var one = _v0.a;
	return one.VB;
};
var $author$project$Api$Provider$Reports$Membership$lastBillDate = function (_v0) {
	var one = _v0.a;
	return one.VC;
};
var $author$project$Api$Provider$Reports$MembershipPatient$membership = function (_v0) {
	var record = _v0;
	return record.kk;
};
var $author$project$Api$Provider$Reports$Plan$Min$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$Reports$Membership$nextBillDate = function (_v0) {
	var one = _v0.a;
	return one.XP;
};
var $author$project$Api$Provider$Reports$Membership$owner = function (_v0) {
	var one = _v0.a;
	return one.YD;
};
var $author$project$Api$Provider$Reports$MembershipPatient$patient = function (_v0) {
	var record = _v0;
	return record.YY;
};
var $author$project$Api$Provider$Reports$Membership$periodInMonths = function (_v0) {
	var one = _v0.a;
	return one.Zs;
};
var $author$project$Api$Provider$Reports$Membership$periodRateInCents = function (_v0) {
	var one = _v0.a;
	return one.Zt;
};
var $author$project$Api$Provider$Reports$Membership$plan = function (_v0) {
	var one = _v0.a;
	return one.Jb;
};
var $author$project$Api$Provider$Reports$Plan$Min$planType = function (_v0) {
	var record = _v0;
	return record.ZF;
};
var $author$project$Api$Provider$Reports$Membership$sourceStatus = function (_v0) {
	var one = _v0.a;
	return one.uM;
};
var $author$project$Api$Provider$Reports$MembershipPatient$startDate = function (_v0) {
	var record = _v0;
	return record.ab7;
};
var $author$project$Api$Provider$Reports$MembershipPatient$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Components$Reports$Memberships$membershipPatientToRow = function (membershipPatient) {
	var membership = $author$project$Api$Provider$Reports$MembershipPatient$membership(membershipPatient);
	var owner = $author$project$Api$Provider$Reports$Membership$owner(membership);
	var lastBillAmountInCents = A2(
		$elm$core$Maybe$withDefault,
		0,
		$author$project$Api$Provider$Reports$Membership$lastBillAmountInCents(membership));
	var isFixedFee = _Utils_eq(
		$author$project$Api$Provider$Reports$Plan$Min$planType(
			$author$project$Api$Provider$Reports$Membership$plan(membership)),
		$elm$core$Maybe$Just(1));
	var lastBillWasFixedFee = isFixedFee && (!lastBillAmountInCents);
	return {
		Mm: A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Reports$Patient$forMembershipAutopay, owner)),
		sb: A2(
			$elm$core$Maybe$withDefault,
			$author$project$Api$Provider$Reports$Membership$endDate(membership),
			A2(
				$elm$core$Maybe$map,
				$elm$core$Maybe$Just,
				$author$project$Api$Provider$Reports$MembershipPatient$endDate(membershipPatient))),
		Ak: isFixedFee,
		VB: lastBillAmountInCents,
		VC: $author$project$Api$Provider$Reports$Membership$lastBillDate(membership),
		Az: lastBillWasFixedFee,
		XP: $author$project$Api$Provider$Reports$Membership$nextBillDate(membership),
		YD: owner,
		YZ: $elm$core$Maybe$Just(
			$author$project$Api$Provider$Patient$Min$id(
				$author$project$Api$Provider$Reports$MembershipPatient$patient(membershipPatient))),
		Y1: $elm$core$Maybe$Just(
			$author$project$Api$Provider$Patient$Min$name(
				$author$project$Api$Provider$Reports$MembershipPatient$patient(membershipPatient))),
		CK: _List_Nil,
		Zs: $author$project$Api$Provider$Reports$Membership$periodInMonths(membership),
		Zt: $author$project$Api$Provider$Reports$Membership$periodRateInCents(membership),
		aj4: $author$project$Api$Provider$Reports$Plan$Min$id(
			$author$project$Api$Provider$Reports$Membership$plan(
				$author$project$Api$Provider$Reports$MembershipPatient$membership(membershipPatient))),
		ZE: $author$project$Api$Provider$Reports$Plan$Min$name(
			$author$project$Api$Provider$Reports$Membership$plan(
				$author$project$Api$Provider$Reports$MembershipPatient$membership(membershipPatient))),
		uM: $author$project$Api$Provider$Reports$Membership$sourceStatus(membership),
		ab7: $elm$core$Maybe$Just(
			$author$project$Api$Provider$Reports$MembershipPatient$startDate(membershipPatient)),
		alH: $author$project$Api$Provider$Reports$MembershipPatient$status(membershipPatient)
	};
};
var $author$project$Api$Provider$Reports$Membership$membershipPatients = function (_v0) {
	var all = _v0.b;
	return all.WR;
};
var $author$project$Api$Provider$Reports$MembershipPatient$ForMembership$patient = function (_v0) {
	var record = _v0;
	return record.YY;
};
var $author$project$Api$Provider$Reports$Membership$startDate = function (_v0) {
	var one = _v0.a;
	return one.ab7;
};
var $author$project$Api$Provider$Reports$Membership$status = function (_v0) {
	var one = _v0.a;
	return one.alH;
};
var $author$project$Components$Reports$Memberships$membershipToRow = function (membership) {
	var owner = $author$project$Api$Provider$Reports$Membership$owner(membership);
	var membershipPatients = $author$project$Api$Provider$Reports$Membership$membershipPatients(membership);
	var lastBillAmountInCents = A2(
		$elm$core$Maybe$withDefault,
		0,
		$author$project$Api$Provider$Reports$Membership$lastBillAmountInCents(membership));
	var isFixedFee = _Utils_eq(
		$author$project$Api$Provider$Reports$Plan$Min$planType(
			$author$project$Api$Provider$Reports$Membership$plan(membership)),
		$elm$core$Maybe$Just(1));
	var lastBillWasFixedFee = isFixedFee && (!lastBillAmountInCents);
	return {
		Mm: A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Reports$Patient$forMembershipAutopay, owner)),
		sb: $author$project$Api$Provider$Reports$Membership$endDate(membership),
		Ak: isFixedFee,
		VB: lastBillAmountInCents,
		VC: $author$project$Api$Provider$Reports$Membership$lastBillDate(membership),
		Az: lastBillWasFixedFee,
		XP: $author$project$Api$Provider$Reports$Membership$nextBillDate(membership),
		YD: owner,
		YZ: $elm$core$Maybe$Nothing,
		Y1: $elm$core$Maybe$Nothing,
		CK: A2(
			$elm$core$List$map,
			function (membershipPatient) {
				return $author$project$Api$Provider$Patient$Min$name(
					$author$project$Api$Provider$Reports$MembershipPatient$ForMembership$patient(membershipPatient));
			},
			membershipPatients),
		Zs: $author$project$Api$Provider$Reports$Membership$periodInMonths(membership),
		Zt: $author$project$Api$Provider$Reports$Membership$periodRateInCents(membership),
		aj4: $author$project$Api$Provider$Reports$Plan$Min$id(
			$author$project$Api$Provider$Reports$Membership$plan(membership)),
		ZE: $author$project$Api$Provider$Reports$Plan$Min$name(
			$author$project$Api$Provider$Reports$Membership$plan(membership)),
		uM: $author$project$Api$Provider$Reports$Membership$sourceStatus(membership),
		ab7: $author$project$Api$Provider$Reports$Membership$startDate(membership),
		alH: $author$project$Api$Provider$Reports$Membership$status(membership)
	};
};
var $author$project$Api$Provider$Reports$Patient$forMembershipId = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Reports$Patient$forMembershipName = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Components$Reports$Memberships$viewRow = F4(
	function (canGoToPatients, canGoToAdmin, showBy, _v0) {
		var owner = _v0.YD;
		var patientId = _v0.YZ;
		var patientName = _v0.Y1;
		var patientNames = _v0.CK;
		var status = _v0.alH;
		var startDate = _v0.ab7;
		var endDate = _v0.sb;
		var lastBillDate = _v0.VC;
		var lastBillWasFixedFee = _v0.Az;
		var lastBillAmountInCents = _v0.VB;
		var nextBillDate = _v0.XP;
		var isFixedFee = _v0.Ak;
		var periodRateInCents = _v0.Zt;
		var periodInMonths = _v0.Zs;
		var autopay = _v0.Mm;
		var sourceStatus = _v0.uM;
		var planName = _v0.ZE;
		var planId = _v0.aj4;
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					function () {
						var _v1 = _Utils_Tuple2(owner, canGoToPatients);
						if (!_v1.a.$) {
							if (_v1.b) {
								var owner_ = _v1.a.a;
								return _List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
											{
												YZ: $author$project$Api$Provider$Reports$Patient$forMembershipId(owner_)
											}),
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$text,
												_List_fromArray(
													[
														$author$project$Ui$Typography$phi(true)
													]),
												$author$project$Api$Provider$Reports$Patient$forMembershipName(owner_))
											]))
									]);
							} else {
								var owner_ = _v1.a.a;
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$text,
										_List_fromArray(
											[
												$author$project$Ui$Typography$phi(true)
											]),
										$author$project$Api$Provider$Reports$Patient$forMembershipName(owner_))
									]);
							}
						} else {
							var _v2 = _v1.a;
							return _List_Nil;
						}
					}()),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					function () {
						if (!showBy.$) {
							var _v4 = _Utils_Tuple2(canGoToPatients, patientId);
							if (_v4.a && (!_v4.b.$)) {
								var patientId_ = _v4.b.a;
								return _List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
											{YZ: patientId_}),
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$text,
												_List_fromArray(
													[
														$author$project$Ui$Typography$phi(true)
													]),
												A2($elm$core$Maybe$withDefault, '', patientName))
											]))
									]);
							} else {
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$text,
										_List_fromArray(
											[
												$author$project$Ui$Typography$phi(true)
											]),
										A2($elm$core$Maybe$withDefault, '', patientName))
									]);
							}
						} else {
							return A2(
								$elm$core$List$map,
								function (name) {
									return A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$phi]),
										_List_fromArray(
											[
												$elm$html$Html$text(name)
											]));
								},
								patientNames);
						}
					}()),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					canGoToAdmin ? _List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Admin__Plans__Id_String(
								{ahP: planId}),
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(planName)
								]))
						]) : _List_fromArray(
						[
							$elm$html$Html$text(planName)
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Ui$Badge$fromString, _List_Nil, status),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textMuted]),
							_List_fromArray(
								[
									function () {
									if (!endDate.$) {
										var endDate_ = endDate.a;
										return $elm$html$Html$text(
											'ending ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, endDate_));
									} else {
										return $elm$html$Html$text(
											'since ' + A2(
												$elm$core$Maybe$withDefault,
												'',
												A2(
													$elm$core$Maybe$map,
													$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
													startDate)));
									}
								}()
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					function () {
						if (!lastBillDate.$) {
							var lastBillDate_ = lastBillDate.a;
							return _List_fromArray(
								[
									$elm$html$Html$text(
									A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, lastBillDate_)),
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$helpBlock]),
									_List_fromArray(
										[
											lastBillWasFixedFee ? $elm$html$Html$text('Fixed Fee') : $elm$html$Html$text(
											'for ' + $author$project$Utils$Currency$fromInt(lastBillAmountInCents))
										]))
								]);
						} else {
							return _List_Nil;
						}
					}()),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					function () {
						if (!nextBillDate.$) {
							var nextBillDate_ = nextBillDate.a;
							return _List_fromArray(
								[
									$elm$html$Html$text(
									A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, nextBillDate_)),
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$helpBlock]),
									isFixedFee ? _List_fromArray(
										[
											$elm$html$Html$text('Fixed Fee'),
											((periodRateInCents - lastBillAmountInCents) > 0) ? $author$project$Ui$Icon$increase(
											_List_fromArray(
												[$author$project$Ui$Icon$danger])) : $author$project$Ui$Icon$decrease(
											_List_fromArray(
												[$author$project$Ui$Icon$success]))
										]) : _List_fromArray(
										[
											$elm$html$Html$text(
											'for ' + $author$project$Utils$Currency$fromInt(periodRateInCents))
										]))
								]);
						} else {
							return _List_Nil;
						}
					}()),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Formatters$Int$asPeriod(periodInMonths))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							'Autopay: ' + $author$project$Formatters$Bool$toString(autopay)),
							A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Source: '),
									A2(
									$author$project$Ui$Badge$fromString,
									_List_Nil,
									A2($elm$core$Maybe$withDefault, 'none', sourceStatus))
								]))
						]))
				]));
	});
var $author$project$Components$Reports$Memberships$viewTable = function (model) {
	var _v0 = function () {
		var _v1 = model.Pw;
		_v1$2:
		while (true) {
			if (!_v1.$) {
				if (_v1.a.$ === 3) {
					var _v2 = _v1.a;
					var membershipPatients = _v2.a;
					return _Utils_Tuple2(
						false,
						A2($elm$core$List$map, $author$project$Components$Reports$Memberships$membershipPatientToRow, membershipPatients));
				} else {
					break _v1$2;
				}
			} else {
				if (_v1.a.$ === 3) {
					var _v3 = _v1.a;
					var memberships = _v3.a;
					return _Utils_Tuple2(
						false,
						A2($elm$core$List$map, $author$project$Components$Reports$Memberships$membershipToRow, memberships));
				} else {
					break _v1$2;
				}
			}
		}
		return _Utils_Tuple2(true, _List_Nil);
	}();
	var loading = _v0.a;
	var rows = _v0.b;
	return A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$map,
					$author$project$Api$Column$view(
						A2($author$project$Api$Column$Sortable, model.alA, $author$project$Components$Reports$Memberships$SortTable)),
					model.N3),
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[$author$project$Ui$Table$textRight]),
						_List_fromArray(
							[
								A2($elm$html$Html$map, $author$project$Components$Reports$Memberships$ExportCsvMsg, $author$project$Components$ExportCsv$button)
							]))
					])
				])),
		A2(
			$elm$core$List$map,
			A3($author$project$Components$Reports$Memberships$viewRow, model.GQ, model.GO, model.Pw),
			rows),
		_List_Nil);
};
var $author$project$Components$Reports$Memberships$view = F2(
	function (apiClient, _v0) {
		var model = _v0;
		var totalCount = function () {
			var _v5 = model.Pw;
			if (!_v5.$) {
				var lastResponse_ = _v5.a;
				return $author$project$Api$Data$totalCount(lastResponse_);
			} else {
				var lastResponse_ = _v5.a;
				return $author$project$Api$Data$totalCount(lastResponse_);
			}
		}();
		var reportParams = function () {
			var _v4 = model.Pw;
			if (!_v4.$) {
				return A2($elm$core$Basics$composeL, $author$project$Api$Provider$Reports$MembershipPatient$listOptionsToParams, $author$project$Components$Reports$Memberships$fetchParams)(model);
			} else {
				return A2($elm$core$Basics$composeL, $author$project$Api$Provider$Reports$Membership$listOptionsToParams, $author$project$Components$Reports$Memberships$fetchParams)(model);
			}
		}();
		var loading = function () {
			var _v1 = model.Pw;
			_v1$2:
			while (true) {
				if (!_v1.$) {
					if (_v1.a.$ === 3) {
						var _v2 = _v1.a;
						return false;
					} else {
						break _v1$2;
					}
				} else {
					if (_v1.a.$ === 3) {
						var _v3 = _v1.a;
						return false;
					} else {
						break _v1$2;
					}
				}
			}
			return true;
		}();
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Reports$Memberships$ExportCsvMsg,
				A3(
					$author$project$Components$ExportCsv$modal,
					apiClient,
					_List_fromArray(
						[
							$author$project$Components$ExportCsv$report(totalCount),
							$author$project$Components$ExportCsv$reportParams(reportParams)
						]),
					model.nD)),
				A2(
				$elm$html$Html$map,
				$author$project$Components$Reports$Memberships$CustomerEmailModalMsg,
				$author$project$Components$CustomerEmailModal$modal(model.m5)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Memberships')
									])),
								A2(
								$author$project$Ui$Grid$row,
								_List_fromArray(
									[$author$project$Ui$Grid$gutterSm, $author$project$Ui$Grid$mt2]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(2)
											]),
										_List_fromArray(
											[
												$author$project$Components$Reports$Memberships$viewFilterDropdown(model)
											])),
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$spanSm(6)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Components$Reports$Memberships$DateRangeInputMsg,
												$author$project$Components$DateRangeInput$view(model.i4))
											])),
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$spanSm(4)
											]),
										_List_fromArray(
											[
												$author$project$Components$Reports$Memberships$viewShowByButtonGroup(model)
											]))
									])),
								A2(
								$author$project$Ui$Grid$row,
								_List_fromArray(
									[$author$project$Ui$Grid$gutterSm]),
								_Utils_ap(
									A2(
										$elm$core$List$map,
										A2(
											$elm$core$Basics$composeR,
											$elm$core$List$singleton,
											$author$project$Ui$Grid$column(
												_List_fromArray(
													[
														$author$project$Ui$Grid$span(6),
														$author$project$Ui$Grid$spanMd(4)
													]))),
										A2(
											$elm$core$List$map,
											$elm$html$Html$map($author$project$Components$Reports$Memberships$GroupLocationAndPractitionerFiltersMsg),
											A2(
												$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$view,
												_List_fromArray(
													[$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$multi]),
												model.dn))),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$span(6),
													$author$project$Ui$Grid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$Memberships$viewBillingPeriodDropdown(model)
												])),
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$span(6),
													$author$project$Ui$Grid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$Memberships$viewSourceStatusDropdown(model)
												])),
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$span(6),
													$author$project$Ui$Grid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$Memberships$viewAutopayDropdown(model)
												])),
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$span(6),
													$author$project$Ui$Grid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$Memberships$viewPlanResourceFilter(model.hi)
												])),
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$span(6),
													$author$project$Ui$Grid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$Memberships$viewCompanyResourceFilter(model.mZ)
												])),
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$span(6),
													$author$project$Ui$Grid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$Memberships$viewRateCalculationDropdown(model)
												])),
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$span(6),
													$author$project$Ui$Grid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$Memberships$viewCouponResourceFilter(model.iU)
												]))
										]))),
								A2(
								$author$project$Ui$Grid$row,
								_List_fromArray(
									[$author$project$Ui$Grid$gutterSm]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_Nil,
										function () {
											var activeFilters = _Utils_ap(
												A2(
													$elm$core$List$map,
													$elm$html$Html$map($author$project$Components$Reports$Memberships$PlanResourceFilterMsg),
													$author$project$Components$ResourceFilter$Plan$viewMultiSelected(model.hi)),
												_Utils_ap(
													A2(
														$elm$core$List$map,
														$elm$html$Html$map($author$project$Components$Reports$Memberships$CompanyResourceFilterMsg),
														$author$project$Components$ResourceFilter$Company$viewMultiSelected(model.mZ)),
													_Utils_ap(
														A2(
															$elm$core$List$map,
															$elm$html$Html$map($author$project$Components$Reports$Memberships$CouponResourceFilterMsg),
															$author$project$Components$ResourceFilter$Coupon$viewMultiSelected(model.iU)),
														A2(
															$elm$core$List$map,
															$elm$html$Html$map($author$project$Components$Reports$Memberships$GroupLocationAndPractitionerFiltersMsg),
															$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewMultiSelected(model.dn)))));
											return $elm$core$List$isEmpty(activeFilters) ? _List_Nil : _List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$mt2, $author$project$Ui$Element$mb2]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$strong,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Active filters')
																]))
														])),
													A2($elm$html$Html$span, _List_Nil, activeFilters)
												]);
										}())
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Components$Reports$Memberships$viewTable(model)
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$Reports$Memberships$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(loading)
										]),
									model.ajJ))
							]))
					]))
			]);
	});
var $author$project$Pages$Reports$Memberships$view = function (model) {
	return {
		fO: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			A2($author$project$Components$Reports$Memberships$view, model.Gv, model.kV)),
		ac9: 'Reports | Memberships'
	};
};
var $author$project$Pages$Reports$Memberships$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Reports$Memberships$init, aiq: $author$project$Pages$Reports$Memberships$load, k8: $author$project$Pages$Reports$Memberships$save, alO: $author$project$Pages$Reports$Memberships$subscriptions, adT: $author$project$Pages$Reports$Memberships$update, amo: $author$project$Pages$Reports$Memberships$view});
var $author$project$Pages$Reports$Months$GotReportingPeriods = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Reports$Months$fetchParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				HB: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.sb),
				ajJ: model.ajJ,
				alA: model.alA,
				JV: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.ab7)
			});
	};
};
var $author$project$Api$Provider$ReportingPeriod$All$ReportingPeriod = $elm$core$Basics$identity;
var $author$project$Api$Provider$ReportingPeriod$Shared$ReportingPeriod = $elm$core$Basics$identity;
var $author$project$Api$Provider$ReportingPeriod$Shared$Record = function (id) {
	return function (name) {
		return function (locked) {
			return function (isLockable) {
				return function (endDate) {
					return function (startDate) {
						return function (revenueInCents) {
							return function (receiptsInCents) {
								return function (stripeFeesInCents) {
									return function (hintFeesInCents) {
										return function (taxesInCents) {
											return function (creditsInCents) {
												return {O9: creditsInCents, sb: endDate, Tz: hintFeesInCents, ahP: id, UT: isLockable, Wi: locked, Bq: name, $c: receiptsInCents, $_: revenueInCents, ab7: startDate, acp: stripeFeesInCents, ac_: taxesInCents};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$ReportingPeriod$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'credits_in_cents',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'taxes_in_cents',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'hint_fees_in_cents',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'stripe_fees_in_cents',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'receipts_in_cents',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'revenue_in_cents',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'start_date',
							$author$project$Utils$Date$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'end_date',
								$author$project$Utils$Date$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'is_lockable',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'locked',
										$elm$json$Json$Decode$bool,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'name',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'id',
												$elm$json$Json$Decode$string,
												$elm$json$Json$Decode$succeed($author$project$Api$Provider$ReportingPeriod$Shared$Record)))))))))))));
var $author$project$Api$Provider$ReportingPeriod$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ReportingPeriod$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$ReportingPeriod$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ReportingPeriod$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$ReportingPeriod$listDefaults = {HB: $elm$core$Maybe$Nothing, ajJ: $author$project$Api$Pagination$init, alA: $author$project$Api$Sort$init, JV: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$ReportingPeriod$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$ReportingPeriod$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.JV;
				if (!_v0.$) {
					var start_ = _v0.a;
					return _List_fromArray(
						[
							A2(
							$author$project$Api$Param$string,
							'start',
							$author$project$Utils$Date$toQuery(start_))
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.HB;
				if (!_v1.$) {
					var end_ = _v1.a;
					return _List_fromArray(
						[
							A2(
							$author$project$Api$Param$string,
							'end',
							$author$project$Utils$Date$toQuery(end_))
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$Provider$ReportingPeriod$reportingPeriodsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['reporting_periods']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$ReportingPeriod$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$ReportingPeriod$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$ReportingPeriod$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$ReportingPeriod$reportingPeriodsPath)));
	});
var $author$project$Pages$Reports$Months$fetchReportingPeriods = function (model) {
	return A3(
		$author$project$Api$Provider$ReportingPeriod$list,
		model.Gv,
		$author$project$Pages$Reports$Months$fetchParams(model),
		$author$project$Pages$Reports$Months$GotReportingPeriods);
};
var $author$project$Pages$Reports$Months$init = F4(
	function (_v0, _v1, shared, _v2) {
		var query = _v2.DE;
		var _v3 = $author$project$Utils$DateWithDefault$fromQuery(query);
		var start = _v3.a;
		var end = _v3.b;
		var model = {
			Gv: shared.Gv,
			dd: shared.dd,
			sb: end,
			kc: $elm$core$Maybe$Nothing,
			kd: $elm$core$Set$empty,
			ajJ: A2($author$project$Api$Pagination$withItemsPerPage, 13, $author$project$Api$Pagination$init),
			pG: $author$project$Api$Data$Loading,
			alA: A3($author$project$Api$Sort$withDefault, 'start_date', 1, $author$project$Api$Sort$init),
			ab7: start,
			lS: $elm$core$Maybe$Nothing,
			lT: $elm$core$Set$empty
		};
		return _Utils_Tuple2(
			model,
			$author$project$Pages$Reports$Months$fetchReportingPeriods(model));
	});
var $author$project$Pages$Reports$Months$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{dd: shared.dd}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$Months$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Reports$Months$LockHiConfirmClosed = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$Reports$Months$UnlockHiConfirmClosed = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Reports$Months$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Reports$Months$UnlockHiConfirmClosed),
					model.lS)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Reports$Months$LockHiConfirmClosed),
					model.kc))
			]));
};
var $author$project$Pages$Reports$Months$ReportingPeriodLocked = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Reports$Months$ReportingPeriodUnlocked = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$ReportingPeriod$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$ReportingPeriod$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ReportingPeriod$Shared$id(shared);
};
var $author$project$Api$Provider$ReportingPeriod$One$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ReportingPeriod$Shared$id(shared);
};
var $author$project$Api$Provider$ReportingPeriod$One$ReportingPeriod = $elm$core$Basics$identity;
var $author$project$Api$Provider$ReportingPeriod$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ReportingPeriod$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$ReportingPeriod$reportingPeriodPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$ReportingPeriod$reportingPeriodsPath);
};
var $author$project$Api$Provider$ReportingPeriod$lock = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$ReportingPeriod$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'locked',
							$elm$json$Json$Encode$bool(true))
						])),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$ReportingPeriod$reportingPeriodPath(id_))));
	});
var $author$project$Api$Provider$ReportingPeriod$unlock = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$ReportingPeriod$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'locked',
							$elm$json$Json$Encode$bool(false))
						])),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$ReportingPeriod$reportingPeriodPath(id_))));
	});
var $author$project$Pages$Reports$Months$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{pG: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$reportDecodeError(response));
			case 1:
				var reportingPeriod = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							lS: $elm$core$Maybe$Just(reportingPeriod)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var reportingPeriod = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							kc: $elm$core$Maybe$Just(reportingPeriod)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var reportingPeriod = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							lS: $elm$core$Maybe$Nothing,
							lT: A2(
								$elm$core$Set$insert,
								$author$project$Api$Provider$ReportingPeriod$All$id(reportingPeriod),
								model.lT)
						}),
					A3(
						$author$project$Api$Provider$ReportingPeriod$unlock,
						model.Gv,
						$author$project$Api$Provider$ReportingPeriod$All$id(reportingPeriod),
						$author$project$Pages$Reports$Months$ReportingPeriodUnlocked),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{lS: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var reportingPeriod = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							kc: $elm$core$Maybe$Nothing,
							kd: A2(
								$elm$core$Set$insert,
								$author$project$Api$Provider$ReportingPeriod$All$id(reportingPeriod),
								model.kd)
						}),
					A3(
						$author$project$Api$Provider$ReportingPeriod$lock,
						model.Gv,
						$author$project$Api$Provider$ReportingPeriod$All$id(reportingPeriod),
						$author$project$Pages$Reports$Months$ReportingPeriodLocked),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{kc: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					var reportingPeriod = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								pG: $author$project$Api$Data$Loading,
								lT: A2(
									$elm$core$Set$remove,
									$author$project$Api$Provider$ReportingPeriod$One$id(reportingPeriod),
									model.lT)
							}),
						$author$project$Pages$Reports$Months$fetchReportingPeriods(model),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Reporting period unlocked')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var reportingPeriod = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								kd: A2(
									$elm$core$Set$remove,
									$author$project$Api$Provider$ReportingPeriod$One$id(reportingPeriod),
									model.kd),
								pG: $author$project$Api$Data$Loading
							}),
						$author$project$Pages$Reports$Months$fetchReportingPeriods(model),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Reporting period locked')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Api$Provider$ReportingPeriod$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$ReportingPeriod$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ReportingPeriod$Shared$name(shared);
};
var $author$project$Pages$Reports$Months$UnlockReportingPeriod = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$ReportingPeriod$Shared$endDate = function (_v0) {
	var record = _v0;
	return record.sb;
};
var $author$project$Api$Provider$ReportingPeriod$All$endDate = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ReportingPeriod$Shared$endDate(shared);
};
var $author$project$Api$Provider$ReportingPeriod$Shared$isLockable = function (_v0) {
	var record = _v0;
	return record.UT;
};
var $author$project$Api$Provider$ReportingPeriod$All$isLockable = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ReportingPeriod$Shared$isLockable(shared);
};
var $author$project$Api$Provider$ReportingPeriod$Shared$locked = function (_v0) {
	var record = _v0;
	return record.Wi;
};
var $author$project$Api$Provider$ReportingPeriod$All$locked = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ReportingPeriod$Shared$locked(shared);
};
var $author$project$Api$Provider$ReportingPeriod$Shared$startDate = function (_v0) {
	var record = _v0;
	return record.ab7;
};
var $author$project$Api$Provider$ReportingPeriod$All$startDate = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ReportingPeriod$Shared$startDate(shared);
};
var $author$project$Pages$Reports$Months$LockReportingPeriod = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Reports$Months$viewLockButton = F3(
	function (unlockingReportingPeriods, lockingReportingPeriods, reportingPeriod) {
		var locked = $author$project$Api$Provider$ReportingPeriod$All$locked(reportingPeriod);
		var id = $author$project$Api$Provider$ReportingPeriod$All$id(reportingPeriod);
		var locking = A2($elm$core$Set$member, id, lockingReportingPeriods);
		var unlocking = A2($elm$core$Set$member, id, unlockingReportingPeriods);
		var label = locking ? 'Locking...' : (unlocking ? 'Unlocking...' : (locked ? 'Locked' : 'Lock'));
		var buttonStyle = function () {
			var _v0 = _Utils_Tuple2(locked, unlocking);
			if (_v0.a && (!_v0.b)) {
				return 1;
			} else {
				return 0;
			}
		}();
		var buttonEnabled = (!(locked || locking)) && $author$project$Api$Provider$ReportingPeriod$All$isLockable(reportingPeriod);
		return A3(
			$author$project$Ui$Button$view,
			{mm: label},
			_List_fromArray(
				[
					$author$project$Ui$Button$styled(buttonStyle),
					$author$project$Ui$Button$loading(locking || unlocking),
					$author$project$Ui$Button$disabled(!buttonEnabled),
					$author$project$Ui$Button$onClick(
					$author$project$Pages$Reports$Months$LockReportingPeriod(reportingPeriod)),
					$author$project$Ui$Button$icon($author$project$Ui$Icon$lock)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Api$Provider$ReportingPeriod$Shared$creditsInCents = function (_v0) {
	var record = _v0;
	return record.O9;
};
var $author$project$Api$Provider$ReportingPeriod$All$creditsInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ReportingPeriod$Shared$creditsInCents(shared);
};
var $author$project$Api$Provider$ReportingPeriod$Shared$hintFeesInCents = function (_v0) {
	var record = _v0;
	return record.Tz;
};
var $author$project$Api$Provider$ReportingPeriod$All$hintFeesInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ReportingPeriod$Shared$hintFeesInCents(shared);
};
var $author$project$Ui$Panel$Primary = 0;
var $author$project$Ui$Panel$primary = $author$project$Ui$Panel$Styling(0);
var $author$project$Api$Provider$ReportingPeriod$Shared$receiptsInCents = function (_v0) {
	var record = _v0;
	return record.$c;
};
var $author$project$Api$Provider$ReportingPeriod$All$receiptsInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ReportingPeriod$Shared$receiptsInCents(shared);
};
var $author$project$Api$Provider$ReportingPeriod$Shared$revenueInCents = function (_v0) {
	var record = _v0;
	return record.$_;
};
var $author$project$Api$Provider$ReportingPeriod$All$revenueInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ReportingPeriod$Shared$revenueInCents(shared);
};
var $author$project$Api$Provider$ReportingPeriod$Shared$stripeFeesInCents = function (_v0) {
	var record = _v0;
	return record.acp;
};
var $author$project$Api$Provider$ReportingPeriod$All$stripeFeesInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ReportingPeriod$Shared$stripeFeesInCents(shared);
};
var $author$project$Api$Provider$ReportingPeriod$Shared$taxesInCents = function (_v0) {
	var record = _v0;
	return record.ac_;
};
var $author$project$Api$Provider$ReportingPeriod$All$taxesInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ReportingPeriod$Shared$taxesInCents(shared);
};
var $author$project$Pages$Reports$Months$viewMetric = F5(
	function (label, route, start, end, cents) {
		var reportParams = _List_fromArray(
			[
				A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('start'),
				$author$project$Utils$Date$toQuery)(start),
				A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('end'),
				$author$project$Utils$Date$toQuery)(end)
			]);
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label(label),
					$author$project$Ui$Form$Group$labelSpan(6),
					$author$project$Ui$Form$Group$inputSpan(6),
					$author$project$Ui$Form$Group$labelClass('')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_fromArray(
						[$author$project$Ui$Form$Static$numeric]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							route,
							_List_fromArray(
								[
									$author$project$Ui$Link$routeParams(reportParams)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(cents))
								]))
						]))
				]));
	});
var $author$project$Pages$Reports$Months$viewPanel = function (reportingPeriod) {
	var startDate = $author$project$Api$Provider$ReportingPeriod$All$startDate(reportingPeriod);
	var panelOptions = $author$project$Api$Provider$ReportingPeriod$All$locked(reportingPeriod) ? _List_fromArray(
		[$author$project$Ui$Panel$primary]) : _List_Nil;
	var endDate = $author$project$Api$Provider$ReportingPeriod$All$endDate(reportingPeriod);
	return A2(
		$author$project$Ui$Panel$view,
		panelOptions,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						A5(
						$author$project$Pages$Reports$Months$viewMetric,
						'Billed Revenue',
						$author$project$Spa$Generated$Route$Reports__Revenue,
						startDate,
						endDate,
						$author$project$Api$Provider$ReportingPeriod$All$revenueInCents(reportingPeriod)),
						A5(
						$author$project$Pages$Reports$Months$viewMetric,
						'Payments Received',
						$author$project$Spa$Generated$Route$Reports__PaymentApplications,
						startDate,
						endDate,
						$author$project$Api$Provider$ReportingPeriod$All$receiptsInCents(reportingPeriod)),
						A5(
						$author$project$Pages$Reports$Months$viewMetric,
						'Fees',
						$author$project$Spa$Generated$Route$Reports__PaymentApplications,
						startDate,
						endDate,
						$author$project$Api$Provider$ReportingPeriod$All$hintFeesInCents(reportingPeriod) + $author$project$Api$Provider$ReportingPeriod$All$stripeFeesInCents(reportingPeriod)),
						A5(
						$author$project$Pages$Reports$Months$viewMetric,
						'Taxes',
						$author$project$Spa$Generated$Route$Reports__SalesTax,
						startDate,
						endDate,
						$author$project$Api$Provider$ReportingPeriod$All$taxesInCents(reportingPeriod)),
						A5(
						$author$project$Pages$Reports$Months$viewMetric,
						'Credits',
						$author$project$Spa$Generated$Route$Reports__CreditTransactions,
						startDate,
						endDate,
						$author$project$Api$Provider$ReportingPeriod$All$creditsInCents(reportingPeriod))
					]))
			]));
};
var $author$project$Pages$Reports$Months$viewReportingPeriod = F3(
	function (unlockingReportingPeriods, lockingReportingPeriods, reportingPeriod) {
		var locked = $author$project$Api$Provider$ReportingPeriod$All$locked(reportingPeriod);
		return A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h3,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Provider$ReportingPeriod$All$name(reportingPeriod))
										])),
									A3($author$project$Pages$Reports$Months$viewLockButton, unlockingReportingPeriods, lockingReportingPeriods, reportingPeriod)
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$spaceBetween]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$helpBlock]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											'Period from ' + (A2(
												$author$project$Formatters$Date$toString,
												$author$project$Formatters$Date$Full,
												$author$project$Api$Provider$ReportingPeriod$All$startDate(reportingPeriod)) + (' to ' + A2(
												$author$project$Formatters$Date$toString,
												$author$project$Formatters$Date$Full,
												$author$project$Api$Provider$ReportingPeriod$All$endDate(reportingPeriod)))))
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textMuted]),
									locked ? _List_fromArray(
										[
											$elm$html$Html$text('If you need to update charges for this period you can '),
											A3(
											$author$project$Ui$Button$view,
											{mm: 'Unlock this reporting period'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick(
													$author$project$Pages$Reports$Months$UnlockReportingPeriod(reportingPeriod))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('unlock this reporting period')
												]))
										]) : (((!$author$project$Api$Provider$ReportingPeriod$All$locked(reportingPeriod)) && (!$author$project$Api$Provider$ReportingPeriod$All$isLockable(reportingPeriod))) ? _List_fromArray(
										[
											$elm$html$Html$text(
											'The current reporting period cannot be locked until it is complete on ' + A2(
												$author$project$Formatters$Date$toString,
												$author$project$Formatters$Date$Full,
												$author$project$Api$Provider$ReportingPeriod$All$endDate(reportingPeriod)))
										]) : _List_Nil))
								])),
							$author$project$Pages$Reports$Months$viewPanel(reportingPeriod)
						]))
				]));
	});
var $author$project$Pages$Reports$Months$viewReportingPeriodSkeleton = function (panel) {
	return A2(
		$author$project$Ui$Grid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$column,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Skeleton$text(
										_List_fromArray(
											[
												$author$project$Ui$Skeleton$spanFromText('February')
											]))
									])),
								$author$project$Ui$Skeleton$input(
								_List_fromArray(
									[
										$author$project$Ui$Skeleton$spanFromText('  Lock  ')
									]))
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$text(
								_List_fromArray(
									[
										$author$project$Ui$Skeleton$span(4)
									]))
							])),
						panel
					]))
			]));
}(
	A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		$elm$core$List$singleton(
			A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				A2(
					$elm$core$List$map,
					function (label) {
						return A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$labelSkeleton(label),
									$author$project$Ui$Form$Group$labelSpan(6),
									$author$project$Ui$Form$Group$inputSpan(6),
									$author$project$Ui$Form$Group$labelClass('')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Static$view,
									_List_fromArray(
										[$author$project$Ui$Form$Static$numeric]),
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$text(
											_List_fromArray(
												[
													$author$project$Ui$Skeleton$spanFromText('$100.00')
												]))
										]))
								]));
					},
					_List_fromArray(
						['Billed Revenue', 'Payments Received', 'Fees', 'Taxes']))))));
var $author$project$Pages$Reports$Months$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				function () {
				var _v0 = model.lS;
				if (!_v0.$) {
					var reportingPeriod = _v0.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Reports$Months$UnlockHiConfirmClosed(reportingPeriod),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('unlock'),
								$author$project$Components$HiConfirm$noun(
								$author$project$Api$Provider$ReportingPeriod$All$name(reportingPeriod)),
								$author$project$Components$HiConfirm$customMessage(
								_List_fromArray(
									[
										$elm$html$Html$text(
										'Are you sure you want to unlock your ' + ($author$project$Api$Provider$ReportingPeriod$All$name(reportingPeriod) + ' reporting period? This will allow updating of charges made during this period which may alter your revenue, payment, tax or credit reports.'))
									]))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v1 = model.kc;
				if (!_v1.$) {
					var reportingPeriod = _v1.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Reports$Months$LockHiConfirmClosed(reportingPeriod),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('lock'),
								$author$project$Components$HiConfirm$noun(
								$author$project$Api$Provider$ReportingPeriod$All$name(reportingPeriod)),
								$author$project$Components$HiConfirm$customMessage(
								_List_fromArray(
									[
										$elm$html$Html$text(
										'Locking your ' + ($author$project$Api$Provider$ReportingPeriod$All$name(reportingPeriod) + ' reporting period will completely lock down invoices made in this period and ensure your revenue, payments, tax and credit transaction reports cannot change.'))
									]))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v2 = model.pG;
				if (_v2.$ === 3) {
					var reportingPeriods = _v2.a;
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						A2(
							$elm$core$List$map,
							A2($author$project$Pages$Reports$Months$viewReportingPeriod, model.lT, model.kd),
							reportingPeriods));
				} else {
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						A2($elm$core$List$repeat, 12, $author$project$Pages$Reports$Months$viewReportingPeriodSkeleton));
				}
			}()
			]),
		ac9: 'Reports | Reporting Periods'
	};
};
var $author$project$Pages$Reports$Months$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Reports$Months$init, aiq: $author$project$Pages$Reports$Months$load, k8: $author$project$Pages$Reports$Months$save, alO: $author$project$Pages$Reports$Months$subscriptions, adT: $author$project$Pages$Reports$Months$update, amo: $author$project$Pages$Reports$Months$view});
var $author$project$Pages$Reports$PatientPackages$ReportMsg = $elm$core$Basics$identity;
var $author$project$Components$Reports$PatientPackages$DateRangeInputMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Reports$PatientPackages$Model = $elm$core$Basics$identity;
var $author$project$Components$Reports$PatientPackages$PackageFilterMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$Report$PatientPackage = 16;
var $author$project$Components$Reports$PatientPackages$StatusDropdownMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Reports$PatientPackages$statusToValue = function (status) {
	switch (status) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Just('active');
		default:
			return $elm$core$Maybe$Just('ended');
	}
};
var $author$project$Components$Reports$PatientPackages$buildUrl = function (model) {
	var statusParam = function () {
		var _v1 = $author$project$Components$Reports$PatientPackages$statusToValue(model.hN);
		if (!_v1.$) {
			var value = _v1.a;
			return _List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'status', value)
				]);
		} else {
			return _List_Nil;
		}
	}();
	var packageParam = function () {
		var _v0 = model.kw;
		if (!_v0.$) {
			var ids = _v0.a;
			return _List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'package', ids)
				]);
		} else {
			return _List_Nil;
		}
	}();
	var dateParams = A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$map,
				function (d) {
					return A2(
						$elm$url$Url$Builder$string,
						'start',
						A3($author$project$Utils$DateWithDefault$toQuery, model.dd, 0, d));
				},
				model.JV),
				A2(
				$elm$core$Maybe$map,
				function (d) {
					return A2(
						$elm$url$Url$Builder$string,
						'end',
						A3($author$project$Utils$DateWithDefault$toQuery, model.dd, 0, d));
				},
				model.HB)
			]));
	return A2(
		$elm$url$Url$Builder$relative,
		_List_fromArray(
			[
				$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__PatientPackages)
			]),
		A2(
			$elm$core$List$append,
			$author$project$Api$Pagination$toPageQuery(model.ajJ),
			A2(
				$elm$core$List$append,
				$author$project$Api$Sort$toQuery(model.alA),
				_Utils_ap(
					statusParam,
					_Utils_ap(packageParam, dateParams)))));
};
var $author$project$Components$Reports$PatientPackages$priorMonthAdditionalItems = function (today) {
	var priorMonthStart = A2(
		$justinmimbs$date$Date$floor,
		2,
		A3($justinmimbs$date$Date$add, 1, -1, today));
	var priorMonthEnd = A3(
		$justinmimbs$date$Date$add,
		3,
		-1,
		A2($justinmimbs$date$Date$floor, 2, today));
	return _List_fromArray(
		[
			{
			HB: $elm$core$Maybe$Just(priorMonthEnd),
			ahP: 'prior-month',
			aih: 'Prior Month',
			JV: $elm$core$Maybe$Just(priorMonthStart)
		}
		]);
};
var $author$project$Components$Reports$PatientPackages$dateRangeInputSettings = F3(
	function (_v0, fromDate, toDate) {
		var defaults = $author$project$Components$DateRangeInput$defaultSettings;
		return _Utils_update(
			defaults,
			{ma: $author$project$Components$Reports$PatientPackages$priorMonthAdditionalItems, ahy: fromDate, al5: toDate});
	});
var $author$project$Components$Reports$PatientPackages$GotData = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Reports$PatientPackages$fetchParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				HB: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.HB),
				tA: model.kw,
				ajJ: model.ajJ,
				alA: model.alA,
				JV: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.JV),
				alH: $author$project$Components$Reports$PatientPackages$statusToValue(model.hN)
			});
	};
};
var $author$project$Api$Provider$Reports$PatientPackage$PatientPackage = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$PatientPackage$Record = F6(
	function (status, purchasedOn, itemsRemaining, patient, package_, invoice) {
		return {Uk: invoice, Vt: itemsRemaining, tA: package_, YY: patient, _L: purchasedOn, alH: status};
	});
var $author$project$Api$Provider$Reports$PatientPackage$InvoiceRow = function (id) {
	return {ahP: id};
};
var $author$project$Api$Provider$Reports$PatientPackage$invoiceRowDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'id',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$PatientPackage$InvoiceRow));
var $author$project$Api$Provider$Reports$PatientPackage$PackageRow = F2(
	function (id, name) {
		return {ahP: id, Bq: name};
	});
var $author$project$Api$Provider$Reports$PatientPackage$packageRowDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$PatientPackage$PackageRow)));
var $author$project$Api$Provider$Reports$PatientPackage$PatientRow = F2(
	function (id, name) {
		return {ahP: id, Bq: name};
	});
var $author$project$Api$Provider$Reports$PatientPackage$patientRowDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$PatientPackage$PatientRow)));
var $author$project$Api$Provider$Reports$PatientPackage$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'invoice',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Reports$PatientPackage$invoiceRowDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'package',
		$author$project$Api$Provider$Reports$PatientPackage$packageRowDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'patient',
			$author$project$Api$Provider$Reports$PatientPackage$patientRowDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'items_remaining',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'purchased_on',
					$author$project$Utils$Date$decode,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'status',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$PatientPackage$Record)))))));
var $author$project$Api$Provider$Reports$PatientPackage$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Reports$PatientPackage$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$PatientPackage$listDefaults = {
	HB: $elm$core$Maybe$Nothing,
	tA: $elm$core$Maybe$Nothing,
	ajJ: $author$project$Api$Pagination$init,
	alA: A3($author$project$Api$Sort$withDefault, 'created_at', 1, $author$project$Api$Sort$init),
	JV: $elm$core$Maybe$Nothing,
	alH: $elm$core$Maybe$Nothing
};
var $author$project$Api$Provider$Reports$PatientPackage$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Reports$PatientPackage$listDefaults);
	return A2(
		$elm$core$List$append,
		$author$project$Api$Pagination$toApiParams(options.ajJ),
		A2(
			$elm$core$List$append,
			$author$project$Api$Sort$toParams(options.alA),
			$elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						var _v0 = options.JV;
						if (!_v0.$) {
							var date = _v0.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'start', date)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v1 = options.HB;
						if (!_v1.$) {
							var date = _v1.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'end', date)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v2 = options.alH;
						if (!_v2.$) {
							var s = _v2.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'status', s)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v3 = options.tA;
						if (!_v3.$) {
							var idents = _v3.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'package', idents)
								]);
						} else {
							return _List_Nil;
						}
					}()
					]))));
};
var $author$project$Api$Provider$Reports$PatientPackage$listPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['reports', 'patient_packages']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Reports$PatientPackage$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Reports$PatientPackage$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Reports$PatientPackage$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$PatientPackage$listPath)));
	});
var $author$project$Components$Reports$PatientPackages$fetchData = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Api$Provider$Reports$PatientPackage$list,
			apiClient,
			$author$project$Components$Reports$PatientPackages$fetchParams(model),
			$author$project$Components$Reports$PatientPackages$GotData);
	});
var $author$project$Components$Reports$PatientPackages$initColumns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'patient', false, 'Patient'),
		A3($author$project$Api$Column$init, 'package', false, 'Package'),
		A3($author$project$Api$Column$init, 'status', false, 'Status'),
		A3($author$project$Api$Column$init, 'created_at', true, 'Purchase Date'),
		A3($author$project$Api$Column$init, 'items_remaining', false, 'Items Remaining')
	]);
var $author$project$Components$Reports$PatientPackages$AllStatuses = 0;
var $author$project$Components$Reports$PatientPackages$OnlyActive = 1;
var $author$project$Components$Reports$PatientPackages$OnlyEnded = 2;
var $author$project$Components$Reports$PatientPackages$statusFromQuery = function (query) {
	_v0$2:
	while (true) {
		if (!query.$) {
			switch (query.a) {
				case 'active':
					return 1;
				case 'ended':
					return 2;
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return 0;
};
var $author$project$Components$Reports$PatientPackages$init = F4(
	function (session, _v0, _v1, query) {
		var currentDate = _v1.dd;
		var apiClient = _v1.Gv;
		var hinterViewOff = _v1.ahK;
		var statusFilter = $author$project$Components$Reports$PatientPackages$statusFromQuery(
			A2($elm$core$Dict$get, 'status', query));
		var statusDropdown = $author$project$Ui$Dropdown$init(
			$author$project$Ui$Dropdown$defaultConfig(
				{ahP: 'patient-packages-status-dropdown', al6: $author$project$Components$Reports$PatientPackages$StatusDropdownMsg}));
		var packageIds = A2($elm$core$Dict$get, 'package', query);
		var _v2 = A4(
			$author$project$Components$ResourceFilter$ChargeItem$initWithItemType,
			true,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						sW: $elm$core$Maybe$Just(
							$author$project$Api$Provider$ChargeItem$Shared$itemTypeToString(1))
					});
			},
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'All Packages', akb: packageIds});
			});
		var packageFilter = _v2.a;
		var packageFilterCmd = _v2.b;
		var _v3 = $author$project$Utils$DateWithDefault$fromQuery(query);
		var start = _v3.a;
		var end = _v3.b;
		var _v4 = A2(
			$author$project$Components$DateRangeInput$init,
			'patient-packages-date-range',
			A3(
				$author$project$Components$Reports$PatientPackages$dateRangeInputSettings,
				currentDate,
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					start),
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					end)));
		var dateRangeInput = _v4.a;
		var dateRangeInputCmd = _v4.b;
		var model = {
			GO: A3($author$project$Permission$canGoTo, session, hinterViewOff, 0),
			GQ: A3($author$project$Permission$canGoTo, session, hinterViewOff, 50),
			N3: $author$project$Components$Reports$PatientPackages$initColumns,
			dd: currentDate,
			Pw: $author$project$Api$Data$Loading,
			i4: dateRangeInput,
			HB: end,
			nD: $author$project$Components$ExportCsv$initForPractice(16),
			oP: packageFilter,
			kw: packageIds,
			ajJ: $author$project$Api$Pagination$initFromQuery(query),
			alA: A3(
				$author$project$Api$Sort$withDefault,
				'created_at',
				1,
				$author$project$Api$Sort$initFromQuery(query)),
			JV: start,
			qn: statusDropdown,
			hN: statusFilter
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PatientPackages$DateRangeInputMsg, dateRangeInputCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PatientPackages$PackageFilterMsg, packageFilterCmd),
						A2($author$project$Components$Reports$PatientPackages$fetchData, apiClient, model),
						A2($elm$core$Basics$composeR, $author$project$Components$Reports$PatientPackages$buildUrl, $author$project$Ports$Navigation$replaceUrl)(model)
					])));
	});
var $author$project$Pages$Reports$PatientPackages$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.DE;
		var _v1 = A4($author$project$Components$Reports$PatientPackages$init, session, practice, shared, query);
		var report = _v1.a;
		var reportCmd = _v1.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, kV: report},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportCmd));
	});
var $author$project$Pages$Reports$PatientPackages$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$PatientPackages$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Reports$PatientPackages$ExportCsvMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Reports$PatientPackages$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$PatientPackages$DateRangeInputMsg,
				$author$project$Components$DateRangeInput$subscriptions(model.i4)),
				$author$project$Ui$Dropdown$subscriptions(model.qn),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$PatientPackages$PackageFilterMsg,
				$author$project$Components$ResourceFilter$ChargeItem$subscriptions(model.oP)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$PatientPackages$ExportCsvMsg,
				$author$project$Components$ExportCsv$subscriptions(model.nD))
			]));
};
var $author$project$Pages$Reports$PatientPackages$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Reports$PatientPackages$subscriptions(model.kV));
};
var $author$project$Components$ResourceFilter$ChargeItem$value = function (model) {
	return A2($author$project$Components$ResourceFilter$choiceToValue, model.b8, model.Jy);
};
var $author$project$Components$Reports$PatientPackages$updateRecord = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Pw: response,
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Pw: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{Pw: $author$project$Api$Data$Loading, ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$PatientPackages$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$PatientPackages$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 2:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						Pw: $author$project$Api$Data$Loading,
						alA: A2($author$project$Api$Sort$update, columnId, model.alA)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$PatientPackages$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$PatientPackages$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 3:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Components$DateRangeInput$update, subMsg, model.i4);
				var dateRangeInput = _v2.a;
				var subCmd = _v2.b;
				var event = _v2.c;
				var _v3 = function () {
					if (event.$ === 1) {
						var fromDate = event.a;
						var toDate = event.b;
						return _Utils_Tuple2(
							A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate),
							A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate));
					} else {
						return _Utils_Tuple2(model.JV, model.HB);
					}
				}();
				var newStart = _v3.a;
				var newEnd = _v3.b;
				var changed = (!_Utils_eq(newStart, model.JV)) || (!_Utils_eq(newEnd, model.HB));
				var newModel = changed ? _Utils_update(
					model,
					{
						Pw: $author$project$Api$Data$Loading,
						i4: dateRangeInput,
						HB: newEnd,
						ajJ: $author$project$Api$Pagination$reset(model.ajJ),
						JV: newStart
					}) : _Utils_update(
					model,
					{i4: dateRangeInput});
				var cmds = changed ? _List_fromArray(
					[
						A2($author$project$Components$Reports$PatientPackages$fetchData, apiClient, newModel),
						A2($elm$core$Basics$composeR, $author$project$Components$Reports$PatientPackages$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
					]) : _List_Nil;
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$cons,
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PatientPackages$DateRangeInputMsg, subCmd),
							cmds)),
					_List_Nil);
			case 4:
				var subMsg = msg.a;
				var _v5 = A2($author$project$Ui$Dropdown$update, subMsg, model.qn);
				var dropdown = _v5.a;
				var subCmd = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qn: dropdown}),
					subCmd,
					_List_Nil);
			case 5:
				var newStatus = msg.a;
				var changed = !_Utils_eq(newStatus, model.hN);
				var newModel = _Utils_update(
					model,
					{
						Pw: changed ? $author$project$Api$Data$Loading : model.Pw,
						ajJ: changed ? $author$project$Api$Pagination$reset(model.ajJ) : model.ajJ,
						hN: newStatus
					});
				return _Utils_Tuple3(
					newModel,
					changed ? $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$PatientPackages$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$PatientPackages$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])) : $elm$core$Platform$Cmd$none,
					_List_Nil);
			case 6:
				var subMsg = msg.a;
				var packageResult = A3($author$project$Components$ResourceFilter$ChargeItem$update, apiClient, subMsg, model.oP);
				var newPackageIds = function () {
					var _v6 = packageResult.agZ;
					if (!_v6.$) {
						return $author$project$Components$ResourceFilter$ChargeItem$value(packageResult.aiO);
					} else {
						return model.kw;
					}
				}();
				var changed = !_Utils_eq(newPackageIds, model.kw);
				var newModel = _Utils_update(
					model,
					{
						Pw: changed ? $author$project$Api$Data$Loading : model.Pw,
						oP: packageResult.aiO,
						kw: newPackageIds,
						ajJ: changed ? $author$project$Api$Pagination$reset(model.ajJ) : model.ajJ
					});
				var cmd = changed ? $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2($author$project$Components$Reports$PatientPackages$fetchData, apiClient, newModel),
							A2($elm$core$Basics$composeR, $author$project$Components$Reports$PatientPackages$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
						])) : $elm$core$Platform$Cmd$none;
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PatientPackages$PackageFilterMsg, packageResult.GZ),
								cmd
							])),
					packageResult.aR);
			default:
				var subMsg = msg.a;
				var _v7 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.nD);
				var exportCsv = _v7.a;
				var subCmd = _v7.b;
				var subOutMsg = _v7.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nD: exportCsv}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PatientPackages$ExportCsvMsg, subCmd),
					subOutMsg);
		}
	});
var $author$project$Components$Reports$PatientPackages$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		var wrap = function (_v1) {
			var m = _v1.a;
			var cmd = _v1.b;
			var outMsgs = _v1.c;
			return _Utils_Tuple3(m, cmd, outMsgs);
		};
		return wrap(
			A3($author$project$Components$Reports$PatientPackages$updateRecord, apiClient, msg, model));
	});
var $author$project$Pages$Reports$PatientPackages$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Reports$PatientPackages$update, model.Gv, subMsg, model.kV);
		var report = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{kV: report}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Components$Reports$PatientPackages$PaginationMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Reports$PatientPackages$isLoading = function (data) {
	if (data.$ === 3) {
		return false;
	} else {
		return true;
	}
};
var $author$project$Components$Reports$PatientPackages$viewPackageFilter = function (packageFilter) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Reports$PatientPackages$PackageFilterMsg,
		A2(
			$author$project$Components$ResourceFilter$ChargeItem$view,
			_List_fromArray(
				[
					$author$project$Components$ResourceFilter$style(1),
					$author$project$Components$ResourceFilter$multi
				]),
			packageFilter));
};
var $author$project$Components$Reports$PatientPackages$StatusSelected = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Reports$PatientPackages$statusToLabel = function (status) {
	switch (status) {
		case 0:
			return 'All Statuses';
		case 1:
			return 'Active';
		default:
			return 'Ended';
	}
};
var $author$project$Components$Reports$PatientPackages$statusDropdownItems = function (current) {
	return A2(
		$elm$core$List$map,
		function (option) {
			return A2(
				$author$project$Ui$Dropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$Dropdown$selected(
						_Utils_eq(option, current)),
						$author$project$Ui$Dropdown$onSelect(
						$author$project$Components$Reports$PatientPackages$StatusSelected(option))
					]),
				$elm$html$Html$text(
					$author$project$Components$Reports$PatientPackages$statusToLabel(option)));
		},
		_List_fromArray(
			[0, 1, 2]));
};
var $author$project$Components$Reports$PatientPackages$viewStatusDropdown = function (model) {
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Components$Reports$PatientPackages$statusToLabel(model.hN))
			]),
		$author$project$Components$Reports$PatientPackages$statusDropdownItems(model.hN),
		model.qn);
};
var $author$project$Components$Reports$PatientPackages$SortTable = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Reports$PatientPackages$humanizeStatus = function (status) {
	switch (status) {
		case 'active':
			return 'Active';
		case 'ended':
			return 'Ended';
		default:
			var other = status;
			return other;
	}
};
var $author$project$Api$Provider$Reports$PatientPackage$invoiceId = function (_v0) {
	var record = _v0;
	return A2(
		$elm$core$Maybe$map,
		function ($) {
			return $.ahP;
		},
		record.Uk);
};
var $author$project$Api$Provider$Reports$PatientPackage$itemsRemaining = function (_v0) {
	var record = _v0;
	return record.Vt;
};
var $author$project$Api$Provider$Reports$PatientPackage$packageName = function (_v0) {
	var record = _v0;
	return record.tA.Bq;
};
var $author$project$Api$Provider$Reports$PatientPackage$patientId = function (_v0) {
	var record = _v0;
	return record.YY.ahP;
};
var $author$project$Api$Provider$Reports$PatientPackage$patientName = function (_v0) {
	var record = _v0;
	return record.YY.Bq;
};
var $author$project$Api$Provider$Reports$PatientPackage$purchasedOn = function (_v0) {
	var record = _v0;
	return record._L;
};
var $author$project$Api$Provider$Reports$PatientPackage$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Components$Reports$PatientPackages$statusBadgeOptions = function (status) {
	if (status === 'active') {
		return _List_fromArray(
			[$author$project$Ui$Badge$success]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Reports$PatientPackages$viewRow = F3(
	function (canGoToPatients, canGoToAdmin, patientPackage) {
		var status_ = $author$project$Api$Provider$Reports$PatientPackage$status(patientPackage);
		var purchasedOn_ = $author$project$Api$Provider$Reports$PatientPackage$purchasedOn(patientPackage);
		var patientName_ = $author$project$Api$Provider$Reports$PatientPackage$patientName(patientPackage);
		var patientId_ = $author$project$Api$Provider$Reports$PatientPackage$patientId(patientPackage);
		var packageName_ = A2(
			$elm$core$Maybe$withDefault,
			'',
			$author$project$Api$Provider$Reports$PatientPackage$packageName(patientPackage));
		var itemsRemaining_ = $author$project$Api$Provider$Reports$PatientPackage$itemsRemaining(patientPackage);
		var invoiceCell = function () {
			var _v0 = _Utils_Tuple2(
				canGoToPatients,
				$author$project$Api$Provider$Reports$PatientPackage$invoiceId(patientPackage));
			if (_v0.a && (!_v0.b.$)) {
				var invoiceId_ = _v0.b.a;
				return _List_fromArray(
					[
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top(
							{Us: invoiceId_, YZ: patientId_}),
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, purchasedOn_))
							]))
					]);
			} else {
				return _List_fromArray(
					[
						$elm$html$Html$text(
						A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, purchasedOn_))
					]);
			}
		}();
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					canGoToPatients ? _List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
								{YZ: patientId_}),
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[
											$author$project$Ui$Typography$phi(true)
										]),
									patientName_)
								]))
						]) : _List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[
									$author$project$Ui$Typography$phi(true)
								]),
							patientName_)
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					canGoToAdmin ? _List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Admin__ChargeItems__Top,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(packageName_)
								]))
						]) : _List_fromArray(
						[
							$elm$html$Html$text(packageName_)
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Badge$fromString,
							$author$project$Components$Reports$PatientPackages$statusBadgeOptions(status_),
							$author$project$Components$Reports$PatientPackages$humanizeStatus(status_))
						])),
					A2($author$project$Ui$Table$cell, _List_Nil, invoiceCell),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(itemsRemaining_))
						]))
				]));
	});
var $author$project$Components$Reports$PatientPackages$viewTable = function (model) {
	var _v0 = function () {
		var _v1 = model.Pw;
		if (_v1.$ === 3) {
			var patientPackages = _v1.a;
			return _Utils_Tuple2(false, patientPackages);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var rows = _v0.b;
	return A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('No data for the time period and filters selected. Try broadening your search to see more results.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$map,
					$author$project$Api$Column$view(
						A2($author$project$Api$Column$Sortable, model.alA, $author$project$Components$Reports$PatientPackages$SortTable)),
					model.N3),
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[$author$project$Ui$Table$textRight]),
						_List_fromArray(
							[
								A2($elm$html$Html$map, $author$project$Components$Reports$PatientPackages$ExportCsvMsg, $author$project$Components$ExportCsv$button)
							]))
					])
				])),
		A2(
			$elm$core$List$map,
			A2($author$project$Components$Reports$PatientPackages$viewRow, model.GQ, model.GO),
			rows),
		_List_Nil);
};
var $author$project$Components$Reports$PatientPackages$view = F2(
	function (apiClient, _v0) {
		var model = _v0;
		var totalCount = $author$project$Api$Data$totalCount(model.Pw);
		var reportParams = A2($elm$core$Basics$composeL, $author$project$Api$Provider$Reports$PatientPackage$listOptionsToParams, $author$project$Components$Reports$PatientPackages$fetchParams)(model);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Reports$PatientPackages$ExportCsvMsg,
				A3(
					$author$project$Components$ExportCsv$modal,
					apiClient,
					_List_fromArray(
						[
							$author$project$Components$ExportCsv$report(totalCount),
							$author$project$Components$ExportCsv$reportParams(reportParams)
						]),
					model.nD)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Package Sales')
									])),
								A2(
								$author$project$Ui$Grid$row,
								_List_fromArray(
									[$author$project$Ui$Grid$gutterSm, $author$project$Ui$Grid$mt2]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$spanSm(6)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Components$Reports$PatientPackages$DateRangeInputMsg,
												$author$project$Components$DateRangeInput$view(model.i4))
											])),
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$spanSm(3)
											]),
										_List_fromArray(
											[
												$author$project$Components$Reports$PatientPackages$viewStatusDropdown(model)
											])),
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$spanSm(3)
											]),
										_List_fromArray(
											[
												$author$project$Components$Reports$PatientPackages$viewPackageFilter(model.oP)
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Components$Reports$PatientPackages$viewTable(model)
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$Reports$PatientPackages$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(
											$author$project$Components$Reports$PatientPackages$isLoading(model.Pw))
										]),
									model.ajJ))
							]))
					]))
			]);
	});
var $author$project$Pages$Reports$PatientPackages$view = function (model) {
	return {
		fO: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			A2($author$project$Components$Reports$PatientPackages$view, model.Gv, model.kV)),
		ac9: 'Reports | Package Sales'
	};
};
var $author$project$Pages$Reports$PatientPackages$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Reports$PatientPackages$init, aiq: $author$project$Pages$Reports$PatientPackages$load, k8: $author$project$Pages$Reports$PatientPackages$save, alO: $author$project$Pages$Reports$PatientPackages$subscriptions, adT: $author$project$Pages$Reports$PatientPackages$update, amo: $author$project$Pages$Reports$PatientPackages$view});
var $author$project$Pages$Reports$PaymentApplications$ReportMsg = $elm$core$Basics$identity;
var $author$project$Components$Reports$PaymentApplications$Table = 0;
var $author$project$Components$Reports$PaymentApplications$ByDropdownMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Reports$PaymentApplications$CategoryResourceFilterMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Reports$PaymentApplications$DateFilterTypeDropdownMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Reports$PaymentApplications$DateRangeInputMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Reports$PaymentApplications$DepositDropdownMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Reports$PaymentApplications$FeeTypeDropdownMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Reports$PaymentApplications$GotDeposits = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Reports$PaymentApplications$GroupLocationAndPractitionerFiltersMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Report$PaymentApplicationLine = 9;
var $author$project$Components$Reports$PaymentApplications$PaymentProcessorDropdownMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Reports$PaymentApplications$Transaction = 0;
var $author$project$Components$Reports$PaymentApplications$TransactionTypeDropdownMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Reports$PaymentApplications$ByCategory = 0;
var $author$project$Components$Reports$PaymentApplications$ByLocation = 2;
var $author$project$Components$Reports$PaymentApplications$ByPractitioner = 1;
var $author$project$Components$Reports$PaymentApplications$ByTransactionType = 3;
var $author$project$Components$Reports$PaymentApplications$byOptionFromString = function (str) {
	switch (str) {
		case 'category':
			return $elm$core$Maybe$Just(0);
		case 'practitioner':
			return $elm$core$Maybe$Just(1);
		case 'location':
			return $elm$core$Maybe$Just(2);
		case 'transaction_type':
			return $elm$core$Maybe$Just(3);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Reports$PaymentApplications$dateRangeInputSettings = F2(
	function (start, end) {
		var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
		return _Utils_update(
			defaultSettings,
			{ahy: start, al5: end});
	});
var $author$project$Components$Reports$PaymentApplications$AmericanExpress = 2;
var $author$project$Components$Reports$PaymentApplications$BankTransfer = 0;
var $author$project$Components$Reports$PaymentApplications$Card = 1;
var $author$project$Components$Reports$PaymentApplications$CashCheck = 4;
var $author$project$Components$Reports$PaymentApplications$NoFee = 3;
var $author$project$Components$Reports$PaymentApplications$feeTypeFromString = function (str) {
	switch (str) {
		case 'Bank Transfer':
			return $elm$core$Maybe$Just(0);
		case 'Card':
			return $elm$core$Maybe$Just(1);
		case 'American Express':
			return $elm$core$Maybe$Just(2);
		case 'No Fee':
			return $elm$core$Maybe$Just(3);
		case 'Cash/Check':
			return $elm$core$Maybe$Just(4);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Reports$PaymentApplications$GotPaymentApplications = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Reports$PaymentApplications$dateFilterTypeToString = function (dateFilterType) {
	if (!dateFilterType) {
		return 'transaction';
	} else {
		return 'deposit';
	}
};
var $author$project$Components$Reports$PaymentApplications$feeTypeToValue = function (feeType) {
	switch (feeType) {
		case 0:
			return 'Bank Transfer';
		case 1:
			return 'Card';
		case 2:
			return 'American Express';
		case 3:
			return 'No Fee';
		default:
			return 'Cash/Check';
	}
};
var $author$project$Components$Reports$PaymentApplications$transactionTypeToValue = function (transactionType) {
	switch (transactionType) {
		case 0:
			return 'all';
		case 1:
			return 'payments';
		default:
			return 'refunds';
	}
};
var $author$project$Components$Reports$PaymentApplications$fetchPaymentApplicationsParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				GW: model.iF,
				Hh: $elm$core$Maybe$Just(
					$author$project$Components$Reports$PaymentApplications$dateFilterTypeToString(model.Hh)),
				Hq: model.agt,
				HB: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.HB),
				Sj: A2($elm$core$Maybe$map, $author$project$Components$Reports$PaymentApplications$feeTypeToValue, model.Sj),
				ais: model.We,
				s4: model.gL,
				ajJ: model.ajJ,
				Zd: model.Zd,
				aka: model.Z2,
				alA: model.alA,
				JV: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.JV),
				Kb: A2($elm$core$Maybe$map, $author$project$Components$Reports$PaymentApplications$transactionTypeToValue, model.Kb)
			});
	};
};
var $author$project$Api$Provider$Reports$PaymentApplication$PaymentApplication = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$PaymentApplication$Record = function (transactionDate) {
	return function (amountInCents) {
		return function (hintFeeInCents) {
			return function (stripeFeeInCents) {
				return function (totalFeeInCents) {
					return function (charge) {
						return function (deposit) {
							return function (receipt) {
								return function (patient) {
									return function (category) {
										return function (invoice) {
											return function (practitioner) {
												return function (location) {
													return {LE: amountInCents, GW: category, afx: charge, Hq: deposit, Ty: hintFeeInCents, Uk: invoice, ais: location, YY: patient, aka: practitioner, $a: receipt, aco: stripeFeeInCents, adn: totalFeeInCents, adw: transactionDate};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Deposit$Shared$Deposit = $elm$core$Basics$identity;
var $author$project$Api$Provider$Deposit$Shared$Record = F4(
	function (id, availableOn, amountInCents, status) {
		return {LE: amountInCents, Mp: availableOn, ahP: id, alH: status};
	});
var $author$project$Api$Provider$Deposit$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'status',
	A2($elm$json$Json$Decode$andThen, $author$project$Api$Provider$Reports$Deposit$decodeStatus, $elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'amount_in_cents',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'available_on',
			$author$project$Utils$Date$decode,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$Deposit$Shared$Record)))));
var $author$project$Api$Provider$Deposit$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Deposit$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Receipt$Shared$Receipt = $elm$core$Basics$identity;
var $author$project$Api$Provider$Receipt$Shared$Record = F4(
	function (objectType, feeType, expectedDepositDate, paymentProcessor) {
		return {RU: expectedDepositDate, Sj: feeType, X7: objectType, Zd: paymentProcessor};
	});
var $author$project$Api$Provider$Receipt$Shared$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'payment_processor',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'expected_deposit_date',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'fee_type',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'object_type',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$Receipt$Shared$Record)))));
var $author$project$Api$Provider$Receipt$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Receipt$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$PaymentApplication$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'location',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Location$Min$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'practitioner',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Practitioner$Min$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'invoice',
			$elm$json$Json$Decode$nullable($author$project$Api$Common$Payable$Invoice$MinWithOwner$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'category',
				$elm$json$Json$Decode$nullable($author$project$Api$Provider$Category$Min$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'patient',
					$elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Min$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'receipt',
						$elm$json$Json$Decode$nullable($author$project$Api$Provider$Receipt$Shared$decoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'deposit',
							$elm$json$Json$Decode$nullable($author$project$Api$Provider$Deposit$Shared$decoder),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'charge',
								$elm$json$Json$Decode$nullable($author$project$Api$Provider$Reports$Charge$decoder),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'total_fee_in_cents',
									$elm$json$Json$Decode$int,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'stripe_fee_in_cents',
										$elm$json$Json$Decode$int,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'hint_fee_in_cents',
											$elm$json$Json$Decode$int,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'amount_in_cents',
												$elm$json$Json$Decode$int,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'transaction_date',
													$author$project$Utils$Date$decode,
													$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$PaymentApplication$Record))))))))))))));
var $author$project$Api$Provider$Reports$PaymentApplication$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Reports$PaymentApplication$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$PaymentApplication$listDefaults = {GW: $elm$core$Maybe$Nothing, Hh: $elm$core$Maybe$Nothing, Hq: $elm$core$Maybe$Nothing, HB: $elm$core$Maybe$Nothing, Sj: $elm$core$Maybe$Nothing, ais: $elm$core$Maybe$Nothing, s4: $elm$core$Maybe$Nothing, ajJ: $author$project$Api$Pagination$init, Zd: $elm$core$Maybe$Nothing, aka: $elm$core$Maybe$Nothing, alA: $author$project$Api$Sort$init, JV: $elm$core$Maybe$Nothing, Kb: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$Reports$PaymentApplication$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Reports$PaymentApplication$listDefaults);
	return A2(
		$elm$core$List$append,
		$author$project$Api$Pagination$toApiParams(options.ajJ),
		A2(
			$elm$core$List$append,
			$author$project$Api$Sort$toParams(options.alA),
			$elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						var _v0 = options.Hh;
						if (!_v0.$) {
							var string = _v0.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'date_filter_type', string)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v1 = options.JV;
						if (!_v1.$) {
							var start_ = _v1.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'start', start_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v2 = options.HB;
						if (!_v2.$) {
							var end_ = _v2.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'end', end_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v3 = options.GW;
						if (!_v3.$) {
							var category_ = _v3.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'category', category_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v4 = options.s4;
						if (!_v4.$) {
							var locationGroup_ = _v4.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'location_group', locationGroup_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v5 = options.ais;
						if (!_v5.$) {
							var location_ = _v5.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'location', location_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v6 = options.aka;
						if (!_v6.$) {
							var practitioner_ = _v6.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'practitioner', practitioner_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v7 = options.Hq;
						if (!_v7.$) {
							var string = _v7.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'deposit', string)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v8 = options.Sj;
						if ((!_v8.$) && (_v8.a === 'Cash/Check')) {
							return _List_fromArray(
								[
									A2(
									$author$project$Api$Param$string,
									'payment',
									A2(
										$elm$json$Json$Encode$encode,
										0,
										$elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'external_type',
													A2(
														$elm$json$Json$Encode$list,
														$elm$json$Json$Encode$string,
														_List_fromArray(
															['cash', 'check', 'other'])))
												]))))
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var receiptFields = A2(
							$elm$core$List$filterMap,
							$elm$core$Basics$identity,
							_List_fromArray(
								[
									function () {
									var _v9 = options.Sj;
									if (!_v9.$) {
										if (_v9.a === 'Cash/Check') {
											return $elm$core$Maybe$Nothing;
										} else {
											var string = _v9.a;
											return $elm$core$Maybe$Just(
												_Utils_Tuple2(
													'fee_type',
													$elm$json$Json$Encode$string(string)));
										}
									} else {
										return $elm$core$Maybe$Nothing;
									}
								}(),
									A2(
									$elm$core$Maybe$map,
									function (pp) {
										return _Utils_Tuple2(
											'payment_processor',
											$elm$json$Json$Encode$string(pp));
									},
									options.Zd)
								]));
						return $elm$core$List$isEmpty(receiptFields) ? _List_Nil : _List_fromArray(
							[
								A2(
								$author$project$Api$Param$string,
								'receipt',
								A2(
									$elm$json$Json$Encode$encode,
									0,
									$elm$json$Json$Encode$object(receiptFields)))
							]);
					}(),
						function () {
						var _v10 = options.Kb;
						if (!_v10.$) {
							var string = _v10.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'transaction_type', string)
								]);
						} else {
							return _List_Nil;
						}
					}()
					]))));
};
var $author$project$Api$Provider$Reports$PaymentApplication$listPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['reports', 'payment_applications']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Reports$PaymentApplication$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Reports$PaymentApplication$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Reports$PaymentApplication$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$PaymentApplication$listPath)));
	});
var $author$project$Components$Reports$PaymentApplications$fetchPaymentApplications = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Api$Provider$Reports$PaymentApplication$list,
			apiClient,
			$author$project$Components$Reports$PaymentApplications$fetchPaymentApplicationsParams(model),
			$author$project$Components$Reports$PaymentApplications$GotPaymentApplications);
	});
var $author$project$Components$Reports$PaymentApplications$GotSummary = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Reports$PaymentApplications$byOptionToValue = function (byOption) {
	switch (byOption) {
		case 0:
			return 'category';
		case 1:
			return 'practitioner';
		case 2:
			return 'location';
		default:
			return 'transaction_type';
	}
};
var $author$project$Components$Reports$PaymentApplications$fetchSummaryParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				GW: model.iF,
				Hh: $elm$core$Maybe$Just(
					$author$project$Components$Reports$PaymentApplications$dateFilterTypeToString(model.Hh)),
				Hq: model.agt,
				HB: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.HB),
				Sj: A2($elm$core$Maybe$map, $author$project$Components$Reports$PaymentApplications$feeTypeToValue, model.Sj),
				ais: model.We,
				s4: model.gL,
				Zd: model.Zd,
				aka: model.Z2,
				JV: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.JV),
				Kb: A2($elm$core$Maybe$map, $author$project$Components$Reports$PaymentApplications$transactionTypeToValue, model.Kb)
			});
	};
};
var $author$project$Api$Provider$Reports$PaymentApplication$summary = F4(
	function (apiClient, by, optionals, toMsg) {
		return A5(
			$author$project$Api$Provider$Reports$Summary$retrieve,
			apiClient,
			$author$project$Api$Provider$Reports$PaymentApplication$listPath,
			by,
			$author$project$Api$Provider$Reports$PaymentApplication$listOptionsToParams(optionals),
			toMsg);
	});
var $author$project$Components$Reports$PaymentApplications$fetchSummary = F2(
	function (apiClient, model) {
		return A4(
			$author$project$Api$Provider$Reports$PaymentApplication$summary,
			apiClient,
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Maybe$map, $author$project$Components$Reports$PaymentApplications$byOptionToValue, model.co)),
			$author$project$Components$Reports$PaymentApplications$fetchSummaryParams(model),
			$author$project$Components$Reports$PaymentApplications$GotSummary);
	});
var $author$project$Components$Reports$PaymentApplications$fetchData = F2(
	function (apiClient, model) {
		var _v0 = model.amg;
		if (!_v0) {
			return A2($author$project$Components$Reports$PaymentApplications$fetchPaymentApplications, apiClient, model);
		} else {
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Components$Reports$PaymentApplications$fetchSummary, apiClient, model),
						A2($author$project$Components$Reports$PaymentApplications$fetchPaymentApplications, apiClient, model)
					]));
		}
	});
var $author$project$Components$Reports$PaymentApplications$fetchDepositsParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				HB: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.HB),
				alA: A3($author$project$Api$Sort$withDefault, 'available_on', 1, $author$project$Api$Sort$init),
				JV: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.JV)
			});
	};
};
var $author$project$Components$Reports$PaymentApplications$initColumns = function (trackPatientsByLocation) {
	return A2(
		$elm$core$List$cons,
		A3($author$project$Api$Column$init, 'transaction_date', true, 'Txn Date'),
		A2(
			$elm$core$List$cons,
			A3($author$project$Api$Column$init, 'payment', false, 'Payment'),
			A2(
				$elm$core$List$cons,
				A3($author$project$Api$Column$init, 'amount_in_cents', true, 'Charge'),
				A2(
					$elm$core$List$cons,
					A3($author$project$Api$Column$init, 'invoice', false, 'Invoice'),
					A2(
						$elm$core$List$cons,
						A3($author$project$Api$Column$init, 'patient', true, 'Patient'),
						A2(
							$elm$core$List$cons,
							A3($author$project$Api$Column$init, 'category', true, 'Category'),
							A2(
								$elm$core$List$cons,
								A3($author$project$Api$Column$init, 'practitioner', true, 'Provider'),
								_Utils_ap(
									trackPatientsByLocation ? _List_fromArray(
										[
											A3($author$project$Api$Column$init, 'location', true, 'Location')
										]) : _List_Nil,
									_List_fromArray(
										[
											A3($author$project$Api$Column$init, 'payment_processor', false, 'Processor')
										])))))))));
};
var $author$project$Api$Provider$Deposit$All$Deposit = $elm$core$Basics$identity;
var $author$project$Api$Provider$Deposit$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Deposit$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Deposit$depositsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['deposits']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Deposit$listDefaults = {
	HB: $elm$core$Maybe$Nothing,
	ajJ: $author$project$Api$Pagination$init,
	alA: A3($author$project$Api$Sort$withDefault, 'available_on', 1, $author$project$Api$Sort$init),
	JV: $elm$core$Maybe$Nothing
};
var $author$project$Api$Provider$Deposit$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Deposit$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = _Utils_Tuple2(options.JV, options.HB);
				if ((_v0.a.$ === 1) && (_v0.b.$ === 1)) {
					var _v1 = _v0.a;
					var _v2 = _v0.b;
					return _List_Nil;
				} else {
					var dates = A2(
						$elm$json$Json$Encode$encode,
						0,
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'gte',
									A2(
										$author$project$Utils$Encode$nullable,
										A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$Utils$Date$toQuery),
										options.JV)),
									_Utils_Tuple2(
									'lte',
									A2(
										$author$project$Utils$Encode$nullable,
										A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$Utils$Date$toQuery),
										options.HB))
								])));
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'transaction_date', dates)
						]);
				}
			}(),
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$Provider$Deposit$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Deposit$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Deposit$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Deposit$depositsPath)));
	});
var $author$project$Components$Reports$PaymentApplications$Deposit = 1;
var $author$project$Components$Reports$PaymentApplications$stringToDateFilterType = function (str) {
	switch (str) {
		case 'transaction':
			return $elm$core$Maybe$Just(0);
		case 'deposit':
			return $elm$core$Maybe$Just(1);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Reports$PaymentApplications$AllTransactions = 0;
var $author$project$Components$Reports$PaymentApplications$Payments = 1;
var $author$project$Components$Reports$PaymentApplications$Refunds = 2;
var $author$project$Components$Reports$PaymentApplications$transactionTypeFromString = function (str) {
	switch (str) {
		case 'all':
			return $elm$core$Maybe$Just(0);
		case 'payments':
			return $elm$core$Maybe$Just(1);
		case 'refunds':
			return $elm$core$Maybe$Just(2);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Reports$PaymentApplications$urlParams = function (model) {
	var queryParams = _List_fromArray(
		[
			$elm$core$Maybe$Just(
			_Utils_Tuple2(
				'date_filter_type',
				$author$project$Components$Reports$PaymentApplications$dateFilterTypeToString(model.Hh))),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Tuple$pair('start'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.dd, 0)),
			model.JV),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Tuple$pair('end'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.dd, 0)),
			model.HB),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('category'),
			model.iF),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('deposit'),
			model.agt),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('location_group'),
			model.gL),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('location'),
			model.We),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('practitioner'),
			model.Z2),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Tuple$pair('fee_type'),
				$author$project$Components$Reports$PaymentApplications$feeTypeToValue),
			model.Sj),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('payment_processor'),
			model.Zd),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Tuple$pair('by'),
				$author$project$Components$Reports$PaymentApplications$byOptionToValue),
			model.co),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Tuple$pair('transaction_type'),
				$author$project$Components$Reports$PaymentApplications$transactionTypeToValue),
			model.Kb)
		]);
	return $elm$core$Dict$fromList(
		A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams));
};
var $author$project$Components$Reports$PaymentApplications$updateUrl = function (model) {
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					function () {
					var _v0 = model.co;
					if (!_v0.$) {
						return $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__PaymentApplications__Summary);
					} else {
						return $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__PaymentApplications);
					}
				}()
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.ajJ),
				A2(
					$elm$core$List$append,
					$author$project$Api$Sort$toQuery(model.alA),
					$author$project$Utils$QueryParameter$fromDict(
						$author$project$Components$Reports$PaymentApplications$urlParams(model))))));
};
var $author$project$Components$Reports$PaymentApplications$init = F5(
	function (type_, session, practice, shared, query) {
		var trackPatientsByLocation = $author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice);
		var practitionerId = A2($elm$core$Dict$get, 'practitioner', query);
		var locationId = A2($elm$core$Dict$get, 'location', query);
		var locationGroupId = A2($elm$core$Dict$get, 'location_group', query);
		var feePlanType = $author$project$Api$Provider$Practice$One$feePlanType(practice);
		var categoryId = A2($elm$core$Dict$get, 'category', query);
		var _v0 = function () {
			if (!type_) {
				return _Utils_Tuple2($author$project$Api$Data$Loading, $author$project$Api$Data$NotAsked);
			} else {
				return _Utils_Tuple2($author$project$Api$Data$NotAsked, $author$project$Api$Data$Loading);
			}
		}();
		var paymentApplications = _v0.a;
		var summary = _v0.b;
		var _v2 = shared;
		var currentDate = _v2.dd;
		var apiClient = _v2.Gv;
		var hinterViewOff = _v2.ahK;
		var _v3 = A7($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$init, apiClient, session, practice, false, locationGroupId, locationId, practitionerId);
		var groupLocationAndPractitionerFilters = _v3.a;
		var groupLocationAndPractitionerFiltersCmd = _v3.b;
		var _v4 = $author$project$Utils$DateWithDefault$fromQuery(query);
		var start = _v4.a;
		var end = _v4.b;
		var _v5 = A2(
			$author$project$Components$DateRangeInput$init,
			'date-range-input',
			A2(
				$author$project$Components$Reports$PaymentApplications$dateRangeInputSettings,
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					start),
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					end)));
		var dateRangeInput = _v5.a;
		var dateRangeInputCmd = _v5.b;
		var _v6 = A3($author$project$Utils$Report$CategoryResourceFilter$init, apiClient, session, categoryId);
		var categoryResourceFilter = _v6.a;
		var categoryResourceFilterCmd = _v6.b;
		var model = {
			co: A2(
				$elm$core$Maybe$andThen,
				$author$project$Components$Reports$PaymentApplications$byOptionFromString,
				A2($elm$core$Dict$get, 'by', query)),
			mB: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'by-dropdown', al6: $author$project$Components$Reports$PaymentApplications$ByDropdownMsg})),
			GQ: A3($author$project$Permission$canGoTo, session, hinterViewOff, 50),
			iF: categoryId,
			c8: categoryResourceFilter,
			N3: $author$project$Components$Reports$PaymentApplications$initColumns(trackPatientsByLocation),
			dd: currentDate,
			Hh: A2(
				$elm$core$Maybe$withDefault,
				0,
				A2(
					$elm$core$Maybe$andThen,
					$author$project$Components$Reports$PaymentApplications$stringToDateFilterType,
					A2($elm$core$Dict$get, 'date_filter_type', query))),
			m9: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'date-filter-type-dropdown-filter', al6: $author$project$Components$Reports$PaymentApplications$DateFilterTypeDropdownMsg})),
			i4: dateRangeInput,
			nh: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'deposit-dropdown', al6: $author$project$Components$Reports$PaymentApplications$DepositDropdownMsg})),
			agt: A2($elm$core$Dict$get, 'deposit', query),
			cC: $author$project$Api$Data$Loading,
			HB: end,
			nD: $author$project$Components$ExportCsv$initForPractice(9),
			Si: feePlanType,
			Sj: A2(
				$elm$core$Maybe$andThen,
				$author$project$Components$Reports$PaymentApplications$feeTypeFromString,
				A2($elm$core$Dict$get, 'fee_type', query)),
			nJ: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'fee-type-dropdown', al6: $author$project$Components$Reports$PaymentApplications$FeeTypeDropdownMsg})),
			dn: groupLocationAndPractitionerFilters,
			Ij: $author$project$Shared$isHintAdmin(shared),
			gL: locationGroupId,
			We: locationId,
			ajJ: $author$project$Api$Pagination$initFromQuery(query),
			G: paymentApplications,
			Zd: A2($elm$core$Dict$get, 'payment_processor', query),
			o3: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'payment-processor-dropdown', al6: $author$project$Components$Reports$PaymentApplications$PaymentProcessorDropdownMsg})),
			Z2: practitionerId,
			alA: A3(
				$author$project$Api$Sort$withDefault,
				'transaction_date',
				1,
				$author$project$Api$Sort$initFromQuery(query)),
			JV: start,
			acF: summary,
			adt: trackPatientsByLocation,
			Kb: A2(
				$elm$core$Maybe$andThen,
				$author$project$Components$Reports$PaymentApplications$transactionTypeFromString,
				A2($elm$core$Dict$get, 'transaction_type', query)),
			qE: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'transaction-type-dropdown', al6: $author$project$Components$Reports$PaymentApplications$TransactionTypeDropdownMsg})),
			amg: type_
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PaymentApplications$CategoryResourceFilterMsg, categoryResourceFilterCmd),
						A3(
						$author$project$Api$Provider$Deposit$list,
						apiClient,
						$author$project$Components$Reports$PaymentApplications$fetchDepositsParams(model),
						$author$project$Components$Reports$PaymentApplications$GotDeposits),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PaymentApplications$DateRangeInputMsg, dateRangeInputCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PaymentApplications$GroupLocationAndPractitionerFiltersMsg, groupLocationAndPractitionerFiltersCmd),
						A2($author$project$Components$Reports$PaymentApplications$fetchData, apiClient, model),
						$author$project$Components$Reports$PaymentApplications$updateUrl(model)
					])));
	});
var $author$project$Pages$Reports$PaymentApplications$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.DE;
		var _v1 = A5($author$project$Components$Reports$PaymentApplications$init, 0, session, practice, shared, query);
		var report = _v1.a;
		var reportTaxCmd = _v1.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, kV: report},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportTaxCmd));
	});
var $author$project$Pages$Reports$PaymentApplications$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$PaymentApplications$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Reports$PaymentApplications$ExportCsvMsg = function (a) {
	return {$: 20, a: a};
};
var $author$project$Components$Reports$PaymentApplications$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$PaymentApplications$DateRangeInputMsg,
				$author$project$Components$DateRangeInput$subscriptions(model.i4)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$PaymentApplications$ExportCsvMsg,
				$author$project$Components$ExportCsv$subscriptions(model.nD)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$PaymentApplications$GroupLocationAndPractitionerFiltersMsg,
				$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$subscriptions(model.dn)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$PaymentApplications$CategoryResourceFilterMsg,
				$author$project$Components$ResourceFilter$Category$subscriptions(model.c8)),
				$author$project$Ui$Dropdown$subscriptions(model.mB),
				$author$project$Ui$Dropdown$subscriptions(model.nh),
				$author$project$Ui$Dropdown$subscriptions(model.nJ),
				$author$project$Ui$Dropdown$subscriptions(model.o3),
				$author$project$Ui$Dropdown$subscriptions(model.m9),
				$author$project$Ui$Dropdown$subscriptions(model.qE)
			]));
};
var $author$project$Pages$Reports$PaymentApplications$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Reports$PaymentApplications$subscriptions(model.kV));
};
var $author$project$Components$Reports$PaymentApplications$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Ui$Dropdown$update, subMsg, model.m9);
				var dateFilterTypeDropdown = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{m9: dateFilterTypeDropdown}),
					cmd,
					_List_Nil);
			case 1:
				var dateFilterType = msg.a;
				var newModel = _Utils_update(
					model,
					{
						Hh: dateFilterType,
						ajJ: $author$project$Api$Pagination$reset(model.ajJ),
						G: $author$project$Api$Data$Loading
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$PaymentApplications$fetchData, apiClient, newModel),
								$author$project$Components$Reports$PaymentApplications$updateUrl(newModel)
							])),
					_List_Nil);
			case 4:
				var subMsg = msg.a;
				var categoryResourceResult = A3($author$project$Components$ResourceFilter$Category$update, apiClient, subMsg, model.c8);
				var categoryId = function () {
					var _v3 = categoryResourceResult.agZ;
					if (!_v3.$) {
						return $author$project$Components$ResourceFilter$Category$value(categoryResourceResult.aiO);
					} else {
						return model.iF;
					}
				}();
				var newModel = _Utils_update(
					model,
					{iF: categoryId, c8: categoryResourceResult.aiO});
				var _v2 = _Utils_eq(model.iF, newModel.iF) ? _Utils_Tuple2(model.G, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					$author$project$Api$Data$Loading,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$PaymentApplications$fetchData, apiClient, newModel),
								$author$project$Components$Reports$PaymentApplications$updateUrl(newModel)
							])));
				var paymentApplications = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{G: paymentApplications}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PaymentApplications$CategoryResourceFilterMsg, categoryResourceResult.GZ),
								cmd
							])),
					categoryResourceResult.aR);
			case 5:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cC: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 6:
				var subMsg = msg.a;
				var _v4 = A2($author$project$Ui$Dropdown$update, subMsg, model.nh);
				var depositDropdown = _v4.a;
				var cmd = _v4.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nh: depositDropdown}),
					cmd,
					_List_Nil);
			case 7:
				var depositId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						agt: depositId,
						ajJ: $author$project$Api$Pagination$reset(model.ajJ),
						G: $author$project$Api$Data$Loading
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$PaymentApplications$fetchData, apiClient, newModel),
								$author$project$Components$Reports$PaymentApplications$updateUrl(newModel)
							])),
					_List_Nil);
			case 8:
				var subMsg = msg.a;
				var _v5 = A2($author$project$Ui$Dropdown$update, subMsg, model.nJ);
				var feeTypeDropdown = _v5.a;
				var cmd = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nJ: feeTypeDropdown}),
					cmd,
					_List_Nil);
			case 9:
				var feeType = msg.a;
				var newModel = _Utils_update(
					model,
					{
						Sj: feeType,
						ajJ: $author$project$Api$Pagination$reset(model.ajJ),
						G: $author$project$Api$Data$Loading
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$PaymentApplications$fetchData, apiClient, newModel),
								$author$project$Components$Reports$PaymentApplications$updateUrl(newModel)
							])),
					_List_Nil);
			case 10:
				var subMsg = msg.a;
				var _v6 = A2($author$project$Ui$Dropdown$update, subMsg, model.o3);
				var paymentProcessorDropdown = _v6.a;
				var cmd = _v6.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{o3: paymentProcessorDropdown}),
					cmd,
					_List_Nil);
			case 11:
				var paymentProcessor = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ajJ: $author$project$Api$Pagination$reset(model.ajJ),
						G: $author$project$Api$Data$Loading,
						Zd: paymentProcessor
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$PaymentApplications$fetchData, apiClient, newModel),
								$author$project$Components$Reports$PaymentApplications$updateUrl(newModel)
							])),
					_List_Nil);
			case 12:
				var subMsg = msg.a;
				var _v7 = A2($author$project$Ui$Dropdown$update, subMsg, model.mB);
				var byDropdown = _v7.a;
				var cmd = _v7.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{mB: byDropdown}),
					cmd,
					_List_Nil);
			case 13:
				var by = msg.a;
				var newModel = _Utils_update(
					model,
					{
						co: by,
						ajJ: $author$project$Api$Pagination$reset(model.ajJ),
						G: $author$project$Api$Data$Loading
					});
				var cmds = function () {
					var _v8 = _Utils_Tuple2(model.amg, newModel.co);
					if (!_v8.a) {
						if (!_v8.b.$) {
							var _v9 = _v8.a;
							return _List_fromArray(
								[
									$author$project$Components$Reports$PaymentApplications$updateUrl(newModel)
								]);
						} else {
							var _v10 = _v8.a;
							var _v11 = _v8.b;
							return _List_fromArray(
								[$elm$core$Platform$Cmd$none]);
						}
					} else {
						if (_v8.b.$ === 1) {
							var _v12 = _v8.a;
							var _v13 = _v8.b;
							return _List_fromArray(
								[
									$author$project$Components$Reports$PaymentApplications$updateUrl(newModel)
								]);
						} else {
							var _v14 = _v8.a;
							return _List_fromArray(
								[
									A2($author$project$Components$Reports$PaymentApplications$fetchData, apiClient, newModel),
									$author$project$Components$Reports$PaymentApplications$updateUrl(newModel)
								]);
						}
					}
				}();
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(cmds),
					_List_Nil);
			case 14:
				var subMsg = msg.a;
				var _v15 = A2($author$project$Ui$Dropdown$update, subMsg, model.qE);
				var transactionTypeDropdown = _v15.a;
				var cmd = _v15.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qE: transactionTypeDropdown}),
					cmd,
					_List_Nil);
			case 15:
				var transactionType = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ajJ: $author$project$Api$Pagination$reset(model.ajJ),
						G: $author$project$Api$Data$Loading,
						Kb: transactionType
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$PaymentApplications$fetchData, apiClient, newModel),
								$author$project$Components$Reports$PaymentApplications$updateUrl(newModel)
							])),
					_List_Nil);
			case 2:
				var subMsg = msg.a;
				var _v16 = A2($author$project$Components$DateRangeInput$update, subMsg, model.i4);
				var dateRangeInput = _v16.a;
				var subCmd = _v16.b;
				var event = _v16.c;
				var newModel = function () {
					if (event.$ === 1) {
						var fromDate = event.a;
						var toDate = event.b;
						return _Utils_update(
							model,
							{
								i4: dateRangeInput,
								HB: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
								ajJ: $author$project$Api$Pagination$reset(model.ajJ),
								G: $author$project$Api$Data$Loading,
								JV: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
							});
					} else {
						return _Utils_update(
							model,
							{i4: dateRangeInput});
					}
				}();
				var cmds = (_Utils_eq(newModel.JV, model.JV) && _Utils_eq(newModel.HB, model.HB)) ? _List_Nil : _List_fromArray(
					[
						A2($author$project$Components$Reports$PaymentApplications$fetchData, apiClient, newModel),
						$author$project$Components$Reports$PaymentApplications$updateUrl(newModel)
					]);
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$cons,
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PaymentApplications$DateRangeInputMsg, subCmd),
							cmds)),
					_List_Nil);
			case 3:
				var subMsg = msg.a;
				var result = A3($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$update, apiClient, subMsg, model.dn);
				var _v18 = result.agZ;
				if (!_v18.$) {
					var locationGroupId = _v18.a;
					var locationId = _v18.b;
					var practitionerId = _v18.c;
					var newModel = _Utils_update(
						model,
						{
							dn: result.aiO,
							gL: locationGroupId,
							We: locationId,
							ajJ: $author$project$Api$Pagination$reset(model.ajJ),
							G: $author$project$Api$Data$Loading,
							Z2: practitionerId
						});
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PaymentApplications$GroupLocationAndPractitionerFiltersMsg, result.GZ),
									A2($author$project$Components$Reports$PaymentApplications$fetchData, apiClient, newModel),
									$author$project$Components$Reports$PaymentApplications$updateUrl(newModel)
								])),
						result.aR);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dn: result.aiO}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PaymentApplications$GroupLocationAndPractitionerFiltersMsg, result.GZ),
						result.aR);
				}
			case 16:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ),
								G: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{G: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 17:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{acF: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 18:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{ajJ: pagination, G: $author$project$Api$Data$Loading});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$PaymentApplications$fetchData, apiClient, newModel),
								$author$project$Components$Reports$PaymentApplications$updateUrl(newModel)
							])),
					_List_Nil);
			case 19:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						alA: A2($author$project$Api$Sort$update, columnId, model.alA)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$PaymentApplications$fetchData, apiClient, newModel),
								$author$project$Components$Reports$PaymentApplications$updateUrl(newModel)
							])),
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v20 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.nD);
				var exportCsv = _v20.a;
				var subCmd = _v20.b;
				var subOutMsg = _v20.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nD: exportCsv}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PaymentApplications$ExportCsvMsg, subCmd),
					subOutMsg);
		}
	});
var $author$project$Pages$Reports$PaymentApplications$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Reports$PaymentApplications$update, model.Gv, subMsg, model.kV);
		var report = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{kV: report}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Components$Reports$PaymentApplications$PaginationMsg = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$Reports$PaymentApplications$amountFromHeader = F2(
	function (headers, name) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$String$toInt,
				A2($elm$core$Dict$get, name, headers)));
	});
var $author$project$Components$Reports$PaymentApplications$creditTransactionsReportParams = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('start'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.dd, 0)),
			model.JV),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('end'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.dd, 0)),
			model.HB),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('practitioner'),
			model.Z2)
		]);
	return A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams);
};
var $author$project$Components$Reports$PaymentApplications$BySelected = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Reports$PaymentApplications$byOptionToLabel = function (byOption) {
	switch (byOption) {
		case 0:
			return 'Category';
		case 1:
			return 'Provider';
		case 2:
			return 'Location';
		default:
			return 'Transaction Type';
	}
};
var $author$project$Components$Reports$PaymentApplications$byDropdownItems = F2(
	function (trackPatientsByLocation, currentBy) {
		var baseOptions = _List_fromArray(
			[0, 1, 3]);
		var allOptions = trackPatientsByLocation ? _Utils_ap(
			baseOptions,
			_List_fromArray(
				[2])) : baseOptions;
		return A2(
			$elm$core$List$cons,
			A2(
				$author$project$Ui$Dropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$Dropdown$onSelect(
						$author$project$Components$Reports$PaymentApplications$BySelected($elm$core$Maybe$Nothing)),
						$author$project$Ui$Dropdown$selected(
						_Utils_eq(currentBy, $elm$core$Maybe$Nothing))
					]),
				$elm$html$Html$text('No Summary')),
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Dropdown$separator,
				A2(
					$elm$core$List$map,
					function (byOption) {
						return A2(
							$author$project$Ui$Dropdown$item,
							_List_fromArray(
								[
									$author$project$Ui$Dropdown$onSelect(
									$author$project$Components$Reports$PaymentApplications$BySelected(
										$elm$core$Maybe$Just(byOption))),
									$author$project$Ui$Dropdown$selected(
									_Utils_eq(
										currentBy,
										$elm$core$Maybe$Just(byOption)))
								]),
							$elm$html$Html$text(
								$author$project$Components$Reports$PaymentApplications$byOptionToLabel(byOption)));
					},
					allOptions)));
	});
var $author$project$Components$Reports$PaymentApplications$viewByDropdown = function (model) {
	var placeholder = function () {
		var _v0 = model.co;
		if (!_v0.$) {
			var by = _v0.a;
			return $author$project$Components$Reports$PaymentApplications$byOptionToLabel(by);
		} else {
			return 'Summarize By';
		}
	}();
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(placeholder)
			]),
		A2($author$project$Components$Reports$PaymentApplications$byDropdownItems, model.adt, model.co),
		model.mB);
};
var $author$project$Components$Reports$PaymentApplications$viewCategoryResourceFilter = function (categoryResourceFilter) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Reports$PaymentApplications$CategoryResourceFilterMsg,
		A2(
			$author$project$Components$ResourceFilter$Category$view,
			_List_fromArray(
				[
					$author$project$Components$ResourceFilter$style(1),
					$author$project$Components$ResourceFilter$multi
				]),
			categoryResourceFilter));
};
var $author$project$Components$Reports$PaymentApplications$DateFilterTypeSelected = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Reports$PaymentApplications$dateFilterTypeToLabel = function (dateFilterType) {
	if (!dateFilterType) {
		return 'Transacted';
	} else {
		return 'Deposited';
	}
};
var $author$project$Components$Reports$PaymentApplications$viewDateFilterTypeDropdown = function (model) {
	var currentLabel = $author$project$Components$Reports$PaymentApplications$dateFilterTypeToLabel(model.Hh);
	var allTypes = _List_fromArray(
		[0, 1]);
	var items = A2(
		$elm$core$List$map,
		function (dateFilterType) {
			return A2(
				$author$project$Ui$Dropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$Dropdown$onSelect(
						$author$project$Components$Reports$PaymentApplications$DateFilterTypeSelected(dateFilterType)),
						$author$project$Ui$Dropdown$selected(
						_Utils_eq(model.Hh, dateFilterType))
					]),
				$elm$html$Html$text(
					$author$project$Components$Reports$PaymentApplications$dateFilterTypeToLabel(dateFilterType)));
		},
		allTypes);
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(currentLabel)
			]),
		items,
		model.m9);
};
var $author$project$Components$Reports$PaymentApplications$DepositSelected = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$Deposit$Shared$amountInCents = function (_v0) {
	var record = _v0;
	return record.LE;
};
var $author$project$Api$Provider$Deposit$All$amountInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Deposit$Shared$amountInCents(shared);
};
var $author$project$Api$Provider$Deposit$Shared$availableOn = function (_v0) {
	var record = _v0;
	return record.Mp;
};
var $author$project$Api$Provider$Deposit$All$availableOn = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Deposit$Shared$availableOn(shared);
};
var $author$project$Components$Reports$PaymentApplications$depositLabel = function (deposit) {
	return $author$project$Utils$Currency$fromInt(
		$author$project$Api$Provider$Deposit$All$amountInCents(deposit)) + (' on ' + A2(
		$author$project$Formatters$Date$toString,
		$author$project$Formatters$Date$Full,
		$author$project$Api$Provider$Deposit$All$availableOn(deposit)));
};
var $author$project$Api$Provider$Deposit$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Deposit$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Deposit$Shared$id(shared);
};
var $author$project$Components$Reports$PaymentApplications$depositDropdownItems = F2(
	function (deposits, currentDepositId) {
		return A2(
			$elm$core$List$cons,
			A2(
				$author$project$Ui$Dropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$Dropdown$onSelect(
						$author$project$Components$Reports$PaymentApplications$DepositSelected($elm$core$Maybe$Nothing)),
						$author$project$Ui$Dropdown$selected(
						_Utils_eq(currentDepositId, $elm$core$Maybe$Nothing))
					]),
				$elm$html$Html$text('All Deposits')),
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Dropdown$separator,
				A2(
					$elm$core$List$map,
					function (deposit) {
						var depositId = $author$project$Api$Provider$Deposit$All$id(deposit);
						return A2(
							$author$project$Ui$Dropdown$item,
							_List_fromArray(
								[
									$author$project$Ui$Dropdown$onSelect(
									$author$project$Components$Reports$PaymentApplications$DepositSelected(
										$elm$core$Maybe$Just(depositId))),
									$author$project$Ui$Dropdown$selected(
									_Utils_eq(
										currentDepositId,
										$elm$core$Maybe$Just(depositId)))
								]),
							$elm$html$Html$text(
								$author$project$Components$Reports$PaymentApplications$depositLabel(deposit)));
					},
					deposits)));
	});
var $author$project$Components$Reports$PaymentApplications$viewDepositDropdown = function (model) {
	var placeholder = function () {
		var _v1 = model.agt;
		if (!_v1.$) {
			var depositId = _v1.a;
			var _v2 = model.cC;
			if (_v2.$ === 3) {
				var deposits = _v2.a;
				return A2(
					$elm$core$Maybe$withDefault,
					depositId,
					A2(
						$elm$core$Maybe$map,
						$author$project$Components$Reports$PaymentApplications$depositLabel,
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (deposit) {
									return _Utils_eq(
										$author$project$Api$Provider$Deposit$All$id(deposit),
										depositId);
								},
								deposits))));
			} else {
				return depositId;
			}
		} else {
			return 'Deposit';
		}
	}();
	var items = function () {
		var _v0 = model.cC;
		if (_v0.$ === 3) {
			var deposits = _v0.a;
			return A2($author$project$Components$Reports$PaymentApplications$depositDropdownItems, deposits, model.agt);
		} else {
			return _List_Nil;
		}
	}();
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(placeholder)
			]),
		items,
		model.nh);
};
var $author$project$Components$Reports$PaymentApplications$FeeTypeSelected = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Reports$PaymentApplications$feeTypeToLabel = function (feeType) {
	switch (feeType) {
		case 0:
			return 'Bank Transfer';
		case 1:
			return 'Card (Non Amex)';
		case 2:
			return 'American Express';
		case 3:
			return 'All External';
		default:
			return 'Cash/Check/Other';
	}
};
var $author$project$Components$Reports$PaymentApplications$feeTypeDropdownItems = function (currentFeeType) {
	return A2(
		$elm$core$List$cons,
		A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Components$Reports$PaymentApplications$FeeTypeSelected($elm$core$Maybe$Nothing)),
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(currentFeeType, $elm$core$Maybe$Nothing))
				]),
			$elm$html$Html$text('All Payment Types')),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$Dropdown$separator,
			A2(
				$elm$core$List$map,
				function (feeType) {
					return A2(
						$author$project$Ui$Dropdown$item,
						_List_fromArray(
							[
								$author$project$Ui$Dropdown$onSelect(
								$author$project$Components$Reports$PaymentApplications$FeeTypeSelected(
									$elm$core$Maybe$Just(feeType))),
								$author$project$Ui$Dropdown$selected(
								_Utils_eq(
									currentFeeType,
									$elm$core$Maybe$Just(feeType)))
							]),
						$elm$html$Html$text(
							$author$project$Components$Reports$PaymentApplications$feeTypeToLabel(feeType)));
				},
				_List_fromArray(
					[0, 1, 2, 3, 4]))));
};
var $author$project$Components$Reports$PaymentApplications$viewFeeTypeDropdown = function (model) {
	var placeholder = function () {
		var _v0 = model.Sj;
		if (!_v0.$) {
			var feeType = _v0.a;
			return $author$project$Components$Reports$PaymentApplications$feeTypeToLabel(feeType);
		} else {
			return 'Payment Type';
		}
	}();
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(placeholder)
			]),
		$author$project$Components$Reports$PaymentApplications$feeTypeDropdownItems(model.Sj),
		model.nJ);
};
var $author$project$Components$Reports$PaymentApplications$PaymentProcessorSelected = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Reports$PaymentApplications$paymentProcessorDropdownItems = F2(
	function (isHintAdmin, currentProcessor) {
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Dropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$Dropdown$onSelect(
						$author$project$Components$Reports$PaymentApplications$PaymentProcessorSelected($elm$core$Maybe$Nothing)),
						$author$project$Ui$Dropdown$selected(
						_Utils_eq(currentProcessor, $elm$core$Maybe$Nothing))
					]),
				$elm$html$Html$text('All Processors')),
				$author$project$Ui$Dropdown$separator,
				A2(
				$author$project$Ui$Dropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$Dropdown$onSelect(
						$author$project$Components$Reports$PaymentApplications$PaymentProcessorSelected(
							$elm$core$Maybe$Just('rainforest'))),
						$author$project$Ui$Dropdown$selected(
						_Utils_eq(
							currentProcessor,
							$elm$core$Maybe$Just('rainforest')))
					]),
				$elm$html$Html$text(
					A2($author$project$Utils$PaymentProcessor$toLabelText, isHintAdmin, 'rainforest'))),
				A2(
				$author$project$Ui$Dropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$Dropdown$onSelect(
						$author$project$Components$Reports$PaymentApplications$PaymentProcessorSelected(
							$elm$core$Maybe$Just('stripe'))),
						$author$project$Ui$Dropdown$selected(
						_Utils_eq(
							currentProcessor,
							$elm$core$Maybe$Just('stripe')))
					]),
				$elm$html$Html$text(
					A2($author$project$Utils$PaymentProcessor$toLabelText, isHintAdmin, 'stripe')))
			]);
	});
var $author$project$Components$Reports$PaymentApplications$viewPaymentProcessorDropdown = function (model) {
	var placeholder = function () {
		var _v0 = model.Zd;
		if (!_v0.$) {
			var processor = _v0.a;
			return $elm$html$Html$text(
				A2($author$project$Utils$PaymentProcessor$toLabelText, model.Ij, processor));
		} else {
			return $elm$html$Html$text('Payment Processor');
		}
	}();
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[placeholder]),
		A2($author$project$Components$Reports$PaymentApplications$paymentProcessorDropdownItems, model.Ij, model.Zd),
		model.o3);
};
var $author$project$Ui$Table$alignBottom = $author$project$Ui$Table$VerticalAlignedBottom;
var $author$project$Api$Provider$Reports$Summary$summaryRowHintFeeInCents = function (_v0) {
	var record = _v0;
	return record.q_.Ty;
};
var $author$project$Api$Provider$Reports$Summary$summaryRowStripeFeeInCents = function (_v0) {
	var record = _v0;
	return record.q_.aco;
};
var $author$project$Api$Provider$Reports$Summary$summaryRowTotalFeeInCents = function (_v0) {
	var record = _v0;
	return record.q_.adn;
};
var $author$project$Components$Reports$PaymentApplications$feePlanTypeAmounts = F2(
	function (feePlanType, summaryRow) {
		if (!feePlanType) {
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween]),
					_List_fromArray(
						[
							$elm$html$Html$text('Platform Fees'),
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$Reports$Summary$summaryRowHintFeeInCents(summaryRow)))
								]))
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween]),
					_List_fromArray(
						[
							$elm$html$Html$text('Stripe Fees'),
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$Reports$Summary$summaryRowStripeFeeInCents(summaryRow)))
								]))
						]))
				]);
		} else {
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween]),
					_List_fromArray(
						[
							$elm$html$Html$text('Transaction Fees'),
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$Reports$Summary$summaryRowTotalFeeInCents(summaryRow)))
								]))
						]))
				]);
		}
	});
var $author$project$Components$Reports$PaymentApplications$viewSummaryRow = F2(
	function (model, summaryRow) {
		var routeParams = _List_fromArray(
			[
				$author$project$Ui$Link$routeParams(
				A2(
					$author$project$Utils$Report$summaryRowTableParams,
					$author$project$Components$Reports$PaymentApplications$urlParams(model),
					summaryRow))
			]);
		var netInCents = ($author$project$Api$Provider$Reports$Summary$summaryRowAmountInCents(summaryRow) - $author$project$Api$Provider$Reports$Summary$summaryRowHintFeeInCents(summaryRow)) - $author$project$Api$Provider$Reports$Summary$summaryRowStripeFeeInCents(summaryRow);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$alignBottom]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_fromArray(
								[$author$project$Ui$Typography$info]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Reports__PaymentApplications,
									routeParams,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'None',
												$author$project$Api$Provider$Reports$Summary$summaryRowName(summaryRow)))
										]))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$alignBottom]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Reports__PaymentApplications,
							routeParams,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$String$pluralize,
										'payment application',
										$author$project$Api$Provider$Reports$Summary$summaryRowCount(summaryRow)))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$spaceBetween]),
							_List_fromArray(
								[
									$elm$html$Html$text('Net Amount'),
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Utils$Currency$fromInt(netInCents))
										]))
								])),
						_Utils_ap(
							A2($author$project$Components$Reports$PaymentApplications$feePlanTypeAmounts, model.Si, summaryRow),
							_List_fromArray(
								[
									$author$project$Ui$HorizontalRule$view(
									_List_fromArray(
										[$author$project$Ui$HorizontalRule$thin])),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textRight]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$strong,
											_List_Nil,
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Reports__PaymentApplications,
													routeParams,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Utils$Currency$fromInt(
																$author$project$Api$Provider$Reports$Summary$summaryRowAmountInCents(summaryRow)))
														]))
												]))
										]))
								]))))
				]));
	});
var $author$project$Components$Reports$PaymentApplications$viewSummaryTable = function (model) {
	var summaryType = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Api$Provider$Reports$Summary$summaryType, $author$project$Formatters$String$humanize),
			$author$project$Api$Data$toMaybe(model.acF)));
	var summaryRows = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$Reports$Summary$summaryRows,
			$author$project$Api$Data$toMaybe(model.acF)));
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$loading(
				!$author$project$Api$Data$isSuccess(model.acF)),
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mb4]),
						_List_fromArray(
							[
								$elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
							]))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(summaryType)
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Number of Payment Applications')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4),
						$author$project$Ui$Table$textRight
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Amount')
					]))
			]),
		A2(
			$elm$core$List$map,
			$author$project$Components$Reports$PaymentApplications$viewSummaryRow(model),
			summaryRows),
		_List_Nil);
};
var $author$project$Components$Reports$PaymentApplications$SortTable = function (a) {
	return {$: 19, a: a};
};
var $author$project$Ui$Typography$Amount = {$: 9};
var $author$project$Ui$Typography$amount = $author$project$Ui$Typography$Amount;
var $author$project$Api$Provider$Reports$PaymentApplication$amountInCents = function (_v0) {
	var record = _v0;
	return record.LE;
};
var $author$project$Api$Provider$Reports$PaymentApplication$category = function (_v0) {
	var record = _v0;
	return record.GW;
};
var $author$project$Api$Provider$Reports$PaymentApplication$charge = function (_v0) {
	var record = _v0;
	return record.afx;
};
var $author$project$Api$Provider$Reports$PaymentApplication$deposit = function (_v0) {
	var record = _v0;
	return record.Hq;
};
var $author$project$Components$Reports$PaymentApplications$depositParams = function (deposit) {
	return _List_fromArray(
		[
			A2(
			$elm$url$Url$Builder$string,
			'start',
			$author$project$Utils$Date$toQuery(
				$author$project$Api$Provider$Deposit$Shared$availableOn(deposit))),
			A2(
			$elm$url$Url$Builder$string,
			'end',
			$author$project$Utils$Date$toQuery(
				$author$project$Api$Provider$Deposit$Shared$availableOn(deposit)))
		]);
};
var $author$project$Api$Provider$Receipt$Shared$feeType = function (_v0) {
	var record = _v0;
	return record.Sj;
};
var $author$project$Api$Provider$Reports$PaymentApplication$hintFeeInCents = function (_v0) {
	var record = _v0;
	return record.Ty;
};
var $author$project$Api$Provider$Reports$PaymentApplication$invoice = function (_v0) {
	var record = _v0;
	return record.Uk;
};
var $author$project$Api$Provider$Reports$PaymentApplication$location = function (_v0) {
	var record = _v0;
	return record.ais;
};
var $author$project$Api$Provider$Receipt$Shared$objectType = function (_v0) {
	var record = _v0;
	return record.X7;
};
var $author$project$Api$Provider$Reports$PaymentApplication$patient = function (_v0) {
	var record = _v0;
	return record.YY;
};
var $author$project$Api$Provider$Receipt$Shared$paymentProcessor = function (_v0) {
	var record = _v0;
	return record.Zd;
};
var $author$project$Api$Provider$Reports$PaymentApplication$practitioner = function (_v0) {
	var record = _v0;
	return record.aka;
};
var $author$project$Api$Provider$Reports$PaymentApplication$receipt = function (_v0) {
	var record = _v0;
	return record.$a;
};
var $author$project$Api$Provider$Deposit$Shared$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Api$Provider$Reports$PaymentApplication$stripeFeeInCents = function (_v0) {
	var record = _v0;
	return record.aco;
};
var $author$project$Api$Provider$Reports$PaymentApplication$totalFeeInCents = function (_v0) {
	var record = _v0;
	return record.adn;
};
var $author$project$Api$Provider$Reports$PaymentApplication$transactionDate = function (_v0) {
	var record = _v0;
	return record.adw;
};
var $author$project$Api$Provider$Receipt$Shared$expectedDepositDate = function (_v0) {
	var record = _v0;
	return record.RU;
};
var $author$project$Components$Reports$PaymentApplications$viewDateWithoutDeposit = function (paymentApplication) {
	var _v0 = A2(
		$elm$core$Maybe$andThen,
		$author$project$Api$Provider$Receipt$Shared$expectedDepositDate,
		$author$project$Api$Provider$Reports$PaymentApplication$receipt(paymentApplication));
	if (!_v0.$) {
		var expectedDepositDate = _v0.a;
		return A2(
			$author$project$Ui$Typography$p,
			_List_fromArray(
				[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
			_List_fromArray(
				[
					$elm$html$Html$text('Expected deposit date: '),
					$elm$html$Html$text(
					A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, expectedDepositDate))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Reports$PaymentApplications$viewRow = F5(
	function (feePlanType, trackPatientsByLocation, canGoToPatients, isHintAdmin, paymentApplication) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$Date$toString,
										$author$project$Formatters$Date$Full,
										$author$project$Api$Provider$Reports$PaymentApplication$transactionDate(paymentApplication))),
									function () {
									var _v0 = $author$project$Api$Provider$Reports$PaymentApplication$deposit(paymentApplication);
									if (!_v0.$) {
										var deposit = _v0.a;
										return ($author$project$Api$Provider$Deposit$Shared$status(deposit) === 5) ? $author$project$Components$Reports$PaymentApplications$viewDateWithoutDeposit(paymentApplication) : A2(
											$author$project$Ui$Typography$p,
											_List_fromArray(
												[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
											_List_fromArray(
												[
													$elm$html$Html$text('Deposited '),
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Reports__Deposits,
													_List_fromArray(
														[
															$author$project$Ui$Link$routeParams(
															$author$project$Components$Reports$PaymentApplications$depositParams(deposit))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Utils$Currency$fromInt(
																$author$project$Api$Provider$Deposit$Shared$amountInCents(deposit))),
															$elm$html$Html$text(' on '),
															$elm$html$Html$text(
															A2(
																$author$project$Formatters$Date$toString,
																$author$project$Formatters$Date$Full,
																$author$project$Api$Provider$Deposit$Shared$availableOn(deposit)))
														]))
												]));
									} else {
										return $author$project$Components$Reports$PaymentApplications$viewDateWithoutDeposit(paymentApplication);
									}
								}()
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											A2($elm$core$Basics$composeR, $author$project$Api$Provider$Receipt$Shared$objectType, $author$project$Formatters$String$humanize),
											$author$project$Api$Provider$Reports$PaymentApplication$receipt(paymentApplication)))),
									$elm$html$Html$text(' '),
									A2(
									$author$project$Ui$Typography$text,
									A2(
										$elm$core$List$cons,
										$author$project$Ui$Typography$small,
										A2(
											$elm$core$List$cons,
											$author$project$Ui$Typography$amount,
											($author$project$Api$Provider$Reports$PaymentApplication$amountInCents(paymentApplication) < 0) ? _List_fromArray(
												[$author$project$Ui$Typography$danger]) : _List_Nil)),
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$Reports$PaymentApplication$amountInCents(paymentApplication))),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
											'Fee Category: ' + A2(
												$elm$core$Maybe$withDefault,
												'',
												A2(
													$elm$core$Maybe$map,
													$author$project$Api$Provider$Receipt$Shared$feeType,
													$author$project$Api$Provider$Reports$PaymentApplication$receipt(paymentApplication)))),
											A2($elm$html$Html$br, _List_Nil, _List_Nil),
											A2(
											$elm$html$Html$span,
											_List_Nil,
											function () {
												if (!feePlanType) {
													return _List_fromArray(
														[
															$elm$html$Html$text(
															'Platform Fee: ' + $author$project$Utils$Currency$fromInt(
																$author$project$Api$Provider$Reports$PaymentApplication$hintFeeInCents(paymentApplication))),
															A2($elm$html$Html$br, _List_Nil, _List_Nil),
															$elm$html$Html$text(
															'Stripe Fee: ' + $author$project$Utils$Currency$fromInt(
																$author$project$Api$Provider$Reports$PaymentApplication$stripeFeeInCents(paymentApplication)))
														]);
												} else {
													return _List_fromArray(
														[
															$elm$html$Html$text(
															'Transaction Fee: ' + $author$project$Utils$Currency$fromInt(
																$author$project$Api$Provider$Reports$PaymentApplication$totalFeeInCents(paymentApplication)))
														]);
												}
											}())
										]))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$Reports$PaymentApplication$amountInCents(paymentApplication))),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
									'for '),
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[
											$author$project$Ui$Typography$phi(true)
										]),
									A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										A2(
											$elm$core$Maybe$map,
											$author$project$Api$Provider$Reports$Charge$name,
											$author$project$Api$Provider$Reports$PaymentApplication$charge(paymentApplication)))),
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
									' on ' + A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										A2(
											$elm$core$Maybe$map,
											$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
											A2(
												$elm$core$Maybe$map,
												$author$project$Api$Provider$Reports$Charge$serviceDate,
												$author$project$Api$Provider$Reports$PaymentApplication$charge(paymentApplication)))))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							function () {
								var _v2 = $author$project$Api$Provider$Reports$PaymentApplication$invoice(paymentApplication);
								if (!_v2.$) {
									var invoice = _v2.a;
									var paidBy = A2(
										$author$project$Ui$Typography$text,
										_List_fromArray(
											[
												$author$project$Ui$Typography$phi(true),
												$author$project$Ui$Typography$small,
												$author$project$Ui$Typography$muted
											]),
										'paid by ' + A2(
											$elm$core$Maybe$withDefault,
											'N/A',
											A2(
												$elm$core$Maybe$map,
												$author$project$Api$Common$Payable$Owner$Min$name,
												$author$project$Api$Common$Payable$Invoice$MinWithOwner$owner(invoice))));
									var invoicePath_ = function () {
										var _v4 = $author$project$Api$Common$Payable$Invoice$MinWithOwner$type_(invoice);
										switch (_v4) {
											case 1:
												var _v5 = _Utils_Tuple2(
													canGoToPatients,
													$author$project$Api$Common$Payable$Invoice$MinWithOwner$owner(invoice));
												if (_v5.a && (!_v5.b.$)) {
													var owner = _v5.b.a;
													return $elm$core$Maybe$Just(
														$author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top(
															{
																Us: $author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice),
																YZ: $author$project$Api$Common$Payable$Owner$Min$id(owner)
															}));
												} else {
													return $elm$core$Maybe$Nothing;
												}
											case 0:
												var _v6 = $author$project$Api$Common$Payable$Invoice$MinWithOwner$owner(invoice);
												if (!_v6.$) {
													var owner = _v6.a;
													return $elm$core$Maybe$Just(
														$author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String(
															{
																fZ: $author$project$Api$Common$Payable$Owner$Min$id(owner),
																ahP: $author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice)
															}));
												} else {
													return $elm$core$Maybe$Nothing;
												}
											default:
												return $elm$core$Maybe$Nothing;
										}
									}();
									var invoiceNumber = $elm$html$Html$text(
										'#' + $elm$core$String$fromInt(
											$author$project$Api$Common$Payable$Invoice$MinWithOwner$invoiceNumber(invoice)));
									if (!invoicePath_.$) {
										var path = invoicePath_.a;
										return _List_fromArray(
											[
												A3(
												$author$project$Ui$Link$route,
												path,
												_List_Nil,
												_List_fromArray(
													[invoiceNumber])),
												A2($elm$html$Html$br, _List_Nil, _List_Nil),
												paidBy
											]);
									} else {
										return _List_fromArray(
											[
												invoiceNumber,
												A2($elm$html$Html$br, _List_Nil, _List_Nil),
												paidBy
											]);
									}
								} else {
									return _List_Nil;
								}
							}()),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							function () {
								var _v7 = _Utils_Tuple2(
									$author$project$Api$Provider$Reports$PaymentApplication$patient(paymentApplication),
									canGoToPatients);
								if (!_v7.a.$) {
									if (_v7.b) {
										var patient = _v7.a.a;
										return _List_fromArray(
											[
												A3(
												$author$project$Ui$Link$route,
												$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
													{
														YZ: $author$project$Api$Provider$Patient$Min$id(patient)
													}),
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$text,
														_List_fromArray(
															[
																$author$project$Ui$Typography$phi(true)
															]),
														A2(
															$author$project$Formatters$String$ellipsis,
															20,
															$author$project$Api$Provider$Patient$Min$name(patient)))
													]))
											]);
									} else {
										var patient = _v7.a.a;
										return _List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$text,
												_List_fromArray(
													[
														$author$project$Ui$Typography$phi(true)
													]),
												A2(
													$author$project$Formatters$String$ellipsis,
													20,
													$author$project$Api$Provider$Patient$Min$name(patient)))
											]);
									}
								} else {
									var _v8 = _v7.a;
									return _List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[
													$author$project$Ui$Typography$phi(true)
												]),
											'N/A')
										]);
								}
							}()),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											$author$project$Api$Provider$Category$Min$name,
											$author$project$Api$Provider$Reports$PaymentApplication$category(paymentApplication))))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_fromArray(
								[
									$author$project$Ui$Table$colspan(
									trackPatientsByLocation ? 1 : 2)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$String$ellipsis,
										20,
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Maybe$map,
												$author$project$Api$Provider$Practitioner$Min$name,
												$author$project$Api$Provider$Reports$PaymentApplication$practitioner(paymentApplication)))))
								]))
						]),
						trackPatientsByLocation ? _List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$String$ellipsis,
										20,
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Maybe$map,
												$author$project$Api$Provider$Location$Min$name,
												$author$project$Api$Provider$Reports$PaymentApplication$location(paymentApplication)))))
								]))
						]) : _List_Nil,
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$core$Maybe$withDefault,
									$author$project$Utils$Html$empty,
									A4(
										$author$project$Utils$PaymentProcessor$toBadge,
										true,
										isHintAdmin,
										paymentApplication,
										A2(
											$elm$core$Basics$composeR,
											$author$project$Api$Provider$Reports$PaymentApplication$receipt,
											$elm$core$Maybe$andThen($author$project$Api$Provider$Receipt$Shared$paymentProcessor))))
								]))
						])
					])));
	});
var $author$project$Components$Reports$PaymentApplications$viewTable = function (model) {
	var _v0 = function () {
		var _v1 = model.G;
		if (_v1.$ === 3) {
			var paymentApplications_ = _v1.a;
			return _Utils_Tuple2(false, paymentApplications_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var paymentApplications = _v0.b;
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$map,
					$author$project$Api$Column$view(
						A2($author$project$Api$Column$Sortable, model.alA, $author$project$Components$Reports$PaymentApplications$SortTable)),
					model.N3),
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[$author$project$Ui$Table$textRight]),
						_List_fromArray(
							[
								A2($elm$html$Html$map, $author$project$Components$Reports$PaymentApplications$ExportCsvMsg, $author$project$Components$ExportCsv$button)
							]))
					])
				])),
		A2(
			$elm$core$List$map,
			A4($author$project$Components$Reports$PaymentApplications$viewRow, model.Si, model.adt, model.GQ, model.Ij),
			paymentApplications),
		_List_Nil);
};
var $author$project$Components$Reports$PaymentApplications$TransactionTypeSelected = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Reports$PaymentApplications$transactionTypeToLabel = function (transactionType) {
	switch (transactionType) {
		case 0:
			return 'All Transactions';
		case 1:
			return 'Payments';
		default:
			return 'Refunds';
	}
};
var $author$project$Components$Reports$PaymentApplications$transactionTypeDropdownItems = function (currentTransactionType) {
	return A2(
		$elm$core$List$cons,
		A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Components$Reports$PaymentApplications$TransactionTypeSelected($elm$core$Maybe$Nothing)),
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(currentTransactionType, $elm$core$Maybe$Nothing))
				]),
			$elm$html$Html$text('All Transaction Types')),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$Dropdown$separator,
			A2(
				$elm$core$List$map,
				function (transactionType) {
					return A2(
						$author$project$Ui$Dropdown$item,
						_List_fromArray(
							[
								$author$project$Ui$Dropdown$onSelect(
								$author$project$Components$Reports$PaymentApplications$TransactionTypeSelected(
									$elm$core$Maybe$Just(transactionType))),
								$author$project$Ui$Dropdown$selected(
								_Utils_eq(
									currentTransactionType,
									$elm$core$Maybe$Just(transactionType)))
							]),
						$elm$html$Html$text(
							$author$project$Components$Reports$PaymentApplications$transactionTypeToLabel(transactionType)));
				},
				_List_fromArray(
					[1, 2]))));
};
var $author$project$Components$Reports$PaymentApplications$viewTransactionTypeDropdownFilter = function (model) {
	var placeholder = function () {
		var _v0 = model.Kb;
		if (!_v0.$) {
			var transactionType = _v0.a;
			return $author$project$Components$Reports$PaymentApplications$transactionTypeToLabel(transactionType);
		} else {
			return 'Transaction Type';
		}
	}();
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(placeholder)
			]),
		$author$project$Components$Reports$PaymentApplications$transactionTypeDropdownItems(model.Kb),
		model.qE);
};
var $author$project$Components$Reports$PaymentApplications$view = F2(
	function (apiClient, model) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Reports$PaymentApplications$ExportCsvMsg,
				A3(
					$author$project$Components$ExportCsv$modal,
					apiClient,
					_List_fromArray(
						[
							$author$project$Components$ExportCsv$report(
							$author$project$Api$Data$totalCount(model.G)),
							$author$project$Components$ExportCsv$reportParams(
							A2($elm$core$Basics$composeL, $author$project$Api$Provider$Reports$PaymentApplication$listOptionsToParams, $author$project$Components$Reports$PaymentApplications$fetchPaymentApplicationsParams)(model))
						]),
					model.nD)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Received Payments')
									])),
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								function () {
									var _v0 = model.G;
									if (_v0.$ === 3) {
										var headers = _v0.b;
										var totalPassthroughFeesAmount = A2($author$project$Components$Reports$PaymentApplications$amountFromHeader, headers, 'x-total-passthrough-fee-amount');
										var totalFeeAmount = A2($author$project$Components$Reports$PaymentApplications$amountFromHeader, headers, 'x-total-fee-amount');
										var totalAmount = A2($author$project$Components$Reports$PaymentApplications$amountFromHeader, headers, 'x-total-amount');
										var totalNetAmount = totalAmount - totalFeeAmount;
										return _List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Utils$Currency$fromInt(totalAmount)),
												A2(
												$author$project$Ui$Typography$text,
												_List_fromArray(
													[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
												' Net ' + ($author$project$Utils$Currency$fromInt(totalNetAmount) + (' across ' + A2(
													$author$project$Formatters$String$pluralize,
													'payment application',
													A2($author$project$Components$Reports$PaymentApplications$amountFromHeader, headers, 'x-total-count'))))),
												function () {
												var _v1 = model.Si;
												if (!_v1) {
													return A2(
														$author$project$Ui$Typography$text,
														_List_fromArray(
															[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
														' including ' + ($author$project$Utils$Currency$fromInt(
															A2($author$project$Components$Reports$PaymentApplications$amountFromHeader, headers, 'x-total-hint-fee-amount')) + (' in Platform fees and ' + ($author$project$Utils$Currency$fromInt(
															A2($author$project$Components$Reports$PaymentApplications$amountFromHeader, headers, 'x-total-stripe-fee-amount')) + ' in Stripe fees.'))));
												} else {
													return A2(
														$author$project$Ui$Typography$text,
														_List_fromArray(
															[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
														' including ' + ($author$project$Utils$Currency$fromInt(totalFeeAmount) + ' in transaction fees.'));
												}
											}(),
												function () {
												if (totalPassthroughFeesAmount > 0) {
													var nonPassthroughFeesAmount = totalFeeAmount - totalPassthroughFeesAmount;
													var passthroughFeesText = ' Of those fees, ' + ($author$project$Utils$Currency$fromInt(totalPassthroughFeesAmount) + (' were paid by patients and ' + ($author$project$Utils$Currency$fromInt(nonPassthroughFeesAmount) + ' by your practice.')));
													return A2(
														$author$project$Ui$Typography$text,
														_List_fromArray(
															[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
														passthroughFeesText);
												} else {
													return $author$project$Utils$Html$empty;
												}
											}()
											]);
									} else {
										return _List_fromArray(
											[
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$spaceX2]),
												_List_fromArray(
													[
														$author$project$Ui$Skeleton$text(
														_List_fromArray(
															[
																$author$project$Ui$Skeleton$spanFromText('$1000.00')
															])),
														A2(
														$author$project$Ui$Typography$span,
														_List_fromArray(
															[$author$project$Ui$Typography$small]),
														_List_fromArray(
															[
																$author$project$Ui$Skeleton$text(
																_List_fromArray(
																	[
																		$author$project$Ui$Skeleton$span(5)
																	]))
															]))
													]))
											]);
									}
								}()),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpBlock]),
								_List_fromArray(
									[
										$elm$html$Html$text('Total payments (and refunds) applied to charges, excluding '),
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Reports__CreditTransactions,
										_List_fromArray(
											[
												$author$project$Ui$Link$routeParams(
												$author$project$Components$Reports$PaymentApplications$creditTransactionsReportParams(model))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('credit transactions')
											])),
										$elm$html$Html$text('.')
									])),
								A2(
								$author$project$Ui$Grid$row,
								_List_fromArray(
									[$author$project$Ui$Grid$gutterSm]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(3)
											]),
										_List_fromArray(
											[
												$author$project$Components$Reports$PaymentApplications$viewDateFilterTypeDropdown(model)
											])),
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(9)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Components$Reports$PaymentApplications$DateRangeInputMsg,
												$author$project$Components$DateRangeInput$view(model.i4))
											]))
									])),
								A2(
								$author$project$Ui$Grid$row,
								_List_fromArray(
									[$author$project$Ui$Grid$gutterSm]),
								_Utils_ap(
									A2(
										$elm$core$List$map,
										A2(
											$elm$core$Basics$composeR,
											$elm$core$List$singleton,
											$author$project$Ui$Grid$column(
												_List_fromArray(
													[
														$author$project$Ui$Grid$span(6),
														$author$project$Ui$Grid$spanMd(4)
													]))),
										A2(
											$elm$core$List$map,
											$elm$html$Html$map($author$project$Components$Reports$PaymentApplications$GroupLocationAndPractitionerFiltersMsg),
											A2(
												$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$view,
												_List_fromArray(
													[$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$multi]),
												model.dn))),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$span(6),
													$author$project$Ui$Grid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$PaymentApplications$viewCategoryResourceFilter(model.c8)
												])),
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$span(6),
													$author$project$Ui$Grid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$PaymentApplications$viewDepositDropdown(model)
												])),
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$span(6),
													$author$project$Ui$Grid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$PaymentApplications$viewFeeTypeDropdown(model)
												])),
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$span(6),
													$author$project$Ui$Grid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$PaymentApplications$viewPaymentProcessorDropdown(model)
												])),
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$span(6),
													$author$project$Ui$Grid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$PaymentApplications$viewByDropdown(model)
												])),
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$span(6),
													$author$project$Ui$Grid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$PaymentApplications$viewTransactionTypeDropdownFilter(model)
												]))
										]))),
								A2(
								$author$project$Ui$Grid$row,
								_List_fromArray(
									[$author$project$Ui$Grid$gutterSm]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_Nil,
										function () {
											var activeFilters = _Utils_ap(
												A2(
													$elm$core$List$map,
													$elm$html$Html$map($author$project$Components$Reports$PaymentApplications$CategoryResourceFilterMsg),
													$author$project$Components$ResourceFilter$Category$viewMultiSelected(model.c8)),
												A2(
													$elm$core$List$map,
													$elm$html$Html$map($author$project$Components$Reports$PaymentApplications$GroupLocationAndPractitionerFiltersMsg),
													$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewMultiSelected(model.dn)));
											return $elm$core$List$isEmpty(activeFilters) ? _List_Nil : _List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$mt2, $author$project$Ui$Element$mb2]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$strong,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Active filters')
																]))
														])),
													A2($elm$html$Html$span, _List_Nil, activeFilters)
												]);
										}())
									]))
							])),
						function () {
						var _v2 = model.amg;
						if (!_v2) {
							return $author$project$Components$Reports$PaymentApplications$viewTable(model);
						} else {
							return $author$project$Components$Reports$PaymentApplications$viewSummaryTable(model);
						}
					}(),
						function () {
						var _v3 = model.amg;
						if (!_v3) {
							return A2(
								$author$project$Ui$Panel$footer,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Components$Reports$PaymentApplications$PaginationMsg,
										A2(
											$author$project$Api$Pagination$view,
											_List_fromArray(
												[
													$author$project$Ui$Pagination$List$loading(
													!$author$project$Utils$Maybe$toBool(
														$author$project$Api$Data$toMaybe(model.G)))
												]),
											model.ajJ))
									]));
						} else {
							return $author$project$Ui$Panel$none;
						}
					}()
					]))
			]);
	});
var $author$project$Pages$Reports$PaymentApplications$view = function (model) {
	return {
		fO: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			A2($author$project$Components$Reports$PaymentApplications$view, model.Gv, model.kV)),
		ac9: 'Reports | Received Payments'
	};
};
var $author$project$Pages$Reports$PaymentApplications$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Reports$PaymentApplications$init, aiq: $author$project$Pages$Reports$PaymentApplications$load, k8: $author$project$Pages$Reports$PaymentApplications$save, alO: $author$project$Pages$Reports$PaymentApplications$subscriptions, adT: $author$project$Pages$Reports$PaymentApplications$update, amo: $author$project$Pages$Reports$PaymentApplications$view});
var $author$project$Pages$Reports$PaymentApplications$Summary$ReportMsg = $elm$core$Basics$identity;
var $author$project$Components$Reports$PaymentApplications$Summary = 1;
var $author$project$Pages$Reports$PaymentApplications$Summary$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.DE;
		var _v1 = A5($author$project$Components$Reports$PaymentApplications$init, 1, session, practice, shared, query);
		var report = _v1.a;
		var reportCmd = _v1.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, kV: report},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportCmd));
	});
var $author$project$Pages$Reports$PaymentApplications$Summary$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$PaymentApplications$Summary$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Reports$PaymentApplications$Summary$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Reports$PaymentApplications$subscriptions(model.kV));
};
var $author$project$Pages$Reports$PaymentApplications$Summary$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Reports$PaymentApplications$update, model.Gv, subMsg, model.kV);
		var report = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{kV: report}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Pages$Reports$PaymentApplications$Summary$view = function (model) {
	return {
		fO: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			A2($author$project$Components$Reports$PaymentApplications$view, model.Gv, model.kV)),
		ac9: 'Reports | Received Payments'
	};
};
var $author$project$Pages$Reports$PaymentApplications$Summary$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Reports$PaymentApplications$Summary$init, aiq: $author$project$Pages$Reports$PaymentApplications$Summary$load, k8: $author$project$Pages$Reports$PaymentApplications$Summary$save, alO: $author$project$Pages$Reports$PaymentApplications$Summary$subscriptions, adT: $author$project$Pages$Reports$PaymentApplications$Summary$update, amo: $author$project$Pages$Reports$PaymentApplications$Summary$view});
var $author$project$Pages$Reports$Revenue$ReportMsg = $elm$core$Basics$identity;
var $author$project$Components$Reports$Revenue$Table = 0;
var $author$project$Components$Reports$Revenue$ByDropdownMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Reports$Revenue$CategoryResourceFilterMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Reports$Revenue$DateRangeInputMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Reports$Revenue$GroupLocationAndPractitionerFiltersMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Report$RevenueLine = 6;
var $author$project$Components$Reports$Revenue$urlParams = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Tuple$pair('start'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.dd, 0)),
			model.JV),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Tuple$pair('end'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.dd, 0)),
			model.HB),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('category'),
			model.iF),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('location_group'),
			model.gL),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('location'),
			model.We),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('practitioner'),
			model.Z2),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('by'),
			model.co)
		]);
	return $elm$core$Dict$fromList(
		A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams));
};
var $author$project$Components$Reports$Revenue$buildUrl = function (model) {
	return A2(
		$elm$url$Url$Builder$relative,
		_List_fromArray(
			[
				function () {
				var _v0 = model.co;
				if (!_v0.$) {
					return $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__Revenue__Summary);
				} else {
					return $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__Revenue);
				}
			}()
			]),
		A2(
			$elm$core$List$append,
			$author$project$Api$Pagination$toPageQuery(model.ajJ),
			A2(
				$elm$core$List$append,
				$author$project$Api$Sort$toQuery(model.alA),
				$author$project$Utils$QueryParameter$fromDict(
					$author$project$Components$Reports$Revenue$urlParams(model)))));
};
var $author$project$Components$Reports$Revenue$dateRangeInputSettings = F2(
	function (start, end) {
		var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
		return _Utils_update(
			defaultSettings,
			{ahy: start, al5: end});
	});
var $author$project$Components$Reports$Revenue$GotRevenueLines = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Reports$Revenue$fetchRevenueLinesParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				GW: model.iF,
				HB: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.HB),
				ais: model.We,
				s4: model.gL,
				ajJ: model.ajJ,
				aka: model.Z2,
				alA: model.alA,
				JV: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.JV)
			});
	};
};
var $author$project$Api$Provider$Reports$RevenueLine$RevenueLine = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$RevenueLine$Record = F8(
	function (transactionDate, amountInCents, category, charge, invoice, client, practitioner, location) {
		return {LE: amountInCents, GW: category, afx: charge, NJ: client, Uk: invoice, ais: location, aka: practitioner, adw: transactionDate};
	});
var $author$project$Api$Provider$Reports$RevenueLine$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'location',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Location$Min$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'practitioner',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Practitioner$Min$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'client',
			$elm$json$Json$Decode$nullable($author$project$Api$Provider$Reports$RevenueLine$Client$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'invoice',
				$elm$json$Json$Decode$nullable($author$project$Api$Common$Payable$Invoice$MinWithOwner$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'charge',
					$elm$json$Json$Decode$nullable($author$project$Api$Provider$Reports$Charge$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'category',
						$elm$json$Json$Decode$nullable($author$project$Api$Provider$Category$Min$decoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'amount_in_cents',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'transaction_date',
								$author$project$Utils$Date$decode,
								$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$RevenueLine$Record)))))))));
var $author$project$Api$Provider$Reports$RevenueLine$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Reports$RevenueLine$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$RevenueLine$listDefaults = {GW: $elm$core$Maybe$Nothing, HB: $elm$core$Maybe$Nothing, ais: $elm$core$Maybe$Nothing, s4: $elm$core$Maybe$Nothing, ajJ: $author$project$Api$Pagination$init, aka: $elm$core$Maybe$Nothing, alA: $author$project$Api$Sort$init, JV: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$Reports$RevenueLine$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Reports$RevenueLine$listDefaults);
	return A2(
		$elm$core$List$append,
		$author$project$Api$Pagination$toApiParams(options.ajJ),
		A2(
			$elm$core$List$append,
			$author$project$Api$Sort$toParams(options.alA),
			$elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						var _v0 = options.JV;
						if (!_v0.$) {
							var start_ = _v0.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'start', start_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v1 = options.HB;
						if (!_v1.$) {
							var end_ = _v1.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'end', end_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v2 = options.GW;
						if (!_v2.$) {
							var taxJurisdiction_ = _v2.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'category', taxJurisdiction_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v3 = options.s4;
						if (!_v3.$) {
							var locationGroup_ = _v3.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'location_group', locationGroup_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v4 = options.ais;
						if (!_v4.$) {
							var location_ = _v4.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'location', location_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v5 = options.aka;
						if (!_v5.$) {
							var practitioner_ = _v5.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'practitioner', practitioner_)
								]);
						} else {
							return _List_Nil;
						}
					}()
					]))));
};
var $author$project$Api$Provider$Reports$RevenueLine$listPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['reports', 'revenue_lines']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Reports$RevenueLine$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Reports$RevenueLine$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Reports$RevenueLine$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$RevenueLine$listPath)));
	});
var $author$project$Components$Reports$Revenue$fetchRevenueLines = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Api$Provider$Reports$RevenueLine$list,
			apiClient,
			$author$project$Components$Reports$Revenue$fetchRevenueLinesParams(model),
			$author$project$Components$Reports$Revenue$GotRevenueLines);
	});
var $author$project$Components$Reports$Revenue$GotSummary = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Reports$Revenue$fetchSummaryParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				GW: model.iF,
				HB: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.HB),
				ais: model.We,
				s4: model.gL,
				aka: model.Z2,
				JV: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.JV)
			});
	};
};
var $author$project$Api$Provider$Reports$RevenueLine$summary = F4(
	function (apiClient, by, optionals, toMsg) {
		return A5(
			$author$project$Api$Provider$Reports$Summary$retrieve,
			apiClient,
			$author$project$Api$Provider$Reports$RevenueLine$listPath,
			by,
			$author$project$Api$Provider$Reports$RevenueLine$listOptionsToParams(optionals),
			toMsg);
	});
var $author$project$Components$Reports$Revenue$fetchSummary = F2(
	function (apiClient, model) {
		return A4(
			$author$project$Api$Provider$Reports$RevenueLine$summary,
			apiClient,
			A2($elm$core$Maybe$withDefault, '', model.co),
			$author$project$Components$Reports$Revenue$fetchSummaryParams(model),
			$author$project$Components$Reports$Revenue$GotSummary);
	});
var $author$project$Components$Reports$Revenue$fetchData = F2(
	function (apiClient, model) {
		var _v0 = model.amg;
		if (!_v0) {
			return A2($author$project$Components$Reports$Revenue$fetchRevenueLines, apiClient, model);
		} else {
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Components$Reports$Revenue$fetchSummary, apiClient, model),
						A2($author$project$Components$Reports$Revenue$fetchRevenueLines, apiClient, model)
					]));
		}
	});
var $author$project$Components$Reports$Revenue$initColumns = function (trackPatientsByLocation) {
	return A2(
		$elm$core$List$cons,
		A3($author$project$Api$Column$init, 'transaction_date', true, 'Txn Date'),
		A2(
			$elm$core$List$cons,
			A3($author$project$Api$Column$init, 'amount_in_cents', true, 'Charge'),
			A2(
				$elm$core$List$cons,
				A3($author$project$Api$Column$init, 'invoice', false, 'Invoice'),
				A2(
					$elm$core$List$cons,
					A3($author$project$Api$Column$init, 'client', true, 'Client'),
					A2(
						$elm$core$List$cons,
						A3($author$project$Api$Column$init, 'category', true, 'Category'),
						A2(
							$elm$core$List$cons,
							A3($author$project$Api$Column$init, 'practitioner', true, 'Provider'),
							trackPatientsByLocation ? _List_fromArray(
								[
									A3($author$project$Api$Column$init, 'location', true, 'Location')
								]) : _List_Nil))))));
};
var $author$project$Components$Reports$Revenue$init = F5(
	function (type_, session, practice, _v0, query) {
		var currentDate = _v0.dd;
		var apiClient = _v0.Gv;
		var hinterViewOff = _v0.ahK;
		var trackPatientsByLocation = $author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice);
		var practitionerId = A2($elm$core$Dict$get, 'practitioner', query);
		var locationId = A2($elm$core$Dict$get, 'location', query);
		var locationGroupId = A2($elm$core$Dict$get, 'location_group', query);
		var categoryId = A2($elm$core$Dict$get, 'category', query);
		var _v1 = function () {
			if (!type_) {
				return _Utils_Tuple2($author$project$Api$Data$Loading, $author$project$Api$Data$NotAsked);
			} else {
				return _Utils_Tuple2($author$project$Api$Data$NotAsked, $author$project$Api$Data$Loading);
			}
		}();
		var revenueLines = _v1.a;
		var summary = _v1.b;
		var _v3 = A7($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$init, apiClient, session, practice, false, locationGroupId, locationId, practitionerId);
		var groupLocationAndPractitionerFilters = _v3.a;
		var groupLocationAndPractitionerFiltersCmd = _v3.b;
		var _v4 = $author$project$Utils$DateWithDefault$fromQuery(query);
		var start = _v4.a;
		var end = _v4.b;
		var _v5 = A2(
			$author$project$Components$DateRangeInput$init,
			'date-range-input',
			A2(
				$author$project$Components$Reports$Revenue$dateRangeInputSettings,
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					start),
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					end)));
		var dateRangeInput = _v5.a;
		var dateRangeInputCmd = _v5.b;
		var _v6 = A3($author$project$Utils$Report$CategoryResourceFilter$init, apiClient, session, categoryId);
		var categoryResourceFilter = _v6.a;
		var categoryResourceFilterCmd = _v6.b;
		var model = {
			co: A2($elm$core$Dict$get, 'by', query),
			mB: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'by-dropdown', al6: $author$project$Components$Reports$Revenue$ByDropdownMsg})),
			GP: A3($author$project$Permission$canGoTo, session, hinterViewOff, 18),
			GQ: A3($author$project$Permission$canGoTo, session, hinterViewOff, 50),
			iF: categoryId,
			c8: categoryResourceFilter,
			N3: $author$project$Components$Reports$Revenue$initColumns(trackPatientsByLocation),
			dd: currentDate,
			i4: dateRangeInput,
			HB: end,
			nD: $author$project$Components$ExportCsv$initForPractice(6),
			dn: groupLocationAndPractitionerFilters,
			gL: locationGroupId,
			We: locationId,
			ajJ: $author$project$Api$Pagination$initFromQuery(query),
			Z2: practitionerId,
			bg: revenueLines,
			alA: A3(
				$author$project$Api$Sort$withDefault,
				'transaction_date',
				1,
				$author$project$Api$Sort$initFromQuery(query)),
			JV: start,
			acF: summary,
			adt: trackPatientsByLocation,
			amg: type_
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Revenue$CategoryResourceFilterMsg, categoryResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Revenue$DateRangeInputMsg, dateRangeInputCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Revenue$GroupLocationAndPractitionerFiltersMsg, groupLocationAndPractitionerFiltersCmd),
						A2($author$project$Components$Reports$Revenue$fetchData, apiClient, model),
						A2($elm$core$Basics$composeR, $author$project$Components$Reports$Revenue$buildUrl, $author$project$Ports$Navigation$replaceUrl)(model)
					])));
	});
var $author$project$Pages$Reports$Revenue$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.DE;
		var _v1 = A5($author$project$Components$Reports$Revenue$init, 0, session, practice, shared, query);
		var report = _v1.a;
		var reportTaxCmd = _v1.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, kV: report},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportTaxCmd));
	});
var $author$project$Pages$Reports$Revenue$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$Revenue$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Reports$Revenue$ExportCsvMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Reports$Revenue$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$Revenue$DateRangeInputMsg,
				$author$project$Components$DateRangeInput$subscriptions(model.i4)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$Revenue$ExportCsvMsg,
				$author$project$Components$ExportCsv$subscriptions(model.nD)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$Revenue$GroupLocationAndPractitionerFiltersMsg,
				$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$subscriptions(model.dn)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$Revenue$CategoryResourceFilterMsg,
				$author$project$Components$ResourceFilter$Category$subscriptions(model.c8)),
				$author$project$Ui$Dropdown$subscriptions(model.mB)
			]));
};
var $author$project$Pages$Reports$Revenue$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Reports$Revenue$subscriptions(model.kV));
};
var $author$project$Components$Reports$Revenue$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 2:
				var subMsg = msg.a;
				var categoryResourceResult = A3($author$project$Components$ResourceFilter$Category$update, apiClient, subMsg, model.c8);
				var categoryId = function () {
					var _v2 = categoryResourceResult.agZ;
					if (!_v2.$) {
						return $author$project$Components$ResourceFilter$Category$value(categoryResourceResult.aiO);
					} else {
						return model.iF;
					}
				}();
				var newModel = _Utils_update(
					model,
					{iF: categoryId, c8: categoryResourceResult.aiO});
				var _v1 = _Utils_eq(model.iF, newModel.iF) ? _Utils_Tuple2(model.bg, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					$author$project$Api$Data$Loading,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$Revenue$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$Revenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])));
				var revenueLines = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{bg: revenueLines}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Revenue$CategoryResourceFilterMsg, categoryResourceResult.GZ),
								cmd
							])),
					categoryResourceResult.aR);
			case 3:
				var subMsg = msg.a;
				var _v3 = A2($author$project$Ui$Dropdown$update, subMsg, model.mB);
				var byDropdown = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{mB: byDropdown}),
					cmd,
					_List_Nil);
			case 4:
				var by = msg.a;
				var newModel = _Utils_update(
					model,
					{
						co: by,
						ajJ: $author$project$Api$Pagination$reset(model.ajJ),
						bg: $author$project$Api$Data$Loading
					});
				var cmds = function () {
					var _v4 = _Utils_Tuple2(model.amg, newModel.co);
					if (!_v4.a) {
						if (!_v4.b.$) {
							var _v5 = _v4.a;
							return _List_fromArray(
								[
									A2($elm$core$Basics$composeR, $author$project$Components$Reports$Revenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
								]);
						} else {
							var _v6 = _v4.a;
							var _v7 = _v4.b;
							return _List_fromArray(
								[$elm$core$Platform$Cmd$none]);
						}
					} else {
						if (_v4.b.$ === 1) {
							var _v8 = _v4.a;
							var _v9 = _v4.b;
							return _List_fromArray(
								[
									A2($elm$core$Basics$composeR, $author$project$Components$Reports$Revenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
								]);
						} else {
							var _v10 = _v4.a;
							return _List_fromArray(
								[
									A2($author$project$Components$Reports$Revenue$fetchData, apiClient, newModel),
									A2($elm$core$Basics$composeR, $author$project$Components$Reports$Revenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
								]);
						}
					}
				}();
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(cmds),
					_List_Nil);
			case 0:
				var subMsg = msg.a;
				var _v11 = A2($author$project$Components$DateRangeInput$update, subMsg, model.i4);
				var dateRangeInput = _v11.a;
				var subCmd = _v11.b;
				var event = _v11.c;
				var newModel = function () {
					if (event.$ === 1) {
						var fromDate = event.a;
						var toDate = event.b;
						return _Utils_update(
							model,
							{
								i4: dateRangeInput,
								HB: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
								ajJ: $author$project$Api$Pagination$reset(model.ajJ),
								bg: $author$project$Api$Data$Loading,
								JV: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
							});
					} else {
						return _Utils_update(
							model,
							{i4: dateRangeInput});
					}
				}();
				var cmds = (_Utils_eq(newModel.JV, model.JV) && _Utils_eq(newModel.HB, model.HB)) ? _List_Nil : _List_fromArray(
					[
						A2($author$project$Components$Reports$Revenue$fetchData, apiClient, newModel),
						A2($elm$core$Basics$composeR, $author$project$Components$Reports$Revenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
					]);
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$cons,
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Revenue$DateRangeInputMsg, subCmd),
							cmds)),
					_List_Nil);
			case 1:
				var subMsg = msg.a;
				var result = A3($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$update, apiClient, subMsg, model.dn);
				var _v13 = result.agZ;
				if (!_v13.$) {
					var locationGroupId = _v13.a;
					var locationId = _v13.b;
					var practitionerId = _v13.c;
					var newModel = _Utils_update(
						model,
						{
							dn: result.aiO,
							gL: locationGroupId,
							We: locationId,
							ajJ: $author$project$Api$Pagination$reset(model.ajJ),
							Z2: practitionerId,
							bg: $author$project$Api$Data$Loading
						});
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Revenue$GroupLocationAndPractitionerFiltersMsg, result.GZ),
									A2($author$project$Components$Reports$Revenue$fetchData, apiClient, newModel),
									A2($elm$core$Basics$composeR, $author$project$Components$Reports$Revenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
								])),
						result.aR);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dn: result.aiO}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Revenue$GroupLocationAndPractitionerFiltersMsg, result.GZ),
						result.aR);
				}
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ),
								bg: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bg: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 6:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{acF: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 7:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{ajJ: pagination, bg: $author$project$Api$Data$Loading});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$Revenue$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$Revenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 8:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						alA: A2($author$project$Api$Sort$update, columnId, model.alA)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$Revenue$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$Revenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v15 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.nD);
				var exportCsv = _v15.a;
				var subCmd = _v15.b;
				var subOutMsg = _v15.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nD: exportCsv}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Revenue$ExportCsvMsg, subCmd),
					subOutMsg);
		}
	});
var $author$project$Pages$Reports$Revenue$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Reports$Revenue$update, model.Gv, subMsg, model.kV);
		var report = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{kV: report}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Components$Reports$Revenue$PaginationMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Reports$Revenue$amountFromHeader = F2(
	function (headers, name) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$String$toInt,
				A2($elm$core$Dict$get, name, headers)));
	});
var $author$project$Components$Reports$Revenue$BySelected = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Reports$Revenue$byDropdownItems = F2(
	function (trackPatientsByLocation, currentBy) {
		return A2(
			$elm$core$List$cons,
			A2(
				$author$project$Ui$Dropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$Dropdown$onSelect(
						$author$project$Components$Reports$Revenue$BySelected($elm$core$Maybe$Nothing)),
						$author$project$Ui$Dropdown$selected(
						_Utils_eq(currentBy, $elm$core$Maybe$Nothing))
					]),
				$elm$html$Html$text('No Summary')),
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Dropdown$separator,
				A2(
					$elm$core$List$cons,
					A2(
						$author$project$Ui$Dropdown$item,
						_List_fromArray(
							[
								$author$project$Ui$Dropdown$onSelect(
								$author$project$Components$Reports$Revenue$BySelected(
									$elm$core$Maybe$Just('category'))),
								$author$project$Ui$Dropdown$selected(
								_Utils_eq(
									currentBy,
									$elm$core$Maybe$Just('category')))
							]),
						$elm$html$Html$text('Category')),
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$Ui$Dropdown$item,
							_List_fromArray(
								[
									$author$project$Ui$Dropdown$onSelect(
									$author$project$Components$Reports$Revenue$BySelected(
										$elm$core$Maybe$Just('practitioner'))),
									$author$project$Ui$Dropdown$selected(
									_Utils_eq(
										currentBy,
										$elm$core$Maybe$Just('practitioner')))
								]),
							$elm$html$Html$text('Provider')),
						trackPatientsByLocation ? _List_fromArray(
							[
								A2(
								$author$project$Ui$Dropdown$item,
								_List_fromArray(
									[
										$author$project$Ui$Dropdown$onSelect(
										$author$project$Components$Reports$Revenue$BySelected(
											$elm$core$Maybe$Just('location'))),
										$author$project$Ui$Dropdown$selected(
										_Utils_eq(
											currentBy,
											$elm$core$Maybe$Just('location')))
									]),
								$elm$html$Html$text('Location'))
							]) : _List_Nil))));
	});
var $author$project$Components$Reports$Revenue$byToDisplayName = function (by) {
	switch (by) {
		case 'category':
			return 'Category';
		case 'practitioner':
			return 'Provider';
		case 'location':
			return 'Location';
		default:
			return by;
	}
};
var $author$project$Components$Reports$Revenue$viewByDropdown = function (model) {
	var placeholder = function () {
		var _v0 = model.co;
		if (!_v0.$) {
			var by = _v0.a;
			return $author$project$Components$Reports$Revenue$byToDisplayName(by);
		} else {
			return 'Summarize by';
		}
	}();
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(placeholder)
			]),
		A2($author$project$Components$Reports$Revenue$byDropdownItems, model.adt, model.co),
		model.mB);
};
var $author$project$Components$Reports$Revenue$viewCategoryResourceFilter = function (categoryResourceFilter) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Reports$Revenue$CategoryResourceFilterMsg,
		A2(
			$author$project$Components$ResourceFilter$Category$view,
			_List_fromArray(
				[
					$author$project$Components$ResourceFilter$style(1),
					$author$project$Components$ResourceFilter$multi
				]),
			categoryResourceFilter));
};
var $author$project$Components$Reports$Revenue$viewSummaryRow = F2(
	function (model, summaryRow) {
		var routeParams = _List_fromArray(
			[
				$author$project$Ui$Link$routeParams(
				A2(
					$author$project$Utils$Report$summaryRowTableParams,
					$author$project$Components$Reports$Revenue$urlParams(model),
					summaryRow))
			]);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_fromArray(
								[
									$author$project$Ui$Typography$info,
									$author$project$Ui$Typography$phi(true)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Reports__Revenue,
									routeParams,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'Unassigned',
												$author$project$Api$Provider$Reports$Summary$summaryRowName(summaryRow)))
										]))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Reports__Revenue,
							routeParams,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$String$pluralize,
										'charge',
										$author$project$Api$Provider$Reports$Summary$summaryRowCount(summaryRow)))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$textRight]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Reports__Revenue,
									routeParams,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Utils$Currency$fromInt(
												$author$project$Api$Provider$Reports$Summary$summaryRowAmountInCents(summaryRow)))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Reports$Revenue$viewSummaryTable = function (model) {
	var summaryType = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Api$Provider$Reports$Summary$summaryType, $author$project$Formatters$String$humanize),
			$author$project$Api$Data$toMaybe(model.acF)));
	var summaryRows = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$Reports$Summary$summaryRows,
			$author$project$Api$Data$toMaybe(model.acF)));
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$loading(
				!$author$project$Api$Data$isSuccess(model.acF)),
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mb4]),
						_List_fromArray(
							[
								$elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
							]))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(summaryType)
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Number of Charges')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4),
						$author$project$Ui$Table$textRight
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Amount')
					]))
			]),
		A2(
			$elm$core$List$map,
			$author$project$Components$Reports$Revenue$viewSummaryRow(model),
			summaryRows),
		_List_Nil);
};
var $author$project$Components$Reports$Revenue$SortTable = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$Reports$RevenueLine$amountInCents = function (_v0) {
	var record = _v0;
	return record.LE;
};
var $author$project$Api$Provider$Reports$RevenueLine$category = function (_v0) {
	var record = _v0;
	return record.GW;
};
var $author$project$Api$Provider$Reports$RevenueLine$charge = function (_v0) {
	var record = _v0;
	return record.afx;
};
var $author$project$Api$Provider$Reports$RevenueLine$client = function (_v0) {
	var record = _v0;
	return record.NJ;
};
var $author$project$Api$Provider$Reports$RevenueLine$invoice = function (_v0) {
	var record = _v0;
	return record.Uk;
};
var $author$project$Api$Provider$Reports$RevenueLine$location = function (_v0) {
	var record = _v0;
	return record.ais;
};
var $author$project$Api$Provider$Reports$RevenueLine$practitioner = function (_v0) {
	var record = _v0;
	return record.aka;
};
var $author$project$Api$Provider$Reports$RevenueLine$transactionDate = function (_v0) {
	var record = _v0;
	return record.adw;
};
var $author$project$Components$Reports$Revenue$viewRow = F4(
	function (trackPatientsByLocation, canGoToPatients, canGoToCompany, revenueLine) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$Date$toString,
										$author$project$Formatters$Date$Full,
										$author$project$Api$Provider$Reports$RevenueLine$transactionDate(revenueLine)))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$Reports$RevenueLine$amountInCents(revenueLine))),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
									'for '),
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[
											$author$project$Ui$Typography$phi(true)
										]),
									A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										A2(
											$elm$core$Maybe$map,
											$author$project$Api$Provider$Reports$Charge$name,
											$author$project$Api$Provider$Reports$RevenueLine$charge(revenueLine)))),
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
									' on ' + A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										A2(
											$elm$core$Maybe$map,
											$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
											A2(
												$elm$core$Maybe$map,
												$author$project$Api$Provider$Reports$Charge$serviceDate,
												$author$project$Api$Provider$Reports$RevenueLine$charge(revenueLine)))))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							function () {
								var _v0 = $author$project$Api$Provider$Reports$RevenueLine$invoice(revenueLine);
								if (!_v0.$) {
									var invoice = _v0.a;
									var invoiceStatus = A2(
										$author$project$Ui$Badge$fromString,
										_List_Nil,
										$author$project$Api$Common$Payable$Invoice$MinWithOwner$status(invoice));
									var invoicePath_ = function () {
										var _v2 = $author$project$Api$Common$Payable$Invoice$MinWithOwner$type_(invoice);
										switch (_v2) {
											case 1:
												var _v3 = _Utils_Tuple2(
													canGoToPatients,
													$author$project$Api$Common$Payable$Invoice$MinWithOwner$owner(invoice));
												if (_v3.a && (!_v3.b.$)) {
													var owner = _v3.b.a;
													return $elm$core$Maybe$Just(
														$author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top(
															{
																Us: $author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice),
																YZ: $author$project$Api$Common$Payable$Owner$Min$id(owner)
															}));
												} else {
													return $elm$core$Maybe$Nothing;
												}
											case 0:
												var _v4 = _Utils_Tuple2(
													canGoToCompany,
													$author$project$Api$Common$Payable$Invoice$MinWithOwner$owner(invoice));
												if (_v4.a && (!_v4.b.$)) {
													var owner = _v4.b.a;
													return $elm$core$Maybe$Just(
														$author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String(
															{
																fZ: $author$project$Api$Common$Payable$Owner$Min$id(owner),
																ahP: $author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice)
															}));
												} else {
													return $elm$core$Maybe$Nothing;
												}
											default:
												return $elm$core$Maybe$Nothing;
										}
									}();
									var invoiceNumber = $elm$html$Html$text(
										'#' + ($elm$core$String$fromInt(
											$author$project$Api$Common$Payable$Invoice$MinWithOwner$invoiceNumber(invoice)) + ' '));
									var _for = A2(
										$author$project$Ui$Typography$text,
										_List_fromArray(
											[
												$author$project$Ui$Typography$phi(true),
												$author$project$Ui$Typography$small,
												$author$project$Ui$Typography$muted
											]),
										'for ' + A2(
											$elm$core$Maybe$withDefault,
											'N/A',
											A2(
												$elm$core$Maybe$map,
												$author$project$Api$Common$Payable$Owner$Min$name,
												$author$project$Api$Common$Payable$Invoice$MinWithOwner$owner(invoice))));
									if (!invoicePath_.$) {
										var path = invoicePath_.a;
										return _List_fromArray(
											[
												A3(
												$author$project$Ui$Link$route,
												path,
												_List_Nil,
												_List_fromArray(
													[invoiceNumber, invoiceStatus])),
												A2($elm$html$Html$br, _List_Nil, _List_Nil),
												_for
											]);
									} else {
										return _List_fromArray(
											[
												invoiceNumber,
												invoiceStatus,
												A2($elm$html$Html$br, _List_Nil, _List_Nil),
												_for
											]);
									}
								} else {
									return _List_Nil;
								}
							}()),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							function () {
								var _v5 = $author$project$Api$Provider$Reports$RevenueLine$client(revenueLine);
								if (!_v5.$) {
									var client = _v5.a;
									var path = function () {
										var _v7 = $author$project$Api$Provider$Reports$RevenueLine$Client$type_(client);
										if (!_v7) {
											return canGoToPatients ? $elm$core$Maybe$Just(
												$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
													{
														YZ: $author$project$Api$Provider$Reports$RevenueLine$Client$id(client)
													})) : $elm$core$Maybe$Nothing;
										} else {
											return canGoToCompany ? $elm$core$Maybe$Just(
												$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top(
													{
														fZ: $author$project$Api$Provider$Reports$RevenueLine$Client$id(client)
													})) : $elm$core$Maybe$Nothing;
										}
									}();
									var clientName = A2(
										$author$project$Ui$Typography$text,
										_List_fromArray(
											[
												$author$project$Ui$Typography$phi(true)
											]),
										A2(
											$author$project$Formatters$String$ellipsis,
											20,
											$author$project$Api$Provider$Reports$RevenueLine$Client$name(client)));
									if (!path.$) {
										var path_ = path.a;
										return _List_fromArray(
											[
												A3(
												$author$project$Ui$Link$route,
												path_,
												_List_Nil,
												_List_fromArray(
													[clientName]))
											]);
									} else {
										return _List_fromArray(
											[clientName]);
									}
								} else {
									return _List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[
													$author$project$Ui$Typography$phi(true)
												]),
											'N/A')
										]);
								}
							}()),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											$author$project$Api$Provider$Category$Min$name,
											$author$project$Api$Provider$Reports$RevenueLine$category(revenueLine))))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_fromArray(
								[
									$author$project$Ui$Table$colspan(
									trackPatientsByLocation ? 1 : 2)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$String$ellipsis,
										20,
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Maybe$map,
												$author$project$Api$Provider$Practitioner$Min$name,
												$author$project$Api$Provider$Reports$RevenueLine$practitioner(revenueLine)))))
								]))
						]),
						trackPatientsByLocation ? _List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$String$ellipsis,
										20,
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Maybe$map,
												$author$project$Api$Provider$Location$Min$name,
												$author$project$Api$Provider$Reports$RevenueLine$location(revenueLine)))))
								]))
						]) : _List_Nil
					])));
	});
var $author$project$Components$Reports$Revenue$viewTable = function (model) {
	var _v0 = function () {
		var _v1 = model.bg;
		if (_v1.$ === 3) {
			var revenueLines_ = _v1.a;
			return _Utils_Tuple2(false, revenueLines_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var revenueLines = _v0.b;
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$map,
					$author$project$Api$Column$view(
						A2($author$project$Api$Column$Sortable, model.alA, $author$project$Components$Reports$Revenue$SortTable)),
					model.N3),
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[$author$project$Ui$Table$textRight]),
						_List_fromArray(
							[
								A2($elm$html$Html$map, $author$project$Components$Reports$Revenue$ExportCsvMsg, $author$project$Components$ExportCsv$button)
							]))
					])
				])),
		A2(
			$elm$core$List$map,
			A3($author$project$Components$Reports$Revenue$viewRow, model.adt, model.GQ, model.GP),
			revenueLines),
		_List_Nil);
};
var $author$project$Components$Reports$Revenue$view = F2(
	function (apiClient, model) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Reports$Revenue$ExportCsvMsg,
				A3(
					$author$project$Components$ExportCsv$modal,
					apiClient,
					_List_fromArray(
						[
							$author$project$Components$ExportCsv$report(
							$author$project$Api$Data$totalCount(model.bg)),
							$author$project$Components$ExportCsv$reportParams(
							A2($elm$core$Basics$composeL, $author$project$Api$Provider$Reports$RevenueLine$listOptionsToParams, $author$project$Components$Reports$Revenue$fetchRevenueLinesParams)(model))
						]),
					model.nD)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Billed Revenue')
									])),
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								function () {
									var _v0 = model.bg;
									if (_v0.$ === 3) {
										var headers = _v0.b;
										return _List_fromArray(
											[
												$elm$html$Html$text(
												'Total: ' + $author$project$Utils$Currency$fromInt(
													A2($author$project$Components$Reports$Revenue$amountFromHeader, headers, 'x-total-amount')))
											]);
									} else {
										return _List_fromArray(
											[
												$author$project$Ui$Skeleton$text(
												_List_fromArray(
													[
														$author$project$Ui$Skeleton$spanFromText('Total: $1000.00')
													]))
											]);
									}
								}()),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpBlock]),
								_List_fromArray(
									[
										$elm$html$Html$text('Total billed (and reversed out) revenue across retail customers and employers')
									])),
								A2(
								$elm$html$Html$map,
								$author$project$Components$Reports$Revenue$DateRangeInputMsg,
								$author$project$Components$DateRangeInput$view(model.i4)),
								A2(
								$author$project$Ui$Grid$row,
								_List_fromArray(
									[$author$project$Ui$Grid$gutterSm]),
								_Utils_ap(
									A2(
										$elm$core$List$map,
										A2(
											$elm$core$Basics$composeR,
											$elm$core$List$singleton,
											$author$project$Ui$Grid$column(
												_List_fromArray(
													[
														$author$project$Ui$Grid$span(6),
														$author$project$Ui$Grid$spanMd(4)
													]))),
										A2(
											$elm$core$List$map,
											$elm$html$Html$map($author$project$Components$Reports$Revenue$GroupLocationAndPractitionerFiltersMsg),
											A2(
												$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$view,
												_List_fromArray(
													[$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$multi]),
												model.dn))),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$span(6),
													$author$project$Ui$Grid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$Revenue$viewCategoryResourceFilter(model.c8)
												])),
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$span(6),
													$author$project$Ui$Grid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$Revenue$viewByDropdown(model)
												]))
										]))),
								A2(
								$author$project$Ui$Grid$row,
								_List_fromArray(
									[$author$project$Ui$Grid$gutterSm]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_Nil,
										function () {
											var activeFilters = _Utils_ap(
												A2(
													$elm$core$List$map,
													$elm$html$Html$map($author$project$Components$Reports$Revenue$CategoryResourceFilterMsg),
													$author$project$Components$ResourceFilter$Category$viewMultiSelected(model.c8)),
												A2(
													$elm$core$List$map,
													$elm$html$Html$map($author$project$Components$Reports$Revenue$GroupLocationAndPractitionerFiltersMsg),
													$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewMultiSelected(model.dn)));
											return $elm$core$List$isEmpty(activeFilters) ? _List_Nil : _List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$mt2, $author$project$Ui$Element$mb2]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$strong,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Active filters')
																]))
														])),
													A2($elm$html$Html$span, _List_Nil, activeFilters)
												]);
										}())
									]))
							])),
						function () {
						var _v1 = model.amg;
						if (!_v1) {
							return $author$project$Components$Reports$Revenue$viewTable(model);
						} else {
							return $author$project$Components$Reports$Revenue$viewSummaryTable(model);
						}
					}(),
						function () {
						var _v2 = model.amg;
						if (!_v2) {
							return A2(
								$author$project$Ui$Panel$footer,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Components$Reports$Revenue$PaginationMsg,
										A2(
											$author$project$Api$Pagination$view,
											_List_fromArray(
												[
													$author$project$Ui$Pagination$List$loading(
													!$author$project$Utils$Maybe$toBool(
														$author$project$Api$Data$toMaybe(model.bg)))
												]),
											model.ajJ))
									]));
						} else {
							return $author$project$Ui$Panel$none;
						}
					}()
					]))
			]);
	});
var $author$project$Pages$Reports$Revenue$view = function (model) {
	return {
		fO: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			A2($author$project$Components$Reports$Revenue$view, model.Gv, model.kV)),
		ac9: 'Reports | Billed Revenue'
	};
};
var $author$project$Pages$Reports$Revenue$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Reports$Revenue$init, aiq: $author$project$Pages$Reports$Revenue$load, k8: $author$project$Pages$Reports$Revenue$save, alO: $author$project$Pages$Reports$Revenue$subscriptions, adT: $author$project$Pages$Reports$Revenue$update, amo: $author$project$Pages$Reports$Revenue$view});
var $author$project$Pages$Reports$Revenue$Summary$ReportMsg = $elm$core$Basics$identity;
var $author$project$Components$Reports$Revenue$Summary = 1;
var $author$project$Pages$Reports$Revenue$Summary$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.DE;
		var _v1 = A5($author$project$Components$Reports$Revenue$init, 1, session, practice, shared, query);
		var report = _v1.a;
		var reportCmd = _v1.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, kV: report},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportCmd));
	});
var $author$project$Pages$Reports$Revenue$Summary$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$Revenue$Summary$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Reports$Revenue$Summary$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Reports$Revenue$subscriptions(model.kV));
};
var $author$project$Pages$Reports$Revenue$Summary$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Reports$Revenue$update, model.Gv, subMsg, model.kV);
		var report = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{kV: report}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Pages$Reports$Revenue$Summary$view = function (model) {
	return {
		fO: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			A2($author$project$Components$Reports$Revenue$view, model.Gv, model.kV)),
		ac9: 'Reports | Billed Revenue'
	};
};
var $author$project$Pages$Reports$Revenue$Summary$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Reports$Revenue$Summary$init, aiq: $author$project$Pages$Reports$Revenue$Summary$load, k8: $author$project$Pages$Reports$Revenue$Summary$save, alO: $author$project$Pages$Reports$Revenue$Summary$subscriptions, adT: $author$project$Pages$Reports$Revenue$Summary$update, amo: $author$project$Pages$Reports$Revenue$Summary$view});
var $author$project$Pages$Reports$SalesTax$ReportMsg = $elm$core$Basics$identity;
var $author$project$Components$Reports$SalesTax$Table = 0;
var $author$project$Components$Reports$SalesTax$ByDropdownMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Reports$SalesTax$DateRangeInputMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Reports$SalesTax$GotTaxJurisdictions = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Reports$SalesTax$GroupLocationAndPractitionerFiltersMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Reports$SalesTax$TaxJurisdictionDropdownMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Report$TaxLine = 8;
var $author$project$Components$Reports$SalesTax$dateRangeInputSettings = F2(
	function (start, end) {
		var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
		return _Utils_update(
			defaultSettings,
			{ahy: start, al5: end});
	});
var $author$project$Components$Reports$SalesTax$GotSummary = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Reports$SalesTax$fetchSummaryParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				HB: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.HB),
				ais: model.We,
				s4: model.gL,
				aka: model.Z2,
				JV: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.JV),
				u4: model.hT
			});
	};
};
var $author$project$Api$Provider$Reports$TaxLine$listDefaults = {HB: $elm$core$Maybe$Nothing, ais: $elm$core$Maybe$Nothing, s4: $elm$core$Maybe$Nothing, ajJ: $author$project$Api$Pagination$init, aka: $elm$core$Maybe$Nothing, alA: $author$project$Api$Sort$init, JV: $elm$core$Maybe$Nothing, u4: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$Reports$TaxLine$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Reports$TaxLine$listDefaults);
	return A2(
		$elm$core$List$append,
		$author$project$Api$Pagination$toApiParams(options.ajJ),
		A2(
			$elm$core$List$append,
			$author$project$Api$Sort$toParams(options.alA),
			$elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						var _v0 = options.JV;
						if (!_v0.$) {
							var start_ = _v0.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'start', start_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v1 = options.HB;
						if (!_v1.$) {
							var end_ = _v1.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'end', end_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v2 = options.aka;
						if (!_v2.$) {
							var practitioner_ = _v2.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'practitioner', practitioner_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v3 = options.u4;
						if (!_v3.$) {
							var taxJurisdiction_ = _v3.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'tax_jurisdiction', taxJurisdiction_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v4 = options.s4;
						if (!_v4.$) {
							var locationGroup_ = _v4.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'location_group', locationGroup_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v5 = options.ais;
						if (!_v5.$) {
							var location_ = _v5.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'location', location_)
								]);
						} else {
							return _List_Nil;
						}
					}()
					]))));
};
var $author$project$Api$Provider$Reports$TaxLine$listPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['reports', 'tax_lines']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Reports$TaxLine$summary = F4(
	function (apiClient, by, optionals, toMsg) {
		return A5(
			$author$project$Api$Provider$Reports$Summary$retrieve,
			apiClient,
			$author$project$Api$Provider$Reports$TaxLine$listPath,
			by,
			$author$project$Api$Provider$Reports$TaxLine$listOptionsToParams(optionals),
			toMsg);
	});
var $author$project$Components$Reports$SalesTax$fetchSummary = F2(
	function (apiClient, model) {
		return A4(
			$author$project$Api$Provider$Reports$TaxLine$summary,
			apiClient,
			A2($elm$core$Maybe$withDefault, '', model.co),
			$author$project$Components$Reports$SalesTax$fetchSummaryParams(model),
			$author$project$Components$Reports$SalesTax$GotSummary);
	});
var $author$project$Components$Reports$SalesTax$GotTaxLines = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Reports$SalesTax$fetchTaxLinesParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				HB: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.HB),
				ais: model.We,
				s4: model.gL,
				ajJ: model.ajJ,
				aka: model.Z2,
				alA: model.alA,
				JV: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.JV),
				u4: model.hT
			});
	};
};
var $author$project$Api$Provider$Reports$TaxLine$TaxLine = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$TaxLine$Record = F8(
	function (transactionDate, amountInCents, rate, serviceDate, taxJurisdiction, invoice, practitioner, location) {
		return {LE: amountInCents, Uk: invoice, ais: location, aka: practitioner, _1: rate, aa$: serviceDate, u4: taxJurisdiction, adw: transactionDate};
	});
var $author$project$Api$Provider$TaxJurisdiction$Min$TaxJurisdiction = $elm$core$Basics$identity;
var $author$project$Api$Provider$TaxJurisdiction$Min$Record = function (name) {
	return {Bq: name};
};
var $author$project$Api$Provider$TaxJurisdiction$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$TaxJurisdiction$Min$Record));
var $author$project$Api$Provider$TaxJurisdiction$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$TaxJurisdiction$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$TaxLine$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'location',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Location$Min$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'practitioner',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Practitioner$Min$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'invoice',
			$elm$json$Json$Decode$nullable($author$project$Api$Common$Payable$Invoice$MinWithOwner$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'tax_jurisdiction',
				$elm$json$Json$Decode$nullable($author$project$Api$Provider$TaxJurisdiction$Min$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'service_date',
					$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'rate',
						$elm$json$Json$Decode$float,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'amount_in_cents',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'transaction_date',
								$author$project$Utils$Date$decode,
								$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$TaxLine$Record)))))))));
var $author$project$Api$Provider$Reports$TaxLine$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Reports$TaxLine$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$TaxLine$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Reports$TaxLine$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Reports$TaxLine$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$TaxLine$listPath)));
	});
var $author$project$Components$Reports$SalesTax$fetchTaxLines = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Api$Provider$Reports$TaxLine$list,
			apiClient,
			$author$project$Components$Reports$SalesTax$fetchTaxLinesParams(model),
			$author$project$Components$Reports$SalesTax$GotTaxLines);
	});
var $author$project$Components$Reports$SalesTax$fetchData = F2(
	function (apiClient, model) {
		var _v0 = model.amg;
		if (!_v0) {
			return A2($author$project$Components$Reports$SalesTax$fetchTaxLines, apiClient, model);
		} else {
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Components$Reports$SalesTax$fetchSummary, apiClient, model),
						A2($author$project$Components$Reports$SalesTax$fetchTaxLines, apiClient, model)
					]));
		}
	});
var $author$project$Components$Reports$SalesTax$initColumns = function (trackPatientsByLocation) {
	return $elm$core$List$concat(
		_List_fromArray(
			[
				_List_fromArray(
				[
					A3($author$project$Api$Column$init, 'transaction_date', true, 'Txn Date'),
					A3($author$project$Api$Column$init, 'amount_in_cents', true, 'Amount'),
					A3($author$project$Api$Column$init, 'rate', true, 'Rate'),
					A3($author$project$Api$Column$init, 'charge', true, 'Service Date'),
					A3($author$project$Api$Column$init, 'tax_jurisdiction', true, 'Jurisdiction'),
					A3($author$project$Api$Column$init, 'invoice', false, 'Invoice'),
					A3($author$project$Api$Column$init, 'practitioner', true, 'Provider')
				]),
				trackPatientsByLocation ? _List_fromArray(
				[
					A3($author$project$Api$Column$init, 'location', true, 'Location')
				]) : _List_Nil
			]));
};
var $author$project$Components$Reports$SalesTax$urlParams = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Tuple$pair('start'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.dd, 0)),
			model.JV),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Tuple$pair('end'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.dd, 0)),
			model.HB),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('tax_jurisdiction'),
			model.hT),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('location_group'),
			model.gL),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('location'),
			model.We),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('practitioner'),
			model.Z2),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('by'),
			model.co)
		]);
	return $elm$core$Dict$fromList(
		A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams));
};
var $author$project$Components$Reports$SalesTax$updateUrl = function (model) {
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					function () {
					var _v0 = model.co;
					if (!_v0.$) {
						return $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__SalesTax__Summary);
					} else {
						return $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__SalesTax);
					}
				}()
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.ajJ),
				A2(
					$elm$core$List$append,
					$author$project$Api$Sort$toQuery(model.alA),
					$author$project$Utils$QueryParameter$fromDict(
						$author$project$Components$Reports$SalesTax$urlParams(model))))));
};
var $author$project$Components$Reports$SalesTax$init = F5(
	function (type_, session, practice, _v0, query) {
		var currentDate = _v0.dd;
		var apiClient = _v0.Gv;
		var hinterViewOff = _v0.ahK;
		var trackPatientsByLocation = $author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice);
		var practitionerId = A2($elm$core$Dict$get, 'practitioner', query);
		var locationId = A2($elm$core$Dict$get, 'location', query);
		var locationGroupId = A2($elm$core$Dict$get, 'location_group', query);
		var _v1 = function () {
			if (!type_) {
				return _Utils_Tuple2($author$project$Api$Data$Loading, $author$project$Api$Data$NotAsked);
			} else {
				return _Utils_Tuple2($author$project$Api$Data$NotAsked, $author$project$Api$Data$Loading);
			}
		}();
		var taxLines = _v1.a;
		var summary = _v1.b;
		var _v3 = A7($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$init, apiClient, session, practice, false, locationGroupId, locationId, practitionerId);
		var groupLocationAndPractitionerFilters = _v3.a;
		var groupLocationAndPractitionerFiltersCmd = _v3.b;
		var _v4 = $author$project$Utils$DateWithDefault$fromQuery(query);
		var start = _v4.a;
		var end = _v4.b;
		var _v5 = A2(
			$author$project$Components$DateRangeInput$init,
			'date-range-input',
			A2(
				$author$project$Components$Reports$SalesTax$dateRangeInputSettings,
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					start),
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					end)));
		var dateRangeInput = _v5.a;
		var dateRangeInputCmd = _v5.b;
		var model = {
			co: A2($elm$core$Dict$get, 'by', query),
			mB: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'by-dropdown', al6: $author$project$Components$Reports$SalesTax$ByDropdownMsg})),
			GQ: A3($author$project$Permission$canGoTo, session, hinterViewOff, 50),
			N3: $author$project$Components$Reports$SalesTax$initColumns(trackPatientsByLocation),
			dd: currentDate,
			i4: dateRangeInput,
			HB: end,
			nD: $author$project$Components$ExportCsv$initForPractice(8),
			dn: groupLocationAndPractitionerFilters,
			gL: locationGroupId,
			We: locationId,
			ajJ: $author$project$Api$Pagination$initFromQuery(query),
			Z2: practitionerId,
			alA: A3(
				$author$project$Api$Sort$withDefault,
				'transaction_date',
				1,
				$author$project$Api$Sort$initFromQuery(query)),
			JV: start,
			acF: summary,
			qt: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'tax-jurisdiction-dropdown', al6: $author$project$Components$Reports$SalesTax$TaxJurisdictionDropdownMsg})),
			hT: A2($elm$core$Dict$get, 'tax_jurisdiction', query),
			acW: $author$project$Api$Data$Loading,
			bN: taxLines,
			adt: trackPatientsByLocation,
			amg: type_
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Api$Provider$TaxJurisdiction$list, apiClient, $author$project$Components$Reports$SalesTax$GotTaxJurisdictions),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$SalesTax$DateRangeInputMsg, dateRangeInputCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$SalesTax$GroupLocationAndPractitionerFiltersMsg, groupLocationAndPractitionerFiltersCmd),
						A2($author$project$Components$Reports$SalesTax$fetchData, apiClient, model),
						$author$project$Components$Reports$SalesTax$updateUrl(model)
					])));
	});
var $author$project$Pages$Reports$SalesTax$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.DE;
		var _v1 = A5($author$project$Components$Reports$SalesTax$init, 0, session, practice, shared, query);
		var report = _v1.a;
		var reportTaxCmd = _v1.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, kV: report},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportTaxCmd));
	});
var $author$project$Pages$Reports$SalesTax$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$SalesTax$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Reports$SalesTax$ExportCsvMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Reports$SalesTax$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$SalesTax$DateRangeInputMsg,
				$author$project$Components$DateRangeInput$subscriptions(model.i4)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$SalesTax$ExportCsvMsg,
				$author$project$Components$ExportCsv$subscriptions(model.nD)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$SalesTax$GroupLocationAndPractitionerFiltersMsg,
				$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$subscriptions(model.dn)),
				$author$project$Ui$Dropdown$subscriptions(model.mB),
				$author$project$Ui$Dropdown$subscriptions(model.qt)
			]));
};
var $author$project$Pages$Reports$SalesTax$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Reports$SalesTax$subscriptions(model.kV));
};
var $author$project$Components$Reports$SalesTax$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{acW: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 3:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Ui$Dropdown$update, subMsg, model.qt);
				var taxJurisdictionDropdown = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qt: taxJurisdictionDropdown}),
					cmd,
					_List_Nil);
			case 4:
				var taxJurisdictionId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ajJ: $author$project$Api$Pagination$reset(model.ajJ),
						hT: taxJurisdictionId,
						bN: $author$project$Api$Data$Loading
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$SalesTax$fetchData, apiClient, newModel),
								$author$project$Components$Reports$SalesTax$updateUrl(newModel)
							])),
					_List_Nil);
			case 5:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Ui$Dropdown$update, subMsg, model.mB);
				var byDropdown = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{mB: byDropdown}),
					cmd,
					_List_Nil);
			case 6:
				var by = msg.a;
				var newModel = _Utils_update(
					model,
					{
						co: by,
						ajJ: $author$project$Api$Pagination$reset(model.ajJ),
						bN: $author$project$Api$Data$Loading
					});
				var cmds = function () {
					var _v3 = _Utils_Tuple2(model.amg, newModel.co);
					if (!_v3.a) {
						if (!_v3.b.$) {
							var _v4 = _v3.a;
							return _List_fromArray(
								[
									$author$project$Components$Reports$SalesTax$updateUrl(newModel)
								]);
						} else {
							var _v5 = _v3.a;
							var _v6 = _v3.b;
							return _List_fromArray(
								[$elm$core$Platform$Cmd$none]);
						}
					} else {
						if (_v3.b.$ === 1) {
							var _v7 = _v3.a;
							var _v8 = _v3.b;
							return _List_fromArray(
								[
									$author$project$Components$Reports$SalesTax$updateUrl(newModel)
								]);
						} else {
							var _v9 = _v3.a;
							return _List_fromArray(
								[
									A2($author$project$Components$Reports$SalesTax$fetchData, apiClient, newModel),
									$author$project$Components$Reports$SalesTax$updateUrl(newModel)
								]);
						}
					}
				}();
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(cmds),
					_List_Nil);
			case 1:
				var subMsg = msg.a;
				var _v10 = A2($author$project$Components$DateRangeInput$update, subMsg, model.i4);
				var dateRangeInput = _v10.a;
				var subCmd = _v10.b;
				var event = _v10.c;
				var newModel = function () {
					if (event.$ === 1) {
						var fromDate = event.a;
						var toDate = event.b;
						return _Utils_update(
							model,
							{
								i4: dateRangeInput,
								HB: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
								ajJ: $author$project$Api$Pagination$reset(model.ajJ),
								JV: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate),
								bN: $author$project$Api$Data$Loading
							});
					} else {
						return _Utils_update(
							model,
							{i4: dateRangeInput});
					}
				}();
				var cmds = (_Utils_eq(newModel.JV, model.JV) && _Utils_eq(newModel.HB, model.HB)) ? _List_Nil : _List_fromArray(
					[
						A2($author$project$Components$Reports$SalesTax$fetchData, apiClient, newModel),
						$author$project$Components$Reports$SalesTax$updateUrl(newModel)
					]);
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$cons,
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$SalesTax$DateRangeInputMsg, subCmd),
							cmds)),
					_List_Nil);
			case 2:
				var subMsg = msg.a;
				var result = A3($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$update, apiClient, subMsg, model.dn);
				var _v12 = result.agZ;
				if (!_v12.$) {
					var locationGroupId = _v12.a;
					var locationId = _v12.b;
					var practitionerId = _v12.c;
					var newModel = _Utils_update(
						model,
						{
							dn: result.aiO,
							gL: locationGroupId,
							We: locationId,
							ajJ: $author$project$Api$Pagination$reset(model.ajJ),
							Z2: practitionerId,
							bN: $author$project$Api$Data$Loading
						});
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$SalesTax$GroupLocationAndPractitionerFiltersMsg, result.GZ),
									A2($author$project$Components$Reports$SalesTax$fetchData, apiClient, newModel),
									$author$project$Components$Reports$SalesTax$updateUrl(newModel)
								])),
						result.aR);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dn: result.aiO}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$SalesTax$GroupLocationAndPractitionerFiltersMsg, result.GZ),
						result.aR);
				}
			case 7:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ),
								bN: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bN: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 8:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{acF: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 9:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{ajJ: pagination, bN: $author$project$Api$Data$Loading});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$SalesTax$fetchData, apiClient, newModel),
								$author$project$Components$Reports$SalesTax$updateUrl(newModel)
							])),
					_List_Nil);
			case 10:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						alA: A2($author$project$Api$Sort$update, columnId, model.alA)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$SalesTax$fetchData, apiClient, newModel),
								$author$project$Components$Reports$SalesTax$updateUrl(newModel)
							])),
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v14 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.nD);
				var exportCsv = _v14.a;
				var subCmd = _v14.b;
				var subOutMsg = _v14.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nD: exportCsv}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$SalesTax$ExportCsvMsg, subCmd),
					subOutMsg);
		}
	});
var $author$project$Pages$Reports$SalesTax$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Reports$SalesTax$update, model.Gv, subMsg, model.kV);
		var report = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{kV: report}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Components$Reports$SalesTax$PaginationMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Reports$SalesTax$amountFromHeader = F2(
	function (headers, name) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$String$toInt,
				A2($elm$core$Dict$get, name, headers)));
	});
var $author$project$Components$Reports$SalesTax$BySelected = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Reports$SalesTax$byDropdownItems = F2(
	function (trackPatientsByLocation, currentBy) {
		return A2(
			$elm$core$List$cons,
			A2(
				$author$project$Ui$Dropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$Dropdown$onSelect(
						$author$project$Components$Reports$SalesTax$BySelected($elm$core$Maybe$Nothing)),
						$author$project$Ui$Dropdown$selected(
						_Utils_eq(currentBy, $elm$core$Maybe$Nothing))
					]),
				$elm$html$Html$text('No Summary')),
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Dropdown$separator,
				A2(
					$elm$core$List$cons,
					A2(
						$author$project$Ui$Dropdown$item,
						_List_fromArray(
							[
								$author$project$Ui$Dropdown$onSelect(
								$author$project$Components$Reports$SalesTax$BySelected(
									$elm$core$Maybe$Just('tax_jurisdiction'))),
								$author$project$Ui$Dropdown$selected(
								_Utils_eq(
									currentBy,
									$elm$core$Maybe$Just('tax_jurisdiction')))
							]),
						$elm$html$Html$text('Tax Jurisdiction')),
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$Ui$Dropdown$item,
							_List_fromArray(
								[
									$author$project$Ui$Dropdown$onSelect(
									$author$project$Components$Reports$SalesTax$BySelected(
										$elm$core$Maybe$Just('practitioner'))),
									$author$project$Ui$Dropdown$selected(
									_Utils_eq(
										currentBy,
										$elm$core$Maybe$Just('practitioner')))
								]),
							$elm$html$Html$text('Provider')),
						trackPatientsByLocation ? _List_fromArray(
							[
								A2(
								$author$project$Ui$Dropdown$item,
								_List_fromArray(
									[
										$author$project$Ui$Dropdown$onSelect(
										$author$project$Components$Reports$SalesTax$BySelected(
											$elm$core$Maybe$Just('location'))),
										$author$project$Ui$Dropdown$selected(
										_Utils_eq(
											currentBy,
											$elm$core$Maybe$Just('location')))
									]),
								$elm$html$Html$text('Location'))
							]) : _List_Nil))));
	});
var $author$project$Components$Reports$SalesTax$byToDisplayName = function (by) {
	switch (by) {
		case 'tax_jurisdiction':
			return 'Tax Jurisdiction';
		case 'practitioner':
			return 'Provider';
		case 'location':
			return 'Location';
		default:
			return by;
	}
};
var $author$project$Components$Reports$SalesTax$viewByDropdown = function (model) {
	var placeholder = function () {
		var _v0 = model.co;
		if (!_v0.$) {
			var by = _v0.a;
			return $author$project$Components$Reports$SalesTax$byToDisplayName(by);
		} else {
			return 'Summarize by';
		}
	}();
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(placeholder)
			]),
		A2($author$project$Components$Reports$SalesTax$byDropdownItems, model.adt, model.co),
		model.mB);
};
var $author$project$Components$Reports$SalesTax$viewSummaryRow = F2(
	function (model, summaryRow) {
		var routeParams = _List_fromArray(
			[
				$author$project$Ui$Link$routeParams(
				A2(
					$author$project$Utils$Report$summaryRowTableParams,
					$author$project$Components$Reports$SalesTax$urlParams(model),
					summaryRow))
			]);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_fromArray(
								[
									$author$project$Ui$Typography$info,
									$author$project$Ui$Typography$phi(true)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Reports__SalesTax,
									routeParams,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'None',
												$author$project$Api$Provider$Reports$Summary$summaryRowName(summaryRow)))
										]))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Reports__SalesTax,
							routeParams,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$String$pluralize,
										'tax line',
										$author$project$Api$Provider$Reports$Summary$summaryRowCount(summaryRow)))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$textRight]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Reports__SalesTax,
									routeParams,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Utils$Currency$fromInt(
												$author$project$Api$Provider$Reports$Summary$summaryRowAmountInCents(summaryRow)))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Reports$SalesTax$viewSummaryTable = function (model) {
	var summaryType = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Api$Provider$Reports$Summary$summaryType, $author$project$Formatters$String$humanize),
			$author$project$Api$Data$toMaybe(model.acF)));
	var summaryRows = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$Reports$Summary$summaryRows,
			$author$project$Api$Data$toMaybe(model.acF)));
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$loading(
				!$author$project$Api$Data$isSuccess(model.acF)),
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mb4]),
						_List_fromArray(
							[
								$elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
							]))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(summaryType)
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Number of Tax Lines')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4),
						$author$project$Ui$Table$textRight
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Amount')
					]))
			]),
		A2(
			$elm$core$List$map,
			$author$project$Components$Reports$SalesTax$viewSummaryRow(model),
			summaryRows),
		_List_Nil);
};
var $author$project$Components$Reports$SalesTax$SortTable = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Provider$Reports$TaxLine$amountInCents = function (_v0) {
	var record = _v0;
	return record.LE;
};
var $author$project$Api$Provider$Reports$TaxLine$invoice = function (_v0) {
	var record = _v0;
	return record.Uk;
};
var $author$project$Api$Provider$Reports$TaxLine$location = function (_v0) {
	var record = _v0;
	return record.ais;
};
var $author$project$Api$Provider$TaxJurisdiction$Min$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$Reports$TaxLine$practitioner = function (_v0) {
	var record = _v0;
	return record.aka;
};
var $author$project$Api$Provider$Reports$TaxLine$rate = function (_v0) {
	var record = _v0;
	return record._1;
};
var $author$project$Api$Provider$Reports$TaxLine$serviceDate = function (_v0) {
	var record = _v0;
	return record.aa$;
};
var $author$project$Api$Provider$Reports$TaxLine$taxJurisdiction = function (_v0) {
	var record = _v0;
	return record.u4;
};
var $author$project$Api$Provider$Reports$TaxLine$transactionDate = function (_v0) {
	var record = _v0;
	return record.adw;
};
var $author$project$Components$Reports$SalesTax$viewRow = F3(
	function (canGoToPatients, trackPatientsByLocation, taxLine) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$Date$toString,
										$author$project$Formatters$Date$Full,
										$author$project$Api$Provider$Reports$TaxLine$transactionDate(taxLine)))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$Reports$TaxLine$amountInCents(taxLine)))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromFloat(
										$author$project$Api$Provider$Reports$TaxLine$rate(taxLine)) + '%')
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
											$author$project$Api$Provider$Reports$TaxLine$serviceDate(taxLine))))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											$author$project$Api$Provider$TaxJurisdiction$Min$name,
											$author$project$Api$Provider$Reports$TaxLine$taxJurisdiction(taxLine))))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							function () {
								var _v0 = $author$project$Api$Provider$Reports$TaxLine$invoice(taxLine);
								if (!_v0.$) {
									var invoice = _v0.a;
									var _v1 = _Utils_Tuple2(
										canGoToPatients,
										$author$project$Api$Common$Payable$Invoice$MinWithOwner$owner(invoice));
									if (_v1.a && (!_v1.b.$)) {
										var owner = _v1.b.a;
										return _List_fromArray(
											[
												A3(
												$author$project$Ui$Link$route,
												$author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top(
													{
														Us: $author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice),
														YZ: $author$project$Api$Common$Payable$Owner$Min$id(owner)
													}),
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														'#' + $elm$core$String$fromInt(
															$author$project$Api$Common$Payable$Invoice$MinWithOwner$invoiceNumber(invoice)))
													]))
											]);
									} else {
										return _List_fromArray(
											[
												$elm$html$Html$text(
												'#' + $elm$core$String$fromInt(
													$author$project$Api$Common$Payable$Invoice$MinWithOwner$invoiceNumber(invoice)))
											]);
									}
								} else {
									return _List_Nil;
								}
							}()),
							A2(
							$author$project$Ui$Table$cell,
							_List_fromArray(
								[
									$author$project$Ui$Table$colspan(
									trackPatientsByLocation ? 1 : 2)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											$author$project$Api$Provider$Practitioner$Min$name,
											$author$project$Api$Provider$Reports$TaxLine$practitioner(taxLine))))
								]))
						]),
						trackPatientsByLocation ? _List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$String$ellipsis,
										20,
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Maybe$map,
												$author$project$Api$Provider$Location$Min$name,
												$author$project$Api$Provider$Reports$TaxLine$location(taxLine)))))
								]))
						]) : _List_Nil
					])));
	});
var $author$project$Components$Reports$SalesTax$viewTable = function (model) {
	var _v0 = function () {
		var _v1 = model.bN;
		if (_v1.$ === 3) {
			var taxLines_ = _v1.a;
			return _Utils_Tuple2(false, taxLines_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var taxLines = _v0.b;
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$map,
					$author$project$Api$Column$view(
						A2($author$project$Api$Column$Sortable, model.alA, $author$project$Components$Reports$SalesTax$SortTable)),
					model.N3),
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[$author$project$Ui$Table$textRight]),
						_List_fromArray(
							[
								A2($elm$html$Html$map, $author$project$Components$Reports$SalesTax$ExportCsvMsg, $author$project$Components$ExportCsv$button)
							]))
					])
				])),
		A2(
			$elm$core$List$map,
			A2($author$project$Components$Reports$SalesTax$viewRow, model.GQ, model.adt),
			taxLines),
		_List_Nil);
};
var $author$project$Components$Reports$SalesTax$TaxJurisdictionSelected = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Reports$SalesTax$taxJurisdictionDropdownItems = F2(
	function (taxJurisdictions, currentTaxJurisdictionId) {
		return A2(
			$elm$core$List$cons,
			A2(
				$author$project$Ui$Dropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$Dropdown$onSelect(
						$author$project$Components$Reports$SalesTax$TaxJurisdictionSelected($elm$core$Maybe$Nothing)),
						$author$project$Ui$Dropdown$selected(
						_Utils_eq(currentTaxJurisdictionId, $elm$core$Maybe$Nothing))
					]),
				$elm$html$Html$text('All Tax Jurisdictions')),
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Dropdown$separator,
				A2(
					$elm$core$List$map,
					function (taxJurisdiction) {
						var jurisdictionId = $author$project$Api$Provider$TaxJurisdiction$All$id(taxJurisdiction);
						return A2(
							$author$project$Ui$Dropdown$item,
							_List_fromArray(
								[
									$author$project$Ui$Dropdown$onSelect(
									$author$project$Components$Reports$SalesTax$TaxJurisdictionSelected(
										$elm$core$Maybe$Just(jurisdictionId))),
									$author$project$Ui$Dropdown$selected(
									_Utils_eq(
										currentTaxJurisdictionId,
										$elm$core$Maybe$Just(jurisdictionId)))
								]),
							$elm$html$Html$text(
								$author$project$Api$Provider$TaxJurisdiction$All$name(taxJurisdiction)));
					},
					taxJurisdictions)));
	});
var $author$project$Components$Reports$SalesTax$viewTaxJurisrictionDropdown = function (model) {
	var placeholder = function () {
		var _v1 = model.hT;
		if (!_v1.$) {
			var taxJurisdictionId = _v1.a;
			var _v2 = model.acW;
			if (_v2.$ === 3) {
				var taxJurisdictions = _v2.a;
				return A2(
					$elm$core$Maybe$withDefault,
					taxJurisdictionId,
					A2(
						$elm$core$Maybe$map,
						$author$project$Api$Provider$TaxJurisdiction$All$name,
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (jurisdiction) {
									return _Utils_eq(
										$author$project$Api$Provider$TaxJurisdiction$All$id(jurisdiction),
										taxJurisdictionId);
								},
								taxJurisdictions))));
			} else {
				return taxJurisdictionId;
			}
		} else {
			return 'Tax Jurisdiction';
		}
	}();
	var items = function () {
		var _v0 = model.acW;
		if (_v0.$ === 3) {
			var taxJurisdictions = _v0.a;
			return A2($author$project$Components$Reports$SalesTax$taxJurisdictionDropdownItems, taxJurisdictions, model.hT);
		} else {
			return _List_Nil;
		}
	}();
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(placeholder)
			]),
		items,
		model.qt);
};
var $author$project$Components$Reports$SalesTax$view = F2(
	function (apiClient, model) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Reports$SalesTax$ExportCsvMsg,
				A3(
					$author$project$Components$ExportCsv$modal,
					apiClient,
					_List_fromArray(
						[
							$author$project$Components$ExportCsv$report(
							$author$project$Api$Data$totalCount(model.bN)),
							$author$project$Components$ExportCsv$reportParams(
							A2($elm$core$Basics$composeL, $author$project$Api$Provider$Reports$TaxLine$listOptionsToParams, $author$project$Components$Reports$SalesTax$fetchTaxLinesParams)(model))
						]),
					model.nD)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Sales Tax')
									])),
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								function () {
									var _v0 = model.bN;
									if (_v0.$ === 3) {
										var headers = _v0.b;
										return _List_fromArray(
											[
												$elm$html$Html$text(
												'Total: ' + $author$project$Utils$Currency$fromInt(
													A2($author$project$Components$Reports$SalesTax$amountFromHeader, headers, 'x-total-amount')))
											]);
									} else {
										return _List_fromArray(
											[
												$author$project$Ui$Skeleton$text(
												_List_fromArray(
													[
														$author$project$Ui$Skeleton$spanFromText('Total: $1000.00')
													]))
											]);
									}
								}()),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpBlock]),
								_List_fromArray(
									[
										$elm$html$Html$text('Total sales tax liabilities for all invoices (excluding \"draft\" or \"cancelled\" invoices). The only way to reverse these liabilities is to '),
										A3(
										$author$project$Ui$Link$externalHref,
										'https://support.hint.com/invoices/creating-and-issuing-invoices',
										_List_fromArray(
											[$author$project$Ui$Link$targetBlank]),
										_List_fromArray(
											[
												$elm$html$Html$text('void the invoice.')
											])),
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(' Learn more about this report ')
											])),
										A3(
										$author$project$Ui$Link$externalHref,
										'https://support.hint.com/reports-and-deposits/sales-tax-reporting',
										_List_fromArray(
											[$author$project$Ui$Link$targetBlank]),
										_List_fromArray(
											[
												$elm$html$Html$text('here')
											]))
									])),
								A2(
								$elm$html$Html$map,
								$author$project$Components$Reports$SalesTax$DateRangeInputMsg,
								$author$project$Components$DateRangeInput$view(model.i4)),
								A2(
								$author$project$Ui$Grid$row,
								_List_fromArray(
									[$author$project$Ui$Grid$gutterSm]),
								_Utils_ap(
									A2(
										$elm$core$List$map,
										A2(
											$elm$core$Basics$composeR,
											$elm$core$List$singleton,
											$author$project$Ui$Grid$column(
												_List_fromArray(
													[
														$author$project$Ui$Grid$span(6),
														$author$project$Ui$Grid$spanMd(4)
													]))),
										A2(
											$elm$core$List$map,
											$elm$html$Html$map($author$project$Components$Reports$SalesTax$GroupLocationAndPractitionerFiltersMsg),
											A2(
												$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$view,
												_List_fromArray(
													[$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$multi]),
												model.dn))),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$span(6),
													$author$project$Ui$Grid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$SalesTax$viewTaxJurisrictionDropdown(model)
												])),
											A2(
											$author$project$Ui$Grid$column,
											_List_fromArray(
												[
													$author$project$Ui$Grid$span(6),
													$author$project$Ui$Grid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$SalesTax$viewByDropdown(model)
												]))
										]))),
								A2(
								$author$project$Ui$Grid$row,
								_List_fromArray(
									[$author$project$Ui$Grid$gutterSm]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_Nil,
										function () {
											var activeFilters = A2(
												$elm$core$List$map,
												$elm$html$Html$map($author$project$Components$Reports$SalesTax$GroupLocationAndPractitionerFiltersMsg),
												$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewMultiSelected(model.dn));
											return $elm$core$List$isEmpty(activeFilters) ? _List_Nil : _List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$mt2, $author$project$Ui$Element$mb2]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$strong,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Active filters')
																]))
														])),
													A2($elm$html$Html$span, _List_Nil, activeFilters)
												]);
										}())
									]))
							])),
						function () {
						var _v1 = model.amg;
						if (!_v1) {
							return $author$project$Components$Reports$SalesTax$viewTable(model);
						} else {
							return $author$project$Components$Reports$SalesTax$viewSummaryTable(model);
						}
					}(),
						function () {
						var _v2 = model.amg;
						if (!_v2) {
							return A2(
								$author$project$Ui$Panel$footer,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Components$Reports$SalesTax$PaginationMsg,
										A2(
											$author$project$Api$Pagination$view,
											_List_fromArray(
												[
													$author$project$Ui$Pagination$List$loading(
													!$author$project$Utils$Maybe$toBool(
														$author$project$Api$Data$toMaybe(model.bN)))
												]),
											model.ajJ))
									]));
						} else {
							return $author$project$Ui$Panel$none;
						}
					}()
					]))
			]);
	});
var $author$project$Pages$Reports$SalesTax$view = function (model) {
	return {
		fO: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			A2($author$project$Components$Reports$SalesTax$view, model.Gv, model.kV)),
		ac9: 'Reports | Sales Tax'
	};
};
var $author$project$Pages$Reports$SalesTax$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Reports$SalesTax$init, aiq: $author$project$Pages$Reports$SalesTax$load, k8: $author$project$Pages$Reports$SalesTax$save, alO: $author$project$Pages$Reports$SalesTax$subscriptions, adT: $author$project$Pages$Reports$SalesTax$update, amo: $author$project$Pages$Reports$SalesTax$view});
var $author$project$Pages$Reports$SalesTax$Summary$ReportMsg = $elm$core$Basics$identity;
var $author$project$Components$Reports$SalesTax$Summary = 1;
var $author$project$Pages$Reports$SalesTax$Summary$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.DE;
		var _v1 = A5($author$project$Components$Reports$SalesTax$init, 1, session, practice, shared, query);
		var report = _v1.a;
		var reportCmd = _v1.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, kV: report},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportCmd));
	});
var $author$project$Pages$Reports$SalesTax$Summary$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$SalesTax$Summary$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Reports$SalesTax$Summary$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Reports$SalesTax$subscriptions(model.kV));
};
var $author$project$Pages$Reports$SalesTax$Summary$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Reports$SalesTax$update, model.Gv, subMsg, model.kV);
		var report = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{kV: report}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Pages$Reports$SalesTax$Summary$view = function (model) {
	return {
		fO: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			A2($author$project$Components$Reports$SalesTax$view, model.Gv, model.kV)),
		ac9: 'Reports | Sales Tax'
	};
};
var $author$project$Pages$Reports$SalesTax$Summary$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Reports$SalesTax$Summary$init, aiq: $author$project$Pages$Reports$SalesTax$Summary$load, k8: $author$project$Pages$Reports$SalesTax$Summary$save, alO: $author$project$Pages$Reports$SalesTax$Summary$subscriptions, adT: $author$project$Pages$Reports$SalesTax$Summary$update, amo: $author$project$Pages$Reports$SalesTax$Summary$view});
var $author$project$Pages$Reports$SignupAttempts$ReportMsg = $elm$core$Basics$identity;
var $author$project$Components$Reports$SignupAttempts$DateRangeInputMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Reports$SignupAttempts$GotSignupPages = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Reports$SignupAttempts$LeadSourceResourceFilterMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Report$SignupAttempt = 1;
var $author$project$Components$Reports$SignupAttempts$SignupPageDropdownMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Reports$SignupAttempts$StatusDropdownMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Reports$SignupAttempts$buildUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('start'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.dd, 0)),
			model.JV),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('end'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.dd, 0)),
			model.HB),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('lead_source'),
			model.VS),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('signup_page'),
			model.qe),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('status'),
			model.alH)
		]);
	return A2(
		$elm$url$Url$Builder$relative,
		_List_fromArray(
			[
				$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__SignupAttempts)
			]),
		A2(
			$elm$core$List$append,
			$author$project$Api$Pagination$toPageQuery(model.ajJ),
			A2(
				$elm$core$List$append,
				$author$project$Api$Sort$toQuery(model.alA),
				A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams))));
};
var $author$project$Components$Reports$SignupAttempts$dateRangeInputSettings = F2(
	function (start, end) {
		var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
		return _Utils_update(
			defaultSettings,
			{ahy: start, al5: end});
	});
var $author$project$Components$Reports$SignupAttempts$GotSignupAttempts = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Reports$SignupAttempts$fetchParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				HB: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.HB),
				VR: model.VS,
				ajJ: model.ajJ,
				JM: model.qe,
				alA: model.alA,
				JV: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.dd, 0),
					model.JV),
				alH: model.alH
			});
	};
};
var $author$project$Api$Provider$Reports$SignupAttempt$SignupAttempt = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$SignupAttempt$Record = function (createdAt) {
	return function (status) {
		return function (firstName) {
			return function (lastName) {
				return function (email) {
					return function (zip) {
						return function (phoneNumber) {
							return function (followUpInfo) {
								return function (leadSourceOther) {
									return function (signupPage) {
										return function (leadSource) {
											return function (broker) {
												return function (patient) {
													return {xF: broker, O1: createdAt, Rj: email, Sv: firstName, SC: followUpInfo, VH: lastName, VR: leadSource, VT: leadSourceOther, YY: patient, Zx: phoneNumber, JM: signupPage, alH: status, vv: zip};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$LeadSource$Min$LeadSource = $elm$core$Basics$identity;
var $author$project$Api$Provider$LeadSource$Min$Record = function (name) {
	return {Bq: name};
};
var $author$project$Api$Provider$LeadSource$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$LeadSource$Min$Record));
var $author$project$Api$Provider$LeadSource$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$LeadSource$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$SignupAttempt$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'patient',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Min$decoder),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'broker',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Broker$Min$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'lead_source',
			$elm$json$Json$Decode$nullable($author$project$Api$Provider$LeadSource$Min$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'signup_page',
				$elm$json$Json$Decode$nullable($author$project$Api$Provider$SignupPage$Min$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'lead_source_other',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'follow_up_info',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'phone_number',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'zip',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'email',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'last_name',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'first_name',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'status',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'created_at',
													$elm_community$json_extra$Json$Decode$Extra$datetime,
													$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$SignupAttempt$Record))))))))))))));
var $author$project$Api$Provider$Reports$SignupAttempt$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Reports$SignupAttempt$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$SignupAttempt$reportDefaults = {HB: $elm$core$Maybe$Nothing, VR: $elm$core$Maybe$Nothing, ajJ: $author$project$Api$Pagination$init, JM: $elm$core$Maybe$Nothing, alA: $author$project$Api$Sort$init, JV: $elm$core$Maybe$Nothing, alH: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$Reports$SignupAttempt$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Reports$SignupAttempt$reportDefaults);
	return A2(
		$elm$core$List$append,
		$author$project$Api$Pagination$toApiParams(options.ajJ),
		A2(
			$elm$core$List$append,
			$author$project$Api$Sort$toParams(options.alA),
			$elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						var _v0 = options.JV;
						if (!_v0.$) {
							var start_ = _v0.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'start', start_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v1 = options.HB;
						if (!_v1.$) {
							var end_ = _v1.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'end', end_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v2 = options.JM;
						if (!_v2.$) {
							var signupPage_ = _v2.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'signup_page', signupPage_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v3 = options.VR;
						if (!_v3.$) {
							var leadSource_ = _v3.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'lead_source', leadSource_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v4 = options.alH;
						if (!_v4.$) {
							var status_ = _v4.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'status', status_)
								]);
						} else {
							return _List_Nil;
						}
					}()
					]))));
};
var $author$project$Api$Provider$Reports$SignupAttempt$listPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['reports', 'signup_attempts']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Reports$SignupAttempt$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Reports$SignupAttempt$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Reports$SignupAttempt$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$SignupAttempt$listPath)));
	});
var $author$project$Components$Reports$SignupAttempts$fetchSignupAttempts = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Api$Provider$Reports$SignupAttempt$list,
			apiClient,
			$author$project$Components$Reports$SignupAttempts$fetchParams(model),
			$author$project$Components$Reports$SignupAttempts$GotSignupAttempts);
	});
var $author$project$Components$Reports$SignupAttempts$initColumns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'created_at', true, 'Started on'),
		A3($author$project$Api$Column$init, 'signup_page', true, 'Signup Page'),
		A3($author$project$Api$Column$init, 'lead_source', true, 'Lead Source'),
		A3($author$project$Api$Column$init, 'first_name', true, 'First Name'),
		A3($author$project$Api$Column$init, 'last_name', true, 'Last Name'),
		A3($author$project$Api$Column$init, 'email', true, 'Email'),
		A3($author$project$Api$Column$init, 'zip', true, 'Zip'),
		A3($author$project$Api$Column$init, 'phone_number', true, 'Phone Number'),
		A3($author$project$Api$Column$init, 'status', false, 'Status')
	]);
var $author$project$Components$Reports$SignupAttempts$init = F2(
	function (_v0, query) {
		var currentDate = _v0.dd;
		var timeFormatter = _v0.J7;
		var apiClient = _v0.Gv;
		var leadSourceId = A2($elm$core$Dict$get, 'lead_source', query);
		var _v1 = A3(
			$author$project$Components$ResourceFilter$LeadSource$init,
			apiClient,
			$elm$core$Basics$identity,
			function (d) {
				return _Utils_update(
					d,
					{Gp: 'All Lead Sources', XY: 'Unassigned', ai5: true, akb: leadSourceId});
			});
		var leadSourceResourceFilter = _v1.a;
		var leadSourceResourceFilterCmd = _v1.b;
		var _v2 = $author$project$Utils$DateWithDefault$fromQuery(query);
		var start = _v2.a;
		var end = _v2.b;
		var _v3 = A2(
			$author$project$Components$DateRangeInput$init,
			'date-range-input',
			A2(
				$author$project$Components$Reports$SignupAttempts$dateRangeInputSettings,
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					start),
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					end)));
		var dateRangeInput = _v3.a;
		var dateRangeInputCmd = _v3.b;
		var model = {
			N3: $author$project$Components$Reports$SignupAttempts$initColumns,
			G$: $elm$core$Maybe$Nothing,
			dd: currentDate,
			i4: dateRangeInput,
			HB: end,
			nD: $author$project$Components$ExportCsv$initForPractice(1),
			VS: leadSourceId,
			oi: leadSourceResourceFilter,
			ajJ: $author$project$Api$Pagination$initFromQuery(query),
			fh: $elm$core$Set$empty,
			bk: $author$project$Api$Data$Loading,
			qd: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'signup-page-dropdown', al6: $author$project$Components$Reports$SignupAttempts$SignupPageDropdownMsg})),
			qe: A2($elm$core$Dict$get, 'signup_page', query),
			uJ: $author$project$Api$Data$Loading,
			alA: A3(
				$author$project$Api$Sort$withDefault,
				'created_at',
				1,
				$author$project$Api$Sort$initFromQuery(query)),
			JV: start,
			alH: A2($elm$core$Dict$get, 'status', query),
			qn: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'status-dropdown', al6: $author$project$Components$Reports$SignupAttempts$StatusDropdownMsg})),
			J7: timeFormatter
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$SignupAttempts$LeadSourceResourceFilterMsg, leadSourceResourceFilterCmd),
						A3(
						$author$project$Api$Provider$SignupPage$list,
						apiClient,
						function (d) {
							return _Utils_update(
								d,
								{ajJ: $elm$core$Maybe$Nothing});
						},
						$author$project$Components$Reports$SignupAttempts$GotSignupPages),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$SignupAttempts$DateRangeInputMsg, dateRangeInputCmd),
						A2($author$project$Components$Reports$SignupAttempts$fetchSignupAttempts, apiClient, model),
						A2($elm$core$Basics$composeR, $author$project$Components$Reports$SignupAttempts$buildUrl, $author$project$Ports$Navigation$replaceUrl)(model)
					])));
	});
var $author$project$Pages$Reports$SignupAttempts$init = F4(
	function (_v0, _v1, shared, _v2) {
		var query = _v2.DE;
		var _v3 = A2($author$project$Components$Reports$SignupAttempts$init, shared, query);
		var report = _v3.a;
		var reportCmd = _v3.b;
		return _Utils_Tuple2(
			{Gv: shared.Gv, kV: report},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportCmd));
	});
var $author$project$Pages$Reports$SignupAttempts$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$SignupAttempts$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Reports$SignupAttempts$ExportCsvMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Reports$SignupAttempts$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$SignupAttempts$DateRangeInputMsg,
				$author$project$Components$DateRangeInput$subscriptions(model.i4)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$SignupAttempts$ExportCsvMsg,
				$author$project$Components$ExportCsv$subscriptions(model.nD)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$SignupAttempts$LeadSourceResourceFilterMsg,
				$author$project$Components$ResourceFilter$LeadSource$subscriptions(model.oi)),
				$author$project$Ui$Dropdown$subscriptions(model.qd),
				$author$project$Ui$Dropdown$subscriptions(model.qn)
			]));
};
var $author$project$Pages$Reports$SignupAttempts$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Reports$SignupAttempts$subscriptions(model.kV));
};
var $author$project$Components$Reports$SignupAttempts$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var leadSourceResourceResult = A3($author$project$Components$ResourceFilter$LeadSource$update, apiClient, subMsg, model.oi);
				var leadSourceId = function () {
					var _v2 = leadSourceResourceResult.agZ;
					if (!_v2.$) {
						return $author$project$Components$ResourceFilter$LeadSource$value(leadSourceResourceResult.aiO);
					} else {
						return model.VS;
					}
				}();
				var newModel = _Utils_update(
					model,
					{VS: leadSourceId, oi: leadSourceResourceResult.aiO});
				var _v1 = _Utils_eq(model.VS, newModel.VS) ? _Utils_Tuple2(model.bk, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					$author$project$Api$Data$Loading,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$SignupAttempts$fetchSignupAttempts, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$SignupAttempts$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])));
				var signupAttempts = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{bk: signupAttempts}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$SignupAttempts$LeadSourceResourceFilterMsg, leadSourceResourceResult.GZ),
								cmd
							])),
					leadSourceResourceResult.aR);
			case 1:
				var dataSignupPages = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{uJ: dataSignupPages}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(dataSignupPages));
			case 2:
				var subMsg = msg.a;
				var _v3 = A2($author$project$Ui$Dropdown$update, subMsg, model.qd);
				var signupPageDropdown = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qd: signupPageDropdown}),
					cmd,
					_List_Nil);
			case 4:
				var subMsg = msg.a;
				var _v4 = A2($author$project$Ui$Dropdown$update, subMsg, model.qn);
				var statusDropdown = _v4.a;
				var cmd = _v4.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qn: statusDropdown}),
					cmd,
					_List_Nil);
			case 3:
				var signupPageId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ajJ: $author$project$Api$Pagination$reset(model.ajJ),
						bk: $author$project$Api$Data$Loading,
						qe: signupPageId
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$SignupAttempts$fetchSignupAttempts, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$SignupAttempts$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 5:
				var status = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ajJ: $author$project$Api$Pagination$reset(model.ajJ),
						bk: $author$project$Api$Data$Loading,
						alH: status
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$SignupAttempts$fetchSignupAttempts, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$SignupAttempts$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 6:
				var subMsg = msg.a;
				var _v5 = A2($author$project$Components$DateRangeInput$update, subMsg, model.i4);
				var dateRangeInput = _v5.a;
				var subCmd = _v5.b;
				var event = _v5.c;
				var newModel = function () {
					if (event.$ === 1) {
						var fromDate = event.a;
						var toDate = event.b;
						return _Utils_update(
							model,
							{
								i4: dateRangeInput,
								HB: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
								ajJ: $author$project$Api$Pagination$reset(model.ajJ),
								bk: $author$project$Api$Data$Loading,
								JV: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
							});
					} else {
						return _Utils_update(
							model,
							{i4: dateRangeInput});
					}
				}();
				var cmds = (_Utils_eq(newModel.JV, model.JV) && _Utils_eq(newModel.HB, model.HB)) ? _List_Nil : _List_fromArray(
					[
						A2($author$project$Components$Reports$SignupAttempts$fetchSignupAttempts, apiClient, newModel),
						A2($elm$core$Basics$composeR, $author$project$Components$Reports$SignupAttempts$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
					]);
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$cons,
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$SignupAttempts$DateRangeInputMsg, subCmd),
							cmds)),
					_List_Nil);
			case 7:
				var dataSignupAttempts = msg.a;
				if (dataSignupAttempts.$ === 3) {
					var headers = dataSignupAttempts.b;
					var completedCount = A2(
						$elm$core$Maybe$andThen,
						$elm$core$String$toInt,
						A2($elm$core$Dict$get, 'x-completed-count', headers));
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								G$: completedCount,
								ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ),
								fh: $elm$core$Set$empty,
								bk: dataSignupAttempts
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{fh: $elm$core$Set$empty, bk: dataSignupAttempts}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(dataSignupAttempts));
				}
			case 8:
				var index = msg.a;
				var showMoreInfoFor = A2($elm$core$Set$member, index, model.fh) ? A2($elm$core$Set$remove, index, model.fh) : A2($elm$core$Set$insert, index, model.fh);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{fh: showMoreInfoFor}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 9:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{ajJ: pagination, bk: $author$project$Api$Data$Loading});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$SignupAttempts$fetchSignupAttempts, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$SignupAttempts$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 10:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						alA: A2($author$project$Api$Sort$update, columnId, model.alA)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$SignupAttempts$fetchSignupAttempts, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$SignupAttempts$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v8 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.nD);
				var exportCsv = _v8.a;
				var subCmd = _v8.b;
				var subOutMsg = _v8.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nD: exportCsv}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$SignupAttempts$ExportCsvMsg, subCmd),
					subOutMsg);
		}
	});
var $author$project$Pages$Reports$SignupAttempts$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Reports$SignupAttempts$update, model.Gv, subMsg, model.kV);
		var report = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{kV: report}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Components$Reports$SignupAttempts$PaginationMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Reports$SignupAttempts$countFromHeader = F2(
	function (headers, name) {
		return A2(
			$elm$core$Maybe$withDefault,
			'N/A',
			A2($elm$core$Dict$get, name, headers));
	});
var $author$project$Components$ResourceFilter$LeadSource$viewMultiSelected = function (model) {
	return A2(
		$elm$core$List$map,
		$elm$html$Html$map($elm$core$Basics$identity),
		A2($author$project$Components$ResourceFilter$viewMultiSelected, model.Jy, model.b8));
};
var $author$project$Components$Reports$SignupAttempts$SignupPageSelected = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Reports$SignupAttempts$signupPageDropdownItems = function (signupPages) {
	return $elm$core$List$concat(
		_List_fromArray(
			[
				_List_fromArray(
				[
					A2(
					$author$project$Ui$Dropdown$item,
					_List_fromArray(
						[
							$author$project$Ui$Dropdown$onSelect(
							$author$project$Components$Reports$SignupAttempts$SignupPageSelected($elm$core$Maybe$Nothing))
						]),
					$elm$html$Html$text('All Signup Pages')),
					$author$project$Ui$Dropdown$separator
				]),
				A2(
				$elm$core$List$map,
				function (signupPage) {
					return A2(
						$author$project$Ui$Dropdown$item,
						_List_fromArray(
							[
								$author$project$Ui$Dropdown$onSelect(
								$author$project$Components$Reports$SignupAttempts$SignupPageSelected(
									$elm$core$Maybe$Just(
										$author$project$Api$Provider$SignupPage$All$id(signupPage))))
							]),
						$elm$html$Html$text(
							$author$project$Api$Provider$SignupPage$All$slug(signupPage)));
				},
				signupPages)
			]));
};
var $author$project$Components$Reports$SignupAttempts$viewSignupPageDropdown = function (model) {
	var placeholder = function () {
		var _v2 = model.qe;
		if (!_v2.$) {
			var id = _v2.a;
			return A2(
				$elm$core$Maybe$withDefault,
				'Signup Page',
				A2(
					$elm$core$Maybe$map,
					$author$project$Api$Provider$SignupPage$All$slug,
					A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$filter(
								function (sp) {
									return _Utils_eq(
										$author$project$Api$Provider$SignupPage$All$id(sp),
										id);
								}),
							$elm$core$List$head),
						$author$project$Api$Data$toMaybe(model.uJ))));
		} else {
			return 'Signup Page';
		}
	}();
	var _v0 = function () {
		var _v1 = model.uJ;
		if (_v1.$ === 3) {
			var signupPages = _v1.a;
			return _Utils_Tuple2(
				false,
				$author$project$Components$Reports$SignupAttempts$signupPageDropdownItems(signupPages));
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var items = _v0.b;
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_fromArray(
			[
				$author$project$Ui$Dropdown$disabled(loading)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(placeholder)
			]),
		items,
		model.qd);
};
var $author$project$Components$Reports$SignupAttempts$StatusSelected = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Reports$SignupAttempts$statusDropdownItems = _List_fromArray(
	[
		A2(
		$author$project$Ui$Dropdown$item,
		_List_fromArray(
			[
				$author$project$Ui$Dropdown$onSelect(
				$author$project$Components$Reports$SignupAttempts$StatusSelected($elm$core$Maybe$Nothing))
			]),
		$elm$html$Html$text('All Statuses')),
		$author$project$Ui$Dropdown$separator,
		A2(
		$author$project$Ui$Dropdown$item,
		_List_fromArray(
			[
				$author$project$Ui$Dropdown$onSelect(
				$author$project$Components$Reports$SignupAttempts$StatusSelected(
					$elm$core$Maybe$Just('abandoned')))
			]),
		$elm$html$Html$text('Abandoned')),
		A2(
		$author$project$Ui$Dropdown$item,
		_List_fromArray(
			[
				$author$project$Ui$Dropdown$onSelect(
				$author$project$Components$Reports$SignupAttempts$StatusSelected(
					$elm$core$Maybe$Just('completed')))
			]),
		$elm$html$Html$text('Completed')),
		A2(
		$author$project$Ui$Dropdown$item,
		_List_fromArray(
			[
				$author$project$Ui$Dropdown$onSelect(
				$author$project$Components$Reports$SignupAttempts$StatusSelected(
					$elm$core$Maybe$Just('pending')))
			]),
		$elm$html$Html$text('Pending')),
		A2(
		$author$project$Ui$Dropdown$item,
		_List_fromArray(
			[
				$author$project$Ui$Dropdown$onSelect(
				$author$project$Components$Reports$SignupAttempts$StatusSelected(
					$elm$core$Maybe$Just('ineligible')))
			]),
		$elm$html$Html$text('Ineligible'))
	]);
var $author$project$Components$Reports$SignupAttempts$statusToDisplayName = function (status) {
	switch (status) {
		case 'abandoned':
			return 'Abandoned';
		case 'completed':
			return 'Completed';
		case 'pending':
			return 'Pending';
		case 'ineligible':
			return 'Ineligible';
		default:
			return status;
	}
};
var $author$project$Components$Reports$SignupAttempts$viewStatusDropdown = function (model) {
	var placeholder = function () {
		var _v0 = model.alH;
		if (!_v0.$) {
			var status = _v0.a;
			return $author$project$Components$Reports$SignupAttempts$statusToDisplayName(status);
		} else {
			return 'Status';
		}
	}();
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(placeholder)
			]),
		$author$project$Components$Reports$SignupAttempts$statusDropdownItems,
		model.qn);
};
var $author$project$Components$Reports$SignupAttempts$SortTable = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Reports$SignupAttempts$ShowMoreInfo = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$Reports$SignupAttempt$broker = function (_v0) {
	var record = _v0;
	return record.xF;
};
var $author$project$Api$Provider$Reports$SignupAttempt$createdAt = function (_v0) {
	var record = _v0;
	return record.O1;
};
var $author$project$Api$Provider$Reports$SignupAttempt$email = function (_v0) {
	var record = _v0;
	return record.Rj;
};
var $author$project$Api$Provider$Reports$SignupAttempt$firstName = function (_v0) {
	var record = _v0;
	return record.Sv;
};
var $author$project$Api$Provider$Reports$SignupAttempt$followUpInfo = function (_v0) {
	var record = _v0;
	return record.SC;
};
var $author$project$Api$Provider$Reports$SignupAttempt$lastName = function (_v0) {
	var record = _v0;
	return record.VH;
};
var $author$project$Api$Provider$Reports$SignupAttempt$leadSource = function (_v0) {
	var record = _v0;
	return record.VR;
};
var $author$project$Api$Provider$LeadSource$Min$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Components$Reports$SignupAttempts$leadSourceIsOther = function (maybeLeadSource) {
	if (!maybeLeadSource.$) {
		var leadSource = maybeLeadSource.a;
		return $author$project$Api$Provider$LeadSource$Min$name(leadSource) === 'Other';
	} else {
		return false;
	}
};
var $author$project$Api$Provider$Reports$SignupAttempt$leadSourceOther = function (_v0) {
	var record = _v0;
	return record.VT;
};
var $author$project$Components$Reports$SignupAttempts$moreInfoAvailable = function (signupAttempt) {
	var _v0 = _Utils_Tuple2(
		$author$project$Api$Provider$Reports$SignupAttempt$broker(signupAttempt),
		$author$project$Api$Provider$Reports$SignupAttempt$followUpInfo(signupAttempt));
	if (!_v0.a.$) {
		if (!_v0.b.$) {
			return true;
		} else {
			var _v1 = _v0.b;
			return true;
		}
	} else {
		if (!_v0.b.$) {
			var _v2 = _v0.a;
			return true;
		} else {
			return false;
		}
	}
};
var $author$project$Api$Provider$Reports$SignupAttempt$phoneNumber = function (_v0) {
	var record = _v0;
	return record.Zx;
};
var $author$project$Api$Provider$Reports$SignupAttempt$signupPage = function (_v0) {
	var record = _v0;
	return record.JM;
};
var $author$project$Api$Provider$SignupPage$Min$slug = function (_v0) {
	var record = _v0;
	return record.abG;
};
var $author$project$Api$Provider$Reports$SignupAttempt$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Api$Provider$Reports$SignupAttempt$patientId = function (_v0) {
	var record = _v0;
	return A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Min$id, record.YY);
};
var $author$project$Components$Reports$SignupAttempts$viewPatientName = F2(
	function (signupAttempt, maybeName) {
		var nameText = A2($elm$core$Maybe$withDefault, '', maybeName);
		if ($elm$core$String$trim(nameText) !== '') {
			var _v0 = $author$project$Api$Provider$Reports$SignupAttempt$patientId(signupAttempt);
			if (!_v0.$) {
				var pid = _v0.a;
				return A3(
					$author$project$Ui$Link$route,
					$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
						{YZ: pid}),
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[
									$author$project$Ui$Typography$phi(true)
								]),
							nameText)
						]));
			} else {
				return A2(
					$author$project$Ui$Typography$text,
					_List_fromArray(
						[
							$author$project$Ui$Typography$phi(true)
						]),
					nameText);
			}
		} else {
			return A2(
				$author$project$Ui$Typography$text,
				_List_fromArray(
					[
						$author$project$Ui$Typography$phi(true)
					]),
				nameText);
		}
	});
var $author$project$Api$Provider$Reports$SignupAttempt$zip = function (_v0) {
	var record = _v0;
	return record.vv;
};
var $author$project$Components$Reports$SignupAttempts$viewRow = F4(
	function (timeFormatter, showMoreInfoFor, index, signupAttempt) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								timeFormatter,
								0,
								$author$project$Api$Provider$Reports$SignupAttempt$createdAt(signupAttempt)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									$author$project$Api$Provider$SignupPage$Min$slug,
									$author$project$Api$Provider$Reports$SignupAttempt$signupPage(signupAttempt))))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					$elm$core$List$concat(
						_List_fromArray(
							[
								_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											$author$project$Api$Provider$LeadSource$Min$name,
											$author$project$Api$Provider$Reports$SignupAttempt$leadSource(signupAttempt)))),
									$author$project$Utils$Html$noBreakSpace
								]),
								$author$project$Components$Reports$SignupAttempts$leadSourceIsOther(
								$author$project$Api$Provider$Reports$SignupAttempt$leadSource(signupAttempt)) ? _List_fromArray(
								[
									A3(
									$author$project$Ui$Tooltip$view,
									_List_Nil,
									A2(
										$elm$core$Maybe$withDefault,
										'',
										$author$project$Api$Provider$Reports$SignupAttempt$leadSourceOther(signupAttempt)),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$span,
											_List_fromArray(
												[$author$project$Ui$Typography$small]),
											_List_fromArray(
												[
													$author$project$Ui$Icon$help(_List_Nil)
												]))
										]))
								]) : _List_Nil
							]))),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Components$Reports$SignupAttempts$viewPatientName,
							signupAttempt,
							$author$project$Api$Provider$Reports$SignupAttempt$firstName(signupAttempt))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Components$Reports$SignupAttempts$viewPatientName,
							signupAttempt,
							$author$project$Api$Provider$Reports$SignupAttempt$lastName(signupAttempt))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[
									$author$project$Ui$Typography$phi(true)
								]),
							A2(
								$elm$core$Maybe$withDefault,
								'',
								$author$project$Api$Provider$Reports$SignupAttempt$email(signupAttempt)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[
									$author$project$Ui$Typography$phi(true)
								]),
							A2(
								$elm$core$Maybe$withDefault,
								'',
								$author$project$Api$Provider$Reports$SignupAttempt$zip(signupAttempt)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[
									$author$project$Ui$Typography$phi(true)
								]),
							$author$project$Formatters$Phone$format(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									$author$project$Api$Provider$Reports$SignupAttempt$phoneNumber(signupAttempt))))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					$elm$core$List$concat(
						_List_fromArray(
							[
								_List_fromArray(
								[
									A2(
									$author$project$Ui$Badge$fromString,
									_List_Nil,
									$author$project$Api$Provider$Reports$SignupAttempt$status(signupAttempt))
								]),
								$author$project$Components$Reports$SignupAttempts$moreInfoAvailable(signupAttempt) ? _List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'display', 'grid')
										]),
									$elm$core$List$concat(
										_List_fromArray(
											[
												_List_fromArray(
												[
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('small clickable'),
															A2($elm$html$Html$Attributes$style, 'margin', '4px 0 3px 0;]'),
															$elm$html$Html$Events$onClick(
															$author$project$Components$Reports$SignupAttempts$ShowMoreInfo(index))
														]),
													A2($elm$core$Set$member, index, showMoreInfoFor) ? _List_fromArray(
														[
															A2(
															$elm$html$Html$span,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Less info'),
																	$author$project$Utils$Html$noBreakSpace,
																	$author$project$Ui$Icon$chevron(
																	_List_fromArray(
																		[$author$project$Ui$Icon$rotate180]))
																]))
														]) : _List_fromArray(
														[
															A2(
															$elm$html$Html$span,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('More info'),
																	$author$project$Utils$Html$noBreakSpace,
																	$author$project$Ui$Icon$chevronDown(
																	_List_fromArray(
																		[$author$project$Ui$Icon$rotate270]))
																]))
														]))
												]),
												A2($elm$core$Set$member, index, showMoreInfoFor) ? $elm$core$List$concat(
												_List_fromArray(
													[
														function () {
														var _v0 = $author$project$Api$Provider$Reports$SignupAttempt$broker(signupAttempt);
														if (!_v0.$) {
															var broker = _v0.a;
															return _List_fromArray(
																[
																	A2(
																	$author$project$Ui$Typography$text,
																	_List_fromArray(
																		[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
																	'Broker: ' + $author$project$Api$Provider$Broker$Min$name(broker))
																]);
														} else {
															return _List_Nil;
														}
													}(),
														function () {
														var _v1 = $author$project$Api$Provider$Reports$SignupAttempt$followUpInfo(signupAttempt);
														if (!_v1.$) {
															var followUpInfo = _v1.a;
															return _List_fromArray(
																[
																	A2(
																	$author$project$Ui$Typography$text,
																	_List_fromArray(
																		[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
																	'Followup: ' + followUpInfo)
																]);
														} else {
															return _List_Nil;
														}
													}()
													])) : _List_Nil
											])))
								]) : _List_Nil
							]))),
					A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil)
				]));
	});
var $author$project$Components$Reports$SignupAttempts$viewTable = function (model) {
	var _v0 = function () {
		var _v1 = model.bk;
		if (_v1.$ === 3) {
			var signupAttempts_ = _v1.a;
			return _Utils_Tuple2(false, signupAttempts_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var signupAttempts = _v0.b;
	return A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$map,
					$author$project$Api$Column$view(
						A2($author$project$Api$Column$Sortable, model.alA, $author$project$Components$Reports$SignupAttempts$SortTable)),
					model.N3),
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[$author$project$Ui$Table$textRight]),
						_List_fromArray(
							[
								A2($elm$html$Html$map, $author$project$Components$Reports$SignupAttempts$ExportCsvMsg, $author$project$Components$ExportCsv$button)
							]))
					])
				])),
		A2(
			$elm$core$List$indexedMap,
			A2($author$project$Components$Reports$SignupAttempts$viewRow, model.J7, model.fh),
			signupAttempts),
		_List_Nil);
};
var $author$project$Components$Reports$SignupAttempts$view = F2(
	function (apiClient, model) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Reports$SignupAttempts$ExportCsvMsg,
				A3(
					$author$project$Components$ExportCsv$modal,
					apiClient,
					_List_fromArray(
						[
							$author$project$Components$ExportCsv$report(
							$author$project$Api$Data$totalCount(model.bk)),
							$author$project$Components$ExportCsv$reportParams(
							A2($elm$core$Basics$composeL, $author$project$Api$Provider$Reports$SignupAttempt$listOptionsToParams, $author$project$Components$Reports$SignupAttempts$fetchParams)(model))
						]),
					model.nD)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Signup Attempts')
									])),
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								function () {
									var _v0 = model.bk;
									if (_v0.$ === 3) {
										var headers = _v0.b;
										return _List_fromArray(
											[
												$elm$html$Html$text(
												'Total completed: ' + A2($author$project$Components$Reports$SignupAttempts$countFromHeader, headers, 'x-completed-count')),
												$author$project$Utils$Html$noBreakSpace,
												A2(
												$elm$html$Html$small,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('text-muted')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														'out of ' + (A2($author$project$Components$Reports$SignupAttempts$countFromHeader, headers, 'x-total-count') + ' total'))
													]))
											]);
									} else {
										return _List_fromArray(
											[
												$author$project$Ui$Spinner$view(_List_Nil)
											]);
									}
								}()),
								A2(
								$elm$html$Html$map,
								$author$project$Components$Reports$SignupAttempts$DateRangeInputMsg,
								$author$project$Components$DateRangeInput$view(model.i4)),
								A2(
								$author$project$Ui$Grid$row,
								_List_fromArray(
									[$author$project$Ui$Grid$gutterSm]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(6),
												$author$project$Ui$Grid$spanMd(4)
											]),
										_List_fromArray(
											[
												$author$project$Components$Reports$SignupAttempts$viewSignupPageDropdown(model)
											])),
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(6),
												$author$project$Ui$Grid$spanMd(4)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Components$Reports$SignupAttempts$LeadSourceResourceFilterMsg,
												A2(
													$author$project$Components$ResourceFilter$LeadSource$view,
													_List_fromArray(
														[
															$author$project$Components$ResourceFilter$style(1),
															$author$project$Components$ResourceFilter$multi
														]),
													model.oi))
											])),
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$span(6),
												$author$project$Ui$Grid$spanMd(4)
											]),
										_List_fromArray(
											[
												$author$project$Components$Reports$SignupAttempts$viewStatusDropdown(model)
											]))
									])),
								A2(
								$author$project$Ui$Grid$row,
								_List_fromArray(
									[$author$project$Ui$Grid$gutterSm]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_Nil,
										function () {
											var activeFilters = A2(
												$elm$core$List$map,
												$elm$html$Html$map($author$project$Components$Reports$SignupAttempts$LeadSourceResourceFilterMsg),
												$author$project$Components$ResourceFilter$LeadSource$viewMultiSelected(model.oi));
											return $elm$core$List$isEmpty(activeFilters) ? _List_Nil : _List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$mt2, $author$project$Ui$Element$mb2]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$strong,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Active filters')
																]))
														])),
													A2($elm$html$Html$span, _List_Nil, activeFilters)
												]);
										}())
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Components$Reports$SignupAttempts$viewTable(model)
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$Reports$SignupAttempts$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(
											!$author$project$Utils$Maybe$toBool(
												$author$project$Api$Data$toMaybe(model.bk)))
										]),
									model.ajJ))
							]))
					]))
			]);
	});
var $author$project$Pages$Reports$SignupAttempts$view = function (model) {
	return {
		fO: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			A2($author$project$Components$Reports$SignupAttempts$view, model.Gv, model.kV)),
		ac9: 'Reports | Signup Attempts'
	};
};
var $author$project$Pages$Reports$SignupAttempts$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$Reports$SignupAttempts$init, aiq: $author$project$Pages$Reports$SignupAttempts$load, k8: $author$project$Pages$Reports$SignupAttempts$save, alO: $author$project$Pages$Reports$SignupAttempts$subscriptions, adT: $author$project$Pages$Reports$SignupAttempts$update, amo: $author$project$Pages$Reports$SignupAttempts$view});
var $author$project$Ui$Spinner$Attr = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Spinner$attrs = $author$project$Ui$Spinner$Attr;
var $author$project$Pages$StyleGuide$ActivityIndicators$viewBody = _List_fromArray(
	[
		A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('extraSmall'),
						$author$project$Ui$Spinner$view(
						_List_fromArray(
							[$author$project$Ui$Spinner$extraSmall]))
					])),
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('small'),
						$author$project$Ui$Spinner$view(
						_List_fromArray(
							[
								$author$project$Ui$Spinner$small,
								$author$project$Ui$Spinner$attrs(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('some-class')
									]))
							]))
					])),
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('medium'),
						$author$project$Ui$Spinner$view(
						_List_fromArray(
							[
								$author$project$Ui$Spinner$attrs(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mr-8')
									]))
							]))
					])),
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('large'),
						$author$project$Ui$Spinner$view(
						_List_fromArray(
							[
								$author$project$Ui$Spinner$large,
								$author$project$Ui$Spinner$attrs(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mr-8')
									]))
							]))
					]))
			]))
	]);
var $author$project$Pages$StyleGuide$ActivityIndicators$view = function (_v0) {
	return {fO: $author$project$Pages$StyleGuide$ActivityIndicators$viewBody, ac9: 'Style Guide'};
};
var $author$project$Pages$StyleGuide$ActivityIndicators$page = $author$project$Spa$Page$static($author$project$Pages$StyleGuide$ActivityIndicators$view);
var $author$project$Pages$StyleGuide$AddressInput$AddressInputMsg = $elm$core$Basics$identity;
var $author$project$Pages$StyleGuide$AddressInput$init = function (_v0) {
	var _v1 = $author$project$Components$AddressInput$init('address-input');
	var addressInput = _v1.a;
	var addressInputCmd = _v1.b;
	return _Utils_Tuple2(
		{mb: addressInput},
		A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, addressInputCmd));
};
var $author$project$Pages$StyleGuide$AddressInput$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$StyleGuide$AddressInput$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A2($author$project$Components$AddressInput$update, subMsg, model.mb);
		var addressInput = _v1.a;
		var addressInputCmd = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{mb: addressInput}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, addressInputCmd));
	});
var $author$project$Generated$StyleGuide$Examples$addressInputExample = '\n    [ AddressInput.view\n        []\n        model.addressInput\n        |> Html.map AddressInputMsg\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$addressInputExampleDisabled = '\n    [ AddressInput.view\n        [ AddressInput.disabled True ]\n        model.addressInput\n        |> Html.map AddressInputMsg\n    ]\n    ';
var $author$project$Pages$StyleGuide$AddressInput$example = function (model) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2($author$project$Components$AddressInput$view, _List_Nil, model.mb))
		]);
};
var $author$project$Components$AddressInput$Disabled = $elm$core$Basics$identity;
var $author$project$Components$AddressInput$disabled = $elm$core$Basics$identity;
var $author$project$Pages$StyleGuide$AddressInput$exampleDisabled = function (model) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$AddressInput$view,
				_List_fromArray(
					[
						$author$project$Components$AddressInput$disabled(true)
					]),
				model.mb))
		]);
};
var $author$project$Components$StyleGuide$Example$Title = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$StyleGuide$Example$title = $author$project$Components$StyleGuide$Example$Title;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$HCode = $elm$core$Basics$identity;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Style1 = 2;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Style2 = 3;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Style3 = 4;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Style4 = 5;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Style5 = 6;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Style6 = 7;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$syntaxToStyle = function (syntax) {
	switch (syntax) {
		case 0:
			return _Utils_Tuple2(3, 'elm-s');
		case 1:
			return _Utils_Tuple2(4, 'elm-bs');
		case 2:
			return _Utils_Tuple2(5, 'elm-gs');
		case 3:
			return _Utils_Tuple2(7, 'elm-c');
		case 4:
			return _Utils_Tuple2(4, 'elm-k');
		case 5:
			return _Utils_Tuple2(6, 'elm-f');
		case 6:
			return _Utils_Tuple2(5, 'elm-ts');
		default:
			return _Utils_Tuple2(2, 'elm-n');
	}
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$newLine = function (fragments) {
	return {ahv: fragments, nT: $elm$core$Maybe$Nothing};
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$LineBreak = {$: 2};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Comment = 1;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Default = 0;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toFragment = F2(
	function (toStyle, _v0) {
		var syntax = _v0.a;
		var text = _v0.b;
		switch (syntax.$) {
			case 0:
				return {aeI: '', akS: 0, ac3: text};
			case 1:
				return {aeI: '', akS: 1, ac3: text};
			case 2:
				return {aeI: '', akS: 0, ac3: text};
			default:
				var c = syntax.a;
				var _v2 = toStyle(c);
				var requiredStyle = _v2.a;
				var additionalClass = _v2.b;
				return {aeI: additionalClass, akS: requiredStyle, ac3: text};
		}
	});
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toLinesHelp = F3(
	function (toStyle, _v0, _v1) {
		var syntax = _v0.a;
		var text = _v0.b;
		var lines = _v1.a;
		var fragments = _v1.b;
		var maybeLastSyntax = _v1.c;
		if (_Utils_eq(syntax, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$LineBreak)) {
			return _Utils_Tuple3(
				A2(
					$elm$core$List$cons,
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$newLine(fragments),
					lines),
				_List_fromArray(
					[
						A2(
						$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toFragment,
						toStyle,
						_Utils_Tuple2(syntax, text))
					]),
				$elm$core$Maybe$Nothing);
		} else {
			if (_Utils_eq(
				$elm$core$Maybe$Just(syntax),
				maybeLastSyntax)) {
				if (fragments.b) {
					var headFrag = fragments.a;
					var tailFrags = fragments.b;
					return _Utils_Tuple3(
						lines,
						A2(
							$elm$core$List$cons,
							_Utils_update(
								headFrag,
								{
									ac3: _Utils_ap(text, headFrag.ac3)
								}),
							tailFrags),
						maybeLastSyntax);
				} else {
					return _Utils_Tuple3(
						lines,
						A2(
							$elm$core$List$cons,
							A2(
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toFragment,
								toStyle,
								_Utils_Tuple2(syntax, text)),
							fragments),
						maybeLastSyntax);
				}
			} else {
				return _Utils_Tuple3(
					lines,
					A2(
						$elm$core$List$cons,
						A2(
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toFragment,
							toStyle,
							_Utils_Tuple2(syntax, text)),
						fragments),
					$elm$core$Maybe$Just(syntax));
			}
		}
	});
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toLines = F2(
	function (toStyle, revTokens) {
		return function (_v0) {
			var lines = _v0.a;
			var frags = _v0.b;
			return A2(
				$elm$core$List$cons,
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$newLine(frags),
				lines);
		}(
			A3(
				$elm$core$List$foldl,
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toLinesHelp(toStyle),
				_Utils_Tuple3(_List_Nil, _List_Nil, $elm$core$Maybe$Nothing),
				revTokens));
	});
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Comment = {$: 1};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak = function (c) {
	return c === '\n';
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile = F2(
	function (isNotRelevant, previousParser) {
		return A2(
			$elm$parser$Parser$ignorer,
			previousParser,
			$elm$parser$Parser$chompWhile(isNotRelevant));
	});
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$inlineComment = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _List_fromArray(
			[
				_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Comment, b)
			]);
	},
	$elm$parser$Parser$getChompedString(
		A2(
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak),
			$elm$parser$Parser$symbol('--'))));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$addThen = F3(
	function (f, list, plist) {
		return A2(
			$elm$parser$Parser$andThen,
			function (n) {
				return f(
					_Utils_ap(n, list));
			},
			plist);
	});
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$consThen = F3(
	function (f, list, pn) {
		return A2(
			$elm$parser$Parser$andThen,
			function (n) {
				return f(
					A2($elm$core$List$cons, n, list));
			},
			pn);
	});
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedUnnestable = F2(
	function (options, revAList) {
		var defaultMap = options.P1;
		var isNotRelevant = options.U$;
		var end = options.HB;
		var innerParsers = options.T2;
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$map,
					$elm$core$Basics$always(
						A2(
							$elm$core$List$cons,
							defaultMap(end),
							revAList)),
					$elm$parser$Parser$symbol(end)),
					A2(
					$elm$parser$Parser$map,
					$elm$core$Basics$always(revAList),
					$elm$parser$Parser$end),
					A3(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$addThen,
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedUnnestable(options),
					revAList,
					$elm$parser$Parser$oneOf(innerParsers)),
					A3(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$consThen,
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedUnnestable(options),
					revAList,
					A2(
						$elm$parser$Parser$map,
						defaultMap,
						$elm$parser$Parser$getChompedString(
							A2(
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile,
								isNotRelevant,
								$elm$parser$Parser$chompIf(
									$elm$core$Basics$always(true))))))
				]));
	});
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedNestable = F3(
	function (nestLevel, options, revAList) {
		var defaultMap = options.P1;
		var isNotRelevant = options.U$;
		var start = options.JV;
		var end = options.HB;
		var innerParsers = options.T2;
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$andThen,
					function (n) {
						return (nestLevel === 1) ? $elm$parser$Parser$succeed(n) : A3($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedNestable, nestLevel - 1, options, n);
					},
					A2(
						$elm$parser$Parser$map,
						$elm$core$Basics$always(
							A2(
								$elm$core$List$cons,
								defaultMap(end),
								revAList)),
						$elm$parser$Parser$symbol(end))),
					A3(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$consThen,
					A2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedNestable, nestLevel + 1, options),
					revAList,
					A2(
						$elm$parser$Parser$map,
						defaultMap,
						$elm$parser$Parser$getChompedString(
							A2(
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile,
								isNotRelevant,
								$elm$parser$Parser$symbol(start))))),
					A3(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$addThen,
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedUnnestable(options),
					revAList,
					$elm$parser$Parser$oneOf(innerParsers)),
					A2(
					$elm$parser$Parser$map,
					$elm$core$Basics$always(revAList),
					$elm$parser$Parser$end),
					A3(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$consThen,
					A2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedNestable, nestLevel, options),
					revAList,
					A2(
						$elm$parser$Parser$map,
						defaultMap,
						$elm$parser$Parser$getChompedString(
							A2(
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile,
								isNotRelevant,
								$elm$parser$Parser$chompIf(
									$elm$core$Basics$always(true))))))
				]));
	});
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedHelp = F2(
	function (options, revAList) {
		var start = options.JV;
		var end = options.HB;
		var isNotRelevant = options.U$;
		var _v0 = _Utils_Tuple2(
			$elm$core$String$uncons(options.JV),
			$elm$core$String$uncons(options.HB));
		if (_v0.a.$ === 1) {
			var _v1 = _v0.a;
			return $elm$parser$Parser$problem('Trying to parse a delimited helper, but the start token cannot be an empty string!');
		} else {
			if (_v0.b.$ === 1) {
				var _v2 = _v0.b;
				return $elm$parser$Parser$problem('Trying to parse a delimited helper, but the end token cannot be an empty string!');
			} else {
				var _v3 = _v0.a.a;
				var startChar = _v3.a;
				var _v4 = _v0.b.a;
				var endChar = _v4.a;
				return options.UZ ? A3(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedNestable,
					1,
					_Utils_update(
						options,
						{
							U$: function (c) {
								return isNotRelevant(c) && ((!_Utils_eq(c, startChar)) && (!_Utils_eq(c, endChar)));
							}
						}),
					revAList) : A2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedUnnestable,
					_Utils_update(
						options,
						{
							U$: function (c) {
								return isNotRelevant(c) && (!_Utils_eq(c, endChar));
							}
						}),
					revAList);
			}
		}
	});
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited = function (options) {
	var start = options.JV;
	var isNotRelevant = options.U$;
	var defaultMap = options.P1;
	return A2(
		$elm$parser$Parser$andThen,
		function (n) {
			return A2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedHelp,
				options,
				_List_fromArray(
					[n]));
		},
		A2(
			$elm$parser$Parser$map,
			$elm$core$Basics$always(
				defaultMap(start)),
			$elm$parser$Parser$symbol(start)));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$lineBreakList = A2(
	$elm$parser$Parser$map,
	function (_v0) {
		return _List_fromArray(
			[
				_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$LineBreak, '\n')
			]);
	},
	$elm$parser$Parser$symbol('\n'));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$multilineComment = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited(
	{
		P1: function (b) {
			return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Comment, b);
		},
		HB: '-}',
		T2: _List_fromArray(
			[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$lineBreakList]),
		UZ: true,
		U$: function (c) {
			return !$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak(c);
		},
		JV: '{-'
	});
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$comment = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$inlineComment, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$multilineComment]));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$BasicSymbol = 1;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C = function (a) {
	return {$: 3, a: a};
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$Capitalized = 3;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$GroupSymbol = 2;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$Keyword = 4;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal = {$: 0};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$Number = 7;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile = function (isNotRelevant) {
	return A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed(0),
			$elm$parser$Parser$chompIf(isNotRelevant)),
		$elm$parser$Parser$chompWhile(isNotRelevant));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$basicSymbols = $elm$core$Set$fromList(
	_List_fromArray(
		['|', '.', '=', '\\', '/', '(', ')', '-', '>', '<', ':', '+', '!', '$', '%', '&', '*']));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isBasicSymbol = function (c) {
	return A2($elm$core$Set$member, c, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$basicSymbols);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$basicSymbol = $elm$parser$Parser$getChompedString(
	$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isBasicSymbol));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$groupSymbols = $elm$core$Set$fromList(
	_List_fromArray(
		[',', '[', ']', '{', '}']));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isGroupSymbol = function (c) {
	return A2($elm$core$Set$member, c, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$groupSymbols);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isStringLiteralChar = function (c) {
	return (c === '\"') || (c === '\'');
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isSpace = function (c) {
	return (c === ' ') || (c === '\t');
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isWhitespace = function (c) {
	return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isSpace(c) || $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak(c);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isVariableChar = function (c) {
	return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isWhitespace(c) || ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isBasicSymbol(c) || ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isGroupSymbol(c) || $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isStringLiteralChar(c))));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$capitalized = $elm$parser$Parser$getChompedString(
	A2(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile,
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isVariableChar,
		$elm$parser$Parser$chompIf($elm$core$Char$isUpper)));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$groupSymbol = $elm$parser$Parser$getChompedString(
	$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isGroupSymbol));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$Function = 5;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$infixSet = $elm$core$Set$fromList(
	_List_fromArray(
		['+', '-', '/', '*', '=', '.', '$', '<', '>', ':', '&', '|', '^', '?', '%', '#', '@', '~', '!', ',']));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isInfixChar = function (c) {
	return A2($elm$core$Set$member, c, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$infixSet);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$infixParser = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2(
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(5),
			b);
	},
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(0),
					$elm$parser$Parser$backtrackable(
						$elm$parser$Parser$symbol('('))),
				$elm$parser$Parser$backtrackable(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isInfixChar))),
			$elm$parser$Parser$backtrackable(
				$elm$parser$Parser$symbol(')')))));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$keywordSet = $elm$core$Set$fromList(
	_List_fromArray(
		['as', 'where', 'let', 'in', 'if', 'else', 'then', 'case', 'of', 'type', 'alias']));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isKeyword = function (str) {
	return A2($elm$core$Set$member, str, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$keywordSet);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isNumber = function (c) {
	return $elm$core$Char$isDigit(c) || (c === '.');
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$positiveNumber = A2(
	$elm$parser$Parser$ignorer,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed(0),
		$elm$parser$Parser$chompIf($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isNumber)),
	$elm$parser$Parser$chompWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isNumber));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$negativeNumber = A2(
	$elm$parser$Parser$ignorer,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed(0),
		$elm$parser$Parser$backtrackable(
			$elm$parser$Parser$symbol('-'))),
	$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$positiveNumber);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$number = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$positiveNumber, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$negativeNumber]));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$variable = $elm$parser$Parser$getChompedString(
	A2(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile,
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isVariableChar,
		$elm$parser$Parser$chompIf($elm$core$Char$isLower)));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$weirdText = $elm$parser$Parser$getChompedString(
	$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isVariableChar));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionBodyContent = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$map,
			function (b) {
				return _Utils_Tuple2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(7),
					b);
			},
			$elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$number)),
			A2(
			$elm$parser$Parser$map,
			$elm$core$Basics$always(
				_Utils_Tuple2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(3),
					'()')),
			$elm$parser$Parser$symbol('()')),
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$infixParser,
			A2(
			$elm$parser$Parser$map,
			function (b) {
				return _Utils_Tuple2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(1),
					b);
			},
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$basicSymbol),
			A2(
			$elm$parser$Parser$map,
			function (b) {
				return _Utils_Tuple2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(2),
					b);
			},
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$groupSymbol),
			A2(
			$elm$parser$Parser$map,
			function (b) {
				return _Utils_Tuple2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(3),
					b);
			},
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$capitalized),
			A2(
			$elm$parser$Parser$map,
			function (n) {
				return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isKeyword(n) ? _Utils_Tuple2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(4),
					n) : _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, n);
			},
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$variable),
			A2(
			$elm$parser$Parser$map,
			function (b) {
				return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
			},
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$weirdText)
		]));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$String = 0;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$escapableSet = $elm$core$Set$fromList(
	_List_fromArray(
		['\'', '\"', '\\', 'n', 'r', 't', 'b', 'f', 'v']));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isEscapableChar = function (c) {
	return A2($elm$core$Set$member, c, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$escapableSet);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$escapable = A2(
	$elm$parser$Parser$ignorer,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed(0),
		$elm$parser$Parser$backtrackable(
			$elm$parser$Parser$symbol('\\'))),
	$elm$parser$Parser$chompIf($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isEscapableChar));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$elmEscapable = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _List_fromArray(
			[
				_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(3),
				b)
			]);
	},
	$elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$escapable));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isEscapable = function (c) {
	return c === '\\';
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$stringDelimiter = {
	P1: function (b) {
		return _Utils_Tuple2(
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(0),
			b);
	},
	HB: '\"',
	T2: _List_fromArray(
		[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$lineBreakList, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$elmEscapable]),
	UZ: false,
	U$: function (c) {
		return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak(c) || $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isEscapable(c));
	},
	JV: '\"'
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$doubleQuote = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$stringDelimiter);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$quote = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited(
	_Utils_update(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$stringDelimiter,
		{HB: '\'', JV: '\''}));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$tripleDoubleQuote = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited(
	_Utils_update(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$stringDelimiter,
		{HB: '\"\"\"', JV: '\"\"\"'}));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$stringLiteral = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$tripleDoubleQuote, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$doubleQuote, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$quote]));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$lineBreak = A2(
	$elm$parser$Parser$map,
	function (_v0) {
		return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$LineBreak, '\n');
	},
	$elm$parser$Parser$symbol('\n'));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$space = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
	},
	$elm$parser$Parser$getChompedString(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isSpace)));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$checkContext = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$whitespaceOrCommentStep(revTokens),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$whitespaceOrCommentStep = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$space),
				A2(
				$elm$parser$Parser$andThen,
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$checkContext,
				A2(
					$elm$parser$Parser$map,
					function (n) {
						return A2($elm$core$List$cons, n, revTokens);
					},
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$lineBreak)),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$comment)
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionBody = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				function (ns) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(ns, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$stringLiteral),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionBodyContent),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$TypeSignature = 6;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$fnSigIsNotRelevant = function (c) {
	return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isWhitespace(c) || ((c === '(') || ((c === ')') || ((c === '-') || (c === ',')))));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$fnSigContentHelp = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$map,
			$elm$core$Basics$always(
				_Utils_Tuple2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(6),
					'()')),
			$elm$parser$Parser$symbol('()')),
			A2(
			$elm$parser$Parser$map,
			$elm$core$Basics$always(
				_Utils_Tuple2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(1),
					'->')),
			$elm$parser$Parser$symbol('->')),
			A2(
			$elm$parser$Parser$map,
			function (b) {
				return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
			},
			$elm$parser$Parser$getChompedString(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile(
					function (c) {
						return (c === '(') || ((c === ')') || ((c === '-') || (c === ',')));
					}))),
			A2(
			$elm$parser$Parser$map,
			function (b) {
				return _Utils_Tuple2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(6),
					b);
			},
			$elm$parser$Parser$getChompedString(
				A2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile,
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$fnSigIsNotRelevant,
					$elm$parser$Parser$chompIf($elm$core$Char$isUpper)))),
			A2(
			$elm$parser$Parser$map,
			function (b) {
				return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
			},
			$elm$parser$Parser$getChompedString(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$fnSigIsNotRelevant)))
		]));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$fnSigContent = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$fnSigContentHelp),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionSignature = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Done,
				A2(
					$elm$parser$Parser$andThen,
					function (ns) {
						return A2($elm$parser$Parser$loop, ns, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$fnSigContent);
					},
					A2(
						$elm$parser$Parser$map,
						$elm$core$Basics$always(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(1),
									':'),
								revTokens)),
						$elm$parser$Parser$symbol(':')))),
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Done,
				A2($elm$parser$Parser$loop, revTokens, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionBody)),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isCommentChar = function (c) {
	return (c === '-') || (c === '{');
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$commentChar = $elm$parser$Parser$getChompedString(
	$elm$parser$Parser$chompIf($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isCommentChar));
var $elm$parser$Parser$ExpectingKeyword = function (a) {
	return {$: 9, a: a};
};
var $elm$parser$Parser$Advanced$keyword = function (_v0) {
	var kwd = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(kwd);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, kwd, s.g, s.pL, s.NQ, s.uN);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return (_Utils_eq(newOffset, -1) || (0 <= A3(
			$elm$parser$Parser$Advanced$isSubChar,
			function (c) {
				return $elm$core$Char$isAlphaNum(c) || (c === '_');
			},
			newOffset,
			s.uN))) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{NQ: newCol, a3: s.a3, ahY: s.ahY, g: newOffset, pL: newRow, uN: s.uN});
	};
};
var $elm$parser$Parser$keyword = function (kwd) {
	return $elm$parser$Parser$Advanced$keyword(
		A2(
			$elm$parser$Parser$Advanced$Token,
			kwd,
			$elm$parser$Parser$ExpectingKeyword(kwd)));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$modDecIsNotRelevant = function (c) {
	return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isWhitespace(c) || ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isCommentChar(c) || (c === '(')));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$mdpIsNotRelevant = function (c) {
	return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isWhitespace(c) || ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isCommentChar(c) || ((c === '(') || ((c === ')') || ((c === ',') || (c === '.'))))));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$mdpnIsSpecialChar = function (c) {
	return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak(c) || ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isCommentChar(c) || ((c === '(') || (c === ')')));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$checkContextNested = function (_v1) {
	var nestLevel = _v1.a;
	var revTokens = _v1.b;
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$whitespaceOrCommentStepNested(
				_Utils_Tuple2(nestLevel, revTokens)),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$whitespaceOrCommentStepNested = function (_v0) {
	var nestLevel = _v0.a;
	var revTokens = _v0.b;
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						_Utils_Tuple2(
							nestLevel,
							A2($elm$core$List$cons, n, revTokens)));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$space),
				A2(
				$elm$parser$Parser$andThen,
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$checkContextNested,
				A2(
					$elm$parser$Parser$map,
					function (n) {
						return _Utils_Tuple2(
							nestLevel,
							A2($elm$core$List$cons, n, revTokens));
					},
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$lineBreak)),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						_Utils_Tuple2(
							nestLevel,
							_Utils_ap(n, revTokens)));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$comment)
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$modDecParNest = function (_v0) {
	var nestLevel = _v0.a;
	var revTokens = _v0.b;
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$whitespaceOrCommentStepNested(
				_Utils_Tuple2(nestLevel, revTokens)),
				A2(
				$elm$parser$Parser$map,
				function (ns) {
					return $elm$parser$Parser$Loop(
						_Utils_Tuple2(nestLevel + 1, ns));
				},
				A2(
					$elm$parser$Parser$map,
					$elm$core$Basics$always(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, '('),
							revTokens)),
					$elm$parser$Parser$symbol('('))),
				A2(
				$elm$parser$Parser$map,
				function (ns) {
					return (!nestLevel) ? $elm$parser$Parser$Done(ns) : $elm$parser$Parser$Loop(
						_Utils_Tuple2(nestLevel - 1, ns));
				},
				A2(
					$elm$parser$Parser$map,
					$elm$core$Basics$always(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, ')'),
							revTokens)),
					$elm$parser$Parser$symbol(')'))),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						_Utils_Tuple2(
							nestLevel,
							A2($elm$core$List$cons, n, revTokens)));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[
							A2(
							$elm$parser$Parser$map,
							function (b) {
								return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
							},
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$commentChar),
							A2(
							$elm$parser$Parser$map,
							function (s) {
								return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, s);
							},
							$elm$parser$Parser$getChompedString(
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile(
									A2($elm$core$Basics$composeL, $elm$core$Basics$not, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$mdpnIsSpecialChar))))
						]))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$modDecParentheses = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Done,
				A2(
					$elm$parser$Parser$map,
					$elm$core$Basics$always(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, ')'),
							revTokens)),
					$elm$parser$Parser$symbol(')'))),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, n, revTokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$infixParser,
							A2(
							$elm$parser$Parser$map,
							function (b) {
								return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
							},
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$commentChar),
							A2(
							$elm$parser$Parser$map,
							function (b) {
								return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
							},
							$elm$parser$Parser$getChompedString(
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile(
									function (c) {
										return (c === ',') || (c === '.');
									}))),
							A2(
							$elm$parser$Parser$map,
							function (b) {
								return _Utils_Tuple2(
									$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(6),
									b);
							},
							$elm$parser$Parser$getChompedString(
								A2(
									$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile,
									$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$mdpIsNotRelevant,
									$elm$parser$Parser$chompIf($elm$core$Char$isUpper)))),
							A2(
							$elm$parser$Parser$map,
							function (b) {
								return _Utils_Tuple2(
									$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(5),
									b);
							},
							$elm$parser$Parser$getChompedString(
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$mdpIsNotRelevant)))
						]))),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Loop,
				A2(
					$elm$parser$Parser$andThen,
					function (n) {
						return A2(
							$elm$parser$Parser$loop,
							_Utils_Tuple2(0, n),
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$modDecParNest);
					},
					A2(
						$elm$parser$Parser$map,
						$elm$core$Basics$always(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, '('),
								revTokens)),
						$elm$parser$Parser$symbol('(')))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$moduleDeclaration = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Loop,
				A2(
					$elm$parser$Parser$andThen,
					function (n) {
						return A2($elm$parser$Parser$loop, n, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$modDecParentheses);
					},
					A2(
						$elm$parser$Parser$map,
						$elm$core$Basics$always(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, '('),
								revTokens)),
						$elm$parser$Parser$symbol('(')))),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, n, revTokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[
							A2(
							$elm$parser$Parser$map,
							function (b) {
								return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
							},
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$commentChar),
							A2(
							$elm$parser$Parser$map,
							$elm$core$Basics$always(
								_Utils_Tuple2(
									$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(4),
									'exposing')),
							$elm$parser$Parser$keyword('exposing')),
							A2(
							$elm$parser$Parser$map,
							$elm$core$Basics$always(
								_Utils_Tuple2(
									$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(4),
									'as')),
							$elm$parser$Parser$keyword('as')),
							A2(
							$elm$parser$Parser$map,
							function (b) {
								return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
							},
							$elm$parser$Parser$getChompedString(
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$modDecIsNotRelevant)))
						]))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$portDeclarationHelp = F2(
	function (revTokens, str) {
		return (str === 'module') ? A2(
			$elm$parser$Parser$loop,
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(4),
					str),
				revTokens),
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$moduleDeclaration) : A2(
			$elm$parser$Parser$loop,
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(5),
					str),
				revTokens),
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionSignature);
	});
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$portDeclaration = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Done,
				A2(
					$elm$parser$Parser$andThen,
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$portDeclarationHelp(revTokens),
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$variable)),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Done,
				A2($elm$parser$Parser$loop, revTokens, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionBody)),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$lineStartVariable = F2(
	function (revTokens, n) {
		return ((n === 'module') || (n === 'import')) ? A2(
			$elm$parser$Parser$loop,
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(4),
					n),
				revTokens),
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$moduleDeclaration) : ((n === 'port') ? A2(
			$elm$parser$Parser$loop,
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(4),
					n),
				revTokens),
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$portDeclaration) : ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isKeyword(n) ? A2(
			$elm$parser$Parser$loop,
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(4),
					n),
				revTokens),
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionBody) : A2(
			$elm$parser$Parser$loop,
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(5),
					n),
				revTokens),
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionSignature)));
	});
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$mainLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$space),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$lineBreak),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$comment),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Loop,
				A2(
					$elm$parser$Parser$andThen,
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$lineStartVariable(revTokens),
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$variable)),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Loop,
				A2(
					$elm$parser$Parser$andThen,
					function (s) {
						return A2(
							$elm$parser$Parser$loop,
							_Utils_ap(s, revTokens),
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionBody);
					},
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$stringLiteral)),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Loop,
				A2(
					$elm$parser$Parser$andThen,
					function (s) {
						return A2(
							$elm$parser$Parser$loop,
							A2($elm$core$List$cons, s, revTokens),
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionBody);
					},
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionBodyContent)),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$toRevTokens = A2($elm$parser$Parser$loop, _List_Nil, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$mainLoop);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$toLines = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$toRevTokens),
	$elm$core$Result$map(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toLines($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$syntaxToStyle)));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$elm = A2(
	$elm$core$Basics$composeR,
	$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$toLines,
	$elm$core$Result$map($elm$core$Basics$identity));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme = $elm$core$Basics$identity;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$AtRule = function (a) {
	return {$: 1, a: a};
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$ClassExtends = 8;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$Css = function (a) {
	return {$: 3, a: a};
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$DeclarationKeyword = 3;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$Elm = function (a) {
	return {$: 0, a: a};
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex = function (a) {
	return {$: 1, a: a};
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$Identifier = 0;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$Javascript = function (a) {
	return {$: 2, a: a};
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$Property = {$: 3};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$bold = function (style) {
	return _Utils_update(
		style,
		{n5: true});
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$italic = function (style) {
	return _Utils_update(
		style,
		{n7: true});
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$DefaultColor = {$: 0};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$backgroundColor = function (background) {
	return {rr: background, n5: false, n7: false, sU: false, ac3: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$DefaultColor};
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$noEmphasis = F2(
	function (text, background) {
		return {rr: background, n5: false, n7: false, sU: false, ac3: text};
	});
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$textColor = function (text) {
	return {rr: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$DefaultColor, n5: false, n7: false, sU: false, ac3: text};
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Monokai$requiredStyles = {
	ra: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$backgroundColor(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#003800')),
	N4: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$textColor(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#75715e')),
	PW: A2(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$noEmphasis,
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#f8f8f2'),
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#23241f')),
	r0: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$backgroundColor(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#380000')),
	nT: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$backgroundColor(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#343434')),
	uR: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$textColor(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#ae81ff')),
	uS: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$textColor(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#e6db74')),
	uT: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$textColor(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#f92672')),
	uU: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$textColor(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#66d9ef')),
	uV: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$textColor(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#a6e22e')),
	uW: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$textColor(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#ae81ff')),
	uX: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$textColor(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#fd971f'))
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Monokai$theme = {
	af4: _List_fromArray(
		[
			_Utils_Tuple2(
			_List_fromArray(
				[
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$Elm(6),
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$Javascript(3),
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$Css($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$Property)
				]),
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$italic(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$textColor(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#66d9ef')))),
			_Utils_Tuple2(
			_List_fromArray(
				[
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$Javascript(8)
				]),
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$italic(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$textColor(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#a6e22e')))),
			_Utils_Tuple2(
			_List_fromArray(
				[
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$Css(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$AtRule(0))
				]),
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$bold(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$textColor(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#f92672'))))
		]),
	akT: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Monokai$requiredStyles
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$atRuleToFragment = function (a) {
	switch (a) {
		case 0:
			return _Utils_Tuple2(4, 'css-ar-i');
		case 1:
			return _Utils_Tuple2(6, 'css-ar-p');
		case 2:
			return _Utils_Tuple2(4, 'css-ar-k');
		default:
			return _Utils_Tuple2(5, 'css-ar-v');
	}
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Style7 = 8;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$attributeSelectorToFragment = function (att) {
	switch (att) {
		case 0:
			return _Utils_Tuple2(6, 'css-s-a-an');
		case 1:
			return _Utils_Tuple2(3, 'css-s-a-av');
		default:
			return _Utils_Tuple2(4, 'css-s-a-o');
	}
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$selectorToFragment = function (s) {
	switch (s.$) {
		case 0:
			return _Utils_Tuple2(4, 'css-s-e');
		case 1:
			return _Utils_Tuple2(6, 'css-s-i');
		case 2:
			return _Utils_Tuple2(6, 'css-s-cl');
		case 3:
			return _Utils_Tuple2(8, 'css-s-c');
		case 4:
			return _Utils_Tuple2(4, 'css-s-u');
		case 5:
			var att = s.a;
			return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$attributeSelectorToFragment(att);
		case 6:
			return _Utils_Tuple2(0, 'css-s-pe');
		default:
			return _Utils_Tuple2(0, 'css-s-pc');
	}
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$syntaxToStyle = function (syntax) {
	switch (syntax.$) {
		case 0:
			return _Utils_Tuple2(3, 'css-s');
		case 1:
			var a = syntax.a;
			return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$atRuleToFragment(a);
		case 2:
			var s = syntax.a;
			return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$selectorToFragment(s);
		case 3:
			return _Utils_Tuple2(5, 'css-p');
		case 4:
			return _Utils_Tuple2(5, 'css-pv');
		case 5:
			return _Utils_Tuple2(2, 'css-n');
		default:
			return _Utils_Tuple2(4, 'css-u');
	}
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$syntaxToStyle = function (syntax) {
	switch (syntax) {
		case 0:
			return _Utils_Tuple2(2, 'js-n');
		case 1:
			return _Utils_Tuple2(3, 'js-s');
		case 2:
			return _Utils_Tuple2(4, 'js-k');
		case 3:
			return _Utils_Tuple2(5, 'js-dk');
		case 4:
			return _Utils_Tuple2(5, 'js-fe');
		case 5:
			return _Utils_Tuple2(6, 'js-f');
		case 6:
			return _Utils_Tuple2(7, 'js-lk');
		case 7:
			return _Utils_Tuple2(8, 'js-p');
		default:
			return _Utils_Tuple2(6, 'js-ce');
	}
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$NoLang$syntaxToStyle = function (syntax) {
	return _Utils_Tuple2(0, 'nolang');
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$syntaxToStyle = function (syntax) {
	switch (syntax) {
		case 0:
			return _Utils_Tuple2(2, 'py-n');
		case 1:
			return _Utils_Tuple2(3, 'py-s');
		case 2:
			return _Utils_Tuple2(4, 'py-k');
		case 3:
			return _Utils_Tuple2(5, 'py-dk');
		case 5:
			return _Utils_Tuple2(6, 'py-f');
		case 6:
			return _Utils_Tuple2(7, 'py-lk');
		case 7:
			return _Utils_Tuple2(8, 'py-p');
		default:
			return _Utils_Tuple2(0, 'py-fe');
	}
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$syntaxToStyle = function (syntax) {
	switch (syntax) {
		case 0:
			return _Utils_Tuple2(2, 'sql-n');
		case 1:
			return _Utils_Tuple2(3, 'sql-s');
		case 2:
			return _Utils_Tuple2(4, 'sql-k');
		case 3:
			return _Utils_Tuple2(5, 'sql-o');
		case 4:
			return _Utils_Tuple2(6, 'sql-f');
		case 5:
			return _Utils_Tuple2(7, 'sql-p');
		default:
			return _Utils_Tuple2(8, 'sql-l');
	}
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$syntaxToStyle = function (syntax) {
	switch (syntax) {
		case 0:
			return _Utils_Tuple2(4, 'xml-t');
		case 1:
			return _Utils_Tuple2(6, 'xml-a');
		default:
			return _Utils_Tuple2(3, 'xlm-av');
	}
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$syntaxToSelector = function (syntax) {
	switch (syntax.$) {
		case 0:
			var elmSyntax = syntax.a;
			return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$syntaxToStyle(elmSyntax).b;
		case 1:
			var xmlSyntax = syntax.a;
			return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$syntaxToStyle(xmlSyntax).b;
		case 2:
			var jsSyntax = syntax.a;
			return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$syntaxToStyle(jsSyntax).b;
		case 3:
			var cssSyntax = syntax.a;
			return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$syntaxToStyle(cssSyntax).b;
		case 4:
			var pythonSyntax = syntax.a;
			return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$syntaxToStyle(pythonSyntax).b;
		case 5:
			var sqlSyntax = syntax.a;
			return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$syntaxToStyle(sqlSyntax).b;
		default:
			var noLangSyntax = syntax.a;
			return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$NoLang$syntaxToStyle(noLangSyntax).b;
	}
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$syntaxesToSelectors = function (syntaxes) {
	return $elm$core$String$concat(
		A2(
			$elm$core$List$intersperse,
			', ',
			A2(
				$elm$core$List$map,
				$elm$core$Basics$append('.elmsh-'),
				A2($elm$core$List$map, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$syntaxToSelector, syntaxes))));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$colorToCss = F2(
	function (property, color) {
		switch (color.$) {
			case 0:
				return '';
			case 1:
				var hex = color.a;
				return property + (hex + ';');
			case 2:
				var r = color.a;
				var g = color.b;
				var b = color.c;
				return $elm$core$String$concat(
					_List_fromArray(
						[
							property,
							'rgb(',
							$elm$core$String$fromInt(r),
							', ',
							$elm$core$String$fromInt(g),
							',',
							$elm$core$String$fromInt(b),
							');'
						]));
			default:
				var r = color.a;
				var g = color.b;
				var b = color.c;
				var a = color.d;
				return $elm$core$String$concat(
					_List_fromArray(
						[
							property,
							'rgba(',
							$elm$core$String$fromInt(r),
							', ',
							$elm$core$String$fromInt(g),
							',',
							$elm$core$String$fromInt(b),
							', ',
							$elm$core$String$fromFloat(a),
							');'
						]));
		}
	});
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$emptyIfFalse = F2(
	function (bool, str) {
		return bool ? str : '';
	});
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$styleToCss = function (_v0) {
	var isBold = _v0.n5;
	var isItalic = _v0.n7;
	var isUnderline = _v0.sU;
	var text = _v0.ac3;
	var background = _v0.rr;
	return $elm$core$String$concat(
		_List_fromArray(
			[
				A2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$emptyIfFalse, isBold, 'font-weight: bold;'),
				A2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$emptyIfFalse, isItalic, 'font-style: italic;'),
				A2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$emptyIfFalse, isUnderline, 'text-decoration: underline;'),
				A2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$colorToCss, 'color: ', text),
				A2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$colorToCss, 'background: ', background)
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$toCssClass = function (_v0) {
	var selectors = _v0.a;
	var style = _v0.b;
	return $elm$core$String$isEmpty(selectors) ? '' : (selectors + (' {' + ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$styleToCss(style) + '}')));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$toCss = function (classes) {
	return $elm$core$String$concat(
		A2($elm$core$List$map, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$toCssClass, classes));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$toCss = function (_v0) {
	var requiredStyles = _v0.akT;
	var customStyles = _v0.af4;
	return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$toCss(
		_Utils_ap(
			_List_fromArray(
				[
					_Utils_Tuple2('.elmsh', requiredStyles.PW),
					_Utils_Tuple2('.elmsh-hl', requiredStyles.nT),
					_Utils_Tuple2('.elmsh-add', requiredStyles.ra),
					_Utils_Tuple2('.elmsh-del', requiredStyles.r0),
					_Utils_Tuple2('.elmsh-comm', requiredStyles.N4),
					_Utils_Tuple2('.elmsh1', requiredStyles.uR),
					_Utils_Tuple2('.elmsh2', requiredStyles.uS),
					_Utils_Tuple2('.elmsh3', requiredStyles.uT),
					_Utils_Tuple2('.elmsh4', requiredStyles.uU),
					_Utils_Tuple2('.elmsh5', requiredStyles.uV),
					_Utils_Tuple2('.elmsh6', requiredStyles.uW),
					_Utils_Tuple2('.elmsh7', requiredStyles.uX)
				]),
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$mapFirst($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$syntaxesToSelectors),
				customStyles)));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Monokai$css = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$toCss($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Monokai$theme);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$monokai = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Monokai$css;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$monokai = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$monokai;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Add = 1;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Del = 2;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Normal = 0;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$requiredStyleToString = function (required) {
	return 'elmsh' + function () {
		switch (required) {
			case 0:
				return '0';
			case 1:
				return '-comm';
			case 2:
				return '1';
			case 3:
				return '2';
			case 4:
				return '3';
			case 5:
				return '4';
			case 6:
				return '5';
			case 7:
				return '6';
			default:
				return '7';
		}
	}();
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$fragmentView = function (_v0) {
	var text = _v0.ac3;
	var requiredStyle = _v0.akS;
	var additionalClass = _v0.aeI;
	return ((!requiredStyle) && $elm$core$String$isEmpty(additionalClass)) ? $elm$html$Html$text(text) : A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2(
						$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$requiredStyleToString(requiredStyle),
						!(!requiredStyle)),
						_Utils_Tuple2('elmsh-' + additionalClass, additionalClass !== '')
					]))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(text)
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$lineView = F3(
	function (start, index, _v0) {
		var fragments = _v0.ahv;
		var highlight = _v0.nT;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('elmsh-line', true),
							_Utils_Tuple2(
							'elmsh-hl',
							_Utils_eq(
								highlight,
								$elm$core$Maybe$Just(0))),
							_Utils_Tuple2(
							'elmsh-add',
							_Utils_eq(
								highlight,
								$elm$core$Maybe$Just(1))),
							_Utils_Tuple2(
							'elmsh-del',
							_Utils_eq(
								highlight,
								$elm$core$Maybe$Just(2)))
						])),
					A2(
					$elm$html$Html$Attributes$attribute,
					'data-elmsh-lc',
					$elm$core$String$fromInt(start + index))
				]),
			A2($elm$core$List$map, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$fragmentView, fragments));
	});
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$toInlineHtml = function (lines) {
	return A2(
		$elm$html$Html$code,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('elmsh')
			]),
		$elm$core$List$concat(
			A2(
				$elm$core$List$map,
				function (_v0) {
					var highlight = _v0.nT;
					var fragments = _v0.ahv;
					return _Utils_eq(highlight, $elm$core$Maybe$Nothing) ? A2($elm$core$List$map, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$fragmentView, fragments) : _List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'elmsh-hl',
											_Utils_eq(
												highlight,
												$elm$core$Maybe$Just(0))),
											_Utils_Tuple2(
											'elmsh-add',
											_Utils_eq(
												highlight,
												$elm$core$Maybe$Just(1))),
											_Utils_Tuple2(
											'elmsh-del',
											_Utils_eq(
												highlight,
												$elm$core$Maybe$Just(2)))
										]))
								]),
							A2($elm$core$List$map, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$fragmentView, fragments))
						]);
				},
				lines)));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$toBlockHtml = F2(
	function (maybeStart, lines) {
		if (maybeStart.$ === 1) {
			return A2(
				$elm$html$Html$pre,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('elmsh')
					]),
				_List_fromArray(
					[
						$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$toInlineHtml(lines)
					]));
		} else {
			var start = maybeStart.a;
			return A2(
				$elm$html$Html$pre,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('elmsh')
					]),
				$elm$core$List$singleton(
					A2(
						$elm$html$Html$code,
						_List_Nil,
						A2(
							$elm$core$List$indexedMap,
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$lineView(start),
							lines))));
		}
	});
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$toBlockHtml = F2(
	function (maybeStart, _v0) {
		var lines = _v0;
		return A2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$toBlockHtml, maybeStart, lines);
	});
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$useTheme = function (_v0) {
	var theme = _v0;
	return A3(
		$elm$html$Html$node,
		'style',
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(theme)
			]));
};
var $author$project$Components$StyleGuide$Example$highlight = function (code) {
	return _List_fromArray(
		[
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$useTheme($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$monokai),
			A2(
			$elm$core$Result$withDefault,
			A2(
				$elm$html$Html$pre,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pre')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$code,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(code)
							]))
					])),
			A2(
				$elm$core$Result$map,
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$toBlockHtml(
					$elm$core$Maybe$Just(1)),
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$elm(code)))
		]);
};
var $author$project$Components$StyleGuide$Example$Base = 0;
var $author$project$Components$StyleGuide$Example$optionsToOptionsRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, acc) {
				switch (option.$) {
					case 2:
						var string = option.a;
						return _Utils_update(
							acc,
							{ac9: string});
					case 0:
						var content = option.a;
						return _Utils_update(
							acc,
							{Qr: content});
					default:
						var surface = option.a;
						return _Utils_update(
							acc,
							{FI: surface});
				}
			}),
		{Qr: _List_Nil, FI: 0, ac9: ''},
		options);
};
var $author$project$Components$StyleGuide$Example$view = F2(
	function (options, _v0) {
		var content = _v0.G1;
		var code = _v0.NN;
		var optionsRecord = $author$project$Components$StyleGuide$Example$optionsToOptionsRecord(options);
		var surfaceClass = function () {
			var _v1 = optionsRecord.FI;
			if (_v1 === 1) {
				return 'surface-subtle';
			} else {
				return '';
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id(
					$author$project$Formatters$String$slugify(optionsRecord.ac9)),
					$elm$html$Html$Attributes$class('style-guide-example'),
					$elm$html$Html$Attributes$class(surfaceClass)
				]),
			_List_fromArray(
				[
					$elm$core$String$isEmpty(optionsRecord.ac9) ? $elm$html$Html$text('') : A2(
					$elm$html$Html$strong,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(
									'#' + $author$project$Formatters$String$slugify(optionsRecord.ac9))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(optionsRecord.ac9)
								]))
						])),
					$elm$core$List$isEmpty(optionsRecord.Qr) ? $elm$html$Html$text('') : A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('style-guide-example__description')
						]),
					optionsRecord.Qr),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('style-guide-example__separator')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('style-guide-example__content')
						]),
					content),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('style-guide-example__code')
						]),
					$author$project$Components$StyleGuide$Example$highlight(code))
				]));
	});
var $author$project$Pages$StyleGuide$AddressInput$viewBody = function (model) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Components$StyleGuide$Example$view,
							_List_fromArray(
								[
									$author$project$Components$StyleGuide$Example$title('Address Input')
								]),
							{
								NN: $author$project$Generated$StyleGuide$Examples$addressInputExample,
								G1: $author$project$Pages$StyleGuide$AddressInput$example(model)
							})
						]))
				])),
			A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Components$StyleGuide$Example$view,
							_List_fromArray(
								[
									$author$project$Components$StyleGuide$Example$title('Invalid address input')
								]),
							{
								NN: $author$project$Generated$StyleGuide$Examples$addressInputExampleDisabled,
								G1: $author$project$Pages$StyleGuide$AddressInput$exampleDisabled(model)
							})
						]))
				]))
		]);
};
var $author$project$Pages$StyleGuide$AddressInput$view = function (model) {
	return {
		fO: $author$project$Pages$StyleGuide$AddressInput$viewBody(model),
		ac9: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$AddressInput$page = $author$project$Spa$Page$element(
	{ah_: $author$project$Pages$StyleGuide$AddressInput$init, alO: $author$project$Pages$StyleGuide$AddressInput$subscriptions, adT: $author$project$Pages$StyleGuide$AddressInput$update, amo: $author$project$Pages$StyleGuide$AddressInput$view});
var $author$project$Pages$StyleGuide$Alert$init = function (_v0) {
	return _Utils_Tuple2(
		{mi: false},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$StyleGuide$Alert$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$StyleGuide$Alert$update = F2(
	function (msg, model) {
		if (msg === 1) {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{mi: false}),
				$elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{mi: true}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Generated$StyleGuide$Examples$alertExample = '\n    [ Alert.view Alert.Success [] [ text "This is a Success alert" ]\n    , Alert.view Alert.Danger [] [ text "This is a Danger alert" ]\n    , Alert.view Alert.Warning [] [ text "This is a Warning alert" ]\n    , Alert.view Alert.Info [] [ text "This is a Info alert" ]\n    , Alert.view Alert.Primary [] [ text "This is a Primary alert" ]\n    , Alert.view Alert.Primary [ Alert.icon Icon.Location ] [ text "This is a Primary alert with an Icon" ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$alertExampleDismissible = '\n    List.singleton <|\n        if alertDismissed then\n            Button.view { ariaLabel = "Show dismissible alert" } [ Button.onClick AlertShown ] [ text "show dismissible alert " ]\n\n        else\n            Alert.view Alert.Success [ Alert.dismissible AlertDismissed ] [ text "This is a dismissible alert" ]    ';
var $author$project$Ui$Alert$Primary = 4;
var $author$project$Pages$StyleGuide$Alert$example = _List_fromArray(
	[
		A3(
		$author$project$Ui$Alert$view,
		0,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('This is a Success alert')
			])),
		A3(
		$author$project$Ui$Alert$view,
		3,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('This is a Danger alert')
			])),
		A3(
		$author$project$Ui$Alert$view,
		2,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('This is a Warning alert')
			])),
		A3(
		$author$project$Ui$Alert$view,
		1,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('This is a Info alert')
			])),
		A3(
		$author$project$Ui$Alert$view,
		4,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('This is a Primary alert')
			])),
		A3(
		$author$project$Ui$Alert$view,
		4,
		_List_fromArray(
			[
				$author$project$Ui$Alert$icon(14)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('This is a Primary alert with an Icon')
			]))
	]);
var $author$project$Pages$StyleGuide$Alert$AlertDismissed = 0;
var $author$project$Pages$StyleGuide$Alert$AlertShown = 1;
var $author$project$Ui$Alert$Dismissible = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Alert$dismissible = $author$project$Ui$Alert$Dismissible;
var $author$project$Pages$StyleGuide$Alert$exampleDismissible = function (_v0) {
	var alertDismissed = _v0.mi;
	return $elm$core$List$singleton(
		alertDismissed ? A3(
			$author$project$Ui$Button$view,
			{mm: 'Show dismissible alert'},
			_List_fromArray(
				[
					$author$project$Ui$Button$onClick(1)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('show dismissible alert ')
				])) : A3(
			$author$project$Ui$Alert$view,
			0,
			_List_fromArray(
				[
					$author$project$Ui$Alert$dismissible(0)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('This is a dismissible alert')
				])));
};
var $author$project$Pages$StyleGuide$Alert$exampleDismissibleWithIcon = function (_v0) {
	var alertDismissed = _v0.mi;
	return $elm$core$List$singleton(
		alertDismissed ? A3(
			$author$project$Ui$Button$view,
			{mm: 'Show dismissible alert'},
			_List_fromArray(
				[
					$author$project$Ui$Button$onClick(1)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('show dismissible alert ')
				])) : A3(
			$author$project$Ui$Alert$view,
			0,
			_List_fromArray(
				[
					$author$project$Ui$Alert$dismissible(0),
					$author$project$Ui$Alert$icon(67)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('This is a dismissible alert with an icon')
				])));
};
var $author$project$Pages$StyleGuide$Alert$viewBody = function (model) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanMd(6)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$StyleGuide$Example$view,
							_List_fromArray(
								[
									$author$project$Components$StyleGuide$Example$title('Alert')
								]),
							{NN: $author$project$Generated$StyleGuide$Examples$alertExample, G1: $author$project$Pages$StyleGuide$Alert$example})
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanMd(6)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$StyleGuide$Example$view,
							_List_fromArray(
								[
									$author$project$Components$StyleGuide$Example$title('Dismissible Alert')
								]),
							{
								NN: $author$project$Generated$StyleGuide$Examples$alertExampleDismissible,
								G1: $author$project$Pages$StyleGuide$Alert$exampleDismissible(model)
							}),
							A2(
							$author$project$Components$StyleGuide$Example$view,
							_List_fromArray(
								[
									$author$project$Components$StyleGuide$Example$title('Dismissible Alert with an Icon')
								]),
							{
								NN: $author$project$Generated$StyleGuide$Examples$alertExampleDismissible,
								G1: $author$project$Pages$StyleGuide$Alert$exampleDismissibleWithIcon(model)
							})
						]))
				]))
		]);
};
var $author$project$Pages$StyleGuide$Alert$view = function (model) {
	return {
		fO: $author$project$Pages$StyleGuide$Alert$viewBody(model),
		ac9: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$Alert$page = $author$project$Spa$Page$element(
	{ah_: $author$project$Pages$StyleGuide$Alert$init, alO: $author$project$Pages$StyleGuide$Alert$subscriptions, adT: $author$project$Pages$StyleGuide$Alert$update, amo: $author$project$Pages$StyleGuide$Alert$view});
var $author$project$Pages$StyleGuide$Badge$marketplaceStatuses = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7, 8]);
var $author$project$Pages$StyleGuide$Badge$supportedLables = _List_fromArray(
	['needs_payment_info', 'pending', 'downloading', 'bank_not_verified', 'successful', 'live', 'failed', 'refunded', 'retrying', 'cancelled', 'default', 'saving', 'refund_pending', 'refund_successful', 'refund_failed', 'active', 'unconfirmed', 'confirmed', 'warning', 'new_payment_source', 'needs_trial_deposits', 'invalid', 'inactive', 'expiring', 'connected', 'requested', 'unpaid', 'paid', 'clearing', 'processing', 'redeemable', 'not_redeemable', 'viewed', 'bad_debt', 'disputed', 'overdue', 'sent', 'issued', 'no_payment', 'missing', 'accepted', 'accepted_and_outdated', 'not_accepted', 'none', 'scheduled', 'scheduled_without_source', 'in transit', 'completed', 'enabled', 'synced', 'unsynced', 'errored', 'opened', 'error', 'processed', 'review_data_matches', 'review_file_size', 'enqueued_for_preprocessing', 'enqueued_for_processing', 'preprocessing', 'ready_to_preprocess', 'ready_to_process', 'payable', 'deal_ending', 'failed_payment']);
var $author$project$Pages$StyleGuide$Badge$viewLabel = function (label) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$mb2]),
		_List_fromArray(
			[
				A2($author$project$Ui$Badge$fromString, _List_Nil, label)
			]));
};
var $author$project$Pages$StyleGuide$Badge$viewListingStatus = function (status) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$mb2]),
		_List_fromArray(
			[
				$author$project$Components$Marketplace$Product$Status$view(status)
			]));
};
var $author$project$Pages$StyleGuide$Badge$viewBody = _List_fromArray(
	[
		$author$project$Ui$Typography$headingLg(
		_List_fromArray(
			[
				$elm$html$Html$text('Badge')
			])),
		A2(
		$author$project$Ui$Grid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$spanMd(6)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Components$StyleGuide$Example$view,
						_List_fromArray(
							[
								$author$project$Components$StyleGuide$Example$title('Supported labels')
							]),
						{
							NN: 'Badge.fromString [] "active\"',
							G1: A2($elm$core$List$map, $author$project$Pages$StyleGuide$Badge$viewLabel, $author$project$Pages$StyleGuide$Badge$supportedLables)
						}),
						A2(
						$author$project$Components$StyleGuide$Example$view,
						_List_fromArray(
							[
								$author$project$Components$StyleGuide$Example$title('Non supported label')
							]),
						{
							NN: 'Badge.fromString [] "other->unsupported\"',
							G1: _List_fromArray(
								[
									A2($author$project$Ui$Badge$fromString, _List_Nil, 'other->unsupported')
								])
						})
					])),
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$spanMd(6)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Components$StyleGuide$Example$view,
						_List_fromArray(
							[
								$author$project$Components$StyleGuide$Example$title('Marketplace — Product Listing Status')
							]),
						{
							NN: 'Badge.view (listingStatusOptions product.listingStatus)\n    [ text (Status.toLabel product.listingStatus) ]',
							G1: A2($elm$core$List$map, $author$project$Pages$StyleGuide$Badge$viewListingStatus, $author$project$Pages$StyleGuide$Badge$marketplaceStatuses)
						})
					]))
			]))
	]);
var $author$project$Pages$StyleGuide$Badge$view = function (_v0) {
	return {fO: $author$project$Pages$StyleGuide$Badge$viewBody, ac9: 'Style Guide'};
};
var $author$project$Pages$StyleGuide$Badge$page = $author$project$Spa$Page$static($author$project$Pages$StyleGuide$Badge$view);
var $author$project$Pages$StyleGuide$Button$init = function (_v0) {
	return _Utils_Tuple2(
		{},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$StyleGuide$Button$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$StyleGuide$Button$update = F2(
	function (_v0, _v1) {
		return _Utils_Tuple2(
			{},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Generated$StyleGuide$Examples$buttonExampleFullWidthGroup = '\n    [ Button.group\n        [ Button.view\n            { ariaLabel = "Active" }\n            [ Button.active True, Button.fullWidth True ]\n            [ text "Active" ]\n        , Button.view\n            { ariaLabel = "Inactive" }\n            [ Button.fullWidth True ]\n            [ text "Inactive" ]\n        ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$buttonExampleGroup = '\n    [ Button.group\n        [ Button.view\n            { ariaLabel = "Active" }\n            [ Button.active True ]\n            [ text "Active" ]\n        , Button.view\n            { ariaLabel = "Inactive" }\n            []\n            [ text "Inactive" ]\n        ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$buttonExampleIcon = '\n    [ Button.view { ariaLabel = "Send message" } [ Button.sm, Button.icon Icon.send ] [ text "Send" ]\n    , Button.view { ariaLabel = "Send message" } [ Button.icon Icon.send ] [ text "Send" ]\n    , Button.view { ariaLabel = "Send message" } [ Button.lg, Button.icon Icon.send ] [ text "Send" ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$buttonExampleIconButton = '\n    [ Button.view\n        { ariaLabel = "Flag note" }\n        [ Button.iconOnly, Button.icon Icon.flag ]\n        []\n    , Button.view\n        { ariaLabel = "Flag note" }\n        [ Button.iconOnly, Button.icon Icon.flag, Button.danger ]\n        []\n    , Button.view\n        { ariaLabel = "Edit note" }\n        [ Button.iconOnly, Button.icon Icon.edit ]\n        []\n    , Button.view\n        { ariaLabel = "Delete note" }\n        [ Button.iconOnly, Button.icon Icon.delete ]\n        []\n    , Button.view\n        { ariaLabel = "Small flag" }\n        [ Button.iconOnly, Button.sm, Button.icon Icon.flag ]\n        []\n    , Button.view\n        { ariaLabel = "Large flag" }\n        [ Button.iconOnly, Button.lg, Button.icon Icon.flag ]\n        []\n    ]\n    ';
var $author$project$Generated$StyleGuide$Examples$buttonExampleIconOnly = '\n    [ Button.view\n        { ariaLabel = "Flag Button" }\n        [ Button.secondary\n        , Button.sm\n        , Button.icon Icon.flag\n        ]\n        []\n    , Button.view\n        { ariaLabel = "Flag Button" }\n        [ Button.secondary\n        , Button.icon Icon.flag\n        ]\n        []\n    , Button.view\n        { ariaLabel = "Flag Button" }\n        [ Button.secondary\n        , Button.lg\n        , Button.icon Icon.flag\n        ]\n        []\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$buttonExampleLink = '\n    [ Button.view { ariaLabel = "Small link button" } [ Button.link, Button.sm ] [ text "Small link" ]\n    , Button.view { ariaLabel = "Link button" } [ Button.link ] [ text "Link" ]\n    , Button.view { ariaLabel = "Large link button" } [ Button.link, Button.lg ] [ text "Chonk link" ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$buttonExampleOther = '\n    [ Button.view { ariaLabel = "Loading button" } [ Button.loading True ] [ text "Loading..." ]\n    , Button.view { ariaLabel = "Disabled button" } [ Button.disabled True ] [ text "disabled" ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$buttonExampleSecondaryOverSubtle = '\n    [ Button.view { ariaLabel = "over subtle" } [ Button.secondary ] [ text "I\'m lighter!" ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$buttonExampleSize = '\n    [ Button.view { ariaLabel = "Small button" } [ Button.sm ] [ text "Small" ]\n    , Button.view { ariaLabel = "Medium button" } [] [ text "Medium" ]\n    , Button.view { ariaLabel = "Large button" } [ Button.lg ] [ text "Large" ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$buttonExampleStyled = '\n    [ Button.view { ariaLabel = "Default button" } [] [ text "Default" ]\n    , Button.view { ariaLabel = "Primary button" } [ Button.primary ] [ text "Primary" ]\n    , Button.view { ariaLabel = "Secondary button" } [ Button.secondary ] [ text "Secondary" ]\n    , Button.view { ariaLabel = "Success button" } [ Button.success ] [ text "Success" ]\n    , Button.view { ariaLabel = "Warning button" } [ Button.warning ] [ text "Warning" ]\n    , Button.view { ariaLabel = "Danger button" } [ Button.danger ] [ text "Danger" ]\n    , Hr.view []\n    , Button.view { ariaLabel = "Link button" } [ Button.link ] [ text "Link" ]\n    , Button.view { ariaLabel = "Grey link button" } [ Button.styled Button.GreyLink ] [ text "Grey Link" ]\n    ]    ';
var $author$project$Components$StyleGuide$Example$Description = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$StyleGuide$Example$description = $author$project$Components$StyleGuide$Example$Description;
var $author$project$Pages$StyleGuide$Button$exampleFullWidthGroup = _List_fromArray(
	[
		$author$project$Ui$Button$group(
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Active'},
				_List_fromArray(
					[
						$author$project$Ui$Button$active(true),
						$author$project$Ui$Button$fullWidth(true)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Active')
					])),
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Inactive'},
				_List_fromArray(
					[
						$author$project$Ui$Button$fullWidth(true)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Inactive')
					]))
			]))
	]);
var $author$project$Pages$StyleGuide$Button$exampleGroup = _List_fromArray(
	[
		$author$project$Ui$Button$group(
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Active'},
				_List_fromArray(
					[
						$author$project$Ui$Button$active(true)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Active')
					])),
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Inactive'},
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Inactive')
					]))
			]))
	]);
var $author$project$Pages$StyleGuide$Button$exampleIcon = _List_fromArray(
	[
		A3(
		$author$project$Ui$Button$view,
		{mm: 'Send message'},
		_List_fromArray(
			[
				$author$project$Ui$Button$sm,
				$author$project$Ui$Button$icon($author$project$Ui$Icon$send)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Send')
			])),
		A3(
		$author$project$Ui$Button$view,
		{mm: 'Send message'},
		_List_fromArray(
			[
				$author$project$Ui$Button$icon($author$project$Ui$Icon$send)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Send')
			])),
		A3(
		$author$project$Ui$Button$view,
		{mm: 'Send message'},
		_List_fromArray(
			[
				$author$project$Ui$Button$lg,
				$author$project$Ui$Button$icon($author$project$Ui$Icon$send)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Send')
			]))
	]);
var $author$project$Ui$Button$IconOnly = {$: 14};
var $author$project$Ui$Button$iconOnly = $author$project$Ui$Button$IconOnly;
var $author$project$Pages$StyleGuide$Button$exampleIconButton = _List_fromArray(
	[
		A3(
		$author$project$Ui$Button$view,
		{mm: 'Flag note'},
		_List_fromArray(
			[
				$author$project$Ui$Button$iconOnly,
				$author$project$Ui$Button$icon($author$project$Ui$Icon$flag)
			]),
		_List_Nil),
		A3(
		$author$project$Ui$Button$view,
		{mm: 'Flag note'},
		_List_fromArray(
			[
				$author$project$Ui$Button$iconOnly,
				$author$project$Ui$Button$icon($author$project$Ui$Icon$flag),
				$author$project$Ui$Button$danger
			]),
		_List_Nil),
		A3(
		$author$project$Ui$Button$view,
		{mm: 'Edit note'},
		_List_fromArray(
			[
				$author$project$Ui$Button$iconOnly,
				$author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
			]),
		_List_Nil),
		A3(
		$author$project$Ui$Button$view,
		{mm: 'Delete note'},
		_List_fromArray(
			[
				$author$project$Ui$Button$iconOnly,
				$author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
			]),
		_List_Nil),
		A3(
		$author$project$Ui$Button$view,
		{mm: 'Small flag'},
		_List_fromArray(
			[
				$author$project$Ui$Button$iconOnly,
				$author$project$Ui$Button$sm,
				$author$project$Ui$Button$icon($author$project$Ui$Icon$flag)
			]),
		_List_Nil),
		A3(
		$author$project$Ui$Button$view,
		{mm: 'Large flag'},
		_List_fromArray(
			[
				$author$project$Ui$Button$iconOnly,
				$author$project$Ui$Button$lg,
				$author$project$Ui$Button$icon($author$project$Ui$Icon$flag)
			]),
		_List_Nil)
	]);
var $author$project$Pages$StyleGuide$Button$exampleIconOnly = _List_fromArray(
	[
		A3(
		$author$project$Ui$Button$view,
		{mm: 'Flag Button'},
		_List_fromArray(
			[
				$author$project$Ui$Button$secondary,
				$author$project$Ui$Button$sm,
				$author$project$Ui$Button$icon($author$project$Ui$Icon$flag)
			]),
		_List_Nil),
		A3(
		$author$project$Ui$Button$view,
		{mm: 'Flag Button'},
		_List_fromArray(
			[
				$author$project$Ui$Button$secondary,
				$author$project$Ui$Button$icon($author$project$Ui$Icon$flag)
			]),
		_List_Nil),
		A3(
		$author$project$Ui$Button$view,
		{mm: 'Flag Button'},
		_List_fromArray(
			[
				$author$project$Ui$Button$secondary,
				$author$project$Ui$Button$lg,
				$author$project$Ui$Button$icon($author$project$Ui$Icon$flag)
			]),
		_List_Nil)
	]);
var $author$project$Pages$StyleGuide$Button$exampleLink = _List_fromArray(
	[
		A3(
		$author$project$Ui$Button$view,
		{mm: 'Small link button'},
		_List_fromArray(
			[$author$project$Ui$Button$link, $author$project$Ui$Button$sm]),
		_List_fromArray(
			[
				$elm$html$Html$text('Small link')
			])),
		A3(
		$author$project$Ui$Button$view,
		{mm: 'Link button'},
		_List_fromArray(
			[$author$project$Ui$Button$link]),
		_List_fromArray(
			[
				$elm$html$Html$text('Link')
			])),
		A3(
		$author$project$Ui$Button$view,
		{mm: 'Large link button'},
		_List_fromArray(
			[$author$project$Ui$Button$link, $author$project$Ui$Button$lg]),
		_List_fromArray(
			[
				$elm$html$Html$text('Chonk link')
			]))
	]);
var $author$project$Pages$StyleGuide$Button$exampleOther = _List_fromArray(
	[
		A3(
		$author$project$Ui$Button$view,
		{mm: 'Loading button'},
		_List_fromArray(
			[
				$author$project$Ui$Button$loading(true)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Loading...')
			])),
		A3(
		$author$project$Ui$Button$view,
		{mm: 'Disabled button'},
		_List_fromArray(
			[
				$author$project$Ui$Button$disabled(true)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('disabled')
			]))
	]);
var $author$project$Pages$StyleGuide$Button$exampleSecondaryOverSubtle = _List_fromArray(
	[
		A3(
		$author$project$Ui$Button$view,
		{mm: 'over subtle'},
		_List_fromArray(
			[$author$project$Ui$Button$secondary]),
		_List_fromArray(
			[
				$elm$html$Html$text('I\'m lighter!')
			]))
	]);
var $author$project$Pages$StyleGuide$Button$exampleSize = _List_fromArray(
	[
		A3(
		$author$project$Ui$Button$view,
		{mm: 'Small button'},
		_List_fromArray(
			[$author$project$Ui$Button$sm]),
		_List_fromArray(
			[
				$elm$html$Html$text('Small')
			])),
		A3(
		$author$project$Ui$Button$view,
		{mm: 'Medium button'},
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Medium')
			])),
		A3(
		$author$project$Ui$Button$view,
		{mm: 'Large button'},
		_List_fromArray(
			[$author$project$Ui$Button$lg]),
		_List_fromArray(
			[
				$elm$html$Html$text('Large')
			]))
	]);
var $author$project$Pages$StyleGuide$Button$exampleStyled = _List_fromArray(
	[
		A3(
		$author$project$Ui$Button$view,
		{mm: 'Default button'},
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Default')
			])),
		A3(
		$author$project$Ui$Button$view,
		{mm: 'Primary button'},
		_List_fromArray(
			[$author$project$Ui$Button$primary]),
		_List_fromArray(
			[
				$elm$html$Html$text('Primary')
			])),
		A3(
		$author$project$Ui$Button$view,
		{mm: 'Secondary button'},
		_List_fromArray(
			[$author$project$Ui$Button$secondary]),
		_List_fromArray(
			[
				$elm$html$Html$text('Secondary')
			])),
		A3(
		$author$project$Ui$Button$view,
		{mm: 'Success button'},
		_List_fromArray(
			[$author$project$Ui$Button$success]),
		_List_fromArray(
			[
				$elm$html$Html$text('Success')
			])),
		A3(
		$author$project$Ui$Button$view,
		{mm: 'Warning button'},
		_List_fromArray(
			[$author$project$Ui$Button$warning]),
		_List_fromArray(
			[
				$elm$html$Html$text('Warning')
			])),
		A3(
		$author$project$Ui$Button$view,
		{mm: 'Danger button'},
		_List_fromArray(
			[$author$project$Ui$Button$danger]),
		_List_fromArray(
			[
				$elm$html$Html$text('Danger')
			])),
		$author$project$Ui$HorizontalRule$view(_List_Nil),
		A3(
		$author$project$Ui$Button$view,
		{mm: 'Link button'},
		_List_fromArray(
			[$author$project$Ui$Button$link]),
		_List_fromArray(
			[
				$elm$html$Html$text('Link')
			])),
		A3(
		$author$project$Ui$Button$view,
		{mm: 'Grey link button'},
		_List_fromArray(
			[
				$author$project$Ui$Button$styled(9)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Grey Link')
			]))
	]);
var $author$project$Components$StyleGuide$Example$Subtle = 1;
var $author$project$Components$StyleGuide$Example$Surface = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$StyleGuide$Example$subtleSurface = $author$project$Components$StyleGuide$Example$Surface(1);
var $author$project$Pages$StyleGuide$Button$view = function (_v0) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(6)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Button Styles'),
										$author$project$Components$StyleGuide$Example$description(_List_Nil)
									]),
								{NN: $author$project$Generated$StyleGuide$Examples$buttonExampleStyled, G1: $author$project$Pages$StyleGuide$Button$exampleStyled}),
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Button Sizes')
									]),
								{NN: $author$project$Generated$StyleGuide$Examples$buttonExampleSize, G1: $author$project$Pages$StyleGuide$Button$exampleSize}),
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Button Secondary over subtle surface'),
										$author$project$Components$StyleGuide$Example$subtleSurface
									]),
								{NN: $author$project$Generated$StyleGuide$Examples$buttonExampleSecondaryOverSubtle, G1: $author$project$Pages$StyleGuide$Button$exampleSecondaryOverSubtle}),
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Link options'),
										$author$project$Components$StyleGuide$Example$description(
										_List_fromArray(
											[
												$elm$html$Html$text('Buttons that look like links but don\'t have a href')
											]))
									]),
								{NN: $author$project$Generated$StyleGuide$Examples$buttonExampleLink, G1: $author$project$Pages$StyleGuide$Button$exampleLink}),
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Other options')
									]),
								{NN: $author$project$Generated$StyleGuide$Examples$buttonExampleOther, G1: $author$project$Pages$StyleGuide$Button$exampleOther})
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(6)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Button Group')
									]),
								{NN: $author$project$Generated$StyleGuide$Examples$buttonExampleGroup, G1: $author$project$Pages$StyleGuide$Button$exampleGroup}),
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Full width button Group')
									]),
								{NN: $author$project$Generated$StyleGuide$Examples$buttonExampleFullWidthGroup, G1: $author$project$Pages$StyleGuide$Button$exampleFullWidthGroup}),
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('with Icon')
									]),
								{NN: $author$project$Generated$StyleGuide$Examples$buttonExampleIcon, G1: $author$project$Pages$StyleGuide$Button$exampleIcon}),
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('with Icon and no content'),
										$author$project$Components$StyleGuide$Example$description(
										_List_fromArray(
											[
												$elm$html$Html$text('They require Button.ariaLabel option for accessibility')
											]))
									]),
								{NN: $author$project$Generated$StyleGuide$Examples$buttonExampleIconOnly, G1: $author$project$Pages$StyleGuide$Button$exampleIconOnly}),
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Compact icon-only'),
										$author$project$Components$StyleGuide$Example$description(
										_List_fromArray(
											[
												$elm$html$Html$text('Use Button.iconOnly for compact square buttons with no background. Combine with Button.styled (e.g. Button.danger) to color the icon glyph without filling the surface — handy for inline actions in dense list rows.')
											]))
									]),
								{NN: $author$project$Generated$StyleGuide$Examples$buttonExampleIconButton, G1: $author$project$Pages$StyleGuide$Button$exampleIconButton})
							]))
					]))
			]),
		ac9: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$Button$page = $author$project$Spa$Page$element(
	{ah_: $author$project$Pages$StyleGuide$Button$init, alO: $author$project$Pages$StyleGuide$Button$subscriptions, adT: $author$project$Pages$StyleGuide$Button$update, amo: $author$project$Pages$StyleGuide$Button$view});
var $author$project$Pages$StyleGuide$Carousel$CarouselMsg = $elm$core$Basics$identity;
var $author$project$Pages$StyleGuide$Carousel$init = function (_v0) {
	return _Utils_Tuple2(
		{
			mH: $author$project$Components$Carousel$init($elm$core$Basics$identity)
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$StyleGuide$Carousel$subscriptions = function (model) {
	return $author$project$Components$Carousel$subscriptions(model.mH);
};
var $author$project$Pages$StyleGuide$Carousel$update = F2(
	function (msg, model) {
		var subMsg = msg;
		return A2(
			$elm$core$Tuple$mapFirst,
			function (carousel) {
				return _Utils_update(
					model,
					{mH: carousel});
			},
			A2($author$project$Components$Carousel$update, subMsg, model.mH));
	});
var $author$project$Pages$StyleGuide$Carousel$images = _List_fromArray(
	[
		A3($author$project$Components$Carousel$image, '1', 'https://cdn2.hubspot.net/hubfs/2562809/production-app/web/full-logo.svg', 'Hint Logo'),
		A3($author$project$Components$Carousel$image, '2', 'https://cdn2.hubspot.net/hubfs/2562809/production-app/web/onboarding-complete.png', 'Hint Logo')
	]);
var $author$project$Pages$StyleGuide$Carousel$view = function (model) {
	return {
		fO: $elm$core$List$singleton(
			A3(
				$author$project$Components$Carousel$view,
				_List_fromArray(
					[$author$project$Components$Carousel$aspectVideo, $author$project$Components$Carousel$expand]),
				model.mH,
				$author$project$Pages$StyleGuide$Carousel$images)),
		ac9: 'StyleGuide.Carousel'
	};
};
var $author$project$Pages$StyleGuide$Carousel$page = $author$project$Spa$Page$element(
	{ah_: $author$project$Pages$StyleGuide$Carousel$init, alO: $author$project$Pages$StyleGuide$Carousel$subscriptions, adT: $author$project$Pages$StyleGuide$Carousel$update, amo: $author$project$Pages$StyleGuide$Carousel$view});
var $author$project$Pages$StyleGuide$Checkbox$init = function (_v0) {
	return {x$: false, x0: true, mN: false, mO: false, mP: false};
};
var $author$project$Spa$Page$sandbox = function (page) {
	return {
		ah_: F2(
			function (_v0, url) {
				return _Utils_Tuple3(
					page.ah_(url),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			}),
		aiq: $elm$core$Basics$always($author$project$Spa$Page$ignoreEffect),
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v1) {
			return $elm$core$Platform$Sub$none;
		},
		adT: F2(
			function (msg, model) {
				return _Utils_Tuple3(
					A2(page.adT, msg, model),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			}),
		amo: page.amo
	};
};
var $author$project$Pages$StyleGuide$Checkbox$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var value = msg.a;
				return _Utils_update(
					model,
					{x$: value});
			case 1:
				var value = msg.a;
				return _Utils_update(
					model,
					{x0: value});
			case 2:
				var value = msg.a;
				return _Utils_update(
					model,
					{mN: value});
			case 3:
				var value = msg.a;
				return _Utils_update(
					model,
					{mO: value});
			case 4:
				var value = msg.a;
				return _Utils_update(
					model,
					{mP: value});
			default:
				var value = msg.a;
				return _Utils_update(
					model,
					{mN: value, mO: value, mP: value});
		}
	});
var $author$project$Generated$StyleGuide$Examples$checkboxExample = '\n    [ Checkbox.view [ Checkbox.value model.checkbox1, Checkbox.onCheck Checkbox1Changed ] [ text "Unchecked" ]\n    , Checkbox.view [ Checkbox.value model.checkbox2, Checkbox.onCheck Checkbox2Changed ]\n        [ p [] [ text "Checked" ]\n        , p [] [ text "With multiple lines" ]\n        ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$checkboxExampleDisabled = '\n    [ Checkbox.view [ Checkbox.value False, Checkbox.disabled True ] [ text "Disabled unchecked" ]\n    , Checkbox.view [ Checkbox.value True, Checkbox.disabled True ] [ text "Disabled checked" ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$checkboxExampleSelectAll = '\n    let\n        allChecked =\n            model.checkbox3 && model.checkbox4 && model.checkbox5\n    in\n    [ Checkbox.view [ Checkbox.value allChecked, Checkbox.onCheck ToggleAllCheckboxes ] [ text "Check All" ]\n    , Checkbox.view [ Checkbox.value model.checkbox3, Checkbox.onCheck Checkbox3Changed ] [ text "A" ]\n    , Checkbox.view [ Checkbox.value model.checkbox4, Checkbox.onCheck Checkbox4Changed ] [ text "B" ]\n    , Checkbox.view [ Checkbox.value model.checkbox5, Checkbox.onCheck Checkbox5Changed ] [ text "C" ]\n    ]\n    ';
var $author$project$Pages$StyleGuide$Checkbox$Checkbox1Changed = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$StyleGuide$Checkbox$Checkbox2Changed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$StyleGuide$Checkbox$example = function (model) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Form$Checkbox$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Checkbox$value(model.x$),
					$author$project$Ui$Form$Checkbox$onCheck($author$project$Pages$StyleGuide$Checkbox$Checkbox1Changed)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Unchecked')
				])),
			A2(
			$author$project$Ui$Form$Checkbox$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Checkbox$value(model.x0),
					$author$project$Ui$Form$Checkbox$onCheck($author$project$Pages$StyleGuide$Checkbox$Checkbox2Changed)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Checked')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('With multiple lines')
						]))
				]))
		]);
};
var $author$project$Pages$StyleGuide$Checkbox$exampleDisabled = _List_fromArray(
	[
		A2(
		$author$project$Ui$Form$Checkbox$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Checkbox$value(false),
				$author$project$Ui$Form$Checkbox$disabled(true)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Disabled unchecked')
			])),
		A2(
		$author$project$Ui$Form$Checkbox$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Checkbox$value(true),
				$author$project$Ui$Form$Checkbox$disabled(true)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Disabled checked')
			]))
	]);
var $author$project$Pages$StyleGuide$Checkbox$Checkbox3Changed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$StyleGuide$Checkbox$Checkbox4Changed = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$StyleGuide$Checkbox$Checkbox5Changed = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$StyleGuide$Checkbox$ToggleAllCheckboxes = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$StyleGuide$Checkbox$exampleSelectAll = function (model) {
	var allChecked = model.mN && (model.mO && model.mP);
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Form$Checkbox$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Checkbox$value(allChecked),
					$author$project$Ui$Form$Checkbox$onCheck($author$project$Pages$StyleGuide$Checkbox$ToggleAllCheckboxes)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Check All')
				])),
			A2(
			$author$project$Ui$Form$Checkbox$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Checkbox$value(model.mN),
					$author$project$Ui$Form$Checkbox$onCheck($author$project$Pages$StyleGuide$Checkbox$Checkbox3Changed)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('A')
				])),
			A2(
			$author$project$Ui$Form$Checkbox$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Checkbox$value(model.mO),
					$author$project$Ui$Form$Checkbox$onCheck($author$project$Pages$StyleGuide$Checkbox$Checkbox4Changed)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('B')
				])),
			A2(
			$author$project$Ui$Form$Checkbox$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Checkbox$value(model.mP),
					$author$project$Ui$Form$Checkbox$onCheck($author$project$Pages$StyleGuide$Checkbox$Checkbox5Changed)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('C')
				]))
		]);
};
var $author$project$Pages$StyleGuide$Checkbox$viewBody = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Typography$headingLg(
				_List_fromArray(
					[
						$elm$html$Html$text('Form > Checkbox')
					])),
				A2(
				$author$project$Components$StyleGuide$Example$view,
				_List_fromArray(
					[
						$author$project$Components$StyleGuide$Example$title('Basic')
					]),
				{
					NN: $author$project$Generated$StyleGuide$Examples$checkboxExample,
					G1: $author$project$Pages$StyleGuide$Checkbox$example(model)
				}),
				A2(
				$author$project$Components$StyleGuide$Example$view,
				_List_fromArray(
					[
						$author$project$Components$StyleGuide$Example$title('Disabled')
					]),
				{NN: $author$project$Generated$StyleGuide$Examples$checkboxExampleDisabled, G1: $author$project$Pages$StyleGuide$Checkbox$exampleDisabled}),
				A2(
				$author$project$Components$StyleGuide$Example$view,
				_List_fromArray(
					[
						$author$project$Components$StyleGuide$Example$title('Select All')
					]),
				{
					NN: $author$project$Generated$StyleGuide$Examples$checkboxExampleSelectAll,
					G1: $author$project$Pages$StyleGuide$Checkbox$exampleSelectAll(model)
				})
			]));
};
var $author$project$Pages$StyleGuide$Checkbox$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				$author$project$Pages$StyleGuide$Checkbox$viewBody(model)
			]),
		ac9: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$Checkbox$page = $author$project$Spa$Page$sandbox(
	{ah_: $author$project$Pages$StyleGuide$Checkbox$init, adT: $author$project$Pages$StyleGuide$Checkbox$update, amo: $author$project$Pages$StyleGuide$Checkbox$view});
var $author$project$Pages$StyleGuide$CurrencyInput$init = function (_v0) {
	return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
};
var $author$project$Pages$StyleGuide$CurrencyInput$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$StyleGuide$CurrencyInput$update = F2(
	function (msg, _v0) {
		var _int = msg;
		return _Utils_Tuple2(_int, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$StyleGuide$CurrencyInput$CurrencyInputChanged = $elm$core$Basics$identity;
var $author$project$Pages$StyleGuide$CurrencyInput$amountInCentsErrors = function (currency) {
	return $author$project$Utils$Maybe$toBool(currency) ? _List_Nil : _List_fromArray(
		['Please enter an amount.']);
};
var $author$project$Pages$StyleGuide$CurrencyInput$viewBody = function (amountInCents) {
	return _List_fromArray(
		[
			$author$project$Ui$Typography$headingLg(
			_List_fromArray(
				[
					$elm$html$Html$text('Form -> Currency Input')
				])),
			$author$project$Ui$Form$CurrencyInput$view(
			_List_fromArray(
				[
					$author$project$Ui$Form$CurrencyInput$value(amountInCents),
					$author$project$Ui$Form$CurrencyInput$onInput($elm$core$Basics$identity),
					$author$project$Ui$Form$CurrencyInput$invalid(
					!$author$project$Utils$Maybe$toBool(amountInCents)),
					$author$project$Ui$Form$CurrencyInput$errors(
					$author$project$Pages$StyleGuide$CurrencyInput$amountInCentsErrors(amountInCents))
				])),
			$elm$html$Html$text(
			'Amount in cents: ' + A2(
				$elm$core$Maybe$withDefault,
				'N/A',
				A2($elm$core$Maybe$map, $author$project$Currency$toString, amountInCents)))
		]);
};
var $author$project$Pages$StyleGuide$CurrencyInput$view = function (model) {
	return {
		fO: $author$project$Pages$StyleGuide$CurrencyInput$viewBody(model),
		ac9: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$CurrencyInput$page = $author$project$Spa$Page$element(
	{ah_: $author$project$Pages$StyleGuide$CurrencyInput$init, alO: $author$project$Pages$StyleGuide$CurrencyInput$subscriptions, adT: $author$project$Pages$StyleGuide$CurrencyInput$update, amo: $author$project$Pages$StyleGuide$CurrencyInput$view});
var $author$project$Pages$StyleGuide$DateInput$DateInputMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$StyleGuide$DateInput$DisabledDateInputMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$StyleGuide$DateInput$InvalidDateInputMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$StyleGuide$DateInput$init = function (_v0) {
	var _v1 = $author$project$Components$DateInput$init;
	var invalidDateInput = _v1.a;
	var invalidDateInputCmd = _v1.b;
	var _v2 = $author$project$Components$DateInput$init;
	var disabledDateInput = _v2.a;
	var disabledDateInputCmd = _v2.b;
	var _v3 = $author$project$Components$DateInput$init;
	var dateInput = _v3.a;
	var dateInputCmd = _v3.b;
	return _Utils_Tuple2(
		{PB: $elm$core$Maybe$Nothing, rZ: dateInput, zf: disabledDateInput, Ad: invalidDateInput},
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$DateInput$DateInputMsg, dateInputCmd),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$DateInput$InvalidDateInputMsg, invalidDateInputCmd),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$DateInput$DisabledDateInputMsg, disabledDateInputCmd)
				])));
};
var $author$project$Pages$StyleGuide$DateInput$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$StyleGuide$DateInput$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 2:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Components$DateInput$update, subMsg, model.rZ);
				var disabledDateInput = _v1.a;
				var disabledDateInputCmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{zf: disabledDateInput}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$DateInput$DisabledDateInputMsg, disabledDateInputCmd));
			case 1:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Components$DateInput$update, subMsg, model.rZ);
				var invalidDateInput = _v2.a;
				var invalidDateInputCmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{Ad: invalidDateInput}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$DateInput$InvalidDateInputMsg, invalidDateInputCmd));
			default:
				var subMsg = msg.a;
				var _v3 = A2($author$project$Components$DateInput$update, subMsg, model.rZ);
				var dateInput = _v3.a;
				var dateInputCmd = _v3.b;
				var dateInputEvent = _v3.c;
				var date = function () {
					if (dateInputEvent.$ === 1) {
						var date_ = dateInputEvent.a;
						return date_;
					} else {
						return model.PB;
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{PB: date, rZ: dateInput}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$DateInput$DateInputMsg, dateInputCmd));
		}
	});
var $author$project$Generated$StyleGuide$Examples$dateInputExample1 = '\n    [ DateInput.view\n        [ DateInput.value model.date\n        ]\n        model.dateInput\n        |> Html.map DateInputMsg\n    , text\n        ("Date: "\n            ++ (model.date\n                    |> Maybe.map Date.toIsoString\n                    |> Maybe.withDefault "N/A"\n               )\n        )\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$dateInputExampleDisabled = '\n    [ DateInput.view\n        [ DateInput.placeholder "disabled"\n        , DateInput.disabled True\n        ]\n        model.disabledDateInput\n        |> Html.map DisabledDateInputMsg\n    ]\n    ';
var $author$project$Generated$StyleGuide$Examples$dateInputExampleInvalid = '\n    [ DateInput.view\n        [ DateInput.placeholder "invalid"\n        , DateInput.invalid True\n        , DateInput.errors [ "Some error" ]\n        ]\n        model.invalidDateInput\n        |> Html.map InvalidDateInputMsg\n    ]    ';
var $author$project$Pages$StyleGuide$DateInput$example1 = function (model) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$map,
			$author$project$Pages$StyleGuide$DateInput$DateInputMsg,
			A2(
				$author$project$Components$DateInput$view,
				_List_fromArray(
					[
						$author$project$Components$DateInput$value(model.PB)
					]),
				model.rZ)),
			$elm$html$Html$text(
			'Date: ' + A2(
				$elm$core$Maybe$withDefault,
				'N/A',
				A2($elm$core$Maybe$map, $justinmimbs$date$Date$toIsoString, model.PB)))
		]);
};
var $author$project$Pages$StyleGuide$DateInput$exampleDisabled = function (model) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$map,
			$author$project$Pages$StyleGuide$DateInput$DisabledDateInputMsg,
			A2(
				$author$project$Components$DateInput$view,
				_List_fromArray(
					[
						$author$project$Components$DateInput$placeholder('disabled'),
						$author$project$Components$DateInput$disabled(true)
					]),
				model.zf))
		]);
};
var $author$project$Pages$StyleGuide$DateInput$exampleInvalid = function (model) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$map,
			$author$project$Pages$StyleGuide$DateInput$InvalidDateInputMsg,
			A2(
				$author$project$Components$DateInput$view,
				_List_fromArray(
					[
						$author$project$Components$DateInput$placeholder('invalid'),
						$author$project$Components$DateInput$invalid(true),
						$author$project$Components$DateInput$errors(
						_List_fromArray(
							['Some error']))
					]),
				model.Ad))
		]);
};
var $author$project$Pages$StyleGuide$DateInput$viewBody = function (model) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanMd(6)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$StyleGuide$Example$view,
							_List_fromArray(
								[
									$author$project$Components$StyleGuide$Example$title('Date Input')
								]),
							{
								NN: $author$project$Generated$StyleGuide$Examples$dateInputExample1,
								G1: $author$project$Pages$StyleGuide$DateInput$example1(model)
							})
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanMd(6)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$StyleGuide$Example$view,
							_List_fromArray(
								[
									$author$project$Components$StyleGuide$Example$title('Disabled date input')
								]),
							{
								NN: $author$project$Generated$StyleGuide$Examples$dateInputExampleDisabled,
								G1: $author$project$Pages$StyleGuide$DateInput$exampleDisabled(model)
							})
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanMd(6)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$StyleGuide$Example$view,
							_List_fromArray(
								[
									$author$project$Components$StyleGuide$Example$title('Invalid date input')
								]),
							{
								NN: $author$project$Generated$StyleGuide$Examples$dateInputExampleInvalid,
								G1: $author$project$Pages$StyleGuide$DateInput$exampleInvalid(model)
							})
						]))
				]))
		]);
};
var $author$project$Pages$StyleGuide$DateInput$view = function (model) {
	return {
		fO: $author$project$Pages$StyleGuide$DateInput$viewBody(model),
		ac9: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$DateInput$page = $author$project$Spa$Page$element(
	{ah_: $author$project$Pages$StyleGuide$DateInput$init, alO: $author$project$Pages$StyleGuide$DateInput$subscriptions, adT: $author$project$Pages$StyleGuide$DateInput$update, amo: $author$project$Pages$StyleGuide$DateInput$view});
var $author$project$Pages$StyleGuide$DateRangeInput$DateRangeInputMsg = $elm$core$Basics$identity;
var $author$project$Pages$StyleGuide$DateRangeInput$dateRangeInputSettings = F2(
	function (start, end) {
		var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
		return _Utils_update(
			defaultSettings,
			{ahy: start, al5: end});
	});
var $author$project$Utils$Date$fromQuery = F2(
	function (key, query) {
		return A2(
			$elm$core$Maybe$andThen,
			$author$project$Utils$Date$fromIsoString,
			A2($elm$core$Dict$get, key, query));
	});
var $author$project$Pages$StyleGuide$DateRangeInput$init = F2(
	function (_v0, _v1) {
		var query = _v1.DE;
		var rawUrl = _v1.akq;
		var start = A2($author$project$Utils$Date$fromQuery, 'start', query);
		var end = A2($author$project$Utils$Date$fromQuery, 'end', query);
		var _v2 = A2(
			$author$project$Components$DateRangeInput$init,
			'date-range',
			A2($author$project$Pages$StyleGuide$DateRangeInput$dateRangeInputSettings, start, end));
		var dateRangeInput = _v2.a;
		var dateRangeInputCmd = _v2.b;
		return _Utils_Tuple3(
			{i4: dateRangeInput, HB: end, YX: rawUrl.YX, JV: start},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, dateRangeInputCmd),
			_List_Nil);
	});
var $author$project$Pages$StyleGuide$DateRangeInput$load = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$StyleGuide$DateRangeInput$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$StyleGuide$DateRangeInput$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$DateRangeInput$subscriptions(model.i4));
};
var $author$project$Pages$StyleGuide$DateRangeInput$updateUrl = F3(
	function (model, start, end) {
		var queryParams = _List_fromArray(
			[
				A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeL,
					$elm$url$Url$Builder$string('start'),
					$author$project$Utils$Date$toQuery),
				start),
				A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeL,
					$elm$url$Url$Builder$string('end'),
					$author$project$Utils$Date$toQuery),
				end)
			]);
		return $author$project$Ports$Navigation$pushUrl(
			A2(
				$elm$url$Url$Builder$relative,
				_List_fromArray(
					[model.YX]),
				A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)));
	});
var $author$project$Pages$StyleGuide$DateRangeInput$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A2($author$project$Components$DateRangeInput$update, subMsg, model.i4);
		var dateRangeInput = _v1.a;
		var subCmd = _v1.b;
		var event = _v1.c;
		var _v2 = function () {
			if (event.$ === 1) {
				var fromDate = event.a;
				var toDate = event.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{HB: toDate, JV: fromDate}),
					_List_fromArray(
						[
							A3($author$project$Pages$StyleGuide$DateRangeInput$updateUrl, model, fromDate, toDate)
						]));
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		}();
		var newModel = _v2.a;
		var cmds = _v2.b;
		return _Utils_Tuple3(
			_Utils_update(
				newModel,
				{i4: dateRangeInput}),
			$elm$core$Platform$Cmd$batch(
				A2(
					$elm$core$List$cons,
					A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
					cmds)),
			_List_Nil);
	});
var $author$project$Pages$StyleGuide$DateRangeInput$viewBody = function (model) {
	return _List_fromArray(
		[
			$author$project$Ui$Typography$headingLg(
			_List_fromArray(
				[
					$elm$html$Html$text('Date Range Input')
				])),
			$author$project$Ui$Typography$heading(
			_List_fromArray(
				[
					$elm$html$Html$text('Default')
				])),
			A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			$author$project$Components$DateRangeInput$view(model.i4)),
			$elm$html$Html$text(
			'Start: ' + A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Maybe$map, $author$project$Utils$Date$toQuery, model.JV))),
			A2($elm$html$Html$br, _List_Nil, _List_Nil),
			$elm$html$Html$text(
			'End: ' + A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Maybe$map, $author$project$Utils$Date$toQuery, model.HB)))
		]);
};
var $author$project$Pages$StyleGuide$DateRangeInput$view = function (model) {
	return {
		fO: $author$project$Pages$StyleGuide$DateRangeInput$viewBody(model),
		ac9: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$DateRangeInput$page = $author$project$Spa$Page$application(
	{ah_: $author$project$Pages$StyleGuide$DateRangeInput$init, aiq: $author$project$Pages$StyleGuide$DateRangeInput$load, k8: $author$project$Pages$StyleGuide$DateRangeInput$save, alO: $author$project$Pages$StyleGuide$DateRangeInput$subscriptions, adT: $author$project$Pages$StyleGuide$DateRangeInput$update, amo: $author$project$Pages$StyleGuide$DateRangeInput$view});
var $author$project$Pages$StyleGuide$DragDrop$DragDropMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$StyleGuide$DragDrop$init = function (_v0) {
	return _Utils_Tuple2(
		{
			nk: $author$project$Components$DragDrop$init($author$project$Pages$StyleGuide$DragDrop$DragDropMsg),
			j4: _List_fromArray(
				[
					{Qr: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.', ahP: '1', ZP: 1, ac9: 'Item 1'},
					{Qr: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.', ahP: '2', ZP: 2, ac9: 'Item 2'},
					{Qr: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.', ahP: '3', ZP: 3, ac9: 'Item 3'},
					{Qr: 'Lorem ipsum dolor sit amet.', ahP: '4', ZP: 4, ac9: 'Item 4'}
				])
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$StyleGuide$DragDrop$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$StyleGuide$DragDrop$assignPosition = F2(
	function (index, item) {
		return _Utils_update(
			item,
			{ZP: index + 1});
	});
var $author$project$Pages$StyleGuide$DragDrop$notSameId = F2(
	function (a, b) {
		return !_Utils_eq(a.ahP, b.ahP);
	});
var $author$project$Pages$StyleGuide$DragDrop$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Components$DragDrop$update, subMsg, model.nk);
				var dragDrop = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{nk: dragDrop}),
					cmd);
			case 1:
				var draggedItem = msg.a;
				var zoneIdx = msg.b;
				var withoutDragged = A2(
					$elm$core$List$filter,
					$author$project$Pages$StyleGuide$DragDrop$notSameId(draggedItem),
					model.j4);
				var fromPos = draggedItem.ZP;
				var toPos = (_Utils_cmp(zoneIdx, fromPos) < 0) ? (zoneIdx + 1) : zoneIdx;
				var reordered = _Utils_ap(
					A2($elm$core$List$take, toPos - 1, withoutDragged),
					A2(
						$elm$core$List$cons,
						draggedItem,
						A2($elm$core$List$drop, toPos - 1, withoutDragged)));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							j4: A2($elm$core$List$indexedMap, $author$project$Pages$StyleGuide$DragDrop$assignPosition, reordered)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var item = msg.a;
				var remaining = A2(
					$elm$core$List$filter,
					$author$project$Pages$StyleGuide$DragDrop$notSameId(item),
					model.j4);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							j4: A2($elm$core$List$indexedMap, $author$project$Pages$StyleGuide$DragDrop$assignPosition, remaining)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Generated$StyleGuide$Examples$dragDropExample = '\n    let\n        isNoOp zoneIdx item =\n            zoneIdx == item.position - 1 || zoneIdx == item.position\n\n        viewZone zoneIdx =\n            DragDrop.zone\n                [ DragDrop.off (isNoOp zoneIdx), DragDrop.onDrop MoveItem ]\n                zoneIdx\n                model.dragDrop\n\n        viewItem item =\n            DragDrop.draggable item\n                model.dragDrop\n                [ Grid.row [ Grid.rowItemsCenter ]\n                    [ Grid.column [ Grid.spanSm 1 ]\n                        [ Typ.p [ Typ.muted ]\n                            [ text (String.fromInt item.position) ]\n                        ]\n                    , Grid.column [ Grid.spanSm 9 ]\n                        [ Element.view [ Element.itemsCenter, Element.gap2 ]\n                            [ DragDrop.indicator\n                            , Element.view [ Element.flexCol ]\n                                [ Typ.headingSm [ text item.title ]\n                                , Typ.p [ Typ.muted ] [ text item.description ]\n                                ]\n                            ]\n                        ]\n                    , Grid.column [ Grid.spanSm 2 ]\n                        [ Element.view [ Element.justifyRight ]\n                            [ Button.view { ariaLabel = "Delete item" }\n                                [ Button.sm\n                                , Button.danger\n                                , Button.icon Icon.delete\n                                , Button.onClick (DeleteItem item)\n                                ]\n                                []\n                            ]\n                        ]\n                    ]\n                ]\n\n        viewPair index item =\n            [ viewZone index, viewItem item ]\n\n        itemsWithZones =\n            List.concat (List.indexedMap viewPair model.items)\n                ++ [ viewZone (List.length model.items) ]\n    in\n    [ Element.custom "card"\n        []\n        [ Element.view []\n            [ Element.view [ Element.spaceBetween, Element.itemsCenter ]\n                [ Typ.headingSm [ text "Items" ]\n                , Typ.p [ Typ.muted ]\n                    [ text (String.fromInt (List.length model.items) ++ " total") ]\n                ]\n            , Hr.view [ Hr.thin ]\n            , itemsWithZones\n                |> Element.view [ Element.mt4, Element.flexCol, Element.gap4 ]\n            ]\n        ]\n    ]\n    ';
var $author$project$Pages$StyleGuide$DragDrop$DeleteItem = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$StyleGuide$DragDrop$MoveItem = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Pages$StyleGuide$DragDrop$example = function (model) {
	var viewItem = function (item) {
		return A3(
			$author$project$Components$DragDrop$draggable,
			item,
			model.nk,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_fromArray(
						[$author$project$Ui$Grid$rowItemsCenter]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(1)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$muted]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$core$String$fromInt(item.ZP))
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(9)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
									_List_fromArray(
										[
											$author$project$Components$DragDrop$indicator,
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$flexCol]),
											_List_fromArray(
												[
													$author$project$Ui$Typography$headingSm(
													_List_fromArray(
														[
															$elm$html$Html$text(item.ac9)
														])),
													A2(
													$author$project$Ui$Typography$p,
													_List_fromArray(
														[$author$project$Ui$Typography$muted]),
													_List_fromArray(
														[
															$elm$html$Html$text(item.Qr)
														]))
												]))
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(2)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$justifyRight]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{mm: 'Delete item'},
											_List_fromArray(
												[
													$author$project$Ui$Button$sm,
													$author$project$Ui$Button$danger,
													$author$project$Ui$Button$icon($author$project$Ui$Icon$delete),
													$author$project$Ui$Button$onClick(
													$author$project$Pages$StyleGuide$DragDrop$DeleteItem(item))
												]),
											_List_Nil)
										]))
								]))
						]))
				]));
	};
	var isNoOp = F2(
		function (zoneIdx, item) {
			return _Utils_eq(zoneIdx, item.ZP - 1) || _Utils_eq(zoneIdx, item.ZP);
		});
	var viewZone = function (zoneIdx) {
		return A3(
			$author$project$Components$DragDrop$zone,
			_List_fromArray(
				[
					$author$project$Components$DragDrop$off(
					isNoOp(zoneIdx)),
					$author$project$Components$DragDrop$onDrop($author$project$Pages$StyleGuide$DragDrop$MoveItem)
				]),
			zoneIdx,
			model.nk);
	};
	var viewPair = F2(
		function (index, item) {
			return _List_fromArray(
				[
					viewZone(index),
					viewItem(item)
				]);
		});
	var itemsWithZones = _Utils_ap(
		$elm$core$List$concat(
			A2($elm$core$List$indexedMap, viewPair, model.j4)),
		_List_fromArray(
			[
				viewZone(
				$elm$core$List$length(model.j4))
			]));
	return _List_fromArray(
		[
			A3(
			$author$project$Ui$Element$custom,
			'card',
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
							_List_fromArray(
								[
									$author$project$Ui$Typography$headingSm(
									_List_fromArray(
										[
											$elm$html$Html$text('Items')
										])),
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$muted]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$core$String$fromInt(
												$elm$core$List$length(model.j4)) + ' total')
										]))
								])),
							$author$project$Ui$HorizontalRule$view(
							_List_fromArray(
								[$author$project$Ui$HorizontalRule$thin])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$mt4, $author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap4]),
							itemsWithZones)
						]))
				]))
		]);
};
var $author$project$Pages$StyleGuide$DragDrop$viewBody = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Typography$headingLg(
				_List_fromArray(
					[
						$elm$html$Html$text('DragDrop')
					])),
				A2(
				$author$project$Components$StyleGuide$Example$view,
				_List_fromArray(
					[
						$author$project$Components$StyleGuide$Example$title('Reorderable list')
					]),
				{
					NN: $author$project$Generated$StyleGuide$Examples$dragDropExample,
					G1: $author$project$Pages$StyleGuide$DragDrop$example(model)
				})
			]));
};
var $author$project$Pages$StyleGuide$DragDrop$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				$author$project$Pages$StyleGuide$DragDrop$viewBody(model)
			]),
		ac9: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$DragDrop$page = $author$project$Spa$Page$element(
	{ah_: $author$project$Pages$StyleGuide$DragDrop$init, alO: $author$project$Pages$StyleGuide$DragDrop$subscriptions, adT: $author$project$Pages$StyleGuide$DragDrop$update, amo: $author$project$Pages$StyleGuide$DragDrop$view});
var $author$project$Pages$StyleGuide$Dropdown$ComboboxDropdownMsg = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$StyleGuide$Dropdown$DisabledDropdownMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$StyleGuide$Dropdown$ErrorDropdownMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$StyleGuide$Dropdown$InnerDropdownMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$StyleGuide$Dropdown$LangDropdownMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$StyleGuide$Dropdown$LangWithSearchDropdownMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$StyleGuide$Dropdown$LinksDropdownMsg = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$StyleGuide$Dropdown$MultiLangDropdownMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$StyleGuide$Dropdown$OuterDropdownMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$StyleGuide$Dropdown$ReadonlyDropdownMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$StyleGuide$Dropdown$SecondInnerDropdownMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$StyleGuide$Dropdown$WithInputMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Ui$Dropdown$toRight = function (config) {
	return _Utils_update(
		config,
		{bv: 1});
};
var $author$project$Pages$StyleGuide$Dropdown$init = function (_v0) {
	return _Utils_Tuple2(
		{
			bT: _List_Nil,
			mV: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'free-text-dropdown', al6: $author$project$Pages$StyleGuide$Dropdown$ComboboxDropdownMsg})),
			mW: '',
			jp: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'disabled-dropdown', al6: $author$project$Pages$StyleGuide$Dropdown$DisabledDropdownMsg})),
			jF: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'error-dropdown', al6: $author$project$Pages$StyleGuide$Dropdown$ErrorDropdownMsg})),
			jZ: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$toRight(
					$author$project$Ui$Dropdown$defaultConfig(
						{ahP: 'inner', al6: $author$project$Pages$StyleGuide$Dropdown$InnerDropdownMsg}))),
			gI: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'lang-dropdown', al6: $author$project$Pages$StyleGuide$Dropdown$LangDropdownMsg})),
			gJ: '',
			j7: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'lang-dropdown-with-search', al6: $author$project$Pages$StyleGuide$Dropdown$LangWithSearchDropdownMsg})),
			op: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'links-dropdown', al6: $author$project$Pages$StyleGuide$Dropdown$LinksDropdownMsg})),
			ko: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'multi-lang-dropdown', al6: $author$project$Pages$StyleGuide$Dropdown$MultiLangDropdownMsg})),
			kv: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'outer', al6: $author$project$Pages$StyleGuide$Dropdown$OuterDropdownMsg})),
			hr: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'readonly-dropdown', al6: $author$project$Pages$StyleGuide$Dropdown$ReadonlyDropdownMsg})),
			lb: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$toRight(
					$author$project$Ui$Dropdown$defaultConfig(
						{ahP: 'second-inner', al6: $author$project$Pages$StyleGuide$Dropdown$SecondInnerDropdownMsg}))),
			n: $elm$core$Maybe$Nothing,
			lQ: $elm$core$Maybe$Nothing,
			aee: $elm$core$Maybe$Nothing,
			q3: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'with-input', al6: $author$project$Pages$StyleGuide$Dropdown$WithInputMsg}))
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$StyleGuide$Dropdown$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$Dropdown$subscriptions(model.gI),
				$author$project$Ui$Dropdown$subscriptions(model.j7),
				$author$project$Ui$Dropdown$subscriptions(model.ko),
				(model.jZ.Yn || model.lb.Yn) ? $elm$core$Platform$Sub$none : $author$project$Ui$Dropdown$subscriptions(model.kv),
				$author$project$Ui$Dropdown$subscriptions(model.jZ),
				$author$project$Ui$Dropdown$subscriptions(model.lb),
				$author$project$Ui$Dropdown$subscriptions(model.q3),
				$author$project$Ui$Dropdown$subscriptions(model.jp),
				$author$project$Ui$Dropdown$subscriptions(model.hr),
				$author$project$Ui$Dropdown$subscriptions(model.jF),
				$author$project$Ui$Dropdown$subscriptions(model.mV),
				$author$project$Ui$Dropdown$subscriptions(model.op)
			]));
};
var $author$project$Pages$StyleGuide$Dropdown$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 6:
				var text = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{gJ: text}),
					$elm$core$Platform$Cmd$none);
			case 5:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{gJ: '', n: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var lang = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gJ: '',
							n: $elm$core$Maybe$Just(lang),
							lQ: $elm$core$Maybe$Nothing
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var lang = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							mW: lang,
							n: $elm$core$Maybe$Just(lang)
						}),
					$elm$core$Platform$Cmd$none);
			case 0:
				var dropdownMsg = msg.a;
				var _v1 = A2($author$project$Ui$Dropdown$update, dropdownMsg, model.gI);
				var newDropdown = _v1.a;
				var dropdownCmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{gI: newDropdown}),
					dropdownCmd);
			case 1:
				var dropdownMsg = msg.a;
				var _v2 = A2($author$project$Ui$Dropdown$update, dropdownMsg, model.j7);
				var newDropdown = _v2.a;
				var dropdownCmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{j7: newDropdown}),
					dropdownCmd);
			case 2:
				var dropdownMsg = msg.a;
				var _v3 = A2($author$project$Ui$Dropdown$update, dropdownMsg, model.ko);
				var newDropdown = _v3.a;
				var dropdownCmd = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ko: newDropdown}),
					dropdownCmd);
			case 9:
				var dropdownMsg = msg.a;
				var _v4 = A2($author$project$Ui$Dropdown$update, dropdownMsg, model.kv);
				var newDropdown = _v4.a;
				var dropdownCmd = _v4.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{kv: newDropdown}),
					dropdownCmd);
			case 10:
				var dropdownMsg = msg.a;
				var _v5 = A2($author$project$Ui$Dropdown$update, dropdownMsg, model.jZ);
				var newDropdown = _v5.a;
				var dropdownCmd = _v5.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{jZ: newDropdown}),
					dropdownCmd);
			case 11:
				var dropdownMsg = msg.a;
				var _v6 = A2($author$project$Ui$Dropdown$update, dropdownMsg, model.lb);
				var newDropdown = _v6.a;
				var dropdownCmd = _v6.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{lb: newDropdown}),
					dropdownCmd);
			case 12:
				var dropdownMsg = msg.a;
				var _v7 = A2($author$project$Ui$Dropdown$update, dropdownMsg, model.q3);
				var newDropdown = _v7.a;
				var dropdownCmd = _v7.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{q3: newDropdown}),
					dropdownCmd);
			case 7:
				var lang = msg.a;
				var checked = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bT: checked ? A2($elm$core$List$cons, lang, model.bT) : A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(lang),
								model.bT)
						}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var langs = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bT: langs}),
					$elm$core$Platform$Cmd$none);
			case 13:
				var lang = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							lQ: $elm$core$Maybe$Just(lang)
						}),
					$elm$core$Platform$Cmd$none);
			case 14:
				var dropdownMsg = msg.a;
				var _v8 = A2($author$project$Ui$Dropdown$update, dropdownMsg, model.jp);
				var newDropdown = _v8.a;
				var dropdownCmd = _v8.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{jp: newDropdown}),
					dropdownCmd);
			case 15:
				var dropdownMsg = msg.a;
				var _v9 = A2($author$project$Ui$Dropdown$update, dropdownMsg, model.hr);
				var newDropdown = _v9.a;
				var dropdownCmd = _v9.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{hr: newDropdown}),
					dropdownCmd);
			case 16:
				var dropdownMsg = msg.a;
				var _v10 = A2($author$project$Ui$Dropdown$update, dropdownMsg, model.jF);
				var newDropdown = _v10.a;
				var dropdownCmd = _v10.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{jF: newDropdown}),
					dropdownCmd);
			case 17:
				var dropdownMsg = msg.a;
				var _v11 = A2($author$project$Ui$Dropdown$update, dropdownMsg, model.mV);
				var newDropdown = _v11.a;
				var dropdownCmd = _v11.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{mV: newDropdown}),
					dropdownCmd);
			case 18:
				var string = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{mW: string}),
					$elm$core$Platform$Cmd$none);
			default:
				var dropdownMsg = msg.a;
				var _v12 = A2($author$project$Ui$Dropdown$update, dropdownMsg, model.op);
				var newDropdown = _v12.a;
				var dropdownCmd = _v12.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{op: newDropdown}),
					dropdownCmd);
		}
	});
var $author$project$Generated$StyleGuide$Examples$dropdownExample = '\n    let\n        toOption lang =\n            Dropdown.item\n                [ Dropdown.onSelect <| LangSelected lang\n                , Dropdown.selected (model.selectedLang == Just lang)\n                ]\n                (text lang)\n\n        options =\n            Dropdown.item\n                [ Dropdown.onSelect LangCleared\n                , Dropdown.selected (model.selectedLang == Nothing)\n                ]\n                (text "None")\n                :: Dropdown.separator\n                :: ([ "Elm", "Ruby", "Javascript", "Lua" ]\n                        |> List.map toOption\n                   )\n    in\n    [ span [ Html.Attributes.id <| model.langDropdown.id ++ "-selected" ]\n        [ text "Selected: "\n        , text <|\n            case model.selectedLang of\n                Just lang ->\n                    lang\n\n                Nothing ->\n                    "None"\n        ]\n    , model.langDropdown\n        |> Dropdown.view [ Dropdown.buttonSecondary ]\n            [ Icon.translate []\n            , span [ Html.Attributes.class "ml-1" ] [ text "Select a Language" ]\n            ]\n            options\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$dropdownExampleDisabled = '\n    let\n        toOption lang =\n            Dropdown.item\n                [ Dropdown.onSelect <| LangSelected lang\n                , Dropdown.selected (model.selectedLang == Just lang)\n                ]\n                (text lang)\n\n        options =\n            Dropdown.item\n                [ Dropdown.onSelect LangCleared\n                , Dropdown.selected (model.selectedLang == Nothing)\n                ]\n                (text "None")\n                :: Dropdown.separator\n                :: ([ "Elm", "Ruby", "Javascript", "Lua" ]\n                        |> List.map toOption\n                   )\n    in\n    [ span [ Html.Attributes.id <| model.disabledDropdown.id ++ "-selected" ]\n        [ text "Selected: "\n        , text <|\n            case model.selectedLang of\n                Just lang ->\n                    lang\n\n                Nothing ->\n                    "None"\n        ]\n    , model.disabledDropdown\n        |> Dropdown.viewSelect [ Dropdown.disabled True ]\n            [ text "Disabled Dropdown" ]\n            options\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$dropdownExampleInnerDropdown = '\n    -- Make sure to check the subscriptions function!\n    let\n        toOption lang =\n            Dropdown.checkbox\n                [ Dropdown.onCheck <| LangChecked lang\n                , Dropdown.checked (List.member lang model.checkedLangs)\n                ]\n                (text lang)\n    in\n    [ span [ Html.Attributes.id <| model.outerDropdown.id ++ "-selected" ]\n        [ text "Selected: "\n        , text <|\n            if List.isEmpty model.checkedLangs then\n                "None"\n\n            else\n                model.checkedLangs |> String.join ", "\n        ]\n    , model.outerDropdown\n        |> Dropdown.view [ Dropdown.buttonSecondary ]\n            [ text "Pick languages" ]\n            [ Dropdown.innerDropdown\n                [ Element.view [ Element.spaceBetween, Element.itemsCenter ]\n                    [ Html.span []\n                        [ text "Functional" ]\n                    , Icon.chevron [ Icon.info ]\n                    ]\n                ]\n                ([ "Elm", "Haskell", "Elixir", "Idris" ] |> List.map toOption)\n                model.innerDropdown\n            , Dropdown.innerDropdown\n                [ Element.view [ Element.spaceBetween, Element.itemsCenter ]\n                    [ Html.span []\n                        [ text "Object Oriented" ]\n                    , Icon.chevron [ Icon.info ]\n                    ]\n                ]\n                ([ "Ruby", "Javascript", "Python" ] |> List.map toOption)\n                model.secondInnerDropdown\n            ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$dropdownExampleMultiSelect = '\n    let\n        toOption lang =\n            Dropdown.checkbox\n                [ Dropdown.onCheck <| LangChecked lang\n                , Dropdown.checked (List.member lang model.checkedLangs)\n                ]\n                (text lang)\n\n        options =\n            Dropdown.item\n                [ Dropdown.onSelect <| CheckedLangsSet []\n                ]\n                (text "None")\n                :: Dropdown.separator\n                :: ([ "Elm", "Ruby", "Javascript", "Lua" ]\n                        |> List.filter (String.contains model.langSearch)\n                        |> List.map toOption\n                   )\n    in\n    [ span [ Html.Attributes.id <| model.multiLangDropdown.id ++ "-selected" ] [ text "Selected: " ]\n    , text <|\n        if List.isEmpty model.checkedLangs then\n            "None"\n\n        else\n            model.checkedLangs |> String.join ", "\n    , model.multiLangDropdown |> Dropdown.view [ Dropdown.buttonSecondary ] [ text "Langs" ] options\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$dropdownExampleReadonly = '\n    let\n        toOption lang =\n            Dropdown.item\n                [ Dropdown.onSelect <| LangSelected lang\n                , Dropdown.selected (model.selectedLang == Just lang)\n                ]\n                (text lang)\n\n        options =\n            Dropdown.item\n                [ Dropdown.onSelect LangCleared\n                , Dropdown.selected (model.selectedLang == Nothing)\n                ]\n                (text "None")\n                :: Dropdown.separator\n                :: ([ "Elm", "Ruby", "Javascript", "Lua" ]\n                        |> List.map toOption\n                   )\n    in\n    [ span [ Html.Attributes.id <| model.readonlyDropdown.id ++ "-selected" ]\n        [ text "Selected: "\n        , text <|\n            case model.selectedLang of\n                Just lang ->\n                    lang\n\n                Nothing ->\n                    "None"\n        ]\n    , model.readonlyDropdown\n        |> Dropdown.viewSelect [ Dropdown.readonly True ]\n            [ text "Readonly Dropdown" ]\n            options\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$dropdownExampleSearch = '\n    let\n        -- Transform language into an option\n        toOption lang =\n            Dropdown.item\n                [ Dropdown.onSelect <| LangSelected lang\n                , Dropdown.selected (model.selectedLang == Just lang)\n                ]\n                (text lang)\n\n        contains lang =\n            String.toLower lang |> String.contains (String.toLower model.langSearch)\n\n        -- Define (and filter in this case) the list of languages.\n        langs =\n            [ "Elm", "Ruby", "Javascript", "Lua", "Rust" ]\n                |> List.filter contains\n\n        options =\n            Dropdown.input\n                (Dropdown.onInput LangSearched\n                    :: Dropdown.value model.langSearch\n                    :: Dropdown.placeholder "Search..."\n                    :: (case langs of\n                            [ singleLang ] ->\n                                -- Optionally, select a single result on Enter.\n                                [ Dropdown.onEnter (LangSelected singleLang) ]\n\n                            _ ->\n                                []\n                       )\n                )\n                :: Dropdown.item\n                    [ Dropdown.onSelect LangCleared\n                    , Dropdown.selected (model.selectedLang == Nothing)\n                    ]\n                    (text "None")\n                :: Dropdown.separator\n                :: (langs\n                        |> List.map toOption\n                   )\n    in\n    [ span [ Html.Attributes.id <| model.langWithSearchDropdown.id ++ "-selected" ]\n        [ text "Selected: "\n        , text <|\n            case model.selectedLang of\n                Just lang ->\n                    lang\n\n                Nothing ->\n                    "None"\n        ]\n    , model.langWithSearchDropdown\n        |> Dropdown.view [ Dropdown.buttonSecondary ] [ text "Lang" ] options\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$dropdownExampleWithButton = '\n    let\n        toOption lang =\n            Dropdown.item\n                [ Dropdown.onSelect <| LangSelected lang\n                , Dropdown.selected (model.selectedLang == Just lang)\n                ]\n                (text lang)\n\n        options =\n            Dropdown.item\n                [ Dropdown.onSelect LangCleared\n                , Dropdown.selected (model.selectedLang == Nothing)\n                ]\n                (text "None")\n                :: Dropdown.separator\n                :: ([ "Elm", "Ruby", "Javascript", "Lua" ]\n                        |> List.map toOption\n                   )\n    in\n    [ Button.group\n        [ Button.view { ariaLabel = "Open dropdown menu" }\n            []\n            [ text <|\n                case model.selectedLang of\n                    Just lang ->\n                        lang\n\n                    Nothing ->\n                        "None"\n            ]\n        , model.langDropdown\n            |> Dropdown.view []\n                [ Icon.translate []\n                ]\n                options\n        ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$dropdownExampleWithCombobox = '\n    let\n        toOption lang =\n            Dropdown.item\n                [ Dropdown.onSelect <| FreeLangSelected lang\n                , Dropdown.selected (model.selectedLang == Just lang)\n                ]\n                (text lang)\n\n        contains lang =\n            String.toLower lang |> String.contains (String.toLower model.comboboxString)\n\n        -- Define (and filter in this case) the list of languages.\n        langs =\n            [ "Elm", "Ruby", "Javascript", "Lua", "Rust" ]\n                |> List.filter contains\n\n        options =\n            langs\n                |> List.map toOption\n    in\n    [ span [ Html.Attributes.id <| model.readonlyDropdown.id ++ "-selected" ]\n        [ text "Selected: "\n        , text <|\n            case model.selectedLang of\n                Just lang ->\n                    lang\n\n                Nothing ->\n                    "None"\n        ]\n    , model.comboboxDropdown\n        |> Dropdown.viewCombobox []\n            { onInput = ComboboxDropdownInput\n            , value = model.comboboxString\n            , onEnter =\n                langs\n                    |> List.head\n                    |> Maybe.map FreeLangSelected\n            }\n            options\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$dropdownExampleWithErrors = '\n    let\n        toOption lang =\n            Dropdown.item\n                [ Dropdown.onSelect <| LangSelected lang\n                , Dropdown.selected (model.selectedLang == Just lang)\n                ]\n                (text lang)\n\n        options =\n            Dropdown.item\n                [ Dropdown.onSelect LangCleared\n                , Dropdown.selected (model.selectedLang == Nothing)\n                ]\n                (text "None")\n                :: Dropdown.separator\n                :: ([ "Elm", "Ruby", "Javascript", "Lua" ]\n                        |> List.map toOption\n                   )\n    in\n    [ span [ Html.Attributes.id <| model.errorDropdown.id ++ "-selected" ]\n        [ text "Selected: "\n        , text <|\n            case model.selectedLang of\n                Just lang ->\n                    lang\n\n                Nothing ->\n                    "None"\n        ]\n    , model.errorDropdown\n        |> Dropdown.viewSelect\n            [ Dropdown.errors [ "This field is required", "Please select a valid option" ]\n            , Dropdown.invalid True\n            ]\n            [ text "Dropdown with Errors" ]\n            options\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$dropdownExampleWithInput = '\n    let\n        toOption lang =\n            Dropdown.item\n                [ Dropdown.onSelect <| LangSelected lang\n                , Dropdown.selected (model.selectedLang == Just lang)\n                ]\n                (text lang)\n\n        contains lang =\n            case model.typedLang of\n                Nothing ->\n                    True\n\n                Just typedLang ->\n                    String.toLower lang |> String.contains (String.toLower typedLang)\n\n        -- Define (and filter in this case) the list of languages.\n        langs =\n            [ "Elm", "Ruby", "Javascript", "Lua", "Rust" ]\n                |> List.filter contains\n\n        options =\n            Dropdown.input\n                [ Dropdown.onInput TypedLang\n                , Dropdown.value <| Maybe.withDefault "" model.typedLang\n                , Dropdown.placeholder "Search or type your own"\n                ]\n                :: Dropdown.item\n                    [ Dropdown.onSelect LangCleared\n                    , Dropdown.selected (model.selectedLang == Nothing)\n                    ]\n                    (text "None")\n                :: Dropdown.separator\n                :: (langs\n                        |> List.map toOption\n                   )\n\n        notIfEmpty lang =\n            if String.isEmpty lang then\n                Nothing\n\n            else\n                Just lang\n    in\n    [ model.withInput\n        |> Dropdown.viewSelect []\n            [ model.typedLang\n                |> Maybe.andThen notIfEmpty\n                |> Maybe.withDefault (model.selectedLang |> Maybe.withDefault "All langs")\n                |> text\n            ]\n            options\n    ]    ';
var $author$project$Pages$StyleGuide$Dropdown$LangCleared = {$: 5};
var $author$project$Pages$StyleGuide$Dropdown$LangSelected = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$StyleGuide$Dropdown$example = function (model) {
	var toOption = function (lang) {
		return A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Pages$StyleGuide$Dropdown$LangSelected(lang)),
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(
						model.n,
						$elm$core$Maybe$Just(lang)))
				]),
			$elm$html$Html$text(lang));
	};
	var options = A2(
		$elm$core$List$cons,
		A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onSelect($author$project$Pages$StyleGuide$Dropdown$LangCleared),
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(model.n, $elm$core$Maybe$Nothing))
				]),
			$elm$html$Html$text('None')),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$Dropdown$separator,
			A2(
				$elm$core$List$map,
				toOption,
				_List_fromArray(
					['Elm', 'Ruby', 'Javascript', 'Lua']))));
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id(model.gI.ahP + '-selected')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Selected: '),
					$elm$html$Html$text(
					function () {
						var _v0 = model.n;
						if (!_v0.$) {
							var lang = _v0.a;
							return lang;
						} else {
							return 'None';
						}
					}())
				])),
			A4(
			$author$project$Ui$Dropdown$view,
			_List_fromArray(
				[$author$project$Ui$Dropdown$buttonSecondary]),
			_List_fromArray(
				[
					$author$project$Ui$Icon$translate(_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ml-1')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Select a Language')
						]))
				]),
			options,
			model.gI)
		]);
};
var $author$project$Pages$StyleGuide$Dropdown$exampleDisabled = function (model) {
	var toOption = function (lang) {
		return A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Pages$StyleGuide$Dropdown$LangSelected(lang)),
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(
						model.n,
						$elm$core$Maybe$Just(lang)))
				]),
			$elm$html$Html$text(lang));
	};
	var options = A2(
		$elm$core$List$cons,
		A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onSelect($author$project$Pages$StyleGuide$Dropdown$LangCleared),
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(model.n, $elm$core$Maybe$Nothing))
				]),
			$elm$html$Html$text('None')),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$Dropdown$separator,
			A2(
				$elm$core$List$map,
				toOption,
				_List_fromArray(
					['Elm', 'Ruby', 'Javascript', 'Lua']))));
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id(model.jp.ahP + '-selected')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Selected: '),
					$elm$html$Html$text(
					function () {
						var _v0 = model.n;
						if (!_v0.$) {
							var lang = _v0.a;
							return lang;
						} else {
							return 'None';
						}
					}())
				])),
			A4(
			$author$project$Ui$Dropdown$viewSelect,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$disabled(true)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Disabled Dropdown')
				]),
			options,
			model.jp)
		]);
};
var $author$project$Pages$StyleGuide$Dropdown$LangChecked = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Ui$Dropdown$InnerDropdown = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $author$project$Ui$Dropdown$innerDropdown = $author$project$Ui$Dropdown$InnerDropdown;
var $author$project$Pages$StyleGuide$Dropdown$exampleInnerDropdown = function (model) {
	var toOption = function (lang) {
		return A2(
			$author$project$Ui$Dropdown$checkbox,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onCheck(
					$author$project$Pages$StyleGuide$Dropdown$LangChecked(lang)),
					$author$project$Ui$Dropdown$checked(
					A2($elm$core$List$member, lang, model.bT))
				]),
			$elm$html$Html$text(lang));
	};
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id(model.kv.ahP + '-selected')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Selected: '),
					$elm$html$Html$text(
					$elm$core$List$isEmpty(model.bT) ? 'None' : A2($elm$core$String$join, ', ', model.bT))
				])),
			A4(
			$author$project$Ui$Dropdown$view,
			_List_fromArray(
				[$author$project$Ui$Dropdown$buttonSecondary]),
			_List_fromArray(
				[
					$elm$html$Html$text('Pick languages')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Dropdown$innerDropdown,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Functional')
										])),
									$author$project$Ui$Icon$chevron(
									_List_fromArray(
										[$author$project$Ui$Icon$info]))
								]))
						]),
					A2(
						$elm$core$List$map,
						toOption,
						_List_fromArray(
							['Elm', 'Haskell', 'Elixir', 'Idris'])),
					model.jZ),
					A3(
					$author$project$Ui$Dropdown$innerDropdown,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Object Oriented')
										])),
									$author$project$Ui$Icon$chevron(
									_List_fromArray(
										[$author$project$Ui$Icon$info]))
								]))
						]),
					A2(
						$elm$core$List$map,
						toOption,
						_List_fromArray(
							['Ruby', 'Javascript', 'Python'])),
					model.lb)
				]),
			model.kv)
		]);
};
var $author$project$Pages$StyleGuide$Dropdown$CheckedLangsSet = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$StyleGuide$Dropdown$exampleMultiSelect = function (model) {
	var toOption = function (lang) {
		return A2(
			$author$project$Ui$Dropdown$checkbox,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onCheck(
					$author$project$Pages$StyleGuide$Dropdown$LangChecked(lang)),
					$author$project$Ui$Dropdown$checked(
					A2($elm$core$List$member, lang, model.bT))
				]),
			$elm$html$Html$text(lang));
	};
	var options = A2(
		$elm$core$List$cons,
		A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Pages$StyleGuide$Dropdown$CheckedLangsSet(_List_Nil))
				]),
			$elm$html$Html$text('None')),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$Dropdown$separator,
			A2(
				$elm$core$List$map,
				toOption,
				A2(
					$elm$core$List$filter,
					$elm$core$String$contains(model.gJ),
					_List_fromArray(
						['Elm', 'Ruby', 'Javascript', 'Lua'])))));
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id(model.ko.ahP + '-selected')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Selected: ')
				])),
			$elm$html$Html$text(
			$elm$core$List$isEmpty(model.bT) ? 'None' : A2($elm$core$String$join, ', ', model.bT)),
			A4(
			$author$project$Ui$Dropdown$view,
			_List_fromArray(
				[$author$project$Ui$Dropdown$buttonSecondary]),
			_List_fromArray(
				[
					$elm$html$Html$text('Langs')
				]),
			options,
			model.ko)
		]);
};
var $author$project$Ui$Dropdown$Readonly = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Dropdown$readonly = $author$project$Ui$Dropdown$Readonly;
var $author$project$Pages$StyleGuide$Dropdown$exampleReadonly = function (model) {
	var toOption = function (lang) {
		return A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Pages$StyleGuide$Dropdown$LangSelected(lang)),
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(
						model.n,
						$elm$core$Maybe$Just(lang)))
				]),
			$elm$html$Html$text(lang));
	};
	var options = A2(
		$elm$core$List$cons,
		A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onSelect($author$project$Pages$StyleGuide$Dropdown$LangCleared),
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(model.n, $elm$core$Maybe$Nothing))
				]),
			$elm$html$Html$text('None')),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$Dropdown$separator,
			A2(
				$elm$core$List$map,
				toOption,
				_List_fromArray(
					['Elm', 'Ruby', 'Javascript', 'Lua']))));
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id(model.hr.ahP + '-selected')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Selected: '),
					$elm$html$Html$text(
					function () {
						var _v0 = model.n;
						if (!_v0.$) {
							var lang = _v0.a;
							return lang;
						} else {
							return 'None';
						}
					}())
				])),
			A4(
			$author$project$Ui$Dropdown$viewSelect,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$readonly(true)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Readonly Dropdown')
				]),
			options,
			model.hr)
		]);
};
var $author$project$Pages$StyleGuide$Dropdown$LangSearched = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$StyleGuide$Dropdown$exampleSearch = function (model) {
	var toOption = function (lang) {
		return A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Pages$StyleGuide$Dropdown$LangSelected(lang)),
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(
						model.n,
						$elm$core$Maybe$Just(lang)))
				]),
			$elm$html$Html$text(lang));
	};
	var contains = function (lang) {
		return A2(
			$elm$core$String$contains,
			$elm$core$String$toLower(model.gJ),
			$elm$core$String$toLower(lang));
	};
	var langs = A2(
		$elm$core$List$filter,
		contains,
		_List_fromArray(
			['Elm', 'Ruby', 'Javascript', 'Lua', 'Rust']));
	var options = A2(
		$elm$core$List$cons,
		$author$project$Ui$Dropdown$input(
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Dropdown$onInput($author$project$Pages$StyleGuide$Dropdown$LangSearched),
				A2(
					$elm$core$List$cons,
					$author$project$Ui$Dropdown$value(model.gJ),
					A2(
						$elm$core$List$cons,
						$author$project$Ui$Dropdown$placeholder('Search...'),
						function () {
							if (langs.b && (!langs.b.b)) {
								var singleLang = langs.a;
								return _List_fromArray(
									[
										$author$project$Ui$Dropdown$onEnter(
										$author$project$Pages$StyleGuide$Dropdown$LangSelected(singleLang))
									]);
							} else {
								return _List_Nil;
							}
						}())))),
		A2(
			$elm$core$List$cons,
			A2(
				$author$project$Ui$Dropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$Dropdown$onSelect($author$project$Pages$StyleGuide$Dropdown$LangCleared),
						$author$project$Ui$Dropdown$selected(
						_Utils_eq(model.n, $elm$core$Maybe$Nothing))
					]),
				$elm$html$Html$text('None')),
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Dropdown$separator,
				A2($elm$core$List$map, toOption, langs))));
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id(model.j7.ahP + '-selected')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Selected: '),
					$elm$html$Html$text(
					function () {
						var _v0 = model.n;
						if (!_v0.$) {
							var lang = _v0.a;
							return lang;
						} else {
							return 'None';
						}
					}())
				])),
			A4(
			$author$project$Ui$Dropdown$view,
			_List_fromArray(
				[$author$project$Ui$Dropdown$buttonSecondary]),
			_List_fromArray(
				[
					$elm$html$Html$text('Lang')
				]),
			options,
			model.j7)
		]);
};
var $author$project$Pages$StyleGuide$Dropdown$exampleWithButton = function (model) {
	var toOption = function (lang) {
		return A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Pages$StyleGuide$Dropdown$LangSelected(lang)),
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(
						model.n,
						$elm$core$Maybe$Just(lang)))
				]),
			$elm$html$Html$text(lang));
	};
	var options = A2(
		$elm$core$List$cons,
		A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onSelect($author$project$Pages$StyleGuide$Dropdown$LangCleared),
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(model.n, $elm$core$Maybe$Nothing))
				]),
			$elm$html$Html$text('None')),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$Dropdown$separator,
			A2(
				$elm$core$List$map,
				toOption,
				_List_fromArray(
					['Elm', 'Ruby', 'Javascript', 'Lua']))));
	return _List_fromArray(
		[
			$author$project$Ui$Button$group(
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{mm: 'Open dropdown menu'},
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							function () {
								var _v0 = model.n;
								if (!_v0.$) {
									var lang = _v0.a;
									return lang;
								} else {
									return 'None';
								}
							}())
						])),
					A4(
					$author$project$Ui$Dropdown$view,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Icon$translate(_List_Nil)
						]),
					options,
					model.gI)
				]))
		]);
};
var $author$project$Pages$StyleGuide$Dropdown$ComboboxDropdownInput = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$StyleGuide$Dropdown$FreeLangSelected = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$StyleGuide$Dropdown$exampleWithCombobox = function (model) {
	var toOption = function (lang) {
		return A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Pages$StyleGuide$Dropdown$FreeLangSelected(lang)),
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(
						model.n,
						$elm$core$Maybe$Just(lang)))
				]),
			$elm$html$Html$text(lang));
	};
	var contains = function (lang) {
		return A2(
			$elm$core$String$contains,
			$elm$core$String$toLower(model.mW),
			$elm$core$String$toLower(lang));
	};
	var langs = A2(
		$elm$core$List$filter,
		contains,
		_List_fromArray(
			['Elm', 'Ruby', 'Javascript', 'Lua', 'Rust']));
	var options = A2($elm$core$List$map, toOption, langs);
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id(model.hr.ahP + '-selected')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Selected: '),
					$elm$html$Html$text(
					function () {
						var _v0 = model.n;
						if (!_v0.$) {
							var lang = _v0.a;
							return lang;
						} else {
							return 'None';
						}
					}())
				])),
			A4(
			$author$project$Ui$Dropdown$viewCombobox,
			_List_Nil,
			{
				aji: A2(
					$elm$core$Maybe$map,
					$author$project$Pages$StyleGuide$Dropdown$FreeLangSelected,
					$elm$core$List$head(langs)),
				ajm: $author$project$Pages$StyleGuide$Dropdown$ComboboxDropdownInput,
				aee: model.mW
			},
			options,
			model.mV)
		]);
};
var $author$project$Pages$StyleGuide$Dropdown$exampleWithErrors = function (model) {
	var toOption = function (lang) {
		return A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Pages$StyleGuide$Dropdown$LangSelected(lang)),
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(
						model.n,
						$elm$core$Maybe$Just(lang)))
				]),
			$elm$html$Html$text(lang));
	};
	var options = A2(
		$elm$core$List$cons,
		A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onSelect($author$project$Pages$StyleGuide$Dropdown$LangCleared),
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(model.n, $elm$core$Maybe$Nothing))
				]),
			$elm$html$Html$text('None')),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$Dropdown$separator,
			A2(
				$elm$core$List$map,
				toOption,
				_List_fromArray(
					['Elm', 'Ruby', 'Javascript', 'Lua']))));
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id(model.jF.ahP + '-selected')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Selected: '),
					$elm$html$Html$text(
					function () {
						var _v0 = model.n;
						if (!_v0.$) {
							var lang = _v0.a;
							return lang;
						} else {
							return 'None';
						}
					}())
				])),
			A4(
			$author$project$Ui$Dropdown$viewSelect,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$errors(
					_List_fromArray(
						['This field is required', 'Please select a valid option'])),
					$author$project$Ui$Dropdown$invalid(true)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Dropdown with Errors')
				]),
			options,
			model.jF)
		]);
};
var $author$project$Pages$StyleGuide$Dropdown$TypedLang = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$StyleGuide$Dropdown$exampleWithInput = function (model) {
	var toOption = function (lang) {
		return A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Pages$StyleGuide$Dropdown$LangSelected(lang)),
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(
						model.n,
						$elm$core$Maybe$Just(lang)))
				]),
			$elm$html$Html$text(lang));
	};
	var notIfEmpty = function (lang) {
		return $elm$core$String$isEmpty(lang) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(lang);
	};
	var contains = function (lang) {
		var _v0 = model.lQ;
		if (_v0.$ === 1) {
			return true;
		} else {
			var typedLang = _v0.a;
			return A2(
				$elm$core$String$contains,
				$elm$core$String$toLower(typedLang),
				$elm$core$String$toLower(lang));
		}
	};
	var langs = A2(
		$elm$core$List$filter,
		contains,
		_List_fromArray(
			['Elm', 'Ruby', 'Javascript', 'Lua', 'Rust']));
	var options = A2(
		$elm$core$List$cons,
		$author$project$Ui$Dropdown$input(
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onInput($author$project$Pages$StyleGuide$Dropdown$TypedLang),
					$author$project$Ui$Dropdown$value(
					A2($elm$core$Maybe$withDefault, '', model.lQ)),
					$author$project$Ui$Dropdown$placeholder('Search or type your own')
				])),
		A2(
			$elm$core$List$cons,
			A2(
				$author$project$Ui$Dropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$Dropdown$onSelect($author$project$Pages$StyleGuide$Dropdown$LangCleared),
						$author$project$Ui$Dropdown$selected(
						_Utils_eq(model.n, $elm$core$Maybe$Nothing))
					]),
				$elm$html$Html$text('None')),
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Dropdown$separator,
				A2($elm$core$List$map, toOption, langs))));
	return _List_fromArray(
		[
			A4(
			$author$project$Ui$Dropdown$viewSelect,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2(
						$elm$core$Maybe$withDefault,
						A2($elm$core$Maybe$withDefault, 'All langs', model.n),
						A2($elm$core$Maybe$andThen, notIfEmpty, model.lQ)))
				]),
			options,
			model.q3)
		]);
};
var $author$project$Ui$Dropdown$ButtonLink = 1;
var $author$project$Ui$Dropdown$buttonLink = $author$project$Ui$Dropdown$Button(1);
var $author$project$Ui$Dropdown$Link = F3(
	function (a, b, c) {
		return {$: 6, a: a, b: b, c: c};
	});
var $author$project$Ui$Dropdown$link = $author$project$Ui$Dropdown$Link;
var $author$project$Pages$StyleGuide$Dropdown$exampleWithLinks = function (model) {
	return _List_fromArray(
		[
			$elm$html$Html$text('Test arrow navigation on this dropdown with links:'),
			A4(
			$author$project$Ui$Dropdown$view,
			_List_fromArray(
				[$author$project$Ui$Dropdown$buttonLink]),
			_List_fromArray(
				[
					$elm$html$Html$text('Switch To')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Dropdown$link,
					'https://example.com/clinical',
					_List_Nil,
					$elm$html$Html$text('Clinical')),
					A3(
					$author$project$Ui$Dropdown$link,
					'https://example.com/admin',
					_List_Nil,
					$elm$html$Html$text('Admin Portal')),
					A2(
					$author$project$Ui$Dropdown$item,
					_List_fromArray(
						[
							$author$project$Ui$Dropdown$onSelect(
							$author$project$Pages$StyleGuide$Dropdown$LangSelected('regular'))
						]),
					$elm$html$Html$text('Regular Item')),
					A3(
					$author$project$Ui$Dropdown$link,
					'https://example.com/settings',
					_List_Nil,
					$elm$html$Html$text('Settings'))
				]),
			model.op)
		]);
};
var $author$project$Pages$StyleGuide$Dropdown$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Select Like')
									]),
								{
									NN: $author$project$Generated$StyleGuide$Examples$dropdownExample,
									G1: $author$project$Pages$StyleGuide$Dropdown$example(model)
								})
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Select Like with search')
									]),
								{
									NN: $author$project$Generated$StyleGuide$Examples$dropdownExampleSearch,
									G1: $author$project$Pages$StyleGuide$Dropdown$exampleSearch(model)
								})
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Multi select')
									]),
								{
									NN: $author$project$Generated$StyleGuide$Examples$dropdownExampleMultiSelect,
									G1: $author$project$Pages$StyleGuide$Dropdown$exampleMultiSelect(model)
								})
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Dropdownception')
									]),
								{
									NN: $author$project$Generated$StyleGuide$Examples$dropdownExampleInnerDropdown,
									G1: $author$project$Pages$StyleGuide$Dropdown$exampleInnerDropdown(model)
								})
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Next to Button')
									]),
								{
									NN: $author$project$Generated$StyleGuide$Examples$dropdownExampleWithButton,
									G1: $author$project$Pages$StyleGuide$Dropdown$exampleWithButton(model)
								})
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Free text like?')
									]),
								{
									NN: $author$project$Generated$StyleGuide$Examples$dropdownExampleWithInput,
									G1: $author$project$Pages$StyleGuide$Dropdown$exampleWithInput(model)
								})
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Disabled')
									]),
								{
									NN: $author$project$Generated$StyleGuide$Examples$dropdownExampleDisabled,
									G1: $author$project$Pages$StyleGuide$Dropdown$exampleDisabled(model)
								})
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Readonly')
									]),
								{
									NN: $author$project$Generated$StyleGuide$Examples$dropdownExampleReadonly,
									G1: $author$project$Pages$StyleGuide$Dropdown$exampleReadonly(model)
								})
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('With Errors')
									]),
								{
									NN: $author$project$Generated$StyleGuide$Examples$dropdownExampleWithErrors,
									G1: $author$project$Pages$StyleGuide$Dropdown$exampleWithErrors(model)
								})
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Combobox')
									]),
								{
									NN: $author$project$Generated$StyleGuide$Examples$dropdownExampleWithCombobox,
									G1: $author$project$Pages$StyleGuide$Dropdown$exampleWithCombobox(model)
								})
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('With Links (like navbar)')
									]),
								{
									NN: '-- Links dropdown example',
									G1: $author$project$Pages$StyleGuide$Dropdown$exampleWithLinks(model)
								})
							]))
					]))
			]),
		ac9: 'StyleGuide.Dropdown'
	};
};
var $author$project$Pages$StyleGuide$Dropdown$page = $author$project$Spa$Page$element(
	{ah_: $author$project$Pages$StyleGuide$Dropdown$init, alO: $author$project$Pages$StyleGuide$Dropdown$subscriptions, adT: $author$project$Pages$StyleGuide$Dropdown$update, amo: $author$project$Pages$StyleGuide$Dropdown$view});
var $author$project$Pages$StyleGuide$Element$IStart = 0;
var $author$project$Pages$StyleGuide$Element$JLeft = 0;
var $author$project$Pages$StyleGuide$Element$init = function (_v0) {
	return _Utils_Tuple2(
		{j4: 0, gH: 0},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$StyleGuide$Element$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$StyleGuide$Element$ICenter = 1;
var $author$project$Pages$StyleGuide$Element$IEnd = 2;
var $author$project$Pages$StyleGuide$Element$itemsFromString = function (str) {
	switch (str) {
		case 'center':
			return 1;
		case 'end':
			return 2;
		default:
			return 0;
	}
};
var $author$project$Pages$StyleGuide$Element$JCenter = 1;
var $author$project$Pages$StyleGuide$Element$JRight = 2;
var $author$project$Pages$StyleGuide$Element$JSpaceBetween = 3;
var $author$project$Pages$StyleGuide$Element$justifyFromString = function (str) {
	switch (str) {
		case 'center':
			return 1;
		case 'right':
			return 2;
		case 'space-between':
			return 3;
		default:
			return 0;
	}
};
var $author$project$Pages$StyleGuide$Element$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var str = msg.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						gH: $author$project$Pages$StyleGuide$Element$justifyFromString(str)
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			var str = msg.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						j4: $author$project$Pages$StyleGuide$Element$itemsFromString(str)
					}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Generated$StyleGuide$Examples$elementExampleDivideY = '\n    [ Element.view [ Element.divideY ]\n        [ div [ class "py-3" ] [ text "Row 1" ]\n        , div [ class "py-3" ] [ text "Row 2" ]\n        , div [ class "py-3" ] [ text "Row 3" ]\n        ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$elementExampleGap = '\n    [ div [] [ text "gap" ]\n    , Element.view [ Element.gap ]\n        [ demoBox "A"\n        , demoBox "B"\n        , demoBox "C"\n        ]\n    , div [ class "mt-4" ] [ text "gap2" ]\n    , Element.view [ Element.gap2 ]\n        [ demoBox "A"\n        , demoBox "B"\n        , demoBox "C"\n        ]\n    , div [ class "mt-4" ] [ text "gap4" ]\n    , Element.view [ Element.gap4 ]\n        [ demoBox "A"\n        , demoBox "B"\n        , demoBox "C"\n        ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$elementExampleItems = '\n    [ div [ class "mb-3" ]\n        [ select [ onInput ItemsChanged, class "border p-1 rounded text-sm" ]\n            [ option [ value "start", selected (model.items == IStart) ] [ text "itemsStart" ]\n            , option [ value "center", selected (model.items == ICenter) ] [ text "itemsCenter" ]\n            , option [ value "end", selected (model.items == IEnd) ] [ text "itemsEnd" ]\n            ]\n        ]\n    , Element.view [ Element.gap2, itemsToOption model.items, Element.fullWidth ]\n        [ div [ class "bg-primary-50 p-3 rounded text-center w-16 h-8" ] [ text "A" ]\n        , div [ class "bg-primary-50 p-3 rounded text-center w-16 h-16" ] [ text "B" ]\n        , div [ class "bg-primary-50 p-3 rounded text-center w-16 h-12" ] [ text "C" ]\n        ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$elementExampleJustify = '\n    [ div [ class "mb-3" ]\n        [ select [ onInput JustifyChanged, class "border p-1 rounded text-sm" ]\n            [ option [ value "left", selected (model.justify == JLeft) ] [ text "justifyLeft" ]\n            , option [ value "center", selected (model.justify == JCenter) ] [ text "justifyCenter" ]\n            , option [ value "right", selected (model.justify == JRight) ] [ text "justifyRight" ]\n            , option [ value "space-between", selected (model.justify == JSpaceBetween) ] [ text "spaceBetween" ]\n            ]\n        ]\n    , Element.view [ justifyToOption model.justify, Element.fullWidth ]\n        [ demoBox "A"\n        , demoBox "B"\n        , demoBox "C"\n        ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$elementExampleLayoutCentered = '\n    [ Element.view [ Element.justifyCenter, Element.itemsCenter, Element.gap2 ]\n        [ demoBox "A"\n        , demoBox "B"\n        , demoBox "C"\n        ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$elementExampleLayoutColumn = '\n    [ Element.view [ Element.flexCol, Element.gap2 ]\n        [ div [ class "bg-primary-50 p-3 rounded" ] [ text "Row 1" ]\n        , div [ class "bg-primary-50 p-3 rounded" ] [ text "Row 2" ]\n        , div [ class "bg-primary-50 p-3 rounded" ] [ text "Row 3" ]\n        ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$elementExampleLayoutLeftRight = '\n    [ Element.view [ Element.spaceBetween, Element.itemsCenter, Element.fullWidth ]\n        [ div [] [ text "Label on the left" ]\n        , div [ class "bg-primary-50 p-2 rounded" ] [ text "Action" ]\n        ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$elementExampleMarginBottom = '\n    [ Element.view [ Element.mb2 ]\n        [ div [ class "bg-primary-50 p-2 rounded" ] [ text "mb2" ] ]\n    , Element.view [ Element.mb4 ]\n        [ div [ class "bg-primary-50 p-2 rounded" ] [ text "mb4" ] ]\n    , Element.view [ Element.mb6 ]\n        [ div [ class "bg-primary-50 p-2 rounded" ] [ text "mb6" ] ]\n    , Element.view [ Element.mb8 ]\n        [ div [ class "bg-primary-50 p-2 rounded" ] [ text "mb8" ] ]\n    , div [ class "bg-primary-50 p-2 rounded" ] [ text "next element" ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$elementExampleMarginHorizontal = '\n    [ Element.view [ Element.itemsCenter ]\n        [ div [ class "bg-primary-50 p-2 rounded" ] [ text "base" ]\n        , Element.view [ Element.ml2 ]\n            [ div [ class "bg-primary-50 p-2 rounded" ] [ text "ml2" ] ]\n        , Element.view [ Element.mr4 ]\n            [ div [ class "bg-primary-50 p-2 rounded" ] [ text "mr4" ] ]\n        , div [ class "bg-primary-50 p-2 rounded" ] [ text "next" ]\n        ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$elementExampleMarginTop = '\n    [ div [ class "bg-primary-50 p-2 rounded" ] [ text "first element" ]\n    , Element.view [ Element.mt2 ]\n        [ div [ class "bg-primary-50 p-2 rounded" ] [ text "mt2" ] ]\n    , Element.view [ Element.mt4 ]\n        [ div [ class "bg-primary-50 p-2 rounded" ] [ text "mt4" ] ]\n    , Element.view [ Element.mt8 ]\n        [ div [ class "bg-primary-50 p-2 rounded" ] [ text "mt8" ] ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$elementExampleMaxHeight = '\n    [ Element.view [ Element.maxH72, Element.overflowYAuto ]\n        [ div [ class "bg-primary-50 p-2 rounded" ] [ text "Row 1" ]\n        , div [ class "bg-primary-50 p-2 rounded" ] [ text "Row 2" ]\n        , div [ class "bg-primary-50 p-2 rounded" ] [ text "Row 3" ]\n        , div [ class "bg-primary-50 p-2 rounded" ] [ text "Row 4" ]\n        , div [ class "bg-primary-50 p-2 rounded" ] [ text "Row 5" ]\n        , div [ class "bg-primary-50 p-2 rounded" ] [ text "Row 6" ]\n        ]\n    ]\n    ';
var $author$project$Ui$Element$DivideY = {$: 28};
var $author$project$Ui$Element$divideY = $author$project$Ui$Element$DivideY;
var $author$project$Pages$StyleGuide$Element$exampleDivideY = _List_fromArray(
	[
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$divideY]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('py-3')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Row 1')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('py-3')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Row 2')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('py-3')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Row 3')
					]))
			]))
	]);
var $author$project$Pages$StyleGuide$Element$demoBox = function (label) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('bg-primary-50 p-3 rounded text-center w-16')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(label)
			]));
};
var $author$project$Pages$StyleGuide$Element$exampleGap = _List_fromArray(
	[
		A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('gap')
			])),
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$gap]),
		_List_fromArray(
			[
				$author$project$Pages$StyleGuide$Element$demoBox('A'),
				$author$project$Pages$StyleGuide$Element$demoBox('B'),
				$author$project$Pages$StyleGuide$Element$demoBox('C')
			])),
		A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mt-4')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('gap2')
			])),
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$gap2]),
		_List_fromArray(
			[
				$author$project$Pages$StyleGuide$Element$demoBox('A'),
				$author$project$Pages$StyleGuide$Element$demoBox('B'),
				$author$project$Pages$StyleGuide$Element$demoBox('C')
			])),
		A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mt-4')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('gap4')
			])),
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$gap4]),
		_List_fromArray(
			[
				$author$project$Pages$StyleGuide$Element$demoBox('A'),
				$author$project$Pages$StyleGuide$Element$demoBox('B'),
				$author$project$Pages$StyleGuide$Element$demoBox('C')
			]))
	]);
var $author$project$Pages$StyleGuide$Element$ItemsChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$StyleGuide$Element$itemsToOption = function (items) {
	switch (items) {
		case 0:
			return $author$project$Ui$Element$itemsStart;
		case 1:
			return $author$project$Ui$Element$itemsCenter;
		default:
			return $author$project$Ui$Element$itemsEnd;
	}
};
var $author$project$Pages$StyleGuide$Element$exampleItems = function (model) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mb-3')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$select,
					_List_fromArray(
						[
							$elm$html$Html$Events$onInput($author$project$Pages$StyleGuide$Element$ItemsChanged),
							$elm$html$Html$Attributes$class('border p-1 rounded text-sm')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$option,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$value('start'),
									$elm$html$Html$Attributes$selected(!model.j4)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('itemsStart')
								])),
							A2(
							$elm$html$Html$option,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$value('center'),
									$elm$html$Html$Attributes$selected(model.j4 === 1)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('itemsCenter')
								])),
							A2(
							$elm$html$Html$option,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$value('end'),
									$elm$html$Html$Attributes$selected(model.j4 === 2)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('itemsEnd')
								]))
						]))
				])),
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[
					$author$project$Ui$Element$gap2,
					$author$project$Pages$StyleGuide$Element$itemsToOption(model.j4),
					$author$project$Ui$Element$fullWidth
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bg-primary-50 p-3 rounded text-center w-16 h-8')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('A')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bg-primary-50 p-3 rounded text-center w-16 h-16')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('B')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bg-primary-50 p-3 rounded text-center w-16 h-12')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('C')
						]))
				]))
		]);
};
var $author$project$Pages$StyleGuide$Element$JustifyChanged = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$StyleGuide$Element$justifyToOption = function (justify) {
	switch (justify) {
		case 0:
			return $author$project$Ui$Element$justifyLeft;
		case 1:
			return $author$project$Ui$Element$justifyCenter;
		case 2:
			return $author$project$Ui$Element$justifyRight;
		default:
			return $author$project$Ui$Element$spaceBetween;
	}
};
var $author$project$Pages$StyleGuide$Element$exampleJustify = function (model) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mb-3')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$select,
					_List_fromArray(
						[
							$elm$html$Html$Events$onInput($author$project$Pages$StyleGuide$Element$JustifyChanged),
							$elm$html$Html$Attributes$class('border p-1 rounded text-sm')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$option,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$value('left'),
									$elm$html$Html$Attributes$selected(!model.gH)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('justifyLeft')
								])),
							A2(
							$elm$html$Html$option,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$value('center'),
									$elm$html$Html$Attributes$selected(model.gH === 1)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('justifyCenter')
								])),
							A2(
							$elm$html$Html$option,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$value('right'),
									$elm$html$Html$Attributes$selected(model.gH === 2)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('justifyRight')
								])),
							A2(
							$elm$html$Html$option,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$value('space-between'),
									$elm$html$Html$Attributes$selected(model.gH === 3)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('spaceBetween')
								]))
						]))
				])),
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[
					$author$project$Pages$StyleGuide$Element$justifyToOption(model.gH),
					$author$project$Ui$Element$fullWidth
				]),
			_List_fromArray(
				[
					$author$project$Pages$StyleGuide$Element$demoBox('A'),
					$author$project$Pages$StyleGuide$Element$demoBox('B'),
					$author$project$Pages$StyleGuide$Element$demoBox('C')
				]))
		]);
};
var $author$project$Pages$StyleGuide$Element$exampleLayoutCentered = _List_fromArray(
	[
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
		_List_fromArray(
			[
				$author$project$Pages$StyleGuide$Element$demoBox('A'),
				$author$project$Pages$StyleGuide$Element$demoBox('B'),
				$author$project$Pages$StyleGuide$Element$demoBox('C')
			]))
	]);
var $author$project$Pages$StyleGuide$Element$exampleLayoutColumn = _List_fromArray(
	[
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap2]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bg-primary-50 p-3 rounded')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Row 1')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bg-primary-50 p-3 rounded')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Row 2')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bg-primary-50 p-3 rounded')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Row 3')
					]))
			]))
	]);
var $author$project$Pages$StyleGuide$Element$exampleLayoutLeftRight = _List_fromArray(
	[
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$fullWidth]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Label on the left')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bg-primary-50 p-2 rounded')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Action')
					]))
			]))
	]);
var $author$project$Pages$StyleGuide$Element$exampleMarginBottom = _List_fromArray(
	[
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$mb2]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bg-primary-50 p-2 rounded')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('mb2')
					]))
			])),
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$mb4]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bg-primary-50 p-2 rounded')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('mb4')
					]))
			])),
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$mb6]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bg-primary-50 p-2 rounded')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('mb6')
					]))
			])),
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$mb8]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bg-primary-50 p-2 rounded')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('mb8')
					]))
			])),
		A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('bg-primary-50 p-2 rounded')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('next element')
			]))
	]);
var $author$project$Pages$StyleGuide$Element$exampleMarginHorizontal = _List_fromArray(
	[
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$itemsCenter]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bg-primary-50 p-2 rounded')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('base')
					])),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$ml2]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('bg-primary-50 p-2 rounded')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('ml2')
							]))
					])),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mr4]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('bg-primary-50 p-2 rounded')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('mr4')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bg-primary-50 p-2 rounded')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('next')
					]))
			]))
	]);
var $author$project$Pages$StyleGuide$Element$exampleMarginTop = _List_fromArray(
	[
		A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('bg-primary-50 p-2 rounded')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('first element')
			])),
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$mt2]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bg-primary-50 p-2 rounded')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('mt2')
					]))
			])),
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$mt4]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bg-primary-50 p-2 rounded')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('mt4')
					]))
			])),
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$mt8]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bg-primary-50 p-2 rounded')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('mt8')
					]))
			]))
	]);
var $author$project$Ui$Element$MaxHeight = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Element$maxH72 = $author$project$Ui$Element$MaxHeight('max-h-72');
var $author$project$Ui$Element$OverflowYAuto = {$: 6};
var $author$project$Ui$Element$overflowYAuto = $author$project$Ui$Element$OverflowYAuto;
var $author$project$Pages$StyleGuide$Element$exampleMaxHeight = _List_fromArray(
	[
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$maxH72, $author$project$Ui$Element$overflowYAuto]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bg-primary-50 p-2 rounded')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Row 1')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bg-primary-50 p-2 rounded')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Row 2')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bg-primary-50 p-2 rounded')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Row 3')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bg-primary-50 p-2 rounded')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Row 4')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bg-primary-50 p-2 rounded')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Row 5')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bg-primary-50 p-2 rounded')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Row 6')
					]))
			]))
	]);
var $author$project$Pages$StyleGuide$Element$viewBody = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Components$StyleGuide$Example$view,
				_List_fromArray(
					[
						$author$project$Components$StyleGuide$Example$title('Justify Alignment'),
						$author$project$Components$StyleGuide$Example$description(
						_List_fromArray(
							[
								$elm$html$Html$text('Controls how flex children are distributed along the main axis.')
							]))
					]),
				{
					NN: $author$project$Generated$StyleGuide$Examples$elementExampleJustify,
					G1: $author$project$Pages$StyleGuide$Element$exampleJustify(model)
				}),
				A2(
				$author$project$Components$StyleGuide$Example$view,
				_List_fromArray(
					[
						$author$project$Components$StyleGuide$Example$title('Items Alignment'),
						$author$project$Components$StyleGuide$Example$description(
						_List_fromArray(
							[
								$elm$html$Html$text('Controls how flex children are aligned along the cross axis.')
							]))
					]),
				{
					NN: $author$project$Generated$StyleGuide$Examples$elementExampleItems,
					G1: $author$project$Pages$StyleGuide$Element$exampleItems(model)
				}),
				A2(
				$author$project$Components$StyleGuide$Example$view,
				_List_fromArray(
					[
						$author$project$Components$StyleGuide$Example$title('Margin Bottom')
					]),
				{NN: $author$project$Generated$StyleGuide$Examples$elementExampleMarginBottom, G1: $author$project$Pages$StyleGuide$Element$exampleMarginBottom}),
				A2(
				$author$project$Components$StyleGuide$Example$view,
				_List_fromArray(
					[
						$author$project$Components$StyleGuide$Example$title('Margin Top')
					]),
				{NN: $author$project$Generated$StyleGuide$Examples$elementExampleMarginTop, G1: $author$project$Pages$StyleGuide$Element$exampleMarginTop}),
				A2(
				$author$project$Components$StyleGuide$Example$view,
				_List_fromArray(
					[
						$author$project$Components$StyleGuide$Example$title('Margin Horizontal')
					]),
				{NN: $author$project$Generated$StyleGuide$Examples$elementExampleMarginHorizontal, G1: $author$project$Pages$StyleGuide$Element$exampleMarginHorizontal}),
				A2(
				$author$project$Components$StyleGuide$Example$view,
				_List_fromArray(
					[
						$author$project$Components$StyleGuide$Example$title('Gap')
					]),
				{NN: $author$project$Generated$StyleGuide$Examples$elementExampleGap, G1: $author$project$Pages$StyleGuide$Element$exampleGap}),
				A2(
				$author$project$Components$StyleGuide$Example$view,
				_List_fromArray(
					[
						$author$project$Components$StyleGuide$Example$title('Layout: Left + Right'),
						$author$project$Components$StyleGuide$Example$description(
						_List_fromArray(
							[
								$elm$html$Html$text('Flex row with spaceBetween — label on the left, action on the right.')
							]))
					]),
				{NN: $author$project$Generated$StyleGuide$Examples$elementExampleLayoutLeftRight, G1: $author$project$Pages$StyleGuide$Element$exampleLayoutLeftRight}),
				A2(
				$author$project$Components$StyleGuide$Example$view,
				_List_fromArray(
					[
						$author$project$Components$StyleGuide$Example$title('Layout: Centered'),
						$author$project$Components$StyleGuide$Example$description(
						_List_fromArray(
							[
								$elm$html$Html$text('Flex row centered on both axes.')
							]))
					]),
				{NN: $author$project$Generated$StyleGuide$Examples$elementExampleLayoutCentered, G1: $author$project$Pages$StyleGuide$Element$exampleLayoutCentered}),
				A2(
				$author$project$Components$StyleGuide$Example$view,
				_List_fromArray(
					[
						$author$project$Components$StyleGuide$Example$title('Layout: Column Stack'),
						$author$project$Components$StyleGuide$Example$description(
						_List_fromArray(
							[
								$elm$html$Html$text('Flex column with gap.')
							]))
					]),
				{NN: $author$project$Generated$StyleGuide$Examples$elementExampleLayoutColumn, G1: $author$project$Pages$StyleGuide$Element$exampleLayoutColumn}),
				A2(
				$author$project$Components$StyleGuide$Example$view,
				_List_fromArray(
					[
						$author$project$Components$StyleGuide$Example$title('Row Dividers'),
						$author$project$Components$StyleGuide$Example$description(
						_List_fromArray(
							[
								$elm$html$Html$text('Thin line between each child — used for stacked list rows in cards.')
							]))
					]),
				{NN: $author$project$Generated$StyleGuide$Examples$elementExampleDivideY, G1: $author$project$Pages$StyleGuide$Element$exampleDivideY}),
				A2(
				$author$project$Components$StyleGuide$Example$view,
				_List_fromArray(
					[
						$author$project$Components$StyleGuide$Example$title('Max height with scroll'),
						$author$project$Components$StyleGuide$Example$description(
						_List_fromArray(
							[
								$elm$html$Html$text('maxH72 caps the element at 18rem (288px); combine with overflowYAuto to make overflowing content scroll inside the cap.')
							]))
					]),
				{NN: $author$project$Generated$StyleGuide$Examples$elementExampleMaxHeight, G1: $author$project$Pages$StyleGuide$Element$exampleMaxHeight})
			]));
};
var $author$project$Pages$StyleGuide$Element$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				$author$project$Pages$StyleGuide$Element$viewBody(model)
			]),
		ac9: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$Element$page = $author$project$Spa$Page$element(
	{ah_: $author$project$Pages$StyleGuide$Element$init, alO: $author$project$Pages$StyleGuide$Element$subscriptions, adT: $author$project$Pages$StyleGuide$Element$update, amo: $author$project$Pages$StyleGuide$Element$view});
var $author$project$Pages$StyleGuide$ExportCsv$WithSession = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$StyleGuide$ExportCsv$WithoutSession = {$: 1};
var $author$project$Pages$StyleGuide$ExportCsv$init = F2(
	function (shared, _v0) {
		var _v1 = shared.aa4;
		if (_v1.$ === 3) {
			return _Utils_Tuple3(
				$author$project$Pages$StyleGuide$ExportCsv$WithSession(
					{
						Gv: shared.Gv,
						nD: $author$project$Components$ExportCsv$initForPractice(0),
						pF: $author$project$Components$ExportCsv$initForPractice(1)
					}),
				$elm$core$Platform$Cmd$none,
				_List_Nil);
		} else {
			return _Utils_Tuple3($author$project$Pages$StyleGuide$ExportCsv$WithoutSession, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Pages$StyleGuide$ExportCsv$load = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$StyleGuide$ExportCsv$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$StyleGuide$ExportCsv$ExportCsvMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$StyleGuide$ExportCsv$ReportExportCsvMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$StyleGuide$ExportCsv$subscriptions = function (model) {
	if (!model.$) {
		var record = model.a;
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$StyleGuide$ExportCsv$ExportCsvMsg,
					$author$project$Components$ExportCsv$subscriptions(record.nD)),
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$StyleGuide$ExportCsv$ReportExportCsvMsg,
					$author$project$Components$ExportCsv$subscriptions(record.pF))
				]));
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Pages$StyleGuide$ExportCsv$update = F2(
	function (msg, model) {
		if (model.$ === 1) {
			return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		} else {
			var modelRecord = model.a;
			if (!msg.$) {
				var subMsg = msg.a;
				var _v2 = A3($author$project$Components$ExportCsv$update, modelRecord.Gv, subMsg, modelRecord.nD);
				var exportCsv = _v2.a;
				var subCmd = _v2.b;
				var subOutMsgs = _v2.c;
				return _Utils_Tuple3(
					$author$project$Pages$StyleGuide$ExportCsv$WithSession(
						_Utils_update(
							modelRecord,
							{nD: exportCsv})),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$ExportCsv$ExportCsvMsg, subCmd),
					subOutMsgs);
			} else {
				var subMsg = msg.a;
				var _v3 = A3($author$project$Components$ExportCsv$update, modelRecord.Gv, subMsg, modelRecord.pF);
				var exportCsv = _v3.a;
				var subCmd = _v3.b;
				var subOutMsgs = _v3.c;
				return _Utils_Tuple3(
					$author$project$Pages$StyleGuide$ExportCsv$WithSession(
						_Utils_update(
							modelRecord,
							{pF: exportCsv})),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$ExportCsv$ReportExportCsvMsg, subCmd),
					subOutMsgs);
			}
		}
	});
var $author$project$Pages$StyleGuide$ExportCsv$viewBody = function (model) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$map,
			$author$project$Pages$StyleGuide$ExportCsv$ExportCsvMsg,
			A3(
				$author$project$Components$ExportCsv$modal,
				model.Gv,
				_List_fromArray(
					[
						$author$project$Components$ExportCsv$params(
						_List_fromArray(
							[
								A2($author$project$Api$Param$string, 'practitioner', 'pct-26sCCZ8P7PQC')
							])),
						$author$project$Components$ExportCsv$path($author$project$Api$Provider$Patient$patientsPath),
						$author$project$Components$ExportCsv$filter('current_membership')
					]),
				model.nD)),
			A2(
			$elm$html$Html$map,
			$author$project$Pages$StyleGuide$ExportCsv$ReportExportCsvMsg,
			A3(
				$author$project$Components$ExportCsv$modal,
				model.Gv,
				_List_fromArray(
					[
						$author$project$Components$ExportCsv$report(
						$elm$core$Maybe$Just(100)),
						$author$project$Components$ExportCsv$reportParams(
						_List_fromArray(
							[
								A2($author$project$Api$Param$string, 'signup_page', 'spg-5M6rwSEww8Y9')
							]))
					]),
				model.pF)),
			$author$project$Ui$Typography$headingLg(
			_List_fromArray(
				[
					$elm$html$Html$text('Export Csv')
				])),
			$author$project$Ui$Typography$heading(
			_List_fromArray(
				[
					$elm$html$Html$text('Non Report Export')
				])),
			A2($elm$html$Html$map, $author$project$Pages$StyleGuide$ExportCsv$ExportCsvMsg, $author$project$Components$ExportCsv$button),
			$author$project$Ui$Typography$heading(
			_List_fromArray(
				[
					$elm$html$Html$text('Report Export')
				])),
			A2($elm$html$Html$map, $author$project$Pages$StyleGuide$ExportCsv$ReportExportCsvMsg, $author$project$Components$ExportCsv$button)
		]);
};
var $author$project$Pages$StyleGuide$ExportCsv$view = function (model) {
	return {
		fO: function () {
			if (!model.$) {
				var modelRecord = model.a;
				return $author$project$Pages$StyleGuide$ExportCsv$viewBody(modelRecord);
			} else {
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Alert$warning,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('You need to be logged in to view this style guide')
							]))
					]);
			}
		}(),
		ac9: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$ExportCsv$page = $author$project$Spa$Page$application(
	{ah_: $author$project$Pages$StyleGuide$ExportCsv$init, aiq: $author$project$Pages$StyleGuide$ExportCsv$load, k8: $author$project$Pages$StyleGuide$ExportCsv$save, alO: $author$project$Pages$StyleGuide$ExportCsv$subscriptions, adT: $author$project$Pages$StyleGuide$ExportCsv$update, amo: $author$project$Pages$StyleGuide$ExportCsv$view});
var $author$project$Pages$StyleGuide$FileInput$init = function (_v0) {
	return _Utils_Tuple2(
		{zF: _List_Nil},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$StyleGuide$FileInput$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$StyleGuide$FileInput$update = F2(
	function (msg, model) {
		var files = msg;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{zF: files}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$StyleGuide$FileInput$FilesUploaded = $elm$core$Basics$identity;
var $author$project$Pages$StyleGuide$FileInput$viewFile = function (file) {
	return A2(
		$elm$html$Html$li,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$elm$file$File$name(file))
			]));
};
var $author$project$Pages$StyleGuide$FileInput$viewBody = function (_v0) {
	var files = _v0.zF;
	return _List_fromArray(
		[
			$author$project$Ui$Typography$headingLg(
			_List_fromArray(
				[
					$elm$html$Html$text('Form -> Input')
				])),
			$author$project$Ui$Form$File$view(
			_List_fromArray(
				[
					$author$project$Ui$Form$File$onInput($elm$core$Basics$identity)
				])),
			$author$project$Ui$Typography$heading(
			_List_fromArray(
				[
					$elm$html$Html$text('Disabled')
				])),
			$author$project$Ui$Form$File$view(
			_List_fromArray(
				[
					$author$project$Ui$Form$File$disabled(true)
				])),
			$author$project$Ui$Typography$heading(
			_List_fromArray(
				[
					$elm$html$Html$text('Mutiple')
				])),
			$author$project$Ui$Form$File$view(
			_List_fromArray(
				[
					$author$project$Ui$Form$File$multiple(true),
					$author$project$Ui$Form$File$onInput($elm$core$Basics$identity)
				])),
			$author$project$Ui$Typography$heading(
			_List_fromArray(
				[
					$elm$html$Html$text('Allowed types')
				])),
			$author$project$Ui$Form$File$view(
			_List_fromArray(
				[
					$author$project$Ui$Form$File$multiple(true),
					$author$project$Ui$Form$File$accept(1),
					$author$project$Ui$Form$File$accept(0),
					$author$project$Ui$Form$File$onInput($elm$core$Basics$identity)
				])),
			$elm$html$Html$text('Selected: '),
			A2($elm$html$Html$br, _List_Nil, _List_Nil),
			A2(
			$elm$html$Html$ul,
			_List_Nil,
			A2($elm$core$List$map, $author$project$Pages$StyleGuide$FileInput$viewFile, files))
		]);
};
var $author$project$Pages$StyleGuide$FileInput$view = function (model) {
	return {
		fO: $author$project$Pages$StyleGuide$FileInput$viewBody(model),
		ac9: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$FileInput$page = $author$project$Spa$Page$element(
	{ah_: $author$project$Pages$StyleGuide$FileInput$init, alO: $author$project$Pages$StyleGuide$FileInput$subscriptions, adT: $author$project$Pages$StyleGuide$FileInput$update, amo: $author$project$Pages$StyleGuide$FileInput$view});
var $author$project$Pages$StyleGuide$FlyoutMenu$AbsoluteFlyoutMenuMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$StyleGuide$FlyoutMenu$FixedFlyoutMenuMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$StyleGuide$FlyoutMenu$KebabFlyoutMenuMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$FlyoutMenu$Model = $elm$core$Basics$identity;
var $author$project$Ui$FlyoutMenu$init = F2(
	function (id, toMsg) {
		return {ahP: id, Yn: false, al6: toMsg};
	});
var $author$project$Pages$StyleGuide$FlyoutMenu$init = function (_v0) {
	return _Utils_Tuple2(
		{
			l4: A2($author$project$Ui$FlyoutMenu$init, 'absolute-menu', $author$project$Pages$StyleGuide$FlyoutMenu$AbsoluteFlyoutMenuMsg),
			nL: A2($author$project$Ui$FlyoutMenu$init, 'fixed-menu', $author$project$Pages$StyleGuide$FlyoutMenu$FixedFlyoutMenuMsg),
			j6: A2($author$project$Ui$FlyoutMenu$init, 'kebab-menu', $author$project$Pages$StyleGuide$FlyoutMenu$KebabFlyoutMenuMsg)
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Ui$FlyoutMenu$Close = 1;
var $author$project$Ui$FlyoutMenu$decodePressedKey = function (closeMsg) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (key) {
			return (key === 'Escape') ? $elm$json$Json$Decode$succeed(closeMsg) : $elm$json$Json$Decode$fail('ignore');
		},
		A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
};
var $author$project$Ui$FlyoutMenu$subscribeToEscapeKeyPress = function (closeMsg) {
	return $elm$browser$Browser$Events$onKeyDown(
		$author$project$Ui$FlyoutMenu$decodePressedKey(closeMsg));
};
var $author$project$Ui$FlyoutMenu$subscriptions = function (_v0) {
	var open = _v0.Yn;
	var toMsg = _v0.al6;
	var id = _v0.ahP;
	return open ? $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$FlyoutMenu$subscribeToEscapeKeyPress(
				toMsg(1)),
				A2(
				$author$project$Utils$Dom$onOutsideMouseDown,
				toMsg(1),
				id)
			])) : $elm$core$Platform$Sub$none;
};
var $author$project$Pages$StyleGuide$FlyoutMenu$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$FlyoutMenu$subscriptions(model.nL),
				$author$project$Ui$FlyoutMenu$subscriptions(model.l4),
				$author$project$Ui$FlyoutMenu$subscriptions(model.j6)
			]));
};
var $author$project$Ui$FlyoutMenu$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg) {
			case 0:
				return _Utils_update(
					model,
					{Yn: true});
			case 1:
				return _Utils_update(
					model,
					{Yn: false});
			default:
				return _Utils_update(
					model,
					{Yn: false});
		}
	});
var $author$project$Pages$StyleGuide$FlyoutMenu$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var flyoutMenu = A2($author$project$Ui$FlyoutMenu$update, subMsg, model.l4);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{l4: flyoutMenu}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var subMsg = msg.a;
				var flyoutMenu = A2($author$project$Ui$FlyoutMenu$update, subMsg, model.nL);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{nL: flyoutMenu}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var subMsg = msg.a;
				var flyoutMenu = A2($author$project$Ui$FlyoutMenu$update, subMsg, model.j6);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{j6: flyoutMenu}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							j6: A2($author$project$Ui$FlyoutMenu$init, 'kebab-menu', $author$project$Pages$StyleGuide$FlyoutMenu$KebabFlyoutMenuMsg)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Ui$FlyoutMenu$DownLeft = 2;
var $author$project$Ui$FlyoutMenu$Fixed = 0;
var $author$project$Pages$StyleGuide$FlyoutMenu$KebabAction = {$: 3};
var $author$project$Ui$FlyoutMenu$Body = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$FlyoutMenu$body = function (contents) {
	return $author$project$Ui$FlyoutMenu$Body(contents);
};
var $author$project$Ui$FlyoutMenu$Direction = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$FlyoutMenu$direction = $author$project$Ui$FlyoutMenu$Direction;
var $author$project$Ui$FlyoutMenu$Header = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$FlyoutMenu$header = function (contents) {
	return $author$project$Ui$FlyoutMenu$Header(contents);
};
var $author$project$Ui$FlyoutMenu$menuItem = function (options) {
	var clickAttrs = options.ep ? _List_Nil : _List_fromArray(
		[
			$elm$html$Html$Events$onClick(options.IS)
		]);
	return A2(
		$elm$html$Html$button,
		A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$class('flyout-menu__item'),
			A2(
				$elm$core$List$cons,
				A2($elm$html$Html$Attributes$attribute, 'aria-label', options.aih),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$disabled(options.ep),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$type_('button'),
						clickAttrs)))),
		_List_fromArray(
			[
				A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, options.ahO),
				$elm$html$Html$text(options.aih)
			]));
};
var $author$project$Ui$Icon$MoreVert = 112;
var $author$project$Ui$Icon$moreVert = $author$project$Ui$Icon$viewIcon(112);
var $author$project$Ui$FlyoutMenu$Position = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$FlyoutMenu$position = $author$project$Ui$FlyoutMenu$Position;
var $author$project$Ui$FlyoutMenu$title = function (string) {
	return A2(
		$elm$html$Html$h4,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal__title')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(string)
			]));
};
var $author$project$Ui$FlyoutMenu$BlurredOutside = 2;
var $author$project$Ui$FlyoutMenu$Down = 1;
var $author$project$Ui$FlyoutMenu$Open = 0;
var $author$project$Ui$FlyoutMenu$Right = 0;
var $author$project$Ui$FlyoutMenu$UpLeft = 3;
var $author$project$Ui$FlyoutMenu$Absolute = 1;
var $author$project$Ui$FlyoutMenu$defaultOptions = {bv: 0, s9: false, ZP: 1};
var $author$project$Ui$FlyoutMenu$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var pos = option.a;
						return _Utils_update(
							record,
							{ZP: pos});
					case 1:
						var dir = option.a;
						return _Utils_update(
							record,
							{bv: dir});
					default:
						return _Utils_update(
							record,
							{s9: true});
				}
			}),
		$author$project$Ui$FlyoutMenu$defaultOptions,
		options);
};
var $author$project$Ui$FlyoutMenu$viewSection = function (section) {
	if (!section.$) {
		var contents = section.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flyout-menu__header')
				]),
			contents);
	} else {
		var contents = section.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flyout-menu__content')
				]),
			contents);
	}
};
var $author$project$Ui$FlyoutMenu$view = F4(
	function (options, sections, btnOrLink, _v0) {
		var model = _v0;
		var optionsRecord = $author$project$Ui$FlyoutMenu$optionsToRecord(options);
		var displayIfOpen = function (html) {
			return model.Yn ? html : $author$project$Utils$Html$empty;
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('flyout-menu-wrapper', true),
							_Utils_Tuple2('flyout-menu-wrapper--mobile-overlay', optionsRecord.s9)
						])),
					$elm$html$Html$Attributes$id(model.ahP),
					A2(
					$author$project$Utils$Dom$onOutsideBlur,
					model.al6(2),
					model.ahP)
				]),
			_List_fromArray(
				[
					displayIfOpen(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('flyout-menu', true),
										_Utils_Tuple2('flyout-menu--right', !optionsRecord.bv),
										_Utils_Tuple2('flyout-menu--down', optionsRecord.bv === 1),
										_Utils_Tuple2('flyout-menu--down-left', optionsRecord.bv === 2),
										_Utils_Tuple2('flyout-menu--up-left', optionsRecord.bv === 3),
										_Utils_Tuple2('flyout-menu--fixed', !optionsRecord.ZP),
										_Utils_Tuple2('flyout-menu--mobile-overlay', optionsRecord.s9)
									]))
							]),
						A2($elm$core$List$map, $author$project$Ui$FlyoutMenu$viewSection, sections))),
					(optionsRecord.bv === 2) ? $author$project$Utils$Html$empty : displayIfOpen(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flyout-menu__caret')
							]),
						_List_Nil)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							model.al6(0)),
							model.Yn ? A2($elm$html$Html$Attributes$style, 'pointer-events', 'none') : $elm$html$Html$Attributes$class('')
						]),
					_List_fromArray(
						[btnOrLink]))
				]));
	});
var $author$project$Pages$StyleGuide$FlyoutMenu$viewBody = function (model) {
	return _List_fromArray(
		[
			$author$project$Ui$Typography$headingLg(
			_List_fromArray(
				[
					$elm$html$Html$text('Flyout Menu')
				])),
			A2(
			$elm$html$Html$div,
			_List_Nil,
			$elm$core$List$singleton(
				A4(
					$author$project$Ui$FlyoutMenu$view,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$FlyoutMenu$header(
							_List_fromArray(
								[
									$author$project$Ui$FlyoutMenu$title('Example Header')
								])),
							$author$project$Ui$FlyoutMenu$body(
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Menu item 1'},
									_List_fromArray(
										[$author$project$Ui$Button$link]),
									_List_fromArray(
										[
											$elm$html$Html$text('Lorem Ipsum Hello World')
										])),
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Menu item 2'},
									_List_fromArray(
										[$author$project$Ui$Button$link]),
									_List_fromArray(
										[
											$elm$html$Html$text('Ipsum Hello World Lorem')
										])),
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Menu item 3'},
									_List_fromArray(
										[$author$project$Ui$Button$link]),
									_List_fromArray(
										[
											$elm$html$Html$text('Hello World Lorem Ipsum')
										])),
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Menu item 4'},
									_List_fromArray(
										[$author$project$Ui$Button$link]),
									_List_fromArray(
										[
											$elm$html$Html$text('World Lorem Ipsum Hello')
										]))
								]))
						]),
					A3(
						$author$project$Ui$Button$view,
						{mm: 'Open absolute flyout menu'},
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Absolute Flyout Menu')
							])),
					model.l4))),
			A2(
			$elm$html$Html$div,
			_List_Nil,
			$elm$core$List$singleton(
				A4(
					$author$project$Ui$FlyoutMenu$view,
					_List_fromArray(
						[
							$author$project$Ui$FlyoutMenu$position(0)
						]),
					_List_fromArray(
						[
							$author$project$Ui$FlyoutMenu$header(
							_List_fromArray(
								[
									$author$project$Ui$FlyoutMenu$title('Example Header')
								])),
							$author$project$Ui$FlyoutMenu$body(
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Menu item 1'},
									_List_fromArray(
										[$author$project$Ui$Button$link]),
									_List_fromArray(
										[
											$elm$html$Html$text('Lorem Ipsum Hello World')
										])),
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Menu item 2'},
									_List_fromArray(
										[$author$project$Ui$Button$link]),
									_List_fromArray(
										[
											$elm$html$Html$text('Ipsum Hello World Lorem')
										])),
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Menu item 3'},
									_List_fromArray(
										[$author$project$Ui$Button$link]),
									_List_fromArray(
										[
											$elm$html$Html$text('Hello World Lorem Ipsum')
										])),
									A3(
									$author$project$Ui$Button$view,
									{mm: 'Menu item 4'},
									_List_fromArray(
										[$author$project$Ui$Button$link]),
									_List_fromArray(
										[
											$elm$html$Html$text('World Lorem Ipsum Hello')
										]))
								]))
						]),
					A3(
						$author$project$Ui$Button$view,
						{mm: 'Open fixed flyout menu'},
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Fixed Flyout Menu')
							])),
					model.nL))),
			$author$project$Ui$Typography$headingSm(
			_List_fromArray(
				[
					$elm$html$Html$text('Kebab menu (DownLeft)')
				])),
			A2($author$project$Ui$Typography$text, _List_Nil, 'Use this variant when a card\'s header has a 3-dot menu near the right edge. The menu anchors its right edge to the trigger and extends leftward, fits its longest label, and renders without a caret. Each row is FlyoutMenu.menuItem with an optional leading icon.'),
			A2(
			$elm$html$Html$div,
			_List_Nil,
			$elm$core$List$singleton(
				A4(
					$author$project$Ui$FlyoutMenu$view,
					_List_fromArray(
						[
							$author$project$Ui$FlyoutMenu$direction(2)
						]),
					_List_fromArray(
						[
							$author$project$Ui$FlyoutMenu$body(
							_List_fromArray(
								[
									$author$project$Ui$FlyoutMenu$menuItem(
									{ep: false, ahO: $elm$core$Maybe$Nothing, aih: 'Edit', IS: $author$project$Pages$StyleGuide$FlyoutMenu$KebabAction}),
									$author$project$Ui$FlyoutMenu$menuItem(
									{ep: false, ahO: $elm$core$Maybe$Nothing, aih: 'Duplicate', IS: $author$project$Pages$StyleGuide$FlyoutMenu$KebabAction}),
									$author$project$Ui$FlyoutMenu$menuItem(
									{
										ep: false,
										ahO: $elm$core$Maybe$Just(
											$author$project$Ui$Icon$send(_List_Nil)),
										aih: 'Send for Review',
										IS: $author$project$Pages$StyleGuide$FlyoutMenu$KebabAction
									})
								]))
						]),
					A3(
						$author$project$Ui$Button$view,
						{mm: 'More actions'},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$icon($author$project$Ui$Icon$moreVert)
							]),
						_List_Nil),
					model.j6)))
		]);
};
var $author$project$Pages$StyleGuide$FlyoutMenu$view = function (model) {
	return {
		fO: $author$project$Pages$StyleGuide$FlyoutMenu$viewBody(model),
		ac9: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$FlyoutMenu$page = $author$project$Spa$Page$element(
	{ah_: $author$project$Pages$StyleGuide$FlyoutMenu$init, alO: $author$project$Pages$StyleGuide$FlyoutMenu$subscriptions, adT: $author$project$Pages$StyleGuide$FlyoutMenu$update, amo: $author$project$Pages$StyleGuide$FlyoutMenu$view});
var $author$project$Pages$StyleGuide$FormExample$formFieldsInit = {Lj: $elm$core$Maybe$Nothing, Sv: '', VH: ''};
var $author$project$Pages$StyleGuide$FormExample$init = function (_v0) {
	return _Utils_Tuple2(
		{
			SD: $author$project$Utils$Form$init($author$project$Pages$StyleGuide$FormExample$formFieldsInit),
			_r: false
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$StyleGuide$FormExample$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$StyleGuide$FormExample$formFieldsUpdate = F2(
	function (field, form) {
		switch (field.$) {
			case 1:
				var firstName = field.a;
				return _Utils_update(
					form,
					{Sv: firstName});
			case 2:
				var lastName = field.a;
				return _Utils_update(
					form,
					{VH: lastName});
			default:
				var age = field.a;
				return _Utils_update(
					form,
					{Lj: age});
		}
	});
var $author$project$Pages$StyleGuide$FormExample$FirstNameValidation = 0;
var $author$project$Pages$StyleGuide$FormExample$LastNameValidation = 1;
var $author$project$Pages$StyleGuide$FormExample$AgeValidation = 2;
var $author$project$Pages$StyleGuide$FormExample$validateAge = function (form) {
	var _v0 = form.Lj;
	if (_v0.$ === 1) {
		return _List_Nil;
	} else {
		var age = _v0.a;
		return (age < 5) ? _List_fromArray(
			[
				_Utils_Tuple2(2, 'Must be at least 5 years old')
			]) : ((age > 65) ? _List_fromArray(
			[
				_Utils_Tuple2(2, 'Must be younger than 65 years old')
			]) : _List_Nil);
	}
};
var $author$project$Pages$StyleGuide$FormExample$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.Sv;
			},
			_Utils_Tuple2(0, 'Please enter a first name.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.VH;
			},
			_Utils_Tuple2(1, 'Please enter a last name.')),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$StyleGuide$FormExample$validateAge)
		]));
var $author$project$Pages$StyleGuide$FormExample$CompletedSubmit = {$: 2};
var $author$project$Pages$StyleGuide$FormExample$processForm = function (_v0) {
	return A2(
		$elm$core$Task$perform,
		function (_v1) {
			return $author$project$Pages$StyleGuide$FormExample$CompletedSubmit;
		},
		$elm$core$Process$sleep(3000));
};
var $author$project$Pages$StyleGuide$FormExample$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var field = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							SD: A3($author$project$Utils$Form$update, $author$project$Pages$StyleGuide$FormExample$formFieldsUpdate, field, model.SD)
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var _v1 = A2($author$project$Utils$Form$validate, $author$project$Pages$StyleGuide$FormExample$formFieldsValidator, model.SD);
				if (!_v1.$) {
					var _v2 = _v1.a;
					var form = _v2.a;
					var validFormFields = _v2.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{SD: form, _r: true}),
						$author$project$Pages$StyleGuide$FormExample$processForm(validFormFields));
				} else {
					var form = _v1.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{SD: form}),
						$elm$core$Platform$Cmd$none);
				}
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{_r: false}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$StyleGuide$FormExample$Age = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$StyleGuide$FormExample$AttemptedSubmit = {$: 1};
var $author$project$Pages$StyleGuide$FormExample$FirstName = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$StyleGuide$FormExample$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$StyleGuide$FormExample$LastName = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$StyleGuide$FormExample$ageToString = function (maybeInt) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Maybe$map, $elm$core$String$fromInt, maybeInt));
};
var $author$project$Pages$StyleGuide$FormExample$maskAge = F2(
	function (currentAge, nextAgeString) {
		var _v0 = $elm$core$String$toInt(nextAgeString);
		if (_v0.$ === 1) {
			return (nextAgeString === '') ? $elm$core$Maybe$Nothing : currentAge;
		} else {
			var age = _v0.a;
			return $elm$core$Maybe$Just(age);
		}
	});
var $author$project$Pages$StyleGuide$FormExample$viewForm = F2(
	function (processing, form) {
		var _v0 = $author$project$Utils$Form$fields(form);
		var firstName = _v0.Sv;
		var lastName = _v0.VH;
		var age = _v0.Lj;
		return A2(
			$author$project$Ui$Form$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$label('First Name'),
											$author$project$Ui$Form$Group$required(true)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$value(firstName),
													$author$project$Ui$Form$Input$placeholder('Jane'),
													$author$project$Ui$Form$Input$onInput(
													A2($elm$core$Basics$composeL, $author$project$Pages$StyleGuide$FormExample$FormUpdated, $author$project$Pages$StyleGuide$FormExample$FirstName)),
													$author$project$Ui$Form$Input$invalid(
													A2($author$project$Utils$Form$hasValidationErrors, 0, form))
												])),
											$author$project$Utils$FormErrors$view(
											A2($author$project$Utils$Form$validationErrors, 0, form))
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$spanSm(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$label('Last Name'),
											$author$project$Ui$Form$Group$required(true)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$value(lastName),
													$author$project$Ui$Form$Input$placeholder('Doe'),
													$author$project$Ui$Form$Input$onInput(
													A2($elm$core$Basics$composeL, $author$project$Pages$StyleGuide$FormExample$FormUpdated, $author$project$Pages$StyleGuide$FormExample$LastName)),
													$author$project$Ui$Form$Input$invalid(
													A2($author$project$Utils$Form$hasValidationErrors, 1, form))
												])),
											$author$project$Utils$FormErrors$view(
											A2($author$project$Utils$Form$validationErrors, 1, form))
										]))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('Age')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanSm(12)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$value(
													$author$project$Pages$StyleGuide$FormExample$ageToString(age)),
													$author$project$Ui$Form$Input$placeholder('e.g 30'),
													$author$project$Ui$Form$Input$onInput(
													A2(
														$elm$core$Basics$composeL,
														A2($elm$core$Basics$composeL, $author$project$Pages$StyleGuide$FormExample$FormUpdated, $author$project$Pages$StyleGuide$FormExample$Age),
														$author$project$Pages$StyleGuide$FormExample$maskAge(age))),
													$author$project$Ui$Form$Input$invalid(
													A2($author$project$Utils$Form$hasValidationErrors, 2, form))
												])),
											$author$project$Utils$FormErrors$view(
											A2($author$project$Utils$Form$validationErrors, 2, form))
										]))
								]))
						])),
					A3(
					$author$project$Ui$Button$view,
					{mm: 'Submit form'},
					_List_fromArray(
						[
							$author$project$Ui$Button$primary,
							$author$project$Ui$Button$disabled(processing),
							$author$project$Ui$Button$loading(processing),
							$author$project$Ui$Button$onClick($author$project$Pages$StyleGuide$FormExample$AttemptedSubmit)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Submit')
						]))
				]));
	});
var $author$project$Pages$StyleGuide$FormExample$view = function (_v0) {
	var processing = _v0._r;
	var form = _v0.SD;
	return {
		fO: _List_fromArray(
			[
				A2($author$project$Pages$StyleGuide$FormExample$viewForm, processing, form)
			]),
		ac9: 'Form Example'
	};
};
var $author$project$Pages$StyleGuide$FormExample$page = $author$project$Spa$Page$element(
	{ah_: $author$project$Pages$StyleGuide$FormExample$init, alO: $author$project$Pages$StyleGuide$FormExample$subscriptions, adT: $author$project$Pages$StyleGuide$FormExample$update, amo: $author$project$Pages$StyleGuide$FormExample$view});
var $author$project$Pages$StyleGuide$FormGroup$init = function (_v0) {
	return _Utils_Tuple2(
		{Sv: 'Bruce', VH: 'Wayne', J5: false},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$StyleGuide$FormGroup$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$StyleGuide$FormGroup$update = F2(
	function (msg, model) {
		var bool = msg;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{J5: bool}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$StyleGuide$FormGroup$example = function (_v0) {
	var firstName = _v0.Sv;
	var lastName = _v0.VH;
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Name'),
					$author$project$Ui$Form$Group$labelSpanSm(4)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(6)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(firstName),
											$author$project$Ui$Form$Input$placeholder('First')
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(6)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(lastName),
											$author$project$Ui$Form$Input$placeholder('Last')
										]))
								]))
						]))
				]))
		]);
};
var $author$project$Pages$StyleGuide$FormGroup$TermsAcceptedchanged = $elm$core$Basics$identity;
var $author$project$Pages$StyleGuide$FormGroup$exampleCheckbox = function (_v0) {
	var termsAccepted = _v0.J5;
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label(''),
					$author$project$Ui$Form$Group$labelSpanSm(4)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Checkbox$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Checkbox$value(termsAccepted),
							$author$project$Ui$Form$Checkbox$required(true),
							$author$project$Ui$Form$Checkbox$onCheck($elm$core$Basics$identity)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('I agree to Hint Health\'s Terms of Service.')
								]))
						]))
				]))
		]);
};
var $author$project$Pages$StyleGuide$FormGroup$exampleLabelAbove = function (_v0) {
	var firstName = _v0.Sv;
	var lastName = _v0.VH;
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Some label'),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$labelAbove,
					$author$project$Ui$Form$Group$required(true)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(6)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(firstName),
											$author$project$Ui$Form$Input$placeholder('First')
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(6)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(lastName),
											$author$project$Ui$Form$Input$placeholder('Last')
										]))
								]))
						]))
				]))
		]);
};
var $author$project$Pages$StyleGuide$FormGroup$exampleStatic = function (_v0) {
	var firstName = _v0.Sv;
	var lastName = _v0.VH;
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('First Name'),
					$author$project$Ui$Form$Group$labelSpanSm(4)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(firstName)
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Last Name'),
					$author$project$Ui$Form$Group$labelSpanSm(4)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(lastName)
						]))
				]))
		]);
};
var $author$project$Pages$StyleGuide$FormGroup$exampleWithoutLabel = function (_v0) {
	var firstName = _v0.Sv;
	var lastName = _v0.VH;
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Form$Group$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(6)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(firstName),
											$author$project$Ui$Form$Input$placeholder('First')
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(6)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(lastName),
											$author$project$Ui$Form$Input$placeholder('Last')
										]))
								]))
						]))
				]))
		]);
};
var $author$project$Pages$StyleGuide$FormGroup$exampleWithoutLabelButSpaced = function (_v0) {
	var firstName = _v0.Sv;
	var lastName = _v0.VH;
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label(''),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$value(firstName),
							$author$project$Ui$Form$Input$placeholder('First')
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Label'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$value(lastName),
							$author$project$Ui$Form$Input$placeholder('Last Name')
						]))
				]))
		]);
};
var $author$project$Generated$StyleGuide$Examples$formGroupExample = '\n    [ FormGroup.view\n        [ FormGroup.label "Name"\n        , FormGroup.labelSpanSm 4\n        ]\n        [ Grid.row []\n            [ Grid.column [ Grid.span 6 ]\n                [ Input.view\n                    [ Input.value firstName\n                    , Input.placeholder "First"\n                    ]\n                ]\n            , Grid.column [ Grid.span 6 ]\n                [ Input.view\n                    [ Input.value lastName\n                    , Input.placeholder "Last"\n                    ]\n                ]\n            ]\n        ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$formGroupExampleCheckbox = '\n    [ FormGroup.view\n        [ FormGroup.label ""\n        , FormGroup.labelSpanSm 4\n        ]\n        [ Checkbox.view\n            [ Checkbox.value termsAccepted\n            , Checkbox.required True\n            , Checkbox.onCheck TermsAcceptedchanged\n            ]\n            [ strong []\n                [ text "I agree to Hint Health\'s Terms of Service."\n                ]\n            ]\n        ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$formGroupExampleLabelAbove = '\n    [ FormGroup.view\n        [ FormGroup.label "Some label"\n        , FormGroup.labelSpanSm 4\n        , FormGroup.labelAbove\n        , FormGroup.required True\n        ]\n        [ Grid.row []\n            [ Grid.column [ Grid.span 6 ]\n                [ Input.view\n                    [ Input.value firstName\n                    , Input.placeholder "First"\n                    ]\n                ]\n            , Grid.column [ Grid.span 6 ]\n                [ Input.view\n                    [ Input.value lastName\n                    , Input.placeholder "Last"\n                    ]\n                ]\n            ]\n        ]\n    ]\n    ';
var $author$project$Generated$StyleGuide$Examples$formGroupExampleStatic = '\n    [ FormGroup.view\n        [ FormGroup.label "First Name"\n        , FormGroup.labelSpanSm 4\n        ]\n        [ FormStatic.view [] [ text firstName ]\n        ]\n    , FormGroup.view\n        [ FormGroup.label "Last Name"\n        , FormGroup.labelSpanSm 4\n        ]\n        [ FormStatic.view [] [ text lastName ]\n        ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$formGroupExampleWithoutLabel = '\n    [ FormGroup.view\n        []\n        [ Grid.row []\n            [ Grid.column [ Grid.span 6 ]\n                [ Input.view\n                    [ Input.value firstName\n                    , Input.placeholder "First"\n                    ]\n                ]\n            , Grid.column [ Grid.span 6 ]\n                [ Input.view\n                    [ Input.value lastName\n                    , Input.placeholder "Last"\n                    ]\n                ]\n            ]\n        ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$formGroupExampleWithoutLabelButSpaced = '\n    [ FormGroup.view\n        [ FormGroup.label ""\n        , FormGroup.labelSpan 4\n        , FormGroup.inputSpan 8\n        ]\n        [ Input.view\n            [ Input.value firstName\n            , Input.placeholder "First"\n            ]\n        ]\n    , FormGroup.view\n        [ FormGroup.label "Label"\n        , FormGroup.labelSpan 4\n        , FormGroup.inputSpan 8\n        ]\n        [ Input.view\n            [ Input.value lastName\n            , Input.placeholder "Last Name"\n            ]\n        ]\n    ]    ';
var $author$project$Pages$StyleGuide$FormGroup$viewBody = function (model) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Grid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanMd(6)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$StyleGuide$Example$view,
							_List_fromArray(
								[
									$author$project$Components$StyleGuide$Example$title('Form Group')
								]),
							{
								NN: $author$project$Generated$StyleGuide$Examples$formGroupExample,
								G1: $author$project$Pages$StyleGuide$FormGroup$example(model)
							}),
							A2(
							$author$project$Components$StyleGuide$Example$view,
							_List_fromArray(
								[
									$author$project$Components$StyleGuide$Example$title('Form Group with static data'),
									$author$project$Components$StyleGuide$Example$description(
									_List_fromArray(
										[
											$elm$html$Html$text('Inputs and buttons have a certain height that form groups'),
											$elm$html$Html$text(' account for, so they align.'),
											$elm$html$Html$text(' Text, because of having way less height'),
											$elm$html$Html$text(' need to be wrapped inside FormStatic to align.')
										]))
								]),
							{
								NN: $author$project$Generated$StyleGuide$Examples$formGroupExampleStatic,
								G1: $author$project$Pages$StyleGuide$FormGroup$exampleStatic(model)
							}),
							A2(
							$author$project$Components$StyleGuide$Example$view,
							_List_fromArray(
								[
									$author$project$Components$StyleGuide$Example$title('Label above'),
									$author$project$Components$StyleGuide$Example$description(
									_List_fromArray(
										[
											$elm$html$Html$text('Only available in QA')
										]))
								]),
							{
								NN: $author$project$Generated$StyleGuide$Examples$formGroupExampleLabelAbove,
								G1: $author$project$Pages$StyleGuide$FormGroup$exampleLabelAbove(model)
							})
						])),
					A2(
					$author$project$Ui$Grid$column,
					_List_fromArray(
						[
							$author$project$Ui$Grid$spanMd(6)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$StyleGuide$Example$view,
							_List_fromArray(
								[
									$author$project$Components$StyleGuide$Example$title('without label'),
									$author$project$Components$StyleGuide$Example$description(
									_List_fromArray(
										[
											$elm$html$Html$text('Input will take the full width')
										]))
								]),
							{
								NN: $author$project$Generated$StyleGuide$Examples$formGroupExampleWithoutLabel,
								G1: $author$project$Pages$StyleGuide$FormGroup$exampleWithoutLabel(model)
							}),
							A2(
							$author$project$Components$StyleGuide$Example$view,
							_List_fromArray(
								[
									$author$project$Components$StyleGuide$Example$title('without label but with left spacing'),
									$author$project$Components$StyleGuide$Example$description(
									_List_fromArray(
										[
											$elm$html$Html$text('Just set the label as an empty text')
										]))
								]),
							{
								NN: $author$project$Generated$StyleGuide$Examples$formGroupExampleWithoutLabelButSpaced,
								G1: $author$project$Pages$StyleGuide$FormGroup$exampleWithoutLabelButSpaced(model)
							}),
							A2(
							$author$project$Components$StyleGuide$Example$view,
							_List_fromArray(
								[
									$author$project$Components$StyleGuide$Example$title('Checkbox'),
									$author$project$Components$StyleGuide$Example$description(_List_Nil)
								]),
							{
								NN: $author$project$Generated$StyleGuide$Examples$formGroupExampleCheckbox,
								G1: $author$project$Pages$StyleGuide$FormGroup$exampleCheckbox(model)
							})
						]))
				]))
		]);
};
var $author$project$Pages$StyleGuide$FormGroup$view = function (model) {
	return {
		fO: $author$project$Pages$StyleGuide$FormGroup$viewBody(model),
		ac9: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$FormGroup$page = $author$project$Spa$Page$element(
	{ah_: $author$project$Pages$StyleGuide$FormGroup$init, alO: $author$project$Pages$StyleGuide$FormGroup$subscriptions, adT: $author$project$Pages$StyleGuide$FormGroup$update, amo: $author$project$Pages$StyleGuide$FormGroup$view});
var $author$project$Pages$StyleGuide$FormStatic$viewBody = _List_fromArray(
	[
		A2(
		$author$project$Ui$Form$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('field label'),
										$author$project$Ui$Form$Group$labelSpanSm(4),
										$author$project$Ui$Form$Group$inputSpanSm(8)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Static$view,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('value')
											]))
									]))
							]))
					])),
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('phi field label'),
										$author$project$Ui$Form$Group$labelSpanSm(4),
										$author$project$Ui$Form$Group$inputSpanSm(8)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Static$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Static$phi(true)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('phi value')
											]))
									]))
							]))
					]))
			]))
	]);
var $author$project$Pages$StyleGuide$FormStatic$view = function (_v0) {
	return {fO: $author$project$Pages$StyleGuide$FormStatic$viewBody, ac9: 'Style Guide'};
};
var $author$project$Pages$StyleGuide$FormStatic$page = $author$project$Spa$Page$static($author$project$Pages$StyleGuide$FormStatic$view);
var $author$project$Ui$Grid$Hidden = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Grid$hidden = $author$project$Ui$Grid$Hidden(0);
var $author$project$Ui$Grid$Show = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Grid$showMd = $author$project$Ui$Grid$Show(2);
var $author$project$Pages$StyleGuide$Grid$viewGrid = _List_fromArray(
	[
		A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('section')
			]),
		_List_fromArray(
			[
				$author$project$Ui$Typography$headingLg(
				_List_fromArray(
					[
						$elm$html$Html$text('Flex Grid')
					])),
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(3)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center'),
										A2($elm$html$Html$Attributes$style, 'background-color', 'blueviolet'),
										A2($elm$html$Html$Attributes$style, 'height', '3em')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Col 3')
									]))
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(3)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center'),
										A2($elm$html$Html$Attributes$style, 'background-color', 'blueviolet'),
										A2($elm$html$Html$Attributes$style, 'height', '3em')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Col 3')
									]))
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(3)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center'),
										A2($elm$html$Html$Attributes$style, 'background-color', 'blueviolet'),
										A2($elm$html$Html$Attributes$style, 'height', '3em')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Col 3')
									]))
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(3)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center'),
										A2($elm$html$Html$Attributes$style, 'background-color', 'blueviolet'),
										A2($elm$html$Html$Attributes$style, 'height', '3em')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Col 3')
									]))
							]))
					])),
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(6)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center'),
										A2($elm$html$Html$Attributes$style, 'background-color', 'lightblue'),
										A2($elm$html$Html$Attributes$style, 'height', '3em')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Col 6')
									]))
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(6),
								$author$project$Ui$Grid$spanMd(3)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center'),
										A2($elm$html$Html$Attributes$style, 'background-color', 'lightblue'),
										A2($elm$html$Html$Attributes$style, 'height', '3em')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Col 3')
									]))
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(6),
								$author$project$Ui$Grid$spanMd(3)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center'),
										A2($elm$html$Html$Attributes$style, 'background-color', 'lightblue'),
										A2($elm$html$Html$Attributes$style, 'height', '3em')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Col 3')
									]))
							]))
					])),
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(2),
								$author$project$Ui$Grid$span(4)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center'),
										A2($elm$html$Html$Attributes$style, 'background-color', 'cornflowerblue'),
										A2($elm$html$Html$Attributes$style, 'height', '3em')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Col 2')
									]))
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(2),
								$author$project$Ui$Grid$span(4)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center'),
										A2($elm$html$Html$Attributes$style, 'background-color', 'cornflowerblue'),
										A2($elm$html$Html$Attributes$style, 'height', '3em')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Col 2')
									]))
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(2),
								$author$project$Ui$Grid$span(4)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center'),
										A2($elm$html$Html$Attributes$style, 'background-color', 'cornflowerblue'),
										A2($elm$html$Html$Attributes$style, 'height', '3em')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Col 2')
									]))
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(6)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center'),
										A2($elm$html$Html$Attributes$style, 'background-color', 'cornflowerblue'),
										A2($elm$html$Html$Attributes$style, 'height', '3em')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Col 6')
									]))
							]))
					])),
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(6)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center'),
										A2($elm$html$Html$Attributes$style, 'background-color', 'deepskyblue'),
										A2($elm$html$Html$Attributes$style, 'height', '3em')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Col 6')
									]))
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(3)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center'),
										A2($elm$html$Html$Attributes$style, 'background-color', 'deepskyblue'),
										A2($elm$html$Html$Attributes$style, 'height', '3em')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Col 3')
									]))
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(3)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center'),
										A2($elm$html$Html$Attributes$style, 'background-color', 'deepskyblue'),
										A2($elm$html$Html$Attributes$style, 'height', '3em')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Col 3')
									]))
							]))
					])),
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$offset(6),
								$author$project$Ui$Grid$span(3)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center'),
										A2($elm$html$Html$Attributes$style, 'background-color', 'skyblue'),
										A2($elm$html$Html$Attributes$style, 'height', '3em')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Col 3')
									]))
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(3)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center'),
										A2($elm$html$Html$Attributes$style, 'background-color', 'skyblue'),
										A2($elm$html$Html$Attributes$style, 'height', '3em')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Col 3')
									]))
							]))
					])),
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(9),
								$author$project$Ui$Grid$hidden,
								$author$project$Ui$Grid$showMd
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center'),
										A2($elm$html$Html$Attributes$style, 'background-color', 'skyblue'),
										A2($elm$html$Html$Attributes$style, 'height', '3em')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Col 9 Hidden')
									]))
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(3)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center'),
										A2($elm$html$Html$Attributes$style, 'background-color', 'skyblue'),
										A2($elm$html$Html$Attributes$style, 'height', '3em')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Col 3')
									]))
							]))
					])),
				A2(
				$elm$html$Html$h2,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('underline mt-4')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Stretched columns')
					])),
				A2(
				$author$project$Ui$Grid$row,
				_List_fromArray(
					[$author$project$Ui$Grid$rowItemsStretch, $author$project$Ui$Grid$mt4]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(4)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center p-2'),
										A2($elm$html$Html$Attributes$style, 'background-color', 'lightcoral')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('This column has some content.')
									]))
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(4)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center p-2 h-full'),
										A2($elm$html$Html$Attributes$style, 'background-color', 'lightgreen')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('This column\'s content div has `h-full`, allowing its background to fill the stretched column.')
									]))
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$span(4)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center p-2'),
										A2($elm$html$Html$Attributes$style, 'background-color', 'lightblue')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('This column stretches to match the content, but the content\'s background does not fill the height.'),
										$elm$html$Html$text(' It has the most content of the three columns, and will be the primary column that sets the height for the row.')
									]))
							]))
					]))
			]))
	]);
var $author$project$Pages$StyleGuide$Grid$view = function (_v0) {
	return {fO: $author$project$Pages$StyleGuide$Grid$viewGrid, ac9: 'Style Guide'};
};
var $author$project$Pages$StyleGuide$Grid$page = $author$project$Spa$Page$static($author$project$Pages$StyleGuide$Grid$view);
var $author$project$Pages$StyleGuide$HiConfirm$init = function (_v0) {
	return _Utils_Tuple2(
		{xW: true, rH: false, rV: false, rW: false, y1: $elm$core$Maybe$Nothing, zd: $elm$core$Maybe$Nothing, jQ: false, BP: $elm$core$Maybe$Nothing, Ew: $elm$core$Maybe$Nothing, FQ: true, aef: $elm$core$Maybe$Nothing},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$StyleGuide$HiConfirm$HiConfirmClosed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$StyleGuide$HiConfirm$subscriptions = function (model) {
	return model.jQ ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$StyleGuide$HiConfirm$HiConfirmClosed) : $elm$core$Platform$Sub$none;
};
var $author$project$Pages$StyleGuide$HiConfirm$stringToMaybe = function (string) {
	return $elm$core$String$isEmpty(string) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(string);
};
var $author$project$Pages$StyleGuide$HiConfirm$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{jQ: true}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var confirmed = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{rH: confirmed, jQ: false}),
					$elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{rW: true}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var confirmed = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{rV: confirmed, rW: false}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var string = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aef: $author$project$Pages$StyleGuide$HiConfirm$stringToMaybe(string)
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var string = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							BP: $author$project$Pages$StyleGuide$HiConfirm$stringToMaybe(string)
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var string = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							y1: $author$project$Pages$StyleGuide$HiConfirm$stringToMaybe(string)
						}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var string = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							zd: $author$project$Pages$StyleGuide$HiConfirm$stringToMaybe(string)
						}),
					$elm$core$Platform$Cmd$none);
			case 9:
				var string = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							Ew: $author$project$Pages$StyleGuide$HiConfirm$stringToMaybe(string)
						}),
					$elm$core$Platform$Cmd$none);
			case 10:
				var bool = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{FQ: bool}),
					$elm$core$Platform$Cmd$none);
			case 11:
				var bool = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{xW: bool}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{rH: false, rV: false}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$StyleGuide$HiConfirm$OpenHiConfirm = {$: 0};
var $author$project$Pages$StyleGuide$HiConfirm$Reset = {$: 4};
var $author$project$Pages$StyleGuide$HiConfirm$CenterTextChanged = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$StyleGuide$HiConfirm$CustomHiConfirmClosed = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$StyleGuide$HiConfirm$CustomMessageChanged = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$StyleGuide$HiConfirm$DetailChanged = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$StyleGuide$HiConfirm$NounChanged = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$StyleGuide$HiConfirm$OpenCustomHiConfirm = {$: 2};
var $author$project$Pages$StyleGuide$HiConfirm$SentenceChanged = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$StyleGuide$HiConfirm$TitleizeNounChanged = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$StyleGuide$HiConfirm$VerbChanged = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$StyleGuide$HiConfirm$viewCustom = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				function () {
				if (model.rW) {
					var customOptions = A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								A2($elm$core$Maybe$map, $author$project$Components$HiConfirm$verb, model.aef),
								A2($elm$core$Maybe$map, $author$project$Components$HiConfirm$noun, model.BP),
								A2(
								$elm$core$Maybe$map,
								function (customMessage) {
									return $author$project$Components$HiConfirm$customMessage(
										_List_fromArray(
											[
												$elm$html$Html$text(customMessage)
											]));
								},
								model.y1),
								A2($elm$core$Maybe$map, $author$project$Components$HiConfirm$detail, model.zd),
								A2($elm$core$Maybe$map, $author$project$Components$HiConfirm$sentence, model.Ew),
								$elm$core$Maybe$Just(
								$author$project$Components$HiConfirm$titleizeNoun(model.FQ)),
								$elm$core$Maybe$Just(
								$author$project$Components$HiConfirm$centerText(model.xW))
							]));
					return A2($author$project$Components$HiConfirm$modal, $author$project$Pages$StyleGuide$HiConfirm$CustomHiConfirmClosed, customOptions);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				$author$project$Ui$Typography$heading(
				_List_fromArray(
					[
						$elm$html$Html$text('Customize')
					])),
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$placeholder('Verb'),
						$author$project$Ui$Form$Input$value(
						A2($elm$core$Maybe$withDefault, '', model.aef)),
						$author$project$Ui$Form$Input$onInput($author$project$Pages$StyleGuide$HiConfirm$VerbChanged)
					])),
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$placeholder('Noun'),
						$author$project$Ui$Form$Input$value(
						A2($elm$core$Maybe$withDefault, '', model.BP)),
						$author$project$Ui$Form$Input$onInput($author$project$Pages$StyleGuide$HiConfirm$NounChanged)
					])),
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$placeholder('Custom Message'),
						$author$project$Ui$Form$Input$value(
						A2($elm$core$Maybe$withDefault, '', model.y1)),
						$author$project$Ui$Form$Input$onInput($author$project$Pages$StyleGuide$HiConfirm$CustomMessageChanged)
					])),
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$placeholder('Detail'),
						$author$project$Ui$Form$Input$value(
						A2($elm$core$Maybe$withDefault, '', model.zd)),
						$author$project$Ui$Form$Input$onInput($author$project$Pages$StyleGuide$HiConfirm$DetailChanged)
					])),
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$placeholder('Sentence'),
						$author$project$Ui$Form$Input$value(
						A2($elm$core$Maybe$withDefault, '', model.Ew)),
						$author$project$Ui$Form$Input$onInput($author$project$Pages$StyleGuide$HiConfirm$SentenceChanged)
					])),
				A2(
				$author$project$Ui$Form$Checkbox$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Checkbox$value(model.FQ),
						$author$project$Ui$Form$Checkbox$onCheck($author$project$Pages$StyleGuide$HiConfirm$TitleizeNounChanged)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Titleize Noun')
					])),
				A2(
				$author$project$Ui$Form$Checkbox$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Checkbox$value(model.xW),
						$author$project$Ui$Form$Checkbox$onCheck($author$project$Pages$StyleGuide$HiConfirm$CenterTextChanged)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Center text')
					])),
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Open custom confirmation dialog'},
				_List_fromArray(
					[
						$author$project$Ui$Button$onClick($author$project$Pages$StyleGuide$HiConfirm$OpenCustomHiConfirm)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Custom Confirm?')
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						'Confirmed: ' + (model.rV ? 'Yes' : 'No'))
					]))
			]));
};
var $author$project$Pages$StyleGuide$HiConfirm$viewBody = function (model) {
	return _List_fromArray(
		[
			model.jQ ? A2($author$project$Components$HiConfirm$modal, $author$project$Pages$StyleGuide$HiConfirm$HiConfirmClosed, _List_Nil) : $author$project$Utils$Html$empty,
			$author$project$Ui$Typography$headingLg(
			_List_fromArray(
				[
					$elm$html$Html$text('Hi Confirm')
				])),
			$author$project$Ui$Typography$heading(
			_List_fromArray(
				[
					$elm$html$Html$text('Default')
				])),
			A3(
			$author$project$Ui$Button$view,
			{mm: 'Open confirmation dialog'},
			_List_fromArray(
				[
					$author$project$Ui$Button$onClick($author$project$Pages$StyleGuide$HiConfirm$OpenHiConfirm)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Confirm?')
				])),
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					'Confirmed: ' + (model.rH ? 'Yes' : 'No'))
				])),
			$author$project$Pages$StyleGuide$HiConfirm$viewCustom(model),
			A3(
			$author$project$Ui$Button$view,
			{mm: 'Reset form'},
			_List_fromArray(
				[
					$author$project$Ui$Button$onClick($author$project$Pages$StyleGuide$HiConfirm$Reset)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Reset')
				]))
		]);
};
var $author$project$Pages$StyleGuide$HiConfirm$view = function (model) {
	return {
		fO: $author$project$Pages$StyleGuide$HiConfirm$viewBody(model),
		ac9: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$HiConfirm$page = $author$project$Spa$Page$element(
	{ah_: $author$project$Pages$StyleGuide$HiConfirm$init, alO: $author$project$Pages$StyleGuide$HiConfirm$subscriptions, adT: $author$project$Pages$StyleGuide$HiConfirm$update, amo: $author$project$Pages$StyleGuide$HiConfirm$view});
var $author$project$Pages$StyleGuide$HorizontalRule$view = function (_v0) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Typography$headingLg(
								_List_fromArray(
									[
										$elm$html$Html$text('Default')
									])),
								$author$project$Ui$HorizontalRule$view(_List_Nil),
								$author$project$Ui$Typography$headingLg(
								_List_fromArray(
									[
										$elm$html$Html$text('Thin')
									])),
								$author$project$Ui$HorizontalRule$view(
								_List_fromArray(
									[$author$project$Ui$HorizontalRule$thin])),
								$author$project$Ui$Typography$headingLg(
								_List_fromArray(
									[
										$elm$html$Html$text('Minimal')
									])),
								$author$project$Ui$HorizontalRule$view(
								_List_fromArray(
									[$author$project$Ui$HorizontalRule$minimal]))
							]))
					]))
			]),
		ac9: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$HorizontalRule$page = $author$project$Spa$Page$static($author$project$Pages$StyleGuide$HorizontalRule$view);
var $author$project$Pages$StyleGuide$Icon$init = function (_v0) {
	return _Utils_Tuple2(
		{iL: '#000', aly: _List_Nil},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$StyleGuide$Icon$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$StyleGuide$Icon$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var color = msg.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{iL: color}),
				$elm$core$Platform$Cmd$none);
		} else {
			var sizeStr = msg.a;
			var size = function () {
				switch (sizeStr) {
					case 'xs':
						return _List_fromArray(
							[$author$project$Ui$Icon$xs]);
					case 'sm':
						return _List_fromArray(
							[$author$project$Ui$Icon$sm]);
					case 'lg':
						return _List_fromArray(
							[$author$project$Ui$Icon$lg]);
					default:
						return _List_Nil;
				}
			}();
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{aly: size}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$StyleGuide$Icon$ColorChanged = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$StyleGuide$Icon$SizeChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Icon$Account = 3;
var $author$project$Ui$Icon$AccountAndPricing = 28;
var $author$project$Ui$Icon$Admin = 4;
var $author$project$Ui$Icon$ApiKey = 86;
var $author$project$Ui$Icon$Bank = 114;
var $author$project$Ui$Icon$BurgerMenu = 29;
var $author$project$Ui$Icon$BurgerMenuClose = 30;
var $author$project$Ui$Icon$Card = 115;
var $author$project$Ui$Icon$Chatbox = 111;
var $author$project$Ui$Icon$Commissions = 6;
var $author$project$Ui$Icon$Contact = 80;
var $author$project$Ui$Icon$Dashboard = 77;
var $author$project$Ui$Icon$Demography = 101;
var $author$project$Ui$Icon$Dev = 102;
var $author$project$Ui$Icon$EmployeeUploads = 25;
var $author$project$Ui$Icon$Employees = 24;
var $author$project$Ui$Icon$Enter = 16;
var $author$project$Ui$Icon$Envelope = 108;
var $author$project$Ui$Icon$FlagFilled = 45;
var $author$project$Ui$Icon$Form = 81;
var $author$project$Ui$Icon$HintHeartFlat = 33;
var $author$project$Ui$Icon$Inbox = 79;
var $author$project$Ui$Icon$Inventory = 82;
var $author$project$Ui$Icon$Invoices = 26;
var $author$project$Ui$Icon$KebabMenu = 20;
var $author$project$Ui$Icon$Open = 18;
var $author$project$Ui$Icon$Patients = 8;
var $author$project$Ui$Icon$PaymentMethods = 23;
var $author$project$Ui$Icon$Phone = 107;
var $author$project$Ui$Icon$Pin = 109;
var $author$project$Ui$Icon$Report = 9;
var $author$project$Ui$Icon$Search = 41;
var $author$project$Ui$Icon$SelectArrows = 17;
var $author$project$Ui$Icon$Share = 10;
var $author$project$Ui$Icon$Shield = 110;
var $author$project$Ui$Icon$Webhook = 87;
var $author$project$Pages$StyleGuide$Icon$allIcons = _List_fromArray(
	[3, 28, 38, 4, 5, 65, 64, 66, 29, 30, 59, 47, 12, 13, 6, 15, 50, 68, 42, 56, 62, 63, 39, 25, 24, 16, 53, 44, 45, 7, 31, 32, 33, 57, 106, 26, 20, 21, 14, 27, 18, 19, 8, 23, 46, 9, 41, 17, 37, 10, 34, 35, 36, 11, 61, 1, 0, 51, 69, 71, 70, 2, 52, 58, 113, 67, 72, 73, 74, 75, 77, 79, 80, 81, 82, 85, 86, 87, 93, 94, 95, 89, 101, 102, 48, 78, 104, 105, 54, 55, 49, 60, 22, 90, 84, 83, 107, 108, 109, 110, 111, 112, 114, 115]);
var $author$project$Pages$StyleGuide$Icon$exampleCircled = _List_fromArray(
	[
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$gap4, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mb2]),
		_List_fromArray(
			[
				$author$project$Ui$Icon$check(
				_List_fromArray(
					[$author$project$Ui$Icon$circled, $author$project$Ui$Icon$success])),
				$elm$html$Html$text('Success')
			])),
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$gap4, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mb2]),
		_List_fromArray(
			[
				$author$project$Ui$Icon$cross(
				_List_fromArray(
					[$author$project$Ui$Icon$circled, $author$project$Ui$Icon$danger])),
				$elm$html$Html$text('Danger')
			])),
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$gap4, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mb2]),
		_List_fromArray(
			[
				$author$project$Ui$Icon$alert(
				_List_fromArray(
					[$author$project$Ui$Icon$circled, $author$project$Ui$Icon$info])),
				$elm$html$Html$text('Info')
			])),
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$gap4, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mb2]),
		_List_fromArray(
			[
				$author$project$Ui$Icon$circle(
				_List_fromArray(
					[$author$project$Ui$Icon$info, $author$project$Ui$Icon$xl])),
				$elm$html$Html$text('Incomplete')
			]))
	]);
var $author$project$Pages$StyleGuide$Icon$exampleCircledSizes = _List_fromArray(
	[
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$gap4, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mb2]),
		_List_fromArray(
			[
				$author$project$Ui$Icon$check(
				_List_fromArray(
					[$author$project$Ui$Icon$circled, $author$project$Ui$Icon$success, $author$project$Ui$Icon$xs])),
				$elm$html$Html$text('Extra Small')
			])),
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$gap4, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mb2]),
		_List_fromArray(
			[
				$author$project$Ui$Icon$check(
				_List_fromArray(
					[$author$project$Ui$Icon$circled, $author$project$Ui$Icon$success, $author$project$Ui$Icon$sm])),
				$elm$html$Html$text('Small')
			])),
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$gap4, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mb2]),
		_List_fromArray(
			[
				$author$project$Ui$Icon$check(
				_List_fromArray(
					[$author$project$Ui$Icon$circled, $author$project$Ui$Icon$success])),
				$elm$html$Html$text('Default')
			])),
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$gap4, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mb2]),
		_List_fromArray(
			[
				$author$project$Ui$Icon$check(
				_List_fromArray(
					[$author$project$Ui$Icon$circled, $author$project$Ui$Icon$success, $author$project$Ui$Icon$lg])),
				$elm$html$Html$text('Large')
			])),
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$gap4, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mb2]),
		_List_fromArray(
			[
				$author$project$Ui$Icon$check(
				_List_fromArray(
					[$author$project$Ui$Icon$circled, $author$project$Ui$Icon$success, $author$project$Ui$Icon$xl])),
				$elm$html$Html$text('Extra Large')
			]))
	]);
var $author$project$Ui$Icon$account = $author$project$Ui$Icon$viewIcon(3);
var $author$project$Ui$Icon$accountAndPricing = $author$project$Ui$Icon$viewIcon(28);
var $author$project$Ui$Icon$admin = $author$project$Ui$Icon$viewIcon(4);
var $author$project$Ui$Icon$apiKey = $author$project$Ui$Icon$viewIcon(86);
var $author$project$Ui$Icon$bank = $author$project$Ui$Icon$viewIcon(114);
var $author$project$Ui$Icon$Book = 97;
var $author$project$Ui$Icon$book = $author$project$Ui$Icon$viewIcon(97);
var $author$project$Ui$Icon$Bookmark = 98;
var $author$project$Ui$Icon$bookmark = $author$project$Ui$Icon$viewIcon(98);
var $author$project$Ui$Icon$BookmarkFilled = 99;
var $author$project$Ui$Icon$bookmarkFilled = $author$project$Ui$Icon$viewIcon(99);
var $author$project$Ui$Icon$BookmarkNav = 100;
var $author$project$Ui$Icon$bookmarkNav = $author$project$Ui$Icon$viewIcon(100);
var $author$project$Ui$Icon$burgerMenu = $author$project$Ui$Icon$viewIcon(29);
var $author$project$Ui$Icon$burgerMenuClose = $author$project$Ui$Icon$viewIcon(30);
var $author$project$Ui$Icon$card = $author$project$Ui$Icon$viewIcon(115);
var $author$project$Ui$Icon$chatbox = $author$project$Ui$Icon$viewIcon(111);
var $author$project$Ui$Icon$commissions = $author$project$Ui$Icon$viewIcon(6);
var $author$project$Ui$Icon$contact = $author$project$Ui$Icon$viewIcon(80);
var $author$project$Ui$Icon$dashboard = $author$project$Ui$Icon$viewIcon(77);
var $author$project$Ui$Icon$DeleteOutline = 43;
var $author$project$Ui$Icon$deleteOutline = $author$project$Ui$Icon$viewIcon(43);
var $author$project$Ui$Icon$demography = $author$project$Ui$Icon$viewIcon(101);
var $author$project$Ui$Icon$dev = $author$project$Ui$Icon$viewIcon(102);
var $author$project$Ui$Icon$dollar = $author$project$Ui$Icon$viewIcon(56);
var $author$project$Ui$Icon$EditOutline = 40;
var $author$project$Ui$Icon$editOutline = $author$project$Ui$Icon$viewIcon(40);
var $author$project$Ui$Icon$employeeUploads = $author$project$Ui$Icon$viewIcon(25);
var $author$project$Ui$Icon$employees = $author$project$Ui$Icon$viewIcon(24);
var $author$project$Ui$Icon$enter = $author$project$Ui$Icon$viewIcon(16);
var $author$project$Ui$Icon$envelope = $author$project$Ui$Icon$viewIcon(108);
var $author$project$Ui$Icon$flagFilled = $author$project$Ui$Icon$viewIcon(45);
var $author$project$Ui$Icon$form = $author$project$Ui$Icon$viewIcon(81);
var $author$project$Ui$Icon$Groups = 91;
var $author$project$Ui$Icon$groups = $author$project$Ui$Icon$viewIcon(91);
var $author$project$Ui$Icon$hintHeartFlat = $author$project$Ui$Icon$viewIcon(33);
var $author$project$Ui$Icon$inbox = $author$project$Ui$Icon$viewIcon(79);
var $author$project$Ui$Icon$inventory = $author$project$Ui$Icon$viewIcon(82);
var $author$project$Ui$Icon$invoices = $author$project$Ui$Icon$viewIcon(26);
var $author$project$Ui$Icon$kebabMenu = $author$project$Ui$Icon$viewIcon(20);
var $author$project$Ui$Icon$Marketplace = 96;
var $author$project$Ui$Icon$marketplace = $author$project$Ui$Icon$viewIcon(96);
var $author$project$Ui$Icon$open = $author$project$Ui$Icon$viewIcon(18);
var $author$project$Ui$Icon$patients = $author$project$Ui$Icon$viewIcon(8);
var $author$project$Ui$Icon$paymentMethods = $author$project$Ui$Icon$viewIcon(23);
var $author$project$Ui$Icon$phone = $author$project$Ui$Icon$viewIcon(107);
var $author$project$Ui$Icon$pin = $author$project$Ui$Icon$viewIcon(109);
var $author$project$Ui$Icon$Practices = 88;
var $author$project$Ui$Icon$practices = $author$project$Ui$Icon$viewIcon(88);
var $author$project$Ui$Icon$quote = $author$project$Ui$Icon$viewIcon(103);
var $author$project$Ui$Icon$report = $author$project$Ui$Icon$viewIcon(9);
var $author$project$Ui$Icon$Sandbox = 92;
var $author$project$Ui$Icon$sandbox = $author$project$Ui$Icon$viewIcon(92);
var $author$project$Ui$Icon$scissors = $author$project$Ui$Icon$viewIcon(72);
var $author$project$Ui$Icon$search = $author$project$Ui$Icon$viewIcon(41);
var $author$project$Ui$Icon$selectArrows = $author$project$Ui$Icon$viewIcon(17);
var $author$project$Ui$Icon$share = $author$project$Ui$Icon$viewIcon(10);
var $author$project$Ui$Icon$shield = $author$project$Ui$Icon$viewIcon(110);
var $author$project$Ui$Icon$sort = $author$project$Ui$Icon$viewIcon(34);
var $author$project$Ui$Icon$sortDown = $author$project$Ui$Icon$viewIcon(35);
var $author$project$Ui$Icon$sortUp = $author$project$Ui$Icon$viewIcon(36);
var $author$project$Ui$Icon$sponsors = $author$project$Ui$Icon$viewIcon(11);
var $author$project$Ui$Icon$star = $author$project$Ui$Icon$viewIcon(73);
var $author$project$Ui$Icon$starNote = $author$project$Ui$Icon$viewIcon(74);
var $author$project$Ui$Icon$webhook = $author$project$Ui$Icon$viewIcon(87);
var $author$project$Pages$StyleGuide$Icon$iconNameToFunctionAndName = function (icon) {
	switch (icon) {
		case 0:
			return _Utils_Tuple2($author$project$Ui$Icon$syncedTo, 'syncedTo');
		case 1:
			return _Utils_Tuple2($author$project$Ui$Icon$syncedFrom, 'syncedFrom');
		case 2:
			return _Utils_Tuple2($author$project$Ui$Icon$unpublishedRuleArrow, 'unpublishedRuleArrow');
		case 3:
			return _Utils_Tuple2($author$project$Ui$Icon$account, 'account');
		case 4:
			return _Utils_Tuple2($author$project$Ui$Icon$admin, 'admin');
		case 6:
			return _Utils_Tuple2($author$project$Ui$Icon$commissions, 'commissions');
		case 7:
			return _Utils_Tuple2($author$project$Ui$Icon$help, 'help');
		case 8:
			return _Utils_Tuple2($author$project$Ui$Icon$patients, 'patients');
		case 9:
			return _Utils_Tuple2($author$project$Ui$Icon$report, 'report');
		case 10:
			return _Utils_Tuple2($author$project$Ui$Icon$share, 'share');
		case 11:
			return _Utils_Tuple2($author$project$Ui$Icon$sponsors, 'sponsors');
		case 12:
			return _Utils_Tuple2($author$project$Ui$Icon$chevron, 'chevron');
		case 13:
			return _Utils_Tuple2($author$project$Ui$Icon$chevronDown, 'chevronDown');
		case 14:
			return _Utils_Tuple2($author$project$Ui$Icon$location, 'location');
		case 15:
			return _Utils_Tuple2($author$project$Ui$Icon$copy, 'copy');
		case 16:
			return _Utils_Tuple2($author$project$Ui$Icon$enter, 'enter');
		case 17:
			return _Utils_Tuple2($author$project$Ui$Icon$selectArrows, 'selectArrows');
		case 18:
			return _Utils_Tuple2($author$project$Ui$Icon$open, 'open');
		case 19:
			return _Utils_Tuple2($author$project$Ui$Icon$openInFull, 'openInFull');
		case 20:
			return _Utils_Tuple2($author$project$Ui$Icon$kebabMenu, 'kebabMenu');
		case 21:
			return _Utils_Tuple2($author$project$Ui$Icon$launch, 'launch');
		case 23:
			return _Utils_Tuple2($author$project$Ui$Icon$paymentMethods, 'paymentMethods');
		case 24:
			return _Utils_Tuple2($author$project$Ui$Icon$employees, 'employees');
		case 25:
			return _Utils_Tuple2($author$project$Ui$Icon$employeeUploads, 'employeeUploads');
		case 26:
			return _Utils_Tuple2($author$project$Ui$Icon$invoices, 'invoices');
		case 27:
			return _Utils_Tuple2($author$project$Ui$Icon$onlineSignup, 'onlineSignup');
		case 28:
			return _Utils_Tuple2($author$project$Ui$Icon$accountAndPricing, 'accountPricing');
		case 29:
			return _Utils_Tuple2($author$project$Ui$Icon$burgerMenu, 'burgerMenu');
		case 30:
			return _Utils_Tuple2($author$project$Ui$Icon$burgerMenuClose, 'burgerMenuClose');
		case 32:
			return _Utils_Tuple2($author$project$Ui$Icon$hintHeart, 'hintHeart');
		case 33:
			return _Utils_Tuple2($author$project$Ui$Icon$hintHeartFlat, 'hintHeartFlat');
		case 31:
			return _Utils_Tuple2($author$project$Ui$Icon$hint404, 'hint404');
		case 34:
			return _Utils_Tuple2($author$project$Ui$Icon$sort, 'sort');
		case 35:
			return _Utils_Tuple2($author$project$Ui$Icon$sortDown, 'sortDown');
		case 36:
			return _Utils_Tuple2($author$project$Ui$Icon$sortUp, 'sortUp');
		case 37:
			return _Utils_Tuple2($author$project$Ui$Icon$send, 'send');
		case 38:
			return _Utils_Tuple2($author$project$Ui$Icon$add, 'add');
		case 39:
			return _Utils_Tuple2($author$project$Ui$Icon$edit, 'edit');
		case 40:
			return _Utils_Tuple2($author$project$Ui$Icon$editOutline, 'editOutline');
		case 41:
			return _Utils_Tuple2($author$project$Ui$Icon$search, 'search');
		case 42:
			return _Utils_Tuple2($author$project$Ui$Icon$delete, 'delete');
		case 43:
			return _Utils_Tuple2($author$project$Ui$Icon$deleteOutline, 'deleteOutline');
		case 44:
			return _Utils_Tuple2($author$project$Ui$Icon$flag, 'flag');
		case 45:
			return _Utils_Tuple2($author$project$Ui$Icon$flagFilled, 'flagFilled');
		case 46:
			return _Utils_Tuple2($author$project$Ui$Icon$repeat, 'repeat');
		case 47:
			return _Utils_Tuple2($author$project$Ui$Icon$check, 'check');
		case 50:
			return _Utils_Tuple2($author$project$Ui$Icon$cross, 'cross');
		case 51:
			return _Utils_Tuple2($author$project$Ui$Icon$transfer, 'transfer');
		case 57:
			return _Utils_Tuple2($author$project$Ui$Icon$history, 'history');
		case 106:
			return _Utils_Tuple2($author$project$Ui$Icon$hourglass, 'hourglass');
		case 113:
			return _Utils_Tuple2($author$project$Ui$Icon$wandStars, 'wandStars');
		case 52:
			return _Utils_Tuple2($author$project$Ui$Icon$upload, 'upload');
		case 53:
			return _Utils_Tuple2($author$project$Ui$Icon$export, 'export');
		case 56:
			return _Utils_Tuple2($author$project$Ui$Icon$dollar, 'dollar');
		case 58:
			return _Utils_Tuple2($author$project$Ui$Icon$void, 'void');
		case 59:
			return _Utils_Tuple2($author$project$Ui$Icon$calendar, 'calendar');
		case 61:
			return _Utils_Tuple2($author$project$Ui$Icon$stop, 'stop');
		case 62:
			return _Utils_Tuple2($author$project$Ui$Icon$dots, 'dots');
		case 63:
			return _Utils_Tuple2($author$project$Ui$Icon$dragIndicator, 'dragIndicator');
		case 64:
			return _Utils_Tuple2($author$project$Ui$Icon$arrowRight, 'arrowRight');
		case 66:
			return _Utils_Tuple2($author$project$Ui$Icon$arrowRightBottom, 'arrowRightBottom');
		case 65:
			return _Utils_Tuple2($author$project$Ui$Icon$arrowLeft, 'arrowLeft');
		case 67:
			return _Utils_Tuple2($author$project$Ui$Icon$warning, 'warning');
		case 5:
			return _Utils_Tuple2($author$project$Ui$Icon$alert, 'alert');
		case 68:
			return _Utils_Tuple2($author$project$Ui$Icon$crossCircle, 'crossCircle');
		case 69:
			return _Utils_Tuple2($author$project$Ui$Icon$translate, 'translate');
		case 71:
			return _Utils_Tuple2($author$project$Ui$Icon$trendingDown, 'trendingDown');
		case 70:
			return _Utils_Tuple2($author$project$Ui$Icon$trendingUp, 'trendingUp');
		case 72:
			return _Utils_Tuple2($author$project$Ui$Icon$scissors, 'scissors');
		case 73:
			return _Utils_Tuple2($author$project$Ui$Icon$star, 'star');
		case 74:
			return _Utils_Tuple2($author$project$Ui$Icon$starNote, 'starNote');
		case 75:
			return _Utils_Tuple2($author$project$Ui$Icon$minus, 'minus');
		case 76:
			return _Utils_Tuple2($author$project$Ui$Icon$testConnection, 'testConnection');
		case 77:
			return _Utils_Tuple2($author$project$Ui$Icon$dashboard, 'dashboard');
		case 79:
			return _Utils_Tuple2($author$project$Ui$Icon$inbox, 'inbox');
		case 80:
			return _Utils_Tuple2($author$project$Ui$Icon$contact, 'contact');
		case 81:
			return _Utils_Tuple2($author$project$Ui$Icon$form, 'form');
		case 82:
			return _Utils_Tuple2($author$project$Ui$Icon$inventory, 'inventory');
		case 85:
			return _Utils_Tuple2($author$project$Ui$Icon$task, 'task');
		case 86:
			return _Utils_Tuple2($author$project$Ui$Icon$apiKey, 'apiKey');
		case 87:
			return _Utils_Tuple2($author$project$Ui$Icon$webhook, 'webhook');
		case 88:
			return _Utils_Tuple2($author$project$Ui$Icon$practices, 'practices');
		case 91:
			return _Utils_Tuple2($author$project$Ui$Icon$groups, 'groups');
		case 92:
			return _Utils_Tuple2($author$project$Ui$Icon$sandbox, 'sandbox');
		case 93:
			return _Utils_Tuple2($author$project$Ui$Icon$package, 'package');
		case 94:
			return _Utils_Tuple2($author$project$Ui$Icon$call, 'call');
		case 95:
			return _Utils_Tuple2($author$project$Ui$Icon$mail, 'mail');
		case 89:
			return _Utils_Tuple2($author$project$Ui$Icon$progressActivity, 'progressActivity');
		case 96:
			return _Utils_Tuple2($author$project$Ui$Icon$marketplace, 'marketplace');
		case 97:
			return _Utils_Tuple2($author$project$Ui$Icon$book, 'book');
		case 98:
			return _Utils_Tuple2($author$project$Ui$Icon$bookmark, 'bookmark');
		case 99:
			return _Utils_Tuple2($author$project$Ui$Icon$bookmarkFilled, 'bookmarkFilled');
		case 100:
			return _Utils_Tuple2($author$project$Ui$Icon$bookmarkNav, 'bookmarkNav');
		case 101:
			return _Utils_Tuple2($author$project$Ui$Icon$demography, 'demography');
		case 102:
			return _Utils_Tuple2($author$project$Ui$Icon$dev, 'dev');
		case 103:
			return _Utils_Tuple2($author$project$Ui$Icon$quote, 'quote');
		case 48:
			return _Utils_Tuple2($author$project$Ui$Icon$circle, 'circle');
		case 78:
			return _Utils_Tuple2($author$project$Ui$Icon$wrench, 'wrench');
		case 104:
			return _Utils_Tuple2($author$project$Ui$Icon$link, 'link');
		case 105:
			return _Utils_Tuple2($author$project$Ui$Icon$eraser, 'eraser');
		case 54:
			return _Utils_Tuple2($author$project$Ui$Icon$visibility, 'visibility');
		case 55:
			return _Utils_Tuple2($author$project$Ui$Icon$visibilityOff, 'visibilityOff');
		case 49:
			return _Utils_Tuple2($author$project$Ui$Icon$bolt, 'bolt');
		case 60:
			return _Utils_Tuple2($author$project$Ui$Icon$cart, 'cart');
		case 22:
			return _Utils_Tuple2($author$project$Ui$Icon$lock, 'lock');
		case 90:
			return _Utils_Tuple2($author$project$Ui$Icon$gift, 'gift');
		case 84:
			return _Utils_Tuple2($author$project$Ui$Icon$increase, 'increase');
		case 83:
			return _Utils_Tuple2($author$project$Ui$Icon$decrease, 'decrease');
		case 107:
			return _Utils_Tuple2($author$project$Ui$Icon$phone, 'phone');
		case 108:
			return _Utils_Tuple2($author$project$Ui$Icon$envelope, 'envelope');
		case 109:
			return _Utils_Tuple2($author$project$Ui$Icon$pin, 'pin');
		case 110:
			return _Utils_Tuple2($author$project$Ui$Icon$shield, 'shield');
		case 111:
			return _Utils_Tuple2($author$project$Ui$Icon$chatbox, 'chatbox');
		case 112:
			return _Utils_Tuple2($author$project$Ui$Icon$moreVert, 'moreVert');
		case 114:
			return _Utils_Tuple2($author$project$Ui$Icon$bank, 'bank');
		default:
			return _Utils_Tuple2($author$project$Ui$Icon$card, 'card');
	}
};
var $author$project$Pages$StyleGuide$Icon$viewIcon = F2(
	function (sizeOptions, name) {
		var _v0 = $author$project$Pages$StyleGuide$Icon$iconNameToFunctionAndName(name);
		var viewIconFn = _v0.a;
		var functionName = _v0.b;
		return A2(
			$author$project$Ui$Grid$column,
			_List_fromArray(
				[
					$author$project$Ui$Grid$span(3),
					$author$project$Ui$Grid$justifyLeft
				]),
			_List_fromArray(
				[
					viewIconFn(sizeOptions),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-base-color mb-8')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Icon.' + functionName)
						]))
				]));
	});
var $author$project$Pages$StyleGuide$Icon$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				$author$project$Ui$Typography$headingLg(
				_List_fromArray(
					[
						$elm$html$Html$text('Icon')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mb-4')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('(Make sure when selecting a new color the SVG icon changes accordingly)'),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('color'),
								$elm$html$Html$Events$onInput($author$project$Pages$StyleGuide$Icon$ColorChanged),
								$elm$html$Html$Attributes$value(model.iL)
							]),
						_List_Nil),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Sorts and Hint404 are extent from this ckeck.')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mb-4')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Size: '),
						A2(
						$elm$html$Html$select,
						_List_fromArray(
							[
								$elm$html$Html$Events$onInput($author$project$Pages$StyleGuide$Icon$SizeChanged)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$option,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$value('base')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('base (default)')
									])),
								A2(
								$elm$html$Html$option,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$value('xs')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('xs')
									])),
								A2(
								$elm$html$Html$option,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$value('sm')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('sm')
									])),
								A2(
								$elm$html$Html$option,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$value('lg')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('lg')
									]))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'color', model.iL)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$row,
						_List_Nil,
						A2(
							$elm$core$List$map,
							$author$project$Pages$StyleGuide$Icon$viewIcon(model.aly),
							$author$project$Pages$StyleGuide$Icon$allIcons))
					])),
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Circled Icons'),
										$author$project$Components$StyleGuide$Example$description(
										_List_fromArray(
											[
												$elm$html$Html$text('Icons with circular backgrounds, useful for status indicators')
											]))
									]),
								{NN: 'Icon.check [ Icon.circled, Icon.success ]\nIcon.cross [ Icon.circled, Icon.danger ]\nIcon.alert [ Icon.circled, Icon.info ]\nIcon.circle [ Icon.info, Icon.xl ]', G1: $author$project$Pages$StyleGuide$Icon$exampleCircled}),
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Circled Icon Sizes')
									]),
								{NN: 'Icon.check [ Icon.circled, Icon.success, Icon.xs ]\nIcon.check [ Icon.circled, Icon.success, Icon.sm ]\nIcon.check [ Icon.circled, Icon.success ]\nIcon.check [ Icon.circled, Icon.success, Icon.lg ]\nIcon.check [ Icon.circled, Icon.success, Icon.xl ]', G1: $author$project$Pages$StyleGuide$Icon$exampleCircledSizes})
							]))
					]))
			]),
		ac9: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$Icon$page = $author$project$Spa$Page$element(
	{ah_: $author$project$Pages$StyleGuide$Icon$init, alO: $author$project$Pages$StyleGuide$Icon$subscriptions, adT: $author$project$Pages$StyleGuide$Icon$update, amo: $author$project$Pages$StyleGuide$Icon$view});
var $author$project$Pages$StyleGuide$Input$init = function (_v0) {
	return {xy: 'Some initial text', r8: '', kE: '', kY: '', Eo: ''};
};
var $author$project$Pages$StyleGuide$Input$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var string = msg.a;
				return _Utils_update(
					model,
					{xy: string});
			case 1:
				var string = msg.a;
				return _Utils_update(
					model,
					{Eo: string});
			case 2:
				var string = msg.a;
				return _Utils_update(
					model,
					{kY: string});
			case 3:
				var string = msg.a;
				return _Utils_update(
					model,
					{r8: string});
			default:
				var string = msg.a;
				return _Utils_update(
					model,
					{kE: string});
		}
	});
var $author$project$Pages$StyleGuide$Input$BaseInputChanged = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$StyleGuide$Input$example = function (model) {
	return _List_fromArray(
		[
			$author$project$Ui$Form$Input$view(
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$value(model.xy),
					$author$project$Ui$Form$Input$onInput($author$project$Pages$StyleGuide$Input$BaseInputChanged)
				]))
		]);
};
var $author$project$Pages$StyleGuide$Input$exampleAddon = _List_fromArray(
	[
		$author$project$Ui$Form$Input$group(
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$addon(
				_List_fromArray(
					[
						$elm$html$Html$text('$')
					])),
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$value('1.000,00')
					]))
			])),
		$author$project$Ui$Form$Input$group(
		A2(
			$author$project$Ui$Form$Input$withPreAddon,
			'$',
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$value('1.000,00')
				]))),
		$author$project$Ui$Form$Input$group(
		A2(
			$author$project$Ui$Form$Input$withPostAddon,
			'%',
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$value('20')
				])))
	]);
var $author$project$Pages$StyleGuide$Input$exampleDisabled = _List_fromArray(
	[
		$author$project$Ui$Form$Input$view(
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$placeholder('Disabled'),
				$author$project$Ui$Form$Input$disabled(true)
			]))
	]);
var $author$project$Pages$StyleGuide$Input$EmailInputchanged = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$StyleGuide$Input$emailValid = function (emailText) {
	return $elm$core$String$isEmpty(emailText) || A2($elm$core$String$contains, '@', emailText);
};
var $author$project$Pages$StyleGuide$Input$exampleEmail = function (model) {
	return _List_fromArray(
		[
			$author$project$Ui$Form$Input$view(
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$placeholder('This is an email'),
					$author$project$Ui$Form$Input$email,
					$author$project$Ui$Form$Input$withFeedback(true),
					$author$project$Ui$Form$Input$value(model.r8),
					$author$project$Ui$Form$Input$invalid(
					!$author$project$Pages$StyleGuide$Input$emailValid(model.r8)),
					$author$project$Ui$Form$Input$onInput($author$project$Pages$StyleGuide$Input$EmailInputchanged)
				]))
		]);
};
var $author$project$Pages$StyleGuide$Input$RequiredInputchanged = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$StyleGuide$Input$exampleFeedback = function (model) {
	return _List_fromArray(
		[
			$author$project$Ui$Form$Input$view(
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$placeholder('This is required with feedback'),
					$author$project$Ui$Form$Input$withFeedback(true),
					$author$project$Ui$Form$Input$value(model.kY),
					$author$project$Ui$Form$Input$invalid(
					$elm$core$String$isEmpty(model.kY)),
					$author$project$Ui$Form$Input$onInput($author$project$Pages$StyleGuide$Input$RequiredInputchanged)
				]))
		]);
};
var $author$project$Pages$StyleGuide$Input$exampleInvalid = function (model) {
	return _List_fromArray(
		[
			$author$project$Ui$Form$Input$view(
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$placeholder('This is required'),
					$author$project$Ui$Form$Input$value(model.kY),
					$author$project$Ui$Form$Input$invalid(
					$elm$core$String$isEmpty(model.kY)),
					$author$project$Ui$Form$Input$onInput($author$project$Pages$StyleGuide$Input$RequiredInputchanged)
				]))
		]);
};
var $author$project$Pages$StyleGuide$Input$SecretInputChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$StyleGuide$Input$examplePassword = function (model) {
	return _List_fromArray(
		[
			$author$project$Ui$Form$Input$view(
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$placeholder('Secret'),
					$author$project$Ui$Form$Input$password,
					$author$project$Ui$Form$Input$value(model.Eo),
					$author$project$Ui$Form$Input$onInput($author$project$Pages$StyleGuide$Input$SecretInputChanged)
				]))
		]);
};
var $author$project$Pages$StyleGuide$Input$PhoneInputchanged = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$StyleGuide$Input$phoneMask = '(###) ###-####';
var $author$project$Pages$StyleGuide$Input$phonePattern = $agustinrhcp$elm_mask$Mask$fromString($author$project$Pages$StyleGuide$Input$phoneMask);
var $author$project$Pages$StyleGuide$Input$phoneIncomplete = function (phoneNumber) {
	var maskedPhone = A2($agustinrhcp$elm_mask$Mask$mask, $author$project$Pages$StyleGuide$Input$phonePattern, phoneNumber);
	return ($elm$core$String$length(maskedPhone) > 0) && (!_Utils_eq(
		$elm$core$String$length($author$project$Pages$StyleGuide$Input$phoneMask),
		$elm$core$String$length(maskedPhone)));
};
var $author$project$Pages$StyleGuide$Input$phoneErrors = function (phoneNumber) {
	return $author$project$Pages$StyleGuide$Input$phoneIncomplete(phoneNumber) ? _List_fromArray(
		['Please enter a valid phone number.']) : _List_Nil;
};
var $author$project$Pages$StyleGuide$Input$phonePlaceholder = A3($elm$core$String$replace, '#', '5', $author$project$Pages$StyleGuide$Input$phoneMask);
var $author$project$Pages$StyleGuide$Input$examplePhone = function (model) {
	return _List_fromArray(
		[
			$author$project$Ui$Form$Input$view(
			_List_fromArray(
				[
					A2($author$project$Ui$Form$Input$maskedValue, $author$project$Pages$StyleGuide$Input$phonePattern, model.kE),
					$author$project$Ui$Form$Input$placeholder($author$project$Pages$StyleGuide$Input$phonePlaceholder),
					A3($author$project$Ui$Form$Input$onMaskedInput, $author$project$Pages$StyleGuide$Input$phonePattern, model.kE, $author$project$Pages$StyleGuide$Input$PhoneInputchanged),
					$author$project$Ui$Form$Input$invalid(
					$author$project$Pages$StyleGuide$Input$phoneIncomplete(model.kE)),
					$author$project$Ui$Form$Input$autoComplete(false),
					$author$project$Ui$Form$Input$phi(true),
					$author$project$Ui$Form$Input$withFeedback(true),
					$author$project$Ui$Form$Input$errors(
					$author$project$Pages$StyleGuide$Input$phoneErrors(model.kE))
				]))
		]);
};
var $author$project$Pages$StyleGuide$Input$exampleWithButton = _List_fromArray(
	[
		$author$project$Ui$Form$Input$group(
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$value('a search string')
					])),
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Search'},
				_List_fromArray(
					[$author$project$Ui$Button$primary]),
				_List_fromArray(
					[
						$elm$html$Html$text('Search')
					]))
			]))
	]);
var $author$project$Generated$StyleGuide$Examples$inputExample = '\n    [ Input.view [ Input.value model.baseText, Input.onInput BaseInputChanged ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$inputExampleAddon = '\n    [ Input.group\n        [ Input.addon [ text "$" ]\n        , Input.view [ Input.value "1.000,00" ]\n        ]\n    , Input.group\n        (Input.withPreAddon "$" [ Input.value "1.000,00" ])\n    , Input.group\n        (Input.withPostAddon "%" [ Input.value "20" ])\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$inputExampleDisabled = '\n    [ Input.view [ Input.placeholder "Disabled", Input.disabled True ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$inputExampleEmail = '\n    [ Input.view\n        [ Input.placeholder "This is an email"\n        , Input.email\n        , Input.withFeedback True\n        , Input.value model.emailText\n        , Input.invalid (not (emailValid model.emailText))\n        , Input.onInput EmailInputchanged\n        ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$inputExampleFeedback = '\n    [ Input.view\n        [ Input.placeholder "This is required with feedback"\n        , Input.withFeedback True\n        , Input.value model.requiredText\n        , Input.invalid (String.isEmpty model.requiredText)\n        , Input.onInput RequiredInputchanged\n        ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$inputExampleInvalid = '\n    [ Input.view [ Input.placeholder "This is required", Input.value model.requiredText, Input.invalid (String.isEmpty model.requiredText), Input.onInput RequiredInputchanged ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$inputExamplePassword = '\n    [ Input.view [ Input.placeholder "Secret", Input.password, Input.value model.secretText, Input.onInput SecretInputChanged ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$inputExamplePhone = '\n    [ Input.view\n        [ Input.maskedValue phonePattern model.phoneText\n        , Input.placeholder phonePlaceholder\n        , Input.onMaskedInput phonePattern model.phoneText PhoneInputchanged\n        , Input.invalid (phoneIncomplete model.phoneText)\n        , Input.autoComplete False\n        , Input.phi True\n        , Input.withFeedback True\n        , Input.errors (phoneErrors model.phoneText)\n        ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$inputExampleWithButton = '\n    [ Input.group\n        [ Input.view [ Input.value "a search string" ]\n        , Button.view { ariaLabel = "Search" } [ Button.primary ] [ text "Search" ]\n        ]\n    ]    ';
var $author$project$Pages$StyleGuide$Input$viewBody = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Typography$headingLg(
				_List_fromArray(
					[
						$elm$html$Html$text('Form > Input')
					])),
				A2(
				$author$project$Components$StyleGuide$Example$view,
				_List_fromArray(
					[
						$author$project$Components$StyleGuide$Example$title('Basic')
					]),
				{
					NN: $author$project$Generated$StyleGuide$Examples$inputExample,
					G1: $author$project$Pages$StyleGuide$Input$example(model)
				}),
				A2(
				$author$project$Components$StyleGuide$Example$view,
				_List_fromArray(
					[
						$author$project$Components$StyleGuide$Example$title('Disabled')
					]),
				{NN: $author$project$Generated$StyleGuide$Examples$inputExampleDisabled, G1: $author$project$Pages$StyleGuide$Input$exampleDisabled}),
				A2(
				$author$project$Components$StyleGuide$Example$view,
				_List_fromArray(
					[
						$author$project$Components$StyleGuide$Example$title('Password')
					]),
				{
					NN: $author$project$Generated$StyleGuide$Examples$inputExamplePassword,
					G1: $author$project$Pages$StyleGuide$Input$examplePassword(model)
				}),
				A2(
				$author$project$Components$StyleGuide$Example$view,
				_List_fromArray(
					[
						$author$project$Components$StyleGuide$Example$title('Invalid')
					]),
				{
					NN: $author$project$Generated$StyleGuide$Examples$inputExampleInvalid,
					G1: $author$project$Pages$StyleGuide$Input$exampleInvalid(model)
				}),
				A2(
				$author$project$Components$StyleGuide$Example$view,
				_List_fromArray(
					[
						$author$project$Components$StyleGuide$Example$title('With Feedback')
					]),
				{
					NN: $author$project$Generated$StyleGuide$Examples$inputExampleFeedback,
					G1: $author$project$Pages$StyleGuide$Input$exampleFeedback(model)
				}),
				A2(
				$author$project$Components$StyleGuide$Example$view,
				_List_fromArray(
					[
						$author$project$Components$StyleGuide$Example$title('Email')
					]),
				{
					NN: $author$project$Generated$StyleGuide$Examples$inputExampleEmail,
					G1: $author$project$Pages$StyleGuide$Input$exampleEmail(model)
				}),
				A2(
				$author$project$Components$StyleGuide$Example$view,
				_List_fromArray(
					[
						$author$project$Components$StyleGuide$Example$title('Phone (Masked)')
					]),
				{
					NN: $author$project$Generated$StyleGuide$Examples$inputExamplePhone,
					G1: $author$project$Pages$StyleGuide$Input$examplePhone(model)
				}),
				A2(
				$author$project$Components$StyleGuide$Example$view,
				_List_fromArray(
					[
						$author$project$Components$StyleGuide$Example$title('Addon')
					]),
				{NN: $author$project$Generated$StyleGuide$Examples$inputExampleAddon, G1: $author$project$Pages$StyleGuide$Input$exampleAddon}),
				A2(
				$author$project$Components$StyleGuide$Example$view,
				_List_fromArray(
					[
						$author$project$Components$StyleGuide$Example$title('With Button')
					]),
				{NN: $author$project$Generated$StyleGuide$Examples$inputExampleWithButton, G1: $author$project$Pages$StyleGuide$Input$exampleWithButton})
			]));
};
var $author$project$Pages$StyleGuide$Input$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				$author$project$Pages$StyleGuide$Input$viewBody(model)
			]),
		ac9: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$Input$page = $author$project$Spa$Page$sandbox(
	{ah_: $author$project$Pages$StyleGuide$Input$init, adT: $author$project$Pages$StyleGuide$Input$update, amo: $author$project$Pages$StyleGuide$Input$view});
var $author$project$Pages$StyleGuide$Link$example = _List_fromArray(
	[
		A3(
		$author$project$Ui$Link$externalHref,
		'http://www.hint.com',
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('External')
			])),
		A3(
		$author$project$Ui$Link$route,
		$author$project$Spa$Generated$Route$StyleGuide__Link,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Internal (Route)')
			])),
		A3(
		$author$project$Ui$Link$externalHref,
		'http://www.hint.com',
		_List_fromArray(
			[$author$project$Ui$Link$underline]),
		_List_fromArray(
			[
				$elm$html$Html$text('Link with underline')
			]))
	]);
var $author$project$Pages$StyleGuide$Link$exampleButton = _List_fromArray(
	[
		A3(
		$author$project$Ui$Link$externalHref,
		'http://www.hint.com',
		_List_fromArray(
			[$author$project$Ui$Link$buttonDefault]),
		_List_fromArray(
			[
				$elm$html$Html$text('Go to Hint')
			])),
		A3(
		$author$project$Ui$Link$externalHref,
		'http://www.hint.com',
		_List_fromArray(
			[$author$project$Ui$Link$buttonPrimary]),
		_List_fromArray(
			[
				$elm$html$Html$text('Go to Hint')
			])),
		A3(
		$author$project$Ui$Link$externalHref,
		'http://www.hint.com',
		_List_fromArray(
			[$author$project$Ui$Link$buttonSecondary]),
		_List_fromArray(
			[
				$elm$html$Html$text('Go to Hint')
			])),
		A3(
		$author$project$Ui$Link$externalHref,
		'http://www.hint.com',
		_List_fromArray(
			[$author$project$Ui$Link$buttonSuccess]),
		_List_fromArray(
			[
				$elm$html$Html$text('Go to Hint')
			])),
		A3(
		$author$project$Ui$Link$externalHref,
		'http://www.hint.com',
		_List_fromArray(
			[$author$project$Ui$Link$buttonWarning]),
		_List_fromArray(
			[
				$elm$html$Html$text('Go to Hint')
			]))
	]);
var $author$project$Ui$Link$Lg = 3;
var $author$project$Ui$Link$lg = $author$project$Ui$Link$Size(3);
var $author$project$Pages$StyleGuide$Link$exampleWithIcon = _List_fromArray(
	[
		A3(
		$author$project$Ui$Link$externalHref,
		'http://www.hint.com',
		_List_fromArray(
			[
				$author$project$Ui$Link$xs,
				$author$project$Ui$Link$icon($author$project$Ui$Icon$flag)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Flag')
			])),
		A3(
		$author$project$Ui$Link$externalHref,
		'http://www.hint.com',
		_List_fromArray(
			[
				$author$project$Ui$Link$sm,
				$author$project$Ui$Link$icon($author$project$Ui$Icon$flag)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Flag')
			])),
		A3(
		$author$project$Ui$Link$externalHref,
		'http://www.hint.com',
		_List_fromArray(
			[
				$author$project$Ui$Link$icon($author$project$Ui$Icon$flag)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Flag')
			])),
		A3(
		$author$project$Ui$Link$externalHref,
		'http://www.hint.com',
		_List_fromArray(
			[
				$author$project$Ui$Link$lg,
				$author$project$Ui$Link$icon($author$project$Ui$Icon$flag)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Flag')
			]))
	]);
var $author$project$Pages$StyleGuide$Link$exampleWithIconOnly = _List_fromArray(
	[
		A3(
		$author$project$Ui$Link$externalHref,
		'http://www.hint.com',
		_List_fromArray(
			[
				$author$project$Ui$Link$buttonSecondary,
				$author$project$Ui$Link$xs,
				$author$project$Ui$Link$icon($author$project$Ui$Icon$flag)
			]),
		_List_Nil),
		A3(
		$author$project$Ui$Link$externalHref,
		'http://www.hint.com',
		_List_fromArray(
			[
				$author$project$Ui$Link$buttonSecondary,
				$author$project$Ui$Link$sm,
				$author$project$Ui$Link$icon($author$project$Ui$Icon$flag)
			]),
		_List_Nil),
		A3(
		$author$project$Ui$Link$externalHref,
		'http://www.hint.com',
		_List_fromArray(
			[
				$author$project$Ui$Link$buttonSecondary,
				$author$project$Ui$Link$icon($author$project$Ui$Icon$flag)
			]),
		_List_Nil),
		A3(
		$author$project$Ui$Link$externalHref,
		'http://www.hint.com',
		_List_fromArray(
			[
				$author$project$Ui$Link$buttonSecondary,
				$author$project$Ui$Link$lg,
				$author$project$Ui$Link$icon($author$project$Ui$Icon$flag)
			]),
		_List_Nil)
	]);
var $author$project$Pages$StyleGuide$Link$exampleWithIconRight = _List_fromArray(
	[
		A3(
		$author$project$Ui$Link$externalHref,
		'http://www.hint.com',
		_List_fromArray(
			[
				$author$project$Ui$Link$xs,
				$author$project$Ui$Link$iconRight($author$project$Ui$Icon$flag)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Flag')
			])),
		A3(
		$author$project$Ui$Link$externalHref,
		'http://www.hint.com',
		_List_fromArray(
			[
				$author$project$Ui$Link$sm,
				$author$project$Ui$Link$iconRight($author$project$Ui$Icon$flag)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Flag')
			])),
		A3(
		$author$project$Ui$Link$externalHref,
		'http://www.hint.com',
		_List_fromArray(
			[
				$author$project$Ui$Link$iconRight($author$project$Ui$Icon$flag)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Flag')
			])),
		A3(
		$author$project$Ui$Link$externalHref,
		'http://www.hint.com',
		_List_fromArray(
			[
				$author$project$Ui$Link$lg,
				$author$project$Ui$Link$iconRight($author$project$Ui$Icon$flag)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Flag')
			]))
	]);
var $author$project$Generated$StyleGuide$Examples$linkExample = '\n    [ Link.externalHref "http://www.hint.com"\n        []\n        [ text "External" ]\n    , Link.route Route.StyleGuide__Link\n        []\n        [ text "Internal (Route)" ]\n    , Link.externalHref "http://www.hint.com"\n        [ Link.underline ]\n        [ text "Link with underline" ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$linkExampleButton = '\n    [ Link.externalHref "http://www.hint.com"\n        [ Link.buttonDefault\n        ]\n        [ text "Go to Hint" ]\n    , Link.externalHref "http://www.hint.com"\n        [ Link.buttonPrimary\n        ]\n        [ text "Go to Hint" ]\n    , Link.externalHref "http://www.hint.com"\n        [ Link.buttonSecondary\n        ]\n        [ text "Go to Hint" ]\n    , Link.externalHref "http://www.hint.com"\n        [ Link.buttonSuccess\n        ]\n        [ text "Go to Hint" ]\n    , Link.externalHref "http://www.hint.com"\n        [ Link.buttonWarning\n        ]\n        [ text "Go to Hint" ]\n    ]\n    ';
var $author$project$Generated$StyleGuide$Examples$linkExampleWithIcon = '\n    [ Link.externalHref "http://www.hint.com"\n        [ Link.xs\n        , Link.icon Icon.flag\n        ]\n        [ text "Flag" ]\n    , Link.externalHref "http://www.hint.com"\n        [ Link.sm\n        , Link.icon Icon.flag\n        ]\n        [ text "Flag" ]\n    , Link.externalHref "http://www.hint.com"\n        [ Link.icon Icon.flag\n        ]\n        [ text "Flag" ]\n    , Link.externalHref "http://www.hint.com"\n        [ Link.lg\n        , Link.icon Icon.flag\n        ]\n        [ text "Flag" ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$linkExampleWithIconOnly = '\n    [ Link.externalHref "http://www.hint.com"\n        [ Link.buttonSecondary\n        , Link.xs\n        , Link.icon Icon.flag\n        ]\n        []\n    , Link.externalHref "http://www.hint.com"\n        [ Link.buttonSecondary\n        , Link.sm\n        , Link.icon Icon.flag\n        ]\n        []\n    , Link.externalHref "http://www.hint.com"\n        [ Link.buttonSecondary\n        , Link.icon Icon.flag\n        ]\n        []\n    , Link.externalHref "http://www.hint.com"\n        [ Link.buttonSecondary\n        , Link.lg\n        , Link.icon Icon.flag\n        ]\n        []\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$linkExampleWithIconRight = '\n    [ Link.externalHref "http://www.hint.com"\n        [ Link.xs\n        , Link.iconRight Icon.flag\n        ]\n        [ text "Flag" ]\n    , Link.externalHref "http://www.hint.com"\n        [ Link.sm\n        , Link.iconRight Icon.flag\n        ]\n        [ text "Flag" ]\n    , Link.externalHref "http://www.hint.com"\n        [ Link.iconRight Icon.flag\n        ]\n        [ text "Flag" ]\n    , Link.externalHref "http://www.hint.com"\n        [ Link.lg\n        , Link.iconRight Icon.flag\n        ]\n        [ text "Flag" ]\n    ]    ';
var $author$project$Pages$StyleGuide$Link$view = function (_v0) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(6)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Link')
									]),
								{NN: $author$project$Generated$StyleGuide$Examples$linkExample, G1: $author$project$Pages$StyleGuide$Link$example}),
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Button options'),
										$author$project$Components$StyleGuide$Example$description(
										_List_fromArray(
											[
												$elm$html$Html$text('Link that look like buttons redirect to a new page. '),
												$elm$html$Html$text('Most common use case should be downloading files')
											]))
									]),
								{NN: $author$project$Generated$StyleGuide$Examples$linkExampleButton, G1: $author$project$Pages$StyleGuide$Link$exampleButton})
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(6)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('With icon')
									]),
								{NN: $author$project$Generated$StyleGuide$Examples$linkExampleWithIcon, G1: $author$project$Pages$StyleGuide$Link$exampleWithIcon}),
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('With icon right')
									]),
								{NN: $author$project$Generated$StyleGuide$Examples$linkExampleWithIconRight, G1: $author$project$Pages$StyleGuide$Link$exampleWithIconRight}),
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('With icon and no content')
									]),
								{NN: $author$project$Generated$StyleGuide$Examples$linkExampleWithIconOnly, G1: $author$project$Pages$StyleGuide$Link$exampleWithIconOnly})
							]))
					]))
			]),
		ac9: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$Link$page = $author$project$Spa$Page$static($author$project$Pages$StyleGuide$Link$view);
var $author$project$Ui$ListGroup$Info = 1;
var $author$project$Ui$ListGroup$heading = function (contents) {
	return A2(
		$elm$html$Html$h3,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('list-group__heading')
			]),
		contents);
};
var $author$project$Pages$StyleGuide$ListGroup$viewBody = _List_fromArray(
	[
		$author$project$Ui$Typography$heading(
		_List_fromArray(
			[
				$elm$html$Html$text('List Group')
			])),
		A2(
		$author$project$Ui$ListGroup$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$ListGroup$item,
				_List_fromArray(
					[
						$author$project$Ui$ListGroup$style(0)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Success')
					])),
				A2(
				$author$project$Ui$ListGroup$item,
				_List_fromArray(
					[
						$author$project$Ui$ListGroup$style(1)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Info')
					])),
				A2(
				$author$project$Ui$ListGroup$item,
				_List_fromArray(
					[
						$author$project$Ui$ListGroup$style(2)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Warning')
					])),
				A2(
				$author$project$Ui$ListGroup$item,
				_List_fromArray(
					[
						$author$project$Ui$ListGroup$style(3)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Danger')
					])),
				A2(
				$author$project$Ui$ListGroup$item,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$ListGroup$heading(
						_List_fromArray(
							[
								$elm$html$Html$text('List group item heading')
							])),
						$author$project$Ui$ListGroup$body(
						_List_fromArray(
							[
								$elm$html$Html$text('Donec id elit non mi porta gravida at eget metus. Maecenas sed diam eget risus varius blandit.')
							]))
					]))
			]))
	]);
var $author$project$Pages$StyleGuide$ListGroup$view = function (_v0) {
	return {fO: $author$project$Pages$StyleGuide$ListGroup$viewBody, ac9: 'Style Guide'};
};
var $author$project$Pages$StyleGuide$ListGroup$page = $author$project$Spa$Page$static($author$project$Pages$StyleGuide$ListGroup$view);
var $author$project$Pages$StyleGuide$Modal$ModalClosed = 0;
var $author$project$Pages$StyleGuide$Modal$init = function (_v0) {
	return _Utils_Tuple2(
		{Yn: 0},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$StyleGuide$Modal$CloseModal = 3;
var $author$project$Pages$StyleGuide$Modal$subscriptions = function (model) {
	var _v0 = model.Yn;
	if (!_v0) {
		return $elm$core$Platform$Sub$none;
	} else {
		return $author$project$Ui$Modal$subscribeToEscapeKeyPress(3);
	}
};
var $author$project$Pages$StyleGuide$Modal$BasicOpen = 1;
var $author$project$Pages$StyleGuide$Modal$FaqOpen = 3;
var $author$project$Pages$StyleGuide$Modal$LgOpen = 2;
var $author$project$Pages$StyleGuide$Modal$update = F2(
	function (msg, model) {
		switch (msg) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{Yn: 1}),
					$elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{Yn: 2}),
					$elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{Yn: 3}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{Yn: 0}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$StyleGuide$Modal$OpenBasic = 0;
var $author$project$Pages$StyleGuide$Modal$exampleBasic = _List_fromArray(
	[
		A3(
		$author$project$Ui$Button$view,
		{mm: 'Open modal'},
		_List_fromArray(
			[
				$author$project$Ui$Button$onClick(0)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Open Modal')
			]))
	]);
var $author$project$Pages$StyleGuide$Modal$OpenFaq = 2;
var $author$project$Pages$StyleGuide$Modal$exampleFaq = _List_fromArray(
	[
		A3(
		$author$project$Ui$Button$view,
		{mm: 'Open modal with FAQ'},
		_List_fromArray(
			[
				$author$project$Ui$Button$onClick(2)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Open Modal with FAQ')
			]))
	]);
var $author$project$Pages$StyleGuide$Modal$OpenLg = 1;
var $author$project$Pages$StyleGuide$Modal$exampleSizes = _List_fromArray(
	[
		A3(
		$author$project$Ui$Button$view,
		{mm: 'Open default modal'},
		_List_fromArray(
			[
				$author$project$Ui$Button$onClick(0)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Default')
			])),
		A3(
		$author$project$Ui$Button$view,
		{mm: 'Open large modal'},
		_List_fromArray(
			[
				$author$project$Ui$Button$onClick(1)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Large')
			]))
	]);
var $author$project$Generated$StyleGuide$Examples$modalExampleBasic = '\n    [ Button.view { ariaLabel = "Open modal" } [ Button.onClick OpenBasic ] [ text "Open Modal" ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$modalExampleFaq = '\n    [ Button.view { ariaLabel = "Open modal with FAQ" } [ Button.onClick OpenFaq ] [ text "Open Modal with FAQ" ]\n    ]\n    ';
var $author$project$Generated$StyleGuide$Examples$modalExampleSizes = '\n    [ Button.view { ariaLabel = "Open default modal" } [ Button.onClick OpenBasic ] [ text "Default" ]\n    , Button.view { ariaLabel = "Open large modal" } [ Button.onClick OpenLg ] [ text "Large" ]\n    ]    ';
var $author$project$Pages$StyleGuide$Modal$viewModal = function (model) {
	var _v0 = model.Yn;
	switch (_v0) {
		case 0:
			return $author$project$Utils$Html$empty;
		case 1:
			return A3(
				$author$project$Ui$Modal$view,
				3,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Modal$header(
						_List_fromArray(
							[
								$author$project$Ui$Modal$title('Modal Title')
							])),
						$author$project$Ui$Modal$body(
						_List_fromArray(
							[
								$elm$html$Html$text('Modal body content goes here.')
							])),
						$author$project$Ui$Modal$footer(
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Cancel'},
								_List_fromArray(
									[
										$author$project$Ui$Button$onClick(3)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Cancel')
									])),
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Save'},
								_List_fromArray(
									[
										$author$project$Ui$Button$primary,
										$author$project$Ui$Button$onClick(3)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Save')
									]))
							]))
					]));
		case 2:
			return A3(
				$author$project$Ui$Modal$view,
				3,
				_List_fromArray(
					[$author$project$Ui$Modal$lg]),
				_List_fromArray(
					[
						$author$project$Ui$Modal$header(
						_List_fromArray(
							[
								$author$project$Ui$Modal$title('Large Modal')
							])),
						$author$project$Ui$Modal$body(
						_List_fromArray(
							[
								$elm$html$Html$text('Modal body content goes here.')
							])),
						$author$project$Ui$Modal$footer(
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Close'},
								_List_fromArray(
									[
										$author$project$Ui$Button$onClick(3)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Close')
									]))
							]))
					]));
		default:
			return A3(
				$author$project$Ui$Modal$view,
				3,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Modal$header(
						_List_fromArray(
							[
								$author$project$Ui$Modal$title('Modal with Collapsible Section')
							])),
						$author$project$Ui$Modal$body(
						_List_fromArray(
							[
								$elm$html$Html$text('Body content above the collapsible section.')
							])),
						A2(
						$author$project$Ui$Modal$collapsible,
						'How does this work?',
						_List_fromArray(
							[
								$elm$html$Html$text('This section is collapsible. Click the header to toggle it open or closed. No Elm state required.')
							])),
						$author$project$Ui$Modal$footer(
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Close'},
								_List_fromArray(
									[
										$author$project$Ui$Button$onClick(3)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Close')
									]))
							]))
					]));
	}
};
var $author$project$Pages$StyleGuide$Modal$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				$author$project$Pages$StyleGuide$Modal$viewModal(model),
				$author$project$Ui$Typography$headingLg(
				_List_fromArray(
					[
						$elm$html$Html$text('Modal')
					])),
				A2(
				$author$project$Components$StyleGuide$Example$view,
				_List_fromArray(
					[
						$author$project$Components$StyleGuide$Example$title('Basic')
					]),
				{NN: $author$project$Generated$StyleGuide$Examples$modalExampleBasic, G1: $author$project$Pages$StyleGuide$Modal$exampleBasic}),
				A2(
				$author$project$Components$StyleGuide$Example$view,
				_List_fromArray(
					[
						$author$project$Components$StyleGuide$Example$title('Sizes')
					]),
				{NN: $author$project$Generated$StyleGuide$Examples$modalExampleSizes, G1: $author$project$Pages$StyleGuide$Modal$exampleSizes}),
				A2(
				$author$project$Components$StyleGuide$Example$view,
				_List_fromArray(
					[
						$author$project$Components$StyleGuide$Example$title('With FAQ section')
					]),
				{NN: $author$project$Generated$StyleGuide$Examples$modalExampleFaq, G1: $author$project$Pages$StyleGuide$Modal$exampleFaq})
			]),
		ac9: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$Modal$page = $author$project$Spa$Page$element(
	{ah_: $author$project$Pages$StyleGuide$Modal$init, alO: $author$project$Pages$StyleGuide$Modal$subscriptions, adT: $author$project$Pages$StyleGuide$Modal$update, amo: $author$project$Pages$StyleGuide$Modal$view});
var $author$project$Pages$StyleGuide$OrderedList$init = function (_v0) {
	return _Utils_Tuple2(
		{},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$StyleGuide$OrderedList$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$StyleGuide$OrderedList$update = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$StyleGuide$OrderedList$example = _List_fromArray(
	[
		A2(
		$author$project$Ui$OrderedList$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$OrderedList$item,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('First item')
					])),
				A2(
				$author$project$Ui$OrderedList$item,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Second item')
					])),
				A2(
				$author$project$Ui$OrderedList$item,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Third item')
					]))
			]))
	]);
var $author$project$Pages$StyleGuide$OrderedList$exampleRoman = _List_fromArray(
	[
		A2(
		$author$project$Ui$OrderedList$view,
		_List_fromArray(
			[$author$project$Ui$OrderedList$roman]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$OrderedList$item,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('First item')
					])),
				A2(
				$author$project$Ui$OrderedList$item,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Second item')
					])),
				A2(
				$author$project$Ui$OrderedList$item,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Third item')
					]))
			]))
	]);
var $author$project$Generated$StyleGuide$Examples$orderedListExample = '\n    [ OrderedList.view []\n        [ OrderedList.item [] [ text "First item" ]\n        , OrderedList.item [] [ text "Second item" ]\n        , OrderedList.item [] [ text "Third item" ]\n        ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$orderedListExampleRoman = '\n    [ OrderedList.view [ OrderedList.roman ]\n        [ OrderedList.item [] [ text "First item" ]\n        , OrderedList.item [] [ text "Second item" ]\n        , OrderedList.item [] [ text "Third item" ]\n        ]\n    ]\n    ';
var $author$project$Pages$StyleGuide$OrderedList$viewBody = _List_fromArray(
	[
		A2(
		$author$project$Components$StyleGuide$Example$view,
		_List_fromArray(
			[
				$author$project$Components$StyleGuide$Example$title('Default')
			]),
		{NN: $author$project$Generated$StyleGuide$Examples$orderedListExample, G1: $author$project$Pages$StyleGuide$OrderedList$example}),
		A2(
		$author$project$Components$StyleGuide$Example$view,
		_List_fromArray(
			[
				$author$project$Components$StyleGuide$Example$title('Roman numerals')
			]),
		{NN: $author$project$Generated$StyleGuide$Examples$orderedListExampleRoman, G1: $author$project$Pages$StyleGuide$OrderedList$exampleRoman})
	]);
var $author$project$Pages$StyleGuide$OrderedList$view = function (_v0) {
	return {fO: $author$project$Pages$StyleGuide$OrderedList$viewBody, ac9: 'Style Guide'};
};
var $author$project$Pages$StyleGuide$OrderedList$page = $author$project$Spa$Page$element(
	{ah_: $author$project$Pages$StyleGuide$OrderedList$init, alO: $author$project$Pages$StyleGuide$OrderedList$subscriptions, adT: $author$project$Pages$StyleGuide$OrderedList$update, amo: $author$project$Pages$StyleGuide$OrderedList$view});
var $author$project$Pages$StyleGuide$Pagination$defaultItemsPerPage = 7;
var $author$project$Pages$StyleGuide$Pagination$defaultTotalCount = 95;
var $author$project$Pages$StyleGuide$Pagination$init = function (_v0) {
	return _Utils_Tuple2(
		{bX: 1, gG: $author$project$Pages$StyleGuide$Pagination$defaultItemsPerPage, qC: $author$project$Pages$StyleGuide$Pagination$defaultTotalCount},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$StyleGuide$Pagination$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$StyleGuide$Pagination$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var string = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bX: 1,
							qC: A2(
								$elm$core$Maybe$withDefault,
								$author$project$Pages$StyleGuide$Pagination$defaultTotalCount,
								$elm$core$String$toInt(string))
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var string = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bX: 1,
							gG: A2(
								$elm$core$Maybe$withDefault,
								$author$project$Pages$StyleGuide$Pagination$defaultItemsPerPage,
								$elm$core$String$toInt(string))
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var currentPage = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bX: currentPage}),
					$elm$core$Platform$Cmd$none);
			default:
				var perPage = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bX: 1, gG: perPage}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$StyleGuide$Pagination$CurrentPageChanged = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$StyleGuide$Pagination$ItemsPerPageChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$StyleGuide$Pagination$PerPageChanged = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$StyleGuide$Pagination$TotalCountChanged = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Pagination$List$HideTotalItemsForSinglePage = {$: 2};
var $author$project$Ui$Pagination$List$hideTotalItemsForSinglePage = $author$project$Ui$Pagination$List$HideTotalItemsForSinglePage;
var $author$project$Ui$Pagination$List$Size = function (a) {
	return {$: 8, a: a};
};
var $author$project$Ui$Pagination$List$Sm = 0;
var $author$project$Ui$Pagination$List$sm = $author$project$Ui$Pagination$List$Size(0);
var $author$project$Pages$StyleGuide$Pagination$viewBody = function (model) {
	return _List_fromArray(
		[
			$author$project$Ui$Typography$heading(
			_List_fromArray(
				[
					$elm$html$Html$text('Pagination')
				])),
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$number,
									$author$project$Ui$Form$Input$placeholder(
									'Total Count (Default: ' + ($elm$core$String$fromInt($author$project$Pages$StyleGuide$Pagination$defaultTotalCount) + ')')),
									$author$project$Ui$Form$Input$onInput($author$project$Pages$StyleGuide$Pagination$TotalCountChanged)
								])),
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$number,
									$author$project$Ui$Form$Input$placeholder(
									'Items Per Page (Default: ' + ($elm$core$String$fromInt($author$project$Pages$StyleGuide$Pagination$defaultItemsPerPage) + ')')),
									$author$project$Ui$Form$Input$onInput($author$project$Pages$StyleGuide$Pagination$ItemsPerPageChanged)
								]))
						]))
				])),
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Panel$title(
							_List_fromArray(
								[
									$elm$html$Html$text('Default')
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Pagination$List$view(
							_List_fromArray(
								[
									$author$project$Ui$Pagination$List$totalCount(model.qC),
									$author$project$Ui$Pagination$List$itemsPerPage(model.gG),
									$author$project$Ui$Pagination$List$currentPage(model.bX),
									$author$project$Ui$Pagination$List$onClick($author$project$Pages$StyleGuide$Pagination$CurrentPageChanged),
									$author$project$Ui$Pagination$List$onPerPageChange($author$project$Pages$StyleGuide$Pagination$PerPageChanged)
								]))
						]))
				])),
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Panel$title(
							_List_fromArray(
								[
									$elm$html$Html$text('Small')
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Pagination$List$view(
							_List_fromArray(
								[
									$author$project$Ui$Pagination$List$totalCount(model.qC),
									$author$project$Ui$Pagination$List$itemsPerPage(model.gG),
									$author$project$Ui$Pagination$List$currentPage(model.bX),
									$author$project$Ui$Pagination$List$sm,
									$author$project$Ui$Pagination$List$onClick($author$project$Pages$StyleGuide$Pagination$CurrentPageChanged),
									$author$project$Ui$Pagination$List$onPerPageChange($author$project$Pages$StyleGuide$Pagination$PerPageChanged)
								]))
						]))
				])),
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Panel$title(
							_List_fromArray(
								[
									$elm$html$Html$text('Hide Total Items For Single Page')
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Pagination$List$view(
							_List_fromArray(
								[
									$author$project$Ui$Pagination$List$totalCount(model.qC),
									$author$project$Ui$Pagination$List$itemsPerPage(model.qC),
									$author$project$Ui$Pagination$List$hideTotalItemsForSinglePage,
									$author$project$Ui$Pagination$List$currentPage(model.bX),
									$author$project$Ui$Pagination$List$onClick($author$project$Pages$StyleGuide$Pagination$CurrentPageChanged),
									$author$project$Ui$Pagination$List$onPerPageChange($author$project$Pages$StyleGuide$Pagination$PerPageChanged)
								]))
						]))
				])),
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Panel$title(
							_List_fromArray(
								[
									$elm$html$Html$text('Loading')
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Pagination$List$view(
							_List_fromArray(
								[
									$author$project$Ui$Pagination$List$loading(true)
								]))
						]))
				]))
		]);
};
var $author$project$Pages$StyleGuide$Pagination$view = function (model) {
	return {
		fO: $author$project$Pages$StyleGuide$Pagination$viewBody(model),
		ac9: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$Pagination$page = $author$project$Spa$Page$element(
	{ah_: $author$project$Pages$StyleGuide$Pagination$init, alO: $author$project$Pages$StyleGuide$Pagination$subscriptions, adT: $author$project$Pages$StyleGuide$Pagination$update, amo: $author$project$Pages$StyleGuide$Pagination$view});
var $author$project$Pages$StyleGuide$Panel$exampleCollapsible = _List_fromArray(
	[
		A2(
		$author$project$Ui$Panel$view,
		_List_fromArray(
			[
				$author$project$Ui$Panel$collapsed(false)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Panel$title(
						_List_fromArray(
							[
								$elm$html$Html$text('Click to toggle')
							]))
					])),
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('This panel body is collapsible. Click the heading to expand or collapse it.')
					])),
				A2(
				$author$project$Ui$Panel$footer,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('The footer is also hidden when collapsed.')
					]))
			]))
	]);
var $author$project$Pages$StyleGuide$Panel$exampleCollapsibleStyled = _List_fromArray(
	[
		A2(
		$author$project$Ui$Panel$view,
		_List_fromArray(
			[
				$author$project$Ui$Panel$info,
				$author$project$Ui$Panel$collapsed(true)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Panel$title(
						_List_fromArray(
							[
								$elm$html$Html$text('Styled collapsible (starts collapsed)')
							]))
					])),
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Collapsible panels work with all panel style variants.')
					]))
			]))
	]);
var $author$project$Ui$Panel$ListGroup = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Ui$Panel$listGroup = $author$project$Ui$Panel$ListGroup;
var $author$project$Pages$StyleGuide$Panel$exampleListGroup = _List_fromArray(
	[
		A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_fromArray(
					[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$text,
						_List_fromArray(
							[$author$project$Ui$Typography$bold]),
						'Payment Methods'),
						A2(
						$author$project$Ui$Typography$text,
						_List_fromArray(
							[$author$project$Ui$Typography$muted]),
						'3 records')
					])),
				A2(
				$author$project$Ui$Panel$listGroup,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$ListGroup$item,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Visa *4242 — added Jan 2024')
							])),
						A2(
						$author$project$Ui$ListGroup$item,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Bank of America *2210 — added Mar 2024')
							])),
						A2(
						$author$project$Ui$ListGroup$item,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Amex *0005 — added May 2026')
							]))
					])),
				A2(
				$author$project$Ui$Panel$footer,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$text,
						_List_fromArray(
							[$author$project$Ui$Typography$muted]),
						'Newest first')
					]))
			]))
	]);
var $author$project$Pages$StyleGuide$Panel$exampleTiles = _List_fromArray(
	[
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$flex, $author$project$Ui$Element$wrap, $author$project$Ui$Element$gap4]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_fromArray(
					[$author$project$Ui$Panel$tile, $author$project$Ui$Panel$info]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Active')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('1,284'),
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								$elm$html$Html$text('Across 8 providers, 3 locations, 12 service lines and counting.')
							]))
					])),
				A2(
				$author$project$Ui$Panel$view,
				_List_fromArray(
					[$author$project$Ui$Panel$tile, $author$project$Ui$Panel$success]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('New')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('+42')
							]))
					])),
				A2(
				$author$project$Ui$Panel$view,
				_List_fromArray(
					[$author$project$Ui$Panel$tile, $author$project$Ui$Panel$danger]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Lost')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('-7')
							]))
					])),
				A2(
				$author$project$Ui$Panel$view,
				_List_fromArray(
					[$author$project$Ui$Panel$tile, $author$project$Ui$Panel$warning]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Past Due')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('$3,200 across patients and sponsors')
							]))
					]))
			]))
	]);
var $author$project$Generated$StyleGuide$Examples$panelExampleCollapsible = '\n    [ Panel.view\n        [ Panel.collapsed False\n        ]\n        [ Panel.heading []\n            [ Panel.title [ text "Click to toggle" ]\n            ]\n        , Panel.body []\n            [ text "This panel body is collapsible. Click the heading to expand or collapse it."\n            ]\n        , Panel.footer []\n            [ text "The footer is also hidden when collapsed."\n            ]\n        ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$panelExampleCollapsibleStyled = '\n    [ Panel.view\n        [ Panel.info\n        , Panel.collapsed True\n        ]\n        [ Panel.heading []\n            [ Panel.title [ text "Styled collapsible (starts collapsed)" ]\n            ]\n        , Panel.body []\n            [ text "Collapsible panels work with all panel style variants."\n            ]\n        ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$panelExampleListGroup = '\n    [ Panel.view []\n        [ Panel.heading [ Element.spaceBetween, Element.itemsCenter ]\n            [ Typ.text [ Typ.bold ] "Payment Methods"\n            , Typ.text [ Typ.muted ] "3 records"\n            ]\n        , Panel.listGroup []\n            [ ListGroup.item []\n                [ text "Visa *4242 — added Jan 2024" ]\n            , ListGroup.item []\n                [ text "Bank of America *2210 — added Mar 2024" ]\n            , ListGroup.item []\n                [ text "Amex *0005 — added May 2026" ]\n            ]\n        , Panel.footer []\n            [ Typ.text [ Typ.muted ] "Newest first" ]\n        ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$panelExampleTiles = '\n    [ Element.view [ Element.flex, Element.wrap, Element.gap4 ]\n        [ Panel.view [ Panel.tile, Panel.info ]\n            [ Panel.heading [] [ Panel.title [ text "Active" ] ]\n            , Panel.body []\n                [ text "1,284"\n                , Html.br [] []\n                , text "Across 8 providers, 3 locations, 12 service lines and counting."\n                ]\n            ]\n        , Panel.view [ Panel.tile, Panel.success ]\n            [ Panel.heading [] [ Panel.title [ text "New" ] ]\n            , Panel.body [] [ text "+42" ]\n            ]\n        , Panel.view [ Panel.tile, Panel.danger ]\n            [ Panel.heading [] [ Panel.title [ text "Lost" ] ]\n            , Panel.body [] [ text "-7" ]\n            ]\n        , Panel.view [ Panel.tile, Panel.warning ]\n            [ Panel.heading [] [ Panel.title [ text "Past Due" ] ]\n            , Panel.body [] [ text "$3,200 across patients and sponsors" ]\n            ]\n        ]\n    ]\n    ';
var $author$project$Pages$StyleGuide$Panel$viewPanel = A2(
	$author$project$Ui$Panel$view,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Panel$heading,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Panel Title')
				])),
			A2(
			$author$project$Ui$Panel$body,
			_List_fromArray(
				[$author$project$Ui$Element$textCenter]),
			_List_fromArray(
				[
					$elm$html$Html$text('Panel Content')
				])),
			A4(
			$author$project$Ui$Panel$table,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$header,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Panel')
						])),
					A2(
					$author$project$Ui$Table$header,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Table')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Jhon')
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Doe')
								]))
						])),
					A2(
					$author$project$Ui$Table$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Jane')
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Doe')
								]))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Some')
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Footer')
								]))
						]))
				])),
			A2(
			$author$project$Ui$Panel$footer,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Panel Footer')
				]))
		]));
var $author$project$Pages$StyleGuide$Panel$viewPanelStyle = function (panelStyle) {
	return A2(
		$author$project$Ui$Panel$view,
		_List_fromArray(
			[panelStyle]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Panel Title')
					])),
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Panel Content')
					]))
			]));
};
var $author$project$Pages$StyleGuide$Panel$view = function (_v0) {
	var panelStyles = _List_fromArray(
		[$author$project$Ui$Panel$primary, $author$project$Ui$Panel$success, $author$project$Ui$Panel$info, $author$project$Ui$Panel$warning, $author$project$Ui$Panel$danger]);
	return {
		fO: $elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[$author$project$Pages$StyleGuide$Panel$viewPanel]),
					A2($elm$core$List$map, $author$project$Pages$StyleGuide$Panel$viewPanelStyle, panelStyles),
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mb4]),
						_List_Nil),
						A2(
						$author$project$Components$StyleGuide$Example$view,
						_List_fromArray(
							[
								$author$project$Components$StyleGuide$Example$title('Collapsible Panel'),
								$author$project$Components$StyleGuide$Example$description(
								_List_fromArray(
									[
										$elm$html$Html$text('The collapsed option sets the initial state only. After rendering, the panel state is managed by CSS (checkbox hack). Click the heading to toggle.')
									]))
							]),
						{NN: $author$project$Generated$StyleGuide$Examples$panelExampleCollapsible, G1: $author$project$Pages$StyleGuide$Panel$exampleCollapsible}),
						A2(
						$author$project$Components$StyleGuide$Example$view,
						_List_fromArray(
							[
								$author$project$Components$StyleGuide$Example$title('Collapsible Styled Panel'),
								$author$project$Components$StyleGuide$Example$description(
								_List_fromArray(
									[
										$elm$html$Html$text('The collapsed option sets the initial state only. After rendering, the panel state is managed by CSS (checkbox hack). Click the heading to toggle.')
									]))
							]),
						{NN: $author$project$Generated$StyleGuide$Examples$panelExampleCollapsibleStyled, G1: $author$project$Pages$StyleGuide$Panel$exampleCollapsibleStyled}),
						A2(
						$author$project$Components$StyleGuide$Example$view,
						_List_fromArray(
							[
								$author$project$Components$StyleGuide$Example$title('Tile Panels'),
								$author$project$Components$StyleGuide$Example$description(
								_List_fromArray(
									[
										$elm$html$Html$text('The tile option turns a panel into a flex item with a 200px minimum width. Combine with a flex container (e.g. Element.view [ Element.flex, Element.wrap, Element.gap4 ]) to flow tiles into rows.')
									]))
							]),
						{NN: $author$project$Generated$StyleGuide$Examples$panelExampleTiles, G1: $author$project$Pages$StyleGuide$Panel$exampleTiles}),
						A2(
						$author$project$Components$StyleGuide$Example$view,
						_List_fromArray(
							[
								$author$project$Components$StyleGuide$Example$title('Panel with List Group'),
								$author$project$Components$StyleGuide$Example$description(
								_List_fromArray(
									[
										$elm$html$Html$text('Panel.listGroup mirrors Panel.table — attach a Ui.ListGroup as a panel section. Useful when the body is a flat list of records (payment methods, integrations, members) instead of a tabular structure.')
									]))
							]),
						{NN: $author$project$Generated$StyleGuide$Examples$panelExampleListGroup, G1: $author$project$Pages$StyleGuide$Panel$exampleListGroup})
					])
				])),
		ac9: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$Panel$page = $author$project$Spa$Page$static($author$project$Pages$StyleGuide$Panel$view);
var $author$project$Pages$StyleGuide$PasswordInput$init = function (_v0) {
	return _Utils_Tuple2('', $elm$core$Platform$Cmd$none);
};
var $author$project$Pages$StyleGuide$PasswordInput$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$StyleGuide$PasswordInput$update = F2(
	function (msg, _v0) {
		var string = msg;
		return _Utils_Tuple2(string, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$StyleGuide$PasswordInput$PasswordInputChanged = $elm$core$Basics$identity;
var $author$project$Pages$StyleGuide$PasswordInput$viewBody = function (password) {
	return _List_fromArray(
		[
			$author$project$Ui$Typography$headingLg(
			_List_fromArray(
				[
					$elm$html$Html$text('Form -> Password Input')
				])),
			$author$project$Ui$Form$PasswordInput$view(
			_List_fromArray(
				[
					$author$project$Ui$Form$PasswordInput$value(password),
					$author$project$Ui$Form$PasswordInput$onInput($elm$core$Basics$identity)
				]))
		]);
};
var $author$project$Pages$StyleGuide$PasswordInput$view = function (model) {
	return {
		fO: $author$project$Pages$StyleGuide$PasswordInput$viewBody(model),
		ac9: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$PasswordInput$page = $author$project$Spa$Page$element(
	{ah_: $author$project$Pages$StyleGuide$PasswordInput$init, alO: $author$project$Pages$StyleGuide$PasswordInput$subscriptions, adT: $author$project$Pages$StyleGuide$PasswordInput$update, amo: $author$project$Pages$StyleGuide$PasswordInput$view});
var $author$project$Pages$StyleGuide$PaymentSourceDisplayer$GotBankAccounts = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$StyleGuide$PaymentSourceDisplayer$GotCards = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$StyleGuide$PaymentSourceDisplayer$WithSession = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$StyleGuide$PaymentSourceDisplayer$WithoutSession = {$: 1};
var $author$project$Pages$StyleGuide$PaymentSourceDisplayer$init = F2(
	function (shared, _v0) {
		var _v1 = shared.aa4;
		if (_v1.$ === 3) {
			return _Utils_Tuple3(
				$author$project$Pages$StyleGuide$PaymentSourceDisplayer$WithSession(
					{rs: $author$project$Api$Data$Loading, rC: $author$project$Api$Data$Loading, J7: shared.J7}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A3($author$project$Api$Provider$Card$list, $author$project$Api$Data$providerPath, shared.Gv, $author$project$Pages$StyleGuide$PaymentSourceDisplayer$GotCards),
							A3($author$project$Api$Provider$BankAccount$list, $author$project$Api$Data$providerPath, shared.Gv, $author$project$Pages$StyleGuide$PaymentSourceDisplayer$GotBankAccounts)
						])),
				_List_Nil);
		} else {
			return _Utils_Tuple3($author$project$Pages$StyleGuide$PaymentSourceDisplayer$WithoutSession, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Pages$StyleGuide$PaymentSourceDisplayer$load = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$StyleGuide$PaymentSourceDisplayer$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$StyleGuide$PaymentSourceDisplayer$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$StyleGuide$PaymentSourceDisplayer$update = F2(
	function (msg, model) {
		if (!model.$) {
			var withSession = model.a;
			if (!msg.$) {
				var response = msg.a;
				return _Utils_Tuple3(
					$author$project$Pages$StyleGuide$PaymentSourceDisplayer$WithSession(
						_Utils_update(
							withSession,
							{rC: response})),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			} else {
				var response = msg.a;
				return _Utils_Tuple3(
					$author$project$Pages$StyleGuide$PaymentSourceDisplayer$WithSession(
						_Utils_update(
							withSession,
							{rs: response})),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			}
		} else {
			return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Pages$StyleGuide$PaymentSourceDisplayer$viewBody = function (model) {
	return _List_fromArray(
		[
			$author$project$Ui$Typography$headingLg(
			_List_fromArray(
				[
					$elm$html$Html$text('Payment Source Displayer')
				])),
			$author$project$Ui$Typography$heading(
			_List_fromArray(
				[
					$elm$html$Html$text('Card')
				])),
			function () {
			var _v0 = model.rC;
			if (_v0.$ === 3) {
				var cards = _v0.a;
				return $elm$core$List$isEmpty(cards) ? A2(
					$author$project$Ui$Alert$warning,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('The current practice does not have any cards, add one  or change to a practice that does')
						])) : A2(
					$author$project$Components$PaymentSourceDisplayer$view,
					model.J7,
					_List_fromArray(
						[
							$author$project$Components$PaymentSourceDisplayer$source(
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeL, $author$project$Api$Source$Card, $author$project$Api$Card$ProviderAll),
								$elm$core$List$head(cards)))
						]));
			} else {
				return $author$project$Ui$Spinner$view(_List_Nil);
			}
		}(),
			$author$project$Ui$Typography$heading(
			_List_fromArray(
				[
					$elm$html$Html$text('BankAccount')
				])),
			function () {
			var _v1 = model.rs;
			if (_v1.$ === 3) {
				var bankAccounts = _v1.a;
				return $elm$core$List$isEmpty(bankAccounts) ? A2(
					$author$project$Ui$Alert$warning,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('The current practice does not have any cards, add one  or change to a practice that does')
						])) : A2(
					$author$project$Components$PaymentSourceDisplayer$view,
					model.J7,
					_List_fromArray(
						[
							$author$project$Components$PaymentSourceDisplayer$source(
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeL, $author$project$Api$Source$BankAccount, $author$project$Api$BankAccount$ProviderAll),
								$elm$core$List$head(bankAccounts)))
						]));
			} else {
				return $author$project$Ui$Spinner$view(_List_Nil);
			}
		}(),
			$author$project$Ui$Typography$heading(
			_List_fromArray(
				[
					$elm$html$Html$text('Practice Source Displayer')
				])),
			function () {
			var _v2 = _Utils_Tuple2(model.rC, model.rs);
			if ((_v2.a.$ === 3) && (_v2.b.$ === 3)) {
				var _v3 = _v2.a;
				var cards = _v3.a;
				var _v4 = _v2.b;
				var bankAccounts = _v4.a;
				return A2(
					$author$project$Components$PracticeSourceDisplayer$view,
					model.J7,
					A2($author$project$Api$Source$defaultPracticeSource, cards, bankAccounts));
			} else {
				return $author$project$Ui$Spinner$view(_List_Nil);
			}
		}()
		]);
};
var $author$project$Pages$StyleGuide$PaymentSourceDisplayer$view = function (model) {
	return {
		fO: function () {
			if (!model.$) {
				var modelRecord = model.a;
				return $author$project$Pages$StyleGuide$PaymentSourceDisplayer$viewBody(modelRecord);
			} else {
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Alert$warning,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('You need to be logged in to view this style guide')
							]))
					]);
			}
		}(),
		ac9: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$PaymentSourceDisplayer$page = $author$project$Spa$Page$application(
	{ah_: $author$project$Pages$StyleGuide$PaymentSourceDisplayer$init, aiq: $author$project$Pages$StyleGuide$PaymentSourceDisplayer$load, k8: $author$project$Pages$StyleGuide$PaymentSourceDisplayer$save, alO: $author$project$Pages$StyleGuide$PaymentSourceDisplayer$subscriptions, adT: $author$project$Pages$StyleGuide$PaymentSourceDisplayer$update, amo: $author$project$Pages$StyleGuide$PaymentSourceDisplayer$view});
var $author$project$Pages$StyleGuide$PhoneInput$init = function (_v0) {
	return _Utils_Tuple2(
		{
			b6: A3($author$project$Components$PhoneInput$init, 'phone-input', _List_Nil, $elm$core$Basics$identity),
			o9: A3(
				$author$project$Components$PhoneInput$init,
				'phone-input-one',
				_List_Nil,
				function (d) {
					return _Utils_update(
						d,
						{Gh: true, agl: $author$project$Api$Common$Phone$Shared$Office, AU: 1});
				}),
			pa: A3(
				$author$project$Components$PhoneInput$init,
				'phone-input-one-required',
				_List_Nil,
				function (d) {
					return _Utils_update(
						d,
						{Gh: true, agl: $author$project$Api$Common$Phone$Shared$Office, AU: 1, akR: true});
				}),
			pb: A3(
				$author$project$Components$PhoneInput$init,
				'phone-input-preloaded',
				_List_fromArray(
					[
						A3($author$project$Components$PhoneInput$initPhone, $author$project$Api$Common$Phone$Shared$Office, 1, '1234')
					]),
				$elm$core$Basics$identity),
			pc: A3(
				$author$project$Components$PhoneInput$init,
				'phone-input-required',
				_List_Nil,
				function (d) {
					return _Utils_update(
						d,
						{
							Gh: true,
							agl: $author$project$Api$Common$Phone$Shared$Office,
							AU: 10,
							akR: true,
							amh: _List_fromArray(
								[$author$project$Api$Common$Phone$Shared$Office, $author$project$Api$Common$Phone$Shared$Mobile])
						});
				})
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputOneMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputOneRequiredMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputPreloadedMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputRequiredMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$StyleGuide$PhoneInput$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputMsg,
				$author$project$Components$PhoneInput$subscriptions(model.b6)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputRequiredMsg,
				$author$project$Components$PhoneInput$subscriptions(model.pc)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputOneMsg,
				$author$project$Components$PhoneInput$subscriptions(model.o9)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputOneRequiredMsg,
				$author$project$Components$PhoneInput$subscriptions(model.pa)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputPreloadedMsg,
				$author$project$Components$PhoneInput$subscriptions(model.pb))
			]));
};
var $author$project$Pages$StyleGuide$PhoneInput$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Components$PhoneInput$update, subMsg, model.b6);
				var updatedPhoneInput = _v1.a;
				var phoneCmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{b6: updatedPhoneInput}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputMsg, phoneCmd));
			case 1:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Components$PhoneInput$update, subMsg, model.pc);
				var updatedPhoneInputRequired = _v2.a;
				var phoneCmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{pc: updatedPhoneInputRequired}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputRequiredMsg, phoneCmd));
			case 2:
				var subMsg = msg.a;
				var _v3 = A2($author$project$Components$PhoneInput$update, subMsg, model.o9);
				var updatedPhoneInputOne = _v3.a;
				var phoneCmd = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{o9: updatedPhoneInputOne}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputOneMsg, phoneCmd));
			case 3:
				var subMsg = msg.a;
				var _v4 = A2($author$project$Components$PhoneInput$update, subMsg, model.pa);
				var updatedPhoneInputOneRequired = _v4.a;
				var phoneCmd = _v4.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{pa: updatedPhoneInputOneRequired}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputOneRequiredMsg, phoneCmd));
			default:
				var subMsg = msg.a;
				var _v5 = A2($author$project$Components$PhoneInput$update, subMsg, model.pb);
				var updatedPhoneInputPreloaded = _v5.a;
				var phoneCmd = _v5.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{pb: updatedPhoneInputPreloaded}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputPreloadedMsg, phoneCmd));
		}
	});
var $author$project$Pages$StyleGuide$PhoneInput$viewBody = function (_v0) {
	var phoneInput = _v0.b6;
	var phoneInputPreloaded = _v0.pb;
	var phoneInputRequired = _v0.pc;
	var phoneInputOne = _v0.o9;
	var phoneInputOneRequired = _v0.pa;
	return _List_fromArray(
		[
			$author$project$Ui$Typography$headingLg(
			_List_fromArray(
				[
					$elm$html$Html$text('Phone Input')
				])),
			$author$project$Ui$Typography$heading(
			_List_fromArray(
				[
					$elm$html$Html$text('Default')
				])),
			A2(
			$elm$html$Html$map,
			$author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputMsg,
			$author$project$Components$PhoneInput$view(phoneInput)),
			$author$project$Ui$Typography$heading(
			_List_fromArray(
				[
					$elm$html$Html$text('Default + Preloaded')
				])),
			A2(
			$elm$html$Html$map,
			$author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputPreloadedMsg,
			$author$project$Components$PhoneInput$view(phoneInputPreloaded)),
			$author$project$Ui$Typography$heading(
			_List_fromArray(
				[
					$elm$html$Html$text('Required')
				])),
			A2(
			$elm$html$Html$map,
			$author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputRequiredMsg,
			$author$project$Components$PhoneInput$view(phoneInputRequired)),
			$author$project$Ui$Typography$heading(
			_List_fromArray(
				[
					$elm$html$Html$text('One')
				])),
			A2(
			$elm$html$Html$map,
			$author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputOneMsg,
			$author$project$Components$PhoneInput$view(phoneInputOne)),
			$author$project$Ui$Typography$heading(
			_List_fromArray(
				[
					$elm$html$Html$text('One + Required')
				])),
			A2(
			$elm$html$Html$map,
			$author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputOneRequiredMsg,
			$author$project$Components$PhoneInput$view(phoneInputOneRequired))
		]);
};
var $author$project$Pages$StyleGuide$PhoneInput$view = function (model) {
	return {
		fO: $author$project$Pages$StyleGuide$PhoneInput$viewBody(model),
		ac9: 'Phone Input'
	};
};
var $author$project$Pages$StyleGuide$PhoneInput$page = $author$project$Spa$Page$element(
	{ah_: $author$project$Pages$StyleGuide$PhoneInput$init, alO: $author$project$Pages$StyleGuide$PhoneInput$subscriptions, adT: $author$project$Pages$StyleGuide$PhoneInput$update, amo: $author$project$Pages$StyleGuide$PhoneInput$view});
var $author$project$Pages$StyleGuide$Popover$example = A3(
	$author$project$Ui$Popover$view,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Hover over '),
							$author$project$Ui$Icon$help(_List_Nil)
						]))
				]))
		]),
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Popover$heading,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Popover Heading')
				])),
			A2(
			$author$project$Ui$Popover$body,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Popover Body')
				])),
			A2(
			$author$project$Ui$Popover$footer,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Popover Footer')
				]))
		]));
var $author$project$Pages$StyleGuide$Popover$exampleDark = A3(
	$author$project$Ui$Popover$view,
	_List_fromArray(
		[$author$project$Ui$Popover$dark]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Hover over '),
							$author$project$Ui$Icon$help(_List_Nil)
						]))
				]))
		]),
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Popover$body,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Popover Body')
				]))
		]));
var $author$project$Pages$StyleGuide$Popover$exampleHistory = A3(
	$author$project$Ui$Popover$view,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('See history ')
						]))
				]))
		]),
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Popover$body,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Last updated by practice user')
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$textMuted]),
					_List_fromArray(
						[
							$elm$html$Html$text('06/25/2023 at 15:25 by test@test.com')
						])),
					$author$project$Ui$HorizontalRule$view(
					_List_fromArray(
						[$author$project$Ui$HorizontalRule$thin])),
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Created by practice')
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$textMuted]),
					_List_fromArray(
						[
							$elm$html$Html$text('04/13/2023 at 13:16 via online signup https://member.staging.hint.com/signup?practice=test')
						]))
				]))
		]));
var $author$project$Generated$StyleGuide$Examples$popoverExample = '\n    Popover.view []\n        [ div []\n            [ span []\n                [ text "Hover over "\n                , Icon.help []\n                ]\n            ]\n        ]\n        [ Popover.heading []\n            [ text "Popover Heading"\n            ]\n        , Popover.body []\n            [ text "Popover Body"\n            ]\n        , Popover.footer []\n            [ text "Popover Footer"\n            ]\n        ]    ';
var $author$project$Generated$StyleGuide$Examples$popoverExampleDark = '\n    Popover.view [ Popover.dark ]\n        [ div []\n            [ span []\n                [ text "Hover over "\n                , Icon.help []\n                ]\n            ]\n        ]\n        [ Popover.body []\n            [ text "Popover Body"\n            ]\n        ]    ';
var $author$project$Generated$StyleGuide$Examples$popoverExampleHistory = '\n    Popover.view []\n        [ div []\n            [ span []\n                [ text "See history "\n                ]\n            ]\n        ]\n        [ Popover.body []\n            [ Element.view [] [ text "Last updated by practice user" ]\n            , Element.view [ Element.textMuted ] [ text "06/25/2023 at 15:25 by test@test.com" ]\n            , Hr.view [ Hr.thin ]\n            , Element.view [] [ text "Created by practice" ]\n            , Element.view [ Element.textMuted ] [ text "04/13/2023 at 13:16 via online signup https://member.staging.hint.com/signup?practice=test" ]\n            ]\n        ]\n    ';
var $author$project$Pages$StyleGuide$Popover$view = function (_v0) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(6)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Popover')
									]),
								{
									NN: $author$project$Generated$StyleGuide$Examples$popoverExample,
									G1: _List_fromArray(
										[$author$project$Pages$StyleGuide$Popover$example])
								}),
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('History Popover')
									]),
								{
									NN: $author$project$Generated$StyleGuide$Examples$popoverExampleHistory,
									G1: _List_fromArray(
										[$author$project$Pages$StyleGuide$Popover$exampleHistory])
								})
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(6)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Dark Popover')
									]),
								{
									NN: $author$project$Generated$StyleGuide$Examples$popoverExampleDark,
									G1: _List_fromArray(
										[$author$project$Pages$StyleGuide$Popover$exampleDark])
								})
							]))
					]))
			]),
		ac9: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$Popover$page = $author$project$Spa$Page$static($author$project$Pages$StyleGuide$Popover$view);
var $author$project$Pages$StyleGuide$Pre$exampleBasic = _List_fromArray(
	[
		A2(
		$author$project$Ui$Typography$pre,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('SELECT * FROM users WHERE id = 1;')
			])),
		A2(
		$author$project$Ui$Typography$pre,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('This is a long line that will wrap instead of causing horizontal scroll when it exceeds the container width.')
			]))
	]);
var $author$project$Generated$StyleGuide$Examples$preExampleBasic = '\n    [ Typography.pre [] [ text "SELECT * FROM users WHERE id = 1;" ]\n    , Typography.pre [] [ text "This is a long line that will wrap instead of causing horizontal scroll when it exceeds the container width." ]\n    ]\n    ';
var $author$project$Pages$StyleGuide$Pre$view = function (_v0) {
	return {
		fO: _List_fromArray(
			[
				$author$project$Ui$Typography$headingLg(
				_List_fromArray(
					[
						$elm$html$Html$text('Pre')
					])),
				A2(
				$author$project$Components$StyleGuide$Example$view,
				_List_fromArray(
					[
						$author$project$Components$StyleGuide$Example$title('Basic')
					]),
				{NN: $author$project$Generated$StyleGuide$Examples$preExampleBasic, G1: $author$project$Pages$StyleGuide$Pre$exampleBasic})
			]),
		ac9: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$Pre$page = $author$project$Spa$Page$static($author$project$Pages$StyleGuide$Pre$view);
var $author$project$Pages$StyleGuide$ProgressBar$exampleLabel = _List_fromArray(
	[
		$author$project$Ui$ProgressBar$view(
		_List_fromArray(
			[
				$author$project$Ui$ProgressBar$width(70.512),
				$author$project$Ui$ProgressBar$showProgress
			]))
	]);
var $author$project$Pages$StyleGuide$ProgressBar$exampleStacked = _List_fromArray(
	[
		$author$project$Ui$ProgressBar$stacked(
		_List_fromArray(
			[
				$author$project$Ui$ProgressBar$bar(
				_List_fromArray(
					[
						$author$project$Ui$ProgressBar$success,
						$author$project$Ui$ProgressBar$width(20)
					])),
				$author$project$Ui$ProgressBar$bar(
				_List_fromArray(
					[
						$author$project$Ui$ProgressBar$warning,
						$author$project$Ui$ProgressBar$width(30)
					])),
				$author$project$Ui$ProgressBar$bar(
				_List_fromArray(
					[
						$author$project$Ui$ProgressBar$danger,
						$author$project$Ui$ProgressBar$width(40)
					]))
			]))
	]);
var $author$project$Pages$StyleGuide$ProgressBar$exampleStriped = _List_fromArray(
	[
		$author$project$Ui$ProgressBar$view(
		_List_fromArray(
			[
				$author$project$Ui$ProgressBar$striped,
				$author$project$Ui$ProgressBar$width(40)
			])),
		$author$project$Ui$ProgressBar$view(
		_List_fromArray(
			[
				$author$project$Ui$ProgressBar$striped,
				$author$project$Ui$ProgressBar$animated,
				$author$project$Ui$ProgressBar$width(60)
			]))
	]);
var $author$project$Pages$StyleGuide$ProgressBar$exampleStyles = _List_fromArray(
	[
		$author$project$Ui$ProgressBar$view(
		_List_fromArray(
			[
				$author$project$Ui$ProgressBar$width(30)
			])),
		$author$project$Ui$ProgressBar$view(
		_List_fromArray(
			[
				$author$project$Ui$ProgressBar$success,
				$author$project$Ui$ProgressBar$width(40)
			])),
		$author$project$Ui$ProgressBar$view(
		_List_fromArray(
			[
				$author$project$Ui$ProgressBar$warning,
				$author$project$Ui$ProgressBar$width(50)
			])),
		$author$project$Ui$ProgressBar$view(
		_List_fromArray(
			[
				$author$project$Ui$ProgressBar$danger,
				$author$project$Ui$ProgressBar$width(70)
			]))
	]);
var $author$project$Generated$StyleGuide$Examples$progressBarExampleLabel = '\n    [ ProgressBar.view [ ProgressBar.width 70.512, ProgressBar.showProgress ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$progressBarExampleStacked = '\n    [ ProgressBar.stacked\n        [ ProgressBar.bar [ ProgressBar.success, ProgressBar.width 20 ]\n        , ProgressBar.bar [ ProgressBar.warning, ProgressBar.width 30 ]\n        , ProgressBar.bar [ ProgressBar.danger, ProgressBar.width 40 ]\n        ]\n    ]\n    ';
var $author$project$Generated$StyleGuide$Examples$progressBarExampleStriped = '\n    [ ProgressBar.view [ ProgressBar.striped, ProgressBar.width 40 ]\n    , ProgressBar.view [ ProgressBar.striped, ProgressBar.animated, ProgressBar.width 60 ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$progressBarExampleStyles = '\n    [ ProgressBar.view [ ProgressBar.width 30 ]\n    , ProgressBar.view [ ProgressBar.success, ProgressBar.width 40 ]\n    , ProgressBar.view [ ProgressBar.warning, ProgressBar.width 50 ]\n    , ProgressBar.view [ ProgressBar.danger, ProgressBar.width 70 ]\n    ]    ';
var $author$project$Pages$StyleGuide$ProgressBar$view = function (_v0) {
	return {
		fO: _List_fromArray(
			[
				$author$project$Ui$Typography$headingLg(
				_List_fromArray(
					[
						$elm$html$Html$text('Progress Bar')
					])),
				A2(
				$author$project$Components$StyleGuide$Example$view,
				_List_fromArray(
					[
						$author$project$Components$StyleGuide$Example$title('Styles')
					]),
				{NN: $author$project$Generated$StyleGuide$Examples$progressBarExampleStyles, G1: $author$project$Pages$StyleGuide$ProgressBar$exampleStyles}),
				A2(
				$author$project$Components$StyleGuide$Example$view,
				_List_fromArray(
					[
						$author$project$Components$StyleGuide$Example$title('Striped & Animated')
					]),
				{NN: $author$project$Generated$StyleGuide$Examples$progressBarExampleStriped, G1: $author$project$Pages$StyleGuide$ProgressBar$exampleStriped}),
				A2(
				$author$project$Components$StyleGuide$Example$view,
				_List_fromArray(
					[
						$author$project$Components$StyleGuide$Example$title('With Label')
					]),
				{NN: $author$project$Generated$StyleGuide$Examples$progressBarExampleLabel, G1: $author$project$Pages$StyleGuide$ProgressBar$exampleLabel}),
				A2(
				$author$project$Components$StyleGuide$Example$view,
				_List_fromArray(
					[
						$author$project$Components$StyleGuide$Example$title('Stacked')
					]),
				{NN: $author$project$Generated$StyleGuide$Examples$progressBarExampleStacked, G1: $author$project$Pages$StyleGuide$ProgressBar$exampleStacked})
			]),
		ac9: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$ProgressBar$page = $author$project$Spa$Page$static($author$project$Pages$StyleGuide$ProgressBar$view);
var $author$project$Pages$StyleGuide$Radio$init = function (_v0) {
	return {rB: 'A', aB: 'A'};
};
var $author$project$Pages$StyleGuide$Radio$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var value = msg.a;
			return _Utils_update(
				model,
				{aB: value});
		} else {
			var value = msg.a;
			return _Utils_update(
				model,
				{rB: value});
		}
	});
var $author$project$Pages$StyleGuide$Radio$Selected = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$StyleGuide$Radio$example = function (model) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Form$Radio$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Radio$value(model.aB === 'A'),
					$author$project$Ui$Form$Radio$onCheck(
					$elm$core$Basics$always(
						$author$project$Pages$StyleGuide$Radio$Selected('A')))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Option A')
				])),
			A2(
			$author$project$Ui$Form$Radio$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Radio$value(model.aB === 'B'),
					$author$project$Ui$Form$Radio$onCheck(
					$elm$core$Basics$always(
						$author$project$Pages$StyleGuide$Radio$Selected('B')))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Option B')
				])),
			A2(
			$author$project$Ui$Form$Radio$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Radio$value(model.aB === 'C'),
					$author$project$Ui$Form$Radio$onCheck(
					$elm$core$Basics$always(
						$author$project$Pages$StyleGuide$Radio$Selected('C')))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Option C')
				]))
		]);
};
var $author$project$Pages$StyleGuide$Radio$CardSelected = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$StyleGuide$Radio$exampleCard = function (model) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Form$Radio$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Radio$card,
					$author$project$Ui$Form$Radio$value(model.rB === 'A'),
					$author$project$Ui$Form$Radio$onCheck(
					$elm$core$Basics$always(
						$author$project$Pages$StyleGuide$Radio$CardSelected('A')))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Option A')
				])),
			A2(
			$author$project$Ui$Form$Radio$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Radio$card,
					$author$project$Ui$Form$Radio$value(model.rB === 'B'),
					$author$project$Ui$Form$Radio$onCheck(
					$elm$core$Basics$always(
						$author$project$Pages$StyleGuide$Radio$CardSelected('B')))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Option B')
				]))
		]);
};
var $author$project$Pages$StyleGuide$Radio$exampleDisabled = _List_fromArray(
	[
		A2(
		$author$project$Ui$Form$Radio$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Radio$value(true),
				$author$project$Ui$Form$Radio$disabled(true)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Disabled checked')
			])),
		A2(
		$author$project$Ui$Form$Radio$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Radio$value(false),
				$author$project$Ui$Form$Radio$disabled(true)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Disabled unchecked')
			]))
	]);
var $author$project$Generated$StyleGuide$Examples$radioExample = '\n    [ Radio.view [ Radio.value (model.selected == "A"), Radio.onCheck (always (Selected "A")) ] [ text "Option A" ]\n    , Radio.view [ Radio.value (model.selected == "B"), Radio.onCheck (always (Selected "B")) ] [ text "Option B" ]\n    , Radio.view [ Radio.value (model.selected == "C"), Radio.onCheck (always (Selected "C")) ] [ text "Option C" ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$radioExampleCard = '\n    [ Radio.view\n        [ Radio.card\n        , Radio.value (model.cardSelected == "A")\n        , Radio.onCheck (always (CardSelected "A"))\n        ]\n        [ text "Option A" ]\n    , Radio.view\n        [ Radio.card\n        , Radio.value (model.cardSelected == "B")\n        , Radio.onCheck (always (CardSelected "B"))\n        ]\n        [ text "Option B" ]\n    ]\n    ';
var $author$project$Generated$StyleGuide$Examples$radioExampleDisabled = '\n    [ Radio.view [ Radio.value True, Radio.disabled True ] [ text "Disabled checked" ]\n    , Radio.view [ Radio.value False, Radio.disabled True ] [ text "Disabled unchecked" ]\n    ]    ';
var $author$project$Pages$StyleGuide$Radio$viewBody = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Typography$headingLg(
				_List_fromArray(
					[
						$elm$html$Html$text('Form > Radio')
					])),
				A2(
				$author$project$Components$StyleGuide$Example$view,
				_List_fromArray(
					[
						$author$project$Components$StyleGuide$Example$title('Basic')
					]),
				{
					NN: $author$project$Generated$StyleGuide$Examples$radioExample,
					G1: $author$project$Pages$StyleGuide$Radio$example(model)
				}),
				A2(
				$author$project$Components$StyleGuide$Example$view,
				_List_fromArray(
					[
						$author$project$Components$StyleGuide$Example$title('Disabled')
					]),
				{NN: $author$project$Generated$StyleGuide$Examples$radioExampleDisabled, G1: $author$project$Pages$StyleGuide$Radio$exampleDisabled}),
				A2(
				$author$project$Components$StyleGuide$Example$view,
				_List_fromArray(
					[
						$author$project$Components$StyleGuide$Example$title('Card')
					]),
				{
					NN: $author$project$Generated$StyleGuide$Examples$radioExampleCard,
					G1: $author$project$Pages$StyleGuide$Radio$exampleCard(model)
				})
			]));
};
var $author$project$Pages$StyleGuide$Radio$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				$author$project$Pages$StyleGuide$Radio$viewBody(model)
			]),
		ac9: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$Radio$page = $author$project$Spa$Page$sandbox(
	{ah_: $author$project$Pages$StyleGuide$Radio$init, adT: $author$project$Pages$StyleGuide$Radio$update, amo: $author$project$Pages$StyleGuide$Radio$view});
var $author$project$Pages$StyleGuide$ResourceFilter$LocationResourceFilterMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$StyleGuide$ResourceFilter$PlanResourceFilterMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$StyleGuide$ResourceFilter$init = F4(
	function (session, _v0, _v1, _v2) {
		var apiClient = _v1.Gv;
		var _v3 = A4(
			$author$project$Components$ResourceFilter$Plan$init,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{
						De: _List_fromArray(
							[0, 1])
					});
			},
			$elm$core$Basics$identity);
		var planResourceFilter = _v3.a;
		var planResourceFilterCmd = _v3.b;
		var _v4 = A4($author$project$Components$ResourceFilter$Location$init, apiClient, $elm$core$Maybe$Nothing, $elm$core$Basics$identity, $elm$core$Basics$identity);
		var locationResourceFilter = _v4.a;
		var locationResourceFilterCmd = _v4.b;
		return _Utils_Tuple2(
			{Gv: apiClient, ais: $author$project$Components$ResourceFilter$None, os: locationResourceFilter, Jb: $author$project$Components$ResourceFilter$None, hi: planResourceFilter},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$ResourceFilter$PlanResourceFilterMsg, planResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$ResourceFilter$LocationResourceFilterMsg, locationResourceFilterCmd)
					])));
	});
var $author$project$Pages$StyleGuide$ResourceFilter$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$StyleGuide$ResourceFilter$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$StyleGuide$ResourceFilter$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$StyleGuide$ResourceFilter$PlanResourceFilterMsg,
				$author$project$Components$ResourceFilter$Plan$subscriptions(model.hi)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$StyleGuide$ResourceFilter$LocationResourceFilterMsg,
				$author$project$Components$ResourceFilter$Location$subscriptions(model.os))
			]));
};
var $author$project$Pages$StyleGuide$ResourceFilter$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var subMsg = msg.a;
			var planResourceResult = A3($author$project$Components$ResourceFilter$Plan$update, model.Gv, subMsg, model.hi);
			var modelAfterEvent = function () {
				var _v1 = planResourceResult.agZ;
				if (!_v1.$) {
					var selected = _v1.a;
					return _Utils_update(
						model,
						{Jb: selected});
				} else {
					return model;
				}
			}();
			return _Utils_Tuple3(
				_Utils_update(
					modelAfterEvent,
					{hi: planResourceResult.aiO}),
				A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$ResourceFilter$PlanResourceFilterMsg, planResourceResult.GZ),
				planResourceResult.aR);
		} else {
			var subMsg = msg.a;
			var locationResourceResult = A3($author$project$Components$ResourceFilter$Location$update, model.Gv, subMsg, model.os);
			var modelAfterEvent = function () {
				var _v2 = locationResourceResult.agZ;
				if (!_v2.$) {
					var selected = _v2.a;
					return _Utils_update(
						model,
						{ais: selected});
				} else {
					return model;
				}
			}();
			return _Utils_Tuple3(
				_Utils_update(
					modelAfterEvent,
					{os: locationResourceResult.aiO}),
				A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$ResourceFilter$LocationResourceFilterMsg, locationResourceResult.GZ),
				locationResourceResult.aR);
		}
	});
var $author$project$Pages$StyleGuide$ResourceFilter$planName = function (choice) {
	switch (choice.$) {
		case 2:
			return 'All';
		case 3:
			return 'None';
		case 0:
			var plan = choice.a;
			return $author$project$Api$Plan$name(plan);
		case 1:
			var plans = choice.a;
			return A2(
				$elm$core$String$join,
				', ',
				A2($elm$core$List$map, $author$project$Api$Plan$name, plans));
		case 4:
			var extraItem = choice.a;
			return extraItem.aih;
		default:
			var string = choice.a;
			return 'Custom: ' + string;
	}
};
var $author$project$Pages$StyleGuide$ResourceFilter$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				$author$project$Ui$Typography$headingLg(
				_List_fromArray(
					[
						$elm$html$Html$text('Resource Filter')
					])),
				$author$project$Ui$Typography$heading(
				_List_fromArray(
					[
						$elm$html$Html$text('Plan')
					])),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$StyleGuide$ResourceFilter$PlanResourceFilterMsg,
				A2($author$project$Components$ResourceFilter$Plan$view, _List_Nil, model.hi)),
				$elm$html$Html$text(
				'Plan: ' + $author$project$Pages$StyleGuide$ResourceFilter$planName(model.Jb)),
				$author$project$Ui$Typography$heading(
				_List_fromArray(
					[
						$elm$html$Html$text('Location')
					])),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$StyleGuide$ResourceFilter$LocationResourceFilterMsg,
				A2($author$project$Components$ResourceFilter$Location$view, _List_Nil, model.os)),
				$elm$html$Html$text(
				'Location: ' + A2(
					$elm$core$Maybe$withDefault,
					'None',
					$author$project$Components$ResourceFilter$Location$value(model.os))),
				$author$project$Ui$Typography$heading(
				_List_fromArray(
					[
						$elm$html$Html$text('Location (disabled)')
					])),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$StyleGuide$ResourceFilter$LocationResourceFilterMsg,
				A2(
					$author$project$Components$ResourceFilter$Location$view,
					_List_fromArray(
						[
							$author$project$Components$ResourceFilter$disabled(true)
						]),
					model.os))
			]),
		ac9: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$ResourceFilter$page = $author$project$Spa$Page$applicationPractice(
	{ah_: $author$project$Pages$StyleGuide$ResourceFilter$init, aiq: $author$project$Pages$StyleGuide$ResourceFilter$load, k8: $author$project$Pages$StyleGuide$ResourceFilter$save, alO: $author$project$Pages$StyleGuide$ResourceFilter$subscriptions, adT: $author$project$Pages$StyleGuide$ResourceFilter$update, amo: $author$project$Pages$StyleGuide$ResourceFilter$view});
var $author$project$Pages$StyleGuide$SearchInput$urlParams = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('q'),
			model.akl)
		]);
	return $elm$core$Dict$fromList(
		A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams));
};
var $author$project$Pages$StyleGuide$SearchInput$buildUrl = function (model) {
	return A2(
		$elm$url$Url$Builder$relative,
		_List_fromArray(
			[
				$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$StyleGuide__SearchInput)
			]),
		$author$project$Utils$QueryParameter$fromDict(
			$author$project$Pages$StyleGuide$SearchInput$urlParams(model)));
};
var $author$project$Pages$StyleGuide$SearchInput$GotHeroes = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$StyleGuide$SearchInput$Hero = $elm$core$Basics$identity;
var $author$project$Pages$StyleGuide$SearchInput$heroes = _List_fromArray(
	[
		{ahP: '1', Bq: 'Batman'},
		{ahP: 'spidey', Bq: 'Spiderman'},
		{ahP: 'drstrange', Bq: 'Dr Strange'},
		{ahP: '2', Bq: 'The Flash'},
		{ahP: 'ironman', Bq: 'Ironman'}
	]);
var $author$project$Pages$StyleGuide$SearchInput$searchHeroes = function (query) {
	return A2(
		$elm$core$List$filter,
		function (choice) {
			var _v0 = _Utils_Tuple2(query, choice);
			if (!_v0.a.$) {
				var query_ = _v0.a.a;
				var hero = _v0.b;
				return A2($elm$core$String$contains, query_, hero.Bq);
			} else {
				return true;
			}
		},
		$author$project$Pages$StyleGuide$SearchInput$heroes);
};
var $author$project$Pages$StyleGuide$SearchInput$fetchHeroes = function (model) {
	return A2(
		$elm$core$Task$perform,
		function (_v0) {
			return $author$project$Pages$StyleGuide$SearchInput$GotHeroes(
				$author$project$Pages$StyleGuide$SearchInput$searchHeroes(model.akl));
		},
		$elm$core$Process$sleep(1500));
};
var $author$project$Pages$StyleGuide$SearchInput$init = F2(
	function (_v0, _v1) {
		var query = _v1.DE;
		var q = A2($elm$core$Dict$get, 'q', query);
		var model = {
			sy: _List_Nil,
			V8: $author$project$Utils$Maybe$toBool(q),
			akl: q,
			up: $author$project$Ui$SearchInput$init(q)
		};
		return _Utils_Tuple3(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Pages$StyleGuide$SearchInput$fetchHeroes(model),
						A2($elm$core$Basics$composeR, $author$project$Pages$StyleGuide$SearchInput$buildUrl, $author$project$Ports$Navigation$replaceUrl)(model)
					])),
			_List_Nil);
	});
var $author$project$Pages$StyleGuide$SearchInput$load = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$StyleGuide$SearchInput$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$StyleGuide$SearchInput$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$StyleGuide$SearchInput$SearchInputMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$StyleGuide$SearchInput$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var subMsg = msg.a;
			var _v1 = A2($author$project$Ui$SearchInput$update, subMsg, model.up);
			var searchInput = _v1.a;
			var searchInputCmd = _v1.b;
			var searchInputEvent = _v1.c;
			var q = function () {
				if (searchInputEvent.$ === 1) {
					var query = searchInputEvent.a;
					return query;
				} else {
					return model.akl;
				}
			}();
			var _v2 = function () {
				if (_Utils_eq(q, model.akl)) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var qModel = _Utils_update(
						model,
						{V8: true, akl: q});
					return _Utils_Tuple2(
						qModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Pages$StyleGuide$SearchInput$fetchHeroes(qModel),
									A2($elm$core$Basics$composeR, $author$project$Pages$StyleGuide$SearchInput$buildUrl, $author$project$Ports$Navigation$pushUrl)(qModel)
								])));
				}
			}();
			var newModel = _v2.a;
			var cmd = _v2.b;
			return _Utils_Tuple3(
				_Utils_update(
					newModel,
					{up: searchInput}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$SearchInput$SearchInputMsg, searchInputCmd),
							cmd
						])),
				_List_Nil);
		} else {
			var heroes_ = msg.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{sy: heroes_, V8: false}),
				$elm$core$Platform$Cmd$none,
				_List_Nil);
		}
	});
var $author$project$Pages$StyleGuide$SearchInput$heroToLabel = function (_v0) {
	var hero = _v0;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(hero.Bq)
			]));
};
var $author$project$Pages$StyleGuide$SearchInput$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				$author$project$Ui$Typography$headingLg(
				_List_fromArray(
					[
						$elm$html$Html$text('Search Input')
					])),
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$StyleGuide$SearchInput$SearchInputMsg,
								A2(
									$author$project$Ui$SearchInput$view,
									_List_fromArray(
										[
											$author$project$Ui$SearchInput$placeholder('Search for heroes'),
											$author$project$Ui$SearchInput$phi(false),
											$author$project$Ui$SearchInput$loading(model.V8)
										]),
									model.up))
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Typography$heading(
								_List_fromArray(
									[
										$elm$html$Html$text('Search results')
									])),
								$elm$core$List$isEmpty(model.sy) ? $elm$html$Html$text('None') : A2(
								$elm$html$Html$div,
								_List_Nil,
								A2($elm$core$List$map, $author$project$Pages$StyleGuide$SearchInput$heroToLabel, model.sy))
							]))
					]))
			]),
		ac9: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$SearchInput$page = $author$project$Spa$Page$application(
	{ah_: $author$project$Pages$StyleGuide$SearchInput$init, aiq: $author$project$Pages$StyleGuide$SearchInput$load, k8: $author$project$Pages$StyleGuide$SearchInput$save, alO: $author$project$Pages$StyleGuide$SearchInput$subscriptions, adT: $author$project$Pages$StyleGuide$SearchInput$update, amo: $author$project$Pages$StyleGuide$SearchInput$view});
var $author$project$Pages$StyleGuide$Select$init = function (_v0) {
	return _Utils_Tuple2(
		{Ep: 'spidey'},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$StyleGuide$Select$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$StyleGuide$Select$update = F2(
	function (msg, model) {
		var selectedHero = msg;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{Ep: selectedHero}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$StyleGuide$Select$HeroSelected = $elm$core$Basics$identity;
var $author$project$Pages$StyleGuide$Select$heroChoices = _List_fromArray(
	[
		{ahP: '1', Bq: 'Batman', lR: 'DC'},
		{ahP: 'spidey', Bq: 'Spiderman', lR: 'Marver'},
		{ahP: 'drstrange', Bq: 'Dr Strange', lR: 'Marver'},
		{ahP: '2', Bq: 'The Flash', lR: 'DC'}
	]);
var $author$project$Pages$StyleGuide$Select$heroGroupOptions = function (heroes) {
	return A2(
		$elm$core$List$map,
		function (hero) {
			return A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(hero.ahP),
				hero.Bq);
		},
		heroes);
};
var $author$project$Pages$StyleGuide$Select$heroOptions = function (heroes) {
	return A2(
		$elm$core$List$map,
		function (_v0) {
			var hero = _v0.a;
			var grouped = _v0.b;
			return A2(
				$author$project$Ui$Form$Select$group,
				hero.lR,
				$author$project$Pages$StyleGuide$Select$heroGroupOptions(
					A2($elm$core$List$cons, hero, grouped)));
		},
		A2(
			$elm_community$list_extra$List$Extra$gatherEqualsBy,
			function ($) {
				return $.lR;
			},
			heroes));
};
var $author$project$Pages$StyleGuide$Select$viewBody = function (model) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('section')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingLg(
					_List_fromArray(
						[
							$elm$html$Html$text('Form > Select')
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(
									$elm$core$Maybe$Just(model.Ep)),
									$author$project$Ui$Form$Select$onChange($elm$core$Basics$identity)
								]),
							$author$project$Pages$StyleGuide$Select$heroOptions($author$project$Pages$StyleGuide$Select$heroChoices))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$disabled(true)
								]),
							_List_fromArray(
								[
									A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, 'Disabled')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$loading(true)
								]),
							_List_fromArray(
								[
									A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, 'Loading')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$invalid(true),
									$author$project$Ui$Form$Select$errors(
									_List_fromArray(
										['Some error']))
								]),
							_List_fromArray(
								[
									A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, 'Invalid')
								]))
						]))
				]))
		]);
};
var $author$project$Pages$StyleGuide$Select$view = function (model) {
	return {
		fO: $author$project$Pages$StyleGuide$Select$viewBody(model),
		ac9: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$Select$page = $author$project$Spa$Page$element(
	{ah_: $author$project$Pages$StyleGuide$Select$init, alO: $author$project$Pages$StyleGuide$Select$subscriptions, adT: $author$project$Pages$StyleGuide$Select$update, amo: $author$project$Pages$StyleGuide$Select$view});
var $author$project$Pages$StyleGuide$Skeleton$init = function (_v0) {
	return {};
};
var $author$project$Pages$StyleGuide$Skeleton$update = F2(
	function (_v0, model) {
		return model;
	});
var $author$project$Pages$StyleGuide$Skeleton$exampleFormGroup = _List_fromArray(
	[
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$labelSkeleton('Papyrus')
			]),
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$input(_List_Nil)
			])),
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$labelSkeleton('Sans')
			]),
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$input(_List_Nil)
			])),
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Skeleton$text(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$span(4)
							]))
					]))
			]))
	]);
var $author$project$Pages$StyleGuide$Skeleton$exampleInput = _List_fromArray(
	[
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$spaceBetween]),
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$input(
				_List_fromArray(
					[
						$author$project$Ui$Skeleton$span(8)
					])),
				$author$project$Ui$Skeleton$input(
				_List_fromArray(
					[
						$author$project$Ui$Skeleton$span(2)
					]))
			]))
	]);
var $author$project$Pages$StyleGuide$Skeleton$exampleSpan = _List_fromArray(
	[
		$author$project$Ui$Skeleton$text(
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$block,
				$author$project$Ui$Skeleton$span(2)
			])),
		$author$project$Ui$Skeleton$text(
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$block,
				$author$project$Ui$Skeleton$span(4)
			])),
		$author$project$Ui$Skeleton$text(
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$block,
				$author$project$Ui$Skeleton$span(6)
			])),
		$author$project$Ui$Skeleton$text(
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$block,
				$author$project$Ui$Skeleton$span(8)
			])),
		$author$project$Ui$Skeleton$text(
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$block,
				$author$project$Ui$Skeleton$span(10)
			])),
		$author$project$Ui$Skeleton$text(
		_List_fromArray(
			[$author$project$Ui$Skeleton$block]))
	]);
var $author$project$Pages$StyleGuide$Skeleton$exampleSpanFromText = _List_fromArray(
	[
		A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('The sight of such a friendly skeleton fills you with determination.')
			])),
		$author$project$Ui$Skeleton$text(
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$spanFromText('The sight of such a friendly skeleton fills you with determination.')
			])),
		A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('I can cook spaghetti')
			])),
		$author$project$Ui$Skeleton$text(
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$spanFromText('I can cook spaghetti')
			])),
		A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Its a beautiful day outside')
			])),
		$author$project$Ui$Skeleton$text(
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$spanFromText('Its a beautiful day outside')
			]))
	]);
var $author$project$Pages$StyleGuide$Skeleton$exampleTableWithPagination = _List_fromArray(
	[
		A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$loading(true)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Header 1')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Header 2')
					]))
			]),
		_List_Nil,
		_List_Nil),
		$author$project$Ui$Pagination$List$view(
		_List_fromArray(
			[
				$author$project$Ui$Pagination$List$loading(true)
			]))
	]);
var $author$project$Pages$StyleGuide$Skeleton$exampleText = _List_fromArray(
	[
		A2(
		$elm$html$Html$h1,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$text(_List_Nil)
			])),
		A2(
		$elm$html$Html$h2,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$text(_List_Nil)
			])),
		A2(
		$elm$html$Html$h3,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$text(_List_Nil)
			])),
		A2(
		$elm$html$Html$p,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$text(_List_Nil)
			]))
	]);
var $author$project$Generated$StyleGuide$Examples$skeletonExampleFormGroup = '\n    [ FormGroup.view\n        [ FormGroup.labelSpan 4\n        , FormGroup.inputSpan 8\n        , FormGroup.labelSkeleton "Papyrus"\n        ]\n        [ Skeleton.input []\n        ]\n    , FormGroup.view\n        [ FormGroup.labelSpan 4\n        , FormGroup.inputSpan 8\n        , FormGroup.labelSkeleton "Sans"\n        ]\n        [ Skeleton.input []\n        ]\n    , FormGroup.view\n        [ FormGroup.labelSpan 4\n        , FormGroup.inputSpan 8\n        , FormGroup.label ""\n        ]\n        [ FormStatic.view [] [ Skeleton.text [ Skeleton.span 4 ] ]\n        ]\n    ]\n    ';
var $author$project$Generated$StyleGuide$Examples$skeletonExampleInput = '\n    [ Element.view [ Element.spaceBetween ]\n        [ Skeleton.input [ Skeleton.span 8 ]\n        , Skeleton.input [ Skeleton.span 2 ]\n        ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$skeletonExampleSpan = '\n    [ Skeleton.text [ Skeleton.block, Skeleton.span 2 ]\n    , Skeleton.text [ Skeleton.block, Skeleton.span 4 ]\n    , Skeleton.text [ Skeleton.block, Skeleton.span 6 ]\n    , Skeleton.text [ Skeleton.block, Skeleton.span 8 ]\n    , Skeleton.text [ Skeleton.block, Skeleton.span 10 ]\n    , Skeleton.text [ Skeleton.block ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$skeletonExampleSpanFromText = '\n    [ Html.div [] [ text "The sight of such a friendly skeleton fills you with determination." ]\n    , Skeleton.text [ Skeleton.spanFromText "The sight of such a friendly skeleton fills you with determination." ]\n    , Html.div [] [ text "I can cook spaghetti" ]\n    , Skeleton.text [ Skeleton.spanFromText "I can cook spaghetti" ]\n    , Html.div [] [ text "Its a beautiful day outside" ]\n    , Skeleton.text [ Skeleton.spanFromText "Its a beautiful day outside" ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$skeletonExampleTableWithPagination = '\n    [ Table.view [ Table.loading True ]\n        [ Table.header [] [ text "Header 1" ]\n        , Table.header [] [ text "Header 2" ]\n        ]\n        []\n        []\n    , Pagination.view [ Pagination.loading True ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$skeletonExampleText = '\n    [ Html.h1 [] [ Skeleton.text [] ]\n    , Html.h2 [] [ Skeleton.text [] ]\n    , Html.h3 [] [ Skeleton.text [] ]\n    , Html.p [] [ Skeleton.text [] ]\n    ]    ';
var $author$project$Pages$StyleGuide$Skeleton$viewBody = _List_fromArray(
	[
		A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Panel$title(
						_List_fromArray(
							[
								$elm$html$Html$text('Skeletons')
							]))
					])),
				$author$project$Ui$Panel$hr,
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Skeletons are the main activity indicator.')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('They can be used alongside progressive loading techniques to enhance the user experience and reduce the perception of waiting time.')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Skeletons are the go to component on first loads or when the data shown is stale and new one being loaded (like on tables).')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('They also look pretty good in my (biased) opinion')
							]))
					]))
			])),
		A2(
		$author$project$Ui$Grid$row,
		_List_fromArray(
			[$author$project$Ui$Grid$mt4]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$spanMd(6)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Components$StyleGuide$Example$view,
						_List_fromArray(
							[
								$author$project$Components$StyleGuide$Example$title('Text Skeleton'),
								$author$project$Components$StyleGuide$Example$description(
								_List_fromArray(
									[
										$elm$html$Html$text('The height will adjust based on font size, so they can be used inside headings.')
									]))
							]),
						{NN: $author$project$Generated$StyleGuide$Examples$skeletonExampleText, G1: $author$project$Pages$StyleGuide$Skeleton$exampleText})
					])),
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$spanMd(6)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Components$StyleGuide$Example$view,
						_List_fromArray(
							[
								$author$project$Components$StyleGuide$Example$title('Input Skeleton'),
								$author$project$Components$StyleGuide$Example$description(
								_List_fromArray(
									[
										$elm$html$Html$text('Buttons count as inputs')
									]))
							]),
						{NN: $author$project$Generated$StyleGuide$Examples$skeletonExampleInput, G1: $author$project$Pages$StyleGuide$Skeleton$exampleInput})
					])),
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$spanMd(6)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Components$StyleGuide$Example$view,
						_List_fromArray(
							[
								$author$project$Components$StyleGuide$Example$title('Input Span'),
								$author$project$Components$StyleGuide$Example$description(
								_List_fromArray(
									[
										$elm$html$Html$text('Same API as grid, they also support responsive spans (spanSm, spanMd, spanLg)')
									]))
							]),
						{NN: $author$project$Generated$StyleGuide$Examples$skeletonExampleSpan, G1: $author$project$Pages$StyleGuide$Skeleton$exampleSpan})
					])),
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$spanMd(6)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Components$StyleGuide$Example$view,
						_List_fromArray(
							[
								$author$project$Components$StyleGuide$Example$title('Span from Text'),
								$author$project$Components$StyleGuide$Example$description(
								_List_fromArray(
									[
										$elm$html$Html$text('If the text is known beforehand it can be used directly to take the same space')
									]))
							]),
						{NN: $author$project$Generated$StyleGuide$Examples$skeletonExampleSpanFromText, G1: $author$project$Pages$StyleGuide$Skeleton$exampleSpanFromText})
					])),
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$spanMd(6)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Components$StyleGuide$Example$view,
						_List_fromArray(
							[
								$author$project$Components$StyleGuide$Example$title('Table with Pagination')
							]),
						{NN: $author$project$Generated$StyleGuide$Examples$skeletonExampleTableWithPagination, G1: $author$project$Pages$StyleGuide$Skeleton$exampleTableWithPagination})
					])),
				A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$spanMd(6)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Components$StyleGuide$Example$view,
						_List_fromArray(
							[
								$author$project$Components$StyleGuide$Example$title('Form Group')
							]),
						{NN: $author$project$Generated$StyleGuide$Examples$skeletonExampleFormGroup, G1: $author$project$Pages$StyleGuide$Skeleton$exampleFormGroup})
					]))
			]))
	]);
var $author$project$Pages$StyleGuide$Skeleton$view = function (_v0) {
	return {fO: $author$project$Pages$StyleGuide$Skeleton$viewBody, ac9: 'Style Guide'};
};
var $author$project$Pages$StyleGuide$Skeleton$page = $author$project$Spa$Page$sandbox(
	{ah_: $author$project$Pages$StyleGuide$Skeleton$init, adT: $author$project$Pages$StyleGuide$Skeleton$update, amo: $author$project$Pages$StyleGuide$Skeleton$view});
var $author$project$Pages$StyleGuide$Spinner$exampleSizes = _List_fromArray(
	[
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap4]),
		_List_fromArray(
			[
				$author$project$Ui$Spinner$view(_List_Nil),
				$author$project$Ui$Spinner$view(
				_List_fromArray(
					[$author$project$Ui$Spinner$small])),
				$author$project$Ui$Spinner$view(
				_List_fromArray(
					[$author$project$Ui$Spinner$extraSmall])),
				$author$project$Ui$Spinner$view(
				_List_fromArray(
					[$author$project$Ui$Spinner$large]))
			]))
	]);
var $author$project$Generated$StyleGuide$Examples$spinnerExampleSizes = '\n    [ Element.view [ Element.flex, Element.itemsCenter, Element.gap4 ]\n        [ Spinner.view []\n        , Spinner.view [ Spinner.small ]\n        , Spinner.view [ Spinner.extraSmall ]\n        , Spinner.view [ Spinner.large ]\n        ]\n    ]\n    ';
var $author$project$Pages$StyleGuide$Spinner$view = function (_v0) {
	return {
		fO: _List_fromArray(
			[
				$author$project$Ui$Typography$headingLg(
				_List_fromArray(
					[
						$elm$html$Html$text('Spinner')
					])),
				A2(
				$author$project$Components$StyleGuide$Example$view,
				_List_fromArray(
					[
						$author$project$Components$StyleGuide$Example$title('Sizes')
					]),
				{NN: $author$project$Generated$StyleGuide$Examples$spinnerExampleSizes, G1: $author$project$Pages$StyleGuide$Spinner$exampleSizes})
			]),
		ac9: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$Spinner$page = $author$project$Spa$Page$static($author$project$Pages$StyleGuide$Spinner$view);
var $author$project$Pages$StyleGuide$Table$Id = 0;
var $author$project$Pages$StyleGuide$Table$init = function (_v0) {
	return _Utils_Tuple2(
		{lu: 0, lv: 1},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$StyleGuide$Table$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$StyleGuide$Table$update = F2(
	function (msg, model) {
		var column = msg;
		var newDirection = function () {
			if (_Utils_eq(model.lu, column)) {
				var _v1 = model.lv;
				if (!_v1) {
					return 1;
				} else {
					return 0;
				}
			} else {
				return 0;
			}
		}();
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{lu: column, lv: newDirection}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$StyleGuide$Table$Name = 1;
var $author$project$Pages$StyleGuide$Table$Datum = F3(
	function (id, name, ring) {
		return {ahP: id, Bq: name, $6: ring};
	});
var $author$project$Pages$StyleGuide$Table$data = _List_fromArray(
	[
		A3($author$project$Pages$StyleGuide$Table$Datum, 1, 'Mercury', 'Inner'),
		A3($author$project$Pages$StyleGuide$Table$Datum, 2, 'Venus', 'Inner'),
		A3($author$project$Pages$StyleGuide$Table$Datum, 3, 'Earth', 'Inner'),
		A3($author$project$Pages$StyleGuide$Table$Datum, 4, 'Mars', 'Inner'),
		A3($author$project$Pages$StyleGuide$Table$Datum, 5, 'Jupiter', 'Outer')
	]);
var $author$project$Pages$StyleGuide$Table$sort = F3(
	function (column, direction, items) {
		return function () {
			if (!direction) {
				return $elm$core$List$reverse;
			} else {
				return $elm$core$Basics$identity;
			}
		}()(
			A2(
				$elm$core$List$sortWith,
				F2(
					function (one, other) {
						if (!column) {
							return A2($elm$core$Basics$compare, one.ahP, other.ahP);
						} else {
							return A2($elm$core$Basics$compare, one.Bq, other.Bq);
						}
					}),
				items));
	});
var $author$project$Pages$StyleGuide$Table$SortTable = $elm$core$Basics$identity;
var $author$project$Pages$StyleGuide$Table$sortableHeaderAttributes = F3(
	function (sortColumn, sortDirection, column) {
		var columnSort = _Utils_eq(column, sortColumn) ? _List_fromArray(
			[
				$author$project$Ui$Table$sortDirection(sortDirection)
			]) : _List_Nil;
		return $elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						$author$project$Ui$Table$onClick(column),
						$author$project$Ui$Table$sortable(true)
					]),
					columnSort
				]));
	});
var $author$project$Pages$StyleGuide$Table$viewTableRow = function (_v0) {
	var id = _v0.ahP;
	var name = _v0.Bq;
	var ring = _v0.$6;
	return A2(
		$author$project$Ui$Table$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$fromInt(id))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(name)
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(ring)
					]))
			]));
};
var $author$project$Pages$StyleGuide$Table$exampleBasic = function (model) {
	var sortedData = A3($author$project$Pages$StyleGuide$Table$sort, model.lu, model.lv, $author$project$Pages$StyleGuide$Table$data);
	return _List_fromArray(
		[
			A4(
			$author$project$Ui$Table$view,
			_List_fromArray(
				[$author$project$Ui$Table$bordered]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$header,
					A3($author$project$Pages$StyleGuide$Table$sortableHeaderAttributes, model.lu, model.lv, 0),
					_List_fromArray(
						[
							$elm$html$Html$text('Id')
						])),
					A2(
					$author$project$Ui$Table$header,
					A3($author$project$Pages$StyleGuide$Table$sortableHeaderAttributes, model.lu, model.lv, 1),
					_List_fromArray(
						[
							$elm$html$Html$text('Name')
						])),
					A2(
					$author$project$Ui$Table$header,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Ring')
						]))
				]),
			A2($elm$core$List$map, $author$project$Pages$StyleGuide$Table$viewTableRow, sortedData),
			_List_Nil)
		]);
};
var $author$project$Pages$StyleGuide$Table$exampleLoading = _List_fromArray(
	[
		A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$loading(true)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Name')
					]))
			]),
		_List_Nil,
		_List_Nil)
	]);
var $author$project$Pages$StyleGuide$Table$exampleRowStyles = _List_fromArray(
	[
		A4(
		$author$project$Ui$Table$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Style')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Usage')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$row,
				_List_fromArray(
					[
						$author$project$Ui$Table$styled(0)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('success')
							])),
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Positive outcomes')
							]))
					])),
				A2(
				$author$project$Ui$Table$row,
				_List_fromArray(
					[
						$author$project$Ui$Table$styled(1)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('info')
							])),
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Informational')
							]))
					])),
				A2(
				$author$project$Ui$Table$row,
				_List_fromArray(
					[
						$author$project$Ui$Table$styled(2)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('warning')
							])),
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Needs attention')
							]))
					])),
				A2(
				$author$project$Ui$Table$row,
				_List_fromArray(
					[
						$author$project$Ui$Table$styled(3)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('danger')
							])),
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Error or risk')
							]))
					]))
			]),
		_List_Nil)
	]);
var $author$project$Pages$StyleGuide$Table$exampleZeroState = _List_fromArray(
	[
		A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('No data for the selected period.')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Name')
					]))
			]),
		_List_Nil,
		_List_Nil)
	]);
var $author$project$Generated$StyleGuide$Examples$tableExampleBasic = '\n    let\n        sortedData =\n            sort model.sortColumn model.sortDirection data\n    in\n    [ Table.view [ Table.bordered ]\n        [ Table.header (sortableHeaderAttributes model.sortColumn model.sortDirection Id) [ text "Id" ]\n        , Table.header (sortableHeaderAttributes model.sortColumn model.sortDirection Name) [ text "Name" ]\n        , Table.header [] [ text "Ring" ]\n        ]\n        (List.map viewTableRow sortedData)\n        []\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$tableExampleLoading = '\n    [ Table.view [ Table.loading True ]\n        [ Table.header [] [ text "Name" ] ]\n        []\n        []\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$tableExampleRowStyles = '\n    [ Table.view []\n        [ Table.header [] [ text "Style" ]\n        , Table.header [] [ text "Usage" ]\n        ]\n        [ Table.row [ Table.styled Table.Success ] [ Table.cell [] [ text "success" ], Table.cell [] [ text "Positive outcomes" ] ]\n        , Table.row [ Table.styled Table.Info ] [ Table.cell [] [ text "info" ], Table.cell [] [ text "Informational" ] ]\n        , Table.row [ Table.styled Table.Warning ] [ Table.cell [] [ text "warning" ], Table.cell [] [ text "Needs attention" ] ]\n        , Table.row [ Table.styled Table.Danger ] [ Table.cell [] [ text "danger" ], Table.cell [] [ text "Error or risk" ] ]\n        ]\n        []\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$tableExampleZeroState = '\n    [ Table.view [ Table.zeroState [ text "No data for the selected period." ] ]\n        [ Table.header [] [ text "Name" ] ]\n        []\n        []\n    ]    ';
var $author$project$Pages$StyleGuide$Table$viewBody = function (model) {
	return _List_fromArray(
		[
			$author$project$Ui$Typography$headingLg(
			_List_fromArray(
				[
					$elm$html$Html$text('Table')
				])),
			A2(
			$author$project$Components$StyleGuide$Example$view,
			_List_fromArray(
				[
					$author$project$Components$StyleGuide$Example$title('Basic')
				]),
			{
				NN: $author$project$Generated$StyleGuide$Examples$tableExampleBasic,
				G1: $author$project$Pages$StyleGuide$Table$exampleBasic(model)
			}),
			A2(
			$author$project$Components$StyleGuide$Example$view,
			_List_fromArray(
				[
					$author$project$Components$StyleGuide$Example$title('Row styles')
				]),
			{NN: $author$project$Generated$StyleGuide$Examples$tableExampleRowStyles, G1: $author$project$Pages$StyleGuide$Table$exampleRowStyles}),
			A2(
			$author$project$Components$StyleGuide$Example$view,
			_List_fromArray(
				[
					$author$project$Components$StyleGuide$Example$title('Zero state')
				]),
			{NN: $author$project$Generated$StyleGuide$Examples$tableExampleZeroState, G1: $author$project$Pages$StyleGuide$Table$exampleZeroState}),
			A2(
			$author$project$Components$StyleGuide$Example$view,
			_List_fromArray(
				[
					$author$project$Components$StyleGuide$Example$title('Loading')
				]),
			{NN: $author$project$Generated$StyleGuide$Examples$tableExampleLoading, G1: $author$project$Pages$StyleGuide$Table$exampleLoading})
		]);
};
var $author$project$Pages$StyleGuide$Table$view = function (model) {
	return {
		fO: $author$project$Pages$StyleGuide$Table$viewBody(model),
		ac9: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$Table$page = $author$project$Spa$Page$element(
	{ah_: $author$project$Pages$StyleGuide$Table$init, alO: $author$project$Pages$StyleGuide$Table$subscriptions, adT: $author$project$Pages$StyleGuide$Table$update, amo: $author$project$Pages$StyleGuide$Table$view});
var $author$project$Pages$StyleGuide$Toast$init = F2(
	function (_v0, _v1) {
		return _Utils_Tuple3(
			{},
			$elm$core$Platform$Cmd$none,
			_List_Nil);
	});
var $author$project$Pages$StyleGuide$Toast$load = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$StyleGuide$Toast$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$StyleGuide$Toast$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$StyleGuide$Toast$update = F2(
	function (msg, model) {
		var level = msg.a;
		var message = msg.b;
		return _Utils_Tuple3(
			model,
			$elm$core$Platform$Cmd$none,
			_List_fromArray(
				[
					A2($author$project$OutMsg$ShowToast, level, message)
				]));
	});
var $author$project$Pages$StyleGuide$Toast$ShowToast = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Pages$StyleGuide$Toast$viewBody = _List_fromArray(
	[
		A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Show info toast'},
				_List_fromArray(
					[
						$author$project$Ui$Button$primary,
						$author$project$Ui$Button$onClick(
						A2($author$project$Pages$StyleGuide$Toast$ShowToast, 0, 'Lots of info'))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Info')
					]))
			])),
		A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Show success toast'},
				_List_fromArray(
					[
						$author$project$Ui$Button$success,
						$author$project$Ui$Button$onClick(
						A2($author$project$Pages$StyleGuide$Toast$ShowToast, 3, 'Wohoo'))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Success')
					]))
			])),
		A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Show error toast'},
				_List_fromArray(
					[
						$author$project$Ui$Button$danger,
						$author$project$Ui$Button$onClick(
						A2($author$project$Pages$StyleGuide$Toast$ShowToast, 1, 'Oopsie Daisy!'))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Error')
					]))
			])),
		A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Show warning toast'},
				_List_fromArray(
					[
						$author$project$Ui$Button$styled(4),
						$author$project$Ui$Button$onClick(
						A2($author$project$Pages$StyleGuide$Toast$ShowToast, 2, 'Halt!'))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Warning')
					]))
			]))
	]);
var $author$project$Pages$StyleGuide$Toast$view = function (_v0) {
	return {fO: $author$project$Pages$StyleGuide$Toast$viewBody, ac9: 'Style Guide'};
};
var $author$project$Pages$StyleGuide$Toast$page = $author$project$Spa$Page$application(
	{ah_: $author$project$Pages$StyleGuide$Toast$init, aiq: $author$project$Pages$StyleGuide$Toast$load, k8: $author$project$Pages$StyleGuide$Toast$save, alO: $author$project$Pages$StyleGuide$Toast$subscriptions, adT: $author$project$Pages$StyleGuide$Toast$update, amo: $author$project$Pages$StyleGuide$Toast$view});
var $author$project$Pages$StyleGuide$ToggleSwitch$init = function (_v0) {
	return {lP: true};
};
var $author$project$Pages$StyleGuide$ToggleSwitch$update = F2(
	function (msg, model) {
		var bool = msg;
		return _Utils_update(
			model,
			{lP: bool});
	});
var $author$project$Pages$StyleGuide$ToggleSwitch$ToggleSwitchChanged = $elm$core$Basics$identity;
var $author$project$Pages$StyleGuide$ToggleSwitch$example = function (value) {
	return _List_fromArray(
		[
			$author$project$Ui$ToggleSwitch$view(
			_List_fromArray(
				[
					$author$project$Ui$ToggleSwitch$on(value),
					$author$project$Ui$ToggleSwitch$onChange($elm$core$Basics$identity)
				]))
		]);
};
var $author$project$Pages$StyleGuide$ToggleSwitch$exampleDisabled = function (value) {
	return _List_fromArray(
		[
			$author$project$Ui$ToggleSwitch$view(
			_List_fromArray(
				[
					$author$project$Ui$ToggleSwitch$on(value),
					$author$project$Ui$ToggleSwitch$disabled(true),
					$author$project$Ui$ToggleSwitch$onChange($elm$core$Basics$identity)
				]))
		]);
};
var $author$project$Pages$StyleGuide$ToggleSwitch$exampleSmall = function (value) {
	return _List_fromArray(
		[
			$author$project$Ui$ToggleSwitch$view(
			_List_fromArray(
				[
					$author$project$Ui$ToggleSwitch$on(value),
					$author$project$Ui$ToggleSwitch$sm,
					$author$project$Ui$ToggleSwitch$onChange($elm$core$Basics$identity)
				]))
		]);
};
var $author$project$Generated$StyleGuide$Examples$toggleSwitchExample = '\n    [ ToggleSwitch.view\n        [ ToggleSwitch.on value\n        , ToggleSwitch.onChange ToggleSwitchChanged\n        ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$toggleSwitchExampleDisabled = '\n    [ ToggleSwitch.view\n        [ ToggleSwitch.on value\n        , ToggleSwitch.disabled True\n        , ToggleSwitch.onChange ToggleSwitchChanged\n        ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$toggleSwitchExampleSmall = '\n    [ ToggleSwitch.view\n        [ ToggleSwitch.on value\n        , ToggleSwitch.sm\n        , ToggleSwitch.onChange ToggleSwitchChanged\n        ]\n    ]\n    ';
var $author$project$Pages$StyleGuide$ToggleSwitch$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(6)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title(
										'Toggle Switch: ' + (model.lP ? 'True' : 'False'))
									]),
								{
									NN: $author$project$Generated$StyleGuide$Examples$toggleSwitchExample,
									G1: $author$project$Pages$StyleGuide$ToggleSwitch$example(model.lP)
								}),
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Small')
									]),
								{
									NN: $author$project$Generated$StyleGuide$Examples$toggleSwitchExampleSmall,
									G1: $author$project$Pages$StyleGuide$ToggleSwitch$exampleSmall(model.lP)
								})
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(6)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Disabled')
									]),
								{
									NN: $author$project$Generated$StyleGuide$Examples$toggleSwitchExampleDisabled,
									G1: $author$project$Pages$StyleGuide$ToggleSwitch$exampleDisabled(model.lP)
								})
							]))
					]))
			]),
		ac9: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$ToggleSwitch$page = $author$project$Spa$Page$sandbox(
	{ah_: $author$project$Pages$StyleGuide$ToggleSwitch$init, adT: $author$project$Pages$StyleGuide$ToggleSwitch$update, amo: $author$project$Pages$StyleGuide$ToggleSwitch$view});
var $author$project$Pages$StyleGuide$Tooltip$view = function (_v0) {
	return {
		fO: _List_fromArray(
			[
				$author$project$Ui$Typography$headingLg(
				_List_fromArray(
					[
						$elm$html$Html$text('Tooltip')
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Tooltip$view,
						_List_Nil,
						'Thanks for hovering! I\'m a tooltip',
						_List_fromArray(
							[
								$elm$html$Html$text('TOP: Hover over me!')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Tooltip$view,
						_List_fromArray(
							[
								$author$project$Ui$Tooltip$placement(3)
							]),
						'Thanks for hovering! I\'m a tooltip',
						_List_fromArray(
							[
								$elm$html$Html$text('RIGHT: Hover over me!')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Tooltip$view,
						_List_fromArray(
							[
								$author$project$Ui$Tooltip$placement(1)
							]),
						'Thanks for hovering! I\'m a tooltip',
						_List_fromArray(
							[
								$elm$html$Html$text('BOTTOM: Hover over me!')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Tooltip$view,
						_List_fromArray(
							[
								$author$project$Ui$Tooltip$placement(2)
							]),
						'Thanks for hovering! I\'m a tooltip',
						_List_fromArray(
							[
								$elm$html$Html$text('LEFT: Hover over me!')
							]))
					]))
			]),
		ac9: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$Tooltip$page = $author$project$Spa$Page$static($author$project$Pages$StyleGuide$Tooltip$view);
var $author$project$Pages$StyleGuide$Top$view = function (_v0) {
	return {
		fO: _List_fromArray(
			[
				$elm$html$Html$text('StyleGuide')
			]),
		ac9: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$Top$page = $author$project$Spa$Page$static($author$project$Pages$StyleGuide$Top$view);
var $author$project$Ui$OverflowWrap$Anywhere = 2;
var $author$project$Ui$OverflowWrap$anywhere = 2;
var $author$project$Pages$StyleGuide$Typography$loremIpsum = 'Lorem ipsum dolor sit amet, Antidisestablishmentarianism adipiscing elit.';
var $author$project$Ui$OverflowWrap$Normal = 1;
var $author$project$Ui$OverflowWrap$normal = 1;
var $author$project$Pages$StyleGuide$Typography$viewBody = _List_fromArray(
	[
		A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Typography$headingLg(
				_List_fromArray(
					[
						$elm$html$Html$text('Headings')
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Typography$heading(
						_List_fromArray(
							[
								$elm$html$Html$text('Base Title')
							])),
						$author$project$Ui$Typography$headingSm(
						_List_fromArray(
							[
								$elm$html$Html$text('Small Title')
							]))
					]))
			])),
		A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Typography$headingLg(
				_List_fromArray(
					[
						$elm$html$Html$text('Type')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mt-4')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Normal text')
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$muted]),
						_List_fromArray(
							[
								$elm$html$Html$text('Muted text')
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$gray]),
						_List_fromArray(
							[
								$elm$html$Html$text('Gray text')
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$primary]),
						_List_fromArray(
							[
								$elm$html$Html$text('Primary text')
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$success]),
						_List_fromArray(
							[
								$elm$html$Html$text('Success text')
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$info]),
						_List_fromArray(
							[
								$elm$html$Html$text('Info text')
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$warning]),
						_List_fromArray(
							[
								$elm$html$Html$text('Warning text')
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$danger]),
						_List_fromArray(
							[
								$elm$html$Html$text('Danger text')
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$underline]),
						_List_fromArray(
							[
								$elm$html$Html$text('Underline text')
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$strike]),
						_List_fromArray(
							[
								$elm$html$Html$text('Strike text')
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[
								$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textLeft)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Left text')
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[
								$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Center text')
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[
								$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Right text')
							]))
					]))
			])),
		A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Typography$headingLg(
				_List_fromArray(
					[
						$elm$html$Html$text('Word wrap')
					])),
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanSm(12)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Typography$heading(
								_List_fromArray(
									[
										$elm$html$Html$text('Break Word')
									]))
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanSm(1)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$text,
								_List_fromArray(
									[
										$author$project$Ui$Typography$overflowWrap($author$project$Ui$OverflowWrap$breakWord)
									]),
								$author$project$Pages$StyleGuide$Typography$loremIpsum)
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanSm(12)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Typography$heading(
								_List_fromArray(
									[
										$elm$html$Html$text('Anywhere')
									]))
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanSm(1)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$text,
								_List_fromArray(
									[
										$author$project$Ui$Typography$overflowWrap($author$project$Ui$OverflowWrap$anywhere)
									]),
								$author$project$Pages$StyleGuide$Typography$loremIpsum)
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanSm(12)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Typography$heading(
								_List_fromArray(
									[
										$elm$html$Html$text('Normal')
									]))
							])),
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanSm(1)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$text,
								_List_fromArray(
									[
										$author$project$Ui$Typography$overflowWrap($author$project$Ui$OverflowWrap$normal)
									]),
								$author$project$Pages$StyleGuide$Typography$loremIpsum)
							]))
					]))
			]))
	]);
var $author$project$Pages$StyleGuide$Typography$view = function (_v0) {
	return {fO: $author$project$Pages$StyleGuide$Typography$viewBody, ac9: 'Typography'};
};
var $author$project$Pages$StyleGuide$Typography$page = $author$project$Spa$Page$static($author$project$Pages$StyleGuide$Typography$view);
var $author$project$Pages$StyleGuide$UploadForm$DropdownMenuMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$StyleGuide$UploadForm$UploadFormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$StyleGuide$UploadForm$WithSession = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$StyleGuide$UploadForm$WithoutSession = {$: 1};
var $author$project$Pages$StyleGuide$UploadForm$init = F2(
	function (shared, _v0) {
		var _v1 = shared.aa4;
		if (_v1.$ === 3) {
			var _v2 = A4($author$project$Components$Upload$Form$init, shared.J7, shared.Gv, 0, $elm$core$Maybe$Nothing);
			var uploadForm = _v2.a;
			var uploadFormCmd = _v2.b;
			return _Utils_Tuple3(
				$author$project$Pages$StyleGuide$UploadForm$WithSession(
					{
						Gv: shared.Gv,
						fZ: '',
						no: $author$project$Ui$Dropdown$init(
							$author$project$Ui$Dropdown$defaultConfig(
								{ahP: 'resource-dropdown-menu', al6: $author$project$Pages$StyleGuide$UploadForm$DropdownMenuMsg})),
						Jy: 0,
						J7: shared.J7,
						h4: $elm$core$Maybe$Just(uploadForm)
					}),
				A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$UploadForm$UploadFormMsg, uploadFormCmd),
				_List_Nil);
		} else {
			return _Utils_Tuple3($author$project$Pages$StyleGuide$UploadForm$WithoutSession, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Pages$StyleGuide$UploadForm$load = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$StyleGuide$UploadForm$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$StyleGuide$UploadForm$subscriptions = function (model) {
	if (!model.$) {
		var withSessionModel = model.a;
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$subscriptions(withSessionModel.no),
					function () {
					var _v1 = withSessionModel.h4;
					if (!_v1.$) {
						var uploadForm = _v1.a;
						return A2(
							$elm$core$Platform$Sub$map,
							$author$project$Pages$StyleGuide$UploadForm$UploadFormMsg,
							$author$project$Components$Upload$Form$subscriptions(uploadForm));
					} else {
						return $elm$core$Platform$Sub$none;
					}
				}()
				]));
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Pages$StyleGuide$UploadForm$update = F2(
	function (msg, model) {
		if (model.$ === 1) {
			return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		} else {
			var modelRecord = model.a;
			switch (msg.$) {
				case 0:
					var subMsg = msg.a;
					var _v2 = modelRecord.h4;
					if (!_v2.$) {
						var uploadForm = _v2.a;
						var _v3 = A3($author$project$Components$Upload$Form$update, modelRecord.Gv, subMsg, uploadForm);
						var uploadForm_ = _v3.a;
						var subCmd = _v3.b;
						var subOutMsgs = _v3.c;
						return _Utils_Tuple3(
							$author$project$Pages$StyleGuide$UploadForm$WithSession(
								_Utils_update(
									modelRecord,
									{
										h4: $elm$core$Maybe$Just(uploadForm_)
									})),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$UploadForm$UploadFormMsg, subCmd),
							subOutMsgs);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				case 1:
					var subMsg = msg.a;
					var _v4 = A2($author$project$Ui$Dropdown$update, subMsg, modelRecord.no);
					var dropdownMenu = _v4.a;
					var cmd = _v4.b;
					return _Utils_Tuple3(
						$author$project$Pages$StyleGuide$UploadForm$WithSession(
							_Utils_update(
								modelRecord,
								{no: dropdownMenu})),
						cmd,
						_List_Nil);
				default:
					var resource = msg.a;
					var _v5 = A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Platform$Cmd$map($author$project$Pages$StyleGuide$UploadForm$UploadFormMsg),
						A2(
							$elm$core$Tuple$mapFirst,
							$elm$core$Maybe$Just,
							A4($author$project$Components$Upload$Form$init, modelRecord.J7, modelRecord.Gv, resource, $elm$core$Maybe$Nothing)));
					var uploadForm = _v5.a;
					var uploadFormCmd = _v5.b;
					return _Utils_Tuple3(
						$author$project$Pages$StyleGuide$UploadForm$WithSession(
							_Utils_update(
								modelRecord,
								{Jy: resource, h4: uploadForm})),
						uploadFormCmd,
						_List_Nil);
			}
		}
	});
var $author$project$Pages$StyleGuide$UploadForm$ResourceSelected = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$StyleGuide$UploadForm$dropdownMenuItem = F2(
	function (currentResource, resource) {
		return A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(currentResource, resource)),
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Pages$StyleGuide$UploadForm$ResourceSelected(resource))
				]),
			$elm$html$Html$text(
				$author$project$Api$Upload$Resource$toString(resource)));
	});
var $author$project$Pages$StyleGuide$UploadForm$dropdownMenuItems = function (resource) {
	return A2(
		$elm$core$List$map,
		$author$project$Pages$StyleGuide$UploadForm$dropdownMenuItem(resource),
		_List_fromArray(
			[0, 1, 2, 3, 5]));
};
var $author$project$Pages$StyleGuide$UploadForm$viewBody = function (model) {
	return _List_fromArray(
		[
			function () {
			var _v0 = model.h4;
			if (!_v0.$) {
				var uploadForm = _v0.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$StyleGuide$UploadForm$UploadFormMsg,
					A2($author$project$Components$Upload$Form$modal, model.Gv, uploadForm));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			$author$project$Ui$Typography$headingLg(
			_List_fromArray(
				[
					$elm$html$Html$text('Upload Form')
				])),
			A4(
			$author$project$Ui$Dropdown$viewSelect,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Api$Upload$Resource$toString(model.Jy))
				]),
			$author$project$Pages$StyleGuide$UploadForm$dropdownMenuItems(model.Jy),
			model.no),
			$author$project$Utils$Html$empty,
			function () {
			var _v1 = model.h4;
			if (!_v1.$) {
				var uploadForm = _v1.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$StyleGuide$UploadForm$UploadFormMsg,
					A2($author$project$Components$Upload$Form$view, model.Gv, uploadForm));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}()
		]);
};
var $author$project$Pages$StyleGuide$UploadForm$view = function (model) {
	return {
		fO: function () {
			if (!model.$) {
				var modelRecord = model.a;
				return $author$project$Pages$StyleGuide$UploadForm$viewBody(modelRecord);
			} else {
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Alert$warning,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('You need to be logged in to view this style guide')
							]))
					]);
			}
		}(),
		ac9: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$UploadForm$page = $author$project$Spa$Page$application(
	{ah_: $author$project$Pages$StyleGuide$UploadForm$init, aiq: $author$project$Pages$StyleGuide$UploadForm$load, k8: $author$project$Pages$StyleGuide$UploadForm$save, alO: $author$project$Pages$StyleGuide$UploadForm$subscriptions, adT: $author$project$Pages$StyleGuide$UploadForm$update, amo: $author$project$Pages$StyleGuide$UploadForm$view});
var $author$project$Pages$StyleGuide$UploadResult$WithSession = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$StyleGuide$UploadResult$WithoutSession = {$: 1};
var $author$project$Pages$StyleGuide$UploadResult$init = F2(
	function (shared, _v0) {
		var _v1 = shared.aa4;
		if (_v1.$ === 3) {
			return _Utils_Tuple3(
				$author$project$Pages$StyleGuide$UploadResult$WithSession(
					{Gv: shared.Gv, Kj: '', h5: $elm$core$Maybe$Nothing}),
				$elm$core$Platform$Cmd$none,
				_List_Nil);
		} else {
			return _Utils_Tuple3($author$project$Pages$StyleGuide$UploadResult$WithoutSession, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Pages$StyleGuide$UploadResult$load = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$StyleGuide$UploadResult$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$StyleGuide$UploadResult$UploadResultMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$StyleGuide$UploadResult$subscriptions = function (model) {
	if (!model.$) {
		var record = model.a;
		return A2(
			$elm$core$Platform$Sub$map,
			$author$project$Pages$StyleGuide$UploadResult$UploadResultMsg,
			A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2($elm$core$Maybe$map, $author$project$Components$Upload$Result$subscriptions, record.h5)));
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Pages$StyleGuide$UploadResult$update = F2(
	function (msg, model) {
		if (!model.$) {
			var modelRecord = model.a;
			switch (msg.$) {
				case 0:
					var subMsg = msg.a;
					var _v2 = modelRecord.h5;
					if (!_v2.$) {
						var uploadResult = _v2.a;
						var result = A3($author$project$Components$Upload$Result$update, modelRecord.Gv, subMsg, uploadResult);
						var uploadResult_ = function () {
							var _v3 = result.agZ;
							if (!_v3) {
								return $elm$core$Maybe$Just(result.aiO);
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}();
						return _Utils_Tuple3(
							$author$project$Pages$StyleGuide$UploadResult$WithSession(
								_Utils_update(
									modelRecord,
									{h5: uploadResult_})),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$UploadResult$UploadResultMsg, result.GZ),
							result.aR);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				case 2:
					var uploadId = msg.a;
					return _Utils_Tuple3(
						$author$project$Pages$StyleGuide$UploadResult$WithSession(
							_Utils_update(
								modelRecord,
								{Kj: uploadId})),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				default:
					var _v4 = A2($author$project$Components$Upload$Result$init, modelRecord.Gv, modelRecord.Kj);
					var uploadResult = _v4.a;
					var uploadResultCmd = _v4.b;
					return _Utils_Tuple3(
						$author$project$Pages$StyleGuide$UploadResult$WithSession(
							_Utils_update(
								modelRecord,
								{
									h5: $elm$core$Maybe$Just(uploadResult)
								})),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$UploadResult$UploadResultMsg, uploadResultCmd),
						_List_Nil);
			}
		} else {
			return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Pages$StyleGuide$UploadResult$UploadIdChanged = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$StyleGuide$UploadResult$ViewUploadResult = {$: 1};
var $author$project$Pages$StyleGuide$UploadResult$uploadIdInvalid = function (uploadId) {
	return $elm$core$String$isEmpty(uploadId) || (!A2($elm$core$String$startsWith, 'upl-', uploadId));
};
var $author$project$Pages$StyleGuide$UploadResult$uploadIdErrors = function (email) {
	return $author$project$Pages$StyleGuide$UploadResult$uploadIdInvalid(email) ? _List_fromArray(
		['Please enter a valid upload id.']) : _List_Nil;
};
var $author$project$Pages$StyleGuide$UploadResult$viewBody = function (model) {
	return _List_fromArray(
		[
			function () {
			var _v0 = model.h5;
			if (!_v0.$) {
				var uploadResult = _v0.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$StyleGuide$UploadResult$UploadResultMsg,
					A2($author$project$Components$Upload$Result$modal, model.Gv, uploadResult));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			$author$project$Ui$Typography$headingLg(
			_List_fromArray(
				[
					$elm$html$Html$text('Upload > Result')
				])),
			A2(
			$author$project$Ui$Form$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('Upload Id'),
							$author$project$Ui$Form$Group$required(true),
							$author$project$Ui$Form$Group$labelSpanSm(2),
							$author$project$Ui$Form$Group$inputSpanSm(4)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(model.Kj),
									$author$project$Ui$Form$Input$invalid(
									$author$project$Pages$StyleGuide$UploadResult$uploadIdInvalid(model.Kj)),
									$author$project$Ui$Form$Input$errors(
									$author$project$Pages$StyleGuide$UploadResult$uploadIdErrors(model.Kj)),
									$author$project$Ui$Form$Input$onInput($author$project$Pages$StyleGuide$UploadResult$UploadIdChanged)
								])),
							A3(
							$author$project$Ui$Button$view,
							{mm: 'View result'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$onClick($author$project$Pages$StyleGuide$UploadResult$ViewUploadResult)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('View result')
								]))
						]))
				]))
		]);
};
var $author$project$Pages$StyleGuide$UploadResult$view = function (model) {
	return {
		fO: function () {
			if (!model.$) {
				var modelRecord = model.a;
				return $author$project$Pages$StyleGuide$UploadResult$viewBody(modelRecord);
			} else {
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Alert$warning,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('You need to be logged in to view this style guide')
							]))
					]);
			}
		}(),
		ac9: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$UploadResult$page = $author$project$Spa$Page$application(
	{ah_: $author$project$Pages$StyleGuide$UploadResult$init, aiq: $author$project$Pages$StyleGuide$UploadResult$load, k8: $author$project$Pages$StyleGuide$UploadResult$save, alO: $author$project$Pages$StyleGuide$UploadResult$subscriptions, adT: $author$project$Pages$StyleGuide$UploadResult$update, amo: $author$project$Pages$StyleGuide$UploadResult$view});
var $author$project$Pages$StyleGuide$Well$exampleOptions = _List_fromArray(
	[
		A2(
		$author$project$Ui$Well$view,
		_List_fromArray(
			[$author$project$Ui$Well$noBorder]),
		_List_fromArray(
			[
				$elm$html$Html$text('No border')
			])),
		A2(
		$author$project$Ui$Well$view,
		_List_fromArray(
			[$author$project$Ui$Well$wFull]),
		_List_fromArray(
			[
				$elm$html$Html$text('Full width')
			]))
	]);
var $author$project$Ui$Well$large = $author$project$Ui$Well$Size(3);
var $author$project$Pages$StyleGuide$Well$exampleSizes = _List_fromArray(
	[
		A2(
		$author$project$Ui$Well$view,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Default')
			])),
		A2(
		$author$project$Ui$Well$view,
		_List_fromArray(
			[$author$project$Ui$Well$small]),
		_List_fromArray(
			[
				$elm$html$Html$text('Small')
			])),
		A2(
		$author$project$Ui$Well$view,
		_List_fromArray(
			[$author$project$Ui$Well$large]),
		_List_fromArray(
			[
				$elm$html$Html$text('Large')
			]))
	]);
var $author$project$Generated$StyleGuide$Examples$wellExampleOptions = '\n    [ Well.view [ Well.noBorder ] [ text "No border" ]\n    , Well.view [ Well.wFull ] [ text "Full width" ]\n    ]\n    ';
var $author$project$Generated$StyleGuide$Examples$wellExampleSizes = '\n    [ Well.view [] [ text "Default" ]\n    , Well.view [ Well.small ] [ text "Small" ]\n    , Well.view [ Well.large ] [ text "Large" ]\n    ]    ';
var $author$project$Pages$StyleGuide$Well$view = function (_v0) {
	return {
		fO: _List_fromArray(
			[
				$author$project$Ui$Typography$headingLg(
				_List_fromArray(
					[
						$elm$html$Html$text('Well')
					])),
				A2(
				$author$project$Components$StyleGuide$Example$view,
				_List_fromArray(
					[
						$author$project$Components$StyleGuide$Example$title('Sizes')
					]),
				{NN: $author$project$Generated$StyleGuide$Examples$wellExampleSizes, G1: $author$project$Pages$StyleGuide$Well$exampleSizes}),
				A2(
				$author$project$Components$StyleGuide$Example$view,
				_List_fromArray(
					[
						$author$project$Components$StyleGuide$Example$title('Options')
					]),
				{NN: $author$project$Generated$StyleGuide$Examples$wellExampleOptions, G1: $author$project$Pages$StyleGuide$Well$exampleOptions})
			]),
		ac9: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$Well$page = $author$project$Spa$Page$static($author$project$Pages$StyleGuide$Well$view);
var $author$project$Pages$Support$CannySso$GotCannyJwt = $elm$core$Basics$identity;
var $author$project$Api$Provider$Support$CannySso$CannyJwtResponse = $elm$core$Basics$identity;
var $author$project$Api$Provider$Support$CannySso$Record = function (cannyJwt) {
	return {Nm: cannyJwt};
};
var $author$project$Api$Provider$Support$CannySso$decoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'canny_jwt',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Support$CannySso$Record)));
var $author$project$Api$Provider$Support$CannySso$createToken = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Support$CannySso$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['user', 'canny_jwt']),
					$author$project$Api$Data$platformPath)));
	});
var $author$project$Pages$Support$CannySso$init = F3(
	function (_v0, _v1, _v2) {
		var apiClient = _v1.Gv;
		var flags = _v1.ahq;
		return _Utils_Tuple2(
			{Gv: apiClient, afr: flags.afr, Nm: $author$project$Api$Data$NotAsked},
			A2($author$project$Api$Provider$Support$CannySso$createToken, apiClient, $elm$core$Basics$identity));
	});
var $author$project$Pages$Support$CannySso$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Support$CannySso$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Support$CannySso$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $elm$url$Url$Builder$absolute = F2(
	function (pathSegments, parameters) {
		return '/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters));
	});
var $author$project$Api$Provider$Support$CannySso$cannyJwt = function (_v0) {
	var record = _v0;
	return record.Nm;
};
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $author$project$Pages$Support$CannySso$update = F2(
	function (msg, model) {
		var response = msg;
		if (response.$ === 3) {
			var jwt = response.a;
			var urlParam = A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (param) {
						return _List_fromArray(
							[param]);
					},
					A2(
						$elm$core$Maybe$map,
						$elm$url$Url$Builder$string('companyID'),
						model.afr)));
			var redirectUrl = 'https://feedback.hint.com/feature-requests';
			var urlWithJwt = A2(
				$elm$core$String$append,
				'https://canny.io',
				A2(
					$elm$url$Url$Builder$absolute,
					_List_fromArray(
						['api', 'redirects', 'sso']),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$url$Url$Builder$string,
							'ssoToken',
							$author$project$Api$Provider$Support$CannySso$cannyJwt(jwt)),
						A2(
							$elm$core$List$cons,
							A2($elm$url$Url$Builder$string, 'redirect', redirectUrl),
							urlParam))));
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{Nm: response}),
				$elm$browser$Browser$Navigation$load(urlWithJwt),
				_List_Nil);
		} else {
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{Nm: response}),
				$elm$core$Platform$Cmd$none,
				_List_Nil);
		}
	});
var $author$project$Pages$Support$CannySso$view = function (_v0) {
	return {fO: $author$project$Components$LoadingPage$view, ac9: 'Support'};
};
var $author$project$Pages$Support$CannySso$page = $author$project$Spa$Page$applicationPrivate(
	{ah_: $author$project$Pages$Support$CannySso$init, aiq: $author$project$Pages$Support$CannySso$load, k8: $author$project$Pages$Support$CannySso$save, alO: $author$project$Pages$Support$CannySso$subscriptions, adT: $author$project$Pages$Support$CannySso$update, amo: $author$project$Pages$Support$CannySso$view});
var $author$project$Pages$Tasks$New$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Tasks$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Tasks$New$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Tasks$New$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'New Task'};
};
var $author$project$Pages$Tasks$New$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$Tasks$New$init,
		aiq: $author$project$Pages$Tasks$New$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$Tasks$New$update,
		amo: $author$project$Pages$Tasks$New$view
	});
var $author$project$Pages$Tasks$TasksId_String$Top$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Tasks$TasksId_String$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Tasks$TasksId_String$Top$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Tasks$TasksId_String$Top$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Task'};
};
var $author$project$Pages$Tasks$TasksId_String$Top$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$Tasks$TasksId_String$Top$init,
		aiq: $author$project$Pages$Tasks$TasksId_String$Top$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$Tasks$TasksId_String$Top$update,
		amo: $author$project$Pages$Tasks$TasksId_String$Top$view
	});
var $author$project$Pages$Tasks$Top$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{Gv: shared.Gv, adY: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Tasks$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Tasks$Top$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Tasks$Top$view = function (_v0) {
	return {fO: _List_Nil, ac9: 'Tasks'};
};
var $author$project$Pages$Tasks$Top$page = $author$project$Spa$Page$applicationPractice(
	{
		ah_: $author$project$Pages$Tasks$Top$init,
		aiq: $author$project$Pages$Tasks$Top$load,
		k8: $elm$core$Basics$always($elm$core$Basics$identity),
		alO: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		adT: $author$project$Pages$Tasks$Top$update,
		amo: $author$project$Pages$Tasks$Top$view
	});
var $author$project$Pages$Top$init = F2(
	function (_v0, _v1) {
		return _Utils_Tuple3(
			{},
			A2($author$project$Ports$Navigation$pushRoute, _List_Nil, $author$project$Spa$Generated$Route$Login),
			_List_Nil);
	});
var $author$project$Pages$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Top$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Top$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Top$view = function (_v0) {
	return {fO: _List_Nil, ac9: ''};
};
var $author$project$Pages$Top$page = $author$project$Spa$Page$application(
	{ah_: $author$project$Pages$Top$init, aiq: $author$project$Pages$Top$load, k8: $author$project$Pages$Top$save, alO: $author$project$Pages$Top$subscriptions, adT: $author$project$Pages$Top$update, amo: $author$project$Pages$Top$view});
var $author$project$Spa$Page$applicationUser = function (page) {
	return {
		ah_: F2(
			function (shared, url) {
				var _v0 = _Utils_Tuple2(shared.aa4, shared.ad0);
				_v0$3:
				while (true) {
					_v0$4:
					while (true) {
						switch (_v0.a.$) {
							case 3:
								switch (_v0.b.$) {
									case 3:
										var _v1 = _v0.a;
										var session = _v1.a;
										var _v2 = _v0.b;
										var user = _v2.a;
										return (!A3($author$project$Spa$Page$authorizeUrl, session, shared.ahK, shared.adY)) ? _Utils_Tuple3(
											$author$project$Spa$Page$SessionLoading(url),
											A2(
												$author$project$Utils$Route$navigate,
												$elm$core$Dict$empty,
												A2($author$project$Permission$homeStateFor, session, shared.ahK)),
											_List_Nil) : A2(
											$author$project$Utils$Tuple3$mapFirst,
											$author$project$Spa$Page$SessionLoaded,
											A2(
												$author$project$Utils$Tuple3$fromTuple2,
												_List_Nil,
												A4(page.ah_, session, user, shared, url)));
									case 2:
										break _v0$3;
									default:
										break _v0$4;
								}
							case 0:
								var _v3 = _v0.a;
								return _Utils_Tuple3(
									$author$project$Spa$Page$SessionLoading(url),
									$author$project$Ports$Session$authorize(
										{aku: true}),
									_List_Nil);
							case 2:
								return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
							default:
								if (_v0.b.$ === 2) {
									break _v0$3;
								} else {
									break _v0$4;
								}
						}
					}
					return _Utils_Tuple3(
						$author$project$Spa$Page$SessionLoading(url),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
				return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
			}),
		aiq: F2(
			function (shared, model) {
				var _v4 = _Utils_Tuple2(shared.aa4, shared.ad0);
				_v4$2:
				while (true) {
					_v4$3:
					while (true) {
						switch (_v4.a.$) {
							case 3:
								switch (_v4.b.$) {
									case 3:
										var _v5 = _v4.a;
										var session = _v5.a;
										var _v6 = _v4.b;
										var user = _v6.a;
										switch (model.$) {
											case 0:
												var url = model.a;
												if (!A3($author$project$Spa$Page$authorizeUrl, session, shared.ahK, shared.adY)) {
													return _Utils_Tuple3(
														$author$project$Spa$Page$SessionLoading(url),
														A2(
															$author$project$Utils$Route$navigate,
															$elm$core$Dict$empty,
															A2($author$project$Permission$homeStateFor, session, shared.ahK)),
														_List_Nil);
												} else {
													var _v8 = A4(page.ah_, session, user, shared, url);
													var pageModel = _v8.a;
													var cmd = _v8.b;
													return _Utils_Tuple3(
														$author$project$Spa$Page$SessionLoaded(pageModel),
														cmd,
														_List_Nil);
												}
											case 1:
												var modelWithSession = model.a;
												return A2(
													$author$project$Utils$Tuple3$fromTuple2,
													_List_Nil,
													A2(
														$elm$core$Tuple$mapFirst,
														$author$project$Spa$Page$SessionLoaded,
														A2(
															page.aiq,
															shared,
															_Utils_update(
																modelWithSession,
																{Gv: shared.Gv}))));
											default:
												return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
										}
									case 2:
										break _v4$2;
									default:
										break _v4$3;
								}
							case 2:
								return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
							default:
								if (_v4.b.$ === 2) {
									break _v4$2;
								} else {
									break _v4$3;
								}
						}
					}
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
				return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
			}),
		k8: F2(
			function (model, shared) {
				if (model.$ === 1) {
					var modelWithSession = model.a;
					return A2(page.k8, modelWithSession, shared);
				} else {
					return shared;
				}
			}),
		alO: function (model) {
			if (model.$ === 1) {
				var modelWithSession = model.a;
				return page.alO(modelWithSession);
			} else {
				return $elm$core$Platform$Sub$none;
			}
		},
		adT: F2(
			function (msg, model) {
				if (model.$ === 1) {
					var modelWithSession = model.a;
					return A2(
						$author$project$Utils$Tuple3$mapFirst,
						$author$project$Spa$Page$SessionLoaded,
						A2(page.adT, msg, modelWithSession));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			}),
		amo: function (model) {
			if (model.$ === 1) {
				var modelWithSession = model.a;
				return page.amo(modelWithSession);
			} else {
				return {fO: $author$project$Components$BlankPage$view, ac9: 'Loading...'};
			}
		}
	};
};
var $author$project$Api$Platform$User$Shared$termsAccepted = function (_v0) {
	var record = _v0;
	return record.J5;
};
var $author$project$Api$Platform$User$One$termsAccepted = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Platform$User$Shared$termsAccepted(shared);
};
var $author$project$Pages$User$AcceptTerms$initFormFields = function (user) {
	return {
		J5: $author$project$Api$Platform$User$One$termsAccepted(user)
	};
};
var $author$project$Pages$User$AcceptTerms$init = F4(
	function (session, user, shared, _v0) {
		return _Utils_Tuple2(
			{
				Gv: shared.Gv,
				SD: $author$project$Utils$Form$init(
					$author$project$Pages$User$AcceptTerms$initFormFields(user)),
				k9: $author$project$Api$Data$NotAsked,
				aa4: session,
				ad0: user
			},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$User$AcceptTerms$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$User$AcceptTerms$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$User$AcceptTerms$Close = {$: 0};
var $author$project$Pages$User$AcceptTerms$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Pages$User$AcceptTerms$Close);
};
var $author$project$Pages$User$AcceptTerms$formFieldsUpdate = F2(
	function (field, fields) {
		var bool = field;
		return _Utils_update(
			fields,
			{J5: bool});
	});
var $author$project$Pages$User$AcceptTerms$TermsAcceptedValidation = 0;
var $author$project$Pages$User$AcceptTerms$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifFalse,
			function ($) {
				return $.J5;
			},
			_Utils_Tuple2(0, 'Please accept our terms.'))
		]));
var $author$project$Pages$User$AcceptTerms$UserUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Platform$User$updateTermsAcceptance = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'user',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'terms_accepted',
								$elm$json$Json$Encode$bool(fields.J5))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Platform$User$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Platform$User$userPath)));
	});
var $author$project$Pages$User$AcceptTerms$updateUser = F2(
	function (apiClient, formFields) {
		return A3(
			$author$project$Api$Platform$User$updateTermsAcceptance,
			apiClient,
			$rtfeldman$elm_validate$Validate$fromValid(formFields),
			$author$project$Pages$User$AcceptTerms$UserUpdated);
	});
var $author$project$Pages$User$AcceptTerms$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 1:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$User$AcceptTerms$formFieldsUpdate, field, model.SD);
				var validatedForm = function () {
					var _v1 = A2($author$project$Utils$Form$validate, $author$project$Pages$User$AcceptTerms$formFieldsValidator, newForm);
					if (!_v1.$) {
						var _v2 = _v1.a;
						var form = _v2.a;
						return form;
					} else {
						var form = _v1.a;
						return form;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: validatedForm}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var _v3 = A2($author$project$Utils$Form$validate, $author$project$Pages$User$AcceptTerms$formFieldsValidator, model.SD);
				if (!_v3.$) {
					var _v4 = _v3.a;
					var newForm = _v4.a;
					var validFormFields = _v4.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{SD: newForm}),
						A2($author$project$Pages$User$AcceptTerms$updateUser, model.Gv, validFormFields),
						_List_Nil);
				} else {
					var newForm = _v3.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{SD: newForm}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					var _v6 = function () {
						var _v7 = $author$project$Api$Platform$Session$One$organization(model.aa4);
						if (!_v7.$) {
							var organization = _v7.a;
							return _Utils_Tuple2(
								$elm$core$Platform$Cmd$none,
								_List_fromArray(
									[
										A3(
										$author$project$OutMsg$SwitchToOrganization,
										$author$project$Api$Platform$Organization$Shared$id(organization),
										$elm$core$Maybe$Nothing,
										$author$project$OutMsg$GoToDefaultStateAction)
									]));
						} else {
							return _Utils_Tuple2(
								A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$User__Organizations__Top),
								_List_Nil);
						}
					}();
					var cmd = _v6.a;
					var outMsgs = _v6.b;
					return _Utils_Tuple3(
						model,
						cmd,
						_Utils_ap(
							outMsgs,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Your profile has been updated')
								])));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Pages$User$AcceptTerms$UpdateUser = {$: 2};
var $author$project$Ui$Modal$Dismissible = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Modal$dismissible = $author$project$Ui$Modal$Dismissible;
var $author$project$Pages$User$AcceptTerms$FormFieldUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$User$AcceptTerms$TermsAccepted = $elm$core$Basics$identity;
var $author$project$Pages$User$AcceptTerms$viewAcceptTerms = F2(
	function (user, form) {
		if ($author$project$Api$Platform$User$One$termsAccepted(user)) {
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Icon$check(
							_List_fromArray(
								[$author$project$Ui$Icon$success])),
							$author$project$Utils$Html$noBreakSpace,
							$elm$html$Html$text(' You agreed to this software platform\'s'),
							A3(
							$author$project$Ui$Link$externalHref,
							$author$project$Utils$HintUrls$termsUrl,
							_List_fromArray(
								[$author$project$Ui$Link$targetBlank]),
							_List_fromArray(
								[
									$elm$html$Html$text(' Terms of Service.')
								]))
						]))
				]);
		} else {
			var _v0 = $author$project$Utils$Form$fields(form);
			var termsAccepted = _v0.J5;
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Checkbox$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Checkbox$value(termsAccepted),
									$author$project$Ui$Form$Checkbox$required(true),
									$author$project$Ui$Form$Checkbox$onCheck(
									A2($elm$core$Basics$composeL, $author$project$Pages$User$AcceptTerms$FormFieldUpdated, $elm$core$Basics$identity))
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('I agree to this software platform\'s'),
											A3(
											$author$project$Ui$Link$externalHref,
											$author$project$Utils$HintUrls$termsUrl,
											_List_fromArray(
												[$author$project$Ui$Link$targetBlank]),
											_List_fromArray(
												[
													$elm$html$Html$text(' Terms of Service.')
												]))
										]))
								])),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						]))
				]);
		}
	});
var $author$project$Pages$User$AcceptTerms$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A3(
				$author$project$Ui$Modal$view,
				$author$project$Pages$User$AcceptTerms$Close,
				_List_fromArray(
					[
						$author$project$Ui$Modal$dismissible(false)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Modal$header(
						_List_fromArray(
							[
								$author$project$Ui$Modal$title('Protect Your Patients\' Privacy')
							])),
						$author$project$Ui$Modal$body(
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('This platform has instituted more rigorous safeguards, policies, and procedures in accordance with the HIPAA and HITECH final rule. To help better protect your patients\' privacy, please change your password.')
											]))
									])),
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('')
									]),
								A2($author$project$Pages$User$AcceptTerms$viewAcceptTerms, model.ad0, model.SD))
							])),
						$author$project$Ui$Modal$footer(
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Update terms'},
								_List_fromArray(
									[
										$author$project$Ui$Button$primary,
										$author$project$Ui$Button$submit,
										$author$project$Ui$Button$onClick($author$project$Pages$User$AcceptTerms$UpdateUser),
										$author$project$Ui$Button$loading(
										_Utils_eq(model.k9, $author$project$Api$Data$Loading))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Update')
									]))
							]))
					]))
			]),
		ac9: 'Patients'
	};
};
var $author$project$Pages$User$AcceptTerms$page = $author$project$Spa$Page$applicationUser(
	{ah_: $author$project$Pages$User$AcceptTerms$init, aiq: $author$project$Pages$User$AcceptTerms$load, k8: $author$project$Pages$User$AcceptTerms$save, alO: $author$project$Pages$User$AcceptTerms$subscriptions, adT: $author$project$Pages$User$AcceptTerms$update, amo: $author$project$Pages$User$AcceptTerms$view});
var $author$project$Pages$User$Mfa$GotMfa = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$User$Mfa$Qr = 0;
var $author$project$Api$Platform$User$One$requiresMfa = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Platform$User$Shared$requiresMfa(shared);
};
var $author$project$Api$Platform$Mfa$One$Mfa = $elm$core$Basics$identity;
var $author$project$Api$Platform$Mfa$One$Record = F5(
	function (accountName, otpSecretKey, qrcodeUrl, qrcode, status) {
		return {KH: accountName, Yy: otpSecretKey, _M: qrcode, _N: qrcodeUrl, alH: status};
	});
var $author$project$Api$Platform$Mfa$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'status',
	$author$project$Api$Platform$Mfa$Status$decode,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'qrcode',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'qrcode_url',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'otp_secret_key',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'account_name',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Platform$Mfa$One$Record))))));
var $author$project$Api$Platform$Mfa$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$Mfa$One$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Platform$Mfa$mfaPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['mfa']),
	$author$project$Api$Data$platformPath);
var $author$project$Api$Platform$Mfa$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Platform$Mfa$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Platform$Mfa$mfaPath));
	});
var $author$project$Pages$User$Mfa$initFromSessionAndUser = F3(
	function (apiClient, user, requiresMfaPrerequisite) {
		return _Utils_Tuple2(
			{
				l7: $author$project$Api$Data$NotAsked,
				Gv: apiClient,
				r_: $elm$core$Maybe$Nothing,
				IA: 0,
				gV: $author$project$Api$Data$Loading,
				tw: '',
				$H: $author$project$Api$Platform$User$One$requiresMfa(user),
				Jv: requiresMfaPrerequisite
			},
			A2($author$project$Api$Platform$Mfa$retrieve, apiClient, $author$project$Pages$User$Mfa$GotMfa));
	});
var $author$project$Pages$User$Mfa$init = F4(
	function (_v0, user, _v1, _v2) {
		var apiClient = _v1.Gv;
		var query = _v2.DE;
		var requiresMfaPrerequisite = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$eq('true'),
				A2($elm$core$Dict$get, 'requiresMfaPrerequisite', query)));
		return A3($author$project$Pages$User$Mfa$initFromSessionAndUser, apiClient, user, requiresMfaPrerequisite);
	});
var $author$project$Pages$User$Mfa$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$User$Mfa$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$User$Mfa$QRDecoderMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ports$QRDecoder$onDecodePort = _Platform_incomingPort('onDecodePort', $elm$json$Json$Decode$string);
var $author$project$Ports$QRDecoder$onDecode = $author$project$Ports$QRDecoder$onDecodePort;
var $author$project$Pages$User$Mfa$subscriptions = function (_v0) {
	return $author$project$Ports$QRDecoder$onDecode($author$project$Pages$User$Mfa$QRDecoderMsg);
};
var $author$project$Pages$User$Mfa$GotActivatingMfa = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$User$Mfa$Logout = {$: 4};
var $author$project$Pages$User$Mfa$Manual = 1;
var $author$project$Api$Platform$Mfa$activateMfaPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['activate']),
	$author$project$Api$Platform$Mfa$mfaPath);
var $author$project$Api$Platform$Mfa$activate = F4(
	function (apiClient, otpCode, qrCodeUrl, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'otp_code',
					$elm$json$Json$Encode$string(otpCode)),
					_Utils_Tuple2(
					'qrcode_url',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, qrCodeUrl))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Platform$Mfa$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Platform$Mfa$activateMfaPath)));
	});
var $author$project$Api$Platform$Mfa$create = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Platform$Mfa$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Platform$Mfa$mfaPath));
	});
var $author$project$Ports$QRDecoder$decodePort = _Platform_outgoingPort('decodePort', $elm$json$Json$Encode$string);
var $author$project$Ports$QRDecoder$decode = function (base64) {
	return $author$project$Ports$QRDecoder$decodePort(base64);
};
var $author$project$Api$Platform$Mfa$One$qrcode = function (_v0) {
	var record = _v0;
	return record._M;
};
var $author$project$Api$Platform$Mfa$One$qrcodeUrl = function (_v0) {
	var record = _v0;
	return record._N;
};
var $author$project$Api$Platform$Mfa$update = F3(
	function (apiClient, qrCodeUrl, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'qrcode_url',
					$elm$json$Json$Encode$string(qrCodeUrl))
				]));
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Platform$Mfa$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Platform$Mfa$mfaPath)));
	});
var $author$project$Pages$User$Mfa$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var dataMfa = msg.a;
				_v1$2:
				while (true) {
					switch (dataMfa.$) {
						case 3:
							var mfa = dataMfa.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										r_: $elm$core$Maybe$Just(
											$author$project$Api$Platform$Mfa$One$qrcodeUrl(mfa)),
										gV: dataMfa
									}),
								A2(
									$elm$core$Maybe$withDefault,
									$elm$core$Platform$Cmd$none,
									A2(
										$elm$core$Maybe$map,
										$author$project$Ports$QRDecoder$decode,
										$author$project$Api$Platform$Mfa$One$qrcode(mfa))),
								_List_Nil);
						case 2:
							if (dataMfa.a.$ === 5) {
								var _v2 = dataMfa.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{gV: dataMfa}),
									A2($author$project$Api$Platform$Mfa$create, model.Gv, $author$project$Pages$User$Mfa$GotMfa),
									_List_Nil);
							} else {
								break _v1$2;
							}
						default:
							break _v1$2;
					}
				}
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{gV: dataMfa}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$reportDecodeError(dataMfa));
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{IA: 1}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var code = msg.a;
				var _v3 = ($elm$core$String$length(code) === 6) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{l7: $author$project$Api$Data$Loading}),
					A4($author$project$Api$Platform$Mfa$activate, model.Gv, code, model.r_, $author$project$Pages$User$Mfa$GotActivatingMfa)) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				var newModel = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{tw: code}),
					cmd,
					_List_Nil);
			case 3:
				var dataMfa = msg.a;
				switch (dataMfa.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{l7: dataMfa, gV: dataMfa}),
							A2(
								$elm$core$Task$perform,
								function (_v5) {
									return $author$project$Pages$User$Mfa$Logout;
								},
								$elm$core$Process$sleep(5000)),
							_List_Nil);
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{l7: dataMfa, tw: ''}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(dataMfa));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				return _Utils_Tuple3(
					model,
					$author$project$Ports$Session$logout(
						{aku: true}),
					_List_Nil);
			default:
				var qrCode = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							r_: $elm$core$Maybe$Just(qrCode)
						}),
					A3($author$project$Api$Platform$Mfa$update, model.Gv, qrCode, $author$project$Pages$User$Mfa$GotMfa),
					_List_Nil);
		}
	});
var $author$project$Api$Platform$Mfa$One$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Pages$User$Mfa$OtpCodeChanged = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$User$Mfa$viewActivate = F2(
	function (otpCode, activatingMfa) {
		var loading = function () {
			if (activatingMfa.$ === 1) {
				return true;
			} else {
				return false;
			}
		}();
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$li,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Enter the 6 digit code from your phone bellow')
							])),
						A2(
						$author$project$Ui$Grid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanSm(4)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$disabled(loading),
												$author$project$Ui$Form$Input$value(otpCode),
												$author$project$Ui$Form$Input$autofocus(true),
												$author$project$Ui$Form$Input$onInput($author$project$Pages$User$Mfa$OtpCodeChanged)
											])),
										loading ? $author$project$Ui$Spinner$view(_List_Nil) : $author$project$Utils$Html$empty
									]))
							]))
					]))
			]);
	});
var $author$project$Api$Platform$Mfa$One$accountName = function (_v0) {
	var record = _v0;
	return record.KH;
};
var $author$project$Api$Platform$Mfa$One$otpSecretKey = function (_v0) {
	var record = _v0;
	return record.Yy;
};
var $author$project$Pages$User$Mfa$viewManualSteps = function (mfa) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Select the '),
					A2(
					$author$project$Ui$Typography$strong,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Enter a provided key')
						])),
					$elm$html$Html$text(' option')
				])),
			A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Enter the following information')
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Account name: '),
							A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Platform$Mfa$One$accountName(mfa))
								])),
							A2($elm$html$Html$br, _List_Nil, _List_Nil),
							$elm$html$Html$text('Key: '),
							A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Platform$Mfa$One$otpSecretKey(mfa))
								]))
						]))
				])),
			A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Tap '),
							A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Add')
								]))
						]))
				]))
		]);
};
var $pablohirafuji$elm_qrcode$QRCode$Quartile = 2;
var $author$project$Pages$User$Mfa$SwitchToManual = {$: 1};
var $pablohirafuji$elm_qrcode$QRCode$QRCode = $elm$core$Basics$identity;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex = F3(
	function (size, row, col) {
		return (size * row) + col;
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$isOccupy = F4(
	function (row, col, size, matrix) {
		var _v0 = A2(
			$elm$core$Array$get,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row, col),
			matrix);
		if ((!_v0.$) && (!_v0.a.$)) {
			return true;
		} else {
			return false;
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$nextModule = function (placement) {
	var row = placement.pL;
	var col = placement.NQ;
	var isRight = placement.eF;
	var isUp = placement.sV;
	return isRight ? _Utils_update(
		placement,
		{NQ: col - 1, eF: false}) : (isUp ? _Utils_update(
		placement,
		{NQ: col + 1, eF: true, pL: row - 1}) : _Utils_update(
		placement,
		{NQ: col + 1, eF: true, pL: row + 1}));
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$bitToColor = F2(
	function (_byte, offset) {
		return (1 & (_byte >> (7 - offset))) === 1;
	});
var $elm$core$Elm$JsArray$unsafeSet = _JsArray_unsafeSet;
var $elm$core$Array$setHelp = F4(
	function (shift, index, value, tree) {
		var pos = $elm$core$Array$bitMask & (index >>> shift);
		var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
		if (!_v0.$) {
			var subTree = _v0.a;
			var newSub = A4($elm$core$Array$setHelp, shift - $elm$core$Array$shiftStep, index, value, subTree);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$SubTree(newSub),
				tree);
		} else {
			var values = _v0.a;
			var newLeaf = A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, values);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$Leaf(newLeaf),
				tree);
		}
	});
var $elm$core$Array$set = F3(
	function (index, value, array) {
		var len = array.a;
		var startShift = array.b;
		var tree = array.c;
		var tail = array.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? array : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			tree,
			A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, tail)) : A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			A4($elm$core$Array$setHelp, startShift, index, value, tree),
			tail));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setDataModule = F3(
	function (_v0, _byte, offset) {
		var size = _v0.aly;
		var row = _v0.pL;
		var col = _v0.NQ;
		return A2(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row, col),
			$elm$core$Maybe$Just(
				_Utils_Tuple2(
					false,
					A2($pablohirafuji$elm_qrcode$QRCode$Matrix$bitToColor, _byte, offset))));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$addDataModule = F4(
	function (placement, bytes, offset, matrix) {
		addDataModule:
		while (true) {
			var size = placement.aly;
			var row = placement.pL;
			var col = placement.NQ;
			if (!bytes.b) {
				return matrix;
			} else {
				var head = bytes.a;
				var tail = bytes.b;
				if (offset >= 8) {
					var $temp$placement = placement,
						$temp$bytes = tail,
						$temp$offset = 0,
						$temp$matrix = matrix;
					placement = $temp$placement;
					bytes = $temp$bytes;
					offset = $temp$offset;
					matrix = $temp$matrix;
					continue addDataModule;
				} else {
					if (col === 6) {
						var $temp$placement = _Utils_update(
							placement,
							{NQ: col - 1, eF: true}),
							$temp$bytes = bytes,
							$temp$offset = offset,
							$temp$matrix = matrix;
						placement = $temp$placement;
						bytes = $temp$bytes;
						offset = $temp$offset;
						matrix = $temp$matrix;
						continue addDataModule;
					} else {
						if (row < 0) {
							var $temp$placement = _Utils_update(
								placement,
								{NQ: col - 2, eF: true, sV: false, pL: 0}),
								$temp$bytes = bytes,
								$temp$offset = offset,
								$temp$matrix = matrix;
							placement = $temp$placement;
							bytes = $temp$bytes;
							offset = $temp$offset;
							matrix = $temp$matrix;
							continue addDataModule;
						} else {
							if (_Utils_cmp(row, size) > -1) {
								var $temp$placement = _Utils_update(
									placement,
									{NQ: col - 2, eF: true, sV: true, pL: size - 1}),
									$temp$bytes = bytes,
									$temp$offset = offset,
									$temp$matrix = matrix;
								placement = $temp$placement;
								bytes = $temp$bytes;
								offset = $temp$offset;
								matrix = $temp$matrix;
								continue addDataModule;
							} else {
								if (A4($pablohirafuji$elm_qrcode$QRCode$Matrix$isOccupy, row, col, size, matrix)) {
									var $temp$placement = $pablohirafuji$elm_qrcode$QRCode$Matrix$nextModule(placement),
										$temp$bytes = bytes,
										$temp$offset = offset,
										$temp$matrix = matrix;
									placement = $temp$placement;
									bytes = $temp$bytes;
									offset = $temp$offset;
									matrix = $temp$matrix;
									continue addDataModule;
								} else {
									var $temp$placement = $pablohirafuji$elm_qrcode$QRCode$Matrix$nextModule(placement),
										$temp$bytes = bytes,
										$temp$offset = offset + 1,
										$temp$matrix = A4($pablohirafuji$elm_qrcode$QRCode$Matrix$setDataModule, placement, head, offset, matrix);
									placement = $temp$placement;
									bytes = $temp$bytes;
									offset = $temp$offset;
									matrix = $temp$matrix;
									continue addDataModule;
								}
							}
						}
					}
				}
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$initPlacement = function (size) {
	return {NQ: size + 1, eF: true, sV: true, pL: size + 1, aly: size};
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$addData = F3(
	function (size, bytes, matrix) {
		return A4(
			$pablohirafuji$elm_qrcode$QRCode$Matrix$addDataModule,
			$pablohirafuji$elm_qrcode$QRCode$Matrix$initPlacement(size),
			bytes,
			0,
			matrix);
	});
var $pablohirafuji$elm_qrcode$QRCode$Error$AlignmentPatternNotFound = {$: 0};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentPatternData = $elm$core$Array$fromList(
	_List_fromArray(
		[
			_List_Nil,
			_List_fromArray(
			[6, 18]),
			_List_fromArray(
			[6, 22]),
			_List_fromArray(
			[6, 26]),
			_List_fromArray(
			[6, 30]),
			_List_fromArray(
			[6, 34]),
			_List_fromArray(
			[6, 22, 38]),
			_List_fromArray(
			[6, 24, 42]),
			_List_fromArray(
			[6, 26, 46]),
			_List_fromArray(
			[6, 28, 50]),
			_List_fromArray(
			[6, 30, 54]),
			_List_fromArray(
			[6, 32, 58]),
			_List_fromArray(
			[6, 34, 62]),
			_List_fromArray(
			[6, 26, 46, 66]),
			_List_fromArray(
			[6, 26, 48, 70]),
			_List_fromArray(
			[6, 26, 50, 74]),
			_List_fromArray(
			[6, 30, 54, 78]),
			_List_fromArray(
			[6, 30, 56, 82]),
			_List_fromArray(
			[6, 30, 58, 86]),
			_List_fromArray(
			[6, 34, 62, 90]),
			_List_fromArray(
			[6, 28, 50, 72, 94]),
			_List_fromArray(
			[6, 26, 50, 74, 98]),
			_List_fromArray(
			[6, 30, 54, 78, 102]),
			_List_fromArray(
			[6, 28, 54, 80, 106]),
			_List_fromArray(
			[6, 32, 58, 84, 110]),
			_List_fromArray(
			[6, 30, 58, 86, 114]),
			_List_fromArray(
			[6, 34, 62, 90, 118]),
			_List_fromArray(
			[6, 26, 50, 74, 98, 122]),
			_List_fromArray(
			[6, 30, 54, 78, 102, 126]),
			_List_fromArray(
			[6, 26, 52, 78, 104, 130]),
			_List_fromArray(
			[6, 30, 56, 82, 108, 134]),
			_List_fromArray(
			[6, 34, 60, 86, 112, 138]),
			_List_fromArray(
			[6, 30, 58, 86, 114, 142]),
			_List_fromArray(
			[6, 34, 62, 90, 118, 146]),
			_List_fromArray(
			[6, 30, 54, 78, 102, 126, 150]),
			_List_fromArray(
			[6, 24, 50, 76, 102, 128, 154]),
			_List_fromArray(
			[6, 28, 54, 80, 106, 132, 158]),
			_List_fromArray(
			[6, 32, 58, 84, 110, 136, 162]),
			_List_fromArray(
			[6, 26, 54, 82, 110, 138, 166]),
			_List_fromArray(
			[6, 30, 58, 86, 114, 142, 170])
		]));
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getAreaCoord = F2(
	function (rows, cols) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (row, list) {
					return A3(
						$elm$core$List$foldl,
						F2(
							function (col, list_) {
								return A2(
									$elm$core$List$cons,
									_Utils_Tuple2(row, col),
									list_);
							}),
						list,
						cols);
				}),
			_List_Nil,
			rows);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$isValidAlign = F2(
	function (size, _v0) {
		var row = _v0.a;
		var col = _v0.b;
		return ((row > 10) || ((10 < col) && (_Utils_cmp(col, size - 10) < 0))) && ((_Utils_cmp(row, size - 10) < 0) || (col > 10));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentRange = A2($elm$core$List$range, -2, 2);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentColor = F2(
	function (row, col) {
		return (_Utils_eq(row, -2) || ((row === 2) || (_Utils_eq(col, -2) || ((col === 2) || ((!row) && (!col)))))) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(true, true)) : $elm$core$Maybe$Just(
			_Utils_Tuple2(true, false));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignModule = F4(
	function (size, rowPos, colPos, _v0) {
		var row = _v0.a;
		var col = _v0.b;
		return A2(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row + rowPos, col + colPos),
			A2($pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentColor, row, col));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignment = F3(
	function (size, _v0, matrix) {
		var row = _v0.a;
		var col = _v0.b;
		return A3(
			$elm$core$List$foldl,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignModule, size, row, col),
			matrix,
			A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getAreaCoord, $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentRange, $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentRange));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignments = F3(
	function (size, locations, matrix) {
		return A3(
			$elm$core$List$foldl,
			$pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignment(size),
			matrix,
			A2(
				$elm$core$List$filter,
				$pablohirafuji$elm_qrcode$QRCode$Matrix$isValidAlign(size),
				A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getAreaCoord, locations, locations)));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentPattern = F3(
	function (version, size, matrix) {
		return A2(
			$elm$core$Result$map,
			function (a) {
				return A3($pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignments, size, a, matrix);
			},
			A2(
				$elm$core$Result$fromMaybe,
				$pablohirafuji$elm_qrcode$QRCode$Error$AlignmentPatternNotFound,
				A2($elm$core$Array$get, version - 1, $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentPatternData)));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$darkModule = F2(
	function (version, size) {
		return A2(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, (4 * version) + 9, 8),
			$elm$core$Maybe$Just(
				_Utils_Tuple2(true, true)));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$finderRange = A2($elm$core$List$range, 0, 8);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$finderColor = F2(
	function (row, col) {
		return ((1 <= row) && ((row <= 7) && ((col === 1) || (col === 7)))) || (((1 <= col) && ((col <= 7) && ((row === 1) || (row === 7)))) || ((3 <= row) && ((row <= 5) && ((3 <= col) && (col <= 5)))));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setFinder = F5(
	function (size, rowOffset, colOffset, _v0, matrix) {
		var row = _v0.a;
		var col = _v0.b;
		var finalRow = row + rowOffset;
		var finalCol = col + colOffset;
		return ((finalRow < 0) || ((finalCol < 0) || ((_Utils_cmp(finalRow, size) > -1) || (_Utils_cmp(finalCol, size) > -1)))) ? matrix : A3(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, finalRow, finalCol),
			$elm$core$Maybe$Just(
				_Utils_Tuple2(
					true,
					A2($pablohirafuji$elm_qrcode$QRCode$Matrix$finderColor, row, col))),
			matrix);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$finderPattern = F4(
	function (size, rowOffset, colOffset, matrix) {
		return A3(
			$elm$core$List$foldl,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$setFinder, size, rowOffset, colOffset),
			matrix,
			A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getAreaCoord, $pablohirafuji$elm_qrcode$QRCode$Matrix$finderRange, $pablohirafuji$elm_qrcode$QRCode$Matrix$finderRange));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$applyMaskColor = F2(
	function (maybeModule, isChange) {
		if (isChange) {
			if ((!maybeModule.$) && (!maybeModule.a.a)) {
				var _v1 = maybeModule.a;
				var isDark = _v1.b;
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(false, !isDark));
			} else {
				return maybeModule;
			}
		} else {
			return maybeModule;
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getCoord = F2(
	function (size, index) {
		return _Utils_Tuple2(
			(index / size) | 0,
			A2($elm$core$Basics$modBy, size, index));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$applyMaskFunction = F4(
	function (_function, size, index, maybeModule) {
		return A2(
			$pablohirafuji$elm_qrcode$QRCode$Matrix$applyMaskColor,
			maybeModule,
			_function(
				A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getCoord, size, index)));
	});
var $elm$core$Elm$JsArray$foldl = _JsArray_foldl;
var $elm$core$Elm$JsArray$indexedMap = _JsArray_indexedMap;
var $elm$core$Array$indexedMap = F2(
	function (func, _v0) {
		var len = _v0.a;
		var tree = _v0.c;
		var tail = _v0.d;
		var initialBuilder = {
			ak: _List_Nil,
			F: 0,
			X: A3(
				$elm$core$Elm$JsArray$indexedMap,
				func,
				$elm$core$Array$tailIndex(len),
				tail)
		};
		var helper = F2(
			function (node, builder) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldl, helper, builder, subTree);
				} else {
					var leaf = node.a;
					var offset = builder.F * $elm$core$Array$branchFactor;
					var mappedLeaf = $elm$core$Array$Leaf(
						A3($elm$core$Elm$JsArray$indexedMap, func, offset, leaf));
					return {
						ak: A2($elm$core$List$cons, mappedLeaf, builder.ak),
						F: builder.F + 1,
						X: builder.X
					};
				}
			});
		return A2(
			$elm$core$Array$builderToArray,
			true,
			A3($elm$core$Elm$JsArray$foldl, helper, initialBuilder, tree));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$maskFunction = function (mask) {
	switch (mask) {
		case 0:
			return function (_v1) {
				var row = _v1.a;
				var col = _v1.b;
				return !A2($elm$core$Basics$modBy, 2, row + col);
			};
		case 1:
			return function (_v2) {
				var row = _v2.a;
				return !A2($elm$core$Basics$modBy, 2, row);
			};
		case 2:
			return function (_v3) {
				var col = _v3.b;
				return !A2($elm$core$Basics$modBy, 3, col);
			};
		case 3:
			return function (_v4) {
				var row = _v4.a;
				var col = _v4.b;
				return !A2($elm$core$Basics$modBy, 3, row + col);
			};
		case 4:
			return function (_v5) {
				var row = _v5.a;
				var col = _v5.b;
				return !A2(
					$elm$core$Basics$modBy,
					2,
					$elm$core$Basics$floor(row / 2) + $elm$core$Basics$floor(col / 3));
			};
		case 5:
			return function (_v6) {
				var row = _v6.a;
				var col = _v6.b;
				return !(A2($elm$core$Basics$modBy, 2, row * col) + A2($elm$core$Basics$modBy, 3, row * col));
			};
		case 6:
			return function (_v7) {
				var row = _v7.a;
				var col = _v7.b;
				return !A2(
					$elm$core$Basics$modBy,
					2,
					A2($elm$core$Basics$modBy, 2, row * col) + A2($elm$core$Basics$modBy, 3, row * col));
			};
		default:
			return function (_v8) {
				var row = _v8.a;
				var col = _v8.b;
				return !A2(
					$elm$core$Basics$modBy,
					2,
					A2($elm$core$Basics$modBy, 3, row * col) + A2($elm$core$Basics$modBy, 2, row + col));
			};
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$applyMask = F3(
	function (size, mask, matrix) {
		return A2(
			$elm$core$Array$indexedMap,
			A2(
				$pablohirafuji$elm_qrcode$QRCode$Matrix$applyMaskFunction,
				$pablohirafuji$elm_qrcode$QRCode$Matrix$maskFunction(mask),
				size),
			matrix);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$breakList = F3(
	function (width, list, acc) {
		breakList:
		while (true) {
			if (!list.b) {
				return $elm$core$List$reverse(acc);
			} else {
				var $temp$width = width,
					$temp$list = A2($elm$core$List$drop, width, list),
					$temp$acc = A2(
					$elm$core$List$cons,
					A2($elm$core$List$take, width, list),
					acc);
				width = $temp$width;
				list = $temp$list;
				acc = $temp$acc;
				continue breakList;
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$isDarkModule = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map($elm$core$Tuple$second),
	$elm$core$Maybe$withDefault(false));
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score_ = F2(
	function (simplifiedList, _v0) {
		rule1Score_:
		while (true) {
			var last = _v0.a;
			var partialScore = _v0.b;
			var score = _v0.c;
			if (!simplifiedList.b) {
				return (partialScore >= 5) ? ((score + partialScore) - 2) : score;
			} else {
				var head = simplifiedList.a;
				var tail = simplifiedList.b;
				if (_Utils_eq(last, head)) {
					var $temp$simplifiedList = tail,
						$temp$_v0 = _Utils_Tuple3(last, partialScore + 1, score);
					simplifiedList = $temp$simplifiedList;
					_v0 = $temp$_v0;
					continue rule1Score_;
				} else {
					if (partialScore >= 5) {
						var $temp$simplifiedList = tail,
							$temp$_v0 = _Utils_Tuple3(head, 0, (score + partialScore) - 2);
						simplifiedList = $temp$simplifiedList;
						_v0 = $temp$_v0;
						continue rule1Score_;
					} else {
						var $temp$simplifiedList = tail,
							$temp$_v0 = _Utils_Tuple3(head, 0, score);
						simplifiedList = $temp$simplifiedList;
						_v0 = $temp$_v0;
						continue rule1Score_;
					}
				}
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$map(
		function (a) {
			return A2(
				$pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score_,
				a,
				_Utils_Tuple3(false, 0, 0));
		}),
	$elm$core$List$sum);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule2Score_ = F4(
	function (row1, row2, maybeLast, score) {
		rule2Score_:
		while (true) {
			if (!row1.b) {
				return score;
			} else {
				var head = row1.a;
				var tail = row1.b;
				if (!row2.b) {
					return score;
				} else {
					var head2 = row2.a;
					var tail2 = row2.b;
					if (_Utils_eq(head, head2)) {
						if (_Utils_eq(
							$elm$core$Maybe$Just(head),
							maybeLast)) {
							var $temp$row1 = tail,
								$temp$row2 = tail2,
								$temp$maybeLast = $elm$core$Maybe$Just(head),
								$temp$score = score + 3;
							row1 = $temp$row1;
							row2 = $temp$row2;
							maybeLast = $temp$maybeLast;
							score = $temp$score;
							continue rule2Score_;
						} else {
							var $temp$row1 = tail,
								$temp$row2 = tail2,
								$temp$maybeLast = $elm$core$Maybe$Just(head),
								$temp$score = score;
							row1 = $temp$row1;
							row2 = $temp$row2;
							maybeLast = $temp$maybeLast;
							score = $temp$score;
							continue rule2Score_;
						}
					} else {
						var $temp$row1 = tail,
							$temp$row2 = tail2,
							$temp$maybeLast = $elm$core$Maybe$Nothing,
							$temp$score = score;
						row1 = $temp$row1;
						row2 = $temp$row2;
						maybeLast = $temp$maybeLast;
						score = $temp$score;
						continue rule2Score_;
					}
				}
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule2Score = F2(
	function (list, score) {
		rule2Score:
		while (true) {
			if (list.b && list.b.b) {
				var head1 = list.a;
				var _v1 = list.b;
				var head2 = _v1.a;
				var tail = _v1.b;
				var $temp$list = tail,
					$temp$score = score + A4($pablohirafuji$elm_qrcode$QRCode$Matrix$rule2Score_, head1, head2, $elm$core$Maybe$Nothing, 0);
				list = $temp$list;
				score = $temp$score;
				continue rule2Score;
			} else {
				return score;
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score_ = F2(
	function (simplifiedList, score) {
		rule3Score_:
		while (true) {
			_v0$3:
			while (true) {
				if (!simplifiedList.b) {
					return score;
				} else {
					if (!simplifiedList.a) {
						if (((((((((((((((((((simplifiedList.b.b && (!simplifiedList.b.a)) && simplifiedList.b.b.b) && (!simplifiedList.b.b.a)) && simplifiedList.b.b.b.b) && (!simplifiedList.b.b.b.a)) && simplifiedList.b.b.b.b.b) && simplifiedList.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b) && simplifiedList.b.b.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b.b.b) && simplifiedList.b.b.b.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b.b.b.b) && simplifiedList.b.b.b.b.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b.b.b.b.b) && simplifiedList.b.b.b.b.b.b.b.b.b.b.a) {
							var _v1 = simplifiedList.b;
							var _v2 = _v1.b;
							var _v3 = _v2.b;
							var _v4 = _v3.b;
							var _v5 = _v4.b;
							var _v6 = _v5.b;
							var _v7 = _v6.b;
							var _v8 = _v7.b;
							var _v9 = _v8.b;
							var _v10 = _v9.b;
							var tail = _v10.b;
							var $temp$simplifiedList = tail,
								$temp$score = score + 40;
							simplifiedList = $temp$simplifiedList;
							score = $temp$score;
							continue rule3Score_;
						} else {
							break _v0$3;
						}
					} else {
						if (((((((((((((((((((simplifiedList.b.b && (!simplifiedList.b.a)) && simplifiedList.b.b.b) && simplifiedList.b.b.a) && simplifiedList.b.b.b.b) && simplifiedList.b.b.b.a) && simplifiedList.b.b.b.b.b) && simplifiedList.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b) && simplifiedList.b.b.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.b.b.b.b.b.a)) {
							var _v11 = simplifiedList.b;
							var _v12 = _v11.b;
							var _v13 = _v12.b;
							var _v14 = _v13.b;
							var _v15 = _v14.b;
							var _v16 = _v15.b;
							var _v17 = _v16.b;
							var _v18 = _v17.b;
							var _v19 = _v18.b;
							var _v20 = _v19.b;
							var tail = _v20.b;
							var $temp$simplifiedList = tail,
								$temp$score = score + 40;
							simplifiedList = $temp$simplifiedList;
							score = $temp$score;
							continue rule3Score_;
						} else {
							break _v0$3;
						}
					}
				}
			}
			var head = simplifiedList.a;
			var tail = simplifiedList.b;
			var $temp$simplifiedList = tail,
				$temp$score = score;
			simplifiedList = $temp$simplifiedList;
			score = $temp$score;
			continue rule3Score_;
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score = A2($elm$core$List$foldl, $pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score_, 0);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule4Score = F2(
	function (size, simplifiedList) {
		var moduleCount = size * size;
		var darkCount = $elm$core$List$length(
			A2($elm$core$List$filter, $elm$core$Basics$identity, simplifiedList));
		var darkPerc = $elm$core$Basics$round((100 * darkCount) / moduleCount);
		var remOf5 = darkPerc % 5;
		var nextMult5 = $elm$core$Basics$round(
			$elm$core$Basics$abs((darkPerc + (5 - remOf5)) - 50) / 5);
		var prevMult5 = $elm$core$Basics$round(
			$elm$core$Basics$abs((darkPerc - remOf5) - 50) / 5);
		return A2($elm$core$Basics$min, prevMult5, nextMult5) * 10;
	});
var $pablohirafuji$elm_qrcode$QRCode$Helpers$transpose = function (ll) {
	transpose:
	while (true) {
		if (!ll.b) {
			return _List_Nil;
		} else {
			if (!ll.a.b) {
				var xss = ll.b;
				var $temp$ll = xss;
				ll = $temp$ll;
				continue transpose;
			} else {
				var _v1 = ll.a;
				var x = _v1.a;
				var xs = _v1.b;
				var xss = ll.b;
				var tails = A2($elm$core$List$filterMap, $elm$core$List$tail, xss);
				var heads = A2($elm$core$List$filterMap, $elm$core$List$head, xss);
				return A2(
					$elm$core$List$cons,
					A2($elm$core$List$cons, x, heads),
					$pablohirafuji$elm_qrcode$QRCode$Helpers$transpose(
						A2($elm$core$List$cons, xs, tails)));
			}
		}
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getMaskScore = F2(
	function (size, matrix) {
		var list = A2(
			$elm$core$List$map,
			$pablohirafuji$elm_qrcode$QRCode$Matrix$isDarkModule,
			$elm$core$Array$toList(matrix));
		var rowList = A3($pablohirafuji$elm_qrcode$QRCode$Matrix$breakList, size, list, _List_Nil);
		var transposedRowList = $pablohirafuji$elm_qrcode$QRCode$Helpers$transpose(rowList);
		return function (b) {
			return _Utils_Tuple2(rowList, b);
		}(
			A2($pablohirafuji$elm_qrcode$QRCode$Matrix$rule4Score, size, list) + ($pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score(transposedRowList) + ($pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score(rowList) + (A2($pablohirafuji$elm_qrcode$QRCode$Matrix$rule2Score, rowList, 0) + ($pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score(transposedRowList) + $pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score(rowList))))));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$ecLevelToInt = function (ecLevel) {
	switch (ecLevel) {
		case 0:
			return 1;
		case 1:
			return 0;
		case 2:
			return 3;
		default:
			return 2;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit = function (_int) {
	var helper = F2(
		function (digit, int_) {
			helper:
			while (true) {
				if (!(!int_)) {
					var $temp$digit = digit + 1,
						$temp$int_ = int_ >>> 1;
					digit = $temp$digit;
					int_ = $temp$int_;
					continue helper;
				} else {
					return digit;
				}
			}
		});
	return A2(helper, 0, _int);
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$maskToInt = function (mask) {
	switch (mask) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		case 4:
			return 4;
		case 5:
			return 5;
		case 6:
			return 6;
		default:
			return 7;
	}
};
var $elm$core$Bitwise$xor = _Bitwise_xor;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$encodeFormatInfo = F2(
	function (ecLevel, mask) {
		var g15Mask = 21522;
		var g15Int = 1335;
		var g15Digit = $pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(g15Int);
		var formatInfoInt = $pablohirafuji$elm_qrcode$QRCode$Matrix$maskToInt(mask) | ($pablohirafuji$elm_qrcode$QRCode$Matrix$ecLevelToInt(ecLevel) << 3);
		var helper = function (d_) {
			helper:
			while (true) {
				if (($pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(d_) - g15Digit) >= 0) {
					var $temp$d_ = d_ ^ (g15Int << ($pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(d_) - g15Digit));
					d_ = $temp$d_;
					continue helper;
				} else {
					return g15Mask ^ (d_ | (formatInfoInt << 10));
				}
			}
		};
		var d = formatInfoInt << 10;
		return helper(d);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$formatInfoHorizontal = F2(
	function (size, count) {
		return (count < 8) ? _Utils_Tuple2(8, (size - count) - 1) : ((count < 9) ? _Utils_Tuple2(8, 15 - count) : _Utils_Tuple2(8, (15 - count) - 1));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$formatInfoVertical = F2(
	function (size, count) {
		return (count < 6) ? _Utils_Tuple2(count, 8) : ((count < 8) ? _Utils_Tuple2(count + 1, 8) : _Utils_Tuple2((size - 15) + count, 8));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatModule = F4(
	function (size, isBlack, row, col) {
		return A2(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row, col),
			$elm$core$Maybe$Just(
				_Utils_Tuple2(true, isBlack)));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo_ = F4(
	function (size, isBlackFn, count, matrix) {
		setFormatInfo_:
		while (true) {
			if (count < 15) {
				var isBlack = isBlackFn(count);
				var _v0 = A2($pablohirafuji$elm_qrcode$QRCode$Matrix$formatInfoVertical, size, count);
				var x2 = _v0.a;
				var y2 = _v0.b;
				var _v1 = A2($pablohirafuji$elm_qrcode$QRCode$Matrix$formatInfoHorizontal, size, count);
				var x1 = _v1.a;
				var y1 = _v1.b;
				var $temp$size = size,
					$temp$isBlackFn = isBlackFn,
					$temp$count = count + 1,
					$temp$matrix = A5(
					$pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatModule,
					size,
					isBlack,
					x2,
					y2,
					A5($pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatModule, size, isBlack, x1, y1, matrix));
				size = $temp$size;
				isBlackFn = $temp$isBlackFn;
				count = $temp$count;
				matrix = $temp$matrix;
				continue setFormatInfo_;
			} else {
				return matrix;
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo = F4(
	function (ecLevel, size, mask, matrix) {
		var isBlack = F2(
			function (bits_, count) {
				return (1 & (bits_ >> count)) === 1;
			});
		var bits = A2($pablohirafuji$elm_qrcode$QRCode$Matrix$encodeFormatInfo, ecLevel, mask);
		return A4(
			$pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo_,
			size,
			isBlack(bits),
			0,
			matrix);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getBestMask_ = F5(
	function (ecLevel, size, matrix, mask, _v0) {
		var minSMatrix = _v0.a;
		var minScore = _v0.b;
		var maskedMatrix = A4(
			$pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo,
			ecLevel,
			size,
			mask,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$applyMask, size, mask, matrix));
		var _v1 = A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getMaskScore, size, maskedMatrix);
		var maskSMatrix = _v1.a;
		var maskScore = _v1.b;
		return ((_Utils_cmp(minScore, maskScore) < 0) && (!_Utils_eq(minScore, -1))) ? _Utils_Tuple2(minSMatrix, minScore) : _Utils_Tuple2(maskSMatrix, maskScore);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern0 = 0;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern1 = 1;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern2 = 2;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern3 = 3;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern4 = 4;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern5 = 5;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern6 = 6;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern7 = 7;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$patternList = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7]);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getBestMask = F3(
	function (ecLevel, size, matrix) {
		return A3(
			$elm$core$List$foldl,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getBestMask_, ecLevel, size, matrix),
			_Utils_Tuple2(_List_Nil, -1),
			$pablohirafuji$elm_qrcode$QRCode$Matrix$patternList).a;
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$reserveFormatInfo = F2(
	function (size, matrix) {
		return A4(
			$pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo_,
			size,
			$elm$core$Basics$always(true),
			0,
			matrix);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$encodeVersionInfo = function (version) {
	var g18Int = 7973;
	var g18Digit = $pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(g18Int);
	var helper = function (d_) {
		helper:
		while (true) {
			if (($pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(d_) - g18Digit) >= 0) {
				var $temp$d_ = d_ ^ (g18Int << ($pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(d_) - g18Digit));
				d_ = $temp$d_;
				continue helper;
			} else {
				return d_ | (version << 12);
			}
		}
	};
	var d = version << 12;
	return helper(d);
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionModule = F3(
	function (size, isBlack, _v0) {
		var row = _v0.a;
		var col = _v0.b;
		return A2(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row, col),
			$elm$core$Maybe$Just(
				_Utils_Tuple2(true, isBlack)));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionInfo_ = F4(
	function (size, isBlackFn, count, matrix) {
		setVersionInfo_:
		while (true) {
			if (count < 18) {
				var topRight = _Utils_Tuple2(
					$elm$core$Basics$floor(count / 3),
					((A2($elm$core$Basics$modBy, 3, count) + size) - 8) - 3);
				var isBlack = isBlackFn(count);
				var bottomLeft = _Utils_Tuple2(
					((A2($elm$core$Basics$modBy, 3, count) + size) - 8) - 3,
					$elm$core$Basics$floor(count / 3));
				var $temp$size = size,
					$temp$isBlackFn = isBlackFn,
					$temp$count = count + 1,
					$temp$matrix = A4(
					$pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionModule,
					size,
					isBlack,
					bottomLeft,
					A4($pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionModule, size, isBlack, topRight, matrix));
				size = $temp$size;
				isBlackFn = $temp$isBlackFn;
				count = $temp$count;
				matrix = $temp$matrix;
				continue setVersionInfo_;
			} else {
				return matrix;
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionInfo = F3(
	function (version, size, matrix) {
		if (version >= 7) {
			var isBlack = F2(
				function (bits_, count) {
					return (1 & (bits_ >> count)) === 1;
				});
			var bits = $pablohirafuji$elm_qrcode$QRCode$Matrix$encodeVersionInfo(version);
			return A4(
				$pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionInfo_,
				size,
				isBlack(bits),
				0,
				matrix);
		} else {
			return matrix;
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$timingColor = F2(
	function (row, col) {
		return (!A2($elm$core$Basics$modBy, 2, row + col)) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(true, true)) : $elm$core$Maybe$Just(
			_Utils_Tuple2(true, false));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setTiming = F3(
	function (size, row, col) {
		return A2(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row, col),
			A2($pablohirafuji$elm_qrcode$QRCode$Matrix$timingColor, row, col));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$timingPattern = F2(
	function (size, matrix) {
		var range = A2($elm$core$List$range, 8, size - 9);
		return A3(
			$elm$core$List$foldl,
			function (b) {
				return A3($pablohirafuji$elm_qrcode$QRCode$Matrix$setTiming, size, b, 6);
			},
			A3(
				$elm$core$List$foldl,
				A2($pablohirafuji$elm_qrcode$QRCode$Matrix$setTiming, size, 6),
				matrix,
				range),
			range);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$apply = function (_v0) {
	var ecLevel = _v0.a.Q$;
	var groupInfo = _v0.a.ahB;
	var bytes = _v0.b;
	var version = groupInfo.Kn;
	var size = ((version - 1) * 4) + 21;
	return A2(
		$elm$core$Result$map,
		A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getBestMask, ecLevel, size),
		A2(
			$elm$core$Result$map,
			A2($pablohirafuji$elm_qrcode$QRCode$Matrix$addData, size, bytes),
			A3(
				$pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentPattern,
				version,
				size,
				A2(
					$pablohirafuji$elm_qrcode$QRCode$Matrix$timingPattern,
					size,
					A3(
						$pablohirafuji$elm_qrcode$QRCode$Matrix$darkModule,
						version,
						size,
						A3(
							$pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionInfo,
							version,
							size,
							A2(
								$pablohirafuji$elm_qrcode$QRCode$Matrix$reserveFormatInfo,
								size,
								A4(
									$pablohirafuji$elm_qrcode$QRCode$Matrix$finderPattern,
									size,
									-1,
									size - 8,
									A4(
										$pablohirafuji$elm_qrcode$QRCode$Matrix$finderPattern,
										size,
										size - 8,
										-1,
										A4(
											$pablohirafuji$elm_qrcode$QRCode$Matrix$finderPattern,
											size,
											-1,
											-1,
											A2(
												$elm$core$Array$initialize,
												size * size,
												$elm$core$Basics$always($elm$core$Maybe$Nothing))))))))))));
};
var $pablohirafuji$elm_qrcode$QRCode$ECLevel$H = 3;
var $pablohirafuji$elm_qrcode$QRCode$ECLevel$L = 0;
var $pablohirafuji$elm_qrcode$QRCode$ECLevel$M = 1;
var $pablohirafuji$elm_qrcode$QRCode$ECLevel$Q = 2;
var $pablohirafuji$elm_qrcode$QRCode$convertEC = function (ec) {
	switch (ec) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$AlignmentPatternNotFound = {$: 0};
var $pablohirafuji$elm_qrcode$QRCode$InputLengthOverflow = {$: 7};
var $pablohirafuji$elm_qrcode$QRCode$InvalidAlphanumericChar = {$: 2};
var $pablohirafuji$elm_qrcode$QRCode$InvalidNumericChar = {$: 1};
var $pablohirafuji$elm_qrcode$QRCode$InvalidUTF8Char = {$: 3};
var $pablohirafuji$elm_qrcode$QRCode$LogTableException = function (a) {
	return {$: 4, a: a};
};
var $pablohirafuji$elm_qrcode$QRCode$PolynomialModException = {$: 6};
var $pablohirafuji$elm_qrcode$QRCode$PolynomialMultiplyException = {$: 5};
var $pablohirafuji$elm_qrcode$QRCode$convertError = function (e) {
	switch (e.$) {
		case 0:
			return $pablohirafuji$elm_qrcode$QRCode$AlignmentPatternNotFound;
		case 1:
			return $pablohirafuji$elm_qrcode$QRCode$InvalidNumericChar;
		case 2:
			return $pablohirafuji$elm_qrcode$QRCode$InvalidAlphanumericChar;
		case 3:
			return $pablohirafuji$elm_qrcode$QRCode$InvalidUTF8Char;
		case 4:
			var n = e.a;
			return $pablohirafuji$elm_qrcode$QRCode$LogTableException(n);
		case 5:
			return $pablohirafuji$elm_qrcode$QRCode$PolynomialMultiplyException;
		case 6:
			return $pablohirafuji$elm_qrcode$QRCode$PolynomialModException;
		default:
			return $pablohirafuji$elm_qrcode$QRCode$InputLengthOverflow;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$firstFillerByte = 236;
var $pablohirafuji$elm_qrcode$QRCode$Encode$secondFillerByte = 17;
var $pablohirafuji$elm_qrcode$QRCode$Encode$addFiller = F2(
	function (capacity, bytes) {
		var fillerLength = ((capacity / 8) | 0) - $elm$core$List$length(bytes);
		var ns = $elm$core$List$concat(
			A2(
				$elm$core$List$repeat,
				(fillerLength / 2) | 0,
				_List_fromArray(
					[$pablohirafuji$elm_qrcode$QRCode$Encode$firstFillerByte, $pablohirafuji$elm_qrcode$QRCode$Encode$secondFillerByte])));
		return (!A2($elm$core$Basics$modBy, 2, fillerLength)) ? _Utils_ap(bytes, ns) : _Utils_ap(
			bytes,
			_Utils_ap(
				ns,
				_List_fromArray(
					[$pablohirafuji$elm_qrcode$QRCode$Encode$firstFillerByte])));
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$addTerminator = F3(
	function (capacity, bitsCount, bits) {
		return _Utils_ap(
			bits,
			_List_fromArray(
				[
					_Utils_Tuple2(
					0,
					A2($elm$core$Basics$min, 4, capacity - bitsCount))
				]));
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes3 = function (_v0) {
	bitsToBytes3:
	while (true) {
		var _v1 = _v0.a;
		var bits = _v1.a;
		var length = _v1.b;
		var bytes = _v0.b;
		if (length >= 8) {
			var remLength = length - 8;
			var remBits = bits & ((1 << remLength) - 1);
			var _byte = bits >> remLength;
			var $temp$_v0 = _Utils_Tuple2(
				_Utils_Tuple2(remBits, remLength),
				A2($elm$core$List$cons, _byte, bytes));
			_v0 = $temp$_v0;
			continue bitsToBytes3;
		} else {
			return _Utils_Tuple2(
				_Utils_Tuple2(bits, length),
				bytes);
		}
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes2 = F2(
	function (_v0, _v1) {
		var curBits = _v0.a;
		var curLength = _v0.b;
		var _v2 = _v1.a;
		var remBits = _v2.a;
		var remLength = _v2.b;
		var bytes = _v1.b;
		var lengthSum = curLength + remLength;
		var bitsSum = curBits | (remBits << curLength);
		return $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes3(
			_Utils_Tuple2(
				_Utils_Tuple2(bitsSum, lengthSum),
				bytes));
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes1 = F2(
	function (bits, _v0) {
		bitsToBytes1:
		while (true) {
			var _v1 = _v0.a;
			var remBits = _v1.a;
			var remLength = _v1.b;
			var bytes = _v0.b;
			if (bits.b) {
				var head = bits.a;
				var tail = bits.b;
				var $temp$bits = tail,
					$temp$_v0 = A2(
					$pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes2,
					head,
					_Utils_Tuple2(
						_Utils_Tuple2(remBits, remLength),
						bytes));
				bits = $temp$bits;
				_v0 = $temp$_v0;
				continue bitsToBytes1;
			} else {
				return (!remLength) ? $elm$core$List$reverse(bytes) : $elm$core$List$reverse(
					A2($elm$core$List$cons, remBits << (8 - remLength), bytes));
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes = function (bits) {
	return A2(
		$pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes1,
		bits,
		_Utils_Tuple2(
			_Utils_Tuple2(0, 0),
			_List_Nil));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8 = 3;
var $pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicatorLength = F2(
	function (mode, version) {
		if (version <= 9) {
			switch (mode) {
				case 0:
					return 10;
				case 1:
					return 9;
				case 2:
					return 8;
				default:
					return 8;
			}
		} else {
			if (version <= 26) {
				switch (mode) {
					case 0:
						return 12;
					case 1:
						return 11;
					case 2:
						return 16;
					default:
						return 16;
				}
			} else {
				switch (mode) {
					case 0:
						return 14;
					case 1:
						return 13;
					case 2:
						return 16;
					default:
						return 16;
				}
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicator = F2(
	function (_v0, bits) {
		var groupInfo = _v0.ahB;
		var inputStr = _v0.H5;
		var mode = _v0.aiN;
		var length = A2($pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicatorLength, mode, groupInfo.Kn);
		var charCount = (mode === 3) ? $elm$core$List$length(bits) : $elm$core$String$length(inputStr);
		return _Utils_Tuple2(charCount, length);
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$modeIndicator = function (mode) {
	switch (mode) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 4;
		default:
			return 4;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$addInfoAndFinalBits = function (_v0) {
	var bits = _v0.a;
	var model = _v0.b;
	return _Utils_Tuple2(
		model,
		A2(
			$pablohirafuji$elm_qrcode$QRCode$Encode$addFiller,
			model.ahB.xS,
			$pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes(
				A3(
					$pablohirafuji$elm_qrcode$QRCode$Encode$addTerminator,
					model.ahB.xS,
					model.GG,
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							$pablohirafuji$elm_qrcode$QRCode$Encode$modeIndicator(model.aiN),
							4),
						A2(
							$elm$core$List$cons,
							A2($pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicator, model, bits),
							bits))))));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$concatTranspose = function (_v0) {
	var model = _v0.a;
	var dataBlocks = _v0.b;
	var ecBlocks = _v0.c;
	return _Utils_Tuple2(
		model,
		$elm$core$List$concat(
			_Utils_ap(
				$pablohirafuji$elm_qrcode$QRCode$Helpers$transpose(dataBlocks),
				$pablohirafuji$elm_qrcode$QRCode$Helpers$transpose(ecBlocks))));
};
var $elm_community$list_extra$List$Extra$greedyGroupsOfWithStep = F3(
	function (size, step, xs) {
		var xs_ = A2($elm$core$List$drop, step, xs);
		var okayXs = $elm$core$List$length(xs) > 0;
		var okayArgs = (size > 0) && (step > 0);
		return (okayArgs && okayXs) ? A2(
			$elm$core$List$cons,
			A2($elm$core$List$take, size, xs),
			A3($elm_community$list_extra$List$Extra$greedyGroupsOfWithStep, size, step, xs_)) : _List_Nil;
	});
var $elm_community$list_extra$List$Extra$greedyGroupsOf = F2(
	function (size, xs) {
		return A3($elm_community$list_extra$List$Extra$greedyGroupsOfWithStep, size, size, xs);
	});
var $pablohirafuji$elm_qrcode$QRCode$Error$InvalidAlphanumericChar = {$: 2};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$alphanumericCodes = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('0', 0),
			_Utils_Tuple2('1', 1),
			_Utils_Tuple2('2', 2),
			_Utils_Tuple2('3', 3),
			_Utils_Tuple2('4', 4),
			_Utils_Tuple2('5', 5),
			_Utils_Tuple2('6', 6),
			_Utils_Tuple2('7', 7),
			_Utils_Tuple2('8', 8),
			_Utils_Tuple2('9', 9),
			_Utils_Tuple2('A', 10),
			_Utils_Tuple2('B', 11),
			_Utils_Tuple2('C', 12),
			_Utils_Tuple2('D', 13),
			_Utils_Tuple2('E', 14),
			_Utils_Tuple2('F', 15),
			_Utils_Tuple2('G', 16),
			_Utils_Tuple2('H', 17),
			_Utils_Tuple2('I', 18),
			_Utils_Tuple2('J', 19),
			_Utils_Tuple2('K', 20),
			_Utils_Tuple2('L', 21),
			_Utils_Tuple2('M', 22),
			_Utils_Tuple2('N', 23),
			_Utils_Tuple2('O', 24),
			_Utils_Tuple2('P', 25),
			_Utils_Tuple2('Q', 26),
			_Utils_Tuple2('R', 27),
			_Utils_Tuple2('S', 28),
			_Utils_Tuple2('T', 29),
			_Utils_Tuple2('U', 30),
			_Utils_Tuple2('V', 31),
			_Utils_Tuple2('W', 32),
			_Utils_Tuple2('X', 33),
			_Utils_Tuple2('Y', 34),
			_Utils_Tuple2('Z', 35),
			_Utils_Tuple2(' ', 36),
			_Utils_Tuple2('$', 37),
			_Utils_Tuple2('%', 38),
			_Utils_Tuple2('*', 39),
			_Utils_Tuple2('+', 40),
			_Utils_Tuple2('-', 41),
			_Utils_Tuple2('.', 42),
			_Utils_Tuple2('/', 43),
			_Utils_Tuple2(':', 44)
		]));
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toAlphanumericCode = function (_char) {
	return A2(
		$elm$core$Result$fromMaybe,
		$pablohirafuji$elm_qrcode$QRCode$Error$InvalidAlphanumericChar,
		A2($elm$core$Dict$get, _char, $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$alphanumericCodes));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toBinary = function (chars) {
	_v0$2:
	while (true) {
		if (chars.b) {
			if (chars.b.b) {
				if (!chars.b.b.b) {
					var firstChar = chars.a;
					var _v1 = chars.b;
					var secondChar = _v1.a;
					return A3(
						$elm$core$Result$map2,
						F2(
							function (firstCode, secondCode) {
								return _Utils_Tuple2((firstCode * 45) + secondCode, 11);
							}),
						$pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toAlphanumericCode(firstChar),
						$pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toAlphanumericCode(secondChar));
				} else {
					break _v0$2;
				}
			} else {
				var _char = chars.a;
				return A2(
					$elm$core$Result$map,
					function (a) {
						return _Utils_Tuple2(a, 6);
					},
					$pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toAlphanumericCode(_char));
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Result$Err($pablohirafuji$elm_qrcode$QRCode$Error$InvalidAlphanumericChar);
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$encode = function (str) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Result$map2($elm$core$List$cons),
		$elm$core$Result$Ok(_List_Nil),
		A2(
			$elm$core$List$map,
			$pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toBinary,
			A2(
				$elm_community$list_extra$List$Extra$greedyGroupsOf,
				2,
				$elm$core$String$toList(str))));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Byte$encode = function (str) {
	return $elm$core$Result$Ok(
		A2(
			$elm$core$List$map,
			function (a) {
				return _Utils_Tuple2(
					$elm$core$Char$toCode(a),
					8);
			},
			$elm$core$String$toList(str)));
};
var $pablohirafuji$elm_qrcode$QRCode$Error$InvalidNumericChar = {$: 1};
var $elm$core$String$fromList = _String_fromList;
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$numericLength = function (str) {
	var _v0 = $elm$core$String$length(str);
	switch (_v0) {
		case 1:
			return 4;
		case 2:
			return 7;
		default:
			return 10;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$encodeHelp = function (chars) {
	var str = $elm$core$String$fromList(chars);
	return A2(
		$elm$core$Result$fromMaybe,
		$pablohirafuji$elm_qrcode$QRCode$Error$InvalidNumericChar,
		A2(
			$elm$core$Maybe$map,
			function (a) {
				return _Utils_Tuple2(
					a,
					$pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$numericLength(str));
			},
			$elm$core$String$toInt(str)));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$encode = function (str) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Result$map2($elm$core$List$cons),
		$elm$core$Result$Ok(_List_Nil),
		A2(
			$elm$core$List$map,
			$pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$encodeHelp,
			A2(
				$elm_community$list_extra$List$Extra$greedyGroupsOf,
				3,
				$elm$core$String$toList(str))));
};
var $pablohirafuji$elm_qrcode$QRCode$Error$InvalidUTF8Char = {$: 3};
var $elm$bytes$Bytes$Encode$getStringWidth = _Bytes_getStringWidth;
var $elm$bytes$Bytes$Decode$loopHelp = F4(
	function (state, callback, bites, offset) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var decoder = _v0;
			var _v1 = A2(decoder, bites, offset);
			var newOffset = _v1.a;
			var step = _v1.b;
			if (!step.$) {
				var newState = step.a;
				var $temp$state = newState,
					$temp$callback = callback,
					$temp$bites = bites,
					$temp$offset = newOffset;
				state = $temp$state;
				callback = $temp$callback;
				bites = $temp$bites;
				offset = $temp$offset;
				continue loopHelp;
			} else {
				var result = step.a;
				return _Utils_Tuple2(newOffset, result);
			}
		}
	});
var $elm$bytes$Bytes$Decode$loop = F2(
	function (state, callback) {
		return A2($elm$bytes$Bytes$Decode$loopHelp, state, callback);
	});
var $elm$bytes$Bytes$Decode$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$bytes$Bytes$Decode$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$bytes$Bytes$Decode$map = F2(
	function (func, _v0) {
		var decodeA = _v0;
		return F2(
			function (bites, offset) {
				var _v1 = A2(decodeA, bites, offset);
				var aOffset = _v1.a;
				var a = _v1.b;
				return _Utils_Tuple2(
					aOffset,
					func(a));
			});
	});
var $elm$bytes$Bytes$Decode$succeed = function (a) {
	return F2(
		function (_v0, offset) {
			return _Utils_Tuple2(offset, a);
		});
};
var $elm$bytes$Bytes$Decode$unsignedInt8 = _Bytes_read_u8;
var $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$step = function (_v0) {
	var n = _v0.a;
	var xs = _v0.b;
	return (n <= 0) ? $elm$bytes$Bytes$Decode$succeed(
		$elm$bytes$Bytes$Decode$Done(
			$elm$core$List$reverse(xs))) : A2(
		$elm$bytes$Bytes$Decode$map,
		function (x) {
			return $elm$bytes$Bytes$Decode$Loop(
				_Utils_Tuple2(
					n - 1,
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(x, 8),
						xs)));
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $elm$bytes$Bytes$Encode$Utf8 = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $elm$bytes$Bytes$Encode$string = function (str) {
	return A2(
		$elm$bytes$Bytes$Encode$Utf8,
		_Bytes_getStringWidth(str),
		str);
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$encode = function (str) {
	var utf8BytesWidth = $elm$bytes$Bytes$Encode$getStringWidth(str);
	var decoder = A2(
		$elm$bytes$Bytes$Decode$loop,
		_Utils_Tuple2(utf8BytesWidth, _List_Nil),
		$pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$step);
	return A2(
		$elm$core$Result$fromMaybe,
		$pablohirafuji$elm_qrcode$QRCode$Error$InvalidUTF8Char,
		A2(
			$elm$bytes$Bytes$Decode$decode,
			decoder,
			$elm$bytes$Bytes$Encode$encode(
				$elm$bytes$Bytes$Encode$string(str))));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$encoder = function (mode) {
	switch (mode) {
		case 0:
			return $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$encode;
		case 1:
			return $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$encode;
		case 2:
			return $pablohirafuji$elm_qrcode$QRCode$Encode$Byte$encode;
		default:
			return $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$encode;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$expTable = $elm$core$Array$fromList(
	_List_fromArray(
		[1, 2, 4, 8, 16, 32, 64, 128, 29, 58, 116, 232, 205, 135, 19, 38, 76, 152, 45, 90, 180, 117, 234, 201, 143, 3, 6, 12, 24, 48, 96, 192, 157, 39, 78, 156, 37, 74, 148, 53, 106, 212, 181, 119, 238, 193, 159, 35, 70, 140, 5, 10, 20, 40, 80, 160, 93, 186, 105, 210, 185, 111, 222, 161, 95, 190, 97, 194, 153, 47, 94, 188, 101, 202, 137, 15, 30, 60, 120, 240, 253, 231, 211, 187, 107, 214, 177, 127, 254, 225, 223, 163, 91, 182, 113, 226, 217, 175, 67, 134, 17, 34, 68, 136, 13, 26, 52, 104, 208, 189, 103, 206, 129, 31, 62, 124, 248, 237, 199, 147, 59, 118, 236, 197, 151, 51, 102, 204, 133, 23, 46, 92, 184, 109, 218, 169, 79, 158, 33, 66, 132, 21, 42, 84, 168, 77, 154, 41, 82, 164, 85, 170, 73, 146, 57, 114, 228, 213, 183, 115, 230, 209, 191, 99, 198, 145, 63, 126, 252, 229, 215, 179, 123, 246, 241, 255, 227, 219, 171, 75, 150, 49, 98, 196, 149, 55, 110, 220, 165, 87, 174, 65, 130, 25, 50, 100, 200, 141, 7, 14, 28, 56, 112, 224, 221, 167, 83, 166, 81, 162, 89, 178, 121, 242, 249, 239, 195, 155, 43, 86, 172, 69, 138, 9, 18, 36, 72, 144, 61, 122, 244, 245, 247, 243, 251, 235, 203, 139, 11, 22, 44, 88, 176, 125, 250, 233, 207, 131, 27, 54, 108, 216, 173, 71, 142, 1]));
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getExp = function (index) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		A2(
			$elm$core$Array$get,
			A2($elm$core$Basics$modBy, 255, index),
			$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$expTable));
};
var $pablohirafuji$elm_qrcode$QRCode$Error$PolynomialMultiplyException = {$: 5};
var $pablohirafuji$elm_qrcode$QRCode$Error$LogTableException = function (a) {
	return {$: 4, a: a};
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$logTable = $elm$core$Array$fromList(
	_List_fromArray(
		[0, 1, 25, 2, 50, 26, 198, 3, 223, 51, 238, 27, 104, 199, 75, 4, 100, 224, 14, 52, 141, 239, 129, 28, 193, 105, 248, 200, 8, 76, 113, 5, 138, 101, 47, 225, 36, 15, 33, 53, 147, 142, 218, 240, 18, 130, 69, 29, 181, 194, 125, 106, 39, 249, 185, 201, 154, 9, 120, 77, 228, 114, 166, 6, 191, 139, 98, 102, 221, 48, 253, 226, 152, 37, 179, 16, 145, 34, 136, 54, 208, 148, 206, 143, 150, 219, 189, 241, 210, 19, 92, 131, 56, 70, 64, 30, 66, 182, 163, 195, 72, 126, 110, 107, 58, 40, 84, 250, 133, 186, 61, 202, 94, 155, 159, 10, 21, 121, 43, 78, 212, 229, 172, 115, 243, 167, 87, 7, 112, 192, 247, 140, 128, 99, 13, 103, 74, 222, 237, 49, 197, 254, 24, 227, 165, 153, 119, 38, 184, 180, 124, 17, 68, 146, 217, 35, 32, 137, 46, 55, 63, 209, 91, 149, 188, 207, 205, 144, 135, 151, 178, 220, 252, 190, 97, 242, 86, 211, 171, 20, 42, 93, 158, 132, 60, 57, 83, 71, 109, 65, 162, 31, 45, 67, 216, 183, 123, 164, 118, 196, 23, 73, 236, 127, 12, 111, 246, 108, 161, 59, 82, 41, 157, 85, 170, 251, 96, 134, 177, 187, 204, 62, 90, 203, 89, 95, 176, 156, 169, 160, 81, 11, 245, 22, 235, 122, 117, 44, 215, 79, 174, 213, 233, 230, 231, 173, 232, 116, 214, 244, 234, 168, 80, 88, 175]));
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getLog = function (index) {
	return (index < 1) ? $elm$core$Result$Err(
		$pablohirafuji$elm_qrcode$QRCode$Error$LogTableException(index)) : A2(
		$elm$core$Result$fromMaybe,
		$pablohirafuji$elm_qrcode$QRCode$Error$LogTableException(index),
		A2($elm$core$Array$get, index - 1, $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$logTable));
};
var $elm$core$Array$length = function (_v0) {
	var len = _v0.a;
	return len;
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getOffset = function (_v0) {
	getOffset:
	while (true) {
		var num = _v0.a;
		var offset = _v0.b;
		if (num.b) {
			var head = num.a;
			var tail = num.b;
			if (!head) {
				var $temp$_v0 = _Utils_Tuple2(tail, offset + 1);
				_v0 = $temp$_v0;
				continue getOffset;
			} else {
				return offset;
			}
		} else {
			return offset;
		}
	}
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial = F2(
	function (num, shift) {
		var offset = $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getOffset(
			_Utils_Tuple2(num, 0));
		var numArray = $elm$core$Array$fromList(num);
		return A2(
			$elm$core$Array$initialize,
			($elm$core$List$length(num) - offset) + shift,
			function (index) {
				return A2(
					$elm$core$Maybe$withDefault,
					0,
					A2($elm$core$Array$get, index + offset, numArray));
			});
	});
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$multiply = F2(
	function (poly1, poly2) {
		var valuesArray = A2(
			$elm$core$List$indexedMap,
			F2(
				function (index1, value1) {
					return A2(
						$elm$core$List$indexedMap,
						F2(
							function (index2, value2) {
								return _Utils_Tuple3(index1 + index2, value1, value2);
							}),
						$elm$core$Array$toList(poly2));
				}),
			$elm$core$Array$toList(poly1));
		var process__ = F3(
			function (indexSum, num_, exp) {
				return A2(
					$elm$core$Result$fromMaybe,
					$pablohirafuji$elm_qrcode$QRCode$Error$PolynomialMultiplyException,
					A2(
						$elm$core$Maybe$map,
						$elm$core$Bitwise$xor(exp),
						A2($elm$core$Array$get, indexSum, num_)));
			});
		var process_ = F2(
			function (_v0, num_) {
				var indexSum = _v0.a;
				var value1 = _v0.b;
				var value2 = _v0.c;
				return A2(
					$elm$core$Result$map,
					function (r) {
						return A3($elm$core$Array$set, indexSum, r, num_);
					},
					A2(
						$elm$core$Result$andThen,
						A2(process__, indexSum, num_),
						A2(
							$elm$core$Result$map,
							$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getExp,
							A3(
								$elm$core$Result$map2,
								$elm$core$Basics$add,
								$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getLog(value1),
								$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getLog(value2)))));
			});
		var process = F2(
			function (args, numResult) {
				return A2(
					$elm$core$Result$andThen,
					process_(args),
					numResult);
			});
		var num = A2(
			$elm$core$Array$initialize,
			($elm$core$Array$length(poly1) + $elm$core$Array$length(poly2)) - 1,
			$elm$core$Basics$always(0));
		return A2(
			$elm$core$Result$map,
			function (a) {
				return A2($pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial, a, 0);
			},
			A2(
				$elm$core$Result$map,
				$elm$core$Array$toList,
				A3(
					$elm$core$List$foldl,
					process,
					$elm$core$Result$Ok(num),
					$elm$core$List$concat(valuesArray))));
	});
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getECPolynomial = function (ecLength) {
	var generate = F2(
		function (count, polyResult) {
			generate:
			while (true) {
				if (_Utils_cmp(count, ecLength) < 0) {
					var $temp$count = count + 1,
						$temp$polyResult = A2(
						$elm$core$Result$andThen,
						function (a) {
							return A2(
								$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$multiply,
								a,
								A2(
									$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial,
									_List_fromArray(
										[
											1,
											$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getExp(count)
										]),
									0));
						},
						polyResult);
					count = $temp$count;
					polyResult = $temp$polyResult;
					continue generate;
				} else {
					return polyResult;
				}
			}
		});
	return A2(
		generate,
		0,
		$elm$core$Result$Ok(
			A2(
				$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial,
				_List_fromArray(
					[1]),
				0)));
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get___ = F2(
	function (ecLength, modPoly) {
		return $elm$core$Array$toList(
			A2(
				$elm$core$Array$initialize,
				ecLength,
				function (index) {
					var modIndex = (index + $elm$core$Array$length(modPoly)) - ecLength;
					return (modIndex >= 0) ? A2(
						$elm$core$Maybe$withDefault,
						0,
						A2($elm$core$Array$get, modIndex, modPoly)) : 0;
				}));
	});
var $pablohirafuji$elm_qrcode$QRCode$Error$PolynomialModException = {$: 6};
var $elm$core$Array$foldl = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldl, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldl, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldl,
			func,
			A3($elm$core$Elm$JsArray$foldl, helper, baseCase, tree),
			tail);
	});
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$mod = F2(
	function (poly1, poly2) {
		if (($elm$core$Array$length(poly1) - $elm$core$Array$length(poly2)) < 0) {
			return $elm$core$Result$Ok(poly1);
		} else {
			var helper_ = F3(
				function (index2, poly1_, exp) {
					return A2(
						$elm$core$Result$fromMaybe,
						$pablohirafuji$elm_qrcode$QRCode$Error$PolynomialModException,
						A2(
							$elm$core$Maybe$map,
							$elm$core$Bitwise$xor(exp),
							A2($elm$core$Array$get, index2, poly1_)));
				});
			var getHead = function (poly) {
				return A2(
					$elm$core$Result$andThen,
					$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getLog,
					A2(
						$elm$core$Result$fromMaybe,
						$pablohirafuji$elm_qrcode$QRCode$Error$PolynomialModException,
						A2($elm$core$Array$get, 0, poly)));
			};
			var ratio = A3(
				$elm$core$Result$map2,
				$elm$core$Basics$sub,
				getHead(poly1),
				getHead(poly2));
			var helper = F2(
				function (_v0, poly1_) {
					var index2 = _v0.a;
					var value2 = _v0.b;
					return A2(
						$elm$core$Result$map,
						function (r) {
							return A3($elm$core$Array$set, index2, r, poly1_);
						},
						A2(
							$elm$core$Result$andThen,
							A2(helper_, index2, poly1_),
							A2(
								$elm$core$Result$map,
								$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getExp,
								A3(
									$elm$core$Result$map2,
									$elm$core$Basics$add,
									ratio,
									$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getLog(value2)))));
				});
			var numFold = F2(
				function (args, poly1Result) {
					return A2(
						$elm$core$Result$andThen,
						helper(args),
						poly1Result);
				});
			var numResult = A3(
				$elm$core$Array$foldl,
				numFold,
				$elm$core$Result$Ok(poly1),
				A2(
					$elm$core$Array$indexedMap,
					F2(
						function (a, b) {
							return _Utils_Tuple2(a, b);
						}),
					poly2));
			return A2(
				$elm$core$Result$andThen,
				function (a) {
					return A2($pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$mod, a, poly2);
				},
				A2(
					$elm$core$Result$map,
					function (a) {
						return A2($pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial, a, 0);
					},
					A2($elm$core$Result$map, $elm$core$Array$toList, numResult)));
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get__ = F2(
	function (rsPoly, dataCodewords) {
		return A2(
			$elm$core$Result$map,
			$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get___(
				$elm$core$Array$length(rsPoly) - 1),
			A2(
				$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$mod,
				A2(
					$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial,
					dataCodewords,
					$elm$core$Array$length(rsPoly) - 1),
				rsPoly));
	});
var $pablohirafuji$elm_qrcode$QRCode$Helpers$listResult = F3(
	function (fun, listb, lista) {
		if (lista.b) {
			var head = lista.a;
			var tail = lista.b;
			return A2(
				$elm$core$Result$andThen,
				function (a) {
					return A3($pablohirafuji$elm_qrcode$QRCode$Helpers$listResult, fun, a, tail);
				},
				A2(
					$elm$core$Result$map,
					function (r) {
						return A2($elm$core$List$cons, r, listb);
					},
					fun(head)));
		} else {
			return $elm$core$Result$Ok(
				$elm$core$List$reverse(listb));
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get_ = F2(
	function (byteBlocks, rsPoly) {
		return A3(
			$pablohirafuji$elm_qrcode$QRCode$Helpers$listResult,
			$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get__(rsPoly),
			_List_Nil,
			byteBlocks);
	});
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get = F2(
	function (ecPerBlock, byteBlocks) {
		return A2(
			$elm$core$Result$andThen,
			$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get_(byteBlocks),
			$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getECPolynomial(ecPerBlock));
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$getErrorCorrection = function (_v0) {
	var model = _v0.a;
	var dataBlocks = _v0.b;
	return A2(
		$elm$core$Result$map,
		function (c) {
			return _Utils_Tuple3(model, dataBlocks, c);
		},
		A2($pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get, model.ahB.agF, dataBlocks));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric = 1;
var $pablohirafuji$elm_qrcode$QRCode$Encode$Byte = 2;
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric = 0;
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$onlyAlphanumeric = A2(
	$elm$regex$Regex$fromStringWith,
	{afu: false, aiR: false},
	'^[0-9A-Z $%*+\\-.\\/:]+$');
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$isValid = function (input) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (r) {
				return A2($elm$regex$Regex$contains, r, input);
			},
			$pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$onlyAlphanumeric));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Byte$only8Bit = A2(
	$elm$regex$Regex$fromStringWith,
	{afu: false, aiR: false},
	'^[\\u0000-\\u00ff]+$');
var $pablohirafuji$elm_qrcode$QRCode$Encode$Byte$isValid = function (input) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (r) {
				return A2($elm$regex$Regex$contains, r, input);
			},
			$pablohirafuji$elm_qrcode$QRCode$Encode$Byte$only8Bit));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$onlyNumber = A2(
	$elm$regex$Regex$fromStringWith,
	{afu: false, aiR: false},
	'^[0-9]+$');
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$isValid = function (input) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (r) {
				return A2($elm$regex$Regex$contains, r, input);
			},
			$pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$onlyNumber));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$selectMode = function (input) {
	return $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$isValid(input) ? 0 : ($pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$isValid(input) ? 1 : ($pablohirafuji$elm_qrcode$QRCode$Encode$Byte$isValid(input) ? 2 : 3));
};
var $pablohirafuji$elm_qrcode$QRCode$Error$InputLengthOverflow = {$: 7};
var $pablohirafuji$elm_qrcode$QRCode$Encode$filterCapacity = F3(
	function (mode, dataLength, _v0) {
		var version = _v0.Kn;
		var capacity = _v0.xS;
		return _Utils_cmp(
			A2($pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicatorLength, mode, version) + dataLength,
			capacity) < 1;
	});
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$blockByteCapacity = function (_v0) {
	var blockCount = _v0.a;
	var bytePerBlock = _v0.b;
	return blockCount * bytePerBlock;
};
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$byteCapacity = F2(
	function (group1, maybeGroup2) {
		if (!maybeGroup2.$) {
			var block2 = maybeGroup2.a;
			return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$blockByteCapacity(group1) + $pablohirafuji$elm_qrcode$QRCode$GroupInfo$blockByteCapacity(block2);
		} else {
			return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$blockByteCapacity(group1);
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo = F4(
	function (version, ecPerBlock, group1, maybeGroup2) {
		return {
			xS: A2($pablohirafuji$elm_qrcode$QRCode$GroupInfo$byteCapacity, group1, maybeGroup2) * 8,
			agF: ecPerBlock,
			SY: group1,
			aiA: maybeGroup2,
			Kn: version
		};
	});
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataH = _List_fromArray(
	[
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		1,
		17,
		_Utils_Tuple2(1, 9),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		2,
		28,
		_Utils_Tuple2(1, 16),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		3,
		22,
		_Utils_Tuple2(2, 13),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		4,
		16,
		_Utils_Tuple2(4, 9),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		5,
		22,
		_Utils_Tuple2(2, 11),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 12))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		6,
		28,
		_Utils_Tuple2(4, 15),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		7,
		26,
		_Utils_Tuple2(4, 13),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 14))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		8,
		26,
		_Utils_Tuple2(4, 14),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 15))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		9,
		24,
		_Utils_Tuple2(4, 12),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 13))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		10,
		28,
		_Utils_Tuple2(6, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		11,
		24,
		_Utils_Tuple2(3, 12),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(8, 13))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		12,
		28,
		_Utils_Tuple2(7, 14),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 15))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		13,
		22,
		_Utils_Tuple2(12, 11),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 12))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		14,
		24,
		_Utils_Tuple2(11, 12),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 13))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		15,
		24,
		_Utils_Tuple2(11, 12),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 13))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		16,
		30,
		_Utils_Tuple2(3, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(13, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		17,
		28,
		_Utils_Tuple2(2, 14),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(17, 15))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		18,
		28,
		_Utils_Tuple2(2, 14),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(19, 15))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		19,
		26,
		_Utils_Tuple2(9, 13),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(16, 14))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		20,
		28,
		_Utils_Tuple2(15, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		21,
		30,
		_Utils_Tuple2(19, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 17))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		22,
		24,
		_Utils_Tuple2(34, 13),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		23,
		30,
		_Utils_Tuple2(16, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		24,
		30,
		_Utils_Tuple2(30, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 17))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		25,
		30,
		_Utils_Tuple2(22, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(13, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		26,
		30,
		_Utils_Tuple2(33, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 17))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		27,
		30,
		_Utils_Tuple2(12, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(28, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		28,
		30,
		_Utils_Tuple2(11, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(31, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		29,
		30,
		_Utils_Tuple2(19, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(26, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		30,
		30,
		_Utils_Tuple2(23, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(25, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		31,
		30,
		_Utils_Tuple2(23, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(28, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		32,
		30,
		_Utils_Tuple2(19, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(35, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		33,
		30,
		_Utils_Tuple2(11, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(46, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		34,
		30,
		_Utils_Tuple2(59, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 17))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		35,
		30,
		_Utils_Tuple2(22, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(41, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		36,
		30,
		_Utils_Tuple2(2, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(64, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		37,
		30,
		_Utils_Tuple2(24, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(46, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		38,
		30,
		_Utils_Tuple2(42, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(32, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		39,
		30,
		_Utils_Tuple2(10, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(67, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		40,
		30,
		_Utils_Tuple2(20, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(61, 16)))
	]);
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataL = _List_fromArray(
	[
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		1,
		7,
		_Utils_Tuple2(1, 19),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		2,
		10,
		_Utils_Tuple2(1, 34),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		3,
		15,
		_Utils_Tuple2(1, 55),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		4,
		20,
		_Utils_Tuple2(1, 80),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		5,
		26,
		_Utils_Tuple2(1, 108),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		6,
		18,
		_Utils_Tuple2(2, 68),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		7,
		20,
		_Utils_Tuple2(2, 78),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		8,
		24,
		_Utils_Tuple2(2, 97),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		9,
		30,
		_Utils_Tuple2(2, 116),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		10,
		18,
		_Utils_Tuple2(2, 68),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 69))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		11,
		20,
		_Utils_Tuple2(4, 81),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		12,
		24,
		_Utils_Tuple2(2, 92),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 93))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		13,
		26,
		_Utils_Tuple2(4, 107),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		14,
		30,
		_Utils_Tuple2(3, 115),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 116))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		15,
		22,
		_Utils_Tuple2(5, 87),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 88))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		16,
		24,
		_Utils_Tuple2(5, 98),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 99))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		17,
		28,
		_Utils_Tuple2(1, 107),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 108))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		18,
		30,
		_Utils_Tuple2(5, 120),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 121))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		19,
		28,
		_Utils_Tuple2(3, 113),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 114))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		20,
		28,
		_Utils_Tuple2(3, 107),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 108))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		21,
		28,
		_Utils_Tuple2(4, 116),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 117))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		22,
		28,
		_Utils_Tuple2(2, 111),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 112))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		23,
		30,
		_Utils_Tuple2(4, 121),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 122))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		24,
		30,
		_Utils_Tuple2(6, 117),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 118))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		25,
		26,
		_Utils_Tuple2(8, 106),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 107))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		26,
		28,
		_Utils_Tuple2(10, 114),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 115))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		27,
		30,
		_Utils_Tuple2(8, 122),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 123))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		28,
		30,
		_Utils_Tuple2(3, 117),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 118))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		29,
		30,
		_Utils_Tuple2(7, 116),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 117))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		30,
		30,
		_Utils_Tuple2(5, 115),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 116))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		31,
		30,
		_Utils_Tuple2(13, 115),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(3, 116))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		32,
		30,
		_Utils_Tuple2(17, 115),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		33,
		30,
		_Utils_Tuple2(17, 115),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 116))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		34,
		30,
		_Utils_Tuple2(13, 115),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 116))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		35,
		30,
		_Utils_Tuple2(12, 121),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 122))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		36,
		30,
		_Utils_Tuple2(6, 121),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 122))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		37,
		30,
		_Utils_Tuple2(17, 122),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 123))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		38,
		30,
		_Utils_Tuple2(4, 122),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(18, 123))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		39,
		30,
		_Utils_Tuple2(20, 117),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 118))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		40,
		30,
		_Utils_Tuple2(19, 118),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 119)))
	]);
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataM = _List_fromArray(
	[
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		1,
		10,
		_Utils_Tuple2(1, 16),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		2,
		16,
		_Utils_Tuple2(1, 28),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		3,
		26,
		_Utils_Tuple2(1, 44),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		4,
		18,
		_Utils_Tuple2(2, 32),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		5,
		24,
		_Utils_Tuple2(2, 43),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		6,
		16,
		_Utils_Tuple2(4, 27),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		7,
		18,
		_Utils_Tuple2(4, 31),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		8,
		22,
		_Utils_Tuple2(2, 38),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 39))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		9,
		22,
		_Utils_Tuple2(3, 36),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 37))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		10,
		26,
		_Utils_Tuple2(4, 43),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 44))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		11,
		30,
		_Utils_Tuple2(1, 50),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 51))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		12,
		22,
		_Utils_Tuple2(6, 36),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 37))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		13,
		22,
		_Utils_Tuple2(8, 37),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 38))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		14,
		24,
		_Utils_Tuple2(4, 40),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 41))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		15,
		24,
		_Utils_Tuple2(5, 41),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 42))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		16,
		28,
		_Utils_Tuple2(7, 45),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(3, 46))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		17,
		28,
		_Utils_Tuple2(10, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		18,
		26,
		_Utils_Tuple2(9, 43),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 44))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		19,
		26,
		_Utils_Tuple2(3, 44),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(11, 45))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		20,
		26,
		_Utils_Tuple2(3, 41),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(13, 42))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		21,
		26,
		_Utils_Tuple2(17, 42),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		22,
		28,
		_Utils_Tuple2(17, 46),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		23,
		28,
		_Utils_Tuple2(4, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 48))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		24,
		28,
		_Utils_Tuple2(6, 45),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 46))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		25,
		28,
		_Utils_Tuple2(8, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(13, 48))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		26,
		28,
		_Utils_Tuple2(19, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		27,
		28,
		_Utils_Tuple2(22, 45),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(3, 46))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		28,
		28,
		_Utils_Tuple2(3, 45),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(23, 46))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		29,
		28,
		_Utils_Tuple2(21, 45),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 46))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		30,
		28,
		_Utils_Tuple2(19, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 48))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		31,
		28,
		_Utils_Tuple2(2, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(29, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		32,
		28,
		_Utils_Tuple2(10, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(23, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		33,
		28,
		_Utils_Tuple2(14, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(21, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		34,
		28,
		_Utils_Tuple2(14, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(23, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		35,
		28,
		_Utils_Tuple2(12, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(26, 48))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		36,
		28,
		_Utils_Tuple2(6, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(34, 48))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		37,
		28,
		_Utils_Tuple2(29, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		38,
		28,
		_Utils_Tuple2(13, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(32, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		39,
		28,
		_Utils_Tuple2(40, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 48))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		40,
		28,
		_Utils_Tuple2(18, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(31, 48)))
	]);
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataQ = _List_fromArray(
	[
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		1,
		13,
		_Utils_Tuple2(1, 13),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		2,
		22,
		_Utils_Tuple2(1, 22),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		3,
		18,
		_Utils_Tuple2(2, 17),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		4,
		26,
		_Utils_Tuple2(2, 24),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		5,
		18,
		_Utils_Tuple2(2, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		6,
		24,
		_Utils_Tuple2(4, 19),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		7,
		18,
		_Utils_Tuple2(2, 14),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 15))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		8,
		22,
		_Utils_Tuple2(4, 18),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 19))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		9,
		20,
		_Utils_Tuple2(4, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 17))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		10,
		24,
		_Utils_Tuple2(6, 19),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 20))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		11,
		28,
		_Utils_Tuple2(4, 22),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 23))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		12,
		26,
		_Utils_Tuple2(4, 20),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 21))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		13,
		24,
		_Utils_Tuple2(8, 20),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 21))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		14,
		20,
		_Utils_Tuple2(11, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 17))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		15,
		30,
		_Utils_Tuple2(5, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		16,
		24,
		_Utils_Tuple2(15, 19),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 20))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		17,
		28,
		_Utils_Tuple2(1, 22),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(15, 23))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		18,
		28,
		_Utils_Tuple2(17, 22),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 23))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		19,
		26,
		_Utils_Tuple2(17, 21),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 22))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		20,
		30,
		_Utils_Tuple2(15, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		21,
		28,
		_Utils_Tuple2(17, 22),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 23))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		22,
		30,
		_Utils_Tuple2(7, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(16, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		23,
		30,
		_Utils_Tuple2(11, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		24,
		30,
		_Utils_Tuple2(11, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(16, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		25,
		30,
		_Utils_Tuple2(7, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(22, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		26,
		28,
		_Utils_Tuple2(28, 22),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 23))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		27,
		30,
		_Utils_Tuple2(8, 23),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(26, 24))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		28,
		30,
		_Utils_Tuple2(4, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(31, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		29,
		30,
		_Utils_Tuple2(1, 23),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(37, 24))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		30,
		30,
		_Utils_Tuple2(15, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(25, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		31,
		30,
		_Utils_Tuple2(42, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		32,
		30,
		_Utils_Tuple2(10, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(35, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		33,
		30,
		_Utils_Tuple2(29, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(19, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		34,
		30,
		_Utils_Tuple2(44, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		35,
		30,
		_Utils_Tuple2(39, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		36,
		30,
		_Utils_Tuple2(46, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		37,
		30,
		_Utils_Tuple2(49, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		38,
		30,
		_Utils_Tuple2(48, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		39,
		30,
		_Utils_Tuple2(43, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(22, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		40,
		30,
		_Utils_Tuple2(34, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(34, 25)))
	]);
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$getGroupData = function (ecLevel) {
	switch (ecLevel) {
		case 0:
			return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataL;
		case 1:
			return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataM;
		case 2:
			return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataQ;
		default:
			return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataH;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$getVersion = F3(
	function (ecLevel, mode, dataLength) {
		return A2(
			$elm$core$Result$fromMaybe,
			$pablohirafuji$elm_qrcode$QRCode$Error$InputLengthOverflow,
			$elm$core$List$head(
				A2(
					$elm$core$List$sortBy,
					function ($) {
						return $.xS;
					},
					A2(
						$elm$core$List$filter,
						A2($pablohirafuji$elm_qrcode$QRCode$Encode$filterCapacity, mode, dataLength),
						$pablohirafuji$elm_qrcode$QRCode$GroupInfo$getGroupData(ecLevel)))));
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$versionToModel = F5(
	function (inputStr, ecLevel, mode, partialBitsCount, groupInfo) {
		return {
			GG: partialBitsCount + A2($pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicatorLength, mode, groupInfo.Kn),
			Q$: ecLevel,
			ahB: groupInfo,
			H5: inputStr,
			aiN: mode
		};
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$selectVersion = F4(
	function (inputStr, ecLevel, mode, encodedStr) {
		var partialBitsCount = 4 + A3(
			$elm$core$List$foldl,
			F2(
				function (a, b) {
					return a.b + b;
				}),
			0,
			encodedStr);
		return A2(
			$elm$core$Result$map,
			function (b) {
				return _Utils_Tuple2(encodedStr, b);
			},
			A2(
				$elm$core$Result$map,
				A4($pablohirafuji$elm_qrcode$QRCode$Encode$versionToModel, inputStr, ecLevel, mode, partialBitsCount),
				A3($pablohirafuji$elm_qrcode$QRCode$Encode$getVersion, ecLevel, mode, partialBitsCount)));
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$breakList = F3(
	function (checkFinish, _v0, _v1) {
		breakList:
		while (true) {
			var times = _v0.a;
			var itemCount = _v0.b;
			var byteList = _v1.a;
			var progress = _v1.b;
			if (times > 0) {
				var remainList = A2($elm$core$List$drop, itemCount, byteList);
				var block = A2($elm$core$List$take, itemCount, byteList);
				var $temp$checkFinish = checkFinish,
					$temp$_v0 = _Utils_Tuple2(times - 1, itemCount),
					$temp$_v1 = _Utils_Tuple2(
					remainList,
					A2($elm$core$List$cons, block, progress));
				checkFinish = $temp$checkFinish;
				_v0 = $temp$_v0;
				_v1 = $temp$_v1;
				continue breakList;
			} else {
				if (checkFinish && ($elm$core$List$length(byteList) > 0)) {
					return $elm$core$Result$Err($pablohirafuji$elm_qrcode$QRCode$Error$InputLengthOverflow);
				} else {
					return $elm$core$Result$Ok(
						_Utils_Tuple2(byteList, progress));
				}
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$toBlocks = function (_v0) {
	var model = _v0.a;
	var groupInfo = model.ahB;
	var byteList = _v0.b;
	var _v1 = groupInfo.aiA;
	if (!_v1.$) {
		var group2 = _v1.a;
		return A2(
			$elm$core$Result$map,
			function (b) {
				return _Utils_Tuple2(model, b);
			},
			A2(
				$elm$core$Result$map,
				A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $elm$core$List$reverse),
				A2(
					$elm$core$Result$andThen,
					A2($pablohirafuji$elm_qrcode$QRCode$Encode$breakList, true, group2),
					A3(
						$pablohirafuji$elm_qrcode$QRCode$Encode$breakList,
						false,
						groupInfo.SY,
						_Utils_Tuple2(byteList, _List_Nil)))));
	} else {
		return A2(
			$elm$core$Result$map,
			function (b) {
				return _Utils_Tuple2(model, b);
			},
			A2(
				$elm$core$Result$map,
				A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $elm$core$List$reverse),
				A3(
					$pablohirafuji$elm_qrcode$QRCode$Encode$breakList,
					true,
					groupInfo.SY,
					_Utils_Tuple2(byteList, _List_Nil))));
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$encode = F2(
	function (inputStr, ecLevel) {
		var mode = $pablohirafuji$elm_qrcode$QRCode$Encode$selectMode(inputStr);
		return A2(
			$elm$core$Result$map,
			$pablohirafuji$elm_qrcode$QRCode$Encode$concatTranspose,
			A2(
				$elm$core$Result$andThen,
				$pablohirafuji$elm_qrcode$QRCode$Encode$getErrorCorrection,
				A2(
					$elm$core$Result$andThen,
					$pablohirafuji$elm_qrcode$QRCode$Encode$toBlocks,
					A2(
						$elm$core$Result$map,
						$pablohirafuji$elm_qrcode$QRCode$Encode$addInfoAndFinalBits,
						A2(
							$elm$core$Result$andThen,
							A3($pablohirafuji$elm_qrcode$QRCode$Encode$selectVersion, inputStr, ecLevel, mode),
							A2($pablohirafuji$elm_qrcode$QRCode$Encode$encoder, mode, inputStr))))));
	});
var $pablohirafuji$elm_qrcode$QRCode$fromStringWith = F2(
	function (ecLevel, input) {
		return A2(
			$elm$core$Result$mapError,
			$pablohirafuji$elm_qrcode$QRCode$convertError,
			A2(
				$elm$core$Result$andThen,
				function (_v0) {
					var encodeModel = _v0.a;
					var encodedData = _v0.b;
					return A2(
						$elm$core$Result$map,
						function (matrix) {
							return {s7: matrix, Kn: encodeModel.ahB.Kn};
						},
						$pablohirafuji$elm_qrcode$QRCode$Matrix$apply(
							_Utils_Tuple2(encodeModel, encodedData)));
				},
				A2(
					$pablohirafuji$elm_qrcode$QRCode$Encode$encode,
					input,
					$pablohirafuji$elm_qrcode$QRCode$convertEC(ecLevel))));
	});
var $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize = 5;
var $pablohirafuji$elm_qrcode$QRCode$Render$Svg$appendLastRect = function (_v0) {
	var lastRect = _v0.a;
	var rowLines = _v0.b;
	return A2(
		$elm$core$List$cons,
		'h' + $elm$core$String$fromInt(lastRect.ams * $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize),
		rowLines);
};
var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
var $elm$svg$Svg$Attributes$shapeRendering = _VirtualDom_attribute('shape-rendering');
var $elm$svg$Svg$Attributes$stroke = _VirtualDom_attribute('stroke');
var $elm$svg$Svg$Attributes$strokeWidth = _VirtualDom_attribute('stroke-width');
var $elm$svg$Svg$Attributes$style = _VirtualDom_attribute('style');
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $pablohirafuji$elm_qrcode$QRCode$Render$Svg$toRowLines = F2(
	function (isDark, _v0) {
		var lastRect = _v0.a;
		var rowLines = _v0.b;
		return isDark ? ((!lastRect.lw) ? _Utils_Tuple2(
			_Utils_update(
				lastRect,
				{ams: lastRect.ams + 1}),
			rowLines) : _Utils_Tuple2(
			{lw: 0, ams: 1},
			A2(
				$elm$core$List$cons,
				$elm$core$String$concat(
					_List_fromArray(
						[
							(lastRect.ams > 0) ? ('h' + $elm$core$String$fromInt(lastRect.ams * $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize)) : '',
							'm',
							$elm$core$String$fromInt(lastRect.lw * $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize),
							' 0'
						])),
				rowLines))) : _Utils_Tuple2(
			_Utils_update(
				lastRect,
				{lw: lastRect.lw + 1}),
			rowLines);
	});
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $pablohirafuji$elm_qrcode$QRCode$Render$Svg$viewRow = F3(
	function (quietZoneSize, rowIndex, rowLines) {
		return A2(
			$elm$core$List$cons,
			'M0 ',
			A2(
				$elm$core$List$cons,
				$elm$core$String$fromInt(rowIndex * $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize),
				rowLines));
	});
var $pablohirafuji$elm_qrcode$QRCode$Render$Svg$viewBase = F3(
	function (quietZoneSize, extraAttrs, matrix) {
		var quietZonePx = quietZoneSize * $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize;
		var sizePx = $elm$core$String$fromInt(
			($elm$core$List$length(matrix) * $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize) + (2 * quietZonePx));
		return A2(
			$elm$svg$Svg$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$viewBox('0 0 ' + (sizePx + (' ' + sizePx))),
						$elm$svg$Svg$Attributes$shapeRendering('crispEdges'),
						$elm$svg$Svg$Attributes$stroke('#000'),
						$elm$svg$Svg$Attributes$strokeWidth(
						$elm$core$String$fromInt($pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize) + 'px')
					]),
				extraAttrs),
			function (d) {
				return _List_fromArray(
					[
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								d,
								$elm$svg$Svg$Attributes$transform(
								'translate(' + ($elm$core$String$fromInt(quietZonePx) + (', ' + ($elm$core$String$fromFloat(quietZonePx + ($pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize / 2)) + ')')))),
								$elm$svg$Svg$Attributes$style('stroke-width: 5px')
							]),
						_List_Nil)
					]);
			}(
				$elm$svg$Svg$Attributes$d(
					$elm$core$String$concat(
						$elm$core$List$concat(
							A2(
								$elm$core$List$indexedMap,
								$pablohirafuji$elm_qrcode$QRCode$Render$Svg$viewRow(quietZoneSize),
								A2(
									$elm$core$List$map,
									A2(
										$elm$core$Basics$composeR,
										A2(
											$elm$core$List$foldl,
											$pablohirafuji$elm_qrcode$QRCode$Render$Svg$toRowLines,
											_Utils_Tuple2(
												{lw: 0, ams: 0},
												_List_Nil)),
										A2($elm$core$Basics$composeR, $pablohirafuji$elm_qrcode$QRCode$Render$Svg$appendLastRect, $elm$core$List$reverse)),
									matrix)))))));
	});
var $pablohirafuji$elm_qrcode$QRCode$Render$Svg$view = $pablohirafuji$elm_qrcode$QRCode$Render$Svg$viewBase(4);
var $pablohirafuji$elm_qrcode$QRCode$toSvg = F2(
	function (extraAttrs, _v0) {
		var matrix = _v0.s7;
		return A2($pablohirafuji$elm_qrcode$QRCode$Render$Svg$view, extraAttrs, matrix);
	});
var $author$project$Pages$User$Mfa$viewQrSteps = function (mfa) {
	var qrCodeImage = function () {
		var _v0 = $author$project$Api$Platform$Mfa$One$qrcode(mfa);
		if (!_v0.$) {
			var qrcode_ = _v0.a;
			return A3(
				$author$project$Ui$Image$fromSrc,
				{LD: 'QR Code'},
				qrcode_,
				_List_Nil);
		} else {
			return A2(
				$elm$core$Result$withDefault,
				A2(
					$author$project$Ui$Alert$danger,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('There was a problem generating the QR code, please contact us.')
						])),
				A2(
					$elm$core$Result$map,
					$pablohirafuji$elm_qrcode$QRCode$toSvg(
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$width('200px'),
								$elm$svg$Svg$Attributes$height('200px')
							])),
					A2(
						$pablohirafuji$elm_qrcode$QRCode$fromStringWith,
						2,
						$author$project$Api$Platform$Mfa$One$qrcodeUrl(mfa))));
		}
	}();
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Select the '),
					A2(
					$author$project$Ui$Typography$strong,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Scan Barcode')
						])),
					$elm$html$Html$text(' option'),
					$elm$html$Html$text(' (or '),
					A3(
					$author$project$Ui$Button$view,
					{mm: 'Click here'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$onClick($author$project$Pages$User$Mfa$SwitchToManual)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Click here')
						])),
					$elm$html$Html$text(' if you are having issues scanning the code)')
				])),
			A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Scan the following barcode')
						])),
					qrCodeImage
				]))
		]);
};
var $author$project$Pages$User$Mfa$viewInactiveMfa = F2(
	function (_v0, mfa) {
		var method = _v0.IA;
		var otpCode = _v0.tw;
		var activatingMfa = _v0.l7;
		var requiresMfaPrerequisite = _v0.Jv;
		var requiresMfa = _v0.$H;
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$p,
				_List_Nil,
				_List_fromArray(
					[
						((!requiresMfa) && requiresMfaPrerequisite) ? $elm$html$Html$text('In order to require multi-factor authentication for all users accessing your account, please complete the setup of multi-factor authentication for your account by following the directions below. ') : $author$project$Utils$Html$empty,
						requiresMfa ? $elm$html$Html$text('To protect patient information, one of your practices requires that all users enable multi-factor authentication to access their account. ') : $author$project$Utils$Html$empty,
						$elm$html$Html$text('To Enable Multi-factor authentication (MFA), you\'ll need the '),
						A2(
						$author$project$Ui$Typography$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Google Authenticator')
							])),
						$elm$html$Html$text(' app, which you can download from the '),
						A3(
						$author$project$Ui$Link$externalHref,
						'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en_US',
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Google Play Store')
							])),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(' or the ')
							])),
						A3(
						$author$project$Ui$Link$externalHref,
						'https://itunes.apple.com/us/app/google-authenticator/id388497605?mt=8',
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Apple App Store.')
							]))
					])),
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$offset(4)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$ul,
								_List_Nil,
								$elm$core$List$concat(
									_List_fromArray(
										[
											_List_fromArray(
											[
												A2(
												$elm$html$Html$li,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Open Google Authenticator on your phone.')
													])),
												A2(
												$elm$html$Html$li,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Tap the + button in Google Authenticator')
													]))
											]),
											function () {
											if (!method) {
												return $author$project$Pages$User$Mfa$viewQrSteps(mfa);
											} else {
												return $author$project$Pages$User$Mfa$viewManualSteps(mfa);
											}
										}(),
											A2($author$project$Pages$User$Mfa$viewActivate, otpCode, activatingMfa)
										])))
							]))
					]))
			]);
	});
var $author$project$Pages$User$Mfa$viewInactiveMfaSkeleton = _List_fromArray(
	[
		A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$text(
				_List_fromArray(
					[
						$author$project$Ui$Skeleton$block,
						$author$project$Ui$Skeleton$span(10)
					])),
				A2(
				$author$project$Ui$Grid$row,
				_List_fromArray(
					[$author$project$Ui$Grid$mt2]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$offset(4)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$ul,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('list-none')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Ui$Skeleton$text(
												_List_fromArray(
													[
														$author$project$Ui$Skeleton$spanFromText('Open Google Authenticator on your phone.')
													]))
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Ui$Skeleton$text(
												_List_fromArray(
													[
														$author$project$Ui$Skeleton$spanFromText('Tap the + button in Google Authenticator')
													]))
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Ui$Skeleton$text(
												_List_fromArray(
													[
														$author$project$Ui$Skeleton$span(3)
													]))
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Ui$Skeleton$card(
												_List_fromArray(
													[
														$author$project$Ui$Skeleton$span(4)
													]))
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Ui$Skeleton$text(
												_List_fromArray(
													[
														$author$project$Ui$Skeleton$block,
														$author$project$Ui$Skeleton$span(5)
													])),
												$author$project$Ui$Skeleton$input(
												_List_fromArray(
													[
														$author$project$Ui$Skeleton$span(5)
													]))
											]))
									]))
							]))
					]))
			]))
	]);
var $author$project$Pages$User$Mfa$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Multi-factor authentication (MFA)')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$spanSm(12)
											]),
										function () {
											var _v0 = model.gV;
											if (_v0.$ === 3) {
												var mfa = _v0.a;
												var _v1 = $author$project$Api$Platform$Mfa$One$status(mfa);
												if (!_v1) {
													return _List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('text-center')
																]),
															_List_fromArray(
																[
																	$author$project$Ui$Typography$heading(
																	_List_fromArray(
																		[
																			$elm$html$Html$text('You\'re all set!')
																		])),
																	A2(
																	$author$project$Ui$Alert$info,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text('You will be logged out and will need to login again.')
																		]))
																]))
														]);
												} else {
													return A2($author$project$Pages$User$Mfa$viewInactiveMfa, model, mfa);
												}
											} else {
												return $author$project$Pages$User$Mfa$viewInactiveMfaSkeleton;
											}
										}())
									]))
							])),
						function () {
						var _v2 = model.gV;
						if (_v2.$ === 3) {
							var mfa = _v2.a;
							var _v3 = $author$project$Api$Platform$Mfa$One$status(mfa);
							if (_v3 === 1) {
								return A2(
									$author$project$Ui$Panel$footer,
									_List_Nil,
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$User__Security,
											_List_fromArray(
												[$author$project$Ui$Link$buttonDefault]),
											_List_fromArray(
												[
													$elm$html$Html$text('Back')
												]))
										]));
							} else {
								return $author$project$Ui$Panel$none;
							}
						} else {
							return $author$project$Ui$Panel$none;
						}
					}()
					]))
			]),
		ac9: 'Login'
	};
};
var $author$project$Pages$User$Mfa$page = $author$project$Spa$Page$applicationUser(
	{ah_: $author$project$Pages$User$Mfa$init, aiq: $author$project$Pages$User$Mfa$load, k8: $author$project$Pages$User$Mfa$save, alO: $author$project$Pages$User$Mfa$subscriptions, adT: $author$project$Pages$User$Mfa$update, amo: $author$project$Pages$User$Mfa$view});
var $author$project$Pages$User$Organizations$Top$AdminActionsDropdownMsg = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$User$Organizations$Top$GoAsRoleDropdownMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$User$Organizations$Top$NavMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$User$Organizations$Top$PracticesDropdownMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Api$Platform$User$One$companiesCount = function (_v0) {
	var record = _v0.b;
	return record.Oa;
};
var $author$project$Pages$User$Organizations$Top$GotCompanyRoles = function (a) {
	return {$: 14, a: a};
};
var $author$project$Api$Employer$Role$rolesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['roles']),
	$author$project$Api$Data$employerPath);
var $author$project$Api$Employer$Role$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Common$Role$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Employer$Role$rolesPath));
	});
var $author$project$Pages$User$Organizations$Top$fetchCompanyRoles = function (apiClient) {
	return A2($author$project$Api$Employer$Role$list, apiClient, $author$project$Pages$User$Organizations$Top$GotCompanyRoles);
};
var $author$project$Pages$User$Organizations$Top$GotCompanies = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$User$Organizations$Top$GotPartners = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$User$Organizations$Top$GotPractices = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$User$Organizations$Top$filterToValue = function (filter) {
	return 'with_flagged_notes';
};
var $author$project$Api$Platform$User$Company$companiesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['companies']),
	$author$project$Api$Platform$User$userPath);
var $author$project$Api$Platform$Company$All$Company = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Platform$Company$Min$Company = $elm$core$Basics$identity;
var $author$project$Api$Platform$Company$Min$Record = F3(
	function (id, name, requiresMfa) {
		return {ahP: id, Bq: name, $H: requiresMfa};
	});
var $author$project$Api$Platform$Company$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'requires_mfa',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Platform$Company$Min$Record))));
var $author$project$Api$Platform$Company$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$Company$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Platform$Company$All$Record = F2(
	function (practice, organizationId) {
		return {ajD: organizationId, ZV: practice};
	});
var $author$project$Api$Platform$Company$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'organization_id',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'practice',
		$author$project$Api$Platform$Practice$Min$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Platform$Company$All$Record)));
var $author$project$Api$Platform$Company$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$Company$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Platform$Company$Min$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Platform$Company$All$Company)));
var $author$project$Api$Platform$User$Company$listDefaults = {
	ajJ: $author$project$Api$Pagination$init,
	akl: $elm$core$Maybe$Nothing,
	alA: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init)
};
var $author$project$Api$Platform$User$Company$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Platform$User$Company$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.akl;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$Platform$User$Company$list = F4(
	function (apiClient, optionals, maybeTracker, toMsg) {
		var request = function (req) {
			if (!maybeTracker.$) {
				var tracker = maybeTracker.a;
				return A2($author$project$Api$Data$requestWithTracker, tracker, req);
			} else {
				return req;
			}
		}(
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Platform$User$Company$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Platform$User$Company$companiesPath)));
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Platform$Company$All$decoder),
			toMsg,
			request);
	});
var $author$project$Api$Platform$Partner$All$Partner = $elm$core$Basics$identity;
var $author$project$Api$Platform$Partner$Shared$Partner = $elm$core$Basics$identity;
var $author$project$Api$Platform$Partner$Shared$Record = F6(
	function (id, name, requiresMfa, active, status, organizationId) {
		return {KN: active, ahP: id, Bq: name, ajD: organizationId, $H: requiresMfa, alH: status};
	});
var $author$project$Api$Platform$Partner$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'organization_id',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'status',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'active',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'requires_mfa',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'name',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Api$Platform$Partner$Shared$Record)))))));
var $author$project$Api$Platform$Partner$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$Partner$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Platform$Partner$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$Partner$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Platform$User$Partner$listDefaults = {
	ajJ: $author$project$Api$Pagination$init,
	akl: $elm$core$Maybe$Nothing,
	alA: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init)
};
var $author$project$Api$Platform$User$Partner$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Platform$User$Partner$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.akl;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$Platform$User$Partner$partnersPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['partners']),
	$author$project$Api$Platform$User$userPath);
var $author$project$Api$Platform$User$Partner$list = F4(
	function (apiClient, optionals, maybeTracker, toMsg) {
		var request = function (req) {
			if (!maybeTracker.$) {
				var tracker = maybeTracker.a;
				return A2($author$project$Api$Data$requestWithTracker, tracker, req);
			} else {
				return req;
			}
		}(
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Platform$User$Partner$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Platform$User$Partner$partnersPath)));
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Platform$Partner$All$decoder),
			toMsg,
			request);
	});
var $author$project$Pages$User$Organizations$Top$organizationSearchTracker = function (q) {
	return 'organization-search-' + A2($elm$core$Maybe$withDefault, '', q);
};
var $author$project$Pages$User$Organizations$Top$fetchOrganizations = function (model) {
	var tracker = $author$project$Pages$User$Organizations$Top$organizationSearchTracker(model.akl);
	var _v0 = model.de;
	if (!_v0.$) {
		switch (_v0.a) {
			case 0:
				var _v1 = _v0.a;
				return A4(
					$author$project$Api$Platform$User$Practice$list,
					model.Gv,
					function (d) {
						return _Utils_update(
							d,
							{
								HM: A2($elm$core$Maybe$map, $author$project$Pages$User$Organizations$Top$filterToValue, model.Jk),
								ajJ: model.ajJ,
								akl: model.akl
							});
					},
					$elm$core$Maybe$Just(tracker),
					$author$project$Pages$User$Organizations$Top$GotPractices);
			case 1:
				var _v2 = _v0.a;
				return A4(
					$author$project$Api$Platform$User$Company$list,
					model.Gv,
					function (d) {
						return _Utils_update(
							d,
							{ajJ: model.ajJ, akl: model.akl});
					},
					$elm$core$Maybe$Just(tracker),
					$author$project$Pages$User$Organizations$Top$GotCompanies);
			default:
				var _v3 = _v0.a;
				return A4(
					$author$project$Api$Platform$User$Partner$list,
					model.Gv,
					function (d) {
						return _Utils_update(
							d,
							{ajJ: model.ajJ, akl: model.akl});
					},
					$elm$core$Maybe$Just(tracker),
					$author$project$Pages$User$Organizations$Top$GotPartners);
		}
	} else {
		return $elm$core$Platform$Cmd$none;
	}
};
var $author$project$Pages$User$Organizations$Top$GotPartnerRoles = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$User$Organizations$Top$fetchPartnerRoles = function (apiClient) {
	return A2($author$project$Api$Partner$Role$list, apiClient, $author$project$Pages$User$Organizations$Top$GotPartnerRoles);
};
var $author$project$Pages$User$Organizations$Top$GotPracticeRoles = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$User$Organizations$Top$fetchPracticeRoles = function (apiClient) {
	return A2($author$project$Api$Provider$Role$list, apiClient, $author$project$Pages$User$Organizations$Top$GotPracticeRoles);
};
var $author$project$Pages$User$Organizations$Top$FocusResult = {$: 20};
var $author$project$Pages$User$Organizations$Top$focusSearchInput = A2(
	$elm$core$Task$attempt,
	function (_v0) {
		return $author$project$Pages$User$Organizations$Top$FocusResult;
	},
	$elm$browser$Browser$Dom$focus('organization-search-input'));
var $author$project$Api$Platform$User$One$partnersCount = function (_v0) {
	var record = _v0.b;
	return record.YT;
};
var $author$project$Api$Platform$User$One$practicesCount = function (_v0) {
	var record = _v0.b;
	return record.Z0;
};
var $author$project$Pages$User$Organizations$Top$init = F4(
	function (session, user, shared, _v0) {
		var organizationTypes = $elm$core$List$concat(
			_List_fromArray(
				[
					($author$project$Api$Platform$User$One$practicesCount(user) > 0) ? _List_fromArray(
					[0]) : _List_Nil,
					($author$project$Api$Platform$User$One$companiesCount(user) > 0) ? _List_fromArray(
					[1]) : _List_Nil,
					($author$project$Api$Platform$User$One$partnersCount(user) > 0) ? _List_fromArray(
					[2]) : _List_Nil
				]));
		var currentUserIsHintAdmin = $author$project$Api$Platform$User$Shared$isAdmin(
			$author$project$Api$Platform$Session$One$user(session));
		var currentOrganizationType = $elm$core$List$head(organizationTypes);
		var _v1 = A2($author$project$Ui$Nav$init, 'organization-types', $author$project$Pages$User$Organizations$Top$NavMsg);
		var navModel = _v1.a;
		var navCmd = _v1.b;
		var model = {
			mc: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$toDownLeft(
					$author$project$Ui$Dropdown$defaultConfig(
						{ahP: 'admin-actions-dropdown', al6: $author$project$Pages$User$Organizations$Top$AdminActionsDropdownMsg}))),
			Gv: shared.Gv,
			ae6: shared.ahq.ae6,
			yJ: _List_Nil,
			m3: $author$project$Api$Platform$Session$One$organization(session),
			de: currentOrganizationType,
			Hd: user,
			He: currentUserIsHintAdmin,
			nQ: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$toDownLeft(
					$author$project$Ui$Dropdown$defaultConfig(
						{ahP: 'go-as-role-dropdown', al6: $author$project$Pages$User$Organizations$Top$GoAsRoleDropdownMsg}))),
			nU: shared.nU,
			Ij: $author$project$Shared$isHintAdmin(shared),
			V8: true,
			kp: navModel,
			oM: organizationTypes,
			tu: _List_Nil,
			ajJ: $author$project$Api$Pagination$init,
			I3: _List_Nil,
			Di: _List_Nil,
			pg: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'practices-dropdown-filter', al6: $author$project$Pages$User$Organizations$Top$PracticesDropdownMsg})),
			Jk: $elm$core$Maybe$Nothing,
			akl: $elm$core$Maybe$Nothing,
			up: $author$project$Ui$SearchInput$init($elm$core$Maybe$Nothing),
			aa4: session
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Pages$User$Organizations$Top$fetchOrganizations(model),
						navCmd,
						(currentUserIsHintAdmin && A2($elm$core$List$member, 0, organizationTypes)) ? $author$project$Pages$User$Organizations$Top$fetchPracticeRoles(model.Gv) : $elm$core$Platform$Cmd$none,
						(currentUserIsHintAdmin && A2($elm$core$List$member, 1, organizationTypes)) ? $author$project$Pages$User$Organizations$Top$fetchCompanyRoles(model.Gv) : $elm$core$Platform$Cmd$none,
						(currentUserIsHintAdmin && A2($elm$core$List$member, 2, organizationTypes)) ? $author$project$Pages$User$Organizations$Top$fetchPartnerRoles(model.Gv) : $elm$core$Platform$Cmd$none,
						$author$project$Pages$User$Organizations$Top$focusSearchInput
					])));
	});
var $author$project$Pages$User$Organizations$Top$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					nU: shared.nU,
					Ij: $author$project$Shared$isHintAdmin(shared)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$User$Organizations$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$User$Organizations$Top$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$Dropdown$subscriptions(model.pg),
				$author$project$Ui$Dropdown$subscriptions(model.mc),
				$author$project$Ui$Dropdown$subscriptions(model.nQ),
				$author$project$Ui$Nav$subscriptions(model.kp)
			]));
};
var $author$project$Pages$User$Organizations$Top$SearchInputMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$OutMsg$SwitchRole = function (a) {
	return {$: 18, a: a};
};
var $author$project$OutMsg$SwitchToClinical = function (a) {
	return {$: 17, a: a};
};
var $author$project$OutMsg$ToggleHighlightPhi = {$: 14};
var $author$project$OutMsg$ToggleHinterView = {$: 13};
var $author$project$Api$Platform$Company$Min$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Platform$Company$All$id = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Platform$Company$Min$id(min);
};
var $author$project$Api$Platform$Company$Min$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Platform$Company$All$name = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Platform$Company$Min$name(min);
};
var $author$project$Api$Platform$Company$All$organizationId = function (_v0) {
	var record = _v0.b;
	return record.ajD;
};
var $author$project$Api$Platform$Company$All$practice = function (_v0) {
	var record = _v0.b;
	return record.ZV;
};
var $author$project$Api$Platform$Company$Min$requiresMfa = function (_v0) {
	var record = _v0;
	return record.$H;
};
var $author$project$Api$Platform$Company$All$requiresMfa = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Platform$Company$Min$requiresMfa(min);
};
var $author$project$Pages$User$Organizations$Top$companyToOrganization = function (company) {
	return {
		Sz: 0,
		ahP: $author$project$Api$Platform$Company$All$id(company),
		UL: false,
		ais: $elm$core$Maybe$Nothing,
		Bq: $author$project$Api$Platform$Company$All$name(company),
		ajD: $author$project$Api$Platform$Company$All$organizationId(company),
		YD: $elm$core$Maybe$Nothing,
		ZY: $elm$core$Maybe$Just(
			$author$project$Api$Platform$Practice$Min$name(
				$author$project$Api$Platform$Company$All$practice(company))),
		Jo: $elm$core$Maybe$Nothing,
		$H: $author$project$Api$Platform$Company$All$requiresMfa(company),
		amg: 1
	};
};
var $author$project$Api$Platform$Partner$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Platform$Partner$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Platform$Partner$Shared$id(shared);
};
var $author$project$Api$Platform$Partner$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Platform$Partner$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Platform$Partner$Shared$name(shared);
};
var $author$project$Api$Platform$Partner$Shared$organizationId = function (_v0) {
	var record = _v0;
	return record.ajD;
};
var $author$project$Api$Platform$Partner$All$organizationId = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Platform$Partner$Shared$organizationId(shared);
};
var $author$project$Api$Platform$Partner$Shared$requiresMfa = function (_v0) {
	var record = _v0;
	return record.$H;
};
var $author$project$Api$Platform$Partner$All$requiresMfa = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Platform$Partner$Shared$requiresMfa(shared);
};
var $author$project$Api$Platform$Partner$Shared$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Api$Platform$Partner$All$status = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Platform$Partner$Shared$status(shared);
};
var $author$project$Pages$User$Organizations$Top$partnerToOrganization = function (partner) {
	return {
		Sz: 0,
		ahP: $author$project$Api$Platform$Partner$All$id(partner),
		UL: false,
		ais: $elm$core$Maybe$Nothing,
		Bq: _Utils_ap(
			$author$project$Api$Platform$Partner$All$name(partner),
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function (status) {
						return ' (' + (status + ')');
					},
					$author$project$Api$Platform$Partner$All$status(partner)))),
		ajD: $author$project$Api$Platform$Partner$All$organizationId(partner),
		YD: $elm$core$Maybe$Nothing,
		ZY: $elm$core$Maybe$Nothing,
		Jo: $elm$core$Maybe$Nothing,
		$H: $author$project$Api$Platform$Partner$All$requiresMfa(partner),
		amg: 2
	};
};
var $author$project$Api$Platform$Practice$Min$flaggedNotesCount = function (_v0) {
	var record = _v0;
	return record.Sz;
};
var $author$project$Api$Platform$Practice$All$flaggedNotesCount = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Platform$Practice$Min$flaggedNotesCount(min);
};
var $author$project$Api$Platform$Practice$Min$isDeactivated = function (_v0) {
	var record = _v0;
	return record.UL;
};
var $author$project$Api$Platform$Practice$All$isDeactivated = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Platform$Practice$Min$isDeactivated(min);
};
var $author$project$Api$Platform$Practice$All$organizationId = function (_v0) {
	var record = _v0.b;
	return record.ajD;
};
var $author$project$Api$Platform$Practice$All$owner = function (_v0) {
	var record = _v0.b;
	return record.YD;
};
var $author$project$Api$Platform$Practice$All$productType = function (_v0) {
	var record = _v0.b;
	return record.Jo;
};
var $author$project$Api$Platform$Practice$Min$requiresMfa = function (_v0) {
	var record = _v0;
	return record.$H;
};
var $author$project$Api$Platform$Practice$All$requiresMfa = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Platform$Practice$Min$requiresMfa(min);
};
var $author$project$Components$AddressDisplay$viewCityState = function (address) {
	var state = $author$project$Components$AddressDisplay$formatSegment(
		$author$project$Api$Common$Address$Shared$state(address));
	var city = $author$project$Components$AddressDisplay$formatSegment(
		$author$project$Api$Common$Address$Shared$city(address));
	var _v0 = _Utils_Tuple2(city, state);
	if (_v0.a === '') {
		if (_v0.b === '') {
			return '';
		} else {
			var stateStr = _v0.b;
			return stateStr;
		}
	} else {
		if (_v0.b === '') {
			var cityStr = _v0.a;
			return cityStr;
		} else {
			var cityStr = _v0.a;
			var stateStr = _v0.b;
			return cityStr + (', ' + stateStr);
		}
	}
};
var $author$project$Pages$User$Organizations$Top$practiceToOrganization = function (practice) {
	var location = function () {
		var _v0 = $author$project$Api$Platform$Practice$All$address(practice);
		if (!_v0.$) {
			var address = _v0.a;
			return $elm$core$Maybe$Just(
				$author$project$Components$AddressDisplay$viewCityState(address));
		} else {
			return $elm$core$Maybe$Just('');
		}
	}();
	return {
		Sz: $author$project$Api$Platform$Practice$All$flaggedNotesCount(practice),
		ahP: $author$project$Api$Platform$Practice$All$id(practice),
		UL: $author$project$Api$Platform$Practice$All$isDeactivated(practice),
		ais: location,
		Bq: $author$project$Api$Platform$Practice$All$name(practice),
		ajD: $author$project$Api$Platform$Practice$All$organizationId(practice),
		YD: A2(
			$elm$core$Maybe$map,
			$author$project$Api$Platform$User$Min$name,
			$author$project$Api$Platform$Practice$All$owner(practice)),
		ZY: $elm$core$Maybe$Just(
			$author$project$Api$Platform$Practice$All$name(practice)),
		Jo: $elm$core$Maybe$Just(
			$author$project$Api$Platform$Practice$All$productType(practice)),
		$H: $author$project$Api$Platform$Practice$All$requiresMfa(practice),
		amg: 0
	};
};
var $author$project$Pages$User$Organizations$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					_List_fromArray(
						[$author$project$OutMsg$ToggleHinterView]));
			case 1:
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					_List_fromArray(
						[$author$project$OutMsg$ToggleHighlightPhi]));
			case 2:
				var navMsg = msg.a;
				var _v1 = A2($author$project$Ui$Nav$update, navMsg, model.kp);
				var nav = _v1.a;
				var navCmd = _v1.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{kp: nav}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$User$Organizations$Top$NavMsg, navCmd),
					_List_Nil);
			case 3:
				var organizationType = msg.a;
				var newModel = _Utils_update(
					model,
					{
						de: $elm$core$Maybe$Just(organizationType),
						V8: true,
						tu: _List_Nil,
						Jk: $elm$core$Maybe$Nothing,
						akl: $elm$core$Maybe$Nothing,
						up: $author$project$Ui$SearchInput$init($elm$core$Maybe$Nothing)
					});
				return _Utils_Tuple3(
					newModel,
					$author$project$Pages$User$Organizations$Top$fetchOrganizations(newModel),
					_List_Nil);
			case 4:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Ui$SearchInput$update, subMsg, model.up);
				var searchInput = _v2.a;
				var searchInputCmd = _v2.b;
				var searchInputEvent = _v2.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.akl;
					}
				}();
				var _v3 = function () {
					if (_Utils_eq(q, model.akl)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{akl: q});
						return _Utils_Tuple2(
							qModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$elm$http$Http$cancel(
										$author$project$Pages$User$Organizations$Top$organizationSearchTracker(model.akl)),
										$author$project$Pages$User$Organizations$Top$fetchOrganizations(qModel)
									])));
					}
				}();
				var newModel = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{up: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$User$Organizations$Top$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
			case 5:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ajJ);
				var newModel = _Utils_update(
					model,
					{ajJ: pagination});
				return _Utils_Tuple3(
					newModel,
					$author$project$Pages$User$Organizations$Top$fetchOrganizations(newModel),
					_List_Nil);
			case 6:
				var response = msg.a;
				if (!_Utils_eq(
					model.de,
					$elm$core$Maybe$Just(0))) {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				} else {
					if (response.$ === 3) {
						var practices = response.a;
						var headers = response.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									V8: false,
									tu: A2($elm$core$List$map, $author$project$Pages$User$Organizations$Top$practiceToOrganization, practices),
									ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{V8: false, tu: _List_Nil}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				}
			case 7:
				var response = msg.a;
				if (!_Utils_eq(
					model.de,
					$elm$core$Maybe$Just(1))) {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				} else {
					if (response.$ === 3) {
						var companies = response.a;
						var headers = response.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									V8: false,
									tu: A2($elm$core$List$map, $author$project$Pages$User$Organizations$Top$companyToOrganization, companies),
									ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{V8: false, tu: _List_Nil}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				}
			case 8:
				var response = msg.a;
				if (!_Utils_eq(
					model.de,
					$elm$core$Maybe$Just(2))) {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				} else {
					if (response.$ === 3) {
						var partners = response.a;
						var headers = response.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									V8: false,
									tu: A2($elm$core$List$map, $author$project$Pages$User$Organizations$Top$partnerToOrganization, partners),
									ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ajJ)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{V8: false, tu: _List_Nil}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				}
			case 9:
				var organization = msg.a;
				var role = msg.b;
				var roleWithPrefix = function () {
					var _v8 = _Utils_Tuple2(model.de, role);
					if ((!_v8.a.$) && (!_v8.b.$)) {
						switch (_v8.a.a) {
							case 0:
								var _v9 = _v8.a.a;
								var role_ = _v8.b.a;
								return $elm$core$Maybe$Just(
									'practice_' + $author$project$Api$Common$Role$All$name(role_));
							case 1:
								var _v10 = _v8.a.a;
								var role_ = _v8.b.a;
								return $elm$core$Maybe$Just(
									'company_' + $author$project$Api$Common$Role$All$name(role_));
							default:
								var _v11 = _v8.a.a;
								var role_ = _v8.b.a;
								return $elm$core$Maybe$Just(
									'partner_' + $author$project$Api$Common$Role$All$name(role_));
						}
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}();
				var postOrganizationSwitchedAction = $author$project$Api$Platform$Session$One$sandbox(model.aa4) ? $author$project$OutMsg$GoToDefaultStateAndReloadAction : $author$project$OutMsg$GoToDefaultStateAction;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{V8: true}),
					$elm$core$Platform$Cmd$none,
					_List_fromArray(
						[
							A3($author$project$OutMsg$SwitchToOrganization, organization.ajD, roleWithPrefix, postOrganizationSwitchedAction)
						]));
			case 10:
				var organization = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{V8: true}),
					$elm$core$Platform$Cmd$none,
					_List_fromArray(
						[
							$author$project$OutMsg$SwitchToClinical(organization.ajD)
						]));
			case 11:
				var subMsg = msg.a;
				var _v12 = A2($author$project$Ui$Dropdown$update, subMsg, model.nQ);
				var dropdown = _v12.a;
				var dropdownCmd = _v12.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nQ: dropdown}),
					dropdownCmd,
					_List_Nil);
			case 12:
				var role = msg.a;
				var roleWithPrefix = function () {
					var _v13 = A2($elm$core$Maybe$map, $author$project$Api$Platform$Organization$Shared$type_, model.m3);
					if (!_v13.$) {
						switch (_v13.a) {
							case 0:
								var _v14 = _v13.a;
								return 'practice_' + $author$project$Api$Common$Role$All$name(role);
							case 1:
								var _v15 = _v13.a;
								return 'company_' + $author$project$Api$Common$Role$All$name(role);
							default:
								var _v16 = _v13.a;
								return 'partner_' + $author$project$Api$Common$Role$All$name(role);
						}
					} else {
						return $author$project$Api$Common$Role$All$name(role);
					}
				}();
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					_List_fromArray(
						[
							$author$project$OutMsg$SwitchRole(roleWithPrefix)
						]));
			case 13:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							Di: A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								$author$project$Api$Data$toMaybe(response))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 14:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							yJ: A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								$author$project$Api$Data$toMaybe(response))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 15:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							I3: A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								$author$project$Api$Data$toMaybe(response))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 16:
				var subMsg = msg.a;
				var _v17 = A2($author$project$Ui$Dropdown$update, subMsg, model.pg);
				var dropdown = _v17.a;
				var dropdownCmd = _v17.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{pg: dropdown}),
					dropdownCmd,
					_List_Nil);
			case 18:
				var subMsg = msg.a;
				var _v18 = A2($author$project$Ui$Dropdown$update, subMsg, model.mc);
				var dropdown = _v18.a;
				var dropdownCmd = _v18.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{mc: dropdown}),
					dropdownCmd,
					_List_Nil);
			case 17:
				var selected = msg.a;
				var newModel = _Utils_update(
					model,
					{V8: true, tu: _List_Nil, Jk: selected});
				return _Utils_Tuple3(
					newModel,
					$author$project$Pages$User$Organizations$Top$fetchOrganizations(newModel),
					_List_Nil);
			case 19:
				var text = msg.a;
				return _Utils_Tuple3(
					model,
					$author$project$Ports$Clipboard$copy(text),
					_List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 3, 'Copied to clipboard')
						]));
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Pages$User$Organizations$Top$GoAsRole = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$User$Organizations$Top$currentOrgRoles = function (model) {
	var _v0 = A2($elm$core$Maybe$map, $author$project$Api$Platform$Organization$Shared$type_, model.m3);
	if (!_v0.$) {
		switch (_v0.a) {
			case 0:
				var _v1 = _v0.a;
				return model.Di;
			case 1:
				var _v2 = _v0.a;
				return model.yJ;
			default:
				var _v3 = _v0.a;
				return model.I3;
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$Pages$User$Organizations$Top$PaginationMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$SearchInput$Autofocus = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$SearchInput$autofocus = $author$project$Ui$SearchInput$Autofocus;
var $author$project$Ui$SearchInput$Id = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$SearchInput$id = $author$project$Ui$SearchInput$Id;
var $author$project$Pages$User$Organizations$Top$CopyToClipboard = function (a) {
	return {$: 19, a: a};
};
var $author$project$Api$Platform$User$One$isMfaActive = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Platform$User$Shared$isMfaActive(shared);
};
var $author$project$Pages$User$Organizations$Top$mfaRequiredButDisabled = F2(
	function (currentUser, organization) {
		return organization.$H && (!$author$project$Api$Platform$User$One$isMfaActive(currentUser));
	});
var $author$project$Pages$User$Organizations$Top$cantSwitchOrganizationMessage = F2(
	function (currentUser, organization) {
		return A2($author$project$Pages$User$Organizations$Top$mfaRequiredButDisabled, currentUser, organization) ? $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('MFA is required for this practice. Click '),
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$User__Mfa,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('here')
							])),
						$elm$html$Html$text(' to enable it.')
					]))) : $elm$core$Maybe$Nothing;
	});
var $author$project$Pages$User$Organizations$Top$canSwitchOrganization = F2(
	function (currentUser, organization) {
		return _Utils_eq(
			A2($author$project$Pages$User$Organizations$Top$cantSwitchOrganizationMessage, currentUser, organization),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Pages$User$Organizations$Top$isCurrentOrganization = F2(
	function (currentOrganization, organization) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (currentOrganization_) {
					return _Utils_eq(
						$author$project$Api$Platform$Organization$Shared$type_(currentOrganization_),
						organization.amg) && _Utils_eq(
						$author$project$Api$Platform$Organization$Shared$id(currentOrganization_),
						organization.ahP);
				},
				currentOrganization));
	});
var $author$project$Ui$Element$mr1 = $author$project$Ui$Element$Margin('mr-1');
var $author$project$Pages$User$Organizations$Top$SwitchToOrganization = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Ui$Button$Aligned = function (a) {
	return {$: 11, a: a};
};
var $author$project$Ui$Button$aligned = $author$project$Ui$Button$Aligned;
var $author$project$Pages$User$Organizations$Top$viewOrganizationNameCell = F2(
	function (isLoading, organization) {
		var name = organization.UL ? (organization.Bq + ' (deactivated)') : organization.Bq;
		return A3(
			$author$project$Ui$Button$view,
			{mm: 'Switch to ' + name},
			_List_fromArray(
				[
					$author$project$Ui$Button$link,
					$author$project$Ui$Button$onClick(
					A2($author$project$Pages$User$Organizations$Top$SwitchToOrganization, organization, $elm$core$Maybe$Nothing)),
					$author$project$Ui$Button$disabled(isLoading),
					$author$project$Ui$Button$aligned($author$project$Ui$Alignment$textLeft)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
					_List_fromArray(
						[
							$elm$html$Html$text(name),
							(organization.amg === 1) ? A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textSm]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($elm$core$Maybe$withDefault, '', organization.ZY))
								])) : $author$project$Utils$Html$empty,
							((organization.Sz > 0) && (!organization.amg)) ? $author$project$Ui$Icon$flag(_List_Nil) : $author$project$Utils$Html$empty
						]))
				]));
	});
var $author$project$Pages$User$Organizations$Top$SwitchToClinical = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$User$Organizations$Top$viewProductOptions = function (_v0) {
	var organization = _v0.Yr;
	var isCurrentOrganization_ = _v0.UJ;
	var currentUser = _v0.Hd;
	var backupAuthEnabled = _v0.ae6;
	var isLoading = _v0.dp;
	var _v1 = _Utils_Tuple2(
		isCurrentOrganization_,
		A2($author$project$Pages$User$Organizations$Top$cantSwitchOrganizationMessage, currentUser, organization));
	if (_v1.a) {
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$flex, $author$project$Ui$Element$justifyRight]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$text,
					_List_fromArray(
						[$author$project$Ui$Typography$muted]),
					'active')
				]));
	} else {
		if (!_v1.b.$) {
			var message = _v1.b.a;
			return A2(
				$author$project$Ui$Badge$view,
				_List_fromArray(
					[$author$project$Ui$Badge$danger]),
				_List_fromArray(
					[message]));
		} else {
			var _v2 = _v1.b;
			return A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$flex, $author$project$Ui$Element$justifyRight]),
				_List_fromArray(
					[
						$author$project$Ui$Button$group(
						_List_fromArray(
							[
								function () {
								var _v3 = organization.Jo;
								if ((!_v3.$) && (_v3.a === 'Clinical')) {
									var switchToClinicalButton = A3(
										$author$project$Ui$Button$view,
										{mm: 'Switch to clinical'},
										_List_fromArray(
											[
												$author$project$Ui$Button$onClick(
												$author$project$Pages$User$Organizations$Top$SwitchToClinical(organization)),
												$author$project$Ui$Button$disabled(backupAuthEnabled || isLoading)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Clinical '),
												$author$project$Ui$Icon$arrowRight(
												_List_fromArray(
													[$author$project$Ui$Icon$xs, $author$project$Ui$Icon$info]))
											]));
									return backupAuthEnabled ? A3(
										$author$project$Ui$Popover$view,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Ui$Button$group(
												_List_fromArray(
													[switchToClinicalButton]))
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Popover$body,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('The Clinical app is temporarily unavailable due to the sign-in system outage.')
													]))
											])) : switchToClinicalButton;
								} else {
									return $author$project$Utils$Html$empty;
								}
							}(),
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Switch to core'},
								_List_fromArray(
									[
										$author$project$Ui$Button$onClick(
										A2($author$project$Pages$User$Organizations$Top$SwitchToOrganization, organization, $elm$core$Maybe$Nothing)),
										$author$project$Ui$Button$disabled(isLoading),
										$author$project$Ui$Button$loading(isLoading)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Core '),
										$author$project$Ui$Icon$arrowRight(
										_List_fromArray(
											[$author$project$Ui$Icon$xs, $author$project$Ui$Icon$info]))
									]))
							]))
					]));
		}
	}
};
var $author$project$Pages$User$Organizations$Top$viewOrganizationRow = F2(
	function (model, organization) {
		var isCurrentOrganization_ = A2($author$project$Pages$User$Organizations$Top$isCurrentOrganization, model.m3, organization);
		var productSwitcherParams = {ae6: model.ae6, Hd: model.Hd, UJ: isCurrentOrganization_, dp: model.V8, Yr: organization};
		var rowOptions = isCurrentOrganization_ ? _List_fromArray(
			[
				$author$project$Ui$Table$styled(0)
			]) : ((!A2($author$project$Pages$User$Organizations$Top$canSwitchOrganization, model.Hd, organization)) ? _List_fromArray(
			[
				$author$project$Ui$Table$styled(3)
			]) : (organization.UL ? _List_fromArray(
			[
				$author$project$Ui$Table$styled(2)
			]) : _List_Nil));
		var _v0 = _Utils_Tuple2(model.Ij, organization.amg);
		if (_v0.a) {
			switch (_v0.b) {
				case 0:
					var _v1 = _v0.b;
					return A2(
						$author$project$Ui$Table$row,
						rowOptions,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$Pages$User$Organizations$Top$viewOrganizationNameCell, model.V8, organization)
									])),
								A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2($elm$core$Maybe$withDefault, '', organization.YD))
									])),
								A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2($elm$core$Maybe$withDefault, '', organization.ais))
									])),
								A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2($elm$core$Maybe$withDefault, '', organization.Jo))
									])),
								A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$inlineBlock, $author$project$Ui$Element$mr1]),
										_List_fromArray(
											[
												$elm$html$Html$text(organization.ahP)
											])),
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Copy organization id'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$onClick(
												$author$project$Pages$User$Organizations$Top$CopyToClipboard(organization.ahP)),
												$author$project$Ui$Button$icon($author$project$Ui$Icon$copy)
											]),
										_List_Nil)
									])),
								A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$inlineBlock, $author$project$Ui$Element$mr1]),
										_List_fromArray(
											[
												$elm$html$Html$text(organization.ajD)
											])),
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Copy organization identifier'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$onClick(
												$author$project$Pages$User$Organizations$Top$CopyToClipboard(organization.ajD)),
												$author$project$Ui$Button$icon($author$project$Ui$Icon$copy)
											]),
										_List_Nil)
									])),
								A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Pages$User$Organizations$Top$viewProductOptions(productSwitcherParams)
									]))
							]));
				case 2:
					var _v2 = _v0.b;
					return A2(
						$author$project$Ui$Table$row,
						rowOptions,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$Pages$User$Organizations$Top$viewOrganizationNameCell, model.V8, organization)
									])),
								A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$inlineBlock, $author$project$Ui$Element$mr1]),
										_List_fromArray(
											[
												$elm$html$Html$text(organization.ahP)
											])),
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Copy organization id'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$onClick(
												$author$project$Pages$User$Organizations$Top$CopyToClipboard(organization.ahP)),
												$author$project$Ui$Button$icon($author$project$Ui$Icon$copy)
											]),
										_List_Nil)
									])),
								A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$inlineBlock, $author$project$Ui$Element$mr1]),
										_List_fromArray(
											[
												$elm$html$Html$text(organization.ajD)
											])),
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Copy organization identifier'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$onClick(
												$author$project$Pages$User$Organizations$Top$CopyToClipboard(organization.ajD)),
												$author$project$Ui$Button$icon($author$project$Ui$Icon$copy)
											]),
										_List_Nil)
									])),
								A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Pages$User$Organizations$Top$viewProductOptions(productSwitcherParams)
									]))
							]));
				default:
					var _v3 = _v0.b;
					return A2(
						$author$project$Ui$Table$row,
						rowOptions,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$Pages$User$Organizations$Top$viewOrganizationNameCell, model.V8, organization)
									])),
								A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$inlineBlock, $author$project$Ui$Element$mr1]),
										_List_fromArray(
											[
												$elm$html$Html$text(organization.ahP)
											])),
										A3(
										$author$project$Ui$Button$view,
										{mm: 'Copy organization id'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$onClick(
												$author$project$Pages$User$Organizations$Top$CopyToClipboard(organization.ahP)),
												$author$project$Ui$Button$icon($author$project$Ui$Icon$copy)
											]),
										_List_Nil)
									])),
								A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2($elm$core$Maybe$withDefault, '', organization.ZY))
									])),
								A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Pages$User$Organizations$Top$viewProductOptions(productSwitcherParams)
									]))
							]));
			}
		} else {
			return A2(
				$author$project$Ui$Table$row,
				rowOptions,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Pages$User$Organizations$Top$viewOrganizationNameCell, model.V8, organization)
							])),
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Pages$User$Organizations$Top$viewProductOptions(productSwitcherParams)
							]))
					]));
		}
	});
var $author$project$Pages$User$Organizations$Top$filterToLabel = function (filter) {
	if (filter.$ === 1) {
		return 'All Practices';
	} else {
		var _v1 = filter.a;
		return 'Has Flagged Notes';
	}
};
var $author$project$Pages$User$Organizations$Top$PracticesFilterSelected = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$User$Organizations$Top$WithFlaggedNotes = 0;
var $author$project$Pages$User$Organizations$Top$practicesDropdownOptions = function (currentFilter) {
	var filterToItem = function (filter) {
		return A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Pages$User$Organizations$Top$PracticesFilterSelected(filter)),
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(filter, currentFilter))
				]),
			$elm$html$Html$text(
				$author$project$Pages$User$Organizations$Top$filterToLabel(filter)));
	};
	return _List_fromArray(
		[
			filterToItem($elm$core$Maybe$Nothing),
			$author$project$Ui$Dropdown$separator,
			filterToItem(
			$elm$core$Maybe$Just(0))
		]);
};
var $author$project$Pages$User$Organizations$Top$viewPracticesDropdown = function (model) {
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Pages$User$Organizations$Top$filterToLabel(model.Jk))
			]),
		$author$project$Pages$User$Organizations$Top$practicesDropdownOptions(model.Jk),
		model.pg);
};
var $author$project$Pages$User$Organizations$Top$toPane = F2(
	function (model, organizationType) {
		var showPracticeFilters = (!organizationType) && model.Ij;
		return A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanSm(
											showPracticeFilters ? 10 : 12)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$map,
											$author$project$Pages$User$Organizations$Top$SearchInputMsg,
											A2(
												$author$project$Ui$SearchInput$view,
												_List_fromArray(
													[
														$author$project$Ui$SearchInput$loading(model.V8),
														$author$project$Ui$SearchInput$autofocus(true),
														$author$project$Ui$SearchInput$id('organization-search-input')
													]),
												model.up))
										])),
									showPracticeFilters ? A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$spanSm(2)
										]),
									_List_fromArray(
										[
											$author$project$Pages$User$Organizations$Top$viewPracticesDropdown(model)
										])) : $author$project$Ui$Grid$none
								]))
						])),
					A4(
					$author$project$Ui$Panel$table,
					_List_fromArray(
						[
							$author$project$Ui$Table$zeroState(
							_List_fromArray(
								[
									$elm$html$Html$text('No results')
								])),
							$author$project$Ui$Table$loading(model.V8)
						]),
					function () {
						var _v0 = _Utils_Tuple2(model.Ij, organizationType);
						if (_v0.a) {
							switch (_v0.b) {
								case 0:
									var _v1 = _v0.b;
									return _List_fromArray(
										[
											A2(
											$author$project$Ui$Table$header,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Practice Name')
												])),
											A2(
											$author$project$Ui$Table$header,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Owner')
												])),
											A2(
											$author$project$Ui$Table$header,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Location')
												])),
											A2(
											$author$project$Ui$Table$header,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Product')
												])),
											A2(
											$author$project$Ui$Table$header,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Practice ID')
												])),
											A2(
											$author$project$Ui$Table$header,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Org ID')
												])),
											A2(
											$author$project$Ui$Table$header,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('')
												]))
										]);
								case 2:
									var _v2 = _v0.b;
									return _List_fromArray(
										[
											A2(
											$author$project$Ui$Table$header,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Partner Name')
												])),
											A2(
											$author$project$Ui$Table$header,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Partner ID')
												])),
											A2(
											$author$project$Ui$Table$header,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Org ID')
												])),
											A2(
											$author$project$Ui$Table$header,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('')
												]))
										]);
								default:
									var _v3 = _v0.b;
									return _List_fromArray(
										[
											A2(
											$author$project$Ui$Table$header,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Company Name')
												])),
											A2(
											$author$project$Ui$Table$header,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Company ID')
												])),
											A2(
											$author$project$Ui$Table$header,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Practice Name')
												])),
											A2(
											$author$project$Ui$Table$header,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('')
												]))
										]);
							}
						} else {
							return _List_Nil;
						}
					}(),
					A2(
						$elm$core$List$map,
						$author$project$Pages$User$Organizations$Top$viewOrganizationRow(model),
						model.tu),
					_List_Nil),
					($elm$core$List$length(model.oM) > 0) ? A2(
					$author$project$Ui$Panel$footer,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Pages$User$Organizations$Top$PaginationMsg,
							A2($author$project$Api$Pagination$view, _List_Nil, model.ajJ))
						])) : $author$project$Ui$Panel$none
				]));
	});
var $author$project$Pages$User$Organizations$Top$ToggleHighlightPhi = {$: 1};
var $author$project$Pages$User$Organizations$Top$viewHighlightPhiToggle = function (highlightPhi) {
	return A2(
		$author$project$Ui$Typography$p,
		_List_Nil,
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{mm: 'Toggle PHI highlighting'},
				_List_fromArray(
					[
						$author$project$Ui$Button$badge,
						$author$project$Ui$Button$onClick($author$project$Pages$User$Organizations$Top$ToggleHighlightPhi)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Highlight Phi: '),
						highlightPhi ? $elm$html$Html$text('ON') : $elm$html$Html$text('OFF')
					]))
			]));
};
var $author$project$Pages$User$Organizations$Top$ToggleHinterView = {$: 0};
var $author$project$Pages$User$Organizations$Top$viewHinterViewToggle = function (isHintAdmin) {
	var label = $elm$core$String$concat(
		_List_fromArray(
			[
				'as ',
				isHintAdmin ? '' : 'NON-',
				'hinter'
			]));
	return A3(
		$author$project$Ui$HinterOnly$button,
		{mm: label},
		_List_fromArray(
			[
				$author$project$Ui$Button$link,
				$author$project$Ui$Button$onClick($author$project$Pages$User$Organizations$Top$ToggleHinterView)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(label)
			]));
};
var $author$project$Pages$User$Organizations$Top$TabClicked = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$OrganizationType$toString = function (organizationType) {
	switch (organizationType) {
		case 0:
			return 'practice';
		case 1:
			return 'company';
		default:
			return 'partner';
	}
};
var $author$project$Pages$User$Organizations$Top$toTab = function (organizationType) {
	switch (organizationType) {
		case 0:
			return $elm$html$Html$text('Practices');
		case 1:
			return $elm$html$Html$text('Companies');
		default:
			return $elm$html$Html$text('Partners');
	}
};
var $author$project$Pages$User$Organizations$Top$viewNavItem = F2(
	function (currentType, orgType) {
		return A2(
			$author$project$Ui$Nav$item,
			_List_fromArray(
				[
					$author$project$Ui$Nav$itemId(
					$author$project$Api$OrganizationType$toString(orgType)),
					$author$project$Ui$Nav$activeItem(
					_Utils_eq(
						currentType,
						$elm$core$Maybe$Just(orgType))),
					$author$project$Ui$Nav$onItemClick(
					$author$project$Pages$User$Organizations$Top$TabClicked(orgType))
				]),
			_List_fromArray(
				[
					$author$project$Pages$User$Organizations$Top$toTab(orgType)
				]));
	});
var $author$project$Pages$User$Organizations$Top$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Choose Organization')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween]),
								_List_fromArray(
									[
										function () {
										var _v0 = model.m3;
										if (!_v0.$) {
											var currentOrganization = _v0.a;
											return A2(
												$author$project$Ui$Typography$p,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('You are currently administering '),
														A2(
														$author$project$Ui$Typography$strong,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(
																$author$project$Api$Platform$Organization$Shared$name(currentOrganization))
															])),
														$author$project$Utils$Html$noBreakSpace,
														model.He ? $author$project$Pages$User$Organizations$Top$viewHinterViewToggle(model.Ij) : $author$project$Utils$Html$empty,
														model.Ij ? $author$project$Pages$User$Organizations$Top$viewHighlightPhiToggle(model.nU) : $author$project$Utils$Html$empty
													]));
										} else {
											return $author$project$Utils$Html$empty;
										}
									}(),
										model.Ij ? A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
										_List_fromArray(
											[
												(!$elm$core$List$isEmpty(
												$author$project$Pages$User$Organizations$Top$currentOrgRoles(model))) ? A4(
												$author$project$Ui$HinterOnly$dropdown,
												_List_fromArray(
													[$author$project$Ui$Dropdown$buttonSecondary]),
												_List_fromArray(
													[
														$elm$html$Html$text('Go As Role')
													]),
												A2(
													$elm$core$List$map,
													function (role) {
														return A2(
															$author$project$Ui$Dropdown$item,
															_List_fromArray(
																[
																	$author$project$Ui$Dropdown$onSelect(
																	$author$project$Pages$User$Organizations$Top$GoAsRole(role))
																]),
															$elm$html$Html$text(
																'Go as ' + $author$project$Api$Common$Role$All$name(role)));
													},
													$author$project$Pages$User$Organizations$Top$currentOrgRoles(model)),
												model.nQ) : $author$project$Utils$Html$empty,
												A4(
												$author$project$Ui$HinterOnly$dropdown,
												_List_fromArray(
													[$author$project$Ui$Dropdown$buttonSecondary]),
												_List_fromArray(
													[
														$elm$html$Html$text('Hinter Actions')
													]),
												_List_fromArray(
													[
														A3(
														$author$project$Ui$Dropdown$link,
														$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Hinter__ClonePractice),
														_List_Nil,
														$elm$html$Html$text('Clone practice')),
														A3(
														$author$project$Ui$Dropdown$link,
														$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Hinter__NewPractice),
														_List_Nil,
														$elm$html$Html$text('Create new practice')),
														A3(
														$author$project$Ui$Dropdown$link,
														$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Hinter__NewPartner),
														_List_Nil,
														$elm$html$Html$text('Create new partner')),
														A3(
														$author$project$Ui$Dropdown$link,
														$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Hinter__NewGroup),
														_List_Nil,
														$elm$html$Html$text('Create new group')),
														$author$project$Ui$Dropdown$separator,
														A3(
														$author$project$Ui$Dropdown$link,
														$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Hinter__Disputes),
														_List_Nil,
														$elm$html$Html$text('Manage Disputes')),
														A3(
														$author$project$Ui$Dropdown$link,
														$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Hinter__AdminUsersGroups__Top),
														_List_Nil,
														$elm$html$Html$text('Manage Admin Users Groups')),
														A3(
														$author$project$Ui$Dropdown$link,
														$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Hinter__FeatureFlags),
														_List_Nil,
														$elm$html$Html$text('Manage Feature Flags'))
													]),
												model.mc)
											])) : $author$project$Utils$Html$empty
									])),
								($elm$core$List$length(model.oM) > 1) ? A3(
								$author$project$Ui$Nav$view,
								_List_Nil,
								A2(
									$elm$core$List$map,
									$author$project$Pages$User$Organizations$Top$viewNavItem(model.de),
									model.oM),
								model.kp) : $author$project$Utils$Html$empty,
								($elm$core$List$length(model.oM) > 0) ? A2(
								$elm$core$Maybe$withDefault,
								$elm$html$Html$text(''),
								A2(
									$elm$core$Maybe$map,
									$author$project$Pages$User$Organizations$Top$toPane(model),
									model.de)) : $author$project$Utils$Html$empty
							]))
					]))
			]),
		ac9: 'Switch Organization'
	};
};
var $author$project$Pages$User$Organizations$Top$page = $author$project$Spa$Page$applicationUser(
	{ah_: $author$project$Pages$User$Organizations$Top$init, aiq: $author$project$Pages$User$Organizations$Top$load, k8: $author$project$Pages$User$Organizations$Top$save, alO: $author$project$Pages$User$Organizations$Top$subscriptions, adT: $author$project$Pages$User$Organizations$Top$update, amo: $author$project$Pages$User$Organizations$Top$view});
var $author$project$Api$Practice$hasClinicalAccount = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$hasClinicalAccount(practice_);
	} else {
		return false;
	}
};
var $author$project$Api$Platform$User$Shared$identityProviderId = function (_v0) {
	var record = _v0;
	return record.TM;
};
var $author$project$Api$Platform$User$One$identityProviderId = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Platform$User$Shared$identityProviderId(shared);
};
var $author$project$Api$Platform$User$One$email = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Platform$User$Shared$email(shared);
};
var $author$project$Api$Platform$User$One$firstName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Platform$User$Shared$firstName(shared);
};
var $author$project$Api$Platform$User$One$lastName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Platform$User$Shared$lastName(shared);
};
var $author$project$Pages$User$Profile$initFormFields = function (user) {
	return {
		Rj: $author$project$Api$Platform$User$One$email(user),
		Sv: $author$project$Api$Platform$User$One$firstName(user),
		VH: $author$project$Api$Platform$User$One$lastName(user),
		J5: $author$project$Api$Platform$User$One$termsAccepted(user)
	};
};
var $author$project$Pages$User$Profile$initPhoneInput = function (phones) {
	return A3(
		$author$project$Components$PhoneInput$init,
		'user-phone-input',
		A2($elm$core$List$map, $author$project$Utils$Phone$fromApi, phones),
		$elm$core$Basics$identity);
};
var $author$project$Api$Platform$User$One$phones = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Platform$User$Shared$phones(shared);
};
var $author$project$Ports$Navigation$navigationPortRequestUrl = _Platform_outgoingPort(
	'navigationPortRequestUrl',
	function ($) {
		var a = $.a;
		var b = $.b;
		var c = $.c;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$json$Json$Encode$string(a),
					$elm$json$Json$Encode$bool(b),
					$elm$json$Json$Encode$bool(c)
				]));
	});
var $author$project$Ports$Navigation$requestUrl = F3(
	function (href, isLocal, shouldOpenInNewWindow) {
		return $author$project$Ports$Navigation$navigationPortRequestUrl(
			_Utils_Tuple3(href, isLocal, shouldOpenInNewWindow));
	});
var $author$project$Pages$User$Profile$init = F4(
	function (_v0, user, shared, _v1) {
		var redirectCmd = function () {
			var _v2 = $author$project$Api$Data$toMaybe(shared.ZV);
			if (!_v2.$) {
				var practice = _v2.a;
				if ($author$project$Api$Practice$hasClinicalAccount(practice) && A2($author$project$Api$Practice$featureEnabled, 19, practice)) {
					var _v3 = $author$project$Api$Platform$User$One$identityProviderId(user);
					if (!_v3.$) {
						var ipId = _v3.a;
						return A3(
							$author$project$Ports$Navigation$requestUrl,
							$author$project$Spa$Generated$Route$toString(
								$author$project$Spa$Generated$Route$NewSettings__Team__TeamId_String__BasicInfo(
									{alX: ipId})),
							true,
							false);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				} else {
					return $elm$core$Platform$Cmd$none;
				}
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		}();
		var emailDisabled = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Practice$hasClinicalAccount,
				$author$project$Api$Data$toMaybe(shared.ZV)));
		return _Utils_Tuple2(
			{
				Gv: shared.Gv,
				Hz: emailDisabled,
				SD: $author$project$Utils$Form$init(
					$author$project$Pages$User$Profile$initFormFields(user)),
				b6: $author$project$Pages$User$Profile$initPhoneInput(
					$author$project$Api$Platform$User$One$phones(user)),
				vh: $author$project$Api$Data$NotAsked,
				ad0: user
			},
			redirectCmd);
	});
var $author$project$Pages$User$Profile$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$User$Profile$save = F2(
	function (model, shared) {
		var _v0 = model.vh;
		if (_v0.$ === 3) {
			return _Utils_update(
				shared,
				{ad0: model.vh});
		} else {
			return shared;
		}
	});
var $author$project$Pages$User$Profile$GotPhoneInputMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$User$Profile$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$User$Profile$GotPhoneInputMsg,
		$author$project$Components$PhoneInput$subscriptions(model.b6));
};
var $author$project$Pages$User$Profile$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var firstName = field.a;
				return _Utils_update(
					fields,
					{Sv: firstName});
			case 1:
				var lastName = field.a;
				return _Utils_update(
					fields,
					{VH: lastName});
			case 2:
				var email = field.a;
				return _Utils_update(
					fields,
					{Rj: email});
			default:
				var bool = field.a;
				return _Utils_update(
					fields,
					{J5: bool});
		}
	});
var $author$project$Pages$User$Profile$EmailValidation = 0;
var $author$project$Pages$User$Profile$TermsAcceptedValidation = 1;
var $author$project$Pages$User$Profile$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A3(
			$author$project$Utils$Validate$ifInvalidEmail,
			{aeT: false},
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.Rj;
				},
				$elm$core$Maybe$Just),
			_Utils_Tuple2(0, 'Please enter a valid email.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifFalse,
			function ($) {
				return $.J5;
			},
			_Utils_Tuple2(1, 'Please accept this platform\'s terms.'))
		]));
var $author$project$Pages$User$Profile$GotUpdatedUser = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Platform$User$update = F4(
	function (apiClient, fields, phones_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'user',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'first_name',
								$elm$json$Json$Encode$string(fields.Sv)),
								_Utils_Tuple2(
								'last_name',
								$elm$json$Json$Encode$string(fields.VH)),
								_Utils_Tuple2(
								'email',
								$elm$json$Json$Encode$string(fields.Rj)),
								_Utils_Tuple2(
								'terms_accepted',
								$elm$json$Json$Encode$bool(fields.J5)),
								_Utils_Tuple2(
								'phones',
								A2($elm$json$Json$Encode$list, $author$project$Api$Common$Phone$Shared$encode, phones_))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Platform$User$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Platform$User$userPath)));
	});
var $author$project$Pages$User$Profile$updateUser = F3(
	function (apiClient, formFields, phones) {
		return A4(
			$author$project$Api$Platform$User$update,
			apiClient,
			$rtfeldman$elm_validate$Validate$fromValid(formFields),
			A2($elm$core$List$map, $author$project$Utils$Phone$toRecord, phones),
			$author$project$Pages$User$Profile$GotUpdatedUser);
	});
var $author$project$Pages$User$Profile$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 3:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$User$Profile$formFieldsUpdate, field, model.SD);
				var validatedForm = function () {
					var _v1 = A2($author$project$Utils$Form$validate, $author$project$Pages$User$Profile$formFieldsValidator, newForm);
					if (!_v1.$) {
						var _v2 = _v1.a;
						var form = _v2.a;
						return form;
					} else {
						var form = _v1.a;
						return form;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{SD: validatedForm}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var _v3 = _Utils_Tuple2(
					A2($author$project$Utils$Form$validate, $author$project$Pages$User$Profile$formFieldsValidator, model.SD),
					$author$project$Components$PhoneInput$getPhones(model.b6));
				if (!_v3.a.$) {
					if (!_v3.b.$) {
						var _v4 = _v3.a.a;
						var newForm = _v4.a;
						var validFormFields = _v4.b;
						var phones = _v3.b.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{SD: newForm}),
							A3($author$project$Pages$User$Profile$updateUser, model.Gv, validFormFields, phones),
							_List_Nil);
					} else {
						var _v5 = _v3.a.a;
						var newForm = _v5.a;
						var _v6 = _v3.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{SD: newForm}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					var newForm = _v3.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{SD: newForm}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 2:
				var dataUser = msg.a;
				if (dataUser.$ === 3) {
					var user = dataUser.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								SD: $author$project$Utils$Form$init(
									$author$project$Pages$User$Profile$initFormFields(user)),
								b6: $author$project$Pages$User$Profile$initPhoneInput(
									$author$project$Api$Platform$User$One$phones(user)),
								vh: dataUser,
								ad0: user
							}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your profile has been updated')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(dataUser));
				}
			default:
				var subMsg = msg.a;
				var _v8 = A2($author$project$Components$PhoneInput$update, subMsg, model.b6);
				var updatedPhoneInput = _v8.a;
				var phoneCmd = _v8.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{b6: updatedPhoneInput}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$User$Profile$GotPhoneInputMsg, phoneCmd),
					_List_Nil);
		}
	});
var $author$project$Pages$User$Profile$UpdateUser = {$: 1};
var $author$project$Pages$User$Profile$Email = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$User$Profile$FirstName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$User$Profile$FormFieldUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$User$Profile$LastName = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$User$Profile$TermsAccepted = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$User$Profile$viewAcceptTerms = F2(
	function (user, form) {
		if ($author$project$Api$Platform$User$One$termsAccepted(user)) {
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Icon$check(
							_List_fromArray(
								[$author$project$Ui$Icon$success])),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Utils$Html$noBreakSpace,
									$elm$html$Html$text(' You agreed to this software platform\'s')
								])),
							A3(
							$author$project$Ui$Link$externalHref,
							$author$project$Utils$HintUrls$termsUrl,
							_List_fromArray(
								[$author$project$Ui$Link$targetBlank]),
							_List_fromArray(
								[
									$elm$html$Html$text(' Terms of Service.')
								]))
						]))
				]);
		} else {
			var _v0 = $author$project$Utils$Form$fields(form);
			var termsAccepted = _v0.J5;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Checkbox$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Checkbox$value(termsAccepted),
									$author$project$Ui$Form$Checkbox$required(true),
									$author$project$Ui$Form$Checkbox$onCheck(
									A2($elm$core$Basics$composeL, $author$project$Pages$User$Profile$FormFieldUpdated, $author$project$Pages$User$Profile$TermsAccepted))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('I agree to this software platform\'s'),
											A3(
											$author$project$Ui$Link$externalHref,
											$author$project$Utils$HintUrls$termsUrl,
											_List_fromArray(
												[$author$project$Ui$Link$targetBlank]),
											_List_fromArray(
												[
													$elm$html$Html$text(' Terms of Service.')
												]))
										]))
								])),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 1, form))
						]))
				]);
		}
	});
var $author$project$Pages$User$Profile$viewProfileFields = F4(
	function (user, form, phoneInput, emailDisabled) {
		var _v0 = $author$project$Utils$Form$fields(form);
		var firstName = _v0.Sv;
		var lastName = _v0.VH;
		var email = _v0.Rj;
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Name'),
						$author$project$Ui$Form$Group$labelSpanSm(4)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanSm(4)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$value(firstName),
												$author$project$Ui$Form$Input$placeholder('First'),
												$author$project$Ui$Form$Input$onInput(
												A2($elm$core$Basics$composeL, $author$project$Pages$User$Profile$FormFieldUpdated, $author$project$Pages$User$Profile$FirstName))
											]))
									])),
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanSm(4)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$value(lastName),
												$author$project$Ui$Form$Input$placeholder('Last'),
												$author$project$Ui$Form$Input$onInput(
												A2($elm$core$Basics$composeL, $author$project$Pages$User$Profile$FormFieldUpdated, $author$project$Pages$User$Profile$LastName))
											]))
									]))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Email'),
						$author$project$Ui$Form$Group$required(true),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(email),
								$author$project$Ui$Form$Input$withFeedback(
								$author$project$Utils$Form$validated(form)),
								$author$project$Ui$Form$Input$placeholder('email@example.com'),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Pages$User$Profile$FormFieldUpdated, $author$project$Pages$User$Profile$Email)),
								$author$project$Ui$Form$Input$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
								$author$project$Ui$Form$Input$errors(
								A2($author$project$Utils$Form$validationErrors, 0, form)),
								$author$project$Ui$Form$Input$disabled(emailDisabled)
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Phone'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Pages$User$Profile$GotPhoneInputMsg,
						$author$project$Components$PhoneInput$view(phoneInput))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label(''),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				A2($author$project$Pages$User$Profile$viewAcceptTerms, user, form))
			]);
	});
var $author$project$Pages$User$Profile$toPane = function (model) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Panel$title(
							_List_fromArray(
								[
									$elm$html$Html$text('Your account')
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$form,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$name('profileForm'),
									$elm$html$Html$Attributes$novalidate(true),
									$elm$html$Html$Attributes$autocomplete(true)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_Nil,
									A4($author$project$Pages$User$Profile$viewProfileFields, model.ad0, model.SD, model.b6, model.Hz))
								]))
						])),
					A2(
					$author$project$Ui$Panel$footer,
					_List_fromArray(
						[$author$project$Ui$Element$justifyCenter]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Update profile'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$submit,
									$author$project$Ui$Button$onClick($author$project$Pages$User$Profile$UpdateUser)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Update')
								]))
						]))
				]))
		]);
};
var $author$project$Pages$User$Profile$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(12)
							]),
						$author$project$Pages$User$Profile$toPane(model))
					]))
			]),
		ac9: 'Profile'
	};
};
var $author$project$Pages$User$Profile$page = $author$project$Spa$Page$applicationUser(
	{ah_: $author$project$Pages$User$Profile$init, aiq: $author$project$Pages$User$Profile$load, k8: $author$project$Pages$User$Profile$save, alO: $author$project$Pages$User$Profile$subscriptions, adT: $author$project$Pages$User$Profile$update, amo: $author$project$Pages$User$Profile$view});
var $author$project$Pages$User$Security$GotSessions = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$User$Security$GotTrustedDevices = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Platform$User$Session$listDefaults = {
	HM: $elm$core$Maybe$Nothing,
	ajJ: $author$project$Api$Pagination$init,
	alA: A3($author$project$Api$Sort$withDefault, 'created_at', 1, $author$project$Api$Sort$init)
};
var $author$project$Api$Platform$User$Session$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Platform$User$Session$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.HM;
				if (!_v0.$) {
					var filter = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'filter', filter)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$Platform$User$Session$sessionsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['sessions']),
	$author$project$Api$Platform$User$userPath);
var $author$project$Api$Platform$User$Session$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Platform$Session$One$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Platform$User$Session$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Platform$User$Session$sessionsPath)));
	});
var $author$project$Pages$User$Security$fetchSessions = F2(
	function (model, toMsg) {
		return A3(
			$author$project$Api$Platform$User$Session$list,
			model.Gv,
			function (d) {
				return _Utils_update(
					d,
					{ajJ: model.hB});
			},
			toMsg);
	});
var $author$project$Api$Platform$TrustedDevice$All$TrustedDevice = $elm$core$Basics$identity;
var $author$project$Api$Platform$TrustedDevice$Shared$TrustedDevice = $elm$core$Basics$identity;
var $author$project$Api$Platform$TrustedDevice$Shared$Record = F4(
	function (isExpired, trustedAt, trustedUntil, requestDetail) {
		return {UQ: isExpired, $A: requestDetail, adF: trustedAt, adG: trustedUntil};
	});
var $author$project$Api$Platform$TrustedDevice$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'request_detail',
	$elm$json$Json$Decode$nullable($author$project$Api$Common$RequestDetail$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'trusted_until',
		$elm_community$json_extra$Json$Decode$Extra$datetime,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'trusted_at',
			$elm_community$json_extra$Json$Decode$Extra$datetime,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'is_expired',
				$elm$json$Json$Decode$bool,
				$elm$json$Json$Decode$succeed($author$project$Api$Platform$TrustedDevice$Shared$Record)))));
var $author$project$Api$Platform$TrustedDevice$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$TrustedDevice$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Platform$TrustedDevice$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$TrustedDevice$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Platform$User$TrustedDevice$listDefaults = {
	ajJ: $author$project$Api$Pagination$init,
	alA: A3($author$project$Api$Sort$withDefault, 'created_at', 0, $author$project$Api$Sort$init)
};
var $author$project$Api$Platform$User$TrustedDevice$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Platform$User$TrustedDevice$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				$author$project$Api$Sort$toParams(options.alA),
				$author$project$Api$Pagination$toApiParams(options.ajJ)
			]));
};
var $author$project$Api$Platform$User$TrustedDevice$listPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['trusted_devices']),
	$author$project$Api$Platform$User$userPath);
var $author$project$Api$Platform$User$TrustedDevice$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Platform$TrustedDevice$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Platform$User$TrustedDevice$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Platform$User$TrustedDevice$listPath)));
	});
var $author$project$Pages$User$Security$fetchTrustedDevices = F2(
	function (model, toMsg) {
		return A3(
			$author$project$Api$Platform$User$TrustedDevice$list,
			model.Gv,
			function (d) {
				return _Utils_update(
					d,
					{ajJ: model.h$});
			},
			toMsg);
	});
var $author$project$Pages$User$Security$initPasswordFormFields = {aiX: '', ti: '', ajR: '', oT: $elm$core$Maybe$Nothing};
var $author$project$Pages$User$Security$init = F4(
	function (session, user, shared, _v0) {
		var model = {
			Gv: shared.Gv,
			jo: false,
			g8: $author$project$Utils$Form$init($author$project$Pages$User$Security$initPasswordFormFields),
			oU: $author$project$Api$Data$NotAsked,
			aa4: session,
			pY: $author$project$Api$Data$Loading,
			hB: $author$project$Api$Pagination$init,
			J7: shared.J7,
			qH: $author$project$Api$Data$Loading,
			h$: $author$project$Api$Pagination$init,
			ad0: user
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Pages$User$Security$fetchSessions, model, $author$project$Pages$User$Security$GotSessions),
						A2($author$project$Pages$User$Security$fetchTrustedDevices, model, $author$project$Pages$User$Security$GotTrustedDevices)
					])));
	});
var $author$project$Pages$User$Security$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$User$Security$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$User$Security$DisableMfaHiConfirmClosed = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$User$Security$PasswordFormFieldUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$User$Security$PasswordStrengthCheck = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$User$Security$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ports$PasswordStrength$checked(
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Pages$User$Security$PasswordFormFieldUpdated, $author$project$Pages$User$Security$PasswordStrengthCheck),
					$elm$core$Maybe$Just)),
				model.jo ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$User$Security$DisableMfaHiConfirmClosed) : $elm$core$Platform$Sub$none
			]));
};
var $author$project$Pages$User$Security$GotMfaDestroy = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Platform$Mfa$delete = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Platform$Mfa$mfaPath));
	});
var $author$project$Pages$User$Security$passwordFormFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{ajR: string});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{aiX: string, oT: $elm$core$Maybe$Nothing});
			case 2:
				var string = field.a;
				return _Utils_update(
					fields,
					{ti: string});
			default:
				var check = field.a;
				return _Utils_update(
					fields,
					{oT: check});
		}
	});
var $author$project$Pages$User$Security$NewPasswordValidation = 1;
var $author$project$Pages$User$Security$PasswordValidation = 0;
var $author$project$Pages$User$Security$NewPasswordConfirmationValidation = 2;
var $author$project$Pages$User$Security$validateNewPasswordConfirmation = function (form) {
	return $elm$core$String$isEmpty(form.aiX) ? _List_Nil : (_Utils_eq(form.aiX, form.ti) ? _List_Nil : _List_fromArray(
		[
			_Utils_Tuple2(2, 'The new password and its confirmation don\'t match')
		]));
};
var $author$project$Pages$User$Security$passwordFormFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.ajR;
			},
			_Utils_Tuple2(0, 'Please enter your current password.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.aiX;
			},
			_Utils_Tuple2(1, 'Please enter your new password.')),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$User$Security$validateNewPasswordConfirmation),
			A2(
			$rtfeldman$elm_validate$Validate$ifFalse,
			function (subject) {
				return A2(
					$elm$core$Maybe$withDefault,
					false,
					A2($elm$core$Maybe$map, $author$project$Utils$PasswordStrength$isUnguessable, subject.oT));
			},
			_Utils_Tuple2(1, 'Please enter a secure password.'))
		]));
var $author$project$Pages$User$Security$GotPasswordUpdate = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Platform$User$Password$passwordPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['password']),
	$author$project$Api$Platform$User$userPath);
var $author$project$Api$Platform$User$Password$update = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'password',
					$elm$json$Json$Encode$string(fields.ajR)),
					_Utils_Tuple2(
					'new_password',
					$elm$json$Json$Encode$string(fields.aiX))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Platform$User$Password$passwordPath)));
	});
var $author$project$Pages$User$Security$updatePassword = F2(
	function (apiClient, passwordFormFields) {
		return A3(
			$author$project$Api$Platform$User$Password$update,
			apiClient,
			$rtfeldman$elm_validate$Validate$fromValid(passwordFormFields),
			$author$project$Pages$User$Security$GotPasswordUpdate);
	});
var $author$project$Pages$User$Security$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var _v1 = _Utils_Tuple2(
					A3($author$project$Utils$Form$update, $author$project$Pages$User$Security$passwordFormFieldsUpdate, field, model.g8),
					function () {
						if (field.$ === 1) {
							var newPassword = field.a;
							return $author$project$Ports$PasswordStrength$check(newPassword);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
				var newForm = _v1.a;
				var cmd = _v1.b;
				var validatedForm = function () {
					var _v3 = A2($author$project$Utils$Form$validate, $author$project$Pages$User$Security$passwordFormFieldsValidator, newForm);
					if (!_v3.$) {
						var _v4 = _v3.a;
						var form = _v4.a;
						return form;
					} else {
						var form = _v3.a;
						return form;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{g8: validatedForm}),
					cmd,
					_List_Nil);
			case 1:
				var _v5 = A2($author$project$Utils$Form$validate, $author$project$Pages$User$Security$passwordFormFieldsValidator, model.g8);
				if (!_v5.$) {
					var _v6 = _v5.a;
					var newForm = _v6.a;
					var validFormFields = _v6.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{g8: newForm, oU: $author$project$Api$Data$Loading}),
						A2($author$project$Pages$User$Security$updatePassword, model.Gv, validFormFields),
						_List_Nil);
				} else {
					var newForm = _v5.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{g8: newForm}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 2:
				var passwordUpdate = msg.a;
				if (passwordUpdate.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{oU: passwordUpdate}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your password has been updated')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{oU: passwordUpdate}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(passwordUpdate));
				}
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{jo: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var confirmed = msg.a;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{jo: false}),
					A2($author$project$Api$Platform$Mfa$delete, model.Gv, $author$project$Pages$User$Security$GotMfaDestroy),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{jo: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var dataMfa = msg.a;
				if (dataMfa.$ === 3) {
					return _Utils_Tuple3(
						model,
						$author$project$Ports$Session$logout(
							{aku: true}),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Multi-factor authentication has been disabled.')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(dataMfa));
				}
			case 6:
				var dataSessions = msg.a;
				if (dataSessions.$ === 3) {
					var headers = dataSessions.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								pY: dataSessions,
								hB: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.hB)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{pY: dataSessions}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$reportDecodeError(dataSessions));
				}
			case 7:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.hB);
				var newModel = _Utils_update(
					model,
					{hB: pagination});
				return _Utils_Tuple3(
					newModel,
					A2($author$project$Pages$User$Security$fetchSessions, newModel, $author$project$Pages$User$Security$GotSessions),
					_List_Nil);
			case 8:
				var dataTrustedDevices = msg.a;
				if (dataTrustedDevices.$ === 3) {
					var headers = dataTrustedDevices.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								qH: dataTrustedDevices,
								h$: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.h$)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{qH: dataTrustedDevices}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$reportDecodeError(dataTrustedDevices));
				}
			case 9:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.h$);
				var newModel = _Utils_update(
					model,
					{h$: pagination});
				return _Utils_Tuple3(
					newModel,
					A2($author$project$Pages$User$Security$fetchTrustedDevices, newModel, $author$project$Pages$User$Security$GotTrustedDevices),
					_List_Nil);
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Pages$User$Security$EnableMfaClicked = {$: 10};
var $author$project$Pages$User$Security$OpenDisableMfaHiConfirm = {$: 3};
var $author$project$Pages$User$Security$TrustedDevicesPaginationMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Platform$User$Shared$mfaStatus = function (_v0) {
	var record = _v0;
	return record.W6;
};
var $author$project$Api$Platform$User$One$mfaStatus = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Platform$User$Shared$mfaStatus(shared);
};
var $author$project$Api$Common$RequestDetail$Shared$clientDescription = function (requestDetail) {
	return A2(
		$elm$core$String$join,
		' on ',
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				'N/A',
				$author$project$Api$Common$RequestDetail$Shared$clientName(requestDetail)),
				A2(
				$elm$core$Maybe$withDefault,
				'N/A',
				$author$project$Api$Common$RequestDetail$Shared$osName(requestDetail)) + (' ' + A2(
				$elm$core$Maybe$withDefault,
				'N/A',
				$author$project$Api$Common$RequestDetail$Shared$deviceType(requestDetail)))
			]));
};
var $author$project$Api$Platform$TrustedDevice$Shared$isExpired = function (_v0) {
	var record = _v0;
	return record.UQ;
};
var $author$project$Api$Platform$TrustedDevice$All$isExpired = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Platform$TrustedDevice$Shared$isExpired(shared);
};
var $author$project$Api$Platform$TrustedDevice$Shared$requestDetail = function (_v0) {
	var record = _v0;
	return record.$A;
};
var $author$project$Api$Platform$TrustedDevice$All$requestDetail = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Platform$TrustedDevice$Shared$requestDetail(shared);
};
var $author$project$Api$Platform$TrustedDevice$Shared$trustedAt = function (_v0) {
	var record = _v0;
	return record.adF;
};
var $author$project$Api$Platform$TrustedDevice$All$trustedAt = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Platform$TrustedDevice$Shared$trustedAt(shared);
};
var $author$project$Api$Platform$TrustedDevice$Shared$trustedUntil = function (_v0) {
	var record = _v0;
	return record.adG;
};
var $author$project$Api$Platform$TrustedDevice$All$trustedUntil = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Platform$TrustedDevice$Shared$trustedUntil(shared);
};
var $author$project$Pages$User$Security$viewTrustedDevice = F2(
	function (timeFormatter, trustedDevice) {
		var style = $author$project$Api$Platform$TrustedDevice$All$isExpired(trustedDevice) ? 3 : 0;
		return A2(
			$author$project$Ui$ListGroup$item,
			_List_fromArray(
				[
					$author$project$Ui$ListGroup$style(style)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'N/A',
								A2(
									$elm$core$Maybe$map,
									$author$project$Api$Common$RequestDetail$Shared$clientDescription,
									$author$project$Api$Platform$TrustedDevice$All$requestDetail(trustedDevice)))),
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									'Trusted from ' + (A2(
										timeFormatter,
										0,
										$author$project$Api$Platform$TrustedDevice$All$trustedAt(trustedDevice)) + (' to ' + A2(
										timeFormatter,
										0,
										$author$project$Api$Platform$TrustedDevice$All$trustedUntil(trustedDevice)))))
								]))
						]))
				]));
	});
var $author$project$Pages$User$Security$viewTrustedDeviceSkeleton = A2(
	$author$project$Ui$ListGroup$item,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$spaceBetween]),
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$spanFromText('Chrome on Mac')
						])),
					$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$spanFromText('Trusted on mm/dd/YYYY at ll:MM pp')
						]))
				]))
		]));
var $author$project$Pages$User$Security$viewMfaStatus = function (model) {
	return A2(
		$elm$html$Html$form,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				$author$project$Ui$Typography$headingSm(
				_List_fromArray(
					[
						$elm$html$Html$text('Multi-factor authentication (MFA)')
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Status'),
						$author$project$Ui$Form$Group$labelSpan(4),
						$author$project$Ui$Form$Group$inputSpan(8)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								function () {
								var _v0 = $author$project$Api$Platform$User$One$mfaStatus(model.ad0);
								if (!_v0) {
									return A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Ui$Icon$check(
												_List_fromArray(
													[$author$project$Ui$Icon$success])),
												$author$project$Utils$Html$noBreakSpace,
												$elm$html$Html$text('Enabled '),
												function () {
												var label = $author$project$Api$Platform$User$One$requiresMfa(model.ad0) ? 'Reset MFA device' : 'Disable';
												return A3(
													$author$project$Ui$Button$view,
													{mm: label},
													_List_fromArray(
														[
															$author$project$Ui$Button$link,
															$author$project$Ui$Button$onClick($author$project$Pages$User$Security$OpenDisableMfaHiConfirm)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(label)
														]));
											}()
											]));
								} else {
									return A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Ui$Icon$cross(
												_List_fromArray(
													[$author$project$Ui$Icon$danger])),
												$author$project$Utils$Html$noBreakSpace,
												$elm$html$Html$text('Disabled'),
												$author$project$Utils$Html$noBreakSpace,
												A3(
												$author$project$Ui$Link$route,
												$author$project$Spa$Generated$Route$User__Mfa,
												_List_fromArray(
													[
														$author$project$Ui$Link$onClick($author$project$Pages$User$Security$EnableMfaClicked)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Enable Now')
													]))
											]));
								}
							}()
							]))
					])),
				function () {
				var _v1 = $author$project$Api$Platform$User$One$mfaStatus(model.ad0);
				if (!_v1) {
					return A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Trusted devices'),
								$author$project$Ui$Form$Group$labelSpan(4),
								$author$project$Ui$Form$Group$inputSpan(8)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Static$view,
								_List_Nil,
								_List_fromArray(
									[
										function () {
										var _v2 = model.qH;
										if (_v2.$ === 3) {
											var trustedDevices = _v2.a;
											return A2(
												$author$project$Ui$ListGroup$view,
												_List_Nil,
												A2(
													$elm$core$List$map,
													$author$project$Pages$User$Security$viewTrustedDevice(model.J7),
													trustedDevices));
										} else {
											return A2(
												$author$project$Ui$ListGroup$view,
												_List_Nil,
												A2($elm$core$List$repeat, 10, $author$project$Pages$User$Security$viewTrustedDeviceSkeleton));
										}
									}(),
										A2(
										$elm$html$Html$map,
										$author$project$Pages$User$Security$TrustedDevicesPaginationMsg,
										A2(
											$author$project$Api$Pagination$view,
											_List_fromArray(
												[
													$author$project$Ui$Pagination$List$hideTotalItemsForSinglePage,
													$author$project$Ui$Pagination$List$loading(
													!$author$project$Api$Data$isSuccess(model.qH))
												]),
											model.h$))
									]))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]));
};
var $author$project$Pages$User$Security$NewPassword = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$User$Security$NewPasswordConfirmation = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$User$Security$Password = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$User$Security$UpdatePassword = {$: 1};
var $author$project$Pages$User$Security$viewPasswordForm = F2(
	function (passwordUpdate, passwordForm) {
		var _v0 = $author$project$Utils$Form$fields(passwordForm);
		var password = _v0.ajR;
		var newPassword = _v0.aiX;
		var newPasswordConfirmation = _v0.ti;
		var passwordStrengthCheck = _v0.oT;
		return A2(
			$elm$html$Html$form,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$novalidate(true),
					$elm$html$Html$Attributes$autocomplete(true)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Password')
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('Current Password'),
							$author$project$Ui$Form$Group$required(true),
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(password),
									$author$project$Ui$Form$Input$phi(true),
									$author$project$Ui$Form$Input$password,
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$User$Security$PasswordFormFieldUpdated, $author$project$Pages$User$Security$Password)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, passwordForm)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 0, passwordForm))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('New Password'),
							$author$project$Ui$Form$Group$required(true),
							$author$project$Ui$Form$Group$labelSpanSm(4),
							$author$project$Ui$Form$Group$inputSpanSm(8)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$PasswordInput$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$PasswordInput$value(newPassword),
									$author$project$Ui$Form$PasswordInput$strengthCheck(passwordStrengthCheck),
									$author$project$Ui$Form$PasswordInput$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$User$Security$PasswordFormFieldUpdated, $author$project$Pages$User$Security$NewPassword)),
									$author$project$Ui$Form$PasswordInput$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 1, passwordForm)),
									$author$project$Ui$Form$PasswordInput$errors(
									A2($author$project$Utils$Form$validationErrors, 1, passwordForm))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('New Password Confirmation'),
							$author$project$Ui$Form$Group$required(true),
							$author$project$Ui$Form$Group$labelSpanSm(4),
							$author$project$Ui$Form$Group$inputSpanSm(8)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(newPasswordConfirmation),
									$author$project$Ui$Form$Input$phi(true),
									$author$project$Ui$Form$Input$password,
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$User$Security$PasswordFormFieldUpdated, $author$project$Pages$User$Security$NewPasswordConfirmation)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 2, passwordForm)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 2, passwordForm))
								]))
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$textCenter, $author$project$Ui$Element$mt4]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Update security settings'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$onClick($author$project$Pages$User$Security$UpdatePassword),
									$author$project$Ui$Button$loading(
									_Utils_eq(passwordUpdate, $author$project$Api$Data$Loading))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Update')
								]))
						]))
				]));
	});
var $author$project$Pages$User$Security$SessionsPaginationMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Common$RequestDetail$Shared$countryCode = function (_v0) {
	var record = _v0;
	return record.OL;
};
var $author$project$Api$Platform$Session$One$createdAt = function (_v0) {
	var record = _v0;
	return record.O1;
};
var $author$project$Api$Platform$Session$One$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Common$RequestDetail$Shared$locationDescription = function (_v0) {
	var record = _v0;
	var _v1 = _Utils_Tuple2(record.uP, record.rK);
	if (!_v1.a.$) {
		if (!_v1.b.$) {
			var state_ = _v1.a.a;
			var country_ = _v1.b.a;
			return state_ + (' - ' + country_);
		} else {
			var state_ = _v1.a.a;
			var _v2 = _v1.b;
			return state_;
		}
	} else {
		if (!_v1.b.$) {
			var _v3 = _v1.a;
			var country_ = _v1.b.a;
			return country_;
		} else {
			var _v4 = _v1.a;
			var _v5 = _v1.b;
			return 'N/A';
		}
	}
};
var $author$project$Api$Platform$Session$One$requestDetail = function (_v0) {
	var record = _v0;
	return record.$A;
};
var $author$project$Ui$CountryFlag$flagClass = function (code) {
	return 'fi-' + $elm$core$String$toLower(code);
};
var $author$project$Ui$CountryFlag$view = F2(
	function (_v0, code) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fi'),
					$elm$html$Html$Attributes$class(
					$author$project$Ui$CountryFlag$flagClass(code))
				]),
			_List_Nil);
	});
var $author$project$Pages$User$Security$viewSession = F3(
	function (currentSession, timeFormatter, session) {
		var options = _Utils_eq(
			$author$project$Api$Platform$Session$One$id(currentSession),
			$author$project$Api$Platform$Session$One$id(session)) ? _List_fromArray(
			[
				$author$project$Ui$ListGroup$style(1)
			]) : _List_Nil;
		return A2(
			$author$project$Ui$ListGroup$item,
			options,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Started at: ')
												])),
											$elm$html$Html$text(
											A2(
												timeFormatter,
												0,
												$author$project$Api$Platform$Session$One$createdAt(session)))
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Location: ')
												])),
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'N/A',
												A2(
													$elm$core$Maybe$map,
													$author$project$Api$Common$RequestDetail$Shared$locationDescription,
													$author$project$Api$Platform$Session$One$requestDetail(session)))),
											$author$project$Utils$Html$noBreakSpace,
											function () {
											var _v0 = A2(
												$elm$core$Maybe$andThen,
												$author$project$Api$Common$RequestDetail$Shared$countryCode,
												$author$project$Api$Platform$Session$One$requestDetail(session));
											if (!_v0.$) {
												var countryCode = _v0.a;
												return A2($author$project$Ui$CountryFlag$view, _List_Nil, countryCode);
											} else {
												return $author$project$Utils$Html$empty;
											}
										}()
										]))
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Device: ')
												])),
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'N/A',
												A2(
													$elm$core$Maybe$map,
													$author$project$Api$Common$RequestDetail$Shared$clientDescription,
													$author$project$Api$Platform$Session$One$requestDetail(session))))
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Role: ')
												])),
											$elm$html$Html$text(
											$author$project$Formatters$String$titleize(
												$author$project$Formatters$String$humanize(
													$author$project$Api$Platform$Session$One$role(session))))
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('IP: ')
												])),
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'N/A',
												A2(
													$elm$core$Maybe$andThen,
													$author$project$Api$Common$RequestDetail$Shared$ip,
													$author$project$Api$Platform$Session$One$requestDetail(session))))
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$User$Security$viewSessionSkeleton = A2(
	$author$project$Ui$ListGroup$item,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$spaceBetween]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$block,
									$author$project$Ui$Skeleton$spanFromText('Started at: mm/dd/YYYY at ll:MM pp')
								])),
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$block,
									$author$project$Ui$Skeleton$spanFromText('Location: Montevideo')
								]))
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$block,
									$author$project$Ui$Skeleton$spanFromText('Authenticated by: SSO')
								])),
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$block,
									$author$project$Ui$Skeleton$spanFromText('Device: Chrome on Mac desktop')
								])),
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$block,
									$author$project$Ui$Skeleton$spanFromText('Role: Practice Admin')
								])),
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$block,
									$author$project$Ui$Skeleton$spanFromText('IP: 123.456.78.900')
								]))
						]))
				]))
		]));
var $author$project$Pages$User$Security$viewSessions = function (model) {
	return A2(
		$elm$html$Html$form,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				$author$project$Ui$Typography$headingSm(
				_List_fromArray(
					[
						$elm$html$Html$text('Sessions')
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								function () {
								var _v0 = model.pY;
								if (_v0.$ === 3) {
									var sessions = _v0.a;
									return A2(
										$author$project$Ui$ListGroup$view,
										_List_Nil,
										A2(
											$elm$core$List$map,
											A2($author$project$Pages$User$Security$viewSession, model.aa4, model.J7),
											sessions));
								} else {
									return A2(
										$author$project$Ui$ListGroup$view,
										_List_Nil,
										A2($elm$core$List$repeat, 10, $author$project$Pages$User$Security$viewSessionSkeleton));
								}
							}(),
								A2(
								$elm$html$Html$map,
								$author$project$Pages$User$Security$SessionsPaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$hideTotalItemsForSinglePage,
											$author$project$Ui$Pagination$List$loading(
											!$author$project$Api$Data$isSuccess(model.pY))
										]),
									model.hB))
							]))
					]))
			]));
};
var $author$project$Pages$User$Security$toPane = function (model) {
	return _List_fromArray(
		[
			model.jo ? A2(
			$author$project$Components$HiConfirm$modal,
			$author$project$Pages$User$Security$DisableMfaHiConfirmClosed,
			_List_fromArray(
				[
					$author$project$Components$HiConfirm$verb('disable'),
					$author$project$Components$HiConfirm$noun('MFA'),
					$author$project$Components$HiConfirm$customMessage(
					_List_fromArray(
						[
							$elm$html$Html$text('Disabling MFA will prevent you from accessing practices that enforce its use. You will be logged out and will have to login again.')
						]))
				])) : $author$project$Utils$Html$empty,
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Panel$title(
							_List_fromArray(
								[
									$elm$html$Html$text('Security')
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Pages$User$Security$viewPasswordForm, model.oU, model.g8),
							$author$project$Pages$User$Security$viewMfaStatus(model),
							$author$project$Pages$User$Security$viewSessions(model)
						]))
				]))
		]);
};
var $author$project$Pages$User$Security$view = function (model) {
	return {
		fO: _List_fromArray(
			[
				A2(
				$author$project$Ui$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$column,
						_List_fromArray(
							[
								$author$project$Ui$Grid$spanMd(12)
							]),
						$author$project$Pages$User$Security$toPane(model))
					]))
			]),
		ac9: 'Profile | Security'
	};
};
var $author$project$Pages$User$Security$page = $author$project$Spa$Page$applicationUser(
	{ah_: $author$project$Pages$User$Security$init, aiq: $author$project$Pages$User$Security$load, k8: $author$project$Pages$User$Security$save, alO: $author$project$Pages$User$Security$subscriptions, adT: $author$project$Pages$User$Security$update, amo: $author$project$Pages$User$Security$view});
var $author$project$Spa$Url$toQueryDict = function (queryString) {
	return $elm$core$Dict$fromList(
		$author$project$Spa$Url$toQuery(queryString));
};
var $author$project$Spa$Url$create = F2(
	function (params, url) {
		return {
			YL: params,
			DE: A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Dict$empty,
				A2($elm$core$Maybe$map, $author$project$Spa$Url$toQueryDict, url.DE)),
			akq: url
		};
	});
var $author$project$Spa$Document$map = F2(
	function (fn, doc) {
		return {
			fO: A2(
				$elm$core$List$map,
				$elm$html$Html$map(fn),
				doc.fO),
			ac9: doc.ac9
		};
	});
var $author$project$Spa$Generated$Pages$mapFirstAndSecond = F3(
	function (mapFirst, mapSecond, _v0) {
		var first = _v0.a;
		var second = _v0.b;
		var third = _v0.c;
		return _Utils_Tuple3(
			mapFirst(first),
			mapSecond(second),
			third);
	});
var $author$project$Spa$Generated$Pages$upgrade = F3(
	function (toModel, toMsg, page) {
		var update_ = F2(
			function (msg, model) {
				return A3(
					$author$project$Spa$Generated$Pages$mapFirstAndSecond,
					toModel,
					$elm$core$Platform$Cmd$map(toMsg),
					A2(page.adT, msg, model));
			});
		var load_ = F2(
			function (model, shared) {
				return A3(
					$author$project$Spa$Generated$Pages$mapFirstAndSecond,
					toModel,
					$elm$core$Platform$Cmd$map(toMsg),
					A2(page.aiq, shared, model));
			});
		var init_ = F2(
			function (params, shared) {
				return A3(
					$author$project$Spa$Generated$Pages$mapFirstAndSecond,
					toModel,
					$elm$core$Platform$Cmd$map(toMsg),
					A2(
						page.ah_,
						shared,
						A2($author$project$Spa$Url$create, params, shared.adY)));
			});
		var bundle_ = function (model) {
			return {
				aiq: function (_v0) {
					return load_(model);
				},
				k8: function (_v1) {
					return page.k8(model);
				},
				alO: function (_v2) {
					return A2(
						$elm$core$Platform$Sub$map,
						toMsg,
						page.alO(model));
				},
				amo: function (_v3) {
					return A2(
						$author$project$Spa$Document$map,
						toMsg,
						page.amo(model));
				}
			};
		};
		return {a: bundle_, ah_: init_, adT: update_};
	});
var $author$project$Spa$Generated$Pages$pages = {
	vx: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Account__Complete__Model, $author$project$Spa$Generated$Pages$Account__Complete__Msg, $author$project$Pages$Account$Complete$page),
	vF: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__AdvanceBilling__Model, $author$project$Spa$Generated$Pages$Admin__AdvanceBilling__Msg, $author$project$Pages$Admin$AdvanceBilling$page),
	vG: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Athenahealth__Fields__Model, $author$project$Spa$Generated$Pages$Admin__Athenahealth__Fields__Msg, $author$project$Pages$Admin$Athenahealth$Fields$page),
	vH: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Athenahealth__Link__Model, $author$project$Spa$Generated$Pages$Admin__Athenahealth__Link__Msg, $author$project$Pages$Admin$Athenahealth$Link$page),
	vI: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Athenahealth__Locations__Model, $author$project$Spa$Generated$Pages$Admin__Athenahealth__Locations__Msg, $author$project$Pages$Admin$Athenahealth$Locations$page),
	vJ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Athenahealth__Overview__Model, $author$project$Spa$Generated$Pages$Admin__Athenahealth__Overview__Msg, $author$project$Pages$Admin$Athenahealth$Overview$page),
	vK: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Athenahealth__Providers__Model, $author$project$Spa$Generated$Pages$Admin__Athenahealth__Providers__Msg, $author$project$Pages$Admin$Athenahealth$Providers$page),
	vL: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Athenahealth__Top__Model, $author$project$Spa$Generated$Pages$Admin__Athenahealth__Top__Msg, $author$project$Pages$Admin$Athenahealth$Top$page),
	vM: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Billing__Model, $author$project$Spa$Generated$Pages$Admin__Billing__Msg, $author$project$Pages$Admin$Billing$page),
	vN: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Billing__PracticeInvoices__Id_String__Model, $author$project$Spa$Generated$Pages$Admin__Billing__PracticeInvoices__Id_String__Msg, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$page),
	vO: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__CancellationReasons__Model, $author$project$Spa$Generated$Pages$Admin__CancellationReasons__Msg, $author$project$Pages$Admin$CancellationReasons$page),
	vP: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__CardReaders__Model, $author$project$Spa$Generated$Pages$Admin__CardReaders__Msg, $author$project$Pages$Admin$CardReaders$page),
	vQ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Categories__Model, $author$project$Spa$Generated$Pages$Admin__Categories__Msg, $author$project$Pages$Admin$Categories$page),
	vR: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__ChargeItems__Id_String__Model, $author$project$Spa$Generated$Pages$Admin__ChargeItems__Id_String__Msg, $author$project$Pages$Admin$ChargeItems$Id_String$page),
	vS: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__ChargeItems__New__Model, $author$project$Spa$Generated$Pages$Admin__ChargeItems__New__Msg, $author$project$Pages$Admin$ChargeItems$New$page),
	vT: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__ChargeItems__Top__Model, $author$project$Spa$Generated$Pages$Admin__ChargeItems__Top__Msg, $author$project$Pages$Admin$ChargeItems$Top$page),
	vU: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__ChargeItems__Upload__Model, $author$project$Spa$Generated$Pages$Admin__ChargeItems__Upload__Msg, $author$project$Pages$Admin$ChargeItems$Upload$page),
	vV: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Commissions__Model, $author$project$Spa$Generated$Pages$Admin__Commissions__Msg, $author$project$Pages$Admin$Commissions$page),
	vW: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__CompanyPlans__Id_String__Model, $author$project$Spa$Generated$Pages$Admin__CompanyPlans__Id_String__Msg, $author$project$Pages$Admin$CompanyPlans$Id_String$page),
	vX: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__CompanyPlans__New__Model, $author$project$Spa$Generated$Pages$Admin__CompanyPlans__New__Msg, $author$project$Pages$Admin$CompanyPlans$New$page),
	vY: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__CompanyPlans__Top__Model, $author$project$Spa$Generated$Pages$Admin__CompanyPlans__Top__Msg, $author$project$Pages$Admin$CompanyPlans$Top$page),
	vZ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Coupons__Model, $author$project$Spa$Generated$Pages$Admin__Coupons__Msg, $author$project$Pages$Admin$Coupons$page),
	v_: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__CoveragePlans__Id_String__Model, $author$project$Spa$Generated$Pages$Admin__CoveragePlans__Id_String__Msg, $author$project$Pages$Admin$CoveragePlans$Id_String$page),
	v$: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__CoveragePlans__New__Model, $author$project$Spa$Generated$Pages$Admin__CoveragePlans__New__Msg, $author$project$Pages$Admin$CoveragePlans$New$page),
	v0: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__CoveragePlans__Top__Model, $author$project$Spa$Generated$Pages$Admin__CoveragePlans__Top__Msg, $author$project$Pages$Admin$CoveragePlans$Top$page),
	v1: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__CreditCategories__Model, $author$project$Spa$Generated$Pages$Admin__CreditCategories__Msg, $author$project$Pages$Admin$CreditCategories$page),
	v2: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Credits__Upload__Model, $author$project$Spa$Generated$Pages$Admin__Credits__Upload__Msg, $author$project$Pages$Admin$Credits$Upload$page),
	v3: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__DataExportSettings__Id_String__Model, $author$project$Spa$Generated$Pages$Admin__DataExportSettings__Id_String__Msg, $author$project$Pages$Admin$DataExportSettings$Id_String$page),
	v4: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__DataExportSettings__New__Model, $author$project$Spa$Generated$Pages$Admin__DataExportSettings__New__Msg, $author$project$Pages$Admin$DataExportSettings$New$page),
	v5: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__DataExportSettings__Top__Model, $author$project$Spa$Generated$Pages$Admin__DataExportSettings__Top__Msg, $author$project$Pages$Admin$DataExportSettings$Top$page),
	v6: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__DataExport__Id_String__Model, $author$project$Spa$Generated$Pages$Admin__DataExport__Id_String__Msg, $author$project$Pages$Admin$DataExport$Id_String$page),
	v7: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__DataExport__Top__Model, $author$project$Spa$Generated$Pages$Admin__DataExport__Top__Msg, $author$project$Pages$Admin$DataExport$Top$page),
	v8: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Developers__ApiKeys__Model, $author$project$Spa$Generated$Pages$Admin__Developers__ApiKeys__Msg, $author$project$Pages$Admin$Developers$ApiKeys$page),
	v9: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Developers__App__Model, $author$project$Spa$Generated$Pages$Admin__Developers__App__Msg, $author$project$Pages$Admin$Developers$App$page),
	wa: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Developers__GetStarted__Model, $author$project$Spa$Generated$Pages$Admin__Developers__GetStarted__Msg, $author$project$Pages$Admin$Developers$GetStarted$page),
	wb: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Developers__Hinter__Model, $author$project$Spa$Generated$Pages$Admin__Developers__Hinter__Msg, $author$project$Pages$Admin$Developers$Hinter$page),
	wc: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Developers__Sandboxes__Model, $author$project$Spa$Generated$Pages$Admin__Developers__Sandboxes__Msg, $author$project$Pages$Admin$Developers$Sandboxes$page),
	wd: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Developers__WebhookEndpoints__Model, $author$project$Spa$Generated$Pages$Admin__Developers__WebhookEndpoints__Msg, $author$project$Pages$Admin$Developers$WebhookEndpoints$page),
	we: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Documents__Id_String__Model, $author$project$Spa$Generated$Pages$Admin__Documents__Id_String__Msg, $author$project$Pages$Admin$Documents$Id_String$page),
	wf: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Documents__New__Model, $author$project$Spa$Generated$Pages$Admin__Documents__New__Msg, $author$project$Pages$Admin$Documents$New$page),
	wg: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Documents__Top__Model, $author$project$Spa$Generated$Pages$Admin__Documents__Top__Msg, $author$project$Pages$Admin$Documents$Top$page),
	wh: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__ElationLegacy__Model, $author$project$Spa$Generated$Pages$Admin__ElationLegacy__Msg, $author$project$Pages$Admin$ElationLegacy$page),
	wi: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Elation__Link__Model, $author$project$Spa$Generated$Pages$Admin__Elation__Link__Msg, $author$project$Pages$Admin$Elation$Link$page),
	wj: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Elation__Overview__Model, $author$project$Spa$Generated$Pages$Admin__Elation__Overview__Msg, $author$project$Pages$Admin$Elation$Overview$page),
	wk: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Elation__Providers__Model, $author$project$Spa$Generated$Pages$Admin__Elation__Providers__Msg, $author$project$Pages$Admin$Elation$Providers$page),
	wl: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Elation__Top__Model, $author$project$Spa$Generated$Pages$Admin__Elation__Top__Msg, $author$project$Pages$Admin$Elation$Top$page),
	wm: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Features__Model, $author$project$Spa$Generated$Pages$Admin__Features__Msg, $author$project$Pages$Admin$Features$page),
	wn: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__HipaaAuthorizations__Model, $author$project$Spa$Generated$Pages$Admin__HipaaAuthorizations__Msg, $author$project$Pages$Admin$HipaaAuthorizations$page),
	wo: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Integrations__Slug_String__Model, $author$project$Spa$Generated$Pages$Admin__Integrations__Slug_String__Msg, $author$project$Pages$Admin$Integrations$Slug_String$page),
	wp: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__InternalSettings__Model, $author$project$Spa$Generated$Pages$Admin__InternalSettings__Msg, $author$project$Pages$Admin$InternalSettings$page),
	wq: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__InvoiceSettings__Model, $author$project$Spa$Generated$Pages$Admin__InvoiceSettings__Msg, $author$project$Pages$Admin$InvoiceSettings$page),
	wr: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__LeadSources__Model, $author$project$Spa$Generated$Pages$Admin__LeadSources__Msg, $author$project$Pages$Admin$LeadSources$page),
	ws: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Locations__Model, $author$project$Spa$Generated$Pages$Admin__Locations__Msg, $author$project$Pages$Admin$Locations$page),
	wt: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Mailgun__Model, $author$project$Spa$Generated$Pages$Admin__Mailgun__Msg, $author$project$Pages$Admin$Mailgun$page),
	wu: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Notes__Model, $author$project$Spa$Generated$Pages$Admin__Notes__Msg, $author$project$Pages$Admin$Notes$page),
	wv: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Notifications__Company__Model, $author$project$Spa$Generated$Pages$Admin__Notifications__Company__Msg, $author$project$Pages$Admin$Notifications$Company$page),
	ww: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Notifications__Employee__Model, $author$project$Spa$Generated$Pages$Admin__Notifications__Employee__Msg, $author$project$Pages$Admin$Notifications$Employee$page),
	wx: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Notifications__Membership__Model, $author$project$Spa$Generated$Pages$Admin__Notifications__Membership__Msg, $author$project$Pages$Admin$Notifications$Membership$page),
	wy: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Notifications__Patient__Model, $author$project$Spa$Generated$Pages$Admin__Notifications__Patient__Msg, $author$project$Pages$Admin$Notifications$Patient$page),
	wz: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Notifications__Patient__DunningSchedule__Model, $author$project$Spa$Generated$Pages$Admin__Notifications__Patient__DunningSchedule__Msg, $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$page),
	wA: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Notifications__Practice__Model, $author$project$Spa$Generated$Pages$Admin__Notifications__Practice__Msg, $author$project$Pages$Admin$Notifications$Practice$page),
	wB: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Notifications__Settings__Model, $author$project$Spa$Generated$Pages$Admin__Notifications__Settings__Msg, $author$project$Pages$Admin$Notifications$Settings$page),
	wC: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Patients__Model, $author$project$Spa$Generated$Pages$Admin__Patients__Msg, $author$project$Pages$Admin$Patients$page),
	wD: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__PaymentMethodImport__Model, $author$project$Spa$Generated$Pages$Admin__PaymentMethodImport__Msg, $author$project$Pages$Admin$PaymentMethodImport$page),
	wE: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__PaymentMethodImport__Upload__Model, $author$project$Spa$Generated$Pages$Admin__PaymentMethodImport__Upload__Msg, $author$project$Pages$Admin$PaymentMethodImport$Upload$page),
	wF: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__PaymentProcessing__Model, $author$project$Spa$Generated$Pages$Admin__PaymentProcessing__Msg, $author$project$Pages$Admin$PaymentProcessing$page),
	wG: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__PaymentSources__Model, $author$project$Spa$Generated$Pages$Admin__PaymentSources__Msg, $author$project$Pages$Admin$PaymentSources$page),
	wH: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Plans__Id_String__Model, $author$project$Spa$Generated$Pages$Admin__Plans__Id_String__Msg, $author$project$Pages$Admin$Plans$Id_String$page),
	wI: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Plans__Id_String__PricingVersions__New__Model, $author$project$Spa$Generated$Pages$Admin__Plans__Id_String__PricingVersions__New__Msg, $author$project$Pages$Admin$Plans$Id_String$PricingVersions$New$page),
	wJ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Plans__Id_String__PricingVersions__PricingVersionId_String__Model, $author$project$Spa$Generated$Pages$Admin__Plans__Id_String__PricingVersions__PricingVersionId_String__Msg, $author$project$Pages$Admin$Plans$Id_String$PricingVersions$PricingVersionId_String$page),
	wK: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Plans__New__Model, $author$project$Spa$Generated$Pages$Admin__Plans__New__Msg, $author$project$Pages$Admin$Plans$New$page),
	wL: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Plans__Top__Model, $author$project$Spa$Generated$Pages$Admin__Plans__Top__Msg, $author$project$Pages$Admin$Plans$Top$page),
	wM: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Practice__Model, $author$project$Spa$Generated$Pages$Admin__Practice__Msg, $author$project$Pages$Admin$Practice$page),
	wN: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__ProviderGroups__Model, $author$project$Spa$Generated$Pages$Admin__ProviderGroups__Msg, $author$project$Pages$Admin$ProviderGroups$page),
	wO: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Providers__Top__Model, $author$project$Spa$Generated$Pages$Admin__Providers__Top__Msg, $author$project$Pages$Admin$Providers$Top$page),
	wP: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Providers__Upload__Model, $author$project$Spa$Generated$Pages$Admin__Providers__Upload__Msg, $author$project$Pages$Admin$Providers$Upload$page),
	wQ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Quickbooks__Top__Model, $author$project$Spa$Generated$Pages$Admin__Quickbooks__Top__Msg, $author$project$Pages$Admin$Quickbooks$Top$page),
	wR: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__ScheduledJobs__Model, $author$project$Spa$Generated$Pages$Admin__ScheduledJobs__Msg, $author$project$Pages$Admin$ScheduledJobs$page),
	wS: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__SelfService__Model, $author$project$Spa$Generated$Pages$Admin__SelfService__Msg, $author$project$Pages$Admin$SelfService$page),
	wT: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Signup__Model, $author$project$Spa$Generated$Pages$Admin__Signup__Msg, $author$project$Pages$Admin$Signup$page),
	wU: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__SignupPages__Id_String__Model, $author$project$Spa$Generated$Pages$Admin__SignupPages__Id_String__Msg, $author$project$Pages$Admin$SignupPages$Id_String$page),
	wV: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__SignupPages__New__Model, $author$project$Spa$Generated$Pages$Admin__SignupPages__New__Msg, $author$project$Pages$Admin$SignupPages$New$page),
	wW: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__SignupPages__Top__Model, $author$project$Spa$Generated$Pages$Admin__SignupPages__Top__Msg, $author$project$Pages$Admin$SignupPages$Top$page),
	wX: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Stripe__Model, $author$project$Spa$Generated$Pages$Admin__Stripe__Msg, $author$project$Pages$Admin$Stripe$page),
	wY: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Taxes__Model, $author$project$Spa$Generated$Pages$Admin__Taxes__Msg, $author$project$Pages$Admin$Taxes$page),
	wZ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Team__Model, $author$project$Spa$Generated$Pages$Admin__Team__Msg, $author$project$Pages$Admin$Team$page),
	w_: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Team__New__Model, $author$project$Spa$Generated$Pages$Admin__Team__New__Msg, $author$project$Pages$Admin$Team$New$page),
	w$: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Waitlist__Model, $author$project$Spa$Generated$Pages$Admin__Waitlist__Msg, $author$project$Pages$Admin$Waitlist$page),
	w1: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$AffiliateBills__Top__Model, $author$project$Spa$Generated$Pages$AffiliateBills__Top__Msg, $author$project$Pages$AffiliateBills$Top$page),
	w3: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__AffiliateActions__Model, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__AffiliateActions__Msg, $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$page),
	w4: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Bills__Id_String__Model, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Bills__Id_String__Msg, $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$page),
	w5: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Bills__Top__Model, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Bills__Top__Msg, $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$page),
	w6: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__LinkProviders__Model, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__LinkProviders__Msg, $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$page),
	w7: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__LinkedProviders__Model, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__LinkedProviders__Msg, $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$page),
	w8: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Patients__Model, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Patients__Msg, $author$project$Pages$Affiliates$AffiliateId_String$Patients$page),
	w9: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Settings__Model, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Settings__Msg, $author$project$Pages$Affiliates$AffiliateId_String$Settings$page),
	xa: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Users__Model, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Users__Msg, $author$project$Pages$Affiliates$AffiliateId_String$Users$page),
	xb: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Affiliates__Create__Model, $author$project$Spa$Generated$Pages$Affiliates__Create__Msg, $author$project$Pages$Affiliates$Create$page),
	xc: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Affiliates__New__Model, $author$project$Spa$Generated$Pages$Affiliates__New__Msg, $author$project$Pages$Affiliates$New$page),
	xd: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Affiliates__Top__Model, $author$project$Spa$Generated$Pages$Affiliates__Top__Msg, $author$project$Pages$Affiliates$Top$page),
	xn: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Apps__Slug_String__Model, $author$project$Spa$Generated$Pages$Apps__Slug_String__Msg, $author$project$Pages$Apps$Slug_String$page),
	xC: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Blank__Model, $author$project$Spa$Generated$Pages$Blank__Msg, $author$project$Pages$Blank$page),
	xD: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Bookkeeping__Model, $author$project$Spa$Generated$Pages$Bookkeeping__Msg, $author$project$Pages$Bookkeeping$page),
	xL: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Calendar__Model, $author$project$Spa$Generated$Pages$Calendar__Msg, $author$project$Pages$Calendar$page),
	xV: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$CcdaImports__CcdaId_String__Top__Model, $author$project$Spa$Generated$Pages$CcdaImports__CcdaId_String__Top__Msg, $author$project$Pages$CcdaImports$CcdaId_String$Top$page),
	x_: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Charges__New__Model, $author$project$Spa$Generated$Pages$Charges__New__Msg, $author$project$Pages$Charges$New$page),
	ya: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__BrokerId_String__Top__Model, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__BrokerId_String__Top__Msg, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$BrokerId_String$Top$page),
	yb: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Ended__Model, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Ended__Msg, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$page),
	yc: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__New__Model, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__New__Msg, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$New$page),
	yd: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top__Model, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top__Msg, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$page),
	ye: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Deals__Model, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Deals__Msg, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$page),
	yf: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__EndedDeals__Model, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__EndedDeals__Msg, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$page),
	yg: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__StatementId_String__Model, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__StatementId_String__Msg, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$page),
	yh: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__Top__Model, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__Top__Msg, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$Top$page),
	yi: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Top__Model, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Top__Msg, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Top$page),
	yj: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__New__Model, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__New__Msg, $author$project$Pages$Commissions$BrokerAccounts$New$page),
	yk: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__Top__Model, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__Top__Msg, $author$project$Pages$Commissions$BrokerAccounts$Top$page),
	yl: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Commissions__StatementLines__Summary__Model, $author$project$Spa$Generated$Pages$Commissions__StatementLines__Summary__Msg, $author$project$Pages$Commissions$StatementLines$Summary$page),
	ym: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Commissions__StatementLines__Top__Model, $author$project$Spa$Generated$Pages$Commissions__StatementLines__Top__Msg, $author$project$Pages$Commissions$StatementLines$Top$page),
	yn: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Commissions__Statements__Model, $author$project$Spa$Generated$Pages$Commissions__Statements__Msg, $author$project$Pages$Commissions$Statements$page),
	yo: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__AffiliatesPricing__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__AffiliatesPricing__Msg, $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$page),
	yp: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Eas__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Eas__Msg, $author$project$Pages$Companies$CompanyId_String$Eas$page),
	yq: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Employees__Create__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Employees__Create__Msg, $author$project$Pages$Companies$CompanyId_String$Employees$Create$page),
	yr: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Employees__EmployeeId_String__Dependent__DependentId_String__Top__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Employees__EmployeeId_String__Dependent__DependentId_String__Top__Msg, $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$page),
	ys: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Employees__Top__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Employees__Top__Msg, $author$project$Pages$Companies$CompanyId_String$Employees$Top$page),
	yt: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__EndedCommissions__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__EndedCommissions__Msg, $author$project$Pages$Companies$CompanyId_String$EndedCommissions$page),
	yu: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__InvoiceSettings__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__InvoiceSettings__Msg, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$page),
	yv: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Invoices__Id_String__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Invoices__Id_String__Msg, $author$project$Pages$Companies$CompanyId_String$Invoices$Id_String$page),
	yw: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Invoices__Top__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Invoices__Top__Msg, $author$project$Pages$Companies$CompanyId_String$Invoices$Top$page),
	yx: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Notes__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Notes__Msg, $author$project$Pages$Companies$CompanyId_String$Notes$page),
	yy: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Notifications__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Notifications__Msg, $author$project$Pages$Companies$CompanyId_String$Notifications$page),
	yz: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__PaymentSources__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__PaymentSources__Msg, $author$project$Pages$Companies$CompanyId_String$PaymentSources$page),
	yA: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Signup__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Signup__Msg, $author$project$Pages$Companies$CompanyId_String$Signup$page),
	yB: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__SignupPages__Id_String__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__SignupPages__Id_String__Msg, $author$project$Pages$Companies$CompanyId_String$SignupPages$Id_String$page),
	yC: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__SignupPages__New__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__SignupPages__New__Msg, $author$project$Pages$Companies$CompanyId_String$SignupPages$New$page),
	yD: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Top__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Top__Msg, $author$project$Pages$Companies$CompanyId_String$Top$page),
	yE: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Uploads__Top__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Uploads__Top__Msg, $author$project$Pages$Companies$CompanyId_String$Uploads$Top$page),
	yF: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Uploads__UploadId_String__Top__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Uploads__UploadId_String__Top__Msg, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$page),
	yG: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Uploads__UploadId_String__UploadResults__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Uploads__UploadId_String__UploadResults__Msg, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$page),
	yH: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__New__Model, $author$project$Spa$Generated$Pages$Companies__New__Msg, $author$project$Pages$Companies$New$page),
	yI: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__Top__Model, $author$project$Spa$Generated$Pages$Companies__Top__Msg, $author$project$Pages$Companies$Top$page),
	yK: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Contacts__ContactId_String__Top__Model, $author$project$Spa$Generated$Pages$Contacts__ContactId_String__Top__Msg, $author$project$Pages$Contacts$ContactId_String$Top$page),
	yL: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Contacts__List__Model, $author$project$Spa$Generated$Pages$Contacts__List__Msg, $author$project$Pages$Contacts$List$page),
	yM: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Contacts__New__Model, $author$project$Spa$Generated$Pages$Contacts__New__Msg, $author$project$Pages$Contacts$New$page),
	zu: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Error__Status_String__Model, $author$project$Spa$Generated$Pages$Error__Status_String__Msg, $author$project$Pages$Error$Status_String$page),
	zG: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Files__Public__Model, $author$project$Spa$Generated$Pages$Files__Public__Msg, $author$project$Pages$Files$Public$page),
	zH: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Files__Top__Model, $author$project$Spa$Generated$Pages$Files__Top__Msg, $author$project$Pages$Files$Top$page),
	aL: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Forms__Model, $author$project$Spa$Generated$Pages$Forms__Msg, $author$project$Pages$Forms$page),
	zM: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$GoogleCallback__Model, $author$project$Spa$Generated$Pages$GoogleCallback__Msg, $author$project$Pages$GoogleCallback$page),
	zY: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Hinter__AdminUsersGroups__Id_String__Model, $author$project$Spa$Generated$Pages$Hinter__AdminUsersGroups__Id_String__Msg, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$page),
	zZ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Hinter__AdminUsersGroups__Top__Model, $author$project$Spa$Generated$Pages$Hinter__AdminUsersGroups__Top__Msg, $author$project$Pages$Hinter$AdminUsersGroups$Top$page),
	z_: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Hinter__ClonePractice__Model, $author$project$Spa$Generated$Pages$Hinter__ClonePractice__Msg, $author$project$Pages$Hinter$ClonePractice$page),
	z$: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Hinter__Disputes__Model, $author$project$Spa$Generated$Pages$Hinter__Disputes__Msg, $author$project$Pages$Hinter$Disputes$page),
	z0: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Hinter__FeatureFlags__Model, $author$project$Spa$Generated$Pages$Hinter__FeatureFlags__Msg, $author$project$Pages$Hinter$FeatureFlags$page),
	z1: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Hinter__NewGroup__Model, $author$project$Spa$Generated$Pages$Hinter__NewGroup__Msg, $author$project$Pages$Hinter$NewGroup$page),
	z2: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Hinter__NewPartner__Model, $author$project$Spa$Generated$Pages$Hinter__NewPartner__Msg, $author$project$Pages$Hinter$NewPartner$page),
	z3: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Hinter__NewPractice__Model, $author$project$Spa$Generated$Pages$Hinter__NewPractice__Msg, $author$project$Pages$Hinter$NewPractice$page),
	z4: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Home__Model, $author$project$Spa$Generated$Pages$Home__Msg, $author$project$Pages$Home$page),
	Af: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Inventory__InventoryId_String__Top__Model, $author$project$Spa$Generated$Pages$Inventory__InventoryId_String__Top__Msg, $author$project$Pages$Inventory$InventoryId_String$Top$page),
	Ag: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Inventory__List__Model, $author$project$Spa$Generated$Pages$Inventory__List__Msg, $author$project$Pages$Inventory$List$page),
	Ah: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Inventory__New__Model, $author$project$Spa$Generated$Pages$Inventory__New__Msg, $author$project$Pages$Inventory$New$page),
	Ai: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Inventory__Settings__Model, $author$project$Spa$Generated$Pages$Inventory__Settings__Msg, $author$project$Pages$Inventory$Settings$page),
	As: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Join__Token_String__Model, $author$project$Spa$Generated$Pages$Join__Token_String__Msg, $author$project$Pages$Join$Token_String$page),
	AG: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Login__Model, $author$project$Spa$Generated$Pages$Login__Msg, $author$project$Pages$Login$page),
	AH: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Logout__Model, $author$project$Spa$Generated$Pages$Logout__Msg, $author$project$Pages$Logout$page),
	AK: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Marketplace__Athenahealth__Manage__Settings__Model, $author$project$Spa$Generated$Pages$Marketplace__Athenahealth__Manage__Settings__Msg, $author$project$Pages$Marketplace$Athenahealth$Manage$Settings$page),
	AL: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Marketplace__Bookkeeping__Manage__Settings__Model, $author$project$Spa$Generated$Pages$Marketplace__Bookkeeping__Manage__Settings__Msg, $author$project$Pages$Marketplace$Bookkeeping$Manage$Settings$page),
	AM: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Marketplace__Elation__Manage__Settings__Model, $author$project$Spa$Generated$Pages$Marketplace__Elation__Manage__Settings__Msg, $author$project$Pages$Marketplace$Elation$Manage$Settings$page),
	AN: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Marketplace__Manage__Model, $author$project$Spa$Generated$Pages$Marketplace__Manage__Msg, $author$project$Pages$Marketplace$Manage$page),
	AO: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Marketplace__Quickbooks__Manage__Settings__Model, $author$project$Spa$Generated$Pages$Marketplace__Quickbooks__Manage__Settings__Msg, $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$page),
	AP: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Model, $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Msg, $author$project$Pages$Marketplace$Slug_String$page),
	AQ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Manage__Onboarding__Model, $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Manage__Onboarding__Msg, $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$page),
	AR: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Manage__Settings__Model, $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Manage__Settings__Msg, $author$project$Pages$Marketplace$Slug_String$Manage$Settings$page),
	AS: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Manage__Users__Model, $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Manage__Users__Msg, $author$project$Pages$Marketplace$Slug_String$Manage$Users$page),
	AT: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Marketplace__Top__Model, $author$project$Spa$Generated$Pages$Marketplace__Top__Msg, $author$project$Pages$Marketplace$Top$page),
	AY: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Messages__Calls__Model, $author$project$Spa$Generated$Pages$Messages__Calls__Msg, $author$project$Pages$Messages$Calls$page),
	AZ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Messages__Chat__Model, $author$project$Spa$Generated$Pages$Messages__Chat__Msg, $author$project$Pages$Messages$Chat$page),
	A_: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Messages__Drafts__Model, $author$project$Spa$Generated$Pages$Messages__Drafts__Msg, $author$project$Pages$Messages$Drafts$page),
	A$: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Messages__Fax__New__Model, $author$project$Spa$Generated$Pages$Messages__Fax__New__Msg, $author$project$Pages$Messages$Fax$New$page),
	A0: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Messages__Faxes__MessageId_String__Model, $author$project$Spa$Generated$Pages$Messages__Faxes__MessageId_String__Msg, $author$project$Pages$Messages$Faxes$MessageId_String$page),
	A1: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Messages__Faxes__New__Model, $author$project$Spa$Generated$Pages$Messages__Faxes__New__Msg, $author$project$Pages$Messages$Faxes$New$page),
	A2: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Messages__Faxes__Top__Model, $author$project$Spa$Generated$Pages$Messages__Faxes__Top__Msg, $author$project$Pages$Messages$Faxes$Top$page),
	A3: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Messages__Forms__Model, $author$project$Spa$Generated$Pages$Messages__Forms__Msg, $author$project$Pages$Messages$Forms$page),
	A4: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Messages__Inbox__Model, $author$project$Spa$Generated$Pages$Messages__Inbox__Msg, $author$project$Pages$Messages$Inbox$page),
	A5: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Messages__Labs__Model, $author$project$Spa$Generated$Pages$Messages__Labs__Msg, $author$project$Pages$Messages$Labs$page),
	A6: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Messages__LegacyCalls__Model, $author$project$Spa$Generated$Pages$Messages__LegacyCalls__Msg, $author$project$Pages$Messages$LegacyCalls$page),
	A7: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Messages__Legacy__Sms__PatientPhoneNumber_String__PracticePhoneNumber_String__Model, $author$project$Spa$Generated$Pages$Messages__Legacy__Sms__PatientPhoneNumber_String__PracticePhoneNumber_String__Msg, $author$project$Pages$Messages$Legacy$Sms$PatientPhoneNumber_String$PracticePhoneNumber_String$page),
	A8: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Messages__ScheduledMessages__New__Model, $author$project$Spa$Generated$Pages$Messages__ScheduledMessages__New__Msg, $author$project$Pages$Messages$ScheduledMessages$New$page),
	A9: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Messages__ScheduledMessages__ScheduledEventId_String__Top__Model, $author$project$Spa$Generated$Pages$Messages__ScheduledMessages__ScheduledEventId_String__Top__Msg, $author$project$Pages$Messages$ScheduledMessages$ScheduledEventId_String$Top$page),
	Ba: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Messages__Scheduled__New__Model, $author$project$Spa$Generated$Pages$Messages__Scheduled__New__Msg, $author$project$Pages$Messages$Scheduled$New$page),
	Bb: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Messages__Scheduled__ScheduledId_String__Top__Model, $author$project$Spa$Generated$Pages$Messages__Scheduled__ScheduledId_String__Top__Msg, $author$project$Pages$Messages$Scheduled$ScheduledId_String$Top$page),
	Bc: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Messages__Scheduled__Top__Model, $author$project$Spa$Generated$Pages$Messages__Scheduled__Top__Msg, $author$project$Pages$Messages$Scheduled$Top$page),
	Bd: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Messages__Sms__Model, $author$project$Spa$Generated$Pages$Messages__Sms__Msg, $author$project$Pages$Messages$Sms$page),
	Be: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Messages__Sms__PhoneNumber_String__Model, $author$project$Spa$Generated$Pages$Messages__Sms__PhoneNumber_String__Msg, $author$project$Pages$Messages$Sms$PhoneNumber_String$page),
	Bf: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Messages__Sms__PhoneNumber_String__PracticeNumber_String__Model, $author$project$Spa$Generated$Pages$Messages__Sms__PhoneNumber_String__PracticeNumber_String__Msg, $author$project$Pages$Messages$Sms$PhoneNumber_String$PracticeNumber_String$page),
	Bg: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Messages__V2__Faxes__MessageId_String__Model, $author$project$Spa$Generated$Pages$Messages__V2__Faxes__MessageId_String__Msg, $author$project$Pages$Messages$V2$Faxes$MessageId_String$page),
	Bs: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__AppointmentTypes__Ident_String__Model, $author$project$Spa$Generated$Pages$NewSettings__AppointmentTypes__Ident_String__Msg, $author$project$Pages$NewSettings$AppointmentTypes$Ident_String$page),
	Bt: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__AppointmentTypes__New__Model, $author$project$Spa$Generated$Pages$NewSettings__AppointmentTypes__New__Msg, $author$project$Pages$NewSettings$AppointmentTypes$New$page),
	Bu: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__AppointmentTypes__Top__Model, $author$project$Spa$Generated$Pages$NewSettings__AppointmentTypes__Top__Msg, $author$project$Pages$NewSettings$AppointmentTypes$Top$page),
	Bv: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__BlockedPhoneNumbers__Model, $author$project$Spa$Generated$Pages$NewSettings__BlockedPhoneNumbers__Msg, $author$project$Pages$NewSettings$BlockedPhoneNumbers$page),
	Bw: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__BookingOverview__Model, $author$project$Spa$Generated$Pages$NewSettings__BookingOverview__Msg, $author$project$Pages$NewSettings$BookingOverview$page),
	Bx: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__Erx__Model, $author$project$Spa$Generated$Pages$NewSettings__Erx__Msg, $author$project$Pages$NewSettings$Erx$page),
	By: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__Export__Model, $author$project$Spa$Generated$Pages$NewSettings__Export__Msg, $author$project$Pages$NewSettings$Export$page),
	Bz: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__HinterSettings__Model, $author$project$Spa$Generated$Pages$NewSettings__HinterSettings__Msg, $author$project$Pages$NewSettings$HinterSettings$page),
	BA: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__Locations__BookingLocationId_String__Model, $author$project$Spa$Generated$Pages$NewSettings__Locations__BookingLocationId_String__Msg, $author$project$Pages$NewSettings$Locations$BookingLocationId_String$page),
	BB: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__Locations__New__LocationId_String__Model, $author$project$Spa$Generated$Pages$NewSettings__Locations__New__LocationId_String__Msg, $author$project$Pages$NewSettings$Locations$New$LocationId_String$page),
	BC: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__Locations__Top__Model, $author$project$Spa$Generated$Pages$NewSettings__Locations__Top__Msg, $author$project$Pages$NewSettings$Locations$Top$page),
	BD: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__PracticeInfo__Model, $author$project$Spa$Generated$Pages$NewSettings__PracticeInfo__Msg, $author$project$Pages$NewSettings$PracticeInfo$page),
	BE: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__Team__Model, $author$project$Spa$Generated$Pages$NewSettings__Team__Msg, $author$project$Pages$NewSettings$Team$page),
	BF: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__Team__TeamId_String__Model, $author$project$Spa$Generated$Pages$NewSettings__Team__TeamId_String__Msg, $author$project$Pages$NewSettings$Team$TeamId_String$page),
	BG: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__Team__TeamId_String__AiSettings__Model, $author$project$Spa$Generated$Pages$NewSettings__Team__TeamId_String__AiSettings__Msg, $author$project$Pages$NewSettings$Team$TeamId_String$AiSettings$page),
	BH: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__Team__TeamId_String__BasicInfo__Model, $author$project$Spa$Generated$Pages$NewSettings__Team__TeamId_String__BasicInfo__Msg, $author$project$Pages$NewSettings$Team$TeamId_String$BasicInfo$page),
	BI: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__Team__TeamId_String__CalendarAndAvailability__Model, $author$project$Spa$Generated$Pages$NewSettings__Team__TeamId_String__CalendarAndAvailability__Msg, $author$project$Pages$NewSettings$Team$TeamId_String$CalendarAndAvailability$page),
	BJ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__Templates__New__Model, $author$project$Spa$Generated$Pages$NewSettings__Templates__New__Msg, $author$project$Pages$NewSettings$Templates$New$page),
	BK: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__Templates__TemplateId_String__Model, $author$project$Spa$Generated$Pages$NewSettings__Templates__TemplateId_String__Msg, $author$project$Pages$NewSettings$Templates$TemplateId_String$page),
	BL: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__Templates__Top__Model, $author$project$Spa$Generated$Pages$NewSettings__Templates__Top__Msg, $author$project$Pages$NewSettings$Templates$Top$page),
	tl: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NotFound__Model, $author$project$Spa$Generated$Pages$NotFound__Msg, $author$project$Pages$NotFound$page),
	BU: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Oauth__Callback__Model, $author$project$Spa$Generated$Pages$Oauth__Callback__Msg, $author$project$Pages$Oauth$Callback$page),
	B6: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Onboard__DealId_String__Top__Model, $author$project$Spa$Generated$Pages$Onboard__DealId_String__Top__Msg, $author$project$Pages$Onboard$DealId_String$Top$page),
	B7: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__Completed__Model, $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__Completed__Msg, $author$project$Pages$Onboard$OnboardId_String$Completed$page),
	B8: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__Completing__Model, $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__Completing__Msg, $author$project$Pages$Onboard$OnboardId_String$Completing$page),
	B9: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__Payment__Model, $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__Payment__Msg, $author$project$Pages$Onboard$OnboardId_String$Payment$page),
	Ca: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__User__Model, $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__User__Msg, $author$project$Pages$Onboard$OnboardId_String$User$page),
	Cc: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Onboarding__Model, $author$project$Spa$Generated$Pages$Onboarding__Msg, $author$project$Pages$Onboarding$page),
	Cn: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__ApiKeys__Model, $author$project$Spa$Generated$Pages$Partner__ApiKeys__Msg, $author$project$Pages$Partner$ApiKeys$page),
	Co: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Billing__Model, $author$project$Spa$Generated$Pages$Partner__Billing__Msg, $author$project$Pages$Partner$Billing$page),
	Cp: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Billing__Charges__Model, $author$project$Spa$Generated$Pages$Partner__Billing__Charges__Msg, $author$project$Pages$Partner$Billing$Charges$page),
	Cq: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Billing__Deposits__Model, $author$project$Spa$Generated$Pages$Partner__Billing__Deposits__Msg, $author$project$Pages$Partner$Billing$Deposits$page),
	Cr: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Billing__Hinter__Model, $author$project$Spa$Generated$Pages$Partner__Billing__Hinter__Msg, $author$project$Pages$Partner$Billing$Hinter$page),
	Cs: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Billing__ServiceFee__Model, $author$project$Spa$Generated$Pages$Partner__Billing__ServiceFee__Msg, $author$project$Pages$Partner$Billing$ServiceFee$page),
	Ct: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Billing__Subscriptions__Model, $author$project$Spa$Generated$Pages$Partner__Billing__Subscriptions__Msg, $author$project$Pages$Partner$Billing$Subscriptions$page),
	Cu: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Dashboard__Top__Model, $author$project$Spa$Generated$Pages$Partner__Dashboard__Top__Msg, $author$project$Pages$Partner$Dashboard$Top$page),
	Cv: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Engagements__Model, $author$project$Spa$Generated$Pages$Partner__Engagements__Msg, $author$project$Pages$Partner$Engagements$page),
	Cw: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Hinter__Model, $author$project$Spa$Generated$Pages$Partner__Hinter__Msg, $author$project$Pages$Partner$Hinter$page),
	Cx: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Practices__Top__Model, $author$project$Spa$Generated$Pages$Partner__Practices__Top__Msg, $author$project$Pages$Partner$Practices$Top$page),
	Cy: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Products__Id_String__Model, $author$project$Spa$Generated$Pages$Partner__Products__Id_String__Msg, $author$project$Pages$Partner$Products$Id_String$page),
	Cz: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Products__Id_String__ActivationSettings__Model, $author$project$Spa$Generated$Pages$Partner__Products__Id_String__ActivationSettings__Msg, $author$project$Pages$Partner$Products$Id_String$ActivationSettings$page),
	CA: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Products__Id_String__AppBuilder__Model, $author$project$Spa$Generated$Pages$Partner__Products__Id_String__AppBuilder__Msg, $author$project$Pages$Partner$Products$Id_String$AppBuilder$page),
	CB: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Products__Id_String__AppSettings__Model, $author$project$Spa$Generated$Pages$Partner__Products__Id_String__AppSettings__Msg, $author$project$Pages$Partner$Products$Id_String$AppSettings$page),
	CC: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Products__Id_String__Hinter__Model, $author$project$Spa$Generated$Pages$Partner__Products__Id_String__Hinter__Msg, $author$project$Pages$Partner$Products$Id_String$Hinter$page),
	CD: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Products__New__Model, $author$project$Spa$Generated$Pages$Partner__Products__New__Msg, $author$project$Pages$Partner$Products$New$page),
	CE: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Sandboxes__Top__Model, $author$project$Spa$Generated$Pages$Partner__Sandboxes__Top__Msg, $author$project$Pages$Partner$Sandboxes$Top$page),
	CF: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Team__Model, $author$project$Spa$Generated$Pages$Partner__Team__Msg, $author$project$Pages$Partner$Team$page),
	CG: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Webhooks__Requests__Model, $author$project$Spa$Generated$Pages$Partner__Webhooks__Requests__Msg, $author$project$Pages$Partner$Webhooks$Requests$page),
	CH: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Webhooks__Settings__Model, $author$project$Spa$Generated$Pages$Partner__Webhooks__Settings__Msg, $author$project$Pages$Partner$Webhooks$Settings$page),
	CN: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__Create__Model, $author$project$Spa$Generated$Pages$Patients__Create__Msg, $author$project$Pages$Patients$Create$page),
	CO: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Accounts__Top__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Accounts__Top__Msg, $author$project$Pages$Patients$PatientId_String$Accounts$Top$page),
	CP: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Affiliation__Top__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Affiliation__Top__Msg, $author$project$Pages$Patients$PatientId_String$Affiliation$Top$page),
	CQ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Agreements__AgreementId_String__Top__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Agreements__AgreementId_String__Top__Msg, $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$page),
	CR: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Charges__InvoiceId_String__Top__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Charges__InvoiceId_String__Top__Msg, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$page),
	CS: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Charges__Top__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Charges__Top__Msg, $author$project$Pages$Patients$PatientId_String$Charges$Top$page),
	CT: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Chart__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Chart__Msg, $author$project$Pages$Patients$PatientId_String$Chart$page),
	CU: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Edit__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Edit__Msg, $author$project$Pages$Patients$PatientId_String$Edit$page),
	CV: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__GrowthChart__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__GrowthChart__Msg, $author$project$Pages$Patients$PatientId_String$GrowthChart$page),
	CW: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__LabTrends__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__LabTrends__Msg, $author$project$Pages$Patients$PatientId_String$LabTrends$page),
	CX: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__ManageCredits__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__ManageCredits__Msg, $author$project$Pages$Patients$PatientId_String$ManageCredits$page),
	CY: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Memberships__MembershipId_String__Top__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Memberships__MembershipId_String__Top__Msg, $author$project$Pages$Patients$PatientId_String$Memberships$MembershipId_String$Top$page),
	CZ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Memberships__New__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Memberships__New__Msg, $author$project$Pages$Patients$PatientId_String$Memberships$New$page),
	C_: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Memberships__Top__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Memberships__Top__Msg, $author$project$Pages$Patients$PatientId_String$Memberships$Top$page),
	C$: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Merge__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Merge__Msg, $author$project$Pages$Patients$PatientId_String$Merge$page),
	C0: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Notes__NoteId_String__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Notes__NoteId_String__Msg, $author$project$Pages$Patients$PatientId_String$Notes$NoteId_String$page),
	C1: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Notes__Top__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Notes__Top__Msg, $author$project$Pages$Patients$PatientId_String$Notes$Top$page),
	C2: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Notifications__Top__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Notifications__Top__Msg, $author$project$Pages$Patients$PatientId_String$Notifications$Top$page),
	C3: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Top__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Top__Msg, $author$project$Pages$Patients$PatientId_String$Top$page),
	C4: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__VitalsTrends__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__VitalsTrends__Msg, $author$project$Pages$Patients$PatientId_String$VitalsTrends$page),
	C5: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__Top__Model, $author$project$Spa$Generated$Pages$Patients__Top__Msg, $author$project$Pages$Patients$Top$page),
	C6: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__Upload__Model, $author$project$Spa$Generated$Pages$Patients__Upload__Msg, $author$project$Pages$Patients$Upload$page),
	Dj: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$PracticeSetup__Account__Model, $author$project$Spa$Generated$Pages$PracticeSetup__Account__Msg, $author$project$Pages$PracticeSetup$Account$page),
	Dk: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$PracticeSetup__Communications__Model, $author$project$Spa$Generated$Pages$PracticeSetup__Communications__Msg, $author$project$Pages$PracticeSetup$Communications$page),
	Dl: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$PracticeSetup__Complete__Model, $author$project$Spa$Generated$Pages$PracticeSetup__Complete__Msg, $author$project$Pages$PracticeSetup$Complete$page),
	Dm: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$PracticeSetup__Documents__Model, $author$project$Spa$Generated$Pages$PracticeSetup__Documents__Msg, $author$project$Pages$PracticeSetup$Documents$page),
	Dn: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$PracticeSetup__Legal__Model, $author$project$Spa$Generated$Pages$PracticeSetup__Legal__Msg, $author$project$Pages$PracticeSetup$Legal$page),
	Do: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$PracticeSetup__PaymentProcessing__Model, $author$project$Spa$Generated$Pages$PracticeSetup__PaymentProcessing__Msg, $author$project$Pages$PracticeSetup$PaymentProcessing$page),
	Dp: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$PracticeSetup__Plans__Model, $author$project$Spa$Generated$Pages$PracticeSetup__Plans__Msg, $author$project$Pages$PracticeSetup$Plans$page),
	Dq: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$PracticeSetup__Plans__Id_String__Edit__Model, $author$project$Spa$Generated$Pages$PracticeSetup__Plans__Id_String__Edit__Msg, $author$project$Pages$PracticeSetup$Plans$Id_String$Edit$page),
	Dr: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$PracticeSetup__Plans__New__Model, $author$project$Spa$Generated$Pages$PracticeSetup__Plans__New__Msg, $author$project$Pages$PracticeSetup$Plans$New$page),
	Ds: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$PracticeSetup__Team__Model, $author$project$Spa$Generated$Pages$PracticeSetup__Team__Msg, $author$project$Pages$PracticeSetup$Team$page),
	Dt: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$PracticeSetup__Top__Model, $author$project$Spa$Generated$Pages$PracticeSetup__Top__Msg, $author$project$Pages$PracticeSetup$Top$page),
	DK: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$RefillRequests__Model, $author$project$Spa$Generated$Pages$RefillRequests__Msg, $author$project$Pages$RefillRequests$page),
	DQ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__AncillaryCharges__Id_String__Model, $author$project$Spa$Generated$Pages$Reports__AncillaryCharges__Id_String__Msg, $author$project$Pages$Reports$AncillaryCharges$Id_String$page),
	DR: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__AncillaryCharges__Top__Model, $author$project$Spa$Generated$Pages$Reports__AncillaryCharges__Top__Msg, $author$project$Pages$Reports$AncillaryCharges$Top$page),
	DS: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__CompanyInvoices__Model, $author$project$Spa$Generated$Pages$Reports__CompanyInvoices__Msg, $author$project$Pages$Reports$CompanyInvoices$page),
	DT: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__CreditOutstanding__Model, $author$project$Spa$Generated$Pages$Reports__CreditOutstanding__Msg, $author$project$Pages$Reports$CreditOutstanding$page),
	DU: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__CreditOutstanding__Summary__Model, $author$project$Spa$Generated$Pages$Reports__CreditOutstanding__Summary__Msg, $author$project$Pages$Reports$CreditOutstanding$Summary$page),
	DV: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__CreditTransactions__Model, $author$project$Spa$Generated$Pages$Reports__CreditTransactions__Msg, $author$project$Pages$Reports$CreditTransactions$page),
	DW: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__CreditTransactions__Summary__Model, $author$project$Spa$Generated$Pages$Reports__CreditTransactions__Summary__Msg, $author$project$Pages$Reports$CreditTransactions$Summary$page),
	DX: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__Custom__Id_String__Model, $author$project$Spa$Generated$Pages$Reports__Custom__Id_String__Msg, $author$project$Pages$Reports$Custom$Id_String$page),
	DY: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__Custom__New__Model, $author$project$Spa$Generated$Pages$Reports__Custom__New__Msg, $author$project$Pages$Reports$Custom$New$page),
	DZ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__Dashboard__Model, $author$project$Spa$Generated$Pages$Reports__Dashboard__Msg, $author$project$Pages$Reports$Dashboard$page),
	D_: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__DeferredRevenue__Model, $author$project$Spa$Generated$Pages$Reports__DeferredRevenue__Msg, $author$project$Pages$Reports$DeferredRevenue$page),
	D$: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__DeferredRevenue__Summary__Model, $author$project$Spa$Generated$Pages$Reports__DeferredRevenue__Summary__Msg, $author$project$Pages$Reports$DeferredRevenue$Summary$page),
	D0: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__Deposits__Model, $author$project$Spa$Generated$Pages$Reports__Deposits__Msg, $author$project$Pages$Reports$Deposits$page),
	D1: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__Disputes__Model, $author$project$Spa$Generated$Pages$Reports__Disputes__Msg, $author$project$Pages$Reports$Disputes$page),
	D2: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__Invoices__Model, $author$project$Spa$Generated$Pages$Reports__Invoices__Msg, $author$project$Pages$Reports$Invoices$page),
	D3: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__Memberships__Model, $author$project$Spa$Generated$Pages$Reports__Memberships__Msg, $author$project$Pages$Reports$Memberships$page),
	D4: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__Months__Model, $author$project$Spa$Generated$Pages$Reports__Months__Msg, $author$project$Pages$Reports$Months$page),
	D5: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__PatientPackages__Model, $author$project$Spa$Generated$Pages$Reports__PatientPackages__Msg, $author$project$Pages$Reports$PatientPackages$page),
	D6: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__PaymentApplications__Model, $author$project$Spa$Generated$Pages$Reports__PaymentApplications__Msg, $author$project$Pages$Reports$PaymentApplications$page),
	D7: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__PaymentApplications__Summary__Model, $author$project$Spa$Generated$Pages$Reports__PaymentApplications__Summary__Msg, $author$project$Pages$Reports$PaymentApplications$Summary$page),
	D8: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__Revenue__Model, $author$project$Spa$Generated$Pages$Reports__Revenue__Msg, $author$project$Pages$Reports$Revenue$page),
	D9: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__Revenue__Summary__Model, $author$project$Spa$Generated$Pages$Reports__Revenue__Summary__Msg, $author$project$Pages$Reports$Revenue$Summary$page),
	Ea: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__SalesTax__Model, $author$project$Spa$Generated$Pages$Reports__SalesTax__Msg, $author$project$Pages$Reports$SalesTax$page),
	Eb: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__SalesTax__Summary__Model, $author$project$Spa$Generated$Pages$Reports__SalesTax__Summary__Msg, $author$project$Pages$Reports$SalesTax$Summary$page),
	Ec: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__SignupAttempts__Model, $author$project$Spa$Generated$Pages$Reports__SignupAttempts__Msg, $author$project$Pages$Reports$SignupAttempts$page),
	ES: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__ActivityIndicators__Model, $author$project$Spa$Generated$Pages$StyleGuide__ActivityIndicators__Msg, $author$project$Pages$StyleGuide$ActivityIndicators$page),
	ET: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__AddressInput__Model, $author$project$Spa$Generated$Pages$StyleGuide__AddressInput__Msg, $author$project$Pages$StyleGuide$AddressInput$page),
	EU: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Alert__Model, $author$project$Spa$Generated$Pages$StyleGuide__Alert__Msg, $author$project$Pages$StyleGuide$Alert$page),
	EV: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Badge__Model, $author$project$Spa$Generated$Pages$StyleGuide__Badge__Msg, $author$project$Pages$StyleGuide$Badge$page),
	EW: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Button__Model, $author$project$Spa$Generated$Pages$StyleGuide__Button__Msg, $author$project$Pages$StyleGuide$Button$page),
	EX: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Carousel__Model, $author$project$Spa$Generated$Pages$StyleGuide__Carousel__Msg, $author$project$Pages$StyleGuide$Carousel$page),
	EY: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Checkbox__Model, $author$project$Spa$Generated$Pages$StyleGuide__Checkbox__Msg, $author$project$Pages$StyleGuide$Checkbox$page),
	EZ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__CurrencyInput__Model, $author$project$Spa$Generated$Pages$StyleGuide__CurrencyInput__Msg, $author$project$Pages$StyleGuide$CurrencyInput$page),
	E_: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__DateInput__Model, $author$project$Spa$Generated$Pages$StyleGuide__DateInput__Msg, $author$project$Pages$StyleGuide$DateInput$page),
	E$: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__DateRangeInput__Model, $author$project$Spa$Generated$Pages$StyleGuide__DateRangeInput__Msg, $author$project$Pages$StyleGuide$DateRangeInput$page),
	E0: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__DragDrop__Model, $author$project$Spa$Generated$Pages$StyleGuide__DragDrop__Msg, $author$project$Pages$StyleGuide$DragDrop$page),
	E1: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Dropdown__Model, $author$project$Spa$Generated$Pages$StyleGuide__Dropdown__Msg, $author$project$Pages$StyleGuide$Dropdown$page),
	E2: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Element__Model, $author$project$Spa$Generated$Pages$StyleGuide__Element__Msg, $author$project$Pages$StyleGuide$Element$page),
	E3: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__ExportCsv__Model, $author$project$Spa$Generated$Pages$StyleGuide__ExportCsv__Msg, $author$project$Pages$StyleGuide$ExportCsv$page),
	E4: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__FileInput__Model, $author$project$Spa$Generated$Pages$StyleGuide__FileInput__Msg, $author$project$Pages$StyleGuide$FileInput$page),
	E5: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__FlyoutMenu__Model, $author$project$Spa$Generated$Pages$StyleGuide__FlyoutMenu__Msg, $author$project$Pages$StyleGuide$FlyoutMenu$page),
	E6: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__FormExample__Model, $author$project$Spa$Generated$Pages$StyleGuide__FormExample__Msg, $author$project$Pages$StyleGuide$FormExample$page),
	E7: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__FormGroup__Model, $author$project$Spa$Generated$Pages$StyleGuide__FormGroup__Msg, $author$project$Pages$StyleGuide$FormGroup$page),
	E8: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__FormStatic__Model, $author$project$Spa$Generated$Pages$StyleGuide__FormStatic__Msg, $author$project$Pages$StyleGuide$FormStatic$page),
	E9: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Grid__Model, $author$project$Spa$Generated$Pages$StyleGuide__Grid__Msg, $author$project$Pages$StyleGuide$Grid$page),
	Fa: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__HiConfirm__Model, $author$project$Spa$Generated$Pages$StyleGuide__HiConfirm__Msg, $author$project$Pages$StyleGuide$HiConfirm$page),
	Fb: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__HorizontalRule__Model, $author$project$Spa$Generated$Pages$StyleGuide__HorizontalRule__Msg, $author$project$Pages$StyleGuide$HorizontalRule$page),
	Fc: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Icon__Model, $author$project$Spa$Generated$Pages$StyleGuide__Icon__Msg, $author$project$Pages$StyleGuide$Icon$page),
	Fd: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Input__Model, $author$project$Spa$Generated$Pages$StyleGuide__Input__Msg, $author$project$Pages$StyleGuide$Input$page),
	Fe: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Link__Model, $author$project$Spa$Generated$Pages$StyleGuide__Link__Msg, $author$project$Pages$StyleGuide$Link$page),
	Ff: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__ListGroup__Model, $author$project$Spa$Generated$Pages$StyleGuide__ListGroup__Msg, $author$project$Pages$StyleGuide$ListGroup$page),
	Fg: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Modal__Model, $author$project$Spa$Generated$Pages$StyleGuide__Modal__Msg, $author$project$Pages$StyleGuide$Modal$page),
	Fh: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__OrderedList__Model, $author$project$Spa$Generated$Pages$StyleGuide__OrderedList__Msg, $author$project$Pages$StyleGuide$OrderedList$page),
	Fi: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Pagination__Model, $author$project$Spa$Generated$Pages$StyleGuide__Pagination__Msg, $author$project$Pages$StyleGuide$Pagination$page),
	Fj: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Panel__Model, $author$project$Spa$Generated$Pages$StyleGuide__Panel__Msg, $author$project$Pages$StyleGuide$Panel$page),
	Fk: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__PasswordInput__Model, $author$project$Spa$Generated$Pages$StyleGuide__PasswordInput__Msg, $author$project$Pages$StyleGuide$PasswordInput$page),
	Fl: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__PaymentSourceDisplayer__Model, $author$project$Spa$Generated$Pages$StyleGuide__PaymentSourceDisplayer__Msg, $author$project$Pages$StyleGuide$PaymentSourceDisplayer$page),
	Fm: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__PhoneInput__Model, $author$project$Spa$Generated$Pages$StyleGuide__PhoneInput__Msg, $author$project$Pages$StyleGuide$PhoneInput$page),
	Fn: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Popover__Model, $author$project$Spa$Generated$Pages$StyleGuide__Popover__Msg, $author$project$Pages$StyleGuide$Popover$page),
	Fo: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Pre__Model, $author$project$Spa$Generated$Pages$StyleGuide__Pre__Msg, $author$project$Pages$StyleGuide$Pre$page),
	Fp: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__ProgressBar__Model, $author$project$Spa$Generated$Pages$StyleGuide__ProgressBar__Msg, $author$project$Pages$StyleGuide$ProgressBar$page),
	Fq: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Radio__Model, $author$project$Spa$Generated$Pages$StyleGuide__Radio__Msg, $author$project$Pages$StyleGuide$Radio$page),
	Fr: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__ResourceFilter__Model, $author$project$Spa$Generated$Pages$StyleGuide__ResourceFilter__Msg, $author$project$Pages$StyleGuide$ResourceFilter$page),
	Fs: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__SearchInput__Model, $author$project$Spa$Generated$Pages$StyleGuide__SearchInput__Msg, $author$project$Pages$StyleGuide$SearchInput$page),
	Ft: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Select__Model, $author$project$Spa$Generated$Pages$StyleGuide__Select__Msg, $author$project$Pages$StyleGuide$Select$page),
	Fu: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Skeleton__Model, $author$project$Spa$Generated$Pages$StyleGuide__Skeleton__Msg, $author$project$Pages$StyleGuide$Skeleton$page),
	Fv: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Spinner__Model, $author$project$Spa$Generated$Pages$StyleGuide__Spinner__Msg, $author$project$Pages$StyleGuide$Spinner$page),
	Fw: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Table__Model, $author$project$Spa$Generated$Pages$StyleGuide__Table__Msg, $author$project$Pages$StyleGuide$Table$page),
	Fx: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Toast__Model, $author$project$Spa$Generated$Pages$StyleGuide__Toast__Msg, $author$project$Pages$StyleGuide$Toast$page),
	Fy: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__ToggleSwitch__Model, $author$project$Spa$Generated$Pages$StyleGuide__ToggleSwitch__Msg, $author$project$Pages$StyleGuide$ToggleSwitch$page),
	Fz: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Tooltip__Model, $author$project$Spa$Generated$Pages$StyleGuide__Tooltip__Msg, $author$project$Pages$StyleGuide$Tooltip$page),
	FA: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Top__Model, $author$project$Spa$Generated$Pages$StyleGuide__Top__Msg, $author$project$Pages$StyleGuide$Top$page),
	FB: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Typography__Model, $author$project$Spa$Generated$Pages$StyleGuide__Typography__Msg, $author$project$Pages$StyleGuide$Typography$page),
	FC: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__UploadForm__Model, $author$project$Spa$Generated$Pages$StyleGuide__UploadForm__Msg, $author$project$Pages$StyleGuide$UploadForm$page),
	FD: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__UploadResult__Model, $author$project$Spa$Generated$Pages$StyleGuide__UploadResult__Msg, $author$project$Pages$StyleGuide$UploadResult$page),
	FE: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Well__Model, $author$project$Spa$Generated$Pages$StyleGuide__Well__Msg, $author$project$Pages$StyleGuide$Well$page),
	FH: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Support__CannySso__Model, $author$project$Spa$Generated$Pages$Support__CannySso__Msg, $author$project$Pages$Support$CannySso$page),
	FK: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Tasks__New__Model, $author$project$Spa$Generated$Pages$Tasks__New__Msg, $author$project$Pages$Tasks$New$page),
	FL: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Tasks__TasksId_String__Top__Model, $author$project$Spa$Generated$Pages$Tasks__TasksId_String__Top__Msg, $author$project$Pages$Tasks$TasksId_String$Top$page),
	FM: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Tasks__Top__Model, $author$project$Spa$Generated$Pages$Tasks__Top__Msg, $author$project$Pages$Tasks$Top$page),
	FU: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Top__Model, $author$project$Spa$Generated$Pages$Top__Msg, $author$project$Pages$Top$page),
	F2: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$User__AcceptTerms__Model, $author$project$Spa$Generated$Pages$User__AcceptTerms__Msg, $author$project$Pages$User$AcceptTerms$page),
	F3: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$User__Mfa__Model, $author$project$Spa$Generated$Pages$User__Mfa__Msg, $author$project$Pages$User$Mfa$page),
	F4: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$User__Organizations__Top__Model, $author$project$Spa$Generated$Pages$User__Organizations__Top__Msg, $author$project$Pages$User$Organizations$Top$page),
	F5: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$User__Profile__Model, $author$project$Spa$Generated$Pages$User__Profile__Msg, $author$project$Pages$User$Profile$page),
	F6: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$User__Security__Model, $author$project$Spa$Generated$Pages$User__Security__Msg, $author$project$Pages$User$Security$page)
};
var $author$project$Spa$Generated$Pages$init = function (route) {
	switch (route.$) {
		case 0:
			return $author$project$Spa$Generated$Pages$pages.FU.ah_(0);
		case 1:
			return $author$project$Spa$Generated$Pages$pages.xC.ah_(0);
		case 2:
			return $author$project$Spa$Generated$Pages$pages.xD.ah_(0);
		case 3:
			return $author$project$Spa$Generated$Pages$pages.xL.ah_(0);
		case 4:
			return $author$project$Spa$Generated$Pages$pages.aL.ah_(0);
		case 5:
			return $author$project$Spa$Generated$Pages$pages.zM.ah_(0);
		case 6:
			return $author$project$Spa$Generated$Pages$pages.z4.ah_(0);
		case 7:
			return $author$project$Spa$Generated$Pages$pages.AG.ah_(0);
		case 8:
			return $author$project$Spa$Generated$Pages$pages.AH.ah_(0);
		case 9:
			return $author$project$Spa$Generated$Pages$pages.tl.ah_(0);
		case 10:
			return $author$project$Spa$Generated$Pages$pages.Cc.ah_(0);
		case 11:
			return $author$project$Spa$Generated$Pages$pages.DK.ah_(0);
		case 12:
			return $author$project$Spa$Generated$Pages$pages.w1.ah_(0);
		case 13:
			return $author$project$Spa$Generated$Pages$pages.xd.ah_(0);
		case 14:
			return $author$project$Spa$Generated$Pages$pages.yI.ah_(0);
		case 15:
			return $author$project$Spa$Generated$Pages$pages.zH.ah_(0);
		case 16:
			return $author$project$Spa$Generated$Pages$pages.AT.ah_(0);
		case 17:
			return $author$project$Spa$Generated$Pages$pages.C5.ah_(0);
		case 18:
			return $author$project$Spa$Generated$Pages$pages.Dt.ah_(0);
		case 19:
			return $author$project$Spa$Generated$Pages$pages.FA.ah_(0);
		case 20:
			return $author$project$Spa$Generated$Pages$pages.FM.ah_(0);
		case 21:
			return $author$project$Spa$Generated$Pages$pages.vx.ah_(0);
		case 22:
			return $author$project$Spa$Generated$Pages$pages.vF.ah_(0);
		case 23:
			return $author$project$Spa$Generated$Pages$pages.vM.ah_(0);
		case 24:
			return $author$project$Spa$Generated$Pages$pages.vO.ah_(0);
		case 25:
			return $author$project$Spa$Generated$Pages$pages.vP.ah_(0);
		case 26:
			return $author$project$Spa$Generated$Pages$pages.vQ.ah_(0);
		case 27:
			return $author$project$Spa$Generated$Pages$pages.vV.ah_(0);
		case 28:
			return $author$project$Spa$Generated$Pages$pages.vZ.ah_(0);
		case 29:
			return $author$project$Spa$Generated$Pages$pages.v1.ah_(0);
		case 30:
			return $author$project$Spa$Generated$Pages$pages.wh.ah_(0);
		case 31:
			return $author$project$Spa$Generated$Pages$pages.wm.ah_(0);
		case 32:
			return $author$project$Spa$Generated$Pages$pages.wn.ah_(0);
		case 33:
			return $author$project$Spa$Generated$Pages$pages.wp.ah_(0);
		case 34:
			return $author$project$Spa$Generated$Pages$pages.wq.ah_(0);
		case 35:
			return $author$project$Spa$Generated$Pages$pages.wr.ah_(0);
		case 36:
			return $author$project$Spa$Generated$Pages$pages.ws.ah_(0);
		case 37:
			return $author$project$Spa$Generated$Pages$pages.wt.ah_(0);
		case 38:
			return $author$project$Spa$Generated$Pages$pages.wu.ah_(0);
		case 39:
			return $author$project$Spa$Generated$Pages$pages.wC.ah_(0);
		case 40:
			return $author$project$Spa$Generated$Pages$pages.wD.ah_(0);
		case 41:
			return $author$project$Spa$Generated$Pages$pages.wF.ah_(0);
		case 42:
			return $author$project$Spa$Generated$Pages$pages.wG.ah_(0);
		case 43:
			return $author$project$Spa$Generated$Pages$pages.wM.ah_(0);
		case 44:
			return $author$project$Spa$Generated$Pages$pages.wN.ah_(0);
		case 45:
			return $author$project$Spa$Generated$Pages$pages.wR.ah_(0);
		case 46:
			return $author$project$Spa$Generated$Pages$pages.wS.ah_(0);
		case 47:
			return $author$project$Spa$Generated$Pages$pages.wT.ah_(0);
		case 48:
			return $author$project$Spa$Generated$Pages$pages.wX.ah_(0);
		case 49:
			return $author$project$Spa$Generated$Pages$pages.wY.ah_(0);
		case 50:
			return $author$project$Spa$Generated$Pages$pages.wZ.ah_(0);
		case 51:
			return $author$project$Spa$Generated$Pages$pages.w$.ah_(0);
		case 52:
			return $author$project$Spa$Generated$Pages$pages.xb.ah_(0);
		case 53:
			return $author$project$Spa$Generated$Pages$pages.xc.ah_(0);
		case 54:
			return $author$project$Spa$Generated$Pages$pages.x_.ah_(0);
		case 55:
			return $author$project$Spa$Generated$Pages$pages.yn.ah_(0);
		case 56:
			return $author$project$Spa$Generated$Pages$pages.yH.ah_(0);
		case 57:
			return $author$project$Spa$Generated$Pages$pages.yL.ah_(0);
		case 58:
			return $author$project$Spa$Generated$Pages$pages.yM.ah_(0);
		case 59:
			return $author$project$Spa$Generated$Pages$pages.zG.ah_(0);
		case 60:
			return $author$project$Spa$Generated$Pages$pages.z_.ah_(0);
		case 61:
			return $author$project$Spa$Generated$Pages$pages.z$.ah_(0);
		case 62:
			return $author$project$Spa$Generated$Pages$pages.z0.ah_(0);
		case 63:
			return $author$project$Spa$Generated$Pages$pages.z1.ah_(0);
		case 64:
			return $author$project$Spa$Generated$Pages$pages.z2.ah_(0);
		case 65:
			return $author$project$Spa$Generated$Pages$pages.z3.ah_(0);
		case 66:
			return $author$project$Spa$Generated$Pages$pages.Ag.ah_(0);
		case 67:
			return $author$project$Spa$Generated$Pages$pages.Ah.ah_(0);
		case 68:
			return $author$project$Spa$Generated$Pages$pages.Ai.ah_(0);
		case 69:
			return $author$project$Spa$Generated$Pages$pages.AN.ah_(0);
		case 70:
			return $author$project$Spa$Generated$Pages$pages.AY.ah_(0);
		case 71:
			return $author$project$Spa$Generated$Pages$pages.AZ.ah_(0);
		case 72:
			return $author$project$Spa$Generated$Pages$pages.A_.ah_(0);
		case 73:
			return $author$project$Spa$Generated$Pages$pages.A3.ah_(0);
		case 74:
			return $author$project$Spa$Generated$Pages$pages.A4.ah_(0);
		case 75:
			return $author$project$Spa$Generated$Pages$pages.A5.ah_(0);
		case 76:
			return $author$project$Spa$Generated$Pages$pages.A6.ah_(0);
		case 77:
			return $author$project$Spa$Generated$Pages$pages.Bd.ah_(0);
		case 78:
			return $author$project$Spa$Generated$Pages$pages.Bv.ah_(0);
		case 79:
			return $author$project$Spa$Generated$Pages$pages.Bw.ah_(0);
		case 80:
			return $author$project$Spa$Generated$Pages$pages.Bx.ah_(0);
		case 81:
			return $author$project$Spa$Generated$Pages$pages.By.ah_(0);
		case 82:
			return $author$project$Spa$Generated$Pages$pages.Bz.ah_(0);
		case 83:
			return $author$project$Spa$Generated$Pages$pages.BD.ah_(0);
		case 84:
			return $author$project$Spa$Generated$Pages$pages.BE.ah_(0);
		case 85:
			return $author$project$Spa$Generated$Pages$pages.BU.ah_(0);
		case 86:
			return $author$project$Spa$Generated$Pages$pages.Cn.ah_(0);
		case 87:
			return $author$project$Spa$Generated$Pages$pages.Co.ah_(0);
		case 88:
			return $author$project$Spa$Generated$Pages$pages.Cv.ah_(0);
		case 89:
			return $author$project$Spa$Generated$Pages$pages.Cw.ah_(0);
		case 90:
			return $author$project$Spa$Generated$Pages$pages.CF.ah_(0);
		case 91:
			return $author$project$Spa$Generated$Pages$pages.CN.ah_(0);
		case 92:
			return $author$project$Spa$Generated$Pages$pages.C6.ah_(0);
		case 93:
			return $author$project$Spa$Generated$Pages$pages.Dj.ah_(0);
		case 94:
			return $author$project$Spa$Generated$Pages$pages.Dk.ah_(0);
		case 95:
			return $author$project$Spa$Generated$Pages$pages.Dl.ah_(0);
		case 96:
			return $author$project$Spa$Generated$Pages$pages.Dm.ah_(0);
		case 97:
			return $author$project$Spa$Generated$Pages$pages.Dn.ah_(0);
		case 98:
			return $author$project$Spa$Generated$Pages$pages.Do.ah_(0);
		case 99:
			return $author$project$Spa$Generated$Pages$pages.Dp.ah_(0);
		case 100:
			return $author$project$Spa$Generated$Pages$pages.Ds.ah_(0);
		case 101:
			return $author$project$Spa$Generated$Pages$pages.DS.ah_(0);
		case 102:
			return $author$project$Spa$Generated$Pages$pages.DT.ah_(0);
		case 103:
			return $author$project$Spa$Generated$Pages$pages.DV.ah_(0);
		case 104:
			return $author$project$Spa$Generated$Pages$pages.DZ.ah_(0);
		case 105:
			return $author$project$Spa$Generated$Pages$pages.D_.ah_(0);
		case 106:
			return $author$project$Spa$Generated$Pages$pages.D0.ah_(0);
		case 107:
			return $author$project$Spa$Generated$Pages$pages.D1.ah_(0);
		case 108:
			return $author$project$Spa$Generated$Pages$pages.D2.ah_(0);
		case 109:
			return $author$project$Spa$Generated$Pages$pages.D3.ah_(0);
		case 110:
			return $author$project$Spa$Generated$Pages$pages.D4.ah_(0);
		case 111:
			return $author$project$Spa$Generated$Pages$pages.D5.ah_(0);
		case 112:
			return $author$project$Spa$Generated$Pages$pages.D6.ah_(0);
		case 113:
			return $author$project$Spa$Generated$Pages$pages.D8.ah_(0);
		case 114:
			return $author$project$Spa$Generated$Pages$pages.Ea.ah_(0);
		case 115:
			return $author$project$Spa$Generated$Pages$pages.Ec.ah_(0);
		case 116:
			return $author$project$Spa$Generated$Pages$pages.ES.ah_(0);
		case 117:
			return $author$project$Spa$Generated$Pages$pages.ET.ah_(0);
		case 118:
			return $author$project$Spa$Generated$Pages$pages.EU.ah_(0);
		case 119:
			return $author$project$Spa$Generated$Pages$pages.EV.ah_(0);
		case 120:
			return $author$project$Spa$Generated$Pages$pages.EW.ah_(0);
		case 121:
			return $author$project$Spa$Generated$Pages$pages.EX.ah_(0);
		case 122:
			return $author$project$Spa$Generated$Pages$pages.EY.ah_(0);
		case 123:
			return $author$project$Spa$Generated$Pages$pages.EZ.ah_(0);
		case 124:
			return $author$project$Spa$Generated$Pages$pages.E_.ah_(0);
		case 125:
			return $author$project$Spa$Generated$Pages$pages.E$.ah_(0);
		case 126:
			return $author$project$Spa$Generated$Pages$pages.E0.ah_(0);
		case 127:
			return $author$project$Spa$Generated$Pages$pages.E1.ah_(0);
		case 128:
			return $author$project$Spa$Generated$Pages$pages.E2.ah_(0);
		case 129:
			return $author$project$Spa$Generated$Pages$pages.E3.ah_(0);
		case 130:
			return $author$project$Spa$Generated$Pages$pages.E4.ah_(0);
		case 131:
			return $author$project$Spa$Generated$Pages$pages.E5.ah_(0);
		case 132:
			return $author$project$Spa$Generated$Pages$pages.E6.ah_(0);
		case 133:
			return $author$project$Spa$Generated$Pages$pages.E7.ah_(0);
		case 134:
			return $author$project$Spa$Generated$Pages$pages.E8.ah_(0);
		case 135:
			return $author$project$Spa$Generated$Pages$pages.E9.ah_(0);
		case 136:
			return $author$project$Spa$Generated$Pages$pages.Fa.ah_(0);
		case 137:
			return $author$project$Spa$Generated$Pages$pages.Fb.ah_(0);
		case 138:
			return $author$project$Spa$Generated$Pages$pages.Fc.ah_(0);
		case 139:
			return $author$project$Spa$Generated$Pages$pages.Fd.ah_(0);
		case 140:
			return $author$project$Spa$Generated$Pages$pages.Fe.ah_(0);
		case 141:
			return $author$project$Spa$Generated$Pages$pages.Ff.ah_(0);
		case 142:
			return $author$project$Spa$Generated$Pages$pages.Fg.ah_(0);
		case 143:
			return $author$project$Spa$Generated$Pages$pages.Fh.ah_(0);
		case 144:
			return $author$project$Spa$Generated$Pages$pages.Fi.ah_(0);
		case 145:
			return $author$project$Spa$Generated$Pages$pages.Fj.ah_(0);
		case 146:
			return $author$project$Spa$Generated$Pages$pages.Fk.ah_(0);
		case 147:
			return $author$project$Spa$Generated$Pages$pages.Fl.ah_(0);
		case 148:
			return $author$project$Spa$Generated$Pages$pages.Fm.ah_(0);
		case 149:
			return $author$project$Spa$Generated$Pages$pages.Fn.ah_(0);
		case 150:
			return $author$project$Spa$Generated$Pages$pages.Fo.ah_(0);
		case 151:
			return $author$project$Spa$Generated$Pages$pages.Fp.ah_(0);
		case 152:
			return $author$project$Spa$Generated$Pages$pages.Fq.ah_(0);
		case 153:
			return $author$project$Spa$Generated$Pages$pages.Fr.ah_(0);
		case 154:
			return $author$project$Spa$Generated$Pages$pages.Fs.ah_(0);
		case 155:
			return $author$project$Spa$Generated$Pages$pages.Ft.ah_(0);
		case 156:
			return $author$project$Spa$Generated$Pages$pages.Fu.ah_(0);
		case 157:
			return $author$project$Spa$Generated$Pages$pages.Fv.ah_(0);
		case 158:
			return $author$project$Spa$Generated$Pages$pages.Fw.ah_(0);
		case 159:
			return $author$project$Spa$Generated$Pages$pages.Fx.ah_(0);
		case 160:
			return $author$project$Spa$Generated$Pages$pages.Fy.ah_(0);
		case 161:
			return $author$project$Spa$Generated$Pages$pages.Fz.ah_(0);
		case 162:
			return $author$project$Spa$Generated$Pages$pages.FB.ah_(0);
		case 163:
			return $author$project$Spa$Generated$Pages$pages.FC.ah_(0);
		case 164:
			return $author$project$Spa$Generated$Pages$pages.FD.ah_(0);
		case 165:
			return $author$project$Spa$Generated$Pages$pages.FE.ah_(0);
		case 166:
			return $author$project$Spa$Generated$Pages$pages.FH.ah_(0);
		case 167:
			return $author$project$Spa$Generated$Pages$pages.FK.ah_(0);
		case 168:
			return $author$project$Spa$Generated$Pages$pages.F2.ah_(0);
		case 169:
			return $author$project$Spa$Generated$Pages$pages.F3.ah_(0);
		case 170:
			return $author$project$Spa$Generated$Pages$pages.F5.ah_(0);
		case 171:
			return $author$project$Spa$Generated$Pages$pages.F6.ah_(0);
		case 172:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.xn.ah_(params);
		case 173:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.zu.ah_(params);
		case 174:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.As.ah_(params);
		case 175:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.AP.ah_(params);
		case 176:
			return $author$project$Spa$Generated$Pages$pages.vL.ah_(0);
		case 177:
			return $author$project$Spa$Generated$Pages$pages.vT.ah_(0);
		case 178:
			return $author$project$Spa$Generated$Pages$pages.vY.ah_(0);
		case 179:
			return $author$project$Spa$Generated$Pages$pages.v0.ah_(0);
		case 180:
			return $author$project$Spa$Generated$Pages$pages.v7.ah_(0);
		case 181:
			return $author$project$Spa$Generated$Pages$pages.v5.ah_(0);
		case 182:
			return $author$project$Spa$Generated$Pages$pages.wg.ah_(0);
		case 183:
			return $author$project$Spa$Generated$Pages$pages.wl.ah_(0);
		case 184:
			return $author$project$Spa$Generated$Pages$pages.wL.ah_(0);
		case 185:
			return $author$project$Spa$Generated$Pages$pages.wO.ah_(0);
		case 186:
			return $author$project$Spa$Generated$Pages$pages.wQ.ah_(0);
		case 187:
			return $author$project$Spa$Generated$Pages$pages.wW.ah_(0);
		case 188:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.xV.ah_(params);
		case 189:
			return $author$project$Spa$Generated$Pages$pages.yk.ah_(0);
		case 190:
			return $author$project$Spa$Generated$Pages$pages.ym.ah_(0);
		case 191:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.yD.ah_(params);
		case 192:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.yK.ah_(params);
		case 193:
			return $author$project$Spa$Generated$Pages$pages.zZ.ah_(0);
		case 194:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.Af.ah_(params);
		case 195:
			return $author$project$Spa$Generated$Pages$pages.A2.ah_(0);
		case 196:
			return $author$project$Spa$Generated$Pages$pages.Bc.ah_(0);
		case 197:
			return $author$project$Spa$Generated$Pages$pages.Bu.ah_(0);
		case 198:
			return $author$project$Spa$Generated$Pages$pages.BC.ah_(0);
		case 199:
			return $author$project$Spa$Generated$Pages$pages.BL.ah_(0);
		case 200:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.B6.ah_(params);
		case 201:
			return $author$project$Spa$Generated$Pages$pages.Cu.ah_(0);
		case 202:
			return $author$project$Spa$Generated$Pages$pages.Cx.ah_(0);
		case 203:
			return $author$project$Spa$Generated$Pages$pages.CE.ah_(0);
		case 204:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.C3.ah_(params);
		case 205:
			return $author$project$Spa$Generated$Pages$pages.DR.ah_(0);
		case 206:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.FL.ah_(params);
		case 207:
			return $author$project$Spa$Generated$Pages$pages.F4.ah_(0);
		case 208:
			return $author$project$Spa$Generated$Pages$pages.vG.ah_(0);
		case 209:
			return $author$project$Spa$Generated$Pages$pages.vH.ah_(0);
		case 210:
			return $author$project$Spa$Generated$Pages$pages.vI.ah_(0);
		case 211:
			return $author$project$Spa$Generated$Pages$pages.vJ.ah_(0);
		case 212:
			return $author$project$Spa$Generated$Pages$pages.vK.ah_(0);
		case 213:
			return $author$project$Spa$Generated$Pages$pages.vS.ah_(0);
		case 214:
			return $author$project$Spa$Generated$Pages$pages.vU.ah_(0);
		case 215:
			return $author$project$Spa$Generated$Pages$pages.vX.ah_(0);
		case 216:
			return $author$project$Spa$Generated$Pages$pages.v$.ah_(0);
		case 217:
			return $author$project$Spa$Generated$Pages$pages.v2.ah_(0);
		case 218:
			return $author$project$Spa$Generated$Pages$pages.v4.ah_(0);
		case 219:
			return $author$project$Spa$Generated$Pages$pages.v8.ah_(0);
		case 220:
			return $author$project$Spa$Generated$Pages$pages.v9.ah_(0);
		case 221:
			return $author$project$Spa$Generated$Pages$pages.wa.ah_(0);
		case 222:
			return $author$project$Spa$Generated$Pages$pages.wb.ah_(0);
		case 223:
			return $author$project$Spa$Generated$Pages$pages.wc.ah_(0);
		case 224:
			return $author$project$Spa$Generated$Pages$pages.wd.ah_(0);
		case 225:
			return $author$project$Spa$Generated$Pages$pages.wf.ah_(0);
		case 226:
			return $author$project$Spa$Generated$Pages$pages.wi.ah_(0);
		case 227:
			return $author$project$Spa$Generated$Pages$pages.wj.ah_(0);
		case 228:
			return $author$project$Spa$Generated$Pages$pages.wk.ah_(0);
		case 229:
			return $author$project$Spa$Generated$Pages$pages.wv.ah_(0);
		case 230:
			return $author$project$Spa$Generated$Pages$pages.ww.ah_(0);
		case 231:
			return $author$project$Spa$Generated$Pages$pages.wx.ah_(0);
		case 232:
			return $author$project$Spa$Generated$Pages$pages.wy.ah_(0);
		case 233:
			return $author$project$Spa$Generated$Pages$pages.wA.ah_(0);
		case 234:
			return $author$project$Spa$Generated$Pages$pages.wB.ah_(0);
		case 235:
			return $author$project$Spa$Generated$Pages$pages.wE.ah_(0);
		case 236:
			return $author$project$Spa$Generated$Pages$pages.wK.ah_(0);
		case 237:
			return $author$project$Spa$Generated$Pages$pages.wP.ah_(0);
		case 238:
			return $author$project$Spa$Generated$Pages$pages.wV.ah_(0);
		case 239:
			return $author$project$Spa$Generated$Pages$pages.w_.ah_(0);
		case 240:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.w3.ah_(params);
		case 241:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.w6.ah_(params);
		case 242:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.w7.ah_(params);
		case 243:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.w8.ah_(params);
		case 244:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.w9.ah_(params);
		case 245:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.xa.ah_(params);
		case 246:
			return $author$project$Spa$Generated$Pages$pages.yj.ah_(0);
		case 247:
			return $author$project$Spa$Generated$Pages$pages.yl.ah_(0);
		case 248:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.yo.ah_(params);
		case 249:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.yp.ah_(params);
		case 250:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.yt.ah_(params);
		case 251:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.yu.ah_(params);
		case 252:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.yx.ah_(params);
		case 253:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.yy.ah_(params);
		case 254:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.yz.ah_(params);
		case 255:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.yA.ah_(params);
		case 256:
			return $author$project$Spa$Generated$Pages$pages.A$.ah_(0);
		case 257:
			return $author$project$Spa$Generated$Pages$pages.A1.ah_(0);
		case 258:
			return $author$project$Spa$Generated$Pages$pages.Ba.ah_(0);
		case 259:
			return $author$project$Spa$Generated$Pages$pages.A8.ah_(0);
		case 260:
			return $author$project$Spa$Generated$Pages$pages.Bt.ah_(0);
		case 261:
			return $author$project$Spa$Generated$Pages$pages.BJ.ah_(0);
		case 262:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.B7.ah_(params);
		case 263:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.B8.ah_(params);
		case 264:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.B9.ah_(params);
		case 265:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.Ca.ah_(params);
		case 266:
			return $author$project$Spa$Generated$Pages$pages.Cp.ah_(0);
		case 267:
			return $author$project$Spa$Generated$Pages$pages.Cq.ah_(0);
		case 268:
			return $author$project$Spa$Generated$Pages$pages.Cr.ah_(0);
		case 269:
			return $author$project$Spa$Generated$Pages$pages.Cs.ah_(0);
		case 270:
			return $author$project$Spa$Generated$Pages$pages.Ct.ah_(0);
		case 271:
			return $author$project$Spa$Generated$Pages$pages.CD.ah_(0);
		case 272:
			return $author$project$Spa$Generated$Pages$pages.CG.ah_(0);
		case 273:
			return $author$project$Spa$Generated$Pages$pages.CH.ah_(0);
		case 274:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.CT.ah_(params);
		case 275:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.CU.ah_(params);
		case 276:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.CV.ah_(params);
		case 277:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.CW.ah_(params);
		case 278:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.CX.ah_(params);
		case 279:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.C$.ah_(params);
		case 280:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.C4.ah_(params);
		case 281:
			return $author$project$Spa$Generated$Pages$pages.Dr.ah_(0);
		case 282:
			return $author$project$Spa$Generated$Pages$pages.DU.ah_(0);
		case 283:
			return $author$project$Spa$Generated$Pages$pages.DW.ah_(0);
		case 284:
			return $author$project$Spa$Generated$Pages$pages.DY.ah_(0);
		case 285:
			return $author$project$Spa$Generated$Pages$pages.D$.ah_(0);
		case 286:
			return $author$project$Spa$Generated$Pages$pages.D7.ah_(0);
		case 287:
			return $author$project$Spa$Generated$Pages$pages.D9.ah_(0);
		case 288:
			return $author$project$Spa$Generated$Pages$pages.Eb.ah_(0);
		case 289:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.vR.ah_(params);
		case 290:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.vW.ah_(params);
		case 291:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.v_.ah_(params);
		case 292:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.v6.ah_(params);
		case 293:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.v3.ah_(params);
		case 294:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.we.ah_(params);
		case 295:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.wo.ah_(params);
		case 296:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.wH.ah_(params);
		case 297:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.wU.ah_(params);
		case 298:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.zY.ah_(params);
		case 299:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.A0.ah_(params);
		case 300:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.Be.ah_(params);
		case 301:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.Bs.ah_(params);
		case 302:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.BA.ah_(params);
		case 303:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.BF.ah_(params);
		case 304:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.BK.ah_(params);
		case 305:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.Cy.ah_(params);
		case 306:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.DQ.ah_(params);
		case 307:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.DX.ah_(params);
		case 308:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.w5.ah_(params);
		case 309:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.yi.ah_(params);
		case 310:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.ys.ah_(params);
		case 311:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.yw.ah_(params);
		case 312:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.yE.ah_(params);
		case 313:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.Bb.ah_(params);
		case 314:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.A9.ah_(params);
		case 315:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.CO.ah_(params);
		case 316:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.CP.ah_(params);
		case 317:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.CS.ah_(params);
		case 318:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.C_.ah_(params);
		case 319:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.C1.ah_(params);
		case 320:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.C2.ah_(params);
		case 321:
			return $author$project$Spa$Generated$Pages$pages.wz.ah_(0);
		case 322:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.ye.ah_(params);
		case 323:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.yf.ah_(params);
		case 324:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.yq.ah_(params);
		case 325:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.yC.ah_(params);
		case 326:
			return $author$project$Spa$Generated$Pages$pages.AK.ah_(0);
		case 327:
			return $author$project$Spa$Generated$Pages$pages.AL.ah_(0);
		case 328:
			return $author$project$Spa$Generated$Pages$pages.AM.ah_(0);
		case 329:
			return $author$project$Spa$Generated$Pages$pages.AO.ah_(0);
		case 330:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.AQ.ah_(params);
		case 331:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.AR.ah_(params);
		case 332:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.AS.ah_(params);
		case 333:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.BG.ah_(params);
		case 334:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.BH.ah_(params);
		case 335:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.BI.ah_(params);
		case 336:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.Cz.ah_(params);
		case 337:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.CA.ah_(params);
		case 338:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.CB.ah_(params);
		case 339:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.CC.ah_(params);
		case 340:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.CZ.ah_(params);
		case 341:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.Dq.ah_(params);
		case 342:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.vN.ah_(params);
		case 343:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.w4.ah_(params);
		case 344:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.yv.ah_(params);
		case 345:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.yB.ah_(params);
		case 346:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.Bf.ah_(params);
		case 347:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.Bg.ah_(params);
		case 348:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.BB.ah_(params);
		case 349:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.C0.ah_(params);
		case 350:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.yd.ah_(params);
		case 351:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.yh.ah_(params);
		case 352:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.yF.ah_(params);
		case 353:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.CQ.ah_(params);
		case 354:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.CR.ah_(params);
		case 355:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.CY.ah_(params);
		case 356:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.wI.ah_(params);
		case 357:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.yb.ah_(params);
		case 358:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.yc.ah_(params);
		case 359:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.yG.ah_(params);
		case 360:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.wJ.ah_(params);
		case 361:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.yg.ah_(params);
		case 362:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.A7.ah_(params);
		case 363:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.ya.ah_(params);
		default:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.yr.ah_(params);
	}
};
var $author$project$Spa$Layout$AdminModel = function (a) {
	return {$: 14, a: a};
};
var $author$project$Spa$Layout$AdminMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Spa$Layout$AffiliatesAffiliateModel = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Spa$Layout$AffiliatesAffiliateMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Spa$Layout$AffiliatesModel = function (a) {
	return {$: 6, a: a};
};
var $author$project$Spa$Layout$AffiliatesMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Spa$Layout$ApplicationModel = {$: 1};
var $author$project$Spa$Layout$BlankModel = {$: 15};
var $author$project$Spa$Layout$ClinicalModel = {$: 16};
var $author$project$Spa$Layout$CommissionsBrokerAccountModel = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Spa$Layout$CommissionsBrokerAccountMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Spa$Layout$CommissionsModel = function (a) {
	return {$: 4, a: a};
};
var $author$project$Spa$Layout$CommissionsMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Spa$Layout$CompanyModel = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Spa$Layout$CompanyMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Spa$Layout$MarketplaceManageModel = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Spa$Layout$MarketplaceManageMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Spa$Layout$OnboardModel = {$: 18};
var $author$project$Spa$Layout$PartnerBillingModel = function (a) {
	return {$: 8, a: a};
};
var $author$project$Spa$Layout$PartnerBillingMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Spa$Layout$PartnerPracticesModel = function (a) {
	return {$: 9, a: a};
};
var $author$project$Spa$Layout$PartnerPracticesMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Spa$Layout$PartnerProductModel = function (a) {
	return {$: 10, a: a};
};
var $author$project$Spa$Layout$PartnerProductMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Spa$Layout$PartnerWebhooksModel = function (a) {
	return {$: 11, a: a};
};
var $author$project$Spa$Layout$PartnerWebhooksMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Spa$Layout$PatientAndSidebarModel = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Spa$Layout$PatientChartModel = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$Spa$Layout$PatientMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Spa$Layout$PatientsSidebarModel = {$: 2};
var $author$project$Spa$Layout$PracticeSetupModel = {$: 20};
var $author$project$Spa$Layout$StyleGuideModel = {$: 0};
var $author$project$Spa$Layout$UserModel = function (a) {
	return {$: 19, a: a};
};
var $author$project$Spa$Layout$UserMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Layouts$Admin$NavMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Layouts$Admin$GotManagedPartner = function (a) {
	return {$: 1, a: a};
};
var $author$project$Layouts$Admin$initManagedPartner = function (shared) {
	var _v0 = shared.ZV;
	if ((_v0.$ === 3) && (!_v0.a.$)) {
		var practice_ = _v0.a.a;
		return $author$project$Api$Provider$Practice$One$hasManagedPartner(practice_) ? _Utils_Tuple2(
			$author$project$Api$Data$Loading,
			A2($author$project$Api$Provider$ManagedPartner$retrieve, shared.Gv, $author$project$Layouts$Admin$GotManagedPartner)) : _Utils_Tuple2($author$project$Api$Data$NotAsked, $elm$core$Platform$Cmd$none);
	} else {
		return _Utils_Tuple2($author$project$Api$Data$NotAsked, $elm$core$Platform$Cmd$none);
	}
};
var $author$project$Layouts$Admin$init = function (shared) {
	var _v0 = A2($author$project$Ui$Nav$init, 'admin-nav', $author$project$Layouts$Admin$NavMsg);
	var nav = _v0.a;
	var navCmd = _v0.b;
	var _v1 = $author$project$Layouts$Admin$initManagedPartner(shared);
	var managedPartner = _v1.a;
	var managedPartnerCmd = _v1.b;
	return _Utils_Tuple2(
		{s6: managedPartner, kp: nav},
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[navCmd, managedPartnerCmd])));
};
var $author$project$Layouts$Affiliates$NavMsg = $elm$core$Basics$identity;
var $author$project$Layouts$Affiliates$init = A2(
	$elm$core$Tuple$mapFirst,
	function (nav) {
		return {kp: nav};
	},
	A2($author$project$Ui$Nav$init, 'affiliates-nav', $elm$core$Basics$identity));
var $author$project$Layouts$Affiliates$Affiliate$GotAffiliate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Layouts$Affiliates$Affiliate$NavMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Layouts$Affiliates$Affiliate$init = F2(
	function (_v0, affiliateId) {
		var apiClient = _v0.Gv;
		var _v1 = A2($author$project$Ui$Nav$init, 'affiliate-nav', $author$project$Layouts$Affiliates$Affiliate$NavMsg);
		var nav = _v1.a;
		var navCmd = _v1.b;
		return _Utils_Tuple2(
			{Gn: $author$project$Api$Data$Loading, rd: affiliateId, kp: nav},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3($author$project$Api$Provider$Affiliate$retrieve, apiClient, affiliateId, $author$project$Layouts$Affiliates$Affiliate$GotAffiliate),
						navCmd
					])));
	});
var $author$project$Layouts$Commissions$NavMsg = $elm$core$Basics$identity;
var $author$project$Layouts$Commissions$init = A2(
	$elm$core$Tuple$mapFirst,
	function (nav) {
		return {kp: nav};
	},
	A2($author$project$Ui$Nav$init, 'commissions-nav', $elm$core$Basics$identity));
var $author$project$Layouts$Commissions$BrokerAccount$GotBrokerAccount = function (a) {
	return {$: 0, a: a};
};
var $author$project$Layouts$Commissions$BrokerAccount$NavMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Layouts$Commissions$BrokerAccount$init = F2(
	function (_v0, brokerAccountId) {
		var apiClient = _v0.Gv;
		var _v1 = A2($author$project$Ui$Nav$init, 'broker-account-nav', $author$project$Layouts$Commissions$BrokerAccount$NavMsg);
		var nav = _v1.a;
		var navCmd = _v1.b;
		return _Utils_Tuple2(
			{xG: $author$project$Api$Data$Loading, cm: brokerAccountId, kp: nav},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3($author$project$Api$Provider$BrokerAccount$retrieve, apiClient, brokerAccountId, $author$project$Layouts$Commissions$BrokerAccount$GotBrokerAccount),
						navCmd
					])));
	});
var $author$project$Layouts$Company$NavMsg = $elm$core$Basics$identity;
var $author$project$Layouts$Company$init = A2(
	$elm$core$Tuple$mapFirst,
	function (nav) {
		return {kp: nav};
	},
	A2($author$project$Ui$Nav$init, 'company-nav', $elm$core$Basics$identity));
var $author$project$Layouts$Marketplace$Manage$GotIntegration = function (a) {
	return {$: 1, a: a};
};
var $author$project$Layouts$Marketplace$Manage$NavMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Layouts$Marketplace$Manage$init = F2(
	function (apiClient, slug) {
		var _v0 = A2($author$project$Ui$Nav$init, 'marketplace-manage-nav', $author$project$Layouts$Marketplace$Manage$NavMsg);
		var nav = _v0.a;
		var navCmd = _v0.b;
		return _Utils_Tuple2(
			{T8: $author$project$Api$Data$Loading, kp: nav, abG: slug},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						navCmd,
						A3($author$project$Api$Provider$Integration$retrieve, apiClient, slug, $author$project$Layouts$Marketplace$Manage$GotIntegration)
					])));
	});
var $author$project$Layouts$Partner$Billing$NavMsg = $elm$core$Basics$identity;
var $author$project$Layouts$Partner$Billing$init = function () {
	var _v0 = A2($author$project$Ui$Nav$init, 'partner-billing-nav', $elm$core$Basics$identity);
	var nav = _v0.a;
	var navCmd = _v0.b;
	return _Utils_Tuple2(
		{kp: nav},
		navCmd);
}();
var $author$project$Layouts$Partner$Practices$NavMsg = $elm$core$Basics$identity;
var $author$project$Layouts$Partner$Practices$init = function () {
	var _v0 = A2($author$project$Ui$Nav$init, 'partner-practices-nav', $elm$core$Basics$identity);
	var nav = _v0.a;
	var navCmd = _v0.b;
	return _Utils_Tuple2(
		{kp: nav},
		navCmd);
}();
var $author$project$Layouts$Partner$Product$NavMsg = $elm$core$Basics$identity;
var $author$project$Layouts$Partner$Product$init = function () {
	var _v0 = A2($author$project$Ui$Nav$init, 'partner-product-nav', $elm$core$Basics$identity);
	var nav = _v0.a;
	var navCmd = _v0.b;
	return _Utils_Tuple2(
		{kp: nav},
		navCmd);
}();
var $author$project$Layouts$Partner$Webhooks$NavMsg = $elm$core$Basics$identity;
var $author$project$Layouts$Partner$Webhooks$init = function () {
	var _v0 = A2($author$project$Ui$Nav$init, 'partner-webhooks-nav', $elm$core$Basics$identity);
	var nav = _v0.a;
	var navCmd = _v0.b;
	return _Utils_Tuple2(
		{kp: nav},
		navCmd);
}();
var $author$project$Layouts$Patient$GotMembershipPatients = function (a) {
	return {$: 6, a: a};
};
var $author$project$Layouts$Patient$NavMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Layouts$Patient$PatientInfoCardMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Layouts$Patient$PaymentMethodsCardMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$PatientChart$PatientInfoCard$Model = $elm$core$Basics$identity;
var $author$project$Components$PatientChart$PatientInfoCard$empty = function (patientId) {
	return {iw: $elm$core$Maybe$Nothing, cJ: $elm$core$Maybe$Nothing, YZ: patientId, aS: $author$project$Api$Data$NotAsked, aX: false};
};
var $author$project$Components$PaymentMethodsCard$FlyoutMenuMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$PaymentMethodsCard$Model = $elm$core$Basics$identity;
var $author$project$Components$PaymentMethodsCard$flyoutMenuId = 'payment-methods-card-flyout-menu';
var $author$project$Components$PaymentMethodsCard$empty = F2(
	function (shared, patientId) {
		return {
			iw: $elm$core$Maybe$Nothing,
			rs: $author$project$Api$Data$NotAsked,
			rC: $author$project$Api$Data$NotAsked,
			i_: $author$project$Components$CreatePaymentMethodModal$init,
			dd: shared.dd,
			gc: $elm$core$Maybe$Nothing,
			x: $elm$core$Maybe$Nothing,
			nN: A2($author$project$Ui$FlyoutMenu$init, $author$project$Components$PaymentMethodsCard$flyoutMenuId, $author$project$Components$PaymentMethodsCard$FlyoutMenuMsg),
			gY: $author$project$Components$MovePaymentMethodsModal$init,
			YZ: patientId,
			kA: $author$project$Api$Data$NotAsked,
			hA: false,
			J: $elm$core$Set$empty
		};
	});
var $author$project$Components$PatientChart$PatientInfoCard$buildAuditTrailLog = F2(
	function (shared, patientId) {
		var _v0 = _Utils_Tuple2(shared.aa4, shared.G9);
		if ((_v0.a.$ === 3) && (_v0.b.$ === 3)) {
			var _v1 = _v0.a;
			var session = _v1.a;
			var _v2 = _v0.b;
			var patient = _v2.a;
			return $elm$core$Maybe$Just(
				A7(
					$author$project$Components$AuditTrailLog$init,
					session,
					shared.adY,
					shared.J7,
					$elm$core$Maybe$Just('patient'),
					$elm$core$Maybe$Just(patientId),
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$Patient$One$createdAt(patient)),
					$elm$core$Maybe$Nothing));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$PatientChart$PatientInfoCard$currentMaskedSsn = function (shared) {
	var _v0 = shared.G9;
	if (_v0.$ === 3) {
		var patient = _v0.a;
		return A2(
			$elm$core$Maybe$andThen,
			$author$project$Api$Common$SocialSecurityNumber$Masked$maskedNumber,
			$author$project$Api$Provider$Patient$One$ssn(patient));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$PatientChart$PatientInfoCard$init = F2(
	function (shared, patientId) {
		return _Utils_Tuple2(
			{
				iw: A2($author$project$Components$PatientChart$PatientInfoCard$buildAuditTrailLog, shared, patientId),
				cJ: $author$project$Components$PatientChart$PatientInfoCard$currentMaskedSsn(shared),
				YZ: patientId,
				aS: $author$project$Api$Data$NotAsked,
				aX: false
			},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Components$PaymentMethodsCard$GotPaymentSourcesMigratable = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$PaymentMethodsCard$patientCreatedAt = function (shared) {
	var _v0 = shared.G9;
	if (_v0.$ === 3) {
		var patient = _v0.a;
		return $elm$core$Maybe$Just(
			$author$project$Api$Provider$Patient$One$createdAt(patient));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$PaymentMethodsCard$initAuditTrailLog = F2(
	function (shared, patientId) {
		var _v0 = shared.aa4;
		if (_v0.$ === 3) {
			var session = _v0.a;
			return $elm$core$Maybe$Just(
				A7(
					$author$project$Components$AuditTrailLog$init,
					session,
					shared.adY,
					shared.J7,
					$elm$core$Maybe$Just('patient'),
					$elm$core$Maybe$Just(patientId),
					$author$project$Components$PaymentMethodsCard$patientCreatedAt(shared),
					$elm$core$Maybe$Just('payment_methods')));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$PaymentMethodsCard$GotBankAccounts = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$PaymentMethodsCard$GotCards = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$PaymentMethodsCard$patientPath = function (patientId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[patientId]),
		A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				['patients']),
			$author$project$Api$Data$providerPath));
};
var $author$project$Components$PaymentMethodsCard$loadSources = F3(
	function (patientId, apiClient, session) {
		return $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A4(
					$author$project$Api$Card$list,
					$author$project$Components$PaymentMethodsCard$patientPath(patientId),
					apiClient,
					session,
					$author$project$Components$PaymentMethodsCard$GotCards),
					A4(
					$author$project$Api$BankAccount$list,
					$author$project$Components$PaymentMethodsCard$patientPath(patientId),
					apiClient,
					session,
					$author$project$Components$PaymentMethodsCard$GotBankAccounts)
				]));
	});
var $author$project$Components$PaymentMethodsCard$init = F2(
	function (shared, patientId) {
		var _v0 = function () {
			var _v1 = shared.aa4;
			if (_v1.$ === 3) {
				var session = _v1.a;
				return _Utils_Tuple3(
					$author$project$Api$Data$Loading,
					$author$project$Api$Data$Loading,
					A3($author$project$Components$PaymentMethodsCard$loadSources, patientId, shared.Gv, session));
			} else {
				return _Utils_Tuple3($author$project$Api$Data$NotAsked, $author$project$Api$Data$NotAsked, $elm$core$Platform$Cmd$none);
			}
		}();
		var cards = _v0.a;
		var bankAccounts = _v0.b;
		var sourcesCmd = _v0.c;
		var _v2 = function () {
			var _v3 = shared.aa4;
			if (_v3.$ === 3) {
				return _Utils_Tuple2(
					$author$project$Api$Data$Loading,
					A3($author$project$Api$Provider$Patient$PaymentMethod$canMigrate, shared.Gv, patientId, $author$project$Components$PaymentMethodsCard$GotPaymentSourcesMigratable));
			} else {
				return _Utils_Tuple2($author$project$Api$Data$NotAsked, $elm$core$Platform$Cmd$none);
			}
		}();
		var paymentSourcesMigratable = _v2.a;
		var migratableCmd = _v2.b;
		return _Utils_Tuple2(
			{
				iw: A2($author$project$Components$PaymentMethodsCard$initAuditTrailLog, shared, patientId),
				rs: bankAccounts,
				rC: cards,
				i_: $author$project$Components$CreatePaymentMethodModal$init,
				dd: shared.dd,
				gc: $elm$core$Maybe$Nothing,
				x: $elm$core$Maybe$Nothing,
				nN: A2($author$project$Ui$FlyoutMenu$init, $author$project$Components$PaymentMethodsCard$flyoutMenuId, $author$project$Components$PaymentMethodsCard$FlyoutMenuMsg),
				gY: $author$project$Components$MovePaymentMethodsModal$init,
				YZ: patientId,
				kA: paymentSourcesMigratable,
				hA: false,
				J: $elm$core$Set$empty
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[sourcesCmd, migratableCmd])));
	});
var $author$project$Layouts$Patient$NotesCardMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$PatientChart$NotesCard$FlaggedDropdownMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$PatientChart$NotesCard$Model = $elm$core$Basics$identity;
var $author$project$Components$PatientChart$NotesCard$GotNotes = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$PatientChart$NotesCard$fetchNotes = F2(
	function (apiClient, model) {
		return A4($author$project$Api$Provider$Note$list, apiClient, model.ks, $elm$core$Basics$identity, $author$project$Components$PatientChart$NotesCard$GotNotes);
	});
var $author$project$Components$PatientChart$NotesCard$init = F6(
	function (apiClient, timeFormatter, baseRoute, query, notable, isPracticeAdmin) {
		var model = {
			aZ: $elm$core$Dict$empty,
			GC: baseRoute,
			jg: $elm$core$Maybe$Nothing,
			ei: $elm$core$Set$empty,
			HN: $author$project$Components$Notes$FlaggedOption$fromQuery(query),
			nM: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'notes-card-flagged-dropdown', al6: $author$project$Components$PatientChart$NotesCard$FlaggedDropdownMsg})),
			ex: $elm$core$Set$empty,
			Im: isPracticeAdmin,
			ks: notable,
			al: $elm$core$Maybe$Nothing,
			kt: $author$project$Api$Data$Loading,
			J7: timeFormatter
		};
		return _Utils_Tuple2(
			model,
			A2($author$project$Components$PatientChart$NotesCard$fetchNotes, apiClient, model));
	});
var $author$project$Layouts$Patient$initNotesCard = F2(
	function (shared, patientId) {
		var query = A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Dict$empty,
			A2($elm$core$Maybe$map, $author$project$Spa$Url$toQueryDict, shared.adY.DE));
		var isPracticeAdmin = function () {
			var _v1 = shared.aa4;
			if (_v1.$ === 3) {
				var session_ = _v1.a;
				return $author$project$Api$Platform$Session$One$userIsPracticeAdmin(session_);
			} else {
				return false;
			}
		}();
		var _v0 = A6(
			$author$project$Components$PatientChart$NotesCard$init,
			shared.Gv,
			shared.J7,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
				{YZ: patientId}),
			query,
			$author$project$Api$Provider$Note$Patient(patientId),
			isPracticeAdmin);
		var m = _v0.a;
		var c = _v0.b;
		return _Utils_Tuple2(
			$elm$core$Maybe$Just(m),
			A2($elm$core$Platform$Cmd$map, $author$project$Layouts$Patient$NotesCardMsg, c));
	});
var $author$project$Api$Feature$UnifiedAppCardLayout = 30;
var $author$project$Components$PatientChart$Helpers$isUnifiedAppCardLayoutEnabled = function (practice) {
	if (practice.$ === 3) {
		var practice_ = practice.a;
		return A2($author$project$Api$Practice$featureEnabled, 30, practice_);
	} else {
		return false;
	}
};
var $author$project$Components$PatientChart$Helpers$isUnifiedExperience = function (practice) {
	if (practice.$ === 3) {
		var practice_ = practice.a;
		return A2($author$project$Api$Practice$featureEnabled, 19, practice_);
	} else {
		return false;
	}
};
var $author$project$Components$PatientChart$Helpers$shouldRenderUnifiedHeader = function (shared) {
	return $author$project$Components$PatientChart$Helpers$isUnifiedExperience(shared.ZV) && $author$project$Components$PatientChart$Helpers$isUnifiedAppCardLayoutEnabled(shared.ZV);
};
var $author$project$Layouts$Patient$init = F2(
	function (shared, patientId) {
		var unified = $author$project$Components$PatientChart$Helpers$shouldRenderUnifiedHeader(shared);
		var _v0 = unified ? A2($author$project$Components$PaymentMethodsCard$init, shared, patientId) : _Utils_Tuple2(
			A2($author$project$Components$PaymentMethodsCard$empty, shared, patientId),
			$elm$core$Platform$Cmd$none);
		var paymentMethodsCard = _v0.a;
		var paymentMethodsCardCmd = _v0.b;
		var _v1 = unified ? A2($author$project$Components$PatientChart$PatientInfoCard$init, shared, patientId) : _Utils_Tuple2(
			$author$project$Components$PatientChart$PatientInfoCard$empty(patientId),
			$elm$core$Platform$Cmd$none);
		var patientInfoCard = _v1.a;
		var patientInfoCardCmd = _v1.b;
		var _v2 = unified ? A2($author$project$Layouts$Patient$initNotesCard, shared, patientId) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
		var notesCardModel = _v2.a;
		var notesCardCmd = _v2.b;
		var _v3 = A2($author$project$Ui$Nav$init, 'patient-nav', $author$project$Layouts$Patient$NavMsg);
		var nav = _v3.a;
		var navCmd = _v3.b;
		var _v4 = unified ? _Utils_Tuple2(
			$author$project$Api$Data$Loading,
			A3($author$project$Api$Provider$Patient$MembershipPatient$list, shared.Gv, patientId, $author$project$Layouts$Patient$GotMembershipPatients)) : _Utils_Tuple2($author$project$Api$Data$NotAsked, $elm$core$Platform$Cmd$none);
		var initialMembershipPatients = _v4.a;
		var membershipsCmd = _v4.b;
		return _Utils_Tuple2(
			{io: $author$project$Api$Data$NotAsked, ahK: shared.ahK, WR: initialMembershipPatients, kp: nav, kq: $author$project$Api$Data$NotAsked, eM: notesCardModel, YY: shared.G9, YZ: patientId, eO: patientInfoCard, eQ: paymentMethodsCard, aa4: shared.aa4},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						navCmd,
						membershipsCmd,
						A2($elm$core$Platform$Cmd$map, $author$project$Layouts$Patient$PaymentMethodsCardMsg, paymentMethodsCardCmd),
						notesCardCmd,
						A2($elm$core$Platform$Cmd$map, $author$project$Layouts$Patient$PatientInfoCardMsg, patientInfoCardCmd)
					])));
	});
var $author$project$Layouts$PatientChart$init = F2(
	function (_v0, patientId) {
		return _Utils_Tuple2(
			{YZ: patientId},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Layouts$User$NavMsg = $elm$core$Basics$identity;
var $author$project$Layouts$User$init = A2(
	$elm$core$Tuple$mapFirst,
	function (nav) {
		return {kp: nav};
	},
	A2($author$project$Ui$Nav$init, 'user-nav', $elm$core$Basics$identity));
var $author$project$Spa$Layout$Route$Admin = {$: 14};
var $author$project$Spa$Layout$Route$Affiliates = {$: 6};
var $author$project$Spa$Layout$Route$AffiliatesAffiliate = function (a) {
	return {$: 7, a: a};
};
var $author$project$Spa$Layout$Route$Application = {$: 1};
var $author$project$Spa$Layout$Route$Clinical = {$: 18};
var $author$project$Spa$Layout$Route$Commissions = {$: 4};
var $author$project$Spa$Layout$Route$CommissionsBrokerAccount = function (a) {
	return {$: 5, a: a};
};
var $author$project$Spa$Layout$Route$Company = function (a) {
	return {$: 13, a: a};
};
var $author$project$Spa$Layout$Route$MarketplaceManage = function (a) {
	return {$: 12, a: a};
};
var $author$project$Spa$Layout$Route$Onboard = {$: 15};
var $author$project$Spa$Layout$Route$PartnerBilling = {$: 8};
var $author$project$Spa$Layout$Route$PartnerPractices = {$: 9};
var $author$project$Spa$Layout$Route$PartnerProduct = {$: 10};
var $author$project$Spa$Layout$Route$PartnerWebhooks = {$: 11};
var $author$project$Spa$Layout$Route$PatientAndSidebar = function (a) {
	return {$: 3, a: a};
};
var $author$project$Spa$Layout$Route$PatientChart = function (a) {
	return {$: 19, a: a};
};
var $author$project$Spa$Layout$Route$PatientsSidebar = {$: 2};
var $author$project$Spa$Layout$Route$PracticeSetup = {$: 16};
var $author$project$Spa$Layout$Route$StyleGuide = {$: 0};
var $author$project$Spa$Layout$Route$User = {$: 17};
var $author$project$Spa$Layout$Route$routeToLayout = function (url) {
	var idRegex = $elm$regex$Regex$fromString('[a-z]+-[a-zA-Z0-9]+');
	var idMatch = function (possibleId) {
		return A2(
			$elm$core$Maybe$andThen,
			function (regex) {
				return A2($elm$regex$Regex$contains, regex, possibleId) ? $elm$core$Maybe$Just(possibleId) : $elm$core$Maybe$Nothing;
			},
			idRegex);
	};
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Spa$Layout$Route$Application,
		function () {
			var _v0 = A2(
				$elm$core$List$filter,
				A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not),
				A2($elm$core$String$split, '/', url.YX));
			_v0$9:
			while (true) {
				_v0$26:
				while (true) {
					_v0$40:
					while (true) {
						if (_v0.b) {
							switch (_v0.a) {
								case 'style_guide':
									return $elm$core$Maybe$Just($author$project$Spa$Layout$Route$StyleGuide);
								case 'onboard':
									return $elm$core$Maybe$Just($author$project$Spa$Layout$Route$Onboard);
								case 'practice_setup':
									return $elm$core$Maybe$Just($author$project$Spa$Layout$Route$PracticeSetup);
								case 'patients':
									if (!_v0.b.b) {
										return $elm$core$Maybe$Just($author$project$Spa$Layout$Route$Application);
									} else {
										if (!_v0.b.b.b) {
											if (_v0.b.a === 'create') {
												var _v1 = _v0.b;
												return $elm$core$Maybe$Just($author$project$Spa$Layout$Route$PatientsSidebar);
											} else {
												break _v0$9;
											}
										} else {
											if (!_v0.b.b.b.b) {
												switch (_v0.b.b.a) {
													case 'chart':
														var _v2 = _v0.b;
														var patientId = _v2.a;
														var _v3 = _v2.b;
														return A2(
															$elm$core$Maybe$map,
															$author$project$Spa$Layout$Route$PatientChart,
															idMatch(patientId));
													case 'growth_chart':
														var _v4 = _v0.b;
														var patientId = _v4.a;
														var _v5 = _v4.b;
														return A2(
															$elm$core$Maybe$map,
															$author$project$Spa$Layout$Route$PatientChart,
															idMatch(patientId));
													case 'lab_trends':
														var _v6 = _v0.b;
														var patientId = _v6.a;
														var _v7 = _v6.b;
														return A2(
															$elm$core$Maybe$map,
															$author$project$Spa$Layout$Route$PatientChart,
															idMatch(patientId));
													case 'vitals_trends':
														var _v8 = _v0.b;
														var patientId = _v8.a;
														var _v9 = _v8.b;
														return A2(
															$elm$core$Maybe$map,
															$author$project$Spa$Layout$Route$PatientChart,
															idMatch(patientId));
													default:
														break _v0$9;
												}
											} else {
												break _v0$9;
											}
										}
									}
								case 'calendar':
									if (!_v0.b.b) {
										return $elm$core$Maybe$Just($author$project$Spa$Layout$Route$Clinical);
									} else {
										break _v0$40;
									}
								case 'home':
									if (!_v0.b.b) {
										return $elm$core$Maybe$Just($author$project$Spa$Layout$Route$Clinical);
									} else {
										break _v0$40;
									}
								case 'contacts':
									return $elm$core$Maybe$Just($author$project$Spa$Layout$Route$Clinical);
								case 'files':
									return $elm$core$Maybe$Just($author$project$Spa$Layout$Route$Clinical);
								case 'forms':
									return $elm$core$Maybe$Just($author$project$Spa$Layout$Route$Clinical);
								case 'google_callback':
									return $elm$core$Maybe$Just($author$project$Spa$Layout$Route$Clinical);
								case 'new_settings':
									return $elm$core$Maybe$Just($author$project$Spa$Layout$Route$Clinical);
								case 'inventory':
									return $elm$core$Maybe$Just($author$project$Spa$Layout$Route$Clinical);
								case 'messages':
									return $elm$core$Maybe$Just($author$project$Spa$Layout$Route$Clinical);
								case 'refill_requests':
									return $elm$core$Maybe$Just($author$project$Spa$Layout$Route$Clinical);
								case 'tasks':
									return $elm$core$Maybe$Just($author$project$Spa$Layout$Route$Clinical);
								case 'companies':
									if (_v0.b.b) {
										var _v11 = _v0.b;
										var companyId = _v11.a;
										return A2(
											$elm$core$Maybe$map,
											$author$project$Spa$Layout$Route$Company,
											idMatch(companyId));
									} else {
										break _v0$40;
									}
								case 'affiliate_bills':
									if (!_v0.b.b) {
										return $elm$core$Maybe$Just($author$project$Spa$Layout$Route$Affiliates);
									} else {
										break _v0$40;
									}
								case 'affiliates':
									if (!_v0.b.b) {
										return $elm$core$Maybe$Just($author$project$Spa$Layout$Route$Affiliates);
									} else {
										if (_v0.b.b.b && (!_v0.b.b.b.b)) {
											switch (_v0.b.b.a) {
												case 'link_providers':
													var _v12 = _v0.b;
													var _v13 = _v12.b;
													return $elm$core$Maybe$Nothing;
												case 'activate_new':
													var _v14 = _v0.b;
													var _v15 = _v14.b;
													return $elm$core$Maybe$Nothing;
												default:
													break _v0$26;
											}
										} else {
											break _v0$26;
										}
									}
								case 'partner':
									if (_v0.b.b) {
										switch (_v0.b.a) {
											case 'billing':
												var _v17 = _v0.b;
												return $elm$core$Maybe$Just($author$project$Spa$Layout$Route$PartnerBilling);
											case 'practices':
												var _v18 = _v0.b;
												return $elm$core$Maybe$Just($author$project$Spa$Layout$Route$PartnerPractices);
											case 'engagements':
												var _v19 = _v0.b;
												return $elm$core$Maybe$Just($author$project$Spa$Layout$Route$PartnerPractices);
											case 'webhooks':
												var _v20 = _v0.b;
												return $elm$core$Maybe$Just($author$project$Spa$Layout$Route$PartnerWebhooks);
											case 'products':
												if (_v0.b.b.b && (_v0.b.b.a === 'new')) {
													var _v21 = _v0.b;
													var _v22 = _v21.b;
													return $elm$core$Maybe$Nothing;
												} else {
													var _v23 = _v0.b;
													return $elm$core$Maybe$Just($author$project$Spa$Layout$Route$PartnerProduct);
												}
											default:
												break _v0$40;
										}
									} else {
										break _v0$40;
									}
								case 'marketplace':
									if ((_v0.b.b && _v0.b.b.b) && (_v0.b.b.a === 'manage')) {
										var _v24 = _v0.b;
										var slug = _v24.a;
										var _v25 = _v24.b;
										return $elm$core$Maybe$Just(
											$author$project$Spa$Layout$Route$MarketplaceManage(slug));
									} else {
										break _v0$40;
									}
								case 'commissions':
									if ((_v0.b.b && (_v0.b.a === 'broker_accounts')) && _v0.b.b.b) {
										var _v26 = _v0.b;
										var _v27 = _v26.b;
										var brokerAccountId = _v27.a;
										return A2(
											$elm$core$Maybe$map,
											$author$project$Spa$Layout$Route$CommissionsBrokerAccount,
											idMatch(brokerAccountId));
									} else {
										return $elm$core$Maybe$Just($author$project$Spa$Layout$Route$Commissions);
									}
								case 'admin':
									return $elm$core$Maybe$Just($author$project$Spa$Layout$Route$Admin);
								case 'user':
									if (_v0.b.b && (_v0.b.a === 'organizations')) {
										var _v28 = _v0.b;
										return $elm$core$Maybe$Nothing;
									} else {
										return $elm$core$Maybe$Just($author$project$Spa$Layout$Route$User);
									}
								case 'account':
									if (_v0.b.b && (_v0.b.a === 'complete')) {
										var _v29 = _v0.b;
										return $elm$core$Maybe$Nothing;
									} else {
										break _v0$40;
									}
								default:
									break _v0$40;
							}
						} else {
							break _v0$40;
						}
					}
					return $elm$core$Maybe$Nothing;
				}
				var _v16 = _v0.b;
				var affiliateId = _v16.a;
				return A2(
					$elm$core$Maybe$map,
					$author$project$Spa$Layout$Route$AffiliatesAffiliate,
					idMatch(affiliateId));
			}
			var _v10 = _v0.b;
			var patientId = _v10.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Spa$Layout$Route$PatientAndSidebar,
				idMatch(patientId));
		}());
};
var $author$project$Spa$Layout$init = function (shared) {
	var route = $author$project$Utils$Route$fromUrl(shared.adY);
	if (_Utils_eq(route, $author$project$Spa$Generated$Route$Blank)) {
		return _Utils_Tuple2($author$project$Spa$Layout$BlankModel, $elm$core$Platform$Cmd$none);
	} else {
		if (_Utils_eq(route, $author$project$Spa$Generated$Route$Account__Complete)) {
			return _Utils_Tuple2($author$project$Spa$Layout$BlankModel, $elm$core$Platform$Cmd$none);
		} else {
			var _v0 = $author$project$Spa$Layout$Route$routeToLayout(shared.adY);
			switch (_v0.$) {
				case 13:
					var companyId = _v0.a;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Platform$Cmd$map($author$project$Spa$Layout$CompanyMsg),
						A2(
							$elm$core$Tuple$mapFirst,
							$author$project$Spa$Layout$CompanyModel(companyId),
							$author$project$Layouts$Company$init));
				case 5:
					var brokerAccountId = _v0.a;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Platform$Cmd$map($author$project$Spa$Layout$CommissionsBrokerAccountMsg),
						A2(
							$elm$core$Tuple$mapFirst,
							$author$project$Spa$Layout$CommissionsBrokerAccountModel(brokerAccountId),
							A2($author$project$Layouts$Commissions$BrokerAccount$init, shared, brokerAccountId)));
				case 4:
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Platform$Cmd$map($author$project$Spa$Layout$CommissionsMsg),
						A2($elm$core$Tuple$mapFirst, $author$project$Spa$Layout$CommissionsModel, $author$project$Layouts$Commissions$init));
				case 7:
					var affiliateId = _v0.a;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Platform$Cmd$map($author$project$Spa$Layout$AffiliatesAffiliateMsg),
						A2(
							$elm$core$Tuple$mapFirst,
							$author$project$Spa$Layout$AffiliatesAffiliateModel(affiliateId),
							A2($author$project$Layouts$Affiliates$Affiliate$init, shared, affiliateId)));
				case 6:
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Platform$Cmd$map($author$project$Spa$Layout$AffiliatesMsg),
						A2($elm$core$Tuple$mapFirst, $author$project$Spa$Layout$AffiliatesModel, $author$project$Layouts$Affiliates$init));
				case 8:
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Platform$Cmd$map($author$project$Spa$Layout$PartnerBillingMsg),
						A2($elm$core$Tuple$mapFirst, $author$project$Spa$Layout$PartnerBillingModel, $author$project$Layouts$Partner$Billing$init));
				case 9:
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Platform$Cmd$map($author$project$Spa$Layout$PartnerPracticesMsg),
						A2($elm$core$Tuple$mapFirst, $author$project$Spa$Layout$PartnerPracticesModel, $author$project$Layouts$Partner$Practices$init));
				case 10:
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Platform$Cmd$map($author$project$Spa$Layout$PartnerProductMsg),
						A2($elm$core$Tuple$mapFirst, $author$project$Spa$Layout$PartnerProductModel, $author$project$Layouts$Partner$Product$init));
				case 11:
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Platform$Cmd$map($author$project$Spa$Layout$PartnerWebhooksMsg),
						A2($elm$core$Tuple$mapFirst, $author$project$Spa$Layout$PartnerWebhooksModel, $author$project$Layouts$Partner$Webhooks$init));
				case 12:
					var slug = _v0.a;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Platform$Cmd$map($author$project$Spa$Layout$MarketplaceManageMsg),
						A2(
							$elm$core$Tuple$mapFirst,
							$author$project$Spa$Layout$MarketplaceManageModel(slug),
							A2($author$project$Layouts$Marketplace$Manage$init, shared.Gv, slug)));
				case 14:
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Platform$Cmd$map($author$project$Spa$Layout$AdminMsg),
						A2(
							$elm$core$Tuple$mapFirst,
							$author$project$Spa$Layout$AdminModel,
							$author$project$Layouts$Admin$init(shared)));
				case 3:
					var id = _v0.a;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Platform$Cmd$map($author$project$Spa$Layout$PatientMsg),
						A2(
							$elm$core$Tuple$mapFirst,
							$author$project$Spa$Layout$PatientAndSidebarModel(id),
							A2($author$project$Layouts$Patient$init, shared, id)));
				case 17:
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Platform$Cmd$map($author$project$Spa$Layout$UserMsg),
						A2($elm$core$Tuple$mapFirst, $author$project$Spa$Layout$UserModel, $author$project$Layouts$User$init));
				case 1:
					return _Utils_Tuple2($author$project$Spa$Layout$ApplicationModel, $elm$core$Platform$Cmd$none);
				case 2:
					return _Utils_Tuple2($author$project$Spa$Layout$PatientsSidebarModel, $elm$core$Platform$Cmd$none);
				case 15:
					return _Utils_Tuple2($author$project$Spa$Layout$OnboardModel, $elm$core$Platform$Cmd$none);
				case 16:
					return _Utils_Tuple2($author$project$Spa$Layout$PracticeSetupModel, $elm$core$Platform$Cmd$none);
				case 0:
					return _Utils_Tuple2($author$project$Spa$Layout$StyleGuideModel, $elm$core$Platform$Cmd$none);
				case 18:
					return _Utils_Tuple2($author$project$Spa$Layout$ClinicalModel, $elm$core$Platform$Cmd$none);
				default:
					var patientId = _v0.a;
					return A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Spa$Layout$PatientChartModel(patientId),
						A2($author$project$Layouts$PatientChart$init, shared, patientId));
			}
		}
	}
};
var $author$project$Ports$Sentry$captureErrorMessage = _Platform_outgoingPort('captureErrorMessage', $elm$json$Json$Encode$string);
var $author$project$Main$defaultUrl = A6($elm$url$Url$Url, 0, 'localhost', $elm$core$Maybe$Nothing, '', $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
var $author$project$Main$locationHrefToUrl = function (locationHref) {
	var _v0 = $elm$url$Url$fromString(locationHref);
	if (!_v0.$) {
		var url = _v0.a;
		return _Utils_Tuple2(url, $elm$core$Platform$Cmd$none);
	} else {
		return _Utils_Tuple2(
			$author$project$Main$defaultUrl,
			$author$project$Ports$Sentry$captureErrorMessage('Url.fromString Failed: ' + locationHref));
	}
};
var $author$project$Shared$BackupAuthOrganizationSwitched = F2(
	function (a, b) {
		return {$: 19, a: a, b: b};
	});
var $author$project$OutMsg$GoToClinicalAction = {$: 4};
var $author$project$Shared$GotCompany = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Shared$GotPatient = F2(
	function (a, b) {
		return {$: 24, a: a, b: b};
	});
var $author$project$Shared$GotRoleSwitched = function (a) {
	return {$: 30, a: a};
};
var $author$project$Shared$NavbarMsg = function (a) {
	return {$: 17, a: a};
};
var $author$project$Shared$PatientsListMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$PatientsList$RefreshPatients = {$: 14};
var $author$project$Shared$ToastMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Ports$Sentry$captureDebugMessage = _Platform_outgoingPort('captureDebugMessage', $elm$json$Json$Encode$string);
var $author$project$Shared$decodeErrorToMsg = function (error) {
	return $author$project$Ports$Sentry$captureErrorMessage('Decoder Failed: ' + error);
};
var $author$project$Api$WhitelabelSetting$empty = {GJ: '', GK: true, I4: $elm$core$Maybe$Nothing, Jd: '', Je: '', Jf: '', Jg: 'App Logo', Jh: $elm$core$Maybe$Nothing};
var $author$project$Api$Practice$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Navbar$CompanyNav = function (a) {
	return {$: 2, a: a};
};
var $author$project$Navbar$CompanyNavbarMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Navbar$Model = $elm$core$Basics$identity;
var $author$project$Navbar$GotHeaderEndElement = function (a) {
	return {$: 4, a: a};
};
var $elm$browser$Browser$Dom$getElement = _Browser_getElement;
var $author$project$Navbar$getHeaderEnd = A2(
	$elm$core$Task$attempt,
	$author$project$Navbar$GotHeaderEndElement,
	$elm$browser$Browser$Dom$getElement('topnav-end'));
var $author$project$Navbars$Company$Model = $elm$core$Basics$identity;
var $author$project$Navbars$Company$ProfileMenuMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Platform$User$Shared$canSwitchOrganizations = function (_v0) {
	var record = _v0;
	return record.Nk;
};
var $author$project$Navbars$Company$initSessionConfiguration = function (session) {
	var showSideNav_ = function (_v0) {
		return true;
	};
	var isViewingAsHinter = $author$project$Utils$User$isViewingAsHinter(session);
	return {
		Nk: A2($elm$core$Basics$composeR, $author$project$Api$Platform$Session$One$user, $author$project$Api$Platform$User$Shared$canSwitchOrganizations)(session),
		Aq: isViewingAsHinter,
		ajF: A2(
			$elm$core$Maybe$map,
			function (org) {
				return $author$project$Api$Platform$Organization$Shared$type_(org);
			},
			$author$project$Api$Platform$Session$One$organization(session)),
		Yx: A2(
			$elm$core$Maybe$andThen,
			$author$project$Api$Common$RequestDetail$Shared$osName,
			$author$project$Api$Platform$Session$One$requestDetail(session)),
		abq: showSideNav_,
		amm: A2($elm$core$Basics$composeR, $author$project$Api$Platform$Session$One$user, $author$project$Api$Platform$User$Shared$name)(session)
	};
};
var $author$project$Navbars$Company$Account = 6;
var $author$project$Navbars$Company$AccountAndPricing = 5;
var $author$project$Navbars$Company$EmployeeUploads = 3;
var $author$project$Navbars$Company$Employees = 0;
var $author$project$Navbars$Company$Invoices = 1;
var $author$project$Navbars$Company$OnlineSignup = 4;
var $author$project$Navbars$Company$PaymentMethods = 2;
var $author$project$Navbars$Company$navItemFromUrl = function (url) {
	var pathList = A2(
		$elm$core$List$drop,
		1,
		A2($elm$core$String$split, '/', url.YX));
	_v0$2:
	while (true) {
		if (pathList.b) {
			switch (pathList.a) {
				case 'companies':
					var tail = pathList.b;
					var companySubpath = A2($elm$core$List$drop, 1, tail);
					if (companySubpath.b) {
						switch (companySubpath.a) {
							case 'employees':
								return 0;
							case 'invoices':
								return 1;
							case 'payment_sources':
								return 2;
							case 'uploads':
								return 3;
							case 'signup':
								return 4;
							default:
								return 0;
						}
					} else {
						return 5;
					}
				case 'user':
					return 6;
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return 0;
};
var $author$project$Navbars$Company$None = 1;
var $author$project$Navbars$Company$ProfileNav = 0;
var $author$project$Navbars$Company$openSubNavFromSelectedNav = function (selectedNav) {
	if (selectedNav === 6) {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$Navbars$Company$init = function (_v0) {
	var url = _v0.adY;
	var session = _v0.aa4;
	var practice = _v0.ZV;
	var company = _v0.afQ;
	var whitelabelSetting = _v0.aey;
	var selectedNav = $author$project$Navbars$Company$navItemFromUrl(url);
	return _Utils_Tuple2(
		{
			afQ: company,
			dw: $author$project$Navbars$Company$openSubNavFromSelectedNav(selectedNav),
			ZV: practice,
			eZ: A2($author$project$Ui$FlyoutMenu$init, 'profile-menu', $author$project$Navbars$Company$ProfileMenuMsg),
			fd: selectedNav,
			aa4: session,
			Ex: $author$project$Navbars$Company$initSessionConfiguration(session),
			qh: false,
			aey: whitelabelSetting
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Navbar$andInitEmployerNavbar = F4(
	function (practice, whitelabelSetting, company, _v0) {
		var model = _v0;
		return function (_v1) {
			var nav = _v1.a;
			var cmd = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{ai: nav}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[cmd, $author$project$Navbar$getHeaderEnd])));
		}(
			A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Platform$Cmd$map($author$project$Navbar$CompanyNavbarMsg),
				A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Navbar$CompanyNav,
					$author$project$Navbars$Company$init(
						{afQ: company, ZV: practice, aa4: model.aa4, adY: model.adY, aey: whitelabelSetting}))));
	});
var $author$project$Navbar$NoNav = {$: 0};
var $author$project$Navbar$init = F3(
	function (session, practice, flags) {
		return {agP: flags.agP, ahK: flags.ahK, sF: flags.sF, ai: $author$project$Navbar$NoNav, ajG: flags.ajG, ZV: practice, aa4: session, abr: false, adY: flags.adY};
	});
var $author$project$Navbar$initForEmployer = F5(
	function (session, whitelabelSetting, practice, company, flags) {
		return A4(
			$author$project$Navbar$andInitEmployerNavbar,
			practice,
			whitelabelSetting,
			company,
			A3(
				$author$project$Navbar$init,
				session,
				$elm$core$Maybe$Just(
					$author$project$Api$Practice$Employer(practice)),
				flags));
	});
var $author$project$Navbar$PartnerNav = function (a) {
	return {$: 3, a: a};
};
var $author$project$Navbar$PartnerNavbarMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Navbars$Partner$Model = $elm$core$Basics$identity;
var $author$project$Navbars$HinterIdButtons$Partner = function (a) {
	return {$: 1, a: a};
};
var $author$project$Navbars$Partner$ProfileMenuMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Navbars$HinterIdButtons$Model = $elm$core$Basics$identity;
var $author$project$Navbars$HinterIdButtons$init = F2(
	function (resource, organizationId) {
		return {ajD: organizationId, Jy: resource};
	});
var $author$project$Navbars$Partner$initSessionConfiguration = function (session) {
	var showSideNav_ = function (_v0) {
		return true;
	};
	var isViewingAsHinter = $author$project$Utils$User$isViewingAsHinter(session);
	return {
		Nk: A2($elm$core$Basics$composeR, $author$project$Api$Platform$Session$One$user, $author$project$Api$Platform$User$Shared$canSwitchOrganizations)(session),
		Aq: isViewingAsHinter,
		ajF: A2(
			$elm$core$Maybe$map,
			function (org) {
				return $author$project$Api$Platform$Organization$Shared$type_(org);
			},
			$author$project$Api$Platform$Session$One$organization(session)),
		Yx: A2(
			$elm$core$Maybe$andThen,
			$author$project$Api$Common$RequestDetail$Shared$osName,
			$author$project$Api$Platform$Session$One$requestDetail(session)),
		abq: showSideNav_,
		amm: A2($elm$core$Basics$composeR, $author$project$Api$Platform$Session$One$user, $author$project$Api$Platform$User$Shared$name)(session)
	};
};
var $author$project$Navbars$Partner$Account = 8;
var $author$project$Navbars$Partner$Marketplace = 9;
var $author$project$Navbars$Partner$PartnerApiKeys = 3;
var $author$project$Navbars$Partner$PartnerBilling = 2;
var $author$project$Navbars$Partner$PartnerHinter = 1;
var $author$project$Navbars$Partner$PartnerPractices = 5;
var $author$project$Navbars$Partner$PartnerProducts = 7;
var $author$project$Navbars$Partner$PartnerSandboxes = 6;
var $author$project$Navbars$Partner$PartnerTeam = 0;
var $author$project$Navbars$Partner$PartnerWebhooks = 4;
var $author$project$Navbars$Partner$navItemFromUrl = function (url) {
	var pathList = A2(
		$elm$core$List$drop,
		1,
		A2($elm$core$String$split, '/', url.YX));
	_v0$3:
	while (true) {
		if (pathList.b) {
			switch (pathList.a) {
				case 'partner':
					var partnerSubpath = pathList.b;
					_v1$10:
					while (true) {
						if (partnerSubpath.b) {
							switch (partnerSubpath.a) {
								case 'team':
									return 0;
								case 'api_keys':
									return 3;
								case 'webhooks':
									return 4;
								case 'practices':
									return 5;
								case 'engagements':
									return 5;
								case 'hinter':
									return 1;
								case 'billing':
									return 2;
								case 'dashboard':
									return 7;
								case 'product':
									return 7;
								case 'sandboxes':
									return 6;
								default:
									break _v1$10;
							}
						} else {
							break _v1$10;
						}
					}
					return 0;
				case 'user':
					return 8;
				case 'marketplace':
					return 9;
				default:
					break _v0$3;
			}
		} else {
			break _v0$3;
		}
	}
	return 0;
};
var $author$project$Navbars$Partner$None = 1;
var $author$project$Navbars$Partner$ProfileNav = 0;
var $author$project$Navbars$Partner$openSubNavFromSelectedNav = function (selectedNav) {
	if (selectedNav === 8) {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$Navbars$Partner$init = function (_v0) {
	var url = _v0.adY;
	var session = _v0.aa4;
	var partner = _v0.YN;
	var selectedNav = $author$project$Navbars$Partner$navItemFromUrl(url);
	return _Utils_Tuple2(
		{
			sz: A2(
				$author$project$Navbars$HinterIdButtons$init,
				$author$project$Navbars$HinterIdButtons$Partner(
					$author$project$Api$Partner$Partner$One$id(partner)),
				$author$project$Api$Partner$Partner$One$organizationId(partner)),
			dw: $author$project$Navbars$Partner$openSubNavFromSelectedNav(selectedNav),
			YN: partner,
			eZ: A2($author$project$Ui$FlyoutMenu$init, 'profile-menu', $author$project$Navbars$Partner$ProfileMenuMsg),
			fd: selectedNav,
			aa4: session,
			Ex: $author$project$Navbars$Partner$initSessionConfiguration(session),
			qh: false
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Navbar$andInitPartnerNavbar = F2(
	function (partner, _v0) {
		var model = _v0;
		return function (_v1) {
			var nav = _v1.a;
			var cmd = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{ai: nav}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[cmd, $author$project$Navbar$getHeaderEnd])));
		}(
			A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Platform$Cmd$map($author$project$Navbar$PartnerNavbarMsg),
				A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Navbar$PartnerNav,
					$author$project$Navbars$Partner$init(
						{YN: partner, aa4: model.aa4, adY: model.adY}))));
	});
var $author$project$Navbar$initForPartner = F3(
	function (session, partner, flags) {
		return A2(
			$author$project$Navbar$andInitPartnerNavbar,
			partner,
			A3($author$project$Navbar$init, session, $elm$core$Maybe$Nothing, flags));
	});
var $author$project$Navbar$PracticeNav = function (a) {
	return {$: 1, a: a};
};
var $author$project$Navbar$PracticeNavbarMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Navbars$Practice$AdminMenuMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Navbars$Practice$GotBookmarks = function (a) {
	return {$: 22, a: a};
};
var $author$project$Navbars$Practice$GotCurrentDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Navbars$Practice$GotEmbeddedReports = function (a) {
	return {$: 1, a: a};
};
var $author$project$Navbars$Practice$GotPartnerApps = function (a) {
	return {$: 18, a: a};
};
var $author$project$Navbars$Practice$GotReports = function (a) {
	return {$: 14, a: a};
};
var $author$project$Navbars$Practice$MobileBookmarkIdle = {$: 0};
var $author$project$Navbars$Practice$Model = $elm$core$Basics$identity;
var $author$project$Navbars$HinterIdButtons$Practice = function (a) {
	return {$: 0, a: a};
};
var $author$project$Navbars$Practice$ProfileMenuMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Navbars$Practice$ReportMenuMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Navbars$Practice$SwitchProductDropDownMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Feature$ManageDataExports = 18;
var $author$project$Api$Feature$NavBookmarking = 24;
var $author$project$Api$Provider$Practice$One$customLogoUrl = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Pq;
	});
var $author$project$Navbars$Practice$buildPracticeConfig = function (practice) {
	return {
		MN: A2($author$project$Api$Provider$Practice$One$featureEnabled, 15, practice) || A2($author$project$Api$Provider$Practice$One$featureEnabled, 16, practice),
		N5: $author$project$Api$Provider$Practice$One$commissionsEnabled(practice),
		Pp: $author$project$Api$Provider$Practice$One$customLogoUrl(practice),
		Py: A2($author$project$Api$Provider$Practice$One$featureEnabled, 18, practice),
		Ib: A2(
			$author$project$Utils$FeatureGate$gateAvailable,
			2,
			$author$project$Api$Practice$Provider(practice)),
		U_: $author$project$Api$Provider$Practice$One$isNetwork(practice),
		Ix: A2(
			$author$project$Utils$FeatureGate$gateAvailable,
			9,
			$author$project$Api$Practice$Provider(practice)),
		ax: A2($author$project$Api$Provider$Practice$One$featureEnabled, 24, practice),
		CI: A2(
			$author$project$Utils$FeatureGate$gateAvailable,
			4,
			$author$project$Api$Practice$Provider(practice)),
		acH: A2($author$project$Api$Provider$Practice$One$featureEnabled, 6, practice),
		qJ: A2($author$project$Api$Provider$Practice$One$featureEnabled, 19, practice)
	};
};
var $author$project$Navbars$Practice$BookmarkedMenuMsg = function (a) {
	return {$: 29, a: a};
};
var $author$project$Navbars$Practice$closedBookmarkedMenu = A2($author$project$Ui$FlyoutMenu$init, 'bookmarked-menu', $author$project$Navbars$Practice$BookmarkedMenuMsg);
var $author$project$Components$HinterPracticeSettingsModal$Closed = {$: 0};
var $author$project$Components$HinterPracticeSettingsModal$init = $author$project$Components$HinterPracticeSettingsModal$Closed;
var $author$project$Api$Platform$Organization$Shared$accountType = function (_v0) {
	var record = _v0.b;
	return record.KJ;
};
var $author$project$Api$Platform$Session$One$accountType = function (_v0) {
	var record = _v0;
	return A2($elm$core$Maybe$map, $author$project$Api$Platform$Organization$Shared$accountType, record.Yr);
};
var $author$project$Navbars$Practice$initSessionConfiguration = function (session) {
	var requiresPaymentInformation = A2(
		$elm$core$Maybe$withDefault,
		true,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Platform$Organization$Shared$requiresPaymentInformation,
			$author$project$Api$Platform$Session$One$organization(session)));
	var practiceIsOnboarding = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Platform$Organization$Shared$practiceIsOnboarding,
			$author$project$Api$Platform$Session$One$organization(session)));
	var isViewingAsHinter = $author$project$Utils$User$isViewingAsHinter(session);
	var showSideNav_ = function (hinterViewOff) {
		return ((practiceIsOnboarding && (!isViewingAsHinter(hinterViewOff))) || ($author$project$Api$Platform$Session$One$role(session) === 'practice_practice_billing_only')) ? false : (isViewingAsHinter(hinterViewOff) ? true : (!requiresPaymentInformation));
	};
	var canGoToReports = function (hinterViewOff) {
		return A3($author$project$Permission$canGoTo, session, hinterViewOff, 51);
	};
	var canGoToPatients = function (hinterViewOff) {
		return A3($author$project$Permission$canGoTo, session, hinterViewOff, 50);
	};
	var canSearch = function (hinterViewOff) {
		return canGoToPatients(hinterViewOff) && (!requiresPaymentInformation);
	};
	var canGoToNetwork = function (hinterViewOff) {
		return A3($author$project$Permission$canGoTo, session, hinterViewOff, 56);
	};
	var canGoToCompanies = function (hinterViewOff) {
		return A3($author$project$Permission$canGoTo, session, hinterViewOff, 17);
	};
	var canGoToCommissions = function (hinterViewOff) {
		return A3($author$project$Permission$canGoTo, session, hinterViewOff, 52);
	};
	var canGoToBookkeeping = function (hinterViewOff) {
		return A3($author$project$Permission$canGoTo, session, hinterViewOff, 59);
	};
	var canGoToAdmin = function (hinterViewOff) {
		return A3($author$project$Permission$canGoTo, session, hinterViewOff, 0);
	};
	return {
		KJ: $author$project$Api$Platform$Session$One$accountType(session),
		GO: canGoToAdmin,
		M9: canGoToBookkeeping,
		Na: canGoToCommissions,
		Nb: canGoToCompanies,
		Nc: canGoToNetwork,
		GQ: canGoToPatients,
		xO: canGoToReports,
		xQ: canSearch,
		ZX: practiceIsOnboarding,
		lk: {
			Nk: A2($elm$core$Basics$composeR, $author$project$Api$Platform$Session$One$user, $author$project$Api$Platform$User$Shared$canSwitchOrganizations)(session),
			Aq: isViewingAsHinter,
			ajF: A2(
				$elm$core$Maybe$map,
				function (org) {
					return $author$project$Api$Platform$Organization$Shared$type_(org);
				},
				$author$project$Api$Platform$Session$One$organization(session)),
			Yx: A2(
				$elm$core$Maybe$andThen,
				$author$project$Api$Common$RequestDetail$Shared$osName,
				$author$project$Api$Platform$Session$One$requestDetail(session)),
			abq: showSideNav_,
			amm: A2($elm$core$Basics$composeR, $author$project$Api$Platform$Session$One$user, $author$project$Api$Platform$User$Shared$name)(session)
		}
	};
};
var $author$project$Api$Provider$EmbeddedReport$All$EmbeddedReport = $elm$core$Basics$identity;
var $author$project$Api$Provider$EmbeddedReport$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$EmbeddedReport$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$EmbeddedReport$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$EmbeddedReport$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$EmbeddedReport$embeddedReportsPath));
	});
var $author$project$Api$Provider$NavBookmark$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			A2(
				$elm$json$Json$Decode$field,
				'bookmarks',
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['nav_bookmarks']),
					$author$project$Api$Data$providerPath)));
	});
var $author$project$Api$Common$PartnerApp$All$PartnerApp = $elm$core$Basics$identity;
var $author$project$Api$Common$PartnerApp$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$PartnerApp$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PartnerApp$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Common$PartnerApp$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$PartnerApp$partnerAppsPath));
	});
var $author$project$Api$Provider$Report$All$Record = function (id) {
	return {ahP: id};
};
var $author$project$Api$Provider$Report$All$Report = $elm$core$Basics$identity;
var $author$project$Api$Provider$Report$All$decoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A2(
		$elm$json$Json$Decode$map,
		$author$project$Api$Provider$Report$All$Record,
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['id']),
			$elm$json$Json$Decode$string)));
var $author$project$Api$Provider$Report$reportsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['reports']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Report$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Report$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Report$reportsPath));
	});
var $author$project$Navbars$Practice$Navigation$Account = {$: 5};
var $author$project$Navbars$Practice$Navigation$Admin = function (a) {
	return {$: 14, a: a};
};
var $author$project$Navbars$Practice$Navigation$AppointmentTypes = 14;
var $author$project$Navbars$Practice$Navigation$Bookkeeping = {$: 6};
var $author$project$Navbars$Practice$Navigation$Calendar = {$: 1};
var $author$project$Navbars$Practice$Navigation$CalendarLocations = 13;
var $author$project$Navbars$Practice$Navigation$ChargeItems = 5;
var $author$project$Navbars$Practice$Navigation$ClinicalDashboard = {$: 7};
var $author$project$Navbars$Practice$Navigation$Commissions = {$: 4};
var $author$project$Navbars$Practice$Navigation$CommissionsSetup = 6;
var $author$project$Navbars$Practice$Navigation$CompanyInvoices = {$: 5};
var $author$project$Navbars$Practice$Navigation$Contacts = {$: 11};
var $author$project$Navbars$Practice$Navigation$CreditCategories = 4;
var $author$project$Navbars$Practice$Navigation$CreditOutstanding = {$: 6};
var $author$project$Navbars$Practice$Navigation$CreditTransactions = {$: 11};
var $author$project$Navbars$Practice$Navigation$Custom = function (a) {
	return {$: 14, a: a};
};
var $author$project$Navbars$Practice$Navigation$Dashboard = {$: 0};
var $author$project$Navbars$Practice$Navigation$DataExport = 12;
var $author$project$Navbars$Practice$Navigation$DeferredRevenue = {$: 8};
var $author$project$Navbars$Practice$Navigation$Deposits = {$: 12};
var $author$project$Navbars$Practice$Navigation$Developers = 19;
var $author$project$Navbars$Practice$Navigation$Documents = 11;
var $author$project$Navbars$Practice$Navigation$ERx = 15;
var $author$project$Navbars$Practice$Navigation$FileDrive = 17;
var $author$project$Navbars$Practice$Navigation$Forms = {$: 10};
var $author$project$Navbars$Practice$Navigation$Help = function (a) {
	return {$: 16, a: a};
};
var $author$project$Navbars$Practice$Navigation$HipaaAuthorizations = 8;
var $author$project$Navbars$Practice$Navigation$Inbox = {$: 8};
var $author$project$Navbars$Practice$Navigation$Integrations = 9;
var $author$project$Navbars$Practice$Navigation$InvoiceSettings = 10;
var $author$project$Navbars$Practice$Navigation$Invoices = {$: 4};
var $author$project$Navbars$Practice$Navigation$Marketplace = {$: 18};
var $author$project$Navbars$Practice$Navigation$Medications = 16;
var $author$project$Navbars$Practice$Navigation$MembershipOptions = 2;
var $author$project$Navbars$Practice$Navigation$Memberships = {$: 3};
var $author$project$Navbars$Practice$Navigation$Months = {$: 1};
var $author$project$Navbars$Practice$Navigation$Networks = {$: 3};
var $author$project$Navbars$Practice$Navigation$NotificationsPatient = 7;
var $author$project$Navbars$Practice$Navigation$PartnerApp = function (a) {
	return {$: 17, a: a};
};
var $author$project$Navbars$Practice$Navigation$PatientPackages = {$: 9};
var $author$project$Navbars$Practice$Navigation$Patients = {$: 0};
var $author$project$Navbars$Practice$Navigation$PaymentApplications = {$: 10};
var $author$project$Navbars$Practice$Navigation$Phones = 20;
var $author$project$Navbars$Practice$Navigation$Practice = 0;
var $author$project$Navbars$Practice$Navigation$Providers = 1;
var $author$project$Navbars$Practice$Navigation$Reports = function (a) {
	return {$: 12, a: a};
};
var $author$project$Navbars$Practice$Navigation$Revenue = {$: 7};
var $author$project$Navbars$Practice$Navigation$SalesTax = {$: 13};
var $author$project$Navbars$Practice$Navigation$Signup = 3;
var $author$project$Navbars$Practice$Navigation$SignupAttempts = {$: 2};
var $author$project$Navbars$Practice$Navigation$Sponsors = {$: 2};
var $author$project$Navbars$Practice$Navigation$Support = 0;
var $author$project$Navbars$Practice$Navigation$Tasks = {$: 9};
var $author$project$Navbars$Practice$Navigation$Team = 21;
var $author$project$Navbars$Practice$Navigation$Templates = 18;
var $author$project$Navbars$Practice$Navigation$navItemFromUrl = function (url) {
	var pathList = A2(
		$elm$core$List$drop,
		1,
		A2($elm$core$String$split, '/', url.YX));
	_v0$23:
	while (true) {
		_v0$27:
		while (true) {
			if (pathList.b) {
				switch (pathList.a) {
					case 'calendar':
						return $author$project$Navbars$Practice$Navigation$Calendar;
					case 'patients':
						return $author$project$Navbars$Practice$Navigation$Patients;
					case 'companies':
						return $author$project$Navbars$Practice$Navigation$Sponsors;
					case 'affiliate_bills':
						return $author$project$Navbars$Practice$Navigation$Networks;
					case 'affiliates':
						return $author$project$Navbars$Practice$Navigation$Networks;
					case 'commissions':
						return $author$project$Navbars$Practice$Navigation$Commissions;
					case 'reports':
						var tail = pathList.b;
						_v1$15:
						while (true) {
							if (tail.b) {
								switch (tail.a) {
									case 'dashboard':
										return $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$Dashboard);
									case 'months':
										return $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$Months);
									case 'signup_attempts':
										return $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$SignupAttempts);
									case 'memberships':
										return $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$Memberships);
									case 'invoices':
										return $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$Invoices);
									case 'company_invoices':
										return $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$CompanyInvoices);
									case 'credit_outstanding':
										return $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$CreditOutstanding);
									case 'revenue':
										return $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$Revenue);
									case 'deferred_revenue':
										return $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$DeferredRevenue);
									case 'patient_packages':
										return $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$PatientPackages);
									case 'payment_applications':
										return $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$PaymentApplications);
									case 'credit_transactions':
										return $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$CreditTransactions);
									case 'deposits':
										return $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$Deposits);
									case 'sales_tax':
										return $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$SalesTax);
									case 'custom':
										if (tail.b.b) {
											var _v2 = tail.b;
											var id = _v2.a;
											return $author$project$Navbars$Practice$Navigation$Reports(
												$author$project$Navbars$Practice$Navigation$Custom(id));
										} else {
											break _v1$15;
										}
									default:
										break _v1$15;
								}
							} else {
								break _v1$15;
							}
						}
						return $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$Dashboard);
					case 'admin':
						var tail = pathList.b;
						_v3$44:
						while (true) {
							if (tail.b) {
								switch (tail.a) {
									case 'practice':
										return $author$project$Navbars$Practice$Navigation$Admin(0);
									case 'team':
										return $author$project$Navbars$Practice$Navigation$Admin(0);
									case 'phones':
										return $author$project$Navbars$Practice$Navigation$Admin(0);
									case 'billing':
										return $author$project$Navbars$Practice$Navigation$Admin(0);
									case 'payment_sources':
										return $author$project$Navbars$Practice$Navigation$Admin(0);
									case 'notes':
										return $author$project$Navbars$Practice$Navigation$Admin(0);
									case 'features':
										return $author$project$Navbars$Practice$Navigation$Admin(0);
									case 'scheduled_jobs':
										return $author$project$Navbars$Practice$Navigation$Admin(0);
									case 'providers':
										return $author$project$Navbars$Practice$Navigation$Admin(1);
									case 'patients':
										return $author$project$Navbars$Practice$Navigation$Admin(1);
									case 'locations':
										return $author$project$Navbars$Practice$Navigation$Admin(1);
									case 'provider_groups':
										return $author$project$Navbars$Practice$Navigation$Admin(1);
									case 'plans':
										return $author$project$Navbars$Practice$Navigation$Admin(2);
									case 'coverage_plans':
										return $author$project$Navbars$Practice$Navigation$Admin(2);
									case 'coupons':
										return $author$project$Navbars$Practice$Navigation$Admin(2);
									case 'cancellation_reasons':
										return $author$project$Navbars$Practice$Navigation$Admin(2);
									case 'advance_billing':
										return $author$project$Navbars$Practice$Navigation$Admin(2);
									case 'signup':
										return $author$project$Navbars$Practice$Navigation$Admin(3);
									case 'signup_pages':
										return $author$project$Navbars$Practice$Navigation$Admin(3);
									case 'self_service':
										return $author$project$Navbars$Practice$Navigation$Admin(3);
									case 'lead_sources':
										return $author$project$Navbars$Practice$Navigation$Admin(3);
									case 'credit_categories':
										return $author$project$Navbars$Practice$Navigation$Admin(4);
									case 'credits':
										return $author$project$Navbars$Practice$Navigation$Admin(4);
									case 'charge_items':
										return $author$project$Navbars$Practice$Navigation$Admin(5);
									case 'categories':
										return $author$project$Navbars$Practice$Navigation$Admin(5);
									case 'taxes':
										return $author$project$Navbars$Practice$Navigation$Admin(5);
									case 'commissions':
										return $author$project$Navbars$Practice$Navigation$Admin(6);
									case 'notifications':
										return $author$project$Navbars$Practice$Navigation$Admin(7);
									case 'hipaa_authorizations':
										return $author$project$Navbars$Practice$Navigation$Admin(8);
									case 'stripe':
										return $author$project$Navbars$Practice$Navigation$Admin(9);
									case 'card_readers':
										return $author$project$Navbars$Practice$Navigation$Admin(9);
									case 'quickbooks':
										return $author$project$Navbars$Practice$Navigation$Admin(9);
									case 'elation':
										return $author$project$Navbars$Practice$Navigation$Admin(9);
									case 'athenahealth':
										return $author$project$Navbars$Practice$Navigation$Admin(9);
									case 'google_analytics':
										return $author$project$Navbars$Practice$Navigation$Admin(9);
									case 'integrations':
										return $author$project$Navbars$Practice$Navigation$Admin(9);
									case 'invoice_settings':
										return $author$project$Navbars$Practice$Navigation$Admin(10);
									case 'company_plans':
										return $author$project$Navbars$Practice$Navigation$Admin(10);
									case 'documents':
										return $author$project$Navbars$Practice$Navigation$Admin(11);
									case 'data_export':
										return $author$project$Navbars$Practice$Navigation$Admin(12);
									case 'calendar':
										return $author$project$Navbars$Practice$Navigation$Admin(13);
									case 'appointment_types':
										return $author$project$Navbars$Practice$Navigation$Admin(14);
									case 'erx':
										return $author$project$Navbars$Practice$Navigation$Admin(15);
									case 'developers':
										return $author$project$Navbars$Practice$Navigation$Admin(19);
									default:
										break _v3$44;
								}
							} else {
								break _v3$44;
							}
						}
						return $author$project$Navbars$Practice$Navigation$Admin(0);
					case 'support':
						return $author$project$Navbars$Practice$Navigation$Help(0);
					case 'user':
						return $author$project$Navbars$Practice$Navigation$Account;
					case 'bookkeeping':
						return $author$project$Navbars$Practice$Navigation$Bookkeeping;
					case 'marketplace':
						return $author$project$Navbars$Practice$Navigation$Marketplace;
					case 'apps':
						if (pathList.b.b && (!pathList.b.b.b)) {
							var _v10 = pathList.b;
							var id = _v10.a;
							return $author$project$Navbars$Practice$Navigation$PartnerApp(id);
						} else {
							break _v0$27;
						}
					case 'google_callback':
						return $author$project$Navbars$Practice$Navigation$ClinicalDashboard;
					case 'home':
						return $author$project$Navbars$Practice$Navigation$ClinicalDashboard;
					case 'contacts':
						return $author$project$Navbars$Practice$Navigation$Contacts;
					case 'files':
						return $author$project$Navbars$Practice$Navigation$Admin(17);
					case 'forms':
						return $author$project$Navbars$Practice$Navigation$Forms;
					case 'inventory':
						return $author$project$Navbars$Practice$Navigation$Admin(16);
					case 'new_settings':
						if (pathList.b.b) {
							switch (pathList.b.a) {
								case 'practice_info':
									var _v4 = pathList.b;
									return $author$project$Navbars$Practice$Navigation$Admin(20);
								case 'team':
									if ((pathList.b.b.b && pathList.b.b.b.b) && (pathList.b.b.b.a === 'basic_info')) {
										var _v5 = pathList.b;
										var _v6 = _v5.b;
										var _v7 = _v6.b;
										return $author$project$Navbars$Practice$Navigation$Account;
									} else {
										var _v8 = pathList.b;
										return $author$project$Navbars$Practice$Navigation$Admin(21);
									}
								case 'erx':
									var _v9 = pathList.b;
									return $author$project$Navbars$Practice$Navigation$Admin(15);
								default:
									break _v0$23;
							}
						} else {
							break _v0$23;
						}
					case 'messages':
						if (pathList.b.b) {
							switch (pathList.b.a) {
								case 'sms':
									var _v12 = pathList.b;
									return $author$project$Navbars$Practice$Navigation$Inbox;
								case 'chat':
									var _v13 = pathList.b;
									return $author$project$Navbars$Practice$Navigation$Inbox;
								default:
									break _v0$27;
							}
						} else {
							break _v0$27;
						}
					case 'tasks':
						return $author$project$Navbars$Practice$Navigation$Tasks;
					default:
						break _v0$27;
				}
			} else {
				break _v0$27;
			}
		}
		return $author$project$Navbars$Practice$Navigation$Patients;
	}
	var tail = pathList.b;
	_v11$7:
	while (true) {
		if (tail.b) {
			switch (tail.a) {
				case 'appointment_types':
					return $author$project$Navbars$Practice$Navigation$Admin(14);
				case 'booking_overview':
					return $author$project$Navbars$Practice$Navigation$Admin(13);
				case 'blocked_phone_numbers':
					return $author$project$Navbars$Practice$Navigation$Admin(20);
				case 'export':
					return $author$project$Navbars$Practice$Navigation$Admin(12);
				case 'locations':
					return $author$project$Navbars$Practice$Navigation$Admin(13);
				case 'templates':
					return $author$project$Navbars$Practice$Navigation$Admin(18);
				case 'hinter_settings':
					return $author$project$Navbars$Practice$Navigation$Admin(0);
				default:
					break _v11$7;
			}
		} else {
			break _v11$7;
		}
	}
	return $author$project$Navbars$Practice$Navigation$Admin(0);
};
var $author$project$Navbars$Practice$Navigation$AdminNav = 1;
var $author$project$Navbars$Practice$Navigation$HelpNav = 2;
var $author$project$Navbars$Practice$Navigation$None = 4;
var $author$project$Navbars$Practice$Navigation$ProfileNav = 3;
var $author$project$Navbars$Practice$Navigation$ReportNav = 0;
var $author$project$Navbars$Practice$openSubNavFromSelectedNav = function (selectedNav) {
	switch (selectedNav.$) {
		case 14:
			return 1;
		case 16:
			return 2;
		case 12:
			return 0;
		case 5:
			return 3;
		default:
			return 4;
	}
};
var $author$project$Navbars$Practice$init = function (shared) {
	var selectedNav = $author$project$Navbars$Practice$Navigation$navItemFromUrl(shared.adY);
	var practice = shared.ZV;
	var apiClient = shared.Gv;
	return _Utils_Tuple3(
		{
			im: A2($author$project$Ui$FlyoutMenu$init, 'admin-menu', $author$project$Navbars$Practice$AdminMenuMsg),
			ae6: shared.ae6,
			fP: $author$project$Navbars$Practice$closedBookmarkedMenu,
			ac: $elm$core$Set$empty,
			x4: $elm$core$Maybe$Nothing,
			dd: $elm$core$Maybe$Nothing,
			r9: $author$project$Api$Data$Loading,
			agP: shared.agP,
			sz: A2(
				$author$project$Navbars$HinterIdButtons$init,
				$author$project$Navbars$HinterIdButtons$Practice(
					$author$project$Api$Provider$Practice$One$id(shared.ZV)),
				$author$project$Api$Provider$Practice$One$organizationId(shared.ZV)),
			jT: $author$project$Components$HinterPracticeSettingsModal$init,
			sF: shared.sF,
			An: false,
			O: $author$project$Navbars$Practice$MobileBookmarkIdle,
			dw: $author$project$Navbars$Practice$openSubNavFromSelectedNav(selectedNav),
			ajG: shared.ajG,
			tC: $author$project$Api$Data$NotAsked,
			ZV: practice,
			kI: $author$project$Navbars$Practice$buildPracticeConfig(practice),
			eZ: A2($author$project$Ui$FlyoutMenu$init, 'profile-menu', $author$project$Navbars$Practice$ProfileMenuMsg),
			kW: A2($author$project$Ui$FlyoutMenu$init, 'reporting-menu', $author$project$Navbars$Practice$ReportMenuMsg),
			ue: $author$project$Api$Data$NotAsked,
			fd: selectedNav,
			aa4: shared.aa4,
			Ex: $author$project$Navbars$Practice$initSessionConfiguration(shared.aa4),
			qc: false,
			qh: false,
			qq: $author$project$Ui$Dropdown$init(
				$author$project$Ui$Dropdown$defaultConfig(
					{ahP: 'switch-product-dropdown', al6: $author$project$Navbars$Practice$SwitchProductDropDownMsg})),
			aey: shared.aey
		},
		$author$project$Api$Data$clientHasAuthToken(apiClient) ? $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($author$project$Api$Provider$EmbeddedReport$list, apiClient, $author$project$Navbars$Practice$GotEmbeddedReports),
					A2($elm$core$Task$perform, $author$project$Navbars$Practice$GotCurrentDate, $justinmimbs$date$Date$today),
					A2($author$project$Api$Provider$Report$list, apiClient, $author$project$Navbars$Practice$GotReports),
					A2($author$project$Api$Provider$PartnerApp$list, apiClient, $author$project$Navbars$Practice$GotPartnerApps),
					$author$project$Navbars$Practice$buildPracticeConfig(practice).ax ? A2($author$project$Api$Provider$NavBookmark$list, apiClient, $author$project$Navbars$Practice$GotBookmarks) : $elm$core$Platform$Cmd$none
				])) : $elm$core$Platform$Cmd$none,
		_List_Nil);
};
var $author$project$Navbar$andInitPracticeNavbar = F5(
	function (apiClient, whitelabelSetting, practice, backupAuthEnabled, _v0) {
		var model = _v0;
		var _v1 = $author$project$Navbars$Practice$init(
			{Gv: apiClient, ae6: backupAuthEnabled, agP: model.agP, ahK: model.ahK, sF: model.sF, ajG: model.ajG, ZV: practice, aa4: model.aa4, adY: model.adY, aey: whitelabelSetting});
		var navbarModel = _v1.a;
		var navbarCmd = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					ai: $author$project$Navbar$PracticeNav(navbarModel)
				}),
			A2($elm$core$Platform$Cmd$map, $author$project$Navbar$PracticeNavbarMsg, navbarCmd));
	});
var $author$project$Navbar$initForPractice = F6(
	function (apiClient, session, whitelabelSetting, practice, backupAuthEnabled, flags) {
		return A5(
			$author$project$Navbar$andInitPracticeNavbar,
			apiClient,
			whitelabelSetting,
			practice,
			backupAuthEnabled,
			A3(
				$author$project$Navbar$init,
				session,
				$elm$core$Maybe$Just(
					$author$project$Api$Practice$Provider(practice)),
				flags));
	});
var $author$project$Shared$isPublicRoute = function (route) {
	var _v0 = $author$project$Permission$forRoute(route);
	if (_v0.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Shared$initNavbar = function (_v0) {
	var model = _v0.a;
	var cmd = _v0.b;
	var _v1 = _Utils_Tuple2(model.aa4, model.aj);
	if ((_v1.a.$ === 3) && (_v1.b.$ === 1)) {
		var _v2 = _v1.a;
		var session = _v2.a;
		var _v3 = _v1.b;
		var currentRoute = $author$project$Utils$Route$fromUrl(model.adY);
		var isPublic = $author$project$Shared$isPublicRoute(currentRoute);
		if (isPublic) {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var whitelabelSetting = A2(
				$elm$core$Maybe$withDefault,
				$author$project$Api$WhitelabelSetting$empty,
				$author$project$Api$Data$toMaybe(model.aey));
			var organizationType = A2(
				$elm$core$Maybe$map,
				function (org) {
					return $author$project$Api$Platform$Organization$Shared$type_(org);
				},
				$author$project$Api$Platform$Session$One$organization(session));
			var _v4 = _Utils_Tuple2(organizationType, model.ZV);
			_v4$3:
			while (true) {
				if (!_v4.a.$) {
					switch (_v4.a.a) {
						case 0:
							if (_v4.b.$ === 3) {
								var _v5 = _v4.a.a;
								var _v6 = _v4.b;
								var practice = _v6.a;
								var _v7 = _Utils_Tuple2(practice, model.afQ);
								if (!_v7.a.$) {
									var practice_ = _v7.a.a;
									return A2(
										$elm$core$Tuple$mapFirst,
										function (navbar) {
											return _Utils_update(
												model,
												{
													aj: $elm$core$Maybe$Just(navbar)
												});
										},
										A2(
											$elm$core$Tuple$mapSecond,
											function (navbarCmd) {
												return $elm$core$Platform$Cmd$batch(
													_List_fromArray(
														[cmd, navbarCmd]));
											},
											A2(
												$elm$core$Tuple$mapSecond,
												$elm$core$Platform$Cmd$map($author$project$Shared$NavbarMsg),
												A6(
													$author$project$Navbar$initForPractice,
													model.Gv,
													session,
													whitelabelSetting,
													practice_,
													model.ahq.ae6,
													{agP: model.ahq.agP, ahK: model.ahK, sF: model.sF, ajG: model.ahq.ajG, adY: model.adY}))));
								} else {
									return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
								}
							} else {
								break _v4$3;
							}
						case 1:
							if (_v4.b.$ === 3) {
								var _v8 = _v4.a.a;
								var _v9 = _v4.b;
								var practice = _v9.a;
								var _v10 = _Utils_Tuple2(practice, model.afQ);
								if (((_v10.a.$ === 1) && (_v10.b.$ === 3)) && (_v10.b.a.$ === 1)) {
									var practice_ = _v10.a.a;
									var _v11 = _v10.b;
									var company = _v11.a.a;
									return A2(
										$elm$core$Tuple$mapFirst,
										function (navbar) {
											return _Utils_update(
												model,
												{
													aj: $elm$core$Maybe$Just(navbar)
												});
										},
										A2(
											$elm$core$Tuple$mapSecond,
											function (navbarCmd) {
												return $elm$core$Platform$Cmd$batch(
													_List_fromArray(
														[cmd, navbarCmd]));
											},
											A2(
												$elm$core$Tuple$mapSecond,
												$elm$core$Platform$Cmd$map($author$project$Shared$NavbarMsg),
												A5(
													$author$project$Navbar$initForEmployer,
													session,
													whitelabelSetting,
													practice_,
													company,
													{agP: model.ahq.agP, ahK: model.ahK, sF: model.sF, ajG: model.ahq.ajG, adY: model.adY}))));
								} else {
									return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
								}
							} else {
								break _v4$3;
							}
						default:
							var _v12 = _v4.a.a;
							var _v13 = model.YN;
							if (_v13.$ === 3) {
								var partner = _v13.a;
								return A2(
									$elm$core$Tuple$mapFirst,
									function (navbar) {
										return _Utils_update(
											model,
											{
												aj: $elm$core$Maybe$Just(navbar)
											});
									},
									A2(
										$elm$core$Tuple$mapSecond,
										function (navbarCmd) {
											return $elm$core$Platform$Cmd$batch(
												_List_fromArray(
													[cmd, navbarCmd]));
										},
										A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$Platform$Cmd$map($author$project$Shared$NavbarMsg),
											A3(
												$author$project$Navbar$initForPartner,
												session,
												partner,
												{agP: model.ahq.agP, ahK: model.ahK, sF: model.sF, ajG: model.ahq.ajG, adY: model.adY}))));
							} else {
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
					}
				} else {
					break _v4$3;
				}
			}
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	} else {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	}
};
var $author$project$Api$Practice$provider = function (practice) {
	return A2($author$project$Api$Data$map, $author$project$Api$Practice$Provider, practice);
};
var $author$project$Navbars$Practice$reloadPartnerApps = function (apiClient) {
	return A2($author$project$Api$Provider$PartnerApp$list, apiClient, $author$project$Navbars$Practice$GotPartnerApps);
};
var $author$project$Navbar$reloadPartnerApps = F2(
	function (apiClient, _v0) {
		var model = _v0;
		var _v1 = model.ai;
		if (_v1.$ === 1) {
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$Navbar$PracticeNavbarMsg,
				$author$project$Navbars$Practice$reloadPartnerApps(apiClient));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Shared$resetTenancyProperties = function (_v0) {
	var model = _v0.a;
	var cmd = _v0.b;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{
				afQ: $author$project$Api$Data$NotAsked,
				G9: $author$project$Api$Data$NotAsked,
				m4: $elm$core$Maybe$Nothing,
				sH: $elm$core$Maybe$Just($elm$core$Dict$empty),
				aj: $elm$core$Maybe$Nothing,
				ajU: $elm$core$Maybe$Nothing,
				pI: $elm$core$Maybe$Nothing
			}),
		cmd);
};
var $author$project$Shared$GotPartner = function (a) {
	return {$: 2, a: a};
};
var $author$project$Shared$retrievePartner = function (apiClient) {
	return A2($author$project$Api$Partner$Partner$retrieve, apiClient, $author$project$Shared$GotPartner);
};
var $author$project$Shared$GotPractice = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Employer$Practice$One$Practice = $elm$core$Basics$identity;
var $author$project$Api$Employer$Practice$One$Record = function (id) {
	return function (name) {
		return function (hasPaymentProcessorAccount) {
			return function (stripePublishableKey) {
				return function (ssnEnabled) {
					return function (features) {
						return function (trackPatientsByLocation) {
							return function (transInclusivity) {
								return function (address) {
									return function (phones) {
										return function (collectSSNOnSignup) {
											return function (featureGates) {
												return function (requiresPatientMobile) {
													return function (requiresSSN) {
														return function (requiresPatientEmail) {
															return function (requiresPractitioner) {
																return function (requiresLocation) {
																	return function (meta) {
																		return function (email) {
																			return function (network) {
																				return function (paymentProcessor) {
																					return function (hideSponsorInvoices) {
																						return function (organizationId) {
																							return {K2: address, N$: collectSSNOnSignup, Rj: email, Sd: featureGates, Sf: features, Tg: hasPaymentProcessorAccount, Ts: hideSponsorInvoices, ahP: id, W4: meta, Bq: name, Xz: network, ajD: organizationId, Zd: paymentProcessor, Zy: phones, $G: requiresLocation, $I: requiresPatientEmail, $J: requiresPatientMobile, $M: requiresPractitioner, $N: requiresSSN, ab6: ssnEnabled, acs: stripePublishableKey, adt: trackPatientsByLocation, adv: transInclusivity};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Employer$Network$Shared$Network = $elm$core$Basics$identity;
var $author$project$Api$Employer$Network$Shared$Record = F2(
	function (syncByAffiliation, ratesFromAffiliate) {
		return {_5: ratesFromAffiliate, acI: syncByAffiliation};
	});
var $author$project$Api$Employer$Network$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'rates_from_affiliate',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'sync_by_affiliation',
		$elm$json$Json$Decode$bool,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$Network$Shared$Record)));
var $author$project$Api$Employer$Network$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Network$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Practice$One$OneMeta = F2(
	function (hasPractitioners, hasLocations) {
		return {Tb: hasLocations, Th: hasPractitioners};
	});
var $author$project$Api$Employer$Practice$One$metaDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'has_locations',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'has_practitioners',
		$elm$json$Json$Decode$bool,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$Practice$One$OneMeta)));
var $author$project$Api$Employer$Practice$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'organization_id',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'hide_sponsor_invoices',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'payment_processor',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'network',
				$elm$json$Json$Decode$nullable($author$project$Api$Employer$Network$Shared$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'email',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'meta',
						$author$project$Api$Employer$Practice$One$metaDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'requires_location',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'requires_practitioner',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'requires_patient_email',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'requires_ssn',
										$elm$json$Json$Decode$bool,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'requires_patient_mobile',
											$elm$json$Json$Decode$bool,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'feature_gates',
												$elm$json$Json$Decode$list($author$project$Api$Common$FeatureGate$Shared$decoder),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'collect_ssn_on_signup',
													$author$project$Api$CollectOnSignup$decoder,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'phones',
														$elm$json$Json$Decode$list($author$project$Api$Common$Phone$Shared$decoder),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'address',
															$elm$json$Json$Decode$nullable($author$project$Api$Common$Address$Shared$decoder),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'trans_inclusivity',
																$elm$json$Json$Decode$bool,
																A4(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																	'track_patients_by_location',
																	$elm$json$Json$Decode$bool,
																	false,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'features',
																		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'ssn_enabled',
																			$elm$json$Json$Decode$bool,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'stripe_publishable_key',
																				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'has_payment_processor_account',
																					$elm$json$Json$Decode$bool,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'name',
																						$elm$json$Json$Decode$string,
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'id',
																							$elm$json$Json$Decode$string,
																							$elm$json$Json$Decode$succeed($author$project$Api$Employer$Practice$One$Record))))))))))))))))))))))));
var $author$project$Api$Employer$Practice$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Practice$One$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Practice$practicePath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['practice']),
	$author$project$Api$Data$employerPath);
var $author$project$Api$Employer$Practice$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Employer$Practice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Employer$Practice$practicePath));
	});
var $author$project$Api$Practice$retrieve = F3(
	function (apiClient, session, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A2(
			$author$project$Api$Employer$Practice$retrieve,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Practice$Employer))) : A3(
			$author$project$Api$Provider$Practice$retrieve,
			apiClient,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Practice$Provider)));
	});
var $author$project$Shared$retrievePractice = F2(
	function (apiClient, session) {
		return A3($author$project$Api$Practice$retrieve, apiClient, session, $author$project$Shared$GotPractice);
	});
var $author$project$Shared$OrgSwitcher$pendingRedirect = function (action) {
	return $elm$core$Maybe$Just(
		{Gg: action});
};
var $author$project$Shared$scheduleOrgSwitchRedirect = F3(
	function (model, action, cmd) {
		return $author$project$Shared$resetTenancyProperties(
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						YN: $author$project$Api$Data$NotAsked,
						dD: $author$project$Shared$OrgSwitcher$pendingRedirect(action),
						ZV: $author$project$Api$Data$NotAsked
					}),
				cmd));
	});
var $author$project$Ui$Toast$levelToString = function (level) {
	switch (level) {
		case 0:
			return 'info';
		case 1:
			return 'danger';
		case 2:
			return 'warning';
		default:
			return 'success';
	}
};
var $author$project$Ui$Toast$sendToastMessagePort = _Platform_outgoingPort(
	'sendToastMessagePort',
	function ($) {
		var a = $.a;
		var b = $.b;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$json$Json$Encode$string(a),
					$elm$json$Json$Encode$string(b)
				]));
	});
var $author$project$Ui$Toast$sendMessage = F2(
	function (level, message) {
		return $author$project$Ui$Toast$sendToastMessagePort(
			_Utils_Tuple2(
				$author$project$Ui$Toast$levelToString(level),
				message));
	});
var $author$project$Shared$showToast = F3(
	function (embedded, toastLevel, message) {
		return embedded ? A2($author$project$Ui$Toast$sendMessage, toastLevel, message) : $elm$core$Platform$Cmd$none;
	});
var $author$project$Ports$HinterView$hinterViewStorePort = _Platform_outgoingPort('hinterViewStorePort', $elm$json$Json$Encode$bool);
var $author$project$Ports$HinterView$store = $author$project$Ports$HinterView$hinterViewStorePort;
var $author$project$Ports$Session$persistBackupAuthTokenPort = _Platform_outgoingPort('persistBackupAuthTokenPort', $elm$json$Json$Encode$string);
var $author$project$Ports$Session$persistBackupAuthToken = function (token) {
	return $author$project$Ports$Session$persistBackupAuthTokenPort(token);
};
var $author$project$Ports$Session$refreshBackupAuthTokenPort = _Platform_outgoingPort('refreshBackupAuthTokenPort', $elm$json$Json$Encode$string);
var $author$project$Ports$Session$refreshBackupAuthToken = function (token) {
	return $author$project$Ports$Session$refreshBackupAuthTokenPort(token);
};
var $author$project$Shared$storeAuthToken = F2(
	function (authToken, isRefresh) {
		var portCmd = isRefresh ? $author$project$Ports$Session$refreshBackupAuthToken : $author$project$Ports$Session$persistBackupAuthToken;
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Platform$Cmd$none,
			A2(
				$elm$core$Maybe$map,
				portCmd,
				$author$project$Api$AuthToken$toString(authToken)));
	});
var $author$project$Api$Platform$Session$switchRole = F3(
	function (apiClient, role, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$elm$json$Json$Encode$string(role))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Platform$Session$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['switch_role']),
						$author$project$Api$Platform$Session$sessionPath))));
	});
var $author$project$Ports$Session$sessionSwitchTenant = _Platform_outgoingPort('sessionSwitchTenant', $elm$json$Json$Encode$string);
var $author$project$Ports$Session$switchTenant = function (organizationId) {
	return $author$project$Ports$Session$sessionSwitchTenant(organizationId);
};
var $author$project$Api$Auth$switchToOrganization = F4(
	function (client, organizationId, role, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'organization',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'id',
								$elm$json$Json$Encode$string(organizationId)),
								_Utils_Tuple2(
								'type',
								$elm$json$Json$Encode$string('organization'))
							]))),
					_Utils_Tuple2(
					'role',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, role))
				]));
		return A4(
			$author$project$Api$Data$post,
			client,
			$author$project$Api$Auth$authTokenDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['switch_organization']),
						$author$project$Api$Auth$authPath))));
	});
var $author$project$Ui$Toast$ToastAutoDismissed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Toast$dismissInSeconds = F2(
	function (seconds, id) {
		return A2(
			$elm$core$Task$perform,
			function (_v0) {
				return $author$project$Ui$Toast$ToastAutoDismissed(id);
			},
			$elm$core$Process$sleep(seconds * 1000));
	});
var $author$project$Ui$Toast$Toast = $elm$core$Basics$identity;
var $author$project$Ui$Toast$ToastRecord = F4(
	function (id, level, message, dismissible) {
		return {r1: dismissible, ahP: id, VV: level, aiH: message};
	});
var $author$project$Ui$Toast$newToast = F3(
	function (id, level, message) {
		return A4($author$project$Ui$Toast$ToastRecord, id, level, message, true);
	});
var $author$project$Ui$Toast$toast = F3(
	function (level, message, _v0) {
		var count = _v0.a;
		var toasts = _v0.b;
		return _Utils_Tuple2(
			A2(
				$author$project$Ui$Toast$Toastr,
				count + 1,
				_Utils_ap(
					toasts,
					_List_fromArray(
						[
							A3($author$project$Ui$Toast$newToast, count, level, message)
						]))),
			A2($author$project$Ui$Toast$dismissInSeconds, 4, count));
	});
var $author$project$Shared$updateFromOutMsg = F2(
	function (outMsg, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		switch (outMsg.$) {
			case 0:
				var error = outMsg.a;
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								cmd,
								$author$project$Shared$decodeErrorToMsg(error)
							])));
			case 1:
				var toastLevel = outMsg.a;
				var message = outMsg.b;
				var _v2 = A3($author$project$Ui$Toast$toast, toastLevel, message, model.lO);
				var toastr = _v2.a;
				var toastrCmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{lO: toastr}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								cmd,
								A3($author$project$Shared$showToast, model.ahq.agL, toastLevel, message),
								A2($elm$core$Platform$Cmd$map, $author$project$Shared$ToastMsg, toastrCmd)
							])));
			case 5:
				var practice = outMsg.a;
				return $author$project$Shared$initNavbar(
					$author$project$Shared$resetTenancyProperties(
						_Utils_Tuple2(
							_Utils_update(
								model,
								{
									ZV: $author$project$Api$Practice$provider(practice)
								}),
							cmd)));
			case 6:
				var partner = outMsg.a;
				return $author$project$Shared$initNavbar(
					_Utils_Tuple2(
						_Utils_update(
							model,
							{YN: partner}),
						cmd));
			case 7:
				var patient = outMsg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{G9: patient}),
					cmd);
			case 8:
				var dataWhitelabelSetting = outMsg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aey: dataWhitelabelSetting}),
					$elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								cmd,
								function () {
								var _v3 = model.aa4;
								if (_v3.$ === 3) {
									var session = _v3.a;
									return A2($author$project$Shared$retrievePractice, model.Gv, session);
								} else {
									return $elm$core$Platform$Cmd$none;
								}
							}()
							])));
			case 3:
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								cmd,
								function () {
								var _v4 = model.aa4;
								if (_v4.$ === 3) {
									return $author$project$Shared$retrievePartner(model.Gv);
								} else {
									return $elm$core$Platform$Cmd$none;
								}
							}()
							])));
			case 10:
				var patientId = outMsg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							G9: $author$project$Api$Data$Loading,
							m4: $elm$core$Maybe$Just(patientId)
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								cmd,
								A3(
								$author$project$Api$Provider$Patient$retrieve,
								model.Gv,
								patientId,
								$author$project$Shared$GotPatient(patientId))
							])));
			case 9:
				var companyId = outMsg.a;
				var _v5 = function () {
					var _v6 = model.aa4;
					switch (_v6.$) {
						case 3:
							var session = _v6.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{afQ: $author$project$Api$Data$Loading}),
								A4(
									$author$project$Api$Company$retrieve,
									model.Gv,
									session,
									companyId,
									$author$project$Shared$GotCompany(companyId)));
						case 1:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										afQ: $author$project$Api$Data$Loading,
										pI: $elm$core$Maybe$Just(companyId)
									}),
								$elm$core$Platform$Cmd$none);
						default:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				}();
				var newModel = _v5.a;
				var retrieveCompanyCmd = _v5.b;
				return _Utils_Tuple2(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[cmd, retrieveCompanyCmd])));
			case 11:
				var query = outMsg.a;
				var _v7 = _Utils_Tuple3(model.aa4, model.ZV, model.ajU);
				if ((((_v7.a.$ === 3) && (_v7.b.$ === 3)) && (!_v7.b.a.$)) && (_v7.c.$ === 1)) {
					var _v8 = _v7.a;
					var session = _v8.a;
					var _v9 = _v7.b;
					var practice = _v9.a.a;
					var _v10 = _v7.c;
					var _v11 = A4(
						$author$project$Components$PatientsList$init,
						session,
						practice,
						model.m4,
						{Gv: model.Gv, DE: query, J7: model.J7, J8: model.J8, adY: model.adY});
					var newList = _v11.a;
					var listCmd = _v11.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ajU: $elm$core$Maybe$Just(newList)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									cmd,
									A2($elm$core$Platform$Cmd$map, $author$project$Shared$PatientsListMsg, listCmd)
								])));
				} else {
					return _Utils_Tuple2(model, cmd);
				}
			case 12:
				var _v12 = model.ajU;
				if (!_v12.$) {
					return _Utils_Tuple2(
						model,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									cmd,
									A2(
									$elm$core$Task$perform,
									function (_v13) {
										return $author$project$Shared$PatientsListMsg($author$project$Components$PatientsList$RefreshPatients);
									},
									$elm$core$Task$succeed(0))
								])));
				} else {
					return _Utils_Tuple2(model, cmd);
				}
			case 13:
				var hinterViewOff = !model.ahK;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ahK: hinterViewOff}),
					$author$project$Ports$HinterView$store(hinterViewOff));
			case 14:
				var highlightPhi = !model.nU;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{nU: highlightPhi}),
					$elm$core$Platform$Cmd$none);
			case 15:
				var error = outMsg.a;
				var serverError = $author$project$Ui$Toast$serverError(error);
				return $author$project$Api$Data$clientHasAuthToken(model.Gv) ? _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Ports$Session$logout(
								{aku: true}),
								$author$project$Ports$Sentry$captureDebugMessage('Unauthorized request: ' + serverError)
							]))) : _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								cmd,
								A3($author$project$Shared$showToast, model.ahq.agL, 1, serverError)
							])));
			case 16:
				var organizationId = outMsg.a;
				var roleWithPrefix = outMsg.b;
				var postOrganizationSwitchedAction_ = outMsg.c;
				return model.ahq.ae6 ? _Utils_Tuple2(
					model,
					A4(
						$author$project$Api$Auth$switchToOrganization,
						model.Gv,
						organizationId,
						roleWithPrefix,
						$author$project$Shared$BackupAuthOrganizationSwitched(postOrganizationSwitchedAction_))) : A3(
					$author$project$Shared$scheduleOrgSwitchRedirect,
					model,
					postOrganizationSwitchedAction_,
					$author$project$Ports$Session$switchTenant(organizationId));
			case 17:
				var id = outMsg.a;
				return A3(
					$author$project$Shared$scheduleOrgSwitchRedirect,
					model,
					$author$project$OutMsg$GoToClinicalAction,
					$author$project$Ports$Session$switchTenant(id));
			case 18:
				var roleWithPrefix = outMsg.a;
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								cmd,
								A3($author$project$Api$Platform$Session$switchRole, model.Gv, roleWithPrefix, $author$project$Shared$GotRoleSwitched)
							])));
			case 4:
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								cmd,
								A2($author$project$Api$Platform$Session$retrieve, model.Gv, $author$project$Shared$GotSession)
							])));
			case 19:
				var authToken = outMsg.a;
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Shared$storeAuthToken, authToken, false),
								$author$project$Ports$Session$authorize(
								{aku: true})
							])));
			case 20:
				return _Utils_Tuple2(
					model,
					$author$project$Ports$Sentry$captureErrorMessage('Bad Gateway error'));
			case 21:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								cmd,
								A2(
								$elm$core$Maybe$withDefault,
								$elm$core$Platform$Cmd$none,
								A2(
									$elm$core$Maybe$map,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Navbar$reloadPartnerApps(model.Gv),
										$elm$core$Platform$Cmd$map($author$project$Shared$NavbarMsg)),
									model.aj))
							])));
		}
	});
var $author$project$Shared$updateFromOutMsgs = F2(
	function (msgs, model) {
		return A3(
			$elm$core$List$foldl,
			$author$project$Shared$updateFromOutMsg,
			_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
			msgs);
	});
var $author$project$Main$init = function (flags) {
	var _v0 = $author$project$Main$locationHrefToUrl(flags.Wd);
	var url = _v0.a;
	var defaultUrlCmd = _v0.b;
	var _v1 = A2($author$project$Shared$init, flags, url);
	var shared = _v1.a;
	var sharedCmd = _v1.b;
	var _v2 = $author$project$Spa$Layout$init(shared);
	var layout = _v2.a;
	var layoutCmd = _v2.b;
	var route = $author$project$Utils$Route$fromUrl(url);
	var _v3 = A2($author$project$Spa$Generated$Pages$init, route, shared);
	var page = _v3.a;
	var pageCmd = _v3.b;
	var outMsgs = _v3.c;
	var _v4 = A2($author$project$Shared$updateFromOutMsgs, outMsgs, shared);
	var newShared = _v4.a;
	var extraSharedCmd = _v4.b;
	return _Utils_Tuple2(
		A5($author$project$Main$Model, newShared, route, page, layout, $jinjor$elm_debounce$Debounce$init),
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($elm$core$Platform$Cmd$map, $author$project$Main$Shared, sharedCmd),
					A2($elm$core$Platform$Cmd$map, $author$project$Main$Shared, extraSharedCmd),
					A2($elm$core$Platform$Cmd$map, $author$project$Main$Pages, pageCmd),
					A2($elm$core$Platform$Cmd$map, $author$project$Main$Layout, layoutCmd),
					defaultUrlCmd
				])));
};
var $author$project$Main$UrlChanged = function (a) {
	return {$: 0, a: a};
};
var $author$project$Main$UrlRequested = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Ports$Navigation$onUrlChange = _Platform_incomingPort('onUrlChange', $elm$json$Json$Decode$string);
var $author$project$Ports$Navigation$navigationPortOnUrlRequest = _Platform_incomingPort(
	'navigationPortOnUrlRequest',
	A2(
		$elm$json$Json$Decode$andThen,
		function (_v0) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (_v1) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (_v2) {
							return $elm$json$Json$Decode$succeed(
								_Utils_Tuple3(_v0, _v1, _v2));
						},
						A2($elm$json$Json$Decode$index, 2, $elm$json$Json$Decode$bool));
				},
				A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$bool));
		},
		A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string)));
var $author$project$Ports$Navigation$onUrlRequest = function (toMsg) {
	return $author$project$Ports$Navigation$navigationPortOnUrlRequest(
		function (_v0) {
			var href = _v0.a;
			var isLocal = _v0.b;
			var shouldOpenInNewWindow = _v0.c;
			return A3(toMsg, href, isLocal, shouldOpenInNewWindow);
		});
};
var $author$project$Shared$AccessTokenCreated = function (a) {
	return {$: 12, a: a};
};
var $author$project$Shared$AccessTokenUpdated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Shared$AccountLockedModalMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Shared$GotCurrentTime = function (a) {
	return {$: 7, a: a};
};
var $author$project$Shared$LoggedOut = {$: 18};
var $author$project$Shared$OrganizationSwitcherMsg = function (a) {
	return {$: 29, a: a};
};
var $author$project$Shared$PendingChangesKeep = {$: 23};
var $author$project$Shared$ShowLogoutWarning = {$: 9};
var $author$project$Ports$Session$NewSession = F2(
	function (accessToken, redirectToURI) {
		return {q7: accessToken, akv: redirectToURI};
	});
var $author$project$Ports$Session$newSessionDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'redirectToURI',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'accessToken',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$json$Json$Decode$succeed($author$project$Ports$Session$NewSession)));
var $author$project$Ports$Session$decodeNewSession = function (json) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Ports$Session$newSessionDecoder, json);
	if (!_v0.$) {
		var newSession = _v0.a;
		return $elm$core$Result$Ok(newSession);
	} else {
		var error = _v0.a;
		return $elm$core$Result$Err(
			$elm$json$Json$Decode$errorToString(error));
	}
};
var $author$project$Ports$Session$onAccessTokenCreatedPort = _Platform_incomingPort('onAccessTokenCreatedPort', $elm$json$Json$Decode$value);
var $author$project$Ports$Session$onAccessTokenCreated = function (toMsg) {
	return $author$project$Ports$Session$onAccessTokenCreatedPort(
		A2($elm$core$Basics$composeL, toMsg, $author$project$Ports$Session$decodeNewSession));
};
var $author$project$Ports$Session$decodeToken = function (json) {
	var _v0 = A2(
		$elm$json$Json$Decode$decodeValue,
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		json);
	if (!_v0.$) {
		var token = _v0.a;
		return $elm$core$Result$Ok(token);
	} else {
		var error = _v0.a;
		return $elm$core$Result$Err(
			$elm$json$Json$Decode$errorToString(error));
	}
};
var $author$project$Ports$Session$onAccessTokenUpdatedPort = _Platform_incomingPort('onAccessTokenUpdatedPort', $elm$json$Json$Decode$value);
var $author$project$Ports$Session$onAccessTokenUpdated = function (toMsg) {
	return $author$project$Ports$Session$onAccessTokenUpdatedPort(
		A2($elm$core$Basics$composeL, toMsg, $author$project$Ports$Session$decodeToken));
};
var $author$project$Ports$Session$onLogoutWarningPort = _Platform_incomingPort(
	'onLogoutWarningPort',
	$elm$json$Json$Decode$null(0));
var $author$project$Ports$Session$onLogoutWarning = function (toMsg) {
	return $author$project$Ports$Session$onLogoutWarningPort(
		$elm$core$Basics$always(toMsg));
};
var $author$project$Shared$seconds = function (_float) {
	return _float * 1000;
};
var $author$project$Ports$Session$onSessionLoggedOutPort = _Platform_incomingPort(
	'onSessionLoggedOutPort',
	$elm$json$Json$Decode$null(0));
var $author$project$Ports$Session$sessionLoggedOut = function (toMsg) {
	return $author$project$Ports$Session$onSessionLoggedOutPort(
		$elm$core$Basics$always(toMsg));
};
var $author$project$Components$AccountLockedModal$Close = 0;
var $author$project$Components$AccountLockedModal$subscriptions = $author$project$Ui$Modal$subscribeToEscapeKeyPress(0);
var $author$project$Components$GlobalSearch$GlobalSearchTriggered = {$: 0};
var $author$project$Components$GlobalSearch$LoggedOut = {$: 13};
var $author$project$Components$GlobalSearch$ModalCloseClicked = {$: 1};
var $author$project$Ports$GlobalSearch$globalSearchTriggeredPort = _Platform_incomingPort(
	'globalSearchTriggeredPort',
	$elm$json$Json$Decode$null(0));
var $author$project$Ports$GlobalSearch$globalSearchTriggered = function (toMsg) {
	return $author$project$Ports$GlobalSearch$globalSearchTriggeredPort(
		$elm$core$Basics$always(toMsg));
};
var $author$project$Components$GlobalSearch$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ports$Session$sessionLoggedOut($author$project$Components$GlobalSearch$LoggedOut),
				function () {
				if (!model.$) {
					return $author$project$Ports$GlobalSearch$globalSearchTriggered($author$project$Components$GlobalSearch$GlobalSearchTriggered);
				} else {
					var openModel = model.a;
					return $elm$core$Platform$Sub$batch(
						_List_fromArray(
							[
								$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$GlobalSearch$ModalCloseClicked),
								A2(
								$elm$core$Maybe$withDefault,
								$elm$core$Platform$Sub$none,
								A2($elm$core$Maybe$map, $author$project$Ui$Nav$subscriptions, openModel.kp))
							]));
				}
			}()
			]));
};
var $author$project$Components$OrganizationSwitcher$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$FlyoutMenu$subscriptions(model.nN),
				$author$project$Ui$Nav$subscriptions(model.oJ)
			]));
};
var $author$project$Components$PendingChangesModal$subscriptions = function (keepChangesMsg) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress(keepChangesMsg);
};
var $author$project$Navbar$HinterViewUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Navbar$ScreenResized = {$: 5};
var $elm$browser$Browser$Events$Window = 1;
var $elm$browser$Browser$Events$onResize = function (func) {
	return A3(
		$elm$browser$Browser$Events$on,
		1,
		'resize',
		A2(
			$elm$json$Json$Decode$field,
			'target',
			A3(
				$elm$json$Json$Decode$map2,
				func,
				A2($elm$json$Json$Decode$field, 'innerWidth', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'innerHeight', $elm$json$Json$Decode$int))));
};
var $author$project$Ports$Navbar$sidenavHinterViewUpdatedPort = _Platform_incomingPort('sidenavHinterViewUpdatedPort', $elm$json$Json$Decode$bool);
var $author$project$Ports$Navbar$sidenavHinterViewUpdated = function (toMsg) {
	return $author$project$Ports$Navbar$sidenavHinterViewUpdatedPort(toMsg);
};
var $author$project$Navbars$Company$SidenavLinkClicked = {$: 3};
var $author$project$Ports$Navbar$onSidenavLinkClickedPort = _Platform_incomingPort(
	'onSidenavLinkClickedPort',
	$elm$json$Json$Decode$null(0));
var $author$project$Ports$Navbar$onSidenavLinkClicked = function (toMsg) {
	return $author$project$Ports$Navbar$onSidenavLinkClickedPort(
		$elm$core$Basics$always(toMsg));
};
var $author$project$Navbars$Company$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ports$Navbar$onSidenavLinkClicked($author$project$Navbars$Company$SidenavLinkClicked),
				$author$project$Ui$FlyoutMenu$subscriptions(model.eZ)
			]));
};
var $author$project$Navbars$Partner$SidenavLinkClicked = {$: 3};
var $author$project$Navbars$Partner$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ports$Navbar$onSidenavLinkClicked($author$project$Navbars$Partner$SidenavLinkClicked),
				$author$project$Ui$FlyoutMenu$subscriptions(model.eZ)
			]));
};
var $author$project$Navbars$Practice$CloseModal = {$: 5};
var $author$project$Navbars$Practice$GotClinicalBadgeCounts = function (a) {
	return {$: 35, a: a};
};
var $author$project$Navbars$Practice$HinterPracticeSettingsModalMsg = function (a) {
	return {$: 17, a: a};
};
var $author$project$Navbars$Practice$MobileBookmarkPopoverClosed = {$: 34};
var $author$project$Navbars$Practice$SidenavLinkClicked = {$: 12};
var $author$project$Api$ClinicalBadges$BadgeCounts = $elm$core$Basics$identity;
var $author$project$Api$ClinicalBadges$Internal = F2(
	function (communication, tasks) {
		return {N9: communication, acT: tasks};
	});
var $author$project$Api$ClinicalBadges$decoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'tasks',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'communication',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$Api$ClinicalBadges$Internal))));
var $author$project$Navbars$Practice$mobileBookmarkPopoverId = 'mobile-bookmark-popover';
var $author$project$Ports$ClinicalBadges$onClinicalBadgeCounts = _Platform_incomingPort('onClinicalBadgeCounts', $elm$json$Json$Decode$value);
var $author$project$Ports$ClinicalBadges$subscribeToCounts = $author$project$Ports$ClinicalBadges$onClinicalBadgeCounts;
var $author$project$Components$HinterPracticeSettingsModal$CloseModal = {$: 0};
var $author$project$Components$HinterPracticeSettingsModal$subscriptions = function (model) {
	if (model.$ === 1) {
		return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$HinterPracticeSettingsModal$CloseModal);
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Navbars$Practice$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				model.An ? $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Navbars$Practice$CloseModal) : $elm$core$Platform$Sub$none,
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Navbars$Practice$HinterPracticeSettingsModalMsg,
				$author$project$Components$HinterPracticeSettingsModal$subscriptions(model.jT)),
				$author$project$Ui$FlyoutMenu$subscriptions(model.kW),
				$author$project$Ui$FlyoutMenu$subscriptions(model.im),
				$author$project$Ui$FlyoutMenu$subscriptions(model.eZ),
				$author$project$Ui$FlyoutMenu$subscriptions(model.fP),
				$author$project$Ports$Navbar$onSidenavLinkClicked($author$project$Navbars$Practice$SidenavLinkClicked),
				$author$project$Ui$Dropdown$subscriptions(model.qq),
				function () {
				var _v1 = model.O;
				switch (_v1.$) {
					case 2:
						return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Navbars$Practice$MobileBookmarkPopoverClosed);
					case 3:
						return $elm$core$Platform$Sub$batch(
							_List_fromArray(
								[
									$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Navbars$Practice$MobileBookmarkPopoverClosed),
									A2($author$project$Utils$Dom$onOutsideMouseDown, $author$project$Navbars$Practice$MobileBookmarkPopoverClosed, $author$project$Navbars$Practice$mobileBookmarkPopoverId)
								]));
					default:
						return $elm$core$Platform$Sub$none;
				}
			}(),
				$author$project$Ports$ClinicalBadges$subscribeToCounts(
				A2(
					$elm$core$Basics$composeR,
					$elm$json$Json$Decode$decodeValue($author$project$Api$ClinicalBadges$decoder),
					$author$project$Navbars$Practice$GotClinicalBadgeCounts))
			]));
};
var $author$project$Navbar$subscriptions = function (_v0) {
	var model = _v0;
	var subs = function () {
		var _v3 = model.ai;
		switch (_v3.$) {
			case 0:
				return $elm$core$Platform$Sub$none;
			case 1:
				var practiceNavModel = _v3.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Navbar$PracticeNavbarMsg,
					$author$project$Navbars$Practice$subscriptions(practiceNavModel));
			case 2:
				var companyNavModel = _v3.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Navbar$CompanyNavbarMsg,
					$author$project$Navbars$Company$subscriptions(companyNavModel));
			default:
				var partnerNavModel = _v3.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Navbar$PartnerNavbarMsg,
					$author$project$Navbars$Partner$subscriptions(partnerNavModel));
		}
	}();
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				subs,
				$author$project$Ports$Navbar$sidenavHinterViewUpdated($author$project$Navbar$HinterViewUpdated),
				$elm$browser$Browser$Events$onResize(
				F2(
					function (_v1, _v2) {
						return $author$project$Navbar$ScreenResized;
					}))
			]));
};
var $author$project$Shared$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ports$Session$onAccessTokenUpdated($author$project$Shared$AccessTokenUpdated),
				$author$project$Ports$Session$onAccessTokenCreated($author$project$Shared$AccessTokenCreated),
				A2(
				$elm$time$Time$every,
				$author$project$Shared$seconds(1),
				$author$project$Shared$GotCurrentTime),
				$author$project$Ports$Session$onLogoutWarning($author$project$Shared$ShowLogoutWarning),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Shared$GlobalSearchMsg,
				$author$project$Components$GlobalSearch$subscriptions(model.gw)),
				A2($elm$core$Platform$Sub$map, $author$project$Shared$AccountLockedModalMsg, $author$project$Components$AccountLockedModal$subscriptions),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Navbar$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Shared$NavbarMsg)),
					model.aj)),
				$author$project$Ports$Session$sessionLoggedOut($author$project$Shared$LoggedOut),
				$author$project$Components$PendingChangesModal$subscriptions($author$project$Shared$PendingChangesKeep),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$PatientsList$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Shared$PatientsListMsg)),
					model.ajU)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$OrganizationSwitcher$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Shared$OrganizationSwitcherMsg)),
					model.g1))
			]));
};
var $author$project$Spa$Generated$Pages$bundle = function (bigModel) {
	switch (bigModel.$) {
		case 0:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.FU.a(model);
		case 1:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.xC.a(model);
		case 2:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.xD.a(model);
		case 3:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.xL.a(model);
		case 4:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.aL.a(model);
		case 5:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.zM.a(model);
		case 6:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.z4.a(model);
		case 7:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.AG.a(model);
		case 8:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.AH.a(model);
		case 9:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.tl.a(model);
		case 10:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Cc.a(model);
		case 11:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.DK.a(model);
		case 12:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.w1.a(model);
		case 13:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.xd.a(model);
		case 14:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yI.a(model);
		case 15:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.zH.a(model);
		case 16:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.AT.a(model);
		case 17:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.C5.a(model);
		case 18:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Dt.a(model);
		case 19:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.FA.a(model);
		case 20:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.FM.a(model);
		case 21:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.vx.a(model);
		case 22:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.vF.a(model);
		case 23:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.vM.a(model);
		case 24:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.vO.a(model);
		case 25:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.vP.a(model);
		case 26:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.vQ.a(model);
		case 27:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.vV.a(model);
		case 28:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.vZ.a(model);
		case 29:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.v1.a(model);
		case 30:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wh.a(model);
		case 31:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wm.a(model);
		case 32:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wn.a(model);
		case 33:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wp.a(model);
		case 34:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wq.a(model);
		case 35:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wr.a(model);
		case 36:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.ws.a(model);
		case 37:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wt.a(model);
		case 38:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wu.a(model);
		case 39:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wC.a(model);
		case 40:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wD.a(model);
		case 41:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wF.a(model);
		case 42:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wG.a(model);
		case 43:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wM.a(model);
		case 44:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wN.a(model);
		case 45:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wR.a(model);
		case 46:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wS.a(model);
		case 47:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wT.a(model);
		case 48:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wX.a(model);
		case 49:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wY.a(model);
		case 50:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wZ.a(model);
		case 51:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.w$.a(model);
		case 52:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.xb.a(model);
		case 53:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.xc.a(model);
		case 54:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.x_.a(model);
		case 55:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yn.a(model);
		case 56:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yH.a(model);
		case 57:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yL.a(model);
		case 58:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yM.a(model);
		case 59:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.zG.a(model);
		case 60:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.z_.a(model);
		case 61:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.z$.a(model);
		case 62:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.z0.a(model);
		case 63:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.z1.a(model);
		case 64:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.z2.a(model);
		case 65:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.z3.a(model);
		case 66:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Ag.a(model);
		case 67:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Ah.a(model);
		case 68:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Ai.a(model);
		case 69:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.AN.a(model);
		case 70:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.AY.a(model);
		case 71:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.AZ.a(model);
		case 72:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.A_.a(model);
		case 73:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.A3.a(model);
		case 74:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.A4.a(model);
		case 75:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.A5.a(model);
		case 76:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.A6.a(model);
		case 77:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Bd.a(model);
		case 78:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Bv.a(model);
		case 79:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Bw.a(model);
		case 80:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Bx.a(model);
		case 81:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.By.a(model);
		case 82:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Bz.a(model);
		case 83:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.BD.a(model);
		case 84:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.BE.a(model);
		case 85:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.BU.a(model);
		case 86:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Cn.a(model);
		case 87:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Co.a(model);
		case 88:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Cv.a(model);
		case 89:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Cw.a(model);
		case 90:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CF.a(model);
		case 91:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CN.a(model);
		case 92:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.C6.a(model);
		case 93:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Dj.a(model);
		case 94:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Dk.a(model);
		case 95:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Dl.a(model);
		case 96:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Dm.a(model);
		case 97:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Dn.a(model);
		case 98:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Do.a(model);
		case 99:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Dp.a(model);
		case 100:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Ds.a(model);
		case 101:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.DS.a(model);
		case 102:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.DT.a(model);
		case 103:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.DV.a(model);
		case 104:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.DZ.a(model);
		case 105:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.D_.a(model);
		case 106:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.D0.a(model);
		case 107:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.D1.a(model);
		case 108:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.D2.a(model);
		case 109:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.D3.a(model);
		case 110:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.D4.a(model);
		case 111:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.D5.a(model);
		case 112:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.D6.a(model);
		case 113:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.D8.a(model);
		case 114:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Ea.a(model);
		case 115:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Ec.a(model);
		case 116:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.ES.a(model);
		case 117:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.ET.a(model);
		case 118:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.EU.a(model);
		case 119:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.EV.a(model);
		case 120:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.EW.a(model);
		case 121:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.EX.a(model);
		case 122:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.EY.a(model);
		case 123:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.EZ.a(model);
		case 124:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.E_.a(model);
		case 125:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.E$.a(model);
		case 126:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.E0.a(model);
		case 127:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.E1.a(model);
		case 128:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.E2.a(model);
		case 129:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.E3.a(model);
		case 130:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.E4.a(model);
		case 131:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.E5.a(model);
		case 132:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.E6.a(model);
		case 133:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.E7.a(model);
		case 134:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.E8.a(model);
		case 135:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.E9.a(model);
		case 136:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Fa.a(model);
		case 137:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Fb.a(model);
		case 138:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Fc.a(model);
		case 139:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Fd.a(model);
		case 140:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Fe.a(model);
		case 141:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Ff.a(model);
		case 142:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Fg.a(model);
		case 143:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Fh.a(model);
		case 144:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Fi.a(model);
		case 145:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Fj.a(model);
		case 146:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Fk.a(model);
		case 147:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Fl.a(model);
		case 148:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Fm.a(model);
		case 149:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Fn.a(model);
		case 150:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Fo.a(model);
		case 151:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Fp.a(model);
		case 152:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Fq.a(model);
		case 153:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Fr.a(model);
		case 154:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Fs.a(model);
		case 155:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Ft.a(model);
		case 156:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Fu.a(model);
		case 157:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Fv.a(model);
		case 158:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Fw.a(model);
		case 159:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Fx.a(model);
		case 160:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Fy.a(model);
		case 161:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Fz.a(model);
		case 162:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.FB.a(model);
		case 163:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.FC.a(model);
		case 164:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.FD.a(model);
		case 165:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.FE.a(model);
		case 166:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.FH.a(model);
		case 167:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.FK.a(model);
		case 168:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.F2.a(model);
		case 169:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.F3.a(model);
		case 170:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.F5.a(model);
		case 171:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.F6.a(model);
		case 172:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.xn.a(model);
		case 173:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.zu.a(model);
		case 174:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.As.a(model);
		case 175:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.AP.a(model);
		case 176:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.vL.a(model);
		case 177:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.vT.a(model);
		case 178:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.vY.a(model);
		case 179:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.v0.a(model);
		case 180:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.v7.a(model);
		case 181:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.v5.a(model);
		case 182:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wg.a(model);
		case 183:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wl.a(model);
		case 184:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wL.a(model);
		case 185:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wO.a(model);
		case 186:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wQ.a(model);
		case 187:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wW.a(model);
		case 188:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.xV.a(model);
		case 189:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yk.a(model);
		case 190:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.ym.a(model);
		case 191:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yD.a(model);
		case 192:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yK.a(model);
		case 193:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.zZ.a(model);
		case 194:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Af.a(model);
		case 195:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.A2.a(model);
		case 196:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Bc.a(model);
		case 197:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Bu.a(model);
		case 198:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.BC.a(model);
		case 199:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.BL.a(model);
		case 200:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.B6.a(model);
		case 201:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Cu.a(model);
		case 202:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Cx.a(model);
		case 203:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CE.a(model);
		case 204:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.C3.a(model);
		case 205:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.DR.a(model);
		case 206:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.FL.a(model);
		case 207:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.F4.a(model);
		case 208:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.vG.a(model);
		case 209:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.vH.a(model);
		case 210:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.vI.a(model);
		case 211:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.vJ.a(model);
		case 212:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.vK.a(model);
		case 213:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.vS.a(model);
		case 214:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.vU.a(model);
		case 215:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.vX.a(model);
		case 216:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.v$.a(model);
		case 217:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.v2.a(model);
		case 218:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.v4.a(model);
		case 219:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.v8.a(model);
		case 220:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.v9.a(model);
		case 221:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wa.a(model);
		case 222:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wb.a(model);
		case 223:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wc.a(model);
		case 224:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wd.a(model);
		case 225:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wf.a(model);
		case 226:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wi.a(model);
		case 227:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wj.a(model);
		case 228:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wk.a(model);
		case 229:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wv.a(model);
		case 230:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.ww.a(model);
		case 231:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wx.a(model);
		case 232:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wy.a(model);
		case 233:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wA.a(model);
		case 234:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wB.a(model);
		case 235:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wE.a(model);
		case 236:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wK.a(model);
		case 237:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wP.a(model);
		case 238:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wV.a(model);
		case 239:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.w_.a(model);
		case 240:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.w3.a(model);
		case 241:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.w6.a(model);
		case 242:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.w7.a(model);
		case 243:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.w8.a(model);
		case 244:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.w9.a(model);
		case 245:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.xa.a(model);
		case 246:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yj.a(model);
		case 247:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yl.a(model);
		case 248:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yo.a(model);
		case 249:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yp.a(model);
		case 250:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yt.a(model);
		case 251:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yu.a(model);
		case 252:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yx.a(model);
		case 253:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yy.a(model);
		case 254:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yz.a(model);
		case 255:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yA.a(model);
		case 256:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.A$.a(model);
		case 257:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.A1.a(model);
		case 258:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Ba.a(model);
		case 259:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.A8.a(model);
		case 260:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Bt.a(model);
		case 261:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.BJ.a(model);
		case 262:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.B7.a(model);
		case 263:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.B8.a(model);
		case 264:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.B9.a(model);
		case 265:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Ca.a(model);
		case 266:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Cp.a(model);
		case 267:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Cq.a(model);
		case 268:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Cr.a(model);
		case 269:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Cs.a(model);
		case 270:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Ct.a(model);
		case 271:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CD.a(model);
		case 272:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CG.a(model);
		case 273:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CH.a(model);
		case 274:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CT.a(model);
		case 275:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CU.a(model);
		case 276:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CV.a(model);
		case 277:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CW.a(model);
		case 278:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CX.a(model);
		case 279:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.C$.a(model);
		case 280:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.C4.a(model);
		case 281:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Dr.a(model);
		case 282:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.DU.a(model);
		case 283:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.DW.a(model);
		case 284:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.DY.a(model);
		case 285:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.D$.a(model);
		case 286:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.D7.a(model);
		case 287:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.D9.a(model);
		case 288:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Eb.a(model);
		case 289:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.vR.a(model);
		case 290:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.vW.a(model);
		case 291:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.v_.a(model);
		case 292:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.v6.a(model);
		case 293:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.v3.a(model);
		case 294:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.we.a(model);
		case 295:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wo.a(model);
		case 296:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wH.a(model);
		case 297:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wU.a(model);
		case 298:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.zY.a(model);
		case 299:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.A0.a(model);
		case 300:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Be.a(model);
		case 301:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Bs.a(model);
		case 302:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.BA.a(model);
		case 303:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.BF.a(model);
		case 304:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.BK.a(model);
		case 305:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Cy.a(model);
		case 306:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.DQ.a(model);
		case 307:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.DX.a(model);
		case 308:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.w5.a(model);
		case 309:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yi.a(model);
		case 310:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.ys.a(model);
		case 311:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yw.a(model);
		case 312:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yE.a(model);
		case 313:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Bb.a(model);
		case 314:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.A9.a(model);
		case 315:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CO.a(model);
		case 316:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CP.a(model);
		case 317:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CS.a(model);
		case 318:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.C_.a(model);
		case 319:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.C1.a(model);
		case 320:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.C2.a(model);
		case 321:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wz.a(model);
		case 322:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.ye.a(model);
		case 323:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yf.a(model);
		case 324:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yq.a(model);
		case 325:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yC.a(model);
		case 326:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.AK.a(model);
		case 327:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.AL.a(model);
		case 328:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.AM.a(model);
		case 329:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.AO.a(model);
		case 330:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.AQ.a(model);
		case 331:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.AR.a(model);
		case 332:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.AS.a(model);
		case 333:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.BG.a(model);
		case 334:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.BH.a(model);
		case 335:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.BI.a(model);
		case 336:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Cz.a(model);
		case 337:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CA.a(model);
		case 338:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CB.a(model);
		case 339:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CC.a(model);
		case 340:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CZ.a(model);
		case 341:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Dq.a(model);
		case 342:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.vN.a(model);
		case 343:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.w4.a(model);
		case 344:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yv.a(model);
		case 345:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yB.a(model);
		case 346:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Bf.a(model);
		case 347:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Bg.a(model);
		case 348:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.BB.a(model);
		case 349:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.C0.a(model);
		case 350:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yd.a(model);
		case 351:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yh.a(model);
		case 352:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yF.a(model);
		case 353:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CQ.a(model);
		case 354:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CR.a(model);
		case 355:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CY.a(model);
		case 356:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wI.a(model);
		case 357:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yb.a(model);
		case 358:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yc.a(model);
		case 359:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yG.a(model);
		case 360:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wJ.a(model);
		case 361:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yg.a(model);
		case 362:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.A7.a(model);
		case 363:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.ya.a(model);
		default:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yr.a(model);
	}
};
var $author$project$Spa$Generated$Pages$subscriptions = function (model) {
	return $author$project$Spa$Generated$Pages$bundle(model).alO(0);
};
var $author$project$Layouts$Admin$subscriptions = function (model) {
	return $author$project$Ui$Nav$subscriptions(model.kp);
};
var $author$project$Layouts$Affiliates$subscriptions = function (model) {
	return $author$project$Ui$Nav$subscriptions(model.kp);
};
var $author$project$Layouts$Affiliates$Affiliate$subscriptions = function (model) {
	return $author$project$Ui$Nav$subscriptions(model.kp);
};
var $author$project$Layouts$Commissions$subscriptions = function (model) {
	return $author$project$Ui$Nav$subscriptions(model.kp);
};
var $author$project$Layouts$Commissions$BrokerAccount$subscriptions = function (model) {
	return $author$project$Ui$Nav$subscriptions(model.kp);
};
var $author$project$Layouts$Company$subscriptions = function (model) {
	return $author$project$Ui$Nav$subscriptions(model.kp);
};
var $author$project$Layouts$Marketplace$Manage$subscriptions = function (model) {
	return $author$project$Ui$Nav$subscriptions(model.kp);
};
var $author$project$Layouts$Partner$Billing$subscriptions = function (model) {
	return $author$project$Ui$Nav$subscriptions(model.kp);
};
var $author$project$Layouts$Partner$Practices$subscriptions = function (model) {
	return $author$project$Ui$Nav$subscriptions(model.kp);
};
var $author$project$Layouts$Partner$Product$subscriptions = function (model) {
	return $author$project$Ui$Nav$subscriptions(model.kp);
};
var $author$project$Layouts$Partner$Webhooks$subscriptions = function (model) {
	return $author$project$Ui$Nav$subscriptions(model.kp);
};
var $author$project$Components$PatientChart$NotesCard$CancelNoteEdit = {$: 11};
var $author$project$Components$PatientChart$NotesCard$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Components$PatientChart$NotesCard$subscriptions = function (_v0) {
	var model = _v0;
	var noteModalSub = function () {
		var _v1 = model.al;
		if (!_v1.$) {
			return $author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$PatientChart$NotesCard$CancelNoteEdit);
		} else {
			return $elm$core$Platform$Sub$none;
		}
	}();
	var deleteConfirmSub = A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Platform$Sub$none,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$PatientChart$NotesCard$HiConfirmClosed),
			model.jg));
	var actionMenuSubs = A2(
		$elm$core$List$map,
		$author$project$Ui$FlyoutMenu$subscriptions,
		$elm$core$Dict$values(model.aZ));
	return $elm$core$Platform$Sub$batch(
		A2(
			$elm$core$List$cons,
			noteModalSub,
			A2(
				$elm$core$List$cons,
				deleteConfirmSub,
				A2(
					$elm$core$List$cons,
					$author$project$Ui$Dropdown$subscriptions(model.nM),
					actionMenuSubs))));
};
var $author$project$Components$PatientChart$PatientInfoCard$AuditTrailLogMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$PatientChart$PatientInfoCard$subscriptions = function (_v0) {
	var model = _v0;
	var _v1 = model.iw;
	if (!_v1.$) {
		var auditTrailLog = _v1.a;
		return $author$project$Components$AuditTrailLog$isOpen(auditTrailLog) ? A2(
			$elm$core$Platform$Sub$map,
			$author$project$Components$PatientChart$PatientInfoCard$AuditTrailLogMsg,
			$author$project$Components$AuditTrailLog$subscriptions(auditTrailLog)) : $elm$core$Platform$Sub$none;
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Components$PaymentMethodsCard$AuditTrailLogMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$PaymentMethodsCard$CancelEdit = {$: 12};
var $author$project$Components$PaymentMethodsCard$CreatePaymentMethodModalMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$PaymentMethodsCard$DeleteConfirmClosed = F2(
	function (a, b) {
		return {$: 19, a: a, b: b};
	});
var $author$project$Components$PaymentMethodsCard$MovePaymentMethodsModalMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$PaymentMethodsCard$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$PaymentMethodsCard$CreatePaymentMethodModalMsg,
				$author$project$Components$CreatePaymentMethodModal$subscriptions(model.i_)),
				$author$project$Ui$FlyoutMenu$subscriptions(model.nN),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$PaymentMethodsCard$MovePaymentMethodsModalMsg,
				$author$project$Components$MovePaymentMethodsModal$subscriptions(model.gY)),
				function () {
				var _v1 = model.iw;
				if (!_v1.$) {
					var auditTrailLog = _v1.a;
					return $author$project$Components$AuditTrailLog$isOpen(auditTrailLog) ? A2(
						$elm$core$Platform$Sub$map,
						$author$project$Components$PaymentMethodsCard$AuditTrailLogMsg,
						$author$project$Components$AuditTrailLog$subscriptions(auditTrailLog)) : $elm$core$Platform$Sub$none;
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				function () {
				var _v2 = model.x;
				if (!_v2.$) {
					var editing = _v2.a;
					return _Utils_eq(editing.k9, $author$project$Api$Data$Loading) ? $elm$core$Platform$Sub$none : $author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$PaymentMethodsCard$CancelEdit);
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				function () {
				var _v3 = model.gc;
				if (!_v3.$) {
					var source = _v3.a;
					return $author$project$Components$HiConfirm$subscribeToEscapeKeyPress(
						$author$project$Components$PaymentMethodsCard$DeleteConfirmClosed(source));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}()
			]));
};
var $author$project$Layouts$Patient$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$Nav$subscriptions(model.kp),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Layouts$Patient$PaymentMethodsCardMsg,
				$author$project$Components$PaymentMethodsCard$subscriptions(model.eQ)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$PatientChart$NotesCard$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Layouts$Patient$NotesCardMsg)),
					model.eM)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Layouts$Patient$PatientInfoCardMsg,
				$author$project$Components$PatientChart$PatientInfoCard$subscriptions(model.eO))
			]));
};
var $author$project$Layouts$PatientChart$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Layouts$User$subscriptions = function (_v0) {
	var nav = _v0.kp;
	return $author$project$Ui$Nav$subscriptions(nav);
};
var $author$project$Spa$Layout$subscriptions = function (model) {
	switch (model.$) {
		case 0:
			return $elm$core$Platform$Sub$none;
		case 1:
			return $elm$core$Platform$Sub$none;
		case 2:
			return $elm$core$Platform$Sub$none;
		case 3:
			var patientModel = model.b;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Spa$Layout$PatientMsg,
				$author$project$Layouts$Patient$subscriptions(patientModel));
		case 4:
			var commissionsModel = model.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Spa$Layout$CommissionsMsg,
				$author$project$Layouts$Commissions$subscriptions(commissionsModel));
		case 5:
			var brokerAccountModel = model.b;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Spa$Layout$CommissionsBrokerAccountMsg,
				$author$project$Layouts$Commissions$BrokerAccount$subscriptions(brokerAccountModel));
		case 6:
			var affiliatesModel = model.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Spa$Layout$AffiliatesMsg,
				$author$project$Layouts$Affiliates$subscriptions(affiliatesModel));
		case 20:
			return $elm$core$Platform$Sub$none;
		case 7:
			var affiliateModel = model.b;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Spa$Layout$AffiliatesAffiliateMsg,
				$author$project$Layouts$Affiliates$Affiliate$subscriptions(affiliateModel));
		case 8:
			var billingModel = model.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Spa$Layout$PartnerBillingMsg,
				$author$project$Layouts$Partner$Billing$subscriptions(billingModel));
		case 9:
			var practicesModel = model.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Spa$Layout$PartnerPracticesMsg,
				$author$project$Layouts$Partner$Practices$subscriptions(practicesModel));
		case 10:
			var productModel = model.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Spa$Layout$PartnerProductMsg,
				$author$project$Layouts$Partner$Product$subscriptions(productModel));
		case 11:
			var webhooksModel = model.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Spa$Layout$PartnerWebhooksMsg,
				$author$project$Layouts$Partner$Webhooks$subscriptions(webhooksModel));
		case 12:
			var manageModel = model.b;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Spa$Layout$MarketplaceManageMsg,
				$author$project$Layouts$Marketplace$Manage$subscriptions(manageModel));
		case 13:
			var companyModel = model.b;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Spa$Layout$CompanyMsg,
				$author$project$Layouts$Company$subscriptions(companyModel));
		case 14:
			var adminModel = model.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Spa$Layout$AdminMsg,
				$author$project$Layouts$Admin$subscriptions(adminModel));
		case 15:
			return $elm$core$Platform$Sub$none;
		case 16:
			return $elm$core$Platform$Sub$none;
		case 17:
			var patientChartModel = model.b;
			return $author$project$Layouts$PatientChart$subscriptions(patientChartModel);
		case 18:
			return $elm$core$Platform$Sub$none;
		default:
			var userModel = model.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Spa$Layout$UserMsg,
				$author$project$Layouts$User$subscriptions(userModel));
	}
};
var $author$project$Main$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ports$Navigation$onUrlChange($author$project$Main$UrlChanged),
				$author$project$Ports$Navigation$onUrlRequest($author$project$Main$UrlRequested),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$Shared,
				$author$project$Shared$subscriptions(model.lk)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$Pages,
				$author$project$Spa$Generated$Pages$subscriptions(model.dB)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$Layout,
				$author$project$Spa$Layout$subscriptions(model.bE))
			]));
};
var $author$project$Spa$Document$toBrowserElement = function (doc) {
	return A2($elm$html$Html$div, _List_Nil, doc.fO);
};
var $author$project$Main$RequestLoadClinical = {$: 6};
var $author$project$Main$AttemptedScrollingToFragment = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $elm$browser$Browser$Dom$setViewport = _Browser_setViewport;
var $author$project$Utils$Scroll$toElementByIdWithDelay = F3(
	function (delay, elementId, toMsg) {
		return A2(
			$elm$core$Task$attempt,
			toMsg,
			A2(
				$elm$core$Task$andThen,
				function (_v1) {
					var element = _v1.agJ;
					return A2($elm$browser$Browser$Dom$setViewport, 0, element.aeD);
				},
				A2(
					$elm$core$Task$andThen,
					function (_v0) {
						return $elm$browser$Browser$Dom$getElement(elementId);
					},
					$elm$core$Process$sleep(delay))));
	});
var $author$project$Main$attemptScrollingToFragment = F2(
	function (attempts, fragment) {
		return (attempts > 3) ? $elm$core$Platform$Cmd$none : A3(
			$author$project$Utils$Scroll$toElementByIdWithDelay,
			500,
			fragment,
			A2($author$project$Main$AttemptedScrollingToFragment, attempts + 1, fragment));
	});
var $author$project$Ports$Clinical$dispatchLoadClinicalPort = _Platform_outgoingPort(
	'dispatchLoadClinicalPort',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$Clinical$load = $author$project$Ports$Clinical$dispatchLoadClinicalPort(0);
var $author$project$Spa$Generated$Pages$load = function (model) {
	return $author$project$Spa$Generated$Pages$bundle(model).aiq(0);
};
var $author$project$Main$LoadClinicalDebounceMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Main$loadClinicalDebounceConfig = {
	alK: $jinjor$elm_debounce$Debounce$later(300),
	ame: $author$project$Main$LoadClinicalDebounceMsg
};
var $author$project$Spa$Generated$Pages$save = function (model) {
	return $author$project$Spa$Generated$Pages$bundle(model).k8(0);
};
var $author$project$Shared$OrgSwitcher$Company = function (a) {
	return {$: 1, a: a};
};
var $author$project$Shared$GotSessionCreated = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Shared$GotUserPractices = F2(
	function (a, b) {
		return {$: 20, a: a, b: b};
	});
var $author$project$Shared$OrgSwitcher$Patient = function (a) {
	return {$: 0, a: a};
};
var $author$project$Shared$OrgSwitcher$transitionToDefaultState = F3(
	function (session, hinterViewOff, reload) {
		return (reload ? $author$project$Utils$Route$navigateAndReload($elm$core$Dict$empty) : $author$project$Utils$Route$navigate($elm$core$Dict$empty))(
			A2($author$project$Permission$homeStateFor, session, hinterViewOff));
	});
var $author$project$Shared$OrgSwitcher$redirect = F3(
	function (session, hinterViewOff, maybePending) {
		if (maybePending.$ === 1) {
			return $elm$core$Platform$Cmd$none;
		} else {
			var action = maybePending.a.Gg;
			var _v1 = _Utils_Tuple2(session, action);
			if (_v1.a.$ === 3) {
				switch (_v1.b.$) {
					case 0:
						var _v2 = _v1.a;
						var session_ = _v2.a;
						var _v3 = _v1.b;
						return A3($author$project$Shared$OrgSwitcher$transitionToDefaultState, session_, hinterViewOff, false);
					case 3:
						var _v4 = _v1.a;
						var session_ = _v4.a;
						var _v5 = _v1.b;
						return A3($author$project$Shared$OrgSwitcher$transitionToDefaultState, session_, hinterViewOff, true);
					case 1:
						var _v6 = _v1.a;
						var route = _v1.b.a;
						return A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, route);
					case 2:
						var _v7 = _v1.a;
						var route = _v1.b.a;
						return A2($author$project$Utils$Route$navigateAndReload, $elm$core$Dict$empty, route);
					default:
						var _v8 = _v1.a;
						var _v9 = _v1.b;
						return $elm$core$Platform$Cmd$none;
				}
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		}
	});
var $author$project$Shared$GotWhitelabelSetting = function (a) {
	return {$: 25, a: a};
};
var $author$project$Shared$retrieveWhitelabelSettings = F2(
	function (apiClient, session) {
		return A3($author$project$Api$WhitelabelSetting$retrieve, apiClient, session, $author$project$Shared$GotWhitelabelSetting);
	});
var $author$project$Shared$applySession = F4(
	function (response, session, model, extraCmd) {
		var retrieveCompanyCmd = function () {
			var _v0 = model.pI;
			if (!_v0.$) {
				var companyId = _v0.a;
				return A4(
					$author$project$Api$Company$retrieve,
					model.Gv,
					session,
					companyId,
					$author$project$Shared$GotCompany(companyId));
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		}();
		var isClinicalSwitch = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (p) {
					return _Utils_eq(p.Gg, $author$project$OutMsg$GoToClinicalAction);
				},
				model.dD));
		var orgSwitchRedirectCmd = isClinicalSwitch ? $elm$core$Platform$Cmd$none : A3($author$project$Shared$OrgSwitcher$redirect, response, model.ahK, model.dD);
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					ajE: $author$project$Api$Platform$Session$One$organizationIsCompany(session),
					dD: isClinicalSwitch ? model.dD : $elm$core$Maybe$Nothing,
					pI: $elm$core$Maybe$Nothing,
					aa4: response
				}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						extraCmd,
						$author$project$Api$Platform$Session$One$organizationIsPartner(session) ? $author$project$Shared$retrievePartner(model.Gv) : $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Shared$retrievePractice, model.Gv, session),
								A2($author$project$Shared$retrieveWhitelabelSettings, model.Gv, session)
							])),
						retrieveCompanyCmd,
						orgSwitchRedirectCmd
					])));
	});
var $author$project$Ports$Intercom$intercomPortShutdown = _Platform_outgoingPort(
	'intercomPortShutdown',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$Intercom$shutdown = $author$project$Ports$Intercom$intercomPortShutdown(0);
var $author$project$Shared$deidentifyForIntercom = $author$project$Ports$Intercom$shutdown;
var $author$project$Ports$FullStory$fullStoryPortStopCapturing = _Platform_outgoingPort(
	'fullStoryPortStopCapturing',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$FullStory$shutdown = $author$project$Ports$FullStory$fullStoryPortStopCapturing(0);
var $author$project$Shared$deidentifyForSessionRecording = $author$project$Ports$FullStory$shutdown;
var $author$project$Shared$deidentifyOnExternalServices = $elm$core$Platform$Cmd$batch(
	_List_fromArray(
		[$author$project$Shared$deidentifyForIntercom, $author$project$Shared$deidentifyForSessionRecording]));
var $author$project$Ports$GlobalSearch$enableGlobalSearchShortcutPort = _Platform_outgoingPort(
	'enableGlobalSearchShortcutPort',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$GlobalSearch$enableCoreGlobalSearchShortcut = $author$project$Ports$GlobalSearch$enableGlobalSearchShortcutPort(0);
var $author$project$Shared$shouldEmbedClinical = function (practice) {
	if (practice.$ === 3) {
		var practice_ = practice.a;
		return $author$project$Api$Practice$hasClinicalAccount(practice_) && A2($author$project$Api$Practice$featureEnabled, 19, practice_);
	} else {
		return false;
	}
};
var $author$project$Shared$enableCoreGlobalSearchShortcutFn = function (_v0) {
	var model = _v0.a;
	var msg = _v0.b;
	return $author$project$Shared$shouldEmbedClinical(model.ZV) ? _Utils_Tuple2(model, msg) : _Utils_Tuple2(
		model,
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[msg, $author$project$Ports$GlobalSearch$enableCoreGlobalSearchShortcut])));
};
var $author$project$Navbars$Company$extractOrgSwitcherMsg = function (msg) {
	if (msg.$ === 5) {
		var subMsg = msg.a;
		return $elm$core$Maybe$Just(subMsg);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Navbars$Partner$extractOrgSwitcherMsg = function (msg) {
	if (msg.$ === 5) {
		var subMsg = msg.a;
		return $elm$core$Maybe$Just(subMsg);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Navbars$Practice$extractOrgSwitcherMsg = function (msg) {
	if (msg.$ === 19) {
		var subMsg = msg.a;
		return $elm$core$Maybe$Just(subMsg);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Navbar$extractOrgSwitcherMsg = function (msg) {
	switch (msg.$) {
		case 0:
			var subMsg = msg.a;
			return $author$project$Navbars$Practice$extractOrgSwitcherMsg(subMsg);
		case 1:
			var subMsg = msg.a;
			return $author$project$Navbars$Company$extractOrgSwitcherMsg(subMsg);
		case 2:
			var subMsg = msg.a;
			return $author$project$Navbars$Partner$extractOrgSwitcherMsg(subMsg);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Utils$Clinical$getDashboardUrl = F3(
	function (isUnifiedExperience, origin, emrHost) {
		return A3($author$project$Utils$Clinical$getHost, isUnifiedExperience, origin, emrHost) + '/home';
	});
var $author$project$Shared$OrgSwitcher$emrDashboardUrl = F3(
	function (practice, origin, emrHost) {
		return A3(
			$author$project$Utils$Clinical$getDashboardUrl,
			A2($author$project$Api$Practice$featureEnabled, 19, practice),
			origin,
			emrHost);
	});
var $author$project$Shared$handlePendingClinicalRedirect = F2(
	function (response, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		var _v1 = _Utils_Tuple2(model.dD, response);
		if ((!_v1.a.$) && (_v1.b.$ === 3)) {
			var action = _v1.a.a.Gg;
			var _v2 = _v1.b;
			var practice = _v2.a;
			return _Utils_eq(action, $author$project$OutMsg$GoToClinicalAction) ? _Utils_Tuple2(
				_Utils_update(
					model,
					{dD: $elm$core$Maybe$Nothing}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							cmd,
							A3(
							$author$project$Ports$Navigation$requestUrl,
							A3($author$project$Shared$OrgSwitcher$emrDashboardUrl, practice, model.ahq.ajG, model.ahq.agP),
							false,
							false)
						]))) : _Utils_Tuple2(model, cmd);
		} else {
			return _Utils_Tuple2(model, cmd);
		}
	});
var $author$project$Ports$Intercom$intercomPortBoot = _Platform_outgoingPort('intercomPortBoot', $elm$core$Basics$identity);
var $author$project$Api$Platform$User$Shared$intercomUserHash = function (_v0) {
	var record = _v0;
	return record.Uh;
};
var $author$project$Utils$User$isHinter = function (user) {
	return $author$project$Api$Platform$User$Shared$isAdmin(user) || A2(
		$author$project$Utils$Regex$matches,
		'@hint\\.com$',
		$author$project$Api$Platform$User$Shared$email(user));
};
var $author$project$Ports$Intercom$boot = F3(
	function (intercomAppId, session, practice) {
		var user = $author$project$Api$Platform$Session$One$user(session);
		var userAttrs = _List_fromArray(
			[
				_Utils_Tuple2(
				'user_id',
				$elm$json$Json$Encode$string(
					$author$project$Api$Platform$User$Shared$id(user))),
				_Utils_Tuple2(
				'user_hash',
				$elm$json$Json$Encode$string(
					$author$project$Api$Platform$User$Shared$intercomUserHash(user)))
			]);
		var practiceAttrs = $author$project$Utils$User$isHinter(user) ? _List_Nil : _List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(
					$author$project$Api$Practice$id(practice)))
			]);
		var encoded = $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'app_id',
					$elm$json$Json$Encode$string(intercomAppId)),
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						'company',
						$elm$json$Json$Encode$object(practiceAttrs)),
					userAttrs)));
		return $author$project$Ports$Intercom$intercomPortBoot(encoded);
	});
var $author$project$Shared$identifyForIntercom = function (_v0) {
	var model = _v0.a;
	var cmd = _v0.b;
	return _Utils_Tuple2(
		model,
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					cmd,
					function () {
					var _v1 = _Utils_Tuple3(model.ahq.ah1, model.aa4, model.ZV);
					if (((!_v1.a.$) && (_v1.b.$ === 3)) && (_v1.c.$ === 3)) {
						var intercomAppId = _v1.a.a;
						var _v2 = _v1.b;
						var session = _v2.a;
						var _v3 = _v1.c;
						var practice = _v3.a;
						return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $author$project$Ports$Intercom$shutdown : A3($author$project$Ports$Intercom$boot, intercomAppId, session, practice);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}()
				])));
};
var $author$project$Api$Provider$Practice$Shared$createdAt = function (_v0) {
	var record = _v0;
	return record.O1;
};
var $author$project$Api$Provider$Practice$One$createdAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$createdAt(shared);
};
var $author$project$Api$Practice$createdAt = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $elm$core$Maybe$Just(
			$author$project$Api$Provider$Practice$One$createdAt(practice_));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Utils$Release$currentRelease = function (_v0) {
	var model = _v0;
	var _v1 = model.Hb;
	if (_v1 === '') {
		return $elm$core$Maybe$Nothing;
	} else {
		var rest = _v1;
		return $elm$core$Maybe$Just(rest);
	}
};
var $author$project$Api$Employer$Practice$One$email = function (_v0) {
	var record = _v0;
	return record.Rj;
};
var $author$project$Api$Practice$email = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$email(practice_);
	} else {
		var practice_ = practice.a;
		return $author$project$Api$Employer$Practice$One$email(practice_);
	}
};
var $author$project$Ports$FullStory$fullStoryPortBoot = _Platform_outgoingPort(
	'fullStoryPortBoot',
	function ($) {
		var a = $.a;
		var b = $.b;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$json$Json$Encode$string(a),
					$elm$core$Basics$identity(b)
				]));
	});
var $author$project$Ports$FullStory$boot = F3(
	function (session, practice, release) {
		var user = $author$project$Api$Platform$Session$One$user(session);
		var organizationAttrs = function () {
			var _v0 = $author$project$Api$Platform$Session$One$organization(session);
			if (!_v0.$) {
				var organization = _v0.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'organization_type',
						$elm$json$Json$Encode$string(
							$author$project$Api$OrganizationType$toString(
								$author$project$Api$Platform$Organization$Shared$type_(organization)))),
						_Utils_Tuple2(
						'organization_id',
						$elm$json$Json$Encode$string(
							$author$project$Api$Platform$Organization$Shared$id(organization)))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var defaultAttrs = _List_fromArray(
			[
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(
					$author$project$Api$Platform$User$Shared$email(user))),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(
					$author$project$Api$Platform$User$Shared$name(user))),
				_Utils_Tuple2(
				'practice_id',
				$elm$json$Json$Encode$string(
					$author$project$Api$Practice$id(practice))),
				_Utils_Tuple2(
				'practice_name',
				$elm$json$Json$Encode$string(
					$author$project$Api$Practice$name(practice))),
				_Utils_Tuple2(
				'practice_created_at',
				A2(
					$author$project$Utils$Encode$nullable,
					$elm$json$Json$Encode$int,
					A2(
						$elm$core$Maybe$map,
						$elm$time$Time$posixToMillis,
						$author$project$Api$Practice$createdAt(practice)))),
				_Utils_Tuple2(
				'practice_email',
				A2(
					$author$project$Utils$Encode$nullable,
					$elm$json$Json$Encode$string,
					$author$project$Api$Practice$email(practice))),
				_Utils_Tuple2(
				'practice_has_stripe_account',
				$elm$json$Json$Encode$bool(
					($author$project$Api$Practice$paymentProcessor(practice) === 'stripe') && $author$project$Api$Practice$hasPaymentProcessorAccount(practice))),
				_Utils_Tuple2(
				'practice_has_payment_processor_account',
				$elm$json$Json$Encode$bool(
					$author$project$Api$Practice$hasPaymentProcessorAccount(practice))),
				_Utils_Tuple2(
				'payment_processor',
				$elm$json$Json$Encode$string(
					$author$project$Api$Practice$paymentProcessor(practice))),
				_Utils_Tuple2(
				'soft_version',
				A2(
					$author$project$Utils$Encode$nullable,
					$elm$json$Json$Encode$string,
					$author$project$Utils$Release$currentRelease(release)))
			]);
		var userAttrs = $elm$json$Json$Encode$object(
			_Utils_ap(defaultAttrs, organizationAttrs));
		return $author$project$Ports$FullStory$fullStoryPortBoot(
			_Utils_Tuple2(
				$author$project$Api$Platform$User$Shared$id(user),
				userAttrs));
	});
var $author$project$Ports$Meticulous$meticulousRecordContext = _Platform_outgoingPort('meticulousRecordContext', $elm$core$Basics$identity);
var $author$project$Ports$Meticulous$recordSessionContext = F2(
	function (session, practice) {
		var user = $author$project$Api$Platform$Session$One$user(session);
		var contextAttrs = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'userId',
					$elm$json$Json$Encode$string(
						$author$project$Api$Platform$User$Shared$id(user))),
					_Utils_Tuple2(
					'userEmail',
					$elm$json$Json$Encode$string(
						$author$project$Api$Platform$User$Shared$email(user))),
					_Utils_Tuple2(
					'practiceId',
					$elm$json$Json$Encode$string(
						$author$project$Api$Practice$id(practice)))
				]));
		return $author$project$Ports$Meticulous$meticulousRecordContext(contextAttrs);
	});
var $author$project$Ports$Sentry$sentrySetContext = _Platform_outgoingPort('sentrySetContext', $elm$core$Basics$identity);
var $author$project$Ports$Sentry$setContext = F2(
	function (user, practice) {
		var contextAttrs = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'user_id',
					$elm$json$Json$Encode$string(
						$author$project$Api$Platform$User$Shared$id(user))),
					_Utils_Tuple2(
					'practice_id',
					$elm$json$Json$Encode$string(
						$author$project$Api$Practice$id(practice)))
				]));
		return $author$project$Ports$Sentry$sentrySetContext(contextAttrs);
	});
var $author$project$Shared$identifyForSessionRecording = function (_v0) {
	var model = _v0.a;
	var cmd = _v0.b;
	var _v1 = _Utils_Tuple2(model.aa4, model.ZV);
	if ((_v1.a.$ === 3) && (_v1.b.$ === 3)) {
		var _v2 = _v1.a;
		var session = _v2.a;
		var _v3 = _v1.b;
		var practice = _v3.a;
		var user = $author$project$Api$Platform$Session$One$user(session);
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						cmd,
						A3($author$project$Ports$FullStory$boot, session, practice, model.akL),
						A2($author$project$Ports$Sentry$setContext, user, practice),
						A2($author$project$Ports$Meticulous$recordSessionContext, session, practice)
					])));
	} else {
		return _Utils_Tuple2(model, cmd);
	}
};
var $author$project$Shared$identifyOnExternalServices = function (_v0) {
	var model = _v0.a;
	var cmd = _v0.b;
	return $author$project$Shared$identifyForSessionRecording(
		$author$project$Shared$identifyForIntercom(
			_Utils_Tuple2(model, cmd)));
};
var $author$project$Components$OrganizationSwitcher$FlyoutMenuMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$OrganizationSwitcher$GotOrganizations = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$OrganizationSwitcher$Live = 0;
var $author$project$Components$OrganizationSwitcher$Model = $elm$core$Basics$identity;
var $author$project$Components$OrganizationSwitcher$NavMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$OrganizationSwitcher$Sandbox = 1;
var $author$project$Api$Platform$User$Organization$organizationsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['organizations']),
	$author$project$Api$Platform$User$userPath);
var $author$project$Api$Platform$User$Organization$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Platform$Organization$Switcher$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Platform$User$Organization$organizationsPath));
	});
var $author$project$Components$OrganizationSwitcher$init = F2(
	function (apiClient, options) {
		var _v0 = A2($author$project$Ui$Nav$init, 'org-switcher-nav', $author$project$Components$OrganizationSwitcher$NavMsg);
		var navModel = _v0.a;
		var navCmd = _v0.b;
		return _Utils_Tuple2(
			{
				si: options.aan ? 1 : 0,
				nN: A2($author$project$Ui$FlyoutMenu$init, 'org-switcher', $author$project$Components$OrganizationSwitcher$FlyoutMenuMsg),
				oJ: navModel,
				tu: $author$project$Api$Data$Loading
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Api$Platform$User$Organization$list, apiClient, $author$project$Components$OrganizationSwitcher$GotOrganizations),
						navCmd
					])));
	});
var $author$project$Shared$initializePatientsList = function (_v0) {
	var model = _v0.a;
	var cmd = _v0.b;
	var _v1 = model.ajU;
	if (_v1.$ === 1) {
		var _v2 = _Utils_Tuple3(model.aa4, model.ZV, model.sH);
		if ((((_v2.a.$ === 3) && (_v2.b.$ === 3)) && (!_v2.b.a.$)) && (!_v2.c.$)) {
			var _v3 = _v2.a;
			var session = _v3.a;
			var _v4 = _v2.b;
			var practice = _v4.a.a;
			var query = _v2.c.a;
			var _v5 = A4(
				$author$project$Components$PatientsList$init,
				session,
				practice,
				model.m4,
				{Gv: model.Gv, DE: query, J7: model.J7, J8: model.J8, adY: model.adY});
			var patientsListModel = _v5.a;
			var patientsListCmd = _v5.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						sH: $elm$core$Maybe$Nothing,
						ajU: $elm$core$Maybe$Just(patientsListModel)
					}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							cmd,
							A2($elm$core$Platform$Cmd$map, $author$project$Shared$PatientsListMsg, patientsListCmd)
						])));
		} else {
			return _Utils_Tuple2(model, cmd);
		}
	} else {
		return _Utils_Tuple2(model, cmd);
	}
};
var $author$project$Shared$navigateToErrorPage = function (error) {
	return A2(
		$author$project$Utils$Route$navigate,
		$elm$core$Dict$empty,
		$author$project$Spa$Generated$Route$Error__Status_String(
			{
				alH: $author$project$Api$Data$errorToStatus(error)
			}));
};
var $author$project$Utils$Route$navigateWithFragment = F3(
	function (params, fragment, route) {
		return $author$project$Ports$Navigation$pushUrl(
			_Utils_ap(
				A2($author$project$Utils$Route$toString, params, route),
				A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						function (f) {
							return '#' + f;
						},
						fragment))));
	});
var $author$project$Shared$OrgSwitcher$postOrganizationSwitchedAction = function (switchOrganizationFrom) {
	return $author$project$OutMsg$GoToRouteAndReloadAction(
		function () {
			switch (switchOrganizationFrom.$) {
				case 0:
					var id = switchOrganizationFrom.a;
					return $author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
						{YZ: id});
				case 1:
					var id = switchOrganizationFrom.a;
					return $author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top(
						{fZ: id});
				case 2:
					var route = switchOrganizationFrom.a;
					return route;
				default:
					var route = switchOrganizationFrom.a;
					return route;
			}
		}());
};
var $author$project$Shared$practiceChanged = F2(
	function (oldPractice, newPractice) {
		var _v0 = _Utils_Tuple2(oldPractice, newPractice);
		_v0$2:
		while (true) {
			if (!_v0.a.$) {
				if (!_v0.b.$) {
					return !_Utils_eq(
						$author$project$Api$Practice$id(oldPractice),
						$author$project$Api$Practice$id(newPractice));
				} else {
					break _v0$2;
				}
			} else {
				if (_v0.b.$ === 1) {
					return !_Utils_eq(
						$author$project$Api$Practice$id(oldPractice),
						$author$project$Api$Practice$id(newPractice));
				} else {
					break _v0$2;
				}
			}
		}
		return true;
	});
var $author$project$Utils$Clinical$getRedirectUrl = F2(
	function (emrHost, url) {
		return _Utils_ap(
			emrHost,
			_Utils_ap(
				url.YX,
				_Utils_ap(
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							function (q) {
								return '?' + q;
							},
							url.DE)),
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							function (f) {
								return '#' + f;
							},
							url.ahu)))));
	});
var $author$project$Spa$Layout$Route$isClinicalRoute = function (url) {
	var _v0 = $author$project$Spa$Layout$Route$routeToLayout(url);
	switch (_v0.$) {
		case 18:
			return true;
		case 19:
			return true;
		default:
			return false;
	}
};
var $author$project$Utils$Clinical$isClinicalRoute = $author$project$Spa$Layout$Route$isClinicalRoute;
var $author$project$Shared$redirectToClinicalAppIfNeeded = function (_v0) {
	var model = _v0.a;
	var cmd = _v0.b;
	var _v1 = model.ZV;
	if (_v1.$ === 3) {
		var practice = _v1.a;
		return ($author$project$Utils$Clinical$isClinicalRoute(model.adY) && ($author$project$Api$Practice$hasClinicalAccount(practice) && (!A2($author$project$Api$Practice$featureEnabled, 19, practice)))) ? _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						cmd,
						$author$project$Ports$Navigation$load(
						A2($author$project$Utils$Clinical$getRedirectUrl, model.ahq.agP, model.adY))
					]))) : _Utils_Tuple2(model, cmd);
	} else {
		return _Utils_Tuple2(model, cmd);
	}
};
var $author$project$Shared$requestLoadEmbeddedClinical = function (_v0) {
	var model = _v0.a;
	var cmd = _v0.b;
	return $author$project$Shared$shouldEmbedClinical(model.ZV) ? _Utils_Tuple2(
		_Utils_update(
			model,
			{Zp: true}),
		cmd) : _Utils_Tuple2(model, cmd);
};
var $author$project$Api$WhitelabelSetting$practiceFacingFaviconAppleUrl = function (_v0) {
	var record = _v0;
	return record.Jd;
};
var $author$project$Api$WhitelabelSetting$practiceFacingFaviconIcoUrl = function (_v0) {
	var record = _v0;
	return record.Je;
};
var $author$project$Api$WhitelabelSetting$practiceFacingFaviconPngUrl = function (_v0) {
	var record = _v0;
	return record.Jf;
};
var $author$project$Ports$Favicon$setFaviconPort = _Platform_outgoingPort(
	'setFaviconPort',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'appleUrl',
					$elm$json$Json$Encode$string($.LV)),
					_Utils_Tuple2(
					'icoUrl',
					$elm$json$Json$Encode$string($.TI)),
					_Utils_Tuple2(
					'pngUrl',
					$elm$json$Json$Encode$string($.ZK))
				]));
	});
var $author$project$Shared$setFaviconUrls = function (whitelabelSetting) {
	var pngUrl = $author$project$Api$WhitelabelSetting$practiceFacingFaviconPngUrl(whitelabelSetting);
	var icoUrl = $author$project$Api$WhitelabelSetting$practiceFacingFaviconIcoUrl(whitelabelSetting);
	var appleUrl = $author$project$Api$WhitelabelSetting$practiceFacingFaviconAppleUrl(whitelabelSetting);
	return $author$project$Ports$Favicon$setFaviconPort(
		{LV: appleUrl, TI: icoUrl, ZK: pngUrl});
};
var $author$project$Shared$GotUserPartners = F2(
	function (a, b) {
		return {$: 21, a: a, b: b};
	});
var $author$project$Shared$OrgSwitcher$PartnerQueryParam = function (a) {
	return {$: 3, a: a};
};
var $author$project$Shared$OrgSwitcher$PracticeQueryParam = function (a) {
	return {$: 2, a: a};
};
var $author$project$Shared$switchToPracticeWithQueryParam = F3(
	function (apiClient, backupAuthEnabled, url) {
		var query = A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Dict$empty,
			A2($elm$core$Maybe$map, $author$project$Spa$Url$toQueryDict, url.DE));
		var practiceId = A2($elm$core$Dict$get, 'switch-to-practice', query);
		var partnerId = A2($elm$core$Dict$get, 'switch-to-partner', query);
		var _v0 = _Utils_Tuple3(backupAuthEnabled, practiceId, partnerId);
		_v0$4:
		while (true) {
			if (_v0.a) {
				if (!_v0.b.$) {
					var practiceId_ = _v0.b.a;
					return A4(
						$author$project$Api$Auth$switchToOrganization,
						apiClient,
						practiceId_,
						$elm$core$Maybe$Nothing,
						$author$project$Shared$BackupAuthOrganizationSwitched(
							$author$project$OutMsg$GoToRouteAndReloadAction(
								$author$project$Utils$Route$fromUrl(url))));
				} else {
					if (!_v0.c.$) {
						var partnerId_ = _v0.c.a;
						return A4(
							$author$project$Api$Auth$switchToOrganization,
							apiClient,
							partnerId_,
							$elm$core$Maybe$Nothing,
							$author$project$Shared$BackupAuthOrganizationSwitched(
								$author$project$OutMsg$GoToRouteAndReloadAction(
									$author$project$Utils$Route$fromUrl(url))));
					} else {
						break _v0$4;
					}
				}
			} else {
				if (!_v0.b.$) {
					var practiceId_ = _v0.b.a;
					return A4(
						$author$project$Api$Platform$User$Practice$list,
						apiClient,
						function (d) {
							return _Utils_update(
								d,
								{
									akl: $elm$core$Maybe$Just(practiceId_)
								});
						},
						$elm$core$Maybe$Nothing,
						$author$project$Shared$GotUserPractices(
							$author$project$Shared$OrgSwitcher$PracticeQueryParam(
								$author$project$Utils$Route$fromUrl(url))));
				} else {
					if (!_v0.c.$) {
						var partnerId_ = _v0.c.a;
						return A4(
							$author$project$Api$Platform$User$Partner$list,
							apiClient,
							function (d) {
								return _Utils_update(
									d,
									{
										akl: $elm$core$Maybe$Just(partnerId_)
									});
							},
							$elm$core$Maybe$Nothing,
							$author$project$Shared$GotUserPartners(
								$author$project$Shared$OrgSwitcher$PartnerQueryParam(
									$author$project$Utils$Route$fromUrl(url))));
					} else {
						break _v0$4;
					}
				}
			}
		}
		var _v1 = _v0.b;
		var _v2 = _v0.c;
		return $elm$core$Platform$Cmd$none;
	});
var $author$project$Components$AccountLockedModal$update = function (msg) {
	return $elm$core$Platform$Cmd$none;
};
var $author$project$Components$GlobalSearch$NavMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$GlobalSearch$Open = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$GlobalSearch$SearchInputFocused = {$: 7};
var $author$project$Components$GlobalSearch$DebounceMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$GlobalSearch$debounceConfig = {
	alK: $jinjor$elm_debounce$Debounce$later(300),
	ame: $author$project$Components$GlobalSearch$DebounceMsg
};
var $author$project$Ports$GlobalSearch$openClinicalSearchPort = _Platform_outgoingPort(
	'openClinicalSearchPort',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$GlobalSearch$openClinicalSearch = $author$project$Ports$GlobalSearch$openClinicalSearchPort(0);
var $author$project$Api$Provider$Search$Min$path = function (_v0) {
	var record = _v0;
	return record.YX;
};
var $author$project$Api$Provider$Search$All$path = function (_v0) {
	var min = _v0;
	return $author$project$Api$Provider$Search$Min$path(min);
};
var $author$project$Api$Provider$SearchPermissions$Shared$attributes = function (_v0) {
	var record = _v0;
	return record.xr;
};
var $author$project$Api$Provider$SearchPermissions$All$attributes = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$SearchPermissions$Shared$attributes(shared);
};
var $author$project$Api$Provider$SearchPermissions$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$SearchPermissions$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$SearchPermissions$Shared$id(shared);
};
var $author$project$Api$Provider$SearchPermissions$Shared$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$SearchPermissions$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$SearchPermissions$Shared$name(shared);
};
var $author$project$Api$Provider$SearchPermissions$Shared$searchable = function (_v0) {
	var record = _v0;
	return record.aaB;
};
var $author$project$Api$Provider$SearchPermissions$All$searchable = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$SearchPermissions$Shared$searchable(shared);
};
var $author$project$Components$GlobalSearch$permissionToPermissionType = function (permission) {
	return {
		xr: A2(
			$elm$core$List$map,
			function (attr) {
				return $elm$core$String$toLower(
					$author$project$Formatters$String$humanize(attr));
			},
			$author$project$Api$Provider$SearchPermissions$All$attributes(permission)),
		ahP: $author$project$Api$Provider$SearchPermissions$All$id(permission),
		Bq: $author$project$Formatters$String$pluralOf(
			$author$project$Api$Provider$SearchPermissions$All$name(permission)),
		aaB: $author$project$Api$Provider$SearchPermissions$All$searchable(permission)
	};
};
var $author$project$Components$GlobalSearch$GotSearchResult = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Api$Provider$Search$All$Search = $elm$core$Basics$identity;
var $author$project$Api$Provider$Search$Min$Search = $elm$core$Basics$identity;
var $author$project$Api$Provider$Search$Min$Record = F6(
	function (id, label, secondaryLabel, type_, path, status) {
		return {ahP: id, aih: label, YX: path, aaC: secondaryLabel, alH: status, amg: type_};
	});
var $author$project$Api$Provider$Search$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'status',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'path',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'type',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'secondary_label',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'label',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$Search$Min$Record)))))));
var $author$project$Api$Provider$Search$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Search$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Search$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Search$Min$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Search$listDefaults = {
	ajJ: $elm$core$Maybe$Just($author$project$Api$Pagination$init)
};
var $author$project$Api$Provider$Search$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Search$listDefaults);
	var _v0 = options.ajJ;
	if (!_v0.$) {
		var pagination = _v0.a;
		return $author$project$Api$Pagination$toApiParams(pagination);
	} else {
		return _List_Nil;
	}
};
var $author$project$Api$Provider$Search$search = F5(
	function (apiClient, term, filter, optionals, toMsg) {
		var queryParams = function () {
			if (!filter.$) {
				var string = filter.a;
				return _List_fromArray(
					[
						A2($author$project$Api$Param$string, 'q', term),
						A2($author$project$Api$Param$string, 'type', string)
					]);
			} else {
				return _List_fromArray(
					[
						A2($author$project$Api$Param$string, 'q', term)
					]);
			}
		}();
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Search$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Search$listOptionsToParams(optionals),
				A2(
					$author$project$Api$Data$requestWithQuery,
					queryParams,
					$author$project$Api$Data$requestTo($author$project$Api$Provider$Search$path))));
	});
var $author$project$Components$GlobalSearch$search = F4(
	function (apiClient, model, maybeFilter, term) {
		return A5(
			$author$project$Api$Provider$Search$search,
			apiClient,
			term,
			maybeFilter,
			function (d) {
				return _Utils_update(
					d,
					{
						ajJ: $elm$core$Maybe$Just(model.ajJ)
					});
			},
			$author$project$Components$GlobalSearch$GotSearchResult(term));
	});
var $author$project$Components$GlobalSearch$update = F5(
	function (apiClient, _v0, practice, msg, model) {
		if (model.$ === 1) {
			var openModel = model.a;
			switch (msg.$) {
				case 0:
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				case 1:
					return _Utils_Tuple3(
						$author$project$Components$GlobalSearch$Closed(
							{adY: openModel.adY}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				case 8:
					var navMsg = msg.a;
					var _v3 = openModel.kp;
					if (!_v3.$) {
						var nav = _v3.a;
						var _v4 = A2($author$project$Ui$Nav$update, navMsg, nav);
						var updatedNav = _v4.a;
						var navCmd = _v4.b;
						return _Utils_Tuple3(
							$author$project$Components$GlobalSearch$Open(
								_Utils_update(
									openModel,
									{
										kp: $elm$core$Maybe$Just(updatedNav)
									})),
							A2($elm$core$Platform$Cmd$map, $author$project$Components$GlobalSearch$NavMsg, navCmd),
							_List_Nil);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				case 9:
					var tabId = msg.a;
					var searchInputFocusedCmd = A2(
						$elm$core$Task$attempt,
						function (_v8) {
							return $author$project$Components$GlobalSearch$SearchInputFocused;
						},
						$elm$browser$Browser$Dom$focus('global-search-input'));
					var filter = function () {
						if (tabId === 'all') {
							return $elm$core$Maybe$Nothing;
						} else {
							return $elm$core$Maybe$Just(tabId);
						}
					}();
					var _v5 = openModel.dP;
					if (_v5 === '') {
						return _Utils_Tuple3(
							$author$project$Components$GlobalSearch$Open(
								_Utils_update(
									openModel,
									{HM: filter})),
							searchInputFocusedCmd,
							_List_Nil);
					} else {
						var _v6 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Components$GlobalSearch$debounceConfig, openModel.dP, openModel.d6);
						var debouncer = _v6.a;
						var cmd = _v6.b;
						return _Utils_Tuple3(
							$author$project$Components$GlobalSearch$Open(
								_Utils_update(
									openModel,
									{d6: debouncer, HM: filter, ajJ: $author$project$Api$Pagination$init})),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[searchInputFocusedCmd, cmd])),
							_List_Nil);
					}
				case 2:
					var term = msg.a;
					var _v9 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Components$GlobalSearch$debounceConfig, term, openModel.d6);
					var debouncer = _v9.a;
					var cmd = _v9.b;
					return _Utils_Tuple3(
						$author$project$Components$GlobalSearch$Open(
							_Utils_update(
								openModel,
								{aa: -1, d6: debouncer, ajJ: $author$project$Api$Pagination$init, dP: term})),
						cmd,
						_List_Nil);
				case 3:
					return _Utils_Tuple3(
						$author$project$Components$GlobalSearch$Open(
							_Utils_update(
								openModel,
								{aa: -1, d6: $jinjor$elm_debounce$Debounce$init, ajJ: $author$project$Api$Pagination$init, $X: $author$project$Api$Data$NotAsked, dP: ''})),
						A2(
							$elm$core$Task$attempt,
							function (_v10) {
								return $author$project$Components$GlobalSearch$SearchInputFocused;
							},
							$elm$browser$Browser$Dom$focus('global-search-input')),
						_List_Nil);
				case 4:
					var debounceMsg = msg.a;
					var _v11 = A4(
						$jinjor$elm_debounce$Debounce$update,
						$author$project$Components$GlobalSearch$debounceConfig,
						$jinjor$elm_debounce$Debounce$takeLast(
							A3($author$project$Components$GlobalSearch$search, apiClient, openModel, openModel.HM)),
						debounceMsg,
						openModel.d6);
					var debouncer = _v11.a;
					var cmd = _v11.b;
					return _Utils_Tuple3(
						$author$project$Components$GlobalSearch$Open(
							_Utils_update(
								openModel,
								{d6: debouncer})),
						cmd,
						_List_Nil);
				case 5:
					var responseTerm = msg.a;
					var response = msg.b;
					if (!_Utils_eq(responseTerm, openModel.dP)) {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					} else {
						if (response.$ === 3) {
							var headers = response.b;
							return _Utils_Tuple3(
								$author$project$Components$GlobalSearch$Open(
									_Utils_update(
										openModel,
										{
											aa: 0,
											ajJ: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, openModel.ajJ),
											$X: response,
											Em: openModel.Em + 1
										})),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
						} else {
							return _Utils_Tuple3(
								model,
								$elm$core$Platform$Cmd$none,
								$author$project$OutMsg$handleErrorResponse(response));
						}
					}
				case 14:
					var response = msg.a;
					if (response.$ === 3) {
						var permissions = response.a;
						var searchableTypeList = A2(
							$elm$core$List$filter,
							function ($) {
								return $.aaB;
							},
							A2($elm$core$List$map, $author$project$Components$GlobalSearch$permissionToPermissionType, permissions));
						var _v14 = A2($author$project$Ui$Nav$init, 'search-tabs', $author$project$Components$GlobalSearch$NavMsg);
						var navModel = _v14.a;
						var navCmd = _v14.b;
						var _v15 = function () {
							if ($elm$core$List$length(searchableTypeList) > 1) {
								return _Utils_Tuple2($elm$core$Maybe$Nothing, 'all');
							} else {
								var _default = A2(
									$elm$core$Maybe$withDefault,
									'',
									A2(
										$elm$core$Maybe$map,
										function (elem) {
											return elem.ahP;
										},
										$elm$core$List$head(searchableTypeList)));
								return _Utils_Tuple2(
									$elm$core$Maybe$Just(_default),
									_default);
							}
						}();
						var filter = _v15.a;
						return _Utils_Tuple3(
							$author$project$Components$GlobalSearch$Open(
								_Utils_update(
									openModel,
									{
										HM: filter,
										kp: $elm$core$Maybe$Just(navModel),
										tP: response
									})),
							navCmd,
							_List_Nil);
					} else {
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				case 6:
					var subMsg = msg.a;
					var pagination = A2($author$project$Api$Pagination$update, subMsg, openModel.ajJ);
					var newModel = _Utils_update(
						openModel,
						{ajJ: pagination});
					return _Utils_Tuple3(
						$author$project$Components$GlobalSearch$Open(newModel),
						A4($author$project$Components$GlobalSearch$search, apiClient, newModel, newModel.HM, newModel.dP),
						_List_Nil);
				case 7:
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				case 12:
					var key = msg.a;
					var resultsCount = function () {
						var _v20 = openModel.$X;
						if (_v20.$ === 3) {
							var results = _v20.a;
							return $elm$core$List$length(results);
						} else {
							return 0;
						}
					}();
					switch (key) {
						case 13:
							var _v17 = function () {
								var _v18 = openModel.$X;
								if (_v18.$ === 3) {
									var results = _v18.a;
									return (openModel.aa >= 0) ? _Utils_Tuple2(
										A2($elm_community$list_extra$List$Extra$getAt, openModel.aa, results),
										openModel.aa) : (($elm$core$List$length(results) > 0) ? _Utils_Tuple2(
										A2($elm_community$list_extra$List$Extra$getAt, 0, results),
										0) : _Utils_Tuple2($elm$core$Maybe$Nothing, -1));
								} else {
									return _Utils_Tuple2($elm$core$Maybe$Nothing, -1);
								}
							}();
							var maybeSelectedDoc = _v17.a;
							if (!maybeSelectedDoc.$) {
								var selectedDoc = maybeSelectedDoc.a;
								return (openModel.aa >= 0) ? _Utils_Tuple3(
									$author$project$Components$GlobalSearch$Closed(
										{adY: openModel.adY}),
									A2(
										$elm$core$Maybe$withDefault,
										$elm$core$Platform$Cmd$none,
										A2(
											$elm$core$Maybe$map,
											$author$project$Utils$Route$navigate($elm$core$Dict$empty),
											A2(
												$elm$core$Maybe$map,
												$author$project$Utils$Route$fromUrl,
												$elm$url$Url$fromString(
													A2(
														$elm$core$String$append,
														'https://app.hint.com',
														$author$project$Api$Provider$Search$All$path(selectedDoc)))))),
									_List_Nil) : _Utils_Tuple3(
									$author$project$Components$GlobalSearch$Open(
										_Utils_update(
											openModel,
											{aa: 0})),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							} else {
								return _Utils_Tuple3(
									$author$project$Components$GlobalSearch$Open(openModel),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							}
						case 38:
							var newIndex = (resultsCount > 0) ? (_Utils_eq(openModel.aa, -1) ? (resultsCount - 1) : A2($elm$core$Basics$modBy, resultsCount, openModel.aa - 1)) : (-1);
							return _Utils_Tuple3(
								$author$project$Components$GlobalSearch$Open(
									_Utils_update(
										openModel,
										{aa: newIndex})),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
						case 40:
							var newIndex = (resultsCount > 0) ? A2($elm$core$Basics$modBy, resultsCount, openModel.aa + 1) : (-1);
							return _Utils_Tuple3(
								$author$project$Components$GlobalSearch$Open(
									_Utils_update(
										openModel,
										{aa: newIndex})),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
						default:
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				case 11:
					var index = msg.a;
					return _Utils_Tuple3(
						$author$project$Components$GlobalSearch$Open(
							_Utils_update(
								openModel,
								{aa: index})),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				case 10:
					return _Utils_Tuple3(
						$author$project$Components$GlobalSearch$Closed(
							{adY: openModel.adY}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				default:
					return _Utils_Tuple3(
						$author$project$Components$GlobalSearch$Closed(
							{adY: openModel.adY}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
			}
		} else {
			var url = model.a.adY;
			var _v21 = _Utils_Tuple2(
				msg,
				$author$project$Api$Data$clientHasAuthToken(apiClient));
			_v21$2:
			while (true) {
				switch (_v21.a.$) {
					case 0:
						if (_v21.b) {
							var _v22 = _v21.a;
							var useClinicalSearch = function () {
								if (practice.$ === 3) {
									var practice_ = practice.a;
									return $author$project$Api$Practice$hasClinicalAccount(practice_) && A2($author$project$Api$Practice$featureEnabled, 19, practice_);
								} else {
									return false;
								}
							}();
							var _v23 = function () {
								if (useClinicalSearch) {
									return _Utils_Tuple2(model, $author$project$Ports$GlobalSearch$openClinicalSearch);
								} else {
									var searchPermissionsCmd = A2($author$project$Api$Provider$Search$permissions, apiClient, $author$project$Components$GlobalSearch$GotSearchPermissions);
									var openModalModel = $author$project$Components$GlobalSearch$Open(
										{aa: -1, d6: $jinjor$elm_debounce$Debounce$init, HM: $elm$core$Maybe$Nothing, kp: $elm$core$Maybe$Nothing, ajJ: $author$project$Api$Pagination$init, tP: $author$project$Api$Data$NotAsked, $X: $author$project$Api$Data$NotAsked, Em: 0, dP: '', adY: url});
									var openModalCmds = $elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[
												A2(
												$elm$core$Task$attempt,
												function (_v24) {
													return $author$project$Components$GlobalSearch$SearchInputFocused;
												},
												$elm$browser$Browser$Dom$focus('global-search-input')),
												searchPermissionsCmd
											]));
									return _Utils_Tuple2(openModalModel, openModalCmds);
								}
							}();
							var newModel = _v23.a;
							var newCmds = _v23.b;
							return _Utils_Tuple3(newModel, newCmds, _List_Nil);
						} else {
							break _v21$2;
						}
					case 13:
						var _v26 = _v21.a;
						return _Utils_Tuple3(
							$author$project$Components$GlobalSearch$Closed(
								{adY: url}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					default:
						break _v21$2;
				}
			}
			return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Components$OrganizationSwitcher$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{tu: response}),
					$elm$core$Platform$Cmd$none,
					function () {
						if (((response.$ === 2) && (response.a.$ === 6)) && (response.a.b === 'Too many organizations')) {
							var _v3 = response.a;
							return _List_Nil;
						} else {
							return $author$project$OutMsg$handleErrorResponse(response);
						}
					}());
			case 1:
				var env = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{si: env}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var subMsg = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							nN: A2($author$project$Ui$FlyoutMenu$update, subMsg, model.nN)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var subMsg = msg.a;
				var _v4 = A2($author$project$Ui$Nav$update, subMsg, model.oJ);
				var newNavModel = _v4.a;
				var navCmd = _v4.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oJ: newNavModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$OrganizationSwitcher$NavMsg, navCmd),
					_List_Nil);
			default:
				var organizationId = msg.a;
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					_List_fromArray(
						[
							A3($author$project$OutMsg$SwitchToOrganization, organizationId, $elm$core$Maybe$Nothing, $author$project$OutMsg$GoToDefaultStateAndReloadAction)
						]));
		}
	});
var $author$project$Navbar$SandboxAlertMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Ports$Navbar$topnavHeaderHeightChangedPort = _Platform_outgoingPort('topnavHeaderHeightChangedPort', $elm$json$Json$Encode$float);
var $author$project$Components$SandboxAlert$update = function (msg) {
	if (!msg.$) {
		var organizationType = msg.a;
		var organizationId = msg.b;
		var postOrganizationSwitchedAction = function () {
			if (organizationType === 2) {
				return $author$project$OutMsg$GoToRouteAndReloadAction($author$project$Spa$Generated$Route$Partner__Sandboxes__Top);
			} else {
				return $author$project$OutMsg$GoToDefaultStateAndReloadAction;
			}
		}();
		return _Utils_Tuple2(
			$elm$core$Platform$Cmd$none,
			_List_fromArray(
				[
					A3($author$project$OutMsg$SwitchToOrganization, organizationId, $elm$core$Maybe$Nothing, postOrganizationSwitchedAction)
				]));
	} else {
		var managedPracticeOrganizationId = msg.a;
		return _Utils_Tuple2(
			$elm$core$Platform$Cmd$none,
			_List_fromArray(
				[
					A3($author$project$OutMsg$SwitchToOrganization, managedPracticeOrganizationId, $elm$core$Maybe$Nothing, $author$project$OutMsg$GoToDefaultStateAndReloadAction)
				]));
	}
};
var $author$project$Ports$Navbar$sidenavLinkClickedPort = _Platform_outgoingPort(
	'sidenavLinkClickedPort',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$Navbar$sidenavLinkClicked = $author$project$Ports$Navbar$sidenavLinkClickedPort(0);
var $author$project$Navbars$Company$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dw: 1,
							eZ: A2($author$project$Ui$FlyoutMenu$init, 'profile-menu', $author$project$Navbars$Company$ProfileMenuMsg)
						}),
					$author$project$Ports$Navbar$sidenavLinkClicked);
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dw: 1,
							eZ: A2($author$project$Ui$FlyoutMenu$init, 'profile-menu', $author$project$Navbars$Company$ProfileMenuMsg)
						}),
					$author$project$Ports$Session$logout(
						{aku: true}));
			case 2:
				var checked = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dw: checked ? $author$project$Navbars$Company$openSubNavFromSelectedNav(model.fd) : 1,
							qh: checked
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dw: 1, qh: false}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var subnav = msg.a;
				var newOpenSubNav = _Utils_eq(subnav, model.dw) ? 1 : subnav;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dw: newOpenSubNav}),
					$elm$core$Platform$Cmd$none);
			case 5:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			default:
				var subMsg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eZ: A2($author$project$Ui$FlyoutMenu$update, subMsg, model.eZ)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Navbars$Partner$HinterIdButtonsMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Navbars$HinterIdButtons$organizationButton = function (id) {
	return {mm: 'Copy organization identifier', aih: 'OID', va: 'Copied organization id to clipboard', aee: id};
};
var $author$project$Navbars$HinterIdButtons$resourceButton = function (resource) {
	if (!resource.$) {
		var id = resource.a;
		return {mm: 'Copy practice identifier', aih: 'PID', va: 'Copied practice id to clipboard', aee: id};
	} else {
		var id = resource.a;
		return {mm: 'Copy partner identifier', aih: 'PID', va: 'Copied partner id to clipboard', aee: id};
	}
};
var $author$project$Navbars$HinterIdButtons$update = F2(
	function (msg, model) {
		var resource = model.Jy;
		var organizationId = model.ajD;
		var button = function () {
			if (!msg) {
				return $author$project$Navbars$HinterIdButtons$resourceButton(resource);
			} else {
				return $author$project$Navbars$HinterIdButtons$organizationButton(organizationId);
			}
		}();
		return _Utils_Tuple3(
			model,
			$author$project$Ports$Clipboard$copy(button.aee),
			_List_fromArray(
				[
					A2($author$project$OutMsg$ShowToast, 3, button.va)
				]));
	});
var $author$project$Navbars$Partner$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							dw: 1,
							eZ: A2($author$project$Ui$FlyoutMenu$init, 'profile-menu', $author$project$Navbars$Partner$ProfileMenuMsg)
						}),
					$author$project$Ports$Navbar$sidenavLinkClicked,
					_List_Nil);
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							dw: 1,
							eZ: A2($author$project$Ui$FlyoutMenu$init, 'profile-menu', $author$project$Navbars$Partner$ProfileMenuMsg)
						}),
					$author$project$Ports$Session$logout(
						{aku: true}),
					_List_Nil);
			case 2:
				var checked = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							dw: checked ? $author$project$Navbars$Partner$openSubNavFromSelectedNav(model.fd) : 1,
							qh: checked
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dw: 1, qh: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var subnav = msg.a;
				var newOpenSubNav = _Utils_eq(subnav, model.dw) ? 1 : subnav;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dw: newOpenSubNav}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
			case 6:
				var subMsg = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							eZ: A2($author$project$Ui$FlyoutMenu$update, subMsg, model.eZ)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Navbars$HinterIdButtons$update, subMsg, model.sz);
				var hinterIdButtons = _v2.a;
				var cmd = _v2.b;
				var outMsgs = _v2.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{sz: hinterIdButtons}),
					A2($elm$core$Platform$Cmd$map, $author$project$Navbars$Partner$HinterIdButtonsMsg, cmd),
					outMsgs);
		}
	});
var $author$project$Navbars$Practice$BookmarkNavResult = F2(
	function (a, b) {
		return {$: 24, a: a, b: b};
	});
var $author$project$Navbars$Practice$GotPracticeRefresh = function (a) {
	return {$: 21, a: a};
};
var $author$project$Navbars$Practice$HinterIdButtonsMsg = function (a) {
	return {$: 20, a: a};
};
var $author$project$Navbars$Practice$MobileBookmarkPopoverReady = {$: 33};
var $author$project$Navbars$Practice$MobileLongPressPending = function (a) {
	return {$: 1, a: a};
};
var $author$project$Navbars$Practice$MobileLongPressTimerFired = function (a) {
	return {$: 32, a: a};
};
var $author$project$Navbars$Practice$MobilePopoverOpen = function (a) {
	return {$: 3, a: a};
};
var $author$project$Navbars$Practice$MobilePopoverOpening = function (a) {
	return {$: 2, a: a};
};
var $author$project$Navbars$Practice$UnbookmarkNavResult = F2(
	function (a, b) {
		return {$: 26, a: a, b: b};
	});
var $author$project$Navbars$Practice$closeBookmarkedMenu = function (model) {
	return _Utils_update(
		model,
		{fP: $author$project$Navbars$Practice$closedBookmarkedMenu});
};
var $author$project$Api$Provider$NavBookmark$create = F3(
	function (apiClient, navKey, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'nav_key',
							$elm$json$Json$Encode$string(navKey))
						])),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['nav_bookmarks']),
						$author$project$Api$Data$providerPath))));
	});
var $author$project$Api$Provider$NavBookmark$delete = F3(
	function (apiClient, navKey, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['nav_bookmarks', navKey]),
					$author$project$Api$Data$providerPath)));
	});
var $author$project$Ports$Navbar$globalSearchButtonClickedPort = _Platform_outgoingPort(
	'globalSearchButtonClickedPort',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$Navbar$globalSearchTriggered = $author$project$Ports$Navbar$globalSearchButtonClickedPort(0);
var $author$project$Navbars$Practice$longPressDurationMs = 500;
var $author$project$Navbars$Practice$BookmarkNav = function (a) {
	return {$: 23, a: a};
};
var $author$project$Navbars$Practice$BookmarkSubNav = function (a) {
	return {$: 27, a: a};
};
var $author$project$Navbars$Practice$UnbookmarkNav = function (a) {
	return {$: 25, a: a};
};
var $author$project$Navbars$Practice$UnbookmarkSubNav = function (a) {
	return {$: 28, a: a};
};
var $author$project$Navbars$Practice$isNavSectionHeader = function (nav) {
	switch (nav.$) {
		case 13:
			return true;
		case 15:
			return true;
		default:
			return false;
	}
};
var $author$project$Navbars$Practice$Navigation$MainNavBookmark = $elm$core$Basics$identity;
var $author$project$Navbars$Practice$Navigation$bookmarkableItems = _List_fromArray(
	[
		{Io: $author$project$Navbars$Practice$Navigation$Patients, At: 'patients', aih: 'Patients'},
		{Io: $author$project$Navbars$Practice$Navigation$Calendar, At: 'calendar', aih: 'Calendar'},
		{Io: $author$project$Navbars$Practice$Navigation$Inbox, At: 'inbox', aih: 'Inbox'},
		{Io: $author$project$Navbars$Practice$Navigation$Tasks, At: 'tasks', aih: 'Tasks'},
		{Io: $author$project$Navbars$Practice$Navigation$Forms, At: 'forms', aih: 'Forms'},
		{Io: $author$project$Navbars$Practice$Navigation$ClinicalDashboard, At: 'clinical_dashboard', aih: 'Dashboard'},
		{Io: $author$project$Navbars$Practice$Navigation$Sponsors, At: 'sponsors', aih: 'Sponsors'},
		{Io: $author$project$Navbars$Practice$Navigation$Networks, At: 'networks', aih: 'Networks'},
		{Io: $author$project$Navbars$Practice$Navigation$Commissions, At: 'commissions', aih: 'Commissions'},
		{Io: $author$project$Navbars$Practice$Navigation$Account, At: 'account', aih: 'Account'},
		{Io: $author$project$Navbars$Practice$Navigation$Bookkeeping, At: 'bookkeeping', aih: 'Bookkeeping'},
		{Io: $author$project$Navbars$Practice$Navigation$Contacts, At: 'contacts', aih: 'Contacts'},
		{
		Io: $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$Dashboard),
		At: 'reports',
		aih: 'Reports'
	},
		{
		Io: $author$project$Navbars$Practice$Navigation$Admin(0),
		At: 'admin',
		aih: 'Admin'
	}
	]);
var $author$project$Navbars$Practice$Navigation$entryNav = function (entry) {
	var _v0 = entry.Io;
	var nav = _v0;
	return nav;
};
var $author$project$Navbars$Practice$Navigation$navToString = function (nav) {
	switch (nav.$) {
		case 17:
			var slug = nav.a;
			return $elm$core$Maybe$Just('partner_app:' + slug);
		case 13:
			return $elm$core$Maybe$Just('reports');
		case 15:
			return $elm$core$Maybe$Just('admin');
		default:
			return A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.At;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (entry) {
							return _Utils_eq(
								$author$project$Navbars$Practice$Navigation$entryNav(entry),
								nav);
						},
						$author$project$Navbars$Practice$Navigation$bookmarkableItems)));
	}
};
var $author$project$Navbars$Practice$Navigation$adminSubNavToKey = function (sub) {
	return 'admin:' + function () {
		switch (sub) {
			case 0:
				return 'practice';
			case 1:
				return 'providers';
			case 2:
				return 'membership_options';
			case 3:
				return 'signup';
			case 4:
				return 'credit_categories';
			case 5:
				return 'charge_items';
			case 6:
				return 'commissions_setup';
			case 7:
				return 'notifications_patient';
			case 8:
				return 'hipaa_authorizations';
			case 9:
				return 'integrations';
			case 10:
				return 'invoice_settings';
			case 11:
				return 'documents';
			case 12:
				return 'data_export';
			case 13:
				return 'calendar_locations';
			case 14:
				return 'appointment_types';
			case 15:
				return 'erx';
			case 16:
				return 'medications';
			case 17:
				return 'file_drive';
			case 18:
				return 'templates';
			case 19:
				return 'developers';
			case 20:
				return 'phones';
			default:
				return 'team';
		}
	}();
};
var $author$project$Navbars$Practice$Navigation$reportsSubNavToKey = function (sub) {
	return 'reports:' + function () {
		switch (sub.$) {
			case 0:
				return 'dashboard';
			case 1:
				return 'months';
			case 2:
				return 'signup_attempts';
			case 3:
				return 'memberships';
			case 4:
				return 'invoices';
			case 5:
				return 'company_invoices';
			case 6:
				return 'credit_outstanding';
			case 7:
				return 'revenue';
			case 8:
				return 'deferred_revenue';
			case 9:
				return 'patient_packages';
			case 10:
				return 'payment_applications';
			case 11:
				return 'credit_transactions';
			case 12:
				return 'deposits';
			case 13:
				return 'sales_tax';
			case 14:
				var slug = sub.a;
				return 'custom:' + slug;
			case 15:
				return 'ancillary_charges';
			default:
				return 'disputes';
		}
	}();
};
var $author$project$Navbars$Practice$subNavInfoKey = function (nav) {
	switch (nav.$) {
		case 12:
			var sub = nav.a;
			return $elm$core$Maybe$Just(
				$author$project$Navbars$Practice$Navigation$reportsSubNavToKey(sub));
		case 14:
			var sub = nav.a;
			return $elm$core$Maybe$Just(
				$author$project$Navbars$Practice$Navigation$adminSubNavToKey(sub));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Navbars$Practice$mobileBookmarkInfo = function (nav) {
	var subNavMsgs = function (key) {
		return {
			xE: $author$project$Navbars$Practice$BookmarkSubNav(key),
			At: key,
			FX: $author$project$Navbars$Practice$UnbookmarkSubNav(key)
		};
	};
	var navMsgs = function (key) {
		return {
			xE: $author$project$Navbars$Practice$BookmarkNav(nav),
			At: key,
			FX: $author$project$Navbars$Practice$UnbookmarkNav(nav)
		};
	};
	if ($author$project$Navbars$Practice$isNavSectionHeader(nav)) {
		return A2(
			$elm$core$Maybe$map,
			navMsgs,
			$author$project$Navbars$Practice$Navigation$navToString(nav));
	} else {
		var _v0 = $author$project$Navbars$Practice$subNavInfoKey(nav);
		if (!_v0.$) {
			var key = _v0.a;
			return $elm$core$Maybe$Just(
				subNavMsgs(key));
		} else {
			return A2(
				$elm$core$Maybe$map,
				navMsgs,
				$author$project$Navbars$Practice$Navigation$navToString(nav));
		}
	}
};
var $author$project$Components$HinterPracticeSettingsModal$GotCurrentManagementGroup = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$HinterPracticeSettingsModal$GotFeatures = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$HinterPracticeSettingsModal$GotManagementGroups = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$HinterPracticeSettingsModal$Open = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$HinterPracticeSettingsModal$open = F2(
	function (apiClient, practice) {
		return _Utils_Tuple2(
			$author$project$Components$HinterPracticeSettingsModal$Open(
				{OF: $elm$core$Maybe$Nothing, i1: $elm$core$Maybe$Nothing, Sf: $author$project$Api$Data$Loading, oz: $author$project$Api$Data$Loading, ZV: practice, uq: ''}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Api$Provider$ManagementGroup$getCurrent, apiClient, $author$project$Components$HinterPracticeSettingsModal$GotCurrentManagementGroup),
						A2($author$project$Api$Provider$ManagementGroup$list, apiClient, $author$project$Components$HinterPracticeSettingsModal$GotManagementGroups),
						A3($author$project$Api$Common$Feature$list, $author$project$Api$Data$providerPath, apiClient, $author$project$Components$HinterPracticeSettingsModal$GotFeatures)
					])));
	});
var $author$project$Navbars$Practice$popoverActivationGraceMs = 50;
var $author$project$Ports$Intercom$intercomPortShow = _Platform_outgoingPort(
	'intercomPortShow',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$Intercom$show = function (session) {
	return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : $author$project$Ports$Intercom$intercomPortShow(0);
};
var $author$project$Components$HinterPracticeSettingsModal$FeaturesUpdated = 3;
var $author$project$Components$HinterPracticeSettingsModal$GotFeatureEnableResponse = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$HinterPracticeSettingsModal$ManagementGroupSaved = 2;
var $author$project$Components$HinterPracticeSettingsModal$ManagementGroupUpdated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$HinterPracticeSettingsModal$ModalClosed = 1;
var $author$project$Components$HinterPracticeSettingsModal$None = 0;
var $author$project$Components$HinterPracticeSettingsModal$replaceUpdatedFeature = F2(
	function (newFeature, feature) {
		return _Utils_eq(
			$author$project$Api$Common$Feature$Shared$id(feature),
			$author$project$Api$Common$Feature$Shared$id(newFeature)) ? newFeature : feature;
	});
var $author$project$Components$HinterPracticeSettingsModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				return {GZ: $elm$core$Platform$Cmd$none, agZ: 1, aiO: $author$project$Components$HinterPracticeSettingsModal$Closed, aR: _List_Nil};
			case 1:
				var response = msg.a;
				if (model.$ === 1) {
					var data = model.a;
					switch (response.$) {
						case 3:
							var group = response.a;
							return {
								GZ: $elm$core$Platform$Cmd$none,
								agZ: 0,
								aiO: $author$project$Components$HinterPracticeSettingsModal$Open(
									_Utils_update(
										data,
										{
											i1: $elm$core$Maybe$Just(group)
										})),
								aR: _List_Nil
							};
						case 2:
							var error = response.a;
							if (error.$ === 5) {
								return {
									GZ: $elm$core$Platform$Cmd$none,
									agZ: 0,
									aiO: $author$project$Components$HinterPracticeSettingsModal$Open(
										_Utils_update(
											data,
											{i1: $elm$core$Maybe$Nothing})),
									aR: _List_Nil
								};
							} else {
								return {
									GZ: $elm$core$Platform$Cmd$none,
									agZ: 0,
									aiO: model,
									aR: $author$project$OutMsg$handleErrorResponse(response)
								};
							}
						default:
							return {
								GZ: $elm$core$Platform$Cmd$none,
								agZ: 0,
								aiO: model,
								aR: $author$project$OutMsg$handleErrorResponse(response)
							};
					}
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
			case 2:
				var response = msg.a;
				if (model.$ === 1) {
					var data = model.a;
					switch (response.$) {
						case 3:
							return {
								GZ: $elm$core$Platform$Cmd$none,
								agZ: 0,
								aiO: $author$project$Components$HinterPracticeSettingsModal$Open(
									_Utils_update(
										data,
										{oz: response})),
								aR: _List_Nil
							};
						case 2:
							return {
								GZ: $elm$core$Platform$Cmd$none,
								agZ: 0,
								aiO: $author$project$Components$HinterPracticeSettingsModal$Open(
									_Utils_update(
										data,
										{oz: response})),
								aR: _List_fromArray(
									[
										A2($author$project$OutMsg$ShowToast, 1, 'Failed to load management groups')
									])
							};
						default:
							return {
								GZ: $elm$core$Platform$Cmd$none,
								agZ: 0,
								aiO: model,
								aR: $author$project$OutMsg$handleErrorResponse(response)
							};
					}
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
			case 3:
				var groupId = msg.a;
				if (model.$ === 1) {
					var data = model.a;
					return {
						GZ: A3($author$project$Api$Provider$ManagementGroup$update, apiClient, groupId, $author$project$Components$HinterPracticeSettingsModal$ManagementGroupUpdated),
						agZ: 0,
						aiO: $author$project$Components$HinterPracticeSettingsModal$Open(data),
						aR: _List_Nil
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
			case 4:
				var response = msg.a;
				if (model.$ === 1) {
					var data = model.a;
					if (response.$ === 3) {
						if (!response.a.$) {
							var group = response.a.a;
							return {
								GZ: $elm$core$Platform$Cmd$none,
								agZ: 2,
								aiO: $author$project$Components$HinterPracticeSettingsModal$Open(
									_Utils_update(
										data,
										{
											i1: $elm$core$Maybe$Just(group)
										})),
								aR: _List_fromArray(
									[
										A2($author$project$OutMsg$ShowToast, 3, 'Management group updated successfully')
									])
							};
						} else {
							var _v9 = response.a;
							return {
								GZ: $elm$core$Platform$Cmd$none,
								agZ: 0,
								aiO: $author$project$Components$HinterPracticeSettingsModal$Open(
									_Utils_update(
										data,
										{i1: $elm$core$Maybe$Nothing})),
								aR: _List_fromArray(
									[
										A2($author$project$OutMsg$ShowToast, 3, 'Management group removed successfully')
									])
							};
						}
					} else {
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 0,
							aiO: model,
							aR: A2(
								$elm$core$List$cons,
								A2($author$project$OutMsg$ShowToast, 1, 'Failed to update management group'),
								$author$project$OutMsg$handleErrorResponse(response))
						};
					}
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
			case 5:
				var response = msg.a;
				if (model.$ === 1) {
					var data = model.a;
					switch (response.$) {
						case 3:
							return {
								GZ: $elm$core$Platform$Cmd$none,
								agZ: 0,
								aiO: $author$project$Components$HinterPracticeSettingsModal$Open(
									_Utils_update(
										data,
										{Sf: response})),
								aR: _List_Nil
							};
						case 2:
							return {
								GZ: $elm$core$Platform$Cmd$none,
								agZ: 0,
								aiO: $author$project$Components$HinterPracticeSettingsModal$Open(
									_Utils_update(
										data,
										{Sf: response})),
								aR: _List_fromArray(
									[
										A2($author$project$OutMsg$ShowToast, 1, 'Failed to load features')
									])
							};
						default:
							return {
								GZ: $elm$core$Platform$Cmd$none,
								agZ: 0,
								aiO: model,
								aR: $author$project$OutMsg$handleErrorResponse(response)
							};
					}
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
			case 6:
				var featureId = msg.a;
				var enabled = msg.b;
				if (model.$ === 1) {
					return {
						GZ: A5($author$project$Api$Common$Feature$enable, $author$project$Api$Data$providerPath, apiClient, featureId, enabled, $author$project$Components$HinterPracticeSettingsModal$GotFeatureEnableResponse),
						agZ: 0,
						aiO: model,
						aR: _List_Nil
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
			case 7:
				var response = msg.a;
				if (model.$ === 1) {
					var data = model.a;
					if (response.$ === 3) {
						var feature = response.a;
						var toastMessage = $author$project$Api$Common$Feature$Shared$enabled(feature) ? A2(
							$author$project$OutMsg$ShowToast,
							3,
							'Feature \"' + ($author$project$Api$Common$Feature$Shared$name(feature) + '\" turned on')) : A2(
							$author$project$OutMsg$ShowToast,
							3,
							'Feature \"' + ($author$project$Api$Common$Feature$Shared$name(feature) + '\" turned off'));
						var newFeatures = A2(
							$author$project$Api$Data$map,
							$elm$core$List$map(
								$author$project$Components$HinterPracticeSettingsModal$replaceUpdatedFeature(feature)),
							data.Sf);
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 3,
							aiO: $author$project$Components$HinterPracticeSettingsModal$Open(
								_Utils_update(
									data,
									{Sf: newFeatures})),
							aR: _List_fromArray(
								[toastMessage, $author$project$OutMsg$RefreshPractice, $author$project$OutMsg$RefreshLayout])
						};
					} else {
						return {
							GZ: $elm$core$Platform$Cmd$none,
							agZ: 0,
							aiO: model,
							aR: A2(
								$elm$core$List$cons,
								A2($author$project$OutMsg$ShowToast, 1, 'Failed to update feature'),
								$author$project$OutMsg$handleErrorResponse(response))
						};
					}
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
			case 8:
				var query = msg.a;
				if (model.$ === 1) {
					var data = model.a;
					return {
						GZ: $elm$core$Platform$Cmd$none,
						agZ: 0,
						aiO: $author$project$Components$HinterPracticeSettingsModal$Open(
							_Utils_update(
								data,
								{uq: query})),
						aR: _List_Nil
					};
				} else {
					return {GZ: $elm$core$Platform$Cmd$none, agZ: 0, aiO: model, aR: _List_Nil};
				}
			case 9:
				var text = msg.a;
				return {
					GZ: $author$project$Ports$Clipboard$copy(text),
					agZ: 0,
					aiO: model,
					aR: _List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 3, 'Copied to clipboard')
						])
				};
			default:
				return {
					GZ: $author$project$Ports$Navigation$pushUrl(
						$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$NewSettings__HinterSettings)),
					agZ: 1,
					aiO: $author$project$Components$HinterPracticeSettingsModal$Closed,
					aR: _List_Nil
				};
		}
	});
var $author$project$Navbars$Practice$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 1:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{r9: response}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 14:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ue: response}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 0:
				var currentDate = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							dd: $elm$core$Maybe$Just(currentDate)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var subnav = msg.a;
				var newOpenSubNav = _Utils_eq(subnav, model.dw) ? 4 : subnav;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dw: newOpenSubNav}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var reportMenu = A2($author$project$Ui$FlyoutMenu$init, 'reporting-menu', $author$project$Navbars$Practice$ReportMenuMsg);
				var profileMenu = A2($author$project$Ui$FlyoutMenu$init, 'profile-menu', $author$project$Navbars$Practice$ProfileMenuMsg);
				var adminMenu = A2($author$project$Ui$FlyoutMenu$init, 'admin-menu', $author$project$Navbars$Practice$AdminMenuMsg);
				return _Utils_Tuple3(
					$author$project$Navbars$Practice$closeBookmarkedMenu(
						_Utils_update(
							model,
							{im: adminMenu, eZ: profileMenu, kW: reportMenu})),
					$author$project$Ports$Navbar$sidenavLinkClicked,
					_List_Nil);
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dw: 4, qh: false}),
					$author$project$Ports$Navbar$globalSearchTriggered,
					_List_Nil);
			case 5:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{An: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 6:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							eZ: A2($author$project$Ui$FlyoutMenu$init, 'profile-menu', $author$project$Navbars$Practice$ProfileMenuMsg)
						}),
					$author$project$Ports$Session$logout(
						{aku: true}),
					_List_Nil);
			case 7:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Ui$Dropdown$update, subMsg, model.qq);
				var dropdownMenu = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qq: dropdownMenu}),
					cmd,
					_List_Nil);
			case 8:
				var subMsg = msg.a;
				var reportMenu = A2($author$project$Ui$FlyoutMenu$update, subMsg, model.kW);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{kW: reportMenu}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 9:
				var subMsg = msg.a;
				var adminMenu = A2($author$project$Ui$FlyoutMenu$update, subMsg, model.im);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{im: adminMenu}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 10:
				var subMsg = msg.a;
				var profileMenu = A2($author$project$Ui$FlyoutMenu$update, subMsg, model.eZ);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{eZ: profileMenu}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 11:
				var checked = msg.a;
				var newOpenSubNav = checked ? $author$project$Navbars$Practice$openSubNavFromSelectedNav(model.fd) : 4;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dw: newOpenSubNav, qh: checked}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 12:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dw: 4, qc: false, qh: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 13:
				return _Utils_Tuple3(
					$author$project$Navbars$Practice$closeBookmarkedMenu(
						_Utils_update(
							model,
							{qc: !model.qc})),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 15:
				return _Utils_Tuple3(
					model,
					$author$project$Ports$Intercom$show(model.aa4),
					_List_Nil);
			case 16:
				var _v3 = A2($author$project$Components$HinterPracticeSettingsModal$open, apiClient, model.ZV);
				var modalModel = _v3.a;
				var modalCmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{jT: modalModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Navbars$Practice$HinterPracticeSettingsModalMsg, modalCmd),
					_List_Nil);
			case 17:
				var modalMsg = msg.a;
				var result = A3($author$project$Components$HinterPracticeSettingsModal$update, apiClient, modalMsg, model.jT);
				var practiceRefreshCmd = function () {
					var _v4 = result.agZ;
					switch (_v4) {
						case 0:
							return $elm$core$Platform$Cmd$none;
						case 1:
							return $elm$core$Platform$Cmd$none;
						case 2:
							return $elm$core$Platform$Cmd$none;
						default:
							return A3($author$project$Api$Provider$Practice$retrieve, apiClient, $elm$core$Basics$identity, $author$project$Navbars$Practice$GotPracticeRefresh);
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{jT: result.aiO}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Navbars$Practice$HinterPracticeSettingsModalMsg, result.GZ),
								practiceRefreshCmd
							])),
					result.aR);
			case 21:
				var practice = msg.a;
				if (practice.$ === 3) {
					var practice_ = practice.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ZV: practice_,
								kI: $author$project$Navbars$Practice$buildPracticeConfig(practice_)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 18:
				var partnerApps = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{tC: partnerApps}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(partnerApps));
			case 20:
				var subMsg = msg.a;
				var _v6 = A2($author$project$Navbars$HinterIdButtons$update, subMsg, model.sz);
				var hinterIdButtons = _v6.a;
				var cmd = _v6.b;
				var outMsgs = _v6.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{sz: hinterIdButtons}),
					A2($elm$core$Platform$Cmd$map, $author$project$Navbars$Practice$HinterIdButtonsMsg, cmd),
					outMsgs);
			case 22:
				var result = msg.a;
				if (result.$ === 3) {
					var keys = result.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ac: $elm$core$Set$fromList(keys)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 23:
				var nav = msg.a;
				var _v8 = $author$project$Navbars$Practice$Navigation$navToString(nav);
				if (_v8.$ === 1) {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				} else {
					var key = _v8.a;
					var newBookmarks = A2($elm$core$Set$insert, key, model.ac);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ac: newBookmarks, O: $author$project$Navbars$Practice$MobileBookmarkIdle}),
						A3(
							$author$project$Api$Provider$NavBookmark$create,
							apiClient,
							key,
							$author$project$Navbars$Practice$BookmarkNavResult(key)),
						_List_Nil);
				}
			case 24:
				var key = msg.a;
				var result = msg.b;
				switch (result.$) {
					case 3:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ac: A2($elm$core$Set$remove, key, model.ac)
								}),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 1, 'Failed to save bookmark. Please try again.')
								]));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 25:
				var nav = msg.a;
				var _v10 = $author$project$Navbars$Practice$Navigation$navToString(nav);
				if (_v10.$ === 1) {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				} else {
					var key = _v10.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ac: A2($elm$core$Set$remove, key, model.ac),
								O: $author$project$Navbars$Practice$MobileBookmarkIdle
							}),
						A3(
							$author$project$Api$Provider$NavBookmark$delete,
							apiClient,
							key,
							$author$project$Navbars$Practice$UnbookmarkNavResult(key)),
						_List_Nil);
				}
			case 27:
				var key = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ac: A2($elm$core$Set$insert, key, model.ac),
							O: $author$project$Navbars$Practice$MobileBookmarkIdle
						}),
					A3(
						$author$project$Api$Provider$NavBookmark$create,
						apiClient,
						key,
						$author$project$Navbars$Practice$BookmarkNavResult(key)),
					_List_Nil);
			case 28:
				var key = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ac: A2($elm$core$Set$remove, key, model.ac),
							O: $author$project$Navbars$Practice$MobileBookmarkIdle
						}),
					A3(
						$author$project$Api$Provider$NavBookmark$delete,
						apiClient,
						key,
						$author$project$Navbars$Practice$UnbookmarkNavResult(key)),
					_List_Nil);
			case 29:
				var subMsg = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							fP: A2($author$project$Ui$FlyoutMenu$update, subMsg, model.fP)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 26:
				var key = msg.a;
				var result = msg.b;
				switch (result.$) {
					case 3:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ac: A2($elm$core$Set$insert, key, model.ac)
								}),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 1, 'Failed to remove bookmark. Please try again.')
								]));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 30:
				var nav = msg.a;
				var _v12 = model.O;
				switch (_v12.$) {
					case 2:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					case 3:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					default:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									O: $author$project$Navbars$Practice$MobileLongPressPending(nav)
								}),
							A2(
								$elm$core$Task$perform,
								$elm$core$Basics$always(
									$author$project$Navbars$Practice$MobileLongPressTimerFired(nav)),
								$elm$core$Process$sleep($author$project$Navbars$Practice$longPressDurationMs)),
							_List_Nil);
				}
			case 31:
				var _v13 = model.O;
				if (_v13.$ === 1) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{O: $author$project$Navbars$Practice$MobileBookmarkIdle}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 32:
				var nav = msg.a;
				var _v14 = model.O;
				if (_v14.$ === 1) {
					var pendingNav = _v14.a;
					return ((!_Utils_eq(pendingNav, nav)) || _Utils_eq(
						$author$project$Navbars$Practice$mobileBookmarkInfo(nav),
						$elm$core$Maybe$Nothing)) ? _Utils_Tuple3(
						_Utils_update(
							model,
							{O: $author$project$Navbars$Practice$MobileBookmarkIdle}),
						$elm$core$Platform$Cmd$none,
						_List_Nil) : _Utils_Tuple3(
						_Utils_update(
							model,
							{
								O: $author$project$Navbars$Practice$MobilePopoverOpening(nav)
							}),
						A2(
							$elm$core$Task$perform,
							$elm$core$Basics$always($author$project$Navbars$Practice$MobileBookmarkPopoverReady),
							$elm$core$Process$sleep($author$project$Navbars$Practice$popoverActivationGraceMs)),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 33:
				var _v15 = model.O;
				if (_v15.$ === 2) {
					var nav = _v15.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								O: $author$project$Navbars$Practice$MobilePopoverOpen(nav)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 34:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{O: $author$project$Navbars$Practice$MobileBookmarkIdle}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 19:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
			default:
				if (!msg.a.$) {
					var counts = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								x4: $elm$core$Maybe$Just(counts)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Navbar$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v2 = model.ai;
				if (_v2.$ === 1) {
					var subModel = _v2.a;
					var _v3 = A3($author$project$Navbars$Practice$update, apiClient, subMsg, subModel);
					var subModel_ = _v3.a;
					var subCmd = _v3.b;
					var subOutMsgs = _v3.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ai: $author$project$Navbar$PracticeNav(subModel_)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Navbar$PracticeNavbarMsg, subCmd),
									$author$project$Navbar$getHeaderEnd
								])),
						subOutMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 1:
				var subMsg = msg.a;
				var _v4 = model.ai;
				if (_v4.$ === 2) {
					var subModel = _v4.a;
					var _v5 = A2($author$project$Navbars$Company$update, subMsg, subModel);
					var subModel_ = _v5.a;
					var subCmd = _v5.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ai: $author$project$Navbar$CompanyNav(subModel_)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Navbar$CompanyNavbarMsg, subCmd),
									$author$project$Navbar$getHeaderEnd
								])),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				var subMsg = msg.a;
				var _v6 = model.ai;
				if (_v6.$ === 3) {
					var subModel = _v6.a;
					var _v7 = A2($author$project$Navbars$Partner$update, subMsg, subModel);
					var subModel_ = _v7.a;
					var subCmd = _v7.b;
					var subOutMsgs = _v7.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ai: $author$project$Navbar$PartnerNav(subModel_)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Navbar$PartnerNavbarMsg, subCmd),
									$author$project$Navbar$getHeaderEnd
								])),
						subOutMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var bool = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ahK: bool}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var result = msg.a;
				if (!result.$) {
					var element = result.a.agJ;
					var viewport = result.a.amp;
					return _Utils_Tuple3(
						model,
						$author$project$Ports$Navbar$topnavHeaderHeightChangedPort(element.aeD - viewport.aeD),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				return _Utils_Tuple3(model, $author$project$Navbar$getHeaderEnd, _List_Nil);
			default:
				var subMsg = msg.a;
				var _v9 = $author$project$Components$SandboxAlert$update(subMsg);
				var sandboxAlertCmd = _v9.a;
				var sandboxAlertOutMsgs = _v9.b;
				return _Utils_Tuple3(
					model,
					A2($elm$core$Platform$Cmd$map, $author$project$Navbar$SandboxAlertMsg, sandboxAlertCmd),
					sandboxAlertOutMsgs);
		}
	});
var $author$project$Ui$Toast$removeToast = F2(
	function (filterFunc, _v0) {
		var count = _v0.a;
		var toasts = _v0.b;
		return A2(
			$author$project$Ui$Toast$Toastr,
			count,
			A2($elm$core$List$filter, filterFunc, toasts));
	});
var $author$project$Ui$Toast$updateToast = F3(
	function (func, id, _v0) {
		var count = _v0.a;
		var toasts = _v0.b;
		return A2(
			$author$project$Ui$Toast$Toastr,
			count,
			A2(
				$elm$core$List$map,
				function (_v1) {
					var toast_ = _v1;
					return _Utils_eq(toast_.ahP, id) ? func(toast_) : toast_;
				},
				toasts));
	});
var $author$project$Ui$Toast$update = F2(
	function (msg, toastr) {
		switch (msg.$) {
			case 1:
				var toRemoveId = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Ui$Toast$removeToast,
						function (_v1) {
							var id = _v1.ahP;
							var dismissible = _v1.r1;
							return !(_Utils_eq(id, toRemoveId) && dismissible);
						},
						toastr),
					$elm$core$Platform$Cmd$none);
			case 0:
				var toRemoveId = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Ui$Toast$removeToast,
						function (_v2) {
							var id = _v2.ahP;
							return !_Utils_eq(id, toRemoveId);
						},
						toastr),
					$elm$core$Platform$Cmd$none);
			case 2:
				var id = msg.a;
				return _Utils_Tuple2(
					A3(
						$author$project$Ui$Toast$updateToast,
						function (toast_) {
							return _Utils_update(
								toast_,
								{r1: false});
						},
						id,
						toastr),
					$elm$core$Platform$Cmd$none);
			default:
				var id = msg.a;
				return _Utils_Tuple2(
					A3(
						$author$project$Ui$Toast$updateToast,
						function (toast_) {
							return _Utils_update(
								toast_,
								{r1: true});
						},
						id,
						toastr),
					A2($author$project$Ui$Toast$dismissInSeconds, 2, id));
		}
	});
var $author$project$Utils$Release$GotLiveRelease = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 2:
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 3:
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.ace));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $elm$http$Http$expectString = function (toMsg) {
	return A2(
		$elm$http$Http$expectStringResponse,
		toMsg,
		$elm$http$Http$resolve($elm$core$Result$Ok));
};
var $elm$http$Http$get = function (r) {
	return $elm$http$Http$request(
		{fO: $elm$http$Http$emptyBody, RT: r.RT, jP: _List_Nil, IA: 'GET', J9: $elm$core$Maybe$Nothing, vd: $elm$core$Maybe$Nothing, adY: r.adY});
};
var $author$project$Utils$Release$fetchLiveRelease = $elm$http$Http$get(
	{
		RT: $elm$http$Http$expectString($author$project$Utils$Release$GotLiveRelease),
		adY: '/RELEASE'
	});
var $author$project$Utils$Release$sha1Regex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('[a-f0-9]{40}'));
var $author$project$Utils$Release$update = F2(
	function (msg, _v0) {
		var model = _v0;
		return A2(
			$elm$core$Tuple$mapFirst,
			$elm$core$Basics$identity,
			function () {
				if (!msg.$) {
					if (!msg.a.$) {
						var liveRelease = msg.a.a;
						return A2($elm$regex$Regex$contains, $author$project$Utils$Release$sha1Regex, liveRelease) ? _Utils_Tuple2(
							_Utils_update(
								model,
								{
									Br: !_Utils_eq(
										$elm$core$String$trim(liveRelease),
										model.Hb)
								}),
							$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
							model,
							$author$project$Ports$Sentry$captureErrorMessage('Fetching RELEASE Failed: Not Found'));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				} else {
					return _Utils_Tuple2(
						model,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Utils$Release$fetchLiveRelease,
									model.Br ? $elm$core$Platform$Cmd$none : $author$project$Utils$Release$scheduleNextReleaseCheck
								])));
				}
			}());
	});
var $author$project$Shared$validateRedirectUrl = F2(
	function (currentPath, redirectToURI) {
		var isErrorPage = function (url) {
			return A2($elm$core$String$contains, '/error/', url);
		};
		var onErrorPage = isErrorPage(currentPath);
		var redirectGoesToErrorPage = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, isErrorPage, redirectToURI));
		return (onErrorPage || (!redirectGoesToErrorPage)) ? redirectToURI : $elm$core$Maybe$Nothing;
	});
var $author$project$Shared$update = F2(
	function (msg, model) {
		update:
		while (true) {
			switch (msg.$) {
				case 0:
					var response = msg.a;
					switch (response.$) {
						case 2:
							var error = response.a;
							if (error.$ === 7) {
								var decodeError = error.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{aa4: response}),
									$elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[
												$author$project$Shared$decodeErrorToMsg(decodeError),
												$author$project$Shared$navigateToErrorPage(error)
											])));
							} else {
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{aa4: response}),
									$author$project$Shared$navigateToErrorPage(error));
							}
						case 3:
							var session = response.a;
							var rainforestEnv = (_Utils_eq(
								model.ahq.ahJ,
								$elm$core$Maybe$Just('production')) && (!$author$project$Api$Platform$Session$One$sandbox(session))) ? 0 : 1;
							var _v3 = function () {
								var _v4 = model.g1;
								if (_v4.$ === 1) {
									return A2(
										$elm$core$Tuple$mapSecond,
										$elm$core$Platform$Cmd$map($author$project$Shared$OrganizationSwitcherMsg),
										A2(
											$elm$core$Tuple$mapFirst,
											$elm$core$Maybe$Just,
											A2(
												$author$project$Components$OrganizationSwitcher$init,
												model.Gv,
												{
													aan: $author$project$Api$Platform$Session$One$sandbox(session)
												})));
								} else {
									var existing = _v4.a;
									return _Utils_Tuple2(
										$elm$core$Maybe$Just(existing),
										$elm$core$Platform$Cmd$none);
								}
							}();
							var orgSwitcher = _v3.a;
							var orgSwitcherCmd = _v3.b;
							return A4(
								$author$project$Shared$applySession,
								response,
								session,
								_Utils_update(
									model,
									{
										g1: orgSwitcher,
										t9: $elm$core$Maybe$Just(rainforestEnv)
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											$author$project$Ports$Rainforest$load(rainforestEnv),
											orgSwitcherCmd
										])));
						default:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{aa4: response}),
								$elm$core$Platform$Cmd$none);
					}
				case 1:
					var response = msg.a;
					_v5$2:
					while (true) {
						if (response.$ === 2) {
							switch (response.a.$) {
								case 7:
									var error = response.a.a;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{ZV: response}),
										$author$project$Shared$decodeErrorToMsg(error));
								case 6:
									if ((response.a.a === 428) && (response.a.b === 'This action requires a Practice')) {
										var _v6 = response.a;
										return _Utils_Tuple2(
											_Utils_update(
												model,
												{ZV: $author$project$Api$Data$NotAsked}),
											$elm$core$Platform$Cmd$none);
									} else {
										break _v5$2;
									}
								default:
									break _v5$2;
							}
						} else {
							break _v5$2;
						}
					}
					var invokeIfNewPractice = F3(
						function (fn, onFirstLoad, newModelAndCmd) {
							var _v7 = _Utils_Tuple2(model.ZV, response);
							if (_v7.b.$ === 3) {
								if (_v7.a.$ === 3) {
									var _v8 = _v7.a;
									var oldPractice = _v8.a;
									var _v9 = _v7.b;
									var newPractice = _v9.a;
									return A2($author$project$Shared$practiceChanged, oldPractice, newPractice) ? fn(newModelAndCmd) : newModelAndCmd;
								} else {
									var _v10 = _v7.b;
									return onFirstLoad ? fn(newModelAndCmd) : newModelAndCmd;
								}
							} else {
								return newModelAndCmd;
							}
						});
					return A2(
						$author$project$Shared$handlePendingClinicalRedirect,
						response,
						$author$project$Shared$initNavbar(
							$author$project$Shared$initializePatientsList(
								$author$project$Shared$enableCoreGlobalSearchShortcutFn(
									$author$project$Shared$redirectToClinicalAppIfNeeded(
										$author$project$Shared$requestLoadEmbeddedClinical(
											A3(
												invokeIfNewPractice,
												$author$project$Shared$identifyOnExternalServices,
												true,
												A3(
													invokeIfNewPractice,
													$author$project$Shared$resetTenancyProperties,
													false,
													_Utils_Tuple2(
														_Utils_update(
															model,
															{ZV: response}),
														$elm$core$Platform$Cmd$none)))))))));
				case 3:
					var companyId = msg.a;
					var response = msg.b;
					_v11$2:
					while (true) {
						if (response.$ === 2) {
							switch (response.a.$) {
								case 5:
									var _v12 = response.a;
									return $author$project$Shared$isHintAdmin(model) ? _Utils_Tuple2(
										_Utils_update(
											model,
											{afQ: response}),
										A4(
											$author$project$Api$Platform$User$Practice$list,
											model.Gv,
											function (d) {
												return _Utils_update(
													d,
													{
														akl: $elm$core$Maybe$Just(companyId)
													});
											},
											$elm$core$Maybe$Nothing,
											$author$project$Shared$GotUserPractices(
												$author$project$Shared$OrgSwitcher$Company(companyId)))) : $author$project$Shared$initNavbar(
										_Utils_Tuple2(
											_Utils_update(
												model,
												{afQ: response}),
											$elm$core$Platform$Cmd$none));
								case 7:
									var error = response.a.a;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{afQ: response}),
										$author$project$Shared$decodeErrorToMsg(error));
								default:
									break _v11$2;
							}
						} else {
							break _v11$2;
						}
					}
					return $author$project$Shared$initNavbar(
						_Utils_Tuple2(
							_Utils_update(
								model,
								{afQ: response}),
							$elm$core$Platform$Cmd$none));
				case 2:
					var response = msg.a;
					if ((response.$ === 2) && (response.a.$ === 7)) {
						var error = response.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{YN: response}),
							$author$project$Shared$decodeErrorToMsg(error));
					} else {
						return $author$project$Shared$initNavbar(
							$author$project$Shared$resetTenancyProperties(
								_Utils_Tuple2(
									_Utils_update(
										model,
										{YN: response}),
									$elm$core$Platform$Cmd$none)));
					}
				case 4:
					var userData = msg.a;
					if ((userData.$ === 2) && (userData.a.$ === 7)) {
						var error = userData.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{ad0: userData}),
							$author$project$Shared$decodeErrorToMsg(error));
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{ad0: userData}),
							$elm$core$Platform$Cmd$none);
					}
				case 5:
					var result = msg.a;
					if (!result.$) {
						var maybeSessionToken = result.a;
						var maybeAuthToken = A2($elm$core$Maybe$map, $author$project$Api$AuthToken$fromString, maybeSessionToken);
						var apiClient = A2($author$project$Api$Data$clientWithAuthToken, maybeAuthToken, model.Gv);
						if ($author$project$Api$Data$clientHasAuthToken(apiClient)) {
							var refreshTimeoutCmd = (!A2($author$project$Api$Data$usingDefaultAuth, model.Gv, model.ahq.ae6)) ? $author$project$Shared$backupJwtRefreshTimeout(apiClient) : $elm$core$Platform$Cmd$none;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{q7: maybeAuthToken, Gv: apiClient}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2($author$project$Api$Platform$Session$retrieve, apiClient, $author$project$Shared$GotSession),
											A2($author$project$Api$Platform$User$retrieve, apiClient, $author$project$Shared$GotUser),
											refreshTimeoutCmd
										])));
						} else {
							return $author$project$Shared$resetTenancyProperties(
								_Utils_Tuple2(
									_Utils_update(
										model,
										{q7: maybeAuthToken, Gv: apiClient, ZV: $author$project$Api$Data$NotAsked, aa4: $author$project$Api$Data$NotAsked, ad0: $author$project$Api$Data$NotAsked}),
									$elm$core$Platform$Cmd$none));
						}
					} else {
						var error = result.a;
						return _Utils_Tuple2(
							model,
							$author$project$Ports$Sentry$captureErrorMessage('Session update failed: ' + error));
					}
				case 6:
					var result = msg.a;
					if (!result.$) {
						var _v17 = result.a;
						var zone = _v17.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									J7: A2($author$project$Formatters$Time$init, zone, model.af3),
									J8: zone
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 7:
					var currentTime = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								dd: A2($justinmimbs$date$Date$fromPosix, model.J8, currentTime),
								af3: currentTime
							}),
						$elm$core$Platform$Cmd$none);
				case 8:
					var patientsListMsg_ = msg.a;
					var _v18 = model.ajU;
					if (!_v18.$) {
						var patientsList = _v18.a;
						var _v19 = A3($author$project$Components$PatientsList$update, model.Gv, patientsListMsg_, patientsList);
						var newList = _v19.a;
						var listCmd = _v19.b;
						var outMsgs = _v19.c;
						var _v20 = A2(
							$author$project$Shared$updateFromOutMsgs,
							outMsgs,
							_Utils_update(
								model,
								{
									ajU: $elm$core$Maybe$Just(newList)
								}));
						var newModel = _v20.a;
						var outCmd = _v20.b;
						return _Utils_Tuple2(
							newModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($elm$core$Platform$Cmd$map, $author$project$Shared$PatientsListMsg, listCmd),
										outCmd
									])));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 9:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{uF: true}),
						$elm$core$Platform$Cmd$none);
				case 10:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{uF: false}),
						$elm$core$Platform$Cmd$none);
				case 11:
					var subMsg = msg.a;
					var _v21 = A5($author$project$Components$GlobalSearch$update, model.Gv, model.aa4, model.ZV, subMsg, model.gw);
					var globalSearch = _v21.a;
					var globalSearchCmd = _v21.b;
					var globalSearchOutMsgs = _v21.c;
					var _v22 = A2(
						$author$project$Shared$updateFromOutMsgs,
						globalSearchOutMsgs,
						_Utils_update(
							model,
							{gw: globalSearch}));
					var newModel = _v22.a;
					var outCmd = _v22.b;
					return _Utils_Tuple2(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Shared$GlobalSearchMsg, globalSearchCmd),
									outCmd
								])));
				case 12:
					var result = msg.a;
					if (!result.$) {
						var result_ = result.a;
						var maybeAuthToken = A2($elm$core$Maybe$map, $author$project$Api$AuthToken$fromString, result_.q7);
						var apiClient = A2($author$project$Api$Data$clientWithAuthToken, maybeAuthToken, model.Gv);
						return $author$project$Api$Data$clientHasAuthToken(apiClient) ? _Utils_Tuple2(
							_Utils_update(
								model,
								{q7: maybeAuthToken, Gv: apiClient, aa4: $author$project$Api$Data$Loading}),
							A2(
								$author$project$Api$Platform$Session$retrieve,
								apiClient,
								$author$project$Shared$GotSessionCreated(result_.akv))) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var error = result.a;
						return _Utils_Tuple2(
							model,
							$author$project$Ports$Sentry$captureErrorMessage('Session create failed: ' + error));
					}
				case 13:
					var redirectToURI = msg.a;
					var response = msg.b;
					_v24$2:
					while (true) {
						switch (response.$) {
							case 2:
								if (response.a.$ === 7) {
									var error = response.a.a;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{aa4: response}),
										$author$project$Shared$decodeErrorToMsg(error));
								} else {
									break _v24$2;
								}
							case 3:
								var session = response.a;
								var validatedRedirectToURI = A2($author$project$Shared$validateRedirectUrl, model.adY.YX, redirectToURI);
								var finalRedirectToURI = function () {
									var _v26 = $author$project$Api$Platform$Session$One$organization(session);
									if (!_v26.$) {
										var session_ = _v26.a;
										return $author$project$Api$Platform$Organization$Shared$practiceIsOnboarding(session_) ? $elm$core$Maybe$Nothing : validatedRedirectToURI;
									} else {
										return validatedRedirectToURI;
									}
								}();
								var navigateTo = A2(
									$elm$core$Maybe$withDefault,
									A2(
										$author$project$Utils$Route$navigate,
										$elm$core$Dict$empty,
										A2($author$project$Permission$homeStateFor, session, model.ahK)),
									A2(
										$elm$core$Maybe$map,
										function (uri) {
											var query = A2(
												$elm$core$Maybe$withDefault,
												$elm$core$Dict$empty,
												A2($elm$core$Maybe$map, $author$project$Spa$Url$toQueryDict, uri.DE));
											return A3(
												$author$project$Utils$Route$navigateWithFragment,
												query,
												uri.ahu,
												$author$project$Utils$Route$fromUrl(uri));
										},
										A2($elm$core$Maybe$andThen, $elm$url$Url$fromString, finalRedirectToURI)));
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{aa4: response}),
									$elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[
												A2($author$project$Api$Platform$User$retrieve, model.Gv, $author$project$Shared$GotUser),
												navigateTo,
												A2(
												$elm$core$Task$perform,
												function (_v25) {
													return $author$project$Shared$GotSession(response);
												},
												$elm$core$Process$sleep(0)),
												A3($author$project$Shared$switchToPracticeWithQueryParam, model.Gv, model.ahq.ae6, model.adY)
											])));
							default:
								break _v24$2;
						}
					}
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{aa4: response}),
						$elm$core$Platform$Cmd$none);
				case 14:
					var releaseMsg = msg.a;
					var _v27 = A2($author$project$Utils$Release$update, releaseMsg, model.akL);
					var release = _v27.a;
					var releaseCmd = _v27.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{akL: release}),
						A2($elm$core$Platform$Cmd$map, $author$project$Shared$ReleaseMsg, releaseCmd));
				case 15:
					var subMsg = msg.a;
					var accountLockedModalCmd = $author$project$Components$AccountLockedModal$update(subMsg);
					return _Utils_Tuple2(
						model,
						A2($elm$core$Platform$Cmd$map, $author$project$Shared$AccountLockedModalMsg, accountLockedModalCmd));
				case 16:
					var toastMsg = msg.a;
					return A2(
						$elm$core$Tuple$mapFirst,
						function (toastr) {
							return _Utils_update(
								model,
								{lO: toastr});
						},
						A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Platform$Cmd$map($author$project$Shared$ToastMsg),
							A2($author$project$Ui$Toast$update, toastMsg, model.lO)));
				case 17:
					var navbarMsg = msg.a;
					var _v28 = $author$project$Navbar$extractOrgSwitcherMsg(navbarMsg);
					if (!_v28.$) {
						var orgSwitcherMsg = _v28.a;
						var $temp$msg = $author$project$Shared$OrganizationSwitcherMsg(orgSwitcherMsg),
							$temp$model = model;
						msg = $temp$msg;
						model = $temp$model;
						continue update;
					} else {
						var _v29 = model.aj;
						if (!_v29.$) {
							var navbar = _v29.a;
							var _v30 = A3($author$project$Navbar$update, model.Gv, navbarMsg, navbar);
							var navbar_ = _v30.a;
							var navbarCmd = _v30.b;
							var navbarOutMsgs = _v30.c;
							var _v31 = A3(
								$elm$core$List$foldl,
								$author$project$Shared$updateFromOutMsg,
								_Utils_Tuple2(
									_Utils_update(
										model,
										{
											aj: $elm$core$Maybe$Just(navbar_)
										}),
									$elm$core$Platform$Cmd$none),
								navbarOutMsgs);
							var modelWithOutMsgs = _v31.a;
							var outMsgCmd = _v31.b;
							return _Utils_Tuple2(
								modelWithOutMsgs,
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2($elm$core$Platform$Cmd$map, $author$project$Shared$NavbarMsg, navbarCmd),
											outMsgCmd
										])));
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					}
				case 18:
					return _Utils_Tuple2(model, $author$project$Shared$deidentifyOnExternalServices);
				case 19:
					var postOrganizationSwitchedAction_ = msg.a;
					var response = msg.b;
					_v32$4:
					while (true) {
						switch (response.$) {
							case 3:
								var authToken = response.a;
								return A3(
									$author$project$Shared$scheduleOrgSwitchRedirect,
									model,
									postOrganizationSwitchedAction_,
									A2($author$project$Shared$storeAuthToken, authToken, true));
							case 2:
								switch (response.a.$) {
									case 9:
										return _Utils_Tuple2(
											model,
											$author$project$Ports$Session$logout(
												{aku: true}));
									case 0:
										return _Utils_Tuple2(
											model,
											$author$project$Ports$Session$logout(
												{aku: true}));
									case 7:
										var error = response.a.a;
										return _Utils_Tuple2(
											model,
											$author$project$Shared$decodeErrorToMsg(error));
									default:
										break _v32$4;
								}
							default:
								break _v32$4;
						}
					}
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				case 20:
					var switchOrganizationFrom = msg.a;
					var response = msg.b;
					_v33$2:
					while (true) {
						switch (response.$) {
							case 3:
								var practices = response.a;
								var _v34 = $elm$core$List$head(practices);
								if (!_v34.$) {
									var practice = _v34.a;
									return model.ahq.ae6 ? _Utils_Tuple2(
										model,
										A4(
											$author$project$Api$Auth$switchToOrganization,
											model.Gv,
											$author$project$Api$Platform$Practice$All$organizationId(practice),
											$elm$core$Maybe$Nothing,
											$author$project$Shared$BackupAuthOrganizationSwitched(
												$author$project$Shared$OrgSwitcher$postOrganizationSwitchedAction(switchOrganizationFrom)))) : A3(
										$author$project$Shared$scheduleOrgSwitchRedirect,
										model,
										$author$project$Shared$OrgSwitcher$postOrganizationSwitchedAction(switchOrganizationFrom),
										$author$project$Ports$Session$switchTenant(
											$author$project$Api$Platform$Practice$All$organizationId(practice)));
								} else {
									return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
								}
							case 2:
								if (response.a.$ === 7) {
									var error = response.a.a;
									return _Utils_Tuple2(
										model,
										$author$project$Shared$decodeErrorToMsg(error));
								} else {
									break _v33$2;
								}
							default:
								break _v33$2;
						}
					}
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				case 21:
					var switchOrganizationFrom = msg.a;
					var response = msg.b;
					_v35$2:
					while (true) {
						switch (response.$) {
							case 3:
								var partners = response.a;
								var _v36 = $elm$core$List$head(partners);
								if (!_v36.$) {
									var partner = _v36.a;
									return model.ahq.ae6 ? _Utils_Tuple2(
										model,
										A4(
											$author$project$Api$Auth$switchToOrganization,
											model.Gv,
											$author$project$Api$Platform$Partner$All$organizationId(partner),
											$elm$core$Maybe$Nothing,
											$author$project$Shared$BackupAuthOrganizationSwitched(
												$author$project$Shared$OrgSwitcher$postOrganizationSwitchedAction(switchOrganizationFrom)))) : A3(
										$author$project$Shared$scheduleOrgSwitchRedirect,
										model,
										$author$project$Shared$OrgSwitcher$postOrganizationSwitchedAction(switchOrganizationFrom),
										$author$project$Ports$Session$switchTenant(
											$author$project$Api$Platform$Partner$All$organizationId(partner)));
								} else {
									return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
								}
							case 2:
								if (response.a.$ === 7) {
									var error = response.a.a;
									return _Utils_Tuple2(
										model,
										$author$project$Shared$decodeErrorToMsg(error));
								} else {
									break _v35$2;
								}
							default:
								break _v35$2;
						}
					}
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				case 22:
					var _v37 = model.Zn;
					if (!_v37.$) {
						var _v38 = _v37.a;
						var url = _v38.a;
						var isLocal = _v38.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{ajY: $elm$core$Maybe$Nothing}),
							A3($author$project$Ports$Navigation$requestUrl, url, isLocal, false));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 23:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{Zn: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none);
				case 24:
					var patientId = msg.a;
					var response = msg.b;
					_v39$2:
					while (true) {
						if (response.$ === 2) {
							switch (response.a.$) {
								case 5:
									var _v40 = response.a;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{G9: response}),
										A4(
											$author$project$Api$Platform$User$Practice$list,
											model.Gv,
											function (d) {
												return _Utils_update(
													d,
													{
														akl: $elm$core$Maybe$Just(patientId)
													});
											},
											$elm$core$Maybe$Nothing,
											$author$project$Shared$GotUserPractices(
												$author$project$Shared$OrgSwitcher$Patient(patientId))));
								case 7:
									var error = response.a.a;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{G9: response}),
										$author$project$Shared$decodeErrorToMsg(error));
								default:
									break _v39$2;
							}
						} else {
							break _v39$2;
						}
					}
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{G9: response}),
						$elm$core$Platform$Cmd$none);
				case 25:
					var response = msg.a;
					_v41$2:
					while (true) {
						switch (response.$) {
							case 2:
								if (response.a.$ === 7) {
									var error = response.a.a;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{aey: response}),
										$author$project$Shared$decodeErrorToMsg(error));
								} else {
									break _v41$2;
								}
							case 3:
								var whitelabelSetting_ = response.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{aey: response}),
									$author$project$Shared$setFaviconUrls(whitelabelSetting_));
							default:
								break _v41$2;
						}
					}
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{aey: response}),
						$elm$core$Platform$Cmd$none);
				case 26:
					var authTokenData = msg.a;
					_v42$4:
					while (true) {
						switch (authTokenData.$) {
							case 3:
								var authToken = authTokenData.a;
								return _Utils_Tuple2(
									model,
									A2($author$project$Shared$storeAuthToken, authToken, true));
							case 2:
								switch (authTokenData.a.$) {
									case 9:
										return _Utils_Tuple2(
											_Utils_update(
												model,
												{uA: true}),
											$elm$core$Platform$Cmd$none);
									case 0:
										return _Utils_Tuple2(
											model,
											$author$project$Ports$Session$logout(
												{aku: true}));
									case 7:
										var error = authTokenData.a.a;
										return _Utils_Tuple2(
											model,
											$author$project$Shared$decodeErrorToMsg(error));
									default:
										break _v42$4;
								}
							default:
								break _v42$4;
						}
					}
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				case 27:
					return _Utils_Tuple2(
						model,
						$author$project$Shared$refreshToken(model.Gv));
				case 28:
					var signOutNow = msg.a;
					var newModel = _Utils_update(
						model,
						{uA: false});
					return signOutNow ? _Utils_Tuple2(
						newModel,
						$author$project$Ports$Session$logout(
							{aku: true})) : _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
				case 29:
					var subMsg = msg.a;
					var _v43 = model.g1;
					if (!_v43.$) {
						var switcher = _v43.a;
						var _v44 = A2($author$project$Components$OrganizationSwitcher$update, subMsg, switcher);
						var newSwitcher = _v44.a;
						var switcherCmd = _v44.b;
						var outMsgs = _v44.c;
						var _v45 = A2(
							$author$project$Shared$updateFromOutMsgs,
							outMsgs,
							_Utils_update(
								model,
								{
									g1: $elm$core$Maybe$Just(newSwitcher)
								}));
						var updatedModel = _v45.a;
						var outMsgCmd = _v45.b;
						return _Utils_Tuple2(
							updatedModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($elm$core$Platform$Cmd$map, $author$project$Shared$OrganizationSwitcherMsg, switcherCmd),
										outMsgCmd
									])));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				default:
					var response = msg.a;
					_v46$2:
					while (true) {
						switch (response.$) {
							case 3:
								var session_ = response.a;
								var scheduledModel = _Utils_update(
									model,
									{
										aj: $elm$core$Maybe$Nothing,
										dD: $author$project$Shared$OrgSwitcher$pendingRedirect($author$project$OutMsg$GoToDefaultStateAction),
										ZV: $author$project$Api$Data$NotAsked
									});
								return A4($author$project$Shared$applySession, response, session_, scheduledModel, $elm$core$Platform$Cmd$none);
							case 2:
								if (response.a.$ === 7) {
									var error = response.a.a;
									return _Utils_Tuple2(
										model,
										$author$project$Shared$decodeErrorToMsg(error));
								} else {
									break _v46$2;
								}
							default:
								break _v46$2;
						}
					}
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$Spa$Generated$Pages$update = F2(
	function (bigMsg, bigModel) {
		var _v0 = _Utils_Tuple2(bigMsg, bigModel);
		_v0$365:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					if (!_v0.b.$) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.FU.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 1:
					if (_v0.b.$ === 1) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.xC.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 2:
					if (_v0.b.$ === 2) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.xD.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 3:
					if (_v0.b.$ === 3) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.xL.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 4:
					if (_v0.b.$ === 4) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.aL.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 5:
					if (_v0.b.$ === 5) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.zM.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 6:
					if (_v0.b.$ === 6) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.z4.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 7:
					if (_v0.b.$ === 7) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.AG.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 8:
					if (_v0.b.$ === 8) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.AH.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 9:
					if (_v0.b.$ === 9) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.tl.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 10:
					if (_v0.b.$ === 10) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Cc.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 11:
					if (_v0.b.$ === 11) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.DK.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 12:
					if (_v0.b.$ === 12) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.w1.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 13:
					if (_v0.b.$ === 13) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.xd.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 14:
					if (_v0.b.$ === 14) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yI.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 15:
					if (_v0.b.$ === 15) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.zH.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 16:
					if (_v0.b.$ === 16) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.AT.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 17:
					if (_v0.b.$ === 17) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.C5.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 18:
					if (_v0.b.$ === 18) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Dt.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 19:
					if (_v0.b.$ === 19) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.FA.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 20:
					if (_v0.b.$ === 20) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.FM.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 21:
					if (_v0.b.$ === 21) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.vx.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 22:
					if (_v0.b.$ === 22) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.vF.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 23:
					if (_v0.b.$ === 23) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.vM.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 24:
					if (_v0.b.$ === 24) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.vO.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 25:
					if (_v0.b.$ === 25) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.vP.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 26:
					if (_v0.b.$ === 26) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.vQ.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 27:
					if (_v0.b.$ === 27) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.vV.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 28:
					if (_v0.b.$ === 28) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.vZ.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 29:
					if (_v0.b.$ === 29) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.v1.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 30:
					if (_v0.b.$ === 30) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wh.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 31:
					if (_v0.b.$ === 31) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wm.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 32:
					if (_v0.b.$ === 32) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wn.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 33:
					if (_v0.b.$ === 33) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wp.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 34:
					if (_v0.b.$ === 34) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wq.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 35:
					if (_v0.b.$ === 35) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wr.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 36:
					if (_v0.b.$ === 36) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.ws.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 37:
					if (_v0.b.$ === 37) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wt.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 38:
					if (_v0.b.$ === 38) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wu.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 39:
					if (_v0.b.$ === 39) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wC.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 40:
					if (_v0.b.$ === 40) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wD.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 41:
					if (_v0.b.$ === 41) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wF.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 42:
					if (_v0.b.$ === 42) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wG.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 43:
					if (_v0.b.$ === 43) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wM.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 44:
					if (_v0.b.$ === 44) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wN.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 45:
					if (_v0.b.$ === 45) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wR.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 46:
					if (_v0.b.$ === 46) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wS.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 47:
					if (_v0.b.$ === 47) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wT.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 48:
					if (_v0.b.$ === 48) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wX.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 49:
					if (_v0.b.$ === 49) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wY.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 50:
					if (_v0.b.$ === 50) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wZ.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 51:
					if (_v0.b.$ === 51) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.w$.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 52:
					if (_v0.b.$ === 52) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.xb.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 53:
					if (_v0.b.$ === 53) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.xc.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 54:
					if (_v0.b.$ === 54) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.x_.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 55:
					if (_v0.b.$ === 55) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yn.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 56:
					if (_v0.b.$ === 56) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yH.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 57:
					if (_v0.b.$ === 57) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yL.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 58:
					if (_v0.b.$ === 58) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yM.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 59:
					if (_v0.b.$ === 59) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.zG.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 60:
					if (_v0.b.$ === 60) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.z_.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 61:
					if (_v0.b.$ === 61) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.z$.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 62:
					if (_v0.b.$ === 62) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.z0.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 63:
					if (_v0.b.$ === 63) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.z1.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 64:
					if (_v0.b.$ === 64) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.z2.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 65:
					if (_v0.b.$ === 65) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.z3.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 66:
					if (_v0.b.$ === 66) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Ag.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 67:
					if (_v0.b.$ === 67) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Ah.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 68:
					if (_v0.b.$ === 68) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Ai.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 69:
					if (_v0.b.$ === 69) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.AN.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 70:
					if (_v0.b.$ === 70) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.AY.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 71:
					if (_v0.b.$ === 71) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.AZ.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 72:
					if (_v0.b.$ === 72) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.A_.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 73:
					if (_v0.b.$ === 73) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.A3.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 74:
					if (_v0.b.$ === 74) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.A4.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 75:
					if (_v0.b.$ === 75) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.A5.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 76:
					if (_v0.b.$ === 76) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.A6.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 77:
					if (_v0.b.$ === 77) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Bd.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 78:
					if (_v0.b.$ === 78) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Bv.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 79:
					if (_v0.b.$ === 79) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Bw.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 80:
					if (_v0.b.$ === 80) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Bx.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 81:
					if (_v0.b.$ === 81) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.By.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 82:
					if (_v0.b.$ === 82) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Bz.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 83:
					if (_v0.b.$ === 83) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.BD.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 84:
					if (_v0.b.$ === 84) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.BE.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 85:
					if (_v0.b.$ === 85) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.BU.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 86:
					if (_v0.b.$ === 86) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Cn.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 87:
					if (_v0.b.$ === 87) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Co.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 88:
					if (_v0.b.$ === 88) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Cv.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 89:
					if (_v0.b.$ === 89) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Cw.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 90:
					if (_v0.b.$ === 90) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CF.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 91:
					if (_v0.b.$ === 91) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CN.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 92:
					if (_v0.b.$ === 92) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.C6.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 93:
					if (_v0.b.$ === 93) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Dj.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 94:
					if (_v0.b.$ === 94) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Dk.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 95:
					if (_v0.b.$ === 95) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Dl.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 96:
					if (_v0.b.$ === 96) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Dm.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 97:
					if (_v0.b.$ === 97) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Dn.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 98:
					if (_v0.b.$ === 98) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Do.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 99:
					if (_v0.b.$ === 99) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Dp.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 100:
					if (_v0.b.$ === 100) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Ds.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 101:
					if (_v0.b.$ === 101) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.DS.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 102:
					if (_v0.b.$ === 102) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.DT.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 103:
					if (_v0.b.$ === 103) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.DV.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 104:
					if (_v0.b.$ === 104) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.DZ.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 105:
					if (_v0.b.$ === 105) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.D_.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 106:
					if (_v0.b.$ === 106) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.D0.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 107:
					if (_v0.b.$ === 107) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.D1.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 108:
					if (_v0.b.$ === 108) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.D2.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 109:
					if (_v0.b.$ === 109) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.D3.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 110:
					if (_v0.b.$ === 110) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.D4.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 111:
					if (_v0.b.$ === 111) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.D5.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 112:
					if (_v0.b.$ === 112) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.D6.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 113:
					if (_v0.b.$ === 113) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.D8.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 114:
					if (_v0.b.$ === 114) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Ea.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 115:
					if (_v0.b.$ === 115) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Ec.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 116:
					if (_v0.b.$ === 116) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.ES.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 117:
					if (_v0.b.$ === 117) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.ET.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 118:
					if (_v0.b.$ === 118) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.EU.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 119:
					if (_v0.b.$ === 119) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.EV.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 120:
					if (_v0.b.$ === 120) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.EW.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 121:
					if (_v0.b.$ === 121) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.EX.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 122:
					if (_v0.b.$ === 122) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.EY.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 123:
					if (_v0.b.$ === 123) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.EZ.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 124:
					if (_v0.b.$ === 124) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.E_.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 125:
					if (_v0.b.$ === 125) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.E$.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 126:
					if (_v0.b.$ === 126) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.E0.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 127:
					if (_v0.b.$ === 127) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.E1.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 128:
					if (_v0.b.$ === 128) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.E2.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 129:
					if (_v0.b.$ === 129) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.E3.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 130:
					if (_v0.b.$ === 130) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.E4.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 131:
					if (_v0.b.$ === 131) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.E5.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 132:
					if (_v0.b.$ === 132) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.E6.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 133:
					if (_v0.b.$ === 133) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.E7.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 134:
					if (_v0.b.$ === 134) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.E8.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 135:
					if (_v0.b.$ === 135) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.E9.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 136:
					if (_v0.b.$ === 136) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Fa.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 137:
					if (_v0.b.$ === 137) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Fb.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 138:
					if (_v0.b.$ === 138) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Fc.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 139:
					if (_v0.b.$ === 139) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Fd.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 140:
					if (_v0.b.$ === 140) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Fe.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 141:
					if (_v0.b.$ === 141) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Ff.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 142:
					if (_v0.b.$ === 142) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Fg.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 143:
					if (_v0.b.$ === 143) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Fh.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 144:
					if (_v0.b.$ === 144) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Fi.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 145:
					if (_v0.b.$ === 145) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Fj.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 146:
					if (_v0.b.$ === 146) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Fk.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 147:
					if (_v0.b.$ === 147) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Fl.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 148:
					if (_v0.b.$ === 148) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Fm.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 149:
					if (_v0.b.$ === 149) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Fn.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 150:
					if (_v0.b.$ === 150) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Fo.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 151:
					if (_v0.b.$ === 151) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Fp.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 152:
					if (_v0.b.$ === 152) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Fq.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 153:
					if (_v0.b.$ === 153) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Fr.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 154:
					if (_v0.b.$ === 154) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Fs.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 155:
					if (_v0.b.$ === 155) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Ft.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 156:
					if (_v0.b.$ === 156) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Fu.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 157:
					if (_v0.b.$ === 157) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Fv.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 158:
					if (_v0.b.$ === 158) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Fw.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 159:
					if (_v0.b.$ === 159) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Fx.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 160:
					if (_v0.b.$ === 160) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Fy.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 161:
					if (_v0.b.$ === 161) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Fz.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 162:
					if (_v0.b.$ === 162) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.FB.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 163:
					if (_v0.b.$ === 163) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.FC.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 164:
					if (_v0.b.$ === 164) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.FD.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 165:
					if (_v0.b.$ === 165) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.FE.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 166:
					if (_v0.b.$ === 166) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.FH.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 167:
					if (_v0.b.$ === 167) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.FK.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 168:
					if (_v0.b.$ === 168) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.F2.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 169:
					if (_v0.b.$ === 169) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.F3.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 170:
					if (_v0.b.$ === 170) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.F5.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 171:
					if (_v0.b.$ === 171) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.F6.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 172:
					if (_v0.b.$ === 172) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.xn.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 173:
					if (_v0.b.$ === 173) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.zu.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 174:
					if (_v0.b.$ === 174) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.As.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 175:
					if (_v0.b.$ === 175) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.AP.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 176:
					if (_v0.b.$ === 176) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.vL.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 177:
					if (_v0.b.$ === 177) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.vT.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 178:
					if (_v0.b.$ === 178) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.vY.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 179:
					if (_v0.b.$ === 179) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.v0.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 180:
					if (_v0.b.$ === 180) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.v7.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 181:
					if (_v0.b.$ === 181) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.v5.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 182:
					if (_v0.b.$ === 182) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wg.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 183:
					if (_v0.b.$ === 183) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wl.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 184:
					if (_v0.b.$ === 184) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wL.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 185:
					if (_v0.b.$ === 185) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wO.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 186:
					if (_v0.b.$ === 186) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wQ.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 187:
					if (_v0.b.$ === 187) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wW.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 188:
					if (_v0.b.$ === 188) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.xV.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 189:
					if (_v0.b.$ === 189) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yk.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 190:
					if (_v0.b.$ === 190) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.ym.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 191:
					if (_v0.b.$ === 191) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yD.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 192:
					if (_v0.b.$ === 192) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yK.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 193:
					if (_v0.b.$ === 193) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.zZ.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 194:
					if (_v0.b.$ === 194) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Af.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 195:
					if (_v0.b.$ === 195) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.A2.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 196:
					if (_v0.b.$ === 196) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Bc.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 197:
					if (_v0.b.$ === 197) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Bu.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 198:
					if (_v0.b.$ === 198) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.BC.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 199:
					if (_v0.b.$ === 199) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.BL.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 200:
					if (_v0.b.$ === 200) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.B6.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 201:
					if (_v0.b.$ === 201) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Cu.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 202:
					if (_v0.b.$ === 202) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Cx.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 203:
					if (_v0.b.$ === 203) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CE.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 204:
					if (_v0.b.$ === 204) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.C3.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 205:
					if (_v0.b.$ === 205) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.DR.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 206:
					if (_v0.b.$ === 206) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.FL.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 207:
					if (_v0.b.$ === 207) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.F4.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 208:
					if (_v0.b.$ === 208) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.vG.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 209:
					if (_v0.b.$ === 209) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.vH.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 210:
					if (_v0.b.$ === 210) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.vI.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 211:
					if (_v0.b.$ === 211) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.vJ.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 212:
					if (_v0.b.$ === 212) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.vK.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 213:
					if (_v0.b.$ === 213) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.vS.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 214:
					if (_v0.b.$ === 214) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.vU.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 215:
					if (_v0.b.$ === 215) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.vX.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 216:
					if (_v0.b.$ === 216) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.v$.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 217:
					if (_v0.b.$ === 217) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.v2.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 218:
					if (_v0.b.$ === 218) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.v4.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 219:
					if (_v0.b.$ === 219) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.v8.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 220:
					if (_v0.b.$ === 220) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.v9.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 221:
					if (_v0.b.$ === 221) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wa.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 222:
					if (_v0.b.$ === 222) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wb.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 223:
					if (_v0.b.$ === 223) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wc.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 224:
					if (_v0.b.$ === 224) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wd.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 225:
					if (_v0.b.$ === 225) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wf.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 226:
					if (_v0.b.$ === 226) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wi.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 227:
					if (_v0.b.$ === 227) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wj.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 228:
					if (_v0.b.$ === 228) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wk.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 229:
					if (_v0.b.$ === 229) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wv.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 230:
					if (_v0.b.$ === 230) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.ww.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 231:
					if (_v0.b.$ === 231) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wx.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 232:
					if (_v0.b.$ === 232) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wy.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 233:
					if (_v0.b.$ === 233) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wA.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 234:
					if (_v0.b.$ === 234) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wB.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 235:
					if (_v0.b.$ === 235) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wE.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 236:
					if (_v0.b.$ === 236) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wK.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 237:
					if (_v0.b.$ === 237) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wP.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 238:
					if (_v0.b.$ === 238) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wV.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 239:
					if (_v0.b.$ === 239) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.w_.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 240:
					if (_v0.b.$ === 240) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.w3.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 241:
					if (_v0.b.$ === 241) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.w6.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 242:
					if (_v0.b.$ === 242) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.w7.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 243:
					if (_v0.b.$ === 243) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.w8.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 244:
					if (_v0.b.$ === 244) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.w9.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 245:
					if (_v0.b.$ === 245) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.xa.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 246:
					if (_v0.b.$ === 246) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yj.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 247:
					if (_v0.b.$ === 247) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yl.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 248:
					if (_v0.b.$ === 248) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yo.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 249:
					if (_v0.b.$ === 249) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yp.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 250:
					if (_v0.b.$ === 250) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yt.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 251:
					if (_v0.b.$ === 251) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yu.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 252:
					if (_v0.b.$ === 252) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yx.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 253:
					if (_v0.b.$ === 253) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yy.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 254:
					if (_v0.b.$ === 254) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yz.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 255:
					if (_v0.b.$ === 255) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yA.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 256:
					if (_v0.b.$ === 256) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.A$.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 257:
					if (_v0.b.$ === 257) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.A1.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 258:
					if (_v0.b.$ === 258) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Ba.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 259:
					if (_v0.b.$ === 259) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.A8.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 260:
					if (_v0.b.$ === 260) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Bt.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 261:
					if (_v0.b.$ === 261) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.BJ.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 262:
					if (_v0.b.$ === 262) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.B7.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 263:
					if (_v0.b.$ === 263) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.B8.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 264:
					if (_v0.b.$ === 264) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.B9.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 265:
					if (_v0.b.$ === 265) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Ca.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 266:
					if (_v0.b.$ === 266) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Cp.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 267:
					if (_v0.b.$ === 267) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Cq.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 268:
					if (_v0.b.$ === 268) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Cr.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 269:
					if (_v0.b.$ === 269) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Cs.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 270:
					if (_v0.b.$ === 270) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Ct.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 271:
					if (_v0.b.$ === 271) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CD.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 272:
					if (_v0.b.$ === 272) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CG.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 273:
					if (_v0.b.$ === 273) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CH.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 274:
					if (_v0.b.$ === 274) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CT.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 275:
					if (_v0.b.$ === 275) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CU.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 276:
					if (_v0.b.$ === 276) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CV.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 277:
					if (_v0.b.$ === 277) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CW.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 278:
					if (_v0.b.$ === 278) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CX.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 279:
					if (_v0.b.$ === 279) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.C$.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 280:
					if (_v0.b.$ === 280) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.C4.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 281:
					if (_v0.b.$ === 281) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Dr.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 282:
					if (_v0.b.$ === 282) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.DU.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 283:
					if (_v0.b.$ === 283) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.DW.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 284:
					if (_v0.b.$ === 284) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.DY.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 285:
					if (_v0.b.$ === 285) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.D$.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 286:
					if (_v0.b.$ === 286) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.D7.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 287:
					if (_v0.b.$ === 287) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.D9.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 288:
					if (_v0.b.$ === 288) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Eb.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 289:
					if (_v0.b.$ === 289) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.vR.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 290:
					if (_v0.b.$ === 290) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.vW.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 291:
					if (_v0.b.$ === 291) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.v_.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 292:
					if (_v0.b.$ === 292) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.v6.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 293:
					if (_v0.b.$ === 293) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.v3.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 294:
					if (_v0.b.$ === 294) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.we.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 295:
					if (_v0.b.$ === 295) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wo.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 296:
					if (_v0.b.$ === 296) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wH.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 297:
					if (_v0.b.$ === 297) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wU.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 298:
					if (_v0.b.$ === 298) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.zY.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 299:
					if (_v0.b.$ === 299) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.A0.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 300:
					if (_v0.b.$ === 300) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Be.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 301:
					if (_v0.b.$ === 301) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Bs.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 302:
					if (_v0.b.$ === 302) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.BA.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 303:
					if (_v0.b.$ === 303) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.BF.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 304:
					if (_v0.b.$ === 304) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.BK.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 305:
					if (_v0.b.$ === 305) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Cy.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 306:
					if (_v0.b.$ === 306) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.DQ.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 307:
					if (_v0.b.$ === 307) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.DX.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 308:
					if (_v0.b.$ === 308) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.w5.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 309:
					if (_v0.b.$ === 309) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yi.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 310:
					if (_v0.b.$ === 310) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.ys.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 311:
					if (_v0.b.$ === 311) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yw.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 312:
					if (_v0.b.$ === 312) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yE.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 313:
					if (_v0.b.$ === 313) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Bb.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 314:
					if (_v0.b.$ === 314) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.A9.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 315:
					if (_v0.b.$ === 315) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CO.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 316:
					if (_v0.b.$ === 316) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CP.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 317:
					if (_v0.b.$ === 317) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CS.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 318:
					if (_v0.b.$ === 318) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.C_.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 319:
					if (_v0.b.$ === 319) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.C1.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 320:
					if (_v0.b.$ === 320) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.C2.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 321:
					if (_v0.b.$ === 321) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wz.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 322:
					if (_v0.b.$ === 322) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.ye.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 323:
					if (_v0.b.$ === 323) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yf.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 324:
					if (_v0.b.$ === 324) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yq.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 325:
					if (_v0.b.$ === 325) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yC.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 326:
					if (_v0.b.$ === 326) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.AK.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 327:
					if (_v0.b.$ === 327) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.AL.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 328:
					if (_v0.b.$ === 328) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.AM.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 329:
					if (_v0.b.$ === 329) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.AO.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 330:
					if (_v0.b.$ === 330) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.AQ.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 331:
					if (_v0.b.$ === 331) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.AR.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 332:
					if (_v0.b.$ === 332) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.AS.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 333:
					if (_v0.b.$ === 333) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.BG.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 334:
					if (_v0.b.$ === 334) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.BH.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 335:
					if (_v0.b.$ === 335) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.BI.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 336:
					if (_v0.b.$ === 336) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Cz.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 337:
					if (_v0.b.$ === 337) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CA.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 338:
					if (_v0.b.$ === 338) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CB.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 339:
					if (_v0.b.$ === 339) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CC.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 340:
					if (_v0.b.$ === 340) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CZ.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 341:
					if (_v0.b.$ === 341) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Dq.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 342:
					if (_v0.b.$ === 342) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.vN.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 343:
					if (_v0.b.$ === 343) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.w4.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 344:
					if (_v0.b.$ === 344) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yv.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 345:
					if (_v0.b.$ === 345) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yB.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 346:
					if (_v0.b.$ === 346) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Bf.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 347:
					if (_v0.b.$ === 347) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Bg.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 348:
					if (_v0.b.$ === 348) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.BB.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 349:
					if (_v0.b.$ === 349) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.C0.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 350:
					if (_v0.b.$ === 350) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yd.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 351:
					if (_v0.b.$ === 351) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yh.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 352:
					if (_v0.b.$ === 352) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yF.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 353:
					if (_v0.b.$ === 353) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CQ.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 354:
					if (_v0.b.$ === 354) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CR.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 355:
					if (_v0.b.$ === 355) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CY.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 356:
					if (_v0.b.$ === 356) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wI.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 357:
					if (_v0.b.$ === 357) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yb.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 358:
					if (_v0.b.$ === 358) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yc.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 359:
					if (_v0.b.$ === 359) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yG.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 360:
					if (_v0.b.$ === 360) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wJ.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 361:
					if (_v0.b.$ === 361) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yg.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 362:
					if (_v0.b.$ === 362) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.A7.adT, msg, model);
					} else {
						break _v0$365;
					}
				case 363:
					if (_v0.b.$ === 363) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.ya.adT, msg, model);
					} else {
						break _v0$365;
					}
				default:
					if (_v0.b.$ === 364) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yr.adT, msg, model);
					} else {
						break _v0$365;
					}
			}
		}
		return _Utils_Tuple3(bigModel, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Layouts$Admin$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var navMsg = msg.a;
			return A2(
				$author$project$Utils$Tuple3$fromTuple2,
				_List_Nil,
				A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Layouts$Admin$NavMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						function (nav) {
							return _Utils_update(
								model,
								{kp: nav});
						},
						A2($author$project$Ui$Nav$update, navMsg, model.kp))));
		} else {
			var response = msg.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{s6: response}),
				$elm$core$Platform$Cmd$none,
				_List_Nil);
		}
	});
var $author$project$Layouts$Affiliates$update = F2(
	function (msg, model) {
		var navMsg = msg;
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map($elm$core$Basics$identity),
			A2(
				$elm$core$Tuple$mapFirst,
				function (nav) {
					return _Utils_update(
						model,
						{kp: nav});
				},
				A2($author$project$Ui$Nav$update, navMsg, model.kp)));
	});
var $author$project$Layouts$Affiliates$Affiliate$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var response = msg.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{Gn: response}),
				$elm$core$Platform$Cmd$none,
				$author$project$OutMsg$handleErrorResponse(response));
		} else {
			var navMsg = msg.a;
			return A2(
				$author$project$Utils$Tuple3$fromTuple2,
				_List_Nil,
				A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Layouts$Affiliates$Affiliate$NavMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						function (nav) {
							return _Utils_update(
								model,
								{kp: nav});
						},
						A2($author$project$Ui$Nav$update, navMsg, model.kp))));
		}
	});
var $author$project$Layouts$Commissions$update = F2(
	function (msg, model) {
		var navMsg = msg;
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map($elm$core$Basics$identity),
			A2(
				$elm$core$Tuple$mapFirst,
				function (nav) {
					return _Utils_update(
						model,
						{kp: nav});
				},
				A2($author$project$Ui$Nav$update, navMsg, model.kp)));
	});
var $author$project$Layouts$Commissions$BrokerAccount$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var response = msg.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{xG: response}),
				$elm$core$Platform$Cmd$none,
				$author$project$OutMsg$handleErrorResponse(response));
		} else {
			var navMsg = msg.a;
			return A2(
				$author$project$Utils$Tuple3$fromTuple2,
				_List_Nil,
				A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Layouts$Commissions$BrokerAccount$NavMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						function (nav) {
							return _Utils_update(
								model,
								{kp: nav});
						},
						A2($author$project$Ui$Nav$update, navMsg, model.kp))));
		}
	});
var $author$project$Layouts$Company$update = F2(
	function (msg, model) {
		var navMsg = msg;
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map($elm$core$Basics$identity),
			A2(
				$elm$core$Tuple$mapFirst,
				function (nav) {
					return _Utils_update(
						model,
						{kp: nav});
				},
				A2($author$project$Ui$Nav$update, navMsg, model.kp)));
	});
var $author$project$Layouts$Marketplace$Manage$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var navMsg = msg.a;
			return A2(
				$author$project$Utils$Tuple3$fromTuple2,
				_List_Nil,
				A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Layouts$Marketplace$Manage$NavMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						function (nav) {
							return _Utils_update(
								model,
								{kp: nav});
						},
						A2($author$project$Ui$Nav$update, navMsg, model.kp))));
		} else {
			var response = msg.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{T8: response}),
				$elm$core$Platform$Cmd$none,
				$author$project$OutMsg$handleErrorResponse(response));
		}
	});
var $author$project$Layouts$Partner$Billing$update = F2(
	function (msg, model) {
		var navMsg = msg;
		return A2(
			$author$project$Utils$Tuple3$fromTuple2,
			_List_Nil,
			A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Platform$Cmd$map($elm$core$Basics$identity),
				A2(
					$elm$core$Tuple$mapFirst,
					function (nav) {
						return _Utils_update(
							model,
							{kp: nav});
					},
					A2($author$project$Ui$Nav$update, navMsg, model.kp))));
	});
var $author$project$Layouts$Partner$Practices$update = F2(
	function (msg, model) {
		var navMsg = msg;
		return A2(
			$author$project$Utils$Tuple3$fromTuple2,
			_List_Nil,
			A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Platform$Cmd$map($elm$core$Basics$identity),
				A2(
					$elm$core$Tuple$mapFirst,
					function (nav) {
						return _Utils_update(
							model,
							{kp: nav});
					},
					A2($author$project$Ui$Nav$update, navMsg, model.kp))));
	});
var $author$project$Layouts$Partner$Product$update = F2(
	function (msg, model) {
		var navMsg = msg;
		return A2(
			$author$project$Utils$Tuple3$fromTuple2,
			_List_Nil,
			A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Platform$Cmd$map($elm$core$Basics$identity),
				A2(
					$elm$core$Tuple$mapFirst,
					function (nav) {
						return _Utils_update(
							model,
							{kp: nav});
					},
					A2($author$project$Ui$Nav$update, navMsg, model.kp))));
	});
var $author$project$Layouts$Partner$Webhooks$update = F2(
	function (msg, model) {
		var navMsg = msg;
		return A2(
			$author$project$Utils$Tuple3$fromTuple2,
			_List_Nil,
			A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Platform$Cmd$map($elm$core$Basics$identity),
				A2(
					$elm$core$Tuple$mapFirst,
					function (nav) {
						return _Utils_update(
							model,
							{kp: nav});
					},
					A2($author$project$Ui$Nav$update, navMsg, model.kp))));
	});
var $author$project$Layouts$Patient$GotAffiliateSyncDetail = function (a) {
	return {$: 4, a: a};
};
var $author$project$Layouts$Patient$GotNetworkSyncDetail = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$Organization$Min$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$Organization$Shared$id = function (_v0) {
	var min = _v0;
	return $author$project$Api$Provider$Organization$Min$id(min);
};
var $author$project$Api$Provider$Patient$SyncDetail$Network = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Patient$SyncDetail$networkDecoder = $elm$json$Json$Decode$nullable(
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Patient$SyncDetail$recordDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['affiliate', 'name']),
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$SyncDetail$Network))));
var $author$project$Api$Provider$SyncDetail$retrieveNetwork = F3(
	function (apiClient, patientId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Patient$SyncDetail$networkDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['sync_details', 'network']),
					$author$project$Api$Provider$Patient$patientPath(patientId))));
	});
var $author$project$Components$PatientChart$NotesCard$NoteDeleted = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Components$PatientChart$NotesCard$NoteFlagged = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Ui$FlyoutMenu$close = function (_v0) {
	var model = _v0;
	return _Utils_update(
		model,
		{Yn: false});
};
var $author$project$Components$PatientChart$NotesCard$closeActionMenu = F2(
	function (noteId, menus) {
		return A3(
			$elm$core$Dict$update,
			noteId,
			$elm$core$Maybe$map($author$project$Ui$FlyoutMenu$close),
			menus);
	});
var $author$project$Components$PatientChart$NotesCard$formFieldsFromNote = function (note) {
	return $author$project$Api$Provider$Note$All$content(note);
};
var $author$project$Components$PatientChart$NotesCard$formFieldsInit = '';
var $author$project$Components$PatientChart$NotesCard$formFieldsUpdate = F2(
	function (field, _v0) {
		var string = field;
		return string;
	});
var $author$project$Components$PatientChart$NotesCard$ContentValidation = 0;
var $author$project$Components$PatientChart$NotesCard$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			$elm$core$Basics$identity,
			_Utils_Tuple2(0, 'Please enter some content.'))
		]));
var $author$project$Components$PatientChart$NotesCard$NoteCreated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$PatientChart$NotesCard$createNote = F3(
	function (apiClient, notable, formFields) {
		var content = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4($author$project$Api$Provider$Note$create, apiClient, notable, content, $author$project$Components$PatientChart$NotesCard$NoteCreated);
	});
var $author$project$Components$PatientChart$NotesCard$NoteUpdated = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$PatientChart$NotesCard$updateNote = F4(
	function (apiClient, notable, id, formFields) {
		var content = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A5($author$project$Api$Provider$Note$update, apiClient, notable, id, content, $author$project$Components$PatientChart$NotesCard$NoteUpdated);
	});
var $author$project$Components$PatientChart$NotesCard$saveNote = F4(
	function (apiClient, notable, maybeId, formFields) {
		if (!maybeId.$) {
			var id = maybeId.a;
			return A4($author$project$Components$PatientChart$NotesCard$updateNote, apiClient, notable, id, formFields);
		} else {
			return A3($author$project$Components$PatientChart$NotesCard$createNote, apiClient, notable, formFields);
		}
	});
var $author$project$Components$PatientChart$NotesCard$ActionMenuMsg = F2(
	function (a, b) {
		return {$: 15, a: a, b: b};
	});
var $author$project$Components$PatientChart$NotesCard$initActionMenu = function (noteId) {
	return A2(
		$author$project$Ui$FlyoutMenu$init,
		'note-actions-menu-' + noteId,
		$author$project$Components$PatientChart$NotesCard$ActionMenuMsg(noteId));
};
var $author$project$Components$PatientChart$NotesCard$syncActionMenus = F2(
	function (existing, response) {
		if (response.$ === 3) {
			var notes = response.a;
			return $elm$core$Dict$fromList(
				A2(
					$elm$core$List$map,
					function (note) {
						var id = $author$project$Api$Provider$Note$All$id(note);
						return _Utils_Tuple2(
							id,
							A2(
								$elm$core$Maybe$withDefault,
								$author$project$Components$PatientChart$NotesCard$initActionMenu(id),
								A2($elm$core$Dict$get, id, existing)));
					},
					notes));
		} else {
			return existing;
		}
	});
var $author$project$Components$PatientChart$NotesCard$updateUrl = function (model) {
	var params = function () {
		var _v0 = model.HN;
		if (!_v0) {
			return $elm$core$Dict$empty;
		} else {
			return A2(
				$elm$core$Dict$singleton,
				$author$project$Components$Notes$FlaggedOption$queryKey,
				$author$project$Components$Notes$FlaggedOption$toValue(model.HN));
		}
	}();
	return A2($author$project$Utils$Route$navigate, params, model.GC);
};
var $author$project$Components$PatientChart$NotesCard$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aZ: A2($author$project$Components$PatientChart$NotesCard$syncActionMenus, model.aZ, response),
							kt: response
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							al: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init($author$project$Components$PatientChart$NotesCard$formFieldsInit),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var field = msg.a;
				var _v2 = model.al;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var id = _v3.a;
					var form = _v3.b;
					var note = _v3.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$PatientChart$NotesCard$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								al: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, note))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var id = msg.a;
				var bool = msg.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aZ: A2($author$project$Components$PatientChart$NotesCard$closeActionMenu, id, model.aZ),
							ex: A2($elm$core$Set$insert, id, model.ex)
						}),
					A5(
						$author$project$Api$Provider$Note$flag,
						apiClient,
						model.ks,
						id,
						bool,
						$author$project$Components$PatientChart$NotesCard$NoteFlagged(id)),
					_List_Nil);
			case 4:
				var note = msg.a;
				var id = $author$project$Api$Provider$Note$All$id(note);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aZ: A2($author$project$Components$PatientChart$NotesCard$closeActionMenu, id, model.aZ),
							al: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(id),
									$author$project$Utils$Form$init(
										$author$project$Components$PatientChart$NotesCard$formFieldsFromNote(note)),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var id = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aZ: A2($author$project$Components$PatientChart$NotesCard$closeActionMenu, id, model.aZ),
							jg: $elm$core$Maybe$Just(id)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 6:
				var response = msg.a;
				var _v4 = model.al;
				if (!_v4.$) {
					var _v5 = _v4.a;
					var id = _v5.a;
					var form = _v5.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{al: $elm$core$Maybe$Nothing}),
							A2($author$project$Components$PatientChart$NotesCard$fetchNotes, apiClient, model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Note successfully created')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									al: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var id = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ex: A2($elm$core$Set$remove, id, model.ex),
									kt: $author$project$Api$Data$Loading
								}),
							A2($author$project$Components$PatientChart$NotesCard$fetchNotes, apiClient, model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Note successfully updated')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ex: A2($elm$core$Set$remove, id, model.ex)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 8:
				var response = msg.a;
				var _v8 = model.al;
				if (!_v8.$) {
					var _v9 = _v8.a;
					var id = _v9.a;
					var form = _v9.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{al: $elm$core$Maybe$Nothing}),
							A2($author$project$Components$PatientChart$NotesCard$fetchNotes, apiClient, model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Note successfully updated')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									al: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var id = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ei: A2($elm$core$Set$remove, id, model.ei),
									kt: $author$project$Api$Data$Loading
								}),
							A2($author$project$Components$PatientChart$NotesCard$fetchNotes, apiClient, model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Note successfully deleted')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ei: A2($elm$core$Set$remove, id, model.ei)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 10:
				var id = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							jg: $elm$core$Maybe$Nothing,
							ei: A2($elm$core$Set$insert, id, model.ei)
						}),
					A4(
						$author$project$Api$Provider$Note$delete,
						apiClient,
						model.ks,
						id,
						$author$project$Components$PatientChart$NotesCard$NoteDeleted(id)),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{jg: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 11:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{al: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 12:
				var form = msg.a;
				var id = msg.b;
				var _v12 = A2($author$project$Utils$Form$validate, $author$project$Components$PatientChart$NotesCard$formFieldsValidator, form);
				if (!_v12.$) {
					var _v13 = _v12.a;
					var newForm = _v13.a;
					var validFormFields = _v13.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								al: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, $author$project$Api$Data$Loading))
							}),
						A4($author$project$Components$PatientChart$NotesCard$saveNote, apiClient, model.ks, id, validFormFields),
						_List_Nil);
				} else {
					var newForm = _v12.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								al: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 13:
				var subMsg = msg.a;
				var _v14 = A2($author$project$Ui$Dropdown$update, subMsg, model.nM);
				var dropdown = _v14.a;
				var dropdownCmd = _v14.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nM: dropdown}),
					dropdownCmd,
					_List_Nil);
			case 14:
				var flagged = msg.a;
				var newModel = _Utils_update(
					model,
					{HN: flagged});
				return _Utils_Tuple3(
					newModel,
					$author$project$Components$PatientChart$NotesCard$updateUrl(newModel),
					_List_Nil);
			default:
				var noteId = msg.a;
				var subMsg = msg.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aZ: A3(
								$elm$core$Dict$update,
								noteId,
								$elm$core$Maybe$map(
									$author$project$Ui$FlyoutMenu$update(subMsg)),
								model.aZ)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
		}
	});
var $author$project$Components$PatientChart$PatientInfoCard$GotPlainSsn = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$PatientChart$PatientInfoCard$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var _v2 = model.aS;
				if (!_v2.$) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{aS: $author$project$Api$Data$Loading, aX: true}),
						A3($author$project$Api$Provider$SocialSecurityNumber$retrieve, apiClient, model.YZ, $author$project$Components$PatientChart$PatientInfoCard$GotPlainSsn),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{aX: !model.aX}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 1:
				var data = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aS: data}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(data));
			case 2:
				var value = msg.a;
				return _Utils_Tuple3(
					model,
					$author$project$Ports$Clipboard$copy(value),
					_List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 3, 'Copied to clipboard')
						]));
			default:
				var subMsg = msg.a;
				var _v3 = model.iw;
				if (!_v3.$) {
					var auditTrailLog = _v3.a;
					var result = A3($author$project$Components$AuditTrailLog$update, apiClient, subMsg, auditTrailLog);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								iw: $elm$core$Maybe$Just(result.aiO)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$PatientChart$PatientInfoCard$AuditTrailLogMsg, result.GZ),
						result.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Components$PaymentMethodsCard$Deleted = F2(
	function (a, b) {
		return {$: 20, a: a, b: b};
	});
var $author$project$Components$PaymentMethodsCard$GotPatientResponse = function (a) {
	return {$: 23, a: a};
};
var $author$project$Components$PaymentMethodsCard$GotRequestPaymentInfo = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$PaymentMethodsCard$MadeDefault = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$OutMsg$PatientUpdated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$PaymentMethodsCard$formFieldsFromSource = function (source) {
	var cardFields = function () {
		if (!source.$) {
			return $elm$core$Maybe$Just(
				{
					ag3: $author$project$Api$Source$expMonth(source),
					ag4: $author$project$Api$Source$expYear(source),
					vv: A2(
						$elm$core$Maybe$withDefault,
						'',
						$author$project$Api$Source$zip(source))
				});
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	return {
		GS: cardFields,
		aih: $author$project$Api$Source$label(source)
	};
};
var $author$project$Components$PaymentMethodsCard$cardFormFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 1:
				var month = field.a;
				return _Utils_update(
					fields,
					{
						ag3: $elm$core$String$toInt(month)
					});
			case 2:
				var year = field.a;
				return _Utils_update(
					fields,
					{
						ag4: $elm$core$String$toInt(year)
					});
			case 3:
				var string = field.a;
				return _Utils_update(
					fields,
					{vv: string});
			default:
				return fields;
		}
	});
var $author$project$Components$PaymentMethodsCard$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var string = field.a;
			return _Utils_update(
				fields,
				{
					aih: $author$project$Utils$String$toMaybe(string)
				});
		} else {
			var _v1 = fields.GS;
			if (_v1.$ === 1) {
				return fields;
			} else {
				var cardFields = _v1.a;
				return _Utils_update(
					fields,
					{
						GS: $elm$core$Maybe$Just(
							A2($author$project$Components$PaymentMethodsCard$cardFormFieldsUpdate, field, cardFields))
					});
			}
		}
	});
var $author$project$Components$PaymentMethodsCard$ExpirationDateValidation = 1;
var $author$project$Components$PaymentMethodsCard$expDateValidator = F2(
	function (currentDate, fields) {
		var _v0 = fields.GS;
		if (_v0.$ === 1) {
			return _List_Nil;
		} else {
			var cardFields = _v0.a;
			var invalid = _Utils_Tuple2(1, 'Please enter a future expiration date.');
			var _v1 = _Utils_Tuple2(cardFields.ag4, cardFields.ag3);
			if ((!_v1.a.$) && (!_v1.b.$)) {
				var expYear = _v1.a.a;
				var expMonth = _v1.b.a;
				var currentYear = $justinmimbs$date$Date$year(currentDate);
				var currentMonth = $justinmimbs$date$Date$monthNumber(currentDate);
				return ((_Utils_cmp(expYear, currentYear) < 0) || (_Utils_eq(expYear, currentYear) && (_Utils_cmp(expMonth, currentMonth) < 0))) ? _List_fromArray(
					[invalid]) : _List_Nil;
			} else {
				return _List_fromArray(
					[invalid]);
			}
		}
	});
var $author$project$Components$PaymentMethodsCard$ZipValidation = 0;
var $author$project$Components$PaymentMethodsCard$zipValidator = function (fields) {
	var _v0 = fields.GS;
	if (_v0.$ === 1) {
		return _List_Nil;
	} else {
		var cardFields = _v0.a;
		var zipLength = $elm$core$String$length(cardFields.vv);
		return ((zipLength === 5) || (zipLength === 9)) ? _List_Nil : _List_fromArray(
			[
				_Utils_Tuple2(0, 'Please enter a valid zip code.')
			]);
	}
};
var $author$project$Components$PaymentMethodsCard$formFieldsValidator = function (currentDate) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$PaymentMethodsCard$zipValidator),
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$PaymentMethodsCard$expDateValidator(currentDate))
			]));
};
var $author$project$Components$AuditTrailLog$open = F2(
	function (apiClient, model) {
		return $author$project$Ui$Popover$isOpen(model.aT) ? {GZ: $elm$core$Platform$Cmd$none, aiO: model, aR: _List_Nil} : A3($author$project$Components$AuditTrailLog$update, apiClient, $author$project$Components$AuditTrailLog$Toggle, model);
	});
var $author$project$Components$PaymentMethodsCard$Updated = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Components$PaymentMethodsCard$updateSourceCmd = F5(
	function (patientId, apiClient, session, source, validFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(validFields);
		return A6(
			$author$project$Api$Source$update,
			$author$project$Components$PaymentMethodsCard$patientPath(patientId),
			apiClient,
			session,
			source,
			fields,
			$author$project$Components$PaymentMethodsCard$Updated(source));
	});
var $author$project$Components$PaymentMethodsCard$update = F4(
	function (apiClient, sessionData, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var data = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{rC: data}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(data));
			case 1:
				var data = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{rs: data}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(data));
			case 2:
				var subMsg = msg.a;
				var result = A3($author$project$Components$CreatePaymentMethodModal$update, apiClient, subMsg, model.i_);
				var _v2 = function () {
					var _v3 = _Utils_Tuple2(result.agZ, sessionData);
					if ((!_v3.a) && (_v3.b.$ === 3)) {
						var _v4 = _v3.a;
						var _v5 = _v3.b;
						var session = _v5.a;
						return _Utils_Tuple3(
							$author$project$Api$Data$Loading,
							$author$project$Api$Data$Loading,
							A3($author$project$Components$PaymentMethodsCard$loadSources, model.YZ, apiClient, session));
					} else {
						return _Utils_Tuple3(model.rC, model.rs, $elm$core$Platform$Cmd$none);
					}
				}();
				var cards = _v2.a;
				var bankAccounts = _v2.b;
				var reloadCmd = _v2.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{rs: bankAccounts, rC: cards, i_: result.aiO}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentMethodsCard$CreatePaymentMethodModalMsg, result.GZ),
								reloadCmd
							])),
					result.aR);
			case 3:
				var subMsg = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							nN: A2($author$project$Ui$FlyoutMenu$update, subMsg, model.nN)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var subMsg = msg.a;
				var _v6 = model.iw;
				if (!_v6.$) {
					var auditTrailLog = _v6.a;
					var result = A3($author$project$Components$AuditTrailLog$update, apiClient, subMsg, auditTrailLog);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								iw: $elm$core$Maybe$Just(result.aiO)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentMethodsCard$AuditTrailLogMsg, result.GZ),
						result.aR);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				var subMsg = msg.a;
				var result = A3($author$project$Components$MovePaymentMethodsModal$update, apiClient, subMsg, model.gY);
				var _v7 = function () {
					var _v8 = _Utils_Tuple2(result.agZ, sessionData);
					if ((!_v8.a) && (_v8.b.$ === 3)) {
						var _v9 = _v8.a;
						var _v10 = _v8.b;
						var session = _v10.a;
						return _Utils_Tuple3(
							$author$project$Api$Data$Loading,
							$author$project$Api$Data$Loading,
							A3($author$project$Components$PaymentMethodsCard$loadSources, model.YZ, apiClient, session));
					} else {
						return _Utils_Tuple3(model.rC, model.rs, $elm$core$Platform$Cmd$none);
					}
				}();
				var cards = _v7.a;
				var bankAccounts = _v7.b;
				var reloadCmd = _v7.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{rs: bankAccounts, rC: cards, gY: result.aiO}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentMethodsCard$MovePaymentMethodsModalMsg, result.GZ),
								reloadCmd
							])),
					result.aR);
			case 6:
				var data = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{kA: data}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(data));
			case 7:
				var _v11 = model.iw;
				if (!_v11.$) {
					var auditTrailLog = _v11.a;
					var result = A2($author$project$Components$AuditTrailLog$open, apiClient, auditTrailLog);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								iw: $elm$core$Maybe$Just(result.aiO),
								nN: A2($author$project$Ui$FlyoutMenu$init, $author$project$Components$PaymentMethodsCard$flyoutMenuId, $author$project$Components$PaymentMethodsCard$FlyoutMenuMsg)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentMethodsCard$AuditTrailLogMsg, result.GZ),
						result.aR);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								nN: A2($author$project$Ui$FlyoutMenu$init, $author$project$Components$PaymentMethodsCard$flyoutMenuId, $author$project$Components$PaymentMethodsCard$FlyoutMenuMsg)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 8:
				var patient = msg.a;
				if (sessionData.$ === 3) {
					var session = sessionData.a;
					var result = A4(
						$author$project$Components$MovePaymentMethodsModal$openAndInit,
						apiClient,
						$author$project$Components$PaymentMethodsCard$patientPath(model.YZ),
						session,
						patient);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								nN: A2($author$project$Ui$FlyoutMenu$init, $author$project$Components$PaymentMethodsCard$flyoutMenuId, $author$project$Components$PaymentMethodsCard$FlyoutMenuMsg),
								gY: result.aiO
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentMethodsCard$MovePaymentMethodsModalMsg, result.GZ),
						result.aR);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								nN: A2($author$project$Ui$FlyoutMenu$init, $author$project$Components$PaymentMethodsCard$flyoutMenuId, $author$project$Components$PaymentMethodsCard$FlyoutMenuMsg)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 9:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							nN: A2($author$project$Ui$FlyoutMenu$init, $author$project$Components$PaymentMethodsCard$flyoutMenuId, $author$project$Components$PaymentMethodsCard$FlyoutMenuMsg),
							hA: true
						}),
					A4($author$project$Api$Provider$Patient$requestPaymentInfo, apiClient, model.YZ, $elm$core$Maybe$Nothing, $author$project$Components$PaymentMethodsCard$GotRequestPaymentInfo),
					_List_Nil);
			case 10:
				var response = msg.a;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{hA: false}),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Payment info request sent successfully.'),
									$author$project$OutMsg$RetrievePatient(model.YZ)
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{hA: false}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 11:
				var source = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							x: $elm$core$Maybe$Just(
								{
									SD: $author$project$Utils$Form$init(
										$author$project$Components$PaymentMethodsCard$formFieldsFromSource(source)),
									s5: false,
									k9: $author$project$Api$Data$NotAsked,
									JQ: source
								})
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 12:
				var _v14 = model.x;
				if (!_v14.$) {
					var editing = _v14.a;
					return _Utils_eq(editing.k9, $author$project$Api$Data$Loading) ? _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil) : _Utils_Tuple3(
						_Utils_update(
							model,
							{x: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 13:
				var field = msg.a;
				var _v15 = model.x;
				if (!_v15.$) {
					var editing = _v15.a;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$PaymentMethodsCard$formFieldsUpdate, field, editing.SD);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								x: $elm$core$Maybe$Just(
									_Utils_update(
										editing,
										{SD: newForm}))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 14:
				var makeDefault = msg.a;
				var _v16 = model.x;
				if (!_v16.$) {
					var editing = _v16.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								x: $elm$core$Maybe$Just(
									_Utils_update(
										editing,
										{s5: makeDefault}))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 15:
				var _v17 = _Utils_Tuple2(model.x, sessionData);
				if ((!_v17.a.$) && (_v17.b.$ === 3)) {
					var editing = _v17.a.a;
					var _v18 = _v17.b;
					var session = _v18.a;
					var validator = $author$project$Components$PaymentMethodsCard$formFieldsValidator(model.dd);
					var _v19 = A2($author$project$Utils$Form$validate, validator, editing.SD);
					if (!_v19.$) {
						var _v20 = _v19.a;
						var newForm = _v20.a;
						var validFields = _v20.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									x: $elm$core$Maybe$Just(
										_Utils_update(
											editing,
											{SD: newForm, k9: $author$project$Api$Data$Loading}))
								}),
							A5($author$project$Components$PaymentMethodsCard$updateSourceCmd, model.YZ, apiClient, session, editing.JQ, validFields),
							_List_Nil);
					} else {
						var newForm = _v19.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									x: $elm$core$Maybe$Just(
										_Utils_update(
											editing,
											{SD: newForm, k9: $author$project$Api$Data$NotAsked}))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 16:
				var source = msg.a;
				var response = msg.b;
				var _v21 = _Utils_Tuple3(response, model.x, sessionData);
				_v21$2:
				while (true) {
					if (!_v21.b.$) {
						switch (_v21.a.$) {
							case 3:
								if (_v21.c.$ === 3) {
									var _v22 = _v21.a;
									var editing = _v21.b.a;
									var _v23 = _v21.c;
									var session = _v23.a;
									var shouldMakeDefault = editing.s5 && (!$author$project$Api$Source$default(source));
									if (shouldMakeDefault) {
										var sourceId = $author$project$Api$Source$id(source);
										return _Utils_Tuple3(
											_Utils_update(
												model,
												{
													J: A2($elm$core$Set$insert, sourceId, model.J)
												}),
											A6(
												$author$project$Api$Source$updateDefault,
												$author$project$Components$PaymentMethodsCard$patientPath(model.YZ),
												apiClient,
												session,
												source,
												$elm$core$Maybe$Nothing,
												$author$project$Components$PaymentMethodsCard$MadeDefault(sourceId)),
											_List_Nil);
									} else {
										return _Utils_Tuple3(
											_Utils_update(
												model,
												{rs: $author$project$Api$Data$Loading, rC: $author$project$Api$Data$Loading, x: $elm$core$Maybe$Nothing}),
											A3($author$project$Components$PaymentMethodsCard$loadSources, model.YZ, apiClient, session),
											_List_fromArray(
												[
													A2($author$project$OutMsg$ShowToast, 3, 'Source successfully updated.')
												]));
									}
								} else {
									break _v21$2;
								}
							case 2:
								var editing = _v21.b.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											x: $elm$core$Maybe$Just(
												_Utils_update(
													editing,
													{k9: response}))
										}),
									$elm$core$Platform$Cmd$none,
									$author$project$OutMsg$handleErrorResponse(response));
							default:
								break _v21$2;
						}
					} else {
						break _v21$2;
					}
				}
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
			case 17:
				var sourceId = msg.a;
				var response = msg.b;
				var _v24 = _Utils_Tuple2(response, sessionData);
				_v24$2:
				while (true) {
					switch (_v24.a.$) {
						case 3:
							if (_v24.b.$ === 3) {
								var _v25 = _v24.a;
								var _v26 = _v24.b;
								var session = _v26.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											rs: $author$project$Api$Data$Loading,
											rC: $author$project$Api$Data$Loading,
											x: $elm$core$Maybe$Nothing,
											J: A2($elm$core$Set$remove, sourceId, model.J)
										}),
									A3($author$project$Components$PaymentMethodsCard$loadSources, model.YZ, apiClient, session),
									_List_fromArray(
										[
											A2($author$project$OutMsg$ShowToast, 3, 'Source successfully updated.')
										]));
							} else {
								break _v24$2;
							}
						case 2:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										x: $elm$core$Maybe$Nothing,
										J: A2($elm$core$Set$remove, sourceId, model.J)
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$OutMsg$handleErrorResponse(response));
						default:
							break _v24$2;
					}
				}
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
			case 18:
				var source = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							gc: $elm$core$Maybe$Just(source)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 19:
				var source = msg.a;
				var confirmed = msg.b;
				var _v27 = _Utils_Tuple2(confirmed, sessionData);
				if (_v27.a && (_v27.b.$ === 3)) {
					var _v28 = _v27.b;
					var session = _v28.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								gc: $elm$core$Maybe$Nothing,
								J: A2(
									$elm$core$Set$insert,
									$author$project$Api$Source$id(source),
									model.J)
							}),
						A5(
							$author$project$Api$Source$delete,
							$author$project$Components$PaymentMethodsCard$patientPath(model.YZ),
							apiClient,
							session,
							source,
							$author$project$Components$PaymentMethodsCard$Deleted(source)),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{gc: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 20:
				var source = msg.a;
				var response = msg.b;
				var _v29 = _Utils_Tuple2(response, sessionData);
				_v29$2:
				while (true) {
					switch (_v29.a.$) {
						case 3:
							if (_v29.b.$ === 3) {
								var _v30 = _v29.a;
								var _v31 = _v29.b;
								var session = _v31.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											rs: $author$project$Api$Data$Loading,
											rC: $author$project$Api$Data$Loading,
											J: A2(
												$elm$core$Set$remove,
												$author$project$Api$Source$id(source),
												model.J)
										}),
									A3($author$project$Components$PaymentMethodsCard$loadSources, model.YZ, apiClient, session),
									_List_fromArray(
										[
											A2($author$project$OutMsg$ShowToast, 3, 'Source successfully deleted'),
											$author$project$OutMsg$RetrievePatient(model.YZ)
										]));
							} else {
								break _v29$2;
							}
						case 2:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										J: A2(
											$elm$core$Set$remove,
											$author$project$Api$Source$id(source),
											model.J)
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$OutMsg$handleErrorResponse(response));
						default:
							break _v29$2;
					}
				}
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
			case 21:
				var newValue = msg.a;
				return _Utils_Tuple3(
					model,
					A4($author$project$Api$Provider$Patient$updateAutopay, apiClient, model.YZ, newValue, $author$project$Components$PaymentMethodsCard$GotPatientResponse),
					_List_Nil);
			case 22:
				var newValue = msg.a;
				return _Utils_Tuple3(
					model,
					A4($author$project$Api$Provider$Patient$updateExemptFromCreditCardFees, apiClient, model.YZ, newValue, $author$project$Components$PaymentMethodsCard$GotPatientResponse),
					_List_Nil);
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								$author$project$OutMsg$PatientUpdated(response)
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Layouts$Patient$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var navMsg = msg.a;
				return A2(
					$author$project$Utils$Tuple3$fromTuple2,
					_List_Nil,
					A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Platform$Cmd$map($author$project$Layouts$Patient$NavMsg),
						A2(
							$elm$core$Tuple$mapFirst,
							function (newNav) {
								return _Utils_update(
									model,
									{kp: newNav});
							},
							A2($author$project$Ui$Nav$update, navMsg, model.kp))));
			case 1:
				var _v1 = model.kq;
				if (!_v1.$) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{kq: $author$project$Api$Data$Loading}),
						A3($author$project$Api$Provider$SyncDetail$retrieveNetwork, apiClient, model.YZ, $author$project$Layouts$Patient$GotNetworkSyncDetail),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var _v2 = model.io;
				if (!_v2.$) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{io: $author$project$Api$Data$Loading}),
						A4($author$project$Api$Provider$SyncDetail$retrieveAffiliate, apiClient, model.YZ, $elm$core$Basics$identity, $author$project$Layouts$Patient$GotAffiliateSyncDetail),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				var data = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{kq: data}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(data));
			case 4:
				var data = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{io: data}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(data));
			case 5:
				var organization = msg.a;
				var patientId = msg.b;
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					_List_fromArray(
						[
							A3(
							$author$project$OutMsg$SwitchToOrganization,
							$author$project$Api$Provider$Organization$Shared$id(organization),
							$elm$core$Maybe$Nothing,
							$author$project$OutMsg$GoToRouteAndReloadAction(
								$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
									{YZ: patientId})))
						]));
			case 6:
				var data = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{WR: data}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(data));
			case 7:
				var subMsg = msg.a;
				var _v3 = A4($author$project$Components$PaymentMethodsCard$update, apiClient, model.aa4, subMsg, model.eQ);
				var paymentMethodsCard = _v3.a;
				var cmd = _v3.b;
				var outMsgs = _v3.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{eQ: paymentMethodsCard}),
					A2($elm$core$Platform$Cmd$map, $author$project$Layouts$Patient$PaymentMethodsCardMsg, cmd),
					outMsgs);
			case 8:
				var subMsg = msg.a;
				var _v4 = model.eM;
				if (!_v4.$) {
					var card = _v4.a;
					var _v5 = A3($author$project$Components$PatientChart$NotesCard$update, apiClient, subMsg, card);
					var newCard = _v5.a;
					var cardCmd = _v5.b;
					var cardOutMsg = _v5.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								eM: $elm$core$Maybe$Just(newCard)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Layouts$Patient$NotesCardMsg, cardCmd),
						cardOutMsg);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var subMsg = msg.a;
				var _v6 = A3($author$project$Components$PatientChart$PatientInfoCard$update, apiClient, subMsg, model.eO);
				var patientInfoCard = _v6.a;
				var cmd = _v6.b;
				var outMsgs = _v6.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{eO: patientInfoCard}),
					A2($elm$core$Platform$Cmd$map, $author$project$Layouts$Patient$PatientInfoCardMsg, cmd),
					outMsgs);
		}
	});
var $author$project$Layouts$User$update = F2(
	function (msg, model) {
		var navMsg = msg;
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map($elm$core$Basics$identity),
			A2(
				$elm$core$Tuple$mapFirst,
				function (nav) {
					return {kp: nav};
				},
				A2($author$project$Ui$Nav$update, navMsg, model.kp)));
	});
var $author$project$Spa$Layout$update = F3(
	function (apiClient, msg, model) {
		var _v0 = _Utils_Tuple2(model, msg);
		_v0$21:
		while (true) {
			switch (_v0.a.$) {
				case 5:
					if (!_v0.b.$) {
						var _v1 = _v0.a;
						var id = _v1.a;
						var layoutModel = _v1.b;
						var subMsg = _v0.b.a;
						return A2(
							$author$project$Utils$Tuple3$mapSecond,
							$elm$core$Platform$Cmd$map($author$project$Spa$Layout$CommissionsBrokerAccountMsg),
							A2(
								$author$project$Utils$Tuple3$mapFirst,
								$author$project$Spa$Layout$CommissionsBrokerAccountModel(id),
								A2($author$project$Layouts$Commissions$BrokerAccount$update, subMsg, layoutModel)));
					} else {
						break _v0$21;
					}
				case 7:
					if (_v0.b.$ === 1) {
						var _v2 = _v0.a;
						var id = _v2.a;
						var layoutModel = _v2.b;
						var subMsg = _v0.b.a;
						return A2(
							$author$project$Utils$Tuple3$mapSecond,
							$elm$core$Platform$Cmd$map($author$project$Spa$Layout$AffiliatesAffiliateMsg),
							A2(
								$author$project$Utils$Tuple3$mapFirst,
								$author$project$Spa$Layout$AffiliatesAffiliateModel(id),
								A2($author$project$Layouts$Affiliates$Affiliate$update, subMsg, layoutModel)));
					} else {
						break _v0$21;
					}
				case 8:
					if (_v0.b.$ === 2) {
						var layoutModel = _v0.a.a;
						var subMsg = _v0.b.a;
						return A2(
							$author$project$Utils$Tuple3$mapSecond,
							$elm$core$Platform$Cmd$map($author$project$Spa$Layout$PartnerBillingMsg),
							A2(
								$author$project$Utils$Tuple3$mapFirst,
								$author$project$Spa$Layout$PartnerBillingModel,
								A2($author$project$Layouts$Partner$Billing$update, subMsg, layoutModel)));
					} else {
						break _v0$21;
					}
				case 9:
					if (_v0.b.$ === 3) {
						var layoutModel = _v0.a.a;
						var subMsg = _v0.b.a;
						return A2(
							$author$project$Utils$Tuple3$mapSecond,
							$elm$core$Platform$Cmd$map($author$project$Spa$Layout$PartnerPracticesMsg),
							A2(
								$author$project$Utils$Tuple3$mapFirst,
								$author$project$Spa$Layout$PartnerPracticesModel,
								A2($author$project$Layouts$Partner$Practices$update, subMsg, layoutModel)));
					} else {
						break _v0$21;
					}
				case 10:
					if (_v0.b.$ === 4) {
						var layoutModel = _v0.a.a;
						var subMsg = _v0.b.a;
						return A2(
							$author$project$Utils$Tuple3$mapSecond,
							$elm$core$Platform$Cmd$map($author$project$Spa$Layout$PartnerProductMsg),
							A2(
								$author$project$Utils$Tuple3$mapFirst,
								$author$project$Spa$Layout$PartnerProductModel,
								A2($author$project$Layouts$Partner$Product$update, subMsg, layoutModel)));
					} else {
						break _v0$21;
					}
				case 11:
					if (_v0.b.$ === 5) {
						var layoutModel = _v0.a.a;
						var subMsg = _v0.b.a;
						return A2(
							$author$project$Utils$Tuple3$mapSecond,
							$elm$core$Platform$Cmd$map($author$project$Spa$Layout$PartnerWebhooksMsg),
							A2(
								$author$project$Utils$Tuple3$mapFirst,
								$author$project$Spa$Layout$PartnerWebhooksModel,
								A2($author$project$Layouts$Partner$Webhooks$update, subMsg, layoutModel)));
					} else {
						break _v0$21;
					}
				case 12:
					if (_v0.b.$ === 6) {
						var _v3 = _v0.a;
						var slug = _v3.a;
						var layoutModel = _v3.b;
						var subMsg = _v0.b.a;
						return A2(
							$author$project$Utils$Tuple3$mapSecond,
							$elm$core$Platform$Cmd$map($author$project$Spa$Layout$MarketplaceManageMsg),
							A2(
								$author$project$Utils$Tuple3$mapFirst,
								$author$project$Spa$Layout$MarketplaceManageModel(slug),
								A2($author$project$Layouts$Marketplace$Manage$update, subMsg, layoutModel)));
					} else {
						break _v0$21;
					}
				case 14:
					if (_v0.b.$ === 11) {
						var layout = _v0.a.a;
						var layoutMsg = _v0.b.a;
						return A2(
							$author$project$Utils$Tuple3$mapSecond,
							$elm$core$Platform$Cmd$map($author$project$Spa$Layout$AdminMsg),
							A2(
								$author$project$Utils$Tuple3$mapFirst,
								$author$project$Spa$Layout$AdminModel,
								A2($author$project$Layouts$Admin$update, layoutMsg, layout)));
					} else {
						break _v0$21;
					}
				case 0:
					var _v4 = _v0.a;
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				case 18:
					var _v5 = _v0.a;
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				case 1:
					var _v6 = _v0.a;
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				case 3:
					if (_v0.b.$ === 7) {
						var _v7 = _v0.a;
						var id = _v7.a;
						var layoutModel = _v7.b;
						var patMsg = _v0.b.a;
						return A2(
							$author$project$Utils$Tuple3$mapSecond,
							$elm$core$Platform$Cmd$map($author$project$Spa$Layout$PatientMsg),
							A2(
								$author$project$Utils$Tuple3$mapFirst,
								$author$project$Spa$Layout$PatientAndSidebarModel(id),
								A3($author$project$Layouts$Patient$update, apiClient, patMsg, layoutModel)));
					} else {
						var _v8 = _v0.a;
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				case 2:
					var _v9 = _v0.a;
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				case 13:
					if (_v0.b.$ === 8) {
						var _v10 = _v0.a;
						var id = _v10.a;
						var layout = _v10.b;
						var layoutMsg = _v0.b.a;
						return A2(
							$author$project$Utils$Tuple3$fromTuple2,
							_List_Nil,
							A2(
								$elm$core$Tuple$mapSecond,
								$elm$core$Platform$Cmd$map($author$project$Spa$Layout$CompanyMsg),
								A2(
									$elm$core$Tuple$mapFirst,
									$author$project$Spa$Layout$CompanyModel(id),
									A2($author$project$Layouts$Company$update, layoutMsg, layout))));
					} else {
						break _v0$21;
					}
				case 4:
					if (_v0.b.$ === 9) {
						var layout = _v0.a.a;
						var layoutMsg = _v0.b.a;
						return A2(
							$author$project$Utils$Tuple3$fromTuple2,
							_List_Nil,
							A2(
								$elm$core$Tuple$mapSecond,
								$elm$core$Platform$Cmd$map($author$project$Spa$Layout$CommissionsMsg),
								A2(
									$elm$core$Tuple$mapFirst,
									$author$project$Spa$Layout$CommissionsModel,
									A2($author$project$Layouts$Commissions$update, layoutMsg, layout))));
					} else {
						break _v0$21;
					}
				case 6:
					if (_v0.b.$ === 10) {
						var layout = _v0.a.a;
						var layoutMsg = _v0.b.a;
						return A2(
							$author$project$Utils$Tuple3$fromTuple2,
							_List_Nil,
							A2(
								$elm$core$Tuple$mapSecond,
								$elm$core$Platform$Cmd$map($author$project$Spa$Layout$AffiliatesMsg),
								A2(
									$elm$core$Tuple$mapFirst,
									$author$project$Spa$Layout$AffiliatesModel,
									A2($author$project$Layouts$Affiliates$update, layoutMsg, layout))));
					} else {
						break _v0$21;
					}
				case 19:
					if (_v0.b.$ === 12) {
						var layout = _v0.a.a;
						var layoutMsg = _v0.b.a;
						return A2(
							$author$project$Utils$Tuple3$fromTuple2,
							_List_Nil,
							A2(
								$elm$core$Tuple$mapSecond,
								$elm$core$Platform$Cmd$map($author$project$Spa$Layout$UserMsg),
								A2(
									$elm$core$Tuple$mapFirst,
									$author$project$Spa$Layout$UserModel,
									A2($author$project$Layouts$User$update, layoutMsg, layout))));
					} else {
						break _v0$21;
					}
				case 15:
					var _v11 = _v0.a;
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				case 16:
					var _v12 = _v0.a;
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				case 17:
					var _v13 = _v0.a;
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				default:
					break _v0$21;
			}
		}
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Layouts$Admin$load = F2(
	function (shared, model) {
		var _v0 = _Utils_Tuple2(model.s6, shared.ZV);
		if (((!_v0.a.$) && (_v0.b.$ === 3)) && (!_v0.b.a.$)) {
			var _v1 = _v0.a;
			var _v2 = _v0.b;
			var practice_ = _v2.a.a;
			return $author$project$Api$Provider$Practice$One$hasManagedPartner(practice_) ? _Utils_Tuple2(
				_Utils_update(
					model,
					{s6: $author$project$Api$Data$Loading}),
				A2($author$project$Api$Provider$ManagedPartner$retrieve, shared.Gv, $author$project$Layouts$Admin$GotManagedPartner)) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Layouts$Affiliates$load = function (model) {
	return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
};
var $author$project$Layouts$Affiliates$Affiliate$load = function (model) {
	return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
};
var $author$project$Layouts$Commissions$load = function (model) {
	return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
};
var $author$project$Layouts$Commissions$BrokerAccount$load = function (model) {
	return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
};
var $author$project$Layouts$Company$load = function (model) {
	return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
};
var $author$project$Layouts$Marketplace$Manage$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Layouts$Partner$Billing$load = function (model) {
	return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
};
var $author$project$Layouts$Partner$Practices$load = function (model) {
	return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
};
var $author$project$Layouts$Partner$Product$load = function (model) {
	return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
};
var $author$project$Layouts$Partner$Webhooks$load = function (model) {
	return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
};
var $author$project$Components$PatientChart$PatientInfoCard$load = F2(
	function (shared, _v0) {
		var model = _v0;
		var ssnState = function () {
			var _v2 = shared.G9;
			if (_v2.$ === 3) {
				var patient = _v2.a;
				var newMasked = A2(
					$elm$core$Maybe$andThen,
					$author$project$Api$Common$SocialSecurityNumber$Masked$maskedNumber,
					$author$project$Api$Provider$Patient$One$ssn(patient));
				return (!_Utils_eq(newMasked, model.cJ)) ? {cJ: newMasked, aS: $author$project$Api$Data$NotAsked, aX: false} : {cJ: model.cJ, aS: model.aS, aX: model.aX};
			} else {
				return {cJ: model.cJ, aS: model.aS, aX: model.aX};
			}
		}();
		var auditTrailLog = function () {
			var _v1 = model.iw;
			if (!_v1.$) {
				var existing = _v1.a;
				return $elm$core$Maybe$Just(existing);
			} else {
				return A2($author$project$Components$PatientChart$PatientInfoCard$buildAuditTrailLog, shared, model.YZ);
			}
		}();
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{iw: auditTrailLog, cJ: ssnState.cJ, aS: ssnState.aS, aX: ssnState.aX}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Components$PaymentMethodsCard$load = F2(
	function (shared, _v0) {
		var model = _v0;
		var modelWithDate = _Utils_update(
			model,
			{dd: shared.dd});
		var _v1 = function () {
			var _v2 = _Utils_Tuple3(shared.aa4, modelWithDate.rC, modelWithDate.rs);
			if (((_v2.a.$ === 3) && (!_v2.b.$)) && (!_v2.c.$)) {
				var _v3 = _v2.a;
				var session = _v3.a;
				var _v4 = _v2.b;
				var _v5 = _v2.c;
				return _Utils_Tuple2(
					_Utils_update(
						modelWithDate,
						{rs: $author$project$Api$Data$Loading, rC: $author$project$Api$Data$Loading}),
					A3($author$project$Components$PaymentMethodsCard$loadSources, modelWithDate.YZ, shared.Gv, session));
			} else {
				return _Utils_Tuple2(modelWithDate, $elm$core$Platform$Cmd$none);
			}
		}();
		var sourcesModel = _v1.a;
		var sourcesCmd = _v1.b;
		var _v6 = function () {
			var _v7 = _Utils_Tuple2(shared.aa4, sourcesModel.kA);
			if ((_v7.a.$ === 3) && (!_v7.b.$)) {
				var _v8 = _v7.a;
				var _v9 = _v7.b;
				return _Utils_Tuple2(
					_Utils_update(
						sourcesModel,
						{kA: $author$project$Api$Data$Loading}),
					A3($author$project$Api$Provider$Patient$PaymentMethod$canMigrate, shared.Gv, sourcesModel.YZ, $author$project$Components$PaymentMethodsCard$GotPaymentSourcesMigratable));
			} else {
				return _Utils_Tuple2(sourcesModel, $elm$core$Platform$Cmd$none);
			}
		}();
		var migratableModel = _v6.a;
		var migratableCmd = _v6.b;
		var auditTrailLog = function () {
			var _v10 = migratableModel.iw;
			if (!_v10.$) {
				return migratableModel.iw;
			} else {
				return A2($author$project$Components$PaymentMethodsCard$initAuditTrailLog, shared, migratableModel.YZ);
			}
		}();
		return _Utils_Tuple2(
			_Utils_update(
				migratableModel,
				{iw: auditTrailLog}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[sourcesCmd, migratableCmd])));
	});
var $author$project$Layouts$Patient$load = F2(
	function (shared, model) {
		var unified = $author$project$Components$PatientChart$Helpers$shouldRenderUnifiedHeader(shared);
		var _v0 = unified ? A2($author$project$Components$PaymentMethodsCard$load, shared, model.eQ) : _Utils_Tuple2(model.eQ, $elm$core$Platform$Cmd$none);
		var paymentMethodsCard = _v0.a;
		var paymentMethodsCardCmd = _v0.b;
		var _v1 = unified ? A2($author$project$Components$PatientChart$PatientInfoCard$load, shared, model.eO) : _Utils_Tuple2(model.eO, $elm$core$Platform$Cmd$none);
		var patientInfoCard = _v1.a;
		var patientInfoCardCmd = _v1.b;
		var _v2 = function () {
			var _v3 = _Utils_Tuple2(unified, model.eM);
			if (_v3.a && (_v3.b.$ === 1)) {
				var _v4 = _v3.b;
				return A2($author$project$Layouts$Patient$initNotesCard, shared, model.YZ);
			} else {
				return _Utils_Tuple2(model.eM, $elm$core$Platform$Cmd$none);
			}
		}();
		var notesCard = _v2.a;
		var notesCardCmd = _v2.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{eM: notesCard, YY: shared.G9, eO: patientInfoCard, eQ: paymentMethodsCard, aa4: shared.aa4}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Layouts$Patient$PaymentMethodsCardMsg, paymentMethodsCardCmd),
						notesCardCmd,
						A2($elm$core$Platform$Cmd$map, $author$project$Layouts$Patient$PatientInfoCardMsg, patientInfoCardCmd)
					])));
	});
var $author$project$Layouts$PatientChart$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Layouts$User$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Spa$Layout$load = F2(
	function (shared, model) {
		switch (model.$) {
			case 5:
				var id = model.a;
				var layoutModel = model.b;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Spa$Layout$CommissionsBrokerAccountMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Spa$Layout$CommissionsBrokerAccountModel(id),
						$author$project$Layouts$Commissions$BrokerAccount$load(layoutModel)));
			case 7:
				var id = model.a;
				var layoutModel = model.b;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Spa$Layout$AffiliatesAffiliateMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Spa$Layout$AffiliatesAffiliateModel(id),
						$author$project$Layouts$Affiliates$Affiliate$load(layoutModel)));
			case 8:
				var layout = model.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Spa$Layout$PartnerBillingMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Spa$Layout$PartnerBillingModel,
						$author$project$Layouts$Partner$Billing$load(layout)));
			case 9:
				var layout = model.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Spa$Layout$PartnerPracticesMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Spa$Layout$PartnerPracticesModel,
						$author$project$Layouts$Partner$Practices$load(layout)));
			case 10:
				var layout = model.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Spa$Layout$PartnerProductMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Spa$Layout$PartnerProductModel,
						$author$project$Layouts$Partner$Product$load(layout)));
			case 11:
				var layout = model.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Spa$Layout$PartnerWebhooksMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Spa$Layout$PartnerWebhooksModel,
						$author$project$Layouts$Partner$Webhooks$load(layout)));
			case 12:
				var slug = model.a;
				var layout = model.b;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Spa$Layout$MarketplaceManageMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Spa$Layout$MarketplaceManageModel(slug),
						A2($author$project$Layouts$Marketplace$Manage$load, shared, layout)));
			case 14:
				var layout = model.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Spa$Layout$AdminMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Spa$Layout$AdminModel,
						A2($author$project$Layouts$Admin$load, shared, layout)));
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 18:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 3:
				var id = model.a;
				var layout = model.b;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Spa$Layout$PatientMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Spa$Layout$PatientAndSidebarModel(id),
						A2($author$project$Layouts$Patient$load, shared, layout)));
			case 2:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 13:
				var id = model.a;
				var layout = model.b;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Spa$Layout$CompanyMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Spa$Layout$CompanyModel(id),
						$author$project$Layouts$Company$load(layout)));
			case 4:
				var layout = model.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Spa$Layout$CommissionsMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Spa$Layout$CommissionsModel,
						$author$project$Layouts$Commissions$load(layout)));
			case 6:
				var layout = model.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Spa$Layout$AffiliatesModel,
					$author$project$Layouts$Affiliates$load(layout));
			case 20:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 19:
				var layout = model.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Spa$Layout$UserMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Spa$Layout$UserModel,
						A2($author$project$Layouts$User$load, shared, layout)));
			case 15:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 16:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			default:
				var id = model.a;
				var layout = model.b;
				return A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Spa$Layout$PatientChartModel(id),
					A2($author$project$Layouts$PatientChart$load, shared, layout));
		}
	});
var $author$project$Layouts$Marketplace$Manage$refresh = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{T8: $author$project$Api$Data$Loading}),
			A3($author$project$Api$Provider$Integration$retrieve, shared.Gv, model.abG, $author$project$Layouts$Marketplace$Manage$GotIntegration));
	});
var $author$project$Spa$Layout$refresh = F2(
	function (shared, model) {
		if (model.$ === 12) {
			var slug = model.a;
			var layout = model.b;
			return A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Platform$Cmd$map($author$project$Spa$Layout$MarketplaceManageMsg),
				A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Spa$Layout$MarketplaceManageModel(slug),
					A2($author$project$Layouts$Marketplace$Manage$refresh, shared, layout)));
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$updateLayout = F3(
	function (shared, outMsgs, layout) {
		var refreshLayout = A2($elm$core$List$member, $author$project$OutMsg$RefreshLayout, outMsgs);
		return function (_v0) {
			var loadedLayout = _v0.a;
			var loadedLayoutCmd = _v0.b;
			return refreshLayout ? A2(
				$elm$core$Tuple$mapSecond,
				function (refreshLayoutCmd) {
					return $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[loadedLayoutCmd, refreshLayoutCmd]));
				},
				A2($author$project$Spa$Layout$refresh, shared, loadedLayout)) : _Utils_Tuple2(loadedLayout, loadedLayoutCmd);
		}(
			A2($author$project$Spa$Layout$load, shared, layout));
	});
var $author$project$Ports$PageTitle$updateTabTitle = _Platform_outgoingPort('updateTabTitle', $elm$json$Json$Encode$string);
var $author$project$Utils$Release$newReleaseAvailable = function (_v0) {
	var model = _v0;
	return model.Br;
};
var $author$project$Ports$Intercom$intercomPortUpdate = _Platform_outgoingPort(
	'intercomPortUpdate',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$Intercom$update = function (session) {
	return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : $author$project$Ports$Intercom$intercomPortUpdate(0);
};
var $author$project$Shared$updateIntercom = function (session) {
	if (session.$ === 3) {
		var session_ = session.a;
		return $author$project$Ports$Intercom$update(session_);
	} else {
		return $elm$core$Platform$Cmd$none;
	}
};
var $author$project$Components$GlobalSearch$urlChanged = F2(
	function (url, model) {
		if (!model.$) {
			var closedModel = model.a;
			return $author$project$Components$GlobalSearch$Closed(
				_Utils_update(
					closedModel,
					{adY: url}));
		} else {
			var openModel = model.a;
			return $author$project$Components$GlobalSearch$Open(
				_Utils_update(
					openModel,
					{adY: url}));
		}
	});
var $author$project$Components$PatientsList$urlChanged = F2(
	function (url, model) {
		return _Utils_update(
			model,
			{adY: url});
	});
var $author$project$Navbars$Company$urlChanged = F2(
	function (url, _v0) {
		var model = _v0;
		var newSelectedNav = $author$project$Navbars$Company$navItemFromUrl(url);
		return _Utils_update(
			model,
			{
				dw: $author$project$Navbars$Company$openSubNavFromSelectedNav(newSelectedNav),
				eZ: A2($author$project$Ui$FlyoutMenu$init, 'profile-menu', $author$project$Navbars$Company$ProfileMenuMsg),
				fd: newSelectedNav
			});
	});
var $author$project$Navbars$Partner$urlChanged = F2(
	function (url, _v0) {
		var model = _v0;
		var newSelectedNav = $author$project$Navbars$Partner$navItemFromUrl(url);
		return _Utils_update(
			model,
			{
				dw: $author$project$Navbars$Partner$openSubNavFromSelectedNav(newSelectedNav),
				eZ: A2($author$project$Ui$FlyoutMenu$init, 'profile-menu', $author$project$Navbars$Partner$ProfileMenuMsg),
				fd: newSelectedNav
			});
	});
var $author$project$Navbars$Practice$urlChanged = F2(
	function (url, _v0) {
		var model = _v0;
		var newSelectedNav = $author$project$Navbars$Practice$Navigation$navItemFromUrl(url);
		return $author$project$Navbars$Practice$closeBookmarkedMenu(
			_Utils_update(
				model,
				{
					dw: $author$project$Navbars$Practice$openSubNavFromSelectedNav(newSelectedNav),
					eZ: A2($author$project$Ui$FlyoutMenu$init, 'profile-menu', $author$project$Navbars$Practice$ProfileMenuMsg),
					fd: newSelectedNav
				}));
	});
var $author$project$Navbar$navbarUrlChanged = F2(
	function (url, navBar) {
		switch (navBar.$) {
			case 0:
				return navBar;
			case 1:
				var model = navBar.a;
				return $author$project$Navbar$PracticeNav(
					A2($author$project$Navbars$Practice$urlChanged, url, model));
			case 2:
				var model = navBar.a;
				return $author$project$Navbar$CompanyNav(
					A2($author$project$Navbars$Company$urlChanged, url, model));
			default:
				var model = navBar.a;
				return $author$project$Navbar$PartnerNav(
					A2($author$project$Navbars$Partner$urlChanged, url, model));
		}
	});
var $author$project$Navbar$urlChanged = F2(
	function (url, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				ai: A2($author$project$Navbar$navbarUrlChanged, url, model.ai),
				adY: url
			});
	});
var $author$project$Shared$urlChanged = F2(
	function (url, model) {
		var session = $author$project$Api$Data$toMaybe(model.aa4);
		var shouldInitNavbar = (!_Utils_eq(session, $elm$core$Maybe$Nothing)) && _Utils_eq(model.aj, $elm$core$Maybe$Nothing);
		var _v0 = shouldInitNavbar ? $author$project$Shared$initNavbar(
			_Utils_Tuple2(
				_Utils_update(
					model,
					{adY: url}),
				$elm$core$Platform$Cmd$none)) : _Utils_Tuple2(
			_Utils_update(
				model,
				{adY: url}),
			$elm$core$Platform$Cmd$none);
		var modelUpdated = _v0.a;
		var navBarResultCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				modelUpdated,
				{
					gw: A2($author$project$Components$GlobalSearch$urlChanged, url, modelUpdated.gw),
					aj: A2(
						$elm$core$Maybe$map,
						$author$project$Navbar$urlChanged(url),
						modelUpdated.aj),
					ajU: A2(
						$elm$core$Maybe$map,
						$author$project$Components$PatientsList$urlChanged(url),
						model.ajU),
					ajY: $elm$core$Maybe$Nothing,
					Zn: $elm$core$Maybe$Nothing
				}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						((!_Utils_eq(model.adY.YX, url.YX)) && $author$project$Utils$Release$newReleaseAvailable(model.akL)) ? $elm$browser$Browser$Navigation$reload : $elm$core$Platform$Cmd$none,
						navBarResultCmd,
						$author$project$Shared$updateIntercom(modelUpdated.aa4)
					])));
	});
var $author$project$Layouts$Admin$initNav = function (model) {
	var _v0 = A2($author$project$Ui$Nav$init, 'admin-nav', $author$project$Layouts$Admin$NavMsg);
	var nav = _v0.a;
	var navCmd = _v0.b;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{kp: nav}),
		navCmd);
};
var $author$project$Ui$Nav$recalculateActiveTab = function (_v0) {
	var model = _v0;
	return $author$project$Ports$NavTabs$navTabActiveChanged(model.ahP);
};
var $author$project$Layouts$Patient$refreshNav = function (model) {
	return $author$project$Ui$Nav$recalculateActiveTab(model.kp);
};
var $author$project$Layouts$Partner$Billing$urlChanged = function (model) {
	return $author$project$Ui$Nav$recalculateActiveTab(model.kp);
};
var $author$project$Spa$Layout$urlChanged = F2(
	function (shared, layoutModel) {
		var _v0 = _Utils_Tuple2(
			$author$project$Spa$Layout$Route$routeToLayout(shared.adY),
			layoutModel);
		_v0$15:
		while (true) {
			switch (_v0.a.$) {
				case 13:
					if (_v0.b.$ === 13) {
						var newId = _v0.a.a;
						var _v1 = _v0.b;
						var currentId = _v1.a;
						return _Utils_eq(newId, currentId) ? _Utils_Tuple2(layoutModel, $elm$core$Platform$Cmd$none) : $author$project$Spa$Layout$init(shared);
					} else {
						break _v0$15;
					}
				case 7:
					if (_v0.b.$ === 7) {
						var newId = _v0.a.a;
						var _v2 = _v0.b;
						var currentId = _v2.a;
						return _Utils_eq(newId, currentId) ? _Utils_Tuple2(layoutModel, $elm$core$Platform$Cmd$none) : $author$project$Spa$Layout$init(shared);
					} else {
						break _v0$15;
					}
				case 8:
					if (_v0.b.$ === 8) {
						var _v3 = _v0.a;
						var billingModel = _v0.b.a;
						return _Utils_Tuple2(
							layoutModel,
							A2(
								$elm$core$Platform$Cmd$map,
								$author$project$Spa$Layout$PartnerBillingMsg,
								$author$project$Layouts$Partner$Billing$urlChanged(billingModel)));
					} else {
						break _v0$15;
					}
				case 9:
					if (_v0.b.$ === 9) {
						var _v4 = _v0.a;
						return _Utils_Tuple2(layoutModel, $elm$core$Platform$Cmd$none);
					} else {
						break _v0$15;
					}
				case 11:
					if (_v0.b.$ === 11) {
						var _v5 = _v0.a;
						return _Utils_Tuple2(layoutModel, $elm$core$Platform$Cmd$none);
					} else {
						break _v0$15;
					}
				case 12:
					if (_v0.b.$ === 12) {
						var newSlug = _v0.a.a;
						var _v6 = _v0.b;
						var currentSlug = _v6.a;
						return _Utils_eq(newSlug, currentSlug) ? _Utils_Tuple2(layoutModel, $elm$core$Platform$Cmd$none) : $author$project$Spa$Layout$init(shared);
					} else {
						break _v0$15;
					}
				case 5:
					if (_v0.b.$ === 5) {
						var newId = _v0.a.a;
						var _v7 = _v0.b;
						var currentId = _v7.a;
						return _Utils_eq(newId, currentId) ? _Utils_Tuple2(layoutModel, $elm$core$Platform$Cmd$none) : $author$project$Spa$Layout$init(shared);
					} else {
						break _v0$15;
					}
				case 3:
					if (_v0.b.$ === 3) {
						var newId = _v0.a.a;
						var _v8 = _v0.b;
						var currentId = _v8.a;
						var patientLayoutModel = _v8.b;
						return _Utils_eq(newId, currentId) ? _Utils_Tuple2(
							layoutModel,
							A2(
								$elm$core$Platform$Cmd$map,
								$author$project$Spa$Layout$PatientMsg,
								$author$project$Layouts$Patient$refreshNav(patientLayoutModel))) : $author$project$Spa$Layout$init(shared);
					} else {
						break _v0$15;
					}
				case 4:
					if (_v0.b.$ === 4) {
						var _v9 = _v0.a;
						return _Utils_Tuple2(layoutModel, $elm$core$Platform$Cmd$none);
					} else {
						break _v0$15;
					}
				case 6:
					if (_v0.b.$ === 6) {
						var _v10 = _v0.a;
						return _Utils_Tuple2(layoutModel, $elm$core$Platform$Cmd$none);
					} else {
						break _v0$15;
					}
				case 14:
					if (_v0.b.$ === 14) {
						var _v11 = _v0.a;
						var adminModel = _v0.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Platform$Cmd$map($author$project$Spa$Layout$AdminMsg),
							A2(
								$elm$core$Tuple$mapFirst,
								$author$project$Spa$Layout$AdminModel,
								$author$project$Layouts$Admin$initNav(adminModel)));
					} else {
						break _v0$15;
					}
				case 2:
					if (_v0.b.$ === 2) {
						var _v12 = _v0.a;
						var _v13 = _v0.b;
						return _Utils_Tuple2(layoutModel, $elm$core$Platform$Cmd$none);
					} else {
						break _v0$15;
					}
				case 17:
					if (_v0.b.$ === 19) {
						var _v14 = _v0.a;
						return _Utils_Tuple2(layoutModel, $elm$core$Platform$Cmd$none);
					} else {
						break _v0$15;
					}
				case 18:
					if (_v0.b.$ === 16) {
						var _v15 = _v0.a;
						var _v16 = _v0.b;
						return _Utils_Tuple2(layoutModel, $elm$core$Platform$Cmd$none);
					} else {
						break _v0$15;
					}
				case 19:
					if (_v0.b.$ === 17) {
						var newId = _v0.a.a;
						var _v17 = _v0.b;
						var currentId = _v17.a;
						return _Utils_eq(newId, currentId) ? _Utils_Tuple2(layoutModel, $elm$core$Platform$Cmd$none) : $author$project$Spa$Layout$init(shared);
					} else {
						break _v0$15;
					}
				default:
					break _v0$15;
			}
		}
		return $author$project$Spa$Layout$init(shared);
	});
var $author$project$Spa$Generated$Pages$view = function (model) {
	return $author$project$Spa$Generated$Pages$bundle(model).amo(0);
};
var $author$project$Main$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 5:
				var attempts = msg.a;
				var fragment = msg.b;
				var result = msg.c;
				if (result.$ === 1) {
					return _Utils_Tuple2(
						model,
						A2($author$project$Main$attemptScrollingToFragment, attempts + 1, fragment));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 1:
				var url = msg.a;
				var isLocal = msg.b;
				var shouldOpenInNewWindow = msg.c;
				var original = model.lk;
				var hasPendingChanges = !_Utils_eq(original.ajY, $elm$core$Maybe$Nothing);
				return _Utils_Tuple2(
					shouldOpenInNewWindow ? model : ((hasPendingChanges && _Utils_eq(original.Zn, $elm$core$Maybe$Nothing)) ? _Utils_update(
						model,
						{
							lk: _Utils_update(
								original,
								{
									Zn: $elm$core$Maybe$Just(
										_Utils_Tuple2(url, isLocal))
								})
						}) : model),
					hasPendingChanges ? $elm$core$Platform$Cmd$none : (isLocal ? $author$project$Ports$Navigation$pushUrl(url) : (shouldOpenInNewWindow ? $elm$core$Platform$Cmd$none : $author$project$Ports$Navigation$load(url))));
			case 0:
				var locationHref = msg.a;
				if (model.lk.ahq.agL && (!_Utils_eq(model.e, $author$project$Spa$Generated$Route$Blank))) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var original = model.lk;
					var _v2 = $author$project$Main$locationHrefToUrl(locationHref);
					var url = _v2.a;
					var defaultUrlCmd = _v2.b;
					var _v3 = A2($author$project$Shared$urlChanged, url, original);
					var shared = _v3.a;
					var urlChangedCmd = _v3.b;
					var _v4 = A2($author$project$Spa$Layout$urlChanged, shared, model.bE);
					var layout = _v4.a;
					var layoutCmd = _v4.b;
					var initPage = (!_Utils_eq(original.adY.YX, shared.adY.YX)) || _Utils_eq(model.e, $author$project$Spa$Generated$Route$Blank);
					var route = $author$project$Utils$Route$fromUrl(url);
					var _v5 = initPage ? A2($author$project$Spa$Generated$Pages$init, route, shared) : _Utils_Tuple3(model.dB, $elm$core$Platform$Cmd$none, _List_Nil);
					var page = _v5.a;
					var pageCmd = _v5.b;
					var outMsgs = _v5.c;
					var _v6 = A2(
						$author$project$Shared$updateFromOutMsgs,
						outMsgs,
						A2($author$project$Spa$Generated$Pages$save, page, shared));
					var newShared = _v6.a;
					var sharedCmd = _v6.b;
					var _v7 = $author$project$Spa$Generated$Pages$view(page);
					var title = _v7.ac9;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bE: layout,
								dB: page,
								e: route,
								lk: A2($author$project$Spa$Generated$Pages$save, page, newShared)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Main$Pages, pageCmd),
									A2($elm$core$Platform$Cmd$map, $author$project$Main$Shared, sharedCmd),
									A2($elm$core$Platform$Cmd$map, $author$project$Main$Layout, layoutCmd),
									defaultUrlCmd,
									A2(
									$elm$core$Maybe$withDefault,
									$elm$core$Platform$Cmd$none,
									A2(
										$elm$core$Maybe$map,
										$author$project$Main$attemptScrollingToFragment(0),
										url.ahu)),
									A2($elm$core$Platform$Cmd$map, $author$project$Main$Shared, urlChangedCmd),
									$author$project$Ports$PageTitle$updateTabTitle(title)
								])));
				}
			case 2:
				var sharedMsg = msg.a;
				var _v8 = A2($author$project$Shared$update, sharedMsg, model.lk);
				var shared = _v8.a;
				var sharedCmd = _v8.b;
				var _v9 = A2($author$project$Spa$Generated$Pages$load, model.dB, shared);
				var page = _v9.a;
				var pageCmd = _v9.b;
				var outMsgs = _v9.c;
				var _v10 = A2($author$project$Shared$updateFromOutMsgs, outMsgs, shared);
				var newShared = _v10.a;
				var newSharedCmd = _v10.b;
				var _v11 = newShared.Zp ? _Utils_Tuple2(
					_Utils_update(
						newShared,
						{Zp: false}),
					A2(
						$elm$core$Task$perform,
						function (_v12) {
							return $author$project$Main$RequestLoadClinical;
						},
						$elm$core$Task$succeed(0))) : _Utils_Tuple2(newShared, $elm$core$Platform$Cmd$none);
				var sharedWithFlagCleared = _v11.a;
				var requestLoadClinicalCmd = _v11.b;
				var _v13 = A3($author$project$Main$updateLayout, shared, outMsgs, model.bE);
				var layout = _v13.a;
				var layoutCmd = _v13.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bE: layout, dB: page, lk: sharedWithFlagCleared}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Main$Shared, sharedCmd),
								A2($elm$core$Platform$Cmd$map, $author$project$Main$Shared, newSharedCmd),
								A2($elm$core$Platform$Cmd$map, $author$project$Main$Pages, pageCmd),
								A2($elm$core$Platform$Cmd$map, $author$project$Main$Layout, layoutCmd),
								requestLoadClinicalCmd
							])));
			case 3:
				var pageMsg = msg.a;
				var _v14 = A2($author$project$Spa$Generated$Pages$update, pageMsg, model.dB);
				var page = _v14.a;
				var pageCmd = _v14.b;
				var outMsgs = _v14.c;
				var _v15 = A2(
					$author$project$Shared$updateFromOutMsgs,
					outMsgs,
					A2($author$project$Spa$Generated$Pages$save, page, model.lk));
				var shared = _v15.a;
				var sharedCmd = _v15.b;
				var _v16 = $author$project$Spa$Generated$Pages$view(page);
				var title = _v16.ac9;
				var _v17 = A3($author$project$Main$updateLayout, shared, outMsgs, model.bE);
				var layout = _v17.a;
				var layoutCmd = _v17.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bE: layout, dB: page, lk: shared}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Main$Pages, pageCmd),
								A2($elm$core$Platform$Cmd$map, $author$project$Main$Shared, sharedCmd),
								$author$project$Ports$PageTitle$updateTabTitle(title),
								A2($elm$core$Platform$Cmd$map, $author$project$Main$Layout, layoutCmd)
							])));
			case 6:
				var _v18 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Main$loadClinicalDebounceConfig, 0, model.s2);
				var debouncer = _v18.a;
				var cmd = _v18.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{s2: debouncer}),
					cmd);
			case 7:
				var subMsg = msg.a;
				var _v19 = A4(
					$jinjor$elm_debounce$Debounce$update,
					$author$project$Main$loadClinicalDebounceConfig,
					$jinjor$elm_debounce$Debounce$takeLast(
						function (_v20) {
							return $author$project$Ports$Clinical$load;
						}),
					subMsg,
					model.s2);
				var debouncer = _v19.a;
				var cmd = _v19.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{s2: debouncer}),
					cmd);
			default:
				var layoutMsg = msg.a;
				var _v21 = A3($author$project$Spa$Layout$update, model.lk.Gv, layoutMsg, model.bE);
				var layout = _v21.a;
				var layoutCmd = _v21.b;
				var outMsgs = _v21.c;
				var _v22 = A2($author$project$Shared$updateFromOutMsgs, outMsgs, model.lk);
				var shared = _v22.a;
				var sharedCmd = _v22.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bE: layout, lk: shared}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Main$Layout, layoutCmd),
								A2($elm$core$Platform$Cmd$map, $author$project$Main$Shared, sharedCmd)
							])));
		}
	});
var $author$project$Main$isClinicalLayout = function (layout) {
	switch (layout.$) {
		case 16:
			return true;
		case 17:
			return true;
		default:
			return false;
	}
};
var $author$project$Shared$HideAuthRecoveryModal = function (a) {
	return {$: 28, a: a};
};
var $author$project$Shared$HideLogoutWarning = {$: 10};
var $author$project$Shared$PendingChangesDiscard = {$: 22};
var $author$project$Shared$organizationFromSession = function (model) {
	return A2(
		$elm$core$Maybe$map,
		function (org) {
			return {
				ahP: $author$project$Api$Platform$Organization$Shared$id(org),
				Bq: $author$project$Api$Platform$Organization$Shared$name(org),
				ajD: $author$project$Api$Platform$Organization$Shared$id(org),
				amg: $author$project$Api$Platform$Organization$Shared$type_(org)
			};
		},
		A2(
			$elm$core$Maybe$andThen,
			$author$project$Api$Platform$Session$One$organization,
			$author$project$Api$Data$toMaybe(model.aa4)));
};
var $author$project$Components$HiConfirm$ShowCancel = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$HiConfirm$showCancel = $author$project$Components$HiConfirm$ShowCancel;
var $author$project$Navbars$Company$showSideNav = F2(
	function (hinterViewOff, _v0) {
		var model = _v0;
		return model.Ex.abq(hinterViewOff);
	});
var $author$project$Navbars$Partner$showSideNav = F2(
	function (hinterViewOff, _v0) {
		var model = _v0;
		return model.Ex.abq(hinterViewOff);
	});
var $author$project$Navbars$Practice$showSideNav = F2(
	function (hinterViewOff, _v0) {
		var model = _v0;
		return model.Ex.lk.abq(hinterViewOff);
	});
var $author$project$Navbar$showSideNav = F2(
	function (hinterViewOff, _v0) {
		var model = _v0;
		var _v1 = model.ai;
		switch (_v1.$) {
			case 0:
				return false;
			case 1:
				var navBar_ = _v1.a;
				return A2($author$project$Navbars$Practice$showSideNav, hinterViewOff, navBar_);
			case 2:
				var navBar_ = _v1.a;
				return A2($author$project$Navbars$Company$showSideNav, hinterViewOff, navBar_);
			default:
				var navBar_ = _v1.a;
				return A2($author$project$Navbars$Partner$showSideNav, hinterViewOff, navBar_);
		}
	});
var $author$project$Utils$Environment$toString = function (environment) {
	return A2(
		$elm$core$Maybe$map,
		function (env) {
			switch (env) {
				case 0:
					return 'production';
				case 1:
					return 'staging';
				case 2:
					return 'development';
				default:
					return 'feature';
			}
		},
		environment);
};
var $author$project$Api$Provider$Practice$One$accessRestricted = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.KE;
	});
var $author$project$Api$Practice$accessRestricted = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$accessRestricted(practice_);
	} else {
		return false;
	}
};
var $author$project$Api$Provider$Practice$One$daysWithOutstandingBalance = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.PN;
	});
var $author$project$Api$Practice$daysWithOutstandingBalance = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$daysWithOutstandingBalance(practice_);
	} else {
		return 0;
	}
};
var $author$project$Components$AccountLockedModal$viewModal = function (daysWithOutstandingBalance) {
	return A3(
		$author$project$Ui$Modal$view,
		0,
		_List_fromArray(
			[
				$author$project$Ui$Modal$dismissible(false)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Your account is locked')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						$elm$html$Html$text('You have outstanding invoices that are '),
						$elm$html$Html$text(
						A2($author$project$Formatters$String$pluralize, 'day', daysWithOutstandingBalance)),
						$elm$html$Html$text(' overdue, so your account has been locked. '),
						A2(
						$author$project$Ui$Typography$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('To unlock your account, please '),
								A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Admin__Billing,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('click here')
									])),
								$elm$html$Html$text(' to view and pay your invoices.')
							])),
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('If you have questions about your invoices or need to temporarily unlock your account, please contact us. ')
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[
								$author$project$Ui$Typography$small,
								$author$project$Ui$Typography$muted,
								$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textLeft)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Note: Although your account is locked, everything is still active and operating as expected. There will be no disruption to your service, including automated billing, notifications, enrollments, or funds disbursement until your account is closed or suspended.')
							]))
					]))
			]));
};
var $author$project$Components$AccountLockedModal$view = F3(
	function (session, practice, route) {
		var userIsAdmin = $author$project$Api$Platform$User$Shared$isAdmin(
			$author$project$Api$Platform$Session$One$user(session));
		var routeString = $author$project$Spa$Generated$Route$toString(route);
		var practiceAccessRestricted = $author$project$Api$Practice$accessRestricted(practice);
		var organizationIsCompany = _Utils_eq(
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Platform$Organization$Shared$type_,
				$author$project$Api$Platform$Session$One$organization(session)),
			$elm$core$Maybe$Just(1));
		var isUserRoute = A2($elm$core$String$startsWith, '/user', routeString);
		var isPaymentSourcesRoute = A2(
			$elm$core$String$startsWith,
			$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Admin__PaymentSources),
			routeString);
		var isBillingRoute = A2(
			$elm$core$String$startsWith,
			$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Admin__Billing),
			routeString);
		var routeAllowed = isBillingRoute || (isPaymentSourcesRoute || isUserRoute);
		var showModal = (!organizationIsCompany) && ((!userIsAdmin) && ((!routeAllowed) && practiceAccessRestricted));
		return showModal ? $author$project$Components$AccountLockedModal$viewModal(
			$author$project$Api$Practice$daysWithOutstandingBalance(practice)) : $author$project$Utils$Html$empty;
	});
var $author$project$Components$Auth$SystemRecoveryModal$hiConfirmMessage = function () {
	var infoText = '\n            Our main sign-in system has recovered from the outage. To continue using all features,\n            please sign out of the temporary system and sign back in with the full system.\n            ';
	var alertText = '\n            If you do not sign out and sign back in within the next 2 minutes, this\n            will happen automatically and you may lose unsaved work,  \n            ';
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$textLeft]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mb2]),
				_List_fromArray(
					[
						$elm$html$Html$text(infoText)
					])),
				A2(
				$author$project$Ui$Alert$warning,
				_List_fromArray(
					[
						$author$project$Ui$Alert$icon(67),
						$author$project$Ui$Alert$alignment($author$project$Ui$Alignment$textLeft)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$text,
						_List_fromArray(
							[$author$project$Ui$Typography$bold]),
						'Important:'),
						A2($author$project$Ui$Typography$text, _List_Nil, alertText)
					]))
			]));
}();
var $author$project$Components$Auth$SystemRecoveryModal$hiConfirmOptions = _List_fromArray(
	[
		$author$project$Components$HiConfirm$verb('sign out'),
		$author$project$Components$HiConfirm$noun('now'),
		$author$project$Components$HiConfirm$customMessage(
		_List_fromArray(
			[$author$project$Components$Auth$SystemRecoveryModal$hiConfirmMessage])),
		$author$project$Components$HiConfirm$customTitle('System Recovery Notice'),
		$author$project$Components$HiConfirm$showCancel(true)
	]);
var $author$project$Components$Auth$SystemRecoveryModal$view = function (onClose) {
	return A2($author$project$Components$HiConfirm$modal, onClose, $author$project$Components$Auth$SystemRecoveryModal$hiConfirmOptions);
};
var $author$project$Components$GlobalSearch$ClearTerm = {$: 3};
var $author$project$Components$GlobalSearch$InputKeyDown = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$GlobalSearch$PaginationMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$GlobalSearch$TermChanged = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$GlobalSearch$attributesToText = function (attributes) {
	var attributesText = A2($elm$core$String$join, ', ', attributes);
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('text-muted')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(attributesText)
			]));
};
var $author$project$Components$GlobalSearch$permissionTypeToAttributesList = function (permissionType) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mt-2')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(permissionType.Bq + ': ')
					])),
				$author$project$Components$GlobalSearch$attributesToText(permissionType.xr)
			]));
};
var $author$project$Components$GlobalSearch$viewNoResultsFound = F2(
	function (permissionsData, maybeFilter) {
		var searchableInfo = function () {
			if (permissionsData.$ === 3) {
				var permissions = permissionsData.a;
				if (!maybeFilter.$) {
					var filter = maybeFilter.a;
					return A2(
						$elm$core$List$filter,
						function (elem) {
							return _Utils_eq(elem.ahP, filter);
						},
						A2($elm$core$List$map, $author$project$Components$GlobalSearch$permissionToPermissionType, permissions));
				} else {
					return A2($elm$core$List$map, $author$project$Components$GlobalSearch$permissionToPermissionType, permissions);
				}
			} else {
				return _List_Nil;
			}
		}();
		var noMatchingText = _List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mt2]),
				_List_fromArray(
					[
						A2($author$project$Ui$Typography$text, _List_Nil, 'No matching results found')
					])),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mt2]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$text,
						_List_fromArray(
							[$author$project$Ui$Typography$muted]),
						$elm$core$String$toUpper('Searchable Information:'))
					]))
			]);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_Utils_ap(
				noMatchingText,
				A2($elm$core$List$map, $author$project$Components$GlobalSearch$permissionTypeToAttributesList, searchableInfo)));
	});
var $author$project$Components$GlobalSearch$DocumentClicked = {$: 10};
var $author$project$Components$GlobalSearch$DocumentHovered = function (a) {
	return {$: 11, a: a};
};
var $author$project$Ui$ListGroup$Active = {$: 2};
var $author$project$Ui$ListGroup$active = $author$project$Ui$ListGroup$Active;
var $author$project$Components$GlobalSearch$documentTypeToIcon = function (name) {
	if (name === 'sponsor') {
		return A2(
			$author$project$Ui$Icon$view,
			_List_fromArray(
				[
					$author$project$Ui$Icon$class('global-search__icon')
				]),
			11);
	} else {
		switch (name) {
			case 'invoice':
				return $author$project$Ui$Icon$invoices(_List_Nil);
			case 'customer_invoice':
				return $author$project$Ui$Icon$invoices(_List_Nil);
			case 'patient':
				return $author$project$Ui$Icon$patients(_List_Nil);
			default:
				return $elm$html$Html$text('');
		}
	}
};
var $author$project$Api$Provider$Search$Min$label = function (_v0) {
	var record = _v0;
	return record.aih;
};
var $author$project$Api$Provider$Search$All$label = function (_v0) {
	var min = _v0;
	return $author$project$Api$Provider$Search$Min$label(min);
};
var $author$project$Ui$ListGroup$None = {$: 3};
var $author$project$Ui$ListGroup$none = $author$project$Ui$ListGroup$None;
var $elm$html$Html$Events$onMouseEnter = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseenter',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Api$Provider$Search$Min$secondaryLabel = function (_v0) {
	var record = _v0;
	return record.aaC;
};
var $author$project$Api$Provider$Search$All$secondaryLabel = function (_v0) {
	var min = _v0;
	return $author$project$Api$Provider$Search$Min$secondaryLabel(min);
};
var $author$project$Api$Provider$Search$Min$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Api$Provider$Search$All$status = function (_v0) {
	var min = _v0;
	return $author$project$Api$Provider$Search$Min$status(min);
};
var $author$project$Api$Provider$Search$Min$type_ = function (_v0) {
	var record = _v0;
	return record.amg;
};
var $author$project$Api$Provider$Search$All$type_ = function (_v0) {
	var min = _v0;
	return $author$project$Api$Provider$Search$Min$type_(min);
};
var $author$project$Components$GlobalSearch$viewDocument = F3(
	function (activeDocumentIndex, index, document) {
		var activeClass = _Utils_eq(activeDocumentIndex, index) ? $author$project$Ui$ListGroup$active : $author$project$Ui$ListGroup$none;
		return A2(
			$author$project$Ui$ListGroup$item,
			_List_fromArray(
				[activeClass]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(
							$author$project$Api$Provider$Search$All$path(document)),
							$elm$html$Html$Attributes$class('stretched-link'),
							$elm$html$Html$Events$onClick($author$project$Components$GlobalSearch$DocumentClicked),
							$elm$html$Html$Events$onMouseEnter(
							$author$project$Components$GlobalSearch$DocumentHovered(index))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap]),
							_List_fromArray(
								[
									$author$project$Components$GlobalSearch$documentTypeToIcon(
									$author$project$Api$Provider$Search$All$type_(document)),
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[
											$author$project$Ui$Typography$phi(true)
										]),
									$author$project$Api$Provider$Search$All$label(document)),
									function () {
									var _v0 = $author$project$Api$Provider$Search$All$secondaryLabel(document);
									if (!_v0.$) {
										var secondaryLabel_ = _v0.a;
										return A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[
													$author$project$Ui$Typography$muted,
													$author$project$Ui$Typography$small,
													$author$project$Ui$Typography$phi(true)
												]),
											secondaryLabel_);
									} else {
										return $author$project$Utils$Html$empty;
									}
								}(),
									A2(
									$author$project$Ui$Badge$fromString,
									_List_Nil,
									$author$project$Api$Provider$Search$All$status(document)),
									A2(
									$author$project$Ui$Icon$view,
									_List_fromArray(
										[
											$author$project$Ui$Icon$class('global-search__action')
										]),
									16)
								]))
						]))
				]));
	});
var $author$project$Components$GlobalSearch$viewResults = F2(
	function (documents, activeDocumentIndex) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('global-search__results')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$ListGroup$view,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						$author$project$Components$GlobalSearch$viewDocument(activeDocumentIndex),
						documents))
				]));
	});
var $author$project$Components$GlobalSearch$TabClicked = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$GlobalSearch$viewPermissionTypeTab = function (permissionType) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-current')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(permissionType.Bq)
					]))
			]));
};
var $author$project$Components$GlobalSearch$viewNavTab = F2(
	function (activeFilter, permissionType) {
		return A2(
			$author$project$Ui$Nav$item,
			_List_fromArray(
				[
					$author$project$Ui$Nav$itemId(permissionType.ahP),
					$author$project$Ui$Nav$activeItem(
					function () {
						if (activeFilter.$ === 1) {
							return permissionType.ahP === 'all';
						} else {
							var filterId = activeFilter.a;
							return _Utils_eq(permissionType.ahP, filterId);
						}
					}()),
					$author$project$Ui$Nav$onItemClick(
					$author$project$Components$GlobalSearch$TabClicked(permissionType.ahP))
				]),
			_List_fromArray(
				[
					$author$project$Components$GlobalSearch$viewPermissionTypeTab(permissionType)
				]));
	});
var $author$project$Components$GlobalSearch$viewTabs = function (openModel) {
	var _v0 = openModel.kp;
	if (!_v0.$) {
		var nav = _v0.a;
		var navItems = function () {
			var _v1 = openModel.tP;
			if (_v1.$ === 3) {
				var permissions = _v1.a;
				var searchableTypeList = A2(
					$elm$core$List$filter,
					function ($) {
						return $.aaB;
					},
					A2($elm$core$List$map, $author$project$Components$GlobalSearch$permissionToPermissionType, permissions));
				if ($elm$core$List$length(searchableTypeList) > 1) {
					var allType = {xr: _List_Nil, ahP: 'all', Bq: 'All', aaB: true};
					return A2(
						$elm$core$List$map,
						$author$project$Components$GlobalSearch$viewNavTab(openModel.HM),
						A2($elm$core$List$cons, allType, searchableTypeList));
				} else {
					return A2(
						$elm$core$List$map,
						$author$project$Components$GlobalSearch$viewNavTab(openModel.HM),
						searchableTypeList);
				}
			} else {
				return _List_Nil;
			}
		}();
		return _List_fromArray(
			[
				A3($author$project$Ui$Nav$view, _List_Nil, navItems, nav)
			]);
	} else {
		return _List_fromArray(
			[$author$project$Utils$Html$empty]);
	}
};
var $author$project$Components$GlobalSearch$viewOpen = function (model) {
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$GlobalSearch$ModalCloseClicked,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						A2(
							$elm$core$List$cons,
							$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$id('global-search-input'),
										$author$project$Ui$Form$Input$placeholder('Search...'),
										$author$project$Ui$Form$Input$value(model.dP),
										$author$project$Ui$Form$Input$onInput($author$project$Components$GlobalSearch$TermChanged),
										$author$project$Ui$Form$Input$onKeyDown($author$project$Components$GlobalSearch$InputKeyDown),
										$author$project$Ui$Form$Input$autoComplete(false),
										$author$project$Ui$Form$Input$customAttributes(
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('search-input')
											])),
										$author$project$Ui$Form$Input$wrapped(
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('lens-search')
													]),
												_List_fromArray(
													[
														$author$project$Ui$Icon$search(_List_Nil)
													])),
												(model.dP === '') ? $author$project$Utils$Html$empty : A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('clear-search'),
														$elm$html$Html$Events$onClick($author$project$Components$GlobalSearch$ClearTerm)
													]),
												_List_fromArray(
													[
														$author$project$Ui$Icon$crossCircle(_List_Nil)
													]))
											])),
										$author$project$Ui$Form$Input$phi(true)
									])),
							$author$project$Components$GlobalSearch$viewTabs(model))),
						function () {
						var _v0 = model.$X;
						switch (_v0.$) {
							case 3:
								var results = _v0.a;
								return $elm$core$List$isEmpty(results) ? A2($author$project$Components$GlobalSearch$viewNoResultsFound, model.tP, model.HM) : A2($author$project$Components$GlobalSearch$viewResults, results, model.aa);
							case 1:
								return $elm$html$Html$text('Loading...');
							default:
								return A2(
									$author$project$Ui$Element$prose,
									_List_fromArray(
										[$author$project$Ui$Element$mt1, $author$project$Ui$Element$ml1]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[$author$project$Ui$Typography$gray]),
											'Try searching for id, invoice number, name, email and other information')
										]));
						}
					}()
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						function () {
						var _v1 = model.$X;
						if (_v1.$ === 3) {
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('global-search__footer')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('global-search__pagination')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Components$GlobalSearch$PaginationMsg,
												A2($author$project$Api$Pagination$view, _List_Nil, model.ajJ))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('global-search__legend')
											]),
										_List_fromArray(
											[
												$author$project$Ui$Icon$selectArrows(_List_Nil),
												$elm$html$Html$text('Select'),
												$author$project$Ui$Icon$open(_List_Nil),
												$elm$html$Html$text('Open')
											]))
									]));
						} else {
							return $author$project$Utils$Html$empty;
						}
					}()
					]))
			]));
};
var $author$project$Components$GlobalSearch$view = function (model) {
	if (!model.$) {
		return $elm$html$Html$text('');
	} else {
		var openModel = model.a;
		return $author$project$Components$GlobalSearch$viewOpen(openModel);
	}
};
var $author$project$Components$PendingChangesModal$view = F3(
	function (pendingChangesDetail, discardChangesMsg, keepChangesMsg) {
		return A3(
			$author$project$Ui$Modal$view,
			keepChangesMsg,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('You have pending changes')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							$elm$html$Html$text(pendingChangesDetail)
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Stay on this page'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick(keepChangesMsg)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Stay')
								])),
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Leave and discard pending changes'},
							_List_fromArray(
								[
									$author$project$Ui$Button$danger,
									$author$project$Ui$Button$onClick(discardChangesMsg)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Leave')
								]))
						]))
				]));
	});
var $elm$html$Html$nav = _VirtualDom_node('nav');
var $author$project$Components$DebugInfo$viewSetting = F2(
	function (label, value) {
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$inline, $author$project$Ui$Element$gap]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$text,
					_List_fromArray(
						[$author$project$Ui$Typography$bold]),
					label + ':'),
					A2($author$project$Ui$Typography$text, _List_Nil, value)
				]));
	});
var $author$project$Components$DebugInfo$view = function (_v0) {
	var nodeEnv = _v0.aiY;
	var hintEnv = _v0.ahJ;
	var apiUrl = _v0.aeZ;
	var debugOrTest = _v0.age;
	var embedded = _v0.agL;
	var session = _v0.aa4;
	return ((!embedded) && debugOrTest) ? A3(
		$author$project$Ui$Element$custom,
		'debug-info',
		_List_Nil,
		A2(
			$elm$core$List$intersperse,
			A2($author$project$Ui$Typography$text, _List_Nil, ' - '),
			_List_fromArray(
				[
					A2(
					$author$project$Components$DebugInfo$viewSetting,
					'NODE_ENV',
					A2($elm$core$Maybe$withDefault, 'N/A', nodeEnv)),
					A2(
					$author$project$Components$DebugInfo$viewSetting,
					'HINT_ENV',
					A2($elm$core$Maybe$withDefault, 'N/A', hintEnv)),
					A2($author$project$Components$DebugInfo$viewSetting, 'API_URL', apiUrl),
					A2(
					$author$project$Components$DebugInfo$viewSetting,
					'session.role',
					$author$project$Api$Platform$Session$One$role(session))
				]))) : $author$project$Utils$Html$empty;
};
var $author$project$Api$Platform$Organization$Shared$sandboxOf = function (_v0) {
	var record = _v0.b;
	return record.aap;
};
var $author$project$Components$SandboxAlert$SwitchToManagedPractice = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$SandboxAlert$SwitchToOrganization = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Platform$Organization$SandboxOf$managedBy = function (_v0) {
	var record = _v0;
	return record.Wq;
};
var $author$project$Api$Platform$Organization$SandboxOf$organizationId = function (_v0) {
	var record = _v0;
	return record.ajD;
};
var $author$project$Api$Platform$Organization$Switcher$organizationId = function (_v0) {
	var record = _v0;
	return record.ajD;
};
var $author$project$Components$SandboxAlert$switchMsg = function (sandboxOf) {
	if (!sandboxOf.$) {
		var organization = sandboxOf.a;
		return A2(
			$author$project$Components$SandboxAlert$SwitchToOrganization,
			0,
			$author$project$Api$Platform$Organization$SandboxOf$organizationId(organization));
	} else {
		var organization = sandboxOf.a;
		var _v1 = $author$project$Api$Platform$Organization$SandboxOf$managedBy(organization);
		if (!_v1.$) {
			var managedPractice = _v1.a;
			return $author$project$Components$SandboxAlert$SwitchToManagedPractice(
				$author$project$Api$Platform$Organization$Switcher$organizationId(managedPractice));
		} else {
			return A2(
				$author$project$Components$SandboxAlert$SwitchToOrganization,
				2,
				$author$project$Api$Platform$Organization$SandboxOf$organizationId(organization));
		}
	}
};
var $author$project$Components$SandboxAlert$view = function (session) {
	return $author$project$Api$Platform$Session$One$sandbox(session) ? A2(
		$author$project$Ui$Alert$warning,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Currently viewing sandbox data.')
							])),
						function () {
						var _v0 = A2(
							$elm$core$Maybe$andThen,
							$author$project$Api$Platform$Organization$Shared$sandboxOf,
							$author$project$Api$Platform$Session$One$organization(session));
						if (!_v0.$) {
							var sandboxOf = _v0.a;
							return A3(
								$author$project$Ui$Button$view,
								{mm: 'Back to Live'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$sm,
										$author$project$Ui$Button$onClick(
										$author$project$Components$SandboxAlert$switchMsg(sandboxOf)),
										$author$project$Ui$Button$secondary
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Back to Live')
									]));
						} else {
							return $author$project$Utils$Html$empty;
						}
					}()
					]))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Components$BackupAuthAlert$view = function (backupAuthEnabled) {
	return backupAuthEnabled ? A2($author$project$Ui$Alert$warning, _List_Nil, $author$project$Components$BackupAuthAlert$viewAlertText) : $author$project$Utils$Html$empty;
};
var $author$project$Api$Feature$HintBillingTax = 27;
var $author$project$Api$Practice$deactivated = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$deactivated(practice_);
	} else {
		return false;
	}
};
var $author$project$Components$DeactivatedPracticeAlert$view = function (practice) {
	return $author$project$Api$Practice$deactivated(practice) ? A2(
		$author$project$Ui$Alert$danger,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$strong,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Practice Deactivated.')
					])),
				$author$project$Utils$Html$noBreakSpace,
				$elm$html$Html$text('Practice is deactivated and will not process payments, bill memberships or send emails.')
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Ui$Link$ButtonWarningInverse = 6;
var $author$project$Ui$Link$buttonWarningInverse = $author$project$Ui$Link$Style(6);
var $author$project$Api$Provider$Practice$One$taxAddressValid = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.acU;
	});
var $author$project$Components$MissingAddressAlert$view = F4(
	function (session, practice, today, hinterViewOff) {
		var isAdmin = A3($author$project$Permission$canGoTo, session, hinterViewOff, 0);
		var showBanner = function () {
			var _v0 = _Utils_Tuple2(isAdmin, practice);
			if (_v0.a && (!_v0.b.$)) {
				var practice_ = _v0.b.a;
				var launchDate = $author$project$Api$Provider$Practice$One$defaultMembershipStartDate(practice_);
				var launchDateIsWithin2Weeks = function (diff) {
					return (diff >= 0) && (diff <= 14);
				}(
					A3($justinmimbs$date$Date$diff, 3, today, launchDate));
				var addressIsValid = $author$project$Api$Provider$Practice$One$taxAddressValid(practice_);
				return (!addressIsValid) && launchDateIsWithin2Weeks;
			} else {
				return false;
			}
		}();
		return showBanner ? A2(
			$author$project$Ui$Alert$warning,
			_List_fromArray(
				[
					$author$project$Ui$Alert$icon(67)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(9)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textLeft]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[$author$project$Ui$Typography$bold]),
											'Your business address is missing'),
											A2($elm$html$Html$br, _List_Nil, _List_Nil),
											A2($author$project$Ui$Typography$text, _List_Nil, 'Completing your address ensures patients see the right information on invoices, email notifications, and billing messages.')
										]))
								])),
							A2(
							$author$project$Ui$Grid$column,
							_List_fromArray(
								[
									$author$project$Ui$Grid$span(3),
									$author$project$Ui$Grid$justifyRight,
									$author$project$Ui$Grid$itemsCenter
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$fullHeight]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$Admin__Practice,
											_List_fromArray(
												[
													$author$project$Ui$Link$test('Add address'),
													$author$project$Ui$Link$buttonWarningInverse
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Add address')
												]))
										]))
								]))
						]))
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Api$Provider$Practice$One$collectionWarningStatus = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.N1;
	});
var $author$project$Api$Practice$collectionWarningStatus = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$collectionWarningStatus(practice_);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$Practice$One$daysUntilAccessRestricted = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.PM;
	});
var $author$project$Api$Practice$daysUntilAccessRestricted = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$daysUntilAccessRestricted(practice_);
	} else {
		return 0;
	}
};
var $author$project$Api$Platform$Session$One$showCollectionWarning = function (_v0) {
	var record = _v0;
	return record.abk;
};
var $author$project$Components$MissingSourceAlert$view = F3(
	function (session, practice, hinterViewOff) {
		var _v0 = _Utils_Tuple2(
			A3($author$project$Permission$canGoTo, session, hinterViewOff, 1) && $author$project$Api$Platform$Session$One$showCollectionWarning(session),
			$author$project$Api$Practice$collectionWarningStatus(practice));
		_v0$2:
		while (true) {
			if (_v0.a && (!_v0.b.$)) {
				switch (_v0.b.a) {
					case 'yellow':
						return A2(
							$author$project$Ui$Alert$warning,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('You have outstanding invoices on your account.')
										])),
									$author$project$Utils$Html$noBreakSpace,
									$elm$html$Html$text('Please '),
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Admin__Billing,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('click here')
										])),
									$elm$html$Html$text(' to view and pay your invoices so that your account doesn\'t become overdue. If you have questions or concerns regarding your invoices, please contact us.')
								]));
					case 'red':
						var daysWithOutstandingBalance = $author$project$Api$Practice$daysWithOutstandingBalance(practice);
						var daysUntilAccessRestricted = $author$project$Api$Practice$daysUntilAccessRestricted(practice);
						return A2(
							$author$project$Ui$Alert$danger,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('You have outstanding invoices and your account is '),
											$elm$html$Html$text(
											A2($author$project$Formatters$String$pluralize, 'day', daysWithOutstandingBalance)),
											$elm$html$Html$text(' overdue.')
										])),
									$author$project$Utils$Html$noBreakSpace,
									$elm$html$Html$text('Please '),
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Admin__Billing,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('click here')
										])),
									$elm$html$Html$text(' to view and pay any overdue invoices to prevent your account from being locked in '),
									$elm$html$Html$text(
									A2($author$project$Formatters$String$pluralize, 'day', daysUntilAccessRestricted)),
									$elm$html$Html$text('. If you have questions or concerns regarding your invoices, please contact us.')
								]));
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return $author$project$Utils$Html$empty;
	});
var $author$project$Components$OnboardedPracticeAlert$isHintAdmin = F2(
	function (session, hinterViewOff) {
		return A2($author$project$Utils$User$isViewingAsHinter, session, hinterViewOff);
	});
var $author$project$Api$Provider$Practice$One$requiresPaymentInformation = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.$L;
	});
var $author$project$Api$Practice$requiresPaymentInformation = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$requiresPaymentInformation(practice_);
	} else {
		return false;
	}
};
var $author$project$Components$OnboardedPracticeAlert$view = F3(
	function (session, practice, hinterViewOff) {
		return (A2($author$project$Components$OnboardedPracticeAlert$isHintAdmin, session, hinterViewOff) && $author$project$Api$Practice$requiresPaymentInformation(practice)) ? A2(
			$author$project$Ui$Alert$danger,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$strong,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('This Practice is required to add payment information.')
						])),
					$author$project$Utils$Html$noBreakSpace,
					$elm$html$Html$text('All users (other than Hinters) are being redirected to the '),
					A3(
					$author$project$Ui$HinterOnly$linkRoute,
					$author$project$Spa$Generated$Route$Onboarding,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('payment setup')
						])),
					$elm$html$Html$text(' view until a payment method is added.')
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Navbar$viewPracticeAlerts = F4(
	function (session, hinterViewOff, practice, currentDate) {
		if (!practice.$) {
			var practice_ = practice.a;
			return _List_fromArray(
				[
					A3($author$project$Components$MissingSourceAlert$view, session, practice_, hinterViewOff),
					A3($author$project$Components$OnboardedPracticeAlert$view, session, practice_, hinterViewOff),
					A2(
					$author$project$Utils$Html$htmlIf,
					A2($author$project$Api$Practice$featureEnabled, 27, practice_),
					A4($author$project$Components$MissingAddressAlert$view, session, practice_, currentDate, hinterViewOff)),
					$author$project$Components$DeactivatedPracticeAlert$view(practice_)
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Navbar$viewAlerts = F5(
	function (session, hinterViewOff, practice, backupAuthEnabled, currentDate) {
		return A2(
			$elm$core$List$cons,
			$author$project$Components$BackupAuthAlert$view(backupAuthEnabled),
			A4($author$project$Navbar$viewPracticeAlerts, session, hinterViewOff, practice, currentDate));
	});
var $author$project$Navbars$Company$NavClicked = function (a) {
	return {$: 4, a: a};
};
var $author$project$Navbars$Company$OrgSwitcherMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Navbars$Company$defaultNav = _List_fromArray(
	[
		{At: 0},
		{At: 1},
		{At: 2},
		{At: 3},
		{At: 4},
		{At: 5}
	]);
var $author$project$Components$OrganizationSwitcher$hasInlineOrgs = function (_v0) {
	var model = _v0;
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (orgs) {
				if (!orgs.b) {
					return false;
				} else {
					if (!orgs.b.b) {
						return false;
					} else {
						return true;
					}
				}
			},
			$author$project$Api$Data$toMaybe(model.tu)));
};
var $author$project$Api$Platform$Organization$Switcher$type_ = function (_v0) {
	var record = _v0;
	return record.amg;
};
var $author$project$Api$Platform$User$Organization$type_ = $author$project$Api$Platform$Organization$Switcher$type_;
var $author$project$Components$OrganizationSwitcher$groupByType = function (orgs) {
	var practices = A2(
		$elm$core$List$filter,
		function (o) {
			return !$author$project$Api$Platform$User$Organization$type_(o);
		},
		orgs);
	var partners = A2(
		$elm$core$List$filter,
		function (o) {
			return $author$project$Api$Platform$User$Organization$type_(o) === 2;
		},
		orgs);
	var companies = A2(
		$elm$core$List$filter,
		function (o) {
			return $author$project$Api$Platform$User$Organization$type_(o) === 1;
		},
		orgs);
	return A2(
		$elm$core$List$filter,
		function (_v0) {
			var items = _v0.b;
			return !$elm$core$List$isEmpty(items);
		},
		_List_fromArray(
			[
				_Utils_Tuple2(0, practices),
				_Utils_Tuple2(1, companies),
				_Utils_Tuple2(2, partners)
			]));
};
var $author$project$Api$Platform$Organization$Switcher$sandbox = function (_v0) {
	var record = _v0;
	return record.aan;
};
var $author$project$Api$Platform$User$Organization$sandbox = $author$project$Api$Platform$Organization$Switcher$sandbox;
var $author$project$Components$OrganizationSwitcher$SetEnvironment = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$OrganizationSwitcher$viewEnvironmentToggle = F2(
	function (current, navModel) {
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mb3]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Nav$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Nav$item,
							_List_fromArray(
								[
									$author$project$Ui$Nav$activeItem(!current),
									$author$project$Ui$Nav$onItemClick(
									$author$project$Components$OrganizationSwitcher$SetEnvironment(0))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Live')
								])),
							A2(
							$author$project$Ui$Nav$item,
							_List_fromArray(
								[
									$author$project$Ui$Nav$activeItem(current === 1),
									$author$project$Ui$Nav$onItemClick(
									$author$project$Components$OrganizationSwitcher$SetEnvironment(1))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Sandbox')
								]))
						]),
					navModel)
				]));
	});
var $author$project$Components$OrganizationSwitcher$orgTypeLabel = function (orgType) {
	switch (orgType) {
		case 0:
			return 'Practices';
		case 1:
			return 'Companies';
		default:
			return 'Partners';
	}
};
var $author$project$Components$OrganizationSwitcher$SelectOrganization = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Platform$Organization$Switcher$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Platform$User$Organization$id = $author$project$Api$Platform$Organization$Switcher$id;
var $author$project$Api$Platform$Organization$Switcher$name = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Platform$User$Organization$name = $author$project$Api$Platform$Organization$Switcher$name;
var $author$project$Api$Platform$User$Organization$organizationId = $author$project$Api$Platform$Organization$Switcher$organizationId;
var $author$project$Components$OrganizationSwitcher$viewOrgItem = F2(
	function (currentOrg, org) {
		var isCurrent = _Utils_eq(
			currentOrg.amg,
			$author$project$Api$Platform$User$Organization$type_(org)) && _Utils_eq(
			currentOrg.ahP,
			$author$project$Api$Platform$User$Organization$id(org));
		return A3(
			$author$project$Ui$Button$view,
			{mm: 'Select org'},
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Button$link,
				A2(
					$elm$core$List$cons,
					$author$project$Ui$Button$onClick(
						$author$project$Components$OrganizationSwitcher$SelectOrganization(
							$author$project$Api$Platform$User$Organization$organizationId(org))),
					isCurrent ? _List_fromArray(
						[
							$author$project$Ui$Button$icon($author$project$Ui$Icon$check)
						]) : _List_Nil)),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Api$Platform$User$Organization$name(org))
				]));
	});
var $author$project$Components$OrganizationSwitcher$viewGroup = F2(
	function (currentOrg, _v0) {
		var orgType = _v0.a;
		var orgs = _v0.b;
		return $elm$core$List$isEmpty(orgs) ? _List_Nil : _List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$gap2, $author$project$Ui$Element$flexCol]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$titleSm,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Components$OrganizationSwitcher$orgTypeLabel(orgType))
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$gap2, $author$project$Ui$Element$flexCol, $author$project$Ui$Element$textMuted]),
						A2(
							$elm$core$List$map,
							$author$project$Components$OrganizationSwitcher$viewOrgItem(currentOrg),
							orgs))
					]))
			]);
	});
var $author$project$Components$OrganizationSwitcher$viewGroupedOrgs = F2(
	function (currentOrg, groups) {
		return A2(
			$elm$core$List$concatMap,
			$author$project$Components$OrganizationSwitcher$viewGroup(currentOrg),
			groups);
	});
var $author$project$Components$OrganizationSwitcher$viewTrigger = function (organizationName) {
	return A3(
		$author$project$Ui$Element$custom,
		'topnav__left--content cursor-pointer py-3.5',
		_List_fromArray(
			[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
		_List_fromArray(
			[
				$author$project$Ui$Icon$location(_List_Nil),
				A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(organizationName)
					])),
				$author$project$Ui$Icon$kebabMenu(_List_Nil)
			]));
};
var $author$project$Components$OrganizationSwitcher$viewDropdown = F3(
	function (currentOrg, model, orgs) {
		var hasSandbox = A2($elm$core$List$any, $author$project$Api$Platform$User$Organization$sandbox, orgs);
		var hasLive = A2(
			$elm$core$List$any,
			function (o) {
				return !$author$project$Api$Platform$User$Organization$sandbox(o);
			},
			orgs);
		var showTabs = hasSandbox && hasLive;
		var filteredOrgs = function () {
			if (showTabs) {
				var _v0 = model.si;
				if (!_v0) {
					return A2(
						$elm$core$List$filter,
						function (o) {
							return !$author$project$Api$Platform$User$Organization$sandbox(o);
						},
						orgs);
				} else {
					return A2($elm$core$List$filter, $author$project$Api$Platform$User$Organization$sandbox, orgs);
				}
			} else {
				return orgs;
			}
		}();
		var grouped = $author$project$Components$OrganizationSwitcher$groupByType(filteredOrgs);
		return A4(
			$author$project$Ui$FlyoutMenu$view,
			_List_fromArray(
				[
					$author$project$Ui$FlyoutMenu$direction(1)
				]),
			_List_fromArray(
				[
					$author$project$Ui$FlyoutMenu$body(
					$elm$core$List$concat(
						_List_fromArray(
							[
								showTabs ? _List_fromArray(
								[
									A2($author$project$Components$OrganizationSwitcher$viewEnvironmentToggle, model.si, model.oJ)
								]) : _List_Nil,
								_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$gap4, $author$project$Ui$Element$flexCol]),
									A2($author$project$Components$OrganizationSwitcher$viewGroupedOrgs, currentOrg, grouped))
								])
							])))
				]),
			$author$project$Components$OrganizationSwitcher$viewTrigger(currentOrg.Bq),
			model.nN);
	});
var $author$project$Components$OrganizationSwitcher$view = F2(
	function (currentOrg, _v0) {
		var model = _v0;
		var _v1 = model.tu;
		if (_v1.$ === 3) {
			var orgs = _v1.a;
			return A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$textSm, $author$project$Ui$Element$itemsCenter]),
				_List_fromArray(
					[
						A3($author$project$Components$OrganizationSwitcher$viewDropdown, currentOrg, model, orgs)
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$OrganizationSwitcher$viewFor = F3(
	function (toMsg, organization, model) {
		return A2(
			$elm$html$Html$map,
			toMsg,
			A2($author$project$Components$OrganizationSwitcher$view, organization, model));
	});
var $author$project$Components$OrganizationSwitcher$maybeViewFor = F2(
	function (toMsg, maybeConfig) {
		return A2(
			$elm$core$Maybe$andThen,
			function (config) {
				return $author$project$Components$OrganizationSwitcher$hasInlineOrgs(config.aiO) ? $elm$core$Maybe$Just(
					A3($author$project$Components$OrganizationSwitcher$viewFor, toMsg, config.Yr, config.aiO)) : $elm$core$Maybe$Nothing;
			},
			maybeConfig);
	});
var $author$project$Ui$Icon$Sidenav = {$: 8};
var $author$project$Ui$Icon$sidenav = $author$project$Ui$Icon$Sidenav;
var $author$project$Ui$Tooltip$Stacking = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Tooltip$stackingOrder = $author$project$Ui$Tooltip$Stacking;
var $author$project$Ui$StackingOrder$z1030 = 1030;
var $author$project$Ui$Tooltip$stackingOrder1030 = $author$project$Ui$Tooltip$stackingOrder($author$project$Ui$StackingOrder$z1030);
var $author$project$Navbars$Company$subNavClasses = F2(
	function (subnav, openSubNav) {
		return 'sidenav__item sidenav__subnav' + (_Utils_eq(subnav, openSubNav) ? ' sidenav__subnav--open' : '');
	});
var $author$project$Api$FeatureGate$EmployeeUploads = 8;
var $author$project$Navbars$Company$LinkClicked = {$: 0};
var $author$project$Api$Employer$Company$One$hideSponsorInvoices = function (_v0) {
	var record = _v0.b;
	return record.Ts;
};
var $author$project$Api$Employer$Practice$One$hideSponsorInvoices = function (_v0) {
	var record = _v0;
	return record.Ts;
};
var $author$project$Navbars$Utils$ifConfiguration = F2(
	function (showSetting, body) {
		return showSetting ? body : $author$project$Utils$Html$empty;
	});
var $author$project$Navbars$Utils$selectedNavClass = F3(
	function (modifier, nav, selectedNav) {
		return 'sidenav__item' + (($elm$core$String$isEmpty(modifier) ? '' : (' ' + modifier)) + (_Utils_eq(nav, selectedNav) ? ' sidenav__active' : ''));
	});
var $author$project$Navbars$Company$selectedNavClass = $author$project$Navbars$Utils$selectedNavClass('sidenav__item--company');
var $author$project$Navbars$Company$viewDesktopNavElements = F6(
	function (hinterViewOff, _v0, company, practice, sessionConfiguration, navItem) {
		var selectedNav = _v0.fd;
		var tooltipOptions = _List_fromArray(
			[
				$author$project$Ui$Tooltip$placement(3),
				$author$project$Ui$Tooltip$stackingOrder1030
			]);
		var companyId = $author$project$Api$Employer$Company$One$id(company);
		var _v1 = navItem.At;
		switch (_v1) {
			case 0:
				var route = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top(
					{fZ: companyId});
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Company$selectedNavClass, 0, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Tooltip$view,
							tooltipOptions,
							'Employees',
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									route,
									_List_fromArray(
										[
											$author$project$Ui$Link$onClick($author$project$Navbars$Company$LinkClicked),
											$author$project$Ui$Link$test('employees')
										]),
									_List_fromArray(
										[
											$author$project$Ui$Icon$employees(
											_List_fromArray(
												[$author$project$Ui$Icon$sidenav]))
										]))
								]))
						]));
			case 1:
				var hideSponsorInvoices = $author$project$Api$Employer$Company$One$hideSponsorInvoices(company) || $author$project$Api$Employer$Practice$One$hideSponsorInvoices(practice);
				if (hideSponsorInvoices) {
					return $author$project$Utils$Html$empty;
				} else {
					var route = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Top(
						{fZ: companyId});
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(
								A2($author$project$Navbars$Company$selectedNavClass, 1, selectedNav))
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Tooltip$view,
								tooltipOptions,
								'Invoices',
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										route,
										_List_fromArray(
											[
												$author$project$Ui$Link$onClick($author$project$Navbars$Company$LinkClicked),
												$author$project$Ui$Link$test('invoices')
											]),
										_List_fromArray(
											[
												$author$project$Ui$Icon$invoices(
												_List_fromArray(
													[$author$project$Ui$Icon$sidenav]))
											]))
									]))
							]));
				}
			case 2:
				var route = $author$project$Spa$Generated$Route$Companies__CompanyId_String__PaymentSources(
					{fZ: companyId});
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Company$selectedNavClass, 2, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Tooltip$view,
							tooltipOptions,
							'Payment Methods',
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									route,
									_List_fromArray(
										[
											$author$project$Ui$Link$onClick($author$project$Navbars$Company$LinkClicked),
											$author$project$Ui$Link$test('paymentMethods')
										]),
									_List_fromArray(
										[
											$author$project$Ui$Icon$paymentMethods(
											_List_fromArray(
												[$author$project$Ui$Icon$sidenav]))
										]))
								]))
						]));
			case 3:
				var route = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__Top(
					{fZ: companyId});
				var canSeeEmployeeUploads = A2(
					$author$project$Utils$FeatureGate$gateAvailable,
					8,
					$author$project$Api$Practice$Employer(practice)) || sessionConfiguration.Aq(hinterViewOff);
				return A2(
					$author$project$Navbars$Utils$ifConfiguration,
					canSeeEmployeeUploads,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(
								A2($author$project$Navbars$Company$selectedNavClass, 3, selectedNav))
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Tooltip$view,
								tooltipOptions,
								'Employee Uploads',
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										route,
										_List_fromArray(
											[
												$author$project$Ui$Link$onClick($author$project$Navbars$Company$LinkClicked),
												$author$project$Ui$Link$test('employee-uploads')
											]),
										_List_fromArray(
											[
												$author$project$Ui$Icon$employeeUploads(
												_List_fromArray(
													[$author$project$Ui$Icon$sidenav]))
											]))
									]))
							])));
			case 4:
				var route = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Signup(
					{fZ: companyId});
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Company$selectedNavClass, 4, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Tooltip$view,
							tooltipOptions,
							'Online Signup',
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									route,
									_List_fromArray(
										[
											$author$project$Ui$Link$onClick($author$project$Navbars$Company$LinkClicked),
											$author$project$Ui$Link$test('online-signup')
										]),
									_List_fromArray(
										[
											$author$project$Ui$Icon$onlineSignup(
											_List_fromArray(
												[$author$project$Ui$Icon$sidenav]))
										]))
								]))
						]));
			case 5:
				var route = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Top(
					{fZ: companyId});
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Company$selectedNavClass, 5, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Tooltip$view,
							tooltipOptions,
							'Account & Pricing',
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									route,
									_List_fromArray(
										[
											$author$project$Ui$Link$onClick($author$project$Navbars$Company$LinkClicked),
											$author$project$Ui$Link$test('account-and-pricing')
										]),
									_List_fromArray(
										[
											$author$project$Ui$Icon$accountAndPricing(
											_List_fromArray(
												[$author$project$Ui$Icon$sidenav]))
										]))
								]))
						]));
			default:
				return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Navbars$Company$viewMobileNavElements = F6(
	function (hinterViewOff, _v0, company, practice, sessionConfiguration, navItem) {
		var selectedNav = _v0.fd;
		var companyId = $author$project$Api$Employer$Company$One$id(company);
		var _v1 = navItem.At;
		switch (_v1) {
			case 0:
				var route = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top(
					{fZ: companyId});
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Company$selectedNavClass, 0, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							route,
							_List_fromArray(
								[
									$author$project$Ui$Link$onClick($author$project$Navbars$Company$LinkClicked),
									$author$project$Ui$Link$test('employees')
								]),
							_List_fromArray(
								[
									$author$project$Ui$Icon$employees(
									_List_fromArray(
										[$author$project$Ui$Icon$sidenav])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Employees')
										]))
								]))
						]));
			case 1:
				var hideSponsorInvoices = $author$project$Api$Employer$Company$One$hideSponsorInvoices(company) || $author$project$Api$Employer$Practice$One$hideSponsorInvoices(practice);
				if (hideSponsorInvoices) {
					return $author$project$Utils$Html$empty;
				} else {
					var route = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Top(
						{fZ: companyId});
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(
								A2($author$project$Navbars$Company$selectedNavClass, 1, selectedNav))
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Link$route,
								route,
								_List_fromArray(
									[
										$author$project$Ui$Link$onClick($author$project$Navbars$Company$LinkClicked),
										$author$project$Ui$Link$test('invoices')
									]),
								_List_fromArray(
									[
										$author$project$Ui$Icon$invoices(
										_List_fromArray(
											[$author$project$Ui$Icon$sidenav])),
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Invoices')
											]))
									]))
							]));
				}
			case 2:
				var route = $author$project$Spa$Generated$Route$Companies__CompanyId_String__PaymentSources(
					{fZ: companyId});
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Company$selectedNavClass, 2, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							route,
							_List_fromArray(
								[
									$author$project$Ui$Link$onClick($author$project$Navbars$Company$LinkClicked),
									$author$project$Ui$Link$test('paymentMethods')
								]),
							_List_fromArray(
								[
									$author$project$Ui$Icon$paymentMethods(
									_List_fromArray(
										[$author$project$Ui$Icon$sidenav])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Payment Methods')
										]))
								]))
						]));
			case 3:
				var route = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__Top(
					{fZ: companyId});
				var canSeeEmployeeUploads = A2(
					$author$project$Utils$FeatureGate$gateAvailable,
					8,
					$author$project$Api$Practice$Employer(practice)) || sessionConfiguration.Aq(hinterViewOff);
				return A2(
					$author$project$Navbars$Utils$ifConfiguration,
					canSeeEmployeeUploads,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(
								A2($author$project$Navbars$Company$selectedNavClass, 3, selectedNav))
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Link$route,
								route,
								_List_fromArray(
									[
										$author$project$Ui$Link$onClick($author$project$Navbars$Company$LinkClicked),
										$author$project$Ui$Link$test('employee-uploads')
									]),
								_List_fromArray(
									[
										$author$project$Ui$Icon$employeeUploads(
										_List_fromArray(
											[$author$project$Ui$Icon$sidenav])),
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Employee Uploads')
											]))
									]))
							])));
			case 4:
				var route = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Signup(
					{fZ: companyId});
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Company$selectedNavClass, 4, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							route,
							_List_fromArray(
								[
									$author$project$Ui$Link$onClick($author$project$Navbars$Company$LinkClicked),
									$author$project$Ui$Link$test('online-signup')
								]),
							_List_fromArray(
								[
									$author$project$Ui$Icon$onlineSignup(
									_List_fromArray(
										[$author$project$Ui$Icon$sidenav])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Online Signup')
										]))
								]))
						]));
			case 5:
				var route = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Top(
					{fZ: companyId});
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Company$selectedNavClass, 5, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							route,
							_List_fromArray(
								[
									$author$project$Ui$Link$onClick($author$project$Navbars$Company$LinkClicked),
									$author$project$Ui$Link$test('account-and-pricing')
								]),
							_List_fromArray(
								[
									$author$project$Ui$Icon$accountAndPricing(
									_List_fromArray(
										[$author$project$Ui$Icon$sidenav])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Account & Pricing')
										]))
								]))
						]));
			default:
				return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Navbars$Utils$viewOrganizationHeader = F2(
	function (organizationName, canSwitchOrganizations) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('sidenav__header')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sidenav__header--right')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Icon$location(_List_Nil),
									$elm$html$Html$text(organizationName)
								])),
							A2(
							$author$project$Navbars$Utils$ifConfiguration,
							canSwitchOrganizations,
							A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$User__Organizations__Top,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Change')
									])))
						]))
				]));
	});
var $author$project$Navbars$Company$LogoutClicked = {$: 1};
var $author$project$Navbars$Company$viewProfileSubNav = function (selectedNav) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('sidenav__subnav__content')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(
						A2($author$project$Navbars$Company$selectedNavClass, 6, selectedNav))
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$User__Profile,
						_List_fromArray(
							[
								$author$project$Ui$Link$onClick($author$project$Navbars$Company$LinkClicked),
								$author$project$Ui$Link$test('account-profile')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Profile')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('sidenav__item')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Logout'},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$onClick($author$project$Navbars$Company$LogoutClicked),
								$author$project$Ui$Button$test('account-logout')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Logout')
							]))
					]))
			]));
};
var $author$project$Navbars$Utils$viewTopNavEnd = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$id('topnav-end'),
			$elm$html$Html$Attributes$class('topnav__end')
		]),
	_List_Nil);
var $author$project$Navbars$Company$SidenavToggled = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$WhitelabelSetting$practiceFacingLogoAltText = function (_v0) {
	var record = _v0;
	return record.Jg;
};
var $author$project$Navbars$Company$viewLogo = F3(
	function (whitelabelSetting, practiceName, maybeLinkOptions) {
		var _v0 = _Utils_Tuple2(
			$author$project$Api$WhitelabelSetting$practiceFacingLogoAltText(whitelabelSetting),
			$author$project$Api$WhitelabelSetting$practiceFacingLogoUrl(whitelabelSetting));
		var altText = _v0.a;
		var maybeLogoUrl = _v0.b;
		if (!maybeLogoUrl.$) {
			var logoUrl = maybeLogoUrl.a;
			if (logoUrl === '') {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'display', 'inline')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(practiceName)
						]));
			} else {
				if (!maybeLinkOptions.$) {
					var listOptions = maybeLinkOptions.a;
					return A3(
						$author$project$Ui$Link$externalHref,
						'/',
						listOptions,
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Image$fromSrc,
								{LD: altText},
								logoUrl,
								_List_fromArray(
									[
										$author$project$Ui$Image$height(40)
									]))
							]));
				} else {
					return A3(
						$author$project$Ui$Image$fromSrc,
						{LD: altText},
						logoUrl,
						_List_fromArray(
							[
								$author$project$Ui$Image$height(40)
							]));
				}
			}
		} else {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'display', 'inline')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(practiceName)
					]));
		}
	});
var $author$project$Navbars$Utils$viewSwitchOrganizationLink = F2(
	function (organizationName, canSwitchOrganizations) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('topnav__left--content')
				]),
			canSwitchOrganizations ? _List_fromArray(
				[
					A3(
					$author$project$Ui$Link$route,
					$author$project$Spa$Generated$Route$User__Organizations__Top,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Icon$view,
							_List_fromArray(
								[
									$author$project$Ui$Icon$class('topnav__icon topnav__icon--location')
								]),
							14),
							$elm$html$Html$text(organizationName),
							A2(
							$author$project$Ui$Icon$view,
							_List_fromArray(
								[
									$author$project$Ui$Icon$class('topnav__icon topnav__icon--change')
								]),
							20)
						]))
				]) : _List_fromArray(
				[
					A2(
					$author$project$Ui$Icon$view,
					_List_fromArray(
						[
							$author$project$Ui$Icon$class('topnav__icon topnav__icon--location')
						]),
					14),
					$elm$html$Html$text(organizationName)
				]));
	});
var $author$project$Navbars$Company$viewTopNavbar = F5(
	function (_v0, whitelabelSetting, companyName, sessionConfig, maybeOrgSwitcher) {
		var slideIn = _v0.qh;
		var practice = _v0.ZV;
		var patientFacingLogoSection = A3(
			$author$project$Navbars$Company$viewLogo,
			whitelabelSetting,
			$author$project$Api$Employer$Practice$One$name(practice),
			$elm$core$Maybe$Just(
				_List_fromArray(
					[
						$author$project$Ui$Link$ariaLabel('Home')
					])));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('elm-mobile-nav')
						]),
					$elm$core$List$concat(
						_List_fromArray(
							[
								_List_fromArray(
								[patientFacingLogoSection]),
								slideIn ? _List_Nil : _List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('sidenav-open')
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{mm: 'Display side navigation menu'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick(
													$author$project$Navbars$Company$SidenavToggled(true))
												]),
											_List_fromArray(
												[
													$author$project$Ui$Icon$burgerMenu(_List_Nil)
												]))
										]))
								])
							]))),
					slideIn ? A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sidenav-close')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Close side navigation menu'},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$onClick(
									$author$project$Navbars$Company$SidenavToggled(false))
								]),
							_List_fromArray(
								[
									$author$project$Ui$Icon$burgerMenuClose(_List_Nil)
								]))
						])) : $author$project$Utils$Html$empty,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('topnav')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('topnav__left')
								]),
							_List_fromArray(
								[
									patientFacingLogoSection,
									A2(
									$elm$core$Maybe$withDefault,
									A2($author$project$Navbars$Utils$viewSwitchOrganizationLink, companyName, sessionConfig.Nk),
									maybeOrgSwitcher)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('topnav__right')
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$Navbars$Company$view = F3(
	function (hinterViewOff, maybeOrgSwitcherConfig, _v0) {
		var model = _v0;
		var practice = model.ZV;
		var whitelabelSetting = model.aey;
		var company = model.afQ;
		var sessionConfiguration = model.Ex;
		var slideIn = model.qh;
		var tooltipOptions = _List_fromArray(
			[
				$author$project$Ui$Tooltip$placement(3),
				$author$project$Ui$Tooltip$stackingOrder1030
			]);
		var profileMobileView = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					A2($author$project$Navbars$Company$subNavClasses, 0, model.dw) + ' sidenav__item--profile-mobile')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{mm: 'Profile'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$onClick(
							$author$project$Navbars$Company$NavClicked(0)),
							$author$project$Ui$Button$test('account-profile-mobile')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Icon$account(
							_List_fromArray(
								[$author$project$Ui$Icon$sidenav])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sidenav__profile-name')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(sessionConfiguration.amm)
								])),
							A2(
							$author$project$Ui$Icon$view,
							_List_fromArray(
								[
									$author$project$Ui$Icon$class('sidenav__icon--show-more ml-2')
								]),
							12)
						])),
					$author$project$Navbars$Company$viewProfileSubNav(model.fd)
				]));
		var profileMenuView = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('sidenav__item sidenav__item--profile sidenav__item--profile-desktop'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('sidenav__active', model.fd === 6)
						]))
				]),
			$elm$core$List$singleton(
				A4(
					$author$project$Ui$FlyoutMenu$view,
					_List_fromArray(
						[
							$author$project$Ui$FlyoutMenu$position(1)
						]),
					_List_fromArray(
						[
							$author$project$Ui$FlyoutMenu$body(
							_List_fromArray(
								[
									$author$project$Navbars$Company$viewProfileSubNav(model.fd)
								]))
						]),
					A3(
						$author$project$Ui$Tooltip$view,
						tooltipOptions,
						'Profile',
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Profile'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$test('account-profile')
									]),
								_List_fromArray(
									[
										$author$project$Ui$Icon$account(
										_List_fromArray(
											[$author$project$Ui$Icon$sidenav]))
									]))
							])),
					model.eZ)));
		var orgSwitcherHtml = A2($author$project$Components$OrganizationSwitcher$maybeViewFor, $author$project$Navbars$Company$OrgSwitcherMsg, maybeOrgSwitcherConfig);
		var navElementsMobile = A2(
			$elm$core$List$map,
			A5($author$project$Navbars$Company$viewMobileNavElements, hinterViewOff, model, company, practice, sessionConfiguration),
			$author$project$Navbars$Company$defaultNav);
		var navElementsDesktop = A2(
			$elm$core$List$map,
			A5($author$project$Navbars$Company$viewDesktopNavElements, hinterViewOff, model, company, practice, sessionConfiguration),
			$author$project$Navbars$Company$defaultNav);
		return _List_fromArray(
			[
				A5(
				$author$project$Navbars$Company$viewTopNavbar,
				model,
				whitelabelSetting,
				$author$project$Api$Employer$Company$One$name(company),
				sessionConfiguration,
				orgSwitcherHtml),
				$author$project$Navbars$Utils$viewTopNavEnd,
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id('sidenav'),
						$elm$html$Html$Attributes$class('sidenav'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('sidenav--slide-in', slideIn)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Navbars$Utils$viewOrganizationHeader,
						$author$project$Api$Employer$Company$One$name(company),
						sessionConfiguration.Nk),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('sidenav__main sidenav__main--mobile')
							]),
						navElementsMobile),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('sidenav__main sidenav__main--desktop')
							]),
						navElementsDesktop),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('sidenav__bottom')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('sidenav__bottom-separator')
									]),
								_List_Nil),
								profileMobileView,
								profileMenuView
							]))
					]))
			]);
	});
var $author$project$Navbars$Partner$NavClicked = function (a) {
	return {$: 4, a: a};
};
var $author$project$Navbars$Partner$OrgSwitcherMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Navbars$Partner$defaultNav = F2(
	function (isHinter, partner) {
		var isManaged = !_Utils_eq(
			$author$project$Api$Partner$Partner$One$managedBy(partner),
			$elm$core$Maybe$Nothing);
		var hideBilling = (!$author$project$Api$Partner$Partner$One$active(partner)) || isManaged;
		return A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					{At: 7}),
					$elm$core$Maybe$Just(
					{At: 0}),
					$elm$core$Maybe$Just(
					{At: 5}),
					hideBilling ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					{At: 2}),
					(!$author$project$Api$Partner$Partner$One$active(partner)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					{At: 3}),
					(!$author$project$Api$Partner$Partner$One$active(partner)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					{At: 4}),
					$author$project$Api$Partner$Partner$One$sandboxEnabled(partner) ? $elm$core$Maybe$Just(
					{At: 6}) : $elm$core$Maybe$Nothing,
					$elm$core$Maybe$Just(
					{At: 9}),
					isHinter ? $elm$core$Maybe$Just(
					{At: 1}) : $elm$core$Maybe$Nothing
				]));
	});
var $author$project$Navbars$Partner$subNavClasses = F2(
	function (subnav, openSubNav) {
		return 'sidenav__item sidenav__subnav' + (_Utils_eq(subnav, openSubNav) ? ' sidenav__subnav--open' : '');
	});
var $author$project$Navbars$Partner$LinkClicked = {$: 0};
var $author$project$Navbars$Partner$selectedNavClass = $author$project$Navbars$Utils$selectedNavClass('sidenav__item--partner');
var $author$project$Navbars$Partner$viewDesktopNavElements = F5(
	function (_v0, _v1, _v2, _v3, navItem) {
		var selectedNav = _v1.fd;
		var tooltipOptions = _List_fromArray(
			[
				$author$project$Ui$Tooltip$placement(3),
				$author$project$Ui$Tooltip$stackingOrder1030
			]);
		var _v4 = navItem.At;
		switch (_v4) {
			case 0:
				var route = $author$project$Spa$Generated$Route$Partner__Team;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Partner$selectedNavClass, 0, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Tooltip$view,
							tooltipOptions,
							'Team',
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									route,
									_List_fromArray(
										[
											$author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
											$author$project$Ui$Link$test('team')
										]),
									_List_fromArray(
										[
											$author$project$Ui$Icon$groups(
											_List_fromArray(
												[$author$project$Ui$Icon$sidenav]))
										]))
								]))
						]));
			case 7:
				var route = $author$project$Spa$Generated$Route$Partner__Dashboard__Top;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Partner$selectedNavClass, 7, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Tooltip$view,
							tooltipOptions,
							'Dashboard',
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									route,
									_List_fromArray(
										[
											$author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
											$author$project$Ui$Link$test('products')
										]),
									_List_fromArray(
										[
											$author$project$Ui$Icon$dashboard(
											_List_fromArray(
												[$author$project$Ui$Icon$sidenav]))
										]))
								]))
						]));
			case 3:
				var route = $author$project$Spa$Generated$Route$Partner__ApiKeys;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Partner$selectedNavClass, 3, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Tooltip$view,
							tooltipOptions,
							'Api Keys',
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									route,
									_List_fromArray(
										[
											$author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
											$author$project$Ui$Link$test('partner-api-keys')
										]),
									_List_fromArray(
										[
											$author$project$Ui$Icon$apiKey(
											_List_fromArray(
												[$author$project$Ui$Icon$sidenav]))
										]))
								]))
						]));
			case 4:
				var route = $author$project$Spa$Generated$Route$Partner__Webhooks__Settings;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Partner$selectedNavClass, 4, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Tooltip$view,
							tooltipOptions,
							'Webhooks',
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									route,
									_List_fromArray(
										[
											$author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
											$author$project$Ui$Link$test('partner-webhooks')
										]),
									_List_fromArray(
										[
											$author$project$Ui$Icon$webhook(
											_List_fromArray(
												[$author$project$Ui$Icon$sidenav]))
										]))
								]))
						]));
			case 5:
				var route = $author$project$Spa$Generated$Route$Partner__Engagements;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Partner$selectedNavClass, 5, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Tooltip$view,
							tooltipOptions,
							'Engagements',
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									route,
									_List_fromArray(
										[
											$author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
											$author$project$Ui$Link$test('practices')
										]),
									_List_fromArray(
										[
											$author$project$Ui$Icon$demography(
											_List_fromArray(
												[$author$project$Ui$Icon$sidenav]))
										]))
								]))
						]));
			case 1:
				var route = $author$project$Spa$Generated$Route$Partner__Hinter;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Partner$selectedNavClass, 1, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Tooltip$view,
							tooltipOptions,
							'Hint',
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									route,
									_List_fromArray(
										[
											$author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
											$author$project$Ui$Link$test('hinter')
										]),
									_List_fromArray(
										[
											$author$project$Ui$Icon$hintHeartFlat(
											_List_fromArray(
												[$author$project$Ui$Icon$sidenav]))
										]))
								]))
						]));
			case 2:
				var route = $author$project$Spa$Generated$Route$Partner__Billing;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Partner$selectedNavClass, 2, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Tooltip$view,
							tooltipOptions,
							'Billing',
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									route,
									_List_fromArray(
										[
											$author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
											$author$project$Ui$Link$test('billing')
										]),
									_List_fromArray(
										[
											$author$project$Ui$Icon$dollar(
											_List_fromArray(
												[$author$project$Ui$Icon$sidenav]))
										]))
								]))
						]));
			case 6:
				var route = $author$project$Spa$Generated$Route$Partner__Sandboxes__Top;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Partner$selectedNavClass, 6, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Tooltip$view,
							tooltipOptions,
							'Sandboxes',
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									route,
									_List_fromArray(
										[
											$author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
											$author$project$Ui$Link$test('sandboxes')
										]),
									_List_fromArray(
										[
											$author$project$Ui$Icon$dev(
											_List_fromArray(
												[$author$project$Ui$Icon$sidenav]))
										]))
								]))
						]));
			case 8:
				return $author$project$Utils$Html$empty;
			default:
				return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Navbars$HinterIdButtons$CopyOrganization = 1;
var $author$project$Navbars$HinterIdButtons$CopyResource = 0;
var $author$project$Navbars$HinterIdButtons$viewButton = F2(
	function (msg, button) {
		return A3(
			$author$project$Ui$Button$view,
			{mm: button.mm},
			_List_fromArray(
				[
					$author$project$Ui$Button$link,
					$author$project$Ui$Button$onClick(msg)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$text,
					_List_fromArray(
						[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
					button.aih)
				]));
	});
var $author$project$Navbars$HinterIdButtons$view = F2(
	function (isHinter, _v0) {
		var resource = _v0.Jy;
		var organizationId = _v0.ajD;
		return isHinter ? A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$flex, $author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$gap]),
			_List_fromArray(
				[
					A2(
					$author$project$Navbars$HinterIdButtons$viewButton,
					0,
					$author$project$Navbars$HinterIdButtons$resourceButton(resource)),
					A2(
					$author$project$Ui$Typography$text,
					_List_fromArray(
						[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
					'|'),
					A2(
					$author$project$Navbars$HinterIdButtons$viewButton,
					1,
					$author$project$Navbars$HinterIdButtons$organizationButton(organizationId))
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Navbars$Partner$viewHinterIdButtons = F2(
	function (model, isHinter) {
		return A2(
			$elm$html$Html$map,
			$author$project$Navbars$Partner$HinterIdButtonsMsg,
			A2($author$project$Navbars$HinterIdButtons$view, isHinter, model.sz));
	});
var $author$project$Navbars$Partner$viewMobileNavElements = F5(
	function (_v0, _v1, _v2, _v3, navItem) {
		var selectedNav = _v1.fd;
		var _v4 = navItem.At;
		switch (_v4) {
			case 0:
				var route = $author$project$Spa$Generated$Route$Partner__Team;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Partner$selectedNavClass, 0, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							route,
							_List_fromArray(
								[
									$author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
									$author$project$Ui$Link$test('team')
								]),
							_List_fromArray(
								[
									$author$project$Ui$Icon$groups(
									_List_fromArray(
										[$author$project$Ui$Icon$sidenav])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Team')
										]))
								]))
						]));
			case 7:
				var route = $author$project$Spa$Generated$Route$Partner__Dashboard__Top;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Partner$selectedNavClass, 7, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							route,
							_List_fromArray(
								[
									$author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Icon$dashboard(
									_List_fromArray(
										[$author$project$Ui$Icon$sidenav])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Dashboard')
										]))
								]))
						]));
			case 3:
				var route = $author$project$Spa$Generated$Route$Partner__ApiKeys;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Partner$selectedNavClass, 3, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							route,
							_List_fromArray(
								[
									$author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
									$author$project$Ui$Link$test('partner-api-keys')
								]),
							_List_fromArray(
								[
									$author$project$Ui$Icon$apiKey(
									_List_fromArray(
										[$author$project$Ui$Icon$sidenav])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Api Keys')
										]))
								]))
						]));
			case 4:
				var route = $author$project$Spa$Generated$Route$Partner__Webhooks__Settings;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Partner$selectedNavClass, 4, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							route,
							_List_fromArray(
								[
									$author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
									$author$project$Ui$Link$test('partner-webhooks')
								]),
							_List_fromArray(
								[
									$author$project$Ui$Icon$webhook(
									_List_fromArray(
										[$author$project$Ui$Icon$sidenav])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Webhooks')
										]))
								]))
						]));
			case 5:
				var route = $author$project$Spa$Generated$Route$Partner__Engagements;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Partner$selectedNavClass, 5, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							route,
							_List_fromArray(
								[
									$author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
									$author$project$Ui$Link$test('practices')
								]),
							_List_fromArray(
								[
									$author$project$Ui$Icon$practices(
									_List_fromArray(
										[$author$project$Ui$Icon$sidenav])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Engagements')
										]))
								]))
						]));
			case 1:
				var route = $author$project$Spa$Generated$Route$Partner__Hinter;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Partner$selectedNavClass, 1, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							route,
							_List_fromArray(
								[
									$author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
									$author$project$Ui$Link$test('hinter')
								]),
							_List_fromArray(
								[
									$author$project$Ui$Icon$hintHeartFlat(
									_List_fromArray(
										[$author$project$Ui$Icon$sidenav])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Hint')
										]))
								]))
						]));
			case 6:
				var route = $author$project$Spa$Generated$Route$Partner__Sandboxes__Top;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Partner$selectedNavClass, 6, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							route,
							_List_fromArray(
								[
									$author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
									$author$project$Ui$Link$test('sandboxes')
								]),
							_List_fromArray(
								[
									$author$project$Ui$Icon$sandbox(
									_List_fromArray(
										[$author$project$Ui$Icon$sidenav])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Sandboxes')
										]))
								]))
						]));
			case 2:
				var route = $author$project$Spa$Generated$Route$Partner__Billing;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Partner$selectedNavClass, 2, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							route,
							_List_fromArray(
								[
									$author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
									$author$project$Ui$Link$test('billing')
								]),
							_List_fromArray(
								[
									$author$project$Ui$Icon$dollar(
									_List_fromArray(
										[$author$project$Ui$Icon$sidenav])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Billing')
										]))
								]))
						]));
			case 8:
				return $author$project$Utils$Html$empty;
			default:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Partner$selectedNavClass, 9, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Marketplace__Top,
							_List_fromArray(
								[
									$author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
									$author$project$Ui$Link$test('marketplace')
								]),
							_List_fromArray(
								[
									$author$project$Ui$Icon$marketplace(
									_List_fromArray(
										[$author$project$Ui$Icon$sidenav])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Marketplace')
										]))
								]))
						]));
		}
	});
var $author$project$Navbars$Partner$LogoutClicked = {$: 1};
var $author$project$Navbars$Partner$viewProfileSubNav = function (selectedNav) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('sidenav__subnav__content')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(
						A2($author$project$Navbars$Partner$selectedNavClass, 8, selectedNav))
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$User__Profile,
						_List_fromArray(
							[
								$author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
								$author$project$Ui$Link$test('account-profile')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Profile')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('sidenav__item')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Logout'},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$onClick($author$project$Navbars$Partner$LogoutClicked),
								$author$project$Ui$Button$test('account-logout')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Logout')
							]))
					]))
			]));
};
var $author$project$Navbars$Partner$SidenavToggled = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Image$viewHintLogoImage = function (optionsMinusAlt) {
	return A3(
		$author$project$Ui$Image$viewImg,
		{LD: 'Hint Logo'},
		$author$project$Ui$Image$nameToCdnSrc('full-logo.svg'),
		optionsMinusAlt);
};
var $author$project$Navbars$Partner$viewLogo = $author$project$Ui$Image$viewHintLogoImage(
	_List_fromArray(
		[
			$author$project$Ui$Image$height(40)
		]));
var $author$project$Navbars$Partner$viewTopNavbar = F4(
	function (_v0, partnerName, sessionConfig, maybeOrgSwitcher) {
		var selectedNav = _v0.fd;
		var slideIn = _v0.qh;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('elm-mobile-nav')
						]),
					$elm$core$List$concat(
						_List_fromArray(
							[
								_List_fromArray(
								[$author$project$Navbars$Partner$viewLogo]),
								slideIn ? _List_Nil : _List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('sidenav-open')
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{mm: 'Display side navigation menu'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick(
													$author$project$Navbars$Partner$SidenavToggled(true))
												]),
											_List_fromArray(
												[
													$author$project$Ui$Icon$burgerMenu(_List_Nil)
												]))
										]))
								])
							]))),
					slideIn ? A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sidenav-close')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Close side navigation menu'},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$onClick(
									$author$project$Navbars$Partner$SidenavToggled(false))
								]),
							_List_fromArray(
								[
									$author$project$Ui$Icon$burgerMenuClose(_List_Nil)
								]))
						])) : $author$project$Utils$Html$empty,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('topnav')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('topnav__left')
								]),
							_List_fromArray(
								[
									$author$project$Navbars$Partner$viewLogo,
									A2(
									$elm$core$Maybe$withDefault,
									A2($author$project$Navbars$Utils$viewSwitchOrganizationLink, partnerName, sessionConfig.Nk),
									maybeOrgSwitcher)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('topnav__right')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('topnav__item'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('topnav__active', 9 === selectedNav)
												]))
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$Marketplace__Top,
											_List_fromArray(
												[
													$author$project$Ui$Link$icon($author$project$Ui$Icon$marketplace)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Marketplace')
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Navbars$Partner$view = F3(
	function (hinterViewOff, maybeOrgSwitcherConfig, _v0) {
		var model = _v0;
		var partner = model.YN;
		var sessionConfiguration = model.Ex;
		var slideIn = model.qh;
		var tooltipOptions = _List_fromArray(
			[
				$author$project$Ui$Tooltip$placement(3),
				$author$project$Ui$Tooltip$stackingOrder1030
			]);
		var profileMobileView = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					A2($author$project$Navbars$Partner$subNavClasses, 0, model.dw) + ' sidenav__item--profile-mobile')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{mm: 'Profile'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$onClick(
							$author$project$Navbars$Partner$NavClicked(0)),
							$author$project$Ui$Button$test('account-profile-mobile')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Icon$account(
							_List_fromArray(
								[$author$project$Ui$Icon$sidenav])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sidenav__profile-name')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(sessionConfiguration.amm)
								])),
							A2(
							$author$project$Ui$Icon$view,
							_List_fromArray(
								[
									$author$project$Ui$Icon$class('sidenav__icon--show-more ml-2')
								]),
							12)
						])),
					$author$project$Navbars$Partner$viewProfileSubNav(model.fd)
				]));
		var profileMenuView = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('sidenav__item sidenav__item--profile sidenav__item--profile-desktop'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('sidenav__active', model.fd === 8)
						]))
				]),
			$elm$core$List$singleton(
				A4(
					$author$project$Ui$FlyoutMenu$view,
					_List_fromArray(
						[
							$author$project$Ui$FlyoutMenu$position(1)
						]),
					_List_fromArray(
						[
							$author$project$Ui$FlyoutMenu$body(
							_List_fromArray(
								[
									$author$project$Navbars$Partner$viewProfileSubNav(model.fd)
								]))
						]),
					A3(
						$author$project$Ui$Tooltip$view,
						tooltipOptions,
						'Profile',
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Profile'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$test('account-profile')
									]),
								_List_fromArray(
									[
										$author$project$Ui$Icon$account(
										_List_fromArray(
											[$author$project$Ui$Icon$sidenav]))
									]))
							])),
					model.eZ)));
		var orgSwitcherHtml = A2($author$project$Components$OrganizationSwitcher$maybeViewFor, $author$project$Navbars$Partner$OrgSwitcherMsg, maybeOrgSwitcherConfig);
		var isHinter = sessionConfiguration.Aq(hinterViewOff);
		var navElementsDesktop = A2(
			$elm$core$List$map,
			A4($author$project$Navbars$Partner$viewDesktopNavElements, hinterViewOff, model, partner, sessionConfiguration),
			A2($author$project$Navbars$Partner$defaultNav, isHinter, partner));
		var navElementsMobile = A2(
			$elm$core$List$map,
			A4($author$project$Navbars$Partner$viewMobileNavElements, hinterViewOff, model, partner, sessionConfiguration),
			A2($author$project$Navbars$Partner$defaultNav, isHinter, partner));
		return _List_fromArray(
			[
				A4(
				$author$project$Navbars$Partner$viewTopNavbar,
				model,
				$author$project$Api$Partner$Partner$One$name(partner),
				sessionConfiguration,
				orgSwitcherHtml),
				$author$project$Navbars$Utils$viewTopNavEnd,
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id('sidenav'),
						$elm$html$Html$Attributes$class('sidenav'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('sidenav--slide-in', slideIn)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Navbars$Utils$viewOrganizationHeader,
						$author$project$Api$Partner$Partner$One$name(model.YN),
						sessionConfiguration.Nk),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('sidenav__main sidenav__main--mobile')
							]),
						navElementsMobile),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('sidenav__main sidenav__main--desktop')
							]),
						navElementsDesktop),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('sidenav__bottom')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('sidenav__bottom-separator')
									]),
								_List_Nil),
								A2($author$project$Navbars$Partner$viewHinterIdButtons, model, isHinter),
								profileMobileView,
								profileMenuView
							]))
					]))
			]);
	});
var $author$project$Navbars$Practice$LinkClicked = {$: 3};
var $author$project$Navbars$Practice$NavClicked = function (a) {
	return {$: 2, a: a};
};
var $author$project$Navbars$Practice$OrgSwitcherMsg = function (a) {
	return {$: 19, a: a};
};
var $author$project$Navbars$Practice$SearchClicked = {$: 4};
var $author$project$Navbars$Practice$SidenavExpandToggled = {$: 13};
var $author$project$Navbars$Practice$SidenavToggled = function (a) {
	return {$: 11, a: a};
};
var $author$project$Navbars$Practice$Navigation$InternalRoute = function (a) {
	return {$: 0, a: a};
};
var $author$project$Navbars$Practice$Navigation$InternalRouteWithParams = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Api$Feature$NewMessagingEndpoint = 25;
var $author$project$Api$ClinicalBadges$communication = function (_v0) {
	var internal = _v0;
	return internal.N9;
};
var $author$project$Navbars$Practice$Navigation$startAndEndDateParams = F2(
	function (startDate, endDate) {
		return _List_fromArray(
			[
				A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('start'),
				$author$project$Utils$Date$toQuery)(startDate),
				A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('end'),
				$author$project$Utils$Date$toQuery)(endDate)
			]);
	});
var $author$project$Navbars$Practice$Navigation$currentMonthParams = function (maybeDate) {
	if (!maybeDate.$) {
		var currentDate_ = maybeDate.a;
		return A2(
			$author$project$Navbars$Practice$Navigation$startAndEndDateParams,
			$author$project$Utils$Date$toBeginningOfMonth(currentDate_),
			$author$project$Utils$Date$toEndOfMonth(currentDate_));
	} else {
		return _List_Nil;
	}
};
var $author$project$Api$ClinicalBadges$tasks = function (_v0) {
	var internal = _v0;
	return internal.acT;
};
var $author$project$Navbars$Practice$Navigation$mainNavItems = F5(
	function (practice, practiceConfiguration, sessionConfiguration, hinterViewOff, clinicalBadgeCounts) {
		var newMessagingEndpointEnabled = A2($author$project$Api$Provider$Practice$One$featureEnabled, 25, practice);
		var inboxRoute = newMessagingEndpointEnabled ? $author$project$Spa$Generated$Route$Messages__Chat : $author$project$Spa$Generated$Route$Messages__Sms;
		var employersText = A2($author$project$Formatters$String$sponsorize, practice, 'Employers');
		return _List_fromArray(
			[
				{
				ae9: $elm$core$Maybe$Nothing,
				ahO: $author$project$Ui$Icon$dashboard,
				At: $author$project$Navbars$Practice$Navigation$ClinicalDashboard,
				Ir: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Home),
				t: 'dashboard',
				ac3: 'Dashboard',
				h8: practiceConfiguration.qJ && practiceConfiguration.acH
			},
				{
				ae9: $elm$core$Maybe$Nothing,
				ahO: $author$project$Ui$Icon$patients,
				At: $author$project$Navbars$Practice$Navigation$Patients,
				Ir: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Patients__Top),
				t: 'patients',
				ac3: 'Patients',
				h8: sessionConfiguration.GQ(hinterViewOff)
			},
				{
				ae9: $elm$core$Maybe$Nothing,
				ahO: $author$project$Ui$Icon$calendar,
				At: $author$project$Navbars$Practice$Navigation$Calendar,
				Ir: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Calendar),
				t: 'clinical-calendar',
				ac3: 'Calendar',
				h8: practiceConfiguration.qJ && practiceConfiguration.acH
			},
				{
				ae9: A2($elm$core$Maybe$map, $author$project$Api$ClinicalBadges$communication, clinicalBadgeCounts),
				ahO: $author$project$Ui$Icon$inbox,
				At: $author$project$Navbars$Practice$Navigation$Inbox,
				Ir: $author$project$Navbars$Practice$Navigation$InternalRoute(inboxRoute),
				t: 'clinical-inbox',
				ac3: 'Inbox',
				h8: practiceConfiguration.qJ && practiceConfiguration.acH
			},
				{
				ae9: A2($elm$core$Maybe$map, $author$project$Api$ClinicalBadges$tasks, clinicalBadgeCounts),
				ahO: $author$project$Ui$Icon$task,
				At: $author$project$Navbars$Practice$Navigation$Tasks,
				Ir: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Tasks__Top),
				t: 'clinical-tasks',
				ac3: 'Tasks',
				h8: practiceConfiguration.qJ && practiceConfiguration.acH
			},
				{
				ae9: $elm$core$Maybe$Nothing,
				ahO: $author$project$Ui$Icon$form,
				At: $author$project$Navbars$Practice$Navigation$Forms,
				Ir: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Forms),
				t: 'clinical-forms',
				ac3: 'Forms',
				h8: practiceConfiguration.qJ && practiceConfiguration.acH
			},
				{
				ae9: $elm$core$Maybe$Nothing,
				ahO: $author$project$Ui$Icon$contact,
				At: $author$project$Navbars$Practice$Navigation$Contacts,
				Ir: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Contacts__List),
				t: 'clinical-contacts',
				ac3: 'Contacts',
				h8: practiceConfiguration.qJ && practiceConfiguration.acH
			},
				{
				ae9: $elm$core$Maybe$Nothing,
				ahO: $author$project$Ui$Icon$sponsors,
				At: $author$project$Navbars$Practice$Navigation$Sponsors,
				Ir: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Companies__Top),
				t: 'sponsors',
				ac3: employersText,
				h8: sessionConfiguration.Nb(hinterViewOff)
			},
				{
				ae9: $elm$core$Maybe$Nothing,
				ahO: $author$project$Ui$Icon$share,
				At: $author$project$Navbars$Practice$Navigation$Networks,
				Ir: A2($author$project$Navbars$Practice$Navigation$InternalRouteWithParams, $author$project$Spa$Generated$Route$AffiliateBills__Top, $author$project$Navbars$Practice$Navigation$currentMonthParams),
				t: 'networks',
				ac3: 'Networks',
				h8: practiceConfiguration.U_ && sessionConfiguration.Nc(hinterViewOff)
			},
				{
				ae9: $elm$core$Maybe$Nothing,
				ahO: $author$project$Ui$Icon$commissions,
				At: $author$project$Navbars$Practice$Navigation$Commissions,
				Ir: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Commissions__BrokerAccounts__Top),
				t: 'commissions',
				ac3: 'Commissions',
				h8: practiceConfiguration.N5 && sessionConfiguration.Na(hinterViewOff)
			},
				{
				ae9: $elm$core$Maybe$Nothing,
				ahO: $author$project$Ui$Icon$trendingUp,
				At: $author$project$Navbars$Practice$Navigation$Bookkeeping,
				Ir: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Bookkeeping),
				t: 'bookkeeping',
				ac3: 'Bookkeeping',
				h8: practiceConfiguration.MN && sessionConfiguration.M9(hinterViewOff)
			}
			]);
	});
var $author$project$Navbars$Practice$selectedNavClass = $author$project$Navbars$Utils$selectedNavClass('');
var $author$project$Navbars$Practice$subNavClasses = F2(
	function (subnav, openSubNav) {
		return 'sidenav__item sidenav__subnav' + (_Utils_eq(subnav, openSubNav) ? ' sidenav__subnav--open' : '');
	});
var $author$project$Components$HinterPracticeSettingsModal$SearchQueryChanged = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$HinterPracticeSettingsModal$filterFeatures = F2(
	function (query, features) {
		if ($elm$core$String$isEmpty(query)) {
			return features;
		} else {
			var lowercaseQuery = $elm$core$String$toLower(query);
			return A2(
				$elm$core$List$filter,
				function (feature) {
					return A2(
						$elm$core$String$contains,
						lowercaseQuery,
						$elm$core$String$toLower(
							$author$project$Api$Common$Feature$Shared$name(feature)));
				},
				features);
		}
	});
var $author$project$Components$HinterPracticeSettingsModal$sortFeatures = function (features) {
	return A2($elm$core$List$sortBy, $author$project$Api$Common$Feature$Shared$name, features);
};
var $author$project$Components$HinterPracticeSettingsModal$ChangeFeature = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Components$HinterPracticeSettingsModal$viewFeature = function (feature) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$itemsCenter]),
		_List_fromArray(
			[
				$author$project$Ui$Button$group(
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$view(
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$on(
								$author$project$Api$Common$Feature$Shared$enabled(feature)),
								$author$project$Ui$ToggleSwitch$onChange(
								$author$project$Components$HinterPracticeSettingsModal$ChangeFeature(
									$author$project$Api$Common$Feature$Shared$id(feature))),
								$author$project$Ui$ToggleSwitch$sm
							]))
					])),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$ml2]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Common$Feature$Shared$name(feature))
					]))
			]));
};
var $author$project$Components$HinterPracticeSettingsModal$viewFeatureFlags = function (data) {
	var _v0 = data.Sf;
	switch (_v0.$) {
		case 1:
			return A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$textMuted]),
				_List_fromArray(
					[
						$author$project$Ui$Spinner$view(
						_List_fromArray(
							[$author$project$Ui$Spinner$small])),
						$elm$html$Html$text(' Loading features...')
					]));
		case 3:
			var features = _v0.a;
			var filteredFeatures = $author$project$Components$HinterPracticeSettingsModal$sortFeatures(
				A2($author$project$Components$HinterPracticeSettingsModal$filterFeatures, data.uq, features));
			return A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$placeholder('Search features...'),
								$author$project$Ui$Form$Input$value(data.uq),
								$author$project$Ui$Form$Input$onInput($author$project$Components$HinterPracticeSettingsModal$SearchQueryChanged)
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mt4, $author$project$Ui$Element$spaceY2]),
						_List_fromArray(
							[
								$elm$core$List$isEmpty(filteredFeatures) ? A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$textMuted]),
								_List_fromArray(
									[
										$elm$html$Html$text('No features found')
									])) : A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								A2($elm$core$List$map, $author$project$Components$HinterPracticeSettingsModal$viewFeature, filteredFeatures))
							]))
					]));
		case 2:
			return $author$project$Utils$Html$empty;
		default:
			return A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$textMuted]),
				_List_fromArray(
					[
						$author$project$Ui$Spinner$view(
						_List_fromArray(
							[$author$project$Ui$Spinner$small])),
						$elm$html$Html$text(' Loading...')
					]));
	}
};
var $author$project$Components$HinterPracticeSettingsModal$ManagementGroupSelected = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$HinterPracticeSettingsModal$currentManagementGroupId = function (currentGroup) {
	return A2($elm$core$Maybe$map, $author$project$Api$Provider$ManagementGroup$Shared$id, currentGroup);
};
var $author$project$Components$HinterPracticeSettingsModal$managementGroupOptions = function (data) {
	var _v0 = data.oz;
	if (_v0.$ === 3) {
		var groups = _v0.a;
		return A2(
			$elm$core$List$cons,
			A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, 'None'),
			A2(
				$elm$core$List$map,
				function (group) {
					return A3(
						$author$project$Ui$Form$Select$option,
						_List_Nil,
						$elm$core$Maybe$Just(
							$author$project$Api$Provider$ManagementGroup$Shared$id(group)),
						$author$project$Api$Provider$ManagementGroup$Shared$name(group));
				},
				groups));
	} else {
		return _List_fromArray(
			[
				A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, 'Loading...')
			]);
	}
};
var $author$project$Components$HinterPracticeSettingsModal$viewManagementGroup = function (data) {
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$title,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Practice Settings')
							]))
					])),
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						function () {
						var _v0 = data.oz;
						switch (_v0.$) {
							case 1:
								return A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$label('Management Group')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$textMuted]),
											_List_fromArray(
												[
													$author$project$Ui$Spinner$view(
													_List_fromArray(
														[$author$project$Ui$Spinner$small])),
													$elm$html$Html$text(' Loading management groups...')
												]))
										]));
							case 3:
								return A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$label('Management Group')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Select$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Select$value(
													$author$project$Components$HinterPracticeSettingsModal$currentManagementGroupId(data.i1)),
													$author$project$Ui$Form$Select$onChange($author$project$Components$HinterPracticeSettingsModal$ManagementGroupSelected)
												]),
											$author$project$Components$HinterPracticeSettingsModal$managementGroupOptions(data))
										]));
							case 2:
								return $author$project$Utils$Html$empty;
							default:
								return A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$label('Management Group')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$textMuted]),
											_List_fromArray(
												[
													$author$project$Ui$Spinner$view(
													_List_fromArray(
														[$author$project$Ui$Spinner$small])),
													$elm$html$Html$text(' Loading...')
												]))
										]));
						}
					}()
					]))
			]));
};
var $author$project$Components$HinterPracticeSettingsModal$CopyToClipboard = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$HinterPracticeSettingsModal$GoToHinterSettings = {$: 10};
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $author$project$Components$HinterPracticeSettingsModal$formatCreatedDate = function (practice) {
	return A2(
		$author$project$Formatters$Date$toString,
		$author$project$Formatters$Date$Full,
		A2(
			$justinmimbs$date$Date$fromPosix,
			$elm$time$Time$utc,
			$author$project$Api$Provider$Practice$One$createdAt(practice)));
};
var $author$project$Components$HinterPracticeSettingsModal$viewPracticeInfo = function (data) {
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$title,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Practice Info')
							]))
					])),
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mb2, $author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Name: ')
											])),
										$elm$html$Html$text(
										$author$project$Api$Provider$Practice$One$name(data.ZV))
									])),
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Copy practice name'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$onClick(
										$author$project$Components$HinterPracticeSettingsModal$CopyToClipboard(
											$author$project$Api$Provider$Practice$One$name(data.ZV))),
										$author$project$Ui$Button$sm,
										$author$project$Ui$Button$icon($author$project$Ui$Icon$copy)
									]),
								_List_Nil)
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mb2, $author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Practice ID: ')
											])),
										$elm$html$Html$text(
										$author$project$Api$Provider$Practice$One$id(data.ZV))
									])),
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Copy practice ID'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$onClick(
										$author$project$Components$HinterPracticeSettingsModal$CopyToClipboard(
											$author$project$Api$Provider$Practice$One$id(data.ZV))),
										$author$project$Ui$Button$sm,
										$author$project$Ui$Button$icon($author$project$Ui$Icon$copy)
									]),
								_List_Nil)
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mb2, $author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Organization ID: ')
											])),
										$elm$html$Html$text(
										$author$project$Api$Provider$Practice$One$organizationId(data.ZV))
									])),
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Copy organization ID'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$onClick(
										$author$project$Components$HinterPracticeSettingsModal$CopyToClipboard(
											$author$project$Api$Provider$Practice$One$organizationId(data.ZV))),
										$author$project$Ui$Button$sm,
										$author$project$Ui$Button$icon($author$project$Ui$Icon$copy)
									]),
								_List_Nil)
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mb2, $author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Created On: ')
											])),
										$elm$html$Html$text(
										$author$project$Components$HinterPracticeSettingsModal$formatCreatedDate(data.ZV))
									])),
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Copy created date'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$onClick(
										$author$project$Components$HinterPracticeSettingsModal$CopyToClipboard(
											$author$project$Components$HinterPracticeSettingsModal$formatCreatedDate(data.ZV))),
										$author$project$Ui$Button$sm,
										$author$project$Ui$Button$icon($author$project$Ui$Icon$copy)
									]),
								_List_Nil)
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mt2]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{mm: 'Go to Hinter settings'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$onClick($author$project$Components$HinterPracticeSettingsModal$GoToHinterSettings)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Go to Clinical Hinter settings.')
									]))
							]))
					]))
			]));
};
var $author$project$Components$HinterPracticeSettingsModal$view = function (model) {
	if (model.$ === 1) {
		var data = model.a;
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$HinterPracticeSettingsModal$CloseModal,
			_List_fromArray(
				[$author$project$Ui$Modal$lg]),
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('Hinter Practice Settings')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Grid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(12),
											$author$project$Ui$Grid$spanMd(6)
										]),
									_List_fromArray(
										[
											$author$project$Components$HinterPracticeSettingsModal$viewPracticeInfo(data),
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$mt4]),
											_List_fromArray(
												[
													$author$project$Components$HinterPracticeSettingsModal$viewManagementGroup(data)
												]))
										])),
									A2(
									$author$project$Ui$Grid$column,
									_List_fromArray(
										[
											$author$project$Ui$Grid$span(12),
											$author$project$Ui$Grid$spanMd(6)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Panel$view,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Panel$heading,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Typography$title,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Feature Flags')
																]))
														])),
													A2(
													$author$project$Ui$Panel$body,
													_List_Nil,
													_List_fromArray(
														[
															$author$project$Components$HinterPracticeSettingsModal$viewFeatureFlags(data)
														]))
												]))
										]))
								]))
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Close modal'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Components$HinterPracticeSettingsModal$CloseModal)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Close')
								]))
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Navbars$Practice$DesktopExpandedStyle = {$: 2};
var $author$project$Navbars$Practice$DesktopStyle = function (a) {
	return {$: 1, a: a};
};
var $author$project$Navbars$Practice$DesktopSubNav = {$: 1};
var $author$project$Navbars$Practice$Navigation$adminSubnavItems = F2(
	function (practice, practiceConfiguration) {
		var providersItem = {
			At: 1,
			Ir: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Admin__Providers__Top),
			t: 'admin-providers',
			ac3: 'Providers & Patients',
			h8: true
		};
		var packagesEnabled = A2(
			$author$project$Utils$FeatureGate$gateAvailable,
			14,
			$author$project$Api$Practice$Provider(practice));
		var onlineSignupItem = {
			At: 3,
			Ir: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Admin__Signup),
			t: 'admin-signup',
			ac3: 'Online Signup',
			h8: true
		};
		var notificationsItem = {
			At: 7,
			Ir: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Admin__Notifications__Patient),
			t: 'admin-notifications-patient',
			ac3: 'Notifications',
			h8: true
		};
		var membershipOptionsItem = {
			At: 2,
			Ir: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Admin__Plans__Top),
			t: 'admin-plans',
			ac3: 'Membership Options',
			h8: true
		};
		var isClinicalAndCore = practiceConfiguration.qJ && practiceConfiguration.acH;
		var integrationsItem = {
			At: 9,
			Ir: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Marketplace__Manage),
			t: 'admin-stripe',
			ac3: 'Integrations',
			h8: true
		};
		var ephiItem = {
			At: 8,
			Ir: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Admin__HipaaAuthorizations),
			t: 'admin-hipaa-authorizations',
			ac3: 'ePHI Communication Waivers',
			h8: true
		};
		var employersText = A2($author$project$Formatters$String$sponsorize, practice, 'Employers');
		var employersItem = {
			At: 10,
			Ir: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Admin__InvoiceSettings),
			t: 'admin-invoice-settings',
			ac3: employersText,
			h8: practiceConfiguration.Ix
		};
		var documentsItem = {
			At: 11,
			Ir: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Admin__Documents__Top),
			t: 'admin-documents',
			ac3: 'Documents',
			h8: true
		};
		var developersItem = {
			At: 19,
			Ir: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Admin__Developers__GetStarted),
			t: 'admin-developers',
			ac3: 'Developers',
			h8: true
		};
		var dataExportItem = {
			At: 12,
			Ir: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Admin__DataExport__Top),
			t: 'admin-data-export',
			ac3: 'Data Exporter',
			h8: practiceConfiguration.Py
		};
		var creditsItem = {
			At: 4,
			Ir: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Admin__CreditCategories),
			t: 'admin-credit-categories',
			ac3: 'Credits',
			h8: practiceConfiguration.CI
		};
		var commissionsItem = {
			At: 6,
			Ir: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Admin__Commissions),
			t: 'admin-commissions-setup',
			ac3: 'Commissions',
			h8: true
		};
		var chargesText = function () {
			var _v0 = _Utils_Tuple2(packagesEnabled, practiceConfiguration.Ib);
			if (_v0.a) {
				if (_v0.b) {
					return 'Charges, Packages, & Taxes';
				} else {
					return 'Charges & Packages';
				}
			} else {
				if (_v0.b) {
					return 'Charges & Taxes';
				} else {
					return 'Charges';
				}
			}
		}();
		var chargesItem = {
			At: 5,
			Ir: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Admin__ChargeItems__Top),
			t: 'admin-charge-items',
			ac3: chargesText,
			h8: true
		};
		var accountItem = {
			At: 0,
			Ir: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Admin__Practice),
			t: 'admin-practice',
			ac3: 'Account',
			h8: true
		};
		if (isClinicalAndCore) {
			var remainingItems = _List_fromArray(
				[
					ephiItem,
					{
					At: 15,
					Ir: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$NewSettings__Erx),
					t: 'clinical-erx',
					ac3: 'eRx',
					h8: true
				},
					{
					At: 17,
					Ir: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Files__Top),
					t: 'clinical-file-drive',
					ac3: 'File Drive',
					h8: true
				},
					integrationsItem,
					{
					At: 16,
					Ir: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Inventory__List),
					t: 'clinical-medications',
					ac3: 'Medications',
					h8: true
				},
					membershipOptionsItem,
					notificationsItem,
					onlineSignupItem,
					{
					At: 20,
					Ir: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$NewSettings__PracticeInfo),
					t: 'clinical-phones',
					ac3: 'Phones',
					h8: true
				},
					providersItem,
					{
					At: 21,
					Ir: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$NewSettings__Team),
					t: 'clinical-team',
					ac3: 'Team',
					h8: true
				},
					{
					At: 18,
					Ir: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$NewSettings__Templates__Top),
					t: 'clinical-templates',
					ac3: 'Templates',
					h8: true
				}
				]);
			var clinicalCoreItems = _List_fromArray(
				[
					accountItem,
					{
					At: 14,
					Ir: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$NewSettings__AppointmentTypes__Top),
					t: 'clinical-appointment-types',
					ac3: 'Appointment Types',
					h8: true
				},
					{
					At: 13,
					Ir: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$NewSettings__Locations__Top),
					t: 'clinical-calendar-locations',
					ac3: 'Calendar > Locations',
					h8: true
				},
					chargesItem,
					commissionsItem,
					creditsItem,
					dataExportItem,
					documentsItem
				]);
			return (employersText === 'Employers') ? _Utils_ap(
				clinicalCoreItems,
				_Utils_ap(
					A2($elm$core$List$cons, employersItem, remainingItems),
					_List_fromArray(
						[developersItem]))) : _Utils_ap(
				clinicalCoreItems,
				_Utils_ap(
					remainingItems,
					_List_fromArray(
						[employersItem, developersItem])));
		} else {
			return _List_fromArray(
				[accountItem, providersItem, membershipOptionsItem, onlineSignupItem, creditsItem, chargesItem, commissionsItem, notificationsItem, ephiItem, integrationsItem, employersItem, documentsItem, dataExportItem, developersItem]);
		}
	});
var $author$project$Navbars$Practice$allSubNavBookmarkInfos = F4(
	function (practice, practiceConfiguration, currentDate, reportsSpecs) {
		var reportInfos = A2(
			$elm$core$List$map,
			function (spec) {
				return {
					aih: spec.aih,
					kp: $author$project$Navbars$Practice$Navigation$Reports(spec.H),
					e: spec.e,
					p: spec.p,
					h8: spec.h8
				};
			},
			reportsSpecs);
		var adminInfos = A2(
			$elm$core$List$map,
			function (item) {
				var _v0 = function () {
					var _v1 = item.Ir;
					if (!_v1.$) {
						var r = _v1.a;
						return _Utils_Tuple2(r, _List_Nil);
					} else {
						var r = _v1.a;
						var paramsFn = _v1.b;
						return _Utils_Tuple2(
							r,
							paramsFn(currentDate));
					}
				}();
				var route = _v0.a;
				var routeParams = _v0.b;
				return {
					aih: item.ac3,
					kp: $author$project$Navbars$Practice$Navigation$Admin(item.At),
					e: route,
					p: routeParams,
					h8: item.h8
				};
			},
			A2($author$project$Navbars$Practice$Navigation$adminSubnavItems, practice, practiceConfiguration));
		return _Utils_ap(reportInfos, adminInfos);
	});
var $author$project$Api$Common$PartnerApp$All$shared = function (_v0) {
	var shared_ = _v0;
	return shared_;
};
var $author$project$Api$Common$PartnerApp$All$embedsCorePage = A2($elm$core$Basics$composeR, $author$project$Api$Common$PartnerApp$All$shared, $author$project$Api$Common$PartnerApp$Shared$embedsCorePage);
var $author$project$Api$Common$PartnerApp$Shared$partner = function (_v0) {
	var record = _v0;
	return record.YN;
};
var $author$project$Api$Common$Partner$Min$slug = function (_v0) {
	var record = _v0;
	return record.abG;
};
var $author$project$Api$Common$PartnerApp$All$partnerSlug = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Common$PartnerApp$All$shared,
	A2($elm$core$Basics$composeR, $author$project$Api$Common$PartnerApp$Shared$partner, $author$project$Api$Common$Partner$Min$slug));
var $author$project$Navbars$Practice$Navigation$AncillaryCharges = {$: 15};
var $author$project$Navbars$Practice$Navigation$Disputes = {$: 16};
var $author$project$Api$Provider$Report$All$record = function (_v0) {
	var record_ = _v0;
	return record_;
};
var $author$project$Api$Provider$Report$All$id = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Report$All$record,
	function ($) {
		return $.ahP;
	});
var $author$project$Api$Provider$Report$idToResource = function (id) {
	switch (id) {
		case 'signup_attempts':
			return $elm$core$Maybe$Just(1);
		case 'memberships':
			return $elm$core$Maybe$Just(11);
		case 'customer_invoices':
			return $elm$core$Maybe$Just(12);
		case 'invoices':
			return $elm$core$Maybe$Just(3);
		case 'credits':
			return $elm$core$Maybe$Just(15);
		case 'revenue_lines':
			return $elm$core$Maybe$Just(6);
		case 'deferred_revenue_lines':
			return $elm$core$Maybe$Just(7);
		case 'patient_packages':
			return $elm$core$Maybe$Just(16);
		case 'payment_applications':
			return $elm$core$Maybe$Just(9);
		case 'credit_lines':
			return $elm$core$Maybe$Just(14);
		case 'deposits':
			return $elm$core$Maybe$Just(13);
		case 'tax_lines':
			return $elm$core$Maybe$Just(8);
		case 'disputes':
			return $elm$core$Maybe$Just(22);
		case 'affiliate_ancillary_charges':
			return $elm$core$Maybe$Just(23);
		case 'company_registrations':
			return $elm$core$Maybe$Just(24);
		case 'payment_method_imports':
			return $elm$core$Maybe$Just(25);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Navbars$Practice$reportsItemSpecs = F4(
	function (practice, practiceConfiguration, currentDate, reports) {
		var viewableReportResources = A2(
			$elm$core$List$filterMap,
			A2($elm$core$Basics$composeR, $author$project$Api$Provider$Report$All$id, $author$project$Api$Provider$Report$idToResource),
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$author$project$Api$Data$toMaybe(reports)));
		var trailing13MonthsParams = function () {
			if (!currentDate.$) {
				var currentDate_ = currentDate.a;
				return function (_v4) {
					var startDate = _v4.a;
					var endDate = _v4.b;
					return A2(
						$author$project$Navbars$Practice$Navigation$startAndEndDateParams,
						$author$project$Utils$Date$toBeginningOfMonth(startDate),
						endDate);
				}(
					A2($author$project$Utils$Date$trailingRange, 13, currentDate_));
			} else {
				return _List_Nil;
			}
		}();
		var trailing12MonthsParams = function () {
			if (!currentDate.$) {
				var currentDate_ = currentDate.a;
				return function (_v2) {
					var startDate = _v2.a;
					var endDate = _v2.b;
					return A2($author$project$Navbars$Practice$Navigation$startAndEndDateParams, startDate, endDate);
				}(
					A2($author$project$Utils$Date$trailingRange, 12, currentDate_));
			} else {
				return _List_Nil;
			}
		}();
		var isViewable = function (resource) {
			return A2($elm$core$List$member, resource, viewableReportResources);
		};
		var currentMonthParams = function () {
			if (!currentDate.$) {
				var currentDate_ = currentDate.a;
				return A2(
					$author$project$Navbars$Practice$Navigation$startAndEndDateParams,
					$author$project$Utils$Date$toBeginningOfMonth(currentDate_),
					$author$project$Utils$Date$toEndOfMonth(currentDate_));
			} else {
				return _List_Nil;
			}
		}();
		return _List_fromArray(
			[
				{aih: 'Dashboard', e: $author$project$Spa$Generated$Route$Reports__Dashboard, p: trailing12MonthsParams, H: $author$project$Navbars$Practice$Navigation$Dashboard, t: 'reports-dashboard', h8: true},
				{
				aih: 'Reporting Periods',
				e: $author$project$Spa$Generated$Route$Reports__Months,
				p: trailing13MonthsParams,
				H: $author$project$Navbars$Practice$Navigation$Months,
				t: 'reports-months',
				h8: isViewable(8) && (isViewable(9) && (isViewable(6) && isViewable(15)))
			},
				{
				aih: 'Signup Attempts',
				e: $author$project$Spa$Generated$Route$Reports__SignupAttempts,
				p: currentMonthParams,
				H: $author$project$Navbars$Practice$Navigation$SignupAttempts,
				t: 'reports-signup-attempts',
				h8: isViewable(1)
			},
				{
				aih: 'Memberships',
				e: $author$project$Spa$Generated$Route$Reports__Memberships,
				p: currentMonthParams,
				H: $author$project$Navbars$Practice$Navigation$Memberships,
				t: 'reports-memberships',
				h8: isViewable(11)
			},
				{
				aih: 'Package Sales',
				e: $author$project$Spa$Generated$Route$Reports__PatientPackages,
				p: _List_Nil,
				H: $author$project$Navbars$Practice$Navigation$PatientPackages,
				t: 'reports-patient-packages',
				h8: A2(
					$author$project$Utils$FeatureGate$gateAvailable,
					14,
					$author$project$Api$Practice$Provider(practice)) && isViewable(16)
			},
				{
				aih: 'Patient Invoices',
				e: $author$project$Spa$Generated$Route$Reports__Invoices,
				p: currentMonthParams,
				H: $author$project$Navbars$Practice$Navigation$Invoices,
				t: 'reports-invoices',
				h8: isViewable(12)
			},
				{
				aih: A2($author$project$Formatters$String$sponsorize, practice, 'Employer Invoices'),
				e: $author$project$Spa$Generated$Route$Reports__CompanyInvoices,
				p: currentMonthParams,
				H: $author$project$Navbars$Practice$Navigation$CompanyInvoices,
				t: 'reports-company-invoices',
				h8: isViewable(3) && practiceConfiguration.Ix
			},
				{
				aih: 'Credit Outstanding',
				e: $author$project$Spa$Generated$Route$Reports__CreditOutstanding,
				p: currentMonthParams,
				H: $author$project$Navbars$Practice$Navigation$CreditOutstanding,
				t: 'reports-credit-outstanding',
				h8: practiceConfiguration.CI && isViewable(15)
			},
				{
				aih: 'Billed Revenue',
				e: $author$project$Spa$Generated$Route$Reports__Revenue,
				p: currentMonthParams,
				H: $author$project$Navbars$Practice$Navigation$Revenue,
				t: 'reports-revenue',
				h8: isViewable(6)
			},
				{
				aih: 'Packages Deferred Revenue',
				e: $author$project$Spa$Generated$Route$Reports__DeferredRevenue,
				p: currentMonthParams,
				H: $author$project$Navbars$Practice$Navigation$DeferredRevenue,
				t: 'reports-deferred-revenue',
				h8: A2(
					$author$project$Utils$FeatureGate$gateAvailable,
					14,
					$author$project$Api$Practice$Provider(practice)) && isViewable(7)
			},
				{
				aih: 'Received Payments',
				e: $author$project$Spa$Generated$Route$Reports__PaymentApplications,
				p: currentMonthParams,
				H: $author$project$Navbars$Practice$Navigation$PaymentApplications,
				t: 'reports-payment-applications',
				h8: isViewable(9)
			},
				{
				aih: 'Credit Transactions',
				e: $author$project$Spa$Generated$Route$Reports__CreditTransactions,
				p: currentMonthParams,
				H: $author$project$Navbars$Practice$Navigation$CreditTransactions,
				t: 'reports-credit-transactions',
				h8: practiceConfiguration.CI && isViewable(14)
			},
				{
				aih: 'Deposits',
				e: $author$project$Spa$Generated$Route$Reports__Deposits,
				p: currentMonthParams,
				H: $author$project$Navbars$Practice$Navigation$Deposits,
				t: 'reports-deposits',
				h8: isViewable(13)
			},
				{
				aih: 'Disputes',
				e: $author$project$Spa$Generated$Route$Reports__Disputes,
				p: currentMonthParams,
				H: $author$project$Navbars$Practice$Navigation$Disputes,
				t: 'reports-disputes',
				h8: isViewable(22)
			},
				{
				aih: 'Sales Tax',
				e: $author$project$Spa$Generated$Route$Reports__SalesTax,
				p: currentMonthParams,
				H: $author$project$Navbars$Practice$Navigation$SalesTax,
				t: 'reports-sales-tax',
				h8: practiceConfiguration.Ib && isViewable(8)
			},
				{aih: 'Affiliate Ancillary Charges', e: $author$project$Spa$Generated$Route$Reports__AncillaryCharges__Top, p: currentMonthParams, H: $author$project$Navbars$Practice$Navigation$AncillaryCharges, t: 'reports-ancillary-charges', h8: practiceConfiguration.U_}
			]);
	});
var $author$project$Navbars$Practice$MobileNavPointerDown = function (a) {
	return {$: 30, a: a};
};
var $author$project$Navbars$Practice$MobileNavPointerUp = {$: 31};
var $author$project$Navbars$Practice$mobileLongPressAttrs = F2(
	function (enabled, nav) {
		return enabled ? _List_fromArray(
			[
				A2(
				$elm$html$Html$Events$preventDefaultOn,
				'pointerdown',
				$elm$json$Json$Decode$succeed(
					_Utils_Tuple2(
						$author$project$Navbars$Practice$MobileNavPointerDown(nav),
						true))),
				A2(
				$elm$html$Html$Events$on,
				'pointerup',
				$elm$json$Json$Decode$succeed($author$project$Navbars$Practice$MobileNavPointerUp)),
				A2(
				$elm$html$Html$Events$on,
				'pointercancel',
				$elm$json$Json$Decode$succeed($author$project$Navbars$Practice$MobileNavPointerUp))
			]) : _List_Nil;
	});
var $author$project$Navbars$Practice$viewMobileBookmarkPopover = F2(
	function (buttonText, msg) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id($author$project$Navbars$Practice$mobileBookmarkPopoverId),
					$elm$html$Html$Attributes$class('sidenav__mobile-bookmark-popover')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sidenav__mobile-bookmark-popover__button'),
							A2(
							$elm$html$Html$Events$stopPropagationOn,
							'click',
							$elm$json$Json$Decode$succeed(
								_Utils_Tuple2(msg, true)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(buttonText)
						]))
				]));
	});
var $author$project$Navbars$Practice$viewMobileBookmarkElements = F5(
	function (practiceConfiguration, bookmarks, nav, _v0, mobilePopoverNav) {
		var _v1 = _Utils_Tuple2(
			practiceConfiguration.ax,
			$author$project$Navbars$Practice$mobileBookmarkInfo(nav));
		if (_v1.a && (!_v1.b.$)) {
			var info = _v1.b.a;
			return _Utils_eq(
				mobilePopoverNav,
				$elm$core$Maybe$Just(nav)) ? (A2($elm$core$Set$member, info.At, bookmarks) ? A2($author$project$Navbars$Practice$viewMobileBookmarkPopover, 'Unbookmark', info.FX) : A2($author$project$Navbars$Practice$viewMobileBookmarkPopover, 'Bookmark', info.xE)) : $author$project$Utils$Html$empty;
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Navbars$Practice$wrapWithMobileSubNavGesture = F7(
	function (practiceConfiguration, bookmarks, popoverNav, nav, label, navClass, innerContent) {
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class(navClass),
				A2($author$project$Navbars$Practice$mobileLongPressAttrs, practiceConfiguration.ax, nav)),
			_List_fromArray(
				[
					innerContent,
					A5($author$project$Navbars$Practice$viewMobileBookmarkElements, practiceConfiguration, bookmarks, nav, label, popoverNav)
				]));
	});
var $author$project$Navbars$Practice$viewAdminSubNav = F6(
	function (selectedNav, rightAdornment, practice, practiceConfiguration, subNavContext, bookmarks) {
		var viewItem = function (item) {
			if (item.h8) {
				var navEl = $author$project$Navbars$Practice$Navigation$Admin(item.At);
				var navClass = A2($author$project$Navbars$Practice$selectedNavClass, navEl, selectedNav);
				var linkEl = function () {
					var _v1 = item.Ir;
					if (!_v1.$) {
						var route = _v1.a;
						return A3(
							$author$project$Ui$Link$route,
							route,
							_List_fromArray(
								[
									$author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
									$author$project$Ui$Link$test(item.t)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(item.ac3)
										]))
								]));
					} else {
						var route = _v1.a;
						return A3(
							$author$project$Ui$Link$route,
							route,
							_List_fromArray(
								[
									$author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
									$author$project$Ui$Link$test(item.t)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(item.ac3)
										]))
								]));
					}
				}();
				if (subNavContext.$ === 1) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(navClass)
							]),
						_List_fromArray(
							[
								linkEl,
								A2(rightAdornment, navEl, item.ac3)
							]));
				} else {
					var popoverNav = subNavContext.a;
					return A7($author$project$Navbars$Practice$wrapWithMobileSubNavGesture, practiceConfiguration, bookmarks, popoverNav, navEl, item.ac3, navClass, linkEl);
				}
			} else {
				return $author$project$Utils$Html$empty;
			}
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('sidenav__subnav__content')
				]),
			A2(
				$elm$core$List$map,
				viewItem,
				A2($author$project$Navbars$Practice$Navigation$adminSubnavItems, practice, practiceConfiguration)));
	});
var $author$project$Navbars$Practice$viewBookmarkIconHelper = F5(
	function (bookmarks, key, label, bookmarkMsg, unbookmarkMsg) {
		var isFilled = A2($elm$core$Set$member, key, bookmarks);
		var iconClass = 'sidenav__bookmark-icon' + (isFilled ? ' sidenav__bookmark-icon--filled' : '');
		var _v0 = isFilled ? _Utils_Tuple3(unbookmarkMsg, 'Remove bookmark for ' + label, 'Remove bookmark') : _Utils_Tuple3(bookmarkMsg, 'Bookmark ' + label, 'Bookmark');
		var clickMsg = _v0.a;
		var ariaLabel = _v0.b;
		var tooltip = _v0.c;
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(iconClass),
					A2($elm$html$Html$Attributes$attribute, 'aria-label', ariaLabel),
					$elm$html$Html$Attributes$title(tooltip),
					A2(
					$elm$html$Html$Events$stopPropagationOn,
					'click',
					$elm$json$Json$Decode$succeed(
						_Utils_Tuple2(clickMsg, true)))
				]),
			_List_fromArray(
				[
					isFilled ? A2(
					$author$project$Ui$Icon$view,
					_List_fromArray(
						[
							$author$project$Ui$Icon$class('sidenav__bookmark-icon__svg')
						]),
					99) : A2(
					$author$project$Ui$Icon$view,
					_List_fromArray(
						[
							$author$project$Ui$Icon$class('sidenav__bookmark-icon__svg')
						]),
					98)
				]));
	});
var $author$project$Navbars$Practice$viewBookmarkIcon = F4(
	function (practiceConfiguration, bookmarks, nav, label) {
		var _v0 = _Utils_Tuple2(
			practiceConfiguration.ax,
			$author$project$Navbars$Practice$Navigation$navToString(nav));
		if (_v0.a && (!_v0.b.$)) {
			var key = _v0.b.a;
			return A5(
				$author$project$Navbars$Practice$viewBookmarkIconHelper,
				bookmarks,
				key,
				label,
				$author$project$Navbars$Practice$BookmarkNav(nav),
				$author$project$Navbars$Practice$UnbookmarkNav(nav));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Navbars$Practice$viewBookmarkedSubNavFlyout = function (config) {
	return $elm$core$List$isEmpty(config.lz) ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('sidenav__bookmarked-label sidenav__bookmarked-label--collapsed')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('sidenav__bookmarked-label__icon-wrapper')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Icon$view,
						_List_fromArray(
							[
								$author$project$Ui$Icon$class('sidenav__bookmarked-label__icon')
							]),
						100)
					]))
			])) : A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('sidenav__item', true),
						_Utils_Tuple2('sidenav__active', config.zI)
					]))
			]),
		_List_fromArray(
			[
				A4(
				$author$project$Ui$FlyoutMenu$view,
				_List_fromArray(
					[
						$author$project$Ui$FlyoutMenu$position(0)
					]),
				_List_fromArray(
					[
						$author$project$Ui$FlyoutMenu$header(
						_List_fromArray(
							[
								$author$project$Ui$FlyoutMenu$title('Bookmarked')
							])),
						$author$project$Ui$FlyoutMenu$body(
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('sidenav__bookmarked-items')
									]),
								config.lz)
							]))
					]),
				A3(
					$author$project$Ui$Tooltip$view,
					config.FT,
					'Bookmarked',
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Show bookmarked items'},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$test('bookmarked')
								]),
							_List_fromArray(
								[
									$author$project$Ui$Icon$bookmarkNav(
									_List_fromArray(
										[$author$project$Ui$Icon$sidenav]))
								]))
						])),
				config.nN)
			]));
};
var $author$project$Navbars$Practice$viewBookmarkedSection = function (config) {
	if ($elm$core$List$isEmpty(config.lz) && $elm$core$List$isEmpty(config.ou)) {
		return _List_Nil;
	} else {
		var expandedSection = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('sidenav__bookmarked-section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sidenav__bookmarked-label')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sidenav__bookmarked-label__icon-wrapper')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Icon$view,
									_List_fromArray(
										[
											$author$project$Ui$Icon$class('sidenav__bookmarked-label__icon')
										]),
									98)
								])),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Bookmarked')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sidenav__bookmarked-items')
						]),
					_Utils_ap(config.lz, config.ou))
				]));
		var section = function () {
			var _v0 = config.JZ;
			switch (_v0.$) {
				case 2:
					return expandedSection;
				case 0:
					return expandedSection;
				default:
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('sidenav__bookmarked-section')
							]),
						_List_fromArray(
							[
								$author$project$Navbars$Practice$viewBookmarkedSubNavFlyout(config),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('sidenav__bookmarked-items')
									]),
								config.ou)
							]));
			}
		}();
		return _List_fromArray(
			[
				section,
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('sidenav__bookmarked-divider')
					]),
				_List_Nil)
			]);
	}
};
var $author$project$Ui$Badge$dot = A2(
	$elm$html$Html$span,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('badge-dot')
		]),
	_List_Nil);
var $author$project$Navbars$Practice$viewMainNavItem = F6(
	function (practiceConfiguration, bookmarks, style, selectedNav, currentDate, item) {
		if (item.h8) {
			var mobilePopoverActive = function () {
				if (!style.$) {
					var mobilePopoverNav = style.a;
					return _Utils_eq(
						mobilePopoverNav,
						$elm$core$Maybe$Just(item.At));
				} else {
					return false;
				}
			}();
			var mobilePointerAttrs = function () {
				if (!style.$) {
					return A2($author$project$Navbars$Practice$mobileLongPressAttrs, practiceConfiguration.ax, item.At);
				} else {
					return _List_Nil;
				}
			}();
			var hasBadgeActivity = A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function (count) {
						return count > 0;
					},
					item.ae9));
			var iconWithDot = hasBadgeActivity ? A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('nav-icon-with-dot')
					]),
				_List_fromArray(
					[
						item.ahO(
						_List_fromArray(
							[$author$project$Ui$Icon$sidenav])),
						$author$project$Ui$Badge$dot
					])) : item.ahO(
				_List_fromArray(
					[$author$project$Ui$Icon$sidenav]));
			var linkContent = function () {
				switch (style.$) {
					case 0:
						return _List_fromArray(
							[
								A2($elm$html$Html$map, $elm$core$Basics$never, iconWithDot),
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(item.ac3)
									]))
							]);
					case 1:
						return _List_fromArray(
							[
								A2($elm$html$Html$map, $elm$core$Basics$never, iconWithDot)
							]);
					default:
						return _List_fromArray(
							[
								A2($elm$html$Html$map, $elm$core$Basics$never, iconWithDot),
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(item.ac3)
									]))
							]);
				}
			}();
			var accessibleLabel = hasBadgeActivity ? (item.ac3 + ' (new activity)') : item.ac3;
			var linkOptions = function () {
				switch (style.$) {
					case 0:
						return _List_fromArray(
							[
								$author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
								$author$project$Ui$Link$test(item.t),
								$author$project$Ui$Link$ariaLabel(accessibleLabel)
							]);
					case 1:
						return _List_fromArray(
							[
								$author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
								$author$project$Ui$Link$test(item.t),
								$author$project$Ui$Link$ariaLabel(accessibleLabel)
							]);
					default:
						return _List_fromArray(
							[
								$author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
								$author$project$Ui$Link$test(item.t),
								$author$project$Ui$Link$ariaLabel(accessibleLabel)
							]);
				}
			}();
			var createLink = F2(
				function (route, params) {
					if (!params.$) {
						var paramsFn = params.a;
						return A3(
							$author$project$Ui$Link$route,
							route,
							A2(
								$elm$core$List$cons,
								$author$project$Ui$Link$routeParams(
									paramsFn(currentDate)),
								linkOptions),
							linkContent);
					} else {
						return A3($author$project$Ui$Link$route, route, linkOptions, linkContent);
					}
				});
			var linkElement = function () {
				var _v2 = item.Ir;
				if (!_v2.$) {
					var route = _v2.a;
					return A2(createLink, route, $elm$core$Maybe$Nothing);
				} else {
					var route = _v2.a;
					var paramsFn = _v2.b;
					return A2(
						createLink,
						route,
						$elm$core$Maybe$Just(paramsFn));
				}
			}();
			var wrappedLink = function () {
				switch (style.$) {
					case 0:
						return linkElement;
					case 1:
						var tooltipOptions = style.a;
						return A3(
							$author$project$Ui$Tooltip$view,
							tooltipOptions,
							item.ac3,
							_List_fromArray(
								[linkElement]));
					default:
						return linkElement;
				}
			}();
			return A2(
				$elm$html$Html$div,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class(
						A2($author$project$Navbars$Practice$selectedNavClass, item.At, selectedNav)),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('sidenav__item--mobile-popover-active', mobilePopoverActive)
								])),
						mobilePointerAttrs)),
				_List_fromArray(
					[
						wrappedLink,
						function () {
						switch (style.$) {
							case 2:
								return A4($author$project$Navbars$Practice$viewBookmarkIcon, practiceConfiguration, bookmarks, item.At, item.ac3);
							case 0:
								var mobilePopoverNav = style.a;
								return A5($author$project$Navbars$Practice$viewMobileBookmarkElements, practiceConfiguration, bookmarks, item.At, item.ac3, mobilePopoverNav);
							default:
								return $author$project$Utils$Html$empty;
						}
					}()
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Api$Common$PartnerApp$All$corePageAnchor = A2($elm$core$Basics$composeR, $author$project$Api$Common$PartnerApp$All$shared, $author$project$Api$Common$PartnerApp$Shared$corePageAnchor);
var $author$project$Api$Common$PartnerApp$Anchor$corePageIconLabel = function (_v0) {
	var record = _v0;
	var _v1 = record.amg;
	if (!_v1) {
		return record.OI;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Common$PartnerApp$Anchor$corePageIconUrl = function (_v0) {
	var record = _v0;
	var _v1 = record.amg;
	if (!_v1) {
		return record.OJ;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Common$PartnerApp$All$name = A2($elm$core$Basics$composeR, $author$project$Api$Common$PartnerApp$All$shared, $author$project$Api$Common$PartnerApp$Shared$name);
var $author$project$WebComponents$SvgIconFromUrl$view = F2(
	function (attributes, url) {
		return A3(
			$elm$html$Html$node,
			'svg-icon-from-url',
			A2(
				$elm$core$List$cons,
				A2($elm$html$Html$Attributes$attribute, 'src', url),
				attributes),
			_List_Nil);
	});
var $author$project$Navbars$Practice$viewPartnerNavItem = F5(
	function (practiceConfiguration, bookmarks, style, selectedNav, partnerApp) {
		var partnerIcon = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Ui$Icon$dashboard(
				_List_fromArray(
					[$author$project$Ui$Icon$sidenav])),
			A2(
				$elm$core$Maybe$map,
				function (url) {
					return A2(
						$author$project$WebComponents$SvgIconFromUrl$view,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('sidenav__icon icon')
							]),
						url);
				},
				A2(
					$elm$core$Maybe$andThen,
					$author$project$Api$Common$PartnerApp$Anchor$corePageIconUrl,
					$author$project$Api$Common$PartnerApp$All$corePageAnchor(partnerApp))));
		var linkLabel = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Api$Common$PartnerApp$All$name(partnerApp),
			A2(
				$elm$core$Maybe$andThen,
				$author$project$Api$Common$PartnerApp$Anchor$corePageIconLabel,
				$author$project$Api$Common$PartnerApp$All$corePageAnchor(partnerApp)));
		var linkContent = function () {
			switch (style.$) {
				case 0:
					return _List_fromArray(
						[
							A2($elm$html$Html$map, $elm$core$Basics$never, partnerIcon),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(linkLabel)
								]))
						]);
				case 1:
					return _List_fromArray(
						[partnerIcon]);
				default:
					return _List_fromArray(
						[
							A2($elm$html$Html$map, $elm$core$Basics$never, partnerIcon),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(linkLabel)
								]))
						]);
			}
		}();
		var appId = $author$project$Api$Common$PartnerApp$All$partnerSlug(partnerApp);
		var linkOptions = function () {
			switch (style.$) {
				case 0:
					return _List_fromArray(
						[
							$author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
							$author$project$Ui$Link$test('partner-app-' + appId)
						]);
				case 1:
					return _List_fromArray(
						[
							$author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
							$author$project$Ui$Link$test('partner-app-' + appId),
							$author$project$Ui$Link$ariaLabel(linkLabel)
						]);
				default:
					return _List_fromArray(
						[
							$author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
							$author$project$Ui$Link$test('partner-app-' + appId)
						]);
			}
		}();
		var linkElement = A3(
			$author$project$Ui$Link$route,
			$author$project$Spa$Generated$Route$Apps__Slug_String(
				{abG: appId}),
			linkOptions,
			linkContent);
		var wrappedLink = function () {
			switch (style.$) {
				case 0:
					return linkElement;
				case 1:
					var tooltipOptions = style.a;
					return A3(
						$author$project$Ui$Tooltip$view,
						tooltipOptions,
						linkLabel,
						_List_fromArray(
							[linkElement]));
				default:
					return linkElement;
			}
		}();
		var partnerNav = $author$project$Navbars$Practice$Navigation$PartnerApp(appId);
		var mobilePointerAttrs = function () {
			if (!style.$) {
				return A2($author$project$Navbars$Practice$mobileLongPressAttrs, practiceConfiguration.ax, partnerNav);
			} else {
				return _List_Nil;
			}
		}();
		var mobilePopoverActive = function () {
			if (!style.$) {
				var mobilePopoverNav = style.a;
				return _Utils_eq(
					mobilePopoverNav,
					$elm$core$Maybe$Just(partnerNav));
			} else {
				return false;
			}
		}();
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class(
					A2($author$project$Navbars$Practice$selectedNavClass, partnerNav, selectedNav)),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('sidenav__item--mobile-popover-active', mobilePopoverActive)
							])),
					mobilePointerAttrs)),
			_List_fromArray(
				[
					wrappedLink,
					function () {
					switch (style.$) {
						case 2:
							return A4($author$project$Navbars$Practice$viewBookmarkIcon, practiceConfiguration, bookmarks, partnerNav, linkLabel);
						case 0:
							var mobilePopoverNav = style.a;
							return A5($author$project$Navbars$Practice$viewMobileBookmarkElements, practiceConfiguration, bookmarks, partnerNav, linkLabel, mobilePopoverNav);
						default:
							return $author$project$Utils$Html$empty;
					}
				}()
				]));
	});
var $author$project$Api$Provider$EmbeddedReport$Shared$id = function (_v0) {
	var record = _v0;
	return record.ahP;
};
var $author$project$Api$Provider$EmbeddedReport$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$EmbeddedReport$Shared$id(shared);
};
var $author$project$Api$Provider$EmbeddedReport$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$EmbeddedReport$Shared$name(shared);
};
var $author$project$Navbars$Practice$viewEmbeddedReport = F2(
	function (selectedNav, report) {
		var reportName = $author$project$Api$Provider$EmbeddedReport$All$name(report);
		var reportId = $author$project$Api$Provider$EmbeddedReport$All$id(report);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					A2(
						$author$project$Navbars$Practice$selectedNavClass,
						$author$project$Navbars$Practice$Navigation$Reports(
							$author$project$Navbars$Practice$Navigation$Custom(reportId)),
						selectedNav))
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Link$route,
					$author$project$Spa$Generated$Route$Reports__Custom__Id_String(
						{ahP: reportId}),
					_List_fromArray(
						[
							$author$project$Ui$Link$test(
							'reports-custom-' + A3(
								$elm$core$String$replace,
								' ',
								'-',
								$elm$core$String$toLower(reportName))),
							$author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(reportName)
						]))
				]));
	});
var $author$project$Navbars$Practice$viewEmbeddedReports = F2(
	function (selectedNav, embeddedReports) {
		if (embeddedReports.$ === 3) {
			var reports = embeddedReports.a;
			return A2(
				$elm$core$List$map,
				$author$project$Navbars$Practice$viewEmbeddedReport(selectedNav),
				reports);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Navbars$Practice$viewReportSubNav = F7(
	function (selectedNav, rightAdornment, specs, embeddedReports, subNavContext, practiceConfiguration, bookmarks) {
		var viewItem = function (spec) {
			if (spec.h8) {
				var navEl = $author$project$Navbars$Practice$Navigation$Reports(spec.H);
				var navClass = A2($author$project$Navbars$Practice$selectedNavClass, navEl, selectedNav);
				var linkEl = A3(
					$author$project$Ui$Link$route,
					spec.e,
					_List_fromArray(
						[
							$author$project$Ui$Link$routeParams(spec.p),
							$author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
							$author$project$Ui$Link$test(spec.t)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(spec.aih)
								]))
						]));
				if (subNavContext.$ === 1) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(navClass)
							]),
						_List_fromArray(
							[
								linkEl,
								A2(rightAdornment, navEl, spec.aih)
							]));
				} else {
					var popoverNav = subNavContext.a;
					return A7($author$project$Navbars$Practice$wrapWithMobileSubNavGesture, practiceConfiguration, bookmarks, popoverNav, navEl, spec.aih, navClass, linkEl);
				}
			} else {
				return $author$project$Utils$Html$empty;
			}
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('sidenav__subnav__content')
				]),
			_Utils_ap(
				A2($elm$core$List$map, viewItem, specs),
				A2($author$project$Navbars$Practice$viewEmbeddedReports, selectedNav, embeddedReports)));
	});
var $author$project$Navbars$Practice$viewSubNavBookmarkIcon = F4(
	function (practiceConfiguration, bookmarks, key, label) {
		return practiceConfiguration.ax ? A5(
			$author$project$Navbars$Practice$viewBookmarkIconHelper,
			bookmarks,
			key,
			label,
			$author$project$Navbars$Practice$BookmarkSubNav(key),
			$author$project$Navbars$Practice$UnbookmarkSubNav(key)) : $author$project$Utils$Html$empty;
	});
var $author$project$Navbars$Practice$viewSubNavBookmarkInSection = F4(
	function (practiceConfiguration, bookmarks, selectedNav, info) {
		var key = A2(
			$elm$core$Maybe$withDefault,
			'',
			$author$project$Navbars$Practice$subNavInfoKey(info.kp));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					A2($author$project$Navbars$Practice$selectedNavClass, info.kp, selectedNav) + ' sidenav__bookmarked-subnav-item')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Link$route,
					info.e,
					_List_fromArray(
						[
							$author$project$Ui$Link$routeParams(info.p),
							$author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
							$author$project$Ui$Link$test('subnav-bookmark-' + key)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(info.aih)
						])),
					A4($author$project$Navbars$Practice$viewSubNavBookmarkIcon, practiceConfiguration, bookmarks, key, info.aih)
				]));
	});
var $author$project$Navbars$Practice$viewDesktopNavElements = F4(
	function (_v0, hinterViewOff, sidenavExpanded, items) {
		var selectedNav = _v0.fd;
		var currentDate = _v0.dd;
		var embeddedReports = _v0.r9;
		var reports = _v0.ue;
		var reportMenu = _v0.kW;
		var adminMenu = _v0.im;
		var openSubNav = _v0.dw;
		var practice = _v0.ZV;
		var practiceConfiguration = _v0.kI;
		var sessionConfiguration = _v0.Ex;
		var partnerApps = _v0.tC;
		var bookmarks = _v0.ac;
		var bookmarkedMenu = _v0.fP;
		var tooltipOptions = _List_fromArray(
			[
				$author$project$Ui$Tooltip$placement(3),
				$author$project$Ui$Tooltip$stackingOrder1030
			]);
		var reportsTrigger = sidenavExpanded ? A3(
			$author$project$Ui$Button$view,
			{mm: 'Reports'},
			_List_fromArray(
				[
					$author$project$Ui$Button$link,
					$author$project$Ui$Button$test('reports')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Icon$report(
					_List_fromArray(
						[$author$project$Ui$Icon$sidenav])),
					$elm$html$Html$text('Reports'),
					A2(
					$author$project$Ui$Icon$view,
					_List_fromArray(
						[
							$author$project$Ui$Icon$class('sidenav__expand-chevron')
						]),
					12)
				])) : A3(
			$author$project$Ui$Tooltip$view,
			tooltipOptions,
			'Reports',
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{mm: 'Reports'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$test('reports')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Icon$report(
							_List_fromArray(
								[$author$project$Ui$Icon$sidenav]))
						]))
				]));
		var reportsSpecs = A4($author$project$Navbars$Practice$reportsItemSpecs, practice, practiceConfiguration, currentDate, reports);
		var subNavEntries = practiceConfiguration.ax ? A2(
			$elm$core$List$filterMap,
			function (info) {
				var _v3 = $author$project$Navbars$Practice$subNavInfoKey(info.kp);
				if (!_v3.$) {
					var key = _v3.a;
					return (info.h8 && A2($elm$core$Set$member, key, bookmarks)) ? $elm$core$Maybe$Just(
						{
							aM: A4($author$project$Navbars$Practice$viewSubNavBookmarkInSection, practiceConfiguration, bookmarks, selectedNav, info),
							At: key,
							kp: info.kp,
							h8: true
						}) : $elm$core$Maybe$Nothing;
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			A4($author$project$Navbars$Practice$allSubNavBookmarkInfos, practice, practiceConfiguration, currentDate, reportsSpecs)) : _List_Nil;
		var itemStyle = sidenavExpanded ? $author$project$Navbars$Practice$DesktopExpandedStyle : $author$project$Navbars$Practice$DesktopStyle(tooltipOptions);
		var mainEntries = A2(
			$elm$core$List$map,
			function (item) {
				return {
					aM: A6($author$project$Navbars$Practice$viewMainNavItem, practiceConfiguration, bookmarks, itemStyle, selectedNav, currentDate, item),
					At: A2(
						$elm$core$Maybe$withDefault,
						'',
						$author$project$Navbars$Practice$Navigation$navToString(item.At)),
					kp: item.At,
					h8: item.h8
				};
			},
			items);
		var partnerEntries = A2(
			$elm$core$List$map,
			function (app) {
				var slug = $author$project$Api$Common$PartnerApp$All$partnerSlug(app);
				return {
					aM: A5($author$project$Navbars$Practice$viewPartnerNavItem, practiceConfiguration, bookmarks, itemStyle, selectedNav, app),
					At: A2(
						$elm$core$Maybe$withDefault,
						'',
						$author$project$Navbars$Practice$Navigation$navToString(
							$author$project$Navbars$Practice$Navigation$PartnerApp(slug))),
					kp: $author$project$Navbars$Practice$Navigation$PartnerApp(slug),
					h8: true
				};
			},
			A2(
				$elm$core$List$filter,
				$author$project$Api$Common$PartnerApp$All$embedsCorePage,
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$author$project$Api$Data$toMaybe(partnerApps))));
		var bookmarkIconWhenExpanded = F2(
			function (nav, label) {
				return sidenavExpanded ? A4($author$project$Navbars$Practice$viewBookmarkIcon, practiceConfiguration, bookmarks, nav, label) : $author$project$Utils$Html$empty;
			});
		var bookmarkAdornment = F2(
			function (nav, lbl) {
				var _v2 = $author$project$Navbars$Practice$subNavInfoKey(nav);
				if (!_v2.$) {
					var key = _v2.a;
					return A4($author$project$Navbars$Practice$viewSubNavBookmarkIcon, practiceConfiguration, bookmarks, key, lbl);
				} else {
					return $author$project$Utils$Html$empty;
				}
			});
		var reportsEntry = {
			aM: A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('sidenav__item', true),
								_Utils_Tuple2(
								'sidenav__active',
								(!openSubNav) || (!$author$project$Navbars$Practice$openSubNavFromSelectedNav(selectedNav)))
							]))
					]),
				_List_fromArray(
					[
						A4(
						$author$project$Ui$FlyoutMenu$view,
						_List_fromArray(
							[
								$author$project$Ui$FlyoutMenu$position(0)
							]),
						_List_fromArray(
							[
								$author$project$Ui$FlyoutMenu$header(
								_List_fromArray(
									[
										$author$project$Ui$FlyoutMenu$title('Reports')
									])),
								$author$project$Ui$FlyoutMenu$body(
								_List_fromArray(
									[
										A7($author$project$Navbars$Practice$viewReportSubNav, selectedNav, bookmarkAdornment, reportsSpecs, embeddedReports, $author$project$Navbars$Practice$DesktopSubNav, practiceConfiguration, bookmarks)
									]))
							]),
						reportsTrigger,
						reportMenu),
						A2(
						bookmarkIconWhenExpanded,
						$author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$Dashboard),
						'Reports')
					])),
			At: A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Navbars$Practice$Navigation$navToString(
					$author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$Dashboard))),
			kp: $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$Dashboard),
			h8: sessionConfiguration.xO(hinterViewOff)
		};
		var adminTrigger = sidenavExpanded ? A3(
			$author$project$Ui$Button$view,
			{mm: 'Admin'},
			_List_fromArray(
				[
					$author$project$Ui$Button$link,
					$author$project$Ui$Button$test('admin')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Icon$admin(
					_List_fromArray(
						[$author$project$Ui$Icon$sidenav])),
					$elm$html$Html$text('Admin'),
					A2(
					$author$project$Ui$Icon$view,
					_List_fromArray(
						[
							$author$project$Ui$Icon$class('sidenav__expand-chevron')
						]),
					12)
				])) : A3(
			$author$project$Ui$Tooltip$view,
			tooltipOptions,
			'Admin',
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{mm: 'Admin'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$test('admin')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Icon$admin(
							_List_fromArray(
								[$author$project$Ui$Icon$sidenav]))
						]))
				]));
		var adminEntry = {
			aM: A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('sidenav__item', true),
								_Utils_Tuple2(
								'sidenav__active',
								(openSubNav === 1) || ($author$project$Navbars$Practice$openSubNavFromSelectedNav(selectedNav) === 1))
							]))
					]),
				_List_fromArray(
					[
						A4(
						$author$project$Ui$FlyoutMenu$view,
						_List_fromArray(
							[
								$author$project$Ui$FlyoutMenu$position(0)
							]),
						_List_fromArray(
							[
								$author$project$Ui$FlyoutMenu$header(
								_List_fromArray(
									[
										$author$project$Ui$FlyoutMenu$title('Admin')
									])),
								$author$project$Ui$FlyoutMenu$body(
								_List_fromArray(
									[
										A6($author$project$Navbars$Practice$viewAdminSubNav, selectedNav, bookmarkAdornment, practice, practiceConfiguration, $author$project$Navbars$Practice$DesktopSubNav, bookmarks)
									]))
							]),
						adminTrigger,
						adminMenu),
						A2(
						bookmarkIconWhenExpanded,
						$author$project$Navbars$Practice$Navigation$Admin(0),
						'Admin')
					])),
			At: A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Navbars$Practice$Navigation$navToString(
					$author$project$Navbars$Practice$Navigation$Admin(0))),
			kp: $author$project$Navbars$Practice$Navigation$Admin(0),
			h8: sessionConfiguration.GO(hinterViewOff)
		};
		var visibleEntries = A2(
			$elm$core$List$filter,
			function ($) {
				return $.h8;
			},
			_Utils_ap(
				mainEntries,
				A2(
					$elm$core$List$cons,
					reportsEntry,
					_Utils_ap(
						partnerEntries,
						_List_fromArray(
							[adminEntry])))));
		var _v1 = practiceConfiguration.ax ? A2(
			$elm$core$List$partition,
			function (entry) {
				return A2($elm$core$Set$member, entry.At, bookmarks);
			},
			visibleEntries) : _Utils_Tuple2(_List_Nil, visibleEntries);
		var bookmarkedEntries = _v1.a;
		var unbookmarkedEntries = _v1.b;
		return _Utils_ap(
			$author$project$Navbars$Practice$viewBookmarkedSection(
				{
					zI: A2(
						$elm$core$List$any,
						function (entry) {
							return _Utils_eq(entry.kp, selectedNav);
						},
						subNavEntries),
					nN: bookmarkedMenu,
					ou: A2(
						$elm$core$List$map,
						function ($) {
							return $.aM;
						},
						bookmarkedEntries),
					JZ: itemStyle,
					lz: A2(
						$elm$core$List$map,
						function ($) {
							return $.aM;
						},
						subNavEntries),
					FT: tooltipOptions
				}),
			A2(
				$elm$core$List$map,
				function ($) {
					return $.aM;
				},
				unbookmarkedEntries));
	});
var $author$project$Navbars$Practice$viewHinterIdButtons = F2(
	function (model, hinterViewOff) {
		return A2(
			$elm$html$Html$map,
			$author$project$Navbars$Practice$HinterIdButtonsMsg,
			A2(
				$author$project$Navbars$HinterIdButtons$view,
				A2($author$project$Utils$User$isViewingAsHinter, model.aa4, hinterViewOff),
				model.sz));
	});
var $author$project$Navbars$Practice$Navigation$AdminHeader = {$: 15};
var $author$project$Navbars$Practice$MobileStyle = function (a) {
	return {$: 0, a: a};
};
var $author$project$Navbars$Practice$MobileSubNav = function (a) {
	return {$: 0, a: a};
};
var $author$project$Navbars$Practice$Navigation$ReportsHeader = {$: 13};
var $author$project$Navbars$Practice$noAdornment = F2(
	function (_v0, _v1) {
		return $author$project$Utils$Html$empty;
	});
var $author$project$Navbars$Practice$popoverOpenNav = function (state) {
	switch (state.$) {
		case 2:
			var nav = state.a;
			return $elm$core$Maybe$Just(nav);
		case 3:
			var nav = state.a;
			return $elm$core$Maybe$Just(nav);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Navbars$Practice$viewMobileSubNavBookmarked = F5(
	function (practiceConfiguration, bookmarks, selectedNav, popoverNav, info) {
		var key = A2(
			$elm$core$Maybe$withDefault,
			'',
			$author$project$Navbars$Practice$subNavInfoKey(info.kp));
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class(
					A2($author$project$Navbars$Practice$selectedNavClass, info.kp, selectedNav) + ' sidenav__bookmarked-subnav-item'),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'sidenav__item--mobile-popover-active',
								_Utils_eq(
									popoverNav,
									$elm$core$Maybe$Just(info.kp)))
							])),
					A2($author$project$Navbars$Practice$mobileLongPressAttrs, practiceConfiguration.ax, info.kp))),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Link$route,
					info.e,
					_List_fromArray(
						[
							$author$project$Ui$Link$routeParams(info.p),
							$author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
							$author$project$Ui$Link$test('subnav-bookmark-' + key)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(info.aih)
								]))
						])),
					A5($author$project$Navbars$Practice$viewMobileBookmarkElements, practiceConfiguration, bookmarks, info.kp, info.aih, popoverNav)
				]));
	});
var $author$project$Navbars$Practice$viewMobileNavElements = F3(
	function (_v0, hinterViewOff, items) {
		var selectedNav = _v0.fd;
		var openSubNav = _v0.dw;
		var currentDate = _v0.dd;
		var embeddedReports = _v0.r9;
		var partnerApps = _v0.tC;
		var practice = _v0.ZV;
		var practiceConfiguration = _v0.kI;
		var sessionConfiguration = _v0.Ex;
		var reports = _v0.ue;
		var bookmarks = _v0.ac;
		var mobileBookmark = _v0.O;
		var bookmarkedMenu = _v0.fP;
		var reportsSpecs = A4($author$project$Navbars$Practice$reportsItemSpecs, practice, practiceConfiguration, currentDate, reports);
		var popoverNav = $author$project$Navbars$Practice$popoverOpenNav(mobileBookmark);
		var subNavContext = $author$project$Navbars$Practice$MobileSubNav(popoverNav);
		var reportsItemHtml = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					A2($author$project$Navbars$Practice$subNavClasses, 0, openSubNav))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('sidenav__mobile-bookmark-row'),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'sidenav__item--mobile-popover-active',
										_Utils_eq(
											popoverNav,
											$elm$core$Maybe$Just($author$project$Navbars$Practice$Navigation$ReportsHeader)))
									])),
							A2($author$project$Navbars$Practice$mobileLongPressAttrs, practiceConfiguration.ax, $author$project$Navbars$Practice$Navigation$ReportsHeader))),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Show reports menu'},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$onClick(
									$author$project$Navbars$Practice$NavClicked(0)),
									$author$project$Ui$Button$test('reports')
								]),
							_List_fromArray(
								[
									$author$project$Ui$Icon$report(
									_List_fromArray(
										[$author$project$Ui$Icon$sidenav])),
									$elm$html$Html$text('Reports'),
									A2(
									$author$project$Ui$Icon$view,
									_List_fromArray(
										[
											$author$project$Ui$Icon$class('sidenav__icon--show-more ml-2')
										]),
									12)
								])),
							A5($author$project$Navbars$Practice$viewMobileBookmarkElements, practiceConfiguration, bookmarks, $author$project$Navbars$Practice$Navigation$ReportsHeader, 'Reports', popoverNav)
						])),
					A7($author$project$Navbars$Practice$viewReportSubNav, selectedNav, $author$project$Navbars$Practice$noAdornment, reportsSpecs, embeddedReports, subNavContext, practiceConfiguration, bookmarks)
				]));
		var reportsEntry = {
			aM: reportsItemHtml,
			At: A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Navbars$Practice$Navigation$navToString(
					$author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$Dashboard))),
			kp: $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$Dashboard),
			h8: sessionConfiguration.xO(hinterViewOff)
		};
		var subNavEntries = practiceConfiguration.ax ? A2(
			$elm$core$List$filterMap,
			function (info) {
				var _v2 = $author$project$Navbars$Practice$subNavInfoKey(info.kp);
				if (!_v2.$) {
					var key = _v2.a;
					return (info.h8 && A2($elm$core$Set$member, key, bookmarks)) ? $elm$core$Maybe$Just(
						A5($author$project$Navbars$Practice$viewMobileSubNavBookmarked, practiceConfiguration, bookmarks, selectedNav, popoverNav, info)) : $elm$core$Maybe$Nothing;
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			A4($author$project$Navbars$Practice$allSubNavBookmarkInfos, practice, practiceConfiguration, currentDate, reportsSpecs)) : _List_Nil;
		var mobileStyle = $author$project$Navbars$Practice$MobileStyle(popoverNav);
		var partnerEntries = A2(
			$elm$core$List$map,
			function (app) {
				var slug = $author$project$Api$Common$PartnerApp$All$partnerSlug(app);
				return {
					aM: A5($author$project$Navbars$Practice$viewPartnerNavItem, practiceConfiguration, bookmarks, mobileStyle, selectedNav, app),
					At: A2(
						$elm$core$Maybe$withDefault,
						'',
						$author$project$Navbars$Practice$Navigation$navToString(
							$author$project$Navbars$Practice$Navigation$PartnerApp(slug))),
					kp: $author$project$Navbars$Practice$Navigation$PartnerApp(slug),
					h8: true
				};
			},
			A2(
				$elm$core$List$filter,
				$author$project$Api$Common$PartnerApp$All$embedsCorePage,
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$author$project$Api$Data$toMaybe(partnerApps))));
		var mainEntries = A2(
			$elm$core$List$map,
			function (item) {
				return {
					aM: A6($author$project$Navbars$Practice$viewMainNavItem, practiceConfiguration, bookmarks, mobileStyle, selectedNav, currentDate, item),
					At: A2(
						$elm$core$Maybe$withDefault,
						'',
						$author$project$Navbars$Practice$Navigation$navToString(item.At)),
					kp: item.At,
					h8: item.h8
				};
			},
			items);
		var adminItemHtml = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					A2($author$project$Navbars$Practice$subNavClasses, 1, openSubNav))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('sidenav__mobile-bookmark-row'),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'sidenav__item--mobile-popover-active',
										_Utils_eq(
											popoverNav,
											$elm$core$Maybe$Just($author$project$Navbars$Practice$Navigation$AdminHeader)))
									])),
							A2($author$project$Navbars$Practice$mobileLongPressAttrs, practiceConfiguration.ax, $author$project$Navbars$Practice$Navigation$AdminHeader))),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Show admin menu'},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$onClick(
									$author$project$Navbars$Practice$NavClicked(1)),
									$author$project$Ui$Button$test('admin')
								]),
							_List_fromArray(
								[
									$author$project$Ui$Icon$admin(
									_List_fromArray(
										[$author$project$Ui$Icon$sidenav])),
									$elm$html$Html$text('Admin'),
									A2(
									$author$project$Ui$Icon$view,
									_List_fromArray(
										[
											$author$project$Ui$Icon$class('sidenav__icon--show-more ml-2')
										]),
									12)
								])),
							A5($author$project$Navbars$Practice$viewMobileBookmarkElements, practiceConfiguration, bookmarks, $author$project$Navbars$Practice$Navigation$AdminHeader, 'Admin', popoverNav)
						])),
					A6($author$project$Navbars$Practice$viewAdminSubNav, selectedNav, $author$project$Navbars$Practice$noAdornment, practice, practiceConfiguration, subNavContext, bookmarks)
				]));
		var adminEntry = {
			aM: adminItemHtml,
			At: A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Navbars$Practice$Navigation$navToString(
					$author$project$Navbars$Practice$Navigation$Admin(0))),
			kp: $author$project$Navbars$Practice$Navigation$Admin(0),
			h8: sessionConfiguration.GO(hinterViewOff)
		};
		var visibleEntries = A2(
			$elm$core$List$filter,
			function ($) {
				return $.h8;
			},
			_Utils_ap(
				mainEntries,
				A2(
					$elm$core$List$cons,
					reportsEntry,
					_Utils_ap(
						partnerEntries,
						_List_fromArray(
							[adminEntry])))));
		var _v1 = practiceConfiguration.ax ? A2(
			$elm$core$List$partition,
			function (entry) {
				return A2($elm$core$Set$member, entry.At, bookmarks);
			},
			visibleEntries) : _Utils_Tuple2(_List_Nil, visibleEntries);
		var bookmarkedEntries = _v1.a;
		var unbookmarkedEntries = _v1.b;
		return _Utils_ap(
			$author$project$Navbars$Practice$viewBookmarkedSection(
				{
					zI: false,
					nN: bookmarkedMenu,
					ou: A2(
						$elm$core$List$map,
						function ($) {
							return $.aM;
						},
						bookmarkedEntries),
					JZ: mobileStyle,
					lz: subNavEntries,
					FT: _List_Nil
				}),
			A2(
				$elm$core$List$map,
				function ($) {
					return $.aM;
				},
				unbookmarkedEntries));
	});
var $author$project$Navbars$Practice$LogoutClicked = {$: 6};
var $author$project$Navbars$Practice$viewProfileSubNav = function (selectedNav) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('sidenav__subnav__content')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(
						A2($author$project$Navbars$Practice$selectedNavClass, $author$project$Navbars$Practice$Navigation$Account, selectedNav)),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'bg-primary-100',
								_Utils_eq(selectedNav, $author$project$Navbars$Practice$Navigation$Account))
							]))
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$User__Profile,
						_List_fromArray(
							[
								$author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
								$author$project$Ui$Link$test('account-profile')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Profile')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('sidenav__item')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'Logout'},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$onClick($author$project$Navbars$Practice$LogoutClicked),
								$author$project$Ui$Button$test('account-logout')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Logout')
							]))
					]))
			]));
};
var $author$project$Ui$Image$HelpCircle = 13;
var $author$project$Navbars$Practice$ShowSupportChat = {$: 15};
var $author$project$Navbars$Practice$viewResourcesSubNav = function (imageStore) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('sidenav__subnav__content')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('sidenav__item')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$externalHref,
						'#',
						_List_fromArray(
							[
								$author$project$Ui$Link$onClick($author$project$Navbars$Practice$ShowSupportChat),
								$author$project$Ui$Link$test('help-support-chat')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Help & Support '),
								A4(
								$author$project$Ui$Image$view,
								imageStore,
								{LD: 'Help and support icon'},
								_List_fromArray(
									[
										$author$project$Ui$Image$height(20)
									]),
								13)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('sidenav__item')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$externalHref,
						'https://support.hint.com/',
						_List_fromArray(
							[
								$author$project$Ui$Link$targetBlank,
								$author$project$Ui$Link$test('help-support-articles')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Support Articles')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('sidenav__item')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$externalHref,
						'https://community.hint.com/c/hint-updates/',
						_List_fromArray(
							[
								$author$project$Ui$Link$targetBlank,
								$author$project$Ui$Link$test('help-product-updates')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Product Updates')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('sidenav__item')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$externalHref,
						'https://roadmap.hint.com',
						_List_fromArray(
							[
								$author$project$Ui$Link$targetBlank,
								$author$project$Ui$Link$test('help-product-roadmap')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Product Roadmap')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('sidenav__item')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Support__CannySso,
						_List_fromArray(
							[
								$author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
								$author$project$Ui$Link$test('help-feature-requests')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Feature Requests')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('sidenav__item')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$externalHref,
						'https://community.hint.com/oauth2/initiate',
						_List_fromArray(
							[
								$author$project$Ui$Link$targetBlank,
								$author$project$Ui$Link$test('help-community')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Community')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('sidenav__item')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$externalHref,
						'https://www.hint.com/ecosystem',
						_List_fromArray(
							[
								$author$project$Ui$Link$targetBlank,
								$author$project$Ui$Link$test('help-partner-ecosystem')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Partner Ecosystem')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('sidenav__item')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$externalHref,
						'https://www.hint.com/blog',
						_List_fromArray(
							[
								$author$project$Ui$Link$targetBlank,
								$author$project$Ui$Link$test('help-blog')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Blog')
							]))
					]))
			]));
};
var $author$project$Navbars$Practice$viewSearchKeyboardShortcut = function (maybeOsName) {
	if (!maybeOsName.$) {
		var osName = maybeOsName.a;
		return ((osName === 'Mac') || ((osName === 'iOS') || (osName === 'iPadOS'))) ? '⌘ K' : 'Ctrl+K';
	} else {
		return '';
	}
};
var $author$project$Ui$Icon$Fill = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Icon$fill = $author$project$Ui$Icon$Fill;
var $author$project$Navbars$Practice$emrDashboardUrl = F3(
	function (practice, origin, emrHost) {
		var isUnifiedExperience = A2($author$project$Api$Provider$Practice$One$featureEnabled, 19, practice);
		return A3($author$project$Utils$Clinical$getDashboardUrl, isUnifiedExperience, origin, emrHost);
	});
var $author$project$Ui$Popover$Attrs = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Popover$ml32 = $author$project$Ui$Popover$Attrs(
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('ml-32')
		]));
var $author$project$Ui$Popover$mt3 = $author$project$Ui$Popover$Attrs(
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mt-3')
		]));
var $author$project$Navbars$Practice$LogoClicked = {$: 16};
var $author$project$Navbars$Practice$viewAppLogo = F4(
	function (whitelabelSetting, practiceName, maybeListOptions, isHintAdmin) {
		var createStaticElement = function (content) {
			return A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$inlineBlock]),
				_List_fromArray(
					[content]));
		};
		var createHinterButton = function (content) {
			return A3(
				$author$project$Ui$Button$view,
				{mm: 'Show hinter practice settings'},
				_List_fromArray(
					[
						$author$project$Ui$Button$link,
						$author$project$Ui$Button$onClick($author$project$Navbars$Practice$LogoClicked)
					]),
				_List_fromArray(
					[content]));
		};
		var renderContent = F2(
			function (content, hasValidUrl) {
				if (isHintAdmin) {
					return createHinterButton(
						A2($elm$html$Html$map, $elm$core$Basics$never, content));
				} else {
					if (hasValidUrl) {
						if (!maybeListOptions.$) {
							var listOptions = maybeListOptions.a;
							return A3(
								$author$project$Ui$Link$externalHref,
								'/',
								listOptions,
								_List_fromArray(
									[content]));
						} else {
							return A2($elm$html$Html$map, $elm$core$Basics$never, content);
						}
					} else {
						return createStaticElement(
							A2($elm$html$Html$map, $elm$core$Basics$never, content));
					}
				}
			});
		var _v0 = _Utils_Tuple2(
			$author$project$Api$WhitelabelSetting$practiceFacingLogoAltText(whitelabelSetting),
			$author$project$Api$WhitelabelSetting$practiceFacingLogoUrl(whitelabelSetting));
		var altText = _v0.a;
		var maybeLogoUrl = _v0.b;
		var logoElementNever = function (logoUrl) {
			return A2(
				$elm$html$Html$map,
				$elm$core$Basics$never,
				A3(
					$author$project$Ui$Image$fromSrc,
					{LD: altText},
					logoUrl,
					_List_fromArray(
						[
							$author$project$Ui$Image$height(40)
						])));
		};
		if (!maybeLogoUrl.$) {
			var logoUrl = maybeLogoUrl.a;
			return A2(
				renderContent,
				logoElementNever(logoUrl),
				true);
		} else {
			return A2(
				renderContent,
				A2(
					$elm$html$Html$map,
					$elm$core$Basics$never,
					$elm$html$Html$text(practiceName)),
				false);
		}
	});
var $author$project$Navbars$Practice$viewAppLogoForDropdown = F2(
	function (whitelabelSetting, practiceName) {
		var _v0 = _Utils_Tuple2(
			$author$project$Api$WhitelabelSetting$practiceFacingLogoAltText(whitelabelSetting),
			$author$project$Api$WhitelabelSetting$practiceFacingLogoUrl(whitelabelSetting));
		var altText = _v0.a;
		var maybeLogoUrl = _v0.b;
		if (!maybeLogoUrl.$) {
			var logoUrl = maybeLogoUrl.a;
			return A3(
				$author$project$Ui$Image$fromSrc,
				{LD: altText},
				logoUrl,
				_List_fromArray(
					[
						$author$project$Ui$Image$height(40)
					]));
		} else {
			return A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$inlineBlock]),
				_List_fromArray(
					[
						$elm$html$Html$text(practiceName)
					]));
		}
	});
var $author$project$Navbars$Practice$viewLogo = F4(
	function (_v0, dropdownMenu, sessionConfiguration, hinterViewOff) {
		var whitelabelSetting = _v0.aey;
		var practice = _v0.ZV;
		var origin = _v0.ajG;
		var emrHost = _v0.agP;
		var showSwitchProduct = _v0.JL;
		var unifiedExperienceEnabled = _v0.qJ;
		var backupAuthEnabled = _v0.ae6;
		var isHintAdmin = _v0.Ij;
		if (showSwitchProduct && (!unifiedExperienceEnabled)) {
			var appSwitcher = function (appList) {
				return isHintAdmin ? A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceX2]),
					_List_fromArray(
						[
							A4(
							$author$project$Navbars$Practice$viewAppLogo,
							whitelabelSetting,
							$author$project$Api$Provider$Practice$One$name(practice),
							$elm$core$Maybe$Nothing,
							isHintAdmin),
							A4(
							$author$project$Ui$Dropdown$view,
							_List_fromArray(
								[
									$author$project$Ui$Dropdown$disabled(backupAuthEnabled),
									$author$project$Ui$Dropdown$buttonLink
								]),
							_List_Nil,
							appList,
							dropdownMenu)
						])) : A4(
					$author$project$Ui$Dropdown$view,
					_List_fromArray(
						[
							$author$project$Ui$Dropdown$disabled(backupAuthEnabled),
							$author$project$Ui$Dropdown$buttonLink
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$elm$core$Basics$never,
							A2(
								$author$project$Navbars$Practice$viewAppLogoForDropdown,
								whitelabelSetting,
								$author$project$Api$Provider$Practice$One$name(practice)))
						]),
					appList,
					dropdownMenu);
			};
			return backupAuthEnabled ? A3(
				$author$project$Ui$Popover$view,
				_List_fromArray(
					[$author$project$Ui$Popover$sm, $author$project$Ui$Popover$mt3, $author$project$Ui$Popover$ml32]),
				_List_fromArray(
					[
						appSwitcher(_List_Nil)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Popover$body,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('The Clinical app is temporarily unavailable due to the sign-in system outage.')
							]))
					])) : appSwitcher(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Dropdown$link,
						A3($author$project$Navbars$Practice$emrDashboardUrl, practice, origin, emrHost),
						_List_Nil,
						$elm$html$Html$text('Clinical'))
					]));
		} else {
			var listOptions = _List_fromArray(
				[
					$author$project$Ui$Link$disabled(
					sessionConfiguration.ZX && (!sessionConfiguration.lk.Aq(hinterViewOff)))
				]);
			return A4(
				$author$project$Navbars$Practice$viewAppLogo,
				whitelabelSetting,
				$author$project$Api$Provider$Practice$One$name(practice),
				$elm$core$Maybe$Just(listOptions),
				isHintAdmin);
		}
	});
var $author$project$Navbars$Practice$viewTopNavbar = F4(
	function (hinterViewOff, model, jointProductEnabled, maybeOrgSwitcher) {
		var sessionConfiguration = model.Ex;
		var isHintAdmin = A2($author$project$Utils$User$isViewingAsHinter, model.aa4, hinterViewOff);
		var logoConfig = {ae6: model.ae6, agP: model.agP, Ij: isHintAdmin, ajG: model.ajG, ZV: model.ZV, JL: jointProductEnabled, qJ: model.kI.qJ, aey: model.aey};
		var logo = A4($author$project$Navbars$Practice$viewLogo, logoConfig, model.qq, sessionConfiguration, hinterViewOff);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('elm-mobile-nav')
						]),
					$elm$core$List$concat(
						_List_fromArray(
							[
								_List_fromArray(
								[logo]),
								model.qh ? _List_Nil : _List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('sidenav-open')
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{mm: 'Display side navigation menu'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick(
													$author$project$Navbars$Practice$SidenavToggled(true))
												]),
											_List_fromArray(
												[
													$author$project$Ui$Icon$burgerMenu(_List_Nil)
												]))
										]))
								])
							]))),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('topnav')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('topnav__left')
								]),
							_List_fromArray(
								[
									logo,
									A2(
									$elm$core$Maybe$withDefault,
									A2(
										$author$project$Navbars$Utils$viewSwitchOrganizationLink,
										$author$project$Api$Provider$Practice$One$name(model.ZV),
										sessionConfiguration.lk.Nk),
									maybeOrgSwitcher)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('topnav__right')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('topnav__search')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Navbars$Utils$ifConfiguration,
											sessionConfiguration.xQ(hinterViewOff),
											A3(
												$author$project$Ui$Button$view,
												{mm: 'Search'},
												_List_fromArray(
													[
														$author$project$Ui$Button$onClick($author$project$Navbars$Practice$SearchClicked)
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('topnav__search-content')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_Nil,
																_List_fromArray(
																	[
																		A2(
																		$author$project$Ui$Icon$view,
																		_List_fromArray(
																			[
																				$author$project$Ui$Icon$fill('currentColor'),
																				$author$project$Ui$Icon$height('0.9rem')
																			]),
																		41),
																		$author$project$Utils$Html$noBreakSpace,
																		$author$project$Utils$Html$noBreakSpace,
																		$elm$html$Html$text('Search')
																	])),
																A2(
																$elm$html$Html$div,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		$author$project$Navbars$Practice$viewSearchKeyboardShortcut(sessionConfiguration.lk.Yx))
																	]))
															]))
													])))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('topnav__item')
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$Marketplace__Top,
											_List_fromArray(
												[
													$author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
													$author$project$Ui$Link$test('marketplace'),
													$author$project$Ui$Link$icon($author$project$Ui$Icon$marketplace)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Marketplace')
												]))
										])),
									(sessionConfiguration.ZX && (!sessionConfiguration.lk.Aq(hinterViewOff))) ? $author$project$Utils$Html$empty : A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('topnav__item topnav__subnav'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('topnav__subnav--open', 2 === model.dw)
												]))
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{mm: 'view help resources'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick(
													$author$project$Navbars$Practice$NavClicked(2)),
													$author$project$Ui$Button$icon($author$project$Ui$Icon$book),
													$author$project$Ui$Button$test('help')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Resources'),
													A2(
													$author$project$Ui$Icon$view,
													_List_fromArray(
														[
															$author$project$Ui$Icon$class('topnav__icon--show-more')
														]),
													12)
												])),
											$author$project$Navbars$Practice$viewResourcesSubNav(model.sF)
										]))
								]))
						]))
				]));
	});
var $author$project$Navbars$Practice$view = F3(
	function (hinterViewOff, maybeOrgSwitcherConfig, _v0) {
		var model = _v0;
		var sessionConfiguration = model.Ex;
		var slideIn = model.qh;
		var sidenavExpanded = model.qc;
		var profileMobileView = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					A2($author$project$Navbars$Practice$subNavClasses, 3, model.dw) + ' sidenav__item--profile-mobile')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{mm: 'Profile'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$onClick(
							$author$project$Navbars$Practice$NavClicked(3)),
							$author$project$Ui$Button$test('account-profile-mobile')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Icon$account(
							_List_fromArray(
								[$author$project$Ui$Icon$sidenav])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sidenav__profile-name')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(sessionConfiguration.lk.amm)
								])),
							A2(
							$author$project$Ui$Icon$view,
							_List_fromArray(
								[
									$author$project$Ui$Icon$class('sidenav__icon--show-more ml-2')
								]),
							12)
						])),
					$author$project$Navbars$Practice$viewProfileSubNav(model.fd)
				]));
		var profileButton = A3(
			$author$project$Ui$Button$view,
			{mm: 'Profile'},
			_List_fromArray(
				[
					$author$project$Ui$Button$link,
					$author$project$Ui$Button$test('account-profile')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Icon$account(
					_List_fromArray(
						[$author$project$Ui$Icon$sidenav])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sidenav__profile-name')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Profile')
						]))
				]));
		var orgSwitcherHtml = A2($author$project$Components$OrganizationSwitcher$maybeViewFor, $author$project$Navbars$Practice$OrgSwitcherMsg, maybeOrgSwitcherConfig);
		var mainItems = A5($author$project$Navbars$Practice$Navigation$mainNavItems, model.ZV, model.kI, model.Ex, hinterViewOff, model.x4);
		var navElementsMobile = A3($author$project$Navbars$Practice$viewMobileNavElements, model, hinterViewOff, mainItems);
		var jointProduct = A2($author$project$Api$Provider$Practice$One$featureEnabled, 6, model.ZV);
		var canExpandNav = A2($author$project$Api$Provider$Practice$One$featureEnabled, 19, model.ZV);
		var isExpanded = sidenavExpanded && canExpandNav;
		var navElementsDesktop = A4($author$project$Navbars$Practice$viewDesktopNavElements, model, hinterViewOff, isExpanded, mainItems);
		var profileMenuView = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('sidenav__item sidenav__item--profile sidenav__item--profile-desktop'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'sidenav__active',
							_Utils_eq(model.fd, $author$project$Navbars$Practice$Navigation$Account))
						]))
				]),
			$elm$core$List$singleton(
				A4(
					$author$project$Ui$FlyoutMenu$view,
					_List_fromArray(
						[
							$author$project$Ui$FlyoutMenu$position(1)
						]),
					_List_fromArray(
						[
							$author$project$Ui$FlyoutMenu$body(
							_List_fromArray(
								[
									$author$project$Navbars$Practice$viewProfileSubNav(model.fd)
								]))
						]),
					isExpanded ? profileButton : A3(
						$author$project$Ui$Tooltip$view,
						_List_fromArray(
							[
								$author$project$Ui$Tooltip$placement(3),
								$author$project$Ui$Tooltip$stackingOrder1030
							]),
						'Profile',
						_List_fromArray(
							[profileButton])),
					model.eZ)));
		return _List_fromArray(
			[
				A4($author$project$Navbars$Practice$viewTopNavbar, hinterViewOff, model, jointProduct, orgSwitcherHtml),
				$author$project$Navbars$Utils$viewTopNavEnd,
				A2(
				$elm$html$Html$map,
				$author$project$Navbars$Practice$HinterPracticeSettingsModalMsg,
				$author$project$Components$HinterPracticeSettingsModal$view(model.jT)),
				A2(
				$author$project$Navbars$Utils$ifConfiguration,
				sessionConfiguration.lk.abq(hinterViewOff),
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id('sidenav'),
							$elm$html$Html$Attributes$class('sidenav'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('sidenav--slide-in', slideIn),
									_Utils_Tuple2('sidenav--expanded', isExpanded)
								]))
						]),
					_List_fromArray(
						[
							canExpandNav ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sidenav__expand-toggle')
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{
										mm: isExpanded ? 'Collapse navigation' : 'Expand navigation'
									},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick($author$project$Navbars$Practice$SidenavExpandToggled),
											$author$project$Ui$Button$test('sidenav-expand-toggle')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Icon$view,
											_List_fromArray(
												[
													$author$project$Ui$Icon$class(
													isExpanded ? 'sidenav__toggle-icon sidenav__toggle-icon--expanded' : 'sidenav__toggle-icon')
												]),
											12)
										]))
								])) : $elm$html$Html$text(''),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sidenav__header sidenav__header--practice')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('sidenav__header--left')
										]),
									_List_fromArray(
										[
											$author$project$Ui$Icon$location(_List_Nil),
											$elm$html$Html$text(
											$author$project$Api$Provider$Practice$One$name(model.ZV)),
											A2(
											$author$project$Navbars$Utils$ifConfiguration,
											sessionConfiguration.lk.Nk,
											A3(
												$author$project$Ui$Link$route,
												$author$project$Spa$Generated$Route$User__Organizations__Top,
												_List_fromArray(
													[
														$author$project$Ui$Link$ariaLabel('Switch organization'),
														$author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked)
													]),
												_List_fromArray(
													[
														$author$project$Ui$Icon$kebabMenu(_List_Nil)
													])))
										])),
									slideIn ? A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('sidenav-close')
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{mm: 'Close side navigation menu'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick(
													$author$project$Navbars$Practice$SidenavToggled(false))
												]),
											_List_fromArray(
												[
													$author$project$Ui$Icon$burgerMenuClose(_List_Nil)
												]))
										])) : $author$project$Utils$Html$empty
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sidenav__search')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Navbars$Utils$ifConfiguration,
									sessionConfiguration.xQ(hinterViewOff),
									A3(
										$author$project$Ui$Button$view,
										{mm: 'Search'},
										_List_fromArray(
											[
												$author$project$Ui$Button$onClick($author$project$Navbars$Practice$SearchClicked)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('sidenav__search-content')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_Nil,
														_List_fromArray(
															[
																$author$project$Ui$Icon$search(_List_Nil),
																$author$project$Utils$Html$noBreakSpace,
																$elm$html$Html$text('Search')
															])),
														A2(
														$elm$html$Html$div,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(
																$author$project$Navbars$Practice$viewSearchKeyboardShortcut(sessionConfiguration.lk.Yx))
															]))
													]))
											])))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sidenav__main sidenav__main--mobile')
								]),
							navElementsMobile),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sidenav__main sidenav__main--desktop')
								]),
							navElementsDesktop),
							A2($author$project$Navbars$Practice$viewHinterIdButtons, model, hinterViewOff),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sidenav__bottom')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('sidenav__bottom-separator')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class(
											A2($author$project$Navbars$Practice$selectedNavClass, $author$project$Navbars$Practice$Navigation$Marketplace, model.fd)),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'bg-primary-100',
													_Utils_eq(model.fd, $author$project$Navbars$Practice$Navigation$Marketplace))
												]))
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$Marketplace__Top,
											_List_fromArray(
												[
													$author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
													$author$project$Ui$Link$test('marketplace')
												]),
											_List_fromArray(
												[
													$author$project$Ui$Icon$marketplace(
													_List_fromArray(
														[$author$project$Ui$Icon$sidenav])),
													$elm$html$Html$text('Marketplace')
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class(
											A2($author$project$Navbars$Practice$subNavClasses, 2, model.dw))
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{mm: 'View help resources'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick(
													$author$project$Navbars$Practice$NavClicked(2)),
													$author$project$Ui$Button$test('help')
												]),
											_List_fromArray(
												[
													$author$project$Ui$Icon$book(
													_List_fromArray(
														[$author$project$Ui$Icon$sidenav])),
													$elm$html$Html$text('Resources'),
													A2(
													$author$project$Ui$Icon$view,
													_List_fromArray(
														[
															$author$project$Ui$Icon$class('sidenav__icon--show-more ml-2')
														]),
													12)
												])),
											$author$project$Navbars$Practice$viewResourcesSubNav(model.sF)
										])),
									profileMobileView,
									profileMenuView
								]))
						])))
			]);
	});
var $author$project$Navbar$viewNavbar = F2(
	function (orgSwitcherConfig, _v0) {
		var model = _v0;
		var _v1 = model.ai;
		switch (_v1.$) {
			case 0:
				return _List_Nil;
			case 1:
				var practiceNavModel = _v1.a;
				return A2(
					$elm$core$List$map,
					$elm$html$Html$map($author$project$Navbar$PracticeNavbarMsg),
					A3($author$project$Navbars$Practice$view, model.ahK, orgSwitcherConfig, practiceNavModel));
			case 2:
				var companyNavModel = _v1.a;
				return A2(
					$elm$core$List$map,
					$elm$html$Html$map($author$project$Navbar$CompanyNavbarMsg),
					A3($author$project$Navbars$Company$view, model.ahK, orgSwitcherConfig, companyNavModel));
			default:
				var partnerNavModel = _v1.a;
				return A2(
					$elm$core$List$map,
					$elm$html$Html$map($author$project$Navbar$PartnerNavbarMsg),
					A3($author$project$Navbars$Partner$view, model.ahK, orgSwitcherConfig, partnerNavModel));
		}
	});
var $author$project$Navbar$view = F2(
	function (shared, _v0) {
		var model = _v0;
		var practice = model.ZV;
		var session = model.aa4;
		if (shared.agL) {
			return $elm$html$Html$text('');
		} else {
			var orgSwitcherConfig = A3(
				$elm$core$Maybe$map2,
				F2(
					function (switcher, org) {
						return {aiO: switcher, Yr: org};
					}),
				shared.ajC,
				shared.Yr);
			return A2(
				$elm$html$Html$nav,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id('navbar-wrapper'),
						$elm$html$Html$Attributes$class('navbar-wrapper')
					]),
				$elm$core$List$concat(
					_List_fromArray(
						[
							_List_fromArray(
							[
								$author$project$Components$DebugInfo$view(
								{aeZ: shared.aeZ, age: shared.age, agL: shared.agL, ahJ: shared.ahJ, aiY: shared.aiY, aa4: session}),
								A2(
								$elm$html$Html$map,
								$author$project$Navbar$SandboxAlertMsg,
								$author$project$Components$SandboxAlert$view(session))
							]),
							A5($author$project$Navbar$viewAlerts, session, model.ahK, practice, shared.ae6, shared.dd),
							A2($author$project$Navbar$viewNavbar, orgSwitcherConfig, model)
						])));
		}
	});
var $author$project$Ui$Toast$ToastBlurred = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Toast$ToastClicked = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Toast$ToastHovered = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Toast$levelClass = function (level) {
	switch (level) {
		case 0:
			return $elm$html$Html$Attributes$class('toast--info');
		case 1:
			return $elm$html$Html$Attributes$class('toast--danger');
		case 2:
			return $elm$html$Html$Attributes$class('toast--warning');
		default:
			return $elm$html$Html$Attributes$class('toast--success');
	}
};
var $elm$html$Html$Events$onMouseOut = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseout',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Ui$Toast$viewToast = function (_v0) {
	var id = _v0.ahP;
	var level = _v0.VV;
	var message = _v0.aiH;
	return _Utils_Tuple2(
		$elm$core$String$fromInt(id),
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					$author$project$Ui$Toast$ToastClicked(id)),
					$elm$html$Html$Events$onMouseEnter(
					$author$project$Ui$Toast$ToastHovered(id)),
					$elm$html$Html$Events$onMouseOut(
					$author$project$Ui$Toast$ToastBlurred(id)),
					$elm$html$Html$Attributes$class('toast'),
					$author$project$Ui$Toast$levelClass(level)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$text,
					_List_fromArray(
						[
							$author$project$Ui$Typography$phi(true)
						]),
					message)
				])));
};
var $author$project$Ui$Toast$view = function (_v0) {
	var toasts = _v0.b;
	return $elm$core$List$isEmpty(toasts) ? $elm$html$Html$text('') : A3(
		$elm$html$Html$Keyed$node,
		'div',
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('toast-container')
			]),
		A2($elm$core$List$map, $author$project$Ui$Toast$viewToast, toasts));
};
var $author$project$Shared$view = F2(
	function (_v0, model) {
		var layout = _v0.bE;
		var page = _v0.dB;
		var toMsg = _v0.al6;
		var isClinicalPage = _v0.aia;
		var user = $author$project$Api$Data$toMaybe(model.ad0);
		var showSideNav = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$author$project$Navbar$showSideNav(model.ahK),
				model.aj));
		return {
			fO: _List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					toMsg,
					A2(
						$elm$html$Html$map,
						$author$project$Shared$ToastMsg,
						$author$project$Ui$Toast$view(model.lO))),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id('ng-app'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('embedded', model.ahq.agL)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('horizontal-wrapper'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'login',
											_Utils_eq(user, $elm$core$Maybe$Nothing))
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('vertical-wrapper'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('with-full-navigation', showSideNav)
												]))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$id('spa-document'),
													$elm$html$Html$Attributes$class('flex'),
													$elm$html$Html$Attributes$class('flex-col'),
													$elm$html$Html$Attributes$class('h-full')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('container content'),
															$elm$html$Html$Attributes$classList(
															_List_fromArray(
																[
																	_Utils_Tuple2('clinical-page', isClinicalPage)
																]))
														]),
													_List_fromArray(
														[
															A2(
															$elm$core$Maybe$withDefault,
															$author$project$Utils$Html$empty,
															A2(
																$elm$core$Maybe$map,
																A2(
																	$elm$core$Basics$composeR,
																	$author$project$Navbar$view(
																		{
																			aeZ: model.ahq.aeZ,
																			ae6: model.ahq.ae6,
																			dd: model.dd,
																			age: model.ahq.age,
																			agL: model.ahq.agL,
																			ahJ: $author$project$Utils$Environment$toString(model.ahJ),
																			aiY: $author$project$Utils$Environment$toString(model.aiY),
																			ajC: model.g1,
																			Yr: $author$project$Shared$organizationFromSession(model)
																		}),
																	$elm$html$Html$map(
																		A2($elm$core$Basics$composeR, $author$project$Shared$NavbarMsg, toMsg))),
																model.aj)),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$id('elm-app'),
																	$elm$html$Html$Attributes$classList(
																	_List_fromArray(
																		[
																			_Utils_Tuple2('highlight-phi', model.nU)
																		]))
																]),
															A2(
																layout,
																A2($elm$core$Basics$composeR, $author$project$Shared$PatientsListMsg, toMsg),
																page.fO)),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$id('hint-clinical-root'),
																	$elm$html$Html$Attributes$class('clinical')
																]),
															_List_Nil)
														]))
												]))
										]))
								])),
							function () {
							var _v1 = _Utils_Tuple2(model.aa4, model.ZV);
							if ((_v1.a.$ === 3) && (_v1.b.$ === 3)) {
								var _v2 = _v1.a;
								var session = _v2.a;
								var _v3 = _v1.b;
								var practice = _v3.a;
								var route = $author$project$Utils$Route$fromUrl(model.adY);
								return A2(
									$elm$html$Html$map,
									toMsg,
									A2(
										$elm$html$Html$map,
										$author$project$Shared$AccountLockedModalMsg,
										A3($author$project$Components$AccountLockedModal$view, session, practice, route)));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}(),
							A2(
							$elm$html$Html$map,
							toMsg,
							function () {
								if (model.uF) {
									var customOptions = _List_fromArray(
										[
											$author$project$Components$HiConfirm$verb('resume'),
											$author$project$Components$HiConfirm$noun('session'),
											$author$project$Components$HiConfirm$customMessage(
											_List_fromArray(
												[
													$elm$html$Html$text('Simply click anywhere on the screen to continue.')
												])),
											$author$project$Components$HiConfirm$customTitle('Your Session Is About to Expire'),
											$author$project$Components$HiConfirm$showCancel(false)
										]);
									return A2(
										$author$project$Components$HiConfirm$modal,
										$elm$core$Basics$always($author$project$Shared$HideLogoutWarning),
										customOptions);
								} else {
									return $author$project$Utils$Html$empty;
								}
							}()),
							A2(
							$elm$html$Html$map,
							toMsg,
							model.uA ? $author$project$Components$Auth$SystemRecoveryModal$view($author$project$Shared$HideAuthRecoveryModal) : $author$project$Utils$Html$empty),
							A2(
							$elm$html$Html$map,
							toMsg,
							A2(
								$elm$html$Html$map,
								$author$project$Shared$GlobalSearchMsg,
								$author$project$Components$GlobalSearch$view(model.gw))),
							function () {
							var _v4 = _Utils_Tuple2(
								model.ajY,
								!_Utils_eq(model.Zn, $elm$core$Maybe$Nothing));
							if ((!_v4.a.$) && _v4.b) {
								var pendingChangesDetail = _v4.a.a;
								return A2(
									$elm$html$Html$map,
									toMsg,
									A3($author$project$Components$PendingChangesModal$view, pendingChangesDetail, $author$project$Shared$PendingChangesDiscard, $author$project$Shared$PendingChangesKeep));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						]))
				]),
			ac9: page.ac9
		};
	});
var $author$project$Layouts$Admin$StructureNode = $elm$core$Basics$identity;
var $author$project$Layouts$Admin$Node = $elm$core$Basics$identity;
var $author$project$Layouts$Admin$structureOrNodeVisible = F2(
	function (practice, featureGated) {
		return A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				function (featureGated_) {
					return A2(
						$author$project$Utils$FeatureGate$gateAvailable,
						featureGated_,
						$author$project$Api$Practice$Provider(practice));
				},
				featureGated));
	});
var $author$project$Layouts$Admin$nodeVisible = F2(
	function (practice, _v0) {
		var node = _v0;
		return A2($author$project$Layouts$Admin$structureOrNodeVisible, practice, node.b);
	});
var $author$project$Layouts$Admin$routeActive = F2(
	function (currentRoute, route) {
		return _Utils_eq(route, currentRoute) || A2(
			$elm$core$String$startsWith,
			$author$project$Spa$Generated$Route$toString(route) + '/',
			$author$project$Spa$Generated$Route$toString(currentRoute));
	});
var $author$project$Layouts$Admin$nodeActive = F3(
	function (currentRoute, practice, _v0) {
		var node = _v0;
		return A2($author$project$Layouts$Admin$nodeVisible, practice, node) && A2($author$project$Layouts$Admin$routeActive, currentRoute, node.e);
	});
var $author$project$Layouts$Admin$structureVisible = F2(
	function (practice, _v0) {
		var node = _v0;
		return A2($author$project$Layouts$Admin$structureOrNodeVisible, practice, node.b);
	});
var $author$project$Layouts$Admin$getActiveStructure = F3(
	function (currentRoute, practice, nodes) {
		return A2(
			$elm_community$list_extra$List$Extra$find,
			function (_v0) {
				var node = _v0;
				var visible = A2($author$project$Layouts$Admin$structureVisible, practice, node);
				return visible && A2(
					$elm$core$List$any,
					A2($author$project$Layouts$Admin$nodeActive, currentRoute, practice),
					node.L);
			},
			nodes);
	});
var $author$project$Layouts$Admin$appTabVisible = F2(
	function (isHintAdmin, managedPartner) {
		return isHintAdmin || function () {
			if (managedPartner.$ === 3) {
				var partner = managedPartner.a;
				return $author$project$Api$Provider$ManagedPartner$One$appEnabled(partner);
			} else {
				return false;
			}
		}();
	});
var $author$project$Layouts$Admin$getAccountLayout = F2(
	function (practice, isHintAdmin) {
		return $elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						{b: $elm$core$Maybe$Nothing, ahO: $elm$core$Maybe$Nothing, ahP: 'nav-item-general', Bq: 'General', e: $author$project$Spa$Generated$Route$Admin__Practice}
					]),
					(A2($author$project$Api$Provider$Practice$One$featureEnabled, 19, practice) && A2($author$project$Api$Provider$Practice$One$featureEnabled, 6, practice)) ? _List_Nil : (((!$author$project$Api$Provider$Practice$One$hasClinicalAccount(practice)) || isHintAdmin) ? _List_fromArray(
					[
						{b: $elm$core$Maybe$Nothing, ahO: $elm$core$Maybe$Nothing, ahP: 'nav-item-users', Bq: 'Users', e: $author$project$Spa$Generated$Route$Admin__Team}
					]) : _List_Nil),
					_List_fromArray(
					[
						{b: $elm$core$Maybe$Nothing, ahO: $elm$core$Maybe$Nothing, ahP: 'nav-item-billing', Bq: 'Billing', e: $author$project$Spa$Generated$Route$Admin__Billing},
						{b: $elm$core$Maybe$Nothing, ahO: $elm$core$Maybe$Nothing, ahP: 'nav-item-sources', Bq: 'Payment Methods', e: $author$project$Spa$Generated$Route$Admin__PaymentSources},
						{b: $elm$core$Maybe$Nothing, ahO: $elm$core$Maybe$Nothing, ahP: 'nav-item-payment-processing', Bq: 'Payment Processing', e: $author$project$Spa$Generated$Route$Admin__PaymentProcessing}
					]),
					((($author$project$Api$Provider$Practice$One$paymentProcessor(practice) === 'stripe') || $author$project$Api$Provider$Practice$One$hasStripeAccount(practice)) && (!A2($author$project$Api$Provider$Practice$One$featureEnabled, 26, practice))) ? _List_fromArray(
					[
						{b: $elm$core$Maybe$Nothing, ahO: $elm$core$Maybe$Nothing, ahP: 'nav-item-stripe', Bq: 'Stripe', e: $author$project$Spa$Generated$Route$Admin__Stripe}
					]) : _List_Nil,
					_List_fromArray(
					[
						{b: $elm$core$Maybe$Nothing, ahO: $elm$core$Maybe$Nothing, ahP: 'nav-item-card-readers', Bq: 'Card Readers', e: $author$project$Spa$Generated$Route$Admin__CardReaders}
					]),
					isHintAdmin ? _List_fromArray(
					[
						{
						b: $elm$core$Maybe$Nothing,
						ahO: $elm$core$Maybe$Just(
							$author$project$Ui$Icon$hintHeart(
								_List_fromArray(
									[$author$project$Ui$Icon$spacedRight]))),
						ahP: 'nav-item-notes',
						Bq: 'Notes',
						e: $author$project$Spa$Generated$Route$Admin__Notes
					},
						{
						b: $elm$core$Maybe$Nothing,
						ahO: $elm$core$Maybe$Just(
							$author$project$Ui$Icon$hintHeart(
								_List_fromArray(
									[$author$project$Ui$Icon$spacedRight]))),
						ahP: 'nav-item-features',
						Bq: 'Beta Features',
						e: $author$project$Spa$Generated$Route$Admin__Features
					},
						{
						b: $elm$core$Maybe$Nothing,
						ahO: $elm$core$Maybe$Just(
							$author$project$Ui$Icon$hintHeart(
								_List_fromArray(
									[$author$project$Ui$Icon$spacedRight]))),
						ahP: 'nav-item-internal-settings',
						Bq: 'Internal Settings',
						e: $author$project$Spa$Generated$Route$Admin__InternalSettings
					},
						{
						b: $elm$core$Maybe$Nothing,
						ahO: $elm$core$Maybe$Just(
							$author$project$Ui$Icon$hintHeart(
								_List_fromArray(
									[$author$project$Ui$Icon$spacedRight]))),
						ahP: 'nav-item-scheduled-jobs',
						Bq: 'Scheduled Jobs',
						e: $author$project$Spa$Generated$Route$Admin__ScheduledJobs
					}
					]) : _List_Nil
				]));
	});
var $author$project$Layouts$Admin$structure = F5(
	function (session, practice, hinterViewOff, isHintAdmin, managedPartner) {
		return A3($author$project$Permission$canGoTo, session, hinterViewOff, 0) ? $elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						{
						L: A2($author$project$Layouts$Admin$getAccountLayout, practice, isHintAdmin),
						b: $elm$core$Maybe$Nothing,
						ac9: 'Account'
					}
					]),
					(A2($author$project$Api$Provider$Practice$One$featureEnabled, 19, practice) && A2($author$project$Api$Provider$Practice$One$featureEnabled, 6, practice)) ? _List_fromArray(
					[
						{
						L: _List_fromArray(
							[
								{b: $elm$core$Maybe$Nothing, ahO: $elm$core$Maybe$Nothing, ahP: 'nav-item-phones', Bq: 'Phones', e: $author$project$Spa$Generated$Route$NewSettings__PracticeInfo}
							]),
						b: $elm$core$Maybe$Nothing,
						ac9: 'Phones'
					},
						{
						L: _List_fromArray(
							[
								{b: $elm$core$Maybe$Nothing, ahO: $elm$core$Maybe$Nothing, ahP: 'nav-item-team', Bq: 'Team', e: $author$project$Spa$Generated$Route$NewSettings__Team}
							]),
						b: $elm$core$Maybe$Nothing,
						ac9: 'Team'
					}
					]) : _List_Nil,
					_List_fromArray(
					[
						{
						L: $elm$core$List$concat(
							_List_fromArray(
								[
									_List_fromArray(
									[
										{b: $elm$core$Maybe$Nothing, ahO: $elm$core$Maybe$Nothing, ahP: 'nav-item-providers', Bq: 'Providers', e: $author$project$Spa$Generated$Route$Admin__Providers__Top},
										{b: $elm$core$Maybe$Nothing, ahO: $elm$core$Maybe$Nothing, ahP: 'nav-item-patients', Bq: 'Patients', e: $author$project$Spa$Generated$Route$Admin__Patients},
										{b: $elm$core$Maybe$Nothing, ahO: $elm$core$Maybe$Nothing, ahP: 'nav-item-locations', Bq: 'Locations', e: $author$project$Spa$Generated$Route$Admin__Locations},
										{b: $elm$core$Maybe$Nothing, ahO: $elm$core$Maybe$Nothing, ahP: 'nav-item-location-groups', Bq: 'Location Groups', e: $author$project$Spa$Generated$Route$Admin__ProviderGroups}
									]),
									A2($author$project$Api$Provider$Practice$One$featureEnabled, 28, practice) ? _List_fromArray(
									[
										{b: $elm$core$Maybe$Nothing, ahO: $elm$core$Maybe$Nothing, ahP: 'nav-item-waitlist', Bq: 'Waitlist', e: $author$project$Spa$Generated$Route$Admin__Waitlist}
									]) : _List_Nil
								])),
						b: $elm$core$Maybe$Nothing,
						ac9: 'Providers & Patients'
					},
						{
						L: _List_fromArray(
							[
								{b: $elm$core$Maybe$Nothing, ahO: $elm$core$Maybe$Nothing, ahP: 'nav-item-plans', Bq: 'Plans', e: $author$project$Spa$Generated$Route$Admin__Plans__Top},
								{b: $elm$core$Maybe$Nothing, ahO: $elm$core$Maybe$Nothing, ahP: 'nav-item-coverage-plans', Bq: 'Coverage Plans', e: $author$project$Spa$Generated$Route$Admin__CoveragePlans__Top},
								{b: $elm$core$Maybe$Nothing, ahO: $elm$core$Maybe$Nothing, ahP: 'nav-item-coupons', Bq: 'Coupons', e: $author$project$Spa$Generated$Route$Admin__Coupons},
								{b: $elm$core$Maybe$Nothing, ahO: $elm$core$Maybe$Nothing, ahP: 'nav-item-cancellation-reasons', Bq: 'Cancellation Reasons', e: $author$project$Spa$Generated$Route$Admin__CancellationReasons},
								{b: $elm$core$Maybe$Nothing, ahO: $elm$core$Maybe$Nothing, ahP: 'nav-item-invoicing', Bq: 'Invoicing Ahead of Time', e: $author$project$Spa$Generated$Route$Admin__AdvanceBilling}
							]),
						b: $elm$core$Maybe$Nothing,
						ac9: 'Membership Options'
					},
						{
						L: _List_fromArray(
							[
								{b: $elm$core$Maybe$Nothing, ahO: $elm$core$Maybe$Nothing, ahP: 'nav-item-global', Bq: 'Global Settings', e: $author$project$Spa$Generated$Route$Admin__Signup},
								{b: $elm$core$Maybe$Nothing, ahO: $elm$core$Maybe$Nothing, ahP: 'nav-item-signup', Bq: 'Signup Pages', e: $author$project$Spa$Generated$Route$Admin__SignupPages__Top},
								{
								b: $elm$core$Maybe$Just(5),
								ahO: $elm$core$Maybe$Nothing,
								ahP: 'nav-item-patient-portal',
								Bq: 'Patient Portal',
								e: $author$project$Spa$Generated$Route$Admin__SelfService
							},
								{
								b: $elm$core$Maybe$Just(5),
								ahO: $elm$core$Maybe$Nothing,
								ahP: 'nav-item-lead-sources',
								Bq: 'Lead Sources',
								e: $author$project$Spa$Generated$Route$Admin__LeadSources
							}
							]),
						b: $elm$core$Maybe$Nothing,
						ac9: 'Online Signup'
					},
						{
						L: _List_fromArray(
							[
								{b: $elm$core$Maybe$Nothing, ahO: $elm$core$Maybe$Nothing, ahP: 'nav-item-categories', Bq: 'Categories', e: $author$project$Spa$Generated$Route$Admin__CreditCategories},
								{b: $elm$core$Maybe$Nothing, ahO: $elm$core$Maybe$Nothing, ahP: 'nav-item-upload', Bq: 'Upload', e: $author$project$Spa$Generated$Route$Admin__Credits__Upload}
							]),
						b: $elm$core$Maybe$Just(4),
						ac9: 'Credits'
					},
						{
						L: _List_fromArray(
							[
								{
								b: $elm$core$Maybe$Nothing,
								ahO: $elm$core$Maybe$Nothing,
								ahP: 'nav-item-charge-items',
								Bq: A2(
									$author$project$Utils$FeatureGate$gateAvailable,
									14,
									$author$project$Api$Practice$Provider(practice)) ? 'Charge Items & Packages' : 'Charge Items',
								e: $author$project$Spa$Generated$Route$Admin__ChargeItems__Top
							},
								{b: $elm$core$Maybe$Nothing, ahO: $elm$core$Maybe$Nothing, ahP: 'nav-item-charge-categories', Bq: 'Charge Categories', e: $author$project$Spa$Generated$Route$Admin__Categories},
								{
								b: $elm$core$Maybe$Just(2),
								ahO: $elm$core$Maybe$Nothing,
								ahP: 'nav-item-tax',
								Bq: 'Sales Tax',
								e: $author$project$Spa$Generated$Route$Admin__Taxes
							}
							]),
						b: $elm$core$Maybe$Nothing,
						ac9: 'Charges'
					},
						{
						L: _List_fromArray(
							[
								{b: $elm$core$Maybe$Nothing, ahO: $elm$core$Maybe$Nothing, ahP: 'nav-item-setup', Bq: 'Set-Up', e: $author$project$Spa$Generated$Route$Admin__Commissions}
							]),
						b: $elm$core$Maybe$Nothing,
						ac9: 'Commissions'
					},
						{
						L: _List_fromArray(
							[
								{b: $elm$core$Maybe$Nothing, ahO: $elm$core$Maybe$Nothing, ahP: 'nav-item-patient', Bq: 'Patient', e: $author$project$Spa$Generated$Route$Admin__Notifications__Patient},
								{b: $elm$core$Maybe$Nothing, ahO: $elm$core$Maybe$Nothing, ahP: 'nav-item-membership', Bq: 'Membership', e: $author$project$Spa$Generated$Route$Admin__Notifications__Membership},
								{b: $elm$core$Maybe$Nothing, ahO: $elm$core$Maybe$Nothing, ahP: 'nav-item-practice', Bq: 'Practice', e: $author$project$Spa$Generated$Route$Admin__Notifications__Practice},
								{
								b: $elm$core$Maybe$Just(9),
								ahO: $elm$core$Maybe$Nothing,
								ahP: 'nav-item-employer',
								Bq: 'Employer',
								e: $author$project$Spa$Generated$Route$Admin__Notifications__Company
							},
								{
								b: $elm$core$Maybe$Just(9),
								ahO: $elm$core$Maybe$Nothing,
								ahP: 'nav-item-employee',
								Bq: 'Employee',
								e: $author$project$Spa$Generated$Route$Admin__Notifications__Employee
							},
								{b: $elm$core$Maybe$Nothing, ahO: $elm$core$Maybe$Nothing, ahP: 'nav-item-setting', Bq: 'Settings', e: $author$project$Spa$Generated$Route$Admin__Notifications__Settings}
							]),
						b: $elm$core$Maybe$Nothing,
						ac9: 'Notifications'
					},
						{
						L: _List_fromArray(
							[
								{b: $elm$core$Maybe$Nothing, ahO: $elm$core$Maybe$Nothing, ahP: 'nav-item-ephi', Bq: 'ePHI Communication Waivers', e: $author$project$Spa$Generated$Route$Admin__HipaaAuthorizations}
							]),
						b: $elm$core$Maybe$Nothing,
						ac9: 'ePHI Communication Waivers'
					},
						{
						L: _List_fromArray(
							[
								{
								b: $elm$core$Maybe$Nothing,
								ahO: $elm$core$Maybe$Nothing,
								ahP: 'nav-item-employers-invoice-settings',
								Bq: A2($author$project$Formatters$String$sponsorize, practice, 'Employers') + ' Invoice Settings',
								e: $author$project$Spa$Generated$Route$Admin__InvoiceSettings
							},
								{
								b: $elm$core$Maybe$Nothing,
								ahO: $elm$core$Maybe$Nothing,
								ahP: 'nav-item-empoyers-plans',
								Bq: A2($author$project$Formatters$String$sponsorize, practice, 'Employers') + ' Plans',
								e: $author$project$Spa$Generated$Route$Admin__CompanyPlans__Top
							}
							]),
						b: $elm$core$Maybe$Nothing,
						ac9: A2($author$project$Formatters$String$sponsorize, practice, 'Employers')
					},
						{
						L: _List_fromArray(
							[
								{b: $elm$core$Maybe$Nothing, ahO: $elm$core$Maybe$Nothing, ahP: 'nav-item-documents', Bq: 'Documents', e: $author$project$Spa$Generated$Route$Admin__Documents__Top}
							]),
						b: $elm$core$Maybe$Nothing,
						ac9: 'Documents'
					},
						{
						L: A2(
							$elm$core$List$cons,
							{b: $elm$core$Maybe$Nothing, ahO: $elm$core$Maybe$Nothing, ahP: 'nav-item-developers-get-started', Bq: 'Get Started', e: $author$project$Spa$Generated$Route$Admin__Developers__GetStarted},
							$author$project$Api$Provider$Practice$One$hasManagedPartner(practice) ? $elm$core$List$concat(
								_List_fromArray(
									[
										_List_fromArray(
										[
											{b: $elm$core$Maybe$Nothing, ahO: $elm$core$Maybe$Nothing, ahP: 'nav-item-developers-api-keys', Bq: 'API Keys', e: $author$project$Spa$Generated$Route$Admin__Developers__ApiKeys},
											{b: $elm$core$Maybe$Nothing, ahO: $elm$core$Maybe$Nothing, ahP: 'nav-item-developers-webhook-endpoints', Bq: 'Webhook Endpoints', e: $author$project$Spa$Generated$Route$Admin__Developers__WebhookEndpoints},
											{b: $elm$core$Maybe$Nothing, ahO: $elm$core$Maybe$Nothing, ahP: 'nav-item-developers-sandboxes', Bq: 'Sandboxes', e: $author$project$Spa$Generated$Route$Admin__Developers__Sandboxes}
										]),
										A2($author$project$Layouts$Admin$appTabVisible, isHintAdmin, managedPartner) ? _List_fromArray(
										[
											{b: $elm$core$Maybe$Nothing, ahO: $elm$core$Maybe$Nothing, ahP: 'nav-item-developers-app', Bq: 'Custom App', e: $author$project$Spa$Generated$Route$Admin__Developers__App}
										]) : _List_Nil,
										isHintAdmin ? _List_fromArray(
										[
											{
											b: $elm$core$Maybe$Nothing,
											ahO: $elm$core$Maybe$Just(
												$author$project$Ui$Icon$hintHeart(
													_List_fromArray(
														[$author$project$Ui$Icon$spacedRight]))),
											ahP: 'nav-item-developers-hinter',
											Bq: 'Hinter',
											e: $author$project$Spa$Generated$Route$Admin__Developers__Hinter
										}
										]) : _List_Nil
									])) : _List_Nil),
						b: $elm$core$Maybe$Nothing,
						ac9: 'Developers'
					},
						{
						L: _List_fromArray(
							[
								{b: $elm$core$Maybe$Nothing, ahO: $elm$core$Maybe$Nothing, ahP: 'nav-item-data-export', Bq: 'Exports', e: $author$project$Spa$Generated$Route$Admin__DataExport__Top},
								{b: $elm$core$Maybe$Nothing, ahO: $elm$core$Maybe$Nothing, ahP: 'nav-item-data-export-settings', Bq: 'Settings', e: $author$project$Spa$Generated$Route$Admin__DataExportSettings__Top}
							]),
						b: $elm$core$Maybe$Nothing,
						ac9: 'Data Exporter'
					}
					]),
					(isHintAdmin && ($author$project$Api$Provider$Practice$One$accountType(practice) === 1)) ? _List_fromArray(
					[
						{
						L: _List_fromArray(
							[
								{
								b: $elm$core$Maybe$Nothing,
								ahO: $elm$core$Maybe$Just(
									$author$project$Ui$Icon$hintHeart(
										_List_fromArray(
											[$author$project$Ui$Icon$spacedRight]))),
								ahP: 'nav-item-affiliate-plans',
								Bq: 'Plans',
								e: $author$project$Spa$Generated$Route$Admin__Plans__Top
							}
							]),
						b: $elm$core$Maybe$Nothing,
						ac9: ''
					}
					]) : _List_Nil
				])) : _List_Nil;
	});
var $author$project$Ui$Nav$Empty = {$: 2};
var $author$project$Ui$Nav$emptyItem = $author$project$Ui$Nav$Empty;
var $author$project$Ui$Nav$Route = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Nav$route = $author$project$Ui$Nav$Route;
var $author$project$Layouts$Admin$viewActiveChildren = F3(
	function (currentRoute, practice, _v0) {
		var node = _v0;
		return A2($author$project$Layouts$Admin$nodeVisible, practice, node) ? A2(
			$author$project$Ui$Nav$item,
			_List_fromArray(
				[
					$author$project$Ui$Nav$route(node.e),
					$author$project$Ui$Nav$activeItem(
					A3($author$project$Layouts$Admin$nodeActive, currentRoute, practice, node))
				]),
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$withDefault,
					$elm$html$Html$text(''),
					node.ahO),
					$elm$html$Html$text(node.Bq)
				])) : $author$project$Ui$Nav$emptyItem;
	});
var $author$project$Layouts$Admin$viewNav = F6(
	function (currentRoute, session, practice, hinterViewOff, isHintAdmin, model) {
		var _v0 = A3(
			$author$project$Layouts$Admin$getActiveStructure,
			currentRoute,
			practice,
			A5($author$project$Layouts$Admin$structure, session, practice, hinterViewOff, isHintAdmin, model.s6));
		if (!_v0.$) {
			var active = _v0.a;
			return A3(
				$author$project$Ui$Nav$view,
				_List_Nil,
				A2(
					$elm$core$List$map,
					A2($author$project$Layouts$Admin$viewActiveChildren, currentRoute, practice),
					active.L),
				model.kp);
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Layouts$Admin$view = F4(
	function (toMsg, shared, model, body) {
		var session = shared.aa4;
		var practice = shared.ZV;
		var hinterViewOff = shared.ahK;
		var url = shared.adY;
		var _v0 = _Utils_Tuple2(session, practice);
		if (((_v0.a.$ === 3) && (_v0.b.$ === 3)) && (!_v0.b.a.$)) {
			var _v1 = _v0.a;
			var session_ = _v1.a;
			var _v2 = _v0.b;
			var practice_ = _v2.a.a;
			var isHintAdmin = $author$project$Shared$isHintAdmin(shared);
			var currentRoute = $author$project$Utils$Route$fromUrl(url);
			var activeStructure = A3(
				$author$project$Layouts$Admin$getActiveStructure,
				currentRoute,
				practice_,
				A5($author$project$Layouts$Admin$structure, session_, practice_, hinterViewOff, isHintAdmin, model.s6));
			return _Utils_ap(
				function () {
					if (!activeStructure.$) {
						var node = activeStructure.a;
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('layout-header')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mb2]),
										_List_fromArray(
											[
												$author$project$Ui$Typography$heading(
												_List_fromArray(
													[
														$elm$html$Html$text(node.ac9)
													]))
											])),
										A2(
										$elm$html$Html$map,
										toMsg,
										A6($author$project$Layouts$Admin$viewNav, currentRoute, session_, practice_, hinterViewOff, isHintAdmin, model))
									]))
							]);
					} else {
						return _List_Nil;
					}
				}(),
				body);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Ui$Nav$LinkOptions = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Nav$linkOptions = $author$project$Ui$Nav$LinkOptions;
var $author$project$Layouts$Affiliates$viewNav = F2(
	function (currentRoute, nav) {
		return A3(
			$author$project$Ui$Nav$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route($author$project$Spa$Generated$Route$AffiliateBills__Top),
							$author$project$Ui$Nav$linkOptions(
							_List_fromArray(
								[
									$author$project$Ui$Link$routeParams(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'start', 'default'),
											A2($elm$url$Url$Builder$string, 'end', 'default')
										]))
								])),
							$author$project$Ui$Nav$activeItem(
							_Utils_eq(currentRoute, $author$project$Spa$Generated$Route$AffiliateBills__Top))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Affiliate Bills')
						])),
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route($author$project$Spa$Generated$Route$Affiliates__Top),
							$author$project$Ui$Nav$activeItem(
							_Utils_eq(currentRoute, $author$project$Spa$Generated$Route$Affiliates__Top))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Manage Affiliates')
						]))
				]),
			nav);
	});
var $author$project$Layouts$Affiliates$view = F4(
	function (toMsg, _v0, _v1, body) {
		var url = _v0.adY;
		var nav = _v1.kp;
		var currentRoute = $author$project$Utils$Route$fromUrl(url);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('layout-header')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mb2]),
						_List_fromArray(
							[
								$author$project$Ui$Typography$heading(
								_List_fromArray(
									[
										$elm$html$Html$text('Networks')
									]))
							])),
						A2(
						$elm$html$Html$map,
						toMsg,
						A2($author$project$Layouts$Affiliates$viewNav, currentRoute, nav))
					])),
				A2($elm$html$Html$div, _List_Nil, body)
			]);
	});
var $author$project$Api$Provider$Affiliate$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Affiliate$Shared$name(shared);
};
var $author$project$Layouts$Affiliates$Affiliate$affiliateName = function (affiliate) {
	if (affiliate.$ === 3) {
		var affiliate_ = affiliate.a;
		return $elm$html$Html$text(
			A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Api$Provider$Affiliate$One$name(affiliate_)));
	} else {
		return $author$project$Ui$Spinner$view(
			_List_fromArray(
				[$author$project$Ui$Spinner$extraSmall]));
	}
};
var $author$project$Layouts$Affiliates$Affiliate$viewBreadcrumbs = function (affiliate) {
	return A2(
		$elm$html$Html$map,
		$elm$core$Basics$never,
		A2(
			$author$project$Ui$Breadcrumb$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Breadcrumb$item,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Affiliates__Top,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Affiliates')
								]))
						])),
					A2(
					$author$project$Ui$Breadcrumb$item,
					_List_fromArray(
						[
							$author$project$Ui$Breadcrumb$active(true)
						]),
					_List_fromArray(
						[
							$author$project$Layouts$Affiliates$Affiliate$affiliateName(affiliate)
						]))
				])));
};
var $author$project$Layouts$Affiliates$Affiliate$viewHeader = function (affiliate) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
		_List_fromArray(
			[
				$author$project$Ui$Typography$heading(
				_List_fromArray(
					[
						$author$project$Layouts$Affiliates$Affiliate$affiliateName(affiliate)
					])),
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					function (status) {
						return A2(
							$author$project$Ui$Badge$fromString,
							_List_fromArray(
								[$author$project$Ui$Badge$inline]),
							status);
					},
					A2(
						$elm$core$Maybe$map,
						$author$project$Api$Provider$Affiliate$One$status,
						$author$project$Api$Data$toMaybe(affiliate))))
			]));
};
var $author$project$Ui$HinterOnly$navItem = F2(
	function (options, content) {
		return A2(
			$author$project$Ui$Nav$item,
			options,
			A2(
				$elm$core$List$cons,
				$author$project$Ui$HinterOnly$icon(
					_List_fromArray(
						[$author$project$Ui$Icon$spacedRight])),
				content));
	});
var $author$project$Layouts$Affiliates$Affiliate$viewNav = F3(
	function (currentRoute, _v0, shared) {
		var affiliateId = _v0.rd;
		var nav = _v0.kp;
		var usersRoute = $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Users(
			{rd: affiliateId});
		var syncByAffiliation = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Network$Shared$syncByAffiliation,
				A2(
					$elm$core$Maybe$andThen,
					$author$project$Api$Practice$network,
					$author$project$Api$Data$toMaybe(shared.ZV))));
		var settingsRoute = $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Settings(
			{rd: affiliateId});
		var patientsRoute = $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Patients(
			{rd: affiliateId});
		var linkedProvidersRoute = $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__LinkedProviders(
			{rd: affiliateId});
		var isHintAdmin = $author$project$Shared$isHintAdmin(shared);
		var billsRoute = $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Top(
			{rd: affiliateId});
		return A3(
			$author$project$Ui$Nav$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route(billsRoute),
							$author$project$Ui$Nav$activeItem(
							A2(
								$elm$core$String$startsWith,
								$author$project$Spa$Generated$Route$toString(billsRoute),
								$author$project$Spa$Generated$Route$toString(currentRoute)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Bills')
						])),
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route(patientsRoute),
							$author$project$Ui$Nav$activeItem(
							A2(
								$elm$core$String$startsWith,
								$author$project$Spa$Generated$Route$toString(patientsRoute),
								$author$project$Spa$Generated$Route$toString(currentRoute)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Patients')
						])),
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route(linkedProvidersRoute),
							$author$project$Ui$Nav$activeItem(
							A2(
								$elm$core$String$startsWith,
								$author$project$Spa$Generated$Route$toString(linkedProvidersRoute),
								$author$project$Spa$Generated$Route$toString(currentRoute)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							syncByAffiliation ? 'Linked Providers & Locations' : 'Linked Providers')
						])),
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route(settingsRoute),
							$author$project$Ui$Nav$activeItem(
							A2(
								$elm$core$String$startsWith,
								$author$project$Spa$Generated$Route$toString(settingsRoute),
								$author$project$Spa$Generated$Route$toString(currentRoute)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Terms & Conditions')
						])),
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route(usersRoute),
							$author$project$Ui$Nav$activeItem(
							A2(
								$elm$core$String$startsWith,
								$author$project$Spa$Generated$Route$toString(usersRoute),
								$author$project$Spa$Generated$Route$toString(currentRoute)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Users')
						])),
					function () {
					if (isHintAdmin) {
						var affiliateActionsRoute = $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__AffiliateActions(
							{rd: affiliateId});
						return A2(
							$author$project$Ui$HinterOnly$navItem,
							_List_fromArray(
								[
									$author$project$Ui$Nav$route(affiliateActionsRoute),
									$author$project$Ui$Nav$activeItem(
									_Utils_eq(currentRoute, affiliateActionsRoute))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Affiliate Actions')
								]));
					} else {
						return $author$project$Ui$Nav$emptyItem;
					}
				}()
				]),
			nav);
	});
var $author$project$Layouts$Affiliates$Affiliate$view = F4(
	function (toMsg, shared, model, body) {
		var currentRoute = $author$project$Utils$Route$fromUrl(shared.adY);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('layout-header')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						toMsg,
						$author$project$Layouts$Affiliates$Affiliate$viewBreadcrumbs(model.Gn)),
						$author$project$Layouts$Affiliates$Affiliate$viewHeader(model.Gn),
						A2(
						$elm$html$Html$map,
						toMsg,
						A3($author$project$Layouts$Affiliates$Affiliate$viewNav, currentRoute, model, shared))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('nav-panel nav-panel-header-white')
					]),
				body)
			]);
	});
var $author$project$Layouts$Application$view = function (body) {
	return body;
};
var $author$project$Layouts$Blank$view = function (body) {
	return body;
};
var $author$project$Layouts$Commissions$viewNav = F2(
	function (currentRoute, nav) {
		return A3(
			$author$project$Ui$Nav$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route($author$project$Spa$Generated$Route$Commissions__BrokerAccounts__Top),
							$author$project$Ui$Nav$activeItem(
							_Utils_eq(currentRoute, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__Top) || _Utils_eq(currentRoute, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__New))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Broker Accounts')
						])),
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route($author$project$Spa$Generated$Route$Commissions__Statements),
							$author$project$Ui$Nav$linkOptions(
							_List_fromArray(
								[
									$author$project$Ui$Link$routeParams(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'start', 'default'),
											A2($elm$url$Url$Builder$string, 'end', 'default')
										]))
								])),
							$author$project$Ui$Nav$activeItem(
							_Utils_eq(currentRoute, $author$project$Spa$Generated$Route$Commissions__Statements))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Statements')
						])),
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route($author$project$Spa$Generated$Route$Commissions__StatementLines__Top),
							$author$project$Ui$Nav$linkOptions(
							_List_fromArray(
								[
									$author$project$Ui$Link$routeParams(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'start', 'default'),
											A2($elm$url$Url$Builder$string, 'end', 'default')
										]))
								])),
							$author$project$Ui$Nav$activeItem(
							_Utils_eq(currentRoute, $author$project$Spa$Generated$Route$Commissions__StatementLines__Top) || _Utils_eq(currentRoute, $author$project$Spa$Generated$Route$Commissions__StatementLines__Summary))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Statement Lines')
						]))
				]),
			nav);
	});
var $author$project$Layouts$Commissions$view = F4(
	function (toMsg, _v0, _v1, body) {
		var url = _v0.adY;
		var nav = _v1.kp;
		var currentRoute = $author$project$Utils$Route$fromUrl(url);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('layout-header')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mb2]),
						_List_fromArray(
							[
								$author$project$Ui$Typography$heading(
								_List_fromArray(
									[
										$elm$html$Html$text('Commissions')
									]))
							])),
						A2(
						$elm$html$Html$map,
						toMsg,
						A2($author$project$Layouts$Commissions$viewNav, currentRoute, nav))
					])),
				A2($elm$html$Html$div, _List_Nil, body)
			]);
	});
var $author$project$Layouts$Commissions$BrokerAccount$brokerAccountName = function (brokerAccount) {
	if (brokerAccount.$ === 3) {
		var brokerAccount_ = brokerAccount.a;
		return $elm$html$Html$text(
			$author$project$Api$Provider$BrokerAccount$One$name(brokerAccount_));
	} else {
		return $author$project$Ui$Skeleton$text(
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$spanFromText('Some Broker')
				]));
	}
};
var $author$project$Layouts$Commissions$BrokerAccount$viewBreadcrumbs = function (brokerAccount) {
	return A2(
		$elm$html$Html$map,
		$elm$core$Basics$never,
		A2(
			$author$project$Ui$Breadcrumb$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Breadcrumb$item,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__Top,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('All Broker Accounts')
								]))
						])),
					A2(
					$author$project$Ui$Breadcrumb$item,
					_List_fromArray(
						[
							$author$project$Ui$Breadcrumb$active(true)
						]),
					_List_fromArray(
						[
							$author$project$Layouts$Commissions$BrokerAccount$brokerAccountName(brokerAccount)
						]))
				])));
};
var $author$project$Layouts$Commissions$BrokerAccount$viewHeader = function (brokerAccount) {
	return $author$project$Ui$Typography$heading(
		_List_fromArray(
			[
				$author$project$Layouts$Commissions$BrokerAccount$brokerAccountName(brokerAccount)
			]));
};
var $author$project$Layouts$Commissions$BrokerAccount$viewNav = F4(
	function (currentRoute, brokerAccountId, brokerAccount, nav) {
		var statementsRoute = $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__Top(
			{cm: brokerAccountId});
		var multipleBrokers = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$BrokerAccount$One$multipleBrokers,
				$author$project$Api$Data$toMaybe(brokerAccount)));
		var endedDealsRoute = $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__EndedDeals(
			{cm: brokerAccountId});
		var dealsRoute = $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Deals(
			{cm: brokerAccountId});
		var brokerAccountRoute = $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Top(
			{cm: brokerAccountId});
		return A3(
			$author$project$Ui$Nav$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route(dealsRoute),
							$author$project$Ui$Nav$activeItem(
							A2(
								$elm$core$List$member,
								currentRoute,
								_List_fromArray(
									[dealsRoute, endedDealsRoute])))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Deals')
						])),
					function () {
					if (multipleBrokers) {
						var brokersRoute = $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top(
							{cm: brokerAccountId});
						return A2(
							$author$project$Ui$Nav$item,
							_List_fromArray(
								[
									$author$project$Ui$Nav$route(brokersRoute),
									$author$project$Ui$Nav$activeItem(
									A2(
										$elm$core$String$startsWith,
										$author$project$Spa$Generated$Route$toString(brokersRoute),
										$author$project$Spa$Generated$Route$toString(currentRoute)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Brokers')
								]));
					} else {
						return $author$project$Ui$Nav$emptyItem;
					}
				}(),
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route(statementsRoute),
							$author$project$Ui$Nav$activeItem(
							A2(
								$elm$core$String$startsWith,
								$author$project$Spa$Generated$Route$toString(statementsRoute),
								$author$project$Spa$Generated$Route$toString(currentRoute)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Statements')
						])),
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route(brokerAccountRoute),
							$author$project$Ui$Nav$activeItem(
							_Utils_eq(currentRoute, brokerAccountRoute))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Account Setup')
						]))
				]),
			nav);
	});
var $author$project$Layouts$Commissions$BrokerAccount$view = F4(
	function (toMsg, _v0, model, body) {
		var url = _v0.adY;
		var currentRoute = $author$project$Utils$Route$fromUrl(url);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('layout-header')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						toMsg,
						$author$project$Layouts$Commissions$BrokerAccount$viewBreadcrumbs(model.xG)),
						$author$project$Layouts$Commissions$BrokerAccount$viewHeader(model.xG),
						A2(
						$elm$html$Html$map,
						toMsg,
						A4($author$project$Layouts$Commissions$BrokerAccount$viewNav, currentRoute, model.cm, model.xG, model.kp))
					])),
				A2($elm$html$Html$div, _List_Nil, body)
			]);
	});
var $author$project$Layouts$Company$companyName = function (company) {
	if (company.$ === 3) {
		var company_ = company.a;
		return $elm$html$Html$text(
			$author$project$Api$Company$name(company_));
	} else {
		return $author$project$Ui$Skeleton$text(
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$spanFromText('Company Name')
				]));
	}
};
var $author$project$Api$Provider$Company$One$flaggedNotesCount = function (_v0) {
	var record = _v0.b;
	return record.Sz;
};
var $author$project$Api$Company$flaggedNotesCount = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$flaggedNotesCount(company_);
	} else {
		return 0;
	}
};
var $author$project$Ui$Badge$SizeMd = {$: 1};
var $author$project$Ui$Badge$md = $author$project$Ui$Badge$SizeMd;
var $author$project$Api$Employer$Company$Shared$status = function (_v0) {
	var record = _v0;
	return record.alH;
};
var $author$project$Api$Employer$Company$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Company$Shared$status(shared);
};
var $author$project$Api$Company$status = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$status(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$status(company_);
	}
};
var $author$project$Layouts$Company$viewHeader = F3(
	function (organizationIsCompany, practice, company) {
		return organizationIsCompany ? _List_Nil : _List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsStart]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$elm$core$Basics$never,
						A2(
							$author$project$Ui$Breadcrumb$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Breadcrumb$item,
									_List_Nil,
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$Companies__Top,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$core$Maybe$withDefault,
													$author$project$Ui$Skeleton$text(
														_List_fromArray(
															[
																$author$project$Ui$Skeleton$spanFromText('Employers')
															])),
													$author$project$Api$Data$toMaybe(
														A2(
															$author$project$Api$Data$map,
															function (pra) {
																return $elm$html$Html$text(
																	A2($author$project$Api$Practice$sponsorize, pra, 'Employers'));
															},
															practice)))
												]))
										])),
									A2(
									$author$project$Ui$Breadcrumb$item,
									_List_fromArray(
										[
											$author$project$Ui$Breadcrumb$active(true)
										]),
									_List_fromArray(
										[
											$author$project$Layouts$Company$companyName(company)
										]))
								]))),
						A2(
						$elm$html$Html$map,
						$elm$core$Basics$never,
						A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Companies__Top,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Ui$Icon$cross(
											_List_fromArray(
												[$author$project$Ui$Icon$sm]))
										]))
								])))
					])),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mb2]),
				_List_fromArray(
					[
						$author$project$Ui$Typography$heading(
						_List_fromArray(
							[
								$author$project$Layouts$Company$companyName(company)
							])),
						A2(
						$elm$core$Maybe$withDefault,
						$author$project$Utils$Html$empty,
						A2(
							$elm$core$Maybe$map,
							function (status) {
								return A2(
									$author$project$Ui$Badge$fromString,
									_List_fromArray(
										[$author$project$Ui$Badge$md, $author$project$Ui$Badge$inline]),
									status);
							},
							A2(
								$elm$core$Maybe$map,
								$author$project$Api$Company$status,
								$author$project$Api$Data$toMaybe(company)))),
						$author$project$Utils$Html$noBreakSpace,
						A2(
						$elm$core$Maybe$withDefault,
						$author$project$Utils$Html$empty,
						A2(
							$elm$core$Maybe$andThen,
							function (company_) {
								return ($author$project$Api$Company$flaggedNotesCount(company_) > 0) ? $elm$core$Maybe$Just(
									A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Companies__CompanyId_String__Notes(
											{
												fZ: $author$project$Api$Company$id(company_)
											}),
										_List_fromArray(
											[
												$author$project$Ui$Link$routeParams(
												_List_fromArray(
													[
														A2($elm$url$Url$Builder$string, 'flagged', 'flagged')
													])),
												$author$project$Ui$Link$icon($author$project$Ui$Icon$flag)
											]),
										_List_Nil)) : $elm$core$Maybe$Nothing;
							},
							$author$project$Api$Data$toMaybe(company)))
					]))
			]);
	});
var $author$project$Api$Provider$Company$One$invitationPending = function (_v0) {
	var record = _v0.b;
	return record.Ui;
};
var $author$project$Api$Company$invitationPending = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$invitationPending(company_);
	} else {
		return false;
	}
};
var $author$project$Layouts$Company$viewInvitationPendingWarning = function (company) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Utils$Html$empty,
		A2(
			$elm$core$Maybe$andThen,
			function (company_) {
				return $author$project$Api$Company$invitationPending(company_) ? $elm$core$Maybe$Just(
					A2(
						$author$project$Ui$Alert$warning,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('No administrators have accepted their invitation. '),
								$elm$html$Html$text('We cannot send any invoices or emails to administrators who have not accepted their invitation. '),
								A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Companies__CompanyId_String__Top(
									{
										fZ: $author$project$Api$Company$id(company_)
									}),
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Click here')
									])),
								$elm$html$Html$text(' to review invitations.')
							]))) : $elm$core$Maybe$Nothing;
			},
			$author$project$Api$Data$toMaybe(company)));
};
var $author$project$Api$Feature$CustomizableNotificationsByEmployer = 12;
var $author$project$Layouts$Company$viewNav = F5(
	function (currentRoute, isHintAdmin, practice, company, nav) {
		var gateAvailable = function (code) {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function (practice_) {
						return A2($author$project$Utils$FeatureGate$gateAvailable, code, practice_);
					},
					$author$project$Api$Data$toMaybe(practice)));
		};
		var customizableNotifificationsByEmployerEnabled = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (practice_) {
					return A2($author$project$Api$Practice$featureEnabled, 12, practice_);
				},
				$author$project$Api$Data$toMaybe(practice)));
		var companyType = $author$project$Api$Company$companyType(company);
		var isChildCompany = companyType === 1;
		var isNetwork = !companyType;
		var companyId = $author$project$Api$Company$id(company);
		var employeesRoute = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top(
			{fZ: companyId});
		var invoicesRoute = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Top(
			{fZ: companyId});
		var notesRoute = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Notes(
			{fZ: companyId});
		return A3(
			$author$project$Ui$Nav$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route(employeesRoute),
							$author$project$Ui$Nav$activeItem(
							A2(
								$elm$core$String$startsWith,
								$author$project$Spa$Generated$Route$toString(employeesRoute),
								$author$project$Spa$Generated$Route$toString(currentRoute)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$author$project$Formatters$String$affiliateMember,
								'Employees',
								$elm$core$Maybe$Just(companyType)))
						])),
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route(invoicesRoute),
							$author$project$Ui$Nav$activeItem(
							A2(
								$elm$core$String$startsWith,
								$author$project$Spa$Generated$Route$toString(invoicesRoute),
								$author$project$Spa$Generated$Route$toString(currentRoute)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Invoices')
						])),
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route(notesRoute),
							$author$project$Ui$Nav$activeItem(
							A2(
								$elm$core$String$startsWith,
								$author$project$Spa$Generated$Route$toString(notesRoute),
								$author$project$Spa$Generated$Route$toString(currentRoute)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Notes')
						])),
					function () {
					if (!isNetwork) {
						var endedCommissionsRoute = $author$project$Spa$Generated$Route$Companies__CompanyId_String__EndedCommissions(
							{fZ: companyId});
						var companyRoute = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Top(
							{fZ: companyId});
						return A2(
							$author$project$Ui$Nav$item,
							_List_fromArray(
								[
									$author$project$Ui$Nav$route(companyRoute),
									$author$project$Ui$Nav$activeItem(
									A2(
										$elm$core$List$member,
										currentRoute,
										_List_fromArray(
											[companyRoute, endedCommissionsRoute])))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Account & Pricing')
								]));
					} else {
						return $author$project$Ui$Nav$emptyItem;
					}
				}(),
					function () {
					if (!isNetwork) {
						var signupRoute = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Signup(
							{fZ: companyId});
						return A2(
							$author$project$Ui$Nav$item,
							_List_fromArray(
								[
									$author$project$Ui$Nav$route(signupRoute),
									$author$project$Ui$Nav$activeItem(
									A2(
										$elm$core$String$startsWith,
										$author$project$Spa$Generated$Route$toString(signupRoute),
										$author$project$Spa$Generated$Route$toString(currentRoute)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Online Signup')
								]));
					} else {
						return $author$project$Ui$Nav$emptyItem;
					}
				}(),
					function () {
					if (!isNetwork) {
						var paymentSourcesRoute = $author$project$Spa$Generated$Route$Companies__CompanyId_String__PaymentSources(
							{fZ: companyId});
						return A2(
							$author$project$Ui$Nav$item,
							_List_fromArray(
								[
									$author$project$Ui$Nav$route(paymentSourcesRoute),
									$author$project$Ui$Nav$activeItem(
									A2(
										$elm$core$String$startsWith,
										$author$project$Spa$Generated$Route$toString(paymentSourcesRoute),
										$author$project$Spa$Generated$Route$toString(currentRoute)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Payment Options')
								]));
					} else {
						return $author$project$Ui$Nav$emptyItem;
					}
				}(),
					function () {
					if (!isNetwork) {
						var invoiceSettingsRoute = $author$project$Spa$Generated$Route$Companies__CompanyId_String__InvoiceSettings(
							{fZ: companyId});
						return A2(
							$author$project$Ui$Nav$item,
							_List_fromArray(
								[
									$author$project$Ui$Nav$route(invoiceSettingsRoute),
									$author$project$Ui$Nav$activeItem(
									A2(
										$elm$core$String$startsWith,
										$author$project$Spa$Generated$Route$toString(invoiceSettingsRoute),
										$author$project$Spa$Generated$Route$toString(currentRoute)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Invoice Settings')
								]));
					} else {
						return $author$project$Ui$Nav$emptyItem;
					}
				}(),
					function () {
					if (customizableNotifificationsByEmployerEnabled) {
						var notificationsRoute = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Notifications(
							{fZ: companyId});
						return A2(
							$author$project$Ui$Nav$item,
							_List_fromArray(
								[
									$author$project$Ui$Nav$route(notificationsRoute),
									$author$project$Ui$Nav$activeItem(
									A2(
										$elm$core$String$startsWith,
										$author$project$Spa$Generated$Route$toString(notificationsRoute),
										$author$project$Spa$Generated$Route$toString(currentRoute)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Notifications')
								]));
					} else {
						return $author$project$Ui$Nav$emptyItem;
					}
				}(),
					function () {
					if ((!isNetwork) && (gateAvailable(8) || isHintAdmin)) {
						var uploadsRoute = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__Top(
							{fZ: companyId});
						return A2(
							$author$project$Ui$Nav$item,
							_List_fromArray(
								[
									$author$project$Ui$Nav$route(uploadsRoute),
									$author$project$Ui$Nav$activeItem(
									A2(
										$elm$core$String$startsWith,
										$author$project$Spa$Generated$Route$toString(uploadsRoute),
										$author$project$Spa$Generated$Route$toString(currentRoute)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Employee Uploads')
								]));
					} else {
						return $author$project$Ui$Nav$emptyItem;
					}
				}(),
					function () {
					if ((!isNetwork) && (isHintAdmin && (!isChildCompany))) {
						var easRoute = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Eas(
							{fZ: companyId});
						return A2(
							$author$project$Ui$HinterOnly$navItem,
							_List_fromArray(
								[
									$author$project$Ui$Nav$route(easRoute),
									$author$project$Ui$Nav$activeItem(
									A2(
										$elm$core$String$startsWith,
										$author$project$Spa$Generated$Route$toString(easRoute),
										$author$project$Spa$Generated$Route$toString(currentRoute)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Upload Settings')
								]));
					} else {
						return $author$project$Ui$Nav$emptyItem;
					}
				}(),
					function () {
					if (isNetwork) {
						var affiliatesPricingRoute = $author$project$Spa$Generated$Route$Companies__CompanyId_String__AffiliatesPricing(
							{fZ: companyId});
						return A2(
							$author$project$Ui$Nav$item,
							_List_fromArray(
								[
									$author$project$Ui$Nav$route(affiliatesPricingRoute),
									$author$project$Ui$Nav$activeItem(
									A2(
										$elm$core$String$startsWith,
										$author$project$Spa$Generated$Route$toString(affiliatesPricingRoute),
										$author$project$Spa$Generated$Route$toString(currentRoute)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Pricing')
								]));
					} else {
						return $author$project$Ui$Nav$emptyItem;
					}
				}()
				]),
			nav);
	});
var $author$project$Layouts$Company$view = F4(
	function (toMsg, shared, _v0, body) {
		var url = shared.adY;
		var organizationIsCompany = shared.ajE;
		var practice = shared.ZV;
		var company = shared.afQ;
		var nav = _v0.kp;
		var headerClass = (!organizationIsCompany) ? 'layout-header' : '';
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(headerClass)
					]),
				_Utils_ap(
					A3($author$project$Layouts$Company$viewHeader, organizationIsCompany, practice, company),
					_List_fromArray(
						[
							$author$project$Layouts$Company$viewInvitationPendingWarning(company),
							function () {
							var _v1 = _Utils_Tuple2(organizationIsCompany, company);
							if ((!_v1.a) && (_v1.b.$ === 3)) {
								var _v2 = _v1.b;
								var company_ = _v2.a;
								var isHintAdmin = $author$project$Shared$isHintAdmin(shared);
								var currentRoute = $author$project$Utils$Route$fromUrl(url);
								return A2(
									$elm$html$Html$map,
									toMsg,
									A5($author$project$Layouts$Company$viewNav, currentRoute, isHintAdmin, practice, company_, nav));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						]))),
				A2($elm$html$Html$div, _List_Nil, body)
			]);
	});
var $author$project$Api$Provider$Integration$One$product = function (_v0) {
	var record = _v0.c;
	return record._s;
};
var $author$project$Api$Common$PartnerApp$Anchor$settingsLabel = function (_v0) {
	var record = _v0;
	var _v1 = record.amg;
	if (_v1 === 3) {
		return record.aa5;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Layouts$Marketplace$Manage$appNavItems = F3(
	function (currentRoute, integration, slug) {
		var _v0 = _Utils_Tuple2(
			$author$project$Api$Provider$Integration$One$status(integration),
			$author$project$Api$Common$Marketplace$Product$Shared$type_(
				$author$project$Api$Provider$Integration$One$product(integration)));
		if ((_v0.a === 'active') && (!_v0.b)) {
			var _v1 = _v0.b;
			var usersRoute = $author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Users(
				{abG: slug});
			var settingsAnchor = A2(
				$elm$core$Maybe$andThen,
				$author$project$Api$Common$PartnerApp$Shared$settingsAnchor,
				$author$project$Api$Provider$Integration$One$partnerApp(integration));
			var settingsNavItem = function () {
				if (!settingsAnchor.$) {
					var anchor = settingsAnchor.a;
					var settingsRoute = $author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Settings(
						{abG: slug});
					return _List_fromArray(
						[
							A2(
							$author$project$Ui$Nav$item,
							_List_fromArray(
								[
									$author$project$Ui$Nav$route(settingsRoute),
									$author$project$Ui$Nav$activeItem(
									_Utils_eq(currentRoute, settingsRoute))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'Settings',
										$author$project$Api$Common$PartnerApp$Anchor$settingsLabel(anchor)))
								]))
						]);
				} else {
					return _List_Nil;
				}
			}();
			return A2(
				$elm$core$List$cons,
				A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route(usersRoute),
							$author$project$Ui$Nav$activeItem(
							_Utils_eq(currentRoute, usersRoute))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Manage Users')
						])),
				settingsNavItem);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Layouts$Marketplace$Manage$viewNav = F2(
	function (currentRoute, _v0) {
		var nav = _v0.kp;
		var slug = _v0.abG;
		var integration = _v0.T8;
		var navItems = function () {
			var _v1 = $author$project$Api$Data$toMaybe(integration);
			if (!_v1.$) {
				var integration_ = _v1.a;
				var quickbooksSettingsNavItem = (slug === 'quickbooks') ? _List_fromArray(
					[
						A2(
						$author$project$Ui$Nav$item,
						_List_fromArray(
							[
								$author$project$Ui$Nav$route($author$project$Spa$Generated$Route$Marketplace__Quickbooks__Manage__Settings),
								$author$project$Ui$Nav$activeItem(
								_Utils_eq(currentRoute, $author$project$Spa$Generated$Route$Marketplace__Quickbooks__Manage__Settings))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Settings')
							]))
					]) : _List_Nil;
				var onboardingNavItem = ((slug !== 'quickbooks') && ((slug !== 'elation') && ((slug !== 'athenahealth') && A2(
					$elm$core$List$member,
					$author$project$Api$Provider$Integration$One$status(integration_),
					_List_fromArray(
						['pending', 'inactive']))))) ? _List_fromArray(
					[
						A2(
						$author$project$Ui$Nav$item,
						_List_fromArray(
							[
								$author$project$Ui$Nav$route(
								$author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Onboarding(
									{abG: slug})),
								$author$project$Ui$Nav$activeItem(
								_Utils_eq(
									currentRoute,
									$author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Onboarding(
										{abG: slug})))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Onboarding')
							]))
					]) : _List_Nil;
				var elationSettingsNavItem = (slug === 'elation') ? _List_fromArray(
					[
						A2(
						$author$project$Ui$Nav$item,
						_List_fromArray(
							[
								$author$project$Ui$Nav$route($author$project$Spa$Generated$Route$Marketplace__Elation__Manage__Settings),
								$author$project$Ui$Nav$activeItem(
								_Utils_eq(currentRoute, $author$project$Spa$Generated$Route$Marketplace__Elation__Manage__Settings))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Settings')
							]))
					]) : _List_Nil;
				var bookkeepingSettingsNavItem = ((slug === 'bookkeeping') && ($author$project$Api$Provider$Integration$One$status(integration_) === 'active')) ? _List_fromArray(
					[
						A2(
						$author$project$Ui$Nav$item,
						_List_fromArray(
							[
								$author$project$Ui$Nav$route($author$project$Spa$Generated$Route$Marketplace__Bookkeeping__Manage__Settings),
								$author$project$Ui$Nav$activeItem(
								_Utils_eq(currentRoute, $author$project$Spa$Generated$Route$Marketplace__Bookkeeping__Manage__Settings))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Settings')
							]))
					]) : _List_Nil;
				var athenaSettingsNavItem = (slug === 'athenahealth') ? _List_fromArray(
					[
						A2(
						$author$project$Ui$Nav$item,
						_List_fromArray(
							[
								$author$project$Ui$Nav$route($author$project$Spa$Generated$Route$Marketplace__Athenahealth__Manage__Settings),
								$author$project$Ui$Nav$activeItem(
								_Utils_eq(currentRoute, $author$project$Spa$Generated$Route$Marketplace__Athenahealth__Manage__Settings))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Settings')
							]))
					]) : _List_Nil;
				return $elm$core$List$concat(
					_List_fromArray(
						[
							onboardingNavItem,
							bookkeepingSettingsNavItem,
							quickbooksSettingsNavItem,
							elationSettingsNavItem,
							athenaSettingsNavItem,
							A3($author$project$Layouts$Marketplace$Manage$appNavItems, currentRoute, integration_, slug)
						]));
			} else {
				return _List_Nil;
			}
		}();
		return A3($author$project$Ui$Nav$view, _List_Nil, navItems, nav);
	});
var $author$project$Layouts$Marketplace$Manage$view = F4(
	function (toMsg, shared, model, body) {
		var currentRoute = $author$project$Utils$Route$fromUrl(shared.adY);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('layout-header')
					]),
				_List_fromArray(
					[
						function () {
						var _v0 = model.T8;
						if (_v0.$ === 3) {
							var integration = _v0.a;
							var product = $author$project$Api$Provider$Integration$One$product(integration);
							var productIcon = $author$project$Api$Common$Marketplace$Product$Shared$iconUrl(product);
							var productName = $author$project$Api$Common$Marketplace$Product$Shared$name(product);
							return A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap4, $author$project$Ui$Element$mb4, $author$project$Ui$Element$mt2]),
										_List_fromArray(
											[
												function () {
												if (!productIcon.$) {
													var iconUrl = productIcon.a;
													return A3(
														$author$project$Ui$Image$fromSrc,
														{LD: productName},
														iconUrl,
														_List_fromArray(
															[
																$author$project$Ui$Image$height(32)
															]));
												} else {
													return $elm$html$Html$text('');
												}
											}(),
												$author$project$Ui$Typography$heading(
												_List_fromArray(
													[
														$elm$html$Html$text(productName + ' Settings')
													]))
											])),
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$mb2]),
										_List_fromArray(
											[
												function () {
												var _v2 = $author$project$Api$Common$Marketplace$Product$Shared$type_(product);
												switch (_v2) {
													case 0:
														return $elm$html$Html$text('Manage app configuration and user access.');
													case 1:
														return $elm$html$Html$text('Manage integration settings.');
													default:
														return $elm$html$Html$text('');
												}
											}()
											]))
									]));
						} else {
							return $elm$html$Html$text('');
						}
					}(),
						A2(
						$elm$html$Html$map,
						toMsg,
						A2($author$project$Layouts$Marketplace$Manage$viewNav, currentRoute, model))
					])),
				A2($elm$html$Html$div, _List_Nil, body)
			]);
	});
var $author$project$Ui$Grid$offsetLg = $author$project$Ui$Grid$Offset(3);
var $author$project$Ui$Grid$offsetXl = $author$project$Ui$Grid$Offset(4);
var $author$project$Layouts$Onboard$viewHeader = A2(
	$author$project$Ui$Grid$row,
	_List_fromArray(
		[$author$project$Ui$Grid$mb4]),
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Grid$column,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Image$viewHintLogoImage(
					_List_fromArray(
						[
							$author$project$Ui$Image$class('topnav__logo')
						]))
				]))
		]));
var $author$project$Layouts$Onboard$isCurrentRoute = F2(
	function (url, route) {
		return A2(
			$elm$core$String$endsWith,
			$elm$core$String$concat(
				_List_fromArray(
					['/', route])),
			$author$project$Spa$Generated$Route$toString(
				$author$project$Utils$Route$fromUrl(url)));
	});
var $author$project$Components$OnboardingStepper$setCurrentStepFromUrl = function (url) {
	var route = $author$project$Utils$Route$fromUrl(url);
	return A2(
		$elm$core$String$endsWith,
		'/payment',
		$author$project$Spa$Generated$Route$toString(route)) ? 2 : (A2(
		$elm$core$String$endsWith,
		'/user',
		$author$project$Spa$Generated$Route$toString(route)) ? 1 : 0);
};
var $author$project$Ui$Stepper$Step = F5(
	function (label, index, disabled, subtitle, subtitleDescription) {
		return {ep: disabled, sG: index, aih: label, acA: subtitle, acB: subtitleDescription};
	});
var $author$project$Components$OnboardingStepper$convertedSteps = A2(
	$elm$core$List$map,
	function (internalStep) {
		return A5($author$project$Ui$Stepper$Step, internalStep.aih, internalStep.sG, false, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
	},
	$author$project$Components$OnboardingStepper$internalSteps);
var $author$project$Ui$Stepper$viewStep = F3(
	function (_v0, attr, step) {
		var currentIndex = _v0.ae;
		var numSteps = _v0.am;
		var stepIndexString = $elm$core$String$fromInt(step.sG + 1);
		var stepOptions = step.ep ? {
			c9: A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('stepper__circle')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(stepIndexString)
					])),
			dN: 'disabled',
			dO: $elm$html$Html$text(step.aih)
		} : (_Utils_eq(step.sG, currentIndex) ? {
			c9: A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('stepper__circle')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(stepIndexString)
					])),
			dN: 'current',
			dO: $elm$html$Html$text(step.aih)
		} : ((_Utils_cmp(step.sG, currentIndex) < 0) ? {
			c9: A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('stepper__circle'),
						attr
					]),
				_List_fromArray(
					[
						$author$project$Ui$Icon$check(_List_Nil)
					])),
			dN: 'previous',
			dO: A2(
				$elm$html$Html$a,
				_List_fromArray(
					[attr]),
				_List_fromArray(
					[
						$elm$html$Html$text(step.aih)
					]))
		} : {
			c9: A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('stepper__circle')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(stepIndexString)
					])),
			dN: 'next',
			dO: $elm$html$Html$text(step.aih)
		}));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('stepper__step stepper__step--' + stepOptions.dN)
				]),
			_List_fromArray(
				[
					stepOptions.c9,
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('stepper__text')
						]),
					_List_fromArray(
						[stepOptions.dO])),
					A2(
					$author$project$Utils$Html$htmlIf,
					_Utils_cmp(step.sG + 1, numSteps) < 0,
					A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('stepper__line')
							]),
						_List_fromArray(
							[
								$author$project$Ui$HorizontalRule$view(_List_Nil)
							])))
				]));
	});
var $author$project$Ui$Stepper$viewStaticStep = F2(
	function (_v0, step) {
		var currentIndex = _v0.ae;
		var numSteps = _v0.am;
		return A3(
			$author$project$Ui$Stepper$viewStep,
			{ae: currentIndex, am: numSteps},
			$elm$html$Html$Attributes$class('label'),
			step);
	});
var $author$project$Ui$Stepper$viewStatic = F2(
	function (maybeStepIndex, steps) {
		if ($elm$core$List$isEmpty(steps)) {
			return $author$project$Utils$Html$empty;
		} else {
			if (!maybeStepIndex.$) {
				var stepIndex = maybeStepIndex.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('stepper')
						]),
					A2(
						$elm$core$List$map,
						function (step) {
							return A2(
								$author$project$Ui$Stepper$viewStaticStep,
								{
									ae: stepIndex,
									am: $elm$core$List$length(steps)
								},
								step);
						},
						steps));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}
	});
var $author$project$Components$OnboardingStepper$view = function (model) {
	var currentStep = model.Hc;
	return A2(
		$author$project$Ui$Stepper$viewStatic,
		$elm$core$Maybe$Just(currentStep.sG),
		$author$project$Components$OnboardingStepper$convertedSteps);
};
var $author$project$Layouts$Onboard$viewStepper = function (url) {
	if (A2($author$project$Layouts$Onboard$isCurrentRoute, url, 'complete') || A2($author$project$Layouts$Onboard$isCurrentRoute, url, 'completing')) {
		return $author$project$Utils$Html$empty;
	} else {
		var stepId = $author$project$Components$OnboardingStepper$setCurrentStepFromUrl(url);
		var stepperModel = $author$project$Components$OnboardingStepper$init(stepId);
		return $author$project$Components$OnboardingStepper$view(stepperModel);
	}
};
var $author$project$Layouts$Onboard$view = F2(
	function (_v0, body) {
		var url = _v0.adY;
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Layouts$Onboard$viewHeader,
						$author$project$Layouts$Onboard$viewStepper(url),
						A2(
						$author$project$Ui$Grid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanSm(8),
										$author$project$Ui$Grid$offsetSm(2),
										$author$project$Ui$Grid$spanMd(6),
										$author$project$Ui$Grid$offsetMd(3),
										$author$project$Ui$Grid$spanLg(6),
										$author$project$Ui$Grid$offsetLg(3),
										$author$project$Ui$Grid$spanXl(4),
										$author$project$Ui$Grid$offsetXl(4)
									]),
								body)
							]))
					]))
			]);
	});
var $author$project$Layouts$Partner$Billing$viewNav = F3(
	function (shared, currentRoute, _v0) {
		var nav = _v0.kp;
		var isHintAdmin = $author$project$Shared$isHintAdmin(shared);
		var billingRoute = $author$project$Spa$Generated$Route$Partner__Billing;
		return A3(
			$author$project$Ui$Nav$view,
			_List_Nil,
			_List_fromArray(
				[
					function () {
					var chargesRoute = $author$project$Spa$Generated$Route$Partner__Billing__Charges;
					return A2(
						$author$project$Ui$Nav$item,
						_List_fromArray(
							[
								$author$project$Ui$Nav$route(chargesRoute),
								$author$project$Ui$Nav$activeItem(
								_Utils_eq(chargesRoute, currentRoute))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Charges')
							]));
				}(),
					function () {
					var depositsRoute = $author$project$Spa$Generated$Route$Partner__Billing__Deposits;
					return A2(
						$author$project$Ui$Nav$item,
						_List_fromArray(
							[
								$author$project$Ui$Nav$route(depositsRoute),
								$author$project$Ui$Nav$activeItem(
								_Utils_eq(currentRoute, depositsRoute))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Deposits')
							]));
				}(),
					function () {
					var serviceFeeRoute = $author$project$Spa$Generated$Route$Partner__Billing__ServiceFee;
					return A2(
						$author$project$Ui$Nav$item,
						_List_fromArray(
							[
								$author$project$Ui$Nav$route(serviceFeeRoute),
								$author$project$Ui$Nav$activeItem(
								_Utils_eq(serviceFeeRoute, currentRoute))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Service Fee')
							]));
				}(),
					function () {
					var subscriptionsRoute = $author$project$Spa$Generated$Route$Partner__Billing__Subscriptions;
					return A2(
						$author$project$Ui$Nav$item,
						_List_fromArray(
							[
								$author$project$Ui$Nav$route(subscriptionsRoute),
								$author$project$Ui$Nav$activeItem(
								_Utils_eq(subscriptionsRoute, currentRoute))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Subscriptions')
							]));
				}(),
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route(billingRoute),
							$author$project$Ui$Nav$activeItem(
							_Utils_eq(currentRoute, billingRoute))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Payment Processing')
						])),
					function () {
					if (isHintAdmin) {
						var hinterRoute = $author$project$Spa$Generated$Route$Partner__Billing__Hinter;
						return A2(
							$author$project$Ui$HinterOnly$navItem,
							_List_fromArray(
								[
									$author$project$Ui$Nav$route(hinterRoute),
									$author$project$Ui$Nav$activeItem(
									_Utils_eq(hinterRoute, currentRoute))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Billing')
								]));
					} else {
						return $author$project$Ui$Nav$emptyItem;
					}
				}()
				]),
			nav);
	});
var $author$project$Layouts$Partner$Billing$view = F4(
	function (toMsg, shared, model, body) {
		var currentRoute = $author$project$Utils$Route$fromUrl(shared.adY);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('layout-header')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						toMsg,
						A3($author$project$Layouts$Partner$Billing$viewNav, shared, currentRoute, model))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('nav-panel nav-panel-header-white')
					]),
				body)
			]);
	});
var $author$project$Layouts$Partner$Practices$viewNav = F2(
	function (currentRoute, _v0) {
		var nav = _v0.kp;
		var engagementsRoute = $author$project$Spa$Generated$Route$Partner__Engagements;
		var connectionsRoute = $author$project$Spa$Generated$Route$Partner__Practices__Top;
		return A3(
			$author$project$Ui$Nav$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route(engagementsRoute),
							$author$project$Ui$Nav$activeItem(
							_Utils_eq(currentRoute, engagementsRoute))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Engagements')
						])),
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route(connectionsRoute),
							$author$project$Ui$Nav$activeItem(
							_Utils_eq(currentRoute, connectionsRoute))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Connections')
						]))
				]),
			nav);
	});
var $author$project$Layouts$Partner$Practices$view = F4(
	function (toMsg, shared, model, body) {
		var currentRoute = $author$project$Utils$Route$fromUrl(shared.adY);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('layout-header')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						toMsg,
						A2($author$project$Layouts$Partner$Practices$viewNav, currentRoute, model))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('nav-panel nav-panel-header-white')
					]),
				body)
			]);
	});
var $author$project$Layouts$Partner$Product$productIdFromRoute = function (route) {
	switch (route.$) {
		case 305:
			var id = route.a.ahP;
			return $elm$core$Maybe$Just(id);
		case 336:
			var id = route.a.ahP;
			return $elm$core$Maybe$Just(id);
		case 338:
			var id = route.a.ahP;
			return $elm$core$Maybe$Just(id);
		case 337:
			var id = route.a.ahP;
			return $elm$core$Maybe$Just(id);
		case 339:
			var id = route.a.ahP;
			return $elm$core$Maybe$Just(id);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Partner$Partner$Shared$appEnabled = function (_v0) {
	var record = _v0;
	return !record.Jo;
};
var $author$project$Api$Partner$Partner$One$appEnabled = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$appEnabled(shared);
};
var $author$project$Layouts$Partner$Product$gatedNavItem = F4(
	function (partner, gate, skeletonLabel, realItem) {
		switch (partner.$) {
			case 3:
				var p = partner.a;
				return gate(p) ? realItem : $author$project$Ui$Nav$emptyItem;
			case 2:
				return $author$project$Ui$Nav$emptyItem;
			default:
				return A2(
					$author$project$Ui$Nav$customItem,
					_List_Nil,
					$author$project$Ui$Skeleton$text(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$spanFromText(skeletonLabel)
							])));
		}
	});
var $author$project$Layouts$Partner$Product$viewNavWithId = F4(
	function (shared, currentRoute, nav, productId) {
		var partner = shared.YN;
		var isHintAdmin = $author$project$Shared$isHintAdmin(shared);
		var idParams = {ahP: productId};
		var detailRoute = $author$project$Spa$Generated$Route$Partner__Products__Id_String(idParams);
		var appSettingsRoute = $author$project$Spa$Generated$Route$Partner__Products__Id_String__AppSettings(idParams);
		var activationRoute = $author$project$Spa$Generated$Route$Partner__Products__Id_String__ActivationSettings(idParams);
		return A3(
			$author$project$Ui$Nav$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route(detailRoute),
							$author$project$Ui$Nav$activeItem(
							_Utils_eq(currentRoute, detailRoute))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Product Listing')
						])),
					A4(
					$author$project$Layouts$Partner$Product$gatedNavItem,
					partner,
					$author$project$Api$Partner$Partner$One$active,
					'Activation Settings',
					A2(
						$author$project$Ui$Nav$item,
						_List_fromArray(
							[
								$author$project$Ui$Nav$route(activationRoute),
								$author$project$Ui$Nav$activeItem(
								_Utils_eq(activationRoute, currentRoute))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Activation Settings')
							]))),
					A4(
					$author$project$Layouts$Partner$Product$gatedNavItem,
					partner,
					function (p) {
						return $author$project$Api$Partner$Partner$One$active(p) && $author$project$Api$Partner$Partner$One$appEnabled(p);
					},
					'App Settings',
					A2(
						$author$project$Ui$Nav$item,
						_List_fromArray(
							[
								$author$project$Ui$Nav$route(appSettingsRoute),
								$author$project$Ui$Nav$activeItem(
								_Utils_eq(appSettingsRoute, currentRoute))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('App Settings')
							]))),
					function () {
					if (isHintAdmin) {
						var appBuilderRoute = $author$project$Spa$Generated$Route$Partner__Products__Id_String__AppBuilder(idParams);
						return A4(
							$author$project$Layouts$Partner$Product$gatedNavItem,
							partner,
							$author$project$Api$Partner$Partner$One$appEnabled,
							'App Builder',
							A2(
								$author$project$Ui$HinterOnly$navItem,
								_List_fromArray(
									[
										$author$project$Ui$Nav$route(appBuilderRoute),
										$author$project$Ui$Nav$activeItem(
										_Utils_eq(appBuilderRoute, currentRoute))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('App Builder')
									])));
					} else {
						return $author$project$Ui$Nav$emptyItem;
					}
				}(),
					function () {
					if (isHintAdmin) {
						var hinterRoute = $author$project$Spa$Generated$Route$Partner__Products__Id_String__Hinter(idParams);
						return A2(
							$author$project$Ui$HinterOnly$navItem,
							_List_fromArray(
								[
									$author$project$Ui$Nav$route(hinterRoute),
									$author$project$Ui$Nav$activeItem(
									_Utils_eq(hinterRoute, currentRoute))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Admin Settings')
								]));
					} else {
						return $author$project$Ui$Nav$emptyItem;
					}
				}()
				]),
			nav);
	});
var $author$project$Layouts$Partner$Product$viewNav = F3(
	function (shared, currentRoute, _v0) {
		var nav = _v0.kp;
		var _v1 = $author$project$Layouts$Partner$Product$productIdFromRoute(currentRoute);
		if (_v1.$ === 1) {
			return $elm$html$Html$text('');
		} else {
			var productId = _v1.a;
			return A4($author$project$Layouts$Partner$Product$viewNavWithId, shared, currentRoute, nav, productId);
		}
	});
var $author$project$Layouts$Partner$Product$view = F4(
	function (toMsg, shared, model, body) {
		var currentRoute = $author$project$Utils$Route$fromUrl(shared.adY);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('layout-header')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						toMsg,
						A3($author$project$Layouts$Partner$Product$viewNav, shared, currentRoute, model))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('nav-panel nav-panel-header-white')
					]),
				body)
			]);
	});
var $author$project$Layouts$Partner$Webhooks$viewNav = F2(
	function (currentRoute, _v0) {
		var nav = _v0.kp;
		var settingsRoute = $author$project$Spa$Generated$Route$Partner__Webhooks__Settings;
		var requestsRoute = $author$project$Spa$Generated$Route$Partner__Webhooks__Requests;
		return A3(
			$author$project$Ui$Nav$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route(settingsRoute),
							$author$project$Ui$Nav$activeItem(
							_Utils_eq(currentRoute, settingsRoute))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Settings')
						])),
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route(requestsRoute),
							$author$project$Ui$Nav$activeItem(
							_Utils_eq(currentRoute, requestsRoute))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Requests')
						]))
				]),
			nav);
	});
var $author$project$Layouts$Partner$Webhooks$view = F4(
	function (toMsg, shared, model, body) {
		var currentRoute = $author$project$Utils$Route$fromUrl(shared.adY);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('layout-header')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						toMsg,
						A2($author$project$Layouts$Partner$Webhooks$viewNav, currentRoute, model))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('nav-panel nav-panel-header-white')
					]),
				body)
			]);
	});
var $author$project$Components$PatientViewSwitcher$MembershipsBilling = 1;
var $author$project$Components$PatientChart$Helpers$activeViewFor = F2(
	function (whenJointProduct, practice) {
		if (practice.$ === 3) {
			var practice_ = practice.a;
			return A2($author$project$Api$Practice$featureEnabled, 6, practice_) ? $elm$core$Maybe$Just(whenJointProduct) : $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$PatientChart$Helpers$isPatientRootRoute = function (url) {
	var _v0 = $author$project$Spa$Generated$Route$fromUrl(url);
	if ((!_v0.$) && (_v0.a.$ === 204)) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$PatientChart$DemographicsHeader$displayName = function (patient) {
	var last = A2(
		$elm$core$Maybe$withDefault,
		'',
		$author$project$Api$Provider$Patient$One$lastName(patient));
	var first = A2(
		$elm$core$Maybe$withDefault,
		$author$project$Api$Provider$Patient$One$firstName(patient),
		$author$project$Api$Provider$Patient$One$chosenFirstName(patient));
	return $elm$core$String$trim(first + (' ' + last));
};
var $author$project$Ui$Element$px6 = $author$project$Ui$Element$Padding('px-6');
var $author$project$Ui$Element$Base = 2;
var $author$project$Ui$Element$textBase = $author$project$Ui$Element$Text(2);
var $author$project$Components$PatientChart$DemographicsHeader$viewBreadcrumb = function (patient) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2, $author$project$Ui$Element$textBase, $author$project$Ui$Element$px6, $author$project$Ui$Element$pt4]),
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Link$route,
				$author$project$Spa$Generated$Route$Patients__Top,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Patients')
					])),
				A2(
				$author$project$Ui$Typography$span,
				_List_fromArray(
					[$author$project$Ui$Typography$muted]),
				_List_fromArray(
					[
						$elm$html$Html$text('/')
					])),
				A2(
				$author$project$Ui$Typography$span,
				_List_fromArray(
					[$author$project$Ui$Typography$black]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Components$PatientChart$DemographicsHeader$displayName(patient))
					]))
			]));
};
var $author$project$Ui$Element$gap6 = $author$project$Ui$Element$Gap(6);
var $author$project$Components$PatientChart$DemographicsHeader$actionIcon = F2(
	function (_v0, icon) {
		var filled = _v0.gs;
		var classes = filled ? 'demographics-header__action-icon demographics-header__action-icon--filled' : 'demographics-header__action-icon';
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(classes)
				]),
			_List_fromArray(
				[icon]));
	});
var $author$project$Components$PatientChart$DemographicsHeader$viewActionIcons = function (withMoreVert) {
	var moreVertIcon = withMoreVert ? _List_fromArray(
		[
			A2(
			$author$project$Components$PatientChart$DemographicsHeader$actionIcon,
			{gs: false},
			$author$project$Ui$Icon$moreVert(_List_Nil))
		]) : _List_Nil;
	var filledIcons = _List_fromArray(
		[
			A2(
			$author$project$Components$PatientChart$DemographicsHeader$actionIcon,
			{gs: true},
			$author$project$Ui$Icon$phone(_List_Nil)),
			A2(
			$author$project$Components$PatientChart$DemographicsHeader$actionIcon,
			{gs: true},
			$author$project$Ui$Icon$chatbox(_List_Nil)),
			A2(
			$author$project$Components$PatientChart$DemographicsHeader$actionIcon,
			{gs: true},
			$author$project$Ui$Icon$envelope(_List_Nil)),
			A2(
			$author$project$Components$PatientChart$DemographicsHeader$actionIcon,
			{gs: true},
			$author$project$Ui$Icon$pin(_List_Nil)),
			A2(
			$author$project$Components$PatientChart$DemographicsHeader$actionIcon,
			{gs: true},
			$author$project$Ui$Icon$dollar(_List_Nil)),
			A2(
			$author$project$Components$PatientChart$DemographicsHeader$actionIcon,
			{gs: true},
			$author$project$Ui$Icon$shield(_List_Nil))
		]);
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2, $author$project$Ui$Element$mt1]),
		_Utils_ap(filledIcons, moreVertIcon));
};
var $author$project$Ui$ProfilePicture$Class = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$ProfilePicture$class = $author$project$Ui$ProfilePicture$Class;
var $author$project$Components$PatientChart$DemographicsHeader$membershipStatusBorderClass = function (status) {
	switch (status) {
		case 0:
			return 'profile-picture--status-active';
		case 1:
			return 'profile-picture--status-unpaid';
		case 2:
			return 'profile-picture--status-inactive';
		case 3:
			return 'profile-picture--status-archived';
		case 4:
			return 'profile-picture--status-unconfirmed';
		default:
			return 'profile-picture--status-pending';
	}
};
var $author$project$Components$PatientChart$DemographicsHeader$Active = 0;
var $author$project$Components$PatientChart$DemographicsHeader$Archived = 3;
var $author$project$Components$PatientChart$DemographicsHeader$Inactive = 2;
var $author$project$Components$PatientChart$DemographicsHeader$Pending = 5;
var $author$project$Components$PatientChart$DemographicsHeader$Unconfirmed = 4;
var $author$project$Components$PatientChart$DemographicsHeader$Unpaid = 1;
var $author$project$Components$PatientChart$DemographicsHeader$membershipStatusFromString = function (status) {
	switch (status) {
		case 'active':
			return $elm$core$Maybe$Just(0);
		case 'unpaid':
			return $elm$core$Maybe$Just(1);
		case 'inactive':
			return $elm$core$Maybe$Just(2);
		case 'archived':
			return $elm$core$Maybe$Just(3);
		case 'unconfirmed':
			return $elm$core$Maybe$Just(4);
		case 'pending':
			return $elm$core$Maybe$Just(5);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Ui$ProfilePicture$firstLetter = function (word) {
	var _v0 = $elm$core$String$uncons(word);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var _char = _v1.a;
		return $elm$core$Maybe$Just(
			$elm$core$String$fromChar(_char));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$String$words = _String_words;
var $author$project$Ui$ProfilePicture$toInitials = function (name) {
	return $elm$core$String$toUpper(
		$elm$core$String$concat(
			A2(
				$elm$core$List$take,
				2,
				A2(
					$elm$core$List$filterMap,
					$author$project$Ui$ProfilePicture$firstLetter,
					$elm$core$String$words(name)))));
};
var $author$project$Ui$ProfilePicture$viewWithInitials = F2(
	function (options, _v0) {
		var photoUrl = _v0.ZA;
		var name = _v0.Bq;
		if (!photoUrl.$) {
			var url = photoUrl.a;
			return A2($author$project$Ui$ProfilePicture$view, options, url);
		} else {
			var optionsRecord = $author$project$Ui$ProfilePicture$optionsToRecord(options);
			return A2(
				$elm$html$Html$div,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('profile-picture profile-picture--initials'),
					A2(
						$elm$core$List$cons,
						A2($elm$html$Html$Attributes$attribute, 'role', 'img'),
						A2(
							$elm$core$List$cons,
							A2($elm$html$Html$Attributes$attribute, 'aria-label', name),
							optionsRecord.xr))),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Ui$ProfilePicture$toInitials(name))
					]));
		}
	});
var $author$project$Components$PatientChart$DemographicsHeader$viewAvatar = function (patient) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$shrinkNone]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$ProfilePicture$viewWithInitials,
				_List_fromArray(
					[
						$author$project$Ui$ProfilePicture$size(80),
						$author$project$Ui$ProfilePicture$alt(
						$author$project$Components$PatientChart$DemographicsHeader$displayName(patient)),
						$author$project$Ui$ProfilePicture$class(
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$map,
								$author$project$Components$PatientChart$DemographicsHeader$membershipStatusBorderClass,
								$author$project$Components$PatientChart$DemographicsHeader$membershipStatusFromString(
									$author$project$Api$Provider$Patient$One$membershipStatus(patient)))))
					]),
				{
					Bq: $author$project$Components$PatientChart$DemographicsHeader$displayName(patient),
					ZA: $author$project$Api$Provider$Patient$One$profilePictureUrl(patient)
				})
			]));
};
var $author$project$Components$PatientChart$DemographicsHeader$demographicDetails = function (patient) {
	return A2(
		$elm$core$String$join,
		', ',
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$author$project$Api$Provider$Patient$One$gender(patient),
					A2(
					$elm$core$Maybe$map,
					$justinmimbs$date$Date$format('M/d/yyyy'),
					$author$project$Api$Provider$Patient$One$dob(patient))
				])));
};
var $author$project$Ui$Element$Title = 3;
var $author$project$Ui$Element$textTitle = $author$project$Ui$Element$Text(3);
var $author$project$Components$PatientChart$DemographicsHeader$viewDetailsRow = function (patient) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap, $author$project$Ui$Element$textTitle]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$span,
				_List_fromArray(
					[$author$project$Ui$Typography$black]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Components$PatientChart$DemographicsHeader$demographicDetails(patient))
					])),
				function () {
				var _v0 = $author$project$Api$Provider$Patient$One$pronoun(patient);
				if (!_v0.$) {
					var pronoun = _v0.a;
					return A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$ml2]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[$author$project$Ui$Typography$muted]),
								_List_fromArray(
									[
										$elm$html$Html$text('(' + (pronoun + ')'))
									]))
							]));
				} else {
					return $elm$html$Html$text('');
				}
			}()
			]));
};
var $author$project$Components$PatientChart$DemographicsHeader$nameWithAge = function (patient) {
	var _v0 = $author$project$Api$Provider$Patient$One$age(patient);
	if (!_v0.$) {
		var age = _v0.a;
		return $author$project$Components$PatientChart$DemographicsHeader$displayName(patient) + (' (' + ($elm$core$String$fromInt(age) + ')'));
	} else {
		return $author$project$Components$PatientChart$DemographicsHeader$displayName(patient);
	}
};
var $author$project$Components$PatientChart$DemographicsHeader$viewNameRow = function (patient) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$title,
				_List_fromArray(
					[$author$project$Ui$Typography$bold]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Components$PatientChart$DemographicsHeader$nameWithAge(patient))
					])),
				A2(
				$author$project$Ui$Badge$fromString,
				_List_Nil,
				$author$project$Api$Provider$Patient$One$membershipStatus(patient))
			]));
};
var $author$project$Components$PatientChart$DemographicsHeader$viewContent = F2(
	function (patient, maybeSwitcher) {
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsStart, $author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$gap4, $author$project$Ui$Element$px6, $author$project$Ui$Element$py4]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap6]),
					_List_fromArray(
						[
							$author$project$Components$PatientChart$DemographicsHeader$viewAvatar(patient),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									$author$project$Components$PatientChart$DemographicsHeader$viewNameRow(patient),
									$author$project$Components$PatientChart$DemographicsHeader$viewDetailsRow(patient),
									$author$project$Components$PatientChart$DemographicsHeader$viewActionIcons(
									$author$project$Utils$Maybe$toBool(maybeSwitcher))
								]))
						])),
					function () {
					if (!maybeSwitcher.$) {
						var s = maybeSwitcher.a;
						return s;
					} else {
						return $elm$html$Html$text('');
					}
				}()
				]));
	});
var $author$project$Components$PatientViewSwitcher$ClinicalChart = 0;
var $author$project$Components$PatientViewSwitcher$viewToRoute = F2(
	function (activeView, patientId) {
		if (!activeView) {
			return $author$project$Spa$Generated$Route$Patients__PatientId_String__Chart(
				{YZ: patientId});
		} else {
			return $author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
				{YZ: patientId});
		}
	});
var $author$project$Components$PatientViewSwitcher$viewItem = F4(
	function (label, itemView, activeView, patientId) {
		return _Utils_eq(itemView, activeView) ? A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('patient-view-switcher__item patient-view-switcher__item--active')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				])) : A3(
			$author$project$Ui$Link$route,
			A2($author$project$Components$PatientViewSwitcher$viewToRoute, itemView, patientId),
			_List_fromArray(
				[$author$project$Ui$Link$currentColor]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('patient-view-switcher__item')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						]))
				]));
	});
var $author$project$Components$PatientViewSwitcher$view = F2(
	function (patientId, activeView) {
		var barClass = function () {
			if (!activeView) {
				return 'patient-view-switcher-bar patient-view-switcher-bar--clinical';
			} else {
				return 'patient-view-switcher-bar patient-view-switcher-bar--core';
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(barClass)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('patient-view-switcher')
						]),
					_List_fromArray(
						[
							A4($author$project$Components$PatientViewSwitcher$viewItem, 'Clinical Chart', 0, activeView, patientId),
							A4($author$project$Components$PatientViewSwitcher$viewItem, 'Memberships & Billing', 1, activeView, patientId)
						]))
				]));
	});
var $author$project$Components$PatientChart$DemographicsHeader$viewSwitcher = F2(
	function (patientId, view_) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$never,
			A2($author$project$Components$PatientViewSwitcher$view, patientId, view_));
	});
var $author$project$Components$PatientChart$DemographicsHeader$view = function (_v0) {
	var patient = _v0.YY;
	var patientId = _v0.YZ;
	var activeView = _v0.aeF;
	return A3(
		$author$project$Ui$Element$custom,
		'demographics-header',
		_List_Nil,
		function () {
			if (!activeView.$) {
				var view_ = activeView.a;
				return _List_fromArray(
					[
						A2(
						$author$project$Components$PatientChart$DemographicsHeader$viewContent,
						patient,
						$elm$core$Maybe$Just(
							A2($author$project$Components$PatientChart$DemographicsHeader$viewSwitcher, patientId, view_)))
					]);
			} else {
				return _List_fromArray(
					[
						$author$project$Components$PatientChart$DemographicsHeader$viewBreadcrumb(patient),
						$author$project$Ui$HorizontalRule$view(_List_Nil),
						A2($author$project$Components$PatientChart$DemographicsHeader$viewContent, patient, $elm$core$Maybe$Nothing)
					]);
			}
		}());
};
var $author$project$Ui$Pagination$List$HideTotalItems = {$: 3};
var $author$project$Ui$Pagination$List$hideTotalItems = $author$project$Ui$Pagination$List$HideTotalItems;
var $author$project$Components$PatientsList$PhiModeToggled = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$PatientsList$viewPhiToggle = function (phiMode) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$itemsCenter]),
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$view(
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$sm,
						$author$project$Ui$ToggleSwitch$on(!phiMode),
						$author$project$Ui$ToggleSwitch$onChange(
						A2($elm$core$Basics$composeL, $author$project$Components$PatientsList$PhiModeToggled, $elm$core$Basics$not))
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('ml-2')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Display patients list')
					]))
			]));
};
var $author$project$Components$PatientsList$viewMini = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('patients-list patients-list--mini'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('patients-list--phi-mode', model.tQ)
					]))
			]),
		_Utils_ap(
			A2($author$project$Components$PatientsList$viewSearchAndFilters, true, model),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Panel$body,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Components$PatientsList$viewPhiToggle(model.tQ)
								])),
							A2($author$project$Components$PatientsList$viewPatientsTable, true, model),
							A2(
							$author$project$Ui$Panel$body,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$mt4]),
									_List_fromArray(
										[
											A2(
											$author$project$Components$PatientsList$viewPagination,
											_List_fromArray(
												[$author$project$Ui$Pagination$List$hideTotalItems, $author$project$Ui$Pagination$List$sm]),
											model)
										]))
								]))
						]))
				])));
};
var $author$project$Layouts$PatientsSidebar$view = F3(
	function (toMsg, patientsListModel, body) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						toMsg,
						$author$project$Components$PatientsList$viewMini(patientsListModel)),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('md:w-full md:ml-64 w-full')
							]),
						body)
					]))
			]);
	});
var $author$project$Layouts$Patient$viewBackToChartCard = F2(
	function (patientId, body) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('patient-content-card')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('patient-content-card__back-link')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
								{YZ: patientId}),
							_List_fromArray(
								[
									$author$project$Ui$Link$icon($author$project$Ui$Icon$arrowLeft)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Back to Patient Chart')
								]))
						])),
					A2($elm$html$Html$div, _List_Nil, body)
				]));
	});
var $author$project$Components$PatientChart$NotesCard$NewNote = {$: 1};
var $author$project$Components$PatientChart$NotesCard$filterNotes = F2(
	function (flagged, notes) {
		return A2(
			$elm$core$List$filter,
			function (note) {
				switch (flagged) {
					case 0:
						return true;
					case 1:
						return $author$project$Api$Provider$Note$All$flagged(note);
					default:
						return !$author$project$Api$Provider$Note$All$flagged(note);
				}
			},
			notes);
	});
var $author$project$Ui$Element$pb0 = $author$project$Ui$Element$Padding('pb-0');
var $author$project$Ui$Element$pt2 = $author$project$Ui$Element$Padding('pt-2');
var $author$project$Components$PatientChart$NotesCard$FlaggedFiltered = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$PatientChart$NotesCard$flaggedDropdownOptions = function (currentFlaggedOption) {
	var flaggedOptionToItem = function (option) {
		return A2(
			$author$project$Ui$Dropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$Dropdown$selected(
					_Utils_eq(currentFlaggedOption, option)),
					$author$project$Ui$Dropdown$onSelect(
					$author$project$Components$PatientChart$NotesCard$FlaggedFiltered(option))
				]),
			$elm$html$Html$text(
				$author$project$Components$Notes$FlaggedOption$toLabel(option)));
	};
	return A2(
		$elm$core$List$cons,
		flaggedOptionToItem(0),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$Dropdown$separator,
			A2(
				$elm$core$List$map,
				flaggedOptionToItem,
				_List_fromArray(
					[1, 2]))));
};
var $author$project$Components$PatientChart$NotesCard$viewFlaggedDropdown = function (model) {
	return A4(
		$author$project$Ui$Dropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Components$Notes$FlaggedOption$toLabel(model.HN))
			]),
		$author$project$Components$PatientChart$NotesCard$flaggedDropdownOptions(model.HN),
		model.nM);
};
var $author$project$Components$PatientChart$NotesCard$Content = $elm$core$Basics$identity;
var $author$project$Components$PatientChart$NotesCard$FormUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$PatientChart$NotesCard$SaveNote = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Components$PatientChart$NotesCard$viewNoteModal = F3(
	function (maybeId, note, form) {
		var modalConfig = {
			Tq: $elm$core$Maybe$Nothing,
			aih: 'Note',
			V8: _Utils_eq(note, $author$project$Api$Data$Loading),
			WG: maybeId,
			WH: $elm$core$Maybe$Nothing,
			Yd: $author$project$Components$PatientChart$NotesCard$CancelNoteEdit,
			Yf: $author$project$Components$PatientChart$NotesCard$SaveNote(form)
		};
		var content = $author$project$Utils$Form$fields(form);
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$required(true),
							$author$project$Ui$Form$Group$label('Content')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Textarea$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Textarea$value(content),
									$author$project$Ui$Form$Textarea$phi(true),
									$author$project$Ui$Form$Textarea$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$PatientChart$NotesCard$FormUpdated, $elm$core$Basics$identity)),
									$author$project$Ui$Form$Textarea$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form))
								])),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						]))
				]));
	});
var $author$project$Components$PatientChart$NotesCard$DeleteNote = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$PatientChart$NotesCard$EditNote = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$PatientChart$NotesCard$FlagNote = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Ui$Element$py3 = $author$project$Ui$Element$Padding('py-3');
var $author$project$Ui$Element$Relative = {$: 7};
var $author$project$Ui$Element$relative = $author$project$Ui$Element$Relative;
var $author$project$Ui$Button$ariaExpanded = function (value) {
	return $author$project$Ui$Button$Attrs(
		_List_fromArray(
			[
				A2(
				$elm$html$Html$Attributes$attribute,
				'aria-expanded',
				value ? 'true' : 'false')
			]));
};
var $author$project$Ui$Button$ariaHaspopup = function (popupType) {
	return $author$project$Ui$Button$Attrs(
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'aria-haspopup', popupType)
			]));
};
var $author$project$Ui$Element$hiddenMd = $author$project$Ui$Element$Hidden(2);
var $author$project$Ui$FlyoutMenu$isOpen = function (_v0) {
	var model = _v0;
	return model.Yn;
};
var $author$project$Ui$FlyoutMenu$MobileOverlay = {$: 2};
var $author$project$Ui$FlyoutMenu$mobileOverlay = $author$project$Ui$FlyoutMenu$MobileOverlay;
var $author$project$Components$PatientChart$NotesCard$viewMobileActionMenu = F8(
	function (model, note, id, isLast, noteFlagged, canEdit, canDelete, loading) {
		var menuDirection = isLast ? 3 : 2;
		var menu = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Components$PatientChart$NotesCard$initActionMenu(id),
			A2($elm$core$Dict$get, id, model.aZ));
		var kebabTrigger = A3(
			$author$project$Ui$Button$view,
			{mm: 'Note actions'},
			_List_fromArray(
				[
					$author$project$Ui$Button$link,
					$author$project$Ui$Button$icon($author$project$Ui$Icon$moreVert),
					$author$project$Ui$Button$ariaHaspopup('menu'),
					$author$project$Ui$Button$ariaExpanded(
					$author$project$Ui$FlyoutMenu$isOpen(menu))
				]),
			_List_Nil);
		var flagItem = $author$project$Ui$FlyoutMenu$menuItem(
			{
				ep: loading,
				ahO: $elm$core$Maybe$Just(
					(noteFlagged ? $author$project$Ui$Icon$flagFilled : $author$project$Ui$Icon$flag)(_List_Nil)),
				aih: noteFlagged ? 'Unflag note' : 'Flag note',
				IS: A2($author$project$Components$PatientChart$NotesCard$FlagNote, id, !noteFlagged)
			});
		var editItems = canEdit ? _List_fromArray(
			[
				$author$project$Ui$FlyoutMenu$menuItem(
				{
					ep: loading,
					ahO: $elm$core$Maybe$Just(
						$author$project$Ui$Icon$edit(_List_Nil)),
					aih: 'Edit note',
					IS: $author$project$Components$PatientChart$NotesCard$EditNote(note)
				})
			]) : _List_Nil;
		var deleteItems = canDelete ? _List_fromArray(
			[
				$author$project$Ui$FlyoutMenu$menuItem(
				{
					ep: loading,
					ahO: $elm$core$Maybe$Just(
						$author$project$Ui$Icon$delete(_List_Nil)),
					aih: 'Delete note',
					IS: $author$project$Components$PatientChart$NotesCard$DeleteNote(id)
				})
			]) : _List_Nil;
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2, $author$project$Ui$Element$hiddenMd]),
			_List_fromArray(
				[
					noteFlagged ? A3(
					$author$project$Ui$Button$view,
					{mm: 'Unflag note'},
					_List_fromArray(
						[
							$author$project$Ui$Button$iconOnly,
							$author$project$Ui$Button$icon($author$project$Ui$Icon$flagFilled),
							$author$project$Ui$Button$danger,
							$author$project$Ui$Button$onClick(
							A2($author$project$Components$PatientChart$NotesCard$FlagNote, id, false)),
							$author$project$Ui$Button$disabled(loading)
						]),
					_List_Nil) : $author$project$Utils$Html$empty,
					A4(
					$author$project$Ui$FlyoutMenu$view,
					_List_fromArray(
						[
							$author$project$Ui$FlyoutMenu$direction(menuDirection),
							$author$project$Ui$FlyoutMenu$mobileOverlay
						]),
					_List_fromArray(
						[
							$author$project$Ui$FlyoutMenu$body(
							A2(
								$elm$core$List$cons,
								flagItem,
								_Utils_ap(editItems, deleteItems)))
						]),
					kebabTrigger,
					menu)
				]));
	});
var $author$project$Ui$Element$w20 = $author$project$Ui$Element$Width('w-20');
var $author$project$Components$PatientChart$NotesCard$viewNoteRow = F3(
	function (model, position, note) {
		var noteFlagged = $author$project$Api$Provider$Note$All$flagged(note);
		var id = $author$project$Api$Provider$Note$All$id(note);
		var loading = A2($elm$core$Set$member, id, model.ex) || A2($elm$core$Set$member, id, model.ei);
		var canEdit = $author$project$Api$Provider$Note$Meta$editable(
			$author$project$Api$Provider$Note$All$meta(note));
		var canDelete = canEdit || model.Im;
		return A3(
			$author$project$Ui$Element$custom,
			'notes-card__row',
			_List_fromArray(
				[$author$project$Ui$Element$relative, $author$project$Ui$Element$py3]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[
							$author$project$Ui$Typography$phi(true),
							$author$project$Ui$Typography$overflowWrap($author$project$Ui$OverflowWrap$breakWord),
							$author$project$Ui$Typography$preWrap
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$Note$All$content(note))
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$gap2]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[$author$project$Ui$Typography$muted]),
							A2(
								$elm$core$Maybe$withDefault,
								'N/A',
								A2(
									$elm$core$Maybe$map,
									$author$project$Api$Provider$User$Shared$name,
									$author$project$Api$Provider$Note$All$createdBy(note))) + (' commented on ' + A2(
								model.J7,
								5,
								$author$project$Api$Provider$Note$All$createdAt(note)))),
							A3(
							$author$project$Ui$Element$custom,
							'notes-card__actions-slot',
							_List_fromArray(
								[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$justifyRight, $author$project$Ui$Element$shrinkNone, $author$project$Ui$Element$w20]),
							_List_fromArray(
								[
									A8($author$project$Components$PatientChart$NotesCard$viewMobileActionMenu, model, note, id, position.US, noteFlagged, canEdit, canDelete, loading),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$hidden, $author$project$Ui$Element$flexMd, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$justifyRight, $author$project$Ui$Element$fullWidth]),
									_List_fromArray(
										[
											noteFlagged ? A3(
											$author$project$Ui$Element$custom,
											'notes-card__flag-indicator',
											_List_Nil,
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Button$view,
													{mm: 'Flagged'},
													_List_fromArray(
														[
															$author$project$Ui$Button$iconOnly,
															$author$project$Ui$Button$icon($author$project$Ui$Icon$flagFilled),
															$author$project$Ui$Button$danger,
															$author$project$Ui$Button$disabled(true),
															$author$project$Ui$Button$preventFocus
														]),
													_List_Nil)
												])) : $author$project$Utils$Html$empty,
											A3(
											$author$project$Ui$Element$custom,
											'notes-card__row-controls',
											_List_fromArray(
												[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter]),
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Button$view,
													{
														mm: noteFlagged ? 'Unflag note' : 'Flag note'
													},
													_List_fromArray(
														[
															$author$project$Ui$Button$iconOnly,
															$author$project$Ui$Button$icon(
															noteFlagged ? $author$project$Ui$Icon$flagFilled : $author$project$Ui$Icon$flag),
															$author$project$Ui$Button$onClick(
															A2($author$project$Components$PatientChart$NotesCard$FlagNote, id, !noteFlagged)),
															$author$project$Ui$Button$disabled(loading),
															noteFlagged ? $author$project$Ui$Button$danger : $author$project$Ui$Button$default
														]),
													_List_Nil),
													canEdit ? A3(
													$author$project$Ui$Button$view,
													{mm: 'Edit note'},
													_List_fromArray(
														[
															$author$project$Ui$Button$iconOnly,
															$author$project$Ui$Button$icon($author$project$Ui$Icon$edit),
															$author$project$Ui$Button$onClick(
															$author$project$Components$PatientChart$NotesCard$EditNote(note)),
															$author$project$Ui$Button$disabled(loading)
														]),
													_List_Nil) : $author$project$Utils$Html$empty,
													canDelete ? A3(
													$author$project$Ui$Button$view,
													{mm: 'Delete note'},
													_List_fromArray(
														[
															$author$project$Ui$Button$iconOnly,
															$author$project$Ui$Button$icon($author$project$Ui$Icon$delete),
															$author$project$Ui$Button$onClick(
															$author$project$Components$PatientChart$NotesCard$DeleteNote(id)),
															$author$project$Ui$Button$disabled(loading)
														]),
													_List_Nil) : $author$project$Utils$Html$empty
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$PatientChart$NotesCard$viewNoteSkeleton = A3(
	$author$project$Ui$Element$custom,
	'notes-card__row',
	_List_fromArray(
		[$author$project$Ui$Element$relative, $author$project$Ui$Element$py3]),
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$span(6)
						]))
				])),
			A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$span(4)
						]))
				]))
		]));
var $author$project$Components$PatientChart$NotesCard$noun = function (notable) {
	switch (notable.$) {
		case 0:
			return 'practice';
		case 1:
			return 'company';
		default:
			return 'patient';
	}
};
var $author$project$Components$PatientChart$NotesCard$zeroStateText = F2(
	function (notable, flagged) {
		return 'This ' + ($author$project$Components$PatientChart$NotesCard$noun(notable) + (' has no ' + ($author$project$Components$Notes$FlaggedOption$toValue(flagged) + ' notes')));
	});
var $author$project$Components$PatientChart$NotesCard$view = function (_v0) {
	var model = _v0;
	return _List_fromArray(
		[
			function () {
			var _v1 = model.al;
			if (!_v1.$) {
				var _v2 = _v1.a;
				var id = _v2.a;
				var form = _v2.b;
				var note = _v2.c;
				return A3($author$project$Components$PatientChart$NotesCard$viewNoteModal, id, note, form);
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			function () {
			var _v3 = model.jg;
			if (!_v3.$) {
				var id = _v3.a;
				return A2(
					$author$project$Components$HiConfirm$modal,
					$author$project$Components$PatientChart$NotesCard$HiConfirmClosed(id),
					_List_fromArray(
						[
							$author$project$Components$HiConfirm$verb('delete'),
							$author$project$Components$HiConfirm$noun('note')
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_fromArray(
						[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$pb0]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap4]),
							_List_fromArray(
								[
									$author$project$Ui$Panel$title(
									_List_fromArray(
										[
											$elm$html$Html$text('Notes')
										])),
									$author$project$Components$PatientChart$NotesCard$viewFlaggedDropdown(model)
								])),
							A3(
							$author$project$Ui$Button$view,
							{mm: 'Add Note'},
							_List_fromArray(
								[
									$author$project$Ui$Button$secondary,
									$author$project$Ui$Button$onClick($author$project$Components$PatientChart$NotesCard$NewNote),
									$author$project$Ui$Button$icon($author$project$Ui$Icon$add)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Add Note')
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_fromArray(
						[$author$project$Ui$Element$pt2]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Element$custom,
							'notes-card__list',
							_List_fromArray(
								[$author$project$Ui$Element$maxH72, $author$project$Ui$Element$overflowYAuto]),
							_List_fromArray(
								[
									function () {
									var _v4 = model.kt;
									if (_v4.$ === 3) {
										var notes = _v4.a;
										var filteredNotes = A2($author$project$Components$PatientChart$NotesCard$filterNotes, model.HN, notes);
										if ($elm$core$List$isEmpty(filteredNotes)) {
											return A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$textCenter, $author$project$Ui$Element$py4]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2($author$project$Components$PatientChart$NotesCard$zeroStateText, model.ks, model.HN))
													]));
										} else {
											var total = $elm$core$List$length(filteredNotes);
											var lastIndex = total - 1;
											return A2(
												$author$project$Ui$Element$view,
												_List_Nil,
												A2(
													$elm$core$List$intersperse,
													$author$project$Ui$HorizontalRule$view(
														_List_fromArray(
															[$author$project$Ui$HorizontalRule$minimal])),
													A2(
														$elm$core$List$indexedMap,
														F2(
															function (i, n) {
																return A3(
																	$author$project$Components$PatientChart$NotesCard$viewNoteRow,
																	model,
																	{
																		US: (total > 1) && _Utils_eq(i, lastIndex)
																	},
																	n);
															}),
														filteredNotes)));
										}
									} else {
										return A2(
											$author$project$Ui$Element$view,
											_List_Nil,
											A2(
												$elm$core$List$intersperse,
												$author$project$Ui$HorizontalRule$view(
													_List_fromArray(
														[$author$project$Ui$HorizontalRule$minimal])),
												A2($elm$core$List$repeat, 3, $author$project$Components$PatientChart$NotesCard$viewNoteSkeleton)));
									}
								}()
								]))
						]))
				]))
		]);
};
var $author$project$Layouts$Patient$notesPanel = function (model) {
	return A2(
		$author$project$Ui$Grid$column,
		_List_fromArray(
			[
				$author$project$Ui$Grid$span(12),
				$author$project$Ui$Grid$spanSm(6),
				$author$project$Ui$Grid$spanMd(4)
			]),
		function () {
			var _v0 = model.eM;
			if (!_v0.$) {
				var card = _v0.a;
				return A2(
					$elm$core$List$map,
					$elm$html$Html$map($author$project$Layouts$Patient$NotesCardMsg),
					$author$project$Components$PatientChart$NotesCard$view(card));
			} else {
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Notes')
											]))
									]))
							]))
					]);
			}
		}());
};
var $author$project$Layouts$Patient$titlePanel = function (titleText) {
	return A2(
		$author$project$Ui$Grid$column,
		_List_fromArray(
			[
				$author$project$Ui$Grid$span(12),
				$author$project$Ui$Grid$spanSm(6),
				$author$project$Ui$Grid$spanMd(4)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text(titleText)
									]))
							]))
					]))
			]));
};
var $author$project$Ui$Link$ButtonInfo = 4;
var $author$project$Ui$Link$buttonInfo = $author$project$Ui$Link$Style(4);
var $author$project$Components$PatientChart$PatientInfoCard$viewEditLink = function (patientId) {
	return A3(
		$author$project$Ui$Link$route,
		$author$project$Spa$Generated$Route$Patients__PatientId_String__Edit(
			{YZ: patientId}),
		_List_fromArray(
			[
				$author$project$Ui$Link$buttonInfo,
				$author$project$Ui$Link$icon($author$project$Ui$Icon$edit)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Edit')
			]));
};
var $author$project$Ui$Button$Ghost = 13;
var $author$project$Ui$Button$ghost = $author$project$Ui$Button$styled(13);
var $author$project$Ui$Popover$MobileOverlay = {$: 6};
var $author$project$Ui$Popover$mobileOverlay = $author$project$Ui$Popover$MobileOverlay;
var $author$project$Ui$Tooltip$Nowrap = {$: 4};
var $author$project$Ui$Tooltip$nowrap = $author$project$Ui$Tooltip$Nowrap;
var $author$project$Components$AuditTrailLog$viewIconOnly = function (model) {
	return A3(
		$author$project$Components$AuditTrailLog$viewWith,
		_List_fromArray(
			[$author$project$Ui$Popover$mobileOverlay]),
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Tooltip$view,
				_List_fromArray(
					[
						$author$project$Ui$Tooltip$placement(0),
						$author$project$Ui$Tooltip$nowrap
					]),
				'See Change History',
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{mm: 'See change history'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$AuditTrailLog$Toggle),
								$author$project$Ui$Button$ghost,
								$author$project$Ui$Button$icon(
								function (_v0) {
									return $author$project$Ui$Icon$history(
										_List_fromArray(
											[$author$project$Ui$Icon$lg, $author$project$Ui$Icon$primary]));
								})
							]),
						_List_Nil)
					]))
			]),
		model);
};
var $author$project$Components$PatientChart$PatientInfoCard$viewHistoryButton = function (model) {
	var _v0 = model.iw;
	if (!_v0.$) {
		var auditTrailLog = _v0.a;
		return A2(
			$elm$html$Html$map,
			$author$project$Components$PatientChart$PatientInfoCard$AuditTrailLogMsg,
			$author$project$Components$AuditTrailLog$viewIconOnly(auditTrailLog));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Ui$Typography$BodyMd = {$: 16};
var $author$project$Ui$Typography$bodyMd = $author$project$Ui$Typography$BodyMd;
var $author$project$Components$PatientChart$PatientInfoCard$emptyValue = function (placeholder) {
	return A2(
		$author$project$Ui$Typography$text,
		_List_fromArray(
			[$author$project$Ui$Typography$bodyMd, $author$project$Ui$Typography$muted]),
		placeholder);
};
var $author$project$Components$PatientChart$PatientInfoCard$CopyClicked = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$PatientChart$PatientInfoCard$viewAddress = F2(
	function (copyLabel, address) {
		var zip = A2(
			$elm$core$Maybe$withDefault,
			'',
			$author$project$Api$Common$Address$Shared$zip(address));
		var cs = $author$project$Components$AddressDisplay$viewCityState(address);
		var cityStateZip = function () {
			var _v1 = _Utils_Tuple2(cs, zip);
			if (_v1.b === '') {
				return cs;
			} else {
				if (_v1.a === '') {
					return zip;
				} else {
					return cs + (' ' + zip);
				}
			}
		}();
		var lines = A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$withDefault,
					'',
					$author$project$Api$Common$Address$Shared$line1(address)),
					A2(
					$elm$core$Maybe$withDefault,
					'',
					$author$project$Api$Common$Address$Shared$line2(address)),
					cityStateZip
				]));
		var _v0 = $elm$core$List$reverse(lines);
		if (!_v0.b) {
			return $author$project$Components$PatientChart$PatientInfoCard$emptyValue('None');
		} else {
			var lastLine = _v0.a;
			var reversedLeading = _v0.b;
			var copyButton = A3(
				$author$project$Ui$Button$view,
				{mm: copyLabel},
				_List_fromArray(
					[
						$author$project$Ui$Button$link,
						$author$project$Ui$Button$sm,
						$author$project$Ui$Button$onClick(
						$author$project$Components$PatientChart$PatientInfoCard$CopyClicked(
							$author$project$Components$AddressDisplay$viewOneLineAddress(address))),
						$author$project$Ui$Button$icon($author$project$Ui$Icon$copy)
					]),
				_List_Nil);
			return A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$flex, $author$project$Ui$Element$flexCol]),
				_Utils_ap(
					A2(
						$elm$core$List$map,
						function (line) {
							return A2(
								$author$project$Ui$Typography$text,
								_List_fromArray(
									[$author$project$Ui$Typography$bodyMd]),
								line);
						},
						$elm$core$List$reverse(reversedLeading)),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$text,
									_List_fromArray(
										[$author$project$Ui$Typography$bodyMd]),
									lastLine),
									copyButton
								]))
						])));
		}
	});
var $author$project$Components$PatientChart$PatientInfoCard$viewRow = F2(
	function (label, content) {
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap, $author$project$Ui$Element$fullWidth]),
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Ui$Typography$span,
					_List_fromArray(
						[$author$project$Ui$Typography$hintLabel]),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						])),
				content));
	});
var $author$project$Components$PatientChart$PatientInfoCard$viewBillingAddress = function (patient) {
	return (!$author$project$Api$Provider$Patient$One$usesBillingAddress(patient)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		A2(
			$author$project$Components$PatientChart$PatientInfoCard$viewRow,
			'Billing Address',
			_List_fromArray(
				[
					function () {
					var _v0 = $author$project$Api$Provider$Patient$One$billingAddress(patient);
					if (!_v0.$) {
						var address = _v0.a;
						return A2($author$project$Components$PatientChart$PatientInfoCard$viewAddress, 'Copy billing address', address);
					} else {
						return $author$project$Components$PatientChart$PatientInfoCard$emptyValue('None');
					}
				}()
				])));
};
var $author$project$Components$PatientChart$PatientInfoCard$formatPhoneWithType = F2(
	function (maybePhone, number) {
		if (!maybePhone.$) {
			var phone = maybePhone.a;
			return number + (' (' + ($author$project$Formatters$PhoneType$toString(
				$author$project$Api$Common$Phone$Shared$type_(phone)) + ')'));
		} else {
			return number;
		}
	});
var $author$project$Components$PatientChart$PatientInfoCard$valueText = function (value) {
	return A2(
		$author$project$Ui$Typography$text,
		_List_fromArray(
			[$author$project$Ui$Typography$bodyMd]),
		value);
};
var $author$project$Components$PatientChart$PatientInfoCard$viewCopyableLine = F2(
	function (value, ariaLabel) {
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
			_List_fromArray(
				[
					$author$project$Components$PatientChart$PatientInfoCard$valueText(value),
					A3(
					$author$project$Ui$Button$view,
					{mm: ariaLabel},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$sm,
							$author$project$Ui$Button$onClick(
							$author$project$Components$PatientChart$PatientInfoCard$CopyClicked(value)),
							$author$project$Ui$Button$icon($author$project$Ui$Icon$copy)
						]),
					_List_Nil)
				]));
	});
var $author$project$Components$PatientChart$PatientInfoCard$viewEmergencyContact = function (patient) {
	var _v0 = $author$project$Api$Provider$Patient$One$emergencyContact(patient);
	if (!_v0.$) {
		var contact = _v0.a;
		return A2(
			$author$project$Components$PatientChart$PatientInfoCard$viewRow,
			'Emergency Contact',
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$map,
						$author$project$Components$PatientChart$PatientInfoCard$valueText,
						$author$project$Api$Common$EmergencyContact$Shared$name(contact)),
						A2(
						$elm$core$Maybe$map,
						function (e) {
							return A2($author$project$Components$PatientChart$PatientInfoCard$viewCopyableLine, e, 'Copy emergency contact email');
						},
						$author$project$Api$Common$EmergencyContact$Shared$email(contact)),
						A2(
						$elm$core$Maybe$map,
						function (n) {
							return A2(
								$author$project$Components$PatientChart$PatientInfoCard$viewCopyableLine,
								A2(
									$author$project$Components$PatientChart$PatientInfoCard$formatPhoneWithType,
									$author$project$Api$Common$EmergencyContact$Shared$phone(contact),
									n),
								'Copy emergency contact phone');
						},
						A2(
							$elm$core$Maybe$andThen,
							$author$project$Api$Common$Phone$Shared$number,
							$author$project$Api$Common$EmergencyContact$Shared$phone(contact)))
					])));
	} else {
		return A2(
			$author$project$Components$PatientChart$PatientInfoCard$viewRow,
			'Emergency Contact',
			_List_fromArray(
				[
					$author$project$Components$PatientChart$PatientInfoCard$emptyValue('None')
				]));
	}
};
var $author$project$Components$PatientChart$PatientInfoCard$viewJoinedPracticeDate = function (patient) {
	return A2(
		$author$project$Components$PatientChart$PatientInfoCard$viewRow,
		'Joined Practice On',
		_List_fromArray(
			[
				function () {
				var _v0 = $author$project$Api$Provider$Patient$One$joinedPracticeDate(patient);
				if (!_v0.$) {
					var date = _v0.a;
					return $author$project$Components$PatientChart$PatientInfoCard$valueText(
						A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, date));
				} else {
					return $author$project$Components$PatientChart$PatientInfoCard$emptyValue('—');
				}
			}()
			]));
};
var $author$project$Components$PatientChart$PatientInfoCard$viewLeadSource = function (patient) {
	return A2(
		$author$project$Components$PatientChart$PatientInfoCard$viewRow,
		'Lead Source',
		_List_fromArray(
			[
				function () {
				var _v0 = $author$project$Api$Provider$Patient$One$leadSource(patient);
				if (!_v0.$) {
					var leadSource = _v0.a;
					var leadSourceName = $author$project$Api$Provider$LeadSource$Shared$name(leadSource);
					if (leadSourceName === 'Other') {
						var _v1 = $author$project$Api$Provider$Patient$One$leadSourceOther(patient);
						if (!_v1.$) {
							var other = _v1.a;
							return $author$project$Components$PatientChart$PatientInfoCard$valueText(other);
						} else {
							return $author$project$Components$PatientChart$PatientInfoCard$emptyValue('Other');
						}
					} else {
						return $author$project$Components$PatientChart$PatientInfoCard$valueText(leadSourceName);
					}
				} else {
					return $author$project$Components$PatientChart$PatientInfoCard$emptyValue('None');
				}
			}()
			]));
};
var $author$project$Components$PatientChart$PatientInfoCard$viewLocation = F2(
	function (practice, patient) {
		var _v0 = _Utils_Tuple2(
			$author$project$Api$Practice$trackPatientsByLocation(practice),
			$author$project$Api$Provider$Patient$One$location(patient));
		if (_v0.a && (!_v0.b.$)) {
			var location = _v0.b.a;
			return $elm$core$Maybe$Just(
				A2(
					$author$project$Components$PatientChart$PatientInfoCard$viewRow,
					'Location',
					_List_fromArray(
						[
							$author$project$Components$PatientChart$PatientInfoCard$valueText(
							$author$project$Api$Provider$Location$Shared$name(location))
						])));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$PatientChart$PatientInfoCard$viewPreferredLanguage = F2(
	function (practice, patient) {
		return A2($author$project$Api$Practice$featureEnabled, 10, practice) ? $elm$core$Maybe$Just(
			A2(
				$author$project$Components$PatientChart$PatientInfoCard$viewRow,
				'Preferred Language',
				_List_fromArray(
					[
						$author$project$Components$PatientChart$PatientInfoCard$valueText(
						$author$project$Language$toLabel(
							$author$project$Api$Provider$Patient$One$preferredLanguage(patient)))
					]))) : $elm$core$Maybe$Nothing;
	});
var $author$project$Components$PatientChart$PatientInfoCard$viewPrimaryAddress = function (patient) {
	return A2(
		$author$project$Components$PatientChart$PatientInfoCard$viewRow,
		'Primary Address',
		_List_fromArray(
			[
				function () {
				var _v0 = $author$project$Api$Provider$Patient$One$address(patient);
				if (!_v0.$) {
					var address = _v0.a;
					return A2($author$project$Components$PatientChart$PatientInfoCard$viewAddress, 'Copy primary address', address);
				} else {
					return $author$project$Components$PatientChart$PatientInfoCard$emptyValue('None');
				}
			}()
			]));
};
var $author$project$Components$PatientChart$PatientInfoCard$viewPrimaryCareClinic = F2(
	function (practice, patient) {
		var syncByAffiliation = A2(
			$elm$core$Maybe$map,
			$author$project$Api$Network$Shared$syncByAffiliation,
			$author$project$Api$Practice$network(practice));
		var affiliationName = A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Maybe$Nothing,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$Affiliate$AffiliateMin$name,
				$author$project$Api$Provider$Patient$One$assignedAffiliation(patient)));
		var _v0 = _Utils_Tuple2(affiliationName, syncByAffiliation);
		if (((!_v0.a.$) && (!_v0.b.$)) && _v0.b.a) {
			var name = _v0.a.a;
			return $elm$core$Maybe$Just(
				A2(
					$author$project$Components$PatientChart$PatientInfoCard$viewRow,
					'Primary Care Clinic',
					_List_fromArray(
						[
							$author$project$Components$PatientChart$PatientInfoCard$valueText(name)
						])));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$PatientChart$PatientInfoCard$viewProvider = function (patient) {
	return A2(
		$author$project$Components$PatientChart$PatientInfoCard$viewRow,
		'Provider',
		_List_fromArray(
			[
				function () {
				var _v0 = $author$project$Api$Provider$Patient$One$practitioner(patient);
				if (!_v0.$) {
					var practitioner = _v0.a;
					return $author$project$Components$PatientChart$PatientInfoCard$valueText(
						$author$project$Api$Provider$Practitioner$Shared$name(practitioner));
				} else {
					return $author$project$Components$PatientChart$PatientInfoCard$emptyValue('None');
				}
			}()
			]));
};
var $author$project$Components$PatientChart$PatientInfoCard$ToggleSsn = {$: 0};
var $author$project$Components$PatientChart$PatientInfoCard$viewSsnToggle = function (model) {
	var _v0 = model.aX ? _Utils_Tuple2($author$project$Ui$Icon$visibilityOff, 'Hide SSN') : _Utils_Tuple2($author$project$Ui$Icon$visibility, 'Show SSN');
	var iconFn = _v0.a;
	var ariaLabel = _v0.b;
	return A3(
		$author$project$Ui$Button$view,
		{mm: ariaLabel},
		_List_fromArray(
			[
				$author$project$Ui$Button$link,
				$author$project$Ui$Button$sm,
				$author$project$Ui$Button$onClick($author$project$Components$PatientChart$PatientInfoCard$ToggleSsn),
				$author$project$Ui$Button$loading(
				_Utils_eq(model.aS, $author$project$Api$Data$Loading)),
				$author$project$Ui$Button$icon(
				function (_v1) {
					return iconFn(_List_Nil);
				})
			]),
		_List_Nil);
};
var $author$project$Components$PatientChart$PatientInfoCard$viewSsn = F4(
	function (shared, practice, patient, model) {
		if (!$author$project$Api$Practice$ssnEnabled(practice)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var maskedSsn = A2(
				$elm$core$Maybe$andThen,
				$author$project$Api$Common$SocialSecurityNumber$Masked$maskedNumber,
				$author$project$Api$Provider$Patient$One$ssn(patient));
			if (maskedSsn.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var masked = maskedSsn.a;
				var shownValue = function () {
					if (model.aX) {
						var _v2 = model.aS;
						if (_v2.$ === 3) {
							var ssnData = _v2.a;
							return A2(
								$elm$core$Maybe$withDefault,
								masked,
								$author$project$Api$Provider$SocialSecurityNumber$One$formattedNumber(ssnData));
						} else {
							return masked;
						}
					} else {
						return masked;
					}
				}();
				var hasAdminAccess = function () {
					var _v1 = shared.aa4;
					if (_v1.$ === 3) {
						var session = _v1.a;
						return A3($author$project$Permission$canGoTo, session, shared.ahK, 0);
					} else {
						return false;
					}
				}();
				return $elm$core$Maybe$Just(
					A2(
						$author$project$Components$PatientChart$PatientInfoCard$viewRow,
						'SSN',
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$text,
										_List_fromArray(
											[
												$author$project$Ui$Typography$phi(true),
												$author$project$Ui$Typography$bodyMd
											]),
										shownValue),
										hasAdminAccess ? $author$project$Components$PatientChart$PatientInfoCard$viewSsnToggle(model) : $author$project$Utils$Html$empty
									]))
							])));
			}
		}
	});
var $author$project$Components$PatientChart$PatientInfoCard$viewTobaccoUse = F2(
	function (practice, patient) {
		return A2($author$project$Api$Practice$featureEnabled, 2, practice) ? $elm$core$Maybe$Just(
			A2(
				$author$project$Components$PatientChart$PatientInfoCard$viewRow,
				'Tobacco Use',
				_List_fromArray(
					[
						function () {
						var _v0 = $author$project$Api$Provider$Patient$One$usesTobacco(patient);
						if (!_v0.$) {
							if (_v0.a) {
								return $author$project$Components$PatientChart$PatientInfoCard$valueText('Uses tobacco');
							} else {
								return $author$project$Components$PatientChart$PatientInfoCard$valueText('Does not use tobacco');
							}
						} else {
							return $author$project$Components$PatientChart$PatientInfoCard$emptyValue('Unknown');
						}
					}()
					]))) : $elm$core$Maybe$Nothing;
	});
var $author$project$Components$PatientChart$PatientInfoCard$viewRows = F4(
	function (shared, patient, practice, _v0) {
		var model = _v0;
		var rows = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					$author$project$Components$PatientChart$PatientInfoCard$viewProvider(patient)),
					$elm$core$Maybe$Just(
					$author$project$Components$PatientChart$PatientInfoCard$viewEmergencyContact(patient)),
					A2($author$project$Components$PatientChart$PatientInfoCard$viewPreferredLanguage, practice, patient),
					A4($author$project$Components$PatientChart$PatientInfoCard$viewSsn, shared, practice, patient, model),
					$elm$core$Maybe$Just(
					$author$project$Components$PatientChart$PatientInfoCard$viewLeadSource(patient)),
					$elm$core$Maybe$Just(
					$author$project$Components$PatientChart$PatientInfoCard$viewPrimaryAddress(patient)),
					$author$project$Components$PatientChart$PatientInfoCard$viewBillingAddress(patient),
					$elm$core$Maybe$Just(
					$author$project$Components$PatientChart$PatientInfoCard$viewJoinedPracticeDate(patient)),
					A2($author$project$Components$PatientChart$PatientInfoCard$viewLocation, practice, patient),
					A2($author$project$Components$PatientChart$PatientInfoCard$viewPrimaryCareClinic, practice, patient),
					A2($author$project$Components$PatientChart$PatientInfoCard$viewTobaccoUse, practice, patient)
				]));
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$fullWidth]),
			A2(
				$elm$core$List$intersperse,
				$author$project$Ui$HorizontalRule$view(
					_List_fromArray(
						[$author$project$Ui$HorizontalRule$thin])),
				rows));
	});
var $author$project$Components$PatientChart$PatientInfoCard$view = F4(
	function (shared, patient, practice, _v0) {
		var model = _v0;
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_fromArray(
							[$author$project$Ui$Element$pb0]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$fullWidth]),
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Patient Info')
											])),
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
										_List_fromArray(
											[
												$author$project$Components$PatientChart$PatientInfoCard$viewHistoryButton(model),
												$author$project$Components$PatientChart$PatientInfoCard$viewEditLink(model.YZ)
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_fromArray(
							[$author$project$Ui$Element$pt2]),
						_List_fromArray(
							[
								A4($author$project$Components$PatientChart$PatientInfoCard$viewRows, shared, patient, practice, model)
							]))
					]))
			]);
	});
var $author$project$Layouts$Patient$patientInfoPanel = F3(
	function (shared, patient, model) {
		var _v0 = shared.ZV;
		if (_v0.$ === 3) {
			var practice = _v0.a;
			return A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$span(12),
						$author$project$Ui$Grid$spanSm(6),
						$author$project$Ui$Grid$spanMd(4)
					]),
				A2(
					$elm$core$List$map,
					$elm$html$Html$map($author$project$Layouts$Patient$PatientInfoCardMsg),
					A4($author$project$Components$PatientChart$PatientInfoCard$view, shared, patient, practice, model.eO)));
		} else {
			return $author$project$Layouts$Patient$titlePanel('Patient Info');
		}
	});
var $author$project$Components$PaymentMethodsCard$OpenChangeHistory = {$: 7};
var $author$project$Components$PaymentMethodsCard$OpenMovePayments = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$PaymentMethodsCard$SendRequestForPaymentInfo = {$: 9};
var $author$project$Ui$Popover$alignRight = $author$project$Ui$Popover$Attrs(
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('popover--align-right')
		]));
var $author$project$Components$PaymentMethodsCard$headerMenu = F2(
	function (patient, model) {
		var kebabTrigger = A3(
			$author$project$Ui$Button$view,
			{mm: 'More payment method actions'},
			_List_fromArray(
				[
					$author$project$Ui$Button$link,
					$author$project$Ui$Button$icon($author$project$Ui$Icon$moreVert),
					$author$project$Ui$Button$ariaHaspopup('menu'),
					$author$project$Ui$Button$ariaExpanded(
					$author$project$Ui$FlyoutMenu$isOpen(model.nN))
				]),
			_List_Nil);
		var changeHistoryPopover = function () {
			var _v1 = model.iw;
			if (!_v1.$) {
				var auditTrailLog = _v1.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Components$PaymentMethodsCard$AuditTrailLogMsg,
					A3(
						$author$project$Components$AuditTrailLog$viewWith,
						_List_fromArray(
							[$author$project$Ui$Popover$alignRight, $author$project$Ui$Popover$mobileOverlay]),
						_List_Nil,
						auditTrailLog));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}();
		var canMigrate = function () {
			var _v0 = model.kA;
			if (_v0.$ === 3) {
				var migratable = _v0.a;
				return migratable;
			} else {
				return false;
			}
		}();
		var menuItems = $elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						$author$project$Ui$FlyoutMenu$menuItem(
						{ep: false, ahO: $elm$core$Maybe$Nothing, aih: 'See Change History', IS: $author$project$Components$PaymentMethodsCard$OpenChangeHistory})
					]),
					canMigrate ? _List_fromArray(
					[
						$author$project$Ui$FlyoutMenu$menuItem(
						{
							ep: false,
							ahO: $elm$core$Maybe$Nothing,
							aih: 'Move All Payment Methods to Another Patient',
							IS: $author$project$Components$PaymentMethodsCard$OpenMovePayments(patient)
						})
					]) : _List_Nil,
					_List_fromArray(
					[
						$author$project$Ui$FlyoutMenu$menuItem(
						{
							ep: model.hA,
							ahO: $elm$core$Maybe$Just(
								$author$project$Ui$Icon$send(_List_Nil)),
							aih: 'Send Request for Payment Info',
							IS: $author$project$Components$PaymentMethodsCard$SendRequestForPaymentInfo
						})
					])
				]));
		var flyout = A4(
			$author$project$Ui$FlyoutMenu$view,
			_List_fromArray(
				[
					$author$project$Ui$FlyoutMenu$direction(2),
					$author$project$Ui$FlyoutMenu$mobileOverlay
				]),
			_List_fromArray(
				[
					$author$project$Ui$FlyoutMenu$body(menuItems)
				]),
			kebabTrigger,
			model.nN);
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
			_List_fromArray(
				[changeHistoryPopover, flyout]));
	});
var $author$project$Components$CreatePaymentMethodModal$openMsg = $author$project$Components$CreatePaymentMethodModal$OpenModal;
var $author$project$Components$PaymentMethodsCard$isFailure = function (data) {
	if (data.$ === 2) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$PaymentMethodsCard$attributionLine = F2(
	function (timeFormatter, source) {
		var _v0 = $author$project$Api$Source$createdVia(source);
		if (!_v0.$) {
			var createdVia = _v0.a;
			var on = A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function (t) {
						return ' on ' + A2(timeFormatter, 5, t);
					},
					$author$project$Api$Source$createdAt(source)));
			var by = A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function (name) {
						return ' by ' + name;
					},
					$author$project$Api$Source$createdByName(source)));
			return A2(
				$author$project$Ui$Typography$text,
				_List_fromArray(
					[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
				_Utils_ap(
					createdVia,
					_Utils_ap(by, on)));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$PaymentMethodsCard$StartDelete = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$PaymentMethodsCard$StartEdit = function (a) {
	return {$: 11, a: a};
};
var $author$project$Ui$Element$HoverReveal = {$: 26};
var $author$project$Ui$Element$hoverReveal = $author$project$Ui$Element$HoverReveal;
var $author$project$Components$PaymentMethodsCard$rowActions = F2(
	function (ctx, source) {
		var loading = A2(
			$elm$core$Set$member,
			$author$project$Api$Source$id(source),
			ctx.J);
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$hoverReveal, $author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{mm: 'Edit payment method'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$icon($author$project$Ui$Icon$editOutline),
							$author$project$Ui$Button$onClick(
							$author$project$Components$PaymentMethodsCard$StartEdit(source)),
							$author$project$Ui$Button$disabled(loading)
						]),
					_List_Nil),
					A3(
					$author$project$Ui$Button$view,
					{mm: 'Delete payment method'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$icon($author$project$Ui$Icon$deleteOutline),
							$author$project$Ui$Button$onClick(
							$author$project$Components$PaymentMethodsCard$StartDelete(source)),
							$author$project$Ui$Button$loading(loading)
						]),
					_List_Nil)
				]));
	});
var $author$project$Components$PaymentMethodsCard$attributionRow = F2(
	function (ctx, source) {
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
			_List_fromArray(
				[
					A2($author$project$Components$PaymentMethodsCard$attributionLine, ctx.J7, source),
					A2($author$project$Components$PaymentMethodsCard$rowActions, ctx, source)
				]));
	});
var $author$project$Components$PaymentMethodsCard$detailsLine = function (source) {
	var zip = A2(
		$elm$core$Maybe$map,
		function (z) {
			return 'ZIP code ' + z;
		},
		$author$project$Api$Source$zip(source));
	var expires = function () {
		var _v1 = _Utils_Tuple2(
			$author$project$Api$Source$expMonth(source),
			$author$project$Api$Source$expYear(source));
		if ((!_v1.a.$) && (!_v1.b.$)) {
			var m = _v1.a.a;
			var y = _v1.b.a;
			return $elm$core$Maybe$Just(
				'Expires ' + ($elm$core$String$fromInt(m) + ('/' + $elm$core$String$fromInt(y))));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	var parts = A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[expires, zip]));
	if (!parts.b) {
		return $author$project$Utils$Html$empty;
	} else {
		return A2(
			$author$project$Ui$Typography$text,
			_List_fromArray(
				[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
			A2($elm$core$String$join, ', ', parts));
	}
};
var $author$project$Ui$Element$HoverGroup = {$: 25};
var $author$project$Ui$Element$hoverGroup = $author$project$Ui$Element$HoverGroup;
var $author$project$Components$PaymentMethodsCard$nonEmpty = function (s) {
	return $elm$core$String$isEmpty(
		$elm$core$String$trim(s)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(s);
};
var $author$project$Components$PaymentMethodsCard$labelLine = function (source) {
	var _v0 = A2(
		$elm$core$Maybe$andThen,
		$author$project$Components$PaymentMethodsCard$nonEmpty,
		$author$project$Api$Source$label(source));
	if (!_v0.$) {
		var label = _v0.a;
		return A2(
			$author$project$Ui$Typography$text,
			_List_fromArray(
				[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small, $author$project$Ui$Typography$italic]),
			'“' + (label + '”'));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Ui$Element$MinW0 = {$: 27};
var $author$project$Ui$Element$minW0 = $author$project$Ui$Element$MinW0;
var $author$project$Components$PaymentMethodsCard$sourceIcon = function (source) {
	var icon = function () {
		if (source.$ === 1) {
			return $author$project$Ui$Icon$bank(
				_List_fromArray(
					[$author$project$Ui$Icon$base]));
		} else {
			return $author$project$Ui$Icon$card(
				_List_fromArray(
					[$author$project$Ui$Icon$base]));
		}
	}();
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$textMuted]),
		_List_fromArray(
			[icon]));
};
var $author$project$Components$PaymentMethodsCard$badges = function (source) {
	var defaultBadge = $author$project$Api$Source$default(source) ? _List_fromArray(
		[
			A2(
			$author$project$Ui$Badge$fromString,
			_List_fromArray(
				[$author$project$Ui$Badge$primary]),
			'Default')
		]) : _List_Nil;
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
		A2(
			$elm$core$List$cons,
			A2(
				$author$project$Ui$Badge$fromString,
				_List_Nil,
				A2(
					$elm$core$Maybe$withDefault,
					'N/A',
					$author$project$Api$Source$status(source))),
			defaultBadge));
};
var $author$project$Components$PaymentMethodsCard$titleLine = function (source) {
	var name = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$author$project$Formatters$String$titleize,
			A2(
				$elm$core$Maybe$andThen,
				$author$project$Components$PaymentMethodsCard$nonEmpty,
				$author$project$Api$Source$name(source))));
	var lastFour = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function (lf) {
				return ' *' + lf;
			},
			$author$project$Api$Source$lastFour(source)));
	var funding = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function (f) {
				return ' (' + (f + ')');
			},
			$author$project$Api$Source$funding(source)));
	return A2(
		$author$project$Ui$Typography$text,
		_List_Nil,
		_Utils_ap(
			name,
			_Utils_ap(lastFour, funding)));
};
var $author$project$Components$PaymentMethodsCard$titleRow = function (source) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
		_List_fromArray(
			[
				$author$project$Components$PaymentMethodsCard$titleLine(source),
				$author$project$Components$PaymentMethodsCard$badges(source)
			]));
};
var $author$project$Components$PaymentMethodsCard$viewRow = F2(
	function (ctx, source) {
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$hoverGroup, $author$project$Ui$Element$flex, $author$project$Ui$Element$gap4, $author$project$Ui$Element$py4, $author$project$Ui$Element$itemsStart]),
			_List_fromArray(
				[
					$author$project$Components$PaymentMethodsCard$sourceIcon(source),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$flexAuto, $author$project$Ui$Element$minW0, $author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap]),
					_List_fromArray(
						[
							$author$project$Components$PaymentMethodsCard$titleRow(source),
							$author$project$Components$PaymentMethodsCard$detailsLine(source),
							$author$project$Components$PaymentMethodsCard$labelLine(source),
							A2($author$project$Components$PaymentMethodsCard$attributionRow, ctx, source)
						]))
				]));
	});
var $author$project$Components$PaymentMethodsCard$ToggleAutopay = function (a) {
	return {$: 21, a: a};
};
var $author$project$Ui$Tooltip$AlignStart = {$: 5};
var $author$project$Ui$Tooltip$alignStart = $author$project$Ui$Tooltip$AlignStart;
var $author$project$Components$PaymentMethodsCard$viewToggleLabel = F2(
	function (label, maybeTooltip) {
		if (!maybeTooltip.$) {
			var tooltip = maybeTooltip.a;
			return A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$gap, $author$project$Ui$Element$itemsCenter]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(label)
							])),
						A3(
						$author$project$Ui$Tooltip$view,
						_List_fromArray(
							[
								$author$project$Ui$Tooltip$placement(1),
								$author$project$Ui$Tooltip$wide,
								$author$project$Ui$Tooltip$alignStart
							]),
						tooltip,
						_List_fromArray(
							[
								$author$project$Ui$Icon$help(
								_List_fromArray(
									[$author$project$Ui$Icon$primary]))
							]))
					]));
		} else {
			return A2(
				$author$project$Ui$Typography$label,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(label)
					]));
		}
	});
var $author$project$Components$PaymentMethodsCard$viewToggleRow = function (_v0) {
	var label = _v0.aih;
	var tooltip = _v0.FS;
	var description = _v0.Qr;
	var isOn = _v0.Il;
	var onChange = _v0.ajd;
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$gap4, $author$project$Ui$Element$py4, $author$project$Ui$Element$itemsStart, $author$project$Ui$Element$spaceBetween]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$flexAuto, $author$project$Ui$Element$minW0, $author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap]),
				_List_fromArray(
					[
						A2($author$project$Components$PaymentMethodsCard$viewToggleLabel, label, tooltip),
						A2(
						$author$project$Ui$Typography$text,
						_List_fromArray(
							[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
						description)
					])),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$shrinkNone]),
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$view(
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$on(isOn),
								$author$project$Ui$ToggleSwitch$onChange(onChange)
							]))
					]))
			]));
};
var $author$project$Components$PaymentMethodsCard$viewAutopayToggle = F2(
	function (patient, practice) {
		var tooltip = $author$project$Api$Practice$allowMultipleRetailMemberships(practice) ? $elm$core$Maybe$Just('To set a different payment method for a specific membership, update it from the Memberships tab under Pricing.') : $elm$core$Maybe$Nothing;
		var _v0 = $author$project$Api$Provider$Patient$One$autopay(patient) ? _Utils_Tuple2('Automated payments collection will be attempted.', 'Disable Autopay to stop automated payment collection on upcoming invoices.') : _Utils_Tuple2('No automated payments collection will be attempted.', 'Enable Autopay to start automated payment collection on upcoming invoices.');
		var current = _v0.a;
		var action = _v0.b;
		return $elm$core$Maybe$Just(
			$author$project$Components$PaymentMethodsCard$viewToggleRow(
				{
					Qr: current + (' ' + action),
					Il: $author$project$Api$Provider$Patient$One$autopay(patient),
					aih: 'Autopay',
					ajd: $author$project$Components$PaymentMethodsCard$ToggleAutopay,
					FS: tooltip
				}));
	});
var $author$project$Components$PaymentMethodsCard$ToggleExemptFromCreditCardFees = function (a) {
	return {$: 22, a: a};
};
var $author$project$Api$Practice$chargePatientsCreditCardFees = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$chargePatientsCreditCardFees(practice_);
	} else {
		return false;
	}
};
var $author$project$Components$PaymentMethodsCard$viewExemptToggle = F2(
	function (patient, practice) {
		return $author$project$Api$Practice$chargePatientsCreditCardFees(practice) ? $elm$core$Maybe$Just(
			$author$project$Components$PaymentMethodsCard$viewToggleRow(
				{
					Qr: 'When enabled, this patient will not be charged credit card fees, even if they pay with a credit card.',
					Il: $author$project$Api$Provider$Patient$One$exemptFromCreditCardFees(patient),
					aih: 'Exclude from credit card surcharge',
					ajd: $author$project$Components$PaymentMethodsCard$ToggleExemptFromCreditCardFees,
					FS: $elm$core$Maybe$Nothing
				})) : $elm$core$Maybe$Nothing;
	});
var $author$project$Components$PaymentMethodsCard$viewToggles = F2(
	function (patient, practice) {
		return A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2($author$project$Components$PaymentMethodsCard$viewExemptToggle, patient, practice),
					A2($author$project$Components$PaymentMethodsCard$viewAutopayToggle, patient, practice)
				]));
	});
var $author$project$Components$PaymentMethodsCard$viewZeroState = F2(
	function (addMethodClickOption, _v0) {
		var model = _v0;
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap4, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$py4]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$text,
					_List_fromArray(
						[$author$project$Ui$Typography$muted]),
					'This patient has no payment sources set up.'),
					A3(
					$author$project$Ui$Button$view,
					{mm: 'Add a Method'},
					_List_fromArray(
						[$author$project$Ui$Button$link, addMethodClickOption]),
					_List_fromArray(
						[
							$elm$html$Html$text('Add a Method')
						])),
					A2(
					$author$project$Ui$Typography$text,
					_List_fromArray(
						[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
					'or'),
					A3(
					$author$project$Ui$Button$view,
					{mm: 'Send Request for Payment Info'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$icon($author$project$Ui$Icon$send),
							$author$project$Ui$Button$onClick($author$project$Components$PaymentMethodsCard$SendRequestForPaymentInfo),
							$author$project$Ui$Button$loading(model.hA)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Send Request for Payment Info')
						]))
				]));
	});
var $author$project$Components$PaymentMethodsCard$viewBody = F5(
	function (shared, patient, practice, addMethodClickOption, _v0) {
		var model = _v0;
		var rows = function () {
			var _v1 = _Utils_Tuple2(model.rC, model.rs);
			if ((_v1.a.$ === 3) && (_v1.b.$ === 3)) {
				var _v2 = _v1.a;
				var cards = _v2.a;
				var _v3 = _v1.b;
				var bankAccounts = _v3.a;
				var sources = $elm$core$List$reverse(
					A2(
						$elm$core$List$sortBy,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Api$Source$createdAt,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Maybe$map($elm$time$Time$posixToMillis),
								$elm$core$Maybe$withDefault(0))),
						_Utils_ap(
							A2($elm$core$List$map, $author$project$Api$Source$Card, cards),
							A2($elm$core$List$map, $author$project$Api$Source$BankAccount, bankAccounts))));
				if ($elm$core$List$isEmpty(sources)) {
					return _List_fromArray(
						[
							A2($author$project$Components$PaymentMethodsCard$viewZeroState, addMethodClickOption, model)
						]);
				} else {
					var rowContext = {J7: shared.J7, J: model.J};
					return A2(
						$elm$core$List$map,
						$author$project$Components$PaymentMethodsCard$viewRow(rowContext),
						sources);
				}
			} else {
				return ($author$project$Components$PaymentMethodsCard$isFailure(model.rC) || $author$project$Components$PaymentMethodsCard$isFailure(model.rs)) ? _List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$py4]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$text,
								_List_fromArray(
									[$author$project$Ui$Typography$muted]),
								'Could not load payment methods.')
							]))
					]) : A2(
					$elm$core$List$repeat,
					2,
					A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$py4]),
						_List_fromArray(
							[$author$project$Components$PaymentSourceDisplayer$skeleton])));
			}
		}();
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$divideY]),
			_Utils_ap(
				rows,
				A2($author$project$Components$PaymentMethodsCard$viewToggles, patient, practice)));
	});
var $author$project$Components$PaymentMethodsCard$viewDeleteConfirm = function (model) {
	var _v0 = model.gc;
	if (!_v0.$) {
		var source = _v0.a;
		return A2(
			$author$project$Components$HiConfirm$modal,
			$author$project$Components$PaymentMethodsCard$DeleteConfirmClosed(source),
			_List_fromArray(
				[
					$author$project$Components$HiConfirm$verb('delete'),
					$author$project$Components$HiConfirm$noun(
					$author$project$Api$Source$noun(source)),
					$author$project$Components$HiConfirm$detail(
					$author$project$Api$Source$detail(source))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$PaymentMethodsCard$FormUpdated = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$PaymentMethodsCard$Label = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$PaymentMethodsCard$SaveEdit = {$: 15};
var $author$project$Components$PaymentMethodsCard$ExpMonth = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$PaymentMethodsCard$ExpYear = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$PaymentMethodsCard$Zip = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$PaymentMethodsCard$monthOptions = A2(
	$elm$core$List$map,
	function (month) {
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(
				$elm$core$String$fromInt(month)),
			$elm$core$String$fromInt(month));
	},
	A2($elm$core$List$range, 1, 12));
var $author$project$Components$PaymentMethodsCard$yearOptions = function (currentDate) {
	var fromYear = $justinmimbs$date$Date$year(currentDate);
	var toYear = fromYear + 10;
	return A2(
		$elm$core$List$map,
		function (year) {
			return A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(
					$elm$core$String$fromInt(year)),
				$elm$core$String$fromInt(year));
		},
		A2($elm$core$List$range, fromYear, toYear));
};
var $author$project$Components$PaymentMethodsCard$viewCardFields = F3(
	function (currentDate, form, cardFields) {
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpan(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Expiration Date'),
						$author$project$Ui$Form$Group$required(true)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Grid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanSm(6)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Select$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Select$value(
												A2($elm$core$Maybe$map, $elm$core$String$fromInt, cardFields.ag3)),
												$author$project$Ui$Form$Select$onChange(
												A2($elm$core$Basics$composeL, $author$project$Components$PaymentMethodsCard$FormUpdated, $author$project$Components$PaymentMethodsCard$ExpMonth)),
												$author$project$Ui$Form$Select$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, 1, form))
											]),
										$author$project$Components$PaymentMethodsCard$monthOptions)
									])),
								A2(
								$author$project$Ui$Grid$column,
								_List_fromArray(
									[
										$author$project$Ui$Grid$spanSm(6)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Select$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Select$value(
												A2($elm$core$Maybe$map, $elm$core$String$fromInt, cardFields.ag4)),
												$author$project$Ui$Form$Select$onChange(
												A2($elm$core$Basics$composeL, $author$project$Components$PaymentMethodsCard$FormUpdated, $author$project$Components$PaymentMethodsCard$ExpYear)),
												$author$project$Ui$Form$Select$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, 1, form))
											]),
										$author$project$Components$PaymentMethodsCard$yearOptions(currentDate))
									]))
							])),
						$author$project$Utils$FormErrors$view(
						A2($author$project$Utils$Form$validationErrors, 1, form))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpan(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Zip Code'),
						$author$project$Ui$Form$Group$required(true)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(cardFields.vv),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Components$PaymentMethodsCard$FormUpdated, $author$project$Components$PaymentMethodsCard$Zip)),
								$author$project$Ui$Form$Input$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 0, form))
							])),
						$author$project$Utils$FormErrors$view(
						A2($author$project$Utils$Form$validationErrors, 0, form))
					]))
			]);
	});
var $author$project$Components$PaymentMethodsCard$ToggleMakeDefault = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$PaymentMethodsCard$viewMakeDefaultGroup = function (editing) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('Make Default')
			]),
		_List_fromArray(
			[
				$author$project$Api$Source$default(editing.JQ) ? A2(
				$author$project$Ui$Typography$text,
				_List_fromArray(
					[$author$project$Ui$Typography$muted]),
				'Already the default payment method.') : $author$project$Ui$ToggleSwitch$view(
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$on(editing.s5),
						$author$project$Ui$ToggleSwitch$onChange($author$project$Components$PaymentMethodsCard$ToggleMakeDefault)
					]))
			]));
};
var $author$project$Components$PaymentMethodsCard$viewEditModal = function (model) {
	var _v0 = model.x;
	if (!_v0.$) {
		var editing = _v0.a;
		var modalConfig = {
			Tq: $elm$core$Maybe$Nothing,
			aih: 'Payment Source',
			V8: _Utils_eq(editing.k9, $author$project$Api$Data$Loading),
			WG: $elm$core$Maybe$Just(''),
			WH: $elm$core$Maybe$Nothing,
			Yd: $author$project$Components$PaymentMethodsCard$CancelEdit,
			Yf: $elm$core$Basics$always($author$project$Components$PaymentMethodsCard$SaveEdit)
		};
		var fields = $author$project$Utils$Form$fields(editing.SD);
		var cardFieldGroups = function () {
			var _v1 = fields.GS;
			if (_v1.$ === 1) {
				return _List_Nil;
			} else {
				var cardFields = _v1.a;
				return A3($author$project$Components$PaymentMethodsCard$viewCardFields, model.dd, editing.SD, cardFields);
			}
		}();
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Description')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$placeholder('HSA card for incidental charges'),
									$author$project$Ui$Form$Input$value(
									A2($elm$core$Maybe$withDefault, '', fields.aih)),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$PaymentMethodsCard$FormUpdated, $author$project$Components$PaymentMethodsCard$Label))
								]))
						])),
				_Utils_ap(
					cardFieldGroups,
					_List_fromArray(
						[
							$author$project$Components$PaymentMethodsCard$viewMakeDefaultGroup(editing)
						]))));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$PaymentMethodsCard$view = F4(
	function (shared, patient, practice, _v0) {
		var model = _v0;
		var addMethodClickOption = function () {
			var _v1 = shared.aa4;
			if (_v1.$ === 3) {
				var session = _v1.a;
				var openOptions = {
					xx: $author$project$Components$PaymentMethodsCard$patientPath(model.YZ),
					sF: shared.sF,
					jY: $elm$core$Maybe$Nothing,
					Ij: $author$project$Shared$isHintAdmin(shared),
					YD: $author$project$Components$CreatePaymentMethodModal$Patient(patient),
					ZV: practice,
					t9: shared.t9,
					aa4: session,
					J7: shared.J7,
					vl: true
				};
				return $author$project$Ui$Button$onClick(
					$author$project$Components$PaymentMethodsCard$CreatePaymentMethodModalMsg(
						$author$project$Components$CreatePaymentMethodModal$openMsg(openOptions)));
			} else {
				return $author$project$Ui$Button$disabled(true);
			}
		}();
		var addMethodButton = A3(
			$author$project$Ui$Button$view,
			{mm: 'Add Method'},
			_List_fromArray(
				[
					$author$project$Ui$Button$secondary,
					$author$project$Ui$Button$icon($author$project$Ui$Icon$add),
					addMethodClickOption
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Add Method')
				]));
		var headerActions = A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$gap4, $author$project$Ui$Element$itemsCenter]),
			_List_fromArray(
				[
					A2($author$project$Components$PaymentMethodsCard$headerMenu, patient, model),
					addMethodButton
				]));
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_fromArray(
							[$author$project$Ui$Element$pb0]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Payment Methods')
											])),
										headerActions
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_fromArray(
							[$author$project$Ui$Element$pt2]),
						_List_fromArray(
							[
								A5($author$project$Components$PaymentMethodsCard$viewBody, shared, patient, practice, addMethodClickOption, model)
							]))
					])),
				A2(
				$elm$html$Html$map,
				$author$project$Components$PaymentMethodsCard$CreatePaymentMethodModalMsg,
				$author$project$Components$CreatePaymentMethodModal$modal(model.i_)),
				A2(
				$elm$html$Html$map,
				$author$project$Components$PaymentMethodsCard$MovePaymentMethodsModalMsg,
				$author$project$Components$MovePaymentMethodsModal$modal(model.gY)),
				$author$project$Components$PaymentMethodsCard$viewEditModal(model),
				$author$project$Components$PaymentMethodsCard$viewDeleteConfirm(model)
			]);
	});
var $author$project$Layouts$Patient$paymentMethodsPanel = F3(
	function (shared, patient, model) {
		var _v0 = shared.ZV;
		if (_v0.$ === 3) {
			var practice = _v0.a;
			return A2(
				$author$project$Ui$Grid$column,
				_List_fromArray(
					[
						$author$project$Ui$Grid$span(12),
						$author$project$Ui$Grid$spanSm(6),
						$author$project$Ui$Grid$spanMd(4)
					]),
				A2(
					$elm$core$List$map,
					$elm$html$Html$map($author$project$Layouts$Patient$PaymentMethodsCardMsg),
					A4($author$project$Components$PaymentMethodsCard$view, shared, patient, practice, model.eQ)));
		} else {
			return $author$project$Layouts$Patient$titlePanel('Payment Methods');
		}
	});
var $author$project$Layouts$Patient$basePanels = F3(
	function (shared, patient, model) {
		return _List_fromArray(
			[
				A3($author$project$Layouts$Patient$patientInfoPanel, shared, patient, model),
				$author$project$Layouts$Patient$titlePanel('Invoices'),
				A3($author$project$Layouts$Patient$paymentMethodsPanel, shared, patient, model),
				$author$project$Layouts$Patient$notesPanel(model),
				$author$project$Layouts$Patient$titlePanel('Memberships & Packages'),
				$author$project$Layouts$Patient$titlePanel('Engagement')
			]);
	});
var $author$project$Ui$Element$pb4 = $author$project$Ui$Element$Padding('pb-4');
var $author$project$Layouts$Patient$hasSponsoredMembership = function (data) {
	if (data.$ === 3) {
		var mps = data.a;
		return A2(
			$elm$core$List$any,
			function (mp) {
				return _Utils_eq(
					$author$project$Api$Provider$MembershipPatient$ForPatientOne$isSponsored(mp),
					$elm$core$Maybe$Just(true));
			},
			mps);
	} else {
		return false;
	}
};
var $author$project$Layouts$Patient$sponsorshipPanel = function (data) {
	return $author$project$Layouts$Patient$hasSponsoredMembership(data) ? _List_fromArray(
		[
			$author$project$Layouts$Patient$titlePanel('Sponsorships')
		]) : _List_Nil;
};
var $author$project$Layouts$Patient$viewCardGrid = F3(
	function (shared, patient, model) {
		return A3(
			$author$project$Ui$Element$custom,
			'unified-app-card-layout',
			_List_fromArray(
				[$author$project$Ui$Element$pt4, $author$project$Ui$Element$pb4, $author$project$Ui$Element$px6]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Grid$row,
					_List_fromArray(
						[$author$project$Ui$Grid$gutterMd]),
					_Utils_ap(
						A3($author$project$Layouts$Patient$basePanels, shared, patient, model),
						$author$project$Layouts$Patient$sponsorshipPanel(model.WR)))
				]));
	});
var $author$project$Layouts$Patient$AffiliateSyncDetailHovered = {$: 3};
var $author$project$Layouts$Patient$NetworkSyncDetailHovered = {$: 1};
var $author$project$Api$Provider$Patient$One$affiliateSyncStatus = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$One$record_,
	function ($) {
		return $.Lh;
	});
var $author$project$Api$Provider$Patient$One$hasFlaggedNotes = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$One$record_,
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.Sz;
		},
		function (flaggedNotesCount) {
			return flaggedNotesCount > 0;
		}));
var $author$project$Api$Provider$Patient$One$isAffiliated = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$One$record_,
	function ($) {
		return $.UA;
	});
var $author$project$Components$SyncedIcon$Md = 0;
var $author$project$Components$SyncedIcon$Size = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$SyncedIcon$md = $author$project$Components$SyncedIcon$Size(0);
var $author$project$Layouts$Patient$membershipStatus = function (patient) {
	return _Utils_ap(
		$author$project$Formatters$String$humanize(
			$author$project$Api$Provider$Patient$One$membershipStatus(patient)),
		function () {
			var _v0 = $author$project$Api$Provider$Patient$One$membershipThrough(patient);
			if (!_v0.$) {
				var membershipThrough = _v0.a;
				return ' through ' + $author$project$Api$Provider$Patient$Min$name(membershipThrough);
			} else {
				return '';
			}
		}());
};
var $author$project$Api$Provider$Patient$One$networkSyncStatus = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$One$record_,
	function ($) {
		return $.XG;
	});
var $author$project$Layouts$Patient$GoToAffiliatedPatient = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Api$Provider$Patient$One$affiliate = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$One$record_,
	function ($) {
		return $.Gn;
	});
var $author$project$Layouts$Patient$isHintAdmin = F2(
	function (session, hinterViewOff) {
		if (session.$ === 3) {
			var session_ = session.a;
			return A2($author$project$Utils$User$isViewingAsHinter, session_, hinterViewOff);
		} else {
			return false;
		}
	});
var $author$project$Api$Provider$Patient$One$masterRecordId = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$One$record_,
	function ($) {
		return $.Wz;
	});
var $author$project$Api$Provider$Patient$One$network = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$One$record_,
	function ($) {
		return $.Xz;
	});
var $author$project$Api$Provider$Patient$One$syncedRecordId = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$One$record_,
	function ($) {
		return $.acP;
	});
var $author$project$Layouts$Patient$viewActions = F2(
	function (_v0, patient) {
		var session = _v0.aa4;
		var hinterViewOff = _v0.ahK;
		var isHintAdmin_ = A2($author$project$Layouts$Patient$isHintAdmin, session, hinterViewOff);
		var hintAdminActions = function () {
			if (isHintAdmin_) {
				var syncedRecordId = $author$project$Api$Provider$Patient$One$syncedRecordId(patient);
				var network = $author$project$Api$Provider$Patient$One$network(patient);
				var masterRecordId = $author$project$Api$Provider$Patient$One$masterRecordId(patient);
				var affiliate = $author$project$Api$Provider$Patient$One$affiliate(patient);
				return _List_fromArray(
					[
						function () {
						var _v1 = _Utils_Tuple2(network, masterRecordId);
						if ((!_v1.a.$) && (!_v1.b.$)) {
							var network_ = _v1.a.a;
							var masterId = _v1.b.a;
							return A3(
								$author$project$Ui$HinterOnly$button,
								{mm: 'Go to affiliated patient'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$onClick(
										A2($author$project$Layouts$Patient$GoToAffiliatedPatient, network_, masterId)),
										$author$project$Ui$Button$icon($author$project$Ui$Icon$arrowLeft)
									]),
								_List_Nil);
						} else {
							return $author$project$Utils$Html$empty;
						}
					}(),
						function () {
						var _v2 = _Utils_Tuple2(affiliate, syncedRecordId);
						if ((!_v2.a.$) && (!_v2.b.$)) {
							var affiliate_ = _v2.a.a;
							var syncedId = _v2.b.a;
							return A3(
								$author$project$Ui$HinterOnly$button,
								{mm: 'Go to affiliated patient'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$onClick(
										A2($author$project$Layouts$Patient$GoToAffiliatedPatient, affiliate_, syncedId)),
										$author$project$Ui$Button$icon($author$project$Ui$Icon$arrowRight)
									]),
								_List_Nil);
						} else {
							return $author$project$Utils$Html$empty;
						}
					}()
					]);
			} else {
				return _List_Nil;
			}
		}();
		return _Utils_ap(
			hintAdminActions,
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Link$route,
					$author$project$Spa$Generated$Route$Charges__New,
					_List_fromArray(
						[
							$author$project$Ui$Link$buttonSecondary,
							$author$project$Ui$Link$icon($author$project$Ui$Icon$dollarSign),
							$author$project$Ui$Link$test('add-charge'),
							$author$project$Ui$Link$routeParams(
							_List_fromArray(
								[
									A2(
									$elm$url$Url$Builder$string,
									'patient',
									$author$project$Api$Provider$Patient$One$id(patient))
								]))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Add Charge')
						]))
				]));
	});
var $author$project$Layouts$Patient$viewDemographicsDetails = function (patient) {
	var pronouns = A2(
		$elm$core$Maybe$map,
		function (p) {
			return '(' + ($author$project$Formatters$String$humanize(p) + ')');
		},
		$author$project$Api$Provider$Patient$One$pronoun(patient));
	var mainDetails = A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$map,
				$author$project$Formatters$String$humanize,
				$author$project$Api$Provider$Patient$One$gender(patient)),
				A2(
				$elm$core$Maybe$map,
				$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
				$author$project$Api$Provider$Patient$One$dob(patient))
			]));
	return ($elm$core$List$isEmpty(mainDetails) && _Utils_eq(pronouns, $elm$core$Maybe$Nothing)) ? $author$project$Utils$Html$empty : A2(
		$elm$html$Html$span,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('demographics-bar__details')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($elm$core$String$join, ', ', mainDetails))
					])),
				function () {
				if (!pronouns.$) {
					var p = pronouns.a;
					return A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('demographics-bar__pronouns text-muted')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(' ' + p)
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]));
};
var $author$project$Api$Provider$Patient$SyncDetail$enrollmentStatus = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$SyncDetail$record_,
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.RG;
		},
		$elm$core$Maybe$withDefault('')));
var $author$project$Api$Provider$Patient$SyncDetail$errorMessage = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$SyncDetail$record_,
	function ($) {
		return $.RM;
	});
var $author$project$Api$Provider$Patient$SyncDetail$startedAt = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$SyncDetail$record_,
	function ($) {
		return $.aca;
	});
var $author$project$Api$Provider$Patient$SyncDetail$syncStatus = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$SyncDetail$record_,
	function ($) {
		return $.acL;
	});
var $author$project$Api$Provider$Patient$SyncDetail$syncedWith = function (detail) {
	if (!detail.$) {
		var name = detail.a;
		return name;
	} else {
		var name = detail.a;
		return name;
	}
};
var $author$project$Layouts$Patient$viewSyncedIconPopover = F2(
	function (timeFormatter, detailsData) {
		if ((detailsData.$ === 3) && (!detailsData.a.$)) {
			var details = detailsData.a.a;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							function () {
								var _v1 = $author$project$Api$Provider$Patient$SyncDetail$syncStatus(details);
								if (_v1 === 'synced') {
									return 'Synced with ';
								} else {
									var status = _v1;
									return 'Sync ' + (status + ' with ');
								}
							}()),
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$Patient$SyncDetail$syncedWith(details))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								$author$project$Api$Provider$Patient$SyncDetail$errorMessage(details)))
						])),
					$elm$html$Html$text(
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							timeFormatter(0),
							A2(
								$author$project$Utils$Maybe$orElse,
								$author$project$Api$Provider$Patient$SyncDetail$startedAt(details),
								$author$project$Api$Provider$Patient$SyncDetail$completedAt(details))))),
					$author$project$Utils$Html$noBreakSpace,
					$elm$html$Html$text($author$project$Utils$Html$middleDot),
					$author$project$Utils$Html$noBreakSpace,
					$elm$html$Html$text(
					$author$project$Api$Provider$Patient$SyncDetail$enrollmentStatus(details))
				]);
		} else {
			return _List_fromArray(
				[
					$elm$html$Html$text('Loading details...'),
					$author$project$Ui$Spinner$view(
					_List_fromArray(
						[$author$project$Ui$Spinner$small]))
				]);
		}
	});
var $author$project$Layouts$Patient$viewDemographicsBar = F4(
	function (shared, patient, model, timeFormatter) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('demographics-bar demographics-bar--unified')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('demographics-bar__name-row')
										]),
									_List_fromArray(
										[
											$author$project$Ui$Typography$heading(
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$text,
													_List_fromArray(
														[
															$author$project$Ui$Typography$phi(true)
														]),
													$author$project$Api$Provider$Patient$One$name(patient)),
													function () {
													var ageDisplay = A3(
														$author$project$Formatters$Patient$formatAge,
														shared.dd,
														$author$project$Api$Provider$Patient$One$dob(patient),
														$author$project$Api$Provider$Patient$One$age(patient));
													return $elm$core$String$isEmpty(ageDisplay) ? $elm$html$Html$text('') : $elm$html$Html$text(' (' + (ageDisplay + ')'));
												}()
												])),
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
											_List_fromArray(
												[
													function () {
													var _v0 = $author$project$Api$Provider$Patient$One$membershipThrough(patient);
													if (!_v0.$) {
														return A3(
															$author$project$Ui$Tooltip$view,
															_List_fromArray(
																[
																	$author$project$Ui$Tooltip$placement(0)
																]),
															$author$project$Layouts$Patient$membershipStatus(patient),
															_List_fromArray(
																[
																	A3(
																	$author$project$Ui$Badge$fromStringWithIcon,
																	_List_Nil,
																	$author$project$Api$Provider$Patient$One$membershipStatus(patient),
																	$author$project$Ui$Icon$arrowRightBottom(_List_Nil))
																]));
													} else {
														return A2(
															$author$project$Ui$Badge$fromString,
															_List_Nil,
															$author$project$Api$Provider$Patient$One$membershipStatus(patient));
													}
												}(),
													$author$project$Api$Provider$Patient$One$hasFlaggedNotes(patient) ? A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Patients__PatientId_String__Notes__Top(
														{
															YZ: $author$project$Api$Provider$Patient$One$id(patient)
														}),
													_List_fromArray(
														[
															$author$project$Ui$Link$routeParams(
															_List_fromArray(
																[
																	A2($elm$url$Url$Builder$string, 'flagged', '1')
																])),
															$author$project$Ui$Link$icon($author$project$Ui$Icon$flag)
														]),
													_List_Nil) : $elm$html$Html$text(''),
													($author$project$Api$Provider$Patient$One$isMaster(patient) && $author$project$Api$Provider$Patient$One$isAffiliated(patient)) ? A3(
													$author$project$Ui$Popover$view,
													_List_fromArray(
														[
															$author$project$Ui$Popover$dark,
															$author$project$Ui$Popover$onHover($author$project$Layouts$Patient$NetworkSyncDetailHovered)
														]),
													_List_fromArray(
														[
															$author$project$Components$SyncedIcon$view(
															_List_fromArray(
																[
																	$author$project$Components$SyncedIcon$md,
																	$author$project$Components$SyncedIcon$master,
																	$author$project$Components$SyncedIcon$status(
																	$author$project$Api$Provider$Patient$One$networkSyncStatus(patient))
																]))
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Popover$body,
															_List_Nil,
															A2($author$project$Layouts$Patient$viewSyncedIconPopover, timeFormatter, model.kq))
														])) : $author$project$Utils$Html$empty,
													($author$project$Api$Provider$Patient$One$isSynced(patient) && $author$project$Api$Provider$Patient$One$isAffiliated(patient)) ? A3(
													$author$project$Ui$Popover$view,
													_List_fromArray(
														[
															$author$project$Ui$Popover$dark,
															$author$project$Ui$Popover$onHover($author$project$Layouts$Patient$AffiliateSyncDetailHovered)
														]),
													_List_fromArray(
														[
															$author$project$Components$SyncedIcon$view(
															_List_fromArray(
																[
																	$author$project$Components$SyncedIcon$md,
																	$author$project$Components$SyncedIcon$synced,
																	$author$project$Components$SyncedIcon$status(
																	$author$project$Api$Provider$Patient$One$affiliateSyncStatus(patient))
																]))
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Popover$body,
															_List_Nil,
															A2($author$project$Layouts$Patient$viewSyncedIconPopover, timeFormatter, model.io))
														])) : $author$project$Utils$Html$empty
												]))
										])),
									$author$project$Layouts$Patient$viewDemographicsDetails(patient)
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
							A2($author$project$Layouts$Patient$viewActions, shared, patient))
						]))
				]));
	});
var $author$project$Layouts$Patient$viewHeader = F3(
	function (shared, patient, model) {
		var practice = shared.ZV;
		var timeFormatter = shared.J7;
		if (practice.$ === 3) {
			var practice_ = practice.a;
			var isJointProduct = A2($author$project$Api$Practice$featureEnabled, 6, practice_);
			return A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						isJointProduct ? A2(
						$elm$html$Html$map,
						$elm$core$Basics$never,
						A2($author$project$Components$PatientViewSwitcher$view, model.YZ, 1)) : A2(
						$elm$html$Html$map,
						$elm$core$Basics$never,
						A2(
							$author$project$Ui$Breadcrumb$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Breadcrumb$item,
									_List_Nil,
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$Patients__Top,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Patients')
												]))
										])),
									A2(
									$author$project$Ui$Breadcrumb$item,
									_List_fromArray(
										[
											$author$project$Ui$Breadcrumb$active(true)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$text,
											_List_fromArray(
												[
													$author$project$Ui$Typography$phi(true)
												]),
											$author$project$Api$Provider$Patient$One$name(patient))
										]))
								]))),
						A4($author$project$Layouts$Patient$viewDemographicsBar, shared, patient, model, timeFormatter)
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Utils$Clinical$getPatientUrl = F4(
	function (isUnifiedExperience, origin, emrHost, patientId) {
		return A3($author$project$Utils$Clinical$getHost, isUnifiedExperience, origin, emrHost) + ('/patients/' + (patientId + '/chart'));
	});
var $author$project$Layouts$Patient$viewHeaderLegacy = F3(
	function (shared, patient, model) {
		var practice = shared.ZV;
		var timeFormatter = shared.J7;
		if (practice.$ === 3) {
			var practice_ = practice.a;
			return A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsStart]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$elm$core$Basics$never,
								A2(
									$author$project$Ui$Breadcrumb$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Breadcrumb$item,
											_List_Nil,
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Patients__Top,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Patients')
														]))
												])),
											A2(
											$author$project$Ui$Breadcrumb$item,
											_List_fromArray(
												[
													$author$project$Ui$Breadcrumb$active(true)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$text,
													_List_fromArray(
														[
															$author$project$Ui$Typography$phi(true)
														]),
													$author$project$Api$Provider$Patient$One$name(patient))
												]))
										]))),
								A2(
								$elm$html$Html$map,
								$elm$core$Basics$never,
								A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$Patients__Top,
											_List_Nil,
											_List_fromArray(
												[
													$author$project$Ui$Icon$cross(
													_List_fromArray(
														[$author$project$Ui$Icon$sm]))
												]))
										])))
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mb2, $author$project$Ui$Element$gap2]),
								_List_fromArray(
									[
										$author$project$Ui$Typography$heading(
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$text,
												_List_fromArray(
													[
														$author$project$Ui$Typography$phi(true)
													]),
												$author$project$Api$Provider$Patient$One$name(patient)),
												function () {
												var ageDisplay = A3(
													$author$project$Formatters$Patient$formatAge,
													shared.dd,
													$author$project$Api$Provider$Patient$One$dob(patient),
													$author$project$Api$Provider$Patient$One$age(patient));
												return $elm$core$String$isEmpty(ageDisplay) ? $elm$html$Html$text('') : $elm$html$Html$text(', ' + ageDisplay);
											}()
											])),
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
										_List_fromArray(
											[
												function () {
												var _v1 = $author$project$Api$Provider$Patient$One$membershipThrough(patient);
												if (!_v1.$) {
													return A3(
														$author$project$Ui$Tooltip$view,
														_List_fromArray(
															[
																$author$project$Ui$Tooltip$placement(0)
															]),
														$author$project$Layouts$Patient$membershipStatus(patient),
														_List_fromArray(
															[
																A3(
																$author$project$Ui$Badge$fromStringWithIcon,
																_List_Nil,
																$author$project$Api$Provider$Patient$One$membershipStatus(patient),
																$author$project$Ui$Icon$arrowRightBottom(_List_Nil))
															]));
												} else {
													return A2(
														$author$project$Ui$Badge$fromString,
														_List_Nil,
														$author$project$Api$Provider$Patient$One$membershipStatus(patient));
												}
											}(),
												function () {
												if (A2($author$project$Api$Practice$featureEnabled, 6, practice_)) {
													var isUnifiedExperience = A2($author$project$Api$Practice$featureEnabled, 19, practice_);
													var emrUrl = A4(
														$author$project$Utils$Clinical$getPatientUrl,
														isUnifiedExperience,
														shared.ahq.ajG,
														shared.ahq.agP,
														$author$project$Api$Provider$Patient$One$id(patient));
													return A3(
														$author$project$Ui$Link$externalHref,
														emrUrl,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('View Chart in Clinical')
															]));
												} else {
													return $elm$html$Html$text('');
												}
											}(),
												$author$project$Api$Provider$Patient$One$hasFlaggedNotes(patient) ? A3(
												$author$project$Ui$Link$route,
												$author$project$Spa$Generated$Route$Patients__PatientId_String__Notes__Top(
													{
														YZ: $author$project$Api$Provider$Patient$One$id(patient)
													}),
												_List_fromArray(
													[
														$author$project$Ui$Link$routeParams(
														_List_fromArray(
															[
																A2($elm$url$Url$Builder$string, 'flagged', '1')
															])),
														$author$project$Ui$Link$icon($author$project$Ui$Icon$flag)
													]),
												_List_Nil) : $elm$html$Html$text(''),
												($author$project$Api$Provider$Patient$One$isMaster(patient) && $author$project$Api$Provider$Patient$One$isAffiliated(patient)) ? A3(
												$author$project$Ui$Popover$view,
												_List_fromArray(
													[
														$author$project$Ui$Popover$dark,
														$author$project$Ui$Popover$onHover($author$project$Layouts$Patient$NetworkSyncDetailHovered)
													]),
												_List_fromArray(
													[
														$author$project$Components$SyncedIcon$view(
														_List_fromArray(
															[
																$author$project$Components$SyncedIcon$md,
																$author$project$Components$SyncedIcon$master,
																$author$project$Components$SyncedIcon$status(
																$author$project$Api$Provider$Patient$One$networkSyncStatus(patient))
															]))
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Popover$body,
														_List_Nil,
														A2($author$project$Layouts$Patient$viewSyncedIconPopover, timeFormatter, model.kq))
													])) : $author$project$Utils$Html$empty,
												($author$project$Api$Provider$Patient$One$isSynced(patient) && $author$project$Api$Provider$Patient$One$isAffiliated(patient)) ? A3(
												$author$project$Ui$Popover$view,
												_List_fromArray(
													[
														$author$project$Ui$Popover$dark,
														$author$project$Ui$Popover$onHover($author$project$Layouts$Patient$AffiliateSyncDetailHovered)
													]),
												_List_fromArray(
													[
														$author$project$Components$SyncedIcon$view(
														_List_fromArray(
															[
																$author$project$Components$SyncedIcon$md,
																$author$project$Components$SyncedIcon$synced,
																$author$project$Components$SyncedIcon$status(
																$author$project$Api$Provider$Patient$One$affiliateSyncStatus(patient))
															]))
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Popover$body,
														_List_Nil,
														A2($author$project$Layouts$Patient$viewSyncedIconPopover, timeFormatter, model.io))
													])) : $author$project$Utils$Html$empty
											]))
									])),
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mb2, $author$project$Ui$Element$gap2]),
								A2($author$project$Layouts$Patient$viewActions, shared, patient))
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Layouts$Patient$Affiliation = 4;
var $author$project$Layouts$Patient$Invoices = 3;
var $author$project$Layouts$Patient$Memberships = 1;
var $author$project$Layouts$Patient$Notes = 5;
var $author$project$Layouts$Patient$Notifications = 6;
var $author$project$Layouts$Patient$Patient = 0;
var $author$project$Layouts$Patient$PaymentOptions = 2;
var $author$project$Layouts$Patient$isAuthorized = function (session) {
	if (session.$ === 3) {
		var session_ = session.a;
		return !$author$project$Api$Platform$Session$One$practiceReadOnlyRole(session_);
	} else {
		return false;
	}
};
var $author$project$Layouts$Patient$showIfAuthorized = F2(
	function (authorized, item) {
		return authorized ? item : $author$project$Ui$Nav$emptyItem;
	});
var $author$project$Layouts$Patient$tabFromUrl = function (url) {
	var pathWithoutPat = A2(
		$elm$core$List$drop,
		3,
		A2($elm$core$String$split, '/', url.YX));
	_v0$6:
	while (true) {
		if (pathWithoutPat.b) {
			switch (pathWithoutPat.a) {
				case 'memberships':
					return 1;
				case 'accounts':
					return 2;
				case 'charges':
					return 3;
				case 'notes':
					return 5;
				case 'notifications':
					return 6;
				case 'affiliation':
					return 4;
				default:
					break _v0$6;
			}
		} else {
			break _v0$6;
		}
	}
	return 0;
};
var $author$project$Layouts$Patient$tabToRoute = function (tab) {
	return function (id) {
		switch (tab) {
			case 0:
				return $author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
					{YZ: id});
			case 1:
				return $author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__Top(
					{YZ: id});
			case 2:
				return $author$project$Spa$Generated$Route$Patients__PatientId_String__Accounts__Top(
					{YZ: id});
			case 3:
				return $author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__Top(
					{YZ: id});
			case 4:
				return $author$project$Spa$Generated$Route$Patients__PatientId_String__Affiliation__Top(
					{YZ: id});
			case 5:
				return $author$project$Spa$Generated$Route$Patients__PatientId_String__Notes__Top(
					{YZ: id});
			default:
				return $author$project$Spa$Generated$Route$Patients__PatientId_String__Notifications__Top(
					{YZ: id});
		}
	};
};
var $author$project$Layouts$Patient$viewNavWith = F4(
	function (linkOptions, _v0, patient, _v1) {
		var url = _v0.adY;
		var session = _v0.aa4;
		var practice = _v0.ZV;
		var patientId = _v1.YZ;
		var nav = _v1.kp;
		var paymentOptionsTabLabel = function () {
			if (practice.$ === 3) {
				var practice_ = practice.a;
				return A2($author$project$Api$Practice$featureEnabled, 19, practice_) ? 'Payment Methods' : 'Payment Options';
			} else {
				return 'Payment Options';
			}
		}();
		var membershipsTabLabel = function () {
			if (practice.$ === 3) {
				var practice_ = practice.a;
				return A2($author$project$Utils$FeatureGate$gateAvailable, 14, practice_) ? 'Memberships & Packages' : 'Memberships';
			} else {
				return 'Memberships';
			}
		}();
		var linkRoute = function (tab) {
			return A2($author$project$Layouts$Patient$tabToRoute, tab, patientId);
		};
		var isSynced = $author$project$Api$Provider$Patient$One$isSynced(patient);
		var isAuthorized_ = $author$project$Layouts$Patient$isAuthorized(session);
		var activeTab = $author$project$Layouts$Patient$tabFromUrl(url);
		var isActive = function (tab) {
			return $author$project$Ui$Nav$activeItem(
				_Utils_eq(activeTab, tab));
		};
		return A3(
			$author$project$Ui$Nav$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							isActive(0),
							$author$project$Ui$Nav$route(
							linkRoute(0)),
							$author$project$Ui$Nav$linkOptions(linkOptions)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Patient')
						])),
					A2(
					$author$project$Layouts$Patient$showIfAuthorized,
					isAuthorized_,
					A2(
						$author$project$Ui$Nav$item,
						_List_fromArray(
							[
								isActive(3),
								$author$project$Ui$Nav$route(
								linkRoute(3)),
								$author$project$Ui$Nav$linkOptions(linkOptions)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Invoices'),
										($author$project$Api$Provider$Patient$One$overdueAmountInCents(patient) > 0) ? A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Utils$Html$noBreakSpace,
												$author$project$Ui$Icon$warning(
												_List_fromArray(
													[$author$project$Ui$Icon$danger]))
											])) : $author$project$Utils$Html$empty
									]))
							]))),
					A2(
					$author$project$Layouts$Patient$showIfAuthorized,
					isAuthorized_,
					A2(
						$author$project$Ui$Nav$item,
						_List_fromArray(
							[
								isActive(1),
								$author$project$Ui$Nav$route(
								linkRoute(1)),
								$author$project$Ui$Nav$linkOptions(linkOptions)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(membershipsTabLabel)
							]))),
					A2(
					$author$project$Layouts$Patient$showIfAuthorized,
					isAuthorized_,
					A2(
						$author$project$Ui$Nav$item,
						_List_fromArray(
							[
								isActive(2),
								$author$project$Ui$Nav$route(
								linkRoute(2)),
								$author$project$Ui$Nav$linkOptions(linkOptions)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(paymentOptionsTabLabel)
							]))),
					A2(
					$author$project$Layouts$Patient$showIfAuthorized,
					isAuthorized_ && isSynced,
					A2(
						$author$project$Ui$Nav$item,
						_List_fromArray(
							[
								isActive(4),
								$author$project$Ui$Nav$route(
								linkRoute(4)),
								$author$project$Ui$Nav$linkOptions(linkOptions)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Affiliation')
							]))),
					A2(
					$author$project$Layouts$Patient$showIfAuthorized,
					isAuthorized_,
					A2(
						$author$project$Ui$Nav$item,
						_List_fromArray(
							[
								isActive(5),
								$author$project$Ui$Nav$route(
								linkRoute(5)),
								$author$project$Ui$Nav$linkOptions(linkOptions)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Notes')
							]))),
					A2(
					$author$project$Layouts$Patient$showIfAuthorized,
					isAuthorized_,
					A2(
						$author$project$Ui$Nav$item,
						_List_fromArray(
							[
								isActive(6),
								$author$project$Ui$Nav$route(
								linkRoute(6)),
								$author$project$Ui$Nav$linkOptions(linkOptions)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Notifications')
							])))
				]),
			nav);
	});
var $author$project$Layouts$Patient$viewNav = F3(
	function (shared, patient, model) {
		return A4($author$project$Layouts$Patient$viewNavWith, _List_Nil, shared, patient, model);
	});
var $author$project$Layouts$Patient$viewNavLegacy = F4(
	function (shared, patient, patientsList, model) {
		return A4(
			$author$project$Layouts$Patient$viewNavWith,
			_List_fromArray(
				[
					$author$project$Ui$Link$routeParams(
					$author$project$Components$PatientsList$urlParams(patientsList))
				]),
			shared,
			patient,
			model);
	});
var $author$project$Layouts$Patient$view = F5(
	function (toMsg, patientListToMsg, shared, model, body) {
		var isUnifiedExperience = function () {
			var _v3 = shared.ZV;
			if (_v3.$ === 3) {
				var practice_ = _v3.a;
				return A2($author$project$Api$Practice$featureEnabled, 19, practice_);
			} else {
				return false;
			}
		}();
		if (isUnifiedExperience) {
			var _v0 = model.YY;
			if (_v0.$ === 3) {
				var patient = _v0.a;
				if ($author$project$Components$PatientChart$Helpers$shouldRenderUnifiedHeader(shared)) {
					var content = $author$project$Components$PatientChart$Helpers$isPatientRootRoute(shared.adY) ? A2(
						$elm$html$Html$map,
						toMsg,
						A3($author$project$Layouts$Patient$viewCardGrid, shared, patient, model)) : A2($author$project$Layouts$Patient$viewBackToChartCard, model.YZ, body);
					var activeView = A2($author$project$Components$PatientChart$Helpers$activeViewFor, 1, shared.ZV);
					return _List_fromArray(
						[
							$author$project$Components$PatientChart$DemographicsHeader$view(
							{aeF: activeView, YY: patient, YZ: model.YZ}),
							content
						]);
				} else {
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('layout-header--patient')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									toMsg,
									A3($author$project$Layouts$Patient$viewHeader, shared, patient, model))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('patient-content-card')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('patient-nav-bar')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$map,
											toMsg,
											A3($author$project$Layouts$Patient$viewNav, shared, patient, model))
										])),
									A2($elm$html$Html$div, _List_Nil, body)
								]))
						]);
				}
			} else {
				return _List_Nil;
			}
		} else {
			var _v1 = shared.ajU;
			if (!_v1.$) {
				var patientsList = _v1.a;
				return A3(
					$author$project$Layouts$PatientsSidebar$view,
					patientListToMsg,
					patientsList,
					function () {
						var _v2 = model.YY;
						if (_v2.$ === 3) {
							var patient = _v2.a;
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('layout-header md:ml-0')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$map,
											toMsg,
											A3($author$project$Layouts$Patient$viewHeaderLegacy, shared, patient, model)),
											A2(
											$elm$html$Html$map,
											toMsg,
											A4($author$project$Layouts$Patient$viewNavLegacy, shared, patient, patientsList, model))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('md:ml-8')
										]),
									body)
								]);
						} else {
							return _List_Nil;
						}
					}());
			} else {
				return _List_Nil;
			}
		}
	});
var $author$project$Layouts$PatientChart$view = F3(
	function (shared, model, _v0) {
		if ($author$project$Components$PatientChart$Helpers$shouldRenderUnifiedHeader(shared)) {
			var _v1 = shared.G9;
			if (_v1.$ === 3) {
				var patient = _v1.a;
				return _List_fromArray(
					[
						$author$project$Components$PatientChart$DemographicsHeader$view(
						{
							aeF: A2($author$project$Components$PatientChart$Helpers$activeViewFor, 0, shared.ZV),
							YY: patient,
							YZ: model.YZ
						})
					]);
			} else {
				return _List_Nil;
			}
		} else {
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$elm$core$Basics$never,
					A2($author$project$Components$PatientViewSwitcher$view, model.YZ, 0))
				]);
		}
	});
var $author$project$Ui$Panel$FullHeight = {$: 1};
var $author$project$Ui$Panel$fullHeight = $author$project$Ui$Panel$FullHeight;
var $author$project$Layouts$PracticeSetup$isCurrentRoute = F2(
	function (url, route) {
		return A2(
			$elm$core$String$endsWith,
			$elm$core$String$concat(
				_List_fromArray(
					['/', route])),
			$author$project$Spa$Generated$Route$toString(
				$author$project$Utils$Route$fromUrl(url)));
	});
var $author$project$Components$PracticeSetupStepper$InternalStep = F5(
	function (id, index, label, subtitle, subtitleDescription) {
		return {ahP: id, sG: index, aih: label, acA: subtitle, acB: subtitleDescription};
	});
var $author$project$Components$PracticeSetupStepper$stepIndex = F2(
	function (isHintClinical, stepId) {
		if (isHintClinical) {
			if (!stepId.$) {
				switch (stepId.a) {
					case 0:
						var _v1 = stepId.a;
						return 0;
					case 1:
						var _v2 = stepId.a;
						return 1;
					default:
						var _v3 = stepId.a;
						return 2;
				}
			} else {
				switch (stepId.a) {
					case 0:
						var _v4 = stepId.a;
						return 0;
					case 1:
						var _v5 = stepId.a;
						return 1;
					case 2:
						var _v6 = stepId.a;
						return 1;
					case 3:
						var _v7 = stepId.a;
						return 2;
					default:
						var _v8 = stepId.a;
						return 3;
				}
			}
		} else {
			if (!stepId.$) {
				switch (stepId.a) {
					case 0:
						var _v10 = stepId.a;
						return 0;
					case 1:
						var _v11 = stepId.a;
						return 1;
					default:
						var _v12 = stepId.a;
						return 2;
				}
			} else {
				switch (stepId.a) {
					case 0:
						var _v13 = stepId.a;
						return 0;
					case 3:
						var _v14 = stepId.a;
						return 1;
					case 4:
						var _v15 = stepId.a;
						return 2;
					default:
						return -1;
				}
			}
		}
	});
var $author$project$Components$PracticeSetupStepper$stepLabel = F2(
	function (paymentProcessor, stepId) {
		if (!stepId.$) {
			switch (stepId.a) {
				case 0:
					var _v1 = stepId.a;
					return 'General Practice Information';
				case 1:
					var _v2 = stepId.a;
					return 'Membership Pricing Setup';
				default:
					var _v3 = stepId.a;
					return 'Patient Agreements';
			}
		} else {
			switch (stepId.a) {
				case 3:
					var _v4 = stepId.a;
					return (paymentProcessor === 'rainforest') ? 'Payment Processor Setup' : 'Setup Stripe';
				case 0:
					var _v5 = stepId.a;
					return 'Profile Setup';
				case 1:
					var _v6 = stepId.a;
					return 'Communications Setup';
				case 2:
					var _v7 = stepId.a;
					return 'Communications Setup';
				default:
					var _v8 = stepId.a;
					return '';
			}
		}
	});
var $author$project$Components$PracticeSetupStepper$stepSubtitle = F2(
	function (paymentProcessor, stepId) {
		if (!stepId.$) {
			switch (stepId.a) {
				case 0:
					var _v1 = stepId.a;
					return $elm$core$Maybe$Just('3-5 mins');
				case 1:
					var _v2 = stepId.a;
					return $elm$core$Maybe$Just('5-10 mins');
				default:
					var _v3 = stepId.a;
					return $elm$core$Maybe$Just('2 mins');
			}
		} else {
			switch (stepId.a) {
				case 3:
					var _v4 = stepId.a;
					return (paymentProcessor === 'rainforest') ? $elm$core$Maybe$Just('5-10 mins') : $elm$core$Maybe$Just('10 mins');
				case 0:
					var _v5 = stepId.a;
					return $elm$core$Maybe$Just('5-10 mins');
				case 1:
					var _v6 = stepId.a;
					return $elm$core$Maybe$Just('3-5 mins');
				case 2:
					var _v7 = stepId.a;
					return $elm$core$Maybe$Just('3-5 mins');
				default:
					var _v8 = stepId.a;
					return $elm$core$Maybe$Nothing;
			}
		}
	});
var $author$project$Components$PracticeSetupStepper$stepSubtitleDescription = F2(
	function (paymentProcessor, stepId) {
		if (!stepId.$) {
			switch (stepId.a) {
				case 0:
					var _v1 = stepId.a;
					return $elm$core$Maybe$Nothing;
				case 1:
					var _v2 = stepId.a;
					return $elm$core$Maybe$Nothing;
				default:
					var _v3 = stepId.a;
					return $elm$core$Maybe$Nothing;
			}
		} else {
			switch (stepId.a) {
				case 3:
					var _v4 = stepId.a;
					return (paymentProcessor === 'rainforest') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('*requires tax ID & practice bank account & routing number');
				case 0:
					var _v5 = stepId.a;
					return $elm$core$Maybe$Nothing;
				case 1:
					var _v6 = stepId.a;
					return $elm$core$Maybe$Nothing;
				case 2:
					var _v7 = stepId.a;
					return $elm$core$Maybe$Nothing;
				default:
					var _v8 = stepId.a;
					return $elm$core$Maybe$Nothing;
			}
		}
	});
var $author$project$Components$PracticeSetupStepper$buildInternalStep = F3(
	function (isHintClinical, paymentProcessor, stepId) {
		return A5(
			$author$project$Components$PracticeSetupStepper$InternalStep,
			stepId,
			A2($author$project$Components$PracticeSetupStepper$stepIndex, isHintClinical, stepId),
			A2($author$project$Components$PracticeSetupStepper$stepLabel, paymentProcessor, stepId),
			A2($author$project$Components$PracticeSetupStepper$stepSubtitle, paymentProcessor, stepId),
			A2($author$project$Components$PracticeSetupStepper$stepSubtitleDescription, paymentProcessor, stepId));
	});
var $author$project$Components$PracticeSetupStepper$Account = 0;
var $author$project$Components$PracticeSetupStepper$AdminStep = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$PracticeSetupStepper$Communications = 1;
var $author$project$Components$PracticeSetupStepper$Complete = 4;
var $author$project$Components$PracticeSetupStepper$Documents = 2;
var $author$project$Components$PracticeSetupStepper$Legal = 2;
var $author$project$Components$PracticeSetupStepper$PaymentProcessing = 3;
var $author$project$Components$PracticeSetupStepper$Plan = 1;
var $author$project$Components$PracticeSetupStepper$PracticeInfoStep = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$PracticeSetupStepper$Team = 0;
var $author$project$Components$PracticeSetupStepper$stepIds = _List_fromArray(
	[
		$author$project$Components$PracticeSetupStepper$PracticeInfoStep(0),
		$author$project$Components$PracticeSetupStepper$PracticeInfoStep(1),
		$author$project$Components$PracticeSetupStepper$PracticeInfoStep(2),
		$author$project$Components$PracticeSetupStepper$AdminStep(0),
		$author$project$Components$PracticeSetupStepper$AdminStep(1),
		$author$project$Components$PracticeSetupStepper$AdminStep(2),
		$author$project$Components$PracticeSetupStepper$AdminStep(3),
		$author$project$Components$PracticeSetupStepper$AdminStep(4)
	]);
var $author$project$Components$PracticeSetupStepper$internalSteps = F2(
	function (isHintClinical, paymentProcessor) {
		return A2(
			$elm$core$List$map,
			A2($author$project$Components$PracticeSetupStepper$buildInternalStep, isHintClinical, paymentProcessor),
			$author$project$Components$PracticeSetupStepper$stepIds);
	});
var $author$project$Components$PracticeSetupStepper$init = F3(
	function (paymentProcessor, stepId, practice) {
		return {
			Hc: A3($author$project$Components$PracticeSetupStepper$buildInternalStep, false, paymentProcessor, stepId),
			Zd: paymentProcessor,
			ZV: practice,
			ach: A2($author$project$Components$PracticeSetupStepper$internalSteps, false, paymentProcessor)
		};
	});
var $author$project$Components$PracticeSetupStepper$setCurrentStepFromUrl = function (url) {
	var route = $author$project$Utils$Route$fromUrl(url);
	return A2(
		$elm$core$String$endsWith,
		'/account',
		$author$project$Spa$Generated$Route$toString(route)) ? $author$project$Components$PracticeSetupStepper$PracticeInfoStep(0) : (A2(
		$elm$core$String$endsWith,
		'/new',
		$author$project$Spa$Generated$Route$toString(route)) ? $author$project$Components$PracticeSetupStepper$PracticeInfoStep(1) : ((A2(
		$elm$core$String$endsWith,
		'/plans',
		$author$project$Spa$Generated$Route$toString(route)) || A2(
		$elm$core$String$contains,
		'/plans',
		$author$project$Spa$Generated$Route$toString(route))) ? $author$project$Components$PracticeSetupStepper$PracticeInfoStep(1) : (A2(
		$elm$core$String$endsWith,
		'/documents',
		$author$project$Spa$Generated$Route$toString(route)) ? $author$project$Components$PracticeSetupStepper$PracticeInfoStep(2) : (A2(
		$elm$core$String$endsWith,
		'/team',
		$author$project$Spa$Generated$Route$toString(route)) ? $author$project$Components$PracticeSetupStepper$AdminStep(0) : (A2(
		$elm$core$String$endsWith,
		'/communications',
		$author$project$Spa$Generated$Route$toString(route)) ? $author$project$Components$PracticeSetupStepper$AdminStep(1) : (A2(
		$elm$core$String$endsWith,
		'/legal',
		$author$project$Spa$Generated$Route$toString(route)) ? $author$project$Components$PracticeSetupStepper$AdminStep(2) : (A2(
		$elm$core$String$endsWith,
		'/payment_processing',
		$author$project$Spa$Generated$Route$toString(route)) ? $author$project$Components$PracticeSetupStepper$AdminStep(3) : (A2(
		$elm$core$String$endsWith,
		'/complete',
		$author$project$Spa$Generated$Route$toString(route)) ? $author$project$Components$PracticeSetupStepper$AdminStep(4) : $author$project$Components$PracticeSetupStepper$PracticeInfoStep(0)))))))));
};
var $author$project$Components$PracticeSetupStepper$adminStepIds = function (isHintClinical) {
	return isHintClinical ? _List_fromArray(
		[
			$author$project$Components$PracticeSetupStepper$AdminStep(0),
			$author$project$Components$PracticeSetupStepper$AdminStep(1),
			$author$project$Components$PracticeSetupStepper$AdminStep(2),
			$author$project$Components$PracticeSetupStepper$AdminStep(3)
		]) : _List_fromArray(
		[
			$author$project$Components$PracticeSetupStepper$AdminStep(0),
			$author$project$Components$PracticeSetupStepper$AdminStep(3)
		]);
};
var $author$project$Components$PracticeSetupStepper$convertStepsToStep = F3(
	function (isHintClinical, paymentProcessor, stepIds_) {
		return A2(
			$elm$core$List$map,
			function (step) {
				return A5($author$project$Ui$Stepper$Step, step.aih, step.sG, true, step.acA, step.acB);
			},
			A2(
				$elm_community$list_extra$List$Extra$uniqueBy,
				function (step) {
					return step.sG;
				},
				A2(
					$elm$core$List$map,
					A2($author$project$Components$PracticeSetupStepper$buildInternalStep, isHintClinical, paymentProcessor),
					stepIds_)));
	});
var $author$project$Components$PracticeSetupStepper$convertedAdminSteps = F2(
	function (isHintClinical, paymentProcessor) {
		return A3(
			$author$project$Components$PracticeSetupStepper$convertStepsToStep,
			isHintClinical,
			paymentProcessor,
			$author$project$Components$PracticeSetupStepper$adminStepIds(isHintClinical));
	});
var $author$project$Ui$Stepper$viewVerticalStep = F3(
	function (_v0, attr, step) {
		var currentIndex = _v0.ae;
		var lastCompletedIndex = _v0.sY;
		var numSteps = _v0.am;
		var stepIndexString = $elm$core$String$fromInt(step.sG + 1);
		var stepOptions = function () {
			if (_Utils_eq(step.sG, currentIndex)) {
				return {
					c9: A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('stepper__circle')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(stepIndexString)
							])),
					dN: 'current',
					dO: $elm$html$Html$text(step.aih)
				};
			} else {
				if (step.ep) {
					return {
						c9: A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('stepper__circle')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(stepIndexString)
								])),
						dN: 'disabled',
						dO: $elm$html$Html$text(step.aih)
					};
				} else {
					if (_Utils_cmp(step.sG, currentIndex) < 0) {
						return {
							c9: A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('stepper__circle'),
										attr
									]),
								_List_fromArray(
									[
										$author$project$Ui$Icon$check(_List_Nil)
									])),
							dN: 'previous',
							dO: A2(
								$elm$html$Html$a,
								_List_fromArray(
									[attr]),
								_List_fromArray(
									[
										$elm$html$Html$text(step.aih)
									]))
						};
					} else {
						var circleBodyText = function () {
							if (!lastCompletedIndex.$) {
								var index = lastCompletedIndex.a;
								return (_Utils_cmp(step.sG, index) < 0) ? $author$project$Ui$Icon$check(_List_Nil) : $elm$html$Html$text(stepIndexString);
							} else {
								return $elm$html$Html$text(stepIndexString);
							}
						}();
						return {
							c9: A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('stepper__circle')
									]),
								_List_fromArray(
									[circleBodyText])),
							dN: 'next',
							dO: $elm$html$Html$text(step.aih)
						};
					}
				}
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('stepper__step stepper__step--' + stepOptions.dN)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('stepper__step__left')
						]),
					_List_fromArray(
						[
							stepOptions.c9,
							A2(
							$author$project$Utils$Html$htmlIf,
							_Utils_cmp(step.sG + 1, numSteps) < 0,
							A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('stepper__line')
									]),
								_List_fromArray(
									[
										$author$project$Ui$HorizontalRule$view(_List_Nil)
									])))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('stepper__step__right')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('stepper__text')
								]),
							_List_fromArray(
								[stepOptions.dO])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('stepper__subtitle')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($elm$core$Maybe$withDefault, '', step.acA))
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('stepper__subtitle stepper__description')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($elm$core$Maybe$withDefault, '', step.acB))
								]))
						]))
				]));
	});
var $author$project$Ui$Stepper$viewStaticVerticalStep = F2(
	function (_v0, step) {
		var currentIndex = _v0.ae;
		var numSteps = _v0.am;
		return A3(
			$author$project$Ui$Stepper$viewVerticalStep,
			{ae: currentIndex, sY: $elm$core$Maybe$Nothing, am: numSteps},
			$elm$html$Html$Attributes$class('label'),
			step);
	});
var $author$project$Ui$Stepper$viewVertical = F2(
	function (maybeStepIndex, steps) {
		if ($elm$core$List$isEmpty(steps)) {
			return $author$project$Utils$Html$empty;
		} else {
			if (!maybeStepIndex.$) {
				var stepIndex = maybeStepIndex.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('stepper__vertical')
						]),
					A2(
						$elm$core$List$map,
						function (step) {
							return A2(
								$author$project$Ui$Stepper$viewStaticVerticalStep,
								{
									ae: stepIndex,
									am: $elm$core$List$length(steps)
								},
								step);
						},
						steps));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}
	});
var $author$project$Components$PracticeSetupStepper$viewExpandedHeader = F4(
	function (partLabel, title, steps, currentStep) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$fontBold]),
					_List_fromArray(
						[
							$elm$html$Html$text(partLabel)
						])),
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						])),
					A2(
					$author$project$Ui$Stepper$viewVertical,
					$elm$core$Maybe$Just(currentStep.sG),
					steps)
				]));
	});
var $author$project$Components$PracticeSetupStepper$viewMinimizedHeader = F2(
	function (partLabel, title) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
					_List_fromArray(
						[
							$elm$html$Html$text(partLabel)
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mt2]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$bold]),
							title)
						]))
				]));
	});
var $author$project$Components$PracticeSetupStepper$viewAdminSetup = F3(
	function (isHintClinical, model, currentStep) {
		return (A2(
			$elm$core$List$member,
			currentStep.ahP,
			$author$project$Components$PracticeSetupStepper$adminStepIds(isHintClinical)) || _Utils_eq(
			currentStep.ahP,
			$author$project$Components$PracticeSetupStepper$AdminStep(2))) ? A4(
			$author$project$Components$PracticeSetupStepper$viewExpandedHeader,
			'Part 2 of 2',
			'Admin Setup',
			A2($author$project$Components$PracticeSetupStepper$convertedAdminSteps, isHintClinical, model.Zd),
			_Utils_update(
				currentStep,
				{
					sG: A2($author$project$Components$PracticeSetupStepper$stepIndex, isHintClinical, currentStep.ahP)
				})) : A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Components$PracticeSetupStepper$viewMinimizedHeader, 'Part 2 of 2', 'Admin Setup'),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mb2]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
							'Est. 25-30 mins.')
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mb2]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$text,
							_List_fromArray(
								[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
							'Requires tax ID & practice bank routing & account numbers.')
						]))
				]));
	});
var $author$project$Components$PracticeSetupStepper$practiceInfoStepIds = _List_fromArray(
	[
		$author$project$Components$PracticeSetupStepper$PracticeInfoStep(0),
		$author$project$Components$PracticeSetupStepper$PracticeInfoStep(1),
		$author$project$Components$PracticeSetupStepper$PracticeInfoStep(2)
	]);
var $author$project$Components$PracticeSetupStepper$convertedPracticeSteps = F2(
	function (isHintClinical, paymentProcessor) {
		return A3($author$project$Components$PracticeSetupStepper$convertStepsToStep, isHintClinical, paymentProcessor, $author$project$Components$PracticeSetupStepper$practiceInfoStepIds);
	});
var $author$project$Components$PracticeSetupStepper$viewPracticeInfoSetup = F3(
	function (isHintClinical, model, currentStep) {
		return A2($elm$core$List$member, currentStep.ahP, $author$project$Components$PracticeSetupStepper$practiceInfoStepIds) ? A4(
			$author$project$Components$PracticeSetupStepper$viewExpandedHeader,
			'Part 1 of 2',
			'Public Practice Information',
			A2($author$project$Components$PracticeSetupStepper$convertedPracticeSteps, isHintClinical, model.Zd),
			currentStep) : A2($author$project$Components$PracticeSetupStepper$viewMinimizedHeader, 'Part 1 of 2', 'Public Practice Information');
	});
var $author$project$Components$PracticeSetupStepper$view = F2(
	function (model, _v0) {
		var isHintClinical = function () {
			var _v1 = model.ZV;
			if ((_v1.$ === 3) && (!_v1.a.$)) {
				var practice_ = _v1.a.a;
				var _v2 = $author$project$Api$Provider$Practice$One$emr(practice_);
				if (!_v2.$) {
					var emr = _v2.a;
					return !$author$project$Api$Provider$Practice$Emr$toOption(emr);
				} else {
					return false;
				}
			} else {
				return false;
			}
		}();
		var currentStep = model.Hc;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A3($author$project$Components$PracticeSetupStepper$viewPracticeInfoSetup, isHintClinical, model, currentStep),
					A2($elm$html$Html$hr, _List_Nil, _List_Nil),
					A3($author$project$Components$PracticeSetupStepper$viewAdminSetup, isHintClinical, model, currentStep)
				]));
	});
var $author$project$Layouts$PracticeSetup$viewStepper = F4(
	function (paymentProcessor_, url, accountStep, practice) {
		var stepId = $author$project$Components$PracticeSetupStepper$setCurrentStepFromUrl(url);
		var stepperModel = A3($author$project$Components$PracticeSetupStepper$init, paymentProcessor_, stepId, practice);
		return A2($author$project$Components$PracticeSetupStepper$view, stepperModel, accountStep);
	});
var $author$project$Layouts$PracticeSetup$view = F2(
	function (_v0, body) {
		var practice = _v0.ZV;
		var url = _v0.adY;
		var _v1 = function () {
			if ((practice.$ === 3) && (!practice.a.$)) {
				var practice_ = practice.a.a;
				return _Utils_Tuple2(
					A2(
						$elm$core$Maybe$withDefault,
						0,
						A2(
							$elm$core$Maybe$map,
							$author$project$Api$Provider$PracticeOnboarding$Shared$accountStep,
							$author$project$Api$Provider$Practice$One$practiceOnboarding(practice_))),
					$author$project$Api$Provider$Practice$One$paymentProcessor(practice_));
			} else {
				return _Utils_Tuple2(8, 'stripe');
			}
		}();
		var accountStep = _v1.a;
		var paymentProcessor_ = _v1.b;
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_fromArray(
					[$author$project$Ui$Panel$extraPadding, $author$project$Ui$Panel$fullHeight]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								A2($author$project$Layouts$PracticeSetup$isCurrentRoute, url, 'complete') ? _List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												A2($elm$html$Html$Attributes$style, 'border', '1px solid #ccc'),
												A2($elm$html$Html$Attributes$style, 'padding', '1rem'),
												A2($elm$html$Html$Attributes$style, 'margin', '1rem 0')
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Grid$row,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Grid$column,
														_List_fromArray(
															[
																$author$project$Ui$Grid$spanSm(12),
																$author$project$Ui$Grid$justifyLeft
															]),
														body)
													]))
											]))
									]) : _List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$row,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Grid$column,
												_List_fromArray(
													[
														$author$project$Ui$Grid$spanSm(3)
													]),
												_List_fromArray(
													[
														A4($author$project$Layouts$PracticeSetup$viewStepper, paymentProcessor_, url, accountStep, practice)
													])),
												A2(
												$author$project$Ui$Grid$column,
												_List_fromArray(
													[
														$author$project$Ui$Grid$spanSm(9),
														$author$project$Ui$Grid$justifyCenter
													]),
												body)
											]))
									]))
							]))
					]))
			]);
	});
var $author$project$Spa$Generated$Route$all = _List_fromArray(
	[
		$author$project$Spa$Generated$Route$Top,
		$author$project$Spa$Generated$Route$Blank,
		$author$project$Spa$Generated$Route$Bookkeeping,
		$author$project$Spa$Generated$Route$Calendar,
		$author$project$Spa$Generated$Route$Forms,
		$author$project$Spa$Generated$Route$GoogleCallback,
		$author$project$Spa$Generated$Route$Home,
		$author$project$Spa$Generated$Route$Login,
		$author$project$Spa$Generated$Route$Logout,
		$author$project$Spa$Generated$Route$NotFound,
		$author$project$Spa$Generated$Route$Onboarding,
		$author$project$Spa$Generated$Route$RefillRequests,
		$author$project$Spa$Generated$Route$AffiliateBills__Top,
		$author$project$Spa$Generated$Route$Affiliates__Top,
		$author$project$Spa$Generated$Route$Companies__Top,
		$author$project$Spa$Generated$Route$Files__Top,
		$author$project$Spa$Generated$Route$Marketplace__Top,
		$author$project$Spa$Generated$Route$Patients__Top,
		$author$project$Spa$Generated$Route$PracticeSetup__Top,
		$author$project$Spa$Generated$Route$StyleGuide__Top,
		$author$project$Spa$Generated$Route$Tasks__Top,
		$author$project$Spa$Generated$Route$Account__Complete,
		$author$project$Spa$Generated$Route$Admin__AdvanceBilling,
		$author$project$Spa$Generated$Route$Admin__Billing,
		$author$project$Spa$Generated$Route$Admin__CancellationReasons,
		$author$project$Spa$Generated$Route$Admin__CardReaders,
		$author$project$Spa$Generated$Route$Admin__Categories,
		$author$project$Spa$Generated$Route$Admin__Commissions,
		$author$project$Spa$Generated$Route$Admin__Coupons,
		$author$project$Spa$Generated$Route$Admin__CreditCategories,
		$author$project$Spa$Generated$Route$Admin__ElationLegacy,
		$author$project$Spa$Generated$Route$Admin__Features,
		$author$project$Spa$Generated$Route$Admin__HipaaAuthorizations,
		$author$project$Spa$Generated$Route$Admin__InternalSettings,
		$author$project$Spa$Generated$Route$Admin__InvoiceSettings,
		$author$project$Spa$Generated$Route$Admin__LeadSources,
		$author$project$Spa$Generated$Route$Admin__Locations,
		$author$project$Spa$Generated$Route$Admin__Mailgun,
		$author$project$Spa$Generated$Route$Admin__Notes,
		$author$project$Spa$Generated$Route$Admin__Patients,
		$author$project$Spa$Generated$Route$Admin__PaymentMethodImport,
		$author$project$Spa$Generated$Route$Admin__PaymentProcessing,
		$author$project$Spa$Generated$Route$Admin__PaymentSources,
		$author$project$Spa$Generated$Route$Admin__Practice,
		$author$project$Spa$Generated$Route$Admin__ProviderGroups,
		$author$project$Spa$Generated$Route$Admin__ScheduledJobs,
		$author$project$Spa$Generated$Route$Admin__SelfService,
		$author$project$Spa$Generated$Route$Admin__Signup,
		$author$project$Spa$Generated$Route$Admin__Stripe,
		$author$project$Spa$Generated$Route$Admin__Taxes,
		$author$project$Spa$Generated$Route$Admin__Team,
		$author$project$Spa$Generated$Route$Admin__Waitlist,
		$author$project$Spa$Generated$Route$Affiliates__Create,
		$author$project$Spa$Generated$Route$Affiliates__New,
		$author$project$Spa$Generated$Route$Charges__New,
		$author$project$Spa$Generated$Route$Commissions__Statements,
		$author$project$Spa$Generated$Route$Companies__New,
		$author$project$Spa$Generated$Route$Contacts__List,
		$author$project$Spa$Generated$Route$Contacts__New,
		$author$project$Spa$Generated$Route$Files__Public,
		$author$project$Spa$Generated$Route$Hinter__ClonePractice,
		$author$project$Spa$Generated$Route$Hinter__Disputes,
		$author$project$Spa$Generated$Route$Hinter__FeatureFlags,
		$author$project$Spa$Generated$Route$Hinter__NewGroup,
		$author$project$Spa$Generated$Route$Hinter__NewPartner,
		$author$project$Spa$Generated$Route$Hinter__NewPractice,
		$author$project$Spa$Generated$Route$Inventory__List,
		$author$project$Spa$Generated$Route$Inventory__New,
		$author$project$Spa$Generated$Route$Inventory__Settings,
		$author$project$Spa$Generated$Route$Marketplace__Manage,
		$author$project$Spa$Generated$Route$Messages__Calls,
		$author$project$Spa$Generated$Route$Messages__Chat,
		$author$project$Spa$Generated$Route$Messages__Drafts,
		$author$project$Spa$Generated$Route$Messages__Forms,
		$author$project$Spa$Generated$Route$Messages__Inbox,
		$author$project$Spa$Generated$Route$Messages__Labs,
		$author$project$Spa$Generated$Route$Messages__LegacyCalls,
		$author$project$Spa$Generated$Route$Messages__Sms,
		$author$project$Spa$Generated$Route$NewSettings__BlockedPhoneNumbers,
		$author$project$Spa$Generated$Route$NewSettings__BookingOverview,
		$author$project$Spa$Generated$Route$NewSettings__Erx,
		$author$project$Spa$Generated$Route$NewSettings__Export,
		$author$project$Spa$Generated$Route$NewSettings__HinterSettings,
		$author$project$Spa$Generated$Route$NewSettings__PracticeInfo,
		$author$project$Spa$Generated$Route$NewSettings__Team,
		$author$project$Spa$Generated$Route$Oauth__Callback,
		$author$project$Spa$Generated$Route$Partner__ApiKeys,
		$author$project$Spa$Generated$Route$Partner__Billing,
		$author$project$Spa$Generated$Route$Partner__Engagements,
		$author$project$Spa$Generated$Route$Partner__Hinter,
		$author$project$Spa$Generated$Route$Partner__Team,
		$author$project$Spa$Generated$Route$Patients__Create,
		$author$project$Spa$Generated$Route$Patients__Upload,
		$author$project$Spa$Generated$Route$PracticeSetup__Account,
		$author$project$Spa$Generated$Route$PracticeSetup__Communications,
		$author$project$Spa$Generated$Route$PracticeSetup__Complete,
		$author$project$Spa$Generated$Route$PracticeSetup__Documents,
		$author$project$Spa$Generated$Route$PracticeSetup__Legal,
		$author$project$Spa$Generated$Route$PracticeSetup__PaymentProcessing,
		$author$project$Spa$Generated$Route$PracticeSetup__Plans,
		$author$project$Spa$Generated$Route$PracticeSetup__Team,
		$author$project$Spa$Generated$Route$Reports__CompanyInvoices,
		$author$project$Spa$Generated$Route$Reports__CreditOutstanding,
		$author$project$Spa$Generated$Route$Reports__CreditTransactions,
		$author$project$Spa$Generated$Route$Reports__Dashboard,
		$author$project$Spa$Generated$Route$Reports__DeferredRevenue,
		$author$project$Spa$Generated$Route$Reports__Deposits,
		$author$project$Spa$Generated$Route$Reports__Disputes,
		$author$project$Spa$Generated$Route$Reports__Invoices,
		$author$project$Spa$Generated$Route$Reports__Memberships,
		$author$project$Spa$Generated$Route$Reports__Months,
		$author$project$Spa$Generated$Route$Reports__PatientPackages,
		$author$project$Spa$Generated$Route$Reports__PaymentApplications,
		$author$project$Spa$Generated$Route$Reports__Revenue,
		$author$project$Spa$Generated$Route$Reports__SalesTax,
		$author$project$Spa$Generated$Route$Reports__SignupAttempts,
		$author$project$Spa$Generated$Route$StyleGuide__ActivityIndicators,
		$author$project$Spa$Generated$Route$StyleGuide__AddressInput,
		$author$project$Spa$Generated$Route$StyleGuide__Alert,
		$author$project$Spa$Generated$Route$StyleGuide__Badge,
		$author$project$Spa$Generated$Route$StyleGuide__Button,
		$author$project$Spa$Generated$Route$StyleGuide__Carousel,
		$author$project$Spa$Generated$Route$StyleGuide__Checkbox,
		$author$project$Spa$Generated$Route$StyleGuide__CurrencyInput,
		$author$project$Spa$Generated$Route$StyleGuide__DateInput,
		$author$project$Spa$Generated$Route$StyleGuide__DateRangeInput,
		$author$project$Spa$Generated$Route$StyleGuide__DragDrop,
		$author$project$Spa$Generated$Route$StyleGuide__Dropdown,
		$author$project$Spa$Generated$Route$StyleGuide__Element,
		$author$project$Spa$Generated$Route$StyleGuide__ExportCsv,
		$author$project$Spa$Generated$Route$StyleGuide__FileInput,
		$author$project$Spa$Generated$Route$StyleGuide__FlyoutMenu,
		$author$project$Spa$Generated$Route$StyleGuide__FormExample,
		$author$project$Spa$Generated$Route$StyleGuide__FormGroup,
		$author$project$Spa$Generated$Route$StyleGuide__FormStatic,
		$author$project$Spa$Generated$Route$StyleGuide__Grid,
		$author$project$Spa$Generated$Route$StyleGuide__HiConfirm,
		$author$project$Spa$Generated$Route$StyleGuide__HorizontalRule,
		$author$project$Spa$Generated$Route$StyleGuide__Icon,
		$author$project$Spa$Generated$Route$StyleGuide__Input,
		$author$project$Spa$Generated$Route$StyleGuide__Link,
		$author$project$Spa$Generated$Route$StyleGuide__ListGroup,
		$author$project$Spa$Generated$Route$StyleGuide__Modal,
		$author$project$Spa$Generated$Route$StyleGuide__OrderedList,
		$author$project$Spa$Generated$Route$StyleGuide__Pagination,
		$author$project$Spa$Generated$Route$StyleGuide__Panel,
		$author$project$Spa$Generated$Route$StyleGuide__PasswordInput,
		$author$project$Spa$Generated$Route$StyleGuide__PaymentSourceDisplayer,
		$author$project$Spa$Generated$Route$StyleGuide__PhoneInput,
		$author$project$Spa$Generated$Route$StyleGuide__Popover,
		$author$project$Spa$Generated$Route$StyleGuide__Pre,
		$author$project$Spa$Generated$Route$StyleGuide__ProgressBar,
		$author$project$Spa$Generated$Route$StyleGuide__Radio,
		$author$project$Spa$Generated$Route$StyleGuide__ResourceFilter,
		$author$project$Spa$Generated$Route$StyleGuide__SearchInput,
		$author$project$Spa$Generated$Route$StyleGuide__Select,
		$author$project$Spa$Generated$Route$StyleGuide__Skeleton,
		$author$project$Spa$Generated$Route$StyleGuide__Spinner,
		$author$project$Spa$Generated$Route$StyleGuide__Table,
		$author$project$Spa$Generated$Route$StyleGuide__Toast,
		$author$project$Spa$Generated$Route$StyleGuide__ToggleSwitch,
		$author$project$Spa$Generated$Route$StyleGuide__Tooltip,
		$author$project$Spa$Generated$Route$StyleGuide__Typography,
		$author$project$Spa$Generated$Route$StyleGuide__UploadForm,
		$author$project$Spa$Generated$Route$StyleGuide__UploadResult,
		$author$project$Spa$Generated$Route$StyleGuide__Well,
		$author$project$Spa$Generated$Route$Support__CannySso,
		$author$project$Spa$Generated$Route$Tasks__New,
		$author$project$Spa$Generated$Route$User__AcceptTerms,
		$author$project$Spa$Generated$Route$User__Mfa,
		$author$project$Spa$Generated$Route$User__Profile,
		$author$project$Spa$Generated$Route$User__Security,
		$author$project$Spa$Generated$Route$Apps__Slug_String(
		{abG: ''}),
		$author$project$Spa$Generated$Route$Error__Status_String(
		{alH: ''}),
		$author$project$Spa$Generated$Route$Join__Token_String(
		{adi: ''}),
		$author$project$Spa$Generated$Route$Marketplace__Slug_String(
		{abG: ''}),
		$author$project$Spa$Generated$Route$Admin__Athenahealth__Top,
		$author$project$Spa$Generated$Route$Admin__ChargeItems__Top,
		$author$project$Spa$Generated$Route$Admin__CompanyPlans__Top,
		$author$project$Spa$Generated$Route$Admin__CoveragePlans__Top,
		$author$project$Spa$Generated$Route$Admin__DataExport__Top,
		$author$project$Spa$Generated$Route$Admin__DataExportSettings__Top,
		$author$project$Spa$Generated$Route$Admin__Documents__Top,
		$author$project$Spa$Generated$Route$Admin__Elation__Top,
		$author$project$Spa$Generated$Route$Admin__Plans__Top,
		$author$project$Spa$Generated$Route$Admin__Providers__Top,
		$author$project$Spa$Generated$Route$Admin__Quickbooks__Top,
		$author$project$Spa$Generated$Route$Admin__SignupPages__Top,
		$author$project$Spa$Generated$Route$CcdaImports__CcdaId_String__Top(
		{afv: ''}),
		$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__Top,
		$author$project$Spa$Generated$Route$Commissions__StatementLines__Top,
		$author$project$Spa$Generated$Route$Companies__CompanyId_String__Top(
		{fZ: ''}),
		$author$project$Spa$Generated$Route$Contacts__ContactId_String__Top(
		{afW: ''}),
		$author$project$Spa$Generated$Route$Hinter__AdminUsersGroups__Top,
		$author$project$Spa$Generated$Route$Inventory__InventoryId_String__Top(
		{ah4: ''}),
		$author$project$Spa$Generated$Route$Messages__Faxes__Top,
		$author$project$Spa$Generated$Route$Messages__Scheduled__Top,
		$author$project$Spa$Generated$Route$NewSettings__AppointmentTypes__Top,
		$author$project$Spa$Generated$Route$NewSettings__Locations__Top,
		$author$project$Spa$Generated$Route$NewSettings__Templates__Top,
		$author$project$Spa$Generated$Route$Onboard__DealId_String__Top(
		{agc: ''}),
		$author$project$Spa$Generated$Route$Partner__Dashboard__Top,
		$author$project$Spa$Generated$Route$Partner__Practices__Top,
		$author$project$Spa$Generated$Route$Partner__Sandboxes__Top,
		$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
		{YZ: ''}),
		$author$project$Spa$Generated$Route$Reports__AncillaryCharges__Top,
		$author$project$Spa$Generated$Route$Tasks__TasksId_String__Top(
		{alV: ''}),
		$author$project$Spa$Generated$Route$User__Organizations__Top,
		$author$project$Spa$Generated$Route$Admin__Athenahealth__Fields,
		$author$project$Spa$Generated$Route$Admin__Athenahealth__Link,
		$author$project$Spa$Generated$Route$Admin__Athenahealth__Locations,
		$author$project$Spa$Generated$Route$Admin__Athenahealth__Overview,
		$author$project$Spa$Generated$Route$Admin__Athenahealth__Providers,
		$author$project$Spa$Generated$Route$Admin__ChargeItems__New,
		$author$project$Spa$Generated$Route$Admin__ChargeItems__Upload,
		$author$project$Spa$Generated$Route$Admin__CompanyPlans__New,
		$author$project$Spa$Generated$Route$Admin__CoveragePlans__New,
		$author$project$Spa$Generated$Route$Admin__Credits__Upload,
		$author$project$Spa$Generated$Route$Admin__DataExportSettings__New,
		$author$project$Spa$Generated$Route$Admin__Developers__ApiKeys,
		$author$project$Spa$Generated$Route$Admin__Developers__App,
		$author$project$Spa$Generated$Route$Admin__Developers__GetStarted,
		$author$project$Spa$Generated$Route$Admin__Developers__Hinter,
		$author$project$Spa$Generated$Route$Admin__Developers__Sandboxes,
		$author$project$Spa$Generated$Route$Admin__Developers__WebhookEndpoints,
		$author$project$Spa$Generated$Route$Admin__Documents__New,
		$author$project$Spa$Generated$Route$Admin__Elation__Link,
		$author$project$Spa$Generated$Route$Admin__Elation__Overview,
		$author$project$Spa$Generated$Route$Admin__Elation__Providers,
		$author$project$Spa$Generated$Route$Admin__Notifications__Company,
		$author$project$Spa$Generated$Route$Admin__Notifications__Employee,
		$author$project$Spa$Generated$Route$Admin__Notifications__Membership,
		$author$project$Spa$Generated$Route$Admin__Notifications__Patient,
		$author$project$Spa$Generated$Route$Admin__Notifications__Practice,
		$author$project$Spa$Generated$Route$Admin__Notifications__Settings,
		$author$project$Spa$Generated$Route$Admin__PaymentMethodImport__Upload,
		$author$project$Spa$Generated$Route$Admin__Plans__New,
		$author$project$Spa$Generated$Route$Admin__Providers__Upload,
		$author$project$Spa$Generated$Route$Admin__SignupPages__New,
		$author$project$Spa$Generated$Route$Admin__Team__New,
		$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__AffiliateActions(
		{rd: ''}),
		$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__LinkProviders(
		{rd: ''}),
		$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__LinkedProviders(
		{rd: ''}),
		$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Patients(
		{rd: ''}),
		$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Settings(
		{rd: ''}),
		$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Users(
		{rd: ''}),
		$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__New,
		$author$project$Spa$Generated$Route$Commissions__StatementLines__Summary,
		$author$project$Spa$Generated$Route$Companies__CompanyId_String__AffiliatesPricing(
		{fZ: ''}),
		$author$project$Spa$Generated$Route$Companies__CompanyId_String__Eas(
		{fZ: ''}),
		$author$project$Spa$Generated$Route$Companies__CompanyId_String__EndedCommissions(
		{fZ: ''}),
		$author$project$Spa$Generated$Route$Companies__CompanyId_String__InvoiceSettings(
		{fZ: ''}),
		$author$project$Spa$Generated$Route$Companies__CompanyId_String__Notes(
		{fZ: ''}),
		$author$project$Spa$Generated$Route$Companies__CompanyId_String__Notifications(
		{fZ: ''}),
		$author$project$Spa$Generated$Route$Companies__CompanyId_String__PaymentSources(
		{fZ: ''}),
		$author$project$Spa$Generated$Route$Companies__CompanyId_String__Signup(
		{fZ: ''}),
		$author$project$Spa$Generated$Route$Messages__Fax__New,
		$author$project$Spa$Generated$Route$Messages__Faxes__New,
		$author$project$Spa$Generated$Route$Messages__Scheduled__New,
		$author$project$Spa$Generated$Route$Messages__ScheduledMessages__New,
		$author$project$Spa$Generated$Route$NewSettings__AppointmentTypes__New,
		$author$project$Spa$Generated$Route$NewSettings__Templates__New,
		$author$project$Spa$Generated$Route$Onboard__OnboardId_String__Completed(
		{ajz: ''}),
		$author$project$Spa$Generated$Route$Onboard__OnboardId_String__Completing(
		{ajz: ''}),
		$author$project$Spa$Generated$Route$Onboard__OnboardId_String__Payment(
		{ajz: ''}),
		$author$project$Spa$Generated$Route$Onboard__OnboardId_String__User(
		{ajz: ''}),
		$author$project$Spa$Generated$Route$Partner__Billing__Charges,
		$author$project$Spa$Generated$Route$Partner__Billing__Deposits,
		$author$project$Spa$Generated$Route$Partner__Billing__Hinter,
		$author$project$Spa$Generated$Route$Partner__Billing__ServiceFee,
		$author$project$Spa$Generated$Route$Partner__Billing__Subscriptions,
		$author$project$Spa$Generated$Route$Partner__Products__New,
		$author$project$Spa$Generated$Route$Partner__Webhooks__Requests,
		$author$project$Spa$Generated$Route$Partner__Webhooks__Settings,
		$author$project$Spa$Generated$Route$Patients__PatientId_String__Chart(
		{YZ: ''}),
		$author$project$Spa$Generated$Route$Patients__PatientId_String__Edit(
		{YZ: ''}),
		$author$project$Spa$Generated$Route$Patients__PatientId_String__GrowthChart(
		{YZ: ''}),
		$author$project$Spa$Generated$Route$Patients__PatientId_String__LabTrends(
		{YZ: ''}),
		$author$project$Spa$Generated$Route$Patients__PatientId_String__ManageCredits(
		{YZ: ''}),
		$author$project$Spa$Generated$Route$Patients__PatientId_String__Merge(
		{YZ: ''}),
		$author$project$Spa$Generated$Route$Patients__PatientId_String__VitalsTrends(
		{YZ: ''}),
		$author$project$Spa$Generated$Route$PracticeSetup__Plans__New,
		$author$project$Spa$Generated$Route$Reports__CreditOutstanding__Summary,
		$author$project$Spa$Generated$Route$Reports__CreditTransactions__Summary,
		$author$project$Spa$Generated$Route$Reports__Custom__New,
		$author$project$Spa$Generated$Route$Reports__DeferredRevenue__Summary,
		$author$project$Spa$Generated$Route$Reports__PaymentApplications__Summary,
		$author$project$Spa$Generated$Route$Reports__Revenue__Summary,
		$author$project$Spa$Generated$Route$Reports__SalesTax__Summary,
		$author$project$Spa$Generated$Route$Admin__ChargeItems__Id_String(
		{ahP: ''}),
		$author$project$Spa$Generated$Route$Admin__CompanyPlans__Id_String(
		{ahP: ''}),
		$author$project$Spa$Generated$Route$Admin__CoveragePlans__Id_String(
		{ahP: ''}),
		$author$project$Spa$Generated$Route$Admin__DataExport__Id_String(
		{ahP: ''}),
		$author$project$Spa$Generated$Route$Admin__DataExportSettings__Id_String(
		{ahP: ''}),
		$author$project$Spa$Generated$Route$Admin__Documents__Id_String(
		{ahP: ''}),
		$author$project$Spa$Generated$Route$Admin__Integrations__Slug_String(
		{abG: ''}),
		$author$project$Spa$Generated$Route$Admin__Plans__Id_String(
		{ahP: ''}),
		$author$project$Spa$Generated$Route$Admin__SignupPages__Id_String(
		{ahP: ''}),
		$author$project$Spa$Generated$Route$Hinter__AdminUsersGroups__Id_String(
		{ahP: ''}),
		$author$project$Spa$Generated$Route$Messages__Faxes__MessageId_String(
		{aiI: ''}),
		$author$project$Spa$Generated$Route$Messages__Sms__PhoneNumber_String(
		{Zx: ''}),
		$author$project$Spa$Generated$Route$NewSettings__AppointmentTypes__Ident_String(
		{ahQ: ''}),
		$author$project$Spa$Generated$Route$NewSettings__Locations__BookingLocationId_String(
		{afk: ''}),
		$author$project$Spa$Generated$Route$NewSettings__Team__TeamId_String(
		{alX: ''}),
		$author$project$Spa$Generated$Route$NewSettings__Templates__TemplateId_String(
		{alY: ''}),
		$author$project$Spa$Generated$Route$Partner__Products__Id_String(
		{ahP: ''}),
		$author$project$Spa$Generated$Route$Reports__AncillaryCharges__Id_String(
		{ahP: ''}),
		$author$project$Spa$Generated$Route$Reports__Custom__Id_String(
		{ahP: ''}),
		$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Top(
		{rd: ''}),
		$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Top(
		{cm: ''}),
		$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top(
		{fZ: ''}),
		$author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Top(
		{fZ: ''}),
		$author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__Top(
		{fZ: ''}),
		$author$project$Spa$Generated$Route$Messages__Scheduled__ScheduledId_String__Top(
		{ald: ''}),
		$author$project$Spa$Generated$Route$Messages__ScheduledMessages__ScheduledEventId_String__Top(
		{alc: ''}),
		$author$project$Spa$Generated$Route$Patients__PatientId_String__Accounts__Top(
		{YZ: ''}),
		$author$project$Spa$Generated$Route$Patients__PatientId_String__Affiliation__Top(
		{YZ: ''}),
		$author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__Top(
		{YZ: ''}),
		$author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__Top(
		{YZ: ''}),
		$author$project$Spa$Generated$Route$Patients__PatientId_String__Notes__Top(
		{YZ: ''}),
		$author$project$Spa$Generated$Route$Patients__PatientId_String__Notifications__Top(
		{YZ: ''}),
		$author$project$Spa$Generated$Route$Admin__Notifications__Patient__DunningSchedule,
		$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Deals(
		{cm: ''}),
		$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__EndedDeals(
		{cm: ''}),
		$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Create(
		{fZ: ''}),
		$author$project$Spa$Generated$Route$Companies__CompanyId_String__SignupPages__New(
		{fZ: ''}),
		$author$project$Spa$Generated$Route$Marketplace__Athenahealth__Manage__Settings,
		$author$project$Spa$Generated$Route$Marketplace__Bookkeeping__Manage__Settings,
		$author$project$Spa$Generated$Route$Marketplace__Elation__Manage__Settings,
		$author$project$Spa$Generated$Route$Marketplace__Quickbooks__Manage__Settings,
		$author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Onboarding(
		{abG: ''}),
		$author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Settings(
		{abG: ''}),
		$author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Users(
		{abG: ''}),
		$author$project$Spa$Generated$Route$NewSettings__Team__TeamId_String__AiSettings(
		{alX: ''}),
		$author$project$Spa$Generated$Route$NewSettings__Team__TeamId_String__BasicInfo(
		{alX: ''}),
		$author$project$Spa$Generated$Route$NewSettings__Team__TeamId_String__CalendarAndAvailability(
		{alX: ''}),
		$author$project$Spa$Generated$Route$Partner__Products__Id_String__ActivationSettings(
		{ahP: ''}),
		$author$project$Spa$Generated$Route$Partner__Products__Id_String__AppBuilder(
		{ahP: ''}),
		$author$project$Spa$Generated$Route$Partner__Products__Id_String__AppSettings(
		{ahP: ''}),
		$author$project$Spa$Generated$Route$Partner__Products__Id_String__Hinter(
		{ahP: ''}),
		$author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__New(
		{YZ: ''}),
		$author$project$Spa$Generated$Route$PracticeSetup__Plans__Id_String__Edit(
		{ahP: ''}),
		$author$project$Spa$Generated$Route$Admin__Billing__PracticeInvoices__Id_String(
		{ahP: ''}),
		$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Id_String(
		{rd: '', ahP: ''}),
		$author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String(
		{fZ: '', ahP: ''}),
		$author$project$Spa$Generated$Route$Companies__CompanyId_String__SignupPages__Id_String(
		{fZ: '', ahP: ''}),
		$author$project$Spa$Generated$Route$Messages__Sms__PhoneNumber_String__PracticeNumber_String(
		{Zx: '', aj7: ''}),
		$author$project$Spa$Generated$Route$Messages__V2__Faxes__MessageId_String(
		{aiI: ''}),
		$author$project$Spa$Generated$Route$NewSettings__Locations__New__LocationId_String(
		{We: ''}),
		$author$project$Spa$Generated$Route$Patients__PatientId_String__Notes__NoteId_String(
		{ai7: '', YZ: ''}),
		$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top(
		{cm: ''}),
		$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__Top(
		{cm: ''}),
		$author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__UploadId_String__Top(
		{fZ: '', Kj: ''}),
		$author$project$Spa$Generated$Route$Patients__PatientId_String__Agreements__AgreementId_String__Top(
		{Ll: '', YZ: ''}),
		$author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top(
		{Us: '', YZ: ''}),
		$author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__MembershipId_String__Top(
		{AW: '', YZ: ''}),
		$author$project$Spa$Generated$Route$Admin__Plans__Id_String__PricingVersions__New(
		{ahP: ''}),
		$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Ended(
		{cm: ''}),
		$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__New(
		{cm: ''}),
		$author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__UploadId_String__UploadResults(
		{fZ: '', Kj: ''}),
		$author$project$Spa$Generated$Route$Admin__Plans__Id_String__PricingVersions__PricingVersionId_String(
		{ahP: '', akh: ''}),
		$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__StatementId_String(
		{cm: '', alG: ''}),
		$author$project$Spa$Generated$Route$Messages__Legacy__Sms__PatientPhoneNumber_String__PracticePhoneNumber_String(
		{ajT: '', aj8: ''}),
		$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__BrokerId_String__Top(
		{cm: '', GN: ''}),
		$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__EmployeeId_String__Dependent__DependentId_String__Top(
		{fZ: '', agp: '', agM: ''})
	]);
var $author$project$Layouts$StyleGuide$routeLabel = function (route) {
	switch (route.$) {
		case 120:
			return $elm$core$Maybe$Just('Button');
		case 135:
			return $elm$core$Maybe$Just('Grid');
		case 165:
			return $elm$core$Maybe$Just('Well');
		case 137:
			return $elm$core$Maybe$Just('Horizontal Rule');
		case 138:
			return $elm$core$Maybe$Just('Icon');
		case 143:
			return $elm$core$Maybe$Just('Ordered List');
		case 150:
			return $elm$core$Maybe$Just('Pre');
		case 145:
			return $elm$core$Maybe$Just('Panel');
		case 158:
			return $elm$core$Maybe$Just('Table');
		case 160:
			return $elm$core$Maybe$Just('Toggle Switch');
		case 116:
			return $elm$core$Maybe$Just('Activity Indicators');
		case 162:
			return $elm$core$Maybe$Just('Typography');
		case 140:
			return $elm$core$Maybe$Just('Link');
		case 159:
			return $elm$core$Maybe$Just('Toast');
		case 151:
			return $elm$core$Maybe$Just('Progress Bar');
		case 118:
			return $elm$core$Maybe$Just('Alert');
		case 132:
			return $elm$core$Maybe$Just('Form');
		case 122:
			return $elm$core$Maybe$Just('Form > Checkbox');
		case 139:
			return $elm$core$Maybe$Just('Form > Input');
		case 133:
			return $elm$core$Maybe$Just('Form > Group');
		case 144:
			return $elm$core$Maybe$Just('Pagination');
		case 148:
			return $elm$core$Maybe$Just('Phone Input');
		case 142:
			return $elm$core$Maybe$Just('Modal');
		case 136:
			return $elm$core$Maybe$Just('Hi Confirm');
		case 119:
			return $elm$core$Maybe$Just('Badge');
		case 161:
			return $elm$core$Maybe$Just('Tooltip');
		case 131:
			return $elm$core$Maybe$Just('Flyout Menu');
		case 149:
			return $elm$core$Maybe$Just('Popover');
		case 129:
			return $elm$core$Maybe$Just('Export Csv');
		case 141:
			return $elm$core$Maybe$Just('List Group');
		case 146:
			return $elm$core$Maybe$Just('Form > Password Input');
		case 134:
			return $elm$core$Maybe$Just('Form > Static');
		case 130:
			return $elm$core$Maybe$Just('Form > File Input');
		case 125:
			return $elm$core$Maybe$Just('Date Range Input');
		case 147:
			return $elm$core$Maybe$Just('Payment Source Displayer');
		case 164:
			return $elm$core$Maybe$Just('Upload > Result');
		case 163:
			return $elm$core$Maybe$Just('Upload > Form');
		case 153:
			return $elm$core$Maybe$Just('Resource Filter');
		case 123:
			return $elm$core$Maybe$Just('Form > Currency Input');
		case 155:
			return $elm$core$Maybe$Just('Form > Select');
		case 124:
			return $elm$core$Maybe$Just('Date Input');
		case 154:
			return $elm$core$Maybe$Just('Search Input');
		case 117:
			return $elm$core$Maybe$Just('Address Input');
		case 156:
			return $elm$core$Maybe$Just('Skeleton');
		case 157:
			return $elm$core$Maybe$Just('Spinner');
		case 127:
			return $elm$core$Maybe$Just('Dropdown | Select');
		case 121:
			return $elm$core$Maybe$Just('Carousel');
		case 126:
			return $elm$core$Maybe$Just('Drag & Drop');
		case 128:
			return $elm$core$Maybe$Just('Element');
		case 152:
			return $elm$core$Maybe$Just('Form > Radio');
		case 19:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Nothing;
		case 9:
			return $elm$core$Maybe$Nothing;
		case 170:
			return $elm$core$Maybe$Nothing;
		case 31:
			return $elm$core$Maybe$Nothing;
		case 33:
			return $elm$core$Maybe$Nothing;
		case 44:
			return $elm$core$Maybe$Nothing;
		case 169:
			return $elm$core$Maybe$Nothing;
		case 171:
			return $elm$core$Maybe$Nothing;
		case 45:
			return $elm$core$Maybe$Nothing;
		case 24:
			return $elm$core$Maybe$Nothing;
		case 35:
			return $elm$core$Maybe$Nothing;
		case 115:
			return $elm$core$Maybe$Nothing;
		case 111:
			return $elm$core$Maybe$Nothing;
		case 39:
			return $elm$core$Maybe$Nothing;
		case 104:
			return $elm$core$Maybe$Nothing;
		case 110:
			return $elm$core$Maybe$Nothing;
		case 23:
			return $elm$core$Maybe$Nothing;
		case 10:
			return $elm$core$Maybe$Nothing;
		case 217:
			return $elm$core$Maybe$Nothing;
		case 92:
			return $elm$core$Maybe$Nothing;
		case 46:
			return $elm$core$Maybe$Nothing;
		case 114:
			return $elm$core$Maybe$Nothing;
		case 288:
			return $elm$core$Maybe$Nothing;
		case 56:
			return $elm$core$Maybe$Nothing;
		case 205:
			return $elm$core$Maybe$Nothing;
		case 306:
			return $elm$core$Maybe$Nothing;
		case 106:
			return $elm$core$Maybe$Nothing;
		case 101:
			return $elm$core$Maybe$Nothing;
		case 108:
			return $elm$core$Maybe$Nothing;
		case 102:
			return $elm$core$Maybe$Nothing;
		case 282:
			return $elm$core$Maybe$Nothing;
		case 103:
			return $elm$core$Maybe$Nothing;
		case 283:
			return $elm$core$Maybe$Nothing;
		case 112:
			return $elm$core$Maybe$Nothing;
		case 286:
			return $elm$core$Maybe$Nothing;
		case 113:
			return $elm$core$Maybe$Nothing;
		case 287:
			return $elm$core$Maybe$Nothing;
		case 105:
			return $elm$core$Maybe$Nothing;
		case 285:
			return $elm$core$Maybe$Nothing;
		case 284:
			return $elm$core$Maybe$Nothing;
		case 307:
			return $elm$core$Maybe$Nothing;
		case 109:
			return $elm$core$Maybe$Nothing;
		case 107:
			return $elm$core$Maybe$Nothing;
		case 29:
			return $elm$core$Maybe$Nothing;
		case 26:
			return $elm$core$Maybe$Nothing;
		case 32:
			return $elm$core$Maybe$Nothing;
		case 182:
			return $elm$core$Maybe$Nothing;
		case 225:
			return $elm$core$Maybe$Nothing;
		case 294:
			return $elm$core$Maybe$Nothing;
		case 230:
			return $elm$core$Maybe$Nothing;
		case 232:
			return $elm$core$Maybe$Nothing;
		case 229:
			return $elm$core$Maybe$Nothing;
		case 231:
			return $elm$core$Maybe$Nothing;
		case 233:
			return $elm$core$Maybe$Nothing;
		case 234:
			return $elm$core$Maybe$Nothing;
		case 321:
			return $elm$core$Maybe$Nothing;
		case 34:
			return $elm$core$Maybe$Nothing;
		case 38:
			return $elm$core$Maybe$Nothing;
		case 252:
			return $elm$core$Maybe$Nothing;
		case 253:
			return $elm$core$Maybe$Nothing;
		case 251:
			return $elm$core$Maybe$Nothing;
		case 50:
			return $elm$core$Maybe$Nothing;
		case 239:
			return $elm$core$Maybe$Nothing;
		case 83:
			return $elm$core$Maybe$Nothing;
		case 84:
			return $elm$core$Maybe$Nothing;
		case 303:
			return $elm$core$Maybe$Nothing;
		case 334:
			return $elm$core$Maybe$Nothing;
		case 335:
			return $elm$core$Maybe$Nothing;
		case 333:
			return $elm$core$Maybe$Nothing;
		case 80:
			return $elm$core$Maybe$Nothing;
		case 49:
			return $elm$core$Maybe$Nothing;
		case 36:
			return $elm$core$Maybe$Nothing;
		case 177:
			return $elm$core$Maybe$Nothing;
		case 213:
			return $elm$core$Maybe$Nothing;
		case 289:
			return $elm$core$Maybe$Nothing;
		case 214:
			return $elm$core$Maybe$Nothing;
		case 179:
			return $elm$core$Maybe$Nothing;
		case 216:
			return $elm$core$Maybe$Nothing;
		case 291:
			return $elm$core$Maybe$Nothing;
		case 185:
			return $elm$core$Maybe$Nothing;
		case 237:
			return $elm$core$Maybe$Nothing;
		case 51:
			return $elm$core$Maybe$Nothing;
		case 187:
			return $elm$core$Maybe$Nothing;
		case 238:
			return $elm$core$Maybe$Nothing;
		case 297:
			return $elm$core$Maybe$Nothing;
		case 22:
			return $elm$core$Maybe$Nothing;
		case 236:
			return $elm$core$Maybe$Nothing;
		case 184:
			return $elm$core$Maybe$Nothing;
		case 296:
			return $elm$core$Maybe$Nothing;
		case 215:
			return $elm$core$Maybe$Nothing;
		case 178:
			return $elm$core$Maybe$Nothing;
		case 290:
			return $elm$core$Maybe$Nothing;
		case 27:
			return $elm$core$Maybe$Nothing;
		case 30:
			return $elm$core$Maybe$Nothing;
		case 48:
			return $elm$core$Maybe$Nothing;
		case 37:
			return $elm$core$Maybe$Nothing;
		case 28:
			return $elm$core$Maybe$Nothing;
		case 311:
			return $elm$core$Maybe$Nothing;
		case 344:
			return $elm$core$Maybe$Nothing;
		case 43:
			return $elm$core$Maybe$Nothing;
		case 2:
			return $elm$core$Maybe$Nothing;
		case 65:
			return $elm$core$Maybe$Nothing;
		case 60:
			return $elm$core$Maybe$Nothing;
		case 64:
			return $elm$core$Maybe$Nothing;
		case 63:
			return $elm$core$Maybe$Nothing;
		case 61:
			return $elm$core$Maybe$Nothing;
		case 193:
			return $elm$core$Maybe$Nothing;
		case 298:
			return $elm$core$Maybe$Nothing;
		case 62:
			return $elm$core$Maybe$Nothing;
		case 17:
			return $elm$core$Maybe$Nothing;
		case 42:
			return $elm$core$Maybe$Nothing;
		case 41:
			return $elm$core$Maybe$Nothing;
		case 40:
			return $elm$core$Maybe$Nothing;
		case 235:
			return $elm$core$Maybe$Nothing;
		case 254:
			return $elm$core$Maybe$Nothing;
		case 342:
			return $elm$core$Maybe$Nothing;
		case 310:
			return $elm$core$Maybe$Nothing;
		case 324:
			return $elm$core$Maybe$Nothing;
		case 364:
			return $elm$core$Maybe$Nothing;
		case 248:
			return $elm$core$Maybe$Nothing;
		case 250:
			return $elm$core$Maybe$Nothing;
		case 191:
			return $elm$core$Maybe$Nothing;
		case 14:
			return $elm$core$Maybe$Nothing;
		case 25:
			return $elm$core$Maybe$Nothing;
		case 189:
			return $elm$core$Maybe$Nothing;
		case 246:
			return $elm$core$Maybe$Nothing;
		case 309:
			return $elm$core$Maybe$Nothing;
		case 322:
			return $elm$core$Maybe$Nothing;
		case 350:
			return $elm$core$Maybe$Nothing;
		case 358:
			return $elm$core$Maybe$Nothing;
		case 363:
			return $elm$core$Maybe$Nothing;
		case 357:
			return $elm$core$Maybe$Nothing;
		case 351:
			return $elm$core$Maybe$Nothing;
		case 55:
			return $elm$core$Maybe$Nothing;
		case 361:
			return $elm$core$Maybe$Nothing;
		case 323:
			return $elm$core$Maybe$Nothing;
		case 190:
			return $elm$core$Maybe$Nothing;
		case 247:
			return $elm$core$Maybe$Nothing;
		case 204:
			return $elm$core$Maybe$Nothing;
		case 275:
			return $elm$core$Maybe$Nothing;
		case 279:
			return $elm$core$Maybe$Nothing;
		case 278:
			return $elm$core$Maybe$Nothing;
		case 353:
			return $elm$core$Maybe$Nothing;
		case 13:
			return $elm$core$Maybe$Nothing;
		case 53:
			return $elm$core$Maybe$Nothing;
		case 308:
			return $elm$core$Maybe$Nothing;
		case 241:
			return $elm$core$Maybe$Nothing;
		case 242:
			return $elm$core$Maybe$Nothing;
		case 245:
			return $elm$core$Maybe$Nothing;
		case 12:
			return $elm$core$Maybe$Nothing;
		case 343:
			return $elm$core$Maybe$Nothing;
		case 52:
			return $elm$core$Maybe$Nothing;
		case 240:
			return $elm$core$Maybe$Nothing;
		case 295:
			return $elm$core$Maybe$Nothing;
		case 312:
			return $elm$core$Maybe$Nothing;
		case 352:
			return $elm$core$Maybe$Nothing;
		case 249:
			return $elm$core$Maybe$Nothing;
		case 359:
			return $elm$core$Maybe$Nothing;
		case 174:
			return $elm$core$Maybe$Nothing;
		case 7:
			return $elm$core$Maybe$Nothing;
		case 8:
			return $elm$core$Maybe$Nothing;
		case 85:
			return $elm$core$Maybe$Nothing;
		case 166:
			return $elm$core$Maybe$Nothing;
		case 243:
			return $elm$core$Maybe$Nothing;
		case 91:
			return $elm$core$Maybe$Nothing;
		case 244:
			return $elm$core$Maybe$Nothing;
		case 354:
			return $elm$core$Maybe$Nothing;
		case 47:
			return $elm$core$Maybe$Nothing;
		case 54:
			return $elm$core$Maybe$Nothing;
		case 315:
			return $elm$core$Maybe$Nothing;
		case 317:
			return $elm$core$Maybe$Nothing;
		case 318:
			return $elm$core$Maybe$Nothing;
		case 340:
			return $elm$core$Maybe$Nothing;
		case 355:
			return $elm$core$Maybe$Nothing;
		case 319:
			return $elm$core$Maybe$Nothing;
		case 320:
			return $elm$core$Maybe$Nothing;
		case 255:
			return $elm$core$Maybe$Nothing;
		case 207:
			return $elm$core$Maybe$Nothing;
		case 316:
			return $elm$core$Maybe$Nothing;
		case 325:
			return $elm$core$Maybe$Nothing;
		case 345:
			return $elm$core$Maybe$Nothing;
		case 183:
			return $elm$core$Maybe$Nothing;
		case 226:
			return $elm$core$Maybe$Nothing;
		case 228:
			return $elm$core$Maybe$Nothing;
		case 227:
			return $elm$core$Maybe$Nothing;
		case 186:
			return $elm$core$Maybe$Nothing;
		case 176:
			return $elm$core$Maybe$Nothing;
		case 209:
			return $elm$core$Maybe$Nothing;
		case 210:
			return $elm$core$Maybe$Nothing;
		case 208:
			return $elm$core$Maybe$Nothing;
		case 212:
			return $elm$core$Maybe$Nothing;
		case 211:
			return $elm$core$Maybe$Nothing;
		case 181:
			return $elm$core$Maybe$Nothing;
		case 218:
			return $elm$core$Maybe$Nothing;
		case 293:
			return $elm$core$Maybe$Nothing;
		case 180:
			return $elm$core$Maybe$Nothing;
		case 292:
			return $elm$core$Maybe$Nothing;
		case 219:
			return $elm$core$Maybe$Nothing;
		case 220:
			return $elm$core$Maybe$Nothing;
		case 221:
			return $elm$core$Maybe$Nothing;
		case 223:
			return $elm$core$Maybe$Nothing;
		case 224:
			return $elm$core$Maybe$Nothing;
		case 222:
			return $elm$core$Maybe$Nothing;
		case 168:
			return $elm$core$Maybe$Nothing;
		case 173:
			return $elm$core$Maybe$Nothing;
		case 0:
			return $elm$core$Maybe$Nothing;
		case 200:
			return $elm$core$Maybe$Nothing;
		case 264:
			return $elm$core$Maybe$Nothing;
		case 265:
			return $elm$core$Maybe$Nothing;
		case 263:
			return $elm$core$Maybe$Nothing;
		case 262:
			return $elm$core$Maybe$Nothing;
		case 18:
			return $elm$core$Maybe$Nothing;
		case 93:
			return $elm$core$Maybe$Nothing;
		case 99:
			return $elm$core$Maybe$Nothing;
		case 281:
			return $elm$core$Maybe$Nothing;
		case 341:
			return $elm$core$Maybe$Nothing;
		case 96:
			return $elm$core$Maybe$Nothing;
		case 98:
			return $elm$core$Maybe$Nothing;
		case 100:
			return $elm$core$Maybe$Nothing;
		case 94:
			return $elm$core$Maybe$Nothing;
		case 97:
			return $elm$core$Maybe$Nothing;
		case 95:
			return $elm$core$Maybe$Nothing;
		case 90:
			return $elm$core$Maybe$Nothing;
		case 305:
			return $elm$core$Maybe$Nothing;
		case 86:
			return $elm$core$Maybe$Nothing;
		case 273:
			return $elm$core$Maybe$Nothing;
		case 272:
			return $elm$core$Maybe$Nothing;
		case 202:
			return $elm$core$Maybe$Nothing;
		case 89:
			return $elm$core$Maybe$Nothing;
		case 356:
			return $elm$core$Maybe$Nothing;
		case 360:
			return $elm$core$Maybe$Nothing;
		case 338:
			return $elm$core$Maybe$Nothing;
		case 201:
			return $elm$core$Maybe$Nothing;
		case 271:
			return $elm$core$Maybe$Nothing;
		case 336:
			return $elm$core$Maybe$Nothing;
		case 339:
			return $elm$core$Maybe$Nothing;
		case 337:
			return $elm$core$Maybe$Nothing;
		case 203:
			return $elm$core$Maybe$Nothing;
		case 266:
			return $elm$core$Maybe$Nothing;
		case 268:
			return $elm$core$Maybe$Nothing;
		case 267:
			return $elm$core$Maybe$Nothing;
		case 269:
			return $elm$core$Maybe$Nothing;
		case 270:
			return $elm$core$Maybe$Nothing;
		case 87:
			return $elm$core$Maybe$Nothing;
		case 88:
			return $elm$core$Maybe$Nothing;
		case 172:
			return $elm$core$Maybe$Nothing;
		case 16:
			return $elm$core$Maybe$Nothing;
		case 175:
			return $elm$core$Maybe$Nothing;
		case 330:
			return $elm$core$Maybe$Nothing;
		case 332:
			return $elm$core$Maybe$Nothing;
		case 331:
			return $elm$core$Maybe$Nothing;
		case 327:
			return $elm$core$Maybe$Nothing;
		case 329:
			return $elm$core$Maybe$Nothing;
		case 328:
			return $elm$core$Maybe$Nothing;
		case 326:
			return $elm$core$Maybe$Nothing;
		case 69:
			return $elm$core$Maybe$Nothing;
		case 3:
			return $elm$core$Maybe$Nothing;
		case 6:
			return $elm$core$Maybe$Nothing;
		case 274:
			return $elm$core$Maybe$Nothing;
		case 57:
			return $elm$core$Maybe$Nothing;
		case 58:
			return $elm$core$Maybe$Nothing;
		case 192:
			return $elm$core$Maybe$Nothing;
		case 15:
			return $elm$core$Maybe$Nothing;
		case 59:
			return $elm$core$Maybe$Nothing;
		case 4:
			return $elm$core$Maybe$Nothing;
		case 66:
			return $elm$core$Maybe$Nothing;
		case 67:
			return $elm$core$Maybe$Nothing;
		case 194:
			return $elm$core$Maybe$Nothing;
		case 68:
			return $elm$core$Maybe$Nothing;
		case 77:
			return $elm$core$Maybe$Nothing;
		case 300:
			return $elm$core$Maybe$Nothing;
		case 346:
			return $elm$core$Maybe$Nothing;
		case 362:
			return $elm$core$Maybe$Nothing;
		case 71:
			return $elm$core$Maybe$Nothing;
		case 70:
			return $elm$core$Maybe$Nothing;
		case 76:
			return $elm$core$Maybe$Nothing;
		case 75:
			return $elm$core$Maybe$Nothing;
		case 74:
			return $elm$core$Maybe$Nothing;
		case 195:
			return $elm$core$Maybe$Nothing;
		case 257:
			return $elm$core$Maybe$Nothing;
		case 299:
			return $elm$core$Maybe$Nothing;
		case 256:
			return $elm$core$Maybe$Nothing;
		case 347:
			return $elm$core$Maybe$Nothing;
		case 73:
			return $elm$core$Maybe$Nothing;
		case 72:
			return $elm$core$Maybe$Nothing;
		case 196:
			return $elm$core$Maybe$Nothing;
		case 258:
			return $elm$core$Maybe$Nothing;
		case 313:
			return $elm$core$Maybe$Nothing;
		case 259:
			return $elm$core$Maybe$Nothing;
		case 314:
			return $elm$core$Maybe$Nothing;
		case 20:
			return $elm$core$Maybe$Nothing;
		case 167:
			return $elm$core$Maybe$Nothing;
		case 206:
			return $elm$core$Maybe$Nothing;
		case 197:
			return $elm$core$Maybe$Nothing;
		case 260:
			return $elm$core$Maybe$Nothing;
		case 301:
			return $elm$core$Maybe$Nothing;
		case 198:
			return $elm$core$Maybe$Nothing;
		case 302:
			return $elm$core$Maybe$Nothing;
		case 348:
			return $elm$core$Maybe$Nothing;
		case 199:
			return $elm$core$Maybe$Nothing;
		case 261:
			return $elm$core$Maybe$Nothing;
		case 304:
			return $elm$core$Maybe$Nothing;
		case 82:
			return $elm$core$Maybe$Nothing;
		case 5:
			return $elm$core$Maybe$Nothing;
		case 79:
			return $elm$core$Maybe$Nothing;
		case 78:
			return $elm$core$Maybe$Nothing;
		case 81:
			return $elm$core$Maybe$Nothing;
		case 349:
			return $elm$core$Maybe$Nothing;
		case 276:
			return $elm$core$Maybe$Nothing;
		case 277:
			return $elm$core$Maybe$Nothing;
		case 280:
			return $elm$core$Maybe$Nothing;
		case 11:
			return $elm$core$Maybe$Nothing;
		case 188:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Layouts$StyleGuide$menuItems = A2(
	$elm$core$List$sortBy,
	$elm$core$Tuple$second,
	A2(
		$elm$core$List$filterMap,
		function (route) {
			return A2(
				$elm$core$Maybe$map,
				function (label) {
					return _Utils_Tuple2(route, label);
				},
				$author$project$Layouts$StyleGuide$routeLabel(route));
		},
		$author$project$Spa$Generated$Route$all));
var $author$project$Layouts$StyleGuide$viewHeader = $author$project$Ui$Typography$heading(
	_List_fromArray(
		[
			A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href(
					$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$StyleGuide__Typography))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Hint Legos')
				]))
		]));
var $author$project$Layouts$StyleGuide$viewMenuItem = F2(
	function (currentUrl, _v0) {
		var route = _v0.a;
		var linkText = _v0.b;
		var stringRoute = $author$project$Spa$Generated$Route$toString(route);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'active',
							A2($elm$core$String$contains, stringRoute, currentUrl))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(stringRoute)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(linkText)
						]))
				]));
	});
var $author$project$Layouts$StyleGuide$view = F2(
	function (_v0, body) {
		var url = _v0.adY;
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Layouts$StyleGuide$viewHeader,
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Grid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$spanSm(4),
												$author$project$Ui$Grid$spanMd(3),
												$author$project$Ui$Grid$spanLg(2)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('')
													]),
												A2(
													$elm$core$List$map,
													$author$project$Layouts$StyleGuide$viewMenuItem(
														$elm$url$Url$toString(url)),
													$author$project$Layouts$StyleGuide$menuItems))
											])),
										A2(
										$author$project$Ui$Grid$column,
										_List_fromArray(
											[
												$author$project$Ui$Grid$spanSm(8),
												$author$project$Ui$Grid$spanMd(9),
												$author$project$Ui$Grid$spanLg(10)
											]),
										body)
									]))
							]))
					]))
			]);
	});
var $author$project$Layouts$User$viewNav = F2(
	function (currentRoute, nav) {
		return A3(
			$author$project$Ui$Nav$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route($author$project$Spa$Generated$Route$User__Profile),
							$author$project$Ui$Nav$activeItem(
							_Utils_eq(currentRoute, $author$project$Spa$Generated$Route$User__Profile))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('General')
						])),
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route($author$project$Spa$Generated$Route$User__Security),
							$author$project$Ui$Nav$activeItem(
							_Utils_eq(currentRoute, $author$project$Spa$Generated$Route$User__Security))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Security')
						]))
				]),
			nav);
	});
var $author$project$Layouts$User$view = F4(
	function (toMsg, _v0, _v1, body) {
		var url = _v0.adY;
		var nav = _v1.kp;
		var currentRoute = $author$project$Utils$Route$fromUrl(url);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('nav-panel nav-panel-header')
					]),
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$map,
						toMsg,
						A2($author$project$Layouts$User$viewNav, currentRoute, nav)),
					body))
			]);
	});
var $author$project$Spa$Layout$view = F5(
	function (toMainMsg, layout, shared, toSharedMsg, body) {
		if (shared.ahq.agL) {
			return $author$project$Layouts$Blank$view(body);
		} else {
			switch (layout.$) {
				case 0:
					return A2($author$project$Layouts$StyleGuide$view, shared, body);
				case 18:
					return A2($author$project$Layouts$Onboard$view, shared, body);
				case 15:
					return $author$project$Layouts$Blank$view(body);
				case 16:
					return _List_Nil;
				case 17:
					var layoutModel = layout.b;
					return A3($author$project$Layouts$PatientChart$view, shared, layoutModel, body);
				case 1:
					return $author$project$Layouts$Application$view(body);
				case 4:
					var layoutModel = layout.a;
					return A4(
						$author$project$Layouts$Commissions$view,
						A2($elm$core$Basics$composeR, $author$project$Spa$Layout$CommissionsMsg, toMainMsg),
						shared,
						layoutModel,
						body);
				case 5:
					var layoutModel = layout.b;
					return A4(
						$author$project$Layouts$Commissions$BrokerAccount$view,
						A2($elm$core$Basics$composeR, $author$project$Spa$Layout$CommissionsBrokerAccountMsg, toMainMsg),
						shared,
						layoutModel,
						body);
				case 6:
					var layoutModel = layout.a;
					return A4(
						$author$project$Layouts$Affiliates$view,
						A2($elm$core$Basics$composeR, $author$project$Spa$Layout$AffiliatesMsg, toMainMsg),
						shared,
						layoutModel,
						body);
				case 20:
					return A2($author$project$Layouts$PracticeSetup$view, shared, body);
				case 7:
					var layoutModel = layout.b;
					return A4(
						$author$project$Layouts$Affiliates$Affiliate$view,
						A2($elm$core$Basics$composeR, $author$project$Spa$Layout$AffiliatesAffiliateMsg, toMainMsg),
						shared,
						layoutModel,
						body);
				case 8:
					var layoutModel = layout.a;
					return A4(
						$author$project$Layouts$Partner$Billing$view,
						A2($elm$core$Basics$composeR, $author$project$Spa$Layout$PartnerBillingMsg, toMainMsg),
						shared,
						layoutModel,
						body);
				case 9:
					var layoutModel = layout.a;
					return A4(
						$author$project$Layouts$Partner$Practices$view,
						A2($elm$core$Basics$composeR, $author$project$Spa$Layout$PartnerPracticesMsg, toMainMsg),
						shared,
						layoutModel,
						body);
				case 10:
					var layoutModel = layout.a;
					return A4(
						$author$project$Layouts$Partner$Product$view,
						A2($elm$core$Basics$composeR, $author$project$Spa$Layout$PartnerProductMsg, toMainMsg),
						shared,
						layoutModel,
						body);
				case 11:
					var layoutModel = layout.a;
					return A4(
						$author$project$Layouts$Partner$Webhooks$view,
						A2($elm$core$Basics$composeR, $author$project$Spa$Layout$PartnerWebhooksMsg, toMainMsg),
						shared,
						layoutModel,
						body);
				case 12:
					var layoutModel = layout.b;
					return A4(
						$author$project$Layouts$Marketplace$Manage$view,
						A2($elm$core$Basics$composeR, $author$project$Spa$Layout$MarketplaceManageMsg, toMainMsg),
						shared,
						layoutModel,
						body);
				case 3:
					var layoutModel = layout.b;
					return A5(
						$author$project$Layouts$Patient$view,
						A2($elm$core$Basics$composeR, $author$project$Spa$Layout$PatientMsg, toMainMsg),
						toSharedMsg,
						shared,
						layoutModel,
						body);
				case 2:
					var _v1 = shared.ajU;
					if (!_v1.$) {
						var patientsList = _v1.a;
						return A3($author$project$Layouts$PatientsSidebar$view, toSharedMsg, patientsList, body);
					} else {
						return body;
					}
				case 13:
					var layoutModel = layout.b;
					return A4(
						$author$project$Layouts$Company$view,
						A2($elm$core$Basics$composeR, $author$project$Spa$Layout$CompanyMsg, toMainMsg),
						shared,
						layoutModel,
						body);
				case 14:
					var layoutModel = layout.a;
					return A4(
						$author$project$Layouts$Admin$view,
						A2($elm$core$Basics$composeR, $author$project$Spa$Layout$AdminMsg, toMainMsg),
						shared,
						layoutModel,
						body);
				default:
					var layoutModel = layout.a;
					return A4(
						$author$project$Layouts$User$view,
						A2($elm$core$Basics$composeR, $author$project$Spa$Layout$UserMsg, toMainMsg),
						shared,
						layoutModel,
						body);
			}
		}
	});
var $author$project$Main$view = function (model) {
	return A2(
		$author$project$Shared$view,
		{
			aia: $author$project$Main$isClinicalLayout(model.bE),
			bE: A3($author$project$Spa$Layout$view, $author$project$Main$Layout, model.bE, model.lk),
			dB: A2(
				$author$project$Spa$Document$map,
				$author$project$Main$Pages,
				$author$project$Spa$Generated$Pages$view(model.dB)),
			al6: $author$project$Main$Shared
		},
		model.lk);
};
var $author$project$Main$main = $elm$browser$Browser$element(
	{
		ah_: $author$project$Main$init,
		alO: $author$project$Main$subscriptions,
		adT: $author$project$Main$update,
		amo: A2($elm$core$Basics$composeR, $author$project$Main$view, $author$project$Spa$Document$toBrowserElement)
	});
_Platform_export({'Main':{'init':$author$project$Main$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (showRedesignToggle) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (sessionToken) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (release) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (providerAuthUrl) {
									return A2(
										$elm$json$Json$Decode$andThen,
										function (origin) {
											return A2(
												$elm$json$Json$Decode$andThen,
												function (nodeEnv) {
													return A2(
														$elm$json$Json$Decode$andThen,
														function (locationHref) {
															return A2(
																$elm$json$Json$Decode$andThen,
																function (intercomAppId) {
																	return A2(
																		$elm$json$Json$Decode$andThen,
																		function (images) {
																			return A2(
																				$elm$json$Json$Decode$andThen,
																				function (hinterViewOff) {
																					return A2(
																						$elm$json$Json$Decode$andThen,
																						function (hintEnv) {
																							return A2(
																								$elm$json$Json$Decode$andThen,
																								function (emrHost) {
																									return A2(
																										$elm$json$Json$Decode$andThen,
																										function (embedded) {
																											return A2(
																												$elm$json$Json$Decode$andThen,
																												function (defaultHubspotDeal) {
																													return A2(
																														$elm$json$Json$Decode$andThen,
																														function (debugOrTest) {
																															return A2(
																																$elm$json$Json$Decode$andThen,
																																function (currentTime) {
																																	return A2(
																																		$elm$json$Json$Decode$andThen,
																																		function (currentRataDieDate) {
																																			return A2(
																																				$elm$json$Json$Decode$andThen,
																																				function (cannyAppId) {
																																					return A2(
																																						$elm$json$Json$Decode$andThen,
																																						function (backupAuthEnabled) {
																																							return A2(
																																								$elm$json$Json$Decode$andThen,
																																								function (apiVersion) {
																																									return A2(
																																										$elm$json$Json$Decode$andThen,
																																										function (apiUrl) {
																																											return $elm$json$Json$Decode$succeed(
																																												{aeZ: apiUrl, Gw: apiVersion, ae6: backupAuthEnabled, afr: cannyAppId, af2: currentRataDieDate, af3: currentTime, age: debugOrTest, agi: defaultHubspotDeal, agL: embedded, agP: emrHost, ahJ: hintEnv, ahK: hinterViewOff, TQ: images, ah1: intercomAppId, Wd: locationHref, aiY: nodeEnv, ajG: origin, Jp: providerAuthUrl, akL: release, alq: sessionToken, alw: showRedesignToggle});
																																										},
																																										A2($elm$json$Json$Decode$field, 'apiUrl', $elm$json$Json$Decode$string));
																																								},
																																								A2(
																																									$elm$json$Json$Decode$field,
																																									'apiVersion',
																																									$elm$json$Json$Decode$oneOf(
																																										_List_fromArray(
																																											[
																																												$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
																																												A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
																																											]))));
																																						},
																																						A2($elm$json$Json$Decode$field, 'backupAuthEnabled', $elm$json$Json$Decode$bool));
																																				},
																																				A2(
																																					$elm$json$Json$Decode$field,
																																					'cannyAppId',
																																					$elm$json$Json$Decode$oneOf(
																																						_List_fromArray(
																																							[
																																								$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
																																								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
																																							]))));
																																		},
																																		A2($elm$json$Json$Decode$field, 'currentRataDieDate', $elm$json$Json$Decode$int));
																																},
																																A2($elm$json$Json$Decode$field, 'currentTime', $elm$json$Json$Decode$int));
																														},
																														A2($elm$json$Json$Decode$field, 'debugOrTest', $elm$json$Json$Decode$bool));
																												},
																												A2(
																													$elm$json$Json$Decode$field,
																													'defaultHubspotDeal',
																													$elm$json$Json$Decode$oneOf(
																														_List_fromArray(
																															[
																																$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
																																A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
																															]))));
																										},
																										A2($elm$json$Json$Decode$field, 'embedded', $elm$json$Json$Decode$bool));
																								},
																								A2($elm$json$Json$Decode$field, 'emrHost', $elm$json$Json$Decode$string));
																						},
																						A2(
																							$elm$json$Json$Decode$field,
																							'hintEnv',
																							$elm$json$Json$Decode$oneOf(
																								_List_fromArray(
																									[
																										$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
																										A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
																									]))));
																				},
																				A2($elm$json$Json$Decode$field, 'hinterViewOff', $elm$json$Json$Decode$bool));
																		},
																		A2(
																			$elm$json$Json$Decode$field,
																			'images',
																			$elm$json$Json$Decode$list(
																				A2(
																					$elm$json$Json$Decode$andThen,
																					function (_v0) {
																						return A2(
																							$elm$json$Json$Decode$andThen,
																							function (_v1) {
																								return $elm$json$Json$Decode$succeed(
																									_Utils_Tuple2(_v0, _v1));
																							},
																							A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string));
																					},
																					A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string)))));
																},
																A2(
																	$elm$json$Json$Decode$field,
																	'intercomAppId',
																	$elm$json$Json$Decode$oneOf(
																		_List_fromArray(
																			[
																				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
																				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
																			]))));
														},
														A2($elm$json$Json$Decode$field, 'locationHref', $elm$json$Json$Decode$string));
												},
												A2(
													$elm$json$Json$Decode$field,
													'nodeEnv',
													$elm$json$Json$Decode$oneOf(
														_List_fromArray(
															[
																$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
																A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
															]))));
										},
										A2($elm$json$Json$Decode$field, 'origin', $elm$json$Json$Decode$string));
								},
								A2($elm$json$Json$Decode$field, 'providerAuthUrl', $elm$json$Json$Decode$string));
						},
						A2(
							$elm$json$Json$Decode$field,
							'release',
							$elm$json$Json$Decode$oneOf(
								_List_fromArray(
									[
										$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
										A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
									]))));
				},
				A2(
					$elm$json$Json$Decode$field,
					'sessionToken',
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
							]))));
		},
		A2($elm$json$Json$Decode$field, 'showRedesignToggle', $elm$json$Json$Decode$string)))(0)}});}(_s));export var Elm=_s.Elm;